webpackJsonp([25],{

/***/ "+0l1":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1363);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1363:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1364)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "ripplecontainer",
	    name: "RippleContainer",
	    category: "web",
	    depends: [ "core" ]
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        extend = $.extend,
	        ripple = kendo.util.ripple;

	    var RippleContainer = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element);

	            element = that.wrapper = that.element;

	            that.options = extend({}, that.options, options);

	            that.registerListeners();
	        },

	        options: {
	            name: "RippleContainer",
	            elements: [
	                { selector: ".k-button:not(li)" },
	                { selector: ".k-list > .k-item", options: { global: true } },
	                { selector: ".k-checkbox-label, .k-radio-label" },
	                {
	                    selector: ".k-checkbox, .k-radio",
	                    options: {
	                        events: ["focusin"],
	                        container: function(el) {
	                            if (/\b(k-checkbox|k-radio)\b/.test(el.className)) {
	                                return el.nextElementSibling;
	                            }
	                        }
	                    }
	                }
	            ]
	        },

	        removeListeners: function() {},

	        registerListeners: function() {
	            var that = this;
	            var root = that.element[0];
	            var elements = that.options.elements;

	            that.removeListeners();

	            var callback = ripple.register(root, elements);

	            that.removeListeners = callback;
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            that.removeListeners();
	        }
	    });

	    ui.plugin(RippleContainer);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1364:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("tQup");

/***/ })

/******/ });

/***/ }),

/***/ "+E39":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("S82l")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "+FHp":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1623);
	module.exports = __webpack_require__(1623);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 948:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Fv0e");

/***/ }),

/***/ 1578:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("I2Wh");

/***/ }),

/***/ 1606:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7Ygf");

/***/ }),

/***/ 1623:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20), __webpack_require__(948), __webpack_require__(1578), __webpack_require__(1624), __webpack_require__(1606) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    /* jshint laxbreak:true, eqnull:true */

	    var RangeRef = kendo.spreadsheet.RangeRef;
	    var UnionRef = kendo.spreadsheet.UnionRef;
	    var CellRef = kendo.spreadsheet.CellRef;
	    var Range = kendo.spreadsheet.Range;

	    // This is a “dynamic variable” (see Greenspun's 10th rule).  It's
	    // bound to an array via sheet._saveModifiedFormulas (which see)
	    // while the callback runs.  The goal is to enable external code
	    // to get a list of formulas or validations that have been
	    // adjusted as an effect of an insert/delete row/column operation,
	    // to be able to undo it.
	    //
	    // The reason why simply saving the state via sheet.getState() or
	    // range.getState() won't suffice is that an insert or delete
	    // operation can have far-reaching effects, like adjusting
	    // formulas from another sheet.
	    var MODIFIED_FORMULAS;

	    var Selection = kendo.Class.extend({
	        init: function(sheet) {
	            this._sheet = sheet;
	            this.selection = kendo.spreadsheet.FIRSTREF.toRangeRef();
	            this.originalSelection = kendo.spreadsheet.FIRSTREF.toRangeRef();
	            this._activeCell = kendo.spreadsheet.FIRSTREF.toRangeRef();
	            this.originalActiveCell = kendo.spreadsheet.FIRSTREF;
	        },

	        currentSelectionRange: function() {
	            return this.selection.rangeAt(this.selectionRangeIndex).toRangeRef();
	        },

	        currentOriginalNavigationRange: function() {
	            return this.originalSelection.rangeAt(this.selectionRangeIndex).toRangeRef();
	        },

	        currentNavigationRange: function() {
	            if (this.singleCellSelection()) {
	                return this._sheet._sheetRef;
	            } else {
	                return this.selection.rangeAt(this.selectionRangeIndex).toRangeRef();
	            }
	        },

	        nextNavigationRange: function() {
	            if (!this.singleCellSelection()) {
	                this.selectionRangeIndex = this.selection.nextRangeIndex(this.selectionRangeIndex);
	            }

	            return this.currentNavigationRange();
	        },

	        previousNavigationRange: function() {
	            if (!this.singleCellSelection()) {
	                this.selectionRangeIndex = this.selection.previousRangeIndex(this.selectionRangeIndex);
	            }

	            return this.currentNavigationRange();
	        },

	        activeCell: function(ref) {
	            if (ref) {
	                this.originalActiveCell = ref.first();
	                this._activeCell = this._sheet.unionWithMerged(ref.toRangeRef());
	                this._sheet.focus(ref);
	                this._sheet.triggerChange({ activeCell: true, selection: true });
	            }

	            return this._activeCell;
	        },

	        select: function(ref, expanded, changeActiveCell, view) {
	            if (ref) {
	                if (ref.eq(this.originalSelection)) {
	                    return;
	                }

	                this._sheet.triggerSelect(new Range(ref, this._sheet));

	                this.originalSelection = ref;

	                this.selection = expanded;

	                if (changeActiveCell !== false) {
	                    if (ref.isCell()) {
	                        // when selecting part of a merged cell, i.e. A1:B2 is merged and select(B2)
	                        // is requested, mark A1 as the actually active cell.
	                        // https://github.com/telerik/kendo/issues/7698
	                        this._sheet.forEachMergedCell(ref, function(merged){
	                            ref = merged.topLeft;
	                        });
	                        this.activeCell(ref);
	                    } else {
	                        ref = this.selection.lastRange();
	                        if (view && view._sheet === this._sheet && view.panes[0]) {
	                            // we should intersect this ref with the range that's currently on
	                            // screen, so that the view doesn't scroll (that is, keep the activeCell
	                            // visible) - https://github.com/telerik/kendo-ui-core/issues/5182 —
	                            // XXX: fiddling with View internals here is probably bad practice, but
	                            // this whole thing is a mess already, so it can be forgiven. :-/
	                            var panes = view.panes;
	                            var i, pane, rows, cols, visible, newRef;

	                            for (i = 0; i < panes.length; i++) {
	                                pane = panes[i];
	                                rows = pane._currentView.rows.values;
	                                cols = pane._currentView.columns.values;

	                                visible = new RangeRef(
	                                    new CellRef(rows.start, cols.start),
	                                    new CellRef(rows.end, cols.end)
	                                );

	                                newRef = ref.intersect(visible);

	                                if (newRef !== kendo.spreadsheet.NULLREF) {
	                                    break;
	                                }
	                            }

	                            if (newRef && newRef !== kendo.spreadsheet.NULLREF) {
	                                ref = newRef;
	                            }
	                        }
	                        this.activeCell(ref.first());
	                    }

	                    this.selectionRangeIndex = this.selection.size() - 1;
	                } else {
	                    this._sheet.triggerChange({ selection: true });
	                }
	            }

	            return this.selection;
	        },

	        singleCellSelection: function() {
	            return this._activeCell.eq(this.selection);
	        }
	    });

	    var Sheet = kendo.Observable.extend({
	        init: function() {
	            kendo.Observable.prototype.init.call(this);
	            this._reinit.apply(this, arguments);
	        },


	        events: [
	            "changing",
	            "commandRequest",
	            "afterInsertRow",
	            "afterDeleteRow",
	            "insertRow",
	            "insertColumn",
	            "deleteRow",
	            "deleteColumn",
	            "hideRow",
	            "hideColumn",
	            "unhideRow",
	            "unhideColumn",
	            "select",
	            "dataBinding",
	            "dataBound"
	        ],

	        _reinit: function(rowCount, columnCount, rowHeight, columnWidth, headerHeight, headerWidth, defaultCellStyle) {
	            defaultCellStyle = defaultCellStyle || {};

	            this._defaultCellStyle = {
	                background: defaultCellStyle.background,
	                color: defaultCellStyle.color,
	                fontFamily: defaultCellStyle.fontFamily,
	                fontSize: defaultCellStyle.fontSize,
	                italic: defaultCellStyle.italic,
	                bold: defaultCellStyle.bold,
	                underline: defaultCellStyle.underline,
	                wrap: defaultCellStyle.wrap,
	                verticalAlign: defaultCellStyle.verticalAlign,
	                textAlign: defaultCellStyle.textAlign
	            };

	            this._rows = new kendo.spreadsheet.Axis(rowCount, rowHeight);
	            this._columns = new kendo.spreadsheet.Axis(columnCount, columnWidth);
	            this._filteredRows = new kendo.spreadsheet.RangeList(0, rowCount - 1, false);
	            this._mergedCells = [];
	            this._frozenRows = 0;
	            this._frozenColumns = 0;
	            this._suspendChanges = false;
	            this._filter = null;
	            this._showGridLines = true;
	            this._gridLinesColor = null;
	            this._grid = new kendo.spreadsheet.Grid(this._rows, this._columns, rowCount, columnCount, headerHeight, headerWidth);
	            this._sheetRef = this._grid.normalize(kendo.spreadsheet.SHEETREF);
	            this._properties = new kendo.spreadsheet.PropertyBag(rowCount, columnCount, this._defaultCellStyle);
	            this._sorter = new kendo.spreadsheet.Sorter(this._grid, this._properties.sortable());

	            this._viewSelection = new Selection(this);

	            this._editSelection = new Selection(this);

	            this._formulaSelections = [];
	            this._drawings = [];
	       },

	        _selectionState: function() {
	            return this._inEdit ? this._editSelection : this._viewSelection;
	        },

	        navigator: function() {
	            if(!this._navigator) {
	                 this._navigator = new kendo.spreadsheet.SheetNavigator(this);
	            }
	            return this._navigator;
	        },

	        axisManager: function() {
	            if(!this._axisManager) {
	                 this._axisManager = new kendo.spreadsheet.AxisManager(this);
	            }

	            return this._axisManager;
	        },

	        _name: function(value) {
	            if (!value) {
	                return this._sheetName;
	            }

	            this._sheetName = value;

	            return this;
	        },

	        name: function() {
	            return this._name();
	        },

	        _property: function(accessor, value, reason) {
	            if (value === undefined) {
	                return accessor();
	            } else {
	                accessor(value);

	                return this.triggerChange(reason);
	            }
	        },

	        _field: function(name, value, reason) {
	            if (value === undefined) {
	                return this[name];
	            } else {
	                this[name] = value;

	                return this.triggerChange(reason);
	            }
	        },

	        suspendChanges: function(value) {
	            if (value === undefined) {
	                return this._suspendChanges;
	            }

	            this._suspendChanges = value;

	            return this;
	        },

	        triggerChange: function(reason) {
	            if (!this._suspendChanges) {
	                this.trigger("change", reason);
	            }
	            return this;
	        },

	        triggerSelect: function(range) {
	            this.trigger("select", { range: range });
	        },

	        setDataSource: function(dataSource, columns) {
	            if (this.dataSourceBinder) {
	                this.dataSourceBinder.destroy();
	            }

	            this.dataSourceBinder = new kendo.spreadsheet.SheetDataSourceBinder({
	                dataSource: dataSource,
	                sheet: this,
	                columns: columns
	            });

	            this.dataSource = this.dataSourceBinder.dataSource;
	        },

	        hideColumn: function(columnIndex) {
	            if (this.trigger("hideColumn", { index: columnIndex })) {
	                return;
	            }

	            return this._property(this._columns.hide.bind(this._columns), columnIndex, { layout: true });
	        },

	        unhideColumn: function(columnIndex) {
	            if (this.trigger("unhideColumn", { index: columnIndex })) {
	                return;
	            }

	            return this._property(this._columns.unhide.bind(this._columns), columnIndex, { layout: true });
	        },

	        isHiddenColumn: function(columnIndex) {
	            return this._grid._columns.hidden(columnIndex);
	        },

	        _copyRange: function(sourceRangeRef, targetRef) {
	            var grid = this._grid;
	            var rowCount = grid.rowCount;

	            var nextRefTopLeft = grid.normalize(sourceRangeRef.topLeft);
	            var nextRefBottomRight = grid.normalize(sourceRangeRef.bottomRight);

	            var nextIndex = nextRefTopLeft.col * rowCount + nextRefTopLeft.row;
	            var nextBottomIndex = nextRefBottomRight.col * rowCount + nextRefBottomRight.row;

	            var targetIndex = targetRef.col * rowCount + targetRef.row;

	            this._properties.copy(nextIndex, nextBottomIndex, targetIndex);
	        },

	        _saveModifiedFormulas: function(array, callback) {
	            var save = MODIFIED_FORMULAS;
	            MODIFIED_FORMULAS = array;
	            var ret = callback();
	            MODIFIED_FORMULAS = save;
	            return ret;
	        },

	        _restoreModifiedFormulas: function(array) {
	            var wb = this._workbook;
	            array.forEach(function(f){
	                var sheet = wb.sheetByName(f.sheet), index;
	                if (f instanceof kendo.spreadsheet.calc.runtime.Formula) {
	                    index = sheet._grid.cellRefIndex(f); // f has row, col
	                    sheet._properties.set("formula", index, index, f);
	                }
	                if (f instanceof kendo.spreadsheet.validation.Validation) {
	                    index = sheet._grid.cellRefIndex(f); // f has row, col
	                    sheet._properties.set("validation", index, index, f);
	                }
	            });
	        },

	        _adjustReferences: function(operation, start, delta, mergedCells) {
	            this._mergedCells = mergedCells.reduce(function(a, ref){
	                ref = ref.adjust(null, null, null, null, operation == "row", start, delta);
	                if (ref instanceof RangeRef) {
	                    a.push(ref);
	                }
	                return a;
	            }, []);
	            if (this._workbook) {
	                var affectedSheet = this._name();
	                this._workbook._sheets.forEach(function(sheet){
	                    sheet._forFormulas(function(formula){
	                        var prev = formula.adjust(affectedSheet, operation, start, delta);
	                        if (prev && MODIFIED_FORMULAS) {
	                            // if formula.adjust returns non-null,
	                            // that means the formula was indeed
	                            // modified and the returned value is a
	                            // copy of the previous Formula, which we
	                            // can use for undoing the operation.
	                            MODIFIED_FORMULAS.push(prev);
	                        }
	                    });

	                    sheet._forValidations(function(validation){
	                        var prev = validation.adjust(affectedSheet, operation, start, delta);
	                        if (prev && MODIFIED_FORMULAS) {
	                            MODIFIED_FORMULAS.push(prev);
	                        }
	                    });
	                });
	                this._workbook.adjustNames(affectedSheet, operation == "row", start, delta);
	            }
	            var selection = this.select();
	            selection = selection.adjust(null, null, null, null, operation == "row", start, delta);
	            if (selection !== kendo.spreadsheet.NULLREF) {
	                this.select(selection);
	            }
	            // adjust column widths or row heights and hidden attribute
	            var axis = operation == "col" ? this._columns : this._rows;
	            axis.adjust(start, delta);

	            if (operation == "row") {
	                if (delta < 0) {
	                    this._filteredRows.copy(start - delta, this._rows._count - 1, start);
	                } else {
	                    this._filteredRows.copy(start, this._rows._count, start + delta);
	                    this._filteredRows.value(start, start + delta - 1, false);
	                }
	            }

	            // adjust drawing anchor cells
	            this._drawings.forEach(function(drawing){
	                if (drawing.topLeftCell) {
	                    drawing.topLeftCell = drawing.topLeftCell.adjust(null, null, null, null,
	                                                                     operation == "row", start, delta);
	                }
	            });
	        },

	        _forFormulas: function(callback) {
	            var props = this._properties;
	            var formulas = props.get("formula").values();
	            var n = formulas.length;
	            formulas.forEach(function(f, i){
	                callback.call(this, f.value, i, n);
	            }, this);
	        },

	        _forValidations: function(callback) {
	            var props = this._properties;
	            props.get("validation").values().forEach(function(v){
	                callback.call(this, v.value);
	            }, this);
	        },

	        preventInsertRow: function(rowIndex, count) {
	            if (this.selectedHeaders().allRows) {
	                return { reason: "error", type: "insertRowWhenColumnIsSelected" };
	            }

	            count = count || 1;
	            var grid = this._grid;
	            var range = this.range(grid.rowCount - count, 0, count, grid.columnCount);

	            //TODO: Improve has value to return true only if real value is available?
	            if (range.hasValue()) {
	                return { reason: "error", type: "shiftingNonblankCells" };
	            }

	            return false;
	        },

	        preventInsertBelowLastRow: function(rowIndex, count) {
	            count = count || 1;

	            if (rowIndex + count === this._rows._count) {
	                return { reason: "error", type: "insertRowBelowLastRow" };
	            }

	            return false;
	        },

	        preventInsertColumn: function(colIndex, count) {
	            if (this.selectedHeaders().allCols) {
	                return { reason: "error", type: "insertColumnWhenRowIsSelected" };
	            }

	            count = count || 1;
	            var grid = this._grid;
	            var range = this.range(0, grid.columnCount - count, grid.rowCount, count);

	            //TODO: Improve has value to return true only if real value is available?
	            if (range.hasValue()) {
	                return { reason: "error", type: "shiftingNonblankCells" };
	            }

	            return false;
	        },

	        preventInsertAfterLastColumn: function(colIndex, count) {
	            count = count || 1;

	            if (colIndex + count === this._columns._count) {
	                return { reason: "error", type: "insertColAfterLastCol" };
	            }

	            return false;
	        },

	        insertRow: function(rowIndex, skipDataSourceInsert) {
	            var result = this.preventInsertRow(rowIndex);

	            if (result) {
	                throw new Error("Shifting nonblank cells off the worksheet is not supported!");
	            }

	            if (this.trigger("insertRow", { index: rowIndex })) {
	                return;
	            }

	            this.batch(function() {

	                var grid = this._grid;
	                var columnCount = grid.columnCount;
	                var rowCount = grid.rowCount;

	                var frozenRows = this.frozenRows();

	                if (rowIndex < frozenRows) {
	                    this.frozenRows(frozenRows + 1);
	                }

	                var mergedCells = this._mergedCells.slice();

	                for (var ci = 0; ci < columnCount; ci++) {
	                    var ref = new RangeRef(new CellRef(rowIndex, ci), new CellRef(rowIndex, ci));

	                    var topLeft = grid.normalize(ref.topLeft);
	                    var bottomRight = grid.normalize(ref.bottomRight);

	                    var nextRef = new RangeRef(
	                        new CellRef(topLeft.row, topLeft.col),
	                        new CellRef(rowCount - 2, bottomRight.col)
	                    );

	                    this._copyRange(nextRef, new CellRef(topLeft.row + 1, topLeft.col));

	                    new Range(ref, this).clear({ clearAll: true, keepBorders: true });
	                }

	                this._adjustReferences("row", rowIndex, 1, mergedCells);
	            }, {
	                recalc: true,
	                layout: true,
	                insertRow: { index: rowIndex },
	                ref: new RangeRef(new CellRef(rowIndex, 0), new CellRef(Infinity, Infinity))
	            });

	            if (!skipDataSourceInsert) {
	                this.trigger("afterInsertRow", { index: rowIndex });
	            }

	            return this;
	        },

	        isEnabledRow: function(rowIndex) {
	            var ref = new RangeRef(new CellRef(rowIndex, 0), new CellRef(rowIndex, this._grid.columnCount));
	            return new Range(ref, this).enable();
	        },

	        deleteRow: function(rowIndex, skipDataSourceDelete) {
	            if (!this.isEnabledRow(rowIndex)) {
	                return this;
	            }

	            if (this.trigger("deleteRow", { index: rowIndex })) {
	                return;
	            }

	            this.batch(function() {
	                var grid = this._grid;
	                var columnCount = grid.columnCount;

	                var frozenRows = this.frozenRows();
	                if (rowIndex < frozenRows) {
	                    this.frozenRows(frozenRows - 1);
	                }

	                var mergedCells = this._mergedCells.slice();

	                for (var ci = 0; ci < columnCount; ci++) {
	                    var ref = new RangeRef(new CellRef(rowIndex, ci), new CellRef(rowIndex, ci));

	                    new Range(ref, this).clear({ clearAll: true, keepBorders: true });

	                    var topLeft = grid.normalize(ref.topLeft);
	                    var bottomRight = grid.normalize(ref.bottomRight);

	                    var nextRef = new RangeRef(
	                        new CellRef(topLeft.row + 1, topLeft.col),
	                        new CellRef(Infinity, bottomRight.col)
	                    );

	                    this._copyRange(nextRef, topLeft);

	                    var nextRefBottomRight = grid.normalize(nextRef.bottomRight);

	                    new Range(new RangeRef(nextRefBottomRight, nextRefBottomRight), this).clear();
	                }

	                this._adjustReferences("row", rowIndex, -1, mergedCells);
	            }, {
	                recalc: true,
	                layout: true,
	                deleteRow: { index: rowIndex },
	                ref: new RangeRef(new CellRef(rowIndex, 0), new CellRef(Infinity, Infinity))
	            });

	            if (!skipDataSourceDelete) {
	                this.trigger("afterDeleteRow", { index: rowIndex });
	            }

	            return this;
	        },

	        insertColumn: function(columnIndex) {
	            if (this.trigger("insertColumn", { index: columnIndex })) {
	                return;
	            }

	            this.batch(function() {
	                var grid = this._grid;
	                var columnCount = grid.columnCount;

	                var frozenColumns = this.frozenColumns();

	                if (columnIndex < frozenColumns) {
	                    this.frozenColumns(frozenColumns + 1);
	                }

	                var mergedCells = this._mergedCells.slice();

	                for (var ci = columnCount; ci >= columnIndex; ci--) {
	                    var ref = new RangeRef(new CellRef(0, ci), new CellRef(Infinity, ci));

	                    new Range(ref, this).clear({ clearAll: true, keepBorders: true });

	                    if (ci == columnIndex) {
	                        break;
	                    }

	                    var topLeft = grid.normalize(ref.topLeft);
	                    var bottomRight = grid.normalize(ref.bottomRight);

	                    var nextRef = new RangeRef(
	                        new CellRef(topLeft.row, topLeft.col - 1),
	                        new CellRef(bottomRight.row, bottomRight.col - 1)
	                    );

	                    this._copyRange(nextRef, topLeft);
	                }

	                this._adjustReferences("col", columnIndex, 1, mergedCells);
	            }, {
	                recalc: true,
	                layout: true,
	                insertColumn: { index: columnIndex },
	                ref: new RangeRef(new CellRef(0, columnIndex), new CellRef(Infinity, Infinity))
	            });

	            return this;
	        },

	        isEnabledColumn: function(columnIndex) {
	            var ref = new RangeRef(new CellRef(0, columnIndex), new CellRef(Infinity, columnIndex));
	            return new Range(ref, this).enable();
	        },

	        deleteColumn: function(columnIndex) {
	            if (!this.isEnabledColumn(columnIndex)) {
	                return this;
	            }

	            if (this.trigger("deleteColumn", { index: columnIndex })) {
	                return;
	            }

	            this.batch(function() {
	                var grid = this._grid;
	                var columnCount = grid.columnCount;

	                var frozenColumns = this.frozenColumns();

	                if (columnIndex < frozenColumns) {
	                    this.frozenColumns(frozenColumns - 1);
	                }

	                var mergedCells = this._mergedCells.slice();

	                for (var ci = columnIndex; ci < columnCount; ci++) {
	                    var ref = new RangeRef(new CellRef(0, ci), new CellRef(Infinity, ci));

	                    new Range(ref, this).clear({ clearAll: true, keepBorders: true });

	                    if (ci == columnCount - 1) {
	                        break;
	                    }

	                    var topLeft = grid.normalize(ref.topLeft);
	                    var bottomRight = grid.normalize(ref.bottomRight);

	                    var nextRef = new RangeRef(
	                        new CellRef(topLeft.row, topLeft.col + 1),
	                        new CellRef(bottomRight.row, bottomRight.col + 1)
	                    );

	                    this._copyRange(nextRef, topLeft);
	                }

	                this._adjustReferences("col", columnIndex, -1, mergedCells);
	            }, {
	                recalc: true,
	                layout: true,
	                deleteColumn: { index: columnIndex },
	                ref: new RangeRef(new CellRef(0, columnIndex), new CellRef(Infinity, Infinity))
	            });

	            return this;
	        },

	        _filterRow: function(rowIndex) {
	            this._rows.hide(rowIndex);
	            this._filteredRows.value(rowIndex, rowIndex, true);
	            this.triggerChange({ layout: true });
	        },

	        hideRow: function(rowIndex) {
	            if (this.trigger("hideRow", { index: rowIndex })) {
	                return;
	            }
	            return this._property(this._rows.hide.bind(this._rows), rowIndex, { layout: true });
	        },

	        unhideRow: function(rowIndex) {
	            if (this.trigger("unhideRow", { index: rowIndex })) {
	                return;
	            }
	            return this._property(this._rows.unhide.bind(this._rows), rowIndex, { layout: true });
	        },

	        isHiddenRow: function(rowIndex) {
	            return this._grid._rows.hidden(rowIndex);
	        },

	        isFilteredRow: function(rowIndex) {
	            return this._filteredRows.value(rowIndex);
	        },

	        columnWidth: function(columnIndex, width) {
	            return this._property(this._columns.value.bind(this._columns, columnIndex, columnIndex), width, { layout: true });
	        },

	        rowHeight: function(rowIndex, height) {
	            return this._property(this._rows.value.bind(this._rows, rowIndex, rowIndex), height, { layout: true });
	        },

	        frozenRows: function(value) {
	            return this._field("_frozenRows", value, { layout: true });
	        },

	        frozenColumns: function(value) {
	            return this._field("_frozenColumns", value, { layout: true });
	        },

	        showGridLines: function(value) {
	            return this._field("_showGridLines", value, { layout: true });
	        },

	        gridLinesColor: function(value) {
	            return this._field("_gridLinesColor", value, { layout: true });
	        },

	        _ref: function(row, column, numRows, numColumns) {
	            var ref = null;

	            if (row instanceof kendo.spreadsheet.Ref) {
	                return row;
	            }

	            if (row instanceof kendo.spreadsheet.Range) {
	                return row._ref.toRangeRef();
	            }

	            if (typeof row === "string") {
	                ref = kendo.spreadsheet.calc.parseReference(row);
	            } else {
	                if (!numRows) {
	                    numRows = 1;
	                }

	                if (!numColumns) {
	                    numColumns = 1;
	                }
	                ref = new RangeRef(new CellRef(row, column), new CellRef(row + numRows - 1, column + numColumns - 1));
	            }

	            return ref;
	        },

	        range: function(row, column, numRows, numColumns) {
	            return new Range(this._ref(row, column, numRows, numColumns), this);
	        },

	        _getMergedCells: function(range) {
	            var grid = this._grid;
	            var primary = {};
	            var secondary = {};
	            var hasMerged = false;

	            this.forEachMergedCell(range, function(ref) {
	                var topLeft = ref.topLeft;
	                grid.forEach(ref, function(cellRef) {
	                    if (topLeft.eq(cellRef)) {
	                        primary[cellRef.print()] = ref;
	                        hasMerged = true;
	                    } else if (range.contains(cellRef)) {
	                        secondary[cellRef.print()] = topLeft;
	                        hasMerged = true;
	                    }
	                });
	            });

	            return { primary: primary, secondary: secondary, hasMerged: hasMerged };
	        },

	        forEachMergedCell: function(ref, callback) {
	            var selectAll = false;

	            if (typeof callback === "undefined") {
	                callback = ref;
	                selectAll = true;
	            }

	            this._mergedCells.forEach(function(merged) {
	                if (selectAll || merged.intersects(ref)) {
	                    callback(merged);
	                }
	            });
	        },

	        forEachFilterHeader: function(ref, callback) {
	            var selectAll = false;

	            if (typeof callback === "undefined") {
	                callback = ref;
	                selectAll = true;
	            }

	            if (this._filter) {
	                var refs = [];

	                // get refs of all columns
	                this._filter.ref.forEachColumn(function(columnRef) {
	                    if (selectAll || columnRef.intersects(ref)) {
	                        refs.push(columnRef.topLeft);
	                    }
	                });

	                // filter out merged references
	                this._mergedCells.forEach(function(merged) {
	                    refs = refs.map(function(ref) {
	                        if (merged.intersects(ref)) {
	                            return merged;
	                        }

	                        return ref;
	                    });
	                });

	                // use only unique refs
	                refs.reduce(function unique(result, element) {
	                    if (result.indexOf(element) < 0) {
	                        result.push(element);
	                    }

	                    return result;
	                }, []).forEach(callback);
	            }
	        },

	        forEach: function(ref, callback) {
	            var self = this;
	            function forEachRange(ref) {
	                if (!(ref instanceof RangeRef)) {
	                    ref = ref.toRangeRef();
	                }
	                var topLeft = self._grid.normalize(ref.topLeft);
	                var bottomRight = self._grid.normalize(ref.bottomRight);
	                var ci, ri;

	                function doIt(value) {
	                    callback(ri++, ci, value);
	                }

	                for (ci = topLeft.col; ci <= bottomRight.col; ci++) {
	                    ri = topLeft.row;
	                    var startCellIndex = self._grid.index(ri, ci);
	                    var endCellIndex = self._grid.index(bottomRight.row, ci);
	                    self._properties.forEach(startCellIndex, endCellIndex, doIt);
	                }
	            }

	            if (!(ref instanceof RangeRef)) {
	                ref = self._ref(ref);
	            }

	            if (ref instanceof UnionRef) {
	                // _ref() might still return a UnionRef, for instance, if
	                // `ref` happens to be one.  Probably an oversight, but it
	                // turns out to be useful.
	                ref.forEach(forEachRange);
	            } else {
	                forEachRange(ref);
	            }
	        },

	        startResizing: function(initialPosition) {
	            this._initialPosition = initialPosition;
	            this._resizeInProgress = true;
	        },

	        startAutoFill: function() {
	            this._autoFillInProgress = true;
	            var selection = this.select();
	            this._autoFillOrigin = selection;
	            this._autoFillDest = selection;
	            this.triggerChange({ selection: true });
	        },

	        updateAutoFill: function(dest, punch, hint, direction) {
	            this._autoFillDest = dest;
	            this._autoFillPunch = punch;
	            this._autoFillHint = hint;
	            this._autoFillDirection = direction;
	            this.triggerChange({ selection: true });
	        },

	        autoFillRef: function() {
	            return this._autoFillDest;
	        },

	        autoFillPunch: function() {
	            return this._autoFillPunch;
	        },

	        autoFillInProgress: function() {
	            return this._autoFillInProgress;
	        },

	        resizingInProgress: function() {
	            return this._resizeInProgress;
	        },

	        draggingInProgress: function() {
	            return this._draggingInProgress;
	        },

	        completeResizing: function() {
	            if (this._resizeInProgress) {
	                this._resizeInProgress = false;
	                var hintPosition = this.resizeHintPosition();

	                if (this._initialPosition && hintPosition) {
	                    var handlePosition = this.resizeHandlePosition();
	                    if (handlePosition.col !== -Infinity) {
	                        this.trigger("commandRequest", {
	                            command: "ColumnWidthCommand",
	                            options: {
	                                target: handlePosition.col,
	                                value: this.columnWidth(handlePosition.col) - (this._initialPosition.x - hintPosition.x)
	                            }
	                        });
	                    } else {
	                        this.trigger("commandRequest", {
	                            command: "RowHeightCommand",
	                            options: {
	                                target: handlePosition.row,
	                                value: this.rowHeight(handlePosition.row) - (this._initialPosition.y - hintPosition.y)
	                            }
	                        });
	                    }
	                } else {
	                    this.trigger("change", { resize: true });
	                }
	            }
	        },

	        _renderComment: function(ref) {
	            var comment = ref ? this.range(ref).comment() : null;
	            if (comment) {
	                if (!this._commentRef || !ref.eq(this._commentRef)) {
	                    this._commentRef = ref;
	                    this.trigger("change", { comment: true });
	                }
	            } else {
	                if (this._commentRef) {
	                    this._commentRef = null;
	                    this.trigger("change", { comment: true });
	                }
	            }
	        },

	        resizeHandlePosition: function() {
	            return this._resizeHandlePosition;
	        },

	        resizeHintPosition: function(location) {
	            if (location !== undefined) {
	                this._resizeHintPosition = location;
	                this.trigger("change", { resize: true });
	            }
	            return this._resizeHintPosition;
	        },

	        removeResizeHandle: function() {
	            if (this._resizeHandlePosition) {
	                this._resizeHintPosition = undefined;
	                this._resizeHandlePosition = undefined;
	                this._initialPosition = undefined;
	                this.trigger("change", { resize: true });
	            }
	        },

	        positionResizeHandle: function(ref) {
	            this._resizeHandlePosition = ref;
	            this.trigger("change", { resize: true });
	        },

	        startDragging: function(data) {
	            this._draggingInProgress = data;
	        },

	        completeDragging: function() {
	            var drag = this._draggingInProgress;
	            if (drag) {
	                this._draggingInProgress = null;
	                var drawing = drag.drawing;
	                if (drawing.eq(drag.copy)) {
	                    return;
	                }
	                if (drawing.topLeftCell) {
	                    // adjust reference - in case the top-left corner
	                    // was moving, select the cell beneath it.
	                    var box = this.drawingBoundingBox(drawing);
	                    var row = this._rows.indexVisible(box.top);
	                    var col = this._columns.indexVisible(box.left);
	                    var ref = new CellRef(row, col);
	                    var refBox = this.refBoundingBox(ref);
	                    drawing.offsetX = box.left - refBox.left;
	                    drawing.offsetY = box.top - refBox.top;
	                    drawing.topLeftCell = ref;
	                    this.triggerChange({ dragging: true });
	                }
	                this.trigger("commandRequest", {
	                    command: "DrawingUpdateCommand",
	                    options: {
	                        sheet    : this,
	                        drawing  : drawing,
	                        previous : drag.copy
	                    }
	                });
	            }
	        },

	        startSelection: function(view) {
	            if (this.frozenRows() || this.frozenColumns()) {
	                this._currentView = null;
	            } else if (view && view._sheet === this) {
	                this._currentView = view;
	            }
	            this._selectionInProgress = true;
	        },

	        completeSelection: function() {
	            if (this._selectionInProgress) {
	                this._selectionInProgress = false;
	                this._resizeHintPosition = undefined;
	                this.trigger("change", { selection: true });
	            }
	            if (this._autoFillInProgress) {
	                this._autoFillInProgress = false;
	                var dest = this._autoFillDest;
	                var origin = this._autoFillOrigin;

	                if (this._autoFillPunch) { // we just clear data here
	                    this.trigger("commandRequest", {
	                        command: "ClearContentCommand", options: { operatingRange: this.range(this._autoFillPunch) }
	                    });
	                } else {
	                    if (!dest.eq(origin)) {
	                        this.trigger("commandRequest", {
	                            command: "AutoFillCommand", options: { operatingRange: this.range(dest), origin: this.range(origin) }
	                        });
	                    } else {
	                        this.triggerChange({ selection: true });
	                    }
	                }

	                this._autoFillDest = null;
	                this._autoFillPunch = null;
	                this._autoFillOrigin = null;

	                this.select(dest);
	            }
	        },

	        selectionInProgress: function() {
	            return this._selectionInProgress;
	        },

	        select: function(ref, changeActiveCell) {
	            var selectionState = this._selectionState();

	            var expandedRef;

	            if (ref) {
	                ref = this._ref(ref);
	                ref = this._grid.normalize(ref);
	                expandedRef = this._grid.isAxis(ref) ? ref : this.unionWithMerged(ref);
	            }

	            return selectionState.select(ref, expandedRef, changeActiveCell, this._currentView);
	        },

	        originalSelect: function() {
	            return this._selectionState().originalSelection;
	        },

	        currentSelectionRange: function() {
	            return this._selectionState().currentSelectionRange();
	        },

	        currentOriginalSelectionRange: function() {
	            return this._selectionState().currentOriginalNavigationRange();
	        },

	        currentNavigationRange: function() {
	            return this._selectionState().currentNavigationRange();
	        },

	        nextNavigationRange: function() {
	            return this._selectionState().nextNavigationRange();
	        },

	        previousNavigationRange: function() {
	            return this._selectionState().previousNavigationRange();
	        },

	        selectionRangeIndex: function() {
	            return this._selectionState().selectionRangeIndex;
	        },

	        activeCell: function(ref) {
	            return this._selectionState().activeCell(ref);
	        },

	        originalActiveCell: function() {
	            return this._selectionState().originalActiveCell;
	        },

	        singleCellSelection: function() {
	            return this._selectionState().singleCellSelection();
	        },

	        unionWithMerged: function(ref) {
	            var mergedCells = this._mergedCells;

	            return ref.map(function(ref) {
	                return ref.toRangeRef().union(mergedCells);
	            });
	        },

	        trim: function(ref) {
	            var trims = [];
	            var grid = this._grid;
	            this._properties.forEachProperty(function(property) {
	                trims.push(grid.trim(ref, property.list));
	            });
	            return this.unionWithMerged(ref.topLeft.toRangeRef().union(trims));
	        },

	        focus: function(ref) {
	            if (ref) {
	                this._focus = ref.toRangeRef();
	            } else {
	                var focus = this._focus;
	                this._focus = null;
	                return focus;
	            }
	        },

	        activeCellSelection: function() {
	            return new Range(this._grid.normalize(this.activeCell()), this);
	        },

	        selection: function() {
	            return new Range(this._grid.normalize(this._selectionState().selection), this);
	        },

	        selectedHeaders: function() {
	            var selection = this.select();

	            var rows = {};
	            var cols = {};
	            var allCols = false;
	            var allRows = false;
	            var maxRow = this._grid.rowCount - 1;
	            var maxCol = this._grid.columnCount - 1;

	            selection.forEach(function(ref) {
	                var i;
	                var rowState = "partial";
	                var colState = "partial";
	                ref = ref.toRangeRef();

	                var bottomRight = ref.bottomRight;
	                var topLeft = ref.topLeft;

	                var rowSelection = topLeft.col <= 0 && bottomRight.col >= maxCol;
	                var colSelection = topLeft.row <= 0 && bottomRight.row >= maxRow;

	                if (colSelection) { //column selection
	                    allRows = true;
	                    colState = "full";
	                }

	                if (rowSelection) { //row selection
	                    allCols = true;
	                    rowState = "full";
	                }

	                if (!colSelection) { //column selection
	                    for (i = topLeft.row; i <= bottomRight.row; i++) {
	                        if (rows[i] !== "full") {
	                            rows[i] = rowState;
	                        }
	                    }
	                }

	                if (!rowSelection) {
	                    for (i = topLeft.col; i <= bottomRight.col; i++) {
	                        if (cols[i] !== "full") {
	                            cols[i] = colState;
	                        }
	                    }
	                }
	            });

	            return {
	                rows: rows,
	                cols: cols,
	                allRows: allRows,
	                allCols: allCols,
	                all: allRows && allCols
	            };
	        },

	        isInEditMode: function(isInEdit) {
	            if (isInEdit === undefined) {
	                return this._inEdit;
	            }

	            this._inEdit = isInEdit;

	            if (isInEdit) {
	                this._editSelection.selection = this._viewSelection.selection.clone();
	                this._editSelection.originalSelection = this._viewSelection.originalSelection.clone();
	                this._editSelection._activeCell = this._viewSelection._activeCell.clone();
	                this._editSelection.originalActiveCell = this._viewSelection.originalActiveCell.clone();
	            }
	        },

	        _setFormulaSelections: function(selection) {
	            this._formulaSelections = (selection || []).slice();
	            this.triggerChange({ selection: true });
	        },

	        _viewActiveCell: function() {
	            return this._viewSelection._activeCell.toRangeRef();
	        },

	        toJSON: function() {
	            var positions = {};

	            var rows = this._rows.toJSON("height", positions);
	            var columns = this._columns.toJSON("width", {});
	            var viewSelection = this._viewSelection;
	            var hyperlinks = [];
	            var defaultCellStyle = this._defaultCellStyle || {};

	            function clearDefaultStyle(cell) {
	                Object.keys(defaultCellStyle).forEach(function(key){
	                    if (cell[key] === defaultCellStyle[key]) {
	                        delete cell[key];
	                    }
	                });
	            }

	            this.forEach(kendo.spreadsheet.SHEETREF, function(row, col, cell) {
	                clearDefaultStyle(cell);

	                if (Object.keys(cell).length === 0) {
	                    return;
	                }

	                if (cell.link) {
	                    hyperlinks.push({
	                        ref    : kendo.spreadsheet.Ref.display(null, row, col),
	                        target : cell.link
	                    });
	                }

	                var position = positions[row];

	                if (position === undefined) {
	                    position = rows.length;
	                    rows.push({ index: row });
	                    positions[row] = position;
	                }

	                row = rows[position];

	                cell.index = col;

	                if (row.cells === undefined) {
	                    row.cells = [];
	                }

	                if (cell.formula) {
	                    // stringify Formula object.
	                    if (cell.formula.arrayFormulaRange) {
	                        cell.formula = {
	                            src: cell.formula.toString(),
	                            ref: cell.formula.arrayFormulaRange.toString()
	                        };
	                    } else {
	                        cell.formula = cell.formula.toString();
	                    }
	                }

	                if (cell.validation) {
	                    cell.validation = cell.validation.toJSON();
	                }

	                if (cell.color) {
	                    cell.color = kendo.parseColor(cell.color).toCss();
	                }

	                if (cell.background) {
	                    cell.background = kendo.parseColor(cell.background).toCss();
	                }

	                if (cell.borderTop && cell.borderTop.color) {
	                    cell.borderTop.color = kendo.parseColor(cell.borderTop.color).toCss();
	                }

	                if (cell.borderBottom && cell.borderBottom.color) {
	                    cell.borderBottom.color = kendo.parseColor(cell.borderBottom.color).toCss();
	                }

	                if (cell.borderRight && cell.borderRight.color) {
	                    cell.borderRight.color = kendo.parseColor(cell.borderRight.color).toCss();
	                }

	                if (cell.borderLeft && cell.borderLeft.color) {
	                    cell.borderLeft.color = kendo.parseColor(cell.borderLeft.color).toCss();
	                }

	                row.cells.push(cell);
	            });

	            var json = {
	                name: this._name(),
	                rows: rows,
	                columns: columns,
	                selection: viewSelection.selection.toString(),
	                activeCell: viewSelection.activeCell().toString(),
	                frozenRows: this.frozenRows(),
	                frozenColumns: this.frozenColumns(),
	                showGridLines: this.showGridLines(),
	                gridLinesColor: this.gridLinesColor(),
	                mergedCells: this._mergedCells.map(function(ref) {
	                    return ref.toString();
	                }),
	                hyperlinks: hyperlinks,
	                defaultCellStyle: defaultCellStyle,
	                drawings: this._drawings.map(function(dr){
	                    return dr.toJSON();
	                })
	            };

	            if (this._sort) {
	               json.sort = {
	                   ref: this._sort.ref.toString(),
	                   columns: this._sort.columns.map(function(column) {
	                       return {
	                           index: column.index,
	                           ascending: column.ascending
	                       };
	                   })
	               };
	            }

	            if (this._filter) {
	               json.filter = {
	                   ref: this._filter.ref.toString(),
	                   columns: this._filter.columns.map(function(column) {
	                        var filter = column.filter.toJSON();
	                        filter.index = column.index;
	                        return filter;
	                   })
	               };
	            }

	            return json;
	        },

	        fromJSON: function(json) {
	            this.batch(function() {
	                if (json.name !== undefined) {
	                    this._name(json.name);
	                }

	                if (json.frozenColumns !== undefined) {
	                    this.frozenColumns(json.frozenColumns);
	                }

	                if (json.frozenRows !== undefined) {
	                    this.frozenRows(json.frozenRows);
	                }

	                if (json.columns !== undefined) {
	                    this._columns.fromJSON("width", json.columns);
	                }

	                if (json.rows !== undefined) {
	                    this._rows.fromJSON("height", json.rows);

	                    for (var ri = 0; ri < json.rows.length; ri++) {
	                        var row = json.rows[ri];
	                        var rowIndex = row.index;

	                        if (rowIndex === undefined) {
	                            rowIndex = ri;
	                        }

	                        if (row.cells) {
	                            for (var ci = 0; ci < row.cells.length; ci++) {
	                                var cell = row.cells[ci];
	                                var columnIndex = cell.index;

	                                if (columnIndex === undefined) {
	                                    columnIndex = ci;
	                                }

	                                if (cell.formula) {
	                                    var isArray = typeof cell.formula != "string";
	                                    var src = isArray ? cell.formula.src : cell.formula;
	                                    var formula = this._compileFormula(rowIndex, columnIndex, src);
	                                    if (isArray) {
	                                        formula.setArrayFormulaRange(
	                                            kendo.spreadsheet.calc.parseReference(cell.formula.ref));
	                                    }
	                                    cell.formula = formula;
	                                }

	                                if (cell.validation) {
	                                    cell.validation = this._compileValidation(rowIndex, columnIndex, cell.validation);
	                                }

	                                this._properties.fromJSON(this._grid.index(rowIndex, columnIndex), cell);
	                            }
	                        }
	                    }
	                }

	                if (json.drawings) {
	                    this._drawings = json.drawings.map(Drawing.fromJSON);
	                }

	                if (json.selection) {
	                    this._viewSelection.selection =
	                        this._viewSelection.originalSelection = this._ref(json.selection);
	                }

	                if (json.activeCell) {
	                    var activeCellRef = this._ref(json.activeCell);

	                    this._viewSelection._activeCell = activeCellRef.toRangeRef();
	                    this._viewSelection.originalActiveCell = activeCellRef.first();
	                }


	                if (json.mergedCells) {
	                    json.mergedCells.forEach(function(ref) {
	                       this.range(ref).merge();
	                    }, this);
	                }

	                if (json.sort) {
	                    this._sort = {
	                        ref: this._ref(json.sort.ref),
	                        columns: json.sort.columns.slice(0)
	                    };
	                }

	                if (json.filter) {
	                    var ref = json.filter.ref;
	                    var columns = json.filter.columns  === undefined ? [] : json.filter.columns;

	                    if (!ref) {
	                        kendo.logToConsole("Dropping filter for sheet '" + json.name + "' due to missing ref");
	                    } else {
	                        this._filter = {
	                            ref: this._ref(ref),
	                            columns: columns.map(function(column) {
	                                return {
	                                    index: column.index,
	                                    filter: kendo.spreadsheet.Filter.create(column)
	                                };
	                            })
	                        };

	                        this._refreshFilter();
	                    }
	                }

	                if (json.showGridLines !== undefined) {
	                    this._showGridLines = json.showGridLines;
	                }

	                this._gridLinesColor = json.gridLinesColor;
	            });

	            this._rows._refresh();
	            this._columns._refresh();
	        },

	        formula: function(ref) {
	            return this._properties.get("formula", this._grid.cellRefIndex(ref));
	        },

	        validation: function(ref) {
	            return this._properties.get("validation", this._grid.cellRefIndex(ref));
	        },

	        // NOTE: resetFormulas should be called first.  We don't do it in this
	        // function because it should be done from the Workbook object for all
	        // sheets.
	        resetFormulas: function() {
	            this._forFormulas(function(formula){
	                formula.reset();
	            });
	        },

	        resetValidations: function() {
	            this._forValidations(function(validation){
	                validation.reset();
	            });
	        },

	        recalc: function(context, callback) {
	            var formulas = this._properties.get("formula").values();
	            var count = formulas.length, pending = 0, i = 0;
	            if (!count && callback) {
	                return callback();
	            }
	            function next() {
	                pending--;
	                if (i == count && !pending) {
	                    callback();
	                }
	            }
	            while (i < count) {
	                pending++;
	                formulas[i++].value.exec(context, callback ? next : null);
	            }
	        },

	        revalidate: function(context) {
	            var self = this;
	            this._forValidations(function(validation){
	                var cellRef = new CellRef(validation.row, validation.col);
	                var ref =  new RangeRef(cellRef, cellRef);
	                validation.exec(context, self._get(ref, "value"), self._get(ref, "format"));
	            });
	        },

	        _value: function(row, col, value) {
	            var index = this._grid.index(row, col);

	            if (value !== undefined) {
	                this._properties.set("value", index, index, value);
	            } else {
	                return this._properties.get("value", index);
	            }
	        },

	        _validation: function(row, col) {
	            var index = this._grid.index(row, col);

	            return this._properties.get("validation", index);
	        },

	        _compileValidation: function(row, col, validation) {
	            if (validation instanceof kendo.spreadsheet.validation.Validation) {
	                // do not alter an existing object.
	                return validation.clone(this._name(), row, col);
	            }

	            if (validation.from != null) { // jshint ignore: line
	                validation.from = (validation.from + "").replace(/^=/, "");
	            }

	            if (validation.to != null) { // jshint ignore: line
	                validation.to = (validation.to + "").replace(/^=/, "");
	            }

	            return kendo.spreadsheet.validation.compile(this._name(), row, col, validation);
	        },

	        _compileFormula: function(row, col, f) {
	            f = f.replace(/^=/, "");
	            f = kendo.spreadsheet.calc.parseFormula(this._name(), row, col, f);
	            return kendo.spreadsheet.calc.compile(f);
	        },

	        _copyValuesInRange: function (topLeft, bottomRight, value, property) {
	            var ci, start, end;

	            for (ci = topLeft.col; ci <= bottomRight.col; ci++) {
	                start = this._grid.index(topLeft.row, ci);
	                end = this._grid.index(bottomRight.row, ci);
	                for (var index = start, row = topLeft.row; index <= end; ++index, ++row) {
	                    // Even if it's the same formula in multiple cells, we
	                    // need to have different Formula objects, hence cloning
	                    // it.  Don't worry, clone() is fast.
	                    value = value.clone(this._name(), row, ci);
	                    this._properties.set(property, index, index, value);
	                }
	            }
	            return value;
	        },

	        _set: function(ref, name, value) {
	            var topLeft = this._grid.normalize(ref.topLeft);
	            var bottomRight = this._grid.normalize(ref.bottomRight);
	            var ci, start, end;

	            if (typeof value == "number") {
	                // Apparently, Excel (and LibreOffice and Google
	                // Sheets) will limit precision to 14 digits; type:
	                // -4.2524999999999995 and you get -4.2525.  The
	                // formula engine already does something similar for
	                // intermediate formula results, but we must do it
	                // here as well for original input values.
	                value = kendo.spreadsheet.calc.runtime.limitPrecision(value);
	            }

	            if (value && name == "formula") {
	                if (typeof value == "string") {
	                    // get Formula object.  we don't care about handling errors
	                    // here since it won't be called interactively.
	                    value = this._compileFormula(topLeft.row, topLeft.col, value);
	                }

	                value = this._copyValuesInRange(topLeft, bottomRight, value, "formula");

	            } else if (value && name == "validation") {
	                value = this._compileValidation(topLeft.row, topLeft.col, value);
	                value = this._copyValuesInRange(topLeft, bottomRight, value, "validation");

	            } else {
	                for (ci = topLeft.col; ci <= bottomRight.col; ci++) {
	                    start = this._grid.index(topLeft.row, ci);
	                    end = this._grid.index(bottomRight.row, ci);
	                    this._properties.set(name, start, end, value);
	                    if (name == "formula") {
	                        // removing a formula, must clear value.
	                        this._properties.set("value", start, end, null);
	                    }
	                }
	            }
	        },

	        _get: function(ref, name) {
	            var topLeft = this._grid.normalize(ref.topLeft);

	            var index = this._grid.index(topLeft.row, topLeft.col);

	            return this._properties.get(name, index);
	        },

	        batch: function(callback, reason) {
	            var suspended = this.suspendChanges();

	            this.suspendChanges(true);

	            callback.call(this);

	            return this.suspendChanges(suspended).triggerChange(reason || { recalc: true });
	        },

	        _sortBy: function(ref, columns) {
	            var indices = null;

	            columns.forEach(function(column) {
	                indices = this._sorter.sortBy(ref, column.index, this._properties.get("value"), column.ascending, indices);
	            }, this);

	            this._sort = {
	                ref: ref,
	                columns: columns
	            };

	            this._refreshFilter();

	            this.forEach(ref, function(row, col, props) {
	                var formula = props.formula;
	                if (formula) {
	                    var diff = row - formula.row;
	                    if (diff !== 0) {
	                        var start = diff > 0 ? formula.row : formula.row + diff;
	                        formula.adjust(this.name(), "row", start, diff);
	                    }
	                }
	            }.bind(this));

	            this.triggerChange({ recalc: true });
	        },

	        _refreshFilter: function() {
	            if (this._filter) {
	                this._filterBy(this._filter.ref, this._filter.columns);
	            }
	        },

	        _filterBy: function(ref, columns) {
	            this.batch(function() {
	                for (var ri = ref.topLeft.row; ri <= ref.bottomRight.row; ri++) {
	                    if (this.isFilteredRow(ri)) {
	                        this._filteredRows.value(ri, ri, false);
	                        this._rows.unhide(ri);
	                    }
	                }

	                columns.forEach(function(column) {
	                    // do not filter header row
	                    var columnRef = ref.resize({ top: 1 }).toColumn(column.index);

	                    var cells = [];

	                    if (columnRef === kendo.spreadsheet.NULLREF) {
	                        return;
	                    }

	                    this.forEach(columnRef, function(row, col, cell) {
	                        cell.row = row;
	                        cells.push(cell);
	                    });

	                    column.filter.prepare(cells);

	                    for (var ci = 0; ci < cells.length; ci++) {
	                        var cell = cells[ci];
	                        var value = column.filter.value(cell);

	                        if (column.filter.matches(value) === false) {
	                            this._filterRow(cell.row);
	                        }
	                    }
	                }, this);

	                this._filter = {
	                    ref: ref,
	                    columns: columns
	                };
	            }, { recalc: true, layout: true, filter: true });
	        },

	        filterColumn: function(ref) {
	            var filterRef = this.filter().ref;
	            return ref.toRangeRef().topLeft.col - filterRef.topLeft.col;
	        },

	        filter: function() {
	            return this._filter;
	        },

	        clearFilter: function(spec) {
	            this._clearFilter(spec instanceof Array ? spec : [spec]);
	        },

	        _clearFilter: function(indices) {
	            if (this._filter) {
	                this.batch(function() {
	                    this._filter.columns = this._filter.columns.filter(function(column) {
	                        return indices.indexOf(column.index) < 0;
	                    });

	                    this._refreshFilter();
	                }, { recalc: true, layout: true, filter: true });
	            }
	        },

	        getAxisState: function() {
	            return {
	                rows: this._rows.getState(),
	                columns: this._columns.getState()
	            };
	        },

	        setAxisState: function(state) {
	            this._rows.setState(state.rows);
	            this._columns.setState(state.columns);
	            this.triggerChange({ layout: true });
	        },

	        getState: function() {
	            return {
	                rows: this._rows.getState(),
	                columns: this._columns.getState(),
	                mergedCells: this._mergedCells.map(function(cell) { return cell.clone(); }),
	                properties: this._properties.getState()
	            };
	        },

	        setState: function(state) {
	            this._rows.setState(state.rows);
	            this._columns.setState(state.columns);
	            this._mergedCells = state.mergedCells;
	            this._properties.setState(state.properties);
	            this.triggerChange(kendo.spreadsheet.ALL_REASONS);
	        },

	        _merge: function(ref) {
	            var mergedCells = this._mergedCells;

	            var sheet = this;
	            var mergedRef;
	            this.batch(function() {
	                mergedRef = ref.map(function(ref) {
	                    if (ref instanceof kendo.spreadsheet.CellRef) {
	                        return ref;
	                    }

	                    var currentRef = ref.toRangeRef().union(mergedCells, function(ref) {
	                        mergedCells.splice(mergedCells.indexOf(ref), 1);
	                    });

	                    var range = new Range(currentRef, sheet);
	                    var formula = range._get("formula");
	                    var value = range.value();
	                    var format = range.format();
	                    var background = range.background();

	                    range.value(null);
	                    range.format(null);
	                    range.background(null);

	                    var topLeft = new Range(currentRef.collapse(), sheet);

	                    if (formula) {
	                        topLeft._set("formula", formula);
	                    } else {
	                        topLeft.value(value);
	                    }
	                    topLeft.format(format);
	                    topLeft.background(background);

	                    mergedCells.push(currentRef);
	                    return currentRef;
	                });

	                var viewSelection = sheet._viewSelection;

	                viewSelection.selection = sheet.unionWithMerged(viewSelection.originalSelection);
	                viewSelection._activeCell = sheet.unionWithMerged(viewSelection.originalActiveCell);
	            }, { activeCell: true, selection: true });

	            return mergedRef;
	        },

	        _useCultureDecimals: function() {
	            return this._workbook && this._workbook.options.useCultureDecimals;
	        },

	        withCultureDecimals: function(f) {
	            var dot = ".";
	            if (this._useCultureDecimals()) {
	                dot = kendo.culture().numberFormat["."];
	            }
	            return kendo.spreadsheet.calc.withDecimalSeparator(dot, f);
	        },

	        drawingBoundingBox: function(drawing) {
	            var left = drawing.offsetX;
	            var top = drawing.offsetY;
	            if (drawing.topLeftCell) {
	                // offsets are relative to cell
	                left += this._columns.sum(0, drawing.topLeftCell.col - 1);
	                top += this._rows.sum(0, drawing.topLeftCell.row - 1);
	            }
	            return new kendo.spreadsheet.Rectangle(left, top, drawing.width, drawing.height);
	        },

	        refBoundingBox: function(ref) {
	            return this._grid.rectangle(ref.toRangeRef());
	        },

	        addDrawing: function(drw, activate) {
	            if (!(drw instanceof Drawing)) {
	                drw = new Drawing(drw);
	            }
	            this._drawings.push(drw);
	            if (activate) {
	                this._activeDrawing = drw;
	            }
	            this.triggerChange({ layout: true });
	            return drw;
	        },

	        removeDrawing: function(drawing) {
	            var pos = this._drawings.indexOf(drawing);
	            if (pos >= 0) {
	                this._drawings.splice(pos, 1);
	                this.triggerChange({ layout: true });
	            }
	        },

	        usesImage: function(img) {
	            for (var i = this._drawings.length; --i >= 0;) {
	                if (this._drawings[i].image === img) {
	                    return true;
	                }
	            }
	            return false;
	        }
	    });

	    var Drawing = kendo.Class.extend({
	        init: function Drawing(args) {
	            this.reset(args);
	        },

	        toJSON: function() {
	            return {
	                topLeftCell: this.topLeftCell.toString(),
	                offsetX: this.offsetX,
	                offsetY: this.offsetY,
	                width: this.width,
	                height: this.height,
	                image: this.image,
	                opacity: this.opacity
	            };
	        },

	        clone: function() {
	            return new Drawing(this);
	        },

	        reset: function(dr) {
	            var anchor = dr.topLeftCell;
	            if (typeof anchor == "string") {
	                anchor = kendo.spreadsheet.calc.parseReference(anchor);
	            }
	            this.topLeftCell = anchor;
	            this.offsetX = dr.offsetX || 0;
	            this.offsetY = dr.offsetY || 0;
	            this.width = dr.width;
	            this.height = dr.height;
	            this.image = dr.image;
	            this.opacity = dr.opacity != null ? dr.opacity : 1;
	        },

	        eq: function(dr) {
	            return ((!this.topLeftCell && !dr.topLeftCell)
	                    || (this.topLeftCell && dr.topLeftCell
	                        && this.topLeftCell.eq(dr.topLeftCell)))
	                && this.offsetX === dr.offsetX
	                && this.offsetY === dr.offsetY
	                && this.width === dr.width
	                && this.height === dr.height
	                && this.image === dr.image
	                && this.opacity === dr.opacity;
	        }
	    });

	    Drawing.fromJSON = function(args) {
	        return new Drawing(args);
	    };

	    kendo.spreadsheet.Sheet = Sheet;
	    kendo.spreadsheet.Drawing = Drawing;
	})(kendo);

	}, __webpack_require__(3));


/***/ }),

/***/ 1624:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("kXT1");

/***/ })

/******/ });

/***/ }),

/***/ "+Uqz":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1074);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1074:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1049), __webpack_require__(1075)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function () {

	    var __meta__ = { // jshint ignore:line
	        id: "button",
	        name: "Button",
	        category: "web",
	        description: "The Button widget displays styled buttons.",
	        depends: ["core", "badge"]
	    };

	    (function ($, undefined) {
	        var kendo = window.kendo,
	            Widget = kendo.ui.Widget,
	            ui = kendo.ui,
	            proxy = $.proxy,
	            keys = kendo.keys,
	            CLICK = "click",
	            MOUSEDOWN = kendo.support.mousedown,
	            MOUSEUP = kendo.support.mouseup,
	            MOUSEOUT = "mouseout",
	            KBUTTON = "k-button",
	            KBUTTONICON = "k-button-icon",
	            KBUTTONICONTEXT = "k-button-icontext",
	            NS = ".kendoButton",
	            DISABLED = "disabled",
	            DISABLEDSTATE = "k-state-disabled",
	            FOCUSEDSTATE = "k-state-focused",
	            SELECTEDSTATE = "k-state-active";

	        var BUTTON_DEFAULTS = {
	            icon: "",
	            iconClass: "",
	            spriteCssClass: "",
	            imageUrl: "",
	            badge: null
	        };
	        kendo.setDefaults("button", BUTTON_DEFAULTS);

	        var Button = Widget.extend({
	            init: function (element, options) {
	                var that = this;

	                Widget.fn.init.call(that, element, options);

	                element = that.wrapper = that.element;
	                options = that.options;

	                element.addClass(KBUTTON).attr("role", "button");

	                options.enable = options.enable && options.enabled && !element.attr(DISABLED);
	                that.enable(options.enable);

	                if (options.enable) {
	                    that._tabindex();
	                }

	                that._badge();

	                that.iconElement();

	                element
	                    .on(CLICK + NS, proxy(that._click, that))
	                    .on("focus" + NS, proxy(that._focus, that))
	                    .on("blur" + NS, proxy(that._blur, that))
	                    .on("keydown" + NS, proxy(that._keydown, that))
	                    .on("keyup" + NS, proxy(that._removeActive, that))
	                    .on(MOUSEDOWN + NS, proxy(that._addActive, that))
	                    .on(MOUSEUP + NS  + " " + MOUSEOUT + NS, proxy(that._removeActive, that));

	                kendo.notify(that);
	            },

	            destroy: function() {
	                var that = this;

	                that.wrapper.off(NS);

	                if (that.badge){
	                    that.badge.destroy();
	                }

	                Widget.fn.destroy.call(that);
	            },

	            events: [
	                CLICK
	            ],

	            options: {
	                name: "Button",
	                enable: true,
	                enabled: true,
	                icon: "",
	                iconClass: "",
	                spriteCssClass: "",
	                imageUrl: "",
	                badge: null
	            },

	            _isNativeButton: function() {
	                return this.element.prop("tagName").toLowerCase() == "button";
	            },

	            _click: function(e) {
	                if (this.options.enable) {
	                    if (this.trigger(CLICK, { event: e })) {
	                        e.preventDefault();
	                    }
	                }
	            },

	            _focus: function() {
	                if (this.options.enable) {
	                    this.element.addClass(FOCUSEDSTATE);
	                }
	            },

	            _blur: function() {
	                var that = this;
	                that.element.removeClass(FOCUSEDSTATE);
	                setTimeout(function() {
	                    that.element.removeClass(SELECTEDSTATE);
	                });
	            },

	            _keydown: function(e) {
	                var that = this;
	                if (e.keyCode == keys.ENTER || e.keyCode == keys.SPACEBAR) {
	                    that._addActive();

	                    if (!that._isNativeButton()) {
	                        if (e.keyCode == keys.SPACEBAR) {
	                            e.preventDefault();
	                        }
	                        that._click(e);
	                    }
	                }
	            },

	            _removeActive: function() {
	                this.element.removeClass(SELECTEDSTATE);
	            },

	            _addActive: function() {
	                if (this.options.enable) {
	                    this.element.addClass(SELECTEDSTATE);
	                }
	            },

	            iconElement: function() {
	                var that = this,
	                    element = that.element,
	                    options = that.options,
	                    icon = options.icon,
	                    iconClass = options.iconClass,
	                    spriteCssClass = options.spriteCssClass,
	                    imageUrl = options.imageUrl,
	                    span, img, isEmpty;

	                if (spriteCssClass || imageUrl || icon || iconClass) {
	                    isEmpty = true;

	                    element.contents().filter(function() {
	                        return (!$(this).hasClass("k-sprite") && !$(this).hasClass("k-icon") && !$(this).hasClass("k-image"));
	                    }).each(function(idx, el){
	                        if (el.nodeType == 1 || el.nodeType == 3 && kendo.trim(el.nodeValue).length > 0) {
	                            isEmpty = false;
	                        }
	                    });

	                    if (isEmpty) {
	                        element.addClass(KBUTTONICON);
	                    } else {
	                        element.addClass(KBUTTONICONTEXT);
	                    }
	                }

	                if (imageUrl) {
	                    img = element.children("img.k-image").first();
	                    if (!img[0]) {
	                        img = $('<img alt="icon" class="k-image" />').prependTo(element);
	                    }
	                    img.attr("src", imageUrl);
	                } else if (icon || iconClass) {
	                    span = element.children("span.k-icon").first();
	                    if (!span[0]) {
	                        span = $('<span></span>').prependTo(element);
	                    }
	                    span.attr("class", icon ? "k-icon k-i-" + icon : iconClass);
	                } else if (spriteCssClass) {
	                    span = element.children("span.k-sprite").first();
	                    if (!span[0]) {
	                        span = $('<span class="k-sprite"></span>').prependTo(element);
	                    }
	                    span.addClass(spriteCssClass);
	                }
	            },

	            enable: function(enable) {
	                var that = this,
	                    element = that.element;

	                if (enable === undefined) {
	                    enable = true;
	                }

	                enable = !!enable;
	                that.options.enable = enable;
	                element.toggleClass(DISABLEDSTATE, !enable)
	                    .attr("aria-disabled", !enable)
	                    .attr(DISABLED, !enable);

	                if (enable) {
	                    that._tabindex();
	                }

	                // prevent 'Unspecified error' in IE when inside iframe
	                try {
	                    element.blur();
	                } catch (err) {}
	            },

	            _badge: function() {
	                var that = this;
	                var badgeOptions = that.options.badge;
	                var badgeEelement;

	                if (badgeOptions === null || badgeOptions === undefined) {
	                    return;
	                }

	                if (badgeOptions.constructor !== Object) {
	                    badgeOptions = { text: badgeOptions };
	                }

	                if (badgeOptions.position === undefined || badgeOptions.position === "") {
	                    badgeOptions.position = "edge";

	                    if (badgeOptions.align === undefined || badgeOptions.align === "") {
	                        badgeOptions.align = "top end";
	                    }
	                }

	                badgeOptions._classNames = ["k-button-badge"];

	                that.element.addClass("k-badge-container");

	                badgeEelement = $('<span />').appendTo(that.element);
	                that.badge = new ui.Badge(badgeEelement, badgeOptions);
	            }
	        });

	        if (Button.fn.hasOwnProperty("defaults") === false) {
	            Object.defineProperty(Button.fn, "defaults", {
	                get: function() {
	                    return kendo.defaults.button;
	                }
	            });
	        }

	        kendo.ui.plugin(Button);

	    })(window.kendo.jQuery);

	    return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1075:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("BHwR");

/***/ })

/******/ });

/***/ }),

/***/ "+X3p":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1138);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1069:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("jBxA");

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FZAa");

/***/ }),

/***/ 1103:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7Omp");

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1110:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nzx/");

/***/ }),

/***/ 1138:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1059), __webpack_require__(1088), __webpack_require__(1103), __webpack_require__(1069), __webpack_require__(1109),
	        __webpack_require__(1110),

	        __webpack_require__(1140),
	        __webpack_require__(1141),
	        __webpack_require__(1142),
	        __webpack_require__(1139),
	        __webpack_require__(1143),
	        __webpack_require__(1144),
	        __webpack_require__(1145),
	        __webpack_require__(1146),
	        __webpack_require__(1147),
	        __webpack_require__(1148),
	        __webpack_require__(1149),
	        __webpack_require__(1150)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	    var __meta__ = { // jshint ignore:line
	        id: "dataviz.map",
	        name: "Map",
	        category: "dataviz",
	        description: "The Kendo DataViz Map displays spatial data",
	        depends: [ "data", "userevents", "tooltip", "dataviz.core", "drawing", "mobile.scroller" ]
	    };

	    return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1139:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("M6Jv");

/***/ }),

/***/ 1140:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("pV45");

/***/ }),

/***/ 1141:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("R2J4");

/***/ }),

/***/ 1142:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("6har");

/***/ }),

/***/ 1143:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ddUy");

/***/ }),

/***/ 1144:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Rqq1");

/***/ }),

/***/ 1145:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("5Y6m");

/***/ }),

/***/ 1146:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("OJgz");

/***/ }),

/***/ 1147:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("uC7k");

/***/ }),

/***/ 1148:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("j74h");

/***/ }),

/***/ 1149:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Jrhv");

/***/ }),

/***/ 1150:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("kQPp");

/***/ })

/******/ });

/***/ }),

/***/ "+Y9o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var Events = (function () {
    function Events() {
    }
    /** Everything has changed with the columns. Either complete new set of columns set, or user called setState()*/
    Events.EVENT_COLUMN_EVERYTHING_CHANGED = 'columnEverythingChanged';
    /** User has set in new columns. */
    Events.EVENT_NEW_COLUMNS_LOADED = 'newColumnsLoaded';
    /** The pivot mode flag was changed */
    Events.EVENT_COLUMN_PIVOT_MODE_CHANGED = 'columnPivotModeChanged';
    /** A row group column was added, removed or order changed. */
    Events.EVENT_COLUMN_ROW_GROUP_CHANGED = 'columnRowGroupChanged';
    /** A pivot column was added, removed or order changed. */
    Events.EVENT_COLUMN_PIVOT_CHANGED = 'columnPivotChanged';
    /** The list of grid columns has changed. */
    Events.EVENT_GRID_COLUMNS_CHANGED = 'gridColumnsChanged';
    /** A value column was added, removed or agg function was changed. */
    Events.EVENT_COLUMN_VALUE_CHANGED = 'columnValueChanged';
    /** A column was moved */
    Events.EVENT_COLUMN_MOVED = 'columnMoved';
    /** One or more columns was shown / hidden */
    Events.EVENT_COLUMN_VISIBLE = 'columnVisible';
    /** One or more columns was pinned / unpinned*/
    Events.EVENT_COLUMN_PINNED = 'columnPinned';
    /** A column group was opened / closed */
    Events.EVENT_COLUMN_GROUP_OPENED = 'columnGroupOpened';
    /** One or more columns was resized. If just one, the column in the event is set. */
    Events.EVENT_COLUMN_RESIZED = 'columnResized';
    /** The list of displayed columns has changed, can result from columns open / close, column move, pivot, group, etc */
    Events.EVENT_DISPLAYED_COLUMNS_CHANGED = 'displayedColumnsChanged';
    /** The list of virtual columns has changed, results from viewport changing */
    Events.EVENT_VIRTUAL_COLUMNS_CHANGED = 'virtualColumnsChanged';
    /** A row group was opened / closed */
    Events.EVENT_ROW_GROUP_OPENED = 'rowGroupOpened';
    /** The client has set new data into the grid */
    Events.EVENT_ROW_DATA_CHANGED = 'rowDataChanged';
    /** The client has updated data for the grid */
    Events.EVENT_ROW_DATA_UPDATED = 'rowDataUpdated';
    /** The client has set new floating data into the grid */
    Events.EVENT_PINNED_ROW_DATA_CHANGED = 'pinnedRowDataChanged';
    /** Range selection has changed */
    Events.EVENT_RANGE_SELECTION_CHANGED = 'rangeSelectionChanged';
    /** Model was updated - grid updates the drawn rows when this happens */
    Events.EVENT_MODEL_UPDATED = 'modelUpdated';
    Events.EVENT_CELL_CLICKED = 'cellClicked';
    Events.EVENT_CELL_DOUBLE_CLICKED = 'cellDoubleClicked';
    Events.EVENT_CELL_CONTEXT_MENU = 'cellContextMenu';
    Events.EVENT_CELL_VALUE_CHANGED = 'cellValueChanged';
    Events.EVENT_ROW_VALUE_CHANGED = 'rowValueChanged';
    Events.EVENT_CELL_FOCUSED = 'cellFocused';
    Events.EVENT_ROW_SELECTED = 'rowSelected';
    Events.EVENT_SELECTION_CHANGED = 'selectionChanged';
    Events.EVENT_CELL_MOUSE_OVER = 'cellMouseOver';
    Events.EVENT_CELL_MOUSE_OUT = 'cellMouseOut';
    /** 2 events for filtering. The grid LISTENS for filterChanged and afterFilterChanged */
    Events.EVENT_FILTER_CHANGED = 'filterChanged';
    /** Filter was change but not applied. Only useful if apply buttons are used in filters. */
    Events.EVENT_FILTER_MODIFIED = 'filterModified';
    Events.EVENT_SORT_CHANGED = 'sortChanged';
    /** A row was removed from the dom, for any reason. Use to clean up resources (if any) used by the row. */
    Events.EVENT_VIRTUAL_ROW_REMOVED = 'virtualRowRemoved';
    Events.EVENT_ROW_CLICKED = 'rowClicked';
    Events.EVENT_ROW_DOUBLE_CLICKED = 'rowDoubleClicked';
    /** Gets called once after the grid has finished initialising. */
    Events.EVENT_GRID_READY = 'gridReady';
    /** Width of height of the main grid div has changed. Grid listens for this and does layout of grid if it's
     * changed, so always filling the space it was given. */
    Events.EVENT_GRID_SIZE_CHANGED = 'gridSizeChanged';
    /** The indexes of the rows rendered has changed, eg user has scrolled to a new vertical position. */
    Events.EVENT_VIEWPORT_CHANGED = 'viewportChanged';
    /** A column drag has started, either resizing a column or moving a column. */
    Events.EVENT_DRAG_STARTED = 'dragStarted';
    /** A column drag has stopped */
    Events.EVENT_DRAG_STOPPED = 'dragStopped';
    Events.EVENT_ROW_EDITING_STARTED = 'rowEditingStarted';
    Events.EVENT_ROW_EDITING_STOPPED = 'rowEditingStopped';
    Events.EVENT_CELL_EDITING_STARTED = 'cellEditingStarted';
    Events.EVENT_CELL_EDITING_STOPPED = 'cellEditingStopped';
    /** Main body of grid has scrolled, either horizontally or vertically */
    Events.EVENT_BODY_SCROLL = 'bodyScroll';
    /** The displayed page for pagination has changed. For example the data was filtered or sorted,
     * or the user has moved to a different page. */
    Events.EVENT_PAGINATION_CHANGED = 'paginationChanged';
    /** Only used by React, Angular 2+, Web Components, Aurelia and VueJS ag-Grid components
     * (not used if doing plain JavaScript or Angular 1.x). If the grid receives changes due
     * to bound properties, this event fires after the grid has finished processing the change. */
    Events.EVENT_COMPONENT_STATE_CHANGED = 'componentStateChanged';
    /** All items from here down are used internally by the grid, not intended for external use. */
    // not documented, either experimental, or we just don't want users using an depending on them
    Events.EVENT_BODY_HEIGHT_CHANGED = 'bodyHeightChanged';
    Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED = 'displayedColumnsWidthChanged';
    Events.EVENT_SCROLL_VISIBILITY_CHANGED = 'scrollVisibilityChanged';
    Events.EVENT_COLUMN_HOVER_CHANGED = 'columnHoverChanged';
    Events.EVENT_FLASH_CELLS = 'flashCells';
    Events.EVENT_ROW_DRAG_ENTER = 'rowDragEnter';
    Events.EVENT_ROW_DRAG_MOVE = 'rowDragMove';
    Events.EVENT_ROW_DRAG_LEAVE = 'rowDragLeave';
    Events.EVENT_ROW_DRAG_END = 'rowDragEnd';
    // these are used for server side group and agg - only used by CS with Viewport Row Model - intention is
    // to design these better around server side functions and then release to general public when fully working with
    // all the row models.
    Events.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST = 'columnRowGroupChangeRequest';
    Events.EVENT_COLUMN_PIVOT_CHANGE_REQUEST = 'columnPivotChangeRequest';
    Events.EVENT_COLUMN_VALUE_CHANGE_REQUEST = 'columnValueChangeRequest';
    Events.EVENT_COLUMN_AGG_FUNC_CHANGE_REQUEST = 'columnAggFuncChangeRequest';
    return Events;
}());
exports.Events = Events;


/***/ }),

/***/ "+ZMJ":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("lOnJ");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "/0gA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("7+uW");

var Vue = _interopRequireWildcard(_vue);

var _KendoAutoCompleteMixin = __webpack_require__("/mbW");

var _KendoAutoCompleteMixin2 = _interopRequireDefault(_KendoAutoCompleteMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-autocomplete',
    mixins: [_KendoAutoCompleteMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('input', [this.$slots['kendo-datasource']]);
    }
};

/***/ }),

/***/ "/3L8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var rangeController_1 = __webpack_require__("PH8O");
var ClipboardService = (function () {
    function ClipboardService() {
    }
    ClipboardService.prototype.init = function () {
        this.logger = this.loggerFactory.create('ClipboardService');
    };
    ClipboardService.prototype.pasteFromClipboard = function () {
        var _this = this;
        this.logger.log('pasteFromClipboard');
        this.executeOnTempElement(function (textArea) {
            textArea.focus();
        }, function (element) {
            var text = element.value;
            _this.finishPasteFromClipboard(text);
        });
    };
    ClipboardService.prototype.copyRangeDown = function () {
        var _this = this;
        if (this.rangeController.isEmpty()) {
            return;
        }
        var cellsToFlash = {};
        var firstRowValues = null;
        var updatedRowNodes = [];
        var updatedColumnIds = [];
        var rowCallback = function (currentRow, rowNode, columns) {
            // take reference of first row, this is the one we will be using to copy from
            if (!firstRowValues) {
                firstRowValues = [];
                // two reasons for looping through columns
                columns.forEach(function (column) {
                    // reason 1 - to get the initial values to copy down
                    var value = _this.valueService.getValue(column, rowNode);
                    var processCellForClipboardFunc = _this.gridOptionsWrapper.getProcessCellForClipboardFunc();
                    value = _this.userProcessCell(rowNode, column, value, processCellForClipboardFunc, main_1.Constants.EXPORT_TYPE_DRAG_COPY);
                    firstRowValues.push(value);
                    // reason 2 - to record the columnId for refreshing
                    updatedColumnIds.push(column.getId());
                });
            }
            else {
                // otherwise we are not the first row, so copy
                updatedRowNodes.push(rowNode);
                columns.forEach(function (column, index) {
                    if (!column.isCellEditable(rowNode)) {
                        return;
                    }
                    var firstRowValue = firstRowValues[index];
                    var processCellFromClipboardFunc = _this.gridOptionsWrapper.getProcessCellFromClipboardFunc();
                    firstRowValue = _this.userProcessCell(rowNode, column, firstRowValue, processCellFromClipboardFunc, main_1.Constants.EXPORT_TYPE_DRAG_COPY);
                    _this.valueService.setValue(rowNode, column, firstRowValue);
                    var gridCellDef = { rowIndex: currentRow.rowIndex, floating: currentRow.floating, column: column };
                    var cellId = new main_1.GridCell(gridCellDef).createId();
                    cellsToFlash[cellId] = true;
                });
            }
        };
        this.iterateActiveRanges(true, rowCallback);
        // this is very heavy, should possibly just refresh the specific cells?
        this.rowRenderer.refreshCells({ rowNodes: updatedRowNodes, columns: updatedColumnIds });
        this.dispatchFlashCells(cellsToFlash);
    };
    ClipboardService.prototype.finishPasteFromClipboard = function (data) {
        if (main_1.Utils.missingOrEmpty(data)) {
            return;
        }
        var focusedCell = this.focusedCellController.getFocusedCell();
        if (!focusedCell) {
            return;
        }
        var parsedData = this.dataToArray(data);
        if (!parsedData) {
            return;
        }
        // remove last row if empty, excel puts empty last row in
        var lastLine = parsedData[parsedData.length - 1];
        if (lastLine.length === 1 && lastLine[0] === '') {
            main_1.Utils.removeFromArray(parsedData, lastLine);
        }
        var currentRow = new main_1.GridRow(focusedCell.rowIndex, focusedCell.floating);
        var cellsToFlash = {};
        var updatedRowNodes = [];
        var updatedColumnIds = [];
        var columnsToPasteInto = this.columnController.getDisplayedColumnsStartingAt(focusedCell.column);
        var onlyOneCellInRange = parsedData.length === 1 && parsedData[0].length === 1;
        if (onlyOneCellInRange) {
            this.singleCellRange(parsedData, updatedRowNodes, currentRow, cellsToFlash, updatedColumnIds);
        }
        else {
            this.multipleCellRange(parsedData, currentRow, updatedRowNodes, columnsToPasteInto, cellsToFlash, updatedColumnIds, main_1.Constants.EXPORT_TYPE_CLIPBOARD);
        }
        // this is very heavy, should possibly just refresh the specific cells?
        this.rowRenderer.refreshCells({ rowNodes: updatedRowNodes, columns: updatedColumnIds });
        this.dispatchFlashCells(cellsToFlash);
        this.focusedCellController.setFocusedCell(focusedCell.rowIndex, focusedCell.column, focusedCell.floating, true);
    };
    ClipboardService.prototype.multipleCellRange = function (clipboardGridData, currentRow, updatedRowNodes, columnsToPasteInto, cellsToFlash, updatedColumnIds, type) {
        var _this = this;
        clipboardGridData.forEach(function (clipboardRowData) {
            // if we have come to end of rows in grid, then skip
            if (!currentRow) {
                return;
            }
            var rowNode = _this.getRowNode(currentRow);
            updatedRowNodes.push(rowNode);
            clipboardRowData.forEach(function (value, index) {
                var column = columnsToPasteInto[index];
                if (main_1.Utils.missing(column)) {
                    return;
                }
                if (!column.isCellEditable(rowNode)) {
                    return;
                }
                _this.updateCellValue(rowNode, column, value, currentRow, cellsToFlash, updatedColumnIds, type);
            });
            // move to next row down for next set of values
            currentRow = _this.cellNavigationService.getRowBelow(currentRow);
        });
        return currentRow;
    };
    ClipboardService.prototype.singleCellRange = function (parsedData, updatedRowNodes, currentRow, cellsToFlash, updatedColumnIds) {
        var _this = this;
        var value = parsedData[0][0];
        var rowCallback = function (gridRow, rowNode, columns) {
            updatedRowNodes.push(rowNode);
            columns.forEach(function (column) {
                if (column.isCellEditable(rowNode)) {
                    _this.updateCellValue(rowNode, column, value, currentRow, cellsToFlash, updatedColumnIds, main_1.Constants.EXPORT_TYPE_CLIPBOARD);
                }
            });
        };
        this.iterateActiveRanges(false, rowCallback);
    };
    ClipboardService.prototype.updateCellValue = function (rowNode, column, value, currentRow, cellsToFlash, updatedColumnIds, type) {
        if (column.isSuppressPaste(rowNode)) {
            return;
        }
        var processedValue = this.userProcessCell(rowNode, column, value, this.gridOptionsWrapper.getProcessCellFromClipboardFunc(), type);
        this.valueService.setValue(rowNode, column, processedValue);
        var gridCellDef = {
            rowIndex: currentRow.rowIndex,
            floating: currentRow.floating,
            column: column
        };
        var cellId = new main_1.GridCell(gridCellDef).createId();
        cellsToFlash[cellId] = true;
        if (updatedColumnIds.indexOf(column.getId()) < 0) {
            updatedColumnIds.push(column.getId());
        }
    };
    ClipboardService.prototype.copyToClipboard = function (includeHeaders) {
        if (includeHeaders === void 0) { includeHeaders = false; }
        this.logger.log("copyToClipboard: includeHeaders = " + includeHeaders);
        var selectedRowsToCopy = !this.selectionController.isEmpty()
            && !this.gridOptionsWrapper.isSuppressCopyRowsToClipboard();
        // default is copy range if exists, otherwise rows
        if (this.rangeController.isMoreThanOneCell()) {
            this.copySelectedRangeToClipboard(includeHeaders);
        }
        else if (selectedRowsToCopy) {
            // otherwise copy selected rows if they exist
            this.copySelectedRowsToClipboard(includeHeaders);
        }
        else if (this.focusedCellController.isAnyCellFocused()) {
            // if there is a focused cell, copy this
            this.copyFocusedCellToClipboard(includeHeaders);
        }
        else {
            // lastly if no focused cell, try range again. this can happen
            // if use has cellSelection turned off (so no focused cell)
            // but has a cell clicked, so there exists a cell range
            // of exactly one cell (hence the first 'if' above didn't
            // get executed).
            this.copySelectedRangeToClipboard(includeHeaders);
        }
    };
    ClipboardService.prototype.iterateActiveRanges = function (onlyFirst, rowCallback, columnCallback) {
        var _this = this;
        if (this.rangeController.isEmpty()) {
            return;
        }
        var rangeSelections = this.rangeController.getCellRanges();
        if (onlyFirst) {
            var range = rangeSelections[0];
            this.iterateActiveRange(range, rowCallback, columnCallback);
        }
        else {
            rangeSelections.forEach(function (range) { return _this.iterateActiveRange(range, rowCallback, columnCallback); });
        }
    };
    ClipboardService.prototype.iterateActiveRange = function (range, rowCallback, columnCallback) {
        // get starting and ending row, remember rowEnd could be before rowStart
        var startRow = range.start.getGridRow();
        var endRow = range.end.getGridRow();
        var startRowIsFirst = startRow.before(endRow);
        var currentRow = startRowIsFirst ? startRow : endRow;
        var lastRow = startRowIsFirst ? endRow : startRow;
        if (main_1.Utils.exists(columnCallback)) {
            columnCallback(range.columns);
        }
        while (true) {
            var rowNode = this.getRowNode(currentRow);
            rowCallback(currentRow, rowNode, range.columns);
            if (currentRow.equals(lastRow)) {
                break;
            }
            currentRow = this.cellNavigationService.getRowBelow(currentRow);
        }
    };
    ClipboardService.prototype.copySelectedRangeToClipboard = function (includeHeaders) {
        var _this = this;
        if (includeHeaders === void 0) { includeHeaders = false; }
        if (this.rangeController.isEmpty()) {
            return;
        }
        var deliminator = this.gridOptionsWrapper.getClipboardDeliminator();
        var data = '';
        var cellsToFlash = {};
        // adds columns to the data
        var columnCallback = function (columns) {
            if (!includeHeaders) {
                return;
            }
            columns.forEach(function (column, index) {
                var value = _this.columnController.getDisplayNameForColumn(column, 'clipboard', true);
                if (index != 0) {
                    data += deliminator;
                }
                if (main_1.Utils.exists(value)) {
                    data += value;
                }
            });
            data += '\r\n';
        };
        // adds cell values to the data
        var rowCallback = function (currentRow, rowNode, columns) {
            columns.forEach(function (column, index) {
                var value = _this.valueService.getValue(column, rowNode);
                var processedValue = _this.userProcessCell(rowNode, column, value, _this.gridOptionsWrapper.getProcessCellForClipboardFunc(), main_1.Constants.EXPORT_TYPE_CLIPBOARD);
                if (index != 0) {
                    data += deliminator;
                }
                if (main_1.Utils.exists(processedValue)) {
                    data += processedValue;
                }
                var gridCellDef = { rowIndex: currentRow.rowIndex, floating: currentRow.floating, column: column };
                var cellId = new main_1.GridCell(gridCellDef).createId();
                cellsToFlash[cellId] = true;
            });
            data += '\r\n';
        };
        this.iterateActiveRanges(false, rowCallback, columnCallback);
        this.copyDataToClipboard(data);
        this.dispatchFlashCells(cellsToFlash);
    };
    ClipboardService.prototype.copyFocusedCellToClipboard = function (includeHeaders) {
        if (includeHeaders === void 0) { includeHeaders = false; }
        var focusedCell = this.focusedCellController.getFocusedCell();
        if (main_1.Utils.missing(focusedCell)) {
            return;
        }
        var currentRow = focusedCell.getGridRow();
        var rowNode = this.getRowNode(currentRow);
        var column = focusedCell.column;
        var value = this.valueService.getValue(column, rowNode);
        var processedValue = this.userProcessCell(rowNode, column, value, this.gridOptionsWrapper.getProcessCellForClipboardFunc(), main_1.Constants.EXPORT_TYPE_CLIPBOARD);
        if (main_1._.missing(processedValue)) {
            // copy the new line character to clipboard instead of an empty string, as the 'execCommand' will ignore it.
            // this behaviour is consistent with how Excel works!
            processedValue = '\n';
        }
        var data = '';
        if (includeHeaders) {
            data = this.columnController.getDisplayNameForColumn(column, 'clipboard', true) + '\r\n';
        }
        data += processedValue.toString();
        this.copyDataToClipboard(data);
        var cellId = focusedCell.createId();
        var cellsToFlash = {};
        cellsToFlash[cellId] = true;
        this.dispatchFlashCells(cellsToFlash);
    };
    ClipboardService.prototype.dispatchFlashCells = function (cellsToFlash) {
        var _this = this;
        setTimeout(function () {
            var event = {
                type: main_1.Events.EVENT_FLASH_CELLS,
                cells: cellsToFlash,
                api: _this.gridApi,
                columnApi: _this.columnApi
            };
            _this.eventService.dispatchEvent(event);
        }, 0);
    };
    ClipboardService.prototype.userProcessCell = function (rowNode, column, value, func, type) {
        if (func) {
            var params = {
                column: column,
                node: rowNode,
                value: value,
                api: this.gridOptionsWrapper.getApi(),
                columnApi: this.gridOptionsWrapper.getColumnApi(),
                context: this.gridOptionsWrapper.getContext(),
                type: type
            };
            return func(params);
        }
        else {
            return value;
        }
    };
    ClipboardService.prototype.getRowNode = function (gridRow) {
        switch (gridRow.floating) {
            case main_1.Constants.PINNED_TOP:
                return this.pinnedRowModel.getPinnedTopRowData()[gridRow.rowIndex];
            case main_1.Constants.PINNED_BOTTOM:
                return this.pinnedRowModel.getPinnedBottomRowData()[gridRow.rowIndex];
            default:
                return this.rowModel.getRow(gridRow.rowIndex);
        }
    };
    ClipboardService.prototype.copySelectedRowsToClipboard = function (includeHeaders, columnKeys) {
        if (includeHeaders === void 0) { includeHeaders = false; }
        var skipHeader = !includeHeaders;
        var deliminator = this.gridOptionsWrapper.getClipboardDeliminator();
        var params = {
            columnKeys: columnKeys,
            skipHeader: skipHeader,
            skipFooters: true,
            suppressQuotes: true,
            columnSeparator: deliminator,
            onlySelected: true,
            processCellCallback: this.gridOptionsWrapper.getProcessCellForClipboardFunc()
        };
        var data = this.csvCreator.getDataAsCsv(params);
        this.copyDataToClipboard(data);
    };
    ClipboardService.prototype.copyDataToClipboard = function (data) {
        var userProvidedFunc = this.gridOptionsWrapper.getSendToClipboardFunc();
        if (main_1.Utils.exists(userProvidedFunc)) {
            var params = { data: data };
            userProvidedFunc(params);
        }
        else {
            this.executeOnTempElement(function (element) {
                element.value = data;
                element.select();
                element.focus();
                return document.execCommand('copy');
            });
        }
    };
    ClipboardService.prototype.executeOnTempElement = function (callbackNow, callbackAfter) {
        var eTempInput = document.createElement('textarea');
        eTempInput.style.width = '1px';
        eTempInput.style.height = '1px';
        eTempInput.style.top = '0px';
        eTempInput.style.left = '0px';
        eTempInput.style.position = 'absolute';
        eTempInput.style.opacity = '0.0';
        var guiRoot = this.gridCore.getRootGui();
        guiRoot.appendChild(eTempInput);
        try {
            var result = callbackNow(eTempInput);
            this.logger.log('Clipboard operation result: ' + result);
        }
        catch (err) {
            this.logger.log('Browser doesn\t support document.execComment(\'copy\') for clipboard operations');
        }
        //It needs 100 otherwise OS X seemed to not always be able to paste... Go figure...
        if (callbackAfter) {
            setTimeout(function () {
                callbackAfter(eTempInput);
                guiRoot.removeChild(eTempInput);
            }, 100);
        }
        else {
            guiRoot.removeChild(eTempInput);
        }
    };
    // From http://stackoverflow.com/questions/1293147/javascript-code-to-parse-csv-data
    // This will parse a delimited string into an array of arrays.
    // Note: this code fixes an issue with the example posted on stack overflow where it doesn't correctly handle
    // empty values in the first cell.
    ClipboardService.prototype.dataToArray = function (strData) {
        var delimiter = this.gridOptionsWrapper.getClipboardDeliminator();
        // Create a regular expression to parse the CSV values.
        var objPattern = new RegExp((
        // Delimiters.
        "(\\" + delimiter + "|\\r?\\n|\\r|^)" +
            // Quoted fields.
            "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
            // Standard fields.
            "([^\"\\" + delimiter + "\\r\\n]*))"), "gi");
        // Create an array to hold our data. Give the array
        // a default empty first row.
        var arrData = [[]];
        // Create an array to hold our individual pattern matching groups.
        var arrMatches;
        // Required for handling edge case on first row copy
        var atFirstRow = true;
        // Keep looping over the regular expression matches
        // until we can no longer find a match.
        while (arrMatches = objPattern.exec(strData)) {
            // Get the delimiter that was found.
            var strMatchedDelimiter = arrMatches[1];
            // Handles case when first row is an empty cell, insert an empty string before delimiter
            if (atFirstRow && strMatchedDelimiter) {
                arrData[0].push("");
            }
            // Check to see if the given delimiter has a length
            // (is not the start of string) and if it matches
            // field delimiter. If id does not, then we know
            // that this delimiter is a row delimiter.
            if (strMatchedDelimiter.length && strMatchedDelimiter !== delimiter) {
                // Since we have reached a new row of data,
                // add an empty row to our data array.
                arrData.push([]);
            }
            var strMatchedValue = void 0;
            // Now that we have our delimiter out of the way,
            // let's check to see which kind of value we
            // captured (quoted or unquoted).
            if (arrMatches[2]) {
                // We found a quoted value. When we capture
                // this value, unescaped any double quotes.
                strMatchedValue = arrMatches[2].replace(new RegExp("\"\"", "g"), "\"");
            }
            else {
                // We found a non-quoted value.
                strMatchedValue = arrMatches[3];
            }
            // Now that we have our value string, let's add
            // it to the data array.
            arrData[arrData.length - 1].push(strMatchedValue);
            atFirstRow = false;
        }
        // Return the parsed data.
        return arrData;
    };
    __decorate([
        main_1.Autowired('csvCreator'),
        __metadata("design:type", main_1.CsvCreator)
    ], ClipboardService.prototype, "csvCreator", void 0);
    __decorate([
        main_1.Autowired('loggerFactory'),
        __metadata("design:type", main_1.LoggerFactory)
    ], ClipboardService.prototype, "loggerFactory", void 0);
    __decorate([
        main_1.Autowired('selectionController'),
        __metadata("design:type", main_1.SelectionController)
    ], ClipboardService.prototype, "selectionController", void 0);
    __decorate([
        main_1.Autowired('rangeController'),
        __metadata("design:type", rangeController_1.RangeController)
    ], ClipboardService.prototype, "rangeController", void 0);
    __decorate([
        main_1.Autowired('rowModel'),
        __metadata("design:type", Object)
    ], ClipboardService.prototype, "rowModel", void 0);
    __decorate([
        main_1.Autowired('pinnedRowModel'),
        __metadata("design:type", main_1.PinnedRowModel)
    ], ClipboardService.prototype, "pinnedRowModel", void 0);
    __decorate([
        main_1.Autowired('valueService'),
        __metadata("design:type", main_1.ValueService)
    ], ClipboardService.prototype, "valueService", void 0);
    __decorate([
        main_1.Autowired('focusedCellController'),
        __metadata("design:type", main_1.FocusedCellController)
    ], ClipboardService.prototype, "focusedCellController", void 0);
    __decorate([
        main_1.Autowired('rowRenderer'),
        __metadata("design:type", main_1.RowRenderer)
    ], ClipboardService.prototype, "rowRenderer", void 0);
    __decorate([
        main_1.Autowired('columnController'),
        __metadata("design:type", main_1.ColumnController)
    ], ClipboardService.prototype, "columnController", void 0);
    __decorate([
        main_1.Autowired('eventService'),
        __metadata("design:type", main_1.EventService)
    ], ClipboardService.prototype, "eventService", void 0);
    __decorate([
        main_1.Autowired('cellNavigationService'),
        __metadata("design:type", main_1.CellNavigationService)
    ], ClipboardService.prototype, "cellNavigationService", void 0);
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], ClipboardService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        main_1.Autowired('gridCore'),
        __metadata("design:type", main_1.GridCore)
    ], ClipboardService.prototype, "gridCore", void 0);
    __decorate([
        main_1.Autowired('columnApi'),
        __metadata("design:type", main_1.ColumnApi)
    ], ClipboardService.prototype, "columnApi", void 0);
    __decorate([
        main_1.Autowired('gridApi'),
        __metadata("design:type", main_1.GridApi)
    ], ClipboardService.prototype, "gridApi", void 0);
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ClipboardService.prototype, "init", null);
    ClipboardService = __decorate([
        main_1.Bean('clipboardService')
    ], ClipboardService);
    return ClipboardService;
}());
exports.ClipboardService = ClipboardService;


/***/ }),

/***/ "/4Yk":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1102);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1045:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FTkt");

/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1069:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("jBxA");

/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FZAa");

/***/ }),

/***/ 1097:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("WPfE");

/***/ }),

/***/ 1098:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("rS7A");

/***/ }),

/***/ 1102:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1049),
	        __webpack_require__(1104),
	        __webpack_require__(1105),
	        __webpack_require__(1106),
	        __webpack_require__(1097),
	        __webpack_require__(1098),
	        __webpack_require__(1059),
	        __webpack_require__(1107),
	        __webpack_require__(1108),
	        __webpack_require__(1088),
	        __webpack_require__(1109),
	        __webpack_require__(1069),
	        __webpack_require__(1086),
	        __webpack_require__(1103),
	        __webpack_require__(1045),
	        __webpack_require__(1110),
	        __webpack_require__(1111),
	        __webpack_require__(1112),
	        __webpack_require__(1113),
	        __webpack_require__(1114),
	        __webpack_require__(1115),
	        __webpack_require__(1116),
	        __webpack_require__(1117),
	        __webpack_require__(1118),
	        __webpack_require__(1119),
	        __webpack_require__(1120),
	        __webpack_require__(1121)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	    "bundle all";
	    return window.kendo;
	}, __webpack_require__(3));


/***/ }),

/***/ 1103:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7Omp");

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Dz7c");

/***/ }),

/***/ 1105:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ef9w");

/***/ }),

/***/ 1106:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("iFTV");

/***/ }),

/***/ 1107:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MWyb");

/***/ }),

/***/ 1108:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ydSV");

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1110:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nzx/");

/***/ }),

/***/ 1111:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nK46");

/***/ }),

/***/ 1112:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("IPyL");

/***/ }),

/***/ 1113:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("o1Yl");

/***/ }),

/***/ 1114:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("38Th");

/***/ }),

/***/ 1115:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("KEjV");

/***/ }),

/***/ 1116:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("E1oU");

/***/ }),

/***/ 1117:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nOyd");

/***/ }),

/***/ 1118:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("+X3p");

/***/ }),

/***/ 1119:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("askF");

/***/ }),

/***/ 1120:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ndND");

/***/ }),

/***/ 1121:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("eN7V");

/***/ })

/******/ });

/***/ }),

/***/ "/9Ut":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = __webpack_require__("pQ38");
var column_1 = __webpack_require__("hDyE");
var utils_1 = __webpack_require__("IRr6");
var columnGroup_1 = __webpack_require__("YX13");
var columnApi_1 = __webpack_require__("E/Wy");
var columnController_1 = __webpack_require__("77lH");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var horizontalDragService_1 = __webpack_require__("jJge");
var context_1 = __webpack_require__("RQ1/");
var cssClassApplier_1 = __webpack_require__("NRBX");
var dragAndDropService_1 = __webpack_require__("I/uN");
var setLeftFeature_1 = __webpack_require__("yLI2");
var gridApi_1 = __webpack_require__("BAow");
var componentRecipes_1 = __webpack_require__("EOXx");
var beans_1 = __webpack_require__("YaQm");
var HeaderGroupWrapperComp = (function (_super) {
    __extends(HeaderGroupWrapperComp, _super);
    function HeaderGroupWrapperComp(columnGroup, eRoot, dragSourceDropTarget, pinned) {
        var _this = _super.call(this, HeaderGroupWrapperComp.TEMPLATE) || this;
        // the children can change, we keep destroy functions related to listening to the children here
        _this.childColumnsDestroyFuncs = [];
        _this.columnGroup = columnGroup;
        _this.eRoot = eRoot;
        _this.dragSourceDropTarget = dragSourceDropTarget;
        _this.pinned = pinned;
        return _this;
    }
    HeaderGroupWrapperComp.prototype.postConstruct = function () {
        cssClassApplier_1.CssClassApplier.addHeaderClassesFromColDef(this.columnGroup.getColGroupDef(), this.getGui(), this.gridOptionsWrapper, null, this.columnGroup);
        var displayName = this.columnController.getDisplayNameForColumnGroup(this.columnGroup, 'header');
        this.appendHeaderGroupComp(displayName);
        this.setupResize();
        this.addClasses();
        this.setupWidth();
        this.addAttributes();
        this.setupMovingCss();
        var setLeftFeature = new setLeftFeature_1.SetLeftFeature(this.columnGroup, this.getGui(), this.beans);
        setLeftFeature.init();
        this.addDestroyFunc(setLeftFeature.destroy.bind(setLeftFeature));
    };
    HeaderGroupWrapperComp.prototype.setupMovingCss = function () {
        var _this = this;
        var originalColumnGroup = this.columnGroup.getOriginalColumnGroup();
        var leafColumns = originalColumnGroup.getLeafColumns();
        leafColumns.forEach(function (col) {
            _this.addDestroyableEventListener(col, column_1.Column.EVENT_MOVING_CHANGED, _this.onColumnMovingChanged.bind(_this));
        });
        this.onColumnMovingChanged();
    };
    HeaderGroupWrapperComp.prototype.onColumnMovingChanged = function () {
        // this function adds or removes the moving css, based on if the col is moving.
        // this is what makes the header go dark when it is been moved (gives impression to
        // user that the column was picked up).
        if (this.columnGroup.isMoving()) {
            utils_1.Utils.addCssClass(this.getGui(), 'ag-header-cell-moving');
        }
        else {
            utils_1.Utils.removeCssClass(this.getGui(), 'ag-header-cell-moving');
        }
    };
    HeaderGroupWrapperComp.prototype.addAttributes = function () {
        this.getGui().setAttribute("col-id", this.columnGroup.getUniqueId());
    };
    HeaderGroupWrapperComp.prototype.appendHeaderGroupComp = function (displayName) {
        var _this = this;
        var params = {
            displayName: displayName,
            columnGroup: this.columnGroup,
            setExpanded: function (expanded) {
                _this.columnController.setColumnGroupOpened(_this.columnGroup.getOriginalColumnGroup(), expanded, "gridInitializing");
            },
            api: this.gridApi,
            columnApi: this.columnApi,
            context: this.gridOptionsWrapper.getContext()
        };
        if (!displayName) {
            var leafCols = this.columnGroup.getLeafColumns();
            displayName = leafCols ? leafCols[0].getColDef().headerName : '';
        }
        var callback = this.afterHeaderCompCreated.bind(this, displayName);
        this.componentRecipes.newHeaderGroupComponent(params).then(callback);
    };
    HeaderGroupWrapperComp.prototype.afterHeaderCompCreated = function (displayName, headerGroupComp) {
        this.appendChild(headerGroupComp);
        this.setupMove(headerGroupComp.getGui(), displayName);
        if (headerGroupComp.destroy) {
            this.addDestroyFunc(headerGroupComp.destroy.bind(headerGroupComp));
        }
    };
    HeaderGroupWrapperComp.prototype.addClasses = function () {
        // having different classes below allows the style to not have a bottom border
        // on the group header, if no group is specified
        // columnGroup.getColGroupDef
        if (this.columnGroup.isPadding()) {
            this.addCssClass('ag-header-group-cell-no-group');
        }
        else {
            this.addCssClass('ag-header-group-cell-with-group');
        }
    };
    HeaderGroupWrapperComp.prototype.setupMove = function (eHeaderGroup, displayName) {
        var _this = this;
        if (!eHeaderGroup) {
            return;
        }
        if (this.isSuppressMoving()) {
            return;
        }
        var allLeafColumns = this.columnGroup.getOriginalColumnGroup().getLeafColumns();
        if (eHeaderGroup) {
            var dragSource_1 = {
                type: dragAndDropService_1.DragSourceType.HeaderCell,
                eElement: eHeaderGroup,
                dragItemName: displayName,
                // we add in the original group leaf columns, so we move both visible and non-visible items
                dragItemCallback: this.getDragItemForGroup.bind(this),
                dragSourceDropTarget: this.dragSourceDropTarget,
                dragStarted: function () { return allLeafColumns.forEach(function (col) { return col.setMoving(true, "uiColumnDragged"); }); },
                dragStopped: function () { return allLeafColumns.forEach(function (col) { return col.setMoving(false, "uiColumnDragged"); }); }
            };
            this.dragAndDropService.addDragSource(dragSource_1, true);
            this.addDestroyFunc(function () { return _this.dragAndDropService.removeDragSource(dragSource_1); });
        }
    };
    // when moving the columns, we want to move all the columns (contained within the DragItem) in this group in one go,
    // and in the order they are currently in the screen.
    HeaderGroupWrapperComp.prototype.getDragItemForGroup = function () {
        var allColumnsOriginalOrder = this.columnGroup.getOriginalColumnGroup().getLeafColumns();
        // capture visible state, used when reentering grid to dictate which columns should be visible
        var visibleState = {};
        allColumnsOriginalOrder.forEach(function (column) { return visibleState[column.getId()] = column.isVisible(); });
        var allColumnsCurrentOrder = [];
        this.columnController.getAllDisplayedColumns().forEach(function (column) {
            if (allColumnsOriginalOrder.indexOf(column) >= 0) {
                allColumnsCurrentOrder.push(column);
                utils_1.Utils.removeFromArray(allColumnsOriginalOrder, column);
            }
        });
        // we are left with non-visible columns, stick these in at the end
        allColumnsOriginalOrder.forEach(function (column) { return allColumnsCurrentOrder.push(column); });
        // create and return dragItem
        return {
            columns: allColumnsCurrentOrder,
            visibleState: visibleState
        };
    };
    HeaderGroupWrapperComp.prototype.isSuppressMoving = function () {
        // if any child is fixed, then don't allow moving
        var childSuppressesMoving = false;
        this.columnGroup.getLeafColumns().forEach(function (column) {
            if (column.getColDef().suppressMovable || column.isLockPosition()) {
                childSuppressesMoving = true;
            }
        });
        var result = childSuppressesMoving
            || this.gridOptionsWrapper.isSuppressMovableColumns()
            || this.gridOptionsWrapper.isForPrint();
        return result;
    };
    HeaderGroupWrapperComp.prototype.setupWidth = function () {
        // we need to listen to changes in child columns, as they impact our width
        this.addListenersToChildrenColumns();
        // the children belonging to this group can change, so we need to add and remove listeners as they change
        this.addDestroyableEventListener(this.columnGroup, columnGroup_1.ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED, this.onDisplayedChildrenChanged.bind(this));
        this.onWidthChanged();
        // the child listeners are not tied to this components lifecycle, as children can get added and removed
        // to the group - hence they are on a different lifecycle. so we must make sure the existing children
        // listeners are removed when we finally get destroyed
        this.addDestroyFunc(this.destroyListenersOnChildrenColumns.bind(this));
    };
    HeaderGroupWrapperComp.prototype.onDisplayedChildrenChanged = function () {
        this.addListenersToChildrenColumns();
        this.onWidthChanged();
    };
    HeaderGroupWrapperComp.prototype.addListenersToChildrenColumns = function () {
        var _this = this;
        // first destroy any old listeners
        this.destroyListenersOnChildrenColumns();
        // now add new listeners to the new set of children
        var widthChangedListener = this.onWidthChanged.bind(this);
        this.columnGroup.getLeafColumns().forEach(function (column) {
            column.addEventListener(column_1.Column.EVENT_WIDTH_CHANGED, widthChangedListener);
            column.addEventListener(column_1.Column.EVENT_VISIBLE_CHANGED, widthChangedListener);
            _this.childColumnsDestroyFuncs.push(function () {
                column.removeEventListener(column_1.Column.EVENT_WIDTH_CHANGED, widthChangedListener);
                column.removeEventListener(column_1.Column.EVENT_VISIBLE_CHANGED, widthChangedListener);
            });
        });
    };
    HeaderGroupWrapperComp.prototype.destroyListenersOnChildrenColumns = function () {
        this.childColumnsDestroyFuncs.forEach(function (func) { return func(); });
        this.childColumnsDestroyFuncs = [];
    };
    HeaderGroupWrapperComp.prototype.onWidthChanged = function () {
        this.getGui().style.width = this.columnGroup.getActualWidth() + 'px';
    };
    HeaderGroupWrapperComp.prototype.setupResize = function () {
        var _this = this;
        this.eHeaderCellResize = this.getRefElement('agResize');
        if (!this.columnGroup.isResizable()) {
            utils_1.Utils.removeFromParent(this.eHeaderCellResize);
            return;
        }
        this.dragService.addDragHandling({
            eDraggableElement: this.eHeaderCellResize,
            eBody: this.eRoot,
            cursor: 'col-resize',
            startAfterPixels: 0,
            onDragStart: this.onDragStart.bind(this),
            onDragging: this.onDragging.bind(this)
        });
        if (!this.gridOptionsWrapper.isSuppressAutoSize()) {
            this.eHeaderCellResize.addEventListener('dblclick', function (event) {
                // get list of all the column keys we are responsible for
                var keys = [];
                _this.columnGroup.getDisplayedLeafColumns().forEach(function (column) {
                    // not all cols in the group may be participating with auto-resize
                    if (!column.getColDef().suppressAutoSize) {
                        keys.push(column.getColId());
                    }
                });
                if (keys.length > 0) {
                    _this.columnController.autoSizeColumns(keys, "uiColumnResized");
                }
            });
        }
    };
    HeaderGroupWrapperComp.prototype.onDragStart = function () {
        var _this = this;
        this.groupWidthStart = this.columnGroup.getActualWidth();
        this.childrenWidthStarts = [];
        this.columnGroup.getDisplayedLeafColumns().forEach(function (column) {
            _this.childrenWidthStarts.push(column.getActualWidth());
        });
    };
    HeaderGroupWrapperComp.prototype.onDragging = function (dragChange, finished) {
        var _this = this;
        // this will be the width we have to distribute to the resizable columns
        var widthForResizableCols;
        // this is all the displayed cols in the group less those that we cannot resize
        var resizableCols;
        // a lot of variables defined for the first set of maths, but putting
        // braces in, we localise the variables to this bit of the method
        {
            var dragChangeNormalised = this.normaliseDragChange(dragChange);
            var totalGroupWidth = this.groupWidthStart + dragChangeNormalised;
            var displayedColumns = this.columnGroup.getDisplayedLeafColumns();
            resizableCols = utils_1.Utils.filter(displayedColumns, function (col) { return col.isResizable(); });
            var nonResizableCols = utils_1.Utils.filter(displayedColumns, function (col) { return !col.isResizable(); });
            var nonResizableColsWidth_1 = 0;
            nonResizableCols.forEach(function (col) { return nonResizableColsWidth_1 += col.getActualWidth(); });
            widthForResizableCols = totalGroupWidth - nonResizableColsWidth_1;
            var minWidth_1 = 0;
            resizableCols.forEach(function (col) { return minWidth_1 += col.getMinWidth(); });
            if (widthForResizableCols < minWidth_1) {
                widthForResizableCols = minWidth_1;
            }
        }
        // distribute the new width to the child headers
        var changeRatio = widthForResizableCols / this.groupWidthStart;
        // keep track of pixels used, and last column gets the remaining,
        // to cater for rounding errors, and min width adjustments
        var pixelsToDistribute = widthForResizableCols;
        resizableCols.forEach(function (column, index) {
            var notLastCol = index !== (resizableCols.length - 1);
            var newChildSize;
            if (notLastCol) {
                // if not the last col, calculate the column width as normal
                var startChildSize = _this.childrenWidthStarts[index];
                newChildSize = startChildSize * changeRatio;
                if (newChildSize < column.getMinWidth()) {
                    newChildSize = column.getMinWidth();
                }
                pixelsToDistribute -= newChildSize;
            }
            else {
                // if last col, give it the remaining pixels
                newChildSize = pixelsToDistribute;
            }
            _this.columnController.setColumnWidth(column, newChildSize, finished, "uiColumnDragged");
        });
    };
    // optionally inverts the drag, depending on pinned and RTL
    // note - this method is duplicated in RenderedHeaderCell - should refactor out?
    HeaderGroupWrapperComp.prototype.normaliseDragChange = function (dragChange) {
        var result = dragChange;
        if (this.gridOptionsWrapper.isEnableRtl()) {
            // for RTL, dragging left makes the col bigger, except when pinning left
            if (this.pinned !== column_1.Column.PINNED_LEFT) {
                result *= -1;
            }
        }
        else {
            // for LTR (ie normal), dragging left makes the col smaller, except when pinning right
            if (this.pinned === column_1.Column.PINNED_RIGHT) {
                result *= -1;
            }
        }
        return result;
    };
    HeaderGroupWrapperComp.TEMPLATE = '<div class="ag-header-group-cell">' +
        '<div ref="agResize" class="ag-header-cell-resize"></div>' +
        '</div>';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], HeaderGroupWrapperComp.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], HeaderGroupWrapperComp.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('horizontalDragService'),
        __metadata("design:type", horizontalDragService_1.HorizontalDragService)
    ], HeaderGroupWrapperComp.prototype, "dragService", void 0);
    __decorate([
        context_1.Autowired('dragAndDropService'),
        __metadata("design:type", dragAndDropService_1.DragAndDropService)
    ], HeaderGroupWrapperComp.prototype, "dragAndDropService", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], HeaderGroupWrapperComp.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('componentRecipes'),
        __metadata("design:type", componentRecipes_1.ComponentRecipes)
    ], HeaderGroupWrapperComp.prototype, "componentRecipes", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], HeaderGroupWrapperComp.prototype, "gridApi", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], HeaderGroupWrapperComp.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('beans'),
        __metadata("design:type", beans_1.Beans)
    ], HeaderGroupWrapperComp.prototype, "beans", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], HeaderGroupWrapperComp.prototype, "postConstruct", null);
    return HeaderGroupWrapperComp;
}(component_1.Component));
exports.HeaderGroupWrapperComp = HeaderGroupWrapperComp;


/***/ }),

/***/ "/A/6":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1434);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FZAa");

/***/ }),

/***/ 1434:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1088) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "touch",
	    name: "Touch",
	    category: "mobile",
	    description: "The kendo Touch widget provides a cross-platform compatible API for handling user-initiated touch events, multi-touch gestures and event sequences (drag, swipe, etc.). ",
	    depends: [ "core", "userevents" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        proxy = $.proxy,
	        abs = Math.abs,
	        MAX_DOUBLE_TAP_DISTANCE = 20;

	    var Touch = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);
	            options = that.options;

	            element = that.element;
	            that.wrapper = element;

	            function eventProxy(name) {
	                return function(e) {
	                    that._triggerTouch(name, e);
	                };
	            }

	            function gestureEventProxy(name) {
	                return function(e) {
	                    that.trigger(name, { touches: e.touches, distance: e.distance, center: e.center, event: e.event });
	                };
	            }

	            that.events = new kendo.UserEvents(element, {
	                filter: options.filter,
	                surface: options.surface,
	                minHold: options.minHold,
	                multiTouch: options.multiTouch,
	                allowSelection: true,
	                fastTap: options.fastTap,
	                press: eventProxy("touchstart"),
	                hold: eventProxy("hold"),
	                tap: proxy(that, "_tap"),
	                gesturestart: gestureEventProxy("gesturestart"),
	                gesturechange: gestureEventProxy("gesturechange"),
	                gestureend: gestureEventProxy("gestureend")
	            });

	            if (options.enableSwipe) {
	                that.events.bind("start", proxy(that, "_swipestart"));
	                that.events.bind("move", proxy(that, "_swipemove"));
	            } else {
	                that.events.bind("start", proxy(that, "_dragstart"));
	                that.events.bind("move", eventProxy("drag"));
	                that.events.bind("end", eventProxy("dragend"));
	            }

	            kendo.notify(that);
	        },

	        events: [
	            "touchstart",
	            "dragstart",
	            "drag",
	            "dragend",
	            "tap",
	            "doubletap",
	            "hold",
	            "swipe",
	            "gesturestart",
	            "gesturechange",
	            "gestureend"
	        ],

	        options: {
	            name: "Touch",
	            surface: null,
	            global: false,
	            fastTap: false,
	            filter: null,
	            multiTouch: false,
	            enableSwipe: false,
	            minXDelta: 30,
	            maxYDelta: 20,
	            maxDuration: 1000,
	            minHold: 800,
	            doubleTapTimeout: 800
	        },

	        cancel: function() {
	            this.events.cancel();
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            this.events.destroy();
	        },

	        _triggerTouch: function(type, e) {
	            if (this.trigger(type, { touch: e.touch, event: e.event })) {
	                e.preventDefault();
	            }
	        },

	        _tap: function(e) {
	            var that = this,
	                lastTap = that.lastTap,
	                touch = e.touch;

	            if (lastTap &&
	                (touch.endTime - lastTap.endTime < that.options.doubleTapTimeout) &&
	                kendo.touchDelta(touch, lastTap).distance < MAX_DOUBLE_TAP_DISTANCE
	                ) {

	               that._triggerTouch("doubletap", e);
	               that.lastTap = null;
	            } else {
	                that._triggerTouch("tap", e);
	                that.lastTap = touch;
	            }
	        },

	        _dragstart: function(e) {
	            this._triggerTouch("dragstart", e);
	        },

	        _swipestart: function(e) {
	            if (abs(e.x.velocity) * 2 >= abs(e.y.velocity)) {
	                e.sender.capture();
	            }
	        },

	        _swipemove: function(e) {
	            var that = this,
	                options = that.options,
	                touch = e.touch,
	                duration = e.event.timeStamp - touch.startTime,
	                direction = touch.x.initialDelta > 0 ? "right" : "left";

	            if (
	                abs(touch.x.initialDelta) >= options.minXDelta &&
	                abs(touch.y.initialDelta) < options.maxYDelta &&
	                duration < options.maxDuration
	                )
	            {
	                that.trigger("swipe", {
	                    direction: direction,
	                    touch: e.touch
	                });

	                touch.cancel();
	            }
	        }
	    });

	    kendo.ui.plugin(Touch);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "/PKt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var rowNode_1 = __webpack_require__("bP2e");
var utils_1 = __webpack_require__("IRr6");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var selectionController_1 = __webpack_require__("D4cr");
var eventService_1 = __webpack_require__("k5uU");
var columnController_1 = __webpack_require__("77lH");
var FlattenStage = (function () {
    function FlattenStage() {
    }
    FlattenStage.prototype.execute = function (params) {
        var rootNode = params.rowNode;
        // even if not doing grouping, we do the mapping, as the client might
        // of passed in data that already has a grouping in it somewhere
        var result = [];
        // putting value into a wrapper so it's passed by reference
        var nextRowTop = { value: 0 };
        var skipLeafNodes = this.columnController.isPivotMode();
        // if we are reducing, and not grouping, then we want to show the root node, as that
        // is where the pivot values are
        var showRootNode = skipLeafNodes && rootNode.leafGroup;
        var topList = showRootNode ? [rootNode] : rootNode.childrenAfterSort;
        // set all row tops to null, then set row tops on all visible rows. if we don't
        // do this, then the algorithm below only sets row tops, old row tops from old rows
        // will still lie around
        this.resetRowTops(rootNode);
        this.recursivelyAddToRowsToDisplay(topList, result, nextRowTop, skipLeafNodes, 0);
        return result;
    };
    FlattenStage.prototype.resetRowTops = function (rowNode) {
        rowNode.clearRowTop();
        if (rowNode.hasChildren()) {
            if (rowNode.childrenAfterGroup) {
                for (var i = 0; i < rowNode.childrenAfterGroup.length; i++) {
                    this.resetRowTops(rowNode.childrenAfterGroup[i]);
                }
            }
            if (rowNode.sibling) {
                rowNode.sibling.clearRowTop();
            }
        }
    };
    FlattenStage.prototype.recursivelyAddToRowsToDisplay = function (rowsToFlatten, result, nextRowTop, skipLeafNodes, uiLevel) {
        if (utils_1.Utils.missingOrEmpty(rowsToFlatten)) {
            return;
        }
        var groupSuppressRow = this.gridOptionsWrapper.isGroupSuppressRow();
        var hideOpenParents = this.gridOptionsWrapper.isGroupHideOpenParents();
        // these two are mutually exclusive, so if first set, we don't set the second
        var groupRemoveSingleChildren = this.gridOptionsWrapper.isGroupRemoveSingleChildren();
        var groupRemoveLowestSingleChildren = !groupRemoveSingleChildren && this.gridOptionsWrapper.isGroupRemoveLowestSingleChildren();
        for (var i = 0; i < rowsToFlatten.length; i++) {
            var rowNode = rowsToFlatten[i];
            // check all these cases, for working out if this row should be included in the final mapped list
            var isParent = rowNode.hasChildren();
            var isGroupSuppressedNode = groupSuppressRow && isParent;
            var isSkippedLeafNode = skipLeafNodes && !isParent;
            var isRemovedSingleChildrenGroup = groupRemoveSingleChildren && isParent && rowNode.childrenAfterGroup.length === 1;
            var isRemovedLowestSingleChildrenGroup = groupRemoveLowestSingleChildren && isParent && rowNode.leafGroup && rowNode.childrenAfterGroup.length === 1;
            // hide open parents means when group is open, we don't show it. we also need to make sure the
            // group is expandable in the first place (as leaf groups are not expandable if pivot mode is on).
            // the UI will never allow expanding leaf  groups, however the user might via the API (or menu option 'expand all')
            var neverAllowToExpand = skipLeafNodes && rowNode.leafGroup;
            var isHiddenOpenParent = hideOpenParents && rowNode.expanded && (!neverAllowToExpand);
            var thisRowShouldBeRendered = !isSkippedLeafNode && !isGroupSuppressedNode && !isHiddenOpenParent && !isRemovedSingleChildrenGroup && !isRemovedLowestSingleChildrenGroup;
            if (thisRowShouldBeRendered) {
                this.addRowNodeToRowsToDisplay(rowNode, result, nextRowTop, uiLevel);
            }
            // if we are pivoting, we never map below the leaf group
            if (skipLeafNodes && rowNode.leafGroup) {
                continue;
            }
            if (isParent) {
                var excludedParent = isRemovedSingleChildrenGroup || isRemovedLowestSingleChildrenGroup;
                // we traverse the group if it is expended, however we always traverse if the parent node
                // was removed (as the group will never be opened if it is not displayed, we show the children instead)
                if (rowNode.expanded || excludedParent) {
                    // if the parent was excluded, then ui level is that of the parent
                    var uiLevelForChildren = excludedParent ? uiLevel : uiLevel + 1;
                    this.recursivelyAddToRowsToDisplay(rowNode.childrenAfterSort, result, nextRowTop, skipLeafNodes, uiLevelForChildren);
                    // put a footer in if user is looking for it
                    if (this.gridOptionsWrapper.isGroupIncludeFooter()) {
                        this.ensureFooterNodeExists(rowNode);
                        this.addRowNodeToRowsToDisplay(rowNode.sibling, result, nextRowTop, uiLevel);
                    }
                }
                else {
                }
            }
            else if (rowNode.master && rowNode.expanded) {
                var detailNode = this.createDetailNode(rowNode);
                this.addRowNodeToRowsToDisplay(detailNode, result, nextRowTop, uiLevel);
            }
        }
    };
    // duplicated method, it's also in floatingRowModel
    FlattenStage.prototype.addRowNodeToRowsToDisplay = function (rowNode, result, nextRowTop, uiLevel) {
        result.push(rowNode);
        if (utils_1.Utils.missing(rowNode.rowHeight)) {
            var rowHeight = this.gridOptionsWrapper.getRowHeightForNode(rowNode);
            rowNode.setRowHeight(rowHeight);
        }
        rowNode.setUiLevel(uiLevel);
        rowNode.setRowTop(nextRowTop.value);
        rowNode.setRowIndex(result.length - 1);
        nextRowTop.value += rowNode.rowHeight;
    };
    FlattenStage.prototype.ensureFooterNodeExists = function (groupNode) {
        // only create footer node once, otherwise we have daemons and
        // the animate screws up with the daemons hanging around
        if (utils_1.Utils.exists(groupNode.sibling)) {
            return;
        }
        var footerNode = new rowNode_1.RowNode();
        this.context.wireBean(footerNode);
        Object.keys(groupNode).forEach(function (key) {
            footerNode[key] = groupNode[key];
        });
        footerNode.footer = true;
        footerNode.rowTop = null;
        footerNode.oldRowTop = null;
        if (utils_1.Utils.exists(footerNode.id)) {
            footerNode.id = 'rowGroupFooter_' + footerNode.id;
        }
        // get both header and footer to reference each other as siblings. this is never undone,
        // only overwritten. so if a group is expanded, then contracted, it will have a ghost
        // sibling - but that's fine, as we can ignore this if the header is contracted.
        footerNode.sibling = groupNode;
        groupNode.sibling = footerNode;
    };
    FlattenStage.prototype.createDetailNode = function (masterNode) {
        if (utils_1.Utils.exists(masterNode.detailNode)) {
            return masterNode.detailNode;
        }
        else {
            var detailNode = new rowNode_1.RowNode();
            this.context.wireBean(detailNode);
            detailNode.detail = true;
            // flower was renamed to 'detail', but keeping for backwards compatibility
            detailNode.flower = detailNode.detail;
            detailNode.parent = masterNode;
            if (utils_1.Utils.exists(masterNode.id)) {
                detailNode.id = 'detail_' + masterNode.id;
            }
            detailNode.data = masterNode.data;
            detailNode.level = masterNode.level + 1;
            masterNode.detailNode = detailNode;
            masterNode.childFlower = masterNode.detailNode; // for backwards compatibility
            return detailNode;
        }
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], FlattenStage.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('selectionController'),
        __metadata("design:type", selectionController_1.SelectionController)
    ], FlattenStage.prototype, "selectionController", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], FlattenStage.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], FlattenStage.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], FlattenStage.prototype, "columnController", void 0);
    FlattenStage = __decorate([
        context_1.Bean('flattenStage')
    ], FlattenStage);
    return FlattenStage;
}());
exports.FlattenStage = FlattenStage;


/***/ }),

/***/ "/bQp":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "/d84":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var Downloader = (function () {
    function Downloader() {
    }
    Downloader.prototype.download = function (fileName, content, mimeType) {
        // for Excel, we need \ufeff at the start
        // http://stackoverflow.com/questions/17879198/adding-utf-8-bom-to-string-blob
        var blobObject = new Blob(["\ufeff", content], {
            type: mimeType
        });
        // Internet Explorer
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blobObject, fileName);
        }
        else {
            // Chrome
            var downloadLink = document.createElement("a");
            downloadLink.href = window.URL.createObjectURL(blobObject);
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    };
    Downloader = __decorate([
        context_1.Bean('downloader')
    ], Downloader);
    return Downloader;
}());
exports.Downloader = Downloader;


/***/ }),

/***/ "/lhy":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(989);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 980:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("N+Bk");

/***/ }),

/***/ 989:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(980) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	(function($) {

	var kendo = window.kendo,
	    Class = kendo.Class,
	    Editor = kendo.ui.editor,
	    formats = kendo.ui.Editor.fn.options.formats,
	    EditorUtils = Editor.EditorUtils,
	    Tool = Editor.Tool,
	    ToolTemplate = Editor.ToolTemplate,
	    FormatTool = Editor.FormatTool,
	    dom = Editor.Dom,
	    RangeUtils = Editor.RangeUtils,
	    extend = $.extend,
	    registerTool = Editor.EditorUtils.registerTool,
	    registerFormat = Editor.EditorUtils.registerFormat,
	    MOUSEDOWN_NS = "mousedown.kendoEditor",
	    KEYDOWN_NS = "keydown.kendoEditor",
	    KMARKER = "k-marker";

	var InlineFormatFinder = Class.extend({
	    init: function(format) {
	        this.format = format;
	    },

	    numberOfSiblings: function(referenceNode) {
	        var textNodesCount = 0,
	            elementNodesCount = 0,
	            markerCount = 0,
	            parentNode = referenceNode.parentNode,
	            node;

	        for (node = parentNode.firstChild; node; node = node.nextSibling) {
	            if (node != referenceNode) {
	                if (node.className == KMARKER) {
	                    markerCount++;
	                } else if (node.nodeType == 3) {
	                    textNodesCount++;
	                } else {
	                    elementNodesCount++;
	                }
	            }
	        }

	        if (markerCount > 1 && parentNode.firstChild.className == KMARKER && parentNode.lastChild.className == KMARKER) {
	            // full node selection
	            return 0;
	        } else {
	            return elementNodesCount + textNodesCount;
	        }
	    },

	    findSuitable: function (sourceNode, skip) {
	        if (!skip && this.numberOfSiblings(sourceNode) > 0) {
	            return null;
	        }

	        var node = sourceNode.parentNode;
	        var tags = this.format[0].tags;

	        while (!dom.ofType(node, tags)) {
	            if (this.numberOfSiblings(node) > 0) {
	                return null;
	            }

	            node = node.parentNode;
	        }

	        return node;
	    },

	    findFormat: function (sourceNode) {
	        var format = this.format,
	            attrEquals = dom.attrEquals,
	            i, len, node, tags, attributes;

	        for (i = 0, len = format.length; i < len; i++) {
	            node = sourceNode;
	            tags = format[i].tags;
	            attributes = format[i].attr;

	            if (node && dom.ofType(node, tags) && attrEquals(node, attributes)) {
	                return node;
	            }

	            while (node) {
	                node = dom.parentOfType(node, tags);
	                if (node && attrEquals(node, attributes)) {
	                    return node;
	                }
	            }
	        }

	        return null;
	    },

	    isFormatted: function (nodes) {
	        var i, len;

	        for (i = 0, len = nodes.length; i < len; i++) {
	            if (this.findFormat(nodes[i])) {
	                return true;
	            }
	        }
	        return false;
	    }
	});

	var InlineFormatter = Class.extend({
	    init: function(format, values) {
	        this.finder = new InlineFormatFinder(format);
	        this.attributes = extend({}, format[0].attr, values);
	        this.tag = format[0].tags[0];
	    },

	    wrap: function(node) {
	        return dom.wrap(node, dom.create(node.ownerDocument, this.tag, this.attributes));
	    },

	    activate: function(range, nodes) {
	        if (this.finder.isFormatted(nodes)) {
	            this.split(range);
	            this.remove(nodes);
	        } else {
	            this.apply(nodes);
	        }
	    },

	    toggle: function (range) {
	        var textNodes = this.immutables() ? RangeUtils.editableTextNodes : RangeUtils.textNodes;
	        var nodes = textNodes(range);

	        if (nodes.length > 0) {
	            this.activate(range, nodes);
	        }
	    },

	    immutables: function(){
	        return this.editor && this.editor.options.immutables;
	    },

	    apply: function (nodes) {
	        var formatNodes = [];
	        var i, l, node, formatNode;

	        if (nodes.length > 1) {
	            for (i = 0, l = nodes.length; i < l; i++) {
	                node = nodes[i];
	                formatNode = this.format(node, true);
	                formatNodes.push(formatNode);

	            }
	        } else {
	            node = nodes[0];
	            formatNode = this.format(node, false);
	        }

	        this.consolidate(formatNodes);
	    },

	    format: function (node, outerMostInline) {
	        var formatNode = this.finder.findSuitable(node);
	        var attributes = this.attributes;
	        var styleAttr = attributes ? attributes.style || {} : {};

	        if (formatNode) {
	            if (dom.is(formatNode, "font")) {
	                if (styleAttr.color) {
	                    formatNode.removeAttribute("color");
	                }
	                if (styleAttr.fontName) {
	                    formatNode.removeAttribute("face");
	                }
	                if (styleAttr.fontSize) {
	                    formatNode.removeAttribute("size");
	                }
	            }
	            dom.attr(formatNode, attributes);
	        } else {
	            while (!dom.isBlock(node.parentNode) && node.parentNode.childNodes.length == 1 && node.parentNode.contentEditable !== 'true' && outerMostInline) {
	                node = node.parentNode;
	            }

	            formatNode = this.wrap(node);
	        }

	        return formatNode;
	    },

	    remove: function (nodes) {
	        var i, l, formatNode;

	        for (i = 0, l = nodes.length; i < l; i++) {
	            formatNode = this.finder.findFormat(nodes[i]);
	            if (formatNode) {
	                if (this.attributes && this.attributes.style) {
	                    dom.unstyle(formatNode, this.attributes.style);
	                    if (!formatNode.style.cssText && !formatNode.attributes["class"]) {
	                        dom.unwrap(formatNode);
	                    }
	                } else {
	                    dom.unwrap(formatNode);
	                }
	            }
	        }
	    },

	    split: function (range) {
	        var nodes = RangeUtils.textNodes(range);
	        var l = nodes.length;
	        var i, formatNode;

	        if (l > 0) {
	            for (i = 0; i < l; i++) {
	                formatNode = this.finder.findFormat(nodes[i]);
	                if (formatNode) {
	                    RangeUtils.split(range, formatNode, true);
	                }
	            }
	        }
	    },

	    consolidate: function (nodes) {
	        var node, last;

	        while (nodes.length > 1) {
	            node = nodes.pop();
	            last = nodes[nodes.length - 1];

	            if (node.previousSibling && node.previousSibling.className == KMARKER) {
	                last.appendChild(node.previousSibling);
	            }

	            if (node.tagName == last.tagName &&
	                node.previousSibling == last &&
	                node.style.cssText == last.style.cssText &&
	                node.className === last.className) {

	                while (node.firstChild) {
	                    last.appendChild(node.firstChild);
	                }

	                dom.remove(node);
	            }
	        }
	    }
	});

	var GreedyInlineFormatFinder = InlineFormatFinder.extend({
	    init: function(format, greedyProperty) {
	        this.format = format;
	        this.greedyProperty = greedyProperty;
	        InlineFormatFinder.fn.init.call(this, format);
	    },

	    getInlineCssValue: function(node) {
	        var attributes = node.attributes;
	        var trim = kendo.trim;
	        var i, l, attribute, name, attributeValue, css, pair, cssIndex, len;
	        var propertyAndValue, property, value;

	        if (!attributes) {
	            return;
	        }

	        for (i = 0, l = attributes.length; i < l; i++) {
	            attribute = attributes[i];
	            name = attribute.nodeName;
	            attributeValue = attribute.nodeValue;

	            if (attribute.specified && name == "style") {

	                css = trim(attributeValue || node.style.cssText).split(";");

	                for (cssIndex = 0, len = css.length; cssIndex < len; cssIndex++) {
	                    pair = css[cssIndex];
	                    if (pair.length) {
	                        propertyAndValue = pair.split(":");
	                        property = trim(propertyAndValue[0].toLowerCase());
	                        value = trim(propertyAndValue[1]);

	                        if (property != this.greedyProperty) {
	                            continue;
	                        }

	                        return property.indexOf("color") >= 0 ? dom.toHex(value) : value;
	                    }
	                }
	            }
	        }
	    },

	    getFormatInner: function (node) {
	        var $node = $(dom.isDataNode(node) ? node.parentNode : node);
	        var parents = $node.parentsUntil("[contentEditable]").addBack().toArray().reverse();
	        var i, len, value;

	        for (i = 0, len = parents.length; i < len; i++) {
	            value = this.greedyProperty == "className" ? parents[i].className : this.getInlineCssValue(parents[i]);
	            if (value) {
	                return value;
	            }
	        }

	        return "inherit";
	    },

	    getFormat: function (nodes) {
	        var result = this.getFormatInner(nodes[0]), i, len;

	        for (i = 1, len = nodes.length; i < len; i++) {
	            if (result != this.getFormatInner(nodes[i])) {
	                return "";
	            }
	        }

	        return result;
	    },

	    isFormatted: function (nodes) {
	        return this.getFormat(nodes) !== "";
	    }
	});

	var GreedyInlineFormatter = InlineFormatter.extend({
	    init: function(format, values, greedyProperty) {
	        InlineFormatter.fn.init.call(this, format, values);

	        this.values = values;
	        this.finder = new GreedyInlineFormatFinder(format, greedyProperty);

	        if (greedyProperty) {
	            this.greedyProperty = kendo.toCamelCase(greedyProperty);
	        }

	    },

	    activate: function(range, nodes) {
	        var greedyProperty = this.greedyProperty;
	        var action = "apply";

	        this.split(range);

	        if (greedyProperty && this.values.style[greedyProperty] == "inherit") {
	            action = "remove";
	        }

	        this[action](nodes);
	    }
	});

	var InlineFormatTool = FormatTool.extend({
	    init: function(options) {
	        FormatTool.fn.init.call(this, extend(options, {
	            finder: new InlineFormatFinder(options.format),
	            formatter: function () { return new InlineFormatter(options.format); }
	        }));
	    }
	});

	var DelayedExecutionTool = Tool.extend({
	    update: function(ui, nodes) {
	        var list = ui.data(this.type);

	        list.close();
	        list.value(this.finder.getFormat(nodes));
	    }
	});

	var FontTool = DelayedExecutionTool.extend({
	    init: function(options) {
	        Tool.fn.init.call(this, options);

	        // IE has single selection hence we are using select box instead of combobox
	        this.type = (kendo.support.browser.msie || kendo.support.touch) ? "kendoDropDownList" : "kendoComboBox";
	        this.format = [{ tags: ["span", "font"] }];
	        this.finder = new GreedyInlineFormatFinder(this.format, options.cssAttr);
	    },

	    command: function (commandArguments) {
	        var options = this.options,
	            format = this.format,
	            style = {};

	        return new Editor.FormatCommand(extend(commandArguments, {
	            formatter: function () {
	                style[options.domAttr] = commandArguments.value;

	                return new GreedyInlineFormatter(format, { style: style }, options.cssAttr);
	            }
	        }));
	    },

	    initialize: function (ui, initOptions) {
	        var editor = initOptions.editor,
	            options = this.options,
	            toolName = options.name,
	            dataSource,
	            range,
	            defaultValue = [];

	        if (options.defaultValue) {
	           defaultValue = [{
	                text: editor.options.messages[options.defaultValue[0].text],
	                value: options.defaultValue[0].value
	           }];
	        }

	        dataSource = defaultValue.concat(options.items ? options.items : (editor.options[toolName] || [] ));

	        ui.attr({ title: initOptions.title});
	        ui[this.type]({
	            dataTextField: "text",
	            dataValueField: "value",
	            dataSource: dataSource,
	            change: function () {
	                editor._range = range;
	                Tool.exec(editor, toolName, this.value());
	            },
	            close: function () {
	                setTimeout(function(){
	                    editor._deleteSavedRange();
	                },0);
	            },
	            highlightFirst: false
	        });

	        ui.closest(".k-widget").removeClass("k-" + toolName).find("*").addBack().attr("unselectable", "on");

	        var widget = ui.data(this.type);
	        widget.value("inherit");

	        widget.wrapper.on(MOUSEDOWN_NS, ".k-select,.k-input", function() {
	            var newRange = editor.getRange();
	            range = editor._containsRange(newRange) ? newRange : range;
	        })
	        .on(KEYDOWN_NS, function(e) {
	            if (e.keyCode === kendo.keys.ENTER) {
	                editor._deleteSavedRange();
	                e.preventDefault();
	            }
	        });
	    }

	});

	var ColorTool = Tool.extend({
	    init: function(options) {
	        Tool.fn.init.call(this, options);

	        this.format = [{ tags: ["span","font"]}];
	        this.finder = new GreedyInlineFormatFinder(this.format, options.cssAttr);
	    },

	    options: {
	        palette: "websafe"
	    },

	    update: function() {
	        this._widget.close();
	    },

	    command: function (commandArguments) {
	        var options = this.options,
	            format = this.format,
	            style = {};

	        return new Editor.FormatCommand(extend(commandArguments, {
	            formatter: function () {
	                style[options.domAttr] = commandArguments.value;

	                return new GreedyInlineFormatter(format, { style: style }, options.cssAttr);
	            }
	        }));
	    },

	    initialize: function(ui, initOptions) {
	        var that = this,
	            editor = initOptions.editor,
	            toolName = this.name,
	            options =  extend({}, ColorTool.fn.options, this.options),
	            palette = options.palette,
	            columns = options.columns;

	        ui = this._widget = new kendo.ui.ColorPicker(ui, {
	            toolIcon: "k-icon k-i-" + EditorUtils.getToolCssClass(options.name),
	            palette: palette,
	            columns: columns,
	            change: function() {
	                var color = ui.value();

	                if (kendo.support.browser.msie && that.storedRange && that._inputFocused) {
	                    editor.selectRange(that.storedRange);
	                }

	                if (color) {
	                    Tool.exec(editor, toolName, color);
	                }

	                delete that.storedRange;
	                delete that._inputFocused;
	                editor.focus();
	            },
	            open: function (e) {
	                var picker = e.sender;
	                that.storedRange = editor.getRange();

	                picker._popup.element.on(MOUSEDOWN_NS, function(e){
	                    if(!$(e.target).is("input.k-color-value")){
	                        e.preventDefault();
	                    }
	                });

	                if(!picker._popup.element.is("[unselectable='on']")) {
	                    picker._popup.element
	                        .attr({ unselectable: "on" })
	                        .find("*:not(input)").attr("unselectable", "on")
	                        .end().find("input").on("focus", function(){
	                            that._inputFocused = true;
	                        });
	                }
	            },
	            close: function(e) {
	                e.sender._popup.element.off(MOUSEDOWN_NS);

	                if (kendo.support.browser.msie && that.storedRange && that._inputFocused) {
	                    editor.selectRange(that.storedRange);
	                }
	            },
	            activate: function(e) {
	                e.preventDefault();

	                if (e.sender._value.toCssRgba() === "rgba(255, 255, 255, 0)") {
	                    return;
	                }

	                ui.trigger("change");
	            }
	        });
	        ui.wrapper
	            .attr({ title: initOptions.title, unselectable: "on" })
	            .find("*:not(input)").attr("unselectable", "on");

	        ui.value("transparent");
	    }
	});

	extend(Editor, {
	    InlineFormatFinder: InlineFormatFinder,
	    InlineFormatter: InlineFormatter,
	    DelayedExecutionTool: DelayedExecutionTool,
	    GreedyInlineFormatFinder: GreedyInlineFormatFinder,
	    GreedyInlineFormatter: GreedyInlineFormatter,
	    InlineFormatTool: InlineFormatTool,
	    FontTool: FontTool,
	    ColorTool: ColorTool
	});

	registerFormat("bold", [ { tags: ["strong", "b"] }, { tags: ["span"], attr: { style: { fontWeight: "bold"}} } ]);
	registerTool("bold", new InlineFormatTool({ key: "B", ctrl: true, format: formats.bold, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Bold"}) }));

	registerFormat("italic", [ { tags: ["em", "i"] }, { tags: ["span"], attr: { style: { fontStyle: "italic"}} } ]);
	registerTool("italic", new InlineFormatTool({ key: "I", ctrl: true, format: formats.italic, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Italic"})}));

	registerFormat("underline", [ { tags: ["span"], attr: { style: { textDecoration: "underline"}} }, { tags: ["u"] } ]);
	registerTool("underline", new InlineFormatTool({ key: "U", ctrl: true, format: formats.underline, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Underline"})}));

	registerFormat("strikethrough", [ { tags: ["del", "strike"] }, { tags: ["span"], attr: { style: { textDecoration: "line-through"}} } ]);
	registerTool("strikethrough", new InlineFormatTool({format: formats.strikethrough, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Strikethrough"})}));

	registerFormat("superscript", [ { tags: ["sup"] } ]);
	registerTool("superscript", new InlineFormatTool({format: formats.superscript, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Superscript"})}));

	registerFormat("subscript", [ { tags: ["sub"] } ]);
	registerTool("subscript", new InlineFormatTool({format: formats.subscript, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Subscript"})}));

	registerTool("foreColor", new ColorTool({cssAttr:"color", domAttr:"color", name:"foreColor", template: new ToolTemplate({template: EditorUtils.colorPickerTemplate, title: "Color"})}));

	registerTool("backColor", new ColorTool({cssAttr:"background-color", domAttr: "backgroundColor", name:"backColor", template: new ToolTemplate({template: EditorUtils.colorPickerTemplate, title: "Background Color"})}));

	registerTool("fontName", new FontTool({cssAttr:"font-family", domAttr: "fontFamily", name:"fontName", defaultValue: [{ text: "fontNameInherit",  value: "inherit" }], template: new ToolTemplate({template: EditorUtils.comboBoxTemplate, title: "Font Name"})}));

	registerTool("fontSize", new FontTool({cssAttr:"font-size", domAttr:"fontSize", name:"fontSize", defaultValue: [{ text: "fontSizeInherit",  value: "inherit" }], template: new ToolTemplate({template: EditorUtils.comboBoxTemplate, title: "Font Size"})}));

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "/mbW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__("ungA");

var _AutoCompleteProps = __webpack_require__("a7ls");

var _AutoCompleteProps2 = _interopRequireDefault(_AutoCompleteProps);

var _Animation = __webpack_require__("dGGS");

var _Animation2 = _interopRequireDefault(_Animation);

var _Virtual = __webpack_require__("ZSoY");

var _Virtual2 = _interopRequireDefault(_Virtual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: _AutoCompleteProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _Animation2.default, _Virtual2.default],
    model: {
        event: 'changemodel'
    },
    mounted: function mounted() {
        var that = this;
        var widgetElement = that.$el;
        kendo.jQuery(widgetElement).kendoAutoComplete(that.widgetOptions);
        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', widgetElement.value);
            } else {
                that.$emit('changemodel', widgetElement.value);
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            var widgetElement = this.$el;

            return kendo.jQuery(widgetElement).getKendoAutoComplete();
        }
    }
};

/***/ }),

/***/ "/nTy":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(992);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 988:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Ytuf");

/***/ }),

/***/ 992:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(988) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($) {

	// Imports ================================================================
	var kendo = window.kendo,
	    extend = $.extend,
	    editorNS = kendo.ui.editor,
	    dom = editorNS.Dom,
	    Command = editorNS.Command,
	    Tool = editorNS.Tool,
	    BlockFormatter = editorNS.BlockFormatter,
	    normalize = dom.normalize,
	    RangeUtils = editorNS.RangeUtils,
	    registerTool = editorNS.EditorUtils.registerTool;

	var ParagraphCommand = Command.extend({
	    init: function(options) {
	        this.options = options;
	        Command.fn.init.call(this, options);
	    },

	    _insertMarker: function(doc, range) {
	        var marker = dom.create(doc, 'a'), container;
	        marker.className = "k-marker";

	        range.insertNode(marker);

	        if (!marker.parentNode) {
	            // inserting paragraph in Firefox full body range
	            container = range.commonAncestorContainer;
	            container.innerHTML = "";
	            container.appendChild(marker);
	        }

	        normalize(marker.parentNode);

	        return marker;
	    },

	    _moveFocus: function(range, candidate) {
	        if (dom.isEmpty(candidate)) {
	            range.setStartBefore(candidate);
	        } else {
	            range.selectNodeContents(candidate);

	            var focusNode = RangeUtils.textNodes(range)[0];

	            if (!focusNode) {
	                while (candidate.childNodes.length && !dom.is(candidate.firstChild, "br")) {
	                    candidate = candidate.firstChild;
	                }

	                focusNode = candidate;
	            }

	            if (dom.isEmpty(focusNode)) {
	                range.setStartBefore(focusNode);
	            } else {
	                if (dom.emptyNode(focusNode)) {
	                    focusNode.innerHTML = "\ufeff";
	                }
	                var startNode = focusNode.firstChild || focusNode;
	                if (dom.isDataNode(startNode)) {
	                    range.setStart(startNode, 0);
	                } else {
	                    range.setStartBefore(startNode);
	                }
	            }
	        }
	    },

	    shouldTrim: function(range) {
	        var blocks = 'p,h1,h2,h3,h4,h5,h6'.split(','),
	            startInBlock = dom.parentOfType(range.startContainer, blocks),
	            endInBlock = dom.parentOfType(range.endContainer, blocks);
	        return (startInBlock && !endInBlock) || (!startInBlock && endInBlock);
	    },

	    _blankAfter: function (node) {
	        while (node && (dom.isMarker(node) || dom.stripBom(node.nodeValue) === "")) {
	            node = node.nextSibling;
	        }

	        return !node;
	    },

	    exec: function () {
	        var range = this.getRange(),
	            doc = RangeUtils.documentFromRange(range),
	            parent, previous, next,
	            emptyParagraphContent = editorNS.emptyElementContent,
	            paragraph, marker, li, heading, tableNode, rng,
	            shouldTrim;

	        this.expandImmutablesIn(range);

	        shouldTrim = this.shouldTrim(range);

	        range.deleteContents();
	        marker = this._insertMarker(doc, range);

	        dom.stripBomNode(marker.previousSibling);
	        dom.stripBomNode(marker.nextSibling);

	        li = dom.closestEditableOfType(marker, ['li']);
	        heading = dom.closestEditableOfType(marker, 'h1,h2,h3,h4,h5,h6'.split(','));
	        tableNode = dom.is(marker.parentNode, 'table') &&  marker.parentNode;

	        if (li) {
	            // hitting 'enter' in empty li
	            if (dom.emptyNode(li)) {
	                paragraph = dom.create(doc, 'p');

	                if (dom.next(li)) {
	                    rng = range.cloneRange();
	                    rng.selectNode(li);

	                    RangeUtils.split(rng, li.parentNode);
	                }

	                var br = $("br", li);
	                if (br.length == 1) {
	                    br.remove();
	                }

	                var parentNode = li.parentNode;
	                var parentChildrenLength = li.parentNode.children.length;
	                var firstChild = parentChildrenLength > 1 && li.childNodes.length == 1 && li.children[0];

	                dom.insertAfter(paragraph, parentNode);
	                dom.remove(parentChildrenLength == 1 ? li.parentNode : li);

	                if (firstChild && firstChild !== marker) {
	                    paragraph.appendChild(firstChild);
	                    paragraph.appendChild(marker);
	                } else {
	                    paragraph.innerHTML = emptyParagraphContent;
	                }
	                next = paragraph;
	            }
	        } else if (heading && this._blankAfter(marker)) {
	            paragraph = this._insertParagraphAfter(heading);
	            dom.remove(marker);
	            next = paragraph;
	        } else if (tableNode) {
	            paragraph = this._insertParagraphAfter(tableNode);
	            dom.remove(marker);
	            next = paragraph;
	        }

	        if (!next) {
	            if (!(li || heading)) {
	                new BlockFormatter([{ tags: ['p']}]).apply([marker]);
	            }

	            range.selectNode(marker);

	            parent = dom.parentOfType(marker, [li ? 'li' : heading ? dom.name(heading) : 'p']);

	            RangeUtils.split(range, parent, shouldTrim);

	            previous = parent.previousSibling;

	            if (dom.is(previous, 'li') && previous.firstChild && !dom.is(previous.firstChild, 'br')) {
	                previous = previous.firstChild;
	            }

	            next = parent.nextSibling;

	            this.clean(previous, { links: true });
	            this.clean(next, { links: true });

	            if (dom.is(next, 'li') && next.firstChild && !dom.is(next.firstChild, 'br')) {
	                next = next.firstChild;
	            }

	            dom.remove(parent);

	            // normalize updates the caret display in Gecko
	            normalize(previous);
	        }

	        normalize(next);

	        this._moveFocus(range, next);

	        range.collapse(true);

	        dom.scrollTo(next, true);

	        RangeUtils.selectRange(range);
	    },

	    _insertParagraphAfter: function (node) {
	        var range = this.getRange();
	        var doc = RangeUtils.documentFromRange(range);
	        var emptyElementContent = editorNS.emptyElementContent;
	        var paragraph = dom.create(doc, 'p');

	        dom.insertAfter(paragraph, node);
	        paragraph.innerHTML = emptyElementContent;

	        return paragraph;
	    },

	    clean: function(node, options) {
	        var root = node;

	        if (node.firstChild && dom.is(node.firstChild, 'br')) {
	            dom.remove(node.firstChild);
	        }

	        if (dom.isDataNode(node) && !node.nodeValue) {
	            node = node.parentNode;
	        }

	        if (node) {
	            var siblings = false;
	            while (node.firstChild && node.firstChild.nodeType == 1) {
	                siblings = siblings || (dom.significantNodes(node.childNodes).length > 1);
	                node = node.firstChild;
	            }

	            if (!dom.isEmpty(node) && /^\s*$/.test(node.innerHTML) && !siblings) {
	                $(root).find(".k-br").remove();
	                node.innerHTML = editorNS.emptyElementContent;
	            }

	            if (options && options.links) {
	                while (node != root) {
	                    if (dom.is(node, "a") && dom.emptyNode(node)) {
	                        dom.unwrap(node);
	                        break;
	                    }
	                    node = node.parentNode;
	                }
	            }
	        }
	    }
	});

	var NewLineCommand = Command.extend({
	    init: function(options) {
	        this.options = options;
	        Command.fn.init.call(this, options);
	    },

	    exec: function () {
	        var range = this.getRange();
	        this.expandImmutablesIn(range);

	        var br = dom.create(RangeUtils.documentFromRange(range), 'br');
	        var node = range.startContainer;
	        var filler;
	        var browser = kendo.support.browser;
	        var oldIE = browser.msie && browser.version < 11;

	        var tableNode = dom.is(node, 'table') && node;

	        range.deleteContents();
	        if (tableNode) {
	            dom.insertAfter(br, tableNode);
	        } else {
	            range.insertNode(br);
	        }

	        normalize(br.parentNode);

	        if (!oldIE && (!br.nextSibling || dom.isWhitespace(br.nextSibling))) {
	            // Gecko and WebKit cannot put the caret after only one br.
	            filler = br.cloneNode(true);
	            filler.className = 'k-br';
	            dom.insertAfter(filler, br);
	        }

	        range.setStartAfter(br);
	        range.collapse(true);

	        dom.scrollTo(br.nextSibling || br, true);

	        RangeUtils.selectRange(range);
	    }
	});

	extend(editorNS, {
	    ParagraphCommand: ParagraphCommand,
	    NewLineCommand: NewLineCommand
	});

	registerTool("insertLineBreak", new Tool({ key: 13, shift: true, command: NewLineCommand }));
	registerTool("insertParagraph", new Tool({ key: 13, command: ParagraphCommand }));

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "/ocq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v3.0.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.0.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),

/***/ "02+g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("7+uW");

var Vue = _interopRequireWildcard(_vue);

var _KendoMultiSelectMixin = __webpack_require__("VqpB");

var _KendoMultiSelectMixin2 = _interopRequireDefault(_KendoMultiSelectMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-multiselect',
    mixins: [_KendoMultiSelectMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('input', [this.$slots['kendo-datasource']]);
    }
};

/***/ }),

/***/ "0B0E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var dragAndDropService_1 = __webpack_require__("I/uN");
var context_1 = __webpack_require__("RQ1/");
var moveColumnController_1 = __webpack_require__("7JmM");
var column_1 = __webpack_require__("hDyE");
var gridPanel_1 = __webpack_require__("inOk");
var bodyDropPivotTarget_1 = __webpack_require__("PobA");
var columnController_1 = __webpack_require__("77lH");
var DropType;
(function (DropType) {
    DropType[DropType["ColumnMove"] = 0] = "ColumnMove";
    DropType[DropType["Pivot"] = 1] = "Pivot";
})(DropType || (DropType = {}));
var BodyDropTarget = (function () {
    function BodyDropTarget(pinned, eContainer) {
        this.dropListeners = {};
        this.pinned = pinned;
        this.eContainer = eContainer;
    }
    BodyDropTarget.prototype.isInterestedIn = function (type) {
        // not interested in row drags
        return type === dragAndDropService_1.DragSourceType.HeaderCell || type === dragAndDropService_1.DragSourceType.ToolPanel;
    };
    BodyDropTarget.prototype.getSecondaryContainers = function () {
        return this.eSecondaryContainers;
    };
    BodyDropTarget.prototype.getContainer = function () {
        return this.eContainer;
    };
    BodyDropTarget.prototype.init = function () {
        var moveColumnController = new moveColumnController_1.MoveColumnController(this.pinned, this.eContainer);
        this.context.wireBean(moveColumnController);
        var bodyDropPivotTarget = new bodyDropPivotTarget_1.BodyDropPivotTarget(this.pinned);
        this.context.wireBean(bodyDropPivotTarget);
        this.dropListeners[DropType.ColumnMove] = moveColumnController;
        this.dropListeners[DropType.Pivot] = bodyDropPivotTarget;
        switch (this.pinned) {
            case column_1.Column.PINNED_LEFT:
                this.eSecondaryContainers = this.gridPanel.getDropTargetLeftContainers();
                break;
            case column_1.Column.PINNED_RIGHT:
                this.eSecondaryContainers = this.gridPanel.getDropTargetPinnedRightContainers();
                break;
            default:
                this.eSecondaryContainers = this.gridPanel.getDropTargetBodyContainers();
                break;
        }
        this.dragAndDropService.addDropTarget(this);
    };
    BodyDropTarget.prototype.getIconName = function () {
        return this.currentDropListener.getIconName();
    };
    // we want to use the bodyPivotTarget if the user is dragging columns in from the toolPanel
    // and we are in pivot mode, as it has to logic to set pivot/value/group on the columns when
    // dropped into the grid's body.
    BodyDropTarget.prototype.getDropType = function (draggingEvent) {
        if (this.columnController.isPivotMode()) {
            // in pivot mode, then if moving a column (ie didn't come from toolpanel) then it's
            // a standard column move, however if it came from teh toolpanel, then we are introducing
            // dimensions or values to the grid
            if (draggingEvent.dragSource.type === dragAndDropService_1.DragSourceType.ToolPanel) {
                return DropType.Pivot;
            }
            else {
                return DropType.ColumnMove;
            }
        }
        else {
            // it's a column, and not pivot mode, so always moving
            return DropType.ColumnMove;
        }
    };
    BodyDropTarget.prototype.onDragEnter = function (draggingEvent) {
        // we pick the drop listener depending on whether we are in pivot mode are not. if we are
        // in pivot mode, then dropping cols changes the row group, pivot, value stats. otherwise
        // we change visibility state and position.
        // if (this.columnController.isPivotMode()) {
        var dropType = this.getDropType(draggingEvent);
        this.currentDropListener = this.dropListeners[dropType];
        this.currentDropListener.onDragEnter(draggingEvent);
    };
    BodyDropTarget.prototype.onDragLeave = function (params) {
        this.currentDropListener.onDragLeave(params);
    };
    BodyDropTarget.prototype.onDragging = function (params) {
        this.currentDropListener.onDragging(params);
    };
    BodyDropTarget.prototype.onDragStop = function (params) {
        this.currentDropListener.onDragStop(params);
    };
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], BodyDropTarget.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('gridPanel'),
        __metadata("design:type", gridPanel_1.GridPanel)
    ], BodyDropTarget.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('dragAndDropService'),
        __metadata("design:type", dragAndDropService_1.DragAndDropService)
    ], BodyDropTarget.prototype, "dragAndDropService", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], BodyDropTarget.prototype, "columnController", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BodyDropTarget.prototype, "init", null);
    return BodyDropTarget;
}());
exports.BodyDropTarget = BodyDropTarget;


/***/ }),

/***/ "0CSa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("7+uW");

var Vue = _interopRequireWildcard(_vue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue; // @ts-ignore

var gh = allVue.h;
exports.default = {
    render: function render(createElement) {
        var h = gh || createElement;
        return h('input', {
            ref: 'valueInput',
            props: {
                value: this.value
            }
        });
    },

    model: {
        event: 'changemodel'
    }
};

/***/ }),

/***/ "0Gxk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = __webpack_require__("pQ38");
var componentAnnotations_1 = __webpack_require__("x5ih");
var utils_1 = __webpack_require__("IRr6");
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var AgCheckbox = (function (_super) {
    __extends(AgCheckbox, _super);
    function AgCheckbox() {
        var _this = _super.call(this) || this;
        _this.selected = false;
        _this.readOnly = false;
        _this.passive = false;
        return _this;
    }
    AgCheckbox.prototype.postConstruct = function () {
        this.setTemplate(AgCheckbox.TEMPLATE);
        this.loadIcons();
        this.updateIcons();
    };
    AgCheckbox.prototype.attributesSet = function () {
        _super.prototype.attributesSet.call(this);
        var label = this.getAttribute('label');
        if (label) {
            this.eLabel.innerText = label;
        }
    };
    AgCheckbox.prototype.loadIcons = function () {
        utils_1.Utils.removeAllChildren(this.eChecked);
        utils_1.Utils.removeAllChildren(this.eUnchecked);
        utils_1.Utils.removeAllChildren(this.eIndeterminate);
        if (this.readOnly) {
            this.eChecked.appendChild(utils_1.Utils.createIconNoSpan('checkboxCheckedReadOnly', this.gridOptionsWrapper, null));
            this.eUnchecked.appendChild(utils_1.Utils.createIconNoSpan('checkboxUncheckedReadOnly', this.gridOptionsWrapper, null));
            this.eIndeterminate.appendChild(utils_1.Utils.createIconNoSpan('checkboxIndeterminateReadOnly', this.gridOptionsWrapper, null));
        }
        else {
            this.eChecked.appendChild(utils_1.Utils.createIconNoSpan('checkboxChecked', this.gridOptionsWrapper, null));
            this.eUnchecked.appendChild(utils_1.Utils.createIconNoSpan('checkboxUnchecked', this.gridOptionsWrapper, null));
            this.eIndeterminate.appendChild(utils_1.Utils.createIconNoSpan('checkboxIndeterminate', this.gridOptionsWrapper, null));
        }
    };
    AgCheckbox.prototype.onClick = function (event) {
        // if we don't set the path, then won't work in Edge, as once the <span> is removed from the dom,
        // it's not possible to calculate the path by following the parent's chain. in other browser (eg
        // chrome) there is event.path for this purpose, but missing in Edge.
        utils_1.Utils.addAgGridEventPath(event);
        if (!this.readOnly) {
            this.toggle();
        }
    };
    AgCheckbox.prototype.getNextValue = function () {
        if (this.selected === undefined) {
            return true;
        }
        else {
            return !this.selected;
        }
    };
    AgCheckbox.prototype.setPassive = function (passive) {
        this.passive = passive;
    };
    AgCheckbox.prototype.setReadOnly = function (readOnly) {
        this.readOnly = readOnly;
        this.loadIcons();
    };
    AgCheckbox.prototype.isReadOnly = function () {
        return this.readOnly;
    };
    AgCheckbox.prototype.isSelected = function () {
        return this.selected;
    };
    AgCheckbox.prototype.toggle = function () {
        var nextValue = this.getNextValue();
        if (this.passive) {
            var event_1 = {
                type: AgCheckbox.EVENT_CHANGED,
                selected: nextValue
            };
            this.dispatchEvent(event_1);
        }
        else {
            this.setSelected(nextValue);
        }
    };
    AgCheckbox.prototype.setSelected = function (selected) {
        if (this.selected === selected) {
            return;
        }
        if (selected === true) {
            this.selected = true;
        }
        else if (selected === false) {
            this.selected = false;
        }
        else {
            this.selected = undefined;
        }
        this.updateIcons();
        var event = {
            type: AgCheckbox.EVENT_CHANGED,
            selected: this.selected
        };
        this.dispatchEvent(event);
    };
    AgCheckbox.prototype.updateIcons = function () {
        utils_1.Utils.setVisible(this.eChecked, this.selected === true);
        utils_1.Utils.setVisible(this.eUnchecked, this.selected === false);
        utils_1.Utils.setVisible(this.eIndeterminate, this.selected === undefined);
    };
    AgCheckbox.EVENT_CHANGED = 'change';
    AgCheckbox.TEMPLATE = '<span class="ag-checkbox" role="presentation">' +
        '  <span class="ag-checkbox-checked" role="presentation"></span>' +
        '  <span class="ag-checkbox-unchecked" role="presentation"></span>' +
        '  <span class="ag-checkbox-indeterminate" role="presentation"></span>' +
        '  <span class="ag-checkbox-label" role="presentation"></span>' +
        '</span>';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], AgCheckbox.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        componentAnnotations_1.QuerySelector('.ag-checkbox-checked'),
        __metadata("design:type", HTMLElement)
    ], AgCheckbox.prototype, "eChecked", void 0);
    __decorate([
        componentAnnotations_1.QuerySelector('.ag-checkbox-unchecked'),
        __metadata("design:type", HTMLElement)
    ], AgCheckbox.prototype, "eUnchecked", void 0);
    __decorate([
        componentAnnotations_1.QuerySelector('.ag-checkbox-indeterminate'),
        __metadata("design:type", HTMLElement)
    ], AgCheckbox.prototype, "eIndeterminate", void 0);
    __decorate([
        componentAnnotations_1.QuerySelector('.ag-checkbox-label'),
        __metadata("design:type", HTMLElement)
    ], AgCheckbox.prototype, "eLabel", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AgCheckbox.prototype, "postConstruct", null);
    __decorate([
        componentAnnotations_1.Listener('click'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [MouseEvent]),
        __metadata("design:returntype", void 0)
    ], AgCheckbox.prototype, "onClick", null);
    return AgCheckbox;
}(component_1.Component));
exports.AgCheckbox = AgCheckbox;


/***/ }),

/***/ "0vz1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var context_2 = __webpack_require__("RQ1/");
var TemplateService = (function () {
    function TemplateService() {
        this.templateCache = {};
        this.waitingCallbacks = {};
    }
    // returns the template if it is loaded, or null if it is not loaded
    // but will call the callback when it is loaded
    TemplateService.prototype.getTemplate = function (url, callback) {
        var templateFromCache = this.templateCache[url];
        if (templateFromCache) {
            return templateFromCache;
        }
        var callbackList = this.waitingCallbacks[url];
        var that = this;
        if (!callbackList) {
            // first time this was called, so need a new list for callbacks
            callbackList = [];
            this.waitingCallbacks[url] = callbackList;
            // and also need to do the http request
            var client = new XMLHttpRequest();
            client.onload = function () {
                that.handleHttpResult(this, url);
            };
            client.open("GET", url);
            client.send();
        }
        // add this callback
        if (callback) {
            callbackList.push(callback);
        }
        // caller needs to wait for template to load, so return null
        return null;
    };
    TemplateService.prototype.handleHttpResult = function (httpResult, url) {
        if (httpResult.status !== 200 || httpResult.response === null) {
            console.warn('Unable to get template error ' + httpResult.status + ' - ' + url);
            return;
        }
        // response success, so process it
        // in IE9 the response is in - responseText
        this.templateCache[url] = httpResult.response || httpResult.responseText;
        // inform all listeners that this is now in the cache
        var callbacks = this.waitingCallbacks[url];
        for (var i = 0; i < callbacks.length; i++) {
            var callback = callbacks[i];
            // we could pass the callback the response, however we know the client of this code
            // is the cell renderer, and it passes the 'cellRefresh' method in as the callback
            // which doesn't take any parameters.
            callback();
        }
        if (this.$scope) {
            var that_1 = this;
            setTimeout(function () {
                that_1.$scope.$apply();
            }, 0);
        }
    };
    __decorate([
        context_2.Autowired('$scope'),
        __metadata("design:type", Object)
    ], TemplateService.prototype, "$scope", void 0);
    TemplateService = __decorate([
        context_1.Bean('templateService')
    ], TemplateService);
    return TemplateService;
}());
exports.TemplateService = TemplateService;


/***/ }),

/***/ "10Gu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var PivotColDefService = (function () {
    function PivotColDefService() {
    }
    PivotColDefService.prototype.createPivotColumnDefs = function (uniqueValues) {
        // this is passed to the columnController, to configure the columns and groups we show
        var pivotColumnGroupDefs = [];
        // this is used by the aggregation stage, to do the aggregation based on the pivot columns
        var pivotColumnDefs = [];
        var pivotColumns = this.columnController.getPivotColumns();
        var levelsDeep = pivotColumns.length;
        var columnIdSequence = new main_1.NumberSequence();
        this.recursivelyAddGroup(pivotColumnGroupDefs, pivotColumnDefs, 1, uniqueValues, [], columnIdSequence, levelsDeep, pivotColumns);
        this.addPivotTotalsToGroups(pivotColumnGroupDefs, pivotColumnDefs, columnIdSequence);
        // we clone, so the colDefs in pivotColumnsGroupDefs and pivotColumnDefs are not shared. this is so that
        // any changes the user makes (via processSecondaryColumnDefinitions) don't impact the internal aggregations,
        // as these use the col defs also
        var pivotColumnDefsClone = pivotColumnDefs.map(function (colDef) { return main_1.Utils.cloneObject(colDef); });
        return {
            pivotColumnGroupDefs: pivotColumnGroupDefs,
            pivotColumnDefs: pivotColumnDefsClone
        };
    };
    // parentChildren - the list of colDefs we are adding to
    // @index - how far the column is from the top (also same as pivotKeys.length)
    // @uniqueValues - the values for which we should create a col for
    // @pivotKeys - the keys for the pivot, eg if pivoting on {Language,Country} then could be {English,Ireland}
    PivotColDefService.prototype.recursivelyAddGroup = function (parentChildren, pivotColumnDefs, index, uniqueValues, pivotKeys, columnIdSequence, levelsDeep, primaryPivotColumns) {
        var _this = this;
        main_1.Utils.iterateObject(uniqueValues, function (key, value) {
            var newPivotKeys = pivotKeys.slice(0);
            newPivotKeys.push(key);
            var createGroup = index !== levelsDeep;
            if (createGroup) {
                var groupDef = {
                    children: [],
                    headerName: key,
                    pivotKeys: newPivotKeys,
                    columnGroupShow: 'open',
                    groupId: 'pivot' + columnIdSequence.next()
                };
                // add total pivot column to non value group
                // this.addPivotTotalColumn(newPivotKeys, columnIdSequence, groupDef, pivotColumnDefs);
                parentChildren.push(groupDef);
                _this.recursivelyAddGroup(groupDef.children, pivotColumnDefs, index + 1, value, newPivotKeys, columnIdSequence, levelsDeep, primaryPivotColumns);
            }
            else {
                var measureColumns = _this.columnController.getValueColumns();
                var valueGroup_1 = {
                    children: [],
                    headerName: key,
                    pivotKeys: newPivotKeys,
                    columnGroupShow: 'open',
                    groupId: 'pivot' + columnIdSequence.next()
                };
                // if no value columns selected, then we insert one blank column, so the user at least sees columns
                // rendered. otherwise the grid would render with no columns (just empty groups) which would give the
                // impression that the grid is broken
                if (measureColumns.length === 0) {
                    // this is the blank column, for when no value columns enabled.
                    var colDef_1 = _this.createColDef(null, '-', newPivotKeys, columnIdSequence);
                    valueGroup_1.children.push(colDef_1);
                    pivotColumnDefs.push(colDef_1);
                }
                else {
                    // add total pivot column to value group
                    // this.addPivotTotalColumn(newPivotKeys, columnIdSequence, valueGroup, pivotColumnDefs);
                    measureColumns.forEach(function (measureColumn) {
                        var columnName = _this.columnController.getDisplayNameForColumn(measureColumn, 'header');
                        var colDef = _this.createColDef(measureColumn, columnName, newPivotKeys, columnIdSequence);
                        colDef.columnGroupShow = 'open';
                        valueGroup_1.children.push(colDef);
                        pivotColumnDefs.push(colDef);
                    });
                }
                parentChildren.push(valueGroup_1);
            }
        });
        // sort by either user provided comparator, or our own one
        var colDef = primaryPivotColumns[index - 1].getColDef();
        var userComparator = colDef.pivotComparator;
        var comparator = this.headerNameComparator.bind(this, userComparator);
        parentChildren.sort(comparator);
    };
    PivotColDefService.prototype.addPivotTotalsToGroups = function (pivotColumnGroupDefs, pivotColumnDefs, columnIdSequence) {
        var _this = this;
        if (!this.gridOptionsWrapper.isPivotTotals())
            return;
        var valueColDefs = this.columnController.getValueColumns();
        var aggFuncs = valueColDefs.map(function (colDef) { return colDef.getAggFunc(); });
        // don't add pivot totals if there is less than 1 aggFunc or they are not all the same
        if (!aggFuncs || aggFuncs.length < 1 || !this.sameAggFuncs(aggFuncs)) {
            // console.warn('ag-Grid: aborting adding pivot total columns - value columns require same aggFunc');
            return;
        }
        // arbitrarily select a value column to use as a template for pivot columns
        var valueColumn = this.columnController.getValueColumns()[0];
        pivotColumnGroupDefs.forEach(function (groupDef) {
            _this.recursivelyAddPivotTotal(groupDef, pivotColumnDefs, columnIdSequence, valueColumn);
        });
    };
    PivotColDefService.prototype.recursivelyAddPivotTotal = function (groupDef, pivotColumnDefs, columnIdSequence, valueColumn) {
        var _this = this;
        var group = groupDef;
        if (!group.children)
            return [groupDef.colId];
        var colIds = [];
        // need to recurse children first to obtain colIds used in the aggregation stage
        group.children
            .forEach(function (grp) {
            var childColIds = _this.recursivelyAddPivotTotal(grp, pivotColumnDefs, columnIdSequence, valueColumn);
            colIds = colIds.concat(childColIds);
        });
        // only add total colDef if there is more than 1 child node
        if (group.children.length > 1) {
            //create total colDef using an arbitrary value column as a template
            var totalColDef = this.createColDef(valueColumn, 'Total', groupDef.pivotKeys, columnIdSequence);
            totalColDef.pivotTotalColumnIds = colIds;
            totalColDef.aggFunc = valueColumn.getAggFunc();
            // add total colDef to group and pivot colDefs array
            groupDef.children.unshift(totalColDef); //put totals to the front
            pivotColumnDefs.push(totalColDef);
        }
        return colIds;
    };
    PivotColDefService.prototype.createColDef = function (valueColumn, headerName, pivotKeys, columnIdSequence) {
        var colDef = {};
        if (valueColumn) {
            var colDefToCopy = valueColumn.getColDef();
            main_1.Utils.assign(colDef, colDefToCopy);
            // even if original column was hidden, we always show the pivot value column, otherwise it would be
            // very confusing for people thinking the pivot is broken
            colDef.hide = false;
        }
        colDef.headerName = headerName;
        colDef.colId = 'pivot_' + columnIdSequence.next();
        // pivot columns repeat over field, so it makes sense to use the unique id instead. For example if you want to
        // assign values to pinned bottom rows using setPinnedBottomRowData the value service will use this colId.
        colDef.field = colDef.colId;
        colDef.pivotKeys = pivotKeys;
        colDef.pivotValueColumn = valueColumn;
        return colDef;
    };
    PivotColDefService.prototype.sameAggFuncs = function (aggFuncs) {
        if (aggFuncs.length == 1)
            return true;
        //check if all aggFunc's match
        for (var i = 1; i < aggFuncs.length; i++) {
            if (aggFuncs[i] !== aggFuncs[0])
                return false;
        }
        return true;
    };
    PivotColDefService.prototype.headerNameComparator = function (userComparator, a, b) {
        if (userComparator) {
            return userComparator(a.headerName, b.headerName);
        }
        else {
            if (a.headerName < b.headerName) {
                return -1;
            }
            else if (a.headerName > b.headerName) {
                return 1;
            }
            else {
                return 0;
            }
        }
    };
    __decorate([
        main_1.Autowired('columnController'),
        __metadata("design:type", main_1.ColumnController)
    ], PivotColDefService.prototype, "columnController", void 0);
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], PivotColDefService.prototype, "gridOptionsWrapper", void 0);
    PivotColDefService = __decorate([
        main_1.Bean('pivotColDefService')
    ], PivotColDefService);
    return PivotColDefService;
}());
exports.PivotColDefService = PivotColDefService;


/***/ }),

/***/ "162o":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__("mypn");
// On some exotic environments, it's not clear which object `setimmeidate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "1Xu6":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1012);
	module.exports = __webpack_require__(1012);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1012:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1013) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {

	// Imports ================================================================
	var kendo = window.kendo;
	var Editor = kendo.ui.editor;
	var dom = Editor.Dom;
	var extend = $.extend;

	var fontSizeMappings = 'xx-small,x-small,small,medium,large,x-large,xx-large'.split(',');
	var quoteRe = /"/g; //"
	var brRe = /<br[^>]*>/i;
	var pixelRe = /^\d+(\.\d*)?(px)?$/i;
	var emptyPRe = /<p>(?:&nbsp;)?<\/p>/i;
	var cssDeclaration = /(\*?[-#\/\*\\\w]+(?:\[[0-9a-z_-]+\])?)\s*:\s*((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^\)]*?\)|[^};])+)/g;
	var sizzleAttr = /^sizzle-\d+/i;
	var scriptAttr = /^k-script-/i;
	var onerrorRe = /\s*onerror\s*=\s*(?:'|")?([^'">\s]*)(?:'|")?/i;
	var br = '<br class="k-br">';
	var bomSpan = "<span class='k-br'>\ufeff</span>";

	var div = document.createElement("div");
	div.innerHTML = " <hr>";
	var supportsLeadingWhitespace = div.firstChild.nodeType === 3;
	div = null;
	var isFunction = $.isFunction;

	var TD = "td";

	var Serializer = {
	    toEditableHtml: function(html) {
	        return (html || "")
	            .replace(/<!\[CDATA\[(.*)?\]\]>/g, "<!--[CDATA[$1]]-->")
	            .replace(/<(\/?)script([^>]*)>/ig, "<$1k:script$2>")
	            .replace(/<img([^>]*)>/ig, function(match) {
	                return match.replace(onerrorRe, "");
	            })
	            .replace(/(<\/?img[^>]*>)[\r\n\v\f\t ]+/ig, "$1")
	            .replace(/^<(table|blockquote)/i, br + '<$1')
	            .replace(/^[\s]*(&nbsp;|\u00a0)/i, '$1')
	            .replace(/<\/(table|blockquote)>$/i, '</$1>' + br);
	    },

	    _toEditableImmutables: function(body) {
	        var immutable = Editor.Immutables.immutable,
	            emptyTextNode = dom.emptyTextNode,
	            first = body.firstChild,
	            last = body.lastChild;

	        while (emptyTextNode(first)){
	            first = first.nextSibling;
	        }

	        while (emptyTextNode(last)){
	            last = last.previousSibling;
	        }

	        if (first && immutable(first)) {
	            $(bomSpan).prependTo(body);
	        }

	        if (last && immutable(last)) {
	            $(bomSpan).appendTo(body);
	        }
	    },

	    _fillEmptyElements: function(body) {
	        // fills empty elements to allow them to be focused
	        $(body).find("p,td").each(function() {
	            var p = $(this);
	            if (/^\s*$/g.test(p.text()) && !p.find("img,input").length) {
	                var node = this;
	                while (node.firstChild && node.firstChild.nodeType != 3) {
	                    node = node.firstChild;
	                }

	                if (node.nodeType == 1 && !dom.empty[dom.name(node)]) {
	                    if(dom.is(node, "td")) {
	                        node.innerHTML = kendo.ui.editor.emptyTableCellContent;
	                    }
	                    else {
	                        node.innerHTML = kendo.ui.editor.emptyElementContent;
	                    }
	                }
	            }
	        });
	    },

	    _removeSystemElements: function(body) {
	        // removes persisted system elements
	        $(".k-paste-container", body).remove();
	    },

	    _resetOrderedLists: function(root){
	        // fix for IE9 OL bug -- https://connect.microsoft.com/IE/feedback/details/657695/ordered-list-numbering-changes-from-correct-to-0-0
	        var ols = root.getElementsByTagName("ol"), i, ol, originalStart;

	        for (i = 0; i < ols.length; i++) {
	            ol = ols[i];
	            originalStart = ol.getAttribute("start");

	            ol.setAttribute("start", 1);

	            if (originalStart) {
	                ol.setAttribute("start", originalStart);
	            } else {
	                ol.removeAttribute(originalStart);
	            }
	        }
	    },

	    _preventScriptExecution: function(root) {
	        $(root).find("*").each(function() {
	            var attributes = this.attributes;
	            var attribute, i, l, name;
	            var attributesToRemove = [];

	            for (i = 0, l = attributes.length; i < l; i++) {
	                attribute = attributes[i];
	                name = attribute.nodeName;

	                if (attribute.specified && /^on/i.test(name)) {
	                    this.setAttribute("k-script-" + name, attribute.value);
	                    attributesToRemove.push(name);
	                }
	            }

	            for (i = 0, l = attributesToRemove.length; i < l; i++) {
	                this.removeAttribute(attributesToRemove[i]);
	            }
	        });
	    },

	    htmlToDom: function(html, root, options) {
	        var browser = kendo.support.browser;
	        var msie = browser.msie;
	        var legacyIE = msie && browser.version < 9;
	        var originalSrc = "originalsrc";
	        var originalHref = "originalhref";
	        var o = options || {};
	        var immutables = o.immutables;

	        html = Serializer.toEditableHtml(html);

	        if (legacyIE) {
	            // Internet Explorer removes comments from the beginning of the html
	            html = "<br/>" + html;

	            // IE < 8 makes href and src attributes absolute
	            html = html.replace(/href\s*=\s*(?:'|")?([^'">\s]*)(?:'|")?/, originalHref + '="$1"');
	            html = html.replace(/src\s*=\s*(?:'|")?([^'">\s]*)(?:'|")?/, originalSrc + '="$1"');

	        }

	        if(isFunction(o.custom)) {
	            html = o.custom(html) || html;
	        }
	        root.innerHTML = html;

	        if (immutables) {
	            immutables.deserialize(root);
	        }

	        if (legacyIE) {
	            dom.remove(root.firstChild);

	            $(root).find("k\\:script,script,link,img,a").each(function () {
	                var node = this;
	                if (node[originalHref]) {
	                    node.setAttribute("href", node[originalHref]);
	                    node.removeAttribute(originalHref);
	                }
	                if (node[originalSrc]) {
	                    node.setAttribute("src", node[originalSrc]);
	                    node.removeAttribute(originalSrc);
	                }
	            });
	        } else if (msie) {
	            // unicode characters denormalize the DOM tree in IE9
	            dom.normalize(root);

	            Serializer._resetOrderedLists(root);
	        }

	        Serializer._preventScriptExecution(root);

	        Serializer._fillEmptyElements(root);

	        Serializer._removeSystemElements(root);

	        Serializer._toEditableImmutables(root);

	        // add k-table class to all tables
	        $("table", root).addClass("k-table");

	        return root;
	    },

	    domToXhtml: function(root, options) {
	        var result = [];
	        var immutables = options && options.immutables;

	        function semanticFilter(attributes) {
	            return $.grep(attributes, function(attr) {
	                return attr.name != "style";
	            });
	        }

	        function mapStart(node, tag) {
	            result.push('<' + tag);
	            attr(node);
	            result.push('>');
	        }

	        var tagMap = {
	            iframe: {
	                start: function (node) { mapStart(node, "iframe"); },
	                end: function () { result.push('</iframe>'); }
	            },
	            'k:script': {
	                start: function (node) { mapStart(node, "script"); },
	                end: function () { result.push('</script>'); },
	                skipEncoding: true
	            },
	            span: {
	                semantic: true,
	                start: function(node) {
	                    var style = node.style;
	                    var attributes = specifiedAttributes(node);
	                    var semanticAttributes = semanticFilter(attributes);

	                    if (semanticAttributes.length) {
	                        result.push("<span"); attr(node, semanticAttributes); result.push(">");
	                    }

	                    if (style.textDecoration == "underline") {
	                        result.push("<u>");
	                    }

	                    var font = [];
	                    if (style.color) {
	                        font.push('color="' + dom.toHex(style.color) + '"');
	                    }

	                    if (style.fontFamily) {
	                        font.push('face="' + style.fontFamily + '"');
	                    }

	                    if (style.fontSize) {
	                        var size = $.inArray(style.fontSize, fontSizeMappings);
	                        font.push('size="' + size + '"');
	                    }

	                    if (font.length) {
	                        result.push("<font " + font.join(" ") + ">");
	                    }
	                },
	                end: function(node) {
	                    var style = node.style;

	                    if (style.color || style.fontFamily || style.fontSize) {
	                        result.push("</font>");
	                    }

	                    if (style.textDecoration == "underline") {
	                        result.push("</u>");
	                    }

	                    if (semanticFilter(specifiedAttributes(node)).length) {
	                        result.push("</span>");
	                    }
	                }
	            },
	            strong: {
	                semantic: true,
	                start: function (node) { mapStart(node, "b"); },
	                end: function () { result.push('</b>'); }
	            },
	            em: {
	                semantic: true,
	                start: function (node) { mapStart(node, "i"); },
	                end: function () { result.push('</i>'); }
	            },
	            b: {
	                semantic: false,
	                start: function (node) { mapStart(node, "strong"); },
	                end: function () { result.push('</strong>'); }
	            },
	            i: {
	                semantic: false,
	                start: function (node) { mapStart(node, "em"); },
	                end: function () { result.push('</em>'); }
	            },
	            u: {
	                semantic: false,
	                start: function (node) {
	                    result.push('<span');

	                    var attributes = specifiedAttributes(node);
	                    var style = $(attributes).filter(function(i, item){ return item.name == "style"; })[0];
	                    var styleObj = { nodeName: "style", value: "text-decoration:underline;"};

	                    if (style) {
	                        styleObj.value  = style.value;
	                        if (!/text-decoration/i.test(styleObj.value)) {
	                            styleObj.value = "text-decoration:underline;" + styleObj.value;
	                        }
	                        attributes.splice($.inArray(style, attributes), 1);
	                    }
	                    attributes.push(styleObj);

	                    attr(node, attributes);
	                    result.push('>');
	                },
	                end: function () { result.push('</span>'); }
	            },
	            font: {
	                semantic: false,
	                start: function (node) {
	                    result.push('<span style="');

	                    var color = node.getAttribute('color');
	                    var size = fontSizeMappings[node.getAttribute('size')];
	                    var face = node.getAttribute('face');

	                    if (color) {
	                        result.push('color:');
	                        result.push(dom.toHex(color));
	                        result.push(';');
	                    }

	                    if (face) {
	                        result.push('font-family:');
	                        result.push(face);
	                        result.push(';');
	                    }

	                    if (size) {
	                        result.push('font-size:');
	                        result.push(size);
	                        result.push(';');
	                    }

	                    result.push('">');
	                },
	                end: function () {
	                    result.push('</span>');
	                }
	            }
	        };

	        tagMap.script = tagMap["k:script"];

	        options = options || {};

	        if (typeof options.semantic == "undefined") {
	            options.semantic = true;
	        }

	        function cssProperties(cssText) {
	            var trim = kendo.trim;
	            var css = trim(cssText);
	            var match;
	            var property, value;
	            var properties = [];

	            cssDeclaration.lastIndex = 0;

	            while (true) {
	                match = cssDeclaration.exec(css);

	                if (!match) {
	                    break;
	                }

	                property = trim(match[1].toLowerCase());
	                value = trim(match[2]);

	                if (property == "font-size-adjust" || property == "font-stretch") {
	                    continue;
	                }

	                if (property.indexOf('color') >= 0) {
	                    value = dom.toHex(value);
	                } else if (property.indexOf('font') >= 0) {
	                    value = value.replace(quoteRe, "'");
	                } else if (/\burl\(/g.test(value)) {
	                    value = value.replace(quoteRe, "");
	                }

	                properties.push({ property: property, value: value });
	            }

	            return properties;
	        }

	        function styleAttr(cssText) {
	            var properties = cssProperties(cssText);
	            var i;

	            for (i = 0; i < properties.length; i++) {
	                result.push(properties[i].property);
	                result.push(':');
	                result.push(properties[i].value);
	                result.push(';');
	            }
	        }

	        function specifiedAttributes(node) {
	            var result = [];
	            var attributes = node.attributes;
	            var attribute, i, l;
	            var name, value, specified;

	            for (i = 0, l = attributes.length; i < l; i++) {
	                attribute = attributes[i];

	                name = attribute.nodeName;
	                value = attribute.value;
	                specified = attribute.specified;

	                // In IE < 8 the 'value' attribute is not returned as 'specified'. The same goes for type="text"
	                if (name == 'value' && 'value' in node && node.value) {
	                    specified = true;
	                } else if (name == 'type' && value == 'text') {
	                    specified = true;
	                } else if (name == "class" && !value) {
	                    specified = false;
	                } else if (sizzleAttr.test(name)) {
	                    specified = false;
	                } else if (name == 'complete') {
	                    specified = false;
	                } else if (name == 'altHtml') {
	                    specified = false;
	                } else if (name == 'start' && dom.is(node, "ul")) {
	                    specified = false;
	                } else if (name == 'start' && dom.is(node, "ol") && value == "1") {
	                    specified = false;
	                } else if (name.indexOf('_moz') >= 0) {
	                    specified = false;
	                } else if (scriptAttr.test(name)) {
	                    specified = !!options.scripts;
	                } else if (name == 'data-role' && value == 'resizable' && (dom.is(node, "tr") || dom.is(node, "td"))) {
	                    specified = false;
	                }

	                if (specified) {
	                    result.push(attribute);
	                }
	            }

	            return result;
	        }

	        function attr(node, attributes) {
	            var i, l, attribute, name, value;

	            attributes = attributes || specifiedAttributes(node);

	            if (dom.is(node, 'img')) {
	                var width = node.style.width,
	                    height = node.style.height,
	                    $node = $(node);

	                if (width && pixelRe.test(width)) {
	                    $node.attr('width', parseInt(width, 10));
	                    dom.unstyle(node, { width: undefined });
	                }

	                if (height && pixelRe.test(height)) {
	                    $node.attr('height', parseInt(height, 10));
	                    dom.unstyle(node, { height: undefined });
	                }
	            }

	            if (!attributes.length) {
	                return;
	            }

	            // Remove the following if everything seems to be in order.
	            // https://github.com/telerik/kendo-ui-core/issues/3639
	            // attributes.sort(function (a, b) {
	            //     return a.nodeName > b.nodeName ? 1 : a.nodeName < b.nodeName ? -1 : 0;
	            // });

	            for (i = 0, l = attributes.length; i < l; i++) {
	                attribute = attributes[i];
	                name = attribute.nodeName;
	                value = attribute.value;

	                if (name == "class" && value == "k-table") {
	                    continue;
	                }

	                name = name.replace(scriptAttr, "");

	                result.push(' ');
	                result.push(name);
	                result.push('="');

	                if (name == 'style') {
	                    styleAttr(value || node.style.cssText);
	                } else if (name == 'src' || name == 'href') {
	                    result.push(kendo.htmlEncode(node.getAttribute(name, 2)));
	                } else {
	                    result.push(dom.fillAttrs[name] ? name : value);
	                }

	                result.push('"');
	            }
	        }

	        function children(node, skip, skipEncoding) {
	            for (var childNode = node.firstChild; childNode; childNode = childNode.nextSibling) {
	                child(childNode, skip, skipEncoding);
	            }
	        }

	        function text(node) {
	            return node.nodeValue.replace(/\ufeff/g, "");
	        }

	        function isEmptyBomNode(node) {
	            if (dom.isBom(node)) {
	                do {
	                    node = node.parentNode;

	                    if (dom.is(node, TD) && node.childNodes.length === 1) {
	                        return true;
	                    }

	                    if (node.childNodes.length !== 1) {
	                        return false;
	                    }
	                } while(!dom.isBlock(node));

	                return true;
	            }

	            return false;
	        }

	        function child(node, skip, skipEncoding) {
	            var nodeType = node.nodeType,
	                tagName, mapper,
	                parent, value, previous, jqNode;

	            if (immutables && Editor.Immutables.immutable(node)) {
	                result.push(immutables.serialize(node));
	            } else if (nodeType == 1) {
	                tagName = dom.name(node);
	                jqNode = $(node);

	                if (jqNode.hasClass("k-table-resize-handle-wrapper") || jqNode.hasClass("k-column-resize-handle-wrapper") || jqNode.hasClass("k-row-resize-handle-wrapper")) {
	                    return;
	                }

	                if (!tagName || dom.insignificant(node)) {
	                    return;
	                }

	                if (!options.scripts && (tagName == "script" || tagName == "k:script")) {
	                    return;
	                }

	                mapper = tagMap[tagName];

	                if (mapper) {
	                    if (typeof mapper.semantic == "undefined" ||
	                        (options.semantic ^ mapper.semantic)) {
	                        mapper.start(node);
	                        children(node, false, mapper.skipEncoding);
	                        mapper.end(node);
	                        return;
	                    }
	                }

	                result.push('<');
	                result.push(tagName);

	                attr(node);

	                if (dom.empty[tagName]) {
	                    result.push(' />');
	                } else {
	                    result.push('>');
	                    children(node, skip || dom.is(node, 'pre'));
	                    result.push('</');
	                    result.push(tagName);
	                    result.push('>');
	                }
	            } else if (nodeType == 3) {
	                if(isEmptyBomNode(node)) {
	                    result.push('&nbsp;');
	                    return;
	                }

	                value = text(node);

	                if (!skip && supportsLeadingWhitespace) {
	                    parent = node.parentNode;
	                    previous = node.previousSibling;

	                    if (!previous) {
	                         previous = (dom.isInline(parent) ? parent : node).previousSibling;
	                    }

	                    if (!previous || previous.innerHTML === "" || dom.isBlock(previous)) {
	                        value = value.replace(/^[\r\n\v\f\t ]+/, '');
	                    }

	                    value = value.replace(/ +/, ' ');
	                }

	                result.push(skipEncoding ? value : dom.encode(value, options));

	            } else if (nodeType == 4) {
	                result.push('<![CDATA[');
	                result.push(node.data);
	                result.push(']]>');
	            } else if (nodeType == 8) {
	                if (node.data.indexOf('[CDATA[') < 0) {
	                    result.push('<!--');
	                    result.push(node.data);
	                    result.push('-->');
	                } else {
	                    result.push('<!');
	                    result.push(node.data);
	                    result.push('>');
	                }
	            }
	        }

	        function textOnly(root) {
	            var childrenCount = root.childNodes.length;
	            var textChild = childrenCount && root.firstChild.nodeType == 3;

	            return textChild && (childrenCount == 1 || (childrenCount == 2 && dom.insignificant(root.lastChild)));
	        }

	        function runCustom() {
	            if ($.isFunction(options.custom)) {
	                result = options.custom(result) || result;
	            }
	        }

	        if (textOnly(root)) {
	            result = dom.encode(text(root.firstChild).replace(/[\r\n\v\f\t ]+/, ' '), options);
	            runCustom();

	            return result;
	        }

	        children(root);
	        result = result.join('');
	        runCustom();

	        // if serialized dom contains only whitespace elements, consider it empty (required field validation)
	        if (result.replace(brRe, "").replace(emptyPRe, "") === "") {
	            return "";
	        }

	        return result;
	    }

	};

	extend(Editor, {
	    Serializer: Serializer
	});

	})(window.kendo.jQuery);

	}, __webpack_require__(3));





/***/ }),

/***/ 1013:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("N5PI");

/***/ })

/******/ });

/***/ }),

/***/ "1Z35":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1480);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1480:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1109), __webpack_require__(1086)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	    var __meta__ = { // jshint ignore:line
	        id: "window",
	        name: "Window",
	        category: "web",
	        description: "The Window widget displays content in a modal or non-modal HTML window.",
	        depends: [ "draganddrop", "popup" ],
	        features: [ {
	            id: "window-fx",
	            name: "Animation",
	            description: "Support for animation",
	            depends: [ "fx" ]
	        } ]
	    };

	    (function($, undefined) {
	        var kendo = window.kendo,
	            Widget = kendo.ui.Widget,
	            TabKeyTrap = kendo.ui.Popup.TabKeyTrap,
	            Draggable = kendo.ui.Draggable,
	            isPlainObject = $.isPlainObject,
	            activeElement = kendo._activeElement,
	            outerWidth = kendo._outerWidth,
	            outerHeight = kendo._outerHeight,
	            proxy = $.proxy,
	            extend = $.extend,
	            each = $.each,
	            template = kendo.template,
	            BODY = "body",
	            templates,
	            NS = ".kendoWindow",
	            MODAL_NS = ".kendoWindowModal",
	            // classNames
	            KWINDOW = ".k-window",
	            KWINDOWTITLE = ".k-window-title",
	            KWINDOWTITLEBAR = KWINDOWTITLE + "bar",
	            KWINDOWCONTENT = ".k-window-content",
	            KDIALOGCONTENT = ".k-dialog-content",
	            KWINDOWRESIZEHANDLES = ".k-resize-handle",
	            KOVERLAY = ".k-overlay",
	            KCONTENTFRAME = "k-content-frame",
	            LOADING = "k-i-loading",
	            KHOVERSTATE = "k-state-hover",
	            KFOCUSEDSTATE = "k-state-focused",
	            MAXIMIZEDSTATE = "k-window-maximized",
	            // constants
	            VISIBLE = ":visible",
	            HIDDEN = "hidden",
	            CURSOR = "cursor",
	            // events
	            OPEN = "open",
	            ACTIVATE = "activate",
	            DEACTIVATE = "deactivate",
	            CLOSE = "close",
	            REFRESH = "refresh",
	            MINIMIZE = "minimize",
	            MAXIMIZE = "maximize",
	            RESIZESTART = "resizeStart",
	            RESIZE = "resize",
	            RESIZEEND = "resizeEnd",
	            DRAGSTART = "dragstart",
	            DRAGEND = "dragend",
	            KENDOKEYDOWN = "kendoKeydown",
	            ERROR = "error",
	            OVERFLOW = "overflow",
	            DATADOCOVERFLOWRULE = "original-overflow-rule",
	            ZINDEX = "zIndex",
	            MINIMIZE_MAXIMIZE = ".k-window-actions .k-i-window-minimize,.k-window-actions .k-i-window-maximize",
	            KPIN = ".k-i-pin",
	            KUNPIN = ".k-i-unpin",
	            PIN_UNPIN = KPIN + "," + KUNPIN,
	            TITLEBAR_BUTTONS = ".k-window-titlebar .k-window-action",
	            REFRESHICON = ".k-window-titlebar .k-i-refresh",
	            WINDOWEVENTSHANDLED = "WindowEventsHandled",
	            zero = /^0[a-z]*$/i,
	            isLocalUrl = kendo.isLocalUrl,
	            SIZE = {
	                small: "k-window-sm",
	                medium: "k-window-md",
	                large: "k-window-lg"
	            };

	        function defined(x) {
	            return (typeof x != "undefined");
	        }

	        function toInt(element, property) {
	            return parseInt(element.css(property), 10) || 0;
	        }

	        function constrain(value, low, high) {
	            var normalizedValue;

	            if (value && isNaN(value) && value.toString().indexOf("px") < 0) {
	                normalizedValue = value;
	            } else {
	                normalizedValue = Math.max(
	                    Math.min(parseInt(value, 10), high === Infinity ? high : parseInt(high, 10)),
	                    low === -Infinity ? low : parseInt(low, 10)
	                );
	            }

	            return normalizedValue;
	        }

	        function executableScript() {
	            return !this.type || this.type.toLowerCase().indexOf("script") >= 0;
	        }


	        function getPosition(elem) {
	            var result = { top: elem.offsetTop, left: elem.offsetLeft },
	                parent = elem.offsetParent;

	            while (parent) {
	                result.top += parent.offsetTop;
	                result.left += parent.offsetLeft;

	                var parentOverflowX = $(parent).css("overflowX");
	                var parentOverflowY = $(parent).css("overflowY");

	                if (parentOverflowY === "auto" || parentOverflowY === "scroll") {
	                    result.top -= parent.scrollTop;
	                }

	                if (parentOverflowX === "auto" || parentOverflowX === "scroll") {
	                    result.left -= parent.scrollLeft;
	                }

	                parent = parent.offsetParent;
	            }

	            return result;
	        }

	        var Window = Widget.extend({
	            init: function(element, options) {
	                var that = this,
	                    wrapper,
	                    offset = {},
	                    visibility, display, position,
	                    isVisible = false,
	                    content,
	                    windowContent,
	                    windowFrame,
	                    globalWindow,
	                    suppressActions = options && options.actions && !options.actions.length,
	                    id;

	                Widget.fn.init.call(that, element, options);
	                options = that.options;
	                position = options.position;
	                element = that.element;
	                content = options.content;
	                globalWindow = $(window);

	                if (suppressActions) {
	                    options.actions = [];
	                }

	                that.appendTo = $(options.appendTo);

	                that.containment = options.draggable.containment ? $(options.draggable.containment).first() : null;

	                if (content && !isPlainObject(content)) {
	                    content = options.content = { url: content };
	                }

	                // remove script blocks to prevent double-execution
	                element.find("script").filter(executableScript).remove();

	                if (!element.parent().is(that.appendTo) && !that.containment && (position.top === undefined || position.left === undefined)) {
	                    if (element.is(VISIBLE)) {
	                        offset = element.offset();
	                        isVisible = true;
	                    } else {
	                        visibility = element.css("visibility");
	                        display = element.css("display");

	                        element.css({ visibility: HIDDEN, display: "" });
	                        offset = element.offset();
	                        element.css({ visibility: visibility, display: display });
	                    }

	                    if (position.top === undefined) {
	                        position.top = offset.top;
	                    }
	                    if (position.left === undefined) {
	                        position.left = offset.left;
	                    }
	                }

	                if (!defined(options.visible) || options.visible === null) {
	                    options.visible = element.is(VISIBLE);
	                }

	                wrapper = that.wrapper = element.closest(KWINDOW);

	                if (!element.is(".k-window-content") || !wrapper[0]) {
	                    element.addClass("k-window-content");
	                    that._createWindow(element, options);
	                    wrapper = that.wrapper = element.closest(KWINDOW);

	                    that.title(that.options.title);
	                    that._dimensions();
	                }

	                that.minTop = that.minLeft = -Infinity;
	                that.maxTop = that.maxLeft = Infinity;
	                that._position();

	                if (content) {
	                    that.refresh(content);
	                }

	                if (options.visible) {
	                    that.toFront();
	                }

	                windowContent = wrapper.children(KWINDOWCONTENT);

	                if (options.visible && options.modal) {
	                    that._overlay(wrapper.is(VISIBLE)).css({ opacity: 0.5 });
	                }

	                wrapper
	                    .on("mouseenter" + NS, TITLEBAR_BUTTONS, proxy(that._buttonEnter, that))
	                    .on("mouseleave" + NS, TITLEBAR_BUTTONS, proxy(that._buttonLeave, that))
	                    .on("click" + NS, "> " + TITLEBAR_BUTTONS, proxy(that._windowActionHandler, that))
	                    .on("keydown" + NS, that, proxy(that._keydown, that))
	                    .on("focus" + NS, proxy(that._focus, that))
	                    .on("blur" + NS, proxy(that._blur, that));

	                windowContent
	                    .on("keydown" + NS, that, proxy(that._keydownContent, that));

	                windowFrame = windowContent.find("." + KCONTENTFRAME)[0];

	                if(windowFrame && !globalWindow.data(WINDOWEVENTSHANDLED)){

	                    globalWindow.on("blur" + NS, function(){
	                        var element = $(document.activeElement).parent(KWINDOWCONTENT);
	                        if (element.length) {
	                            var windowInstance = kendo.widgetInstance(element);
	                            windowInstance._focus();
	                        }
	                    });

	                    globalWindow.on("focus" + NS, function(){
	                        $(KWINDOWCONTENT).not(KDIALOGCONTENT).each(function(i, element){
	                            kendo.widgetInstance($(element))._blur();
	                        });
	                    });

	                    globalWindow.data(WINDOWEVENTSHANDLED, true);
	                }

	                this._resizable();

	                this._draggable();

	                if (options.pinned && this.wrapper.is(":visible")) {
	                    that.pin();
	                }

	                id = element.attr("id");
	                if (id) {
	                    id = id + "_wnd_title";
	                    wrapper.children(KWINDOWTITLEBAR)
	                        .children(KWINDOWTITLE)
	                        .attr("id", id);

	                    windowContent
	                        .attr({
	                            "role": "dialog",
	                            "aria-labelledby": id
	                        });
	                }

	                wrapper.add(wrapper.children(".k-resize-handle," + KWINDOWTITLEBAR))
	                    .on("mousedown" + NS, proxy(that.toFront, that));

	                that.touchScroller = kendo.touchScroller(element);

	                that._resizeHandler = proxy(that._onDocumentResize, that);

	                that._marker = kendo.guid().substring(0, 8);

	                $(window).on("resize" + NS + that._marker, that._resizeHandler);

	                if (options.visible) {
	                    that.trigger(OPEN);
	                    that.trigger(ACTIVATE);
	                }

	                kendo.notify(that);

	                if(this.options.modal) {
	                    this._tabKeyTrap = new TabKeyTrap(wrapper);
	                    this._tabKeyTrap.trap();
	                    this._tabKeyTrap.shouldTrap = function () {
	                        return wrapper.data("isFront");
	                    };
	                }
	            },

	            _buttonEnter: function(e) {
	                $(e.currentTarget).addClass(KHOVERSTATE);
	            },

	            _buttonLeave: function(e) {
	                $(e.currentTarget).removeClass(KHOVERSTATE);
	            },

	            _focus: function() {
	                this.wrapper.addClass(KFOCUSEDSTATE);
	            },

	            _blur: function() {
	                this.wrapper.removeClass(KFOCUSEDSTATE);
	            },

	            _dimensions: function() {
	                var wrapper = this.wrapper;
	                var options = this.options;
	                var width = options.width;
	                var height = options.height;
	                var maxHeight = options.maxHeight;
	                var sizeClass = options.size;
	                var dimensions = ["minWidth","minHeight","maxWidth","maxHeight"];
	                var contentBoxSizing = wrapper.css("box-sizing") == "content-box";

	                var lrBorderWidth = contentBoxSizing ? toInt(wrapper, "border-left-width") + toInt(wrapper, "border-right-width") : 0;
	                var tbBorderWidth = contentBoxSizing ? toInt(wrapper, "border-top-width") + toInt(wrapper, "border-bottom-width") : 0;
	                var paddingTop = contentBoxSizing ? toInt(wrapper, "padding-top") : 0;

	                if (this.containment && !this._isPinned) {
	                    this._updateBoundaries();
	                    options.maxHeight = Math.min(this.containment.height - (tbBorderWidth + paddingTop), maxHeight);
	                    options.maxWidth = Math.min(this.containment.width - lrBorderWidth, options.maxWidth);
	                }

	                for (var i = 0; i < dimensions.length; i++) {
	                    var value = options[dimensions[i]] || "";
	                    if (value != Infinity) {
	                        wrapper.css(dimensions[i], value);
	                    }
	                }

	                if (maxHeight != Infinity) {
	                    this.element.css("maxHeight", maxHeight);
	                }

	                if (width) {
	                    wrapper.width(constrain(width, options.minWidth, options.maxWidth));
	                }
	                else {
	                    wrapper.width("");
	                }

	                if (height) {
	                    wrapper.height(constrain(height, options.minHeight, options.maxHeight));
	                }
	                else {
	                    wrapper.height("");
	                }

	                if (!options.visible) {
	                    wrapper.hide();
	                }

	                if (sizeClass && SIZE[sizeClass]) {
	                    wrapper.addClass(SIZE[sizeClass]);
	                }
	            },

	            _position: function() {
	                var wrapper = this.wrapper,
	                    position = this.options.position,
	                    containmentTop, containmentLeft;

	                this._updateBoundaries();

	                if (this.containment) {
	                    position.top = position.top || 0;
	                    position.left = position.left || 0;

	                    containmentTop = position.top.toString().indexOf("%") > 0 ?
	                        parseInt(this.containment.height * (parseFloat(position.top) / 100), 10) :
	                        position.top;

	                    containmentLeft = position.left.toString().indexOf("%") > 0 ?
	                        parseInt(this.containment.width * (parseFloat(position.left) / 100), 10) :
	                        position.left;

	                    position.top = constrain(containmentTop, this.minTop, this.maxTop);
	                    position.left = constrain(containmentLeft, this.minLeft, this.maxLeft);
	                }

	                if (position.top === 0) {
	                    position.top = position.top.toString();
	                }

	                if (position.left === 0) {
	                    position.left = position.left.toString();
	                }

	                wrapper.css({
	                    top: position.top || "",
	                    left: position.left || ""
	                });
	            },

	            _updateBoundaries: function() {
	                var containment = this.containment;

	                if (!containment) {
	                    return null;
	                }

	                containment.width = containment.innerWidth();
	                containment.height = containment.innerHeight();

	                if (parseInt(containment.width, 10) > containment[0].clientWidth) {
	                    containment.width -= kendo.support.scrollbar();
	                }

	                if (parseInt(containment.height, 10) > containment[0].clientHeight) {
	                    containment.height -= kendo.support.scrollbar();
	                }

	                containment.position = getPosition(containment[0]);

	                if (this._isPinned) {
	                    this.minTop = this.minLeft = -Infinity;
	                    this.maxTop = this.maxLeft = Infinity;
	                } else {
	                    this.minTop = containment.scrollTop();
	                    this.minLeft = containment.scrollLeft();
	                    this.maxLeft = this.minLeft + containment.width - outerWidth(this.wrapper, true);
	                    this.maxTop = this.minTop + containment.height - outerHeight(this.wrapper, true);
	                }
	            },

	            _animationOptions: function(id) {
	                var animation = this.options.animation;
	                var basicAnimation = {
	                    open: { effects: {} },
	                    close: { hide: true, effects: {} }
	                };

	                return animation && animation[id] || basicAnimation[id];
	            },

	            _resize: function() {
	                kendo.resize(this.element.children());
	            },

	            _resizable: function() {
	                var resizable = this.options.resizable;
	                var wrapper = this.wrapper;

	                if (this.resizing) {
	                    wrapper
	                        .off("dblclick" + NS)
	                        .children(KWINDOWRESIZEHANDLES).remove();

	                    this.resizing.destroy();
	                    this.resizing = null;
	                }

	                if (resizable) {
	                    wrapper.on("dblclick" + NS, KWINDOWTITLEBAR, proxy(function(e) {
	                        if (!$(e.target).closest(".k-window-action").length) {
	                            this.toggleMaximization();
	                        }
	                    }, this));

	                    each("n e s w se sw ne nw".split(" "), function(index, handler) {
	                        wrapper.append(templates.resizeHandle(handler));
	                    });

	                    this.resizing = new WindowResizing(this);
	                }

	                wrapper = null;
	            },

	            _draggable: function() {
	                var draggable = this.options.draggable;

	                if (this.dragging) {
	                    this.dragging.destroy();
	                    this.dragging = null;
	                }
	                if (draggable) {
	                    this.dragging = new WindowDragging(this, draggable.dragHandle || KWINDOWTITLEBAR);
	                }
	            },

	            _actions: function() {
	                var options = this.options;
	                var actions = options.actions;
	                var pinned = options.pinned;
	                var titlebar = this.wrapper.children(KWINDOWTITLEBAR);
	                var container = titlebar.find(".k-window-actions");
	                var windowSpecificCommands = [ "maximize", "minimize" ];

	                actions = $.map(actions, function(action) {
	                    action = pinned && action.toLowerCase() === "pin" ? "unpin" : action;
	                    return { name: (windowSpecificCommands.indexOf(action.toLowerCase()) > - 1) ? "window-" + action : action };
	                });

	                container.html(kendo.render(templates.action, actions));
	            },

	            setOptions: function(options) {
	                var that = this;
	                var sizeClass = that.options.size;
	                // make a deep extend over options.position telerik/kendo-ui-core#844
	                var cachedOptions = JSON.parse(JSON.stringify(options));
	                extend(options.position, that.options.position);
	                extend(options.position, cachedOptions.position);

	                Widget.fn.setOptions.call(that, options);
	                var scrollable = that.options.scrollable !== false;

	                that.restore();

	                if (typeof options.title !== "undefined") {
	                    that.title(options.title);
	                }

	                that.wrapper.removeClass(SIZE[sizeClass]);
	                that._dimensions();

	                that._position();
	                that._resizable();
	                that._draggable();
	                that._actions();
	                if (typeof options.modal !== "undefined") {
	                    var visible = that.options.visible !== false;
	                    that._enableDocumentScrolling();
	                    that._overlay(options.modal && visible);
	                }

	                that.element.css(OVERFLOW, scrollable ? "" : "hidden");
	            },

	            events:[
	                OPEN,
	                ACTIVATE,
	                DEACTIVATE,
	                CLOSE,
	                MINIMIZE,
	                MAXIMIZE,
	                REFRESH,
	                RESIZESTART,
	                RESIZE,
	                RESIZEEND,
	                DRAGSTART,
	                DRAGEND,
	                KENDOKEYDOWN,
	                ERROR
	            ],

	            options: {
	                name: "Window",
	                animation: {
	                    open: {
	                        effects: { zoom: { direction: "in" }, fade: { direction: "in" } },
	                        duration: 350
	                    },
	                    close: {
	                        effects: { zoom: { direction: "out", properties: { scale: 0.7 } }, fade: { direction: "out" } },
	                        duration: 350,
	                        hide: true
	                    }
	                },
	                title: "",
	                actions: ["Close"],
	                autoFocus: true,
	                modal: false,
	                size: "auto",
	                resizable: true,
	                draggable: true,
	                minWidth: 90,
	                minHeight: 50,
	                maxWidth: Infinity,
	                maxHeight: Infinity,
	                pinned: false,
	                scrollable: true,
	                position: {},
	                content: null,
	                visible: null,
	                height: null,
	                width: null,
	                appendTo: "body",
	                isMaximized: false,
	                isMinimized: false
	            },

	            _closable: function() {
	                return $.inArray("close", $.map(this.options.actions, function(x) { return x.toLowerCase(); })) > -1;
	            },

	            _keydownContent: function(e) {
	                var that = this,
	                    keys = kendo.keys,
	                    keyCode = e.keyCode;

	                if (keyCode == keys.ESC && that._closable()) {
	                    e.stopPropagation();
	                    that._close(false);
	                }
	            },

	            _keydown: function(e) {
	                var that = this,
	                    options = that.options,
	                    keys = kendo.keys,
	                    keyCode = e.keyCode,
	                    wrapper = that.wrapper,
	                    offset, handled,
	                    distance = 10,
	                    isMaximized = options.isMaximized,
	                    isMinimized = options.isMinimized,
	                    newWidth, newHeight, w, h;

	                if (keyCode == keys.ESC && that._closable()) {
	                    e.stopPropagation();
	                    that._close(false);
	                }

	                if (e.target != e.currentTarget || that._closing) {
	                    return;
	                }

	                 // Refresh
	                if (e.altKey && keyCode == 82) {// Alt + R
	                    that.refresh();
	                }

	                // Pin/Unpin
	                if (e.altKey && keyCode == 80) {// Alt + P
	                    if(that.options.pinned){
	                        that.unpin();
	                    } else {
	                        that.pin();
	                    }
	                }

	                // Maximize/Restore/Miminimize
	                if(e.altKey && keyCode == keys.UP){
	                    if (isMinimized) {
	                        that.restore();
	                        that.wrapper.focus();
	                    } else if (!isMaximized) {
	                        that.maximize();
	                        that.wrapper.focus();
	                    }

	                } else if (e.altKey && keyCode == keys.DOWN){
	                    if (!isMinimized && !isMaximized) {
	                        that.minimize();
	                        that.wrapper.focus();
	                    } else if (isMaximized) {
	                        that.restore();
	                    }

	                }

	                offset = kendo.getOffset(wrapper);

	                if (that.containment && !that._isPinned) {
	                    offset = that.options.position;
	                }

	                if (options.draggable && !e.ctrlKey && !e.altKey && !isMaximized) {
	                    that._updateBoundaries();
	                    if (keyCode == keys.UP) {
	                        offset.top = constrain(offset.top - distance, that.minTop, that.maxTop);
	                        handled = wrapper.css("top", offset.top);
	                    } else if (keyCode == keys.DOWN) {
	                        offset.top = constrain(offset.top + distance, that.minTop, that.maxTop);
	                        handled = wrapper.css("top", offset.top);
	                    } else if (keyCode == keys.LEFT) {
	                        offset.left = constrain(offset.left - distance, that.minLeft, that.maxLeft);
	                        handled = wrapper.css("left", offset.left);
	                    } else if (keyCode == keys.RIGHT) {
	                        offset.left = constrain(offset.left + distance, that.minLeft, that.maxLeft);
	                        handled = wrapper.css("left", offset.left);
	                    }
	                }

	                if (options.resizable && e.ctrlKey && !isMaximized && !isMinimized) {
	                    if (keyCode == keys.UP) {
	                        handled = true;
	                        newHeight = wrapper.height() - distance;
	                    } else if (keyCode == keys.DOWN) {
	                        handled = true;
	                        if (that.containment && !that._isPinned) {
	                            newHeight = Math.min(wrapper.height() + distance,
	                                that.containment.height - offset.top - toInt(wrapper, "padding-top") -
	                                toInt(wrapper, "borderBottomWidth") - toInt(wrapper, "borderTopWidth"));
	                        } else {
	                            newHeight = wrapper.height() + distance;
	                        }
	                    } if (keyCode == keys.LEFT) {
	                        handled = true;
	                        newWidth = wrapper.width() - distance;
	                    } else if (keyCode == keys.RIGHT) {
	                        handled = true;
	                        if (that.containment && !that._isPinned) {
	                            newWidth = Math.min(wrapper.width() + distance,
	                                                that.containment.width - offset.left -
	                                                toInt(wrapper, "borderLeftWidth") - toInt(wrapper, "borderRightWidth"));
	                        } else {
	                            newWidth = wrapper.width() + distance;
	                        }
	                    }

	                    if (handled) {
	                        w = constrain(newWidth, options.minWidth, options.maxWidth);
	                        h = constrain(newHeight, options.minHeight, options.maxHeight);

	                        if (!isNaN(w)) {
	                            wrapper.width(w);
	                            that.options.width = w + "px";
	                        }
	                        if (!isNaN(h)) {
	                            wrapper.height(h);
	                            that.options.height = h + "px";
	                        }

	                        that.resize();
	                    }
	                }

	                if (handled) {
	                    e.preventDefault();
	                }
	            },

	            _overlay: function (visible) {
	                var overlay = this.containment ? this.containment.children(KOVERLAY) : this.appendTo.children(KOVERLAY),
	                    wrapper = this.wrapper;

	                if (!overlay.length) {
	                    overlay = $("<div class='k-overlay' />");
	                }

	                overlay
	                    .insertBefore(wrapper[0])
	                    .toggle(visible)
	                    .css(ZINDEX, parseInt(wrapper.css(ZINDEX), 10) - 1);

	                if (this.options.modal.preventScroll && !this.containment) {
	                    this._stopDocumentScrolling();
	                }

	                return overlay;
	            },

	            _actionForIcon: function(icon) {
	                var iconClass = /\bk-i(-\w+)+\b/.exec(icon[0].className)[0];
	                return {
	                    "k-i-close": "_close",
	                    "k-i-window-maximize": "maximize",
	                    "k-i-window-minimize": "minimize",
	                    "k-i-window-restore": "restore",
	                    "k-i-refresh": "refresh",
	                    "k-i-pin": "pin",
	                    "k-i-unpin": "unpin"
	                }[iconClass];
	            },

	            _windowActionHandler: function (e) {
	                if (this._closing) {
	                    return;
	                }
	                var icon = $(e.target).closest(".k-window-action").find(".k-icon");
	                var action = this._actionForIcon(icon);

	                if (action) {
	                    e.preventDefault();
	                    this[action]();
	                    return false;
	                }
	            },

	            _modals: function() {
	                var that = this;

	                var zStack = $(KWINDOW).filter(function() {
	                    var dom = $(this);
	                    var object = that._object(dom);
	                    var options = object && object.options;

	                    return options && options.modal && options.visible && options.appendTo === that.options.appendTo && dom.is(VISIBLE);
	                }).sort(function(a, b){
	                    return +$(a).css("zIndex") - +$(b).css("zIndex");
	                });

	                that = null;

	                return zStack;
	            },

	            _object: function(element) {
	                var content = element.children(KWINDOWCONTENT);
	                var widget = kendo.widgetInstance(content);

	                if (widget) {
	                    return widget;
	                }

	                return undefined;
	            },

	            center: function () {
	                var that = this,
	                    position = that.options.position,
	                    wrapper = that.wrapper,
	                    documentWindow = $(window),
	                    scrollTop = 0,
	                    scrollLeft = 0,
	                    newTop, newLeft;

	                if (that.options.isMaximized) {
	                    return that;
	                }

	                if(that.options.pinned && !that._isPinned) {
	                    that.pin();
	                }

	                if (!that.options.pinned) {
	                    scrollTop = documentWindow.scrollTop();
	                    scrollLeft = documentWindow.scrollLeft();
	                }

	                if (this.containment && !that.options.pinned) {
	                    newTop = this.minTop + (this.maxTop - this.minTop) / 2;
	                    newLeft = this.minLeft + (this.maxLeft - this.minLeft) / 2;
	                } else {
	                    that._scrollIsAppended = true;
	                    newLeft = scrollLeft + Math.max(0, (documentWindow.width() - wrapper.width()) / 2);
	                    newTop = scrollTop + Math.max(0, (documentWindow.height() - wrapper.height() - toInt(wrapper, "paddingTop")) / 2);
	                }

	                wrapper.css({
	                    left: newLeft,
	                    top: newTop
	                });

	                position.top = newTop;
	                position.left = newLeft;

	                return that;
	            },

	            title: function (title) {
	                var that = this,
	                    value,
	                    encoded = true,
	                    wrapper = that.wrapper,
	                    titleBar = wrapper.children(KWINDOWTITLEBAR),
	                    titleElement = titleBar.children(KWINDOWTITLE),
	                    titleBarHeight,
	                    display, visibility;

	                if (!arguments.length) {
	                    return titleElement.html();
	                }

	                if ($.isPlainObject(title)) {
	                    value = typeof title.text !== "undefined" ? title.text :  "";
	                    encoded = title.encoded !== false;
	                } else {
	                    value = title;
	                }

	                if (value === false) {
	                    wrapper.addClass("k-window-titleless");
	                    wrapper.css("padding-top", 0);
	                    titleBar.remove();
	                } else {
	                    if (!titleBar.length) {
	                        wrapper.prepend(templates.titlebar({
	                            title: encoded ? kendo.htmlEncode(value) : value
	                        }));
	                        that._actions();
	                        titleBar = wrapper.children(KWINDOWTITLEBAR);
	                    } else {
	                        titleElement.html(encoded ? kendo.htmlEncode(value) : value);
	                    }

	                    visibility = wrapper.css("visibility");
	                    display = wrapper.css("display");

	                    if (visibility === HIDDEN) {
	                        wrapper.css({ display: "" });
	                        titleBarHeight = parseInt(outerHeight(titleBar), 10);
	                        wrapper.css({ display: display });
	                    } else {
	                        wrapper.css({ visibility: HIDDEN, display: "" });
	                        titleBarHeight = parseInt(outerHeight(titleBar), 10);
	                        wrapper.css({ visibility: visibility, display: display });
	                    }

	                    wrapper.css("padding-top", titleBarHeight);
	                    titleBar.css("margin-top", -titleBarHeight);
	                }

	                that.options.title = value;

	                return that;
	            },

	            content: function (html, data) {
	                var content = this.wrapper.children(KWINDOWCONTENT),
	                    scrollContainer = content.children(".km-scroll-container");

	                content = scrollContainer[0] ? scrollContainer : content;

	                if (!defined(html)) {
	                    return content.html();
	                }

	                this.angular("cleanup", function(){
	                    return { elements: content.children() };
	                });

	                kendo.destroy(this.element.children());

	                content.empty().html(html);

	                this.angular("compile", function(){
	                    var a = [];
	                    for (var i = content.length; --i >= 0;) {
	                        a.push({ dataItem: data });
	                    }
	                    return {
	                        elements: content.children(),
	                        data: a
	                    };
	                });

	                return this;
	            },

	            open: function () {
	                var that = this,
	                    wrapper = that.wrapper,
	                    options = that.options,
	                    showOptions = this._animationOptions("open"),
	                    contentElement = wrapper.children(KWINDOWCONTENT),
	                    overlay, otherModalsVisible,
	                    containmentContext = this.containment && !that._isPinned,
	                    doc = containmentContext ? this.containment : $(document);

	                if (!that.trigger(OPEN)) {
	                    if (that._closing) {
	                        wrapper.kendoStop(true, true);
	                    }

	                    that._closing = false;

	                    that.toFront();

	                    if (options.autoFocus) {
	                        that.wrapper.focus();
	                    }

	                    options.visible = true;

	                    if (options.modal) {
	                        otherModalsVisible = !!that._modals().length;
	                        overlay = that._overlay(otherModalsVisible);

	                        overlay.kendoStop(true, true);

	                        if (showOptions.duration && kendo.effects.Fade && !otherModalsVisible) {
	                            var overlayFx = kendo.fx(overlay).fadeIn();
	                            overlayFx.duration(showOptions.duration || 0);
	                            overlayFx.endValue(0.5);
	                            overlayFx.play();
	                        } else {
	                            overlay.css("opacity", 0.5);
	                        }

	                        overlay.show();

	                        $(window).on("focus" + MODAL_NS, function() {
	                            if (wrapper.data("isFront") && !$(document.activeElement).closest(wrapper).length) {
	                               that.wrapper.focus();
	                            }
	                        });
	                    }

	                    if (!wrapper.is(VISIBLE)) {
	                        contentElement.css(OVERFLOW, HIDDEN);

	                        that.wrapper.find(TITLEBAR_BUTTONS).addClass("k-flat");

	                        wrapper.show().kendoStop().kendoAnimate({
	                            effects: showOptions.effects,
	                            duration: showOptions.duration,
	                            complete: proxy(this._activate, this)
	                        });
	                    }
	                }

	                if (options.isMaximized) {
	                    that._containerScrollTop = doc.scrollTop();
	                    that._containerScrollLeft = doc.scrollLeft();
	                    that._stopDocumentScrolling();
	                }

	                if(this.options.pinned && !this._isPinned){
	                    this.pin();
	                }

	                return that;
	            },

	            _activate: function() {
	                var scrollable = this.options.scrollable !== false;

	                if (this.options.autoFocus) {
	                    this.wrapper.focus();
	                }

	                this.element.css(OVERFLOW, scrollable ? "" : "hidden");
	                kendo.resize(this.element.children());

	                this.trigger(ACTIVATE);
	            },

	            _removeOverlay: function(suppressAnimation) {
	                var modals = this._modals();
	                var options = this.options;
	                var hideOverlay = options.modal && !modals.length;
	                var overlay = options.modal ? this._overlay(true) : $(undefined);
	                var hideOptions  = this._animationOptions("close");

	                if (hideOverlay) {
	                    if (!suppressAnimation && hideOptions.duration && kendo.effects.Fade) {
	                        var overlayFx = kendo.fx(overlay).fadeOut();
	                        overlayFx.duration(hideOptions.duration || 0);
	                        overlayFx.startValue(0.5);
	                        overlayFx.play();
	                    } else {
	                        this._overlay(false).remove();
	                    }
	                    if (options.modal.preventScroll) {
	                        this._enableDocumentScrolling();
	                    }
	                } else if (modals.length) {
	                    this._object(modals.last())._overlay(true);

	                    if (options.modal.preventScroll) {
	                        this._stopDocumentScrolling();
	                    }
	                }
	            },

	            _close: function(systemTriggered) {
	                var that = this,
	                    wrapper = that.wrapper,
	                    options = that.options,
	                    showOptions = this._animationOptions("open"),
	                    hideOptions  = this._animationOptions("close"),
	                    containmentContext = this.containment && !that._isPinned,
	                    doc = containmentContext ? this.containment : $(document),
	                    defaultPrevented;

	                if (that._closing) {
	                    return;
	                }

	                defaultPrevented = that.trigger(CLOSE, { userTriggered: !systemTriggered });
	                that._closing = !defaultPrevented;

	                if (wrapper.is(VISIBLE) && !defaultPrevented) {
	                    options.visible = false;

	                    $(KWINDOW).each(function(i, element) {
	                        var contentElement = $(element).children(KWINDOWCONTENT);

	                        // Remove overlay set by toFront
	                        if (element != wrapper && contentElement.find("> ." + KCONTENTFRAME).length > 0) {
	                            contentElement.children(KOVERLAY).remove();
	                        }
	                    });

	                    this._removeOverlay();

	                    // Prevent close animation from stopping
	                    that.wrapper.find(TITLEBAR_BUTTONS).removeClass("k-flat");

	                    wrapper.kendoStop().kendoAnimate({
	                        effects: hideOptions.effects || showOptions.effects,
	                        reverse: hideOptions.reverse === true,
	                        duration: hideOptions.duration,
	                        complete: proxy(this._deactivate, this)
	                    });
	                    $(window).off(MODAL_NS);
	                }

	                if (that.options.isMaximized) {
	                    that._enableDocumentScrolling();
	                    if (that._containerScrollTop && that._containerScrollTop > 0) {
	                        doc.scrollTop(that._containerScrollTop);
	                    }
	                    if (that._containerScrollLeft && that._containerScrollLeft > 0) {
	                        doc.scrollLeft(that._containerScrollLeft);
	                    }
	                }

	                if (that.options.iframe) {
	                    that.wrapper.blur();
	                }
	            },

	            _deactivate: function () {
	                var that = this;
	                that.wrapper.hide().css("opacity", "");
	                that.trigger(DEACTIVATE);
	                if (that.options.modal) {
	                    var lastModal = that._object(that._modals().last());
	                    if (lastModal) {
	                        lastModal.toFront();
	                    }
	                }
	            },

	            close: function () {
	                this._close(true);
	                return this;
	            },

	            _actionable: function(element) {
	                return $(element).is(TITLEBAR_BUTTONS + "," + TITLEBAR_BUTTONS + " .k-icon,:input,a");
	            },

	            _shouldFocus: function(target) {
	                var active = activeElement(),
	                    element = this.wrapper;

	                return this.options.autoFocus &&
	                    !$(active).is(element) &&
	                    !this._actionable(target) &&
	                    (!element.find(active).length || !element.find(target).length);
	            },

	            toFront: function (e) {
	                var that = this,
	                    wrapper = that.wrapper,
	                    currentWindow = wrapper[0],
	                    containmentContext = that.containment && !that._isPinned,
	                    zIndex = +wrapper.css(ZINDEX),
	                    originalZIndex = zIndex,
	                    target = (e && e.target) || null;

	                $(KWINDOW).each(function(i, element) {
	                    var windowObject = $(element),
	                        zIndexNew = windowObject.css(ZINDEX),
	                        contentElement = windowObject.children(KWINDOWCONTENT);

	                    if (!isNaN(zIndexNew)) {
	                        zIndex = Math.max(+zIndexNew, zIndex);
	                    }

	                    wrapper.data("isFront", element == currentWindow);
	                    // Add overlay to windows with iframes and lower z-index to prevent
	                    // trapping of events when resizing / dragging
	                    if (element != currentWindow && contentElement.find("> ." + KCONTENTFRAME).length > 0) {
	                        contentElement.append(templates.overlay);
	                    }
	                });

	                if (!wrapper[0].style.zIndex || originalZIndex < zIndex) {
	                    wrapper.css(ZINDEX, zIndex + 2);
	                }
	                that.element.find("> .k-overlay").remove();

	                if (that._shouldFocus(target)) {
	                    setTimeout(function(){
	                        that.wrapper.focus();
	                    });

	                    var scrollTop = containmentContext ? that.containment.scrollTop() : $(window).scrollTop(),
	                        windowTop = parseInt(wrapper.position().top, 10);

	                    if (!that.options.pinned && windowTop > 0 && windowTop < scrollTop) {
	                        if (scrollTop > 0) {
	                            $(window).scrollTop(windowTop);
	                        } else {
	                            wrapper.css("top", scrollTop);
	                        }
	                    }
	                }

	                wrapper = null;

	                return that;
	            },

	            toggleMaximization: function () {
	                if (this._closing) {
	                    return this;
	                }

	                return this[this.options.isMaximized ? "restore" : "maximize"]();
	            },

	            restore: function () {
	                var that = this;
	                var options = that.options;
	                var minHeight = options.minHeight;
	                var restoreOptions = that.restoreOptions;
	                var shouldRestrictTop;
	                var container = that.containment && !that._isPinned ? that.containment : $(document);

	                if (!options.isMaximized && !options.isMinimized) {
	                    return that;
	                }

	                if (minHeight && minHeight != Infinity) {
	                    that.wrapper.css("min-height", minHeight);
	                }

	                if (restoreOptions && !options.isMaximized) {
	                    restoreOptions.height = constrain(restoreOptions.height, that.options.minHeight, that.options.maxHeight);

	                    shouldRestrictTop = options.position.top + parseInt(restoreOptions.height, 10) > that.maxTop;

	                    if (shouldRestrictTop) {
	                        options.position.top = constrain(options.position.top, that.minTop, that.maxTop - parseInt(restoreOptions.height, 10));

	                        extend(restoreOptions, {
	                            left: options.position.left,
	                            top: options.position.top
	                        });
	                    }
	                }

	                that.wrapper
	                    .css({
	                        position: options.pinned ? "fixed" : "absolute",
	                        left: restoreOptions.left,
	                        top: restoreOptions.top,
	                        width: restoreOptions.width,
	                        height: restoreOptions.height
	                    })
	                    .removeClass(MAXIMIZEDSTATE)
	                    .find(".k-window-content,.k-resize-handle").show().end()
	                    .find(".k-window-titlebar .k-i-window-restore").parent().remove().end().end()
	                    .find(MINIMIZE_MAXIMIZE).parent().show().end().end()
	                    .find(PIN_UNPIN).parent().show();

	                if (options.isMaximized) {
	                    that.wrapper.find(".k-i-window-maximize").parent().focus();
	                } else if (options.isMinimized) {
	                    that.wrapper.find(".k-i-window-minimize").parent().focus();
	                }

	                that.options.width = restoreOptions.width;
	                that.options.height = restoreOptions.height;

	                if (!that.options.modal.preventScroll) {
	                    that._enableDocumentScrolling();
	                }

	                if (that._containerScrollTop && that._containerScrollTop > 0) {
	                    container.scrollTop(that._containerScrollTop);
	                }
	                if (that._containerScrollLeft && that._containerScrollLeft > 0) {
	                    container.scrollLeft(that._containerScrollLeft);
	                }

	                options.isMaximized = options.isMinimized = false;

	                that.wrapper.removeAttr("aria-labelled-by");

	                that.resize();

	                return that;
	            },

	            _sizingAction: function(actionId, callback) {
	                var that = this,
	                    wrapper = that.wrapper,
	                    style = wrapper[0].style,
	                    options = that.options;

	                if (options.isMaximized || options.isMinimized) {
	                    return that;
	                }

	                that.restoreOptions = {
	                    width: style.width,
	                    height: style.height
	                };

	                wrapper
	                    .children(KWINDOWRESIZEHANDLES).hide().end()
	                    .children(KWINDOWTITLEBAR).find(MINIMIZE_MAXIMIZE).parent().hide()
	                    .eq(0).before(templates.action({ name: "window-restore" }));

	                callback.call(that);

	                that.wrapper.children(KWINDOWTITLEBAR).find(PIN_UNPIN).parent().toggle(actionId !== "maximize");

	                that.trigger(actionId);

	                wrapper.find(".k-i-window-restore").parent().focus();

	                return that;
	            },

	            maximize: function() {
	                this._sizingAction("maximize", function() {
	                    var that = this,
	                        wrapper = that.wrapper,
	                        containmentContext = this.containment && !that._isPinned,
	                        position = wrapper.position(),
	                        doc = $(document);

	                    extend(that.restoreOptions, {
	                        left: position.left + (containmentContext ? this.containment.scrollLeft() : 0),
	                        top: position.top + (containmentContext ? this.containment.scrollTop() : 0)
	                    });

	                    this._containerScrollTop = containmentContext ? this.containment.scrollTop() : doc.scrollTop();
	                    this._containerScrollLeft = containmentContext ? this.containment.scrollLeft() : doc.scrollLeft();

	                    that._stopDocumentScrolling();

	                    wrapper
	                        .css({
	                            top: containmentContext ? this.containment.scrollTop() : 0,
	                            left: containmentContext ? this.containment.scrollLeft() : 0,
	                            position: containmentContext ? "absolute" : "fixed"
	                        })
	                        .addClass(MAXIMIZEDSTATE);

	                    that.options.isMaximized = true;

	                    that._onDocumentResize();
	                });

	                return this;
	            },

	            _stopDocumentScrolling: function(){
	                var that = this;
	                var containment = that.containment;

	                if (containment && !that._isPinned) {
	                    that._storeOverflowRule(containment);
	                    containment.css(OVERFLOW, HIDDEN);
	                    that.wrapper.css({
	                        maxWidth: containment.innerWidth(),
	                        maxHeight: containment.innerHeight()
	                    });
	                    return;
	                }

	                var $body = $("body");
	                that._storeOverflowRule($body);
	                $body.css(OVERFLOW, HIDDEN);

	                var $html = $("html");
	                that._storeOverflowRule($html);
	                $html.css(OVERFLOW, HIDDEN);
	            },

	            _enableDocumentScrolling: function(){
	                var that = this;
	                var containment = that.containment;

	                if (containment && !that._isPinned) {
	                    that._restoreOverflowRule(containment);
	                    that.wrapper.css({
	                        maxWidth: containment.width,
	                        maxHeight: containment.height
	                    });
	                    return;
	                }

	                that._restoreOverflowRule($(document.body));
	                that._restoreOverflowRule($("html"));
	            },

	            _storeOverflowRule: function($element){
	                if(this._isOverflowStored($element)){
	                    return;
	                }

	                var overflowRule = $element.get(0).style.overflow;

	                if(typeof overflowRule === "string"){
	                    $element.data(DATADOCOVERFLOWRULE, overflowRule);
	                }
	            },

	            _isOverflowStored: function ($element){
	                return typeof $element.data(DATADOCOVERFLOWRULE) === "string";
	            },

	            _restoreOverflowRule: function($element){
	                var overflowRule = $element.data(DATADOCOVERFLOWRULE);

	                if(overflowRule !== null && overflowRule !== undefined){
	                    $element.css(OVERFLOW, overflowRule);
	                    $element.removeData(DATADOCOVERFLOWRULE);
	                } else {
	                    $element.css(OVERFLOW, "");
	                }
	            },

	            isMaximized: function() {
	                return this.options.isMaximized;
	            },

	            minimize: function() {
	                this._sizingAction("minimize", function() {
	                    var that = this;

	                    that.wrapper.css({
	                        height: "",
	                        minHeight: ""
	                    });

	                    that.element.hide();

	                    that.options.isMinimized = true;
	                });

	                this.wrapper.attr("aria-labelled-by", this.element.attr("aria-labelled-by"));

	                this._updateBoundaries();

	                return this;
	            },

	            isMinimized: function() {
	                return this.options.isMinimized;
	            },

	            pin: function() {
	                var that = this,
	                    win = $(window),
	                    wrapper = that.wrapper,
	                    options = that.options,
	                    position = options.position,
	                    top = this.containment ? getPosition(wrapper[0]).top + toInt(this.containment, "borderTopWidth") : toInt(wrapper, "top"),
	                    left = this.containment ? getPosition(wrapper[0]).left + toInt(this.containment, "borderLeftWidth") : toInt(wrapper, "left");

	                if (!that.options.isMaximized) {
	                    position.top = top;
	                    position.left = left;

	                    if (that._scrollIsAppended && (!this.containment || this.containment.css("position") !== "fixed")) {
	                        position.top -= win.scrollTop();
	                        position.left -= win.scrollLeft();
	                        that._scrollIsAppended = false;
	                    }

	                    wrapper.css(extend(position, {position: "fixed"}));
	                    wrapper.children(KWINDOWTITLEBAR).find(KPIN).addClass("k-i-unpin").removeClass("k-i-pin");

	                    that._isPinned = true;
	                    that.options.pinned = true;

	                    if (this.containment) {
	                        options.maxWidth = options.maxHeight = Infinity;
	                        wrapper.css({
	                            maxWidth: "",
	                            maxHeight: ""
	                        });
	                    }
	                }
	            },

	            unpin: function() {
	                var that = this,
	                    win = $(window),
	                    wrapper = that.wrapper,
	                    options = that.options,
	                    position = that.options.position,
	                    containment = that.containment,
	                    top = parseInt(wrapper.css("top"), 10) + win.scrollTop(),
	                    left = parseInt(wrapper.css("left"), 10) + win.scrollLeft();

	                if (!that.options.isMaximized) {
	                    that._isPinned = false;
	                    that._scrollIsAppended = true;
	                    that.options.pinned = false;

	                    if (containment) {
	                        that._updateBoundaries();

	                        options.maxWidth = Math.min(containment.width, options.maxWidth);
	                        options.maxHeight = Math.min(containment.height - toInt(wrapper, "padding-top"), options.maxHeight);

	                        wrapper.css({
	                            maxWidth: options.maxWidth,
	                            maxHeight: options.maxHeight
	                        });

	                        if (top < containment.position.top) {
	                            top = that.minTop;
	                        } else if (top > containment.position.top + containment.height) {
	                            top = that.maxTop;
	                        } else {
	                            top = top + containment.scrollTop() - (containment.position.top + toInt(containment, "border-top-width"));
	                        }

	                        if (left < containment.position.left) {
	                            left = that.minLeft;
	                        } else if (left > containment.position.left + containment.width) {
	                            left = that.maxLeft;
	                        } else {
	                            left = left + containment.scrollLeft() - (containment.position.left + toInt(containment, "border-left-width"));
	                        }

	                    }

	                    position.top = constrain(top, that.minTop, that.maxTop);
	                    position.left = constrain(left, that.minLeft, that.maxLeft);

	                    wrapper.css(extend(position, {position: ""}));
	                    wrapper.children(KWINDOWTITLEBAR).find(KUNPIN).addClass("k-i-pin").removeClass("k-i-unpin");
	                }
	            },

	            _onDocumentResize: function () {
	                var that = this,
	                    wrapper = that.wrapper,
	                    wnd = $(window),
	                    zoomLevel = kendo.support.zoomLevel(),
	                    contentBoxSizing = wrapper.css("box-sizing") == "content-box",
	                    w, h;

	                if (!that.options.isMaximized) {
	                    return;
	                }

	                var lrBorderWidth = contentBoxSizing ? toInt(wrapper, "border-left-width") + toInt(wrapper, "border-right-width") : 0;
	                var tbBorderWidth = contentBoxSizing ? toInt(wrapper, "border-top-width") + toInt(wrapper, "border-bottom-width") : 0;
	                var paddingTop = contentBoxSizing ? toInt(wrapper, "padding-top") : 0;

	                if (that.containment && !that._isPinned) {
	                    w = that.containment.innerWidth() - lrBorderWidth;
	                    h = that.containment.innerHeight() - (tbBorderWidth + paddingTop);
	                } else {
	                    w = wnd.width() / zoomLevel - lrBorderWidth;
	                    h = wnd.height() / zoomLevel - (tbBorderWidth + paddingTop);
	                }

	                wrapper.css({
	                    width: w,
	                    height: h
	                });
	                that.options.width = w;
	                that.options.height = h;

	                that.resize();
	            },

	            refresh: function (options) {
	                var that = this,
	                    initOptions = that.options,
	                    element = $(that.element),
	                    iframe,
	                    showIframe,
	                    url;

	                if (!isPlainObject(options)) {
	                    options = { url: options };
	                }

	                options = extend({}, initOptions.content, options);

	                showIframe = defined(initOptions.iframe) ? initOptions.iframe : options.iframe;

	                url = options.url;

	                if (url) {
	                    if (!defined(showIframe)) {
	                        showIframe = !isLocalUrl(url);
	                    }

	                    if (!showIframe) {
	                        // perform AJAX request
	                        that._ajaxRequest(options);
	                    } else {
	                        iframe = element.find("." + KCONTENTFRAME)[0];

	                        if (iframe) {
	                            // refresh existing iframe
	                            iframe.src = url || iframe.src;
	                        } else {
	                            // render new iframe
	                            element.html(templates.contentFrame(extend({}, initOptions, { content: options })));
	                        }

	                        element.find("." + KCONTENTFRAME)
	                            .unbind("load" + NS)
	                            .on("load" + NS, proxy(this._triggerRefresh, this));
	                    }
	                } else {
	                    if (options.template) {
	                        // refresh template
	                        that.content(template(options.template)({}));
	                    }

	                    that.trigger(REFRESH);
	                }

	                element.toggleClass("k-window-iframecontent", !!showIframe);

	                return that;
	            },

	            _triggerRefresh: function() {
	                this.trigger(REFRESH);
	            },

	            _ajaxComplete: function() {
	                clearTimeout(this._loadingIconTimeout);
	                this.wrapper.find(REFRESHICON).removeClass(LOADING);
	            },

	            _ajaxError: function (xhr, status) {
	                this.trigger(ERROR, { status: status, xhr: xhr });
	            },

	            _ajaxSuccess: function (contentTemplate) {
	                return function (data) {
	                    var html = data;
	                    if (contentTemplate) {
	                        html = template(contentTemplate)(data || {});
	                    }

	                    this.content(html, data);
	                    this.element.prop("scrollTop", 0);

	                    this.trigger(REFRESH);
	                };
	            },

	            _showLoading: function() {
	                this.wrapper.find(REFRESHICON).addClass(LOADING);
	            },

	            _ajaxRequest: function (options) {
	                this._loadingIconTimeout = setTimeout(proxy(this._showLoading, this), 100);

	                $.ajax(extend({
	                    type: "GET",
	                    dataType: "html",
	                    cache: false,
	                    error: proxy(this._ajaxError, this),
	                    complete: proxy(this._ajaxComplete, this),
	                    success: proxy(this._ajaxSuccess(options.template), this)
	                }, options));
	            },

	            _destroy: function() {
	                if (this.resizing) {
	                    this.resizing.destroy();
	                }

	                if (this.dragging) {
	                    this.dragging.destroy();
	                }

	                this.wrapper.off(NS)
	                    .children(KWINDOWCONTENT).off(NS).end()
	                    .find(".k-resize-handle,.k-window-titlebar").off(NS);

	                $(window).off("resize" + NS + this._marker);
	                $(window).off(MODAL_NS);
	                $(window).off(NS);

	                clearTimeout(this._loadingIconTimeout);

	                Widget.fn.destroy.call(this);

	                this.unbind(undefined);

	                kendo.destroy(this.wrapper);

	                this._removeOverlay(true);
	            },

	            destroy: function() {
	                this._destroy();

	                this.wrapper.empty().remove();

	                this.wrapper = this.appendTo = this.element = $();
	            },

	            _createWindow: function() {
	                var contentHtml = this.element,
	                    options = this.options,
	                    iframeSrcAttributes,
	                    wrapper,
	                    isRtl = kendo.support.isRtl(contentHtml);

	                if (options.scrollable === false) {
	                    contentHtml.css("overflow", "hidden");
	                }

	                wrapper = $(templates.wrapper(options));

	                // Collect the src attributes of all iframes and then set them to empty string.
	                // This seems to fix this IE9 "feature": http://msdn.microsoft.com/en-us/library/gg622929%28v=VS.85%29.aspx?ppud=4
	                iframeSrcAttributes = contentHtml.find("iframe:not(.k-content-frame)").map(function() {
	                    var src = this.getAttribute("src");
	                    this.src = "";
	                    return src;
	                });

	                // Make sure the wrapper is appended to the body only once. IE9+ will throw exceptions if you move iframes in DOM
	                wrapper
	                    .toggleClass("k-rtl", isRtl)
	                    .attr("tabindex", 0)
	                    .append(contentHtml)
	                    .find("iframe:not(.k-content-frame)").each(function(index) {
	                    // Restore the src attribute of the iframes when they are part of the live DOM tree
	                    this.src = iframeSrcAttributes[index];
	                });

	                if (this.containment) {
	                    this.containment.prepend(wrapper);
	                } else if (this.appendTo) {
	                    wrapper.appendTo(this.appendTo);
	                }

	                wrapper.find(".k-window-title")
	                    .css(isRtl ? "left" : "right", outerWidth(wrapper.find(".k-window-actions")) + 10);

	                contentHtml.css("visibility", "").show();

	                contentHtml.find("[data-role=editor]").each(function() {
	                    var editor = $(this).data("kendoEditor");

	                    if (editor) {
	                        editor.refresh();
	                    }
	                });

	                wrapper = contentHtml = null;
	            }
	        });

	        templates = {
	            wrapper: template("<div class='k-widget k-window'></div>"),
	            action: template(
	                "<a role='button' href='\\#' class='k-button k-flat k-button-icon k-window-action' aria-label='#= name #'>" +
	                "<span class='k-icon k-i-#= name.toLowerCase() #'></span>" +
	                "</a>"
	            ),
	            titlebar: template(
	                "<div class='k-window-titlebar'>" +
	                "<span class='k-window-title'>#= title #</span>" +
	                "<div class='k-window-actions'></div>" +
	                "</div>"
	            ),
	            overlay: "<div class='k-overlay'></div>",
	            contentFrame: template(
	                "<iframe frameborder='0' title='#= title #' class='" + KCONTENTFRAME + "' " +
	                "src='#= content.url #'>" +
	                "This page requires frames in order to show content" +
	                "</iframe>"
	            ),
	            resizeHandle: template("<div class='k-resize-handle k-resize-#= data #'></div>")
	        };


	        function WindowResizing(wnd) {
	            var that = this;
	            that.owner = wnd;
	            that._preventDragging = false;
	            that._draggable = new Draggable(wnd.wrapper, {
	                filter: ">" + KWINDOWRESIZEHANDLES,
	                group: wnd.wrapper.id + "-resizing",
	                dragstart: proxy(that.dragstart, that),
	                drag: proxy(that.drag, that),
	                dragend: proxy(that.dragend, that)
	            });

	            that._draggable.userEvents.bind("press", proxy(that.addOverlay, that));
	            that._draggable.userEvents.bind("release", proxy(that.removeOverlay, that));
	        }

	        WindowResizing.prototype = {
	            addOverlay: function () {
	                this.owner.wrapper.append(templates.overlay);
	            },
	            removeOverlay: function () {
	                this.owner.wrapper.find(KOVERLAY).remove();
	            },
	            dragstart: function (e) {
	                var that = this;
	                var wnd = that.owner;
	                var wrapper = wnd.wrapper;

	                that._preventDragging = wnd.trigger(RESIZESTART);
	                if (that._preventDragging) {
	                    return;
	                }

	                that.elementPadding = parseInt(wrapper.css("padding-top"), 10);
	                that.initialPosition = kendo.getOffset(wrapper, "position");

	                that.resizeDirection = e.currentTarget.prop("className").replace("k-resize-handle k-resize-", "");

	                that.initialSize = {
	                    width: wrapper.outerWidth(),
	                    height: wrapper.outerHeight()
	                };

	                wnd._updateBoundaries();

	                that.containerOffset = wnd.containment ? wnd.containment.position : kendo.getOffset(wnd.appendTo, "position");

	                var offsetParent = wrapper.offsetParent();

	                if (offsetParent.is("html")) {
	                    that.containerOffset.top = that.containerOffset.left = 0;
	                } else {
	                    var marginTop = offsetParent.css("margin-top");
	                    var marginLeft = offsetParent.css("margin-left");
	                    var hasMargin = !zero.test(marginTop) || !zero.test(marginLeft);
	                    if (hasMargin) {
	                        var wrapperPosition = getPosition(wrapper[0]);
	                        var relativeElMarginLeft = wrapperPosition.left - that.containerOffset.left - that.initialPosition.left;
	                        var relativeElMarginTop = wrapperPosition.top - that.containerOffset.top - that.initialPosition.top;

	                        that._relativeElMarginLeft = relativeElMarginLeft > 1 ? relativeElMarginLeft : 0;
	                        that._relativeElMarginTop = relativeElMarginTop > 1 ? relativeElMarginTop : 0;

	                        that.initialPosition.left += that._relativeElMarginLeft;
	                        that.initialPosition.top += that._relativeElMarginTop;
	                    }
	                }

	                wrapper
	                    .children(KWINDOWRESIZEHANDLES).not(e.currentTarget).hide();

	                $(BODY).css(CURSOR, e.currentTarget.css(CURSOR));
	            },
	            drag: function (e) {
	                if (this._preventDragging) {
	                    return;
	                }
	                var that = this,
	                    wnd = that.owner,
	                    wrapper = wnd.wrapper,
	                    options = wnd.options,
	                    position = options.position,
	                    direction = that.resizeDirection,
	                    containerOffset = that.containerOffset,
	                    initialPosition = that.initialPosition,
	                    initialSize = that.initialSize,
	                    containmentContext = wnd.containment && !wnd._isPinned,
	                    rtl = kendo.support.isRtl(wnd.containment),
	                    leftRtlOffset = containmentContext && rtl && wnd.containment.innerWidth() > wnd.containment.width ? kendo.support.scrollbar() : 0,
	                    scrollOffset = containmentContext ? { top: wnd.containment.scrollTop(), left: wnd.containment.scrollLeft()} : { top: 0, left: 0},
	                    newWidth, newHeight,
	                    windowBottom, windowRight,
	                    x = Math.max(e.x.location, 0),
	                    y = Math.max(e.y.location, 0);

	                    if (direction.indexOf("e") >= 0) {

	                        if (wnd.containment && x - initialSize.width >= wnd.maxLeft - scrollOffset.left + containerOffset.left + leftRtlOffset) {
	                            newWidth = wnd.maxLeft + leftRtlOffset - initialPosition.left + initialSize.width - scrollOffset.left;
	                        } else {
	                            newWidth = x - initialPosition.left - containerOffset.left;
	                        }

	                        wrapper.width(constrain(newWidth, options.minWidth, options.maxWidth));
	                    } else if (direction.indexOf("w") >= 0) {
	                        windowRight = initialPosition.left + initialSize.width + containerOffset.left;
	                        newWidth = constrain(windowRight - x, options.minWidth, options.maxWidth);
	                        position.left = windowRight - newWidth - containerOffset.left - leftRtlOffset - (that._relativeElMarginLeft || 0) + scrollOffset.left;

	                        if (wnd.containment && position.left <= wnd.minLeft) {
	                            position.left = wnd.minLeft;
	                            newWidth = constrain(windowRight - leftRtlOffset - position.left - containerOffset.left + scrollOffset.left, options.minWidth, options.maxWidth);
	                        }

	                        wrapper.css({
	                            left: position.left,
	                            width: newWidth
	                        });
	                    }

	                    var newWindowTop = y;
	                    if (wnd.options.pinned) {
	                        newWindowTop -= $(window).scrollTop();
	                    }
	                    if (direction.indexOf("s") >= 0) {
	                        newHeight = newWindowTop - initialPosition.top - that.elementPadding - containerOffset.top;

	                        if (newWindowTop - initialSize.height - that.elementPadding >= wnd.maxTop + containerOffset.top - scrollOffset.top) {
	                            newHeight = wnd.maxTop - initialPosition.top + initialSize.height - scrollOffset.top;
	                        }

	                        wrapper.height(constrain(newHeight, options.minHeight, options.maxHeight));
	                    } else if (direction.indexOf("n") >= 0) {
	                        windowBottom = initialPosition.top + initialSize.height + containerOffset.top;
	                        newHeight = constrain(windowBottom - newWindowTop, options.minHeight, options.maxHeight);
	                        position.top = windowBottom - newHeight - containerOffset.top - (that._relativeElMarginTop || 0) + scrollOffset.top;

	                        if (position.top <= wnd.minTop && wnd.containment) {
	                            position.top = wnd.minTop;
	                            newHeight = constrain(windowBottom - position.top - containerOffset.top + scrollOffset.top, options.minHeight, options.maxHeight);
	                        }

	                        wrapper.css({
	                            top: position.top,
	                            height: newHeight
	                        });
	                    }

	                    if (newWidth) {
	                        wnd.options.width = newWidth + "px";
	                    }
	                    if (newHeight) {
	                        wnd.options.height = newHeight + "px";
	                    }

	                    wnd.resize();
	            },
	            dragend: function (e) {
	                if (this._preventDragging) {
	                    return;
	                }

	                var that = this,
	                    wnd = that.owner,
	                    wrapper = wnd.wrapper;

	                wrapper
	                    .children(KWINDOWRESIZEHANDLES).not(e.currentTarget).show();

	                $(BODY).css(CURSOR, "");

	                if (wnd.touchScroller) {
	                    wnd.touchScroller.reset();
	                }

	                if (e.keyCode == 27) {
	                    wrapper.css(that.initialPosition)
	                        .css(that.initialSize);
	                }

	                wnd.trigger(RESIZEEND);

	                return false;
	            },
	            destroy: function() {
	                if (this._draggable) {
	                    this._draggable.destroy();
	                }

	                this._draggable = this.owner = null;
	            }
	        };

	        function WindowDragging(wnd, dragHandle) {
	            var that = this;
	            that.owner = wnd;
	            that._preventDragging = false;
	            that._draggable = new Draggable(wnd.wrapper, {
	                filter: dragHandle,
	                group: wnd.wrapper.id + "-moving",
	                dragstart: proxy(that.dragstart, that),
	                drag: proxy(that.drag, that),
	                dragend: proxy(that.dragend, that),
	                dragcancel: proxy(that.dragcancel, that)
	            });

	            that._draggable.userEvents.stopPropagation = false;
	        }

	        WindowDragging.prototype = {
	            dragstart: function (e) {
	                var wnd = this.owner,
	                    draggable = wnd.options.draggable,
	                    element = wnd.element,
	                    actions = element.find(".k-window-actions"),
	                    containerOffset = kendo.getOffset(wnd.appendTo);

	                this._preventDragging = wnd.trigger(DRAGSTART) || !draggable;
	                if (this._preventDragging || wnd.isMaximized()) {
	                    return;
	                }

	                wnd.initialWindowPosition = kendo.getOffset(wnd.wrapper, "position");

	                wnd.initialPointerPosition = {
	                    left: wnd.options.position.left,
	                    top: wnd.options.position.top
	                };

	                wnd.startPosition = {
	                    left: e.x.client - wnd.initialWindowPosition.left,
	                    top: e.y.client - wnd.initialWindowPosition.top
	                };

	                wnd._updateBoundaries();
	                if (!wnd.containment) {
	                    if (actions.length > 0) {
	                        wnd.minLeft = outerWidth(actions) + parseInt(actions.css("right"), 10) - outerWidth(element);
	                    } else {
	                        wnd.minLeft =  20 - outerWidth(element); // at least 20px remain visible
	                    }

	                    wnd.minLeft -= containerOffset.left;
	                    wnd.minTop = -containerOffset.top;
	                }

	                wnd.wrapper
	                    .append(templates.overlay)
	                    .children(KWINDOWRESIZEHANDLES).hide();

	                $(BODY).css(CURSOR, e.currentTarget.css(CURSOR));
	            },

	            drag: function (e) {
	                var wnd = this.owner;
	                var position = wnd.options.position;
	                var axis = wnd.options.draggable.axis;
	                var left;
	                var top;

	                if (this._preventDragging || wnd.isMaximized()) {
	                    return;
	                }

	                if (!axis || axis.toLowerCase() === "x") {
	                    left = e.x.client - wnd.startPosition.left;

	                    if (wnd.containment && !wnd._isPinned) {
	                        left += wnd.containment.scrollLeft();
	                    }

	                    position.left = constrain(left, wnd.minLeft, wnd.maxLeft);
	                }

	                if (!axis || axis.toLowerCase() === "y") {
	                    top = e.y.client - wnd.startPosition.top;

	                    if (wnd.containment && !wnd._isPinned) {
	                        top += wnd.containment.scrollTop();
	                    }

	                    position.top = constrain(top, wnd.minTop, wnd.maxTop);
	                }

	                if (kendo.support.transforms) {
	                    $(wnd.wrapper).css(
	                        "transform", "translate(" +
	                        (position.left - wnd.initialPointerPosition.left) + "px, " +
	                        (position.top - wnd.initialPointerPosition.top) + "px)"
	                    );
	                } else {
	                    $(wnd.wrapper).css(position);
	                }

	            },

	            _finishDrag: function() {
	                var wnd = this.owner;

	                wnd.wrapper
	                    .children(KWINDOWRESIZEHANDLES).toggle(!wnd.options.isMinimized).end()
	                    .find(KOVERLAY).remove();

	                $(BODY).css(CURSOR, "");
	            },

	            dragcancel: function (e) {
	                if (this._preventDragging) {
	                    return;
	                }
	                this._finishDrag();

	                e.currentTarget.closest(KWINDOW).css(this.owner.initialWindowPosition);
	            },

	            dragend: function () {
	                var wnd = this.owner;

	                if (this._preventDragging || wnd.isMaximized()) {
	                    return;
	                }

	                $(wnd.wrapper)
	                    .css(wnd.options.position)
	                    .css("transform", "");

	                this._finishDrag();

	                wnd.trigger(DRAGEND);

	                return false;
	            },
	            destroy: function() {
	                if (this._draggable) {
	                    this._draggable.destroy();
	                }

	                this._draggable = this.owner = null;
	            }
	        };

	        kendo.ui.plugin(Window);

	    })(window.kendo.jQuery);

	    return window.kendo;

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "1aUC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = __webpack_require__("U9Xd");
var context_1 = __webpack_require__("RQ1/");
var context_2 = __webpack_require__("RQ1/");
var ExpressionService = (function () {
    function ExpressionService() {
        this.expressionToFunctionCache = {};
    }
    ExpressionService.prototype.setBeans = function (loggerFactory) {
        this.logger = loggerFactory.create('ExpressionService');
    };
    ExpressionService.prototype.evaluate = function (expressionOrFunc, params) {
        if (typeof expressionOrFunc === 'function') {
            // valueGetter is a function, so just call it
            var func = expressionOrFunc;
            return func(params);
        }
        else if (typeof expressionOrFunc === 'string') {
            // valueGetter is an expression, so execute the expression
            var expression = expressionOrFunc;
            return this.evaluateExpression(expression, params);
        }
        else {
            console.error('ag-Grid: value should be either a string or a function', expressionOrFunc);
        }
    };
    ExpressionService.prototype.evaluateExpression = function (expression, params) {
        try {
            var javaScriptFunction = this.createExpressionFunction(expression);
            // the params don't have all these values, rather we add every possible
            // value a params can have, which makes whatever is in the params available.
            var result = javaScriptFunction(params.value, params.context, params.oldValue, params.newValue, params.value, params.node, params.data, params.colDef, params.rowIndex, params.api, params.columnApi, params.getValue, params.column, params.columnGroup);
            return result;
        }
        catch (e) {
            // the expression failed, which can happen, as it's the client that
            // provides the expression. so print a nice message
            console.log('Processing of the expression failed');
            console.log('Expression = ' + expression);
            console.log('Exception = ' + e);
            return null;
        }
    };
    ExpressionService.prototype.createExpressionFunction = function (expression) {
        // check cache first
        if (this.expressionToFunctionCache[expression]) {
            return this.expressionToFunctionCache[expression];
        }
        // if not found in cache, return the function
        var functionBody = this.createFunctionBody(expression);
        var theFunction = new Function('x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, columnApi, getValue, column, columnGroup', functionBody);
        // store in cache
        this.expressionToFunctionCache[expression] = theFunction;
        return theFunction;
    };
    ExpressionService.prototype.createFunctionBody = function (expression) {
        // if the expression has the 'return' word in it, then use as is,
        // if not, then wrap it with return and ';' to make a function
        if (expression.indexOf('return') >= 0) {
            return expression;
        }
        else {
            return 'return ' + expression + ';';
        }
    };
    __decorate([
        __param(0, context_2.Qualifier('loggerFactory')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
        __metadata("design:returntype", void 0)
    ], ExpressionService.prototype, "setBeans", null);
    ExpressionService = __decorate([
        context_1.Bean('expressionService')
    ], ExpressionService);
    return ExpressionService;
}());
exports.ExpressionService = ExpressionService;


/***/ }),

/***/ "1kkP":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1094);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1068:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("S/9S");

/***/ }),

/***/ 1069:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("jBxA");

/***/ }),

/***/ 1070:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("bFti");

/***/ }),

/***/ 1094:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1068), __webpack_require__(1069), __webpack_require__(1070) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "combobox",
	    name: "ComboBox",
	    category: "web",
	    description: "The ComboBox widget allows the selection from pre-defined values or entering a new value.",
	    depends: [ "list" ],
	    features: [ {
	        id: "mobile-scroller",
	        name: "Mobile scroller",
	        description: "Support for kinetic scrolling in mobile device",
	        depends: [ "mobile.scroller" ]
	    }, {
	        id: "virtualization",
	        name: "VirtualList",
	        description: "Support for virtualization",
	        depends: [ "virtuallist" ]
	    } ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        List = ui.List,
	        Select = ui.Select,
	        caret = kendo.caret,
	        support = kendo.support,
	        placeholderSupported = support.placeholder,
	        activeElement = kendo._activeElement,
	        keys = kendo.keys,
	        ns = ".kendoComboBox",
	        nsFocusEvent = ns + "FocusEvent",
	        CLICK = "click" + ns,
	        MOUSEDOWN = "mousedown" + ns,
	        DISABLED = "disabled",
	        READONLY = "readonly",
	        CHANGE = "change",
	        LOADING = "k-i-loading",
	        DEFAULT = "k-state-default",
	        FOCUSED = "k-state-focused",
	        STATEDISABLED = "k-state-disabled",
	        ARIA_DISABLED = "aria-disabled",
	        ARIA_READONLY = "aria-readonly",
	        AUTOCOMPLETEVALUE = "off",
	        STATE_FILTER = "filter",
	        STATE_ACCEPT = "accept",
	        STATE_REBIND = "rebind",
	        HOVEREVENTS = "mouseenter" + ns + " mouseleave" + ns,
	        proxy = $.proxy,
	        newLineRegEx = /(\r\n|\n|\r)/gm;

	    var ComboBox = Select.extend({
	        init: function(element, options) {
	            var that = this, text, disabled;

	            that.ns = ns;

	            options = $.isArray(options) ? { dataSource: options } : options;

	            Select.fn.init.call(that, element, options);

	            options = that.options;
	            element = that.element.on("focus" + ns, proxy(that._focusHandler, that));

	            options.placeholder = options.placeholder || element.attr("placeholder");

	            that._reset();

	            that._wrapper();

	            that._input();

	            that._clearButton();

	            that._tabindex(that.input);

	            that._popup();

	            that._dataSource();
	            that._ignoreCase();

	            that._enable();

	            that._attachFocusEvents();

	            that._oldIndex = that.selectedIndex = -1;

	            that._aria();

	            that._initialIndex = options.index;

	            that.requireValueMapper(that.options);
	            that._initList();

	            that._cascade();

	            if (options.autoBind) {
	                that._filterSource();
	            } else {
	                text = options.text;

	                if (!text && that._isSelect) {
	                    text = element.children(":selected").text();
	                }

	                if (text) {
	                    that._setText(text);
	                }
	            }

	            if (!text) {
	                that._placeholder();
	            }

	            disabled = $(that.element).parents("fieldset").is(':disabled');

	            if (disabled) {
	                that.enable(false);
	            }

	            kendo.notify(that);
	            that._toggleCloseVisibility();
	        },

	        options: {
	            name: "ComboBox",
	            enabled: true,
	            index: -1,
	            text: null,
	            value: null,
	            autoBind: true,
	            delay: 200,
	            dataTextField: "",
	            dataValueField: "",
	            minLength: 1,
	            enforceMinLength: false,
	            height: 200,
	            highlightFirst: true,
	            filter: "none",
	            placeholder: "",
	            suggest: false,
	            cascadeFrom: "",
	            cascadeFromField: "",
	            cascadeFromParentField: "",
	            ignoreCase: true,
	            animation: {},
	            virtual: false,
	            template: null,
	            groupTemplate: "#:data#",
	            fixedGroupTemplate: "#:data#",
	            clearButton: true,
	            syncValueAndText: true,
	            autoWidth: false,
	            popup: null
	        },

	        events:[
	            "open",
	            "close",
	            CHANGE,
	            "select",
	            "filtering",
	            "dataBinding",
	            "dataBound",
	            "cascade",
	            "set"
	        ],

	        setOptions: function(options) {
	            var listOptions = this._listOptions(options);

	            Select.fn.setOptions.call(this, options);

	            this.listView.setOptions(listOptions);

	            this._accessors();
	            this._aria();
	            this._clearButton();
	        },

	        destroy: function() {
	            var that = this;

	            that.input.off(ns);
	            that.input.off(nsFocusEvent);
	            that.element.off(ns);
	            that.wrapper.off(ns);
	            that._inputWrapper.off(ns);
	            clearTimeout(that._pasteTimeout);

	            that._arrow.off(CLICK + " " + MOUSEDOWN);
	            that._clear.off(CLICK + " " + MOUSEDOWN);

	            Select.fn.destroy.call(that);
	        },

	        _isValueChanged: function(value) {
	            return value !== List.unifyType(this._old, typeof value) &&
	                value !== List.unifyType(this._oldText, typeof value);
	        },

	        _change: function() {
	            var that = this;
	            var text = that.text();
	            var hasText = text && text !== that._oldText && text !== that.options.placeholder;
	            var index = that.selectedIndex;
	            var isCustom = index === -1;

	            if (!that.options.syncValueAndText && !that.value() && isCustom && hasText) {
	                that._old = "";
	                that._oldIndex = index;
	                that._oldText = text;

	                if (!that._typing) {
	                    // trigger the DOM change event so any subscriber gets notified
	                    that.element.trigger(CHANGE);
	                }

	                that.trigger(CHANGE);
	                that._typing = false;
	                return;
	            }

	            Select.fn._change.call(that);

	            that._oldText = that.text && that.text();

	            that._toggleCloseVisibility();
	        },

	        _attachFocusEvents: function() {
	            var that = this;
	            that.input.on("focus" + nsFocusEvent, proxy(that._inputFocus, that))
	                      .on("focusout" + nsFocusEvent, proxy(that._inputFocusout, that));
	        },

	        _focusHandler: function(e) {
	            if(e.target === this.element[0]) {
	                this.input.focus();
	            }
	        },

	        _arrowClick: function() {
	            this._toggle();
	        },

	        _inputFocus: function() {
	            this._inputWrapper.addClass(FOCUSED);
	            this._placeholder(false);
	        },

	        _inputFocusout: function() {
	            var that = this;
	            var value = that.value();

	            that._userTriggered = true;
	            that._inputWrapper.removeClass(FOCUSED);
	            clearTimeout(that._typingTimeout);
	            that._typingTimeout = null;

	            that.text(that.text());

	            var item = that._focus();
	            var dataItem = this.listView.dataItemByIndex(this.listView.getElementIndex(item));

	            if (value !== that.value() && that.trigger("select", { dataItem: dataItem, item: item })) {
	                that.value(value);
	                return;
	            }

	            that._placeholder();
	            that._valueBeforeCascade = that._old;
	            that._blur();

	            that.element.blur();
	        },

	        _inputPaste: function() {
	            var that = this;
	            clearTimeout(that._pasteTimeout);
	            that._pasteTimeout = null;

	            that._pasteTimeout = setTimeout(function() {
	                that.search();
	            });
	        },

	        _editable: function(options) {
	            var that = this,
	                disable = options.disable,
	                readonly = options.readonly,
	                wrapper = that._inputWrapper.off(ns),
	                input = that.element.add(that.input.off(ns)),
	                arrow = that._arrow.off(CLICK + " " + MOUSEDOWN),
	                clear = that._clear;

	            if (!readonly && !disable) {
	                wrapper
	                    .addClass(DEFAULT)
	                    .removeClass(STATEDISABLED)
	                    .on(HOVEREVENTS, that._toggleHover);

	                input.removeAttr(DISABLED)
	                     .removeAttr(READONLY)
	                     .attr(ARIA_DISABLED, false)
	                     .attr(ARIA_READONLY, false);

	                arrow.on(CLICK, proxy(that._arrowClick, that))
	                     .on(MOUSEDOWN, function(e) { e.preventDefault(); });

	                clear.on(CLICK + " touchend" + ns, proxy(that._clearValue, that));

	                that.input
	                    .on("keydown" + ns, proxy(that._keydown, that))
	                    .on("input" + ns, proxy(that._search, that))
	                    .on("paste" + ns, proxy(that._inputPaste, that));

	                that.wrapper.on(CLICK + ns, proxy(that._focusHandler, that));
	            } else {
	                wrapper
	                    .addClass(disable ? STATEDISABLED : DEFAULT)
	                    .removeClass(disable ? DEFAULT : STATEDISABLED);

	                input.attr(DISABLED, disable)
	                     .attr(READONLY, readonly)
	                     .attr(ARIA_DISABLED, disable)
	                     .attr(ARIA_READONLY, readonly);
	            }

	            that._toggleCloseVisibility();
	        },

	        open: function() {
	            var that = this;
	            var state = that._state;
	            var isFiltered = that.dataSource.filter() ? that.dataSource.filter().filters.length > 0 : false;
	            var reinitialized = !that.ul.find(that.listView.focus()).length;

	            if (that.popup.visible()) {
	                return;
	            }

	            if ((!that.listView.bound() && state !== STATE_FILTER) || state === STATE_ACCEPT) {
	                that._open = true;
	                that._state = STATE_REBIND;
	                if ((that.options.minLength !== 1 && !isFiltered) || (isFiltered && that.value() && that.selectedIndex === -1 )) {
	                    that.refresh();
	                    that._openPopup();
	                    if (!this.options.virtual) {
	                        that.listView.bound(false);
	                    }
	                } else {
	                    that._filterSource();
	                }
	            } else if (that._allowOpening()) {
	                // In some cases when the popup is opened resize is triggered which will cause it to close
	                // Setting the below flag will prevent this from happening
	                that.popup._hovered = true;
	                that._openPopup();
	                if(that.options.virtual) {
	                    that._focusItem();
	                } else if (reinitialized && that.options.highlightFirst) {
	                    that.listView.focus(0);
	                }
	            }
	        },

	        _scrollToFocusedItem: function() {
	            var listView = this.listView;

	            listView.scrollToIndex(listView.getElementIndex(listView.focus()));
	        },

	        _openPopup: function() {
	            this.popup.one("activate", proxy(this._scrollToFocusedItem, this));
	            this.popup.open();
	        },

	        _updateSelectionState: function() {
	            var that = this;
	            var text = that.options.text;
	            var value = that.options.value;

	            if (that.listView.isFiltered()) {
	                return;
	            }

	            if (that.selectedIndex === -1) {
	                if (text === undefined || text === null) {
	                    text = value;
	                }

	                that._accessor(value);
	                that.input.val(text || that.input.val());
	                that._placeholder();
	            } else if (that._oldIndex === -1) {
	                that._oldIndex = that.selectedIndex;
	            }
	        },

	        _buildOptions: function(data) {
	            var that = this;
	            if (!that._isSelect) {
	                return;
	            }

	            var custom = that._customOption;

	            if (that._state === STATE_REBIND) {
	                that._state = "";
	            }

	            that._customOption = undefined;
	            that._options(data, "", that.value());

	            if (custom && custom[0].selected && !that.listView._emptySearch) {
	                that._custom(custom.val());
	            }
	        },

	        _updateSelection: function() {
	            var that = this;
	            var listView = that.listView;
	            var initialIndex = that._initialIndex;
	            var hasInitialIndex = initialIndex !== null && initialIndex > -1;
	            var filtered = that._state === STATE_FILTER;

	            if (filtered) {
	                $(listView.focus()).removeClass("k-state-selected");
	                return;
	            }

	            if (that._fetch) {
	                return;
	            }

	            if (!listView.value().length) {
	                if (hasInitialIndex) {
	                    that.select(initialIndex);
	                } else if (that._accessor()) {
	                    listView.value(that._accessor());
	                }
	            }

	            that._initialIndex = null;
	            var dataItem = listView.selectedDataItems()[0];

	            if (!dataItem) {
	                return;
	            }

	            if (that._value(dataItem) !== that.value()) {
	                that._custom(that._value(dataItem));
	            } else if (that._value(dataItem) !== that.element[0].value){
	                that._accessor(that._value(dataItem));
	            }

	            if (that.text() && that.text() !== that._text(dataItem)) {
	                that._selectValue(dataItem);
	            }
	        },

	        _updateItemFocus: function() {
	            var listView = this.listView;

	            if (!this.options.highlightFirst) {
	                listView.focus(-1);
	            } else if (!listView.focus() && !listView.focusIndex()) {
	                listView.focus(0);
	            }
	        },

	        _listBound: function() {
	            var that = this;
	            var isActive = that.input[0] === activeElement();

	            var data = that.dataSource.flatView();
	            var skip = that.listView.skip();
	            var length = data.length;
	            var groupsLength = that.dataSource._group ? that.dataSource._group.length : 0;
	            var isFirstPage = skip === undefined || skip === 0;

	            that._presetValue = false;

	            that._renderFooter();
	            that._renderNoData();
	            that._toggleNoData(!length);
	            that._toggleHeader(!!groupsLength && !!length);

	            that._resizePopup();

	            that.popup.position();

	            that._buildOptions(data);

	            that._makeUnselectable();

	            that._updateSelection();

	            if (data.length && isFirstPage) {
	                that._updateItemFocus();

	                if (that.options.suggest && isActive && that.input.val()) {
	                    that.suggest(data[0]);
	                }
	            }

	            if (that._open) {
	                that._open = false;

	                if (that._typingTimeout && !isActive) {
	                    that.popup.close();
	                } else {
	                    that.toggle(that._allowOpening());
	                }

	                that._typingTimeout = null;
	            }

	            that._hideBusy();
	            that.trigger("dataBound");
	        },

	        _listChange: function() {
	            this._selectValue(this.listView.selectedDataItems()[0]);

	            if (this._presetValue) {
	                this._oldIndex = this.selectedIndex;
	            }
	        },

	        _get: function(candidate) {
	            var data, found, idx;

	            if (typeof candidate === "function") {
	                data = this.dataSource.flatView();

	                for (idx = 0; idx < data.length; idx++) {
	                    if (candidate(data[idx])) {
	                        candidate = idx;
	                        found = true;
	                        break;
	                    }
	                }

	                if (!found) {
	                    candidate = -1;
	                }
	            }

	            return candidate;
	        },

	        _select: function(candidate, keepState) {
	            var that = this;

	            candidate = that._get(candidate);

	            if (candidate === -1) {
	                that.input[0].value = "";
	                that._accessor("");
	            }

	            return that.listView.select(candidate).done(function() {
	                if (!keepState && that._state === STATE_FILTER) {
	                    that._state = STATE_ACCEPT;
	                }
	                that._toggleCloseVisibility();
	            });
	        },

	        _selectValue: function(dataItem) {
	            var idx = this.listView.select();
	            var value = "";
	            var text = "";

	            idx = idx[idx.length - 1];
	            if (idx === undefined) {
	                idx = -1;
	            }

	            this.selectedIndex = idx;

	            if (this.listView.isFiltered() && idx !== -1) {
	                this._valueBeforeCascade = this._old;
	            }

	            if (idx === -1 && !dataItem) {
	                if (this.options.syncValueAndText) {
	                    if (this.options.dataTextField === this.options.dataValueField) {
	                        text = this._accessor();
	                    } else {
	                        text = this.input[0].value;
	                    }
	                    value = text;
	                }
	                else {
	                    text = this.text();
	                }
	                this.listView.focus(-1);
	            } else {
	                if (dataItem || dataItem === 0) {
	                    value = this._dataValue(dataItem);
	                    text = this._text(dataItem);
	                }

	                if (value === null) {
	                    value = "";
	                }
	            }

	            this._setDomInputValue(text);
	            this._accessor(value !== undefined ? value : text, idx);

	            this._placeholder();
	            this._triggerCascade();
	        },

	        _setDomInputValue: function(text){
	            var that = this;
	            var currentCaret = caret(this.input);
	            var caretStart;

	            if(currentCaret && currentCaret.length){
	                caretStart = currentCaret[0];
	            }

	            this._prev = this.input[0].value = text;

	            if(caretStart && this.selectedIndex === -1){
	                var mobile = support.mobileOS;
	                if(mobile.wp || mobile.android) {// without the timeout the caret is at the end of the input
	                    setTimeout(function() { that.input[0].setSelectionRange(caretStart, caretStart); }, 0);
	                }
	                else {
	                    this.input[0].setSelectionRange(caretStart, caretStart);
	                }
	            }
	        },

	        refresh: function() {
	            this.listView.refresh();
	        },

	        _toggleCloseVisibility: function() {
	            var preventShow = this.element.is(":disabled") || this.element.is("[readonly]");

	            if (this.text() && !preventShow) {
	                this._showClear();
	            } else {
	                this._hideClear();
	            }
	        },

	        suggest: function(word) {
	            var that = this;
	            var element = that.input[0];
	            var value = that.text();
	            var caretIdx = caret(element)[0];
	            var key = that._last;
	            var idx;
	            var accentFoldingFiltering = that.dataSource.options.accentFoldingFiltering;

	            if (key == keys.BACKSPACE || key == keys.DELETE) {
	                that._last = undefined;
	                return;
	            }

	            word = word || "";

	            if (typeof word !== "string") {
	                if (word[0]) {
	                    word = that.dataSource.view()[List.inArray(word[0], that.ul[0])];
	                }

	                word = word ? that._text(word) : "";
	            }

	            if (caretIdx <= 0) {
	                caretIdx = (accentFoldingFiltering ? value.toLocaleLowerCase(accentFoldingFiltering) : value.toLowerCase()).indexOf(accentFoldingFiltering ? word.toLocaleLowerCase(accentFoldingFiltering) : word.toLowerCase()) + 1;
	            }

	            if (word) {
	                word = word.toString();
	                idx = (accentFoldingFiltering ? word.toLocaleLowerCase(accentFoldingFiltering) : word.toLowerCase()).indexOf(accentFoldingFiltering ? value.toLocaleLowerCase(accentFoldingFiltering) : value.toLowerCase());
	                if (idx > -1) {
	                    value += word.substring(idx + value.length);
	                }
	            } else {
	                value = value.substring(0, caretIdx);
	            }

	            if (value.length !== caretIdx || !word) {
	                element.value = value;
	                if (element === activeElement()) {
	                    caret(element, caretIdx, value.length);
	                }
	            }
	        },

	        text: function (text) {
	            text = text === null ? "" : text;

	            var that = this;
	            var input = that.input[0];
	            var ignoreCase = that.options.ignoreCase;
	            var loweredText = text;
	            var dataItem;
	            var value;

	            if (text === undefined) {
	                return input.value;
	            }

	            if (that.options.autoBind === false && !that.listView.bound()) {
	                that._setText(text);
	                return;
	            }

	            dataItem = that.dataItem();

	            if (dataItem && that._text(dataItem).replace && that._text(dataItem).replace(newLineRegEx,"") === text) {
	                value = that._value(dataItem);

	                if (value === List.unifyType(that._old, typeof value)) {
	                    that._triggerCascade();
	                    return;
	                }
	            }

	            if (ignoreCase) {
	                loweredText = loweredText.toLowerCase();
	            }

	            if(that.dataItem() && that._text(that.dataItem()) === text){
	                return;
	            }

	            that._select(function(data) {
	                data = that._text(data);
	                if (ignoreCase) {
	                    data = (data + "").toLowerCase();
	                }

	                return data === loweredText;
	            }).done(function() {
	                if (that.selectedIndex < 0) {
	                    input.value = text;

	                    if (that.options.syncValueAndText) {
	                        that._accessor(text);
	                    }

	                    that._cascadeTriggered = true;
	                    that._triggerCascade();
	                }

	                that._prev = input.value;
	            });

	            that._toggleCloseVisibility();
	        },

	        toggle: function(toggle) {
	            this._toggle(toggle, true);
	        },

	        value: function(value) {
	            var that = this;
	            var options = that.options;
	            var listView = that.listView;

	            if (value === undefined) {
	                value = that._accessor() || that.listView.value()[0];
	                return value === undefined || value === null ? "" : value;
	            }

	            that.requireValueMapper(that.options, value);

	            that.trigger("set", { value: value });

	            if (value === options.value && that.input.val() === options.text &&
	            !that.options.cascadeFrom) {
	                return;
	            }

	            that._accessor(value);

	            if (that._isFilterEnabled() && listView.bound() && listView.isFiltered()) {
	                that._clearFilter();
	            } else {
	                that._fetchData();
	            }

	            listView
	                .value(value)
	                .done(function() {
	                    if (that.selectedIndex === -1 && (!listView._selectedDataItems || !listView._selectedDataItems.length)) {
	                        that._accessor(value);
	                        that.input.val(value);
	                        that._placeholder(true);
	                    }

	                    if(that._userTriggered) {
	                         that._old = that._accessor();
	                    } else {
	                         that._old = that._valueBeforeCascade = that._accessor();
	                    }

	                    that._oldIndex = that.selectedIndex;

	                    that._prev = that._oldText = that.input.val();

	                    if (that._state === STATE_FILTER) {
	                        that._state = STATE_ACCEPT;
	                    }
	                    that._toggleCloseVisibility();
	                });
	        },

	        _hideBusy: function () {
	            var that = this;
	            clearTimeout(that._busy);
	            that._arrowIcon.removeClass(LOADING);
	            that._focused.attr("aria-busy", false);
	            that._busy = null;
	            that._toggleCloseVisibility();
	        },

	        _click: function(e) {
	            var that = this;
	            var item = e.item;
	            var dataItem = that.listView.dataItemByIndex(that.listView.getElementIndex(item));
	            var shouldTrigger = true;
	            e.preventDefault();

	            if(dataItem){
	                shouldTrigger = that._value(dataItem) !==  List.unifyType(that.value(), typeof that._value(dataItem));

	                if(!shouldTrigger){
	                   that.input.val(that._text(dataItem));
	                }
	            }

	            if (shouldTrigger && that.trigger("select", { dataItem: dataItem, item: item })) {
	                that.close();
	                return;
	            }

	            that._userTriggered = true;

	            that._select(item).done(function() {
	                that._blur();
	            });
	        },

	        _syncValueAndText: function () {
	            return this.options.syncValueAndText;
	        },

	        _inputValue: function() {
	            return this.text();
	        },

	        _searchByWord: function(word) {
	            var that = this;
	            var options = that.options;
	            var dataSource = that.dataSource;
	            var ignoreCase = options.ignoreCase;
	            var predicate = function (dataItem) {
	                var text = that._text(dataItem);
	                if (text !== undefined) {
	                    text = text + "";
	                    if (text !== "" && word === "") {
	                        return false;
	                    }

	                    if (ignoreCase) {
	                        text = text.toLowerCase();
	                    }

	                    return text.indexOf(word) === 0;
	                }
	            };

	            if (ignoreCase) {
	                word = word.toLowerCase();
	            }

	            if (!that.ul[0].firstChild) {
	                dataSource.one(CHANGE, function () {
	                    if (dataSource.view()[0]) {
	                        that.search(word);
	                    }
	                }).fetch();
	                return;
	            }

	            this.listView.focus(this._get(predicate));

	            var current = this.listView.focus();

	            if (current) {
	                if (options.suggest) {
	                    that.suggest(current);
	                }

	                this.open();
	            }

	            if (this.options.highlightFirst && !word) {
	                this.listView.focusFirst();
	            }
	        },

	        _input: function() {
	            var that = this,
	                element = that.element.removeClass("k-input")[0],
	                accessKey = element.accessKey,
	                wrapper = that.wrapper,
	                SELECTOR = "input.k-input",
	                name = element.name || "",
	                input,
	                maxLength;

	            if (name) {
	                name = 'name="' + name + '_input" ';
	            }

	            input = wrapper.find(SELECTOR);

	            if (!input[0]) {
	                wrapper.append('<span tabindex="-1" unselectable="on" class="k-dropdown-wrap k-state-default"><input ' + name + 'class="k-input" type="text" autocomplete="' + AUTOCOMPLETEVALUE +'"/><span unselectable="on" class="k-select" aria-label="select"><span class="k-icon k-i-arrow-60-down"></span></span></span>')
	                    .append(that.element);

	                input = wrapper.find(SELECTOR);
	            }

	            input[0].style.cssText = element.style.cssText;
	            input[0].title = element.title;

	            maxLength = parseInt(this.element.prop("maxlength") || this.element.attr("maxlength"), 10);
	            if (maxLength > -1) {
	                input[0].maxLength = maxLength;
	            }

	            input.addClass(element.className)
	                 .css({
	                    width: "",
	                    height: element.style.height
	                 })
	                 .attr({
	                     "role": "combobox",
	                     "aria-expanded": false
	                 })
	                 .show();

	            if (placeholderSupported) {
	                input.attr("placeholder", that.options.placeholder);
	            }

	            if (accessKey) {
	                element.accessKey = "";
	                input[0].accessKey = accessKey;
	            }

	            that._focused = that.input = input;
	            that._inputWrapper = $(wrapper[0].firstChild);
	            that._arrow = wrapper.find(".k-select")
	                .attr({
	                    "role": "button",
	                    "tabIndex": -1
	                });
	            that._arrowIcon = that._arrow.find(".k-icon");

	            if (element.id) {
	                that._arrow.attr("aria-controls", that.ul[0].id);
	            }
	        },

	        _clearButton: function() {
	            List.fn._clearButton.call(this);

	            if (this.options.clearButton) {
	                this._clear.insertAfter(this.input);
	                this.wrapper.addClass("k-combobox-clearable");
	            }
	        },

	        _keydown: function(e) {
	            var that = this,
	                key = e.keyCode;

	            that._last = key;

	            clearTimeout(that._typingTimeout);
	            that._typingTimeout = null;

	            if (key === keys.HOME) {
	                that._firstItem();
	            } else if (key === keys.END) {
	                that._lastItem();
	            } else if (key === keys.ENTER || (key === keys.TAB && that.popup.visible())) {
	                var current = that.listView.focus();
	                var dataItem = that.dataItem();
	                var shouldTrigger = true;

	                if (!that.popup.visible() && (!dataItem || that.text() !== that._text(dataItem))) {
	                    current = null;
	                }

	                if (current) {
	                    if (that.popup.visible()) {
	                        e.preventDefault();
	                    }

	                    dataItem = that.listView.dataItemByIndex(that.listView.getElementIndex(current));

	                    if(dataItem){
	                        shouldTrigger = that._value(dataItem) !==  List.unifyType(that.value(), typeof that._value(dataItem));
	                    }

	                    if (shouldTrigger && that.trigger("select", { dataItem: dataItem, item: current })) {
	                        return;
	                    }

	                    that._userTriggered = true;

	                    that._select(current).done(function() {
	                        that._blur();
	                        that._valueBeforeCascade = that._old = that.value();
	                    });
	                } else {
	                    if(that._syncValueAndText() || that._isSelect){
	                        that._accessor(that.input.val());
	                    }

	                    if (that.options.highlightFirst) {
	                        that.listView.value(that.input.val());
	                        that._blur();
	                    } else {
	                        that._oldText = that.text();
	                    }
	                }
	            } else if (key != keys.TAB && !that._move(e)) {
	               that._search();
	            } else if (key === keys.ESC && !that.popup.visible() && that.text()) {
	                that._clearValue();
	            }
	        },

	        _placeholder: function(show) {
	            if (placeholderSupported) {
	                return;
	            }

	            var that = this,
	                input = that.input,
	                placeholder = that.options.placeholder,
	                value;

	            if (placeholder) {
	                value = that.value();

	                if (show === undefined) {
	                    show = !value;
	                }

	                input.toggleClass("k-readonly", show);

	                if (!show) {
	                    if (!value) {
	                        placeholder = "";
	                    } else {
	                        return;
	                    }
	                }

	                input.val(placeholder);

	                if (!placeholder && input[0] === activeElement()) {
	                    caret(input[0], 0, 0);
	                }
	            }
	        },

	        _search: function() {
	            var that = this;

	            clearTimeout(that._typingTimeout);

	            that._typingTimeout = setTimeout(function() {
	                var value = that.text();

	                if (value !== "" && that._prev !== value) {
	                    that._prev = value;

	                    if (that.options.filter === "none" && that.options.virtual) {
	                        that.listView.select(-1);
	                    }

	                    that.search(value);

	                    that._toggleCloseVisibility();
	                }
	                else if (value === "" && that._prev !== "") {
	                    that._clearValue();
	                    that.search("");
	                }

	                that._typingTimeout = null;
	            }, that.options.delay);
	        },

	        _setText: function(text) {
	            this.input.val(text);
	            this._prev = text;
	        },

	        _wrapper: function() {
	            var that = this,
	                element = that.element,
	                wrapper = element.parent();

	            if (!wrapper.is("span.k-widget")) {
	                wrapper = element.hide().wrap("<span />").parent();
	                wrapper[0].style.cssText = element[0].style.cssText;
	            }

	            that.wrapper = wrapper.addClass("k-widget k-combobox")
	                .addClass(element[0].className)
	                .removeClass('input-validation-error')
	                .css("display", "");
	        },

	        _clearSelection: function(parent, isFiltered) {
	            var that = this;
	            var hasValue = parent.value();
	            var custom = hasValue && parent.selectedIndex === -1;

	            if (this.selectedIndex == -1 && this.value()) {
	                return;
	            }

	            if (isFiltered || !hasValue || custom) {
	                that.options.value = "";
	                that.value("");
	            }
	        },

	        _preselect: function(value, text) {
	            this.input.val(text);
	            this._accessor(value);

	            this._old = this._accessor();
	            this._oldIndex = this.selectedIndex;

	            this.listView.setValue(value);
	            this._placeholder();

	            this._initialIndex = null;
	            this._presetValue = true;
	            this._toggleCloseVisibility();
	        },

	        _clearText: function() {
	            this._old = this.value();
	            this.text("");
	        },

	        _clearValue: function() {
	            Select.fn._clearValue.call(this);
	            this.input.focus();
	        }
	    });

	    ui.plugin(ComboBox);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "1pYj":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1334);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1334:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1086) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "notification",
	    name: "Notification",
	    category: "web",
	    description: "The Notification widget displays user alerts.",
	    depends: [ "core", "popup" ],
	    features: [ {
	        id: "notification-fx",
	        name: "Animation",
	        description: "Support for animation",
	        depends: [ "fx" ]
	    } ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        proxy = $.proxy,
	        extend = $.extend,
	        setTimeout = window.setTimeout,
	        CLICK = "click",
	        SHOW = "show",
	        HIDE = "hide",
	        KNOTIFICATION = "k-notification",
	        KICLOSE = ".k-notification-wrap .k-i-close",
	        KHIDING = "k-hiding",
	        INFO = "info",
	        SUCCESS = "success",
	        WARNING = "warning",
	        ERROR = "error",
	        TOP = "top",
	        LEFT = "left",
	        BOTTOM = "bottom",
	        RIGHT = "right",
	        UP = "up",
	        NS = ".kendoNotification",
	        WRAPPER = '<div class="k-widget k-popup k-notification"></div>',
	        TEMPLATE = '<div class="k-notification-wrap">' +
	                '<span class="k-icon k-i-#=typeIcon#" title="#=typeIcon#"></span>' +
	                '<div class="k-notification-content">#=content#</div>' +
	                '<span class="k-icon k-i-close" title="Hide"></span>' +
	            '</div>',
	        SAFE_TEMPLATE = TEMPLATE.replace("#=content#", "#:content#");

	    var Notification = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            options = that.options;

	            if (!options.appendTo || !$(options.appendTo).is(element)) {
	                that.element.hide();
	            }

	            that._compileTemplates(options.templates);
	            that._guid = "_" + kendo.guid();
	            that._isRtl = kendo.support.isRtl(element);
	            that._compileStacking(options.stacking, options.position.top, options.position.left);

	            kendo.notify(that);
	        },

	        events: [
	            SHOW,
	            HIDE
	        ],

	        options: {
	            name: "Notification",
	            position: {
	                pinned: true,
	                top: null,
	                left: null,
	                bottom: 20,
	                right: 20
	            },
	            stacking: "default",
	            hideOnClick: true,
	            button: false,
	            allowHideAfter: 0,
	            autoHideAfter: 5000,
	            appendTo: null,
	            width: null,
	            height: null,
	            templates: [],
	            animation: {
	                open: {
	                    effects: "fade:in",
	                    duration: 300
	                },
	                close: {
	                    effects: "fade:out",
	                    duration: 600,
	                    hide: true
	                }
	            }
	        },

	        _compileTemplates: function(templates) {
	            var that = this;
	            var kendoTemplate = kendo.template;

	            that._compiled = {};

	            $.each(templates, function(key, value) {
	                that._compiled[value.type] = kendoTemplate(value.template || $("#" + value.templateId).html());
	            });

	            that._defaultCompiled = kendoTemplate(TEMPLATE);
	            that._safeCompiled = kendoTemplate(SAFE_TEMPLATE);
	        },

	        _getCompiled: function(type, safe) {
	            var defaultCompiled = safe ? this._safeCompiled : this._defaultCompiled;

	            return type ? this._compiled[type] || defaultCompiled : defaultCompiled;
	        },

	        _compileStacking: function(stacking, top, left) {
	            var that = this,
	                paddings = { paddingTop: 0, paddingRight: 0, paddingBottom: 0, paddingLeft: 0 },
	                horizontalAlignment = left !== null ? LEFT : RIGHT,
	                origin, position;

	            switch (stacking) {
	                case "down":
	                    origin = BOTTOM + " " + horizontalAlignment;
	                    position = TOP + " " + horizontalAlignment;
	                    delete paddings.paddingBottom;
	                break;
	                case RIGHT:
	                    origin = TOP + " " + RIGHT;
	                    position = TOP + " " + LEFT;
	                    delete paddings.paddingRight;
	                break;
	                case LEFT:
	                    origin = TOP + " " + LEFT;
	                    position = TOP + " " + RIGHT;
	                    delete paddings.paddingLeft;
	                break;
	                case UP:
	                    origin = TOP + " " + horizontalAlignment;
	                    position = BOTTOM + " " + horizontalAlignment;
	                    delete paddings.paddingTop;
	                break;
	                default:
	                    if (top !== null) {
	                        origin = BOTTOM + " " + horizontalAlignment;
	                        position = TOP + " " + horizontalAlignment;
	                        delete paddings.paddingBottom;
	                    } else {
	                        origin = TOP + " " + horizontalAlignment;
	                        position = BOTTOM + " " + horizontalAlignment;
	                        delete paddings.paddingTop;
	                    }
	                break;
	            }

	            that._popupOrigin = origin;
	            that._popupPosition = position;
	            that._popupPaddings = paddings;
	        },

	        _attachPopupEvents: function(options, popup) {
	            var that = this,
	                allowHideAfter = options.allowHideAfter,
	                attachDelay = !isNaN(allowHideAfter) && allowHideAfter > 0,
	                closeIcon;

	            function attachClick(target) {
	                target.on(CLICK + NS, function () {
	                    that._hidePopup(popup);
	                });
	            }

	            if (options.hideOnClick) {
	                popup.bind("activate", function() {
	                    if (attachDelay) {
	                        setTimeout(function(){
	                            attachClick(popup.element);
	                        }, allowHideAfter);
	                    } else {
	                        attachClick(popup.element);
	                    }
	                });
	            } else if (options.button) {
	                closeIcon = popup.element.find(KICLOSE);
	                if (attachDelay) {
	                    setTimeout(function(){
	                        attachClick(closeIcon);
	                    }, allowHideAfter);
	                } else {
	                    attachClick(closeIcon);
	                }
	            }
	        },

	        _showPopup: function(wrapper, options) {
	            var that = this,
	                autoHideAfter = options.autoHideAfter,
	                x = options.position.left,
	                y = options.position.top,
	                popup, openPopup;

	            openPopup = $("." + that._guid + ":not(." + KHIDING + ")").last();

	            popup = new kendo.ui.Popup(wrapper, {
	                anchor: openPopup[0] ? openPopup : document.body,
	                origin: that._popupOrigin,
	                position: that._popupPosition,
	                animation: options.animation,
	                copyAnchorStyles: false,
	                modal: true,
	                collision: "",
	                isRtl: that._isRtl,
	                close: function() {
	                    that._triggerHide(this.element);
	                },
	                deactivate: function(e) {
	                    e.sender.element.off(NS);
	                    e.sender.element.find(KICLOSE).off(NS);
	                    e.sender.destroy();
	                }
	            });

	            that._attachPopupEvents(options, popup);

	            wrapper.removeClass("k-group k-reset");

	            if (openPopup[0]) {
	                popup.open();
	            } else {
	                if (x === null) {
	                    x = $(window).width() - wrapper.outerWidth() - options.position.right;
	                }

	                if (y === null) {
	                    y = $(window).height() - wrapper.outerHeight() - options.position.bottom;
	                }

	                popup.open(x, y);
	            }

	            popup.wrapper.addClass(that._guid).css(extend({margin:0,zIndex:10050}, that._popupPaddings));

	            if (options.position.pinned) {
	                popup.wrapper.css("position", "fixed");
	                if (openPopup[0]) {
	                    that._togglePin(popup.wrapper, true);
	                }
	            } else if (!openPopup[0]) {
	                that._togglePin(popup.wrapper, false);
	            }

	            if (autoHideAfter > 0) {
	                setTimeout(function () {
	                    that._hidePopup(popup);
	                }, autoHideAfter);
	            }
	        },

	        _hidePopup: function (popup) {
	            popup.wrapper.addClass(KHIDING);
	            popup.close();
	        },

	        _togglePin: function(wrapper, pin) {
	            var win = $(window),
	                sign = pin ? -1 : 1;

	            wrapper.css({
	                top: parseInt(wrapper.css(TOP), 10) + sign * win.scrollTop(),
	                left: parseInt(wrapper.css(LEFT), 10) + sign * win.scrollLeft()
	            });
	        },

	        _attachStaticEvents: function(options, wrapper) {
	            var that = this,
	                allowHideAfter = options.allowHideAfter,
	                attachDelay = !isNaN(allowHideAfter) && allowHideAfter > 0;

	            function attachClick(target) {
	                target.on(CLICK + NS, proxy(that._hideStatic, that, wrapper));
	            }

	            if (options.hideOnClick) {
	                if (attachDelay) {
	                    setTimeout(function(){
	                        attachClick(wrapper);
	                    }, allowHideAfter);
	                } else {
	                    attachClick(wrapper);
	                }
	            } else if (options.button) {
	                if (attachDelay) {
	                    setTimeout(function(){
	                        attachClick(wrapper.find(KICLOSE));
	                    }, allowHideAfter);
	                } else {
	                    attachClick(wrapper.find(KICLOSE));
	                }
	            }
	        },

	        _showStatic: function(wrapper, options) {
	            var that = this,
	                autoHideAfter = options.autoHideAfter,
	                animation = options.animation,
	                insertionMethod = options.stacking == UP || options.stacking == LEFT ? "prependTo" : "appendTo",
	                initializedNotifications;

	            wrapper
	                .removeClass("k-popup")
	                .addClass(that._guid)
	                [insertionMethod](options.appendTo)
	                .hide()
	                .kendoAnimate(animation.open || false);

	            initializedNotifications = that.getNotifications();
	            initializedNotifications.each(function(idx, element) {
	                that._attachStaticEvents(options, $(element));

	                if (autoHideAfter > 0) {
	                    setTimeout(function(){
	                        that._hideStatic($(element));
	                    }, autoHideAfter);
	                }
	            });
	        },

	        _hideStatic: function(wrapper) {
	            wrapper.kendoAnimate(extend(this.options.animation.close || false, { complete: function() {
	                wrapper.off(NS).find(KICLOSE).off(NS);
	                wrapper.remove();
	            }}));
	            this._triggerHide(wrapper);
	        },

	        _triggerHide: function(element) {
	            this.trigger(HIDE, { element: element });
	            this.angular("cleanup", function(){
	                return { elements: element };
	            });
	        },

	        show: function(content, type, safe) {
	            var that = this,
	                options = that.options,
	                wrapper = $(WRAPPER),
	                args, defaultArgs;

	            if (!type) {
	                type = INFO;
	            }

	            if (content !== null && content !== undefined && content !== "") {

	                if (kendo.isFunction(content)) {
	                    content = content();
	                }

	                defaultArgs = {typeIcon: type, content: ""};

	                if ($.isPlainObject(content)) {
	                    args = extend(defaultArgs, content);
	                } else {
	                    args = extend(defaultArgs, {content: content});
	                }

	                wrapper
	                    .addClass(KNOTIFICATION + "-" + type)
	                    .toggleClass(KNOTIFICATION + "-button", options.button)
	                    .toggleClass(KNOTIFICATION + "-closable", options.button)
	                    .attr("data-role", "alert")
	                    .css({width: options.width, height: options.height})
	                    .append(that._getCompiled(type, safe)(args));

	                that.angular("compile", function(){
	                    return {
	                        elements: wrapper,
	                        data: [{ dataItem: args }]
	                    };
	                });

	                if ($(options.appendTo)[0]) {
	                    that._showStatic(wrapper, options);
	                } else {
	                    that._showPopup(wrapper, options);
	                }

	                that.trigger(SHOW, {element: wrapper});
	            }

	            return that;
	        },

	        showText: function(content, type) {
	            this.show(content, type, true);
	        },

	        info: function(content) {
	            return this.show(content, INFO);
	        },

	        success: function(content) {
	            return this.show(content, SUCCESS);
	        },

	        warning: function(content) {
	            return this.show(content, WARNING);
	        },

	        error: function(content) {
	            return this.show(content, ERROR);
	        },

	        hide: function() {
	            var that = this,
	                openedNotifications = that.getNotifications();

	            if (that.options.appendTo) {
	                openedNotifications.each(function(idx, element){
	                    that._hideStatic($(element));
	                });
	            } else {
	                openedNotifications.each(function(idx, element){
	                    var popup = $(element).data("kendoPopup");
	                    if (popup) {
	                        that._hidePopup(popup);
	                    }
	                });
	            }

	            return that;
	        },

	        getNotifications: function() {
	            var that = this,
	                guidElements = $("." + that._guid + ":not(." + KHIDING + ")");

	            if (that.options.appendTo) {
	                return guidElements;
	            } else {
	                return guidElements.children("." + KNOTIFICATION);
	            }
	        },

	        setOptions: function(newOptions) {
	            var that = this,
	                options;

	            Widget.fn.setOptions.call(that, newOptions);

	            options = that.options;

	            if (newOptions.templates !== undefined) {
	                that._compileTemplates(options.templates);
	            }

	            if (newOptions.stacking !== undefined || newOptions.position !== undefined) {
	                that._compileStacking(options.stacking, options.position.top, options.position.left);
	            }
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            this.getNotifications().off(NS).find(KICLOSE).off(NS);
	        }
	    });

	    kendo.ui.plugin(Notification);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "21It":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("FtD3");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "2Le/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var constants_1 = __webpack_require__("ZZFX");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var columnApi_1 = __webpack_require__("E/Wy");
var columnController_1 = __webpack_require__("77lH");
var filterManager_1 = __webpack_require__("Up6z");
var rowNode_1 = __webpack_require__("bP2e");
var eventService_1 = __webpack_require__("k5uU");
var events_1 = __webpack_require__("3ok8");
var context_1 = __webpack_require__("RQ1/");
var selectionController_1 = __webpack_require__("D4cr");
var inMemoryNodeManager_1 = __webpack_require__("mhUy");
var changedPath_1 = __webpack_require__("ODdY");
var valueService_1 = __webpack_require__("5JVC");
var valueCache_1 = __webpack_require__("uKqK");
var gridApi_1 = __webpack_require__("BAow");
var RecursionType;
(function (RecursionType) {
    RecursionType[RecursionType["Normal"] = 0] = "Normal";
    RecursionType[RecursionType["AfterFilter"] = 1] = "AfterFilter";
    RecursionType[RecursionType["AfterFilterAndSort"] = 2] = "AfterFilterAndSort";
    RecursionType[RecursionType["PivotNodes"] = 3] = "PivotNodes";
})(RecursionType || (RecursionType = {}));
;
var InMemoryRowModel = (function () {
    function InMemoryRowModel() {
    }
    InMemoryRowModel.prototype.init = function () {
        var refreshEverythingFunc = this.refreshModel.bind(this, { step: constants_1.Constants.STEP_EVERYTHING });
        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, refreshEverythingFunc);
        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, refreshEverythingFunc);
        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.onValueChanged.bind(this));
        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_PIVOT_CHANGED, this.refreshModel.bind(this, { step: constants_1.Constants.STEP_PIVOT }));
        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_ROW_GROUP_OPENED, this.onRowGroupOpened.bind(this));
        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, refreshEverythingFunc);
        var refreshMapFunc = this.refreshModel.bind(this, { step: constants_1.Constants.STEP_MAP, keepRenderedRows: true, animate: true });
        this.gridOptionsWrapper.addEventListener(gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_REMOVE_SINGLE_CHILDREN, refreshMapFunc);
        this.gridOptionsWrapper.addEventListener(gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_REMOVE_LOWEST_SINGLE_CHILDREN, refreshMapFunc);
        this.rootNode = new rowNode_1.RowNode();
        this.nodeManager = new inMemoryNodeManager_1.InMemoryNodeManager(this.rootNode, this.gridOptionsWrapper, this.context, this.eventService, this.columnController);
        this.context.wireBean(this.rootNode);
    };
    // returns false if row was moved, otherwise true
    InMemoryRowModel.prototype.ensureRowAtPixel = function (rowNode, pixel) {
        var indexAtPixelNow = this.getRowIndexAtPixel(pixel);
        var rowNodeAtPixelNow = this.getRow(indexAtPixelNow);
        if (rowNodeAtPixelNow === rowNode) {
            return false;
        }
        utils_1.Utils.removeFromArray(this.rootNode.allLeafChildren, rowNode);
        utils_1.Utils.insertIntoArray(this.rootNode.allLeafChildren, rowNode, indexAtPixelNow);
        this.refreshModel({ step: constants_1.Constants.STEP_EVERYTHING, keepRenderedRows: true, animate: true, keepEditingRows: true });
        return true;
    };
    InMemoryRowModel.prototype.isLastRowFound = function () {
        return true;
    };
    InMemoryRowModel.prototype.getRowCount = function () {
        if (this.rowsToDisplay) {
            return this.rowsToDisplay.length;
        }
        else {
            return 0;
        }
    };
    InMemoryRowModel.prototype.getRowBounds = function (index) {
        if (utils_1.Utils.missing(this.rowsToDisplay)) {
            return null;
        }
        var rowNode = this.rowsToDisplay[index];
        if (rowNode) {
            return {
                rowTop: rowNode.rowTop,
                rowHeight: rowNode.rowHeight
            };
        }
        else {
            return null;
        }
    };
    InMemoryRowModel.prototype.onRowGroupOpened = function () {
        var animate = this.gridOptionsWrapper.isAnimateRows();
        this.refreshModel({ step: constants_1.Constants.STEP_MAP, keepRenderedRows: true, animate: animate });
    };
    InMemoryRowModel.prototype.onFilterChanged = function () {
        var animate = this.gridOptionsWrapper.isAnimateRows();
        this.refreshModel({ step: constants_1.Constants.STEP_FILTER, keepRenderedRows: true, animate: animate });
    };
    InMemoryRowModel.prototype.onSortChanged = function () {
        // we only act on the sort event here if the user is doing in grid sorting.
        // we ignore it if the sorting is happening on the server side.
        if (this.gridOptionsWrapper.isEnableServerSideSorting()) {
            return;
        }
        var animate = this.gridOptionsWrapper.isAnimateRows();
        this.refreshModel({ step: constants_1.Constants.STEP_SORT, keepRenderedRows: true, animate: animate, keepEditingRows: true });
    };
    InMemoryRowModel.prototype.getType = function () {
        return constants_1.Constants.ROW_MODEL_TYPE_IN_MEMORY;
    };
    InMemoryRowModel.prototype.onValueChanged = function () {
        if (this.columnController.isPivotActive()) {
            this.refreshModel({ step: constants_1.Constants.STEP_PIVOT });
        }
        else {
            this.refreshModel({ step: constants_1.Constants.STEP_AGGREGATE });
        }
    };
    InMemoryRowModel.prototype.createChangePath = function (transaction) {
        if (!transaction) {
            return null;
        }
        // for updates, if the row is updated at all, then we re-calc all the values
        // in that row. we could compare each value to each old value, however if we
        // did this, we would be calling the valueService twice, once on the old value
        // and once on the new value. so it's less valueGetter calls if we just assume
        // each column is different. that way the changedPath is used so that only
        // the impacted parent rows are recalculated, parents who's children have
        // not changed are not impacted.
        var valueColumns = this.columnController.getValueColumns();
        if (!valueColumns || valueColumns.length === 0) {
            return null;
        }
        var changedPath = new changedPath_1.ChangedPath(false);
        return changedPath;
    };
    InMemoryRowModel.prototype.refreshModel = function (params) {
        // this goes through the pipeline of stages. what's in my head is similar
        // to the diagram on this page:
        // http://commons.apache.org/sandbox/commons-pipeline/pipeline_basics.html
        // however we want to keep the results of each stage, hence we manually call
        // each step rather than have them chain each other.
        var _this = this;
        // fallthrough in below switch is on purpose,
        // eg if STEP_FILTER, then all steps below this
        // step get done
        // let start: number;
        // console.log('======= start =======');
        var changedPath = this.createChangePath(params.rowNodeTransaction);
        switch (params.step) {
            case constants_1.Constants.STEP_EVERYTHING:
                // start = new Date().getTime();
                this.doRowGrouping(params.groupState, params.rowNodeTransaction, params.rowNodeOrder, changedPath);
            // console.log('rowGrouping = ' + (new Date().getTime() - start));
            case constants_1.Constants.STEP_FILTER:
                // start = new Date().getTime();
                this.doFilter();
            // console.log('filter = ' + (new Date().getTime() - start));
            case constants_1.Constants.STEP_PIVOT:
                this.doPivot();
            case constants_1.Constants.STEP_AGGREGATE:// depends on agg fields
                // start = new Date().getTime();
                this.doAggregate(changedPath);
            // console.log('aggregation = ' + (new Date().getTime() - start));
            case constants_1.Constants.STEP_SORT:
                // start = new Date().getTime();
                this.doSort();
            // console.log('sort = ' + (new Date().getTime() - start));
            case constants_1.Constants.STEP_MAP:
                // start = new Date().getTime();
                this.doRowsToDisplay();
        }
        var event = {
            type: events_1.Events.EVENT_MODEL_UPDATED,
            api: this.gridApi,
            columnApi: this.columnApi,
            animate: params.animate,
            keepRenderedRows: params.keepRenderedRows,
            newData: params.newData,
            newPage: false
        };
        this.eventService.dispatchEvent(event);
        if (this.$scope) {
            setTimeout(function () {
                _this.$scope.$apply();
            }, 0);
        }
    };
    InMemoryRowModel.prototype.isEmpty = function () {
        var rowsMissing;
        var doingLegacyTreeData = utils_1.Utils.exists(this.gridOptionsWrapper.getNodeChildDetailsFunc());
        if (doingLegacyTreeData) {
            rowsMissing = utils_1.Utils.missing(this.rootNode.childrenAfterGroup) || this.rootNode.childrenAfterGroup.length === 0;
        }
        else {
            rowsMissing = utils_1.Utils.missing(this.rootNode.allLeafChildren) || this.rootNode.allLeafChildren.length === 0;
        }
        var empty = utils_1.Utils.missing(this.rootNode) || rowsMissing || !this.columnController.isReady();
        return empty;
    };
    InMemoryRowModel.prototype.isRowsToRender = function () {
        return utils_1.Utils.exists(this.rowsToDisplay) && this.rowsToDisplay.length > 0;
    };
    InMemoryRowModel.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
        // if lastSelectedNode is missing, we start at the first row
        var firstRowHit = !lastInRange;
        var lastRowHit = false;
        var lastRow;
        var result = [];
        var groupsSelectChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
        this.forEachNodeAfterFilterAndSort(function (rowNode) {
            var lookingForLastRow = firstRowHit && !lastRowHit;
            // check if we need to flip the select switch
            if (!firstRowHit) {
                if (rowNode === lastInRange || rowNode === firstInRange) {
                    firstRowHit = true;
                }
            }
            var skipThisGroupNode = rowNode.group && groupsSelectChildren;
            if (!skipThisGroupNode) {
                var inRange = firstRowHit && !lastRowHit;
                var childOfLastRow = rowNode.isParentOfNode(lastRow);
                if (inRange || childOfLastRow) {
                    result.push(rowNode);
                }
            }
            if (lookingForLastRow) {
                if (rowNode === lastInRange || rowNode === firstInRange) {
                    lastRowHit = true;
                    if (rowNode === lastInRange) {
                        lastRow = lastInRange;
                    }
                    else {
                        lastRow = firstInRange;
                    }
                }
            }
        });
        return result;
    };
    InMemoryRowModel.prototype.setDatasource = function (datasource) {
        console.error('ag-Grid: should never call setDatasource on inMemoryRowController');
    };
    InMemoryRowModel.prototype.getTopLevelNodes = function () {
        return this.rootNode ? this.rootNode.childrenAfterGroup : null;
    };
    InMemoryRowModel.prototype.getRootNode = function () {
        return this.rootNode;
    };
    InMemoryRowModel.prototype.getRow = function (index) {
        return this.rowsToDisplay[index];
    };
    InMemoryRowModel.prototype.isRowPresent = function (rowNode) {
        return this.rowsToDisplay.indexOf(rowNode) >= 0;
    };
    InMemoryRowModel.prototype.getVirtualRowCount = function () {
        console.warn('ag-Grid: rowModel.getVirtualRowCount() is not longer a function, use rowModel.getRowCount() instead');
        return this.getPageLastRow();
    };
    InMemoryRowModel.prototype.getPageFirstRow = function () {
        return 0;
    };
    InMemoryRowModel.prototype.getPageLastRow = function () {
        if (this.rowsToDisplay) {
            return this.rowsToDisplay.length - 1;
        }
        else {
            return 0;
        }
    };
    InMemoryRowModel.prototype.getRowIndexAtPixel = function (pixelToMatch) {
        if (this.isEmpty()) {
            return -1;
        }
        // do binary search of tree
        // http://oli.me.uk/2013/06/08/searching-javascript-arrays-with-a-binary-search/
        var bottomPointer = 0;
        var topPointer = this.rowsToDisplay.length - 1;
        // quick check, if the pixel is out of bounds, then return last row
        if (pixelToMatch <= 0) {
            // if pixel is less than or equal zero, it's always the first row
            return 0;
        }
        var lastNode = this.rowsToDisplay[this.rowsToDisplay.length - 1];
        if (lastNode.rowTop <= pixelToMatch) {
            return this.rowsToDisplay.length - 1;
        }
        while (true) {
            var midPointer = Math.floor((bottomPointer + topPointer) / 2);
            var currentRowNode = this.rowsToDisplay[midPointer];
            if (this.isRowInPixel(currentRowNode, pixelToMatch)) {
                return midPointer;
            }
            else if (currentRowNode.rowTop < pixelToMatch) {
                bottomPointer = midPointer + 1;
            }
            else if (currentRowNode.rowTop > pixelToMatch) {
                topPointer = midPointer - 1;
            }
        }
    };
    InMemoryRowModel.prototype.isRowInPixel = function (rowNode, pixelToMatch) {
        var topPixel = rowNode.rowTop;
        var bottomPixel = rowNode.rowTop + rowNode.rowHeight;
        var pixelInRow = topPixel <= pixelToMatch && bottomPixel > pixelToMatch;
        return pixelInRow;
    };
    InMemoryRowModel.prototype.getCurrentPageHeight = function () {
        if (this.rowsToDisplay && this.rowsToDisplay.length > 0) {
            var lastRow = this.rowsToDisplay[this.rowsToDisplay.length - 1];
            var lastPixel = lastRow.rowTop + lastRow.rowHeight;
            return lastPixel;
        }
        else {
            return 0;
        }
    };
    InMemoryRowModel.prototype.forEachLeafNode = function (callback) {
        if (this.rootNode.allLeafChildren) {
            this.rootNode.allLeafChildren.forEach(function (rowNode, index) { return callback(rowNode, index); });
        }
    };
    InMemoryRowModel.prototype.forEachNode = function (callback) {
        this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterGroup, callback, RecursionType.Normal, 0);
    };
    InMemoryRowModel.prototype.forEachNodeAfterFilter = function (callback) {
        this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterFilter, callback, RecursionType.AfterFilter, 0);
    };
    InMemoryRowModel.prototype.forEachNodeAfterFilterAndSort = function (callback) {
        this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterSort, callback, RecursionType.AfterFilterAndSort, 0);
    };
    InMemoryRowModel.prototype.forEachPivotNode = function (callback) {
        this.recursivelyWalkNodesAndCallback([this.rootNode], callback, RecursionType.PivotNodes, 0);
    };
    // iterates through each item in memory, and calls the callback function
    // nodes - the rowNodes to traverse
    // callback - the user provided callback
    // recursion type - need this to know what child nodes to recurse, eg if looking at all nodes, or filtered notes etc
    // index - works similar to the index in forEach in javascripts array function
    InMemoryRowModel.prototype.recursivelyWalkNodesAndCallback = function (nodes, callback, recursionType, index) {
        if (nodes) {
            for (var i = 0; i < nodes.length; i++) {
                var node = nodes[i];
                callback(node, index++);
                // go to the next level if it is a group
                if (node.hasChildren()) {
                    // depending on the recursion type, we pick a difference set of children
                    var nodeChildren = void 0;
                    switch (recursionType) {
                        case RecursionType.Normal:
                            nodeChildren = node.childrenAfterGroup;
                            break;
                        case RecursionType.AfterFilter:
                            nodeChildren = node.childrenAfterFilter;
                            break;
                        case RecursionType.AfterFilterAndSort:
                            nodeChildren = node.childrenAfterSort;
                            break;
                        case RecursionType.PivotNodes:
                            // for pivot, we don't go below leafGroup levels
                            nodeChildren = !node.leafGroup ? node.childrenAfterSort : null;
                            break;
                    }
                    if (nodeChildren) {
                        index = this.recursivelyWalkNodesAndCallback(nodeChildren, callback, recursionType, index);
                    }
                }
            }
        }
        return index;
    };
    // it's possible to recompute the aggregate without doing the other parts
    // + gridApi.recomputeAggregates()
    InMemoryRowModel.prototype.doAggregate = function (changedPath) {
        if (this.aggregationStage) {
            this.aggregationStage.execute({ rowNode: this.rootNode, changedPath: changedPath });
        }
    };
    // + gridApi.expandAll()
    // + gridApi.collapseAll()
    InMemoryRowModel.prototype.expandOrCollapseAll = function (expand) {
        if (this.rootNode) {
            recursiveExpandOrCollapse(this.rootNode.childrenAfterGroup);
        }
        function recursiveExpandOrCollapse(rowNodes) {
            if (!rowNodes) {
                return;
            }
            rowNodes.forEach(function (rowNode) {
                if (rowNode.group) {
                    rowNode.expanded = expand;
                    recursiveExpandOrCollapse(rowNode.childrenAfterGroup);
                }
            });
        }
        this.refreshModel({ step: constants_1.Constants.STEP_MAP });
    };
    InMemoryRowModel.prototype.doSort = function () {
        this.sortStage.execute({ rowNode: this.rootNode });
    };
    InMemoryRowModel.prototype.doRowGrouping = function (groupState, rowNodeTransaction, rowNodeOrder, changedPath) {
        // grouping is enterprise only, so if service missing, skip the step
        var doingLegacyTreeData = utils_1.Utils.exists(this.gridOptionsWrapper.getNodeChildDetailsFunc());
        if (doingLegacyTreeData) {
            return;
        }
        if (this.groupStage) {
            if (rowNodeTransaction) {
                this.groupStage.execute({ rowNode: this.rootNode,
                    rowNodeTransaction: rowNodeTransaction,
                    rowNodeOrder: rowNodeOrder,
                    changedPath: changedPath });
            }
            else {
                // groups are about to get disposed, so need to deselect any that are selected
                this.selectionController.removeGroupsFromSelection();
                this.groupStage.execute({ rowNode: this.rootNode });
                // set open/closed state on groups
                this.restoreGroupState(groupState);
            }
            if (this.gridOptionsWrapper.isGroupSelectsChildren()) {
                this.selectionController.updateGroupsFromChildrenSelections();
            }
        }
        else {
            this.rootNode.childrenAfterGroup = this.rootNode.allLeafChildren;
        }
    };
    InMemoryRowModel.prototype.restoreGroupState = function (groupState) {
        if (!groupState) {
            return;
        }
        utils_1.Utils.traverseNodesWithKey(this.rootNode.childrenAfterGroup, function (node, key) {
            // if the group was open last time, then open it this time. however
            // if was not open last time, then don't touch the group, so the 'groupDefaultExpanded'
            // setting will take effect.
            if (typeof groupState[key] === 'boolean') {
                node.expanded = groupState[key];
            }
        });
    };
    InMemoryRowModel.prototype.doFilter = function () {
        this.filterStage.execute({ rowNode: this.rootNode });
    };
    InMemoryRowModel.prototype.doPivot = function () {
        if (this.pivotStage) {
            this.pivotStage.execute({ rowNode: this.rootNode });
        }
    };
    InMemoryRowModel.prototype.getGroupState = function () {
        if (!this.rootNode.childrenAfterGroup || !this.gridOptionsWrapper.isRememberGroupStateWhenNewData()) {
            return null;
        }
        var result = {};
        utils_1.Utils.traverseNodesWithKey(this.rootNode.childrenAfterGroup, function (node, key) { return result[key] = node.expanded; });
        return result;
    };
    InMemoryRowModel.prototype.getCopyOfNodesMap = function () {
        return this.nodeManager.getCopyOfNodesMap();
    };
    InMemoryRowModel.prototype.getRowNode = function (id) {
        return this.nodeManager.getRowNode(id);
    };
    // rows: the rows to put into the model
    InMemoryRowModel.prototype.setRowData = function (rowData) {
        // no need to invalidate cache, as the cache is stored on the rowNode,
        // so new rowNodes means the cache is wiped anyway.
        // remember group state, so we can expand groups that should be expanded
        var groupState = this.getGroupState();
        this.nodeManager.setRowData(rowData);
        // this event kicks off:
        // - clears selection
        // - updates filters
        // - shows 'no rows' overlay if needed
        var rowDataChangedEvent = {
            type: events_1.Events.EVENT_ROW_DATA_CHANGED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(rowDataChangedEvent);
        this.refreshModel({
            step: constants_1.Constants.STEP_EVERYTHING,
            groupState: groupState,
            newData: true
        });
    };
    InMemoryRowModel.prototype.updateRowData = function (rowDataTran, rowNodeOrder) {
        this.valueCache.onDataChanged();
        var rowNodeTran = this.nodeManager.updateRowData(rowDataTran, rowNodeOrder);
        this.refreshModel({
            step: constants_1.Constants.STEP_EVERYTHING,
            rowNodeTransaction: rowNodeTran,
            rowNodeOrder: rowNodeOrder,
            keepRenderedRows: true,
            animate: true,
            keepEditingRows: true
        });
        var event = {
            type: events_1.Events.EVENT_ROW_DATA_UPDATED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(event);
        return rowNodeTran;
    };
    InMemoryRowModel.prototype.doRowsToDisplay = function () {
        this.rowsToDisplay = this.flattenStage.execute({ rowNode: this.rootNode });
    };
    InMemoryRowModel.prototype.onRowHeightChanged = function () {
        this.refreshModel({ step: constants_1.Constants.STEP_MAP, keepRenderedRows: true, keepEditingRows: true });
    };
    InMemoryRowModel.prototype.resetRowHeights = function () {
        this.forEachNode(function (rowNode) { return rowNode.setRowHeight(null); });
        this.onRowHeightChanged();
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], InMemoryRowModel.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], InMemoryRowModel.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('filterManager'),
        __metadata("design:type", filterManager_1.FilterManager)
    ], InMemoryRowModel.prototype, "filterManager", void 0);
    __decorate([
        context_1.Autowired('$scope'),
        __metadata("design:type", Object)
    ], InMemoryRowModel.prototype, "$scope", void 0);
    __decorate([
        context_1.Autowired('selectionController'),
        __metadata("design:type", selectionController_1.SelectionController)
    ], InMemoryRowModel.prototype, "selectionController", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], InMemoryRowModel.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], InMemoryRowModel.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('valueService'),
        __metadata("design:type", valueService_1.ValueService)
    ], InMemoryRowModel.prototype, "valueService", void 0);
    __decorate([
        context_1.Autowired('valueCache'),
        __metadata("design:type", valueCache_1.ValueCache)
    ], InMemoryRowModel.prototype, "valueCache", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], InMemoryRowModel.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], InMemoryRowModel.prototype, "gridApi", void 0);
    __decorate([
        context_1.Autowired('filterStage'),
        __metadata("design:type", Object)
    ], InMemoryRowModel.prototype, "filterStage", void 0);
    __decorate([
        context_1.Autowired('sortStage'),
        __metadata("design:type", Object)
    ], InMemoryRowModel.prototype, "sortStage", void 0);
    __decorate([
        context_1.Autowired('flattenStage'),
        __metadata("design:type", Object)
    ], InMemoryRowModel.prototype, "flattenStage", void 0);
    __decorate([
        context_1.Optional('groupStage'),
        __metadata("design:type", Object)
    ], InMemoryRowModel.prototype, "groupStage", void 0);
    __decorate([
        context_1.Optional('aggregationStage'),
        __metadata("design:type", Object)
    ], InMemoryRowModel.prototype, "aggregationStage", void 0);
    __decorate([
        context_1.Optional('pivotStage'),
        __metadata("design:type", Object)
    ], InMemoryRowModel.prototype, "pivotStage", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], InMemoryRowModel.prototype, "init", null);
    InMemoryRowModel = __decorate([
        context_1.Bean('rowModel')
    ], InMemoryRowModel);
    return InMemoryRowModel;
}());
exports.InMemoryRowModel = InMemoryRowModel;


/***/ }),

/***/ "2Mfy":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1423);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1277:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("SDgz");

/***/ }),

/***/ 1423:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1277) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "stepper",
	    name: "Stepper",
	    category: "web",
	    description: "The Stepper widget displays navigation steps.",
	    depends: [ "core", "progressbar" ]
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        keys = kendo.keys,
	        extend = $.extend,
	        proxy = $.proxy,

	        STEPPER = ".kendoStepper",

	        CLICK = "click",
	        ACTIVATE = "activate",
	        SELECT = "select",
	        KEYDOWN = "keydown",
	        FOCUSOUT = "focusout",

	        DOT = ".",
	        SPACE = " ",
	        VERTICAL = "vertical",
	        TABINDEX = "tabindex",

	        ARIA_CURRENT = "aria-current",
	        ARIA_DISABLED = "aria-disabled",
	        ARIA_INVALID = "aria-invalid",
	        ARIA_HIDDEN = "aria-hidden";

	    var stepStyles = {
	        step: "k-step",
	        firstStep: "k-step-first",
	        lastStep: "k-step-last",
	        doneStep: "k-step-done",
	        successStep: "k-step-success",
	        errorStep: "k-step-error",
	        currentStep: "k-step-current",
	        focusStep: "k-step-focus",
	        disabledStep: "k-step-disabled",
	        stepLink: "k-step-link",
	        stepIndicator: "k-step-indicator",
	        stepLabel: "k-step-label"
	    };

	    var stepperStyles = {
	        widget: "k-widget k-stepper",
	        stepperLinear: "k-stepper-linear",
	        stepList: "k-step-list",
	        stepListHorizontal: "k-step-list-horizontal",
	        stepListVertical: "k-step-list-vertical"
	    };

	    var Step = kendo.Class.extend({
	        init: function(options) {
	            this.options = extend({}, this.options, options);
	            this._render();
	        },

	        options: {
	            label: "",
	            icon: "",
	            successIcon: "",
	            iconTemplate: "",
	            enabled: true,
	            error: false,
	            selected: false,
	            isFirstStep: false,
	            isLastStep: false,
	            indicatorVisible: true,
	            labelVisible: true,
	            index: 0,
	            previous: false,
	            selectable: true
	        },

	        _indicatorTemplate: '<span class="k-step-indicator" aria-hidden="true">' +
	            '#if(successIcon && previous && !error) {#' +
	                '<span class="k-step-indicator-icon k-icon k-i-#: successIcon #"></span>' +
	            '#} else if(icon) {#' +
	                '<span class="k-step-indicator-icon k-icon k-i-#: icon #"></span>' +
	            '#} else if(previous && !error) {#' +
	                '<span class="k-step-indicator-icon k-icon k-i-check"></span>' +
	            '#} else {#' +
	                '<span class="k-step-indicator-text">#: index + 1 #</span>' +
	            '#}#' +
	        '</span>',

	        _labelTemplate: '<span class="k-step-label">' +
	            '<span class="k-step-text">' +
	                '#: label #' +
	            '</span>' +
	            ' ' +
	            '#if(error || (!indicatorVisible && !error && previous)) {#' +
	                '<span class="k-icon' +
	                    '#if(previous && !error){# k-i-check#}#' +
	                    '#if(error){# k-i-warning#}#' +
	                '" aria-hidden="true"></span>' +
	            '#}#' +
	        '</span>',

	        deselect: function() {
	            this.options.selected = false;
	            this._link();
	            this._stepClasses();
	        },

	        enable: function(value) {
	            if(this.options.enabled !== value) {
	                this.options.enabled = value;
	                this.options.selectable = value;
	                this._link();
	                this._stepClasses();
	            }
	        },

	        select: function() {
	            this.options.selected = true;
	            this._link();
	            this._stepClasses();
	        },

	        getEnabled: function() {
	            return this.options.enabled;
	        },

	        getIndex: function() {
	            return this.options.index;
	        },

	        setPrevious: function(previous) {
	            this.options.previous = previous;
	            this._link();
	            this._stepClasses();
	        },

	        getSelectable: function() {
	            return this.options.selectable;
	        },

	        getSelected: function() {
	            return this.options.selected;
	        },

	        setValid: function(valid) {
	            if(this.options.error === valid) {
	                this.options.error = !valid;
	                this._link();
	                this._stepClasses();
	            }
	        },

	        _indicator: function() {
	            var options = this.options,
	                stepIndicator;

	            if(!!options.iconTemplate) {
	                stepIndicator = $("<span>").addClass(stepStyles.stepIndicator).attr(ARIA_HIDDEN, "true");
	                stepIndicator.append(kendo.template(options.iconTemplate)(options));
	            } else {
	                stepIndicator = kendo.template(this._indicatorTemplate)(options);
	            }

	            this.element.find(DOT + stepStyles.stepLink).append(stepIndicator);
	        },

	        _label: function() {
	            var stepLabel = kendo.template(this._labelTemplate)(this.options);
	            this.element.find(DOT + stepStyles.stepLink).append(stepLabel);
	        },

	        _link: function() {
	            var options = this.options;

	            this.element.find(DOT + stepStyles.stepLink).empty();
	            this._linkAttributes();

	            if(options.indicatorVisible) {
	                this._indicator();
	            }
	            if(options.labelVisible) {
	                this._label();
	            }
	        },

	        _linkAttributes: function() {
	            var options = this.options,
	                link = this.element.find(DOT + stepStyles.stepLink);

	            link.removeAttr(ARIA_DISABLED + SPACE + ARIA_INVALID + SPACE + ARIA_CURRENT + SPACE + TABINDEX);

	            if(!options.selected) {
	                link.attr(TABINDEX, "-1");
	            } else {
	                link.attr(ARIA_CURRENT, "true");
	            }
	            if(!options.enabled || !options.selectable) {
	                link.attr(ARIA_DISABLED, "true");
	            }
	            if(options.error) {
	                link.attr(ARIA_INVALID, "true");
	            }
	        },

	        _render: function() {
	            var stepLink = $("<a href='#'>").addClass(stepStyles.stepLink).attr("title", this.options.label);

	            this.element = $("<li>").append(stepLink);

	            this._link();
	            this._stepClasses();
	        },

	        _stepClasses: function() {
	            var options = this.options,
	                stepClasses = stepStyles.step;

	            if(options.isFirstStep){
	                stepClasses += (SPACE + stepStyles.firstStep);
	            }
	            if(options.isLastStep){
	                stepClasses += (SPACE + stepStyles.lastStep);
	            }
	            if(!options.enabled){
	                stepClasses += (SPACE + stepStyles.disabledStep);
	            }
	            if(options.error){
	                stepClasses += (SPACE + stepStyles.errorStep);
	            }
	            if(options.previous){
	                stepClasses += (SPACE + stepStyles.doneStep);
	                if(!options.error) {
	                    stepClasses += (SPACE + stepStyles.successStep);
	                }
	            } else if(options.selected) {
	                stepClasses += (SPACE + stepStyles.currentStep);
	                stepClasses += (SPACE + stepStyles.focusStep);
	            }

	            this.element.removeClass().addClass(stepClasses);
	        }
	    });

	    var Stepper = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            options = options || {};

	            Widget.fn.init.call(that, element, options);

	            that._indicatorAndLabel();

	            that._wrapper();

	            if (options.steps && options.steps.length) {
	                that._processSteps(options.steps);
	                that._progressBar();
	            }

	            that._attachEvents();

	            that._resizeHandler = kendo.onResize(function() {
	                that.resize();
	            });
	        },

	        options: {
	            orientation: "horizontal",
	            linear: true,
	            indicator: true,
	            label: true,
	            selectOnFocus: false,
	            steps: null,
	            name: "Stepper"
	        },

	        events: [ ACTIVATE, SELECT, "kendoKeydown" ],

	        destroy: function() {
	            var that = this;

	            if(that.progressBar) {
	                Widget.fn.destroy.call(that.progressBar);
	            }

	            Widget.fn.destroy.call(that);

	            kendo.unbindResize(that._resizeHandler);

	            that.wrapper.off(STEPPER);
	        },

	        setOptions: function(options) {
	            var that = this;

	            Widget.fn.setOptions.call(that, options);

	            if(that.progressBar) {
	                Widget.fn.destroy.call(that.progressBar);
	            }

	            that._indicatorAndLabel();

	            that._addStepList();

	            if (that.options.steps && that.options.steps.length) {
	                that._processSteps(that.options.steps);
	                that._progressBar();
	            }
	        },

	        enable: function(value) {
	            var steps = this.steps(),
	                stepsOptions = this.options.steps;

	            var enableStep = function(step, idx) {
	                step.enable(value);
	                stepsOptions[idx] = step.options;
	            };

	            if(value) {
	                this.wrapper.removeAttr(ARIA_DISABLED);
	            } else {
	                this.wrapper.attr(ARIA_DISABLED, "true");
	            }

	            this.progressBar.enable(value);

	            steps.forEach(enableStep);
	        },

	        insertAt: function(index, stepOptions) {
	            var steps = this.options.steps,
	                selectedStep;
	            var findSelectedStep = function(step) {
	                if(step.selected) {
	                    selectedStep = step;
	                }
	            };

	            if(!stepOptions || isNaN(index)) {
	                return;
	            }
	            if(index < 0) {
	                index = steps.length + index;
	            }
	            if(index < 0) {
	                return;
	            }
	            if(!steps) {
	                steps = [];
	            }

	            if(steps.length === 0 || index >= steps.length) {
	                index = steps.length;
	            }

	            steps.forEach(findSelectedStep);

	            if(stepOptions.selected === true) {
	                selectedStep.selected = false;
	            }

	            steps.splice(index, 0, stepOptions);

	            this._createSteps();
	            this._renderSteps();
	            this._resetProgressBar();
	            this._calculateDimensions();
	        },

	        next: function() {
	            if(!this._steps || this._steps.length <= 1) {
	                return;
	            }

	            var selectedStep = this.selectedStep;
	            var selectedIndex = selectedStep.getIndex();

	            if(selectedIndex + 1 === this._steps.length) {
	                return;
	            } else {
	                this._select(selectedIndex + 1);
	            }
	        },

	        previous: function() {
	            if(!this._steps || this._steps.length <= 1) {
	                return;
	            }

	            var selectedStep = this.selectedStep;
	            var selectedIndex = selectedStep.getIndex();

	            if(selectedIndex === 0) {
	                return;
	            } else {
	                this._select(selectedIndex - 1);
	            }
	        },

	        removeAt: function(index) {
	            var steps = this.options.steps,
	                removedStep, newSelected, newSelectedIndex;

	            if(isNaN(index) || !steps || steps.length < 2 || index >= steps.length) {
	                return;
	            }
	            if(index < 0) {
	                index = steps.length + index;
	            }
	            if(index < 0) {
	                return;
	            }

	            removedStep = steps.splice(index, 1)[0];

	            if(removedStep.selected === true && steps.length > 0) {
	                if(index > 0) {
	                    newSelectedIndex = index - 1;
	                } else {
	                    newSelectedIndex = 0;
	                }

	                newSelected = steps[newSelectedIndex];

	                if(typeof newSelected === "string") {
	                    newSelected = {
	                        label: newSelected
	                    };
	                    steps[newSelectedIndex] = newSelected;
	                }

	                newSelected.selected = true;
	                newSelected.previous = false;
	            }

	            this._createSteps();
	            this._renderSteps();
	            this._resetProgressBar();
	            this._calculateDimensions();
	        },

	        resize: function() {
	            this._calculateDimensions();
	        },

	        select: function(stepIndex) {
	            var that = this;

	            if(stepIndex === undefined || stepIndex === null || isNaN(stepIndex)) {
	                return that.selectedStep;
	            }

	            if(stepIndex >= that._steps.length || stepIndex < 0) {
	                return;
	            }

	            stepIndex = Number(stepIndex);

	            that._select(stepIndex);
	        },

	        steps: function(steps) {
	            if(steps === undefined) {
	                return this._steps;
	            }

	            this._processSteps(steps);
	            this._resetProgressBar();
	            this._calculateDimensions();
	        },

	        _processSteps: function(steps) {
	            var that = this,
	                selectedStep;
	            var findSelectedStep = function(step) {
	                if(step.selected) {
	                    selectedStep = step;
	                }
	            };

	            steps.forEach(findSelectedStep);

	            if(!selectedStep) {
	                if(typeof steps[0] === "string") {
	                    steps[0] = {
	                        label: steps[0]
	                    };
	                }
	                steps[0].selected = true;
	            }

	            that.options.steps = steps;

	            that._createSteps();
	            that._renderSteps();
	        },

	        _addStepList: function() {
	            var that = this;

	            that.wrapper.empty().append($("<ol />").addClass(stepperStyles.stepList));
	            that._stepList = that.wrapper.find(DOT + stepperStyles.stepList);

	            if(that.options.orientation === VERTICAL) {
	                that._stepList.addClass(stepperStyles.stepListVertical);
	            } else {
	                that._stepList.addClass(stepperStyles.stepListHorizontal);
	            }
	        },

	        _attachEvents: function() {
	            var that = this;

	            that.wrapper
	                .on(CLICK + STEPPER, DOT + stepStyles.step, proxy(that._selectClickHandler, that))
	                .on(CLICK + STEPPER, proxy(that._wrapperClickHandler, that))
	                .on(FOCUSOUT + STEPPER, proxy(that._focusout, that))
	                .on(KEYDOWN + STEPPER, that, proxy(that._keydown, that));
	        },

	        _calculateDimensions: function() {
	            var orientation = this.options.orientation,
	                numberOfSteps = this._steps.length,
	                stepList = this._stepList,
	                steps = stepList.find(DOT + stepStyles.step),
	                stepWidth = stepList.width() / numberOfSteps,
	                stepHeight = stepList.height() / numberOfSteps,
	                progressElement = this.progressBar.element,
	                margin = "margin-left",
	                style = {};

	            if(orientation === VERTICAL) {
	                steps.css("max-height", 100 / numberOfSteps + "%");
	                progressElement.css({
	                    "margin-top": -1 * (stepList.height() - 16),
	                    "height": stepHeight * (numberOfSteps - 1)
	                });
	            } else {
	                steps.css("max-width", 100 / numberOfSteps + "%");

	                if(kendo.support.isRtl(this.wrapper)) {
	                    margin = "margin-right";
	                }
	                style[margin] = stepWidth / 2;
	                style.width = stepWidth * (numberOfSteps - 1);

	                progressElement.css(style);
	            }
	        },

	        _createStep: function(stepOptions, idx, isLastStep) {
	            var that = this,
	                isFirstStep = idx === 0,
	                options = that.options,
	                indicatorVisible = options.indicator,
	                labelVisible = options.label;

	            stepOptions = extend({}, stepOptions, {
	                enabled: stepOptions.enabled === false ? false : true
	            });

	            stepOptions = extend({}, stepOptions, {
	                isFirstStep: isFirstStep,
	                isLastStep: isLastStep,
	                indicatorVisible: indicatorVisible,
	                labelVisible: labelVisible,
	                index: idx
	            });

	            return new Step(stepOptions);
	        },

	        _createSteps: function() {
	            var that = this,
	                stepsOptions = that.options.steps,
	                selected = false,
	                step, idx, isLastStep, stepOpt;

	            that._steps = [];

	            for (idx = 0; idx < stepsOptions.length; idx++) {
	                stepOpt = stepsOptions[idx];

	                if(typeof stepOpt === "string") {
	                    stepOpt = {
	                        label: stepOpt
	                    };
	                }

	                if (stepOpt !== undefined) {
	                    isLastStep = idx === stepsOptions.length - 1;

	                    if(stepOpt.selected) {
	                        selected = true;
	                    } else {
	                        stepOpt = that._selectablePreviousState(stepOpt, selected, idx);
	                    }

	                    step = that._createStep(stepOpt, idx, isLastStep);
	                    that._steps.push(step);

	                    if(step.getSelected()) {
	                        that.selectedStep = step;
	                    }
	                }
	            }
	        },

	        _indicatorAndLabel: function() {
	            if(!this.options.indicator && !this.options.label) {
	                this.options.indicator = true;
	                this.options.label = true;
	            }
	        },

	        _focusout: function(e) {
	            var that = this;

	            if(!that.wrapper.get(0).contains(e.relatedTarget)) {
	                setTimeout(function() {
	                    that._leaveStepper();
	                });
	            }
	        },

	        _focusStep: function(newStep) {
	            var focusedStep = this.wrapper.find(DOT + stepStyles.focusStep),
	                allStepLinks = this.wrapper.find(DOT + stepStyles.stepLink);

	            if(newStep.length > 0) {
	                focusedStep.removeClass(stepStyles.focusStep);
	                allStepLinks.attr(TABINDEX, "-1");
	                newStep.find(DOT + stepStyles.stepLink).removeAttr(TABINDEX)[0].focus();
	            }
	        },

	        _focusNextStep: function() {
	            var focusedStep = $(document.activeElement).closest(DOT + stepStyles.step),
	                nextStep = focusedStep.next();

	            this._focusStep(nextStep);
	        },

	        _focusPreviousStep: function() {
	            var focusedStep = $(document.activeElement).closest(DOT + stepStyles.step),
	                previousStep = focusedStep.prev();

	            this._focusStep(previousStep);
	        },

	        _focusFirstStep: function() {
	            var wrapper = this.wrapper,
	                firstStep = wrapper.find(DOT + stepStyles.firstStep);

	            this._focusStep(firstStep);
	        },

	        _focusLastStep: function() {
	            var wrapper = this.wrapper,
	                lastStep = wrapper.find(DOT + stepStyles.lastStep);

	            this._focusStep(lastStep);
	        },

	        _keydown: function(e) {
	            var that = this,
	                keyCode = e.keyCode,
	                focusedStepElement = $(document.activeElement).closest(DOT + stepStyles.step),
	                focusedStepIndex = focusedStepElement.index(),
	                stepsCount = that.steps().length;

	            if(keyCode === keys.TAB) {
	                if(e.shiftKey && focusedStepIndex > 0) {
	                    e.preventDefault();
	                    that._tabKey(e, -1);
	                } else if(!e.shiftKey && focusedStepIndex < stepsCount - 1) {
	                    e.preventDefault();
	                    that._tabKey(e, +1);
	                }
	            } else if(keyCode > 34 && keyCode < 41){
	                e.preventDefault();
	                that._navKeys(e);
	            } else if(keyCode === keys.ENTER || keyCode === keys.SPACEBAR) {
	                e.preventDefault();
	                that._selectHandler(e, $(document.activeElement).closest(DOT + stepStyles.step));
	            } else {
	                e.preventDefault();
	            }
	        },

	        _leaveStepper: function() {
	            var selectedStep = this.wrapper.find(DOT + stepStyles.currentStep),
	                allStepLinks = this.wrapper.find(DOT + stepStyles.stepLink);

	            allStepLinks.removeClass(stepStyles.focusStep).attr(TABINDEX, "-1");

	            selectedStep.addClass(stepStyles.focusStep);
	            selectedStep.find(DOT + stepStyles.stepLink).removeAttr(TABINDEX);
	        },

	        _navKeys: function(e) {
	            var selectOnFocus = this.options.selectOnFocus;

	            if(selectOnFocus) {
	                this._navKeysSelect(e);
	            } else {
	                this._navKeysFocus(e);
	            }
	        },

	        _navKeysFocus: function(e) {
	            var keyCode = e.keyCode,
	                rtl = kendo.support.isRtl(this.wrapper),
	                orientation = this.options.orientation;

	            switch(keyCode) {
	                case keys.DOWN:
	                    if(rtl && orientation !== VERTICAL) {
	                        this._focusPreviousStep();
	                    } else {
	                        this._focusNextStep();
	                    }
	                    break;
	                case keys.RIGHT:
	                    if(rtl) {
	                        this._focusPreviousStep();
	                    } else {
	                        this._focusNextStep();
	                    }
	                    break;
	                case keys.UP:
	                    if(rtl && orientation !== VERTICAL) {
	                        this._focusNextStep();
	                    } else {
	                        this._focusPreviousStep();
	                    }
	                    break;
	                case keys.LEFT:
	                    if(rtl) {
	                        this._focusNextStep();
	                    } else {
	                        this._focusPreviousStep();
	                    }
	                    break;
	                case keys.HOME:
	                    this._focusFirstStep();
	                    break;
	                case keys.END:
	                    this._focusLastStep();
	                    break;
	            }
	        },

	        _navKeysSelect: function(e) {
	            var keyCode = e.keyCode,
	                focusedStepIndex = $(document.activeElement).closest(DOT + stepStyles.step).index(),
	                rtl = kendo.support.isRtl(this.wrapper),
	                steps = this.steps(),
	                orientation = this.options.orientation,
	                targetStep;

	            switch(keyCode) {
	                case keys.DOWN:
	                    if(rtl && orientation !== VERTICAL) {
	                        targetStep = steps[focusedStepIndex - 1];
	                    } else {
	                        targetStep = steps[focusedStepIndex + 1];
	                    }
	                    break;
	                case keys.RIGHT:
	                    if(rtl) {
	                        targetStep = steps[focusedStepIndex - 1];
	                    } else {
	                        targetStep = steps[focusedStepIndex + 1];
	                    }
	                    break;
	                case keys.UP:
	                    if(rtl && orientation !== VERTICAL) {
	                        targetStep = steps[focusedStepIndex + 1];
	                    } else {
	                        targetStep = steps[focusedStepIndex - 1];
	                    }
	                    break;
	                case keys.LEFT:
	                    if(rtl) {
	                        targetStep = steps[focusedStepIndex + 1];
	                    } else {
	                        targetStep = steps[focusedStepIndex - 1];
	                    }
	                    break;
	                case keys.HOME:
	                    targetStep = steps[0];
	                    break;
	                case keys.END:
	                    targetStep = steps[steps.length - 1];
	                    break;
	            }

	            if(targetStep) {
	                this._focusStep(targetStep.element);
	                this._selectHandlerOnKey(e, targetStep.element);
	            }
	        },

	        _progressBar: function() {
	            var wrapper = this.wrapper,
	                progressBarOptions = this._progressOptions();

	            this.progressBar = $("<div>").kendoProgressBar(progressBarOptions).getKendoProgressBar();

	            this._calculateDimensions();

	            wrapper.append(this.progressBar.element);
	        },

	        _progressOptions: function() {
	            var options = this.options,
	                orientation = options.orientation,
	                stepsOptions = options.steps,
	                numberOfSteps, progressBarOptions;

	            if(!stepsOptions || stepsOptions.length === 0) {
	                return;
	            } else {
	                numberOfSteps = stepsOptions.length;
	            }

	            progressBarOptions = {
	                max: numberOfSteps - 1,
	                value: this.select().getIndex(),
	                orientation: orientation,
	                showStatus: false
	            };

	            if(orientation === VERTICAL) {
	                progressBarOptions.reverse = true;
	            }

	            return progressBarOptions;
	        },

	        _resetProgressBar: function() {
	            var progressBar = this.progressBar,
	                newOptions;

	            if(!progressBar) {
	                return;
	            }

	            newOptions = this._progressOptions();
	            progressBar.setOptions(newOptions);
	        },

	        _renderSteps: function() {
	            var steps = this._steps,
	                stepsList = this._stepList,
	                step, idx;

	            stepsList.empty();

	            for (idx = 0; idx < steps.length; idx++) {
	                step = steps[idx];
	                stepsList.append(step.element);
	            }
	        },

	        _resetStep: function(i, index, forward) {
	            var step = this._steps[i];

	            if(!forward && i < index) {
	                step.options.selectable = true;
	            } else if(i === index) {
	                step.options.previous = false;
	                step.options.selected = true;
	            } else if (forward && i > index) {
	                step.options.selectable = true;
	            } else {
	                step.options.selected = false;
	                step.options.previous = forward;
	            }

	            if(this.options.linear && (i < index - 1 || i > index + 1)) {
	                step.options.selectable = false;
	            }

	            step._link();
	            step._stepClasses();
	            this.options.steps[i] = step.options;
	        },

	        _select: function(index) {
	            var options = this.options,
	                linear = options.linear,
	                selectedStep = this.select(),
	                selectedIndex = selectedStep.getIndex(),
	                stepsOptions = options.steps,
	                targetStep = this._steps[index],
	                forward, i, min, max;

	            if(!targetStep || !targetStep.getEnabled() || !targetStep.getSelectable()) {
	                return;
	            }

	            if(index > selectedIndex) {
	                forward = true;

	                if(linear) {
	                    min = Math.max(selectedIndex - 1, 0);
	                    max = Math.min(index + 1, stepsOptions.length - 1);
	                } else {
	                    min = selectedIndex;
	                    max = index;
	                }
	            } else {
	                forward = false;

	                if(linear) {
	                    min = Math.max(index - 1, 0);
	                    max = Math.min(selectedIndex + 1, stepsOptions.length - 1);
	                } else {
	                    min = index;
	                    max = selectedIndex;
	                }
	            }

	            for(i = min; i <= max; i ++) {
	                this._resetStep(i, index, forward);
	            }

	            this.selectedStep = targetStep;
	            this.progressBar.value(index);
	        },

	        _selectablePreviousState: function(stepOpt, selected, idx) {
	            var stepsOptions = this.options.steps,
	                linear = this.options.linear;

	            if(!selected) {
	                stepOpt.previous = true;
	                if(linear && !stepsOptions[idx + 1].selected) {
	                    stepOpt.selectable = false;
	                } else {
	                    stepOpt.selectable = true;
	                }
	            } else if(linear && !stepsOptions[idx - 1].selected) {
	                stepOpt.selectable = false;
	            } else {
	                stepOpt.selectable = true;
	            }

	            return stepOpt;
	        },

	        _selectClickHandler: function(e) {
	            var stepElement = $(e.target).closest(DOT + stepStyles.step);

	            e.preventDefault();
	            this._preventWrapperClick = true;
	            this._selectHandler(e, stepElement);
	        },

	        _selectHandler: function(e, stepElement) {
	            var that = this,
	                step = that._steps[stepElement.index()],
	                currentStep = this.select();

	            if(!step || step.getIndex() === currentStep.getIndex() || !step.getEnabled() || !step.getSelectable()) {
	                that._focusStep(currentStep.element);

	                return;
	            }

	            if(!that.trigger(SELECT, { sender: that, originalEvent: e, step: step})) {
	                that._select(step.getIndex());
	                stepElement.find(DOT + stepStyles.stepLink)[0].focus();
	                that.trigger(ACTIVATE, { sender: that, originalEvent: e, step: step});
	            }
	        },

	        _selectHandlerOnKey: function(e, stepElement) {
	            var that = this,
	                step = that._steps[stepElement.index()];

	            if(!step.getEnabled() || !step.getSelectable()) {
	                return;
	            }

	            if(!that.trigger(SELECT, { sender: that, originalEvent: e, step: step})) {
	                that._select(step.getIndex());
	                stepElement.find(DOT + stepStyles.stepLink)[0].focus();
	                that.trigger(ACTIVATE, { sender: that, originalEvent: e, step: step});
	            }
	        },

	        _tabKey: function(e, shift) {
	            var selectOnFocus = this.options.selectOnFocus,
	                focusedStepElement = $(document.activeElement).closest(DOT + stepStyles.step),
	                focusedStepIndex = focusedStepElement.index(),
	                targetStep = $(focusedStepElement.parent().find(DOT + stepStyles.step)[focusedStepIndex + shift]);

	            this._focusStep(targetStep);

	            if(selectOnFocus) {
	                this._selectHandlerOnKey(e, targetStep);
	            }
	        },

	        _wrapper: function() {
	            var that = this,
	                element = that.element;

	            that.wrapper = element;
	            that.wrapper.addClass(stepperStyles.widget);

	            if(that.options.linear) {
	                that.wrapper.addClass(stepperStyles.stepperLinear);
	            }

	            this._addStepList();
	        },

	        _wrapperClickHandler: function(e) {
	            var currentStep = this.select();

	            if(!this._preventWrapperClick) {
	                e.preventDefault();
	                this._focusStep(currentStep.element);
	            } else {
	                this._preventWrapperClick = false;
	            }
	        }
	    });

	    kendo.stepper = {
	        Step: Step
	    };

	    kendo.ui.plugin(Stepper);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "2UxK":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(965);
	module.exports = __webpack_require__(965);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1kkP");

/***/ }),

/***/ 965:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*jshint scripturl: true */
	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(966),
	        __webpack_require__(6),
	        __webpack_require__(967),
	        __webpack_require__(968),
	        __webpack_require__(969)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($,undefined) {

	    // Imports ================================================================
	    var kendo = window.kendo,
	        Class = kendo.Class,
	        Widget = kendo.ui.Widget,
	        os = kendo.support.mobileOS,
	        browser = kendo.support.browser,
	        extend = $.extend,
	        proxy = $.proxy,
	        deepExtend = kendo.deepExtend,
	        keys = kendo.keys;

	    var SELECT = "select";
	    var SELECT_OVERLAY_SELECTOR = "select.k-select-overlay";
	    var PLACEHOLDER_CLASS= "k-placeholder";
	    var PLACEHOLDER_TAG_ID = "placeholder";
	    var REFRESH_INTERVAL = 200;
	    var DEFAULT_LANGUAGE = "en";

	    // options can be: template (as string), cssClass, title, defaultValue
	    var ToolTemplate = Class.extend({
	        init: function(options) {
	            this.options = options;
	        },

	        getHtml: function() {
	            var options = this.options;
	            return kendo.template(options.template, {useWithBlock:false})(options);
	        }
	    });

	    var EditorUtils = {
	        editorWrapperTemplate:
	            '<table cellspacing="0" cellpadding="0" class="k-widget k-editor" role="presentation">' +
	                '<tbody>' +
	                    '<tr role="presentation"><td class="k-editor-toolbar-wrap" role="presentation"><ul class="k-toolbar k-editor-toolbar" role="toolbar"></ul></td></tr>' +
	                    '<tr><td class="k-editable-area"></td></tr>' +
	                '</tbody>' +
	            '</table>',

	        buttonTemplate:
	            '# var iconCssClass = "k-icon k-i-" + kendo.toHyphens(data.cssClass.replace("k-", ""));#' +
	            '# var dataPopup = data.popup ? "data-popup" : "";#' +
	            '<button tabindex="0" role="button" class="k-button k-tool" #= dataPopup # title="#= data.title #" aria-label="#= data.title #">' +
	                '<span class="#= iconCssClass #"></span>' +
	                '<span class="k-tool-text k-button-text">#= data.title #</span>' +
	            '</button>',

	        tableWizardButtonTemplate:
	            '# var iconCssClass = "k-icon k-i-" + kendo.toHyphens(data.cssClass.replace("k-", ""));#' +
	            '# var dataPopup = data.popup ? "data-popup" : "";#' +
	            '<button tabindex="0" role="button" class="k-tool k-button" #= dataPopup # title="#= data.title #" aria-label="#= data.title #">'+
	                '<span class="#= iconCssClass #"></span>' +
	                '<span class="k-tool-text">#= data.title #</span>'+
	            '</button>',

	        colorPickerTemplate:
	            '<input class="k-colorpicker k-icon k-i-#= data.cssClass.replace("k-", "") #" />',

	        comboBoxTemplate:
	            '<select title="#= data.title #" aria-label="#= data.title #" class="#= data.cssClass #"></select>',

	        dropDownListTemplate:
	            '<span class="k-editor-dropdown"><select title="#= data.title #" aria-label="#= data.title #" class="#= data.cssClass #"></select></span>',

	        separatorTemplate:
	            '<span class="k-separator"></span>',

	        overflowAnchorTemplate:
	            '<button tabindex="0" role="button" class="k-button k-tool k-overflow-anchor" data-popup' +
	                ' title="#= data.title #" aria-label="#= data.title #" aria-haspopup="true" aria-expanded="false">' +
	                '<span class="k-icon k-i-more-vertical"></span>' +
	            '</button>',

	        formatByName: function(name, format) {
	            for (var i = 0; i < format.length; i++) {
	                if ($.inArray(name, format[i].tags) >= 0) {
	                    return format[i];
	                }
	            }
	        },

	        getToolCssClass: function (name) {
	            var toolCssClassNames = {

	                superscript: "sup-script",
	                subscript: "sub-script",
	                justifyLeft: "align-left",
	                justifyCenter: "align-center",
	                justifyRight: "align-right",
	                justifyFull: "align-justify",
	                insertUnorderedList: "list-unordered",
	                insertOrderedList: "list-ordered",
	                "import": "login",
	                indent: "indent-increase",
	                outdent: "indent-decrease",
	                createLink: "link-horizontal",
	                unlink: "unlink-horizontal",
	                insertImage: "image",
	                insertFile: "file-add",
	                viewHtml: "html",
	                foreColor: "foreground-color",
	                backColor: "paint",
	                createTable: "table-insert",
	                addColumnLeft: "table-column-insert-left",
	                addColumnRight: "table-column-insert-right",
	                addRowAbove: "table-row-insert-above",
	                addRowBelow: "table-row-insert-below",
	                deleteRow: "table-row-delete",
	                deleteColumn: "table-column-delete",
	                mergeCellsHorizontally: "cells-merge-horizontally",
	                mergeCellsVertically: "cells-merge-vertically",
	                splitCellHorizontally: "cell-split-horizontally",
	                splitCellVertically: "cell-split-vertically",
	                tableWizard: "table-properties",
	                tableWizardInsert: "table-wizard",
	                cleanFormatting: "clear-css",
	                copyFormat: "copy-format",
	                applyFormat: "apply-format"
	            };

	            var cssClass = toolCssClassNames[name];
	            if(cssClass) {
	                return cssClass;
	            }
	            return name;
	        },

	        registerTool: function(toolName, tool) {
	            var toolOptions = tool.options;
	            if (toolOptions && toolOptions.template) {
	                toolOptions.template.options.cssClass = "k-" + EditorUtils.getToolCssClass(toolName);
	            }

	            if (!tool.name) {
	                tool.options.name = toolName;
	                tool.name = toolName.toLowerCase();
	            }

	            Editor.defaultTools[toolName] = tool;
	        },

	        registerFormat: function(formatName, format) {
	            Editor.fn.options.formats[formatName] = format;
	        },

	        cacheComments: function (content, comments) {
	            for(var index in comments){
	                content = content.replace(comments[index], "{" + index + "}");
	            }
	            return content;
	        },

	        retrieveComments: function (content, comments) {
	            for(var index in comments){
	                content = content.replace("{" + index + "}", comments[index]);
	            }
	            return content;
	        }
	    };

	    var messages = {
	        bold: "Bold",
	        italic: "Italic",
	        underline: "Underline",
	        strikethrough: "Strikethrough",
	        superscript: "Superscript",
	        subscript: "Subscript",
	        justifyCenter: "Center text",
	        justifyLeft: "Align text left",
	        justifyRight: "Align text right",
	        justifyFull: "Justify",
	        insertUnorderedList: "Insert unordered list",
	        insertOrderedList: "Insert ordered list",
	        indent: "Indent",
	        outdent: "Outdent",
	        createLink: "Insert hyperlink",
	        unlink: "Remove hyperlink",
	        insertImage: "Insert image",
	        insertFile: "Insert file",
	        insertHtml: "Insert HTML",
	        viewHtml: "View HTML",
	        fontName: "Select font family",
	        fontNameInherit: "(inherited font)",
	        fontSize: "Select font size",
	        fontSizeInherit: "(inherited size)",
	        formatBlock: "Format",
	        formatting: "Format",
	        foreColor: "Color",
	        backColor: "Background color",
	        style: "Styles",
	        emptyFolder: "Empty Folder",
	        editAreaTitle: "Editable area. Press F10 for toolbar.",
	        uploadFile: "Upload",
	        overflowAnchor: "More tools",
	        orderBy: "Arrange by:",
	        orderBySize: "Size",
	        orderByName: "Name",
	        invalidFileType: "The selected file \"{0}\" is not valid. Supported file types are {1}.",
	        deleteFile: 'Are you sure you want to delete "{0}"?',
	        overwriteFile: 'A file with name "{0}" already exists in the current directory. Do you want to overwrite it?',
	        directoryNotFound: "A directory with this name was not found.",
	        imageWebAddress: "Web address",
	        imageAltText: "Alternate text",
	        imageWidth: "Width (px)",
	        imageHeight: "Height (px)",
	        fileWebAddress: "Web address",
	        fileTitle: "Title",
	        fileText: "Text",
	        linkWebAddress: "Web address",
	        linkText: "Text",
	        linkToolTip: "ToolTip",
	        linkOpenInNewWindow: "Open link in new window",
	        dialogUpdate: "Update",
	        dialogInsert: "Insert",
	        dialogOk: "Ok",
	        dialogCancel: "Cancel",
	        cleanFormatting: "Clean formatting",
	        createTable: "Create a table",
	        createTableHint: "Create a {0} x {1} table",
	        addColumnLeft: "Add column on the left",
	        addColumnRight: "Add column on the right",
	        addRowAbove: "Add row above",
	        addRowBelow: "Add row below",
	        deleteRow: "Delete row",
	        deleteColumn: "Delete column",
	        mergeCellsHorizontally: "Merge cells horizontally",
	        mergeCellsVertically: "Merge cells vertically",
	        splitCellHorizontally: "Split cells horizontally",
	        splitCellVertically: "Split cells vertically",
	        tableWizard: "Table Wizard",
	        tableTab: "Table",
	        cellTab: "Cell",
	        accessibilityTab: "Accessibility",
	        caption: "Caption",
	        summary: "Summary",
	        width: "Width",
	        height: "Height",
	        units: "Units",
	        cellSpacing: "Cell Spacing",
	        cellPadding: "Cell Padding",
	        cellMargin: "Cell Margin",
	        alignment: "Alignment",
	        background: "Background",
	        cssClass: "CSS Class",
	        id: "ID",
	        border: "Border",
	        borderStyle: "Border Style",
	        collapseBorders: "Collapse borders",
	        wrapText: "Wrap text",
	        associateCellsWithHeaders: "Associate headers",
	        alignLeft: "Align Left",
	        alignCenter: "Align Center",
	        alignRight: "Align Right",
	        alignLeftTop: "Align Left Top",
	        alignCenterTop: "Align Center Top",
	        alignRightTop: "Align Right Top",
	        alignLeftMiddle: "Align Left Middle",
	        alignCenterMiddle: "Align Center Middle",
	        alignRightMiddle: "Align Right Middle",
	        alignLeftBottom: "Align Left Bottom",
	        alignCenterBottom: "Align Center Bottom",
	        alignRightBottom: "Align Right Bottom",
	        alignRemove: "Remove Alignment",
	        columns: "Columns",
	        rows: "Rows",
	        selectAllCells: "Select All Cells",
	        exportAs: "Export As",
	        "import": "Import",
	        print: "Print",
	        headerRows: "Header Rows",
	        headerColumns: "Header Cols",
	        tableSummaryPlaceholder: "Summary attribute is not HTML5 compatible.",
	        associateNone: "None",
	        associateScope: "Associate using 'scope' attribute",
	        associateIds: "Associate using Ids",
	        copyFormat: "Copy format",
	        applyFormat: "Apply format"
	    };

	    var supportedBrowser = !os || (os.ios && os.flatVersion >= 500) || (!os.ios && typeof(document.documentElement.contentEditable) != 'undefined');

	    var toolGroups = {
	        basic: [ "bold", "italic", "underline" ],
	        alignment: [ "justifyLeft", "justifyCenter", "justifyRight" ],
	        lists: [ "insertUnorderedList", "insertOrderedList" ],
	        indenting: [ "indent", "outdent" ],
	        formatPainter: [ "copyFormat", "applyFormat" ],
	        links: [ "createLink", "unlink" ],
	        tables: [ "tableWizard", "createTable", "addColumnLeft", "addColumnRight", "addRowAbove", "addRowBelow", "deleteRow", "deleteColumn", "mergeCellsHorizontally", "mergeCellsVertically", "splitCellHorizontally", "splitCellVertically" ]
	    };

	    var Editor = Widget.extend({
	        init: function (element, options) {
	            var that = this,
	                value,
	                editorNS = kendo.ui.editor,
	                toolbarContainer,
	                toolbarOptions,
	                type, comments;
	            var domElement;
	            var dom = editorNS.Dom;

	            /* suppress initialization in mobile webkit devices (w/o proper contenteditable support) */
	            if (!supportedBrowser) {
	                return;
	            }

	            Widget.fn.init.call(that, element, options);

	            that.options = deepExtend({}, that.options, options);
	            that.options.tools = that.options.tools.slice();

	            element = that.element;
	            domElement = element[0];

	            type = dom.name(domElement);

	            this._registerHandler(
	                element.closest("form"), "submit", proxy(that.update, that, undefined)
	            );

	            toolbarOptions = extend({}, that.options);
	            toolbarOptions.editor = that;

	            if (type == "textarea") {
	                that._wrapTextarea();

	                toolbarContainer = that.wrapper.find(".k-editor-toolbar");

	                if (domElement.id) {
	                    toolbarContainer.attr("aria-controls", domElement.id);
	                }
	            } else {
	                that.element.attr("contenteditable", true).addClass("k-widget k-editor k-editor-inline");

	                toolbarOptions.popup = true;

	                toolbarContainer = $('<ul class="k-toolbar k-editor-toolbar" role="toolbar" />').insertBefore(element);
	            }

	            that.toolbar = new editorNS.Toolbar(toolbarContainer[0], toolbarOptions);

	            that.toolbar.bindTo(that);

	            if (type == "textarea") {
	                setTimeout(function () {
	                    var heightStyle = that.wrapper[0].style.height;
	                    var expectedHeight = parseInt(heightStyle, 10);
	                    var actualHeight = that.wrapper.height();
	                    if (heightStyle.indexOf("px") > 0 && !isNaN(expectedHeight) && actualHeight > expectedHeight) {
	                        that.wrapper.height(expectedHeight - (actualHeight - expectedHeight));
	                    }
	                });
	            }

	            that._resizable();
	            that._initializeContentElement(that);

	            that.keyboard = new editorNS.Keyboard([
	                new editorNS.BackspaceHandler(that),
	                new editorNS.TypingHandler(that),
	                new editorNS.SystemHandler(that),
	                new editorNS.SelectAllHandler(that)
	            ]);

	            that.clipboard = new editorNS.Clipboard(this);

	            that.undoRedoStack = new kendo.util.UndoRedoStack();

	            if (options && options.value) {
	                value = options.value;
	            } else if (that.textarea) {
	                // indented HTML introduces problematic ranges in IE
	                value = domElement.value;

	                // revert encoding of value when content is fetched from cache
	                if (that.options.encoded && domElement.defaultValue && domElement.defaultValue.trim().length) {
	                    value = domElement.defaultValue;
	                }

	                var deserializedRoot = editorNS.Serializer.htmlToDom(value, $("<div></div>")[0], that.options.deserialization);
	                comments = dom.getAllComments(deserializedRoot);
	                value = EditorUtils.cacheComments(value, comments);
	                value = value.replace(/[\r\n\v\f\t ]+/ig, " ");
	                value = EditorUtils.retrieveComments(value, comments);
	            } else {
	                value = domElement.innerHTML;
	            }

	            that.value(value || '\ufeff');

	            // using $.proxy here will break #5337
	            this._registerHandler(document, {
	                "mousedown": function() { that._endTyping(); },
	                "mouseup": function(e) { that._mouseup(e); }
	            });

	            that._initializeImmutables();

	            that.toolbar.resize();

	            kendo.notify(that);
	        },

	        setOptions: function(options) {
	            var editor = this;

	            Widget.fn.setOptions.call(editor, options);
	            if (options.tools) {
	                editor.toolbar.bindTo(editor);
	            }

	            this._initializePlaceholder();
	        },

	        _togglePlaceholder: function(show) {
	            var that = this,
	                body = that.body,
	                $body = $(body),
	                placeholder = that.options.placeholder;

	            if(!that.textarea || !placeholder) {
	                return;
	            }

	            $body.attr('aria-label', function() {
	                return  show ? placeholder : "";
	            });

	            $body.toggleClass(PLACEHOLDER_CLASS, show);
	        },

	        _endTyping: function() {
	            var keyboard = this.keyboard;

	            try {
	                if (keyboard.isTypingInProgress()) {
	                    keyboard.endTyping(true);
	                    this.saveSelection();
	                }
	            } catch (e) { }
	        },

	        _selectionChange: function() {
	            this._selectionStarted = false;
	            this.saveSelection();
	            this.trigger("select", {});
	        },

	        _resizable: function() {
	            var resizable = this.options.resizable;
	            var isResizable = $.isPlainObject(resizable) ? (resizable.content === undefined || resizable.content === true) : resizable;

	            if (isResizable && this.textarea) {
	                var draggableElement = $("<div class='k-resize-handle'><span class='k-icon k-i-arrow-45-down-right'></span></div>")
	                    .insertAfter(this.textarea);

	                this.wrapper.addClass('k-resizable');

	                this.wrapper.kendoResizable(extend({}, this.options.resizable, {
	                    draggableElement: draggableElement,
	                    start: function(e) {
	                        var editor = this.editor = $(e.currentTarget).closest(".k-editor");
	                        this.initialSize = editor.height();
	                        editor.find("td:last").append("<div class='k-overlay' />");
	                    },
	                    resize: function(e) {
	                        var delta = e.y.initialDelta;
	                        var newSize = this.initialSize + delta;
	                        var min = this.options.min || 0;
	                        var max = this.options.max || Infinity;

	                        newSize = Math.min(max, Math.max(min, newSize));

	                        this.editor.height(newSize);
	                    },
	                    resizeend: function() {
	                        this.editor.find(".k-overlay").remove();
	                        this.editor = null;
	                    }
	                }));

	                if (kendo.support.mobileOS.ios) {
	                    var resizableWidget = this.wrapper.getKendoResizable();
	                    resizableWidget.draggable.options.ignore = SELECT_OVERLAY_SELECTOR;
	                }
	            }
	        },

	        _initializeTableResizing: function() {
	            var editor = this;

	            kendo.ui.editor.TableResizing.create(editor);

	            editor._showTableResizeHandlesProxy = proxy(editor._showTableResizeHandles, editor);
	            editor.bind(SELECT, editor._showTableResizeHandlesProxy);
	        },

	        _destroyTableResizing: function() {
	            var editor = this;
	            var tableResizing = editor.tableResizing;

	            if (tableResizing) {
	                tableResizing.destroy();
	                editor.tableResizing = null;
	            }

	            if (editor._showTableResizeHandlesProxy) {
	                editor.unbind(SELECT, editor._showTableResizeHandlesProxy);
	            }
	        },

	        _showTableResizeHandles: function() {
	            var editor = this;
	            var tableResizing = editor.tableResizing;

	            if (tableResizing) {
	                tableResizing.showResizeHandles();
	            }
	        },

	        _initializeColumnResizing: function() {
	            kendo.ui.editor.ColumnResizing.create(this);
	        },

	        _destroyColumnResizing: function() {
	            var editor = this;

	            if (editor.columnResizing) {
	                editor.columnResizing.destroy();
	                editor.columnResizing = null;
	            }
	        },

	        _initializeRowResizing: function() {
	            kendo.ui.editor.RowResizing.create(this);
	        },

	        _destroyRowResizing: function() {
	            var editor = this;

	            if (editor.rowResizing) {
	                editor.rowResizing.destroy();
	                editor.rowResizing = null;
	            }
	        },

	        _wrapTextarea: function() {
	            var that = this,
	                textarea = that.element,
	                w = textarea[0].style.width,
	                h = textarea[0].style.height,
	                template = EditorUtils.editorWrapperTemplate,
	                editorWrap = $(template).insertBefore(textarea).width(w).height(h),
	                editArea = editorWrap.find(".k-editable-area");

	            textarea.attr("autocomplete", "off")
	                .appendTo(editArea).addClass("k-content k-raw-content").css("display", "none");

	            that.textarea = textarea;
	            that.wrapper = editorWrap;
	        },

	        _createContentElement: function(stylesheets) {
	            var editor = this;
	            var iframe, wnd, doc;
	            var textarea = editor.textarea;
	            var specifiedDomain = editor.options.domain;
	            var domain = specifiedDomain || document.domain;
	            var domainScript = "";
	            var src = 'javascript:""';
	            var lang ="";

	            textarea.hide();

	            iframe = $("<iframe />", { title: editor.options.messages.editAreaTitle, frameBorder: "0" })[0];

	            $(iframe)
	                .css("display", "")
	                .addClass("k-content")
	                .attr("tabindex", textarea[0].tabIndex)
	                .insertBefore(textarea);

	            // automatically relax same-origin policy if document.domain != location.hostname,
	            // or forcefully relax if options.domain is specified (for document.domain = document.domain scenario)
	            if (specifiedDomain || domain != location.hostname) {
	                // relax same-origin policy
	                domainScript = "<script>document.domain=\"" + domain + "\"</script>";
	                src = "javascript:document.write('" + domainScript + "')";
	                iframe.src = src;
	            }

	            if(!iframe.src) {
	                iframe.src = "";
	            }

	            wnd = iframe.contentWindow || iframe;
	            doc = wnd.document || iframe.contentDocument;

	            $(iframe).one("load", function() {
	                editor.toolbar.decorateFrom(doc.body);
	            });

	            lang = document.getElementsByTagName("html")[0].getAttribute("lang") || DEFAULT_LANGUAGE;

	            doc.open();
	            doc.write(
	                "<!DOCTYPE html><html lang='" + lang + "'><head>" +
	                "<meta charset='utf-8' />" +
	                "<title>Kendo UI Editor content</title>" +
	                "<style>" +
	                    "html{padding:0;margin:0;height:100%;min-height:100%;cursor:text;}" +
	                    "body{padding:0;margin:0;}" +
	                    "body{box-sizing:border-box;font-size:12px;font-family:Verdana,Geneva,sans-serif;margin-top:-1px;padding:5px .4em 0;" +
	                    "word-wrap: break-word;-webkit-nbsp-mode: space;-webkit-line-break: after-white-space;" +
	                    (kendo.support.isRtl(textarea) ? "direction:rtl;" : "") +
	                    (os.ios ? "word-break:keep-all;" : "") +
	                    "}" +
	                    "h1{font-size:2em;margin:.67em 0}h2{font-size:1.5em}h3{font-size:1.16em}h4{font-size:1em}h5{font-size:.83em}h6{font-size:.7em}" +
	                    "p{margin:0 0 1em;}.k-marker{display:none;}.k-paste-container,.Apple-style-span{position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden}" +
	                    "ul,ol{padding-left:2.5em}" +
	                    "span{-ms-high-contrast-adjust:none;}" +
	                    "a{color:#00a}" +
	                    "code{font-size:1.23em}" +
	                    "telerik\\3Ascript{display: none;}" +
	                    ".k-table{width:100%;border-spacing:0;margin: 0 0 1em;}" +
	                    ".k-table td{min-width:1px;padding:.2em .3em;}" +
	                    ".k-table,.k-table td{outline:0;border: 1px dotted #ccc;}" +
	                    ".k-table th{outline:0;border: 1px dotted #999;}" +
	                    ".k-table p{margin:0;padding:0;}" +
	                    ".k-column-resize-handle-wrapper {position: absolute; height: 10px; width:10px; cursor: col-resize; z-index: 2;}" +
	                    ".k-column-resize-handle {width: 100%; height: 100%;}" +
	                    ".k-column-resize-handle > .k-column-resize-marker {width:2px; height:100%; margin:0 auto; background-color:#00b0ff; display:none; opacity:0.8;}" +
	                    ".k-row-resize-handle-wrapper {position: absolute; cursor: row-resize; z-index:2; width: 10px; height: 10px;}" +
	                    ".k-row-resize-handle {display: table; width: 100%; height: 100%;}" +
	                    ".k-row-resize-marker-wrapper{display: table-cell; height:100%; width:100%; margin:0; padding:0; vertical-align: middle;}" +
	                    ".k-row-resize-marker{margin: 0; padding:0; width:100%; height:2px; background-color: #00b0ff; opacity:0.8; display:none;}" +
	                    ".k-table-resize-handle-wrapper {position: absolute; background-color: #fff; border: 1px solid #000; z-index: 100; width: 5px; height: 5px;}" +
	                    ".k-table-resize-handle {width: 100%; height: 100%;}" +
	                    ".k-table-resize-handle.k-resize-east{cursor:e-resize;}" +
	                    ".k-table-resize-handle.k-resize-north{cursor:n-resize;}" +
	                    ".k-table-resize-handle.k-resize-northeast{cursor:ne-resize;}" +
	                    ".k-table-resize-handle.k-resize-northwest{cursor:nw-resize;}" +
	                    ".k-table-resize-handle.k-resize-south{cursor:s-resize;}" +
	                    ".k-table-resize-handle.k-resize-southeast{cursor:se-resize;}" +
	                    ".k-table-resize-handle.k-resize-southwest{cursor:sw-resize;}" +
	                    ".k-table-resize-handle.k-resize-west{cursor:w-resize;}" +
	                    ".k-table.k-table-resizing{opacity:0.6;}" +
	                    ".k-placeholder{color:grey}" +
	                    "k\\:script{display:none;}" +
	                "</style>" +
	                domainScript +
	                $.map(stylesheets, function(href){
	                    return "<link rel='stylesheet' href='" + href + "'>";
	                }).join("") +
	                "</head><body autocorrect='off' contenteditable='true'></body></html>"
	            );
	            doc.close();

	            return wnd;
	        },

	        _blur: function() {
	            var textarea = this.textarea;
	            var old = textarea ? textarea.val() : this._oldValue;
	            var value = this.options.encoded ? this.encodedValue() : this.value();

	            this.update();

	            if (textarea) {
	                textarea.trigger("blur");
	            }

	            if (value != old) {
	                this.trigger("change");
	                if(textarea) {
	                    textarea.trigger("change");
	                }
	            }
	        },

	        _spellCorrect: function(editor) {
	            var beforeCorrection;
	            var falseTrigger = false;

	            this._registerHandler(editor.body, {
	                "contextmenu": function() {
	                    editor.one("select", function() {
	                        beforeCorrection = null;
	                    });

	                    editor._spellCorrectTimeout = setTimeout(function() {
	                        beforeCorrection = new kendo.ui.editor.RestorePoint(editor.getRange(), editor.body);
	                        falseTrigger = false;
	                    }, 10);
	                },
	                "input": function() {
	                    if (!beforeCorrection) {
	                        return;
	                    }

	                    if (kendo.support.browser.mozilla && !falseTrigger) {
	                        falseTrigger = true;
	                        return;
	                    }

	                    kendo.ui.editor._finishUpdate(editor, beforeCorrection);
	                }
	            });
	        },

	        _registerHandler: function(element, type, handler) {
	            var editor = this;
	            var NS = ".kendoEditor";
	            var eventNames;
	            var i;

	            element = $(element);

	            if (!this._handlers) {
	                this._handlers = [];
	            }

	            if (element.length) {
	                if ($.isPlainObject(type)) {
	                    for (var t in type) {
	                        if (type.hasOwnProperty(t)) {
	                            this._registerHandler(element, t, type[t]);
	                        }
	                    }
	                } else {
	                    //map the original event to handle interaction on mobile platforms
	                    eventNames = kendo.applyEventMap(type).split(" ");

	                    for (i = 0; i < eventNames.length; i++) {
	                        editor._handlers.push({
	                            element: element,
	                            type: eventNames[i] + NS,
	                            handler: handler
	                        });

	                        element.on(eventNames[i] + NS, handler);
	                    }
	                }
	            }
	        },

	        _deregisterHandlers: function() {
	            var handlers = this._handlers;

	            for (var i = 0; i < handlers.length; i++) {
	                var h = handlers[i];
	                h.element.off(h.type, h.handler);
	            }

	            this._handlers = [];
	        },

	        _initializeContentElement: function() {
	            var editor = this;
	            var doc;
	            var blurTrigger;
	            var mousedownTrigger;

	            if (editor.textarea) {
	                editor.window = editor._createContentElement(editor.options.stylesheets);
	                doc = editor.document = editor.window.contentDocument || editor.window.document;

	                // Ensure that body exists as various Firefox plugins can cause a delay of the body creation
	                // https://github.com/telerik/kendo-ui-core/issues/3515
	                if (!doc.body) {
	                    var body = doc.createElement("body");
	                    body.setAttribute("contenteditable", "true");
	                    body.setAttribute("autocorrect", "off");
	                    doc.getElementsByTagName("html")[0].appendChild(body);

	                    var interval = setInterval(function (){
	                        if ($(editor.document).find("body").length > 1) {
	                            $(editor.document).find("body:last").remove();
	                            window.clearInterval(interval);
	                        }
	                    },10);
	                }

	                editor.body = doc.body;

	                blurTrigger = editor.window;
	                mousedownTrigger = doc;

	                this._registerHandler(doc, "mouseup", proxy(this._mouseup, this));
	            } else {
	                editor.window = window;
	                doc = editor.document = document;
	                editor.body = editor.element[0];

	                blurTrigger = editor.body;
	                mousedownTrigger = editor.body;

	                editor.toolbar.decorateFrom(editor.body);
	            }

	            this._registerHandler(blurTrigger, "blur", proxy(this._blur, this));
	            editor._registerHandler(mousedownTrigger, "down", proxy(editor._mousedown, editor));

	            try {
	                doc.execCommand("enableInlineTableEditing", null, false);
	            } catch(e) { }

	            if (kendo.support.touch) {
	                this._registerHandler(doc, {
	                    "keydown": function() {
	                        // necessary in iOS when touch events are bound to the page
	                        if (kendo._activeElement() != doc.body) {
	                            editor.window.focus();
	                        }
	                    }
	                });
	            }

	            this._initializePlaceholder();

	            this._spellCorrect(editor);

	            this._registerHandler(editor.document, {
	                "mouseover dragenter": function(e){
	                    var height = $(editor.body).height();
	                    var htmlHeight = $(editor.body.parentElement).height();

	                    if (htmlHeight > height && e.target.nodeName.toLowerCase() === "html") {
	                        editor._cachedHeight = "" + editor.body.style.height;
	                        editor.body.style.height = "100%";
	                    }
	                },
	                "mouseout dragleave drop contextmenu": function(e){
	                    var restoreHeight = function(){
	                        if (editor._cachedHeight !== undefined && e.target === editor.body) {
	                            editor.body.style.height = editor._cachedHeight;
	                            delete editor._cachedHeight;
	                        }
	                    };

	                    if (e.type === "contextmenu") {
	                        setTimeout(function(){
	                            restoreHeight();
	                        }, 10);
	                    } else {
	                        restoreHeight();
	                    }

	                }
	            });

	            this._registerHandler(editor.body, {
	                "keydown": function (e) {
	                    var range;

	                    if ((e.keyCode === keys.BACKSPACE || e.keyCode === keys.DELETE) && editor.body.getAttribute("contenteditable") !== "true") {
	                        return false;
	                    }

	                    if (e.keyCode === keys.F10) {
	                        // Handling with timeout to avoid the default IE menu
	                        setTimeout(proxy(editor.toolbar.focus, editor.toolbar), 100);
	                        editor.toolbar.preventPopupHide = true;
	                        e.preventDefault();
	                        return;
	                    } else if (e.keyCode == keys.LEFT || e.keyCode == keys.RIGHT) {
	                        // skip bom nodes when navigating with arrows
	                        range = editor.getRange();
	                        var left = e.keyCode == keys.LEFT;
	                        var container = range[left ? "startContainer" : "endContainer"];
	                        var offset = range[left ? "startOffset" : "endOffset"];
	                        var direction = left ? -1 : 1;

	                        var next = offset + direction;
	                        var nextChar = left ? next : offset;

	                        if (container.nodeType == 3 && container.nodeValue[nextChar] == "\ufeff") {
	                            range.setStart(container, next);
	                            range.collapse(true);
	                            editor.selectRange(range);
	                        }
	                    }

	                    var tools = editor.toolbar.tools;
	                    var toolName = editor.keyboard.toolFromShortcut(tools, e);
	                    var toolOptions = toolName ? tools[toolName].options : {};
	                    if (toolName && !toolOptions.keyPressCommand) {
	                        e.preventDefault();

	                        if (!/^(undo|redo)$/.test(toolName)) {
	                            editor.keyboard.endTyping(true);
	                        }

	                        editor.trigger("keydown", e);
	                        editor.exec(toolName);
	                        editor._runPostContentKeyCommands(e);

	                        return false;
	                    }

	                    editor.keyboard.clearTimeout();

	                    editor.keyboard.keydown(e);
	                },
	                "keypress": function(e) {
	                    setTimeout(function () {
	                        editor._runPostContentKeyCommands(e);
	                        editor._showTableResizeHandles();
	                    }, 0);
	                },
	                "keyup": function (e) {
	                    var selectionCodes = [
	                       keys.BACKSPACE,
	                       keys.TAB,
	                       keys.PAGEUP,
	                       keys.PAGEDOWN,
	                       keys.END,
	                       keys.HOME,
	                       keys.LEFT,
	                       keys.UP,
	                       keys.RIGHT,
	                       keys.DOWN,
	                       keys.INSERT,
	                       keys.DELETE
	                    ];

	                    if ($.inArray(e.keyCode, selectionCodes) > -1 || (e.keyCode == 65 && e.ctrlKey && !e.altKey && !e.shiftKey)) {
	                        window.clearTimeout(this._refreshInterval);
	                        this._refreshInterval = window.setTimeout(function(){
	                            editor._selectionChange();
	                        }, REFRESH_INTERVAL);
	                    }

	                    editor.keyboard.keyup(e);
	                },
	                "click": function(e) {
	                    var dom = kendo.ui.editor.Dom, range;

	                    if (dom.name(e.target) === "img") {
	                        range = editor.createRange();
	                        range.selectNode(e.target);
	                        editor.selectRange(range);
	                    }
	                },
	                "cut copy paste drop dragover": function (e) {
	                    editor.clipboard["on" + e.type](e);
	                },
	                "focusin": function () {
	                    if (editor.body.hasAttribute("contenteditable")) {
	                        $(this).addClass("k-state-active");
	                        editor.toolbar.show();
	                        editor._togglePlaceholder(false);
	                    }
	                },
	                "focusout": function() {
	                    setTimeout(function() {
	                        var active = kendo._activeElement();
	                        var body = editor.body;
	                        var toolbar = editor.toolbar;
	                        if (toolbar.options.popup) {
	                            var toolbarContainerElement = toolbar.window.element.get(0);
	                            if (toolbarContainerElement && !($.contains(toolbarContainerElement, active) || toolbarContainerElement == active)) {
	                                toolbar.preventPopupHide = false;
	                            }
	                        }
	                        if (active != body && !$.contains(body, active) && !$(active).is(".k-editortoolbar-dragHandle") && !toolbar.focused()) {
	                            $(body).removeClass("k-state-active");
	                            toolbar.hide();
	                        }

	                        editor._togglePlaceholder(!editor.value().trim());
	                    }, 10);
	                }
	            });

	            editor._initializeColumnResizing();
	            editor._initializeRowResizing();
	            editor._initializeTableResizing();
	        },

	        _initializePlaceholder: function() {
	            var that = this,
	                placeholder = that.options.placeholder,
	                style, $head;

	            if(!that.textarea || !placeholder) {
	                return;
	            }

	            style = "<style id='"+ PLACEHOLDER_TAG_ID +"'>." +
	                        PLACEHOLDER_CLASS +  ":before { content: '"+ placeholder + "'; }" +
	                    "</style>";

	            $head = $(that.document.head);
	            $head.find("#" + PLACEHOLDER_TAG_ID).remove();
	            $head.append(style);

	            that._togglePlaceholder(!that.value().trim());
	        },

	        _initializeImmutables: function(){
	            var that = this,
	                editorNS = kendo.ui.editor;

	            if (that.options.immutables){
	                that.immutables = new editorNS.Immutables(that);
	            }
	        },

	        _mousedown: function (e) {
	            var editor = this;
	            editor._selectionStarted = true;

	            if ($(editor.body).parents('.k-window').length) {
	                e.stopPropagation();
	            }

	            // handle middle-click and ctrl-click on links
	            if (browser.gecko) {
	                return;
	            }

	            var target = $(e.target).closest("a[href]");

	            if ((e.which == 2 || (e.which == 1 && e.ctrlKey)) && target &&  target.is("a[href]")) {
	                window.open(target.attr("href"), "_new");
	            }

	            if(e.target.tagName && e.target.tagName.toLowerCase() === "html") {
	                setTimeout(function(){
	                    editor.body.focus();
	                }, 0);
	            }
	        },

	        _mouseup: function(e) {
	            var that = this;

	            if (kendo.support.mobileOS.ios && e && $(e.target).is(SELECT_OVERLAY_SELECTOR)) {
	                return;
	            }

	            if (that._selectionStarted) {
	                setTimeout(function() {
	                    that._selectionChange();
	                }, 1);
	            }
	        },

	        _runPostContentKeyCommands: function (e) {
	            var range = this.getRange();
	            var tools = this.keyboard.toolsFromShortcut(this.toolbar.tools, e);

	            for (var i = 0; i < tools.length; i++) {
	                var tool = tools[i];
	                var o = tool.options;
	                if (!o.keyPressCommand) {
	                    continue;
	                }

	                var cmd = new o.command({range: range});
	                if (cmd.changesContent()) {
	                    this.keyboard.endTyping(true);
	                    this.exec(tool.name);
	                }
	            }
	        },

	        refresh: function() {
	            var that = this;

	            if (that.textarea) {
	                that._destroyResizings();
	                // preserve updated value before re-initializing
	                // don't use update() to prevent the editor from encoding the content too early
	                var value = that.value();
	                that.textarea.val(value);
	                that.wrapper.find("iframe").remove();
	                that._initializeContentElement(that);
	                that.value(value);
	            }
	        },

	        events: [
	            "select",
	            "change",
	            "execute",
	            "error",
	            "paste",
	            "keydown",
	            "keyup"
	        ],

	        options: {
	            name: "Editor",
	            messages: messages,
	            placeholder: "",
	            formats: {},
	            encoded: true,
	            domain: null,
	            resizable: false,
	            deserialization: {
	                custom: null
	            },
	            serialization: {
	                entities: true,
	                semantic: true,
	                scripts: false
	            },
	            pasteCleanup: {
	                all: false,
	                css: false,
	                custom: null,
	                keepNewLines: false,
	                msAllFormatting: false,
	                msConvertLists: true,
	                msTags: true,
	                none: false,
	                span: false
	            },
	            stylesheets: [],
	            dialogOptions: {
	                modal: true, resizable: false, draggable: true,
	                animation: false
	            },
	            imageBrowser: null,
	            fileBrowser: null,
	            fontName: [
	                { text: "Arial", value: "Arial, Helvetica, sans-serif" },
	                { text: "Courier New", value: "\"Courier New\", Courier, monospace" },
	                { text: "Georgia", value: "Georgia, serif" },
	                { text: "Impact", value: "Impact, Charcoal, sans-serif" },
	                { text: "Lucida Console", value: "\"Lucida Console\", Monaco, monospace" },
	                { text: "Tahoma", value: "Tahoma, Geneva, sans-serif" },
	                { text: "Times New Roman", value: "\"Times New Roman\", Times, serif" },
	                { text: "Trebuchet MS", value: "\"Trebuchet MS\", Helvetica, sans-serif" },
	                { text: "Verdana", value: "Verdana, Geneva, sans-serif" }
	            ],
	            fontSize: [
	                { text: "1 (8pt)",  value: "xx-small" },
	                { text: "2 (10pt)", value: "x-small" },
	                { text: "3 (12pt)", value: "small" },
	                { text: "4 (14pt)", value: "medium" },
	                { text: "5 (18pt)", value: "large" },
	                { text: "6 (24pt)", value: "x-large" },
	                { text: "7 (36pt)", value: "xx-large" }
	            ],
	            formatBlock: [
	                { text: "Paragraph", value: "p" },
	                { text: "Quotation", value: "blockquote" },
	                { text: "Heading 1", value: "h1" },
	                { text: "Heading 2", value: "h2" },
	                { text: "Heading 3", value: "h3" },
	                { text: "Heading 4", value: "h4" },
	                { text: "Heading 5", value: "h5" },
	                { text: "Heading 6", value: "h6" }
	            ],
	            tools: [].concat.call(
	                ["formatting"],
	                toolGroups.basic,
	                toolGroups.alignment,
	                toolGroups.formatPainter,
	                toolGroups.lists,
	                toolGroups.indenting,
	                toolGroups.links,
	                ["insertImage"],
	                toolGroups.tables
	            )
	        },

	        destroy: function() {
	            var editor = this;

	            Widget.fn.destroy.call(this);

	            this._endTyping(true);

	            this._deregisterHandlers();

	            clearTimeout(this._spellCorrectTimeout);

	            this._focusOutside();

	            this.toolbar.destroy();

	            editor._destroyUploadWidget();

	            editor._destroyResizings();

	            kendo.destroy(this.wrapper);
	        },

	        _destroyResizings: function() {
	            var editor = this;

	            editor._destroyTableResizing();
	            kendo.ui.editor.TableResizing.dispose(editor);
	            editor._destroyRowResizing();
	            kendo.ui.editor.RowResizing.dispose(editor);
	            editor._destroyColumnResizing();
	            kendo.ui.editor.ColumnResizing.dispose(editor);
	        },

	        _focusOutside: function () {
	            // move focus outside the Editor, see https://github.com/telerik/kendo/issues/3673
	            if (kendo.support.browser.msie && this.textarea) {
	                var tempInput = $("<input style='position:fixed;left:1px;top:1px;width:1px;height:1px;font-size:0;border:0;opacity:0' />").appendTo(document.body).focus();
	                tempInput.blur().remove();
	            }
	        },

	        _destroyUploadWidget: function(){
	            var editor = this;
	            if (editor._uploadWidget) {
	                editor._uploadWidget.destroy();
	                editor._uploadWidget = null;
	            }
	        },

	        state: function(toolName) {
	            var tool = Editor.defaultTools[toolName];
	            var finder = tool && (tool.options.finder || tool.finder);
	            var RangeUtils = kendo.ui.editor.RangeUtils;
	            var range, textNodes;

	            if (finder) {
	                range = this.getRange();

	                textNodes = RangeUtils.textNodes(range);

	                if (!textNodes.length && range.collapsed) {
	                    textNodes = [range.startContainer];
	                }

	                return finder.getFormat ? finder.getFormat(textNodes) : finder.isFormatted(textNodes);
	            }

	            return false;
	        },

	        value: function (html) {
	            var body = this.body,
	                editorNS = kendo.ui.editor,
	                options = this.options,
	                currentHtml = editorNS.Serializer.domToXhtml(body, options.serialization);

	            if (html === undefined) {
	                return currentHtml;
	            }

	            if (html == currentHtml) {
	                return;
	            }

	            editorNS.Serializer.htmlToDom(html, body, options.deserialization);

	            this.selectionRestorePoint = null;
	            this.update();

	            this.toolbar.refreshTools();
	        },

	        saveSelection: function(range) {
	            range = range || this.getRange();
	            var container = range.commonAncestorContainer,
	                body = this.body;

	            if (container == body || $.contains(body, container)) {
	                this.selectionRestorePoint = new kendo.ui.editor.RestorePoint(range, body);
	            }
	        },

	        _focusBody: function() {
	            var body = this.body;
	            var iframe = this.wrapper && this.wrapper.find("iframe")[0];
	            var documentElement = this.document.documentElement;
	            var activeElement = kendo._activeElement();
	            var scrollTop;


	            if(!iframe && body.scrollHeight > body.clientHeight) {
	                scrollTop = body.scrollTop;
	                body.focus();
	                body.scrollTop = scrollTop;

	            } else if(activeElement != body && activeElement != iframe) {
	                scrollTop = documentElement.scrollTop;
	                body.focus();
	                documentElement.scrollTop = scrollTop;
	            }
	        },

	        restoreSelection: function() {
	            this._focusBody();

	            if (this.selectionRestorePoint) {
	                this.selectRange(this.selectionRestorePoint.toRange());
	            }
	        },

	        focus: function () {
	            this.restoreSelection();
	        },

	        update: function (value) {
	            value = value || this.options.encoded ? this.encodedValue() : this.value();

	            if (this.textarea) {
	                this.textarea.val(value);
	                this._togglePlaceholder(!value.trim());
	            } else {
	                this._oldValue = value;
	            }
	        },

	        encodedValue: function () {
	            return kendo.ui.editor.Dom.encode(this.value());
	        },

	        createRange: function (document) {
	            return kendo.ui.editor.RangeUtils.createRange(document || this.document);
	        },

	        getSelection: function () {
	            return kendo.ui.editor.SelectionUtils.selectionFromDocument(this.document);
	        },

	        selectRange: function(range) {
	            this._focusBody();
	            var selection = this.getSelection();
	            selection.removeAllRanges();
	            selection.addRange(range);
	            this.saveSelection(range);
	        },

	        getRange: function () {
	            var selection = this.getSelection(),
	                range = selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : this.createRange(),
	                doc = this.document;

	            if (range.startContainer == doc && range.endContainer == doc && !range.startOffset && !range.endOffset) {
	                range.setStart(this.body, 0);
	                range.collapse(true);
	            }

	            return range;
	        },

	        _containsRange: function (range) {
	            var dom = kendo.ui.editor.Dom;
	            var body = this.body;
	            return range && dom.isAncestorOrSelf(body, range.startContainer) &&
	                dom.isAncestorOrSelf(body, range.endContainer);
	        },

	        _deleteSavedRange: function () {
	            if ("_range" in this) {
	                delete this._range;
	            }
	        },

	        selectedHtml: function() {
	            return kendo.ui.editor.Serializer.domToXhtml(this.getRange().cloneContents());
	        },

	        paste: function (html, options) {
	            this.focus();

	            var command = new kendo.ui.editor.InsertHtmlCommand($.extend({
	                range: this.getRange(),
	                html: html
	            }, options));

	            command.editor = this;

	            command.exec();
	        },

	        exec: function (name, params) {
	            var that = this;
	            var command = null;
	            var range, tool, prevented;

	            if (!name) {
	                throw new Error("kendoEditor.exec(): `name` parameter cannot be empty");
	            }

	            if (that.body.getAttribute("contenteditable") !== "true" &&
	                name !== "print" &&
	                name !== "pdf" &&
	                name !== "exportAs") {
	                return false;
	            }

	            name = name.toLowerCase();

	            if (!that.keyboard.isTypingInProgress()) {
	                that._focusBody();
	                that.selectRange(that._range || that.getRange());
	            }

	            tool = that.toolbar.toolById(name);

	            if (!tool) {
	                // execute non-toolbar tool
	                for (var id in Editor.defaultTools) {
	                    if (id.toLowerCase() == name) {
	                        tool = Editor.defaultTools[id];
	                        break;
	                    }
	                }
	            }

	            if (tool) {
	                range = that.getRange();

	                if (tool.command) {
	                    command = tool.command(extend({ range: range, body: that.body, immutables: !!that.immutables }, params));
	                }

	                prevented = that.trigger("execute", { name: name, command: command });

	                if (prevented) {
	                    return;
	                }

	                if (/^(undo|redo)$/i.test(name)) {
	                    that.undoRedoStack[name]();
	                } else if (command) {
	                    that.execCommand(command);

	                    if (command.async) {
	                        command.change = proxy(that._selectionChange, that);
	                        return;
	                    }
	                }

	                that._selectionChange();
	            }
	        },

	        execCommand: function(command) {
	            if (!command.managesUndoRedo) {
	                this.undoRedoStack.push(command);
	            }

	            command.editor = this;
	            command.exec();
	        }
	    });

	    Editor.defaultTools = {
	        undo: { options: { key: "Z", ctrl: true } },
	        redo: { options: { key: "Y", ctrl: true } }
	    };

	    kendo.ui.plugin(Editor);

	    var Tool = Class.extend({
	        init: function(options) {
	            this.options = options;
	        },

	        initialize: function(ui, options) {
	            ui.attr({ unselectable: "on", title: options.title, "aria-label": options.title });
	        },

	        command: function (commandArguments) {
	            return new this.options.command(commandArguments);
	        },

	        update: $.noop
	    });

	    Tool.exec = function (editor, name, value) {
	        editor.exec(name, { value: value });
	    };

	    EditorUtils.registerTool("separator", new Tool({ template: new ToolTemplate({template: EditorUtils.separatorTemplate})}));

	    // Exports ================================================================

	    var bomFill = browser.msie && browser.version < 9 ? '\ufeff' : '';
	    var emptyElementContent = '\ufeff';
	    var emptyTableCellContent = emptyElementContent;

	    if(browser.msie || browser.edge) {
	        emptyTableCellContent = emptyElementContent = "&nbsp;";
	    }

	    extend(kendo.ui, {
	        editor: {
	            ToolTemplate: ToolTemplate,
	            EditorUtils: EditorUtils,
	            Tool: Tool,
	            _bomFill: bomFill,
	            emptyElementContent: emptyElementContent,
	            emptyTableCellContent: emptyTableCellContent
	        }
	    });

	    if (kendo.PDFMixin) {
	        kendo.PDFMixin.extend(Editor.prototype);
	        Editor.prototype._drawPDF = function() {
	            return kendo.drawing.drawDOM(this.body, this.options.pdf);
	        };
	        Editor.prototype.saveAsPDF = function() {
	            var progress = new $.Deferred();
	            var promise = progress.promise();
	            var args = { promise: promise };

	            if (this.trigger("pdfExport", args)) {
	                return;
	            }

	            var options = this.options.pdf;

	            this._drawPDF(progress)
	            .then(function(root) {
	                return kendo.drawing.exportPDF(root, options);
	            })
	            .done(function(dataURI) {
	                kendo.saveAs({
	                    dataURI: dataURI,
	                    fileName: options.fileName,
	                    proxyURL: options.proxyURL,
	                    proxyTarget: options.proxyTarget,
	                    forceProxy: options.forceProxy
	                });
	                progress.resolve();
	            })
	            .fail(function(err) {
	                progress.reject(err);
	            });

	            return promise;
	        };
	    }

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 966:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("xTQk");

/***/ }),

/***/ 967:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CRfZ");

/***/ }),

/***/ 968:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1Z35");

/***/ }),

/***/ 969:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("3Bvt");

/***/ })

/******/ });

/***/ }),

/***/ "2btM":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1174);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1174:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "dom",
	    name: "Virtual DOM",
	    category: "framework",
	    depends: [ "core" ],
	    advanced: true
	};

	(function(kendo) {
	    function Node() {
	        this.node = null;
	    }

	    Node.prototype = {
	        remove: function() {
	            if (this.node.parentNode) {
	                this.node.parentNode.removeChild(this.node);
	            }
	            this.attr = {};
	        },
	        attr: {},
	        text: function() {
	            return "";
	        }
	    };

	    function NullNode() {
	    }

	    NullNode.prototype = {
	        nodeName: "#null",
	        attr: { style: {} },
	        children: [],
	        remove: function() {
	        }
	    };

	    var NULL_NODE = new NullNode();

	    function Element(nodeName, attr, children) {
	        this.nodeName = nodeName;

	        this.attr = attr || {};

	        this.children = children || [];
	    }

	    Element.prototype = new Node();

	    Element.prototype.appendTo = function(parent) {
	        var node = document.createElement(this.nodeName);

	        var children = this.children;

	        for (var index = 0; index < children.length; index++) {
	            children[index].render(node, NULL_NODE);
	        }

	        parent.appendChild(node);

	        return node;
	    };

	    Element.prototype.render = function(parent, cached) {
	        var node;

	        if (cached.nodeName !== this.nodeName) {
	            cached.remove();

	            node = this.appendTo(parent);
	        } else {
	            node = cached.node;

	            var index;

	            var children = this.children;

	            var length = children.length;

	            var cachedChildren = cached.children;

	            var cachedLength = cachedChildren.length;

	            if (Math.abs(cachedLength - length) > 2) {
	                this.render({
	                    appendChild: function(node) {
	                        parent.replaceChild(node, cached.node);
	                    }
	                }, NULL_NODE);

	                return;
	            }

	            for (index = 0; index < length; index++) {
	                children[index].render(node, cachedChildren[index] || NULL_NODE);
	            }

	            for (index = length; index < cachedLength; index++) {
	                cachedChildren[index].remove();
	            }
	        }

	        this.node = node;

	        this.syncAttributes(cached.attr);

	        this.removeAttributes(cached.attr);
	    };

	    Element.prototype.syncAttributes = function(cachedAttr) {
	        var attr = this.attr;

	        for (var name in attr) {
	            var value = attr[name];

	            var cachedValue = cachedAttr[name];

	            if (name === "style") {
	                this.setStyle(value, cachedValue);
	            } else if (value !== cachedValue) {
	                this.setAttribute(name, value, cachedValue);
	            }
	        }
	    };

	    Element.prototype.setStyle = function(style, cachedValue) {
	        var node = this.node;
	        var key;

	        if (cachedValue) {
	            for (key in style) {
	                if (style[key] !== cachedValue[key]) {
	                    node.style[key] = style[key];
	                }
	            }
	        } else {
	            for (key in style) {
	                node.style[key] = style[key];
	            }
	        }
	    };

	    Element.prototype.removeStyle = function(cachedStyle) {
	        var style = this.attr.style || {};
	        var node = this.node;

	        for (var key in cachedStyle) {
	            if (style[key] === undefined) {
	                node.style[key] = "";
	            }
	        }
	    };

	    Element.prototype.removeAttributes = function(cachedAttr) {
	        var attr = this.attr;

	        for (var name in cachedAttr) {
	            if (name === "style") {
	                this.removeStyle(cachedAttr.style);
	            } else if (attr[name] === undefined) {
	                this.removeAttribute(name);
	            }
	        }
	    };

	    Element.prototype.removeAttribute = function(name) {
	        var node = this.node;

	        if (name === "style") {
	            node.style.cssText = "";
	        } else if (name === "className") {
	            node.className = "";
	        } else {
	            node.removeAttribute(name);
	        }
	    };

	    Element.prototype.setAttribute = function(name, value) {
	        var node = this.node;

	        if (node[name] !== undefined) {
	            node[name] = value;
	        } else {
	            node.setAttribute(name, value);
	        }
	    };

	    Element.prototype.text = function() {
	        var str = "";
	        for (var i = 0; i < this.children.length; ++i) {
	            str += this.children[i].text();
	        }
	        return str;
	    };

	    function TextNode(nodeValue) {
	        this.nodeValue = String(nodeValue);
	    }

	    TextNode.prototype = new Node();

	    TextNode.prototype.nodeName = "#text";

	    TextNode.prototype.render = function(parent, cached) {
	        var node;

	        if (cached.nodeName !== this.nodeName) {
	            cached.remove();

	            node = document.createTextNode(this.nodeValue);

	            parent.appendChild(node);
	        } else {
	            node = cached.node;

	            if (this.nodeValue !== cached.nodeValue) {
	                if (node.parentNode) {
	                    // sometimes in IE parentNode is null (reason unknown),
	                    // and IE throws an error when you try to set a
	                    // parentless' nodeValue, because why not.
	                    node.nodeValue = this.nodeValue;
	                }
	            }
	        }

	        this.node = node;
	    };

	    TextNode.prototype.text = function() {
	        return this.nodeValue;
	    };

	    function HtmlNode(html) {
	        this.html = html;
	    }

	    HtmlNode.prototype = {
	       nodeName: "#html",
	       attr: {},
	       remove: function() {
	           for (var index = 0; index < this.nodes.length; index++) {
	               var el = this.nodes[index];
	               if (el.parentNode) {
	                   el.parentNode.removeChild(el);
	               }
	           }
	       },
	       render: function(parent, cached) {
	           if (cached.nodeName !== this.nodeName || cached.html !== this.html) {
	               cached.remove();

	               var lastChild = parent.lastChild;

	               insertHtml(parent, this.html);

	               this.nodes = [];

	               for (var child = lastChild ? lastChild.nextSibling : parent.firstChild; child; child = child.nextSibling) {
	                   this.nodes.push(child);
	               }
	           } else {
	               this.nodes = cached.nodes.slice(0);
	           }
	       }
	    };

	    var HTML_CONTAINER = document.createElement("div");

	    function insertHtml(node, html) {
	        HTML_CONTAINER.innerHTML = html;

	        while (HTML_CONTAINER.firstChild) {
	            node.appendChild(HTML_CONTAINER.firstChild);
	        }
	    }

	    function html(value) {
	        return new HtmlNode(value);
	    }

	    function element(nodeName, attrs, children) {
	        return new Element(nodeName, attrs, children);
	    }

	    function text(value) {
	        return new TextNode(value);
	    }

	    function Tree(root) {
	       this.root = root;
	       this.children = [];
	    }

	    Tree.prototype = {
	        html: html,
	        element: element,
	        text: text,
	        render: function(children) {
	            var cachedChildren = this.children;

	            var index;

	            var length;

	            for (index = 0, length = children.length; index < length; index++) {
	                var cached = cachedChildren[index];
	                if (!cached) {
	                    cached = NULL_NODE;
	                } else if (!cached.node || !cached.node.parentNode) {
	                    cached.remove();
	                    cached = NULL_NODE;
	                }
	                children[index].render(this.root, cached);
	            }

	            for (index = length; index < cachedChildren.length; index++) {
	                cachedChildren[index].remove();
	            }

	            this.children = children;
	        }
	    };

	    kendo.dom = {
	        html: html,
	        text: text,
	        element: element,
	        Tree: Tree,
	        Node: Node
	    };
	})(window.kendo);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "33E9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var selectCellEditor_1 = __webpack_require__("POfv");
var PopupSelectCellEditor = (function (_super) {
    __extends(PopupSelectCellEditor, _super);
    function PopupSelectCellEditor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopupSelectCellEditor.prototype.isPopup = function () {
        return true;
    };
    return PopupSelectCellEditor;
}(selectCellEditor_1.SelectCellEditor));
exports.PopupSelectCellEditor = PopupSelectCellEditor;


/***/ }),

/***/ "38Th":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1122);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1045:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FTkt");

/***/ }),

/***/ 1110:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nzx/");

/***/ }),

/***/ 1122:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1110), __webpack_require__(1045) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "dataviz.barcode",
	    name: "Barcode",
	    category: "dataviz",
	    description: "Barcode widget",
	    depends: [ "dataviz.core" ]
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,

	        extend = $.extend,
	        deepExtend = kendo.deepExtend,
	        inArray = $.inArray,
	        isPlainObject = $.isPlainObject,

	        draw = kendo.drawing,
	        geom = kendo.geometry,
	        util = kendo.drawing.util,
	        defined = util.defined,
	        dataviz = kendo.dataviz,
	        Box2D = dataviz.Box2D,
	        TextBox = dataviz.TextBox,
	        DEFAULT_WIDTH = 300,
	        DEFAULT_HEIGHT = 100,
	        DEFAULT_QUIETZONE_LENGTH = 10,
	        numberRegex = /^\d+$/,
	        alphanumericRegex = /^[a-z0-9]+$/i,
	        InvalidCharacterErrorTemplate = "Character '{0}' is not valid for symbology {1}";

	    function getNext(value, index, count){
	        return value.substring(index, index + count);
	    }

	    var Encoding  = kendo.Class.extend({
	        init: function (options) {
	            this.setOptions(options);
	        },
	        setOptions: function(options){
	            var that = this;
	            that.options = extend({}, that.options, options);
	            that.quietZoneLength = that.options.addQuietZone ? 2 * that.options.quietZoneLength : 0;
	        },
	        encode: function (value, width, height) {
	            var that = this;
	            if (defined(value)) {
	                value+='';
	            }

	            that.initValue(value, width, height);

	            if (that.options.addQuietZone) {
	                that.addQuietZone();
	            }

	            that.addData();

	            if (that.options.addQuietZone) {
	                that.addQuietZone();
	            }

	            return {
	                baseUnit: that.baseUnit,
	                pattern: that.pattern
	            };
	        },
	        options: {
	            quietZoneLength: DEFAULT_QUIETZONE_LENGTH,
	            addQuietZone: true,
	            addCheckSum: true
	        },
	        initValue: function () {},
	        addQuietZone: function () {
	            this.pattern.push(this.options.quietZoneLength || DEFAULT_QUIETZONE_LENGTH);
	        },
	        addData: function () {
	        },
	        invalidCharacterError: function(character){
	            throw new Error(kendo.format(InvalidCharacterErrorTemplate, character, this.name));
	        }
	    });

	    var encodings = {};

	    var code39Base = Encoding.extend({
	        minBaseUnitLength: 0.7,
	        addData: function(){
	            var that = this,
	                value  = that.value;

	            that.addStart();

	            for(var idx = 0; idx < value.length; idx++){
	                that.addCharacter(value.charAt(idx));
	            }

	            if(that.options.addCheckSum){
	                that.pushCheckSum();
	            }

	            that.addStop();
	            that.prepareValues();
	        },
	        addCharacter: function(character){
	            var that = this,
	                charData = that.characterMap[character];
	            if(!charData){
	                that.invalidCharacterError(character);
	            }
	            that.addBase(charData);
	        },
	        addBase: function(){}
	    });

	    var code39ExtendedBase = {
	        addCharacter: function(character){
	            var that = this;
	            if(that.characterMap[character]){
	                that.addBase(that.characterMap[character]);
	            }
	            else if(character.charCodeAt(0) > 127){
	                that.invalidCharacterError(character);
	            }
	            else{
	                that.addExtended(character.charCodeAt(0));
	            }
	        },
	        addExtended: function(code){
	            var that = this,
	                patterns;
	            for(var i = 0; i < that.extendedMappings.length; i++){
	                if((patterns = that.extendedMappings[i].call(that, code))){
	                    for(var j = 0; j < patterns.length; j++){
	                        that.addBase(patterns[j]);
	                    }
	                    that.dataLength+= patterns.length - 1;
	                    return;
	                }
	            }
	        },
	        extendedMappings: [
	            function(code){
	                if(97 <= code && code <= 122){
	                    var that = this;
	                    return [that.characterMap[that.shiftCharacters[0]], that.characterMap[String.fromCharCode(code - 32)]];
	                }
	            },
	            function(code){
	                if(33 <= code && code <= 58){
	                    var that = this;
	                    return [that.characterMap[that.shiftCharacters[1]], that.characterMap[String.fromCharCode(code + 32)]];
	                }
	            },
	            function(code){
	                if(1 <= code && code <= 26){
	                    var that = this;
	                    return [that.characterMap[that.shiftCharacters[2]], that.characterMap[String.fromCharCode(code + 64)]];
	                }
	            },
	            function(code){
	                var that = this,
	                    result,
	                    dataCharacter;
	                if(!that.specialAsciiCodes[code]){
	                    dataCharacter =  Math.floor(code / 32) * 6 + (code - 27) % 32 + 64;
	                    result = [that.characterMap[that.shiftCharacters[3]], that.characterMap[String.fromCharCode(dataCharacter)]];
	                }
	                else{
	                    result = [];
	                    for(var i = 0; i < that.specialAsciiCodes[code].length; i++){
	                        result.push(that.characterMap[that.shiftCharacters[3]]);
	                        result.push(that.characterMap[that.specialAsciiCodes[code][i]]);
	                    }
	                }

	                return result;
	            }
	        ],
	        specialAsciiCodes: {
	            "0": ["U"],
	            "64": ["V"],
	            "96": ["W"],
	            "127": ["T","X","Y","Z"]
	        },
	        shiftValuesAsciiCodes:{
	            "39": 36,
	            "40": 47,
	            "41": 43,
	            "42": 37
	        },
	        characterMap: {
	            "+": false,
	            "/": false,
	            "$": false,
	            "%": false
	        },
	        shiftCharacters: ["SHIFT0", "SHIFT1", "SHIFT2", "SHIFT3"]
	    };

	    encodings.code39 =  code39Base.extend({
	        name: "Code 39",
	        checkSumMod: 43,
	        minRatio: 2.5,
	        maxRatio: 3,
	        gapWidth: 1,
	        splitCharacter: "|",
	        initValue: function (value, width, height) {
	            var that = this;
	            that.width = width;
	            that.height = height;
	            that.value = value;
	            that.dataLength = value.length;
	            that.pattern = [];
	            that.patternString = "";
	        },
	        prepareValues: function(){
	            var that = this,
	                baseUnit,
	                minBaseUnit = that.minBaseUnitLength,
	                ratio = that.maxRatio,
	                minRatio = that.minRatio,
	                minHeight = Math.max(0.15 * that.width, 24);
	            if (that.height < minHeight) {
	                throw new Error("Insufficient Height. The minimum height for value: " + that.value + " is: " + minHeight);
	            }

	            while((baseUnit = that.getBaseUnit(ratio)) < minBaseUnit && ratio > minRatio){
	                ratio = parseFloat((ratio - 0.1).toFixed(1));
	            }

	            if(baseUnit < minBaseUnit){
	                var minWidth = Math.ceil(that.getBaseWidth(minRatio) * minBaseUnit);
	                throw new Error("Insufficient width. The minimum width for value: " + that.value + " is: " + minWidth);
	            }

	            that.ratio = ratio;
	            that.baseUnit = baseUnit;
	            that.patternString = that.patternString.substring(0, that.patternString.length - 1);
	            that.pattern = that.pattern.concat(that.patternString.replace(/ratio/g, ratio).split(that.splitCharacter));
	        },
	        getBaseUnit: function(ratio){
	            return this.width / this.getBaseWidth(ratio);
	        },
	        getBaseWidth: function(ratio){
	            var that = this,
	                characterLength = 3 * (ratio + 2);
	            return that.quietZoneLength + characterLength * (that.dataLength + 2) + that.gapWidth * (that.dataLength + 1);
	        },
	        addStart: function () {
	            var that = this;
	            that.addPattern(that.characterMap.START.pattern);
	            that.addCharacterGap();
	        },
	        addBase: function(character){
	            this.addPattern(character.pattern);
	            this.addCharacterGap();
	        },
	        addStop: function () {
	            this.addPattern(this.characterMap.START.pattern);
	        },
	        addPattern: function (pattern) {
	            for (var i = 0; i < pattern.length; i++) {
	                 this.patternString+= this.patternMappings[pattern.charAt(i)];
	            }
	        },
	        addCharacterGap: function () {
	            var that = this;
	            that.patternString+=that.gapWidth + that.splitCharacter;
	        },
	        patternMappings: {
	            "b": "1|",
	            "w": "1|",
	            "B": "ratio|",
	            "W": "ratio|"
	        },
	        characterMap: {
	            "0":{"pattern":"bwbWBwBwb","value":0},
	            "1":{"pattern":"BwbWbwbwB","value":1},
	            "2":{"pattern":"bwBWbwbwB","value":2},
	            "3":{"pattern":"BwBWbwbwb","value":3},
	            "4":{"pattern":"bwbWBwbwB","value":4},
	            "5":{"pattern":"BwbWBwbwb","value":5},
	            "6":{"pattern":"bwBWBwbwb","value":6},
	            "7":{"pattern":"bwbWbwBwB","value":7},
	            "8":{"pattern":"BwbWbwBwb","value":8},
	            "9":{"pattern":"bwBWbwBwb","value":9},
	            "A":{"pattern":"BwbwbWbwB","value":10},
	            "B":{"pattern":"bwBwbWbwB","value":11},
	            "C":{"pattern":"BwBwbWbwb","value":12},
	            "D":{"pattern":"bwbwBWbwB","value":13},
	            "E":{"pattern":"BwbwBWbwb","value":14},
	            "F":{"pattern":"bwBwBWbwb","value":15},
	            "G":{"pattern":"bwbwbWBwB","value":16},
	            "H":{"pattern":"BwbwbWBwb","value":17},
	            "I":{"pattern":"bwBwbWBwb","value":18},
	            "J":{"pattern":"bwbwBWBwb","value":19},
	            "K":{"pattern":"BwbwbwbWB","value":20},
	            "L":{"pattern":"bwBwbwbWB","value":21},
	            "M":{"pattern":"BwBwbwbWb","value":22},
	            "N":{"pattern":"bwbwBwbWB","value":23},
	            "O":{"pattern":"BwbwBwbWb","value":24},
	            "P":{"pattern":"bwBwBwbWb","value":25},
	            "Q":{"pattern":"bwbwbwBWB","value":26},
	            "R":{"pattern":"BwbwbwBWb","value":27},
	            "S":{"pattern":"bwBwbwBWb","value":28},
	            "T":{"pattern":"bwbwBwBWb","value":29},
	            "U":{"pattern":"BWbwbwbwB","value":30},
	            "V":{"pattern":"bWBwbwbwB","value":31},
	            "W":{"pattern":"BWBwbwbwb","value":32},
	            "X":{"pattern":"bWbwBwbwB","value":33},
	            "Y":{"pattern":"BWbwBwbwb","value":34},
	            "Z":{"pattern":"bWBwBwbwb","value":35},
	            "-":{"pattern":"bWbwbwBwB","value":36},
	            ".":{"pattern":"BWbwbwBwb","value":37},
	            " ":{"pattern":"bWBwbwBwb","value":38},
	            "$":{"pattern":"bWbWbWbwb","value":39},
	            "/":{"pattern":"bWbWbwbWb","value":40},
	            "+":{"pattern":"bWbwbWbWb","value":41},
	            "%":{"pattern":"bwbWbWbWb","value":42},
	            START: { pattern: "bWbwBwBwb"}
	        },
	        options: {
	            addCheckSum: false
	        }
	    });

	    encodings.code39extended = encodings.code39.extend(deepExtend({}, code39ExtendedBase, {
	        name: "Code 39 extended",
	        characterMap: {
	            SHIFT0: {"pattern":"bWbwbWbWb","value":41},
	            SHIFT1: {"pattern":"bWbWbwbWb","value":40},
	            SHIFT2: {"pattern":"bWbWbWbwb","value":39},
	            SHIFT3: {"pattern":"bwbWbWbWb","value":42}
	        }
	    }));

	    encodings.code93 = code39Base.extend({
	        name: "Code 93",
	        cCheckSumTotal: 20,
	        kCheckSumTotal: 15,
	        checkSumMod: 47,
	        initValue: function(value, width, height){
	            var that = this;
	            that.value = value;
	            that.width = width;
	            that.height = height;
	            that.pattern = [];
	            that.values = [];
	            that.dataLength = value.length;
	        },
	        prepareValues: function(){
	            var that = this,
	                minHeight = Math.max(0.15 * that.width, 24);
	            if (that.height < minHeight) {
	                throw new Error("Insufficient Height");
	            }

	            that.setBaseUnit();

	            if(that.baseUnit < that.minBaseUnitLength){
	                throw new Error("Insufficient Width");
	            }
	        },
	        setBaseUnit: function(){
	            var that = this,
	                checkSumLength = 2;
	            that.baseUnit = that.width / (9 * (that.dataLength + 2 + checkSumLength) + that.quietZoneLength + 1);
	        },
	        addStart: function(){
	            var pattern = this.characterMap.START.pattern;
	            this.addPattern(pattern);
	        },
	        addStop: function(){
	            var that = this;
	            that.addStart();
	            that.pattern.push(that.characterMap.TERMINATION_BAR);
	        },
	        addBase: function(charData){
	            this.addPattern(charData.pattern);
	            this.values.push(charData.value);
	        },
	        pushCheckSum: function(){
	            var that = this,
	                checkValues = that._getCheckValues(),
	                charData;

	            that.checksum = checkValues.join("");
	            for(var i = 0; i < checkValues.length; i++){
	                charData = that.characterMap[that._findCharacterByValue(checkValues[i])];
	                that.addPattern(charData.pattern);
	            }
	        },
	        _getCheckValues: function(){
	            var that = this,
	                values = that.values,
	                length = values.length,
	                wightedSum = 0,
	                cValue,
	                kValue,
	                idx;

	            for(idx = length - 1; idx >= 0; idx--){
	                wightedSum += that.weightedValue(values[idx],length - idx, that.cCheckSumTotal);
	            }
	            cValue = wightedSum % that.checkSumMod;

	            wightedSum = that.weightedValue(cValue, 1, that.kCheckSumTotal);
	            for(idx = length - 1; idx >= 0; idx--){
	                wightedSum += that.weightedValue(values[idx], length - idx + 1, that.kCheckSumTotal);
	            }

	            kValue = wightedSum % that.checkSumMod;
	            return [cValue, kValue];
	        },
	        _findCharacterByValue: function (value) {
	            for (var character in this.characterMap) {
	                if (this.characterMap[character].value === value) {
	                    return character;
	                }
	            }
	        },
	        weightedValue: function(value, index, total){
	            return (index % total || total) * value;
	        },
	        addPattern: function(pattern){
	            var value;

	            for(var i = 0; i < pattern.length; i++){
	                value = parseInt(pattern.charAt(i),10);
	                this.pattern.push(value);
	            }
	        },
	        characterMap: {
	            "0":{"pattern":"131112","value":0},
	            "1":{"pattern":"111213","value":1},
	            "2":{"pattern":"111312","value":2},
	            "3":{"pattern":"111411","value":3},
	            "4":{"pattern":"121113","value":4},
	            "5":{"pattern":"121212","value":5},
	            "6":{"pattern":"121311","value":6},
	            "7":{"pattern":"111114","value":7},
	            "8":{"pattern":"131211","value":8},
	            "9":{"pattern":"141111","value":9},
	            "A":{"pattern":"211113","value":10},
	            "B":{"pattern":"211212","value":11},
	            "C":{"pattern":"211311","value":12},
	            "D":{"pattern":"221112","value":13},
	            "E":{"pattern":"221211","value":14},
	            "F":{"pattern":"231111","value":15},
	            "G":{"pattern":"112113","value":16},
	            "H":{"pattern":"112212","value":17},
	            "I":{"pattern":"112311","value":18},
	            "J":{"pattern":"122112","value":19},
	            "K":{"pattern":"132111","value":20},
	            "L":{"pattern":"111123","value":21},
	            "M":{"pattern":"111222","value":22},
	            "N":{"pattern":"111321","value":23},
	            "O":{"pattern":"121122","value":24},
	            "P":{"pattern":"131121","value":25},
	            "Q":{"pattern":"212112","value":26},
	            "R":{"pattern":"212211","value":27},
	            "S":{"pattern":"211122","value":28},
	            "T":{"pattern":"211221","value":29},
	            "U":{"pattern":"221121","value":30},
	            "V":{"pattern":"222111","value":31},
	            "W":{"pattern":"112122","value":32},
	            "X":{"pattern":"112221","value":33},
	            "Y":{"pattern":"122121","value":34},
	            "Z":{"pattern":"123111","value":35},
	            "-":{"pattern":"121131","value":36},
	            ".":{"pattern":"311112","value":37},
	            " ":{"pattern":"311211","value":38},
	            "$":{"pattern":"321111","value":39},
	            "/":{"pattern":"112131","value":40},
	            "+":{"pattern":"113121","value":41},
	            "%":{"pattern":"211131","value":42},
	            SHIFT0:{"pattern":"122211","value":46},
	            SHIFT1:{"pattern":"311121","value":45},
	            SHIFT2:{"pattern":"121221","value":43},
	            SHIFT3:{"pattern":"312111","value":44},
	            START: {"pattern":"111141"},
	            TERMINATION_BAR: "1"
	        }
	    });

	    encodings.code93extended = encodings.code93.extend(deepExtend({}, code39ExtendedBase, {
	        name: "Code 93 extended",
	        pushCheckSum: function(){
	            var that = this,
	                checkValues = that._getCheckValues(),
	                value;

	            that.checksum = checkValues.join("");

	            for(var i = 0; i < checkValues.length; i++){
	                value = checkValues[i];
	                if(that.shiftValuesAsciiCodes[value]){
	                    that.addExtended(that.shiftValuesAsciiCodes[value]);
	                }
	                else{
	                    that.addPattern(that.characterMap[that._findCharacterByValue(value)].pattern);
	                }
	            }
	        }
	    }));

	    var state128 = kendo.Class.extend({
	        init: function(encoding){
	            this.encoding = encoding;
	        },
	        addStart: function(){},
	        is: function (){},
	        move: function (){},
	        pushState: function(){}
	    });

	    var state128AB = state128.extend({
	        FNC4: "FNC4",
	        init: function(encoding, states){
	            var that = this;
	            that.encoding = encoding;
	            that.states = states;
	            that._initMoves(states);
	        },
	        addStart: function(){
	            this.encoding.addPattern(this.START);
	        },
	        is: function (value, index){
	            var code = value.charCodeAt(index);
	            return this.isCode(code);
	        },
	        move: function(encodingState){
	            var that = this,
	                idx = 0;

	            while(!that._moves[idx].call(that, encodingState) && idx < that._moves.length){
	                idx++;
	            }
	        },
	        pushState: function(encodingState){
	            var that = this,
	                states = that.states,
	                value = encodingState.value,
	                maxLength = value.length,
	                code;

	            if(inArray("C", states) >= 0){
	                var numberMatch = value.substr(encodingState.index).match(/\d{4,}/g);
	                if(numberMatch){
	                    maxLength = value.indexOf(numberMatch[0], encodingState.index);
	                }
	            }

	            while((code = encodingState.value.charCodeAt(encodingState.index)) >= 0 &&
	                that.isCode(code) && encodingState.index < maxLength){
	                that.encoding.addPattern(that.getValue(code));
	                encodingState.index++;
	            }
	        },
	        _initMoves: function(states){
	            var that = this;
	            that._moves = [];

	            if(inArray(that.FNC4, states) >= 0){
	                that._moves.push(that._moveFNC);
	            }

	            if(inArray(that.shiftKey, states) >= 0){
	                that._moves.push(that._shiftState);
	            }
	            that._moves.push(that._moveState);
	        },
	        _moveFNC: function(encodingState){
	            if(encodingState.fnc){
	                encodingState.fnc = false;
	                return encodingState.previousState == this.key;
	            }
	        },
	        _shiftState: function(encodingState){
	            var that = this;
	            if(encodingState.previousState == that.shiftKey &&
	                (encodingState.index + 1 >= encodingState.value.length ||
	                    that.encoding[that.shiftKey].is(encodingState.value, encodingState.index + 1))){
	                that.encoding.addPattern(that.SHIFT);
	                encodingState.shifted = true;
	                return true;
	            }
	        },
	        _moveState: function(){
	            this.encoding.addPattern(this.MOVE);
	            return true;
	        },
	        SHIFT: 98
	    });

	    var states128 = {};

	    states128.A = state128AB.extend({
	        key: "A",
	        shiftKey: "B",
	        isCode: function(code){
	            return 0 <= code && code < 96;
	        },
	        getValue: function(code){
	            if(code < 32){
	                return code + 64;
	            }

	            return code - 32;
	        },
	        MOVE: 101,
	        START: 103
	    });

	    states128.B = state128AB.extend({
	        key: "B",
	        shiftKey: "A",
	        isCode: function(code){
	            return 32 <= code && code < 128;
	        },
	        getValue: function(code){
	            return code - 32;
	        },
	        MOVE: 100,
	        START: 104
	    });

	    states128.C = state128.extend({
	        key: "C",
	        addStart: function(){
	            this.encoding.addPattern(this.START);
	        },
	        is: function (value, index){
	            var next4 = getNext(value, index, 4);
	            return (index + 4 <= value.length || value.length == 2) && numberRegex.test(next4);
	        },
	        move: function (){
	            this.encoding.addPattern(this.MOVE);
	        },
	        pushState: function(encodingState){
	            var code;
	            while(( code = getNext(encodingState.value, encodingState.index, 2)) &&
	                numberRegex.test(code) && code.length == 2)
	            {
	                this.encoding.addPattern(parseInt(code, 10));
	                encodingState.index+=2;
	            }
	        },
	        getValue: function(code){
	            return code;
	        },
	        MOVE: 99,
	        START: 105
	    });

	    states128.FNC4 = state128.extend({
	        key: "FNC4",
	        dependentStates: ["A","B"],
	        init: function(encoding, states){
	            this.encoding = encoding;
	            this._initSubStates(states);
	        },
	        addStart: function(encodingState){
	            var code = encodingState.value.charCodeAt(0) - 128,
	                subState = this._getSubState(code);

	            this.encoding[subState].addStart();
	        },
	        is: function(value, index){
	            var code = value.charCodeAt(index);
	            return this.isCode(code);
	        },
	        isCode: function(code){
	            return 128 <= code && code < 256;
	        },
	        pushState: function(encodingState){
	            var that = this,
	                subState = that._initSubState(encodingState),
	                encoding = that.encoding,
	                length = subState.value.length;
	            encodingState.index += length;

	            if(length < 3){
	                var code;
	                for(; subState.index < length; subState.index++){
	                    code = subState.value.charCodeAt(subState.index);
	                    subState.state = that._getSubState(code);
	                    if(subState.previousState != subState.state){
	                        subState.previousState = subState.state;
	                        encoding[subState.state].move(subState);
	                    }
	                    encoding.addPattern(encoding[subState.state].MOVE);
	                    encoding.addPattern(encoding[subState.state].getValue(code));
	                }
	            }
	            else{
	                if(subState.state != subState.previousState){
	                    encoding[subState.state].move(subState);
	                }
	                that._pushStart(subState);
	                encoding.pushData(subState, that.subStates);
	                if(encodingState.index < encodingState.value.length){
	                    that._pushStart(subState);
	                }
	            }

	            encodingState.fnc = true;
	            encodingState.state = subState.state;
	        },
	        _pushStart: function(subState){
	            var that = this;
	            that.encoding.addPattern(that.encoding[subState.state].MOVE);
	            that.encoding.addPattern(that.encoding[subState.state].MOVE);
	        },
	        _initSubState: function(encodingState){
	            var that = this,
	                subState = {
	                    value: that._getAll(encodingState.value, encodingState.index),
	                    index: 0
	                };
	            subState.state = that._getSubState(subState.value.charCodeAt(0));
	            subState.previousState = encodingState.previousState == that.key ?
	                subState.state : encodingState.previousState;
	            return subState;
	        },
	        _initSubStates: function(states){
	            var that = this;
	            that.subStates = [];
	            for(var i = 0; i < states.length; i++){
	                if(inArray(states[i], that.dependentStates) >= 0){
	                    that.subStates.push(states[i]);
	                }
	            }
	        },
	        _getSubState: function(code){
	            var that = this;
	            for(var i = 0; i < that.subStates.length; i++){
	                if(that.encoding[that.subStates[i]].isCode(code)){
	                    return that.subStates[i];
	                }
	            }
	        },
	        _getAll: function(value, index){
	            var code,
	                result = "";
	            while((code = value.charCodeAt(index++)) && this.isCode(code)){
	                result += String.fromCharCode(code - 128);
	            }
	            return result;
	        }
	    });

	    states128.FNC1 = state128.extend({
	        key: "FNC1",
	        startState: "C",
	        dependentStates: ["C","B"],
	        startAI: "(",
	        endAI: ")",
	        init: function(encoding, states){
	            this.encoding = encoding;
	            this.states = states;
	        },
	        addStart: function(){
	            this.encoding[this.startState].addStart();
	        },
	        is: function(){
	            return inArray(this.key, this.states) >= 0;
	        },
	        pushState: function(encodingState){
	            var that = this,
	                encoding = that.encoding,
	                value = encodingState.value.replace(/\s/g, ""),
	                regexSeparators = new RegExp("[" +  that.startAI + that.endAI + "]", "g"),
	                index = encodingState.index,
	                subState= {
	                    state: that.startState
	                },
	                current,
	                nextStart,
	                separatorLength;

	            encoding.addPattern(that.START);

	            while(true){
	                subState.index = 0;

	                separatorLength = value.charAt(index) === that.startAI ? 2 : 0;
	                current = separatorLength > 0 ? that.getBySeparator(value, index) : that.getByLength(value, index);
	                if(current.ai.length){
	                    nextStart = index + separatorLength + current.id.length + current.ai.length;
	                }
	                else{
	                    nextStart = value.indexOf(that.startAI, index + 1);
	                    if(nextStart < 0){
	                        if(index + current.ai.max + current.id.length + separatorLength < value.length){
	                            throw new Error("Separators are required after variable length identifiers");
	                        }
	                        nextStart = value.length;
	                    }
	                }
	                subState.value = value.substring(index, nextStart).replace(regexSeparators, "");
	                that.validate(current, subState.value);

	                encoding.pushData(subState, that.dependentStates);

	                if(nextStart >= value.length){
	                    break;
	                }

	                index = nextStart;

	                if(subState.state != that.startState){
	                    encoding[that.startState].move(subState);
	                    subState.state = that.startState;
	                }

	                if(!current.ai.length){
	                    encoding.addPattern(that.START);
	                }
	            }
	            encodingState.index = encodingState.value.length;
	        },
	        validate: function(current, value){
	            var code = value.substr(current.id.length),
	                ai = current.ai;
	            if(!ai.type && !numberRegex.test(code)){
	                throw new Error("Application identifier " + current.id+ " is numeric only but contains non numeric character(s).");
	            }

	            if(ai.type == "alphanumeric" && !alphanumericRegex.test(code)){
	                 throw new Error("Application identifier " + current.id+ " is alphanumeric only but contains non alphanumeric character(s).");
	            }

	            if(ai.length && ai.length !== code.length){
	                 throw new Error("Application identifier " + current.id + " must be " + ai.length + " characters long.");
	            }

	            if(ai.min && ai.min > code.length){
	                 throw new Error("Application identifier " + current.id + " must be at least " + ai.min + " characters long.");
	            }

	            if(ai.max && ai.max < code.length){
	                 throw new Error("Application identifier " + current.id + " must be at most " + ai.max + " characters long.");
	            }
	        },
	        getByLength: function(value, index){
	            var that = this,
	                id,
	                ai;
	            for(var i = 2; i <= 4; i++){
	                id = getNext(value, index, i);
	                ai = that.getAI(id) || that.getAI(id.substring(0, id.length - 1));
	                if(ai){
	                    return {
	                        id: id,
	                        ai: ai
	                    };
	                }
	            }
	            that.unsupportedAIError(id);
	        },
	        unsupportedAIError: function(id){
	            throw new Error(kendo.format("'{0}' is not a supported Application Identifier"),id);
	        },
	        getBySeparator: function(value, index){
	            var that = this,
	                start = value.indexOf(that.startAI, index),
	                end = value.indexOf(that.endAI, start),
	                id = value.substring(start + 1,end),
	                ai = that.getAI(id) || that.getAI(id.substr(id.length - 1));
	            if(!ai){
	                that.unsupportedAIError(id);
	            }

	            return {
	                ai: ai,
	                id: id
	            };
	        },
	        getAI: function(id){
	            var ai = this.applicationIdentifiers,
	                multiKey = ai.multiKey;
	            if(ai[id]){
	                return ai[id];
	            }

	            for(var i = 0; i < multiKey.length; i++){
	                if(multiKey[i].ids && inArray(id, multiKey[i].ids) >= 0){
	                    return multiKey[i].type;
	                }
	                else if(multiKey[i].ranges){
	                    var ranges = multiKey[i].ranges;
	                    for(var j = 0; j < ranges.length; j++){
	                        if(ranges[j][0] <= id && id <= ranges[j][1]){
	                            return multiKey[i].type;
	                        }
	                    }
	                }
	            }
	        },
	        applicationIdentifiers: {
	            "22": {max: 29, type: "alphanumeric"},
	            "402": {length: 17},
	            "7004": {max: 4, type: "alphanumeric"},
	            "242": {max: 6, type: "alphanumeric"},
	            "8020": {max: 25, type: "alphanumeric"},
	            "703": { min: 3, max: 30, type: "alphanumeric"},
	            "8008": { min: 8, max: 12, type: "alphanumeric"},
	            "253": { min: 13, max: 17, type: "alphanumeric"},
	            "8003": { min: 14, max: 30, type: "alphanumeric"},
	            multiKey: [{
	                ids: ["15", "17", "8005", "8100"],
	                ranges: [
	                    [11, 13],
	                    [310, 316],
	                    [320, 336],
	                    [340, 369]
	                ],
	                type: { length: 6}
	            },{
	                ids: ["240", "241", "250", "251", "400", "401", "403", "7002", "8004", "8007", "8110"],
	                ranges: [[90-99]],
	                type: {max: 30, type: "alphanumeric"}
	            },{
	                ids: ["7001"],
	                ranges: [[410, 414]],
	                type: { length: 13}
	            },{
	                ids: ["10","21", "254", "420", "8002"],
	                type: {max: 20, type: "alphanumeric"}
	            },{
	                ids: ["00", "8006", "8017", "8018"],
	                type: {length: 18}
	            },{
	                ids: ["01", "02", "8001"],
	                type: { length: 14}
	            },{
	                ids: ["422"],
	                ranges: [
	                    [424, 426]
	                ],
	                type: {length: 3}
	            },{
	                ids: ["20", "8102"],
	                type: { length: 2}
	            },{
	                ids: ["30","37"],
	                type: {max: 8, type: "alphanumeric"}
	            },{
	                ids: ["390","392"],
	                type: {max: 15, type: "alphanumeric"}
	            },{
	                ids: ["421", "423"],
	                type: { min: 3, max: 15, type: "alphanumeric"}
	            }, {
	                ids: ["391", "393"],
	                type: { min: 3, max: 18, type: "alphanumeric"}
	            },{
	                ids: ["7003", "8101"],
	                type: {length: 10}
	            }]
	        },
	        START: 102
	    });

	    var code128Base = Encoding.extend({
	        init: function (options) {
	            Encoding.fn.init.call(this, options);
	            this._initStates();
	        },
	        _initStates: function(){
	            var that = this;
	            for(var i = 0; i < that.states.length; i++){
	                that[that.states[i]]  = new states128[that.states[i]](that, that.states);
	            }
	        },
	        initValue: function (value, width, height) {
	           var that = this;
	           that.pattern = [];
	           that.value = value;
	           that.width = width;
	           that.height = height;
	           that.checkSum = 0;
	           that.totalUnits = 0;
	           that.index = 0;
	           that.position = 1;
	        },
	        addData: function(){
	            var that = this,
	                encodingState = {
	                    value: that.value,
	                    index: 0,
	                    state: ""
	                };
	            if(that.value.length === 0){
	                return;
	            }

	            encodingState.state =
	                encodingState.previousState = that.getNextState(encodingState, that.states);

	            that.addStart(encodingState);

	            that.pushData(encodingState, that.states);

	            that.addCheckSum();
	            that.addStop();
	            that.setBaseUnit();
	        },
	        pushData: function(encodingState, states){
	            var that = this;
	            while(true){
	                that[encodingState.state].pushState(encodingState);
	                if(encodingState.index >= encodingState.value.length){
	                    break;
	                }

	                if(!encodingState.shifted){
	                    encodingState.previousState = encodingState.state;
	                    encodingState.state  = that.getNextState(encodingState, states);
	                    that[encodingState.state].move(encodingState);
	                }
	                else{
	                   var temp = encodingState.state;
	                   encodingState.state = encodingState.previousState;
	                   encodingState.previousState = temp;
	                   encodingState.shifted = false;
	                }
	            }
	        },
	        addStart: function(encodingState){
	            this[encodingState.state].addStart(encodingState);
	            this.position = 1;
	        },
	        addCheckSum: function(){
	            var that = this;

	            that.checksum = that.checkSum % 103;
	            that.addPattern(that.checksum);
	        },
	        addStop: function(){
	            this.addPattern(this.STOP);
	        },
	        setBaseUnit: function(){
	            var that = this;
	            that.baseUnit = that.width / (that.totalUnits + that.quietZoneLength);
	        },
	        addPattern: function(code){
	            var that = this,
	                pattern = that.characterMap[code].toString(),
	                value;

	            for(var i = 0; i < pattern.length; i++){
	                value = parseInt(pattern.charAt(i),10);
	                that.pattern.push(value);
	                that.totalUnits += value;
	            }
	            that.checkSum += code * that.position++;
	        },
	        getNextState: function(encodingState, states){
	            for(var i = 0; i < states.length; i++){
	                if(this[states[i]].is(encodingState.value, encodingState.index)){
	                    return states[i];
	                }
	            }
	            this.invalidCharacterError(encodingState.value.charAt(encodingState.index));
	        },
	        characterMap: [
	            212222,222122,222221,121223,121322,131222,122213,122312,132212,221213,
	            221312,231212,112232,122132,122231,113222,123122,123221,223211,221132,
	            221231,213212,223112,312131,311222,321122,321221,312212,322112,322211,
	            212123,212321,232121,111323,131123,131321,112313,132113,132311,211313,
	            231113,231311,112133,112331,132131,113123,113321,133121,313121,211331,
	            231131,213113,213311,213131,311123,311321,331121,312113,312311,332111,
	            314111,221411,431111,111224,111422,121124,121421,141122,141221,112214,
	            112412,122114,122411,142112,142211,241211,221114,413111,241112,134111,
	            111242,121142,121241,114212,124112,124211,411212,421112,421211,212141,
	            214121,412121,111143,111341,131141,114113,114311,411113,411311,113141,
	            114131,311141,411131,211412,211214,211232,2331112
	        ],
	        STOP: 106
	    });

	    encodings.code128a = code128Base.extend({
	        name: "Code 128 A",
	        states: ["A"]
	    });


	    encodings.code128b = code128Base.extend({
	        name: "Code 128 B",
	        states: ["B"]
	    });

	    encodings.code128c = code128Base.extend({
	        name: "Code 128 C",
	        states: ["C"]
	    });

	    encodings.code128 = code128Base.extend({
	        name: "Code 128",
	        states: ["C", "B", "A", "FNC4"]
	    });

	    encodings["gs1-128"] = code128Base.extend({
	       name: "Code GS1-128",
	       states: ["FNC1", "C", "B"]
	    });

	    var msiBase = Encoding.extend({
	        initValue: function(value, width){
	            var that = this;
	            that.pattern = [];
	            that.value = value;
	            that.checkSumLength = 0;
	            that.width = width;
	        },
	        setBaseUnit: function(){
	            var that = this,
	                startStopLength = 7;

	            that.baseUnit = that.width /
	                    ( 12 * (that.value.length + that.checkSumLength) + that.quietZoneLength + startStopLength);
	        },
	        addData:  function(){
	            var that = this,
	                value = that.value;
	            that.addPattern(that.START);

	            for(var i = 0; i < value.length; i++){
	                that.addCharacter(value.charAt(i));
	            }

	            if(that.options.addCheckSum){
	                that.addCheckSum();
	            }

	            that.addPattern(that.STOP);
	            that.setBaseUnit();
	        },
	        addCharacter: function(character){
	            var that = this,
	                pattern = that.characterMap[character];
	            if(!pattern){
	                that.invalidCharacterError(character);
	            }
	            that.addPattern(pattern);
	        },
	        addPattern: function(pattern){
	            for(var i = 0; i < pattern.length; i++){
	                this.pattern.push(parseInt(pattern.charAt(i),10));
	            }
	        },
	        addCheckSum: function(){
	            var that = this,
	                checkSumFunction = that.checkSums[that.checkSumType],
	                checkValues;

	            checkValues = checkSumFunction.call(that.checkSums, that.value);

	            that.checksum = checkValues.join("");
	            for(var i = 0; i < checkValues.length; i++){
	                that.checkSumLength++;
	                that.addPattern(that.characterMap[checkValues[i]]);
	            }
	        },
	        checkSums: {
	            Modulo10: function(value){
	                var checkValues = [0, ""],
	                odd = value.length % 2,
	                idx,
	                evenSum,
	                oddSum;

	                for(idx = 0; idx < value.length; idx++){
	                    checkValues[(idx + odd) % 2] += parseInt(value.charAt(idx),10);
	                }

	                oddSum = checkValues[0];
	                evenSum = (checkValues[1] * 2).toString();

	                for(idx = 0; idx < evenSum.length; idx++){
	                    oddSum += parseInt(evenSum.charAt(idx),10);
	                }

	                return [(10 - (oddSum % 10)) % 10];
	            },
	            Modulo11: function(value){
	                var weightedSum = 0,
	                    mod = 11,
	                    length = value.length,
	                    weight,
	                    checkValue;

	                for(var i = 0; i < length; i++){
	                    weight = ((length - i) % 6 || 6) + 1;
	                    weightedSum +=  weight * value.charAt(i);
	                }
	                checkValue = (mod - weightedSum % mod) % mod;
	                if(checkValue != 10){
	                    return [checkValue];
	                }
	                return [1, 0];
	            },
	            Modulo11Modulo10: function(value){
	                var checkValues = this.Modulo11(value),
	                    mod11Value;
	                mod11Value = value + checkValues[0];

	                return checkValues.concat(this.Modulo10(mod11Value));
	            },
	            Modulo10Modulo10: function(value){
	                var checkValues = this.Modulo10(value),
	                    mod10Value;
	                mod10Value = value + checkValues[0];

	                return checkValues.concat(this.Modulo10(mod10Value));
	            }
	        },
	        characterMap: ["12121212", "12121221","12122112", "12122121", "12211212", "12211221", "12212112", "12212121", "21121212", "21121221"],
	        START: "21",
	        STOP: "121",
	        checkSumType: ""
	    });

	    encodings.msimod10 = msiBase.extend({
	        name: "MSI Modulo10",
	        checkSumType: "Modulo10"
	    });

	    encodings.msimod11 = msiBase.extend({
	        name: "MSI Modulo11",
	        checkSumType: "Modulo11"
	    });

	    encodings.msimod1110 = msiBase.extend({
	        name: "MSI Modulo11 Modulo10",
	        checkSumType: "Modulo11Modulo10"
	    });

	    encodings.msimod1010 = msiBase.extend({
	        name: "MSI Modulo10 Modulo10",
	        checkSumType: "Modulo10Modulo10"
	    });

	    encodings.code11 = Encoding.extend({
	        name: "Code 11",
	        cCheckSumTotal: 10,
	        kCheckSumTotal: 9,
	        kCheckSumMinLength: 10,
	        checkSumMod: 11,
	        DASH_VALUE: 10,
	        DASH: "-",
	        START: "112211",
	        STOP: "11221",
	        initValue: function(value, width){
	            var that = this;
	            that.pattern = [];
	            that.value = value;
	            that.width = width;
	            that.totalUnits = 0;
	        },
	        addData:  function(){
	            var that = this;
	            var value = that.value;
	            that.addPattern(that.START);

	            for(var i = 0; i < value.length; i++){
	                that.addCharacter(value.charAt(i));
	            }

	            if(that.options.addCheckSum){
	                that.addCheckSum();
	            }

	            that.addPattern(that.STOP);
	            that.setBaseUnit();
	        },
	        setBaseUnit: function(){
	            var that = this;
	            that.baseUnit = that.width / (that.totalUnits + that.quietZoneLength);
	        },
	        addCheckSum: function(){
	            var that = this,
	                value = that.value,
	                length = value.length,
	                cValue;

	            cValue = that.getWeightedSum(value, length, that.cCheckSumTotal) % that.checkSumMod;
	            that.checksum = cValue + "";
	            that.addPattern(that.characterMap[cValue]);

	            length++;
	            if(length >= that.kCheckSumMinLength){
	                var kValue = (cValue + that.getWeightedSum(value, length, that.kCheckSumTotal)) % that.checkSumMod;
	                that.checksum += kValue;
	                that.addPattern(that.characterMap[kValue]);
	            }
	        },
	        getWeightedSum: function(value, length, total){
	            var weightedSum = 0;
	            for(var i = 0; i < value.length; i++){
	                weightedSum+= this.weightedValue(this.getValue(value.charAt(i)), length, i, total);
	            }

	            return weightedSum;
	        },
	        weightedValue: function(value, length, index, total){
	            var weight = (length - index) % total || total;
	            return weight * value;
	        },
	        getValue: function(character){
	            var that = this;
	            if(!isNaN(character)){
	                return parseInt(character,10);
	            }
	            else if(character !== that.DASH){
	                that.invalidCharacterError(character);
	            }
	            return that.DASH_VALUE;
	        },
	        addCharacter: function(character){
	            var that = this,
	                value = that.getValue(character),
	                pattern = that.characterMap[value];
	            that.addPattern(pattern);
	        },
	        addPattern: function(pattern){
	            var value;
	            for(var i = 0; i < pattern.length; i++){
	                value = parseInt(pattern.charAt(i),10);
	                this.pattern.push(value);
	                this.totalUnits+=value;
	            }
	        },
	        characterMap: ["111121", "211121", "121121", "221111", "112121", "212111", "122111", "111221", "211211", "211111", "112111"],
	        options: {
	            addCheckSum: true
	        }
	    });

	    encodings.postnet = Encoding.extend({
	        name: "Postnet",
	        START: "2",
	        VALID_CODE_LENGTHS: [5,9, 11],
	        DIGIT_SEPARATOR: "-",
	        initValue: function(value, width, height){
	            var that = this;
	            that.height = height;
	            that.width = width;
	            that.baseHeight = height /2;
	            that.value = value.replace(new RegExp(that.DIGIT_SEPARATOR,"g"), "");
	            that.pattern = [];
	            that.validate(that.value);
	            that.checkSum = 0;
	            that.setBaseUnit();
	        },
	        addData:  function(){
	            var that = this,
	                value = that.value;
	            that.addPattern(that.START);

	            for(var i = 0; i < value.length; i++){
	                that.addCharacter(value.charAt(i));
	            }

	            if(that.options.addCheckSum){
	                that.addCheckSum();
	            }

	            that.addPattern(that.START);
	            that.pattern.pop();
	        },
	        addCharacter: function(character){
	            var that = this,
	                pattern = that.characterMap[character];
	            that.checkSum+= parseInt(character,10);
	            that.addPattern(pattern);
	        },
	        addCheckSum: function(){
	            var that = this;
	            that.checksum = (10 - (that.checkSum % 10)) % 10;
	            that.addCharacter(that.checksum);
	        },
	        setBaseUnit: function(){
	            var that=this,
	                startStopLength = 3;
	            that.baseUnit = that.width / ((that.value.length + 1) * 10 +  startStopLength + that.quietZoneLength);
	        },
	        validate: function(value){
	            var that = this;

	            if(!numberRegex.test(value)){
	                that.invalidCharacterError(value.match(/[^0-9]/)[0]);
	            }
	            if(inArray(value.length, that.VALID_CODE_LENGTHS) < 0){
	                throw new Error("Invalid value length. Valid lengths for the Postnet symbology are " + that.VALID_CODE_LENGTHS.join(","));
	            }
	        },
	        addPattern: function(pattern){
	            var that = this,
	                y1;
	            for(var i = 0; i < pattern.length; i++){
	                y1 = that.height - that.baseHeight * pattern.charAt(i);
	                that.pattern.push({width: 1, y1: y1, y2: that.height});
	                that.pattern.push(1);
	            }
	        },
	        characterMap: ["22111", "11122", "11212", "11221", "12112", "12121", "12211", "21112", "21121", "21211"]
	    });

	    encodings.ean13 = Encoding.extend({
	        initValue: function(value, width, height){
	            value+="";

	            if(value.length!=12 || /\D/.test(value)){
	                throw new Error('The value of the "EAN13" encoding should be 12 symbols');
	            }

	            var that = this;
	            that.pattern = [];
	            that.options.height = height;
	            that.baseUnit = width /(95 + that.quietZoneLength);
	            that.value = value;
	            that.checksum = that.calculateChecksum();
	            that.leftKey = value[0];
	            that.leftPart = value.substr(1,6);
	            that.rightPart = value.substr(7)+that.checksum;
	        },
	        addData:  function(){
	            var that = this;
	            that.addPieces(that.characterMap.start);
	            that.addSide(that.leftPart,that.leftKey);
	            that.addPieces(that.characterMap.middle);
	            that.addSide(that.rightPart);
	            that.addPieces(that.characterMap.start);
	        },
	        addSide:function(leftPart,key){
	            var that = this;
	            for(var i = 0; i < leftPart.length; i++){
	                if(key && parseInt(that.keyTable[key].charAt(i),10)){
	                    that.addPieces(Array.prototype.slice.call(that.characterMap.digits[leftPart.charAt(i)]).reverse(),true);
	                }else{
	                    that.addPieces(that.characterMap.digits[leftPart.charAt(i)],true);
	                }
	            }
	        },
	        addPieces:function(arrToAdd,limitedHeight){
	            var that = this;
	            for(var i=0;i<arrToAdd.length;i++){
	                if(limitedHeight){
	                    that.pattern.push({
	                        y1:0,
	                        y2:that.options.height*0.95,
	                        width:arrToAdd[i]
	                    });
	                }else{
	                    that.pattern.push(arrToAdd[i]);
	                }
	            }
	        },
	        calculateChecksum: function (){
	            var odd = 0,
	                even = 0,
	                value = this.value.split("").reverse().join("");
	            for(var i = 0;i < value.length;i++){
	                if(i%2){
	                    even += parseInt(value.charAt(i),10);
	                }
	                else{
	                    odd += parseInt(value.charAt(i),10);
	                }
	            }
	            var checksum = (10 - ((3*odd + even)%10))%10;
	            return checksum;
	        },
	        keyTable:[
	            '000000',
	            '001011',
	            '001101',
	            '001110',
	            '010011',
	            '011001',
	            '011100',
	            '010101',
	            '010110',
	            '011010'
	        ],
	        characterMap: {
	            digits:[
	                [3,2,1,1],
	                [2,2,2,1],
	                [2,1,2,2],
	                [1,4,1,1],
	                [1,1,3,2],
	                [1,2,3,1],
	                [1,1,1,4],
	                [1,3,1,2],
	                [1,2,1,3],
	                [3,1,1,2]
	            ],
	            start: [1,1,1],
	            middle: [1,1,1,1,1]
	        }
	    });

	    encodings.ean8 = encodings.ean13.extend({
	        initValue: function(value, width, height){
	            var that = this;
	            if(value.length!=7 || /\D/.test(value)){
	                throw new Error('Invalid value provided');
	            }
	            that.value = value;
	            that.options.height = height;
	            that.checksum = that.calculateChecksum(that.value);
	            that.leftPart  = that.value.substr(0,4);
	            that.rightPart = that.value.substr(4) + that.checksum;
	            that.pattern = [];
	            that.baseUnit = width /(67 + that.quietZoneLength);
	        }
	    });

	    var Barcode = Widget.extend({
	        init: function (element, options) {
	             var that = this;
	             Widget.fn.init.call(that, element, options);
	             that.element = $(element);
	             that.wrapper = that.element;
	             that.element.addClass("k-barcode").css("display", "block");
	             that.surfaceWrap = $("<div />").css("position", "relative").appendTo(this.element);
	             that.surface = draw.Surface.create(that.surfaceWrap, {
	                 type: that.options.renderAs
	             });
	             that._setOptions(options);
	             if (options && defined(options.value)) {
	                 that.redraw();
	             }
	        },

	        setOptions: function (options) {
	            this._setOptions(options);
	            this.redraw();
	        },

	        redraw: function () {
	            var size = this._getSize();

	            this.surface.clear();
	            this.surface.setSize({
	                width: size.width,
	                height: size.height
	            });

	            this.createVisual();
	            this.surface.draw(this.visual);
	        },

	        getSize: function() {
	            return kendo.dimensions(this.element);
	        },

	        _resize: function() {
	            this.redraw();
	        },

	        createVisual: function() {
	            this.visual = this._render();
	        },

	        _render: function() {
	            var that = this,
	                options = that.options,
	                value = options.value,
	                textOptions = options.text,
	                textMargin = dataviz.getSpacing(textOptions.margin),
	                size = that._getSize(),
	                border = options.border || {},
	                encoding = that.encoding,
	                contentBox = new Box2D(0, 0, size.width, size.height).unpad(border.width).unpad(options.padding),
	                barHeight = contentBox.height(),
	                result, textToDisplay,
	                textHeight;

	            var visual = new draw.Group();

	            that.contentBox = contentBox;
	            visual.append(that._getBackground(size));

	            if (textOptions.visible) {
	                textHeight = draw.util.measureText(value, { font: textOptions.font }).height;
	                barHeight -= textHeight + textMargin.top + textMargin.bottom;
	            }

	            result = encoding.encode(value, contentBox.width(), barHeight);

	            if (textOptions.visible) {
	                textToDisplay = value;
	                if (options.checksum && defined(encoding.checksum)) {
	                    textToDisplay += " " + encoding.checksum;
	                }

	                visual.append(that._getText(textToDisplay));
	            }

	            that.barHeight = barHeight;
	            this._bandsGroup = this._getBands(result.pattern, result.baseUnit);
	            visual.append(this._bandsGroup);

	            return visual;
	        },

	        exportVisual: function() {
	            return this._render();
	        },

	        _getSize: function() {
	            var that = this,
	                element = that.element,
	                size = new geom.Size(DEFAULT_WIDTH, DEFAULT_HEIGHT);

	            if (element.width() > 0) {
	                size.width = element.width();
	            }
	            if (element.height() > 0) {
	                size.height = element.height();
	            }
	            if (that.options.width) {
	               size.width = that.options.width;
	            }
	            if (that.options.height) {
	               size.height = that.options.height;
	            }

	            return size;
	        },

	        value: function(value) {
	            var that = this;
	            if (!defined(value)) {
	                return that.options.value;
	            }
	            that.options.value = value + '';
	            that.redraw();
	        },

	        _getBands: function (pattern, baseUnit) {
	            var that = this,
	                contentBox = that.contentBox,
	                position = contentBox.x1,
	                step,
	                item;

	            var group = new draw.Group();
	            for (var i = 0; i < pattern.length; i++) {
	                item = isPlainObject(pattern[i]) ? pattern[i] : {
	                    width: pattern[i],
	                    y1: 0,
	                    y2: that.barHeight
	                };

	                step = item.width * baseUnit;

	                if (i%2) {
	                    var rect = geom.Rect.fromPoints(
	                        new geom.Point(position, item.y1 + contentBox.y1),
	                        new geom.Point(position + step, item.y2 + contentBox.y1)
	                    );

	                    var path = draw.Path.fromRect(rect, {
	                        fill: {
	                            color: that.options.color
	                        },
	                        stroke: null
	                    });

	                    group.append(path);
	                }

	                position += step;
	            }

	            return group;
	        },

	        _getBackground: function (size) {
	            var that = this,
	                options = that.options,
	                border = options.border || {};

	            var box = new Box2D(0,0, size.width, size.height).unpad(border.width / 2);
	            var path = draw.Path.fromRect(box.toRect(), {
	                fill: {
	                    color: options.background
	                },
	                stroke: {
	                    color: border.width ? border.color : "",
	                    width: border.width,
	                    dashType: border.dashType
	                }
	            });

	            return path;
	        },

	        _getText: function(value) {
	            var that = this,
	                textOptions = that.options.text,
	                text = that._textbox = new TextBox(value, {
	                    font: textOptions.font,
	                    color: textOptions.color,
	                    align: "center",
	                    vAlign: "bottom",
	                    margin: textOptions.margin
	                });

	            text.reflow(that.contentBox);
	            text.renderVisual();

	            return text.visual;
	        },

	        _setOptions: function (options) {
	            var that = this;
	            that.type = (options.type || that.options.type).toLowerCase();

	            if (that.type=="upca") { //extend instead
	                that.type = "ean13";
	                options.value = '0' + options.value;
	            }

	            if (that.type=="upce") {
	                that.type = "ean8";
	                options.value = '0' + options.value;
	            }

	            if (!encodings[that.type]) {
	                throw new Error('Encoding ' + that.type + 'is not supported.');
	            }

	            that.encoding = new encodings[that.type]();

	            that.options = extend(true, that.options, options);
	        },

	        options: {
	            name: "Barcode",
	            renderAs: "svg",
	            value: "",
	            type: "code39",
	            checksum: false,
	            width: 0,
	            height: 0,
	            color: "black",
	            background: "white",
	            text: {
	                visible: true,
	                font: "16px Consolas, Monaco, Sans Mono, monospace, sans-serif",
	                color: "black",
	                margin: {
	                    top: 0,
	                    bottom: 0,
	                    left: 0,
	                    right: 0
	                }
	            },
	            border: {
	                width: 0,
	                dashType: "solid",
	                color: "black"
	            },
	            padding: {
	                top: 0,
	                bottom: 0,
	                left: 0,
	                right: 0
	            }
	        }
	    });
	    dataviz.ExportMixin.extend(Barcode.fn);

	    dataviz.ui.plugin(Barcode);

	    kendo.deepExtend(dataviz, {
	        encodings: encodings,
	        Encoding: Encoding
	    });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "39p0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var columnController_1 = __webpack_require__("77lH");
var constants_1 = __webpack_require__("ZZFX");
var utils_1 = __webpack_require__("IRr6");
var selectionController_1 = __webpack_require__("D4cr");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var displayedGroupCreator_1 = __webpack_require__("Tttz");
var balancedColumnTreeBuilder_1 = __webpack_require__("WPdJ");
var groupInstanceIdCreator_1 = __webpack_require__("cERj");
var columnGroup_1 = __webpack_require__("YX13");
var pinnedRowModel_1 = __webpack_require__("xRx6");
var BaseGridSerializingSession = (function () {
    function BaseGridSerializingSession(columnController, valueService, gridOptionsWrapper, processCellCallback, processHeaderCallback, cellAndHeaderEscaper) {
        this.columnController = columnController;
        this.valueService = valueService;
        this.gridOptionsWrapper = gridOptionsWrapper;
        this.processCellCallback = processCellCallback;
        this.processHeaderCallback = processHeaderCallback;
        this.cellAndHeaderEscaper = cellAndHeaderEscaper;
    }
    BaseGridSerializingSession.prototype.extractHeaderValue = function (column) {
        var nameForCol = this.getHeaderName(this.processHeaderCallback, column);
        if (nameForCol === null || nameForCol === undefined) {
            nameForCol = '';
        }
        return this.cellAndHeaderEscaper ? this.cellAndHeaderEscaper(nameForCol) : nameForCol;
    };
    BaseGridSerializingSession.prototype.extractRowCellValue = function (column, index, type, node) {
        var isRowGrouping = this.columnController.getRowGroupColumns().length > 0;
        var valueForCell;
        if (node.group && isRowGrouping && index === 0) {
            valueForCell = this.createValueForGroupNode(node);
        }
        else {
            valueForCell = this.valueService.getValue(column, node);
        }
        valueForCell = this.processCell(node, column, valueForCell, this.processCellCallback, type);
        if (valueForCell === null || valueForCell === undefined) {
            valueForCell = '';
        }
        return this.cellAndHeaderEscaper ? this.cellAndHeaderEscaper(valueForCell) : valueForCell;
    };
    BaseGridSerializingSession.prototype.getHeaderName = function (callback, column) {
        if (callback) {
            return callback({
                column: column,
                api: this.gridOptionsWrapper.getApi(),
                columnApi: this.gridOptionsWrapper.getColumnApi(),
                context: this.gridOptionsWrapper.getContext()
            });
        }
        else {
            return this.columnController.getDisplayNameForColumn(column, 'csv', true);
        }
    };
    BaseGridSerializingSession.prototype.createValueForGroupNode = function (node) {
        var keys = [node.key];
        while (node.parent) {
            node = node.parent;
            keys.push(node.key);
        }
        return keys.reverse().join(' -> ');
    };
    BaseGridSerializingSession.prototype.processCell = function (rowNode, column, value, processCellCallback, type) {
        if (processCellCallback) {
            return processCellCallback({
                column: column,
                node: rowNode,
                value: value,
                api: this.gridOptionsWrapper.getApi(),
                columnApi: this.gridOptionsWrapper.getColumnApi(),
                context: this.gridOptionsWrapper.getContext(),
                type: type
            });
        }
        else {
            return value;
        }
    };
    return BaseGridSerializingSession;
}());
exports.BaseGridSerializingSession = BaseGridSerializingSession;
var GridSerializer = (function () {
    function GridSerializer() {
    }
    GridSerializer.prototype.serialize = function (gridSerializingSession, params) {
        var dontSkipRows = function () { return false; };
        var skipGroups = params && params.skipGroups;
        var skipHeader = params && params.skipHeader;
        var columnGroups = params && params.columnGroups;
        var skipFooters = params && params.skipFooters;
        var skipPinnedTop = params && params.skipPinnedTop;
        var skipPinnedBottom = params && params.skipPinnedBottom;
        var includeCustomHeader = params && params.customHeader;
        var includeCustomFooter = params && params.customFooter;
        var allColumns = params && params.allColumns;
        var onlySelected = params && params.onlySelected;
        var columnKeys = params && params.columnKeys;
        var onlySelectedAllPages = params && params.onlySelectedAllPages;
        var rowSkipper = (params && params.shouldRowBeSkipped) || dontSkipRows;
        var api = this.gridOptionsWrapper.getApi();
        var context = this.gridOptionsWrapper.getContext();
        // when in pivot mode, we always render cols on screen, never 'all columns'
        var isPivotMode = this.columnController.isPivotMode();
        var rowModelNormal = this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_IN_MEMORY;
        var onlySelectedNonStandardModel = !rowModelNormal && onlySelected;
        var columnsToExport;
        if (utils_1.Utils.existsAndNotEmpty(columnKeys)) {
            columnsToExport = this.columnController.getGridColumns(columnKeys);
        }
        else if (allColumns && !isPivotMode) {
            columnsToExport = this.columnController.getAllPrimaryColumns();
        }
        else {
            columnsToExport = this.columnController.getAllDisplayedColumns();
        }
        if (!columnsToExport || columnsToExport.length === 0) {
            return '';
        }
        gridSerializingSession.prepare(columnsToExport);
        if (includeCustomHeader) {
            gridSerializingSession.addCustomHeader(params.customHeader);
        }
        // first pass, put in the header names of the cols
        if (columnGroups) {
            var groupInstanceIdCreator = new groupInstanceIdCreator_1.GroupInstanceIdCreator();
            var displayedGroups = this.displayedGroupCreator.createDisplayedGroups(columnsToExport, this.columnController.getGridBalancedTree(), groupInstanceIdCreator);
            this.recursivelyAddHeaderGroups(displayedGroups, gridSerializingSession);
        }
        if (!skipHeader) {
            var gridRowIterator_1 = gridSerializingSession.onNewHeaderRow();
            columnsToExport.forEach(function (column, index) {
                gridRowIterator_1.onColumn(column, index, null);
            });
        }
        this.pinnedRowModel.forEachPinnedTopRow(processRow);
        if (isPivotMode) {
            this.rowModel.forEachPivotNode(processRow);
        }
        else {
            // onlySelectedAllPages: user doing pagination and wants selected items from
            // other pages, so cannot use the standard row model as it won't have rows from
            // other pages.
            // onlySelectedNonStandardModel: if user wants selected in non standard row model
            // (eg viewport) then again rowmodel cannot be used, so need to use selected instead.
            if (onlySelectedAllPages || onlySelectedNonStandardModel) {
                var selectedNodes = this.selectionController.getSelectedNodes();
                selectedNodes.forEach(function (node) {
                    processRow(node);
                });
            }
            else {
                // here is everything else - including standard row model and selected. we don't use
                // the selection model even when just using selected, so that the result is the order
                // of the rows appearing on the screen.
                if (rowModelNormal) {
                    this.rowModel.forEachNodeAfterFilterAndSort(processRow);
                }
                else {
                    this.rowModel.forEachNode(processRow);
                }
            }
        }
        this.pinnedRowModel.forEachPinnedBottomRow(processRow);
        if (includeCustomFooter) {
            gridSerializingSession.addCustomFooter(params.customFooter);
        }
        function processRow(node) {
            if (skipGroups && node.group) {
                return;
            }
            if (skipFooters && node.footer) {
                return;
            }
            if (onlySelected && !node.isSelected()) {
                return;
            }
            if (skipPinnedTop && node.rowPinned === 'top') {
                return;
            }
            if (skipPinnedBottom && node.rowPinned === 'bottom') {
                return;
            }
            // if we are in pivotMode, then the grid will show the root node only
            // if it's not a leaf group
            var nodeIsRootNode = node.level === -1;
            if (nodeIsRootNode && !node.leafGroup) {
                return;
            }
            var shouldRowBeSkipped = rowSkipper({
                node: node,
                api: api,
                context: context
            });
            if (shouldRowBeSkipped)
                return;
            var rowAccumulator = gridSerializingSession.onNewBodyRow();
            columnsToExport.forEach(function (column, index) {
                rowAccumulator.onColumn(column, index, node);
            });
        }
        return gridSerializingSession.parse();
    };
    GridSerializer.prototype.recursivelyAddHeaderGroups = function (displayedGroups, gridSerializingSession) {
        var directChildrenHeaderGroups = [];
        displayedGroups.forEach(function (columnGroupChild) {
            var columnGroup = columnGroupChild;
            if (!columnGroup.getChildren)
                return;
            columnGroup.getChildren().forEach(function (it) { return directChildrenHeaderGroups.push(it); });
        });
        if (displayedGroups.length > 0 && displayedGroups[0] instanceof columnGroup_1.ColumnGroup) {
            this.doAddHeaderHeader(gridSerializingSession, displayedGroups);
        }
        if (directChildrenHeaderGroups && directChildrenHeaderGroups.length > 0) {
            this.recursivelyAddHeaderGroups(directChildrenHeaderGroups, gridSerializingSession);
        }
    };
    GridSerializer.prototype.doAddHeaderHeader = function (gridSerializingSession, displayedGroups) {
        var _this = this;
        var gridRowIterator = gridSerializingSession.onNewHeaderGroupingRow();
        var columnIndex = 0;
        displayedGroups.forEach(function (columnGroupChild) {
            var columnGroup = columnGroupChild;
            var colDef = columnGroup.getDefinition();
            var columnName = _this.columnController.getDisplayNameForColumnGroup(columnGroup, 'header');
            gridRowIterator.onColumn(columnName, columnIndex++, columnGroup.getLeafColumns().length - 1);
        });
    };
    __decorate([
        context_1.Autowired('displayedGroupCreator'),
        __metadata("design:type", displayedGroupCreator_1.DisplayedGroupCreator)
    ], GridSerializer.prototype, "displayedGroupCreator", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], GridSerializer.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('rowModel'),
        __metadata("design:type", Object)
    ], GridSerializer.prototype, "rowModel", void 0);
    __decorate([
        context_1.Autowired('pinnedRowModel'),
        __metadata("design:type", pinnedRowModel_1.PinnedRowModel)
    ], GridSerializer.prototype, "pinnedRowModel", void 0);
    __decorate([
        context_1.Autowired('selectionController'),
        __metadata("design:type", selectionController_1.SelectionController)
    ], GridSerializer.prototype, "selectionController", void 0);
    __decorate([
        context_1.Autowired('balancedColumnTreeBuilder'),
        __metadata("design:type", balancedColumnTreeBuilder_1.BalancedColumnTreeBuilder)
    ], GridSerializer.prototype, "balancedColumnTreeBuilder", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], GridSerializer.prototype, "gridOptionsWrapper", void 0);
    GridSerializer = __decorate([
        context_1.Bean("gridSerializer")
    ], GridSerializer);
    return GridSerializer;
}());
exports.GridSerializer = GridSerializer;
var RowType;
(function (RowType) {
    RowType[RowType["HEADER_GROUPING"] = 0] = "HEADER_GROUPING";
    RowType[RowType["HEADER"] = 1] = "HEADER";
    RowType[RowType["BODY"] = 2] = "BODY";
})(RowType = exports.RowType || (exports.RowType = {}));


/***/ }),

/***/ "3Bvt":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1084);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1048:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("BOhp");

/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1084:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1085), __webpack_require__(1086), __webpack_require__(1087), __webpack_require__(1088), __webpack_require__(1089) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "colorpicker",
	    name: "Color tools",
	    category: "web",
	    description: "Color selection widgets",
	    depends: [ "core", "color", "popup", "slider", "userevents", "button" ]
	};

	(function($, parseInt, undefined){
	    // WARNING: removing the following jshint declaration and turning
	    // == into === to make JSHint happy will break functionality.
	    /*jshint eqnull:true  */
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        parseColor = kendo.parseColor,
	        Color = kendo.Color,
	        KEYS = kendo.keys,
	        BACKGROUNDCOLOR = "background-color",
	        ITEMSELECTEDCLASS = "k-state-selected",
	        SIMPLEPALETTE = "000000,7f7f7f,880015,ed1c24,ff7f27,fff200,22b14c,00a2e8,3f48cc,a349a4,ffffff,c3c3c3,b97a57,ffaec9,ffc90e,efe4b0,b5e61d,99d9ea,7092be,c8bfe7",
	        WEBPALETTE = "FFFFFF,FFCCFF,FF99FF,FF66FF,FF33FF,FF00FF,CCFFFF,CCCCFF,CC99FF,CC66FF,CC33FF,CC00FF,99FFFF,99CCFF,9999FF,9966FF,9933FF,9900FF,FFFFCC,FFCCCC,FF99CC,FF66CC,FF33CC,FF00CC,CCFFCC,CCCCCC,CC99CC,CC66CC,CC33CC,CC00CC,99FFCC,99CCCC,9999CC,9966CC,9933CC,9900CC,FFFF99,FFCC99,FF9999,FF6699,FF3399,FF0099,CCFF99,CCCC99,CC9999,CC6699,CC3399,CC0099,99FF99,99CC99,999999,996699,993399,990099,FFFF66,FFCC66,FF9966,FF6666,FF3366,FF0066,CCFF66,CCCC66,CC9966,CC6666,CC3366,CC0066,99FF66,99CC66,999966,996666,993366,990066,FFFF33,FFCC33,FF9933,FF6633,FF3333,FF0033,CCFF33,CCCC33,CC9933,CC6633,CC3333,CC0033,99FF33,99CC33,999933,996633,993333,990033,FFFF00,FFCC00,FF9900,FF6600,FF3300,FF0000,CCFF00,CCCC00,CC9900,CC6600,CC3300,CC0000,99FF00,99CC00,999900,996600,993300,990000,66FFFF,66CCFF,6699FF,6666FF,6633FF,6600FF,33FFFF,33CCFF,3399FF,3366FF,3333FF,3300FF,00FFFF,00CCFF,0099FF,0066FF,0033FF,0000FF,66FFCC,66CCCC,6699CC,6666CC,6633CC,6600CC,33FFCC,33CCCC,3399CC,3366CC,3333CC,3300CC,00FFCC,00CCCC,0099CC,0066CC,0033CC,0000CC,66FF99,66CC99,669999,666699,663399,660099,33FF99,33CC99,339999,336699,333399,330099,00FF99,00CC99,009999,006699,003399,000099,66FF66,66CC66,669966,666666,663366,660066,33FF66,33CC66,339966,336666,333366,330066,00FF66,00CC66,009966,006666,003366,000066,66FF33,66CC33,669933,666633,663333,660033,33FF33,33CC33,339933,336633,333333,330033,00FF33,00CC33,009933,006633,003333,000033,66FF00,66CC00,669900,666600,663300,660000,33FF00,33CC00,339900,336600,333300,330000,00FF00,00CC00,009900,006600,003300,000000",
	        WHITE = "#ffffff",
	        MESSAGES = {
	            apply  : "Apply",
	            cancel : "Cancel",
	            noColor: "no color",
	            clearColor: "Clear color",
	            previewInput: "Color Hexadecimal Code"
	        },
	        NS = ".kendoColorTools",
	        CLICK_NS = "click" + NS,
	        KEYDOWN_NS = "keydown" + NS,
	        DISABLED = "k-state-disabled",

	        browser = kendo.support.browser,
	        isIE8 = browser.msie && browser.version < 9;

	    var ColorSelector = Widget.extend({
	        init: function(element, options) {
	            var that = this, ariaId;

	            Widget.fn.init.call(that, element, options);
	            element = that.element;
	            options = that.options;
	            that._value = options.value = parseColor(options.value);
	            that._tabIndex = element.attr("tabIndex") || 0;

	            ariaId = that._ariaId = options.ariaId;
	            if (ariaId) {
	                element.attr("aria-labelledby", ariaId);
	            }

	            if (options._standalone) {
	                that._triggerSelect = that._triggerChange;
	            }
	        },
	        options: {
	            name: "ColorSelector",
	            value: null,
	            _standalone: true
	        },
	        events: [
	            "change",
	            "select",
	            "cancel"
	        ],
	        color: function(value) {
	            if (value !== undefined) {
	                this._value = parseColor(value);
	                this._updateUI(this._value);
	            }

	            return this._value;
	        },
	        value: function(color) {
	            color = this.color(color);

	            if (color) {
	                if (this.options.opacity) {
	                    color = color.toCssRgba();
	                } else {
	                    color = color.toCss();
	                }
	            }

	            return color || null;
	        },
	        enable: function(enable) {
	            if (arguments.length === 0) {
	                enable = true;
	            }

	            this.wrapper.toggleClass(DISABLED, !enable);

	            this._onEnable(enable);
	        },
	        _select: function(color, nohooks) {
	            var prev = this._value;
	            color = this.color(color);
	            if (!nohooks) {
	                this.element.trigger("change");
	                if (!color.equals(prev)) {
	                    this.trigger("change", { value: this.value() });
	                } else if (!this._standalone) {
	                    this.trigger("cancel");
	                }
	            }
	        },
	        _triggerSelect: function(color) {
	            triggerEvent(this, "select", color);
	        },
	        _triggerChange: function(color) {
	            triggerEvent(this, "change", color);
	        },
	        destroy: function() {
	            if (this.element) {
	                this.element.off(NS);
	            }
	            if (this.wrapper) {
	                this.wrapper.off(NS).find("*").off(NS);
	            }
	            this.wrapper = null;
	            Widget.fn.destroy.call(this);
	        },
	        _updateUI: $.noop,
	        _selectOnHide: function() {
	            return null;
	        },
	        _cancel: function() {
	            this.trigger("cancel");
	        }
	    });

	    function triggerEvent(self, type, color) {
	        color = parseColor(color);
	        if (color && !color.equals(self.color())) {
	            if (type == "change") {
	                // UI is already updated.  setting _value directly
	                // rather than calling self.color(color) to avoid an
	                // endless loop.
	                self._value = color;
	            }
	            if (color.a != 1) {
	                color = color.toCssRgba();
	            } else {
	                color = color.toCss();
	            }
	            self.trigger(type, { value: color });
	        }
	    }

	    var ColorPalette = ColorSelector.extend({
	        init: function(element, options) {
	            var that = this;
	            ColorSelector.fn.init.call(that, element, options);
	            element = that.wrapper = that.element;
	            options = that.options;
	            var colors = options.palette;

	            if (colors == "websafe") {
	                colors = WEBPALETTE;
	                options.columns = 18;
	            } else if (colors == "basic") {
	                colors = SIMPLEPALETTE;
	            }

	            if (typeof colors == "string") {
	                colors = colors.split(",");
	            }

	            if ($.isArray(colors)) {
	                colors = $.map(colors, function(x) { return parseColor(x); });
	            }

	            that._selectedID = (options.ariaId || kendo.guid()) + "_selected";

	            element.addClass("k-widget k-colorpalette")
	                .attr("role", "grid")
	                .attr("aria-readonly", "true")
	                .append($(that._template({
	                    colors   : colors,
	                    columns  : options.columns,
	                    tileSize : options.tileSize,
	                    value    : that._value,
	                    id       : options.ariaId
	                })))
	                .on(CLICK_NS, ".k-item", function(ev){
	                    that._select($(ev.currentTarget).css(BACKGROUNDCOLOR));
	                })
	                .attr("tabIndex", that._tabIndex)
	                .on(KEYDOWN_NS, bind(that._keydown, that));

	            var tileSize = options.tileSize, width, height;
	            if (tileSize) {
	                if (/number|string/.test(typeof tileSize)) {
	                    width = height = parseFloat(tileSize);
	                } else if (typeof tileSize == "object") {
	                    width = parseFloat(tileSize.width);
	                    height = parseFloat(tileSize.height);
	                } else {
	                    throw new Error("Unsupported value for the 'tileSize' argument");
	                }
	                element.find(".k-item").css({ width: width, height: height });
	            }
	        },
	        focus: function(){
	            if (this.wrapper && !this.wrapper.is("[unselectable='on']")) {
	                this.wrapper.focus();
	            }
	        },
	        options: {
	            name: "ColorPalette",
	            columns: 10,
	            tileSize: null,
	            palette: "basic"
	        },
	        _onEnable: function(enable) {
	            if (enable) {
	                this.wrapper.attr("tabIndex", this._tabIndex);
	            } else {
	                this.wrapper.removeAttr("tabIndex");
	            }
	        },
	        _keydown: function(e) {
	            var selected,
	                wrapper = this.wrapper,
	                items = wrapper.find(".k-item"),
	                current = items.filter("." + ITEMSELECTEDCLASS).get(0),
	                keyCode = e.keyCode;

	            if (keyCode == KEYS.LEFT) {
	                selected = relative(items, current, -1);
	            } else if (keyCode == KEYS.RIGHT) {
	                selected = relative(items, current, 1);
	            } else if (keyCode == KEYS.DOWN) {
	                selected = relative(items, current, this.options.columns);
	            } else if (keyCode == KEYS.UP) {
	                selected = relative(items, current, -this.options.columns);
	            } else if (keyCode == KEYS.ENTER) {
	                preventDefault(e);
	                if (current) {
	                    this._select($(current).css(BACKGROUNDCOLOR));
	                }
	            } else if (keyCode == KEYS.ESC) {
	                this._cancel();
	            }

	            if (selected) {
	                preventDefault(e);

	                this._current(selected);

	                try {
	                    var color = parseColor(selected.css(BACKGROUNDCOLOR));
	                    this._triggerSelect(color);
	                } catch(ex) {}
	            }
	        },
	        _current: function(item) {
	            this.wrapper.find("." + ITEMSELECTEDCLASS)
	                .removeClass(ITEMSELECTEDCLASS)
	                .attr("aria-selected", false)
	                .removeAttr("id");

	            $(item)
	                .addClass(ITEMSELECTEDCLASS)
	                .attr("aria-selected", true)
	                .attr("id", this._selectedID);

	            this.element
	                .removeAttr("aria-activedescendant")
	                .attr("aria-activedescendant", this._selectedID);
	        },
	        _updateUI: function(color) {
	            var item = null;

	            this.wrapper.find(".k-item").each(function(){
	                var c = parseColor($(this).css(BACKGROUNDCOLOR));

	                if (c && c.equals(color)) {
	                    item = this;

	                    return false;
	                }
	            });

	            this._current(item);
	        },
	        _template: kendo.template(
	            '<table class="k-palette k-reset" role="presentation"><tr role="row">' +
	              '# for (var i = 0; i < colors.length; ++i) { #' +
	                '# var selected = colors[i].equals(value); #' +
	                '# if (i && i % columns == 0) { # </tr><tr role="row"> # } #' +
	                '<td role="gridcell" unselectable="on" style="background-color:#= colors[i].toCss() #"' +
	                    '#= selected ? " aria-selected=true" : "" # ' +
	                    '#=(id && i === 0) ? "id=\\""+id+"\\" " : "" # ' +
	                    'class="k-item#= selected ? " ' + ITEMSELECTEDCLASS + '" : "" #" ' +
	                    'aria-label="#= colors[i].toCss() #"></td>' +
	              '# } #' +
	            '</tr></table>'
	        )
	    });

	    var FlatColorPicker = ColorSelector.extend({
	        init: function(element, options) {
	            var that = this;
	            ColorSelector.fn.init.call(that, element, options);

	            options = that.options;
	            options.messages = options.options ? $.extend(that.options.messages, options.options.messages) : that.options.messages;
	            element = that.element;

	            that.wrapper = element.addClass("k-widget k-flatcolorpicker")
	                .append(that._template(options));

	            that._hueElements = $(".k-hsv-rectangle, .k-alpha-slider .k-slider-track", element);

	            that._selectedColor = $(".k-selected-color-display", element);

	            that._colorAsText = $("input.k-color-value", element);

	            that._sliders();

	            that._hsvArea();

	            that._updateUI(that._value || parseColor("#f00"));

	            element
	                .find("input.k-color-value").on(KEYDOWN_NS, function(ev){
	                    var input = this;
	                    if (ev.keyCode == KEYS.ENTER) {
	                        try {
	                            var color = parseColor(input.value);
	                            var val = that.color();
	                            that._select(color, color.equals(val));
	                        } catch(ex) {
	                            $(input).addClass("k-state-error");
	                        }
	                    } else if (that.options.autoupdate) {
	                        setTimeout(function(){
	                            var color = parseColor(input.value, true);
	                            if (color) {
	                                that._updateUI(color, true);
	                            }
	                        }, 10);
	                    }
	                }).end()

	                .on(CLICK_NS, ".k-controls button.apply", function(){
	                    // calling select for the currently displayed
	                    // color will trigger the "change" event.
	                    if (that.options._clearedColor) {
	                        that.trigger("change");
	                    } else {
	                        that._select(that._getHSV());
	                    }
	                })
	                .on(CLICK_NS, ".k-controls button.cancel", function(){
	                    // but on cancel, we simply select the previous
	                    // value (again, triggers "change" event).
	                    that._updateUI(that.color());
	                    that._cancel();
	                });

	            if (isIE8) {
	                // IE filters require absolute URLs
	                that._applyIEFilter();
	            }
	        },
	        destroy: function() {
	            this._hsvEvents.destroy();

	            this._hueSlider.destroy();
	            if (this._opacitySlider) {
	                this._opacitySlider.destroy();
	            }
	            this._hueSlider = this._opacitySlider = this._hsvRect = this._hsvHandle =
	                this._hueElements = this._selectedColor = this._colorAsText = null;
	            ColorSelector.fn.destroy.call(this);
	        },
	        options: {
	            name       : "FlatColorPicker",
	            opacity    : false,
	            buttons    : false,
	            input      : true,
	            preview    : true,
	            clearButton: false,
	            autoupdate : true,
	            messages   : MESSAGES
	        },
	        _applyIEFilter: function() {
	            var track = this.element.find(".k-hue-slider .k-slider-track")[0],
	                url = track.currentStyle.backgroundImage;

	            url = url.replace(/^url\([\'\"]?|[\'\"]?\)$/g, "");
	            track.style.filter = "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" + url + "', sizingMethod='scale')";
	        },
	        _sliders: function() {
	            var that = this,
	                element = that.element,
	                hueSlider = element.find(".k-hue-slider"),
	                opacitySlider = element.find(".k-alpha-slider");

	            function hueChange(e) {
	                that._updateUI(that._getHSV(e.value, null, null, null));
	            }

	            hueSlider.attr("aria-label", "hue saturation");
	            that._hueSlider = hueSlider.kendoSlider({
	                min: 0,
	                max: 360,
	                tickPlacement: "none",
	                showButtons: false,
	                slide: hueChange,
	                change: hueChange
	            }).data("kendoSlider");

	            function opacityChange(e) {
	                that._updateUI(that._getHSV(null, null, null, e.value / 100));
	            }

	            opacitySlider.attr("aria-label", "opacity");
	            that._opacitySlider = opacitySlider.kendoSlider({
	                min: 0,
	                max: 100,
	                tickPlacement: "none",
	                showButtons: false,
	                slide: opacityChange,
	                change: opacityChange
	            }).data("kendoSlider");
	        },
	        _hsvArea: function() {
	            var that = this,
	                element = that.element,
	                hsvRect = element.find(".k-hsv-rectangle"),
	                hsvHandle = hsvRect.find(".k-draghandle").attr("tabIndex", 0).on(KEYDOWN_NS, bind(that._keydown, that));

	            function update(x, y) {
	                var offset = this.offset,
	                    dx = x - offset.left, dy = y - offset.top,
	                    rw = this.width, rh = this.height;

	                dx = dx < 0 ? 0 : dx > rw ? rw : dx;
	                dy = dy < 0 ? 0 : dy > rh ? rh : dy;
	                that._svChange(dx / rw, 1 - dy / rh);
	            }

	            that._hsvEvents = new kendo.UserEvents(hsvRect, {
	                global: true,
	                press: function(e) {
	                    this.offset = kendo.getOffset(hsvRect);
	                    this.width = hsvRect.width();
	                    this.height = hsvRect.height();
	                    hsvHandle.focus();
	                    update.call(this, e.x.location, e.y.location);
	                },
	                start: function() {
	                    hsvRect.addClass("k-dragging");
	                    hsvHandle.focus();
	                },
	                move: function(e) {
	                    e.preventDefault();
	                    update.call(this, e.x.location, e.y.location);
	                },
	                end: function() {
	                    hsvRect.removeClass("k-dragging");
	                }
	            });

	            that._hsvRect = hsvRect;
	            that._hsvHandle = hsvHandle;
	        },
	        _onEnable: function(enable) {
	            this._hueSlider.enable(enable);

	            if (this._opacitySlider) {
	                this._opacitySlider.enable(enable);
	            }

	            this.wrapper.find("input").attr("disabled", !enable);

	            var handle = this._hsvRect.find(".k-draghandle");

	            if (enable) {
	                handle.attr("tabIndex", this._tabIndex);
	            } else {
	                handle.removeAttr("tabIndex");
	            }
	        },
	        _keydown: function(ev) {
	            var that = this;
	            function move(prop, d) {
	                var c = that._getHSV();
	                c[prop] += d * (ev.shiftKey ? 0.01 : 0.05);
	                if (c[prop] < 0) { c[prop] = 0; }
	                if (c[prop] > 1) { c[prop] = 1; }
	                that._updateUI(c);
	                preventDefault(ev);
	            }
	            function hue(d) {
	                var c = that._getHSV();
	                c.h += d * (ev.shiftKey ? 1 : 5);
	                if (c.h < 0) { c.h = 0; }
	                if (c.h > 359) { c.h = 359; }
	                that._updateUI(c);
	                preventDefault(ev);
	            }
	            switch (ev.keyCode) {
	              case KEYS.LEFT:
	                if (ev.ctrlKey) {
	                    hue(-1);
	                } else {
	                    move("s", -1);
	                }
	                break;
	              case KEYS.RIGHT:
	                if (ev.ctrlKey) {
	                    hue(1);
	                } else {
	                    move("s", 1);
	                }
	                break;
	              case KEYS.UP:
	                move(ev.ctrlKey && that._opacitySlider ? "a" : "v", 1);
	                break;
	              case KEYS.DOWN:
	                move(ev.ctrlKey && that._opacitySlider ? "a" : "v", -1);
	                break;
	              case KEYS.ENTER:
	                that._select(that._getHSV());
	                break;
	              case KEYS.F2:
	                that.wrapper.find("input.k-color-value").focus().select();
	                break;
	              case KEYS.ESC:
	                that._cancel();
	                break;
	            }
	        },
	        focus: function() {
	            this._hsvHandle.focus();
	        },
	        _getHSV: function(h, s, v, a) {
	            var rect = this._hsvRect,
	                width = rect.width(),
	                height = rect.height(),
	                handlePosition = this._hsvHandle.position();

	            if (h == null) {
	                h = this._hueSlider.value();
	            }
	            if (s == null) {
	                s = handlePosition.left / width;
	            }
	            if (v == null) {
	                v = 1 - handlePosition.top / height;
	            }
	            if (a == null) {
	                a = this._opacitySlider ? this._opacitySlider.value() / 100 : 1;
	            }
	            return Color.fromHSV(h, s, v, a);
	        },
	        _svChange: function(s, v) {
	            var color = this._getHSV(null, s, v, null);
	            this._updateUI(color);
	        },
	        _updateUI: function(color, dontChangeInput) {
	            var that = this,
	                rect = that._hsvRect;

	            if (!color) {
	                return;
	            }

	            this._colorAsText.attr("title", that.options.messages.previewInput);
	            this._colorAsText.removeClass("k-state-error");

	            that._selectedColor.css(BACKGROUNDCOLOR, color.toDisplay());
	            if (!dontChangeInput) {
	                that._colorAsText.val(that._opacitySlider ? color.toCssRgba() : color.toCss());
	            }
	            that._triggerSelect(color);

	            color = color.toHSV();
	            that._hsvHandle.css({
	                // saturation is 0 on the left side, full (1) on the right
	                left: color.s * rect.width() + "px",
	                // value is 0 on the bottom, full on the top.
	                top: (1 - color.v) * rect.height() + "px"
	            });

	            that._hueElements.css(BACKGROUNDCOLOR, Color.fromHSV(color.h, 1, 1, 1).toCss());
	            that._hueSlider.value(color.h);

	            if (that._opacitySlider) {
	                that._opacitySlider.value(100 * color.a);
	            }
	        },
	        _selectOnHide: function() {
	            return this.options.buttons ? null : this._getHSV();
	        },
	        _template: kendo.template(
	            '# if (preview) { #' +
	                '<div class="k-selected-color"><div class="k-selected-color-display"><div class="k-color-input"><input class="k-color-value" ' +
	                    '# if (clearButton && !_standalone) { #' +
	                        'placeholder="#: messages.noColor #" ' +
	                    '# } #' +
	                    '#= !data.input ? \'style=\"visibility: hidden;\"\' : \"\" #>' +
	                '# if (clearButton && !_standalone) { #' +
	                    '<span class="k-clear-color k-button k-flat" title="#: messages.clearColor #"></span>' +
	                '# } #' +
	                '</div></div></div>' +
	            '# } #' +
	             '# if (clearButton && !_standalone && !preview) { #' +
	                    '<div class="k-clear-color-container"><span class="k-clear-color k-button k-flat">#: messages.clearColor #</span></div>' +
	             '# } #' +
	            '<div class="k-hsv-rectangle"><div class="k-hsv-gradient"></div><div class="k-draghandle"></div></div>' +
	            '<div class="k-sliders-wrap k-vbox">' +
	                '<input class="k-hue-slider" />' +
	                '# if (opacity) { #' +
	                    '<input class="k-alpha-slider k-transparency-slider" />' +
	                '# } #' +
	            '</div>' +
	            '# if (buttons) { #' +
	                '<div unselectable="on" class="k-controls"><button class="k-button k-primary apply">#: messages.apply #</button> <button class="k-button cancel">#: messages.cancel #</button></div>' +
	            '# } #'
	        )
	    });

	    function relative(array, element, delta) {
	        array = Array.prototype.slice.call(array);
	        var n = array.length;
	        var pos = array.indexOf(element);
	        if (pos < 0) {
	            return delta < 0 ? array[n - 1] : array[0];
	        }
	        pos += delta;
	        if (pos < 0) {
	            pos += n;
	        } else {
	            pos %= n;
	        }
	        return array[pos];
	    }

	    /* -----[ The ColorPicker widget ]----- */

	    var ColorPicker = Widget.extend({
	        init: function(element, options) {
	            var that = this;
	            Widget.fn.init.call(that, element, options);
	            options = that.options;
	            element = that.element;

	            var value = element.attr("value") || element.val();
	            if (value) {
	                value = parseColor(value, true);
	            } else {
	                value = parseColor(options.value, true);
	            }
	            that._value = options.value = value;

	            var content = that.wrapper = $(that._template(options));
	            element.hide().after(content);

	            that._inputWrapper = $(that.wrapper[0].firstChild);

	            if (element.is("input")) {
	                element.appendTo(content);

	                // if there exists a <label> associated with this
	                // input field, we must catch clicks on it to prevent
	                // the built-in color picker from showing up.
	                // https://github.com/telerik/kendo-ui-core/issues/292

	                var label = element.closest("label");
	                var id = element.attr("id");
	                if (id) {
	                    label = label.add('label[for="' + id + '"]');
	                }
	                label.click(function(ev){
	                    that.open();
	                    ev.preventDefault();
	                });
	            }

	            that._tabIndex = element.attr("tabIndex") || 0;

	            that.enable(!element.attr("disabled"));

	            var accesskey = element.attr("accesskey");
	            if (accesskey) {
	                element.attr("accesskey", null);
	                content.attr("accesskey", accesskey);
	            }

	            that.bind("activate", function(ev){
	                if (!ev.isDefaultPrevented()) {
	                    that.toggle();
	                }
	            });

	            that._updateUI(value);
	        },
	        destroy: function() {
	            this.wrapper.off(NS).find("*").off(NS);
	            if (this._popup) {
	                this._selector.destroy();
	                this._popup.destroy();
	            }
	            this._selector = this._popup = this.wrapper = null;
	            Widget.fn.destroy.call(this);
	        },
	        enable: function(enable) {
	            var that = this,
	                wrapper = that.wrapper,
	                innerWrapper = wrapper.children(".k-picker-wrap"),
	                arrow = innerWrapper.find(".k-select");

	            if (arguments.length === 0) {
	                enable = true;
	            }

	            that.element.attr("disabled", !enable);
	            wrapper.attr("aria-disabled", !enable);

	            arrow.off(NS).on("mousedown" + NS, preventDefault);

	            wrapper.addClass("k-state-disabled")
	                .removeAttr("tabIndex")
	                .add("*", wrapper).off(NS);

	            if (enable) {
	                wrapper.removeClass("k-state-disabled")
	                    .attr("tabIndex", that._tabIndex)
	                    .on("mouseenter" + NS, function () { innerWrapper.addClass("k-state-hover"); })
	                    .on("mouseleave" + NS, function () { innerWrapper.removeClass("k-state-hover"); })
	                    .on("focus" + NS, function () { innerWrapper.addClass("k-state-focused"); })
	                    .on("blur" + NS, function () { innerWrapper.removeClass("k-state-focused"); })
	                    .on(KEYDOWN_NS, bind(that._keydown, that))
	                    .on(CLICK_NS, ".k-select", bind(that.toggle, that))
	                    .on(CLICK_NS, that.options.toolIcon ? ".k-tool-icon" : ".k-selected-color", function () {
	                        that.trigger("activate");
	                    });
	            } else {
	                that.close();
	            }
	        },

	        _template: kendo.template(
	            '<span role="textbox" aria-haspopup="true" class="k-widget k-colorpicker">' +
	                '<span class="k-picker-wrap k-state-default">' +
	                    '# if (toolIcon) { #' +
	                        '<span class="k-icon k-tool-icon #= toolIcon #">' +
	                            '<span class="k-selected-color"></span>' +
	                        '</span>' +
	                    '# } else { #' +
	                        '<span class="k-selected-color"><span class="k-icon k-i-line" style="display: none;"></span></span>' +
	                    '# } #' +
	                    '<span class="k-select" unselectable="on" aria-label="select">' +
	                        '<span class="k-icon k-i-arrow-60-down"></span>' +
	                    '</span>' +
	                '</span>' +
	            '</span>'
	        ),

	        options: {
	            name: "ColorPicker",
	            palette: null,
	            columns: 10,
	            toolIcon: null,
	            value: null,
	            messages: MESSAGES,
	            opacity: false,
	            buttons: true,
	            preview: true,
	            clearButton: false,
	            ARIATemplate: 'Current selected color is #=data || ""#'
	        },

	        events: [ "activate", "change", "select", "open", "close" ],

	        open: function () {
	            if (!this.element.prop("disabled")) {
	                this._getPopup().open();
	            }
	        },
	        close: function () {
	            var selOptions = (this._selector && this._selector.options) || {};
	            selOptions._closing = true;

	            this._getPopup().close();

	            delete selOptions._closing;
	        },
	        toggle: function () {
	            if (!this.element.prop("disabled")) {
	                this._getPopup().toggle();
	            }
	        },
	        _noColorIcon: function(){
	            return this.wrapper.find(".k-picker-wrap > .k-selected-color > .k-icon.k-i-line");
	        },
	        color: ColorSelector.fn.color,
	        value: ColorSelector.fn.value,
	        _select: ColorSelector.fn._select,
	        _triggerSelect: ColorSelector.fn._triggerSelect,
	        _isInputTypeColor: function() {
	            var el = this.element[0];
	            return (/^input$/i).test(el.tagName) && (/^color$/i).test(el.type);
	        },

	        _updateUI: function(value) {
	            var formattedValue = "";

	            if (value) {
	                if (this._isInputTypeColor() || value.a == 1) {
	                    // seems that input type="color" doesn't support opacity
	                    // in colors; the only accepted format is hex #RRGGBB
	                    formattedValue = value.toCss();
	                } else {
	                    formattedValue = value.toCssRgba();
	                }

	                this.element.val(formattedValue);
	            }

	            if (!this._ariaTemplate) {
	                this._ariaTemplate = kendo.template(this.options.ARIATemplate);
	            }

	            this.wrapper.attr("aria-label", this._ariaTemplate(formattedValue));

	            this._triggerSelect(value);
	            this.wrapper.find(".k-selected-color").css(
	                BACKGROUNDCOLOR,
	                value ? value.toDisplay() : WHITE
	            );

	            this._noColorIcon()[formattedValue ? "hide": "show"]();
	        },
	        _keydown: function(ev) {
	            var key = ev.keyCode;
	            if (this._getPopup().visible()) {
	                if (key == KEYS.ESC) {
	                    this._selector._cancel();
	                } else {
	                    this._selector._keydown(ev);
	                }
	                preventDefault(ev);
	            }
	            else if (key == KEYS.ENTER || key == KEYS.DOWN) {
	                this.open();
	                preventDefault(ev);
	            }
	        },
	        _getPopup: function() {
	            var that = this, popup = that._popup;

	            if (!popup) {
	                var options = that.options;
	                var selectorType;

	                if (options.palette) {
	                    selectorType = ColorPalette;
	                } else {
	                    selectorType = FlatColorPicker;
	                }

	                options._standalone = false;
	                delete options.select;
	                delete options.change;
	                delete options.cancel;

	                var id = kendo.guid();
	                var selector = that._selector = new selectorType($('<div id="' + id +'"></div>').appendTo(document.body), options);

	                that.wrapper.attr("aria-owns", id);

	                that._popup = popup = selector.wrapper.kendoPopup({
	                    anchor: that.wrapper,
	                    adjustSize: { width: 5, height: 0 }
	                }).data("kendoPopup");

	                selector.element.find(".k-clear-color").kendoButton({
	                    icon: "reset-color",
	                    click: function(e) {
	                        selector.options._clearedColor = true;
	                        that.value(null);
	                        that.element.val(null);
	                        that._updateUI(null);
	                        selector._colorAsText.val("");
	                        selector._hsvHandle.css({
	                            top: "0px",
	                            left: "0px"
	                        });
	                        selector._selectedColor.css(BACKGROUNDCOLOR, WHITE);

	                        that.trigger("change", { value: that.value() });
	                        e.preventDefault();
	                    }
	                });

	                selector.bind({
	                    select: function(ev){
	                        that._updateUI(parseColor(ev.value));
	                        delete selector.options._clearedColor;
	                    },
	                    change: function(){
	                        if (!selector.options._clearedColor) {
	                            that._select(selector.color());
	                        }
	                        that.close();
	                    },
	                    cancel: function() {
	                        if (selector.options._clearedColor && !that.value() && selector.value()) {
	                            that._select(selector.color(), true);
	                        }
	                        that.close();
	                    }
	                });
	                popup.bind({
	                    close: function(ev){
	                        if (that.trigger("close")) {
	                            ev.preventDefault();
	                            return;
	                        }
	                        that.wrapper.children(".k-picker-wrap").removeClass("k-state-focused");
	                        var color = selector._selectOnHide();
	                        var selectorColor = selector.value();
	                        var value = that.value();
	                        var options = selector.options;
	                        if (!color) {
	                            setTimeout(function(){
	                                if (that.wrapper && !that.wrapper.is("[unselectable='on']")) {
	                                    that.wrapper.focus();
	                                }
	                            });

	                            if (!options._closing && options._clearedColor && !value && selectorColor) {
	                                that._select(selectorColor, true);
	                            } else {
	                                that._updateUI(that.color());
	                            }
	                        } else if (!(options._clearedColor && !value)) {
	                            that._select(color);
	                        }
	                    },
	                    open: function(ev) {
	                        if (that.trigger("open")) {
	                            ev.preventDefault();
	                        } else {
	                            that.wrapper.children(".k-picker-wrap").addClass("k-state-focused");
	                        }
	                    },
	                    activate: function(){
	                        selector._select(that.color(), true);
	                        selector.focus();
	                        that.wrapper.children(".k-picker-wrap").addClass("k-state-focused");
	                    }
	                });
	            }
	            return popup;
	        }
	    });

	    function preventDefault(ev) { ev.preventDefault(); }

	    function bind(callback, obj) {
	        return function() {
	            return callback.apply(obj, arguments);
	        };
	    }

	    ui.plugin(ColorPalette);
	    ui.plugin(FlatColorPicker);
	    ui.plugin(ColorPicker);

	})(jQuery, parseInt);

	return window.kendo;

	}, __webpack_require__(3));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1048)))

/***/ }),

/***/ 1085:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Fv0e");

/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1087:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("WuVc");

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FZAa");

/***/ }),

/***/ 1089:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("+Uqz");

/***/ })

/******/ });

/***/ }),

/***/ "3Eo+":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "3RUv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var gridPanel_1 = __webpack_require__("inOk");
var expressionService_1 = __webpack_require__("1aUC");
var templateService_1 = __webpack_require__("0vz1");
var valueService_1 = __webpack_require__("5JVC");
var eventService_1 = __webpack_require__("k5uU");
var rowComp_1 = __webpack_require__("ci/Y");
var events_1 = __webpack_require__("3ok8");
var constants_1 = __webpack_require__("ZZFX");
var cellComp_1 = __webpack_require__("wTNE");
var context_1 = __webpack_require__("RQ1/");
var gridCore_1 = __webpack_require__("b9np");
var columnApi_1 = __webpack_require__("E/Wy");
var columnController_1 = __webpack_require__("77lH");
var logger_1 = __webpack_require__("U9Xd");
var focusedCellController_1 = __webpack_require__("4Sr9");
var cellNavigationService_1 = __webpack_require__("Cz2g");
var gridCell_1 = __webpack_require__("hie4");
var beanStub_1 = __webpack_require__("xffp");
var paginationProxy_1 = __webpack_require__("wYvi");
var gridApi_1 = __webpack_require__("BAow");
var pinnedRowModel_1 = __webpack_require__("xRx6");
var beans_1 = __webpack_require__("YaQm");
var animationFrameService_1 = __webpack_require__("tvEw");
var RowRenderer = (function (_super) {
    __extends(RowRenderer, _super);
    function RowRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // map of row ids to row objects. keeps track of which elements
        // are rendered for which rows in the dom.
        _this.rowCompsByIndex = {};
        _this.floatingTopRowComps = [];
        _this.floatingBottomRowComps = [];
        // we only allow one refresh at a time, otherwise the internal memory structure here
        // will get messed up. this can happen if the user has a cellRenderer, and inside the
        // renderer they call an API method that results in another pass of the refresh,
        // then it will be trying to draw rows in the middle of a refresh.
        _this.refreshInProgress = false;
        return _this;
    }
    RowRenderer.prototype.agWire = function (loggerFactory) {
        this.logger = loggerFactory.create('RowRenderer');
    };
    RowRenderer.prototype.init = function () {
        this.forPrint = this.gridOptionsWrapper.isForPrint();
        this.autoHeight = this.gridOptionsWrapper.isAutoHeight();
        this.rowContainers = this.gridPanel.getRowContainers();
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_PAGINATION_CHANGED, this.onPageLoaded.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.redrawAfterModelUpdate();
    };
    RowRenderer.prototype.onPageLoaded = function (refreshEvent) {
        if (utils_1.Utils.missing(refreshEvent)) {
            refreshEvent = {
                type: events_1.Events.EVENT_MODEL_UPDATED,
                api: this.gridApi,
                columnApi: this.columnApi,
                animate: false,
                keepRenderedRows: false,
                newData: false,
                newPage: false
            };
        }
        this.onModelUpdated(refreshEvent);
    };
    RowRenderer.prototype.getAllCellsForColumn = function (column) {
        var eCells = [];
        utils_1.Utils.iterateObject(this.rowCompsByIndex, callback);
        utils_1.Utils.iterateObject(this.floatingBottomRowComps, callback);
        utils_1.Utils.iterateObject(this.floatingTopRowComps, callback);
        function callback(key, rowComp) {
            var eCell = rowComp.getCellForCol(column);
            if (eCell) {
                eCells.push(eCell);
            }
        }
        return eCells;
    };
    RowRenderer.prototype.refreshFloatingRowComps = function () {
        this.refreshFloatingRows(this.floatingTopRowComps, this.pinnedRowModel.getPinnedTopRowData(), this.rowContainers.floatingTopPinnedLeft, this.rowContainers.floatingTopPinnedRight, this.rowContainers.floatingTop, this.rowContainers.floatingTopFullWidth);
        this.refreshFloatingRows(this.floatingBottomRowComps, this.pinnedRowModel.getPinnedBottomRowData(), this.rowContainers.floatingBottomPinnedLeft, this.rowContainers.floatingBottomPinnedRight, this.rowContainers.floatingBottom, this.rowContainers.floatingBottomFullWith);
    };
    RowRenderer.prototype.refreshFloatingRows = function (rowComps, rowNodes, pinnedLeftContainerComp, pinnedRightContainerComp, bodyContainerComp, fullWidthContainerComp) {
        var _this = this;
        rowComps.forEach(function (row) {
            row.destroy();
        });
        rowComps.length = 0;
        // if no cols, don't draw row - can we get rid of this???
        var columns = this.columnController.getAllDisplayedColumns();
        if (utils_1.Utils.missingOrEmpty(columns)) {
            return;
        }
        if (rowNodes) {
            rowNodes.forEach(function (node) {
                var rowComp = new rowComp_1.RowComp(_this.$scope, bodyContainerComp, pinnedLeftContainerComp, pinnedRightContainerComp, fullWidthContainerComp, node, _this.beans, false, false);
                rowComp.init();
                rowComps.push(rowComp);
            });
        }
        this.flushContainers(rowComps);
    };
    RowRenderer.prototype.onPinnedRowDataChanged = function () {
        this.redrawAfterModelUpdate();
    };
    RowRenderer.prototype.onModelUpdated = function (refreshEvent) {
        var params = {
            recycleRows: refreshEvent.keepRenderedRows,
            animate: refreshEvent.animate,
            newData: refreshEvent.newData,
            newPage: refreshEvent.newPage
        };
        this.redrawAfterModelUpdate(params);
        // this.eventService.dispatchEvent(Events.DEPRECATED_EVENT_PAGINATION_PAGE_LOADED);
    };
    // if the row nodes are not rendered, no index is returned
    RowRenderer.prototype.getRenderedIndexesForRowNodes = function (rowNodes) {
        var result = [];
        if (utils_1.Utils.missing(rowNodes)) {
            return result;
        }
        utils_1.Utils.iterateObject(this.rowCompsByIndex, function (index, renderedRow) {
            var rowNode = renderedRow.getRowNode();
            if (rowNodes.indexOf(rowNode) >= 0) {
                result.push(index);
            }
        });
        return result;
    };
    RowRenderer.prototype.redrawRows = function (rowNodes) {
        if (!rowNodes || rowNodes.length == 0) {
            return;
        }
        // we only need to be worried about rendered rows, as this method is
        // called to whats rendered. if the row isn't rendered, we don't care
        var indexesToRemove = this.getRenderedIndexesForRowNodes(rowNodes);
        // remove the rows
        this.removeRowComps(indexesToRemove);
        // add draw them again
        this.redrawAfterModelUpdate({
            recycleRows: true
        });
    };
    RowRenderer.prototype.getCellToRestoreFocusToAfterRefresh = function (params) {
        var focusedCell = params.suppressKeepFocus ? null : this.focusedCellController.getFocusCellToUseAfterRefresh();
        if (utils_1.Utils.missing(focusedCell)) {
            return null;
        }
        // if the dom is not actually focused on a cell, then we don't try to refocus. the problem this
        // solves is with editing - if the user is editing, eg focus is on a text field, and not on the
        // cell itself, then the cell can be registered as having focus, however it's the text field that
        // has the focus and not the cell div. therefore, when the refresh is finished, the grid will focus
        // the cell, and not the textfield. that means if the user is in a text field, and the grid refreshes,
        // the focus is lost from the text field. we do not want this.
        var activeElement = document.activeElement;
        var domData = this.gridOptionsWrapper.getDomData(activeElement, cellComp_1.CellComp.DOM_DATA_KEY_CELL_COMP);
        var elementIsNotACellDev = utils_1.Utils.missing(domData);
        if (elementIsNotACellDev) {
            return null;
        }
        return focusedCell;
    };
    // gets called after changes to the model.
    RowRenderer.prototype.redrawAfterModelUpdate = function (params) {
        if (params === void 0) { params = {}; }
        this.getLockOnRefresh();
        var focusedCell = this.getCellToRestoreFocusToAfterRefresh(params);
        if (!this.forPrint) {
            this.sizeContainerToPageHeight();
        }
        this.scrollToTopIfNewData(params);
        // never keep rendered rows if doing forPrint or autoHeight, as we do not use 'top' to
        // position the rows (it uses normal flow), so we have to remove
        // all rows and insert them again from scratch
        var rowsUsingFlow = this.forPrint || this.autoHeight;
        var recycleRows = rowsUsingFlow ? false : params.recycleRows;
        var animate = rowsUsingFlow ? false : (params.animate && this.gridOptionsWrapper.isAnimateRows());
        var rowsToRecycle = this.binRowComps(recycleRows);
        this.redraw(rowsToRecycle, animate);
        if (!params.onlyBody) {
            this.refreshFloatingRowComps();
        }
        this.restoreFocusedCell(focusedCell);
        this.releaseLockOnRefresh();
    };
    RowRenderer.prototype.scrollToTopIfNewData = function (params) {
        var scrollToTop = params.newData || params.newPage;
        var suppressScrollToTop = this.gridOptionsWrapper.isSuppressScrollOnNewData();
        if (scrollToTop && !suppressScrollToTop) {
            this.gridPanel.scrollToTop();
        }
    };
    RowRenderer.prototype.sizeContainerToPageHeight = function () {
        var containerHeight = this.paginationProxy.getCurrentPageHeight();
        // we need at least 1 pixel for the horizontal scroll to work. so if there are now rows,
        // we still want the scroll to be present, otherwise there would be no way to access the columns
        // on the RHS - and if that was where the filter was that cause no rows to be presented, there
        // is no way to remove the filter.
        if (containerHeight === 0) {
            containerHeight = 1;
        }
        this.rowContainers.body.setHeight(containerHeight);
        this.rowContainers.fullWidth.setHeight(containerHeight);
        this.rowContainers.pinnedLeft.setHeight(containerHeight);
        this.rowContainers.pinnedRight.setHeight(containerHeight);
    };
    RowRenderer.prototype.getLockOnRefresh = function () {
        if (this.refreshInProgress) {
            throw 'ag-Grid: cannot get grid to draw rows when it is in the middle of drawing rows. ' +
                'Your code probably called a grid API method while the grid was in the render stage. To overcome ' +
                'this, put the API call into a timeout, eg instead of api.refreshView(), ' +
                'call setTimeout(function(){api.refreshView(),0}). To see what part of your code ' +
                'that caused the refresh check this stacktrace.';
        }
        this.refreshInProgress = true;
    };
    RowRenderer.prototype.releaseLockOnRefresh = function () {
        this.refreshInProgress = false;
    };
    // sets the focus to the provided cell, if the cell is provided. this way, the user can call refresh without
    // worry about the focus been lost. this is important when the user is using keyboard navigation to do edits
    // and the cellEditor is calling 'refresh' to get other cells to update (as other cells might depend on the
    // edited cell).
    RowRenderer.prototype.restoreFocusedCell = function (gridCell) {
        if (gridCell) {
            this.focusedCellController.setFocusedCell(gridCell.rowIndex, gridCell.column, gridCell.floating, true);
        }
    };
    RowRenderer.prototype.stopEditing = function (cancel) {
        if (cancel === void 0) { cancel = false; }
        this.forEachRowComp(function (key, renderedRow) {
            renderedRow.stopEditing(cancel);
        });
    };
    RowRenderer.prototype.forEachCellComp = function (callback) {
        utils_1.Utils.iterateObject(this.rowCompsByIndex, function (index, renderedRow) {
            renderedRow.forEachCellComp(callback);
        });
    };
    RowRenderer.prototype.forEachRowComp = function (callback) {
        utils_1.Utils.iterateObject(this.rowCompsByIndex, callback);
        utils_1.Utils.iterateObject(this.floatingTopRowComps, callback);
        utils_1.Utils.iterateObject(this.floatingBottomRowComps, callback);
    };
    RowRenderer.prototype.addRenderedRowListener = function (eventName, rowIndex, callback) {
        var rowComp = this.rowCompsByIndex[rowIndex];
        if (rowComp) {
            rowComp.addEventListener(eventName, callback);
        }
    };
    RowRenderer.prototype.refreshCells = function (params) {
        var _this = this;
        if (params === void 0) { params = {}; }
        var rowIdsMap;
        if (utils_1.Utils.exists(params.rowNodes)) {
            rowIdsMap = {
                top: {},
                bottom: {},
                normal: {}
            };
            params.rowNodes.forEach(function (rowNode) {
                if (rowNode.rowPinned === constants_1.Constants.PINNED_TOP) {
                    rowIdsMap.top[rowNode.id] = true;
                }
                else if (rowNode.rowPinned === constants_1.Constants.PINNED_BOTTOM) {
                    rowIdsMap.bottom[rowNode.id] = true;
                }
                else {
                    rowIdsMap.normal[rowNode.id] = true;
                }
            });
        }
        var colIdsMap;
        if (utils_1.Utils.exists(params.columns)) {
            colIdsMap = {};
            params.columns.forEach(function (colKey) {
                var column = _this.columnController.getGridColumn(colKey);
                if (utils_1.Utils.exists(column)) {
                    colIdsMap[column.getId()] = true;
                }
            });
        }
        var processRow = function (rowComp) {
            var rowNode = rowComp.getRowNode();
            var id = rowNode.id;
            var floating = rowNode.rowPinned;
            // skip this row if it is missing from the provided list
            if (utils_1.Utils.exists(rowIdsMap)) {
                if (floating === constants_1.Constants.PINNED_BOTTOM) {
                    if (!rowIdsMap.bottom[id]) {
                        return;
                    }
                }
                else if (floating === constants_1.Constants.PINNED_TOP) {
                    if (!rowIdsMap.top[id]) {
                        return;
                    }
                }
                else {
                    if (!rowIdsMap.normal[id]) {
                        return;
                    }
                }
            }
            rowComp.forEachCellComp(function (cellComp) {
                var colId = cellComp.getColumn().getId();
                var excludeColFromRefresh = colIdsMap && !colIdsMap[colId];
                if (excludeColFromRefresh) {
                    return;
                }
                cellComp.refreshCell({
                    forceRefresh: params.force,
                    newData: false
                });
            });
        };
        utils_1.Utils.iterateObject(this.rowCompsByIndex, function (index, rowComp) {
            processRow(rowComp);
        });
        if (this.floatingTopRowComps) {
            this.floatingTopRowComps.forEach(processRow);
        }
        if (this.floatingBottomRowComps) {
            this.floatingBottomRowComps.forEach(processRow);
        }
    };
    RowRenderer.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        var rowIndexesToRemove = Object.keys(this.rowCompsByIndex);
        this.removeRowComps(rowIndexesToRemove);
    };
    RowRenderer.prototype.binRowComps = function (recycleRows) {
        var _this = this;
        var indexesToRemove;
        var rowsToRecycle = {};
        if (recycleRows) {
            indexesToRemove = [];
            utils_1.Utils.iterateObject(this.rowCompsByIndex, function (index, rowComp) {
                var rowNode = rowComp.getRowNode();
                if (utils_1.Utils.exists(rowNode.id)) {
                    rowsToRecycle[rowNode.id] = rowComp;
                    delete _this.rowCompsByIndex[index];
                }
                else {
                    indexesToRemove.push(index);
                }
            });
        }
        else {
            indexesToRemove = Object.keys(this.rowCompsByIndex);
        }
        this.removeRowComps(indexesToRemove);
        return rowsToRecycle;
    };
    // takes array of row indexes
    RowRenderer.prototype.removeRowComps = function (rowsToRemove) {
        var _this = this;
        // if no fromIndex then set to -1, which will refresh everything
        // let realFromIndex = -1;
        rowsToRemove.forEach(function (indexToRemove) {
            var renderedRow = _this.rowCompsByIndex[indexToRemove];
            renderedRow.destroy();
            delete _this.rowCompsByIndex[indexToRemove];
        });
    };
    // gets called when rows don't change, but viewport does, so after:
    // 1) size of grid changed
    // 2) grid scrolled to new position
    // 3) ensure index visible (which is a scroll)
    RowRenderer.prototype.redrawAfterScroll = function () {
        this.getLockOnRefresh();
        this.redraw(null, false, true);
        this.releaseLockOnRefresh();
    };
    RowRenderer.prototype.removeRowCompsNotToDraw = function (indexesToDraw) {
        // for speedy lookup, dump into map
        var indexesToDrawMap = {};
        indexesToDraw.forEach(function (index) { return indexesToDrawMap[index] = true; });
        var existingIndexes = Object.keys(this.rowCompsByIndex);
        var indexesNotToDraw = utils_1.Utils.filter(existingIndexes, function (index) { return !indexesToDrawMap[index]; });
        this.removeRowComps(indexesNotToDraw);
    };
    RowRenderer.prototype.calculateIndexesToDraw = function () {
        var _this = this;
        // all in all indexes in the viewport
        var indexesToDraw = utils_1.Utils.createArrayOfNumbers(this.firstRenderedRow, this.lastRenderedRow);
        // add in indexes of rows we want to keep, because they are currently editing
        utils_1.Utils.iterateObject(this.rowCompsByIndex, function (indexStr, rowComp) {
            var index = Number(indexStr);
            if (index < _this.firstRenderedRow || index > _this.lastRenderedRow) {
                if (_this.keepRowBecauseEditing(rowComp)) {
                    indexesToDraw.push(index);
                }
            }
        });
        indexesToDraw.sort(function (a, b) { return a - b; });
        return indexesToDraw;
    };
    RowRenderer.prototype.redraw = function (rowsToRecycle, animate, afterScroll) {
        var _this = this;
        if (animate === void 0) { animate = false; }
        if (afterScroll === void 0) { afterScroll = false; }
        this.workOutFirstAndLastRowsToRender();
        // the row can already exist and be in the following:
        // rowsToRecycle -> if model change, then the index may be different, however row may
        //                         exist here from previous time (mapped by id).
        // this.rowCompsByIndex -> if just a scroll, then this will contain what is currently in the viewport
        // this is all the indexes we want, including those that already exist, so this method
        // will end up going through each index and drawing only if the row doesn't already exist
        var indexesToDraw = this.calculateIndexesToDraw();
        this.removeRowCompsNotToDraw(indexesToDraw);
        // add in new rows
        var nextVmTurnFunctions = [];
        var rowComps = [];
        indexesToDraw.forEach(function (rowIndex) {
            var rowComp = _this.createOrUpdateRowComp(rowIndex, rowsToRecycle, animate, afterScroll);
            if (utils_1.Utils.exists(rowComp)) {
                rowComps.push(rowComp);
                utils_1.Utils.pushAll(nextVmTurnFunctions, rowComp.getAndClearNextVMTurnFunctions());
            }
        });
        this.flushContainers(rowComps);
        utils_1.Utils.executeNextVMTurn(nextVmTurnFunctions);
        if (afterScroll && !this.gridOptionsWrapper.isSuppressAnimationFrame()) {
            this.beans.taskQueue.addP2Task(this.destroyRowComps.bind(this, rowsToRecycle, animate));
        }
        else {
            this.destroyRowComps(rowsToRecycle, animate);
        }
        this.checkAngularCompile();
    };
    RowRenderer.prototype.flushContainers = function (rowComps) {
        utils_1.Utils.iterateObject(this.rowContainers, function (key, rowContainerComp) {
            if (rowContainerComp) {
                rowContainerComp.flushRowTemplates();
            }
        });
        rowComps.forEach(function (rowComp) { return rowComp.afterFlush(); });
    };
    RowRenderer.prototype.onDisplayedColumnsChanged = function () {
        var pinningLeft = this.columnController.isPinningLeft();
        var pinningRight = this.columnController.isPinningRight();
        var atLeastOneChanged = this.pinningLeft !== pinningLeft || pinningRight !== this.pinningRight;
        if (atLeastOneChanged) {
            this.pinningLeft = pinningLeft;
            this.pinningRight = pinningRight;
            if (this.gridOptionsWrapper.isEmbedFullWidthRows()) {
                this.redrawFullWidthEmbeddedRows();
            }
        }
    };
    // when embedding, what gets showed in each section depends on what is pinned. eg if embedding group expand / collapse,
    // then it should go into the pinned left area if pinning left, or the center area if not pinning.
    RowRenderer.prototype.redrawFullWidthEmbeddedRows = function () {
        // if either of the pinned panels has shown / hidden, then need to redraw the fullWidth bits when
        // embedded, as what appears in each section depends on whether we are pinned or not
        var rowsToRemove = [];
        this.forEachRowComp(function (id, rowComp) {
            if (rowComp.isFullWidth()) {
                var rowIndex = rowComp.getRowNode().rowIndex;
                rowsToRemove.push(rowIndex.toString());
            }
        });
        this.removeRowComps(rowsToRemove);
        this.redrawAfterScroll();
    };
    RowRenderer.prototype.createOrUpdateRowComp = function (rowIndex, rowsToRecycle, animate, afterScroll) {
        var rowNode;
        var rowComp = this.rowCompsByIndex[rowIndex];
        // if no row comp, see if we can get it from the previous rowComps
        if (!rowComp) {
            rowNode = this.paginationProxy.getRow(rowIndex);
            if (utils_1.Utils.exists(rowNode) && utils_1.Utils.exists(rowsToRecycle) && rowsToRecycle[rowNode.id]) {
                rowComp = rowsToRecycle[rowNode.id];
                rowsToRecycle[rowNode.id] = null;
            }
        }
        var creatingNewRowComp = !rowComp;
        if (creatingNewRowComp) {
            // create a new one
            if (!rowNode) {
                rowNode = this.paginationProxy.getRow(rowIndex);
            }
            if (utils_1.Utils.exists(rowNode)) {
                rowComp = this.createRowComp(rowNode, animate, afterScroll);
            }
            else {
                // this should never happen - if somehow we are trying to create
                // a row for a rowNode that does not exist.
                return;
            }
        }
        else {
            // ensure row comp is in right position in DOM
            rowComp.ensureDomOrder();
        }
        this.rowCompsByIndex[rowIndex] = rowComp;
        return rowComp;
    };
    RowRenderer.prototype.destroyRowComps = function (rowCompsMap, animate) {
        var delayedFuncs = [];
        utils_1.Utils.iterateObject(rowCompsMap, function (nodeId, rowComp) {
            // if row was used, then it's null
            if (!rowComp) {
                return;
            }
            rowComp.destroy(animate);
            utils_1.Utils.pushAll(delayedFuncs, rowComp.getAndClearDelayedDestroyFunctions());
        });
        utils_1.Utils.executeInAWhile(delayedFuncs);
    };
    RowRenderer.prototype.checkAngularCompile = function () {
        var _this = this;
        // if we are doing angular compiling, then do digest the scope here
        if (this.gridOptionsWrapper.isAngularCompileRows()) {
            // we do it in a timeout, in case we are already in an apply
            setTimeout(function () { _this.$scope.$apply(); }, 0);
        }
    };
    RowRenderer.prototype.workOutFirstAndLastRowsToRender = function () {
        var newFirst;
        var newLast;
        if (!this.paginationProxy.isRowsToRender()) {
            newFirst = 0;
            newLast = -1; // setting to -1 means nothing in range
        }
        else {
            var pageFirstRow = this.paginationProxy.getPageFirstRow();
            var pageLastRow = this.paginationProxy.getPageLastRow();
            if (this.forPrint) {
                newFirst = pageFirstRow;
                newLast = pageLastRow;
            }
            else {
                var pixelOffset = this.paginationProxy ? this.paginationProxy.getPixelOffset() : 0;
                var bodyVRange = this.gridPanel.getVerticalPixelRange();
                var topPixel = bodyVRange.top;
                var bottomPixel = bodyVRange.bottom;
                var first = this.paginationProxy.getRowIndexAtPixel(topPixel + pixelOffset);
                var last = this.paginationProxy.getRowIndexAtPixel(bottomPixel + pixelOffset);
                //add in buffer
                var buffer = this.gridOptionsWrapper.getRowBuffer();
                first = first - buffer;
                last = last + buffer;
                // adjust, in case buffer extended actual size
                if (first < pageFirstRow) {
                    first = pageFirstRow;
                }
                if (last > pageLastRow) {
                    last = pageLastRow;
                }
                newFirst = first;
                newLast = last;
            }
        }
        var firstDiffers = newFirst !== this.firstRenderedRow;
        var lastDiffers = newLast !== this.lastRenderedRow;
        if (firstDiffers || lastDiffers) {
            this.firstRenderedRow = newFirst;
            this.lastRenderedRow = newLast;
            var event_1 = {
                type: events_1.Events.EVENT_VIEWPORT_CHANGED,
                firstRow: newFirst,
                lastRow: newLast,
                api: this.gridApi,
                columnApi: this.columnApi
            };
            this.eventService.dispatchEvent(event_1);
        }
    };
    RowRenderer.prototype.getFirstVirtualRenderedRow = function () {
        return this.firstRenderedRow;
    };
    RowRenderer.prototype.getLastVirtualRenderedRow = function () {
        return this.lastRenderedRow;
    };
    // check that none of the rows to remove are editing or focused as:
    // a) if editing, we want to keep them, otherwise the user will loose the context of the edit,
    //    eg user starts editing, enters some text, then scrolls down and then up, next time row rendered
    //    the edit is reset - so we want to keep it rendered.
    // b) if focused, we want ot keep keyboard focus, so if user ctrl+c, it goes to clipboard,
    //    otherwise the user can range select and drag (with focus cell going out of the viewport)
    //    and then ctrl+c, nothing will happen if cell is removed from dom.
    RowRenderer.prototype.keepRowBecauseEditing = function (rowComp) {
        var REMOVE_ROW = false;
        var KEEP_ROW = true;
        var rowNode = rowComp.getRowNode();
        var rowHasFocus = this.focusedCellController.isRowNodeFocused(rowNode);
        var rowIsEditing = rowComp.isEditing();
        var mightWantToKeepRow = rowHasFocus || rowIsEditing;
        // if we deffo don't want to keep it,
        if (!mightWantToKeepRow) {
            return REMOVE_ROW;
        }
        // editing row, only remove if it is no longer rendered, eg filtered out or new data set.
        // the reason we want to keep is if user is scrolling up and down, we don't want to loose
        // the context of the editing in process.
        var rowNodePresent = this.paginationProxy.isRowPresent(rowNode);
        return rowNodePresent ? KEEP_ROW : REMOVE_ROW;
    };
    RowRenderer.prototype.createRowComp = function (rowNode, animate, afterScroll) {
        var useAnimationFrameForCreate = afterScroll && !this.gridOptionsWrapper.isSuppressAnimationFrame();
        var rowComp = new rowComp_1.RowComp(this.$scope, this.rowContainers.body, this.rowContainers.pinnedLeft, this.rowContainers.pinnedRight, this.rowContainers.fullWidth, rowNode, this.beans, animate, useAnimationFrameForCreate);
        rowComp.init();
        return rowComp;
    };
    RowRenderer.prototype.getRenderedNodes = function () {
        var renderedRows = this.rowCompsByIndex;
        return Object.keys(renderedRows).map(function (key) {
            return renderedRows[key].getRowNode();
        });
    };
    // we use index for rows, but column object for columns, as the next column (by index) might not
    // be visible (header grouping) so it's not reliable, so using the column object instead.
    RowRenderer.prototype.navigateToNextCell = function (event, key, previousCell, allowUserOverride) {
        var nextCell = previousCell;
        // we keep searching for a next cell until we find one. this is how the group rows get skipped
        while (true) {
            nextCell = this.cellNavigationService.getNextCellToFocus(key, nextCell);
            if (utils_1.Utils.missing(nextCell)) {
                break;
            }
            var skipGroupRows = this.gridOptionsWrapper.isGroupUseEntireRow();
            if (skipGroupRows) {
                var rowNode = this.paginationProxy.getRow(nextCell.rowIndex);
                if (!rowNode.group) {
                    break;
                }
            }
            else {
                break;
            }
        }
        // allow user to override what cell to go to next. when doing normal cell navigation (with keys)
        // we allow this, however if processing 'enter after edit' we don't allow override
        if (allowUserOverride) {
            var userFunc = this.gridOptionsWrapper.getNavigateToNextCellFunc();
            if (utils_1.Utils.exists(userFunc)) {
                var params = {
                    key: key,
                    previousCellDef: previousCell,
                    nextCellDef: nextCell ? nextCell.getGridCellDef() : null,
                    event: event
                };
                var nextCellDef = userFunc(params);
                if (utils_1.Utils.exists(nextCellDef)) {
                    nextCell = new gridCell_1.GridCell(nextCellDef);
                }
                else {
                    nextCell = null;
                }
            }
        }
        // no next cell means we have reached a grid boundary, eg left, right, top or bottom of grid
        if (!nextCell) {
            return;
        }
        // this scrolls the row into view
        if (utils_1.Utils.missing(nextCell.floating)) {
            this.gridPanel.ensureIndexVisible(nextCell.rowIndex);
        }
        if (!nextCell.column.isPinned()) {
            this.gridPanel.ensureColumnVisible(nextCell.column);
        }
        // need to nudge the scrolls for the floating items. otherwise when we set focus on a non-visible
        // floating cell, the scrolls get out of sync
        this.gridPanel.horizontallyScrollHeaderCenterAndFloatingCenter();
        // need to flush frames, to make sure the correct cells are rendered
        this.animationFrameService.flushAllFrames();
        this.focusedCellController.setFocusedCell(nextCell.rowIndex, nextCell.column, nextCell.floating, true);
        if (this.rangeController) {
            var gridCell = new gridCell_1.GridCell({ rowIndex: nextCell.rowIndex, floating: nextCell.floating, column: nextCell.column });
            this.rangeController.setRangeToCell(gridCell);
        }
    };
    RowRenderer.prototype.startEditingCell = function (gridCell, keyPress, charPress) {
        var cell = this.getComponentForCell(gridCell);
        if (cell) {
            cell.startRowOrCellEdit(keyPress, charPress);
        }
    };
    RowRenderer.prototype.getComponentForCell = function (gridCell) {
        var rowComponent;
        switch (gridCell.floating) {
            case constants_1.Constants.PINNED_TOP:
                rowComponent = this.floatingTopRowComps[gridCell.rowIndex];
                break;
            case constants_1.Constants.PINNED_BOTTOM:
                rowComponent = this.floatingBottomRowComps[gridCell.rowIndex];
                break;
            default:
                rowComponent = this.rowCompsByIndex[gridCell.rowIndex];
                break;
        }
        if (!rowComponent) {
            return null;
        }
        var cellComponent = rowComponent.getRenderedCellForColumn(gridCell.column);
        return cellComponent;
    };
    RowRenderer.prototype.onTabKeyDown = function (previousRenderedCell, keyboardEvent) {
        var backwards = keyboardEvent.shiftKey;
        var success = this.moveToCellAfter(previousRenderedCell, backwards);
        if (success) {
            keyboardEvent.preventDefault();
        }
    };
    RowRenderer.prototype.tabToNextCell = function (backwards) {
        var focusedCell = this.focusedCellController.getFocusedCell();
        // if no focus, then cannot navigate
        if (utils_1.Utils.missing(focusedCell)) {
            return false;
        }
        var renderedCell = this.getComponentForCell(focusedCell);
        // if cell is not rendered, means user has scrolled away from the cell
        if (utils_1.Utils.missing(renderedCell)) {
            return false;
        }
        var result = this.moveToCellAfter(renderedCell, backwards);
        return result;
    };
    RowRenderer.prototype.moveToCellAfter = function (previousRenderedCell, backwards) {
        var editing = previousRenderedCell.isEditing();
        var res;
        if (editing) {
            if (this.gridOptionsWrapper.isFullRowEdit()) {
                res = this.moveToNextEditingRow(previousRenderedCell, backwards);
            }
            else {
                res = this.moveToNextEditingCell(previousRenderedCell, backwards);
            }
        }
        else {
            res = this.moveToNextCellNotEditing(previousRenderedCell, backwards);
        }
        return res;
    };
    RowRenderer.prototype.moveToNextEditingCell = function (previousRenderedCell, backwards) {
        var gridCell = previousRenderedCell.getGridCell();
        // need to do this before getting next cell to edit, in case the next cell
        // has editable function (eg colDef.editable=func() ) and it depends on the
        // result of this cell, so need to save updates from the first edit, in case
        // the value is referenced in the function.
        previousRenderedCell.stopEditing();
        // find the next cell to start editing
        var nextRenderedCell = this.findNextCellToFocusOn(gridCell, backwards, true);
        var foundCell = utils_1.Utils.exists(nextRenderedCell);
        // only prevent default if we found a cell. so if user is on last cell and hits tab, then we default
        // to the normal tabbing so user can exit the grid.
        if (foundCell) {
            nextRenderedCell.startEditingIfEnabled(null, null, true);
            nextRenderedCell.focusCell(false);
        }
        return foundCell;
    };
    RowRenderer.prototype.moveToNextEditingRow = function (previousRenderedCell, backwards) {
        var gridCell = previousRenderedCell.getGridCell();
        // find the next cell to start editing
        var nextRenderedCell = this.findNextCellToFocusOn(gridCell, backwards, true);
        var foundCell = utils_1.Utils.exists(nextRenderedCell);
        // only prevent default if we found a cell. so if user is on last cell and hits tab, then we default
        // to the normal tabbing so user can exit the grid.
        if (foundCell) {
            this.moveEditToNextCellOrRow(previousRenderedCell, nextRenderedCell);
        }
        return foundCell;
    };
    RowRenderer.prototype.moveToNextCellNotEditing = function (previousRenderedCell, backwards) {
        var gridCell = previousRenderedCell.getGridCell();
        // find the next cell to start editing
        var nextRenderedCell = this.findNextCellToFocusOn(gridCell, backwards, false);
        var foundCell = utils_1.Utils.exists(nextRenderedCell);
        // only prevent default if we found a cell. so if user is on last cell and hits tab, then we default
        // to the normal tabbing so user can exit the grid.
        if (foundCell) {
            nextRenderedCell.focusCell(true);
        }
        return foundCell;
    };
    RowRenderer.prototype.moveEditToNextCellOrRow = function (previousRenderedCell, nextRenderedCell) {
        var pGridCell = previousRenderedCell.getGridCell();
        var nGridCell = nextRenderedCell.getGridCell();
        var rowsMatch = (pGridCell.rowIndex === nGridCell.rowIndex)
            && (pGridCell.floating === nGridCell.floating);
        if (rowsMatch) {
            // same row, so we don't start / stop editing, we just move the focus along
            previousRenderedCell.setFocusOutOnEditor();
            nextRenderedCell.setFocusInOnEditor();
        }
        else {
            var pRow = previousRenderedCell.getRenderedRow();
            var nRow = nextRenderedCell.getRenderedRow();
            previousRenderedCell.setFocusOutOnEditor();
            pRow.stopEditing();
            nRow.startRowEditing();
            nextRenderedCell.setFocusInOnEditor();
        }
        nextRenderedCell.focusCell();
    };
    // called by the cell, when tab is pressed while editing.
    // @return: RenderedCell when navigation successful, otherwise null
    RowRenderer.prototype.findNextCellToFocusOn = function (gridCell, backwards, startEditing) {
        var nextCell = gridCell;
        while (true) {
            nextCell = this.cellNavigationService.getNextTabbedCell(nextCell, backwards);
            // allow user to override what cell to go to next
            var userFunc = this.gridOptionsWrapper.getTabToNextCellFunc();
            if (utils_1.Utils.exists(userFunc)) {
                var params = {
                    backwards: backwards,
                    editing: startEditing,
                    previousCellDef: gridCell.getGridCellDef(),
                    nextCellDef: nextCell ? nextCell.getGridCellDef() : null
                };
                var nextCellDef = userFunc(params);
                if (utils_1.Utils.exists(nextCellDef)) {
                    nextCell = new gridCell_1.GridCell(nextCellDef);
                }
                else {
                    nextCell = null;
                }
            }
            // if no 'next cell', means we have got to last cell of grid, so nothing to move to,
            // so bottom right cell going forwards, or top left going backwards
            if (!nextCell) {
                return null;
            }
            // this scrolls the row into view
            var cellIsNotFloating = utils_1.Utils.missing(nextCell.floating);
            if (cellIsNotFloating) {
                this.gridPanel.ensureIndexVisible(nextCell.rowIndex);
            }
            // pinned columns don't scroll, so no need to ensure index visible
            if (!nextCell.column.isPinned()) {
                this.gridPanel.ensureColumnVisible(nextCell.column);
            }
            // need to nudge the scrolls for the floating items. otherwise when we set focus on a non-visible
            // floating cell, the scrolls get out of sync
            this.gridPanel.horizontallyScrollHeaderCenterAndFloatingCenter();
            // get the grid panel to flush all animation frames - otherwise the call below to get the cellComp
            // could fail, if we just scrolled the grid (to make a cell visible) and the rendering hasn't finished.
            this.animationFrameService.flushAllFrames();
            // we have to call this after ensureColumnVisible - otherwise it could be a virtual column
            // or row that is not currently in view, hence the renderedCell would not exist
            var nextCellComp = this.getComponentForCell(nextCell);
            // if next cell is fullWidth row, then no rendered cell,
            // as fullWidth rows have no cells, so we skip it
            if (utils_1.Utils.missing(nextCellComp)) {
                continue;
            }
            // if editing, but cell not editable, skip cell
            if (startEditing && !nextCellComp.isCellEditable()) {
                continue;
            }
            if (nextCellComp.isSuppressNavigable()) {
                continue;
            }
            // by default, when we click a cell, it gets selected into a range, so to keep keyboard navigation
            // consistent, we set into range here also.
            if (this.rangeController) {
                var gridCell_2 = new gridCell_1.GridCell({ rowIndex: nextCell.rowIndex, floating: nextCell.floating, column: nextCell.column });
                this.rangeController.setRangeToCell(gridCell_2);
            }
            // we successfully tabbed onto a grid cell, so return true
            return nextCellComp;
        }
    };
    __decorate([
        context_1.Autowired('paginationProxy'),
        __metadata("design:type", paginationProxy_1.PaginationProxy)
    ], RowRenderer.prototype, "paginationProxy", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], RowRenderer.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], RowRenderer.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('gridCore'),
        __metadata("design:type", gridCore_1.GridCore)
    ], RowRenderer.prototype, "gridCore", void 0);
    __decorate([
        context_1.Autowired('gridPanel'),
        __metadata("design:type", gridPanel_1.GridPanel)
    ], RowRenderer.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('$scope'),
        __metadata("design:type", Object)
    ], RowRenderer.prototype, "$scope", void 0);
    __decorate([
        context_1.Autowired('expressionService'),
        __metadata("design:type", expressionService_1.ExpressionService)
    ], RowRenderer.prototype, "expressionService", void 0);
    __decorate([
        context_1.Autowired('templateService'),
        __metadata("design:type", templateService_1.TemplateService)
    ], RowRenderer.prototype, "templateService", void 0);
    __decorate([
        context_1.Autowired('valueService'),
        __metadata("design:type", valueService_1.ValueService)
    ], RowRenderer.prototype, "valueService", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], RowRenderer.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('pinnedRowModel'),
        __metadata("design:type", pinnedRowModel_1.PinnedRowModel)
    ], RowRenderer.prototype, "pinnedRowModel", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], RowRenderer.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('loggerFactory'),
        __metadata("design:type", logger_1.LoggerFactory)
    ], RowRenderer.prototype, "loggerFactory", void 0);
    __decorate([
        context_1.Autowired('focusedCellController'),
        __metadata("design:type", focusedCellController_1.FocusedCellController)
    ], RowRenderer.prototype, "focusedCellController", void 0);
    __decorate([
        context_1.Autowired('cellNavigationService'),
        __metadata("design:type", cellNavigationService_1.CellNavigationService)
    ], RowRenderer.prototype, "cellNavigationService", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], RowRenderer.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], RowRenderer.prototype, "gridApi", void 0);
    __decorate([
        context_1.Autowired('beans'),
        __metadata("design:type", beans_1.Beans)
    ], RowRenderer.prototype, "beans", void 0);
    __decorate([
        context_1.Autowired('animationFrameService'),
        __metadata("design:type", animationFrameService_1.AnimationFrameService)
    ], RowRenderer.prototype, "animationFrameService", void 0);
    __decorate([
        context_1.Optional('rangeController'),
        __metadata("design:type", Object)
    ], RowRenderer.prototype, "rangeController", void 0);
    __decorate([
        __param(0, context_1.Qualifier('loggerFactory')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
        __metadata("design:returntype", void 0)
    ], RowRenderer.prototype, "agWire", null);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RowRenderer.prototype, "init", null);
    __decorate([
        context_1.PreDestroy,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RowRenderer.prototype, "destroy", null);
    RowRenderer = __decorate([
        context_1.Bean('rowRenderer')
    ], RowRenderer);
    return RowRenderer;
}(beanStub_1.BeanStub));
exports.RowRenderer = RowRenderer;


/***/ }),

/***/ "3f5E":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1569);
	module.exports = __webpack_require__(1569);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1569:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {
	    var NS = ".kendoPDFViewer",
	        Widget = kendo.ui.Widget,
	        CHANGE = "change",
	        KEYDOWN = "keydown",
	        CLICK = kendo.support.click,
	        SHRINKWIDTH = 480,
	        kendoAttr = kendo.attr,
	        proxy = $.proxy,
	        extend = $.extend,
	        DOT = ".",
	        ARIA_DISABLED = "aria-disabled";

	    var pagerStyles = {
	        wrapperClass: "k-pager-wrap",
	        iconFirst: "k-i-arrow-end-left",
	        iconLast: "k-i-arrow-end-right",
	        iconPrev: "k-i-arrow-60-left",
	        iconNext: "k-i-arrow-60-right",
	        first: "k-pager-first",
	        last: "k-pager-last",
	        nav: "k-pager-nav",
	        disabled: "k-state-disabled"
	    };

	    var Pager = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            that.linkTemplate = kendo.template(that.options.linkTemplate);

	            that.element.addClass(pagerStyles.wrapperClass);

	            that._renderLinks();
	            that._toggleDisabledClass();
	            that._attachEvents();
	        },

	        options: {
	            linkTemplate: '<a href="\\#" aria-label="#=text#" title="#=text#" class="k-button k-button-icon k-flat k-pager-nav #= wrapClass #" data-page="#=pageIdx#"><span class="k-icon #= iconClass #"></span></a>',
	            previousNext: true,
	            input: true,
	            page: 1,
	            total: 1,
	            messages: {}
	        },

	        events: [
	            CHANGE
	        ],

	        _pagerLink: function (iconClass, text, pageIdx, wrapClass) {
	            return this.linkTemplate({
	                iconClass: iconClass,
	                text: text,
	                wrapClass: wrapClass || "",
	                pageIdx: pageIdx
	            });
	        },

	        _renderLinks: function ()
	        {
	            var that = this,
	                options = that.options;

	            if (options.previousNext) {
	                that.firstLink = $(that._pagerLink(pagerStyles.iconFirst, options.messages.first, 1, pagerStyles.first));
	                that.prevLink = $(that._pagerLink(pagerStyles.iconPrev, options.messages.previous, options.page - 1));
	                that.nextLink = $(that._pagerLink(pagerStyles.iconNext, options.messages.next, options.page + 1));
	                that.lastLink = $(that._pagerLink(pagerStyles.iconLast, options.messages.last, options.total, pagerStyles.last));
	            }

	            that.element.append(that.firstLink);
	            that.element.append(that.prevLink);

	            if (options.input) {
	                that._renderInput();
	            }

	            that.element.append(that.nextLink);
	            that.element.append(that.lastLink);

	        },

	        _toggleDisabledClass: function () {
	            var that = this,
	                options = that.options,
	                total = !options.total;

	            if (that.nextLink && that.prevLink) {
	                that.prevLink.toggleClass(pagerStyles.disabled, total || options.page === 1);
	                that.nextLink.toggleClass(pagerStyles.disabled, total || options.page === options.total);
	                that.lastLink.toggleClass(pagerStyles.disabled, total || options.page === options.total);
	                that.firstLink.toggleClass(pagerStyles.disabled,total || options.page === 1);

	                that.prevLink.attr(ARIA_DISABLED, total || options.page === 1);
	                that.firstLink.attr(ARIA_DISABLED, total || options.page === 1);

	                that.nextLink.attr(ARIA_DISABLED, options.page === options.total);
	                that.lastLink.attr(ARIA_DISABLED, options.page === options.total);
	            }

	            if (that.input) {
	                that.input.toggleClass(pagerStyles.disabled, options.total <= 1);
	                that.input.attr(ARIA_DISABLED, options.total <= 1);
	            }
	        },

	        _attachEvents: function () {
	            var that = this;

	            that.element.on(CLICK + NS, DOT + pagerStyles.nav, proxy(that._click, that));
	            that.element.on(KEYDOWN + NS, DOT + pagerStyles.nav, function (e) {
	                if (e.keyCode === kendo.keys.ENTER)
	                {
	                    that._click(e);
	                    e.preventDefault();
	                }
	            });

	            if (that.input) {
	                that.input.on(KEYDOWN + NS, proxy(that._keydown, that));
	            }
	        },

	        _click: function (e) {
	            var target = $(e.currentTarget);
	            var page = parseInt(target.attr(kendoAttr("page")), 10);

	            if (e.isDefaultPrevented()) {
	                return;
	            }

	            this._change(page);
	        },

	        _keydown: function (e) {
	            var key = e.keyCode,
	                keys = kendo.keys,
	                input = $(e.target),
	                page = parseInt(input.val(), 10),
	                upDown = key === keys.UP || key === keys.DOWN,
	                allowedKeys = key === keys.RIGHT || key === keys.LEFT ||
	                                key === keys.BACKSPACE || key === keys.DELETE,
	                direction = upDown && key === keys.UP ? 1 : -1;

	            if (upDown) {
	                page += direction;
	            }

	            if (key === keys.ENTER || upDown) {
	                if (isNaN(page) || page < 1 || page > this.options.total) {
	                    page = this.options.page;
	                    input.val(page);
	                    return;
	                }
	                this._change(page);
	                e.preventDefault();
	            } else if (!e.key.match(/^\d+$/) && !allowedKeys) {
	                e.preventDefault();
	            }

	        },

	        _change: function (page) {
	            var that = this;

	            if (page >= 1 && page <= that.options.total) {
	                that.options.page = page;
	                if (that.input) {
	                    that.input.val(page);
	                }
	                that.prevLink.attr(kendoAttr("page"), page - 1);
	                that.nextLink.attr(kendoAttr("page"), page + 1);
	                that._toggleDisabledClass();
	            }

	            that.trigger(CHANGE, { page: page});
	        },

	        setOptions: function (options) {
	            var that = this,
	                prevTotal = that.options.total;

	            options = $.extend(that.options, options);

	            Widget.fn.setOptions.call(that, options);

	            if (options.input) {
	                if (prevTotal != options.total) {
	                    that._renderInput();
	                    that.input
	                            .on(KEYDOWN + NS, proxy(that._keydown, that));
	                }
	                else {
	                    that.input.val(options.total > 0 ? options.page : 1);
	                }
	            }

	            if (options.total > 1) {
	                that.prevLink.attr(kendoAttr("page"), options.page - 1);
	                that.nextLink.attr(kendoAttr("page"), options.page + 1);
	                that.lastLink.attr(kendoAttr("page"), options.total);
	            }

	            that._toggleDisabledClass();
	        },

	        _renderInput: function () {
	            var that = this,
	                totalMessage,
	                options = that.options,
	                shouldShrink = that.element.parent().width() <= SHRINKWIDTH,
	                inputTemplate,
	                pagerInputWrap = that.element.find(".k-pager-input");

	            if (that.input) {
	                that.input.off(NS);
	            }

	            totalMessage = options.total > 0 ? kendo.format(options.messages.of, options.total) : "";

	            if (!shouldShrink) {
	                totalMessage += options.total > 1 ? options.messages.pages : options.messages.page;
	            }

	            inputTemplate = '<input class="k-textbox" aria-label="' + options.page + totalMessage  +  '">' + totalMessage;

	            if (pagerInputWrap.length) {
	                pagerInputWrap.html(inputTemplate);
	            } else {
	                that.element.append('<span class="k-pager-input k-label">' + inputTemplate +'</span>');
	            }

	            that.input = that.element
	                                .find("input")
	                                .val(options.total > 0 ? options.page : 1);
	        },

	        destroy: function() {
	            this.element.off(NS);

	            if (this.input) {
	                this.input.off(NS);
	            }
	            Widget.fn.destroy.call(this);
	        }
	    });


	    extend(kendo.pdfviewer, {
	        Pager: Pager
	    });
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "3fs2":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("RY/4");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var Iterators = __webpack_require__("/bQp");
module.exports = __webpack_require__("FeBl").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "3gOi":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1246);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1054:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CRfZ");

/***/ }),

/***/ 1108:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ydSV");

/***/ }),

/***/ 1170:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("zQRd");

/***/ }),

/***/ 1187:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("99zt");

/***/ }),

/***/ 1246:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1170), __webpack_require__(1187), __webpack_require__(1054), __webpack_require__(1108) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "filtermenu",
	    name: "Filtering Menu",
	    category: "framework",
	    depends: [ "datepicker", "numerictextbox", "dropdownlist", "binder" ],
	    advanced: true
	};

	/* jshint eqnull: true */
	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        proxy = $.proxy,
	        support = kendo.support,
	        AUTOCOMPLETEVALUE = support.browser.chrome ? "disabled" : "off",
	        POPUP = "kendoPopup",
	        INIT = "init",
	        OPEN = "open",
	        REFRESH = "refresh",
	        CHANGE = "change",
	        NS = ".kendoFilterMenu",
	        EQ = "Is equal to",
	        NEQ = "Is not equal to",
	        roles = {
	            "number": "numerictextbox",
	            "date": "datepicker"
	        },
	        mobileRoles = {
	            "string": "text",
	            "number": "number",
	            "date": "date"
	        },
	        isFunction = kendo.isFunction,
	        Widget = ui.Widget;

	    var booleanTemplate =
	        '<div class="k-filter-menu-container">' +
	            '<div class="k-filter-help-text">#=messages.info#</div>'+
	            '<label>'+
	                '<input type="radio" data-#=ns#bind="checked: filters[0].value" value="true" name="filters[0].value"/>' +
	                '#=messages.isTrue#' +
	            '</label>' +
	            '<label>'+
	                '<input type="radio" data-#=ns#bind="checked: filters[0].value" value="false" name="filters[0].value"/>' +
	                '#=messages.isFalse#' +
	            '</label>' +
	            '<div class="k-action-buttons">' +
	                '<button type="submit" title="#=messages.filter#" class="k-button k-primary">#=messages.filter#</button>' +
	                '<button type="reset" title="#=messages.clear#" class="k-button">#=messages.clear#</button>'+
	            '</div>' +
	        '</div>';

	    var customBooleanTemplate =
	        '<div class="k-filter-menu-container">' +
	            '<div class="k-filter-help-text">#=messages.info#</div>'+
	            '<label>'+
	                '<input class="k-textbox" data-#=ns#bind="value: filters[0].value" name="filters[0].value"/>' +
	            '</label>' +
	            '<div class="k-action-buttons">' +
	                '<button type="submit" title="#=messages.filter#" class="k-button k-primary">#=messages.filter#</button>' +
	                '<button type="reset" title="#=messages.clear#" class="k-button">#=messages.clear#</button>'+
	            '</div>' +
	        '</div>';

	    var defaultTemplate =
	        '<div class="k-filter-menu-container">' +
	            '<div class="k-filter-help-text">#=messages.info#</div>'+
	            '<select title="#=messages.operator#" data-#=ns#bind="value: filters[0].operator" data-#=ns#role="dropdownlist">'+
	                '#for(var op in operators){#'+
	                    '<option value="#=op#">#=operators[op]#</option>' +
	                '#}#'+
	            '</select>'+
	            '#if(values){#' +
	                '<select title="#=messages.value#" data-#=ns#bind="value:filters[0].value" data-#=ns#text-field="text" data-#=ns#value-field="value" data-#=ns#source=\'#=kendo.stringify(values).replace(/\'/g,"&\\#39;")#\' data-#=ns#role="dropdownlist" data-#=ns#option-label="#=messages.selectValue#" data-#=ns#value-primitive="true">' +
	                '</select>' +
	            '#}else{#' +
	                '<input title="#=messages.value#" data-#=ns#bind="value:filters[0].value" class="k-textbox" type="text" #=role ? "data-" + ns + "role=\'" + role + "\'" : ""# />'+
	            '#}#' +
	            '#if(extra){#'+
	                '<select title="#=messages.logic#" class="k-filter-and" data-#=ns#bind="value: logic" data-#=ns#role="dropdownlist">'+
	                    '<option value="and">#=messages.and#</option>'+
	                    '<option value="or">#=messages.or#</option>'+
	                '</select>'+
	                '<select title="#=messages.additionalOperator#" data-#=ns#bind="value: filters[1].operator" data-#=ns#role="dropdownlist">'+
	                    '#for(var op in operators){#'+
	                        '<option value="#=op#">#=operators[op]#</option>'+
	                    '#}#'+
	                '</select>'+
	                '#if(values){#' +
	                    '<select title="#=messages.additionalValue#" data-#=ns#bind="value:filters[1].value" data-#=ns#text-field="text" data-#=ns#value-field="value" data-#=ns#source=\'#=kendo.stringify(values).replace(/\'/g,"&\\#39;")#\' data-#=ns#role="dropdownlist" data-#=ns#option-label="#=messages.selectValue#" data-#=ns#value-primitive="true">' +
	                    '</select>'+
	                '#}else{#' +
	                    '<input title="#=messages.additionalValue#" data-#=ns#bind="value: filters[1].value" class="k-textbox" type="text" #=role ? "data-" + ns + "role=\'" + role + "\'" : ""#/>'+
	                '#}#' +
	            '#}#'+
	            '<div class="k-action-buttons">'+
	                '<button type="submit" title="#=messages.filter#" class="k-button k-primary">#=messages.filter#</button>'+
	                '<button type="reset" title="#=messages.clear#" class="k-button">#=messages.clear#</button>'+
	            '</div>'+
	        '</div>';

	    var defaultMobileTemplate =
	        '<div data-#=ns#role="view" class="k-grid-filter-menu">' +
	            '<div data-#=ns#role="header" class="k-header">' +
	                '<a href="\\#" class="k-header-cancel k-link" title="#=messages.cancel#" ' +
	                'aria-label="#=messages.cancel#"><span class="k-icon k-i-arrow-chevron-left"></span></a>' +
	                '#=messages.filter# #=messages.into# #=title#' +
	                '<a href="\\#" class="k-header-done k-link" title="#=messages.done#" ' +
	                'aria-label="#=messages.done#"><span class="k-icon k-i-check"></span></a>' +
	            '</div>' +
	            '<form title="#=messages.title#" class="k-filter-menu">' +
	                '<ul class="k-reset">' +
	                    '<li>' +
	                        '<span class="k-list-title k-filter-help-text">#=messages.info#</span>' +
	                        '<ul class="k-listgroup k-listgroup-flush">' +
	                            '<li class="k-item k-listgroup-item">' +
	                                '<label class="k-listgroup-form-row k-label">' +
	                                    '<span class="k-listgroup-form-field-label k-filter-operator-text">#=messages.operator#</span>' +
	                                    '<span class="k-listgroup-form-field-wrapper">' +
	                                        '<select id="operator_#=filterMenuGuid#" title="#=messages.operator#" class="k-filter-operator" data-#=ns#bind="value: filters[0].operator" autocomplete="'+AUTOCOMPLETEVALUE+'" >' +
	                                            '#for(var op in operators){#' +
	                                                '<option value="#=op#">#=operators[op]#</option>' +
	                                            '#}#' +
	                                        '</select>' +
	                                    '</span>' +
	                                '</label>' +
	                            '</li>' +
	                            '<li class="k-item k-listgroup-item">' +
	                                '<label class="k-listgroup-form-row k-label">' +
	                                    '<span class="k-listgroup-form-field-label k-filter-input-text">#=messages.value#</span>' +
	                                    '<span class="k-listgroup-form-field-wrapper">' +
	                                        '#if(values){#' +
	                                            '<select id="value_#=filterMenuGuid#" title="#=messages.value#" data-#=ns#bind="value:filters[0].value" autocomplete="'+AUTOCOMPLETEVALUE+'" >' +
	                                                '<option value="">#=messages.selectValue#</option>' +
	                                                '#for(var val in values){#' +
	                                                    '<option value="#=values[val].value#">#=values[val].text#</option>' +
	                                                '#}#' +
	                                            '</select>' +
	                                        '#}else{#' +
	                                            '<input id="value_#=filterMenuGuid#" title="#=messages.value#" data-#=ns#bind="value:filters[0].value" class="k-value-input" type="#=inputType#" autocomplete="'+AUTOCOMPLETEVALUE+'" />' +
	                                        '#}#' +
	                                    '</span>' +
	                                '</label>' +
	                            '</li>' +
	                        '</ul>' +
	                        '#if(extra){#' +
	                        '<ul class="k-listgroup k-listgroup-flush">' +
	                            '<li class="k-item k-listgroup-item">' +
	                                '<label class="k-listgroup-form-row k-label">' +
	                                    '<span class="k-listgroup-form-field-label k-filter-logic-and-text">#=messages.and#</span>' +
	                                    '<span class="k-listgroup-form-field-wrapper">' +
	                                        '<input id="and_#=filterMenuGuid#" title="#=messages.and#" type="radio" name="logic"data-#=ns#bind="checked: logic" value="and" autocomplete="'+AUTOCOMPLETEVALUE+'" />' +
	                                    '</span>' +
	                                '</label>' +
	                            '</li>' +
	                            '<li class="k-item k-listgroup-item">' +
	                                '<label class="k-listgroup-form-row k-label">' +
	                                    '<span class="k-listgroup-form-field-label k-filter-logic-or-text">#=messages.or#</span>' +
	                                    '<span class="k-listgroup-form-field-wrapper">' +
	                                        '<input id="or_#=filterMenuGuid#" title="#=messages.or#" type="radio" name="logic" data-#=ns#bind="checked: logic" value="or" autocomplete="'+AUTOCOMPLETEVALUE+'" />' +
	                                    '</span>' +
	                                '</label>' +
	                            '</li>' +
	                        '</ul>' +
	                        '<ul class="k-listgroup k-listgroup-flush">' +
	                            '<li class="k-item k-listgroup-item">' +
	                                '<label class="k-listgroup-form-row k-label">' +
	                                    '<span class="k-listgroup-form-field-label k-filter-operator-text">#=messages.additionalOperator#</span>' +
	                                    '<span class="k-listgroup-form-field-wrapper">' +
	                                        '<select id="additionalOperator_#=filterMenuGuid#" title="#=messages.additionalOperator#" class="k-filter-operator" data-#=ns#bind="value: filters[1].operator" autocomplete="'+AUTOCOMPLETEVALUE+'" >' +
	                                            '#for(var op in operators){#' +
	                                                '<option value="#=op#">#=operators[op]#</option>' +
	                                            '#}#' +
	                                        '</select>' +
	                                    '</span>' +
	                                '</label>' +
	                            '</li>' +
	                            '<li class="k-item k-listgroup-item">' +
	                                '<label class="k-listgroup-form-row k-label">' +
	                                    '<span class="k-listgroup-form-field-label k-filter-input-text">#=messages.additionalValue#</span>' +
	                                    '<span class="k-listgroup-form-field-wrapper">' +
	                                        '#if(values){#' +
	                                            '<select id="additionalValue_#=filterMenuGuid#" title="#=messages.additionalValue#" data-#=ns#bind="value:filters[1].value" autocomplete="'+AUTOCOMPLETEVALUE+'" >' +
	                                                '<option value="">#=messages.selectValue#</option>' +
	                                                '#for(var val in values){#' +
	                                                    '<option value="#=values[val].value#">#=values[val].text#</option>' +
	                                                '#}#' +
	                                            '</select>' +
	                                        '#}else{#' +
	                                            '<input id="additionalValue_#=filterMenuGuid#" title="#=messages.additionalValue#" data-#=ns#bind="value:filters[1].value" class="k-value-input" type="#=inputType#" autocomplete="'+AUTOCOMPLETEVALUE+'" />' +
	                                        '#}#' +
	                                    '</span>' +
	                                '</label>' +
	                            '</li>' +
	                        '</ul>' +
	                        '#}#' +
	                    '</li>' +
	                    '<li class="k-item k-clear-wrap">' +
	                        '<span class="k-list-title">&nbsp;</span>' +
	                        '<ul class="k-listgroup k-listgroup-flush">' +
	                            '<li class="k-listgroup-item">' +
	                                '<span class="k-link k-label k-clear" title="#=messages.clear#" aria-label="#=messages.clear#">' +
	                                    '#=messages.clear#' +
	                                '</span>' +
	                            '</li>' +
	                        '</ul>' +
	                    '</li>' +
	                '</ul>' +
	            '</form>' +
	        '</div>';

	    var booleanMobileTemplate =
	        '<div data-#=ns#role="view" class="k-grid-filter-menu">' +
	            '<div data-#=ns#role="header" class="k-header">' +
	                '<a href="\\#" class="k-header-cancel k-link" title="#=messages.cancel#" ' +
	                'aria-label="#=messages.cancel#"><span class="k-icon k-i-arrow-chevron-left"></span></a>' +
	                '#=messages.filter# #=messages.into# #=title#' +
	                '<a href="\\#" class="k-header-done k-link" title="#=messages.done#" ' +
	                'aria-label="#=messages.done#"><span class="k-icon k-i-check"></span></a>' +
	            '</div>' +
	            '<form title="#=messages.title#" class="k-filter-menu">' +
	                '<ul class="k-reset">' +
	                    '<li>' +
	                        '<span class="k-list-title k-filter-help-text">#=messages.info#</span>' +
	                        '<ul class="k-listgroup k-listgroup-flush k-multicheck-bool-wrap">' +
	                            '<li class="k-item k-listgroup-item">' +
	                                '<label class="k-listgroup-form-row k-label">' +
	                                    '<span class="k-listgroup-form-field-label k-item-title">#=messages.isTrue#</span>' +
	                                    '<span class="k-listgroup-form-field-wrapper"></span>' +
	                                        '<input id="true_#=filterMenuGuid#" title="#=messages.isTrue#" type="radio" data-#=ns#bind="checked: filters[0].value" value="true" name="filters[0].value" autocomplete="'+AUTOCOMPLETEVALUE+'" />' +
	                                    '</span>' +
	                                '</label>' +
	                            '</li>' +
	                            '<li class="k-item k-listgroup-item">' +
	                                '<label class="k-listgroup-form-row k-label">' +
	                                    '<span for="false_#=filterMenuGuid#" class="k-listgroup-form-field-label k-item-title">#=messages.isFalse#</span>' +
	                                    '<span class="k-listgroup-form-field-wrapper">' +
	                                        '<input id="false_#=filterMenuGuid#" title="#=messages.isFalse#" type="radio" data-#=ns#bind="checked: filters[0].value" value="false" name="filters[0].value" autocomplete="'+AUTOCOMPLETEVALUE+'" />' +
	                                    '</span>' +
	                                '</label>'+
	                            '</li>' +
	                        '</ul>'+
	                    '</li>'+
	                    '<li class="k-item k-clear-wrap">' +
	                        '<span class="k-list-title">&nbsp;</span>' +
	                        '<ul class="k-listgroup k-listgroup-flush">' +
	                            '<li class="k-listgroup-item">' +
	                                '<span class="k-link k-label k-clear" title="#=messages.clear#" aria-label="#=messages.clear#">' +
	                                    '#=messages.clear#' +
	                                '</span>' +
	                            '</li>' +
	                        '</ul>' +
	                    '</li>' +
	                '</ul>' +
	            '</form>' +
	        '</div>';

	    function removeFiltersForField(expression, field) {
	        if (expression.filters) {
	            expression.filters = $.grep(expression.filters, function(filter) {
	                removeFiltersForField(filter, field);
	                if (filter.filters) {
	                    return filter.filters.length;
	                } else {
	                    return filter.field != field;
	                }
	            });
	        }
	    }

	    function convertItems(items) {
	        var idx,
	            length,
	            item,
	            value,
	            text,
	            result;

	        if (items && items.length) {
	            result = [];
	            for (idx = 0, length = items.length; idx < length; idx++) {
	                item = items[idx];
	                text = item.text !== "" ? item.text || item.value || item : item.text;
	                value = item.value == null ? (item.text || item) : item.value;

	                result[idx] = { text: text, value: value };
	            }
	        }
	        return result;
	    }


	    function clearFilter(filters, field) {
	        return $.grep(filters, function(expr) {
	            if (expr.filters) {
	                expr.filters = $.grep(expr.filters, function(nested) {
	                    return nested.field != field;
	                });

	                return expr.filters.length;
	            }
	            return expr.field != field;
	        });
	    }

	    var FilterMenu = Widget.extend({
	        init: function(element, options) {
	            var that = this,
	                type = "string",
	                operators,
	                initial,
	                link,
	                field;

	            Widget.fn.init.call(that, element, options);

	            operators = that.operators = options.operators || {};

	            element = that.element;
	            options = that.options;

	            if (!options.appendToElement) {
	                link = element.addClass("k-with-icon k-filterable").find(".k-grid-filter");

	                if (!link[0]) {
	                    link = element.prepend('<a class="k-grid-filter" href="#" title="' +
	                        options.messages.filter + '" aria-label="' +
	                        options.messages.filter + '"><span class="k-icon k-i-filter"></span></a>').find(".k-grid-filter");
	                }

	                link.attr("tabindex", -1).on("click" + NS, proxy(that._click, that));
	            }

	            that.link = link || $();

	            that.dataSource = DataSource.create(options.dataSource);

	            that.field = options.field || element.attr(kendo.attr("field"));

	            that.model = that.dataSource.reader.model;

	            that._parse = function(value) {
	                 return value != null ? (value + "") : value;
	            };

	            if (that.model && that.model.fields) {
	                field = that.model.fields[that.field];

	                if (field) {
	                    type = field.type || "string";
	                    if (field.parse) {
	                        that._parse = proxy(field.parse, field);
	                    }
	                }
	            }

	            if (options.values) {
	                type = "enums";
	            }

	            that.type = type;

	            operators = operators[type] || options.operators[type];

	            for (initial in operators) { // get the first operator
	                break;
	            }

	            that._defaultFilter = function() {
	                return { field: that.field, operator: initial || "eq", value: "" };
	            };

	            that._refreshHandler = proxy(that.refresh, that);

	            that.dataSource.bind(CHANGE, that._refreshHandler);

	            if (options.appendToElement) { // force creation if used in column menu
	                that._init();
	            } else {
	                that.refresh(); //refresh if DataSource is fitered before menu is created
	            }
	        },

	        _init: function() {
	            var that = this,
	                ui = that.options.ui,
	                setUI = isFunction(ui),
	                role;

	            that.pane = that.options.pane;
	            if (that.pane) {
	                that._isMobile = true;
	            }

	            if (!setUI) {
	                role = ui || roles[that.type];
	            }

	            if (that._isMobile) {
	                that._createMobileForm(role);
	            } else {
	                that._createForm(role);
	            }

	            that.form
	                .on("submit" + NS, proxy(that._submit, that))
	                .on("reset" + NS, proxy(that._reset, that));

	            if (setUI) {
	                that.form.find(".k-textbox")
	                    .removeClass("k-textbox")
	                    .each(function() {
	                        ui($(this));
	                    });
	            }

	            that.form
	                 .find("[" + kendo.attr("role") + "=numerictextbox]")
	                 .removeClass("k-textbox")
	                 .end()
	                 .find("[" + kendo.attr("role") + "=datetimepicker]")
	                 .removeClass("k-textbox")
	                 .end()
	                 .find("[" + kendo.attr("role") + "=timepicker]")
	                 .removeClass("k-textbox")
	                 .end()
	                 .find("[" + kendo.attr("role") + "=datepicker]")
	                 .removeClass("k-textbox");

	            that.refresh();

	            that.trigger(INIT, { field: that.field, container: that.form });

	            kendo.cycleForm(that.form);
	        },

	        _createForm: function(role) {
	            var that = this,
	                options = that.options,
	                operators = that.operators || {},
	                type = that.type,
	                hasCustomTemplate = isFunction(that.options.ui);

	            operators = operators[type] || options.operators[type];

	            that.form = $('<form title="' + that.options.messages.title + '" class="k-filter-menu"/>')
	                .html(kendo.template(type === "boolean" ? (hasCustomTemplate ? customBooleanTemplate : booleanTemplate) : defaultTemplate)({
	                    field: that.field,
	                    format: options.format,
	                    ns: kendo.ns,
	                    messages: options.messages,
	                    extra: options.extra,
	                    operators: operators,
	                    type: type,
	                    role: role,
	                    values: convertItems(options.values)
	                }));

	            if (!options.appendToElement) {
	                that.popup = that.form[POPUP]({
	                    anchor: that.link,
	                    copyAnchorStyles: false,
	                    open: proxy(that._open, that),
	                    activate: proxy(that._activate, that),
	                    close: function() {
	                        if (that.options.closeCallback) {
	                            that.options.closeCallback(that.element);
	                        }
	                    }
	                }).data(POPUP);
	            } else {
	                that.element.append(that.form);
	                that.popup = that.element.closest(".k-popup").data(POPUP);
	            }

	            that.form
	                .on("keydown" + NS, proxy(that._keydown, that));
	        },

	        _createMobileForm: function(role) {
	            var that = this,
	                options = that.options,
	                operators = that.operators || {},
	                filterMenuGuid = kendo.guid(),
	                type = that.type;

	            operators = operators[type] || options.operators[type];

	            that.form = $("<div />")
	                .html(kendo.template(type === "boolean" ? booleanMobileTemplate : defaultMobileTemplate)({
	                    field: that.field,
	                    title: options.title || that.field,
	                    format: options.format,
	                    ns: kendo.ns,
	                    messages: options.messages,
	                    extra: options.extra,
	                    operators: operators,
	                    filterMenuGuid: filterMenuGuid,
	                    type: type,
	                    role: role,
	                    inputType: mobileRoles[type],
	                    values: convertItems(options.values)
	                }));

	            that.view = that.pane.append(that.form.html());
	            that.form = that.view.element.find("form");

	            that.view.element
	                .on("click", ".k-header-done", function(e) {
	                    that.form.submit();
	                    e.preventDefault();
	                })
	                .on("click", ".k-header-cancel", function(e) {
	                    that._closeForm();
	                    e.preventDefault();
	                })
	                .on("click", ".k-clear", function(e) {
	                    that._mobileClear();
	                    e.preventDefault();
	                });

	            that.view.bind("showStart", function() {
	                that.refresh();
	            });
	        },

	        refresh: function() {
	            var that = this,
	                expression = that.dataSource.filter() || { filters: [], logic: "and" };

	            var defaultFilters = [ that._defaultFilter() ];
	            var defaultOperator = that._defaultFilter().operator;
	            if (that.options.extra || (defaultOperator !== "isnull" && defaultOperator !== "isnullorempty" && defaultOperator !== "isnotnullorempty" && defaultOperator !== "isnotnull" && defaultOperator !== "isempty" && defaultOperator !== "isnotempty")) {
	                defaultFilters.push(that._defaultFilter());
	            }

	            that.filterModel = kendo.observable({
	                logic: "and",
	                filters: defaultFilters
	            });

	            if (that.form) {
	                //NOTE: binding the form element directly causes weird error in IE when grid is bound through MVVM and column is sorted
	                kendo.bind(that.form.children().first(), that.filterModel);
	            }

	            if (that._bind(expression)) {
	                that.link.addClass("k-state-active");
	            } else {
	                that.link.removeClass("k-state-active");
	            }
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            if (that.form) {
	                kendo.unbind(that.form);
	                kendo.destroy(that.form);
	                that.form.unbind(NS);
	                if (that.popup) {
	                    that.popup.destroy();
	                    that.popup = null;
	                }
	                that.form = null;
	            }

	            if (that.view) {
	                that.view.purge();
	                that.view = null;
	            }

	            that.link.unbind(NS);

	            if (that._refreshHandler) {
	                that.dataSource.unbind(CHANGE, that._refreshHandler);
	                that.dataSource = null;
	            }

	            that.element = that.link = that._refreshHandler = that.filterModel = null;
	        },

	        _bind: function(expression) {
	            var that = this,
	                filters = expression.filters,
	                idx,
	                length,
	                found = false,
	                current = 0,
	                filterModel = that.filterModel,
	                currentFilter,
	                filter;

	            for (idx = 0, length = filters.length; idx < length; idx++) {
	                filter = filters[idx];
	                if (filter.field == that.field) {
	                    filterModel.set("logic", expression.logic);

	                    currentFilter = filterModel.filters[current];
	                    if (!currentFilter) {
	                        filterModel.filters.push({ field: that.field });
	                        currentFilter = filterModel.filters[current];
	                    }
	                    currentFilter.set("value", that._parse(filter.value));
	                    currentFilter.set("operator", filter.operator);

	                    current++;
	                    found = true;
	                } else if (filter.filters) {
	                    found = found || that._bind(filter);
	                }
	            }

	            return found;
	        },

	        _stripFilters: function(filters) {
	           return $.grep(filters, function(filter) {
	               return (filter.value !== "" && filter.value != null) ||
	               (filter.operator === "isnull" || filter.operator === "isnotnull" ||
	                   filter.operator === "isempty" || filter.operator === "isnotempty" ||
	                   filter.operator == "isnullorempty" || filter.operator == "isnotnullorempty");
	            });
	        },

	        _merge: function(expression) {
	            var that = this,
	                logic = expression.logic || "and",
	                filters = this._stripFilters(expression.filters),
	                filter,
	                result = that.dataSource.filter() || { filters:[], logic: "and" },
	                idx,
	                length;

	            removeFiltersForField(result, that.field);

	            for (idx = 0, length = filters.length; idx < length; idx++) {
	                filter = filters[idx];
	                filter.value = that._parse(filter.value);
	            }

	            if (filters.length) {
	                if (result.filters.length) {
	                    expression.filters = filters;

	                    if (result.logic !== "and") {
	                        result.filters = [ { logic: result.logic, filters: result.filters }];
	                        result.logic = "and";
	                    }

	                    if (filters.length > 1) {
	                        result.filters.push(expression);
	                    } else {
	                        result.filters.push(filters[0]);
	                    }
	                } else {
	                    result.filters = filters;
	                    result.logic = logic;
	                }
	            }

	            return result;
	        },

	        filter: function(expression) {
	            var filters = this._stripFilters(expression.filters);
	            if (filters.length && this.trigger("change", {
	                    filter: { logic: expression.logic, filters: filters },
	                    field: this.field
	                })) {

	                return;
	            }

	            expression = this._merge(expression);

	            if (expression.filters.length) {
	                this.dataSource.filter(expression);
	            }
	        },

	        clear: function(expression) {
	            var that = this;
	            expression = expression || that.dataSource.filter() || { filters:[] };

	            if (this.trigger("change", { filter: null, field: that.field })) {
	                return;
	            }

	            that._removeFilter(expression);
	        },

	        _mobileClear: function() {
	            var that = this;
	            var viewElement = that.view.element;

	            if (that.type ==="boolean") {
	                var booleanRadioButton = viewElement.find("[type='radio']:checked");
	                var booleanRadioButtonValue = booleanRadioButton.val();

	                booleanRadioButton.val("");
	                booleanRadioButton.trigger("change");
	                booleanRadioButton.val(booleanRadioButtonValue);
	                booleanRadioButton.prop("checked", false);
	            } else {
	                var operatorSelects = viewElement.find("select");

	                operatorSelects.each(function(i, e) {
	                    var input = $(e);

	                    input.val(input.find("option:first").val());
	                    input.trigger("change");
	                });

	                if (that.type ==="string" || that.type ==="date" || that.type ==="number") {
	                    var valueInputs = viewElement.find(".k-value-input");

	                    valueInputs.each(function(i, e) {
	                        var input = $(e);

	                        input.val("");
	                        input.trigger("change");
	                    });
	                }

	                if (that.options.extra) {
	                    var andLogicRadio = viewElement.find("[name=logic]").first();

	                    andLogicRadio.prop("checked", true);
	                    andLogicRadio.trigger("change");
	                }
	            }
	        },

	        _removeFilter: function(expression) {
	            var that = this;
	            expression.filters = $.grep(expression.filters, function(filter) {
	                if (filter.filters) {
	                    filter.filters = clearFilter(filter.filters, that.field);

	                    return filter.filters.length;
	                }

	                return filter.field != that.field;
	            });

	            if (!expression.filters.length) {
	                expression = null;
	            }

	            that.dataSource.filter(expression);
	        },

	        _submit: function(e) {
	            e.preventDefault();
	            e.stopPropagation();
	            var expression = this.filterModel.toJSON();
	            var containsFilters = $.grep(expression.filters, function(filter) {
	                return filter.value !== "" && filter.value !== null;
	            });

	            if (this._checkForNullOrEmptyFilter(expression) || (containsFilters && containsFilters.length)) {
	                this.filter(expression);
	            } else {
	                var currentExpression = this.dataSource.filter();

	                if (currentExpression) {
	                    currentExpression.filters.push(expression);
	                    expression = currentExpression;
	                }
	                this.clear(expression);
	            }

	            this._closeForm();
	        },

	        _checkForNullOrEmptyFilter: function(expression) {
	            if(!expression || !expression.filters || !expression.filters.length) {
	                return false;
	            }
	            var firstNullOrEmpty = false;
	            var secondNullOrEmpty = false;
	            var operator;

	            if (expression.filters[0]) {
	                operator = expression.filters[0].operator;
	                firstNullOrEmpty = operator == "isnull" || operator == "isnotnull" || operator == "isnotempty" ||
	                    operator == "isempty" || operator == "isnullorempty" || operator == "isnotnullorempty";
	            }
	            if (expression.filters[1]) {
	                operator = expression.filters[1].operator;
	                secondNullOrEmpty = operator == "isnull" || operator == "isnotnull" || operator == "isnotempty" ||
	                    operator == "isempty" || operator == "isnullorempty" || operator == "isnotnullorempty";
	            }

	            return (!this.options.extra && firstNullOrEmpty) || (this.options.extra && (firstNullOrEmpty || secondNullOrEmpty));
	        },

	        _reset: function() {
	            this.clear();

	            if (this.options.search && this.container) {
	                this.container.find("label").parent().show();
	            }
	            this._closeForm();
	        },

	        _closeForm: function() {
	            if (this._isMobile) {
	                this.pane.navigate("", this.options.animations.right);
	            } else {
	                this.popup.close();
	            }
	        },

	        _click: function(e) {
	            e.preventDefault();
	            e.stopPropagation();

	            if (!this.popup && !this.pane) {
	                this._init();
	            }

	            if (this._isMobile) {
	                this.pane.navigate(this.view, this.options.animations.left);
	            } else {
	                this.popup.toggle();
	            }
	        },

	        _open: function() {
	            var popup;

	            $(".k-filter-menu").not(this.form).each(function() {
	                popup = $(this).data(POPUP);
	                if (popup) {
	                    popup.close();
	                }
	            });
	        },

	        _activate: function() {
	            this.form.find(":kendoFocusable:first").focus();

	            this.trigger(OPEN, { field: this.field, container: this.form });
	        },

	        _keydown: function(e) {
	            if (e.keyCode == kendo.keys.ESC) {
	                this.popup.close();
	            }
	        },

	        events: [ INIT, "change", OPEN ],

	        options: {
	            name: "FilterMenu",
	            extra: true,
	            appendToElement: false,
	            type: "string",
	            operators: {
	                string: {
	                    eq: EQ,
	                    neq: NEQ,
	                    startswith: "Starts with",
	                    contains: "Contains",
	                    doesnotcontain: "Does not contain",
	                    endswith: "Ends with",
	                    isnull: "Is null",
	                    isnotnull: "Is not null",
	                    isempty: "Is empty",
	                    isnotempty: "Is not empty",
	                    isnullorempty: "Has no value",
	                    isnotnullorempty: "Has value"
	                },
	                number: {
	                    eq: EQ,
	                    neq: NEQ,
	                    gte: "Is greater than or equal to",
	                    gt: "Is greater than",
	                    lte: "Is less than or equal to",
	                    lt: "Is less than",
	                    isnull: "Is null",
	                    isnotnull: "Is not null"
	                },
	                date: {
	                    eq: EQ,
	                    neq: NEQ,
	                    gte: "Is after or equal to",
	                    gt: "Is after",
	                    lte: "Is before or equal to",
	                    lt: "Is before",
	                    isnull: "Is null",
	                    isnotnull: "Is not null"
	                },
	                enums: {
	                    eq: EQ,
	                    neq: NEQ,
	                    isnull: "Is null",
	                    isnotnull: "Is not null"
	                }
	            },
	            messages: {
	                info: "Show items with value that:",
	                title: "Show items with value that:",
	                isTrue: "is true",
	                isFalse: "is false",
	                filter: "Filter",
	                clear: "Clear",
	                and: "And",
	                or: "Or",
	                selectValue: "-Select value-",
	                operator: "Operator",
	                value: "Value",
	                additionalValue: "Additional value",
	                additionalOperator: "Additional operator",
	                logic: "Filters logic",
	                cancel: "Cancel",
	                done: "Done",
	                into: "in"
	            },
	            animations: {
	                left: "slide",
	                right: "slide:right"
	            }
	        }
	    });

	    var multiCheckNS = ".kendoFilterMultiCheck";

	    function filterValuesForField(expression, field) {

	        if (expression.filters) {
	            expression.filters = $.grep(expression.filters, function(filter) {
	                filterValuesForField(filter, field);
	                if (filter.filters) {
	                    return filter.filters.length;
	                } else {
	                    return filter.field == field && filter.operator == "eq";
	                }
	            });
	        }
	    }

	    function flatFilterValues(expression) {
	        if (expression.logic == "and" && expression.filters.length > 1) {
	            return [];
	        }
	        if (expression.filters) {
	            return $.map(expression.filters, function(filter) {
	                return flatFilterValues(filter);
	            });
	        } else if (expression.value !== undefined) {
	            return [expression.value];
	        } else {
	            return [];
	        }
	    }

	    function distinct(items, field) {
	        var getter = kendo.getter(field, true),
	            result = [],
	            index = 0,
	            seen = {};

	        while (index < items.length) {
	            var item = items[index++],
	                text = getter(item);

	            if(text !== undefined && !seen.hasOwnProperty(text)){
	                result.push(item);
	                seen[text] = true;
	            }
	        }

	        return result;
	    }

	    function removeDuplicates (dataSelector, dataTextField) {

	        return function(e) {
	            var items = dataSelector(e);

	            return distinct(items, dataTextField);
	        };
	    }

	    var DataSource = kendo.data.DataSource;

	    var multiCkeckMobileTemplate =
	        '<div data-#=ns#role="view" class="k-grid-filter-menu">' +
	            '<div data-#=ns#role="header" class="k-header">' +
	                '<a href="\\#" class="k-header-cancel k-link" title="#=messages.cancel#" ' +
	                'aria-label="#=messages.cancel#"><span class="k-icon k-i-arrow-chevron-left"></span></a>' +
	                '#=messages.filter# #=messages.into# #=title#' +
	                '<a href="\\#" class="k-header-done k-link" title="#=messages.done#" ' +
	                'aria-label="#=messages.done#"><span class="k-icon k-i-check"></span></a>' +
	            '</div>' +
	            '<form class="k-filter-menu">' +
	                '<ul class="k-reset">' +
	                    '#if(search){#' +
	                        '<li class="k-textbox k-space-right">' +
	                            '<input placeholder="#=messages.search#" title="#=messages.search#" autocomplete="'+AUTOCOMPLETEVALUE+'"  />' +
	                            '<span class="k-icon k-i-zoom"></span>' +
	                        '</li>' +
	                    '#}#' +
	                    '<li class="k-filter-tools">' +
	                        '<span style="#=checkAll ? "" : "visibility: hidden;" #" class="k-label k-select-all" title="#=messages.checkAll#" ' +
	                        'aria-label="#=messages.checkAll#">#=messages.checkAll#</span>' +
	                        '<span class="k-label k-clear-all" title="#=messages.clearAll#" ' +
	                        'aria-label="#=messages.clearAll#">#=messages.clearAll#</span>' +
	                    '</li>' +
	                    '#if(messages.selectedItemsFormat){#' +
	                        '<li>' +
	                            '<div class="k-filter-selected-items"></div>' +
	                        '</li>' +
	                    '#}#' +
	                    '<li>' +
	                        '<ul class="k-multicheck-wrap k-listgroup k-listgroup-flush"></ul>' +
	                    '</li>' +
	                '</ul>' +
	            '</form>' +
	        '</div>';

	    var FilterMultiCheck = Widget.extend({
	        init: function(element, options) {
	            Widget.fn.init.call(this, element, options);
	            options = this.options;
	            this.element = $(element);
	            var field = this.field = this.options.field || this.element.attr(kendo.attr("field"));
	            var checkSource = options.checkSource;
	            if (this._foreignKeyValues()) {
	                this.checkSource = DataSource.create(options.values);
	                this.checkSource.fetch();
	            } else if (options.forceUnique) {
	                checkSource = $.extend(true, {}, options.dataSource.options);
	                delete checkSource.pageSize;

	                this.checkSource = DataSource.create(checkSource);
	                this.checkSource.reader.data = removeDuplicates(this.checkSource.reader.data, this.field);
	            } else {
	                this.checkSource = DataSource.create(checkSource);
	            }

	            this.dataSource = options.dataSource;
	            this.model = this.dataSource.reader.model;

	            this._parse = function(value) {
	                 return value + "";
	            };

	            if (this.model && this.model.fields) {
	                field = this.model.fields[this.field];

	                if (field) {
	                    if (field.type == "number") {
	                        this._parse = function (value) {
	                            if (typeof value === "string" && (value.toLowerCase() === "null" || this._foreignKeyValues() && value === "")) {
	                                return null;
	                            }
	                            return parseFloat(value);
	                        };
	                    } else if (field.parse) {
	                        this._parse = proxy(field.parse, field);
	                    }
	                    this.type = field.type || "string";
	                }
	            }
	            if (!options.appendToElement) {
	                this._createLink();
	            } else {
	                this._init();
	            }

	            this._refreshHandler = proxy(this.refresh, this);
	            this.dataSource.bind(CHANGE, this._refreshHandler);

	        },
	        _createLink: function() {
	            var element = this.element;
	            var link = element.addClass("k-with-icon k-filterable").find(".k-grid-filter");

	            if (!link[0]) {
	                link = element.prepend('<a class="k-grid-filter" href="#" title="' +
	                this.options.messages.filter + '" aria-label="' +
	                this.options.messages.filter + '"><span class="k-icon k-i-filter"></span></a>').find(".k-grid-filter");
	            }

	            this._link = link.attr("tabindex", -1).on("click" + NS, proxy(this._click, this));
	        },
	        _init: function() {
	            var that = this;
	            var forceUnique = this.options.forceUnique;

	            var options = this.options;
	            this.pane = options.pane;

	            if (this.pane) {
	                this._isMobile = true;
	            }

	            this._createForm();

	            if (this._foreignKeyValues()) {
	                this.refresh();
	            } else if (forceUnique && !this.checkSource.options.serverPaging && this.dataSource.data().length) {
	                this.checkSource.data(distinct(this.dataSource.data(),this.field));
	                this.refresh();
	            } else {
	                this._attachProgress();

	                this.checkSource.fetch(function() {
	                    that.refresh.call(that);
	                });
	            }

	            if (!this.options.forceUnique) {
	                this.checkChangeHandler = function() {
	                    that.container.empty();
	                    that.refresh();
	                };
	                this.checkSource.bind(CHANGE, this.checkChangeHandler);
	            }

	            this.form.on("keydown" + multiCheckNS, proxy(this._keydown, this))
	                        .on("submit" + multiCheckNS, proxy(this._filter, this))
	                        .on("reset" + multiCheckNS, proxy(this._reset, this));

	            this.trigger(INIT, { field: this.field, container: this.form });
	        },

	        _attachProgress: function() {
	            var that = this;

	            this._progressHandler = function() {
	                ui.progress(that.container, true);
	            };

	            this._progressHideHandler = function() {
	                ui.progress(that.container, false);
	            };

	            this.checkSource
	                .bind("progress", this._progressHandler)
	                .bind("change", this._progressHideHandler);
	        },

	        _input: function () {
	            var that = this;
	            that._clearTypingTimeout();
	            that._typingTimeout = setTimeout(function () { that.search(); }, 100);
	        },

	        _clearTypingTimeout: function() {
	            if (this._typingTimeout) {
	                clearTimeout(this._typingTimeout);
	                this._typingTimeout = null;
	            }
	        },

	        search: function () {
	            var ignoreCase = this.options.ignoreCase;
	            var searchString = this.searchTextBox[0].value;
	            var labels = this.container.find("label");

	            if (ignoreCase) {
	                searchString = searchString.toLowerCase();
	            }
	            var i = 0;
	            if(this.options.checkAll && labels.length)
	            {
	                if (!this._isMobile) {
	                    labels[0].parentNode.style.display = searchString ? "none" : "";
	                    i++;
	                } else {
	                    this.view.element.find(".k-select-all")[0].style.visibility = searchString ? "hidden" : "";
	                }
	            }

	            while (i < labels.length) {
	                var label = labels[i];
	                var labelText = label.textContent || label.innerText;
	                if (ignoreCase) {
	                    labelText = labelText.toLowerCase();
	                }
	                label.parentNode.style.display = labelText.indexOf(searchString) >= 0 ? "" : "none";
	                i++;
	            }
	        },
	        _activate: function() {
	            this.form.find(":kendoFocusable:first").focus();

	            this.trigger(OPEN, { field: this.field, container: this.form });
	        },
	        _createForm: function() {
	            var options = this.options;
	            var html = "";
	            var that = this;

	            if (!this._isMobile) {
	                html+= "<div class='k-filter-menu-container'>";
	                if (options.search) {
	                    html += "<div class='k-textbox k-space-right'>" +
	                    "<input placeholder='" + options.messages.search + "'/>" +
	                    "<span class='k-icon k-i-zoom'></span>" +
	                    "</div>";
	                }
	                html += "<ul class='k-reset k-multicheck-wrap'></ul>";
	                if (options.messages.selectedItemsFormat) {
	                    html += "<div class='k-filter-selected-items'>" + kendo.format(options.messages.selectedItemsFormat, 0) + "</div>";
	                }
	                html += "<div class='k-action-buttons'>";
	                html +="<button type='submit' class='k-button k-primary'>" + options.messages.filter + "</button>";
	                html += "<button type='reset' class='k-button'>" + options.messages.clear + "</button>";
	                html += "</div>";
	                html += "</div>";

	                this.form = $('<form class="k-filter-menu"/>').html(html);
	                this.container = this.form.find(".k-multicheck-wrap");
	            }
	            if (this._isMobile) {
	                that.form = $("<div />")
	                    .html(kendo.template(multiCkeckMobileTemplate)({
	                        field: that.field,
	                        title: options.title || that.field,
	                        ns: kendo.ns,
	                        messages: options.messages,
	                        search: options.search,
	                        checkAll: options.checkAll
	                    }));

	                that.view = that.pane.append(that.form.html());
	                that.form = that.view.element.find("form");
	                var element = this.view.element;
	                this.container = element.find(".k-multicheck-wrap");

	                element
	                    .on("click", ".k-header-done", function (e) {
	                        that.form.submit();
	                        e.preventDefault();
	                    })
	                    .on("click", ".k-header-cancel", function (e) {
	                        that._closeForm();
	                        e.preventDefault();
	                    })
	                    .on("click", ".k-clear-all", function(e) {
	                        that._mobileCheckAll(false);
	                        e.preventDefault();
	                    })
	                    .on("click", ".k-select-all", function(e) {
	                        that._mobileCheckAll(true);
	                        e.preventDefault();
	                    });

	                that.view.bind("showStart", function() {
	                    that.refresh();
	                });
	            } else {
	                if (!options.appendToElement) {
	                    that.popup = that.form.kendoPopup({
	                        anchor: that._link,
	                        copyAnchorStyles: false,
	                        open: proxy(that._open, that),
	                        activate: proxy(that._activate, that),
	                        close: function() {
	                            if (that.options.closeCallback) {
	                                that.options.closeCallback(that.element);
	                            }
	                        }
	                    }).data(POPUP);
	                } else {
	                    this.popup = this.element.closest(".k-popup").data(POPUP);
	                    this.element.append(this.form);
	                }
	            }

	            if (options.search) {
	                this.searchTextBox = this.form.find(".k-textbox > input");
	                this.searchTextBox.on("input", proxy(this._input, this));
	            }
	        },
	        createCheckAllItem: function () {
	            var options = this.options;
	            var template = kendo.template(options.itemTemplate({ field: "all", mobile: this._isMobile }));
	            var checkAllContainer = $(template({ all: options.messages.checkAll}));
	            this.container.prepend(checkAllContainer);

	            this.checkBoxAll = checkAllContainer.find(":checkbox").eq(0).addClass("k-check-all");
	            this.checkAllHandler = proxy(this.checkAll, this);
	            this.checkBoxAll.on(CHANGE+ multiCheckNS, this.checkAllHandler);
	        },
	        updateCheckAllState: function() {
	            if (this.options.messages.selectedItemsFormat) {
	                this.form.find(".k-filter-selected-items").text(kendo.format(this.options.messages.selectedItemsFormat, this.container.find(":checked:not(.k-check-all)").length));
	            }
	            if (this.checkBoxAll) {
	                var state = this.container.find(":checkbox:not(.k-check-all)").length == this.container.find(":checked:not(.k-check-all)").length;
	                this.checkBoxAll.prop("checked", state);
	            }
	        },
	        refresh: function(e) {
	            var forceUnique = this.options.forceUnique;
	            var dataSource = this.dataSource;
	            var filters = this.getFilterArray();

	            if (this._link) {
	                this._link.toggleClass("k-state-active", filters.length !== 0);
	            }

	            if (this.form) {
	                if (e && forceUnique && e.sender === dataSource && !dataSource.options.serverPaging &&
	                     (e.action == "itemchange" || e.action == "add" || e.action == "remove" || (dataSource.options.autoSync && e.action === "sync")) &&
	                         !this._foreignKeyValues()) {
	                    this.checkSource.data(distinct(this.dataSource.data(),this.field));
	                    this.container.empty();
	                }

	                if (this.container.is(":empty")) {
	                    this.createCheckBoxes();
	                }
	                this.checkValues(filters);
	                this.trigger(REFRESH);
	            }
	        },
	        getFilterArray: function() {
	            var expression = $.extend(true, {}, { filters: [], logic: "and" }, this.dataSource.filter());
	            filterValuesForField(expression, this.field);
	            var flatValues = flatFilterValues(expression);
	            return flatValues;
	        },
	        createCheckBoxes: function() {
	            var options = this.options;
	            var data;
	            var templateOptions = {
	                field: this.field,
	                format: options.format,
	                mobile: this._isMobile,
	                type: this.type
	            };

	            if (!this.options.forceUnique) {
	                data = this.checkSource.view();
	            } else if (this._foreignKeyValues()) {
	                data = this.checkSource.data();
	                templateOptions.valueField = "value";
	                templateOptions.field = "text";
	            } else if (this.checkSource._isServerGrouped()) {
	                data = distinct(this.checkSource._flatData(this.checkSource.data()), this.field);
	            } else {
	                data = this.checkSource.data();
	            }

	            var template = kendo.template(options.itemTemplate(templateOptions));
	            var itemsHtml = kendo.render(template, data);
	            if (options.checkAll && !this._isMobile) {
	                this.createCheckAllItem();
	            }
	            this.container.on(CHANGE + multiCheckNS, ":checkbox", proxy(this.updateCheckAllState, this));

	            this.container.append(itemsHtml);

	        },
	        checkAll: function() {
	            var state = this.checkBoxAll.is(":checked");
	            this.container.find(":checkbox").prop("checked", state);
	        },
	        checkValues: function(values) {
	            var that = this;

	            $($.grep(this.container.find(":checkbox").prop("checked", false), function(ele) {
	                var found = false;
	                if ($(ele).is(".k-check-all")) {
	                    return;
	                }
	                var checkBoxVal = that._parse($(ele).val());
	                for (var i = 0; i < values.length; i++) {
	                    if (that.type == "date") {
	                        if (values[i] && checkBoxVal) {
	                            found = values[i].getTime() == checkBoxVal.getTime();
	                        } else if (values[i] === null && checkBoxVal === null) {
	                            found = true;
	                        } else {
	                            found = false;
	                        }
	                    } else {
	                        found = values[i] == checkBoxVal;
	                    }
	                    if (found) {
	                        return found;
	                    }
	                }
	            })).prop("checked", true);
	            this.updateCheckAllState();
	        },

	        _mobileCheckAll: function(state) {
	            var that = this;
	            var checkboxes = that.container.find(":checkbox");

	            checkboxes.each(function(i, e) {
	                var checkbox = $(e);

	                checkbox.prop("checked", state);
	                checkbox.trigger("change");
	            });
	        },

	        _filter: function(e) {
	            e.preventDefault();
	            e.stopPropagation();

	            var expression = { logic: "or" };

	            var that = this;
	            expression.filters = $.map(this.form.find(":checkbox:checked:not(.k-check-all)"), function (item) {
	                return { value: $(item).val(), operator: "eq", field: that.field };
	            });

	            if (this.trigger("change", { filter: expression, field: that.field })) {
	                return;
	            }

	            expression = this._merge(expression);
	            if (expression.filters.length) {
	                this.dataSource.filter(expression);
	            } else {
	                that._removeFilter(that.dataSource.filter() || { filters:[] });
	            }

	            this._closeForm();
	        },

	        _stripFilters: function(filters) {
	           return $.grep(filters, function(filter) {
	                return filter.value != null;
	            });
	        },

	        _foreignKeyValues: function() {
	            var options = this.options;
	            return options.values && !options.checkSource;
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            if (that.form) {
	                kendo.unbind(that.form);
	                kendo.destroy(that.form);
	                that.form.unbind(multiCheckNS);
	                if (that.popup) {
	                    that.popup.destroy();
	                    that.popup = null;
	                }
	                that.form = null;
	                if (that.container) {
	                    that.container.unbind(multiCheckNS);
	                    that.container = null;
	                }

	                if (that.checkBoxAll) {
	                    that.checkBoxAll.unbind(multiCheckNS);
	                }
	            }

	            if (that.view) {
	                that.view.purge();
	                that.view = null;
	            }

	            if (that._link) {
	                that._link.unbind(NS);
	            }

	            if (that._refreshHandler) {
	                that.dataSource.unbind(CHANGE, that._refreshHandler);
	                that.dataSource = null;
	            }

	            if (that.checkChangeHandler) {
	                that.checkSource.unbind(CHANGE, that.checkChangeHandler);
	            }

	            if (that._progressHandler) {
	                that.checkSource.unbind("progress", that._progressHandler);
	            }

	            if (that._progressHideHandler) {
	                that.checkSource.unbind("change", that._progressHideHandler);
	            }

	            this._clearTypingTimeout();
	            this.searchTextBox = null;

	            that.element = that.checkSource = that.container = that.checkBoxAll = that._link = that._refreshHandler = that.checkAllHandler = null;
	        },
	        options: {
	            name: "FilterMultiCheck",
	            itemTemplate: function(options) {
	                var field = options.field;
	                var format = options.format;
	                var valueField = options.valueField;
	                var mobile = options.mobile;
	                var valueFormat = "";

	                if (valueField === undefined) {
	                    valueField = field;
	                }
	                if (options.type == "date") {
	                    valueFormat = ":yyyy-MM-ddTHH:mm:sszzz";
	                }

	                if (mobile) {
	                    return "<li class='k-item k-listgroup-item'>" +
	                            "<label class='k-label k-listgroup-form-row'>" +
	                                "<span class='k-listgroup-form-field-label k-item-title '>#:kendo.format('" + ( format ?  format  : "{0}" ) + "', "  + field + ")#</span>" +
	                                '<span class="k-listgroup-form-field-wrapper">' +
	                                    "<input type='checkbox' value='#:kendo.format('{0"+ valueFormat + "}'," + valueField + ")#'/>" +
	                                '</span>' +
	                            "</label>" +
	                        "</li>";
	                }

	                return "<li class='k-item'>" +
	                        "<label class='k-label'>" +
	                            "<input type='checkbox' value='#:kendo.format('{0"+ valueFormat + "}'," + valueField + ")#'/>" +
	                            "<span>#:kendo.format('" + ( format ?  format  : "{0}" ) + "', "  + field + ")#</span>" +
	                        "</label>" +
	                    "</li>";
	            },
	            checkAll: true,
	            search: false,
	            ignoreCase: true,
	            appendToElement: false,
	            messages: {
	                checkAll: "Select All",
	                clearAll: "Clear All",
	                clear: "Clear",
	                filter: "Filter",
	                search: "Search",
	                cancel: "Cancel",
	                selectedItemsFormat: "{0} items selected",
	                done: "Done",
	                into: "in"
	            },
	            forceUnique: true,
	            animations: {
	                left: "slide",
	                right: "slide:right"
	            }
	        },
	        events: [ INIT, REFRESH, "change", OPEN ]
	    });

	    $.extend(FilterMultiCheck.fn, {
	        _click: FilterMenu.fn._click,
	        _keydown: FilterMenu.fn._keydown,
	        _reset: FilterMenu.fn._reset,
	        _closeForm: FilterMenu.fn._closeForm,
	        _removeFilter: FilterMenu.fn._removeFilter,
	        clear: FilterMenu.fn.clear,

	        _merge: FilterMenu.fn._merge
	    });

	    ui.plugin(FilterMenu);
	    ui.plugin(FilterMultiCheck);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "3i6F":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1451);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1451:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "validator",
	    name: "Validator",
	    category: "web",
	    description: "The Validator offers an easy way to do a client-side form validation.",
	    depends: [ "core" ]
	};

	/* jshint eqnull: true */
	(function($, undefined) {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        NS = ".kendoValidator",
	        INVALIDMSG = "k-invalid-msg",
	        invalidMsgRegExp = new RegExp(INVALIDMSG,'i'),
	        INVALIDINPUT = "k-invalid",
	        VALIDINPUT = "k-valid",
	        VALIDATIONSUMMARY = "k-validation-summary",
	        INVALIDLABEL = "k-text-error",
	        MESSAGEBOX = "k-messagebox k-messagebox-error",
	        ARIAINVALID = "aria-invalid",
	        ARIADESCRIBEDBY = "aria-describedby",
	        emailRegExp = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i,
	        urlRegExp = /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
	        INPUTSELECTOR = ":input:not(:button,[type=submit],[type=reset],[disabled],[readonly])",
	        CHECKBOXSELECTOR = ":checkbox:not([disabled],[readonly])",
	        NUMBERINPUTSELECTOR = "[type=number],[type=range]",
	        BLUR = "blur",
	        NAME = "name",
	        FORM = "form",
	        NOVALIDATE = "novalidate",
	        //events
	        VALIDATE = "validate",
	        CHANGE = "change",
	        VALIDATE_INPUT = "validateInput",
	        proxy = $.proxy,
	        patternMatcher = function(value, pattern) {
	            if (typeof pattern === "string") {
	                pattern = new RegExp('^(?:' + pattern + ')$');
	            }
	            return pattern.test(value);
	        },
	        matcher = function(input, selector, pattern) {
	            var value = input.val();

	            if (input.filter(selector).length && value !== "") {
	                return patternMatcher(value, pattern);
	            }
	            return true;
	        },
	        hasAttribute = function(input, name) {
	            if (input.length)  {
	                return input[0].attributes[name] != null;
	            }
	            return false;
	        };

	    if (!kendo.ui.validator) {
	        kendo.ui.validator = { rules: {}, messages: {}, allowSubmit: $.noop, validateOnInit: $.noop };
	    }

	    function resolveRules(element) {
	        var resolvers = kendo.ui.validator.ruleResolvers || {},
	            rules = {},
	            name;

	        for (name in resolvers) {
	            $.extend(true, rules, resolvers[name].resolve(element));
	        }
	        return rules;
	    }

	    function decode(value) {
	        return value.replace(/&amp/g, '&amp;')
	            .replace(/&quot;/g, '"')
	            .replace(/&#39;/g, "'")
	            .replace(/&lt;/g, '<')
	            .replace(/&gt;/g, '>');
	    }

	    function numberOfDecimalDigits(value) {
	        value = (value + "").split('.');
	        if (value.length > 1) {
	            return value[1].length;
	        }
	        return 0;
	    }

	    function parseHtml(text) {
	        if ($.parseHTML) {
	            return $($.parseHTML(text));
	        }
	        return $(text);
	    }

	    function searchForMessageContainer(elements, fieldName) {
	        var containers = $(),
	            element,
	            attr;

	        for (var idx = 0, length = elements.length; idx < length; idx++) {
	            element = elements[idx];
	            if (invalidMsgRegExp.test(element.className)) {
	                attr = element.getAttribute(kendo.attr("for"));
	                if (attr === fieldName) {
	                    containers = containers.add(element);
	                }
	            }
	        }
	        return containers;
	    }

	    function isLabelFor(label, element) {
	        if (!label) {
	            return false;
	        }
	        if (typeof label.nodeName !== 'string' || label.nodeName !== 'LABEL') {
	            return false;
	        }
	        if (typeof label.getAttribute('for') !== 'string' || typeof element.getAttribute('id') !== 'string') {
	            return false;
	        }
	        if (label.getAttribute('for') !== element.getAttribute('id')) {
	            return false;
	        }

	        return true;
	    }

	    var SUMMARYTEMPLATE = '<ul>' +
	        '#for(var i = 0; i < errors.length; i += 1){#' +
	            '<li><a data-field="#=errors[i].field#" href="\\#">#= errors[i].message #</a></li>' +
	        '# } #' +
	    '</ul>';

	    var Validator = Widget.extend({
	        init: function(element, options) {
	            var that = this,
	                resolved = resolveRules(element),
	                validateAttributeSelector = "[" + kendo.attr("validate") + "!=false]";

	            options = options || {};

	            options.rules = $.extend({}, kendo.ui.validator.rules, resolved.rules, options.rules);
	            options.messages = $.extend({}, kendo.ui.validator.messages, resolved.messages, options.messages);

	            Widget.fn.init.call(that, element, options);

	            that._errorTemplate = kendo.template(that.options.errorTemplate);
	            that._summaryTemplate = kendo.template(that.options.validationSummary.template || SUMMARYTEMPLATE);

	            if (that.element.is(FORM)) {
	                that.element.attr(NOVALIDATE, NOVALIDATE);
	            }

	            that._inputSelector = INPUTSELECTOR + validateAttributeSelector;
	            that._checkboxSelector = CHECKBOXSELECTOR + validateAttributeSelector;

	            that._errors = {};
	            that._attachEvents();
	            that._isValidated = false;

	            if (that._validateOnInit()) {
	                that.validate();
	            }
	        },

	        events: [ VALIDATE, CHANGE, VALIDATE_INPUT ],

	        options: {
	            name: "Validator",
	            errorTemplate: '<span class="k-form-error">#= message #</span>',
	            messages: {
	                required: "{0} is required",
	                pattern: "{0} is not valid",
	                min: "{0} should be greater than or equal to {1}",
	                max: "{0} should be smaller than or equal to {1}",
	                step: "{0} is not valid",
	                email: "{0} is not valid email",
	                url: "{0} is not valid URL",
	                date: "{0} is not valid date",
	                dateCompare: "End date should be greater than or equal to the start date"
	            },
	            rules: {
	                required: function(input) {
	                    var checkbox = input.filter("[type=checkbox]").length && !input.is(":checked"),
	                        value = input.val();

	                    return !(hasAttribute(input, "required") && (!value || value === "" || value.length === 0 || checkbox));
	                },
	                pattern: function(input) {
	                    if (input.filter("[type=text],[type=email],[type=url],[type=tel],[type=search],[type=password]").filter("[pattern]").length && input.val() !== "") {
	                        return patternMatcher(input.val(), input.attr("pattern"));
	                    }
	                    return true;
	                },
	                min: function(input) {
	                    if (input.filter(NUMBERINPUTSELECTOR + ",[" + kendo.attr("type") + "=number]").filter("[min]").length && input.val() !== "") {
	                        var min = parseFloat(input.attr("min")) || 0,
	                            val = kendo.parseFloat(input.val());

	                        return min <= val;
	                    }
	                    return true;
	                },
	                max: function(input) {
	                    if (input.filter(NUMBERINPUTSELECTOR + ",[" + kendo.attr("type") + "=number]").filter("[max]").length && input.val() !== "") {
	                        var max = parseFloat(input.attr("max")) || 0,
	                            val = kendo.parseFloat(input.val());

	                        return max >= val;
	                    }
	                    return true;
	                },
	                step: function(input) {
	                    if (input.filter(NUMBERINPUTSELECTOR + ",[" + kendo.attr("type") + "=number]").filter("[step]").length && input.val() !== "") {
	                        var min = parseFloat(input.attr("min")) || 0,
	                            step = parseFloat(input.attr("step")) || 1,
	                            val = parseFloat(input.val()),
	                            decimals = numberOfDecimalDigits(step),
	                            raise;

	                        if (decimals) {
	                            raise = Math.pow(10, decimals);
	                            return ((Math.floor((val-min)*raise))%(step*raise)) / Math.pow(100, decimals) === 0;
	                        }
	                        return ((val-min)%step) === 0;
	                    }
	                    return true;
	                },
	                email: function(input) {
	                    return matcher(input, "[type=email],[" + kendo.attr("type") + "=email]", emailRegExp);
	                },
	                url: function(input) {
	                    return matcher(input, "[type=url],[" + kendo.attr("type") + "=url]", urlRegExp);
	                },
	                date: function(input) {
	                    if (input.filter("[type^=date],[" + kendo.attr("type") + "=date]").length && input.val() !== "") {
	                        return kendo.parseDate(input.val(), input.attr(kendo.attr("format"))) !== null;
	                    }
	                    return true;
	                }
	            },
	            validateOnBlur: true,
	            validationSummary: false
	        },

	        _allowSubmit: function() {
	            return kendo.ui.validator.allowSubmit(this.element, this.errors());
	        },

	        _validateOnInit: function() {
	            return kendo.ui.validator.validateOnInit(this.element);
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            this.element.off(NS);

	            if (this.validationSummary) {
	                this.validationSummary.off(NS);
	                this.validationSummary = null;
	            }
	        },

	        value: function() {
	            if (!this._isValidated) {
	                return false;
	            }

	            return this.errors().length === 0;
	        },

	        _submit: function(e) {
	            if (!this.validate() && !this._allowSubmit()) {
	                e.stopPropagation();
	                e.stopImmediatePropagation();
	                e.preventDefault();
	                return false;
	            }
	            return true;
	        },

	        _checkElement: function(element) {
	            var state = this.value();

	            this.validateInput(element);

	            if (this.value() !== state) {
	                this.trigger(CHANGE);
	            }
	        },

	        _attachEvents: function() {
	            var that = this;

	            if (that.element.is(FORM)) {
	                that.element.on("submit" + NS, proxy(that._submit, that));
	            }

	            if (that.options.validateOnBlur) {
	                if (!that.element.is(INPUTSELECTOR)) {
	                    that.element.on(BLUR + NS, that._inputSelector, function() {
	                        that._checkElement($(this));
	                    });

	                    that.element.on("click" + NS, that._checkboxSelector, function() {
	                        that._checkElement($(this));
	                    });
	                } else {
	                    that.element.on(BLUR + NS, function() {
	                        that._checkElement(that.element);
	                    });

	                    if (that.element.is(CHECKBOXSELECTOR)) {
	                        that.element.on("click" + NS, function() {
	                            that._checkElement(that.element);
	                        });
	                    }
	                }
	            }
	        },

	        validate: function() {
	            var inputs;
	            var idx;
	            var result = false;
	            var length;

	            var isValid = this.value();

	            this._errors = {};

	            if (!this.element.is(INPUTSELECTOR)) {
	                var invalid = false;

	                inputs = this.element.find(this._inputSelector);

	                for (idx = 0, length = inputs.length; idx < length; idx++) {
	                    if (!this.validateInput(inputs.eq(idx))) {
	                        invalid = true;
	                    }
	                }

	                result = !invalid;
	            } else {
	                result = this.validateInput(this.element);
	            }

	            if (this.options.validationSummary && !isValid) {
	                this.showValidationSummary();
	            }

	            this.trigger(VALIDATE, { valid: result, errors: this.errors() });

	            if (isValid !== result) {
	                this.trigger(CHANGE);
	            }

	            return result;
	        },

	        validateInput: function(input) {
	            input = $(input);

	            this._isValidated = true;

	            var that = this,
	                template = that._errorTemplate,
	                result = that._checkValidity(input),
	                valid = result.valid,
	                className = "." + INVALIDMSG,
	                fieldName = (input.attr(NAME) || ""),
	                lbl = that._findMessageContainer(fieldName).add(input.next(className).filter(function() {
	                    var element = $(this);
	                    if (element.filter("[" + kendo.attr("for") + "]").length) {
	                        return element.attr(kendo.attr("for")) === fieldName;
	                    }

	                    return true;

	                })).addClass("k-hidden"),
	                messageText = !valid ? that._extractMessage(input, result.key) : "",
	                messageLabel = !valid ? parseHtml(template({ message: decode(messageText), field: fieldName })) : "",
	                wasValid = !input.attr(ARIAINVALID);

	            input.removeAttr(ARIAINVALID);

	            if (!valid) {
	                that._errors[fieldName] = messageText;
	                var lblId = lbl.attr('id');

	                that._decorateMessageContainer(messageLabel, fieldName);


	                if (lblId) {
	                    messageLabel.attr('id', lblId);
	                }

	                if (lbl.length !== 0) {
	                    lbl.replaceWith(messageLabel);
	                } else {
	                    var widgetInstance = kendo.widgetInstance(input);
	                    var parentElement = input.parent().get(0);
	                    var nextElement = input.next().get(0);
	                    var prevElement = input.prev().get(0);

	                    if (widgetInstance && widgetInstance.wrapper) {
	                        messageLabel.insertAfter(widgetInstance.wrapper);
	                    } else if (parentElement && parentElement.nodeName === "LABEL") {
	                        // Input inside label
	                        messageLabel.insertAfter(parentElement);
	                    } else if (nextElement && isLabelFor(nextElement, input[0])) {
	                        // Input before label
	                        messageLabel.insertAfter(nextElement);
	                    } else if (prevElement && isLabelFor(prevElement, input[0])) {
	                        // Input after label
	                        messageLabel.insertAfter(input);
	                    } else {
	                        messageLabel.insertAfter(input);
	                    }
	                }

	                messageLabel.removeClass("k-hidden");

	                input.attr(ARIAINVALID, true);
	            } else {
	                delete that._errors[fieldName];
	            }

	            if (wasValid !== valid) {
	                this.trigger(VALIDATE_INPUT, { valid: valid, input: input, error: messageText, field: fieldName });
	            }

	            input.toggleClass(INVALIDINPUT, !valid);
	            input.toggleClass(VALIDINPUT, valid);

	            if (kendo.widgetInstance(input)) {
	                var inputWrap = kendo.widgetInstance(input)._inputWrapper;
	                var inputLabel = kendo.widgetInstance(input)._inputLabel;

	                if (inputWrap) {
	                    inputWrap.toggleClass(INVALIDINPUT, !valid);
	                    inputWrap.toggleClass(VALIDINPUT, valid);
	                }
	                if (inputLabel) {
	                    inputLabel.toggleClass(INVALIDLABEL, !valid);
	                }
	            }

	            if (wasValid !== valid) {
	                var errorId = messageLabel ? messageLabel.attr("id") : lbl.attr("id");

	                that._associateMessageContainer(input, errorId);

	                if (this.options.validationSummary && this.options.validateOnBlur) {
	                    this.showValidationSummary();
	                }
	            }

	            return valid;
	        },

	        hideMessages: function() {
	            var that = this,
	                className = "." + INVALIDMSG,
	                element = that.element;

	            that._disassociateMessageContainers();

	            if (!element.is(INPUTSELECTOR)) {
	                element.find(className).addClass("k-hidden");
	            } else {
	                element.next(className).addClass("k-hidden");
	            }
	        },

	        reset: function() {
	            var that = this,
	                inputs = that.element.find("." + INVALIDINPUT),
	                labels = that.element.find("." + INVALIDLABEL);

	            that._errors = [];

	            that.hideMessages();

	            that.hideValidationSummary();

	            inputs.removeAttr(ARIAINVALID);
	            inputs.removeClass(INVALIDINPUT);
	            labels.removeClass(INVALIDLABEL);
	        },

	        _findMessageContainer: function(fieldName) {
	            var locators = kendo.ui.validator.messageLocators,
	                name,
	                containers = $();

	            for (var idx = 0, length = this.element.length; idx < length; idx++) {
	                containers = containers.add(searchForMessageContainer(this.element[idx].getElementsByTagName("*"), fieldName));
	            }

	            for (name in locators) {
	                containers = containers.add(locators[name].locate(this.element, fieldName));
	            }

	            return containers;
	        },

	        _decorateMessageContainer: function(container, fieldName) {
	            var locators = kendo.ui.validator.messageLocators,
	                name;

	            container.addClass(INVALIDMSG)
	                .attr(kendo.attr("for"), fieldName || "");

	            if (!container.attr("id")) {
	                container.attr("id", fieldName + "-error");
	            }

	            for (name in locators) {
	                locators[name].decorate(container, fieldName);
	            }
	        },

	        _extractMessage: function(input, ruleKey) {
	            var that = this,
	                customMessage = that.options.messages[ruleKey],
	                fieldName = input.attr(NAME),
	                nonDefaultMessage;

	            if (!kendo.ui.Validator.prototype.options.messages[ruleKey]) {
	                 nonDefaultMessage = kendo.isFunction(customMessage) ? customMessage(input) : customMessage;
	            }

	            customMessage = kendo.isFunction(customMessage) ? customMessage(input) : customMessage;

	            return kendo.format(input.attr(kendo.attr(ruleKey + "-msg")) || input.attr("validationMessage") || nonDefaultMessage || customMessage || input.attr("title") || "",
	                fieldName,
	                input.attr(ruleKey) || input.attr(kendo.attr(ruleKey)));
	        },

	        _checkValidity: function(input) {
	            var rules = this.options.rules,
	                rule;

	            for (rule in rules) {
	                if (!rules[rule].call(this, input)) {
	                    return { valid: false, key: rule };
	                }
	            }

	            return { valid: true };
	        },

	        errors: function() {
	            var results = [],
	                errors = this._errors,
	                error;

	            for (error in errors) {
	                results.push(errors[error]);
	            }
	            return results;
	        },

	        setOptions: function(options) {
	            if (options.validationSummary) {
	                this.hideValidationSummary();
	            }

	            kendo.deepExtend(this.options, options);

	            this.destroy();

	            this.init(this.element, this.options);

	            this._setEvents(this.options);
	        },

	        _getInputNames: function() {
	            var that = this,
	                inputs = that.element.find(that._inputSelector),
	                sorted = [];

	            for (var idx = 0, length = inputs.length; idx < length; idx++) {
	                var input = $(inputs[idx]);

	                if (hasAttribute(input, NAME)) {
	                    sorted.push(input.attr(NAME));
	                }
	            }

	            return sorted;
	        },

	        _associateMessageContainer: function(input, errorId) {
	            var nextFocusable = kendo.getWidgetFocusableElement(input);

	            if (!nextFocusable || !errorId) {
	                return;
	            }

	            kendo.toggleAttribute(nextFocusable, ARIADESCRIBEDBY, errorId);
	        },

	        _disassociateMessageContainers: function() {
	            var that = this,
	                inputs = that.element.find("." + INVALIDINPUT).addBack(),
	                input, errorId;

	            for (var i = 0; i < inputs.length; i += 1) {
	                input = $(inputs[i]);

	                if (input.is("input")) {
	                    errorId = that._findMessageContainer(input.attr(NAME))
	                        .add(input.next("." + INVALIDMSG))
	                        .attr("id");

	                    that._associateMessageContainer(input, errorId);
	                }
	            }
	        },

	        _errorsByName: function() {
	            var that = this,
	                inputNames = that._getInputNames(),
	                sorted = [];

	            for (var i = 0; i < inputNames.length; i += 1) {
	                var name = inputNames[i];

	                if (that._errors[name]) {
	                    sorted.push({
	                        field: name,
	                        message: that._errors[name]
	                    });
	                }
	            }

	            return sorted;
	        },

	        _renderSummary: function() {
	            var that = this,
	                options = this.options.validationSummary,
	                element = this.element,
	                prevElement = element.prev(),
	                container;

	            if (options.container) {
	                container = $(options.container);
	            } else if (prevElement && prevElement.hasClass(VALIDATIONSUMMARY)) {
	                container = prevElement;
	            } else {
	                container = $("<div />").insertBefore(that.element);
	            }

	            container.addClass([VALIDATIONSUMMARY, MESSAGEBOX].join(" "));
	            container.attr("role", "alert");

	            container.on("click" + NS, proxy(that._summaryClick, that));

	            return container;
	        },

	        _summaryClick: function(e) {
	            e.preventDefault();

	            var that = this,
	                link = $(e.target),
	                target = that.element.find("[name='" + link.data("field") +  "']"),
	                nextFocusable;

	            if (!target.length) {
	                return;
	            }

	            nextFocusable = kendo.getWidgetFocusableElement(target);

	            if (nextFocusable) {
	                nextFocusable.focus();
	            }
	        },

	        showValidationSummary: function() {
	            var that = this,
	                summary = that.validationSummary,
	                errors = that._errorsByName(),
	                errorsList;

	            if (!summary) {
	                summary = that.validationSummary = that._renderSummary();
	            }

	            errorsList = parseHtml(that._summaryTemplate({
	                errors: errors
	            }));

	            summary.html(errorsList);

	            summary.toggleClass("k-hidden", !errors.length);
	        },

	        hideValidationSummary: function() {
	            var that = this,
	                summary = that.validationSummary;

	            if (!summary) {
	                return;
	            }

	            summary.addClass("k-hidden");
	        }
	    });

	    kendo.ui.plugin(Validator);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "3ok8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var eventKeys_1 = __webpack_require__("+Y9o");
exports.Events = eventKeys_1.Events;


/***/ }),

/***/ "4/sQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1040);
	module.exports = __webpack_require__(1040);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 967:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CRfZ");

/***/ }),

/***/ 1030:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nce5");

/***/ }),

/***/ 1040:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1030), __webpack_require__(967)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        extend = $.extend,
	        proxy = $.proxy,
	        ToolBar = kendo.ui.ToolBar,
	        Item = kendo.toolbar.Item,

	        CLICK = "click",
	        DROPDOWNCHANGE = "dropDownChange",
	        ACTION = "action";

	    var ImageEditorToolBar = ToolBar.extend({
	        init: function(element, options) {
	            var that = this;

	            that._extendOptions(options);

	            ToolBar.fn.init.call(that, element, options);

	            that._attachEvents();
	            that.toggleTools();
	        },

	        events: ToolBar.fn.events.concat([
	            DROPDOWNCHANGE,
	            ACTION
	        ]),

	        defaultTools: {
	            open: { type: "button", icon: "upload", name: "open", command: "OpenImageEditorCommand", showText: "overflow" },
	            save: { type: "button", icon: "download", name: "save", command: "SaveImageEditorCommand", showText: "overflow", toggleCondition:"canExport" },
	            separator: { type: "separator" },
	            undo: { type: "button", icon: "undo", name: "undo", command: "UndoImageEditorCommand", showText: "overflow", toggleCondition:"undo" },
	            redo: { type: "button", icon: "redo", name: "redo", command: "RedoImageEditorCommand", showText: "overflow", toggleCondition:"redo" },
	            separator1: { type: "separator" },
	            crop: { type: "button", icon: "crop", name: "crop", command: "OpenPaneImageEditorCommand", options: "crop", showText: "overflow", toggleCondition:"canExport"  },
	            resize: { type: "button", icon: "image-resize", name: "resize", command: "OpenPaneImageEditorCommand", options: "resize", showText: "overflow", toggleCondition:"canExport"  },
	            zoomIn: { type: "button", icon: "zoom-in", name: "zoomIn", command: "ZoomImageEditorCommand", showText: "overflow", options: "zoomIn", toggleCondition:"enable"  },
	            zoomOut: { type: "button", icon: "zoom-out", name: "zoomOut", command: "ZoomImageEditorCommand", showText: "overflow", options: "zoomOut", toggleCondition:"enable"  },
	            zoomDropdown: { type: "imageEditorZoomDropDown", name: "zoomDropdown", command: "ZoomImageEditorCommand", text: "Zoom options", toggleCondition:"enable" , items: [
	                { name: "zoomActualSize", icon: "zoom-actual-size", text: "Show actual size", options: "actualSize" },
	                { name: "zoomFitToScreen", icon: "zoom-best-fit", text: "Fit to screen", options: "fitToScreen" }
	            ]}
	        },

	        _attachEvents: function() {
	            var that = this;

	            that.bind(DROPDOWNCHANGE, proxy(that._dropDownChange, that));
	            that.bind(CLICK, proxy(that._click, that));
	        },

	        _extendOptions: function(options) {
	            var that = this,
	                tools = options.items ? options.items : Object.keys(that.defaultTools);

	            that.options = options;

	            that.options.items = that._extendToolsOptions(tools);
	        },

	        _extendToolsOptions: function(tools) {
	            var that = this,
	                messages = that.options.messages;

	            if (!tools.length) {
	                return;
	            }

	            return tools.map(function (tool) {
	                var isBuiltInTool =  $.isPlainObject(tool) && Object.keys(tool).length === 1 && tool.name,
	                    toolOptions, text;

	                tool = isBuiltInTool ? tool.name : tool;
	                toolOptions = $.isPlainObject(tool) ? tool : extend({}, that.defaultTools[tool]);

	                text = messages[toolOptions.name] || toolOptions.text;

	                kendo.deepExtend(toolOptions, {
	                    id: toolOptions.name + "-" + kendo.guid(),
	                    name: toolOptions.name,
	                    text: text,
	                    attributes: {
	                        "aria-label": text,
	                        "title": text,
	                        "data-command": toolOptions.command,
	                        "data-options": toolOptions.options,
	                        "data-toggle": toolOptions.toggleCondition
	                    },
	                    overflow: toolOptions.overflow
	                });

	                if(toolOptions.type === "imageEditorZoomDropDown") {
	                    toolOptions.items = that._extendToolsOptions(toolOptions.items);
	                }

	                return toolOptions;
	            }, that);
	        },

	        _click: function(ev) {
	            var command = $(ev.target).data("command"),
	                options = $(ev.target).data("options");

	            if (!command) {
	                return;
	            }

	            this.action({
	                command: command,
	                options: options
	            });
	        },

	        _dropDownChange: function (ev) {
	            if (!ev.command) {
	                return;
	            }

	            this.action({
	                command: ev.command,
	                options: ev.options
	            });
	        },

	        action: function (args) {
	            this.trigger(ACTION, args);
	        },

	        toggleTools: function (conditions) {
	            var that = this,
	                tools = that.element.find("[data-toggle]");

	            tools.each(function(index, elm){
	                var tool = $(elm),
	                    widget = null,
	                    condition = tool.data("toggle"),
	                    toToggle = conditions && conditions[condition];

	                if (tool.is("[data-role]")) {
	                    widget = kendo.widgetInstance(tool);
	                }

	                if (widget && widget.enable){
	                    widget.enable(toToggle || false);
	                } else {
	                    that.enable(tool, toToggle);
	                }
	            });
	        },

	        destroy: function () {
	            var that = this;

	            if (that.zoomDropdown) {
	                that.zoomDropdown.destroy();
	            }

	            ToolBar.fn.destroy.call(this);
	        }
	    });

	    var ImageEditorZoomDropDown = Item.extend({
	        init: function(options, toolbar) {
	            var that = this,
	                element =  $("<div></div>"),
	                input = $("<input />").attr(options.attributes),
	                template = "<span class=\"k-icon k-i-#:icon#\"></span> #:text#";

	                that.element = element;
	                that.input = input;
	                that.toolbar = toolbar;

	                that.dropDown = new ui.DropDownList(that.input, {
	                    optionLabel: { text: options.text, icon: "" },
	                    dataTextField: "text",
	                    dataSource: options.items,
	                    template: template,
	                    change: proxy(that._change, that)
	                });

	                that.element.append(that.dropDown.wrapper);
	                that.dropDown.list.find(".k-list-optionlabel").hide();

	                that.toolbar.zoomDropdown = that;
	        },
	        _change: function (ev) {
	            var that = this;
	            that.toolbar.trigger(DROPDOWNCHANGE, {
	                command: ev.sender.element.data("command"),
	                options: ev.sender.dataItem().options
	            });
	        },
	        destroy: function(){
	            this.dropDown.destroy();
	        }
	    });

	    kendo.toolbar.registerComponent("imageEditorZoomDropDown", ImageEditorZoomDropDown);

	    extend(kendo.ui, {
	        imageeditor: {
	            ToolBar: ImageEditorToolBar,
	            ZoomDropDown: ImageEditorZoomDropDown
	        }
	    });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "46fC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var setFilterModel_1 = __webpack_require__("jK1P");
var setFilterListItem_1 = __webpack_require__("cvpo");
var virtualList_1 = __webpack_require__("X1NG");
var CheckboxState;
(function (CheckboxState) {
    CheckboxState[CheckboxState["CHECKED"] = 0] = "CHECKED";
    CheckboxState[CheckboxState["UNCHECKED"] = 1] = "UNCHECKED";
    CheckboxState[CheckboxState["INTERMEDIATE"] = 2] = "INTERMEDIATE";
})(CheckboxState || (CheckboxState = {}));
;
var SetFilter = (function (_super) {
    __extends(SetFilter, _super);
    function SetFilter() {
        return _super.call(this) || this;
    }
    SetFilter.prototype.customInit = function () {
        var _this = this;
        var changeFilter = function () {
            _this.onFilterChanged();
        };
        var debounceMs = this.filterParams && this.filterParams.debounceMs != null ? this.filterParams.debounceMs : 0;
        this.debounceFilterChanged = main_1._.debounce(changeFilter, debounceMs);
        this.eCheckedIcon = main_1._.createIconNoSpan('checkboxChecked', this.gridOptionsWrapper, this.filterParams.column);
        this.eUncheckedIcon = main_1._.createIconNoSpan('checkboxUnchecked', this.gridOptionsWrapper, this.filterParams.column);
        this.eIndeterminateCheckedIcon = main_1._.createIconNoSpan('checkboxIndeterminate', this.gridOptionsWrapper, this.filterParams.column);
    };
    SetFilter.prototype.updateCheckboxIcon = function () {
        main_1._.removeAllChildren(this.eSelectAll);
        var icon;
        switch (this.selectAllState) {
            case CheckboxState.INTERMEDIATE:
                icon = this.eIndeterminateCheckedIcon;
                break;
            case CheckboxState.CHECKED:
                icon = this.eCheckedIcon;
                break;
            case CheckboxState.UNCHECKED:
                icon = this.eUncheckedIcon;
                break;
            default:// default happens when initialising for first time
                icon = this.eCheckedIcon;
                break;
        }
        this.eSelectAll.appendChild(icon);
    };
    SetFilter.prototype.setLoading = function (loading) {
        main_1._.setVisible(this.eFilterLoading, loading);
    };
    SetFilter.prototype.initialiseFilterBodyUi = function () {
        var _this = this;
        this.virtualList = new virtualList_1.VirtualList();
        this.context.wireBean(this.virtualList);
        this.getGui().querySelector('#richList').appendChild(this.virtualList.getGui());
        if (main_1.Utils.exists(this.filterParams.cellHeight)) {
            this.virtualList.setRowHeight(this.filterParams.cellHeight);
        }
        this.virtualList.setComponentCreator(this.createSetListItem.bind(this));
        this.model = new setFilterModel_1.SetFilterModel(this.filterParams.colDef, this.filterParams.rowModel, this.filterParams.valueGetter, this.filterParams.doesRowPassOtherFilter, this.filterParams.suppressSorting, function (values) { return _this.setFilterValues(values, true, false); }, this.setLoading.bind(this));
        this.virtualList.setModel(new ModelWrapper(this.model));
        main_1._.setVisible(this.getGui().querySelector('#ag-mini-filter'), !this.filterParams.suppressMiniFilter);
        this.eMiniFilter.value = this.model.getMiniFilter();
        this.addDestroyableEventListener(this.eMiniFilter, 'input', function () { return _this.onMiniFilterChanged(); });
        this.updateCheckboxIcon();
        this.addDestroyableEventListener(this.eSelectAllContainer, 'click', this.onSelectAll.bind(this));
        this.updateSelectAll();
        this.virtualList.refresh();
    };
    SetFilter.prototype.modelFromFloatingFilter = function (from) {
        return [from];
    };
    SetFilter.prototype.refreshFilterBodyUi = function () {
    };
    SetFilter.prototype.createSetListItem = function (value) {
        var _this = this;
        var listItem = new setFilterListItem_1.SetFilterListItem(value, this.filterParams.column);
        this.context.wireBean(listItem);
        listItem.setSelected(this.model.isValueSelected(value));
        listItem.addEventListener(setFilterListItem_1.SetFilterListItem.EVENT_SELECTED, function () {
            _this.onItemSelected(value, listItem.isSelected());
        });
        return listItem;
    };
    // we need to have the gui attached before we can draw the virtual rows, as the
    // virtual row logic needs info about the gui state
    SetFilter.prototype.afterGuiAttached = function (params) {
        this.virtualList.refresh();
        this.eMiniFilter.focus();
    };
    SetFilter.prototype.isFilterActive = function () {
        return this.model.isFilterActive();
    };
    SetFilter.prototype.doesFilterPass = function (params) {
        // if no filter, always pass
        if (this.model.isEverythingSelected() && !this.filterParams.selectAllOnMiniFilter) {
            return true;
        }
        // if nothing selected in filter, always fail
        if (this.model.isNothingSelected() && !this.filterParams.selectAllOnMiniFilter) {
            return false;
        }
        var value = this.filterParams.valueGetter(params.node);
        if (this.filterParams.colDef.keyCreator) {
            value = this.filterParams.colDef.keyCreator({ value: value });
        }
        value = main_1.Utils.makeNull(value);
        if (Array.isArray(value)) {
            for (var i = 0; i < value.length; i++) {
                if (this.model.isValueSelected(value[i])) {
                    return true;
                }
            }
            return false;
        }
        else {
            return this.model.isValueSelected(value);
        }
    };
    SetFilter.prototype.onNewRowsLoaded = function () {
        var keepSelection = this.filterParams && this.filterParams.newRowsAction === 'keep';
        var isSelectAll = this.selectAllState === CheckboxState.CHECKED;
        // default is reset
        this.model.refreshAfterNewRowsLoaded(keepSelection, isSelectAll);
        this.updateSelectAll();
        this.virtualList.refresh();
    };
    //noinspection JSUnusedGlobalSymbols
    /**
     * Public method provided so the user can change the value of the filter once
     * the filter has been already started
     * @param options The options to use.
     * @param selectAll If by default all the values should be selected.
     * @param notify If we should let know the model that the values of the filter have changed
     */
    SetFilter.prototype.setFilterValues = function (options, selectAll, notify) {
        var _this = this;
        if (selectAll === void 0) { selectAll = false; }
        if (notify === void 0) { notify = true; }
        this.model.onFilterValuesReady(function () {
            var keepSelection = _this.filterParams && _this.filterParams.newRowsAction === 'keep';
            var isSelectAll = selectAll || (_this.selectAllState === CheckboxState.CHECKED);
            _this.model.setValuesType(setFilterModel_1.SetFilterModelValuesType.PROVIDED_LIST);
            _this.model.refreshValues(options, keepSelection, isSelectAll);
            _this.updateSelectAll();
            options.forEach(function (option) { return _this.model.selectValue(option); });
            _this.virtualList.refresh();
            if (notify) {
                _this.debounceFilterChanged();
            }
        });
    };
    //noinspection JSUnusedGlobalSymbols
    /**
     * Public method provided so the user can reset the values of the filter once that it has started
     * @param options The options to use.
     */
    SetFilter.prototype.resetFilterValues = function () {
        this.model.setValuesType(setFilterModel_1.SetFilterModelValuesType.NOT_PROVIDED);
        this.onNewRowsLoaded();
    };
    SetFilter.prototype.onAnyFilterChanged = function () {
        this.model.refreshAfterAnyFilterChanged();
        this.virtualList.refresh();
    };
    SetFilter.prototype.bodyTemplate = function () {
        var translate = this.translate.bind(this);
        return "<div ref=\"ag-filter-loading\" class=\"loading-filter ag-hidden\">" + translate('loadingOoo') + "</div>\n                <div>\n                    <div class=\"ag-filter-header-container\" id=\"ag-mini-filter\">\n                        <input class=\"ag-filter-filter\" type=\"text\" placeholder=\"" + translate('searchOoo') + "\"/>\n                    </div>\n                    <div class=\"ag-filter-header-container\">\n                        <label id=\"selectAllContainer\">\n                            <div id=\"selectAll\" class=\"ag-filter-checkbox\"></div><span class=\"ag-filter-value\">(" + translate('selectAll') + ")</span>\n                        </label>\n                    </div>\n                    <div id=\"richList\" class=\"ag-set-filter-list\"></div>                    \n                </div>";
    };
    SetFilter.prototype.updateSelectAll = function () {
        if (this.model.isEverythingSelected()) {
            this.selectAllState = CheckboxState.CHECKED;
        }
        else if (this.model.isNothingSelected()) {
            this.selectAllState = CheckboxState.UNCHECKED;
        }
        else {
            this.selectAllState = CheckboxState.INTERMEDIATE;
        }
        this.updateCheckboxIcon();
    };
    SetFilter.prototype.onMiniFilterChanged = function () {
        var miniFilterChanged = this.model.setMiniFilter(this.eMiniFilter.value);
        if (miniFilterChanged) {
            this.virtualList.refresh();
        }
        this.updateSelectAll();
    };
    SetFilter.prototype.onSelectAll = function (event) {
        main_1._.addAgGridEventPath(event);
        if (this.selectAllState === CheckboxState.CHECKED) {
            this.selectAllState = CheckboxState.UNCHECKED;
        }
        else {
            this.selectAllState = CheckboxState.CHECKED;
        }
        this.doSelectAll();
    };
    SetFilter.prototype.doSelectAll = function () {
        var checked = this.selectAllState === CheckboxState.CHECKED;
        if (checked) {
            this.model.selectEverything();
        }
        else {
            this.model.selectNothing();
        }
        this.virtualList.refresh();
        this.debounceFilterChanged();
        this.updateSelectAll();
    };
    SetFilter.prototype.onItemSelected = function (value, selected) {
        if (selected) {
            this.model.selectValue(value);
        }
        else {
            this.model.unselectValue(value);
        }
        this.updateSelectAll();
        this.debounceFilterChanged();
    };
    SetFilter.prototype.setMiniFilter = function (newMiniFilter) {
        this.model.setMiniFilter(newMiniFilter);
        this.eMiniFilter.value = this.model.getMiniFilter();
    };
    SetFilter.prototype.getMiniFilter = function () {
        return this.model.getMiniFilter();
    };
    SetFilter.prototype.selectEverything = function () {
        this.model.selectEverything();
        this.updateSelectAll();
        this.virtualList.refresh();
    };
    SetFilter.prototype.selectNothing = function () {
        this.model.selectNothing();
        this.updateSelectAll();
        this.virtualList.refresh();
    };
    SetFilter.prototype.unselectValue = function (value) {
        this.model.unselectValue(value);
        this.updateSelectAll();
        this.virtualList.refresh();
    };
    SetFilter.prototype.selectValue = function (value) {
        this.model.selectValue(value);
        this.updateSelectAll();
        this.virtualList.refresh();
    };
    SetFilter.prototype.isValueSelected = function (value) {
        return this.model.isValueSelected(value);
    };
    SetFilter.prototype.isEverythingSelected = function () {
        return this.model.isEverythingSelected();
    };
    SetFilter.prototype.isNothingSelected = function () {
        return this.model.isNothingSelected();
    };
    SetFilter.prototype.getUniqueValueCount = function () {
        return this.model.getUniqueValueCount();
    };
    SetFilter.prototype.getUniqueValue = function (index) {
        return this.model.getUniqueValue(index);
    };
    SetFilter.prototype.serialize = function () {
        return this.model.getModel();
    };
    SetFilter.prototype.parse = function (dataModel) {
        this.model.setModel(dataModel);
        this.updateSelectAll();
        this.virtualList.refresh();
    };
    SetFilter.prototype.resetState = function () {
        this.setMiniFilter(null);
        this.model.setModel(null, true);
        this.selectEverything();
    };
    __decorate([
        main_1.QuerySelector('#selectAll'),
        __metadata("design:type", HTMLInputElement)
    ], SetFilter.prototype, "eSelectAll", void 0);
    __decorate([
        main_1.QuerySelector('#selectAllContainer'),
        __metadata("design:type", HTMLElement)
    ], SetFilter.prototype, "eSelectAllContainer", void 0);
    __decorate([
        main_1.QuerySelector('.ag-filter-filter'),
        __metadata("design:type", HTMLInputElement)
    ], SetFilter.prototype, "eMiniFilter", void 0);
    __decorate([
        main_1.RefSelector('ag-filter-loading'),
        __metadata("design:type", HTMLInputElement)
    ], SetFilter.prototype, "eFilterLoading", void 0);
    return SetFilter;
}(main_1.BaseFilter));
exports.SetFilter = SetFilter;
var ModelWrapper = (function () {
    function ModelWrapper(model) {
        this.model = model;
    }
    ModelWrapper.prototype.getRowCount = function () {
        return this.model.getDisplayedValueCount();
    };
    ModelWrapper.prototype.getRow = function (index) {
        return this.model.getDisplayedValue(index);
    };
    return ModelWrapper;
}());


/***/ }),

/***/ "4Nap":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1090);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1090:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1086), __webpack_require__(1091), __webpack_require__(1092) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "columnmenu",
	    name: "Column Menu",
	    category: "framework",
	    depends: [ "popup", "filtermenu", "menu" ],
	    advanced: true
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        proxy = $.proxy,
	        extend = $.extend,
	        grep = $.grep,
	        map = $.map,
	        inArray = $.inArray,
	        ACTIVE = "k-state-selected",
	        ASC = "asc",
	        DESC = "desc",
	        CHANGE = "change",
	        INIT = "init",
	        OPEN = "open",
	        SELECT = "select",
	        STICK = "stick",
	        UNSTICK= "unstick",
	        POPUP = "kendoPopup",
	        FILTERMENU = "kendoFilterMenu",
	        MENU = "kendoMenu",
	        NS = ".kendoColumnMenu",
	        Widget = ui.Widget;

	    function trim(text) {
	        return kendo.trim(text).replace(/&nbsp;/gi, "");
	    }

	    function toHash(arr, key) {
	        var result = {};
	        var idx, len, current;
	        for (idx = 0, len = arr.length; idx < len; idx ++) {
	            current = arr[idx];
	            result[current[key]] = current;
	        }
	        return result;
	    }

	    function leafColumns(columns) {
	        var result = [];

	        for (var idx = 0; idx < columns.length; idx++) {
	            if (!columns[idx].columns) {
	                result.push(columns[idx]);
	                continue;
	            }
	            result = result.concat(leafColumns(columns[idx].columns));
	        }

	        return result;
	    }

	    function attrEquals(attrName, attrValue) {
	        return "[" + kendo.attr(attrName) + "='" + (attrValue || "").replace(/'/g, "\"") + "']";
	    }

	    function insertElementAt(index, element, container) {
	        if (index > 0) {
	            element.insertAfter(container.children().eq(index - 1));
	        } else {
	            container.prepend(element);
	        }
	    }

	    function columnOccurrences(columns) {
	        var columnDict = {};
	        var signature;

	        for (var i = 0; i < columns.length; i++) {
	            signature = JSON.stringify(columns[i]);

	            if (columnDict[signature]) {
	                columnDict[signature].push(i);
	            } else {
	                columnDict[signature] = [i];
	            }
	        }

	        return columnDict;
	    }

	    function oldColumnOccurrences(renderedListElements, checkBoxes) {
	        var indexAttr = kendo.attr("index");
	        var fieldAttr = kendo.attr("field");
	        var columnDict = {};
	        var signature;
	        var columCheckbox;
	        var index;
	        var field;
	        var title;

	        for (var j = 0; j < renderedListElements.length; j++) {
	            columCheckbox = checkBoxes.eq(j);
	            index = parseInt(columCheckbox.attr(indexAttr), 10);
	            field = columCheckbox.attr(fieldAttr);
	            title = columCheckbox.attr("title");
	            signature = field ? field : title;

	            if (columnDict[signature]) {
	                columnDict[signature].push(index);
	            } else {
	                columnDict[signature] = [index];
	            }
	        }

	        return columnDict;
	    }

	    var ColumnMenu = Widget.extend({
	        init: function(element, options) {
	            var that = this,
	                link;

	            Widget.fn.init.call(that, element, options);

	            element = that.element;
	            options = that.options;
	            that.owner = options.owner;
	            that.dataSource = options.dataSource;

	            that.field = element.attr(kendo.attr("field"));
	            that.title = element.attr(kendo.attr("title"));

	            link = element.find(".k-header-column-menu");

	            if (!link[0]) {
	                link = element.addClass("k-with-icon").prepend('<a class="k-header-column-menu" href="#" title="' +
	                    options.messages.settings + '" aria-label="' +
	                    options.messages.settings + '"><span class="k-icon k-i-more-vertical"></span></a>').find(".k-header-column-menu");
	            }

	            that.link = link
	                .attr("tabindex", -1)
	                .on("click" + NS, proxy(that._click, that));

	            that.wrapper = $('<div class="k-column-menu"/>');

	            that._refreshHandler = proxy(that.refresh, that);

	            that.dataSource.bind(CHANGE, that._refreshHandler);
	        },

	        _init: function() {
	            var that = this;

	            that.pane = that.options.pane;
	            if (that.pane) {
	                that._isMobile = true;
	            }

	            if (that._isMobile) {
	                that._createMobileMenu();
	            } else {
	                that._createMenu();
	            }

	            that.owner._muteAngularRebind(function() {
	                that._angularItems("compile");
	            });

	            that._sort();

	            that._columns();

	            that._filter();

	            that._lockColumns();

	            that._stickyColumns();

	            that.trigger(INIT, { field: that.field, container: that.wrapper });
	        },

	        events: [ INIT, OPEN, "sort", "filtering", STICK, UNSTICK ],

	        options: {
	            name: "ColumnMenu",
	            messages: {
	                sortAscending: "Sort Ascending",
	                sortDescending: "Sort Descending",
	                filter: "Filter",
	                column: "Column",
	                columns: "Columns",
	                columnVisibility: "Column Visibility",
	                clear: "Clear",
	                cancel: "Cancel",
	                done: "Done",
	                settings: "Edit Column Settings",
	                lock: "Lock Column",
	                unlock: "Unlock Column",
	                stick: "Stick Column",
	                unstick: "Unstick Column",
	                setColumnPosition: "Set Column Position"
	            },
	            filter: "",
	            columns: true,
	            sortable: true,
	            filterable: true,
	            animations: {
	                left: "slide"
	            },
	            encodeTitles: false
	        },

	        _createMenu: function() {
	            var that = this,
	                options = that.options;

	            that.wrapper.html(kendo.template(template)({
	                uid: kendo.guid(),
	                ns: kendo.ns,
	                messages: options.messages,
	                sortable: options.sortable,
	                filterable: options.filterable,
	                columns: that._ownerColumns(),
	                showColumns: options.columns,
	                hasLockableColumns: options.hasLockableColumns,
	                hasStickableColumns: options.hasStickableColumns,
	                encodeTitles: options.encodeTitles
	            }));

	            that.popup = that.wrapper[POPUP]({
	                anchor: that.link,
	                copyAnchorStyles: false,
	                open: proxy(that._open, that),
	                activate: proxy(that._activate, that),
	                deactivate: proxy(that._deactivate, that),
	                close: function() {
	                    that.menu._closing = true;
	                    if (that.options.closeCallback) {
	                        that.options.closeCallback(that.element);
	                    }
	                }
	            }).data(POPUP);

	            that.menu = that.wrapper.children()[MENU]({
	                orientation: "vertical",
	                closeOnClick: false,
	                open: function() {
	                    that._updateMenuItems();
	                }
	            }).data(MENU);
	        },

	        _deactivate: function() {
	            this.menu._closing = false;
	        },

	        _createMobileMenu: function() {
	            var that = this,
	                options = that.options;

	            var html = kendo.template(mobileTemplate)({
	                ns: kendo.ns,
	                field: that.field,
	                title: that.title || that.field,
	                messages: options.messages,
	                sortable: options.sortable,
	                filterable: options.filterable,
	                columns: that._ownerColumns(),
	                showColumns: options.columns,
	                hasLockableColumns: options.hasLockableColumns,
	                hasStickableColumns: options.hasStickableColumns
	            });

	            that.view = that.pane.append(html);
	            that.view.state = { columns: {} };

	            that.wrapper = that.view.element.find(".k-column-menu");

	            that.menu = new MobileMenu(that.wrapper.children(), {
	                pane: that.pane,
	                columnMenu: that
	            });

	            // The toggle animation of the switches should not propagate to the view
	            that.menu.element.on("transitionend" + NS, function(e) {
	                e.stopPropagation();
	            });

	            var viewElement = that.view.wrapper && that.view.wrapper[0] ? that.view.wrapper : that.view.element;

	            viewElement.on("click", ".k-header-done", function(e) {
	                e.preventDefault();

	                that.menu._applyChanges();
	                that.menu._cancelChanges(false);
	                that.close();
	            });

	            viewElement.on("click", ".k-header-cancel", function(e) {
	                e.preventDefault();

	                that.menu._cancelChanges(true);
	                that.close();
	            });

	            that.view.bind("showStart", function() {
	                var view = that.view || { columns: {} };

	                if (that.options.hasLockableColumns) {
	                    that._updateLockedColumns();
	                }

	                if (that.options.hasStickableColumns) {
	                    that._updateStickyColumns();
	                }

	                if (view.element.find(".k-sort-asc.k-state-selected").length) {
	                    view.state.initialSort = "asc";
	                } else if (view.element.find(".k-sort-desc.k-state-selected").length) {
	                    view.state.initialSort = "desc";
	                }
	            });
	        },

	        _angularItems: function(action) {
	            var that = this;
	            that.angular(action, function(){
	                var items = that.wrapper.find(".k-columns-item input[" + kendo.attr("field") + "]").map(function(){
	                    return $(this).closest("li");
	                });
	                var data = map(that._ownerColumns(), function(col){
	                    return { column: col._originalObject };
	                });
	                return {
	                    elements: items,
	                    data: data
	                };
	            });
	        },

	        destroy: function() {
	            var that = this;

	            that._angularItems("cleanup");

	            Widget.fn.destroy.call(that);

	            if (that.filterMenu) {
	                that.filterMenu.destroy();
	            }

	            if (that._refreshHandler) {
	                that.dataSource.unbind(CHANGE, that._refreshHandler);
	            }

	            if (that.options.columns && that.owner) {
	                if (that._updateColumnsMenuHandler) {
	                    that.owner.unbind("columnShow", that._updateColumnsMenuHandler);
	                    that.owner.unbind("columnHide", that._updateColumnsMenuHandler);
	                }

	                if (that._updateColumnsLockedStateHandler) {
	                    that.owner.unbind("columnLock", that._updateColumnsLockedStateHandler);
	                    that.owner.unbind("columnUnlock", that._updateColumnsLockedStateHandler);
	                }
	            }

	            if (that.menu) {
	                that.menu.element.off(NS);
	                that.menu.destroy();
	            }

	            that.wrapper.off(NS);

	            if (that.popup) {
	                that.popup.destroy();
	            }

	            if (that.view) {
	                that.view.purge();
	            }

	            that.link.off(NS);
	            that.owner = null;
	            that.wrapper = null;
	            that.element = null;
	        },

	        close: function() {
	            this.menu.close();
	            if (this.popup) {
	                this.popup.close();
	                this.popup.element.off("keydown" + NS);
	            }
	        },

	        _click: function(e) {
	            var that = this;

	            e.preventDefault();
	            e.stopPropagation();

	            var options = this.options;

	            if (options.filter && this.element.is(!options.filter)) {
	                return;
	            }

	            if (!this.popup && !this.pane) {
	                this._init();
	            } else {
	                that._updateMenuItems();
	            }

	            if (this._isMobile) {
	                this.pane.navigate(this.view, this.options.animations.left);
	            } else {
	                this.popup.toggle();
	            }
	        },

	        _updateMenuItems: function() {
	            var that = this;
	            if (that.options.columns) {
	                that._setMenuItemsVisibility();
	                if (!that.options.columns.sort) {
	                    that._reorderMenuItems();
	                } else {
	                    that._updateDataIndexes();
	                }
	            }
	        },

	        _setMenuItemsVisibility: function() {
	            var that = this;

	            that._eachRenderedMenuItem(function(index, column, renderedListElement) {
	                if (column.matchesMedia === false) {
	                    renderedListElement.hide();
	                } else {
	                    renderedListElement.show();
	                }
	            });
	        },

	        _reorderMenuItems: function() {
	            var that = this;

	            that._eachRenderedMenuItem(function(index, column, renderedListElement, renderedList) {
	                if (renderedListElement[0] && renderedListElement.index() !== index) {
	                    insertElementAt(index, renderedListElement, renderedList);
	                }
	            });
	            that._updateDataIndexes();
	        },

	        _updateDataIndexes: function () {
	            var that = this;
	            var renderedList = that._isMobile && that.view ?
	                $(that.view.element).find(".k-columns-item").children("ul") :
	                $(that.wrapper).find(".k-menu-group").first(),
	                mappedColumns = that._ownerColumns(true).map(function(x) {
	                    return x.title || x.field;
	                });

	            renderedList.find("span." + (this._isMobile ? "k-listgroup-form-field-wrapper" : "k-menu-link") +
	                " input").each(function (i) {
	                var columns;
	                var index;
	                if (that.options.columns.sort) {
	                    columns = that._ownerColumns();
	                    index = mappedColumns.indexOf(columns[i].title);
	                    $(this).attr(kendo.attr("index"), index);
	                } else {
	                    $(this).attr(kendo.attr("index"), i);
	                }
	            });
	        },

	        _eachRenderedMenuItem: function(callback) {
	            var that = this;
	            var renderedListElement;
	            var duplicateColumnIndex;
	            var fieldValue;
	            var currentColumn;
	            var columns = grep(leafColumns(that.owner.columns), function(col) {
	                var result = true,
	                    title = trim(col.title || "");

	                if (col.menu === false || (!col.field && !title.length)) {
	                    result = false;
	                }

	                return result;
	            }).map(function(col) {
	                return  {
	                     field: col.field,
	                     title: col.title,
	                     matchesMedia: col.matchesMedia
	                   };
	            });
	            var renderedList = that._isMobile && that.view ?
	                $(that.view.element).find(".k-columns-item").children("ul") :
	                $(that.wrapper).find(".k-menu-group").first();

	            var renderedListElements = renderedList.find("span." + (this._isMobile ? "k-listgroup-form-field-wrapper" : "k-menu-link"));
	            var oldOccurances = oldColumnOccurrences(renderedListElements, renderedList.find("input[type=checkbox]"));
	            var columnOccurrence = columnOccurrences(columns);
	            var columnElements;

	            for (var i = 0; i < columns.length; i++) {
	                currentColumn = columns[i];
	                fieldValue = currentColumn.field ? currentColumn.field : currentColumn.title;
	                duplicateColumnIndex = $.inArray(i, columnOccurrence[JSON.stringify(currentColumn)]);
	                columnElements = $();

	                for (var idx = 0; idx < oldOccurances[fieldValue].length; idx++) {
	                    columnElements = columnElements.add(renderedListElements.eq(oldOccurances[fieldValue][idx]));
	                }
	                renderedListElement = columnElements.find(attrEquals("field", fieldValue)).closest("li").eq(duplicateColumnIndex);
	                callback(i, currentColumn, renderedListElement, renderedList);
	            }
	        },

	        _open: function() {
	            var that = this;
	            $(".k-column-menu").not(that.wrapper).each(function() {
	                $(this).data(POPUP).close();
	            });
	            that.popup.element.on("keydown" + NS, function(e) {
	                if (e.keyCode == kendo.keys.ESC) {
	                    that.close();
	                }
	            });

	            if (that.options.hasLockableColumns) {
	                that._updateLockedColumns();
	            }

	            if (that.options.hasStickableColumns) {
	                that._updateStickyColumns();
	            }
	        },

	        _activate: function() {
	            this.menu.element.focus();

	            this.trigger(OPEN, { field: this.field, container: this.wrapper });
	        },

	        _ownerColumns: function(omitSort) {
	            var columns = leafColumns(this.owner.columns),
	                menuColumns = grep(columns, function(col) {
	                    var result = true,
	                        title = trim(col.title || "");

	                    if (col.menu === false || (!col.field && !title.length)) {
	                        result = false;
	                    }

	                    return result;
	                }),
	                result,
	                sort = this.options.columns.sort;

	            result = map(menuColumns, function(col) {
	                return {
	                    originalField: col.field,
	                    field: col.field || col.title,
	                    title: col.title || col.field,
	                    hidden: col.hidden,
	                    matchesMedia: col.matchesMedia,
	                    index: inArray(col, columns),
	                    locked: !!col.locked,
	                    _originalObject: col,
	                    uid: col.headerAttributes.id
	                };
	            });

	            if (sort && !omitSort) {
	                result.sort(function(a,b) {
	                    if ( a.title < b.title ) {
	                        return sort === "asc" ? -1 : 1;
	                      }
	                      if ( a.title > b.title ) {
	                        return sort === "asc" ? 1 : -1;
	                      }
	                      return 0;
	                });
	            }

	            return result;
	        },

	        _sort: function() {
	            var that = this;

	            if (that.options.sortable) {
	                that.refresh();

	                that.menu.bind(SELECT, function(e) {
	                    var item = $(e.item),
	                        dir;

	                    if (item.hasClass("k-sort-asc")) {
	                        dir = ASC;
	                    } else if (item.hasClass("k-sort-desc")) {
	                        dir = DESC;
	                    }

	                    if (!dir) {
	                        return;
	                    }

	                    item.parent().find(".k-sort-" + (dir == ASC ? DESC : ASC)).removeClass(ACTIVE);

	                    that._sortDataSource(item, dir);

	                    if (!that._isMobile) {
	                        that.close();
	                    }
	                });
	            }
	        },

	        _sortDataSource: function(item, dir) {
	            var that = this,
	                sortable = that.options.sortable,
	                compare = sortable.compare === null ? undefined : sortable.compare,
	                dataSource = that.dataSource,
	                idx,
	                length,
	                sort = dataSource.sort() || [];

	            var removeClass = item.hasClass(ACTIVE) && sortable && sortable.allowUnsort !== false;

	            dir = !removeClass ? dir : undefined;

	            if (that.trigger("sort", { sort: { field: that.field, dir: dir, compare: compare } })) {
	                return;
	            }

	            if (removeClass) {
	                item.removeClass(ACTIVE);
	            } else {
	                item.addClass(ACTIVE);
	            }

	            if (sortable.mode === "multiple") {
	                for (idx = 0, length = sort.length; idx < length; idx++) {
	                    if (sort[idx].field === that.field) {
	                        sort.splice(idx, 1);
	                        break;
	                    }
	                }
	                sort.push({ field: that.field, dir: dir, compare: compare });
	            } else {
	                sort = [ { field: that.field, dir: dir, compare: compare} ];
	            }

	            dataSource.sort(sort);
	        },

	        _columns: function() {
	            var that = this;

	            if (that.options.columns) {

	                that._updateColumnsMenu();

	                that._updateColumnsMenuHandler = proxy(that._updateColumnsMenu, that);

	                that.owner.bind(["columnHide", "columnShow"], that._updateColumnsMenuHandler);

	                that._updateColumnsLockedStateHandler = proxy(that._updateColumnsLockedState, that);

	                that.owner.bind(["columnUnlock", "columnLock" ], that._updateColumnsLockedStateHandler);

	                that.menu.bind(SELECT, function(e) {
	                    var item = $(e.item),
	                        input,
	                        column,
	                        indexAttr = kendo.attr("index"),
	                        columnIndexMap = {},
	                        columnsCount = 0,
	                        columns = grep(leafColumns(that.owner.columns), function(col, idx) {
	                            var result = true,
	                                title = trim(col.title || "");

	                            if (col.menu === false || (!col.field && !title.length)) {
	                                result = false;
	                            }

	                            if (result) {
	                                columnIndexMap[idx] = columnsCount;
	                                columnsCount++;
	                            }

	                            return result;
	                        });

	                    if (that._isMobile) {
	                        e.preventDefault();
	                    }

	                    if (!item.parent().closest("li.k-columns-item")[0]) {
	                        return;
	                    }

	                    input = item.find(":checkbox");
	                    if (input.attr("disabled")) {
	                        return;
	                    }

	                    column = columns[parseInt(input.attr(indexAttr), 10)];

	                    if (column.hidden === true) {
	                        that.owner.showColumn(column);
	                    } else {
	                        that.owner.hideColumn(column);
	                    }
	                });
	            }
	        },

	        _updateColumnsMenu: function() {
	            var idx, length, current, checked, locked;
	            var fieldAttr = kendo.attr("field"),
	                lockedAttr = kendo.attr("locked"),
	                uidAttr = kendo.attr("uid"),
	                columnIndexMap = {},
	                columnsCount = 0,
	                colIdx = 0,
	                columnsInMenu = grep(leafColumns(this.owner.columns), function(col, idx) {
	                    var result = true,
	                        title = trim(col.title || "");

	                    if (col.menu === false || (!col.field && !title.length)) {
	                        result = false;
	                    }

	                    if (result) {
	                        columnIndexMap[idx] = columnsCount;
	                        columnsCount++;
	                    }

	                    return result;
	                }),
	                visibleFields = grep(this._ownerColumns(), function(field) {
	                    return !field.hidden && field.matchesMedia !== false;
	                }),
	                visibleDataFields = grep(visibleFields, function(field) {
	                    return field.originalField;
	                }),
	                lockedCount = grep(visibleDataFields, function(col) {
	                    return col.locked === true;
	                }).length,
	                nonLockedCount = grep(visibleDataFields, function(col) {
	                    return col.locked !== true;
	                }).length,
	                columnsNotInMenu = grep(this.owner.columns, function(col) {
	                    return col.menu === false;
	                }),
	                hiddenColumnsNotInMenu = grep(columnsNotInMenu, function(col) {
	                    return col.hidden;
	                });

	            this.wrapper.find("[role='menuitemcheckbox']").attr("aria-checked", false);

	            var checkboxes = this.wrapper
	                .find(".k-columns-item input[" + fieldAttr + "]")
	                .prop("disabled", false)
	                .prop("checked", false);
	            var switchWidget;

	            for (idx = 0, length = checkboxes.length; idx < length; idx ++) {
	                current = checkboxes.eq(idx);
	                locked = current.attr(lockedAttr) === "true";
	                checked = false;
	                switchWidget = current.data("kendoSwitch");
	                colIdx = columnsInMenu.map(function (col) {
	                    return col.headerAttributes.id;
	                }).indexOf(current.attr(uidAttr));

	                checked = !columnsInMenu[colIdx].hidden && columnsInMenu[colIdx].matchesMedia !== false;
	                current.prop("checked", checked);

	                if (switchWidget) {
	                    switchWidget.enable(true);
	                    switchWidget.check(checked);
	                }

	                current.closest("[role='menuitemcheckbox']").attr("aria-checked", checked);

	                if (checked) {
	                    if (lockedCount == 1 && locked) {
	                        current.prop("disabled", true);

	                        if (switchWidget) {
	                            switchWidget.enable(false);
	                        }
	                    }

	                    if ((columnsNotInMenu.length === 0 || (columnsNotInMenu.length ===  hiddenColumnsNotInMenu.length)) && nonLockedCount == 1 && !locked) {
	                        current.prop("disabled", true);

	                        if (switchWidget) {
	                            switchWidget.enable(false);
	                        }
	                    }
	                }
	            }
	        },

	        _updateColumnsLockedState: function() {
	            var idx, length, current, column;
	            var fieldAttr = kendo.attr("field");
	            var lockedAttr = kendo.attr("locked");
	            var columns = toHash(this._ownerColumns(), "field");
	            var checkboxes = this.wrapper
	                .find(".k-columns-item input[type=checkbox]");

	            for (idx = 0, length = checkboxes.length; idx < length; idx ++ ) {
	                current = checkboxes.eq(idx);
	                column = columns[current.attr(fieldAttr)];
	                if (column) {
	                    current.attr(lockedAttr, column.locked);
	                }
	            }

	            this._updateColumnsMenu();
	        },

	        _filter: function() {
	            var that = this,
	                widget = FILTERMENU,
	                options = that.options;

	            if (options.filterable !== false) {

	                if (options.filterable.multi) {
	                    widget = "kendoFilterMultiCheck";
	                    if (options.filterable.dataSource) {
	                        options.filterable.checkSource = options.filterable.dataSource;
	                        delete options.filterable.dataSource;
	                    }
	                }
	                that.filterMenu = that.wrapper.find(".k-filterable")[widget](
	                    extend(true, {}, {
	                        appendToElement: true,
	                        dataSource: options.dataSource,
	                        values: options.values,
	                        field: that.field,
	                        title: that.title,
	                        change: function(e) {
	                            if (that.trigger("filtering", { filter: e.filter, field: e.field })) {
	                                e.preventDefault();
	                            }
	                        }
	                    },
	                    options.filterable)
	                    ).data(widget);

	                if (that._isMobile) {
	                    that.menu.bind(SELECT, function(e) {
	                        var item = $(e.item);

	                        if (item.hasClass("k-filter-item")) {
	                            that.pane.navigate(that.filterMenu.view, that.options.animations.left);
	                        }
	                    });
	                }
	            }
	        },

	        _lockColumns: function() {
	            var that = this;
	            that.menu.bind(SELECT, function(e) {
	                var item = $(e.item);

	                if (item.hasClass("k-lock")) {
	                    that.owner.lockColumn(that.field);
	                    if (!that._isMobile) {
	                        that.close();
	                    }
	                } else if (item.hasClass("k-unlock")) {
	                    that.owner.unlockColumn(that.field);
	                    if (!that._isMobile) {
	                        that.close();
	                    }
	                }
	            });
	        },

	        _stickyColumns: function() {
	            var that = this;
	            that.menu.bind(SELECT, function(e) {
	                var item = $(e.item);
	                var field = that.field;
	                var columns = that.owner.columns;
	                var column = grep(columns, function(column) {
	                    return column.field == field || column.title == field;
	                })[0];

	                if (item.hasClass("k-stick")) {
	                    that.owner.stickColumn(that.field);
	                    that.trigger(STICK, { column: column });
	                    if (!that._isMobile) {
	                        that.close();
	                    }
	                } else if (item.hasClass("k-unstick")) {
	                    that.owner.unstickColumn(that.field);
	                    that.trigger(UNSTICK, { column: column });
	                    if (!that._isMobile) {
	                        that.close();
	                    }
	                }
	            });
	        },

	        _updateLockedColumns: function() {
	            var field = this.field;
	            var columns = this.owner.columns;
	            var column = grep(columns, function(column) {
	                return column.field == field || column.title == field;
	            })[0];

	            if (!column) {
	                return;
	            }

	            var locked = column.locked === true;
	            var length = grep(columns, function(column) {
	                return !column.hidden && ((column.locked && locked) || (!column.locked && !locked));
	            }).length;
	            var notLockable = column.lockable === false;

	            var lockItem = this.wrapper.find(".k-lock").removeClass("k-state-disabled");
	            var unlockItem = this.wrapper.find(".k-unlock").removeClass("k-state-disabled");

	            if (locked || length == 1 || notLockable) {
	                lockItem.addClass("k-state-disabled");
	            }

	            if (!locked || length == 1 || notLockable) {
	                unlockItem.addClass("k-state-disabled");
	            }

	            this._updateColumnsLockedState();
	        },

	        _updateStickyColumns: function() {
	            var field = this.field;
	            var columns = this.owner.columns;
	            var column = grep(columns, function(column) {
	                return column.field == field || column.title == field;
	            })[0];

	            if (!column) {
	                return;
	            }

	            var sticky = column.sticky === true;
	            var stickable  = column.stickable  === true;
	            var locked = column.locked === true;
	            var length = grep(columns, function(column) {
	                return !column.hidden && ((column.locked && locked) || (!column.locked && !locked));
	            }).length;

	            var stickItem = this.wrapper.find(".k-stick").removeClass("k-state-disabled");
	            var unstickItem = this.wrapper.find(".k-unstick").removeClass("k-state-disabled");

	            if (sticky || !stickable || (locked && length === 1)) {
	                stickItem.addClass("k-state-disabled");
	            }

	            if (!sticky || !stickable) {
	                unstickItem.addClass("k-state-disabled");
	            }
	        },

	        refresh: function() {
	            var that = this,
	                sort = that.options.dataSource.sort() || [],
	                descriptor,
	                field = that.field,
	                idx,
	                length;

	            that.wrapper.find(".k-sort-asc, .k-sort-desc").removeClass(ACTIVE);

	            for (idx = 0, length = sort.length; idx < length; idx++) {
	               descriptor = sort[idx];

	               if (field == descriptor.field) {
	                    that.wrapper.find(".k-sort-" + descriptor.dir).addClass(ACTIVE);
	               }
	            }

	            that.link[that._filterExist(that.dataSource.filter()) ? "addClass" : "removeClass"]("k-state-active");
	        },

	        _filterExist: function(filters) {
	            var found = false;
	            var filter;

	            if (!filters) {
	                return;
	            }

	            filters = filters.filters;

	            for (var idx = 0, length = filters.length; idx < length; idx++) {
	                filter = filters[idx];

	                if (filter.field == this.field) {
	                    found = true;
	                } else if (filter.filters) {
	                    found = found || this._filterExist(filter);
	                }
	            }

	            return found;
	        }
	    });

	    var template = '<ul id="#=uid#">'+
	                    '#if(sortable){#'+
	                        '<li class="k-item k-menu-item k-sort-asc"><span class="k-link k-menu-link"><span class="k-icon k-i-sort-asc-sm"></span>${messages.sortAscending}</span></li>'+
	                        '<li class="k-item k-menu-item k-sort-desc"><span class="k-link k-menu-link"><span class="k-icon k-i-sort-desc-sm"></span>${messages.sortDescending}</span></li>'+
	                        '#if(showColumns || filterable){#'+
	                            '<li class="k-separator k-menu-separator" role="presentation"></li>'+
	                        '#}#'+
	                    '#}#'+
	                    '#if(showColumns){#'+
	                        '<li class="k-item k-menu-item k-columns-item" aria-haspopup="true"><span class="k-link k-menu-link"><span class="k-icon k-i-columns"></span>${messages.columns}</span><ul>'+
	                        '#for (var idx = 0; idx < columns.length; idx++) {#'+
	                            '<li role="menuitemcheckbox" aria-checked="false" #=columns[idx].matchesMedia === false ? "style=\'display:none;\'" : ""#><input type="checkbox" title="#=encodeTitles ? kendo.htmlEncode(columns[idx].title) : columns[idx].title#" data-#=ns#field="#=columns[idx].field.replace(/\"/g,"&\\#34;")#" data-#=ns#index="#=columns[idx].index#" data-#=ns#locked="#=columns[idx].locked#" data-#=ns#uid="#=columns[idx].uid#"/>#=encodeTitles ? kendo.htmlEncode(columns[idx].title) : columns[idx].title#</li>'+
	                        '#}#'+
	                        '</ul></li>'+
	                        '#if(filterable || hasLockableColumns || hasStickableColumns){#'+
	                            '<li class="k-separator k-menu-separator" role="presentation"></li>'+
	                        '#}#'+
	                    '#}#'+
	                    '#if(filterable){#'+
	                        '<li class="k-item k-menu-item k-filter-item" aria-haspopup="true"><span class="k-link k-menu-link"><span class="k-icon k-i-filter"></span>${messages.filter}</span><ul>'+
	                            '<li><div class="k-filterable"></div></li>'+
	                        '</ul></li>'+
	                        '#if(hasLockableColumns || hasStickableColumns){#'+
	                            '<li class="k-separator k-menu-separator" role="presentation"></li>'+
	                        '#}#'+
	                    '#}#'+
	                    '#if(hasLockableColumns || hasStickableColumns){#'+
	                        '<li class="k-item k-menu-item k-position-item" aria-haspopup="true"><span class="k-link k-menu-link"><span class="k-icon k-i-set-column-position"></span>${messages.setColumnPosition}</span><ul>'+
	                            '#if(hasLockableColumns){#'+
	                                '<li class="k-item k-menu-item k-lock"><span class="k-link k-menu-link"><span class="k-icon k-i-lock"></span>${messages.lock}</span></li>'+
	                                '<li class="k-item k-menu-item k-unlock"><span class="k-link k-menu-link"><span class="k-icon k-i-unlock"></span>${messages.unlock}</span></li>'+
	                                '#if(hasStickableColumns){#'+
	                                    '<li class="k-separator k-menu-separator" role="presentation"></li>'+
	                                '#}#'+
	                            '#}#'+
	                            '#if(hasStickableColumns){#'+
	                                '<li class="k-item k-menu-item k-stick"><span class="k-link k-menu-link"><span class="k-icon k-i-stick"></span>${messages.stick}</span></li>'+
	                                '<li class="k-item k-menu-item k-unstick"><span class="k-link k-menu-link"><span class="k-icon k-i-unstick"></span>${messages.unstick}</span></li>'+
	                            '#}#'+
	                        '</ul></li>'+
	                    '#}#'+
	                    '</ul>';

	    var mobileTemplate =
	            '<div data-#=ns#role="view" class="k-grid-column-menu">' +
	                '<div data-#=ns#role="header" class="k-header">' +
	                    '<a href="\\#" class="k-header-cancel k-link" title="#=messages.cancel#" ' +
	                    'aria-label="#=messages.cancel#"><span class="k-icon k-i-arrow-chevron-left"></span></a>' +
	                    '${messages.settings}' +
	                    '<a href="\\#" class="k-header-done k-link" title="#=messages.done#" ' +
	                    'aria-label="#=messages.done#"><span class="k-icon k-i-check"></span></a>' +
	                '</div>' +
	                '<div class="k-column-menu">' +
	                    '<ul class="k-reset">' +
	                        '<li>' +
	                            '<span class="k-list-title">#=messages.column#: ${title}</span>' +
	                            '<ul class="k-listgroup k-listgroup-flush">' +
	                                '#if(sortable){#' +
	                                    '<li id="#=kendo.guid()#" class="k-item k-listgroup-item k-sort-asc"><span class="k-link"><span class="k-icon k-i-sort-asc-sm"></span><span class="k-item-title">${messages.sortAscending}</span></span></li>' +
	                                    '<li id="#=kendo.guid()#" class="k-item k-listgroup-item k-sort-desc"><span class="k-link"><span class="k-icon k-i-sort-desc-sm"></span><span class="k-item-title">${messages.sortDescending}</span></span></li>' +
	                                '#}#' +
	                                '#if(hasLockableColumns){#' +
	                                    '<li id="#=kendo.guid()#" class="k-item k-listgroup-item k-lock"><span class="k-link"><span class="k-icon k-i-lock"></span><span class="k-item-title">${messages.lock}</span></span></li>' +
	                                    '<li id="#=kendo.guid()#" class="k-item k-listgroup-item k-unlock"><span class="k-link"><span class="k-icon k-i-unlock"></span><span class="k-item-title">${messages.unlock}</span></span></li>' +
	                                '#}#' +
	                                '#if(hasStickableColumns){#' +
	                                    '<li id="#=kendo.guid()#" class="k-item k-listgroup-item k-stick"><span class="k-link"><span class="k-icon k-i-stick"></span><span class="k-item-title">${messages.stick}</span></span></li>' +
	                                    '<li id="#=kendo.guid()#" class="k-item k-listgroup-item k-unstick"><span class="k-link"><span class="k-icon k-i-unstick"></span><span class="k-item-title">${messages.unstick}</span></span></li>' +
	                                '#}#' +
	                                '#if(filterable){#' +
	                                    '<li id="#=kendo.guid()#" class="k-item k-listgroup-item k-filter-item">' +
	                                        '<span class="k-link k-filterable">' +
	                                            '<span class="k-icon k-i-filter"></span>' +
	                                            '<span class="k-item-title">${messages.filter}</span>' +
	                                            '<span class="k-select"><span class="k-icon k-i-arrow-chevron-right"></span></span>' +
	                                        '</span>' +
	                                    '</li>' +
	                                '#}#' +
	                            '</ul>' +
	                        '</li>' +
	                        '#if(showColumns){#' +
	                        '<li class="k-columns-item"><span class="k-list-title">${messages.columnVisibility}</span>' +
	                            '<ul class="k-listgroup k-listgroup-flush">' +
	                            '#for (var idx = 0; idx < columns.length; idx++) {#' +
	                                '<li id="#=kendo.guid()#" class="k-item k-listgroup-item">' +
	                                    '<span class="k-listgroup-form-row">' +
	                                        '<span class="k-listgroup-form-field-label k-item-title">' +
	                                            '#=columns[idx].title#' +
	                                        '</span>' +
	                                        '<span class="k-listgroup-form-field-wrapper">' +
	                                            '<input type="checkbox" title="#=columns[idx].title#" ' +
	                                                ' data-#=ns#field="#=columns[idx].field.replace(/\"/g,"&\\#34;")#"' +
	                                                ' data-#=ns#index="#=columns[idx].index#"' +
	                                                ' data-#=ns#uid="#=columns[idx].uid#"' +
	                                                ' data-#=ns#locked="#=columns[idx].locked#" />' +
	                                        '</span>' +
	                                    '</span>' +
	                                '</li>' +
	                            '#}#' +
	                            '</ul>' +
	                        '</li>'+
	                        '#}#'+
	                        '<li class="k-item k-clear-wrap">' +
	                            '<span class="k-list-title">&nbsp;</span>' +
	                            '<ul class="k-listgroup k-listgroup-flush">' +
	                                '<li class="k-listgroup-item">' +
	                                    '<span class="k-link k-label k-clear" title="#=messages.clear#" aria-label="#=messages.clear#">' +
	                                        '#=messages.clear#' +
	                                    '</span>' +
	                                '</li>' +
	                            '</ul>' +
	                        '</li>' +
	                    '</ul>' +
	                '</div>'+
	            '</div>';

	    var MobileMenu = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            that._createCheckBoxes();

	            that.element.on("click" + NS, "li.k-item:not(.k-separator):not(.k-state-disabled):not(:has(.k-switch))", "_click");
	        },

	        events: [ SELECT ],

	        _click: function(e) {
	            var that = this;

	            if (!$(e.target).is("[type=checkbox]")) {
	                e.preventDefault();
	            }

	            if ($(e.target).hasClass("k-clear")) {
	                that._cancelChanges(true);

	                return;
	            }

	            if ($(e.target).hasClass("k-filterable")) {
	                that._cancelChanges(true);
	                that.trigger(SELECT, { item: e.currentTarget });

	                return;
	            }

	            that._updateSelectedItems(e.currentTarget);
	        },

	        _updateSelectedItems: function(el) {
	            var that = this;
	            var item = $(el);
	            var state = that.options.columnMenu.view.state || { columns: {} };
	            var id = item.prop("id");

	            if (item.hasClass("k-filter-item")) {
	                return;
	            }

	            if (state[id]) {
	                state[id] = false;
	            } else {
	                state[id] = true;
	            }

	            if (item.hasClass("k-sort-asc") || item.hasClass("k-sort-desc")) {
	                var dir;
	                var otherItem;
	                var otherItemId;

	                if (item.hasClass("k-sort-asc")) {
	                    dir = "asc";
	                    otherItem = that.element.find(".k-sort-desc");
	                } else {
	                    dir = "desc";
	                    otherItem = that.element.find(".k-sort-asc");
	                }

	                otherItemId = otherItem.prop("id");

	                if (dir === state.initialSort && !item.hasClass("k-state-selected")) {
	                    state[id] = false;
	                }

	                if (state[otherItemId]) {
	                    state[otherItemId] = false;
	                }

	                otherItem.removeClass(ACTIVE);
	            }

	            if (item.hasClass(ACTIVE)) {
	                item.removeClass(ACTIVE);
	            } else {
	                item.addClass(ACTIVE);
	            }
	        },

	        _cancelChanges: function(force) {
	            var that = this;
	            var menu = that.options.columnMenu;
	            var view = menu.view;
	            var state = view.state || { columns: {} };
	            var columns = state.columns;

	            that.element.find("." + ACTIVE).removeClass(ACTIVE);
	            menu.refresh();

	            if (force) {
	                var selectedItems = [];

	                for (var key in columns) {
	                    if (columns.hasOwnProperty(key)) {
	                        if (columns[key] === true) {
	                            var item = view.element.find("#" + key);

	                            selectedItems.push(item[0]);
	                        }
	                    }
	                }
	                // In order to use the columns hide/show validation,
	                // triggering the Select event must be done backwards
	                for (var i = selectedItems.length - 1; i >= 0; i--) {
	                    that.trigger(SELECT, { item: selectedItems[i] });
	                }

	                if (menu.options.hasLockableColumns) {
	                    menu._updateLockedColumns();
	                }

	                if (menu.options.hasStickableColumns) {
	                    menu._updateStickyColumns();
	                }
	            }

	            that.options.columnMenu.view.state = { columns: {} };
	        },

	        _applyChanges: function() {
	            var that = this;
	            var view = that.options.columnMenu.view;
	            var state = view.state || { columns: {} };

	            for (var key in state) {
	                if (state.hasOwnProperty(key)) {
	                    if (key !== "initialSort" && key !== "columns" && state[key] === true) {
	                        var item = view.element.find("#" + key);

	                        if (item.hasClass(ACTIVE)) {
	                            item.removeClass(ACTIVE);
	                        } else {
	                            item.addClass(ACTIVE);
	                        }

	                        that.trigger(SELECT, { item: item[0] });
	                    }
	                }
	            }
	        },

	        _createCheckBoxes: function() {
	            var that = this;

	            that.element.find(".k-columns-item").find("[type='checkbox']").kendoSwitch({
	                messages: {
	                    checked: "",
	                    unchecked: ""
	                },
	                change: function(e) {
	                    var item = e.sender.element.closest(".k-item");
	                    var state = that.options.columnMenu.view.state || { columns: {} };
	                    var id = item.prop("id");

	                    if (state.columns[id]) {
	                        state.columns[id] = false;
	                    } else {
	                        state.columns[id] = true;
	                    }

	                    that.trigger(SELECT, { item: item });
	                }
	            });
	        },

	        _destroyCheckBoxes: function() {
	            var that = this;
	            var elements = that.element.find(".k-columns-item").find("[type='checkbox']");
	            var switchWidget;

	            for (var i = 0; i < elements.length; i++) {
	                switchWidget = elements.eq(i).data("kendoSwitch");

	                if (switchWidget) {
	                    switchWidget.destroy();
	                }
	            }
	        },

	        close: function() {
	            this.options.pane.navigate("");
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            that.element.off(NS);
	            that._destroyCheckBoxes();
	        }
	    });

	    ui.plugin(ColumnMenu);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1091:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("3gOi");

/***/ }),

/***/ 1092:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("apSr");

/***/ })

/******/ });

/***/ }),

/***/ "4Sr9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var eventService_1 = __webpack_require__("k5uU");
var events_1 = __webpack_require__("3ok8");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var columnApi_1 = __webpack_require__("E/Wy");
var columnController_1 = __webpack_require__("77lH");
var utils_1 = __webpack_require__("IRr6");
var gridCell_1 = __webpack_require__("hie4");
var gridApi_1 = __webpack_require__("BAow");
var cellComp_1 = __webpack_require__("wTNE");
var FocusedCellController = (function () {
    function FocusedCellController() {
    }
    FocusedCellController.prototype.init = function () {
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.clearFocusedCell.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.clearFocusedCell.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_GROUP_OPENED, this.clearFocusedCell.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_MOVED, this.clearFocusedCell.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_PINNED, this.clearFocusedCell.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.clearFocusedCell.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_VISIBLE, this.clearFocusedCell.bind(this));
    };
    FocusedCellController.prototype.clearFocusedCell = function () {
        this.focusedCell = null;
        this.onCellFocused(false);
    };
    FocusedCellController.prototype.getFocusedCell = function () {
        return this.focusedCell;
    };
    // we check if the browser is focusing something, and if it is, and
    // it's the cell we think is focused, then return the cell. so this
    // methods returns the cell if a) we think it has focus and b) the
    // browser thinks it has focus. this then returns nothing if we
    // first focus a cell, then second click outside the grid, as then the
    // grid cell will still be focused as far as the grid is concerned,
    // however the browser focus will have moved somewhere else.
    FocusedCellController.prototype.getFocusCellToUseAfterRefresh = function () {
        if (this.gridOptionsWrapper.isSuppressFocusAfterRefresh()) {
            return null;
        }
        if (!this.focusedCell) {
            return null;
        }
        // we check that the browser is actually focusing on the grid, if it is not, then
        // we have nothing to worry about
        var browserFocusedCell = this.getGridCellForDomElement(document.activeElement);
        if (!browserFocusedCell) {
            return null;
        }
        return this.focusedCell;
    };
    FocusedCellController.prototype.getGridCellForDomElement = function (eBrowserCell) {
        var ePointer = eBrowserCell;
        while (ePointer) {
            var cellComp = this.gridOptionsWrapper.getDomData(ePointer, cellComp_1.CellComp.DOM_DATA_KEY_CELL_COMP);
            if (cellComp) {
                return cellComp.getGridCell();
            }
            ePointer = ePointer.parentNode;
        }
        return null;
    };
    FocusedCellController.prototype.setFocusedCell = function (rowIndex, colKey, floating, forceBrowserFocus) {
        if (forceBrowserFocus === void 0) { forceBrowserFocus = false; }
        if (this.gridOptionsWrapper.isSuppressCellSelection()) {
            return;
        }
        var column = utils_1.Utils.makeNull(this.columnController.getGridColumn(colKey));
        this.focusedCell = new gridCell_1.GridCell({ rowIndex: rowIndex,
            floating: utils_1.Utils.makeNull(floating),
            column: column });
        this.onCellFocused(forceBrowserFocus);
    };
    FocusedCellController.prototype.isCellFocused = function (gridCell) {
        if (utils_1.Utils.missing(this.focusedCell)) {
            return false;
        }
        return this.focusedCell.column === gridCell.column && this.isRowFocused(gridCell.rowIndex, gridCell.floating);
    };
    FocusedCellController.prototype.isRowNodeFocused = function (rowNode) {
        return this.isRowFocused(rowNode.rowIndex, rowNode.rowPinned);
    };
    FocusedCellController.prototype.isAnyCellFocused = function () {
        return !!this.focusedCell;
    };
    FocusedCellController.prototype.isRowFocused = function (rowIndex, floating) {
        if (utils_1.Utils.missing(this.focusedCell)) {
            return false;
        }
        var floatingOrNull = utils_1.Utils.makeNull(floating);
        return this.focusedCell.rowIndex === rowIndex && this.focusedCell.floating === floatingOrNull;
    };
    FocusedCellController.prototype.onCellFocused = function (forceBrowserFocus) {
        var event = {
            type: events_1.Events.EVENT_CELL_FOCUSED,
            forceBrowserFocus: forceBrowserFocus,
            rowIndex: null,
            column: null,
            floating: null,
            api: this.gridApi,
            columnApi: this.columnApi,
            rowPinned: null
        };
        if (this.focusedCell) {
            event.rowIndex = this.focusedCell.rowIndex;
            event.column = this.focusedCell.column;
            event.rowPinned = this.focusedCell.floating;
        }
        this.eventService.dispatchEvent(event);
    };
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], FocusedCellController.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], FocusedCellController.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], FocusedCellController.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], FocusedCellController.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], FocusedCellController.prototype, "gridApi", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FocusedCellController.prototype, "init", null);
    FocusedCellController = __decorate([
        context_1.Bean('focusedCellController')
    ], FocusedCellController);
    return FocusedCellController;
}());
exports.FocusedCellController = FocusedCellController;


/***/ }),

/***/ "4fFG":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1608);
	module.exports = __webpack_require__(1608);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1608:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20),  __webpack_require__(1609) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var RangeRef = kendo.spreadsheet.RangeRef;
	    var CellRef = kendo.spreadsheet.CellRef;

	    var EdgeNavigator = kendo.Class.extend({
	        init: function(field, axis, rangeGetter, union) {
	            this.rangeGetter = rangeGetter;

	            this.prevLeft = function(index) {
	                var current = union(this.range(index));
	                var range = this.range(axis.prevVisible(current.topLeft[field]));
	                return union(range).topLeft[field];
	            };

	            this.nextRight = function(index) {
	                var current = union(this.range(index));
	                var range = this.range(axis.nextVisible(current.bottomRight[field]));
	                return union(range).bottomRight[field];
	            };

	            // these two don't look like the other ones, as they "shrink"
	            this.nextLeft = function(index) {
	                var range = union(this.range(index));
	                return axis.nextVisible(range.bottomRight[field]);
	            };

	            this.prevRight = function(index) {
	                var range = union(this.range(index));
	                return axis.prevVisible(range.topLeft[field]);
	            };
	        },

	        boundary: function(top, bottom) {
	            this.top = top;
	            this.bottom = bottom;
	        },

	        range: function(index) {
	            return this.rangeGetter(index, this.top, this.bottom);
	        }
	    });

	    var SheetNavigator = kendo.Class.extend({
	        init: function(sheet) {
	            this._sheet = sheet;
	            this.autoFillCalculator = new kendo.spreadsheet.AutoFillCalculator(sheet._grid);

	            this.colEdge = new EdgeNavigator("col", this._sheet._grid._columns, this.columnRange.bind(this), this.union.bind(this));
	            this.rowEdge = new EdgeNavigator("row", this._sheet._grid._rows, this.rowRange.bind(this), this.union.bind(this));
	        },

	        height: function(height) {
	            this._viewPortHeight = height;
	        },

	        union: function(ref) {
	            return this._sheet.unionWithMerged(ref);
	        },

	        columnRange: function(col, topRow, bottomRow) {
	            return this._sheet._ref(topRow, col, bottomRow - topRow, 1);
	        },

	        rowRange: function(row, leftCol, rightCol) {
	            return this._sheet._ref(row, leftCol, 1, rightCol - leftCol);
	        },

	        selectionIncludesMergedCells: function() {
	            return this._sheet.select().contains(this._sheet._mergedCells);
	        },

	        setSelectionValue: function(value) {
	            var selection = this._sheet.selection();

	            setTimeout(function() {
	                selection.value(value());
	            });
	        },

	        selectAll: function() {
	            this._sheet.select(this._sheet._sheetRef);
	        },

	        select: function(ref, mode, addToExisting) {
	            ref = this.refForMode(ref, mode);

	            if (addToExisting) {
	                ref = this._sheet.select().concat(ref);
	            }

	            this._sheet.select(ref);
	        },

	        refForMode: function(ref, mode) {
	            var grid = this._sheet._grid;

	            switch(mode) {
	                case "range":
	                    ref = grid.normalize(ref);
	                    break;
	                case "row":
	                    ref = grid.rowRef(ref.row);
	                    break;
	                case "column":
	                    ref = grid.colRef(ref.col);
	                    break;
	                case "sheet":
	                    ref = this._sheet._sheetRef;
	                    break;
	            }

	            return ref;
	        },

	        startSelection: function(ref, mode, addToExisting, shiftKey, view) {
	            if (mode == "autofill") {
	                this._sheet.startAutoFill();
	            } else if (shiftKey && mode == "range") {
	                var range = new RangeRef(this._sheet.activeCell().first(), ref);
	                this._sheet.select(range, false, false);
	                this._sheet.startSelection(view);
	            } else {
	                this._sheet.startSelection(view);
	                this.select(ref, mode, addToExisting);
	            }
	        },

	        completeSelection: function() {
	            this._sheet.completeSelection();
	        },

	        selectForContextMenu: function(ref, mode) {
	            var sheet = this._sheet;
	            sheet._activeDrawing = null;
	            if (!sheet.select().contains(this.refForMode(ref, mode))) {
	                this.select(ref, mode);
	            }
	        },

	        selectDrawingForContextMenu: function(drawing) {
	            var sheet = this._sheet;
	            sheet._activeDrawing = drawing;
	            sheet.triggerChange({ selection: true });
	        },

	        modifySelection: function(action) {
	            var direction = this.determineDirection(action);

	            var sheet = this._sheet;
	            var viewPortHeight = this._viewPortHeight;
	            var rows = sheet._grid._rows;
	            var columns = sheet._grid._columns;

	            var originalSelection = sheet.currentOriginalSelectionRange();
	            var selection = sheet.select().toRangeRef();
	            var activeCell = sheet.activeCell();

	            var topLeft = originalSelection.topLeft.clone();
	            var bottomRight = originalSelection.bottomRight.clone();
	            var bottomLeft = new CellRef(bottomRight.row, topLeft.col);

	            var scrollInto;

	            this.colEdge.boundary(selection.topLeft.row, selection.bottomRight.row);
	            this.rowEdge.boundary(selection.topLeft.col, selection.bottomRight.col);

	            switch (direction) {
	              case "expand-left": // <| |
	                topLeft.col = this.colEdge.prevLeft(topLeft.col);
	                scrollInto = topLeft;
	                break;
	              case "shrink-right": // |>|
	                topLeft.col = this.colEdge.nextLeft(topLeft.col);
	                scrollInto = topLeft;
	                break;
	              case "expand-right": // | |>
	                bottomRight.col = this.colEdge.nextRight(bottomRight.col);
	                scrollInto = bottomRight;
	                break;
	              case "shrink-left": // |<|
	                bottomRight.col = this.colEdge.prevRight(bottomRight.col);
	                scrollInto = bottomRight;
	                break;

	                // four actions below mirror the upper ones, on the vertical axis
	              case "expand-up":
	                topLeft.row = this.rowEdge.prevLeft(topLeft.row);
	                scrollInto = topLeft;
	                break;
	              case "shrink-down":
	                topLeft.row = this.rowEdge.nextLeft(topLeft.row);
	                scrollInto = topLeft;
	                break;
	              case "expand-down":
	                bottomRight.row = this.rowEdge.nextRight(bottomRight.row);
	                scrollInto = bottomRight;
	                break;
	              case "shrink-up":
	                bottomRight.row = this.rowEdge.prevRight(bottomRight.row);
	                scrollInto = bottomRight;
	                break;

	                // pageup/down - may need improvement
	              case "expand-page-up":
	                topLeft.row = rows.prevPage(topLeft.row, viewPortHeight);
	                break;
	              case "shrink-page-up":
	                bottomRight.row = rows.prevPage(bottomRight.row, viewPortHeight);
	                break;
	              case "expand-page-down":
	                bottomRight.row = rows.nextPage(bottomRight.row, viewPortHeight);
	                break;
	              case "shrink-page-down":
	                topLeft.row = rows.nextPage(topLeft.row, viewPortHeight);
	                break;

	              case "first-col":
	                topLeft.col = columns.firstVisible();
	                bottomRight.col = activeCell.bottomRight.col;
	                scrollInto = topLeft;
	                break;
	              case "last-col":
	                bottomRight.col = columns.lastVisible();
	                topLeft.col = activeCell.topLeft.col;
	                scrollInto = bottomRight;
	                break;
	              case "first-row":
	                topLeft.row = rows.firstVisible();
	                bottomRight.row = activeCell.bottomRight.row;
	                scrollInto = topLeft;
	                break;
	              case "last-row":
	                bottomRight.row = rows.lastVisible();
	                topLeft.row = activeCell.topLeft.row;
	                scrollInto = bottomRight;
	                break;
	              case "last":
	                bottomRight.row = rows.lastVisible();
	                bottomRight.col = columns.lastVisible();
	                topLeft = activeCell.topLeft;
	                scrollInto = bottomRight;
	                break;
	              case "first":
	                topLeft.row = rows.firstVisible();
	                topLeft.col = columns.firstVisible();
	                bottomRight = activeCell.bottomRight;
	                scrollInto = topLeft;
	                break;

	              case "expand-word-right":
	                bottomRight.col = columns.nextUntil(bottomRight.col, makeWordMovement(sheet, bottomRight, true));
	                scrollInto = bottomRight;
	                break;
	              case "shrink-word-right":
	                topLeft.col = columns.nextUntil(bottomLeft.col, makeWordMovement(sheet, bottomLeft, true));
	                scrollInto = topLeft;
	                break;
	              case "expand-word-left":
	                topLeft.col = columns.prevUntil(bottomLeft.col, makeWordMovement(sheet, bottomLeft, true));
	                scrollInto = topLeft;
	                break;
	              case "shrink-word-left":
	                bottomRight.col = columns.prevUntil(bottomRight.col, makeWordMovement(sheet, bottomRight, true));
	                scrollInto = bottomRight;
	                break;
	              case "expand-word-up":
	                topLeft.row = rows.prevUntil(topLeft.row, makeWordMovement(sheet, topLeft, false));
	                scrollInto = topLeft;
	                break;
	              case "shrink-word-up":
	                bottomRight.row = rows.prevUntil(bottomRight.row, makeWordMovement(sheet, bottomRight, false));
	                scrollInto = bottomRight;
	                break;
	              case "expand-word-down":
	                bottomRight.row = rows.nextUntil(bottomRight.row, makeWordMovement(sheet, bottomRight, false));
	                scrollInto = bottomRight;
	                break;
	              case "shrink-word-down":
	                topLeft.row = rows.nextUntil(topLeft.row, makeWordMovement(sheet, topLeft, false));
	                scrollInto = topLeft;
	                break;
	            }

	            var newSelection = new RangeRef(topLeft, bottomRight);

	            if (!this.union(newSelection).intersects(activeCell)) {
	                // throw new Error(newSelection.print() + " does not contain " + activeCell.print());
	                this.modifySelection(direction.replace("shrink", "expand"));
	                return;
	            }

	            if (scrollInto) {
	                sheet.focus(scrollInto);
	            }

	            this.updateCurrentSelectionRange(newSelection);
	        },

	        moveActiveCell: function(direction) {
	            var sheet = this._sheet;
	            var activeCell = sheet.activeCell();
	            var topLeft = activeCell.topLeft;
	            var bottomRight = activeCell.bottomRight;

	            var cell = sheet.originalActiveCell();
	            var rows = sheet._grid._rows;
	            var columns = sheet._grid._columns;

	            var row = cell.row;
	            var column = cell.col;

	            switch (direction) {
	              case "left":
	                column = columns.prevVisible(topLeft.col);
	                break;
	              case "up":
	                row = rows.prevVisible(topLeft.row);
	                break;
	              case "right":
	                column = columns.nextVisible(bottomRight.col);
	                break;
	              case "down":
	                row = rows.nextVisible(bottomRight.row);
	                break;
	              case "first-col":
	                column = columns.firstVisible();
	                break;
	              case "last-col":
	                column = columns.lastVisible();
	                break;
	              case "first-row":
	                row = rows.firstVisible();
	                break;
	              case "last-row":
	                row = rows.lastVisible();
	                break;
	              case "last":
	                row = rows.lastVisible();
	                column = columns.lastVisible();
	                break;
	              case "first":
	                row = rows.firstVisible();
	                column = columns.firstVisible();
	                break;
	              case "next-page":
	                row = rows.nextPage(bottomRight.row, this._viewPortHeight);
	                break;
	              case "prev-page":
	                row = rows.prevPage(bottomRight.row, this._viewPortHeight);
	                break;

	              case "word-right":
	                column = columns.nextUntil(column, makeWordMovement(sheet, bottomRight, true));
	                break;
	              case "word-left":
	                column = columns.prevUntil(column, makeWordMovement(sheet, bottomRight, true));
	                break;
	              case "word-up":
	                row = rows.prevUntil(row, makeWordMovement(sheet, bottomRight, false));
	                break;
	              case "word-down":
	                row = rows.nextUntil(row, makeWordMovement(sheet, bottomRight, false));
	                break;
	            }

	            sheet.select(new CellRef(row, column));
	        },

	        navigateInSelection: function(direction) {
	            var sheet = this._sheet;
	            var activeCell = sheet.activeCell();
	            var topLeft = activeCell.topLeft;

	            var cell = sheet.originalActiveCell();
	            var rows = sheet._grid._rows;
	            var columns = sheet._grid._columns;

	            var row = cell.row;
	            var column = cell.col;

	            var isFirstCell = false;
	            var isLastCell = false;

	            var selTopLeft, selBottomRight;

	            var topLeftCol = topLeft.col;
	            var topLeftRow = topLeft.row;
	            var tmp;

	            function setSelection(sel) {
	                selTopLeft = sel.topLeft;
	                selBottomRight = sel.bottomRight;
	            }

	            setSelection(sheet.currentNavigationRange());

	            var done = false;
	            var navigatedAway = false;

	            while (!done && !navigatedAway) {
	                var current = new CellRef(row, column);
	                var isSingleCellSelected = sheet.singleCellSelection();

	                if(isSingleCellSelected) {
	                    isFirstCell = selTopLeft.eq(current) && sheet._sheetRef.topLeft.eq(current);
	                    isLastCell = selBottomRight.eq(current) && sheet._sheetRef.bottomRight.eq(current);

	                    if(!isFirstCell) {
	                        isFirstCell = columns.firstVisible() === column && rows.firstVisible() === row;
	                    }

	                    if(!isLastCell) {
	                        isLastCell = columns.lastVisible() === column && rows.lastVisible() === row;
	                    }
	                }

	                switch (direction) {
	                    case "next":
	                        if(isLastCell) {
	                            navigatedAway = true;
	                            kendo.focusNextElement();
	                        } else if (selBottomRight.eq(current)) {
	                            setSelection(sheet.nextNavigationRange());
	                            row = selTopLeft.row;
	                            column = selTopLeft.col;
	                        } else {
	                            column = columns.nextVisible(topLeftCol);
	                            if (column == topLeftCol || column > selBottomRight.col) {
	                                column = selTopLeft.col;
	                                tmp = rows.nextVisible(row);
	                                if (tmp == row || tmp > selBottomRight.row) {
	                                    row = selTopLeft.row;
	                                } else {
	                                    row = tmp;
	                                }
	                            }
	                        }
	                        break;
	                    case "previous":
	                        if(isFirstCell) {
	                            navigatedAway = true;
	                            this._sheet._workbook._view.element.find('.k-spreadsheet-name-editor .k-input').focus();
	                        } else if (selTopLeft.eq(current)) {
	                            setSelection(sheet.previousNavigationRange());
	                            row = selBottomRight.row;
	                            column = selBottomRight.col;
	                        } else {
	                            column = columns.prevVisible(topLeftCol);
	                            if (column == topLeftCol || column < selTopLeft.col) {
	                                column = selBottomRight.col;
	                                tmp = rows.prevVisible(row);
	                                if (tmp == row || tmp < selTopLeft.row) {
	                                    row = selBottomRight.row;
	                                } else {
	                                    row = tmp;
	                                }
	                            }
	                        }
	                        break;
	                    case "lower":
	                        if (selBottomRight.eq(current)) {
	                            setSelection(sheet.nextNavigationRange());
	                            row = selTopLeft.row;
	                            column = selTopLeft.col;
	                        } else {
	                            row = rows.nextVisible(topLeftRow);
	                            if (row == topLeftRow || row > selBottomRight.row) {
	                                row = selTopLeft.row;
	                                tmp = columns.nextVisible(column);
	                                if (tmp == column || tmp > selBottomRight.col) {
	                                    column = selTopLeft.col;
	                                } else {
	                                    column = tmp;
	                                }
	                            }
	                        }
	                        break;
	                    case "upper":
	                        if (selTopLeft.eq(current)) {
	                            setSelection(sheet.previousNavigationRange());
	                            row = selBottomRight.row;
	                            column = selBottomRight.col;
	                        } else {
	                            row = rows.prevVisible(topLeftRow);
	                            if (row == topLeftRow || row < selTopLeft.row) {
	                                row = selBottomRight.row;
	                                tmp = columns.prevVisible(column);
	                                if (tmp == column || tmp < selTopLeft.col) {
	                                    column = selBottomRight.col;
	                                } else {
	                                    column = tmp;
	                                }
	                            }
	                        }
	                        break;
	                    default:
	                        throw new Error("Unknown entry navigation: " + direction);
	                }

	                done = !this.shouldSkip(row, column);
	                // if (!done) { console.log("skipping", row, column); }
	                topLeftCol = column;
	                topLeftRow = row;
	            }

	            if(done) {
	                if (sheet.singleCellSelection()) {
	                    sheet.select(new CellRef(row, column));
	                } else {
	                    sheet.activeCell(new CellRef(row, column));
	                }
	            }
	        },

	        extendSelection: function(ref, mode) {
	            var sheet = this._sheet;
	            var grid = sheet._grid;

	            if (mode === "autofill") {
	               this.resizeAutoFill(ref);
	               return;
	            }
	            if (mode === "range") {
	                ref = grid.normalize(ref);
	            }
	            else if (mode === "row") {
	                ref = grid.rowRef(ref.row).bottomRight;
	            } else if (mode === "column") {
	                ref = grid.colRef(ref.col).bottomRight;
	            }

	            var activeCell = sheet.originalActiveCell().toRangeRef();

	            this.updateCurrentSelectionRange(new RangeRef(activeCell.topLeft, ref));
	        },

	        shouldSkip: function(row, col) {
	            if (this._sheet.isHiddenRow(row) || this._sheet.isHiddenColumn(col)) {
	                return true;
	            }
	            var ref = new CellRef(row, col);
	            var isMerged = false;
	            this._sheet.forEachMergedCell(function(merged) {
	                if (merged.intersects(ref) && !merged.collapse().eq(ref)) {
	                    isMerged = true;
	                }
	            });

	            return isMerged;
	        },

	        resizeAutoFill: function(ref) {
	            var sheet = this._sheet;
	            var selection = sheet.select();
	            var origin = sheet._autoFillOrigin;
	            var dest = this.autoFillCalculator.autoFillDest(selection, ref);

	            var punch = this.punch(selection, dest);
	            var hint, direction;

	            if (!punch) {
	                var preview = sheet.range(dest)._previewFillFrom(sheet.range(origin));
	                if (preview) {
	                    direction = preview.direction;
	                    hint = preview.hint;
	                }
	            }

	            sheet.updateAutoFill(dest, punch, hint, direction);
	        },

	        determineDirection: function(action) {
	            var selection = this._sheet.currentSelectionRange();
	            var activeCell = this._sheet.activeCell();

	            // There may be a third, indeterminate state, caused by a merged cell.
	            // In this state, all key movements are treated as shrinks.
	            // The navigator will reverse them if it detects this it will cause the selection to exclude the active cell.
	            var leftMode = activeCell.topLeft.col == selection.topLeft.col;
	            var rightMode = activeCell.bottomRight.col == selection.bottomRight.col;
	            var topMode = activeCell.topLeft.row == selection.topLeft.row;
	            var bottomMode = activeCell.bottomRight.row == selection.bottomRight.row;

	            switch (action) {
	              case "left":
	                action = rightMode ? "expand-left" : "shrink-left";
	                break;
	              case "right":
	                action = leftMode ? "expand-right" : "shrink-right";
	                break;
	              case "up":
	                action = bottomMode ? "expand-up" : "shrink-up";
	                break;
	              case "down":
	                action = topMode ? "expand-down" : "shrink-down";
	                break;
	              case "prev-page":
	                action = bottomMode ? "expand-page-up" : "shrink-page-up";
	                break;
	              case "next-page":
	                action = topMode ? "expand-page-down" : "shrink-page-down";
	                break;
	              case "word-left":
	                action = rightMode ? "expand-word-left" : "shrink-word-left";
	                break;
	              case "word-right":
	                action = leftMode ? "expand-word-right" : "shrink-word-right";
	                break;
	              case "word-up":
	                action = bottomMode ? "expand-word-up" : "shrink-word-up";
	                break;
	              case "word-down":
	                action = topMode ? "expand-word-down" : "shrink-word-down";
	                break;
	            }

	            return action;
	        },

	        updateCurrentSelectionRange: function(ref) {
	            var sheet = this._sheet;
	            sheet.select(sheet.originalSelect().replaceAt(sheet.selectionRangeIndex(), ref), false);
	        },

	        punch: function(selection, subset) {
	            var punch;
	            if (subset.topLeft.eq(selection.topLeft)) {
	                if (subset.bottomRight.row < selection.bottomRight.row) {
	                    var bottomRow = this.rowEdge.nextRight(subset.bottomRight.row);

	                    punch = new RangeRef(
	                        new CellRef(bottomRow, selection.topLeft.col),
	                        selection.bottomRight
	                    );
	                } else if (subset.bottomRight.col < selection.bottomRight.col) {
	                    var bottomCol = this.colEdge.nextRight(subset.bottomRight.col);

	                    punch = new RangeRef(
	                        new CellRef(selection.topLeft.row, bottomCol),
	                        selection.bottomRight
	                    );
	                }
	            }

	            return punch;
	        }
	    });

	    function makeWordMovement(sheet, pivot, isCol) {
	        // the general idea is:
	        //
	        // - if we start on a non-empty cell, we should select the
	        //   range of non-empty cells that follow it.  If, however,
	        //   the second cell is empty, then we don't stop there; we
	        //   should skip all the empty cells and stop at the first
	        //   non-empty cell (and select it).
	        //
	        // - if we start on an empty cell, then skip all empty cells
	        //   and select the first non-empty one.

	        var firstVal = sheet.range(pivot).value();
	        return function(pos, advanced, hidden) {
	            if (hidden) { return true; }   // skip hidden cells
	            var val = ( isCol ?
	                        sheet.range(pivot.row, pos) :
	                        sheet.range(pos, pivot.col) ).value();
	            if (firstVal === null) {
	                return val === null ? false : pos;
	            } else if (!advanced && val === null) {
	                firstVal = null; // switch to the other mode
	                return false;
	            } else {
	                return val === null;
	            }
	        };
	    }

	    kendo.spreadsheet.SheetNavigator = SheetNavigator;
	})(kendo);
	}, __webpack_require__(3));


/***/ }),

/***/ 1609:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lQLJ");

/***/ })

/******/ });

/***/ }),

/***/ "52gC":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "5AFk":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1247);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1247:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1049)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function () {

	var __meta__ = {// jshint ignore:line
	    id: "floatinglabel",
	    name: "FloatingLabel",
	    category: "framework",
	    depends: ["core"],
	    hidden: true
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        ui = kendo.ui,
	        NS = ".kendoFloatingLabel",
	        FLOATINGLABELCONTAINER = "k-floating-label-container",
	        EMPTY = "k-state-empty",
	        FOCUSED = "k-state-focused",
	        STATEDISABLED = "k-state-disabled",
	        NOCLICKCLASS = "k-no-click",
	        proxy = $.proxy;

	    var FloatingLabel = Widget.extend({
	        init: function (element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);
	            options = $.extend(true, {}, options);

	            that.refresh();
	            that._editable({
	                readonly: that.options.widget.options.readonly !== undefined ? that.options.widget.options.readonly : false,
	                disable: that.options.widget.options.enable !== undefined ? !(that.options.widget.options.enable) : false
	            });

	            that.element.addClass(FLOATINGLABELCONTAINER);

	            kendo.notify(that);
	        },

	        options: {
	            name: 'FloatingLabel',
	            widget: null
	        },

	        readonly: function(readonly) {
	            this._editable({
	                readonly: readonly === undefined ? true : readonly,
	                disable: false
	            });
	        },

	        enable: function(enable) {
	            this._editable({
	                readonly: false,
	                disable: !(enable = enable === undefined ? true : enable)
	            });
	        },

	        refresh: function () {
	            var that = this;
	            var element = that.element;

	            element
	                .removeClass(EMPTY)
	                .removeClass(FOCUSED);


	            if (!that.options.widget.element.val()) {
	                element.addClass(EMPTY);
	            }

	            if (document.activeElement === that.options.widget.element[0]) {
	                element.addClass(FOCUSED);
	            }
	        },

	        destroy: function() {
	            var that = this;

	            that.element.off(NS);
	            Widget.fn.destroy.call(that);
	        },

	        _editable: function(options) {
	            var that = this;
	            var element = that.element;
	            var disable = options.disable;
	            var readonly = options.readonly;

	            element.off(NS);

	            if (!readonly && !disable) {
	                element
	                    .removeClass(STATEDISABLED)
	                    .removeClass(NOCLICKCLASS);

	                element.on("focusin" + NS, proxy(that.refresh, that));
	                element.on("focusout" + NS, proxy(that.refresh, that));
	            } else {
	                element
	                    .toggleClass(STATEDISABLED, disable)
	                    .toggleClass(NOCLICKCLASS, readonly);
	            }
	        }
	    });
	    ui.plugin(FloatingLabel);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "5AnZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var utils_1 = __webpack_require__("IRr6");
var eventService_1 = __webpack_require__("k5uU");
var events_1 = __webpack_require__("3ok8");
var columnController_1 = __webpack_require__("77lH");
var columnApi_1 = __webpack_require__("E/Wy");
var gridApi_1 = __webpack_require__("BAow");
var ScrollVisibleService = (function () {
    function ScrollVisibleService() {
    }
    ScrollVisibleService.prototype.setScrollsVisible = function (params) {
        var atLeastOneDifferent = this.vBody !== params.vBody
            || this.hBody !== params.hBody
            || this.vPinnedLeft !== params.vPinnedLeft
            || this.vPinnedRight !== params.vPinnedRight;
        if (atLeastOneDifferent) {
            this.vBody = params.vBody;
            this.hBody = params.hBody;
            this.vPinnedLeft = params.vPinnedLeft;
            this.vPinnedRight = params.vPinnedRight;
            var event_1 = {
                type: events_1.Events.EVENT_SCROLL_VISIBILITY_CHANGED,
                api: this.gridApi,
                columnApi: this.columnApi
            };
            this.eventService.dispatchEvent(event_1);
        }
    };
    ScrollVisibleService.prototype.isVBodyShowing = function () {
        return this.vBody;
    };
    ScrollVisibleService.prototype.isHBodyShowing = function () {
        return this.hBody;
    };
    ScrollVisibleService.prototype.isVPinnedLeftShowing = function () {
        return this.vPinnedLeft;
    };
    ScrollVisibleService.prototype.isVPinnedRightShowing = function () {
        return this.vPinnedRight;
    };
    ScrollVisibleService.prototype.getPinnedLeftWidth = function () {
        return this.columnController.getPinnedLeftContainerWidth();
    };
    ScrollVisibleService.prototype.getPinnedLeftWithScrollWidth = function () {
        var result = this.getPinnedLeftWidth();
        if (this.vPinnedLeft) {
            result += utils_1.Utils.getScrollbarWidth();
        }
        return result;
    };
    ScrollVisibleService.prototype.getPinnedRightWidth = function () {
        return this.columnController.getPinnedRightContainerWidth();
    };
    ScrollVisibleService.prototype.getPinnedRightWithScrollWidth = function () {
        var result = this.getPinnedRightWidth();
        if (this.vPinnedRight) {
            result += utils_1.Utils.getScrollbarWidth();
        }
        return result;
    };
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], ScrollVisibleService.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], ScrollVisibleService.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], ScrollVisibleService.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], ScrollVisibleService.prototype, "gridApi", void 0);
    ScrollVisibleService = __decorate([
        context_1.Bean('scrollVisibleService')
    ], ScrollVisibleService);
    return ScrollVisibleService;
}());
exports.ScrollVisibleService = ScrollVisibleService;


/***/ }),

/***/ "5JVC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var expressionService_1 = __webpack_require__("1aUC");
var columnController_1 = __webpack_require__("77lH");
var context_1 = __webpack_require__("RQ1/");
var utils_1 = __webpack_require__("IRr6");
var events_1 = __webpack_require__("3ok8");
var eventService_1 = __webpack_require__("k5uU");
var valueCache_1 = __webpack_require__("uKqK");
var ValueService = (function () {
    function ValueService() {
        this.initialised = false;
    }
    ValueService.prototype.init = function () {
        this.cellExpressions = this.gridOptionsWrapper.isEnableCellExpressions();
        this.initialised = true;
    };
    ValueService.prototype.getValue = function (column, rowNode, ignoreAggData) {
        // console.log(`turnActive = ${this.turnActive}`);
        if (ignoreAggData === void 0) { ignoreAggData = false; }
        // hack - the grid is getting refreshed before this bean gets initialised, race condition.
        // really should have a way so they get initialised in the right order???
        if (!this.initialised) {
            this.init();
        }
        // pull these out to make code below easier to read
        var colDef = column.getColDef();
        var field = colDef.field;
        var colId = column.getId();
        var data = rowNode.data;
        var result;
        // if there is a value getter, this gets precedence over a field
        var groupDataExists = rowNode.groupData && rowNode.groupData[colId] !== undefined;
        var aggDataExists = !ignoreAggData && rowNode.aggData && rowNode.aggData[colId] !== undefined;
        if (groupDataExists) {
            result = rowNode.groupData[colId];
        }
        else if (aggDataExists) {
            result = rowNode.aggData[colId];
        }
        else if (colDef.valueGetter) {
            result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
        }
        else if (field && data) {
            result = utils_1._.getValueUsingField(data, field, column.isFieldContainsDots());
        }
        else {
            result = undefined;
        }
        // the result could be an expression itself, if we are allowing cell values to be expressions
        if (this.cellExpressions && (typeof result === 'string') && result.indexOf('=') === 0) {
            var cellValueGetter = result.substring(1);
            result = this.executeValueGetter(cellValueGetter, data, column, rowNode);
        }
        return result;
    };
    ValueService.prototype.setValue = function (rowNode, colKey, newValue) {
        var column = this.columnController.getPrimaryColumn(colKey);
        if (!rowNode || !column) {
            return;
        }
        // this will only happen if user is trying to paste into a group row, which doesn't make sense
        // the user should not be trying to paste into group rows
        var data = rowNode.data;
        if (utils_1._.missing(data)) {
            rowNode.data = {};
        }
        // for backwards compatibility we are also retrieving the newValueHandler as well as the valueSetter
        var _a = column.getColDef(), field = _a.field, newValueHandler = _a.newValueHandler, valueSetter = _a.valueSetter;
        // need either a field or a newValueHandler for this to work
        if (utils_1._.missing(field) && utils_1._.missing(newValueHandler) && utils_1._.missing(valueSetter)) {
            // we don't tell user about newValueHandler, as that is deprecated
            console.warn("ag-Grid: you need either field or valueSetter set on colDef for editing to work");
            return;
        }
        var params = {
            node: rowNode,
            data: rowNode.data,
            oldValue: this.getValue(column, rowNode),
            newValue: newValue,
            colDef: column.getColDef(),
            column: column,
            api: this.gridOptionsWrapper.getApi(),
            columnApi: this.gridOptionsWrapper.getColumnApi(),
            context: this.gridOptionsWrapper.getContext()
        };
        params.newValue = newValue;
        var valueWasDifferent;
        if (utils_1._.exists(newValueHandler)) {
            valueWasDifferent = newValueHandler(params);
        }
        else if (utils_1._.exists(valueSetter)) {
            valueWasDifferent = this.expressionService.evaluate(valueSetter, params);
        }
        else {
            valueWasDifferent = this.setValueUsingField(data, field, newValue, column.isFieldContainsDots());
        }
        // in case user forgot to return something (possible if they are not using TypeScript
        // and just forgot, or using an old newValueHandler we didn't always expect a return
        // value here), we default the return value to true, so we always refresh.
        if (valueWasDifferent === undefined) {
            valueWasDifferent = true;
        }
        // if no change to the value, then no need to do the updating, or notifying via events.
        // otherwise the user could be tabbing around the grid, and cellValueChange would get called
        // all the time.
        if (!valueWasDifferent) {
            return;
        }
        // reset quick filter on this row
        rowNode.resetQuickFilterAggregateText();
        this.valueCache.onDataChanged();
        params.newValue = this.getValue(column, rowNode);
        if (typeof column.getColDef().onCellValueChanged === 'function') {
            // to make callback async, do in a timeout
            setTimeout(function () { return column.getColDef().onCellValueChanged(params); }, 0);
        }
        var event = {
            type: events_1.Events.EVENT_CELL_VALUE_CHANGED,
            event: null,
            rowIndex: rowNode.rowIndex,
            rowPinned: rowNode.rowPinned,
            column: params.column,
            api: params.api,
            colDef: params.colDef,
            columnApi: params.columnApi,
            context: params.context,
            data: rowNode.data,
            node: rowNode,
            oldValue: params.oldValue,
            newValue: params.newValue,
            value: params.newValue
        };
        this.eventService.dispatchEvent(event);
    };
    ValueService.prototype.setValueUsingField = function (data, field, newValue, isFieldContainsDots) {
        // if no '.', then it's not a deep value
        var valuesAreSame;
        if (!isFieldContainsDots) {
            data[field] = newValue;
        }
        else {
            // otherwise it is a deep value, so need to dig for it
            var fieldPieces = field.split('.');
            var currentObject = data;
            while (fieldPieces.length > 0 && currentObject) {
                var fieldPiece = fieldPieces.shift();
                if (fieldPieces.length === 0) {
                    currentObject[fieldPiece] = newValue;
                }
                else {
                    currentObject = currentObject[fieldPiece];
                }
            }
        }
        return !valuesAreSame;
    };
    ValueService.prototype.executeValueGetter = function (valueGetter, data, column, rowNode) {
        var colId = column.getId();
        // if inside the same turn, just return back the value we got last time
        var valueFromCache = this.valueCache.getValue(rowNode, colId);
        if (valueFromCache !== undefined) {
            return valueFromCache;
        }
        var params = {
            data: data,
            node: rowNode,
            column: column,
            colDef: column.getColDef(),
            api: this.gridOptionsWrapper.getApi(),
            columnApi: this.gridOptionsWrapper.getColumnApi(),
            context: this.gridOptionsWrapper.getContext(),
            getValue: this.getValueCallback.bind(this, rowNode)
        };
        var result = this.expressionService.evaluate(valueGetter, params);
        // if a turn is active, store the value in case the grid asks for it again
        this.valueCache.setValue(rowNode, colId, result);
        return result;
    };
    ValueService.prototype.getValueCallback = function (node, field) {
        var otherColumn = this.columnController.getPrimaryColumn(field);
        if (otherColumn) {
            return this.getValue(otherColumn, node);
        }
        else {
            return null;
        }
    };
    // used by row grouping and pivot, to get key for a row. col can be a pivot col or a row grouping col
    ValueService.prototype.getKeyForNode = function (col, rowNode) {
        var value = this.getValue(col, rowNode);
        var result;
        var keyCreator = col.getColDef().keyCreator;
        if (keyCreator) {
            result = keyCreator({ value: value });
        }
        else {
            result = value;
        }
        // if already a string, or missing, just return it
        if (typeof result === 'string' || result === null || result === undefined) {
            return result;
        }
        result = String(result);
        if (result === '[object Object]') {
            utils_1._.doOnce(function () {
                console.warn('ag-Grid: a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (se ag-Grid docs) or b) to toString() on the object to return a key');
            }, 'getKeyForNode - warn about [object,object]');
        }
        return result;
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], ValueService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('expressionService'),
        __metadata("design:type", expressionService_1.ExpressionService)
    ], ValueService.prototype, "expressionService", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], ValueService.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], ValueService.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('valueCache'),
        __metadata("design:type", valueCache_1.ValueCache)
    ], ValueService.prototype, "valueCache", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ValueService.prototype, "init", null);
    ValueService = __decorate([
        context_1.Bean('valueService')
    ], ValueService);
    return ValueService;
}());
exports.ValueService = ValueService;


/***/ }),

/***/ "5MhB":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1621);
	module.exports = __webpack_require__(1621);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1578:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("I2Wh");

/***/ }),

/***/ 1612:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Iu+f");

/***/ }),

/***/ 1621:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// -*- fill-column: 100 -*-

	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1578), __webpack_require__(1612) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	    "use strict";

	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    // WARNING: removing the following jshint declaration and turning
	    // == into === to make JSHint happy will break functionality.
	    /* jshint eqnull:true, newcap:false, laxbreak:true, validthis:true */
	    /* jshint latedef:false */

	    var util = kendo.util;
	    var spreadsheet = kendo.spreadsheet;
	    var calc = spreadsheet.calc;
	    var runtime = calc.runtime;
	    var defineFunction = runtime.defineFunction;
	    var defineAlias = runtime.defineAlias;
	    var CalcError = runtime.CalcError;
	    var RangeRef = spreadsheet.RangeRef;
	    var CellRef = spreadsheet.CellRef;
	    var UnionRef = spreadsheet.UnionRef;
	    var Matrix = runtime.Matrix;
	    var Ref = spreadsheet.Ref;
	    var NameRef = spreadsheet.NameRef;
	    var daysInMonth = runtime.daysInMonth;
	    var packDate = runtime.packDate;
	    var unpackDate = runtime.unpackDate;
	    var daysInYear = runtime.daysInYear;

	    /* -----[ Math functions ]----- */

	    [ "abs", "cos", "sin", "acos", "asin", "tan", "atan", "exp", "sqrt" ].forEach(function(name){
	        defineFunction(name, Math[name]).args([
	            [ "*n", "number" ]
	        ]);
	    });

	    defineFunction("ln", Math.log).args([
	        [ "*n", "number" ]
	    ]);

	    defineFunction("log", function(num, base){
	        return Math.log(num) / Math.log(base);
	    }).args([
	        [ "*num", "number++" ],
	        [ "*base", [ "or", "number++", [ "null", 10 ] ] ],
	        [ "?", [ "assert", "$base != 1", "DIV/0" ] ]
	    ]);

	    defineFunction("log10", function(num){
	        return Math.log(num) / Math.log(10);
	    }).args([
	        [ "*num", "number++" ]
	    ]);

	    defineFunction("pi", function(){
	        return Math.PI;
	    }).args([]);

	    defineFunction("sqrtpi", function(n){
	        return Math.sqrt(n * Math.PI);
	    }).args([
	        [ "*num", "number+" ]
	    ]);

	    defineFunction("degrees", function(rad){
	        return ((180 * rad) / Math.PI) % 360;
	    }).args([
	        [ "*radians", "number" ]
	    ]);

	    defineFunction("radians", function(deg){
	        return Math.PI * deg / 180;
	    }).args([
	        [ "*degrees", "number" ]
	    ]);

	    function _cosh(n){
	        return (Math.exp(n) + Math.exp(-n)) / 2;
	    }

	    defineFunction("cosh", _cosh).args([
	        [ "*num", "number" ]
	    ]);

	    defineFunction("acosh", function(n){
	        return Math.log(n + Math.sqrt(n - 1) * Math.sqrt(n + 1));
	    }).args([
	        [ "*num", "number" ],
	        [ "?", [ "assert", "$num >= 1" ] ]
	    ]);

	    function _sinh(n){
	        return (Math.exp(n) - Math.exp(-n)) / 2;
	    }

	    defineFunction("sinh", _sinh).args([
	        [ "*num", "number" ]
	    ]);

	    defineFunction("asinh", function(n){
	        return Math.log(n + Math.sqrt(n * n + 1));
	    }).args([
	        [ "*num", "number" ]
	    ]);

	    defineFunction("sec", function(n){
	        return 1 / Math.cos(n);
	    }).args([
	        [ "*num", "number" ]
	    ]);

	    defineFunction("sech", function(n){
	        return 1 / _cosh(n);
	    }).args([
	        [ "*num", "number" ]
	    ]);

	    defineFunction("csc", function(n){
	        return 1 / Math.sin(n);
	    }).args([
	        [ "*num", "number" ]
	    ]);

	    defineFunction("csch", function(n){
	        return 1 / _sinh(n);
	    }).args([
	        [ "*num", "number" ]
	    ]);

	    defineFunction("atan2", function(x, y){
	        return Math.atan(y / x);
	    }).args([
	        [ "*x", "divisor" ],
	        [ "*y", "number" ]
	    ]);

	    function _tanh(n) {
	        return _sinh(n) / _cosh(n);
	    }

	    defineFunction("tanh", _tanh).args([
	        [ "*num", "number" ]
	    ]);

	    defineFunction("atanh", function(n){
	        return Math.log(Math.sqrt(1 - n*n) / (1 - n));
	    }).args([
	        [ "*num", [ "and", "number", [ "(between)", -1, 1 ] ] ]
	    ]);

	    defineFunction("cot", function(n){
	        return 1 / Math.tan(n);
	    }).args([
	        [ "*num", "divisor" ]
	    ]);

	    defineFunction("coth", function(n){
	        return 1 / _tanh(n);
	    }).args([
	        [ "*num", "divisor" ]
	    ]);

	    defineFunction("acot", function(n){
	        return Math.PI / 2 - Math.atan(n);
	    }).args([
	        [ "*num", "number" ]
	    ]);

	    defineFunction("acoth", function(n){
	        return Math.log((n + 1) / (n - 1)) / 2;
	    }).args([
	        [ "*num", "number" ],
	        [ "?", [ "or",
	                 [ "assert", "$num < -1"],
	                 [ "assert", "$num > 1" ] ] ]
	    ]);

	    defineFunction("power", function(a, b){
	        return Math.pow(a, b);
	    }).args([
	        [ "*a", "number" ],
	        [ "*b", "number" ]
	    ]);

	    defineFunction("mod", function(a, b){
	        return a % b;
	    }).args([
	        [ "*a", "number" ],
	        [ "*b", "divisor" ]
	    ]);

	    defineFunction("quotient", function(a, b){
	        return Math.floor(a / b);
	    }).args([
	        [ "*a", "number" ],
	        [ "*b", "divisor" ]
	    ]);

	    defineFunction("ceiling", function(num, s){
	        return s ? s * Math.ceil(num / s) : 0;
	    }).args([
	        [ "*number", "number" ],
	        [ "*significance", "number" ],
	        [ "?", [ "assert", "$significance >= 0 || $number < 0" ] ]
	    ]);

	    defineFunction("ceiling.precise", function(num, s){
	        s = Math.abs(s);
	        return s ? s * Math.ceil(num / s) : 0;
	    }).args([
	        [ "*number", "number" ],
	        [ "*significance", [ "or", "number", [ "null", 1 ] ] ]
	    ]);

	    defineAlias("iso.ceiling", "ceiling.precise");

	    // XXX: how do we know if this function is correct?
	    //
	    // https://support.office.com/en-gb/article/CEILING-MATH-function-80f95d2f-b499-4eee-9f16-f795a8e306c8
	    //
	    // “There are many combinations of Significance and Mode values that affect rounding of negative
	    // numbers in different ways.” — right, thanks for the info. :-\
	    defineFunction("ceiling.math", function(num, s, mode){
	        if (!s || !num) {
	            return 0;
	        }
	        if (num < 0 && ((!mode && s < 0) || (mode && s > 0))) {
	            s = -s;
	        }
	        return s ? s * Math.ceil(num / s) : 0;
	    }).args([
	        [ "*number", "number" ],
	        [ "*significance", [ "or", "number", [ "null", "$number < 0 ? -1 : 1" ] ] ],
	        [ "*mode", [ "or", "logical", [ "null", 0 ] ] ]
	    ]);

	    defineFunction("floor", function(num, s){
	        return s ? s * Math.floor(num / s) : 0;
	    }).args([
	        [ "*number", "number" ],
	        [ "*significance", "number" ],
	        [ "?", [ "assert", "$significance >= 0 || $number < 0" ] ]
	    ]);

	    defineFunction("floor.precise", function(num, s){
	        s = Math.abs(s);
	        return s ? s * Math.floor(num / s) : 0;
	    }).args([
	        [ "*number", "number" ],
	        [ "*significance", [ "or", "number", [ "null", 1 ] ] ]
	    ]);

	    // XXX: check this
	    defineFunction("floor.math", function(num, s, mode){
	        if (!s || !num) {
	            return 0;
	        }
	        if (num < 0 && ((!mode && s < 0) || (mode && s > 0))) {
	            s = -s;
	        }
	        return s ? s * Math.floor(num / s) : 0;
	    }).args([
	        [ "*number", "number" ],
	        [ "*significance", [ "or", "number", [ "null", "$number < 0 ? -1 : 1" ] ] ],
	        [ "*mode", [ "or", "logical", [ "null", 0 ] ] ]
	    ]);

	    defineFunction("int", Math.floor).args([
	        [ "*number", "number" ]
	    ]);

	    defineFunction("mround", function(num, mult){
	        return mult ? mult * Math.round(num / mult) : 0;
	    }).args([
	        [ "*number", "number" ],
	        [ "*multiple", "number" ]
	    ]);

	    defineFunction("round", function(num, digits){
	        var sign = num < 0 ? -1 : 1;
	        if (sign < 0) { num = -num; }
	        digits = Math.pow(10, digits);
	        num *= digits;
	        num = Math.round(num);
	        return sign * num / digits;
	    }).args([
	        [ "*number", "number" ],
	        [ "*digits", "number" ]
	    ]);

	    defineFunction("roundup", function(num, digits){
	        digits = Math.pow(10, digits);
	        num *= digits;
	        num = num < 0 ? Math.floor(num) : Math.ceil(num);
	        return num / digits;
	    }).args([
	        [ "*number", "number" ],
	        [ "*digits", "number" ]
	    ]);

	    defineFunction("rounddown", function(num, digits){
	        digits = Math.pow(10, digits);
	        num *= digits;
	        num = num < 0 ? Math.ceil(num) : Math.floor(num);
	        return num / digits;
	    }).args([
	        [ "*number", "number" ],
	        [ "*digits", "number" ]
	    ]);

	    defineFunction("even", function(num){
	        var n = num < 0 ? Math.floor(num) : Math.ceil(num);
	        return n % 2 ? n + (n < 0 ? -1 : 1) : n;
	    }).args([
	        [ "*number", "number" ]
	    ]);

	    defineFunction("odd", function(num){
	        var n = num < 0 ? Math.floor(num) : Math.ceil(num);
	        return n % 2 ? n : n + (n < 0 ? -1 : 1);
	    }).args([
	        [ "*number", "number" ]
	    ]);

	    defineFunction("sign", function(num){
	        return num < 0 ? -1 : num > 0 ? 1 : 0;
	    }).args([
	        [ "*number", "number" ]
	    ]);

	    function _gcd(a, b) {
	        while (b) {
	            var r = a % b;
	            a = b;
	            b = r;
	        }
	        return a;
	    }

	    function _lcm(a, b) {
	        return Math.abs(a * b) / _gcd(a, b);
	    }

	    defineFunction("gcd", function(args){
	        var a = args[0];
	        for (var i = 1; i < args.length; ++i) {
	            a = _gcd(a, args[i]);
	        }
	        return a;
	    }).args([
	        [ "numbers", [ "collect", "number" ] ]
	    ]);

	    defineFunction("lcm", function(args){
	        var a = args[0];
	        for (var i = 1; i < args.length; ++i) {
	            a = _lcm(a, args[i]);
	        }
	        return a;
	    }).args([
	        [ "numbers", [ "collect", "number" ] ]
	    ]);

	    defineFunction("sum", function(numbers){
	        return numbers.reduce(function(sum, num){
	            return sum + num;
	        }, 0);
	    }).args([
	        [ "numbers", [ "collect", "number" ] ]
	    ]);

	    defineFunction("product", function(numbers){
	        return numbers.reduce(function(prod, num){
	            return prod * num;
	        }, 1);
	    }).args([
	        [ "numbers", [ "collect", "number" ] ]
	    ]);

	    defineFunction("sumproduct", function(first, rest) {
	        var sum = 0;
	        first.each(function(p, row, col){
	            if (typeof p == "number") {
	                for (var i = 0; i < rest.length; ++i) {
	                    var v = rest[i].get(row, col);
	                    if (typeof v != "number") {
	                        return;
	                    }
	                    p *= v;
	                }
	                sum += p;
	            }
	        });
	        return sum;
	    }).args([
	        [ "a1", "matrix" ],
	        [ "+",
	          [ "a2", [ "and", "matrix",
	                    [ "assert", "$a2.width == $a1.width" ],
	                    [ "assert", "$a2.height == $a1.height" ] ] ] ]
	    ]);

	    defineFunction("sumsq", function(numbers){
	        return numbers.reduce(function(sum, num){
	            return sum + num * num;
	        }, 0);
	    }).args([
	        [ "numbers", [ "collect", "number" ] ]
	    ]);

	    defineFunction("sumx2my2", function(a, b){
	        var sum = 0;
	        a.each(function(x, row, col){
	            var y = b.get(row, col);
	            if (typeof x == "number" && typeof y == "number") {
	                sum += x*x - y*y;
	            }
	        });
	        return sum;
	    }).args([
	        [ "a", "matrix" ],
	        [ "b", [ "and", "matrix",
	                 [ "assert", "$b.width == $a.width" ],
	                 [ "assert", "$b.height == $a.height" ] ] ]
	    ]);

	    defineFunction("sumx2py2", function(a, b){
	        var sum = 0;
	        a.each(function(x, row, col){
	            var y = b.get(row, col);
	            if (typeof x == "number" && typeof y == "number") {
	                sum += x*x + y*y;
	            }
	        });
	        return sum;
	    }).args([
	        [ "a", "matrix" ],
	        [ "b", [ "and", "matrix",
	                 [ "assert", "$b.width == $a.width" ],
	                 [ "assert", "$b.height == $a.height" ] ] ]
	    ]);

	    defineFunction("sumxmy2", function(a, b){
	        var sum = 0;
	        a.each(function(x, row, col){
	            var y = b.get(row, col);
	            if (typeof x == "number" && typeof y == "number") {
	                sum += (x - y) * (x - y);
	            }
	        });
	        return sum;
	    }).args([
	        [ "a", "matrix" ],
	        [ "b", [ "and", "matrix",
	                 [ "assert", "$b.width == $a.width" ],
	                 [ "assert", "$b.height == $a.height" ] ] ]
	    ]);

	    defineFunction("seriessum", function(x, n, m, a){
	        var sum = 0;
	        a.each(function(coef){
	            if (typeof coef != "number") {
	                throw new CalcError("VALUE");
	            }
	            sum += coef * Math.pow(x, n);
	            n += m;
	        });
	        return sum;
	    }).args([
	        [ "x", "number" ],
	        [ "y", "number" ],
	        [ "m", "number" ],
	        [ "a", "matrix" ]
	    ]);

	    defineFunction("min", function(numbers){
	        return numbers.length ? Math.min.apply(Math, numbers) : 0;
	    }).args([
	        [ "numbers", [ "collect", "number" ] ]
	    ]);

	    defineFunction("max", function(numbers){
	        return numbers.length ? Math.max.apply(Math, numbers) : 0;
	    }).args([
	        [ "numbers", [ "collect", "number" ] ]
	    ]);

	    defineFunction("counta", function(values){
	        return values.length;
	    }).args([
	        [ "values", [ "#collect", "anyvalue" ] ]
	    ]);

	    defineFunction("count", function(numbers){
	        return numbers.length;
	    }).args([
	        [ "numbers", [ "#collect", "number" ] ]
	    ]);

	    defineFunction("countunique", function(values){
	        var count = 0, seen = [];
	        values.forEach(function(val){
	            if (seen.indexOf(val) < 0) {
	                count++;
	                seen.push(val);
	            }
	        });
	        return count;
	    }).args([
	        [ "values", [ "#collect", "anyvalue" ] ]
	    ]);

	    defineFunction("countblank", function(a){
	        var count = 0;
	        function add(val) {
	            if (val == null || val === "") {
	                count++;
	            }
	        }
	        function loop(args){
	            for (var i = 0; i < args.length; ++i) {
	                var x = args[i];
	                if (x instanceof Matrix) {
	                    x.each(add, true);
	                } else {
	                    add(x);
	                }
	            }
	        }
	        loop(a);
	        return count;
	    }).args([
	        [ "+", [ "args", [ "or", "matrix", "anyvalue" ] ] ]
	    ]);

	    defineFunction("iseven", function(num){
	        return num % 2 === 0;
	    }).args([
	        [ "*number", "number" ]
	    ]);

	    defineFunction("isodd", function(num){
	        return num % 2 !== 0;
	    }).args([
	        [ "*number", "number" ]
	    ]);

	    defineFunction("n", function(val){
	        if (typeof val == "boolean") {
	            return val ? 1 : 0;
	        }
	        if (typeof val == "number") {
	            return val;
	        }
	        return 0;
	    }).args([
	        [ "*value", "anyvalue" ]
	    ]);

	    defineFunction("na", function(){
	        return new CalcError("N/A");
	    }).args([]);

	    /* -----[ the "*IFS" functions ]----- */

	    // helper function: take `args` like COUNTIFS (see Excel docs) and
	    // calls `f` for each cell matching all criteria.  `f` receives
	    // `chunks` (parsed args containing matrix and predicate) and
	    // row,col of matching cells.
	    function forIFS(args, f) {
	        var chunks = [], i = 0, matrix = args[0];
	        while (i < args.length) {
	            chunks.push({
	                matrix: args[i++],
	                pred: parseCriteria(args[i++])
	            });
	        }
	        ROW: for (var row = 0; row < matrix.height; ++row) {
	            COL: for (var col = 0; col < matrix.width; ++col) {
	                for (i = 0; i < chunks.length; ++i) {
	                    var val = chunks[i].matrix.get(row, col);
	                    if (!chunks[i].pred(val == null || val === "" ? 0 : val)) {
	                        continue COL;
	                    }
	                }
	                f(row, col);
	            }
	        }
	    }

	    var ARGS_COUNTIFS = [
	        [ "m1", "matrix" ],
	        [ "c1", "anyvalue" ],
	        [ [ "m2", "matrix" ],
	          [ "c2", "anyvalue" ] ]
	    ];

	    defineFunction("countifs", function(m1, c1, rest){
	        var count = 0;
	        rest.unshift(m1, c1);
	        forIFS(rest, function(){ count++; });
	        return count;
	    }).args(ARGS_COUNTIFS);

	    var ARGS_SUMIFS = [
	        [ "range", "matrix" ]
	    ].concat(ARGS_COUNTIFS);

	    defineFunction("sumifs", function(range, m1, c1, args){
	        // hack: insert a predicate that filters out non-numeric
	        // values; should also accept blank cells.  it's safe to
	        // modify args.
	        args.unshift(range, numericPredicate, m1, c1);
	        var sum = 0;
	        forIFS(args, function(row, col){
	            var val = range.get(row, col);
	            if (val) {
	                sum += val;
	            }
	        });
	        return sum;
	    }).args(ARGS_SUMIFS);

	    // similar to sumifs, but compute average of matching cells
	    defineFunction("averageifs", function(range, m1, c1, args){
	        args.unshift(range, numericPredicate, m1, c1);
	        var sum = 0, count = 0;
	        forIFS(args, function(row, col){
	            var val = range.get(row, col);
	            if (val == null || val === "") {
	                val = 0;
	            }
	            sum += val;
	            count++;
	        });
	        return count ? sum / count : new CalcError("DIV/0");
	    }).args(ARGS_SUMIFS);

	    defineFunction("countif", function(matrix, criteria){
	        criteria = parseCriteria(criteria);
	        var count = 0;
	        matrix.each(function(val){
	            if (criteria(val)) {
	                count++;
	            }
	        });
	        return count;
	    }).args([
	        [ "range", "matrix" ],
	        [ "*criteria", "anyvalue" ]
	    ]);

	    var ARGS_SUMIF = [
	        [ "range", "matrix" ],
	        [ "*criteria", "anyvalue" ],
	        [ "sumRange", [ "or", "area", "#matrix", [ "null", "$range" ] ] ]
	    ];

	    function fetchSumRange(continuation) {
	        return function(callback, range, criteria, sumRange) {
	            var self = this;
	            if (sumRange instanceof Ref) {
	                // make sure it covers the same area as `range`, as the “spec” mentions:
	                //
	                //     The sum_range argument does not have to be the same size and shape as the
	                //     range argument. The actual cells that are added are determined by using the
	                //     upper leftmost cell in the sum_range argument as the beginning cell, and then
	                //     including cells that correspond in size and shape to the range argument.
	                //
	                // It does make one wonder, since only the top-left cell in `sumRange` matters, why
	                // should it be a range at all?  Oh well, Excel.
	                var r = sumRange.clone().toRangeRef();
	                if (r.width() != range.width || r.height() != range.height) {
	                    if (!isFinite(r.topLeft.row)) {
	                        r.topLeft.row = 0;
	                    }
	                    if (!isFinite(r.topLeft.col)) {
	                        r.topLeft.col = 0;
	                    }
	                    r.bottomRight.row = r.topLeft.row + range.height - 1;
	                    r.bottomRight.col = r.topLeft.col + range.width - 1;
	                    return self.resolveCells([ r ], function(){
	                        callback(continuation(range, criteria, self.asMatrix(r)));
	                    });
	                }
	            }
	            callback(continuation(range, criteria, self.asMatrix(sumRange)));
	        };
	    }

	    defineFunction("sumif", fetchSumRange(function(range, criteria, sumRange){
	        var sum = 0;
	        criteria = parseCriteria(criteria);
	        range.each(function(val, row, col){
	            if (criteria(val)) {
	                var v = sumRange.get(row, col);
	                if (numericPredicate(v)) {
	                    sum += v || 0;
	                }
	            }
	        });
	        return sum;
	    })).argsAsync(ARGS_SUMIF);

	    defineFunction("averageif", fetchSumRange(function(range, criteria, sumRange){
	        var sum = 0, count = 0;
	        criteria = parseCriteria(criteria);
	        range.each(function(val, row, col){
	            if (criteria(val)) {
	                var v = sumRange.get(row, col);
	                if (numericPredicate(v)) {
	                    sum += v || 0;
	                    count++;
	                }
	            }
	        });
	        return count ? sum / count : new CalcError("DIV/0");
	    })).argsAsync(ARGS_SUMIF);

	    (function(def){
	        def("large", function(numbers, nth){
	            return numbers.sort(descending)[nth];
	        });
	        def("small", function(numbers, nth){
	            return numbers.sort(ascending)[nth];
	        });
	    })(function(name, handler){
	        defineFunction(name, function(matrix, nth){
	            var numbers = [];
	            var error = matrix.each(function(val){
	                if (val instanceof CalcError) {
	                    return val;
	                }
	                if (typeof val == "number") {
	                    numbers.push(val);
	                }
	            });
	            if (error) {
	                return error;
	            }
	            if (nth > numbers.length) {
	                return new CalcError("NUM");
	            }
	            return handler(numbers, nth - 1);
	        }).args([
	            [ "array", "matrix" ],
	            [ "*nth", "number++" ]
	        ]);
	    });

	    function _avg(numbers) {
	        return numbers.reduce(function(sum, num){
	            return sum + num;
	        }, 0) / numbers.length;
	    }

	    function _var_sp(numbers, divisor, avg) {
	        if (avg == null) {
	            avg = _avg(numbers);
	        }
	        return numbers.reduce(function(sum, num){
	            return sum + Math.pow(num - avg, 2);
	        }, 0) / divisor;
	    }

	    function _stdev_sp(numbers, divisor) {
	        return Math.sqrt(_var_sp(numbers, divisor));
	    }

	    // https://support.office.com/en-sg/article/STDEV-S-function-7d69cf97-0c1f-4acf-be27-f3e83904cc23
	    defineFunction("stdev.s", function(numbers){
	        return _stdev_sp(numbers, numbers.length - 1);
	    }).args([
	        [ "numbers", [ "collect", "number" ] ],
	        [ "?", [ "assert", "$numbers.length >= 2", "NUM" ] ]
	    ]);

	    // https://support.office.com/en-sg/article/STDEV-P-function-6e917c05-31a0-496f-ade7-4f4e7462f285
	    defineFunction("stdev.p", function(numbers){
	        return _stdev_sp(numbers, numbers.length);
	    }).args([
	        [ "numbers", [ "collect", "number" ] ],
	        [ "?", [ "assert", "$numbers.length >= 2", "NUM" ] ]
	    ]);

	    defineFunction("var.s", function(numbers){
	        return _var_sp(numbers, numbers.length - 1);
	    }).args([
	        [ "numbers", [ "collect", "number" ] ],
	        [ "?", [ "assert", "$numbers.length >= 2", "NUM" ] ]
	    ]);

	    defineFunction("var.p", function(numbers){
	        return _var_sp(numbers, numbers.length);
	    }).args([
	        [ "numbers", [ "collect", "number" ] ],
	        [ "?", [ "assert", "$numbers.length >= 2", "NUM" ] ]
	    ]);

	    defineFunction("median", function(numbers){
	        var n = numbers.length;
	        numbers.sort(ascending);
	        if (n % 2) {
	            // when length is odd, the median is the number in the middle
	            return numbers[n >> 1];
	        }
	        // that's the average of the two middle numbers, written in in a fancy way
	        return (numbers[n >>= 1] + numbers[n - 1]) / 2;
	    }).args([
	        [ "numbers", [ "collect", "number" ] ],
	        [ "?", [ "assert", "$numbers.length > 0", "N/A" ] ]
	    ]);

	    defineFunction("mode.sngl", function(numbers){
	        numbers.sort(ascending);
	        var prev = null, count = 0, max = 1, mode = null;
	        for (var i = 0; i < numbers.length; ++i) {
	            var n = numbers[i];
	            if (n != prev) {
	                count = 1;
	                prev = n;
	            } else {
	                count++;
	            }
	            if (count > max) {
	                max = count;
	                mode = n;
	            }
	        }
	        return mode == null ? new CalcError("N/A") : mode;
	    }).args([
	        [ "numbers", [ "collect", "number" ] ]
	    ]);

	    defineFunction("mode.mult", function(numbers){
	        var seen = Object.create(null), max = 2, res = [];
	        numbers.forEach(function(num){
	            var s = seen[num] || 0;
	            seen[num] = ++s;
	            if (s == max) {
	                res.push(num);
	            } else if (s > max) {
	                max = s;
	                res = [ num ];
	            }
	        });
	        var m = new Matrix(this);
	        res.forEach(function(num, i){
	            m.set(i, 0, num);
	        });
	        return m;
	    }).args([
	        [ "numbers", [ "collect", "number" ] ]
	    ]);

	    defineFunction("geomean", function(numbers){
	        var n = numbers.length;
	        var p = numbers.reduce(function(p, num){
	            if (num < 0) {
	                throw new CalcError("NUM");
	            }
	            return p * num;
	        }, 1);
	        return Math.pow(p, 1/n);
	    }).args([
	        [ "numbers", [ "collect", "number" ] ],
	        [ "?", [ "assert", "$numbers.length > 0", "NUM" ] ]
	    ]);

	    defineFunction("harmean", function(numbers){
	        var n = numbers.length;
	        var s = numbers.reduce(function(s, num){
	            if (!num) {
	                throw new CalcError("DIV/0");
	            }
	            return s + 1 / num;
	        }, 0);
	        return n / s;
	    }).args([
	        [ "numbers", [ "collect", "number" ] ],
	        [ "?", [ "assert", "$numbers.length > 0", "NUM" ] ]
	    ]);

	    defineFunction("trimmean", function(numbers, p){
	        var n = numbers.length;
	        numbers.sort(ascending);
	        var discard = Math.floor(n * p);
	        if (discard % 2) {
	            --discard;
	        }
	        discard /= 2;
	        var sum = 0;
	        for (var i = discard; i < n-discard; ++i) {
	            sum += numbers[i];
	        }
	        return sum / (n - discard * 2);
	    }).args([
	        [ "numbers", [ "collect", "number", 1 ] ],
	        [ "percent", [ "and", "number", [ "[between)", 0, 1 ] ] ],
	        [ "?", [ "assert", "$numbers.length > 0", "NUM" ] ]
	    ]);

	    defineFunction("frequency", function(data, bins){
	        // apparently this always returns a vertical matrix in Excel, so we collect all numbers in
	        // bins instead of receiving it as a Matrix and try to mimic its shape.
	        data.sort(ascending);
	        bins.sort(ascending);
	        var prev = -Infinity;
	        var i = 0;
	        function count(max) {
	            var n = 0;
	            while (i < data.length && data[i] > prev && data[i] <= max) {
	                ++n; ++i;
	            }
	            return n;
	        }
	        var m = new Matrix(this);
	        bins.forEach(function(val, i){
	            var n = count(val);
	            prev = val;
	            m.set(i, 0, n);
	        });
	        m.set(m.height, 0, data.length - i);
	        return m;
	    }).args([
	        [ "data", [ "collect", "number", 1 ] ],
	        [ "bins", [ "collect", "number", 1 ] ]
	    ]);

	    defineFunction("rank.eq", function(val, numbers, asc) {
	        numbers.sort(asc ? ascending : descending);
	        var pos = numbers.indexOf(val);
	        return pos < 0 ? new CalcError("N/A") : pos + 1;
	    }).args([
	        [ "value", "number" ],
	        [ "numbers", [ "collect", "number" ] ],
	        [ "order", [ "or", "logical", [ "null", false ] ] ]
	    ]);

	    defineAlias("rank", "rank.eq");

	    defineFunction("rank.avg", function(val, numbers, asc) {
	        numbers.sort(asc ? ascending : descending);
	        var pos = numbers.indexOf(val);
	        if (pos < 0) {
	            return new CalcError("N/A");
	        }
	        for (var i = pos; numbers[i] == val; ++i){}
	        return (pos + i + 1) / 2;
	    }).args([
	        [ "value", "number" ],
	        [ "numbers", [ "collect", "number" ] ],
	        [ "order", [ "or", "logical", [ "null", false ] ] ]
	    ]);

	    // formula available at https://support.office.microsoft.com/en-us/article/KURT-function-cbbc2312-dfa6-4cc4-b5c0-1b3c59cc9377
	    defineFunction("kurt", function(numbers){
	        var n = numbers.length;
	        var avg = _avg(numbers);
	        var variance = _var_sp(numbers, n-1, avg);
	        var stddev = Math.sqrt(variance);
	        var sum = numbers.reduce(function(sum, num){
	            return sum + Math.pow((num - avg) / stddev, 4);
	        }, 0);
	        return n*(n+1)/((n-1)*(n-2)*(n-3)) * sum
	            - 3*Math.pow(n-1, 2)/((n-2)*(n-3));
	    }).args([
	        [ "numbers", [ "collect", "number" ] ],
	        [ "?", [ "assert", "$numbers.length >= 4", "NUM" ] ]
	    ]);

	    function _percentrank(numbers, x, exc) {
	        var nlt = 0, ngt = 0, left = null, right = null, found = false;
	        numbers.forEach(function(num){
	            if (num < x) {
	                nlt++;
	                left = left == null ? num : Math.max(left, num);
	            } else if (num > x) {
	                ngt++;
	                right = right == null ? num : Math.min(right, num);
	            } else {
	                found = true;
	            }
	        });
	        if (!nlt && !ngt) {
	            return new CalcError("N/A");
	        }
	        if (found) {
	            if (exc) {
	                return (nlt + 1) / (numbers.length + 1);
	            }
	            return nlt / (nlt + ngt);
	        }
	        return ((right - x) * _percentrank(numbers, left, exc) +
	                (x - left) * _percentrank(numbers, right, exc)) / (right - left);
	    }

	    var ARGS_PERCENTRANK = [
	        [ "array", [ "collect", "number", 1 ] ],
	        [ "x", "number" ],
	        [ "significance", [ "or", [ "null", 3 ], "integer++" ] ],
	        [ "?", [ "assert", "$array.length > 0", "NUM" ] ]
	    ];

	    defineFunction("percentrank.inc", function(numbers, x, significance) {
	        var p = _percentrank(numbers, x, 0);
	        p = p.toFixed(significance + 1);
	        return parseFloat(p.substr(0, p.length - 1));
	    }).args(ARGS_PERCENTRANK);

	    defineFunction("percentrank.exc", function(numbers, x, significance) {
	        var p = _percentrank(numbers, x, 1);
	        p = p.toFixed(significance + 1);
	        return parseFloat(p.substr(0, p.length - 1));
	    }).args(ARGS_PERCENTRANK);

	    defineAlias("percentrank", "percentrank.inc");

	    function _covariance(x, y, divisor) {
	        var sum = 0;
	        var ax = _avg(x);
	        var ay = _avg(y);
	        var n = x.length;
	        for (var i = 0; i < n; ++i) {
	            sum += (x[i] - ax) * (y[i] - ay);
	        }
	        return sum / divisor;
	    }

	    defineFunction("covariance.p", function(x, y){
	        return _covariance(x, y, x.length);
	    }).args([
	        [ "array1", [ "collect", "number", 1 ] ],
	        [ "array2", [ "collect", "number", 1 ] ],
	        [ "?", [ "assert", "$array1.length == $array2.length", "N/A" ] ],
	        [ "?", [ "assert", "$array1.length > 0", "DIV/0" ] ]
	    ]);

	    defineFunction("covariance.s", function(x, y){
	        return _covariance(x, y, x.length - 1);
	    }).args([
	        [ "array1", [ "collect", "number", 1 ] ],
	        [ "array2", [ "collect", "number", 1 ] ],
	        [ "?", [ "assert", "$array1.length == $array2.length", "N/A" ] ],
	        [ "?", [ "assert", "$array1.length > 1", "DIV/0" ] ]
	    ]);

	    defineAlias("covar", "covariance.p");

	    /* -----[ Factorials ]----- */

	    var _fact = util.memoize(function(n){
	        for (var i = 2, fact = 1; i <= n; ++i) {
	            fact *= i;
	        }
	        return fact;
	    });

	    defineFunction("fact", _fact).args([
	        [ "*n", "integer+" ]
	    ]);

	    defineFunction("factdouble", function(n){
	        for (var i = 2 + (n&1), fact = 1; i <= n; i += 2) {
	            fact *= i;
	        }
	        return fact;
	    }).args([
	        [ "*n", "integer+" ]
	    ]);

	    defineFunction("multinomial", function(numbers){
	        var div = 1, sum = 0;
	        numbers.forEach(function(n){
	            if (n < 0) {
	                throw new CalcError("NUM");
	            }
	            sum += n;
	            div *= _fact(n);
	        });
	        return _fact(sum) / div;
	    }).args([
	        [ "numbers", [ "collect", "number" ] ]
	    ]);

	    var _combinations = util.memoize(function (n, k){
	        for (var f1 = k + 1, f2 = 1, p1 = 1, p2 = 1; f2 <= n - k; ++f1, ++f2) {
	            p1 *= f1;
	            p2 *= f2;
	        }
	        return p1/p2;
	    });

	    defineFunction("combin", _combinations).args([
	        [ "*n", "integer++" ],
	        [ "*k", [ "and", "integer", [ "[between]", 0, "$n" ] ] ]
	    ]);

	    defineFunction("combina", function(n, k){
	        return _combinations(n + k - 1, n - 1);
	    }).args([
	        [ "*n", "integer++" ],
	        [ "*k", [ "and", "integer", [ "[between]", 1, "$n" ] ] ]
	    ]);

	    /* -----[ Statistical functions ]----- */

	    defineFunction("average", function(numbers){
	        var sum = numbers.reduce(function(sum, num){
	            return sum + num;
	        }, 0);
	        return sum / numbers.length;
	    }).args([
	        // most numeric functions must treat booleans as numbers (1 for TRUE
	        // and 0 for FALSE), but AVERAGE shouldn't.
	        [ "numbers", [ "collect", "number!" ] ],
	        [ "?", [ "assert", "$numbers.length > 0", "DIV/0" ] ]
	    ]);

	    defineFunction("averagea", function(values){
	        var sum = 0, count = 0;
	        values.forEach(function(num){
	            if (typeof num != "string") {
	                sum += num;
	            }
	            ++count;
	        });
	        return count ? sum / count : new CalcError("DIV/0");
	    }).args([
	        [ "values", [ "collect", "anyvalue" ] ]
	    ]);

	    function _percentile(numbers, rank) {
	        numbers.sort(ascending);
	        var n = numbers.length;
	        var k = rank | 0, d = rank - k;
	        if (k === 0) {
	            return numbers[0];
	        }
	        if (k >= n) {
	            return numbers[n - 1];
	        }
	        --k;
	        return numbers[k] + d * (numbers[k + 1] - numbers[k]);
	    }

	    function _percentile_inc(numbers, p){
	        // algorithm from https://en.wikipedia.org/wiki/Percentile#Microsoft_Excel_method
	        var rank = p * (numbers.length - 1) + 1;
	        return _percentile(numbers, rank);
	    }

	    function _percentile_exc(numbers, p){
	        // https://en.wikipedia.org/wiki/Percentile#NIST_method
	        var rank = p * (numbers.length + 1);
	        return _percentile(numbers, rank);
	    }

	    defineFunction("percentile.inc", _percentile_inc).args([
	        [ "numbers", [ "collect", "number", 1 ] ],
	        [ "p", [ "and", "number", [ "[between]", 0, 1 ] ] ]
	    ]);

	    defineFunction("percentile.exc", _percentile_exc).args([
	        [ "numbers", [ "collect", "number", 1 ] ],
	        [ "p", [ "and", "number", [ "(between)", 0, 1 ] ] ]
	    ]);

	    defineFunction("quartile.inc", function(numbers, quarter){
	        return _percentile_inc(numbers, quarter / 4);
	    }).args([
	        [ "numbers", [ "collect", "number", 1 ] ],
	        [ "quarter", [ "values", 0, 1, 2, 3, 4 ] ]
	    ]);

	    defineFunction("quartile.exc", function(numbers, quarter){
	        return _percentile_exc(numbers, quarter / 4);
	    }).args([
	        [ "numbers", [ "collect", "number", 1 ] ],
	        [ "quarter", [ "values", 0, 1, 2, 3, 4 ] ]
	    ]);

	    defineAlias("quartile", "quartile.inc");
	    defineAlias("percentile", "percentile.inc");

	    var AGGREGATE_FUNCS = [
	        "AVERAGE", "COUNT", "COUNTA", "MAX", "MIN", "PRODUCT",
	        "STDEV.S", "STDEV.P", "SUM", "VAR.S", "VAR.P", "MEDIAN",
	        "MODE.SNGL", "LARGE", "SMALL", "PERCENTILE.INC",
	        "QUARTILE.INC", "PERCENTILE.EXC", "QUARTILE.EXC"
	    ];

	    function fetchValuesForAggregate(self, args, options) {
	        var values = [];
	        var opt_ignore_hidden_rows = 1;
	        var opt_ignore_errors = 2;
	        var opt_use_aggregates = 4;
	        (function fetchValues(args) {
	            if (args instanceof Ref) {
	                self.getRefCells(args, true).forEach(function(cell){
	                    var value = cell.value;
	                    if ((options & opt_ignore_hidden_rows) && cell.hidden) {
	                        return;
	                    }
	                    if (cell.formula) {
	                        // XXX: formula.print is fast, but still, can't we do any better here?
	                        //      perhaps access the input string directly somehow?
	                        var str = cell.formula.print(cell.row, cell.col);
	                        if (/^\s*(?:aggregate|subtotal)\s*\(/i.test(str)) {
	                            if (!(options & opt_use_aggregates)) {
	                                return;
	                            }
	                        }
	                    }
	                    if ((options & opt_ignore_errors) && value instanceof CalcError) {
	                        return;
	                    }
	                    if (typeof value == "number" || value instanceof CalcError) {
	                        values.push(value);
	                    }
	                });
	            } else if (Array.isArray(args)) {
	                for (var i = 0; i < args.length; ++i) {
	                    fetchValues(args[i]);
	                }
	            } else if (args instanceof Matrix) {
	                args.each(fetchValues);
	            } else if (typeof args == "number") {
	                values.push(args);
	            } else if (args instanceof CalcError && !(options & opt_ignore_errors)) {
	                values.push(args);
	            }
	        })(args);
	        return values;
	    }

	    // AGGREGATE function
	    //
	    // https://support.office.com/en-SG/article/aggregate-function-c8caed56-07df-4aeb-9741-23693ffbe525
	    //
	    // we can only partially type-check this function.  also, we need to use the async version in
	    // order to resolve references and delegate values to the function to aggregate.
	    defineFunction("aggregate", function(callback, funcId, options, args){
	        // options is a bit field.  that makes sense; it's the documentation which doesn't.
	        var self = this;
	        self.resolveCells(args, function(){
	            var values;
	            if (funcId > 12) {
	                // "array form"
	                values = fetchValuesForAggregate(self, args[0], options);
	                var k = args[1];
	                if (k instanceof CellRef) {
	                    k = self.getRefData(k);
	                }
	                if (typeof k != "number") {
	                    return callback(new CalcError("VALUE"));
	                }
	            } else {
	                values = fetchValuesForAggregate(self, args, options);
	            }
	            self.func(AGGREGATE_FUNCS[funcId - 1], callback, values);
	        });
	    }).argsAsync([
	        [ "funcId", [ "values", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
	                      11, 12, 13, 14, 15, 16, 17, 18, 19 ] ],
	        [ "options", [ "or",
	                       [ "null", 0 ],
	                       [ "values", 0, 1, 2, 3, 4, 5, 6, 7  ] ] ],
	        [ "args", "rest" ]
	    ]);

	    defineFunction("subtotal", function(callback, funcId){
	        var self = this;
	        var ignoreHidden = funcId > 100;
	        if (ignoreHidden) {
	            funcId -= 100;
	        }
	        var args = [];
	        for (var i = 2; i < arguments.length; ++i) {
	            args.push(arguments[i]);
	        }
	        self.resolveCells(args, function(){
	            var values = fetchValuesForAggregate(self, args, ignoreHidden ? 1 : 0);
	            self.func(AGGREGATE_FUNCS[funcId - 1], callback, values);
	        });
	    }).argsAsync([
	        [ "funcId", [ "values", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
	                      101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111 ] ],
	        [ "+", [ "ref", [ "or", "ref", "#matrix" ] ] ]
	    ]);

	    // https://support.office.com/en-sg/article/AVEDEV-function-ec78fa01-4755-466c-9a2b-0c4f9eacaf6d
	    defineFunction("avedev", function(numbers){
	        var avg = numbers.reduce(function(sum, num){
	            return sum + num;
	        }, 0) / numbers.length;
	        return numbers.reduce(function(sum, num){
	            return sum + Math.abs(num - avg);
	        }, 0) / numbers.length;
	    }).args([
	        [ "numbers", [ "collect", "number" ] ],
	        [ "?", [ "assert", "$numbers.length >= 2", "NUM" ] ]
	    ]);

	    function _binom_dist(x, n, p, cumulative) {
	        if (!cumulative) {
	            return _combinations(n, x) * Math.pow(p, x) * Math.pow(1-p, n-x);
	        } else {
	            var sum = 0;
	            for (var j = 0; j <= x; ++j) {
	                sum += _combinations(n, j) * Math.pow(p, j) * Math.pow(1-p, n-j);
	            }
	            return sum;
	        }
	    }

	    defineFunction("binom.dist", _binom_dist).args([
	        [ "successes", "integer+" ],
	        [ "trials", [ "and", "integer", [ "assert", "$trials >= $successes" ] ] ],
	        [ "probability", [ "and", "number", [ "[between]", 0, 1 ] ] ],
	        [ "cumulative", "logical" ]
	    ]);

	    defineAlias("binomdist", "binom.dist");

	    defineFunction("binom.inv", function(n, p, alpha){
	        // XXX: could a binary search be faster?
	        for (var x = 0; x <= n; ++x) {
	            if (_binom_dist(x, n, p, true) >= alpha) {
	                return x;
	            }
	        }
	        return new CalcError("N/A"); // XXX: is this right?
	    }).args([
	        [ "trials", "integer+" ],
	        [ "probability", [ "and", "number", [ "[between]", 0, 1 ] ] ],
	        [ "alpha", [ "and", "number", [ "[between]", 0, 1 ] ] ]
	    ]);

	    defineAlias("critbinom", "binom.inv");

	    defineFunction("binom.dist.range", function(n, p, s, s2){
	        var sum = 0;
	        for (var k = s; k <= s2; ++k) {
	            sum += _combinations(n, k) * Math.pow(p, k) * Math.pow(1-p, n-k);
	        }
	        return sum;
	    }).args([
	        [ "trials", "integer+" ],
	        [ "probability", [ "and", "number", [ "[between]", 0, 1 ] ] ],
	        [ "successes_min", [ "and", "integer", [ "[between]", 0, "$trials" ] ] ],
	        [ "successes_max", [ "or",
	                             [ "and", "integer",
	                               [ "[between]", "$successes_min", "$trials" ] ],
	                             [ "null", "$successes_min" ] ] ]
	    ]);

	    defineFunction("negbinom.dist", function(x, k, p, cumulative){
	        if (cumulative) {
	            var sum = 0;
	            while (x >= 0) {
	                sum += _combinations(x+k-1, x) * Math.pow(p, k) * Math.pow(1-p, x);
	                x--;
	            }
	            return sum;
	        }
	        return _combinations(x+k-1, x) * Math.pow(p, k) * Math.pow(1-p, x);
	    }).args([
	        [ "number_f", "integer+" ],
	        [ "number_s", "integer+" ],
	        [ "probability_s", [ "and", "number", [ "[between]", 0, 1 ] ] ],
	        [ "cumulative", "logical" ]
	    ]);

	    defineAlias("negbinomdist", "negbinom.dist");

	    /* -----[ lookup functions ]----- */

	    defineFunction("address", function(row, col, abs, a1, sheet){
	        // by some lucky coincidence, we get the corret `rel` value by just subtracting 1 from the
	        // abs argument
	        var cell = new CellRef(row - 1, col - 1, abs - 1);
	        if (sheet) {
	            cell.setSheet(sheet, true);
	        }
	        return a1 ? cell.print(0, 0) : cell.print();
	    }).args([
	        [ "row", "integer++" ],
	        [ "col", "integer++" ],
	        [ "abs", [ "or", [ "null", 1 ], [ "values", 1, 2, 3, 4 ]]],
	        [ "a1", [ "or", [ "null", true ], "logical" ]],
	        [ "sheet", [ "or", "null", "string" ]]
	    ]);

	    defineFunction("areas", function(ref){
	        var count = 0;
	        (function loop(x){
	            if (x instanceof CellRef || x instanceof RangeRef) {
	                count++;
	            } else if (x instanceof UnionRef) {
	                x.refs.forEach(loop);
	            }
	            // XXX: NameRef if we add support
	        })(ref);
	        return count;
	    }).args([
	        [ "ref", "ref" ]
	    ]);

	    defineFunction("choose", function(index, args){
	        if (index > args.length) {
	            return new CalcError("N/A");
	        } else {
	            return args[index - 1];
	        }
	    }).args([
	        [ "*index", "integer" ],
	        [ "+", [ "value", "anything" ] ]
	    ]);

	    defineFunction("column", function(ref){
	        if (!ref) {
	            return this.formula.col + 1;
	        }
	        if (ref instanceof CellRef) {
	            return ref.col + 1;
	        }
	        return this.asMatrix(ref).mapCol(function(col){
	            return col + ref.topLeft.col + 1;
	        });
	    }).args([
	        [ "ref", [ "or", "area", "null" ]]
	    ]);

	    defineFunction("columns", function(m){
	        return m instanceof Ref ? m.width() : m.width;
	    }).args([
	        [ "ref", [ "or", "area", "#matrix" ] ]
	    ]);

	    defineFunction("formulatext", function(ref){
	        var cell = this.getRefCells(ref)[0]; // XXX: overkill, but oh well.
	        if (!cell.formula) {
	            return new CalcError("N/A");
	        }
	        return cell.formula.print(cell.row, cell.col);
	    }).args([
	        [ "ref", "ref" ]
	    ]);

	    defineFunction("hlookup", function(value, m, row, approx){
	        var resultCol = null;
	        m.eachCol(function(col){
	            var data = m.get(0, col);
	            if (approx) {
	                if (data > value) {
	                    return true;
	                }
	                resultCol = col;
	            } else if (data === value) {
	                resultCol = col;
	                return true;
	            }
	        });
	        if (resultCol == null) {
	            return new CalcError("N/A");
	        }
	        return m.get(row - 1, resultCol);
	    }).args([
	        [ "value", "anyvalue" ],
	        [ "range", "matrix" ],
	        [ "row", "integer++" ],
	        [ "approx", [ "or", "logical", [ "null", true ]]]
	    ]);

	    defineFunction("index", function(callback, ref, row, col, areanum){
	        var self = this;
	        if (ref instanceof UnionRef) {
	            ref = ref.refs[areanum - 1];
	        }
	        if ((!row && !col) || !ref) {
	            return callback(new CalcError("N/A"));
	        }
	        if (ref instanceof CellRef) {
	            ref = ref.toRangeRef();
	        }
	        if (ref instanceof RangeRef) {
	            if (row && col) {
	                if (col > ref.width() || row > ref.height()) {
	                    return callback(new CalcError("REF"));
	                }
	                // fetching a single cell
	                var cell = ref.toCell(row - 1, col - 1);
	                self.resolveCells([ cell ], function(){
	                    callback(self.getRefData(cell));
	                });
	                return;
	            }
	            if (!row) {
	                // fetch a full column
	                var colRange = ref.toColumn(col - 1);
	                self.resolveCells([ colRange ], function(){
	                    callback(self.asMatrix(colRange));
	                });
	                return;
	            }
	            if (!col) {
	                // fetch a full row
	                var rowRange = ref.toRow(row - 1);
	                self.resolveCells([ rowRange ], function(){
	                    callback(self.asMatrix(rowRange));
	                });
	                return;
	            }
	        }
	        else if (ref instanceof Matrix) {
	            if (ref.width > 1 && ref.height > 1) {
	                if (row && col) {
	                    return callback(ref.get(row - 1, col - 1));
	                }
	                if (!row) {
	                    return callback(ref.mapRow(function(row){
	                        return ref.get(row, col - 1);
	                    }));
	                }
	                if (!col) {
	                    return callback(ref.mapCol(function(col){
	                        return ref.get(row - 1, col);
	                    }));
	                }
	            }
	            if (ref.width == 1) {
	                return callback(ref.get(row - 1, 0));
	            }
	            if (ref.height == 1) {
	                return callback(ref.get(0, col - 1));
	            }
	        }
	        else {
	            callback(new CalcError("REF"));
	        }
	    }).argsAsync([
	        [ "range", [ "or", "ref", "matrix" ] ],
	        [ "row", [ "or", "integer+", "null" ] ],
	        [ "col", [ "or", "integer+", "null" ] ],
	        [ "areanum", [ "or", "integer++", [ "null", 1 ] ] ]
	    ]);

	    defineFunction("indirect", function(thing){
	        try {
	            // XXX: does more work than needed.  we could go for parseReference, but that one
	            // doesn't (yet?) support "SheetName!" prefix.
	            var f = this.formula;
	            var exp = calc.parseFormula(f.sheet, f.row, f.col, thing);
	            var ref = exp.ast;
	            if (ref instanceof NameRef) {
	                ref = this.ss.nameValue(ref, f.sheet, f.row, f.col);
	            }
	            if (!(ref instanceof Ref)) {
	                throw 1;
	            }
	            return ref.absolute(f.row, f.col);
	        } catch(ex) {
	            return new CalcError("REF");
	        }
	    }).args([
	        [ "thing", "string" ]
	    ]);

	    // XXX: LOOKUP.  seems to be deprecated in favor of HLOOKUP/VLOOKUP

	    // XXX: double-check this one.
	    defineFunction("match", function(val, m, type){
	        var index = 1, cmp;
	        if (type === 0) {
	            cmp = parseCriteria(val);
	        } else if (type === -1) {
	            cmp = parseCriteria("<=" + val);
	        } else if (type === 1) {
	            cmp = parseCriteria(">=" + val);
	        }
	        if (m.each(function(el){
	            if (el != null && cmp(el)) {
	                if (type !== 0 && val != el) {
	                    --index;
	                }
	                return true;
	            }
	            index++;
	        }, true) && index > 0) {
	            return index;
	        } else {
	            return new CalcError("N/A");
	        }
	    }).args([
	        [ "value", "anyvalue" ],
	        [ "range", "matrix" ],
	        [ "type", [ "or",
	                    [ "values", -1, 0, 1 ],
	                    [ "null", 1 ]]]
	    ]);

	    defineFunction("offset", function(ref, rows, cols, height, width){
	        var topLeft = (ref instanceof CellRef ? ref : ref.topLeft).clone();
	        topLeft.row += rows;
	        topLeft.col += cols;
	        if (topLeft.row < 0 || topLeft.col < 0) {
	            return new CalcError("VALUE");
	        }
	        if (height > 1 || width > 1) {
	            return new RangeRef(topLeft, new CellRef(topLeft.row + height - 1,
	                                                     topLeft.col + width - 1))
	                .setSheet(ref.sheet, ref.hasSheet());
	        }
	        return topLeft;
	    }).args([
	        [ "ref", "area" ],
	        [ "*rows", "integer" ],
	        [ "*cols", "integer" ],
	        [ "*height", [ "or", "integer++", [ "null", "$ref.height()" ]]],
	        [ "*width", [ "or", "integer++", [ "null", "$ref.width()" ]]]
	    ]);

	    defineFunction("row", function(ref){
	        if (!ref) {
	            return this.formula.row + 1;
	        }
	        if (ref instanceof CellRef) {
	            return ref.row + 1;
	        }
	        return this.asMatrix(ref).mapRow(function(row){
	            return row + ref.topLeft.row + 1;
	        });
	    }).args([
	        [ "ref", [ "or", "area", "null" ]]
	    ]);

	    defineFunction("rows", function(m){
	        return m instanceof Ref ? m.height() : m.height;
	    }).args([
	        [ "ref", [ "or", "area", "#matrix" ] ]
	    ]);

	    defineFunction("vlookup", function(value, m, col, approx){
	        var resultRow = null;
	        if (typeof value != "number") {
	            approx = false;
	        }
	        if (typeof value == "string") {
	            value = value.toLowerCase();
	        }
	        m.eachRow(function(row){
	            var data = m.get(row, 0);
	            if (approx) {
	                if (data > value) {
	                    return true;
	                }
	                resultRow = row;
	            } else {
	                if (typeof data == "string") {
	                    data = data.toLowerCase();
	                }
	                if (data === value) {
	                    resultRow = row;
	                    return true;
	                }
	            }
	        });
	        if (resultRow == null) {
	            return new CalcError("N/A");
	        }
	        return m.get(resultRow, col - 1);
	    }).args([
	        [ "value", "anyvalue" ],
	        [ "range", "matrix" ],
	        [ "col", "integer++" ],
	        [ "approx", [ "or", "logical", [ "null", true ]]]
	    ]);

	    /* -----[ Date and time functions ]----- */

	    defineFunction("date", function(year, month, date){
	        return packDate(year, month-1, date);
	    }).args([
	        [ "*year", "integer" ],
	        [ "*month", "integer" ],
	        [ "*date", "integer" ]
	    ]);

	    defineFunction("day", function(date){
	        return unpackDate(date).date;
	    }).args([
	        [ "*date", "date" ]
	    ]);

	    defineFunction("month", function(date){
	        return unpackDate(date).month + 1;
	    }).args([
	        [ "*date", "date" ]
	    ]);

	    defineFunction("year", function(date){
	        return unpackDate(date).year;
	    }).args([
	        [ "*date", "date" ]
	    ]);

	    defineFunction("weekday", function(date){
	        // XXX: TODO type
	        return unpackDate(date).day + 1;
	    }).args([
	        [ "*date", "date" ]
	    ]);

	    // https://support.office.com/en-GB/article/WEEKNUM-function-e5c43a03-b4ab-426c-b411-b18c13c75340
	    // XXX: this is a mess.
	    defineFunction("weeknum", function(date, type){
	        var fw = packDate(unpackDate(date).year, 0, 1);
	        var sy = unpackDate(fw);
	        var diff;
	        if (type == 21) {
	            // Monday-based weeks, first week is the one containing the first Thursday of the year
	            // we want to place in fw and sy the first Thursday
	            diff = 3 - (sy.day + 6) % 7;
	            if (diff < 0) {
	                diff += 7;
	            }
	            fw += diff;
	            sy.date += diff;
	            sy.day = 4;         // Thursday.
	            type = 1;
	        } else {
	            if (type == 1) {
	                type = 0;
	            } else if (type == 2) {
	                type = 1;
	            } else {
	                type = (type - 10) % 7;
	            }
	            // finally compatible with what we got:
	            // type == 0 means week starts on Sunday
	            //         1                      Monday
	            //         2                      Tuesday
	            // ...
	        }
	        diff = sy.day - type;
	        if (diff < 0) {
	            diff += 7;
	        }
	        fw -= diff;
	        return Math.ceil((date + 1 - fw) / 7);
	    }).args([
	        [ "*date", "date" ],
	        [ "*type", [ "or", [ "null", 1 ],
	                     [ "values", 1, 2, 11, 12, 13, 14, 15, 16, 17, 21 ] ] ]
	    ]);

	    function weeksInYear(year) {
	        var d = unpackDate(packDate(year, 0, 1));
	        if ((d.day == 4) || (d.day == 3 && runtime.isLeapYear(year))) {
	            // long year
	            return 53;
	        }
	        return 52;
	    }

	    defineFunction("isoweeknum", function isoweeknum(date){
	        // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_the_week_number_of_a_given_date
	        var d = unpackDate(date);
	        var dow = d.day || 7;
	        var wk = Math.floor((d.ord - dow + 10) / 7);
	        if (wk < 1) {
	            return weeksInYear(d.year - 1);
	        } else if (wk == 53 && wk > weeksInYear(d.year)) {
	            return 1;
	        }
	        return wk;
	    }).args([
	        [ "*date", "date" ]
	    ]);

	    defineFunction("now", function(){
	        return runtime.dateToSerial(new Date());
	    }).args([]);

	    defineFunction("today", function(){
	        return runtime.dateToSerial(new Date()) | 0;
	    }).args([]);

	    defineFunction("time", function(hh, mm, ss){
	        return runtime.packTime(hh, mm, ss, 0);
	    }).args([
	        [ "*hours", "integer" ],
	        [ "*minutes", "integer" ],
	        [ "*seconds", "integer" ]
	    ]);

	    defineFunction("hour", function(time){
	        return runtime.unpackTime(time).hours;
	    }).args([
	        [ "*time", "datetime" ]
	    ]);

	    defineFunction("minute", function(time){
	        return runtime.unpackTime(time).minutes;
	    }).args([
	        [ "*time", "datetime" ]
	    ]);

	    defineFunction("second", function(time){
	        return runtime.unpackTime(time).seconds;
	    }).args([
	        [ "*time", "datetime" ]
	    ]);

	    defineFunction("edate", function(base, months){
	        var d = unpackDate(base);
	        var m = d.month + months;
	        var y = d.year + Math.floor(m/12);
	        m %= 12;
	        if (m < 0) {
	            m += 12;
	        }
	        d = Math.min(d.date, daysInMonth(y, m));
	        return packDate(y, m, d);
	    }).args([
	        [ "*start_date", "date" ],
	        [ "*months", "integer" ]
	    ]);

	    defineFunction("eomonth", function(base, months){
	        var d = unpackDate(base);
	        var m = d.month + months;
	        var y = d.year + Math.floor(m/12);
	        m %= 12;
	        if (m < 0) {
	            m += 12;
	        }
	        d = daysInMonth(y, m);
	        return packDate(y, m, d);
	    }).args([
	        [ "*start_date", "date" ],
	        [ "*months", "integer" ]
	    ]);

	    defineFunction("workday", function(date, n, holidays){
	        // XXX: the algorithm here is pretty dumb, can we do better?
	        var inc = n > 0 ? 1 : -1;
	        n = Math.abs(n);
	        var dow = unpackDate(date).day;
	        while (n > 0) {
	            date += inc;
	            dow = (dow + inc) % 7;
	            if (dow > 0 && dow < 6 && holidays.indexOf(date) < 0) {
	                --n;
	            }
	        }
	        return date;
	    }).args([
	        [ "start_date", "date" ],
	        [ "days", "integer" ],
	        [ "holidays", [ "collect", "date" ] ]
	    ]);

	    defineFunction("networkdays", function(date, end, holidays){
	        // XXX: the algorithm here is pretty dumb, can we do better?
	        if (date > end) {
	            var tmp = date;
	            date = end;
	            end = tmp;
	        }
	        var count = 0;
	        var dow = unpackDate(date).day;
	        while (date <= end) {
	            if (dow > 0 && dow < 6 && holidays.indexOf(date) < 0) {
	                count++;
	            }
	            date++;
	            dow = (dow + 1) % 7;
	        }
	        return count;
	    }).args([
	        [ "start_date", "date" ],
	        [ "end_date", "date" ],
	        [ "holidays", [ "collect", "date" ] ]
	    ]);

	    defineFunction("days", function(start, end){
	        return end - start;
	    }).args([
	        [ "*start_date", "date" ],
	        [ "*end_date", "date" ]
	    ]);

	    function _days_360(start, end, method) {
	        var d1 = unpackDate(start);
	        var d2 = unpackDate(end);

	        // https://en.wikipedia.org/wiki/360-day_calendar
	        // humanity is a mess.
	        if (method) {
	            // EU method
	            if (d1.date == 31) {
	                d1.date = 30;
	            }
	            if (d2.date == 31) {
	                d2.date = 30;
	            }
	        } else {
	            // US method
	            if (d1.month == 1 && d2.month == 1
	                && d1.date == daysInMonth(d1.year, 1)
	                && d2.date == daysInMonth(d2.year, 1)) {
	                d2.date = 30;
	            }
	            if (d1.date == daysInMonth(d1.year, d1.month)) {
	                d1.date = 30;
	                if (d2.date == 31) {
	                    d2.date = 30;
	                }
	            } else {
	                if (d1.date == 30 && d2.date == 31) {
	                    d2.date = 30;
	                }
	            }
	        }

	        return (360 * (d2.year - d1.year)
	                + 30 * (d2.month - d1.month)
	                + (d2.date - d1.date));
	    }

	    runtime._days_360 = _days_360;

	    defineFunction("days360", _days_360).args([
	        [ "*start_date", "date" ],
	        [ "*end_date", "date" ],
	        [ "*method", [ "or", "logical", [ "null", false ] ] ]
	    ]);

	    defineFunction("yearfrac", function(start, end, method){
	        switch (method) {
	          case 0:
	            return _days_360(start, end, false) / 360;
	          case 1:
	            return (end - start) / daysInYear(unpackDate(start).year);
	          case 2:
	            return (end - start) / 360;
	          case 3:
	            return (end - start) / 365;
	          case 4:
	            return _days_360(start, end, true) / 360;
	        }
	    }).args([
	        [ "*start_date", "date" ],
	        [ "*end_date", "date" ],
	        [ "*method", [ "or", [ "null", 0 ], [ "values", 0, 1, 2, 3, 4 ] ] ]
	    ]);

	    defineFunction("datevalue", function(text){
	        var date = runtime.parseDate(text);
	        if (date) {
	            return runtime.dateToSerial(date);
	        }
	        return new CalcError("VALUE");
	    }).args([
	        [ "*text", "string" ]
	    ]);

	    defineFunction("timevalue", function(text){
	        var m = text.toLowerCase().match(/(\d+):(\d+)(:(\d+)(\.(\d+))?)?\s*(am?|pm?)?/);
	        if (m) {
	            var hh = parseFloat(m[1]);
	            var mm = parseFloat(m[2]);
	            var ss = m[3] ? parseFloat(m[4]) : 0;
	            //var ms = m[5] ? parseFloat(m[6]) : 0;
	            var ampm = m[7];
	            if (ampm && (hh > 12 || hh < 1)) {
	                return new CalcError("VALUE");
	            }
	            if (/^p/.test(ampm)) {
	                hh += 12;
	            }
	            return runtime.packTime(hh, mm, ss, 0);
	        }
	        return new CalcError("VALUE");
	    }).args([
	        [ "*text", "string" ]
	    ]);

	    /* -----[ Matrix functions ]----- */

	    defineFunction("mdeterm", function(m){
	        var error = m.each(function(val){
	            if (typeof val != "number") {
	                return new CalcError("VALUE");
	            }
	        }, true);
	        return error || m.determinant();
	    }).args([
	        [ "m", [ "and", "matrix",
	                 [ "assert", "$m.width == $m.height" ] ] ]
	    ]);

	    defineFunction("transpose", function(m){
	        return m.transpose();
	    }).args([
	        [ "range", "matrix" ]
	    ]);

	    defineFunction("mmult", function(a, b){
	        return a.multiply(b);
	    }).args([
	        [ "a", "matrix" ],
	        [ "b", [ "and", "matrix",
	                 [ "assert", "$b.height == $a.width" ] ] ]
	    ]);

	    defineFunction("munit", function(n){
	        return new Matrix(this).unit(n);
	    }).args([
	        [ "n", "integer+" ]
	    ]);

	    defineFunction("minverse", function(m){
	        var error = m.each(function(val){
	            if (typeof val != "number") {
	                return new CalcError("VALUE");
	            }
	        }, true);
	        return error || m.inverse() || new CalcError("VALUE");
	    }).args([
	        [ "m", [ "and", "matrix",
	                 [ "assert", "$m.width == $m.height" ] ] ]
	    ]);

	    /* -----[ Other ]----- */

	    defineFunction("rand", function() {
	        return Math.random();
	    }).args([]);

	    defineFunction("randbetween", function(min, max){
	        return min + Math.floor((max - min + 1) * Math.random());
	    }).args([
	        [ "min", "integer" ],
	        [ "max", [ "and", "integer", [ "assert", "$max >= $min" ] ] ]
	    ]);

	    defineFunction("true", function(){
	        return true;
	    }).args([]);

	    defineFunction("false", function(){
	        return true;
	    }).args([]);

	    defineFunction("roman", function(num){
	        return util.arabicToRoman(num).toUpperCase();
	    }).args([
	        [ "*number", "integer" ]
	    ]);

	    defineFunction("arabic", function(rom){
	        var num = util.romanToArabic(rom);
	        return num == null ? new CalcError("VALUE") : num;
	    }).args([
	        [ "*roman", "string" ]
	    ]);

	    defineFunction("base", function(number, radix, minLen){
	        var str = number.toString(radix).toUpperCase();
	        while (str.length < minLen) {
	            str = "0" + str;
	        }
	        return str;
	    }).args([
	        [ "*number", "integer" ],
	        [ "*radix", [ "and", "integer", [ "[between]", 2, 36 ] ] ],
	        [ "*minLen", [ "or", "integer+", [ "null", 0 ] ] ]
	    ]);

	    defineFunction("decimal", function(text, radix){
	        text = text.toUpperCase();
	        var val = 0;
	        for (var i = 0; i < text.length; ++i) {
	            var d = text.charCodeAt(i);
	            if (d >= 48 && d <= 57) {
	                d -= 48;
	            } else if (d >= 65 && d < (55 + radix)) {
	                d -= 55;
	            } else {
	                return new CalcError("VALUE");
	            }
	            val = val * radix + d;
	        }
	        return val;
	    }).args([
	        [ "*text", "string" ],
	        [ "*radix", [ "and", "integer", [ "[between]", 2, 36 ] ] ]
	    ]);

	    /* -----[ String functions ]----- */

	    defineFunction("char", function(code){
	        return String.fromCharCode(code);
	    }).args([
	        [ "*code", "integer+" ]
	    ]);

	    // From XRegExp
	    var RX_NON_PRINTABLE = /[\0-\x1F\x7F-\x9F\xAD\u0378\u0379\u037F-\u0383\u038B\u038D\u03A2\u0528-\u0530\u0557\u0558\u0560\u0588\u058B-\u058E\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u0605\u061C\u061D\u06DD\u070E\u070F\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08A1\u08AD-\u08E3\u08FF\u0978\u0980\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0C00\u0C04\u0C0D\u0C11\u0C29\u0C34\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5A-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C80\u0C81\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D01\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D4F-\u0D56\u0D58-\u0D5F\u0D64\u0D65\u0D76-\u0D78\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F5-\u13FF\u169D-\u169F\u16F1-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191D-\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C80-\u1CBF\u1CC8-\u1CCF\u1CF7-\u1CFF\u1DE7-\u1DFB\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u200B-\u200F\u202A-\u202E\u2060-\u206F\u2072\u2073\u208F\u209D-\u209F\u20BB-\u20CF\u20F1-\u20FF\u218A-\u218F\u23F4-\u23FF\u2427-\u243F\u244B-\u245F\u2700\u2B4D-\u2B4F\u2B5A-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E3C-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FCD-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA698-\uA69E\uA6F8-\uA6FF\uA78F\uA794-\uA79F\uA7AB-\uA7F7\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C5-\uA8CD\uA8DA-\uA8DF\uA8FC-\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9E0-\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAA7C-\uAA7F\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F-\uABBF\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE27-\uFE2F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD-\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF]/g;

	    defineFunction("clean", function(text){
	        return text.replace(RX_NON_PRINTABLE, "");
	    }).args([
	        [ "*text", "string" ]
	    ]);

	    defineFunction("code", function(text){
	        return text.charAt(0);
	    }).args([
	        [ "*text", "string" ]
	    ]);

	    defineAlias("unichar", "char");
	    defineAlias("unicode", "code");

	    defineFunction("concatenate", function(args){
	        var out = "";
	        for (var i = 0; i < args.length; ++i) {
	            out += args[i];
	        }
	        return out;
	    }).args([
	        [ "+",
	          [ "*text", "string" ] ]
	    ]);

	    defineFunction("dollar", function(number, decimals){
	        var format = "$#,##0DECIMALS;($#,##0DECIMALS)";
	        var dec = "";
	        var denomitator = 1;

	        while (decimals-- > 0) {
	          dec += "0";
	        }

	        while (++decimals < 0) {
	          denomitator *= 10;
	        }

	        if (dec !== "") {
	          dec = "." + dec;
	        } else if (denomitator !== 1) {
	            number = Math.round(number / denomitator) * denomitator;
	        }

	        format = format.replace(/DECIMALS/g, dec);

	        return spreadsheet.formatting.text(number, format);
	    }).args([
	        [ "*number", "number" ],
	        [ "*decimals", [ "or", "integer", [ "null", 2 ] ] ]
	    ]);

	    defineFunction("exact", function(a, b){
	        return a === b;
	    }).args([
	        [ "*text1", "string" ],
	        [ "*text2", "string" ]
	    ]);

	    defineFunction("find", function(substring, string, start){
	        var pos = string.indexOf(substring, start - 1);
	        return pos < 0 ? new CalcError("VALUE") : pos + 1;
	    }).args([
	        [ "*substring", "string" ],
	        [ "*string", "string" ],
	        [ "*start", [ "or", "integer++", [ "null", 1 ] ] ]
	    ]);

	    defineFunction("fixed", function(number, decimals, noCommas){
	        var scale = Math.pow(10, decimals);
	        number = Math.round(number * scale) / scale;
	        var format = noCommas ? "0" : "#,##0";
	        if (decimals > 0) {
	            format += ".";
	            while (decimals-- > 0) { format += "0"; }
	        }
	        return spreadsheet.formatting.text(number, format);
	    }).args([
	        [ "*number", "number" ],
	        [ "*decimals", [ "or", "integer", [ "null", 2 ] ] ],
	        [ "*noCommas", [ "or", "boolean", [ "null", false ] ] ]
	    ]);

	    defineFunction("left", function(text, length){
	        return text.substr(0, length);
	    }).args([
	        [ "*text", "string" ],
	        [ "*length", [ "or", "integer+", [ "null", 1 ] ] ]
	    ]);

	    defineFunction("right", function(text, length){
	        return text.substr(-length);
	    }).args([
	        [ "*text", "string" ],
	        [ "*length", [ "or", "integer+", [ "null", 1 ] ] ]
	    ]);

	    defineFunction("len", function(text){
	        return text.length;
	    }).args([
	        [ "*text", "string" ]
	    ]);

	    defineFunction("lower", function(text){
	        return text.toLowerCase();
	    }).args([
	        [ "*text", "string" ]
	    ]);

	    defineFunction("upper", function(text){
	        return text.toUpperCase();
	    }).args([
	        [ "*text", "string" ]
	    ]);

	    defineFunction("ltrim", function(text){
	        return text.replace(/^\s+/, "");
	    }).args([
	        [ "*text", "string" ]
	    ]);

	    defineFunction("rtrim", function(text){
	        return text.replace(/\s+$/, "");
	    }).args([
	        [ "*text", "string" ]
	    ]);

	    defineFunction("trim", function(text){
	        return text.replace(/^\s+|\s+$/, "");
	    }).args([
	        [ "*text", "string" ]
	    ]);

	    defineFunction("mid", function(text, start, length){
	        return text.substr(start - 1, length);
	    }).args([
	        [ "*text", "string" ],
	        [ "*start", "integer++" ],
	        [ "*length", "integer+" ]
	    ]);

	    defineFunction("proper", function(text){
	        return text.toLowerCase().replace(/\b./g, function(s){
	            return s.toUpperCase();
	        });
	    }).args([
	        [ "*text", "string" ]
	    ]);

	    defineFunction("replace", function(text, start, length, newText){
	        return text.substr(0, --start) + newText + text.substr(start + length);
	    }).args([
	        [ "*text", "string" ],
	        [ "*start", "integer++" ],
	        [ "*length", "integer+" ],
	        [ "*newText", "string" ]
	    ]);

	    defineFunction("rept", function(text, number){
	        var out = "";
	        while (number-- > 0) { out += text; }
	        return out;
	    }).args([
	        [ "*text", "string" ],
	        [ "*number", "integer+" ]
	    ]);

	    defineFunction("search", function(substring, string, start){
	        var pos = string.toLowerCase().indexOf(substring.toLowerCase(), start - 1);
	        return pos < 0 ? new CalcError("VALUE") : pos + 1;
	    }).args([
	        [ "*substring", "string" ],
	        [ "*string", "string" ],
	        [ "*start", [ "or", "integer++", [ "null", 1 ] ] ]
	    ]);

	    defineFunction("substitute", function(text, oldText, newText, nth){
	        if (oldText === newText) {
	            return text;
	        }
	        var a = text.split(oldText);
	        if (nth == null) {
	            return a.join(newText);
	        }
	        text = "";
	        nth--;
	        for (var i = 0; i < a.length; ++i) {
	            text += a[i];
	            if (i < a.length - 1) {
	                if (i === nth) {
	                    text += newText;
	                } else {
	                    text += oldText;
	                }
	            }
	        }
	        return text;
	    }).args([
	        [ "*text", "string" ],
	        [ "*oldText", "string" ],
	        [ "*newText", "string" ],
	        [ "*nth", [ "or", "integer++", "null" ] ]
	    ]);

	    defineFunction("t", function(value){
	        return typeof value == "string" ? value : "";
	    }).args([
	        [ "*value", "anyvalue" ]
	    ]);

	    defineFunction("text", function(value, format){
	        return spreadsheet.formatting.text(value, format);
	    }).args([
	        [ "*value", "anyvalue" ],
	        [ "*format", "string" ]
	    ]);

	    defineFunction("value", function(value){
	        if (typeof value == "number") {
	            return value;
	        }
	        if (typeof value == "boolean") {
	            return +value;
	        }
	        // XXX: this is dirty.  we need it so we can parse i.e. "$12,345.50"
	        value = (value+"").replace(/[$€,]/g, "");
	        value = parseFloat(value);
	        return isNaN(value) ? new CalcError("VALUE") : value;
	    }).args([
	        [ "*value", "anyvalue" ]
	    ]);

	    function Hyperlink(link, text) {
	        this.link = link;
	        this.text = text;
	    }
	    Hyperlink.prototype.toString = function() {
	        return this.text;
	    };

	    defineFunction("hyperlink", function(link, text){
	        return new Hyperlink(link, text);
	    }).args([
	        [ "*link", "string" ],
	        [ "*text", [ "or", "string", [ "null", "$link" ] ] ]
	    ]);

	    //// other misc functions

	    defineFunction("iferror", function(value, valueIfError){
	        return value instanceof CalcError ? valueIfError : value;
	    }).args([
	        [ "*value", "forced!" ],
	        [ "*value_if_error", "anyvalue!" ]
	    ]);

	    //// utils

	    var parseCriteria = (function(){
	        var RXCACHE = Object.create(null);

	        function makeComparator(cmp, x) {
	            if (typeof x == "string") {
	                var num = parseFloat(x);
	                if (!isNaN(num) && num == x) {
	                    x = num;
	                }
	            }
	            return function(a) {
	                var b = x;
	                if (typeof a == "string" && typeof b == "string") {
	                    a = a.toLowerCase();
	                    b = b.toLowerCase();
	                }
	                return cmp(a, b);
	            };
	        }

	        function lc(a) {
	            var num, str;
	            if (typeof a == "string") {
	                a = a.toLowerCase();
	            }
	            if (/^[0-9.]+%$/.test(a)) {
	                str = a.substr(0, a.length - 1);
	                num = parseFloat(str);
	                if (!isNaN(num) && num == str) {
	                    a = num / 100;
	                }
	            } else if (/^[0-9.]+$/.test(a)) {
	                num = parseFloat(a);
	                if (!isNaN(num) && num == a) {
	                    a = num;
	                }
	            }
	            return a;
	        }

	        function compLT(a, b) { return lc(a) < lc(b); }
	        function compLTE(a, b) { return lc(a) <= lc(b); }
	        function compGT(a, b) { return lc(a) > lc(b); }
	        function compGTE(a, b) { return lc(a) >= lc(b); }
	        function compNE(a, b) { return !compEQ(a, b); }
	        function compEQ(a, b) {
	            if (b instanceof RegExp) {
	                return b.test(a);
	            }
	            if (typeof a == "string" || typeof b == "string") {
	                // if either one is string, make sure both are strings
	                a = String(a);
	                b = String(b);
	            }
	            return lc(a) == lc(b);
	        }

	        return function(cmp) {
	            if (typeof cmp == "function") {
	                return cmp;
	            }
	            var m;
	            if ((m = /^=(.*)$/.exec(cmp))) {
	                return makeComparator(compEQ, m[1]);
	            }
	            if ((m = /^<>(.*)$/.exec(cmp))) {
	                return makeComparator(compNE, m[1]);
	            }
	            if ((m = /^<=(.*)$/.exec(cmp))) {
	                return makeComparator(compLTE, m[1]);
	            }
	            if ((m = /^<(.*)$/.exec(cmp))) {
	                return makeComparator(compLT, m[1]);
	            }
	            if ((m = /^>=(.*)$/.exec(cmp))) {
	                return makeComparator(compGTE, m[1]);
	            }
	            if ((m = /^>(.*)$/.exec(cmp))) {
	                return makeComparator(compGT, m[1]);
	            }
	            if (/[?*]/.exec(cmp)) {
	                // has wildchars
	                var rx = RXCACHE[cmp];
	                if (!rx) {
	                    rx = cmp.replace(/(~\?|~\*|[\]({\+\.\|\^\$\\})\[]|[?*])/g, function(s){
	                        switch (s) {
	                          case "~?" : return "\\?";
	                          case "~*" : return "\\*";
	                          case "?"  : return ".";
	                          case "*"  : return ".*";
	                          default   : return "\\" + s;
	                        }
	                    });
	                    rx = RXCACHE[cmp] = new RegExp("^" + rx + "$", "i");
	                }
	                return makeComparator(compEQ, rx);
	            }
	            return makeComparator(compEQ, cmp);
	        };
	    })();

	    function numericPredicate(val) {
	        return typeof val == "number"
	            || typeof val == "boolean"
	            || val == null
	            || val === "";
	    }

	    function ascending(a, b) {
	        return a === b ? 0 : a < b ? -1 : 1;
	    }

	    function descending(a, b) {
	        return a === b ? 0 : a < b ? 1 : -1;
	    }

	    // var m = new Matrix();
	    // m.data = [[1, 2, 3], [4, 1, 6], [7, 8, 9]];
	    // //m.data = [[0, 2, 1], [2, 6, 1], [1, 1, 4]];
	    // //m.data = [[1,4,1,1], [1,4,0,1], [2,3,1,2], [3,2,6,4]];
	    // m.width = m.height = 3;
	    // var x = m.inverse();
	    // x.dump();

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "5VQ+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "5Y6m":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(925);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 916:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("pV45");

/***/ }),

/***/ 922:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Rqq1");

/***/ }),

/***/ 925:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(922), __webpack_require__(916)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($, undefined) {
	    // Imports ================================================================
	    var proxy = $.proxy,

	        kendo = window.kendo,
	        Class = kendo.Class,
	        DataSource = kendo.data.DataSource,

	        dataviz = kendo.dataviz,
	        deepExtend = kendo.deepExtend,

	        g = kendo.geometry,

	        d = kendo.drawing,
	        Group = d.Group,

	        last = d.util.last,
	        defined = d.util.defined,

	        map = dataviz.map,
	        Location = map.Location,
	        Layer = map.layers.Layer;

	    // Implementation =========================================================
	    var ShapeLayer = Layer.extend({
	        init: function(map, options) {

	            this._pan = proxy(this._pan, this);

	            Layer.fn.init.call(this, map, options);

	            this.surface = d.Surface.create(this.element, {
	                width: map.scrollElement.width(),
	                height: map.scrollElement.height()
	            });

	            this._initRoot();

	            this.movable = new kendo.ui.Movable(this.surface.element);
	            this._markers = [];

	            this._click = this._handler("shapeClick");
	            this.surface.bind("click", this._click);

	            this._mouseenter = this._handler("shapeMouseEnter");
	            this.surface.bind("mouseenter", this._mouseenter);

	            this._mouseleave = this._handler("shapeMouseLeave");
	            this.surface.bind("mouseleave", this._mouseleave);

	            this._initDataSource();
	        },

	        options: {
	            autoBind: true
	        },

	        destroy: function() {
	            Layer.fn.destroy.call(this);

	            this.surface.destroy();
	            this.dataSource.unbind("change", this._dataChange);
	        },

	        setDataSource: function(dataSource) {
	            if (this.dataSource) {
	                this.dataSource.unbind("change", this._dataChange);
	            }

	            this.dataSource = kendo.data.DataSource.create(dataSource);
	            this.dataSource.bind("change", this._dataChange);

	            if (this.options.autoBind) {
	                this.dataSource.fetch();
	            }
	        },

	        _reset: function() {
	            Layer.fn._reset.call(this);
	            this._translateSurface();

	            if (this._data) {
	                this._load(this._data);
	            }
	        },

	        _initRoot: function() {
	            this._root = new Group();
	            this.surface.draw(this._root);
	        },

	        _beforeReset: function() {
	            this.surface.clear();
	            this._initRoot();
	        },

	        _resize: function() {
	            this.surface.size(this.map.size());
	        },

	        _initDataSource: function() {
	            var dsOptions = this.options.dataSource;
	            this._dataChange = proxy(this._dataChange, this);
	            this.dataSource = DataSource
	                .create(dsOptions)
	                .bind("change", this._dataChange);

	            if (dsOptions && this.options.autoBind) {
	                this.dataSource.fetch();
	            }
	        },

	        _dataChange: function(e) {
	            this._data = e.sender.view();
	            this._load(this._data);
	        },

	        _load: function(data) {
	            this._clearMarkers();

	            if (!this._loader) {
	                this._loader = new GeoJSONLoader(this.map, this.options.style, this);
	            }

	            var container = new Group();
	            for (var i = 0; i < data.length; i++) {
	                var shape = this._loader.parse(data[i]);
	                if (shape) {
	                    container.append(shape);
	                }
	            }

	            this._root.clear();
	            this._root.append(container);
	        },

	        shapeCreated: function(shape) {
	            var cancelled = false;
	            if (shape instanceof d.Circle) {
	                cancelled = defined(this._createMarker(shape));
	            }

	            if (!cancelled) {
	                var args = { layer: this, shape: shape };
	                cancelled = this.map.trigger("shapeCreated", args);
	            }

	            return cancelled;
	        },

	        featureCreated: function(e) {
	            e.layer = this;
	            this.map.trigger("shapeFeatureCreated", e);
	        },

	        _createMarker: function(shape) {
	            var marker = this.map.markers.bind({
	                location: shape.location
	            }, shape.dataItem);

	            if (marker) {
	                this._markers.push(marker);
	            }

	            return marker;
	        },

	        _clearMarkers: function() {
	            for (var i = 0; i < this._markers.length; i++) {
	                this.map.markers.remove(this._markers[i]);
	            }
	            this._markers = [];
	        },

	        _pan: function() {
	            if (!this._panning) {
	                this._panning = true;
	                this.surface.suspendTracking();
	            }
	        },

	        _panEnd: function(e) {
	            Layer.fn._panEnd.call(this, e);
	            this._translateSurface();
	            this.surface.resumeTracking();
	            this._panning = false;
	        },

	        _translateSurface: function() {
	            var map = this.map;
	            var nw = map.locationToView(map.extent().nw);

	            if (this.surface.translate) {
	                this.surface.translate(nw);
	                this.movable.moveTo({ x: nw.x, y: nw.y });
	            }
	        },

	        _handler: function(event) {
	            var layer = this;
	            return function(e) {
	                if (e.element) {
	                    var args = {
	                        layer: layer,
	                        shape: e.element,
	                        originalEvent: e.originalEvent
	                    };

	                    layer.map.trigger(event, args);
	                }
	            };
	        },

	        _activate: function() {
	            Layer.fn._activate.call(this);

	            this.map.bind("pan", this._pan);
	        },

	        _deactivate: function() {
	            Layer.fn._deactivate.call(this);

	            this.map.unbind("pan", this._pan);
	        }
	    });

	    var GeoJSONLoader = Class.extend({
	        init: function(locator, defaultStyle, observer) {
	            this.observer = observer;
	            this.locator = locator;
	            this.style = defaultStyle;
	        },

	        parse: function(item) {
	            var root = new Group();
	            var unwrap = true;

	            if (item.type === "Feature") {
	                unwrap = false;
	                this._loadGeometryTo(root, item.geometry, item);
	                this._featureCreated(root, item);
	            } else {
	                this._loadGeometryTo(root, item, item);
	            }

	            if (unwrap && root.children.length < 2) {
	                root = root.children[0];
	            }

	            return root;
	        },

	        _shapeCreated: function(shape) {
	            var cancelled = false;

	            if (this.observer && this.observer.shapeCreated) {
	                cancelled = this.observer.shapeCreated(shape);
	            }

	            return cancelled;
	        },

	        _featureCreated: function(group, dataItem) {
	            if (this.observer && this.observer.featureCreated) {
	                this.observer.featureCreated({
	                    group: group,
	                    dataItem: dataItem,
	                    properties: dataItem.properties
	                });
	            }
	        },

	        _loadGeometryTo: function(container, geometry, dataItem) {
	            var coords = geometry.coordinates;
	            var i;
	            var path;

	            switch(geometry.type) {
	                case "LineString":
	                    path = this._loadPolygon(container, [coords], dataItem);
	                    this._setLineFill(path);
	                    break;

	                case "MultiLineString":
	                    for (i = 0; i < coords.length; i++) {
	                        path = this._loadPolygon(container, [coords[i]], dataItem);
	                        this._setLineFill(path);
	                    }
	                    break;

	                case "Polygon":
	                    this._loadPolygon(container, coords, dataItem);
	                    break;

	                case "MultiPolygon":
	                    for (i = 0; i < coords.length; i++) {
	                        this._loadPolygon(container, coords[i], dataItem);
	                    }
	                    break;

	                case "Point":
	                    this._loadPoint(container, coords, dataItem);
	                    break;

	                case "MultiPoint":
	                    for (i = 0; i < coords.length; i++) {
	                        this._loadPoint(container, coords[i], dataItem);
	                    }
	                    break;
	            }
	        },

	        _setLineFill: function(path) {
	            var segments = path.segments;
	            if (segments.length < 4 || !segments[0].anchor().equals(last(segments).anchor())) {
	                path.options.fill = null;
	            }
	        },

	        _loadShape: function(container, shape) {
	            if (!this._shapeCreated(shape)) {
	                container.append(shape);
	            }

	            return shape;
	        },

	        _loadPolygon: function(container, rings, dataItem) {
	            var shape = this._buildPolygon(rings);
	            shape.dataItem = dataItem;

	            return this._loadShape(container, shape);
	        },

	        _buildPolygon: function(rings) {
	            var type = rings.length > 1 ? d.MultiPath : d.Path;
	            var path = new type(this.style);

	            for (var i = 0; i < rings.length; i++) {
	                for (var j = 0; j < rings[i].length; j++) {
	                    var point = this.locator.locationToView(
	                        Location.fromLngLat(rings[i][j])
	                    );

	                    if (j === 0) {
	                        path.moveTo(point.x, point.y);
	                    } else {
	                        path.lineTo(point.x, point.y);
	                    }
	                }
	            }

	            return path;
	        },

	        _loadPoint: function(container, coords, dataItem) {
	            var location = Location.fromLngLat(coords);
	            var point = this.locator.locationToView(location);

	            var circle = new g.Circle(point, 10);
	            var shape = new d.Circle(circle, this.style);
	            shape.dataItem = dataItem;
	            shape.location = location;

	            return this._loadShape(container, shape);
	        }
	    });

	    // Exports ================================================================
	    deepExtend(kendo.data, {
	        schemas: {
	            geojson: {
	                type: "json",
	                data: function(data) {
	                    if (data.type === "FeatureCollection") {
	                        return data.features;
	                    }

	                    if (data.type === "GeometryCollection") {
	                        return data.geometries;
	                    }

	                    return data;
	                }
	            }
	        },
	        transports: {
	            geojson: {
	                read: {
	                    dataType: "json"
	                }
	            }
	        }
	    });

	    deepExtend(dataviz, {
	        map: {
	            layers: {
	                shape: ShapeLayer,
	                ShapeLayer: ShapeLayer
	            },
	            GeoJSONLoader: GeoJSONLoader
	        }
	    });

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "5Y9s":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1188);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1053:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1kkP");

/***/ }),

/***/ 1054:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CRfZ");

/***/ }),

/***/ 1187:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("99zt");

/***/ }),

/***/ 1188:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1053), __webpack_require__(1054), __webpack_require__(1190), __webpack_require__(1191), __webpack_require__(1192), __webpack_require__(1193), __webpack_require__(1187),

	        __webpack_require__(1194),
	        __webpack_require__(1195),
	        __webpack_require__(1196),
	        __webpack_require__(1197),
	        __webpack_require__(1198),
	        __webpack_require__(1199),
	        __webpack_require__(1200),
	        __webpack_require__(1201),
	        __webpack_require__(1202),

	        __webpack_require__(1203),
	        __webpack_require__(1204),
	        __webpack_require__(1205),
	        __webpack_require__(1206),
	        __webpack_require__(1207),
	        __webpack_require__(1189),
	        __webpack_require__(1208),
	        __webpack_require__(1209),
	        __webpack_require__(1210),
	        __webpack_require__(1211),
	        __webpack_require__(1212),
	        __webpack_require__(1213),
	        __webpack_require__(1214),
	        __webpack_require__(1215),
	        __webpack_require__(1216),
	        __webpack_require__(1217),
	        __webpack_require__(1218),
	        __webpack_require__(1219),
	        __webpack_require__(1220),
	        __webpack_require__(1221),

	        __webpack_require__(1222),
	        __webpack_require__(1223),
	        __webpack_require__(1224),
	        __webpack_require__(1225),
	        __webpack_require__(1226),
	        __webpack_require__(1227)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	    var __meta__ = { // jshint ignore:line
	        id: "editor",
	        name: "Editor",
	        category: "web",
	        description: "Rich text editor component",
	        depends: [ "combobox", "dropdownlist", "window", "colorpicker" ],
	        features: [ {
	            id: "editor-imagebrowser",
	            name: "Image Browser",
	            description: "Support for uploading and inserting images",
	            depends: [ "imagebrowser" ]
	        }, {
	            id: "editor-resizable",
	            name: "Resize handle",
	            description: "Support for resizing the content area via a resize handle",
	            depends: [ "resizable" ]
	        }, {
	            id: "editor-tablewizard",
	            name: "Table wizard dialog",
	            description: "Support for table properties configuration",
	            depends: [ "tabstrip", "button", "numerictextbox" ]
	        }, {
	            id: "editor-pdf-export",
	            name: "PDF export",
	            description: "Export Editor content as PDF",
	            depends: [ "pdf", "drawing" ]
	        }]
	    };

		return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1189:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("RgNN");

/***/ }),

/***/ 1190:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("JKVm");

/***/ }),

/***/ 1191:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1Z35");

/***/ }),

/***/ 1192:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("3Bvt");

/***/ }),

/***/ 1193:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("E+tE");

/***/ }),

/***/ 1194:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("xTQk");

/***/ }),

/***/ 1195:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2UxK");

/***/ }),

/***/ 1196:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("N5PI");

/***/ }),

/***/ 1197:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1Xu6");

/***/ }),

/***/ 1198:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("6GKO");

/***/ }),

/***/ 1199:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("cmba");

/***/ }),

/***/ 1200:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("wVvS");

/***/ }),

/***/ 1201:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("pjl4");

/***/ }),

/***/ 1202:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("xW2y");

/***/ }),

/***/ 1203:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("g3du");

/***/ }),

/***/ 1204:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("wfaU");

/***/ }),

/***/ 1205:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("O8ob");

/***/ }),

/***/ 1206:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("yVNj");

/***/ }),

/***/ 1207:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("AMSY");

/***/ }),

/***/ 1208:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("sWXg");

/***/ }),

/***/ 1209:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("EBHW");

/***/ }),

/***/ 1210:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("QIQM");

/***/ }),

/***/ 1211:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("/nTy");

/***/ }),

/***/ 1212:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("N+Bk");

/***/ }),

/***/ 1213:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("/lhy");

/***/ }),

/***/ 1214:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Ytuf");

/***/ }),

/***/ 1215:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("cWbx");

/***/ }),

/***/ 1216:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("L414");

/***/ }),

/***/ 1217:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("KpOV");

/***/ }),

/***/ 1218:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ydWu");

/***/ }),

/***/ 1219:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("SlR/");

/***/ }),

/***/ 1220:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("UkXK");

/***/ }),

/***/ 1221:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("IPwA");

/***/ }),

/***/ 1222:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7R0X");

/***/ }),

/***/ 1223:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CG72");

/***/ }),

/***/ 1224:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ylaU");

/***/ }),

/***/ 1225:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("xXzn");

/***/ }),

/***/ 1226:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("BwK2");

/***/ }),

/***/ 1227:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("WkgI");

/***/ })

/******/ });

/***/ }),

/***/ "5dnc":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1557);
	module.exports = __webpack_require__(1557);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 948:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Fv0e");

/***/ }),

/***/ 1557:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/***********************************************************************
	 * WARNING: this file is auto-generated.  If you change it directly,
	 * your modifications will eventually be lost.  The source code is in
	 * `kendo-drawing` repository, you should make your changes there and
	 * run `src-modules/sync.sh` in this repository.
	 */
	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1558),
	        __webpack_require__(20),
	        __webpack_require__(948),
	        __webpack_require__(1559)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}) (function(){

	(function(kendo){

	// WARNING: removing the following jshint declaration and turning
	// == into === to make JSHint happy will break functionality.
	/* jshint eqnull:true */
	/* jshint -W069 */
	/* jshint loopfunc:true */
	/* jshint newcap:false */
	/* jshint latedef: nofunc */

	window.kendo.pdf = window.kendo.pdf || {};
	var support = kendo.support;
	var supportBrowser = support.browser;
	var kendoPdf = kendo.pdf;
	var drawing = kendo.drawing;
	var util = drawing.util;
	var kendoGeometry = kendo.geometry;

	/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
	/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
	/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
	/* eslint-disable no-param-reassign, no-var, block-scoped-var */

	// XXX: remove this junk (assume `true`) when we no longer have to support IE < 10
	// IE 9 (at least compatibility) reports having Uint8Array but the request response does not contain ArrayBuffer which results in missing table head error
	var HAS_TYPED_ARRAYS = typeof Uint8Array !== 'undefined' && kendo.support.browser && (!kendo.support.browser.msie || kendo.support.browser.version > 9);

	var BASE64 = (function(){
	    var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	    return {
	        decode: function(str) {
	            var input = str.replace(/[^A-Za-z0-9\+\/\=]/g, ""), i = 0, n = input.length, output = [];

	            while (i < n) {
	                var enc1 = keyStr.indexOf(input.charAt(i++));
	                var enc2 = keyStr.indexOf(input.charAt(i++));
	                var enc3 = keyStr.indexOf(input.charAt(i++));
	                var enc4 = keyStr.indexOf(input.charAt(i++));

	                var chr1 = (enc1 << 2) | (enc2 >>> 4);
	                var chr2 = ((enc2 & 15) << 4) | (enc3 >>> 2);
	                var chr3 = ((enc3 & 3) << 6) | enc4;

	                output.push(chr1);
	                if (enc3 != 64) {
	                    output.push(chr2);
	                }
	                if (enc4 != 64) {
	                    output.push(chr3);
	                }
	            }

	            return output;
	        },
	        encode: function(bytes) {
	            var i = 0, n = bytes.length;
	            var output = "";

	            while (i < n) {
	                var chr1 = bytes[i++];
	                var chr2 = bytes[i++];
	                var chr3 = bytes[i++];

	                var enc1 = chr1 >>> 2;
	                var enc2 = ((chr1 & 3) << 4) | (chr2 >>> 4);
	                var enc3 = ((chr2 & 15) << 2) | (chr3 >>> 6);
	                var enc4 = chr3 & 63;

	                if (i - n == 2) {
	                    enc3 = enc4 = 64;
	                } else if (i - n == 1) {
	                    enc4 = 64;
	                }

	                output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
	            }
	            return output;
	        }
	    };
	}());

	function BinaryStream(data) {
	    var offset = 0, length = 0;
	    if (data == null) {
	        data = HAS_TYPED_ARRAYS ? new Uint8Array(256) : [];
	    } else {
	        length = data.length;
	    }

	    var ensure = HAS_TYPED_ARRAYS ? function(len) {
	        if (len >= data.length) {
	            var tmp = new Uint8Array(Math.max(len + 256, data.length * 2));
	            tmp.set(data, 0);
	            data = tmp;
	        }
	    } : function() {};

	    var get = HAS_TYPED_ARRAYS ? function() {
	        return new Uint8Array(data.buffer, 0, length);
	    } : function() {
	        return data;
	    };

	    var write = HAS_TYPED_ARRAYS ? function(bytes) {
	        if (typeof bytes == "string") {
	            return writeString(bytes);
	        }
	        var len = bytes.length;
	        ensure(offset + len);
	        data.set(bytes, offset);
	        offset += len;
	        if (offset > length) {
	            length = offset;
	        }
	    } : function(bytes) {
	        if (typeof bytes == "string") {
	            return writeString(bytes);
	        }
	        for (var i = 0; i < bytes.length; ++i) {
	            writeByte(bytes[i]);
	        }
	    };

	    var slice = HAS_TYPED_ARRAYS ? function(start, length) {
	        if (data.buffer.slice) {
	            return new Uint8Array(data.buffer.slice(start, start + length));
	        } else {
	            // IE10
	            var x = new Uint8Array(length);
	            x.set(new Uint8Array(data.buffer, start, length));
	            return x;
	        }
	    } : function(start, length) {
	        return data.slice(start, start + length);
	    };

	    function eof() {
	        return offset >= length;
	    }
	    function readByte() {
	        return offset < length ? data[offset++] : 0;
	    }
	    function writeByte(b) {
	        ensure(offset);
	        data[offset++] = b & 0xFF;
	        if (offset > length) {
	            length = offset;
	        }
	    }
	    function readShort() {
	        return (readByte() << 8) | readByte();
	    }
	    function writeShort(w) {
	        writeByte(w >> 8);
	        writeByte(w);
	    }
	    function readShort_() {
	        var w = readShort();
	        return w >= 0x8000 ? w - 0x10000 : w;
	    }
	    function writeShort_(w) {
	        writeShort(w < 0 ? w + 0x10000 : w);
	    }
	    function readLong() {
	        return (readShort() * 0x10000) + readShort();
	    }
	    function writeLong(w) {
	        writeShort((w >>> 16) & 0xFFFF);
	        writeShort(w & 0xFFFF);
	    }
	    function readLong_() {
	        var w = readLong();
	        return w >= 0x80000000 ? w - 0x100000000 : w;
	    }
	    function writeLong_(w) {
	        writeLong(w < 0 ? w + 0x100000000 : w);
	    }
	    function readFixed() {
	        return readLong() / 0x10000;
	    }
	    function writeFixed(f) {
	        writeLong(Math.round(f * 0x10000));
	    }
	    function readFixed_() {
	        return readLong_() / 0x10000;
	    }
	    function writeFixed_(f) {
	        writeLong_(Math.round(f * 0x10000));
	    }
	    function read(len) {
	        return times(len, readByte);
	    }
	    function readString(len) {
	        return String.fromCharCode.apply(String, read(len));
	    }
	    function writeString(str) {
	        for (var i = 0; i < str.length; ++i) {
	            writeByte(str.charCodeAt(i));
	        }
	    }
	    function times(n, reader) {
	        for (var ret = new Array(n), i = 0; i < n; ++i) {
	            ret[i] = reader();
	        }
	        return ret;
	    }

	    var stream = {
	        eof         : eof,
	        readByte    : readByte,
	        writeByte   : writeByte,
	        readShort   : readShort,
	        writeShort  : writeShort,
	        readLong    : readLong,
	        writeLong   : writeLong,
	        readFixed   : readFixed,
	        writeFixed  : writeFixed,

	        // signed numbers.
	        readShort_  : readShort_,
	        writeShort_ : writeShort_,
	        readLong_   : readLong_,
	        writeLong_  : writeLong_,
	        readFixed_  : readFixed_,
	        writeFixed_ : writeFixed_,

	        read        : read,
	        write       : write,
	        readString  : readString,
	        writeString : writeString,

	        times       : times,
	        get         : get,
	        slice       : slice,

	        offset: function(pos) {
	            if (pos != null) {
	                offset = pos;
	                return stream;
	            }
	            return offset;
	        },

	        skip: function(nbytes) {
	            offset += nbytes;
	        },

	        toString: function() {
	            throw new Error("FIX CALLER.  BinaryStream is no longer convertible to string!");
	        },

	        length: function() { return length; },

	        saveExcursion: function(f) {
	            var pos = offset;
	            try {
	                return f();
	            } finally {
	                offset = pos;
	            }
	        },

	        writeBase64: function(base64) {
	            if (window.atob) {
	                writeString(window.atob(base64));
	            } else {
	                write(BASE64.decode(base64));
	            }
	        },
	        base64: function() {
	            return BASE64.encode(get());
	        }
	    };

	    return stream;
	}

	function ucs2decode(string) {
	    var output = [],
	        counter = 0,
	        length = string.length,
	        value,
	        extra;
	    while (counter < length) {
	        value = string.charCodeAt(counter++);
	        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
	            // high surrogate, and there is a next character
	            extra = string.charCodeAt(counter++);
	            if ((extra & 0xFC00) == 0xDC00) { // low surrogate
	                output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
	            } else {
	                // unmatched surrogate; only append this code unit, in case the next
	                // code unit is the high surrogate of a surrogate pair
	                output.push(value);
	                counter--;
	            }
	        } else {
	            output.push(value);
	        }
	    }
	    return output;
	}

	function ucs2encode(array) {
	    return array.map(function(value){
	        var output = "";
	        if (value > 0xFFFF) {
	            value -= 0x10000;
	            output += String.fromCharCode(value >>> 10 & 0x3FF | 0xD800);
	            value = 0xDC00 | value & 0x3FF;
	        }
	        output += String.fromCharCode(value);
	        return output;
	    }).join("");
	}

	function atobUint8Array(base64) {
	    var data = window.atob(base64);
	    var result = new Uint8Array(data.length);

	    for (var idx = 0; idx < data.length; idx++) {
	        result[idx] = data.charCodeAt(idx);
	    }

	    return result;
	}

	function createUint8Array(data) {
	    var result = new Uint8Array(data.length);

	    for (var idx = 0; idx < data.length; idx++) {
	        result[idx] = data[idx];
	    }

	    return result;
	}

	function base64ToUint8Array(base64) {
	    if (window.atob) {
	        return atobUint8Array(base64);
	    }

	    return createUint8Array(BASE64.decode(base64));
	}

	/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
	/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
	/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
	/* eslint-disable no-param-reassign, no-var, block-scoped-var */

	/*****************************************************************************\
	 *
	 * The code in this file, although written from scratch, is influenced by the
	 * TrueType parser/encoder in PDFKit -- http://pdfkit.org/ (a CoffeeScript
	 * library for producing PDF files).
	 *
	 * PDFKit is (c) Devon Govett 2014 and released under the MIT License.
	 *
	\*****************************************************************************/

	function hasOwnProperty$1(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}

	function sortedKeys(obj) {
	    return Object.keys(obj).sort(function(a, b){ return a - b; }).map(parseFloat);
	}

	///

	function Directory(data) {
	    this.raw = data;
	    this.scalerType = data.readLong();
	    this.tableCount = data.readShort();
	    this.searchRange = data.readShort();
	    this.entrySelector = data.readShort();
	    this.rangeShift = data.readShort();

	    var tables = this.tables = {};
	    for (var i = 0; i < this.tableCount; ++i) {
	        var entry = {
	            tag      : data.readString(4),
	            checksum : data.readLong(),
	            offset   : data.readLong(),
	            length   : data.readLong()
	        };
	        tables[entry.tag] = entry;
	    }
	}

	Directory.prototype = {

	    readTable: function(name, Ctor) {
	        var def = this.tables[name];
	        if (!def) {
	            throw new Error("Table " + name + " not found in directory");
	        }
	        return (this[name] = def.table = new Ctor(this, def));
	    },

	    render: function(tables) {
	        var this$1 = this;

	        var tableCount = Object.keys(tables).length;

	        var maxpow2 = Math.pow(2, Math.floor(Math.log(tableCount) / Math.LN2));
	        var searchRange = maxpow2 * 16;
	        var entrySelector = Math.floor(Math.log(maxpow2) / Math.LN2);
	        var rangeShift = tableCount * 16 - searchRange;

	        var out = BinaryStream();
	        out.writeLong(this.scalerType);
	        out.writeShort(tableCount);
	        out.writeShort(searchRange);
	        out.writeShort(entrySelector);
	        out.writeShort(rangeShift);

	        var directoryLength = tableCount * 16;
	        var offset = out.offset() + directoryLength;
	        var headOffset = null;
	        var tableData = BinaryStream();

	        for (var tag in tables) {
	            if (hasOwnProperty$1(tables, tag)) {
	                var table = tables[tag];

	                out.writeString(tag);
	                out.writeLong(this$1.checksum(table));
	                out.writeLong(offset);
	                out.writeLong(table.length);

	                tableData.write(table);
	                if (tag == "head") {
	                    headOffset = offset;
	                }
	                offset += table.length;

	                while (offset % 4) {
	                    tableData.writeByte(0);
	                    offset++;
	                }
	            }
	        }

	        out.write(tableData.get());
	        var sum = this.checksum(out.get());
	        var adjustment = 0xB1B0AFBA - sum;

	        out.offset(headOffset + 8);
	        out.writeLong(adjustment);
	        return out.get();
	    },

	    checksum: function(data) {
	        data = BinaryStream(data);
	        var sum = 0;
	        while (!data.eof()) {
	            sum += data.readLong();
	        }
	        return sum & 0xFFFFFFFF;
	    }
	};

	function deftable(methods) {
	    function Ctor(file, def) {
	        this.definition = def;
	        this.length = def.length;
	        this.offset = def.offset;
	        this.file = file;
	        this.rawData = file.raw;
	        this.parse(file.raw);
	    }
	    Ctor.prototype.raw = function() {
	        return this.rawData.slice(this.offset, this.length);
	    };
	    for (var i in methods) {
	        if (hasOwnProperty$1(methods, i)) {
	            Ctor[i] = Ctor.prototype[i] = methods[i];
	        }
	    }
	    return Ctor;
	}

	var HeadTable = deftable({
	    parse: function(data) {
	        data.offset(this.offset);
	        this.version             = data.readLong();
	        this.revision            = data.readLong();
	        this.checkSumAdjustment  = data.readLong();
	        this.magicNumber         = data.readLong();
	        this.flags               = data.readShort();
	        this.unitsPerEm          = data.readShort();
	        this.created             = data.read(8);
	        this.modified            = data.read(8);

	        this.xMin = data.readShort_();
	        this.yMin = data.readShort_();
	        this.xMax = data.readShort_();
	        this.yMax = data.readShort_();

	        this.macStyle           = data.readShort();
	        this.lowestRecPPEM      = data.readShort();
	        this.fontDirectionHint  = data.readShort_();
	        this.indexToLocFormat   = data.readShort_();
	        this.glyphDataFormat    = data.readShort_();
	    },
	    render: function(indexToLocFormat) {
	        var out = BinaryStream();
	        out.writeLong(this.version);
	        out.writeLong(this.revision);
	        out.writeLong(0);       // checksum adjustment; shall be computed later
	        out.writeLong(this.magicNumber);
	        out.writeShort(this.flags);
	        out.writeShort(this.unitsPerEm);
	        out.write(this.created);
	        out.write(this.modified);
	        out.writeShort_(this.xMin);
	        out.writeShort_(this.yMin);
	        out.writeShort_(this.xMax);
	        out.writeShort_(this.yMax);
	        out.writeShort(this.macStyle);
	        out.writeShort(this.lowestRecPPEM);
	        out.writeShort_(this.fontDirectionHint);
	        out.writeShort_(indexToLocFormat); // this will depend on the `loca` table
	        out.writeShort_(this.glyphDataFormat);
	        return out.get();
	    }
	});

	var LocaTable = deftable({
	    parse: function(data) {
	        data.offset(this.offset);
	        var format = this.file.head.indexToLocFormat;
	        if (format === 0) {
	            this.offsets = data.times(this.length / 2, function(){
	                return 2 * data.readShort();
	            });
	        } else {
	            this.offsets = data.times(this.length / 4, data.readLong);
	        }
	    },
	    offsetOf: function(id) {
	        return this.offsets[id];
	    },
	    lengthOf: function(id) {
	        return this.offsets[id + 1] - this.offsets[id];
	    },
	    render: function(offsets) {
	        var out = BinaryStream();
	        var needsLongFormat = offsets[offsets.length - 1] > 0xFFFF;
	        for (var i = 0; i < offsets.length; ++i) {
	            if (needsLongFormat) {
	                out.writeLong(offsets[i]);
	            } else {
	                out.writeShort(offsets[i] / 2);
	            }
	        }
	        return {
	            format: needsLongFormat ? 1 : 0,
	            table: out.get()
	        };
	    }
	});

	var HheaTable = deftable({
	    parse: function(data) {
	        data.offset(this.offset);

	        this.version              = data.readLong();
	        this.ascent               = data.readShort_();
	        this.descent              = data.readShort_();
	        this.lineGap              = data.readShort_();
	        this.advanceWidthMax      = data.readShort();
	        this.minLeftSideBearing   = data.readShort_();
	        this.minRightSideBearing  = data.readShort_();
	        this.xMaxExtent           = data.readShort_();
	        this.caretSlopeRise       = data.readShort_();
	        this.caretSlopeRun        = data.readShort_();
	        this.caretOffset          = data.readShort_();

	        data.skip(4 * 2);       // reserved

	        this.metricDataFormat     = data.readShort_();
	        this.numOfLongHorMetrics  = data.readShort();
	    },
	    render: function(ids) {
	        var out = BinaryStream();
	        out.writeLong(this.version);
	        out.writeShort_(this.ascent);
	        out.writeShort_(this.descent);
	        out.writeShort_(this.lineGap);
	        out.writeShort(this.advanceWidthMax);
	        out.writeShort_(this.minLeftSideBearing);
	        out.writeShort_(this.minRightSideBearing);
	        out.writeShort_(this.xMaxExtent);
	        out.writeShort_(this.caretSlopeRise);
	        out.writeShort_(this.caretSlopeRun);
	        out.writeShort_(this.caretOffset);

	        out.write([ 0, 0, 0, 0, 0, 0, 0, 0 ]); // reserved bytes

	        out.writeShort_(this.metricDataFormat);
	        out.writeShort(ids.length);
	        return out.get();
	    }
	});

	var MaxpTable = deftable({
	    parse: function(data) {
	        data.offset(this.offset);
	        this.version = data.readLong();
	        this.numGlyphs = data.readShort();
	        this.maxPoints = data.readShort();
	        this.maxContours = data.readShort();
	        this.maxComponentPoints = data.readShort();
	        this.maxComponentContours = data.readShort();
	        this.maxZones = data.readShort();
	        this.maxTwilightPoints = data.readShort();
	        this.maxStorage = data.readShort();
	        this.maxFunctionDefs = data.readShort();
	        this.maxInstructionDefs = data.readShort();
	        this.maxStackElements = data.readShort();
	        this.maxSizeOfInstructions = data.readShort();
	        this.maxComponentElements = data.readShort();
	        this.maxComponentDepth = data.readShort();
	    },
	    render: function(glyphIds) {
	        var out = BinaryStream();
	        out.writeLong(this.version);
	        out.writeShort(glyphIds.length);
	        out.writeShort(this.maxPoints);
	        out.writeShort(this.maxContours);
	        out.writeShort(this.maxComponentPoints);
	        out.writeShort(this.maxComponentContours);
	        out.writeShort(this.maxZones);
	        out.writeShort(this.maxTwilightPoints);
	        out.writeShort(this.maxStorage);
	        out.writeShort(this.maxFunctionDefs);
	        out.writeShort(this.maxInstructionDefs);
	        out.writeShort(this.maxStackElements);
	        out.writeShort(this.maxSizeOfInstructions);
	        out.writeShort(this.maxComponentElements);
	        out.writeShort(this.maxComponentDepth);
	        return out.get();
	    }
	});

	var HmtxTable = deftable({
	    parse: function(data) {
	        data.offset(this.offset);
	        var dir = this.file, hhea = dir.hhea;
	        this.metrics = data.times(hhea.numOfLongHorMetrics, function(){
	            return {
	                advance: data.readShort(),
	                lsb: data.readShort_()
	            };
	        });
	        var lsbCount = dir.maxp.numGlyphs - dir.hhea.numOfLongHorMetrics;
	        this.leftSideBearings = data.times(lsbCount, data.readShort_);
	    },
	    forGlyph: function(id) {
	        var metrics = this.metrics;
	        var n = metrics.length;
	        if (id < n) {
	            return metrics[id];
	        }
	        return {
	            advance: metrics[n - 1].advance,
	            lsb: this.leftSideBearings[id - n]
	        };
	    },
	    render: function(glyphIds) {
	        var this$1 = this;

	        var out = BinaryStream();
	        for (var i = 0; i < glyphIds.length; ++i) {
	            var m = this$1.forGlyph(glyphIds[i]);
	            out.writeShort(m.advance);
	            out.writeShort_(m.lsb);
	        }
	        return out.get();
	    }
	});

	var GlyfTable = (function(){

	    function SimpleGlyph(raw) {
	        this.raw = raw;
	    }
	    SimpleGlyph.prototype = {
	        compound: false,
	        render: function() {
	            return this.raw.get();
	        }
	    };

	    var ARG_1_AND_2_ARE_WORDS     = 0x0001;
	    var WE_HAVE_A_SCALE           = 0x0008;
	    var MORE_COMPONENTS           = 0x0020;
	    var WE_HAVE_AN_X_AND_Y_SCALE  = 0x0040;
	    var WE_HAVE_A_TWO_BY_TWO      = 0x0080;
	    //var WE_HAVE_INSTRUCTIONS      = 0x0100;

	    function CompoundGlyph(data) {
	        this.raw = data;
	        var ids = this.glyphIds = [];
	        var offsets = this.idOffsets = [];
	        while (true) {          // eslint-disable-line no-constant-condition
	            var flags = data.readShort();
	            offsets.push(data.offset());
	            ids.push(data.readShort());

	            if (!(flags & MORE_COMPONENTS)) {
	                break;
	            }

	            data.skip(flags & ARG_1_AND_2_ARE_WORDS ? 4 : 2);

	            if (flags & WE_HAVE_A_TWO_BY_TWO) {
	                data.skip(8);
	            } else if (flags & WE_HAVE_AN_X_AND_Y_SCALE) {
	                data.skip(4);
	            } else if (flags & WE_HAVE_A_SCALE) {
	                data.skip(2);
	            }
	        }
	    }

	    CompoundGlyph.prototype = {
	        compound: true,
	        render: function(old2new) {
	            var this$1 = this;

	            var out = BinaryStream(this.raw.get());
	            for (var i = 0; i < this.glyphIds.length; ++i) {
	                var id = this$1.glyphIds[i];
	                out.offset(this$1.idOffsets[i]);
	                out.writeShort(old2new[id]);
	            }
	            return out.get();
	        }
	    };

	    return deftable({
	        parse: function() {
	            this.cache = {};
	        },
	        glyphFor: function(id) {
	            var cache = this.cache;
	            if (hasOwnProperty$1(cache, id)) {
	                return cache[id];
	            }

	            var loca = this.file.loca;
	            var length = loca.lengthOf(id);

	            if (length === 0) {
	                return (cache[id] = null);
	            }

	            var data = this.rawData;
	            var offset = this.offset + loca.offsetOf(id);
	            var raw = BinaryStream(data.slice(offset, length));

	            var numberOfContours = raw.readShort_();
	            var xMin = raw.readShort_();
	            var yMin = raw.readShort_();
	            var xMax = raw.readShort_();
	            var yMax = raw.readShort_();

	            var glyph = cache[id] = numberOfContours == -1 ? new CompoundGlyph(raw) : new SimpleGlyph(raw);

	            glyph.numberOfContours = numberOfContours;
	            glyph.xMin = xMin;
	            glyph.yMin = yMin;
	            glyph.xMax = xMax;
	            glyph.yMax = yMax;

	            return glyph;
	        },
	        render: function(glyphs, oldIds, old2new) {
	            var out = BinaryStream(), offsets = [];
	            for (var i = 0; i < oldIds.length; ++i) {
	                var id = oldIds[i];
	                var glyph = glyphs[id];
	                offsets.push(out.offset());
	                if (glyph) {
	                    out.write(glyph.render(old2new));
	                }
	            }
	            offsets.push(out.offset());
	            return {
	                table: out.get(),
	                offsets: offsets
	            };
	        }
	    });

	}());

	var NameTable = (function(){

	    function NameEntry(text, entry) {
	        this.text = text;
	        this.length = text.length;
	        this.platformID = entry.platformID;
	        this.platformSpecificID = entry.platformSpecificID;
	        this.languageID = entry.languageID;
	        this.nameID = entry.nameID;
	    }

	    return deftable({
	        parse: function(data) {
	            data.offset(this.offset);
	            data.readShort();   // format
	            var count = data.readShort();
	            var stringOffset = this.offset + data.readShort();
	            var nameRecords = data.times(count, function(){
	                return {
	                    platformID         : data.readShort(),
	                    platformSpecificID : data.readShort(),
	                    languageID         : data.readShort(),
	                    nameID             : data.readShort(),
	                    length             : data.readShort(),
	                    offset             : data.readShort() + stringOffset
	                };
	            });
	            var strings = this.strings = {};
	            for (var i = 0; i < nameRecords.length; ++i) {
	                var rec = nameRecords[i];
	                data.offset(rec.offset);
	                var text = data.readString(rec.length);
	                if (!strings[rec.nameID]) {
	                    strings[rec.nameID] = [];
	                }
	                strings[rec.nameID].push(new NameEntry(text, rec));
	            }
	            this.postscriptEntry = strings[6][0];
	            this.postscriptName = this.postscriptEntry.text.replace(/[^\x20-\x7F]/g, "");
	        },

	        render: function(psName) {
	            var this$1 = this;

	            var strings = this.strings;
	            var strCount = 0;
	            for (var i in strings) {
	                if (hasOwnProperty$1(strings, i)) {
	                    strCount += strings[i].length;
	                }
	            }
	            var out = BinaryStream();
	            var strTable = BinaryStream();

	            out.writeShort(0);  // format
	            out.writeShort(strCount);
	            out.writeShort(6 + 12 * strCount); // stringOffset

	            for (i in strings) {
	                if (hasOwnProperty$1(strings, i)) {
	                    var list = i == 6 ? [
	                        new NameEntry(psName, this$1.postscriptEntry)
	                    ] : strings[i];
	                    for (var j = 0; j < list.length; ++j) {
	                        var str = list[j];
	                        out.writeShort(str.platformID);
	                        out.writeShort(str.platformSpecificID);
	                        out.writeShort(str.languageID);
	                        out.writeShort(str.nameID);
	                        out.writeShort(str.length);
	                        out.writeShort(strTable.offset());

	                        strTable.writeString(str.text);
	                    }
	                }
	            }

	            out.write(strTable.get());

	            return out.get();
	        }
	    });

	})();

	var PostTable = (function(){

	    var POSTSCRIPT_GLYPHS = ".notdef .null nonmarkingreturn space exclam quotedbl numbersign dollar percent ampersand quotesingle parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore grave a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde Adieresis Aring Ccedilla Eacute Ntilde Odieresis Udieresis aacute agrave acircumflex adieresis atilde aring ccedilla eacute egrave ecircumflex edieresis iacute igrave icircumflex idieresis ntilde oacute ograve ocircumflex odieresis otilde uacute ugrave ucircumflex udieresis dagger degree cent sterling section bullet paragraph germandbls registered copyright trademark acute dieresis notequal AE Oslash infinity plusminus lessequal greaterequal yen mu partialdiff summation product pi integral ordfeminine ordmasculine Omega ae oslash questiondown exclamdown logicalnot radical florin approxequal Delta guillemotleft guillemotright ellipsis nonbreakingspace Agrave Atilde Otilde OE oe endash emdash quotedblleft quotedblright quoteleft quoteright divide lozenge ydieresis Ydieresis fraction currency guilsinglleft guilsinglright fi fl daggerdbl periodcentered quotesinglbase quotedblbase perthousand Acircumflex Ecircumflex Aacute Edieresis Egrave Iacute Icircumflex Idieresis Igrave Oacute Ocircumflex apple Ograve Uacute Ucircumflex Ugrave dotlessi circumflex tilde macron breve dotaccent ring cedilla hungarumlaut ogonek caron Lslash lslash Scaron scaron Zcaron zcaron brokenbar Eth eth Yacute yacute Thorn thorn minus multiply onesuperior twosuperior threesuperior onehalf onequarter threequarters franc Gbreve gbreve Idotaccent Scedilla scedilla Cacute cacute Ccaron ccaron dcroat".split(/\s+/g);

	    return deftable({
	        parse: function(data) {
	            var this$1 = this;

	            data.offset(this.offset);

	            this.format = data.readLong();
	            this.italicAngle = data.readFixed_();
	            this.underlinePosition = data.readShort_();
	            this.underlineThickness = data.readShort_();
	            this.isFixedPitch = data.readLong();
	            this.minMemType42 = data.readLong();
	            this.maxMemType42 = data.readLong();
	            this.minMemType1 = data.readLong();
	            this.maxMemType1 = data.readLong();

	            var numberOfGlyphs;

	            switch (this.format) {
	              case 0x00010000:
	              case 0x00030000:
	                break;

	              case 0x00020000:
	                numberOfGlyphs = data.readShort();
	                this.glyphNameIndex = data.times(numberOfGlyphs, data.readShort);
	                this.names = [];
	                var limit = this.offset + this.length;
	                while (data.offset() < limit) {
	                    this$1.names.push(data.readString(data.readByte()));
	                }
	                break;

	              case 0x00025000:
	                numberOfGlyphs = data.readShort();
	                this.offsets = data.read(numberOfGlyphs);
	                break;

	              case 0x00040000:
	                this.map = data.times(this.file.maxp.numGlyphs, data.readShort);
	                break;
	            }
	        },
	        glyphFor: function(code) {
	            switch (this.format) {
	              case 0x00010000:
	                return POSTSCRIPT_GLYPHS[code] || ".notdef";

	              case 0x00020000:
	                var index = this.glyphNameIndex[code];
	                if (index < POSTSCRIPT_GLYPHS.length) {
	                    return POSTSCRIPT_GLYPHS[index];
	                }
	                return this.names[index - POSTSCRIPT_GLYPHS.length] || ".notdef";

	              case 0x00025000:

	              case 0x00030000:
	                return ".notdef";

	              case 0x00040000:
	                return this.map[code] || 0xFFFF;
	            }
	        },
	        render: function(mapping) {
	            var this$1 = this;

	            if (this.format == 0x00030000) {
	                return this.raw();
	            }

	            // keep original header, but set format to 2.0
	            var out = BinaryStream(this.rawData.slice(this.offset, 32));
	            out.writeLong(0x00020000);
	            out.offset(32);

	            var indexes = [];
	            var strings = [];

	            for (var i = 0; i < mapping.length; ++i) {
	                var id = mapping[i];
	                var post = this$1.glyphFor(id);
	                var index = POSTSCRIPT_GLYPHS.indexOf(post);
	                if (index >= 0) {
	                    indexes.push(index);
	                } else {
	                    indexes.push(POSTSCRIPT_GLYPHS.length + strings.length);
	                    strings.push(post);
	                }
	            }

	            out.writeShort(mapping.length);

	            for (i = 0; i < indexes.length; ++i) {
	                out.writeShort(indexes[i]);
	            }

	            for (i = 0; i < strings.length; ++i) {
	                out.writeByte(strings[i].length);
	                out.writeString(strings[i]);
	            }

	            return out.get();
	        }
	    });
	})();

	var CmapTable = (function(){

	    function CmapEntry(data, offset, codeMap) {
	        var self = this;
	        self.platformID = data.readShort();
	        self.platformSpecificID = data.readShort();
	        self.offset = offset + data.readLong();

	        data.saveExcursion(function(){
	            var code;
	            data.offset(self.offset);
	            self.format = data.readShort();

	            switch (self.format) {
	              case 0:
	                self.length = data.readShort();
	                self.language = data.readShort();
	                for (var i = 0; i < 256; ++i) {
	                    codeMap[i] = data.readByte();
	                }
	                break;

	              case 4:
	                self.length = data.readShort();
	                self.language = data.readShort();
	                var segCount = data.readShort() / 2;

	                data.skip(6);       // searchRange, entrySelector, rangeShift
	                var endCode = data.times(segCount, data.readShort);
	                data.skip(2);       // reserved pad
	                var startCode = data.times(segCount, data.readShort);
	                var idDelta = data.times(segCount, data.readShort_);
	                var idRangeOffset = data.times(segCount, data.readShort);

	                var count = (self.length + self.offset - data.offset()) / 2;
	                var glyphIds = data.times(count, data.readShort);

	                for (i = 0; i < segCount; ++i) {
	                    var start = startCode[i], end = endCode[i];
	                    for (code = start; code <= end; ++code) {
	                        var glyphId;
	                        if (idRangeOffset[i] === 0) {
	                            glyphId = code + idDelta[i];
	                        } else {
	                            ///
	                            // When non-zero, idRangeOffset contains for each segment the byte offset of the Glyph ID
	                            // into the glyphIds table, from the *current* `i` cell of idRangeOffset.  In other words,
	                            // this offset spans from the first into the second array.  This works, because the arrays
	                            // are consecutive in the TTF file:
	                            //
	                            //     [ ...idRangeOffset... ][ ...glyphIds... ]
	                            //       ...... 48 ......       .... ID ....
	                            //              ^----- 48 bytes -----^
	                            //
	                            // (but I can't stop wondering why is it not just a plain index, possibly incremented by 1
	                            // so that we can have that special `zero` value.)
	                            //
	                            // The elements of idRangeOffset are even numbers, because both arrays contain 16-bit words,
	                            // yet the offset is in bytes.  That is why we divide it by 2.  Then we subtract the
	                            // remaining segments (segCount-i), and add the code-start offset, to which we need to add
	                            // the corresponding delta to get the actual glyph ID.
	                            ///
	                            var index = idRangeOffset[i] / 2 - (segCount - i) + (code - start);
	                            glyphId = glyphIds[index] || 0;
	                            if (glyphId !== 0) {
	                                glyphId += idDelta[i];
	                            }
	                        }
	                        codeMap[code] = glyphId & 0xFFFF;
	                    }
	                }
	                break;

	              case 6:
	                self.length = data.readShort();
	                self.language = data.readShort();
	                code = data.readShort();
	                var length = data.readShort();
	                while (length-- > 0) {
	                    codeMap[code++] = data.readShort();
	                }
	                break;

	              case 12:
	                data.readShort(); // reserved
	                self.length = data.readLong();
	                self.language = data.readLong();
	                var ngroups = data.readLong();
	                while (ngroups-- > 0) {
	                    code = data.readLong();
	                    var endCharCode = data.readLong();
	                    var glyphCode = data.readLong();
	                    while (code <= endCharCode) {
	                        codeMap[code++] = glyphCode++;
	                    }
	                }
	                break;

	              default:
	                if (window.console) {
	                    window.console.error("Unhandled CMAP format: " + self.format);
	                }
	            }
	        });
	    }

	    function renderCharmap(ncid2ogid, ogid2ngid) {
	        var codes = sortedKeys(ncid2ogid);
	        var startCodes = [];
	        var endCodes = [];
	        var last = null;
	        var diff = null;

	        function new_gid(charcode) {
	            return ogid2ngid[ncid2ogid[charcode]];
	        }

	        for (var i = 0; i < codes.length; ++i) {
	            var code = codes[i];
	            var gid = new_gid(code);
	            var delta = gid - code;
	            if (last == null || delta !== diff) {
	                if (last) {
	                    endCodes.push(last);
	                }
	                startCodes.push(code);
	                diff = delta;
	            }
	            last = code;
	        }

	        if (last) {
	            endCodes.push(last);
	        }
	        endCodes.push(0xFFFF);
	        startCodes.push(0xFFFF);

	        var segCount = startCodes.length;
	        var segCountX2 = segCount * 2;
	        var searchRange = 2 * Math.pow(2, Math.floor(Math.log(segCount) / Math.LN2));
	        var entrySelector = Math.log(searchRange / 2) / Math.LN2;
	        var rangeShift = segCountX2 - searchRange;

	        var deltas = [];
	        var rangeOffsets = [];
	        var glyphIds = [];

	        for (i = 0; i < segCount; ++i) {
	            var startCode = startCodes[i];
	            var endCode = endCodes[i];
	            if (startCode == 0xFFFF) {
	                deltas.push(0);
	                rangeOffsets.push(0);
	                break;
	            }
	            var startGlyph = new_gid(startCode);
	            if (startCode - startGlyph >= 0x8000) {
	                deltas.push(0);
	                rangeOffsets.push(2 * (glyphIds.length + segCount - i));
	                for (var j = startCode; j <= endCode; ++j) {
	                    glyphIds.push(new_gid(j));
	                }
	            } else {
	                deltas.push(startGlyph - startCode);
	                rangeOffsets.push(0);
	            }
	        }

	        var out = BinaryStream();

	        out.writeShort(3);      // platformID
	        out.writeShort(1);      // platformSpecificID
	        out.writeLong(12);      // offset
	        out.writeShort(4);      // format
	        out.writeShort(16 + segCount * 8 + glyphIds.length * 2); // length
	        out.writeShort(0);      // language
	        out.writeShort(segCountX2);
	        out.writeShort(searchRange);
	        out.writeShort(entrySelector);
	        out.writeShort(rangeShift);

	        endCodes.forEach(out.writeShort);
	        out.writeShort(0);      // reserved pad
	        startCodes.forEach(out.writeShort);
	        deltas.forEach(out.writeShort_);
	        rangeOffsets.forEach(out.writeShort);
	        glyphIds.forEach(out.writeShort);

	        return out.get();
	    }

	    return deftable({
	        parse: function(data) {
	            var self = this;
	            var offset = self.offset;
	            data.offset(offset);
	            self.codeMap = {};
	            self.version = data.readShort();
	            var tableCount = data.readShort();
	            self.tables = data.times(tableCount, function(){
	                return new CmapEntry(data, offset, self.codeMap);
	            });
	        },
	        render: function(ncid2ogid, ogid2ngid) {
	            var out = BinaryStream();
	            out.writeShort(0);  // version
	            out.writeShort(1);  // tableCount
	            out.write(renderCharmap(ncid2ogid, ogid2ngid));
	            return out.get();
	        }
	    });

	})();

	var OS2Table = deftable({
	    parse: function(data) {
	        data.offset(this.offset);
	        this.version = data.readShort();
	        this.averageCharWidth = data.readShort_();
	        this.weightClass = data.readShort();
	        this.widthClass = data.readShort();
	        this.type = data.readShort();
	        this.ySubscriptXSize = data.readShort_();
	        this.ySubscriptYSize = data.readShort_();
	        this.ySubscriptXOffset = data.readShort_();
	        this.ySubscriptYOffset = data.readShort_();
	        this.ySuperscriptXSize = data.readShort_();
	        this.ySuperscriptYSize = data.readShort_();
	        this.ySuperscriptXOffset = data.readShort_();
	        this.ySuperscriptYOffset = data.readShort_();
	        this.yStrikeoutSize = data.readShort_();
	        this.yStrikeoutPosition = data.readShort_();
	        this.familyClass = data.readShort_();

	        this.panose = data.times(10, data.readByte);
	        this.charRange = data.times(4, data.readLong);

	        this.vendorID = data.readString(4);
	        this.selection = data.readShort();
	        this.firstCharIndex = data.readShort();
	        this.lastCharIndex = data.readShort();

	        if (this.version > 0) {
	            this.ascent = data.readShort_();
	            this.descent = data.readShort_();
	            this.lineGap = data.readShort_();
	            this.winAscent = data.readShort();
	            this.winDescent = data.readShort();
	            this.codePageRange = data.times(2, data.readLong);

	            if (this.version > 1) {
	                this.xHeight = data.readShort();
	                this.capHeight = data.readShort();
	                this.defaultChar = data.readShort();
	                this.breakChar = data.readShort();
	                this.maxContext = data.readShort();
	            }
	        }
	    },
	    render: function() {
	        return this.raw();
	    }
	});

	var subsetTag = 100000;

	function nextSubsetTag() {
	    var ret = "", n = String(subsetTag);
	    for (var i = 0; i < n.length; ++i) {
	        ret += String.fromCharCode(n.charCodeAt(i) - 48 + 65);
	    }
	    ++subsetTag;
	    return ret;
	}

	function Subfont(font) {
	    this.font = font;
	    this.subset = {};
	    this.unicodes = {};
	    this.ogid2ngid = { 0: 0 };
	    this.ngid2ogid = { 0: 0 };
	    this.ncid2ogid = {};
	    this.next = this.firstChar = 1;
	    this.nextGid = 1;
	    this.psName = nextSubsetTag() + "+" + this.font.psName;
	}

	Subfont.prototype = {
	    use: function(ch) {
	        var self = this;
	        if (typeof ch == "string") {
	            return ucs2decode(ch).reduce(function(ret, code){
	                return ret + String.fromCharCode(self.use(code));
	            }, "");
	        }
	        var code = self.unicodes[ch];
	        if (!code) {
	            code = self.next++;
	            self.subset[code] = ch;
	            self.unicodes[ch] = code;

	            // generate new GID (glyph ID) and maintain newGID ->
	            // oldGID and back mappings
	            var old_gid = self.font.cmap.codeMap[ch];
	            if (old_gid) {
	                self.ncid2ogid[code] = old_gid;
	                if (self.ogid2ngid[old_gid] == null) {
	                    var new_gid = self.nextGid++;
	                    self.ogid2ngid[old_gid] = new_gid;
	                    self.ngid2ogid[new_gid] = old_gid;
	                }
	            }
	        }
	        return code;
	    },
	    encodeText: function(text) {
	        return this.use(text);
	    },
	    glyphIds: function() {
	        return sortedKeys(this.ogid2ngid);
	    },
	    glyphsFor: function(glyphIds, result) {
	        var this$1 = this;

	        if (!result) {
	            result = {};
	        }
	        for (var i = 0; i < glyphIds.length; ++i) {
	            var id = glyphIds[i];
	            if (!result[id]) {
	                var glyph = result[id] = this$1.font.glyf.glyphFor(id);
	                if (glyph && glyph.compound) {
	                    this$1.glyphsFor(glyph.glyphIds, result);
	                }
	            }
	        }
	        return result;
	    },
	    render: function() {
	        var this$1 = this;

	        var glyphs = this.glyphsFor(this.glyphIds());

	        // add missing sub-glyphs
	        for (var old_gid in glyphs) {
	            if (hasOwnProperty$1(glyphs, old_gid)) {
	                old_gid = parseInt(old_gid, 10);
	                if (this$1.ogid2ngid[old_gid] == null) {
	                    var new_gid = this$1.nextGid++;
	                    this$1.ogid2ngid[old_gid] = new_gid;
	                    this$1.ngid2ogid[new_gid] = old_gid;
	                }
	            }
	        }

	        // must obtain old_gid_ids in an order matching sorted
	        // new_gid_ids
	        var new_gid_ids = sortedKeys(this.ngid2ogid);
	        var old_gid_ids = new_gid_ids.map(function(id){
	            return this.ngid2ogid[id];
	        }, this);

	        var font = this.font;
	        var glyf = font.glyf.render(glyphs, old_gid_ids, this.ogid2ngid);
	        var loca = font.loca.render(glyf.offsets);

	        this.lastChar = this.next - 1;

	        var tables = {
	            "cmap" : CmapTable.render(this.ncid2ogid, this.ogid2ngid),
	            "glyf" : glyf.table,
	            "loca" : loca.table,
	            "hmtx" : font.hmtx.render(old_gid_ids),
	            "hhea" : font.hhea.render(old_gid_ids),
	            "maxp" : font.maxp.render(old_gid_ids),
	            "post" : font.post.render(old_gid_ids),
	            "name" : font.name.render(this.psName),
	            "head" : font.head.render(loca.format),
	            "OS/2" : font.os2.render()
	        };

	        return this.font.directory.render(tables);
	    },
	    cidToGidMap: function() {
	        var this$1 = this;

	        var out = BinaryStream(), len = 0;
	        for (var cid = this.firstChar; cid < this.next; ++cid) {
	            while (len < cid) {
	                out.writeShort(0);
	                len++;
	            }
	            var old_gid = this$1.ncid2ogid[cid];
	            if (old_gid) {
	                var new_gid = this$1.ogid2ngid[old_gid];
	                out.writeShort(new_gid);
	            } else {
	                out.writeShort(0);
	            }
	            len++;
	        }
	        return out.get();
	    }
	};

	function TTFFont(rawData, name) {
	    var self = this;
	    var data = self.contents = BinaryStream(rawData);
	    if (data.readString(4) == "ttcf") {
	        var offset;
	        var parse = function() {
	            data.offset(offset);
	            self.parse();
	        };
	        if (!name) {
	            throw new Error("Must specify a name for TTC files");
	        }
	        data.readLong();        // version
	        var numFonts = data.readLong();
	        for (var i = 0; i < numFonts; ++i) {
	            offset = data.readLong();
	            data.saveExcursion(parse);
	            if (self.psName == name) {
	                return;
	            }
	        }
	        throw new Error("Font " + name + " not found in collection");
	    } else {
	        data.offset(0);
	        self.parse();
	    }
	}

	TTFFont.prototype = {
	    parse: function() {
	        var dir = this.directory = new Directory(this.contents);

	        this.head = dir.readTable("head", HeadTable);
	        this.loca = dir.readTable("loca", LocaTable);
	        this.hhea = dir.readTable("hhea", HheaTable);
	        this.maxp = dir.readTable("maxp", MaxpTable);
	        this.hmtx = dir.readTable("hmtx", HmtxTable);
	        this.glyf = dir.readTable("glyf", GlyfTable);
	        this.name = dir.readTable("name", NameTable);
	        this.post = dir.readTable("post", PostTable);
	        this.cmap = dir.readTable("cmap", CmapTable);
	        this.os2  = dir.readTable("OS/2", OS2Table);

	        this.psName = this.name.postscriptName;
	        this.ascent = this.os2.ascent || this.hhea.ascent;
	        this.descent = this.os2.descent || this.hhea.descent;
	        this.lineGap = this.os2.lineGap || this.hhea.lineGap;
	        this.scale = 1000 / this.head.unitsPerEm;
	    },
	    widthOfGlyph: function(glyph) {
	        return this.hmtx.forGlyph(glyph).advance * this.scale;
	    },
	    makeSubset: function() {
	        return new Subfont(this);
	    }
	};

	var fromCharCode = String.fromCharCode;

	var BOM = '\xfe\xff';

	// Encodes a string as UTF-8

	function encodeUnit(codeUnit) {
	    return fromCharCode(codeUnit >> 8) + fromCharCode(codeUnit & 0x00ff);
	}

	// Encodes a string as UTF-16 big-endian
	function encodeUTF16BE(input) {
	    var output = '';

	    for (var i = 0; i < input.length; i++) {
	        var c = input.charCodeAt(i);

	        if (c < 0xFFFF) {
	            output += encodeUnit(c);
	        } else {
	            var lead = ((c - 0x10000) >> 10) + 0xD800;
	            var trail = ((c - 0x10000) & 0x3FF) + 0xDC00;
	            output += encodeUnit(lead);
	            output += encodeUnit(trail);
	        }
	    }

	    return output;
	}

	/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
	/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
	/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
	/* eslint-disable no-param-reassign, no-var, block-scoped-var */

	var browser = kendo.support.browser;
	var NL = "\n";

	var RESOURCE_COUNTER = 0;

	var PAPER_SIZE = {
	    a0        : [ 2383.94 , 3370.39 ],
	    a1        : [ 1683.78 , 2383.94 ],
	    a2        : [ 1190.55 , 1683.78 ],
	    a3        : [ 841.89  , 1190.55 ],
	    a4        : [ 595.28  , 841.89  ],
	    a5        : [ 419.53  , 595.28  ],
	    a6        : [ 297.64  , 419.53  ],
	    a7        : [ 209.76  , 297.64  ],
	    a8        : [ 147.40  , 209.76  ],
	    a9        : [ 104.88  , 147.40  ],
	    a10       : [ 73.70   , 104.88  ],
	    b0        : [ 2834.65 , 4008.19 ],
	    b1        : [ 2004.09 , 2834.65 ],
	    b2        : [ 1417.32 , 2004.09 ],
	    b3        : [ 1000.63 , 1417.32 ],
	    b4        : [ 708.66  , 1000.63 ],
	    b5        : [ 498.90  , 708.66  ],
	    b6        : [ 354.33  , 498.90  ],
	    b7        : [ 249.45  , 354.33  ],
	    b8        : [ 175.75  , 249.45  ],
	    b9        : [ 124.72  , 175.75  ],
	    b10       : [ 87.87   , 124.72  ],
	    c0        : [ 2599.37 , 3676.54 ],
	    c1        : [ 1836.85 , 2599.37 ],
	    c2        : [ 1298.27 , 1836.85 ],
	    c3        : [ 918.43  , 1298.27 ],
	    c4        : [ 649.13  , 918.43  ],
	    c5        : [ 459.21  , 649.13  ],
	    c6        : [ 323.15  , 459.21  ],
	    c7        : [ 229.61  , 323.15  ],
	    c8        : [ 161.57  , 229.61  ],
	    c9        : [ 113.39  , 161.57  ],
	    c10       : [ 79.37   , 113.39  ],
	    executive : [ 521.86  , 756.00  ],
	    folio     : [ 612.00  , 936.00  ],
	    legal     : [ 612.00  , 1008.00 ],
	    letter    : [ 612.00  , 792.00  ],
	    tabloid   : [ 792.00  , 1224.00 ]
	};

	function makeOutput() {
	    var indentLevel = 0, output = BinaryStream();
	    function out() {
	        var arguments$1 = arguments;

	        for (var i = 0; i < arguments.length; ++i) {
	            var x = arguments$1[i];
	            if (x === undefined) {
	                throw new Error("Cannot output undefined to PDF");
	            }
	            else if (x instanceof PDFValue) {
	                x.beforeRender(out);
	                x.render(out);
	            }
	            else if (isArray(x)) {
	                renderArray(x, out);
	            }
	            else if (isDate(x)) {
	                renderDate(x, out);
	            }
	            else if (typeof x == "number") {
	                if (isNaN(x)) {
	                    throw new Error("Cannot output NaN to PDF");
	                }
	                // make sure it doesn't end up in exponent notation
	                var num = x.toFixed(7);
	                if (num.indexOf(".") >= 0) {
	                    num = num.replace(/\.?0+$/, "");
	                }
	                if (num == "-0") {
	                    num = "0";
	                }
	                output.writeString(num);
	            }
	            else if (/string|boolean/.test(typeof x)) {
	                output.writeString(String(x));
	            }
	            else if (typeof x.get == "function") {
	                output.write(x.get());
	            }
	            else if (typeof x == "object") {
	                if (!x) {
	                    output.writeString("null");
	                } else {
	                    out(new PDFDictionary(x));
	                }
	            }
	        }
	    }
	    out.writeData = function(data) {
	        output.write(data);
	    };
	    out.withIndent = function(f) {
	        ++indentLevel;
	        f(out);
	        --indentLevel;
	    };
	    out.indent = function() {
	        out(NL, pad("", indentLevel * 2, "  "));
	        out.apply(null, arguments);
	    };
	    out.offset = function() {
	        return output.offset();
	    };
	    out.toString = function() {
	        throw new Error("FIX CALLER");
	    };
	    out.get = function() {
	        return output.get();
	    };
	    out.stream = function() {
	        return output;
	    };
	    return out;
	}

	function wrapObject(value, id) {
	    var beforeRender = value.beforeRender;
	    var renderValue = value.render;

	    value.beforeRender = function(){};

	    value.render = function(out) {
	        out(id, " 0 R");
	    };

	    value.renderFull = function(out) {
	        value._offset = out.offset();
	        out(id, " 0 obj ");
	        beforeRender.call(value, out);
	        renderValue.call(value, out);
	        out(" endobj");
	    };
	}

	function getPaperOptions(getOption) {
	    if (typeof getOption != "function") {
	        var options = getOption;
	        getOption = function(key, def) {
	            return key in options ? options[key] : def;
	        };
	    }
	    var paperSize = getOption("paperSize", PAPER_SIZE.a4);
	    if (!paperSize) {
	        return {};
	    }
	    if (typeof paperSize == "string") {
	        paperSize = PAPER_SIZE[paperSize.toLowerCase()];
	        if (paperSize == null) {
	            throw new Error("Unknown paper size");
	        }
	    }

	    paperSize[0] = unitsToPoints(paperSize[0]);
	    paperSize[1] = unitsToPoints(paperSize[1]);

	    if (getOption("landscape", false)) {
	        paperSize = [
	            Math.max(paperSize[0], paperSize[1]),
	            Math.min(paperSize[0], paperSize[1])
	        ];
	    }

	    var margin = getOption("margin");
	    if (margin) {
	        if (typeof margin == "string" || typeof margin == "number") {
	            margin = unitsToPoints(margin, 0);
	            margin = { left: margin, top: margin, right: margin, bottom: margin };
	        } else {
	            margin = {
	                left   : unitsToPoints(margin.left, 0),
	                top    : unitsToPoints(margin.top, 0),
	                right  : unitsToPoints(margin.right, 0),
	                bottom : unitsToPoints(margin.bottom, 0)
	            };
	        }
	        if (getOption("addMargin")) {
	            paperSize[0] += margin.left + margin.right;
	            paperSize[1] += margin.top + margin.bottom;
	        }
	    }
	    return { paperSize: paperSize, margin: margin };
	}

	function PDFDocument(options) {
	    var self = this;
	    var out = makeOutput();
	    var objcount = 0;
	    var objects = [];

	    function getOption(name, defval) {
	        return (options && options[name] != null) ? options[name] : defval;
	    }

	    self.getOption = getOption;

	    self.attach = function(value) {
	        if (objects.indexOf(value) < 0) {
	            wrapObject(value, ++objcount);
	            objects.push(value);
	        }
	        return value;
	    };

	    self.pages = [];

	    self.FONTS = {};
	    self.IMAGES = {};
	    self.GRAD_COL_FUNCTIONS = {}; // cache for color gradient functions
	    self.GRAD_OPC_FUNCTIONS = {}; // cache for opacity gradient functions
	    self.GRAD_COL = {};     // cache for whole color gradient objects
	    self.GRAD_OPC = {};     // cache for whole opacity gradient objects

	    var catalog = self.attach(new PDFCatalog());
	    var pageTree = self.attach(new PDFPageTree());

	    if (getOption("autoPrint")) {
	        var nameTree = {};
	        nameTree.JavaScript = new PDFDictionary({ Names: [
	            new PDFString("JS"), self.attach(new PDFDictionary({
	                S: _("JavaScript"),
	                JS: new PDFString("print(true);")
	            }))
	        ] });
	        catalog.props.Names = new PDFDictionary(nameTree);
	    }

	    catalog.setPages(pageTree);

	    var info = self.attach(new PDFDictionary({
	        Producer     : new PDFString(getOption("producer", "Kendo UI PDF Generator"), true), // XXX: kendo.version?
	        Title        : new PDFString(getOption("title", ""), true),
	        Author       : new PDFString(getOption("author", ""), true),
	        Subject      : new PDFString(getOption("subject", ""), true),
	        Keywords     : new PDFString(getOption("keywords", ""), true),
	        Creator      : new PDFString(getOption("creator", "Kendo UI PDF Generator"), true),
	        CreationDate : getOption("date", new Date())
	    }));

	    self.addPage = function(options) {
	        var paperOptions  = getPaperOptions(function(name, defval){
	            return (options && options[name] != null) ? options[name] : defval;
	        });
	        var paperSize     = paperOptions.paperSize;
	        var margin        = paperOptions.margin;
	        var contentWidth  = paperSize[0];
	        var contentHeight = paperSize[1];
	        if (margin) {
	            contentWidth -= margin.left + margin.right;
	            contentHeight -= margin.top + margin.bottom;
	        }
	        var content = new PDFStream(makeOutput(), null, true);
	        var props = {
	            Contents : self.attach(content),
	            Parent   : pageTree,
	            MediaBox : [ 0, 0, paperSize[0], paperSize[1] ]
	        };
	        var page = new PDFPage(self, props);
	        page._content = content;
	        pageTree.addPage(self.attach(page));

	        // canvas-like coord. system.  (0,0) is upper-left.
	        // text must be vertically mirorred before drawing.
	        page.transform(1, 0, 0, -1, 0, paperSize[1]);

	        if (margin) {
	            page.translate(margin.left, margin.top);
	            // XXX: clip to right/bottom margin.  Make this optional?
	            page.rect(0, 0, contentWidth, contentHeight);
	            page.clip();
	        }

	        self.pages.push(page);
	        return page;
	    };

	    self.render = function() {
	        var i;
	        /// file header
	        out("%PDF-1.4", NL, "%\xc2\xc1\xda\xcf\xce", NL, NL);

	        /// file body
	        for (i = 0; i < objects.length; ++i) {
	            objects[i].renderFull(out);
	            out(NL, NL);
	        }

	        /// cross-reference table
	        var xrefOffset = out.offset();
	        out("xref", NL, 0, " ", objects.length + 1, NL);
	        out("0000000000 65535 f ", NL);
	        for (i = 0; i < objects.length; ++i) {
	            out(zeropad(objects[i]._offset, 10), " 00000 n ", NL);
	        }
	        out(NL);

	        /// trailer
	        out("trailer", NL);
	        out(new PDFDictionary({
	            Size: objects.length + 1,
	            Root: catalog,
	            Info: info
	        }), NL, NL);

	        /// end
	        out("startxref", NL, xrefOffset, NL);
	        out("%%EOF", NL);

	        return out.stream().offset(0);
	    };
	}

	var FONT_CACHE = {
	    "Times-Roman"           : true,
	    "Times-Bold"            : true,
	    "Times-Italic"          : true,
	    "Times-BoldItalic"      : true,
	    "Helvetica"             : true,
	    "Helvetica-Bold"        : true,
	    "Helvetica-Oblique"     : true,
	    "Helvetica-BoldOblique" : true,
	    "Courier"               : true,
	    "Courier-Bold"          : true,
	    "Courier-Oblique"       : true,
	    "Courier-BoldOblique"   : true,
	    "Symbol"                : true,
	    "ZapfDingbats"          : true
	};

	function loadBinary(url, cont) {
	    // IE throws Accesss denied error for Data URIs
	    var m;
	    if (browser.msie && (m = /^data:.*?;base64,/i.exec(url))) {
	        cont(base64ToUint8Array(url.substr(m[0].length)));
	        return;
	    }

	    function error() {
	        if (window.console) {
	            if (window.console.error) {
	                window.console.error("Cannot load URL: %s", url);
	            } else {
	                window.console.log("Cannot load URL: %s", url);
	            }
	        }
	        cont(null);
	    }
	    var req = new XMLHttpRequest();
	    req.open('GET', url, true);
	    if (HAS_TYPED_ARRAYS) {
	        req.responseType = "arraybuffer";
	    }
	    req.onload = function() {
	        if (req.status == 200 || req.status == 304) {
	            if (HAS_TYPED_ARRAYS) {
	                cont(new Uint8Array(req.response));
	            } else {
	                cont(new window.VBArray(req.responseBody).toArray()); // IE9 only
	            }
	        } else {
	            error();
	        }
	    };
	    req.onerror = error;
	    req.send(null);
	}

	function loadFont(url, cont) {
	    var font = FONT_CACHE[url];
	    if (font) {
	        cont(font);
	    } else {
	        loadBinary(url, function(data){
	            if (data == null) {
	                throw new Error("Cannot load font from " + url);
	            } else {
	                var font = new TTFFont(data);
	                FONT_CACHE[url] = font;
	                cont(font);
	            }
	        });
	    }
	}

	var IMAGE_CACHE = {};

	function clearImageCache() {
	    IMAGE_CACHE = {};
	}

	function loadImage(url, size, cont, options) {
	    var img = IMAGE_CACHE[url], bloburl, blob;
	    if (img) {
	        cont(img);
	    } else {
	        img = new Image();
	        if (!(/^data:/i.test(url))) {
	            img.crossOrigin = "Anonymous";
	        }
	        if (HAS_TYPED_ARRAYS && !(/^data:/i.test(url))) {
	            // IE10 fails to load images from another domain even when the server sends the
	            // proper CORS headers.  a XHR, however, will be able to load the data.
	            // http://stackoverflow.com/a/19734516/154985
	            //
	            // On the other hand, it's worth doing it this way for all browsers which support
	            // responseType = "blob" (HAS_TYPED_ARRAYS will be true), because we can inspect the
	            // mime type and if it's a JPEG (very common case) we can save a lot of time in
	            // _load below.
	            var xhr = new XMLHttpRequest();
	            xhr.onload = function() {
	                blob = xhr.response;
	                bloburl = URL.createObjectURL(blob);
	                _load(bloburl);
	            };
	            xhr.onerror = _onerror;
	            xhr.open("GET", url, true);
	            xhr.responseType = "blob";
	            xhr.send();
	        } else {
	            _load(url);
	        }
	    }

	    function _load(url) {
	        img.src = url;
	        if (img.complete && !browser.msie) {
	            // IE, bless it's little heart, says img.complete == true even though the image is
	            // not loaded (width=0), therefore we must go the onload route (ticket 929635).
	            _onload();
	        } else {
	            img.onload = _onload;
	            img.onerror = _onerror;
	        }
	    }

	    function _trycanvas() {
	        if (!size) {
	            size = { width: img.width, height: img.height };
	        }

	        var canvas = document.createElement("canvas");
	        canvas.width = size.width;
	        canvas.height = size.height;

	        var ctx = canvas.getContext("2d");
	        ctx.drawImage(img, 0, 0, size.width, size.height);

	        var imgdata;
	        try {
	            imgdata = ctx.getImageData(0, 0, size.width, size.height);
	        } catch (ex) {
	            // it tainted the canvas -- can't draw it.
	            _onerror();
	            return;
	        } finally {
	            if (bloburl) {
	                URL.revokeObjectURL(bloburl);
	            }
	        }

	        // in case it contains transparency, we must separate rgb data from the alpha
	        // channel and create a PDFRawImage image with opacity.  otherwise we can use a
	        // PDFJpegImage.
	        //
	        // to do this in one step, we create the rgb and alpha streams anyway, even if
	        // we might end up not using them if hasAlpha remains false.

	        var hasAlpha = false, rgb = BinaryStream(), alpha = BinaryStream();
	        var rawbytes = imgdata.data;
	        var i = 0;
	        while (i < rawbytes.length) {
	            rgb.writeByte(rawbytes[i++]);
	            rgb.writeByte(rawbytes[i++]);
	            rgb.writeByte(rawbytes[i++]);
	            var a = rawbytes[i++];
	            if (a < 255) {
	                hasAlpha = true;
	            }
	            alpha.writeByte(a);
	        }

	        if (hasAlpha || options.keepPNG) {
	            img = new PDFRawImage(size.width, size.height, rgb, alpha);
	        } else {
	            // no transparency, encode as JPEG.
	            var data = canvas.toDataURL("image/jpeg", options.jpegQuality);
	            data = data.substr(data.indexOf(";base64,") + 8);

	            var stream = BinaryStream();
	            stream.writeBase64(data);
	            img = new PDFJpegImage(stream);
	        }

	        cont(IMAGE_CACHE[url] = img);
	    }

	    function _onerror() {
	        cont(IMAGE_CACHE[url] = "ERROR");
	    }

	    function _onload() {
	        if (size) {
	            // but if requested size is bigger than the image, just use the original image.
	            if (size.width >= img.width || size.height >= img.height) {
	                size = null;
	            }
	        }
	        if (!size && blob && /^image\/jpe?g$/i.test(blob.type)) {
	            // If we know we got a JPEG, we can skip the process of rendering it to a
	            // canvas, getting the pixel data, searching for transparency we know we won't
	            // find, getting back a data URI and then decoding the BASE64 to finally get the
	            // binary we already have.  Also, we avoid downgrading the image quality, with
	            // the possible drawback of making a bigger PDF; still, seems legit.
	            //
	            // Besides saving a lot of work, this also reuses the buffer memory
	            // (BinaryStream does not create a copy), potentially saving some GC cycles.
	            var reader = new FileReader();
	            reader.onload = function() {
	                try {
	                    var img = new PDFJpegImage(BinaryStream(new Uint8Array(this.result)));
	                    URL.revokeObjectURL(bloburl);
	                    cont(IMAGE_CACHE[url] = img);
	                } catch (ex) {
	                    // if there's an error parsing the JPEG stream, it could be due to a
	                    // misconfigured server (improper content-type:
	                    // https://github.com/telerik/kendo-ui-core/issues/4184).  If that's the case,
	                    // the canvas will still be able to draw it.
	                    _trycanvas();
	                }
	            };
	            reader.readAsArrayBuffer(blob);
	        } else {
	            _trycanvas();
	        }
	    }
	}

	function manyLoader(loadOne) {
	    return function(urls, callback) {
	        var n = urls.length, i = n;
	        if (n === 0) {
	            return callback();
	        }
	        function next() {
	            if (--n === 0) {
	                callback();
	            }
	        }
	        while (i-- > 0) {
	            loadOne(urls[i], next);
	        }
	    };
	}

	var loadFonts = manyLoader(loadFont);
	var loadImages = function(images, callback, options) {
	    options = $.extend({
	        jpegQuality : 0.92,
	        keepPNG     : false
	    }, options);
	    var urls = Object.keys(images), n = urls.length;
	    if (n === 0) {
	        return callback();
	    }
	    function next() {
	        if (--n === 0) {
	            callback();
	        }
	    }
	    urls.forEach(function(url){
	        loadImage(url, images[url], next, options);
	    });
	};

	PDFDocument.prototype = {
	    loadFonts: loadFonts,
	    loadImages: loadImages,

	    getFont: function(url) {
	        var font = this.FONTS[url];
	        if (!font) {
	            font = FONT_CACHE[url];
	            if (!font) {
	                throw new Error("Font " + url + " has not been loaded");
	            }
	            if (font === true) {
	                font = this.attach(new PDFStandardFont(url));
	            } else {
	                font = this.attach(new PDFFont(this, font));
	            }
	            this.FONTS[url] = font;
	        }
	        return font;
	    },

	    getImage: function(url) {
	        var img = this.IMAGES[url];
	        if (!img) {
	            img = IMAGE_CACHE[url];
	            if (!img) {
	                throw new Error("Image " + url + " has not been loaded");
	            }
	            if (img === "ERROR") {
	                return null;
	            }
	            img = this.IMAGES[url] = this.attach(img.asStream(this));
	        }
	        return img;
	    },

	    getOpacityGS: function(opacity, forStroke) {
	        var id = parseFloat(opacity).toFixed(3);
	        opacity = parseFloat(id);
	        id += forStroke ? "S" : "F";
	        var cache = this._opacityGSCache || (this._opacityGSCache = {});
	        var gs = cache[id];
	        if (!gs) {
	            var props = {
	                Type: _("ExtGState")
	            };
	            if (forStroke) {
	                props.CA = opacity;
	            } else {
	                props.ca = opacity;
	            }
	            gs = this.attach(new PDFDictionary(props));
	            gs._resourceName = _("GS" + (++RESOURCE_COUNTER));
	            cache[id] = gs;
	        }
	        return gs;
	    },

	    dict: function(props) {
	        return new PDFDictionary(props);
	    },

	    name: function(str) {
	        return _(str);
	    },

	    stream: function(props, content) {
	        return new PDFStream(content, props);
	    }
	};

	/* -----[ utils ]----- */

	function pad(str, len, ch) {
	    while (str.length < len) {
	        str = ch + str;
	    }
	    return str;
	}

	function zeropad(n, len) {
	    return pad(String(n), len, "0");
	}

	function hasOwnProperty(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}

	var isArray = Array.isArray || function(obj) {
	    return obj instanceof Array;
	};

	function isDate(obj) {
	    return obj instanceof Date;
	}

	function renderArray(a, out) {
	    out("[");
	    if (a.length > 0) {
	        out.withIndent(function(){
	            for (var i = 0; i < a.length; ++i) {
	                if (i > 0 && i % 8 === 0) {
	                    out.indent(a[i]);
	                } else {
	                    out(" ", a[i]);
	                }
	            }
	        });
	        //out.indent();
	    }
	    out(" ]");
	}

	function renderDate(date, out) {
	    out("(D:",
	        zeropad(date.getUTCFullYear(), 4),
	        zeropad(date.getUTCMonth() + 1, 2),
	        zeropad(date.getUTCDate(), 2),
	        zeropad(date.getUTCHours(), 2),
	        zeropad(date.getUTCMinutes(), 2),
	        zeropad(date.getUTCSeconds(), 2),
	        "Z)");
	}

	function mm2pt(mm) {
	    return mm * (72/25.4);
	}

	function cm2pt(cm) {
	    return mm2pt(cm * 10);
	}

	function in2pt(inch)  {
	    return inch * 72;
	}

	function unitsToPoints(x, def) {
	    if (typeof x == "number") {
	        return x;
	    }
	    if (typeof x == "string") {
	        var m;
	        m = /^\s*([0-9.]+)\s*(mm|cm|in|pt)\s*$/.exec(x);
	        if (m) {
	            var num = parseFloat(m[1]);
	            if (!isNaN(num)) {
	                if (m[2] == "pt") {
	                    return num;
	                }
	                return {
	                    "mm": mm2pt,
	                    "cm": cm2pt,
	                    "in": in2pt
	                }[m[2]](num);
	            }
	        }
	    }
	    if (def != null) {
	        return def;
	    }
	    throw new Error("Can't parse unit: " + x);
	}

	/* -----[ PDF basic objects ]----- */

	function PDFValue(){}

	PDFValue.prototype.beforeRender = function(){};

	function defclass(Ctor, proto, Base) {
	    if (!Base) {
	        Base = PDFValue;
	    }
	    Ctor.prototype = new Base();
	    for (var i in proto) {
	        if (hasOwnProperty(proto, i)) {
	            Ctor.prototype[i] = proto[i];
	        }
	    }
	    return Ctor;
	}

	var PDFString = defclass(function PDFString(value, utf16be){
	    this.value = value;
	    this.utf16be = Boolean(utf16be);
	}, {
	    render: function(out) {
	        var txt = this.value;
	        if (this.utf16be) {
	            txt = BOM + encodeUTF16BE(txt);
	            txt = txt.replace(/([\(\)\\])/g, "\\$1");
	            out("(", txt, ")");
	        } else {
	            // out.writeString truncates charcodes to 8 bits and
	            // 0x128 & 0xFF is 40, the code for open paren.
	            // therefore we need to do the chopping here to make
	            // sure we backslash all cases.
	            var data = [ 40 ]; // open PDF string '('
	            for (var i = 0; i < txt.length; ++i) {
	                var code = txt.charCodeAt(i) & 0xFF;
	                if (code == 40 || code == 41 || code == 92) {
	                    // backslash before (, ) and \
	                    data.push(92);
	                }
	                data.push(code);
	            }
	            data.push(41);  // ')' close PDF string
	            out.writeData(data);
	        }
	    },
	    toString: function() {
	        return this.value;
	    }
	});

	var PDFHexString = defclass(function PDFHexString(value){
	    this.value = value;
	}, {
	    render: function(out) {
	        var this$1 = this;

	        out("<");
	        for (var i = 0; i < this.value.length; ++i) {
	            out(zeropad(this$1.value.charCodeAt(i).toString(16), 4));
	        }
	        out(">");
	    }
	}, PDFString);

	/// names

	var PDFName = defclass(function PDFName(name) {
	    this.name = name;
	}, {
	    render: function(out) {
	        out("/" + this.escape());
	    },
	    escape: function() {
	        return this.name.replace(/[^\x21-\x7E]/g, function(c){
	            return "#" + zeropad(c.charCodeAt(0).toString(16), 2);
	        });
	    },
	    toString: function() {
	        return this.name;
	    }
	});

	var PDFName_cache = {};
	PDFName.get = _;

	function _(name) {
	    if (hasOwnProperty(PDFName_cache, name)) {
	        return PDFName_cache[name];
	    }
	    return (PDFName_cache[name] = new PDFName(name));
	}

	/// dictionary

	var PDFDictionary = defclass(function PDFDictionary(props) {
	    this.props = props;
	}, {
	    render: function(out) {
	        var props = this.props, empty = true;
	        out("<<");
	        out.withIndent(function(){
	            for (var i in props) {
	                if (hasOwnProperty(props, i) && !/^_/.test(i)) {
	                    empty = false;
	                    out.indent(_(i), " ", props[i]);
	                }
	            }
	        });
	        if (!empty) {
	            out.indent();
	        }
	        out(">>");
	    }
	});

	/// streams

	var PDFStream = defclass(function PDFStream(data, props, compress) {
	    if (typeof data == "string") {
	        var tmp = BinaryStream();
	        tmp.write(data);
	        data = tmp;
	    }
	    this.data = data;
	    this.props = props || {};
	    this.compress = compress;
	}, {
	    render: function(out) {
	        var data = this.data.get(), props = this.props;
	        if (this.compress && kendoPdf.supportsDeflate()) {
	            if (!props.Filter) {
	                props.Filter = [];
	            } else if (!(props.Filter instanceof Array)) {
	                props.Filter = [ props.Filter ];
	            }
	            props.Filter.unshift(_("FlateDecode"));
	            data = kendoPdf.deflate(data);
	        }
	        props.Length = data.length;
	        out(new PDFDictionary(props), " stream", NL);
	        out.writeData(data);
	        out(NL, "endstream");
	    }
	});

	/// catalog

	var PDFCatalog = defclass(function PDFCatalog(){
	    this.props = {
	        Type: _("Catalog")
	    };
	}, {
	    setPages: function(pagesObj) {
	        this.props.Pages = pagesObj;
	    }
	}, PDFDictionary);

	/// page tree

	var PDFPageTree = defclass(function PDFPageTree(){
	    this.props = {
	        Type  : _("Pages"),
	        Kids  : [],
	        Count : 0
	    };
	}, {
	    addPage: function(pageObj) {
	        this.props.Kids.push(pageObj);
	        this.props.Count++;
	    }
	}, PDFDictionary);

	/// images

	// JPEG

	var SOF_CODES = [0xc0, 0xc1, 0xc2, 0xc3, 0xc5, 0xc6, 0xc7, 0xc9, 0xca, 0xcb, 0xcd, 0xce, 0xcf];

	function PDFJpegImage(data) {
	    // we must determine the correct color space.  we'll parse a bit
	    // of the JPEG stream for this, it's still better than going
	    // through the canvas.
	    // https://github.com/telerik/kendo-ui-core/issues/2845
	    data.offset(0);
	    var width, height, colorSpace, bitsPerComponent;
	    var soi = data.readShort();
	    if (soi != 0xFFD8) {
	        // XXX: do we have some better options here?
	        throw new Error("Invalid JPEG image");
	    }
	    while (!data.eof()) {
	        var ff = data.readByte();
	        if (ff != 0xFF) {
	            throw new Error("Invalid JPEG image");
	        }
	        var marker = data.readByte();
	        var length = data.readShort();
	        if (SOF_CODES.indexOf(marker) >= 0) {
	            // "start of frame" marker
	            bitsPerComponent = data.readByte();
	            height = data.readShort();
	            width = data.readShort();
	            colorSpace = data.readByte();
	            break;
	        }
	        data.skip(length - 2);
	    }

	    if (colorSpace == null) {
	        throw new Error("Invalid JPEG image");
	    }

	    var props = {
	        Type             : _("XObject"),
	        Subtype          : _("Image"),
	        Width            : width,
	        Height           : height,
	        BitsPerComponent : bitsPerComponent,
	        Filter           : _("DCTDecode")
	    };

	    switch (colorSpace) {
	      case 1:
	        props.ColorSpace = _("DeviceGray");
	        break;
	      case 3:
	        props.ColorSpace = _("DeviceRGB");
	        break;
	      case 4:
	        props.ColorSpace = _("DeviceCMYK");
	        props.Decode = [ 1, 0, 1, 0, 1, 0, 1, 0 ]; // invert colors
	        break;
	    }

	    this.asStream = function() {
	        data.offset(0);
	        var stream = new PDFStream(data, props);
	        stream._resourceName = _("I" + (++RESOURCE_COUNTER));
	        return stream;
	    };
	}

	// PDFRawImage will be used for images with transparency (PNG)

	function PDFRawImage(width, height, rgb, alpha) {
	    this.asStream = function(pdf) {
	        var mask = new PDFStream(alpha, {
	            Type             : _("XObject"),
	            Subtype          : _("Image"),
	            Width            : width,
	            Height           : height,
	            BitsPerComponent : 8,
	            ColorSpace       : _("DeviceGray")
	        }, true);
	        var stream = new PDFStream(rgb, {
	            Type             : _("XObject"),
	            Subtype          : _("Image"),
	            Width            : width,
	            Height           : height,
	            BitsPerComponent : 8,
	            ColorSpace       : _("DeviceRGB"),
	            SMask            : pdf.attach(mask)
	        }, true);
	        stream._resourceName = _("I" + (++RESOURCE_COUNTER));
	        return stream;
	    };
	}

	/// standard fonts

	var PDFStandardFont = defclass(function PDFStandardFont(name){
	    this.props = {
	        Type     : _("Font"),
	        Subtype  : _("Type1"),
	        BaseFont : _(name)
	    };
	    this._resourceName = _("F" + (++RESOURCE_COUNTER));
	}, {
	    encodeText: function(str) {
	        return new PDFString(String(str));
	    }
	}, PDFDictionary);

	/// TTF fonts

	var PDFFont = defclass(function PDFFont(pdf, font, props){
	    props = this.props = props || {};
	    props.Type = _("Font");
	    props.Subtype = _("Type0");
	    props.Encoding = _("Identity-H");

	    this._pdf = pdf;
	    this._font = font;
	    this._sub = font.makeSubset();
	    this._resourceName = _("F" + (++RESOURCE_COUNTER));

	    var head = font.head;

	    this.name = font.psName;
	    var scale = this.scale = font.scale;
	    this.bbox = [
	        head.xMin * scale,
	        head.yMin * scale,
	        head.xMax * scale,
	        head.yMax * scale
	    ];

	    this.italicAngle = font.post.italicAngle;
	    this.ascent = font.ascent * scale;
	    this.descent = font.descent * scale;
	    this.lineGap = font.lineGap * scale;
	    this.capHeight = font.os2.capHeight || this.ascent;
	    this.xHeight = font.os2.xHeight || 0;
	    this.stemV = 0;

	    this.familyClass = (font.os2.familyClass || 0) >> 8;
	    this.isSerif = this.familyClass >= 1 && this.familyClass <= 7;
	    this.isScript = this.familyClass == 10;

	    this.flags = ((font.post.isFixedPitch ? 1 : 0) |
	                  (this.isSerif ? 1 << 1 : 0) |
	                  (this.isScript ? 1 << 3 : 0) |
	                  (this.italicAngle !== 0 ? 1 << 6 : 0) |
	                  (1 << 5));
	}, {
	    encodeText: function(text) {
	        return new PDFHexString(this._sub.encodeText(String(text)));
	    },
	    getTextWidth: function(fontSize, text) {
	        var this$1 = this;

	        var width = 0, codeMap = this._font.cmap.codeMap;
	        for (var i = 0; i < text.length; ++i) {
	            var glyphId = codeMap[text.charCodeAt(i)];
	            width += this$1._font.widthOfGlyph(glyphId || 0);
	        }
	        return width * fontSize / 1000;
	    },
	    beforeRender: function() {
	        var self = this;
	        var sub = self._sub;

	        // write the TTF data
	        var data = sub.render();
	        var fontStream = new PDFStream(BinaryStream(data), {
	            Length1: data.length
	        }, true);

	        var descriptor = self._pdf.attach(new PDFDictionary({
	            Type         : _("FontDescriptor"),
	            FontName     : _(self._sub.psName),
	            FontBBox     : self.bbox,
	            Flags        : self.flags,
	            StemV        : self.stemV,
	            ItalicAngle  : self.italicAngle,
	            Ascent       : self.ascent,
	            Descent      : self.descent,
	            CapHeight    : self.capHeight,
	            XHeight      : self.xHeight,
	            FontFile2    : self._pdf.attach(fontStream)
	        }));

	        var cmap = sub.ncid2ogid;
	        var firstChar = sub.firstChar;
	        var lastChar = sub.lastChar;
	        var charWidths = [];
	        (function loop(i, chunk){
	            if (i <= lastChar) {
	                var gid = cmap[i];
	                if (gid == null) {
	                    loop(i + 1);
	                } else {
	                    if (!chunk) {
	                        charWidths.push(i, chunk = []);
	                    }
	                    chunk.push(self._font.widthOfGlyph(gid));
	                    loop(i + 1, chunk);
	                }
	            }
	        })(firstChar);

	        // As if two dictionaries weren't enough, we need another
	        // one, the "descendant font".  Only that one can be of
	        // Subtype CIDFontType2.  PDF is the X11 of document
	        // formats: portable but full of legacy that nobody cares
	        // about anymore.

	        var descendant = new PDFDictionary({
	            Type: _("Font"),
	            Subtype: _("CIDFontType2"),
	            BaseFont: _(self._sub.psName),
	            CIDSystemInfo: new PDFDictionary({
	                Registry   : new PDFString("Adobe"),
	                Ordering   : new PDFString("Identity"),
	                Supplement : 0
	            }),
	            FontDescriptor: descriptor,
	            FirstChar: firstChar,
	            LastChar: lastChar,
	            DW: Math.round(self._font.widthOfGlyph(0)),
	            W: charWidths,
	            CIDToGIDMap: self._pdf.attach(self._makeCidToGidMap())
	        });

	        var dict = self.props;
	        dict.BaseFont = _(self._sub.psName);
	        dict.DescendantFonts = [ self._pdf.attach(descendant) ];

	        // Compute the ToUnicode map so that apps can extract
	        // meaningful text from the PDF.
	        var unimap = new PDFToUnicodeCmap(firstChar, lastChar, sub.subset);
	        var unimapStream = new PDFStream(makeOutput(), null, true);
	        unimapStream.data(unimap);
	        dict.ToUnicode = self._pdf.attach(unimapStream);
	    },
	    _makeCidToGidMap: function() {
	        return new PDFStream(BinaryStream(this._sub.cidToGidMap()), null, true);
	    }
	}, PDFDictionary);

	var PDFToUnicodeCmap = defclass(function PDFUnicodeCMap(firstChar, lastChar, map){
	    this.firstChar = firstChar;
	    this.lastChar = lastChar;
	    this.map = map;
	}, {
	    render: function(out) {
	        out.indent("/CIDInit /ProcSet findresource begin");
	        out.indent("12 dict begin");
	        out.indent("begincmap");
	        out.indent("/CIDSystemInfo <<");
	        out.indent("  /Registry (Adobe)");
	        out.indent("  /Ordering (UCS)");
	        out.indent("  /Supplement 0");
	        out.indent(">> def");
	        out.indent("/CMapName /Adobe-Identity-UCS def");
	        out.indent("/CMapType 2 def");
	        out.indent("1 begincodespacerange");
	        out.indent("  <0000><ffff>");
	        out.indent("endcodespacerange");

	        var self = this;
	        out.indent(self.lastChar - self.firstChar + 1, " beginbfchar");
	        out.withIndent(function(){
	            for (var code = self.firstChar; code <= self.lastChar; ++code) {
	                var unicode = self.map[code];
	                var str = ucs2encode([ unicode ]);
	                out.indent("<", zeropad(code.toString(16), 4), ">", "<");
	                for (var i = 0; i < str.length; ++i) {
	                    out(zeropad(str.charCodeAt(i).toString(16), 4));
	                }
	                out(">");
	            }
	        });
	        out.indent("endbfchar");

	        out.indent("endcmap");
	        out.indent("CMapName currentdict /CMap defineresource pop");
	        out.indent("end");
	        out.indent("end");
	    }
	});

	/// gradients

	function makeHash(a) {
	    return a.map(function(x){
	        return isArray(x) ? makeHash(x)
	            : typeof x == "number" ? (Math.round(x * 1000) / 1000).toFixed(3)
	            : x;
	    }).join(" ");
	}

	function cacheColorGradientFunction(pdf, r1, g1, b1, r2, g2, b2) {
	    var hash = makeHash([ r1, g1, b1, r2, g2, b2 ]);
	    var func = pdf.GRAD_COL_FUNCTIONS[hash];
	    if (!func) {
	        func = pdf.GRAD_COL_FUNCTIONS[hash] = pdf.attach(new PDFDictionary({
	            FunctionType: 2,
	            Domain: [ 0, 1 ],
	            Range: [ 0, 1, 0, 1, 0, 1 ],
	            N: 1,
	            C0: [ r1 , g1 , b1 ],
	            C1: [ r2 , g2 , b2 ]
	        }));
	    }
	    return func;
	}

	function cacheOpacityGradientFunction(pdf, a1, a2) {
	    var hash = makeHash([ a1, a2 ]);
	    var func = pdf.GRAD_OPC_FUNCTIONS[hash];
	    if (!func) {
	        func = pdf.GRAD_OPC_FUNCTIONS[hash] = pdf.attach(new PDFDictionary({
	            FunctionType: 2,
	            Domain: [ 0, 1 ],
	            Range: [ 0, 1 ],
	            N: 1,
	            C0: [ a1 ],
	            C1: [ a2 ]
	        }));
	    }
	    return func;
	}

	function makeGradientFunctions(pdf, stops) {
	    var hasAlpha = false;
	    var opacities = [];
	    var colors = [];
	    var offsets = [];
	    var encode = [];
	    var i, prev, cur, prevColor, curColor;
	    for (i = 1; i < stops.length; ++i) {
	        prev = stops[i - 1];
	        cur = stops[i];
	        prevColor = prev.color;
	        curColor = cur.color;
	        colors.push(cacheColorGradientFunction(
	            pdf,
	            prevColor.r, prevColor.g, prevColor.b,
	            curColor.r,  curColor.g,  curColor.b
	        ));
	        if (prevColor.a < 1 || curColor.a < 1) {
	            hasAlpha = true;
	        }
	        offsets.push(cur.offset);
	        encode.push(0, 1);
	    }
	    if (hasAlpha) {
	        for (i = 1; i < stops.length; ++i) {
	            prev = stops[i - 1];
	            cur = stops[i];
	            prevColor = prev.color;
	            curColor = cur.color;
	            opacities.push(cacheOpacityGradientFunction(
	                pdf, prevColor.a, curColor.a
	            ));
	        }
	    }
	    offsets.pop();
	    return {
	        hasAlpha  : hasAlpha,
	        colors    : assemble(colors),
	        opacities : hasAlpha ? assemble(opacities) : null
	    };
	    function assemble(funcs) {
	        if (funcs.length == 1) {
	            return funcs[0];
	        }
	        return {
	            FunctionType: 3,
	            Functions: funcs,
	            Domain: [ 0, 1 ],
	            Bounds: offsets,
	            Encode: encode
	        };
	    }
	}

	function cacheColorGradient(pdf, isRadial, stops, coords, funcs, box) {
	    var shading, hash;
	    // if box is given then we have user-space coordinates, which
	    // means the gradient is designed for a certain position/size
	    // on page.  caching won't do any good.
	    if (!box) {
	        var a = [ isRadial ].concat(coords);
	        stops.forEach(function(x){
	            a.push(x.offset, x.color.r, x.color.g, x.color.b);
	        });
	        hash = makeHash(a);
	        shading = pdf.GRAD_COL[hash];
	    }
	    if (!shading) {
	        shading = new PDFDictionary({
	            Type: _("Shading"),
	            ShadingType: isRadial ? 3 : 2,
	            ColorSpace: _("DeviceRGB"),
	            Coords: coords,
	            Domain: [ 0, 1 ],
	            Function: funcs,
	            Extend: [ true, true ]
	        });
	        pdf.attach(shading);
	        shading._resourceName = "S" + (++RESOURCE_COUNTER);
	        if (hash) {
	            pdf.GRAD_COL[hash] = shading;
	        }
	    }
	    return shading;
	}

	function cacheOpacityGradient(pdf, isRadial, stops, coords, funcs, box) {
	    var opacity, hash;
	    // if box is given then we have user-space coordinates, which
	    // means the gradient is designed for a certain position/size
	    // on page.  caching won't do any good.
	    if (!box) {
	        var a = [ isRadial ].concat(coords);
	        stops.forEach(function(x){
	            a.push(x.offset, x.color.a);
	        });
	        hash = makeHash(a);
	        opacity = pdf.GRAD_OPC[hash];
	    }
	    if (!opacity) {
	        opacity = new PDFDictionary({
	            Type: _("ExtGState"),
	            AIS: false,
	            CA: 1,
	            ca: 1,
	            SMask: {
	                Type: _("Mask"),
	                S: _("Luminosity"),
	                G: pdf.attach(new PDFStream("/a0 gs /s0 sh", {
	                    Type: _("XObject"),
	                    Subtype: _("Form"),
	                    FormType: 1,
	                    BBox: (box ? [
	                        box.left, box.top + box.height, box.left + box.width, box.top
	                    ] : [ 0, 1, 1, 0 ]),
	                    Group: {
	                        Type: _("Group"),
	                        S: _("Transparency"),
	                        CS: _("DeviceGray"),
	                        I: true
	                    },
	                    Resources: {
	                        ExtGState: {
	                            a0: { CA: 1, ca: 1 }
	                        },
	                        Shading: {
	                            s0: {
	                                ColorSpace: _("DeviceGray"),
	                                Coords: coords,
	                                Domain: [ 0, 1 ],
	                                ShadingType: isRadial ? 3 : 2,
	                                Function: funcs,
	                                Extend: [ true, true ]
	                            }
	                        }
	                    }
	                }))
	            }
	        });
	        pdf.attach(opacity);
	        opacity._resourceName = "O" + (++RESOURCE_COUNTER);
	        if (hash) {
	            pdf.GRAD_OPC[hash] = opacity;
	        }
	    }
	    return opacity;
	}

	function cacheGradient(pdf, gradient, box) {
	    var isRadial = gradient.type == "radial";
	    var funcs = makeGradientFunctions(pdf, gradient.stops);
	    var coords = isRadial ? [
	        gradient.start.x , gradient.start.y , gradient.start.r,
	        gradient.end.x   , gradient.end.y   , gradient.end.r
	    ] : [
	        gradient.start.x , gradient.start.y,
	        gradient.end.x   , gradient.end.y
	    ];
	    var shading = cacheColorGradient(
	        pdf, isRadial, gradient.stops, coords, funcs.colors, gradient.userSpace && box
	    );
	    var opacity = funcs.hasAlpha ? cacheOpacityGradient(
	        pdf, isRadial, gradient.stops, coords, funcs.opacities, gradient.userSpace && box
	    ) : null;
	    return {
	        hasAlpha: funcs.hasAlpha,
	        shading: shading,
	        opacity: opacity
	    };
	}

	/// page object

	var PDFPage = defclass(function PDFPage(pdf, props){
	    this._pdf = pdf;
	    this._rcount = 0;
	    this._textMode = false;
	    this._fontResources = {};
	    this._gsResources = {};
	    this._xResources = {};
	    this._patResources = {};
	    this._shResources = {};
	    this._opacity = 1;
	    this._matrix = [ 1, 0, 0, 1, 0, 0 ];
	    this._annotations = [];

	    this._font = null;
	    this._fontSize = null;

	    this._contextStack = [];

	    props = this.props = props || {};
	    props.Type = _("Page");
	    props.ProcSet = [
	        _("PDF"),
	        _("Text"),
	        _("ImageB"),
	        _("ImageC"),
	        _("ImageI")
	    ];
	    props.Resources = new PDFDictionary({
	        Font      : new PDFDictionary(this._fontResources),
	        ExtGState : new PDFDictionary(this._gsResources),
	        XObject   : new PDFDictionary(this._xResources),
	        Pattern   : new PDFDictionary(this._patResources),
	        Shading   : new PDFDictionary(this._shResources)
	    });
	    props.Annots = this._annotations;
	}, {
	    _out: function() {
	        this._content.data.apply(null, arguments);
	    },
	    transform: function(a, b, c, d, e, f) {
	        if (!isIdentityMatrix(arguments)) {
	            this._matrix = mmul(arguments, this._matrix);
	            this._out(a, " ", b, " ", c, " ", d, " ", e, " ", f, " cm");
	            // XXX: debug
	            // this._out(" % current matrix: ", this._matrix);
	            this._out(NL);
	        }
	    },
	    translate: function(dx, dy) {
	        this.transform(1, 0, 0, 1, dx, dy);
	    },
	    scale: function(sx, sy) {
	        this.transform(sx, 0, 0, sy, 0, 0);
	    },
	    rotate: function(angle) {
	        var cos = Math.cos(angle), sin = Math.sin(angle);
	        this.transform(cos, sin, -sin, cos, 0, 0);
	    },
	    beginText: function() {
	        this._textMode = true;
	        this._out("BT", NL);
	    },
	    endText: function() {
	        this._textMode = false;
	        this._out("ET", NL);
	    },
	    _requireTextMode: function() {
	        if (!this._textMode) {
	            throw new Error("Text mode required; call page.beginText() first");
	        }
	    },
	    _requireFont: function() {
	        if (!this._font) {
	            throw new Error("No font selected; call page.setFont() first");
	        }
	    },
	    setFont: function(font, size) {
	        this._requireTextMode();
	        if (font == null) {
	            font = this._font;
	        } else if (!(font instanceof PDFFont)) {
	            font = this._pdf.getFont(font);
	        }
	        if (size == null) {
	            size = this._fontSize;
	        }
	        this._fontResources[font._resourceName] = font;
	        this._font = font;
	        this._fontSize = size;
	        this._out(font._resourceName, " ", size, " Tf", NL);
	    },
	    setTextLeading: function(size) {
	        this._requireTextMode();
	        this._out(size, " TL", NL);
	    },
	    setTextRenderingMode: function(mode) {
	        this._requireTextMode();
	        this._out(mode, " Tr", NL);
	    },
	    showText: function(text, requestedWidth) {
	        this._requireFont();
	        if (text.length > 1 && requestedWidth && this._font instanceof PDFFont) {
	            var outputWidth = this._font.getTextWidth(this._fontSize, text);
	            var scale = requestedWidth / outputWidth * 100;
	            this._out(scale, " Tz ");
	        }
	        this._out(this._font.encodeText(text), " Tj", NL);
	    },
	    showTextNL: function(text) {
	        this._requireFont();
	        this._out(this._font.encodeText(text), " '", NL);
	    },
	    addLink: function(uri, box) {
	        var ll = this._toPage({ x: box.left, y: box.bottom });
	        var ur = this._toPage({ x: box.right, y: box.top });
	        this._annotations.push(new PDFDictionary({
	            Type    : _("Annot"),
	            Subtype : _("Link"),
	            Rect    : [ ll.x, ll.y, ur.x, ur.y ],
	            Border  : [ 0, 0, 0 ],
	            A       : new PDFDictionary({
	                Type : _("Action"),
	                S    : _("URI"),
	                URI  : new PDFString(uri)
	            })
	        }));
	    },
	    setStrokeColor: function(r, g, b) {
	        this._out(r, " ", g, " ", b, " RG", NL);
	    },
	    setOpacity: function(opacity) {
	        this.setFillOpacity(opacity);
	        this.setStrokeOpacity(opacity);
	        this._opacity *= opacity;
	    },
	    setStrokeOpacity: function(opacity) {
	        if (opacity < 1) {
	            var gs = this._pdf.getOpacityGS(this._opacity * opacity, true);
	            this._gsResources[gs._resourceName] = gs;
	            this._out(gs._resourceName, " gs", NL);
	        }
	    },
	    setFillColor: function(r, g, b) {
	        this._out(r, " ", g, " ", b, " rg", NL);
	    },
	    setFillOpacity: function(opacity) {
	        if (opacity < 1) {
	            var gs = this._pdf.getOpacityGS(this._opacity * opacity, false);
	            this._gsResources[gs._resourceName] = gs;
	            this._out(gs._resourceName, " gs", NL);
	        }
	    },
	    gradient: function(gradient, box) {
	        this.save();
	        this.rect(box.left, box.top, box.width, box.height);
	        this.clip();
	        if (!gradient.userSpace) {
	            this.transform(box.width, 0, 0, box.height, box.left, box.top);
	        }
	        var g = cacheGradient(this._pdf, gradient, box);
	        var sname = g.shading._resourceName, oname;
	        this._shResources[sname] = g.shading;
	        if (g.hasAlpha) {
	            oname = g.opacity._resourceName;
	            this._gsResources[oname] = g.opacity;
	            this._out("/" + oname + " gs ");
	        }
	        this._out("/" + sname + " sh", NL);
	        this.restore();
	    },
	    setDashPattern: function(dashArray, dashPhase) {
	        this._out(dashArray, " ", dashPhase, " d", NL);
	    },
	    setLineWidth: function(width) {
	        this._out(width, " w", NL);
	    },
	    setLineCap: function(lineCap) {
	        this._out(lineCap, " J", NL);
	    },
	    setLineJoin: function(lineJoin) {
	        this._out(lineJoin, " j", NL);
	    },
	    setMitterLimit: function(mitterLimit) {
	        this._out(mitterLimit, " M", NL);
	    },
	    save: function() {
	        this._contextStack.push(this._context());
	        this._out("q", NL);
	    },
	    restore: function() {
	        this._out("Q", NL);
	        this._context(this._contextStack.pop());
	    },

	    // paths
	    moveTo: function(x, y) {
	        this._out(x, " ", y, " m", NL);
	    },
	    lineTo: function(x, y) {
	        this._out(x, " ", y, " l", NL);
	    },
	    bezier: function(x1, y1, x2, y2, x3, y3) {
	        this._out(x1, " ", y1, " ", x2, " ", y2, " ", x3, " ", y3, " c", NL);
	    },
	    bezier1: function(x1, y1, x3, y3) {
	        this._out(x1, " ", y1, " ", x3, " ", y3, " y", NL);
	    },
	    bezier2: function(x2, y2, x3, y3) {
	        this._out(x2, " ", y2, " ", x3, " ", y3, " v", NL);
	    },
	    close: function() {
	        this._out("h", NL);
	    },
	    rect: function(x, y, w, h) {
	        this._out(x, " ", y, " ", w, " ", h, " re", NL);
	    },
	    ellipse: function(x, y, rx, ry) {
	        function _X(v) { return x + v; }
	        function _Y(v) { return y + v; }

	        // how to get to the "magic number" is explained here:
	        // http://www.whizkidtech.redprince.net/bezier/circle/kappa/
	        var k = 0.5522847498307936;

	        this.moveTo(_X(0), _Y(ry));
	        this.bezier(
	            _X(rx * k) , _Y(ry),
	            _X(rx)     , _Y(ry * k),
	            _X(rx)     , _Y(0)
	        );
	        this.bezier(
	            _X(rx)     , _Y(-ry * k),
	            _X(rx * k) , _Y(-ry),
	            _X(0)      , _Y(-ry)
	        );
	        this.bezier(
	            _X(-rx * k) , _Y(-ry),
	            _X(-rx)     , _Y(-ry * k),
	            _X(-rx)     , _Y(0)
	        );
	        this.bezier(
	            _X(-rx)     , _Y(ry * k),
	            _X(-rx * k) , _Y(ry),
	            _X(0)       , _Y(ry)
	        );
	    },
	    circle: function(x, y, r) {
	        this.ellipse(x, y, r, r);
	    },
	    stroke: function() {
	        this._out("S", NL);
	    },
	    nop: function() {
	        this._out("n", NL);
	    },
	    clip: function() {
	        this._out("W n", NL);
	    },
	    clipStroke: function() {
	        this._out("W S", NL);
	    },
	    closeStroke: function() {
	        this._out("s", NL);
	    },
	    fill: function() {
	        this._out("f", NL);
	    },
	    fillStroke: function() {
	        this._out("B", NL);
	    },
	    drawImage: function(url) {
	        var img = this._pdf.getImage(url);
	        if (img) { // the result can be null for a cross-domain image
	            this._xResources[img._resourceName] = img;
	            this._out(img._resourceName, " Do", NL);
	        }
	    },
	    comment: function(txt) {
	        var self = this;
	        txt.split(/\r?\n/g).forEach(function(line){
	            self._out("% ", line, NL);
	        });
	    },

	    // internal
	    _context: function(val) {
	        if (val != null) {
	            this._opacity = val.opacity;
	            this._matrix = val.matrix;
	        } else {
	            return {
	                opacity: this._opacity,
	                matrix: this._matrix
	            };
	        }
	    },

	    _toPage: function(p) {
	        var m = this._matrix;
	        var a = m[0], b = m[1], c = m[2], d = m[3], e = m[4], f = m[5];
	        return {
	            x: a*p.x + c*p.y + e,
	            y: b*p.x + d*p.y + f
	        };
	    }
	}, PDFDictionary);

	function unquote(str) {
	    return str.replace(/^\s*(['"])(.*)\1\s*$/, "$2");
	}

	function parseFontDef(fontdef) {
	    // XXX: this is very crude for now and buggy.  Proper parsing is quite involved.
	    var rx = /^\s*((normal|italic)\s+)?((normal|small-caps)\s+)?((normal|bold|\d+)\s+)?(([0-9.]+)(px|pt))(\/(([0-9.]+)(px|pt)|normal))?\s+(.*?)\s*$/i;
	    var m = rx.exec(fontdef);
	    if (!m) {
	        return { fontSize: 12, fontFamily: "sans-serif" };
	    }
	    var fontSize = m[8] ? parseInt(m[8], 10) : 12;
	    return {
	        italic     : m[2] && m[2].toLowerCase() == "italic",
	        variant    : m[4],
	        bold       : m[6] && /bold|700/i.test(m[6]),
	        fontSize   : fontSize,
	        lineHeight : m[12] ? m[12] == "normal" ? fontSize : parseInt(m[12], 10) : null,
	        fontFamily : m[14].split(/\s*,\s*/g).map(unquote)
	    };
	}

	function getFontURL(style) {
	    function mkFamily(name) {
	        if (style.bold) {
	            name += "|bold";
	        }
	        if (style.italic) {
	            name += "|italic";
	        }
	        return name.toLowerCase();
	    }
	    var fontFamily = style.fontFamily;
	    var name, url;
	    if (fontFamily instanceof Array) {
	        for (var i = 0; i < fontFamily.length; ++i) {
	            name = mkFamily(fontFamily[i]);
	            url = FONT_MAPPINGS[name];
	            if (url) {
	                break;
	            }
	        }
	    } else {
	        url = FONT_MAPPINGS[fontFamily.toLowerCase()];
	    }
	    while (typeof url == "function") {
	        url = url();
	    }
	    if (!url) {
	        url = "Times-Roman";
	    }
	    return url;
	}

	var FONT_MAPPINGS = {
	    "serif"                    : "Times-Roman",
	    "serif|bold"               : "Times-Bold",
	    "serif|italic"             : "Times-Italic",
	    "serif|bold|italic"        : "Times-BoldItalic",
	    "sans-serif"               : "Helvetica",
	    "sans-serif|bold"          : "Helvetica-Bold",
	    "sans-serif|italic"        : "Helvetica-Oblique",
	    "sans-serif|bold|italic"   : "Helvetica-BoldOblique",
	    "monospace"                : "Courier",
	    "monospace|bold"           : "Courier-Bold",
	    "monospace|italic"         : "Courier-Oblique",
	    "monospace|bold|italic"    : "Courier-BoldOblique",
	    "zapfdingbats"             : "ZapfDingbats",
	    "zapfdingbats|bold"        : "ZapfDingbats",
	    "zapfdingbats|italic"      : "ZapfDingbats",
	    "zapfdingbats|bold|italic" : "ZapfDingbats"
	};

	function fontAlias(alias, name) {
	    alias = alias.toLowerCase();
	    FONT_MAPPINGS[alias] = function() {
	        return FONT_MAPPINGS[name];
	    };
	    FONT_MAPPINGS[alias + "|bold"] = function() {
	        return FONT_MAPPINGS[name + "|bold"];
	    };
	    FONT_MAPPINGS[alias + "|italic"] = function() {
	        return FONT_MAPPINGS[name + "|italic"];
	    };
	    FONT_MAPPINGS[alias + "|bold|italic"] = function() {
	        return FONT_MAPPINGS[name + "|bold|italic"];
	    };
	}

	// Let's define some common names to an appropriate replacement.
	// These are overridable via pdf.defineFont, should the user want to
	// include the proper versions.

	fontAlias("Times New Roman" , "serif");
	fontAlias("Courier New"     , "monospace");
	fontAlias("Arial"           , "sans-serif");
	fontAlias("Helvetica"       , "sans-serif");
	fontAlias("Verdana"         , "sans-serif");
	fontAlias("Tahoma"          , "sans-serif");
	fontAlias("Georgia"         , "sans-serif");
	fontAlias("Monaco"          , "monospace");
	fontAlias("Andale Mono"     , "monospace");

	function defineFont(name, url) {
	    if (arguments.length == 1) {
	        for (var i in name) {
	            if (hasOwnProperty(name, i)) {
	                defineFont(i, name[i]);
	            }
	        }
	    } else {
	        name = name.toLowerCase();
	        FONT_MAPPINGS[name] = url;

	        // special handling for DejaVu fonts: if they get defined,
	        // let them also replace the default families, for good
	        // Unicode support out of the box.
	        switch (name) {
	          case "dejavu sans"               : FONT_MAPPINGS["sans-serif"]              = url; break;
	          case "dejavu sans|bold"          : FONT_MAPPINGS["sans-serif|bold"]         = url; break;
	          case "dejavu sans|italic"        : FONT_MAPPINGS["sans-serif|italic"]       = url; break;
	          case "dejavu sans|bold|italic"   : FONT_MAPPINGS["sans-serif|bold|italic"]  = url; break;
	          case "dejavu serif"              : FONT_MAPPINGS["serif"]                   = url; break;
	          case "dejavu serif|bold"         : FONT_MAPPINGS["serif|bold"]              = url; break;
	          case "dejavu serif|italic"       : FONT_MAPPINGS["serif|italic"]            = url; break;
	          case "dejavu serif|bold|italic"  : FONT_MAPPINGS["serif|bold|italic"]       = url; break;
	          case "dejavu mono"               : FONT_MAPPINGS["monospace"]               = url; break;
	          case "dejavu mono|bold"          : FONT_MAPPINGS["monospace|bold"]          = url; break;
	          case "dejavu mono|italic"        : FONT_MAPPINGS["monospace|italic"]        = url; break;
	          case "dejavu mono|bold|italic"   : FONT_MAPPINGS["monospace|bold|italic"]   = url; break;
	        }
	    }
	}

	function mmul(a, b) {
	    var a1 = a[0], b1 = a[1], c1 = a[2], d1 = a[3], e1 = a[4], f1 = a[5];
	    var a2 = b[0], b2 = b[1], c2 = b[2], d2 = b[3], e2 = b[4], f2 = b[5];
	    return [
	        a1*a2 + b1*c2,          a1*b2 + b1*d2,
	        c1*a2 + d1*c2,          c1*b2 + d1*d2,
	        e1*a2 + f1*c2 + e2,     e1*b2 + f1*d2 + f2
	    ];
	}

	function isIdentityMatrix(m) {
	    return m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1 && m[4] === 0 && m[5] === 0;
	}

	var TEXT_RENDERING_MODE = {
	    fill           : 0,
	    stroke         : 1,
	    fillAndStroke  : 2,
	    invisible      : 3,
	    fillAndClip    : 4,
	    strokeAndClip  : 5,
	    fillStrokeClip : 6,
	    clip           : 7
	};

	/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
	/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
	/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
	/* eslint-disable no-param-reassign, no-var, block-scoped-var */

	var TEXT_RENDERING_MODE$1 = TEXT_RENDERING_MODE;

	var DASH_PATTERNS = {
	    dash           : [ 4 ],
	    dashDot        : [ 4, 2, 1, 2 ],
	    dot            : [ 1, 2 ],
	    longDash       : [ 8, 2 ],
	    longDashDot    : [ 8, 2, 1, 2 ],
	    longDashDotDot : [ 8, 2, 1, 2, 1, 2 ],
	    solid          : []
	};

	var LINE_CAP = {
	    butt   : 0,
	    round  : 1,
	    square : 2
	};

	var LINE_JOIN = {
	    miter : 0,
	    round : 1,
	    bevel : 2
	};

	function render(group, callback) {
	    var fonts = [], images = {}, options = group.options;

	    function getOption(name, defval, hash) {
	        if (!hash) {
	            hash = options;
	        }
	        if (hash.pdf && hash.pdf[name] != null) {
	            return hash.pdf[name];
	        }
	        return defval;
	    }

	    var multiPage = getOption("multiPage");
	    var imgDPI = getOption("imgDPI");

	    if (imgDPI) {
	        clearImageCache();
	    }

	    group.traverse(function(element){
	        dispatch({
	            Image: function(element) {
	                var url = element.src();
	                if (imgDPI) {
	                    var box = element.bbox().size;
	                    var prev = images[url];
	                    box = {
	                        width: Math.ceil(box.width * imgDPI / 72),
	                        height: Math.ceil(box.height * imgDPI / 72)
	                    };
	                    if (prev) {
	                        box.width = Math.max(prev.width, box.width);
	                        box.height = Math.max(prev.height, box.height);
	                    }
	                    images[url] = box;
	                } else {
	                    images[url] = null;
	                }
	            },
	            Text: function(element) {
	                var style = parseFontDef(element.options.font);
	                var url = getFontURL(style);
	                if (fonts.indexOf(url) < 0) {
	                    fonts.push(url);
	                }
	            }
	        }, element);
	    });

	    function doIt() {
	        if (--count > 0) {
	            return;
	        }

	        var pdf = new (PDFDocument)({
	            producer  : getOption("producer"),
	            title     : getOption("title"),
	            author    : getOption("author"),
	            subject   : getOption("subject"),
	            keywords  : getOption("keywords"),
	            creator   : getOption("creator"),
	            date      : getOption("date"),

	            autoPrint : getOption("autoPrint")
	        });

	        function drawPage(group) {
	            var options = group.options;

	            var tmp = optimize(group);
	            var bbox = tmp.bbox;
	            group = tmp.root;
	            // var tmp, bbox;

	            var paperSize = getOption("paperSize", getOption("paperSize", "auto"), options), addMargin = false;
	            if (paperSize == "auto") {
	                if (bbox) {
	                    var size = bbox.getSize();
	                    paperSize = [ size.width, size.height ];
	                    addMargin = true;
	                    var origin = bbox.getOrigin();
	                    tmp = new drawing.Group();
	                    tmp.transform(new kendoGeometry.Matrix(1, 0, 0, 1, -origin.x, -origin.y));
	                    tmp.append(group);
	                    group = tmp;
	                }
	                else {
	                    paperSize = "A4";
	                }
	            }

	            var page;
	            page = pdf.addPage({
	                paperSize : paperSize,
	                margin    : getOption("margin", getOption("margin"), options),
	                addMargin : addMargin,
	                landscape : getOption("landscape", getOption("landscape", false), options)
	            });
	            drawElement(group, page, pdf);
	        }

	        if (multiPage) {
	            group.children.forEach(drawPage);
	        } else {
	            drawPage(group);
	        }

	        callback(pdf.render(), pdf);
	    }

	    var count = 2;
	    loadFonts(fonts, doIt);
	    loadImages(images, doIt, {
	        jpegQuality : getOption("jpegQuality", 0.92),
	        keepPNG     : getOption("keepPNG", false)
	    });
	}

	function toDataURL(group, callback) {
	    render(group, function(data){
	        callback("data:application/pdf;base64," + data.base64());
	    });
	}

	function toBlob(group, callback) {
	    render(group, function(data){
	        callback(new window.Blob([ data.get() ], { type: "application/pdf" }));
	    });
	}

	function saveAs$1(group, filename, proxy, callback) {
	    // XXX: Safari has Blob, but does not support the download attribute
	    //      so we'd end up converting to dataURL and using the proxy anyway.
	    if (window.Blob && !supportBrowser.safari) {
	        toBlob(group, function(blob){
	            kendo.saveAs({ dataURI: blob, fileName: filename });
	            if (callback) {
	                callback(blob);
	            }
	        });
	    } else {
	        toDataURL(group, function(dataURL){
	            kendo.saveAs({ dataURI: dataURL, fileName: filename, proxyURL: proxy });
	            if (callback) {
	                callback(dataURL);
	            }
	        });
	    }
	}

	function dispatch(handlers, element) {
	    var handler = handlers[element.nodeType];
	    if (handler) {
	        return handler.call.apply(handler, arguments);
	    }
	    return element;
	}

	function drawElement(element, page, pdf) {
	    if (element.options._pdfDebug) {
	        page.comment("BEGIN: " + element.options._pdfDebug);
	    }

	    var transform = element.transform();
	    var opacity = element.opacity();

	    page.save();

	    if (opacity != null && opacity < 1) {
	        page.setOpacity(opacity);
	    }

	    setStrokeOptions(element, page, pdf);
	    setFillOptions(element, page, pdf);

	    if (transform) {
	        var m = transform.matrix();
	        page.transform(m.a, m.b, m.c, m.d, m.e, m.f);
	    }

	    setClipping(element, page, pdf);

	    dispatch({
	        Path      : drawPath,
	        MultiPath : drawMultiPath,
	        Circle    : drawCircle,
	        Arc       : drawArc,
	        Text      : drawText,
	        Image     : drawImage,
	        Group     : drawGroup,
	        Rect      : drawRect
	    }, element, page, pdf);

	    page.restore();

	    if (element.options._pdfDebug) {
	        page.comment("END: " + element.options._pdfDebug);
	    }
	}

	function setStrokeOptions(element, page) {
	    var stroke = element.stroke && element.stroke();
	    if (!stroke) {
	        return;
	    }

	    var color = stroke.color;
	    if (color) {
	        color = parseColor$1(color);
	        if (color == null) {
	            return; // no stroke
	        }
	        page.setStrokeColor(color.r, color.g, color.b);
	        if (color.a != 1) {
	            page.setStrokeOpacity(color.a);
	        }
	    }

	    var width = stroke.width;
	    if (width != null) {
	        if (width === 0) {
	            return; // no stroke
	        }
	        page.setLineWidth(width);
	    }

	    var dashType = stroke.dashType;
	    if (dashType) {
	        page.setDashPattern(DASH_PATTERNS[dashType], 0);
	    }

	    var lineCap = stroke.lineCap;
	    if (lineCap) {
	        page.setLineCap(LINE_CAP[lineCap]);
	    }

	    var lineJoin = stroke.lineJoin;
	    if (lineJoin) {
	        page.setLineJoin(LINE_JOIN[lineJoin]);
	    }

	    var opacity = stroke.opacity;
	    if (opacity != null) {
	        page.setStrokeOpacity(opacity);
	    }
	}

	function setFillOptions(element, page) {
	    var fill = element.fill && element.fill();
	    if (!fill) {
	        return;
	    }

	    if (fill instanceof drawing.Gradient) {
	        return;
	    }

	    var color = fill.color;
	    if (color) {
	        color = parseColor$1(color);
	        if (color == null) {
	            return; // no fill
	        }
	        page.setFillColor(color.r, color.g, color.b);
	        if (color.a != 1) {
	            page.setFillOpacity(color.a);
	        }
	    }

	    var opacity = fill.opacity;
	    if (opacity != null) {
	        page.setFillOpacity(opacity);
	    }
	}

	function setClipping(element, page, pdf) {
	    // XXX: only Path supported at the moment.
	    var clip = element.clip();
	    if (clip) {
	        _drawPath(clip, page, pdf);
	        page.clip();
	        // page.setStrokeColor(Math.random(), Math.random(), Math.random());
	        // page.setLineWidth(1);
	        // page.stroke();
	    }
	}

	function shouldDraw(thing) {
	    return (thing &&
	            (thing instanceof drawing.Gradient ||
	             (thing.color && !/^(none|transparent)$/i.test(thing.color) &&
	              (thing.width == null || thing.width > 0) &&
	              (thing.opacity == null || thing.opacity > 0))));
	}

	function maybeGradient(element, page, pdf, stroke) {
	    var fill = element.fill();
	    if (fill instanceof drawing.Gradient) {
	        if (stroke) {
	            page.clipStroke();
	        } else {
	            page.clip();
	        }
	        var isRadial = fill instanceof drawing.RadialGradient;
	        var start, end;
	        if (isRadial) {
	            start = { x: fill.center().x , y: fill.center().y , r: 0 };
	            end   = { x: fill.center().x , y: fill.center().y , r: fill.radius() };
	        } else {
	            start = { x: fill.start().x , y: fill.start().y };
	            end   = { x: fill.end().x   , y: fill.end().y   };
	        }

	        var stops = fill.stops.elements().map(function(stop){
	            var offset = stop.offset();
	            if (/%$/.test(offset)) {
	                offset = parseFloat(offset) / 100;
	            } else {
	                offset = parseFloat(offset);
	            }
	            var color = parseColor$1(stop.color());
	            color.a *= stop.opacity();
	            return {
	                offset: offset,
	                color: color
	            };
	        });

	        // Duplicats first and last stop to fix
	        // https://github.com/telerik/kendo-ui-core/issues/1782
	        stops.unshift(stops[0]);
	        stops.push(stops[stops.length - 1]);

	        var gradient = {
	            userSpace : fill.userSpace(),
	            type      : isRadial ? "radial" : "linear",
	            start     : start,
	            end       : end,
	            stops     : stops
	        };
	        var box = element.rawBBox();
	        var tl = box.topLeft(), size = box.getSize();
	        box = {
	            left   : tl.x,
	            top    : tl.y,
	            width  : size.width,
	            height : size.height
	        };
	        page.gradient(gradient, box);
	        return true;
	    }
	}

	function maybeFillStroke(element, page, pdf) {
	    if (shouldDraw(element.fill()) && shouldDraw(element.stroke())) {
	        if (!maybeGradient(element, page, pdf, true)) {
	            page.fillStroke();
	        }
	    } else if (shouldDraw(element.fill())) {
	        if (!maybeGradient(element, page, pdf, false)) {
	            page.fill();
	        }
	    } else if (shouldDraw(element.stroke())) {
	        page.stroke();
	    } else {
	        // we should not get here; the path should have been
	        // optimized away.  but let's be prepared.
	        page.nop();
	    }
	}

	function maybeDrawRect(path, page) {
	    var segments = path.segments;
	    if (segments.length == 4 && path.options.closed) {
	        // detect if this path looks like a rectangle parallel to the axis
	        var a = [];
	        for (var i = 0; i < segments.length; ++i) {
	            if (segments[i].controlIn()) { // has curve?
	                return false;
	            }
	            a[i] = segments[i].anchor();
	        }
	        // it's a rectangle if the y/x/y/x or x/y/x/y coords of
	        // consecutive points are the same.
	        var isRect = (
	            a[0].y == a[1].y && a[1].x == a[2].x && a[2].y == a[3].y && a[3].x == a[0].x
	        ) || (
	            a[0].x == a[1].x && a[1].y == a[2].y && a[2].x == a[3].x && a[3].y == a[0].y
	        );
	        if (isRect) {
	            // this saves a bunch of instructions in PDF:
	            // moveTo, lineTo, lineTo, lineTo, close -> rect.
	            page.rect(a[0].x, a[0].y,
	                      a[2].x - a[0].x /*width*/,
	                      a[2].y - a[0].y /*height*/);
	            return true;
	        }
	    }
	}

	function _drawPath(element, page, pdf) {
	    var segments = element.segments;
	    if (segments.length === 0) {
	        return;
	    }
	    if (!maybeDrawRect(element, page, pdf)) {
	        for (var prev, i = 0; i < segments.length; ++i) {
	            var seg = segments[i];
	            var anchor = seg.anchor();
	            if (!prev) {
	                page.moveTo(anchor.x, anchor.y);
	            } else {
	                var prevOut = prev.controlOut();
	                var controlIn = seg.controlIn();
	                if (prevOut && controlIn) {
	                    page.bezier(
	                        prevOut.x   , prevOut.y,
	                        controlIn.x , controlIn.y,
	                        anchor.x    , anchor.y
	                    );
	                } else {
	                    page.lineTo(anchor.x, anchor.y);
	                }
	            }
	            prev = seg;
	        }
	        if (element.options.closed) {
	            page.close();
	        }
	    }
	}

	function drawPath(element, page, pdf) {
	    _drawPath(element, page, pdf);
	    maybeFillStroke(element, page, pdf);
	}

	function drawMultiPath(element, page, pdf) {
	    var paths = element.paths;
	    for (var i = 0; i < paths.length; ++i) {
	        _drawPath(paths[i], page, pdf);
	    }
	    maybeFillStroke(element, page, pdf);
	}

	function drawCircle(element, page, pdf) {
	    var g = element.geometry();
	    page.circle(g.center.x, g.center.y, g.radius);
	    maybeFillStroke(element, page, pdf);
	}

	function drawArc(element, page, pdf) {
	    var points = element.geometry().curvePoints();
	    page.moveTo(points[0].x, points[0].y);
	    for (var i = 1; i < points.length;) {
	        page.bezier(
	            points[i].x, points[i++].y,
	            points[i].x, points[i++].y,
	            points[i].x, points[i++].y
	        );
	    }
	    maybeFillStroke(element, page, pdf);
	}

	function drawText(element, page) {
	    var style = parseFontDef(element.options.font);
	    var pos = element._position;
	    var mode;
	    if (element.fill() && element.stroke()) {
	        mode = TEXT_RENDERING_MODE$1.fillAndStroke;
	    } else if (element.fill()) {
	        mode = TEXT_RENDERING_MODE$1.fill;
	    } else if (element.stroke()) {
	        mode = TEXT_RENDERING_MODE$1.stroke;
	    }

	    page.transform(1, 0, 0, -1, pos.x, pos.y + style.fontSize);
	    page.beginText();
	    page.setFont(getFontURL(style), style.fontSize);
	    page.setTextRenderingMode(mode);
	    page.showText(element.content(), element._pdfRect ? element._pdfRect.width() : null);
	    page.endText();
	}

	function drawGroup(element, page, pdf) {
	    if (element._pdfLink) {
	        page.addLink(element._pdfLink.url, element._pdfLink);
	    }
	    var children = element.children;
	    for (var i = 0; i < children.length; ++i) {
	        drawElement(children[i], page, pdf);
	    }
	}

	function drawImage(element, page) {
	    var url = element.src();
	    if (!url) {
	        return;
	    }

	    var rect = element.rect();
	    var tl = rect.getOrigin();
	    var sz = rect.getSize();
	    page.transform(sz.width, 0, 0, -sz.height, tl.x, tl.y + sz.height);
	    page.drawImage(url);
	}

	function drawRect(element, page, pdf) {
	    var geometry = element.geometry();
	    page.rect(geometry.origin.x, geometry.origin.y, geometry.size.width, geometry.size.height);
	    maybeFillStroke(element, page, pdf);
	}

	function parseColor$1(value) {
	    var color = kendo.parseColor(value, true);
	    return color ? color.toRGB() : null;
	}

	function optimize(root) {
	    var clipbox = false;
	    var matrix = kendoGeometry.Matrix.unit();
	    var currentBox = null;
	    var changed;
	    do {
	        changed = false;
	        root = opt(root);
	    } while (root && changed);
	    return { root: root, bbox: currentBox };

	    function change(newShape) {
	        changed = true;
	        return newShape;
	    }

	    function visible(shape) {
	        return (shape.visible() && shape.opacity() > 0 &&
	                ( shouldDraw(shape.fill()) ||
	                  shouldDraw(shape.stroke()) ));
	    }

	    function optArray(a) {
	        var b = [];
	        for (var i = 0; i < a.length; ++i) {
	            var el = opt(a[i]);
	            if (el != null) {
	                b.push(el);
	            }
	        }
	        return b;
	    }

	    function withClipping(shape, f) {
	        var saveclipbox = clipbox;
	        var savematrix = matrix;

	        if (shape.transform()) {
	            matrix = matrix.multiplyCopy(shape.transform().matrix());
	        }

	        var clip = shape.clip();
	        if (clip) {
	            clip = clip.bbox();
	            if (clip) {
	                clip = clip.bbox(matrix);
	                clipbox = clipbox ? kendoGeometry.Rect.intersect(clipbox, clip) : clip;
	            }
	        }

	        try {
	            return f();
	        }
	        finally {
	            clipbox = saveclipbox;
	            matrix = savematrix;
	        }
	    }

	    function inClipbox(shape) {
	        if (clipbox == null) {
	            return false;
	        }
	        var box = shape.rawBBox().bbox(matrix);
	        if (clipbox && box) {
	            box = kendoGeometry.Rect.intersect(box, clipbox);
	        }
	        return box;
	    }

	    function opt(shape) {
	        return withClipping(shape, function(){
	            if (!(shape instanceof drawing.Group || shape instanceof drawing.MultiPath)) {
	                var box = inClipbox(shape);
	                if (!box) {
	                    return change(null);
	                }
	                currentBox = currentBox ? kendoGeometry.Rect.union(currentBox, box) : box;
	            }
	            return dispatch({
	                Path: function(shape) {
	                    if (shape.segments.length === 0 || !visible(shape)) {
	                        return change(null);
	                    }
	                    return shape;
	                },
	                MultiPath: function(shape) {
	                    if (!visible(shape)) {
	                        return change(null);
	                    }
	                    var el = new drawing.MultiPath(shape.options);
	                    el.paths = optArray(shape.paths);
	                    if (el.paths.length === 0) {
	                        return change(null);
	                    }
	                    return el;
	                },
	                Circle: function(shape) {
	                    if (!visible(shape)) {
	                        return change(null);
	                    }
	                    return shape;
	                },
	                Arc: function(shape) {
	                    if (!visible(shape)) {
	                        return change(null);
	                    }
	                    return shape;
	                },
	                Text: function(shape) {
	                    if (!/\S/.test(shape.content()) || !visible(shape)) {
	                        return change(null);
	                    }
	                    return shape;
	                },
	                Image: function(shape) {
	                    if (!(shape.visible() && shape.opacity() > 0)) {
	                        return change(null);
	                    }
	                    return shape;
	                },
	                Group: function(shape) {
	                    if (!(shape.visible() && shape.opacity() > 0)) {
	                        return change(null);
	                    }
	                    var el = new drawing.Group(shape.options);
	                    el.children = optArray(shape.children);
	                    el._pdfLink = shape._pdfLink;
	                    if (shape !== root && el.children.length === 0 && !shape._pdfLink) {
	                        return change(null);
	                    }
	                    return el;
	                },
	                Rect: function(shape) {
	                    if (!visible(shape)) {
	                        return change(null);
	                    }
	                    return shape;
	                }
	            }, shape);
	        });
	    }
	}

	function exportPDF(group, options) {
	    var promise = util.createPromise();

	    for (var i in options) {
	        if (i == "margin" && group.options.pdf && group.options.pdf._ignoreMargin) {
	            // This hackish option is set by the page breaking code in drawDOM.  The idea is
	            // that margin is already taken into account there (that's required to do proper
	            // page breaking) and we don't want to set it again here, as it would double the
	            // top-left margin, and truncate the content on bottom/right.
	            continue;
	        }
	        group.options.set("pdf." + i, options[i]);
	    }

	    toDataURL(group, promise.resolve);

	    return promise;
	}

	// XXX: the duplication is in order to keep exportPDF return a data
	// URI, which is what previous versions do.  Currently only IE9 does
	// not support Blob, IMO we should switch to Blob by default
	// everywhere.
	function exportPDFToBlob(group, options) {
	    var promise = util.createPromise();

	    for (var i in options) {
	        if (i == "margin" && group.options.pdf && group.options.pdf._ignoreMargin) {
	            // This hackish option is set by the page breaking code in drawDOM.  The idea is
	            // that margin is already taken into account there (that's required to do proper
	            // page breaking) and we don't want to set it again here, as it would double the
	            // top-left margin, and truncate the content on bottom/right.
	            continue;
	        }
	        group.options.set("pdf." + i, options[i]);
	    }

	    if (window.Blob && !supportBrowser.safari) {
	        toBlob(group, promise.resolve);
	    } else {
	        toDataURL(group, promise.resolve);
	    }

	    return promise;
	}

	kendo.deepExtend(kendo.pdf, {
	    Document: PDFDocument,
	    BinaryStream: BinaryStream,
	    defineFont: defineFont,
	    parseFontDef: parseFontDef,
	    getFontURL: getFontURL,
	    loadFonts: loadFonts,
	    loadImages: loadImages,
	    getPaperOptions: getPaperOptions,
	    clearImageCache: clearImageCache,
	    TEXT_RENDERING_MODE: TEXT_RENDERING_MODE,
	    exportPDF: exportPDF,
	    exportPDFToBlob: exportPDFToBlob,
	    saveAs: saveAs$1,
	    toDataURL: toDataURL,
	    toBlob: toBlob,
	    render: render
	});

	kendo.drawing.exportPDF = kendo.pdf.exportPDF;
	kendo.drawing.pdf = kendo.pdf;

	})(kendo);

	return kendo;

	}, __webpack_require__(3));

/***/ }),

/***/ 1558:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ic51");

/***/ }),

/***/ 1559:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FTkt");

/***/ })

/******/ });

/***/ }),

/***/ "5ela":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var selectionController_1 = __webpack_require__("D4cr");
var columnApi_1 = __webpack_require__("E/Wy");
var columnController_1 = __webpack_require__("77lH");
var rowRenderer_1 = __webpack_require__("3RUv");
var headerRenderer_1 = __webpack_require__("U9s4");
var filterManager_1 = __webpack_require__("Up6z");
var valueService_1 = __webpack_require__("5JVC");
var eventService_1 = __webpack_require__("k5uU");
var gridPanel_1 = __webpack_require__("inOk");
var gridApi_1 = __webpack_require__("BAow");
var balancedColumnTreeBuilder_1 = __webpack_require__("WPdJ");
var displayedGroupCreator_1 = __webpack_require__("Tttz");
var expressionService_1 = __webpack_require__("1aUC");
var templateService_1 = __webpack_require__("0vz1");
var popupService_1 = __webpack_require__("LnC7");
var logger_1 = __webpack_require__("U9Xd");
var columnUtils_1 = __webpack_require__("PAC5");
var autoWidthCalculator_1 = __webpack_require__("y9Zr");
var horizontalDragService_1 = __webpack_require__("jJge");
var context_1 = __webpack_require__("RQ1/");
var csvCreator_1 = __webpack_require__("SdeK");
var gridCore_1 = __webpack_require__("b9np");
var standardMenu_1 = __webpack_require__("aXhp");
var dragAndDropService_1 = __webpack_require__("I/uN");
var dragService_1 = __webpack_require__("ytBa");
var sortController_1 = __webpack_require__("fxGZ");
var focusedCellController_1 = __webpack_require__("4Sr9");
var mouseEventService_1 = __webpack_require__("BY3/");
var cellNavigationService_1 = __webpack_require__("Cz2g");
var utils_1 = __webpack_require__("IRr6");
var filterStage_1 = __webpack_require__("Zn08");
var sortStage_1 = __webpack_require__("DGeU");
var flattenStage_1 = __webpack_require__("/PKt");
var cellEditorFactory_1 = __webpack_require__("x4W5");
var events_1 = __webpack_require__("3ok8");
var infiniteRowModel_1 = __webpack_require__("NTM1");
var inMemoryRowModel_1 = __webpack_require__("2Le/");
var cellRendererFactory_1 = __webpack_require__("9WGm");
var cellRendererService_1 = __webpack_require__("sr48");
var valueFormatterService_1 = __webpack_require__("vFc7");
var agCheckbox_1 = __webpack_require__("0Gxk");
var baseFrameworkFactory_1 = __webpack_require__("FpOn");
var scrollVisibleService_1 = __webpack_require__("5AnZ");
var downloader_1 = __webpack_require__("/d84");
var xmlFactory_1 = __webpack_require__("XBCZ");
var gridSerializer_1 = __webpack_require__("39p0");
var stylingService_1 = __webpack_require__("Ewux");
var columnHoverService_1 = __webpack_require__("WO3E");
var columnAnimationService_1 = __webpack_require__("vLqC");
var sortService_1 = __webpack_require__("mLPx");
var filterService_1 = __webpack_require__("9jRp");
var rowNodeFactory_1 = __webpack_require__("HD9n");
var autoGroupColService_1 = __webpack_require__("uLN9");
var paginationProxy_1 = __webpack_require__("wYvi");
var immutableService_1 = __webpack_require__("OrSY");
var constants_1 = __webpack_require__("ZZFX");
var valueCache_1 = __webpack_require__("uKqK");
var changeDetectionService_1 = __webpack_require__("eQt4");
var alignedGridsService_1 = __webpack_require__("sHqg");
var pinnedRowModel_1 = __webpack_require__("xRx6");
var componentResolver_1 = __webpack_require__("migL");
var componentRecipes_1 = __webpack_require__("EOXx");
var componentProvider_1 = __webpack_require__("evUn");
var agComponentUtils_1 = __webpack_require__("rVYJ");
var componentMetadataProvider_1 = __webpack_require__("djkc");
var beans_1 = __webpack_require__("YaQm");
var environment_1 = __webpack_require__("JLYF");
var animationFrameService_1 = __webpack_require__("tvEw");
var navigationService_1 = __webpack_require__("oNv9");
var Grid = (function () {
    function Grid(eGridDiv, gridOptions, params) {
        if (!eGridDiv) {
            console.error('ag-Grid: no div element provided to the grid');
        }
        if (!gridOptions) {
            console.error('ag-Grid: no gridOptions provided to the grid');
        }
        var rowModelClass = this.getRowModelClass(gridOptions);
        var enterprise = utils_1.Utils.exists(Grid.enterpriseBeans);
        var frameworkFactory = params ? params.frameworkFactory : null;
        if (utils_1.Utils.missing(frameworkFactory)) {
            frameworkFactory = new baseFrameworkFactory_1.BaseFrameworkFactory();
        }
        var overrideBeans = [];
        if (Grid.enterpriseBeans) {
            overrideBeans = overrideBeans.concat(Grid.enterpriseBeans);
        }
        if (Grid.frameworkBeans) {
            overrideBeans = overrideBeans.concat(Grid.frameworkBeans);
        }
        var seed = {
            enterprise: enterprise,
            gridOptions: gridOptions,
            eGridDiv: eGridDiv,
            $scope: params ? params.$scope : null,
            $compile: params ? params.$compile : null,
            quickFilterOnScope: params ? params.quickFilterOnScope : null,
            globalEventListener: params ? params.globalEventListener : null,
            frameworkFactory: frameworkFactory
        };
        if (params && params.seedBeanInstances) {
            utils_1.Utils.assign(seed, params.seedBeanInstances);
        }
        var contextParams = {
            overrideBeans: overrideBeans,
            seed: seed,
            //Careful with the order of the beans here, there are dependencies between them that need to be kept
            beans: [rowModelClass, paginationProxy_1.PaginationAutoPageSizeService, gridApi_1.GridApi, componentProvider_1.ComponentProvider, agComponentUtils_1.AgComponentUtils, componentMetadataProvider_1.ComponentMetadataProvider,
                componentProvider_1.ComponentProvider, componentResolver_1.ComponentResolver, componentRecipes_1.ComponentRecipes,
                cellRendererFactory_1.CellRendererFactory, horizontalDragService_1.HorizontalDragService, pinnedRowModel_1.PinnedRowModel, dragService_1.DragService,
                displayedGroupCreator_1.DisplayedGroupCreator, eventService_1.EventService, gridOptionsWrapper_1.GridOptionsWrapper, selectionController_1.SelectionController,
                filterManager_1.FilterManager, columnController_1.ColumnController, paginationProxy_1.PaginationProxy, rowRenderer_1.RowRenderer, headerRenderer_1.HeaderRenderer, expressionService_1.ExpressionService,
                balancedColumnTreeBuilder_1.BalancedColumnTreeBuilder, csvCreator_1.CsvCreator, downloader_1.Downloader, xmlFactory_1.XmlFactory, gridSerializer_1.GridSerializer, templateService_1.TemplateService,
                navigationService_1.NavigationService, gridPanel_1.GridPanel, popupService_1.PopupService, valueCache_1.ValueCache, valueService_1.ValueService, alignedGridsService_1.AlignedGridsService,
                logger_1.LoggerFactory, columnUtils_1.ColumnUtils, autoWidthCalculator_1.AutoWidthCalculator, popupService_1.PopupService, gridCore_1.GridCore, standardMenu_1.StandardMenuFactory,
                dragAndDropService_1.DragAndDropService, columnApi_1.ColumnApi, focusedCellController_1.FocusedCellController, mouseEventService_1.MouseEventService,
                cellNavigationService_1.CellNavigationService, filterStage_1.FilterStage, sortStage_1.SortStage, flattenStage_1.FlattenStage, filterService_1.FilterService, rowNodeFactory_1.RowNodeFactory,
                cellEditorFactory_1.CellEditorFactory, cellRendererService_1.CellRendererService, valueFormatterService_1.ValueFormatterService, stylingService_1.StylingService, scrollVisibleService_1.ScrollVisibleService,
                columnHoverService_1.ColumnHoverService, columnAnimationService_1.ColumnAnimationService, sortService_1.SortService, autoGroupColService_1.AutoGroupColService, immutableService_1.ImmutableService,
                changeDetectionService_1.ChangeDetectionService, environment_1.Environment, beans_1.Beans, animationFrameService_1.AnimationFrameService, sortController_1.SortController],
            components: [
                { componentName: 'AgCheckbox', theClass: agCheckbox_1.AgCheckbox }
            ],
            debug: !!gridOptions.debug
        };
        var isLoggingFunc = function () { return contextParams.debug; };
        this.context = new context_1.Context(contextParams, new logger_1.Logger('Context', isLoggingFunc));
        this.setColumnsAndData();
        this.dispatchGridReadyEvent(gridOptions);
        if (gridOptions.debug) {
            console.log('ag-Grid -> initialised successfully, enterprise = ' + enterprise);
        }
    }
    Grid.setEnterpriseBeans = function (enterpriseBeans, rowModelClasses) {
        this.enterpriseBeans = enterpriseBeans;
        // the enterprise can inject additional row models. this is how it injects the viewportRowModel
        utils_1.Utils.iterateObject(rowModelClasses, function (key, value) { return Grid.RowModelClasses[key] = value; });
    };
    Grid.setFrameworkBeans = function (frameworkBeans) {
        this.frameworkBeans = frameworkBeans;
    };
    Grid.prototype.setColumnsAndData = function () {
        var gridOptionsWrapper = this.context.getBean('gridOptionsWrapper');
        var columnController = this.context.getBean('columnController');
        var rowModel = this.context.getBean('rowModel');
        var columnDefs = gridOptionsWrapper.getColumnDefs();
        var rowData = gridOptionsWrapper.getRowData();
        var nothingToSet = utils_1.Utils.missing(columnDefs) && utils_1.Utils.missing(rowData);
        if (nothingToSet) {
            return;
        }
        var valueService = this.context.getBean('valueService');
        if (utils_1.Utils.exists(columnDefs)) {
            columnController.setColumnDefs(columnDefs, "gridInitializing");
        }
        if (utils_1.Utils.exists(rowData) && rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_IN_MEMORY) {
            var inMemoryRowModel = rowModel;
            inMemoryRowModel.setRowData(rowData);
        }
    };
    Grid.prototype.dispatchGridReadyEvent = function (gridOptions) {
        var eventService = this.context.getBean('eventService');
        var readyEvent = {
            type: events_1.Events.EVENT_GRID_READY,
            api: gridOptions.api,
            columnApi: gridOptions.columnApi
        };
        eventService.dispatchEvent(readyEvent);
    };
    Grid.prototype.getRowModelClass = function (gridOptions) {
        var rowModelType = gridOptions.rowModelType;
        if (utils_1.Utils.exists(rowModelType)) {
            var rowModelClass = Grid.RowModelClasses[rowModelType];
            if (utils_1.Utils.exists(rowModelClass)) {
                return rowModelClass;
            }
            else {
                if (rowModelType === 'normal') {
                    console.warn("ag-Grid: normal rowModel deprecated. Should now be called inMemory rowModel instead.");
                    return inMemoryRowModel_1.InMemoryRowModel;
                }
                console.error('ag-Grid: could not find matching row model for rowModelType ' + rowModelType);
                if (rowModelType === 'viewport') {
                    console.error('ag-Grid: rowModelType viewport is only available in ag-Grid Enterprise');
                }
                if (rowModelType === 'enterprise') {
                    console.error('ag-Grid: rowModelType viewport is only available in ag-Grid Enterprise');
                }
            }
        }
        return inMemoryRowModel_1.InMemoryRowModel;
    };
    ;
    Grid.prototype.destroy = function () {
        this.context.destroy();
    };
    // the default is InMemoryRowModel, which is also used for pagination.
    // the enterprise adds viewport to this list.
    Grid.RowModelClasses = {
        infinite: infiniteRowModel_1.InfiniteRowModel,
        inMemory: inMemoryRowModel_1.InMemoryRowModel
    };
    return Grid;
}());
exports.Grid = Grid;


/***/ }),

/***/ "5yUf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = __webpack_require__("pQ38");
var componentAnnotations_1 = __webpack_require__("x5ih");
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var utils_1 = __webpack_require__("IRr6");
var DEFAULT_TRANSLATIONS = {
    loadingOoo: 'Loading...',
    equals: 'Equals',
    notEqual: 'Not equal',
    lessThan: 'Less than',
    greaterThan: 'Greater than',
    inRange: 'In range',
    lessThanOrEqual: 'Less than or equals',
    greaterThanOrEqual: 'Greater than or equals',
    filterOoo: 'Filter...',
    contains: 'Contains',
    notContains: 'Not contains',
    startsWith: 'Starts with',
    endsWith: 'Ends with',
    searchOoo: 'Search...',
    selectAll: 'Select All',
    applyFilter: 'Apply Filter',
    clearFilter: 'Clear Filter'
};
/**
 * T(ype) The type of this filter. ie in DateFilter T=Date
 * P(arams) The params that this filter can take
 * M(model getModel/setModel) The object that this filter serializes to
 * F Floating filter params
 *
 * Contains common logic to ALL filters.. Translation, apply and clear button
 * get/setModel context wiring....
 */
var BaseFilter = (function (_super) {
    __extends(BaseFilter, _super);
    function BaseFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseFilter.prototype.init = function (params) {
        this.filterParams = params;
        this.defaultFilter = this.filterParams.defaultOption;
        if (this.filterParams.filterOptions && !this.defaultFilter) {
            if (this.filterParams.filterOptions.lastIndexOf(BaseFilter.EQUALS) < 0) {
                this.defaultFilter = this.filterParams.filterOptions[0];
            }
        }
        this.customInit();
        this.filter = this.defaultFilter;
        this.clearActive = params.clearButton === true;
        //Allowing for old param property apply, even though is not advertised through the interface
        this.applyActive = ((params.applyButton === true) || (params.apply === true));
        this.newRowsActionKeep = params.newRowsAction === 'keep';
        this.setTemplate(this.generateTemplate());
        utils_1._.setVisible(this.eApplyButton, this.applyActive);
        if (this.applyActive) {
            this.addDestroyableEventListener(this.eApplyButton, "click", this.filterParams.filterChangedCallback);
        }
        utils_1._.setVisible(this.eClearButton, this.clearActive);
        if (this.clearActive) {
            this.addDestroyableEventListener(this.eClearButton, "click", this.onClearButton.bind(this));
        }
        var anyButtonVisible = this.applyActive || this.clearActive;
        utils_1._.setVisible(this.eButtonsPanel, anyButtonVisible);
        this.instantiate(this.context);
        this.initialiseFilterBodyUi();
        this.refreshFilterBodyUi();
    };
    BaseFilter.prototype.onClearButton = function () {
        this.setModel(null);
        this.onFilterChanged();
    };
    BaseFilter.prototype.floatingFilter = function (from) {
        if (from !== '') {
            var model = this.modelFromFloatingFilter(from);
            this.setModel(model);
        }
        else {
            this.resetState();
        }
        this.onFilterChanged();
    };
    BaseFilter.prototype.onNewRowsLoaded = function () {
        if (!this.newRowsActionKeep) {
            this.resetState();
        }
    };
    BaseFilter.prototype.getModel = function () {
        if (this.isFilterActive()) {
            return this.serialize();
        }
        else {
            return null;
        }
    };
    BaseFilter.prototype.getNullableModel = function () {
        return this.serialize();
    };
    BaseFilter.prototype.setModel = function (model) {
        if (model) {
            this.parse(model);
        }
        else {
            this.resetState();
        }
        this.refreshFilterBodyUi();
    };
    BaseFilter.prototype.doOnFilterChanged = function (applyNow) {
        if (applyNow === void 0) { applyNow = false; }
        this.filterParams.filterModifiedCallback();
        var requiresApplyAndIsApplying = this.applyActive && applyNow;
        var notRequiresApply = !this.applyActive;
        var shouldFilter = notRequiresApply || requiresApplyAndIsApplying;
        if (shouldFilter) {
            this.filterParams.filterChangedCallback();
        }
        this.refreshFilterBodyUi();
        return shouldFilter;
    };
    BaseFilter.prototype.onFilterChanged = function () {
        this.doOnFilterChanged();
    };
    BaseFilter.prototype.onFloatingFilterChanged = function (change) {
        //It has to be of the type FloatingFilterWithApplyChange if it gets here
        var casted = change;
        this.setModel(casted ? casted.model : null);
        return this.doOnFilterChanged(casted ? casted.apply : false);
    };
    BaseFilter.prototype.generateFilterHeader = function () {
        return '';
    };
    BaseFilter.prototype.generateTemplate = function () {
        var translate = this.translate.bind(this);
        var body = this.bodyTemplate();
        return "<div>\n                    " + this.generateFilterHeader() + "\n                    " + body + "\n                    <div class=\"ag-filter-apply-panel\" id=\"applyPanel\">\n                        <button type=\"button\" id=\"clearButton\">" + translate('clearFilter') + "</button>\n                        <button type=\"button\" id=\"applyButton\">" + translate('applyFilter') + "</button>\n                    </div>\n                </div>";
    };
    BaseFilter.prototype.translate = function (toTranslate) {
        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
        return translate(toTranslate, DEFAULT_TRANSLATIONS[toTranslate]);
    };
    BaseFilter.prototype.getDebounceMs = function (filterParams) {
        if (filterParams.applyButton && filterParams.debounceMs) {
            console.warn('ag-Grid: debounceMs is ignored when applyButton = true');
            return 0;
        }
        return filterParams.debounceMs != null ? filterParams.debounceMs : 500;
    };
    BaseFilter.EQUALS = 'equals';
    BaseFilter.NOT_EQUAL = 'notEqual';
    BaseFilter.LESS_THAN = 'lessThan';
    BaseFilter.LESS_THAN_OR_EQUAL = 'lessThanOrEqual';
    BaseFilter.GREATER_THAN = 'greaterThan';
    BaseFilter.GREATER_THAN_OR_EQUAL = 'greaterThanOrEqual';
    BaseFilter.IN_RANGE = 'inRange';
    BaseFilter.CONTAINS = 'contains'; //1;
    BaseFilter.NOT_CONTAINS = 'notContains'; //1;
    BaseFilter.STARTS_WITH = 'startsWith'; //4;
    BaseFilter.ENDS_WITH = 'endsWith'; //5;
    __decorate([
        componentAnnotations_1.QuerySelector('#applyPanel'),
        __metadata("design:type", HTMLElement)
    ], BaseFilter.prototype, "eButtonsPanel", void 0);
    __decorate([
        componentAnnotations_1.QuerySelector('#applyButton'),
        __metadata("design:type", HTMLElement)
    ], BaseFilter.prototype, "eApplyButton", void 0);
    __decorate([
        componentAnnotations_1.QuerySelector('#clearButton'),
        __metadata("design:type", HTMLElement)
    ], BaseFilter.prototype, "eClearButton", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], BaseFilter.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], BaseFilter.prototype, "gridOptionsWrapper", void 0);
    return BaseFilter;
}(component_1.Component));
exports.BaseFilter = BaseFilter;
/**
 * Every filter with a dropdown where the user can specify a comparing type against the filter values
 */
var ComparableBaseFilter = (function (_super) {
    __extends(ComparableBaseFilter, _super);
    function ComparableBaseFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComparableBaseFilter.prototype.init = function (params) {
        _super.prototype.init.call(this, params);
        this.addDestroyableEventListener(this.eTypeSelector, "change", this.onFilterTypeChanged.bind(this));
    };
    ComparableBaseFilter.prototype.customInit = function () {
        if (!this.defaultFilter) {
            this.defaultFilter = this.getDefaultType();
        }
    };
    ComparableBaseFilter.prototype.generateFilterHeader = function () {
        var _this = this;
        var defaultFilterTypes = this.getApplicableFilterTypes();
        var restrictedFilterTypes = this.filterParams.filterOptions;
        var actualFilterTypes = restrictedFilterTypes ? restrictedFilterTypes : defaultFilterTypes;
        var optionsHtml = actualFilterTypes.map(function (filterType) {
            var localeFilterName = _this.translate(filterType);
            return "<option value=\"" + filterType + "\">" + localeFilterName + "</option>";
        });
        var readOnly = optionsHtml.length == 1 ? 'disabled' : '';
        return optionsHtml.length <= 0 ?
            '' :
            "<div>\n                <select class=\"ag-filter-select\" id=\"filterType\" " + readOnly + ">\n                    " + optionsHtml.join('') + "\n                </select>\n            </div>";
    };
    ComparableBaseFilter.prototype.initialiseFilterBodyUi = function () {
        this.setFilterType(this.filter);
    };
    ComparableBaseFilter.prototype.onFilterTypeChanged = function () {
        this.filter = this.eTypeSelector.value;
        this.refreshFilterBodyUi();
        this.onFilterChanged();
    };
    ComparableBaseFilter.prototype.isFilterActive = function () {
        var rawFilterValues = this.filterValues();
        if (this.filter === BaseFilter.IN_RANGE) {
            var filterValueArray = rawFilterValues;
            return filterValueArray[0] != null && filterValueArray[1] != null;
        }
        else {
            return rawFilterValues != null;
        }
    };
    ComparableBaseFilter.prototype.setFilterType = function (filterType) {
        this.filter = filterType;
        this.eTypeSelector.value = filterType;
    };
    __decorate([
        componentAnnotations_1.QuerySelector('#filterType'),
        __metadata("design:type", HTMLSelectElement)
    ], ComparableBaseFilter.prototype, "eTypeSelector", void 0);
    return ComparableBaseFilter;
}(BaseFilter));
exports.ComparableBaseFilter = ComparableBaseFilter;
/**
 * Comparable filter with scalar underlying values (ie numbers and dates. Strings are not scalar so have to extend
 * ComparableBaseFilter)
 */
var ScalarBaseFilter = (function (_super) {
    __extends(ScalarBaseFilter, _super);
    function ScalarBaseFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScalarBaseFilter.prototype.nullComparator = function (type) {
        var _this = this;
        return function (filterValue, gridValue) {
            if (gridValue == null) {
                var nullValue = _this.translateNull(type);
                if (_this.filter === BaseFilter.EQUALS) {
                    return nullValue ? 0 : 1;
                }
                if (_this.filter === BaseFilter.GREATER_THAN) {
                    return nullValue ? 1 : -1;
                }
                if (_this.filter === BaseFilter.GREATER_THAN_OR_EQUAL) {
                    return nullValue ? 1 : -1;
                }
                if (_this.filter === BaseFilter.LESS_THAN_OR_EQUAL) {
                    return nullValue ? -1 : 1;
                }
                if (_this.filter === BaseFilter.LESS_THAN) {
                    return nullValue ? -1 : 1;
                }
                if (_this.filter === BaseFilter.NOT_EQUAL) {
                    return nullValue ? 1 : 0;
                }
            }
            var actualComparator = _this.comparator();
            return actualComparator(filterValue, gridValue);
        };
    };
    ScalarBaseFilter.prototype.getDefaultType = function () {
        return BaseFilter.EQUALS;
    };
    ScalarBaseFilter.prototype.translateNull = function (type) {
        var reducedType = type.indexOf('greater') > -1 ? 'greaterThan' :
            type.indexOf('lessThan') > -1 ? 'lessThan' :
                'equals';
        if (this.filterParams.nullComparator && this.filterParams.nullComparator[reducedType]) {
            return this.filterParams.nullComparator[reducedType];
        }
        ;
        return ScalarBaseFilter.DEFAULT_NULL_COMPARATOR[reducedType];
    };
    ScalarBaseFilter.prototype.doesFilterPass = function (params) {
        var value = this.filterParams.valueGetter(params.node);
        var comparator = this.nullComparator(this.filter);
        var rawFilterValues = this.filterValues();
        var from = Array.isArray(rawFilterValues) ? rawFilterValues[0] : rawFilterValues;
        if (from == null)
            return true;
        var compareResult = comparator(from, value);
        if (this.filter === BaseFilter.EQUALS) {
            return compareResult === 0;
        }
        if (this.filter === BaseFilter.GREATER_THAN) {
            return compareResult > 0;
        }
        if (this.filter === BaseFilter.GREATER_THAN_OR_EQUAL) {
            return compareResult >= 0;
        }
        if (this.filter === BaseFilter.LESS_THAN_OR_EQUAL) {
            return compareResult <= 0;
        }
        if (this.filter === BaseFilter.LESS_THAN) {
            return compareResult < 0;
        }
        if (this.filter === BaseFilter.NOT_EQUAL) {
            return compareResult != 0;
        }
        //From now on the type is a range and rawFilterValues must be an array!
        var compareToResult = comparator(rawFilterValues[1], value);
        if (this.filter === BaseFilter.IN_RANGE) {
            if (!this.filterParams.inRangeInclusive) {
                return compareResult > 0 && compareToResult < 0;
            }
            else {
                return compareResult >= 0 && compareToResult <= 0;
            }
        }
        throw new Error('Unexpected type of date filter!: ' + this.filter);
    };
    ScalarBaseFilter.DEFAULT_NULL_COMPARATOR = {
        equals: false,
        lessThan: false,
        greaterThan: false
    };
    return ScalarBaseFilter;
}(ComparableBaseFilter));
exports.ScalarBaseFilter = ScalarBaseFilter;


/***/ }),

/***/ "5zde":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("zQR9");
__webpack_require__("qyJz");
module.exports = __webpack_require__("FeBl").Array.from;


/***/ }),

/***/ "651g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

Object.defineProperty(exports, "__esModule", { value: true });
var columnSelectComp_1 = __webpack_require__("LE8v");
var toolPanelColumnComp_1 = __webpack_require__("V1aE");
var toolPanelGroupComp_1 = __webpack_require__("HF1M");
var aggregationStage_1 = __webpack_require__("uK4n");
var groupStage_1 = __webpack_require__("8Iik");
var setFilter_1 = __webpack_require__("46fC");
var setFilterModel_1 = __webpack_require__("jK1P");
var statusBar_1 = __webpack_require__("zVEt");
var statusItem_1 = __webpack_require__("MXce");
var clipboardService_1 = __webpack_require__("/3L8");
var enterpriseBoot_1 = __webpack_require__("NGcw");
var enterpriseMenu_1 = __webpack_require__("kQYo");
var menuItemComponent_1 = __webpack_require__("CN4P");
var menuList_1 = __webpack_require__("Fjmu");
var rangeController_1 = __webpack_require__("PH8O");
var rowGroupColumnsPanel_1 = __webpack_require__("Ygk/");
var contextMenu_1 = __webpack_require__("u5iu");
var viewportRowModel_1 = __webpack_require__("f57H");
var richSelectCellEditor_1 = __webpack_require__("xUPt");
var richSelectRow_1 = __webpack_require__("bR1D");
var virtualList_1 = __webpack_require__("X1NG");
var abstractColumnDropPanel_1 = __webpack_require__("HDwJ");
var pivotColumnsPanel_1 = __webpack_require__("dbIj");
var toolPanelComp_1 = __webpack_require__("Hehg");
var licenseManager_1 = __webpack_require__("7uAN");
var pivotStage_1 = __webpack_require__("aQ8F");
var pivotColDefService_1 = __webpack_require__("10Gu");
var pivotModePanel_1 = __webpack_require__("xchs");
var aggFuncService_1 = __webpack_require__("R6MX");
var md5_1 = __webpack_require__("MPcG");
var setFilterListItem_1 = __webpack_require__("cvpo");
var columnComponent_1 = __webpack_require__("jUST");
var valueColumnsPanel_1 = __webpack_require__("K4Qs");
var pivotCompFactory_1 = __webpack_require__("sVZL");
var rowGroupCompFactory_1 = __webpack_require__("RU0j");
var excelCreator_1 = __webpack_require__("O8Rq");
var excelXmlFactory_1 = __webpack_require__("Bx8k");
function populateClientExports(exports) {
    exports.AggFuncService = aggFuncService_1.AggFuncService;
    exports.MD5 = md5_1.MD5;
    exports.EnterpriseMenu = enterpriseMenu_1.EnterpriseMenu;
    exports.MenuList = menuList_1.MenuList;
    exports.MenuItemComponent = menuItemComponent_1.MenuItemComponent;
    exports.RichSelectCellEditor = richSelectCellEditor_1.RichSelectCellEditor;
    exports.RichSelectRow = richSelectRow_1.RichSelectRow;
    exports.VirtualList = virtualList_1.VirtualList;
    exports.AggregationStage = aggregationStage_1.AggregationStage;
    exports.GroupStage = groupStage_1.GroupStage;
    exports.PivotColDefService = pivotColDefService_1.PivotColDefService;
    exports.PivotStage = pivotStage_1.PivotStage;
    exports.SetFilter = setFilter_1.SetFilter;
    exports.SetFilterListItem = setFilterListItem_1.SetFilterListItem;
    exports.SetFilterModel = setFilterModel_1.SetFilterModel;
    exports.StatusBar = statusBar_1.StatusBar;
    exports.StatusItem = statusItem_1.StatusItem;
    exports.AbstractColumnDropPanel = abstractColumnDropPanel_1.AbstractColumnDropPanel;
    exports.ColumnComponent = columnComponent_1.ColumnComponent;
    exports.PivotColumnsPanel = pivotColumnsPanel_1.PivotColumnsPanel;
    exports.PivotModePanel = pivotModePanel_1.PivotModePanel;
    exports.RowGroupColumnsPanel = rowGroupColumnsPanel_1.RowGroupColumnsPanel;
    exports.ValuesColumnPanel = valueColumnsPanel_1.ValuesColumnPanel;
    exports.ToolPanelComp = toolPanelComp_1.ToolPanelComp;
    exports.ColumnSelectPanel = columnSelectComp_1.ColumnSelectComp;
    exports.RenderedColumn = toolPanelColumnComp_1.ToolPanelColumnComp;
    exports.RenderedGroup = toolPanelGroupComp_1.ToolPanelGroupComp;
    exports.ViewportRowModel = viewportRowModel_1.ViewportRowModel;
    exports.ClipboardService = clipboardService_1.ClipboardService;
    exports.ContextMenuFactory = contextMenu_1.ContextMenuFactory;
    exports.EnterpriseBoot = enterpriseBoot_1.EnterpriseBoot;
    exports.LicenseManager = licenseManager_1.LicenseManager;
    exports.PivotCompFactory = pivotCompFactory_1.PivotCompFactory;
    exports.ExcelCreator = excelCreator_1.ExcelCreator;
    exports.ExcelXmlFactory = excelXmlFactory_1.ExcelXmlFactory;
    exports.RangeController = rangeController_1.RangeController;
    exports.RowGroupCompFactory = rowGroupCompFactory_1.RowGroupCompFactory;
}
exports.populateClientExports = populateClientExports;


/***/ }),

/***/ "6DMD":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1568);
	module.exports = __webpack_require__(1568);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1559:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FTkt");

/***/ }),

/***/ 1568:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1559)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {
	    var extend = $.extend,
	        noop = $.noop,
	        drawing = kendo.drawing,
	        Group = drawing.Group,
	        Surface = drawing.Surface,
	        RENDER = "render",
	        Class = kendo.Class;

	    var geometryTypes = {
	        Path: "path",
	        MultiPath: "multipath",
	        Rect: "rect",
	        Image: "image",
	        Text: "text"
	    };

	    var Page = Class.extend({
	        init: function (options, viewer) {
	            this.viewer = viewer;
	            this.processor = options.processor;
	            this.options = options;
	            this.pageNumber = options.number;

	            this.element = $("<div class='k-page' />");
	            this.element.attr(kendo.attr("number"), this.pageNumber);

	            this._updatePageSize(options);
	            this.width = options.width;
	            this.height = options.height;
	        },
	        resize: function (ratio) {
	            var pageElement = this.element;

	            this._updatePageSize({
	                width: Math.min(pageElement.width() * ratio, this.width),
	                height: Math.min(pageElement.height() * ratio, this.height)
	            });
	        },
	        _updatePageSize: function (size) {
	            this.element
	                    .width(size.width)
	                    .height(size.height);
	        },
	        destroy: function () {
	            kendo.destroy(this.element);
	        },
	        render: noop
	    });

	    var DPLPage = Page.extend({
	        draw: function () {
	            var that = this,
	                geometries = that.options.geometries;

	            that.group = new Group();
	            that.surface.draw(that.group);

	            that._drawGeometries(geometries);

	            that.viewer.trigger(RENDER, { page: this });
	            kendo.ui.progress(that.element, false);
	        },
	        load: function () {
	            var that = this;

	            if (that.loaded || !that.processor)
	            {
	                return;
	            }

	            that.processor.fetchPageData(that.pageNumber).then(function (data) {
	                that.options = data;
	                that._initSurface();
	                that.draw();
	            });

	            that.loaded = true;
	        },
	        _initSurface: function () {
	            var size = {
	                width: this.element.width(),
	                height: this.element.height()
	            };
	            var surfaceOptions = extend({ width: this.width, height: this.height }, this.viewer.options.view);
	            this.surface = new Surface(this.element, surfaceOptions);
	            this._updatePageSize(size);
	        },
	        _drawGeometries: function (geometries) {
	            var that = this,
	                kGeometry;

	            if (!geometries) {
	                return;
	            }

	            for (var i = 0; i <= geometries.length; i++) {
	                var geometry = geometries[i];

	                if (!geometry) {
	                    continue;
	                }

	                switch (geometry.type) {
	                    case geometryTypes.Path:
	                    case geometryTypes.MultiPath:
	                        kGeometry = that._drawPath(geometry);
	                        break;
	                    case geometryTypes.Rect:
	                        kGeometry = that._drawRect(geometry);
	                        break;
	                    case geometryTypes.Image:
	                        kGeometry = that._drawImage(geometry);
	                        break;
	                    case geometryTypes.Text:
	                        kGeometry = that._drawText(geometry);
	                        break;
	                    default:
	                        kGeometry = null;
	                        break;
	                }

	                if (kGeometry)
	                {
	                    that.group.append(kGeometry);
	                }
	            }
	        },
	        _drawRect: function (geometry)
	        {
	            var rectGeo = new kendo.geometry.Rect(geometry.point, geometry.size);

	            return new drawing.Rect(rectGeo, {
	                transform: this._getMatrix(geometry.transform),
	                fill: geometry.fillOptions,
	                stroke: geometry.strokeOptions
	            });
	        },

	        _drawImage: function (geometry)
	        {
	            var imageRect =  new kendo.geometry.Rect(geometry.point, geometry.size);
	            return new drawing.Image(geometry.src, imageRect,  {
	                transform: this._getMatrix(geometry.transform)
	            });
	        },

	        _drawText: function (geometry)
	        {
	            var options = {
	                transform: this._getMatrix(geometry.transform),
	                stroke: geometry.strokeOptions,
	                fill: geometry.fillOptions,
	                font: geometry.font
	            };
	            return new kendo.drawing.Text(geometry.content, geometry.point, options);
	        },

	        _drawPath: function (geometry)
	        {
	            var options = {
	                transform: this._getMatrix(geometry.transform),
	                stroke: geometry.strokeOptions,
	                fill: geometry.fillOptions
	            };
	            var path = new drawing.MultiPath(options);

	            for (var i = 0; i < geometry.paths.length; i++) {
	                var subPath = geometry.paths[i];

	                if (!subPath.segments)
	                {
	                    return;
	                }

	                path.moveTo.apply(path, subPath.point);

	                for (var j = 0; j < subPath.segments.length; j++) {
	                    var segment = subPath.segments[j];
	                    var drawAction = segment.points.length === 1 ? path.lineTo : path.curveTo;
	                    drawAction.apply(path, segment.points);
	                }

	                if (subPath.closed) {
	                    path.close();
	                }
	            }

	            return path;
	        },

	        _getMatrix: function (transform) {
	            var matrix = Object.create(kendo.geometry.Matrix.prototype);
	            kendo.geometry.Matrix.apply(matrix, transform);
	            return matrix;
	        }
	    });

	    var PDFJSPage = Page.extend({
	        init: function(options, viewer) {
	            var that = this,
	                canvas;

	            canvas = $("<canvas style='width: 100%; height: 100%;' />");
	            that.canvas = canvas.get(0);

	            Page.fn.init.call(that, options, viewer);

	            that.canvas.width = that.width;
	            that.canvas.height = that.height;
	            that.element.append(canvas);
	        },
	        load: function (defaultScale, force) {
	            var that = this,
	                promise = $.Deferred();

	            if (that._scale === defaultScale && !force)
	            {
	                return;
	            } else if (that._scale && that._scale !== defaultScale && !force)
	            {
	                that._scale = defaultScale;
	                that.render(defaultScale);
	                return promise.resolve(that);
	            }

	            if (that.processor) {
	                that.processor.fetchPageData(that.pageNumber).then(function (page) {
	                    that._page = page;
	                    that._renderPromise = that.render(defaultScale).then(function () {
	                        that.viewer.trigger(RENDER, { page: that });
	                    });
	                    promise.resolve(that);
	                });
	            }

	            that._scale = defaultScale;
	            that.loaded = true;
	            return promise;
	        },
	        render: function (scale) {
	            var that = this;
	            var context = this.canvas.getContext('2d'),
	                viewport = this._page.getViewport({
	                    scale: scale
	                });

	            this._scale = scale;
	            this.canvas.width = viewport.width;
	            this.canvas.height = viewport.height;

	            if (this._renderTask)
	            {
	                this._renderTask.cancel();
	                this._renderTask = null;
	            }

	            this._updatePageSize({
	                width: viewport.width,
	                height: viewport.height
	            });

	            this._renderTask = this._page.render({
	                canvasContext: context,
	                viewport: viewport
	            });

	            this._renderTextLayer(viewport);

	            return this._renderTask.promise.then(function () {
	                that._renderTask = null;

	            }).catch(function () {}); // jshint ignore:line
	        },
	        _renderTextLayer: function (viewport) {
	            var that = this;
	            var page = that._page;

	            if(that.textLayer) {
	                that.textLayer.remove();
	             }

	            that.textLayer = $("<div class='k-text-layer'></div>").get(0);
	            that.element.append(that.textLayer);

	            page.getTextContent({
	                normalizeWhitespace: true
	            }).then(function(textContent){
	                $(that.textLayer).css({
	                  height: viewport.height,
	                  width: viewport.width
	                }).html(""); // Clear content to make sure that refreshing the page will not cause duplication of the text content.

	                var params = {
	                    textContent: textContent,
	                    container: that.textLayer,
	                    viewport: viewport,
	                    textDivs: [],
	                    enhanceTextSelection: true
	                };

	                that.processor.renderTextLayer(params);
	            });
	        }
	    });

	    extend(kendo.pdfviewer.dpl, {
	        geometryTypes: geometryTypes,
	        Page: DPLPage
	    });
	    extend(kendo.pdfviewer.pdfjs, {
	        Page: PDFJSPage
	    });
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "6GKO":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(999);
	module.exports = __webpack_require__(999);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 999:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*jshint boss: true */

	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1000) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($) {

	    // Imports ================================================================
	    var kendo = window.kendo,
	        Class = kendo.Class,
	        extend = $.extend,
	        Editor = kendo.ui.editor,
	        browser = kendo.support.browser,
	        dom = Editor.Dom,
	        findNodeIndex = dom.findNodeIndex,
	        isDataNode = dom.isDataNode,
	        findClosestAncestor = dom.findClosestAncestor,
	        getNodeLength = dom.getNodeLength,
	        normalize = dom.normalize;

	var SelectionUtils = {
	    selectionFromWindow: function(window) {
	        if(!window) {
	            return;
	        }

	        if (!("getSelection" in window)) {
	            return new W3CSelection(window.document);
	        }

	        return window.getSelection();
	    },

	    selectionFromRange: function(range) {
	        var rangeDocument = RangeUtils.documentFromRange(range);
	        return SelectionUtils.selectionFromDocument(rangeDocument);
	    },

	    selectionFromDocument: function(document) {
	        return SelectionUtils.selectionFromWindow(dom.windowFromDocument(document));
	    }
	};

	var W3CRange = Class.extend({
	    init: function(doc) {
	        $.extend(this, {
	            ownerDocument: doc, /* not part of the spec; used when cloning ranges, traversing the dom and creating fragments */
	            startContainer: doc,
	            endContainer: doc,
	            commonAncestorContainer: doc,
	            startOffset: 0,
	            endOffset: 0,
	            collapsed: true
	        });
	    },

	    // Positioning Methods
	    setStart: function (node, offset) {
	        this.startContainer = node;
	        this.startOffset = offset;
	        updateRangeProperties(this);
	        fixIvalidRange(this, true);
	    },

	    setEnd: function (node, offset) {
	        this.endContainer = node;
	        this.endOffset = offset;
	        updateRangeProperties(this);
	        fixIvalidRange(this, false);
	    },

	    setStartBefore: function (node) {
	        this.setStart(node.parentNode, findNodeIndex(node));
	    },

	    setStartAfter: function (node) {
	        this.setStart(node.parentNode, findNodeIndex(node) + 1);
	    },

	    setEndBefore: function (node) {
	        this.setEnd(node.parentNode, findNodeIndex(node));
	    },

	    setEndAfter: function (node) {
	        this.setEnd(node.parentNode, findNodeIndex(node) + 1);
	    },

	    selectNode: function (node) {
	        this.setStartBefore(node);
	        this.setEndAfter(node);
	    },

	    selectNodeContents: function (node) {
	        this.setStart(node, 0);
	        this.setEnd(node, node[node.nodeType === 1 ? 'childNodes' : 'nodeValue'].length);
	    },

	    collapse: function (toStart) {
	        var that = this;

	        if (toStart) {
	            that.setEnd(that.startContainer, that.startOffset);
	        } else {
	            that.setStart(that.endContainer, that.endOffset);
	        }
	    },

	    // Editing Methods

	    deleteContents: function () {
	        var that = this,
	            range = that.cloneRange();

	        if (that.startContainer != that.commonAncestorContainer) {
	            that.setStartAfter(findClosestAncestor(that.commonAncestorContainer, that.startContainer));
	        }

	        that.collapse(true);

	        (function deleteSubtree(iterator) {
	            while (iterator.next()) {
	                if (iterator.hasPartialSubtree()) {
	                    deleteSubtree(iterator.getSubtreeIterator());
	                } else {
	                    iterator.remove();
	                }
	            }
	        })(new RangeIterator(range));
	    },

	    cloneContents: function () {
	        // clone subtree
	        var document = RangeUtils.documentFromRange(this);
	        return (function cloneSubtree(iterator) {
	                var node, frag = document.createDocumentFragment();

	                while (node = iterator.next()) {
	                    node = node.cloneNode(!iterator.hasPartialSubtree());

	                    if (iterator.hasPartialSubtree()) {
	                        node.appendChild(cloneSubtree(iterator.getSubtreeIterator()));
	                    }

	                    frag.appendChild(node);
	                }

	                return frag;
	        })(new RangeIterator(this));
	    },

	    extractContents: function () {
	        var that = this,
	            range = that.cloneRange();

	        if (that.startContainer != that.commonAncestorContainer) {
	            that.setStartAfter(findClosestAncestor(that.commonAncestorContainer, that.startContainer));
	        }

	        that.collapse(true);

	        var document = RangeUtils.documentFromRange(that);

	        return (function extractSubtree(iterator) {
	            var node, frag = document.createDocumentFragment();

	            while (node = iterator.next()) {
	                if (iterator.hasPartialSubtree()) {
	                    node = node.cloneNode(false);
	                    node.appendChild(extractSubtree(iterator.getSubtreeIterator()));
	                } else {
	                    iterator.remove(that.originalRange);
	                }

	                frag.appendChild(node);
	            }

	            return frag;
	        })(new RangeIterator(range));
	    },

	    insertNode: function (node) {
	        var that = this;

	        if (isDataNode(that.startContainer)) {
	            if (that.startOffset != that.startContainer.nodeValue.length) {
	                dom.splitDataNode(that.startContainer, that.startOffset);
	            }

	            dom.insertAfter(node, that.startContainer);
	        } else {
	            dom.insertAt(that.startContainer, node, that.startOffset);
	        }

	        that.setStart(that.startContainer, that.startOffset);
	    },

	    cloneRange: function () {
	        // fast copy
	        return $.extend(new W3CRange(this.ownerDocument), {
	            startContainer: this.startContainer,
	            endContainer: this.endContainer,
	            commonAncestorContainer: this.commonAncestorContainer,
	            startOffset: this.startOffset,
	            endOffset: this.endOffset,
	            collapsed: this.collapsed,

	            originalRange: this /* not part of the spec; used to update the original range when calling extractContents() on clones */
	        });
	    },

	    // used for debug purposes
	    toString: function () {
	        var startNodeName = this.startContainer.nodeName,
	            endNodeName = this.endContainer.nodeName;

	        return [startNodeName == "#text" ? this.startContainer.nodeValue : startNodeName, '(', this.startOffset, ') : ',
	                endNodeName == "#text" ? this.endContainer.nodeValue : endNodeName, '(', this.endOffset, ')'].join('');
	    }
	});

	W3CRange.fromNode = function(node) {
	    return new W3CRange(node.ownerDocument);
	};

	/* can be used in Range.compareBoundaryPoints if we need it one day */
	function compareBoundaries(start, end, startOffset, endOffset) {
	    if (start == end) {
	        return endOffset - startOffset;
	    }

	    // end is child of start
	    var container = end;
	    while (container && container.parentNode != start) {
	        container = container.parentNode;
	    }

	    if (container) {
	        return findNodeIndex(container) - startOffset;
	    }

	    // start is child of end
	    container = start;
	    while (container && container.parentNode != end) {
	        container = container.parentNode;
	    }

	    if (container) {
	        return endOffset - findNodeIndex(container) - 1;
	    }

	    // deep traversal
	    var root = dom.commonAncestor(start, end);
	    var startAncestor = start;

	    while (startAncestor && startAncestor.parentNode != root) {
	        startAncestor = startAncestor.parentNode;
	    }

	    if (!startAncestor) {
	        startAncestor = root;
	    }

	    var endAncestor = end;
	    while (endAncestor && endAncestor.parentNode != root) {
	        endAncestor = endAncestor.parentNode;
	    }

	    if (!endAncestor) {
	        endAncestor = root;
	    }

	    if (startAncestor == endAncestor) {
	        return 0;
	    }

	    return findNodeIndex(endAncestor) - findNodeIndex(startAncestor);
	}

	function fixIvalidRange(range, toStart) {
	    function isInvalidRange(range) {
	        try {
	            return compareBoundaries(range.startContainer, range.endContainer, range.startOffset, range.endOffset) < 0;
	        } catch (ex) {
	            // range was initially invalid (e.g. when cloned from invalid range) - it must be fixed
	            return true;
	        }
	    }

	    if (isInvalidRange(range)) {
	        if (toStart) {
	            range.commonAncestorContainer = range.endContainer = range.startContainer;
	            range.endOffset = range.startOffset;
	        } else {
	            range.commonAncestorContainer = range.startContainer = range.endContainer;
	            range.startOffset = range.endOffset;
	        }

	        range.collapsed = true;
	    }
	}

	function updateRangeProperties(range) {
	    range.collapsed = range.startContainer == range.endContainer && range.startOffset == range.endOffset;

	    var node = range.startContainer;
	    while (node && node != range.endContainer && !dom.isAncestorOf(node, range.endContainer)) {
	        node = node.parentNode;
	    }

	    range.commonAncestorContainer = node;
	}

	var RangeIterator = Class.extend({
	    init: function(range) {
	        $.extend(this, {
	            range: range,
	            _current: null,
	            _next: null,
	            _end: null
	        });

	        if (range.collapsed) {
	            return;
	        }

	        var root = range.commonAncestorContainer;

	        this._next = range.startContainer == root && !isDataNode(range.startContainer) ?
	        range.startContainer.childNodes[range.startOffset] :
	        findClosestAncestor(root, range.startContainer);

	        this._end = range.endContainer == root && !isDataNode(range.endContainer) ?
	        range.endContainer.childNodes[range.endOffset] :
	        findClosestAncestor(root, range.endContainer).nextSibling;
	    },

	    hasNext: function () {
	        return !!this._next;
	    },

	    next: function () {
	        var that = this,
	            current = that._current = that._next;
	        that._next = that._current && that._current.nextSibling != that._end ?
	        that._current.nextSibling : null;

	        if (isDataNode(that._current)) {
	            if (that.range.endContainer == that._current) {
	                current = current.cloneNode(true);
	                current.deleteData(that.range.endOffset, current.length - that.range.endOffset);
	            }

	            if (that.range.startContainer == that._current) {
	                current = current.cloneNode(true);
	                current.deleteData(0, that.range.startOffset);
	            }
	        }

	        return current;
	    },

	    traverse: function (callback) {
	        var that = this,
	            current;

	        function next() {
	            that._current = that._next;
	            that._next = that._current && that._current.nextSibling != that._end ? that._current.nextSibling : null;
	            return that._current;
	        }

	        while (current = next()) {
	            if (that.hasPartialSubtree()) {
	                that.getSubtreeIterator().traverse(callback);
	            } else {
	                callback(current);
	            }
	        }

	        return current;
	    },

	    remove: function (originalRange) {
	        var that = this,
	            inStartContainer = that.range.startContainer == that._current,
	            inEndContainer = that.range.endContainer == that._current,
	            start, end, delta;

	        if (isDataNode(that._current) && (inStartContainer || inEndContainer)) {
	            start = inStartContainer ? that.range.startOffset : 0;
	            end = inEndContainer ? that.range.endOffset : that._current.length;
	            delta = end - start;

	            if (originalRange && (inStartContainer || inEndContainer)) {
	                if (that._current == originalRange.startContainer && start <= originalRange.startOffset) {
	                    originalRange.startOffset -= delta;
	                }

	                if (that._current == originalRange.endContainer && end <= originalRange.endOffset) {
	                    originalRange.endOffset -= delta;
	                }
	            }

	            that._current.deleteData(start, delta);
	        } else {
	            var parent = that._current.parentNode;

	            if (originalRange && (that.range.startContainer == parent || that.range.endContainer == parent)) {
	                var nodeIndex = findNodeIndex(that._current);

	                if (parent == originalRange.startContainer && nodeIndex <= originalRange.startOffset) {
	                    originalRange.startOffset -= 1;
	                }

	                if (parent == originalRange.endContainer && nodeIndex < originalRange.endOffset) {
	                    originalRange.endOffset -= 1;
	                }
	            }

	            dom.remove(that._current);
	        }
	    },

	    hasPartialSubtree: function () {
	        return !isDataNode(this._current) &&
	        (dom.isAncestorOrSelf(this._current, this.range.startContainer) ||
	            dom.isAncestorOrSelf(this._current, this.range.endContainer));
	    },

	    getSubtreeIterator: function () {
	        return new RangeIterator(this.getSubRange());
	    },

	    getSubRange: function(){
	        var that = this,
	            subRange = that.range.cloneRange();
	        subRange.selectNodeContents(that._current);
	        if (dom.isAncestorOrSelf(that._current, that.range.startContainer)) {
	            subRange.setStart(that.range.startContainer, that.range.startOffset);
	        }
	        if (dom.isAncestorOrSelf(that._current, that.range.endContainer)) {
	            subRange.setEnd(that.range.endContainer, that.range.endOffset);
	        }

	        return subRange;
	    }
	});

	var W3CSelection = Class.extend({
	    init: function(doc) {
	        this.ownerDocument = doc;
	        this.rangeCount = 1;
	    },

	    addRange: function (range) {
	        var textRange = this.ownerDocument.body.createTextRange();

	        // end container should be adopted first in order to prevent selection with negative length
	        adoptContainer(textRange, range, false);
	        adoptContainer(textRange, range, true);

	        textRange.select();
	    },

	    removeAllRanges: function () {
	        var selection = this.ownerDocument.selection;

	        if (selection.type != "None") {
	            selection.empty();
	        }
	    },

	    getRangeAt: function () {
	        var textRange,
	            range = new W3CRange(this.ownerDocument),
	            selection = this.ownerDocument.selection,
	            element, commonAncestor;

	        try {
	            textRange = selection.createRange();
	            element = textRange.item ? textRange.item(0) : textRange.parentElement();
	            if (element.ownerDocument != this.ownerDocument) {
	                return range;
	            }
	        } catch (ex) {
	            return range;
	        }

	        if (selection.type == "Control") {
	            range.selectNode(textRange.item(0));
	        } else {
	            commonAncestor = textRangeContainer(textRange);
	            adoptEndPoint(textRange, range, commonAncestor, true);
	            adoptEndPoint(textRange, range, commonAncestor, false);

	            if (range.startContainer.nodeType == 9) {
	                range.setStart(range.endContainer, range.startOffset);
	            }

	            if (range.endContainer.nodeType == 9) {
	                range.setEnd(range.startContainer, range.endOffset);
	            }

	            if (textRange.compareEndPoints("StartToEnd", textRange) === 0) {
	                range.collapse(false);
	            }

	            var startContainer = range.startContainer,
	                endContainer = range.endContainer,
	                body = this.ownerDocument.body;

	            if (!range.collapsed && range.startOffset === 0 && range.endOffset == getNodeLength(range.endContainer) &&  // check for full body selection
	                !(startContainer == endContainer && isDataNode(startContainer) && startContainer.parentNode == body)) { // but not when single textnode is selected
	                var movedStart = false,
	                    movedEnd = false;

	                while (findNodeIndex(startContainer) === 0 && startContainer == startContainer.parentNode.firstChild && startContainer != body) {
	                    startContainer = startContainer.parentNode;
	                    movedStart = true;
	                }

	                while (findNodeIndex(endContainer) == getNodeLength(endContainer.parentNode) - 1 && endContainer == endContainer.parentNode.lastChild && endContainer != body) {
	                    endContainer = endContainer.parentNode;
	                    movedEnd = true;
	                }

	                if (startContainer == body && endContainer == body && movedStart && movedEnd) {
	                    range.setStart(startContainer, 0);
	                    range.setEnd(endContainer, getNodeLength(body));
	                }
	            }
	        }

	        return range;
	    }
	});

	function textRangeContainer(textRange) {
	    var left = textRange.duplicate(),
	        right = textRange.duplicate();

	    left.collapse(true);
	    right.collapse(false);

	    return dom.commonAncestor(textRange.parentElement(), left.parentElement(), right.parentElement());
	}

	function adoptContainer(textRange, range, start) {
	    // find anchor node and offset
	    var container = range[start ? "startContainer" : "endContainer"],
	        offset = range[start ? "startOffset" : "endOffset"],
	        textOffset = 0,
	        isData = isDataNode(container),
	        anchorNode = isData ? container : container.childNodes[offset] || null,
	        anchorParent = isData ? container.parentNode : container,
	        doc = range.ownerDocument,
	        cursor = doc.body.createTextRange(),
	        cursorNode;

	    // visible data nodes need a text offset
	    if (container.nodeType == 3 || container.nodeType == 4) {
	        textOffset = offset;
	    }

	    if (!anchorParent) {
	        anchorParent = doc.body;
	    }

	    if (anchorParent.nodeName.toLowerCase() == "img") {
	        cursor.moveToElementText(anchorParent);
	        cursor.collapse(false);
	        textRange.setEndPoint(start ? "StartToStart" : "EndToStart", cursor);
	    } else {
	        // create a cursor element node to position range (since we can't select text nodes)
	        cursorNode = anchorParent.insertBefore(dom.create(doc, "a"), anchorNode);

	        cursor.moveToElementText(cursorNode);
	        dom.remove(cursorNode);
	        cursor[start ? "moveStart" : "moveEnd"]("character", textOffset);
	        cursor.collapse(false);
	        textRange.setEndPoint(start ? "StartToStart" : "EndToStart", cursor);
	    }
	}

	function adoptEndPoint(textRange, range, commonAncestor, start) {
	    var cursorNode = dom.create(range.ownerDocument, "a"),
	        cursor = textRange.duplicate(),
	        comparison = start ? "StartToStart" : "StartToEnd",
	        result, parent, target,
	        previous, next,
	        args, index,
	        appended = false;

	    cursorNode.innerHTML = "\ufeff";
	    cursor.collapse(start);

	    parent = cursor.parentElement();

	    if (!dom.isAncestorOrSelf(commonAncestor, parent)) {
	        parent = commonAncestor;
	    }

	    // detect range end points
	    // insert cursorNode within the textRange parent and move the cursor until it gets outside of the textRange
	    do {
	        if (appended) {
	            parent.insertBefore(cursorNode, cursorNode.previousSibling);
	        } else {
	            parent.appendChild(cursorNode);
	            appended = true;
	        }
	        cursor.moveToElementText(cursorNode);
	    } while ((result = cursor.compareEndPoints(comparison, textRange)) > 0 && cursorNode.previousSibling);

	    target = cursorNode.nextSibling;

	    if (result == -1 && isDataNode(target)) {
	        cursor.setEndPoint(start ? "EndToStart" : "EndToEnd", textRange);

	        dom.remove(cursorNode);

	        args = [target, cursor.text.length];
	    } else {
	        previous = !start && cursorNode.previousSibling;
	        next = start && cursorNode.nextSibling;

	        if (isDataNode(next)) {
	            args = [next, 0];
	        } else if (isDataNode(previous)) {
	            args = [previous, previous.length];
	        } else {
	            index = findNodeIndex(cursorNode);

	            if (parent.nextSibling && index == parent.childNodes.length - 1) {
	                args = [parent.nextSibling, 0];
	            } else {
	                args = [parent, index];
	            }
	        }

	        dom.remove(cursorNode);
	    }

	    range[start ? "setStart" : "setEnd"].apply(range, args);
	}

	var RangeEnumerator = Class.extend({
	    init: function(range) {
	        this.enumerate = function () {
	            var nodes = [];

	            function visit(node) {
	                if (dom.is(node, "img") || (node.nodeType == 3 && (!dom.isEmptyspace(node) || node.nodeValue == "\ufeff"))) {
	                    nodes.push(node);
	                } else {
	                    node = node.firstChild;
	                    while (node) {
	                        visit(node);
	                        node = node.nextSibling;
	                    }
	                }
	            }

	            new RangeIterator(range).traverse(visit);

	            return nodes;
	        };
	    }
	});

	var ImmutablesRangeIterator = RangeIterator.extend({
	    hasPartialSubtree: function () {
	        var immutable = Editor.Immutables && Editor.Immutables.immutable;
	        return immutable && !immutable(this._current) && RangeIterator.fn.hasPartialSubtree.call(this);
	    },

	    getSubtreeIterator: function () {
	        return new ImmutablesRangeIterator(this.getSubRange());
	    }
	});

	var ImmutablesRangeEnumerator = Class.extend({
	    init: function(range) {
	        this.enumerate = function () {
	            var nodes = [];
	            var immutable = Editor.Immutables && Editor.Immutables.immutable;
	            function visit(node) {
	                if (immutable && !immutable(node)) {
	                    if (dom.is(node, "img") || (node.nodeType == 3 && (!dom.isEmptyspace(node) || node.nodeValue == "\ufeff"))) {
	                        nodes.push(node);
	                    } else {
	                        node = node.firstChild;
	                        while (node) {
	                            visit(node);
	                            node = node.nextSibling;
	                        }
	                    }
	                }
	            }

	            new ImmutablesRangeIterator(range).traverse(visit);

	            return nodes;
	        };
	    }
	});

	var RestorePoint = Class.extend({
	    init: function(range, body, options) {
	        var that = this;
	        that.range = range;
	        that.rootNode = RangeUtils.documentFromRange(range);
	        that.body = body || that.getEditable(range);
	        if (dom.name(that.body) != "body") {
	            that.rootNode = that.body;
	        }

	        that.startContainer = that.nodeToPath(range.startContainer);
	        that.endContainer = that.nodeToPath(range.endContainer);
	        that.startOffset = that.offset(range.startContainer, range.startOffset);
	        that.endOffset = that.offset(range.endContainer, range.endOffset);

	        that.immutables = options && options.immutables;

	        if (that.immutables) {
	            that.serializedImmutables = Editor.Immutables.removeImmutables(that.body);
	        }

	        that.html = that.body.innerHTML;

	        if (that.immutables && !that.serializedImmutables.empty) {
	            Editor.Immutables.restoreImmutables(that.body, that.serializedImmutables);
	        }
	    },

	    index: function(node) {
	        var result = 0,
	            lastType = node.nodeType;

	        while (node = node.previousSibling) {
	            var nodeType = node.nodeType;

	            if (nodeType != 3 || lastType != nodeType) {
	                result ++;
	            }

	            lastType = nodeType;
	        }

	        return result;
	    },

	    getEditable: function(range) {
	        var root = range.commonAncestorContainer;

	        while (root && (root.nodeType == 3 || root.attributes && (!root.attributes.contentEditable || root.attributes.contentEditable.nodeValue.toLowerCase() == "false"))) {
	            root = root.parentNode;
	        }

	        return root;
	    },

	    restoreHtml: function() {
	        var that = this;

	        dom.removeChildren(that.body);
	        that.body.innerHTML = that.html;
	        if (that.immutables && !that.serializedImmutables.empty) {
	            Editor.Immutables.restoreImmutables(that.body, that.serializedImmutables);
	        }
	    },

	    offset: function(node, value) {
	        if (node.nodeType == 3) {
	            while ((node = node.previousSibling) && node.nodeType == 3) {
	                value += node.nodeValue.length;
	            }
	        }

	        return value;
	    },

	    nodeToPath: function(node) {
	        var path = [];

	        while (node != this.rootNode) {
	            path.push(this.index(node));
	            node = node.parentNode;
	        }

	        return path;
	    },

	    toRangePoint: function(range, start, path, denormalizedOffset) {
	        var node = this.rootNode,
	            length = path.length,
	            offset = denormalizedOffset;

	        while (length-- && node) {
	            node = node.childNodes[path[length]];
	        }

	        while (node && node.nodeType == 3 && node.nodeValue.length < offset) {
	            offset -= node.nodeValue.length;
	            node = node.nextSibling;
	        }

	        if (node && offset >= 0) {
	            range[start ? 'setStart' : 'setEnd'](node, offset);
	        }
	    },

	    toRange: function () {
	        var that = this,
	            result = that.range.cloneRange();

	        that.toRangePoint(result, true, that.startContainer, that.startOffset);
	        that.toRangePoint(result, false, that.endContainer, that.endOffset);

	        return result;
	    }

	});

	var Marker = Class.extend({
	    init: function() {
	        this.caret = null;
	    },

	    addCaret: function (range) {
	        var that = this;
	        var caret = that.caret = dom.create(RangeUtils.documentFromRange(range), 'span', { className: 'k-marker' });
	        range.insertNode(caret);

	        dom.stripBomNode(caret.previousSibling);
	        dom.stripBomNode(caret.nextSibling);

	        range.selectNode(caret);
	        return caret;
	    },

	    removeCaret: function (range) {
	        var that = this,
	            previous = that.caret.previousSibling,
	            startOffset = 0;

	        if (previous) {
	            startOffset = isDataNode(previous) ? previous.nodeValue.length : findNodeIndex(previous);
	        }

	        var container = that.caret.parentNode;
	        var containerIndex = previous ? findNodeIndex(previous) : 0;

	        dom.remove(that.caret);
	        normalize(container);

	        var node = container.childNodes[containerIndex];

	        if (isDataNode(node)) {
	            range.setStart(node, startOffset);
	        } else if (node) {
	            var textNode = dom.lastTextNode(node);
	            if (textNode) {
	                range.setStart(textNode, textNode.nodeValue.length);
	            } else {
	                range[previous ? 'setStartAfter' : 'setStartBefore'](node);
	            }
	        } else {
	            if (!browser.msie && !container.innerHTML) {
	                container.innerHTML = '<br _moz_dirty="" />';
	            }

	            range.selectNodeContents(container);
	        }
	        range.collapse(true);
	    },

	    add: function (range, expand) {
	        var that = this;

	        var collapsed = range.collapsed && !RangeUtils.isExpandable(range);
	        var doc = RangeUtils.documentFromRange(range);

	        if (expand && range.collapsed) {
	            that.addCaret(range);
	            range = RangeUtils.expand(range);
	        }

	        var rangeBoundary = range.cloneRange();

	        rangeBoundary.collapse(false);
	        that.end = dom.create(doc, 'span', { className: 'k-marker' });
	        rangeBoundary.insertNode(that.end);

	        rangeBoundary = range.cloneRange();
	        rangeBoundary.collapse(true);
	        that.start = that.end.cloneNode(true);
	        rangeBoundary.insertNode(that.start);

	        that._removeDeadMarkers(that.start, that.end);

	        if (collapsed) {
	            var bom = doc.createTextNode("\ufeff");
	            dom.insertAfter(bom.cloneNode(), that.start);
	            dom.insertBefore(bom, that.end);
	        }

	        normalize(range.commonAncestorContainer);

	        range.setStartBefore(that.start);
	        range.setEndAfter(that.end);

	        return range;
	    },

	    _removeDeadMarkers: function(start, end) {
	        if (start.previousSibling && start.previousSibling.nodeValue == "\ufeff") {
	            dom.remove(start.previousSibling);
	        }

	        if (end.nextSibling && end.nextSibling.nodeValue == "\ufeff") {
	            dom.remove(end.nextSibling);
	        }
	    },

	    _normalizedIndex: function(node) {
	        var index = findNodeIndex(node);
	        var pointer = node;

	        while (pointer.previousSibling) {
	            if (pointer.nodeType == 3 && pointer.previousSibling.nodeType == 3) {
	                index--;
	            }

	            pointer = pointer.previousSibling;
	        }

	        return index;
	    },

	    remove: function (range) {
	        var that = this,
	            start = that.start,
	            end = that.end,
	            shouldNormalizeStart,
	            shouldNormalizeEnd,
	            shouldNormalize;

	        normalize(range.commonAncestorContainer);

	        while (!start.nextSibling && start.parentNode) {
	            start = start.parentNode;
	        }

	        while (!end.previousSibling && end.parentNode) {
	            end = end.parentNode;
	        }

	        // merely accessing the siblings will solve range issues in IE
	        shouldNormalizeStart = (start.previousSibling && start.previousSibling.nodeType == 3) &&
	                               (start.nextSibling && start.nextSibling.nodeType == 3);

	        shouldNormalizeEnd = (end.previousSibling && end.previousSibling.nodeType == 3) &&
	                             (end.nextSibling && end.nextSibling.nodeType == 3);

	        shouldNormalize = shouldNormalizeStart && shouldNormalizeEnd;

	        start = start.nextSibling;
	        end = end.previousSibling;

	        var isBomSelected = start === end && dom.isBom(start);
	        if (isBomSelected && start.length > 1) {
	            start.nodeValue = start.nodeValue.charAt(0);
	        }

	        var collapsed = isBomSelected;
	        var collapsedToStart = false;
	        // collapsed range
	        if (start == that.end) {
	            collapsedToStart = !!that.start.previousSibling;
	            start = end = that.start.previousSibling || that.end.nextSibling;
	            collapsed = true;
	        }

	        dom.remove(that.start);
	        dom.remove(that.end);

	        if (!start || !end) {
	            range.selectNodeContents(range.commonAncestorContainer);
	            range.collapse(true);
	            return;
	        }

	        var startOffset = collapsed ? isDataNode(start) ? start.nodeValue.length : start.childNodes.length : 0;
	        var endOffset = isDataNode(end) ? end.nodeValue.length : end.childNodes.length;

	        if (start.nodeType == 3) {
	            while (start.previousSibling && start.previousSibling.nodeType == 3) {
	                start = start.previousSibling;
	                startOffset += start.nodeValue.length;
	            }
	        }

	        if (end.nodeType == 3) {
	            while (end.previousSibling && end.previousSibling.nodeType == 3) {
	                end = end.previousSibling;
	                endOffset += end.nodeValue.length;
	            }
	        }

	        var startParent = start.parentNode;
	        var endParent = end.parentNode;
	        var startIndex = this._normalizedIndex(start);
	        var endIndex = this._normalizedIndex(end);

	        normalize(startParent);
	        if (start.nodeType == 3) {
	            start = startParent.childNodes[startIndex];
	        }

	        normalize(endParent);
	        if (end.nodeType == 3) {
	            end = endParent.childNodes[endIndex];
	        }

	        if (collapsed) {
	            if (start.nodeType == 3) {
	                range.setStart(start, startOffset);
	            } else {
	                range[collapsedToStart ? 'setStartAfter' : 'setStartBefore'](start);
	            }

	            range.collapse(true);

	        } else {
	            if (start.nodeType == 3) {
	                range.setStart(start, startOffset);
	            } else {
	                range.setStartBefore(start);
	            }

	            if (end.nodeType == 3) {
	                range.setEnd(end, endOffset);
	            } else {
	                range.setEndAfter(end);
	            }
	        }

	        if (that.caret) {
	            that.removeCaret(range);
	        }
	    }
	});

	var boundary = /[\u0009-\u000d]|\u0020|\u00a0|\ufeff|\.|,|;|:|!|\(|\)|\?/;

	var RangeUtils = {
	    nodes: function(range) {
	        var nodes = RangeUtils.textNodes(range);
	        if (!nodes.length) {
	            range.selectNodeContents(range.commonAncestorContainer);
	            nodes = RangeUtils.textNodes(range);
	            if (!nodes.length) {
	                nodes = dom.significantChildNodes(range.commonAncestorContainer);
	            }
	        }
	        return nodes;
	    },

	    textNodes: function(range) {
	        return new RangeEnumerator(range).enumerate();
	    },

	    editableTextNodes: function(range) {
	        var nodes = [],
	            immutableParent = Editor.Immutables && Editor.Immutables.immutableParent;

	        if (immutableParent && !immutableParent(range.commonAncestorContainer)) {
	            nodes = new ImmutablesRangeEnumerator(range).enumerate();
	        }

	        return nodes;
	    },

	    documentFromRange: function(range) {
	        var startContainer = range.startContainer;
	        return startContainer.nodeType == 9 ? startContainer : startContainer.ownerDocument;
	    },

	    createRange: function(document) {
	        if (browser.msie && browser.version < 9) {
	            return new W3CRange(document);
	        }

	        return document.createRange();
	    },

	    selectRange: function(range) {
	        var image = RangeUtils.image(range);
	        if (image) {
	            range.setStartAfter(image);
	            range.setEndAfter(image);
	        }
	        var selection = SelectionUtils.selectionFromRange(range);
	        selection.removeAllRanges();
	        selection.addRange(range);
	    },

	    stringify: function(range) {
	        return kendo.format(
	            "{0}:{1} - {2}:{3}",
	            dom.name(range.startContainer), range.startOffset,
	            dom.name(range.endContainer), range.endOffset
	        );
	    },

	    split: function(range, node, trim) {
	        function partition(start) {
	            var partitionRange = range.cloneRange();
	            partitionRange.collapse(start);
	            partitionRange[start ? 'setStartBefore' : 'setEndAfter'](node);
	            var contents = partitionRange.extractContents();
	            if (trim) {
	                contents = dom.trim(contents);
	            }
	            dom[start ? 'insertBefore' : 'insertAfter'](contents, node);
	        }
	        partition(true);
	        partition(false);
	    },

	    mapAll: function(range, map) {
	        var nodes = [];

	        new RangeIterator(range).traverse(function(node) {
	            var mapped = map(node);

	            if (mapped && $.inArray(mapped, nodes) < 0) {
	                nodes.push(mapped);
	            }
	        });

	        return nodes;
	    },

	    getAll: function(range, predicate) {
	        var selector = predicate;

	        if (typeof predicate == "string") {
	            predicate = function(node) {
	                return dom.is(node, selector);
	            };
	        }

	        return RangeUtils.mapAll(range, function (node) {
	            if (predicate(node)) {
	                return node;
	            }
	        });
	    },

	    getMarkers: function(range) {
	        return RangeUtils.getAll(range, function(node) {
	            return node.className == 'k-marker';
	        });
	    },

	    image: function (range) {
	        var nodes = RangeUtils.getAll(range, "img");

	        if (nodes.length == 1) {
	            return nodes[0];
	        }
	    },

	    isStartOf: function(originalRange, node) {
	        if (originalRange.startOffset !== 0) {
	            return false;
	        }

	        var range = originalRange.cloneRange();

	        while (range.startOffset === 0 && range.startContainer != node) {
	            var index = dom.findNodeIndex(range.startContainer);
	            var parent = range.startContainer.parentNode;

	            while (index > 0 && parent[index-1] && dom.insignificant(parent[index-1])) {
	                index--;
	            }

	            range.setStart(parent, index);
	        }

	        return range.startOffset === 0 && range.startContainer == node;
	    },

	    isEndOf: function(originalRange, node) {
	        var range = originalRange.cloneRange();

	        range.collapse(false);

	        var start = range.startContainer;

	        if (dom.isDataNode(start) && range.startOffset == dom.getNodeLength(start)) {
	            range.setStart(start.parentNode, dom.findNodeIndex(start) + 1);
	            range.collapse(true);
	        }

	        range.setEnd(node, dom.getNodeLength(node));

	        var nodes = [];

	        function visit(node) {
	            if (!dom.insignificant(node) && !(dom.isDataNode(node) && /^[\ufeff]*$/.test(node.nodeValue))) {
	                nodes.push(node);
	            }
	        }

	        new RangeIterator(range).traverse(visit);

	        return !nodes.length;
	    },

	    wrapSelectedElements: function(range) {
	        var startEditable = dom.editableParent(range.startContainer);
	        var endEditable = dom.editableParent(range.endContainer);

	        while (range.startOffset === 0 && range.startContainer != startEditable) {
	            range.setStart(range.startContainer.parentNode, dom.findNodeIndex(range.startContainer));
	        }

	        function isEnd(offset, container) {
	            var length = dom.getNodeLength(container);

	            if (offset == length) {
	                return true;
	            }

	            for (var i = offset; i < length; i++) {
	                if (!dom.insignificant(container.childNodes[i])) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        while (isEnd(range.endOffset, range.endContainer) && range.endContainer != endEditable) {
	            range.setEnd(range.endContainer.parentNode, dom.findNodeIndex(range.endContainer) + 1);
	        }

	        return range;
	    },

	    expand: function (range) {
	        var result = range.cloneRange();

	        var startContainer = result.startContainer.childNodes[result.startOffset === 0 ? 0 : result.startOffset - 1];
	        var endContainer = result.endContainer.childNodes[result.endOffset];

	        if (!isDataNode(startContainer) || !isDataNode(endContainer)) {
	            return result;
	        }

	        var beforeCaret = startContainer.nodeValue;
	        var afterCaret = endContainer.nodeValue;

	        if (!beforeCaret || !afterCaret) {
	            return result;
	        }

	        var startOffset = beforeCaret.split('').reverse().join('').search(boundary);
	        var endOffset = afterCaret.search(boundary);

	        if (!startOffset || !endOffset) {
	            return result;
	        }

	        endOffset = endOffset == -1 ? afterCaret.length : endOffset;
	        startOffset = startOffset == -1 ? 0 : beforeCaret.length - startOffset;

	        result.setStart(startContainer, startOffset);
	        result.setEnd(endContainer, endOffset);

	        return result;
	    },

	    isExpandable: function (range) {
	        var node = range.startContainer;
	        var rangeDocument = RangeUtils.documentFromRange(range);

	        if (node == rangeDocument || node == rangeDocument.body) {
	            return false;
	        }

	        var result = range.cloneRange();

	        var value = node.nodeValue;
	        if (!value) {
	            return false;
	        }

	        var beforeCaret = value.substring(0, result.startOffset);
	        var afterCaret = value.substring(result.startOffset);

	        var startOffset = 0, endOffset = 0;

	        if (beforeCaret) {
	            startOffset = beforeCaret.split('').reverse().join('').search(boundary);
	        }

	        if (afterCaret) {
	            endOffset = afterCaret.search(boundary);
	        }

	        return startOffset && endOffset;
	    }
	};

	extend(Editor, {
	    SelectionUtils: SelectionUtils,
	    W3CRange: W3CRange,
	    RangeIterator: RangeIterator,
	    W3CSelection: W3CSelection,
	    RangeEnumerator: RangeEnumerator,
	    RestorePoint: RestorePoint,
	    Marker: Marker,
	    RangeUtils: RangeUtils
	});

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 1000:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("wVvS");

/***/ })

/******/ });

/***/ }),

/***/ "6LjV":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1593);
	module.exports = __webpack_require__(1593);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1593:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var SheetEditor = kendo.Observable.extend({
	        init: function(view) {
	            kendo.Observable.fn.init.call(this);

	            this.view = view;
	            this.formulaBar = view.formulaBar;
	            this._active = false;

	            this.barInput = view.formulaBar.formulaInput;
	            this.cellInput = view.formulaInput;

	            this.barInput.syncWith(this.cellInput);
	            this.cellInput.syncWith(this.barInput);

	            this.barInput.bind("keyup", this._triggerUpdate.bind(this));
	            this.cellInput.bind("keyup", this._triggerUpdate.bind(this));

	            this.barInput.bind("blur", this._blur.bind(this));
	            this.cellInput.bind("blur", this._blur.bind(this));
	        },

	        events: [
	            "activate",
	            "deactivate",
	            "change",
	            "update"
	        ],

	        _blur: function() {
	            this.deactivate();
	        },

	        _triggerUpdate: function() {
	            this.trigger("update", { value: this.value() });
	        },

	        activeEditor: function() {
	            var editor = null;
	            var activeElement = kendo._activeElement();

	            if (this.barElement()[0] === activeElement) {
	                editor = this.barInput;
	            } else if (this.cellElement()[0] === activeElement) {
	                editor = this.cellInput;
	            }

	            return editor;
	        },

	        activate: function(options) {
	            var viewElement = this.view.element,
	                viewWidth, scrollerElement, scrollbarWidth;

	            this._active = true;
	            this._rect = options.rect;
	            this._range = options.range;

	            this.cellInput.position(options.rect);
	            this.cellInput.resize(options.rect);
	            this.cellInput.tooltip(options.tooltip);
	            this.cellInput.activeCell = this.barInput.activeCell = this._range.topLeft();
	            this.cellInput.activeSheet = this.barInput.activeSheet = this._range._sheet;

	            if(viewElement) {
	                viewWidth = viewElement.width();
	                scrollerElement = viewElement.find(".k-spreadsheet-scroller")[0];
	                scrollbarWidth = scrollerElement.offsetWidth - scrollerElement.clientWidth;

	                this.cellInput.element.css("max-width", viewWidth - scrollbarWidth - this.cellInput.element.position().left + "px");
	            }

	            this.trigger("activate");

	            return this;
	        },

	        deactivate: function(noChange) {
	            var cellInput = this.cellInput;

	            if (!this._active) {
	                return;
	            }

	            this._active = false;

	            if (!noChange && cellInput.value() != this._value) {
	                this.trigger("change", {
	                    value: cellInput.value(),
	                    range: this._range
	                });
	            }

	            this._rect = null;
	            cellInput.hide();
	            this.trigger("deactivate");
	        },

	        enable: function(enable) {
	            this.barInput.enable(enable);
	            this.cellInput.enable(enable);
	        },

	        barElement: function() {
	            return this.barInput.element;
	        },

	        cellElement: function() {
	            return this.cellInput.element;
	        },

	        focus: function(inputType) {
	            inputType = inputType || "cell";

	            if (inputType === "cell") {
	                this.cellInput.element.focus();
	                this.cellInput.end();
	            } else {
	                this.barInput.element.focus();
	            }
	        },

	        isActive: function() {
	            return this._active;
	        },

	        isFiltered: function() {
	            return this.barInput.popup.visible() || this.cellInput.popup.visible();
	        },

	        canInsertRef: function(isKeyboardAction) {
	            var editor = this.activeEditor();
	            return editor && editor.canInsertRef(isKeyboardAction);
	        },

	        highlightedRefs: function() {
	            var editor = this.activeEditor();
	            var refs = [];

	            if (editor) {
	                refs = editor.highlightedRefs();
	            }

	            return refs;
	        },

	        scale: function() {
	            this.cellInput.scale();
	        },

	        toggleTooltip: function(rect) {
	            this.cellInput.toggleTooltip(notEqual(this._rect, rect));
	        },

	        value: function(value, isArrayFormula) {
	            if (value === undefined) {
	                return this.barInput.value();
	            }

	            if (value === null) {
	                value = "";
	            }

	            this._value = value;

	            this.barInput.value(value);
	            this.cellInput.value(value);

	            this.barInput.element.toggleClass("k-spreadsheet-array-formula", !!isArrayFormula);
	        },

	        insertNewline: function() {
	            this.activeEditor().insertNewline();
	            this.scale();
	        },

	        select: function() {
	            this.activeEditor().select();
	        }
	    });

	    function notEqual(oldRect, newRect) {
	        return oldRect && (oldRect.top !== newRect.top || oldRect.left !== newRect.left);
	    }

	    kendo.spreadsheet.SheetEditor = SheetEditor;
	})(kendo);
	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "6cDV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var componentAnnotations_1 = __webpack_require__("x5ih");
var baseFilter_1 = __webpack_require__("5yUf");
var NumberFilter = (function (_super) {
    __extends(NumberFilter, _super);
    function NumberFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NumberFilter.prototype.modelFromFloatingFilter = function (from) {
        return {
            type: this.filter,
            filter: Number(from),
            filterTo: this.filterNumberTo,
            filterType: 'number'
        };
    };
    NumberFilter.prototype.getApplicableFilterTypes = function () {
        return [baseFilter_1.BaseFilter.EQUALS, baseFilter_1.BaseFilter.NOT_EQUAL, baseFilter_1.BaseFilter.LESS_THAN, baseFilter_1.BaseFilter.LESS_THAN_OR_EQUAL,
            baseFilter_1.BaseFilter.GREATER_THAN, baseFilter_1.BaseFilter.GREATER_THAN_OR_EQUAL, baseFilter_1.BaseFilter.IN_RANGE];
    };
    NumberFilter.prototype.bodyTemplate = function () {
        var translate = this.translate.bind(this);
        return "<div class=\"ag-filter-body\">\n            <div>\n                <input class=\"ag-filter-filter\" id=\"filterText\" type=\"text\" placeholder=\"" + translate('filterOoo') + "\"/>\n            </div>\n             <div class=\"ag-filter-number-to\" id=\"filterNumberToPanel\">\n                <input class=\"ag-filter-filter\" id=\"filterToText\" type=\"text\" placeholder=\"" + translate('filterOoo') + "\"/>\n            </div>\n        </div>";
    };
    NumberFilter.prototype.initialiseFilterBodyUi = function () {
        _super.prototype.initialiseFilterBodyUi.call(this);
        this.filterNumber = null;
        this.eFilterTextField = this.queryForHtmlInputElement("#filterText");
        var debounceMs = this.getDebounceMs(this.filterParams);
        var toDebounce = utils_1.Utils.debounce(this.onTextFieldsChanged.bind(this), debounceMs);
        this.addDestroyableEventListener(this.eFilterTextField, "input", toDebounce);
        this.addDestroyableEventListener(this.eFilterToTextField, "input", toDebounce);
    };
    NumberFilter.prototype.afterGuiAttached = function () {
        this.eFilterTextField.focus();
    };
    NumberFilter.prototype.comparator = function () {
        return function (left, right) {
            if (left === right)
                return 0;
            if (left < right)
                return 1;
            if (left > right)
                return -1;
        };
    };
    NumberFilter.prototype.onTextFieldsChanged = function () {
        var newFilter = this.stringToFloat(this.eFilterTextField.value);
        var newFilterTo = this.stringToFloat(this.eFilterToTextField.value);
        if (this.filterNumber !== newFilter || this.filterNumberTo !== newFilterTo) {
            this.filterNumber = newFilter;
            this.filterNumberTo = newFilterTo;
            this.onFilterChanged();
        }
    };
    NumberFilter.prototype.filterValues = function () {
        return this.filter !== baseFilter_1.BaseFilter.IN_RANGE ?
            this.asNumber(this.filterNumber) :
            [this.asNumber(this.filterNumber), this.asNumber(this.filterNumberTo)];
    };
    NumberFilter.prototype.asNumber = function (value) {
        return utils_1.Utils.isNumeric(value) ? value : null;
    };
    NumberFilter.prototype.stringToFloat = function (value) {
        var filterText = utils_1.Utils.makeNull(value);
        if (filterText && filterText.trim() === '') {
            filterText = null;
        }
        var newFilter;
        if (filterText !== null && filterText !== undefined) {
            newFilter = parseFloat(filterText);
        }
        else {
            newFilter = null;
        }
        return newFilter;
    };
    NumberFilter.prototype.setFilter = function (filter) {
        filter = utils_1.Utils.makeNull(filter);
        if (filter !== null && !(typeof filter === 'number')) {
            filter = parseFloat(filter);
        }
        this.filterNumber = filter;
        this.eFilterTextField.value = filter;
    };
    NumberFilter.prototype.setFilterTo = function (filter) {
        filter = utils_1.Utils.makeNull(filter);
        if (filter !== null && !(typeof filter === 'number')) {
            filter = parseFloat(filter);
        }
        this.filterNumberTo = filter;
        this.eFilterToTextField.value = filter;
    };
    NumberFilter.prototype.getFilter = function () {
        return this.filterNumber;
    };
    NumberFilter.prototype.serialize = function () {
        return {
            type: this.filter ? this.filter : this.defaultFilter,
            filter: this.filterNumber,
            filterTo: this.filterNumberTo,
            filterType: 'number'
        };
    };
    NumberFilter.prototype.parse = function (model) {
        this.setFilterType(model.type);
        this.setFilter(model.filter);
        this.setFilterTo(model.filterTo);
    };
    NumberFilter.prototype.refreshFilterBodyUi = function () {
        var visible = this.filter === NumberFilter.IN_RANGE;
        utils_1.Utils.setVisible(this.eNumberToPanel, visible);
    };
    NumberFilter.prototype.resetState = function () {
        this.setFilterType(this.defaultFilter);
        this.setFilter(null);
        this.setFilterTo(null);
    };
    NumberFilter.prototype.setType = function (filterType) {
        this.setFilterType(filterType);
    };
    NumberFilter.LESS_THAN = 'lessThan'; //3;
    __decorate([
        componentAnnotations_1.QuerySelector('#filterNumberToPanel'),
        __metadata("design:type", HTMLElement)
    ], NumberFilter.prototype, "eNumberToPanel", void 0);
    __decorate([
        componentAnnotations_1.QuerySelector('#filterToText'),
        __metadata("design:type", HTMLInputElement)
    ], NumberFilter.prototype, "eFilterToTextField", void 0);
    return NumberFilter;
}(baseFilter_1.ScalarBaseFilter));
exports.NumberFilter = NumberFilter;


/***/ }),

/***/ "6har":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(931);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 887:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(887) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {
	    var kendo = window.kendo;
	    var Widget = kendo.ui.Widget;
	    var keys = kendo.keys;
	    var proxy = $.proxy;

	    var NS = ".kendoNavigator";

	    // Helper functions =======================================================
	    function button(dir) {
	       return kendo.format(
	           '<button class="k-button k-navigator-{0}" aria-label="move {0}">' +
	               '<span class="k-icon k-i-arrow-60-{0}"></span>' +
	           '</button>', dir);
	    }

	    var BUTTONS = button("up") + button("right") + button("down") + button("left");

	    var Navigator = Widget.extend({
	        init: function(element, options) {
	            Widget.fn.init.call(this, element, options);
	            this._initOptions(options);

	            this.element.addClass("k-widget k-navigator")
	                        .append(BUTTONS)
	                        .on("click" + NS, ".k-button", proxy(this, "_click"));

	            var parentElement = this.element.parent().closest("[" + kendo.attr("role") + "]");
	            this._keyroot = parentElement.length > 0 ? parentElement : this.element;
	            this._tabindex(this._keyroot);

	            this._keydown = proxy(this._keydown, this);
	            this._keyroot.on("keydown", this._keydown);
	        },

	        options: {
	            name: "Navigator",
	            panStep: 1
	        },

	        events: [
	            "pan"
	        ],

	        dispose: function() {
	            this._keyroot.off("keydown", this._keydown);
	        },

	        _pan: function(x, y) {
	            var panStep = this.options.panStep;
	            this.trigger("pan", {
	                x: x * panStep,
	                y: y * panStep
	            });
	        },

	        _click: function(e) {
	            var x = 0;
	            var y = 0;
	            var button = $(e.currentTarget);

	            if (button.is(".k-navigator-up")) {
	                y = 1;
	            } else if (button.is(".k-navigator-down")) {
	                y = -1;
	            } else if (button.is(".k-navigator-right")) {
	                x = 1;
	            } else if (button.is(".k-navigator-left")) {
	                x = -1;
	            }

	            this._pan(x, y);
	            e.preventDefault();
	        },

	        _keydown: function(e) {
	            switch (e.which) {
	                case keys.UP:
	                    this._pan(0, 1);
	                    e.preventDefault();
	                    break;

	                case keys.DOWN:
	                    this._pan(0, -1);
	                    e.preventDefault();
	                    break;

	                case keys.RIGHT:
	                    this._pan(1, 0);
	                    e.preventDefault();
	                    break;

	                case keys.LEFT:
	                    this._pan(-1, 0);
	                    e.preventDefault();
	                    break;
	            }
	        }
	    });

	    // Exports ================================================================
	    kendo.dataviz.ui.plugin(Navigator);

	})(window.kendo.jQuery);

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "6iBx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultColumnTypes = {
    "numericColumn": {
        "headerClass": "ag-numeric-header",
        "cellClass": "ag-numeric-cell"
    }
};


/***/ }),

/***/ "7+uW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.13
 * (c) 2014-2017 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind, faster than native
 */
function bind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }
  // record original fn length
  boundFn._length = fn.length;
  return boundFn
}

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */


// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode, deep) {
  var componentOptions = vnode.componentOptions;
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  if (deep) {
    if (vnode.children) {
      cloned.children = cloneVNodes(vnode.children, true);
    }
    if (componentOptions && componentOptions.children) {
      componentOptions.children = cloneVNodes(componentOptions.children, true);
    }
  }
  return cloned
}

function cloneVNodes (vnodes, deep) {
  var len = vnodes.length;
  var res = new Array(len);
  for (var i = 0; i < len; i++) {
    res[i] = cloneVNode(vnodes[i], deep);
  }
  return res
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);[
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
].forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * By default, when a reactive property is set, the new value is
 * also converted to become reactive. However when passing down props,
 * we don't want to force conversion because the value may be a nested value
 * under a frozen data structure. Converting it would defeat the optimization.
 */
var observerState = {
  shouldConvert: true
};

/**
 * Observer class that are attached to each observed
 * object. Once attached, the observer converts target
 * object's property keys into getter/setters that
 * collect dependencies and dispatches updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i], obj[keys[i]]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    observerState.shouldConvert &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'can only contain alphanumeric characters and the hyphen, ' +
      'and must start with a letter.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // handle boolean props
  if (isType(Boolean, prop.type)) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (!isType(String, prop.type) && (value === '' || value === hyphenate(key))) {
      value = true;
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldConvert = observerState.shouldConvert;
    observerState.shouldConvert = true;
    observe(value);
    observerState.shouldConvert = prevShouldConvert;
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isType (type, fn) {
  if (!Array.isArray(fn)) {
    return getType(fn) === getType(type)
  }
  for (var i = 0, len = fn.length; i < len; i++) {
    if (getType(fn[i]) === getType(type)) {
      return true
    }
  }
  /* istanbul ignore next */
  return false
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both micro and macro tasks.
// In < 2.4 we used micro tasks everywhere, but there are some scenarios where
// micro tasks have too high a priority and fires in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using macro tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use micro task by default, but expose a way to force macro task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) Task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine MicroTask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a Task instead of a MicroTask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' &&
    Proxy.toString().match(/native code/);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val)) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, def, cur, old, event;
  for (name in on) {
    def = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    /* istanbul ignore if */
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = (parentVnode.data && parentVnode.data.attrs) || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    observerState.shouldConvert = false;
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      props[key] = validateProp(key, vm.$options.props, propsData, vm);
    }
    observerState.shouldConvert = true;
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  if (listeners) {
    var oldListeners = vm.$options._parentListeners;
    vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, oldListeners);
  }
  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  observerState.shouldConvert = isRoot;
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  observerState.shouldConvert = true;
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  keyOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(keyOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    observerState.shouldConvert = false;
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    observerState.shouldConvert = true;
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject).filter(function (key) {
        /* istanbul ignore next */
        return Object.getOwnPropertyDescriptor(inject, key).enumerable
      })
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && provideKey in source._provided) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (false) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInAlias,
  eventKeyName
) {
  var keyCodes = config.keyCodes[key] || builtInAlias;
  if (keyCodes) {
    if (Array.isArray(keyCodes)) {
      return keyCodes.indexOf(eventKeyCode) === -1
    } else {
      return keyCodes !== eventKeyCode
    }
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree by doing a shallow clone.
  if (tree && !isInFor) {
    return Array.isArray(tree)
      ? cloneVNodes(tree)
      : cloneVNode(tree)
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm = Object.create(parent);
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    vnode.fnContext = contextVm;
    vnode.fnOptions = options;
    if (data.slot) {
      (vnode.data || (vnode.data = {})).slot = data.slot;
    }
  }

  return vnode
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */




// Register the component hook to weex native render engine.
// The hook will be triggered by native, not javascript.


// Updates the state of the component to weex native render engine.

/*  */

// https://github.com/Hanks10100/weex-native-directive/tree/master/component

// listening on native callback

/*  */

/*  */

// hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (!vnode.componentInstance || vnode.componentInstance._isDestroyed) {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    } else if (vnode.data.keepAlive) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // merge component management hooks onto the placeholder node
  mergeHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  // Weex specific: invoke recycle-list optimized @render function for
  // extracting cell-slot template.
  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
  /* istanbul ignore if */
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var options = {
    _isComponent: true,
    parent: parent,
    _parentVnode: vnode,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function mergeHooks (data) {
  if (!data.hook) {
    data.hook = {};
  }
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var fromParent = data.hook[key];
    var ours = componentVNodeHooks[key];
    data.hook[key] = fromParent ? mergeHook$1(ours, fromParent) : ours;
  }
}

function mergeHook$1 (one, two) {
  return function (a, b, c, d) {
    one(a, b, c, d);
    two(a, b, c, d);
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (isDef(vnode)) {
    if (ns) { applyNS(vnode, ns); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force))) {
        applyNS(child, ns, force);
      }
    }
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (vm._isMounted) {
      // if the parent didn't update, the slot nodes will be the ones from
      // last render. They need to be cloned to ensure "freshness" for this render.
      for (var key in vm.$slots) {
        var slot = vm.$slots[key];
        // _rendered is a flag added by renderSlot, but may not be present
        // if the slot is passed from manually written render functions
        if (slot._rendered || (slot[0] && slot[0].elm)) {
          vm.$slots[key] = cloneVNodes(slot, true /* deep */);
        }
      }
    }

    vm.$scopedSlots = (_parentVnode && _parentVnode.data.scopedSlots) || emptyObject;

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid$1 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$1++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue$3 (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue$3);
stateMixin(Vue$3);
eventsMixin(Vue$3);
lifecycleMixin(Vue$3);
renderMixin(Vue$3);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  watch: {
    include: function include (val) {
      pruneCache(this, function (name) { return matches(val, name); });
    },
    exclude: function exclude (val) {
      pruneCache(this, function (name) { return !matches(val, name); });
    }
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue$3);

Object.defineProperty(Vue$3.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue$3.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

Vue$3.version = '2.5.13';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setAttribute (node, key, val) {
  node.setAttribute(key, val);
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setAttribute: setAttribute
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!key) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;
  function createElm (vnode, insertedVnodeQueue, parentElm, refElm, nested) {
    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }
      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setAttribute(vnode.elm, i, '');
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setAttribute(vnode.elm, i, '');
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setAttribute(vnode.elm, i, '');
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // #7138: IE10 & 11 fires input event when setting placeholder on
      // <textarea>... block the first input event and remove the blocker
      // immediately.
      /* istanbul ignore if */
      if (
        isIE && !isIE9 &&
        el.tagName === 'TEXTAREA' &&
        key === 'placeholder' && !el.__ieph
      ) {
        var blocker = function (e) {
          e.stopImmediatePropagation();
          el.removeEventListener('input', blocker);
        };
        el.addEventListener('input', blocker);
        // $flow-disable-line
        el.__ieph = true; /* IE placeholder patched */
      }
      el.setAttribute(key, value);
    }
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + "," + args)
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
  el.plain = false;
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value) {
  el.attrsMap[name] = value;
  el.attrsList.push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
  el.plain = false;
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (name === 'click') {
    if (modifiers.right) {
      name = 'contextmenu';
      delete modifiers.right;
    } else if (modifiers.middle) {
      name = 'mouseup';
    }
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = { value: value };
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
        "? " + baseValueExpression + ".trim()" +
        ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;



function parseModel (val) {
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + value + "=$$a.concat([$$v]))}" +
      "else{$$i>-1&&(" + value + "=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    if (value$1) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally'
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.lazy) {
      // inputs with lazy should only be updated when not in focus
      return false
    }
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      addTransitionClass(el, toClass);
      removeTransitionClass(el, startClass);
      if (!cb.cancelled && !userWantsControl) {
        if (isValidDuration(explicitEnterDuration)) {
          setTimeout(cb, explicitEnterDuration);
        } else {
          whenTransitionEnds(el, type, cb);
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        addTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled && !userWantsControl) {
          if (isValidDuration(explicitLeaveDuration)) {
            setTimeout(cb, explicitLeaveDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        if (!isAndroid) {
          el.addEventListener('compositionstart', onCompositionStart);
          el.addEventListener('compositionend', onCompositionEnd);
        }
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (value === oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue$3.config.mustUseProp = mustUseProp;
Vue$3.config.isReservedTag = isReservedTag;
Vue$3.config.isReservedAttr = isReservedAttr;
Vue$3.config.getTagNamespace = getTagNamespace;
Vue$3.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue$3.options.directives, platformDirectives);
extend(Vue$3.options.components, platformComponents);

// install platform patch function
Vue$3.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
Vue$3.nextTick(function () {
  if (config.devtools) {
    if (devtools) {
      devtools.emit('init', Vue$3);
    } else if (false) {
      console[console.info ? 'info' : 'log'](
        'Download the Vue Devtools extension for a better development experience:\n' +
        'https://github.com/vuejs/vue-devtools'
      );
    }
  }
  if (false
  ) {
    console[console.info ? 'info' : 'log'](
      "You are running Vue in development mode.\n" +
      "Make sure to turn on production mode when deploying for production.\n" +
      "See more tips at https://vuejs.org/guide/deployment.html"
    );
  }
}, 0);

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
var comment = /^<!--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!--([\s\S]*?)-->/g, '$1')
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /(.*?)\s+(?:in|of)\s+(.*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;



function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function closeElement (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
        // element-scope stuff
        processElement(element, options);
      }

      function checkRootConstraints (el) {
        if (false) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (false) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      closeElement(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var res;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment (text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.attrsList.length;

  processRef(element);
  processSlot(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp)
      );
    }
  }
}

function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '');
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "the \"scope\" attribute for scoped slots have been deprecated and " +
          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
          "can also be used on plain elements in addition to <template> to " +
          "denote scoped slots.",
          true
        );
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
          "(v-for takes higher priority). Use a wrapper <template> for the " +
          "scoped slot to make it clearer.",
          true
        );
      }
      el.slotScope = slotScope;
    }
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget);
      }
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true');
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

/**
 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (map['v-model'] && (map['v-bind:type'] || map[':type'])) {
      var typeBinding = getBindingAttr(el, 'type');
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$2 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$2
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^\s*([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^\s*[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?']|\[".*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*\s*$/;

// keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    /* istanbul ignore if */
    return ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? handler.value + '($event)'
      : isFunctionExpression
        ? ("(" + (handler.value) + ")($event)")
        : handler.value;
    /* istanbul ignore if */
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var code = keyCodes[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(code)) + "," +
    "$event.key)"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */

var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, state.warn)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  slots,
  state
) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
      return genScopedSlot(key, slots[key], state)
    }).join(',')) + "])")
}

function genScopedSlot (
  key,
  el,
  state
) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state)
  }
  var fn = "function(" + (String(el.slotScope)) + "){" +
    "return " + (el.tag === 'template'
      ? el.if
        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  return ("{key:" + key + ",fn:" + fn + "}")
}

function genForScopedSlot (
  key,
  el,
  state
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el, state)) +
    '})'
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return (altGenElement || genElement)(el$1, state)
    }
    var normalizationType = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    /* istanbul ignore if */
    {
      res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
    }
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (
  ident,
  type,
  text,
  errors
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
    }
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
      );
    } else {
      errors.push(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n"
      );
    }
  }
}

/*  */

function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        warn$$1(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if (false) {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue$3.prototype.$mount;
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue$3.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["default"] = (Vue$3);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("162o").setImmediate))

/***/ }),

/***/ "76ON":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1028);
	module.exports = __webpack_require__(1028);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1028:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {
	    var kendo = window.kendo,
	        extend = $.extend,
	        data = kendo.data,
	        Node = data.Node,
	        HierarchicalDataSource = data.HierarchicalDataSource,
	        DataSource = data.DataSource;

	    extend(true, kendo.data, {
	        schemas: {
	            "filemanager": {
	                data: function(data) {
	                    return data.items || data || [];
	                },
	                model: {
	                    id: "path",
	                    hasChildren: "hasDirectories",
	                    fields: {
	                        name: {editable: true, type: "String", defaultValue: "New Folder" },
	                        size: {editable: false, type: "Number"},
	                        path: {editable: false, type: "String"},
	                        extension: {editable: false, type: "String"},
	                        isDirectory: {editable: false, defaultValue: true, type: "Boolean"},
	                        hasDirectories: {editable: false, defaultValue: false, type: "Boolean"},
	                        created: { type: "Date", editable: false},
	                        createdUtc: { type: "Date", editable: false },
	                        modified: { type: "Date", editable: false},
	                        modifiedUtc: { type: "Date", editable: false }
	                    }
	                }
	            }
	        }
	    });

	    var FileEntry = Node.define({
	        init: function(value){
	            var that = this,
	                isDirectory = this.isDirectory;

	            Node.fn.init.call(this, value);

	            if(typeof isDirectory === "string"){
	            isDirectory = kendo.getter(isDirectory);
	            }

	            if (kendo.isFunction(isDirectory)) {
	                var isDirectoryObject = isDirectory.call(that, that);

	                if(isDirectoryObject && isDirectoryObject.length === 0){
	                    that.isDirectory = false;
	                } else{
	                    that.isDirectory = !!isDirectoryObject;
	                }
	            }

	            if (that.isDirectory) {
	                that._initChildren();
	            }
	        },
	        _initChildren: function() {
	            var that = this;
	            var children, transport, parameterMap;

	            if (!(that.children instanceof kendo.data.FileManagerDataSource)) {
	                children = that.children = new kendo.data.FileManagerDataSource(that._childrenOptions);

	                transport = children.transport;
	                parameterMap = transport.parameterMap;

	                transport.parameterMap = function(data, type) {
	                    if(type === "read" || type === "create") {
	                        data.target = that.id;
	                    }

	                    if (parameterMap) {
	                        data = parameterMap.call(that, data, type);
	                    }

	                    return data;
	                };

	                children.parent = function(){
	                    return that;
	                };

	                children.bind("change", function(e){
	                    e.node = e.node || that;
	                    that.trigger("change", e);
	                });

	                children.bind("error", function(e){
	                    var collection = that.parent();

	                    if (collection) {
	                        e.node = e.node || that;
	                        collection.trigger("error", e);
	                    }
	                });

	                that._updateChildrenField();
	            }
	        },
	        isNew: function() {
	            if(this.fileManagerNewItem) {
	                delete this.fileManagerNewItem;
	                return true;
	            }

	            return this.id === this._defaultId;
	        }
	    });


	    var FileManagerDataSource = HierarchicalDataSource.extend({
	        init: function(options) {
	            var fileEntry = FileEntry.define({
	                children: options
	            });

	            if(options.filter && !options.serverFiltering){
	                this._hierarchicalFilter = options.filter;
	                options.filter = null;
	            }

	            DataSource.fn.init.call(this, $.extend(true, {}, { schema: { modelBase: fileEntry, model: fileEntry } }, options));

	            this.isLocalBinding = this.transport instanceof kendo.data.LocalTransport;

	            this._attachBubbleHandlers();
	        },
	        insert: function(index, model) {
	            var parentNode = this.parent();

	            if (parentNode && parentNode._initChildren) {
	                if(model && model.isDirectory) {
	                    parentNode.hasDirectories = true;
	                }
	                parentNode.hasChildren = true;
	                parentNode._initChildren();
	            }

	            return DataSource.fn.insert.call(this, index, model);
	        },
	        remove: function(node){
	            var that = this,
	                parentNode = node.parentNode(),
	                dataSource = that,
	                result;

	            if (parentNode && parentNode._initChildren) {
	                dataSource = parentNode.children;
	            }

	            that._cleanDestroyed(node);

	            result = DataSource.fn.remove.call(dataSource, node);

	            if (parentNode && (dataSource.data() && !dataSource.data().length)) {
	                parentNode.hasChildren = false;
	            } else if(parentNode && !this._hasDirectories(parentNode)) {
	                parentNode.hasDirectories = false;
	            }

	            return result;
	        },
	        _cleanDestroyed: function(node){
	            var that = this,
	                dataSource = that;

	            if (node.parentNode && node.parentNode()) {
	                node = node.parentNode();
	                dataSource = node.children;
	                dataSource._destroyed = [];
	                that._cleanDestroyed(node);
	            } else {
	                dataSource._destroyed = [];
	            }
	        },
	        _hasDirectories: function(node){
	            var result;

	            if(!node.children.data()) {
	                return false;
	            }

	            result = node.children.data().filter(function(item){
	                return item.isDirectory;
	            });

	            return !!result.length;
	        }
	    });

	    FileManagerDataSource.create = function(options) {
	        options = options && options.push ? { data: options } : options;

	        var dataSource = options || {},
	            data = dataSource.data;

	        if (data && data._dataSource) {
	            return data._dataSource;
	        }

	        dataSource.data = data;

	        return dataSource instanceof FileManagerDataSource ? dataSource : new FileManagerDataSource(dataSource);
	    };

	    kendo.observableFileManagerData = function(array) {
	        var dataSource = FileManagerDataSource.create({
	            data: array,
	            schema: kendo.data.schemas.filemanager
	        });

	        dataSource.fetch();

	        dataSource._data._dataSource = dataSource;

	        return dataSource._data;
	    };

	    extend(kendo.data, {
	        FileManagerDataSource: FileManagerDataSource,
	        FileEntry: FileEntry
	    });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "77Pl":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("EqjI");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "77lH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var columnGroup_1 = __webpack_require__("YX13");
var column_1 = __webpack_require__("hDyE");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var expressionService_1 = __webpack_require__("1aUC");
var balancedColumnTreeBuilder_1 = __webpack_require__("WPdJ");
var displayedGroupCreator_1 = __webpack_require__("Tttz");
var autoWidthCalculator_1 = __webpack_require__("y9Zr");
var eventService_1 = __webpack_require__("k5uU");
var columnUtils_1 = __webpack_require__("PAC5");
var logger_1 = __webpack_require__("U9Xd");
var events_1 = __webpack_require__("3ok8");
var originalColumnGroup_1 = __webpack_require__("pOb1");
var groupInstanceIdCreator_1 = __webpack_require__("cERj");
var context_1 = __webpack_require__("RQ1/");
var gridPanel_1 = __webpack_require__("inOk");
var columnAnimationService_1 = __webpack_require__("vLqC");
var autoGroupColService_1 = __webpack_require__("uLN9");
var valueCache_1 = __webpack_require__("uKqK");
var gridApi_1 = __webpack_require__("BAow");
var columnApi_1 = __webpack_require__("E/Wy");
var ColumnController = (function () {
    function ColumnController() {
        // header row count, based on user provided columns
        this.primaryHeaderRowCount = 0;
        this.secondaryHeaderRowCount = 0;
        this.secondaryColumnsPresent = false;
        // header row count, either above, or based on pivoting if we are pivoting
        this.gridHeaderRowCount = 0;
        // these are the lists used by the rowRenderer to render nodes. almost the leaf nodes of the above
        // displayed trees, however it also takes into account if the groups are open or not.
        this.displayedLeftColumns = [];
        this.displayedRightColumns = [];
        this.displayedCenterColumns = [];
        // all three lists above combined
        this.allDisplayedColumns = [];
        // same as above, except trimmed down to only columns within the viewport
        this.allDisplayedVirtualColumns = [];
        this.allDisplayedCenterVirtualColumns = [];
        this.rowGroupColumns = [];
        this.valueColumns = [];
        this.pivotColumns = [];
        this.ready = false;
        this.autoGroupsNeedBuilding = false;
        this.pivotMode = false;
        this.bodyWidth = 0;
        this.leftWidth = 0;
        this.rightWidth = 0;
        this.bodyWidthDirty = true;
    }
    ColumnController.prototype.init = function () {
        var pivotMode = this.gridOptionsWrapper.isPivotMode();
        if (this.isPivotSettingAllowed(pivotMode)) {
            this.pivotMode = pivotMode;
        }
        this.usingTreeData = this.gridOptionsWrapper.isTreeData();
    };
    ColumnController.prototype.setVirtualViewportLeftAndRight = function () {
        if (this.gridOptionsWrapper.isEnableRtl()) {
            this.viewportLeft = this.bodyWidth - this.scrollPosition - this.scrollWidth;
            this.viewportRight = this.bodyWidth - this.scrollPosition;
        }
        else {
            this.viewportLeft = this.scrollPosition;
            this.viewportRight = this.scrollWidth + this.scrollPosition;
        }
    };
    // used by clipboard service, to know what columns to paste into
    ColumnController.prototype.getDisplayedColumnsStartingAt = function (column) {
        var currentColumn = column;
        var result = [];
        while (utils_1.Utils.exists(currentColumn)) {
            result.push(currentColumn);
            currentColumn = this.getDisplayedColAfter(currentColumn);
        }
        return result;
    };
    // checks what columns are currently displayed due to column virtualisation. fires an event
    // if the list of columns has changed.
    // + setColumnWidth(), setVirtualViewportPosition(), setColumnDefs(), sizeColumnsToFit()
    ColumnController.prototype.checkDisplayedVirtualColumns = function () {
        // check displayCenterColumnTree exists first, as it won't exist when grid is initialising
        if (utils_1.Utils.exists(this.displayedCenterColumns)) {
            var hashBefore = this.allDisplayedVirtualColumns.map(function (column) { return column.getId(); }).join('#');
            this.updateVirtualSets();
            var hashAfter = this.allDisplayedVirtualColumns.map(function (column) { return column.getId(); }).join('#');
            if (hashBefore !== hashAfter) {
                var event_1 = {
                    type: events_1.Events.EVENT_VIRTUAL_COLUMNS_CHANGED,
                    api: this.gridApi,
                    columnApi: this.columnApi
                };
                this.eventService.dispatchEvent(event_1);
            }
        }
    };
    ColumnController.prototype.setVirtualViewportPosition = function (scrollWidth, scrollPosition) {
        if (scrollWidth !== this.scrollWidth || scrollPosition !== this.scrollPosition || this.bodyWidthDirty) {
            this.scrollWidth = scrollWidth;
            this.scrollPosition = scrollPosition;
            // we need to call setVirtualViewportLeftAndRight() at least once after the body width changes,
            // as the viewport can stay the same, but in RTL, if body width changes, we need to work out the
            // virtual columns again
            this.bodyWidthDirty = true;
            this.setVirtualViewportLeftAndRight();
            if (this.ready) {
                this.checkDisplayedVirtualColumns();
            }
        }
    };
    ColumnController.prototype.isPivotMode = function () {
        return this.pivotMode;
    };
    ColumnController.prototype.isPivotSettingAllowed = function (pivot) {
        if (pivot) {
            if (this.gridOptionsWrapper.isTreeData()) {
                console.warn("ag-Grid: Pivot mode not available in conjunction Tree Data i.e. 'gridOptions.treeData: true'");
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return true;
        }
    };
    ColumnController.prototype.setPivotMode = function (pivotMode, source) {
        if (source === void 0) { source = "api"; }
        if (pivotMode === this.pivotMode) {
            return;
        }
        if (!this.isPivotSettingAllowed(this.pivotMode)) {
            return;
        }
        this.pivotMode = pivotMode;
        this.updateDisplayedColumns(source);
        var event = {
            type: events_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(event);
    };
    ColumnController.prototype.getSecondaryPivotColumn = function (pivotKeys, valueColKey) {
        if (!this.secondaryColumnsPresent) {
            return null;
        }
        var valueColumnToFind = this.getPrimaryColumn(valueColKey);
        var foundColumn = null;
        this.secondaryColumns.forEach(function (column) {
            var thisPivotKeys = column.getColDef().pivotKeys;
            var pivotValueColumn = column.getColDef().pivotValueColumn;
            var pivotKeyMatches = utils_1.Utils.compareArrays(thisPivotKeys, pivotKeys);
            var pivotValueMatches = pivotValueColumn === valueColumnToFind;
            if (pivotKeyMatches && pivotValueMatches) {
                foundColumn = column;
            }
        });
        return foundColumn;
    };
    ColumnController.prototype.setBeans = function (loggerFactory) {
        this.logger = loggerFactory.create('ColumnController');
    };
    ColumnController.prototype.setFirstRightAndLastLeftPinned = function (source) {
        var lastLeft;
        var firstRight;
        if (this.gridOptionsWrapper.isEnableRtl()) {
            lastLeft = this.displayedLeftColumns ? this.displayedLeftColumns[0] : null;
            firstRight = this.displayedRightColumns ? this.displayedRightColumns[this.displayedRightColumns.length - 1] : null;
        }
        else {
            lastLeft = this.displayedLeftColumns ? this.displayedLeftColumns[this.displayedLeftColumns.length - 1] : null;
            firstRight = this.displayedRightColumns ? this.displayedRightColumns[0] : null;
        }
        this.gridColumns.forEach(function (column) {
            column.setLastLeftPinned(column === lastLeft, source);
            column.setFirstRightPinned(column === firstRight, source);
        });
    };
    ColumnController.prototype.autoSizeColumns = function (keys, source) {
        // because of column virtualisation, we can only do this function on columns that are
        // actually rendered, as non-rendered columns (outside the viewport and not rendered
        // due to column virtualisation) are not present. this can result in all rendered columns
        // getting narrowed, which in turn introduces more rendered columns on the RHS which
        // did not get autosized in the original run, leaving the visible grid with columns on
        // the LHS sized, but RHS no. so we keep looping through teh visible columns until
        // no more cols are available (rendered) to be resized
        var _this = this;
        if (source === void 0) { source = "api"; }
        // keep track of which cols we have resized in here
        var columnsAutosized = [];
        // initialise with anything except 0 so that while loop executs at least once
        var changesThisTimeAround = -1;
        while (changesThisTimeAround !== 0) {
            changesThisTimeAround = 0;
            this.actionOnGridColumns(keys, function (column) {
                // if already autosized, skip it
                if (columnsAutosized.indexOf(column) >= 0) {
                    return;
                }
                // get how wide this col should be
                var preferredWidth = _this.autoWidthCalculator.getPreferredWidthForColumn(column);
                // preferredWidth = -1 if this col is not on the screen
                if (preferredWidth > 0) {
                    var newWidth = _this.normaliseColumnWidth(column, preferredWidth);
                    column.setActualWidth(newWidth, source);
                    columnsAutosized.push(column);
                    changesThisTimeAround++;
                }
                return true;
            }, source);
        }
        if (columnsAutosized.length > 0) {
            var event_2 = {
                type: events_1.Events.EVENT_COLUMN_RESIZED,
                columns: columnsAutosized,
                column: columnsAutosized.length === 1 ? columnsAutosized[0] : null,
                finished: true,
                api: this.gridApi,
                columnApi: this.columnApi,
                source: "autosizeColumns"
            };
            this.eventService.dispatchEvent(event_2);
        }
    };
    ColumnController.prototype.autoSizeColumn = function (key, source) {
        if (source === void 0) { source = "api"; }
        this.autoSizeColumns([key], source);
    };
    ColumnController.prototype.autoSizeAllColumns = function (source) {
        if (source === void 0) { source = "api"; }
        var allDisplayedColumns = this.getAllDisplayedColumns();
        this.autoSizeColumns(allDisplayedColumns, source);
    };
    ColumnController.prototype.getColumnsFromTree = function (rootColumns) {
        var result = [];
        recursiveFindColumns(rootColumns);
        return result;
        function recursiveFindColumns(childColumns) {
            for (var i = 0; i < childColumns.length; i++) {
                var child = childColumns[i];
                if (child instanceof column_1.Column) {
                    result.push(child);
                }
                else if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
                    recursiveFindColumns(child.getChildren());
                }
            }
        }
    };
    ColumnController.prototype.getAllDisplayedColumnGroups = function () {
        if (this.displayedLeftColumnTree && this.displayedRightColumnTree && this.displayedCentreColumnTree) {
            return this.displayedLeftColumnTree
                .concat(this.displayedCentreColumnTree)
                .concat(this.displayedRightColumnTree);
        }
        else {
            return null;
        }
    };
    // + columnSelectPanel
    ColumnController.prototype.getPrimaryColumnTree = function () {
        return this.primaryBalancedTree;
    };
    // + gridPanel -> for resizing the body and setting top margin
    ColumnController.prototype.getHeaderRowCount = function () {
        return this.gridHeaderRowCount;
    };
    // + headerRenderer -> setting pinned body width
    ColumnController.prototype.getLeftDisplayedColumnGroups = function () {
        return this.displayedLeftColumnTree;
    };
    // + headerRenderer -> setting pinned body width
    ColumnController.prototype.getRightDisplayedColumnGroups = function () {
        return this.displayedRightColumnTree;
    };
    // + headerRenderer -> setting pinned body width
    ColumnController.prototype.getCenterDisplayedColumnGroups = function () {
        return this.displayedCentreColumnTree;
    };
    ColumnController.prototype.getDisplayedColumnGroups = function (type) {
        switch (type) {
            case column_1.Column.PINNED_LEFT: return this.getLeftDisplayedColumnGroups();
            case column_1.Column.PINNED_RIGHT: return this.getRightDisplayedColumnGroups();
            default: return this.getCenterDisplayedColumnGroups();
        }
    };
    // gridPanel -> ensureColumnVisible
    ColumnController.prototype.isColumnDisplayed = function (column) {
        return this.getAllDisplayedColumns().indexOf(column) >= 0;
    };
    // + csvCreator
    ColumnController.prototype.getAllDisplayedColumns = function () {
        return this.allDisplayedColumns;
    };
    ColumnController.prototype.getAllDisplayedVirtualColumns = function () {
        return this.allDisplayedVirtualColumns;
    };
    ColumnController.prototype.getDisplayedLeftColumnsForRow = function (rowNode) {
        if (!this.colSpanActive) {
            return this.displayedLeftColumns;
        }
        else {
            return this.getDisplayedColumnsForRow(rowNode, this.displayedLeftColumns);
        }
    };
    ColumnController.prototype.getDisplayedRightColumnsForRow = function (rowNode) {
        if (!this.colSpanActive) {
            return this.displayedRightColumns;
        }
        else {
            return this.getDisplayedColumnsForRow(rowNode, this.displayedRightColumns);
        }
    };
    ColumnController.prototype.getDisplayedColumnsForRow = function (rowNode, displayedColumns, filterCallback, gapBeforeCallback) {
        var result = [];
        var lastConsideredCol = null;
        for (var i = 0; i < displayedColumns.length; i++) {
            var col = displayedColumns[i];
            var colSpan = col.getColSpan(rowNode);
            if (colSpan > 1) {
                var colsToRemove = colSpan - 1;
                i += colsToRemove;
            }
            var filterPasses = filterCallback ? filterCallback(col) : true;
            if (filterPasses) {
                var gapBeforeColumn = gapBeforeCallback ? gapBeforeCallback(col) : false;
                var addInPreviousColumn = result.length === 0 && gapBeforeColumn && lastConsideredCol;
                if (addInPreviousColumn) {
                    result.push(lastConsideredCol);
                }
                result.push(col);
            }
            lastConsideredCol = col;
        }
        return result;
    };
    // + rowRenderer
    // if we are not column spanning, this just returns back the virtual centre columns,
    // however if we are column spanning, then different rows can have different virtual
    // columns, so we have to work out the list for each individual row.
    ColumnController.prototype.getAllDisplayedCenterVirtualColumnsForRow = function (rowNode) {
        var _this = this;
        if (!this.colSpanActive) {
            return this.allDisplayedCenterVirtualColumns;
        }
        var gapBeforeCallback = function (col) { return col.getLeft() > _this.viewportLeft; };
        return this.getDisplayedColumnsForRow(rowNode, this.displayedCenterColumns, this.isColumnInViewport.bind(this), gapBeforeCallback);
    };
    ColumnController.prototype.isColumnInViewport = function (col) {
        var columnLeft = col.getLeft();
        var columnRight = col.getLeft() + col.getActualWidth();
        var columnToMuchLeft = columnLeft < this.viewportLeft && columnRight < this.viewportLeft;
        var columnToMuchRight = columnLeft > this.viewportRight && columnRight > this.viewportRight;
        return !columnToMuchLeft && !columnToMuchRight;
    };
    // used by:
    // + angularGrid -> setting pinned body width
    // todo: this needs to be cached
    ColumnController.prototype.getPinnedLeftContainerWidth = function () {
        return this.getWidthOfColsInList(this.displayedLeftColumns);
    };
    // todo: this needs to be cached
    ColumnController.prototype.getPinnedRightContainerWidth = function () {
        return this.getWidthOfColsInList(this.displayedRightColumns);
    };
    ColumnController.prototype.updatePrimaryColumnList = function (keys, masterList, actionIsAdd, columnCallback, eventType, source) {
        var _this = this;
        if (source === void 0) { source = "api"; }
        if (utils_1.Utils.missingOrEmpty(keys)) {
            return;
        }
        var atLeastOne = false;
        keys.forEach(function (key) {
            var columnToAdd = _this.getPrimaryColumn(key);
            if (!columnToAdd) {
                return;
            }
            if (actionIsAdd) {
                if (masterList.indexOf(columnToAdd) >= 0) {
                    return;
                }
                masterList.push(columnToAdd);
            }
            else {
                if (masterList.indexOf(columnToAdd) < 0) {
                    return;
                }
                utils_1.Utils.removeFromArray(masterList, columnToAdd);
            }
            columnCallback(columnToAdd);
            atLeastOne = true;
        });
        if (!atLeastOne) {
            return;
        }
        if (this.autoGroupsNeedBuilding) {
            this.updateGridColumns();
        }
        this.updateDisplayedColumns(source);
        var event = {
            type: eventType,
            columns: masterList,
            column: masterList.length === 1 ? masterList[0] : null,
            api: this.gridApi,
            columnApi: this.columnApi,
            source: source
        };
        this.eventService.dispatchEvent(event);
    };
    ColumnController.prototype.setRowGroupColumns = function (colKeys, source) {
        if (source === void 0) { source = "api"; }
        this.autoGroupsNeedBuilding = true;
        this.setPrimaryColumnList(colKeys, this.rowGroupColumns, events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.setRowGroupActive.bind(this), source);
    };
    ColumnController.prototype.setRowGroupActive = function (active, column, source) {
        if (active === column.isRowGroupActive()) {
            return;
        }
        column.setRowGroupActive(active, source);
        if (!active) {
            column.setVisible(true, source);
        }
    };
    ColumnController.prototype.addRowGroupColumn = function (key, source) {
        if (source === void 0) { source = "api"; }
        this.addRowGroupColumns([key], source);
    };
    ColumnController.prototype.addRowGroupColumns = function (keys, source) {
        if (source === void 0) { source = "api"; }
        this.autoGroupsNeedBuilding = true;
        this.updatePrimaryColumnList(keys, this.rowGroupColumns, true, this.setRowGroupActive.bind(this, true), events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, source);
    };
    ColumnController.prototype.removeRowGroupColumns = function (keys, source) {
        if (source === void 0) { source = "api"; }
        this.autoGroupsNeedBuilding = true;
        this.updatePrimaryColumnList(keys, this.rowGroupColumns, false, this.setRowGroupActive.bind(this, false), events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, source);
    };
    ColumnController.prototype.removeRowGroupColumn = function (key, source) {
        if (source === void 0) { source = "api"; }
        this.removeRowGroupColumns([key], source);
    };
    ColumnController.prototype.addPivotColumns = function (keys, source) {
        if (source === void 0) { source = "api"; }
        this.updatePrimaryColumnList(keys, this.pivotColumns, true, function (column) { return column.setPivotActive(true, source); }, events_1.Events.EVENT_COLUMN_PIVOT_CHANGED, source);
    };
    ColumnController.prototype.setPivotColumns = function (colKeys, source) {
        if (source === void 0) { source = "api"; }
        this.setPrimaryColumnList(colKeys, this.pivotColumns, events_1.Events.EVENT_COLUMN_PIVOT_CHANGED, function (added, column) {
            column.setPivotActive(added, source);
        }, source);
    };
    ColumnController.prototype.addPivotColumn = function (key, source) {
        if (source === void 0) { source = "api"; }
        this.addPivotColumns([key], source);
    };
    ColumnController.prototype.removePivotColumns = function (keys, source) {
        if (source === void 0) { source = "api"; }
        this.updatePrimaryColumnList(keys, this.pivotColumns, false, function (column) { return column.setPivotActive(false, source); }, events_1.Events.EVENT_COLUMN_PIVOT_CHANGED, source);
    };
    ColumnController.prototype.removePivotColumn = function (key, source) {
        if (source === void 0) { source = "api"; }
        this.removePivotColumns([key], source);
    };
    ColumnController.prototype.setPrimaryColumnList = function (colKeys, masterList, eventName, columnCallback, source) {
        var _this = this;
        masterList.length = 0;
        if (utils_1.Utils.exists(colKeys)) {
            colKeys.forEach(function (key) {
                var column = _this.getPrimaryColumn(key);
                masterList.push(column);
            });
        }
        this.primaryColumns.forEach(function (column) {
            var added = masterList.indexOf(column) >= 0;
            columnCallback(added, column);
        });
        if (this.autoGroupsNeedBuilding) {
            this.updateGridColumns();
        }
        this.updateDisplayedColumns(source);
        var event = {
            type: eventName,
            columns: masterList,
            column: masterList.length === 1 ? masterList[0] : null,
            api: this.gridApi,
            columnApi: this.columnApi,
            source: source
        };
        this.eventService.dispatchEvent(event);
    };
    ColumnController.prototype.setValueColumns = function (colKeys, source) {
        if (source === void 0) { source = "api"; }
        this.setPrimaryColumnList(colKeys, this.valueColumns, events_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.setValueActive.bind(this), source);
    };
    ColumnController.prototype.setValueActive = function (active, column, source) {
        if (active === column.isValueActive()) {
            return;
        }
        column.setValueActive(active, source);
        if (active && !column.getAggFunc()) {
            var defaultAggFunc = this.aggFuncService.getDefaultAggFunc(column);
            column.setAggFunc(defaultAggFunc);
        }
    };
    ColumnController.prototype.addValueColumns = function (keys, source) {
        if (source === void 0) { source = "api"; }
        this.updatePrimaryColumnList(keys, this.valueColumns, true, this.setValueActive.bind(this, true), events_1.Events.EVENT_COLUMN_VALUE_CHANGED, source);
    };
    ColumnController.prototype.addValueColumn = function (colKey, source) {
        if (source === void 0) { source = "api"; }
        this.addValueColumns([colKey], source);
    };
    ColumnController.prototype.removeValueColumn = function (colKey, source) {
        if (source === void 0) { source = "api"; }
        this.removeValueColumns([colKey], source);
    };
    ColumnController.prototype.removeValueColumns = function (keys, source) {
        if (source === void 0) { source = "api"; }
        this.updatePrimaryColumnList(keys, this.valueColumns, false, this.setValueActive.bind(this, false), events_1.Events.EVENT_COLUMN_VALUE_CHANGED, source);
    };
    // returns the width we can set to this col, taking into consideration min and max widths
    ColumnController.prototype.normaliseColumnWidth = function (column, newWidth) {
        if (newWidth < column.getMinWidth()) {
            newWidth = column.getMinWidth();
        }
        if (column.isGreaterThanMax(newWidth)) {
            newWidth = column.getMaxWidth();
        }
        return newWidth;
    };
    ColumnController.prototype.getPrimaryOrGridColumn = function (key) {
        var column = this.getPrimaryColumn(key);
        if (column) {
            return column;
        }
        else {
            return this.getGridColumn(key);
        }
    };
    ColumnController.prototype.setColumnWidth = function (key, newWidth, finished, source) {
        if (source === void 0) { source = "api"; }
        var column = this.getPrimaryOrGridColumn(key);
        if (!column) {
            return;
        }
        newWidth = this.normaliseColumnWidth(column, newWidth);
        var widthChanged = column.getActualWidth() !== newWidth;
        if (widthChanged) {
            column.setActualWidth(newWidth, source);
            this.setLeftValues(source);
        }
        this.updateBodyWidths();
        this.checkDisplayedVirtualColumns();
        // check for change first, to avoid unnecessary firing of events
        // however we always fire 'finished' events. this is important
        // when groups are resized, as if the group is changing slowly,
        // eg 1 pixel at a time, then each change will fire change events
        // in all the columns in the group, but only one with get the pixel.
        if (finished || widthChanged) {
            var event_3 = {
                type: events_1.Events.EVENT_COLUMN_RESIZED,
                columns: [column],
                column: column,
                finished: finished,
                api: this.gridApi,
                columnApi: this.columnApi,
                source: source
            };
            this.eventService.dispatchEvent(event_3);
        }
    };
    ColumnController.prototype.setColumnAggFunc = function (column, aggFunc, source) {
        if (source === void 0) { source = "api"; }
        column.setAggFunc(aggFunc);
        var event = {
            type: events_1.Events.EVENT_COLUMN_VALUE_CHANGED,
            columns: [column],
            column: column,
            api: this.gridApi,
            columnApi: this.columnApi,
            source: source
        };
        this.eventService.dispatchEvent(event);
    };
    ColumnController.prototype.moveRowGroupColumn = function (fromIndex, toIndex, source) {
        if (source === void 0) { source = "api"; }
        var column = this.rowGroupColumns[fromIndex];
        this.rowGroupColumns.splice(fromIndex, 1);
        this.rowGroupColumns.splice(toIndex, 0, column);
        var event = {
            type: events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED,
            columns: this.rowGroupColumns,
            column: this.rowGroupColumns.length === 1 ? this.rowGroupColumns[0] : null,
            api: this.gridApi,
            columnApi: this.columnApi,
            source: source
        };
        this.eventService.dispatchEvent(event);
    };
    ColumnController.prototype.moveColumns = function (columnsToMoveKeys, toIndex, source) {
        if (source === void 0) { source = "api"; }
        this.columnAnimationService.start();
        if (toIndex > this.gridColumns.length - columnsToMoveKeys.length) {
            console.warn('ag-Grid: tried to insert columns in invalid location, toIndex = ' + toIndex);
            console.warn('ag-Grid: remember that you should not count the moving columns when calculating the new index');
            return;
        }
        // we want to pull all the columns out first and put them into an ordered list
        var columnsToMove = this.getGridColumns(columnsToMoveKeys);
        var failedRules = !this.doesMovePassRules(columnsToMove, toIndex);
        if (failedRules) {
            return;
        }
        utils_1.Utils.moveInArray(this.gridColumns, columnsToMove, toIndex);
        this.updateDisplayedColumns(source);
        var event = {
            type: events_1.Events.EVENT_COLUMN_MOVED,
            columns: columnsToMove,
            column: columnsToMove.length === 1 ? columnsToMove[0] : null,
            toIndex: toIndex,
            api: this.gridApi,
            columnApi: this.columnApi,
            source: source
        };
        this.eventService.dispatchEvent(event);
        this.columnAnimationService.finish();
    };
    ColumnController.prototype.doesMovePassRules = function (columnsToMove, toIndex) {
        // make a copy of what the grid columns would look like after the move
        var proposedColumnOrder = this.gridColumns.slice();
        utils_1.Utils.moveInArray(proposedColumnOrder, columnsToMove, toIndex);
        // then check that the new proposed order of the columns passes all rules
        if (!this.doesMovePassMarryChildren(proposedColumnOrder)) {
            return false;
        }
        if (!this.doesMovePassLockedPositions(proposedColumnOrder)) {
            return false;
        }
        return true;
    };
    ColumnController.prototype.doesMovePassLockedPositions = function (proposedColumnOrder) {
        var foundNonLocked = false;
        var rulePassed = true;
        // go though the cols, see if any non-locked appear before any locked
        proposedColumnOrder.forEach(function (col) {
            if (col.isLockPosition()) {
                if (foundNonLocked) {
                    rulePassed = false;
                }
            }
            else {
                foundNonLocked = true;
            }
        });
        return rulePassed;
    };
    ColumnController.prototype.doesMovePassMarryChildren = function (allColumnsCopy) {
        var rulePassed = true;
        this.columnUtils.depthFirstOriginalTreeSearch(this.gridBalancedTree, function (child) {
            if (!(child instanceof originalColumnGroup_1.OriginalColumnGroup)) {
                return;
            }
            var columnGroup = child;
            var marryChildren = columnGroup.getColGroupDef() && columnGroup.getColGroupDef().marryChildren;
            if (!marryChildren) {
                return;
            }
            var newIndexes = [];
            columnGroup.getLeafColumns().forEach(function (col) {
                var newColIndex = allColumnsCopy.indexOf(col);
                newIndexes.push(newColIndex);
            });
            var maxIndex = Math.max.apply(Math, newIndexes);
            var minIndex = Math.min.apply(Math, newIndexes);
            // spread is how far the first column in this group is away from the last column
            var spread = maxIndex - minIndex;
            var maxSpread = columnGroup.getLeafColumns().length - 1;
            // if the columns
            if (spread > maxSpread) {
                rulePassed = false;
            }
            // console.log(`maxIndex = ${maxIndex}, minIndex = ${minIndex}, spread = ${spread}, maxSpread = ${maxSpread}, fail = ${spread > (count-1)}`)
            // console.log(allColumnsCopy.map( col => col.getColDef().field).join(','));
        });
        return rulePassed;
    };
    ColumnController.prototype.moveColumn = function (key, toIndex, source) {
        if (source === void 0) { source = "api"; }
        this.moveColumns([key], toIndex, source);
    };
    ColumnController.prototype.moveColumnByIndex = function (fromIndex, toIndex, source) {
        if (source === void 0) { source = "api"; }
        var column = this.gridColumns[fromIndex];
        this.moveColumn(column, toIndex, source);
    };
    // used by:
    // + angularGrid -> for setting body width
    // + rowController -> setting main row widths (when inserting and resizing)
    // need to cache this
    ColumnController.prototype.getBodyContainerWidth = function () {
        return this.bodyWidth;
    };
    ColumnController.prototype.getContainerWidth = function (pinned) {
        switch (pinned) {
            case column_1.Column.PINNED_LEFT: return this.leftWidth;
            case column_1.Column.PINNED_RIGHT: return this.rightWidth;
            default: return this.bodyWidth;
        }
    };
    // after setColumnWidth or updateGroupsAndDisplayedColumns
    ColumnController.prototype.updateBodyWidths = function () {
        var newBodyWidth = this.getWidthOfColsInList(this.displayedCenterColumns);
        var newLeftWidth = this.getWidthOfColsInList(this.displayedLeftColumns);
        var newRightWidth = this.getWidthOfColsInList(this.displayedRightColumns);
        // this is used by virtual col calculation, for RTL only, as a change to body width can impact displayed
        // columns, due to RTL inverting the y coordinates
        this.bodyWidthDirty = this.bodyWidth !== newBodyWidth;
        var atLeastOneChanged = this.bodyWidth !== newBodyWidth || this.leftWidth !== newLeftWidth || this.rightWidth !== newRightWidth;
        if (atLeastOneChanged) {
            this.bodyWidth = newBodyWidth;
            this.leftWidth = newLeftWidth;
            this.rightWidth = newRightWidth;
            // when this fires, it is picked up by the gridPanel, which ends up in
            // gridPanel calling setWidthAndScrollPosition(), which in turn calls setVirtualViewportPosition()
            var event_4 = {
                type: events_1.Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED,
                api: this.gridApi,
                columnApi: this.columnApi
            };
            this.eventService.dispatchEvent(event_4);
        }
    };
    // + rowController
    ColumnController.prototype.getValueColumns = function () {
        return this.valueColumns ? this.valueColumns : [];
    };
    // + rowController
    ColumnController.prototype.getPivotColumns = function () {
        return this.pivotColumns ? this.pivotColumns : [];
    };
    // + inMemoryRowModel
    ColumnController.prototype.isPivotActive = function () {
        return this.pivotColumns && this.pivotColumns.length > 0 && this.pivotMode;
    };
    // + toolPanel
    ColumnController.prototype.getRowGroupColumns = function () {
        return this.rowGroupColumns ? this.rowGroupColumns : [];
    };
    // + rowController -> while inserting rows
    ColumnController.prototype.getDisplayedCenterColumns = function () {
        return this.displayedCenterColumns;
    };
    // + rowController -> while inserting rows
    ColumnController.prototype.getDisplayedLeftColumns = function () {
        return this.displayedLeftColumns;
    };
    ColumnController.prototype.getDisplayedRightColumns = function () {
        return this.displayedRightColumns;
    };
    ColumnController.prototype.getDisplayedColumns = function (type) {
        switch (type) {
            case column_1.Column.PINNED_LEFT: return this.getDisplayedLeftColumns();
            case column_1.Column.PINNED_RIGHT: return this.getDisplayedRightColumns();
            default: return this.getDisplayedCenterColumns();
        }
    };
    // used by:
    // + inMemoryRowController -> sorting, building quick filter text
    // + headerRenderer -> sorting (clearing icon)
    ColumnController.prototype.getAllPrimaryColumns = function () {
        return this.primaryColumns;
    };
    ColumnController.prototype.getAllColumnsForQuickFilter = function () {
        return this.columnsForQuickFilter;
    };
    // + moveColumnController
    ColumnController.prototype.getAllGridColumns = function () {
        return this.gridColumns;
    };
    ColumnController.prototype.isEmpty = function () {
        return utils_1.Utils.missingOrEmpty(this.gridColumns);
    };
    ColumnController.prototype.isRowGroupEmpty = function () {
        return utils_1.Utils.missingOrEmpty(this.rowGroupColumns);
    };
    ColumnController.prototype.setColumnVisible = function (key, visible, source) {
        if (source === void 0) { source = "api"; }
        this.setColumnsVisible([key], visible, source);
    };
    ColumnController.prototype.setColumnsVisible = function (keys, visible, source) {
        var _this = this;
        if (source === void 0) { source = "api"; }
        this.columnAnimationService.start();
        this.actionOnGridColumns(keys, function (column) {
            if (column.isVisible() !== visible) {
                column.setVisible(visible, source);
                return true;
            }
            else {
                return false;
            }
        }, source, function () {
            var event = {
                type: events_1.Events.EVENT_COLUMN_VISIBLE,
                visible: visible,
                column: null,
                columns: null,
                api: _this.gridApi,
                columnApi: _this.columnApi,
                source: source
            };
            return event;
        });
        this.columnAnimationService.finish();
    };
    ColumnController.prototype.setColumnPinned = function (key, pinned, source) {
        if (source === void 0) { source = "api"; }
        this.setColumnsPinned([key], pinned, source);
    };
    ColumnController.prototype.setColumnsPinned = function (keys, pinned, source) {
        var _this = this;
        if (source === void 0) { source = "api"; }
        this.columnAnimationService.start();
        var actualPinned;
        if (pinned === true || pinned === column_1.Column.PINNED_LEFT) {
            actualPinned = column_1.Column.PINNED_LEFT;
        }
        else if (pinned === column_1.Column.PINNED_RIGHT) {
            actualPinned = column_1.Column.PINNED_RIGHT;
        }
        else {
            actualPinned = null;
        }
        this.actionOnGridColumns(keys, function (col) {
            if (col.getPinned() !== actualPinned) {
                col.setPinned(actualPinned);
                return true;
            }
            else {
                return false;
            }
        }, source, function () {
            var event = {
                type: events_1.Events.EVENT_COLUMN_PINNED,
                pinned: actualPinned,
                column: null,
                columns: null,
                api: _this.gridApi,
                columnApi: _this.columnApi,
                source: source
            };
            return event;
        });
        this.columnAnimationService.finish();
    };
    // does an action on a set of columns. provides common functionality for looking up the
    // columns based on key, getting a list of effected columns, and then updated the event
    // with either one column (if it was just one col) or a list of columns
    // used by: autoResize, setVisible, setPinned
    ColumnController.prototype.actionOnGridColumns = function (// the column keys this action will be on
        keys, 
        // the action to do - if this returns false, the column was skipped
        // and won't be included in the event
        action, 
        // should return back a column event of the right type
        source, createEvent) {
        var _this = this;
        if (utils_1.Utils.missingOrEmpty(keys)) {
            return;
        }
        var updatedColumns = [];
        keys.forEach(function (key) {
            var column = _this.getGridColumn(key);
            if (!column) {
                return;
            }
            // need to check for false with type (ie !== instead of !=)
            // as not returning anything (undefined) would also be false
            var resultOfAction = action(column);
            if (resultOfAction !== false) {
                updatedColumns.push(column);
            }
        });
        if (updatedColumns.length === 0) {
            return;
        }
        this.updateDisplayedColumns(source);
        if (utils_1.Utils.exists(createEvent)) {
            var event_5 = createEvent();
            event_5.columns = updatedColumns;
            event_5.column = updatedColumns.length === 1 ? updatedColumns[0] : null;
            this.eventService.dispatchEvent(event_5);
        }
    };
    ColumnController.prototype.getDisplayedColBefore = function (col) {
        var allDisplayedColumns = this.getAllDisplayedColumns();
        var oldIndex = allDisplayedColumns.indexOf(col);
        if (oldIndex > 0) {
            return allDisplayedColumns[oldIndex - 1];
        }
        else {
            return null;
        }
    };
    // used by:
    // + rowRenderer -> for navigation
    ColumnController.prototype.getDisplayedColAfter = function (col) {
        var allDisplayedColumns = this.getAllDisplayedColumns();
        var oldIndex = allDisplayedColumns.indexOf(col);
        if (oldIndex < (allDisplayedColumns.length - 1)) {
            return allDisplayedColumns[oldIndex + 1];
        }
        else {
            return null;
        }
    };
    ColumnController.prototype.isPinningLeft = function () {
        return this.displayedLeftColumns.length > 0;
    };
    ColumnController.prototype.isPinningRight = function () {
        return this.displayedRightColumns.length > 0;
    };
    ColumnController.prototype.getPrimaryAndSecondaryAndAutoColumns = function () {
        var result = this.primaryColumns ? this.primaryColumns.slice(0) : [];
        if (utils_1.Utils.exists(this.groupAutoColumns)) {
            this.groupAutoColumns.forEach(function (col) { return result.push(col); });
        }
        if (this.secondaryColumnsPresent) {
            this.secondaryColumns.forEach(function (column) { return result.push(column); });
        }
        return result;
    };
    ColumnController.prototype.createStateItemFromColumn = function (column) {
        var rowGroupIndex = column.isRowGroupActive() ? this.rowGroupColumns.indexOf(column) : null;
        var pivotIndex = column.isPivotActive() ? this.pivotColumns.indexOf(column) : null;
        var aggFunc = column.isValueActive() ? column.getAggFunc() : null;
        var resultItem = {
            colId: column.getColId(),
            hide: !column.isVisible(),
            aggFunc: aggFunc,
            width: column.getActualWidth(),
            pivotIndex: pivotIndex,
            pinned: column.getPinned(),
            rowGroupIndex: rowGroupIndex
        };
        return resultItem;
    };
    ColumnController.prototype.getColumnState = function () {
        if (utils_1.Utils.missing(this.primaryColumns)) {
            return [];
        }
        var columnStateList = this.primaryColumns.map(this.createStateItemFromColumn.bind(this));
        if (!this.pivotMode) {
            this.orderColumnStateList(columnStateList);
        }
        return columnStateList;
    };
    ColumnController.prototype.orderColumnStateList = function (columnStateList) {
        var gridColumnIds = this.gridColumns.map(function (column) { return column.getColId(); });
        columnStateList.sort(function (itemA, itemB) {
            var posA = gridColumnIds.indexOf(itemA.colId);
            var posB = gridColumnIds.indexOf(itemB.colId);
            return posA - posB;
        });
    };
    ColumnController.prototype.resetColumnState = function (source) {
        if (source === void 0) { source = "api"; }
        // we can't use 'allColumns' as the order might of messed up, so get the primary ordered list
        var primaryColumns = this.getColumnsFromTree(this.primaryBalancedTree);
        var state = [];
        if (primaryColumns) {
            primaryColumns.forEach(function (column) {
                state.push({
                    colId: column.getColId(),
                    aggFunc: column.getColDef().aggFunc,
                    hide: column.getColDef().hide,
                    pinned: column.getColDef().pinned,
                    rowGroupIndex: column.getColDef().rowGroupIndex,
                    pivotIndex: column.getColDef().pivotIndex,
                    width: column.getColDef().width
                });
            });
        }
        this.setColumnState(state, source);
    };
    ColumnController.prototype.setColumnState = function (columnState, source) {
        var _this = this;
        if (source === void 0) { source = "api"; }
        if (utils_1.Utils.missingOrEmpty(this.primaryColumns)) {
            return false;
        }
        this.autoGroupsNeedBuilding = true;
        // at the end below, this list will have all columns we got no state for
        var columnsWithNoState = this.primaryColumns.slice();
        this.rowGroupColumns = [];
        this.valueColumns = [];
        this.pivotColumns = [];
        var success = true;
        var rowGroupIndexes = {};
        var pivotIndexes = {};
        if (columnState) {
            columnState.forEach(function (stateItem) {
                var column = _this.getPrimaryColumn(stateItem.colId);
                if (!column) {
                    console.warn('ag-grid: column ' + stateItem.colId + ' not found');
                    success = false;
                }
                else {
                    _this.syncColumnWithStateItem(column, stateItem, rowGroupIndexes, pivotIndexes, source);
                    utils_1.Utils.removeFromArray(columnsWithNoState, column);
                }
            });
        }
        // anything left over, we got no data for, so add in the column as non-value, non-rowGroup and hidden
        columnsWithNoState.forEach(this.syncColumnWithNoState.bind(this));
        // sort the lists according to the indexes that were provided
        this.rowGroupColumns.sort(this.sortColumnListUsingIndexes.bind(this, rowGroupIndexes));
        this.pivotColumns.sort(this.sortColumnListUsingIndexes.bind(this, pivotIndexes));
        this.updateGridColumns();
        if (columnState) {
            var orderOfColIds_1 = columnState.map(function (stateItem) { return stateItem.colId; });
            this.gridColumns.sort(function (colA, colB) {
                var indexA = orderOfColIds_1.indexOf(colA.getId());
                var indexB = orderOfColIds_1.indexOf(colB.getId());
                return indexA - indexB;
            });
        }
        this.updateDisplayedColumns(source);
        var event = {
            type: events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(event);
        return success;
    };
    ColumnController.prototype.sortColumnListUsingIndexes = function (indexes, colA, colB) {
        var indexA = indexes[colA.getId()];
        var indexB = indexes[colB.getId()];
        return indexA - indexB;
    };
    ColumnController.prototype.syncColumnWithNoState = function (column, source) {
        column.setVisible(false, source);
        column.setAggFunc(null);
        column.setPinned(null);
        column.setRowGroupActive(false, source);
        column.setPivotActive(false, source);
        column.setValueActive(false, source);
    };
    ColumnController.prototype.syncColumnWithStateItem = function (column, stateItem, rowGroupIndexes, pivotIndexes, source) {
        // following ensures we are left with boolean true or false, eg converts (null, undefined, 0) all to true
        column.setVisible(!stateItem.hide, source);
        // sets pinned to 'left' or 'right'
        column.setPinned(stateItem.pinned);
        // if width provided and valid, use it, otherwise stick with the old width
        if (stateItem.width >= this.gridOptionsWrapper.getMinColWidth()) {
            column.setActualWidth(stateItem.width, source);
        }
        if (typeof stateItem.aggFunc === 'string') {
            column.setAggFunc(stateItem.aggFunc);
            column.setValueActive(true, source);
            this.valueColumns.push(column);
        }
        else {
            if (utils_1.Utils.exists(stateItem.aggFunc)) {
                console.warn('ag-Grid: stateItem.aggFunc must be a string. if using your own aggregation ' +
                    'functions, register the functions first before using them in get/set state. This is because it is' +
                    'intended for the column state to be stored and retrieved as simple JSON.');
            }
            column.setAggFunc(null);
            column.setValueActive(false, source);
        }
        if (typeof stateItem.rowGroupIndex === 'number') {
            this.rowGroupColumns.push(column);
            column.setRowGroupActive(true, source);
            rowGroupIndexes[column.getId()] = stateItem.rowGroupIndex;
        }
        else {
            column.setRowGroupActive(false, source);
        }
        if (typeof stateItem.pivotIndex === 'number') {
            this.pivotColumns.push(column);
            column.setPivotActive(true, source);
            pivotIndexes[column.getId()] = stateItem.pivotIndex;
        }
        else {
            column.setPivotActive(false, source);
        }
    };
    ColumnController.prototype.getGridColumns = function (keys) {
        return this.getColumns(keys, this.getGridColumn.bind(this));
    };
    ColumnController.prototype.getColumns = function (keys, columnLookupCallback) {
        var foundColumns = [];
        if (keys) {
            keys.forEach(function (key) {
                var column = columnLookupCallback(key);
                if (column) {
                    foundColumns.push(column);
                }
            });
        }
        return foundColumns;
    };
    // used by growGroupPanel
    ColumnController.prototype.getColumnWithValidation = function (key) {
        var column = this.getPrimaryColumn(key);
        if (!column) {
            console.warn('ag-Grid: could not find column ' + column);
        }
        return column;
    };
    ColumnController.prototype.getPrimaryColumn = function (key) {
        return this.getColumn(key, this.primaryColumns);
    };
    ColumnController.prototype.getGridColumn = function (key) {
        return this.getColumn(key, this.gridColumns);
    };
    ColumnController.prototype.getColumn = function (key, columnList) {
        if (!key) {
            return null;
        }
        for (var i = 0; i < columnList.length; i++) {
            if (this.columnsMatch(columnList[i], key)) {
                return columnList[i];
            }
        }
        return this.getAutoColumn(key);
    };
    ColumnController.prototype.getAutoColumn = function (key) {
        var _this = this;
        if (!utils_1.Utils.exists(this.groupAutoColumns) || utils_1.Utils.missing(this.groupAutoColumns)) {
            return null;
        }
        return utils_1.Utils.find(this.groupAutoColumns, function (groupCol) {
            return _this.columnsMatch(groupCol, key);
        });
    };
    ColumnController.prototype.columnsMatch = function (column, key) {
        var columnMatches = column === key;
        var colDefMatches = column.getColDef() === key;
        var idMatches = column.getColId() == key;
        return columnMatches || colDefMatches || idMatches;
    };
    ColumnController.prototype.getDisplayNameForColumn = function (column, location, includeAggFunc) {
        if (includeAggFunc === void 0) { includeAggFunc = false; }
        var headerName = this.getHeaderName(column.getColDef(), column, null, location);
        if (includeAggFunc) {
            return this.wrapHeaderNameWithAggFunc(column, headerName);
        }
        else {
            return headerName;
        }
    };
    ColumnController.prototype.getDisplayNameForColumnGroup = function (columnGroup, location) {
        var colGroupDef = columnGroup.getOriginalColumnGroup().getColGroupDef();
        if (colGroupDef) {
            return this.getHeaderName(colGroupDef, null, columnGroup, location);
        }
        else {
            return null;
        }
    };
    // location is where the column is going to appear, ie who is calling us
    ColumnController.prototype.getHeaderName = function (colDef, column, columnGroup, location) {
        var headerValueGetter = colDef.headerValueGetter;
        if (headerValueGetter) {
            var params = {
                colDef: colDef,
                column: column,
                columnGroup: columnGroup,
                location: location,
                api: this.gridOptionsWrapper.getApi(),
                context: this.gridOptionsWrapper.getContext()
            };
            if (typeof headerValueGetter === 'function') {
                // valueGetter is a function, so just call it
                return headerValueGetter(params);
            }
            else if (typeof headerValueGetter === 'string') {
                // valueGetter is an expression, so execute the expression
                return this.expressionService.evaluate(headerValueGetter, params);
            }
            else {
                console.warn('ag-grid: headerValueGetter must be a function or a string');
                return '';
            }
        }
        else if (colDef.headerName != null) {
            return colDef.headerName;
        }
        else if (colDef.field) {
            return utils_1.Utils.camelCaseToHumanText(colDef.field);
        }
        else {
            return '';
        }
    };
    /*
        private getHeaderGroupName(columnGroup: ColumnGroup): string {
            let colGroupDef = columnGroup.getOriginalColumnGroup().getColGroupDef();
            let headerValueGetter = colGroupDef.headerValueGetter;

            if (headerValueGetter) {
                let params = {
                    columnGroup: columnGroup,
                    colDef: colGroupDef,
                    api: this.gridOptionsWrapper.getApi(),
                    context: this.gridOptionsWrapper.getContext()
                };

                if (typeof headerValueGetter === 'function') {
                    // valueGetter is a function, so just call it
                    return headerValueGetter(params);
                } else if (typeof headerValueGetter === 'string') {
                    // valueGetter is an expression, so execute the expression
                    return this.expressionService.evaluate(headerValueGetter, params);
                } else {
                    console.warn('ag-grid: headerValueGetter must be a function or a string');
                    return '';
                }
            } else {
                return colGroupDef.headerName;
            }
        }
    */
    ColumnController.prototype.wrapHeaderNameWithAggFunc = function (column, headerName) {
        if (this.gridOptionsWrapper.isSuppressAggFuncInHeader()) {
            return headerName;
        }
        // only columns with aggregation active can have aggregations
        var pivotValueColumn = column.getColDef().pivotValueColumn;
        var pivotActiveOnThisColumn = utils_1.Utils.exists(pivotValueColumn);
        var aggFunc = null;
        var aggFuncFound;
        // otherwise we have a measure that is active, and we are doing aggregation on it
        if (pivotActiveOnThisColumn) {
            aggFunc = pivotValueColumn.getAggFunc();
            aggFuncFound = true;
        }
        else {
            var measureActive = column.isValueActive();
            var aggregationPresent = this.pivotMode || !this.isRowGroupEmpty();
            if (measureActive && aggregationPresent) {
                aggFunc = column.getAggFunc();
                aggFuncFound = true;
            }
            else {
                aggFuncFound = false;
            }
        }
        if (aggFuncFound) {
            var aggFuncString = (typeof aggFunc === 'string') ? aggFunc : 'func';
            var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
            var aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
            return aggFuncStringTranslated + "(" + headerName + ")";
        }
        else {
            return headerName;
        }
    };
    // returns the group with matching colId and instanceId. If instanceId is missing,
    // matches only on the colId.
    ColumnController.prototype.getColumnGroup = function (colId, instanceId) {
        if (!colId) {
            return null;
        }
        if (colId instanceof columnGroup_1.ColumnGroup) {
            return colId;
        }
        var allColumnGroups = this.getAllDisplayedColumnGroups();
        var checkInstanceId = typeof instanceId === 'number';
        var result = null;
        this.columnUtils.depthFirstAllColumnTreeSearch(allColumnGroups, function (child) {
            if (child instanceof columnGroup_1.ColumnGroup) {
                var columnGroup = child;
                var matched = void 0;
                if (checkInstanceId) {
                    matched = colId === columnGroup.getGroupId() && instanceId === columnGroup.getInstanceId();
                }
                else {
                    matched = colId === columnGroup.getGroupId();
                }
                if (matched) {
                    result = columnGroup;
                }
            }
        });
        return result;
    };
    ColumnController.prototype.setColumnDefs = function (columnDefs, source) {
        if (source === void 0) { source = "api"; }
        // always invalidate cache on changing columns, as the column id's for the new columns
        // could overlap with the old id's, so the cache would return old values for new columns.
        this.valueCache.expire();
        // NOTE ==================
        // we should be destroying the existing columns and groups if they exist, for example, the original column
        // group adds a listener to the columns, it should be also removing the listeners
        this.autoGroupsNeedBuilding = true;
        var balancedTreeResult = this.balancedColumnTreeBuilder.createBalancedColumnGroups(columnDefs, true);
        this.primaryBalancedTree = balancedTreeResult.balancedTree;
        this.primaryHeaderRowCount = balancedTreeResult.treeDept + 1;
        this.primaryColumns = this.getColumnsFromTree(this.primaryBalancedTree);
        this.extractRowGroupColumns(source);
        this.extractPivotColumns(source);
        this.createValueColumns(source);
        this.updateGridColumns();
        this.updateDisplayedColumns(source);
        this.checkDisplayedVirtualColumns();
        this.ready = true;
        var eventEverythingChanged = {
            type: events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(eventEverythingChanged);
        var newColumnsLoadedEvent = {
            type: events_1.Events.EVENT_NEW_COLUMNS_LOADED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(newColumnsLoadedEvent);
    };
    ColumnController.prototype.isReady = function () {
        return this.ready;
    };
    ColumnController.prototype.extractRowGroupColumns = function (source) {
        var _this = this;
        this.rowGroupColumns.forEach(function (column) { return column.setRowGroupActive(false, source); });
        this.rowGroupColumns = [];
        // pull out items with rowGroupIndex
        this.primaryColumns.forEach(function (column) {
            if (typeof column.getColDef().rowGroupIndex === 'number') {
                _this.rowGroupColumns.push(column);
                column.setRowGroupActive(true, source);
            }
        });
        // then sort them
        this.rowGroupColumns.sort(function (colA, colB) {
            return colA.getColDef().rowGroupIndex - colB.getColDef().rowGroupIndex;
        });
        // now just pull out items rowGroup, they will be added at the end
        // after the indexed ones, but in the order the columns appear
        this.primaryColumns.forEach(function (column) {
            if (column.getColDef().rowGroup) {
                // if user already specified rowGroupIndex then we skip it as this col already included
                if (_this.rowGroupColumns.indexOf(column) >= 0) {
                    return;
                }
                _this.rowGroupColumns.push(column);
                column.setRowGroupActive(true, source);
            }
        });
    };
    ColumnController.prototype.extractPivotColumns = function (source) {
        var _this = this;
        this.pivotColumns.forEach(function (column) { return column.setPivotActive(false, source); });
        this.pivotColumns = [];
        // pull out items with pivotIndex
        this.primaryColumns.forEach(function (column) {
            if (typeof column.getColDef().pivotIndex === 'number') {
                _this.pivotColumns.push(column);
                column.setPivotActive(true, source);
            }
        });
        // then sort them
        this.pivotColumns.sort(function (colA, colB) {
            return colA.getColDef().pivotIndex - colB.getColDef().pivotIndex;
        });
        // now check the boolean equivalent
        this.primaryColumns.forEach(function (column) {
            if (column.getColDef().pivot) {
                // if user already specified pivotIndex then we skip it as this col already included
                if (_this.pivotColumns.indexOf(column) >= 0) {
                    return;
                }
                _this.pivotColumns.push(column);
                column.setPivotActive(true, source);
            }
        });
    };
    ColumnController.prototype.resetColumnGroupState = function (source) {
        if (source === void 0) { source = "api"; }
        var stateItems = [];
        this.columnUtils.depthFirstOriginalTreeSearch(this.primaryBalancedTree, function (child) {
            if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
                var groupState = {
                    groupId: child.getGroupId(),
                    open: child.getColGroupDef().openByDefault
                };
                stateItems.push(groupState);
            }
        });
        this.setColumnGroupState(stateItems, source);
    };
    ColumnController.prototype.getColumnGroupState = function () {
        var columnGroupState = [];
        this.columnUtils.depthFirstOriginalTreeSearch(this.gridBalancedTree, function (node) {
            if (node instanceof originalColumnGroup_1.OriginalColumnGroup) {
                var originalColumnGroup = node;
                columnGroupState.push({
                    groupId: originalColumnGroup.getGroupId(),
                    open: originalColumnGroup.isExpanded()
                });
            }
        });
        return columnGroupState;
    };
    ColumnController.prototype.setColumnGroupState = function (stateItems, source) {
        var _this = this;
        if (source === void 0) { source = "api"; }
        this.columnAnimationService.start();
        var impactedGroups = [];
        stateItems.forEach(function (stateItem) {
            var groupKey = stateItem.groupId;
            var newValue = stateItem.open;
            var originalColumnGroup = _this.getOriginalColumnGroup(groupKey);
            if (!originalColumnGroup) {
                return;
            }
            if (originalColumnGroup.isExpanded() === newValue) {
                return;
            }
            _this.logger.log('columnGroupOpened(' + originalColumnGroup.getGroupId() + ',' + newValue + ')');
            originalColumnGroup.setExpanded(newValue);
            impactedGroups.push(originalColumnGroup);
        });
        this.updateGroupsAndDisplayedColumns(source);
        impactedGroups.forEach(function (originalColumnGroup) {
            var event = {
                type: events_1.Events.EVENT_COLUMN_GROUP_OPENED,
                columnGroup: originalColumnGroup,
                api: _this.gridApi,
                columnApi: _this.columnApi
            };
            _this.eventService.dispatchEvent(event);
        });
        this.columnAnimationService.finish();
    };
    // called by headerRenderer - when a header is opened or closed
    ColumnController.prototype.setColumnGroupOpened = function (key, newValue, source) {
        if (source === void 0) { source = "api"; }
        var keyAsString;
        if (key instanceof originalColumnGroup_1.OriginalColumnGroup) {
            keyAsString = key.getId();
        }
        else {
            keyAsString = key;
        }
        this.setColumnGroupState([{ groupId: keyAsString, open: newValue }], source);
    };
    ColumnController.prototype.getOriginalColumnGroup = function (key) {
        if (key instanceof originalColumnGroup_1.OriginalColumnGroup) {
            return key;
        }
        if (typeof key !== 'string') {
            console.error('ag-Grid: group key must be a string');
        }
        // otherwise, search for the column group by id
        var res = null;
        this.columnUtils.depthFirstOriginalTreeSearch(this.gridBalancedTree, function (node) {
            if (node instanceof originalColumnGroup_1.OriginalColumnGroup) {
                var originalColumnGroup = node;
                if (originalColumnGroup.getId() === key) {
                    res = originalColumnGroup;
                }
            }
        });
        return res;
    };
    ColumnController.prototype.calculateColumnsForDisplay = function () {
        var _this = this;
        var columnsForDisplay;
        if (this.pivotMode && !this.secondaryColumnsPresent) {
            // pivot mode is on, but we are not pivoting, so we only
            // show columns we are aggregating on
            columnsForDisplay = utils_1.Utils.filter(this.gridColumns, function (column) {
                var isAutoGroupCol = _this.groupAutoColumns && _this.groupAutoColumns.indexOf(column) >= 0;
                var isValueCol = _this.valueColumns && _this.valueColumns.indexOf(column) >= 0;
                return isAutoGroupCol || isValueCol;
            });
        }
        else {
            // otherwise continue as normal. this can be working on the primary
            // or secondary columns, whatever the gridColumns are set to
            columnsForDisplay = utils_1.Utils.filter(this.gridColumns, function (column) {
                // keep col if a) it's auto-group or b) it's visible
                var isAutoGroupCol = _this.groupAutoColumns && _this.groupAutoColumns.indexOf(column) >= 0;
                return isAutoGroupCol || column.isVisible();
            });
        }
        return columnsForDisplay;
    };
    ColumnController.prototype.checkColSpanActiveInCols = function (columns) {
        var result = false;
        columns.forEach(function (col) {
            if (utils_1.Utils.exists(col.getColDef().colSpan)) {
                result = true;
            }
        });
        return result;
    };
    ColumnController.prototype.calculateColumnsForGroupDisplay = function () {
        var _this = this;
        this.groupDisplayColumns = [];
        var checkFunc = function (col) {
            var colDef = col.getColDef();
            if (colDef && utils_1.Utils.exists(colDef.showRowGroup)) {
                _this.groupDisplayColumns.push(col);
            }
        };
        this.gridColumns.forEach(checkFunc);
        if (this.groupAutoColumns) {
            this.groupAutoColumns.forEach(checkFunc);
        }
    };
    ColumnController.prototype.getGroupDisplayColumns = function () {
        return this.groupDisplayColumns;
    };
    ColumnController.prototype.updateDisplayedColumns = function (source) {
        var columnsForDisplay = this.calculateColumnsForDisplay();
        this.buildDisplayedTrees(columnsForDisplay);
        this.calculateColumnsForGroupDisplay();
        // this is also called when a group is opened or closed
        this.updateGroupsAndDisplayedColumns(source);
        this.setFirstRightAndLastLeftPinned(source);
    };
    ColumnController.prototype.isSecondaryColumnsPresent = function () {
        return this.secondaryColumnsPresent;
    };
    ColumnController.prototype.setSecondaryColumns = function (colDefs, source) {
        if (source === void 0) { source = "api"; }
        var newColsPresent = colDefs && colDefs.length > 0;
        // if not cols passed, and we had to cols anyway, then do nothing
        if (!newColsPresent && !this.secondaryColumnsPresent) {
            return;
        }
        if (newColsPresent) {
            this.processSecondaryColumnDefinitions(colDefs);
            var balancedTreeResult = this.balancedColumnTreeBuilder.createBalancedColumnGroups(colDefs, false);
            this.secondaryBalancedTree = balancedTreeResult.balancedTree;
            this.secondaryHeaderRowCount = balancedTreeResult.treeDept + 1;
            this.secondaryColumns = this.getColumnsFromTree(this.secondaryBalancedTree);
            this.secondaryColumnsPresent = true;
        }
        else {
            this.secondaryBalancedTree = null;
            this.secondaryHeaderRowCount = -1;
            this.secondaryColumns = null;
            this.secondaryColumnsPresent = false;
        }
        this.updateGridColumns();
        this.updateDisplayedColumns(source);
    };
    ColumnController.prototype.processSecondaryColumnDefinitions = function (colDefs) {
        var columnCallback = this.gridOptionsWrapper.getProcessSecondaryColDefFunc();
        var groupCallback = this.gridOptionsWrapper.getProcessSecondaryColGroupDefFunc();
        if (!columnCallback && !groupCallback) {
            return;
        }
        searchForColDefs(colDefs);
        function searchForColDefs(colDefs2) {
            colDefs2.forEach(function (abstractColDef) {
                var isGroup = utils_1.Utils.exists(abstractColDef.children);
                if (isGroup) {
                    var colGroupDef = abstractColDef;
                    if (groupCallback) {
                        groupCallback(colGroupDef);
                    }
                    searchForColDefs(colGroupDef.children);
                }
                else {
                    var colDef = abstractColDef;
                    if (columnCallback) {
                        columnCallback(colDef);
                    }
                }
            });
        }
    };
    // called from: setColumnState, setColumnDefs, setSecondaryColumns
    ColumnController.prototype.updateGridColumns = function () {
        if (this.secondaryColumns) {
            this.gridBalancedTree = this.secondaryBalancedTree.slice();
            this.gridHeaderRowCount = this.secondaryHeaderRowCount;
            this.gridColumns = this.secondaryColumns.slice();
        }
        else {
            this.gridBalancedTree = this.primaryBalancedTree.slice();
            this.gridHeaderRowCount = this.primaryHeaderRowCount;
            this.gridColumns = this.primaryColumns.slice();
        }
        this.putFixedColumnsFirst();
        this.addAutoGroupToGridColumns();
        this.setupQuickFilterColumns();
        this.clearDisplayedColumns();
        this.colSpanActive = this.checkColSpanActiveInCols(this.gridColumns);
        var event = {
            type: events_1.Events.EVENT_GRID_COLUMNS_CHANGED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(event);
    };
    // if we are using autoGroupCols, then they should be included for quick filter. this covers the
    // following scenarios:
    // a) user provides 'field' into autoGroupCol of normal grid, so now because a valid col to filter leafs on
    // b) using tree data and user depends on autoGroupCol for first col, and we also want to filter on this
    //    (tree data is a bit different, as parent rows can be filtered on, unlike row grouping)
    ColumnController.prototype.setupQuickFilterColumns = function () {
        if (this.groupAutoColumns) {
            this.columnsForQuickFilter = this.primaryColumns.concat(this.groupAutoColumns);
        }
        else {
            this.columnsForQuickFilter = this.primaryColumns;
        }
    };
    ColumnController.prototype.putFixedColumnsFirst = function () {
        var locked = this.gridColumns.filter(function (c) { return c.isLockPosition(); });
        var unlocked = this.gridColumns.filter(function (c) { return !c.isLockPosition(); });
        this.gridColumns = locked.concat(unlocked);
    };
    ColumnController.prototype.addAutoGroupToGridColumns = function () {
        // add in auto-group here
        this.createGroupAutoColumnsIfNeeded();
        if (utils_1.Utils.missing(this.groupAutoColumns)) {
            return;
        }
        this.gridColumns = this.groupAutoColumns.concat(this.gridColumns);
        var autoColBalancedTree = this.balancedColumnTreeBuilder.createForAutoGroups(this.groupAutoColumns, this.gridBalancedTree);
        this.gridBalancedTree = autoColBalancedTree.concat(this.gridBalancedTree);
    };
    // gets called after we copy down grid columns, to make sure any part of the gui
    // that tries to draw, eg the header, it will get empty lists of columns rather
    // than stale columns. for example, the header will received gridColumnsChanged
    // event, so will try and draw, but it will draw successfully when it acts on the
    // virtualColumnsChanged event
    ColumnController.prototype.clearDisplayedColumns = function () {
        this.displayedLeftColumnTree = [];
        this.displayedRightColumnTree = [];
        this.displayedCentreColumnTree = [];
        this.displayedLeftHeaderRows = {};
        this.displayedRightHeaderRows = {};
        this.displayedCentreHeaderRows = {};
        this.displayedLeftColumns = [];
        this.displayedRightColumns = [];
        this.displayedCenterColumns = [];
        this.allDisplayedColumns = [];
        this.allDisplayedVirtualColumns = [];
    };
    ColumnController.prototype.updateGroupsAndDisplayedColumns = function (source) {
        this.updateOpenClosedVisibilityInColumnGroups();
        this.updateDisplayedColumnsFromTrees(source);
        this.updateVirtualSets();
        this.updateBodyWidths();
        // this event is picked up by the gui, headerRenderer and rowRenderer, to recalculate what columns to display
        var event = {
            type: events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(event);
    };
    ColumnController.prototype.updateDisplayedColumnsFromTrees = function (source) {
        this.addToDisplayedColumns(this.displayedLeftColumnTree, this.displayedLeftColumns);
        this.addToDisplayedColumns(this.displayedCentreColumnTree, this.displayedCenterColumns);
        this.addToDisplayedColumns(this.displayedRightColumnTree, this.displayedRightColumns);
        this.setupAllDisplayedColumns();
        this.setLeftValues(source);
    };
    ColumnController.prototype.setupAllDisplayedColumns = function () {
        if (this.gridOptionsWrapper.isEnableRtl()) {
            this.allDisplayedColumns = this.displayedRightColumns
                .concat(this.displayedCenterColumns)
                .concat(this.displayedLeftColumns);
        }
        else {
            this.allDisplayedColumns = this.displayedLeftColumns
                .concat(this.displayedCenterColumns)
                .concat(this.displayedRightColumns);
        }
    };
    // sets the left pixel position of each column
    ColumnController.prototype.setLeftValues = function (source) {
        this.setLeftValuesOfColumns(source);
        this.setLeftValuesOfGroups();
    };
    ColumnController.prototype.setLeftValuesOfColumns = function (source) {
        var _this = this;
        // go through each list of displayed columns
        var allColumns = this.primaryColumns.slice(0);
        // let totalColumnWidth = this.getWidthOfColsInList()
        var doingRtl = this.gridOptionsWrapper.isEnableRtl();
        [this.displayedLeftColumns, this.displayedRightColumns, this.displayedCenterColumns].forEach(function (columns) {
            if (doingRtl) {
                // when doing RTL, we start at the top most pixel (ie RHS) and work backwards
                var left_1 = _this.getWidthOfColsInList(columns);
                columns.forEach(function (column) {
                    left_1 -= column.getActualWidth();
                    column.setLeft(left_1, source);
                });
            }
            else {
                // otherwise normal LTR, we start at zero
                var left_2 = 0;
                columns.forEach(function (column) {
                    column.setLeft(left_2, source);
                    left_2 += column.getActualWidth();
                });
            }
            utils_1.Utils.removeAllFromArray(allColumns, columns);
        });
        // items left in allColumns are columns not displayed, so remove the left position. this is
        // important for the rows, as if a col is made visible, then taken out, then made visible again,
        // we don't want the animation of the cell floating in from the old position, whatever that was.
        allColumns.forEach(function (column) {
            column.setLeft(null, source);
        });
    };
    ColumnController.prototype.setLeftValuesOfGroups = function () {
        // a groups left value is the lest left value of it's children
        [this.displayedLeftColumnTree, this.displayedRightColumnTree, this.displayedCentreColumnTree].forEach(function (columns) {
            columns.forEach(function (column) {
                if (column instanceof columnGroup_1.ColumnGroup) {
                    var columnGroup = column;
                    columnGroup.checkLeft();
                }
            });
        });
    };
    ColumnController.prototype.addToDisplayedColumns = function (displayedColumnTree, displayedColumns) {
        displayedColumns.length = 0;
        this.columnUtils.depthFirstDisplayedColumnTreeSearch(displayedColumnTree, function (child) {
            if (child instanceof column_1.Column) {
                displayedColumns.push(child);
            }
        });
    };
    ColumnController.prototype.updateDisplayedCenterVirtualColumns = function () {
        var skipVirtualisation = this.gridOptionsWrapper.isSuppressColumnVirtualisation() || this.gridOptionsWrapper.isForPrint();
        if (skipVirtualisation) {
            // no virtualisation, so don't filter
            this.allDisplayedCenterVirtualColumns = this.displayedCenterColumns;
        }
        else {
            // filter out what should be visible
            this.allDisplayedCenterVirtualColumns = this.filterOutColumnsWithinViewport();
        }
        this.allDisplayedVirtualColumns = this.allDisplayedCenterVirtualColumns
            .concat(this.displayedLeftColumns)
            .concat(this.displayedRightColumns);
        // return map of virtual col id's, for easy lookup when building the groups.
        // the map will be colId=>true, ie col id's mapping to 'true'.
        var result = {};
        this.allDisplayedVirtualColumns.forEach(function (col) {
            result[col.getId()] = true;
        });
        return result;
    };
    ColumnController.prototype.getVirtualHeaderGroupRow = function (type, dept) {
        var result;
        switch (type) {
            case column_1.Column.PINNED_LEFT:
                result = this.displayedLeftHeaderRows[dept];
                break;
            case column_1.Column.PINNED_RIGHT:
                result = this.displayedRightHeaderRows[dept];
                break;
            default:
                result = this.displayedCentreHeaderRows[dept];
                break;
        }
        if (utils_1.Utils.missing(result)) {
            result = [];
        }
        return result;
    };
    ColumnController.prototype.updateDisplayedVirtualGroups = function (virtualColIds) {
        // go through each group, see if any of it's cols are displayed, and if yes,
        // then this group is included
        this.displayedLeftHeaderRows = {};
        this.displayedRightHeaderRows = {};
        this.displayedCentreHeaderRows = {};
        testGroup(this.displayedLeftColumnTree, this.displayedLeftHeaderRows, 0);
        testGroup(this.displayedRightColumnTree, this.displayedRightHeaderRows, 0);
        testGroup(this.displayedCentreColumnTree, this.displayedCentreHeaderRows, 0);
        function testGroup(children, result, dept) {
            var returnValue = false;
            for (var i = 0; i < children.length; i++) {
                // see if this item is within viewport
                var child = children[i];
                var addThisItem = void 0;
                if (child instanceof column_1.Column) {
                    // for column, test if column is included
                    addThisItem = virtualColIds[child.getId()] === true;
                }
                else {
                    // if group, base decision on children
                    var columnGroup = child;
                    addThisItem = testGroup(columnGroup.getDisplayedChildren(), result, dept + 1);
                }
                if (addThisItem) {
                    returnValue = true;
                    if (!result[dept]) {
                        result[dept] = [];
                    }
                    result[dept].push(child);
                }
            }
            return returnValue;
        }
    };
    ColumnController.prototype.updateVirtualSets = function () {
        var virtualColIds = this.updateDisplayedCenterVirtualColumns();
        this.updateDisplayedVirtualGroups(virtualColIds);
    };
    ColumnController.prototype.filterOutColumnsWithinViewport = function () {
        return utils_1.Utils.filter(this.displayedCenterColumns, this.isColumnInViewport.bind(this));
    };
    // called from api
    ColumnController.prototype.sizeColumnsToFit = function (gridWidth, source) {
        var _this = this;
        if (source === void 0) { source = "api"; }
        // avoid divide by zero
        var allDisplayedColumns = this.getAllDisplayedColumns();
        if (gridWidth <= 0 || allDisplayedColumns.length === 0) {
            return;
        }
        var colsToNotSpread = utils_1.Utils.filter(allDisplayedColumns, function (column) {
            return column.getColDef().suppressSizeToFit === true;
        });
        var colsToSpread = utils_1.Utils.filter(allDisplayedColumns, function (column) {
            return column.getColDef().suppressSizeToFit !== true;
        });
        // make a copy of the cols that are going to be resized
        var colsToFireEventFor = colsToSpread.slice(0);
        var finishedResizing = false;
        while (!finishedResizing) {
            finishedResizing = true;
            var availablePixels = gridWidth - this.getWidthOfColsInList(colsToNotSpread);
            if (availablePixels <= 0) {
                // no width, set everything to minimum
                colsToSpread.forEach(function (column) {
                    column.setMinimum(source);
                });
            }
            else {
                var scale = availablePixels / this.getWidthOfColsInList(colsToSpread);
                // we set the pixels for the last col based on what's left, as otherwise
                // we could be a pixel or two short or extra because of rounding errors.
                var pixelsForLastCol = availablePixels;
                // backwards through loop, as we are removing items as we go
                for (var i = colsToSpread.length - 1; i >= 0; i--) {
                    var column = colsToSpread[i];
                    var newWidth = Math.round(column.getActualWidth() * scale);
                    if (newWidth < column.getMinWidth()) {
                        column.setMinimum(source);
                        moveToNotSpread(column);
                        finishedResizing = false;
                    }
                    else if (column.isGreaterThanMax(newWidth)) {
                        column.setActualWidth(column.getMaxWidth(), source);
                        moveToNotSpread(column);
                        finishedResizing = false;
                    }
                    else {
                        var onLastCol = i === 0;
                        if (onLastCol) {
                            column.setActualWidth(pixelsForLastCol, source);
                        }
                        else {
                            column.setActualWidth(newWidth, source);
                        }
                    }
                    pixelsForLastCol -= newWidth;
                }
            }
        }
        this.setLeftValues(source);
        this.updateBodyWidths();
        colsToFireEventFor.forEach(function (column) {
            var event = {
                type: events_1.Events.EVENT_COLUMN_RESIZED,
                column: column,
                columns: [column],
                finished: true,
                api: _this.gridApi,
                columnApi: _this.columnApi,
                source: "sizeColumnsToFit"
            };
            _this.eventService.dispatchEvent(event);
        });
        function moveToNotSpread(column) {
            utils_1.Utils.removeFromArray(colsToSpread, column);
            colsToNotSpread.push(column);
        }
    };
    ColumnController.prototype.buildDisplayedTrees = function (visibleColumns) {
        var leftVisibleColumns = utils_1.Utils.filter(visibleColumns, function (column) {
            return column.getPinned() === 'left';
        });
        var rightVisibleColumns = utils_1.Utils.filter(visibleColumns, function (column) {
            return column.getPinned() === 'right';
        });
        var centerVisibleColumns = utils_1.Utils.filter(visibleColumns, function (column) {
            return column.getPinned() !== 'left' && column.getPinned() !== 'right';
        });
        var groupInstanceIdCreator = new groupInstanceIdCreator_1.GroupInstanceIdCreator();
        this.displayedLeftColumnTree = this.displayedGroupCreator.createDisplayedGroups(leftVisibleColumns, this.gridBalancedTree, groupInstanceIdCreator, this.displayedLeftColumnTree);
        this.displayedRightColumnTree = this.displayedGroupCreator.createDisplayedGroups(rightVisibleColumns, this.gridBalancedTree, groupInstanceIdCreator, this.displayedRightColumnTree);
        this.displayedCentreColumnTree = this.displayedGroupCreator.createDisplayedGroups(centerVisibleColumns, this.gridBalancedTree, groupInstanceIdCreator, this.displayedCentreColumnTree);
    };
    ColumnController.prototype.updateOpenClosedVisibilityInColumnGroups = function () {
        var allColumnGroups = this.getAllDisplayedColumnGroups();
        this.columnUtils.depthFirstAllColumnTreeSearch(allColumnGroups, function (child) {
            if (child instanceof columnGroup_1.ColumnGroup) {
                var columnGroup = child;
                columnGroup.calculateDisplayedColumns();
            }
        });
    };
    ColumnController.prototype.getGroupAutoColumns = function () {
        return this.groupAutoColumns;
    };
    ColumnController.prototype.createGroupAutoColumnsIfNeeded = function () {
        if (!this.autoGroupsNeedBuilding) {
            return;
        }
        this.autoGroupsNeedBuilding = false;
        // see if we need to insert the default grouping column
        var needAutoColumns = (this.rowGroupColumns.length > 0 || this.usingTreeData)
            && !this.gridOptionsWrapper.isGroupSuppressAutoColumn()
            && !this.gridOptionsWrapper.isGroupUseEntireRow()
            && !this.gridOptionsWrapper.isGroupSuppressRow();
        if (needAutoColumns) {
            this.groupAutoColumns = this.autoGroupColService.createAutoGroupColumns(this.rowGroupColumns);
        }
        else {
            this.groupAutoColumns = null;
        }
    };
    ColumnController.prototype.createValueColumns = function (source) {
        this.valueColumns.forEach(function (column) { return column.setValueActive(false, source); });
        this.valueColumns = [];
        // override with columns that have the aggFunc specified explicitly
        for (var i = 0; i < this.primaryColumns.length; i++) {
            var column = this.primaryColumns[i];
            if (column.getColDef().aggFunc) {
                column.setAggFunc(column.getColDef().aggFunc);
                this.valueColumns.push(column);
                column.setValueActive(true, source);
            }
        }
    };
    ColumnController.prototype.getWidthOfColsInList = function (columnList) {
        var result = 0;
        for (var i = 0; i < columnList.length; i++) {
            result += columnList[i].getActualWidth();
        }
        return result;
    };
    ColumnController.prototype.getGridBalancedTree = function () {
        return this.gridBalancedTree;
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], ColumnController.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('expressionService'),
        __metadata("design:type", expressionService_1.ExpressionService)
    ], ColumnController.prototype, "expressionService", void 0);
    __decorate([
        context_1.Autowired('balancedColumnTreeBuilder'),
        __metadata("design:type", balancedColumnTreeBuilder_1.BalancedColumnTreeBuilder)
    ], ColumnController.prototype, "balancedColumnTreeBuilder", void 0);
    __decorate([
        context_1.Autowired('displayedGroupCreator'),
        __metadata("design:type", displayedGroupCreator_1.DisplayedGroupCreator)
    ], ColumnController.prototype, "displayedGroupCreator", void 0);
    __decorate([
        context_1.Autowired('autoWidthCalculator'),
        __metadata("design:type", autoWidthCalculator_1.AutoWidthCalculator)
    ], ColumnController.prototype, "autoWidthCalculator", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], ColumnController.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('columnUtils'),
        __metadata("design:type", columnUtils_1.ColumnUtils)
    ], ColumnController.prototype, "columnUtils", void 0);
    __decorate([
        context_1.Autowired('gridPanel'),
        __metadata("design:type", gridPanel_1.GridPanel)
    ], ColumnController.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], ColumnController.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('columnAnimationService'),
        __metadata("design:type", columnAnimationService_1.ColumnAnimationService)
    ], ColumnController.prototype, "columnAnimationService", void 0);
    __decorate([
        context_1.Autowired('autoGroupColService'),
        __metadata("design:type", autoGroupColService_1.AutoGroupColService)
    ], ColumnController.prototype, "autoGroupColService", void 0);
    __decorate([
        context_1.Optional('aggFuncService'),
        __metadata("design:type", Object)
    ], ColumnController.prototype, "aggFuncService", void 0);
    __decorate([
        context_1.Optional('valueCache'),
        __metadata("design:type", valueCache_1.ValueCache)
    ], ColumnController.prototype, "valueCache", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], ColumnController.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], ColumnController.prototype, "gridApi", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ColumnController.prototype, "init", null);
    __decorate([
        __param(0, context_1.Qualifier('loggerFactory')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
        __metadata("design:returntype", void 0)
    ], ColumnController.prototype, "setBeans", null);
    ColumnController = __decorate([
        context_1.Bean('columnController')
    ], ColumnController);
    return ColumnController;
}());
exports.ColumnController = ColumnController;


/***/ }),

/***/ "7GwW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var settle = __webpack_require__("21It");
var buildURL = __webpack_require__("DQCr");
var parseHeaders = __webpack_require__("oJlt");
var isURLSameOrigin = __webpack_require__("GHBc");
var createError = __webpack_require__("FtD3");
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__("thJu");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("p1b6");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "7IF8":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1339);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1106:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("iFTV");

/***/ }),

/***/ 1339:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1106)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "pane",
	    name: "Pane",
	    category: "web",
	    description: "Pane",
	    depends: [ "view" ],
	    hidden: true
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        roleSelector = kendo.roleSelector,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        ViewEngine = kendo.ViewEngine,
	        View = kendo.View,

	        extend = $.extend,

	        NAVIGATE = "navigate",
	        VIEW_SHOW = "viewShow",
	        SAME_VIEW_REQUESTED = "sameViewRequested",
	        OS = kendo.support.mobileOS,
	        SKIP_TRANSITION_ON_BACK_BUTTON = OS.ios && !OS.appMode && OS.flatVersion >= 700,
	        BACK = "#:back";
	    var DOT = ".";

	    var classNames = {
	        pane: "k-pane",
	        paneWrapper: "k-pane-wrapper",
	        collapsiblePane: "k-collapsible-pane",
	        vertical: "k-vertical"
	    };

	    var Pane = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            options = that.options;
	            element = that.element;

	            element.addClass(classNames.pane);

	            if (that.options.collapsible) {
	                element.addClass(classNames.collapsiblePane);
	            }

	            this.history = [];

	            this.historyCallback = function(url, params, backButtonPressed) {
	                var transition = that.transition;
	                that.transition = null;

	                // swiping back in iOS leaves the app in a very broken state if we perform a transition
	                if (SKIP_TRANSITION_ON_BACK_BUTTON && backButtonPressed) {
	                    transition = "none";
	                }

	                return that.viewEngine.showView(url, transition, params);
	            };

	            this._historyNavigate = function(url) {
	                if (url === BACK) {
	                    if (that.history.length === 1) {
	                        return;
	                    }

	                    that.history.pop();
	                    url = that.history[that.history.length - 1];
	                } else {
	                    if (url instanceof View) {
	                        url = "";
	                    }
	                    that.history.push(url);
	                }

	                that.historyCallback(url, kendo.parseQueryStringParams(url));
	            };

	            this._historyReplace = function(url) {
	                var params = kendo.parseQueryStringParams(url);
	                that.history[that.history.length - 1] = url;
	                that.historyCallback(url, params);
	            };

	            that.viewEngine = new ViewEngine(extend({}, {
	                container: element,
	                transition: options.transition,
	                modelScope: options.modelScope,
	                rootNeeded: !options.initial,
	                serverNavigation: options.serverNavigation,
	                remoteViewURLPrefix: options.root || "",
	                layout: options.layout,
	                $angular: options.$angular,

	                showStart: function() {
	                    that.closeActiveDialogs();
	                },

	                after: function() {
	                },

	                viewShow: function(e) {
	                    that.trigger(VIEW_SHOW, e);
	                },

	                loadStart: function() {
	                },

	                loadComplete: function() {
	                },

	                sameViewRequested: function() {
	                    that.trigger(SAME_VIEW_REQUESTED);
	                },

	                viewTypeDetermined: function(e) {
	                    if (!e.remote || !that.options.serverNavigation)  {
	                        that.trigger(NAVIGATE, { url: e.url });
	                    }
	                }
	            }, this.options.viewEngine));


	            this._setPortraitWidth();

	            kendo.onResize(function() {
	                that._setPortraitWidth();
	            });
	        },

	        closeActiveDialogs: function() {
	            var dialogs = this.element.find(roleSelector("actionsheet popover modalview")).filter(":visible");
	            dialogs.each(function() {
	                kendo.widgetInstance($(this), ui).close();
	            });
	        },

	        navigateToInitial: function() {
	            var initial = this.options.initial;

	            if (initial) {
	                this.navigate(initial);
	            }

	            return initial;
	        },

	        options: {
	            name: "Pane",
	            portraitWidth: "",
	            transition: "",
	            layout: "",
	            collapsible: false,
	            initial: null,
	            modelScope: window
	        },

	        events: [
	            NAVIGATE,
	            VIEW_SHOW,
	            SAME_VIEW_REQUESTED
	        ],

	        append: function(html) {
	            return this.viewEngine.append(html);
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            if (that.viewEngine) {
	                that.viewEngine.destroy();
	            }
	        },

	        navigate: function(url, transition) {
	            if (url instanceof View) {
	                url = url.id;
	            }

	            this.transition = transition;

	            this._historyNavigate(url);
	        },

	        replace: function(url, transition) {
	            if (url instanceof View) {
	                url = url.id;
	            }

	            this.transition = transition;

	            this._historyReplace(url);
	        },

	        view: function() {
	            return this.viewEngine.view();
	        },

	        _setPortraitWidth: function() {
	            var width,
	                portraitWidth = this.options.portraitWidth;

	            if (portraitWidth) {
	                width = kendo.mobile.application.element.is(DOT + classNames.vertical) ? portraitWidth : "auto";
	                this.element.css("width", width);
	            }
	        }
	    });

	    Pane.wrap = function(element, options) {
	        if (!element.is(roleSelector("view"))) {
	            element = element.wrap('<div data-' + kendo.ns + 'role="view" data-stretch="true"></div>').parent();
	        }

	        var paneContainer = element.wrap('<div class="' + classNames.paneWrapper + ' k-widget"><div></div></div>').parent();
	        var pane = new Pane(paneContainer, options);

	        pane.navigate("");

	        return pane;
	    };

	    // kendo.ui.Pane is already taken in kendo.draganddrop.js
	    kendo.Pane = Pane;
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "7JmM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var logger_1 = __webpack_require__("U9Xd");
var columnController_1 = __webpack_require__("77lH");
var column_1 = __webpack_require__("hDyE");
var utils_1 = __webpack_require__("IRr6");
var dragAndDropService_1 = __webpack_require__("I/uN");
var gridPanel_1 = __webpack_require__("inOk");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var MoveColumnController = (function () {
    function MoveColumnController(pinned, eContainer) {
        this.needToMoveLeft = false;
        this.needToMoveRight = false;
        this.pinned = pinned;
        this.eContainer = eContainer;
        this.centerContainer = !utils_1.Utils.exists(pinned);
    }
    MoveColumnController.prototype.init = function () {
        this.logger = this.loggerFactory.create('MoveColumnController');
    };
    MoveColumnController.prototype.getIconName = function () {
        return this.pinned ? dragAndDropService_1.DragAndDropService.ICON_PINNED : dragAndDropService_1.DragAndDropService.ICON_MOVE;
    };
    MoveColumnController.prototype.onDragEnter = function (draggingEvent) {
        // we do dummy drag, so make sure column appears in the right location when first placed
        var columns = draggingEvent.dragItem.columns;
        var dragCameFromToolPanel = draggingEvent.dragSource.type === dragAndDropService_1.DragSourceType.ToolPanel;
        if (dragCameFromToolPanel) {
            // the if statement doesn't work if drag leaves grid, then enters again
            this.setColumnsVisible(columns, true, "uiColumnDragged");
        }
        else {
            // restore previous state of visible columns upon re-entering. this means if the user drags
            // a group out, and then drags the group back in, only columns that were originally visible
            // will be visible again. otherwise a group with three columns (but only two visible) could
            // be dragged out, then when it's dragged in again, all three are visible. this stops that.
            var visibleState_1 = draggingEvent.dragItem.visibleState;
            var visibleColumns = columns.filter(function (column) { return visibleState_1[column.getId()]; });
            this.setColumnsVisible(visibleColumns, true, "uiColumnDragged");
        }
        this.setColumnsPinned(columns, this.pinned, "uiColumnDragged");
        this.onDragging(draggingEvent, true);
    };
    MoveColumnController.prototype.onDragLeave = function (draggingEvent) {
        var hideColumnOnExit = !this.gridOptionsWrapper.isSuppressDragLeaveHidesColumns() && !draggingEvent.fromNudge;
        if (hideColumnOnExit) {
            var dragItem = draggingEvent.dragSource.dragItemCallback();
            var columns = dragItem.columns;
            this.setColumnsVisible(columns, false, "uiColumnDragged");
        }
        this.ensureIntervalCleared();
    };
    MoveColumnController.prototype.setColumnsVisible = function (columns, visible, source) {
        if (source === void 0) { source = "api"; }
        if (columns) {
            var allowedCols = columns.filter(function (c) { return !c.isLockVisible(); });
            this.columnController.setColumnsVisible(allowedCols, visible, source);
        }
    };
    MoveColumnController.prototype.setColumnsPinned = function (columns, pinned, source) {
        if (source === void 0) { source = "api"; }
        if (columns) {
            var allowedCols = columns.filter(function (c) { return !c.isLockPinned(); });
            this.columnController.setColumnsPinned(allowedCols, pinned, source);
        }
    };
    MoveColumnController.prototype.onDragStop = function () {
        this.ensureIntervalCleared();
    };
    MoveColumnController.prototype.normaliseX = function (x) {
        // flip the coordinate if doing RTL
        var flipHorizontallyForRtl = this.gridOptionsWrapper.isEnableRtl();
        if (flipHorizontallyForRtl) {
            var clientWidth = this.eContainer.clientWidth;
            x = clientWidth - x;
        }
        // adjust for scroll only if centre container (the pinned containers dont scroll)
        var adjustForScroll = this.centerContainer;
        if (adjustForScroll) {
            x += this.gridPanel.getBodyViewportScrollLeft();
        }
        return x;
    };
    MoveColumnController.prototype.checkCenterForScrolling = function (xAdjustedForScroll) {
        if (this.centerContainer) {
            // scroll if the mouse has gone outside the grid (or just outside the scrollable part if pinning)
            // putting in 50 buffer, so even if user gets to edge of grid, a scroll will happen
            var firstVisiblePixel = this.gridPanel.getBodyViewportScrollLeft();
            var lastVisiblePixel = firstVisiblePixel + this.gridPanel.getCenterWidth();
            if (this.gridOptionsWrapper.isEnableRtl()) {
                this.needToMoveRight = xAdjustedForScroll < (firstVisiblePixel + 50);
                this.needToMoveLeft = xAdjustedForScroll > (lastVisiblePixel - 50);
            }
            else {
                this.needToMoveLeft = xAdjustedForScroll < (firstVisiblePixel + 50);
                this.needToMoveRight = xAdjustedForScroll > (lastVisiblePixel - 50);
            }
            if (this.needToMoveLeft || this.needToMoveRight) {
                this.ensureIntervalStarted();
            }
            else {
                this.ensureIntervalCleared();
            }
        }
    };
    MoveColumnController.prototype.onDragging = function (draggingEvent, fromEnter) {
        var _this = this;
        if (fromEnter === void 0) { fromEnter = false; }
        this.lastDraggingEvent = draggingEvent;
        // if moving up or down (ie not left or right) then do nothing
        if (utils_1.Utils.missing(draggingEvent.hDirection)) {
            return;
        }
        var xNormalised = this.normaliseX(draggingEvent.x);
        // if the user is dragging into the panel, ie coming from the side panel into the main grid,
        // we don't want to scroll the grid this time, it would appear like the table is jumping
        // each time a column is dragged in.
        if (!fromEnter) {
            this.checkCenterForScrolling(xNormalised);
        }
        var hDirectionNormalised = this.normaliseDirection(draggingEvent.hDirection);
        var dragSourceType = draggingEvent.dragSource.type;
        var columnsToMove = draggingEvent.dragSource.dragItemCallback().columns;
        columnsToMove = columnsToMove.filter(function (col) {
            if (col.isLockPinned()) {
                // if locked return true only if both col and container are same pin type.
                // double equals (==) here on purpose so that null==undefined is true (for not pinned options)
                return col.getPinned() == _this.pinned;
            }
            else {
                // if not pin locked, then always allowed to be in this container
                return true;
            }
        });
        this.attemptMoveColumns(dragSourceType, columnsToMove, hDirectionNormalised, xNormalised, fromEnter);
    };
    MoveColumnController.prototype.normaliseDirection = function (hDirection) {
        if (this.gridOptionsWrapper.isEnableRtl()) {
            switch (hDirection) {
                case dragAndDropService_1.HDirection.Left: return dragAndDropService_1.HDirection.Right;
                case dragAndDropService_1.HDirection.Right: return dragAndDropService_1.HDirection.Left;
                default: console.error("ag-Grid: Unknown direction " + hDirection);
            }
        }
        else {
            return hDirection;
        }
    };
    // returns the index of the first column in the list ONLY if the cols are all beside
    // each other. if the cols are not beside each other, then returns null
    MoveColumnController.prototype.calculateOldIndex = function (movingCols) {
        var gridCols = this.columnController.getAllGridColumns();
        var indexes = [];
        movingCols.forEach(function (col) { return indexes.push(gridCols.indexOf(col)); });
        utils_1.Utils.sortNumberArray(indexes);
        var firstIndex = indexes[0];
        var lastIndex = indexes[indexes.length - 1];
        var spread = lastIndex - firstIndex;
        var gapsExist = spread !== indexes.length - 1;
        return gapsExist ? null : firstIndex;
    };
    MoveColumnController.prototype.attemptMoveColumns = function (dragSourceType, allMovingColumns, hDirection, xAdjusted, fromEnter) {
        var draggingLeft = hDirection === dragAndDropService_1.HDirection.Left;
        var draggingRight = hDirection === dragAndDropService_1.HDirection.Right;
        var validMoves = this.calculateValidMoves(allMovingColumns, draggingRight, xAdjusted);
        // if cols are not adjacent, then this returns null. when moving, we constrain the direction of the move
        // (ie left or right) to the mouse direction. however
        var oldIndex = this.calculateOldIndex(allMovingColumns);
        // fromEnter = false;
        for (var i = 0; i < validMoves.length; i++) {
            var newIndex = validMoves[i];
            // the two check below stop an error when the user grabs a group my a middle column, then
            // it is possible the mouse pointer is to the right of a column while been dragged left.
            // so we need to make sure that the mouse pointer is actually left of the left most column
            // if moving left, and right of the right most column if moving right
            // we check 'fromEnter' below so we move the column to the new spot if the mouse is coming from
            // outside the grid, eg if the column is moving from side panel, mouse is moving left, then we should
            // place the column to the RHS even if the mouse is moving left and the column is already on
            // the LHS. otherwise we stick to the rule described above.
            var constrainDirection = oldIndex !== null && !fromEnter;
            // don't consider 'fromEnter' when dragging header cells, otherwise group can jump to opposite direction of drag
            if (dragSourceType == dragAndDropService_1.DragSourceType.HeaderCell) {
                constrainDirection = oldIndex !== null;
            }
            if (constrainDirection) {
                // only allow left drag if this column is moving left
                if (draggingLeft && newIndex >= oldIndex) {
                    continue;
                }
                // only allow right drag if this column is moving right
                if (draggingRight && newIndex <= oldIndex) {
                    continue;
                }
            }
            if (!this.columnController.doesMovePassRules(allMovingColumns, newIndex)) {
                continue;
            }
            this.columnController.moveColumns(allMovingColumns, newIndex, "uiColumnDragged");
            // important to return here, so once we do the first valid move, we don't try do any more
            return;
        }
    };
    MoveColumnController.prototype.calculateValidMoves = function (movingCols, draggingRight, x) {
        // this is the list of cols on the screen, so it's these we use when comparing the x mouse position
        var allDisplayedCols = this.columnController.getDisplayedColumns(this.pinned);
        // but this list is the list of all cols, when we move a col it's the index within this list that gets used,
        // so the result we return has to be and index location for this list
        var allGridCols = this.columnController.getAllGridColumns();
        var colIsMovingFunc = function (col) { return movingCols.indexOf(col) >= 0; };
        var colIsNotMovingFunc = function (col) { return movingCols.indexOf(col) < 0; };
        var movingDisplayedCols = allDisplayedCols.filter(colIsMovingFunc);
        var otherDisplayedCols = allDisplayedCols.filter(colIsNotMovingFunc);
        var otherGridCols = allGridCols.filter(colIsNotMovingFunc);
        // work out how many DISPLAYED columns fit before the 'x' position. this gives us the displayIndex.
        // for example, if cols are a,b,c,d and we find a,b fit before 'x', then we want to place the moving
        // col between b and c (so that it is under the mouse position).
        var displayIndex = 0;
        var availableWidth = x;
        // if we are dragging right, then the columns will be to the left of the mouse, so we also want to
        // include the width of the moving columns
        if (draggingRight) {
            var widthOfMovingDisplayedCols_1 = 0;
            movingDisplayedCols.forEach(function (col) { return widthOfMovingDisplayedCols_1 += col.getActualWidth(); });
            availableWidth -= widthOfMovingDisplayedCols_1;
        }
        // now count how many of the displayed columns will fit to the left
        for (var i = 0; i < otherDisplayedCols.length; i++) {
            var col = otherDisplayedCols[i];
            availableWidth -= col.getActualWidth();
            if (availableWidth < 0) {
                break;
            }
            displayIndex++;
        }
        // trial and error, if going right, we adjust by one, i didn't manage to quantify why, but it works
        if (draggingRight) {
            displayIndex++;
        }
        // the display index is with respect to all the showing columns, however when we move, it's with
        // respect to all grid columns, so we need to translate from display index to grid index
        var gridColIndex;
        if (displayIndex > 0) {
            var leftColumn = otherDisplayedCols[displayIndex - 1];
            gridColIndex = otherGridCols.indexOf(leftColumn) + 1;
        }
        else {
            gridColIndex = 0;
        }
        var validMoves = [gridColIndex];
        // add in all adjacent empty columns as other valid moves. this allows us to try putting the new
        // column in any place of a hidden column, to try different combinations so that we don't break
        // married children. in other words, maybe the new index breaks a group, but only because some
        // columns are hidden, maybe we can reshuffle the hidden columns to find a place that works.
        var nextCol = allGridCols[gridColIndex];
        while (utils_1.Utils.exists(nextCol) && this.isColumnHidden(allDisplayedCols, nextCol)) {
            gridColIndex++;
            validMoves.push(gridColIndex);
            nextCol = allGridCols[gridColIndex];
        }
        return validMoves;
    };
    // isHidden takes into account visible=false and group=closed, ie it is not displayed
    MoveColumnController.prototype.isColumnHidden = function (displayedColumns, col) {
        return displayedColumns.indexOf(col) < 0;
    };
    MoveColumnController.prototype.ensureIntervalStarted = function () {
        if (!this.movingIntervalId) {
            this.intervalCount = 0;
            this.failedMoveAttempts = 0;
            this.movingIntervalId = setInterval(this.moveInterval.bind(this), 100);
            if (this.needToMoveLeft) {
                this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_LEFT, true);
            }
            else {
                this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_RIGHT, true);
            }
        }
    };
    MoveColumnController.prototype.ensureIntervalCleared = function () {
        if (this.moveInterval) {
            clearInterval(this.movingIntervalId);
            this.movingIntervalId = null;
            this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_MOVE);
        }
    };
    MoveColumnController.prototype.moveInterval = function () {
        // the amounts we move get bigger at each interval, so the speed accelerates, starting a bit slow
        // and getting faster. this is to give smoother user experience. we max at 100px to limit the speed.
        var pixelsToMove;
        this.intervalCount++;
        pixelsToMove = 10 + (this.intervalCount * 5);
        if (pixelsToMove > 100) {
            pixelsToMove = 100;
        }
        var pixelsMoved;
        if (this.needToMoveLeft) {
            pixelsMoved = this.gridPanel.scrollHorizontally(-pixelsToMove);
        }
        else if (this.needToMoveRight) {
            pixelsMoved = this.gridPanel.scrollHorizontally(pixelsToMove);
        }
        if (pixelsMoved !== 0) {
            this.onDragging(this.lastDraggingEvent);
            this.failedMoveAttempts = 0;
        }
        else {
            // we count the failed move attempts. if we fail to move 7 times, then we pin the column.
            // this is how we achieve pining by dragging the column to the edge of the grid.
            this.failedMoveAttempts++;
            var columns = this.lastDraggingEvent.dragItem.columns;
            var columnsThatCanPin = columns.filter(function (c) { return !c.isLockPinned(); });
            if (columnsThatCanPin.length > 0) {
                this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_PINNED);
                if (this.failedMoveAttempts > 7) {
                    var pinType = this.needToMoveLeft ? column_1.Column.PINNED_LEFT : column_1.Column.PINNED_RIGHT;
                    this.setColumnsPinned(columnsThatCanPin, pinType, "uiColumnDragged");
                    this.dragAndDropService.nudge();
                }
            }
        }
    };
    __decorate([
        context_1.Autowired('loggerFactory'),
        __metadata("design:type", logger_1.LoggerFactory)
    ], MoveColumnController.prototype, "loggerFactory", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], MoveColumnController.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('gridPanel'),
        __metadata("design:type", gridPanel_1.GridPanel)
    ], MoveColumnController.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('dragAndDropService'),
        __metadata("design:type", dragAndDropService_1.DragAndDropService)
    ], MoveColumnController.prototype, "dragAndDropService", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], MoveColumnController.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MoveColumnController.prototype, "init", null);
    return MoveColumnController;
}());
exports.MoveColumnController = MoveColumnController;


/***/ }),

/***/ "7Jyx":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1034);
	module.exports = __webpack_require__(1034);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1034:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1035), __webpack_require__(1036)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function () {

	    (function ($, undefined) {
	        var kendo = window.kendo,
	            imageeditorNS = kendo.ui.imageeditor,
	            extend = $.extend,
	            proxy = $.proxy,
	            Class = kendo.Class;

	        var Command = Class.extend({
	            init: function (options) {
	                this.options = extend({}, options, this.options);
	                this.imageeditor = options.imageeditor;
	            }
	        });

	        var OpenPaneImageEditorCommand = Command.extend({
	            init: function (options) {
	                Command.fn.init.call(this, options);
	            },
	            exec: function () {
	                var that = this,
	                    imageeditor = that.imageeditor,
	                    pane = new imageeditorNS.panes[that.options.value](imageeditor);

	                    pane.open();
	            }
	        });

	        var ZoomImageEditorCommand = Command.extend({
	            options: {
	                zoomStep: 0.05,
	                spacing: 20
	            },
	            init: function (options) {
	                Command.fn.init.call(this, options);
	            },
	            exec: function () {
	                var that = this,
	                    options = that.options,
	                    value = options.value,
	                    imageeditor = that.imageeditor,
	                    imgHeight = imageeditor._image.height,
	                    currentZoom = imageeditor.getZoomLevel(),
	                    newHeight = imgHeight;

	                    if(!isNaN(value)) {
	                        value = parseFloat(value);
	                    } else if (typeof value === "string") {
	                        value = that._processStringValue(value, currentZoom);
	                    }

	                    newHeight = Math.round(imgHeight * value);

	                    if(newHeight > 0) {
	                        $(imageeditor._canvas).css("height", newHeight);
	                        imageeditor._zoomLevel = value;
	                    }

	                    if (imageeditor.currentPaneTool) {
	                        imageeditor.currentPaneTool.refresh();
	                    }
	            },
	            _processStringValue: function (value, initialZoom) {
	                var that = this,
	                    options = that.options,
	                    imageeditor = that.imageeditor,
	                    imgHeight = imageeditor._image.height,
	                    expectedHeight = imageeditor.canvasWrapper.height() - options.spacing,
	                    zoomStep = options.zoomStep;

	                switch (value) {
	                    case "zoomIn":
	                        return initialZoom + zoomStep;
	                    case "zoomOut":
	                        return initialZoom - zoomStep;
	                    case "fitToScreen":
	                        return Math.round((expectedHeight / imgHeight) * 100) / 100;
	                    default:
	                        return 1;
	                }
	            }
	        });

	        var CropImageEditorCommand = Command.extend({
	            init: function (options) {
	                Command.fn.init.call(this, options);
	            },
	            exec: function () {
	                var that = this,
	                    options = that.options,
	                    imageeditor = that.imageeditor,
	                    canvas = imageeditor.getCanvasElement(),
	                    ctx = imageeditor.getCurrent2dContext(),
	                    croppedImage = ctx.getImageData(options.left, options.top, options.width, options.height);

	                ctx.clearRect(0, 0, canvas.width, canvas.height);
	                canvas.width = options.width;
	                canvas.height = options.height;
	                ctx.putImageData(croppedImage, 0, 0);

	                imageeditor.drawImage(canvas.toDataURL()).done(function(image){
	                    imageeditor.drawCanvas(image);
	                }).fail(function (ev) {
	                    imageeditor.trigger("error", ev);
	                });
	            }
	        });

	        var ResizeImageEditorCommand = Command.extend({
	            init: function (options) {
	                Command.fn.init.call(this, options);
	            },
	            exec: function () {
	                var that = this,
	                    options = that.options,
	                    imageeditor = that.imageeditor,
	                    canvas = imageeditor.getCanvasElement(),
	                    ctx = imageeditor.getCurrent2dContext(),
	                    image = imageeditor.getCurrentImage();

	                ctx.clearRect(0, 0, canvas.width, canvas.height);
	                canvas.width = options.width;
	                canvas.height = options.height;
	                ctx.drawImage(image, 0, 0, options.width, options.height);

	                imageeditor.drawImage(canvas.toDataURL()).done(function(image){
	                    imageeditor.drawCanvas(image);
	                }).fail(function (ev) {
	                    imageeditor.trigger("error", ev);
	                });
	            }
	        });

	        var UndoImageEditorCommand = Command.extend({
	            exec: function () {
	                var that = this,
	                    imageeditor = that.imageeditor,
	                    canvas = imageeditor.getCanvasElement(),
	                    ctx = imageeditor.getCurrent2dContext(),
	                    image = imageeditor.undoStack.pop();

	                if(image) {
	                    imageeditor.redoStack.push(imageeditor.getCurrentImage());
	                    delete imageeditor._image;

	                    ctx.clearRect(0, 0, canvas.width, canvas.height);
	                    canvas.width = image.width;
	                    canvas.height = image.height;
	                    ctx.drawImage(image, 0, 0, image.width, image.height);

	                    imageeditor.drawImage(canvas.toDataURL()).done(function(image){
	                        imageeditor.drawCanvas(image);
	                    }).fail(function (ev) {
	                        imageeditor.trigger("error", ev);
	                    });
	                }
	            }
	        });

	        var RedoImageEditorCommand = Command.extend({
	            exec: function () {
	                var that = this,
	                    imageeditor = that.imageeditor,
	                    canvas = imageeditor.getCanvasElement(),
	                    ctx = imageeditor.getCurrent2dContext(),
	                    image = imageeditor.redoStack.pop();

	                if(image) {
	                    imageeditor.undoStack.push(imageeditor.getCurrentImage());
	                    delete imageeditor._image;

	                    ctx.clearRect(0, 0, canvas.width, canvas.height);
	                    canvas.width = image.width;
	                    canvas.height = image.height;
	                    ctx.drawImage(image, 0, 0, image.width, image.height);

	                    imageeditor.drawImage(canvas.toDataURL()).done(function(image){
	                        imageeditor.drawCanvas(image);
	                    }).fail(function (ev) {
	                        imageeditor.trigger("error", ev);
	                    });
	                }
	            }
	        });

	        var SaveImageEditorCommand = Command.extend({
	            exec: function () {
	                var that = this,
	                    imageeditor = that.imageeditor,
	                    canvas = imageeditor.getCanvasElement();

	                kendo.saveAs(extend({}, imageeditor.options.saveAs, {
	                    dataURI: canvas.toDataURL()
	                }));
	            }
	        });

	        var OpenImageEditorCommand = Command.extend({
	            exec: function () {
	                var that = this,
	                    imageeditor = that.imageeditor,
	                    upload = imageeditor._upload;

	                if (!upload) {
	                    var input = $("<input type='file' />");
	                    input.kendoUpload({
	                        select: proxy(that.onSelect, that),
	                        error: proxy(that.onError, that),
	                        multiple: false,
	                        validation: {
	                            allowedExtensions: [".jpg", ".jpeg", ".gif", ".png", ".bmp", ".tiff", ".webp"]
	                        }
	                    });

	                    imageeditor._upload = upload = input.getKendoUpload();

	                }

	                upload.element.click();
	            },
	            onSelect: function (ev) {
	                var that = this,
	                    imageeditor = that.imageeditor,
	                    file = ev.files[0].rawFile,
	                    reader = new FileReader();

	                reader.addEventListener("load", function () {
	                    imageeditor.drawImage(reader.result).done(function(image){
	                        if (!imageeditor.trigger("imageLoaded", { image: image })) {
	                            imageeditor.drawCanvas(image);
	                            imageeditor._initUndoRedoStack();
	                            imageeditor._toggleTools();
	                        }
	                    }).fail(function (ev) {
	                        imageeditor.trigger("error", ev);
	                    });
	                }, false);


	                if (file) {
	                    reader.readAsDataURL(file);
	                }

	            },
	            onError: function(ev){
	                var that = this,
	                    imageeditor= that.imageeditor;

	                imageeditor.trigger("error", ev);
	            }
	        });

	        extend(kendo.ui.imageeditor, {
	            ImageEditorCommand: Command,
	            commands: {
	                OpenPaneImageEditorCommand: OpenPaneImageEditorCommand,
	                ZoomImageEditorCommand: ZoomImageEditorCommand,
	                CropImageEditorCommand: CropImageEditorCommand,
	                ResizeImageEditorCommand:ResizeImageEditorCommand,
	                UndoImageEditorCommand: UndoImageEditorCommand,
	                RedoImageEditorCommand: RedoImageEditorCommand,
	                SaveImageEditorCommand: SaveImageEditorCommand,
	                OpenImageEditorCommand: OpenImageEditorCommand
	            }
	    });

	    })(window.kendo.jQuery);

	    return window.kendo;

	}, __webpack_require__(3));

/***/ }),

/***/ 1035:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("w8e/");

/***/ }),

/***/ 1036:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("o4s/");

/***/ })

/******/ });

/***/ }),

/***/ "7KvD":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "7Omp":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1433);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1048:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("BOhp");

/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Dz7c");

/***/ }),

/***/ 1433:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1086), __webpack_require__(1104) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "tooltip",
	    name: "Tooltip",
	    category: "web",
	    description: "The Tooltip widget displays a popup hint for a given html element.",
	    depends: [ "core", "popup" ],
	    features: [ {
	        id: "tooltip-fx",
	        name: "Animation",
	        description: "Support for animation",
	        depends: [ "fx" ]
	    } ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        Popup = kendo.ui.Popup,
	        isFunction = kendo.isFunction,
	        isPlainObject = $.isPlainObject,
	        extend = $.extend,
	        proxy = $.proxy,
	        DOCUMENT = $(document),
	        isLocalUrl = kendo.isLocalUrl,
	        ARIAIDSUFFIX = "_tt_active",
	        DESCRIBEDBY = "aria-describedby",
	        SHOW = "show",
	        HIDE = "hide",
	        ERROR = "error",
	        CONTENTLOAD = "contentLoad",
	        REQUESTSTART = "requestStart",
	        KCONTENTFRAME = "k-content-frame",
	        TEMPLATE = '<div role="tooltip" class="k-widget k-tooltip#if (!autoHide) {# k-tooltip-closable#}#">' +
	            '<div class="k-tooltip-content"></div>' +
	            '#if (!autoHide) {# <div class="k-tooltip-button"><a href="\\#" class="k-icon k-i-close" title="Close"></a></div> #}#' +
	            '#if (callout){ #<div class="k-callout k-callout-#=dir#"></div>#}#' +
	        '</div>',
	        IFRAMETEMPLATE = kendo.template(
	            "<iframe frameborder='0' class='" + KCONTENTFRAME + "' src='#= content.url #'>" +
	                "This page requires frames in order to show content" +
	            "</iframe>"
	        ),
	        NS = ".kendoTooltip",
	        POSITIONS = {
	            bottom: {
	                origin: "bottom center",
	                position: "top center"
	            },
	            top: {
	                origin: "top center",
	                position: "bottom center"
	            },
	            left: {
	                origin: "center left",
	                position: "center right",
	                collision: "fit flip"
	            },
	            right: {
	                origin: "center right",
	                position: "center left",
	                collision: "fit flip"
	            },
	            center: {
	                position: "center center",
	                origin: "center center"
	            }
	        },
	        REVERSE = {
	            "top": "bottom",
	            "bottom": "top",
	            "left": "right",
	            "right": "left",
	            "center": "center"
	        },
	        DIRCLASSES = {
	            bottom: "n",
	            top: "s",
	            left: "e",
	            right: "w",
	            center: "n"
	        },
	        DIMENSIONS = {
	            "horizontal": { offset: "top", size: "outerHeight" },
	            "vertical": { offset: "left", size: "outerWidth" }
	        },
	        DEFAULTCONTENT = function(e) {
	            return e.target.data(kendo.ns + "title");
	        };

	    function restoreTitle(element) {
	        while(element.length) {
	            if (restoreTitleAttributeForElement(element)) {
	                break;
	            }
	            element = element.parent();
	        }
	    }

	    function restoreTitleAttributeForElement(element) {
	        var title = element.data(kendo.ns + "title");
	        if (title) {
	            element.attr("title", title);
	            element.removeData(kendo.ns + "title");
	            return true;
	        }
	    }

	    function saveTitleAttributeForElement(element) {
	        var title = element.attr("title");
	        if (title) {
	            element.data(kendo.ns + "title", title);
	            element.attr("title", "");
	            return true;
	        }
	    }

	    function saveTitleAttributes(element) {
	        while(element.length && !element.is("body")) {
	            if (saveTitleAttributeForElement(element)) {
	                break;
	            }
	            element = element.parent();
	        }
	    }

	    var Tooltip = Widget.extend({
	        init: function(element, options) {
	            var that = this,
	                axis;

	            Widget.fn.init.call(that, element, options);

	            axis = that.options.position.match(/left|right/) ? "horizontal" : "vertical";

	            that.dimensions = DIMENSIONS[axis];

	            that._documentKeyDownHandler = proxy(that._documentKeyDown, that);

	            if (kendo.support.touch && this._isShownOnMouseEnter()) {
	                that.element.on(kendo.support.mousedown + NS, that.options.filter, proxy(that._showOn, that));
	            }

	            that.element.on(that.options.showOn + NS, that.options.filter, proxy(that._showOn, that));

	            if (this._isShownOnMouseEnter() || this._isShownOnClick()) {
	                that.element.on("mouseenter" + NS, that.options.filter, proxy(that._mouseenter, that));
	            }

	            if (this.options.autoHide && this._isShownOnMouseEnter()) {
	                that.element.on("mouseleave" + NS, that.options.filter, proxy(that._mouseleave, that));
	            }

	            if (this.options.autoHide && this._isShownOnFocus()) {
	                that.element.on("blur" + NS, that.options.filter, proxy(that._blur, that));
	            }

	            if (kendo.support.touch) {
	                that.element.on(kendo.support.mousedown + NS, that.options.filter, proxy(that._mouseenter, that));
	            }
	        },

	        options: {
	            name: "Tooltip",
	            filter: "",
	            content: DEFAULTCONTENT,
	            showAfter: 100,
	            hideAfter: 100,
	            callout: true,
	            offset: 0,
	            position: "bottom",
	            showOn: "mouseenter",
	            autoHide: true,
	            width: null,
	            height: null,
	            animation: {
	                open: {
	                    effects: "fade:in",
	                    duration: 0
	                },
	                close: {
	                    duration: 40,
	                    hide: true
	                }
	            }
	        },

	        events: [ SHOW, HIDE, CONTENTLOAD, ERROR, REQUESTSTART ],

	        _isShownOnFocus: function(){
	            return this.options.showOn && this.options.showOn.match(/focus/);
	        },

	        _isShownOnMouseEnter: function(){
	            return this.options.showOn && this.options.showOn.match(/mouseenter/);
	        },

	        _isShownOnClick: function(){
	            return this.options.showOn && this.options.showOn.match(/click/);
	        },

	        _mouseenter: function(e) {
	            saveTitleAttributes($(e.currentTarget));
	        },

	        _showOn: function(e) {
	            var that = this;

	            var currentTarget = $(e.currentTarget);
	            if (that._isShownOnClick() && !that._isShownOnMouseEnter()) {
	                that._show(currentTarget);
	            } else if (that._isShownOnFocus()) {
	                saveTitleAttributes(currentTarget);
	                that._show(currentTarget);
	            } else {
	                clearTimeout(that.timeout);

	                that.timeout = setTimeout(function() {
	                    that._show(currentTarget);
	                }, that.options.showAfter);
	            }
	        },

	        _appendContent: function(target) {
	            var that = this,
	                contentOptions = that.options.content,
	                element = that.content,
	                showIframe = that.options.iframe,
	                iframe;

	            if (isPlainObject(contentOptions) && contentOptions.url) {
	                if (!("iframe" in that.options)) {
	                    showIframe = !isLocalUrl(contentOptions.url);
	                }

	                that.trigger(REQUESTSTART, { options: contentOptions, target: target });

	                if (!showIframe) {
	                    element.empty();
	                    kendo.ui.progress(element, true);

	                    // perform AJAX request
	                    that._ajaxRequest(contentOptions);
	                } else {
	                    element.hide();

	                    iframe = element.find("." + KCONTENTFRAME)[0];

	                    if (iframe) {
	                        // refresh existing iframe
	                        iframe.src = contentOptions.url || iframe.src;
	                    } else {
	                        element.html(IFRAMETEMPLATE({ content: contentOptions }));
	                    }

	                    element.find("." + KCONTENTFRAME)
	                        .off("load" + NS)
	                        .on("load" + NS, function(){
	                            that.trigger(CONTENTLOAD);
	                            element.show();
	                        });
	                }
	            } else if (contentOptions && isFunction(contentOptions)) {
	                contentOptions = contentOptions({ sender: this, target: target });
	                element.html(contentOptions || "");
	            } else {
	                element.html(contentOptions);
	            }

	            that.angular("compile", function(){
	                return { elements: element };
	            });
	        },

	        _ajaxRequest: function(options) {
	            var that = this;

	            jQuery.ajax(extend({
	                type: "GET",
	                dataType: "html",
	                cache: false,
	                error: function (xhr, status) {
	                    kendo.ui.progress(that.content, false);

	                    that.trigger(ERROR, { status: status, xhr: xhr });
	                },
	                success: proxy(function (data) {
	                    kendo.ui.progress(that.content, false);

	                    that.content.html(data);

	                    that.trigger(CONTENTLOAD);
	                }, that)
	            }, options));
	        },

	        _documentKeyDown: function(e) {
	            if (e.keyCode === kendo.keys.ESC) {
	                this.hide();
	            }
	        },

	        refresh: function() {
	            var that = this,
	                popup = that.popup;

	            if (popup && popup.options.anchor) {
	                that._appendContent(popup.options.anchor);
	            }
	        },

	        hide: function() {
	            if (this.popup) {
	                this.popup.close();
	            }
	        },

	        show: function(target) {
	            target = target || this.element;

	            saveTitleAttributes(target);
	            this._show(target);
	        },

	        _show: function(target) {
	            var that = this,
	                current = that.target();

	            if (!that.popup) {
	                that._initPopup();
	            }

	            if (current && current[0] != target[0]) {
	                that.popup.close();
	                that.popup.element.kendoStop(true, true);// animation can be too long to hide the element before it is shown again
	            }

	            if (!current || current[0] != target[0]) {
	                that._appendContent(target);
	                that.popup.options.anchor = target;
	            }

	            that.popup.one("deactivate", function() {
	                restoreTitle(target);
	                target.removeAttr(DESCRIBEDBY);

	                this.element
	                    .removeAttr("id")
	                    .attr("aria-hidden", true);

	                DOCUMENT.off("keydown" + NS, that._documentKeyDownHandler);
	            });

	            that.popup._hovered = true;
	            that.popup.open();
	        },

	        _initPopup: function() {
	            var that = this,
	                options = that.options,
	                wrapper = $(kendo.template(TEMPLATE)({
	                    callout: options.callout && options.position !== "center",
	                    dir: DIRCLASSES[options.position],
	                    autoHide: options.autoHide
	                }));

	            that.popup = new Popup(wrapper, extend({
	                autosize:true,
	                activate: function() {
	                    var anchor = this.options.anchor,
	                        ariaId = anchor[0].id || that.element[0].id;

	                    if (ariaId) {
	                        anchor.attr(DESCRIBEDBY, ariaId + ARIAIDSUFFIX);
	                        this.element.attr("id", ariaId + ARIAIDSUFFIX);
	                    }

	                    if (options.callout) {
	                        that._positionCallout();
	                    } else {
	                        that._offset(that.options.position, that.options.offset);
	                    }

	                    this.element.removeAttr("aria-hidden");

	                    DOCUMENT.on("keydown" + NS, that._documentKeyDownHandler);

	                    that.trigger(SHOW);
	                    that.popup._hovered = undefined;
	                },
	                close: function() {
	                    that.trigger(HIDE);
	                },
	                copyAnchorStyles: false,
	                animation: options.animation
	            }, POSITIONS[options.position]));

	            wrapper.css({
	                width: options.width,
	                height: options.height
	            });

	            that.content = wrapper.find(".k-tooltip-content");
	            that.arrow = wrapper.find(".k-callout");

	            if (options.autoHide && this._isShownOnMouseEnter()) {
	                wrapper.on("mouseleave" + NS, proxy(that._mouseleave, that));
	            } else {
	                wrapper.on("click" + NS, ".k-tooltip-button", proxy(that._closeButtonClick, that));
	            }
	        },

	        _closeButtonClick: function(e) {
	            e.preventDefault();
	            this.hide();
	        },

	        _mouseleave: function(e) {
	            var that = this;

	            clearTimeout(that.timeout);

	            that.timeout = setTimeout(function() {
	                that._closePopup(e.currentTarget);
	            }, that.options.hideAfter);
	        },

	        _blur: function(e){
	            this._closePopup(e.currentTarget);
	        },

	        _closePopup: function(target){
	            if (this.popup && !this.popup._hovered) {
	                this.popup.close();
	            } else {
	                restoreTitle($(target));
	            }
	        },

	        target: function() {
	            if (this.popup) {
	                return this.popup.options.anchor;
	            }
	            return null;
	        },

	        _positionCallout: function() {
	            var that = this,
	                position = that.options.position,
	                dimensions = that.dimensions,
	                offset = dimensions.offset,
	                popup = that.popup,
	                anchor = popup.options.anchor,
	                anchorOffset = $(anchor).offset(),
	                elementOffset = $(popup.element).offset(),
	                cssClass = DIRCLASSES[popup.flipped ? REVERSE[position] : position],
	                offsetAmount = anchorOffset[offset] - elementOffset[offset] + ($(anchor)[dimensions.size]() / 2);

	            that._offset(position, that.options.offset);

	            that.arrow
	               .removeClass("k-callout-n k-callout-s k-callout-w k-callout-e")
	               .addClass("k-callout-" + cssClass)
	               .css(offset, offsetAmount);
	        },

	        destroy: function() {
	            var popup = this.popup;

	            if (popup) {
	                popup.element.off(NS);
	                popup.destroy();
	            }

	            clearTimeout(this.timeout);

	            this.element.off(NS);

	            DOCUMENT.off("keydown" + NS, this._documentKeyDownHandler);

	            Widget.fn.destroy.call(this);
	        },

	        _offset: function(position, offsetAmount) {
	            var that = this,
	                isTopLeft = position == "top" || position == "left",
	                isFlipped = that.popup.flipped,
	                direction = (isTopLeft && isFlipped) || (!isTopLeft && !isFlipped) ? 1 : -1,
	                marginRule = isTopLeft ? "margin-" + position : "margin-" + REVERSE[position],
	                offset = (kendo._outerWidth(that.arrow) / 2) + offsetAmount;

	            that.popup.wrapper.css(marginRule, offset * direction + "px");
	        }

	    });

	    kendo.ui.plugin(Tooltip);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1048)))

/***/ })

/******/ });

/***/ }),

/***/ "7R0X":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1001);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 973:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2UxK");

/***/ }),

/***/ 1001:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(973), __webpack_require__(1002), __webpack_require__(1003), __webpack_require__(1004)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function() {

	(function(kendo, undefined) {
	    var global = window;
	    var math = global.Math;
	    var abs = math.abs;

	    var $ = kendo.jQuery;
	    var extend = $.extend;

	    var Editor = kendo.ui.editor;
	    var dom = Editor.Dom;
	    var TableElementResizing = Editor.TableElementResizing;
	    var ResizingUtils = Editor.ResizingUtils;
	    var constrain = ResizingUtils.constrain;
	    var calculatePercentageRatio = ResizingUtils.calculatePercentageRatio;
	    var getScrollBarWidth = ResizingUtils.getScrollBarWidth;
	    var inPercentages = ResizingUtils.inPercentages;
	    var toPercentages = ResizingUtils.toPercentages;
	    var toPixels = ResizingUtils.toPixels;
	    var outerWidth = kendo._outerWidth;

	    var NS = ".kendoEditorColumnResizing";
	    var RESIZE_HANDLE_CLASS = "k-column-resize-handle";
	    var RESIZE_MARKER_CLASS = "k-column-resize-marker";

	    var BODY = "body";
	    var TBODY = "tbody";
	    var THEAD = "thead";
	    var TD = "td";
	    var TH = "th";
	    var TR = "tr";

	    var COLATTR = "col-index";

	    var COMMA = ",";
	    var WIDTH = "width";

	    var ColumnResizing = TableElementResizing.extend({
	        options: {
	            tags: [TD, TH],
	            min: 20,
	            rootElement: null,
	            eventNamespace: NS,
	            rtl: false,
	            handle: {
	                dataAttribute: "column",
	                width: 10,
	                height: 0,
	                classNames: {
	                    handle: RESIZE_HANDLE_CLASS,
	                    marker: RESIZE_MARKER_CLASS
	                },
	                template:
	                    '<div class="k-column-resize-handle-wrapper" unselectable="on" contenteditable="false">' +
	                        '<div class="' + RESIZE_HANDLE_CLASS + '">' +
	                            '<div class="' + RESIZE_MARKER_CLASS + '"></div>' +
	                        '</div>' +
	                    '</div>'
	            }
	        },

	        elementBorderHovered: function(column, e) {
	            var that = this;
	            var options = that.options;
	            var handleWidth = options.handle.width;
	            var borderOffset = column.offset().left + (options.rtl ? 0 : outerWidth(column));


	            var mousePosition = e.clientX + $(column[0].ownerDocument).scrollLeft();

	            if ((mousePosition > (borderOffset - handleWidth)) && (mousePosition < (borderOffset + handleWidth))) {
	                return true;
	            }
	            else {
	                return false;
	            }
	        },

	        setResizeHandlePosition: function(column) {
	            var that = this;
	            var tableInnerElement = $(that.element.tHead || that.element.tBodies[0]);
	            var options = that.options;
	            var rtl = options.rtl;
	            var handleWidth = options.handle.width;
	            var rootElement = $(options.rootElement);
	            var scrollTopOffset = rootElement.is(BODY) ? 0 : rootElement.scrollTop();
	            var scrollLeftOffset = rootElement.is(BODY) ? 0 : kendo.scrollLeft(rootElement);
	            var columnWidthOffset = rtl ? 0 : outerWidth(column);
	            var scrollBarWidth = rtl ? getScrollBarWidth(rootElement[0]) : 0;
	            var columnOffsetLeft = column.offset().left -
	                                    (rootElement.offset().left + parseFloat(rootElement.css("borderLeftWidth"))) -
	                                    parseFloat(column.css("marginLeft"));
	            var innerElementOffsetTop = tableInnerElement.offset().top -
	                                    (rootElement.offset().top + parseFloat(rootElement.css("borderTopWidth"))) -
	                                    parseFloat(tableInnerElement.css("marginTop"));
	            var browser = kendo.support.browser;

	            if(rtl && (browser.mozilla || (browser.webkit && browser.version >= 85))) {
	                scrollLeftOffset = scrollLeftOffset * -1;
	            }

	            that.resizeHandle.css({
	                top: innerElementOffsetTop + scrollTopOffset,
	                left: columnOffsetLeft + columnWidthOffset + (scrollLeftOffset - scrollBarWidth) - (handleWidth / 2),
	                position: "absolute"
	            });
	        },

	        setResizeHandleDimensions: function() {
	            var that = this;
	            var tableHead = $(that.element).children(THEAD);
	            var tableBody = $(that.element).children(TBODY);
	            var fullHeight = tableHead.length > 0 ? tableHead.height() + tableBody.height() : tableBody.height();

	            that.resizeHandle.css({
	                width: that.options.handle.width,
	                height: fullHeight
	            });
	        },

	        setResizeHandleDragPosition: function(e) {
	            var that = this;
	            var column = $($(e.currentTarget).data(that.options.handle.dataAttribute));
	            var options = that.options;
	            var rootElement = $(options.rootElement);
	            var handleWidth = options.handle ? options.handle.width : 0;
	            var min = options.min;
	            var rtl = options.rtl;
	            var columnWidth = outerWidth(column);
	            var columnLeftOffset = column.offset().left -
	                                    (rootElement.offset().left + parseFloat(rootElement.css("borderLeftWidth"))) -
	                                    parseFloat(column.css("marginLeft"));
	            var adjacentColumnWidth = outerWidth(column.next());
	            var resizeHandle = $(that.resizeHandle);
	            var scrollLeftOffset = rootElement.is(BODY) ? 0 : kendo.scrollLeft(rootElement);
	            var scrollBarWidth = rtl ? getScrollBarWidth(rootElement[0]) : 0;
	            var resizeHandleOffsetLeft = resizeHandle.offset().left -
	                                            (rootElement.offset().left + parseFloat(rootElement.css("borderLeftWidth"))) -
	                                            parseFloat(resizeHandle.css("marginLeft"));
	            var browser = kendo.support.browser;

	            if(rtl && (browser.mozilla || (browser.webkit && browser.version >= 85))) {
	                scrollLeftOffset = scrollLeftOffset * -1;
	            }

	            var handleOffset = constrain({
	                value: resizeHandleOffsetLeft + (scrollLeftOffset - scrollBarWidth) + e.x.delta,
	                min: columnLeftOffset + (scrollLeftOffset - scrollBarWidth) - (rtl ? adjacentColumnWidth : 0) + min,
	                max: columnLeftOffset + columnWidth + (scrollLeftOffset - scrollBarWidth) + (rtl ? 0 : adjacentColumnWidth) - handleWidth - min
	            });

	            resizeHandle.css({ left: handleOffset });
	        },

	        resize: function(e) {
	            var that = this;
	            var column = $($(e.currentTarget).data(that.options.handle.dataAttribute));
	            var options = that.options;
	            var rtlModifier = options.rtl ? (-1) : 1;
	            var min = options.min;
	            var initialDeltaX = rtlModifier * e.x.initialDelta;
	            var newWidth;
	            var initialAdjacentColumnWidth;
	            var initialColumnWidth;
	            var colIndex;
	            var nextColumn;

	            dom.reMapTableColumns(that.element, COLATTR);

	            colIndex = parseInt(column.attr(COLATTR), 10);

	            if(column.prop("colSpan") > 1) {
	                column = $(that.element).find("[" + COLATTR + "=" + (colIndex + column.prop("colSpan") - 1) + "]").eq(0);
	                colIndex = parseInt(column.attr(COLATTR), 10);
	            }

	            nextColumn = $(that.element).find("[" + COLATTR + "=" + (colIndex + 1) + "]:not([colspan])");

	            that._setTableComputedWidth();
	            that._setColumnsComputedWidth();

	            initialColumnWidth = outerWidth(column);
	            initialAdjacentColumnWidth = outerWidth(nextColumn);

	            newWidth = constrain({
	                value: initialColumnWidth + initialDeltaX,
	                min: min,
	                max: initialColumnWidth + initialAdjacentColumnWidth - min
	            });

	            that._resizeColumn(column[0], newWidth);
	            that._resizeTopAndBottomColumns(column[0], newWidth);
	            that._resizeAdjacentColumns(parseInt(column.attr(COLATTR),10), initialAdjacentColumnWidth, initialColumnWidth, (initialColumnWidth - newWidth));

	            dom.clearTableMappings(that.element, COLATTR);
	        },

	        _setTableComputedWidth: function() {
	            var element = this.element;

	            if (element.style[WIDTH] === "") {
	                element.style[WIDTH] = toPixels(outerWidth($(element)));
	            }
	        },

	        _setColumnsComputedWidth: function() {
	            var that = this;
	            var tableInnerElement = $(that.element.tHead || that.element.tBodies[0]);
	            var innerElementWidth = outerWidth(tableInnerElement);
	            var columns = tableInnerElement.children(TR).children(TD);
	            var length = columns.length;
	            var currentColumnsWidths = columns.map(function() {
	                return outerWidth($(this));
	            });
	            var i;

	            for (i = 0; i < length; i++) {
	                if (inPercentages(columns[i].style[WIDTH])) {
	                    columns[i].style[WIDTH] = toPercentages(calculatePercentageRatio(currentColumnsWidths[i], innerElementWidth));
	                }
	                else {
	                    columns[i].style[WIDTH] = toPixels(currentColumnsWidths[i]);
	                }
	            }
	        },

	        _resizeTopAndBottomColumns: function(column, newWidth) {
	            var that = this;
	            var columnIndex = $(column).attr(COLATTR);
	            var topAndBottomColumns = $(that.element).children(TBODY + COMMA + THEAD).children(TR).children(that.options.tags.join(COMMA))
	                .filter(function() {
	                    var cell = this;
	                    return ($(cell).attr(COLATTR) === columnIndex && cell !== column);
	                });
	            var length = topAndBottomColumns.length;
	            var i;

	            for (i = 0; i < length; i++) {
	                that._resizeColumn(topAndBottomColumns[i], newWidth);
	            }
	        },

	        _resizeColumn: function(column, newWidth) {
	            var innerTableElement = $(this.element.tHead || this.element.tBodies[0]);
	            if (inPercentages(column.style[WIDTH])) {
	                column.style[WIDTH] = toPercentages(calculatePercentageRatio(newWidth, outerWidth(innerTableElement)));
	            }
	            else {
	                column.style[WIDTH] = toPixels(newWidth);
	            }
	        },

	        _resizeAdjacentColumns: function(columnIndex, initialAdjacentColumnWidth, initialColumnWidth, deltaWidth) {
	            var that = this;
	            var adjacentColumns = $(that.element).children(TBODY + COMMA + THEAD).children(TR).children(that.options.tags.join(COMMA))
	                .filter(function() {
	                    return (parseInt($(this).attr(COLATTR),10) === (columnIndex + 1));
	                });
	            var length = adjacentColumns.length;
	            var i;

	            for (i = 0; i < length; i++) {
	                that._resizeAdjacentColumn(adjacentColumns[i], initialAdjacentColumnWidth, initialColumnWidth, deltaWidth);
	            }
	        },

	        _resizeAdjacentColumn: function(adjacentColumn, initialAdjacentColumnWidth, initialColumnWidth, deltaWidth) {
	            var that = this;
	            var min = that.options.min;
	            var newWidth;

	            newWidth = constrain({
	                value: initialAdjacentColumnWidth + deltaWidth,
	                min: min,
	                max: abs(initialColumnWidth + initialAdjacentColumnWidth - min)
	            });

	            that._resizeColumn(adjacentColumn, newWidth);
	        }
	    });

	    ColumnResizing.create = function(editor) {
	        TableElementResizing.create(editor, {
	            name: "columnResizing",
	            type: ColumnResizing,
	            eventNamespace: NS
	        });
	    };

	    ColumnResizing.dispose = function(editor) {
	        TableElementResizing.dispose(editor, {
	            eventNamespace: NS
	        });
	    };

	    extend(Editor, {
	        ColumnResizing: ColumnResizing
	    });

	})(window.kendo);

	}, __webpack_require__(3));


/***/ }),

/***/ 1002:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lysN");

/***/ }),

/***/ 1003:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("NJlX");

/***/ }),

/***/ 1004:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("N5PI");

/***/ })

/******/ });

/***/ }),

/***/ "7XY/":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1379);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Dz7c");

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1379:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1104), __webpack_require__(1059), __webpack_require__(1109) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "scrollview",
	    name: "ScrollView",
	    category: "web",
	    description: "The Kendo ScrollView widget is used to scroll content wider than the device screen.",
	    depends: [ "fx", "data", "draganddrop" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        proxy = $.proxy,
	        Transition = kendo.effects.Transition,
	        Pane = kendo.ui.Pane,
	        PaneDimensions = kendo.ui.PaneDimensions,
	        Widget = ui.DataBoundWidget,
	        DataSource = kendo.data.DataSource,

	        // Math
	        math = Math,
	        abs  = math.abs,
	        ceil = math.ceil,
	        round = math.round,
	        max = math.max,
	        min = math.min,
	        floor = math.floor,

	        CHANGE = "change",
	        CLICK = "click",
	        CHANGING = "changing",
	        REFRESH = "refresh",
	        CURRENT_PAGE_CLASS = "primary",
	        VIRTUAL_PAGE_CLASS = "scrollview-page",
	        FUNCTION = "function",
	        ITEM_CHANGE = "itemChange",
	        CLEANUP = "cleanup",

	        VIRTUAL_PAGE_COUNT = 3,
	        LEFT_PAGE = -1,
	        CETER_PAGE = 0,
	        RIGHT_PAGE = 1,

	        LEFT_SWIPE = -1,
	        NUDGE = 0,
	        RIGHT_SWIPE = 1;

	    function className(name) {
	        return "k-" + name;
	    }

	    var ScrollViewDataReader = kendo.Observable.extend({
	        init: function(dataSource) {
	            var that = this;
	            this.dataSource = dataSource;
	            this.pendingRequestArray = [];
	            this.initialFetch = false;
	            this.useRanges = dataSource.options.serverPaging;

	            kendo.Observable.fn.init.call(this);

	            dataSource.bind("change", function() {
	                that._change();
	            });
	        },

	        _change: function() {
	            this.trigger("reset", { offset: this.offset });
	        },

	        page: function(page, callback) {
	            var that = this;

	            if (!this.useRanges) {
	                this.dataSource.page(page + 1);
	                if (callback) {
	                    callback(that.dataSource.view());
	                } else {
	                    that.trigger("page", {page: page});
	                }
	             }
	             if (this.useRanges) {
	                this.dataSource.range(page * this.dataSource.pageSize(), this.dataSource.pageSize(), function() {
	                    if (callback) {
	                        callback(that.dataSource.view());
	                    } else {
	                        that.trigger("page", { page: page });
	                    }
	                });
	            }
	        },

	        scrollTo: function(page) {
	            var pageCount = Math.ceil(this.dataSource.total() / this.dataSource.pageSize() || 1);
	            var prevPage = page - 1;
	            var prevPrefetch = prevPage - 1;
	            var currentPage = page;
	            var nextPage = pageCount > 0 && page + 1 >= pageCount ? - 1 : page + 1;
	            var nextPrefetch = pageCount > 0 && nextPage + 1 >= pageCount ? - 1 : nextPage + 1;

	            if (nextPage >= 0) {
	                this.pendingRequestArray.push(nextPage);
	            }

	            if (prevPage >= 0) {
	                this.pendingRequestArray.push(prevPage);
	            }

	            if (prevPrefetch >= 0) {
	                this.pendingRequestArray.push(prevPrefetch);
	            }

	            if (nextPrefetch >= 0) {
	                this.pendingRequestArray.push(nextPrefetch);
	            }

	            this.page(currentPage);
	        },

	        getViewData: function() {
	            var view = this.dataSource.view();
	            var data;
	            if (this.dataSource.options.pageSize > 1) {
	                data = [];
	                for (var index = 0; index < view.length; index++) {
	                    data.push(view[index]);
	                }
	            }
	            else {
	                data = view[0];
	            }
	            return data;
	        },
	        destroy: function() {
	            var that = this;

	            that.dataSource.unbind();
	            that.dataSource = null;
	        }
	    });

	    kendo.ui.ScrollViewDataReader = ScrollViewDataReader;

	    var Pager = kendo.Class.extend({
	        init: function(scrollView) {
	            var that = this,
	                element = $("<ul class='" + className("scrollview-nav") + "'/>"),
	                navigationWrapElement = $("<div class='" + className("scrollview-nav-wrap") + "'></div>");

	            navigationWrapElement.append(element);
	            scrollView._navigationContainer.append(navigationWrapElement);

	            this._changeProxy = proxy(that, "_change");
	            this._refreshProxy = proxy(that, "_refresh");
	            scrollView.bind(CHANGE, this._changeProxy);
	            scrollView.bind(REFRESH, this._refreshProxy);
	            element.on(CLICK, "li.k-link", proxy(this._click, scrollView));

	            $.extend(that, { element: element, scrollView: scrollView });
	        },

	        items: function() {
	            return this.element.children();
	        },

	        _refresh: function(e) {
	            var pageHTML = "";

	            for (var idx = 0; idx < e.pageCount; idx ++) {
	                pageHTML += '<li class="k-link"></li>';
	            }

	            this.element.html(pageHTML);
	            this.items().eq(e.page).addClass(className(CURRENT_PAGE_CLASS));

	            this.scrollView._toggleNavigation({currentPage: e.page});
	        },

	        _change: function(e) {
	            if (e.isDefaultPrevented()) {
	                return;
	            }

	            var innerNavigationContainer = this.scrollView._navigationContainer.find(".k-scrollview-nav");
	            var scrollViewWidth = this.scrollView.element.width();
	            var containerOffset = (scrollViewWidth - innerNavigationContainer.width()) / 2;
	            var pageWidth = innerNavigationContainer.find("li.k-link:eq(0)").outerWidth(true) / 2;

	            this.items()
	                .removeClass(className(CURRENT_PAGE_CLASS))
	                .eq(e.nextPage).addClass(className(CURRENT_PAGE_CLASS));


	            var itemOffset = this.items().eq(e.nextPage).length > 0 ?  this.items().eq(e.nextPage).position().left : 0;

	            if (itemOffset > scrollViewWidth / 2 || itemOffset < kendo.scrollLeft(innerNavigationContainer) + scrollViewWidth / 2) {

	                var translate = 0;
	                if (itemOffset > scrollViewWidth / 2) {
	                    translate = kendo.scrollLeft(innerNavigationContainer) + itemOffset - scrollViewWidth / 2;
	                }
	                else {
	                    translate = kendo.scrollLeft(innerNavigationContainer) - (scrollViewWidth / 2 -itemOffset);
	                }

	                translate += (containerOffset + pageWidth);

	                innerNavigationContainer.animate({"scrollLeft": translate }, 300);
	            }

	            this.scrollView._toggleNavigation({currentPage: e.currentPage, nextPage: e.nextPage});
	        },

	        _click: function(e) {
	            var newPage = $(e.currentTarget).index();

	            this.scrollTo(newPage);
	        },

	        destroy: function() {
	            this.scrollView.unbind(CHANGE, this._changeProxy);
	            this.scrollView.unbind(REFRESH, this._refreshProxy);
	            this.element.off(CLICK);
	            this.element.remove();
	        }
	    });

	    kendo.ui.ScrollViewPager = Pager;

	    var TRANSITION_END = "transitionEnd",
	        DRAG_START = "dragStart",
	        DRAG_END = "dragEnd";

	    var ElasticPane = kendo.Observable.extend({
	        init: function(element, options) {
	            var that = this;

	            kendo.Observable.fn.init.call(this);

	            this.element = element;
	            this.container = element.parent();

	            var movable,
	                transition,
	                userEvents,
	                dimensions,
	                dimension,
	                pane;

	            movable = new kendo.ui.Movable(that.element);

	            transition = new Transition({
	                axis: "x",
	                movable: movable,
	                onEnd: function() {
	                    that.trigger(TRANSITION_END);
	                }
	            });

	            userEvents = new kendo.UserEvents(element, {
	                fastTap: true,
	                start: function(e) {
	                    if (abs(e.x.velocity) * 2 >= abs(e.y.velocity)) {
	                        userEvents.capture();
	                    } else {
	                        userEvents.cancel();
	                    }

	                    that.trigger(DRAG_START, e);
	                    transition.cancel();
	                },
	                allowSelection: true,
	                end: function(e) {
	                    that.trigger(DRAG_END, e);
	                }
	            });

	            dimensions = new PaneDimensions({
	                element: that.element,
	                container: that.container
	            });

	            dimension = dimensions.x;

	            dimension.bind(CHANGE, function() {
	                that.trigger(CHANGE);
	            });

	            pane = new Pane({
	                dimensions: dimensions,
	                userEvents: userEvents,
	                movable: movable,
	                elastic: true
	            });

	            $.extend(that, {
	                duration: options && options.duration || 1,
	                movable: movable,
	                transition: transition,
	                userEvents: userEvents,
	                dimensions: dimensions,
	                dimension: dimension,
	                pane: pane
	            });

	            this.bind([TRANSITION_END, DRAG_START, DRAG_END, CHANGE], options);
	        },

	        size: function() {
	            return { width: this.dimensions.x.getSize(), height: this.dimensions.y.getSize() };
	        },

	        total: function() {
	            return this.dimension.getTotal();
	        },

	        offset: function() {
	            return -this.movable.x;
	        },

	        updateDimension: function() {
	            this.dimension.update(true);
	        },

	        refresh: function() {
	            this.dimensions.refresh();
	            this.dimensions.y.enabled = false;
	        },

	        moveTo: function(offset) {
	            this.movable.moveAxis("x", -offset);
	        },

	        transitionTo: function(offset, ease, instant) {
	            if (instant) {
	                this.moveTo(-offset);
	            } else {
	                this.transition.moveTo({ location: offset, duration: this.duration, ease: ease });
	            }
	        },
	        destroy: function() {
	            var that = this;

	            that.userEvents.destroy();
	            that.unbind();
	            that.movable = that.tansition = that.dimensions = that.dimension = that.pane = null;
	            that.element.remove();
	        }
	    });

	    kendo.ui.ScrollViewElasticPane = ElasticPane;

	    var ScrollViewContent = kendo.Observable.extend({
	        init: function(element, pane, options) {
	            var that = this;

	            kendo.Observable.fn.init.call(this);
	            that.element = element;
	            that.pane = pane;
	            that._getPages();
	            this.page = 0;
	            this.pageSize = options.pageSize || 1;
	            this.contentHeight = options.contentHeight;
	            this.enablePager = options.enablePager;
	            this.pagerOverlay = options.pagerOverlay;
	        },

	        scrollTo: function(page, instant) {
	            var that = this;

	            if (page == that.page && !instant) {
	                return;
	            }

	            if (!that.trigger("resize", { currentPage: this.page, nextPage: page, data: undefined })) {
	                that.page = page;
	                that.pane.transitionTo(- page * that.pane.size().width, Transition.easeOutExpo, instant);
	            }
	        },

	        paneMoved: function(swipeType, bounce, callback, /*internal*/ instant) {
	            var that = this,
	                pane = that.pane,
	                width = pane.size().width * that.pageSize,
	                approx = round,
	                ease = bounce ? Transition.easeOutBack : Transition.easeOutExpo,
	                snap,
	                nextPage;

	            if (swipeType === LEFT_SWIPE) {
	                approx = ceil;
	            } else if (swipeType === RIGHT_SWIPE) {
	                approx = floor;
	            }

	            nextPage = approx(pane.offset() / width);

	            if (nextPage < 0 || nextPage >= that.pageCount) {
	                var tansition = nextPage < 0 ? 0 : (- this.page * this.pane.size().width);
	                return this.pane.transitionTo(tansition, ease, instant);
	            }

	            snap = max(that.minSnap, min(-nextPage * width, that.maxSnap));

	            if (nextPage != that.page) {
	                if (callback && callback({ currentPage: that.page, nextPage: nextPage })) {
	                    snap = -that.page * pane.size().width;
	                }
	            }

	            pane.transitionTo(snap, ease, instant);
	        },

	        updatePage: function() {
	            var pane = this.pane,
	                page = round(pane.offset() / pane.size().width);

	            if (page != this.page) {
	                this.page = page;
	                return true;
	            }

	            return false;
	        },

	        forcePageUpdate: function() {
	            return this.updatePage();
	        },

	        resizeTo: function(size) {
	            var pane = this.pane,
	                width = size.width;

	            this.pageElements.width(width);

	            if (this.contentHeight === "100%") {
	                var containerHeight = this.element.parent().height();

	                if (this.enablePager === true) {
	                    var pager = this.element.parent().find("ul.k-scrollview-nav");
	                    if (!this.pagerOverlay && pager.length) {
	                        containerHeight -= kendo._outerHeight(pager, true);
	                    }
	                }

	                this.element.css("height", containerHeight);
	                this.pageElements.css("height", containerHeight);
	            }

	            // re-read pane dimension after the pageElements have been resized.
	            pane.updateDimension();

	            if (!this._paged) {
	                this.page = floor(pane.offset() / width);
	            }

	            this.scrollTo(this.page, true, true);

	            this.pageCount = floor(pane.total() / width);
	            this.minSnap = - (this.pageCount - 1) * width;
	            this.maxSnap = 0;
	        },

	        _getPages: function() {
	            this.pageElements = this.element.find(kendo.roleSelector("page"));
	            this._paged = this.pageElements.length > 0;
	        },

	        destroy: function() {
	            var that = this;

	            that.pane = null;
	            that.element.remove();
	        }
	    });

	    kendo.ui.ScrollViewContent = ScrollViewContent;

	    var VirtualScrollViewContent = kendo.Observable.extend({
	        init: function(element, pane, options) {
	            var that = this;

	            kendo.Observable.fn.init.call(this);

	            that.element = element;
	            that.pane = pane;
	            that.options = options;
	            that._templates();
	            that.page = options.page || 0;
	            that.pages = [];
	            that._initPages();
	            that.resizeTo(that.pane.size());

	            that.pane.dimension.forceEnabled();
	        },

	        setDataSource: function(dataSource) {
	            this.dataSource = DataSource.create(dataSource);
	            this._dataReader();
	            this._pendingPageRefresh = false;
	            this._pendingWidgetRefresh = false;
	        },

	        _viewShow: function() {
	            var that = this;
	            if (that._pendingWidgetRefresh) {
	                setTimeout(function() {
	                    that._resetPages();
	                }, 0);
	                that._pendingWidgetRefresh = false;
	            }
	        },

	        _dataReader: function() {
	            this.dataReader = new ScrollViewDataReader(this.dataSource);

	            this._pageProxy = proxy(this, "_onPage");
	            this._resetProxy = proxy(this, "_onReset");

	            this.dataReader.bind({
	                "page": this._pageProxy,
	                "reset": this._resetProxy
	            });
	        },

	        _templates: function() {
	            var template = this.options.template,
	                emptyTemplate = this.options.emptyTemplate,
	                templateProxy = {},
	                emptyTemplateProxy = {};

	            if (typeof template === FUNCTION) {
	                templateProxy.template = template;
	                template = "#=this.template(data)#";
	            }

	            this.template = proxy(kendo.template(template), templateProxy);

	            if (typeof emptyTemplate === FUNCTION) {
	                emptyTemplateProxy.emptyTemplate = emptyTemplate;
	                emptyTemplate = "#=this.emptyTemplate(data)#";
	            }

	            this.emptyTemplate = proxy(kendo.template(emptyTemplate), emptyTemplateProxy);
	        },

	        _initPages: function() {
	            var pages = this.pages,
	                element = this.element,
	                page;

	            for (var i = 0; i < VIRTUAL_PAGE_COUNT; i++) {
	                page = new Page(element);
	                pages.push(page);
	            }

	            this.pane.updateDimension();
	        },

	        resizeTo: function(size) {
	            var pages = this.pages,
	                pane = this.pane;

	            for (var i = 0; i < pages.length; i++) {
	                pages[i].setWidth(size.width);
	            }

	            if (this.options.contentHeight === "auto") {
	                this.element.css("height", this.pages[1].element.height());
	            }

	            else if (this.options.contentHeight === "100%") {
	                var containerHeight = this.element.parent().height();

	                if (this.options.enablePager === true) {
	                    var pager = this.element.parent().find("ul.k-scrollview-nav");
	                    if (!this.options.pagerOverlay && pager.length) {
	                        containerHeight -= kendo._outerHeight(pager, true);
	                    }
	                }

	                this.element.css("height", containerHeight);
	                pages[0].element.css("height", containerHeight);
	                pages[1].element.css("height", containerHeight);
	                pages[2].element.css("height", containerHeight);
	            }
	            else if (this.options.contentHeight) {
	                pages[0].element.css("height", this.options.contentHeight);
	                pages[1].element.css("height", this.options.contentHeight);
	                pages[2].element.css("height", this.options.contentHeight);
	            }

	            pane.updateDimension();

	            this._repositionPages();

	            this.width = size.width;
	        },

	        scrollTo: function(page, instant, silent) {
	            var that = this;
	            var dataReader = that.dataReader;

	            if (page == that.page && !instant) {
	                return;
	            }

	            dataReader.page(page, function(data) {
	                if (silent) {
	                    dataReader.scrollTo(page);
	                    return;
	                }
	                if (!that.trigger("resize", { currentPage: that.page, nextPage: page, data: data })) {
	                    if (!instant) {
	                        dataReader.pagerScroll = page > that.page ? - 1 : 1;
	                        that.page = page + dataReader.pagerScroll;
	                    } else {
	                        that.page = page;
	                    }
	                    dataReader.scrollTo(page);
	                }
	            });
	        },
	        paneMoved: function(swipeType, bounce, callback, /*internal*/ instant) {
	            var that = this,
	                pane = that.pane,
	                width = pane.size().width,
	                offset = pane.offset(),
	                thresholdPassed = Math.abs(offset) >= width / 3,
	                ease = bounce ? kendo.effects.Transition.easeOutBack : kendo.effects.Transition. easeOutExpo,
	                isEndReached = that.dataSource.options.serverPaging ? that.page + 2 > that.pageCount : false,
	                nextPage,
	                delta = 0,
	                data,
	                element;

	            if (swipeType === RIGHT_SWIPE) {
	                if (that.page !== 0) {
	                    delta = -1; //backward
	                }
	            } else if (swipeType === LEFT_SWIPE && !isEndReached) {
	                delta = 1; //forward
	            } else if (offset > 0 && (thresholdPassed && !isEndReached)) {
	                delta = 1; //forward
	            } else if (offset < 0 && thresholdPassed) {
	                if (that.page !== 0) {
	                    delta = -1; //backward
	                }
	            }

	            nextPage = that.page;
	            if (delta) {
	                nextPage = (delta > 0) ? nextPage + 1 : nextPage - 1;

	                if(that instanceof kendo.ui.VirtualScrollViewContent) {
	                    that.dataReader.page(nextPage);
	                    data = that.dataReader.getViewData();
	                }
	                else {
	                    data = undefined;
	                }

	                if (!(data instanceof Array)) {
	                    data = [data];
	                }
	                element = that.pages ? that.pages[1].element : undefined;

	            }

	            if (callback && that.page != nextPage && callback({ currentPage: that.page, nextPage: nextPage, element: element, data: data })) {
	                delta = 0;
	            }

	            if (delta === 0) {
	                that._cancelMove(ease, instant);
	            } else if (delta === -1) {
	                that._moveBackward(instant);
	            } else if (delta === 1) {
	                that._moveForward(instant);
	            }
	        },

	        updatePage: function() {
	            var pages = this.pages;

	            if (this.pane.offset() === 0) {
	                return false;
	            }

	            if (this.pane.offset() > 0) {
	                pages.push(this.pages.shift());//forward
	                this.page++;
	                if (this.page + 2 < this.pageCount) {
	                    this.dataReader.pendingRequestArray.push(this.page + 2);
	                }
	                if (this.page + 1 < this.pageCount) {
	                    this.dataReader.page(this.page + 1);
	                }

	                if (this.page + 1 == this.pageCount) {
	                    this.setPageContent(this.pages[2], null);
	                }

	            } else {
	                pages.unshift(this.pages.pop()); //back
	                this.page--;
	                if (this.page - 2 >= 0) {
	                    this.dataReader.pendingRequestArray.push(this.page - 2);
	                }
	                if (this.page - 1 >= 0) {
	                    this.dataReader.page(this.page - 1);
	                }
	            }

	            this._repositionPages();

	            this._resetMovable();

	            return true;
	        },

	        forcePageUpdate: function() {
	            var offset = this.pane.offset(),
	                threshold  = this.pane.size().width * 3/4;

	            if (abs(offset) > threshold) {
	                return this.updatePage();
	            }

	            return false;
	        },

	        _resetMovable: function() {
	            this.pane.moveTo(0);
	        },

	        _moveForward: function(instant) {
	            this.pane.transitionTo(-this.width, kendo.effects.Transition.easeOutExpo, instant);
	        },

	        _moveBackward: function(instant) {
	            this.pane.transitionTo(this.width, kendo.effects.Transition.easeOutExpo, instant);
	        },

	        _cancelMove: function(ease, /*internal*/ instant) {
	            this.pane.transitionTo(0, ease, instant);
	        },

	        _resetPages: function() {
	            this.page = this.options.page || 0;
	            this._repositionPages();

	            this.trigger("reset");
	        },

	        _onPage: function(e) {
	            if (e.page >= this.pageCount) {
	                this.setPageContent(this.pages[2], null);
	            }
	            if (this.page == e.page) {
	                if (!this.dataReader.pagerScroll || this.dataReader.pagerScroll === 0 && this.dataReader.initialFetch) {
	                    this.setPageContent(this.pages[1], this.dataReader.getViewData());
	                }
	                else {
	                    if (this.dataReader.pagerScroll < 0) {
	                        this._moveForward();
	                    }
	                    else {
	                        this._moveBackward();
	                    }

	                    this.dataReader.pagerScroll = 0;
	                    this.setPageContent(this.pages[1], this.dataReader.getViewData());
	                }
	            }
	            else if (this.page + 1 == e.page) {
	                this.setPageContent(this.pages[2], this.dataReader.getViewData());
	            }
	            else if (this.page - 1 == e.page) {
	                this.setPageContent(this.pages[0], this.dataReader.getViewData());
	            }

	            if (this.dataReader.pendingRequestArray.length > 0 && this.dataReader.initialFetch) {
	                var item = this.dataReader.pendingRequestArray.shift();
	                this.dataReader.page(item);
	            }
	        },

	        _onReset: function() {
	            this.pageCount = ceil(this.dataSource.total() / this.dataSource.pageSize());
	        },

	        _repositionPages: function() {
	            var pages = this.pages;

	            pages[0].position(LEFT_PAGE);
	            pages[1].position(CETER_PAGE);
	            pages[2].position(RIGHT_PAGE);
	        },

	        setPageContent: function(page, data) {
	            var template = this.template,
	                emptyTemplate = this.emptyTemplate;

	            if (data !== null && data !== undefined) {
	                page.content(template(data));
	            } else {
	                page.content(emptyTemplate({}));
	            }
	        },

	        destroy: function() {
	            var that = this;
	            var pages = that.pages;

	            that.dataReader.unbind();
	            that.dataSource.unbind();
	            that.dataReader = that.dataSource = that.pane = null;

	            for (var index = 0; index < pages.length; index++) {
	                pages[index].destroy();
	            }

	            that.element.remove();
	        }
	    });

	    kendo.ui.VirtualScrollViewContent = VirtualScrollViewContent;

	    var Page = kendo.Class.extend({
	        init: function(container) {
	            this.element = $("<li class='" + className(VIRTUAL_PAGE_CLASS) + "'></li>");
	            this.width = container.width();
	            this.element.width(this.width);
	            container.append(this.element);
	        },

	        content: function(theContent) {
	            this.element.html(theContent);
	        },

	        position: function(position) { //position can be -1, 0, 1
	            this.element.css("transform", "translate3d(" + this.width * position + "px, 0, 0)");
	        },

	        setWidth: function(width) {
	            this.width = width;
	            this.element.width(width);
	        },

	        destroy: function() {
	            var that = this;

	            that.element.remove();
	            that.element = null;
	        }
	    });

	    kendo.ui.VirtualPage = Page;

	    var ScrollView = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            options = that.options;
	            element = that.element;

	            kendo.stripWhitespace(element[0]);

	            if (element.children().length === 0) {
	                element
	                .wrapInner("<ul class='k-scrollview-wrap'/>");
	            } else {
	                element
	                .wrapInner("<div class='k-scrollview-wrap'/>");
	            }

	            element.addClass("k-widget " + className("scrollview"));

	            that._initNavigation();

	            if (this.options.enablePager) {
	                this.pager = new Pager(this);

	                if (this.options.pagerOverlay) {
	                    element.addClass(className("scrollview-overlay"));
	                }
	            } else {
	                this._changeProxy = proxy(that, "_toggleNavigation");
	                this.bind(CHANGE, this._changeProxy);
	            }

	            that.inner = element.children().first();
	            that.page = 0;

	            that.inner.css("height", options.contentHeight);

	            that.pane = new ElasticPane(that.inner, {
	                duration: this.options.duration,
	                transitionEnd: proxy(this, "_transitionEnd"),
	                dragStart: proxy(this, "_dragStart"),
	                dragEnd: proxy(this, "_dragEnd"),
	                change: proxy(this, REFRESH)
	            });

	            that.bind("resize", function() {
	                that.pane.refresh();
	            });

	            that.page = options.page;

	            var empty = this.inner.children().length === 0;

	            var content = empty ? new VirtualScrollViewContent(that.inner, that.pane, options) : new ScrollViewContent(that.inner, that.pane, options);

	            content.page = that.page;

	            content.bind("reset", function() {
	                this._pendingPageRefresh = false;
	                that.trigger(REFRESH, { pageCount: content.pageCount, page: content.page });
	                that._toggleNavigation({currentPage: content.page, nextPage: content.page });
	            });

	            content.bind("resize", function(e) {
	                var currentPage = content.page;
	                var nextPage = e.nextPage;

	                if (currentPage != nextPage) {
	                    e._defaultPrevented = that.trigger(CHANGE, { currentPage: content.page, nextPage: e.nextPage, data: e.data });
	                }
	                that._toggleNavigation({ currentPage: content.page, nextPage: e.nextPage});
	            });

	            content.bind(ITEM_CHANGE, function(e) {
	                that.trigger(ITEM_CHANGE, e);

	                that.angular("compile", function() {
	                    return { elements: e.item, data: [ { dataItem: e.data } ] };
	                });
	            });

	            content.bind(CLEANUP, function(e) {
	                that.angular("cleanup", function() {
	                    return { elements: e.item };
	                });
	            });

	            that._content = content;
	            that.setDataSource(options.dataSource);
	            this.viewInit();
	            this.viewShow();

	        },

	        options: {
	            name: "ScrollView",
	            page: 0,
	            duration: 400,
	            velocityThreshold: 0.8,
	            contentHeight: "auto",
	            pageSize: 1,
	            bounceVelocityThreshold: 1.6,
	            enablePager: true,
	            enableNavigationButtons: true,
	            pagerOverlay: true,
	            autoBind: true,
	            template: "",
	            emptyTemplate: ""
	        },

	        events: [
	            CHANGING,
	            CHANGE,
	            REFRESH
	        ],

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            this._content.destroy();
	            this.pane.destroy();

	            if (this.pager) {
	                this.pager.destroy();
	            }

	            this.inner = null;
	            kendo.destroy(this.element);
	        },

	        viewInit: function() {
	            if (this.options.autoBind) {
	                this._content.scrollTo(this._content.page, true, true);
	            }
	        },

	        viewShow: function() {
	            this.pane.refresh();
	        },

	        refresh: function() {
	            var content = this._content;
	            var options = this.options;

	            content.resizeTo(this.pane.size());
	            this.page = content.page;

	            if (content instanceof ScrollViewContent || content.dataReader.initialFetch) {
	                if (options.enablePager) {
	                    this.trigger(REFRESH, { pageCount: content.pageCount, page: content.page });
	                }
	                else {
	                    this.trigger(CHANGE, { pageCount: content.pageCount, currentPage: content.page });
	                }
	            }
	        },

	        content: function(html) {
	           this.element.children().first().html(html);
	           this._content._getPages();
	           this.pane.refresh();
	        },

	        scrollTo: function(page, instant, silent) {
	            this._content.scrollTo(page, instant, silent);
	        },

	        prev: function() {
	            var that = this,
	                prevPage =  that._content.page - 1;

	            if (that._content instanceof VirtualScrollViewContent) {
	                that._content.paneMoved(RIGHT_SWIPE, undefined, function(eventData) {
	                    return that.trigger(CHANGE, eventData);
	                });
	            } else if (prevPage > -1) {
	                that.scrollTo(prevPage);
	            }
	        },

	        next: function() {
	            var that = this,
	                nextPage = that._content.page + 1;

	            if (that._content instanceof VirtualScrollViewContent) {
	                that._content.paneMoved(LEFT_SWIPE, undefined, function(eventData) {
	                    return that.trigger(CHANGE, eventData);
	                });
	            } else if (nextPage < that._content.pageCount) {
	                that.scrollTo(nextPage);
	            }
	        },

	        setDataSource: function(dataSource) {
	            var that = this;
	            if (!(this._content instanceof VirtualScrollViewContent)) {
	                return;
	            }
	            // the scrollview should have a ready datasource for MVVM to function properly. But an empty datasource should not empty the element
	            var emptyDataSource = !dataSource;
	            if (dataSource instanceof DataSource) {
	                dataSource.options.pageSize = dataSource.options.pageSize || 1;
	                this.dataSource = dataSource = new DataSource(dataSource.options);
	            }
	            else {
	                this.dataSource = DataSource.create(dataSource);
	            }

	            this._content.setDataSource(this.dataSource);

	            if (this.options.autoBind && !emptyDataSource) {
	                this.dataSource.fetch(function() {
	                    that._content.dataReader.initialFetch = true;
	                    that.scrollTo(that._content.page, true, true);
	                    that._content.trigger("reset");
	                });
	            }
	        },

	        items: function() {
	            return this.element.find(".k-" + VIRTUAL_PAGE_CLASS);
	        },

	        _dragStart: function() {
	            this._content.forcePageUpdate();
	        },

	        _dragEnd: function(e) {
	            var that = this,
	                velocity = e.x.velocity,
	                velocityThreshold = this.options.velocityThreshold,
	                swipeType = NUDGE,
	                bounce = abs(velocity) > this.options.bounceVelocityThreshold;

	            if (velocity > velocityThreshold) {
	                swipeType = RIGHT_SWIPE;
	            } else if (velocity < -velocityThreshold) {
	                swipeType = LEFT_SWIPE;
	            }

	            this._content.paneMoved(swipeType, bounce, function(eventData) {
	                return that.trigger(CHANGE, eventData);
	            });
	        },

	        _transitionEnd: function() {
	            this._content.updatePage();
	        },

	        _initNavigation: function() {
	            var that = this;
	            var navigationContainer = that._navigationContainer = $("<div class='k-scrollview-elements'></div>");
	            var prevArrow = $('<a class="k-scrollview-prev"><span class="k-icon k-i-arrowhead-w"></span></a>').hide();
	            var nextArrow = $('<a class="k-scrollview-next"><span class="k-icon k-i-arrowhead-e"></span></a>').hide();

	            navigationContainer.append(prevArrow);
	            navigationContainer.append(nextArrow);
	            that.element.append(navigationContainer);
	            navigationContainer.on(CLICK, "a.k-scrollview-prev", proxy(that.prev, that));
	            navigationContainer.on(CLICK, "a.k-scrollview-next", proxy(that.next, that));
	        },

	        _toggleNavigation: function(e) {
	            var page = e.nextPage || e.nextPage === 0 ? e.nextPage : e.currentPage;
	            var navigationContainer = this._navigationContainer;
	            var prevArrow = navigationContainer.find(">a.k-scrollview-prev");
	            var nextArrow = navigationContainer.find(">a.k-scrollview-next");

	            prevArrow.hide();
	            nextArrow.hide();

	            if (page || page === 0) {
	                if (page !== 0) {
	                    prevArrow.show();
	                }
	                if (page != this._content.pageCount - 1) {
	                    nextArrow.show();
	                }
	            }
	        }
	    });

	    ui.plugin(ScrollView);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "7Y4C":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1093);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1093:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "columnsorter",
	    name: "Column Sorter",
	    category: "framework",
	    depends: ["core"],
	    advanced: true
	};

	(function ($, undefined) {
	    var kendo = window.kendo;
	    var ui = kendo.ui;
	    var Widget = ui.Widget;
	    var DIR = "dir";
	    var ASC = "asc";
	    var SINGLE = "single";
	    var FIELD = "field";
	    var DESC = "desc";
	    var sorterNS = ".kendoColumnSorter";
	    var TLINK = ".k-link";
	    var ARIASORT = "aria-sort";
	    var proxy = $.proxy;

	    var ColumnSorter = Widget.extend({
	        init: function (element, options) {

	            var that = this, link;

	            Widget.fn.init.call(that, element, options);

	            that._refreshHandler = proxy(that.refresh, that);

	            that.dataSource = that.options.dataSource.bind("change", that._refreshHandler);

	            that.directions = that.options.initialDirection === ASC ? [ASC, DESC] : [DESC, ASC];

	            link = that.element.find(TLINK);

	            if (!link[0]) {
	                link = that.element.wrapInner('<a class="k-link" href="#"/>').find(TLINK);
	            }

	            that.link = link;

	            that.element.on("click" + sorterNS, proxy(that._click, that));
	        },

	        options: {
	            name: "ColumnSorter",
	            mode: SINGLE,
	            allowUnsort: true,
	            compare: null,
	            filter: "",
	            initialDirection: ASC,
	            showIndexes: false
	        },

	        events: ["change"],

	        destroy: function () {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            that.element.off(sorterNS);

	            that.dataSource.unbind("change", that._refreshHandler);
	            that._refreshHandler = that.element = that.link = that.dataSource = null;
	        },

	        refresh: function (e) {
	            if (e && (e.action === "itemchange" || e.action === "sync")) {
	                return;
	            }
	            var that = this,
	                sort = that.dataSource.sort() || [],
	                dir,
	                table,
	                leafCells,
	                element = that.element,
	                field = element.attr(kendo.attr(FIELD)),
	                descriptor = (that.dataSource._sortFields || {})[field],
	                headerIndex,
	                sortOrder;

	            element.removeAttr(kendo.attr(DIR));
	            element.removeAttr(ARIASORT);


	            if (descriptor) {
	                dir = descriptor.dir;
	                element.attr(kendo.attr(DIR), dir);
	                sortOrder = descriptor.index;
	            }

	            if (element.is("th") && descriptor) {
	                table = getColsTable(element);

	                if (table) {
	                    if (element.attr(kendo.attr("index"))) {
	                        leafCells = leafDataCells(element.closest("table"));
	                        headerIndex = leafCells.index(element);
	                    } else {
	                        headerIndex = element.parent().children(":visible").index(element);
	                    }

	                    table.find("col:not(.k-group-col):not(.k-hierarchy-col)").eq(headerIndex).toggleClass("k-sorted", dir !== undefined);
	                }
	            }
	            element.toggleClass("k-sorted", dir !== undefined);
	            element.find(".k-i-sort-asc-sm,.k-i-sort-desc-sm,.k-sort-order").remove();

	            if (dir === ASC) {
	                $('<span class="k-icon k-i-sort-asc-sm" />').appendTo(that.link);
	                element.attr(ARIASORT, "ascending");
	            } else if (dir === DESC) {
	                $('<span class="k-icon k-i-sort-desc-sm" />').appendTo(that.link);
	                element.attr(ARIASORT, "descending");
	            }
	            if (that.options.showIndexes && sort.length > 1 && sortOrder) {
	                $('<span class="k-sort-order" />').html(sortOrder).appendTo(that.link);
	            }
	        },

	        _toggleSortDirection: function(dir) {
	            var directions = this.directions;
	            if (dir === directions[directions.length - 1] && this.options.allowUnsort) {
	                return undefined;
	            }
	            return directions[0] === dir ? directions[1] : directions[0];
	        },

	        _click: function (e) {
	            var that = this,
	                element = that.element,
	                field = element.attr(kendo.attr(FIELD)),
	                dir = element.attr(kendo.attr(DIR)),
	                options = that.options,
	                compare = that.options.compare === null ? undefined : that.options.compare,
	                sort = that.dataSource.sort() || [],
	                idx,
	                length;

	            e.preventDefault();

	            if (options.filter && !element.is(options.filter)) {
	                return;
	            }

	            dir = this._toggleSortDirection(dir);

	            if (this.trigger("change", { sort: { field: field, dir: dir, compare: compare } })) {
	                return;
	            }

	            if (options.mode === SINGLE) {
	                sort = [{ field: field, dir: dir, compare: compare }];
	            } else if (options.mode === "multiple") {
	                for (idx = 0, length = sort.length; idx < length; idx++) {
	                    if (sort[idx].field === field) {
	                        sort.splice(idx, 1);
	                        break;
	                    }
	                }
	                sort.push({ field: field, dir: dir, compare: compare });
	            }

	            if (this.dataSource.options.endless) {
	                this.dataSource.options.endless = null;
	                element.closest(".k-grid").getKendoGrid()._endlessPageSize = that.dataSource.options.pageSize;
	                this.dataSource.pageSize(that.dataSource.options.pageSize);
	            }
	            this.dataSource.sort(sort);
	        }
	    });

	    function leafDataCells(container) {
	        var rows = container.find("tr:not(.k-filter-row)");
	        var indexAttr = kendo.attr("index");

	        var cells = rows.find("th[" + indexAttr + "]:visible");

	        cells.sort(function(a, b) {
	            a = $(a);
	            b = $(b);

	            var indexA = a.attr(indexAttr);
	            var indexB = b.attr(indexAttr);

	            if (indexA === undefined) {
	                indexA = $(a).index();
	            }
	            if (indexB === undefined) {
	                indexB = $(b).index();
	            }

	            indexA = parseInt(indexA, 10);
	            indexB = parseInt(indexB, 10);
	            return indexA > indexB ? 1 : (indexA < indexB ? -1 : 0);
	        });

	        return cells;
	    }

	    function getColsTable(element) {
	        var table = null;
	        if (element.is("th")) {
	            table = element.closest("table");
	            if (table.parent().hasClass("k-grid-header-wrap")) {
	                table = table.closest(".k-grid").find(".k-grid-content > table");
	            } else if (table.parent().hasClass("k-grid-header-locked")) {
	                table = table.closest(".k-grid").find(".k-grid-content-locked > table");
	            }
	        }
	        return table;
	    }

	    ui.plugin(ColumnSorter);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "7Ygf":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1619);
	module.exports = __webpack_require__(1619);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1619:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// -*- fill-column: 100 -*-

	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	    // WARNING: removing the following jshint declaration and turning
	    // == into === to make JSHint happy will break functionality.
	    /* jshint eqnull:true, laxbreak:true */

	    "use strict";

	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var spreadsheet = kendo.spreadsheet;
	    var Class = kendo.Class;

	    function columnName(colIndex) {
	        var letter = Math.floor(colIndex / 26) - 1;
	        return (letter >= 0 ? columnName(letter) : "") + String.fromCharCode(65 + (colIndex % 26));
	    }

	    function displaySheet(sheet) {
	        if (/^[a-z_][a-z0-9_]*$/i.test(sheet)) {
	            return sheet;
	        }
	        return "'" + sheet.replace(/\x27/g, "\\'") + "'";
	    }

	    function displayRef(sheet, row, col, rel) {
	        var aa = "";

	        ++row;

	        if (!isFinite(row)) {
	            row = "";
	        }
	        else if (rel != null && !(rel & 2)) {
	            row = "$" + row;
	        }

	        if (!isFinite(col)) {
	            col = "";
	        }
	        else {
	            aa = columnName(col);
	            if (rel != null && !(rel & 1)) {
	                aa = "$" + aa;
	            }
	        }

	        if (sheet) {
	            return displaySheet(sheet) + "!" + aa + row;
	        } else {
	            return aa + row;
	        }
	    }

	    /* -----[ References ]----- */

	    var Ref = Class.extend({
	        type: "ref",
	        sheet: "",
	        clone: function() {
	            return this;
	        },
	        hasSheet: function() {
	            return this._hasSheet;
	        },
	        simplify: function() {
	            return this;
	        },
	        setSheet: function(sheet, hasSheet) {
	            this.sheet = sheet;
	            if (hasSheet != null) {
	                this._hasSheet = hasSheet;
	            }
	            return this;
	        },
	        absolute: function(){
	            return this;
	        },
	        relative: function(){
	            return this;
	        },
	        adjust: function(){
	            return this;
	        },
	        toString: function() {
	            return this.relative(0, 0, 3, 3).print(0, 0);
	        },
	        forEach: function(callback, obj) {
	            callback.call(obj, this);
	        },
	        map: function(callback, obj) {
	            return callback.call(obj, this);
	        },
	        intersects: function(ref) {
	            return this.intersect(ref) !== NULL;
	        },
	        isCell: function() {
	            return false;
	        },
	        toRow: function() {
	            return this;
	        },
	        toColumn: function() {
	            return this;
	        },

	        // UnionRef overrides these, to access its subranges.
	        first: function() {
	            return this;
	        },
	        lastRange: function() {
	            return this;
	        },
	        size: function() {
	            return 1;
	        },
	        rangeAt: function() {
	            return this;
	        },
	        nextRangeIndex: function() {
	            return 0;
	        },
	        previousRangeIndex: function() {
	            return 0;
	        },
	        eq: function(reference) {
	            var r1 = this;
	            var r2 = reference;

	            if (r1 === NULL || r2 === NULL) {
	                return r1 === r2;
	            }

	            // make positions consistent
	            if ((r2 instanceof CellRef) || (r2 instanceof RangeRef && !(r1 instanceof CellRef))) {
	               r1 = reference;
	               r2 = this;
	            }

	            if (r1 instanceof CellRef) { // cell eq *
	                r2 = r2.simplify();
	                return r2 instanceof CellRef && r1.row == r2.row && r1.col == r2.col && r1.sheet == r2.sheet;
	            }
	            else if (r1 instanceof RangeRef) { // range eq range/union
	                if (r2 instanceof RangeRef) {
	                    return r2.topLeft.eq(r1.topLeft) && r2.bottomRight.eq(r1.bottomRight);
	                }
	                if (r2 instanceof UnionRef) {
	                    return r2.single() && r1.eq(r2.refs[0]);
	                }
	            }
	            else if (r1 instanceof UnionRef && r2 instanceof UnionRef) { // union eq union
	                var refs1 = r1.refs;
	                var refs2 = r2.refs;
	                if (refs1.length != refs2.length) {
	                   return false;
	                }

	                for (var i = 0, len = refs1.length; i < len; i++) {
	                    if (!refs1[i].eq(refs2[i])) {
	                        return false;
	                    }
	                }

	                return true;
	            }

	            return r1 === r2;   // XXX: possibly NameRef when we'll support it.
	        },

	        concat: function(ref) {
	            return new UnionRef([this, ref]);
	        },

	        replaceAt: function(index, ref) {
	            return ref;
	        },

	        forEachColumnIndex: function(callback) {
	            this.forEachAxisIndex('col', callback);
	        },

	        forEachRowIndex: function(callback) {
	            this.forEachAxisIndex('row', callback);
	        },

	        forEachAxisIndex: function(axis, callback) {
	            var sorted = [];

	            var method = axis === 'row' ? 'forEachRow' : 'forEachColumn';

	            this[method](function(ref) {
	                var index = ref.first()[axis];
	                if (sorted.indexOf(index) === -1) {
	                    sorted.push(index);
	                }
	            });

	            sorted.sort(function(a,b) {
	                return a > b ? 1 : (a < b ? -1 : 0);
	            }).forEach(callback);
	        },

	        valid: function() {
	            return false;
	        },

	        renameSheet: function(oldSheetName, newSheetName) {
	            if (this.sheet && this.sheet.toLowerCase() == oldSheetName.toLowerCase()) {
	                this.sheet = newSheetName;
	                return true;
	            }
	        }
	    });

	    Ref.display = displayRef;

	    /* -----[ Null reference ]----- */

	    var NULL = new (Ref.extend({
	        init: function NullRef(){},
	        print: function() {
	            return "#NULL!";
	        },
	        eq: function(ref) {
	            return ref === this;
	        },
	        forEach: function() {}
	    }))();

	    /* -----[ Name reference ]----- */

	    var NameRef = Ref.extend({
	        ref: "name",
	        init: function NameRef(name){
	            this.name = name;
	        },
	        clone: function() {
	            return new NameRef(this.name)
	                .setSheet(this.sheet, this.hasSheet());
	        },
	        print: function() {
	            var ret = displaySheet(this.name);
	            if (this.hasSheet()) {
	                ret = displaySheet(this.sheet) + "!" + ret;
	            }
	            return ret;
	        }
	    });

	    /* -----[ Cell reference ]----- */

	    var CellRef = Ref.extend({
	        ref: "cell",
	        init: function CellRef(row, col, rel) {
	            this.row = row;
	            this.col = col;
	            this.rel = rel || 0;
	        },
	        clone: function() {
	            return new CellRef(this.row, this.col, this.rel)
	                .setSheet(this.sheet, this.hasSheet());
	        },
	        intersect: function(ref) {
	            if (ref instanceof CellRef) {
	                if (this.eq(ref)) {
	                    return this;
	                } else {
	                    return NULL;
	                }
	            }
	            return ref.intersect(this);
	        },
	        print: function(trow, tcol, mod) {
	            var col = this.col, row = this.row, rel = this.rel, abs;
	            if (trow == null && rel) {
	                var sheet = this.hasSheet() ? displaySheet(this.sheet) + "!" : "";
	                if (isFinite(col)) {
	                    col = rel & 1 ? ("C[" + col + "]") : ("C" + (col + 1));
	                } else {
	                    col = "";
	                }
	                if (isFinite(row)) {
	                    row = rel & 2 ? ("R[" + row + "]") : ("R" + (row + 1));
	                } else {
	                    row = "";
	                }
	                return sheet + row + col;
	            } else {
	                abs = this.absolute(trow, tcol);
	                if (mod) {
	                    // Hacks: see the big comment below in `absolute()`
	                    row = abs.row % 0x100000;
	                    col = abs.col % 0x4000;
	                    if (row < 0) {
	                        row += 0x100000;
	                    }
	                    if (col < 0) {
	                        col += 0x4000;
	                    }
	                    return displayRef(this._hasSheet && this.sheet, row, col, rel);
	                }
	                return abs.valid() ? displayRef(this._hasSheet && this.sheet, abs.row, abs.col, rel) : "#REF!";
	            }
	        },
	        absolute: function(arow, acol) {
	            var ret = this.clone();
	            if (ret.rel & 3 === 0) {
	                return ret;    // already absolute
	            }

	            // Hacks: we make coordinates modulo 0x4000 (max col) and 0x100000 (max row).  This
	            // fixes importing relative references in definedName-s from Excel.  Example in
	            // Excel: select cell E3, open the Name Manager (in Formula tab) and define name
	            // TEST with value Sheet1!A1:C3.  The serialization of this name in XLSX is:
	            //
	            //     <definedName name="TEST">Sheet1!XFA1048575:XFC1</definedName>
	            //
	            // This is insane, of course, but oh well.  Excel.  If you type in E3 =SUM(TEST) it
	            // works (it actually sums the cells), but if you type =SUM(Sheet1!XFA1048575:XFC1)
	            // you get back zero.  Let's see why SUM(TEST) works:
	            //
	            //     XFA1048575:XFC1                   E3
	            //     (zero-based indexes below)
	            //
	            //     R[1048574]C[16380]:R[0]C[16382] + R2C4 = R1048576C16384:R2C16386
	            //                                            % (0x100000, 0x4000)
	            //                                            = R0C0:R2C2 (== A1:C3)
	            //
	            // So XFA1048575:XFC1 is relocated to E3 at evaluation time, and because we take
	            // rows modulo 0x100000 and cols modulo 0x4000, we get back the correct range.
	            //
	            // IMO Excel should disallow A1-style relative references in name definitions
	            // (simply because the meaning of the A1:C3 you type in Name Manager depends on the
	            // active cell) and only allow R1C1 notation — that's unambiguous.  But it doesn't.
	            // Moreover, R1C1-style refs in XLSX are explicitly forbidden by the spec, and the
	            // hacks above are not documented — how else could we have fun implementing a XLSX
	            // reader?
	            if (ret.rel & 1) {
	                // relative col, add anchor
	                ret.col = (ret.col + acol) % 0x4000;
	            }
	            if (ret.rel & 2) {
	                // relative row, add anchor
	                ret.row = (ret.row + arow) % 0x100000;
	            }

	            ret.rel = 0;
	            return ret;
	        },
	        toRangeRef: function() {
	            return new RangeRef(this, this);
	        },
	        relative: function(arow, acol, rel) {
	            if (rel == null) {
	                rel = this.rel;
	            }
	            var row = rel & 2 ? this.row - arow : this.row;
	            var col = rel & 1 ? this.col - acol : this.col;
	            return new CellRef(row, col, rel)
	                .setSheet(this.sheet, this.hasSheet());
	        },
	        height: function() {
	            return 1;
	        },
	        width: function() {
	            return 1;
	        },
	        toString: function() {
	            return displayRef(null, this.row, this.col, 3);
	        },
	        isCell: function() {
	            return true;
	        },
	        leftColumn: function() {
	            return this;
	        },
	        rightColumn: function() {
	            return this;
	        },
	        topRow: function() {
	            return this;
	        },
	        bottomRow: function() {
	            return this;
	        },
	        forEachRow: function(callback) {
	            callback(this.toRangeRef());
	        },
	        forEachColumn: function(callback) {
	            callback(this.toRangeRef());
	        },
	        adjust: function(row, col, trow, tcol, forRow, start, delta) {
	            var ref = this.absolute(row, col);
	            if (forRow) {
	                if (ref.row >= start) {
	                    if (delta < 0 && ref.row < start - delta) {
	                        return NULL;
	                    }
	                    ref.row += delta;
	                }
	            } else {
	                if (ref.col >= start) {
	                    if (delta < 0 && ref.col < start - delta) {
	                        return NULL;
	                    }
	                    ref.col += delta;
	                }
	            }
	            if (trow != null && tcol != null) {
	                ref = ref.relative(trow, tcol, this.rel);
	            }
	            return ref;
	        },
	        valid: function() {
	            if (this.rel) {
	                throw new Error("valid() called on relative reference");
	            }
	            var col = this.col, row = this.row;
	            return !((isFinite(col) && col < 0) || (isFinite(row) && row < 0));
	        }
	    });

	    /* -----[ Range reference ]----- */

	    var RangeRef = Ref.extend({
	        ref: "range",
	        init: function RangeRef(tl, br) {
	            if (tl._hasSheet && br._hasSheet && tl.sheet.toLowerCase() != br.sheet.toLowerCase()) {
	                // "3D" reference
	                this.endSheet = br.sheet;
	            }
	            // we want to drop any sheet information from the cells here.
	            this.topLeft = new CellRef(tl.row, tl.col, tl.rel);
	            this.bottomRight = new CellRef(br.row, br.col, br.rel);
	            this.normalize();
	        },
	        clone: function() {
	            return new RangeRef(this.topLeft.clone(), this.bottomRight.clone()).setSheet(this.sheet, this.hasSheet());
	        },
	        _containsRange: function(range) {
	            return this._containsCell(range.topLeft)
	                && this._containsCell(range.bottomRight);
	        },
	        _containsCell: function(cell) {
	            return cell.sheet == this.sheet
	                && cell.row >= this.topLeft.row
	                && cell.col >= this.topLeft.col
	                && cell.row <= this.bottomRight.row
	                && cell.col <= this.bottomRight.col;
	        },
	        contains: function(ref) {
	            if (ref instanceof Array) {
	                var that = this;

	                return ref.some(function(_ref) { return that.contains(_ref); });
	            }
	            if (ref instanceof CellRef) {
	                return this._containsCell(ref);
	            }
	            if (ref instanceof RangeRef) {
	                return this._containsRange(ref);
	            }
	            return false;
	        },
	        _intersectRange: function(ref) {
	            if (this.sheet != ref.sheet) {
	                return NULL;
	            }
	            var a_left    = this.topLeft.col;
	            var a_top     = this.topLeft.row;
	            var a_right   = this.bottomRight.col;
	            var a_bottom  = this.bottomRight.row;
	            var b_left    = ref.topLeft.col;
	            var b_top     = ref.topLeft.row;
	            var b_right   = ref.bottomRight.col;
	            var b_bottom  = ref.bottomRight.row;
	            if (a_left <= b_right &&
	                b_left <= a_right &&
	                a_top <= b_bottom &&
	                b_top <= a_bottom)
	            {
	                return new RangeRef(
	                    // topLeft
	                    new CellRef(Math.max(a_top, b_top),
	                                Math.max(a_left, b_left)),
	                    // bottomRight
	                    new CellRef(Math.min(a_bottom, b_bottom),
	                                Math.min(a_right, b_right))
	                ).setSheet(this.sheet, this.hasSheet());
	            } else {
	                return NULL;
	            }
	        },
	        intersect: function(ref) {
	            if (ref instanceof CellRef) {
	                return this._containsCell(ref) ? ref : NULL;
	            }
	            if (ref instanceof RangeRef) {
	                return this._intersectRange(ref).simplify();
	            }
	            if (ref instanceof UnionRef) {
	                return ref.intersect(this);
	            }
	            return NULL;        // can't handle NameRef-s here.
	        },
	        simplify: function() {
	            if (this.isCell()) {
	                return new CellRef(
	                    this.topLeft.row,
	                    this.topLeft.col,
	                    this.topLeft.rel
	                ).setSheet(this.sheet, this.hasSheet());
	            }
	            return this;
	        },
	        normalize: function() {
	            var a = this.topLeft, b = this.bottomRight;
	            var r1 = a.row, c1 = a.col, r2 = b.row, c2 = b.col;
	            var rr1 = a.rel & 2, rc1 = a.rel & 1;
	            var rr2 = b.rel & 2, rc2 = b.rel & 1;
	            var tmp, changes = false;
	            // do not attempt to normalize unless relativeness of rows and cols are the same.
	            // https://github.com/telerik/kendo-ui-core/issues/4278
	            if (rr1 === rr2 && rc1 === rc2) {
	                if (r1 > r2) {
	                    changes = true;
	                    tmp = r1; r1 = r2; r2 = tmp;
	                    tmp = rr1; rr1 = rr2; rr2 = tmp;
	                }
	                if (c1 > c2) {
	                    changes = true;
	                    tmp = c1; c1 = c2; c2 = tmp;
	                    tmp = rc1; rc1 = rc2; rc2 = tmp;
	                }
	                if (changes) {
	                    this.topLeft = new CellRef(r1, c1, rc1 | rr1);
	                    this.bottomRight = new CellRef(r2, c2, rc2 | rr2);
	                }
	            }
	            return this;
	        },
	        print: function(trow, tcol, mod) {
	            if (mod || this.absolute(trow, tcol).valid()) {
	                var ret = this.topLeft.print(trow, tcol, mod)
	                    + ":"
	                    + this.bottomRight.print(trow, tcol, mod);
	                if (this.hasSheet()) {
	                    ret = displaySheet(this.sheet)
	                        + (this.endSheet ? ":" + displaySheet(this.endSheet) : "")
	                        + "!" + ret;
	                }
	                return ret;
	            }
	            return "#REF!";
	        },
	        absolute: function(arow, acol) {
	            return new RangeRef(
	                this.topLeft.absolute(arow, acol),
	                this.bottomRight.absolute(arow, acol)
	            ).setSheet(this.sheet, this.hasSheet());
	        },
	        relative: function(arow, acol, relTL, relBR) {
	            if (relBR == null) {
	                relBR = relTL;
	            }
	            return new RangeRef(
	                this.topLeft.relative(arow, acol, relTL),
	                this.bottomRight.relative(arow, acol, relBR)
	            ).setSheet(this.sheet, this.hasSheet());
	        },
	        height: function() {
	            if (this.topLeft.rel != this.bottomRight.rel) {
	                throw new Error("Mixed relative/absolute references");
	            }
	            return this.bottomRight.row - this.topLeft.row + 1;
	        },
	        width: function() {
	            if (this.topLeft.rel != this.bottomRight.rel) {
	                throw new Error("Mixed relative/absolute references");
	            }
	            return this.bottomRight.col - this.topLeft.col + 1;
	        },
	        collapse: function() {
	            return this.topLeft.toRangeRef();
	        },
	        leftColumn: function() {
	            return new RangeRef(this.topLeft, new CellRef(this.bottomRight.row, this.topLeft.col));
	        },
	        rightColumn: function() {
	            return new RangeRef(new CellRef(this.topLeft.row, this.bottomRight.col), this.bottomRight);
	        },
	        topRow: function() {
	            return new RangeRef(this.topLeft, new CellRef(this.topLeft.row, this.bottomRight.col));
	        },
	        bottomRow: function() {
	            return new RangeRef(new CellRef(this.bottomRight.row, this.topLeft.col), this.bottomRight);
	        },
	        toRangeRef: function() {
	            return this;
	        },
	        toRow: function(row) {
	            row += Math.max(0, this.topLeft.row);
	            return new RangeRef(
	                new CellRef(row, this.topLeft.col),
	                new CellRef(row, this.bottomRight.col)
	            ).setSheet(this.sheet, this.hasSheet());
	        },
	        toColumn: function(col) {
	            col += Math.max(0, this.topLeft.col);
	            return new RangeRef(
	                new CellRef(this.topLeft.row, col),
	                new CellRef(this.bottomRight.row, col)
	            ).setSheet(this.sheet, this.hasSheet());
	        },
	        toCell: function(row, col) {
	            row += Math.max(0, this.topLeft.row);
	            col += Math.max(0, this.topLeft.col);
	            return new CellRef(row, col, 0)
	                .setSheet(this.sheet, this.hasSheet());
	        },
	        forEachRow: function(callback) {
	            var startRow = this.topLeft.row;
	            var endRow = this.bottomRight.row;
	            var startCol = this.topLeft.col;
	            var endCol = this.bottomRight.col;

	            for (var i = startRow; i <= endRow; i++) {
	                callback(new RangeRef(
	                    new CellRef(i, startCol),
	                    new CellRef(i, endCol)
	                ));
	            }
	        },
	        forEachColumn: function(callback) {
	            var startRow = this.topLeft.row;
	            var endRow = this.bottomRight.row;
	            var startCol = this.topLeft.col;
	            var endCol = this.bottomRight.col;

	            for (var i = startCol; i <= endCol; i++) {
	                callback(new RangeRef(
	                    new CellRef(startRow, i),
	                    new CellRef(endRow, i)
	                ));
	            }
	        },
	        intersecting: function(refs) {
	            return refs.filter(function(ref) {
	                return ref.toRangeRef().intersects(this);
	            }, this);
	        },

	        union: function(refs, callback) {
	            var intersecting = this.intersecting(refs);

	            var topLeftRow = this.topLeft.row;
	            var topLeftCol = this.topLeft.col;
	            var bottomRightRow = this.bottomRight.row;
	            var bottomRightCol = this.bottomRight.col;

	            var modified = false;

	            intersecting.forEach(function(ref) {
	                ref = ref.toRangeRef();
	                if (ref.topLeft.row < topLeftRow) {
	                    modified = true;
	                    topLeftRow = ref.topLeft.row;
	                }

	                if (ref.topLeft.col < topLeftCol) {
	                    modified = true;
	                    topLeftCol = ref.topLeft.col;
	                }

	                if (ref.bottomRight.row > bottomRightRow) {
	                    modified = true;
	                    bottomRightRow = ref.bottomRight.row;
	                }

	                if (ref.bottomRight.col > bottomRightCol) {
	                    modified = true;
	                    bottomRightCol = ref.bottomRight.col;
	                }

	                if (callback) {
	                    callback(ref);
	                }
	            });

	            var result = new RangeRef(
	                new CellRef(topLeftRow, topLeftCol),
	                new CellRef(bottomRightRow, bottomRightCol)
	            );

	            if (modified) {
	                return result.union(refs, callback);
	            } else {
	                return result;
	            }
	        },
	        resize: function(options) {
	            var limit = Math.max.bind(Math, 0);
	            function num(value) { return value || 0; }

	            var top = this.topLeft.row + num(options.top);
	            var left = this.topLeft.col + num(options.left);
	            var bottom = this.bottomRight.row + num(options.bottom);
	            var right = this.bottomRight.col + num(options.right);

	            if (left < 0 && right < 0 || top < 0 && bottom < 0) {
	                return NULL;
	            } else if (top <= bottom && left <= right) {
	                return new RangeRef(new CellRef(limit(top), limit(left)),
	                                    new CellRef(limit(bottom), limit(right)));
	            } else {
	                return NULL;
	            }
	        },
	        move: function(rows, cols) {
	            return new RangeRef(
	                new CellRef(this.topLeft.row + rows,
	                            this.topLeft.col + cols),
	                new CellRef(this.bottomRight.row + rows,
	                            this.bottomRight.col + cols)
	            );
	        },
	        first: function() {
	            return this.topLeft.clone().setSheet(this.sheet, this.hasSheet());
	        },
	        isCell: function() {
	            return !this.endSheet && this.topLeft.eq(this.bottomRight);
	        },
	        toString: function() {
	            return this.topLeft + ":" + this.bottomRight;
	        },
	        adjust: function(row, col, trow, tcol, forRow, start, delta) {
	            var tl = this.topLeft.adjust(row, col, trow, tcol, forRow, start, delta);
	            var tr = this.bottomRight.adjust(row, col, trow, tcol, forRow, start, delta);
	            if (tl === NULL && tr === NULL) {
	                return NULL;
	            }
	            if (tl === NULL) {
	                tl = this.topLeft.absolute(row, col);
	                if (forRow) {
	                    tl.row = start;
	                } else {
	                    tl.col = start;
	                }
	                if (trow != null && tcol != null) {
	                    tl = tl.relative(trow, tcol, this.topLeft.rel);
	                }
	            }
	            else if (tr === NULL) {
	                tr = this.bottomRight.absolute(row, col);
	                if (forRow) {
	                    tr.row = start - 1;
	                } else {
	                    tr.col = start - 1;
	                }
	                if (trow != null && tcol != null) {
	                    tr = tr.relative(trow, tcol, this.bottomRight.rel);
	                }
	            }
	            return new RangeRef(tl, tr)
	                .setSheet(this.sheet, this.hasSheet())
	                .simplify();
	        },
	        valid: function() {
	            return this.topLeft.valid() && this.bottomRight.valid();
	        }
	    });

	    /* -----[ Union reference ]----- */

	    var UnionRef = Ref.extend({
	        init: function UnionRef(refs){
	            this.refs = refs;
	            this.length = refs.length;
	        },
	        clone: function() {
	            return new UnionRef(this.refs.slice());
	        },
	        intersect: function(ref) {
	            var a = [];
	            for (var i = 0; i < this.length; ++i) {
	                var x = ref.intersect(this.refs[i]);
	                if (x !== NULL) {
	                    a.push(x);
	                }
	            }
	            if (a.length > 0) {
	                return new UnionRef(a).simplify();
	            }
	            return NULL;
	        },
	        simplify: function() {
	            var u = new UnionRef(this.refs.reduce(function(a, ref){
	                ref = ref.simplify();
	                if (ref !== NULL) {
	                    a.push(ref);
	                }
	                return a;
	            }, []));
	            if (u.empty()) {
	                return NULL;
	            }
	            if (u.single()) {
	                return u.refs[0];
	            }
	            return u;
	        },
	        absolute: function(arow, acol) {
	            return new UnionRef(this.refs.map(function(ref){
	                return ref.absolute(arow, acol);
	            }));
	        },
	        forEach: function(callback, obj) {
	            this.refs.forEach(function(ref){
	                if (ref instanceof UnionRef) {
	                    ref.forEach(callback, obj);
	                } else {
	                    callback.call(obj, ref);
	                }
	            }, obj);
	        },
	        toRangeRef: function() {
	            return this.refs[0].toRangeRef();
	        },
	        contains: function(theRef) {
	            return this.refs.some(function(ref) { return ref.contains(theRef); });
	        },
	        map: function(callback, obj) {
	            var refs = [];
	            this.forEach(function(ref){
	                refs.push(callback.call(obj, ref));
	            });
	            return new UnionRef(refs);
	        },
	        first: function() {
	            return this.refs[0].first();
	        },
	        lastRange: function() {
	            return this.refs[this.length - 1];
	        },
	        size: function() {
	            return this.length;
	        },
	        single: function() {
	            return this.length == 1;
	        },
	        empty: function() {
	            return this.length === 0;
	        },
	        isCell: function() {
	            return this.single() && this.refs[0].isCell();
	        },
	        rangeAt: function(index) {
	            return this.refs[index];
	        },
	        nextRangeIndex: function(index) {
	            if (index === this.length - 1) {
	                return 0;
	            } else {
	                return index + 1;
	            }
	        },
	        previousRangeIndex: function(index) {
	            if (index === 0) {
	                return this.length - 1;
	            } else {
	                return index - 1;
	            }
	        },
	        concat: function(ref) {
	            return new UnionRef(this.refs.concat([ref]));
	        },
	        print: function(row, col, mod) {
	            return this.refs.map(function(ref) { return ref.print(row, col, mod); }).join(",");
	        },

	        replaceAt: function(index, ref) {
	            var newRefs = this.refs.slice();
	            newRefs.splice(index, 1, ref);
	            return new UnionRef(newRefs);
	        },

	        leftColumn: function() {
	            return this.map(function(ref) {
	                return ref.leftColumn();
	            });
	        },
	        rightColumn: function() {
	            return this.map(function(ref) {
	                return ref.rightColumn();
	            });
	        },
	        topRow: function() {
	            return this.map(function(ref) {
	                return ref.topRow();
	            });
	        },
	        bottomRow: function() {
	            return this.map(function(ref) {
	                return ref.bottomRow();
	            });
	        },
	        forEachRow: function(callback) {
	            this.forEach(function(ref) {
	                ref.forEachRow(callback);
	            });
	        },
	        forEachColumn: function(callback) {
	            this.forEach(function(ref) {
	                ref.forEachColumn(callback);
	            });
	        },
	        adjust: function(row, col, trow, tcol, forRow, start, delta) {
	            return this.map(function(ref){
	                return ref.adjust(row, col, trow, tcol, forRow, start, delta);
	            }).simplify();
	        },
	        toString: function() {
	            return this.refs.map(function(ref){
	                return ref.toString();
	            }).join(", ");
	        },
	        valid: function() {
	            for (var i = this.refs.length; --i >= 0;) {
	                if (this.refs[i].valid()) {
	                    return false;
	                }
	            }
	            return true;
	        },
	        renameSheet: function(oldSheetName, newSheetName) {
	            this.refs.forEach(function(ref){
	                ref.renameSheet(oldSheetName, newSheetName);
	            });
	        }
	    });

	    /* -----[ exports ]----- */

	    spreadsheet.NULLREF = NULL;
	    spreadsheet.SHEETREF = new RangeRef(new CellRef(0, 0), new CellRef(Infinity, Infinity));
	    spreadsheet.FIRSTREF = new CellRef(0, 0);
	    spreadsheet.Ref = Ref;
	    spreadsheet.NameRef = NameRef;
	    spreadsheet.CellRef = CellRef;
	    spreadsheet.RangeRef = RangeRef;
	    spreadsheet.UnionRef = UnionRef;

	    spreadsheet.SHEETREF.print = function() {
	        return "#SHEET";
	    };

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "7coT":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1287);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1287:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1049)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function () {

	var __meta__ = {// jshint ignore:line
	    id: "loader",
	    name: "Loader",
	    category: "web",
	    description: "The Loader is a visual indicator of loading data across different parts of the page.",
	    depends: ["core"]
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        ui = kendo.ui,

	        HIDDEN = 'k-hidden',
	        ARIA_LABEL = 'aria-label',
	        ARIA_HIDDEN = 'aria-hidden';

	    var loaderClasses = {
	        loader: "k-widget k-loader",
	        canvas: "k-loader-canvas",
	        segment: "k-loader-segment"
	    };

	    var loaderTypes = {
	        'pulsing': { className: 'pulsing-2', segments: 2 },
	        'infinite-spinner': { className: 'spinner-3', segments: 3 },
	        'converging-spinner': { className: 'spinner-4', segments: 4 }
	    };

	    var Loader = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            that._render();

	            that._appearance();

	            kendo.notify(that);
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);
	        },

	        options: {
	            name: 'Loader',
	            themeColor: "primary",
	            sizes: {
	                'small': 'sm',
	                'medium': 'md',
	                'large': 'lg'
	            },
	            size: 'medium',
	            type: "pulsing",
	            visible: true,
	            messages: {
	                "loading": "Loading"
	            },
	            _classNames: []
	        },

	        _render: function() {
	            var that = this,
	                wrapper = that.element,
	                type = that.options.type,
	                typeData = loaderTypes[type] === undefined ? type : loaderTypes[type],
	                segments = [];

	            wrapper
	                .empty()
	                .attr(ARIA_LABEL, that.options.messages.loading);

	            if (typeData.segments) {
	                for (var i = 0; i < typeData.segments; i += 1) {
	                    segments.push($('<span/>').addClass(loaderClasses.segment));
	                }
	            }

	            $("<div>").addClass(loaderClasses.canvas)
	                .append(segments)
	                .appendTo(wrapper);
	        },

	        _appearance: function() {
	            var that = this;

	            that._themeColor = that.options.themeColor;
	            that._sizes = that.options.sizes;
	            that._size = that.options.size;
	            that._type = that.options.type;
	            that._visible = that.options.visible;

	            that._updateClassNames();
	        },

	        _updateClassNames: function() {
	            var that = this,
	                classNames = [loaderClasses.loader],
	                keepClassNames = that.options._classNames,
	                themeColor = that._themeColor,
	                sizes = that._sizes,
	                size = that._size,
	                type = that._type,
	                typeData = loaderTypes[type] === undefined ? type : loaderTypes[type],
	                sizeAbbr = sizes[size] === undefined ? size : sizes[size],
	                visible = that._visible;

	            // Remove all class names
	            that.element.removeClass(function(index, className) {
	                if (className.indexOf('k-') === 0 && keepClassNames.indexOf(className) === -1) {
	                    that.element.removeClass(className);
	                }
	            });

	            // Color
	            if (typeof themeColor === 'string' && themeColor !== '' && themeColor !== 'inherit') {
	                classNames.push('k-loader-' + themeColor);
	            }

	            // Size
	            if (typeof size === 'string' && size !== '' && sizeAbbr !== '') {
	                classNames.push('k-loader-' + sizeAbbr);
	            }

	            // Type
	            if (typeof type === 'string' && type !== '') {
	                classNames.push('k-loader-' + ($.isPlainObject(typeData) ? typeData.className : type));
	            }

	            // Visibility
	            if (visible === false) {
	                classNames.push(HIDDEN);
	            }

	            that.element.attr(ARIA_HIDDEN, !visible);

	            // Apply classnames
	            that.element.addClass(classNames.join(' '));
	        },

	        setOptions: function(options) {
	            var that = this;

	            Widget.fn.setOptions.call(that, options);

	            that._render();

	            that._appearance();
	        },

	        themeColor: function(color) {
	            var that = this;

	            if (arguments.length === 0 || color === undefined) {
	                return that._themeColor;
	            }

	            that._themeColor = color;

	            that._updateClassNames();
	        },

	        hide: function() {
	            var that = this;

	            that._visible = false;

	            that._updateClassNames();
	        },

	        show: function() {
	            var that = this;

	            that._visible = true;

	            that._updateClassNames();
	        }
	    });

	    ui.plugin(Loader);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "7quO":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(892);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 881:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 882:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nzx/");

/***/ }),

/***/ 883:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nK46");

/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(881), __webpack_require__(894), __webpack_require__(895),
	           __webpack_require__(896),
	           __webpack_require__(897),
	           __webpack_require__(893),
	           __webpack_require__(882),
	           __webpack_require__(883),
	           __webpack_require__(898),
	           __webpack_require__(899),
	           __webpack_require__(900) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function () {

	    (function ($, undefined) {
	        // Imports ================================================================
	        var dataviz = kendo.dataviz,
	            draw = kendo.drawing,
	            geom = kendo.geometry,
	            diagram = dataviz.diagram,
	            Widget = kendo.ui.Widget,
	            Class = kendo.Class,
	            proxy = $.proxy,
	            deepExtend = kendo.deepExtend,
	            outerWidth = kendo._outerWidth,
	            outerHeight = kendo._outerHeight,
	            extend = $.extend,
	            HierarchicalDataSource = kendo.data.HierarchicalDataSource,
	            Canvas = diagram.Canvas,
	            Group = diagram.Group,
	            Rectangle = diagram.Rectangle,
	            Circle = diagram.Circle,
	            CompositeTransform = diagram.CompositeTransform,
	            Rect = diagram.Rect,
	            Path = diagram.Path,
	            DeleteShapeUnit = diagram.DeleteShapeUnit,
	            DeleteConnectionUnit = diagram.DeleteConnectionUnit,
	            TextBlock = diagram.TextBlock,
	            Image = diagram.Image,
	            Point = diagram.Point,
	            Intersect = diagram.Intersect,
	            ConnectionEditAdorner = diagram.ConnectionEditAdorner,
	            UndoRedoService = diagram.UndoRedoService,
	            ToolService = diagram.ToolService,
	            Selector = diagram.Selector,
	            ResizingAdorner = diagram.ResizingAdorner,
	            ConnectorsAdorner = diagram.ConnectorsAdorner,
	            Cursors = diagram.Cursors,
	            Utils = diagram.Utils,
	            Observable = kendo.Observable,
	            ToBackUnit = diagram.ToBackUnit,
	            ToFrontUnit = diagram.ToFrontUnit,
	            PolylineRouter = diagram.PolylineRouter,
	            CascadingRouter = diagram.CascadingRouter,
	            isUndefined = Utils.isUndefined,
	            isDefined = Utils.isDefined,
	            defined = draw.util.defined,
	            isArray = $.isArray,
	            isFunction = kendo.isFunction,
	            isString = Utils.isString,
	            isPlainObject = $.isPlainObject,

	            math = Math;

	        // Constants ==============================================================
	        var NS = ".kendoDiagram",
	            CASCADING = "cascading",
	            ITEMBOUNDSCHANGE = "itemBoundsChange",
	            CHANGE = "change",
	            CLICK = "click",
	            DRAG = "drag",
	            DRAG_END = "dragEnd",
	            DRAG_START = "dragStart",
	            MOUSE_ENTER = "mouseEnter",
	            MOUSE_LEAVE = "mouseLeave",
	            ERROR = "error",
	            AUTO = "Auto",
	            TOP = "Top",
	            RIGHT = "Right",
	            LEFT = "Left",
	            BOTTOM = "Bottom",
	            MAXINT = 9007199254740992,
	            SELECT = "select",
	            ITEMROTATE = "itemRotate",
	            PAN = "pan",
	            ZOOM_START = "zoomStart",
	            ZOOM_END = "zoomEnd",
	            NONE = "none",
	            DEFAULT_CANVAS_WIDTH = 600,
	            DEFAULT_CANVAS_HEIGHT = 600,
	            DEFAULT_SHAPE_TYPE = "rectangle",
	            DEFAULT_SHAPE_WIDTH = 100,
	            DEFAULT_SHAPE_HEIGHT = 100,
	            DEFAULT_SHAPE_MINWIDTH = 20,
	            DEFAULT_SHAPE_MINHEIGHT = 20,
	            DEFAULT_SHAPE_POSITION = 0,
	            DEFAULT_CONNECTION_BACKGROUND = "Yellow",
	            MAX_VALUE = Number.MAX_VALUE,
	            MIN_VALUE = -Number.MAX_VALUE,
	            ABSOLUTE = "absolute",
	            TRANSFORMED = "transformed",
	            ROTATED = "rotated",
	            TRANSPARENT = "transparent",
	            WIDTH = "width",
	            HEIGHT = "height",
	            X = "x",
	            Y = "y",
	            MOUSEWHEEL_NS = "DOMMouseScroll" + NS + " mousewheel" + NS,
	            MOBILE_ZOOM_RATE = 0.05,
	            MOBILE_PAN_DISTANCE = 5,
	            BUTTON_TEMPLATE = '<a class="k-button k-button-icontext #=className#" href="\\#"><span class="#=iconClass# #=imageClass#"></span>#=text#</a>',
	            CONNECTION_CONTENT_OFFSET = 5;

	        diagram.DefaultConnectors = [{
	            name: TOP
	        }, {
	            name: BOTTOM
	        }, {
	            name: LEFT
	        }, {
	            name: RIGHT
	        }, {
	            name: AUTO,
	            position: function (shape) {
	                return shape.getPosition("center");
	            }
	        }];

	        var defaultButtons = {
	            cancel: {
	                text: "Cancel",
	                imageClass: "k-i-cancel",
	                className: "k-diagram-cancel",
	                iconClass: "k-icon"
	            },
	            update: {
	                text: "Update",
	                imageClass: "k-i-checkmark",
	                className: "k-diagram-update",
	                iconClass: "k-icon"
	            }
	        };

	        diagram.shapeDefaults = function(extra) {
	            var defaults = {
	                type: DEFAULT_SHAPE_TYPE,
	                path: "",
	                autoSize: true,
	                visual: null,
	                x: DEFAULT_SHAPE_POSITION,
	                y: DEFAULT_SHAPE_POSITION,
	                minWidth: DEFAULT_SHAPE_MINWIDTH,
	                minHeight: DEFAULT_SHAPE_MINHEIGHT,
	                width: DEFAULT_SHAPE_WIDTH,
	                height: DEFAULT_SHAPE_HEIGHT,
	                hover: {},
	                editable: {
	                    connect: true,
	                    tools: []
	                },
	                connectors: diagram.DefaultConnectors,
	                rotation: {
	                    angle: 0
	                }
	            };

	            Utils.simpleExtend(defaults, extra);

	            return defaults;
	        };

	        function mwDelta(e) {
	            var origEvent = e.originalEvent,
	                delta = 0;

	            if (origEvent.wheelDelta) {
	                delta = -origEvent.wheelDelta / 40;
	                delta = delta > 0 ? math.ceil(delta) : math.floor(delta);
	            } else if (origEvent.detail) {
	                delta = origEvent.detail;
	            }

	            return delta;
	        }

	        function isAutoConnector(connector) {
	            return connector.options.name.toLowerCase() === AUTO.toLowerCase();
	        }

	        function closestConnector(point, connectors) {
	            var minimumDistance = MAXINT, resCtr, connector;
	            for (var i = 0; i < connectors.length; i++) {
	                connector = connectors[i];
	                if (!isAutoConnector(connector)) {
	                    var dist = point.distanceTo(connector.position());
	                    if (dist < minimumDistance) {
	                        minimumDistance = dist;
	                        resCtr = connector;
	                    }
	                }
	            }
	            return resCtr;
	        }

	        function indicesOfItems(group, visuals) {
	            var i, indices = [], visual;
	            var children = group.drawingContainer().children;
	            var length = children.length;
	            for (i = 0; i < visuals.length; i++) {
	                visual = visuals[i];
	                for (var j = 0; j < length; j++) {
	                    if (children[j] == visual.drawingContainer()) {
	                        indices.push(j);
	                        break;
	                    }
	                }
	            }
	            return indices;
	        }

	        var DiagramElement = Observable.extend({
	            init: function (options) {
	                var that = this;
	                that.dataItem = (options || {}).dataItem;
	                Observable.fn.init.call(that);
	                that.options = deepExtend({ id: diagram.randomId() }, that.options, options);
	                that.isSelected = false;
	                that.visual = new Group({
	                    id: that.options.id,
	                    autoSize: that.options.autoSize
	                });
	                that.id = that.options.id;
	                that._template();
	            },

	            options: {
	                hover: {},
	                cursor: Cursors.grip,
	                content: {
	                    align: "center middle"
	                },
	                selectable: true,
	                serializable: true,
	                enable: true
	            },

	            _getCursor: function (point) {
	                if (this.adorner) {
	                    return this.adorner._getCursor(point);
	                }
	                return this.options.cursor;
	            },

	            visible: function (value) {
	                if (isUndefined(value)) {
	                    return this.visual.visible();
	                } else {
	                    this.visual.visible(value);
	                }
	            },

	            bounds: function () {
	            },

	            refresh: function () {
	                this.visual.redraw();
	            },

	            position: function (point) {
	                this.options.x = point.x;
	                this.options.y = point.y;
	                this.visual.position(point);
	            },

	            toString: function () {
	                return this.options.id;
	            },

	            serialize: function () {
	                // the options json object describes the shape perfectly. So this object can serve as shape serialization.
	                var json = deepExtend({}, {options: this.options});
	                if (this.dataItem) {
	                    json.dataItem = this.dataItem.toString();
	                }
	                return json;
	            },

	            _content: function (content) {
	                if (content !== undefined) {
	                    var options = this.options;

	                    if (diagram.Utils.isString(content)) {
	                        options.content.text = content;
	                    } else {
	                        deepExtend(options.content, content);
	                    }

	                    var contentOptions = options.content;
	                    var contentVisual = this._contentVisual;

	                    if (!contentVisual) {
	                        this._createContentVisual(contentOptions);
	                    } else {
	                        this._updateContentVisual(contentOptions);
	                    }
	                }

	                return this.options.content.text;
	            },

	            _createContentVisual: function(options) {
	                if (options.text) {
	                    this._contentVisual = new TextBlock(options);
	                    this._contentVisual._includeInBBox = false;
	                    this.visual.append(this._contentVisual);
	                }
	            },

	            _updateContentVisual: function(options) {
	                this._contentVisual.redraw(options);
	            },

	            _hitTest: function (point) {
	                var bounds = this.bounds();
	                return this.visible() && bounds.contains(point) && this.options.enable;
	            },

	            _template: function () {
	                var that = this;
	                if (that.options.content.template) {
	                    var data = that.dataItem || {},
	                        elementTemplate = kendo.template(that.options.content.template, {
	                            paramName: "dataItem"
	                        });

	                    that.options.content.text = elementTemplate(data);
	                }
	            },

	            _canSelect: function () {
	                return this.options.selectable !== false;
	            },

	            toJSON: function() {
	                return {
	                    id: this.options.id
	                };
	            }
	        });

	        var Connector = Class.extend({
	            init: function (shape, options) {
	                this.options = deepExtend({}, this.options, options);
	                this.connections = [];
	                this.shape = shape;
	            },
	            options: {
	                width: 7,
	                height: 7,
	                fill: {
	                    color: DEFAULT_CONNECTION_BACKGROUND
	                },
	                hover: {}
	            },
	            position: function () {
	                if (this.options.position) {
	                    return this.options.position(this.shape);
	                } else {
	                    return this.shape.getPosition(this.options.name);
	                }
	            },
	            toJSON: function () {
	                return {
	                    shapeId: this.shape.toString(),
	                    connector: this.options.name
	                };
	            }
	        });

	        Connector.parse = function (diagram, str) {
	            var tempStr = str.split(":"),
	                id = tempStr[0],
	                name = tempStr[1] || AUTO;

	            for (var i = 0; i < diagram.shapes.length; i++) {
	                var shape = diagram.shapes[i];
	                if (shape.options.id == id) {
	                    return shape.getConnector(name.trim());
	                }
	            }
	        };

	        var Shape = DiagramElement.extend({
	            init: function (options, diagram) {
	                var that = this;
	                DiagramElement.fn.init.call(that, options);
	                this.diagram = diagram;
	                this.updateOptionsFromModel();
	                options = that.options;
	                that.connectors = [];
	                that.type = options.type;
	                that.createShapeVisual();
	                that.updateBounds();
	                that.content(that.content());

	                that._createConnectors();
	            },

	            options: diagram.shapeDefaults(),

	            _setOptionsFromModel: function(model) {
	                var modelOptions = filterShapeDataItem(model || this.dataItem);
	                this.options = deepExtend({}, this.options, modelOptions);

	                this.redrawVisual();
	            },

	            updateOptionsFromModel: function(model, field) {
	                if (this.diagram && this.diagram._isEditable) {
	                    var modelOptions = filterShapeDataItem(model || this.dataItem);

	                    if (model && field) {
	                        if (!dataviz.inArray(field, ["x", "y", "width", "height"])) {
	                            if (this.options.visual) {
	                                this._redrawVisual();
	                            } else if (modelOptions.type) {
	                                this.options = deepExtend({}, this.options, modelOptions);
	                                this._redrawVisual();
	                            }

	                            if (this.options.content) {
	                                this._template();
	                                this.content(this.options.content);
	                            }
	                        } else {
	                            var bounds = this.bounds();
	                            bounds[field] = model[field];
	                            this.bounds(bounds);
	                        }
	                    } else {
	                        this.options = deepExtend({}, this.options, modelOptions);
	                    }
	                }
	            },

	            _redrawVisual: function() {
	                this.visual.clear();
	                this._contentVisual = null;
	                this.options.dataItem = this.dataItem;
	                this.createShapeVisual();
	                this.updateBounds();
	            },

	            redrawVisual: function() {
	                this._redrawVisual();
	                if (this.options.content) {
	                    this._template();
	                    this.content(this.options.content);
	                }
	            },

	            updateModel: function(syncChanges) {
	                var diagram = this.diagram;
	                if (diagram && diagram._isEditable) {
	                    var bounds = this._bounds;
	                    var model = this.dataItem;

	                    if (model) {
	                        diagram._suspendModelRefresh();
	                        if (defined(model.x) && bounds.x !== model.x) {
	                            model.set("x", bounds.x);
	                        }

	                        if (defined(model.y) && bounds.y !== model.y) {
	                            model.set("y", bounds.y);
	                        }

	                        if (defined(model.width) && bounds.width !== model.width) {
	                            model.set("width", bounds.width);
	                        }

	                        if (defined(model.height) && bounds.height !== model.height) {
	                            model.set("height", bounds.height);
	                        }

	                        this.dataItem = model;
	                        diagram._resumeModelRefresh();

	                        if (syncChanges) {
	                            diagram._syncShapeChanges();
	                        }
	                    }
	                }
	            },

	            updateBounds: function() {
	                var bounds = this.visual._measure(true);
	                var options = this.options;
	                this.bounds(new Rect(options.x, options.y, bounds.width, bounds.height));
	                this._rotate();
	                this._alignContent();
	            },

	            content: function(content) {
	                var result = this._content(content);

	                this._alignContent();

	                return result;
	            },

	            _alignContent: function() {
	                var contentOptions = this.options.content || {};
	                var contentVisual = this._contentVisual;
	                if (contentVisual && contentOptions.align) {
	                    var containerRect = this.visual._measure();
	                    var aligner = new diagram.RectAlign(containerRect);
	                    var contentBounds = contentVisual.drawingElement.bbox(null);

	                    var contentRect = new Rect(0, 0, contentBounds.width(), contentBounds.height());
	                    var alignedBounds = aligner.align(contentRect, contentOptions.align);

	                    contentVisual.position(alignedBounds.topLeft());
	                }
	            },

	            _createConnectors: function() {
	                var options = this.options,
	                    length = options.connectors.length,
	                    connectorDefaults = options.connectorDefaults,
	                    connector, i;

	                for (i = 0; i < length; i++) {
	                    connector = new Connector(
	                        this, deepExtend({},
	                            connectorDefaults,
	                            options.connectors[i]
	                        )
	                    );
	                    this.connectors.push(connector);
	                }
	            },

	            bounds: function (value) {
	                var bounds;

	                if (value) {
	                    if (isString(value)) {
	                        switch (value) {
	                            case TRANSFORMED :
	                                bounds = this._transformedBounds();
	                                break;
	                            case ABSOLUTE :
	                                bounds = this._transformedBounds();
	                                var pan = this.diagram._pan;
	                                bounds.x += pan.x;
	                                bounds.y += pan.y;
	                                break;
	                            case ROTATED :
	                                bounds = this._rotatedBounds();
	                                break;
	                            default:
	                                bounds = this._bounds;
	                        }
	                    } else {
	                        this._setBounds(value);
	                        this._triggerBoundsChange();
	                        if (!(this.diagram && this.diagram._layouting)) {
	                            this.refreshConnections();
	                        }
	                    }
	                } else {
	                    bounds = this._bounds;
	                }

	                return bounds;
	            },

	            _setBounds: function(rect) {
	                var options = this.options;
	                var topLeft = rect.topLeft();
	                var x = options.x = topLeft.x;
	                var y = options.y = topLeft.y;
	                var width = options.width = math.max(rect.width, options.minWidth);
	                var height = options.height = math.max(rect.height, options.minHeight);

	                this._bounds = new Rect(x, y, width, height);

	                this.visual.redraw({
	                    x: x,
	                    y: y,
	                    width: width,
	                    height: height
	                });
	            },

	            position: function (point) {
	                if (point) {
	                    this.bounds(new Rect(point.x, point.y, this._bounds.width, this._bounds.height));
	                } else {
	                    return this._bounds.topLeft();
	                }
	            },
	            /**
	             * Returns a clone of this shape.
	             * @returns {Shape}
	             */
	            clone: function () {
	                var json = this.serialize();

	                json.options.id = diagram.randomId();

	                if (this.diagram && this.diagram._isEditable && defined(this.dataItem)) {
	                    json.options.dataItem = cloneDataItem(this.dataItem);
	                }

	                return new Shape(json.options);
	            },

	            select: function (value) {
	                var diagram = this.diagram, selected, deselected;
	                if (isUndefined(value)) {
	                    value = true;
	                }

	                if (this._canSelect()) {
	                    if (this.isSelected != value) {
	                        selected = [];
	                        deselected = [];
	                        this.isSelected = value;
	                        if (this.isSelected) {
	                            diagram._selectedItems.push(this);
	                            selected.push(this);
	                        } else {
	                            Utils.remove(diagram._selectedItems, this);
	                            deselected.push(this);
	                        }

	                        if (!diagram._internalSelection) {
	                            diagram._selectionChanged(selected, deselected);
	                        }

	                        return true;
	                    }
	                }
	            },

	            rotate: function (angle, center, undoable) { // we assume the center is always the center of the shape.
	                var rotate = this.visual.rotate();
	                if (angle !== undefined) {
	                    if (undoable !== false && this.diagram && this.diagram.undoRedoService && angle !== rotate.angle) {
	                        this.diagram.undoRedoService.add(
	                            new diagram.RotateUnit(this.diagram._resizingAdorner, [this], [rotate.angle]), false);
	                    }

	                    var b = this.bounds(),
	                        sc = new Point(b.width / 2, b.height / 2),
	                        deltaAngle,
	                        newPosition;

	                    if (center) {
	                        deltaAngle = angle - rotate.angle;
	                        newPosition = b.center().rotate(center, 360 - deltaAngle).minus(sc);
	                        this._rotationOffset = this._rotationOffset.plus(newPosition.minus(b.topLeft()));
	                        this.position(newPosition);
	                    }

	                    this.visual.rotate(angle, sc);
	                    this.options.rotation.angle = angle;

	                    if (this.diagram && this.diagram._connectorsAdorner) {
	                        this.diagram._connectorsAdorner.refresh();
	                    }

	                    this.refreshConnections();

	                    if (this.diagram) {
	                        this.diagram.trigger(ITEMROTATE, { item: this });
	                    }
	                }

	                return rotate;
	            },

	            connections: function (type) { // in, out, undefined = both
	                var result = [], i, j, con, cons, ctr;

	                for (i = 0; i < this.connectors.length; i++) {
	                    ctr = this.connectors[i];
	                    cons = ctr.connections;
	                    for (j = 0, cons; j < cons.length; j++) {
	                        con = cons[j];
	                        if (type == "out") {
	                            var source = con.source();
	                            if (source.shape && source.shape == this) {
	                                result.push(con);
	                            }
	                        } else if (type == "in") {
	                            var target = con.target();
	                            if (target.shape && target.shape == this) {
	                                result.push(con);
	                            }
	                        } else {
	                            result.push(con);
	                        }
	                    }
	                }

	                return result;
	            },

	            refreshConnections: function () {
	                $.each(this.connections(), function () {
	                    this.refresh();
	                });
	            },
	            /**
	             * Gets a connector of this shape either by the connector's supposed name or
	             * via a Point in which case the closest connector will be returned.
	             * @param nameOrPoint The name of a Connector or a Point.
	             * @returns {Connector}
	             */
	            getConnector: function (nameOrPoint) {
	                var i, ctr;
	                if (isString(nameOrPoint)) {
	                    nameOrPoint = nameOrPoint.toLocaleLowerCase();
	                    for (i = 0; i < this.connectors.length; i++) {
	                        ctr = this.connectors[i];
	                        if (ctr.options.name.toLocaleLowerCase() == nameOrPoint) {
	                            return ctr;
	                        }
	                    }
	                } else if (nameOrPoint instanceof Point) {
	                    return closestConnector(nameOrPoint, this.connectors);
	                } else {
	                    return this.connectors.length ? this.connectors[0] : null;
	                }
	            },

	            getPosition: function (side) {
	                var b = this.bounds(),
	                    fnName = side.charAt(0).toLowerCase() + side.slice(1);

	                if (isFunction(b[fnName])) {
	                    return this._transformPoint(b[fnName]());
	                }

	                return b.center();
	            },

	            redraw: function (options) {
	                if (options) {
	                    var shapeOptions = this.options;
	                    var boundsChange;

	                    this.shapeVisual.redraw(this._visualOptions(options));

	                    if (this._diffNumericOptions(options, [WIDTH, HEIGHT, X, Y])) {
	                        this.bounds(new Rect(shapeOptions.x, shapeOptions.y, shapeOptions.width, shapeOptions.height));
	                        boundsChange = true;
	                    }

	                    if (options.connectors) {
	                        shapeOptions.connectors = options.connectors;
	                        this._updateConnectors();
	                    }

	                    shapeOptions = deepExtend(shapeOptions, options);

	                    if  (options.rotation || boundsChange) {
	                        this._rotate();
	                    }

	                    if (shapeOptions.content) {
	                        this.content(shapeOptions.content);
	                    }
	                }
	            },

	            _updateConnectors: function() {
	                var connections = this.connections();
	                this.connectors = [];
	                this._createConnectors();
	                var connection;
	                var source;
	                var target;

	                for (var idx = 0; idx < connections.length; idx++) {
	                    connection = connections[idx];
	                    source = connection.source();
	                    target = connection.target();
	                    if (source.shape && source.shape === this) {
	                        connection.source(this.getConnector(source.options.name) || null);
	                    } else if (target.shape && target.shape === this) {
	                        connection.target(this.getConnector(target.options.name) || null);
	                    }
	                    connection.updateModel();
	                }
	            },

	            _diffNumericOptions: diagram.diffNumericOptions,

	            _visualOptions: function(options) {
	                return {
	                    data: options.path,
	                    source: options.source,
	                    hover: options.hover,
	                    fill: options.fill,
	                    stroke: options.stroke
	                };
	            },

	            _triggerBoundsChange: function () {
	                if (this.diagram) {
	                    this.diagram.trigger(ITEMBOUNDSCHANGE, {item: this, bounds: this._bounds.clone()}); // the trigger modifies the arguments internally.
	                }
	            },

	            _transformPoint: function (point) {
	                var rotate = this.rotate(),
	                    bounds = this.bounds(),
	                    tl = bounds.topLeft();

	                if (rotate.angle) {
	                    point.rotate(rotate.center().plus(tl), 360 - rotate.angle);
	                }

	                return point;
	            },

	            _transformedBounds: function () {
	                var bounds = this.bounds(),
	                    tl = bounds.topLeft(),
	                    br = bounds.bottomRight();

	                return Rect.fromPoints(this.diagram.modelToView(tl), this.diagram.modelToView(br));
	            },

	            _rotatedBounds: function () {
	                var bounds = this.bounds().rotatedBounds(this.rotate().angle),
	                    tl = bounds.topLeft(),
	                    br = bounds.bottomRight();

	                return Rect.fromPoints(tl, br);
	            },

	            _rotate: function () {
	                var rotation = this.options.rotation;

	                if (rotation && rotation.angle) {
	                    this.rotate(rotation.angle);
	                }

	                this._rotationOffset = new Point();
	            },

	            _hover: function (value) {
	                var options = this.options,
	                    hover = options.hover,
	                    stroke = options.stroke,
	                    fill = options.fill;

	                if (value && isDefined(hover.stroke)) {
	                    stroke = deepExtend({}, stroke, hover.stroke);
	                }

	                if (value && isDefined(hover.fill)) {
	                    fill = hover.fill;
	                }

	                this.shapeVisual.redraw({
	                    stroke: stroke,
	                    fill: fill
	                });

	                if (options.editable && options.editable.connect) {
	                    this.diagram._showConnectors(this, value);
	                }
	            },

	            _hitTest: function (value) {
	                if (this.visible()) {
	                    var bounds = this.bounds(), rotatedPoint,
	                        angle = this.rotate().angle;

	                    if (value.isEmpty && !value.isEmpty()) { // rect selection
	                        return Intersect.rects(value, bounds, angle ? angle : 0);
	                    } else { // point
	                        rotatedPoint = value.clone().rotate(bounds.center(), angle); // cloning is important because rotate modifies the point inline.
	                        if (bounds.contains(rotatedPoint)) {
	                            return this;
	                        }
	                    }
	                }
	            },

	            toJSON: function() {
	                return {
	                    shapeId: this.options.id
	                };
	            },

	            createShapeVisual: function() {
	                var options = this.options;
	                var visualOptions = this._visualOptions(options);
	                var visualTemplate = options.visual;
	                var type = (options.type + "").toLocaleLowerCase();
	                var shapeVisual;

	                visualOptions.width = options.width;
	                visualOptions.height = options.height;

	                if (isFunction(visualTemplate)) { // custom template
	                    shapeVisual = visualTemplate.call(this, options);
	                } else if (visualOptions.data) {
	                    shapeVisual = new Path(visualOptions);
	                    translateToOrigin(shapeVisual);
	                } else if (type == "rectangle"){
	                    shapeVisual = new Rectangle(visualOptions);
	                } else if (type == "circle") {
	                    shapeVisual = new Circle(visualOptions);
	                } else if (type == "text") {
	                    shapeVisual = new TextBlock(visualOptions);
	                } else if (type == "image") {
	                    shapeVisual = new Image(visualOptions);
	                } else {
	                    shapeVisual = new Path(visualOptions);
	                }

	                this.shapeVisual = shapeVisual;
	                this.visual.append(this.shapeVisual);
	            }
	        });

	        /**
	         * The visual link between two Shapes through the intermediate of Connectors.
	         */
	        var Connection = DiagramElement.extend({
	            init: function (from, to, options) {
	                var that = this;
	                DiagramElement.fn.init.call(that, options);
	                this.updateOptionsFromModel();
	                this._initRouter();
	                that.path = new diagram.Polyline(that.options);
	                that.path.fill(TRANSPARENT);
	                that.visual.append(that.path);
	                that._sourcePoint = that._targetPoint = new Point();
	                that._setSource(from);
	                that._setTarget(to);
	                that.content(that.options.content);
	                that.definers = [];
	                if (defined(options) && options.points) {
	                    that.points(options.points);
	                }
	            },

	            options: {
	                hover: {
	                    stroke: {}
	                },
	                startCap: NONE,
	                endCap: NONE,
	                points: [],
	                selectable: true,
	                fromConnector: AUTO,
	                toConnector: AUTO
	            },

	            _setOptionsFromModel: function(model) {
	                this.updateOptionsFromModel(model || this.dataItem);
	            },

	            updateOptionsFromModel: function(model) {
	                if (this.diagram && this.diagram._isEditable) {
	                    var dataMap = this.diagram._dataMap;
	                    var options = filterConnectionDataItem(model || this.dataItem);

	                    if (model) {
	                        if (defined(options.from)) {
	                            var from = dataMap[options.from];
	                            if (from && defined(options.fromConnector)) {
	                               from = from.getConnector(options.fromConnector);
	                            }
	                            this.source(from);
	                        } else if (defined(options.fromX) && defined(options.fromY)) {
	                            this.source(new Point(options.fromX, options.fromY));
	                        }

	                        if (defined(options.to)) {
	                            var to = dataMap[options.to];
	                            if (to && defined(options.toConnector)) {
	                                to = to.getConnector(options.toConnector);
	                            }
	                            this.target(to);
	                        } else if (defined(options.toX) && defined(options.toY)) {
	                            this.target(new Point(options.toX, options.toY));
	                        }

	                        if (defined(options.type) && this.type() !== options.type) {
	                            this.points([]);
	                            this.type(options.type);
	                        }

	                        this.dataItem = model;

	                        this._template();
	                        this.redraw(this.options);
	                    } else {
	                        this.options = deepExtend({}, options, this.options);
	                    }
	                }
	            },

	            updateModel: function(syncChanges) {
	                if (this.diagram && this.diagram._isEditable) {
	                    if (this.diagram.connectionsDataSource) {
	                        var model = this.diagram.connectionsDataSource.getByUid(this.dataItem.uid);

	                        if (model) {
	                            this.diagram._suspendModelRefresh();
	                            if (defined(this.options.fromX) && this.options.fromX !== null) {
	                                clearField("from", model);
	                                clearField("fromConnector", model);
	                                model.set("fromX", this.options.fromX);
	                                model.set("fromY", this.options.fromY);
	                            } else  {
	                                model.set("from", this.options.from);
	                                if (defined(model.fromConnector)) {
	                                    model.set("fromConnector", this.sourceConnector ? this.sourceConnector.options.name : null);
	                                }
	                                clearField("fromX", model);
	                                clearField("fromY", model);
	                            }

	                            if (defined(this.options.toX) && this.options.toX !== null) {
	                                clearField("to", model);
	                                clearField("toConnector", model);
	                                model.set("toX", this.options.toX);
	                                model.set("toY", this.options.toY);
	                            } else {
	                                model.set("to", this.options.to);
	                                if (defined(model.toConnector)) {
	                                    model.set("toConnector", this.targetConnector ? this.targetConnector.options.name : null);
	                                }
	                                clearField("toX", model);
	                                clearField("toY", model);
	                            }

	                            if (defined(this.options.type) && defined(model.type)) {
	                                model.set("type", this.options.type);
	                            }

	                            this.dataItem = model;
	                            this.diagram._resumeModelRefresh();

	                            if (syncChanges) {
	                                this.diagram._syncConnectionChanges();
	                            }
	                        }
	                    }
	                }
	            },

	            /**
	             * Gets the Point where the source of the connection resides.
	             * If the endpoint in Auto-connector the location of the resolved connector will be returned.
	             * If the endpoint is floating the location of the endpoint is returned.
	             */
	            sourcePoint: function () {
	                return this._resolvedSourceConnector ? this._resolvedSourceConnector.position() : this._sourcePoint;
	            },

	            _setSource: function(source) {
	                var shapeSource = source instanceof Shape;
	                var defaultConnector = this.options.fromConnector || AUTO;
	                var dataItem;
	                if (shapeSource && !source.getConnector(defaultConnector)) {
	                    return;
	                }

	                if (source !== undefined) {
	                    this.from = source;
	                }

	                this._removeFromSourceConnector();

	                if (source === null) { // detach
	                    if (this.sourceConnector) {
	                        this._sourcePoint = (this._resolvedSourceConnector || this.sourceConnector).position();
	                        this._clearSourceConnector();
	                        this._setFromOptions(null, this._sourcePoint);
	                    }
	                } else if (source instanceof Connector) {
	                    dataItem = source.shape.dataItem;
	                    if (dataItem) {
	                        this._setFromOptions(dataItem.id);
	                    }
	                    this.sourceConnector = source;
	                    this.sourceConnector.connections.push(this);
	                } else if (source instanceof Point) {
	                    this._setFromOptions(null, source);
	                    this._sourcePoint = source;
	                    if (this.sourceConnector) {
	                        this._clearSourceConnector();
	                    }

	                } else if (shapeSource) {
	                    dataItem = source.dataItem;
	                    if (dataItem) {
	                        this._setFromOptions(dataItem.id);
	                    }

	                    this.sourceConnector = source.getConnector(defaultConnector);
	                    this.sourceConnector.connections.push(this);
	                }
	            },

	            source: function (source, undoable) {
	                if (isDefined(source)) {
	                    if (undoable && this.diagram) {
	                        this.diagram.undoRedoService.addCompositeItem(new diagram.ConnectionEditUnit(this, source));
	                    }
	                    this._setSource(source);
	                    this.refresh();
	                }
	                return this.sourceConnector ? this.sourceConnector : this._sourcePoint;
	            },

	            _setFromOptions: function(from, fromPoint) {
	                this.options.from = from;
	                if (fromPoint)  {
	                    this.options.fromX = fromPoint.x;
	                    this.options.fromY = fromPoint.y;
	                } else {
	                    this.options.fromX = null;
	                    this.options.fromY = null;
	                }
	            },

	            /**
	             * Gets or sets the PathDefiner of the sourcePoint.
	             * The left part of this definer is always null since it defines the source tangent.
	             * @param value
	             * @returns {*}
	             */
	            sourceDefiner: function (value) {
	                if (value) {
	                    if (value instanceof diagram.PathDefiner) {
	                        value.left = null;
	                        this._sourceDefiner = value;
	                        this.source(value.point); // refresh implicit here
	                    } else {
	                        throw "The sourceDefiner needs to be a PathDefiner.";
	                    }
	                } else {
	                    if (!this._sourceDefiner) {
	                        this._sourceDefiner = new diagram.PathDefiner(this.sourcePoint(), null, null);
	                    }
	                    return this._sourceDefiner;
	                }
	            },

	            /**
	             * Gets  the Point where the target of the connection resides.
	             */
	            targetPoint: function () {
	                return this._resolvedTargetConnector ? this._resolvedTargetConnector.position() : this._targetPoint;
	            },

	            _setTarget: function(target) {
	                var shapeTarget = target instanceof Shape;
	                var defaultConnector = this.options.toConnector || AUTO;
	                var dataItem;

	                if (shapeTarget && !target.getConnector(defaultConnector)) {
	                    return;
	                }

	                if (target !== undefined) {
	                    this.to = target;
	                }

	                this._removeFromTargetConnector();

	                if (target === null) { // detach
	                    if (this.targetConnector) {
	                        this._targetPoint = (this._resolvedTargetConnector || this.targetConnector).position();
	                        this._clearTargetConnector();
	                        this._setToOptions(null, this._targetPoint);
	                    }
	                } else if (target instanceof Connector) {
	                    dataItem = target.shape.dataItem;
	                    if (dataItem) {
	                        this._setToOptions(dataItem.id);
	                    }
	                    this.targetConnector = target;
	                    this.targetConnector.connections.push(this);
	                } else if (target instanceof Point) {
	                    this._setToOptions(null, target);
	                    this._targetPoint = target;
	                    if (this.targetConnector) {
	                        this._clearTargetConnector();
	                    }
	                } else if (shapeTarget) {
	                    dataItem = target.dataItem;
	                    if (dataItem) {
	                        this._setToOptions(dataItem.id);
	                    }
	                    this.targetConnector = target.getConnector(defaultConnector);
	                    this.targetConnector.connections.push(this);
	                }
	            },

	            target: function (target, undoable) {
	                if (isDefined(target)) {
	                    if (undoable && this.diagram) {
	                        this.diagram.undoRedoService.addCompositeItem(new diagram.ConnectionEditUnit(this, undefined, target));
	                    }
	                    this._setTarget(target);

	                    this.refresh();
	                }
	                return this.targetConnector ? this.targetConnector : this._targetPoint;
	            },

	            _setToOptions: function(to, toPoint) {
	                this.options.to = to;
	                if (toPoint)  {
	                    this.options.toX = toPoint.x;
	                    this.options.toY = toPoint.y;
	                } else {
	                    this.options.toX = null;
	                    this.options.toY = null;
	                }
	            },

	            /**
	             * Gets or sets the PathDefiner of the targetPoint.
	             * The right part of this definer is always null since it defines the target tangent.
	             * @param value
	             * @returns {*}
	             */
	            targetDefiner: function (value) {
	                if (value) {
	                    if (value instanceof diagram.PathDefiner) {
	                        value.right = null;
	                        this._targetDefiner = value;
	                        this.target(value.point); // refresh implicit here
	                    } else {
	                        throw "The sourceDefiner needs to be a PathDefiner.";
	                    }
	                } else {
	                    if (!this._targetDefiner) {
	                        this._targetDefiner = new diagram.PathDefiner(this.targetPoint(), null, null);
	                    }
	                    return this._targetDefiner;
	                }
	            },

	            _updateConnectors: function() {
	                this._updateConnector(this.source(), "source");
	                this._updateConnector(this.target(), "target");
	            },

	            _updateConnector: function(instance, name) {
	                var that = this;
	                var diagram = that.diagram;
	                if (instance instanceof Connector && !diagram.getShapeById(instance.shape.id)) {
	                    var dataItem = instance.shape.dataItem;
	                    var connectorName = instance.options.name;
	                    var setNewTarget = function() {
	                        var shape = diagram._dataMap[dataItem.id];
	                        instance = shape.getConnector(connectorName);
	                        that[name](instance, false);
	                        that.updateModel();
	                    };
	                    if (diagram._dataMap[dataItem.id]) {
	                       setNewTarget();
	                    } else {
	                        var inactiveItem = diagram._inactiveShapeItems.getByUid(dataItem.uid);
	                        if (inactiveItem) {
	                            diagram._deferredConnectionUpdates.push(inactiveItem.onActivate(setNewTarget));
	                        }
	                    }
	                } else {
	                    that[name](instance, false);
	                }
	            },

	            content: function(content) {
	                var result = this._content(content);
	                if (defined(content)) {
	                    this._alignContent();
	                }
	                return result;
	            },

	            _createContentVisual: function(options) {
	                var visual;
	                if (isFunction(options.visual)) {
	                    visual = options.visual.call(this, options);
	                } else if (options.text) {
	                    visual = new TextBlock(options);
	                }

	                if (visual) {
	                    this._contentVisual = visual;
	                    visual._includeInBBox = false;
	                    this.visual.append(visual);
	                }

	                return visual;
	            },

	            _updateContentVisual: function(options) {
	                if (isFunction(options.visual)) {
	                    this.visual.remove(this._contentVisual);
	                    this._createContentVisual(options);
	                } else {
	                    this._contentVisual.redraw(options);
	                }
	            },

	            _alignContent: function() {
	                if (this._contentVisual) {
	                    var offset = CONNECTION_CONTENT_OFFSET;
	                    var points = this.allPoints();
	                    var endIdx = math.floor(points.length / 2);
	                    var startIdx = endIdx - 1;

	                    while(startIdx > 0 && points[startIdx].equals(points[endIdx])) {
	                        startIdx--;
	                        endIdx++;
	                    }

	                    var endPoint = points[endIdx];
	                    var startPoint = points[startIdx];

	                    var boundingBox = this._contentVisual._measure();
	                    var width = boundingBox.width;
	                    var height = boundingBox.height;
	                    var alignToPath = points.length % 2 === 0;
	                    var distance = startPoint.distanceTo(endPoint);

	                    if (alignToPath && points.length > 2 && distance > 0 &&
	                        ((startPoint.y === endPoint.y && distance < width) || (startPoint.x === endPoint.x && distance < height))) {
	                        alignToPath = false;
	                        offset = 0;
	                    }

	                    var point;

	                    if (alignToPath) {
	                        var angle  = draw.util.deg(math.atan2(endPoint.y - startPoint.y, endPoint.x - startPoint.x));
	                        point = new Point((endPoint.x - startPoint.x) / 2 + startPoint.x, (endPoint.y - startPoint.y) / 2 + startPoint.y);

	                        if (math.abs(angle) === 90) {
	                            point.x += offset;
	                            point.y-= height / 2;
	                        } else if (angle % 180 === 0) {
	                            point.x -= width / 2;
	                            point.y -= height + offset;
	                        } else if (angle < -90 || (0 < angle && angle < 90)) {
	                            point.y-= height;
	                        } else if (angle < 0 || angle > 90) {
	                            point.x -= width;
	                            point.y -= height;
	                        }
	                    } else {
	                        var midIdx = math.floor(points.length / 2);
	                        point = points[midIdx].clone();
	                        startPoint = points[midIdx - 1];
	                        endPoint = points[midIdx + 1];

	                        var offsetX = startPoint.x <= point.x && endPoint.x <= point.x ? offset : -boundingBox.width - offset;
	                        var offsetY = startPoint.y <= point.y && endPoint.y <= point.y ? offset : -boundingBox.height - offset;

	                        point.x += offsetX;
	                        point.y += offsetY;
	                    }

	                    this._contentVisual.position(point);
	                }
	            },

	            /**
	             * Selects or unselects this connections.
	             * @param value True to select, false to unselect.
	             */
	            select: function (value) {
	                var diagram = this.diagram, selected, deselected;
	                if (this._canSelect()) {
	                    if (this.isSelected !== value) {
	                        this.isSelected = value;
	                        selected = [];
	                        deselected = [];
	                        if (this.isSelected) {
	                            this.adorner = new ConnectionEditAdorner(this, this.options.selection);
	                            diagram._adorn(this.adorner, true);
	                            diagram._selectedItems.push(this);
	                            selected.push(this);
	                        } else {
	                            if (this.adorner) {
	                                diagram._adorn(this.adorner, false);
	                                Utils.remove(diagram._selectedItems, this);
	                                this.adorner = undefined;
	                                deselected.push(this);
	                            }
	                        }

	                        if (this.adorner) {
	                            this.adorner.refresh();
	                        }

	                        if (!diagram._internalSelection) {
	                            diagram._selectionChanged(selected, deselected);
	                        }
	                        return true;
	                    }
	                }
	            },
	            /**
	             * Gets or sets the bounds of this connection.
	             * @param value A Rect object.
	             * @remark This is automatically set in the refresh().
	             * @returns {Rect}
	             */
	            bounds: function (value) {
	                if (value && !isString(value)) {
	                    this._bounds = value;
	                } else {
	                    return this._bounds;
	                }
	            },
	            /**
	             * Gets or sets the connection type (see ConnectionType enumeration).
	             * @param value A ConnectionType value.
	             * @returns {ConnectionType}
	             */
	            type: function (value) {
	                var options = this.options;
	                if (value) {
	                    if (value !== options.type) {
	                        options.type = value;
	                        this._initRouter();
	                        this.refresh();
	                    }
	                } else {
	                    return options.type;
	                }
	            },

	            _initRouter: function() {
	                var type = (this.options.type || "").toLowerCase();
	                if (type == CASCADING) {
	                    this._router = new CascadingRouter(this);
	                } else {
	                    this._router = new PolylineRouter(this);
	                }
	            },
	            /**
	             * Gets or sets the collection of *intermediate* points.
	             * The 'allPoints()' property will return all the points.
	             * The 'definers' property returns the definers of the intermediate points.
	             * The 'sourceDefiner' and 'targetDefiner' return the definers of the endpoints.
	             * @param value
	             */
	            points: function (value) {
	                if (value) {
	                    this.definers = [];
	                    for (var i = 0; i < value.length; i++) {
	                        var definition = value[i];
	                        if (definition instanceof diagram.Point) {
	                            this.definers.push(new diagram.PathDefiner(definition));
	                        } else if (definition.hasOwnProperty("x") && definition.hasOwnProperty("y")) { // e.g. Clipboard does not preserve the Point definition and tunred into an Object
	                            this.definers.push(new diagram.PathDefiner(new Point(definition.x, definition.y)));
	                        } else {
	                            throw "A Connection point needs to be a Point or an object with x and y properties.";
	                        }
	                    }

	                } else {
	                    var pts = [];
	                    if (isDefined(this.definers)) {
	                        for (var k = 0; k < this.definers.length; k++) {
	                            pts.push(this.definers[k].point);
	                        }
	                    }
	                    return pts;
	                }
	            },
	            /**
	             * Gets all the points of this connection. This is the combination of the sourcePoint, the points and the targetPoint.
	             * @returns {Array}
	             */
	            allPoints: function () {
	                var pts = [this.sourcePoint()];
	                if (this.definers) {
	                    for (var k = 0; k < this.definers.length; k++) {
	                        pts.push(this.definers[k].point);
	                    }
	                }
	                pts.push(this.targetPoint());
	                return pts;
	            },

	            refresh: function () {
	                this._resolveConnectors();
	                this._refreshPath();
	                this._alignContent();

	                if (this.adorner) {
	                    this.adorner.refresh();
	                }
	            },

	            _resolveConnectors: function () {
	                var connection = this,
	                    sourcePoint, targetPoint,
	                    sourceConnectors, targetConnectors,
	                    source = connection.source(),
	                    target = connection.target();

	                if (source instanceof Point) {
	                    sourcePoint = source;
	                } else if (source instanceof Connector) {
	                    if (isAutoConnector(source)) {
	                        sourceConnectors = source.shape.connectors;
	                    } else {
	                        sourceConnectors = [source];
	                    }
	                }

	                if (target instanceof Point) {
	                    targetPoint = target;
	                } else if (target instanceof Connector) {
	                    if (isAutoConnector(target)) {
	                        targetConnectors = target.shape.connectors;
	                    } else {
	                        targetConnectors = [target];
	                    }
	                }

	                if (sourcePoint) {
	                    if (targetConnectors) {
	                        connection._resolvedTargetConnector = closestConnector(sourcePoint, targetConnectors);
	                    }
	                } else if (sourceConnectors) {
	                    if (targetPoint) {
	                        connection._resolvedSourceConnector = closestConnector(targetPoint, sourceConnectors);
	                    } else if (targetConnectors) {
	                        this._resolveAutoConnectors(sourceConnectors, targetConnectors);
	                    }
	                }
	            },

	            _resolveAutoConnectors: function(sourceConnectors, targetConnectors) {
	                var minNonConflict = MAXINT;
	                var minDist = MAXINT;
	                var minNonConflictSource, minNonConflictTarget;
	                var sourcePoint, targetPoint;
	                var minSource, minTarget;
	                var sourceConnector, targetConnector;
	                var sourceIdx, targetIdx;
	                var dist;

	                for (sourceIdx = 0; sourceIdx < sourceConnectors.length; sourceIdx++) {
	                    sourceConnector = sourceConnectors[sourceIdx];
	                    if (!isAutoConnector(sourceConnector)) {
	                        sourcePoint = sourceConnector.position();

	                        for (targetIdx = 0; targetIdx < targetConnectors.length; targetIdx++) {
	                            targetConnector = targetConnectors[targetIdx];
	                            if (!isAutoConnector(targetConnector)) {
	                                targetPoint = targetConnector.position();
	                                dist = math.round(sourcePoint.distanceTo(targetPoint));

	                                if (dist < minNonConflict && this.diagram && this._testRoutePoints(sourcePoint, targetPoint, sourceConnector, targetConnector)) {
	                                    minNonConflict = dist;
	                                    minNonConflictSource = sourceConnector;
	                                    minNonConflictTarget = targetConnector;
	                                }

	                                if (dist < minDist) {
	                                    minSource = sourceConnector;
	                                    minTarget = targetConnector;
	                                    minDist = dist;
	                                }
	                            }
	                        }
	                    }
	                }

	                if (minNonConflictSource) {
	                    minSource = minNonConflictSource;
	                    minTarget = minNonConflictTarget;
	                }

	                this._resolvedSourceConnector = minSource;
	                this._resolvedTargetConnector = minTarget;
	            },

	            _testRoutePoints: function(sourcePoint, targetPoint, sourceConnector, targetConnector) {
	                var router = this._router;
	                var passRoute = true;
	                if (router instanceof CascadingRouter) {
	                    var points = router.routePoints(sourcePoint, targetPoint, sourceConnector, targetConnector),
	                        start, end,
	                         rect, exclude;

	                    exclude = this._getRouteExclude(sourcePoint, targetPoint, sourceConnector.shape, targetConnector.shape);
	                    points.unshift(sourcePoint);
	                    points.push(targetPoint);


	                    for (var idx = 1; idx < points.length; idx++) {
	                        start = points[idx - 1];
	                        end = points[idx];
	                        rect = new Rect(math.min(start.x, end.x), math.min(start.y, end.y),
	                                        math.abs(start.x - end.x), math.abs(start.y - end.y));
	                        if (rect.width > 0) {
	                            rect.x++;
	                            rect.width-=2;
	                        }
	                        if (rect.height > 0) {
	                            rect.y++;
	                            rect.height-=2;
	                        }

	                        if (!rect.isEmpty() && this.diagram._shapesQuadTree.hitTestRect(rect, exclude)) {
	                            passRoute = false;
	                            break;
	                        }
	                    }
	                }
	                return passRoute;
	            },

	            _getRouteExclude: function(sourcePoint, targetPoint, sourceShape, targetShape) {
	                var exclude = [];
	                if (this._isPointInsideShape(sourcePoint, sourceShape)){
	                    exclude.push(sourceShape);
	                }
	                if (this._isPointInsideShape(targetPoint, targetShape)){
	                    exclude.push(targetShape);
	                }
	                return exclude;
	            },

	            _isPointInsideShape: function (point, shape) {
	                var bounds = shape.bounds(), rotatedPoint,
	                    angle = shape.rotate().angle,
	                    pointX, pointY,
	                    boundsX = bounds.x,
	                    boundsY = bounds.y;

	                rotatedPoint = point.clone().rotate(bounds.center(), angle);
	                pointX = rotatedPoint.x;
	                pointY = rotatedPoint.y;
	                return pointX > boundsX && pointX < (boundsX + bounds.width) && pointY > boundsY && pointY < (boundsY + bounds.height);
	            },

	            redraw: function (options) {
	                if (options) {
	                    this.options = deepExtend({}, this.options, options);

	                    var points = this.options.points;

	                    if (defined(points) && points.length > 0) {
	                        this.points(points);
	                        this._refreshPath();
	                    }

	                    if ((options && options.content) || options.text) {
	                        this.content(options.content);
	                    }

	                    this.path.redraw({
	                        fill: options.fill,
	                        stroke: options.stroke,
	                        startCap: options.startCap,
	                        endCap: options.endCap
	                    });
	                }
	            },
	            /**
	             * Returns a clone of this connection.
	             * @returns {Connection}
	             */
	            clone: function () {
	                var json = this.serialize();

	                if (this.diagram && this.diagram._isEditable && defined(this.dataItem)) {
	                    json.options.dataItem = cloneDataItem(this.dataItem);
	                }

	                return new Connection(this.from, this.to, json.options);
	            },
	            /**
	             * Returns a serialized connection in json format. Consist of the options and the dataItem.
	             * @returns {Connection}
	             */
	            serialize: function () {
	                var from = this.from.toJSON ? this.from.toJSON : this.from.toString(),
	                    to = this.to.toJSON ? this.to.toJSON : this.to.toString();

	                var json = deepExtend({}, {
	                    options: this.options,
	                    from: from,
	                    to: to
	                });

	                if (defined(this.dataItem)) {
	                    json.dataItem = this.dataItem.toString();
	                }

	                json.options.points = this.points();
	                return json;
	            },

	            /**
	             * Returns whether the given Point or Rect hits this connection.
	             * @param value
	             * @returns {Connection}
	             * @private
	             */
	            _hitTest: function (value) {
	                if (this.visible()) {
	                    var p = new Point(value.x, value.y), from = this.sourcePoint(), to = this.targetPoint();
	                    if (value.isEmpty && !value.isEmpty() && value.contains(from) && value.contains(to)) {
	                        return this;
	                    }
	                    if (this._router.hitTest(p)) {
	                        return this;
	                    }
	                }
	            },

	            _hover: function (value) {
	                var color = (this.options.stroke || {}).color;

	                if (value && isDefined(this.options.hover.stroke.color)) {
	                    color = this.options.hover.stroke.color;
	                }

	                this.path.redraw({
	                    stroke: {
	                        color: color
	                    }
	                });
	            },

	            _refreshPath: function () {
	                if (!defined(this.path)) {
	                    return;
	                }
	                this._drawPath();
	                this.bounds(this._router.getBounds());
	            },

	            _drawPath: function () {
	                if (this._router) {
	                    this._router.route(); // sets the intermediate points
	                }
	                var source = this.sourcePoint();
	                var target = this.targetPoint();
	                var points = this.points();

	                this.path.redraw({
	                    points: [source].concat(points, [target])
	                });
	            },

	            _clearSourceConnector: function () {
	                this.sourceConnector = undefined;
	                this._resolvedSourceConnector = undefined;
	            },

	            _clearTargetConnector: function () {
	                this.targetConnector = undefined;
	                this._resolvedTargetConnector = undefined;
	            },

	            _removeFromSourceConnector: function() {
	                if (this.sourceConnector) {
	                    Utils.remove(this.sourceConnector.connections, this);
	                }
	            },

	            _removeFromTargetConnector: function() {
	                if (this.targetConnector) {
	                    Utils.remove(this.targetConnector.connections, this);
	                }
	            },

	            toJSON: function() {
	                var connection = this;
	                var from, to, point;
	                if (connection.from && connection.from.toJSON) {
	                    from = connection.from.toJSON();
	                } else {
	                    point = connection._sourcePoint;
	                    from = {
	                        x: point.x,
	                        y: point.y
	                    };
	                }

	                if (connection.to && connection.to.toJSON) {
	                    to = connection.to.toJSON();
	                } else {
	                    point = connection._targetPoint;
	                    to = {
	                        x: point.x,
	                        y: point.y
	                    };
	                }

	                return {
	                    from : from,
	                    to: to
	                };
	            }
	        });

	        var Diagram = Widget.extend({
	            init: function (element, userOptions) {
	                var that = this;

	                kendo.destroy(element);
	                Widget.fn.init.call(that, element, userOptions);

	                that._initTheme();

	                that._initElements();
	                that._extendLayoutOptions(that.options);
	                that._initDefaults(userOptions);
	                that._interactionDefaults();

	                that._initCanvas();

	                that.mainLayer = new Group({
	                    id: "main-layer"
	                });
	                that.canvas.append(that.mainLayer);

	                that._shapesQuadTree = new ShapesQuadTree(that);

	                that._pan = new Point();
	                that._adorners = [];
	                that.adornerLayer = new Group({
	                    id: "adorner-layer"
	                });
	                that.canvas.append(that.adornerLayer);

	                that._createHandlers();

	                that._initialize();

	                that._resizingAdorner = new ResizingAdorner(that, { editable: that.options.editable });
	                that._connectorsAdorner = new ConnectorsAdorner(that);

	                that._adorn(that._resizingAdorner, true);
	                that._adorn(that._connectorsAdorner, true);

	                that.selector = new Selector(that);
	                // TODO: We may consider using real Clipboard API once is supported by the standard.
	                that._clipboard = [];

	                that.pauseMouseHandlers = false;

	                that._fetchFreshData();

	                that._createGlobalToolBar();

	                that._createOptionElements();

	                that.zoom(that.options.zoom);

	                that.canvas.draw();
	            },

	            options: {
	                name: "Diagram",
	                theme: "default",
	                layout: "",
	                zoomRate: 0.1,
	                zoom: 1,
	                zoomMin: 0,
	                zoomMax: 2,
	                dataSource: {},
	                draggable: true,
	                template: "",
	                autoBind: true,
	                editable: {
	                    rotate: {},
	                    resize: {},
	                    text: true,
	                    tools: [],
	                    drag: {
	                        snap: {
	                            size: 10,
	                            angle: 10
	                        }
	                    },
	                    remove: true
	                },
	                pannable: {},
	                selectable: {
	                    key: "none"
	                },
	                tooltip: { enabled: true, format: "{0}" },
	                copy: {
	                    enabled: true,
	                    offsetX: 20,
	                    offsetY: 20
	                },
	                shapeDefaults: diagram.shapeDefaults({ undoable: true }),
	                connectionDefaults: {
	                    editable: {
	                        tools: []
	                    },
	                    type: CASCADING
	                },
	                shapes: [],
	                connections: []
	            },

	            events: [
	                ZOOM_END,
	                ZOOM_START,
	                PAN, SELECT,
	                ITEMROTATE,
	                ITEMBOUNDSCHANGE,
	                CHANGE,
	                CLICK,
	                MOUSE_ENTER,
	                MOUSE_LEAVE,
	                "toolBarClick",
	                "save",
	                "cancel",
	                "edit",
	                "remove",
	                "add",
	                "dataBound",
	                DRAG_START,
	                DRAG,
	                DRAG_END
	            ],

	            items: function() {
	                return $();
	            },

	            _createGlobalToolBar: function() {
	                var editable = this.options.editable;
	                if (editable) {
	                    var tools = editable.tools;
	                    if (this._isEditable && tools !== false && (!tools || tools.length === 0)) {
	                        tools = ["createShape", "undo", "redo", "rotateClockwise", "rotateAnticlockwise"];
	                    }

	                    if (tools && tools.length) {
	                        this.toolBar = new DiagramToolBar(this, {
	                            tools: tools || {},
	                            click: proxy(this._toolBarClick, this),
	                            modal: false
	                        });

	                        this.toolBar.element.css({
	                            textAlign: "left"
	                        });

	                        this.element.prepend(this.toolBar.element);
	                        this._resize();
	                    }
	                }
	            },

	            createShape: function() {
	                if ((this.editor && this.editor.end()) || !this.editor) {
	                    var dataSource = this.dataSource;
	                    var view = dataSource.view() || [];
	                    var index = view.length;
	                    var model = createModel(dataSource, {});
	                    var shape = this._createShape(model, {});

	                    if (!this.trigger("add", { shape: shape })) {
	                        dataSource.insert(index, model);
	                        var inactiveItem = this._inactiveShapeItems.getByUid(model.uid);
	                        inactiveItem.element = shape;
	                        this.edit(shape);
	                    }
	                }
	            },

	            _createShape: function(dataItem, options) {
	                options = deepExtend({}, this.options.shapeDefaults, options);
	                options.dataItem = dataItem;
	                var shape = new Shape(options, this);
	                return shape;
	            },

	            createConnection: function() {
	                if (((this.editor && this.editor.end()) || !this.editor)) {
	                    var connectionsDataSource = this.connectionsDataSource;
	                    var view = connectionsDataSource.view() || [];
	                    var index = view.length;
	                    var model = createModel(connectionsDataSource, {});
	                    var connection = this._createConnection(model);
	                    if (!this.trigger("add", { connection: connection })) {
	                        this._connectionsDataMap[model.uid] = connection;
	                        connectionsDataSource.insert(index, model);
	                        this.addConnection(connection, false);
	                        this.edit(connection);
	                    }
	                }
	            },

	            _createConnection: function(dataItem, source, target) {
	                var options = deepExtend({}, this.options.connectionDefaults);
	                options.dataItem = dataItem;

	                var connection = new Connection(source || new Point(), target || new Point(), options);

	                return connection;
	            },

	            editModel: function(dataItem, editorType) {
	                this.cancelEdit();
	                var editors, template;
	                var editable = this.options.editable;

	                if (editorType == "shape") {
	                    editors = editable.shapeEditors;
	                    template = editable.shapeTemplate;
	                } else if (editorType == "connection") {
	                    var connectionSelectorHandler = proxy(connectionSelector, this);
	                    editors = deepExtend({}, { from: connectionSelectorHandler, to: connectionSelectorHandler }, editable.connectionEditors);
	                    template = editable.connectionTemplate;
	                } else {
	                    return;
	                }

	                this.editor = new PopupEditor(this.element, {
	                    update: proxy(this._update, this),
	                    cancel: proxy(this._cancel, this),
	                    model: dataItem,
	                    type: editorType,
	                    target: this,
	                    editors: editors,
	                    template: template
	                });

	                this.trigger("edit", this._editArgs());
	            },

	            edit: function(item) {
	                if (item.dataItem) {
	                    var editorType = item instanceof Shape ? "shape" : "connection";
	                    this.editModel(item.dataItem, editorType);
	                }
	            },

	            cancelEdit: function() {
	                if (this.editor) {
	                    this._getEditDataSource().cancelChanges(this.editor.model);

	                    this._destroyEditor();
	                }
	            },

	            saveEdit: function() {
	                if (this.editor && this.editor.end() &&
	                    !this.trigger("save", this._editArgs())) {
	                    this._getEditDataSource().sync();
	                }
	            },

	            _update: function() {
	                if (this.editor && this.editor.end() &&
	                    !this.trigger("save", this._editArgs())) {
	                    this._getEditDataSource().sync();
	                    this._destroyEditor();
	                }
	            },

	            _cancel: function() {
	                if (this.editor && !this.trigger("cancel", this._editArgs())) {
	                    var model = this.editor.model;
	                    this._getEditDataSource().cancelChanges(model);
	                    var element = this._connectionsDataMap[model.uid] || this._dataMap[model.id];
	                    if (element) {
	                        element._setOptionsFromModel(model);
	                    }
	                    this._destroyEditor();
	                }
	            },

	            _getEditDataSource: function() {
	                return this.editor.options.type === "shape" ? this.dataSource : this.connectionsDataSource;
	            },

	            _editArgs: function() {
	                var result = { container: this.editor.wrapper };
	                result[this.editor.options.type] = this.editor.model;
	                return result;
	            },

	            _destroyEditor: function() {
	                if (this.editor) {
	                    this.editor.close();
	                    this.editor = null;
	                }
	            },

	            _initElements: function() {
	                this.wrapper = this.element.empty()
	                    .css("position", "relative")
	                    .attr("tabindex", 0)
	                    .addClass("k-widget k-diagram");

	                this.scrollable = $("<div />").appendTo(this.element);
	            },

	            _initDefaults: function(userOptions) {
	                var options = this.options;
	                var editable = options.editable;
	                var shapeDefaults = options.shapeDefaults;
	                var connectionDefaults = options.connectionDefaults;
	                var userShapeDefaults = (userOptions || {}).shapeDefaults;
	                if (editable === false) {
	                    shapeDefaults.editable = false;
	                    connectionDefaults.editable = false;
	                } else {
	                    copyDefaultOptions(editable, shapeDefaults.editable, ["drag", "remove", "connect"]);
	                    copyDefaultOptions(editable, connectionDefaults.editable, ["drag", "remove"]);
	                }

	                if (userShapeDefaults && userShapeDefaults.connectors) {
	                    options.shapeDefaults.connectors = userShapeDefaults.connectors;
	                }
	            },

	            _interactionDefaults: function() {
	                var options = this.options;
	                var selectable = options.selectable;
	                var pannable = options.pannable;
	                var mobile = kendo.support.mobileOS;

	                if (selectable && !defined(selectable.multiple)) {
	                    options.selectable = deepExtend({
	                        multiple: mobile ? false : true
	                    }, options.selectable);
	                }

	                if (pannable && !defined(pannable.key)) {
	                    options.pannable = deepExtend({
	                        key: mobile ? "none" : "ctrl"
	                    }, options.pannable);
	                }
	            },

	            _initCanvas: function() {
	                var canvasContainer = $("<div class='k-layer'></div>").appendTo(this.scrollable)[0];
	                var viewPort = this.viewport();
	                this.canvas = new Canvas(canvasContainer, {
	                    width: viewPort.width || DEFAULT_CANVAS_WIDTH,
	                    height: viewPort.height || DEFAULT_CANVAS_HEIGHT
	                });
	            },

	            _createHandlers: function () {
	                var that = this;
	                var element = that.element;

	                element.on(MOUSEWHEEL_NS, proxy(that._wheel, that))
	                .on("keydown" + NS, proxy(that._keydown, that));

	                that._userEvents = new kendo.UserEvents(this.scrollable, {
	                    multiTouch: true,
	                    fastTap: true,
	                    tap: proxy(that._tap, that),
	                    start: proxy(that._dragStart, that),
	                    move: proxy(that._drag, that),
	                    end: proxy(that._dragEnd, that),
	                    gesturestart: proxy(that._gestureStart, that),
	                    gesturechange: proxy(that._gestureChange, that),
	                    gestureend: proxy(that._gestureEnd, that),
	                    doubleTap: proxy(that._doubleTap, that),
	                    supportDoubleTap: true
	                });

	                that.toolService = new ToolService(that);

	                this.scrollable
	                    .on("mouseover" + NS, proxy(that._mouseover, that))
	                    .on("mouseout" + NS, proxy(that._mouseout, that))
	                    .on("mousemove" + NS, proxy(that._mouseMove, that))
	                    .on("mousedown" + NS, proxy(that._mouseDown, that))
	                    .on("mouseup" + NS, proxy(that._mouseUp, that));

	                this._syncHandler = proxy(that._syncChanges, that);

	                that._resizeHandler = proxy(that.resize, that, false);
	                kendo.onResize(that._resizeHandler);

	                this.bind(ZOOM_START, proxy(that._destroyToolBar, that));
	                this.bind(PAN, proxy(that._destroyToolBar, that));
	            },

	            _dragStart: function (e) {
	                this._pauseMouseHandlers = true;
	                var point = this._eventPositions(e, true);

	                var event = e.event;
	                if (this.toolService.start(point, this._meta(event))) {
	                    this._destroyToolBar();
	                    event.preventDefault();
	                }
	            },

	            _drag: function (e) {
	                var p = this._eventPositions(e);
	                var event = e.event;
	                if (this.toolService.move(p, this._meta(event))) {
	                    event.preventDefault();
	                }
	            },

	            _dragEnd: function (e) {
	                this._pauseMouseHandlers = false;
	                var p = this._eventPositions(e);
	                var event = e.event;
	                if (this.toolService.end(p, this._meta(event))) {
	                    this._createToolBar();
	                    event.preventDefault();
	                }
	            },

	            _mouseMove: function (e) {
	                if (!this._pauseMouseHandlers) {
	                    var p = this._eventPositions(e);
	                    this.toolService._updateHoveredItem(p);
	                    this.toolService._updateCursor(p);
	                }
	            },

	            _mouseDown: function () {
	                this._pauseMouseHandlers = true;
	            },

	            _mouseUp: function () {
	                this._pauseMouseHandlers = false;
	            },

	            _tap: function(e) {
	                var toolService = this.toolService;
	                var selectable = this.options.selectable;
	                var point = this._eventPositions(e);
	                var focused = this.focus();

	                toolService._updateHoveredItem(point);

	                if (toolService.hoveredItem) {
	                    var item = toolService.hoveredItem;

	                    this.trigger("click", {
	                        item: item,
	                        point: point,
	                        meta: this._meta(e.event)
	                    });

	                    if (selectable && item.options.selectable !== false) {
	                        var multiple = selectable.multiple !== false;
	                        var ctrlPressed = kendo.support.mobileOS || this._meta(e.event).ctrlKey;

	                        if (item.isSelected) {
	                            if (ctrlPressed) {
	                                this._destroyToolBar();
	                                item.select(false);
	                            } else {
	                                this._createToolBar(focused);
	                            }
	                        } else {
	                            this._destroyToolBar();
	                            this.select(item, {
	                                addToSelection: multiple && ctrlPressed
	                            });
	                            this._createToolBar(focused);
	                        }
	                    }
	                } else if (selectable) {
	                    this._destroyToolBar();
	                    this.deselect();
	                }
	            },

	            _keydown: function (e) {
	                if (this.toolService.keyDown(e.keyCode, this._meta(e))) {
	                    e.preventDefault();
	                }
	            },

	            _wheel: function (e) {
	                var delta = mwDelta(e),
	                    p = this._eventPositions(e),
	                    meta = deepExtend(this._meta(e), { delta: delta });

	                if (this.toolService.wheel(p, meta)) {
	                    e.preventDefault();
	                }
	            },

	            _meta: function (e) {
	                return { ctrlKey: e.ctrlKey, metaKey: e.metaKey, altKey: e.altKey, shiftKey: e.shiftKey, type: e.type };
	            },

	            _eventPositions: function (e, start) {
	                var point;
	                if (e.touch) {
	                    var field = start ? "startLocation" : "location";
	                    point = new Point(e.x[field], e.y[field]);
	                } else {
	                    var event = e.originalEvent;
	                    point = new Point(event.pageX, event.pageY);
	                }

	                return this.documentToModel(point);
	            },

	            _gestureStart: function(e) {
	                this._destroyToolBar();
	                this.scroller.disable();
	                var initialCenter = this.documentToModel(new Point(e.center.x, e.center.y));
	                var eventArgs = {
	                    point: initialCenter,
	                    zoom: this.zoom()
	                };

	                if (this.trigger(ZOOM_START, eventArgs)) {
	                    return;
	                }

	                this._gesture = e;
	                this._initialCenter = initialCenter;
	            },

	            _gestureChange: function(e) {
	                var previousGesture = this._gesture;
	                var initialCenter = this._initialCenter;
	                var center = this.documentToView(new Point(e.center.x, e.center.y));
	                var scaleDelta = e.distance / previousGesture.distance;
	                var zoom = this._zoom;
	                var updateZoom = false;

	                if (math.abs(scaleDelta - 1) >= MOBILE_ZOOM_RATE) {
	                    this._zoom = zoom = this._getValidZoom(zoom * scaleDelta);
	                    this.options.zoom = zoom;
	                    this._gesture = e;
	                    updateZoom = true;
	                }

	                var zoomedPoint = initialCenter.times(zoom);
	                var pan = center.minus(zoomedPoint);
	                if (updateZoom || this._pan.distanceTo(pan) >= MOBILE_PAN_DISTANCE) {
	                    this._panTransform(pan);
	                    this._updateAdorners();
	                }

	                e.preventDefault();
	            },

	            _doubleTap: function(e) {
	                var diagram = this;
	                var pointPosition = this._eventPositions(e);
	                var options = diagram.options;
	                var zoomRate = options.zoomRate;
	                var zoom = diagram.zoom() + zoomRate;
	                var meta = this._meta(e);
	                var zoomOptions = { point: pointPosition, meta: meta, zoom: zoom };


	                if (diagram.trigger(ZOOM_START, zoomOptions)) {
	                    return;
	                }

	                zoom = kendo.dataviz.round(Math.max(options.zoomMin, Math.min(options.zoomMax, zoom)), 2);
	                zoomOptions.zoom = zoom;

	                diagram.zoom(zoom, zoomOptions);
	                diagram.trigger(ZOOM_END, zoomOptions);
	            },

	            _gestureEnd: function() {
	                if (this.options.pannable !== false)  {
	                    this.scroller.enable();
	                }
	                this.trigger(ZOOM_END, {
	                    point: this._initialCenter,
	                    zoom: this.zoom()
	                });
	            },

	            _resize: function() {
	                var viewport = this.viewport();
	                if (this.canvas) {
	                    this.canvas.size(viewport);
	                }

	                if (this.scrollable && this.toolBar) {
	                    this.scrollable.height(viewport.height);
	                }
	            },

	            _mouseover: function(e) {
	                var node = e.target._kendoNode;
	                if (node && node.srcElement._hover) {
	                    node.srcElement._hover(true, node.srcElement);
	                }
	            },

	            _mouseout: function(e) {
	                var node = e.target._kendoNode;
	                if (node && node.srcElement._hover) {
	                    node.srcElement._hover(false, node.srcElement);
	                }
	            },

	            _initTheme: function() {
	                var that = this;
	                var themeName = ((that.options || {}).theme || "").toLowerCase();
	                var themes = dataviz.ui.themes || {};
	                var themeOptions;

	                if(dataviz.SASS_THEMES.indexOf(themeName) != -1) {
	                    themeOptions = dataviz.autoTheme().diagram;
	                }
	                else {
	                    themeOptions = (themes[themeName] || {}).diagram;
	                }

	                that.options = deepExtend({}, themeOptions, that.options);
	                if (that.options.editable === true) {
	                    deepExtend(that.options, {
	                        editable: (themeOptions || {}).editable
	                    });
	                }
	            },

	            _createOptionElements: function() {
	                var options = this.options;
	                var shapesLength = options.shapes.length;

	                if (shapesLength) {
	                    this._createShapes();
	                }

	                if (options.connections.length) {
	                    this._createConnections();
	                }

	                if (shapesLength && options.layout) {
	                    this.layout(options.layout);
	                }
	            },

	            _createShapes: function() {
	                var that = this,
	                    options = that.options,
	                    shapes = options.shapes,
	                    shape, i;

	                for (i = 0; i < shapes.length; i++) {
	                    shape = shapes[i];
	                    that.addShape(shape);
	                }
	            },

	            _createConnections: function() {
	                var diagram = this,
	                    options = diagram.options,
	                    defaults = options.connectionDefaults,
	                    connections = options.connections,
	                    conn, source, target, i;

	                for(i = 0; i < connections.length; i++) {
	                    conn = connections[i];
	                    source = diagram._findConnectionTarget(conn.from);
	                    target = diagram._findConnectionTarget(conn.to);

	                    diagram.connect(source, target, deepExtend({}, defaults, conn));
	                }
	            },

	            _findConnectionTarget: function(options) {
	                options = options || {};
	                var diagram = this;
	                var shapeId = isString(options) ? options : options.shapeId || options.id;
	                var target;
	                if (shapeId) {
	                    target = diagram.getShapeById(shapeId);
	                    if (options.connector) {
	                        target = target.getConnector(options.connector);
	                    }
	                } else {
	                    target = new Point(options.x || 0, options.y || 0);
	                }

	                return target;
	            },

	            destroy: function () {
	                var that = this;
	                Widget.fn.destroy.call(that);

	                if (this._userEvents) {
	                    this._userEvents.destroy();
	                }

	                kendo.unbindResize(that._resizeHandler);

	                that.clear();
	                that.element.off(NS);
	                that.scroller.wrapper.off(NS);
	                that.canvas.destroy(true);
	                that.canvas = undefined;

	                that._destroyEditor();
	                that.destroyScroller();
	                that._destroyGlobalToolBar();
	                that._destroyToolBar();
	            },

	            destroyScroller: function () {
	                var scroller = this.scroller;

	                if (!scroller) {
	                    return;
	                }

	                scroller.destroy();
	                scroller.element.remove();
	                this.scroller = null;
	            },

	            save: function () {
	                var json = {
	                    shapes: [],
	                    connections: []
	                };
	                var i, connection, shape;

	                for (i = 0; i < this.shapes.length; i++) {
	                    shape = this.shapes[i];
	                    if (shape.options.serializable) {
	                        json.shapes.push(shape.options);
	                    }
	                }

	                for (i = 0; i < this.connections.length; i++) {
	                    connection = this.connections[i];

	                    json.connections.push(deepExtend({}, connection.options, connection.toJSON()));
	                }

	                return json;
	            },

	            focus: function() {
	                if (!this.element.is(kendo._activeElement())) {
	                    var element = this.element,
	                        scrollContainer = element[0],
	                        containers = [],
	                        offsets = [],
	                        documentElement = document.documentElement,
	                        i;

	                    do {
	                        scrollContainer = scrollContainer.parentNode;

	                        if (scrollContainer.scrollHeight > scrollContainer.clientHeight) {
	                            containers.push(scrollContainer);
	                            offsets.push(scrollContainer.scrollTop);
	                        }
	                    } while (scrollContainer != documentElement);

	                    element.focus();

	                    for (i = 0; i < containers.length; i++) {
	                        containers[i].scrollTop = offsets[i];
	                    }
	                    return true;
	                }
	            },

	            load: function(options) {
	                this.clear();

	                this.setOptions(options);
	                this._createShapes();
	                this._createConnections();
	            },

	            setOptions: function(options) {
	                deepExtend(this.options, options);
	            },

	            clear: function () {
	                var that = this;

	                that.select(false);
	                that.mainLayer.clear();
	                that._shapesQuadTree.clear();
	                that._initialize();
	            },
	            /**
	             * Connects two items.
	             * @param source Shape, Connector, Point.
	             * @param target Shape, Connector, Point.
	             * @param options Connection options that will be passed to the newly created connection.
	             * @returns The newly created connection.
	             */
	            connect: function (source, target, options) {
	                var connection;
	                if (this.connectionsDataSource && this._isEditable) {
	                    var dataItem = this.connectionsDataSource.add({});
	                    connection = this._connectionsDataMap[dataItem.uid];
	                    connection.source(source);
	                    connection.target(target);
	                    connection.redraw(options);
	                    connection.updateModel();
	                } else {
	                    connection = new Connection(source, target,
	                        deepExtend({ }, this.options.connectionDefaults, options));

	                    this.addConnection(connection);
	                }

	                return connection;
	            },
	            /**
	             * Determines whether the the two items are connected.
	             * @param source Shape, Connector, Point.
	             * @param target Shape, Connector, Point.
	             * @returns true if the two items are connected.
	             */
	            connected: function (source, target) {
	                for (var i = 0; i < this.connections.length; i++) {
	                    var c = this.connections[i];
	                    if (c.from == source && c.to == target) {
	                        return true;
	                    }
	                }

	                return false;
	            },
	            /**
	             * Adds connection to the diagram.
	             * @param connection Connection.
	             * @param undoable Boolean.
	             * @returns The newly created connection.
	             */
	            addConnection: function (connection, undoable) {
	                if (undoable !== false) {
	                    this.undoRedoService.add(
	                        new diagram.AddConnectionUnit(connection, this), false);
	                }

	                connection.diagram = this;
	                connection._setOptionsFromModel();
	                connection.refresh();
	                this.mainLayer.append(connection.visual);
	                this.connections.push(connection);

	                this.trigger(CHANGE, {
	                    added: [connection],
	                    removed: []
	                });

	                return connection;
	            },

	            _addConnection: function (connection, undoable) {
	                var connectionsDataSource = this.connectionsDataSource;
	                var dataItem;
	                if (connectionsDataSource && this._isEditable) {
	                    dataItem = createModel(connectionsDataSource, cloneDataItem(connection.dataItem));
	                    connection.dataItem = dataItem;
	                    connection.updateModel();

	                    if (!this.trigger("add", { connection: connection })) {
	                        this._connectionsDataMap[dataItem.uid] = connection;

	                        connectionsDataSource.add(dataItem);
	                        this.addConnection(connection, undoable);
	                        connection._updateConnectors();

	                        return connection;
	                    }
	                } else if (!this.trigger("add", { connection: connection })) {
	                    this.addConnection(connection, undoable);
	                    connection._updateConnectors();
	                    return connection;
	                }
	            },

	            /**
	             * Adds shape to the diagram.
	             * @param item Shape, Point. If point is passed it will be created new Shape and positioned at that point.
	             * @param options. The options to be passed to the newly created Shape.
	             * @returns The newly created shape.
	             */
	            addShape: function(item, undoable) {
	                var shape,
	                    shapeDefaults = this.options.shapeDefaults;

	                if (item instanceof Shape) {
	                    shape = item;
	                } else if (!(item instanceof kendo.Class)) {
	                    shapeDefaults = deepExtend({}, shapeDefaults, item || {});
	                    shape = new Shape(shapeDefaults, this);
	                } else {
	                    return;
	                }

	                if (undoable !== false) {
	                    this.undoRedoService.add(new diagram.AddShapeUnit(shape, this), false);
	                }

	                this.shapes.push(shape);
	                if (shape.diagram !== this) {
	                    this._shapesQuadTree.insert(shape);
	                    shape.diagram = this;
	                }
	                this.mainLayer.append(shape.visual);

	                this.trigger(CHANGE, {
	                    added: [shape],
	                    removed: []
	                });

	                return shape;
	            },

	            _addShape: function(shape, undoable) {
	                var that = this;
	                var dataSource = that.dataSource;
	                var dataItem;
	                if (dataSource && this._isEditable) {
	                    dataItem = createModel(dataSource, cloneDataItem(shape.dataItem));
	                    shape.dataItem = dataItem;
	                    shape.updateModel();

	                    if (!this.trigger("add", { shape: shape })) {
	                        this.dataSource.add(dataItem);
	                        var inactiveItem = this._inactiveShapeItems.getByUid(dataItem.uid);
	                        inactiveItem.element = shape;
	                        inactiveItem.undoable = undoable;
	                        return shape;
	                    }
	                } else if (!this.trigger("add", { shape: shape })) {
	                    return this.addShape(shape, undoable);
	                }
	            },
	            /**
	             * Removes items (or single item) from the diagram.
	             * @param items DiagramElement, Array of Items.
	             * @param undoable.
	             */

	           remove: function(items, undoable) {
	                items = isArray(items) ? items.slice(0) : [items];
	                var elements = splitDiagramElements(items);
	                var shapes = elements.shapes;
	                var connections = elements.connections;
	                var i;

	                if (!defined(undoable)) {
	                    undoable = true;
	                }

	                if (undoable) {
	                    this.undoRedoService.begin();
	                }

	                this._suspendModelRefresh();
	                for (i = shapes.length - 1; i >= 0; i--) {
	                   this._removeItem(shapes[i], undoable, connections);
	                }

	                for (i = connections.length - 1; i >= 0; i--) {
	                    this._removeItem(connections[i], undoable);
	                }

	                this._resumeModelRefresh();

	                if (undoable) {
	                    this.undoRedoService.commit(false);
	                }

	                this.trigger(CHANGE, {
	                    added: [],
	                    removed: items
	                });
	            },

	            _removeShapeDataItem: function(item) {
	                if (this._isEditable) {
	                    this.dataSource.remove(item.dataItem);
	                    delete this._dataMap[item.dataItem.id];
	                }
	            },

	            _removeConnectionDataItem: function(item) {
	                if (this._isEditable) {
	                    this.connectionsDataSource.remove(item.dataItem);
	                    delete this._connectionsDataMap[item.dataItem.uid];
	                }
	            },

	            _triggerRemove: function(items){
	                var toRemove = [];
	                var item, args, editable;

	                for (var idx = 0; idx < items.length; idx++) {
	                    item = items[idx];
	                    editable = item.options.editable;
	                    if (item instanceof Shape) {
	                        args = { shape: item };
	                    } else {
	                        args = { connection: item };
	                    }
	                    if (editable && editable.remove !== false && !this.trigger("remove", args)) {
	                        toRemove.push(item);
	                    }
	                }
	                return toRemove;
	            },

	            /**
	             * Executes the next undoable action on top of the undo stack if any.
	             */
	            undo: function () {
	                this.undoRedoService.undo();
	            },
	            /**
	             * Executes the previous undoable action on top of the redo stack if any.
	             */
	            redo: function () {
	                this.undoRedoService.redo();
	            },
	            /**
	             * Selects items on the basis of the given input or returns the current selection if none.
	             * @param itemsOrRect DiagramElement, Array of elements, "All", false or Rect. A value 'false' will deselect everything.
	             * @param options
	             * @returns {Array}
	             */
	            select: function (item, options) {
	                if (isDefined(item)) {
	                    options = deepExtend({ addToSelection: false }, options);

	                    var addToSelection = options.addToSelection,
	                        items = [],
	                        selected = [],
	                        i, element;

	                    if (!addToSelection) {
	                        this.deselect();
	                    }

	                    this._internalSelection = true;

	                    if (item instanceof Array) {
	                        items = item;
	                    } else if (item instanceof DiagramElement) {
	                        items = [ item ];
	                    }

	                    for (i = 0; i < items.length; i++) {
	                        element = items[i];
	                        if (element.select(true)) {
	                            selected.push(element);
	                        }
	                    }

	                    this._selectionChanged(selected, []);

	                    this._internalSelection = false;
	                } else {
	                    return this._selectedItems;
	                }
	            },

	            selectAll: function() {
	                this.select(this.shapes.concat(this.connections));
	            },

	            selectArea: function(rect) {
	                var i, items, item;
	                this._internalSelection = true;
	                var selected = [];
	                if (rect instanceof Rect) {
	                    items = this.shapes.concat(this.connections);
	                    for (i = 0; i < items.length; i++) {
	                        item = items[i];
	                        if ((!rect || item._hitTest(rect)) && item.options.enable) {
	                            if (item.select(true)) {
	                                selected.push(item);
	                            }
	                        }
	                    }
	                }

	                this._selectionChanged(selected, []);
	                this._internalSelection = false;
	            },

	            deselect: function(item) {
	                this._internalSelection = true;
	                var deselected = [],
	                    items = [],
	                    element, i;

	                if (item instanceof Array) {
	                    items = item;
	                } else if (item instanceof DiagramElement) {
	                    items.push(item);
	                } else if (!isDefined(item)) {
	                    items = this._selectedItems.slice(0);
	                }

	                for (i = 0; i < items.length; i++) {
	                    element = items[i];
	                    if (element.select(false)) {
	                        deselected.push(element);
	                    }
	                }

	                this._selectionChanged([], deselected);
	                this._internalSelection = false;
	            },
	            /**
	             * Brings to front the passed items.
	             * @param items DiagramElement, Array of Items.
	             * @param undoable. By default the action is undoable.
	             */
	            toFront: function (items, undoable) {
	                if (!items) {
	                    items = this._selectedItems.slice();
	                }

	                var result = this._getDiagramItems(items), indices;
	                if (!defined(undoable) || undoable) {
	                    indices = indicesOfItems(this.mainLayer, result.visuals);
	                    var unit = new ToFrontUnit(this, items, indices);
	                    this.undoRedoService.add(unit);
	                } else {
	                    this.mainLayer.toFront(result.visuals);
	                    this._fixOrdering(result, true);
	                }
	            },
	            /**
	             * Sends to back the passed items.
	             * @param items DiagramElement, Array of Items.
	             * @param undoable. By default the action is undoable.
	             */
	            toBack: function (items, undoable) {
	                if (!items) {
	                    items = this._selectedItems.slice();
	                }

	                var result = this._getDiagramItems(items), indices;
	                if (!defined(undoable) || undoable) {
	                    indices = indicesOfItems(this.mainLayer, result.visuals);
	                    var unit = new ToBackUnit(this, items, indices);
	                    this.undoRedoService.add(unit);
	                } else {
	                    this.mainLayer.toBack(result.visuals);
	                    this._fixOrdering(result, false);
	                }
	            },
	            /**
	             * Bring into view the passed item(s) or rectangle.
	             * @param items DiagramElement, Array of Items, Rect.
	             * @param options. align - controls the position of the calculated rectangle relative to the viewport.
	             * "Center middle" will position the items in the center. animate - controls if the pan should be animated.
	             */
	            bringIntoView: function (item, options) { // jQuery|Item|Array|Rect
	                var viewport = this.viewport();
	                var aligner = new diagram.RectAlign(viewport);
	                var current, rect, original, newPan;

	                if (viewport.width === 0 || viewport.height === 0) {
	                    return;
	                }

	                options = deepExtend({animate: false, align: "center middle"}, options);
	                if (options.align == "none") {
	                    options.align = "center middle";
	                }

	                if (item instanceof DiagramElement) {
	                    rect = item.bounds(TRANSFORMED);
	                } else if (isArray(item)) {
	                    rect = this.boundingBox(item);
	                } else if (item instanceof Rect) {
	                    rect = item.clone();
	                }

	                original = rect.clone();

	                rect.zoom(this._zoom);

	                if (rect.width > viewport.width || rect.height > viewport.height) {
	                    this._zoom = this._getValidZoom(math.min(viewport.width / original.width, viewport.height / original.height));
	                    rect = original.clone().zoom(this._zoom);
	                }

	                this._zoomMainLayer();

	                current = rect.clone();
	                aligner.align(rect, options.align);

	                newPan = rect.topLeft().minus(current.topLeft());
	                this.pan(newPan.times(-1), options.animate);
	            },

	            alignShapes: function (direction) {
	                if (isUndefined(direction)) {
	                    direction = "Left";
	                }
	                var items = this.select(),
	                    val,
	                    item,
	                    i;

	                if (items.length === 0) {
	                    return;
	                }

	                switch (direction.toLowerCase()) {
	                    case "left":
	                    case "top":
	                        val = MAX_VALUE;
	                        break;
	                    case "right":
	                    case "bottom":
	                        val = MIN_VALUE;
	                        break;
	                }

	                for (i = 0; i < items.length; i++) {
	                    item = items[i];
	                    if (item instanceof Shape) {
	                        switch (direction.toLowerCase()) {
	                            case "left":
	                                val = math.min(val, item.options.x);
	                                break;
	                            case "top":
	                                val = math.min(val, item.options.y);
	                                break;
	                            case "right":
	                                val = math.max(val, item.options.x);
	                                break;
	                            case "bottom":
	                                val = math.max(val, item.options.y);
	                                break;
	                        }
	                    }
	                }
	                var undoStates = [];
	                var shapes = [];
	                for (i = 0; i < items.length; i++) {
	                    item = items[i];
	                    if (item instanceof Shape) {
	                        shapes.push(item);
	                        undoStates.push(item.bounds());
	                        switch (direction.toLowerCase()) {
	                            case "left":
	                            case "right":
	                                item.position(new Point(val, item.options.y));
	                                break;
	                            case "top":
	                            case "bottom":
	                                item.position(new Point(item.options.x, val));
	                                break;
	                        }
	                    }
	                }
	                var unit = new diagram.TransformUnit(shapes, undoStates);
	                this.undoRedoService.add(unit, false);
	            },

	            zoom: function (zoom, options) {
	                if (zoom) {
	                    var staticPoint = options ? options.point : new diagram.Point(0, 0);
	                    // var meta = options ? options.meta : 0;
	                    zoom = this._zoom = this._getValidZoom(zoom);

	                    if (!isUndefined(staticPoint)) {//Viewpoint vector is constant
	                        staticPoint = new diagram.Point(math.round(staticPoint.x), math.round(staticPoint.y));
	                        var zoomedPoint = staticPoint.times(zoom);
	                        var viewportVector = this.modelToView(staticPoint);
	                        var raw = viewportVector.minus(zoomedPoint);//pan + zoomed point = viewpoint vector
	                        this._storePan(new diagram.Point(math.round(raw.x), math.round(raw.y)));
	                    }

	                    if (options) {
	                        options.zoom = zoom;
	                    }

	                    this._panTransform();

	                    this.canvas.surface.hideTooltip();

	                    this._updateAdorners();
	                }

	                return this._zoom;
	            },

	            _getPan: function(pan) {
	                var canvas = this.canvas;
	                if (!canvas.translate) {
	                    pan = pan.plus(this._pan);
	                }
	                return pan;
	            },

	            pan: function (pan, animate) {
	                if (pan instanceof Point) {
	                    var that = this;
	                    var scroller = that.scroller;
	                    pan = that._getPan(pan);
	                    pan = pan.times(-1);

	                    if (animate) {
	                        scroller.animatedScrollTo(pan.x, pan.y, function() {
	                            that._updateAdorners();
	                        });
	                    } else {
	                        scroller.scrollTo(pan.x, pan.y);
	                        that._updateAdorners();
	                    }
	                } else {
	                    return this._pan.times(-1);
	                }
	            },

	            viewport: function () {
	                var element = this.element;
	                var width = element.width();
	                var height = element.height();

	                if (this.toolBar) {
	                    height -= outerHeight(this.toolBar.element);
	                }

	                return new Rect(0, 0, width, height);
	            },
	            copy: function () {
	                if (this.options.copy.enabled) {
	                    this._clipboard = [];
	                    this._copyOffset = 1;
	                    for (var i = 0; i < this._selectedItems.length; i++) {
	                        var item = this._selectedItems[i];
	                        this._clipboard.push(item);
	                    }
	                }
	            },
	            cut: function () {
	                if (this.options.copy.enabled) {
	                    this._clipboard = [];
	                    this._copyOffset = 0;
	                    for (var i = 0; i < this._selectedItems.length; i++) {
	                        var item = this._selectedItems[i];
	                        this._clipboard.push(item);
	                    }
	                    this.remove(this._clipboard, true);
	                }
	            },

	            paste: function () {
	                if (this._clipboard.length > 0) {
	                    var item, copied, i;
	                    var mapping = {};
	                    var elements = splitDiagramElements(this._clipboard);
	                    var connections = elements.connections;
	                    var shapes = elements.shapes;
	                    var offset = {
	                        x: this._copyOffset * this.options.copy.offsetX,
	                        y: this._copyOffset * this.options.copy.offsetY
	                    };
	                    this.deselect();
	                    // first the shapes
	                    for (i = 0; i < shapes.length; i++) {
	                        item = shapes[i];
	                        copied = item.clone();
	                        mapping[item.id] = copied;
	                        copied.position(new Point(item.options.x + offset.x, item.options.y + offset.y));
	                        copied.diagram = this;
	                        copied = this._addShape(copied);
	                        if (copied) {
	                            copied.select();
	                        }
	                    }
	                    // then the connections
	                    for (i = 0; i < connections.length; i++) {
	                        item = connections[i];
	                        copied = this._addConnection(item.clone());
	                        if (copied) {
	                            this._updateCopiedConnection(copied, item, "source", mapping, offset);
	                            this._updateCopiedConnection(copied, item, "target", mapping, offset);

	                            copied.select(true);
	                            copied.updateModel();
	                        }
	                    }

	                    this._syncChanges();

	                    this._copyOffset += 1;
	                }
	            },

	            _updateCopiedConnection: function(connection, sourceConnection, connectorName, mapping, offset) {
	                var onActivate, inactiveItem, targetShape;
	                var target = sourceConnection[connectorName]();
	                var diagram = this;
	                if (target instanceof Connector && mapping[target.shape.id]) {
	                    targetShape = mapping[target.shape.id];
	                    if (diagram.getShapeById(targetShape.id)) {
	                        connection[connectorName](targetShape.getConnector(target.options.name));
	                    } else {
	                        inactiveItem = diagram._inactiveShapeItems.getByUid(targetShape.dataItem.uid);
	                        if (inactiveItem) {
	                            onActivate = function(item) {
	                                targetShape = diagram._dataMap[item.id];
	                                connection[connectorName](targetShape.getConnector(target.options.name));
	                                connection.updateModel();
	                            };
	                            diagram._deferredConnectionUpdates.push(inactiveItem.onActivate(onActivate));
	                        }
	                    }
	                } else {
	                    connection[connectorName](new Point(sourceConnection[connectorName + "Point"]().x + offset.x, sourceConnection[connectorName + "Point"]().y + offset.y));
	                }
	            },
	            /**
	             * Gets the bounding rectangle of the given items.
	             * @param items DiagramElement, Array of elements.
	             * @param origin Boolean. Pass 'true' if you need to get the bounding box of the shapes without their rotation offset.
	             * @returns {Rect}
	             */
	            boundingBox: function (items, origin) {
	                var rect = Rect.empty(), temp,
	                    di = isDefined(items) ? this._getDiagramItems(items) : {shapes: this.shapes};
	                if (di.shapes.length > 0) {
	                    var item = di.shapes[0];
	                    rect = item.bounds(ROTATED);
	                    for (var i = 1; i < di.shapes.length; i++) {
	                        item = di.shapes[i];
	                        temp = item.bounds(ROTATED);
	                        if (origin === true) {
	                            temp.x -= item._rotationOffset.x;
	                            temp.y -= item._rotationOffset.y;
	                        }
	                        rect = rect.union(temp);
	                    }
	                }
	                return rect;
	            },

	            _containerOffset: function() {
	                var containerOffset = this.element.offset();
	                if (this.toolBar) {
	                    containerOffset.top += outerHeight(this.toolBar.element);
	                }
	                return containerOffset;
	            },

	            documentToView: function(point) {
	                var containerOffset = this._containerOffset();

	                return new Point(point.x - containerOffset.left, point.y - containerOffset.top);
	            },
	            viewToDocument: function(point) {
	                var containerOffset = this._containerOffset();

	                return new Point(point.x + containerOffset.left, point.y + containerOffset.top);
	            },
	            viewToModel: function(point) {
	                return this._transformWithMatrix(point, this._matrixInvert);
	            },
	            modelToView: function(point) {
	                return this._transformWithMatrix(point, this._matrix);
	            },
	            modelToLayer: function(point) {
	                return this._transformWithMatrix(point, this._layerMatrix);
	            },
	            layerToModel: function(point) {
	                return this._transformWithMatrix(point, this._layerMatrixInvert);
	            },
	            documentToModel: function(point) {
	                var viewPoint = this.documentToView(point);
	                if (!this.canvas.translate) {
	                    viewPoint.x = viewPoint.x + this.scroller.scrollLeft;
	                    viewPoint.y = viewPoint.y + this.scroller.scrollTop;
	                }
	                return this.viewToModel(viewPoint);
	            },
	            modelToDocument: function(point) {
	                return this.viewToDocument(this.modelToView(point));
	            },
	            _transformWithMatrix: function(point, matrix) {
	                var result = point;
	                if (point instanceof Point) {
	                    if (matrix) {
	                        result = matrix.apply(point);
	                    }
	                }
	                else {
	                    var tl = this._transformWithMatrix(point.topLeft(), matrix),
	                        br = this._transformWithMatrix(point.bottomRight(), matrix);
	                    result = Rect.fromPoints(tl, br);
	                }
	                return result;
	            },

	            setDataSource: function(dataSource) {
	                this.options.dataSource = dataSource;
	                this._dataSource();
	                if (this.options.autoBind) {
	                    this.dataSource.fetch();
	                }
	            },

	            setConnectionsDataSource: function(dataSource) {
	                this.options.connectionsDataSource = dataSource;
	                this._connectionDataSource();
	                if (this.options.autoBind) {
	                    this.connectionsDataSource.fetch();
	                }
	            },

	            /**
	             * Performs a diagram layout of the given type.
	             * @param layoutType The layout algorithm to be applied (TreeLayout, LayeredLayout, SpringLayout).
	             * @param options Layout-specific options.
	             */
	            layout: function (options) {
	                this._layouting = true;
	                // TODO: raise layout event?
	                var type;
	                if(isUndefined(options)) {
	                    options = this.options.layout;
	                }
	                if (isUndefined(options) || isUndefined(options.type)) {
	                    type = "Tree";
	                }
	                else {
	                    type = options.type;
	                }
	                var l;
	                switch (type.toLowerCase()) {
	                    case "tree":
	                        l = new diagram.TreeLayout(this);
	                        break;

	                    case "layered":
	                        l = new diagram.LayeredLayout(this);
	                        break;

	                    case "forcedirected":
	                    case "force":
	                    case "spring":
	                    case "springembedder":
	                        l = new diagram.SpringLayout(this);
	                        break;
	                    default:
	                        throw "Layout algorithm '" + type + "' is not supported.";
	                }
	                var initialState = new diagram.LayoutState(this);
	                var finalState = l.layout(options);
	                if (finalState) {
	                    var unit = new diagram.LayoutUndoUnit(initialState, finalState, options ? options.animate : null);
	                    this.undoRedoService.add(unit);
	                }
	                this._layouting = false;
	                this._redrawConnections();
	            },
	            /**
	             * Gets a shape on the basis of its identifier.
	             * @param id (string) the identifier of a shape.
	             * @returns {Shape}
	             */
	            getShapeById: function (id) {
	                var found;
	                found = Utils.first(this.shapes, function (s) {
	                    return s.visual.id === id;
	                });
	                if (found) {
	                    return found;
	                }
	                found = Utils.first(this.connections, function (c) {
	                    return c.visual.id === id;
	                });
	                return found;
	            },

	            getShapeByModelId: function (id) {
	                var shape;
	                if (this._isEditable) {
	                    shape = this._dataMap[id];
	                } else {
	                    shape = Utils.first(this.shapes, function(shape) {
	                        return (shape.dataItem || {}).id === id;
	                    });
	                }
	                return shape;
	            },

	            getShapeByModelUid: function(uid) {
	                var shape;
	                if (this._isEditable) {
	                    shape = Utils.first(this.shapes, function(shape) {
	                        return (shape.dataItem || {}).uid === uid;
	                    });
	                } else {
	                    shape = this._dataMap[uid];
	                }
	                return shape;
	            },

	            getConnectionByModelId: function(id) {
	                var connection;
	                if (this.connectionsDataSource) {
	                    connection = Utils.first(this.connections, function(connection) {
	                        return (connection.dataItem || {}).id === id;
	                    });
	                }
	                return connection;
	            },

	            getConnectionByModelUid: function(uid) {
	                var connection;
	                if (this.connectionsDataSource) {
	                    connection = this._connectionsDataMap[uid];
	                }
	                return connection;
	            },

	            _extendLayoutOptions: function(options) {
	                if(options.layout) {
	                    options.layout = deepExtend({}, diagram.LayoutBase.fn.defaultOptions || {}, options.layout);
	                }
	            },

	            _selectionChanged: function (selected, deselected) {
	                if (selected.length || deselected.length) {
	                    this.trigger(SELECT, { selected: selected, deselected: deselected });
	                }
	            },
	            _getValidZoom: function (zoom) {
	                return math.min(math.max(zoom, this.options.zoomMin), this.options.zoomMax);
	            },
	            _panTransform: function (pos) {
	                var diagram = this,
	                    pan = pos || diagram._pan;

	                if (diagram.canvas.translate) {
	                    diagram.scroller.scrollTo(pan.x, pan.y);
	                    diagram._zoomMainLayer();
	                } else {
	                    diagram._storePan(pan);
	                    diagram._transformMainLayer();
	                }
	            },

	            _finishPan: function () {
	                this.trigger(PAN, {total: this._pan, delta: Number.NaN});
	            },
	            _storePan: function (pan) {
	                this._pan = pan;
	                this._storeViewMatrix();
	            },
	            _zoomMainLayer: function () {
	                var zoom = this._zoom;

	                var transform = new CompositeTransform(0, 0, zoom, zoom);
	                transform.render(this.mainLayer);
	                this._storeLayerMatrix(transform);
	                this._storeViewMatrix();
	            },
	            _transformMainLayer: function () {
	                var pan = this._pan,
	                    zoom = this._zoom;

	                var transform = new CompositeTransform(pan.x, pan.y, zoom, zoom);
	                transform.render(this.mainLayer);
	                this._storeLayerMatrix(transform);
	                this._storeViewMatrix();
	            },
	            _storeLayerMatrix: function(canvasTransform) {
	                this._layerMatrix = canvasTransform.toMatrix();
	                this._layerMatrixInvert = canvasTransform.invert().toMatrix();
	            },
	            _storeViewMatrix: function() {
	                var pan = this._pan,
	                    zoom = this._zoom;

	                var transform = new CompositeTransform(pan.x, pan.y, zoom, zoom);
	                this._matrix = transform.toMatrix();
	                this._matrixInvert = transform.invert().toMatrix();
	            },
	            _toIndex: function (items, indices) {
	                var result = this._getDiagramItems(items);
	                this.mainLayer.toIndex(result.visuals, indices);
	                this._fixOrdering(result, false);
	            },
	            _fixOrdering: function (result, toFront) {
	                var shapePos = toFront ? this.shapes.length - 1 : 0,
	                    conPos = toFront ? this.connections.length - 1 : 0,
	                    i, item;
	                for (i = 0; i < result.shapes.length; i++) {
	                    item = result.shapes[i];
	                    Utils.remove(this.shapes, item);
	                    Utils.insert(this.shapes, item, shapePos);
	                }
	                for (i = 0; i < result.cons.length; i++) {
	                    item = result.cons[i];
	                    Utils.remove(this.connections, item);
	                    Utils.insert(this.connections, item, conPos);
	                }
	            },
	            _getDiagramItems: function (items) {
	                var i, result = {}, args = items;
	                result.visuals = [];
	                result.shapes = [];
	                result.cons = [];

	                if (!items) {
	                    args = this._selectedItems.slice();
	                } else if (!isArray(items)) {
	                    args = [items];
	                }

	                for (i = 0; i < args.length; i++) {
	                    var item = args[i];
	                    if (item instanceof Shape) {
	                        result.shapes.push(item);
	                        result.visuals.push(item.visual);
	                    } else if (item instanceof Connection) {
	                        result.cons.push(item);
	                        result.visuals.push(item.visual);
	                    }
	                }

	                return result;
	            },

	            _removeItem: function (item, undoable, removedConnections) {
	                item.select(false);
	                if (item instanceof Shape) {
	                    this._removeShapeDataItem(item);
	                    this._removeShape(item, undoable, removedConnections);
	                } else if (item instanceof Connection) {
	                    this._removeConnectionDataItem(item);
	                    this._removeConnection(item, undoable);
	                }

	                this.mainLayer.remove(item.visual);
	            },

	            _removeShape: function (shape, undoable, removedConnections) {
	                var i, connection, connector,
	                    sources = [], targets = [];
	                this.toolService._removeHover();

	                if (undoable) {
	                    this.undoRedoService.addCompositeItem(new DeleteShapeUnit(shape));
	                }
	                Utils.remove(this.shapes, shape);
	                this._shapesQuadTree.remove(shape);

	                for (i = 0; i < shape.connectors.length; i++) {
	                    connector = shape.connectors[i];
	                    for (var j = 0; j < connector.connections.length; j++) {
	                        connection = connector.connections[j];
	                        if (!removedConnections || !dataviz.inArray(connection, removedConnections)) {
	                            if (connection.sourceConnector == connector) {
	                                sources.push(connection);
	                            } else if (connection.targetConnector == connector) {
	                                targets.push(connection);
	                            }
	                        }
	                    }
	                }

	                for (i = 0; i < sources.length; i++) {
	                    sources[i].source(null, undoable);
	                    sources[i].updateModel();
	                }
	                for (i = 0; i < targets.length; i++) {
	                    targets[i].target(null, undoable);
	                    targets[i].updateModel();
	                }
	            },

	            _removeConnection: function (connection, undoable) {
	                if (connection.sourceConnector) {
	                    Utils.remove(connection.sourceConnector.connections, connection);
	                }
	                if (connection.targetConnector) {
	                    Utils.remove(connection.targetConnector.connections, connection);
	                }
	                if (undoable) {
	                    this.undoRedoService.addCompositeItem(new DeleteConnectionUnit(connection));
	                }

	                Utils.remove(this.connections, connection);
	            },

	            _removeDataItems: function(items, recursive) {
	                var item, children, shape, idx;
	                items = isArray(items) ? items : [items];

	                while (items.length) {
	                    item = items.shift();
	                    shape = this._dataMap[item.uid];
	                    if (shape) {
	                        this._removeShapeConnections(shape);
	                        this._removeItem(shape, false);
	                        delete this._dataMap[item.uid];
	                        if (recursive && item.hasChildren && item.loaded()) {
	                            children = item.children.data();
	                            for (idx = 0; idx < children.length; idx++) {
	                                items.push(children[idx]);
	                            }
	                        }
	                    }
	                }
	            },

	            _removeShapeConnections: function(shape) {
	                var connections = shape.connections();
	                var idx;

	                if (connections) {
	                    for (idx = 0; idx < connections.length; idx++) {
	                        this._removeItem(connections[idx], false);
	                    }
	                }
	            },

	            _addDataItem: function(dataItem, undoable) {
	                if (!defined(dataItem)) {
	                    return;
	                }

	                var shape = this._dataMap[dataItem.id];
	                if (shape) {
	                    return shape;
	                }

	                var options = deepExtend({}, this.options.shapeDefaults);
	                options.dataItem = dataItem;
	                shape = new Shape(options, this);
	                this.addShape(shape, undoable !== false);
	                this._dataMap[dataItem.id] = shape;
	                return shape;
	            },

	            _addDataItemByUid: function(dataItem) {
	                if (!defined(dataItem)) {
	                    return;
	                }

	                var shape = this._dataMap[dataItem.uid];
	                if (shape) {
	                    return shape;
	                }

	                var options = deepExtend({}, this.options.shapeDefaults);
	                options.dataItem = dataItem;
	                shape = new Shape(options, this);
	                this.addShape(shape);
	                this._dataMap[dataItem.uid] = shape;
	                return shape;
	            },

	            _addDataItems: function(items, parent) {
	                var item, idx, shape, parentShape, connection;
	                for (idx = 0; idx < items.length; idx++) {
	                    item = items[idx];
	                    shape = this._addDataItemByUid(item);
	                    parentShape = this._addDataItemByUid(parent);
	                    if (parentShape && !this.connected(parentShape, shape)) { // check if connected to not duplicate connections.
	                        connection = this.connect(parentShape, shape);
	                    }
	                }
	            },

	            _refreshSource: function (e) {
	                var that = this,
	                    node = e.node,
	                    action = e.action,
	                    items = e.items,
	                    options = that.options,
	                    idx,
	                    dataBound;

	                if (e.field) {
	                    for (idx = 0; idx < items.length; idx++) {
	                        if (this._dataMap[items[idx].uid]) {
	                            this._dataMap[items[idx].uid].redrawVisual();
	                        }
	                    }
	                    return;
	                }

	                if (action == "remove") {
	                    this._removeDataItems(e.items, true);
	                } else {

	                    if ((!action || action === "itemloaded") && !this._bindingRoots) {
	                        this._bindingRoots = true;
	                        dataBound = true;
	                    }

	                    if (!action && !node) {
	                        that.clear();
	                    }

	                    this._addDataItems(items, node);

	                    for (idx = 0; idx < items.length; idx++) {
	                        items[idx].load();
	                    }
	                }

	                if (options.layout && (dataBound || action == "remove" || action == "add")) {
	                    that.layout(options.layout);
	                }

	                if (dataBound) {
	                    this.trigger("dataBound");
	                    this._bindingRoots = false;
	                }
	            },

	            _addItem: function (item) {
	                if (item instanceof Shape) {
	                    this.addShape(item);
	                } else if (item instanceof Connection) {
	                    this.addConnection(item);
	                }
	            },

	            _createToolBar: function(preventClosing) {
	                var diagram = this.toolService.diagram;

	                if (!this.singleToolBar && diagram.select().length === 1) {
	                    var element = diagram.select()[0];
	                    if (element && element.options.editable !== false) {
	                        var editable = element.options.editable;
	                        var tools = editable.tools;
	                        if (this._isEditable && tools.length === 0) {
	                            if (element instanceof Shape) {
	                                tools = ["edit", "rotateClockwise", "rotateAnticlockwise"];
	                            } else if (element instanceof Connection) {
	                                tools = ["edit"];
	                            }

	                            if (editable && editable.remove !== false) {
	                                tools.push("delete");
	                            }
	                        }

	                        if (tools && tools.length) {
	                            var padding = 20;
	                            var point;
	                            this.singleToolBar = new DiagramToolBar(diagram, {
	                                tools: tools,
	                                click: proxy(this._toolBarClick, this),
	                                modal: true,
	                                popupZIndex: parseInt(diagram.element.closest(".k-window").css("zIndex"), 10) + 10
	                            });
	                            var popupWidth = outerWidth(this.singleToolBar._popup.element);
	                            var popupHeight = outerHeight(this.singleToolBar._popup.element);
	                            if (element instanceof Shape) {
	                                var shapeBounds = this.modelToView(element.bounds(ROTATED));
	                                point = new Point(shapeBounds.x, shapeBounds.y).minus(new Point(
	                                    (popupWidth - shapeBounds.width) / 2,
	                                    popupHeight + padding));
	                            } else if (element instanceof Connection) {
	                                var connectionBounds = this.modelToView(element.bounds());

	                                point = new Point(connectionBounds.x, connectionBounds.y)
	                                    .minus(new Point(
	                                        (popupWidth - connectionBounds.width - 20) / 2,
	                                        popupHeight + padding
	                                    ));
	                            }

	                            if (point) {
	                                if (!this.canvas.translate) {
	                                    point = point.minus(new Point(this.scroller.scrollLeft, this.scroller.scrollTop));
	                                }
	                                point = this.viewToDocument(point);
	                                point = new Point(math.max(point.x, 0), math.max(point.y, 0));
	                                this.singleToolBar.showAt(point);
	                                if (preventClosing) {
	                                    this.singleToolBar._popup.one("close", preventDefault);
	                                }
	                            } else {
	                                this._destroyToolBar();
	                            }
	                        }
	                    }
	                }
	            },

	            _toolBarClick: function(e) {
	                this.trigger("toolBarClick", e);
	                this._destroyToolBar();
	            },

	            _normalizePointZoom: function (point) {
	                return point.times(1 / this.zoom());
	            },

	            _initialize: function () {
	                this.shapes = [];
	                this._selectedItems = [];
	                this.connections = [];
	                this._dataMap = {};
	                this._connectionsDataMap = {};
	                this._inactiveShapeItems = new InactiveItemsCollection();
	                this._deferredConnectionUpdates = [];
	                this.undoRedoService = new UndoRedoService({
	                    undone: this._syncHandler,
	                    redone: this._syncHandler
	                });
	                this.id = diagram.randomId();
	            },

	            _fetchFreshData: function () {
	                var that = this;
	                that._dataSource();

	                if (that._isEditable) {
	                    that._connectionDataSource();
	                }

	                if (that.options.autoBind) {
	                    if (that._isEditable) {
	                        this._loadingShapes = true;
	                        this._loadingConnections = true;
	                        that.dataSource.fetch();
	                        that.connectionsDataSource.fetch();
	                    } else {
	                        that.dataSource.fetch();
	                    }
	                }
	            },

	            _dataSource: function() {
	                if (defined(this.options.connectionsDataSource)) {
	                    this._isEditable = true;
	                    var dsOptions = this.options.dataSource || {};
	                    var ds = isArray(dsOptions) ? { data: dsOptions } : dsOptions;

	                    if (this.dataSource && this._shapesRefreshHandler) {
	                        this.dataSource
	                            .unbind("change", this._shapesRefreshHandler)
	                            .unbind("requestStart", this._shapesRequestStartHandler)
	                            .unbind("error", this._shapesErrorHandler);
	                    } else {
	                        this._shapesRefreshHandler = proxy(this._refreshShapes, this);
	                        this._shapesRequestStartHandler = proxy(this._shapesRequestStart, this);
	                        this._shapesErrorHandler = proxy(this._error, this);
	                    }

	                    this.dataSource = kendo.data.DataSource.create(ds)
	                        .bind("change", this._shapesRefreshHandler)
	                        .bind("requestStart", this._shapesRequestStartHandler)
	                        .bind("error", this._shapesErrorHandler);
	                } else {
	                    this._treeDataSource();
	                    this._isEditable = false;
	                }
	            },

	            _connectionDataSource: function() {
	                var dsOptions = this.options.connectionsDataSource;
	                if (dsOptions) {
	                    var ds = isArray(dsOptions) ? { data: dsOptions } : dsOptions;

	                    if (this.connectionsDataSource && this._connectionsRefreshHandler) {
	                        this.connectionsDataSource
	                            .unbind("change", this._connectionsRefreshHandler)
	                            .unbind("requestStart", this._connectionsRequestStartHandler)
	                            .unbind("error", this._connectionsErrorHandler);
	                    } else {
	                        this._connectionsRefreshHandler = proxy(this._refreshConnections, this);
	                        this._connectionsRequestStartHandler = proxy(this._connectionsRequestStart, this);
	                        this._connectionsErrorHandler = proxy(this._connectionsError, this);
	                    }

	                    this.connectionsDataSource = kendo.data.DataSource.create(ds)
	                        .bind("change", this._connectionsRefreshHandler)
	                        .bind("requestStart", this._connectionsRequestStartHandler)
	                        .bind("error", this._connectionsErrorHandler);
	                }
	            },

	            _shapesRequestStart: function(e) {
	                if (e.type == "read") {
	                    this._loadingShapes = true;
	                }
	            },

	            _connectionsRequestStart: function(e) {
	                if (e.type == "read") {
	                    this._loadingConnections = true;
	                }
	            },

	            _error: function () {
	                this._loadingShapes = false;
	            },

	            _connectionsError: function() {
	                this._loadingConnections = false;
	            },

	            _refreshShapes: function(e) {
	                if (e.action === "remove") {
	                    if (this._shouldRefresh()) {
	                        this._removeShapes(e.items);
	                    }
	                } else if (e.action === "itemchange") {
	                    if (this._shouldRefresh()) {
	                        this._updateShapes(e.items, e.field);
	                    }
	                } else if (e.action === "add") {
	                    this._inactiveShapeItems.add(e.items);
	                } else if (e.action === "sync") {
	                    this._syncShapes(e.items);
	                } else {
	                    this.refresh();
	                }
	            },

	            _shouldRefresh: function() {
	                return !this._suspended;
	            },

	            _suspendModelRefresh: function() {
	                this._suspended = (this._suspended || 0) + 1;
	            },

	            _resumeModelRefresh: function() {
	                this._suspended = math.max((this._suspended || 0) - 1, 0);
	            },

	            refresh: function() {
	                this._loadingShapes = false;
	                if (!this._loadingConnections) {
	                    this._rebindShapesAndConnections();
	                }
	            },

	            _rebindShapesAndConnections: function() {
	                this.clear();
	                this._addShapes(this.dataSource.view());
	                if (this.connectionsDataSource) {
	                    this._addConnections(this.connectionsDataSource.view(), false);
	                }

	                if (this.options.layout) {
	                    this.layout(this.options.layout);
	                } else {
	                    this._redrawConnections();
	                }
	                this.trigger("dataBound");
	            },

	            refreshConnections: function() {
	                this._loadingConnections = false;
	                if (!this._loadingShapes) {
	                    this._rebindShapesAndConnections();
	                }
	            },

	            _redrawConnections: function() {
	                var connections = this.connections;
	                for (var idx = 0; idx < connections.length; idx++) {
	                    connections[idx].refresh();
	                }
	            },

	            _removeShapes: function(items) {
	                var dataMap = this._dataMap;
	                var item, i;
	                for (i = 0; i < items.length; i++) {
	                    item = items[i];
	                    if (dataMap[item.id]) {
	                        this.remove(dataMap[item.id], false);
	                        dataMap[item.id] = null;
	                    }
	                }
	            },

	            _syncShapes: function() {
	                var diagram = this;
	                var inactiveItems = diagram._inactiveShapeItems;
	                inactiveItems.forEach(function(inactiveItem) {
	                    var dataItem = inactiveItem.dataItem;
	                    var shape = inactiveItem.element;
	                    if (!dataItem.isNew()) {
	                        if (shape) {
	                            shape._setOptionsFromModel();
	                            diagram.addShape(shape, inactiveItem.undoable);
	                            diagram._dataMap[dataItem.id] = shape;
	                        } else {
	                            diagram._addDataItem(dataItem);
	                        }
	                        inactiveItem.activate();
	                        inactiveItems.remove(dataItem);
	                    }
	                });
	            },

	            _updateShapes: function(items, field) {
	                for (var i = 0; i < items.length; i++) {
	                    var dataItem = items[i];

	                    var shape = this._dataMap[dataItem.id];
	                    if (shape) {
	                        shape.updateOptionsFromModel(dataItem, field);
	                    }
	                }
	            },

	            _addShapes: function(dataItems) {
	                for (var i = 0; i < dataItems.length; i++) {
	                    this._addDataItem(dataItems[i], false);
	                }
	            },

	            _refreshConnections: function(e) {
	                if (e.action === "remove") {
	                    if (this._shouldRefresh()) {
	                        this._removeConnections(e.items);
	                    }
	                } else if (e.action === "add") {
	                    this._addConnections(e.items);
	                } else if (e.action === "sync") {
	                    //TO DO: include logic to update the connections with different values returned from the server.
	                } else if (e.action === "itemchange") {
	                    if (this._shouldRefresh()) {
	                        this._updateConnections(e.items);
	                    }
	                } else {
	                    this.refreshConnections();
	                }
	            },

	            _removeConnections: function(items) {
	                for (var i = 0; i < items.length; i++) {
	                    this.remove(this._connectionsDataMap[items[i].uid], false);
	                    this._connectionsDataMap[items[i].uid] = null;
	                }
	            },

	            _updateConnections: function(items) {
	                for (var i = 0; i < items.length; i++) {
	                    var dataItem = items[i];

	                    var connection = this._connectionsDataMap[dataItem.uid];
	                    connection.updateOptionsFromModel(dataItem);
	                }
	            },

	            _addConnections: function(connections, undoable) {
	                var length = connections.length;

	                for (var i = 0; i < length; i++) {
	                    var dataItem = connections[i];
	                    this._addConnectionDataItem(dataItem, undoable);
	                }
	            },

	            _addConnectionDataItem: function(dataItem, undoable) {
	                if (!this._connectionsDataMap[dataItem.uid]) {
	                    var from = this._validateConnector(dataItem.from);
	                    if (!defined(from) || from === null) {
	                        from = new Point(dataItem.fromX, dataItem.fromY);
	                    }

	                    var to = this._validateConnector(dataItem.to);
	                    if (!defined(to) || to === null) {
	                        to = new Point(dataItem.toX, dataItem.toY);
	                    }

	                    if (defined(from) && defined(to)) {
	                        var options = deepExtend({}, this.options.connectionDefaults);
	                        options.dataItem = dataItem;
	                        var connection = new Connection(from, to, options);

	                        this._connectionsDataMap[dataItem.uid] = connection;
	                        this.addConnection(connection, undoable);
	                    }
	                }
	            },

	            _validateConnector: function(value) {
	                var connector;

	                if (defined(value) && value !== null) {
	                    connector = this._dataMap[value];
	                }

	                return connector;
	            },

	            _treeDataSource: function () {
	                var that = this,
	                    options = that.options,
	                    dataSource = options.dataSource;

	                dataSource = isArray(dataSource) ? { data: dataSource } : dataSource;

	                if (dataSource instanceof kendo.data.DataSource && !(dataSource instanceof kendo.data.HierarchicalDataSource)) {
	                    throw new Error("Incorrect DataSource type. If a single dataSource instance is set to the diagram then it should be a HierarchicalDataSource. You should set only the options instead of an instance or a HierarchicalDataSource instance or supply connectionsDataSource as well.");
	                }

	                if (!dataSource.fields) {
	                    dataSource.fields = [
	                        { field: "text" },
	                        { field: "url" },
	                        { field: "spriteCssClass" },
	                        { field: "imageUrl" }
	                    ];
	                }
	                if (that.dataSource && that._refreshHandler) {
	                    that._unbindDataSource();
	                }

	                that._refreshHandler = proxy(that._refreshSource, that);
	                that._errorHandler = proxy(that._error, that);

	                that.dataSource = HierarchicalDataSource.create(dataSource)
	                    .bind(CHANGE, that._refreshHandler)
	                    .bind(ERROR, that._errorHandler);
	            },

	            _unbindDataSource: function () {
	                var that = this;

	                that.dataSource.unbind(CHANGE, that._refreshHandler).unbind(ERROR, that._errorHandler);
	            },

	            _adorn: function (adorner, isActive) {
	                if (isActive !== undefined && adorner) {
	                    if (isActive) {
	                        this._adorners.push(adorner);
	                        this.adornerLayer.append(adorner.visual);
	                    }
	                    else {
	                        Utils.remove(this._adorners, adorner);
	                        this.adornerLayer.remove(adorner.visual);
	                    }
	                }
	            },

	            _showConnectors: function (shape, value) {
	                if (value) {
	                    this._connectorsAdorner.show(shape);
	                } else {
	                    this._connectorsAdorner.destroy();
	                }
	            },

	            _updateAdorners: function() {
	                var adorners = this._adorners;

	                for(var i = 0; i < adorners.length; i++) {
	                    var adorner = adorners[i];

	                    if (adorner.refreshBounds) {
	                        adorner.refreshBounds();
	                    }
	                    adorner.refresh();
	                }
	            },

	            _refresh: function () {
	                for (var i = 0; i < this.connections.length; i++) {
	                    this.connections[i].refresh();
	                }
	            },

	            _destroyToolBar: function() {
	                if (this.singleToolBar) {
	                    this.singleToolBar.hide();
	                    this.singleToolBar.destroy();
	                    this.singleToolBar = null;
	                }
	            },

	            _destroyGlobalToolBar: function() {
	                if (this.toolBar) {
	                    this.toolBar.hide();
	                    this.toolBar.destroy();
	                    this.toolBar = null;
	                }
	            },

	            exportDOMVisual: function() {
	                var viewBox = this.canvas._viewBox;
	                var scrollOffset = geom.transform()
	                                       .translate(-viewBox.x, -viewBox.y);

	                var viewRect = new geom.Rect([0, 0], [viewBox.width, viewBox.height]);
	                var clipPath = draw.Path.fromRect(viewRect);
	                var wrap = new draw.Group({ transform: scrollOffset });
	                var clipWrap = new draw.Group({ clip: clipPath });
	                var root = this.canvas.drawingElement.children[0];

	                clipWrap.append(wrap);

	                // Don't reparent the root
	                wrap.children.push(root);

	                return clipWrap;
	            },

	            exportVisual: function() {
	                var scale = geom.transform().scale(1 / this._zoom);
	                var wrap = new draw.Group({
	                    transform: scale
	                });

	                var root = this.mainLayer.drawingElement;
	                wrap.children.push(root);

	                return wrap;
	            },

	            _syncChanges: function() {
	                this._syncShapeChanges();
	                this._syncConnectionChanges();
	            },

	            _syncShapeChanges: function() {
	                if (this.dataSource && this._isEditable) {
	                    this.dataSource.sync();
	                }
	            },

	            _syncConnectionChanges: function() {
	                var that = this;
	                if (that.connectionsDataSource && that._isEditable) {
	                    $.when.apply($, that._deferredConnectionUpdates).then(function() {
	                        that.connectionsDataSource.sync();
	                    });
	                    that.deferredConnectionUpdates = [];
	                }
	            }
	        });

	        dataviz.ExportMixin.extend(Diagram.fn, true);

	        if (kendo.PDFMixin) {
	            kendo.PDFMixin.extend(Diagram.fn);
	        }

	        function filterShapeDataItem(dataItem) {
	            var result = {};

	            dataItem = dataItem || {};

	            if (defined(dataItem.text) && dataItem.text !== null) {
	                result.text = dataItem.text;
	            }

	            if (defined(dataItem.x) && dataItem.x !== null) {
	                result.x = dataItem.x;
	            }

	            if (defined(dataItem.y) && dataItem.y !== null) {
	                result.y = dataItem.y;
	            }

	            if (defined(dataItem.width) && dataItem.width !== null) {
	                result.width = dataItem.width;
	            }

	            if (defined(dataItem.height) && dataItem.height !== null) {
	                result.height = dataItem.height;
	            }

	            if (defined(dataItem.type) && dataItem.type !== null) {
	                result.type = dataItem.type;
	            }

	            return result;
	        }

	        function filterConnectionDataItem(dataItem) {
	            var result = {};

	            dataItem = dataItem || {};

	            if (defined(dataItem.text) && dataItem.text !== null) {
	                result.content = dataItem.text;
	            }

	            if (defined(dataItem.type) && dataItem.type !== null) {
	                result.type = dataItem.type;
	            }

	            if (defined(dataItem.from) && dataItem.from !== null) {
	                result.from = dataItem.from;
	            }

	            if (defined(dataItem.fromConnector) && dataItem.fromConnector !== null) {
	                result.fromConnector = dataItem.fromConnector;
	            }

	            if (defined(dataItem.fromX) && dataItem.fromX !== null) {
	                result.fromX = dataItem.fromX;
	            }

	            if (defined(dataItem.fromY) && dataItem.fromY !== null) {
	                result.fromY = dataItem.fromY;
	            }

	            if (defined(dataItem.to) && dataItem.to !== null) {
	                result.to = dataItem.to;
	            }

	            if (defined(dataItem.toConnector) && dataItem.toConnector !== null) {
	                result.toConnector = dataItem.toConnector;
	            }

	            if (defined(dataItem.toX) && dataItem.toX !== null) {
	                result.toX = dataItem.toX;
	            }

	            if (defined(dataItem.toY) && dataItem.toY !== null) {
	                result.toY = dataItem.toY;
	            }

	            return result;
	        }


	        var DiagramToolBar = kendo.Observable.extend({
	            init: function(diagram, options) {
	                kendo.Observable.fn.init.call(this);
	                this.diagram = diagram;
	                this.options = deepExtend({}, this.options, options);
	                this._tools = [];
	                this.createToolBar();
	                this.createTools();
	                this.appendTools();

	                if (this.options.modal) {
	                    this.createPopup();
	                }

	                this.bind(this.events, options);
	            },

	            events: ["click"],

	            createPopup: function() {
	                this.container = $("<div/>").append(this.element);
	                this._popup = this.container.kendoPopup({}).getKendoPopup();
	            },

	            appendTools: function() {
	                for (var i = 0; i < this._tools.length; i++) {
	                    var tool = this._tools[i];
	                    if (tool.buttons && tool.buttons.length || !defined(tool.buttons)) {
	                        this._toolBar.add(tool);
	                    }
	                }
	            },

	            createToolBar: function() {
	                this.element = $("<div/>");
	                this._toolBar = this.element
	                    .kendoToolBar({
	                        click: proxy(this.click, this),
	                        resizable: false
	                    }).getKendoToolBar();

	                this.element.css("border", "none");
	            },

	            createTools: function() {
	                for (var i = 0; i < this.options.tools.length; i++) {
	                    this.createTool(this.options.tools[i]);
	                }
	            },

	            createTool: function(tool) {
	                if (!isPlainObject(tool)) {
	                    tool = {
	                        name: tool
	                    };
	                }
	                var toolName = tool.name + "Tool";
	                if (this[toolName]) {
	                    this[toolName](tool);
	                } else {
	                    this._tools.push(deepExtend({}, tool, {
	                        attributes: this._setAttributes({action: tool.name})
	                    }));
	                }
	            },

	            showAt: function(point) {
	                var popupZIndex = parseInt(this.options.popupZIndex, 10);

	                if (this._popup) {
	                    this._popup.open(point.x, point.y);

	                    if (popupZIndex) {
	                        this._popup.wrapper.css("zIndex", popupZIndex);
	                    }
	                }
	            },

	            hide: function() {
	                if (this._popup) {
	                    this._popup.close();
	                }
	            },

	            newGroup: function() {
	                return {
	                    type: "buttonGroup",
	                    buttons: []
	                };
	            },

	            editTool: function() {
	                this._tools.push({
	                    icon: "edit",
	                    showText: "overflow",
	                    type: "button",
	                    text: "Edit",
	                    attributes: this._setAttributes({ action: "edit" })
	                });
	            },

	            deleteTool: function() {
	                this._tools.push({
	                    icon: "close",
	                    showText: "overflow",
	                    type: "button",
	                    text: "Delete",
	                    attributes: this._setAttributes({ action: "delete" })
	                });
	            },

	            rotateAnticlockwiseTool: function(options) {
	                this._appendGroup("rotate");
	                this._rotateGroup.buttons.push({
	                    icon: "rotate-left",
	                    showText: "overflow",
	                    text: "RotateAnticlockwise",
	                    group: "rotate",
	                    attributes: this._setAttributes({ action: "rotateAnticlockwise", step: options.step })
	                });
	            },

	            rotateClockwiseTool: function(options) {
	                this._appendGroup("rotate");
	                this._rotateGroup.buttons.push({
	                    icon: "rotate-right",
	                    attributes: this._setAttributes({ action: "rotateClockwise", step: options.step }),
	                    showText: "overflow",
	                    text: "RotateClockwise",
	                    group: "rotate"
	                });
	            },

	            createShapeTool: function() {
	                this._appendGroup("create");
	                this._createGroup.buttons.push({
	                    icon: "shape",
	                    showText: "overflow",
	                    text: "CreateShape",
	                    group: "create",
	                    attributes: this._setAttributes({ action: "createShape" })
	                });
	            },

	            createConnectionTool: function() {
	                this._appendGroup("create");
	                this._createGroup.buttons.push({
	                    icon: "connector",
	                    showText: "overflow",
	                    text: "CreateConnection",
	                    group: "create",
	                    attributes: this._setAttributes({ action: "createConnection" })
	                });
	            },

	            undoTool: function() {
	                this._appendGroup("history");
	                this._historyGroup.buttons.push({
	                    icon: "undo",
	                    showText: "overflow",
	                    text: "Undo",
	                    group: "history",
	                    attributes: this._setAttributes({ action: "undo" })
	                });
	            },

	            redoTool: function() {
	                this._appendGroup("history");
	                this._historyGroup.buttons.push({
	                    icon: "redo",
	                    showText: "overflow",
	                    text: "Redo",
	                    group: "history",
	                    attributes: this._setAttributes({ action: "redo" })
	                });
	            },

	            _appendGroup: function(name) {
	                var prop = "_" + name + "Group";
	                if (!this[prop]) {
	                    this[prop] = this.newGroup();
	                    this._tools.push(this[prop]);
	                }
	            },

	            _setAttributes: function(attributes) {
	                var attr = {};

	                if (attributes.action) {
	                    attr[kendo.attr("action")] = attributes.action;
	                }

	                if (attributes.step) {
	                    attr[kendo.attr("step")] = attributes.step;
	                }

	                return attr;
	            },

	            _getAttributes: function(element) {
	                var attr = {};

	                var action = element.attr(kendo.attr("action"));
	                if (action) {
	                    attr.action = action;
	                }

	                var step = element.attr(kendo.attr("step"));
	                if (step) {
	                    attr.step = step;
	                }

	                return attr;
	            },

	            click: function(e) {
	                var attributes = this._getAttributes($(e.target));
	                var action = attributes.action;

	                if (action && this[action]) {
	                    this[action](attributes);
	                }

	                this.trigger("click", this.eventData(action, e.target));
	            },

	            eventData: function(action, target) {
	                var elements = this.selectedElements(),
	                    length = elements.length,
	                    shapes = [], connections = [], element;

	                for (var idx = 0; idx < length; idx++) {
	                    element = elements[idx];
	                    if (element instanceof Shape) {
	                        shapes.push(element);
	                    } else {
	                        connections.push(element);
	                    }
	                }

	                return {
	                    shapes: shapes,
	                    connections: connections,
	                    action: action,
	                    target: target
	                };
	            },

	            "delete": function() {
	                var diagram = this.diagram;
	                var toRemove = diagram._triggerRemove(this.selectedElements());
	                if (toRemove.length) {
	                    this.diagram.remove(toRemove, true);
	                    this.diagram._syncChanges();
	                }
	            },

	            edit: function() {
	                var selectedElemens = this.selectedElements();
	                if (selectedElemens.length === 1) {
	                    this.diagram.edit(selectedElemens[0]);
	                }
	            },

	            rotateClockwise: function(options) {
	                var angle = parseFloat(options.step || 90);
	                this._rotate(angle);
	            },

	            rotateAnticlockwise: function(options) {
	                var angle = parseFloat(options.step || 90);
	                this._rotate(-angle);
	            },

	            _rotate: function(angle) {
	                var adorner = this.diagram._resizingAdorner;
	                adorner.angle(adorner.angle() + angle);
	                adorner.rotate();
	            },

	            selectedElements: function() {
	                return this.diagram.select();
	            },

	            createShape: function() {
	                this.diagram.createShape();
	            },

	            createConnection: function() {
	                this.diagram.createConnection();
	            },

	            undo: function() {
	                this.diagram.undo();
	            },

	            redo: function() {
	                this.diagram.redo();
	            },

	            destroy: function() {
	                this.diagram = null;
	                this.element = null;
	                this.options = null;

	                if (this._toolBar) {
	                    this._toolBar.destroy();
	                }

	                if (this._popup) {
	                    this._popup.destroy();
	                }
	            }
	        });

	        var Editor = kendo.Observable.extend({
	            init: function(element, options) {
	                kendo.Observable.fn.init.call(this);

	                this.options = extend(true, {}, this.options, options);
	                this.element = element;
	                this.model = this.options.model;
	                this.fields = this._getFields();
	                this._initContainer();
	                this.createEditable();
	            },

	            options: {
	                editors: {}
	            },

	            _initContainer: function() {
	                this.wrapper = this.element;
	            },

	            createEditable: function() {
	                var options = this.options;

	                this.editable = new kendo.ui.Editable(this.wrapper, {
	                    fields: this.fields,
	                    target: options.target,
	                    clearContainer: false,
	                    model: this.model
	                });
	            },

	            _isEditable: function(field) {
	                return this.model.editable && this.model.editable(field);
	            },

	            _getFields: function() {
	                var fields = [];
	                var modelFields = this.model.fields;

	                for (var field in modelFields) {
	                    var result = {};
	                    if (this._isEditable(field)) {
	                        var editor = this.options.editors[field];
	                        if (editor) {
	                            result.editor = editor;
	                        }
	                        result.field = field;
	                        fields.push(result);
	                    }
	                }

	                return fields;
	            },

	            end: function() {
	                return this.editable.end();
	            },

	            destroy: function() {
	                this.editable.destroy();
	                this.editable.element.find("[" + kendo.attr("container-for") + "]").empty();
	                this.model = this.wrapper = this.element = this.columns = this.editable = null;
	            }
	        });

	        var PopupEditor = Editor.extend({
	            init: function(element, options) {
	                Editor.fn.init.call(this, element, options);
	                this.bind(this.events, this.options);

	                this.open();
	            },

	            events: [ "update", "cancel" ],

	            options: {
	                window: {
	                    modal: true,
	                    resizable: false,
	                    draggable: true,
	                    title: "Edit",
	                    visible: false
	                }
	            },

	            _initContainer: function() {
	                var that = this;
	                this.wrapper = $('<div class="k-popup-edit-form"/>')
	                    .attr(kendo.attr("uid"), this.model.uid);

	                var formContent = "";

	                if (this.options.template) {
	                    formContent += this._renderTemplate();
	                    this.fields = [];
	                } else {
	                    formContent += this._renderFields();
	                }

	                formContent += this._renderButtons();

	                this.wrapper.append(
	                    $('<div class="k-edit-form-container"/>').append(formContent));

	                this.window = new kendo.ui.Window(this.wrapper.appendTo(this.element), this.options.window);
	                this.window.bind("close", function(e) {
	                    //The bellow line is required due to: draggable window in IE, change event will be triggered while the window is closing
	                    if (e.userTriggered) {
	                        e.sender.element.focus();
	                        that._cancelClick(e);
	                    }
	                });

	                this._attachButtonEvents();
	            },

	            _renderTemplate: function() {
	                var template = this.options.template;

	                if (typeof template === "string") {
	                    template = kendo.unescape(template);
	                }

	                template = kendo.template(template)(this.model);

	                return template;
	            },

	            _renderFields: function() {
	                var form = "";
	                for (var i = 0; i < this.fields.length; i++) {
	                    var field = this.fields[i];

	                    form += '<div class="k-edit-label"><label for="' + field.field + '">' + (field.field || "") + '</label></div>';

	                    if (this._isEditable(field.field)) {
	                        form += '<div ' + kendo.attr("container-for") + '="' + field.field +
	                        '" class="k-edit-field"></div>';
	                    }
	                }

	                return form;
	            },

	            _renderButtons: function() {
	                var form = '<div class="k-edit-buttons k-state-default">';
	                form += this._createButton("update");
	                form += this._createButton("cancel");
	                form += '</div>';
	                return form;
	            },

	            _createButton: function(name) {
	                return kendo.template(BUTTON_TEMPLATE)(defaultButtons[name]);
	            },

	            _attachButtonEvents: function() {
	                this._cancelClickHandler = proxy(this._cancelClick, this);
	                this.window.element.on(CLICK + NS, "a.k-diagram-cancel", this._cancelClickHandler);

	                this._updateClickHandler = proxy(this._updateClick, this);
	                this.window.element.on(CLICK + NS, "a.k-diagram-update", this._updateClickHandler);
	            },

	            _updateClick: function(e) {
	                e.preventDefault();
	                this.trigger("update");
	            },

	            _cancelClick: function (e) {
	                e.preventDefault();
	                this.trigger("cancel");
	            },

	            open: function() {
	                this.window.center().open();
	            },

	            close: function() {
	                this.window.bind("deactivate", proxy(this.destroy, this)).close();
	            },

	            destroy: function() {
	                this.window.close().destroy();
	                this.window.element.off(CLICK + NS, "a.k-diagram-cancel", this._cancelClickHandler);
	                this.window.element.off(CLICK + NS, "a.k-diagram-update", this._updateClickHandler);
	                this._cancelClickHandler = null;
	                this._editUpdateClickHandler = null;
	                this.window = null;
	                Editor.fn.destroy.call(this);
	            }
	        });

	        function connectionSelector(container, options) {
	            var model = this.dataSource.reader.model;
	            if (model) {
	                var textField = model.fn.fields.text ? "text": model.idField;
	                $("<input name='" + options.field + "' />")
	                    .appendTo(container).kendoDropDownList({
	                        dataValueField: model.idField,
	                        dataTextField: textField,
	                        dataSource: this.dataSource.data().toJSON(),
	                        optionLabel: " ",
	                        valuePrimitive: true
	                    });
	            }
	        }

	        function InactiveItem(dataItem) {
	            this.dataItem = dataItem;
	            this.callbacks = [];
	        }

	        InactiveItem.fn = InactiveItem.prototype = {
	            onActivate: function(callback) {
	                var deffered = $.Deferred();
	                this.callbacks.push({
	                    callback: callback,
	                    deferred: deffered
	                });
	                return deffered;
	            },

	            activate: function() {
	                var callbacks = this.callbacks;
	                var item;
	                for (var idx = 0; idx < callbacks.length; idx++) {
	                    item = this.callbacks[idx];
	                    item.callback(this.dataItem);
	                    item.deferred.resolve();
	                }
	                this.callbacks = [];
	            }
	        };

	        function InactiveItemsCollection() {
	            this.items = {};
	        }

	        InactiveItemsCollection.fn = InactiveItemsCollection.prototype = {
	            add: function(items) {
	                for(var idx = 0; idx < items.length; idx++) {
	                    this.items[items[idx].uid] = new InactiveItem(items[idx]);
	                }
	            },

	            forEach: function(callback){
	                for (var uid in this.items) {
	                    callback(this.items[uid]);
	                }
	            },

	            getByUid: function(uid) {
	                return this.items[uid];
	            },

	            remove: function(item) {
	                delete this.items[item.uid];
	            }
	        };

	        var QuadRoot = Class.extend({
	            init: function() {
	                this.shapes = [];
	            },

	            _add: function(shape, bounds) {
	                this.shapes.push({
	                    bounds: bounds,
	                    shape: shape
	                });
	                shape._quadNode = this;
	            },

	            insert: function(shape, bounds) {
	                this._add(shape, bounds);
	            },

	            remove: function(shape) {
	                var shapes = this.shapes;
	                var length = shapes.length;

	                for (var idx = 0; idx < length; idx++) {
	                    if (shapes[idx].shape === shape) {
	                        shapes.splice(idx, 1);
	                        break;
	                    }
	                }
	            },

	            hitTestRect: function(rect, exclude) {
	                var shapes = this.shapes;
	                var length = shapes.length;

	                for (var i = 0; i < length; i++) {
	                    if (this._testRect(shapes[i].shape, rect) && !dataviz.inArray(shapes[i].shape, exclude)) {
	                        return true;
	                    }
	                }
	            },

	            _testRect: function(shape, rect) {
	                var angle = shape.rotate().angle;
	                var bounds = shape.bounds();
	                var hit;
	                if (!angle) {
	                    hit = bounds.overlaps(rect);
	                } else {
	                    hit = Intersect.rects(rect, bounds, -angle);
	                }
	                return hit;
	            }
	        });

	        var QuadNode = QuadRoot.extend({
	            init: function(rect) {
	                QuadRoot.fn.init.call(this);
	                this.children = [];
	                this.rect = rect;
	            },

	            inBounds: function(rect) {
	                var nodeRect = this.rect;
	                var nodeBottomRight = nodeRect.bottomRight();
	                var bottomRight = rect.bottomRight();
	                var inBounds = nodeRect.x <= rect.x && nodeRect.y <= rect.y && bottomRight.x <= nodeBottomRight.x &&
	                    bottomRight.y <= nodeBottomRight.y;
	                return inBounds;
	            },

	            overlapsBounds: function(rect) {
	                return this.rect.overlaps(rect);
	            },

	            insert: function (shape, bounds) {
	                var inserted = false;
	                var children = this.children;
	                var length = children.length;
	                if (this.inBounds(bounds)) {
	                    if (!length && this.shapes.length < 4) {
	                        this._add(shape, bounds);
	                    } else {
	                        if (!length) {
	                            this._initChildren();
	                        }

	                        for (var idx = 0; idx < children.length; idx++) {
	                            if (children[idx].insert(shape, bounds)) {
	                                inserted = true;
	                                break;
	                            }
	                        }

	                        if (!inserted) {
	                            this._add(shape, bounds);
	                        }
	                    }
	                    inserted = true;
	                }

	                return inserted;
	            },

	            _initChildren: function() {
	                var rect = this.rect,
	                    children = this.children,
	                    shapes = this.shapes,
	                    center = rect.center(),
	                    halfWidth = rect.width / 2,
	                    halfHeight = rect.height / 2,
	                    childIdx, shapeIdx;

	                children.push(
	                    new QuadNode(new Rect(rect.x, rect.y, halfWidth, halfHeight)),
	                    new QuadNode(new Rect(center.x, rect.y, halfWidth, halfHeight)),
	                    new QuadNode(new Rect(rect.x, center.y, halfWidth, halfHeight)),
	                    new QuadNode(new Rect(center.x, center.y, halfWidth, halfHeight))
	                );
	                for (shapeIdx = shapes.length - 1; shapeIdx >= 0; shapeIdx--) {
	                    for (childIdx = 0; childIdx < children.length; childIdx++) {
	                        if (children[childIdx].insert(shapes[shapeIdx].shape, shapes[shapeIdx].bounds)) {
	                            shapes.splice(shapeIdx, 1);
	                            break;
	                        }
	                    }
	                }
	            },

	            hitTestRect: function(rect, exclude) {
	                var idx;
	                var children = this.children;
	                var length = children.length;
	                var hit = false;

	                if (this.overlapsBounds(rect)) {
	                    if (QuadRoot.fn.hitTestRect.call(this, rect, exclude)) {
	                        hit = true;
	                    } else {
	                         for (idx = 0; idx < length; idx++) {
	                            if (children[idx].hitTestRect(rect, exclude)) {
	                               hit = true;
	                               break;
	                            }
	                        }
	                    }
	                }

	                return hit;
	            }
	        });

	        var ShapesQuadTree = Class.extend({
	            ROOT_SIZE: 1000,

	            init: function(diagram) {
	                var boundsChangeHandler = proxy(this._boundsChange, this);
	                diagram.bind(ITEMBOUNDSCHANGE, boundsChangeHandler);
	                diagram.bind(ITEMROTATE, boundsChangeHandler);
	                this.initRoots();
	            },

	            initRoots: function() {
	                this.rootMap = {};
	                this.root = new QuadRoot();
	            },

	            clear: function() {
	                this.initRoots();
	            },

	            _boundsChange: function(e) {
	                if (e.item._quadNode) {
	                    e.item._quadNode.remove(e.item);
	                }
	                this.insert(e.item);
	            },

	            insert: function(shape) {
	                var bounds = shape.bounds(ROTATED);
	                var rootSize = this.ROOT_SIZE;
	                var sectors = this.getSectors(bounds);
	                var x = sectors[0][0];
	                var y = sectors[1][0];

	                if (this.inRoot(sectors)) {
	                    this.root.insert(shape, bounds);
	                } else {
	                    if (!this.rootMap[x]) {
	                        this.rootMap[x] = {};
	                    }

	                    if (!this.rootMap[x][y]) {
	                        this.rootMap[x][y] = new QuadNode(
	                            new Rect(x * rootSize, y * rootSize, rootSize, rootSize)
	                        );
	                    }

	                    this.rootMap[x][y].insert(shape, bounds);
	                }
	            },

	            remove: function(shape) {
	                if (shape._quadNode) {
	                    shape._quadNode.remove(shape);
	                }
	            },

	            inRoot: function(sectors) {
	                return sectors[0].length > 1 || sectors[1].length > 1;
	            },

	            getSectors: function(rect) {
	                var rootSize = this.ROOT_SIZE;
	                var bottomRight = rect.bottomRight();
	                var bottomX = math.floor(bottomRight.x / rootSize);
	                var bottomY = math.floor(bottomRight.y / rootSize);
	                var sectors = [[],[]];
	                for (var x = math.floor(rect.x / rootSize); x <= bottomX; x++) {
	                    sectors[0].push(x);
	                }
	                for (var y = math.floor(rect.y / rootSize); y <= bottomY; y++) {
	                    sectors[1].push(y);
	                }
	                return sectors;
	            },

	            hitTestRect: function(rect, exclude) {
	                var sectors = this.getSectors(rect);
	                var xIdx, yIdx, x, y;
	                var root;

	                if (this.root.hitTestRect(rect, exclude)) {
	                    return true;
	                }

	                for (xIdx = 0; xIdx < sectors[0].length; xIdx++) {
	                    x = sectors[0][xIdx];
	                    for (yIdx = 0; yIdx < sectors[1].length; yIdx++) {
	                        y = sectors[1][yIdx];
	                        root = (this.rootMap[x] || {})[y];
	                        if (root && root.hitTestRect(rect, exclude)) {
	                            return true;
	                        }
	                    }
	                }

	                return false;
	            }
	        });

	        function cloneDataItem(dataItem) {
	            var result = dataItem;
	            if (dataItem instanceof kendo.data.Model) {
	                result = dataItem.toJSON();
	                result[dataItem.idField] = dataItem._defaultId;
	            }
	            return result;
	        }

	        function splitDiagramElements(elements) {
	            var connections = [];
	            var shapes = [];
	            var element, idx;
	            for (idx = 0; idx < elements.length; idx++) {
	                element = elements[idx];
	                if (element instanceof Shape) {
	                    shapes.push(element);
	                } else {
	                    connections.push(element);
	                }
	            }
	            return {
	                shapes: shapes,
	                connections: connections
	            };
	        }

	        function createModel(dataSource, model) {
	            if (dataSource.reader.model) {
	                return new dataSource.reader.model(model);
	            }

	            return new kendo.data.ObservableObject(model);
	        }

	        function clearField(field, model) {
	            if (defined(model[field])) {
	                model.set(field, null);
	            }
	        }

	        function copyDefaultOptions(mainOptions, elementOptions, fields) {
	            var field;
	            for (var idx = 0; idx < fields.length; idx++) {
	                field = fields[idx];
	                if (elementOptions && !defined(elementOptions[field])) {
	                    elementOptions[field] = mainOptions[field];
	                }
	            }
	        }

	        function translateToOrigin(visual) {
	            var bbox = visual.drawingContainer().clippedBBox(null);
	            if (bbox.origin.x !== 0 || bbox.origin.y !== 0) {
	                visual.position(-bbox.origin.x, -bbox.origin.y);
	            }
	        }

	        function preventDefault(e) {
	            e.preventDefault();
	        }

	        dataviz.ui.plugin(Diagram);

	        deepExtend(diagram, {
	            Shape: Shape,
	            Connection: Connection,
	            Connector: Connector,
	            DiagramToolBar: DiagramToolBar,
	            QuadNode: QuadNode,
	            QuadRoot: QuadRoot,
	            ShapesQuadTree: ShapesQuadTree,
	            PopupEditor: PopupEditor
	        });
	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 893:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CRfZ");

/***/ }),

/***/ 894:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 895:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nce5");

/***/ }),

/***/ 896:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("9fcU");

/***/ }),

/***/ 897:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1Z35");

/***/ }),

/***/ 898:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("UZBu");

/***/ }),

/***/ 899:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("O5Ud");

/***/ }),

/***/ 900:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("QBqZ");

/***/ })

/******/ });

/***/ }),

/***/ "7qx9":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1285);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1078:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("qo2y");

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1285:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* jshint eqnull: true */
	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1109), __webpack_require__(1059), __webpack_require__(1078) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "listbox",
	    name: "ListBox",
	    category: "web",
	    depends: ["draganddrop", "data", "selectable"]
	};

	(function($, undefined) {
	    var kendo = window.kendo;
	    var kendoAttr = kendo.attr;
	    var data = kendo.data;
	    var keys = kendo.keys;
	    var kendoTemplate = kendo.template;
	    var Widget = kendo.ui.Widget;
	    var DataSource = data.DataSource;
	    var Selectable = kendo.ui.Selectable;
	    var DataBoundWidget = kendo.ui.DataBoundWidget;
	    var Class = kendo.Class;

	    var extend = $.extend;
	    var noop = $.noop;
	    var proxy = $.proxy;

	    var DASH = "-";
	    var DOT = ".";
	    var SPACE = " ";
	    var HASH = "#";

	    var KENDO_LISTBOX = "kendoListBox";
	    var NS = DOT + KENDO_LISTBOX;
	    var DISABLED_STATE_CLASS = "k-state-disabled";
	    var SELECTED_STATE_CLASS = "k-state-selected";
	    var ENABLED_ITEM_SELECTOR = ".k-item:not(.k-state-disabled)";
	    var ENABLED_ITEMS_SELECTOR = ".k-list:not(.k-state-disabled) >" + ENABLED_ITEM_SELECTOR;
	    var TOOLBAR_CLASS = "k-listbox-toolbar";
	    var TOOL_SELECTOR = "li > a.k-button:not(.k-state-disabled)";
	    var FOCUSED_CLASS = "k-state-focused";
	    var DRAG_CLUE_CLASS = "k-drag-clue";
	    var DROP_HINT_CLASS = "k-drop-hint";
	    var LIST_CLASS = "k-reset k-list";
	    var LIST_SELECTOR = ".k-reset.k-list";
	    var RESET = "k-reset";

	    var CLICK = "click" + NS;
	    var KEYDOWN = "keydown" + NS;
	    var BLUR = "blur" + NS;
	    var outerWidth = kendo._outerWidth;
	    var outerHeight = kendo._outerHeight;
	    var CHANGE = "change";
	    var DATABOUND = "dataBound";
	    var ADD = "add";
	    var REMOVE = "remove";
	    var REORDER = "reorder";
	    var MOVE_UP = "moveUp";
	    var MOVE_DOWN = "moveDown";
	    var TRANSFER_TO = "transferTo";
	    var TRANSFER_FROM = "transferFrom";
	    var TRANSFER_ALL_TO = "transferAllTo";
	    var TRANSFER_ALL_FROM = "transferAllFrom";
	    var DRAGGEDCLASS = "k-ghost";
	    var UNIQUE_ID = "uid";
	    var TABINDEX = "tabindex";
	    var COMMAND = "command";

	    var MOVE_UP_OFFSET = -1;
	    var MOVE_DOWN_OFFSET = 1;
	    var DRAGSTART = "dragstart";
	    var DRAG = "drag";
	    var DROP = "drop";
	    var DRAGEND = "dragend";
	    var DEFAULT_FILTER = "ul.k-reset.k-list>li.k-item";

	    var RIGHT = "right";
	    var BOTTOM = "bottom";

	    var TOOLBAR_POSITION_CLASS_NAMES = [
	        TOOLBAR_CLASS + DASH + "left",
	        TOOLBAR_CLASS + DASH + RIGHT,
	        TOOLBAR_CLASS + DASH + "top",
	        TOOLBAR_CLASS + DASH + BOTTOM
	    ];

	    function getSortedDomIndices(items) {
	        var indices = $.map(items, function(item) {
	            return $(item).index();
	        });

	        return indices;
	    }

	    function isUndefined(value) {
	        return (typeof value === "undefined");
	    }

	    function defaultHint(element) {
	        return element.clone()
	            .removeClass(DRAGGEDCLASS)
	            .removeClass(FOCUSED_CLASS)
	            .addClass(kendo.format("{0} {1} {2}", SELECTED_STATE_CLASS, RESET, DRAG_CLUE_CLASS))
	            .width(element.width());
	    }

	    function defaultPlaceholder() {
	        return $('<li>').addClass(DROP_HINT_CLASS);
	    }

	    var ListBox = DataBoundWidget.extend({
	        init: function(element, options) {
	            var that = this;
	            Widget.fn.init.call(that, element, options);

	            that._wrapper();
	            that._list();
	            element = that.element.attr("multiple", "multiple").hide();

	            if (element[0] && !that.options.dataSource) {
	                that.options.dataTextField = that.options.dataTextField || "text";
	                that.options.dataValueField = that.options.dataValueField || "value";
	            }
	            that._templates();
	            that._selectable();
	            that._dataSource();
	            that._createToolbar();
	            that._createDraggable();
	            that._createNavigatable();
	        },

	        destroy: function() {
	            var that = this;

	            DataBoundWidget.fn.destroy.call(that);
	            if(!isNaN(that._listTabIndex)) {
	                that._getList().off();
	                that._listTabIndex = null;
	            }
	            that._unbindDataSource();
	            that._destroySelectable();
	            that._destroyToolbar();
	            that.wrapper.off(NS);
	            if(that._target){
	                that._target = null;
	            }
	            if(that._draggable) {
	                that._draggable.destroy();
	                that.placeholder = null;
	            }

	            kendo.destroy(that.element);
	        },

	        setOptions: function(options) {
	            Widget.fn.setOptions.call(this, options);
	            this._templates();
	            this._dataSource();
	        },

	        events: [
	            CHANGE,
	            DATABOUND,
	            ADD,
	            REMOVE,
	            REORDER,
	            DRAGSTART,
	            DRAG,
	            DROP,
	            DRAGEND
	        ],

	        options: {
	            name: "ListBox",
	            autoBind: true,
	            template: "",
	            dataTextField: "",
	            dataValueField: "",
	            selectable: "single",
	            draggable: null,
	            dropSources: [],
	            connectWith: "",
	            navigatable: true,
	            toolbar: {
	                position: RIGHT,
	                tools: []
	            },
	            messages: {
	                tools: {
	                    remove: "Delete",
	                    moveUp: "Move Up",
	                    moveDown: "Move Down",
	                    transferTo: "Transfer To",
	                    transferFrom: "Transfer From",
	                    transferAllTo: "Transfer All To",
	                    transferAllFrom: "Transfer All From"
	                }
	            }
	        },

	        add: function(dataItems) {
	            var that = this;
	            var items = dataItems && dataItems.length ? dataItems : [dataItems];
	            var itemsLength = items.length;
	            var list = that._getList();
	            var i;

	            that._unbindDataSource();
	            that._unbindDataChange();
	            for (i = 0; i < itemsLength; i++) {
	                that._addItem(items[i], list);
	            }
	            that._bindDataChange();
	            that._bindDataSource();
	            that._syncElement();
	        },

	        _addItem: function (dataItem, list) {
	            var that = this;
	            var item = that.templates.itemTemplate({ item: dataItem, r: that.templates.itemContent });

	            $(item).attr(kendoAttr(UNIQUE_ID), dataItem.uid).appendTo(list);

	            if (typeof dataItem === typeof "") {
	                that.dataSource._data.push(dataItem);
	            } else {
	                that.dataSource.add(dataItem);
	            }
	        },

	        _addItemAt: function(dataItem, index) {
	            var that = this;
	            var item = that.templates.itemTemplate({ item: dataItem, r: that.templates.itemContent });
	            that._unbindDataSource();
	            if (typeof dataItem === typeof "") {
	                that._insertElementAt(item, index);
	                that.dataSource._data.push(dataItem);
	            } else {
	                that._insertElementAt($(item).attr(kendoAttr(UNIQUE_ID), dataItem.uid), index);
	                that.dataSource.add(dataItem);
	            }
	            that._bindDataSource();
	            that._syncElement();
	        },

	        _insertElementAt: function(item, index) {
	            var that = this;
	            var list = that._getList();

	            if (index > 0) {
	                $(item).insertAfter(list.children().eq(index - 1));
	            } else {
	                $(list).prepend(item);
	            }
	        },

	        _createNavigatable: function() {
	            var that = this;
	            var options = that.options;

	            if(options.navigatable) {
	                that._getList().on(CLICK, ENABLED_ITEM_SELECTOR, proxy(that._click, that))
	                            .on(KEYDOWN, proxy(that._keyDown, that))
	                            .on(BLUR, proxy(that._blur, that));
	            }
	        },

	        _getTabIndex: function() {
	            var that = this;
	            var tabindex;

	            if(!isNaN(that._listTabIndex))
	            {
	                return that._listTabIndex;
	            }

	            tabindex = that.element.attr(TABINDEX);
	            that._listTabIndex = !isNaN(tabindex) ? tabindex : 0;

	            that.element.removeAttr(TABINDEX);

	            return that._listTabIndex;
	        },

	        _blur: function() {
	            if(this._target) {
	                this._target.removeClass(FOCUSED_CLASS);
	                this._getList().removeAttr("aria-activedescendant");
	            }
	            this._target = null;
	        },

	        _click: function(e) {
	            var that = this;
	            var target = $(e.currentTarget);
	            var oldTarget = that._target;
	            var isInput = isInputElement(e.target);

	            if (oldTarget) {
	                oldTarget.removeClass(FOCUSED_CLASS);
	            }

	            that._target = target;
	            target.addClass(FOCUSED_CLASS);
	            that._getList().attr("aria-activedescendant", target.attr("id"));

	            if (that._getList()[0] !== kendo._activeElement() && !isInput) {
	                that.focus();
	            }
	        },

	        _getNavigatableItem: function(key) {
	            var that = this;
	            var current;

	            if (!that._target) {
	                current = that.items().filter(ENABLED_ITEM_SELECTOR).first();
	            }  else {
	                current = that._target;
	            }

	            if (key === keys.UP && that._target) {
	                current = that._target.prevAll(ENABLED_ITEM_SELECTOR).first();
	            }

	            if (key === keys.DOWN && that._target) {
	                current = that._target.nextAll(ENABLED_ITEM_SELECTOR).first();
	            }

	            return current.length ? current : null;
	        },

	        _scrollIntoView: function(item) {
	            if (!item) {
	                return;
	            }

	            if (item[0]) {
	                item = item[0];
	            }

	            var list = this._getList().parent()[0];
	            var itemOffsetTop = item.offsetTop;
	            var contentScrollTop = list.scrollTop;
	            var contentOffsetHeight = list.clientHeight;
	            var bottomDistance = itemOffsetTop + item.offsetHeight;

	            if (contentScrollTop > itemOffsetTop) {
	                contentScrollTop = itemOffsetTop;
	            } else if (bottomDistance > (contentScrollTop + contentOffsetHeight)) {
	                contentScrollTop = (bottomDistance - contentOffsetHeight);
	            }

	            list.scrollTop = contentScrollTop;
	        },

	        _keyDown: function(e) {
	            var that = this;
	            var key = e.keyCode;
	            var current = that._getNavigatableItem(key);
	            var shouldPreventDefault;

	            if(that._target) {
	                that._target.removeClass(FOCUSED_CLASS);
	            }

	            if(!(e.shiftKey && !e.ctrlKey && (key === keys.DOWN || key === keys.UP))) {
	                that._shiftSelecting = false;
	            }

	            if(key == keys.DELETE) {
	                that._executeCommand(REMOVE);
	                if(that._target) {
	                    that._target.removeClass(FOCUSED_CLASS);
	                    that._getList().removeAttr("aria-activedescendant");
	                    that._target = null;
	                }
	                shouldPreventDefault = true;
	            } else if(key === keys.DOWN || key === keys.UP) {
	                if(!current) {
	                    e.preventDefault();
	                    return;
	                }
	                if (e.shiftKey && !e.ctrlKey) {
	                    if (!that._shiftSelecting) {
	                        that.clearSelection();
	                        that._shiftSelecting = true;
	                    }
	                    if (that._target && current.hasClass("k-state-selected")) {
	                        that._target.removeClass(SELECTED_STATE_CLASS);
	                        that.trigger(CHANGE);
	                    } else if(that.options.selectable == "single") {
	                       that.select(current);
	                    } else {
	                       that.select(current.add(that._target));
	                    }
	                } else if (e.shiftKey && e.ctrlKey) {
	                    that._executeCommand(key === keys.DOWN ? MOVE_DOWN : MOVE_UP);
	                    that._scrollIntoView(that._target);
	                    e.preventDefault();
	                    return;
	                } else if (!e.shiftKey && !e.ctrlKey) {
	                    if(that.options.selectable === "multiple"){
	                        that.clearSelection();
	                    }
	                    that.select(current);
	                }

	                that._target = current;
	                if(that._target) {
	                    that._target.addClass(FOCUSED_CLASS);
	                    that._scrollIntoView(that._target);
	                    that._getList().attr("aria-activedescendant", that._target.attr("id"));
	                } else {
	                    that._getList().removeAttr("aria-activedescendant");
	                }
	                shouldPreventDefault = true;
	            } else if(key == keys.SPACEBAR) {
	                if(e.ctrlKey && that._target) {
	                   if(that._target.hasClass(SELECTED_STATE_CLASS)) {
	                       that._target.removeClass(SELECTED_STATE_CLASS);
	                       that.trigger(CHANGE);
	                   } else {
	                       that.select(that._target);
	                   }
	                } else {
	                   that.clearSelection();
	                   that.select(that._target);
	                }
	                shouldPreventDefault = true;
	            } else if(e.ctrlKey && key == keys.RIGHT) {
	                if(e.shiftKey) {
	                   that._executeCommand(TRANSFER_ALL_TO);
	                } else {
	                   that._executeCommand(TRANSFER_TO);
	                }
	                that._target = that.select().length ? that.select(): null;
	                shouldPreventDefault = true;
	            } else if(e.ctrlKey && key == keys.LEFT) {
	                if(e.shiftKey) {
	                   that._executeCommand(TRANSFER_ALL_FROM);
	                } else {
	                   that._executeCommand(TRANSFER_FROM);
	                }
	                shouldPreventDefault = true;
	            }

	            if(shouldPreventDefault) {
	                e.preventDefault();
	            }
	        },

	        focus: function() {
	            kendo.focusElement(this._getList());
	        },

	        _createDraggable: function() {
	            var that = this;
	            var draggable = that.options.draggable;
	            var hint;

	            if(draggable) {
	                hint = draggable.hint;
	                if(!that.options.selectable) {
	                    throw new Error("Dragging requires selection to be enabled");
	                }

	                if(!hint) {
	                    hint = defaultHint;
	                }

	                that._draggable = new kendo.ui.Draggable(that.wrapper, {
	                    filter: draggable.filter ? draggable.filter : DEFAULT_FILTER,
	                    hint: kendo.isFunction(hint) ? hint : $(hint),
	                    dragstart: proxy(that._dragstart, that),
	                    dragcancel: proxy(that._clear, that),
	                    drag: proxy(that._drag, that),
	                    dragend: proxy(that._dragend, that)
	                });
	            }
	        },

	        _dragstart: function(e) {
	            var that = this;
	            var draggedElement = that.draggedElement = e.currentTarget;
	            var placeholder = that.options.draggable.placeholder;
	            var dataItem = that.dataItem(draggedElement);
	            var eventData = { dataItems: dataItem, items: $(draggedElement), draggableEvent: e };

	            if(that.options.draggable.enabled === false) {
	                e.preventDefault();
	                return;
	            }

	            if(!placeholder) {
	                placeholder = defaultPlaceholder;
	            }

	            that.placeholder = kendo.isFunction(placeholder) ? $(placeholder.call(that, draggedElement)) : $(placeholder);

	            if(draggedElement.is(DOT + DISABLED_STATE_CLASS)) {
	                e.preventDefault();
	            } else {
	                if(that.trigger(DRAGSTART, eventData)) {
	                    e.preventDefault();
	                } else {
	                    that.clearSelection();
	                    that.select(draggedElement);
	                    draggedElement.addClass(DRAGGEDCLASS);
	                }
	            }
	        },

	        _clear: function() {
	            this.draggedElement.removeClass(DRAGGEDCLASS);
	            this.placeholder.remove();
	        },

	        _findElementUnderCursor: function(e) {
	            var elementUnderCursor = kendo.elementUnderCursor(e);
	            var draggable = e.sender;

	            if($.contains(draggable.hint[0], elementUnderCursor) || draggable.hint[0] === elementUnderCursor) {
	                draggable.hint.hide();
	                elementUnderCursor = kendo.elementUnderCursor(e);
	                draggable.hint.show();
	            }

	            return elementUnderCursor;
	        },

	        _findTarget: function(e) {
	            var that = this;
	            var element = that._findElementUnderCursor(e);
	            var elementNode = $(element);
	            var list = that._getList();
	            var items;
	            var node;

	            if($.contains(list[0], element)) {
	                items = that.items();
	                element = elementNode.is("li") ? element: elementNode.closest("li")[0];
	                node = items.filter(element)[0] || items.has(element)[0];
	                if(node) {
	                    node = $(node);
	                    return !node.hasClass(DISABLED_STATE_CLASS) ? { element: node, listBox: that } : null;
	                } else {
	                    return null;
	                }
	            } else if (list[0] == element || list.parent()[0] == element) {
	                return { element: $(list), appendToBottom: true, listBox: that };
	            } else {
	                return that._searchConnectedListBox(elementNode);
	            }
	        },

	        _getElementCenter: function(element) {
	            var center = element.length ? kendo.getOffset(element) : null;
	            if(center) {
	                center.top += outerHeight(element) / 2;
	                center.left += outerWidth(element) / 2;
	            }

	            return center;
	        },

	        _searchConnectedListBox: function(element) {
	            var connectedListBox;
	            var items;
	            var node;
	            var originalElement = element;
	            var closestContainer;

	            if(element.hasClass("k-list-scroller k-selectable")) {
	                closestContainer = element;
	            } else {
	                closestContainer = element.closest(".k-list-scroller.k-selectable");
	            }

	            if(closestContainer.length) {
	                connectedListBox = closestContainer.parent().find("[data-role='listbox']").getKendoListBox();
	            } else {
	                return null;
	            }

	            if(connectedListBox && $.inArray(this.element[0].id, connectedListBox.options.dropSources) !== -1) {
	                items = connectedListBox.items();
	                element = element.is("li") ? element[0] : element.closest("li")[0];
	                node = items.filter(element)[0] || items.has(element)[0];
	                if(node) {
	                    node = $(node);
	                    return !node.hasClass(DISABLED_STATE_CLASS) ? { element: node, listBox: connectedListBox } : null;
	                } else if(!items.length ||
	                            originalElement.hasClass("k-list-scroller k-selectable") ||
	                            originalElement.hasClass("k-reset k-list")) {
	                    return { element: connectedListBox._getList(), listBox: connectedListBox, appendToBottom: true };
	                } else {
	                    return null;
	                }
	            }
	            return null;
	        },

	        _drag: function(e) {
	            var that = this;
	            var draggedElement = that.draggedElement;
	            var target = that._findTarget(e);
	            var cursorOffset = { left: e.x.location, top: e.y.location };
	            var dataItem = that.dataItem(draggedElement);
	            var eventData = { dataItems: [dataItem], items: $(draggedElement), draggableEvent: e };
	            var targetCenter;
	            var offsetDelta;
	            var direction;

	            if(that.trigger(DRAG, eventData)) {
	                e.preventDefault();
	                return;
	            }

	            if(target) {
	                targetCenter = this._getElementCenter(target.element);

	                offsetDelta = {
	                    left: Math.round(cursorOffset.left - targetCenter.left),
	                    top: Math.round(cursorOffset.top - targetCenter.top)
	                };

	                if(target.appendToBottom) {
	                    that._movePlaceholder(target, null , draggedElement);
	                    return;
	                }

	                if(offsetDelta.top < 0) {
	                    direction = "prev";
	                } else if(offsetDelta.top > 0) {
	                    direction = "next";
	                }

	                if(direction) {
	                    if(target.element[0] != that.placeholder[0]) {
	                        that._movePlaceholder(target, direction, draggedElement);
	                    }
	                }
	             }
	             else if(that.placeholder.parent().length){
	                that.placeholder.remove();
	             }
	        },

	        _movePlaceholder: function(target, direction, draggedElement) {
	            var that = this;
	            var placeholder = that.placeholder;
	            var draggableOptions = target.listBox.options.draggable;

	            if(placeholder.parent().length) {
	                that.placeholder.remove();
	                if(draggableOptions && draggableOptions.placeholder){
	                    that.placeholder = kendo.isFunction(draggableOptions.placeholder) ? $(draggableOptions.placeholder.call(that, draggedElement)) : $(draggableOptions.placeholder);
	                } else {
	                    that.placeholder = $(defaultPlaceholder.call(that, draggedElement));
	                }
	            }

	            if (!direction) {
	                target.element.append(that.placeholder);
	            } else if (direction === "prev") {
	                target.element.before(that.placeholder);
	            } else if (direction === "next") {
	                target.element.after(that.placeholder);
	            }
	        },

	        _dragend: function(e) {
	            var that = this;
	            var draggedItem = that.draggedElement;
	            var items = that.items();
	            var placeholderIndex = items.not(that.draggedElement).index(that.placeholder);
	            var draggedIndex = items.not(that.placeholder).index(that.draggedElement);
	            var dataItem = that.dataItem(draggedItem);
	            var eventData = { dataItems: [dataItem], items: $(draggedItem) };
	            var connectedListBox = that.placeholder.closest(".k-widget.k-listbox").find("[data-role='listbox']").getKendoListBox();

	            if(that.trigger(DROP, extend({}, eventData, { draggableEvent: e }))) {
	                e.preventDefault();
	                this._clear();
	                return;
	            }

	            if(placeholderIndex >= 0) {
	                if(placeholderIndex !== draggedIndex && !that.trigger(REORDER, extend({}, eventData, { offset: placeholderIndex - draggedIndex }))) {
	                    draggedItem.removeClass(DRAGGEDCLASS);
	                    that.reorder(draggedItem, placeholderIndex);
	                }
	            } else if(connectedListBox) {
	                if(!that.trigger(REMOVE, eventData)) {
	                    that.remove($(draggedItem));
	                }

	                if(!connectedListBox.trigger(ADD, eventData)) {
	                    connectedListBox._addItemAt(dataItem, connectedListBox.items().index(that.placeholder));
	                }
	            }

	            that._clear();
	            that._draggable.dropped = true;

	            that.trigger(DRAGEND, extend({}, eventData, { draggableEvent: e }));

	            that._updateToolbar();
	            that._updateAllToolbars();
	        },

	        reorder: function(item, index) {
	            var that = this;
	            var dataSource = that.dataSource;
	            var dataItem = that.dataItem(item);
	            var dataItemAtIndex = dataSource.at(index);
	            var itemAtIndex = that.items()[index];
	            var listItem = $(item);

	            if (dataItem && itemAtIndex && dataItemAtIndex) {
	                that._removeElement(listItem);
	                that._insertElementAt(listItem, index);
	                that._updateToolbar();
	            }
	        },

	        remove: function (items) {
	            var that = this;
	            var listItems = that._getItems(items);
	            var itemsLength = listItems.length;
	            var i;

	            that._unbindDataSource();
	            that._unbindDataChange();
	            for (i = 0; i < itemsLength; i++) {
	                that._removeItem($(listItems[i]));
	            }
	            that._bindDataChange();
	            that._bindDataSource();
	            that._syncElement();
	            that._updateToolbar();
	            that._updateAllToolbars();
	        },

	        _removeItem: function (item) {
	            var that = this;
	            var dataSource = that.dataSource;
	            var dataItem = that.dataItem(item);
	            var transport = dataSource.transport;

	            if (!dataItem || !dataSource) {
	                return;
	            }
	            if (typeof dataItem === typeof "") {
	                var data = dataSource._data;
	                for (var i = 0; i < data.length; i++) {
	                    if (dataItem === data[i]) {
	                        data[i] = data[data.length - 1];
	                        data.pop();
	                        break;
	                    }
	                }
	            } else {
	                dataSource.remove(dataItem);
	                if (transport && (transport.destroy || (transport.options || {}).destroy) &&
	                    (!dataItem.isNew || !dataItem.isNew())) {
	                    dataSource._destroyed.push(dataItem);
	                }
	            }
	            that._removeElement(item);
	        },

	        _removeElement: function(item) {
	            kendo.destroy(item);
	            $(item).off().remove();
	        },

	        dataItem: function (element) {
	            var uniqueIdAttr = kendoAttr(UNIQUE_ID);
	            var uid = $(element).attr(uniqueIdAttr) || $(element).closest("[" + uniqueIdAttr + "]").attr(uniqueIdAttr);
	            if (uid) {
	                return this.dataSource.getByUid(uid);
	            }
	            else {
	                return $(element).html();
	            }
	        },

	        _dataItems: function (items) {
	            var dataItems = [];
	            var listItems = $(items);
	            var itemsLength = listItems.length;
	            var i;

	            for (i = 0; i < itemsLength; i++) {
	                dataItems.push(this.dataItem(listItems.eq(i)));
	            }

	            return dataItems;
	        },

	        items: function() {
	            var list = this._getList();
	            return list.children();
	        },

	        select: function(items) {
	            var that = this;
	            var selectable = that.selectable;
	            var enabledItems;

	            if (isUndefined(items)) {
	                return selectable.value();
	            }

	            enabledItems = that.items().filter(items).filter(ENABLED_ITEMS_SELECTOR);

	            if (!selectable.options.multiple) {
	                selectable.clear();
	                enabledItems = enabledItems.first();
	            }

	            return selectable.value(enabledItems);
	        },

	        clearSelection: function() {
	            var that = this;
	            var selectable = that.selectable;

	            if (selectable) {
	                selectable.clear();
	            }
	        },

	        enable: function(items, enable) {
	            var that = this;
	            var enabled = isUndefined(enable) ? true : !!enable;
	            var listItems = that._getItems(items);
	            var itemsLength = listItems.length;
	            var i;

	            for (i = 0; i < itemsLength; i++) {
	                that._enableItem($(listItems[i]), enabled);
	            }

	            that._updateAllToolbars();
	        },

	        _enableItem: function(item, enable) {
	            var that = this;
	            var dataItem = that.dataItem(item);

	            if (dataItem) {
	                if (enable) {
	                    $(item).removeClass(DISABLED_STATE_CLASS);
	                } else {
	                    $(item)
	                        .addClass(DISABLED_STATE_CLASS)
	                        .removeClass(SELECTED_STATE_CLASS);
	                }
	            }
	        },

	        setDataSource: function(dataSource) {
	            var that = this;

	            that.options.dataSource = dataSource;

	            that._dataSource();
	        },

	        _dataSource: function() {
	            var that = this;
	            var options = that.options;
	            var dataSource = options.dataSource || {};

	            dataSource = $.isArray(dataSource) ? { data: dataSource } : dataSource;
	            dataSource.select = that.element;
	            dataSource.fields = [
	                { field: options.dataTextField },
	                { field: options.dataValueField }];

	            that._unbindDataSource();
	            that.dataSource = DataSource.create(dataSource);
	            that._bindDataSource();

	            if (that.options.autoBind) {
	                that.dataSource.fetch();
	            }
	        },

	        _bindDataChange: function () {
	            var dataSource = this.dataSource;
	            if (dataSource._data && dataSource._changeHandler) {
	                dataSource._data.bind(CHANGE, dataSource._changeHandler);
	                dataSource._data.trigger(CHANGE);
	            }
	        },

	        _unbindDataChange: function () {
	            var dataSource = this.dataSource;
	            if (dataSource._data && dataSource._changeHandler) {
	                dataSource._data.unbind(CHANGE, dataSource._changeHandler);
	            }
	        },

	        _bindDataSource: function() {
	            var that = this;
	            var dataSource = that.dataSource;

	            that._dataChangeHandler = proxy(that.refresh, that);

	            if (dataSource) {
	                dataSource.bind(CHANGE, that._dataChangeHandler);
	            }
	        },

	        _unbindDataSource: function() {
	            var that = this;
	            var dataSource = that.dataSource;

	            if (dataSource) {
	                dataSource.unbind(CHANGE, that._dataChangeHandler);
	            }
	        },

	        _wrapper: function () {
	            var that = this,
	                element = that.element,
	                wrapper = element.parent("div.k-listbox");

	            if (!wrapper[0]) {
	                wrapper = element.wrap('<div class="k-widget k-listbox" unselectable="on" />').parent();
	                wrapper[0].style.cssText = element[0].style.cssText;
	                wrapper[0].title = element[0].title;
	                $('<div class="k-list-scroller" />').insertBefore(element);
	            }

	            that.wrapper = wrapper.addClass(element[0].className).css("display", "");
	            that._innerWrapper = $(wrapper[0].firstChild);
	        },

	        _list: function () {
	            var that = this;
	            $("<ul class='" + LIST_CLASS + "' role='listbox'></ul>").appendTo(that._innerWrapper);
	            if(that.options.navigatable) {
	                that._getList().attr(TABINDEX, that._getTabIndex());
	            }
	        },

	        _templates: function () {
	            var that = this;
	            var options = this.options;
	            var template;

	            if (options.template && typeof options.template == "string") {
	                template = kendo.template(options.template);
	            } else if (!options.template) {
	                template = kendo.template('${' + kendo.expr(options.dataTextField, "data") + "}", { useWithBlock: false });
	            } else {
	                template = options.template;
	            }

	            that.templates = {
	                itemTemplate: kendo.template("# var item = data.item, r = data.r; # <li class='k-item' role='option' aria-selected='false'>#=r(item)#</li>", { useWithBlock: false }),
	                itemContent: template,
	                toolbar: "<div class='" + TOOLBAR_CLASS + "'></div>"
	            };
	        },

	        refresh: function() {
	            var that = this;
	            var view = that.dataSource.view();
	            var template = that.templates.itemTemplate;
	            var html = "";

	            for (var idx = 0; idx < view.length; idx++) {
	                html += template({ item: view[idx], r: that.templates.itemContent });
	            }
	            that._getList().html(html);
	            that._setItemIds();
	            that._createToolbar();
	            that._syncElement();
	            that._updateToolbar();
	            that._updateAllToolbars();
	            that.trigger(DATABOUND);
	        },

	        _syncElement: function () {
	            var options = "";
	            var view = this.dataSource.view();
	            for (var idx = 0; idx < view.length; idx++) {
	                options += this._option(view[idx][this.options.dataValueField] || view[idx], view[idx][this.options.dataTextField] || view[idx], true);
	            }
	            this.element.html(options);
	        },

	        _option: function (dataValue, dataText) {
	            var option = "<option";

	            if (dataValue !== undefined) {
	                dataValue += "";

	                if (dataValue.indexOf('"') !== -1) {
	                    dataValue = dataValue.replace(/"/g, "&quot;");
	                }

	                option += ' value="' + dataValue + '"';
	            }
	            option += " selected>";

	            if (dataText !== undefined) {
	                option += kendo.htmlEncode(dataText);
	            }

	            return option += "</option>";
	        },

	        _setItemIds: function() {
	            var that = this;
	            var items = that.items();
	            var view = that.dataSource.view();
	            var viewLength = view.length;
	            var i;

	            for (i = 0; i < viewLength; i++) {
	                items.eq(i).attr(kendoAttr(UNIQUE_ID), view[i].uid).attr("id", view[i].uid);
	            }
	        },

	        _selectable: function() {
	            var that = this;
	            var selectable = that.options.selectable;
	            var selectableOptions = Selectable.parseOptions(selectable);

	            if (selectableOptions.multiple) {
	                that.element.attr("aria-multiselectable", "true");
	            }

	            that.selectable = new Selectable(that._innerWrapper, {
	                aria: true,
	                multiple: selectableOptions.multiple,
	                filter: ENABLED_ITEM_SELECTOR,
	                change: proxy(that._onSelect, that)
	            });
	        },

	        _onSelect: function() {
	            var that = this;

	            that._updateToolbar();
	            that._updateAllToolbars();
	            that.trigger(CHANGE);
	        },

	        _destroySelectable: function() {
	            var that = this;

	            if (that.selectable && that.selectable.element) {
	                that.selectable.destroy();
	                that.selectable = null;
	            }
	        },

	        _getList: function() {
	            return this.wrapper.find(LIST_SELECTOR);
	        },

	        _getItems: function(items) {
	            return this.items().filter(items);
	        },

	        _createToolbar: function () {
	            var that = this;
	            var toolbarOptions = that.options.toolbar;
	            var position = toolbarOptions.position || RIGHT;
	            var toolbarInsertion = position === BOTTOM ? "insertAfter" : "insertBefore";
	            var tools = toolbarOptions.tools || [];
	            var messages = that.options.messages;

	            that._destroyToolbar();
	            that.wrapper.removeClass(TOOLBAR_POSITION_CLASS_NAMES.join(SPACE));

	            if (tools.length && tools.length > 0) {
	                var toolbarElement = $(that.templates.toolbar)[toolbarInsertion](that._innerWrapper);
	                that.toolbar = new ToolBar(toolbarElement, extend({}, toolbarOptions, { listBox: that, messages: messages }));
	                that.wrapper.addClass(TOOLBAR_CLASS + DASH + position);
	            }
	        },

	        _destroyToolbar: function() {
	            var that = this;

	            if (that.toolbar) {
	                that.toolbar.destroy();
	                that.toolbar = null;
	            }
	        },

	        _executeCommand: function(commandName) {
	            var that = this;
	            var command = CommandFactory.current.create(commandName, { listBox: that });

	            if (command) {
	                command.execute();
	                that._updateToolbar();
	                that._updateAllToolbars();
	            }
	        },

	        _updateToolbar: function() {
	            var toolbar = this.toolbar;

	            if (toolbar) {
	                toolbar._updateToolStates();
	            }
	        },

	        _updateAllToolbars: function() {
	            var listBoxElements = $("select[data-role='listbox']");
	            var elementsLength = listBoxElements.length;
	            var listBox;
	            var i;

	            for (i = 0; i < elementsLength; i++) {
	                listBox = $(listBoxElements[i]).data(KENDO_LISTBOX);

	                if (listBox) {
	                    listBox._updateToolbar();
	                }
	            }
	        }
	    });

	    kendo.ui.plugin(ListBox);

	    var CommandFactory = Class.extend({
	        init: function() {
	            this._commands = [];
	        },

	        register: function(commandName, commandType) {
	            this._commands.push({
	                commandName: commandName,
	                commandType: commandType
	            });
	        },

	        create: function(commandName, options) {
	            var commands = this._commands;
	            var itemsLength = commands.length;
	            var name = commandName ? commandName.toLowerCase() : "";
	            var match;
	            var command;
	            var i;

	            for (i = 0; i < itemsLength; i++) {
	                command = commands[i];

	                if (command.commandName.toLowerCase() === name) {
	                    match = command;
	                    break;
	                }
	            }

	            if (match) {
	                return new match.commandType(options);
	            }
	        }
	    });
	    CommandFactory.current = new CommandFactory();

	    var ListBoxCommand = Class.extend({
	        init: function(options) {
	            var that = this;

	            that.options = extend({}, that.options, options);
	            that.listBox = that.options.listBox;
	        },

	        options: {
	            listBox: null
	        },

	        getItems: function() {
	            return $(this.listBox.select());
	        },

	        execute: noop,
	        canExecute: noop
	    });

	    var RemoveItemsCommand = ListBoxCommand.extend({
	        execute: function() {
	            var that = this;
	            var listBox = that.listBox;
	            var items = that.getItems();

	            if (!listBox.trigger(REMOVE, { dataItems: listBox._dataItems(items), items: items })) {
	                listBox.remove(items);
	            }
	        },

	        canExecute: function() {
	            return this.listBox.select().length > 0;
	        }
	    });
	    CommandFactory.current.register(REMOVE, RemoveItemsCommand);

	    var MoveItemsCommand = ListBoxCommand.extend({
	        execute: function() {
	            var that = this;

	            if (that.canExecute()) {
	                that.moveItems();
	            }
	        },

	        canExecute: noop,

	        moveItems: function() {
	            var that = this;
	            var listBox = that.listBox;
	            var options = that.options;
	            var items = that.getItems();
	            var offset = options.offset;
	            var indecesInDom = getSortedDomIndices(items);
	            var movedItems = $.makeArray(items.sort(that.itemComparer));
	            var moveAction = options.moveAction;
	            var movedItem;

	            if (!listBox.trigger(REORDER, { dataItems: listBox._dataItems(movedItems), items: $(movedItems), offset: offset })) {
	                while (movedItems.length > 0 && indecesInDom.length > 0) {
	                    movedItem = movedItems[moveAction]();

	                    listBox.reorder(movedItem, indecesInDom[moveAction]() + offset);
	                }
	            }
	        },

	        options: {
	            offset: 0,
	            moveAction: "pop"
	        },

	        itemComparer: function(item1, item2) {
	            var indexItem1 = $(item1).index();
	            var indexItem2 = $(item2).index();

	            if (indexItem1 === indexItem2) {
	                return 0;
	            } else {
	                return (indexItem1 > indexItem2 ? 1 : (-1));
	            }
	        }
	    });

	    var MoveUpItemsCommand = MoveItemsCommand.extend({
	        options: {
	            offset: MOVE_UP_OFFSET,
	            moveAction: "shift"
	        },

	        canExecute: function() {
	            var items = this.getItems();
	            var domIndices = getSortedDomIndices(items);

	            return (domIndices.length > 0 && domIndices[0] > 0);
	        }
	    });
	    CommandFactory.current.register(MOVE_UP, MoveUpItemsCommand);

	    var MoveDownItemsCommand = MoveItemsCommand.extend({
	        options: {
	            offset: MOVE_DOWN_OFFSET,
	            moveAction: "pop"
	        },

	        canExecute: function() {
	            var that = this;
	            var items = that.getItems();
	            var domIndices = getSortedDomIndices(items);

	            return (domIndices.length > 0 && $(domIndices).last()[0] < (that.listBox.items().length - 1));
	        }
	    });
	    CommandFactory.current.register(MOVE_DOWN, MoveDownItemsCommand);

	    var TransferItemsCommand = ListBoxCommand.extend({
	        options: {
	            filter: ENABLED_ITEM_SELECTOR
	        },

	        execute: function() {
	            var that = this;
	            var sourceListBox = that.getSourceListBox();
	            var items = that.getItems().filter(that.options.filter);
	            var dataItems = sourceListBox ? sourceListBox._dataItems(items) : [];
	            var destinationListBox = that.getDestinationListBox();
	            var updatedSelection = that.getUpdatedSelection(items);

	            if (destinationListBox && items.length > 0) {
	                if (!destinationListBox.trigger(ADD, { dataItems: dataItems, items: items })) {
	                    destinationListBox.add(dataItems);
	                }

	                if (!sourceListBox.trigger(REMOVE, { dataItems: dataItems, items: items })) {
	                    sourceListBox.remove(items);
	                    that.updateSelection(updatedSelection);
	                }
	            }
	        },

	        getUpdatedSelection: function(items) {

	            if (items.length !== 1) {
	                return null;
	            }
	            
	            var that = this;
	            var itemFilter = that.options.filter;
	            var sourceListBox = that.getSourceListBox();
	            var lastEnabledItem = sourceListBox ? sourceListBox.items().filter(itemFilter).last() : null;
	            var containsLastItem = $(items).filter(lastEnabledItem).length > 0;
	            var itemToSelect = containsLastItem ? $(items).prevAll(itemFilter)[0] : $(items).nextAll(itemFilter)[0];

	            if (itemToSelect) {
	                return itemToSelect;
	            } else {
	                return null;
	            }
	        },

	        updateSelection: function(item) {
	            var sourceListBox = this.getSourceListBox();

	            if (sourceListBox && item) {
	                $(sourceListBox.select($(item)));
	                sourceListBox._scrollIntoView(item);
	            }
	        },

	        getSourceListBox: noop,
	        getDestinationListBox: noop
	    });

	    var TransferItemsToCommand = TransferItemsCommand.extend({
	        canExecute: function() {
	            var sourceListBox = this.getSourceListBox();

	            return (sourceListBox ? sourceListBox.select().length > 0 : false);
	        },

	        getSourceListBox: function() {
	            return this.listBox;
	        },

	        getDestinationListBox: function() {
	            var sourceListBox = this.getSourceListBox();
	            return sourceListBox && sourceListBox.options.connectWith ? $(HASH + sourceListBox.options.connectWith).data(KENDO_LISTBOX) : null;
	        },

	        getItems: function() {
	            var sourceListBox = this.getSourceListBox();
	            return sourceListBox ? $(sourceListBox.select()) : $();
	        }
	    });
	    CommandFactory.current.register(TRANSFER_TO, TransferItemsToCommand);

	    var TransferItemsFromCommand = TransferItemsCommand.extend({
	        canExecute: function() {
	            var sourceListBox = this.getSourceListBox();

	            return (sourceListBox ? sourceListBox.select().length > 0 : false);
	        },

	        getSourceListBox: function() {
	            var destinationListBox = this.getDestinationListBox();
	            return (destinationListBox && destinationListBox.options.connectWith) ? $(HASH + destinationListBox.options.connectWith).data(KENDO_LISTBOX) : null;
	        },

	        getDestinationListBox: function() {
	            return this.listBox;
	        },

	        getItems: function() {
	            var sourceListBox = this.getSourceListBox();
	            return sourceListBox ? $(sourceListBox.select()) : $();
	        }
	    });
	    CommandFactory.current.register(TRANSFER_FROM, TransferItemsFromCommand);

	    var TransferAllItemsToCommand = TransferItemsToCommand.extend({
	        canExecute: function() {
	            var sourceListBox = this.getSourceListBox();

	            return (sourceListBox ? sourceListBox.wrapper.find(ENABLED_ITEMS_SELECTOR).length > 0 : false);
	        },

	        getItems: function() {
	            var sourceListBox = this.getSourceListBox();
	            return sourceListBox ? sourceListBox.items() : $();
	        },

	        getUpdatedSelection: noop,
	        updateSelection: noop
	    });
	    CommandFactory.current.register(TRANSFER_ALL_TO, TransferAllItemsToCommand);

	    var TransferAllItemsFromCommand = TransferItemsFromCommand.extend({
	        canExecute: function() {
	            var sourceListBox = this.getSourceListBox();

	            return (sourceListBox ? sourceListBox.wrapper.find(ENABLED_ITEMS_SELECTOR).length > 0 : false);
	        },

	        getItems: function() {
	            var sourceListBox = this.getSourceListBox();
	            return sourceListBox ? sourceListBox.items() : $();
	        },

	        getUpdatedSelection: noop,
	        updateSelection: noop
	    });
	    CommandFactory.current.register(TRANSFER_ALL_FROM, TransferAllItemsFromCommand);

	    var ToolBar = Class.extend({
	        init: function(element, options) {
	            var that = this;

	            that.element = $(element).addClass(TOOLBAR_CLASS);
	            that.options = extend({}, that.options, options);
	            that.listBox = that.options.listBox;

	            that._initTemplates();
	            that._createTools();
	            that._updateToolStates();
	            that._attachEventHandlers();
	        },

	        destroy: function() {
	            var that = this;

	            that._detachEventHandlers();
	            kendo.destroy(that.element);
	            that.element.remove();
	            that.element = null;
	        },

	        options: {
	            position: RIGHT,
	            tools: []
	        },

	        _initTemplates: function() {
	            this.templates = {
	                tool: kendoTemplate(
	                    "<li>" +
	                        "<a href='\\\\#' class='k-button k-button-icon' data-command='#= command #' title='#= text #' aria-label='#= text #' role='button'>" +
	                            "<span class='k-icon #= iconClass #'></span>" +
	                        "</a>" +
	                    "</li>")
	            };
	        },

	        _createTools: function() {
	            var that = this;
	            var tools = that.options.tools;
	            var toolsLength = tools.length;
	            var toolsMessages = that.options.messages.tools;
	            var toolList = that._createToolList();
	            var tool;
	            var i;

	            for (i = 0; i < toolsLength; i++) {
	                tool = extend({}, ToolBar.defaultTools[tools[i]], { text: toolsMessages[tools[i]] });

	                if (tool) {
	                    toolList.append($(that.templates.tool(tool)));
	                }
	            }

	            that.element.append(toolList);
	        },

	        _createToolList: function() {
	            return $("<ul class='k-reset' />");
	        },

	        _attachEventHandlers: function() {
	            var that = this;

	            that.element.on(CLICK, TOOL_SELECTOR, proxy(that._onToolClick, that));
	        },

	        _detachEventHandlers: function() {
	            this.element.off(NS).find("*").off(NS);
	        },

	        _onToolClick: function(e) {
	            e.preventDefault();

	            this._executeToolCommand($(e.currentTarget).data(COMMAND));
	        },

	        _executeToolCommand: function(command) {
	            var that = this;
	            var listBox = that.listBox;

	            if (listBox) {
	                listBox._executeCommand(command);
	            }
	        },

	        _updateToolStates: function() {
	            var that = this;
	            var tools = that.options.tools;
	            var toolsLength = tools.length;
	            var i;

	            for (i = 0; i < toolsLength; i++) {
	                that._updateToolState(tools[i]);
	            }
	        },

	        _updateToolState: function(toolName) {
	            var that = this;
	            var command = CommandFactory.current.create(toolName, { listBox: that.listBox });
	            var tool = that.element.find("[data-command='" + toolName + "']");
	            var toolElement = tool[0];

	            if (toolElement && command && command.canExecute) {
	                if (command.canExecute()) {
	                    tool.removeClass(DISABLED_STATE_CLASS).removeAttr(TABINDEX);
	                } else {
	                    tool.addClass(DISABLED_STATE_CLASS).attr(TABINDEX, "-1");
	                }
	            }
	        }
	    });

	    ToolBar.defaultTools = {
	        remove: {
	            command: REMOVE,
	            iconClass: "k-i-x"
	        },
	        moveUp: {
	            command: MOVE_UP,
	            iconClass: "k-i-arrow-60-up"
	        },
	        moveDown: {
	            command: MOVE_DOWN,
	            iconClass: "k-i-arrow-60-down"
	        },
	        transferTo: {
	            command: TRANSFER_TO,
	            iconClass: "k-i-arrow-60-right"
	        },
	        transferFrom: {
	            command: TRANSFER_FROM,
	            iconClass: "k-i-arrow-60-left"
	        },
	        transferAllTo: {
	            command: TRANSFER_ALL_TO,
	            iconClass: "k-i-arrow-double-60-right"
	        },
	        transferAllFrom: {
	            command: TRANSFER_ALL_FROM,
	            iconClass: "k-i-arrow-double-60-left"
	        }
	    };

	    extend(ListBox, {
	        ToolBar: ToolBar
	    });

	    function isInputElement(element) {
	        return $(element).is(":button,a,:input,a>.k-icon,textarea,span.k-select,span.k-icon,span.k-link,label.k-checkbox-label,.k-input,.k-multiselect-wrap,.k-picker-wrap,.k-picker-wrap>.k-selected-color,.k-tool-icon,.k-dropdown");
	    }

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "7uAN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var main_2 = __webpack_require__("F6Mk");
var md5_1 = __webpack_require__("MPcG");
var LicenseManager = (function () {
    function LicenseManager() {
    }
    LicenseManager_1 = LicenseManager;
    LicenseManager.prototype.validateLicense = function () {
        var gridReleaseDate = LicenseManager_1.getGridReleaseDate();
        var valid = false;
        var current = false;
        var expiry = null;
        if (!main_2.Utils.missingOrEmpty(LicenseManager_1.licenseKey) && LicenseManager_1.licenseKey.length > 32) {
            var _a = LicenseManager_1.extractLicenseComponents(LicenseManager_1.licenseKey), md5 = _a.md5, license = _a.license;
            if (md5 === this.md5.md5(license)) {
                expiry = LicenseManager_1.extractExpiry(license);
                if (!isNaN(expiry.getTime())) {
                    valid = true;
                    current = (gridReleaseDate < expiry);
                }
            }
        }
        if (!valid) {
            LicenseManager_1.outputMessage('********************************************* Invalid License **************************************************', '* Your license for ag-Grid Enterprise is not valid - please contact accounts@ag-grid.com to obtain a valid license. *');
        }
        else if (!current) {
            var formattedExpiryDate = LicenseManager_1.formatDate(expiry);
            var formattedReleaseDate = LicenseManager_1.formatDate(gridReleaseDate);
            LicenseManager_1.outputMessage('********************* License not compatible with installed version of ag-Grid Enterprise. *********************', "Your license for ag-Grid Enterprise expired on " + formattedExpiryDate + " but the version installed was released on " + formattedReleaseDate + ". Please " +
                'contact accounts@ag-grid.com to renew your license');
        }
    };
    LicenseManager.extractExpiry = function (license) {
        var restrictionHashed = license.substring(license.lastIndexOf('_') + 1, license.length);
        return new Date(parseInt(LicenseManager_1.decode(restrictionHashed)));
    };
    LicenseManager.extractLicenseComponents = function (licenseKey) {
        var hashStart = licenseKey.length - 32;
        var md5 = licenseKey.substring(hashStart);
        var license = licenseKey.substring(0, hashStart);
        return { md5: md5, license: license };
    };
    LicenseManager.prototype.getLicenseDetails = function (licenseKey) {
        var _a = LicenseManager_1.extractLicenseComponents(licenseKey), md5 = _a.md5, license = _a.license;
        var valid = (md5 === this.md5.md5(license));
        var expiry;
        if (valid) {
            expiry = LicenseManager_1.extractExpiry(license);
            valid = !isNaN(expiry.getTime());
        }
        return {
            licenseKey: licenseKey,
            valid: valid,
            expiry: valid ? LicenseManager_1.formatDate(expiry) : null
        };
    };
    LicenseManager.outputMessage = function (header, message) {
        console.error('****************************************************************************************************************');
        console.error('*************************************** ag-Grid Enterprise License *********************************************');
        console.error(header);
        console.error(message);
        console.error('****************************************************************************************************************');
        console.error('****************************************************************************************************************');
    };
    LicenseManager.formatDate = function (date) {
        var monthNames = [
            'January', 'February', 'March',
            'April', 'May', 'June', 'July',
            'August', 'September', 'October',
            'November', 'December'
        ];
        var day = date.getDate();
        var monthIndex = date.getMonth();
        var year = date.getFullYear();
        return day + ' ' + monthNames[monthIndex] + ' ' + year;
    };
    LicenseManager.getGridReleaseDate = function () {
        return new Date(parseInt(LicenseManager_1.decode(LicenseManager_1.RELEASE_INFORMATION)));
    };
    ;
    LicenseManager.decode = function (input) {
        var keystr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        var t = '';
        var n, r, i;
        var s, o, u, a;
        var f = 0;
        var e = input.replace(/[^A-Za-z0-9+/=]/g, '');
        while (f < e.length) {
            s = keystr.indexOf(e.charAt(f++));
            o = keystr.indexOf(e.charAt(f++));
            u = keystr.indexOf(e.charAt(f++));
            a = keystr.indexOf(e.charAt(f++));
            n = s << 2 | o >> 4;
            r = (o & 15) << 4 | u >> 2;
            i = (u & 3) << 6 | a;
            t = t + String.fromCharCode(n);
            if (u != 64) {
                t = t + String.fromCharCode(r);
            }
            if (a != 64) {
                t = t + String.fromCharCode(i);
            }
        }
        t = LicenseManager_1.utf8_decode(t);
        return t;
    };
    LicenseManager.utf8_decode = function (input) {
        input = input.replace(/rn/g, 'n');
        var t = '';
        for (var n = 0; n < input.length; n++) {
            var r = input.charCodeAt(n);
            if (r < 128) {
                t += String.fromCharCode(r);
            }
            else if (r > 127 && r < 2048) {
                t += String.fromCharCode(r >> 6 | 192);
                t += String.fromCharCode(r & 63 | 128);
            }
            else {
                t += String.fromCharCode(r >> 12 | 224);
                t += String.fromCharCode(r >> 6 & 63 | 128);
                t += String.fromCharCode(r & 63 | 128);
            }
        }
        return t;
    };
    LicenseManager.setLicenseKey = function (licenseKey) {
        LicenseManager_1.licenseKey = licenseKey;
    };
    LicenseManager.RELEASE_INFORMATION = 'MTUxNjgwMzAyNTAwNQ==';
    __decorate([
        main_1.Autowired('md5'),
        __metadata("design:type", md5_1.MD5)
    ], LicenseManager.prototype, "md5", void 0);
    LicenseManager = LicenseManager_1 = __decorate([
        main_1.Bean('licenseManager')
    ], LicenseManager);
    return LicenseManager;
    var LicenseManager_1;
}());
exports.LicenseManager = LicenseManager;


/***/ }),

/***/ "86I2":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(938);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(939)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {

	    var kendo = window.kendo;
	    var dataviz = kendo.dataviz;
	    var ChartInstanceObserver = dataviz.ChartInstanceObserver;
	    var Chart = dataviz.ui.Chart;
	    var KendoStockChart = dataviz.StockChart;
	    var constants = dataviz.constants;
	    var NAVIGATOR_AXIS = constants.NAVIGATOR_AXIS;
	    var NAVIGATOR_PANE = constants.NAVIGATOR_PANE;
	    var deepExtend = kendo.deepExtend;
	    var defined = dataviz.defined;
	    var proxy = $.proxy;

	    var CHANGE = "change";

	    var StockInstanceObserver = ChartInstanceObserver.extend({
	        handlerMap: {
	            navigatorFilter: '_onNavigatorFilter',
	            navigatorCreated: '_onNavigatorCreated'
	        }
	    });

	    var StockChart = Chart.extend({

	        options: {
	            name: "StockChart",
	            dateField: "date",
	            axisDefaults: {
	                categoryAxis: {
	                    type: "date",
	                    baseUnit: "fit",
	                    justified: true
	                },
	                valueAxis: {
	                    narrowRange: true,
	                    labels: {
	                        format: "C"
	                    }
	                }
	            },
	            navigator: {
	                select: {},
	                seriesDefaults: {
	                    markers: {
	                        visible: false
	                    },
	                    tooltip: {
	                        visible: true,
	                        template: "#= kendo.toString(category, 'd') #"
	                    },
	                    line: {
	                        width: 2
	                    }
	                },
	                hint: {},
	                visible: true
	            },
	            tooltip: {
	                visible: true
	            },
	            legend: {
	                visible: false
	            },
	            persistSeriesVisibility: true
	        },

	        _createChart: function(options, themeOptions) {
	            this._initNavigatorOptions(options);
	            this._instance = new KendoStockChart(this.element[0], options, themeOptions, {
	                observer: new StockInstanceObserver(this),
	                sender: this,
	                rtl: this._isRtl()
	            });
	        },

	        _initNavigatorOptions: function(options) {
	            var navigatorOptions = options.navigator || {};
	            var support = kendo.support;
	            var isTouch = support.touch;
	            var isFirefox = support.browser.mozilla;

	            deepExtend(navigatorOptions, {
	                autoBindElements: !navigatorOptions.dataSource,
	                partialRedraw: navigatorOptions.dataSource,
	                liveDrag: !isTouch && !isFirefox
	            });
	        },

	        _initDataSource: function(userOptions) {
	            var options = userOptions || {},
	                dataSource = options.dataSource,
	                hasServerFiltering = dataSource && dataSource.serverFiltering,
	                mainAxis = [].concat(options.categoryAxis)[0],
	                naviOptions = options.navigator || {},
	                select = naviOptions.select,
	                hasSelect = select && select.from && select.to;

	            if (hasServerFiltering && hasSelect) {
	                var filter = [].concat(dataSource.filter || []);

	                var from = kendo.parseDate(select.from);
	                var to = kendo.parseDate(select.to);
	                var dummyAxis = new dataviz.DateCategoryAxis(deepExtend({
	                    baseUnit: "fit"
	                }, mainAxis, {
	                    categories: [from, to]
	                }), kendo);

	                dataSource.filter = buildFilter(dummyAxis.range().min, to).concat(filter);
	            }

	            Chart.fn._initDataSource.call(this, userOptions);
	        },

	        _onNavigatorCreated: function(e) {
	            this._instance = e.sender;
	            this.options = e.sender.options;
	            this._navigator = this.navigator = e.navigator;
	            this._initNavigatorDataSource();
	        },

	        _initNavigatorDataSource: function() {
	            var navigatorOptions = this.options.navigator;
	            var autoBind = navigatorOptions.autoBind;
	            var dsOptions = navigatorOptions.dataSource;

	            if (dsOptions) {
	                this._navigatorDataChangedHandler = this._navigatorDataChangedHandler || proxy(this._onNavigatorDataChanged, this);
	                this._navigatorDataSource = kendo.data.DataSource
	                    .create(dsOptions)
	                    .bind(CHANGE, this._navigatorDataChangedHandler);

	                if (!defined(autoBind)) {
	                   autoBind = this.options.autoBind;
	                }

	                if (autoBind) {
	                    this._navigatorDataSource.fetch();
	                }
	            }
	        },

	        _bindNavigatorSeries: function(series, data) {
	            var seriesIx, currentSeries,
	                seriesLength = series.length;

	            for (seriesIx = 0; seriesIx < seriesLength; seriesIx++) {
	                currentSeries = series[seriesIx];

	                if (currentSeries.axis == NAVIGATOR_AXIS && this._isBindable(currentSeries)) {
	                    currentSeries.data = data;
	                }
	            }
	        },

	        _onNavigatorDataChanged: function() {
	            var chart = this,
	                instance = chart._instance,
	                categoryAxes = chart.options.categoryAxis,
	                axisIx,
	                axesLength = categoryAxes.length,
	                data = chart._navigatorDataSource.view(),
	                currentAxis,
	                naviCategories;

	            this._bindNavigatorSeries(chart.options.series, data);
	            if (chart._sourceSeries) {
	                this._bindNavigatorSeries(chart._sourceSeries, data);
	            }

	            for (axisIx = 0; axisIx < axesLength; axisIx++) {
	                currentAxis = categoryAxes[axisIx];

	                if (currentAxis.pane == NAVIGATOR_PANE) {
	                    if (currentAxis.name == NAVIGATOR_AXIS) {
	                        chart._bindCategoryAxis(currentAxis, data, axisIx);
	                        naviCategories = currentAxis.categories;
	                    } else {
	                        currentAxis.categories = naviCategories;
	                    }
	                }
	            }

	            if (instance._model) {
	                var navigator = this.navigator;
	                navigator.redraw();
	                navigator.setRange();

	                if (!chart.options.dataSource || (chart.options.dataSource && chart._dataBound)) {
	                    navigator.redrawSlaves();
	                }
	            }
	        },

	        _bindCategories: function() {
	            Chart.fn._bindCategories.call(this);
	            if (this._instance) {
	                this._instance.copyNavigatorCategories();
	            }
	        },

	        _onDataChanged: function() {
	            Chart.fn._onDataChanged.call(this);

	            this._dataBound = true;
	        },

	        setOptions: function(options) {
	            this._removeNavigatorDataSource();
	            this._initNavigatorOptions(options);
	            this._instance.destroyNavigator();
	            Chart.fn.setOptions.call(this, options);
	        },

	        _onNavigatorFilter: function(e) {
	            this.dataSource.filter(buildFilter(e.from, e.to));
	        },

	        requiresHandlers: function(names) {
	            if (dataviz.inArray('navigatorFilter', names)) {
	                var dataSource = this.dataSource;
	                var hasServerFiltering = dataSource && dataSource.options.serverFiltering;
	                return hasServerFiltering && this.options.navigator.dataSource;
	            }

	            return Chart.fn.requiresHandlers.call(this, names);
	        },

	        _removeNavigatorDataSource: function() {
	            var navigatorDataSource = this._navigatorDataSource;
	            if (navigatorDataSource) {
	                navigatorDataSource.unbind(CHANGE, this._navigatorDataChangedHandler);
	                delete this._navigatorDataSource;
	            }
	        },

	        destroy: function() {
	            Chart.fn.destroy.call(this);
	            this._removeNavigatorDataSource();
	        }
	    });

	    dataviz.ui.plugin(StockChart);

	    function buildFilter(from, to) {
	        return [{
	            field: "Date", operator: "gte", value: from
	        }, {
	            field: "Date", operator: "lt", value: to
	        }];
	    }

	})(window.kendo.jQuery);

	}, __webpack_require__(3));

/***/ }),

/***/ 939:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("rdB9");

/***/ })

/******/ });

/***/ }),

/***/ "86tn":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1029);
	module.exports = __webpack_require__(1029);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1029:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1030), __webpack_require__(1031)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {
	    var kendo = window.kendo,
	        extend = $.extend,
	        proxy = $.proxy,
	        ToolBar = kendo.ui.ToolBar,
	        Item = kendo.toolbar.Item,

	        CLICK = "click",
	        TOGGLE = "toggle",
	        CLOSE = "close",
	        ACTION = "action",
	        CHANGE = "change",
	        NS = ".fileManagerToolbar";

	    var FileManagerToolBar = ToolBar.extend({
	        init: function(element, options) {
	            var that = this;

	            that._extendOptions(options);

	            ToolBar.fn.init.call(that, element, options);

	            that._attachEvents();
	        },

	        events: ToolBar.fn.events.concat([
	            ACTION
	        ]),

	        defaultTools: {
	            createFolder: { type: "button", text: "New Folder", name: "createFolder", command: "CreateFolderCommand", rules: "{ \"remote\": true }" },
	            upload: { type: "button",  text: "Upload", name: "upload", command: "OpenDialogCommand", options: "{ \"type\": \"uploadDialog\" }", rules: "{ \"remote\": true }" },
	            sortDirection: { type: "buttonGroup", text: "Sort Direction", name:"sortDirection",
	                buttons: [
	                    { name: "sortDirectionAsc", icon: "sort-asc-sm", togglable: true, group: "sortDirection", command: "SortCommand", options: "{ \"dir\": \"asc\" }", selected: true },
	                    { name: "sortDirectionDesc", icon: "sort-desc-sm", togglable: true, group: "sortDirection", command: "SortCommand", options: "{ \"dir\": \"desc\" }" }
	                ]
	            },
	            sortField: { type: "splitButton", text: "Sort By", name: "sortField", command: "SortCommand", menuButtons: [
	                { name: "nameField", text: "Name", options: "{\"field\": \"name\"}", command: "SortCommand" },
	                { name: "typeField", text: "Type", options: "{\"field\": \"extension\"}", command: "SortCommand" },
	                { name: "sizeField", text: "Size", options: "{\"field\": \"size\"}", command: "SortCommand" },
	                { name: "dateCreatedField", text: "Date created", options: "{\"field\": \"createdUtc\"}", command: "SortCommand" },
	                { name: "dateModifiedField", text: "Date modified", options: "{\"field\": \"modifiedUtc\"}", command: "SortCommand" }
	            ] },
	            changeView: { type: "buttonGroup", text: "Change View", name:"changeView",
	                buttons: [
	                    { name: "gridView", icon: "grid-layout", togglable: true, group: "changeView", command: "ChangeViewCommand", options: "grid" },
	                    { name: "listView", icon: "grid", togglable: true, group: "changeView", command: "ChangeViewCommand", options: "list" }
	                ]
	            },
	            spacer: { type: "spacer" },
	            details: { type: "fileManagerDetailsToggle", text: "View Details", name: "details", overflow: "never", command: "TogglePaneCommand", options: "{ \"type\": \"preview\" }"},
	            search: { type: "fileManagerSearch", text: "Search", name: "search", command: "SearchCommand", icon: "search", overflow: "never", options: "{ \"field\": \"name\", \"operator\": \"startswith\" }" }
	        },

	        _attachEvents: function() {
	            var that = this;

	            that.bind(TOGGLE, proxy(that._click, that));
	            that.bind(CLOSE, proxy(that._click, that));
	            that.bind(CLICK, proxy(that._click, that));
	            that.bind(CHANGE, proxy(that._change, that));
	        },

	        _extendOptions: function(options) {
	            var that = this,
	                tools = options.items ? options.items : Object.keys(that.defaultTools);

	            that.options = options;

	            that.options.items = that._extendToolsOptions(tools);
	        },

	        _extendToolsOptions: function(tools) {
	            var that = this,
	                messages = that.options.messages;

	            if (!tools.length) {
	                return;
	            }

	            return tools.map(function (tool) {
	                var isBuiltInTool =  $.isPlainObject(tool) && Object.keys(tool).length === 1 && tool.name,
	                    toolOptions, toolRules;

	                tool = isBuiltInTool ? tool.name : tool;
	                toolOptions = $.isPlainObject(tool) ? tool : extend({}, that.defaultTools[tool]);
	                toolRules = toolOptions.rules ? JSON.parse(toolOptions.rules) : {};

	                kendo.deepExtend(toolOptions, {
	                    id: toolOptions.name + "-" + kendo.guid(),
	                    name: toolOptions.name,
	                    text: messages[toolOptions.name],
	                    attributes: {
	                        "aria-label": messages[toolOptions.name],
	                        "title": messages[toolOptions.name],
	                        "data-command": toolOptions.command,
	                        "data-options": toolOptions.options
	                    },
	                    overflow: toolOptions.overflow
	                });

	                if(toolOptions.type === "buttonGroup") {
	                    toolOptions.buttons = toolOptions.buttons.map(proxy(that._mapButtonGroups, that));
	                }

	                if(toolOptions.type === "splitButton") {
	                    toolOptions.menuButtons = toolOptions.menuButtons.map(proxy(that._mapMenuButtons, that));
	                }

	                if (toolRules.remote && that.options.filemanager.dataSource.isLocalBinding) {
	                    toolOptions.hidden = true;
	                }

	                return toolOptions;
	            }, that);
	        },

	        _mapButtonGroups: function(button) {
	            var that = this,
	                messages = that.options.messages;

	            if(button.group === "changeView" && button.options === that.options.filemanager.options.initialView) {
	                button.selected = true;
	            }

	            return kendo.deepExtend(button,{
	                attributes: extend({}, button.attributes, {
	                    "aria-label": messages[button.name],
	                    "title": messages[button.name],
	                    "data-command": button.command,
	                    "data-options": button.options
	                })
	            });
	        },

	        _mapMenuButtons: function(button) {
	            var that = this,
	                messages = that.options.messages;

	            return kendo.deepExtend(button,{
	                text: messages[button.name],
	                attributes: extend({}, button.attributes, {
	                    "aria-label": messages[button.name],
	                    "title": messages[button.name],
	                    "data-command": button.command,
	                    "data-options": button.options
	                })
	            });
	        },

	        _click: function(ev) {
	            var command = $(ev.target).data("command"),
	                options = $(ev.target).data("options");

	            if (!command) {
	                return;
	            }

	            this.action({
	                command: command,
	                options: options
	            });
	        },

	        _change: function (ev) {
	            var command = $(ev.target).data("command"),
	                options = $(ev.target).data("options");

	            options = extend({}, options, { value: $(ev.target).val() });

	            if (!command) {
	                return;
	            }

	            this.action({
	                command: command,
	                options: options
	            });
	        },

	        isToolEnabled: function(toolName) {
	            var that = this,
	                options = that.options,
	                found = false;

	            for(var i = 0; i < options.items.length; i++) {
	                if (options.items[i].name == toolName) {
	                    found = true;
	                    break;
	                }
	            }

	            return options.items[toolName] || found;
	        },

	        action: function (args) {
	            this.trigger(ACTION, args);
	        },

	        destroy: function () {
	            if(this.fileManagerSearch) {
	                this.fileManagerSearch.destroy();
	            }

	            ToolBar.fn.destroy.call(this);
	        }
	    });

	    var SearchTool = Item.extend({
	        init: function(options, toolbar) {
	            var that = this,
	                element = $("<div class='k-filemanager-search-tool k-textbox'></div>"),
	                input = $("<input class='k-input' autocomplete='off' />"),
	                iconWrapper = $("<span class='k-input-icon'></span>"),
	                icon = $("<span />");

	            that.element = element;
	            that.input = input;
	            that.iconWrapper = iconWrapper;
	            that.icon = icon;
	            that.options = options;
	            that.options.type = "fileManagerSearch";
	            that.toolbar = toolbar;

	            that.attributes();
	            that.renderIcon();
	            that.addUidAttr();
	            that.addIdAttr();
	            that.addOverflowAttr();

	            that.input.attr({
	                placeholder: that.options.text,
	                title: that.options.text
	            });

	            that.iconWrapper.append(icon);

	            that.element.append(that.input).append(iconWrapper);

	            that._bindEvents();
	            that.toolbar.fileManagerSearch = that;
	        },
	        attributes: function () {
	            if (this.options.attributes) {
	                this.input.attr(this.options.attributes);
	            }
	        },
	        renderIcon: function() {
	            if (this.options.icon) {
	                this.icon.addClass("k-icon k-i-" + this.options.icon);
	            }
	        },
	        _bindEvents: function(){
	            this._inputHandler = proxy(this._input, this);
	            this.input.on("input" + NS, this._inputHandler);
	        },
	        _input: function (ev) {
	            this.toolbar.trigger(CHANGE, {target: ev.target});
	        },
	        destroy: function(){
	            this.element.off(NS);
	        }
	    });

	    kendo.toolbar.registerComponent("fileManagerSearch", SearchTool);

	    var FileManagerDetailsToggle = Item.extend({
	        init: function(options, toolbar) {
	            var that = this,
	                element = $("<div class='k-filemanager-details-toggle'></div>"),
	                label = $("<label>" + options.text + "</label>"),
	                switchElement = $("<input title='"+ options.text +"' />");

	            that.element = element;
	            that.input = switchElement;
	            that.label = label;
	            that.options = options;
	            that.toolbar = toolbar;

	            that.attributes();
	            that.addUidAttr();
	            that.addIdAttr();
	            that.addOverflowAttr();

	            that.element.append(that.label);
	            that.element.append(that.input);

	            that.switchInstance = new kendo.ui.Switch(that.input, {
	                change: proxy(that._change, that),
	                messages: {
	                    checked: toolbar.options.messages.detailsChecked,
	                    unchecked: toolbar.options.messages.detailsUnchecked
	                }
	            });

	            that.label.on(CLICK + NS, proxy(that._click, that));

	            that.toolbar.fileManagerDetailsToggle = that;
	        },
	        _change: function (ev) {
	            this.toolbar.trigger(CHANGE, { target: ev.sender.wrapper.parent() });
	        },
	        _click: function(ev) {
	            this.switchInstance.toggle();

	            this.toolbar.trigger(CHANGE, { target: $(ev.target).parent() });
	        },
	        destroy: function() {
	            this.element.off(NS);
	        }
	    });

	    kendo.toolbar.registerComponent("fileManagerDetailsToggle", FileManagerDetailsToggle);

	    extend(kendo.ui.filemanager, {
	        ToolBar: FileManagerToolBar
	    });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ }),

/***/ 1030:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nce5");

/***/ }),

/***/ 1031:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("HQQe");

/***/ })

/******/ });

/***/ }),

/***/ "880/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("hJx8");


/***/ }),

/***/ "8Fbg":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1248);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1248:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1249) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	    var __meta__ = { // jshint ignore:line
	        id: "form",
	        name: "Form",
	        category: "web",
	        description: "The Form widget.",
	        depends: [ "editable" ],
	        features: [{
	            id: "form-dropdowns",
	            name: "DropDowns",
	            description: "Support for DropDown editors",
	            depends: [ "autocomplete", "combobox", "multiselect", "dropdowntree", "multicolumncombobox" ]
	        }, {
	            id: "form-datepickers",
	            name: "DatePickers",
	            description: "Support for DatePicker editors",
	            depends: [ "dateinput", "datepicker", "datetimepicker", "timepicker" ]
	        }, {
	            id: "form-inputs",
	            name: "Inputs",
	            description: "Support for Input editors",
	            depends: [ "numerictextbox", "maskedtextbox", "switch", "rating", "slider", "colorpicker" ]
	        }, {
	            id: "form-editor",
	            name: "Editor",
	            description: "Support for Editor editor",
	            depends: [ "editor" ]
	        }]
	    };

	    (function($, undefined) {
	        var kendo = window.kendo,
	            ui = kendo.ui,
	            NS = ".kendoForm",
	            Widget = ui.Widget,
	            extend = $.extend,
	            proxy = $.proxy,
	            VALIDATE = "validate",
	            VALIDATEFIELD = "validateField",
	            VALIDATEINPUT = "validateInput",
	            CHANGE = "change",
	            CLICK = "click" + NS,
	            SUBMIT = "submit",
	            CLEAR = "clear",
	            MAX_WIDTH = "max-width",
	            SET = "set",
	            EQUAL_SET = "equalSet",
	            GROUP = "group",
	            ARIA_DESCRIBEDBY = "aria-describedby",
	            DATA_STOP = "data-stop",
	            DATA_ROLE = "data-role",
	            EDITABLE = "editable",
	            FORM = "form",
	            DOT = ".";

	        var formStyles = {
	            form: "k-widget k-form",
	            horizontal: "k-form-horizontal",
	            vertical: "",
	            field: "k-form-field",
	            fieldsContainer: "k-form-fields-container",
	            fieldWrap: "k-form-field-wrap",
	            fieldError: "k-form-field-error",
	            fieldHint: "k-form-hint",
	            fieldset: "k-form-fieldset",
	            layout: "k-form-layout",
	            legend: "k-form-legend",
	            label: "k-label k-form-label",
	            optional: "k-label-optional",
	            buttonsContainer: "k-form-buttons",
	            buttonsEnd: "k-buttons-end",
	            submit: "k-form-submit",
	            clear: "k-form-clear",
	            invalid: "k-invalid",
	            hidden: "k-hidden"
	        };

	        var formOrientation = {
	            horizontal: "horizontal",
	            vertical: "vertical"
	        };

	        var Form = Widget.extend({
	            init: function(element, options) {
	                var that = this;

	                Widget.fn.init.call(that, element, options);

	                that.options = kendo.deepExtend({}, that.options, options);

	                that._wrapper();

	                that._setFields();

	                that._setModel();

	                that._renderContainers();

	                that._renderButtons();

	                that._editable();

	                that._renderFieldsHints();

	                that._setEvents();
	            },

	            events: [
	                VALIDATEFIELD,
	                VALIDATE,
	                CHANGE,
	                SUBMIT,
	                CLEAR
	            ],

	            options: {
	                name: "Form",
	                orientation: formOrientation.vertical,
	                validatable: {
	                    validateOnBlur: true,
	                    validationSummary: false,
	                    errorTemplate: null
	                },
	                buttonsTemplate: null,
	                messages: {
	                    submit: "Submit",
	                    clear: "Clear",
	                    optional: "(Optional)"
	                },
	                layout: "",
	                grid: {},
	                formData: {},
	                items: [],
	                formatLabel: null,
	                focusFirst: false
	            },

	            _fieldTemplate: "<div class='#:styles.field#  #if (colSpan) { #  k-colspan-#:colSpan# # } #'>" +
	                                "# if (label) { # " +
	                                    "<label class='#:styles.label#' for='#:id#' id='#:id#-form-label'>" +
	                                        "# if (typeof label.encoded != 'undefined' && label.encoded === false) {#" +
	                                            "#= label.text || label #" +
	                                        "# } else { #" +
	                                            "#: label.text || label #" +
	                                        "# } #" +
	                                        "# if (label.optional) { # <span class='#:styles.optional#'>#:optional#</span>  #}#" +
	                                    "</label>" +
	                                "# } #"  +
	                                "<div class='k-form-field-wrap' data-container-for='#:field#'></div>" +
	                            "</div>",

	            _groupTemplate: "<fieldset class='#:styles.fieldset# #if (colSpan) { #  k-colspan-#:colSpan# # }#'>" +
	                                "<legend class='#:styles.legend#'>#:label.text || label #</legend>" +
	                            "</fieldset>",

	            _buttonsTemplate: "<button class='k-button k-primary #:styles.submit#' type='submit'>#:messages.submit#</button>" +
	                              "<button class='k-button #:styles.clear#'>#:messages.clear#</button>",

	            _errorTemplate:  "<span class='k-form-error' id='#=field#-form-error'><div>#=message#</div></span>",

	            _hintTemplate: "<div class='k-form-hint' id='#=id#-form-hint'><span>#=message#</span></div>",

	            _wrapper: function() {
	                var that = this,
	                    options = that.options,
	                    formStyles = Form.styles,
	                    width = options.width,
	                    height = options.height;

	                that.wrapper = that.element
	                    .addClass(formStyles.form)
	                    .addClass(formStyles[options.orientation]);

	                if (height) {
	                    that.wrapper.height(height);
	                }

	                if (width) {
	                    that.wrapper.css(MAX_WIDTH, width);
	                }

	                that.layoutWrapper = that._setupLayoutContainer(that.wrapper, {
	                    grid: options.grid,
	                    layout: options.layout
	                });
	            },

	            _flattenFields: function(fields) {
	                var items = [].concat(fields),
	                    item = items.shift(),
	                    result = [],
	                    push = [].push;

	                while (item) {
	                    if (item.items) {
	                        push.apply(items, item.items);
	                    } else {
	                        push.call(result, item);
	                    }

	                    item = items.shift();
	                }

	                return result;
	            },

	            _defaultLabel: function(fieldName) {
	                var that = this,
	                    customFormat = that.options.formatLabel;

	                if (!fieldName.length) {
	                    return;
	                }

	                if (kendo.isFunction(customFormat)) {
	                    return customFormat(fieldName);
	                }

	                return fieldName.split(/(.*[a-z])(?=[A-Z])/).join(" ").trim() + ":";
	            },

	            _formatLabel: function(field, label) {
	                var that = this,
	                    text = $.isPlainObject(label) ? label.text : label;

	                if (text !== undefined) {
	                    return label;
	                }

	                return that._defaultLabel(field);
	            },

	            _defaultFields: function() {
	                var that = this,
	                    options = that.options,
	                    formDataFields = Object.keys(options.formData || {}),
	                    itemFields = options.items || {},
	                    defaultFormDataFields = [],
	                    field;

	                if (itemFields.length) {
	                    return itemFields;
	                }

	                for (var i = 0; i < formDataFields.length; i += 1) {
	                    field = formDataFields[i];

	                    defaultFormDataFields.push({
	                        field: field,
	                        id: field
	                    });
	                }

	                return defaultFormDataFields;
	            },

	            _setFields: function () {
	                var that = this,
	                    defaultFields = that._flattenFields(that._defaultFields()),
	                    formData = that.options.formData || {},
	                    fieldInfo, fieldValue, type, editor, attributes;

	                that._fields = [];

	                for (var field in defaultFields) {
	                    fieldInfo = defaultFields[field];
	                    fieldValue = formData[fieldInfo.field];

	                    type = typeof fieldInfo.editor === "string" ? fieldInfo.editor :
	                        $.type(fieldValue ? kendo.parseDate(fieldValue.toString()) || fieldValue : fieldValue);

	                    editor = kendo.isFunction(fieldInfo.editor) ? fieldInfo.editor :
	                         ui.Editable.fn.options.editors[type] ? "" : fieldInfo.editor;

	                    attributes = {
	                        "aria-labelledby": fieldInfo.id || fieldInfo.field + "-form-label"
	                    };

	                    fieldInfo = extend(true, {}, fieldInfo, {
	                        id: fieldInfo.id || fieldInfo.field,
	                        name: fieldInfo.name || fieldInfo.field,
	                        type: type,
	                        editor: editor,
	                        attributes: attributes
	                    });

	                    that._fields[field] = fieldInfo;
	                }
	            },

	            _setModel: function() {
	                var that = this,
	                    options = that.options,
	                    formData = options.formData || {};

	                var MyModel = kendo.data.Model.define({ fields: that._fields });

	                that._model = new MyModel(formData);
	            },

	            _editable: function() {
	                var that = this,
	                    options = that.options,
	                    validatorOptions = that.options.validatable;

	                that._addEditableMvvmAttributes();

	                that.editable = that.wrapper.kendoEditable({
	                    model: that._model,
	                    fields: that._fields || [],
	                    validateOnBlur: validatorOptions.validateOnBlur,
	                    validationSummary: validatorOptions.validationSummary,
	                    errorTemplate: validatorOptions.errorTemplate || that._errorTemplate,
	                    clearContainer: false,
	                    skipFocus: !options.focusFirst,
	                    target: that
	                }).getKendoEditable();

	                that.validator = that.editable.validatable;

	                that._removeEditableMvvmAttributes();
	            },

	            _addEditableMvvmAttributes: function() {
	                // required for two mvvm bindable widgets on one element
	                this.wrapper.attr(DATA_ROLE, EDITABLE);
	            },

	            _removeEditableMvvmAttributes: function() {
	                // required for two mvvm bindable widgets on one element
	                this.wrapper
	                    .attr(DATA_STOP, true)
	                    .attr(DATA_ROLE, FORM);
	            },

	            _getItemTemplate: function(type) {
	                var that = this,
	                    template;

	                if (type === GROUP) {
	                    template = that._groupTemplate;
	                } else {
	                    template = that._fieldTemplate;
	                }

	                return template;
	            },

	            _renderField: function(item) {
	                var that = this,
	                    formStyles = Form.styles,
	                    renderedField;

	                renderedField = (kendo.template(that._fieldTemplate)({
	                    styles: formStyles,
	                    id: item.id || item.field || "",
	                    field: item.field || "",
	                    label: that._formatLabel(item.field, item.label),
	                    colSpan: item.colSpan || "",
	                    optional: that.options.messages.optional
	                }));

	                return renderedField;
	            },

	            _toggleFieldErrorState: function(element, state) {
	                var field = element.closest(DOT + formStyles.field);

	                if (field.length) {
	                    field.toggleClass(formStyles.fieldError, state);
	                }
	            },

	            _renderFieldsHints: function() {
	                var that = this,
	                    fields = that._fields,
	                    field, fieldWidgetInstance, fieldElement, hint;

	                for (var i = 0; i < fields.length; i += 1) {
	                    field = fields[i];
	                    fieldElement = that.wrapper.find("[name='" + field.name + "']");

	                    if (!fieldElement || !field.hint) {
	                        continue;
	                    }

	                    hint = $(kendo.template(that._hintTemplate)({ message: field.hint || "", id: field.id }));

	                    that._associateHintContainer(fieldElement, hint.attr("id"));

	                    fieldWidgetInstance = kendo.widgetInstance(fieldElement);
	                    if (fieldWidgetInstance) {
	                        fieldElement = fieldWidgetInstance.wrapper;
	                    }

	                    if (that.validator._errorsByName(field.name).length) {
	                        hint.toggleClass(formStyles.hidden);
	                        kendo.removeAttribute(fieldElement, ARIA_DESCRIBEDBY, hint.attr("id"));
	                    }

	                    hint.insertAfter(fieldElement);
	                }
	            },

	            _associateHintContainer: function(input, hintId) {
	                var nextFocusable = kendo.getWidgetFocusableElement(input);

	                if (!nextFocusable || !hintId) {
	                    return;
	                }

	                kendo.toggleAttribute(nextFocusable, ARIA_DESCRIBEDBY, hintId);
	            },

	            _toggleHint: function(element, state) {
	                var that = this,
	                    field = element.closest(DOT + formStyles.field),
	                    hint;

	                if (field.length) {
	                    hint = field.find(DOT + formStyles.fieldHint);

	                    if (hint.length) {
	                        hint.toggleClass(formStyles.hidden, state);
	                        that._associateHintContainer(element, hint.attr("id"));
	                    }
	                }
	            },

	            _renderGroup: function(item) {
	                var that = this,
	                    type = item.type,
	                    child, renderedGroup, fieldsContainer;

	                fieldsContainer = renderedGroup = $(kendo.template(that._getItemTemplate(type))({
	                    styles: formStyles,
	                    label: item.label || "",
	                    colSpan: item.colSpan
	                }));

	                fieldsContainer = that._setupLayoutContainer(renderedGroup, {
	                    grid: item.grid,
	                    layout: item.layout
	                }) || renderedGroup;

	                for (var i = 0; i < item.items.length; i += 1) {
	                    child = item.items[i];
	                    fieldsContainer.append(that._renderField(child));
	                }

	                return renderedGroup;
	            },

	            _renderContainers: function() {
	                var that = this,
	                    defaultFields = that._defaultFields(),
	                    columnsLayout = that.options.layout === "grid",
	                    targetContainer = columnsLayout ? that.layoutWrapper : that.wrapper,
	                    item, type, container;

	                for (var i = 0; i < defaultFields.length; i += 1) {
	                    item = defaultFields[i];
	                    type = item.type;

	                    if (type === GROUP) {
	                        container = that._renderGroup(item);
	                    } else {
	                        container = that._renderField(item);
	                    }

	                    targetContainer.append(container);
	                }
	            },

	            _renderButtons: function() {
	                var that = this,
	                    wrapper = that.wrapper,
	                    options = that.options,
	                    messages = options.messages,
	                    formStyles = Form.styles,
	                    isHorizontal = options.orientation === formOrientation.horizontal,
	                    buttonsContainer = wrapper.find(DOT + formStyles.buttonsContainer),
	                    buttonsTemplate;

	                if (!buttonsContainer.length) {
	                    buttonsContainer = $("<div />")
	                        .addClass(formStyles.buttonsContainer)
	                        .addClass(isHorizontal ? formStyles.buttonsEnd : "");
	                }

	                buttonsTemplate = options.buttonsTemplate !== null ? options.buttonsTemplate : that._buttonsTemplate;

	                buttonsContainer.append(kendo.template(buttonsTemplate)({
	                    styles: formStyles,
	                    messages: messages
	                }));

	                that.element.append(buttonsContainer);
	            },

	            _setupLayoutContainer: function(appendTarget, options) {
	                var layout = options.layout,
	                    grid = options.grid,
	                    layoutClassNames = [],
	                    layoutContainer;

	                if (typeof layout === "string" && layout !== "") {
	                    layoutContainer = $("<div></div>")
	                        .appendTo(appendTarget)
	                        .addClass(formStyles.layout);

	                    layoutClassNames.push("k-d-" + layout);
	                }

	                if (layout === "grid" && typeof grid === "object") {
	                    if (typeof grid.cols === "number") {
	                        layoutClassNames.push("k-grid-cols-" + grid.cols);
	                    } else if (typeof grid.cols === "string") {
	                        layoutContainer.css("grid-template-columns", grid.cols);
	                    }

	                    if (typeof grid.gutter === "number" || typeof grid.gutter === "string") {
	                        layoutContainer.css("grid-gap", grid.gutter);
	                    }
	                }

	                if (layoutContainer) {
	                    layoutContainer.addClass(layoutClassNames.join(" "));
	                }

	                return layoutContainer;
	            },

	            _setEvents: function() {
	                var that = this,
	                    validator = that.validator;

	                validator
	                    .bind(VALIDATEINPUT, proxy(that._validateField, that))
	                    .bind(VALIDATE, proxy(that._validate, that));

	                that.wrapper
	                    .on(SUBMIT + NS, proxy(that._submit, that))
	                    .on(CLEAR + NS, proxy(that._clear, that))
	                    .on(CLICK + NS, DOT + formStyles.clear, proxy(that._clear, that));

	                that._model.bind(CHANGE, proxy(that._change, that));
	            },

	            _validateField: function(ev) {
	                var that = this,
	                    data = {
	                        model: that._model.toJSON(),
	                        valid: ev.valid,
	                        field: ev.field,
	                        error: ev.error,
	                        input: ev.input
	                    };

	                that._toggleFieldErrorState(data.input, !data.valid);

	                that._toggleHint(data.input, !data.valid);

	                if(that.trigger(VALIDATEFIELD, data)){
	                    ev.preventDefault();
	                }
	            },

	            _validate: function(ev) {
	                var that = this,
	                    data = {
	                        model: that._model.toJSON(),
	                        valid: ev.valid,
	                        errors: ev.errors
	                    };

	                that.trigger(VALIDATE, data);
	            },

	            _change: function(ev) {
	                var that = this,
	                    field = ev.field,
	                    data = {
	                        field: field,
	                        value: that._model[field]
	                    };

	                that.trigger(CHANGE, data);
	            },

	            _submit: function(ev) {
	                var that = this,
	                    jsonModel = that._model.toJSON();

	                if(that.trigger(SUBMIT, { model: jsonModel })){
	                    ev.preventDefault();
	                }
	            },

	            _clear: function(ev) {
	                var that = this;

	                ev.preventDefault();

	                that.clear();

	                that.trigger(CLEAR);
	            },

	            validate: function() {
	                var that = this,
	                    validator = that.validator;

	                if (!validator) {
	                    return;
	                }

	                return validator.validate();
	            },

	            clear: function() {
	                var that = this,
	                    fields = that._fields,
	                    model = that._model,
	                    editable = that.editable,
	                    validateOnBlur = that.validator.options.validateOnBlur;

	                that.validator.reset();

	                if (validateOnBlur) {
	                    model
	                        .unbind(SET)
	                        .unbind(EQUAL_SET);
	                }

	                for(var i = 0; i < fields.length; i += 1) {
	                    var field = fields[i].field;
	                    var element = that.wrapper.find("[name='" + field + "']");
	                    var widgetInstance = kendo.widgetInstance(element);

	                    element.val("");

	                    if (widgetInstance) {
	                        widgetInstance.value(null);
	                    }

	                    that._toggleHint(element, false);

	                    if (typeof model[field] === "boolean") {
	                        element.val("false");
	                        model.set(field, false);
	                    } else {
	                        model.set(field, null);
	                    }
	                }

	                that.wrapper.find(DOT + formStyles.fieldError)
	                    .removeClass(formStyles.fieldError);

	                if (validateOnBlur) {
	                    model
	                        .bind(SET, editable._validateProxy)
	                        .bind(EQUAL_SET, editable._validateProxy);
	                }
	            },

	            setOptions: function(newOptions) {
	                var that = this;

	                that.destroy();

	                that.wrapper
	                    .removeClass(formStyles.horizontal)
	                    .removeAttr(DATA_STOP)
	                    .empty();

	                that.init(that.element, newOptions);
	            },

	            destroy: function() {
	                var that = this;

	                that.wrapper.off(NS);

	                Widget.fn.destroy.call(that.editable);

	                Widget.fn.destroy.call(that);

	                if (that.editable) {
	                    that.editable.destroy();
	                    that.editable = null;
	                }
	            }
	        });

	        ui.plugin(Form);

	        extend(true, Form, { styles: formStyles });

	  })(window.kendo.jQuery);

	  return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1249:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("9fcU");

/***/ })

/******/ });

/***/ }),

/***/ "8Iik":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var GroupStage = (function () {
    function GroupStage() {
        // we use a sequence variable so that each time we do a grouping, we don't
        // reuse the ids - otherwise the rowRenderer will confuse rowNodes between redraws
        // when it tries to animate between rows. we set to -1 as others row id 0 will be shared
        // with the other rows.
        this.groupIdSequence = new main_1.NumberSequence(1);
    }
    // when grouping, these items are of note:
    // rowNode.parent: RowNode: set to the parent
    // rowNode.childrenAfterGroup: RowNode[] = the direct children of this group
    // rowNode.childrenMapped: string=>RowNode = children mapped by group key (when groups) or an empty map if leaf group (this is then used by pivot)
    // for leaf groups, rowNode.childrenAfterGroup = rowNode.allLeafChildren;
    GroupStage.prototype.postConstruct = function () {
        this.usingTreeData = this.gridOptionsWrapper.isTreeData();
        if (this.usingTreeData) {
            this.getDataPath = this.gridOptionsWrapper.getDataPathFunc();
            if (main_1._.missing(this.getDataPath)) {
                console.warn('ag-Grid: property usingTreeData=true, but you did not provide getDataPath function, please provide getDataPath function if using tree data.');
            }
        }
    };
    GroupStage.prototype.execute = function (params) {
        var details = this.createGroupingDetails(params);
        if (details.transaction) {
            this.handleTransaction(details);
        }
        else {
            this.shotgunResetEverything(details);
        }
    };
    GroupStage.prototype.createGroupingDetails = function (params) {
        var rowNode = params.rowNode, changedPath = params.changedPath, rowNodeTransaction = params.rowNodeTransaction, rowNodeOrder = params.rowNodeOrder;
        var groupedCols = this.usingTreeData ? null : this.columnController.getRowGroupColumns();
        var isGrouping = this.usingTreeData || groupedCols.length > 0;
        var usingTransaction = isGrouping && main_1._.exists(rowNodeTransaction);
        var details = {
            // someone complained that the parent attribute was causing some change detection
            // to break is some angular add-on - which i never used. taking the parent out breaks
            // a cyclic dependency, hence this flag got introduced.
            includeParents: !this.gridOptionsWrapper.isSuppressParentsInRowNodes(),
            expandByDefault: this.gridOptionsWrapper.isGroupSuppressRow() ?
                -1 : this.gridOptionsWrapper.getGroupDefaultExpanded(),
            groupedCols: groupedCols,
            rootNode: rowNode,
            pivotMode: this.columnController.isPivotMode(),
            groupedColCount: this.usingTreeData ? 0 : groupedCols.length,
            rowNodeOrder: rowNodeOrder,
            // important not to do transaction if we are not grouping, as otherwise the 'insert index' is ignored.
            // ie, if not grouping, then we just want to shotgun so the rootNode.allLeafChildren gets copied
            // to rootNode.childrenAfterGroup and maintaining order (as delta transaction misses the order).
            transaction: usingTransaction ? rowNodeTransaction : null,
            // if no transaction, then it's shotgun, so no changed path
            changedPath: usingTransaction ? changedPath : null
        };
        return details;
    };
    GroupStage.prototype.handleTransaction = function (details) {
        var tran = details.transaction;
        if (tran.add) {
            this.insertNodes(tran.add, details);
        }
        if (tran.update) {
            this.moveNodesInWrongPath(tran.update, details);
        }
        if (tran.remove) {
            this.removeNodes(tran.remove, details);
        }
        if (details.rowNodeOrder) {
            this.recursiveSortChildren(details.rootNode, details);
        }
    };
    // this is used when doing delta updates, eg Redux, keeps nodes in right order
    GroupStage.prototype.recursiveSortChildren = function (node, details) {
        var _this = this;
        main_1._.sortRowNodesByOrder(node.childrenAfterGroup, details.rowNodeOrder);
        node.childrenAfterGroup.forEach(function (childNode) {
            if (childNode.childrenAfterGroup) {
                _this.recursiveSortChildren(childNode, details);
            }
        });
    };
    GroupStage.prototype.getExistingPathForNode = function (node, details) {
        var res = [];
        // when doing tree data, the node is part of the path,
        // but when doing grid grouping, the node is not part of the path so we start with the parent.
        var pointer = this.usingTreeData ? node : node.parent;
        while (pointer !== details.rootNode) {
            res.push({
                key: pointer.key,
                rowGroupColumn: pointer.rowGroupColumn,
                field: pointer.field
            });
            pointer = pointer.parent;
        }
        res.reverse();
        return res;
    };
    GroupStage.prototype.moveNodesInWrongPath = function (childNodes, details) {
        var _this = this;
        childNodes.forEach(function (childNode) {
            // we add node, even if parent has not changed, as the data could have
            // changed, hence aggregations will be wrong
            if (details.changedPath) {
                details.changedPath.addParentNode(childNode.parent);
            }
            var infoToKeyMapper = function (item) { return item.key; };
            var oldPath = _this.getExistingPathForNode(childNode, details).map(infoToKeyMapper);
            var newPath = _this.getGroupInfo(childNode, details).map(infoToKeyMapper);
            var nodeInCorrectPath = main_1._.compareArrays(oldPath, newPath);
            if (!nodeInCorrectPath) {
                _this.moveNode(childNode, details);
            }
        });
    };
    GroupStage.prototype.moveNode = function (childNode, details) {
        this.removeOneNode(childNode, details);
        this.insertOneNode(childNode, details);
        // hack - if we didn't do this, then renaming a tree item (ie changing rowNode.key) wouldn't get
        // refreshed into the gui.
        // this is needed to kick off the event that rowComp listens to for refresh. this in turn
        // then will get each cell in the row to refresh - which is what we need as we don't know which
        // columns will be displaying the rowNode.key info.
        childNode.setData(childNode.data);
        // we add both old and new parents to changed path, as both will need to be refreshed.
        // we already added the old parent (in calling method), so just add the new parent here
        if (details.changedPath) {
            var newParent = childNode.parent;
            details.changedPath.addParentNode(newParent);
        }
    };
    GroupStage.prototype.removeNodes = function (leafRowNodes, details) {
        var _this = this;
        leafRowNodes.forEach(function (leafToRemove) {
            _this.removeOneNode(leafToRemove, details);
            if (details.changedPath) {
                details.changedPath.addParentNode(leafToRemove.parent);
            }
        });
    };
    GroupStage.prototype.removeOneNode = function (childNode, details) {
        var _this = this;
        // utility func to execute once on each parent node
        var forEachParentGroup = function (callback) {
            var pointer = childNode.parent;
            while (pointer !== details.rootNode) {
                callback(pointer);
                pointer = pointer.parent;
            }
        };
        // remove leaf from direct parent
        this.removeFromParent(childNode);
        // remove from allLeafChildren
        forEachParentGroup(function (parentNode) { return main_1._.removeFromArray(parentNode.allLeafChildren, childNode); });
        // if not group, and children are present, need to move children to a group.
        // otherwise if no children, we can just remove without replacing.
        var replaceWithGroup = childNode.hasChildren();
        if (replaceWithGroup) {
            var oldPath = this.getExistingPathForNode(childNode, details);
            // because we just removed the userGroup, this will always return new support group
            var newGroupNode_1 = this.findParentForNode(childNode, oldPath, details);
            // these properties are the ones that will be incorrect in the newly created group,
            // so copy them form the old childNode
            newGroupNode_1.expanded = childNode.expanded;
            newGroupNode_1.allLeafChildren = childNode.allLeafChildren;
            newGroupNode_1.childrenAfterGroup = childNode.childrenAfterGroup;
            newGroupNode_1.childrenMapped = childNode.childrenMapped;
            newGroupNode_1.childrenAfterGroup.forEach(function (rowNode) { return rowNode.parent = newGroupNode_1; });
        }
        // remove empty groups
        forEachParentGroup(function (node) {
            if (node.isEmptyFillerNode()) {
                _this.removeFromParent(node);
                // we remove selection on filler nodes here, as the selection would not be removed
                // from the RowNodeManager, as filler nodes don't exist on teh RowNodeManager
                node.setSelected(false);
            }
        });
    };
    GroupStage.prototype.removeFromParent = function (child) {
        main_1._.removeFromArray(child.parent.childrenAfterGroup, child);
        var mapKey = this.getChildrenMappedKey(child.key, child.rowGroupColumn);
        child.parent.childrenMapped[mapKey] = undefined;
        // this is important for transition, see rowComp removeFirstPassFuncs. when doing animation and
        // remove, if rowTop is still present, the rowComp thinks it's just moved position.
        child.setRowTop(null);
    };
    GroupStage.prototype.addToParent = function (child, parent) {
        var mapKey = this.getChildrenMappedKey(child.key, child.rowGroupColumn);
        parent.childrenMapped[mapKey] = child;
        parent.childrenAfterGroup.push(child);
    };
    GroupStage.prototype.shotgunResetEverything = function (details) {
        // because we are not creating the root node each time, we have the logic
        // here to change leafGroup once.
        // we set .leafGroup to false for tree data, as .leafGroup is only used when pivoting, and pivoting
        // isn't allowed with treeData, so the grid never actually use .leafGroup when doing treeData.
        details.rootNode.leafGroup = this.usingTreeData ? false : details.groupedCols.length === 0;
        // we are going everything from scratch, so reset childrenAfterGroup and childrenMapped from the rootNode
        details.rootNode.childrenAfterGroup = [];
        details.rootNode.childrenMapped = {};
        this.insertNodes(details.rootNode.allLeafChildren, details);
    };
    GroupStage.prototype.insertNodes = function (newRowNodes, details) {
        var _this = this;
        newRowNodes.forEach(function (rowNode) {
            _this.insertOneNode(rowNode, details);
            if (details.changedPath) {
                details.changedPath.addParentNode(rowNode.parent);
            }
        });
    };
    GroupStage.prototype.insertOneNode = function (childNode, details) {
        var path = this.getGroupInfo(childNode, details);
        var parentGroup = this.findParentForNode(childNode, path, details);
        if (!parentGroup.group) {
            console.warn("ag-Grid: duplicate group keys for row data, keys should be unique", [parentGroup.data, childNode.data]);
        }
        if (this.usingTreeData) {
            this.swapGroupWithUserNode(parentGroup, childNode);
        }
        else {
            childNode.parent = parentGroup;
            childNode.level = path.length;
            parentGroup.childrenAfterGroup.push(childNode);
        }
    };
    GroupStage.prototype.findParentForNode = function (childNode, path, details) {
        var _this = this;
        var nextNode = details.rootNode;
        path.forEach(function (groupInfo, level) {
            nextNode = _this.getOrCreateNextNode(nextNode, groupInfo, level, details);
            // node gets added to all group nodes.
            // note: we do not add to rootNode here, as the rootNode is the master list of rowNodes
            nextNode.allLeafChildren.push(childNode);
        });
        return nextNode;
    };
    GroupStage.prototype.swapGroupWithUserNode = function (fillerGroup, userGroup) {
        userGroup.parent = fillerGroup.parent;
        userGroup.key = fillerGroup.key;
        userGroup.field = fillerGroup.field;
        userGroup.groupData = fillerGroup.groupData;
        userGroup.level = fillerGroup.level;
        userGroup.expanded = fillerGroup.expanded;
        // we set .leafGroup to false for tree data, as .leafGroup is only used when pivoting, and pivoting
        // isn't allowed with treeData, so the grid never actually use .leafGroup when doing treeData.
        userGroup.leafGroup = fillerGroup.leafGroup;
        // always null for userGroups, as row grouping is not allowed when doing tree data
        userGroup.rowGroupIndex = fillerGroup.rowGroupIndex;
        userGroup.allLeafChildren = fillerGroup.allLeafChildren;
        userGroup.childrenAfterGroup = fillerGroup.childrenAfterGroup;
        userGroup.childrenMapped = fillerGroup.childrenMapped;
        this.removeFromParent(fillerGroup);
        userGroup.childrenAfterGroup.forEach(function (rowNode) { return rowNode.parent = userGroup; });
        this.addToParent(userGroup, fillerGroup.parent);
    };
    GroupStage.prototype.getOrCreateNextNode = function (parentGroup, groupInfo, level, details) {
        var mapKey = this.getChildrenMappedKey(groupInfo.key, groupInfo.rowGroupColumn);
        var nextNode = parentGroup.childrenMapped[mapKey];
        if (!nextNode) {
            nextNode = this.createGroup(groupInfo, parentGroup, level, details);
            // attach the new group to the parent
            this.addToParent(nextNode, parentGroup);
        }
        return nextNode;
    };
    GroupStage.prototype.createGroup = function (groupInfo, parent, level, details) {
        var _this = this;
        var groupNode = new main_1.RowNode();
        this.context.wireBean(groupNode);
        groupNode.group = true;
        groupNode.field = groupInfo.field;
        groupNode.rowGroupColumn = groupInfo.rowGroupColumn;
        groupNode.groupData = {};
        var groupDisplayCols = this.columnController.getGroupDisplayColumns();
        groupDisplayCols.forEach(function (col) {
            // newGroup.rowGroupColumn=null when working off GroupInfo, and we always display the group in the group column
            // if rowGroupColumn is present, then it's grid row grouping and we only include if configuration says so
            var displayGroupForCol = _this.usingTreeData || col.isRowGroupDisplayed(groupNode.rowGroupColumn.getId());
            if (displayGroupForCol) {
                groupNode.groupData[col.getColId()] = groupInfo.key;
            }
        });
        // we use negative number for the ids of the groups, this makes sure we don't clash with the
        // id's of the leaf nodes.
        groupNode.id = (this.groupIdSequence.next() * -1).toString();
        groupNode.key = groupInfo.key;
        groupNode.level = level;
        groupNode.leafGroup = this.usingTreeData ? false : level === (details.groupedColCount - 1);
        // if doing pivoting, then the leaf group is never expanded,
        // as we do not show leaf rows
        if (details.pivotMode && groupNode.leafGroup) {
            groupNode.expanded = false;
        }
        else {
            groupNode.expanded = this.isExpanded(details.expandByDefault, level);
        }
        groupNode.allLeafChildren = [];
        // why is this done here? we are not updating the children could as we go,
        // i suspect this is updated in the filter stage
        groupNode.setAllChildrenCount(0);
        groupNode.rowGroupIndex = this.usingTreeData ? null : level;
        groupNode.childrenAfterGroup = [];
        groupNode.childrenMapped = {};
        groupNode.parent = details.includeParents ? parent : null;
        return groupNode;
    };
    GroupStage.prototype.getChildrenMappedKey = function (key, rowGroupColumn) {
        if (rowGroupColumn) {
            // grouping by columns
            return rowGroupColumn.getId() + '-' + key;
        }
        else {
            // tree data - we don't have rowGroupColumns
            return key;
        }
    };
    GroupStage.prototype.isExpanded = function (expandByDefault, level) {
        if (expandByDefault === -1) {
            return true;
        }
        else {
            return level < expandByDefault;
        }
    };
    GroupStage.prototype.getGroupInfo = function (rowNode, details) {
        if (this.usingTreeData) {
            return this.getGroupInfoFromCallback(rowNode);
        }
        else {
            return this.getGroupInfoFromGroupColumns(rowNode, details);
        }
    };
    GroupStage.prototype.getGroupInfoFromCallback = function (rowNode) {
        var keys = this.getDataPath(rowNode.data);
        if (keys === null || keys === undefined || keys.length === 0) {
            main_1._.doOnce(function () { return console.warn("getDataPath() should not return an empty path for data", rowNode.data); }, 'groupStage.getGroupInfoFromCallback');
        }
        var groupInfoMapper = function (key) { return ({ key: key, field: null, rowGroupColumn: null }); };
        return keys ? keys.map(groupInfoMapper) : [];
    };
    GroupStage.prototype.getGroupInfoFromGroupColumns = function (rowNode, details) {
        var _this = this;
        var res = [];
        details.groupedCols.forEach(function (groupCol) {
            var key = _this.valueService.getKeyForNode(groupCol, rowNode);
            var keyExists = key !== null && key !== undefined;
            // unbalanced tree and pivot mode don't work together - not because of the grid, it doesn't make
            // mathematical sense as you are building up a cube. so if pivot mode, we put in a blank key where missing.
            // this keeps the tree balanced and hence can be represented as a group.
            if (details.pivotMode && !keyExists) {
                key = ' ';
                keyExists = true;
            }
            if (keyExists) {
                var item = {
                    key: key,
                    field: groupCol.getColDef().field,
                    rowGroupColumn: groupCol
                };
                res.push(item);
            }
        });
        return res;
    };
    __decorate([
        main_1.Autowired('selectionController'),
        __metadata("design:type", main_1.SelectionController)
    ], GroupStage.prototype, "selectionController", void 0);
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], GroupStage.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        main_1.Autowired('columnController'),
        __metadata("design:type", main_1.ColumnController)
    ], GroupStage.prototype, "columnController", void 0);
    __decorate([
        main_1.Autowired('valueService'),
        __metadata("design:type", main_1.ValueService)
    ], GroupStage.prototype, "valueService", void 0);
    __decorate([
        main_1.Autowired('eventService'),
        __metadata("design:type", main_1.EventService)
    ], GroupStage.prototype, "eventService", void 0);
    __decorate([
        main_1.Autowired('context'),
        __metadata("design:type", main_1.Context)
    ], GroupStage.prototype, "context", void 0);
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], GroupStage.prototype, "postConstruct", null);
    GroupStage = __decorate([
        main_1.Bean('groupStage')
    ], GroupStage);
    return GroupStage;
}());
exports.GroupStage = GroupStage;


/***/ }),

/***/ "8wuL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var rowNode_1 = __webpack_require__("bP2e");
var beanStub_1 = __webpack_require__("xffp");
var RowNodeBlock = (function (_super) {
    __extends(RowNodeBlock, _super);
    function RowNodeBlock(blockNumber, rowNodeCacheParams) {
        var _this = _super.call(this) || this;
        _this.version = 0;
        _this.state = RowNodeBlock.STATE_DIRTY;
        _this.rowNodeCacheParams = rowNodeCacheParams;
        _this.blockNumber = blockNumber;
        // we don't need to calculate these now, as the inputs don't change,
        // however it makes the code easier to read if we work them out up front
        _this.startRow = blockNumber * rowNodeCacheParams.blockSize;
        _this.endRow = _this.startRow + rowNodeCacheParams.blockSize;
        return _this;
    }
    RowNodeBlock.prototype.isAnyNodeOpen = function (rowCount) {
        var result = false;
        this.forEachNodeCallback(function (rowNode) {
            if (rowNode.expanded) {
                result = true;
            }
        }, rowCount);
        return result;
    };
    RowNodeBlock.prototype.forEachNodeCallback = function (callback, rowCount) {
        for (var rowIndex = this.startRow; rowIndex < this.endRow; rowIndex++) {
            // we check against rowCount as this page may be the last one, and if it is, then
            // the last rows are not part of the set
            if (rowIndex < rowCount) {
                var rowNode = this.getRowUsingLocalIndex(rowIndex);
                callback(rowNode, rowIndex);
            }
        }
    };
    RowNodeBlock.prototype.forEachNode = function (callback, sequence, rowCount, deep) {
        this.forEachNodeCallback(function (rowNode) {
            callback(rowNode, sequence.next());
            // this will only every happen for enterprise row model, as infinite
            // row model doesn't have groups
            if (deep && rowNode.childrenCache) {
                rowNode.childrenCache.forEachNodeDeep(callback, sequence);
            }
        }, rowCount);
    };
    RowNodeBlock.prototype.forEachNodeDeep = function (callback, sequence, rowCount) {
        this.forEachNode(callback, sequence, rowCount, true);
    };
    RowNodeBlock.prototype.forEachNodeShallow = function (callback, sequence, rowCount) {
        this.forEachNode(callback, sequence, rowCount, false);
    };
    RowNodeBlock.prototype.getVersion = function () {
        return this.version;
    };
    RowNodeBlock.prototype.getLastAccessed = function () {
        return this.lastAccessed;
    };
    RowNodeBlock.prototype.getRowUsingLocalIndex = function (rowIndex) {
        this.lastAccessed = this.rowNodeCacheParams.lastAccessedSequence.next();
        var localIndex = rowIndex - this.startRow;
        return this.rowNodes[localIndex];
    };
    RowNodeBlock.prototype.init = function (beans) {
        this.beans = beans;
        this.createRowNodes();
    };
    RowNodeBlock.prototype.getStartRow = function () {
        return this.startRow;
    };
    RowNodeBlock.prototype.getEndRow = function () {
        return this.endRow;
    };
    RowNodeBlock.prototype.getBlockNumber = function () {
        return this.blockNumber;
    };
    RowNodeBlock.prototype.setDirty = function () {
        // in case any current loads in progress, this will have their results ignored
        this.version++;
        this.state = RowNodeBlock.STATE_DIRTY;
    };
    RowNodeBlock.prototype.setDirtyAndPurge = function () {
        this.setDirty();
        this.rowNodes.forEach(function (rowNode) {
            rowNode.setData(null);
        });
    };
    RowNodeBlock.prototype.getState = function () {
        return this.state;
    };
    RowNodeBlock.prototype.setRowNode = function (rowIndex, rowNode) {
        var localIndex = rowIndex - this.startRow;
        this.rowNodes[localIndex] = rowNode;
    };
    RowNodeBlock.prototype.setBlankRowNode = function (rowIndex) {
        var localIndex = rowIndex - this.startRow;
        var newRowNode = this.createBlankRowNode(rowIndex);
        this.rowNodes[localIndex] = newRowNode;
        return newRowNode;
    };
    RowNodeBlock.prototype.setNewData = function (rowIndex, dataItem) {
        var newRowNode = this.setBlankRowNode(rowIndex);
        this.setDataAndId(newRowNode, dataItem, this.startRow + rowIndex);
        return newRowNode;
    };
    RowNodeBlock.prototype.createBlankRowNode = function (rowIndex) {
        var rowNode = new rowNode_1.RowNode();
        this.beans.context.wireBean(rowNode);
        rowNode.setRowHeight(this.rowNodeCacheParams.rowHeight);
        return rowNode;
    };
    // creates empty row nodes, data is missing as not loaded yet
    RowNodeBlock.prototype.createRowNodes = function () {
        this.rowNodes = [];
        for (var i = 0; i < this.rowNodeCacheParams.blockSize; i++) {
            var rowIndex = this.startRow + i;
            var rowNode = this.createBlankRowNode(rowIndex);
            this.rowNodes.push(rowNode);
        }
    };
    RowNodeBlock.prototype.load = function () {
        this.state = RowNodeBlock.STATE_LOADING;
        this.loadFromDatasource();
    };
    RowNodeBlock.prototype.pageLoadFailed = function () {
        this.state = RowNodeBlock.STATE_FAILED;
        var event = {
            type: RowNodeBlock.EVENT_LOAD_COMPLETE,
            success: false,
            page: this,
            lastRow: null
        };
        this.dispatchEvent(event);
    };
    RowNodeBlock.prototype.populateWithRowData = function (rows) {
        var _this = this;
        var rowNodesToRefresh = [];
        this.rowNodes.forEach(function (rowNode, index) {
            var data = rows[index];
            if (rowNode.stub) {
                rowNodesToRefresh.push(rowNode);
            }
            _this.setDataAndId(rowNode, data, _this.startRow + index);
        });
        if (rowNodesToRefresh.length > 0) {
            this.beans.rowRenderer.redrawRows(rowNodesToRefresh);
        }
    };
    RowNodeBlock.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.rowNodes.forEach(function (rowNode) {
            if (rowNode.childrenCache) {
                rowNode.childrenCache.destroy();
                rowNode.childrenCache = null;
            }
            // this is needed, so row render knows to fade out the row, otherwise it
            // see's row top is present, and thinks the row should be shown. maybe
            // rowNode should have a flag on whether it is visible???
            rowNode.clearRowTop();
        });
    };
    RowNodeBlock.prototype.pageLoaded = function (version, rows, lastRow) {
        // we need to check the version, in case there was an old request
        // from the server that was sent before we refreshed the cache,
        // if the load was done as a result of a cache refresh
        if (version === this.version) {
            this.state = RowNodeBlock.STATE_LOADED;
            this.populateWithRowData(rows);
        }
        lastRow = utils_1.Utils.cleanNumber(lastRow);
        // check here if lastrow should be set
        var event = {
            type: RowNodeBlock.EVENT_LOAD_COMPLETE,
            success: true,
            page: this,
            lastRow: lastRow
        };
        this.dispatchEvent(event);
    };
    RowNodeBlock.EVENT_LOAD_COMPLETE = 'loadComplete';
    RowNodeBlock.STATE_DIRTY = 'dirty';
    RowNodeBlock.STATE_LOADING = 'loading';
    RowNodeBlock.STATE_LOADED = 'loaded';
    RowNodeBlock.STATE_FAILED = 'failed';
    return RowNodeBlock;
}(beanStub_1.BeanStub));
exports.RowNodeBlock = RowNodeBlock;


/***/ }),

/***/ "94VQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("Yobk");
var descriptor = __webpack_require__("X8DO");
var setToStringTag = __webpack_require__("e6n0");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("hJx8")(IteratorPrototype, __webpack_require__("dSzd")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "9598":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__("ungA");

var _DropDownListProps = __webpack_require__("yu0z");

var _DropDownListProps2 = _interopRequireDefault(_DropDownListProps);

var _Animation = __webpack_require__("dGGS");

var _Animation2 = _interopRequireDefault(_Animation);

var _Popup = __webpack_require__("rQ4N");

var _Popup2 = _interopRequireDefault(_Popup);

var _Virtual = __webpack_require__("ZSoY");

var _Virtual2 = _interopRequireDefault(_Virtual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: _DropDownListProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _Animation2.default, _Popup2.default, _Virtual2.default],
    model: {
        event: 'changemodel'
    },
    mounted: function mounted() {
        var that = this;
        var widgetElement = that.$el;

        kendo.jQuery(widgetElement).kendoDropDownList(that.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', widgetElement.value);
            } else {
                that.$emit('changemodel', widgetElement.value);
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            var widgetElement = this.$el;

            return kendo.jQuery(widgetElement).getKendoDropDownList();
        }
    }
};

/***/ }),

/***/ "99zt":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1335);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FZAa");

/***/ }),

/***/ 1289:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("5AFk");

/***/ }),

/***/ 1335:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1088), __webpack_require__(1289) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "numerictextbox",
	    name: "NumericTextBox",
	    category: "web",
	    description: "The NumericTextBox widget can format and display numeric, percentage or currency textbox.",
	    depends: [ "core", "userevents", "floatinglabel" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        caret = kendo.caret,
	        keys = kendo.keys,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        activeElement = kendo._activeElement,
	        extractFormat = kendo._extractFormat,
	        parse = kendo.parseFloat,
	        placeholderSupported = kendo.support.placeholder,
	        getCulture = kendo.getCulture,
	        CHANGE = "change",
	        DISABLED = "disabled",
	        READONLY = "readonly",
	        INPUT = "k-input",
	        SPIN = "spin",
	        ns = ".kendoNumericTextBox",
	        TOUCHEND = "touchend",
	        MOUSELEAVE = "mouseleave" + ns,
	        HOVEREVENTS = "mouseenter" + ns + " " + MOUSELEAVE,
	        DEFAULT = "k-state-default",
	        FOCUSED = "k-state-focused",
	        HOVER = "k-state-hover",
	        FOCUS = "focus",
	        POINT = ".",
	        CLASS_ICON = "k-icon",
	        LABELCLASSES = "k-label k-input-label",
	        SELECTED = "k-state-selected",
	        STATEDISABLED = "k-state-disabled",
	        STATE_INVALID = "k-state-invalid",
	        ARIA_DISABLED = "aria-disabled",
	        INTEGER_REGEXP = /^(-)?(\d*)$/,
	        NULL = null,
	        proxy = $.proxy,
	        isPlainObject = $.isPlainObject,
	        extend = $.extend;

	    var NumericTextBox = Widget.extend({
	         init: function(element, options) {
	             var that = this,
	             isStep = options && options.step !== undefined,
	             min, max, step, value, disabled;
	             var inputType;

	             Widget.fn.init.call(that, element, options);

	             options = that.options;
	             element = that.element
	                           .on("focusout" + ns, proxy(that._focusout, that))
	                           .attr("role", "spinbutton");

	             options.placeholder = options.placeholder || element.attr("placeholder");

	             min = that.min(element.attr("min"));
	             max = that.max(element.attr("max"));
	             step = that._parse(element.attr("step"));

	             if (options.min === NULL && min !== NULL) {
	                 options.min = min;
	             }

	             if (options.max === NULL && max !== NULL) {
	                 options.max = max;
	             }

	             if (!isStep && step !== NULL) {
	                 options.step = step;
	             }

	             that._initialOptions = extend({}, options);

	             inputType = element.attr("type");

	             that._reset();
	             that._wrapper();
	             that._arrows();
	             that._validation();
	             that._input();

	             if (!kendo.support.mobileOS) {
	                 that._text.on(FOCUS + ns, proxy(that._click, that));
	             } else {
	                 that._text.on(TOUCHEND + ns + " " + FOCUS + ns, function() {
	                     if (kendo.support.browser.edge) {
	                         that._text.one(FOCUS + ns, function() {
	                             that._toggleText(false);
	                             element.focus();
	                         });
	                     } else {
	                         that._toggleText(false);
	                         element.focus();
	                     }
	                     that.selectValue();
	                 });
	             }

	             element.attr("aria-valuemin", options.min !== NULL ? options.min*options.factor : options.min)
	                    .attr("aria-valuemax", options.max !== NULL ? options.max*options.factor : options.max);

	             options.format = extractFormat(options.format);

	             value = options.value;

	             if (value == NULL) {
	                 if (inputType == "number") {
	                    value = parseFloat(element.val());
	                 } else {
	                     value = element.val();
	                 }
	             }

	             that.value(value);

	             disabled = !options.enable || element.is("[disabled]") || $(that.element).parents("fieldset").is(':disabled');

	             if (disabled) {
	                 that.enable(false);
	             } else {
	                 that.readonly(element.is("[readonly]"));
	             }

	             that.angular("compile", function(){
	                 return {
	                     elements: that._text.get()
	                 };
	             });

	             that._label();

	             kendo.notify(that);
	         },

	        options: {
	            name: "NumericTextBox",
	            decimals: NULL,
	            enable: true,
	            restrictDecimals: false,
	            min: NULL,
	            max: NULL,
	            value: NULL,
	            step: 1,
	            round: true,
	            culture: "",
	            format: "n",
	            spinners: true,
	            placeholder: "",
	            factor: 1,
	            upArrowText: "Increase value",
	            downArrowText: "Decrease value",
	            label: null
	        },
	        events: [
	            CHANGE,
	            SPIN
	        ],

	        _editable: function(options) {
	            var that = this,
	                element = that.element,
	                disable = options.disable,
	                readonly = options.readonly,
	                text = that._text.add(element),
	                wrapper = that._inputWrapper.off(HOVEREVENTS);

	            that._toggleText(true);

	            that._upArrowEventHandler.unbind("press");
	            that._downArrowEventHandler.unbind("press");
	            element
	                .off("keydown" + ns)
	                .off("keyup" + ns)
	                .off("input" + ns)
	                .off("paste" + ns);

	            if (that._inputLabel) {
	                that._inputLabel.off(ns);
	            }

	            if (!readonly && !disable) {
	                wrapper
	                    .addClass(DEFAULT)
	                    .removeClass(STATEDISABLED)
	                    .on(HOVEREVENTS, that._toggleHover);

	                text.removeAttr(DISABLED)
	                    .removeAttr(READONLY)
	                    .attr(ARIA_DISABLED, false);

	                that._upArrowEventHandler.bind("press", function(e) {
	                    e.preventDefault();
	                    that._spin(1);
	                    that._upArrow.addClass(SELECTED);
	                });

	                that._downArrowEventHandler.bind("press", function(e) {
	                    e.preventDefault();
	                    that._spin(-1);
	                    that._downArrow.addClass(SELECTED);
	                });

	                that.element
	                    .on("keydown" + ns, proxy(that._keydown, that))
	                    .on("keyup" + ns, proxy(that._keyup, that))
	                    .on("paste" + ns, proxy(that._paste, that))
	                    .on("input" + ns, proxy(that._inputHandler, that));

	                if (that._inputLabel) {
	                    that._inputLabel.on("click" + ns, proxy(that.focus, that));
	                }

	            } else {
	                wrapper
	                    .addClass(disable ? STATEDISABLED : DEFAULT)
	                    .removeClass(disable ? DEFAULT : STATEDISABLED);

	                text.attr(DISABLED, disable)
	                    .attr(READONLY, readonly)
	                    .attr(ARIA_DISABLED, disable);
	            }
	        },

	        readonly: function(readonly) {
	            var that = this;

	            this._editable({
	                readonly: readonly === undefined ? true : readonly,
	                disable: false
	            });

	            if (that.floatingLabel) {
	                that.floatingLabel.readonly(readonly === undefined ? true : readonly);
	            }
	        },

	        enable: function(enable) {
	            var that = this;

	            this._editable({
	                readonly: false,
	                disable: !(enable = enable === undefined ? true : enable)
	            });

	            if (that.floatingLabel) {
	                that.floatingLabel.enable(enable = enable === undefined ? true : enable);
	            }
	        },

	        setOptions: function (options) {
	            var that = this;
	            Widget.fn.setOptions.call(that, options);

	            that._arrowsWrap.toggle(that.options.spinners);
	            that._inputWrapper.toggleClass("k-expand-padding", !that.options.spinners);
	            that._text.prop("placeholder", that.options.placeholder);
	            that._placeholder(that.options.placeholder);
	            that.element.attr({
	                "aria-valuemin": that.options.min !== NULL ? that.options.min*that.options.factor : that.options.min,
	                "aria-valuemax": that.options.max !== NULL ? that.options.max*that.options.factor : that.options.max
	            });

	            that.options.format = extractFormat(that.options.format);

	            if (options.value !== undefined) {
	                that.value(options.value);
	            }
	        },

	        destroy: function() {
	            var that = this;

	            if (that._inputLabel) {
	                that._inputLabel.off(ns);

	                if (that.floatingLabel) {
	                    that.floatingLabel.destroy();
	                }
	            }

	            that.element
	                .add(that._text)
	                .add(that._upArrow)
	                .add(that._downArrow)
	                .add(that._inputWrapper)
	                .off(ns);

	            that._upArrowEventHandler.destroy();
	            that._downArrowEventHandler.destroy();

	            if (that._form) {
	                that._form.off("reset", that._resetHandler);
	            }

	            Widget.fn.destroy.call(that);
	        },

	        min: function(value) {
	            return this._option("min", value);
	        },

	        max: function(value) {
	            return this._option("max", value);
	        },

	        step: function(value) {
	            return this._option("step", value);
	        },

	        value: function(value) {
	            var that = this, adjusted;

	            if (value === undefined) {
	                return that._value;
	            }

	            value = that._parse(value);
	            adjusted = that._adjust(value);

	            if (value !== adjusted) {
	                return;
	            }

	            that._update(value);
	            that._old = that._value;
	        },

	        focus: function() {
	            this._focusin();
	        },

	        _adjust: function(value) {
	            var that = this,
	            options = that.options,
	            min = options.min,
	            max = options.max;

	            if (value === NULL) {
	                return value;
	            }

	            if (min !== NULL && value < min) {
	                value = min;
	            } else if (max !== NULL && value > max) {
	                value = max;
	            }

	            return value;
	        },

	        _arrows: function() {
	            var that = this,
	            arrows,
	            _release = function() {
	                clearTimeout( that._spinning );
	                arrows.removeClass(SELECTED);
	            },
	            options = that.options,
	            spinners = options.spinners,
	            element = that.element;

	            arrows = element.siblings("." + CLASS_ICON);

	            if (!arrows[0]) {
	                arrows = $(buttonHtml("increase", options.upArrowText) + buttonHtml("decrease", options.downArrowText))
	                        .insertAfter(element);

	                that._arrowsWrap = arrows.wrapAll('<span class="k-select"/>').parent();
	            }

	            if (!spinners) {
	                arrows.parent().toggle(spinners);
	                that._inputWrapper.addClass("k-expand-padding");
	            }

	            that._upArrow = arrows.eq(0);
	            that._upArrowEventHandler = new kendo.UserEvents(that._upArrow, { release: _release });
	            that._downArrow = arrows.eq(1);
	            that._downArrowEventHandler = new kendo.UserEvents(that._downArrow, { release: _release });
	        },

	        _validation: function () {
	            var that = this;
	            var element = that.element;

	            that._validationIcon = $("<span class='" + CLASS_ICON + " k-i-warning'></span>")
	                .hide()
	                .insertAfter(element);
	        },

	        _blur: function() {
	            var that = this;

	            that._toggleText(true);

	            that._change(that.element.val());
	        },

	        _click: function(e) {
	            var that = this;

	            clearTimeout(that._focusing);
	            that._focusing = setTimeout(function() {
	                var input = e.target,
	                    idx = caret(input)[0],
	                    value = input.value.substring(0, idx),
	                    format = that._format(that.options.format),
	                    group = format[","],
	                    result, groupRegExp, extractRegExp,
	                    caretPosition = 0;

	                if (group) {
	                    groupRegExp = new RegExp("\\" + group, "g");
	                    extractRegExp = new RegExp("(^(-)$)|(^(-)?([\\d\\" + group + "]+)(\\" + format[POINT] + ")?(\\d+)?)");
	                }

	                if (extractRegExp) {
	                    result = extractRegExp.exec(value);
	                }

	                if (result) {
	                    caretPosition = result[0].replace(groupRegExp, "").length;

	                    if (value.indexOf("(") != -1 && that._value < 0) {
	                        caretPosition++;
	                    }
	                }

	                that._focusin();

	                caret(that.element[0], caretPosition);
	                that.selectValue();
	            });
	        },

	        selectValue: function(){
	            if (this.options.selectOnFocus) {
	                this.element[0].select();
	            }
	        },

	        _change: function(value) {
	            var that = this,
	                factor = that.options.factor;

	            if(factor && factor !== 1){
	                value = kendo.parseFloat(value);
	                if(value !== null) {
	                    value = value/factor;
	                }
	            }

	            that._update(value);
	            value = that._value;

	            if (that._old != value) {
	                that._old = value;

	                if (!that._typing) {
	                    // trigger the DOM change event so any subscriber gets notified
	                    that.element.trigger(CHANGE);
	                }

	                that.trigger(CHANGE);
	            }

	            that._typing = false;
	        },

	        _culture: function(culture) {
	            return culture || getCulture(this.options.culture);
	        },

	        _focusin: function() {
	            var that = this;
	            that._inputWrapper.addClass(FOCUSED);
	            that._toggleText(false);
	            that.element[0].focus();
	        },

	        _focusout: function() {
	            var that = this;

	            clearTimeout(that._focusing);
	            that._inputWrapper.removeClass(FOCUSED).removeClass(HOVER);
	            that._blur();
	            that._removeInvalidState();
	        },

	        _format: function(format, culture) {
	            var numberFormat = this._culture(culture).numberFormat;

	            format = format.toLowerCase();

	            if (format.indexOf("c") > -1) {
	                numberFormat = numberFormat.currency;
	            } else if (format.indexOf("p") > -1) {
	                numberFormat = numberFormat.percent;
	            }

	            return numberFormat;
	        },

	        _input: function() {
	            var that = this,
	                options = that.options,
	                CLASSNAME = "k-formatted-value",
	                element = that.element.addClass(INPUT).show()[0],
	                accessKey = element.accessKey,
	                wrapper = that.wrapper,
	                text;

	            text = wrapper.find(POINT + CLASSNAME);

	            if (!text[0]) {
	                text = $('<input type="text"/>').insertBefore(element).addClass(CLASSNAME).attr("aria-hidden", "true");
	            }

	            try {
	                element.setAttribute("type", "text");
	            } catch(e) {
	                element.type = "text";
	            }

	            text[0].title = element.title;
	            text[0].tabIndex = element.tabIndex;
	            text[0].style.cssText = element.style.cssText;
	            text.prop("placeholder", options.placeholder);

	            if (accessKey) {
	                text.attr("accesskey", accessKey);
	                element.accessKey = "";
	            }


	            that._text = text.addClass(element.className)
	                             .attr({
	                                 "role": "spinbutton",
	                                 "aria-valuemin": options.min !== NULL ? options.min*options.factor : options.min,
	                                 "aria-valuemax": options.max !== NULL ? options.max*options.factor : options.max,
	                                 "autocomplete": "off"
	                             });
	        },

	        _keydown: function(e) {
	            var that = this,
	                key = e.keyCode;

	            if (key === keys.NUMPAD_DOT) {
	                that._numPadDot = true;
	            }

	            if (key == keys.DOWN) {
	                that._step(-1);
	                return;
	            } else if (key == keys.UP) {
	                that._step(1);
	                return;
	            } else if (key == keys.ENTER) {
	                that._change(that.element.val());
	                return;
	            }

	            if (key != keys.TAB) {
	                that._typing = true;
	            }
	            that._cachedCaret = caret(that.element);
	        },

	        _keyup: function () {
	            this._removeInvalidState();
	        },

	        _inputHandler: function () {
	            var element = this.element;
	            var value = element.val();
	            var min = this.options.min;
	            var numberFormat = this._format(this.options.format);
	            var decimalSeparator = numberFormat[POINT];
	            var minInvalid = (min !== null && min >= 0 && value.charAt(0) === "-");

	            if (this._numPadDot && decimalSeparator !== POINT) {
	                value = value.replace(POINT, decimalSeparator);
	                this.element.val(value);
	                this._numPadDot = false;
	            }

	            if (this._numericRegex(numberFormat).test(value) && !minInvalid) {
	                this._oldText = value;
	            } else {
	                this._blinkInvalidState();
	                this.element.val(this._oldText);
	                if (this._cachedCaret) {
	                    caret(element, this._cachedCaret[0]);
	                    this._cachedCaret = null;
	                }
	            }
	        },

	        _blinkInvalidState: function () {
	            var that = this;

	            that._addInvalidState();
	            clearTimeout(that._invalidStateTimeout);
	            that._invalidStateTimeout = setTimeout(proxy(that._removeInvalidState, that), 100);
	        },

	        _addInvalidState: function () {
	            var that = this;
	            that._inputWrapper.addClass(STATE_INVALID);
	            that._validationIcon.show();
	        },

	        _removeInvalidState: function () {
	            var that = this;
	            that._inputWrapper.removeClass(STATE_INVALID);
	            that._validationIcon.hide();
	            that._invalidStateTimeout = null;
	        },

	        _numericRegex: function(numberFormat) {
	            var that = this;
	            var separator = numberFormat[POINT];
	            var precision = that.options.decimals;
	            var fractionRule = "*";

	            if (separator === POINT) {
	                separator = "\\" + separator;
	            }

	            if (precision === NULL) {
	                precision = numberFormat.decimals;
	            }

	            if (precision === 0 && that.options.restrictDecimals) {
	                return INTEGER_REGEXP;
	            }

	            if (that.options.restrictDecimals) {
	                fractionRule = "{0," + precision + "}";
	            }

	            if (that._separator !== separator) {
	                that._separator = separator;
	                that._floatRegExp = new RegExp("^(-)?(((\\d+(" + separator + "\\d" + fractionRule + ")?)|(" + separator + "\\d" + fractionRule + ")))?$");
	            }

	            return that._floatRegExp;
	        },

	        _paste: function(e) {
	            var that = this;
	            var element = e.target;
	            var value = element.value;
	            var numberFormat = that._format(that.options.format);

	            setTimeout(function() {
	                var result = that._parse(element.value);

	                if (result === NULL) {
	                    that._update(value);
	                } else {
	                    element.value = result.toString().replace(POINT, numberFormat[POINT]);
	                    if (that._adjust(result) !== result || !that._numericRegex(numberFormat).test(element.value)) {
	                        that._update(value);
	                    }
	                }
	            });
	        },

	        _option: function(option, value) {
	            var that = this,
	                element = that.element,
	                options = that.options;

	            if (value === undefined) {
	                return options[option];
	            }

	            value = that._parse(value);

	            if (!value && option === "step") {
	                return;
	            }

	            options[option] = value;
	            element
	                .add(that._text)
	                .attr("aria-value" + option, value);

	            element.attr(option, value);
	        },

	        _spin: function(step, timeout) {
	            var that = this;

	            timeout = timeout || 500;

	            clearTimeout( that._spinning );
	            that._spinning = setTimeout(function() {
	                that._spin(step, 50);
	            }, timeout );

	            that._step(step);
	        },

	        _step: function(step) {
	            var that = this,
	                element = that.element,
	                originalValue = that._value,
	                value = that._parse(element.val()) || 0,
	                precision = that.options.decimals || 2;

	            if (activeElement() != element[0]) {
	                that._focusin();
	            }

	            if(that.options.factor && value) {
	                value = value/that.options.factor;
	            }

	            value =  +(value + that.options.step * step).toFixed(precision);
	            value = that._adjust(value);
	            that._update(value);
	            that._typing = false;

	            if (originalValue !== value) {
	                that.trigger(SPIN);
	            }
	        },

	        _toggleHover: function(e) {
	            $(e.currentTarget).toggleClass(HOVER, e.type === "mouseenter");
	        },

	        _toggleText: function(toggle) {
	            var that = this;

	            that._text.toggle(toggle);
	            that.element.toggle(!toggle);
	        },

	        _parse: function(value, culture) {
	            return parse(value, this._culture(culture), this.options.format);
	        },

	        _round: function(value, precision) {
	            var rounder = this.options.round ? kendo._round : truncate;

	            return rounder(value, precision);
	        },

	        _update: function(value) {
	            var that = this,
	                options = that.options,
	                factor = options.factor,
	                format = options.format,
	                decimals = options.decimals,
	                culture = that._culture(),
	                numberFormat = that._format(format, culture),
	                isNotNull;

	            if (decimals === NULL) {
	                decimals = numberFormat.decimals;
	            }

	            value = that._parse(value, culture);

	            isNotNull = value !== NULL;

	            if (isNotNull) {
	                value = parseFloat(that._round(value, decimals), 10);
	            }

	            that._value = value = that._adjust(value);
	            that._placeholder(kendo.toString(value, format, culture));

	            if (isNotNull) {
	                if(factor) {
	                    value =  parseFloat(that._round(value*factor, decimals), 10);
	                }
	                value = value.toString();
	                if (value.indexOf("e") !== -1) {
	                    value = that._round(+value, decimals);
	                }
	                value = value.replace(POINT, numberFormat[POINT]);
	            } else {
	                value = null;
	            }

	            that.element.val(value);
	            that._oldText = value;
	            that.element.add(that._text).attr("aria-valuenow", value);
	        },

	        _placeholder: function(value) {
	            var input = this._text;

	            input.val(value);
	            if (!placeholderSupported && !value) {
	                input.val(this.options.placeholder);
	            }

	            input.attr("title", this.element.attr("title") || input.val());
	        },

	        _label: function() {
	            var that = this;
	            var element = that.element;
	            var options = that.options;
	            var id = element.attr("id");
	            var floating;
	            var labelText;

	            if (options.label !== null) {
	                floating = isPlainObject(options.label) ? options.label.floating : false;
	                labelText = isPlainObject(options.label) ? options.label.content : options.label;

	                if (floating) {
	                    that._floatingLabelContainer = that.wrapper.wrap("<span></span>").parent();
	                    that.floatingLabel = new kendo.ui.FloatingLabel(that._floatingLabelContainer, { widget: that });
	                }

	                if (kendo.isFunction(labelText)) {
	                    labelText = labelText.call(that);
	                }

	                if (!labelText) {
	                    labelText = "";
	                }

	                if (!id) {
	                    id = options.name + "_" + kendo.guid();
	                    element.attr("id", id);
	                }

	                that._inputLabel = $("<label class='" + LABELCLASSES + "' for='" + id + "'>" + labelText + "</label>'").insertBefore(that.wrapper);

	                if ((that.element.attr("disabled") === undefined) && (that.element.attr("readonly") === undefined)) {
	                    that._inputLabel.on("click" + ns, proxy(that.focus, that));
	                }
	            }
	        },

	        _wrapper: function() {
	            var that = this,
	                element = that.element,
	                DOMElement = element[0],
	                wrapper;

	            wrapper = element.parents(".k-numerictextbox");

	            if (!wrapper.is("span.k-numerictextbox")) {
	                wrapper = element.hide().wrap('<span class="k-numeric-wrap k-state-default" />').parent();
	                wrapper = wrapper.wrap("<span/>").parent();
	            }

	            wrapper[0].style.cssText = DOMElement.style.cssText;
	            DOMElement.style.width = "";
	            that.wrapper = wrapper.addClass("k-widget k-numerictextbox")
	                                  .addClass(DOMElement.className)
	                                  .removeClass('input-validation-error')
	                                  .css("display", "");

	            that._inputWrapper = $(wrapper[0].firstChild);
	        },

	        _reset: function() {
	            var that = this,
	                element = that.element,
	                formId = element.attr("form"),
	                form = formId ? $("#" + formId) : element.closest("form");

	            if (form[0]) {
	                that._resetHandler = function() {
	                    setTimeout(function() {
	                        that.value(element[0].value);
	                        that.max(that._initialOptions.max);
	                        that.min(that._initialOptions.min);
	                    });
	                };

	                that._form = form.on("reset", that._resetHandler);
	            }
	        }
	    });

	    function buttonHtml(direction, text) {
	        var className = "k-i-arrow-" + (direction === "increase" ? "60-up" : "60-down");

	        return (
	            '<span unselectable="on" class="k-link k-link-' + direction + '" aria-label="' + text + '" title="' + text + '">' +
	                '<span unselectable="on" class="' + CLASS_ICON + ' ' + className + '"></span>' +
	            '</span>'
	        );
	    }

	    function truncate(value, precision) {
	        var parts = parseFloat(value, 10).toString().split(POINT);

	        if (parts[1]) {
	            parts[1] = parts[1].substring(0, precision);
	        }

	        return parts.join(POINT);

	    }

	    ui.plugin(NumericTextBox);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "9BzU":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1073);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1073:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "breadcrumb",
	    name: "Breadcrumb",
	    category: "web",
	    description: "The Breadcrumb widget displays navigation breadcrumb.",
	    depends: [ "core" ]
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        extend = $.extend,
	        isPlainObject = $.isPlainObject,

	        proxy = $.proxy,

	        BREADCRUMB = ".kendoBreadcrumb",

	        ARIA_HIDDEN = "aria-hidden",
	        ARIA_LABEL = "aria-label",

	        CLICK = "click",
	        FOCUS = "focus",
	        BLUR = "blur",
	        KEYDOWN = "keydown",
	        CHANGE = "change",
	        DOT = ".";

	    var breadcrumbStyles = {
	        widget: "k-widget k-breadcrumb",
	        overlay: "k-breadcrumb-container",
	        textbox: "k-textbox",
	        link: "k-breadcrumb-link",
	        item: "k-breadcrumb-item",
	        delimiter: "k-breadcrumb-delimiter-icon",
	        rootItem: "k-breadcrumb-root-item",
	        rootLink: "k-breadcrumb-root-link",
	        overflowIcon: "k-breadcrumb-overflow-icon",
	        focused: "k-state-focused",
	        hidden: "k-hidden",
	        inputWrapper: "k-breadcrumb-input-container"
	    };

	    var Breadcrumb = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            options = options || {};

	            Widget.fn.init.call(that, element, options);

	            that._wrapper();

	            if(options.editable) {
	                that._editable();
	                that._tabindex();
	            }

	            that.wrapper.on(CLICK + BREADCRUMB, "a:not(.k-state-disabled)", proxy(that._click, that));

	            if(options.value || options.bindToLocation || !options.items) {
	                that._value();
	            } else if (options.items) {
	                that.items(options.items);
	            }

	            that._resizeHandler = kendo.onResize(function() {
	                that.resize(true);
	            });
	        },

	        options: {
	            editable: false,
	            navigational: false,
	            bindToLocation: false,
	            items: null,
	            name: "Breadcrumb",
	            gap: 0,
	            rootIcon: "home",
	            delimiterIcon: "arrow-chevron-right",
	            messages: {
	                rootTitle: "Go to root"
	            }
	        },

	        events: [ CHANGE, CLICK ],

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            kendo.unbindResize(that._resizeHandler);

	            that.wrapper
	                .add(that.wrapper.find("input"))
	                .add(that.wrapper.find("a"))
	                .off(BREADCRUMB);
	        },

	        items: function(items) {
	            var that = this;

	            if(items === undefined) {
	                return that.options.items;
	            }

	            that.options.items = items;
	            that._segments = items;
	            that.refresh();
	        },

	        _update: function(val) {
	            var that = this;

	            if (val !== that.value()) {
	                that._generateSegments(val);
	                that.refresh();
	                that.trigger(CHANGE, { sender: this, value: val });
	            }
	        },

	        _generateSegments: function (value) {
	            var that = this,
	                options = that.options,
	                items = options.items,
	                path, segments;

	            segments = that._split(value);

	            if(!items) {
	                that.options.items = that._segments = segments;
	                return;
	            }

	            that._segments = [];

	            for (var i = 0; i < segments.length; i++) {
	                path = that._path(items.slice(0, i + 1));

	                if (path !== "" && value.indexOf(path) > -1 && items[i] && items[i].text === segments[i]) {
	                    that._segments.push(items[i]);
	                } else {
	                    that._segments.push(segments[i]);
	                }
	            }
	        },

	        _click: function(e) {
	            var that = this,
	                options = that.options,
	                item = $(e.target).closest(DOT + breadcrumbStyles.item),
	                previousDomItems = item.prevAll().addBack(),
	                previousItems = that._getItems(previousDomItems),
	                path = that._path(previousItems),
	                segment = that._segments[item.index()];

	            if(!options.navigational) {
	                e.preventDefault();
	            }

	            if(!that.trigger(CLICK, { sender: that, originalEvent: e, isRoot: segment.type === "rootitem", item: segment})) {
	                that._update(path);
	            }
	        },

	        _getItems: function(items) {
	            var that = this;

	            return $.map(items, function(item) {
	                return that._segments[$(item).index()] || item.innerText;
	            });
	        },

	        _edit: function() {
	            var that = this,
	                input = that.input;

	            that.oldValue = that.value();
	            that.inputWrapper.css("height", that.wrapper.height());
	            that.overlay.hide();
	            that.input.val(that.value());
	            that.input.attr(ARIA_HIDDEN, false);
	            that.inputWrapper.show();

	            setTimeout(function() {
	                input.select();
	            });
	        },

	        _blur: function(shouldRestoreValue) {
	            var that = this,
	                input = that.input,
	                inputWrapper = that.inputWrapper,
	                wrapper = that.wrapper,
	                overlay = that.overlay,
	                val = input.val().replace(/\/{2,}/g, "/");

	            if (overlay.is(":visible")) {
	                return;
	            }

	            if (shouldRestoreValue) {
	                val = that.oldValue;
	            }

	            input.attr(ARIA_HIDDEN, true);
	            inputWrapper.hide();
	            overlay.show();
	            input.val("");
	            that._update(val);
	            wrapper.removeClass(breadcrumbStyles.focused);
	        },

	        _keydown: function(e) {
	            var that = this,
	                key = e.keyCode,
	                isEnter = key === kendo.keys.ENTER,
	                isEsc = key === kendo.keys.ESC;

	            if (isEnter || isEsc) {
	                that._blur(isEsc);

	                setTimeout(function() {
	                    that.overlay.find("a:first").focus();
	                });
	            }
	        },

	        isNavigational: function(target) {
	            var canNavigate =
	                target.hasClass(breadcrumbStyles.textbox) ||
	                target.closest(DOT + breadcrumbStyles.item);

	            if(target[0] === this.wrapper[0]) {
	                return false;
	            }

	            return canNavigate && !target.hasClass("k-breadcrumb-last-item");
	        },

	        _wrapperKeydown: function (ev) {
	            var that = this,
	                target = $(ev.target),
	                isNavigational = that.isNavigational(target);

	            if (ev.keyCode === kendo.keys.ENTER && !isNavigational) {
	                that._edit();
	            }
	        },

	        _wrapperClick: function (ev) {
	            var that = this,
	                target = $(ev.target),
	                isNavigational = that.isNavigational(target);

	            if(!isNavigational) {
	                this._edit();
	            }
	        },

	        _wrapperFocus: function(ev) {
	            $(ev.target).addClass(breadcrumbStyles.focused);
	        },

	        _wrapperBlur: function(ev) {
	            $(ev.target).removeClass(breadcrumbStyles.focused);
	        },

	        _wrapper: function() {
	            var that = this,
	                element = this.element,
	                elementIsInput = element.is("input");

	            that.wrapper = elementIsInput ? element
	                .wrap($("<nav />"))
	                .parent() : element;

	            if (elementIsInput) {
	                that.element
	                    .wrap($("<div />").addClass(breadcrumbStyles.inputWrapper))
	                    .addClass(breadcrumbStyles.textbox)
	                    .parent()
	                    .hide();

	                that.inputWrapper = that.wrapper.find(DOT + breadcrumbStyles.inputWrapper);
	            } else {
	                that.inputWrapper = that.wrapper
	                    .append($("<div />").addClass(breadcrumbStyles.inputWrapper))
	                    .find(DOT + breadcrumbStyles.inputWrapper).hide();
	            }

	            that.wrapper.addClass(breadcrumbStyles.widget);
	            that.wrapper.attr(ARIA_LABEL, "Breadcrumb");

	            that.overlay = that.wrapper
	                .append($("<ol />").addClass(breadcrumbStyles.overlay))
	                .find(DOT + breadcrumbStyles.overlay);
	        },


	        _editable: function(){
	            var that = this,
	                element = that.element,
	                elementIsInput = element.is("input");

	            if(elementIsInput) {
	                that.input = that.element;
	            } else {
	                that.input = $("<input />");
	            }

	            that.inputWrapper.append(that.input);

	            that.input
	                .addClass(breadcrumbStyles.textbox)
	                .attr(ARIA_HIDDEN, true);

	            that.input
	                .on(BLUR + BREADCRUMB, proxy(that._blur, that, false))
	                .on(KEYDOWN + BREADCRUMB, proxy(that._keydown, that));

	            that.wrapper
	                .on(FOCUS + BREADCRUMB, proxy(that._wrapperFocus, that))
	                .on(BLUR + BREADCRUMB, proxy(that._wrapperBlur, that))
	                .on(KEYDOWN + BREADCRUMB, proxy(that._wrapperKeydown, that))
	                .on(CLICK + BREADCRUMB, proxy(that._wrapperClick, that));
	        },

	        _value: function () {
	            var that = this,
	                options = that.options;

	            if (options.value) {
	                that.value(options.value);
	            } else if (options.bindToLocation) {
	                that.value(window.location.href.replace(/http(s?):\/\//,"").replace(/\/$/, ""));
	            } else {
	                that.value("");
	            }
	        },

	        _split: function(value) {
	            return value.split("/").filter(function (item, index) {
	                if(index > 0 && item === "") {
	                    return false;
	                }

	                return true;
	            });
	        },

	        isRtl: function() {
	            return kendo.support.isRtl(this.wrapper);
	        },

	        refresh: function() {
	            var that = this,
	                options = that.options,
	                messages = options.messages,
	                delimiterIcon = that.options.delimiterIcon,
	                html = "",
	                href = "",
	                isOnlyRoot = that.value() === "",
	                segments = that._segments,
	                segment,
	                idx,
	                length, isLastSegment;

	            if (delimiterIcon == "arrow-chevron-right" && that.isRtl()) {
	                delimiterIcon = "arrow-chevron-left";
	            }

	            for (idx = 0, length = segments.length; idx < length; idx++) {
	                segment = segments[idx];
	                isLastSegment = idx === segments.length - 1;

	                if (segment !== undefined) {
	                    if(!html) {
	                        href = "/";
	                    } else {
	                        href += segment.text || segment || "";
	                    }

	                    if(typeof segment === "string") {
	                        segment = {
	                            type: !html ? "rootitem" : "item",
	                            href: options.navigational ? href : "#",
	                            text: segment,
	                            showIcon: !html,
	                            showText: !!html,
	                            icon: !html ? options.rootIcon : "",
	                            itemClass: !html ? "k-breadcrumb-root-item" : "",
	                            linkClass: !html ? breadcrumbStyles.rootLink : "",
	                            delimiterIcon: delimiterIcon,
	                            renderDelimiter: !isLastSegment && !isOnlyRoot,
	                            lastSegment: isLastSegment,
	                            iconClass: ""
	                        };

	                        that._segments.splice(idx, 1, segment);
	                    } else if (isPlainObject(segment)) {
	                        segment = extend({}, segment, {
	                            type: segment.type ? segment.type.toLowerCase() : "item"
	                        });

	                        segment = extend({}, segment, {
	                            text: segment.text || "",
	                            title: segment.text || "",
	                            icon: segment.icon || (segment.type === "rootitem" ? options.rootIcon : ""),
	                            iconClass: segment.iconClass || "",
	                            lastSegment: isLastSegment,
	                            renderDelimiter: !isLastSegment && segments.length > 1,
	                            href: options.navigational ? segment.href : "#",
	                            delimiterIcon: delimiterIcon,
	                            itemClass: segment.itemClass || "",
	                            linkClass: segment.linkClass || "",
	                            showIcon: segment.showIcon === undefined ? segment.type === "rootitem" && segment.type !== "item" : segment.showIcon,
	                            showText: segment.showText === undefined ? segment.type === "item" && segment.type !== "rootitem" : segment.showText
	                        });

	                        if(segment.type === "rootitem") {
	                            segment.itemClass += " k-breadcrumb-root-item";
	                            segment.linkClass += " " +  breadcrumbStyles.rootLink;
	                        }
	                    }

	                    if(segment.type === "rootitem" && segment.text === "") {
	                        segment.title = messages.rootTitle;
	                    }

	                    href += href.match(/\/$/) ? "" : "/";

	                    html += kendo.template(this.itemTemplate)(segment);
	                }
	            }

	            this.overlay
	                .empty()
	                .append($(html));

	            this.resize(true);
	        },

	        itemTemplate: '<li class="k-breadcrumb-item #:itemClass# #if(lastSegment){#k-breadcrumb-last-item#}#">' +
	            '<a href="#:href#" class="#:linkClass# ' +
	                                     '#if(type !== "rootitem"){# k-breadcrumb-link#}#' +
	                                     '#if(showText && showIcon){# k-breadcrumb-icontext-link#}#' +
	                                     '#if(showIcon && !showText){# k-breadcrumb-icon-link#}#' +
	                                     '#if(lastSegment && type !== "rootitem"){# k-state-disabled#}#"' +
	                                     '#if(lastSegment){# aria-current="page"#}# title="#:text || title#">' +
	                '#if(showIcon) {#' +
	                    '<span class="#if(icon){#k-icon k-i-#:icon##}# #:iconClass#"></span>' +
	                '#}#' +
	                '#if(showText) {#' +
	                    '#:text#' +
	                '#}#' +
	            '</a>' +
	            '#if(renderDelimiter) {#' +
	                '<span class="k-breadcrumb-delimiter-icon k-icon k-i-#:delimiterIcon#" aria-hidden="true"></span>' +
	            '#}#' +
	            '#if(type === "rootitem" && renderDelimiter) {#' +
	                '<span class="k-breadcrumb-delimiter-icon k-hidden k-icon k-i-#:delimiterIcon#" aria-hidden="true"></span>' +
	            '#}#' +
	        '</li>',

	        _displayOverflowIcons: function(visible) {
	            var that = this,
	                rootItem = that.wrapper.find(DOT + breadcrumbStyles.rootItem);

	            if (visible) {
	                rootItem.find(DOT + breadcrumbStyles.delimiter)
	                    .addClass(breadcrumbStyles.overflowIcon)
	                    .removeClass(breadcrumbStyles.hidden);
	            } else {
	                rootItem.find(DOT + breadcrumbStyles.overflowIcon)
	                    .removeClass(breadcrumbStyles.overflowIcon)
	                    .last().addClass(breadcrumbStyles.hidden);
	            }
	        },

	        _shrinkItems: function() {
	            var that = this,
	                wrapper = that.wrapper,
	                overlay = that.overlay,
	                items = that.overlay.find(DOT + breadcrumbStyles.item + ":visible:not(.k-breadcrumb-root-item)"),
	                availableWidth = wrapper.width() - that.options.gap,
	                item;

	            if (items.length == 1) {
	                return;
	            }

	            for (var i = 0; i < items.length; i += 1) {
	                item = $(items[i]);

	                if (kendo._outerWidth(overlay) >= availableWidth) {
	                    if (i == items.length - 1) {
	                        break;
	                    }

	                    item.hide();
	                    that._displayOverflowIcons(true);
	                }
	            }
	        },

	        _showItem: function(item, overlayWidth, availableWidth) {
	            if (item.length && availableWidth > overlayWidth + kendo._outerWidth(item, true)) {
	                item.show();

	                return true;
	            }

	            return false;
	        },

	        _stretchItems: function() {
	            var that = this,
	                wrapper = that.wrapper,
	                overlay = that.overlay,
	                items = that.overlay.find(DOT + breadcrumbStyles.item + ":hidden:not(.k-breadcrumb-root-item)"),
	                availableWidth = wrapper.width() - that.options.gap,
	                item, overlayWidth;

	            if (!items.length) {
	                that._displayOverflowIcons(false);
	            }

	            for (var i = items.length - 1; i >= 0; i--) {
	                item = $(items[i]);

	                overlayWidth = kendo._outerWidth(overlay);

	                if (overlayWidth > availableWidth || !this._showItem(item, overlayWidth, availableWidth)) {
	                    break;
	                }
	            }
	        },

	        _resize: function() {
	            this._shrinkItems();
	            this._stretchItems();
	        },

	        getSize: function() {
	            return kendo.dimensions(this.wrapper);
	        },

	        value: function(val) {
	            var that = this;

	            if (val !== undefined) {
	                that._generateSegments(val);
	                that.refresh();
	                return;
	            }

	            return that._path(that._segments);
	        },

	        _path: function(trail) {
	            return $.map(trail, function(b) {
	                var text = isPlainObject(b) ? b.text : b;
	                return text === "/" ? "" : text;
	            }).join("/");
	        }
	    });

	    kendo.ui.plugin(Breadcrumb);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "9WGm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var utils_1 = __webpack_require__("IRr6");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var eventService_1 = __webpack_require__("k5uU");
var expressionService_1 = __webpack_require__("1aUC");
var animateSlideCellRenderer_1 = __webpack_require__("Vn5t");
var animateShowChangeCellRenderer_1 = __webpack_require__("jeRM");
var groupCellRenderer_1 = __webpack_require__("sYFB");
var CellRendererFactory = (function () {
    function CellRendererFactory() {
        this.cellRendererMap = {};
    }
    CellRendererFactory_1 = CellRendererFactory;
    CellRendererFactory.prototype.init = function () {
        this.cellRendererMap[CellRendererFactory_1.ANIMATE_SLIDE] = animateSlideCellRenderer_1.AnimateSlideCellRenderer;
        this.cellRendererMap[CellRendererFactory_1.ANIMATE_SHOW_CHANGE] = animateShowChangeCellRenderer_1.AnimateShowChangeCellRenderer;
        this.cellRendererMap[CellRendererFactory_1.GROUP] = groupCellRenderer_1.GroupCellRenderer;
        // this.registerRenderersFromGridOptions();
    };
    // private registerRenderersFromGridOptions(): void {
    //     let userProvidedCellRenderers = this.gridOptionsWrapper.getCellRenderers();
    //     _.iterateObject(userProvidedCellRenderers, (key: string, cellRenderer: {new(): ICellRenderer} | ICellRendererFunc)=> {
    //         this.addCellRenderer(key, cellRenderer);
    //     });
    // }
    CellRendererFactory.prototype.addCellRenderer = function (key, cellRenderer) {
        this.cellRendererMap[key] = cellRenderer;
    };
    CellRendererFactory.prototype.getCellRenderer = function (key) {
        var result = this.cellRendererMap[key];
        if (utils_1.Utils.missing(result)) {
            console.warn('ag-Grid: unable to find cellRenderer for key ' + key);
            return null;
        }
        return result;
    };
    CellRendererFactory.ANIMATE_SLIDE = 'animateSlide';
    CellRendererFactory.ANIMATE_SHOW_CHANGE = 'animateShowChange';
    CellRendererFactory.GROUP = 'group';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], CellRendererFactory.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('expressionService'),
        __metadata("design:type", expressionService_1.ExpressionService)
    ], CellRendererFactory.prototype, "expressionService", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], CellRendererFactory.prototype, "eventService", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CellRendererFactory.prototype, "init", null);
    CellRendererFactory = CellRendererFactory_1 = __decorate([
        context_1.Bean('cellRendererFactory')
    ], CellRendererFactory);
    return CellRendererFactory;
    var CellRendererFactory_1;
}());
exports.CellRendererFactory = CellRendererFactory;


/***/ }),

/***/ "9fcU":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1186);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1054:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CRfZ");

/***/ }),

/***/ 1057:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("3i6F");

/***/ }),

/***/ 1108:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ydSV");

/***/ }),

/***/ 1170:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("zQRd");

/***/ }),

/***/ 1186:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1054), __webpack_require__(1170), __webpack_require__(1187), __webpack_require__(1057), __webpack_require__(1108) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "editable",
	    name: "Editable",
	    category: "framework",
	    depends: [ "dropdownlist", "datepicker", "numerictextbox", "validator", "binder" ],
	    hidden: true
	};

	/* jshint eqnull: true */
	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        extend = $.extend,
	        oldIE = kendo.support.browser.msie && kendo.support.browser.version < 9,
	        isFunction = kendo.isFunction,
	        isPlainObject = $.isPlainObject,
	        inArray = $.inArray,
	        POINT = ".",
	        AUTOCOMPLETEVALUE = "off",
	        nameSpecialCharRegExp = /("|\%|'|\[|\]|\$|\.|\,|\:|\;|\+|\*|\&|\!|\#|\(|\)|<|>|\=|\?|\@|\^|\{|\}|\~|\/|\||`)/g,
	        ERRORTEMPLATE = '<div class="k-tooltip k-tooltip-error k-validator-tooltip">' +
	            '<span class="k-tooltip-icon k-icon k-i-warning"></span>' +
	            '<span class="k-tooltip-content">#= message #</span>' +
	            '<span class="k-callout k-callout-n"></span>' +
	        '</div>',
	        CHANGE = "change";
	    var EQUAL_SET = "equalSet";
	    var specialRules = ["url", "email", "number", "date", "boolean"];

	    function fieldType(field) {
	        field = field != null ? field : "";
	        return field.type || $.type(field) || "string";
	    }

	    function convertToValueBinding(container) {
	        container.find(":input:not(:button, .k-combobox .k-input, [" + kendo.attr("role") + "=listbox], [" + kendo.attr("role") + "=upload], [" + kendo.attr("skip") + "], [type=file])").each(function() {
	            var bindAttr = kendo.attr("bind"),
	                binding = this.getAttribute(bindAttr) || "",
	                bindingName = this.type === "checkbox" || this.type === "radio" ? "checked:" : "value:",
	                fieldName = this.name;

	            if (binding.indexOf(bindingName) === -1 && fieldName) {
	                binding += (binding.length ? "," : "") + bindingName + fieldName;

	                $(this).attr(bindAttr, binding);
	            }
	        });
	    }

	    function createAttributes(options) {
	        var field = (options.model.fields || options.model)[options.field],
	            type = fieldType(field),
	            validation = field ? field.validation : {},
	            attributes = field ? field.attributes : {},
	            ruleName,
	            DATATYPE = kendo.attr("type"),
	            BINDING = kendo.attr("bind"),
	            rule,
	            attr = {
	                id: options.id || options.field,
	                name: options.field,
	                title: options.title ? options.title : options.field
	            };

	        for (ruleName in validation) {
	            rule = validation[ruleName];

	            if (inArray(ruleName, specialRules) >= 0) {
	                attr[DATATYPE] = ruleName;
	            } else if (!isFunction(rule)) {
	                var culture = kendo.getCulture();

	                if (typeof rule === "number" && culture.name.length) {
	                    var numberFormat = culture.numberFormat;
	                    var stringRule = rule.toString()
	                        .replace(POINT, numberFormat[POINT]);

	                    attr[ruleName] = stringRule;
	                } else {
	                    attr[ruleName] = isPlainObject(rule) ? rule.value || ruleName : rule;
	                }
	            }

	            attr[kendo.attr(ruleName + "-msg")] = rule.message;

	            attr.autocomplete = AUTOCOMPLETEVALUE;
	        }

	        for (var attributeName in attributes) {
	            attr[attributeName] = attributes[attributeName];
	        }

	        if (inArray(type, specialRules) >= 0) {
	            attr[DATATYPE] = type;
	        }

	        attr[BINDING] = (type === "boolean" ? "checked:" : "value:") + options.field;

	        return attr;
	    }

	    function addIdAttribute(container, attr) {
	        var id = container.attr("id");

	        if (id) {
	            attr.id = id;
	            container.removeAttr("id");
	        }

	        return attr;
	    }

	    function convertItems(items) {
	        var idx,
	            length,
	            item,
	            value,
	            text,
	            result;

	        if (items && items.length) {
	            result = [];
	            for (idx = 0, length = items.length; idx < length; idx++) {
	                item = items[idx];
	                text = item.text || item.value || item;
	                value = item.value == null ? (item.text || item) : item.value;

	                result[idx] = { text: text, value: value };
	            }
	        }
	        return result;
	    }

	    function getEditorTag(type, options) {
	        var tag;

	        if (!type.length) { return; }

	        if ((type === "DropDownTree" && options && options.checkboxes) || type === "MultiSelect") {
	            tag = "<select />";
	        } else {
	            tag = type === "Editor" ? "<textarea />" : "<input />";
	        }

	        return tag;
	    }

	    var kendoEditors = [
	        "AutoComplete", "ColorPicker", "ComboBox", "DateInput",
	        "DatePicker", "DateTimePicker", "DropDownTree",
	        "Editor", "MaskedTextBox", "MultiColumnComboBox","MultiSelect",
	        "NumericTextBox", "Rating", "Slider", "Switch", "TimePicker", "DropDownList"
	    ];

	    var editors = {
	        "number": function(container, options) {
	            var attr = createAttributes(options);
	            $('<input type="text"/>').attr(attr).appendTo(container).kendoNumericTextBox({ format: options.format });
	            $('<span ' + kendo.attr("for") + '="' + options.field + '" class="k-invalid-msg k-hidden"/>').appendTo(container);
	        },
	        "date": function(container, options) {
	            var attr = createAttributes(options),
	                format = options.format;

	            if (format) {
	                format = kendo._extractFormat(format);
	            }

	            attr[kendo.attr("format")] = format;

	            $('<input type="text"/>').attr(attr).appendTo(container).kendoDatePicker({ format: options.format });
	            $('<span ' + kendo.attr("for") + '="' + options.field + '" class="k-invalid-msg k-hidden"/>').appendTo(container);
	        },
	        "string": function(container, options) {
	            var attr = createAttributes(options);

	            $('<input type="text" />').attr(attr).addClass("k-textbox").appendTo(container);
	        },
	        "boolean": function(container, options) {
	            var attr = createAttributes(options);
	            var element = $('<input type="checkbox" />').attr(attr).addClass("k-checkbox").appendTo(container);

	            renderHiddenForMvcCheckbox(element, container, options);
	        },
	        "values": function(container, options) {
	            var attr = createAttributes(options);
	            var items = kendo.stringify(convertItems(options.values));
	            $('<select ' + kendo.attr("text-field") + '="text"' + kendo.attr("value-field") + '="value"' +
	                kendo.attr("source") + "=\'" + (items ? items.replace(/\'/g,"&apos;") : items) +
	                "\'" + kendo.attr("role") + '="dropdownlist"/>') .attr(attr).appendTo(container);
	            $('<span ' + kendo.attr("for") + '="' + options.field + '" class="k-invalid-msg  k-hidden"/>').appendTo(container);
	        },
	        "kendoEditor": function (container, options) {
	            var attr = createAttributes(options);
	            var type = options.editor;
	            var editor = "kendo" + type;
	            var editorOptions = options.editorOptions;
	            var tagElement = getEditorTag(type, editorOptions);

	            var element = $(tagElement)
	                .attr(attr)
	                .appendTo(container)
	                [editor](editorOptions);

	            renderHiddenForMvcCheckbox(element, container, options);
	        }
	    };

	    var mobileEditors = {
	        "number": function (container, options) {
	            var attr = createAttributes(options);
	            attr = addIdAttribute(container, attr);

	            $('<input type="number"/>').attr(attr).appendTo(container);
	        },
	        "date": function (container, options) {
	            var attr = createAttributes(options);
	            attr = addIdAttribute(container, attr);

	            $('<input type="date"/>').attr(attr).appendTo(container);
	        },
	        "string": function (container, options) {
	            var attr = createAttributes(options);
	            attr = addIdAttribute(container, attr);

	            $('<input type="text" />').attr(attr).appendTo(container);
	        },
	        "boolean": function (container, options) {
	            var attr = createAttributes(options);
	            attr = addIdAttribute(container, attr);

	            $('<input type="checkbox" />').attr(attr).appendTo(container);
	        },
	        "values": function (container, options) {
	            var attr = createAttributes(options);
	            var items = options.values;
	            var select = $('<select />');

	            attr = addIdAttribute(container, attr);

	            for (var index in items) {
	                $('<option value="' + items[index].value + '">' + items[index].text + '</option>').appendTo(select);
	            }

	            select.attr(attr).appendTo(container);
	        }
	    };

	    function addValidationRules(modelField, rules) {
	        var validation = modelField ? (modelField.validation || {}) : {},
	            rule,
	            descriptor;

	        for (rule in validation) {
	            descriptor = validation[rule];

	            if (isPlainObject(descriptor) && descriptor.value) {
	                descriptor = descriptor.value;
	            }

	            if (isFunction(descriptor)) {
	                rules[rule] = descriptor;
	            }
	        }
	    }

	    function renderHiddenForMvcCheckbox(tag, container, field) {
	        var addHidden = field ? (field.shouldRenderHidden || false) : false;

	        if (addHidden) {
	            tag.val(true);
	            container.append($("<input type='hidden' name='" + field.field +"' value='false' data-skip='true' data-validate='false'/>"));
	        }
	    }

	    var Editable = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            if (options.target) {
	                options.$angular = options.target.options.$angular;

	                if (options.target.pane) {
	                    that._isMobile = true;
	                }
	            }
	            Widget.fn.init.call(that, element, options);
	            that._validateProxy = $.proxy(that._validate, that);
	            that.refresh();
	        },

	        events: [CHANGE],

	        options: {
	            name: "Editable",
	            editors: editors,
	            mobileEditors: mobileEditors,
	            clearContainer: true,
	            validateOnBlur: true,
	            validationSummary: false,
	            errorTemplate: ERRORTEMPLATE,
	            skipFocus: false
	        },

	        editor: function(field, modelField) {
	            var that = this,
	                editors = that._isMobile ? mobileEditors : that.options.editors,
	                isObject = isPlainObject(field),
	                fieldName = isObject ? field.field : field,
	                model = that.options.model || {},
	                isValuesEditor = isObject && field.values,
	                type = isValuesEditor ? "values" : fieldType(modelField),
	                isCustomEditor = isObject && field.editor,
	                isKendoEditor = isObject && $.inArray(field.editor, kendoEditors) !== -1,
	                editor = isCustomEditor ? field.editor : editors[type],
	                container = that.element.find("[" + kendo.attr("container-for") + "=" + fieldName.replace(nameSpecialCharRegExp, "\\$1")+ "]");

	            editor = editor ? editor : editors.string;

	            if (isKendoEditor) {
	                editor = editors.kendoEditor;
	            } else if (isCustomEditor && typeof field.editor === "string") {
	                editor = function(container) {
	                    container.append(field.editor);
	                };
	            }

	            container = container.length ? container : that.element;
	            editor(container, extend(true, {}, isObject ? field : { field: fieldName }, { model: model }));
	        },

	        _validate: function(e) {
	            var that = this,
	                input,
	                value = e.value,
	                preventChangeTrigger = that._validationEventInProgress,
	                values = {},
	                bindAttribute = kendo.attr("bind"),
	                fieldName = e.field.replace(nameSpecialCharRegExp, "\\$1"),
	                bindingRegex = new RegExp("(value|checked)\\s*:\\s*" + fieldName + "\\s*(,|$)");

	            values[e.field] = e.value;

	            input = $(':input[' + bindAttribute + '*="' + fieldName + '"]', that.element)
	                .filter("[" + kendo.attr("validate") + "!='false']").filter(function() {
	                   return bindingRegex.test($(this).attr(bindAttribute));
	                });
	            if (input.length > 1) {
	                input = input.filter(function () {
	                    var element = $(this);
	                    return !element.is(":radio") || element.val() == value;
	                });
	            }

	            try {
	                that._validationEventInProgress = true;

	                if (!that.validatable.validateInput(input) || (!preventChangeTrigger && that.trigger(CHANGE, { values: values }))) {
	                    e.preventDefault();
	                }

	            } finally {
	                that._validationEventInProgress = false;
	            }
	        },

	        end: function() {
	            return this.validatable.validate();
	        },

	        destroy: function() {
	            var that = this;

	            that.angular("cleanup", function(){
	                return { elements: that.element };
	            });

	            Widget.fn.destroy.call(that);

	            that.options.model.unbind("set", that._validateProxy);
	            that.options.model.unbind(EQUAL_SET, that._validateProxy);

	            kendo.unbind(that.element);

	            if (that.validatable) {
	                that.validatable.destroy();
	            }
	            kendo.destroy(that.element);

	            that.element.removeData("kendoValidator");

	            if (that.element.is("[" + kendo.attr("role") + "=editable]")) {
	                that.element.removeAttr(kendo.attr("role"));
	            }
	        },

	        refresh: function() {
	            var that = this,
	                idx,
	                length,
	                fields = that.options.fields || [],
	                container = that.options.clearContainer ? that.element.empty() : that.element,
	                model = that.options.model || {},
	                rules = {},
	                field,
	                isObject,
	                fieldName,
	                modelField,
	                modelFields;

	            if (!$.isArray(fields)) {
	                fields = [fields];
	            }

	            for (idx = 0, length = fields.length; idx < length; idx++) {
	                 field = fields[idx];
	                 isObject = isPlainObject(field);
	                 fieldName = isObject ? field.field : field;
	                 modelField = (model.fields || model)[fieldName];

	                 addValidationRules(modelField, rules);

	                 that.editor(field, modelField);
	            }

	            if (that.options.target) {
	                that.angular("compile", function(){
	                    return {
	                        elements: container,
	                        data: container.map(function() { return { dataItem: model }; })
	                    };
	                });
	            }

	            if (!length) {
	                modelFields = model.fields || model;
	                for (fieldName in modelFields) {
	                    addValidationRules(modelFields[fieldName], rules);
	               }
	            }

	            convertToValueBinding(container);

	            if (that.validatable) {
	                that.validatable.destroy();
	            }

	            kendo.bind(container, that.options.model);

	            if (that.options.validateOnBlur) {
	                that.options.model
	                    .unbind("set", that._validateProxy)
	                    .bind("set", that._validateProxy);

	                that.options.model
	                    .unbind(EQUAL_SET, that._validateProxy)
	                    .bind(EQUAL_SET, that._validateProxy);
	            }

	            that.validatable = new kendo.ui.Validator(container, {
	                validateOnBlur: that.options.validateOnBlur,
	                validationSummary: that.options.validationSummary,
	                errorTemplate: that.options.errorTemplate || undefined,
	                rules: rules });

	            if (!that.options.skipFocus) {
	                var focusable = container.find(":kendoFocusable").eq(0).focus();
	                if (oldIE) {
	                    focusable.focus();
	                }
	            }
	        }
	   });

	   ui.plugin(Editable);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1187:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("99zt");

/***/ })

/******/ });

/***/ }),

/***/ "9geK":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1290);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1054:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CRfZ");

/***/ }),

/***/ 1087:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("WuVc");

/***/ }),

/***/ 1103:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7Omp");

/***/ }),

/***/ 1290:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1087), __webpack_require__(1291), __webpack_require__(1054), __webpack_require__(1103)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function () {

	    var __meta__ = { // jshint ignore:line
	        id: "mediaplayer",
	        name: "MediaPlayer",
	        category: "web",
	        description: "",
	        depends: ["slider", "toolbar", "dropdownlist", "tooltip"]
	    };

	    (function ($, undefined) {
	        var kendo = window.kendo,
	            END = "end",
	            PAUSE = "pause",
	            PLAY = "play",
	            READY = "ready",
	            TIMECHANGE = "timeChange",
	            VOLUMECHANGE = "volumeChange",
	            FULLSCREEN_ENTER = "k-i-full-screen",
	            FULLSCREEN_EXIT = "k-i-full-screen-exit",
	            MUTE = "k-i-volume-off",
	            LOW_VOLUME = "k-i-volume-down",
	            HIGH_VOLUME = "k-i-volume-up",
	            VIDEO_QUALITY = "k-mediaplayer-quality",
	            STATE_PLAY = "k-i-play",
	            STATE_PAUSE = "k-i-pause",
	            TITLEBAR = "k-mediaplayer-titlebar",
	            TITLE = "k-title",
	            TOOLBARWRAP = "k-mediaplayer-toolbar-wrap",
	            TOOLBAR = "k-mediaplayer-toolbar",
	            SLIDER = "k-mediaplayer-seekbar",
	            VOLUME_SLIDER = "k-mediaplayer-volume",
	            MEDIA = "k-mediaplayer-media",
	            OVERLAY = "k-mediaplayer-overlay",
	            YTPLAYER = "k-mediaplayer-yt",
	            DOT = ".",
	            ui = kendo.ui,
	            ns = ".kendoMediaPlayer",
	            baseTime = new Date(1970, 0, 1),
	            timeZoneSec = baseTime.getTimezoneOffset() * 60,
	            Widget = kendo.ui.Widget,
	            isArray = $.isArray,
	            timeFormats = {
	                shortTime: "mm:ss",
	                longTime: "HH:mm:ss"
	            },
	            template = kendo.template,
	            proxy = $.proxy,
	            keys = kendo.keys,
	            templates = {
	                htmlPlayer: "<video class='" + MEDIA + "'> </video>",
	                titleBar: template("<div class='" + TITLEBAR + "' role='heading'><span class='" + TITLE + "'>Video Title</span></div>"),
	                toolBar: "<div class='" + TOOLBARWRAP + "'><div class='" + TOOLBAR + "'></div></div>",
	                youtubePlayer: "<div class='" + YTPLAYER + "'> </div>",
	                toolBarTime: "<span class='k-mediaplayer-currenttime'>00:00:00</span> / <span class='k-mediaplayer-duration'>00:00:00</span>",
	                slider: "<input class='" + SLIDER + "' value='0' title='seekbar' />",
	                volumeSlider: "<input class='" + VOLUME_SLIDER + "' title='volume'/>",
	                qualityDropDown: "<input class='" + VIDEO_QUALITY + "' title='video quality' />",
	                toolTip: "#= kendo.toString(new Date(value), 'HH:mm:ss') #"
	            };

	        var MediaPlayer = Widget.extend({
	            init: function (element, options) {
	                this.wrapper = $(element);

	                Widget.fn.init.call(this, element, options);

	                this.wrapper.addClass("k-mediaplayer k-widget");

	                options = this.options;

	                this._currentIndex = 0;

	                this._createTitlebar();

	                this._createToolbar();

	                this._createDropDown();

	                this._createSlider();

	                this._createVolumeSlider();

	                this._timers = {};

	                this._aria();

	                this._navigatable();

	                if (options.fullScreen) {
	                    this.fullScreen(true);
	                }

	                if (options.media) {
	                    this.media(this.options.media);
	                }

	                kendo.notify(this);
	            },

	            events: [
	                END,
	                PAUSE,
	                PLAY,
	                READY,
	                TIMECHANGE,
	                VOLUMECHANGE
	            ],

	            options: {
	                name: "MediaPlayer",
	                autoPlay: false,
	                autoRepeat: false,
	                volume: 100,
	                fullScreen: false,
	                mute: false,
	                navigatable: false,
	                forwardSeek: true,
	                media: null,
	                messages: {
	                    "pause": "Pause",
	                    "play": "Play",
	                    "mute": "Mute",
	                    "unmute": "Unmute",
	                    "quality": "Quality",
	                    "fullscreen": "Full Screen"
	                }
	            },

	            _msToTime: function (ms) {
	                var time = new Date(baseTime.getTime());
	                time.setSeconds(ms);
	                return time;
	            },

	            _timeToSec: function (time) {
	                var curTime = new Date(time).getTime();
	                return curTime / 1000;
	            },

	            _createTitlebar: function () {
	                this._titleBar = this.wrapper.find(DOT + TITLEBAR);
	                if (this._titleBar.length === 0) {
	                    this.wrapper.append(templates.titleBar);
	                    this._titleBar = this.wrapper.find(DOT + TITLEBAR);
	                }
	            },

	            _createSlider: function () {
	                var sliderElement = this.wrapper.find(DOT + SLIDER);
	                if (!this._slider) {
	                    this._sliderDragChangeHandler = proxy(this._sliderDragChange, this);
	                    this._sliderDraggingHandler = proxy(this._sliderDragging, this);
	                    sliderElement = this.wrapper.find(DOT + SLIDER);

	                    this._slider = new ui.Slider(sliderElement[0], {
	                        smallStep: 1000,
	                        tickPlacement: "none",
	                        showButtons: false,
	                        change: this._sliderDragChangeHandler,
	                        slide: this._sliderDraggingHandler,
	                        tooltip: {
	                            template: templates.toolTip
	                        },
	                        dragHandleTitle: ""
	                    });
	                }
	            },

	            _createVolumeSlider: function () {
	                var volumeSliderElement = this.wrapper.find(DOT + VOLUME_SLIDER);
	                if (!this._volumeSlider) {
	                    this._volumeDraggingHandler = proxy(this._volumeDragging, this);
	                    this._volumeChangeHandler = proxy(this._volumeChange, this);
	                    volumeSliderElement.width(87);
	                    this._volumeSlider = new ui.Slider(volumeSliderElement[0], {
	                        smallStep: 1,
	                        min: 0,
	                        max: 100,
	                        value: this.options.volume,
	                        slide: this._volumeDraggingHandler,
	                        change: this._volumeChangeHandler,
	                        tickPlacement: "none",
	                        showButtons: false,
	                        tooltip: { enabled: false },
	                        dragHandleTitle: ""
	                    });
	                }
	            },

	            _resetTime: function () {
	                if (this._youTubeVideo) {
	                    this._ytmedia.seekTo(0, true);
	                } else {
	                    this._media.currentTime = 0;
	                }

	                this._mediaTimeUpdate();
	                $.grep(this._toolBar.options.items, function (e) { return !!e.template; }).template = templates.toolBarTime;
	            },

	            _currentUrl: function () {
	                var media = this.media();
	                return isArray(media.source) ? media.source[this._currentIndex].url : media.source;
	            },

	            _isYouTubeUrl: function () {
	                return !!this._currentUrl().match("youtube.com/|youtu.be/");
	            },

	            _setPlayerUrl: function () {
	                var oldPlayer = this._youTubeVideo;
	                this.stop();

	                this._youTubeVideo = this._isYouTubeUrl();

	                if (oldPlayer !== this._youTubeVideo) {
	                    this.wrapper.find(DOT + YTPLAYER).toggle();
	                    this.wrapper.find(DOT + MEDIA).toggle();
	                }

	                var initialized = this._media || this._ytmedia;

	                this._initializePlayer();

	                if (initialized) { //mute and volume settings should be persisted when switching between html and youtube players
	                    this.mute(this.mute());
	                    this.volume(this.volume());
	                }

	                if (!this._youTubeVideo) {
	                    this._videoOverlay.show();
	                    this.wrapper.find(DOT + MEDIA + " > source").remove();
	                    this.wrapper.find(DOT + MEDIA).attr("src", this._currentUrl());

	                    if (this.options.autoPlay) {
	                        this.play();
	                    }
	                }
	                else if (this._ytmedia) {
	                    if (this._videoOverlay) {
	                        this._videoOverlay.hide();
	                    }
	                    if (this.options.autoPlay) {
	                        this._ytmedia.loadVideoById(this._getMediaId());
	                        this._playStateToggle(true);
	                    }
	                    else {
	                        this._ytmedia.cueVideoById(this._getMediaId());
	                        this._playStateToggle(true);
	                    }
	                }
	            },

	            _createToolbar: function () {
	                var toolBarElement = this.wrapper.find(DOT + TOOLBAR);
	                if (toolBarElement.length === 0) {
	                    this._toolbarClickHandler = proxy(this._toolbarClick, this);
	                    this.wrapper.append(templates.toolBar);
	                    toolBarElement = this.wrapper.find(DOT + TOOLBAR);
	                    toolBarElement.width(this.wrapper.find(DOT + MEDIA).width());
	                    this._toolBar = new ui.ToolBar(toolBarElement, {
	                        click: this._toolbarClickHandler,
	                        resizable: false,
	                        items: [
	                            {
	                                type: "button",
	                                attributes: { "class": "k-play-button" },
	                                icon: "play"
	                            },
	                            {
	                                template: templates.toolBarTime,
	                                attributes: { "class": "k-mediaplayer-currenttime-wrap" }
	                            },
	                            {
	                                type: "separator",
	                                attributes: { "class": "k-toolbar-spacer" }
	                            },
	                            {
	                                type: "button",
	                                attributes: { "class": "k-volume-button" },
	                                icon: "volume-up"
	                            },
	                            {
	                                template: templates.volumeSlider,
	                                attributes: { "class": "k-mediaplayer-volume-wrap" }
	                            },
	                            {
	                                template: templates.qualityDropDown,
	                                attributes: { "class": "k-mediaplayer-quality-wrap" }
	                            },
	                            {
	                                type: "button",
	                                attributes: { "class": "k-fullscreen-button" },
	                                icon: "full-screen"
	                            }
	                        ]
	                    });

	                    this._toolBar.wrapper.off("keydown");
	                    toolBarElement.before(templates.slider);

	                    this._volumeButton = toolBarElement.find(".k-volume-button");
	                    this._fullscreenButton = toolBarElement.find(".k-fullscreen-button");
	                    this._volumeButton.attr("title", this.options.mute ? this.options.messages.unmute : this.options.messages.mute);
	                    this._volumeButton.attr("aria-label", this.options.mute ? this.options.messages.unmute : this.options.messages.mute);
	                    this._fullscreenButton.attr("title", this.options.messages.fullscreen);
	                    this._fullscreenButton.attr("aria-label", this.options.messages.fullscreen);

	                    toolBarElement.width("auto");
	                    this._currentTimeElement = toolBarElement.find(".k-mediaplayer-currenttime");
	                    this._durationElement = toolBarElement.find(".k-mediaplayer-duration");
	                    this._playButton = toolBarElement.find(".k-play-button");
	                    this._playButtonSpan = this._playButton.find(".k-i-play");

	                    if (this.options.autoPlay) {
	                        this._playStateToggle(true);
	                    }

	                    if ( kendo.support.cssFlexbox === false ) {
	                        $([
	                            this._volumeButton[0],
	                            toolBarElement.find(".k-mediaplayer-volume-wrap")[0],
	                            toolBarElement.find(".k-mediaplayer-quality-wrap")[0],
	                            this._fullscreenButton[0]
	                        ]).wrapAll("<div class='k-align-right' />");
	                    }

	                    toolBarElement.find(".k-button").addClass("k-flat");
	                }
	            },

	            _createDropDown: function () {
	                var dropDownElement = this.wrapper.find(DOT + VIDEO_QUALITY);
	                var media = this.media();
	                if (typeof dropDownElement.data("kendoDropDownList") === "undefined") {
	                    this._dropDownSelectHandler = proxy(this._dropDownSelect, this);
	                    this._dropDown = new ui.DropDownList(dropDownElement, {
	                        dataTextField: "quality",
	                        dataValueField: "url",
	                        popup: {
	                            position: "bottom",
	                            origin: "top",
	                            appendTo: this.wrapper
	                        },
	                        animation: {
	                            open: {
	                                effects: "slideIn:up",
	                                duration: 1
	                            }
	                        },
	                        select: this._dropDownSelectHandler
	                    });

	                    if (media && isArray(media.source)) {
	                        this._dropDown.setDataSource(media.source);
	                        this._dropDown.select(0);
	                    }

	                    this._dropDown.wrapper.addClass("k-button k-flat");
	                    this._dropDown.wrapper.attr("title", this.options.messages.quality).hide();
	                    this._dropDown.wrapper.find("span.k-i-arrow-60-down")
	                        .removeClass('k-i-arrow-60-down')
	                        .addClass('k-icon k-i-hd');
	                    this._dropDown.list.addClass("k-quality-list");
	                }
	            },

	            _dropDownSelect: function (e) {
	                if (this._currentIndex !== e.item.index()) {
	                    this._currentIndex = e.item.index();
	                    this._setPlayerUrl();
	                }
	            },

	            _toolbarClick: function (e) {
	                var target = $(e.target).children().first();
	                var isPaused = target.hasClass(STATE_PLAY);

	                if (!this.media()) {
	                    return;
	                }

	                if (target.hasClass(STATE_PLAY) || target.hasClass(STATE_PAUSE)) {
	                    if (isPaused) {
	                        this.play();
	                    }
	                    else {
	                        this.pause();
	                    }
	                }

	                if (target.hasClass(FULLSCREEN_ENTER) || target.hasClass(FULLSCREEN_EXIT)) {
	                    if (this._isInFullScreen) {
	                        target
	                            .removeClass(FULLSCREEN_EXIT)
	                            .addClass(FULLSCREEN_ENTER);
	                        this.fullScreen(false);
	                    } else {
	                        target
	                            .removeClass(FULLSCREEN_ENTER)
	                            .addClass(FULLSCREEN_EXIT);
	                        this.fullScreen(true);
	                    }
	                }

	                if (target.hasClass(MUTE) || target.hasClass(LOW_VOLUME) || target.hasClass(HIGH_VOLUME)) {
	                    var muted = this.mute();
	                    this.mute(!muted);
	                }
	            },

	            _sliderDragging: function () {
	                if (!this.media()) {
	                    return;
	                }

	                this._isDragging = true;
	            },

	            _sliderDragChange: function (e) {
	                var that = this;
	                var slider = e.sender;
	                var tzOffset = timeZoneSec * 1000;

	                if (!this.media()) {
	                    return;
	                }

	                that._sliderChangeFired = true;
	                that._isDragging = false;

	                if (!this.options.forwardSeek && slider.value() > this._seekBarLastPosition) {
	                    setTimeout(function () {
	                        slider.value(that._seekBarLastPosition);
	                    }, 1);
	                } else if (this._youTubeVideo) {
	                    that._ytmedia.seekTo(that._timeToSec(e.value - tzOffset));
	                } else {
	                    that._media.currentTime = that._timeToSec(e.value - tzOffset);
	                }
	                that.trigger(TIMECHANGE);
	                that._preventPlay = true;
	            },

	            _changeVolumeButtonImage: function (volume) {
	                var volumeButton = this._volumeButton;
	                var volumeElement = volumeButton.find("span");
	                var cssClass = volumeElement.attr("class");
	                cssClass = cssClass.substring(0, cssClass.lastIndexOf(" "));

	                if (volume === 0) {
	                    volumeElement.attr("class", cssClass + " " + MUTE);
	                    volumeButton.attr("title", this.options.messages.unmute);
	                    volumeButton.attr("aria-label", this.options.messages.unmute);
	                } else if (volume > 0 && volume < 51) {
	                    volumeElement.attr("class", cssClass + " " + LOW_VOLUME);
	                    volumeButton.attr("title", this.options.messages.mute);
	                    volumeButton.attr("aria-label", this.options.messages.mute);
	                } else {
	                    volumeElement.attr("class", cssClass + " " + HIGH_VOLUME);
	                    volumeButton.attr("title", this.options.messages.mute);
	                    volumeButton.attr("aria-label", this.options.messages.mute);
	                }
	            },

	            _volumeDragging: function (e) {
	                if (!this.media()) {
	                    return;
	                }
	                this.volume(e.value);
	                this._changeVolumeButtonImage(e.value);
	                this.trigger(VOLUMECHANGE);
	            },

	            _volumeChange: function (e) {
	                if (!this.media()) {
	                    return;
	                }
	                this.volume(e.value);
	                this._changeVolumeButtonImage(e.value);
	                this.trigger(VOLUMECHANGE);
	            },

	            _mediaTimeUpdate: function () {
	                var currentTime = (this._youTubeVideo) ? this._ytmedia.getCurrentTime() : this._media.currentTime;
	                currentTime = currentTime ? currentTime : 0;
	                var timeInMs = this._msToTime(currentTime);
	                this._currentTimeElement.text(kendo.toString(timeInMs, this._timeFormat));
	                if (!this._isDragging) {
	                    this._seekBarLastPosition = (currentTime + timeZoneSec) * 1000;
	                    this._slider.value(this._seekBarLastPosition);
	                }

	                return this.isPlaying();
	            },

	            _playStateToggle: function (play) {
	                if (typeof play === "undefined") {
	                    play = this._playButtonSpan.is(DOT + STATE_PLAY);
	                }

	                if (play) {
	                    this._playButtonSpan
	                        .removeClass(STATE_PLAY)
	                        .addClass(STATE_PAUSE);
	                    this._playButton.attr("title", this.options.messages.pause);
	                    this._playButton.attr("aria-label", this.options.messages.pause);
	                }
	                else {
	                    this._playButtonSpan
	                        .removeClass(STATE_PAUSE)
	                        .addClass(STATE_PLAY);
	                    this._playButton.attr("title", this.options.messages.play);
	                    this._playButton.attr("aria-label", this.options.messages.play);
	                }
	            },

	            _mediaEnded: function () {
	                this._playStateToggle(false);
	                this._currentTimeElement.text(kendo.toString(this._msToTime(0), this._timeFormat));
	                this._slider.value((0 + timeZoneSec) * 1000);
	                this.trigger(END);
	            },

	            _mediaPlay: function () {
	                this.trigger(PLAY);
	            },

	            _mediaReady: function () {
	                this.trigger(READY);
	            },

	            _mediaDurationChange: function () {
	                var durationTime = this._msToTime((this._youTubeVideo) ? this._ytmedia.getDuration() : this._media.duration);

	                this._timeFormat = durationTime.getHours() === 0 ? timeFormats.shortTime : timeFormats.longTime;

	                this._durationElement.text(kendo.toString(durationTime, this._timeFormat));
	                this._slider.setOptions({
	                    min: baseTime.getTime(),
	                    max: durationTime.getTime()
	                });

	                if (!this._isFirstRun) {
	                    this._resetTime();
	                    this._isFirstRun = true;
	                }
	            },

	            _createYoutubePlayer: function () {
	                this._mediaTimeUpdateHandler = proxy(this._mediaTimeUpdate, this);
	                this._mediaDurationChangeHandler = proxy(this._mediaDurationChange, this);

	                this.wrapper.prepend(templates.youtubePlayer);
	                this._ytPlayer = this.wrapper.find(DOT + YTPLAYER)[0];
	                $(this._ytPlayer)
	                    .css({
	                        width: this.wrapper.width(),
	                        height: this.wrapper.height()
	                    });

	                if (!window.YT || !window.YT.Player) {
	                    if (!window.onYouTubeIframeAPIReadyRegister) {
	                        window.onYouTubeIframeAPIReadyRegister = [];
	                        $.getScript("https://www.youtube.com/iframe_api");
	                        window.onYouTubeIframeAPIReady =
	                            function () {
	                                if (window.onYouTubeIframeAPIReadyRegister) {
	                                    for (var i = 0; i < window.onYouTubeIframeAPIReadyRegister.length; i++) {
	                                        window.onYouTubeIframeAPIReadyRegister[i]._youtubeApiReady();
	                                    }
	                                }
	                                window.onYouTubeIframeAPIReadyRegister.length = 0;
	                                window.onYouTubeIframeAPIReadyRegister = undefined;
	                            };
	                    }
	                    window.onYouTubeIframeAPIReadyRegister[window.onYouTubeIframeAPIReadyRegister.length] = this;
	                }
	                else {
	                    this._configurePlayer();
	                }
	            },

	            _poll: function (name, callback, interval, context) {
	                var that = this;

	                if (that._timers[name] !== null) {
	                    clearTimeout(that._timers[name]);
	                }

	                that._timers[name] = setTimeout((function (context) {
	                    return function callLater() {
	                        if (callback.call(context)) {
	                            that._timers[name] = setTimeout(callLater, interval);
	                        }
	                    };
	                })(context), interval);

	                return that._timers[name];
	            },

	            _youtubeApiReady: function () {
	                this._configurePlayer();
	            },

	            _configurePlayer: function () {
	                var vars = {
	                    'autoplay': +this.options.autoPlay,
	                    'wmode': 'transparent',
	                    'controls': 0,
	                    'rel': 0,
	                    'showinfo': 0
	                };

	                this._onYouTubePlayerReady = proxy(this._onYouTubePlayerReady, this);
	                window.onYouTubePlayerReady = this._onYouTubePlayerReady;
	                this._onPlayerStateChangeHandler = proxy(this._onPlayerStateChange, this);
	                window.onPlayerStateChange = this._onPlayerStateChange;

	                /*jshint unused:false */
	                var player = new window.YT.Player(this.wrapper.find(DOT + YTPLAYER)[0], {
	                    height: this.wrapper.height(),
	                    width: this.wrapper.width(),
	                    videoId: this._getMediaId(),
	                    playerVars: vars,
	                    events: {
	                        'onReady': this._onYouTubePlayerReady,
	                        'onStateChange': this._onPlayerStateChangeHandler
	                    }
	                });
	            },

	            _onYouTubePlayerReady: function (event) {
	                this._ytmedia = event.target;
	                this._ytmedia.getIframe().style.width = "100%";
	                this._ytmedia.getIframe().style.height = "100%";
	                this._youTubeVideo = true;
	                this._mediaDurationChangeHandler();

	                if (this.options.autoPlay) {
	                    this._playStateToggle(true);
	                    this._ytmedia.loadVideoById(this._getMediaId());
	                }
	                else {
	                    this._ytmedia.cueVideoById(this._getMediaId());
	                }

	                if (this.options.mute) {
	                    this.mute(true);
	                }

	                this.trigger(READY);
	            },

	            _updateTitle: function () {
	                this.titlebar().text(this.media().title || this.media().source);
	            },

	            _onPlayerStateChange: function (event) {

	                if (event.data === 0) {
	                    this._slider.value(0);
	                    this._paused = false;
	                    this._playStateToggle(true);
	                    this.trigger(END);
	                    if (this.options.autoRepeat) {
	                        this.play();
	                    }
	                }
	                else if (event.data === 1) {
	                    this._mediaDurationChange();
	                    this._ytmedia.setVolume(this.volume());
	                    if (this._sliderChangeFired) {
	                        this._sliderChangeFired = false;
	                    } else {
	                        this._uiDisplay(false);
	                    }
	                    this.trigger(PLAY);
	                    this._playStateToggle(true);

	                    this._poll("progress", this._mediaTimeUpdate, 500, this);
	                    this._paused = false;
	                }
	                else if (event.data === 2) {
	                    if (!this._paused) {
	                        this._uiDisplay(true);
	                        this._playStateToggle(false);
	                        this.trigger(PAUSE);
	                        this._paused = true;
	                    }
	                }
	            },

	            _getMediaId: function () {
	                var result = this._currentUrl();
	                var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
	                var match = result.match(regExp);

	                if (match && match[7].length === 11) {
	                    result = match[7];
	                }

	                return result;
	            },

	            _mouseClick: function () {
	                if (this.isPaused()) {
	                    this.play();
	                } else {
	                    this.pause();
	                }
	            },

	            _initializePlayer: function () {
	                if (!this._mouseMoveHandler) {
	                    this._mouseMoveHandler = proxy(this._mouseMove, this);
	                    this._mouseInHandler = proxy(this._mouseIn, this);
	                    this._mouseOutHandler = proxy(this._mouseOut, this);

	                    $(this.wrapper)
	                        .on("mouseenter" + ns, this._mouseInHandler)
	                        .on("mouseleave" + ns, this._mouseOutHandler)
	                        .on("mousemove" + ns, this._mouseMoveHandler);
	                }

	                if (!this._ytmedia && this._youTubeVideo) {
	                    this._createYoutubePlayer();
	                }
	                else if (!this._media && !this._youTubeVideo) {
	                    this._createHtmlPlayer();
	                }
	            },

	            _createHtmlPlayer: function () {
	                if (!this._videoOverlay) {
	                    this._mouseClickHanlder = proxy(this._mouseClick, this);
	                    this.wrapper.append("<div class='" + OVERLAY + "'></div>");
	                    this._videoOverlay = this.wrapper.find(".k-mediaplayer-overlay")
	                        .on("click" + ns, this._mouseClickHanlder);
	                }

	                this._mediaTimeUpdateHandler = proxy(this._mediaTimeUpdate, this);
	                this._mediaDurationChangeHandler = proxy(this._mediaDurationChange, this);
	                this._mediaEndedHandler = proxy(this._mediaEnded, this);
	                this._mediaCanPlayHandler = proxy(this._mediaReady, this);
	                this._mediaPlayHandler = proxy(this._mediaPlay, this);
	                this._videoOverlay.after(templates.htmlPlayer);
	                this._media = this.wrapper.find(DOT + MEDIA)[0];
	                $(this._media)
	                    .css({
	                        width: "100%",
	                        height: "100%"
	                    });

	                if (this.options.mute) {
	                    this.mute(true);
	                }

	                this._media.ontimeupdate = this._mediaTimeUpdateHandler;
	                this._media.ondurationchange = this._mediaDurationChangeHandler;
	                this._media.oncanplay = this._mediaCanPlayHandler;
	                this._media.onplay = this._mediaPlayHandler;
	                this._media.onended = this._mediaEndedHandler;
	                this._media.loop = this.options.autoRepeat;
	            },

	            _mouseIn: function () {
	                this._uiDisplay(true);
	            },

	            _mouseOut: function () {
	                this._poll("mouseIdle", this._mouseIdle, 3000, this);
	            },

	            _mouseIdle: function () {
	                this._uiDisplay(false);
	                return false;
	            },

	            _mouseMove: function () {
	                if (!(this._titleBar.is(':animated') || this._toolBar.element.is(':animated') || this._slider.wrapper.is(':animated'))) {
	                    this._uiDisplay(true);
	                }
	                this._poll("mouseIdle", this._mouseIdle, 3000, this);
	            },

	            _uiDisplay: function (state) {
	                var animationSpeed = 'slow';
	                var uiElements = this._titleBar
	                    .add(this._toolBar.element.parent());

	                if (state) {
	                    uiElements.fadeIn(animationSpeed);
	                }
	                else {
	                    uiElements.fadeOut(animationSpeed);
	                    if (this.options.navigatable) {
	                        this.wrapper.focus();
	                    }
	                }
	            },

	            setOptions: function (options) {
	                Widget.fn.setOptions.call(this, options);
	            },

	            destroy: function () {
	                Widget.fn.destroy.call(this);

	                if (!this.isPaused()) {
	                    this.pause();
	                }

	                this.element.off(ns);
	                this.element.find(DOT + OVERLAY).off(ns);
	                this._timers = null;
	                this._mouseMoveHandler = null;
	                this._mouseOutHandler = null;
	                this._mouseInHandler = null;
	                this._mouseClickHanlder = null;
	                this._keyDownHandler = null;
	                this._fullscreenHandler = null;

	                this._toolbarClickHandler = null;
	                this._sliderDragChangeHandler = null;
	                this._sliderDraggingHandler = null;
	                this._volumeDraggingHandler = null;
	                this._volumeChangeHandler = null;
	                this._youtubeApiReadyHandler = null;
	                this._onYouTubePlayerReady = null;
	                this._onPlayerStateChangeHandler = null;
	                this._dropDownSelectHandler = null;

	                if (this._youTubeVideo) {
	                    this._ytmedia.destroy();
	                }
	                else {
	                    this._media.ontimeupdate = this._mediaTimeUpdateHandler = null;
	                    this._media.ondurationchange = this._mediaDurationChangeHandler = null;
	                    this._media.oncanplay = this._mediaCanPlayHandler = null;
	                    this._media.onplay = this._mediaPlayHandler = null;
	                    this._media.onended = this._mediaEndedHandler = null;
	                    this._media.src = "";
	                    this._media.remove();
	                }

	                this._mouseMoveTimer = null;
	                clearTimeout(this._mouseMoveTimer);

	                kendo.destroy(this.element);
	            },

	            seek: function (ms) {
	                if (typeof ms === 'undefined') {
	                    return 1000 * (this._youTubeVideo) ? this._ytmedia.getCurrentTime() : (this._media ? this._media.currentTime : 0);
	                }
	                var seconds = ms / 1000;
	                if (this._youTubeVideo) {
	                    if (seconds + 3 >= this._ytmedia.getDuration() | 0) {
	                        //avoid infinite bad request loop in youtube player.
	                        this._ytmedia.seekTo(this._ytmedia.getDuration() - 3 | 0, true);
	                    } else {
	                        this._ytmedia.seekTo(seconds, true);
	                    }
	                } else {
	                    this._media.currentTime = seconds;
	                }

	                return this;
	            },

	            play: function () {
	                if (this._youTubeVideo) {
	                    this._ytmedia.playVideo();
	                } else {
	                    if (kendo.support.mobileOS) {
	                        this._uiDisplay(false);
	                    }
	                    this._media.play();
	                }
	                this._paused = false;

	                this._playStateToggle(true);

	                return this;
	            },

	            stop: function () {
	                if (this._youTubeVideo && this._ytmedia) {
	                    this._ytmedia.stopVideo();
	                } else if (this._media && !this._youTubeVideo) {
	                    if (kendo.support.mobileOS) {
	                        this._uiDisplay(true);
	                    }
	                    this._media.pause();
	                    this._media.currentTime = 0;
	                }
	                this._paused = true;

	                this._playStateToggle(false);
	                return this;
	            },

	            pause: function () {
	                if (this._youTubeVideo) {
	                    this._ytmedia.pauseVideo();
	                } else {
	                    if (kendo.support.mobileOS) {
	                        this._uiDisplay(true);
	                    }
	                    this._media.pause();
	                }
	                this._paused = true;
	                this._playStateToggle(false);
	                this.trigger(PAUSE);
	                return this;
	            },

	            toolbar: function () {
	                return this._toolBar;
	            },

	            dropdown: function () {
	                return this._dropDown;
	            },

	            titlebar: function () {
	                return this._titleBar;
	            },

	            fullScreen: function (enterFullScreen) {
	                if (typeof enterFullScreen === 'undefined') {
	                    return this._isInFullScreen || false;
	                }
	                var element = this.element.get(0);
	                if (enterFullScreen) {
	                    // Handles the case when the action is triggered by code and not by user iteraction
	                    this.element.addClass("k-mediaplayer-fullscreen");
	                    if (element.requestFullscreen) {
	                        element.requestFullscreen();
	                    } else if (element.webkitRequestFullscreen) {
	                        element.webkitRequestFullscreen();
	                    } else if (element.mozRequestFullScreen) {
	                        element.mozRequestFullScreen();
	                    } else if (element.msRequestFullscreen) {
	                        element.msRequestFullscreen();
	                    }
	                    this._isInFullScreen = true;
	                } else {

	                    if (document.cancelFullscreen) {
	                        document.cancelFullscreen();
	                    } else if (document.webkitCancelFullScreen) {
	                        document.webkitCancelFullScreen();
	                    } else if (document.mozCancelFullScreen) {
	                        document.mozCancelFullScreen();
	                    } else if (document.msCancelFullscreen) {
	                        document.msCancelFullscreen();
	                    } else if (document.exitFullscreen) {
	                        document.exitFullscreen();
	                    } else if (document.msExitFullscreen) {
	                        document.msExitFullscreen();
	                    }
	                    // Handles the case when the action is triggered by code and not by user iteraction
	                    this.element.removeClass("k-mediaplayer-fullscreen");
	                    this._isInFullScreen = false;
	                }
	                this._slider.resize();
	            },

	            volume: function (value) {
	                if (typeof value === 'undefined') {
	                    return (typeof this._volume !== 'undefined') ? this._volume : this._volume = this.options.volume;
	                }
	                this._volume = value;
	                this.mute(value <= 0);

	                if (this._youTubeVideo) {
	                    this._ytmedia.setVolume(this._volume);
	                } else {
	                    this._media.volume = this._volume / 100;
	                }

	                this._volumeSlider.value(value);
	            },

	            mute: function (muted) {
	                var currentState = this._youTubeVideo ? (this._ytmedia && this._ytmedia.isMuted()) : (this._media && this._media.muted);
	                if (typeof muted === 'undefined' || muted === currentState) {
	                    return currentState;
	                }
	                if (this._youTubeVideo) {
	                    if (muted) {
	                        this._ytmedia.mute();
	                    }
	                    else {
	                        this._ytmedia.unMute();
	                    }
	                }
	                else {
	                    this._media.muted = muted;
	                }

	                if (muted) {
	                    this._volumeSlider.value(0);
	                }
	                else {
	                    this._volumeSlider.value((this._media && this._media.volume * 100) || (this._ytmedia && this._ytmedia.getVolume()));
	                }
	                this.trigger(VOLUMECHANGE);
	                this._changeVolumeButtonImage(this._volumeSlider.value());
	            },

	            isEnded: function () {
	                if (this._youTubeVideo) {
	                    return this._ytmedia.getPlayerState() === 0;
	                } else {
	                    return this._media.ended;
	                }
	            },

	            media: function (value) {
	                var dropdown = this.dropdown();
	                if (typeof value === 'undefined') {
	                    return (typeof this._mediaData !== 'undefined') ? this._mediaData : this._mediaData = this.options.media;
	                }

	                if (isArray(value.source)) {
	                    dropdown.setDataSource(value.source);
	                    dropdown.wrapper.show();
	                }
	                else {
	                    dropdown.wrapper.hide();
	                }

	                this._mediaData = value;

	                this._updateTitle();

	                this._setPlayerUrl();
	            },

	            isPaused: function () {
	                return this._paused;
	            },

	            isPlaying: function () {
	                return !this.isEnded() && !this._paused;
	            },

	            _aria: function () {
	                this.wrapper.attr("role", "region");
	                //this.wrapper.attr("aria-labelledby", "mediaplayerTitleBar");
	                //add onfocus with aria active descendant
	            },

	            _navigatable: function () {
	                this._fullscreenHandler = proxy(this._fullscreen, this);
	                $(document)
	                    .on("webkitfullscreenchange mozfullscreenchange fullscreenchange" + ns, this._fullscreenHandler);

	                if (this.options.navigatable) {
	                    this.wrapper.attr("tabIndex", 0);
	                    this._keyDownHandler = proxy(this._keyDown, this);
	                    this.wrapper
	                        .on("keydown" + ns, this._keyDownHandler);
	                }
	            },

	            _fullscreen: function () {
	                var isFullScreen = document.fullScreen ||
	                    document.mozFullScreen ||
	                    document.webkitIsFullScreen;

	                this._uiDisplay(true);
	                this._slider.resize();

	                if (!isFullScreen) {
	                    this.wrapper.find('span[class*="k-i-fullscreen"]')
	                        .removeClass(FULLSCREEN_EXIT)
	                        .addClass(FULLSCREEN_ENTER);
	                    this.fullScreen(false);
	                }
	            },

	            _keyDown: function (e) {
	                e.preventDefault();
	                var fsButton = this.wrapper.find('span[class*="k-i-fullscreen"]');
	                if (e.keyCode === keys.SPACEBAR) {
	                    if (this.isPlaying()) {
	                        this.pause();
	                    }
	                    else {
	                        this.play();
	                    }
	                }
	                else if (e.keyCode === keys.ENTER && !this._isInFullScreen) {
	                    fsButton
	                        .removeClass(FULLSCREEN_ENTER)
	                        .addClass(FULLSCREEN_EXIT);
	                    this.fullScreen(true);
	                }
	                else if (e.keyCode === 77) {
	                    var muted = this.mute();
	                    this.mute(!muted);
	                }
	                else if (e.keyCode === keys.ESC && this._isInFullScreen) {
	                    fsButton
	                        .removeClass(FULLSCREEN_EXIT)
	                        .addClass(FULLSCREEN_ENTER);
	                    this.fullScreen(false);
	                }
	            },

	            _error: function () {
	            },

	            _progress: function () {
	            }

	        });

	        ui.plugin(MediaPlayer);

	    })(window.kendo.jQuery);

	    return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1291:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nce5");

/***/ })

/******/ });

/***/ }),

/***/ "9jRp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var filterManager_1 = __webpack_require__("Up6z");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var FilterService = (function () {
    function FilterService() {
    }
    FilterService.prototype.postConstruct = function () {
        this.doingTreeData = this.gridOptionsWrapper.isTreeData();
    };
    FilterService.prototype.filterAccordingToColumnState = function (rowNode) {
        var filterActive = this.filterManager.isAnyFilterPresent();
        this.filter(rowNode, filterActive);
    };
    FilterService.prototype.filter = function (rowNode, filterActive) {
        var _this = this;
        // recursively get all children that are groups to also filter
        if (rowNode.hasChildren()) {
            rowNode.childrenAfterGroup.forEach(function (node) { return _this.filter(node, filterActive); });
            // result of filter for this node
            if (filterActive) {
                rowNode.childrenAfterFilter = rowNode.childrenAfterGroup.filter(function (childNode) {
                    // a group is included in the result if it has any children of it's own.
                    // by this stage, the child groups are already filtered
                    var passBecauseChildren = childNode.childrenAfterFilter && childNode.childrenAfterFilter.length > 0;
                    // both leaf level nodes and tree data nodes have data. these get added if
                    // the data passes the filter
                    var passBecauseDataPasses = childNode.data && _this.filterManager.doesRowPassFilter(childNode);
                    // note - tree data nodes pass either if a) they pass themselves or b) any children of that node pass
                    return passBecauseChildren || passBecauseDataPasses;
                });
            }
            else {
                // if not filtering, the result is the original list
                rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            }
            this.setAllChildrenCount(rowNode);
        }
        else {
            rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            rowNode.setAllChildrenCount(null);
        }
    };
    FilterService.prototype.setAllChildrenCountTreeData = function (rowNode) {
        // for tree data, we include all children, groups and leafs
        var allChildrenCount = 0;
        rowNode.childrenAfterFilter.forEach(function (child) {
            // include child itself
            allChildrenCount++;
            // include children of children
            allChildrenCount += child.allChildrenCount;
        });
        rowNode.setAllChildrenCount(allChildrenCount);
    };
    FilterService.prototype.setAllChildrenCountGridGrouping = function (rowNode) {
        // for grid data, we only count the leafs
        var allChildrenCount = 0;
        rowNode.childrenAfterFilter.forEach(function (child) {
            if (child.group) {
                allChildrenCount += child.allChildrenCount;
            }
            else {
                allChildrenCount++;
            }
        });
        rowNode.setAllChildrenCount(allChildrenCount);
    };
    FilterService.prototype.setAllChildrenCount = function (rowNode) {
        if (this.doingTreeData) {
            this.setAllChildrenCountTreeData(rowNode);
        }
        else {
            this.setAllChildrenCountGridGrouping(rowNode);
        }
    };
    __decorate([
        context_1.Autowired('filterManager'),
        __metadata("design:type", filterManager_1.FilterManager)
    ], FilterService.prototype, "filterManager", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], FilterService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FilterService.prototype, "postConstruct", null);
    FilterService = __decorate([
        context_1.Bean("filterService")
    ], FilterService);
    return FilterService;
}());
exports.FilterService = FilterService;


/***/ }),

/***/ "AJsk":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1184);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1184:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1185), __webpack_require__(1086) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "dropdowntree",
	    name: "DropDownTree",
	    category: "web",
	    description: "The DropDownTree widget displays a hierarchy of items and allows the selection of single or multiple items.",
	    depends: [ "treeview", "popup" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        TreeView = ui._dropdowntree,
	        ObservableArray = kendo.data.ObservableArray,
	        ObservableObject = kendo.data.ObservableObject,
	        extend = $.extend,
	        activeElement = kendo._activeElement,
	        ns = ".kendoDropDownTree",
	        keys = kendo.keys,
	        support = kendo.support,
	        HIDDENCLASS = "k-hidden",
	        WIDTH = "width",
	        browser = support.browser,
	        outerWidth = kendo._outerWidth,
	        DOT = ".",
	        DISABLED = "disabled",
	        READONLY = "readonly",
	        STATEDISABLED = "k-state-disabled",
	        ARIA_DISABLED = "aria-disabled",
	        ARIA_READONLY = "aria-readonly",
	        HOVER = "k-state-hover",
	        FOCUSED = "k-state-focused",
	        HOVEREVENTS = "mouseenter" + ns + " mouseleave" + ns,
	        TABINDEX = "tabindex",
	        CLICK = "click",
	        OPEN = "open",
	        CLOSE = "close",
	        CHANGE = "change",
	        quotRegExp = /"/g,
	        proxy = $.proxy;

	    var DropDownTree = kendo.ui.Widget.extend( {
	        init: function(element, options) {
	            this.ns = ns;

	            kendo.ui.Widget.fn.init.call(this, element, options);
	            this._selection = this._getSelection();
	            this._focusInputHandler = $.proxy(this._focusInput, this);
	            this._initial = this.element.val();

	            this._values = [];

	            var value = this.options.value;

	            if (value === null || !value.length) {
	                this._noInitialValue = true;
	            }

	            if (!this._isNullorUndefined(value)) {
	                this._valueMethodCalled = true;
	                this._values = $.isArray(value) ? value.slice(0) : [value];
	            }

	            this._inputTemplate();

	            this._accessors();
	            this._setTreeViewOptions(this.options);
	            this._dataSource();
	            this._selection._initWrapper();
	            this._placeholder(true);
	            this._tabindex();
	            this.wrapper.data(TABINDEX, this.wrapper.attr(TABINDEX));

	            this.tree = $('<div/>')
	            .attr({
	                tabIndex: -1,
	                "aria-hidden": true
	            });

	            this.list = $("<div class='k-list-container'/>")
	                .append(this.tree);

	            this._header();
	            this._noData();
	            this._footer();
	            this._reset();
	            this._popup();
	            this.popup.one("open", proxy(this._popupOpen, this));
	            this._clearButton();
	            this._filterHeader();
	            this._treeview();

	            this._renderFooter();

	            this._checkAll();
	            this._enable();
	            this._toggleCloseVisibility();

	            if (!this.options.autoBind) {
	                var text = options.text || "";
	                if (!this._isNullorUndefined(options.value)) {
	                    this._preselect(options.value);
	                } else if (text) {
	                    this._textAccessor(text);
	                } else if (options.placeholder) {
	                    this._placeholder(true);
	                }
	            }

	            var disabled = $(this.element).parents("fieldset").is(':disabled');

	            if (disabled) {
	                this.enable(false);
	            }
	            this._valueMethodCalled = false;
	            kendo.notify(this);
	        },

	        _preselect: function(data, value){
	            this._selection._preselect(data, value);
	        },

	        _setTreeViewOptions: function(options) {
	            var treeviewOptions = {
	                autoBind: options.autoBind,
	                checkboxes: options.checkboxes,
	                dataImageUrlField: options.dataImageUrlField,
	                dataSpriteCssClassField: options.dataSpriteCssClassField,
	                dataTextField: options.dataTextField,
	                dataUrlField: options.dataUrlField,
	                loadOnDemand: options.loadOnDemand
	            };

	            this.options.treeview = $.extend({}, treeviewOptions, this.options.treeview);

	            if (options.template) {
	                this.options.treeview.template = options.template;
	            }
	        },

	        _dataSource: function() {
	            var rootDataSource = this.options.dataSource;

	            this.dataSource = kendo.data.HierarchicalDataSource.create(rootDataSource);
	            if (rootDataSource) {
	                $.extend(this.options.treeview,{
	                    dataSource: this.dataSource
	                });
	            }
	        },

	        _popupOpen: function() {
	            var popup = this.popup;
	            popup.wrapper = kendo.wrap(popup.element);
	        },

	        _getSelection: function() {
	            if (this._isMultipleSelection()) {
	                return new ui.DropDownTree.MultipleSelection(this);
	            } else {
	                return new ui.DropDownTree.SingleSelection(this);
	            }
	        },

	        setDataSource: function(dataSource) {
	            this._isDataSourceSet = true;
	            if(this._tags){
	                this._noInitialValue = true;
	                this.setValue([]);
	                this._tags.empty();
	                this.span.show();
	                this._multipleTags.empty();
	            }
	            this.dataSource = dataSource;
	            this.treeview.setDataSource(dataSource);
	            this._isDataSourceSet = false;
	        },

	        _isMultipleSelection: function() {
	            return this.options && (this.options.treeview.checkboxes || this.options.checkboxes);
	        },

	        options: {
	            name: "DropDownTree",
	            animation: {},
	            autoBind: true,
	            autoClose: true,
	            autoWidth: false,
	            clearButton: true,
	            dataTextField: "",
	            dataValueField: "",
	            dataImageUrlField: "",
	            dataSpriteCssClassField: "",
	            dataUrlField: "",
	            delay: 500,
	            enabled: true,
	            enforceMinLength: false,
	            filter: "none",
	            height: 200,
	            ignoreCase: true,
	            index: 0,
	            loadOnDemand: false,
	            messages: {
	                "singleTag": "item(s) selected",
	                "clear": "clear",
	                "deleteTag": "delete",
	                "noData": "No data found."
	            },
	            minLength: 1,
	            checkboxes: false,
	            noDataTemplate: true,
	            placeholder: "",
	            checkAll:false,
	            checkAllTemplate: "Check all",
	            tagMode: "multiple",
	            template: null,
	            text: null,
	            treeview: {},
	            valuePrimitive: false,
	            footerTemplate: "",
	            headerTemplate: "",
	            value: null,
	            valueTemplate: null,
	            popup: null
	        },

	        events: [
	            "open",
	            "close",
	            "dataBound",
	            CHANGE,
	            "select",
	            "filtering"
	        ],

	        focus: function() {
	            this.wrapper.focus();
	        },

	        dataItem: function (node){
	            return this.treeview.dataItem(node);
	        },

	        readonly: function(readonly) {
	            this._editable({
	                readonly: readonly === undefined ? true : readonly,
	                disable: false
	            });
	            this._toggleCloseVisibility();
	        },

	        enable: function(enable) {
	            this._editable({
	                readonly: false,
	                disable: !(enable = enable === undefined ? true : enable)
	            });
	            this._toggleCloseVisibility();
	        },

	        toggle: function(open) {
	            this._toggle(open);
	        },

	        open: function() {
	            var popup = this.popup;

	            if(!this.options.autoBind && !this.dataSource.data().length){
	                this.treeview._progress(true);
	                if(this._isFilterEnabled()){
	                    this._search();
	                } else {
	                    this.dataSource.fetch();
	                }
	            }

	            if (popup.visible() || !this._allowOpening()) {
	                return;
	            }

	            if(this._isMultipleSelection()){
	                popup.element.addClass("k-multiple-selection");
	            }
	            popup.element.addClass("k-popup-dropdowntree");

	            popup.one("activate", this._focusInputHandler);
	            popup._hovered = true;
	            popup.open();
	        },

	        close: function() {
	            this.popup.close();
	        },

	        search: function(word) {
	            var options = this.options;
	            var filter;
	            clearTimeout(this._typingTimeout);

	            if ((!options.enforceMinLength && !word.length) || word.length >= options.minLength) {
	                filter = this._getFilter(word);
	                if(this.trigger("filtering", { filter: filter }) ||
	                 $.isArray(this.options.dataTextField)){
	                    return;
	                }

	                this._filtering = true;
	                this.treeview.dataSource.filter(filter);
	            }
	        },

	        _getFilter: function (word){
	            return {
	                field: this.options.dataTextField,
	                operator: this.options.filter,
	                value: word,
	                ignoreCase: this.options.ignoreCase
	              };
	        },

	        refresh: function() {
	            var data = this.treeview.dataSource.flatView();
	            this._renderFooter();
	            this._renderNoData();
	            if (this.filterInput && this.checkAll) {
	                this.checkAll.toggle(!this.filterInput.val().length);
	            }

	            this.tree.toggle(!!data.length);
	            $(this.noData).toggle(!data.length);
	        },

	        setOptions: function(options) {
	            Widget.fn.setOptions.call(this, options);

	            this._setTreeViewOptions(options);
	            this._dataSource();
	            if (this.options.treeview) {
	                this.treeview.setOptions(this.options.treeview);
	            }

	            if (options.height && this.tree) {
	                this.tree.css('max-height', options.height);
	            }

	            this._header();
	            this._noData();
	            this._footer();

	            this._renderFooter();
	            this._renderNoData();
	            if (this.span && (this._isMultipleSelection() || this.span.hasClass("k-readonly"))) {
	                this._placeholder(true);
	            }
	            this._inputTemplate();
	            this._accessors();
	            this._filterHeader();
	            this._checkAll();
	            this._enable();
	            if (options && (options.enable || options.enabled)) {
	                this.enable(true);
	            }
	            this._clearButton();
	        },

	        destroy: function() {
	            kendo.ui.Widget.fn.destroy.call(this);
	            if(this.treeview){
	                this.treeview.destroy();
	            }
	            this.popup.destroy();

	            this.wrapper.off(ns);
	            this._clear.off(ns);
	            this._inputWrapper.off(ns);
	            if (this.filterInput) {
	                this.filterInput.off(ns);
	            }

	            if(this.tagList){
	                this.tagList.off(ns);
	            }

	            kendo.unbind(this.tagList);
	            if (this.options.checkAll && this.checkAll) {
	                this.checkAll.off(ns);
	            }

	            if (this._form) {
	                this._form.off("reset", this._resetHandler);
	            }
	        },

	        setValue: function(value) {
	            value = $.isArray(value) || value instanceof ObservableArray ? value.slice(0) : [value];

	            this._values = value;
	        },

	        items: function() {
	            return this.treeview.items();
	        },

	        value: function(value) {
	            var that = this;

	            if(value){
	                if(that.filterInput && that.dataSource._filter){
	                    that._filtering = true;
	                    that.dataSource.filter({});
	                } else if (!that.dataSource.data().length || !that.treeview.dataSource.data().length){
	                    that.dataSource.fetch(function() {
	                        if(that.options.loadOnDemand){
	                            that._selection._setValue(value);
	                        } else {
	                            that.one('allNodesAreLoaded', function(){
	                                that._selection._setValue(value);
	                            });
	                        }
	                    });

	                    return;
	                }
	            }

	            return that._selection._setValue(value);
	        },

	        text: function(text) {
	            var loweredText;
	            var ignoreCase = this.options.ignoreCase;

	            text = text === null ? "" : text;

	            if (text !== undefined && !this._isMultipleSelection()) {
	                if (typeof text !== "string") {
	                    this._textAccessor(text);
	                    return;
	                }

	                loweredText = ignoreCase ? text : text.toLowerCase();

	                this._selectItemByText(loweredText);

	                this._textAccessor(loweredText);
	            } else {
	                return this._textAccessor();
	            }
	        },

	        _header: function() {
	            var list = this;
	            var header = $(list.header);
	            var template = list.options.headerTemplate;

	            this._angularElement(header, "cleanup");
	            kendo.destroy(header);
	            header.remove();

	            if (!template) {
	                list.header = null;
	                return;
	            }

	            var headerTemplate = typeof template !== "function" ? kendo.template(template) : template;
	            header = $(headerTemplate({}));

	            list.header = header[0] ? header : null;
	            list.list.prepend(header);

	            this._angularElement(list.header, "compile");
	        },

	        _noData: function() {
	            var list = this;
	            var noData = $(list.noData);
	            var template = list.options.noDataTemplate === true ?  list.options.messages.noData : list.options.noDataTemplate;

	            list.angular("cleanup", function() { return { elements: noData }; });
	            kendo.destroy(noData);
	            noData.remove();

	            if (!template) {
	                list.noData = null;
	                return;
	            }

	            list.noData = $('<div class="k-nodata" style="display:none"><div></div></div>').appendTo(list.list);
	            list.noDataTemplate = typeof template !== "function" ? kendo.template(template) : template;
	        },

	        _renderNoData: function() {
	            var list = this;
	            var noData = list.noData;

	            if (!noData) {
	                return;
	            }

	            this._angularElement(noData, "cleanup");
	            noData.children(":first").html(list.noDataTemplate({ instance: list }));
	            this._angularElement(noData, "compile");
	        },

	        _footer: function() {
	            var list = this;
	            var footer = $(list.footer);
	            var template = list.options.footerTemplate;

	            this._angularElement(footer, "cleanup");
	            kendo.destroy(footer);
	            footer.remove();

	            if (!template) {
	                list.footer = null;
	                return;
	            }

	            list.footer = $('<div class="k-footer"></div>').appendTo(list.list);
	            list.footerTemplate = typeof template !== "function" ? kendo.template(template) : template;
	        },

	        _renderFooter: function() {
	            var list = this;
	            var footer = list.footer;

	            if (!footer) {
	                return;
	            }

	            this._angularElement(footer, "cleanup");
	            footer.html(list.footerTemplate({ instance: list }));
	            this._angularElement(footer, "compile");
	        },

	        _enable: function() {
	            var that = this,
	                options = that.options,
	                disabled = that.element.is("[disabled]");

	            if (options.enable !== undefined) {
	                options.enabled = options.enable;
	            }

	            if (!options.enabled || disabled) {
	                that.enable(false);
	            } else {
	                that.readonly(that.element.is("[readonly]"));
	            }
	        },

	        _adjustListWidth: function() {
	            var that = this,
	                list = that.list,
	                width = list[0].style.width,
	                wrapper = that.wrapper,
	                computedStyle, computedWidth;

	            if (!list.data(WIDTH) && width) {
	                return;
	            }

	            computedStyle = window.getComputedStyle ? window.getComputedStyle(wrapper[0], null) : 0;
	            computedWidth = parseFloat(computedStyle  && computedStyle.width) || outerWidth(wrapper);

	            if (computedStyle && browser.msie) { // getComputedStyle returns different box in IE.
	                computedWidth += parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight) + parseFloat(computedStyle.borderLeftWidth) + parseFloat(computedStyle.borderRightWidth);
	            }

	            if (list.css("box-sizing") !== "border-box") {
	                width = computedWidth - (outerWidth(list) - list.width());
	            } else {
	                width = computedWidth;
	            }

	            list.css({
	                fontFamily: wrapper.css("font-family"),
	                width: that.options.autoWidth ? "auto" : width,
	                minWidth: width,
	                whiteSpace: that.options.autoWidth ? "nowrap" : "normal"
	            })
	            .data(WIDTH, width);

	            return true;
	        },

	        _reset: function() {
	            var that = this,
	                element = that.element,
	                formId = element.attr("form"),
	                form = formId ? $("#" + formId) : element.closest("form");

	            if (form[0]) {
	                that._resetHandler = function() {
	                    setTimeout(function() {
	                        that.value(that._initial);
	                    });
	                };

	                that._form = form.on("reset", that._resetHandler);
	            }
	        },

	        _popup: function() {
	            var list = this;

	            list.popup = new ui.Popup(list.list, extend({}, list.options.popup, {
	                anchor: list.wrapper,
	                open: proxy(list._openHandler, list),
	                close: proxy(list._closeHandler, list),
	                animation: list.options.animation,
	                isRtl: support.isRtl(list.wrapper),
	                autosize :list.options.autoWidth
	            }));
	        },

	        _angularElement: function(element, action) {
	            if (!element) {
	                return;
	            }

	            this.angular(action, function() {
	                return { elements: element };
	            });
	        },

	        _allowOpening: function() {
	            return this.options.noDataTemplate || this.treeview.dataSource.flatView().length;
	        },

	        _placeholder: function(show) {
	            if (this.span) {
	                this.span.toggleClass("k-readonly", show).text(show? this.options.placeholder: "");
	            }
	        },

	        _currentValue: function(dataItem) {
	            var currentValue = this._value(dataItem);
	            if (!currentValue && currentValue !== 0) {
	                currentValue = dataItem;
	            }

	            return currentValue;
	        },

	        _checkValue: function(dataItem) {
	            var value = "";
	            var indexOfValue = -1;
	            var currentValue = this.value();
	            var isMultiple = this.options.tagMode === "multiple";

	            if (dataItem || dataItem === 0) {
	                if(dataItem.level){
	                    dataItem._level = dataItem.level();
	                }

	                value = this._currentValue(dataItem);

	                indexOfValue = currentValue.indexOf(value);
	            }

	            if (dataItem.checked) {
	                var alreadyAddedTag = $.grep(this._tags, function( item ) {
	                    return item.uid === dataItem._tagUid;
	                });

	                if (alreadyAddedTag.length){
	                    return;
	                }

	                var itemToAdd = new ObservableObject(dataItem.toJSON());
	                dataItem._tagUid = itemToAdd.uid;
	                this._tags.push(itemToAdd);

	                if (this._tags.length === 1) {
	                    this.span.hide();

	                    if (!isMultiple) {
	                        this._multipleTags.push(itemToAdd);
	                    }
	                }

	                if (indexOfValue === -1) {
	                    currentValue.push(value);
	                    this.setValue(currentValue);
	                }
	            } else {
	                var itemToRemove = this._tags.find(function(item){
	                    return item.uid === dataItem._tagUid;
	                });

	                var idx = this._tags.indexOf(itemToRemove);

	                if (idx !== -1) {
	                    this._tags.splice(idx, 1);
	                } else {
	                    this._treeViewCheckAllCheck(dataItem);
	                    return;
	                }

	                if (this._tags.length === 0) {
	                    this.span.show();
	                    if (!isMultiple) {
	                        this._multipleTags.splice(0, 1);
	                    }
	                }
	                if (indexOfValue !== -1) {
	                    currentValue.splice(indexOfValue, 1);
	                    this.setValue(currentValue);
	                }
	            }

	            this._treeViewCheckAllCheck(dataItem);
	            if (!this._preventChangeTrigger && !this._valueMethodCalled && !this._noInitialValue) {
	                this.trigger(CHANGE);
	            }

	            if (this.options.autoClose && this.popup.visible()) {
	                this.close();
	                this.wrapper.focus();
	            }
	            this.popup.position();
	            this._toggleCloseVisibility();
	            this._updateSelectedOptions();
	        },

	        _updateSelectedOptions: function(){
	            if(this.element[0].tagName.toLowerCase() !== 'select'){
	                return;
	            }

	            var selectedItems = this._tags;
	            var options = '';
	            var dataItem = null;
	            var value = null;

	            if (selectedItems.length) {
	                for (var idx = 0; idx < selectedItems.length; idx++) {
	                    dataItem = selectedItems[idx];

	                    value = this._value(dataItem);
	                    options += this._option(value, this._text(dataItem), true);
	                }
	            }

	            this.element.html(options);
	        },

	        _option: function(dataValue, dataText, selected) {
	            var option = "<option";

	            if (dataValue !== undefined) {
	                dataValue += "";

	                if (dataValue.indexOf('"') !== -1) {
	                    dataValue = dataValue.replace(quotRegExp, "&quot;");
	                }

	                option += ' value="' + dataValue + '"';
	            }

	            if (selected) {
	                option += ' selected';
	            }

	            option += ">";

	            if (dataText !== undefined) {
	                option += kendo.htmlEncode(dataText);
	            }

	            return option += "</option>";
	        },

	        _selectValue: function(dataItem) {
	            var value = "";
	            var text = "";

	            if (dataItem || dataItem === 0) {
	                if(dataItem.level){
	                    dataItem._level = dataItem.level();
	                }
	                text = this._text(dataItem) || dataItem;
	                value = this._currentValue(dataItem);
	            }

	            if (value === null) {
	                value = "";
	            }
	            this.setValue(value);
	            this._textAccessor(text, dataItem);
	            this._accessor(value);

	            if(!this._preventChangeTrigger && !this._valueMethodCalled){
	                this.trigger(CHANGE);
	            }
	            this._valueMethodCalled = false;

	            if (this.options.autoClose && this.popup.visible()) {
	                this.close();
	                this.wrapper.focus();
	            }
	            this.popup.position();
	            this._toggleCloseVisibility();
	        },

	        _clearClick: function(e) {
	            e.stopPropagation();
	            this.wrapper.focus();
	            this._clearTextAndValue();
	        },

	        _clearTextAndValue: function() {
	            this.setValue([]);
	            this._clearInput();
	            this._clearText();
	            this._selection._clearValue();
	            this.popup.position();
	            this._toggleCloseVisibility();
	        },

	        _clearText: function() {
	            if (this.options.placeholder) {
	                this._placeholder(true);
	            } else {
	                if (this.span) {
	                    this.span.html("");
	                }
	            }
	        },

	        _inputTemplate: function() {
	            var template = this.options.valueTemplate;

	            if (!template) {
	                template = $.proxy(kendo.template('#:this._text(data)#', { useWithBlock: false }), this);
	            } else {
	                template = kendo.template(template);
	            }

	            this.valueTemplate = template;
	        },

	        _assignInstance: function(text, value) {
	            var dataTextField = this.options.dataTextField;
	            var dataItem = {};

	            if (dataTextField) {
	                assign(dataItem, dataTextField.split(DOT), text);
	                assign(dataItem, this.options.dataValueField.split(DOT), value);
	                dataItem = new ObservableObject(dataItem);
	            } else {
	                dataItem = text;
	            }

	            return dataItem;
	        },

	        _textAccessor: function(text, dataItem) {
	            var valueTemplate = this.valueTemplate;
	            var span = this.span;

	            if (text === undefined) {
	                return span.text();
	            }

	            span.removeClass("k-readonly");

	            if (!dataItem && ($.isPlainObject(text) || text instanceof ObservableObject)) {
	                dataItem = text;
	            }

	            if (!dataItem) {
	                dataItem = this._assignInstance(text, this._accessor());
	            }

	            var getElements = function() {
	                return {
	                    elements: span.get(),
	                    data: [ { dataItem: dataItem } ]
	                };
	            };

	            this.angular("cleanup", getElements);

	            try {
	                span.html(valueTemplate(dataItem));
	            } catch(e) {
	                //dataItem has missing fields required in custom template
	                if (span) {
	                    span.html("");
	                }
	            }

	            this.angular("compile", getElements);
	        },

	        _accessors: function() {
	            var element = this.element;
	            var options = this.options;
	            var getter = kendo.getter;
	            var textField = element.attr(kendo.attr("text-field"));
	            var valueField = element.attr(kendo.attr("value-field"));

	            var getterFunction = function (field) {
	                if ($.isArray(field)) {
	                    var count = field.length;
	                    var levels = $.map(field, function(x) {
	                        return function(d){ return d[x];};
	                    });

	                    return function (dataItem) {
	                        var level = dataItem._level;

	                        if(!level && level !== 0){
	                            return;
	                        }

	                        return levels[Math.min(level, count-1)](dataItem);
	                    };
	                } else {
	                    return getter(field);
	                }
	            };

	            if (!options.dataTextField && textField) {
	                options.dataTextField = textField;
	            }

	            if (!options.dataValueField && valueField) {
	                options.dataValueField = valueField;
	            }

	            options.dataTextField = options.dataTextField || "text";
	            options.dataValueField = options.dataValueField || "value";

	            this._text = getterFunction(options.dataTextField);
	            this._value = getterFunction(options.dataValueField);
	        },

	        _accessor: function(value, idx) {
	            return this._accessorInput(value, idx);
	        },

	        _accessorInput: function(value) {
	            var element = this.element[0];

	            if (value === undefined) {
	                return element.value;
	            } else {
	                if (value === null) {
	                    value = "";
	                }
	                element.value = value;
	            }
	        },

	        _clearInput: function() {
	            var element = this.element[0];
	            element.value = "";
	        },

	        _clearButton: function() {
	            var clearTitle = this.options.messages.clear;

	            if(!this._clear){
	                this._clear = $('<span unselectable="on" class="k-icon k-clear-value k-i-close" title="' + clearTitle + '"></span>').attr({
	                    "role": "button",
	                    "tabIndex": -1
	                });
	            }

	            if (this.options.clearButton) {
	                this._clear.insertAfter(this.span);
	                this.wrapper.addClass("k-dropdowntree-clearable");
	            } else {
	                if (!this.options.clearButton) {
	                    this._clear.remove();
	                }
	            }
	        },

	        _toggleCloseVisibility: function() {
	            var isReadOnly = this.element.attr(READONLY);
	            var hasValue = (this.value() && !this._isMultipleSelection()) || this.value().length;
	            var valueDoesNotEqualPlaceHolder = this.element.val() && this.element.val() !== this.options.placeholder;

	            if ((!isReadOnly && (hasValue || valueDoesNotEqualPlaceHolder))) {
	                this._showClear();
	            } else {
	                this._hideClear();
	            }
	        },

	        _showClear: function() {
	            if(this._clear) {
	                this._clear.removeClass(HIDDENCLASS);
	            }
	        },

	        _hideClear: function() {
	            if(this._clear) {
	                this._clear.addClass(HIDDENCLASS);
	            }
	        },

	        _openHandler: function(e) {
	            this._adjustListWidth();

	            if (this.trigger(OPEN)) {
	                e.preventDefault();
	            } else {
	                 this.wrapper.attr("aria-expanded", true);
	                 this.tree.attr("aria-hidden", false).attr("role", "tree");
	            }
	        },

	        _closeHandler: function(e) {
	            if (this.trigger(CLOSE)) {
	                e.preventDefault();
	            } else {
	                 this.wrapper.attr("aria-expanded", false);
	                 this.tree.attr("aria-hidden", true);
	            }
	        },

	        _treeview: function() {
	            var that = this;
	            if (that.options.height) {
	                that.tree.css('max-height',that.options.height);
	            }
	            that.tree.attr('id', kendo.guid());
	            that.treeview = new TreeView(that.tree, extend({}, that.options.treeview), that);
	            that.dataSource = that.treeview.dataSource;

	            that.treeview.bind("select",function(e) {
	                that.trigger("select", e);
	            });
	        },

	        _treeViewDataBound: function(e) {
	            if (e.node && this._prev && this._prev.length) {
	                e.sender.expand(e.node);
	            }

	            if(this._filtering){
	                if(!e.node){
	                    this._filtering = false;
	                }

	                if (!this._isMultipleSelection()) {
	                    this._deselectItem(e);
	                }
	                return;
	            }

	            if (!this.treeview) {
	                this.treeview = e.sender;
	            }

	            if (!e.node) {
	                var rootItems = e.sender.dataSource.data();

	                this._checkLoadedItems(rootItems);
	                if(this._noInitialValue){
	                    this._noInitialValue = false;
	                }
	            } else {
	                var rootItem = e.sender.dataItem(e.node);
	                if (rootItem) {
	                    var subItems = rootItem.children.data();
	                    this._checkLoadedItems(subItems);
	                }
	            }
	            this.trigger("dataBound", e);
	        },

	        _deselectItem: function(e){
	            var items = [];
	            if (!e.node) {
	                items = e.sender.dataSource.data();
	            } else {
	                var rootItem = e.sender.dataItem(e.node);
	                if (rootItem) {
	                    items = rootItem.children.data();
	                }
	            }

	            for (var i = 0; i < items.length; i++) {
	                if (items[i].selected &&
	                    !this._valueComparer(items[i], this.value())) {
	                    items[i].set("selected", false);
	                }
	            }
	        },

	        _checkLoadedItems: function(items) {
	            var value = this.value();

	            if(!items){
	                return;
	            }

	            for (var idx = 0; idx < items.length; idx++) {
	                this._selection._checkLoadedItem(items[idx], value);
	            }
	        },

	        _treeViewCheckAllCheck: function(dataItem) {
	            if (this.options.checkAll && this.checkAll) {
	                this._getAllChecked();

	                if (dataItem.checked) {
	                    this._checkCheckAll();
	                } else {
	                    this._uncheckCheckAll();
	                }
	            }
	        },

	        _checkCheckAll: function() {
	            var checkAllCheckbox = this.checkAll.find('.k-checkbox');

	            if (this._allItemsAreChecked) {
	                checkAllCheckbox.prop('checked', true)
	                                .prop('indeterminate', false);
	            } else {
	                checkAllCheckbox.prop('indeterminate', true);
	            }
	        },

	        _uncheckCheckAll: function() {
	            var checkAllCheckbox = this.checkAll.find('.k-checkbox');

	            if (this._allItemsAreUnchecked) {
	                checkAllCheckbox.prop('checked', false)
	                                .prop('indeterminate', false);
	            } else {
	                checkAllCheckbox.prop('indeterminate', true);
	            }
	        },

	        _filterHeader: function() {
	            var icon;

	            if (this.filterInput) {
	                this.filterInput
	                    .off(ns)
	                    .parent()
	                    .remove();

	                this.filterInput = null;
	            }

	            if (this._isFilterEnabled()) {
	                this._disableCheckChildren();

	                icon = '<span class="k-icon k-i-zoom"></span>';

	                this.filterInput = $('<input class="k-textbox"/>')
	                                      .attr({
	                                          placeholder: this.element.attr("placeholder"),
	                                          title: this.element.attr("title"),
	                                          role: "listbox",
	                                          "aria-haspopup": true,
	                                          "aria-expanded": false
	                                      });

	                this.filterInput.on("input" , proxy(this._filterChange, this));
	                $('<span class="k-list-filter" />').insertBefore(this.tree)
	                    .append(this.filterInput.add(icon));
	            }
	        },

	        _filterChange: function() {
	            if (this.filterInput) {
	                this._search();
	            }
	        },

	        _disableCheckChildren: function() {
	            if (this._isMultipleSelection() && this.options.treeview.checkboxes && this.options.treeview.checkboxes.checkChildren) {
	                this.options.treeview.checkboxes.checkChildren = false;
	            }
	        },

	        _checkAll: function() {
	            if (this.checkAll) {
	                this.checkAll.find(".k-checkbox-label, .k-checkbox")
	                    .off(ns);
	                this.checkAll.remove();

	                this.checkAll = null;
	            }

	            if (this._isMultipleSelection() && this.options.checkAll) {
	                this.checkAll = $('<div class="k-check-all"><input type="checkbox" class="k-checkbox"/><span class="k-checkbox-label">Check All</span></div>').insertBefore(this.tree);
	                this.checkAll.find(".k-checkbox-label").html(kendo.template(this.options.checkAllTemplate)({ instance: this }));
	                this.checkAll.find(".k-checkbox-label").on(CLICK + ns, proxy(this._clickCheckAll, this));
	                this.checkAll.find(".k-checkbox")
	                                .on("change" + ns, proxy(this._changeCheckAll, this))
	                                .on("keydown" + ns, proxy(this._keydownCheckAll, this));
	                this._disabledCheckedItems = [];
	                this._disabledUnCheckedItems = [];

	                this._getAllChecked();

	                if (!this._allItemsAreUnchecked) {
	                    this._checkCheckAll();
	                }
	            }
	        },

	        _changeCheckAll: function() {
	            var checkAllCheckbox = this.checkAll.find('.k-checkbox');
	            var isChecked = checkAllCheckbox.prop('checked');

	            this._updateCheckAll(isChecked);
	        },

	        _updateCheckAll: function(isChecked) {
	            var checkAllCheckbox = this.checkAll.find('.k-checkbox');
	            this._toggleCheckAllItems(isChecked);
	            checkAllCheckbox.prop('checked', isChecked);
	            if (this._disabledCheckedItems.length && this._disabledUnCheckedItems.length) {
	                checkAllCheckbox.prop('indeterminate', true);
	            } else if (this._disabledCheckedItems.length) {
	                checkAllCheckbox.prop('indeterminate', !isChecked);
	            } else if (this._disabledUnCheckedItems.length) {
	                checkAllCheckbox.prop('indeterminate', isChecked);
	            } else {
	                checkAllCheckbox.prop('indeterminate', false);
	            }
	            this._disabledCheckedItems = [];
	            this._disabledUnCheckedItems = [];
	        },

	        _keydownCheckAll: function(e) {
	            var key = e.keyCode;
	            var altKey = e.altKey;

	            if ((altKey && key === keys.UP) || key === keys.ESC || key === keys.TAB) {
	                this.close();
	                this.wrapper.focus();
	                e.preventDefault();
	                return;
	            }

	            if (key === keys.UP) {
	                if (this.filterInput) {
	                    this.filterInput.focus();
	                } else {
	                    this.wrapper.focus();
	                }

	                e.preventDefault();
	            }

	            if (key === keys.DOWN) {
	                if (this.tree && this.tree.is(":visible")) {
	                    this.tree.focus();
	                }

	                e.preventDefault();
	            }

	            if (key === keys.SPACEBAR && (browser.msie || browser.edge)) {
	                this._clickCheckAll();
	                e.preventDefault();
	            }
	        },

	        _clickCheckAll: function() {
	            var checkAllCheckbox = this.checkAll.find('.k-checkbox');
	            var isChecked = checkAllCheckbox.prop('checked');

	            this._updateCheckAll(!isChecked);

	            checkAllCheckbox.focus();

	        },
	        //treeview
	        _dfs: function(items, action, prop) {
	            for (var idx = 0; idx < items.length; idx++) {
	                if (!this[action](items[idx], prop)) {
	                    break;
	                }
	                this._traverceChildren(items[idx], action, prop);
	            }
	        },

	        _uncheckItemByUid: function(uid) {
	            this._dfs(this.dataSource.data(), '_uncheckItemEqualsUid', uid);
	        },

	        _uncheckItemEqualsUid: function(item, uid) {
	            if (item.enabled !== false && item._tagUid == uid) {
	                item.set("checked", false);
	                return false;
	            }
	            return true;
	        },

	        _selectItemByText: function(text) {
	            this._dfs(this.dataSource.data(), '_itemEqualsText', text);
	        },

	        _itemEqualsText: function(item, text) {
	            if (item.enabled !== false && this._text(item) === text) {
	                this.treeview.select(this.treeview.findByUid(item.uid));
	                this._selectValue(item);
	                return false;
	            }
	            return true;
	        },

	        _selectItemByValue: function(value) {
	            this._dfs(this.dataSource.data(), '_itemEqualsValue', value);
	        },

	        _itemEqualsValue: function(item, value) {
	            if (item.enabled !== false && this._valueComparer(item, value)) {

	                this.treeview.select(this.treeview.findByUid(item.uid));

	                return false;
	            }
	            return true;
	        },

	        _checkItemByValue: function(value) {
	            var items = this.treeview.dataItems();
	            for (var idx = 0; idx < value.length; idx++) {
	                this._dfs(items, '_checkItemEqualsValue', value[idx]);
	            }
	        },

	        _checkItemEqualsValue: function(item, value) {
	            if (item.enabled !== false && this._valueComparer(item, value)) {
	                    item.set("checked", true);
	                return false;
	            }
	            return true;
	        },

	        _valueComparer: function(item, value) {
	            var itemValue = this._value(item);
	            var itemText;

	            if (!this._isNullorUndefined(itemValue)) {
	                if(this._isNullorUndefined(value)){
	                    return false;
	                }

	                var newValue = this._value(value);

	                if(newValue){
	                    return itemValue == newValue;
	                }else{
	                    return itemValue == value;
	                }
	            }

	            itemText = this._text(item);
	            if (itemText) {
	                if (this._text(value)) {
	                    return itemText == this._text(value);
	                } else {
	                    return itemText == value;
	                }
	            }

	            return false;
	        },

	        _isNullorUndefined: function(value){
	            return value === undefined || value === null;
	        },

	        _getAllChecked: function() {
	            this._allCheckedItems = [];
	            this._allItemsAreChecked = true;
	            this._allItemsAreUnchecked = true;

	            this._dfs(this.dataSource.data(), '_getAllCheckedItems');

	            return this._allCheckedItems;
	        },

	        _getAllCheckedItems: function(item) {
	            if (this._allItemsAreChecked) {
	                this._allItemsAreChecked =  item.checked;
	            }

	            if (this._allItemsAreUnchecked) {
	                this._allItemsAreUnchecked = !item.checked;
	            }

	            if (item.checked) {
	                this._allCheckedItems.push(item);
	            }
	            return true;
	        },

	        _traverceChildren: function(item, action, prop) {
	            var childrenField = (item._childrenOptions && item._childrenOptions.schema) ? item._childrenOptions.schema.data : null;
	            var subItems = item[childrenField] || item.items || item.children;

	            if (!subItems) {
	                return;
	            }

	            this._dfs(subItems, action, prop);
	        },

	        _toggleCheckAllItems: function(checked) {
	            this._dfs(this.dataSource.data(), '_checkAllCheckItem', checked);
	        },

	        _checkAllCheckItem: function(item, checked) {
	            if (item.enabled === false) {
	                if (item.checked) {
	                    this._disabledCheckedItems.push(item);
	                } else {
	                    this._disabledUnCheckedItems.push(item);
	                }
	            } else {
	                item.set("checked", checked);
	            }
	            return true;
	        },

	        _isFilterEnabled: function() {
	            var filter = this.options.filter;
	            return filter && filter !== "none";
	        },

	        _editable: function(options) {
	            var that = this;
	            var element = that.element;
	            var disable = options.disable;
	            var readonly = options.readonly;
	            var wrapper = that.wrapper.add(that.filterInput).off(ns);
	            var dropDownWrapper = that._inputWrapper.off(HOVEREVENTS);
	            if (that._isMultipleSelection()) {
	                that.tagList.off(CLICK + ns);
	            }
	            if (!readonly && !disable) {
	                element.removeAttr(DISABLED).removeAttr(READONLY);

	                dropDownWrapper
	                    .removeClass(STATEDISABLED)
	                    .on(HOVEREVENTS, that._toggleHover);

	                that._clear.on("click" + ns, proxy(that._clearClick, that));
	                wrapper
	                    .attr(TABINDEX, wrapper.data(TABINDEX))
	                    .attr(ARIA_DISABLED, false)
	                    .attr(ARIA_READONLY, false)
	                    .on("keydown" + ns, proxy(that._keydown, that))
	                    .on("focusin" + ns, proxy(that._focusinHandler, that))
	                    .on("focusout" + ns, proxy(that._focusoutHandler, that));

	                that.wrapper.on(CLICK + ns, proxy(that._wrapperClick, that));

	                if (this._isMultipleSelection()) {
	                    that.tagList.on(CLICK + ns, "li.k-button", function(e) {
	                        $(e.currentTarget).addClass(FOCUSED);
	                    });

	                    that.tagList.on(CLICK + ns, ".k-select", function(e) {
	                        that._removeTagClick(e);
	                    });
	                }
	            } else if (disable) {
	                wrapper.removeAttr(TABINDEX);
	                dropDownWrapper
	                    .addClass(STATEDISABLED);
	            } else {
	                wrapper
	                    .attr(TABINDEX, wrapper.data(TABINDEX));

	                dropDownWrapper
	                    .removeClass(STATEDISABLED);

	                wrapper
	                    .on("focusin" + ns, proxy(that._focusinHandler, that))
	                    .on("focusout" + ns, proxy(that._focusoutHandler, that));
	            }

	            element.attr(DISABLED, disable)
	                   .attr(READONLY, readonly);

	            wrapper.attr(ARIA_DISABLED, disable)
	                    .attr(ARIA_READONLY, readonly);
	        },

	        _focusinHandler: function() {
	            this._inputWrapper.addClass(FOCUSED);
	            this._prevent = false;
	        },

	        _focusoutHandler: function() {
	            var that = this;

	            if (this._isMultipleSelection()) {
	                this.tagList.find(DOT + FOCUSED).removeClass(FOCUSED);
	            }
	            if (!that._prevent) {
	                this._inputWrapper.removeClass(FOCUSED);
	                that._prevent = true;
	                that.element.blur();
	            }
	        },

	        _toggle: function(open) {
	            open = open !== undefined ? open : !this.popup.visible();

	            this[open ? OPEN : CLOSE]();
	        },

	        _wrapperClick: function(e) {
	            e.preventDefault();
	            this.popup.unbind("activate", this._focusInputHandler);
	            this._focused = this.wrapper;
	            this._prevent = false;
	            this._toggle();
	        },

	        _toggleHover: function(e) {
	            $(e.currentTarget).toggleClass(HOVER, e.type === "mouseenter");
	        },

	        _focusInput: function() {
	            if (this.filterInput) {
	                this.filterInput.focus();
	            } else if (this.checkAll) {
	                this.checkAll.find(".k-checkbox").focus();
	            } else if (this.tree.is(":visible")) {
	                this.tree[0].focus({preventScroll: true});
	                this._ie11PreventScrollOnFocus();
	            }
	        },

	        _ie11PreventScrollOnFocus: function(){
	            if (browser.msie && browser.version == 11) {
	                var popup = this.popup;
	                popup._toggleResize(false);
	                setTimeout(function () {
	                    popup._toggleResize(true);
	                },50);
	            }
	        },

	        _keydown: function(e) {
	            var key = e.keyCode;
	            var altKey = e.altKey;
	            var isFilterInputActive;
	            var isWrapperActive;
	            var focused, tagItem;

	            var isPopupVisible = this.popup.visible();

	            if (this.filterInput) {
	                isFilterInputActive = this.filterInput[0] === activeElement();
	            }

	            if (this.wrapper) {
	                isWrapperActive = this.wrapper[0] === activeElement();
	            }

	            if(isWrapperActive){
	                if (key === keys.ESC) {
	                    this._clearTextAndValue();
	                    e.preventDefault();
	                    return;
	                }

	                if(this._isMultipleSelection()){
	                    if (key === keys.LEFT) {
	                        this._focusPrevTag();
	                        e.preventDefault();
	                        return;
	                    }

	                    if (key === keys.RIGHT) {
	                        this._focusNextTag();
	                          e.preventDefault();
	                        return;
	                    }

	                    if (key === keys.HOME) {
	                        this._focusFirstTag();
	                        e.preventDefault();
	                        return;
	                    }

	                    if (key === keys.END) {
	                        this._focusLastTag();
	                        e.preventDefault();
	                        return;
	                    }

	                    if (key === keys.DELETE) {
	                        focused = this.tagList.find(DOT + FOCUSED).first();
	                        if(focused.length){
	                            tagItem = this._tags[focused.index()];
	                            this._removeTag(tagItem);
	                        }
	                        e.preventDefault();
	                        return;
	                    }

	                    if (key === keys.BACKSPACE) {
	                        focused = this.tagList.find(DOT + FOCUSED).first();
	                        if (focused.length) {
	                            tagItem = this._tags[focused.index()];
	                            this._removeTag(tagItem);
	                        } else {
	                            focused = this._focusLastTag();
	                            if (focused.length) {
	                                tagItem = this._tags[focused.index()];
	                                this._removeTag(tagItem);
	                            }
	                        }
	                        e.preventDefault();
	                        return;
	                    }
	                }
	            }


	            if (isFilterInputActive) {
	                if (key === keys.ESC) {
	                    this._clearFilter();
	                }

	                if ((key === keys.UP) && !altKey) {
	                    this.wrapper.focus();
	                    e.preventDefault();
	                }

	                if(browser.msie && browser.version < 10){
	                    if (key === keys.BACKSPACE || key === keys.DELETE) {
	                        this._search();
	                    }
	                }

	                if(key === keys.TAB){
	                    this.close();
	                    this.wrapper.focus();
	                    e.preventDefault();
	                    return;
	                }
	            }

	            if ((altKey && key === keys.UP) || key === keys.ESC) {
	                this.close();
	                this.wrapper.focus();
	                e.preventDefault();
	                return;
	            }

	            if (key === keys.ENTER && this._typingTimeout && this.filterInput && isPopupVisible) {
	                e.preventDefault();
	                return;
	            }

	            if (key === keys.SPACEBAR && !isFilterInputActive) {
	                this._toggle(!isPopupVisible);
	                e.preventDefault();
	            }

	            if ((altKey && key === keys.DOWN) && !isPopupVisible) {
	                this.open();
	                e.preventDefault();
	            }

	            if ((key === keys.DOWN) && isPopupVisible) {
	                if (this.filterInput && !isFilterInputActive) {
	                    this.filterInput.focus();
	                } else if (this.checkAll && this.checkAll.is(":visible")) {
	                    this.checkAll.find('input').focus();
	                } else if(this.tree.is(":visible")) {
	                    this.tree[0].focus({preventScroll: true});
	                    this._ie11PreventScrollOnFocus();
	                }
	                e.preventDefault();
	            }

	            if(key === keys.TAB && isPopupVisible){
	                this.close();
	                this.wrapper.focus();
	                e.preventDefault();
	            }
	        },

	        _focusPrevTag: function() {
	            var focused = this.tagList.find(DOT + FOCUSED);
	            if (focused.length) {
	                var activedescendant = this.wrapper.attr("aria-activedescendant");
	                focused.first()
	                    .removeClass(FOCUSED)
	                    .removeAttr("id")
	                    .prev().addClass(FOCUSED)
	                    .attr("id", activedescendant);
	                this.wrapper.attr("aria-activedescendant", activedescendant);
	            } else {
	                this._focusLastTag();
	            }
	        },

	        _focusNextTag: function() {
	            var focused = this.tagList.find(DOT + FOCUSED);
	            if (focused.length) {
	                var activedescendant = this.wrapper.attr("aria-activedescendant");
	                focused.first().removeClass(FOCUSED).removeAttr("id")
	                    .next().addClass(FOCUSED)
	                    .attr("id", activedescendant);
	                this.wrapper.attr("aria-activedescendant", activedescendant);
	            } else {
	                this._focusFirstTag();
	            }
	        },

	        _focusFirstTag: function() {
	            var activedescendant = this.wrapper.attr("aria-activedescendant");
	            this._clearDisabledTag();

	            var firstTag = this.tagList.children('li').first().addClass(FOCUSED)
	                .attr("id", activedescendant);
	            this.wrapper.attr("aria-activedescendant", activedescendant);

	            return firstTag;
	        },

	        _focusLastTag: function() {
	            var activedescendant = this.wrapper.attr("aria-activedescendant");
	            this._clearDisabledTag();
	            var lastTag = this.tagList.children('li').last().addClass(FOCUSED)
	                .attr("id", activedescendant);
	            this.wrapper.attr("aria-activedescendant", activedescendant);

	            return lastTag;
	        },

	        _clearDisabledTag: function() {
	            this.tagList.find(DOT + FOCUSED).removeClass(FOCUSED).removeAttr("id");
	        },

	        _search: function() {
	            var that = this;
	            clearTimeout(that._typingTimeout);

	            that._typingTimeout = setTimeout(function() {
	                var value = that.filterInput.val();

	                if (that._prev !== value) {
	                    that._prev = value;
	                    that.search(value);
	                }

	                that._typingTimeout = null;
	            }, that.options.delay);
	        },

	        _clearFilter: function() {
	            if(this.filterInput.val().length){
	                this.filterInput.val("");
	                this._prev = "";
	                this._filtering = true;
	                this.treeview.dataSource.filter({});
	            }
	        },

	        _removeTagClick: function(e) {
	            e.stopPropagation();
	            var tagItem = this._tags[$(e.currentTarget.parentElement).index()];
	            this._removeTag(tagItem);
	        },

	        _removeTag: function(tagItem) {
	           if(!tagItem){
	                return;
	           }

	           var uid = tagItem.uid;
	           this._uncheckItemByUid(uid);
	        }
	    });

	    function assign(instance, fields, value) {
	        var idx = 0,
	            lastIndex = fields.length - 1,
	            field;

	        for (; idx < lastIndex; ++idx) {
	            field = fields[idx];

	            if (!(field in instance)) {
	                instance[field] = {};
	            }

	            instance = instance[field];
	        }

	        instance[fields[lastIndex]] = value;
	    }

	    ui.plugin(DropDownTree);

	    var SingleSelection = kendo.Class.extend({
	        init: function(view) {
	            this._dropdowntree = view;
	        },

	        _initWrapper: function() {
	            this._wrapper();
	            this._span();
	        },

	        _preselect: function(data){
	            var dropdowntree = this._dropdowntree;

	            dropdowntree._selectValue(data);
	        },

	        _wrapper: function() {
	            var dropdowntree = this._dropdowntree,
	                element = dropdowntree.element,
	                DOMelement = element[0],
	                wrapper;

	            wrapper = element.parent();

	            if (!wrapper.is("span.k-widget")) {
	                wrapper = element.wrap("<span />").parent();
	                wrapper[0].style.cssText = DOMelement.style.cssText;
	                wrapper[0].title = DOMelement.title;
	            }

	            dropdowntree._focused = dropdowntree.wrapper = wrapper
	                              .addClass("k-widget k-dropdowntree")
	                              .addClass(DOMelement.className)
	                              .removeClass('input-validation-error')
	                              .css("display", "")
	                              .attr({
	                                  accesskey: element.attr("accesskey"),
	                                  unselectable: "on",
	                                  role: "listbox",
	                                  "aria-haspopup": true,
	                                  "aria-expanded": false
	                              });

	            element.hide().removeAttr("accesskey");
	        },

	        _span: function() {
	            var dropdowntree = this._dropdowntree,
	                wrapper = dropdowntree.wrapper,
	                SELECTOR = "span.k-input",
	                span;

	            span = wrapper.find(SELECTOR);

	            if (!span[0]) {
	                wrapper.append('<span unselectable="on" class="k-dropdown-wrap k-state-default"><span unselectable="on" class="k-input">&nbsp;</span><span unselectable="on" class="k-select" aria-label="select"><span class="k-icon k-i-arrow-60-down"></span></span></span>')
	                       .append(dropdowntree.element);

	                span = wrapper.find(SELECTOR);
	            }

	            dropdowntree.span = span;
	            dropdowntree._inputWrapper = $(wrapper[0].firstChild);
	            dropdowntree._arrow = wrapper.find(".k-select");
	            dropdowntree._arrowIcon = dropdowntree._arrow.find(".k-icon");
	        },

	        _setValue: function(value) {
	            var dropdowntree = this._dropdowntree;
	            var currentValue;

	            if (value === undefined || value === null) {
	                currentValue = dropdowntree._values.slice()[0];
	                value = (typeof currentValue === "object") ? currentValue : dropdowntree._accessor() || currentValue;
	                return value === undefined || value === null ? "" : value;
	            }
	            dropdowntree._valueMethodCalled = true;
	            if (value.length === 0) {
	                dropdowntree._clearTextAndValue();
	                dropdowntree._valueMethodCalled = false;
	                return;
	            }

	            dropdowntree._selectItemByValue(value);
	            dropdowntree._toggleCloseVisibility();
	        },

	        _clearValue: function() {
	            var dropdowntree = this._dropdowntree;
	            var selectedNode = dropdowntree.treeview.select();

	            if (dropdowntree.treeview.dataItem(selectedNode)) {
	                dropdowntree.treeview.dataItem(selectedNode).set('selected', false);
	                if(!dropdowntree._valueMethodCalled){
	                    dropdowntree.trigger(CHANGE);
	                }
	            }
	        },

	        _checkLoadedItem: function(tempItem, value) {
	            var dropdowntree = this._dropdowntree;

	            if (!dropdowntree._isNullorUndefined(value) && value!=="") {
	                if(dropdowntree._valueComparer(tempItem, value)){
	                    dropdowntree._preventChangeTrigger = true;
	                    tempItem.set("selected", true);
	                    dropdowntree._preventChangeTrigger = false;
	                } else if (tempItem.selected){
	                    dropdowntree.treeview.select(dropdowntree.treeview.findByUid(tempItem.uid));
	                }

	            } else if (!value && tempItem.selected){
	                dropdowntree.treeview.select(dropdowntree.treeview.findByUid(tempItem.uid));
	            }
	        }
	    });

	    var MultipleSelection = kendo.Class.extend({
	        init: function(view) {
	            this._dropdowntree = view;
	        },

	        _initWrapper: function() {
	            var dropdowntree = this._dropdowntree;

	            this._tagTemplate();
	            dropdowntree.element.attr("multiple", "multiple").hide();
	            this._wrapper();
	            dropdowntree._tags = new ObservableArray([]);
	            dropdowntree._multipleTags = new ObservableArray([]);
	            this._tagList();
	            dropdowntree.span = $('<span unselectable="on" class="k-input">&nbsp;</span>').insertAfter(dropdowntree.tagList);
	            dropdowntree._inputWrapper = $(dropdowntree.wrapper[0].firstChild);
	        },

	        _preselect: function(data, value){
	            var dropdowntree = this._dropdowntree;
	            var valueToSelect = value || dropdowntree.options.value;

	            if (!$.isArray(data) && !(data instanceof kendo.data.ObservableArray)) {
	                data = [data];
	            }

	            if ($.isPlainObject(data[0]) || data[0] instanceof kendo.data.ObservableObject || !dropdowntree.options.dataValueField) {
	                dropdowntree.dataSource.data(data);

	                dropdowntree.value(valueToSelect);
	            }
	        },

	        _tagTemplate: function() {
	            var dropdowntree = this._dropdowntree;
	            var options = dropdowntree.options;
	            var tagTemplate = options.valueTemplate;
	            var isMultiple = options.tagMode === "multiple";
	            var singleTag = options.messages.singleTag;

	            tagTemplate = tagTemplate ? kendo.template(tagTemplate) : dropdowntree.valueTemplate;

	            dropdowntree.valueTemplate = function(data) {
	                if (isMultiple) {
	                    return '<li class="k-button ' +
	                    ((data.enabled === false) ? "k-state-disabled" : "") +
	                    '" unselectable="on" role="option" ' +
	                    ((data.enabled === false) ? 'aria-disabled="true"' : '') +
	                    '>' +
	                        '<span unselectable="on">' + tagTemplate(data) + '</span>' +
	                        '<span title="' + dropdowntree.options.messages.deleteTag + '" aria-label="' + dropdowntree.options.messages.deleteTag + '" class="k-select">' +
	                            '<span class="k-icon k-i-close"></span>' +
	                        '</span>' +
	                    '</li>';
	                }

	                return '<li class="k-button" unselectable="on" role="option">' +
	                        '<span unselectable="on" data-bind="text: tags.length"></span>' +
	                        '<span unselectable="on">&nbsp;' + singleTag +'</span>' +
	                        '</li>';
	            };
	        },

	        _wrapper: function() {
	            var dropdowntree = this._dropdowntree,
	                element = dropdowntree.element,
	                wrapper = element.parent("span.k-dropdowntree");

	            if (!wrapper[0]) {
	                wrapper = element.wrap('<div class="k-widget k-dropdowntree" unselectable="on" />').parent();
	                wrapper[0].style.cssText = element[0].style.cssText;
	                wrapper[0].title = element[0].title;

	                $('<div class="k-multiselect-wrap k-floatwrap" unselectable="on" />').insertBefore(element);
	            }

	            dropdowntree.wrapper = wrapper.addClass(element[0].className).css("display", "")
	                                   .attr({
	                                        role: "listbox",
	                                        "aria-activedescendant": kendo.guid(),
	                                        "aria-haspopup": true,
	                                        "aria-expanded": false
	                                   });
	            dropdowntree._innerWrapper = $(wrapper[0].firstChild);
	        },

	        _tagList: function() {
	            var dropdowntree = this._dropdowntree,
	                tagList = dropdowntree._innerWrapper.children("ul");

	            if (!tagList[0]) {
	                var isMultiple = dropdowntree.options.tagMode === "multiple";
	                var tagCollection = isMultiple ? "tags": "multipleTag";
	                tagList = $('<ul role="listbox" unselectable="on" data-template="tagTemplate" data-bind="source: ' + tagCollection + '" class="k-reset"/>').appendTo(dropdowntree._innerWrapper);
	            }

	            dropdowntree.tagList = tagList;
	            dropdowntree.tagList.attr('id', kendo.guid() + "_tagList");
	            dropdowntree.wrapper.attr("aria-owns", dropdowntree.tagList.attr('id'));
	            var viewModel = kendo.observable({
	                multipleTag: dropdowntree._multipleTags,
	                tags: dropdowntree._tags,
	                tagTemplate: dropdowntree.valueTemplate
	            });
	            kendo.bind(dropdowntree.tagList, viewModel);
	            dropdowntree.tagList.attr("data-stop", true);
	        },

	        _setValue: function(value) {
	            var dropdowntree = this._dropdowntree;
	            var oldValues = dropdowntree._values;
	            if (value === undefined || value === null) {
	                return dropdowntree._values.slice();
	            }

	            dropdowntree.setValue(value);
	            dropdowntree._valueMethodCalled = true;
	            if (value.length) {
	                this._removeValues(oldValues, value);

	                dropdowntree._checkItemByValue(value);
	            } else {
	                dropdowntree._clearTextAndValue();
	            }

	            dropdowntree._valueMethodCalled = false;
	            dropdowntree._toggleCloseVisibility();
	        },

	        _removeValues: function(oldValues, value) {
	            var dropdowntree = this._dropdowntree;
	            var removedValues = this._getNewValues(oldValues, value);

	            for (var idx = 0; idx < removedValues.length; idx++) {
	                for (var j = 0; j < dropdowntree._tags.length; j++) {
	                    if (dropdowntree._valueComparer(dropdowntree._tags[j],removedValues[idx])){
	                        dropdowntree._uncheckItemByUid(dropdowntree._tags[j].uid);
	                    }
	                }
	            }
	        },

	        _getNewValues: function(oldValues, value){
	            var removedValues = [];

	            for (var idx = 0; idx < oldValues.length; idx++) {
	                if(value.indexOf(oldValues[idx]) === -1){
	                    removedValues.push(oldValues[idx]);
	                }
	            }

	            return removedValues;
	        },

	        _clearValue: function() {
	            var dropdowntree = this._dropdowntree;
	            var tagsArray = dropdowntree._tags.slice();

	            for (var idx = 0; idx < tagsArray.length; idx++) {
	                var uid = tagsArray[idx].uid;
	                dropdowntree._preventChangeTrigger = true;
	                dropdowntree._uncheckItemByUid(uid);
	            }

	            if (tagsArray.length) {
	                dropdowntree._preventChangeTrigger = false;
	                if(!dropdowntree._valueMethodCalled){
	                    dropdowntree.trigger(CHANGE);
	                }
	            }
	        },

	        _checkLoadedItem: function(tempItem, value) {
	            var dropdowntree = this._dropdowntree;

	            if (dropdowntree._noInitialValue && tempItem.checked) {
	                dropdowntree._checkValue(tempItem);
	                return;
	            }

	            if ((value.length || this._isDataSourceSet) &&
	                (value.indexOf(dropdowntree._currentValue(tempItem)) !== -1 || value.indexOf(tempItem)) !== -1 &&
	                !this._findTag(dropdowntree._currentValue(tempItem))) {
	                if (tempItem.checked) {
	                    dropdowntree._checkValue(tempItem);
	                } else {
	                    dropdowntree._preventChangeTrigger = true;
	                    tempItem.set("checked", true);
	                    dropdowntree._preventChangeTrigger = false;
	                }
	            }
	        },

	        _findTag: function(tempItemValue) {
	            var dropdowntree = this._dropdowntree;

	            return dropdowntree._tags.find(function(item) {
	                return dropdowntree._valueComparer(item, tempItemValue);
	            });
	        }
	    });

	    kendo.ui.DropDownTree.SingleSelection = SingleSelection;
	    kendo.ui.DropDownTree.MultipleSelection = MultipleSelection;

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1185:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("mJM+");

/***/ })

/******/ });

/***/ }),

/***/ "AMSY":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(984);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 971:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("cmba");

/***/ }),

/***/ 984:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(985), __webpack_require__(971) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {

	var kendo = window.kendo,
	    extend = $.extend,
	    Editor = kendo.ui.editor,
	    EditorUtils = Editor.EditorUtils,
	    dom = Editor.Dom,
	    registerTool = EditorUtils.registerTool,
	    ToolTemplate = Editor.ToolTemplate,
	    RangeUtils = Editor.RangeUtils,
	    Command = Editor.Command,
	    keys = kendo.keys,
	    KEDITORIMAGEURL = "#k-editor-image-url",
	    KEDITORIMAGETITLE = "#k-editor-image-title",
	    KEDITORIMAGEWIDTH = "#k-editor-image-width",
	    KEDITORIMAGEHEIGHT = "#k-editor-image-height";

	var ImageCommand = Command.extend({
	    init: function(options) {
	        var that = this;
	        Command.fn.init.call(that, options);

	        that.async = true;
	        that.attributes = {};
	    },

	    insertImage: function(img, range) {
	        var attributes = this.attributes;
	        var doc = RangeUtils.documentFromRange(range);

	        if (attributes.src && attributes.src != "http://") {

	            var removeIEAttributes = function() {
	                setTimeout(function(){
	                    if (!attributes.width) {
	                        img.removeAttribute("width");
	                    }

	                    if (!attributes.height) {
	                        img.removeAttribute("height");
	                    }

	                    img.removeAttribute("complete");
	                });
	            };

	            if (!img) {
	                img = dom.create(doc, "img", attributes);
	                img.onload = img.onerror = removeIEAttributes;

	                range.deleteContents();
	                range.insertNode(img);

	                if (!img.nextSibling) {
	                    dom.insertAfter(doc.createTextNode("\ufeff"), img);
	                }

	                removeIEAttributes();

	                range.setStartAfter(img);
	                range.setEndAfter(img);
	                RangeUtils.selectRange(range);
	                return true;
	            } else {
	                img.onload = img.onerror = removeIEAttributes;
	                dom.attr(img, attributes);
	                removeIEAttributes();
	            }
	        }

	        return false;
	    },

	    _dialogTemplate: function(showBrowser) {
	        return kendo.template(
	            '<div class="k-editor-dialog k-popup-edit-form">' +
	                '<div class="k-edit-form-container">' +
	                    '<div class="k-edit-form-content">' +
	                        '# if (showBrowser) { #' +
	                            '<div class="k-filebrowser k-imagebrowser"></div>' +
	                        '# } #' +
	                        "<div class='k-edit-label'>" +
	                            '<label for="k-editor-image-url">#: messages.imageWebAddress #</label>' +
	                        "</div>" +
	                        "<div class='k-edit-field'>" +
	                            '<input type="text" class="k-textbox" id="k-editor-image-url">' +
	                        "</div>" +
	                        "<div class='k-edit-label'>" +
	                            '<label for="k-editor-image-title">#: messages.imageAltText #</label>' +
	                        "</div>" +
	                        "<div class='k-edit-field'>" +
	                            '<input type="text" class="k-textbox" id="k-editor-image-title">' +
	                        "</div>" +
	                        "<div class='k-edit-label'>" +
	                            '<label for="k-editor-image-width">#: messages.imageWidth #</label>' +
	                        "</div>" +
	                        "<div class='k-edit-field'>" +
	                            '<input type="text" class="k-textbox" id="k-editor-image-width">' +
	                        "</div>" +
	                        "<div class='k-edit-label'>" +
	                            '<label for="k-editor-image-height">#: messages.imageHeight #</label>' +
	                        "</div>" +
	                        "<div class='k-edit-field'>" +
	                            '<input type="text" class="k-textbox" id="k-editor-image-height">' +
	                        "</div>" +
	                    '</div>' +
	                    '<div class="k-edit-buttons k-state-default">' +
	                        '<button class="k-dialog-insert k-button k-primary">#: messages.dialogInsert #</button>' +
	                        '<button class="k-dialog-close k-button">#: messages.dialogCancel #</button>' +
	                    '</div>' +
	                '</div>' +
	            '</div>'
	        )({
	            messages: this.editor.options.messages,
	            showBrowser: showBrowser
	        });
	    },

	    redo: function () {
	        var that = this,
	            range = that.lockRange();

	        if (!that.insertImage(RangeUtils.image(range), range)) {
	            that.releaseRange(range);
	        }
	    },

	    exec: function () {
	        var that = this,
	            range = that.lockRange(),
	            applied = false,
	            img = RangeUtils.image(range),
	            imageWidth = img && img.getAttribute("width") || "",
	            imageHeight = img && img.getAttribute("height") || "",
	            dialog,
	            isIE = kendo.support.browser.msie,
	            options = that.editor.options,
	            messages = options.messages,
	            imageBrowser = options.imageBrowser,
	            showBrowser = !!(kendo.ui.ImageBrowser && imageBrowser && imageBrowser.transport && imageBrowser.transport.read !== undefined),
	            dialogOptions = {
	                title: messages.insertImage,
	                visible: false,
	                resizable: showBrowser
	            };

	        this.expandImmutablesIn(range);

	        function apply(e) {
	            var element = dialog.element,
	                w = parseInt(element.find(KEDITORIMAGEWIDTH).val(), 10),
	                h = parseInt(element.find(KEDITORIMAGEHEIGHT).val(), 10);

	            that.attributes = {
	                src: element.find(KEDITORIMAGEURL).val().replace(/ /g, "%20"),
	                alt: element.find(KEDITORIMAGETITLE).val()
	            };

	            that.attributes.width = null;
	            that.attributes.height = null;

	            if (!isNaN(w) && w > 0) {
	                that.attributes.width = w;
	            }

	            if (!isNaN(h) && h > 0) {
	                that.attributes.height = h;
	            }

	            applied = that.insertImage(img, range);

	            close(e);

	            if (that.change) {
	                that.change();
	            }
	        }

	        function close(e) {
	            e.preventDefault();
	            dialog.destroy();

	            dom.windowFromDocument(RangeUtils.documentFromRange(range)).focus();
	            if (!applied) {
	                that.releaseRange(range);
	            }
	        }

	        function keyDown(e) {
	            if (e.keyCode == keys.ENTER) {
	                apply(e);
	            } else if (e.keyCode == keys.ESC) {
	                close(e);
	            }
	        }

	        dialogOptions.close = close;

	        if (showBrowser) {
	            dialogOptions.width = 750;
	        }

	        dialog = this.createDialog(that._dialogTemplate(showBrowser), dialogOptions)
	            .toggleClass("k-filebrowser-dialog", showBrowser)
	            .find(".k-dialog-insert").click(apply).end()
	            .find(".k-dialog-close").click(close).end()
	            .find(".k-edit-field input").keydown(keyDown).end()
	            // IE < 8 returns absolute url if getAttribute is not used
	            .find(KEDITORIMAGEURL).val(img ? img.getAttribute("src", 2) : "http://").end()
	            .find(KEDITORIMAGETITLE).val(img ? img.alt : "").end()
	            .find(KEDITORIMAGEWIDTH).val(imageWidth).end()
	            .find(KEDITORIMAGEHEIGHT).val(imageHeight).end()
	            .data("kendoWindow");

	        var element = dialog.element;
	        if (showBrowser) {
	            this._imageBrowser = new kendo.ui.ImageBrowser(
	                element.find(".k-imagebrowser"),
	                extend({}, imageBrowser)
	            );

	            this._imageBrowser.bind("change", function (ev) {
	                if (ev.selected.get("type") === "f") {
	                    element.find(KEDITORIMAGEURL).val(this.value());
	                }
	            });

	            this._imageBrowser.bind("apply", apply);
	        }

	        if(isIE) {
	            var dialogHeight = element.closest(".k-window").height();
	            element.css("max-height", dialogHeight);
	        }
	        dialog.center().open();
	        element.find(KEDITORIMAGEURL).focus().select();
	    }

	});

	kendo.ui.editor.ImageCommand = ImageCommand;

	registerTool("insertImage", new Editor.Tool({ command: ImageCommand, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Insert Image" }) }));

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 985:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("E+tE");

/***/ })

/******/ });

/***/ }),

/***/ "AhMq":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1429);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Dz7c");

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1429:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1104), __webpack_require__(1059), __webpack_require__(1109) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "timeline",
	    name: "Timeline",
	    category: "web",
	    description: "The Kendo Timeline widget display events over time",
	    depends: [ "userevents" ]
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        DataSource = kendo.data.DataSource,
	        Transition = kendo.effects.Transition,
	        proxy = $.proxy,
	        isArray = $.isArray,

	        LEFT_PAGE = -1,
	        CETER_PAGE = 0,
	        RIGHT_PAGE = 1,
	        VERTICAL = "vertical",
	        TRANSITION_END = "transitionEnd",
	        VIRTUAL_PAGE_COUNT = 3,
	        VIRTUAL_PAGE_CLASS = "timeline-event",
	        FLAGWRAPCLASS = "k-timeline-flag-wrap",
	        TRACKITEMCLASS = "k-timeline-track-item",
	        SCROLLABLEWRAPCLASS = "k-timeline-scrollable-wrap",
	        NS = ".kendoTimeline",
	        CHANGE = "change",
	        DEFAULTHORIZONTALCARDTEMPLATE =
	        '# var titleField = data.titleField, subtitleField = data.subtitleField, descriptionField = data.descriptionField, imagesField = data.imagesField, actionsField = data.actionsField, data = data.data; #' +
	        '<div class="k-card-header">' +
	            '# if(data[titleField]) { #' +
	                '<h5 class="k-card-title">#= data[titleField] #</h5>' +
	            '# }' +
	            'if(data[subtitleField]) { #' +
	                '<h6 class="k-card-subtitle">#= data[subtitleField] #</h6>' +
	            '# } #' +
	        '</div>' +
	        '<div class="k-card-body">' +
	            '<div class="k-card-description">' +
	                '# if(data[descriptionField]) { #' +
	                    '<p>#= data[descriptionField] #</p>' +
	                '# }' +
	                'if(data[imagesField] && data[imagesField].length > 0) { #' +
	                    '<img src="#= data[imagesField][0].src #" class="k-card-image" />' +
	                '# } #' +
	            '</div>' +
	        '</div>' +
	        '# if(data[actionsField] && data[actionsField].length > 0) { #' +
	            '<div class="k-card-actions">' +
	                '# for (var i = 0; i < data[actionsField].length; i++) { #' +
	                    '<a class="k-button k-flat k-primary" href="#= data[actionsField][i].url ? data[actionsField][i].url : "\\#" #">#= data[actionsField][i].text #</a>' +
	                '# } #' +
	            '</div>' +
	        '# } #',
	        DEFAULTVERTICALCARDTEMPLATE =
	        '# var titleField = data.titleField, subtitleField = data.subtitleField, descriptionField = data.descriptionField, imagesField = data.imagesField, actionsField = data.actionsField, data = data.data; #' +
	        '<div class="k-card-header">' +
	            '<h5 class="k-card-title">' +
	                '# if(data[titleField]) { #' +
	                    '<span class="k-event-title">#= data[titleField] #</span>' +
	                '# } #' +
	            '<span class="k-event-collapse k-button k-button-icon k-flat">' +
	                '<span class="k-icon k-i-arrow-chevron-right"></span>' +
	            '</span></h5>'+
	            '# if(data[subtitleField]) { #' +
	                '<h6 class="k-card-subtitle">#= data[subtitleField] #</h6>' +
	            '# } #' +
	        '</div>' +
	        '<div class="k-card-body">' +
	            '<div class="k-card-description">' +
	                '# if(data[descriptionField]) { #' +
	                    '<p>#= data[descriptionField] #</p>' +
	                '# } #' +
	                '# if(data[imagesField] && data[imagesField].length > 0) { #' +
	                    '<img src="#= data[imagesField][0].src #" class="k-card-image" />' +
	                '# } #' +
	            '</div>' +
	        '</div>' +
	        '# if(data[actionsField] && data[actionsField].length > 0) { #' +
	            '<div class="k-card-actions">' +
	                '# for (var i = 0; i < data[actionsField].length; i++) { #' +
	                    '<a class="k-button k-flat k-primary" href="#= data[actionsField][i].url ? data[actionsField][i].url : "\\#" #">#= data[actionsField][i].text #</a>' +
	                '# } #' +
	            '</div>' +
	        '# } #',
	        HORIZONTALTRACKTEMPLATE =
	        '# var itemTemplate = data.itemTemplate, dateField = data.dateField, dateFormat = data.dateFormat, showDateLabels = data.showDateLabels, data = data.data, year = 0; #' +
	            '# for (var i = 0; i < data.length; i++) {' +
	                    'if(!(data[i][dateField] instanceof Date)) {' +
	                        'continue;' +
	                    '}' +
	                    'var currentYear = data[i][dateField].getFullYear();' +
	                    'if(year != currentYear) {' +
	                        'year = currentYear; #' +
	                        '<li class="k-timeline-track-item k-timeline-flag-wrap">' +
	                            '<span class="k-timeline-flag">#= year #</span>' +
	                        '</li>' +
	                    '# } #' +
	                    '<li class="k-timeline-track-item">' +
	                        '<div class="k-timeline-date-wrap">' +
	                            '# if(showDateLabels) { #' +
	                                '<span class="k-timeline-date">#= kendo.toString(data[i][dateField], dateFormat) #</span>' +
	                            '# } #' +
	                        '</div>' +
	                        '<a class="k-timeline-circle"></a>' +
	                    '</li>' +
	            '# } #',
	        VERTICALEVENTSTEMPLATE =
	        '# var itemTemplate = data.itemTemplate, dateField = data.dateField, titleField = data.titleField, descriptionField = data.descriptionField, subtitleField = data.subtitleField, imagesField = data.imagesField, actionsField = data.actionsField, alterMode = data.alterMode, collapsibleEvents = data.collapsibleEvents, dateFormat = data.dateFormat, showDateLabels = data.showDateLabels, data = data.data, counter = 0, year = 0, reverse = false;' +
	            'for (var i = 0; i < data.length; i++) {' +
	                'if(!(data[i][dateField] instanceof Date)) {' +
	                    'continue;' +
	                '}' +
	                'var currentYear = data[i][dateField].getFullYear();' +
	                'if(currentYear != year) {' +
	                    'year = currentYear; #' +
	                    '<li class="k-timeline-flag-wrap">' +
	                        '<span class="k-timeline-flag">#= year #</span>' +
	                    '</li>' +
	                '# } ' +
	                'reverse = counter % 2 === 0 && alterMode; #' +
	            '<li class="#= reverse ? \'k-timeline-event k-reverse\' : \'k-timeline-event\' #" data-uid="#: data[i].uid #">' +
	                '# if(showDateLabels) { #' +
	                    '<div class="k-timeline-date-wrap">' +
	                        '<span class="k-timeline-date">#= kendo.toString(data[i][dateField], dateFormat) #</span>' +
	                    '</div>' +
	                '# } #' +
	                '<a class="k-timeline-circle"></a>' +
	                '<div class="#= collapsibleEvents ? \'k-timeline-card k-collapsed\' : \'k-timeline-card\' #">' +
	                    '<div class="k-card">' +
	                        '<span class="#= reverse ? \'k-timeline-card-callout k-card-callout k-callout-e\' : \'k-timeline-card-callout k-card-callout k-callout-w\' #"></span>' +
	                        '#= itemTemplate({titleField: titleField, subtitleField: subtitleField, descriptionField: descriptionField, imagesField: imagesField, actionsField: actionsField, data: data[i]}) #' +
	                    '</div>' +

	                '</div>' +
	            '</li>' +
	            '# counter ++;' +
	        '} #',
	        ARROWSHTML =
	        '<a class="k-button k-timeline-arrow k-timeline-arrow-left k-state-disabled" title="previous">' +
	            '<span class="k-icon k-i-arrow-60-left"></span>' +
	        '</a>' +
	        '<a class="k-button k-timeline-arrow k-timeline-arrow-right k-state-disabled" title="next">' +
	            '<span class="k-icon k-i-arrow-60-right"></span>' +
	        '</a>';

	        function className(name) {
	            return "k-" + name;
	        }

	        function calculateTransform(element) {
	            var matrix = element.css('transform');
	            var x;
	            var values;

	            if(matrix != "none") {
	                values = matrix.match(/-?[\d\.]+/g);
	                x = values[4];
	                return (x / element.width() * 100);
	            } else {
	                return 0;
	            }
	        }

	        function calculateOffset(element, parentElement) {
	            return element.offset().left - parentElement.offset().left + element.width() / 2;
	        }

	        function applyCssStyles(element, property, value) {
	            element.css(property, value);
	        }

	        var Page = kendo.Class.extend({
	            init: function(container) {
	                this.cardContainer = $("<div class='k-card' />");
	                var cardWrapper = $("<div class='k-timeline-card'></div>").append(this.cardContainer);

	                this.element = $("<li class='" + className(VIRTUAL_PAGE_CLASS) + "'></li>").append(cardWrapper);
	                container.append(this.element);
	            },

	            content: function(htmlContent, uid) {
	                var callOut = $("<span class='k-timeline-card-callout k-card-callout k-callout-n'></span>");
	                this.cardContainer.html(htmlContent);
	                this.cardContainer.append(callOut);
	                this.element.attr("data-uid", uid);
	            },

	            position: function(position) { //position can be -1, 0, 1
	                this.element.css("transform", "translate3d(" + this.element.width() * position + "px, 0, 0)");
	            },

	            setPageCallout: function(propery, value) {
	                var element = this.element;
	                var callOutElement = element.find(".k-timeline-card-callout");
	                callOutElement.css(propery, value);
	            },

	            destroy: function() {
	                var that = this;

	                that.cardContainer = null;
	                that.element.remove();
	                that.element = null;
	            }
	        });

	        var HorizontalPane = kendo.Observable.extend({
	            init: function(element, options) {
	                var that = this;

	                kendo.Observable.fn.init.call(this);

	                this.element = element;

	                var movable,
	                    transition,
	                    pages;

	                movable = new kendo.ui.Movable(that.element);

	                transition = new Transition({
	                    axis: "x",
	                    movable: movable,
	                    onEnd: function() {
	                        that.trigger(TRANSITION_END);
	                    }
	                });

	                pages = [];

	                $.extend(that, {
	                    duration: options && options.duration || 1,
	                    movable: movable,
	                    transition: transition,
	                    pages: pages,
	                    eventTemplate: options.eventTemplate,
	                    eventHeight: options.eventHeight,
	                    dataFieldMappings: options.dataFieldMappings
	                });

	                this.bind([TRANSITION_END], options);
	            },

	            initPages: function() {
	                var pages = this.pages,
	                element = this.element,
	                page;

	                for (var i = 0; i < VIRTUAL_PAGE_COUNT; i++) {
	                    page = new Page(element);
	                    pages.push(page);
	                }
	            },

	            repositionPages: function() {
	                var pages = this.pages;

	                pages[0].position(LEFT_PAGE);
	                pages[1].position(CETER_PAGE);
	                pages[2].position(RIGHT_PAGE);
	            },

	            setPageContent: function(page, data) {
	                var template = typeof this.eventTemplate === Function ? this.eventTemplate : kendo.template(this.eventTemplate);
	                var dataFieldMappings = this.dataFieldMappings;
	                var html;

	                html = template({
	                    data: data,
	                    titleField: dataFieldMappings.title,
	                    subtitleField: dataFieldMappings.subtitle,
	                    descriptionField: dataFieldMappings.description,
	                    imagesField: dataFieldMappings.images,
	                    actionsField: dataFieldMappings.actions
	                });

	                page.content(html, data.uid);
	            },
	            updatePage: function(isForward, data, calloutOffset) {
	                var pages = this.pages;
	                var page = isForward === null ? pages[1] : isForward ? pages[pages.length - 1] : pages[0];

	                this.setPageContent(page, data);
	                page.setPageCallout("left", (calloutOffset / page.element.width()) * 100 + "%");
	            },

	            moveTo: function(offset) {
	                this.movable.moveAxis("x", -offset);
	            },

	            transitionTo: function(offset, ease) {
	                this.transition.moveTo({ location: offset, duration: this.duration, ease: ease });
	            },
	            destroy: function() {
	                var that = this;

	                for (var index = 0; index < that.pages.length; index++) {
	                    that.pages[index].destroy();
	                }

	                that.unbind();

	                that.movable =
	                that.transition =
	                that.dataFieldMappings =
	                that.eventTemplate =
	                that.duration =
	                that.pages = null;
	            }
	        });

	        var Timeline = kendo.ui.Widget.extend({
	            init: function(element, options) {
	                var that = this;
	                var orientation = options.orientation || that.options.orientation;

	                Widget.fn.init.call(this, element, options);

	                this.element.addClass(orientation === VERTICAL ? "k-timeline k-widget k-timeline-vertical": "k-timeline k-widget k-timeline-horizontal");

	                if(orientation != VERTICAL) {
	                    that._horizontal();
	                } else {
	                    that._vertical();
	                }

	                this.element.on("click", ".k-card-actions", function() {
	                    var action = $(event.target);
	                    var dataItemUid = $(event.target).closest(".k-timeline-event").data("uid");
	                    var dataItem = that.dataSource.getByUid(dataItemUid);

	                    that.trigger("actionClick", { sender: that, element: action, dataItem: dataItem});
	                });

	                that.currentEventIndex = 0;
	                that._forward  = null;
	                that._eventPage = 1;
	                that._currentIndex = 0;
	                that._firstIndexInView = 0;

	                that._initDataFieldMappings();

	                that.setDataSource(options.dataSource);
	            },

	            _horizontal: function() {
	                var that = this;
	                var element = this.element;
	                var options = this.options;

	                var trackWrap = $("<div />");
	                var trackEl = $("<div />");
	                var scrollableWrap = $("<ul />");
	                var eventsWrap = $("<div />");
	                var eventsList = $("<ul />");

	                that._trackWrap = trackWrap;
	                that._trackEl = trackEl;
	                that._scrollableWrap = scrollableWrap;
	                that._eventsWrap = eventsWrap;
	                that._eventsList = eventsList;

	                trackWrap.addClass("k-timeline-track-wrap");
	                trackEl.addClass("k-timeline-track");
	                scrollableWrap.addClass("k-timeline-scrollable-wrap");
	                eventsWrap.addClass("k-timeline-events-list");
	                eventsList.addClass("k-timeline-scrollable-wrap");

	                if(options.eventHeight) {
	                    eventsList.height(options.eventHeight);
	                }

	                trackEl.append(scrollableWrap);
	                trackWrap.append(ARROWSHTML);
	                trackWrap.append(trackEl);
	                eventsWrap.append(eventsList);

	                trackWrap.appendTo(element);
	                eventsWrap.appendTo(element);
	            },

	            _vertical: function() {
	                var that = this;
	                var options = this.options;
	                var element = this.element;
	                var eventsList = that._eventsList = $("<ul />");

	                that.element.append(eventsList);

	                if(options.alternatingMode) {
	                    element.addClass("k-timeline-alternating");
	                }

	                if(options.collapsibleEvents) {
	                    element.addClass("k-timeline-collapsible");

	                    this.element.on("click", ".k-card-header", function() {
	                        var card = $(this).closest(".k-timeline-card");
	                        var cardBody = card.find(".k-card-body");
	                        var dataItem = that.dataSource.getByUid(card.closest("li").data("uid"));

	                        if(card.hasClass("k-collapsed")) {
	                            if (!that.trigger("expand", {sender: that, dataItem: dataItem})) {
	                                kendo.fx(cardBody).expand("vertical").stop().play();
	                                card.toggleClass("k-collapsed");
	                            }
	                        } else {
	                            if (!that.trigger("collapse", {sender: that, dataItem: dataItem})) {
	                                kendo.fx(cardBody).expand("vertical").stop().reverse();
	                                card.toggleClass("k-collapsed");
	                            }
	                        }
	                    });
	                }
	            },

	            _renderContentVertical: function(data) {
	                var that = this;
	                var options = that.options;
	                var html;
	                var itemTemplate;

	                if(typeof options.eventTemplate === Function) {
	                    itemTemplate = options.eventTemplate;
	                } else {
	                    itemTemplate = options.eventTemplate ? kendo.template(options.eventTemplate) : kendo.template(DEFAULTVERTICALCARDTEMPLATE, { useWithBlock: false });
	                }

	                var template = kendo.template(VERTICALEVENTSTEMPLATE, { useWithBlock: false });

	                html = template({
	                    data: data,
	                    dateField: options.dataDateField,
	                    titleField: options.dataTitleField,
	                    subtitleField: options.dataSubtitleField,
	                    descriptionField: options.dataDescriptionField,
	                    imagesField: options.dataImagesField,
	                    actionsField: options.dataActionsField,
	                    itemTemplate: itemTemplate,
	                    alterMode: options.alternatingMode,
	                    collapsibleEvents: options.collapsibleEvents,
	                    dateFormat: options.dateFormat,
	                    showDateLabels: options.showDateLabels
	                });

	                this._eventsList.html(html);

	                if(options.eventWidth) {
	                    that.element.find(".k-card").width(options.eventWidth);
	                }
	            },

	            _renderContentHorizontal: function(data) {
	                var that = this;
	                var options = that.options;
	                var html;
	                var itemTemplate;
	                var dataFieldMappings = that._dataFieldMappings;

	                if(typeof options.eventTemplate === Function) {
	                    itemTemplate = options.eventTemplate;
	                } else {
	                    itemTemplate = options.eventTemplate ? kendo.template(options.eventTemplate) : kendo.template(DEFAULTHORIZONTALCARDTEMPLATE, { useWithBlock: false });
	                }

	                var trackTemplate = kendo.template(HORIZONTALTRACKTEMPLATE, { useWithBlock: false });

	                html = trackTemplate({data: data, itemTemplate: itemTemplate, dateFormat: options.dateFormat, dateField: options.dataDateField, showDateLabels: options.showDateLabels});

	                if(options.initialEventIndex) {
	                    that._trackWrap.append($(html).find(".k-timeline-scrollable-wrap").css("transform", "translateX(-100%)").parent());
	                } else {
	                    that._scrollableWrap.html(html);
	                }

	                if(that.pane) {
	                    that.pane.destroy();
	                }

	                that.pane = new HorizontalPane(that._eventsList, {
	                    transitionEnd: proxy(this, "_transitionEnd"),
	                    eventTemplate: itemTemplate,
	                    dataFieldMappings: dataFieldMappings,
	                    eventHeight: options.eventHeight
	                });
	            },

	            _initDataFieldMappings: function() {
	                var that = this;
	                var options = that.options;

	                that._dataFieldMappings = {
	                    "title": options.dataTitleField,
	                    "subtitle": options.dataSubtitleField,
	                    "date": options.dataDateField,
	                    "description": options.dataDescriptionField,
	                    "images": options.dataImagesField,
	                    "actions": options.dataActionsField
	                };
	            },

	            _transitionEnd: function() {
	                if(this._forward) {
	                    this.pane.pages.push(this.pane.pages.shift());//forward
	                } else {
	                    this.pane.pages.unshift(this.pane.pages.pop());//back
	                }

	                this._forward = null;

	                this.pane.repositionPages();
	                this.pane.movable.moveAxis("x", 0);
	                this._animationInProgress = false;
	            },

	            _setCurrentEvent: function(event) {
	                var that = this;
	                var trackItem = $(event.currentTarget);
	                var eventContainer;
	                var dataItem = that.dataSource.view()[trackItem.index("li[class='k-timeline-track-item']")];

	                eventContainer = that._forward ? that.pane.pages[2].element : that.pane.pages[0].element;

	                if(!that.trigger("change", { eventContainer: eventContainer, dataItem: dataItem})) {
	                    that.open(trackItem);
	                }
	            },

	            open: function(element) {
	                var that = this;

	                var trackItem = $(element);
	                var trackItemCircle = trackItem.find(".k-timeline-circle");
	                var itemIndex = trackItem.index("li[class='k-timeline-track-item']");
	                var forward;


	                var dataItem = that.dataSource.view()[itemIndex];

	                if(that.currentEventIndex === itemIndex) {
	                    return;
	                }

	                that._currentIndex = trackItem.index();
	                forward = that._forward = that.currentEventIndex < itemIndex;
	                that.currentEventIndex = itemIndex;

	                that.pane.updatePage(forward, dataItem, calculateOffset(trackItemCircle, that._trackWrap));

	                if(that._forward) {
	                    clearTimeout(that.navigateTimeOut);
	                    that.navigateTimeOut = setTimeout(function(){
	                        that.pane.transition.moveTo({ location: -that.pane.pages[2].element.width(), duration: 800, ease: Transition.easeOutExpo });
	                    }, 200);

	                } else {
	                    clearTimeout(that.navigateTimeOut);
	                    that.navigateTimeOut = setTimeout(function(){
	                        that.pane.transition.moveTo({ location: that.pane.pages[0].element.width(), duration: 800, ease: Transition.easeOutExpo });
	                    }, 200);
	                }

	                that._repositionEvents();
	            },

	            _navigateToView: function(event) {
	                var that = this;
	                var delta = $(event.currentTarget).hasClass("k-timeline-arrow-right") ? 1 : -1;

	                if(!that.trigger("navigate", {sender: that, action: delta > 0 ? "next": "previous"}) && !that._animationInProgress) {
	                    that._animationInProgress = true;

	                    if(delta > 0) {
	                        that.next();
	                    } else {
	                        that.previous();
	                    }
	                    that._updateArrows();
	                }
	            },

	            _updateArrows: function() {
	                var that = this;
	                var arrows = that.element.find(".k-timeline-arrow");


	                if(that._validateNavigation(false)) {
	                    arrows.filter(".k-timeline-arrow-left").addClass("k-state-disabled");
	                } else {
	                    arrows.filter(".k-timeline-arrow-left").removeClass("k-state-disabled");
	                }

	                if(that._validateNavigation(true)) {
	                    arrows.filter(".k-timeline-arrow-right").addClass("k-state-disabled");
	                } else {
	                    arrows.filter(".k-timeline-arrow-right").removeClass("k-state-disabled");
	                }
	            },

	            _validateNavigation: function(next) {
	                var that = this;
	                var transform = that._end || 0;

	                if(next) {
	                    return that._firstIndexInView + that.numOfEvents >= that.maxEvents;
	                } else {
	                    return Math.abs(transform) <= 1;
	                }
	            },

	            next: function() {
	                var that = this;
	                var options = that.options;

	                if(!that._validateNavigation(true) && options.orientation != VERTICAL) {
	                    that._forward = true;
	                    that._navigate();
	                }

	                that._updateArrows();
	            },

	            _navigate: function() {
	                var that = this;
	                var firstEventInViewIndex;
	                var firstEventInView;
	                var dataItem;
	                var width;
	                var forward = that._forward;
	                var end = calculateTransform(this._trackWrap.find("." + SCROLLABLEWRAPCLASS));
	                var leftOffset = forward ? - $("." + SCROLLABLEWRAPCLASS).width() : $("." + SCROLLABLEWRAPCLASS).width();
	                var currentIndex = that._currentIndex;
	                var currentPage;
	                var firstIndexInView = that._firstIndexInView;

	                end = forward ? end - 100 : end + 100;

	                if(end >= 0) {
	                    end = 0;
	                }

	                that._end = end;

	                width = that._tackItemWidth;

	                currentPage = Math.floor(currentIndex / that.numOfEvents);

	                if(forward) {
	                    if(that.numOfEvents === 1) {
	                        firstEventInViewIndex =  firstIndexInView  === 0 ? 1 : firstIndexInView;
	                        firstEventInView = this._trackWrap.find("." + TRACKITEMCLASS).eq(firstEventInViewIndex).nextAll(":not(." + FLAGWRAPCLASS + ")").first();
	                        that._firstIndexInView = firstEventInView.index();
	                    } else {
	                        firstEventInViewIndex = firstIndexInView + that.numOfEvents - 1;
	                        firstEventInView = this._trackWrap.find("." + TRACKITEMCLASS).eq(firstEventInViewIndex).nextAll(":not(." + FLAGWRAPCLASS + ")").first();
	                        that._firstIndexInView = firstIndexInView + that.numOfEvents;
	                    }
	                } else {
	                    if(that.numOfEvents === 1) {
	                        firstEventInViewIndex =  firstIndexInView;
	                        firstEventInView = this._trackWrap.find("." + TRACKITEMCLASS).eq(firstEventInViewIndex).prevAll(":not(." + FLAGWRAPCLASS + ")").first();
	                        that._firstIndexInView = firstEventInView.index();
	                    } else {
	                        firstEventInViewIndex = firstIndexInView;
	                        firstEventInView = this._trackWrap.find("." + TRACKITEMCLASS).eq(firstEventInViewIndex).prevAll(":not(." + FLAGWRAPCLASS + ")").first();
	                        firstEventInView = firstEventInView.length > 0 ? firstEventInView : this._trackWrap.find("." + TRACKITEMCLASS + ":not(." + FLAGWRAPCLASS + ")").first();
	                        that._firstIndexInView = firstIndexInView - that.numOfEvents < 0 ? 0 : firstIndexInView - that.numOfEvents;
	                    }
	                }

	                dataItem = that.dataSource.view()[firstEventInView.index("li[class='k-timeline-track-item']")];

	                this._trackWrap.find("." + SCROLLABLEWRAPCLASS).css("transform",  "translateX(" + end + "%)");

	                if(that._currentIndex != firstEventInView.index()) {
	                    that.currentEventIndex = firstEventInView.index("li[class='k-timeline-track-item']");

	                    that._currentIndex = firstEventInView.index();

	                    that.pane.updatePage(that._forward, dataItem, (currentPage === 0 && !forward ? firstEventInView.find(".k-timeline-circle").offset().left + 15 : calculateOffset(firstEventInView.find(".k-timeline-circle"), that._trackWrap) + leftOffset));

	                    clearTimeout(that.navigateTimeOut);

	                    that.navigateTimeOut = setTimeout(function() {
	                        if(forward && that.pane && that.pane.pages.length > 0) {
	                            that.pane.transition.moveTo({ location: - that.pane.pages[2].element.width(), duration: 800, ease: Transition.easeOutExpo });
	                        } else {
	                            that.pane.transition.moveTo({ location: that.pane.pages[0].element.width(), duration: 800, ease: Transition.easeOutExpo });
	                        }
	                    }, 200);
	                } else {
	                    var scrollWrapElement = this._trackWrap.find("." + SCROLLABLEWRAPCLASS);
	                    var transitionEndHandler = function() {
	                        if(that.numOfEvents != 1) {
	                            var page = that.pane.pages[1];
	                            var calloutOffset = calculateOffset(firstEventInView.find(".k-timeline-circle"), that._trackWrap);
	                            page.setPageCallout("left", (calloutOffset / page.element.width()) * 100 + "%");
	                        }
	                        scrollWrapElement.off('transitionend' + NS, transitionEndHandler);
	                    };
	                    scrollWrapElement.on('transitionend' + NS, transitionEndHandler);
	                }
	            },

	            previous: function() {
	                var that = this;
	                var options = that.options;

	                if(!that._validateNavigation(false) && options.orientation != VERTICAL) {
	                    that._forward = false;
	                    that._navigate();
	                }

	                that._updateArrows();
	            },

	            expand: function(event) {
	                var cardWrapper = $(event).find(".k-timeline-card");
	                var cardBody = $(event).find(".k-card-body");

	                if(cardWrapper.hasClass("k-collapsed")) {
	                    kendo.fx(cardBody).expand("vertical").stop().play();
	                    cardWrapper.removeClass('k-collapsed');
	                }
	            },

	            collapse: function(event) {
	                var cardWrapper = $(event).find(".k-timeline-card");
	                var cardBody = $(event).find(".k-card-body");

	                if(!cardWrapper.hasClass("k-collapsed")) {
	                    kendo.fx(cardBody).expand("vertical").stop().reverse();
	                    cardWrapper.addClass("k-collapsed");
	                }
	            },

	            items: function() {
	                return this.element.find("li[data-uid]");
	            },

	            _resizeHandler: function() {
	                var that = this;
	                clearTimeout(that.resizeTimeOut);
	                that.resizeTimeOut = setTimeout(function(){
	                    that._redrawEvents();
	                    that.pane.repositionPages();
	                });
	            },

	            redraw: function() {
	                var options = this.options;
	                if(options.orientation != VERTICAL) {
	                    this._redrawEvents();
	                    this.pane.repositionPages();
	                }
	            },

	            _redrawEvents: function() {
	                var that = this;
	                var numOfEvents = Math.floor(that.element.find(".k-timeline-scrollable-wrap").width() / 150);
	                var width;

	                if(that.element.width() <= 480) {
	                    that.element.addClass("k-timeline-mobile");
	                    width = 100;
	                    that.numOfEvents = 1;
	                    that._tackItemWidth = width;
	                    that.element.find("li.k-timeline-track-item").css("flex", "1 0 " + width + "%");
	                    that._repositionEvents();
	                } else {
	                    that.element.removeClass("k-timeline-mobile");
	                    if(numOfEvents != that.numOfEvents) {
	                        that.numOfEvents = numOfEvents;
	                        width = 100 / numOfEvents;
	                        applyCssStyles(that.element.find("li.k-timeline-track-item"), "flex", "1 0 " + width + "%");
	                        that._tackItemWidth = width;
	                        that._repositionEvents();
	                    }
	                }

	                that._updateArrows();
	            },

	            _repositionEvents: function() {
	                var that = this;
	                var width = that._tackItemWidth;
	                var page = that._forward === null ? that.pane.pages[1] : that._forward ? that.pane.pages[2] : that.pane.pages[0];
	                var trackWrapScrollableElement = this._trackWrap.find("." + SCROLLABLEWRAPCLASS);
	                var end = calculateTransform(trackWrapScrollableElement);
	                var calloutOffset;
	                var offset;
	                var leftOffset;
	                var circleElement;

	                if(that.numOfEvents === 1) {
	                    offset = that.currentEventIndex * width;
	                } else {
	                    offset = that._currentIndex * width;
	                }
	                if(page) {
	                    if(that.numOfEvents === 1) {
	                        page.setPageCallout("left", "50%");
	                        leftOffset = offset;
	                        applyCssStyles(trackWrapScrollableElement, "transform", "translateX(-" + leftOffset + "%)");
	                        that._firstIndexInView = that._currentIndex;
	                        that._updateArrows();
	                        return;
	                    }
	                    if(offset >= Math.abs(end) + 100) {
	                        leftOffset = Math.abs(end) + ((offset - (Math.abs(end) + 100)) + width);
	                        that._end = -leftOffset;
	                        applyCssStyles(trackWrapScrollableElement, "transform", "translateX(-" + leftOffset + "%)");
	                        that._firstIndexInView = that._currentIndex - that.numOfEvents + 1;
	                    }
	                    else if(offset <= Math.abs(end)) {
	                        leftOffset = offset;
	                        that._end = -leftOffset;
	                        applyCssStyles(trackWrapScrollableElement, "transform", "translateX(-" + leftOffset + "%)");
	                        that._firstIndexInView = that._currentIndex;
	                    } else {
	                        circleElement = trackWrapScrollableElement.find("li.k-timeline-track-item").eq(that._currentIndex).find(".k-timeline-circle");
	                        calloutOffset = calculateOffset(circleElement, that._trackWrap);
	                        page.setPageCallout("left", (calloutOffset / page.element.width()) * 100 + "%");
	                        that._firstIndexInView = Math.round(Math.abs(end) / width);
	                    }
	                    var scrollWrapElement = this._trackWrap.find("." + SCROLLABLEWRAPCLASS);
	                    var transitionEndHandler = function() {
	                        if(that.numOfEvents != 1) {
	                            var page = that.pane.pages[1];
	                            var eventElement = that._trackWrap.find("." + TRACKITEMCLASS).eq(that._currentIndex);
	                            var calloutOffset = calculateOffset(eventElement.find(".k-timeline-circle"), that._trackWrap);
	                            page.setPageCallout("left", (calloutOffset / page.element.width()) * 100 + "%");
	                        }
	                        scrollWrapElement.off('transitionend' + NS, transitionEndHandler);
	                    };
	                    scrollWrapElement.on('transitionend' + NS, transitionEndHandler);
	                }

	                that._updateArrows();
	            },

	            _initHorizontal: function() {
	                var that = this;
	                var firstEventElement = that._trackWrap.find(".k-timeline-circle").first();
	                var dataItem = that.dataSource.view()[0];

	                that.maxEvents = that._trackWrap.find(".k-timeline-track-item").length;

	                that._currentIndex = 1;

	                that.pane.initPages();

	                that.pane.repositionPages();

	                that.pane.updatePage(that._forward, dataItem, calculateOffset(firstEventElement, that._trackWrap));

	                that._updateArrows();

	                $(window).on("resize" + NS, proxy(this, "_resizeHandler"));
	                that._trackWrap.on("click", ".k-timeline-track-item:not(.k-timeline-flag-wrap)", proxy(this, "_setCurrentEvent"));
	                that._trackWrap.on("click", ".k-timeline-arrow:not(.k-state-disabled)", proxy(this, "_navigateToView"));
	            },

	            setDataSource: function(dataSource) {
	                var that = this;
	                var options = that.options;

	                dataSource = isArray(dataSource) ? { data: dataSource } : dataSource;

	                if (that.dataSource && that._refresh) {
	                    that.dataSource.unbind(CHANGE, that._refresh);
	                } else {
	                    this._refresh = proxy(that, "refresh");
	                }

	                this.dataSource = DataSource.create(dataSource);
	                if(this.dataSource._sort === undefined) {
	                    this.dataSource._sort = [{field: options.dataDateField, dir: "asc"}];
	                }

	                that.dataSource.bind(CHANGE, that._refresh);

	                if (options.autoBind) {
	                    this.dataSource.fetch();
	                }
	            },

	            refresh: function() {
	                var that = this;
	                var options = that.options;

	                var data = this.dataSource.view();

	                if(options.orientation != VERTICAL) {
	                    that._trackWrap.empty().remove();
	                    that.element.find('.k-timeline-events-list').remove();
	                    that._horizontal();
	                }

	                that.currentEventIndex = 0;
	                that._forward  = null;
	                that._eventPage = 1;
	                that._currentIndex = 0;
	                that._firstIndexInView = 0;
	                that.numOfEvents = null;
	                that._end = 0;

	                that._initDataFieldMappings();

	                if(data.length){
	                    if(options.orientation === "horizontal") {
	                        that._renderContentHorizontal(data);
	                        that._redrawEvents();
	                        that._initHorizontal();

	                    } else {
	                        that._renderContentVertical(data);
	                    }
	                }

	                that.trigger("dataBound", {sender: that});
	            },

	            destroy: function() {
	                var options = this.options;

	                Widget.fn.destroy.call(this);

	                if(this.resizeTimeOut) {
	                    clearTimeout(this.resizeTimeOut);
	                }

	                if(this.navigateTimeOut) {
	                    clearTimeout(this.navigateTimeOut);
	                }

	                $(window).off("resize" + NS, this._resizeHandler);

	                this.element.off();

	                if(options.orientation != VERTICAL) {
	                    this.pane.destroy();

	                    this._trackWrap.find("." + SCROLLABLEWRAPCLASS).off();
	                    this._trackWrap.off();

	                    this.currentEventIndex =
	                    this.maxEvents =
	                    this.numOfEvents =
	                    this._currentIndex =
	                    this._eventPage =
	                    this._eventsList =
	                    this._eventsWrap =
	                    this.element =
	                    this._trackWrap =
	                    this.pane = null;
	                }

	                kendo.destroy(this.element);

	                this._dataFieldMappings = this.element = null;
	            },

	            options: {
	                autoBind: true,
	                name: "Timeline",
	                orientation: "vertical",
	                dateFormat: "MMM d, yyyy",
	                showDateLabels: true,
	                collapsibleEvents: false,
	                alternatingMode: false,
	                dataTitleField: "title",
	                dataDateField: "date",
	                dataSubtitleField: "subtitle",
	                dataDescriptionField: "description",
	                dataImagesField: "images",
	                dataActionsField: "actions"
	            },

	            events: [
	                "collapse",
	                "dataBound",
	                "expand",
	                "actionClick",
	                "change",
	                "navigate"
	            ]
	        });
	    kendo.ui.plugin(Timeline);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "AhTV":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1377);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1369:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("dWoE");

/***/ }),

/***/ 1377:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1369) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "scheduler.timelineview",
	    name: "Scheduler Timeline View",
	    category: "web",
	    description: "The Scheduler Timeline View",
	    depends: [ "scheduler.view" ],
	    hidden: true
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        setTime = kendo.date.setTime,
	        SchedulerView = ui.SchedulerView,
	        outerWidth = kendo._outerWidth,
	        outerHeight = kendo._outerHeight,
	        extend = $.extend,
	        proxy = $.proxy,
	        getDate = kendo.date.getDate,
	        getMilliseconds = kendo.date.getMilliseconds,
	        MS_PER_DAY = kendo.date.MS_PER_DAY,
	        MS_PER_MINUTE = kendo.date.MS_PER_MINUTE,
	        CURRENT_TIME_MARKER_CLASS = "k-current-time",
	        CURRENT_TIME_MARKER_ARROW_CLASS = "k-current-time-arrow",
	        SCHEDULER_HEADER_WRAP_CLASS = "k-scheduler-header-wrap",
	        INVERSE_COLOR_CLASS = "k-event-inverse",
	        BORDER_SIZE_COEFF = 0.8666,
	        NS = ".kendoTimelineView";

	    var EVENT_TEMPLATE = kendo.template('<div>' +
	        '<div class="k-event-template k-event-time">#:kendo.format("{0:t} - {1:t}", start, end)#</div>' +
	        '<div class="k-event-template">${title}</div></div>'),
	        DATA_HEADER_TEMPLATE = kendo.template("<span class='k-link k-nav-day'>#=kendo.format('{0:m}', date)#</span>"),
	        EVENT_WRAPPER_STRING = '<div role="gridcell" aria-selected="false" ' +
	                'data-#=ns#uid="#=uid#"' +
	                '#if (resources[0]) { #' +
	                    'style="background-color:#=resources[0].color#; border-color: #=resources[0].color#"' +
	                    'class="k-event" ' +
	                '#} else {#' +
	                    'class="k-event"' +
	                '#}#' +
	                '>' +
	                '<span class="k-event-actions">' +
	                    '# if(data.tail) {#' +
	                        '<span class="k-icon k-i-arrow-60-left"></span>' +
	                    '#}#' +
	                    '# if(data.isException()) {#' +
	                        '<span class="k-icon k-i-non-recurrence"></span>' +
	                    '# } else if(data.isRecurring()) {#' +
	                        '<span class="k-icon k-i-reload"></span>' +
	                    '# } #' +
	                '</span>' +
	                '{0}' +
	                '<span class="k-event-actions">' +
	                    '#if (showDelete) {#' +
	                        '<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>' +
	                    '#}#' +
	                    '# if(data.head) {#' +
	                        '<span class="k-icon k-i-arrow-60-right"></span>' +
	                    '#}#' +
	                '</span>' +
	                '#if(resizable && !data.tail){#' +
	                '<span class="k-resize-handle k-resize-w"></span>' +
	                '#}#' +
	                '#if(resizable && !data.head){#' +
	                '<span class="k-resize-handle k-resize-e"></span>' +
	                '#}#' +
	                '</div>';

	    function toInvariantTime(date) {
	        var staticDate = new Date(1980, 1, 1, 0, 0, 0);
	        setTime(staticDate, getMilliseconds(date));
	        return staticDate;
	    }

	    function getWorkDays(options) {
	        if(options.workDays && options.workDays.length) {
	            return options.workDays;
	        }

	        var workDays = [];
	        var dayIndex = options.workWeekStart % 7;
	        var workWeekEnd = Math.abs(options.workWeekEnd % 7);

	        workDays.push(dayIndex);

	        while(workWeekEnd != dayIndex) {
	            if(dayIndex > 6 ) {
	                dayIndex -= 7;
	            } else {
	                dayIndex++;
	            }
	            workDays.push(dayIndex);
	        }
	        return workDays;
	    }

	    function setColspan(columnLevel) {
	        var count = 0;
	        if (columnLevel.columns) {
	            for (var i = 0; i < columnLevel.columns.length; i++) {
	                count += setColspan(columnLevel.columns[i]);
	            }
	            columnLevel.colspan = count;
	            return count;
	        } else {
	            columnLevel.colspan = 1;
	            return 1;
	        }
	    }

	    function collidingEvents(elements, left, right) {
	        var idx,
	            startPosition,
	            overlaps,
	            endPosition;

	        for (idx = elements.length-1; idx >= 0; idx--) {
	            startPosition = elements[idx].rectLeft;
	            endPosition = elements[idx].rectRight;

	            overlaps = startPosition <= left && endPosition >= left;

	            if (overlaps || (startPosition >= left && endPosition <= right) || (left <= startPosition && right >= startPosition)) {
	                if (startPosition < left) {
	                    left = startPosition;
	                }

	                if (endPosition > right) {
	                    right = endPosition;
	                }
	            }
	        }

	        return eventsForSlot(elements, left, right);
	    }

	    function eventsForSlot(elements, left, right) {
	        var events = [];

	        for (var idx = 0; idx < elements.length; idx++) {
	            var event = {
	                rectLeft: elements[idx].rectLeft,
	                rectRight: elements[idx].rectRight
	            };

	            if ((event.rectLeft < left && event.rectRight > left) || (event.rectLeft >= left && event.rectRight <= right)) {
	                events.push(elements[idx]);
	            }
	        }

	        return events;
	    }

	    var TimelineGroupedView = kendo.Class.extend({
	        init: function(view) {
	            this._view = view;
	        },

	        _getTimeSlotByPosition: function(x, y, groupIndex) {
	            var group = this._view.groups[groupIndex];

	            return group.timeSlotByPosition(x, y);
	        },

	        _hideHeaders: function() {
	            var view = this._view;

	            view.timesHeader.find("table tr:last").hide(); /*Chrome fix, use CSS selector*/
	            view.datesHeader.find("table tr:last").hide();
	        },

	        _setColspan: function(timeColumn) {
	            setColspan(timeColumn);
	        },

	        _createRowsLayout: function(resources, rows, groupHeaderTemplate) {
	            var view = this._view;

	            return view._createRowsLayout(resources, rows, groupHeaderTemplate);
	        },

	        _createVerticalColumnsLayout: function(resources, rows, groupHeaderTemplate, columns) {

	            return columns;
	        },

	        _createColumnsLayout: function(resources, columns, groupHeaderTemplate) {
	            var view = this._view;

	            return view._createColumnsLayout(resources, columns, groupHeaderTemplate);
	        },

	        _getRowCount: function() {
	            var view = this._view;

	            return view._groupCount();
	        },

	        _getGroupsCount: function() {
	            return 1;
	        },

	        _addContent: function(dates, columnCount, groupsCount, rowCount, start, end, slotTemplate, isVerticalGrouped) {
	            var view = this._view;
	            var html = '';
	            var options = view.options;

	            var appendRow = function(date) {
	                var content = "";
	                var classes = "";
	                var tmplDate;

	                var resources = function(groupIndex) {
	                    return function() {
	                        return view._resourceBySlot({ groupIndex: groupIndex });
	                    };
	                };

	                if (kendo.date.isToday(dates[idx])) {
	                    classes += "k-today";
	                }

	                if (kendo.date.getMilliseconds(date) < kendo.date.getMilliseconds(options.workDayStart) ||
	                    kendo.date.getMilliseconds(date) >= kendo.date.getMilliseconds(options.workDayEnd) ||
	                    !view._isWorkDay(dates[idx])) {
	                    classes += " k-nonwork-hour";
	                }

	                content += '<td' + (classes !== "" ? ' class="' + classes + '"' : "") + ">";
	                tmplDate = kendo.date.getDate(dates[idx]);
	                kendo.date.setTime(tmplDate, kendo.date.getMilliseconds(date));

	                content += slotTemplate({ date: tmplDate, resources: resources(isVerticalGrouped ? rowIdx : groupIdx) });
	                content += "</td>";

	                return content;
	            };

	            for (var rowIdx = 0; rowIdx < rowCount; rowIdx++) {
	                html += '<tr>';
	                for (var groupIdx = 0 ; groupIdx < groupsCount; groupIdx++) {
	                    for (var idx = 0, length = columnCount; idx < length; idx++) {
	                        html += view._forTimeRange(start, end, appendRow);
	                    }
	                }
	                html += "</tr>";
	            }
	            return html;
	        },

	        _addTimeSlotsCollections: function(groupCount, datesCount, tableRows, interval, isVerticallyGrouped) {
	            var view = this._view;
	            var rowCount = tableRows.length;

	            if (isVerticallyGrouped) {
	                rowCount = Math.floor(rowCount / groupCount);
	            }

	            for (var groupIndex = 0; groupIndex < groupCount; groupIndex++) {
	                var rowMultiplier = 0;
	                var group = view.groups[groupIndex];
	                var time;

	                if (isVerticallyGrouped) {
	                    rowMultiplier = groupIndex;
	                }

	                var rowIndex = rowMultiplier * rowCount;
	                var cellMultiplier = 0;

	                if (!isVerticallyGrouped) {
	                    cellMultiplier = groupIndex;
	                }

	                var cells = tableRows[rowIndex].children;
	                var cellsPerGroup = cells.length / (!isVerticallyGrouped ? groupCount : 1);
	                var cellsPerDay = cellsPerGroup / datesCount;

	                for (var dateIndex = 0; dateIndex < datesCount; dateIndex++) {
	                    var cellOffset = dateIndex * cellsPerDay + (cellsPerGroup * cellMultiplier);
	                    time = getMilliseconds(new Date(+view.startTime()));

	                    for (var cellIndex = 0; cellIndex < cellsPerDay ; cellIndex++) {

	                        view._addTimeSlotToCollection(group, cells, cellIndex, cellOffset, dateIndex, time, interval);
	                        time += interval;
	                    }
	                }
	            }
	        },

	        _getVerticalGroupCount: function(groupsCount) {

	            return groupsCount;
	        },

	        _getVerticalRowCount: function(eventGroups, groupIndex, maxRowCount) {
	            var view = this._view;

	            return view._isVerticallyGrouped() ? eventGroups[groupIndex].maxRowCount : maxRowCount;
	        },

	        _renderEvent: function(eventGroup, event, adjustedEvent, group, range, container) {
	            var view = this._view;
	            var element;

	            element = view._createEventElement(adjustedEvent.occurrence, event, range.head || adjustedEvent.head, range.tail || adjustedEvent.tail);
	            element.appendTo(container).css({top: 0, height: view.options.eventHeight});

	            var eventObject = {
	                start: adjustedEvent.occurrence._startTime || adjustedEvent.occurrence.start,
	                end: adjustedEvent.occurrence._endTime || adjustedEvent.occurrence.end,
	                element: element,
	                uid: event.uid,
	                slotRange: range,
	                rowIndex: 0,
	                offsetTop: 0
	            };

	            eventGroup.events[event.uid] = eventObject;

	            view._inverseEventColor(element);
	            view.addContinuousEvent(group, range, element, event.isAllDay);
	            view._arrangeRows(eventObject, range, eventGroup);
	        },

	        _verticalCountForLevel: function(level) {
	            var view = this._view;

	            return view._rowCountForLevel(level);
	        },

	        _horizontalCountForLevel: function(level) {
	            var view = this._view;

	            return view._columnCountForLevel(level);
	        },

	        _updateCurrentVerticalTimeMarker: function(ranges, currentTime) {
	            var view = this._view;
	            var elementHtml = "<div class='" + CURRENT_TIME_MARKER_CLASS + "'></div>";
	            var headerWrap = view.datesHeader.find("." + SCHEDULER_HEADER_WRAP_CLASS);
	            var left = Math.round(ranges[0].innerRect(currentTime, new Date(currentTime.getTime() + 1), false).left);
	            var timesTableMarker = $(elementHtml)
	                    .prependTo(headerWrap)
	                    .addClass(CURRENT_TIME_MARKER_ARROW_CLASS + "-down");

	            timesTableMarker.css({
	                left: view._adjustLeftPosition(left - (outerWidth(timesTableMarker) * BORDER_SIZE_COEFF / 2)),
	                top: headerWrap.find("tr:last").prev().position().top
	            });

	            $(elementHtml).prependTo(view.content).css({
	                left: view._adjustLeftPosition(left),
	                width: "1px",
	                height: view.content[0].scrollHeight - 1,
	                top: 0
	            });
	        },

	        _changeGroup: function() {
	            return undefined;
	        },

	        _prevGroupSlot: function(slot, group, isDay) {
	            var view = this._view;

	            if (view._isVerticallyGrouped()) {
	                return slot;
	            } else {
	                var collection = group._collection(0, isDay);
	                return collection.last();
	            }
	        },

	        _nextGroupSlot: function(slot, group, isDay) {
	            var view = this._view;

	            if (view._isVerticallyGrouped()) {
	                return slot;
	            } else {
	                var collection = group._collection(0, isDay);
	                return collection.first();
	            }
	        },

	        _verticalSlots: function(selection, reverse) {
	             var view = this._view;

	             return view._changeGroup(selection, reverse);
	        },

	         _verticalMethod: function(reverse) {

	              return  reverse ? "leftSlot" : "rightSlot";
	         },

	         _normalizeVerticalSelection: function() {
	             return undefined;
	         },

	         _horizontalSlots: function(selection, group, method, startSlot, endSlot, multiple, reverse) {
	            var view = this._view;
	            var result = {};

	            result.startSlot = group[method](startSlot);
	            result.endSlot = group[method](endSlot);

	            if (!multiple && view._isHorizontallyGrouped() && (!result.startSlot || !result.endSlot)) {
	                result.startSlot = result.endSlot = view._changeGroup(selection, reverse);
	            }

	            return result;
	        },

	        _changeVerticalViewPeriod: function() {
	            return false;
	        },

	        _changeHorizontalViewPeriod: function(slots, shift, selection, reverse) {
	            var view = this._view;

	            if ((!slots.startSlot ||!slots.endSlot ) && !shift && view._changeViewPeriod(selection, reverse, false)) {
	                return true;
	            }
	            return false;
	        },

	        _updateDirection: function(selection, ranges, shift, reverse) {
	            var view = this._view;

	            view._updateDirection(selection, ranges, shift, reverse, true);
	        },

	         _createMoveHint: function(range, adjustedEvent) {
	                var view = this._view;
	                var startSlot = range.start;

	                var hint = view._createEventElement(adjustedEvent.occurrence ,adjustedEvent.occurrence, false, false);

	                hint.addClass("k-event-drag-hint");

	                var rect = range.innerRect(adjustedEvent.occurrence.start, adjustedEvent.occurrence.end, view.options.snap);
	                var width = rect.right - rect.left;

	                if (width < 0) {
	                    width = 0;
	                }

	                var left = view._adjustLeftPosition(rect.left);

	                var css = {
	                    left: left,
	                    top: startSlot.offsetTop,
	                    height: startSlot.offsetHeight,
	                    width: width
	                };

	                hint.css(css);

	                if(adjustedEvent.occurrence.inverseColor) {
	                    hint.addClass(INVERSE_COLOR_CLASS);
	                }

	                view._appendMoveHint(hint);
	         },

	         _adjustLeftPosition: function(left) {
	            var view = this._view;

	            if (view._isRtl) {
	                left -= (view.content[0].scrollWidth - view.content[0].clientWidth);
	            }

	            return left;
	         }
	    });

	    var TimelineGroupedByDateView = kendo.Class.extend({
	        init: function(view) {
	            this._view = view;
	        },

	        _getTimeSlotByPosition: function(x, y, groupIndex) {
	            var group = this._view.groups[groupIndex];

	            return group.timeSlotByPosition(x, y, true);
	        },

	        _hideHeaders: function() {
	            var view = this._view;

	            if (!view._isVerticallyGrouped()) {
	                view.timesHeader.find("table tr").eq(2).hide();
	                view.datesHeader.find("table tr").eq(2).hide();
	            } else {
	                        view.times.find(".k-last").hide();
	            }
	        },
	        _setColspan: function() {},

	        _createRowsLayout: function(resources, rows, groupHeaderTemplate, columns) {
	            var view = this._view;

	            return view._createDateLayout(columns, null, true);
	        },

	        _createVerticalColumnsLayout: function(resources, rows, groupHeaderTemplate) {
	            var view = this._view;

	            return view._createColumnsLayout(resources, null, groupHeaderTemplate);
	        },

	        _createColumnsLayout: function(resources, columns, groupHeaderTemplate, subColumns) {
	            var view = this._view;

	            return view._createColumnsLayout(resources, columns, groupHeaderTemplate, subColumns, true);
	        },

	        _getRowCount: function(level) {
	            var view = this._view;

	            return view._rowCountForLevel(level);
	        },

	        _getGroupsCount: function() {
	            var view = this._view;

	            return view._groupCount();
	        },

	        _addContent: function(dates, columnCount, groupsCount, rowCount, start, end, slotTemplate, isVerticalGrouped) {
	            var view = this._view;
	            var html = '';
	            var options = view.options;

	            var appendRow = function(date, isMajorTickColumn, isMiddleColumn, isLastSlotColumn, minorTickColumns, groupIdx) {
	                var content = "";
	                var classes = "";
	                var tmplDate;
	                var workDateIndex = view._isVerticallyGrouped() ? dateIndex : idx;

	                var resources = function(groupIndex) {
	                    return function() {
	                        return view._resourceBySlot({ groupIndex: groupIndex });
	                    };
	                };

	                if (kendo.date.isToday(dates[idx])) {
	                    classes += "k-today";
	                }

	                if (kendo.date.getMilliseconds(date) < kendo.date.getMilliseconds(options.workDayStart) ||
	                    kendo.date.getMilliseconds(date) >= kendo.date.getMilliseconds(options.workDayEnd) ||
	                    !view._isWorkDay(dates[workDateIndex])) {
	                    classes += " k-nonwork-hour";
	                }

	                content += '<td' + (classes !== "" ? ' class="' + classes + '"' : "") + ">";
	                tmplDate = kendo.date.getDate(dates[idx]);
	                kendo.date.setTime(tmplDate, kendo.date.getMilliseconds(date));

	                content += slotTemplate({ date: tmplDate, resources: resources(groupIdx)});
	                content += "</td>";

	                return content;
	            };

	            var tempStart = new Date(start),
	                minorTickCount = view.options.minorTickCount,
	                msMajorInterval = view.options.majorTick * MS_PER_MINUTE,
	                msInterval = msMajorInterval / minorTickCount || 1,
	                dateIndex;

	            for (var rowIdx = 0; rowIdx < rowCount; rowIdx++) {
	                html += '<tr>';

	                 if((rowIdx % (rowCount / view._dates.length)) === 0){
	                   dateIndex = (rowIdx / (rowCount / view._dates.length));
	                   tempStart = new Date(view._dates[dateIndex]);
	                   kendo.date.setTime(tempStart, kendo.date.getMilliseconds(start));
	                  }

	                for (var idx = 0, length = columnCount; idx < length; idx++) {

	                    html += view._forTimeRange(tempStart, end, appendRow, isVerticalGrouped, groupsCount);

	                    if (isVerticalGrouped){
	                    setTime(tempStart, msInterval, false);
	                        break;
	                    }
	                }
	               html += "</tr>";
	            }

	            return html;
	        },

	        _addTimeSlotsCollections: function(groupCount, datesCount, tableRows, interval, isVerticallyGrouped) {
	            var view = this._view;
	            var rowCount = tableRows.length;

	             if (isVerticallyGrouped) {
	                rowCount = rowCount/datesCount;
	             }

	            for (var dateIndex = 0; dateIndex < datesCount; dateIndex++) {
	                var rowMultiplier = 0;
	                var time;

	                if (isVerticallyGrouped) {
	                    rowMultiplier = dateIndex;
	                }

	                var rowIndex = rowMultiplier * rowCount;
	                var cellMultiplier = 0;
	                var cells = tableRows[rowIndex].children;
	                var cellsPerGroup = isVerticallyGrouped ? rowCount : cells.length / (datesCount * groupCount);
	                var cellsPerDay = cells.length / datesCount;
	                var cellOffset;

	                time = getMilliseconds(new Date(+view.startTime()));

	                for (var cellIndex = 0; cellIndex < cellsPerGroup; cellIndex++) {
	                    if (!isVerticallyGrouped) {
	                        cellOffset = (dateIndex * cellsPerDay) + (groupCount * cellIndex);
	                        cellMultiplier++;
	                    } else{
	                        cellOffset = 0;
	                        cells = tableRows[cellIndex + (cellsPerGroup*dateIndex)].children;
	                    }

	                    for (var groupIndex = 0; groupIndex < groupCount ; groupIndex++) {
	                        var group = view.groups[groupIndex];

	                        view._addTimeSlotToCollection(group, cells, groupIndex, cellOffset, dateIndex, time, interval);
	                    }
	                    time += interval;
	                }
	             }
	        },

	        _getVerticalGroupCount: function() {
	            var view = this._view;

	            return view.content.find("tr").length;
	        },

	        _getVerticalRowCount: function(eventGroups, groupIndex, maxRowCount) {

	            return maxRowCount;
	        },

	        _renderEvent: function(eventGroup, event, adjustedEvent, group, range, container, startIndex, endIndex) {
	            var view = this._view;
	            var element;
	            var eventObjects = [];

	            for (var i = range.start.index; i <= range.end.index; i++) {
	                element = view._createEventElement(adjustedEvent.occurrence, event, i !== endIndex, i !== startIndex);
	                element.appendTo(container).css({top: 0, height: view.options.eventHeight});
	                var currentSlot = group._timeSlotCollections[0]._slots[i];
	                var dateRange = group.timeSlotRanges(currentSlot.start, currentSlot.end, false)[0];

	                    var eventObject = {
	                    start: i === startIndex ? adjustedEvent.occurrence._startTime || adjustedEvent.occurrence.start : currentSlot.start,
	                    end: i === endIndex ? adjustedEvent.occurrence._endTime || adjustedEvent.occurrence.end : currentSlot.end,
	                    element: element,
	                    uid: event.uid,
	                    slotRange: dateRange,
	                    rowIndex: 0,
	                    offsetTop: 0
	                };

	                eventGroup.events[event.uid] = eventObject;
	                eventObjects.push(eventObject);

	                view.addContinuousEvent(group, dateRange, element, event.isAllDay);
	                view._arrangeRows(eventObject, dateRange, eventGroup);
	            }
	            eventGroup.events[event.uid] = eventObjects;
	        },

	        _verticalCountForLevel: function(level) {
	            var view = this._view;

	            return view._columnCountForLevel(level);
	        },

	        _horizontalCountForLevel: function(level, columnLevel) {
	            var view = this._view;

	            return view._columnCountForLevel(columnLevel) / view._columnCountForLevel(2);
	        },

	        _updateCurrentVerticalTimeMarker: function(ranges,currentTime) {
	            var view = this._view;
	            var firstTimesCell = view.times.find("tr:first th:first");
	            var lastTimesCell = view.times.find("tr:first th:last");
	            var elementHtml = "<div class='" + CURRENT_TIME_MARKER_CLASS + "'></div>";
	            var timesTableMarker = $(elementHtml).prependTo(view.times);
	            var markerTopPosition = Math.round(ranges[0].innerRect(currentTime, new Date(currentTime.getTime() + 1), false).top);
	            var timesTableMarkerCss = {};

	            if (this._isRtl) {
	                timesTableMarkerCss.right = firstTimesCell.position().left + outerHeight(firstTimesCell) - outerHeight(lastTimesCell);
	                timesTableMarker.addClass(CURRENT_TIME_MARKER_ARROW_CLASS + "-left");
	            } else {
	                timesTableMarkerCss.left = lastTimesCell.position().left;
	                timesTableMarker.addClass(CURRENT_TIME_MARKER_ARROW_CLASS + "-right");
	            }

	            timesTableMarkerCss.top = markerTopPosition - (outerWidth(timesTableMarker) * BORDER_SIZE_COEFF / 2);

	            timesTableMarker.css(timesTableMarkerCss);

	            $(elementHtml).prependTo(view.content).css({
	                top: markerTopPosition,
	                height: "1px",
	                right: "1px",
	                width: view.content[0].scrollWidth,
	                left: 0
	            });
	        },

	        _changeGroup: function(selection, previous, slot) {
	             var view = this._view;

	             if (!slot) {
	                selection.groupIndex = previous ? view.groups.length - 1 : 0;
	             }
	        },

	         _prevGroupSlot: function(slot) {
	              return slot;
	        },

	        _nextGroupSlot: function(slot) {
	              return slot;
	        },

	        _changeDate: function(selection, reverse, slot) {
	            var view = this._view;
	            var group = view.groups[selection.groupIndex];
	            var collections, index;

	            if (reverse) {
	                  collections = group._getCollections(false);
	                  index = slot.index - 1;

	                  if (index >= 0) {
	                      return  collections[0]._slots[index];
	                  }
	              } else {
	                  collections = group._getCollections(false);
	                  index = slot.index + 1;

	                  if (collections[0] && collections[0]._slots[index]) {
	                      return  collections[0]._slots[index];
	                  }
	               }
	        },

	        _verticalSlots: function (selection, reverse, slot) {
	            return this._changeDate(selection, reverse, slot);
	        },

	        _verticalMethod: function(reverse, multiple) {
	            if (multiple) {
	               return reverse ? "upSlot" : "downSlot";
	            } else {
	               return  reverse ? "leftSlot" : "rightSlot";
	            }
	        },

	        _normalizeVerticalSelection: function(selection, ranges, reverse, multiple) {
	            var view = this._view;

	            if (!multiple) {
	                return view._normalizeVerticalSelection(selection, ranges, reverse);
	            }

	            return undefined;
	        },

	        _horizontalSlots: function(selection, group, method, startSlot, endSlot, multiple, reverse) {
	             var view = this._view;
	             var tempSlot = view._changeGroup(selection, reverse);
	             var result = {};

	            if (!tempSlot) {
	                if (!view._isVerticallyGrouped()) {
	                    result.startSlot = group[method](startSlot);
	                    result.endSlot = group[method](endSlot);
	                }

	            } else {
	                result.startSlot = result.endSlot = tempSlot;
	            }

	            return result;
	        },

	        _changeVerticalViewPeriod: function(slots, shift, selection, reverse) {
	            var view = this._view;

	            if ((!slots.startSlot || !slots.endSlot) && !shift &&
	                view._changeViewPeriod(selection, reverse, view._isVerticallyGrouped())) {
	                return true;
	            }
	            return false;
	        },

	        _changeHorizontalViewPeriod: function(slots, shift, selection, reverse) {
	           var view = this._view;

	           if ( view._isVerticallyGrouped()) {
	               return false;
	           }

	           if ((!slots.startSlot ||!slots.endSlot ) && !shift && view._changeViewPeriod(selection, reverse, false)) {
	                return true;
	            }
	            return false;
	        },

	        _updateDirection: function(selection, ranges, shift, reverse) {
	            var view = this._view;

	            view._updateDirection(selection, ranges, shift, reverse, !view._isVerticallyGrouped());
	        },

	         _createMoveHint: function(range, adjustedEvent) {
	                var view = this._view;
	                var startSlot = range.start;
	                var startEnd = range.end;

	                for (var slotIdx = startSlot.index; slotIdx <= startEnd.index; slotIdx++) {
	                    var slot = range.collection._slots[slotIdx];
	                    var hint = view._createEventElement(adjustedEvent.occurrence ,adjustedEvent.occurrence, false, false);

	                    hint.addClass("k-event-drag-hint");

	                    var css = {
	                        left: slot.offsetLeft + 2,
	                        top: slot.offsetTop,
	                        height: view.options.eventHeight,
	                        width: slot.offsetWidth
	                    };

	                    hint.css(css);

	                    if(adjustedEvent.occurrence.inverseColor) {
	                        hint.addClass(INVERSE_COLOR_CLASS);
	                    }

	                    view._appendMoveHint(hint);
	                }
	         },

	         _adjustLeftPosition: function(left) {
	             var view = this._view;

	            if (view._isRtl && !view._isVerticallyGrouped()) {
	                left -= (view.content[0].scrollWidth - view.content[0].offsetWidth);
	            }

	            return left;
	         }
	 });

	    kendo.ui.scheduler.TimelineGroupedView = TimelineGroupedView;
	    kendo.ui.scheduler.TimelineGroupedByDateView = TimelineGroupedByDateView;

	    var TimelineView = SchedulerView.extend({
	        init: function(element, options) {
	            var that = this;

	            SchedulerView.fn.init.call(that, element, options);

	            that._groupedView = that._getGroupedView();

	            that.title = that.options.title || that.options.name;

	            that._workDays = getWorkDays(that.options);

	            that._templates();

	            that._editable();

	            that.calculateDateRange();

	            that._groups();

	            that._currentTime(true);
	        },
	        name: "timeline",

	        _isVirtualized: function () {
	            return false;
	        },

	        _getGroupedView: function() {

	            if (this._isGroupedByDate()) {
	                   return new kendo.ui.scheduler.TimelineGroupedByDateView(this);
	            } else {
	                   return new kendo.ui.scheduler.TimelineGroupedView(this);
	            }
	        },

	        _getNextEventIndexBySlot: function(slot, sortedEvents, groupIndex){
	           if(this._isVerticallyGrouped()){
	               return kendo.ui.SchedulerView.fn._getNextEventIndexBySlot.call(this, slot, sortedEvents, groupIndex);
	           }

	            var tempIndex = 0;

	            for (var i = 0; i < sortedEvents.length; i++) {
	                if (slot.startDate()> sortedEvents[i].start.startDate()) {
	                    tempIndex++;
	                    continue;
	                }

	                if (slot.startDate().getTime() === sortedEvents[i].start.startDate().getTime() &&
	                 groupIndex > sortedEvents[i].start.groupIndex) {
	                      tempIndex++;
	                      continue;
	                }

	                 break;

	            }
	            return tempIndex;
	        },

	        _getSelectedSlot: function (slot, sortedEvents, event, idx, pad, prev) {
	            if(this._isVerticallyGrouped()){
	               return kendo.ui.SchedulerView.fn._getSelectedSlot.call(this, slot, sortedEvents, event, idx, pad, prev);
	            }

	            return slot;
	        },

	        _getSortedEvents: function (uniqueAllEvents) {
	            if(this._isVerticallyGrouped()){
	               return kendo.ui.SchedulerView.fn._getSortedEvents.call(this, uniqueAllEvents);
	            }

	            return uniqueAllEvents.sort(function(first, second) {
	                var result = first.start.startDate().getTime() - second.start.startDate().getTime();

	                if (result === 0) {
	                    if (first.start.isDaySlot && !second.start.isDaySlot) {
	                            result = -1;
	                    }

	                    if (!first.start.isDaySlot && second.start.isDaySlot) {
	                            result = 1;
	                    }
	                }

	                if (result === 0) {
	                    result = first.start.groupIndex - second.start.groupIndex;
	                }

	                if (result === 0) {
	                    result = $(first.element).index() - $(second.element).index();
	                }

	                return result;
	            });
	        },

	        _currentTimeMarkerUpdater: function() {
	            this._updateCurrentTimeMarker(new Date());
	        },

	        _updateCurrentTimeMarker: function(currentTime) {
	            var options = this.options;

	            this.datesHeader.find("." + CURRENT_TIME_MARKER_CLASS).remove();
	            this.times.find("." + CURRENT_TIME_MARKER_CLASS).remove();
	            this.content.find("." + CURRENT_TIME_MARKER_CLASS).remove();

	            if (!this._isInDateSlot({start: currentTime, end:currentTime })) {
	                return;
	            }

	            if(options.currentTimeMarker.useLocalTimezone === false) {
	                var timezone = options.dataSource.options.schema.timezone;

	                if(options.dataSource && timezone) {
	                    var timezoneOffset = kendo.timezone.offset(currentTime, timezone);
	                    currentTime = kendo.timezone.convert(currentTime, currentTime.getTimezoneOffset(), timezoneOffset);
	                }
	            }

	            var groupsCount = !options.group || options.group.orientation == "vertical" ? 1 : this.groups.length;

	            for(var groupIndex = 0; groupIndex < groupsCount; groupIndex++) {
	                var currentGroup = this.groups[groupIndex];

	                if (!currentGroup) {
	                    return;
	                }

	                var utcCurrentTime = kendo.date.toUtcTime(currentTime);
	                var ranges = currentGroup.timeSlotRanges(utcCurrentTime, utcCurrentTime + 1);

	                if(ranges.length === 0) {
	                    return;
	                }

	                var collection = ranges[0].collection;
	                var slotElement = collection.slotByStartDate(currentTime);

	                if(slotElement) {

	                    if(this._isVerticallyGrouped()){
	                        this._groupedView._updateCurrentVerticalTimeMarker(ranges,currentTime);
	                    } else{
	                        var elementHtml = "<div class='" + CURRENT_TIME_MARKER_CLASS + "'></div>";
	                        var headerWrap = this.datesHeader.find("." + SCHEDULER_HEADER_WRAP_CLASS);
	                        var left = Math.round(ranges[0].innerRect(currentTime, new Date(currentTime.getTime() + 1), false).left);
	                        var timesTableMarker = $(elementHtml)
	                                .prependTo(headerWrap)
	                                .addClass(CURRENT_TIME_MARKER_ARROW_CLASS + "-down");

	                        timesTableMarker.css({
	                            left: this._adjustLeftPosition(left - (outerWidth(timesTableMarker) * BORDER_SIZE_COEFF / 2)),
	                            top: headerWrap.find("tr:last").prev().position().top
	                        });

	                        $(elementHtml).prependTo(this.content).css({
	                            left: this._adjustLeftPosition(left),
	                            width: "1px",
	                            height: this.content[0].scrollHeight - 1,
	                            top: 0
	                        });
	                    }
	                }
	            }
	        },

	        _adjustLeftPosition: function(left) {
	            return this._groupedView._adjustLeftPosition(left);
	        },

	        _currentTime: function(setUpdateTimer) {
	            var that = this;
	            var markerOptions = that.options.currentTimeMarker;

	            if (markerOptions !== false && markerOptions.updateInterval !== undefined) {
	                that._currentTimeMarkerUpdater();

	                if (setUpdateTimer) {
	                    that._currentTimeUpdateTimer = setInterval(proxy(this._currentTimeMarkerUpdater, that), markerOptions.updateInterval);
	                }
	            }
	        },

	        _editable: function() {
	            if (this.options.editable) {
	                if (this._isMobile()) {
	                    this._touchEditable();
	                } else {
	                    this._mouseEditable();
	                }
	            }
	        },

	        _mouseEditable: function() {
	            var that = this;
	            that.element.on("click" + NS, ".k-event a:has(.k-i-close)", function(e) {
	                that.trigger("remove", { uid: $(this).closest(".k-event").attr(kendo.attr("uid")) });
	                e.preventDefault();
	            });

	            if (that.options.editable.create !== false) {
	                that.element.on("dblclick" + NS, ".k-scheduler-content td", function(e) {
	                    var slot = that._slotByPosition(e.pageX, e.pageY);

	                    if (slot) {
	                        var resourceInfo = that._resourceBySlot(slot);
	                        that.trigger("add", { eventInfo: extend({ start: slot.startDate(), end: slot.endDate() }, resourceInfo) });
	                    }

	                    e.preventDefault();
	                });
	            }

	            if (that.options.editable.update !== false) {
	                that.element.on("dblclick" + NS, ".k-event", function(e) {
	                    that.trigger("edit", { uid: $(this).closest(".k-event").attr(kendo.attr("uid")) });
	                    e.preventDefault();
	                });
	            }
	        },

	        _touchEditable: function() {
	            var that = this;
	            var threshold = 0;

	            if (kendo.support.mobileOS.android) {
	                threshold = 5;
	            }

	            if (that.options.editable.create !== false) {
	                that._addUserEvents = new kendo.UserEvents(that.element, {
	                    threshold: threshold,
	                    useClickAsTap: !kendo.support.browser.edge,
	                    filter:  ".k-scheduler-content td",
	                    tap: function(e) {
	                        if (that._scrolling) {
	                            return;
	                        }
	                        var x = e.x.location !== undefined ? e.x.location : e.x;
	                        var y = e.y.location !== undefined ? e.y.location : e.y;
	                        var slot = that._slotByPosition(x, y);

	                        if (slot) {
	                            var resourceInfo = that._resourceBySlot(slot);
	                            that.trigger("add", { eventInfo: extend({ start: slot.startDate(), end: slot.endDate() }, resourceInfo) });
	                        }

	                        e.preventDefault();
	                    }
	                });
	            }

	            if (that.options.editable.update !== false) {
	                that._editUserEvents = new kendo.UserEvents(that.element, {
	                    threshold: threshold,
	                    useClickAsTap: !kendo.support.browser.edge,
	                    filter: ".k-event",
	                    tap: function(e) {
	                        if (that._scrolling) {
	                            return;
	                        }
	                        var eventElement = $(e.target).closest(".k-event");
	                        var touchElement = $(e.touch.initialTouch);

	                        if (touchElement.hasClass("k-i-close")) {
	                            that.trigger("remove", { uid: eventElement.attr(kendo.attr("uid")) });
	                        } else if (!eventElement.hasClass("k-event-active")) {
	                            that.trigger("edit", { uid: eventElement.attr(kendo.attr("uid")) });
	                        }

	                        e.preventDefault();
	                    }
	                });
	            }
	        },

	        _slotByPosition: function(x, y) {
	            var slot;
	            var content = this.content;
	            var offset = content.offset();
	            var groupIndex;

	            x -= offset.left;
	            y -= offset.top;

	            if (this._isRtl) {
	                var browser = kendo.support.browser;

	                if (browser.mozilla || (browser.webkit && browser.version >= 85)) {
	                     x += (content[0].scrollWidth - content[0].offsetWidth);
	                     x += content[0].scrollLeft;
	                } else if (browser.msie) {
	                     x -= kendo.scrollLeft(content);
	                     x += content[0].scrollWidth - content[0].offsetWidth;
	                } else if (browser.webkit) {
	                     x += content[0].scrollLeft;
	                }
	            } else {
	                x += content[0].scrollLeft;
	            }

	            y += content[0].scrollTop;

	            x = Math.ceil(x);
	            y = Math.ceil(y);

	            for (groupIndex = 0; groupIndex < this.groups.length; groupIndex++) {

	                 slot = this._groupedView._getTimeSlotByPosition(x, y, groupIndex);

	                 if (slot) {
	                     return slot;
	                 }
	            }

	            return null;
	        },

	        options: {
	            name: "TimelineView",
	            title: "Timeline",
	            selectedDateFormat: "{0:D}",
	            selectedShortDateFormat: "{0:d}",
	            selectedMobileDateFormat: "{0:MMM dd}",
	            date: kendo.date.today(),
	            startTime: kendo.date.today(),
	            endTime: kendo.date.today(),
	            showWorkHours: false,
	            minorTickCount: 2,
	            editable: true,
	            workDayStart: new Date(1980, 1, 1, 8, 0, 0),
	            workDayEnd: new Date(1980, 1, 1, 17, 0, 0),
	            workWeekStart: 1,
	            workWeekEnd: 5,
	            majorTick: 60,
	            eventHeight: 25,
	            eventMinWidth: 0,
	            columnWidth: 100,
	            groupHeaderTemplate: "#=text#",
	            majorTimeHeaderTemplate: "#=kendo.toString(date, 't')#",
	            slotTemplate: "&nbsp;",
	            eventTemplate: EVENT_TEMPLATE,
	            dateHeaderTemplate: DATA_HEADER_TEMPLATE,
	            footer: {
	                command: "workDay"
	            },
	            currentTimeMarker: {
	                updateInterval: 10000,
	                useLocalTimezone: true
	            },
	            messages: {
	                defaultRowText: "All events",
	                showFullDay: "Show full day",
	                showWorkDay: "Show business hours"
	            }
	        },

	        events: ["remove", "add", "edit"],

	        _templates: function() {
	            var options = this.options,
	                settings = extend({}, kendo.Template, options.templateSettings);

	            this.eventTemplate = this._eventTmpl(options.eventTemplate, EVENT_WRAPPER_STRING);
	            this.majorTimeHeaderTemplate = kendo.template(options.majorTimeHeaderTemplate, settings);
	            this.dateHeaderTemplate = kendo.template(options.dateHeaderTemplate, settings);
	            this.slotTemplate = kendo.template(options.slotTemplate, settings);
	            this.groupHeaderTemplate = kendo.template(options.groupHeaderTemplate, settings);
	        },

	        _render: function(dates) {
	            var that = this;

	            dates = dates || [];

	            that._dates = dates;

	            that._startDate = dates[0];

	            that._endDate = dates[(dates.length - 1) || 0];

	            that._calculateSlotRanges();

	            that.createLayout(that._layout(dates));

	            that._content(dates);

	            that._footer();

	            that._setContentWidth();

	            that.refreshLayout();

	            that.datesHeader.on("click" + NS, ".k-nav-day", function(e) {
	                var th = $(e.currentTarget).closest("th");

	                var slot = that._slotByPosition(th.offset().left, that.content.offset().top);

	                that.trigger("navigate", { view: "timeline", date: slot.startDate() });
	            });

	            that._groupedView._hideHeaders();
	        },

	        _setContentWidth: function() {
	            var content = this.content;
	            var contentWidth = content.width();
	            var contentTable = this.content.find("table");
	            var columnCount = contentTable.find("tr:first").children().length;

	            var minWidth = 100;
	            var calculatedWidth = columnCount * this.options.columnWidth;

	            if (contentWidth < calculatedWidth) {
	                minWidth = Math.ceil((calculatedWidth / contentWidth) * 100);
	            }

	            contentTable.add(this.datesHeader.find("table"))
	                .css("width", minWidth + "%");
	        },

	        _calculateSlotRanges: function () {
	            var dates = this._dates;
	            var slotStartTime = this.startTime();
	            var slotEndTime = this.endTime();

	            slotEndTime = getMilliseconds(slotEndTime);
	            slotStartTime = getMilliseconds(slotStartTime);

	            if (slotEndTime === slotStartTime) {
	                slotEndTime += MS_PER_DAY - 1;
	            } else if (slotEndTime < slotStartTime) {
	                slotEndTime += MS_PER_DAY;
	            }

	            var slotRanges = [];
	            for (var i = 0; i < dates.length; i++) {
	                var rangeStart = getDate(dates[i]);
	                setTime(rangeStart, slotStartTime);

	                var rangeEnd = getDate(dates[i]);
	                setTime(rangeEnd, slotEndTime);

	                slotRanges.push({
	                    start: kendo.date.toUtcTime(rangeStart),
	                    end: kendo.date.toUtcTime(rangeEnd)
	                });
	            }

	            this._slotRanges = slotRanges;
	        },

	        _forTimeRange: function(min, max, action, verticalByDate, groupsCount) {
	            min = toInvariantTime(min); //convert the date to 1/2/1980 and sets the time
	            max = toInvariantTime(max);

	            var that = this,
	                msMin = getMilliseconds(min),
	                msMax = getMilliseconds(max),
	                minorTickCount = that.options.minorTickCount,
	                msMajorInterval = that.options.majorTick * MS_PER_MINUTE,
	                msInterval = msMajorInterval / minorTickCount || 1,
	                start = new Date(+min),
	                idx = 0, length,
	                html = "";

	            length = MS_PER_DAY / msInterval;

	            if (msMin != msMax) {
	                if (msMin > msMax) {
	                    msMax += MS_PER_DAY;
	                }

	                length = ((msMax - msMin) / msInterval);
	            }

	            length = verticalByDate ? 1 : Math.round(length);

	            if (groupsCount) {
	                length = length * groupsCount;
	            }

	            for (; idx < length; idx++) {
	                var majorTickDivider = idx % (msMajorInterval/msInterval);
	                var isMajorTickColumn = majorTickDivider === 0;
	                var isMiddleColumn = majorTickDivider < minorTickCount - 1;
	                var isLastSlotColumn = majorTickDivider === minorTickCount - 1;
	                var minorTickColumns = minorTickCount;

	                if (length % minorTickCount !== 0) {
	                    var isLastMajorSlot = (length - (idx + 1)) < minorTickCount;
	                    if (isMajorTickColumn && isLastMajorSlot) {
	                        minorTickColumns = length % minorTickCount;
	                    }
	                }

	                html += action(start, isMajorTickColumn, isMiddleColumn, isLastSlotColumn, minorTickColumns, idx % groupsCount);

	                if (!verticalByDate) {
	                    if (groupsCount) {
	                        if ((idx % groupsCount) === groupsCount - 1) {
	                            setTime(start, msInterval, false);
	                        }
	                    } else {
	                        setTime(start, msInterval, false);
	                    }
	                }
	            }

	            return html;
	        },

	        _layout: function(dates) {
	            var timeColumns = [];
	            var columns = [];
	            var that = this;
	            var rows = [{ text: that.options.messages.defaultRowText }];
	            var groupedView = that._groupedView;

	            var minorTickSlots = [];
	            for (var minorTickIndex = 0; minorTickIndex < that.options.minorTickCount; minorTickIndex++) {
	                minorTickSlots.push({
	                    text: "&#8203;",
	                    className: "k-last",
	                    minorTicks: true
	                });
	            }

	            this._forTimeRange(that.startTime(), that.endTime(), function(date, majorTick, middleColumn, lastSlotColumn, minorSlotsCount) {
	                var template = that.majorTimeHeaderTemplate;

	                if (majorTick) {
	                    var timeColumn = {
	                        text: template({ date: date }),
	                        className: lastSlotColumn ? "k-slot-cell" : "",
	                        columns: minorTickSlots.slice(0, minorSlotsCount)
	                    };

	                    groupedView._setColspan(timeColumn);

	                    timeColumns.push(timeColumn);
	                }
	            });

	            for (var idx = 0; idx < dates.length; idx++) {
	                columns.push({
	                    text: that.dateHeaderTemplate({ date: dates[idx] }),
	                    className:  "k-slot-cell",
	                    columns: timeColumns.slice(0)
	                });
	            }

	            var resources = this.groupedResources;
	            if (resources.length) {
	                if (this._groupOrientation() === "vertical") {
	                    rows =  groupedView._createRowsLayout(resources, null, this.groupHeaderTemplate, columns);
	                    columns =  groupedView._createVerticalColumnsLayout(resources, null, this.groupHeaderTemplate, columns);

	                } else {
	                    columns =  groupedView._createColumnsLayout(resources, columns, this.groupHeaderTemplate, columns);
	                }
	            }

	            return {
	                columns: columns,
	                rows: rows
	            };
	        },

	        _footer: function() {
	            var options = this.options;

	            if (options.footer !== false) {
	                var html = '<div class="k-scheduler-footer k-toolbar">';

	                var command = options.footer.command;

	                if (this._isMobile()) {
	                    html += '<span class="k-state-default k-scheduler-today"><a href="#" class="k-link">';
	                    html += options.messages.today + '</a></span>';
	                }

	                if (command && command === "workDay") {
	                    if (this._isMobile()) {
	                        html += '<span class="k-state-default k-scheduler-fullday"><a href="#" class="k-link">';
	                        html += (options.showWorkHours ? options.messages.showFullDay : options.messages.showWorkDay) + '</a></span>';
	                    } else {
	                        html += '<button type="button" class="k-button k-scheduler-fullday">';
	                            html += '<span class="k-icon k-i-clock"></span>';
	                            html += '<span class="k-button-text">';
	                                html += (options.showWorkHours ? options.messages.showFullDay : options.messages.showWorkDay);
	                            html += '</span>';
	                        html += '</button>';
	                    }
	                }

	                html += "</div>";

	                this.footer = $(html).appendTo(this.element);

	                var that = this;

	                this.footer.on("click" + NS, ".k-scheduler-fullday", function(e) {
	                    e.preventDefault();
	                    that.trigger("navigate", { view: that.name || options.name, date: that.startDate(), isWorkDay: !options.showWorkHours });
	                });

	                this.footer.on("click" + NS, ".k-scheduler-today", function(e) {
	                    e.preventDefault();
	                    var timezone = that.options.timezone;
	                    var action = "today";
	                    var currentDate = new Date();
	                    var date;

	                    if(timezone){
	                        var timezoneOffset = kendo.timezone.offset(currentDate, timezone);
	                        date = kendo.timezone.convert(currentDate, currentDate.getTimezoneOffset(), timezoneOffset);
	                    }else{
	                        date = currentDate;
	                    }

	                    that.trigger("navigate", { view: that.name || options.name, action: action, date: date });
	                });
	            }
	        },

	        _columnCountForLevel: function(level) {
	            var columnLevel = this.columnLevels[level];
	            return columnLevel ? columnLevel.length : 0;
	        },

	        _rowCountForLevel: function(level) {
	            var rowLevel = this.rowLevels[level];
	            return rowLevel ? rowLevel.length : 0;
	        },

	        _isWorkDay: function(date) {
	            var day = date.getDay();
	            var workDays =  this._workDays;

	            for (var i = 0; i < workDays.length; i++) {
	                if (workDays[i] === day) {
	                    return true;
	                }
	            }
	            return false;
	        },

	        _content: function(dates) {
	            var that = this;
	            var start = that.startTime();
	            var end = this.endTime();
	            var groupsCount = 1;
	            var rowCount = 1;
	            var columnCount = dates.length;
	            var html = '';
	            var resources = this.groupedResources;
	            var slotTemplate = this.slotTemplate;
	            var isVerticalGrouped = false;

	            if (resources.length) {
	                isVerticalGrouped = that._groupOrientation() === "vertical";

	                if (isVerticalGrouped) {
	                    rowCount = that._groupedView._getRowCount(this.rowLevels.length - 1);
	                    groupsCount = that._groupedView._getGroupsCount();
	                } else {
	                    groupsCount = that._groupCount();
	                }
	            }

	            html += '<tbody>';
	            html += that._groupedView._addContent(dates, columnCount, groupsCount, rowCount, start, end, slotTemplate, isVerticalGrouped);
	            html += '</tbody>';

	            this.content.find("table").append(html);
	        },

	        _groups: function() {
	            var groupCount = this._groupCount();
	            var dates = this._dates;
	            var columnCount = dates.length;

	            this.groups = [];

	            for (var idx = 0; idx < groupCount; idx++) {
	                var view = this._addResourceView(idx);

	                var start = dates[0];
	                var end = dates[(dates.length - 1) || 0];

	                var startTime = getMilliseconds(this.startTime());
	                var endTime = getMilliseconds(this.endTime());

	                if (startTime !== 0 && endTime <= startTime) {
	                    start = getDate(start);
	                    setTime(start, startTime);

	                    end = getDate(end);
	                    setTime(end, endTime);
	                }

	                view.addTimeSlotCollection(start, kendo.date.addDays(end, 1));
	            }

	            this._timeSlotGroups(groupCount, columnCount);
	        },

	        _isHorizontallyGrouped: function() {
	            return this.groupedResources.length && this._groupOrientation() === "horizontal";
	        },

	        _timeSlotGroups: function (groupCount, datesCount) {
	            var interval = this._timeSlotInterval();
	            var isVerticallyGrouped = this._isVerticallyGrouped();
	            var tableRows = this.content.find("tr");

	            tableRows.attr("role", "row");

	            this._groupedView._addTimeSlotsCollections(groupCount, datesCount, tableRows, interval, isVerticallyGrouped);

	        },

	        _addTimeSlotToCollection: function(group, cells, cellIndex, cellOffset, dateIndex, time, interval){
	              var cell = cells[cellIndex+cellOffset];
	              var collection = group.getTimeSlotCollection(0);
	              var currentDate = this._dates[dateIndex];
	              var currentTime = Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
	              var start = currentTime + time;
	              var end = start + interval;
	              cell.setAttribute("role", "gridcell");
	              cell.setAttribute("aria-selected", false);

	              collection.addTimeSlot(cell, start, end, true);
	        },

	        startDate: function() {
	            return this._startDate;
	        },

	        endDate: function() {
	            return this._endDate;
	        },

	        visibleEndDate: function () {
	            var startTime = getMilliseconds(this.startTime());
	            var endTime = getMilliseconds(this.endTime());
	            var endDate = this.endDate();

	            if (startTime !== 0 && endTime <= startTime) {
	                endDate = kendo.date.addDays(endDate, 1);
	            }

	            return endDate;
	        },

	        startTime: function() {
	            var options = this.options;
	            return options.showWorkHours ? options.workDayStart : options.startTime;
	        },

	        endTime: function() {
	            var options = this.options;
	            return options.showWorkHours ? options.workDayEnd : options.endTime;
	        },

	        _timeSlotInterval: function() {
	            var options = this.options;
	            return (options.majorTick/options.minorTickCount) * MS_PER_MINUTE;
	        },

	        nextDate: function () {
	            return kendo.date.nextDay(this.endDate());
	        },

	        previousDate: function () {
	            return kendo.date.previousDay(this.startDate());
	        },

	        calculateDateRange: function() {
	            this._render([this.options.date]);
	        },

	        render: function(events) {
	            this._headerColumnCount = 0;

	            this._groups();

	            this.element.find(".k-event").remove();

	            events = new kendo.data.Query(events)
	                .sort([{ field: "start", dir: "asc" },{ field: "end", dir: "desc" }])
	                .toArray();

	            var eventsByResource = [];

	            this._eventsByResource(events, this.groupedResources, eventsByResource);

	            var eventGroups = [];
	            var maxRowCount = 0;

	            for (var groupIndex = 0; groupIndex < eventsByResource.length; groupIndex++) {
	                var eventGroup = {
	                    groupIndex: groupIndex,
	                    maxRowCount: 0,
	                    events: {}
	                };

	                eventGroups.push(eventGroup);

	                this._renderEvents(eventsByResource[groupIndex], groupIndex, eventGroup);

	                if (maxRowCount < eventGroup.maxRowCount) {
	                    maxRowCount = eventGroup.maxRowCount;
	                }
	            }

	            this._setRowsHeight(eventGroups, eventsByResource.length, maxRowCount);

	            this._positionEvents(eventGroups, eventsByResource.length);

	            this._currentTime(false);

	            this.trigger("activate");
	        },

	        _positionEvents: function(eventGroups, groupsCount) {
	            for (var groupIndex = 0; groupIndex < groupsCount; groupIndex++) {
	                var eventsForGroup = eventGroups[groupIndex].events;
	                for (var eventUid in eventsForGroup) {
	                    var eventObject = eventsForGroup[eventUid];
	                    if($.isArray(eventObject)){
	                        for(var eventIndex = 0; eventIndex<eventObject.length; eventIndex++){
	                            this._positionEvent(eventObject[eventIndex]);
	                        }
	                    } else{
	                        this._positionEvent(eventObject);
	                    }
	                }
	            }
	        },

	        _setRowsHeight: function(eventGroups, groupsCount, maxRowCount) {
	            var eventHeight = this.options.eventHeight;
	            var eventBottomOffset = this._getBottomRowOffset();
	            var groupedView = this._groupedView;
	            var verticalGroupCount = groupedView._getVerticalGroupCount(groupsCount);

	            groupsCount = this._isVerticallyGrouped() ? verticalGroupCount : 1;

	            for (var groupIndex = 0; groupIndex < groupsCount; groupIndex++) {
	                var rowsCount = groupedView._getVerticalRowCount(eventGroups, groupIndex, maxRowCount);

	                rowsCount = rowsCount ? rowsCount : 1;

	                var rowHeight = ((eventHeight + 2) * rowsCount) + eventBottomOffset;
	                var timesRow = $(this.times.find("tr")[groupIndex]);
	                var row = $(this.content.find("tr")[groupIndex]);

	                timesRow.height(rowHeight);
	                row.height(rowHeight);
	            }

	            this._setContentWidth();
	            this.refreshLayout();
	            this._refreshSlots();
	        },

	        _getBottomRowOffset: function() {
	            var eventBottomOffset = this.options.eventHeight * 0.50;
	            var isMobile = this._isMobile();
	            var minOffset;
	            var maxOffset;

	            if (isMobile) {
	                minOffset = 30;
	                maxOffset = 60;
	            } else {
	                minOffset = 15;
	                maxOffset = 30;
	            }

	            if (eventBottomOffset > maxOffset) {
	                eventBottomOffset = maxOffset;
	            } else if (eventBottomOffset < minOffset) {
	                eventBottomOffset = minOffset;
	            }

	            return eventBottomOffset;
	        },

	        _positionEvent: function(eventObject) {
	            var eventHeight = this.options.eventHeight + 2;

	            var rect = eventObject.slotRange.innerRect(eventObject.start, eventObject.end, false);

	            var left = this._adjustLeftPosition(rect.left);

	            var width = rect.right - rect.left;

	            if (width < 0) {
	                width = 0;
	            }

	            if (width < this.options.eventMinWidth) {
	                var slotsCollection = eventObject.slotRange.collection;
	                var lastSlot = slotsCollection._slots[slotsCollection._slots.length-1];
	                var offsetRight = lastSlot.offsetLeft + lastSlot.offsetWidth;

	                width = this.options.eventMinWidth;

	                if (offsetRight < left + width) {
	                    width = offsetRight - rect.left;
	                }
	            }

	            eventObject.element.css({
	                top:  eventObject.slotRange.start.offsetTop + eventObject.rowIndex * (eventHeight + 2) + "px",
	                left: left,
	                width: width
	            });
	        },

	        _refreshSlots: function() {
	            for (var groupIndex = 0; groupIndex < this.groups.length; groupIndex++) {
	                this.groups[groupIndex].refresh();
	            }
	        },

	        _eventsByResource: function(events, resources, result) {
	            var resource = resources[0];

	            if (resource) {
	                var view = resource.dataSource.view();

	                for (var itemIdx = 0; itemIdx < view.length; itemIdx++) {
	                    var value = this._resourceValue(resource, view[itemIdx]);

	                    var eventsFilteredByResource = new kendo.data.Query(events).filter({ field: resource.field, operator: SchedulerView.groupEqFilter(value) }).toArray();

	                    if (resources.length > 1) {
	                        this._eventsByResource(eventsFilteredByResource, resources.slice(1), result);
	                    } else {
	                        result.push(eventsFilteredByResource);
	                    }
	                }
	            } else {
	                result.push(events);
	            }
	        },

	        _isInDateSlot: function(event) {
	            var startTime = event.start;
	            var endTime = event.end;
	            var rangeStart = getDate(this._startDate);
	            var rangeEnd = kendo.date.addDays(getDate(this.visibleEndDate()), 1);

	            if (startTime < rangeEnd && rangeStart <= endTime) {
	                return true;
	            }
	            return false;
	        },

	        _isInTimeSlot: function(event) {
	            var startTime = event._startTime || kendo.date.toUtcTime(event.start);
	            var endTime = event._endTime || kendo.date.toUtcTime(event.end);

	            var slotRanges = this._slotRanges;

	            if (startTime === endTime) {
	                endTime = endTime+1;
	            }

	            for (var slotIndex = 0; slotIndex < slotRanges.length; slotIndex++) {
	                if (startTime < slotRanges[slotIndex].end && slotRanges[slotIndex].start < endTime) {
	                    return true;
	                }
	            }
	            return false;
	        },

	        _adjustEvent: function(event) {
	            var start = event.start;
	            var end = event.end;
	            var eventStartTime = event._time("start");
	            var eventEndTime = event._time("end");
	            var startTime = getMilliseconds(this.startTime());
	            var endTime = getMilliseconds(this.endTime());
	            var adjustedStartDate = null;
	            var adjustedEndDate = null;
	            var occurrence;
	            var head = false;
	            var tail = false;

	            if (event.isAllDay) {
	                start = getDate(start);
	                eventStartTime = 0;

	                end = getDate(end);
	                eventEndTime = MS_PER_DAY;
	                adjustedEndDate = kendo.date.addDays(end, 1);
	            }

	            if (endTime === 0) {
	                endTime = MS_PER_DAY;
	            }

	            if (endTime <= startTime) {
	                if (eventStartTime < startTime && eventStartTime >= endTime) {
	                    adjustedStartDate = getDate(start);
	                    setTime(adjustedStartDate, startTime);
	                    tail = true;
	                }

	                if (eventEndTime > endTime && eventEndTime <= startTime) {
	                    adjustedEndDate = getDate(end);
	                    setTime(adjustedEndDate, endTime);
	                    head = true;
	                }
	            } else {
	                if (startTime > eventStartTime) {
	                    adjustedStartDate = getDate(start);
	                    setTime(adjustedStartDate, startTime);
	                    tail = true;
	                } else if (endTime <= eventStartTime) {
	                    adjustedStartDate = getDate(start);
	                    adjustedStartDate = kendo.date.addDays(adjustedStartDate, 1);
	                    setTime(adjustedStartDate, startTime);
	                    tail = true;
	                }

	                if (endTime < eventEndTime) {
	                    adjustedEndDate = getDate(end);
	                    setTime(adjustedEndDate, endTime);
	                    head = true;
	                } else if (startTime > eventEndTime) {
	                    adjustedEndDate = getDate(end);
	                    adjustedEndDate = kendo.date.addDays(adjustedEndDate,-1);
	                    setTime(adjustedEndDate, endTime);
	                    head = true;
	                }
	            }

	            occurrence = event.clone({
	                start: adjustedStartDate ? adjustedStartDate : start,
	                end: adjustedEndDate ? adjustedEndDate : end,
	                _startTime: adjustedStartDate ? kendo.date.toUtcTime(adjustedStartDate) : event._startTime,
	                _endTime:  adjustedEndDate ? kendo.date.toUtcTime(adjustedEndDate) : event._endTime,
	                isAllDay: false
	            });

	            return {
	                occurrence: occurrence,
	                head: head,
	                tail: tail
	            };
	        },

	        _renderEvents: function(events, groupIndex, eventGroup) {
	            var event;
	            var idx;
	            var length;

	            for (idx = 0, length = events.length; idx < length; idx++) {
	                event = events[idx];

	                if (this._isInDateSlot(event)) {
	                    var isMultiDayEvent = event.isAllDay || event.duration() >= MS_PER_DAY;
	                    var container = this.content;

	                    if (isMultiDayEvent || this._isInTimeSlot(event)) {
	                        var adjustedEvent = this._adjustEvent(event);
	                        var group = this.groups[groupIndex];

	                        if (!group._continuousEvents) {
	                            group._continuousEvents = [];
	                        }

	                        if (this._isInTimeSlot(adjustedEvent.occurrence)) {
	                            var ranges = group.slotRanges(adjustedEvent.occurrence, false);
	                            var range = ranges[0];
	                            var startIndex = range.start.index;
	                            var endIndex = range.end.index;

	                            this._groupedView._renderEvent(eventGroup, event, adjustedEvent, group, range, container, startIndex, endIndex);
	                        }
	                    }
	                }
	            }
	        },

	        addContinuousEvent: function(group, range, element, isAllDay) {
	            var events = group._continuousEvents;

	            events.push({
	                element: element,
	                isAllDay: isAllDay,
	                uid: element.attr(kendo.attr("uid")),
	                start: range.start,
	                end: range.end
	            });
	        },

	        _createEventElement: function(occurrence, event, head, tail) {
	            var template = this.eventTemplate;
	            var editable = this.options.editable;
	            var isMobile = this._isMobile();
	            var showDelete = editable && editable.destroy !== false && !isMobile;
	            var resizable = editable && editable.resize !== false;
	            var eventStartTime = event._time("start");
	            var eventEndTime = event._time("end");
	            var eventStartDate = event.start;
	            var eventEndDate = event.end;

	            var resources = this.eventResources(event);

	            if (event._startTime && eventStartTime !== kendo.date.getMilliseconds(event.start)) {
	                eventStartDate = new Date(eventStartTime);
	                eventStartDate = kendo.timezone.apply(eventStartDate, "Etc/UTC");
	            }

	            if (event._endTime && eventEndTime !== kendo.date.getMilliseconds(event.end)) {
	                eventEndDate = new Date(eventEndTime);
	                eventEndDate = kendo.timezone.apply(eventEndDate, "Etc/UTC");
	            }

	            var data = extend({}, {
	                ns: kendo.ns,
	                resizable: resizable,
	                showDelete: showDelete,
	                head: head,
	                tail: tail,
	                singleDay: this._dates.length == 1,
	                resources: resources,
	                inverseColor: false,
	                messages: this.options.messages
	            }, event, {
	                start: eventStartDate,
	                end: eventEndDate
	            });

	            var element = $(template(data));

	            this.angular("compile", function(){
	                return {
	                    elements: element,
	                    data: [ { dataItem: data } ]
	                };
	            });

	            return element;
	        },

	        _arrangeRows: function (eventObject, slotRange, eventGroup) {
	            var startIndex = slotRange.start.index;
	            var endIndex = slotRange.end.index;

	            var rect = eventObject.slotRange.innerRect(eventObject.start, eventObject.end, false);
	            var rectRight = rect.right + this.options.eventMinWidth;

	            var events = collidingEvents(slotRange.events(), rect.left, rectRight);

	            slotRange.addEvent({
	                slotIndex: startIndex,
	                start: startIndex,
	                end: endIndex,
	                rectLeft: rect.left,
	                rectRight: rectRight,
	                element: eventObject.element,
	                uid: eventObject.uid
	            });

	            events.push({
	                start: startIndex,
	                end: endIndex,
	                uid: eventObject.uid
	            });

	            var rows = SchedulerView.createRows(events);

	            if (eventGroup.maxRowCount < rows.length) {
	                eventGroup.maxRowCount = rows.length;
	            }

	            for (var idx = 0, length = rows.length; idx < length; idx++) {
	                var rowEvents = rows[idx].events;
	                for (var j = 0, eventLength = rowEvents.length; j < eventLength; j++) {
	                    eventGroup.events[rowEvents[j].uid].rowIndex = idx;
	                }
	            }
	        },

	        _groupCount: function() {
	            var resources = this.groupedResources;
	            var groupedView = this._groupedView;

	            if (resources.length) {
	                if (this._groupOrientation() === "vertical") {
	                    return groupedView._verticalCountForLevel(resources.length - 1);
	                } else {
	                    return groupedView._horizontalCountForLevel(resources.length - 1, this.columnLevels.length - 1);
	                }
	            }
	            return 1;
	        },

	        _updateEventForSelection: function(event) {
	            var adjustedEvent = this._adjustEvent(event.clone());
	            return adjustedEvent.occurrence;
	        },

	        _eventOptionsForMove: function(event) {
	            if((event.end.getTime() - event.start.getTime()) / 1000 >= 24 * 60 * 60) {
	                return { isAllDay: true };
	            } else {
	                return { isAllDay: false };
	            }
	        },

	        _updateEventForResize: function(event) {
	            if (event.isAllDay) {
	                event.set("isAllDay", false);
	            }
	        },

	        _updateMoveHint: function(event, groupIndex, distance) {
	            var group = this.groups[groupIndex];

	            var clonedEvent = event.clone({ start: event.start, end: event.end});

	            var eventDuraton =  clonedEvent.duration();
	            clonedEvent.start = new Date(clonedEvent.start.getTime() + distance);
	            clonedEvent.end = new Date(+clonedEvent.start + eventDuraton);

	            this._removeMoveHint(event.uid);

	            if (this._isInDateSlot(clonedEvent)) {
	                if (clonedEvent.isAllDay || clonedEvent.duration() >= MS_PER_DAY || this._isInTimeSlot(clonedEvent)) {
	                    var adjustedEvent = this._adjustEvent(clonedEvent);
	                    var ranges = group.slotRanges(adjustedEvent.occurrence, false);

	                    for (var rangeIndex = 0; rangeIndex < ranges.length; rangeIndex++) {
	                        this._groupedView._createMoveHint(ranges[rangeIndex], adjustedEvent);
	                    }
	                }
	            }
	        },

	       _appendMoveHint: function(hint) {
	            hint.appendTo(this.content);

	            this._moveHint = this._moveHint.add(hint);
	       },

	        _updateResizeHint: function(event, groupIndex, startTime, endTime) {
	            var group = this.groups[groupIndex];
	            var ranges = group.ranges(startTime, endTime, false, false);

	            this._removeResizeHint();

	            for (var rangeIndex = 0; rangeIndex < ranges.length; rangeIndex++) {
	                var range = ranges[rangeIndex];
	                var start = range.startSlot();

	                var startRect = range.innerRect(startTime, endTime, false);
	                startRect.top = start.offsetTop;

	                var width = startRect.right - startRect.left;

	                if (width < 0) {
	                    for (var i = 0; i < range.events().length; i++) {
	                        if (range.events()[i].uid === event.uid) {
	                            width = range.events()[i].rectRight - startRect.left;
	                            break;
	                        }
	                    }
	                }

	                var height = range.endSlot().offsetTop + start.offsetHeight - startRect.top;

	                var left = this._adjustLeftPosition(startRect.left);

	                var hint = SchedulerView.fn._createResizeHint.call(this,
	                    left,
	                    startRect.top,
	                    width,
	                    height
	                );

	                this._resizeHint = this._resizeHint.add(hint);
	            }

	            var format = "t";
	            var container = this.content;

	            this._resizeHint.appendTo(container);

	            this._resizeHint.find(".k-label-top,.k-label-bottom").text("");

	            this._resizeHint.first().addClass("k-first").find(".k-label-top").text(kendo.toString(kendo.timezone.toLocalDate(startTime), format));

	            this._resizeHint.last().addClass("k-last").find(".k-label-bottom").text(kendo.toString(kendo.timezone.toLocalDate(endTime), format));
	        },

	        selectionByElement: function(cell) {
	            var offset = cell.offset();
	            return this._slotByPosition(offset.left, offset.top);
	        },

	        _updateDirection: function(selection, ranges, multiple, reverse, vertical) {

	            var startSlot = ranges[0].start;
	            var endSlot = ranges[ranges.length - 1].end;
	            if (multiple && !vertical) {
	                if (startSlot.index === endSlot.index &&
	                    startSlot.collectionIndex === endSlot.collectionIndex) {
	                    selection.backward = reverse;
	                }
	            }
	        },

	        _changeGroup: function(selection, previous) {
	            var method = previous ? "prevGroupSlot" : "nextGroupSlot";

	            var slot = this[method](selection.start, selection.groupIndex, false);

	            if (slot) {
	                selection.groupIndex += previous ? -1 : 1;
	            }

	            this._groupedView._changeGroup(selection, previous, slot);
	            return slot;
	        },

	        prevGroupSlot: function(date, groupIndex, isDay) {
	            var group = this.groups[groupIndex];
	            var slot = group.ranges(date, date, isDay, false)[0].start;

	            if (groupIndex <= 0) {
	                return;
	            }

	            return this._groupedView._prevGroupSlot(slot, group, isDay);
	        },

	        nextGroupSlot: function(date, groupIndex, isDay) {
	            var group = this.groups[groupIndex];
	            var slot = group.ranges(date, date, isDay, false)[0].start;

	            if (groupIndex >= this.groups.length - 1) {
	                return;
	            }

	            return this._groupedView._nextGroupSlot(slot, group, isDay);
	        },

	        _verticalSlots: function (selection, ranges, multiple, reverse) {
	            var groupedView = this._groupedView;
	            var method = groupedView._verticalMethod(reverse, multiple);
	            var startSlot = ranges[0].start;
	            var endSlot = ranges[ranges.length - 1].end;
	            var group = this.groups[selection.groupIndex];
	            var slot = groupedView._normalizeVerticalSelection(selection, ranges, reverse, multiple);

	            if (slot) {
	                startSlot = endSlot = slot;
	            }

	            startSlot = group[method](startSlot);
	            endSlot = group[method](endSlot);

	            if (!multiple && this._isVerticallyGrouped() && (!startSlot || !endSlot)) {
	                startSlot = endSlot = groupedView._verticalSlots(selection, reverse, slot);
	            }

	            return {
	                startSlot: startSlot,
	                endSlot: endSlot
	            };
	        },

	        _horizontalSlots: function (selection, ranges, multiple, reverse) {
	            var method = reverse ? "upSlot" : "downSlot";
	            var startSlot = ranges[0].start;
	            var endSlot = ranges[ranges.length - 1].end;
	            var group = this.groups[selection.groupIndex];
	            var result = {};

	            if (!multiple) {
	                result = this._groupedView._horizontalSlots(selection, group, method, startSlot, endSlot, multiple, reverse);
	            } else {
	                result.startSlot = group[method](startSlot);
	                result.endSlot = group[method](endSlot);

	                if (!multiple && this._isHorizontallyGrouped() && (!startSlot || !endSlot)) {
	                    result.startSlot = result.endSlot = this._changeGroup(selection, reverse);
	                }
	            }

	            return result;
	        },

	        _changeViewPeriod: function(selection, reverse) {
	            var date = reverse ? this.previousDate() : this.nextDate();
	            var start = selection.start;
	            var end = selection.end;
	            var newStart, newEnd;

	            newStart = new Date(date);
	            newEnd = new Date(date);

	            if(this._isInRange(newStart, newEnd)){
	                return false;
	            }
	            selection.start = newStart;
	            selection.end = newEnd;

	            if (this._isHorizontallyGrouped()) {
	               selection.groupIndex = reverse ? this.groups.length - 1 : 0;
	            }

	            var duration = end - start;

	            if (reverse) {
	                end = getMilliseconds(this.endTime());
	                end = end === 0 ? MS_PER_DAY : end;

	                setTime(selection.start, end-duration);
	                setTime(selection.end,  end);
	            } else {
	                start = getMilliseconds(this.startTime());

	                setTime(selection.start, start);
	                setTime(selection.end, start + duration);
	            }

	            selection.events = [];

	            return true;
	        },

	        move: function(selection, key, shift) {
	            var handled = false;
	            var group = this.groups[selection.groupIndex];
	            var keys = kendo.keys;
	            var groupedView = this._groupedView;
	            var ranges = group.ranges(selection.start, selection.end, false, false);
	            var startSlot, endSlot, reverse, slots;

	            if (key === keys.DOWN || key === keys.UP) {
	                handled = true;
	                reverse = key === keys.UP;

	                groupedView._updateDirection(selection, ranges, shift, reverse);

	                slots = this._verticalSlots(selection, ranges, shift, reverse);

	                if(groupedView._changeVerticalViewPeriod(slots, shift, selection, reverse)){
	                    return handled;
	                }
	            } else if (key === keys.LEFT || key === keys.RIGHT) {
	                handled = true;
	                reverse = key === keys.LEFT;

	                this._updateDirection(selection, ranges, shift, reverse, false);

	                slots = this._horizontalSlots(selection, ranges, shift, reverse);

	                if(groupedView._changeHorizontalViewPeriod(slots, shift, selection, reverse)){
	                     return handled;
	                }
	            }

	           if (handled) {
	               startSlot = slots.startSlot;
	               endSlot = slots.endSlot;

	               if (shift) {
	                   var backward = selection.backward;

	                   if (backward && startSlot) {
	                       selection.start = startSlot.startDate();
	                   } else if (!backward && endSlot) {
	                       selection.end = endSlot.endDate();
	                   }
	               } else if (startSlot && endSlot) {
	                   selection.start = startSlot.startDate();
	                   selection.end = endSlot.endDate();
	               }

	               selection.events = [];
	           }

	            return handled;
	        },

	        destroy: function() {
	            var that = this;

	            if (that.element) {
	                that.element.off(NS);
	            }

	            if (that.footer) {
	                that.footer.remove();
	            }

	            if (that._currentTimeUpdateTimer) {
	                clearInterval(that._currentTimeUpdateTimer);
	            }

	            SchedulerView.fn.destroy.call(this);

	            if (this._isMobile() && that.options.editable) {
	                if (that.options.editable.create !== false) {
	                    that._addUserEvents.destroy();
	                }

	                if (that.options.editable.update !== false) {
	                    that._editUserEvents.destroy();
	                }
	            }
	        }
	    });

	    extend(true, ui, {
	        TimelineView: TimelineView,
	        TimelineWeekView: TimelineView.extend({
	            options: {
	                name: "TimelineWeekView",
	                title: "Timeline Week",
	                selectedDateFormat: "{0:D} - {1:D}",
	                selectedShortDateFormat: "{0:d} - {1:d}",
	                selectedMobileDateFormat: "{0:MMM dd} - {1:dd}",
	                majorTick: 120
	            },
	            name: "timelineWeek",
	            calculateDateRange: function() {
	                var selectedDate = this.options.date,
	                    start = kendo.date.dayOfWeek(selectedDate, this.calendarInfo().firstDay, -1),
	                    idx, length,
	                    dates = [];

	                for (idx = 0, length = 7; idx < length; idx++) {
	                    dates.push(start);
	                    start = kendo.date.nextDay(start);
	                }
	                this._render(dates);
	            }
	        }),
	        TimelineWorkWeekView: TimelineView.extend({
	            options: {
	                name: "TimelineWorkWeekView",
	                title: "Timeline Work Week",
	                selectedDateFormat: "{0:D} - {1:D}",
	                selectedShortDateFormat: "{0:d} - {1:d}",
	                selectedMobileDateFormat: "{0:MMM dd} - {1:dd}",
	                majorTick: 120
	            },
	            name: "timelineWorkWeek",
	            nextDate: function() {
	                var weekStart = kendo.date.dayOfWeek(kendo.date.nextDay(this.endDate()), this.calendarInfo().firstDay, 1);

	                return kendo.date.addDays(weekStart, this._workDays[0]);
	            },
	            previousDate: function() {
	                var weekStart = kendo.date.dayOfWeek(this.startDate(), this.calendarInfo().firstDay, -1);
	                var workDays = this._workDays;

	                return kendo.date.addDays(weekStart, workDays[workDays.length - 1] - 7);
	            },
	            calculateDateRange: function() {
	                var options = this.options,
	                    selectedDate = options.date,
	                    dayOfWeek = kendo.date.dayOfWeek,
	                    weekStart = dayOfWeek(selectedDate, this.calendarInfo().firstDay, -1),
	                    start = dayOfWeek(weekStart, options.workWeekStart, 1),
	                    end = dayOfWeek(start, options.workWeekEnd, 1),
	                    dates = [],
	                    workDays =(options.workDays && options.workDays.length) ? options.workDays.map(function(day){
	                        return dayOfWeek(weekStart, day, 1).getTime();
	                    }) : null;

	                if(workDays) {
	                    start = weekStart;
	                    end = dayOfWeek(start, this.calendarInfo().firstDay + 6, 1);
	                }

	                while (start <= end) {
	                    if(workDays && workDays.indexOf(start.getTime()) > -1) {
	                        dates.push(start);
	                    } else if(!workDays) {
	                        dates.push(start);
	                    }

	                    start = kendo.date.nextDay(start);
	                }

	                this._render(dates);
	            }
	        }),
	        TimelineMonthView: TimelineView.extend({
	            options: {
	                name: "TimelineMonthView",
	                title: "Timeline Month",
	                selectedDateFormat: "{0:D} - {1:D}",
	                selectedShortDateFormat: "{0:d} - {1:d}",
	                workDayStart: new Date(1980, 1, 1, 0, 0, 0),
	                workDayEnd: new Date(1980, 1, 1, 23, 59, 59),
	                footer: false,
	                majorTick: 1440,
	                minorTickCount: 1
	            },
	            name: "timelineMonth",
	            calculateDateRange: function() {
	                var selectedDate = this.options.date,
	                    start = kendo.date.firstDayOfMonth(selectedDate),
	                    end = kendo.date.lastDayOfMonth(selectedDate),
	                    idx, length,
	                    dates = [];

	                for (idx = 0, length = end.getDate(); idx < length; idx++) {
	                    dates.push(start);
	                    start = kendo.date.nextDay(start);
	                }
	                this._render(dates);
	            }
	        })
	    });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "B+Kv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        field: {
            type: String,
            default: undefined
        },
        title: {
            type: String,
            default: undefined
        },
        template: {
            type: [String, Function],
            default: undefined
        },
        headerTemplate: {
            type: [String, Function],
            default: undefined
        },
        width: {
            type: [String, Number],
            default: undefined
        }
    }
};

/***/ }),

/***/ "B21I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = __webpack_require__("pQ38");
var rowNode_1 = __webpack_require__("bP2e");
var utils_1 = __webpack_require__("IRr6");
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var events_1 = __webpack_require__("3ok8");
var eventService_1 = __webpack_require__("k5uU");
var gridApi_1 = __webpack_require__("BAow");
var columnApi_1 = __webpack_require__("E/Wy");
var CheckboxSelectionComponent = (function (_super) {
    __extends(CheckboxSelectionComponent, _super);
    function CheckboxSelectionComponent() {
        return _super.call(this, "<span class=\"ag-selection-checkbox\"/>") || this;
    }
    CheckboxSelectionComponent.prototype.createAndAddIcons = function () {
        this.eCheckedIcon = utils_1.Utils.createIconNoSpan('checkboxChecked', this.gridOptionsWrapper, this.column);
        this.eUncheckedIcon = utils_1.Utils.createIconNoSpan('checkboxUnchecked', this.gridOptionsWrapper, this.column);
        this.eIndeterminateIcon = utils_1.Utils.createIconNoSpan('checkboxIndeterminate', this.gridOptionsWrapper, this.column);
        var element = this.getGui();
        element.appendChild(this.eCheckedIcon);
        element.appendChild(this.eUncheckedIcon);
        element.appendChild(this.eIndeterminateIcon);
    };
    CheckboxSelectionComponent.prototype.onDataChanged = function () {
        // when rows are loaded for the second time, this can impact the selection, as a row
        // could be loaded as already selected (if user scrolls down, and then up again).
        this.onSelectionChanged();
    };
    CheckboxSelectionComponent.prototype.onSelectionChanged = function () {
        var state = this.rowNode.isSelected();
        utils_1.Utils.setVisible(this.eCheckedIcon, state === true);
        utils_1.Utils.setVisible(this.eUncheckedIcon, state === false);
        utils_1.Utils.setVisible(this.eIndeterminateIcon, typeof state !== 'boolean');
    };
    CheckboxSelectionComponent.prototype.onCheckedClicked = function () {
        var groupSelectsFiltered = this.gridOptionsWrapper.isGroupSelectsFiltered();
        var updatedCount = this.rowNode.setSelectedParams({ newValue: false, groupSelectsFiltered: groupSelectsFiltered });
        return updatedCount;
    };
    CheckboxSelectionComponent.prototype.onUncheckedClicked = function (event) {
        var groupSelectsFiltered = this.gridOptionsWrapper.isGroupSelectsFiltered();
        var updatedCount = this.rowNode.setSelectedParams({ newValue: true, rangeSelect: event.shiftKey, groupSelectsFiltered: groupSelectsFiltered });
        return updatedCount;
    };
    CheckboxSelectionComponent.prototype.onIndeterminateClicked = function (event) {
        var result = this.onUncheckedClicked(event);
        if (result === 0) {
            this.onCheckedClicked();
        }
    };
    CheckboxSelectionComponent.prototype.init = function (params) {
        this.rowNode = params.rowNode;
        this.column = params.column;
        this.createAndAddIcons();
        this.onSelectionChanged();
        // we don't want the row clicked event to fire when selecting the checkbox, otherwise the row
        // would possibly get selected twice
        this.addGuiEventListener('click', function (event) { return utils_1.Utils.stopPropagationForAgGrid(event); });
        // likewise we don't want double click on this icon to open a group
        this.addGuiEventListener('dblclick', function (event) { return utils_1.Utils.stopPropagationForAgGrid(event); });
        this.addDestroyableEventListener(this.eCheckedIcon, 'click', this.onCheckedClicked.bind(this));
        this.addDestroyableEventListener(this.eUncheckedIcon, 'click', this.onUncheckedClicked.bind(this));
        this.addDestroyableEventListener(this.eIndeterminateIcon, 'click', this.onIndeterminateClicked.bind(this));
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_ROW_SELECTED, this.onSelectionChanged.bind(this));
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_DATA_CHANGED, this.onDataChanged.bind(this));
        if (typeof this.column.getColDef().checkboxSelection === 'function') {
            this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.showOrHideSelect.bind(this));
            this.showOrHideSelect();
        }
    };
    CheckboxSelectionComponent.prototype.showOrHideSelect = function () {
        var visible = this.column.isCellCheckboxSelection(this.rowNode);
        this.setVisible(visible);
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], CheckboxSelectionComponent.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], CheckboxSelectionComponent.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], CheckboxSelectionComponent.prototype, "gridApi", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], CheckboxSelectionComponent.prototype, "columnApi", void 0);
    return CheckboxSelectionComponent;
}(component_1.Component));
exports.CheckboxSelectionComponent = CheckboxSelectionComponent;


/***/ }),

/***/ "BAow":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var csvCreator_1 = __webpack_require__("SdeK");
var rowRenderer_1 = __webpack_require__("3RUv");
var headerRenderer_1 = __webpack_require__("U9s4");
var filterManager_1 = __webpack_require__("Up6z");
var columnController_1 = __webpack_require__("77lH");
var selectionController_1 = __webpack_require__("D4cr");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var gridPanel_1 = __webpack_require__("inOk");
var valueService_1 = __webpack_require__("5JVC");
var eventService_1 = __webpack_require__("k5uU");
var constants_1 = __webpack_require__("ZZFX");
var context_1 = __webpack_require__("RQ1/");
var gridCore_1 = __webpack_require__("b9np");
var sortController_1 = __webpack_require__("fxGZ");
var focusedCellController_1 = __webpack_require__("4Sr9");
var gridCell_1 = __webpack_require__("hie4");
var utils_1 = __webpack_require__("IRr6");
var cellRendererFactory_1 = __webpack_require__("9WGm");
var cellEditorFactory_1 = __webpack_require__("x4W5");
var paginationProxy_1 = __webpack_require__("wYvi");
var immutableService_1 = __webpack_require__("OrSY");
var valueCache_1 = __webpack_require__("uKqK");
var alignedGridsService_1 = __webpack_require__("sHqg");
var pinnedRowModel_1 = __webpack_require__("xRx6");
var GridApi = (function () {
    function GridApi() {
        this.detailGridInfoMap = {};
        /*
        Taking these out, as we want to reconsider how we register components
        
        public addCellRenderer(key: string, cellRenderer: {new(): ICellRenderer} | ICellRendererFunc): void {
            this.cellRendererFactory.addCellRenderer(key, cellRenderer);
        }
        
        public addCellEditor(key: string, cellEditor: {new(): ICellEditor}): void {
            this.cellEditorFactory.addCellEditor(key, cellEditor);
        }*/
    }
    GridApi.prototype.init = function () {
        switch (this.rowModel.getType()) {
            case constants_1.Constants.ROW_MODEL_TYPE_IN_MEMORY:
                this.inMemoryRowModel = this.rowModel;
                break;
            case constants_1.Constants.ROW_MODEL_TYPE_INFINITE:
                this.infinitePageRowModel = this.rowModel;
                break;
            case constants_1.Constants.ROW_MODEL_TYPE_ENTERPRISE:
                this.enterpriseRowModel = this.rowModel;
                break;
        }
    };
    /** Used internally by grid. Not intended to be used by the client. Interface may change between releases. */
    GridApi.prototype.__getAlignedGridService = function () {
        return this.alignedGridsService;
    };
    GridApi.prototype.addDetailGridInfo = function (id, gridInfo) {
        this.detailGridInfoMap[id] = gridInfo;
    };
    GridApi.prototype.removeDetailGridInfo = function (id) {
        this.detailGridInfoMap[id] = undefined;
    };
    GridApi.prototype.getDetailGridInfo = function (id) {
        return this.detailGridInfoMap[id];
    };
    GridApi.prototype.forEachDetailGridInfo = function (callback) {
        var index = 0;
        utils_1.Utils.iterateObject(this.detailGridInfoMap, function (id, gridInfo) {
            // check for undefined, as old references will still be lying around
            if (utils_1.Utils.exists(gridInfo)) {
                callback(gridInfo, index);
                index++;
            }
        });
    };
    GridApi.prototype.getDataAsCsv = function (params) {
        return this.csvCreator.getDataAsCsv(params);
    };
    GridApi.prototype.exportDataAsCsv = function (params) {
        this.csvCreator.exportDataAsCsv(params);
    };
    GridApi.prototype.getDataAsExcel = function (params) {
        if (!this.excelCreator) {
            console.warn('ag-Grid: Excel export is only available in ag-Grid Enterprise');
        }
        return this.excelCreator.getDataAsExcelXml(params);
    };
    GridApi.prototype.exportDataAsExcel = function (params) {
        if (!this.excelCreator) {
            console.warn('ag-Grid: Excel export is only available in ag-Grid Enterprise');
        }
        this.excelCreator.exportDataAsExcel(params);
    };
    GridApi.prototype.setEnterpriseDatasource = function (datasource) {
        if (this.gridOptionsWrapper.isRowModelEnterprise()) {
            // should really have an IEnterpriseRowModel interface, so we are not casting to any
            this.rowModel.setDatasource(datasource);
        }
        else {
            console.warn("ag-Grid: you can only use an enterprise datasource when gridOptions.rowModelType is '" + constants_1.Constants.ROW_MODEL_TYPE_ENTERPRISE + "'");
        }
    };
    GridApi.prototype.setDatasource = function (datasource) {
        if (this.gridOptionsWrapper.isRowModelInfinite()) {
            this.rowModel.setDatasource(datasource);
        }
        else {
            console.warn("ag-Grid: you can only use a datasource when gridOptions.rowModelType is '" + constants_1.Constants.ROW_MODEL_TYPE_INFINITE + "'");
        }
    };
    GridApi.prototype.setViewportDatasource = function (viewportDatasource) {
        if (this.gridOptionsWrapper.isRowModelViewport()) {
            // this is bad coding, because it's using an interface that's exposed in the enterprise.
            // really we should create an interface in the core for viewportDatasource and let
            // the enterprise implement it, rather than casting to 'any' here
            this.rowModel.setViewportDatasource(viewportDatasource);
        }
        else {
            console.warn("ag-Grid: you can only use a viewport datasource when gridOptions.rowModelType is '" + constants_1.Constants.ROW_MODEL_TYPE_VIEWPORT + "'");
        }
    };
    GridApi.prototype.setRowData = function (rowData) {
        if (this.gridOptionsWrapper.isRowModelDefault()) {
            if (this.gridOptionsWrapper.isDeltaRowDataMode()) {
                var _a = this.immutableService.createTransactionForRowData(rowData), transaction = _a[0], orderIdMap = _a[1];
                this.inMemoryRowModel.updateRowData(transaction, orderIdMap);
            }
            else {
                this.selectionController.reset();
                this.inMemoryRowModel.setRowData(rowData);
            }
        }
        else {
            console.log('cannot call setRowData unless using normal row model');
        }
    };
    // DEPRECATED
    GridApi.prototype.setFloatingTopRowData = function (rows) {
        console.warn('ag-Grid: since v12, api.setFloatingTopRowData() is now api.setPinnedTopRowData()');
        this.setPinnedTopRowData(rows);
    };
    // DEPRECATED
    GridApi.prototype.setFloatingBottomRowData = function (rows) {
        console.warn('ag-Grid: since v12, api.setFloatingBottomRowData() is now api.setPinnedBottomRowData()');
        this.setPinnedBottomRowData(rows);
    };
    // DEPRECATED
    GridApi.prototype.getFloatingTopRowCount = function () {
        console.warn('ag-Grid: since v12, api.getFloatingTopRowCount() is now api.getPinnedTopRowCount()');
        return this.getPinnedTopRowCount();
    };
    // DEPRECATED
    GridApi.prototype.getFloatingBottomRowCount = function () {
        console.warn('ag-Grid: since v12, api.getFloatingBottomRowCount() is now api.getPinnedBottomRowCount()');
        return this.getPinnedBottomRowCount();
    };
    // DEPRECATED
    GridApi.prototype.getFloatingTopRow = function (index) {
        console.warn('ag-Grid: since v12, api.getFloatingTopRow() is now api.getPinnedTopRow()');
        return this.getPinnedTopRow(index);
    };
    // DEPRECATED
    GridApi.prototype.getFloatingBottomRow = function (index) {
        console.warn('ag-Grid: since v12, api.getFloatingBottomRow() is now api.getPinnedBottomRow()');
        return this.getPinnedBottomRow(index);
    };
    GridApi.prototype.setPinnedTopRowData = function (rows) {
        this.pinnedRowModel.setPinnedTopRowData(rows);
    };
    GridApi.prototype.setPinnedBottomRowData = function (rows) {
        this.pinnedRowModel.setPinnedBottomRowData(rows);
    };
    GridApi.prototype.getPinnedTopRowCount = function () {
        return this.pinnedRowModel.getPinnedTopRowCount();
    };
    GridApi.prototype.getPinnedBottomRowCount = function () {
        return this.pinnedRowModel.getPinnedBottomRowCount();
    };
    GridApi.prototype.getPinnedTopRow = function (index) {
        return this.pinnedRowModel.getPinnedTopRow(index);
    };
    GridApi.prototype.getPinnedBottomRow = function (index) {
        return this.pinnedRowModel.getPinnedBottomRow(index);
    };
    GridApi.prototype.setColumnDefs = function (colDefs, source) {
        if (source === void 0) { source = "api"; }
        this.columnController.setColumnDefs(colDefs, source);
    };
    GridApi.prototype.expireValueCache = function () {
        this.valueCache.expire();
    };
    GridApi.prototype.getVerticalPixelRange = function () {
        return this.gridPanel.getVerticalPixelRange();
    };
    GridApi.prototype.refreshToolPanel = function () {
        if (this.toolPanel) {
            this.toolPanel.refresh();
        }
    };
    GridApi.prototype.refreshCells = function (params) {
        if (params === void 0) { params = {}; }
        if (Array.isArray(params)) {
            // the old version of refreshCells() took an array of rowNodes for the first argument
            console.warn('since ag-Grid v11.1, refreshCells() now takes parameters, please see the documentation.');
            return;
        }
        this.rowRenderer.refreshCells(params);
    };
    GridApi.prototype.redrawRows = function (params) {
        if (params === void 0) { params = {}; }
        if (params && params.rowNodes) {
            this.rowRenderer.redrawRows(params.rowNodes);
        }
        else {
            this.rowRenderer.redrawAfterModelUpdate();
        }
    };
    GridApi.prototype.timeFullRedraw = function (count) {
        if (count === void 0) { count = 1; }
        var iterationCount = 0;
        var totalProcessing = 0;
        var totalReflow = 0;
        var that = this;
        doOneIteration();
        function doOneIteration() {
            var start = (new Date()).getTime();
            that.rowRenderer.redrawAfterModelUpdate();
            var endProcessing = (new Date()).getTime();
            setTimeout(function () {
                var endReflow = (new Date()).getTime();
                var durationProcessing = endProcessing - start;
                var durationReflow = endReflow - endProcessing;
                console.log('duration:  processing = ' + durationProcessing + 'ms, reflow = ' + durationReflow + 'ms');
                iterationCount++;
                totalProcessing += durationProcessing;
                totalReflow += durationReflow;
                if (iterationCount < count) {
                    // wait for 1s between tests
                    setTimeout(doOneIteration, 1000);
                }
                else {
                    finish();
                }
            }, 0);
        }
        function finish() {
            console.log('tests complete. iteration count = ' + iterationCount);
            console.log('average processing = ' + (totalProcessing / iterationCount) + 'ms');
            console.log('average reflow = ' + (totalReflow / iterationCount) + 'ms');
        }
    };
    // *** deprecated
    GridApi.prototype.refreshView = function () {
        console.warn('ag-Grid: since v11.1, refreshView() is deprecated, please call refreshCells() or redrawRows() instead');
        this.redrawRows();
    };
    // *** deprecated
    GridApi.prototype.refreshRows = function (rowNodes) {
        console.warn('since ag-Grid v11.1, refreshRows() is deprecated, please use refreshCells({rowNodes: rows}) or redrawRows({rowNodes: rows}) instead');
        this.refreshCells({ rowNodes: rowNodes });
    };
    // *** deprecated
    GridApi.prototype.rowDataChanged = function (rows) {
        console.log('ag-Grid: rowDataChanged is deprecated, either call refreshView() to refresh everything, or call rowNode.setRowData(newData) to set value on a particular node');
        this.redrawRows();
    };
    // *** deprecated
    GridApi.prototype.softRefreshView = function () {
        console.error('ag-Grid: since v16, softRefreshView() is no longer supported. Please check the documentation on how to refresh.');
    };
    // *** deprecated
    GridApi.prototype.refreshGroupRows = function () {
        console.warn('ag-Grid: since v11.1, refreshGroupRows() is no longer supported, call refreshCells() instead. ' +
            'Because refreshCells() now does dirty checking, it will only refresh cells that have changed, so it should ' +
            'not be necessary to only refresh the group rows.');
        this.refreshCells();
    };
    GridApi.prototype.setFunctionsReadOnly = function (readOnly) {
        this.gridOptionsWrapper.setProperty('functionsReadOnly', readOnly);
    };
    GridApi.prototype.refreshHeader = function () {
        this.headerRenderer.refreshHeader();
        this.gridPanel.setBodyAndHeaderHeights();
    };
    GridApi.prototype.isAnyFilterPresent = function () {
        return this.filterManager.isAnyFilterPresent();
    };
    GridApi.prototype.isAdvancedFilterPresent = function () {
        return this.filterManager.isAdvancedFilterPresent();
    };
    GridApi.prototype.isQuickFilterPresent = function () {
        return this.filterManager.isQuickFilterPresent();
    };
    GridApi.prototype.getModel = function () {
        return this.rowModel;
    };
    GridApi.prototype.onGroupExpandedOrCollapsed = function (deprecated_refreshFromIndex) {
        if (utils_1.Utils.missing(this.inMemoryRowModel)) {
            console.log('ag-Grid: cannot call onGroupExpandedOrCollapsed unless using normal row model');
        }
        if (utils_1.Utils.exists(deprecated_refreshFromIndex)) {
            console.log('ag-Grid: api.onGroupExpandedOrCollapsed - refreshFromIndex parameter is no longer used, the grid will refresh all rows');
        }
        // we don't really want the user calling this if one one rowNode was expanded, instead they should be
        // calling rowNode.setExpanded(boolean) - this way we do a 'keepRenderedRows=false' so that the whole
        // grid gets refreshed again - otherwise the row with the rowNodes that were changed won't get updated,
        // and thus the expand icon in the group cell won't get 'opened' or 'closed'.
        this.inMemoryRowModel.refreshModel({ step: constants_1.Constants.STEP_MAP });
    };
    GridApi.prototype.refreshInMemoryRowModel = function (step) {
        if (utils_1.Utils.missing(this.inMemoryRowModel)) {
            console.log('cannot call refreshInMemoryRowModel unless using normal row model');
        }
        var paramsStep = constants_1.Constants.STEP_EVERYTHING;
        var stepsMapped = {
            group: constants_1.Constants.STEP_EVERYTHING,
            filter: constants_1.Constants.STEP_FILTER,
            map: constants_1.Constants.STEP_MAP,
            aggregate: constants_1.Constants.STEP_AGGREGATE,
            sort: constants_1.Constants.STEP_SORT,
            pivot: constants_1.Constants.STEP_PIVOT
        };
        if (utils_1.Utils.exists(step)) {
            paramsStep = stepsMapped[step];
        }
        if (utils_1.Utils.missing(paramsStep)) {
            console.error("ag-Grid: invalid step " + step + ", available steps are " + Object.keys(stepsMapped).join(', '));
            return;
        }
        var modelParams = {
            step: paramsStep,
            keepRenderedRows: true,
            animate: true,
            keepEditingRows: true
        };
        this.inMemoryRowModel.refreshModel(modelParams);
    };
    GridApi.prototype.getRowNode = function (id) {
        if (utils_1.Utils.missing(this.inMemoryRowModel)) {
            console.warn('ag-Grid: cannot call getRowNode unless using normal row model');
            return;
        }
        return this.inMemoryRowModel.getRowNode(id);
    };
    GridApi.prototype.expandAll = function () {
        if (utils_1.Utils.missing(this.inMemoryRowModel)) {
            console.warn('ag-Grid: cannot call expandAll unless using normal row model');
            return;
        }
        this.inMemoryRowModel.expandOrCollapseAll(true);
    };
    GridApi.prototype.collapseAll = function () {
        if (utils_1.Utils.missing(this.inMemoryRowModel)) {
            console.warn('ag-Grid: cannot call collapseAll unless using normal row model');
            return;
        }
        this.inMemoryRowModel.expandOrCollapseAll(false);
    };
    GridApi.prototype.addVirtualRowListener = function (eventName, rowIndex, callback) {
        if (typeof eventName !== 'string') {
            console.log('ag-Grid: addVirtualRowListener is deprecated, please use addRenderedRowListener.');
        }
        this.addRenderedRowListener(eventName, rowIndex, callback);
    };
    GridApi.prototype.addRenderedRowListener = function (eventName, rowIndex, callback) {
        if (eventName === 'virtualRowSelected') {
            console.log('ag-Grid: event virtualRowSelected is deprecated, to register for individual row ' +
                'selection events, add a listener directly to the row node.');
        }
        this.rowRenderer.addRenderedRowListener(eventName, rowIndex, callback);
    };
    GridApi.prototype.setQuickFilter = function (newFilter) {
        this.filterManager.setQuickFilter(newFilter);
    };
    GridApi.prototype.selectIndex = function (index, tryMulti, suppressEvents) {
        console.log('ag-Grid: do not use api for selection, call node.setSelected(value) instead');
        if (suppressEvents) {
            console.log('ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
        }
        this.selectionController.selectIndex(index, tryMulti);
    };
    GridApi.prototype.deselectIndex = function (index, suppressEvents) {
        if (suppressEvents === void 0) { suppressEvents = false; }
        console.log('ag-Grid: do not use api for selection, call node.setSelected(value) instead');
        if (suppressEvents) {
            console.log('ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
        }
        this.selectionController.deselectIndex(index);
    };
    GridApi.prototype.selectNode = function (node, tryMulti, suppressEvents) {
        if (tryMulti === void 0) { tryMulti = false; }
        if (suppressEvents === void 0) { suppressEvents = false; }
        console.log('ag-Grid: API for selection is deprecated, call node.setSelected(value) instead');
        if (suppressEvents) {
            console.log('ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
        }
        node.setSelectedParams({ newValue: true, clearSelection: !tryMulti });
    };
    GridApi.prototype.deselectNode = function (node, suppressEvents) {
        if (suppressEvents === void 0) { suppressEvents = false; }
        console.log('ag-Grid: API for selection is deprecated, call node.setSelected(value) instead');
        if (suppressEvents) {
            console.log('ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
        }
        node.setSelectedParams({ newValue: false });
    };
    GridApi.prototype.selectAll = function () {
        this.selectionController.selectAllRowNodes();
    };
    GridApi.prototype.deselectAll = function () {
        this.selectionController.deselectAllRowNodes();
    };
    GridApi.prototype.selectAllFiltered = function () {
        this.selectionController.selectAllRowNodes(true);
    };
    GridApi.prototype.deselectAllFiltered = function () {
        this.selectionController.deselectAllRowNodes(true);
    };
    GridApi.prototype.recomputeAggregates = function () {
        if (utils_1.Utils.missing(this.inMemoryRowModel)) {
            console.warn('cannot call recomputeAggregates unless using normal row model');
        }
        console.warn("recomputeAggregates is deprecated, please call api.refreshInMemoryRowModel('aggregate') instead");
        this.inMemoryRowModel.refreshModel({ step: constants_1.Constants.STEP_AGGREGATE });
    };
    GridApi.prototype.sizeColumnsToFit = function () {
        if (this.gridOptionsWrapper.isForPrint()) {
            console.warn('ag-grid: sizeColumnsToFit does not work when forPrint=true');
            return;
        }
        this.gridPanel.sizeColumnsToFit();
    };
    GridApi.prototype.showLoadingOverlay = function () {
        this.gridPanel.showLoadingOverlay();
    };
    GridApi.prototype.showNoRowsOverlay = function () {
        this.gridPanel.showNoRowsOverlay();
    };
    GridApi.prototype.hideOverlay = function () {
        this.gridPanel.hideOverlay();
    };
    GridApi.prototype.isNodeSelected = function (node) {
        console.log('ag-Grid: no need to call api.isNodeSelected(), just call node.isSelected() instead');
        return node.isSelected();
    };
    GridApi.prototype.getSelectedNodesById = function () {
        console.error('ag-Grid: since version 3.4, getSelectedNodesById no longer exists, use getSelectedNodes() instead');
        return null;
    };
    GridApi.prototype.getSelectedNodes = function () {
        return this.selectionController.getSelectedNodes();
    };
    GridApi.prototype.getSelectedRows = function () {
        return this.selectionController.getSelectedRows();
    };
    GridApi.prototype.getBestCostNodeSelection = function () {
        return this.selectionController.getBestCostNodeSelection();
    };
    GridApi.prototype.getRenderedNodes = function () {
        return this.rowRenderer.getRenderedNodes();
    };
    GridApi.prototype.ensureColIndexVisible = function (index) {
        console.warn('ag-Grid: ensureColIndexVisible(index) no longer supported, use ensureColumnVisible(colKey) instead.');
    };
    GridApi.prototype.ensureColumnVisible = function (key) {
        this.gridPanel.ensureColumnVisible(key);
    };
    // Valid values for position are bottom, middle and top
    GridApi.prototype.ensureIndexVisible = function (index, position) {
        this.gridPanel.ensureIndexVisible(index, position);
    };
    // Valid values for position are bottom, middle and top
    GridApi.prototype.ensureNodeVisible = function (comparator, position) {
        this.gridCore.ensureNodeVisible(comparator, position);
    };
    GridApi.prototype.forEachLeafNode = function (callback) {
        if (utils_1.Utils.missing(this.inMemoryRowModel)) {
            console.log('cannot call forEachNode unless using normal row model');
        }
        this.inMemoryRowModel.forEachLeafNode(callback);
    };
    GridApi.prototype.forEachNode = function (callback) {
        this.rowModel.forEachNode(callback);
    };
    GridApi.prototype.forEachNodeAfterFilter = function (callback) {
        if (utils_1.Utils.missing(this.inMemoryRowModel)) {
            console.log('cannot call forEachNodeAfterFilter unless using normal row model');
        }
        this.inMemoryRowModel.forEachNodeAfterFilter(callback);
    };
    GridApi.prototype.forEachNodeAfterFilterAndSort = function (callback) {
        if (utils_1.Utils.missing(this.inMemoryRowModel)) {
            console.log('cannot call forEachNodeAfterFilterAndSort unless using normal row model');
        }
        this.inMemoryRowModel.forEachNodeAfterFilterAndSort(callback);
    };
    GridApi.prototype.getFilterApiForColDef = function (colDef) {
        console.warn('ag-grid API method getFilterApiForColDef deprecated, use getFilterApi instead');
        return this.getFilterInstance(colDef);
    };
    GridApi.prototype.getFilterInstance = function (key) {
        var column = this.columnController.getPrimaryColumn(key);
        if (column) {
            return this.filterManager.getFilterComponent(column).resolveNow(null, function (filterComp) { return filterComp; });
        }
    };
    GridApi.prototype.getFilterApi = function (key) {
        console.warn('ag-Grid: getFilterApi is deprecated, use getFilterInstance instead');
        return this.getFilterInstance(key);
    };
    GridApi.prototype.destroyFilter = function (key) {
        var column = this.columnController.getPrimaryColumn(key);
        if (column) {
            return this.filterManager.destroyFilter(column, "filterDestroyed");
        }
    };
    GridApi.prototype.getColumnDef = function (key) {
        var column = this.columnController.getPrimaryColumn(key);
        if (column) {
            return column.getColDef();
        }
        else {
            return null;
        }
    };
    GridApi.prototype.onFilterChanged = function () {
        this.filterManager.onFilterChanged();
    };
    GridApi.prototype.onSortChanged = function () {
        this.sortController.onSortChanged();
    };
    GridApi.prototype.setSortModel = function (sortModel, source) {
        if (source === void 0) { source = "api"; }
        this.sortController.setSortModel(sortModel, source);
    };
    GridApi.prototype.getSortModel = function () {
        return this.sortController.getSortModel();
    };
    GridApi.prototype.setFilterModel = function (model) {
        this.filterManager.setFilterModel(model);
    };
    GridApi.prototype.getFilterModel = function () {
        return this.filterManager.getFilterModel();
    };
    GridApi.prototype.getFocusedCell = function () {
        return this.focusedCellController.getFocusedCell();
    };
    GridApi.prototype.clearFocusedCell = function () {
        return this.focusedCellController.clearFocusedCell();
    };
    GridApi.prototype.setFocusedCell = function (rowIndex, colKey, floating) {
        this.focusedCellController.setFocusedCell(rowIndex, colKey, floating, true);
    };
    GridApi.prototype.setSuppressRowDrag = function (value) {
        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_SUPPRESS_ROW_DRAG, value);
    };
    GridApi.prototype.setHeaderHeight = function (headerHeight) {
        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_HEADER_HEIGHT, headerHeight);
        this.doLayout();
    };
    GridApi.prototype.setGroupHeaderHeight = function (headerHeight) {
        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT, headerHeight);
        this.doLayout();
    };
    GridApi.prototype.setFloatingFiltersHeight = function (headerHeight) {
        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT, headerHeight);
        this.doLayout();
    };
    GridApi.prototype.setPivotGroupHeaderHeight = function (headerHeight) {
        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT, headerHeight);
        this.doLayout();
    };
    GridApi.prototype.setPivotHeaderHeight = function (headerHeight) {
        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT, headerHeight);
        this.doLayout();
    };
    GridApi.prototype.showToolPanel = function (show) {
        this.gridCore.showToolPanel(show);
    };
    GridApi.prototype.isToolPanelShowing = function () {
        return this.gridCore.isToolPanelShowing();
    };
    GridApi.prototype.doLayout = function () {
        this.gridCore.doLayout();
        // if the column is not visible, then made visible, it will be right size, but the
        // correct virtual columns will not be displayed. the setLeftAndRightBounds() gets
        // called when size changes. however when size is not changed, then wrong cols are shown.
        // this was to fix https://ag-grid.atlassian.net/browse/AG-1081
        this.gridPanel.setLeftAndRightBounds();
    };
    GridApi.prototype.resetRowHeights = function () {
        if (utils_1.Utils.exists(this.inMemoryRowModel)) {
            this.inMemoryRowModel.resetRowHeights();
        }
    };
    GridApi.prototype.setGroupRemoveSingleChildren = function (value) {
        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_REMOVE_SINGLE_CHILDREN, value);
    };
    GridApi.prototype.setGroupRemoveLowestSingleChildren = function (value) {
        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_REMOVE_LOWEST_SINGLE_CHILDREN, value);
    };
    GridApi.prototype.onRowHeightChanged = function () {
        if (utils_1.Utils.exists(this.inMemoryRowModel)) {
            this.inMemoryRowModel.onRowHeightChanged();
        }
    };
    GridApi.prototype.getValue = function (colKey, rowNode) {
        var column = this.columnController.getPrimaryColumn(colKey);
        if (utils_1.Utils.missing(column)) {
            column = this.columnController.getGridColumn(colKey);
        }
        if (utils_1.Utils.missing(column)) {
            return null;
        }
        else {
            return this.valueService.getValue(column, rowNode);
        }
    };
    GridApi.prototype.addEventListener = function (eventType, listener) {
        var async = this.gridOptionsWrapper.useAsyncEvents();
        this.eventService.addEventListener(eventType, listener, async);
    };
    GridApi.prototype.addGlobalListener = function (listener) {
        var async = this.gridOptionsWrapper.useAsyncEvents();
        this.eventService.addGlobalListener(listener, async);
    };
    GridApi.prototype.removeEventListener = function (eventType, listener) {
        var async = this.gridOptionsWrapper.useAsyncEvents();
        this.eventService.removeEventListener(eventType, listener, async);
    };
    GridApi.prototype.removeGlobalListener = function (listener) {
        var async = this.gridOptionsWrapper.useAsyncEvents();
        this.eventService.removeGlobalListener(listener, async);
    };
    GridApi.prototype.dispatchEvent = function (event) {
        this.eventService.dispatchEvent(event);
    };
    GridApi.prototype.destroy = function () {
        this.context.destroy();
    };
    GridApi.prototype.resetQuickFilter = function () {
        this.rowModel.forEachNode(function (node) { return node.quickFilterAggregateText = null; });
    };
    GridApi.prototype.getRangeSelections = function () {
        if (this.rangeController) {
            return this.rangeController.getCellRanges();
        }
        else {
            console.warn('ag-Grid: cell range selection is only available in ag-Grid Enterprise');
            return null;
        }
    };
    GridApi.prototype.camelCaseToHumanReadable = function (camelCase) {
        return utils_1.Utils.camelCaseToHumanText(camelCase);
    };
    GridApi.prototype.addRangeSelection = function (rangeSelection) {
        if (!this.rangeController) {
            console.warn('ag-Grid: cell range selection is only available in ag-Grid Enterprise');
        }
        this.rangeController.addRange(rangeSelection);
    };
    GridApi.prototype.clearRangeSelection = function () {
        if (!this.rangeController) {
            console.warn('ag-Grid: cell range selection is only available in ag-Grid Enterprise');
        }
        this.rangeController.clearSelection();
    };
    GridApi.prototype.copySelectedRowsToClipboard = function (includeHeader, columnKeys) {
        if (!this.clipboardService) {
            console.warn('ag-Grid: clipboard is only available in ag-Grid Enterprise');
        }
        this.clipboardService.copySelectedRowsToClipboard(includeHeader, columnKeys);
    };
    GridApi.prototype.copySelectedRangeToClipboard = function (includeHeader) {
        if (!this.clipboardService) {
            console.warn('ag-Grid: clipboard is only available in ag-Grid Enterprise');
        }
        this.clipboardService.copySelectedRangeToClipboard(includeHeader);
    };
    GridApi.prototype.copySelectedRangeDown = function () {
        if (!this.clipboardService) {
            console.warn('ag-Grid: clipboard is only available in ag-Grid Enterprise');
        }
        this.clipboardService.copyRangeDown();
    };
    GridApi.prototype.showColumnMenuAfterButtonClick = function (colKey, buttonElement) {
        var column = this.columnController.getPrimaryColumn(colKey);
        this.menuFactory.showMenuAfterButtonClick(column, buttonElement);
    };
    GridApi.prototype.showColumnMenuAfterMouseClick = function (colKey, mouseEvent) {
        var column = this.columnController.getPrimaryColumn(colKey);
        this.menuFactory.showMenuAfterMouseEvent(column, mouseEvent);
    };
    GridApi.prototype.hidePopupMenu = function () {
        // hide the context menu if in enterprise
        if (this.contextMenuFactory) {
            this.contextMenuFactory.hideActiveMenu();
        }
        // and hide the column menu always
        this.menuFactory.hideActiveMenu();
    };
    GridApi.prototype.setPopupParent = function (ePopupParent) {
        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_POPUP_PARENT, ePopupParent);
    };
    GridApi.prototype.tabToNextCell = function () {
        return this.rowRenderer.tabToNextCell(false);
    };
    GridApi.prototype.tabToPreviousCell = function () {
        return this.rowRenderer.tabToNextCell(true);
    };
    GridApi.prototype.stopEditing = function (cancel) {
        if (cancel === void 0) { cancel = false; }
        this.rowRenderer.stopEditing(cancel);
    };
    GridApi.prototype.startEditingCell = function (params) {
        var column = this.columnController.getGridColumn(params.colKey);
        if (!column) {
            console.warn("ag-Grid: no column found for " + params.colKey);
            return;
        }
        var gridCellDef = {
            rowIndex: params.rowIndex,
            floating: params.rowPinned,
            column: column
        };
        var gridCell = new gridCell_1.GridCell(gridCellDef);
        var notPinned = utils_1.Utils.missing(params.rowPinned);
        if (notPinned) {
            this.gridPanel.ensureIndexVisible(params.rowIndex);
        }
        this.rowRenderer.startEditingCell(gridCell, params.keyPress, params.charPress);
    };
    GridApi.prototype.addAggFunc = function (key, aggFunc) {
        if (this.aggFuncService) {
            this.aggFuncService.addAggFunc(key, aggFunc);
        }
    };
    GridApi.prototype.addAggFuncs = function (aggFuncs) {
        if (this.aggFuncService) {
            this.aggFuncService.addAggFuncs(aggFuncs);
        }
    };
    GridApi.prototype.clearAggFuncs = function () {
        if (this.aggFuncService) {
            this.aggFuncService.clear();
        }
    };
    GridApi.prototype.updateRowData = function (rowDataTransaction) {
        var res = null;
        if (this.inMemoryRowModel) {
            res = this.inMemoryRowModel.updateRowData(rowDataTransaction);
        }
        else if (this.infinitePageRowModel) {
            this.infinitePageRowModel.updateRowData(rowDataTransaction);
        }
        else {
            console.error('ag-Grid: updateRowData() only works with InMemoryRowModel and InfiniteRowModel.');
        }
        // do change detection for all present cells
        if (!this.gridOptionsWrapper.isSuppressChangeDetection()) {
            this.rowRenderer.refreshCells();
        }
        return res;
    };
    GridApi.prototype.insertItemsAtIndex = function (index, items, skipRefresh) {
        if (skipRefresh === void 0) { skipRefresh = false; }
        console.warn('ag-Grid: insertItemsAtIndex() is deprecated, use updateRowData(transaction) instead.');
        this.updateRowData({ add: items, addIndex: index, update: null, remove: null });
    };
    GridApi.prototype.removeItems = function (rowNodes, skipRefresh) {
        if (skipRefresh === void 0) { skipRefresh = false; }
        console.warn('ag-Grid: removeItems() is deprecated, use updateRowData(transaction) instead.');
        var dataToRemove = rowNodes.map(function (rowNode) { return rowNode.data; });
        this.updateRowData({ add: null, addIndex: null, update: null, remove: dataToRemove });
    };
    GridApi.prototype.addItems = function (items, skipRefresh) {
        if (skipRefresh === void 0) { skipRefresh = false; }
        console.warn('ag-Grid: addItems() is deprecated, use updateRowData(transaction) instead.');
        this.updateRowData({ add: items, addIndex: null, update: null, remove: null });
    };
    GridApi.prototype.refreshVirtualPageCache = function () {
        console.warn('ag-Grid: refreshVirtualPageCache() is now called refreshInfiniteCache(), please call refreshInfiniteCache() instead');
        this.refreshInfiniteCache();
    };
    GridApi.prototype.refreshInfinitePageCache = function () {
        console.warn('ag-Grid: refreshInfinitePageCache() is now called refreshInfiniteCache(), please call refreshInfiniteCache() instead');
        this.refreshInfiniteCache();
    };
    GridApi.prototype.refreshInfiniteCache = function () {
        if (this.infinitePageRowModel) {
            this.infinitePageRowModel.refreshCache();
        }
        else {
            console.warn("ag-Grid: api.refreshInfiniteCache is only available when rowModelType='infinite'.");
        }
    };
    GridApi.prototype.purgeVirtualPageCache = function () {
        console.warn('ag-Grid: purgeVirtualPageCache() is now called purgeInfiniteCache(), please call purgeInfiniteCache() instead');
        this.purgeInfinitePageCache();
    };
    GridApi.prototype.purgeInfinitePageCache = function () {
        console.warn('ag-Grid: purgeInfinitePageCache() is now called purgeInfiniteCache(), please call purgeInfiniteCache() instead');
        this.purgeInfiniteCache();
    };
    GridApi.prototype.purgeInfiniteCache = function () {
        if (this.infinitePageRowModel) {
            this.infinitePageRowModel.purgeCache();
        }
        else {
            console.warn("ag-Grid: api.purgeInfiniteCache is only available when rowModelType='infinite'.");
        }
    };
    GridApi.prototype.purgeEnterpriseCache = function (route) {
        if (this.enterpriseRowModel) {
            this.enterpriseRowModel.purgeCache(route);
        }
        else {
            console.warn("ag-Grid: api.purgeEnterpriseCache is only available when rowModelType='enterprise'.");
        }
    };
    GridApi.prototype.getVirtualRowCount = function () {
        console.warn('ag-Grid: getVirtualRowCount() is now called getInfiniteRowCount(), please call getInfiniteRowCount() instead');
        return this.getInfiniteRowCount();
    };
    GridApi.prototype.getInfiniteRowCount = function () {
        if (this.infinitePageRowModel) {
            return this.infinitePageRowModel.getVirtualRowCount();
        }
        else {
            console.warn("ag-Grid: api.getVirtualRowCount is only available when rowModelType='virtual'.");
        }
    };
    GridApi.prototype.isMaxRowFound = function () {
        if (this.infinitePageRowModel) {
            return this.infinitePageRowModel.isMaxRowFound();
        }
        else {
            console.warn("ag-Grid: api.isMaxRowFound is only available when rowModelType='virtual'.");
        }
    };
    GridApi.prototype.setVirtualRowCount = function (rowCount, maxRowFound) {
        console.warn('ag-Grid: setVirtualRowCount() is now called setInfiniteRowCount(), please call setInfiniteRowCount() instead');
        this.setInfiniteRowCount(rowCount, maxRowFound);
    };
    GridApi.prototype.setInfiniteRowCount = function (rowCount, maxRowFound) {
        if (this.infinitePageRowModel) {
            this.infinitePageRowModel.setVirtualRowCount(rowCount, maxRowFound);
        }
        else {
            console.warn("ag-Grid: api.setVirtualRowCount is only available when rowModelType='virtual'.");
        }
    };
    GridApi.prototype.getVirtualPageState = function () {
        console.warn('ag-Grid: getVirtualPageState() is now called getCacheBlockState(), please call getCacheBlockState() instead');
        return this.getCacheBlockState();
    };
    GridApi.prototype.getInfinitePageState = function () {
        console.warn('ag-Grid: getInfinitePageState() is now called getCacheBlockState(), please call getCacheBlockState() instead');
        return this.getCacheBlockState();
    };
    GridApi.prototype.getCacheBlockState = function () {
        if (this.infinitePageRowModel) {
            return this.infinitePageRowModel.getBlockState();
        }
        else if (this.enterpriseRowModel) {
            return this.enterpriseRowModel.getBlockState();
        }
        else {
            console.warn("ag-Grid: api.getCacheBlockState() is only available when rowModelType='infinite' or rowModelType='enterprise'.");
        }
    };
    GridApi.prototype.checkGridSize = function () {
        this.gridPanel.setBodyAndHeaderHeights();
    };
    GridApi.prototype.getFirstRenderedRow = function () {
        console.log('in ag-Grid v12, getFirstRenderedRow() was renamed to getFirstDisplayedRow()');
        return this.getFirstDisplayedRow();
    };
    GridApi.prototype.getFirstDisplayedRow = function () {
        return this.rowRenderer.getFirstVirtualRenderedRow();
    };
    GridApi.prototype.getLastRenderedRow = function () {
        console.log('in ag-Grid v12, getLastRenderedRow() was renamed to getLastDisplayedRow()');
        return this.getLastDisplayedRow();
    };
    GridApi.prototype.getLastDisplayedRow = function () {
        return this.rowRenderer.getLastVirtualRenderedRow();
    };
    GridApi.prototype.getDisplayedRowAtIndex = function (index) {
        return this.rowModel.getRow(index);
    };
    GridApi.prototype.getDisplayedRowCount = function () {
        return this.rowModel.getRowCount();
    };
    GridApi.prototype.paginationIsLastPageFound = function () {
        return this.paginationProxy.isLastPageFound();
    };
    GridApi.prototype.paginationGetPageSize = function () {
        return this.paginationProxy.getPageSize();
    };
    GridApi.prototype.paginationSetPageSize = function (size) {
        this.gridOptionsWrapper.setProperty('paginationPageSize', size);
    };
    GridApi.prototype.paginationGetCurrentPage = function () {
        return this.paginationProxy.getCurrentPage();
    };
    GridApi.prototype.paginationGetTotalPages = function () {
        return this.paginationProxy.getTotalPages();
    };
    GridApi.prototype.paginationGetRowCount = function () {
        return this.paginationProxy.getTotalRowCount();
    };
    GridApi.prototype.paginationGoToNextPage = function () {
        this.paginationProxy.goToNextPage();
    };
    GridApi.prototype.paginationGoToPreviousPage = function () {
        this.paginationProxy.goToPreviousPage();
    };
    GridApi.prototype.paginationGoToFirstPage = function () {
        this.paginationProxy.goToFirstPage();
    };
    GridApi.prototype.paginationGoToLastPage = function () {
        this.paginationProxy.goToLastPage();
    };
    GridApi.prototype.paginationGoToPage = function (page) {
        this.paginationProxy.goToPage(page);
    };
    __decorate([
        context_1.Autowired('immutableService'),
        __metadata("design:type", immutableService_1.ImmutableService)
    ], GridApi.prototype, "immutableService", void 0);
    __decorate([
        context_1.Autowired('csvCreator'),
        __metadata("design:type", csvCreator_1.CsvCreator)
    ], GridApi.prototype, "csvCreator", void 0);
    __decorate([
        context_1.Optional('excelCreator'),
        __metadata("design:type", Object)
    ], GridApi.prototype, "excelCreator", void 0);
    __decorate([
        context_1.Autowired('gridCore'),
        __metadata("design:type", gridCore_1.GridCore)
    ], GridApi.prototype, "gridCore", void 0);
    __decorate([
        context_1.Autowired('rowRenderer'),
        __metadata("design:type", rowRenderer_1.RowRenderer)
    ], GridApi.prototype, "rowRenderer", void 0);
    __decorate([
        context_1.Autowired('headerRenderer'),
        __metadata("design:type", headerRenderer_1.HeaderRenderer)
    ], GridApi.prototype, "headerRenderer", void 0);
    __decorate([
        context_1.Autowired('filterManager'),
        __metadata("design:type", filterManager_1.FilterManager)
    ], GridApi.prototype, "filterManager", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], GridApi.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('selectionController'),
        __metadata("design:type", selectionController_1.SelectionController)
    ], GridApi.prototype, "selectionController", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], GridApi.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('gridPanel'),
        __metadata("design:type", gridPanel_1.GridPanel)
    ], GridApi.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('valueService'),
        __metadata("design:type", valueService_1.ValueService)
    ], GridApi.prototype, "valueService", void 0);
    __decorate([
        context_1.Autowired('alignedGridsService'),
        __metadata("design:type", alignedGridsService_1.AlignedGridsService)
    ], GridApi.prototype, "alignedGridsService", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], GridApi.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('pinnedRowModel'),
        __metadata("design:type", pinnedRowModel_1.PinnedRowModel)
    ], GridApi.prototype, "pinnedRowModel", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], GridApi.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('rowModel'),
        __metadata("design:type", Object)
    ], GridApi.prototype, "rowModel", void 0);
    __decorate([
        context_1.Autowired('sortController'),
        __metadata("design:type", sortController_1.SortController)
    ], GridApi.prototype, "sortController", void 0);
    __decorate([
        context_1.Autowired('paginationProxy'),
        __metadata("design:type", paginationProxy_1.PaginationProxy)
    ], GridApi.prototype, "paginationProxy", void 0);
    __decorate([
        context_1.Autowired('focusedCellController'),
        __metadata("design:type", focusedCellController_1.FocusedCellController)
    ], GridApi.prototype, "focusedCellController", void 0);
    __decorate([
        context_1.Optional('rangeController'),
        __metadata("design:type", Object)
    ], GridApi.prototype, "rangeController", void 0);
    __decorate([
        context_1.Optional('clipboardService'),
        __metadata("design:type", Object)
    ], GridApi.prototype, "clipboardService", void 0);
    __decorate([
        context_1.Optional('aggFuncService'),
        __metadata("design:type", Object)
    ], GridApi.prototype, "aggFuncService", void 0);
    __decorate([
        context_1.Autowired('menuFactory'),
        __metadata("design:type", Object)
    ], GridApi.prototype, "menuFactory", void 0);
    __decorate([
        context_1.Optional('contextMenuFactory'),
        __metadata("design:type", Object)
    ], GridApi.prototype, "contextMenuFactory", void 0);
    __decorate([
        context_1.Autowired('cellRendererFactory'),
        __metadata("design:type", cellRendererFactory_1.CellRendererFactory)
    ], GridApi.prototype, "cellRendererFactory", void 0);
    __decorate([
        context_1.Autowired('cellEditorFactory'),
        __metadata("design:type", cellEditorFactory_1.CellEditorFactory)
    ], GridApi.prototype, "cellEditorFactory", void 0);
    __decorate([
        context_1.Autowired('valueCache'),
        __metadata("design:type", valueCache_1.ValueCache)
    ], GridApi.prototype, "valueCache", void 0);
    __decorate([
        context_1.Optional('toolPanel'),
        __metadata("design:type", Object)
    ], GridApi.prototype, "toolPanel", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], GridApi.prototype, "init", null);
    GridApi = __decorate([
        context_1.Bean('gridApi')
    ], GridApi);
    return GridApi;
}());
exports.GridApi = GridApi;


/***/ }),

/***/ "BHwR":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1071);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1071:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1049)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function () {

	var __meta__ = {// jshint ignore:line
	    id: "badge",
	    name: "Badge",
	    category: "web", // suite
	    description: "The Badge decorates avatars, navigation menus, or other components in the application when visual notification is needed",
	    depends: ["core"] // dependencies
	};

	(function ($, undefined) {
	    var kendo = window.kendo;
	    var Widget = kendo.ui.Widget;
	    var ui = kendo.ui;
	    var HIDDEN = 'k-hidden';

	    var iconTemplate = '<span class=\'k-badge-icon k-icon k-i-#= icon #\'></span>';
	    var svgIconTemplate = '<span class=\'k-badge-icon k-svg-icon\'>#= icon #</span>';

	    var Badge = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            that._content();

	            that._appearance();

	            kendo.notify(that);
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);
	        },

	        options: {
	            name: 'Badge',
	            cutoutBorder: false,
	            data: {},
	            fill: 'solid',
	            icon: '',
	            max: Infinity,
	            position: 'inline',
	            align: '',
	            sizes: {
	                'small': 'sm',
	                'medium': 'md',
	                'large': 'lg'
	            },
	            size: 'medium',
	            shape: 'rounded',
	            template: null,
	            text: '',
	            themeColor: 'secondary',
	            visible: true,
	            _classNames: []
	        },

	        _content: function() {
	            var that = this;
	            var text = that.options.text;
	            var template = that.options.template;
	            var data = that.options.data;
	            var icon = that.options.icon;

	            // Order of precedence
	            // 1) template
	            // 2) icon
	            // 3) text
	            // 4) content

	            if (template !== null) {
	                that._text = text;
	                that._template = kendo.template(template).bind(that);
	                that.element.html( that._template(data) );

	                return;
	            }

	            if (icon !== '') {
	                that.icon(icon);

	                return;
	            }

	            if (text !== '') {
	                that.text(text);

	                return;
	            }

	            that.text(that.element.html());
	        },

	        _appearance: function() {
	            var that = this;
	            that._themeColor = that.options.themeColor;
	            that._shape = that.options.shape;
	            that._sizes = that.options.sizes;
	            that._size = that.options.size;
	            that._fill = that.options.fill;
	            that._cutoutBorder = that.options.cutoutBorder;
	            that._align = that.options.align;
	            that._position = that.options.position;
	            that._visible = that.options.visible;

	            that._updateClassNames();
	        },

	        _updateClassNames: function() {
	            var that = this;
	            var classNames = ['k-badge'];
	            var keepClassNames = that.options._classNames;
	            var themeColor = that._themeColor;
	            var shape = that._shape;
	            var sizes = that._sizes;
	            var size = that._size;
	            var sizeAbbr = sizes[size] === undefined ? size : sizes[size];
	            var fill = that._fill;
	            var cutoutBorder = that._cutoutBorder;
	            var align = that._align;
	            var position = that._position;
	            var visible = that._visible;

	            // Remove all class names
	            that.element.removeClass(function(index, className) {
	                if (className.indexOf('k-') === 0 && keepClassNames.indexOf(className) === -1) {
	                    that.element.removeClass(className);
	                }
	            });

	            // Fill
	            if (typeof fill === 'string' && fill !== '') {
	                classNames.push('k-badge-' + fill);
	            }

	            // Color
	            if (typeof themeColor === 'string' && themeColor !== '') {
	                classNames.push('k-badge-' + themeColor);
	            }

	            // Size
	            if (typeof size === 'string' && size !== '') {
	                classNames.push('k-badge-' + sizeAbbr);
	            }

	            // Shape
	            if (typeof shape === 'string' && shape !== '') {
	                classNames.push('k-badge-' + shape);
	            }

	            // Cutout border
	            if (typeof cutoutBorder === 'boolean' && cutoutBorder === true) {
	                classNames.push('k-badge-border-cutout');
	            }

	            // Position
	            if (typeof position === 'string' && position !== '') {
	                classNames.push('k-badge-' + position);
	            }

	            // Align
	            if (typeof position === 'string' && position !== '' && position !== 'inline' && typeof align === 'string' && align.split(' ').length == 2) {
	                classNames.push('k-' + align.replace(' ', '-'));
	            }

	            // Visibility
	            if (visible === false) {
	                classNames.push(HIDDEN);
	            }

	            // Apply classnames
	            that.element.addClass(classNames.join(' '));
	        },

	        setOptions: function(options) {
	            var that = this;

	            that.element.removeClass(function(index, className) {
	                if (className.indexOf('k-') >= 0) {
	                    that.element.removeClass(className);
	                }
	            });

	            Widget.fn.setOptions.call(that, options);

	            that._content();

	            that._appearance();
	        },

	        text: function(text) {
	            var that = this;
	            var max = that.options.max;

	            // handle badge.text()
	            if (arguments.length === 0 || text === undefined) {
	                return that._text;
	            }

	            that._text = text;

	            // handle badge.text(true|false|null)
	            if (text === true || text === false || text === null) {
	                that.element.html('');

	                return;
	            }

	            // handle badge.text('string')
	            if (typeof text === 'string') {
	                that.element.html(text);

	                return;
	            }

	            // handle badge.text(1)
	            if (typeof text === 'number') {
	                if (text > max) {
	                    that.element.html(max + '+');
	                } else {
	                    that.element.html(text);
	                }

	                return;
	            }

	            // handle other objects
	            if (typeof text === 'object' && 'toString' in text) {
	                that.element.html(text.toString());

	                return;
	            }

	        },

	        icon: function(icon) {
	            var that = this;
	            var iconTemplateFunction;

	            // handle badge.icon()
	            if (arguments.length === 0 || icon === undefined) {
	                return that._icon;
	            }

	            that._icon = icon;

	            // Handle badge.icon(<SVG />)
	            if (icon.indexOf('<svg') === 0) {
	                iconTemplateFunction = kendo.template(svgIconTemplate);
	                that.element.html(iconTemplateFunction({ icon: icon }));

	                return;
	            }

	            // Handle badge.icon(ICON_NAME)
	            iconTemplateFunction = kendo.template(iconTemplate);
	            that.element.html(iconTemplateFunction({ icon: icon }));
	        },

	        themeColor: function(color) {
	            var that = this;

	            // handle badge.color()
	            if (arguments.length === 0 || color === undefined) {
	                return that._themeColor;
	            }

	            that._themeColor = color;
	            that._updateClassNames();
	        },

	        shape: function(shape) {
	            var that = this;

	            // handle badge.shape()
	            if (arguments.length === 0 || shape === undefined) {
	                return that._shape;
	            }

	            that._shape = shape;
	            that._updateClassNames();
	        },

	        hide: function() {
	            var that = this;
	            that._visible = false;

	            that._updateClassNames();
	        },

	        show: function() {
	            var that = this;
	            that._visible = true;

	            that._updateClassNames();
	        }
	    });

	    ui.plugin(Badge);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "BMMp":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(940);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 882:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nzx/");

/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	     !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(882) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($) {
	    var cache;

	    function autoTheme(force) {
	        if (!force && cache) {
	            return cache;
	        }

	        var theme = { chart: kendo.dataviz.chartBaseTheme() };
	        var hook = $(
	            '<div style="display: none">' +
	            '  <div class="k-var--accent"></div>' +
	            '  <div class="k-var--accent-contrast"></div>' +
	            '  <div class="k-var--base"></div>' +
	            '  <div class="k-var--background"></div>' +
	            '  <div class="k-var--normal-background"></div>' +
	            '  <div class="k-var--normal-text-color"></div>' +
	            '  <div class="k-var--hover-background"></div>' +
	            '  <div class="k-var--hover-text-color"></div>' +
	            '  <div class="k-var--selected-background"></div>' +
	            '  <div class="k-var--selected-text-color"></div>' +
	            '  <div class="k-var--chart-error-bars-background"></div>' +
	            '  <div class="k-var--chart-notes-background"></div>' +
	            '  <div class="k-var--chart-notes-border"></div>' +
	            '  <div class="k-var--chart-notes-lines"></div>' +
	            '  <div class="k-var--chart-crosshair-background"></div>' +
	            '  <div class="k-var--chart-inactive"></div>' +
	            '  <div class="k-var--chart-major-lines"></div>' +
	            '  <div class="k-var--chart-minor-lines"></div>' +
	            '  <div class="k-var--chart-area-opacity"></div>' +
	            '  <div class="k-widget k-chart">' +
	            '      <div class="k-var--chart-font"></div>' +
	            '      <div class="k-var--chart-title-font"></div>' +
	            '      <div class="k-var--chart-label-font"></div>' +
	            '  </div>' +
	            '  <div class="k-var--series">' +
	            '    <div class="k-var--series-a"></div>' +
	            '    <div class="k-var--series-b"></div>' +
	            '    <div class="k-var--series-c"></div>' +
	            '    <div class="k-var--series-d"></div>' +
	            '    <div class="k-var--series-e"></div>' +
	            '    <div class="k-var--series-f"></div>' +
	            '  </div>' +
	            '  <div class="k-var--gauge-pointer"></div>' +
	            '  <div class="k-var--gauge-track"></div>' +
	            '</div>').appendTo(document.body);

	        function mapColor(key, varName) {
	            set(key, queryStyle(varName, "backgroundColor"));
	        }

	        function queryStyle(varName, prop) {
	            return hook.find(".k-var--" + varName).css(prop);
	        }

	        function set(path, value) {
	            var store = theme;
	            var parts = path.split('.');
	            var key = parts.shift();

	            while (parts.length > 0) {
	                store = store[key] = store[key] || {};
	                key = parts.shift();
	            }

	            store[key] = value;
	        }

	        (function setColors() {
	            mapColor("chart.axisDefaults.crosshair.color", "chart-crosshair-background");
	            mapColor("chart.axisDefaults.labels.color", "normal-text-color");
	            mapColor("chart.axisDefaults.line.color", "chart-major-lines");
	            mapColor("chart.axisDefaults.majorGridLines.color", "chart-major-lines");
	            mapColor("chart.axisDefaults.minorGridLines.color", "chart-minor-lines");
	            mapColor("chart.axisDefaults.notes.icon.background", "chart-notes-background");
	            mapColor("chart.axisDefaults.notes.icon.border.color", "chart-notes-border");
	            mapColor("chart.axisDefaults.notes.line.color", "chart-notes-lines");
	            mapColor("chart.axisDefaults.title.color", "normal-text-color");
	            mapColor('chart.chartArea.background', 'background');
	            mapColor("chart.legend.inactiveItems.labels.color", "chart-inactive");
	            mapColor("chart.legend.inactiveItems.markers.color", "chart-inactive");
	            mapColor("chart.legend.labels.color", "normal-text-color");
	            mapColor("chart.seriesDefaults.boxPlot.downColor", "chart-major-lines");
	            mapColor("chart.seriesDefaults.boxPlot.mean.color", "base");
	            mapColor("chart.seriesDefaults.boxPlot.median.color", "base");
	            mapColor("chart.seriesDefaults.boxPlot.whiskers.color", "accent");
	            mapColor("chart.seriesDefaults.bullet.target.color", "accent");
	            mapColor("chart.seriesDefaults.candlestick.downColor", "normal-text-color");
	            mapColor("chart.seriesDefaults.candlestick.line.color", "normal-text-color");
	            mapColor("chart.seriesDefaults.errorBars.color", "chart-error-bars-background");
	            mapColor("chart.seriesDefaults.horizontalWaterfall.line.color", "chart-major-lines");
	            mapColor("chart.seriesDefaults.icon.border.color", "chart-major-lines");
	            mapColor("chart.seriesDefaults.labels.background", "background");
	            mapColor("chart.seriesDefaults.labels.color", "normal-text-color");
	            mapColor("chart.seriesDefaults.notes.icon.background", "chart-notes-background");
	            mapColor("chart.seriesDefaults.notes.icon.border.color", "chart-notes-border");
	            mapColor("chart.seriesDefaults.notes.line.color", "chart-notes-lines");
	            mapColor("chart.seriesDefaults.verticalBoxPlot.downColor", "chart-major-lines");
	            mapColor("chart.seriesDefaults.verticalBoxPlot.mean.color", "base");
	            mapColor("chart.seriesDefaults.verticalBoxPlot.median.color", "base");
	            mapColor("chart.seriesDefaults.verticalBoxPlot.whiskers.color", "accent");
	            mapColor("chart.seriesDefaults.verticalBullet.target.color", "accent");
	            mapColor("chart.seriesDefaults.waterfall.line.color", "chart-major-lines");
	            mapColor("chart.title.color", "normal-text-color");

	            set("chart.seriesDefaults.labels.opacity", queryStyle("chart-area-opacity", "opacity"));

	            mapColor("diagram.shapeDefaults.fill.color", "accent");
	            mapColor("diagram.shapeDefaults.content.color", "accent-contrast");
	            mapColor("diagram.shapeDefaults.connectorDefaults.fill.color", "normal-text-color");
	            mapColor("diagram.shapeDefaults.connectorDefaults.stroke.color", "accent-contrast");
	            mapColor("diagram.shapeDefaults.connectorDefaults.hover.fill.color", "accent-contrast");
	            mapColor("diagram.shapeDefaults.connectorDefaults.hover.stroke.color", "normal-text-color");
	            mapColor("diagram.editable.resize.handles.stroke.color", "normal-text-color");
	            mapColor("diagram.editable.resize.handles.fill.color", "normal-background");
	            mapColor("diagram.editable.resize.handles.hover.stroke.color", "normal-text-color");
	            mapColor("diagram.editable.resize.handles.hover.fill.color", "normal-text-color");
	            mapColor("diagram.selectable.stroke.color", "normal-text-color");
	            mapColor("diagram.connectionDefaults.stroke.color", "normal-text-color");
	            mapColor("diagram.connectionDefaults.content.color", "normal-text-color");
	            mapColor("diagram.connectionDefaults.selection.handles.fill.color", "accent-contrast");
	            mapColor("diagram.connectionDefaults.selection.handles.stroke.color", "normal-text-color");
	            mapColor("diagram.connectionDefaults.selection.stroke.color", "normal-text-color");

	            mapColor("gauge.pointer.color", "gauge-pointer");
	            mapColor("gauge.scale.labels.color", "normal-text-color");
	            mapColor("gauge.scale.minorTicks.color", "normal-text-color");
	            mapColor("gauge.scale.majorTicks.color", "normal-text-color");
	            mapColor("gauge.scale.line.color", "normal-text-color");
	            mapColor("gauge.scale.rangePlaceholderColor", "gauge-track");
	        })();

	        (function setFonts() {
	            function font(varName) {
	                return queryStyle(varName, "fontSize") + " " +
	                       queryStyle(varName, "fontFamily");
	            }

	            var defaultFont = font("chart-font");
	            var titleFont = font("chart-title-font");
	            var labelFont = font("chart-label-font");

	            set("chart.axisDefaults.labels.font", labelFont);
	            set("chart.axisDefaults.notes.label.font", defaultFont);
	            set("chart.axisDefaults.title.font", defaultFont);
	            set("chart.legend.labels.font", defaultFont);
	            set("chart.seriesDefaults.labels.font", labelFont);
	            set("chart.seriesDefaults.notes.label.font", defaultFont);
	            set("chart.title.font", titleFont);
	        })();

	        (function setSeriesColors() {
	            function letterPos(letter) {
	                return letter.toLowerCase().charCodeAt(0) - "a".charCodeAt(0);
	            }

	            function seriesPos(name) {
	                return letterPos(name.match(/series-([a-z])$/)[1]);
	            }

	            var series = $(".k-var--series div").toArray();
	            var seriesColors = series.reduce(
	              function(arr, el) {
	                var pos = seriesPos(el.className);
	                arr[pos] = $(el).css("backgroundColor");

	                return arr;
	              },
	              [] // Will populate the series colors in this array
	            );

	            set("chart.seriesColors", seriesColors);
	        })();

	        hook.remove();

	        cache = theme;

	        return theme;
	    }

	    kendo.dataviz.autoTheme = autoTheme;
	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "BOhp":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.5.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2020-05-04T22:49Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.5.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( _i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.5
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2020-03-14
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem.namespaceURI,
		docElem = ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();
						return result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px";
				tr.style.height = "1px";
				trChild.style.height = "9px";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = parseInt( trStyle.height ) > 3;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = (
					dataPriv.get( cur, "events" ) || Object.create( null )
				)[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script
			if ( !isSuccess && jQuery.inArray( "script", s.dataTypes ) > -1 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			if ( typeof props.top === "number" ) {
				props.top += "px";
			}
			if ( typeof props.left === "number" ) {
				props.left += "px";
			}
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),

/***/ "BY3/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var context_2 = __webpack_require__("RQ1/");
var utils_1 = __webpack_require__("IRr6");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var cellComp_1 = __webpack_require__("wTNE");
var MouseEventService = (function () {
    function MouseEventService() {
        this.gridInstanceId = MouseEventService_1.gridInstanceSequence.next();
    }
    MouseEventService_1 = MouseEventService;
    MouseEventService.prototype.init = function () {
        this.stampDomElementWithGridInstance();
    };
    // we put the instance id onto the main DOM element. this is used for events, when grids are inside grids,
    // so the grid can work out if the even came from this grid or a grid inside this one. see the ctrl+v logic
    // for where this is used.
    MouseEventService.prototype.stampDomElementWithGridInstance = function () {
        this.eGridDiv[MouseEventService_1.GRID_DOM_KEY] = this.gridInstanceId;
    };
    MouseEventService.prototype.getRenderedCellForEvent = function (event) {
        var sourceElement = utils_1.Utils.getTarget(event);
        while (sourceElement) {
            var renderedCell = this.gridOptionsWrapper.getDomData(sourceElement, cellComp_1.CellComp.DOM_DATA_KEY_CELL_COMP);
            if (renderedCell) {
                return renderedCell;
            }
            sourceElement = sourceElement.parentElement;
        }
        return null;
    };
    // walks the path of the event, and returns true if this grid is the first one that it finds. if doing
    // master / detail grids, and a child grid is found, then it returns false. this stops things like copy/paste
    // getting executed on many grids at the same time.
    MouseEventService.prototype.isEventFromThisGrid = function (event) {
        var path = utils_1.Utils.getEventPath(event);
        for (var i = 0; i < path.length; i++) {
            var element = path[i];
            var instanceId = element[MouseEventService_1.GRID_DOM_KEY];
            if (utils_1.Utils.exists(instanceId)) {
                var eventFromThisGrid = instanceId === this.gridInstanceId;
                return eventFromThisGrid;
            }
        }
        return false;
    };
    MouseEventService.prototype.getGridCellForEvent = function (event) {
        var cellComp = this.getRenderedCellForEvent(event);
        return cellComp ? cellComp.getGridCell() : null;
    };
    MouseEventService.gridInstanceSequence = new utils_1.NumberSequence();
    MouseEventService.GRID_DOM_KEY = '__ag_grid_instance';
    __decorate([
        context_2.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], MouseEventService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_2.Autowired('eGridDiv'),
        __metadata("design:type", HTMLElement)
    ], MouseEventService.prototype, "eGridDiv", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MouseEventService.prototype, "init", null);
    MouseEventService = MouseEventService_1 = __decorate([
        context_1.Bean('mouseEventService')
    ], MouseEventService);
    return MouseEventService;
    var MouseEventService_1;
}());
exports.MouseEventService = MouseEventService;


/***/ }),

/***/ "BwK2":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1014);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1014:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
	   !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1015)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function() {

	(function($, undefined) {

	var kendo = window.kendo,
	    Editor = kendo.ui.editor,
	    EditorUtils = Editor.EditorUtils,
	    RangeUtils = Editor.RangeUtils,
	    dom = Editor.Dom,
	    registerTool = EditorUtils.registerTool,
	    ToolTemplate = Editor.ToolTemplate,
	    Command = Editor.Command;

	var tableFormatFinder = new Editor.BlockFormatFinder([{tags:["table"]}]);
	var cellsFormatFinder = new Editor.BlockFormatFinder([{tags:["td","th"]}]);
	var reUnit = /([a-z]+|%)$/i;

	var COL = "col";
	var ROW = "row";
	var COLGROUP = "colgroup";
	var SCOPE = "scope";
	var COL_INDEX = "col-index";
	var TH = "th";
	var TD = "td";
	var THEAD = "thead";
	var HEADERS = "headers";
	var TABLE = "table";

	var TableWizardCommand = Command.extend({
	    exec: function() {
	        var cmd = this;
	        var editor = cmd.editor;
	        var range = cmd.range = cmd.lockRange();
	        var selectedTable = cmd._sourceTable = !cmd.options.insertNewTable ? cmd._selectedTable(range) : undefined;
	        var selectedCells = cmd._selectedTableCells = selectedTable ? cmd._selectedCells(range) : undefined;
	        var options = {
	            visible: false,
	            messages: editor.options.messages,
	            closeCallback: $.proxy(cmd.onDialogClose, cmd),
	            table: cmd.parseTable(selectedTable, selectedCells),
	            dialogOptions: editor.options.dialogOptions,
	            isRtl: kendo.support.isRtl(editor.wrapper)
	        };

	        var dialog = new Editor.TableWizardDialog(options);
	        dialog.open();
	    },

	    onDialogClose: function(data) {
	        var cmd = this;
	        cmd.releaseRange(cmd.range);

	        if (data) { //Ok button pressed
	            if (cmd.options.insertNewTable) {
	                cmd.insertTable(cmd.createNewTable(data));
	            } else {
	                cmd.updateTable(data, cmd._sourceTable, cmd._selectedTableCells);
	            }
	        }
	    },
	    releaseRange: function(range) {
	        var cmd = this;
	        var doc = cmd.editor.document;
	        dom.windowFromDocument(doc).focus();
	        Command.fn.releaseRange.call(cmd, range);
	    },
	    insertTable: function(table) {
	        var range = this.range;

	        range.insertNode(table);
	        range.collapse(true);
	        this.editor.selectRange(range);

	        this._ensureFocusableAfterTable(table);
	    },
	    _ensureFocusableAfterTable: function (table) {
	        var siblingNodes = $(table).parent().contents();
	        var lastSiblingIndex = siblingNodes.length - 1;
	        var lastSibling = siblingNodes.get(lastSiblingIndex);

	        while(lastSibling.nodeValue !== null && (lastSibling.nodeValue === " " || lastSibling.nodeValue === "")) {
	            lastSiblingIndex -= 1;
	            lastSibling = siblingNodes.get(lastSiblingIndex);
	        }

	        if(lastSibling === table) {
	            dom.insertAfter(dom.createEmptyNode(this.editor.document, "p"), table);
	        }
	    },
	    updateTable: function(data, table, selectedCells) {
	        var cmd = this;
	        var tableRows = $(table.rows).toArray();
	        var tableProp = data.tableProperties;
	        var rows = tableProp.rows;
	        var tHead = table.tHead;
	        var last = cmd._lastInCollection;
	        var lastSelectedRow, cellProp;

	        //Leave only first selected cell
	        while (selectedCells.length > 1) {
	            selectedCells.pop();
	        }

	        lastSelectedRow = selectedCells.length ? last(selectedCells).parentNode : last(tableRows);

	        cmd._deleteTableRows(tableRows, tableRows.length - rows);

	        if (tableRows.length < rows) {
	            cmd._addRows(lastSelectedRow, rows, tableRows);
	        }

	        dom.reMapTableColumns(table, COL_INDEX);
	        cmd._updateColumns(tableRows, tableProp.columns, selectedCells, lastSelectedRow);
	        cmd._updateTableProperties(table, tableProp);

	        cellProp = data.cellProperties;
	        if (selectedCells[0]) {
	            dom.attr(selectedCells[0], {id: cellProp.id || null});
	        }
	        (cellProp.selectAllCells ? $(tableRows).children() : $(selectedCells)).each(function(i, cell){
	            cmd._updateCellProperties(cell, cellProp);
	        });

	        cmd._updateCaption(table, tableProp);

	        if(tHead) {
	            cmd._updateHeadersWithThead(table, data);
	        } else {
	            cmd._updateHeadersNoThead(table, data);
	        }

	        cmd._updateHeaderAssociates(table, tableProp);
	        dom.clearTableMappings(table, COL_INDEX);
	    },
	    _isHeadingRow: function(row) {
	        return dom.is(row.cells[0], TH) && dom.is(row.parentNode, THEAD);
	    },
	    _isHeadingCell: function(cell) {
	        return dom.is(cell, TH);
	    },
	    cellsWithHeadersAssociated: function(table) {
	        var cells = $(table.rows).children();
	        var headingIds = [];
	        var checkHeader = function(header){
	            return headingIds.indexOf(header) > -1;
	        };

	        cells.each(function(c, cell) {
	            if (cell.id && dom.is(cell, TH)) {
	                headingIds.push(cell.id);
	            }
	        });

	        var associatedCells = cells.filter(function(c, cell) {
	            var headersAttr = cell.getAttribute(HEADERS);
	            var headersArray;

	            if(headersAttr && !dom.is(cell, TH)) {
	                headersArray = headersAttr.split(" ");

	                if(headersArray && headersArray.length > 0) {
	                    return headersArray.some(checkHeader);
	                }
	            }

	            return false;
	        });

	        return !!associatedCells.length;
	    },
	    _insertCells: function(count, row, index) {
	        index = isNaN(index) ? -1 : index;
	        for (var i = 0, cell; i < count; i++) {
	            cell = row.insertCell(index);
	            cell.innerHTML = "&nbsp;";
	        }
	    },
	    _deleteTableRows: function(rows, count){
	        for (var i = 0, row, rowParent; i < count; i++) {
	            row = rows.pop();
	            rowParent = row.parentNode;
	            rowParent.removeChild(row);
	            if (!rowParent.rows.length) {
	                dom.remove(rowParent);
	            }
	        }
	    },
	    createNewTable: function(data) {
	        var cmd = this;
	        var doc = cmd.editor.document;
	        var tableProp = data.tableProperties;
	        var table = dom.create(doc, TABLE);
	        var rowIndex = 0;
	        var thead;

	        cmd._updateTableProperties(table, tableProp);
	        cmd._updateCaption(table, tableProp);

	        if(tableProp.headerRows && tableProp.headerRows > 0) {
	            thead = table.createTHead();
	            cmd._createTableRows(data, thead, rowIndex, true);
	            rowIndex += tableProp.headerRows;
	        }

	        var tbody = table.createTBody();
	        cmd._createTableRows(data, tbody, rowIndex, false);

	        dom.reMapTableColumns(table, COL_INDEX);

	        if (tableProp.cellsWithHeaders === "ids") {
	            dom.associateWithIds(table);
	        } else if(tableProp.cellsWithHeaders === "scope") {
	            cmd._addScopes(table, tableProp.headerRows, tableProp.headerColumns);
	        }

	        dom.clearTableMappings(table, COL_INDEX);

	        return table;
	    },
	    _createTableRows: function(data, container, initialIndex, headerRows) {
	        var cmd = this;
	        var tableProp = data.tableProperties;
	        var cellProp = data.cellProperties;
	        var columns = tableProp.columns;
	        var rows = headerRows ? tableProp.headerRows : tableProp.rows;
	        var cellPropToAll = cellProp.selectAllCells;
	        var headerColumns = tableProp.headerColumns;

	        for (var r = initialIndex, row; r < rows; r++) {
	            row = container.insertRow();

	            for (var c = 0, cell; c < columns; c++) {
	                if(headerRows || headerColumns > c) {
	                    cell = document.createElement(TH);
	                } else {
	                    cell = document.createElement(TD);
	                }

	                row.appendChild(cell);
	                cell.innerHTML = "&nbsp;";
	                if (r === 0 && c === 0 && cellProp.id) {
	                    cell.id = cellProp.id;
	                }
	                cmd._updateCellProperties(cell, (cellPropToAll || (r === 0 && c === 0)) ? cellProp : {});
	            }
	        }
	    },
	    _addRows: function(lastSelectedRow, rows, tableRows) {
	        var cmd = this;
	        var rowIndex = $(lastSelectedRow).index();
	        var cellsLength = lastSelectedRow.cells.length;
	        var newRowsCount = rows - tableRows.length;
	        var parent = lastSelectedRow.parentNode;
	        var row;

	        while (newRowsCount) {
	            row = parent.insertRow(rowIndex + 1);
	            cmd._insertCells(cellsLength - row.cells.length, row);
	            newRowsCount--;
	        }
	    },
	    _updateColumns: function(tableRows, columns, selectedCells, lastSelectedRow) {
	        var cmd = this;
	        var last = cmd._lastInCollection;
	        var firstRowLastCell = last(tableRows[0].cells);
	        var numberOfColumns = Number(firstRowLastCell.getAttribute(COL_INDEX)) + firstRowLastCell.colSpan;

	        if (numberOfColumns > columns) {
	            $(tableRows).each(function(i, row){
	                var lastCurrentCell = last(row.cells);
	                var rowColumns = Number(lastCurrentCell.getAttribute(COL_INDEX)) + lastCurrentCell.colSpan;

	                while(rowColumns > columns) {
	                    if(lastCurrentCell.colSpan && lastCurrentCell.colSpan > 1) {
	                        lastCurrentCell.colSpan -= 1;
	                    } else {
	                        row.deleteCell(-1);
	                    }

	                    lastCurrentCell = last(row.cells);
	                    rowColumns = Number(lastCurrentCell.getAttribute(COL_INDEX)) + lastCurrentCell.colSpan;
	                }
	            });
	        }

	        if (numberOfColumns < columns) {
	            var cellIndex = $(last(selectedCells) || last(lastSelectedRow.cells)).index();
	            $(tableRows).each(function(i, row) {
	                var lastCurrentCell = last(row.cells);
	                cmd._insertCells(columns - Number(lastCurrentCell.getAttribute(COL_INDEX)) - lastCurrentCell.colSpan, row, cellIndex + 1);
	            });
	        }
	    },
	    _updateTableProperties: function(table, data){
	        var style = this._getStylesData(data);
	        dom.attr(table, {
	            cellSpacing: data.cellSpacing || null,
	            cellPadding: data.cellPadding || null,
	            className: data.className || null,
	            id: data.id || null,
	            summary: data.summary || null,
	            style: style || null
	        });
	        $(table).addClass("k-table");
	    },
	    _updateCellProperties: function(cell, data) {
	        var style = this._getStylesData(data);
	        style.padding = data.cellPadding || null;
	        style.margin = data.cellMargin || null;
	        dom.attr(cell, {
	            style: style || null,
	            className: data.className || null
	        });
	    },
	    _updateCaption: function(table, data){
	        if (table.caption && !data.captionContent) {
	            table.deleteCaption();
	        } else if (data.captionContent) {
	            var caption = table.createCaption();
	            caption.innerHTML = data.captionContent;
	            var alignment = this._getAlignmentData(data.captionAlignment);
	            dom.attr(caption, {
	                style: {
	                    textAlign: alignment.textAlign,
	                    verticalAlign: alignment.verticalAlign
	                }
	            });
	        }
	    },
	    _updateHeadersNoThead: function(table, data) {
	        var cmd = this;
	        var tableProp = data.tableProperties;
	        var rows = table.rows;
	        var row, cells, cell, i, j;

	        for(i = 0; i < rows.length; i++) {
	            row = rows[i];
	            cells = row.cells;

	            for(j = 0; j < cells.length; j++) {
	                cell = cells[j];
	                if(!cmd._isHeadingCell(cell) && (i < tableProp.headerRows || tableProp.headerColumns > cell.getAttribute(COL_INDEX))) {
	                    dom.changeTag(cell, TH, false);
	                } else if(cmd._isHeadingCell(cell) && i >= tableProp.headerRows && tableProp.headerColumns <= cell.getAttribute(COL_INDEX)) {
	                    dom.changeTag(cell, TD, false);
	                }
	            }
	        }
	    },
	    _updateHeadersWithThead: function(table, data) {
	        var cmd = this;
	        var tableProp = data.tableProperties;
	        var thead = table.tHead;
	        var rowIndex = 0;
	        var tbody = table.tBodies[0];
	        var row, cell, i;

	        if (!tbody) {
	            tbody = table.createTBody();
	        }

	        if(tableProp.headerRows && tableProp.headerRows > 0) {
	            if (!thead) {
	                thead = table.createTHead();
	            }

	            while(thead.rows.length < tableProp.headerRows) {
	                thead.appendChild(tbody.rows[0]);
	            }

	            while(thead.rows.length > tableProp.headerRows) {
	                tbody.appendChild(thead.rows[0]);
	            }

	            cmd._swapToHeaderCells(thead);
	        } else if(thead) {
	            while(thead.rows.length > 0) {
	                tbody.appendChild(thead.rows[thead.rows.length - 1]);
	            }

	            table.deleteTHead();
	        }

	        while(tbody.rows.length > rowIndex) {
	            row = tbody.rows[rowIndex];
	            for(i = 0; i < row.cells.length; i++) {
	                cell = row.cells[i];
	                if (cmd._isHeadingCell(cell) && tableProp.headerColumns <= cell.getAttribute(COL_INDEX)) {
	                    dom.changeTag(cell, TD, false);
	                } else if(!cmd._isHeadingCell(cell) && tableProp.headerColumns > cell.getAttribute(COL_INDEX)) {
	                    dom.changeTag(cell, TH, false);
	                }
	            }
	            rowIndex += 1;
	        }
	    },
	    _updateHeaderAssociates: function(table, tableProp) {
	        var cmd = this;

	        if (tableProp.cellsWithHeaders === "ids") {
	            if(!cmd.cellsWithHeadersAssociated(table)) {
	                cmd._removeScopes(table);
	            }
	            dom.associateWithIds(table);
	        } else if (tableProp.cellsWithHeaders === "scope") {
	            if(cmd.cellsWithHeadersAssociated(table)) {
	                cmd._removeAssociates(table);
	            }
	            cmd._addScopes(table, tableProp.headerRows, tableProp.headerColumns);
	        } else {
	            if(cmd.cellsWithHeadersAssociated(table)) {
	                cmd._removeAssociates(table);
	            } else {
	                cmd._removeScopes(table);
	            }
	        }
	    },
	    _addScopes: function(table, headerRows, headerCols) {
	        var rows = table.rows;
	        var i, j, row, cell;

	        for(i = 0; i < rows.length; i++) {
	            row = rows[i];

	            for(j = 0; j < row.cells.length; j++) {
	                cell = row.cells[j];

	                if (i < headerRows) {
	                    cell.setAttribute(SCOPE, COL);
	                } else if(cell.getAttribute(COL_INDEX) < headerCols) {
	                    cell.setAttribute(SCOPE, ROW);
	                }
	            }
	        }
	    },
	    _removeScopes: function(table) {
	        $(table).find(TH).removeAttr(SCOPE);
	        $(table).find(COL).remove();
	        $(table).find(COLGROUP).remove();
	    },
	    _removeAssociates: function(table) {
	        $(table).find("th, td").removeAttr("id headers");
	    },
	    _swapToHeaderCells: function(thead) {
	        var tds = $(thead).find("td");
	        var swapCell = function(index, cell) {
	            dom.changeTag(cell, TH, false);
	        };
	        tds.each(swapCell);
	    },
	    _getStylesData: function(data) {
	        var alignment = this._getAlignmentData(data.alignment);
	        var whiteSpace = "wrapText" in data ? (data.wrapText ? "" : "nowrap") : null;

	        return {
	            width: data.width ? data.width + data.widthUnit : null,
	            height: data.height ? data.height + data.heightUnit : null,
	            textAlign: alignment.textAlign,
	            verticalAlign: alignment.verticalAlign,
	            backgroundColor: data.bgColor || "",
	            borderWidth: data.borderWidth,
	            borderStyle: data.borderStyle,
	            borderColor: data.borderColor || "",
	            borderCollapse: data.collapseBorders ? "collapse" : null,
	            whiteSpace: whiteSpace
	        };
	    },
	    _getAlignmentData: function(alignment) {
	        var textAlign = "";
	        var verticalAlign = textAlign;

	        if (alignment) {
	            if (alignment.indexOf(" ") != -1) {
	                var align = alignment.split(" ");
	                textAlign = align[0];
	                verticalAlign = align[1];
	            } else {
	                textAlign = alignment;
	            }
	        }
	        return {textAlign: textAlign, verticalAlign: verticalAlign};
	    },
	    parseTable: function(table, selectedCells) {
	        if (!table) {
	            return { tableProperties: {}, selectedCells: [] };
	        }

	        var cmd = this;
	        var tStyle = table.style;
	        var rows = table.rows;
	        var caption = table.caption;
	        var captionClone = $(caption ? caption.cloneNode(true) : undefined);
	        captionClone.find(".k-marker").remove();

	        var cssClass = table.className;
	        cssClass = cssClass.replace(/^k-table\s|\sk-table$/, "");
	        cssClass = cssClass.replace(/\sk-table\s/, " ");
	        cssClass = cssClass.replace(/^k-table$/, "");

	        var tableAlignment = cmd._getAlignment(table, true);
	        var captionAlignment = caption ? cmd._getAlignment(caption) : undefined;
	        var numberOfHeaderRows = dom._getNumberOfHeaderRows(table);

	        var cellsWithHeaders;
	        if(cmd.cellsWithHeadersAssociated(table)) {
	            cellsWithHeaders = "ids";
	        } else if ($(table).find("th[scope]").length > 0) {
	            cellsWithHeaders = "scope";
	        } else {
	            cellsWithHeaders = "none";
	        }

	        dom.reMapTableColumns(table, COL_INDEX);
	        var numberOfColumns = dom._getNumberOfColumns(table);
	        var numberOfHeaderColumns = dom._getNumberOfHeaderColumns(table, numberOfHeaderRows);
	        dom.clearTableMappings(table, COL_INDEX);

	        var tableJson = {
	            tableProperties: {
	                width: tStyle.width || table.width ? parseFloat(tStyle.width || table.width) : null,
	                height: tStyle.height || table.height ? parseFloat(tStyle.height || table.height) : null,
	                columns: numberOfColumns,
	                rows: rows.length,
	                widthUnit: cmd._getUnit(tStyle.width),
	                heightUnit: cmd._getUnit(tStyle.height),
	                cellSpacing: table.cellSpacing,
	                cellPadding: table.cellPadding,
	                alignment: tableAlignment.textAlign,
	                bgColor: tStyle.backgroundColor || table.bgColor,
	                className: cssClass,
	                id: table.id,
	                borderWidth: tStyle.borderWidth || table.border,
	                borderColor: tStyle.borderColor,
	                borderStyle: tStyle.borderStyle || "",
	                collapseBorders: !!tStyle.borderCollapse,
	                summary: table.summary,
	                captionContent: caption ? captionClone.html() : "",
	                captionAlignment: caption && captionAlignment.textAlign ? captionAlignment.textAlign + " " + captionAlignment.verticalAlign : "",
	                headerRows: numberOfHeaderRows,
	                headerColumns: numberOfHeaderColumns,
	                cellsWithHeaders: cellsWithHeaders
	            },
	            selectedCells: []
	        };

	        tableJson.rows = cmd.parseTableRows(rows, selectedCells, tableJson);

	        return tableJson;
	    },
	    parseTableRows: function(rows, selectedCells, tableJson) {
	        var cmd = this;
	        var data = [], row, rowData, cells, cell, cellData;
	        for (var i = 0; i < rows.length; i++) {
	            row = rows[i];
	            rowData = {cells: []};
	            cells = row.cells;
	            data.push(rowData);
	            for (var j = 0; j < cells.length; j++) {
	                cell = cells[j];
	                cellData = cmd.parseCell(cell);
	                if ($.inArray(cell, selectedCells) != -1) {
	                    tableJson.selectedCells.push(cellData);
	                }
	                rowData.cells.push(cellData);
	            }
	        }
	        return data;
	    },
	    parseCell: function(cell) {
	        var cmd = this;
	        var cStyle = cell.style;
	        var alignment = cmd._getAlignment(cell);
	        alignment = alignment.textAlign ? alignment.textAlign + " " + alignment.verticalAlign : "";

	        var data = {
	            width: cStyle.width || cell.width ? parseFloat(cStyle.width || cell.width) : null,
	            height: cStyle.height || cell.height ? parseFloat(cStyle.height || cell.height) : null,
	            widthUnit: cmd._getUnit(cStyle.width),
	            heightUnit: cmd._getUnit(cStyle.height),
	            cellMargin: cStyle.margin,
	            cellPadding: cStyle.padding,
	            alignment: alignment,
	            bgColor: cStyle.backgroundColor || cell.bgColor,
	            className: cell.className,
	            id: cell.id,
	            borderWidth: cStyle.borderWidth || cell.border,
	            borderColor: cStyle.borderColor,
	            borderStyle: cStyle.borderStyle,
	            wrapText: cStyle.whiteSpace != "nowrap"
	        };

	        return data;
	    },
	    _getAlignment: function(element, horizontalOnly) {
	        var style = element.style;
	        var hAlign = style.textAlign || element.align || "";
	        if (horizontalOnly) {
	            return {textAlign: hAlign};
	        }
	        var vAlign = style.verticalAlign || element.vAlign || "";
	        if(hAlign && vAlign) {
	            return {textAlign: hAlign, verticalAlign: vAlign};
	        }
	        if(!hAlign && vAlign) {
	            return {textAlign: "left", verticalAlign: vAlign};
	        }
	        if(hAlign && !vAlign) {
	            return {textAlign: hAlign, verticalAlign: "top"};
	        }
	        return {textAlign: "", verticalAlign: ""};
	    },
	    _getUnit: function(value) {
	        var unit = (value || "").match(reUnit);
	        return unit ? unit[0] : "px";
	    },
	    _selectedTable: function(range) {
	        var nodes = dom.filterBy(RangeUtils.nodes(range), dom.htmlIndentSpace, true);
	        return tableFormatFinder.findSuitable(nodes)[0];
	    },
	    _selectedCells: function(range) {
	        var nodes = dom.filterBy(RangeUtils.nodes(range), dom.htmlIndentSpace, true);
	        return cellsFormatFinder.findSuitable(nodes);
	    },
	    _lastInCollection: function(collection) {
	        return collection[collection.length - 1];
	    }
	});

	var TableWizardTool = Editor.Tool.extend({
	    command: function (options) {
	        options.insertNewTable = this.options.insertNewTable;
	        return new TableWizardCommand(options);
	    }
	});

	var TableWizardEditTool = TableWizardTool.extend({
	    update: function(ui, nodes) {
	        var isFormatted = !tableFormatFinder.isFormatted(nodes);

	        if (isFormatted === true) {
	            ui.parent().addClass("k-hidden k-state-disabled");
	            ui.attr("disabled", "disabled");
	            ui.addClass("k-state-disabled");
	        } else {
	            ui.parent().removeClass("k-hidden k-state-disabled");
	            ui.removeAttr("disabled");
	            ui.removeClass("k-state-disabled");
	        }
	    }
	});

	kendo.ui.editor.TableWizardTool = TableWizardTool;
	kendo.ui.editor.TableWizardCommand = TableWizardCommand;

	registerTool("tableWizard", new TableWizardEditTool({ command: TableWizardCommand, insertNewTable: false, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Table Wizard"})}));

	})(window.kendo.jQuery);

	}, __webpack_require__(3));

/***/ }),

/***/ 1015:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("L414");

/***/ })

/******/ });

/***/ }),

/***/ "Bx8k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var main_2 = __webpack_require__("F6Mk");
var main_3 = __webpack_require__("F6Mk");
var LINE_SEPARATOR = '\r\n';
/**
 * See https://msdn.microsoft.com/en-us/library/aa140066(v=office.10).aspx
 */
var ExcelXmlFactory = (function () {
    function ExcelXmlFactory() {
    }
    ExcelXmlFactory.prototype.createExcelXml = function (styles, worksheets) {
        var documentProperties = this.documentProperties();
        var excelWorkbook = this.excelWorkbook();
        return this.excelXmlHeader() +
            this.xmlFactory.createXml(this.workbook(documentProperties, excelWorkbook, styles, worksheets), function (boolean) { return boolean ? "1" : "0"; });
    };
    ExcelXmlFactory.prototype.workbook = function (documentProperties, excelWorkbook, styles, worksheets) {
        var _this = this;
        var children = [
            documentProperties,
            excelWorkbook,
            this.stylesXmlElement(styles)
        ];
        main_3.Utils.map(worksheets, function (it) {
            return _this.worksheetXmlElement(it);
        }).forEach(function (it) {
            children.push(it);
        });
        return {
            name: "Workbook",
            properties: {
                prefixedAttributes: [{
                        prefix: "xmlns:",
                        map: {
                            o: "urn:schemas-microsoft-com:office:office",
                            x: "urn:schemas-microsoft-com:office:excel",
                            ss: "urn:schemas-microsoft-com:office:spreadsheet",
                            html: "http://www.w3.org/TR/REC-html40"
                        },
                    }],
                rawMap: {
                    xmlns: "urn:schemas-microsoft-com:office:spreadsheet"
                }
            },
            children: children
        };
    };
    ExcelXmlFactory.prototype.excelXmlHeader = function () {
        // need to take out the question mark, otherwise it bothers php when have < and ? beside each
        // other in a string, as php thinks it's a directive for php
        var QUESTION_MARK = '?';
        return '<' + QUESTION_MARK + 'xml version="1.0"' + QUESTION_MARK + '>' + LINE_SEPARATOR +
            '<' + QUESTION_MARK + 'mso-application progid="Excel.Sheet"' + QUESTION_MARK + '>' + LINE_SEPARATOR;
    };
    ExcelXmlFactory.prototype.stylesXmlElement = function (styles) {
        var _this = this;
        return {
            name: 'Styles',
            children: styles ? main_3.Utils.map(styles, function (it) {
                return _this.styleXmlElement(it);
            }) : []
        };
    };
    ExcelXmlFactory.prototype.styleXmlElement = function (style) {
        var borders = [];
        if (style.borders) {
            [
                style.borders.borderBottom,
                style.borders.borderLeft,
                style.borders.borderRight,
                style.borders.borderTop
            ].forEach(function (it, index) {
                var current = index == 0 ? "Bottom" : index == 1 ? "Left" : index == 2 ? "Right" : "Top";
                borders.push({
                    name: "Border",
                    properties: {
                        prefixedAttributes: [{
                                prefix: "ss:",
                                map: {
                                    Position: current,
                                    LineStyle: it.lineStyle,
                                    Weight: it.weight,
                                    Color: it.color
                                }
                            }]
                    }
                });
            });
        }
        var children = [];
        if (style.alignment) {
            children.push({
                name: "Alignment",
                properties: {
                    prefixedAttributes: [{
                            prefix: "ss:",
                            map: {
                                Vertical: style.alignment.vertical,
                                Horizontal: style.alignment.horizontal,
                                Indent: style.alignment.indent,
                                ReadingOrder: style.alignment.readingOrder,
                                Rotate: style.alignment.rotate,
                                ShrinkToFit: style.alignment.shrinkToFit,
                                VerticalText: style.alignment.verticalText,
                                WrapText: style.alignment.wrapText
                            }
                        }]
                }
            });
        }
        if (style.borders) {
            children.push({
                name: "Borders",
                children: borders
            });
        }
        if (style.font) {
            children.push({
                name: "Font",
                properties: {
                    prefixedAttributes: [{
                            prefix: "ss:",
                            map: {
                                Bold: style.font.bold,
                                FontName: style.font.fontName,
                                Italic: style.font.italic,
                                Color: style.font.color,
                                Outline: style.font.outline,
                                Shadow: style.font.shadow,
                                Size: style.font.size,
                                StrikeThrough: style.font.strikeThrough,
                                Underline: style.font.underline,
                                VerticalAlign: style.font.verticalAlign
                            }
                        }, {
                            prefix: "x:",
                            map: {
                                CharSet: style.font.charSet,
                                Family: style.font.family
                            }
                        }]
                }
            });
        }
        if (style.interior) {
            children.push({
                name: "Interior",
                properties: {
                    prefixedAttributes: [{
                            prefix: "ss:",
                            map: {
                                Color: style.interior.color,
                                Pattern: style.interior.pattern,
                                PatternColor: style.interior.patternColor
                            }
                        }]
                }
            });
        }
        if (style.protection) {
            children.push({
                name: "Protection",
                properties: {
                    prefixedAttributes: [{
                            prefix: "ss:",
                            map: {
                                Protected: style.protection.protected,
                                HideFormula: style.protection.hideFormula
                            }
                        }]
                }
            });
        }
        if (style.numberFormat) {
            children.push({
                name: "NumberFormat",
                properties: {
                    prefixedAttributes: [{
                            prefix: "ss:",
                            map: {
                                Format: style.numberFormat.format
                            }
                        }]
                }
            });
        }
        return {
            name: "Style",
            properties: {
                prefixedAttributes: [{
                        prefix: "ss:",
                        map: {
                            ID: style.id,
                            Name: (style.name) ? style.name : style.id
                        }
                    }]
            },
            children: children
        };
    };
    ExcelXmlFactory.prototype.worksheetXmlElement = function (worksheet) {
        var _this = this;
        var children = [];
        main_3.Utils.map(worksheet.table.columns, function (it) {
            return _this.columnXmlElement(it);
        }).forEach(function (it) {
            children.push(it);
        });
        main_3.Utils.map(worksheet.table.rows, function (it) {
            return _this.rowXmlElement(it);
        }).forEach(function (it) {
            children.push(it);
        });
        return {
            name: "Worksheet",
            children: [{
                    name: "Table",
                    children: children
                }],
            properties: {
                prefixedAttributes: [{
                        prefix: "ss:",
                        map: {
                            Name: worksheet.name
                        }
                    }]
            }
        };
    };
    ExcelXmlFactory.prototype.columnXmlElement = function (column) {
        return {
            name: "Column",
            properties: {
                prefixedAttributes: [{
                        prefix: "ss:",
                        map: {
                            Width: column.width
                        }
                    }]
            }
        };
    };
    ExcelXmlFactory.prototype.rowXmlElement = function (row) {
        var _this = this;
        return {
            name: "Row",
            children: main_3.Utils.map(row.cells, function (it) {
                return _this.rowCellXmlElement(it);
            })
        };
    };
    ExcelXmlFactory.prototype.rowCellXmlElement = function (cell) {
        var properties = {};
        if (cell.mergeAcross) {
            properties['MergeAcross'] = cell.mergeAcross;
        }
        if (cell.styleId) {
            properties['StyleID'] = cell.styleId;
        }
        return {
            name: "Cell",
            properties: {
                prefixedAttributes: [{
                        prefix: "ss:",
                        map: properties
                    }]
            },
            children: [{
                    name: "Data",
                    properties: {
                        prefixedAttributes: [{
                                prefix: "ss:",
                                map: {
                                    Type: cell.data.type
                                }
                            }]
                    },
                    textNode: cell.data.value
                }]
        };
    };
    ExcelXmlFactory.prototype.excelWorkbook = function () {
        return {
            name: "ExcelWorkbook",
            properties: {
                rawMap: {
                    xmlns: "urn:schemas-microsoft-com:office:excel"
                }
            },
            children: [{
                    name: "WindowHeight",
                    textNode: "8130"
                }, {
                    name: "WindowWidth",
                    textNode: "15135"
                }, {
                    name: "WindowHeight",
                    textNode: "8130"
                }, {
                    name: "WindowTopX",
                    textNode: "120"
                }, {
                    name: "WindowTopY",
                    textNode: "45"
                }, {
                    name: "ProtectStructure",
                    textNode: "False"
                }, {
                    name: "ProtectWindow",
                    textNode: "False"
                }]
        };
    };
    ExcelXmlFactory.prototype.documentProperties = function () {
        return {
            name: "DocumentProperties",
            properties: {
                rawMap: {
                    xmlns: "urn:schemas-microsoft-com:office:office"
                }
            },
            children: [{
                    name: "Version",
                    textNode: "12.00"
                }]
        };
    };
    __decorate([
        main_2.Autowired('xmlFactory'),
        __metadata("design:type", main_1.XmlFactory)
    ], ExcelXmlFactory.prototype, "xmlFactory", void 0);
    ExcelXmlFactory = __decorate([
        main_2.Bean('excelXmlFactory')
    ], ExcelXmlFactory);
    return ExcelXmlFactory;
}());
exports.ExcelXmlFactory = ExcelXmlFactory;


/***/ }),

/***/ "CF4A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
function simpleHttpRequest(params) {
    return new utils_1.Promise(function (resolve) {
        var httpRequest = new XMLHttpRequest();
        httpRequest.open('GET', params.url);
        httpRequest.send();
        httpRequest.onreadystatechange = function () {
            if (httpRequest.readyState == 4 && httpRequest.status == 200) {
                var httpResponse = JSON.parse(httpRequest.responseText);
                resolve(httpResponse);
            }
        };
    });
}
exports.simpleHttpRequest = simpleHttpRequest;


/***/ }),

/***/ "CG72":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1006);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 973:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2UxK");

/***/ }),

/***/ 1002:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lysN");

/***/ }),

/***/ 1003:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("NJlX");

/***/ }),

/***/ 1006:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(973), __webpack_require__(1002), __webpack_require__(1003)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function() {

	(function(kendo, undefined) {
	    var math = window.Math;
	    var abs = math.abs;

	    var $ = kendo.jQuery;
	    var extend = $.extend;

	    var Editor = kendo.ui.editor;
	    var TableElementResizing = Editor.TableElementResizing;
	    var ResizingUtils = Editor.ResizingUtils;
	    var getScrollBarWidth = ResizingUtils.getScrollBarWidth;
	    var constrain = ResizingUtils.constrain;
	    var calculatePercentageRatio = ResizingUtils.calculatePercentageRatio;
	    var inPercentages = ResizingUtils.inPercentages;
	    var toPercentages = ResizingUtils.toPercentages;
	    var toPixels = ResizingUtils.toPixels;
	    var outerHeight = kendo._outerHeight;

	    var NS = ".kendoEditorRowResizing";
	    var RESIZE_HANDLE_CLASS = "k-row-resize-handle";
	    var RESIZE_HANDLE_MARKER_WRAPPER_CLASS = "k-row-resize-marker-wrapper";
	    var RESIZE_MARKER_CLASS = "k-row-resize-marker";

	    var BODY = "body";
	    var TR = "tr";
	    var TBODY = "tbody";
	    var THEAD = "thead";

	    var COMMA = ",";
	    var HEIGHT = "height";

	    var RowResizing = TableElementResizing.extend({
	        options: {
	            tags: [TR],
	            min: 20,
	            rootElement: null,
	            eventNamespace: NS,
	            rtl: false,
	            handle: {
	                dataAttribute: "row",
	                width: 0,
	                height: 10,
	                classNames: {
	                    handle: RESIZE_HANDLE_CLASS,
	                    marker: RESIZE_MARKER_CLASS
	                },
	                template:
	                    '<div class="k-row-resize-handle-wrapper" unselectable="on" contenteditable="false">' +
	                        '<div class="' + RESIZE_HANDLE_CLASS + '">' +
	                            '<div class="' + RESIZE_HANDLE_MARKER_WRAPPER_CLASS + '">' +
	                                '<div class="' + RESIZE_MARKER_CLASS + '"></div>' +
	                            '</div>'+
	                        '</div>' +
	                    '</div>'
	            }
	        },

	        elementBorderHovered: function(tableElement, e) {
	            var that = this;
	            var handleHeight = that.options.handle[HEIGHT];
	            var borderOffset = tableElement.offset().top + outerHeight(tableElement);
	            var mousePosition = e.clientY + $(tableElement[0].ownerDocument).scrollTop();

	            if ((mousePosition > (borderOffset - handleHeight)) && (mousePosition < (borderOffset + handleHeight))) {
	                return true;
	            }
	            else {
	                return false;
	            }
	        },

	        setResizeHandlePosition: function(row) {
	            var that = this;
	            var options = that.options;
	            var handleHeight = options.handle[HEIGHT];
	            var rootElement = $(options.rootElement);
	            var scrollTopOffset = rootElement.is(BODY) ? 0 : rootElement.scrollTop();
	            var scrollLeftOffset = rootElement.is(BODY) ? 0 : kendo.scrollLeft(rootElement);
	            var scrollBarWidth = options.rtl ? getScrollBarWidth(rootElement[0]) : 0;

	            var rowOffsetLeft = row.offset().left -
	                                    (rootElement.offset().left + parseFloat(rootElement.css("borderLeftWidth"))) -
	                                    parseFloat(row.css("marginLeft"));
	            var rowOffsetTop = row.offset().top -
	                                    (rootElement.offset().top + parseFloat(rootElement.css("borderTopWidth"))) -
	                                    parseFloat(row.css("marginTop"));
	            var browser = kendo.support.browser;

	            if(options.rtl && (browser.mozilla || (browser.webkit && browser.version >= 85))) {
	                scrollLeftOffset = scrollLeftOffset * -1;
	            }

	            that.resizeHandle.css({
	                top: rowOffsetTop + outerHeight(row) + scrollTopOffset - (handleHeight / 2),
	                left: rowOffsetLeft + (scrollLeftOffset - scrollBarWidth),
	                position: "absolute"
	            });
	        },

	        setResizeHandleDimensions: function() {
	            var that = this;
	            var innerTableElement = $(that.element.tHead || that.element.tBodies[0]);

	            that.resizeHandle.css({
	                width: innerTableElement.width(),
	                height: that.options.handle[HEIGHT]
	            });
	        },

	        setResizeHandleDragPosition: function(e) {
	            var that = this;
	            var options = that.options;
	            var min = options.min;
	            var tableHead =  $(that.element).children(THEAD);
	            var tableBody =  $(that.element).children(TBODY);
	            var topInnerTableElement = tableHead.length > 0 ? tableHead : tableBody;
	            var resizeHandle = $(that.resizeHandle);
	            var row = $(e.currentTarget).data(options.handle.dataAttribute);
	            var $row = $(row);
	            var rootElement = $(options.rootElement);
	            var scrollTopOffset = rootElement.is(BODY) ? 0 : rootElement.scrollTop();
	            var tableTopOffset = topInnerTableElement.offset().top -
	                                    (rootElement.offset().top + parseFloat(rootElement.css("borderTopWidth"))) -
	                                    parseFloat(topInnerTableElement.css("marginTop"));

	            var rowOffsetTop = $row.offset().top -
	                                (rootElement.offset().top + parseFloat(rootElement.css("borderTopWidth"))) -
	                                parseFloat($row.css("marginTop"));

	            var resizeHandleOffsetTop = resizeHandle.offset().top -
	                                (Math.max(0 , rootElement.offset().top) + parseFloat(rootElement.css("borderTopWidth"))) -
	                                parseFloat(resizeHandle.css("marginTop"));

	            var handleOffset = constrain({
	                value: resizeHandleOffsetTop + scrollTopOffset + e.y.delta,
	                min: rowOffsetTop + scrollTopOffset + min,
	                max: tableTopOffset + outerHeight(tableHead) + outerHeight(tableBody) + scrollTopOffset - options.handle[HEIGHT] - min
	            });

	            resizeHandle.css({ top: handleOffset });
	        },

	        resize: function(e) {
	            var that = this;
	            var options = that.options;
	            var row = $(e.currentTarget).data(options.handle.dataAttribute);
	            var currentRowHeight = outerHeight($(row));
	            var element = $(that.element);
	            var initialTableHeight = outerHeight(element);
	            var tableHead = element.children(THEAD);
	            var tableHeadHeight = tableHead.length > 0 ? tableHead.height() : 0;
	            var tableBody = element.children(TBODY);
	            var tableBodyHeight = tableBody.height();
	            var initialStyleHeight = row.style[HEIGHT];
	            var newRowHeight = constrain({
	                value: currentRowHeight + e.y.initialDelta,
	                min: options.min,
	                max: abs(tableHeadHeight + tableBodyHeight - options.min)
	            });

	            that._setRowsHeightInPixels();
	            row.style[HEIGHT] = toPixels(newRowHeight);
	            that._setTableHeight(initialTableHeight + (newRowHeight - currentRowHeight));

	            if (inPercentages(initialStyleHeight)) {
	                //resize rows in percentages as late as possible to prevent incorrect precision calculations
	                that._setRowsHeightInPercentages();
	            }
	        },

	        _setRowsHeightInPixels: function() {
	            var that = this;
	            var rows = $(that.element).children(TBODY + COMMA + THEAD).children(TR);
	            var length = rows.length;
	            var currentRowsHeights = rows.map(function() {
	                return outerHeight($(this));
	            });
	            var i;

	            for (i = 0; i < length; i++) {
	                rows[i].style[HEIGHT] = toPixels(currentRowsHeights[i]);
	            }
	        },

	        _setRowsHeightInPercentages: function() {
	            var that = this;
	            var tableHead = $(that.element).children(THEAD);
	            var tableHeadHeight = tableHead.length > 0 ? tableHead.height() : 0;
	            var tableBody = $(that.element).children(TBODY);
	            var tableBodyHeight = tableBody.height();
	            var rows = $(that.element).children(THEAD + COMMA + TBODY).children(TR);
	            var length = rows.length;
	            var currentRowsHeights = rows.map(function() {
	                return outerHeight($(this));
	            });
	            var i;

	            for (i = 0; i < length; i++) {
	                rows[i].style[HEIGHT] = toPercentages(calculatePercentageRatio(currentRowsHeights[i], tableHeadHeight + tableBodyHeight));
	            }
	        },

	        _setTableHeight: function(newHeight) {
	            var element = this.element;

	            if (inPercentages(element.style[HEIGHT])) {
	                element.style[HEIGHT] = toPercentages(calculatePercentageRatio(newHeight, $(element).parent().height()));
	            }
	            else {
	                element.style[HEIGHT] = toPixels(newHeight);
	            }
	        }
	    });

	    RowResizing.create = function(editor) {
	        TableElementResizing.create(editor, {
	            name: "rowResizing",
	            type: RowResizing,
	            eventNamespace: NS
	        });
	    };

	    RowResizing.dispose = function(editor) {
	        TableElementResizing.dispose(editor, {
	            eventNamespace: NS
	        });
	    };

	    extend(Editor, {
	        RowResizing: RowResizing
	    });

	})(window.kendo);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "CHw0":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1278);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1278:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1109) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "groupable",
	    name: "Groupable",
	    category: "framework",
	    depends: [ "core", "draganddrop" ],
	    advanced: true
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        outerWidth = kendo._outerWidth,
	        kendoAttr = kendo.attr,
	        extend = $.extend,
	        each = $.each,
	        proxy = $.proxy,
	        isRtl = false,

	        DIR = "dir",
	        FIELD = "field",
	        TITLE = "title",
	        ASCENDING = "asc",
	        DESCENDING = "desc",
	        GROUP_SORT = "group-sort",
	        NS = ".kendoGroupable",
	        CHANGE = "change",
	        indicatorTmpl = kendo.template('<div class="k-group-indicator" data-#=data.ns#field="${data.field}" data-#=data.ns#title="${data.title || ""}" data-#=data.ns#dir="${data.dir || "asc"}">' +
	                '<a href="\\#" class="k-link">' +
	                    '<span class="k-icon k-i-sort-${(data.dir || "asc") == "asc" ? "asc-sm" : "desc-sm"}" title="(sorted ${(data.dir || "asc") == "asc" ? "ascending": "descending"})"></span>' +
	                    '${data.title ? data.title: data.field}' +
	                '</a>' +
	                '<a href="\\#" data-role="button" class="k-button k-button-icon k-flat">' +
	                    '<span class="k-icon k-i-close"></span>' +
	                '</a>' +
	             '</div>',  { useWithBlock:false }),
	        hint = function(target) {
	            var title = target.attr(kendo.attr("title"));
	            if (title) {
	                title = kendo.htmlEncode(title);
	            }

	            return $('<div class="k-header k-group-clue k-drag-clue" />')
	                .html(title || target.attr(kendo.attr("field")))
	                .prepend('<span class="k-icon k-drag-status k-i-cancel"></span>');
	        },
	        dropCue = $('<div class="k-grouping-dropclue"/>');

	    var Groupable = Widget.extend({
	        init: function(element, options) {
	            var that = this,
	                group = kendo.guid(),
	                intializePositions = proxy(that._intializePositions, that),
	                draggable,
	                horizontalCuePosition,
	                dropCuePositions = that._dropCuePositions = [];

	            Widget.fn.init.call(that, element, options);

	            isRtl = kendo.support.isRtl(element);
	            horizontalCuePosition = isRtl ? "right" : "left";

	            that.draggable = draggable = that.options.draggable || new kendo.ui.Draggable(that.element, {
	                filter: that.options.draggableElements,
	                hint: hint,
	                group: group
	            });

	            that.groupContainer = $(that.options.groupContainer, that.element)
	                .kendoDropTarget({
	                    group: draggable.options.group,
	                    dragenter: function(e) {
	                        if (that._canDrag(e.draggable.currentTarget)) {
	                            e.draggable.hint.find(".k-drag-status").removeClass("k-i-cancel").addClass("k-i-plus");
	                            dropCue.css(horizontalCuePosition, 0).appendTo(that.groupContainer);
	                        }
	                    },
	                    dragleave: function(e) {
	                        e.draggable.hint.find(".k-drag-status").removeClass("k-i-plus").addClass("k-i-cancel");
	                        dropCue.remove();
	                    },
	                    drop: function(e) {
	                        var targetElement = e.draggable.currentTarget,
	                            field = targetElement.attr(kendo.attr("field")),
	                            title = targetElement.attr(kendo.attr("title")),
	                            sourceIndicator = that.indicator(field),
	                            dropCuePositions = that._dropCuePositions,
	                            lastCuePosition = dropCuePositions[dropCuePositions.length - 1],
	                            position;
	                        var sortOptions = extend({}, that.options.sort, targetElement.data(GROUP_SORT));
	                        var dir = sortOptions.dir;

	                        if (!targetElement.hasClass("k-group-indicator") && !that._canDrag(targetElement)) {
	                            return;
	                        }
	                        if(lastCuePosition) {
	                            position = that._dropCuePosition(kendo.getOffset(dropCue).left + parseInt(lastCuePosition.element.css("marginLeft"), 10) * (isRtl ? -1 : 1) + parseInt(lastCuePosition.element.css("marginRight"), 10));
	                            if(position && that._canDrop($(sourceIndicator), position.element, position.left)) {
	                                if(position.before) {
	                                    position.element.before(sourceIndicator || that.buildIndicator(field, title, dir));
	                                } else {
	                                    position.element.after(sourceIndicator || that.buildIndicator(field, title, dir));
	                                }

	                                that._setIndicatorSortOptions(field, sortOptions);
	                                that._change();
	                            }
	                        } else {
	                            that.groupContainer.empty();
	                            that.groupContainer.append(that.buildIndicator(field, title, dir));
	                            that._setIndicatorSortOptions(field, sortOptions);
	                            that._change();
	                        }
	                    }
	                })
	                .kendoDraggable({
	                    filter: "div.k-group-indicator",
	                    hint: hint,
	                    group: draggable.options.group,
	                    dragcancel: proxy(that._dragCancel, that),
	                    dragstart: function(e) {
	                        var element = e.currentTarget,
	                            marginLeft = parseInt(element.css("marginLeft"), 10),
	                            elementPosition = element.position(),
	                            left = isRtl ? elementPosition.left - marginLeft : elementPosition.left + outerWidth(element);

	                        intializePositions();
	                        dropCue.css("left", left).appendTo(that.groupContainer);
	                        this.hint.find(".k-drag-status").removeClass("k-i-cancel").addClass("k-i-plus");
	                    },
	                    dragend: function() {
	                        that._dragEnd(this);
	                    },
	                    drag: proxy(that._drag, that)
	                })
	                .on("click" + NS, ".k-button", function(e) {
	                    e.preventDefault();
	                    that._removeIndicator($(this).parent());
	                })
	                .on("click" + NS,".k-link", function(e) {
	                    var indicator = $(this).parent();
	                    var newDir = indicator.attr(kendoAttr(DIR)) === ASCENDING ? DESCENDING : ASCENDING;

	                    indicator.attr(kendoAttr(DIR), newDir);
	                    that._change();
	                    e.preventDefault();
	                });

	            draggable.bind([ "dragend", "dragcancel", "dragstart", "drag" ],
	            {
	                dragend: function() {
	                    that._dragEnd(this);
	                },
	                dragcancel: proxy(that._dragCancel, that),
	                dragstart: function(e) {
	                    var element, marginRight, left;

	                    if (!that.options.allowDrag && !that._canDrag(e.currentTarget)) {
	                        e.preventDefault();
	                        return;
	                    }

	                    intializePositions();
	                    if(dropCuePositions.length) {
	                        element = dropCuePositions[dropCuePositions.length - 1].element;
	                        marginRight = parseInt(element.css("marginRight"), 10);
	                        left = element.position().left + outerWidth(element) + marginRight;
	                    } else {
	                        left = 0;
	                    }
	                },
	                drag: proxy(that._drag, that)
	            });

	            that.dataSource = that.options.dataSource;

	            if (that.dataSource && that._refreshHandler) {
	                that.dataSource.unbind(CHANGE, that._refreshHandler);
	            } else {
	                that._refreshHandler = proxy(that.refresh, that);
	            }

	            if(that.dataSource) {
	                that.dataSource.bind("change", that._refreshHandler);
	                that.refresh();
	            }
	        },

	        refresh: function() {
	            var that = this,
	                dataSource = that.dataSource;
	            var groups = dataSource.group() || [];
	            var fieldAttr = kendoAttr(FIELD);
	            var titleAttr = kendoAttr(TITLE);
	            var indicatorHtml;

	            if (that.groupContainer) {
	                that.groupContainer.empty();

	                each(groups, function(index, group) {
	                    var field = group.field;
	                    var dir =group.dir;
	                    var element = that.element
	                        .find(that.options.filter)
	                        .filter(function() {
	                            return $(this).attr(fieldAttr) === field;
	                        });

	                    indicatorHtml = that.buildIndicator(field, element.attr(titleAttr), dir);
	                    that.groupContainer.append(indicatorHtml);
	                    that._setIndicatorSortOptions(field, extend({}, that.options.sort, { dir: dir, compare: group.compare }));
	                });
	            }

	            that._invalidateGroupContainer();
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            that.groupContainer.off(NS);

	            if (that.groupContainer.data("kendoDropTarget")) {
	                that.groupContainer.data("kendoDropTarget").destroy();
	            }

	            if (that.groupContainer.data("kendoDraggable")) {
	                that.groupContainer.data("kendoDraggable").destroy();
	            }

	            if (!that.options.draggable) {
	                that.draggable.destroy();
	            }

	            if (that.dataSource && that._refreshHandler) {
	                that.dataSource.unbind("change", that._refreshHandler);
	                that._refreshHandler = null;
	            }

	            that.groupContainer = that.element = that.draggable = null;
	        },

	        events: ["change"],

	        options: {
	            name: "Groupable",
	            filter: "th",
	            draggableElements: "th",
	            messages: {
	                empty: "Drag a column header and drop it here to group by that column"
	            },
	            sort: {
	                dir: ASCENDING,
	                compare: null
	            }
	        },

	        indicator: function(field) {
	            var indicators = $(".k-group-indicator", this.groupContainer);
	            return $.grep(indicators, function (item)
	                {
	                    return $(item).attr(kendo.attr("field")) === field;
	                })[0];
	        },

	        buildIndicator: function(field, title, dir) {
	            var that = this;
	            var indicator = indicatorTmpl({
	                ns: kendo.ns,
	                field: field.replace(/"/g, "'"),
	                title: title,
	                dir: dir || (that.options.sort || {}).dir || ASCENDING
	            });

	            return indicator;
	        },

	        _setIndicatorSortOptions: function(field, options) {
	            var indicator = $(this.indicator(field));
	            indicator.data(GROUP_SORT, options);
	        },

	        aggregates: function() {
	            var that = this;
	            var names;
	            var idx;
	            var length;

	            return that.element.find(that.options.filter).map(function() {
	                var cell = $(this),
	                    aggregate = cell.attr(kendo.attr("aggregates")),
	                    member = cell.attr(kendo.attr("field"));

	                if (aggregate && aggregate !== "") {
	                    names = aggregate.split(",");
	                    aggregate = [];
	                    for (idx = 0, length = names.length; idx < length; idx++) {
	                        aggregate.push({ field: member, aggregate: names[idx] });
	                    }
	                }
	                return aggregate;
	            }).toArray();
	        },

	        descriptors: function() {
	            var that = this,
	                indicators = $(".k-group-indicator", that.groupContainer),
	                field,
	                aggregates = that.aggregates();

	            return $.map(indicators, function(item) {
	                item = $(item);
	                field = item.attr(kendo.attr("field"));
	                var sortOptions = that.options.sort || {};
	                var indicatorSortOptions = item.data(GROUP_SORT) || {};

	                return {
	                    field: field,
	                    dir: item.attr(kendo.attr("dir")),
	                    aggregates: aggregates || [],
	                    compare: indicatorSortOptions.compare || sortOptions.compare
	                };
	            });
	        },

	        _removeIndicator: function(indicator) {
	            var that = this;
	            indicator.off();
	            indicator.removeData();
	            indicator.remove();
	            that._invalidateGroupContainer();
	            that._change();
	        },

	        _change: function() {
	            var that = this;
	            if(that.dataSource) {
	                var descriptors = that.descriptors();
	                if (that.trigger("change", { groups: descriptors })) {
	                    that.refresh();
	                    return;
	                }
	                that.dataSource.group(descriptors);
	            }
	        },

	        _dropCuePosition: function(position) {
	            var dropCuePositions = this._dropCuePositions;
	            if(!dropCue.is(":visible") || dropCuePositions.length === 0) {
	                return;
	            }

	            position = Math.ceil(position);

	            var lastCuePosition = dropCuePositions[dropCuePositions.length - 1],
	                left = lastCuePosition.left,
	                right = lastCuePosition.right,
	                marginLeft = parseInt(lastCuePosition.element.css("marginLeft"), 10),
	                marginRight = parseInt(lastCuePosition.element.css("marginRight"), 10);

	            if(position >= right && !isRtl || position < left && isRtl) {
	                position = {
	                    left: lastCuePosition.element.position().left + (!isRtl ? outerWidth(lastCuePosition.element) + marginRight : - marginLeft),
	                    element: lastCuePosition.element,
	                    before: false
	                };
	            } else {
	                position = $.grep(dropCuePositions, function(item) {
	                    return (item.left <= position && position <= item.right) || (isRtl && position > item.right);
	                })[0];

	                if(position) {
	                    position = {
	                        left: isRtl ? position.element.position().left + outerWidth(position.element) + marginRight : position.element.position().left - marginLeft,
	                        element: position.element,
	                        before: true
	                    };
	                }
	            }

	            return position;
	        },
	        _drag: function(event) {
	            var position = this._dropCuePosition(event.x.location);

	            if (position) {
	                dropCue.css({ left: position.left, right: "auto" });
	            }
	        },
	        _canDrag: function(element) {
	            var field = element.attr(kendo.attr("field"));

	            return element.attr(kendo.attr("groupable")) != "false" &&
	                field &&
	                (element.hasClass("k-group-indicator") ||
	                    !this.indicator(field));
	        },
	        _canDrop: function(source, target, position) {
	            var next = source.next(),
	                result = source[0] !== target[0] && (!next[0] || target[0] !== next[0] || (!isRtl && position > next.position().left || isRtl && position < next.position().left));
	            return result;
	        },
	        _dragEnd: function(draggable) {
	            var that = this,
	                field = draggable.currentTarget.attr(kendo.attr("field")),
	                sourceIndicator = that.indicator(field);

	            if (draggable !== that.options.draggable && !draggable.dropped && sourceIndicator) {
	                that._removeIndicator($(sourceIndicator));
	            }

	            that._dragCancel();
	        },
	        _dragCancel: function() {
	            dropCue.remove();
	            this._dropCuePositions = [];
	        },
	        _intializePositions: function() {
	            var that = this,
	                indicators = $(".k-group-indicator", that.groupContainer),
	                left;

	            that._dropCuePositions = $.map(indicators, function(item) {
	                item = $(item);
	                left = kendo.getOffset(item).left;
	                return {
	                    left: parseInt(left, 10),
	                    right: parseInt(left + outerWidth(item), 10),
	                    element: item
	                };
	            });
	        },
	        _invalidateGroupContainer: function() {
	            var groupContainer = this.groupContainer;
	            if(groupContainer && groupContainer.is(":empty")) {
	                groupContainer.html(this.options.messages.empty);
	            }
	        }
	    });

	    kendo.ui.plugin(Groupable);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "CLcD":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1362);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "responsive-panel",
	    name: "Responsive Panel",
	    category: "web",
	    description: "The Responsive Panel widget allows a panel of content to be hidden on mobile devices, available through a toggle button.",
	    depends: [ "core" ]
	};

	(function ($, undefined) {
	    var proxy = $.proxy;
	    var NS = ".kendoResponsivePanel";
	    var OPEN = "open";
	    var CLOSE = "close";
	    var ACTIVATE_EVENTS = "click" + NS +" touchstart" + NS + " touchend" + NS;
	    var Widget = kendo.ui.Widget;
	    var ResponsivePanel = Widget.extend({
	        init: function(element, options) {
	            Widget.fn.init.call(this, element, options);

	            this._guid = "_" + kendo.guid();

	            this._toggleHandler = proxy(this._toggleButtonClick, this);
	            this._closeHandler = proxy(this._close, this);

	            $(document.documentElement).on(ACTIVATE_EVENTS, this.options.toggleButton, this._toggleHandler);

	            this._registerBreakpoint();

	            this.element
	                .addClass("k-rpanel k-rpanel-" + this.options.orientation + " " + this._guid);

	            this._resizeHandler = proxy(this.resize, this, true);
	            $(window).on("resize" + NS, this._resizeHandler);
	        },
	        _mediaQuery:
	            "@media (max-width: #= breakpoint-1 #px) {" +
	                ".#= guid #.k-rpanel-animate.k-rpanel-left," +
	                ".#= guid #.k-rpanel-animate.k-rpanel-right {" +
	                    "-webkit-transition: -webkit-transform .2s ease-out;" +
	                    "-ms-transition: -ms-transform .2s ease-out;" +
	                    "transition: transform .2s ease-out;" +
	                "} " +
	                ".#= guid #.k-rpanel-top {" +
	                    "overflow: hidden;" +
	                "}" +
	                ".#= guid #.k-rpanel-animate.k-rpanel-top {" +
	                    "-webkit-transition: max-height .2s linear;" +
	                    "-ms-transition: max-height .2s linear;" +
	                    "transition: max-height .2s linear;" +
	                "}" +
	            "} " +
	            "@media (min-width: #= breakpoint #px) {" +
	                "#= toggleButton # { display: none; } " +
	                ".#= guid #.k-rpanel-left { float: left; } " +
	                ".#= guid #.k-rpanel-right { float: right; } " +
	                ".#= guid #.k-rpanel-left, .#= guid #.k-rpanel-right {" +
	                    "position: relative;" +
	                    "-webkit-transform: translateX(0);" +
	                    "-ms-transform: translateX(0);" +
	                    "transform: translateX(0);" +
	                    "-webkit-transform: translateX(0) translateZ(0);" +
	                    "-ms-transform: translateX(0) translateZ(0);" +
	                    "transform: translateX(0) translateZ(0);" +
	                "} " +
	                ".k-ie9 .#= guid #.k-rpanel-left { left: 0; } " +
	                ".#= guid #.k-rpanel-top { max-height: none; }" +
	            "}",
	        _registerBreakpoint: function() {
	            var options = this.options;

	            this._registerStyle(kendo.template(this._mediaQuery)({
	                breakpoint: options.breakpoint,
	                toggleButton: options.toggleButton,
	                guid: this._guid
	            }));
	        },
	        _registerStyle: function(cssText) {
	            var head = $("head,body")[0];
	            var style = document.createElement('style');

	            head.appendChild(style);

	            if (style.styleSheet){
	                style.styleSheet.cssText = cssText;
	            } else {
	                style.appendChild(document.createTextNode(cssText));
	            }
	        },
	        options: {
	            name: "ResponsivePanel",
	            orientation: "left",
	            toggleButton: ".k-rpanel-toggle",
	            breakpoint: 640,
	            autoClose: true
	        },
	        events: [
	            OPEN,
	            CLOSE
	        ],
	        _resize: function() {
	            this.element.removeClass("k-rpanel-animate k-rpanel-expanded");

	            $(document.documentElement).off(ACTIVATE_EVENTS, this._closeHandler);
	        },
	        _toggleButtonClick: function(e) {
	            e.preventDefault();

	            if(e.type == "touchend") {
	                return;
	            }

	            if (this.element.hasClass("k-rpanel-expanded")) {
	                this.close();
	            } else {
	                this.open();
	            }
	        },
	        open: function() {
	            if (!this.trigger(OPEN)) {
	                this.element.addClass("k-rpanel-animate k-rpanel-expanded");

	                if (this.options.autoClose) {
	                    $(document.documentElement).on(ACTIVATE_EVENTS, this._closeHandler);
	                }
	            }
	        },
	        close: function() {
	            if (!this.trigger(CLOSE)) {
	                this.element.addClass("k-rpanel-animate").removeClass("k-rpanel-expanded");

	                $(document.documentElement).off(ACTIVATE_EVENTS, this._closeHandler);
	            }
	        },
	        _close: function(e) {
	            var prevented = e.isDefaultPrevented();
	            var container = $(e.target).closest(this.options.toggleButton + ",.k-rpanel");

	            if (!container.length && !prevented) {
	                this.close();
	            }
	        },
	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            $(window).off("resize" + NS, this._resizeHandler);
	            $(document.documentElement).off(ACTIVATE_EVENTS, this._closeHandler);
	        }
	    });

	    kendo.ui.plugin(ResponsivePanel);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "CLj3":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1599);
	module.exports = __webpack_require__(1599);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 953:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 956:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ed5Q");

/***/ }),

/***/ 1567:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("99zt");

/***/ }),

/***/ 1599:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20), __webpack_require__(953), __webpack_require__(956), __webpack_require__(1567), __webpack_require__(1600), __webpack_require__(1601) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	    (function(kendo) {
	        if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	            return;
	        }

	        var $ = kendo.jQuery;
	        var Widget = kendo.ui.Widget;
	        var classNames = {
	            details: "k-details",
	            button: "k-button",
	            detailsSummary: "k-details-summary",
	            detailsContent: "k-details-content",
	            icon: "k-icon",
	            iconCollapse: "k-i-arrow-45-down-right",
	            iconExpand: "k-i-arrow-60-right",
	            iconSearch: "k-i-zoom",
	            textbox: "k-textbox",
	            wrapper: "k-spreadsheet-filter-menu",
	            filterByCondition: "k-spreadsheet-condition-filter",
	            filterByValue: "k-spreadsheet-value-filter",
	            valuesTreeViewWrapper: "k-spreadsheet-value-treeview-wrapper",
	            actionButtons: "k-action-buttons"
	        };

	        kendo.spreadsheet.messages.filterMenu = {
	            all: "All",
	            sortAscending: "Sort range A to Z",
	            sortDescending: "Sort range Z to A",
	            filterByValue: "Filter by value",
	            filterByCondition: "Filter by condition",
	            apply: "Apply",
	            search: "Search",
	            addToCurrent: "Add to current selection",
	            clear: "Clear",
	            blanks: "(Blanks)",
	            operatorNone: "None",
	            and: "AND",
	            or: "OR",
	            operators: {
	                string: {
	                    contains: "Text contains",
	                    doesnotcontain: "Text does not contain",
	                    startswith: "Text starts with",
	                    endswith: "Text ends with",
	                    matches: "Text matches",
	                    doesnotmatch: "Text does not match"
	                },
	                date: {
	                    eq:  "Date is",
	                    neq: "Date is not",
	                    lt:  "Date is before",
	                    gt:  "Date is after"
	                },
	                number: {
	                    eq: "Is equal to",
	                    neq: "Is not equal to",
	                    gte: "Is greater than or equal to",
	                    gt: "Is greater than",
	                    lte: "Is less than or equal to",
	                    lt: "Is less than"
	                }
	            }
	        };

	        var Details = Widget.extend({
	            init: function(element, options) {
	                Widget.fn.init.call(this, element, options);

	                this.element.addClass(FilterMenu.classNames.details);

	                this._summary = this.element.find("." + FilterMenu.classNames.detailsSummary)
	                    .on("click", this._toggle.bind(this));

	                var iconClass = options.expanded ? FilterMenu.classNames.iconCollapse : FilterMenu.classNames.iconExpand;
	                this._icon = $("<span />", { "class": FilterMenu.classNames.icon + " " + iconClass })
	                    .prependTo(this._summary);

	                this._container = kendo.wrap(this._summary.next(), true);

	                if (!options.expanded) {
	                    this._container.hide();
	                }
	            },
	            options: {
	                name: "Details"
	            },
	            events: [ "toggle" ],
	            visible: function() {
	                return this.options.expanded;
	            },
	            toggle: function(show) {
	                var animation = kendo.fx(this._container).expand("vertical");

	                animation.stop()[show ? "reverse" : "play"]();

	                this._icon.toggleClass(FilterMenu.classNames.iconExpand, show)
	                          .toggleClass(FilterMenu.classNames.iconCollapse, !show);

	                this.options.expanded = !show;
	            },
	            _toggle: function() {
	                var show = this.visible();
	                this.toggle(show);
	                this.trigger("toggle", { show: show });
	            }
	        });

	        kendo.data.binders.spreadsheetFilterValue = kendo.data.Binder.extend({
	            init: function(element, bindings, options) {
	                kendo.data.Binder.fn.init.call(this, element, bindings, options);

	                this._change = $.proxy(this.change, this);
	                $(this.element).on("change", this._change);
	            },
	            refresh: function() {
	                var that = this,
	                    value = that.bindings.spreadsheetFilterValue.get(); //get the value from the View-Model

	                $(that.element).val(value instanceof Date ? "" : value);
	            },
	            change: function() {
	                var value = this.element.value;
	                this.bindings.spreadsheetFilterValue.set(value); //update the View-Model
	            }
	        });

	        kendo.data.binders.widget.spreadsheetFilterValue = kendo.data.Binder.extend({
	            init: function(widget, bindings, options) {
	                kendo.data.Binder.fn.init.call(this, widget.element[0], bindings, options);

	                this.widget = widget;
	                this._change = $.proxy(this.change, this);
	                this.widget.first("change", this._change);
	            },
	            refresh: function() {
	                var binding = this.bindings.spreadsheetFilterValue,
	                    value = binding.get(),
	                    type = $(this.widget.element).data("filterType");

	                if ((type === "date" && value instanceof Date) || (type === "number" && !isNaN(value))) {
	                    this.widget.value(value);
	                } else {
	                    this.widget.value(null);
	                }
	            },
	            change: function() {
	                var value = this.widget.value(),
	                    binding = this.bindings.spreadsheetFilterValue;

	                binding.set(value);
	            }
	        });

	        var templates = {
	            filterByValue:
	                "<div class='" + classNames.detailsSummary + "'>#= messages.filterByValue #</div>" +
	                "<div class='" + classNames.detailsContent + "'>" +
	                    "<div class='k-textbox k-space-right'>" +
	                        "<input placeholder='#= messages.search #' data-#=ns#bind='events: { input: filterValues }' />" +
	                        "<span class='k-icon k-i-zoom'></span>" +
	                    "</div>" +
	                    "<div data-#=ns#bind='visible: hasActiveSearch'><input class='k-checkbox' type='checkbox' data-#=ns#bind='checked: appendToSearch' id='_#=guid#'/><label class='k-checkbox-label' for='_#=guid#'>#= messages.addToCurrent #</label></div>" +
	                    "<div class='" + classNames.valuesTreeViewWrapper + "'>" +
	                        "<div data-#=ns#role='treeview' " +
	                            "data-#=ns#checkboxes='{ checkChildren: true }' "+
	                            "data-#=ns#bind='source: valuesDataSource, events: { check: valuesChange, select: valueSelect }' "+
	                            "></div>" +
	                    "</div>" +
	                "</div>",
	            filterByCondition:
	                "<div class='" + classNames.detailsSummary + "'>#= messages.filterByCondition #</div>" +
	                "<div class='" + classNames.detailsContent + "'>" +
	                    '<div>' +
	                        '<select ' +
	                            'data-#=ns#role="dropdownlist"' +
	                            'data-#=ns#bind="value: operator, source: operators, events: { change: operatorChange } "' +
	                            'data-value-primitive="false"' +
	                            'data-option-label="#=messages.operatorNone#"' +
	                            'data-height="auto"' +
	                            'data-text-field="text"' +
	                            'data-value-field="unique">'+
	                        '</select>'+
	                    '</div>' +

	                    '<div data-#=ns#bind="visible: isString">' +
	                        '<input data-filter-type="string" data-#=ns#bind="spreadsheetFilterValue: customFilter.criteria[0].value" class="k-textbox" />'+
	                    '</div>' +

	                    '<div data-#=ns#bind="visible: isNumber">' +
	                        '<input data-filter-type="number" data-#=ns#role="numerictextbox" data-#=ns#bind="spreadsheetFilterValue: customFilter.criteria[0].value" />'+
	                    '</div>' +

	                    '<div data-#=ns#bind="visible: isDate">' +
	                        '<input data-filter-type="date" data-#=ns#role="datepicker" data-#=ns#bind="spreadsheetFilterValue: customFilter.criteria[0].value" />'+
	                    '</div>' +
	                "</div>",
	            menuItem:
	                "<li data-command='#=command#' data-dir='#=dir#'>" +
	                    "<span class='k-icon k-i-#=iconClass#'></span>#=text#" +
	                "</li>",
	            actionButtons:
	                "<button data-#=ns#bind='click: apply' class='k-button k-primary'>#=messages.apply#</button>" +
	                "<button data-#=ns#bind='click: clear' class='k-button'>#=messages.clear#</button>"
	        };

	        function distinctValues(values) {
	            var hash = {};
	            var result = [];

	            for (var i = 0; i < values.length; i++) {
	                if (!hash[values[i].value]) {
	                    hash[values[i].value] = values[i];
	                    result.push(values[i]);
	                } else if (!hash[values[i].value].checked && values[i].checked) {
	                    hash[values[i].value].checked = true;
	                }
	            }

	            return result;
	        }

	        function filter(dataSource, query) {
	            var hasVisibleChildren = false;
	            var data = dataSource instanceof kendo.data.HierarchicalDataSource && dataSource.data();
	            var valuesFilter = this;
	            var values = this.values;
	            for (var i = 0; i < data.length; i++) {
	                var item = data[i];
	                var text = item.text.toString().toLocaleLowerCase(kendo.culture().name);
	                var itemVisible = query === true || query === "" || text.indexOf(query) >= 0;
	                var filterSpread = filter.bind(valuesFilter);
	                var anyVisibleChildren = filterSpread(item.children, query); // pass true if parent matches

	                hasVisibleChildren = hasVisibleChildren || anyVisibleChildren || itemVisible;
	                item.hidden = !itemVisible && !anyVisibleChildren;

	                if (query.length || (values && !values.length)) {
	                    item.checked = !item.hidden;
	                } else if (values && values.indexOf(item.text) != -1){
	                    item.checked = true;
	                }
	            }

	            if (data) {
	                // re-apply filter on children
	                dataSource.filter({ field: "hidden", operator: "neq", value: true });
	            }

	            return hasVisibleChildren;
	        }

	        function uncheckAll(dataSource) {
	            var data = dataSource instanceof kendo.data.HierarchicalDataSource && dataSource.data();

	            for (var i = 0; i < data.length; i++) {
	                var item = data[i];
	                item.checked = false;

	                if (item.hasChildren) {
	                    uncheckAll(item.children);
	                }
	            }
	        }

	        var FilterMenuViewModel = kendo.spreadsheet.FilterMenuViewModel = kendo.data.ObservableObject.extend({
	            valuesChange: function(e) {
	                var dataSource = e ? e.sender.dataSource : this.valuesDataSource;
	                var checked = function(item) {
	                    return item.checked;
	                };
	                var value = function(item) {
	                    return item.dataType === "date" ? kendo.spreadsheet.dateToNumber(item.value) : item.value;
	                };
	                var unique = function(value, index, array) {
	                    return array.lastIndexOf(value) === index;
	                };
	                var data = dataSource.data();
	                var values = data.toJSON()[0].items;
	                var blanks = values.filter(function(item) {
	                    return item.dataType === "blank";
	                });

	                blanks = blanks.length ? blanks[0].checked : false;
	                values = values.filter(checked).map(value);

	                if (this.appendToSearch && this.valueFilter && this.valueFilter.values.length) {
	                    values = values.concat(this.valueFilter.values.toJSON()).sort().filter(unique);
	                }

	                this.set("valueFilter", {
	                    values: values,
	                    blanks: blanks
	                });
	            },
	            valueSelect: function(e) {
	                e.preventDefault();

	                var node = e.sender.dataItem(e.node);
	                node.set("checked", !node.checked);
	            },
	            hasActiveSearch: false,
	            appendToSearch: false,
	            filterValues: function(e) {
	                var query = typeof e == "string" ? e : $(e.target).val().toLocaleLowerCase(kendo.culture().name);
	                var dataSource = this.valuesDataSource;

	                this.set("hasActiveSearch", !!query);

	                var filterSpread = filter.bind(this.valueFilter);
	                uncheckAll(dataSource);
	                filterSpread(dataSource, query);
	            },
	            reset: function() {
	                this.set("customFilter", { logic: "and", criteria: [ { operator: null, value: null } ] });
	                this.set("valueFilter", { values: [] });
	            },
	            operatorChange: function(e) {
	                var dataItem = e.sender.dataItem();
	                this.set("operatorType", dataItem.type);

	                // https://github.com/telerik/kendo-ui-core/issues/3317 - when switching from Value
	                // filter to “filter by condition”, the customFilter property is lost.
	                if (!this.get("customFilter")) {
	                    this.reset();
	                }

	                this.set("customFilter.criteria[0].operator", dataItem.value);
	            },
	            isNone: function() {
	                return this.get("operatorType") === undefined;
	            },
	            isString: function() {
	                return this.get("operatorType") === "string";
	            },
	            isNumber: function() {
	                return this.get("operatorType") === "number";
	            },
	            isDate: function() {
	                return this.get("operatorType") === "date";
	            }
	        });

	        function flattenOperators(operators) {
	            var messages = kendo.spreadsheet.messages.filterMenu.operators;
	            var result = [];
	            for (var type in operators) {
	                if (!operators.hasOwnProperty(type)) {
	                    continue;
	                }

	                for (var operator in operators[type]) {
	                    if (!operators[type].hasOwnProperty(operator)) {
	                        continue;
	                    }

	                    result.push({
	                        text: messages[type][operator],
	                        value: operator,
	                        unique: type + "_" + operator,
	                        type: type
	                    });
	                }
	            }
	            return result;
	        }

	        var FilterMenuController = kendo.spreadsheet.FilterMenuController = {
	            valuesTree: function(range, column) {
	                return [{
	                    text: kendo.spreadsheet.messages.filterMenu.all,
	                    expanded: true,
	                    checked: false,
	                    items: this.values(range.resize({ top: 1 }), column)
	                }];
	            },
	            values: function(range, column) {
	                var values = [];
	                var messages = kendo.spreadsheet.messages.filterMenu;
	                var columnRange = range.column(column);
	                var sheet = range.sheet();

	                columnRange.forEachCell(function(row, col, cell) {
	                    var checked = true;
	                    if (sheet.isHiddenRow(row)) {
	                        checked = false;
	                    }

	                    var value = cell.value;
	                    var dataType = cell.dataType;
	                    var text = cell.text;

	                    if (value === undefined) {
	                        dataType = "blank";
	                    } else if (cell.format) {
	                        dataType = kendo.spreadsheet.formatting.type(value, cell.format);
	                    } else {
	                        dataType = typeof value;
	                    }

	                    if (value !== null && cell.format) {
	                        text = kendo.spreadsheet.formatting.text(value, cell.format);
	                    } else {
	                        text = dataType == "blank" ? messages.blanks : value;
	                    }

	                    if (dataType === "percent" || dataType === "currency") { //treat percent as number
	                        dataType = "number";
	                    }

	                    if (dataType === "date") {
	                        value = kendo.spreadsheet.numberToDate(value);
	                    }

	                    values.push({
	                        dataType: dataType,
	                        value: value,
	                        text: text,
	                        checked: checked
	                    });
	                });

	                values = distinctValues(values);

	                values.sort(function(a, b) {
	                    if (a.dataType === b.dataType) {
	                        return 0;
	                    }

	                    if (a.dataType === "blank" || b.dataType === "blank") {
	                        return a.dataType === "blank" ? -1 : 1;
	                    }

	                    if (a.dataType === "number" || b.dataType === "number") {
	                        return a.dataType === "number" ? -1 : 1;
	                    }

	                    if (a.dataType === "date" || b.dataType === "date") {
	                        return a.dataType === "date" ? -1 : 1;
	                    }

	                    return 0;
	                });

	                return values;
	            },

	            filterType: function(range, column) {
	                // 1. try to infer type from current filter
	                var sheet = range.sheet();
	                var filter = this.filterForColumn(column, sheet);
	                var type;

	                filter = filter && filter.filter.toJSON();

	                if (filter && filter.filter == "custom") {
	                    var value = filter.criteria[0].value;

	                    if (value instanceof Date) {
	                        type = "date";
	                    } else if (typeof value == "string") {
	                        type = "string";
	                    } else if (typeof value == "number") {
	                        type = "number";
	                    }
	                }

	                if (!type) {
	                    // 2. try to infer type from column data
	                    var topValue = this.values(range.row(1), column)[0];
	                    type = topValue && topValue.dataType;

	                    if (type == "blank") {
	                        type = null;
	                    }
	                }

	                return type;
	            },

	            filterForColumn: function(column, sheet) {
	                var allFilters = sheet.filter();
	                var filters;

	                if (allFilters) {
	                    filters =  allFilters.columns.filter(function(item) {
	                        return item.index === column;
	                    })[0];
	                }

	                return filters;
	            },

	            filter: function(column, sheet) {
	                var columnFilters = this.filterForColumn(column, sheet);

	                if (!columnFilters) {
	                    return;
	                }

	                var options = columnFilters.filter.toJSON();
	                var type = options.filter;

	                delete options.filter;

	                var result = {
	                    type: type,
	                    options: options
	                };

	                var criteria = options.criteria;
	                if (criteria && criteria.length) {
	                    result.operator = criteria[0].operator;
	                }

	                return result;
	            }
	        };

	        var FilterMenu = Widget.extend({
	            init: function(element, options) {
	                Widget.call(this, element, options);

	                this.element.addClass(FilterMenu.classNames.wrapper);

	                this.viewModel = new FilterMenuViewModel({
	                    active: "value",
	                    operator: null,
	                    operators: flattenOperators(this.options.operators),
	                    clear: this.clear.bind(this),
	                    apply: this.apply.bind(this)
	                });

	                this._filterInit();
	                this._popup();
	                this._sort();
	                this._filterByCondition();
	                this._filterByValue();
	                this._actionButtons();
	            },

	            options: {
	                name: "FilterMenu",
	                column: 0,
	                range: null,
	                operators: {
	                    string: {
	                        contains: "Text contains",
	                        doesnotcontain: "Text does not contain",
	                        startswith: "Text starts with",
	                        endswith: "Text ends with",
	                        matches: "Text matches",
	                        doesnotmatch: "Text does not match"
	                    },
	                    date: {
	                        eq:  "Date is",
	                        neq: "Date is not",
	                        lt:  "Date is before",
	                        gt:  "Date is after"
	                    },
	                    number: {
	                        eq: "Is equal to",
	                        neq: "Is not equal to",
	                        gte: "Is greater than or equal to",
	                        gt: "Is greater than",
	                        lte: "Is less than or equal to",
	                        lt: "Is less than"
	                    }
	                }
	            },

	            events: [
	                "action"
	            ],

	            destroy: function() {
	                Widget.fn.destroy.call(this);

	                this.menu.destroy();
	                this.valuesTreeView.destroy();
	                this.popup.destroy();
	            },

	            openFor: function(anchor) {
	                this.popup.setOptions({ anchor: anchor });
	                this.popup.open();
	            },

	            close: function() {
	                this.popup.close();
	            },

	            clear: function() {
	                this.action({
	                    command: "ClearFilterCommand",
	                    options: {
	                        column: this.options.column
	                    }
	                });
	                this.viewModel.reset();
	                this.close();
	            },

	            apply: function() {
	                this._active();

	                var options = {
	                    operatingRange: this.options.range,
	                    column: this.options.column
	                };

	                var valueFilter;
	                var customFilter;

	                if (this.viewModel.active === "value") {
	                    this.viewModel.valuesChange({ sender: this.valuesTreeView });
	                    valueFilter = this.viewModel.valueFilter.toJSON();

	                    if (valueFilter.blanks || (valueFilter.values && valueFilter.values.length)) {
	                        options.valueFilter = valueFilter;
	                    }
	                } else if (this.viewModel.active === "custom") {
	                    customFilter = this.viewModel.customFilter.toJSON();

	                    if (customFilter.criteria.length && customFilter.criteria[0].value !== null) {
	                        options.customFilter = customFilter;
	                    }
	                }

	                if (options.valueFilter || options.customFilter) {
	                    this.action({ command: "ApplyFilterCommand", options: options });
	                }
	            },

	            action: function(options) {
	                this.trigger("action", $.extend({ }, options));
	            },

	            _filterInit: function() {
	                var column = this.options.column;
	                var range = this.options.range;
	                var sheet = range.sheet();
	                var activeFilter = FilterMenuController.filter(column, sheet);

	                if (activeFilter) {
	                    var filterType = FilterMenuController.filterType(range, column);

	                    this.viewModel.set("active", activeFilter.type);
	                    this.viewModel.set(activeFilter.type + "Filter", activeFilter.options);

	                    if (activeFilter.type == "custom") {
	                        this.viewModel.set("operator", filterType + "_" + activeFilter.operator);
	                        this.viewModel.set("operatorType", filterType);
	                    }
	                } else {
	                    this.viewModel.reset();
	                }
	            },

	            _popup: function() {
	                this.popup = this.element.kendoPopup({
	                    copyAnchorStyles: false
	                }).data("kendoPopup");
	            },

	            _sort: function() {
	                var template = kendo.template(FilterMenu.templates.menuItem);
	                var messages = kendo.spreadsheet.messages.filterMenu;
	                var items = [
	                    { command: "sort", dir: "asc", text: messages.sortAscending, iconClass: "sort-asc" },
	                    { command: "sort", dir: "desc", text: messages.sortDescending, iconClass: "sort-desc" }
	                ];

	                var ul = $("<ul></ul>", {
	                    "html": kendo.render(template, items)
	                }).appendTo(this.element);

	                this.menu = ul.kendoMenu({
	                    orientation: "vertical",
	                    select: function(e) {
	                        var dir = $(e.item).data("dir");
	                        var range = this.options.range.resize({ top: 1 });
	                        var options = {
	                            value: dir,
	                            sheet: false,
	                            operatingRange: range,
	                            column: this.options.column
	                        };

	                        this.action({ command: "SortCommand", options: options });
	                    }.bind(this)
	                }).data("kendoMenu");
	            },

	            _appendTemplate: function(template, className, details, expanded) {
	                var compiledTemplate = kendo.template(template);
	                var wrapper = $("<div class='" + className + "'/>").html(compiledTemplate({
	                    messages: kendo.spreadsheet.messages.filterMenu,
	                    guid: kendo.guid(),
	                    ns: kendo.ns
	                }));

	                this.element.append(wrapper);

	                if (details) {
	                    details = new Details(wrapper, { expanded: expanded, toggle: this._detailToggle.bind(this) }); // jshint ignore:line
	                }

	                kendo.bind(wrapper, this.viewModel);

	                return wrapper;
	            },

	            _detailToggle: function(e) {
	                this.element
	                    .find("[data-role=details]")
	                    .not(e.sender.element)
	                    .data("kendoDetails")
	                    .toggle(!e.show);
	            },

	            _filterByCondition: function() {
	                var isExpanded = this.viewModel.active === "custom";
	                this._appendTemplate(FilterMenu.templates.filterByCondition, FilterMenu.classNames.filterByCondition, true, isExpanded);
	            },

	            _filterByValue: function() {
	                var isExpanded = this.viewModel.active === "value";
	                var wrapper = this._appendTemplate(FilterMenu.templates.filterByValue, FilterMenu.classNames.filterByValue, true, isExpanded);

	                this.valuesTreeView = wrapper.find("[data-role=treeview]").data("kendoTreeView");

	                var values = FilterMenuController.valuesTree(this.options.range, this.options.column);

	                this.viewModel.set("valuesDataSource", new kendo.data.HierarchicalDataSource({ data: values, accentFoldingFiltering: kendo.culture().name }));
	            },

	            _actionButtons: function() {
	                this._appendTemplate(FilterMenu.templates.actionButtons, FilterMenu.classNames.actionButtons, false);
	            },

	            _active: function() {
	                var activeContainer = this.element.find("[data-role=details]").filter(function(index, element) {
	                    return $(element).data("kendoDetails").visible();
	                });

	                if (activeContainer.hasClass(FilterMenu.classNames.filterByValue)) {
	                    this.viewModel.set("active", "value");
	                } else if (activeContainer.hasClass(FilterMenu.classNames.filterByCondition)) {
	                    this.viewModel.set("active", "custom");
	                }
	            }
	        });

	        kendo.spreadsheet.FilterMenu = FilterMenu;
	        $.extend(true, FilterMenu, { classNames: classNames, templates: templates });

	    })(window.kendo);
	}, __webpack_require__(3));


/***/ }),

/***/ 1600:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("zQRd");

/***/ }),

/***/ 1601:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("EDhZ");

/***/ })

/******/ });

/***/ }),

/***/ "CN4P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ag_grid_1 = __webpack_require__("F6Mk");
var MenuItemComponent = (function (_super) {
    __extends(MenuItemComponent, _super);
    function MenuItemComponent(params) {
        var _this = _super.call(this, MenuItemComponent.TEMPLATE) || this;
        _this.params = params;
        return _this;
    }
    MenuItemComponent.prototype.init = function () {
        var _this = this;
        if (this.params.checked) {
            this.queryForHtmlElement('#eIcon').innerHTML = '<span class="ag-icon ag-icon-tick"></span>';
        }
        else if (this.params.icon) {
            if (ag_grid_1.Utils.isNodeOrElement(this.params.icon)) {
                this.queryForHtmlElement('#eIcon').appendChild(this.params.icon);
            }
            else if (typeof this.params.icon === 'string') {
                this.queryForHtmlElement('#eIcon').innerHTML = this.params.icon;
            }
            else {
                console.log('ag-Grid: menu item icon must be DOM node or string');
            }
        }
        else {
            // if i didn't put space here, the alignment was messed up, probably
            // fixable with CSS but i was spending to much time trying to figure
            // it out.
            this.queryForHtmlElement('#eIcon').innerHTML = '&nbsp;';
        }
        if (this.params.tooltip) {
            this.getGui().setAttribute('title', this.params.tooltip);
        }
        if (this.params.shortcut) {
            this.queryForHtmlElement('#eShortcut').innerHTML = this.params.shortcut;
        }
        if (this.params.subMenu) {
            if (this.gridOptionsWrapper.isEnableRtl()) {
                // for RTL, we show arrow going left
                this.queryForHtmlElement('#ePopupPointer').classList.add('ag-icon-small-left');
            }
            else {
                // for normal, we show arrow going right
                this.queryForHtmlElement('#ePopupPointer').classList.add('ag-icon-small-right');
            }
        }
        else {
            this.queryForHtmlElement('#ePopupPointer').innerHTML = '&nbsp;';
        }
        this.queryForHtmlElement('#eName').innerHTML = this.params.name;
        if (this.params.disabled) {
            ag_grid_1.Utils.addCssClass(this.getGui(), 'ag-menu-option-disabled');
        }
        else {
            this.addGuiEventListener('click', this.onOptionSelected.bind(this));
        }
        if (this.params.cssClasses) {
            this.params.cssClasses.forEach(function (it) { return ag_grid_1.Utils.addCssClass(_this.getGui(), it); });
        }
    };
    MenuItemComponent.prototype.onOptionSelected = function (mouseEvent) {
        var event = {
            type: MenuItemComponent.EVENT_ITEM_SELECTED,
            action: this.params.action,
            checked: this.params.checked,
            cssClasses: this.params.cssClasses,
            disabled: this.params.disabled,
            icon: this.params.icon,
            name: this.params.name,
            shortcut: this.params.shortcut,
            subMenu: this.params.subMenu,
            tooltip: this.params.tooltip,
            mouseEvent: mouseEvent
        };
        this.dispatchEvent(event);
        if (this.params.action) {
            this.params.action();
        }
    };
    MenuItemComponent.prototype.destroy = function () {
        // console.log('MenuItemComponent->destroy() ' + this.instance);
        _super.prototype.destroy.call(this);
    };
    // private instance = Math.random();
    MenuItemComponent.TEMPLATE = '<div class="ag-menu-option">' +
        '  <span id="eIcon" class="ag-menu-option-icon"></span>' +
        '  <span id="eName" class="ag-menu-option-text"></span>' +
        '  <span id="eShortcut" class="ag-menu-option-shortcut"></span>' +
        '  <span id="ePopupPointer" class="ag-menu-option-popup-pointer"></span>' +
        '</div>';
    MenuItemComponent.EVENT_ITEM_SELECTED = 'itemSelected';
    __decorate([
        ag_grid_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", ag_grid_1.GridOptionsWrapper)
    ], MenuItemComponent.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        ag_grid_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MenuItemComponent.prototype, "init", null);
    return MenuItemComponent;
}(ag_grid_1.Component));
exports.MenuItemComponent = MenuItemComponent;


/***/ }),

/***/ "CQB/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    methods: {
        resolveInnerTags: function resolveInnerTags(tagName) {
            var items = [];
            var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = defaultSlot[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var childSlot = _step.value;

                    if (childSlot.tag && childSlot.tag.indexOf(tagName) !== -1 || childSlot.type && childSlot.type.name && childSlot.type.name.toLowerCase().indexOf(tagName) !== -1) {
                        var childOptions = childSlot.componentOptions;
                        var childInstance = this.v3 ? childSlot : childSlot.componentInstance;
                        var item = this.v3 ? childInstance.$props || childInstance.props : childOptions.propsData;

                        if (this.v3) {
                            var itemKeys = Object.keys(item);
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;

                            try {
                                for (var _iterator2 = itemKeys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    var propKey = _step2.value;

                                    if (propKey.indexOf('-') !== -1) {
                                        item[this.camelize(propKey)] = item[propKey];
                                    }
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                        _iterator2.return();
                                    }
                                } finally {
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        }

                        if (!item.items) {
                            item.items = childInstance.subitems;
                        }

                        items.push(item);
                        this.handleWatcher(childInstance);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return items;
        },
        handleWatcher: function handleWatcher(childInstance) {
            var that = this;

            if (!childInstance._isWatchAttached && childInstance.$watch) {
                childInstance.$watch('$props', function () {
                    if (that.updateWidget) {
                        that.updateWidget();
                    } else if (that._resolveInnerChildren) {
                        that._resolveInnerChildren();
                    }
                }, { deep: true });

                childInstance._isWatchAttached = true;
            }
        },
        camelize: function camelize(str) {
            var arr = str.split('-');
            var capital = arr.map(function (item, index) {
                return index ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() : item;
            });
            var capitalString = capital.join('');

            return capitalString;
        }
    }
};

/***/ }),

/***/ "CRfZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1183);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1068:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("S/9S");

/***/ }),

/***/ 1069:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("jBxA");

/***/ }),

/***/ 1070:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("bFti");

/***/ }),

/***/ 1183:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1068), __webpack_require__(1069), __webpack_require__(1070) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "dropdownlist",
	    name: "DropDownList",
	    category: "web",
	    description: "The DropDownList widget displays a list of values and allows the selection of a single value from the list.",
	    depends: [ "list" ],
	    features: [ {
	        id: "mobile-scroller",
	        name: "Mobile scroller",
	        description: "Support for kinetic scrolling in mobile device",
	        depends: [ "mobile.scroller" ]
	    }, {
	        id: "virtualization",
	        name: "VirtualList",
	        description: "Support for virtualization",
	        depends: [ "virtuallist" ]
	    } ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        List = ui.List,
	        Select = ui.Select,
	        support = kendo.support,
	        activeElement = kendo._activeElement,
	        ObservableObject = kendo.data.ObservableObject,
	        keys = kendo.keys,
	        ns = ".kendoDropDownList",
	        nsFocusEvent = ns + "FocusEvent",
	        DISABLED = "disabled",
	        READONLY = "readonly",
	        CHANGE = "change",
	        FOCUSED = "k-state-focused",
	        DEFAULT = "k-state-default",
	        STATEDISABLED = "k-state-disabled",
	        ARIA_DISABLED = "aria-disabled",
	        ARIA_READONLY = "aria-readonly",
	        CLICKEVENTS = "click" + ns + " touchend" + ns,
	        HOVEREVENTS = "mouseenter" + ns + " mouseleave" + ns,
	        TABINDEX = "tabindex",
	        STATE_FILTER = "filter",
	        STATE_ACCEPT = "accept",
	        MSG_INVALID_OPTION_LABEL = "The `optionLabel` option is not valid due to missing fields. Define a custom optionLabel as shown here http://docs.telerik.com/kendo-ui/api/javascript/ui/dropdownlist#configuration-optionLabel",
	        proxy = $.proxy;

	    var DropDownList = Select.extend( {
	        init: function(element, options) {
	            var that = this;
	            var index = options && options.index;
	            var optionLabel, text, disabled;

	            that.ns = ns;
	            options = $.isArray(options) ? { dataSource: options } : options;

	            Select.fn.init.call(that, element, options);

	            options = that.options;
	            element = that.element.on("focus" + ns, proxy(that._focusHandler, that));

	            that._focusInputHandler = $.proxy(that._focusInput, that);

	            that.optionLabel = $();
	            that._optionLabel();

	            that._inputTemplate();

	            that._reset();

	            that._prev = "";
	            that._word = "";

	            that._wrapper();

	            that._tabindex();
	            that.wrapper.data(TABINDEX, that.wrapper.attr(TABINDEX));

	            that._span();

	            that._popup();

	            that._mobile();

	            that._dataSource();

	            that._ignoreCase();

	            that._filterHeader();

	            that._aria();

	            //should read changed value of closed dropdownlist
	            that.wrapper.attr("aria-live", "polite");

	            that._enable();

	            that._attachFocusHandlers();

	            that._oldIndex = that.selectedIndex = -1;

	            if (index !== undefined) {
	                options.index = index;
	            }

	            that._initialIndex = options.index;

	            that.requireValueMapper(that.options);
	            that._initList();
	            that.listView.one("dataBound", proxy(that._attachAriaActiveDescendant, that));

	            that._cascade();

	            that.one("set", function(e) {
	                if (!e.sender.listView.bound() && that.hasOptionLabel()) {
	                    that._textAccessor(that._optionLabelText());
	                }
	            });

	            if (options.autoBind) {
	                that.dataSource.fetch();
	            } else if (that.selectedIndex === -1) { //selectedIndex !== -1 when cascade functionality happens instantly
	                text = options.text || "";
	                if (!text) {
	                    optionLabel = options.optionLabel;

	                    if (optionLabel && options.index === 0) {
	                        text = optionLabel;
	                    } else if (that._isSelect) {
	                        text = element.children(":selected").text();
	                    }
	                }

	                that._textAccessor(text);
	            }

	            disabled = $(that.element).parents("fieldset").is(':disabled');

	            if (disabled) {
	                that.enable(false);
	            }

	            that.listView.bind("click", function(e) { e.preventDefault(); });

	            kendo.notify(that);
	        },

	        options: {
	            name: "DropDownList",
	            enabled: true,
	            autoBind: true,
	            index: 0,
	            text: null,
	            value: null,
	            delay: 500,
	            height: 200,
	            dataTextField: "",
	            dataValueField: "",
	            optionLabel: "",
	            cascadeFrom: "",
	            cascadeFromField: "",
	            cascadeFromParentField: "",
	            ignoreCase: true,
	            animation: {},
	            filter: "none",
	            minLength: 1,
	            enforceMinLength: false,
	            virtual: false,
	            template: null,
	            valueTemplate: null,
	            optionLabelTemplate: null,
	            groupTemplate: "#:data#",
	            fixedGroupTemplate: "#:data#",
	            autoWidth: false,
	            popup: null
	        },

	        events: [
	            "open",
	            "close",
	            CHANGE,
	            "select",
	            "filtering",
	            "dataBinding",
	            "dataBound",
	            "cascade",
	            "set",
	            "kendoKeydown"
	        ],

	        setOptions: function(options) {
	            Select.fn.setOptions.call(this, options);

	            this.listView.setOptions(this._listOptions(options));

	            this._optionLabel();
	            this._inputTemplate();
	            this._accessors();
	            this._filterHeader();
	            this._enable();
	            this._aria();

	            if (!this.value() && this.hasOptionLabel()) {
	                this.select(0);
	            }
	        },

	        destroy: function() {
	            var that = this;

	            Select.fn.destroy.call(that);

	            that.wrapper.off(ns);
	            that.wrapper.off(nsFocusEvent);
	            that.element.off(ns);
	            that._inputWrapper.off(ns);

	            that._arrow.off();
	            that._arrow = null;
	            that._arrowIcon = null;

	            that.optionLabel.off();

	            if(that.filterInput){
	                that.filterInput.off(nsFocusEvent);
	            }
	        },

	        open: function() {
	            var that = this;
	            var isFiltered = that.dataSource.filter() ? that.dataSource.filter().filters.length > 0 : false;
	            var listView = this.listView;

	            if (that.popup.visible()) {
	                return;
	            }

	            if (!that.listView.bound() || that._state === STATE_ACCEPT) {
	                that._open = true;
	                that._state = "rebind";

	                if (that.filterInput) {
	                    that.filterInput.val("");
	                    that._prev = "";
	                }

	                if (that.filterInput && that.options.minLength !== 1 && !isFiltered) {
	                    that.refresh();
	                    that.popup.one("activate", that._focusInputHandler);
	                    that.wrapper.attr("aria-activedescendant", listView._optionID);
	                    that.popup.open();
	                    that._resizeFilterInput();
	                } else {
	                    that._filterSource();
	                }
	            } else if (that._allowOpening()) {
	                that._focusFilter = true;
	                that.popup.one("activate", that._focusInputHandler);
	                // In some cases when the popup is opened resize is triggered which will cause it to close
	                // Setting the below flag will prevent this from happening
	                that.popup._hovered = true;
	                that.wrapper.attr("aria-activedescendant", listView._optionID);
	                that.popup.open();
	                that._resizeFilterInput();
	                that._focusItem();
	            }
	        },

	        close: function() {
	            this._attachAriaActiveDescendant();
	            this.popup.close();
	        },

	        _attachAriaActiveDescendant: function() {
	            var wrapper = this.wrapper,
	                inputId = wrapper.find(".k-input").attr('id');

	            wrapper.attr("aria-activedescendant", inputId);
	        },

	        _focusInput: function () {
	            this._focusElement(this.filterInput);
	        },

	        _resizeFilterInput: function () {
	            var filterInput = this.filterInput;
	            var originalPrevent = this._prevent;

	            if (!filterInput) {
	                return;
	            }

	            var isInputActive = this.filterInput[0] === activeElement();
	            var caret = kendo.caret(this.filterInput[0])[0];

	            this._prevent = true;

	            filterInput.css("display", "none")
	                       .css("width", this.popup.element.css("width"))
	                       .css("display", "inline-block");

	            if (isInputActive) {
	                filterInput.focus();
	                kendo.caret(filterInput[0], caret);
	            }

	            this._prevent = originalPrevent;
	        },

	        _allowOpening: function() {
	            return this.hasOptionLabel() || this.filterInput || Select.fn._allowOpening.call(this);
	        },

	        toggle: function(toggle) {
	            this._toggle(toggle, true);
	        },

	        current: function(candidate) {
	            var current;

	            if (candidate === undefined) {
	                current = this.listView.focus();

	                if (!current && this.selectedIndex === 0 && this.hasOptionLabel()) {
	                    return this.optionLabel;
	                }

	                return current;
	            }

	            this._focus(candidate);
	        },

	        dataItem: function(index) {
	            var that = this;
	            var dataItem = null;

	            if (index === null) { return index; }

	            if (index === undefined) {
	                dataItem = that.listView.selectedDataItems()[0];
	            } else {
	                if (typeof index !== "number") {
	                    if (that.options.virtual) {
	                        return that.dataSource.getByUid($(index).data("uid"));
	                    }
	                    if (index.hasClass("k-list-optionlabel")) {
	                        index = -1;
	                    } else {
	                        index = $(that.items()).index(index);
	                    }
	                } else if (that.hasOptionLabel()) {
	                    index -= 1;
	                }

	                dataItem = that.dataSource.flatView()[index];
	            }

	            if (!dataItem) {
	                dataItem = that._optionLabelDataItem();
	            }

	            return dataItem;
	        },

	        refresh: function() {
	            this.listView.refresh();
	        },

	        text: function (text) {
	            var that = this;
	            var loweredText;
	            var ignoreCase = that.options.ignoreCase;

	            text = text === null ? "" : text;

	            if (text !== undefined) {
	                if (typeof text !== "string") {
	                    that._textAccessor(text);
	                    return;
	                }

	                loweredText = ignoreCase ? text.toLowerCase() : text;

	                that._select(function(data) {
	                    data = that._text(data);

	                    if (ignoreCase) {
	                        data = (data + "").toLowerCase();
	                    }

	                    return data === loweredText;
	                }).done(function() {
	                    that._textAccessor(that.dataItem() || text);
	                });

	            } else {
	                return that._textAccessor();
	            }
	        },

	        _clearFilter: function() {
	            $(this.filterInput).val("");
	            Select.fn._clearFilter.call(this);
	        },

	        value: function(value) {
	            var that = this;
	            var listView = that.listView;
	            var dataSource = that.dataSource;

	            if (value === undefined) {
	                value = that._accessor() || that.listView.value()[0];
	                return value === undefined || value === null ? "" : value;
	            }

	            that.requireValueMapper(that.options, value);

	            if (value || !that.hasOptionLabel()) {
	                that._initialIndex = null;
	            }

	            this.trigger("set", { value: value });

	            if (that._request && that.options.cascadeFrom && that.listView.bound()) {
	                if (that._valueSetter) {
	                    dataSource.unbind(CHANGE, that._valueSetter);
	                }

	                that._valueSetter = proxy(function() { that.value(value); }, that);

	                dataSource.one(CHANGE, that._valueSetter);
	                return;
	            }

	            if (that._isFilterEnabled() && listView.bound() && listView.isFiltered()) {
	                that._clearFilter();
	            } else {
	                that._fetchData();
	            }

	            listView.value(value).done(function() {
	                that._old = that._valueBeforeCascade = that._accessor();
	                that._oldIndex = that.selectedIndex;
	            });
	        },

	        hasOptionLabel: function() {
	            return this.optionLabel && !!this.optionLabel[0];
	        },

	        _optionLabel: function() {
	            var that = this;
	            var options = that.options;
	            var optionLabel = options.optionLabel;
	            var template = options.optionLabelTemplate;

	            if (!optionLabel) {
	                that.optionLabel.off().remove();
	                that.optionLabel = $();
	                return;
	            }

	            if (!template) {
	                template = "#:";

	                if (typeof optionLabel === "string") {
	                    template += "data";
	                } else {
	                    template += kendo.expr(options.dataTextField, "data");
	                }

	                template += "#";
	            }

	            if (typeof template !== "function") {
	                template = kendo.template(template);
	            }

	            that.optionLabelTemplate = template;

	            if (!that.hasOptionLabel()) {
	                that.optionLabel = $('<div class="k-list-optionlabel"></div>').prependTo(that.list);
	            }

	            that.optionLabel.html(template(optionLabel))
	                            .off()
	                            .on(CLICKEVENTS, proxy(that._click, that))
	                            .on(HOVEREVENTS, that._toggleHover);

	            that.angular("compile", function() {
	                return { elements: that.optionLabel, data: [{ dataItem: that._optionLabelDataItem() }] };
	            });
	        },

	        _optionLabelText: function() {
	            var optionLabel = this.options.optionLabel;
	            return (typeof optionLabel === "string") ? optionLabel : this._text(optionLabel);
	        },

	        _optionLabelDataItem: function() {
	            var that = this;
	            var optionLabel = that.options.optionLabel;

	            if (that.hasOptionLabel()) {
	                return $.isPlainObject(optionLabel) ? new ObservableObject(optionLabel) : that._assignInstance(that._optionLabelText(), "");
	            }

	            return undefined;
	        },

	        _buildOptions: function(data) {
	            var that = this;
	            if (!that._isSelect) {
	                return;
	            }

	            var value = that.listView.value()[0];
	            var optionLabel = that._optionLabelDataItem();
	            var optionLabelValue = optionLabel && that._value(optionLabel);

	            if (value === undefined || value === null) {
	                value = "";
	            }

	            if (optionLabel) {
	                if (optionLabelValue === undefined || optionLabelValue === null) {
	                    optionLabelValue = "";
	                }

	                optionLabel = '<option value="' + optionLabelValue + '">' + that._text(optionLabel) + "</option>";
	            }

	            that._options(data, optionLabel, value);

	            if (value !== List.unifyType(that._accessor(), typeof value)) {
	                that._customOption = null;
	                that._custom(value);
	            }
	        },

	        _listBound: function() {

	            var that = this;
	            var initialIndex = that._initialIndex;
	            var filtered = that._state === STATE_FILTER;

	            var data = that.dataSource.flatView();
	            var dataItem;

	            that._presetValue = false;

	            that._renderFooter();
	            that._renderNoData();
	            that._toggleNoData(!data.length);

	            that._resizePopup(true);

	            that.popup.position();

	            that._buildOptions(data);

	            that._makeUnselectable();

	            if (!filtered) {
	                if (that._open) {
	                    that.toggle(that._allowOpening());
	                }

	                that._open = false;

	                if (!that._fetch) {
	                    if (data.length) {
	                        if (!that.listView.value().length && initialIndex > -1 && initialIndex !== null) {
	                            that.select(initialIndex);
	                        }

	                        that._initialIndex = null;
	                        dataItem = that.listView.selectedDataItems()[0];
	                        if (dataItem && that.text() !== that._text(dataItem)) {
	                            that._selectValue(dataItem);
	                        }
	                    } else if (that._textAccessor() !== that._optionLabelText()) {
	                        that.listView.value("");
	                        that._selectValue(null);
	                        that._oldIndex = that.selectedIndex;
	                    }
	                }
	            }

	            that._hideBusy();
	            that.trigger("dataBound");
	        },

	        _listChange: function() {
	            this._selectValue(this.listView.selectedDataItems()[0]);

	            if (this._presetValue || (this._old && this._oldIndex === -1)) {
	                this._oldIndex = this.selectedIndex;
	            }
	        },

	        _filterPaste: function() {
	            this._search();
	        },

	        _attachFocusHandlers: function() {
	            var that = this;
	            var wrapper = that.wrapper;

	            wrapper.on("focusin" + nsFocusEvent, proxy(that._focusinHandler, that))
	                   .on("focusout" + nsFocusEvent, proxy(that._focusoutHandler, that));
	            if(that.filterInput) {
	                that.filterInput.on("focusin" + nsFocusEvent, proxy(that._focusinHandler, that))
	                   .on("focusout" + nsFocusEvent, proxy(that._focusoutHandler, that));
	            }
	        },

	        _focusHandler: function() {
	            this.wrapper.focus();
	        },

	        _focusinHandler: function() {
	            this._inputWrapper.addClass(FOCUSED);
	            this._prevent = false;
	        },

	        _focusoutHandler: function() {
	            var that = this;
	            var isIFrame = window.self !== window.top;

	            if (!that._prevent) {
	                clearTimeout(that._typingTimeout);

	                if (support.mobileOS.ios && isIFrame) {
	                    that._change();
	                } else {
	                    that._blur();
	                }

	                that._inputWrapper.removeClass(FOCUSED);
	                that._prevent = true;
	                that._open = false;
	                that.element.blur();
	            }
	        },

	        _wrapperMousedown: function() {
	            this._prevent = !!this.filterInput;
	        },

	        _wrapperClick: function(e) {
	            e.preventDefault();
	            this.popup.unbind("activate", this._focusInputHandler);
	            this._focused = this.wrapper;
	            this._prevent = false;
	            this._toggle();
	        },

	        _editable: function(options) {
	            var that = this;
	            var element = that.element;
	            var disable = options.disable;
	            var readonly = options.readonly;
	            var wrapper = that.wrapper.add(that.filterInput).off(ns);
	            var dropDownWrapper = that._inputWrapper.off(HOVEREVENTS);

	            if (!readonly && !disable) {
	                element.removeAttr(DISABLED).removeAttr(READONLY);

	                dropDownWrapper
	                    .addClass(DEFAULT)
	                    .removeClass(STATEDISABLED)
	                    .on(HOVEREVENTS, that._toggleHover);

	                wrapper
	                    .attr(TABINDEX, wrapper.data(TABINDEX))
	                    .attr(ARIA_DISABLED, false)
	                    .attr(ARIA_READONLY, false)
	                    .on("keydown" + ns, that, proxy(that._keydown, that))
	                    .on(kendo.support.mousedown + ns, proxy(that._wrapperMousedown, that))
	                    .on("paste" + ns, proxy(that._filterPaste, that));

	                that.wrapper.on("click" + ns, proxy(that._wrapperClick, that));

	                if (!that.filterInput) {
	                    wrapper.on("keypress" + ns, proxy(that._keypress, that));
	                } else {
	                    wrapper.on("input" + ns, proxy(that._search, that));
	                }

	            } else if (disable) {
	                wrapper.removeAttr(TABINDEX);
	                dropDownWrapper
	                    .addClass(STATEDISABLED)
	                    .removeClass(DEFAULT);
	            } else {
	                dropDownWrapper
	                    .addClass(DEFAULT)
	                    .removeClass(STATEDISABLED);
	            }

	            element.attr(DISABLED, disable)
	                   .attr(READONLY, readonly);

	            wrapper.attr(ARIA_DISABLED, disable)
	                    .attr(ARIA_READONLY, readonly);
	        },

	        _keydown: function(e) {
	            var that = this;
	            var key = e.keyCode;
	            var altKey = e.altKey;
	            var isInputActive;
	            var handled;

	            var isPopupVisible = that.popup.visible();

	            if (that.filterInput) {
	                isInputActive = that.filterInput[0] === activeElement();
	            }

	            if (key === keys.LEFT) {
	                key = keys.UP;
	                handled = true;
	            } else if (key === keys.RIGHT) {
	                key = keys.DOWN;
	                handled = true;
	            }

	            if (handled && isInputActive) {
	                return;
	            }

	            e.keyCode = key;

	            if ((altKey && key === keys.UP) || key === keys.ESC) {
	                that._focusElement(that.wrapper);
	            }

	            if (that._state === STATE_FILTER && key === keys.ESC) {
	                that._clearFilter();
	                that._open = false;
	                that._state = STATE_ACCEPT;
	            }

	            if (key === keys.ENTER && that._typingTimeout && that.filterInput && isPopupVisible) {
	                e.preventDefault();
	                return;
	            }

	            if (key === keys.SPACEBAR && !isInputActive) {
	                that.toggle(!isPopupVisible);
	                e.preventDefault();
	            }

	            handled = that._move(e);

	            if (handled) {
	                return;
	            }

	            if (!isPopupVisible || !that.filterInput) {
	                var current = that._focus();

	                if (key === keys.HOME) {
	                    handled = true;
	                    that._firstItem();
	                } else if (key === keys.END) {
	                    handled = true;
	                    that._lastItem();
	                }

	                if (handled) {
	                    if (that.trigger("select", { dataItem: that._getElementDataItem(that._focus()), item: that._focus() })) {
	                        that._focus(current);
	                        return;
	                    }

	                    that._select(that._focus(), true).done(function() {
	                        if (!isPopupVisible) {
	                            that._blur();
	                        }
	                    });
	                    e.preventDefault();
	                }
	            }

	            if (!altKey && !handled && that.filterInput) {
	                that._search();
	            }
	        },

	        _matchText: function(text, word) {
	            var ignoreCase = this.options.ignoreCase;

	            if (text === undefined || text === null) {
	                return false;
	            }

	            text = text + "";

	            if (ignoreCase) {
	                text = text.toLowerCase();
	            }

	            return text.indexOf(word) === 0;
	        },

	        _shuffleData: function(data, splitIndex) {
	            var optionDataItem = this._optionLabelDataItem();

	            if (optionDataItem) {
	                data = [optionDataItem].concat(data);
	            }

	            return data.slice(splitIndex).concat(data.slice(0, splitIndex));
	        },

	        _selectNext: function() {
	            var that = this;
	            var data = that.dataSource.flatView();
	            var dataLength = data.length + (that.hasOptionLabel() ? 1 : 0);
	            var isInLoop = sameCharsOnly(that._word, that._last);
	            var startIndex = that.selectedIndex;
	            var oldFocusedItem;
	            var text;

	            if (startIndex === -1) {
	                startIndex = 0;
	            } else {
	                startIndex += isInLoop ? 1 : 0;
	                startIndex = normalizeIndex(startIndex, dataLength);
	            }

	            data = data.toJSON ? data.toJSON() : data.slice();
	            data = that._shuffleData(data, startIndex);

	            for (var idx = 0; idx < dataLength; idx++) {
	                text = that._text(data[idx]);

	                if (isInLoop && that._matchText(text, that._last)) {
	                    break;
	                } else if (that._matchText(text, that._word)) {
	                    break;
	                }
	            }

	            if (idx !== dataLength) {
	                oldFocusedItem = that._focus();

	                that._select(normalizeIndex(startIndex + idx, dataLength)).done(function() {
	                    var done = function() {
	                        if (!that.popup.visible()) {
	                            that._change();
	                        }
	                    };

	                    if (that.trigger("select", { dataItem: that._getElementDataItem(that._focus()), item: that._focus() })) {
	                        that._select(oldFocusedItem).done(done);
	                    } else {
	                        done();
	                    }
	                });
	            }
	        },

	        _keypress: function(e) {
	            var that = this;

	            if (e.which === 0 || e.keyCode === kendo.keys.ENTER) {
	                return;
	            }

	            var character = String.fromCharCode(e.charCode || e.keyCode);

	            if (that.options.ignoreCase) {
	                character = character.toLowerCase();
	            }

	            if (character === " ") {
	                e.preventDefault();
	            }

	            that._word += character;
	            that._last = character;

	            that._search();
	        },

	        _popupOpen: function() {
	            var popup = this.popup;

	            popup.wrapper = kendo.wrap(popup.element);

	            if (popup.element.closest(".km-root")[0]) {
	                popup.wrapper.addClass("km-popup km-widget");
	                this.wrapper.addClass("km-widget");
	            }
	        },

	        _popup: function() {
	            Select.fn._popup.call(this);
	            this.popup.one("open", proxy(this._popupOpen, this));
	        },

	        _getElementDataItem: function(element) {
	            if (!element || !element[0]) {
	                return null;
	            }

	            if (element[0] === this.optionLabel[0]) {
	                return this._optionLabelDataItem();
	            }

	            return this.listView.dataItemByIndex(this.listView.getElementIndex(element));
	        },

	        _click: function (e) {
	            var that = this;
	            var item = e.item || $(e.currentTarget);

	            e.preventDefault();

	            if (that.trigger("select", { dataItem: that._getElementDataItem(item), item: item })) {
	                that.close();
	                return;
	            }

	            that._userTriggered = true;

	            that._select(item).done(function() {
	                that._blur();
	                that._focusElement(that.wrapper);
	            });
	        },

	        _focusElement: function(element) {
	            var active = activeElement();
	            var wrapper = this.wrapper;
	            var filterInput = this.filterInput;
	            var compareElement = element === filterInput ? wrapper : filterInput;
	            var touchEnabled = support.mobileOS && (support.touch || support.MSPointers || support.pointers);

	            if (filterInput && filterInput[0] === element[0] && touchEnabled) {
	                return;
	            }

	            if (filterInput && (compareElement[0] === active || this._focusFilter)) {
	                this._focusFilter = false;
	                this._prevent = true;
	                this._focused = element.focus();
	            }
	        },

	        _searchByWord: function(word) {
	            if (!word) {
	                return;
	            }

	            var that = this;
	            var ignoreCase = that.options.ignoreCase;

	            if (ignoreCase) {
	                word = word.toLowerCase();
	            }

	            that._select(function(dataItem) {
	                return that._matchText(that._text(dataItem), word);
	            });
	        },

	        _inputValue: function() {
	            return this.text();
	        },

	        _search: function() {
	            var that = this;
	            var dataSource = that.dataSource;

	            clearTimeout(that._typingTimeout);

	            if (that._isFilterEnabled()) {
	                that._typingTimeout = setTimeout(function() {
	                    var value = that.filterInput.val();

	                    if (that._prev !== value) {
	                        that._prev = value;
	                        that.search(value);
	                        that._resizeFilterInput();
	                    }

	                    that._typingTimeout = null;
	                }, that.options.delay);
	            } else {
	                that._typingTimeout = setTimeout(function() {
	                    that._word = "";
	                }, that.options.delay);

	                if (!that.listView.bound()) {
	                    dataSource.fetch().done(function () {
	                        that._selectNext();
	                    });
	                    return;
	                }

	                that._selectNext();
	            }
	        },

	        _get: function(candidate) {
	            var data, found, idx;
	            var isFunction = typeof candidate === "function";
	            var jQueryCandidate = !isFunction ? $(candidate) : $();

	            if (this.hasOptionLabel()) {
	                if (typeof candidate === "number") {
	                    if (candidate > -1) {
	                        candidate -= 1;
	                    }
	                } else if (jQueryCandidate.hasClass("k-list-optionlabel")) {
	                    candidate = -1;
	                }
	            }

	            if (isFunction) {
	                data = this.dataSource.flatView();

	                for (idx = 0; idx < data.length; idx++) {
	                    if (candidate(data[idx])) {
	                        candidate = idx;
	                        found = true;
	                        break;
	                    }
	                }

	                if (!found) {
	                    candidate = -1;
	                }
	            }

	            return candidate;
	        },

	        _firstItem: function() {
	            if (this.hasOptionLabel()) {
	                this._focus(this.optionLabel);
	            } else {
	                this.listView.focusFirst();
	            }
	        },

	        _lastItem: function() {
	            this._resetOptionLabel();
	            this.listView.focusLast();
	        },

	        _nextItem: function() {
	            var focusIndex;

	            if (this.optionLabel.hasClass("k-state-focused")) {
	                this._resetOptionLabel();
	                this.listView.focusFirst();
	                focusIndex = 1;
	            } else {
	                focusIndex = this.listView.focusNext();
	            }

	            return focusIndex;
	        },

	        _prevItem: function() {
	            var focusIndex;

	            if (this.optionLabel.hasClass("k-state-focused")) {
	                return;
	            }

	            focusIndex = this.listView.focusPrev();

	            if (!this.listView.focus() && !this.options.virtual) {
	                this._focus(this.optionLabel);
	            }

	            return focusIndex;
	        },

	        _focusItem: function() {
	            var options = this.options;
	            var listView = this.listView;
	            var focusedItem = listView.focus();
	            var index = listView.select();

	            index = index[index.length - 1];

	            if (index === undefined && options.highlightFirst && !focusedItem) {
	                index = 0;
	            }

	            if (index !== undefined) {
	                listView.focus(index);
	            } else {
	                if (options.optionLabel && (!options.virtual || options.virtual.mapValueTo !== "dataItem")) {
	                    this._focus(this.optionLabel);
	                    this._select(this.optionLabel);
	                    this.listView.content.scrollTop(0);
	                } else {
	                    listView.scrollToIndex(0);
	                }
	            }
	        },

	        _resetOptionLabel: function(additionalClass) {
	            this.optionLabel.removeClass("k-state-focused" + (additionalClass || "")).removeAttr("id");
	        },

	        _focus: function(candidate) {
	            var listView = this.listView;
	            var optionLabel = this.optionLabel;

	            if (candidate === undefined) {
	                candidate = listView.focus();

	                if (!candidate && optionLabel.hasClass("k-state-focused")) {
	                    candidate = optionLabel;
	                }

	                return candidate;
	            }

	            this._resetOptionLabel();

	            candidate = this._get(candidate);

	            listView.focus(candidate);

	            if (candidate === -1) {
	                optionLabel.addClass("k-state-focused")
	                           .attr("id", listView._optionID);

	                this._focused.add(this.filterInput)
	                    .removeAttr("aria-activedescendant")
	                    .attr("aria-activedescendant", listView._optionID);
	            }
	        },

	        _select: function(candidate, keepState) {
	            var that = this;

	            candidate = that._get(candidate);

	            return that.listView.select(candidate).done(function() {
	                if (!keepState && that._state === STATE_FILTER) {
	                    that._state = STATE_ACCEPT;
	                }

	                if (candidate === -1) {
	                    that._selectValue(null);
	                }
	            });
	        },

	        _selectValue: function(dataItem) {
	            var that = this;
	            var optionLabel = that.options.optionLabel;
	            var idx = that.listView.select();

	            var value = "";
	            var text = "";

	            idx = idx[idx.length - 1];
	            if (idx === undefined) {
	                idx = -1;
	            }

	            this._resetOptionLabel(" k-state-selected");

	            if (dataItem || dataItem === 0) {
	                text = dataItem;
	                value = that._dataValue(dataItem);
	                if (optionLabel) {
	                    idx += 1;
	                }
	            } else if (optionLabel) {
	                that._focus(that.optionLabel.addClass("k-state-selected"));

	                text = that._optionLabelText();

	                if (typeof optionLabel === "string") {
	                    value = "";
	                } else {
	                    value = that._value(optionLabel);
	                }

	                idx = 0;
	            }

	            that.selectedIndex = idx;

	            if (value === null) {
	                value = "";
	            }

	            that._textAccessor(text);
	            that._accessor(value, idx);

	            that._triggerCascade();
	        },

	        _mobile: function() {
	            var that = this,
	                popup = that.popup,
	                mobileOS = support.mobileOS,
	                root = popup.element.parents(".km-root").eq(0);

	            if (root.length && mobileOS) {
	                popup.options.animation.open.effects = (mobileOS.android || mobileOS.meego) ? "fadeIn" : (mobileOS.ios || mobileOS.wp) ? "slideIn:up" : popup.options.animation.open.effects;
	            }
	        },

	        _filterHeader: function() {
	            var icon;

	            if (this.filterInput) {
	                this.filterInput
	                    .off(ns)
	                    .parent()
	                    .remove();

	                this.filterInput = null;
	            }

	            if (this._isFilterEnabled()) {
	                icon = '<span class="k-icon k-i-zoom"></span>';

	                this.filterInput = $('<input class="k-textbox"/>')
	                                      .attr({
	                                          placeholder: this.element.attr("placeholder"),
	                                          title: this.element.attr("title"),
	                                          role: "listbox",
	                                          "aria-haspopup": "listbox",
	                                          "aria-expanded": false
	                                      });
	                this.list
	                    .prepend($('<span class="k-list-filter" />')
	                    .append(this.filterInput.add(icon)));
	            }
	        },

	        _span: function() {
	            var that = this,
	                wrapper = that.wrapper,
	                SELECTOR = "span.k-input",
	                id = kendo.guid(),
	                span;

	            span = wrapper.find(SELECTOR);

	            if (!span[0]) {
	                wrapper.append('<span unselectable="on" class="k-dropdown-wrap k-state-default"><span id="' + id + '" unselectable="on" role="option" aria-selected="true" class="k-input">&nbsp;</span><span unselectable="on" class="k-select" aria-label="select"><span class="k-icon k-i-arrow-60-down"></span></span></span>')
	                       .append(that.element);

	                span = wrapper.find(SELECTOR);
	            }

	            that.span = span;
	            that._inputWrapper = $(wrapper[0].firstChild);
	            that._arrow = wrapper.find(".k-select");
	            that._arrowIcon = that._arrow.find(".k-icon");
	        },

	        _wrapper: function() {
	            var that = this,
	                element = that.element,
	                DOMelement = element[0],
	                wrapper;

	            wrapper = element.parent();

	            if (!wrapper.is("span.k-widget")) {
	                wrapper = element.wrap("<span />").parent();
	                wrapper[0].style.cssText = DOMelement.style.cssText;
	                wrapper[0].title = DOMelement.title;
	            }

	            that._focused = that.wrapper = wrapper
	                .addClass("k-widget k-dropdown")
	                .addClass(DOMelement.className)
	                .removeClass('input-validation-error')
	                .css("display", "")
	                .attr({
	                    accesskey: element.attr("accesskey"),
	                    unselectable: "on",
	                    role: "listbox",
	                    "aria-haspopup": "listbox",
	                    "aria-expanded": false
	                });

	            element.hide().removeAttr("accesskey");
	        },

	        _clearSelection: function(parent) {
	            this.select(parent.value() ? 0 : -1);
	        },

	        _inputTemplate: function() {
	            var that = this,
	                template = that.options.valueTemplate;


	            if (!template) {
	                template = $.proxy(kendo.template('#:this._text(data)#', { useWithBlock: false }), that);
	            } else {
	                template = kendo.template(template);
	            }

	            that.valueTemplate = template;

	            if (that.hasOptionLabel() && !that.options.optionLabelTemplate) {
	                try {
	                    that.valueTemplate(that._optionLabelDataItem());
	                } catch(e) {
	                    throw new Error(MSG_INVALID_OPTION_LABEL);
	                }
	            }
	        },

	        _textAccessor: function(text) {
	            var dataItem = null;
	            var template = this.valueTemplate;
	            var optionLabelText = this._optionLabelText();
	            var span = this.span;

	            if (text === undefined) {
	                return span.text();
	            }

	            if ($.isPlainObject(text) || text instanceof ObservableObject) {
	                dataItem = text;
	            } else if (optionLabelText && optionLabelText === text) {
	                dataItem = this.options.optionLabel;
	            }

	            if (!dataItem) {
	                dataItem = this._assignInstance(text, this._accessor());
	            }

	            if (this.hasOptionLabel()) {
	                if (dataItem === optionLabelText || this._text(dataItem) === optionLabelText) {
	                    template = this.optionLabelTemplate;

	                    if (typeof this.options.optionLabel === "string" && !this.options.optionLabelTemplate) {
	                        dataItem = optionLabelText;
	                    }
	                }
	            }

	            var getElements = function(){
	                return {
	                    elements: span.get(),
	                    data: [ { dataItem: dataItem } ]
	                };
	            };

	            this.angular("cleanup", getElements);

	            try {
	                span.html(template(dataItem));
	            } catch(e) {
	                //dataItem has missing fields required in custom template
	                span.html("");
	            }

	            this.angular("compile", getElements);
	        },

	        _preselect: function(value, text) {
	            if (!value && !text) {
	                text = this._optionLabelText();
	            }

	            this._accessor(value);
	            this._textAccessor(text);

	            this._old = this._accessor();
	            this._oldIndex = this.selectedIndex;

	            this.listView.setValue(value);

	            this._initialIndex = null;
	            this._presetValue = true;
	        },

	        _assignInstance: function(text, value) {
	            var dataTextField = this.options.dataTextField;
	            var dataItem = {};

	            if (dataTextField) {
	                assign(dataItem, dataTextField.split("."), text);
	                assign(dataItem, this.options.dataValueField.split("."), value);
	                dataItem = new ObservableObject(dataItem);
	            } else {
	                dataItem = text;
	            }

	            return dataItem;
	        }
	    });

	    function assign(instance, fields, value) {
	        var idx = 0,
	            lastIndex = fields.length - 1,
	            field;

	        for (; idx < lastIndex; ++idx) {
	            field = fields[idx];

	            if (!(field in instance)) {
	                instance[field] = {};
	            }

	            instance = instance[field];
	        }

	        instance[fields[lastIndex]] = value;
	    }

	    function normalizeIndex(index, length) {
	        if (index >= length) {
	            index -= length;
	        }
	        return index;
	    }

	    function sameCharsOnly(word, character) {
	        for (var idx = 0; idx < word.length; idx++) {
	            if (word.charAt(idx) !== character) {
	                return false;
	            }
	        }
	        return true;
	    }

	    ui.plugin(DropDownList);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "CTJA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = __webpack_require__("pQ38");
var context_1 = __webpack_require__("RQ1/");
var column_1 = __webpack_require__("hDyE");
var utils_1 = __webpack_require__("IRr6");
var dragAndDropService_1 = __webpack_require__("I/uN");
var columnApi_1 = __webpack_require__("E/Wy");
var columnController_1 = __webpack_require__("77lH");
var horizontalDragService_1 = __webpack_require__("jJge");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var cssClassApplier_1 = __webpack_require__("NRBX");
var setLeftFeature_1 = __webpack_require__("yLI2");
var gridApi_1 = __webpack_require__("BAow");
var sortController_1 = __webpack_require__("fxGZ");
var eventService_1 = __webpack_require__("k5uU");
var componentRecipes_1 = __webpack_require__("EOXx");
var agCheckbox_1 = __webpack_require__("0Gxk");
var componentAnnotations_1 = __webpack_require__("x5ih");
var selectAllFeature_1 = __webpack_require__("ufFs");
var events_1 = __webpack_require__("3ok8");
var columnHoverService_1 = __webpack_require__("WO3E");
var beans_1 = __webpack_require__("YaQm");
var HeaderWrapperComp = (function (_super) {
    __extends(HeaderWrapperComp, _super);
    function HeaderWrapperComp(column, eRoot, dragSourceDropTarget, pinned) {
        var _this = _super.call(this, HeaderWrapperComp.TEMPLATE) || this;
        _this.column = column;
        _this.eRoot = eRoot;
        _this.dragSourceDropTarget = dragSourceDropTarget;
        _this.pinned = pinned;
        return _this;
    }
    HeaderWrapperComp.prototype.getColumn = function () {
        return this.column;
    };
    HeaderWrapperComp.prototype.init = function () {
        this.instantiate(this.context);
        var displayName = this.columnController.getDisplayNameForColumn(this.column, 'header', true);
        var enableSorting = this.gridOptionsWrapper.isEnableSorting() && !this.column.getColDef().suppressSorting;
        var enableMenu = this.menuFactory.isMenuEnabled(this.column) && !this.column.getColDef().suppressMenu;
        this.appendHeaderComp(displayName, enableSorting, enableMenu);
        this.setupWidth();
        this.setupMovingCss();
        this.setupTooltip();
        this.setupResize();
        this.setupMenuClass();
        this.setupSortableClass(enableSorting);
        this.addColumnHoverListener();
        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_FILTER_ACTIVE_CHANGED, this.onFilterChanged.bind(this));
        this.onFilterChanged();
        this.addFeature(this.context, new selectAllFeature_1.SelectAllFeature(this.cbSelectAll, this.column));
        var setLeftFeature = new setLeftFeature_1.SetLeftFeature(this.column, this.getGui(), this.beans);
        setLeftFeature.init();
        this.addDestroyFunc(setLeftFeature.destroy.bind(setLeftFeature));
        this.addAttributes();
        cssClassApplier_1.CssClassApplier.addHeaderClassesFromColDef(this.column.getColDef(), this.getGui(), this.gridOptionsWrapper, this.column, null);
    };
    HeaderWrapperComp.prototype.addColumnHoverListener = function () {
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_HOVER_CHANGED, this.onColumnHover.bind(this));
        this.onColumnHover();
    };
    HeaderWrapperComp.prototype.onColumnHover = function () {
        var isHovered = this.columnHoverService.isHovered(this.column);
        utils_1.Utils.addOrRemoveCssClass(this.getGui(), 'ag-column-hover', isHovered);
    };
    HeaderWrapperComp.prototype.setupSortableClass = function (enableSorting) {
        if (enableSorting) {
            var element = this.getGui();
            utils_1.Utils.addCssClass(element, 'ag-header-cell-sortable');
        }
    };
    HeaderWrapperComp.prototype.onFilterChanged = function () {
        var filterPresent = this.column.isFilterActive();
        utils_1.Utils.addOrRemoveCssClass(this.getGui(), 'ag-header-cell-filtered', filterPresent);
    };
    HeaderWrapperComp.prototype.appendHeaderComp = function (displayName, enableSorting, enableMenu) {
        var _this = this;
        var params = {
            column: this.column,
            displayName: displayName,
            enableSorting: enableSorting,
            enableMenu: enableMenu,
            showColumnMenu: function (source) {
                _this.gridApi.showColumnMenuAfterButtonClick(_this.column, source);
            },
            progressSort: function (multiSort) {
                _this.sortController.progressSort(_this.column, !!multiSort, "uiColumnSorted");
            },
            setSort: function (sort, multiSort) {
                _this.sortController.setSortForColumn(_this.column, sort, !!multiSort, "uiColumnSorted");
            },
            api: this.gridApi,
            columnApi: this.columnApi,
            context: this.gridOptionsWrapper.getContext()
        };
        var callback = this.afterHeaderCompCreated.bind(this, displayName);
        this.componentRecipes.newHeaderComponent(params).then(callback);
    };
    HeaderWrapperComp.prototype.afterHeaderCompCreated = function (displayName, headerComp) {
        this.appendChild(headerComp);
        this.setupMove(headerComp.getGui(), displayName);
        if (headerComp.destroy) {
            this.addDestroyFunc(headerComp.destroy.bind(headerComp));
        }
    };
    HeaderWrapperComp.prototype.onColumnMovingChanged = function () {
        // this function adds or removes the moving css, based on if the col is moving.
        // this is what makes the header go dark when it is been moved (gives impression to
        // user that the column was picked up).
        if (this.column.isMoving()) {
            utils_1.Utils.addCssClass(this.getGui(), 'ag-header-cell-moving');
        }
        else {
            utils_1.Utils.removeCssClass(this.getGui(), 'ag-header-cell-moving');
        }
    };
    HeaderWrapperComp.prototype.setupMove = function (eHeaderCellLabel, displayName) {
        var _this = this;
        var suppressMove = this.gridOptionsWrapper.isSuppressMovableColumns()
            || this.column.getColDef().suppressMovable
            || this.column.isLockPosition()
            || this.gridOptionsWrapper.isForPrint();
        if (suppressMove) {
            return;
        }
        if (eHeaderCellLabel) {
            var dragSource_1 = {
                type: dragAndDropService_1.DragSourceType.HeaderCell,
                eElement: eHeaderCellLabel,
                dragItemCallback: function () { return _this.createDragItem(); },
                dragItemName: displayName,
                dragSourceDropTarget: this.dragSourceDropTarget,
                dragStarted: function () { return _this.column.setMoving(true, "uiColumnMoved"); },
                dragStopped: function () { return _this.column.setMoving(false, "uiColumnMoved"); }
            };
            this.dragAndDropService.addDragSource(dragSource_1, true);
            this.addDestroyFunc(function () { return _this.dragAndDropService.removeDragSource(dragSource_1); });
        }
    };
    HeaderWrapperComp.prototype.createDragItem = function () {
        var visibleState = {};
        visibleState[this.column.getId()] = this.column.isVisible();
        return {
            columns: [this.column],
            visibleState: visibleState
        };
    };
    HeaderWrapperComp.prototype.setupResize = function () {
        var _this = this;
        var colDef = this.column.getColDef();
        // if no eResize in template, do nothing
        if (!this.eResize) {
            return;
        }
        if (!this.column.isResizable()) {
            utils_1.Utils.removeFromParent(this.eResize);
            return;
        }
        this.horizontalDragService.addDragHandling({
            eDraggableElement: this.eResize,
            eBody: this.eRoot,
            cursor: 'col-resize',
            startAfterPixels: 0,
            onDragStart: this.onDragStart.bind(this),
            onDragging: this.onDragging.bind(this)
        });
        var weWantAutoSize = !this.gridOptionsWrapper.isSuppressAutoSize() && !colDef.suppressAutoSize;
        if (weWantAutoSize) {
            this.addDestroyableEventListener(this.eResize, 'dblclick', function () {
                _this.columnController.autoSizeColumn(_this.column, "uiColumnResized");
            });
        }
    };
    HeaderWrapperComp.prototype.onDragging = function (dragChange, finished) {
        var dragChangeNormalised = this.normaliseDragChange(dragChange);
        var newWidth = this.startWidth + dragChangeNormalised;
        this.columnController.setColumnWidth(this.column, newWidth, finished, "uiColumnDragged");
    };
    HeaderWrapperComp.prototype.onDragStart = function () {
        this.startWidth = this.column.getActualWidth();
    };
    HeaderWrapperComp.prototype.setupTooltip = function () {
        var colDef = this.column.getColDef();
        // add tooltip if exists
        if (colDef.headerTooltip) {
            this.getGui().title = colDef.headerTooltip;
        }
    };
    HeaderWrapperComp.prototype.setupMovingCss = function () {
        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_MOVING_CHANGED, this.onColumnMovingChanged.bind(this));
        this.onColumnMovingChanged();
    };
    HeaderWrapperComp.prototype.addAttributes = function () {
        this.getGui().setAttribute("col-id", this.column.getColId());
    };
    HeaderWrapperComp.prototype.setupWidth = function () {
        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_WIDTH_CHANGED, this.onColumnWidthChanged.bind(this));
        this.onColumnWidthChanged();
    };
    HeaderWrapperComp.prototype.setupMenuClass = function () {
        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_MENU_VISIBLE_CHANGED, this.onMenuVisible.bind(this));
        this.onColumnWidthChanged();
    };
    HeaderWrapperComp.prototype.onMenuVisible = function () {
        this.addOrRemoveCssClass('ag-column-menu-visible', this.column.isMenuVisible());
    };
    HeaderWrapperComp.prototype.onColumnWidthChanged = function () {
        this.getGui().style.width = this.column.getActualWidth() + 'px';
    };
    // optionally inverts the drag, depending on pinned and RTL
    // note - this method is duplicated in RenderedHeaderGroupCell - should refactor out?
    HeaderWrapperComp.prototype.normaliseDragChange = function (dragChange) {
        var result = dragChange;
        if (this.gridOptionsWrapper.isEnableRtl()) {
            // for RTL, dragging left makes the col bigger, except when pinning left
            if (this.pinned !== column_1.Column.PINNED_LEFT) {
                result *= -1;
            }
        }
        else {
            // for LTR (ie normal), dragging left makes the col smaller, except when pinning right
            if (this.pinned === column_1.Column.PINNED_RIGHT) {
                result *= -1;
            }
        }
        return result;
    };
    HeaderWrapperComp.TEMPLATE = '<div class="ag-header-cell" role="presentation" >' +
        '<div ref="eResize" class="ag-header-cell-resize" role="presentation"></div>' +
        '<ag-checkbox ref="cbSelectAll" class="ag-header-select-all" role="presentation"></ag-checkbox>' +
        // <inner component goes here>
        '</div>';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], HeaderWrapperComp.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('dragAndDropService'),
        __metadata("design:type", dragAndDropService_1.DragAndDropService)
    ], HeaderWrapperComp.prototype, "dragAndDropService", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], HeaderWrapperComp.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('horizontalDragService'),
        __metadata("design:type", horizontalDragService_1.HorizontalDragService)
    ], HeaderWrapperComp.prototype, "horizontalDragService", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], HeaderWrapperComp.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('menuFactory'),
        __metadata("design:type", Object)
    ], HeaderWrapperComp.prototype, "menuFactory", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], HeaderWrapperComp.prototype, "gridApi", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], HeaderWrapperComp.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('sortController'),
        __metadata("design:type", sortController_1.SortController)
    ], HeaderWrapperComp.prototype, "sortController", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], HeaderWrapperComp.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('componentRecipes'),
        __metadata("design:type", componentRecipes_1.ComponentRecipes)
    ], HeaderWrapperComp.prototype, "componentRecipes", void 0);
    __decorate([
        context_1.Autowired('columnHoverService'),
        __metadata("design:type", columnHoverService_1.ColumnHoverService)
    ], HeaderWrapperComp.prototype, "columnHoverService", void 0);
    __decorate([
        context_1.Autowired('beans'),
        __metadata("design:type", beans_1.Beans)
    ], HeaderWrapperComp.prototype, "beans", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('eResize'),
        __metadata("design:type", HTMLElement)
    ], HeaderWrapperComp.prototype, "eResize", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('cbSelectAll'),
        __metadata("design:type", agCheckbox_1.AgCheckbox)
    ], HeaderWrapperComp.prototype, "cbSelectAll", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], HeaderWrapperComp.prototype, "init", null);
    return HeaderWrapperComp;
}(component_1.Component));
exports.HeaderWrapperComp = HeaderWrapperComp;


/***/ }),

/***/ "CiAW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("7+uW");

var Vue = _interopRequireWildcard(_vue);

var _KendoDropDownListMixin = __webpack_require__("9598");

var _KendoDropDownListMixin2 = _interopRequireDefault(_KendoDropDownListMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-dropdownlist',
    mixins: [_KendoDropDownListMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('input', [this.$slots['kendo-datasource']]);
    }
};

/***/ }),

/***/ "Cloa":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1251);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1190:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("JKVm");

/***/ }),

/***/ 1251:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1059), __webpack_require__(1190), __webpack_require__(1252), __webpack_require__(1253), __webpack_require__(1254), __webpack_require__(1255), __webpack_require__(1256), __webpack_require__(1257)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "gantt",
	    name: "Gantt",
	    category: "web",
	    description: "The Gantt component.",
	    depends: [ "data", "resizable", "switch", "gantt.data", "gantt.editors", "gantt.list", "gantt.timeline", "pdf" ]
	};

	(function($, undefined) {

	    var kendo = window.kendo,
	        keys = $.extend({F10: 121}, kendo.keys),
	        supportsMedia = "matchMedia" in window,
	        mobileOS = kendo.support.mobileOS,
	        Widget = kendo.ui.Widget,
	        ObservableObject = kendo.data.ObservableObject,
	        ObservableArray = kendo.data.ObservableArray,
	        Query = kendo.data.Query,
	        isArray = $.isArray,
	        inArray = $.inArray,
	        isFunction = kendo.isFunction,
	        proxy = $.proxy,
	        extend = $.extend,
	        isPlainObject = $.isPlainObject,
	        outerWidth = kendo._outerWidth,
	        outerHeight = kendo._outerHeight,
	        defaultIndicatorWidth = 3,

	        NS = ".kendoGantt",
	        PERCENTAGE_FORMAT = "p0",
	        TABINDEX = "tabIndex",
	        CLICK = "click",
	        STRING = "string",
	        ARIA_DESCENDANT = "aria-activedescendant",
	        ARIA_LABEL = "aria-label",
	        ACTIVE_CELL = "gantt_active_cell",
	        DOT = ".",
	        TASK_DELETE_CONFIRM = "Are you sure you want to delete this task?",
	        DEPENDENCY_DELETE_CONFIRM = "Are you sure you want to delete this dependency?",
	        TOGGLE_BUTTON_TEMPLATE = kendo.template('<button class="#=styles.buttonToggle#" type="button" '+ ARIA_LABEL + '="Toggle"><span class="#=styles.iconToggle#"></span></button>'),
	        BUTTON_TEMPLATE = '<button class="#=styles.button# #=className#" type="button" '+
	            '#if (action) {#' +
	                'data-action="#=action#"' +
	            '#}#' +
	        '><span class="#=iconClass#"></span><span class="k-button-text">#=text#</span></button>',
	        COMMAND_BUTTON_TEMPLATE = '<a class="#=className#" #=attr# href="\\#">#=text#</a>',
	        VIEWS_DROPDOWN_TEMPLATE = kendo.template('<select class="k-dropdown #= styles.viewsDropdown #">' +
	            '#for(var view in views){#' +
	                '<option value="#=view#">#=views[view].title#</option>' +
	            '#}#' +
	        '</select>'),
	        HEADER_VIEWS_TEMPLATE = kendo.template('<div class="#=styles.viewsWrapper#">' +
	            '<span class="k-button-group #=styles.views#">' +
	                '#for(var view in views){#' +
	                    '<button type="button" class="#=styles.button# #=styles.viewButton#-#= view.toLowerCase() #" data-#=ns#name="#=view#"><span class="k-button-text">#=views[view].title#</span></button>' +
	                '#}#' +
	            '</span>' +
	        '</div>');

	    var ganttStyles = {
	        wrapper: "k-widget k-gantt",
	        plannedTasks: "k-gantt-planned",
	        rowHeight: "k-gantt-rowheight",
	        content: "k-gantt-content",
	        listWrapper: "k-gantt-treelist",
	        list: "k-gantt-treelist",
	        timelineWrapper: "k-gantt-timeline",
	        timeline: "k-gantt-timeline",
	        splitBarWrapper: "k-splitbar k-state-default k-splitbar-horizontal k-splitbar-draggable-horizontal",
	        splitBar: "k-splitbar",
	        splitBarHover: "k-splitbar-horizontal-hover",
	        popupWrapper: "k-list-container",
	        popupList: "k-list k-reset",
	        resizeHandle: "k-resize-handle",
	        icon: "k-icon",
	        item: "k-item",
	        line: "k-gantt-line",
	        buttonDelete: "k-gantt-delete",
	        buttonCancel: "k-gantt-cancel",
	        buttonSave: "k-gantt-update",
	        buttonToggle: "k-gantt-toggle",
	        primary: "k-primary",
	        hovered: "k-state-hover",
	        selected: "k-state-selected",
	        focused: "k-state-focused",
	        gridHeader: "k-grid-header",
	        gridHeaderWrap: "k-grid-header-wrap",
	        gridContent: "k-grid-content",
	        tasks: "k-gantt-tasks",
	        popup: {
	            form: "k-popup-edit-form",
	            editForm: "k-gantt-edit-form",
	            formContainer: "k-edit-form-container",
	            resourcesFormContainer: "k-resources-form-container",
	            message: "k-popup-message",
	            buttonsContainer: "k-edit-buttons k-state-default",
	            button: "k-button",
	            editField: "k-edit-field",
	            editLabel: "k-edit-label",
	            resourcesField: "k-gantt-resources"
	        },
	        toolbar: {
	            headerWrapper: "k-gantt-header k-toolbar k-gantt-toolbar",
	            footerWrapper: "k-gantt-footer k-toolbar k-gantt-toolbar",
	            toolbar: "k-gantt-toolbar",
	            views: "k-gantt-views",
	            viewsWrapper: "k-gantt-views-wrapper",
	            viewsDropdown: "k-views-dropdown",
	            button: "k-button k-button-icontext",
	            buttonToggle: "k-button k-button-icon k-gantt-toggle",
	            iconPlus: "k-icon k-i-plus",
	            iconPdf: "k-icon k-i-file-pdf",
	            iconToggle: "k-icon k-i-layout-1-by-4",
	            viewButtonDefault: "k-state-default",
	            viewButton: "k-view",
	            link: "k-link",
	            pdfButton: "k-gantt-pdf",
	            appendButton: "k-gantt-create"
	        }
	    };

	    function selector(uid) {
	        return "[" + kendo.attr("uid") + (uid ? "='" + uid + "']" : "]");
	    }

	    function trimOptions(options) {
	        delete options.name;
	        delete options.prefix;

	        delete options.remove;
	        delete options.edit;
	        delete options.add;
	        delete options.navigate;

	        return options;
	    }

	    function focusTable(table, direct) {
	        var wrapper = table.parents('[' + kendo.attr("role") + '="gantt"]');
	        var scrollPositions = [];
	        var parents = scrollableParents(wrapper);

	        table.attr(TABINDEX, 0);

	        if (direct) {
	            parents.each(function(index, parent) {
	                scrollPositions[index] = $(parent).scrollTop();
	            });
	        }

	        try {
	            //The setActive method does not cause the document to scroll to the active object in the current page
	            table[0].setActive();
	        } catch (e) {
	            table[0].focus();
	        }

	        if (direct) {
	            parents.each(function(index, parent) {
	                $(parent).scrollTop(scrollPositions[index]);
	            });
	        }
	    }

	    function scrollableParents(element) {
	        return $(element).parentsUntil("body")
	                .filter(function(index, element) {
	                    var computedStyle = kendo.getComputedStyles(element, ["overflow"]);
	                    return computedStyle.overflow != "visible";
	                })
	                .add(window);
	    }

	    var defaultCommands;

	    var Gantt = Widget.extend({
	        init: function(element, options, events) {
	            if (isArray(options)) {
	                options = { dataSource: options };
	            }

	            defaultCommands = {
	                append: {
	                    text: "Add Task",
	                    action: "add",
	                    className: Gantt.styles.toolbar.appendButton,
	                    iconClass: Gantt.styles.toolbar.iconPlus
	                },
	                pdf: {
	                    text: "Export to PDF",
	                    className: Gantt.styles.toolbar.pdfButton,
	                    iconClass: Gantt.styles.toolbar.iconPdf
	                }
	            };

	            Widget.fn.init.call(this, element, options);

	            if (events) {
	                this._events = events;
	            }

	            this._wrapper();

	            this._resources();

	            if (!this.options.views || !this.options.views.length) {
	                this.options.views = ["day", "week", "month"];
	            }

	            this._timeline();

	            this._toolbar();

	            this._footer();

	            this._adjustDimensions();

	            // Prevent extra refresh from setting the view
	            this._preventRefresh = true;

	            this.view(this.timeline._selectedViewName);

	            this._preventRefresh = false;

	            this._dataSource();

	            this._assignments();

	            this._dropDowns();

	            this._list();

	            this._dependencies();

	            this._resizable();

	            this._scrollable();

	            this._dataBind();

	            this._attachEvents();

	            this._createEditor();

	            kendo.notify(this);
	        },

	        events: [
	            "dataBinding",
	            "dataBound",
	            "add",
	            "edit",
	            "remove",
	            "cancel",
	            "save",
	            "change",
	            "navigate",
	            "moveStart",
	            "move",
	            "moveEnd",
	            "resizeStart",
	            "resize",
	            "resizeEnd",
	            "columnResize",
	            "togglePlannedTasks"
	        ],

	        options: {
	            name: "Gantt",
	            autoBind: true,
	            navigatable: false,
	            selectable: true,
	            editable: true,
	            resizable: false,
	            columnResizeHandleWidth: defaultIndicatorWidth,
	            columns: [],
	            views: [],
	            dataSource: {},
	            dependencies: {},
	            resources: {},
	            assignments: {},
	            taskTemplate: null,
	            messages: {
	                save: "Save",
	                cancel: "Cancel",
	                destroy: "Delete",
	                deleteTaskConfirmation: TASK_DELETE_CONFIRM,
	                deleteDependencyConfirmation: DEPENDENCY_DELETE_CONFIRM,
	                deleteTaskWindowTitle: "Delete task",
	                deleteDependencyWindowTitle: "Delete dependency",
	                views: {
	                    day: "Day",
	                    week: "Week",
	                    month: "Month",
	                    year: "Year",
	                    start: "Start",
	                    end: "End"
	                },
	                actions: {
	                    append: "Add Task",
	                    addChild: "Add Child",
	                    insertBefore: "Add Above",
	                    insertAfter: "Add Below",
	                    pdf: "Export to PDF"
	                },
	                editor: {
	                    editorTitle: "Task",
	                    resourcesEditorTitle: "Resources",
	                    title: "Title",
	                    start: "Start",
	                    end: "End",
	                    plannedStart: "Planned Start",
	                    plannedEnd: "Planned End",
	                    percentComplete: "Complete",
	                    resources: "Resources",
	                    assignButton: "Assign",
	                    resourcesHeader: "Resources",
	                    unitsHeader: "Units"
	                },
	                plannedTasks: {
	                    switchText: "Planned Tasks",
	                    offsetTooltipAdvanced: "Met deadline earlier",
	                    offsetTooltipDelay: "Delay",
	                    seconds: "seconds",
	                    minutes: "minutes",
	                    hours: "hours",
	                    days: "days"
	                }
	            },
	            showWorkHours: true,
	            showWorkDays: true,
	            toolbar: null,
	            workDayStart: new Date(1980, 1, 1, 8, 0, 0),
	            workDayEnd: new Date(1980, 1, 1, 17, 0, 0),
	            workWeekStart: 1,
	            workWeekEnd: 5,
	            hourSpan: 1,
	            snap: true,
	            height: 600,
	            listWidth: "30%",
	            rowHeight: null,
	            showPlannedTasks: false
	        },

	        select: function(value) {
	            var list = this.list;

	            if (!value) {
	                return list.select();
	            }

	            if (typeof value === STRING) {
	                value = list.content.find(value);
	            }

	            list.select(value);

	            this.list.element.find("table[role=treegrid]").focus();
	            return;
	        },

	        clearSelection: function() {
	            this.list.clearSelection();
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            if (this.dataSource) {
	                this.dataSource.unbind("change", this._refreshHandler);
	                this.dataSource.unbind("progress", this._progressHandler);
	                this.dataSource.unbind("error", this._errorHandler);
	            }

	            if (this.dependencies) {
	                this.dependencies.unbind("change", this._dependencyRefreshHandler);
	                this.dependencies.unbind("error", this._dependencyErrorHandler);
	            }

	            if (this.timeline) {
	                this.timeline.unbind();
	                this.timeline.destroy();
	            }

	            if (this.list) {
	                this.list.unbind();
	                this.list.destroy();
	            }

	            if (this.footerDropDown) {
	                this.footerDropDown.destroy();
	            }

	            if (this.headerDropDown) {
	                this.headerDropDown.destroy();
	            }

	            if (this._editor) {
	                this._editor.destroy();
	            }

	            if (this._resizeDraggable) {
	                this._resizeDraggable.destroy();
	            }

	            this.toolbar.off(NS);

	            if (supportsMedia) {
	                this._mediaQuery.removeListener(this._mediaQueryHandler);
	                this._mediaQuery = null;
	            }

	            $(window).off("resize" + NS, this._resizeHandler);
	            $(this.wrapper).off(NS);

	            this.toolbar = null;
	            this.footer = null;

	            kendo.destroy(this.element);
	        },

	        setOptions: function(options) {
	            var newOptions = kendo.deepExtend({}, this.options, options);

	            var events = this._events;

	            if (!options.views) {
	                var selectedView = this.view().name;

	                newOptions.views = $.map(this.options.views, function(view) {
	                    var isSettings = isPlainObject(view);
	                    var name = isSettings ? ((typeof view.type !== "string") ? view.title : view.type) : view;

	                    if (selectedView === name) {
	                        if (isSettings) {
	                            view.selected = true;
	                        } else {
	                            view = { type: name, selected: true };
	                        }
	                    } else if (isSettings) {
	                        view.selected = false;
	                    }

	                    return view;
	                });
	            }

	            if (!options.dataSource) { newOptions.dataSource = this.dataSource; }
	            if (!options.dependencies) { newOptions.dependencies = this.dependencies; }
	            if (!options.resources) { newOptions.resources = this.resources; }
	            if (!options.assignments) { newOptions.assignments = this.assignments; }

	            this.destroy();
	            this.element.empty();
	            this.options = null;

	            this.init(this.element, newOptions, events);

	            Widget.fn._setEvents.call(this, newOptions);
	        },

	        _attachEvents: function() {
	            this._resizeHandler = proxy(this.resize, this, false);
	            $(window).on("resize" + NS, this._resizeHandler);

	            if (supportsMedia && this._mediaQuery.matches === true) {
	                this._mediaQueryHandler({ matches: true });
	            }
	        },

	        _wrapper: function() {
	            var ganttStyles = Gantt.styles;
	            var splitBarHandleClassName = [ganttStyles.icon, ganttStyles.resizeHandle].join(" ");
	            var options = this.options;
	            var height = options.height;
	            var width = options.width;

	            this.wrapper = this.element.addClass(ganttStyles.wrapper);
	            this.layout = $("<div class='" + ganttStyles.content + "' />").appendTo(this.wrapper)
	                .append("<div class='" + ganttStyles.listWrapper + "'><div></div></div>")
	                .append("<div class='" + ganttStyles.splitBarWrapper + "'><div class='" + splitBarHandleClassName + "'></div></div>")
	                .append("<div class='" + ganttStyles.timelineWrapper + "'><div></div></div>");

	            if(options.showPlannedTasks) {
	                this.wrapper.addClass(ganttStyles.plannedTasks);
	            }

	            if (height) {
	                this.wrapper.css("height", height);
	            }

	            if (width) {
	                this.wrapper.css("width", width);
	            }

	            if (options.rowHeight) {
	                this.wrapper.addClass(ganttStyles.rowHeight);
	            }

	            this.treelistWrapper = this.wrapper.find(DOT + ganttStyles.list);
	            this.splitbar = this.wrapper.find(DOT + ganttStyles.splitBar);
	            this.timelineWrapper = this.wrapper.find(DOT + ganttStyles.timeline);

	            this.treelistWrapper.css("width", options.listWidth);
	            this.timelineWrapper.css("width", this.wrapper.width() - this.treelistWrapper.outerWidth() - this.splitbar.outerWidth() );
	        },

	        _toolbar: function() {
	            var that = this;
	            var ganttStyles = Gantt.styles;
	            var viewsSelector = DOT + ganttStyles.toolbar.views + " > button";
	            var viewsDropdownSelector = DOT + ganttStyles.toolbar.viewsDropdown;
	            var pdfSelector = DOT + ganttStyles.toolbar.pdfButton;
	            var toggleSelector = DOT + ganttStyles.buttonToggle;
	            var contentSelector = DOT + ganttStyles.gridContent;
	            var splitbar = that.splitbar;
	            var treelist = that.treelistWrapper;
	            var timeline = that.timelineWrapper;
	            var actions = this.options.toolbar;
	            var toolbar;
	            var views;
	            var toggleButton;
	            var mediaQueryHandler = function(e) {

	                if (e.matches) {
	                    treelist.addClass("k-hidden");
	                    splitbar.addClass("k-hidden");

	                    treelist.width("100%");
	                } else {
	                    treelist.removeClass("k-hidden");
	                    splitbar.removeClass("k-hidden");
	                    timeline.removeClass("k-hidden");

	                    treelist.width(treelist.outerWidth());

	                    that.refresh();

	                    timeline
	                        .find(contentSelector)
	                        .scrollTop(that.scrollTop);
	                }

	                that._resize();
	            };

	            if (!isFunction(actions)) {
	                actions = (typeof actions === STRING ? actions : this._actions(actions));
	                actions = proxy(kendo.template(actions), this);
	            }

	            toggleButton = $(TOGGLE_BUTTON_TEMPLATE({ styles: ganttStyles.toolbar }));

	            views = $(HEADER_VIEWS_TEMPLATE({
	                ns: kendo.ns,
	                views: this.timeline.views,
	                styles: ganttStyles.toolbar
	            }));

	            toolbar = $("<div class='" + ganttStyles.toolbar.headerWrapper + "'>")
	                .append(toggleButton)
	                .append(actions({}))
	                .append("<span class='k-spacer k-toolbar-spacer' />")
	                .append(views);

	            if (views.find("button").length > 1) {
	                views.prepend(VIEWS_DROPDOWN_TEMPLATE({
	                    ns: kendo.ns,
	                    views: this.timeline.views,
	                    styles: ganttStyles.toolbar
	                }));
	            }

	            if(this.toggeSwitchWrap) {
	                this.toggeSwitchWrap.insertBefore(views);
	            }

	            this.wrapper.prepend(toolbar);
	            this.toolbar = toolbar;

	            if (supportsMedia) {
	                this._mediaQueryHandler = proxy(mediaQueryHandler, this);
	                this._mediaQuery = window.matchMedia("(max-width: 480px)");
	                this._mediaQuery.addListener(this._mediaQueryHandler);
	            }

	            toolbar
	                .on("change" + NS, viewsDropdownSelector, function() {
	                    var list = that.list;
	                    var name = $(this).val();

	                    if (list.editable && list.editable.trigger("validate")) {
	                        return;
	                    }

	                    if (!that.trigger("navigate", { view: name })) {
	                        that.view(name);
	                    }

	                    that.toolbar.find(DOT + ganttStyles.focused).removeClass(ganttStyles.focused);
	                })
	                .on(CLICK + NS, viewsSelector, function(e) {
	                    e.preventDefault();

	                    var list = that.list;
	                    var name = $(this).attr(kendo.attr("name"));

	                    if (list.editor && !list.editor.end()) {
	                        return;
	                    }

	                    if (!that.trigger("navigate", { view: name })) {
	                        that.view(name);
	                    }

	                    that.toolbar.find(DOT + ganttStyles.focused).removeClass(ganttStyles.focused);
	                })
	                .on("keydown" + NS, viewsSelector, function(e) {
	                    var views = $(DOT + ganttStyles.toolbar.views).children(":not(.k-current-view)");
	                    var focusedViewIndex = views.index((that._focusedView && that._focusedView[0]) || views.closest(DOT + ganttStyles.selected)[0]);

	                    if (e.keyCode === keys.RIGHT) {
	                        $(that.toolbar.find(DOT + ganttStyles.focused)).removeClass(ganttStyles.focused);
	                        that._focusedView = focusedViewIndex + 1 === views.length ? $(views[0]) : $(views[focusedViewIndex + 1]);
	                        that._focusedView.focus().addClass(ganttStyles.focused);
	                        e.preventDefault();
	                    } else if (e.keyCode === keys.LEFT) {
	                        $(that.toolbar.find(DOT + ganttStyles.focused)).removeClass(ganttStyles.focused);
	                        that._focusedView = focusedViewIndex === 0 ? $(views[views.length - 1]) : $(views[focusedViewIndex - 1]);
	                        that._focusedView.focus().addClass(ganttStyles.focused);
	                        e.preventDefault();
	                    } else if ((e.keyCode === keys.ENTER || e.keyCode === keys.SPACEBAR) && that._focusedView) {
	                        that.view(that._focusedView.text().toLowerCase());
	                        e.preventDefault();
	                    } else if (e.keyCode >= 49 && e.keyCode <= 57) {
	                        that.view(that.timeline._viewByIndex(e.keyCode - 49));
	                    }
	                })
	                .on(CLICK + NS, pdfSelector, function(e) {
	                    e.preventDefault();

	                    that.saveAsPDF();
	                })
	                .on(CLICK + NS, toggleSelector, function(e) {
	                    e.preventDefault();

	                    if (treelist.is(":visible")) {
	                        treelist.addClass("k-hidden");
	                        timeline.removeClass("k-hidden");

	                        that.refresh();

	                        timeline
	                            .find(contentSelector)
	                            .scrollTop(that.scrollTop);
	                    } else {
	                        treelist.removeClass("k-hidden");
	                        timeline.addClass("k-hidden");

	                        treelist
	                            .find(contentSelector)
	                            .scrollTop(that.scrollTop);
	                    }

	                    that._resize();
	                });

	            this.wrapper
	                .on("focusout" + NS, function(e) {
	                    if (!$(e.relatedTarget).closest(DOT + ganttStyles.toolbar.toolbar).length) {
	                        that.toolbar.find(DOT + ganttStyles.focused).removeClass(ganttStyles.focused);
	                    }
	                    if (!$(e.relatedTarget).closest(DOT + ganttStyles.toolbar.views).length) {
	                        that.toolbar.find(DOT + ganttStyles.toolbar.views).removeClass(ganttStyles.toolbar.expanded);
	                    }
	                });

	        },

	        _actions: function() {
	            var options = this.options;
	            var editable = options.editable;
	            var actions = options.toolbar;
	            var html = "";
	            var action;

	            if (!isArray(actions)) {
	                if (editable && editable.create !== false) {
	                    actions = ["append"];
	                } else {
	                    return html;
	                }
	            }

	            for (var i = 0, length = actions.length; i < length; i++) {
	                action = actions[i];

	                if(action === "plannedTasks" || action.name === "plannedTasks") {
	                    this._createPlannedTasksSwitch();
	                    continue;
	                }

	                html += this._createButton(action);
	            }

	            return html;
	        },

	        _footer: function() {
	            var editable = this.options.editable;

	            if (!editable || editable.create === false) {
	                return;
	            }

	            var ganttStyles = Gantt.styles.toolbar;
	            var messages = this.options.messages.actions;
	            var button = $(kendo.template(BUTTON_TEMPLATE)(extend(true, { styles: ganttStyles }, defaultCommands.append, { text: messages.append })));
	            var footer = $("<div class='" + ganttStyles.footerWrapper + "'>").append(button);

	            this.wrapper.append(footer);
	            this.footer = footer;
	        },

	        _createButton: function(command) {
	            var template = command.template || BUTTON_TEMPLATE;
	            var messages = this.options.messages.actions;
	            var commandName = typeof command === STRING ? command : command.name || command.text;
	            var className = defaultCommands[commandName] ? defaultCommands[commandName].className : "k-gantt-" + (commandName || "").replace(/\s/g, "");
	            var options = {
	                iconClass: "",
	                action: "",
	                text: commandName,
	                className: className,
	                styles: Gantt.styles.toolbar
	            };

	            if (!commandName && !(isPlainObject(command) && command.template))  {
	                throw new Error("Custom commands should have name specified");
	            }

	            options = extend(true, options, defaultCommands[commandName], { text: messages[commandName] });

	            if (isPlainObject(command)) {
	                if (command.className && inArray(options.className, command.className.split(" ")) < 0) {
	                    command.className += " " + options.className;
	                }

	                options = extend(true, options, command);
	            }

	            return kendo.template(template)(options);
	        },

	        _adjustDimensions: function() {
	            var element = this.element;
	            var toolbarHeight = outerHeight(this.toolbar);
	            var footerHeight = this.footer ? outerHeight(this.footer) : 0;
	            var totalHeight = element.height();
	            var totalWidth = element.width();
	            var splitBarWidth = this.splitbar.is(":visible") ? outerWidth(this.splitbar) : 0;
	            var treeListWidth = this.treelistWrapper.is(":visible") ? outerWidth(this.treelistWrapper) : 0;
	            var timelineWidth = totalWidth - ( treeListWidth + splitBarWidth );

	            this.layout.children().height(totalHeight - (toolbarHeight + footerHeight));
	            this.timelineWrapper.width(timelineWidth);

	            if (totalWidth < (treeListWidth + splitBarWidth)) {
	                this.treelistWrapper.width(totalWidth - splitBarWidth);
	            }
	        },

	        _scrollTo: function(value) {
	            var view = this.timeline.view();
	            var list = this.list;
	            var attr = kendo.attr("uid");
	            var id = typeof value === "string" ? value :
	                value.closest("tr" + selector()).attr(attr);
	            var action;
	            var scrollTarget;
	            var scrollIntoView = function() {
	                if (scrollTarget.length !== 0) {
	                    action();
	                }
	            };

	            if (view.content.is(":visible")) {
	                scrollTarget = view.content.find(selector(id));
	                action = function() {
	                    view._scrollTo(scrollTarget);
	                };
	            } else {
	                scrollTarget = list.element.find(selector(id));
	                action = function() {
	                    scrollTarget.get(0).scrollIntoView();
	                };
	            }

	            scrollIntoView();
	        },

	        _dropDowns: function() {
	            var that = this;
	            var actionsSelector = DOT + Gantt.styles.toolbar.appendButton;
	            var actionMessages = this.options.messages.actions;
	            var timeline = this.timeline;
	            var editable = this.options.editable;

	            var handler = function(e) {
	                var type = e.type;
	                var orderId;
	                var dataSource = that.dataSource;
	                var task = dataSource._createNewModel({});
	                var selected = that.dataItem(that.select());
	                var parent = dataSource.taskParent(selected);
	                var firstSlot = timeline.view()._timeSlots()[0];
	                var target = type === "add" ? selected : parent;
	                var editable = that.list.editor;

	                if (editable && editable.trigger("validate")) {
	                    return;
	                }

	                task.set("title", "New task");

	                if (target) {
	                    task.set("parentId", target.get("id"));
	                    task.set("start", target.get("start"));
	                    task.set("end", target.get("end"));
	                    task.set("plannedStart", target.get("plannedStart"));
	                    task.set("plannedEnd", target.get("plannedEnd"));
	                } else {
	                    task.set("start", firstSlot.start);
	                    task.set("end", firstSlot.end);
	                }

	                if (type !== "add") {
	                    orderId = selected.get("orderId");
	                    orderId = type === "insert-before" ? orderId : orderId + 1;
	                }

	                that._createTask(task, orderId);
	            };

	            if (!editable || editable.create === false) {
	                return;
	            }

	            this.footerDropDown = new kendo.gantt.TaskDropDown(this.footer.children(actionsSelector).eq(0), {
	                messages: {
	                    actions: actionMessages
	                },
	                direction: "up",
	                animation: {
	                    open: {
	                        effects: "slideIn:up"
	                    }
	                },
	                navigatable: that.options.navigatable
	            });

	            this.headerDropDown = new kendo.gantt.TaskDropDown(this.toolbar.children(actionsSelector).eq(0), {
	                messages: {
	                    actions: actionMessages
	                },
	                navigatable: that.options.navigatable
	            });

	            this.footerDropDown.bind("command", handler);
	            this.headerDropDown.bind("command", handler);
	        },

	        _getListEditable: function() {
	            var editable = false,
	                options = this.options;

	            if(options.editable !== false) {
	                if(options.editable) {
	                    if(options.editable.update === false) {
	                        editable = false;
	                    } else if(options.editable.reorder !== false) {
	                        editable = {
	                            mode: "incell",
	                            move: {
	                                reorderable: true
	                            }
	                        };
	                    }
	                } else {
	                    editable = "incell";
	                }
	            }

	            return editable;
	        },

	        _getListOptions: function() {
	            var options = this.options,
	                editable = this._getListEditable(),
	                listWrapper = this.wrapper.find(DOT + ganttStyles.list),
	                ganttListOptions = {
	                    columns: options.columns || [],
	                    dataSource: this.dataSource,
	                    selectable: options.selectable,
	                    reorderable: options.reorderable,
	                    editable: editable,
	                    resizable: options.resizable,
	                    filterable: options.filterable,
	                    columnMenu: options.columnMenu,
	                    columnResizeHandleWidth: this.options.columnResizeHandleWidth,
	                    listWidth: outerWidth(listWrapper),
	                    resourcesField: this.resources.field,
	                    rowHeight: this.options.rowHeight
	                };

	            return ganttListOptions;
	        },

	        _attachResourceEditor: function(columns) {
	            var column;

	            for (var i = 0; i < columns.length; i++) {
	                column = columns[i];

	                if (column.field === this.resources.field && typeof column.editor !== "function") {
	                    column.editor = proxy(this._createResourceEditor, this);
	                }
	            }
	        },

	        _attachListEvents: function() {
	            var that = this,
	                navigatable = that.options.navigatable,
	                toggleButtons = this.wrapper.find(DOT + ganttStyles.toolbar.toolbar + " " + DOT + ganttStyles.toolbar.appendButton),
	                restoreFocus = function() {
	                    var element;

	                    if (navigatable && that._cachedCurrent) {
	                        element = that.list.content.find("tr").eq(that._cachedCurrent.rowIndex).find("td").eq(that._cachedCurrent.columnIndex);

	                        that._current(element);

	                        focusTable(that.list.content.find("table"), true);
	                    }

	                    delete that._cachedCurrent;
	                };

	            that.list
	                .bind("render", function() {
	                    that._navigatable();
	                 }, true)
	                .bind("beforeEdit", function(e) {
	                    that._cachedCurrent = {
	                        rowIndex: e.container.closest("tr").index(),
	                        columnIndex: e.container.index()
	                    };

	                    if (that.trigger("edit", { task: e.model, container: e.container })) {
	                        e.preventDefault();
	                    }
	                })
	                .bind("cancel", function(e) {
	                    if (that.trigger("cancel", { task: e.model, container: e.cell })) {
	                        e.preventDefault();
	                        return;
	                    }

	                    that._preventItemChange = true;
	                    that.list.closeCell(true);
	                    restoreFocus();
	                })
	                .bind("save", function(e) {
	                    var updatedValues = e.values;
	                    that._preventRefresh = true;

	                    if(that.updateDuration === null || that.updateDuration === undefined) {
	                        that.updateDuration = e.model.duration();
	                    }

	                    if (updatedValues.hasOwnProperty("start")) {
	                        updatedValues.end = new Date(updatedValues.start.getTime() + that.updateDuration);
	                    }

	                    that.updatedValues = updatedValues;
	                })
	                .bind("itemChange", function(e) {
	                    var updateInfo = that.updatedValues;
	                    var task = e.data;
	                    var resourcesField = that.resources.field;

	                    if(that._preventItemChange) {
	                        that._preventItemChange = false;
	                        return;
	                    }

	                    if (!that.trigger("save", { task: task, values: updateInfo })) {
	                        if(updateInfo) {
	                            that._preventRefresh = true;
	                            that.dataSource.update(task, updateInfo);

	                            if (updateInfo[resourcesField]) {
	                                that._updateAssignments(task.get("id"), updateInfo[resourcesField]);
	                            }
	                        }

	                        that._preventRefresh = false;
	                        that._requestStart();
	                        that.dataSource.sync().then(function() {
	                            restoreFocus();
	                        });
	                    } else if(that.dataSource.hasChanges()) {
	                        that.dataSource.cancelChanges();
	                        that._preventRefresh = false;
	                        that.refresh();
	                    }

	                    that.updatedValues = null;
	                    that.updateDuration = null;
	                })
	                .bind("change", function() {
	                    that.trigger("change");

	                    var selection = that.list.select();

	                    if (selection.length) {
	                        toggleButtons.removeAttr("data-action", "add");
	                        that.timeline.select("[data-uid='" + selection.attr("data-uid") + "']");
	                    } else {
	                        toggleButtons.attr("data-action", "add");
	                        that.timeline.clearSelection();
	                    }
	                })
	                .bind("columnResize", function(e) {
	                    that.trigger("columnResize", { column: e.column, oldWidth: e.oldWidth, newWidth: e.newWidth });
	                })
	                .bind("collapse", function(e) {
	                    e.preventDefault();

	                    var row = that.list.element.find("tr[data-uid='" + e.model.uid + "']");
	                    e.model.set("expanded", false);

	                    that._cachedCurrent = {
	                        rowIndex: row.index(),
	                        columnIndex: row.find(".k-state-focused").index()
	                    };

	                    restoreFocus();
	                })
	                .bind("expand", function(e) {
	                    e.preventDefault();

	                    var row = that.list.element.find("tr[data-uid='" + e.model.uid + "']");
	                    e.model.set("expanded", true);

	                    that._cachedCurrent = {
	                        rowIndex: row.index(),
	                        columnIndex: row.find(".k-state-focused").index()
	                    };

	                    restoreFocus();
	                })
	                .bind("dragend", function(e) {
	                    var dataSource = that.dataSource,
	                        task, updateInfo;

	                    if(e.position === "over") {
	                        updateInfo = {
	                            parentId: e.source.parentId
	                        };
	                        dataSource.cancelChanges();
	                        task = dataSource.get(e.source.id);

	                        if (!that.trigger("save", { task: task, values: updateInfo })) {
	                            dataSource.update(task, updateInfo);
	                        }
	                    }

	                    dataSource.sync();
	                })
	                .bind("dataBound", function() {
	                    if(that.dataSource.sort().length === 0) {
	                        that.dataSource.sort([{field: "orderId", dir: "asc"}]);
	                    }
	                })
	                .bind("reorder", function(e) {
	                    that._updateTask(e.task, e.updateInfo);
	                    restoreFocus();
	                });
	        },

	        _list: function() {
	            var ganttStyles = Gantt.styles,
	                listWrapper = this.wrapper.find(DOT + ganttStyles.list),
	                listElement = listWrapper.find("> div"),
	                listOptions = this._getListOptions();

	            this._attachResourceEditor(listOptions.columns);

	            this.list = new kendo.ui.GanttList(listElement, listOptions);

	            this._attachListEvents();
	        },

	        _timeline: function() {
	            var that = this;
	            var ganttStyles = Gantt.styles;
	            var options = trimOptions(extend(true, { resourcesField: this.resources.field }, this.options));
	            var element = this.wrapper.find(DOT + ganttStyles.timeline + " > div");

	            this.timeline = new kendo.ui.GanttTimeline(element, options);

	            this.timeline
	                .bind("navigate", function(e) {
	                    var viewName = e.view.replace(/\./g, "\\.").toLowerCase();

	                    that.toolbar
	                        .find(DOT + ganttStyles.toolbar.views + " > button")
	                        .removeClass(ganttStyles.selected)
	                        .end()
	                        .find(DOT + ganttStyles.toolbar.viewButton + "-" + viewName)
	                        .addClass(ganttStyles.selected);

	                    that.toolbar
	                        .find(DOT + ganttStyles.toolbar.viewsDropdown)
	                        .val(viewName);

	                    that.refresh();
	                })
	                .bind("moveStart", function(e) {
	                    var editable = that.list.editor;

	                    if (editable && !editable.end()) {
	                        e.preventDefault();
	                        return;
	                    }

	                    if (that.trigger("moveStart", { task: e.task })) {
	                        e.preventDefault();
	                    }
	                })
	                .bind("move", function(e) {
	                    var task = e.task;
	                    var start = e.start;
	                    var end = new Date(start.getTime() + task.duration());

	                    if (that.trigger("move", { task: task, start: start, end: end })) {
	                        e.preventDefault();
	                    }
	                })
	                .bind("moveEnd", function(e) {
	                    var task = e.task;
	                    var start = e.start;
	                    var end = new Date(start.getTime() + task.duration());

	                    if (!that.trigger("moveEnd", { task: task, start: start, end: end })) {
	                        that._updateTask(that.dataSource.getByUid(task.uid), {
	                            start: start,
	                            end: end
	                        });
	                    }
	                })
	                .bind("resizeStart", function(e) {
	                    var editable = that.list.editor;

	                    if (editable && !editable.end()) {
	                        e.preventDefault();
	                        return;
	                    }

	                    if (that.trigger("resizeStart", { task: e.task })) {
	                        e.preventDefault();
	                    }
	                })
	                .bind("resize", function(e) {
	                    if (that.trigger("resize", { task: e.task, start: e.start, end: e.end })) {
	                        e.preventDefault();
	                    }
	                })
	                .bind("resizeEnd", function(e) {
	                    var task = e.task;
	                    var updateInfo = {};

	                    if (e.resizeStart) {
	                        updateInfo.start = e.start;
	                    } else {
	                        updateInfo.end = e.end;
	                    }

	                    if (!that.trigger("resizeEnd", { task: task, start: e.start, end: e.end })) {
	                        that._updateTask(that.dataSource.getByUid(task.uid), updateInfo);
	                    }
	                })
	                .bind("percentResizeStart", function(e) {
	                    var editable = that.list.editor;

	                    if (editable && !editable.end()) {
	                        e.preventDefault();
	                    }
	                })
	                .bind("percentResizeEnd", function(e) {
	                    that._updateTask(that.dataSource.getByUid(e.task.uid), { percentComplete: e.percentComplete });
	                })
	                .bind("dependencyDragStart", function(e) {
	                    var editable = that.list.editor;

	                    if (editable && !editable.end()) {
	                        e.preventDefault();
	                    }
	                })
	                .bind("dependencyDragEnd", function(e) {
	                    var dependency = that.dependencies._createNewModel({
	                        type: e.type,
	                        predecessorId: e.predecessor.id,
	                        successorId: e.successor.id
	                    });

	                    that._createDependency(dependency);
	                })
	                .bind("select", function(e) {
	                    var editable = that.list.editor;

	                    if (editable) {
	                        editable.end();
	                    }

	                    that.select("[data-uid='" + e.uid + "']");
	                })
	                .bind("editTask", function(e) {
	                    var editable = that.list.editor;

	                    if (editable && !editable.end()) {
	                        return;
	                    }

	                    that.editTask(e.uid);
	                })
	                .bind("clear", function() {
	                    that.clearSelection();
	                })
	                .bind("removeTask", function(e) {
	                    var editable = that.list.editor;

	                    if (editable && !editable.end()) {
	                        return;
	                    }

	                    that.removeTask(that.dataSource.getByUid(e.uid));
	                })
	                .bind("removeDependency", function(e) {
	                    var editable = that.list.editor;

	                    if (editable && !editable.end()) {
	                        return;
	                    }

	                    that.removeDependency(that.dependencies.getByUid(e.uid));
	                });
	        },

	        _dataSource: function() {
	            var options = this.options;
	            var dataSource = options.dataSource;

	            dataSource = isArray(dataSource) ? { data: dataSource } : dataSource;

	            if (this.dataSource && this._refreshHandler) {
	                this.dataSource
	                    .unbind("change", this._refreshHandler)
	                    .unbind("progress", this._progressHandler)
	                    .unbind("error", this._errorHandler);
	            } else {
	                this._refreshHandler = proxy(this.refresh, this);
	                this._progressHandler = proxy(this._requestStart, this);
	                this._errorHandler = proxy(this._error, this);
	            }

	            this.dataSource = kendo.data.GanttDataSource.create(dataSource)
	                .bind("change", this._refreshHandler)
	                .bind("progress", this._progressHandler)
	                .bind("error", this._errorHandler);
	        },

	        _dependencies: function() {
	            var dependencies = this.options.dependencies || {};
	            var dataSource = isArray(dependencies) ? { data: dependencies } : dependencies;

	            if (this.dependencies && this._dependencyRefreshHandler) {
	                this.dependencies
	                    .unbind("change", this._dependencyRefreshHandler)
	                    .unbind("error", this._dependencyErrorHandler);
	            } else {
	                this._dependencyRefreshHandler = proxy(this.refreshDependencies, this);
	                this._dependencyErrorHandler = proxy(this._error, this);
	            }

	            this.dependencies = kendo.data.GanttDependencyDataSource.create(dataSource)
	                .bind("change", this._dependencyRefreshHandler)
	                .bind("error", this._dependencyErrorHandler);
	        },

	        _resources: function() {
	            var resources = this.options.resources;
	            var dataSource = resources.dataSource || {};

	            this.resources = {
	                field: "resources",
	                dataTextField: "name",
	                dataColorField: "color",
	                dataFormatField: "format"
	            };

	            extend(this.resources, resources);

	            this.resources.dataSource = kendo.data.DataSource.create(dataSource);
	        },

	        _assignments: function() {
	            var assignments = this.options.assignments;
	            var dataSource = assignments.dataSource || { };

	            if (this.assignments) {
	                this.assignments.dataSource
	                    .unbind("change", this._assignmentsRefreshHandler);
	            } else {
	                this._assignmentsRefreshHandler = proxy(this.refresh, this);
	            }

	            this.assignments = {
	                dataTaskIdField: "taskId",
	                dataResourceIdField: "resourceId",
	                dataValueField: "value"
	            };

	            extend(this.assignments, assignments);

	            this.assignments.dataSource = kendo.data.DataSource.create(dataSource);

	            this.assignments.dataSource.
	                bind("change", this._assignmentsRefreshHandler);
	        },

	        _createEditor: function() {
	            var that = this;

	            var editor = this._editor = new kendo.gantt.PopupEditor(this.wrapper, extend({}, this.options, {
	                target: this,
	                resources: {
	                    field: this.resources.field,
	                    editor: proxy(this._createResourceEditor, this)
	                },
	                createButton: proxy(this._createPopupButton, this)
	            }));

	            editor
	                .bind("cancel", function(e) {
	                    var task = that.dataSource.getByUid(e.model.uid);

	                    if (that.trigger("cancel", { container: e.container, task: task })) {
	                        e.preventDefault();
	                        return;
	                    }

	                    that.cancelTask();
	                })
	                .bind("edit", function(e) {
	                    var task = that.dataSource.getByUid(e.model.uid);

	                    if (that.trigger("edit", { container: e.container, task: task })) {
	                        e.preventDefault();
	                    }
	                })
	                .bind("save", function(e) {
	                    var task = that.dataSource.getByUid(e.model.uid);

	                    that.saveTask(task, e.updateInfo);
	                })
	                .bind("remove", function(e) {
	                    that.removeTask(e.model.uid);
	                })
	                .bind("close", that._onDialogClose);
	        },

	        _onDialogClose: function() {},

	        _createResourceEditor: function(container, options) {
	            var that = this;
	            var model = options instanceof ObservableObject ? options : options.model;
	            var id = model.get("id");
	            var messages = this.options.messages;
	            var resourcesField = this.resources.field;
	            var unitsValidation = { step: 0.01 };
	            var assignmentsModel = this.assignments.dataSource.options.schema.model;

	            if (assignmentsModel && assignmentsModel.fields.Units && assignmentsModel.fields.Units.validation) {
	                extend(true, unitsValidation, assignmentsModel.fields.Units.validation);
	            }

	            var editor = this._resourceEditor = new kendo.gantt.ResourceEditor(container, {
	                resourcesField: resourcesField,
	                unitsValidation: unitsValidation,
	                data: this._wrapResourceData(id),
	                model: model,
	                messages: extend({}, messages.editor),
	                buttons: [
	                    { name: "update", text: messages.save, className: Gantt.styles.primary },
	                    { name: "cancel", text: messages.cancel }
	                ],
	                createButton: proxy(this._createPopupButton, this),
	                save: function(e) {
	                    that._updateAssignments(e.model.get("id"), e.model.get(resourcesField));
	                }
	            });

	            editor.open();
	        },

	        _createPopupButton: function(command) {
	            var commandName = command.name || command.text;
	            var options = {
	                className: Gantt.styles.popup.button + " k-gantt-" + (commandName || "").replace(/\s/g, ""),
	                text: commandName,
	                attr: ""
	            };

	            if (!commandName && !(isPlainObject(command) && command.template))  {
	                throw new Error("Custom commands should have name specified");
	            }

	            if (isPlainObject(command)) {
	                if (command.className) {
	                    command.className += " " + options.className;
	                }

	                options = extend(true, options, command);
	            }

	            return kendo.template(COMMAND_BUTTON_TEMPLATE)(options);
	        },

	        view: function(type) {
	            return this.timeline.view(type);
	        },

	        range: function (range) {
	            var dataSource = this.dataSource;
	            var view = this.view();
	            var timeline = this.timeline;

	            if (range) {
	                view.options.range = {
	                    start: range.start,
	                    end: range.end
	                };

	                timeline._render(dataSource.taskTree());
	                timeline._renderDependencies(this.dependencies.view());
	            }

	            return {
	                start: view.start,
	                end: view.end
	            };
	        },

	        date: function (date) {
	            var view = this.view();

	            if (date) {
	                view.options.date = date;
	                view._scrollToDate(date);
	            }

	            return view.options.date;
	        },

	        dataItem: function(value) {
	            if (!value) {
	                return null;
	            }

	            var list = this.list;
	            var element = list.element.find(value);

	            return list._modelFromElement(element);
	        },

	        setDataSource: function(dataSource) {
	            this.options.dataSource = dataSource;

	            this._dataSource();

	            this.list.setDataSource(this.dataSource);

	            if (this.options.autoBind) {
	                dataSource.fetch();
	            }
	        },

	        setDependenciesDataSource: function(dependencies) {
	            this.options.dependencies = dependencies;

	            this._dependencies();

	            if (this.options.autoBind) {
	                dependencies.fetch();
	            }
	        },

	        items: function() {
	            return this.wrapper.children(".k-task");
	        },

	        _updateAssignments: function(id, resources) {
	            var dataSource = this.assignments.dataSource;
	            var taskId = this.assignments.dataTaskIdField;
	            var resourceId = this.assignments.dataResourceIdField;
	            var hasMatch = false;
	            var assignments = new Query(dataSource.view())
	                .filter({
	                    field: taskId,
	                    operator: "eq",
	                    value: id
	                }).toArray();
	            var assignment;
	            var resource;
	            var value;

	            while (assignments.length) {
	                assignment = assignments[0];

	                for (var i = 0, length = resources.length; i < length; i++) {
	                    resource = resources[i];

	                    if (assignment.get(resourceId) === resource.get("id")) {
	                        value = resources[i].get("value");
	                        this._updateAssignment(assignment, value);
	                        resources.splice(i, 1);
	                        hasMatch = true;
	                        break;
	                    }
	                }

	                if (!hasMatch) {
	                    this._removeAssignment(assignment);
	                }

	                hasMatch = false;

	                assignments.shift();
	            }

	            for (var j = 0, newLength = resources.length; j < newLength; j++) {
	                resource = resources[j];
	                this._createAssignment(resource, id);
	            }

	            dataSource.sync();
	        },

	        cancelTask: function() {
	            var editor = this._editor;
	            var container = editor.container;

	            if (container) {
	                editor.close();
	            }
	        },

	        editTask: function(uid) {
	            var task = typeof uid === "string" ? this.dataSource.getByUid(uid) : uid;

	            if (!task) {
	                return;
	            }

	            var taskCopy = this.dataSource._createNewModel(task.toJSON());
	            taskCopy.uid = task.uid;

	            this.cancelTask();

	            this._editTask(taskCopy);
	        },

	        _editTask: function(task) {
	            this._editor.editTask(task, this.options.editable.plannedTasks);
	        },

	        saveTask: function(task, updateInfo) {
	            var editor = this._editor;
	            var container = editor.container;
	            var editable = editor.editable;

	            if (container && editable && editable.end()) {
	                this._updateTask(task, updateInfo);
	            }
	        },

	        _updateTask: function(task, updateInfo) {
	            var that = this;
	            var resourcesField = that.resources.field;

	            if (!that.trigger("save", { task: task, values: updateInfo })) {
	                if(updateInfo) {
	                    that._preventRefresh = true;

	                    that.dataSource.update(task, updateInfo);

	                    if (updateInfo[resourcesField]) {
	                        that._updateAssignments(task.get("id"), updateInfo[resourcesField]);
	                    }
	                }

	                that._syncDataSource();
	            } else if(that.dataSource.hasChanges()) {
	                that.dataSource.cancelChanges();
	                that._preventRefresh = false;
	                that.refresh();
	            }
	        },

	        _updateAssignment: function(assignment, value) {
	            var resourceValueField = this.assignments.dataValueField;

	            assignment.set(resourceValueField, value);
	        },

	        removeTask: function(uid) {
	            var that = this;
	            var task = typeof uid === "string" ? this.dataSource.getByUid(uid) : uid;

	            if (!task) {
	                return;
	            }

	            this._taskConfirm(function(cancel) {
	                if (!cancel) {
	                    that._removeTask(task);
	                }
	            }, task);
	        },

	        _createTask: function(task, index) {
	            if (!this.trigger("add", {
	                task: task,
	                dependency: null
	            })) {
	                var dataSource = this.dataSource;

	                this._preventRefresh = true;

	                if (index === undefined) {
	                    dataSource.add(task);
	                } else {
	                    dataSource.insert(index, task);
	                }

	                this._scrollToUid = task.uid;
	                this._syncDataSource();
	            }
	        },

	        _createDependency: function(dependency) {
	            if (!this.trigger("add", {
	                task: null,
	                dependency: dependency
	            })) {
	                this._preventDependencyRefresh = true;

	                this.dependencies.add(dependency);

	                this._preventDependencyRefresh = false;

	                this.dependencies.sync();
	            }
	        },

	        _createAssignment: function(resource, id) {
	            var assignments = this.assignments;
	            var dataSource = assignments.dataSource;
	            var taskId = assignments.dataTaskIdField;
	            var resourceId = assignments.dataResourceIdField;
	            var resourceValue = assignments.dataValueField;
	            var assignment = dataSource._createNewModel();

	            assignment[taskId] = id;
	            assignment[resourceId] = resource.get("id");
	            assignment[resourceValue] = resource.get("value");

	            dataSource.add(assignment);
	        },

	        removeDependency: function(uid) {
	            var that = this;
	            var dependency = typeof uid === "string" ? this.dependencies.getByUid(uid) : uid;

	            if (!dependency) {
	                return;
	            }

	            this._dependencyConfirm(function(cancel) {
	                if (!cancel) {
	                    that._removeDependency(dependency);
	                }
	            }, dependency);
	        },

	        _removeTaskDependencies: function(task, dependencies) {
	            this._preventDependencyRefresh = true;

	            for (var i = 0, length = dependencies.length; i < length; i++) {
	                this.dependencies.remove(dependencies[i]);
	            }

	            this._preventDependencyRefresh = false;

	            this.dependencies.sync();
	        },

	        _removeTaskAssignments: function(task) {
	            var dataSource = this.assignments.dataSource;
	            var assignments = dataSource.view();
	            var filter = {
	                field: this.assignments.dataTaskIdField,
	                operator: "eq",
	                value: task.get("id")
	            };

	            assignments = new Query(assignments).filter(filter).toArray();

	            this._preventRefresh = true;

	            for (var i = 0, length = assignments.length; i < length; i++) {
	                dataSource.remove(assignments[i]);
	            }

	            this._preventRefresh = false;

	            dataSource.sync();
	        },

	        _removeTask: function(task) {
	            var dependencies = this.dependencies.dependencies(task.id);

	            if (!this.trigger("remove", {
	                task: task,
	                dependencies: dependencies
	            })) {
	                this._removeTaskDependencies(task, dependencies);
	                this._removeTaskAssignments(task);

	                this._preventRefresh = true;

	                if (this.dataSource.remove(task)) {
	                    this._syncDataSource();
	                }

	                this._preventRefresh = false;
	            }
	        },

	        _removeDependency: function(dependency) {
	            if (!this.trigger("remove", {
	                task: null,
	                dependencies: [dependency]
	            })) {
	                if (this.dependencies.remove(dependency)) {
	                    this.dependencies.sync();
	                }
	            }
	        },

	        _removeAssignment: function(assignment) {
	            this.assignments.dataSource.remove(assignment);
	        },

	        _taskConfirm: function(callback, task) {
	            var messages = this.options.messages;

	            this._confirm(callback, {
	                model: task,
	                text: messages.deleteTaskConfirmation,
	                title: messages.deleteTaskWindowTitle
	            });
	        },

	        _dependencyConfirm: function(callback, dependency) {
	            var messages = this.options.messages;

	            this._confirm(callback, {
	                model: dependency,
	                text: messages.deleteDependencyConfirmation,
	                title: messages.deleteDependencyWindowTitle
	            });
	        },

	        _confirm: function(callback, options) {
	            var editable = this.options.editable;
	            var messages;
	            var buttons;

	            if (editable === true || editable.confirmation !== false) {
	                messages = this.options.messages;
	                buttons = [
	                    { name: "delete", text: messages.destroy, className: Gantt.styles.primary, click: function() { callback(); } },
	                    { name: "cancel", text: messages.cancel, click: function() { callback(true); } }
	                ];

	                this.showDialog(extend(true, {}, options, { buttons: buttons }));
	            } else {
	                callback();
	            }
	        },

	        showDialog: function(options) {
	            this._editor.showDialog(options);
	        },

	        refresh: function() {
	            if (this._preventRefresh || !this.list || this.list.editor) {
	                return;
	            }

	            this._progress(false);

	            var dataSource = this.dataSource;
	            var taskTree = dataSource.taskTree();
	            var scrollToUid = this._scrollToUid;
	            var current;
	            var cachedUid;
	            var cachedIndex = -1;

	            if (this.current) {
	                cachedUid = this.current.closest("tr").attr(kendo.attr("uid"));
	                cachedIndex = this.current.index();
	            }

	            if (this.trigger("dataBinding")) {
	                return;
	            }

	            if (this.resources.dataSource.data().length !== 0) {
	                this._assignResources(taskTree);
	            }

	            if (this._editor) {
	                this._editor.close();
	            }

	            this.clearSelection();
	            this.list._renderTree(taskTree);
	            this.timeline._render(taskTree);
	            this.timeline._renderDependencies(this.dependencies.view());

	            if (scrollToUid) {
	                this._scrollTo(scrollToUid);
	                this.select(selector(scrollToUid));
	            }

	            if ((scrollToUid || cachedUid) && cachedIndex >= 0) {
	                current = this.list.element
	                    .find("tr" + selector((scrollToUid || cachedUid)) + " > td:eq(" + cachedIndex + ")");

	                this._current(current);
	            }

	            this._scrollToUid = null;

	            this.trigger("dataBound");
	        },

	        refreshDependencies: function() {
	            if (this._preventDependencyRefresh) {
	                return;
	            }

	            if (this.trigger("dataBinding")) {
	                return;
	            }

	            this.timeline._renderDependencies(this.dependencies.view());

	            this.trigger("dataBound");
	        },

	        _assignResources: function(taskTree) {
	            var resources = this.resources;
	            var assignments = this.assignments;
	            var groupAssigments = function() {
	                var data = assignments.dataSource.view();
	                var group = {
	                    field: assignments.dataTaskIdField
	                };

	                data = new Query(data).group(group).toArray();

	                return data;
	            };
	            var assigments = groupAssigments();
	            var applyTaskResource = function(task, action) {
	                var taskId = task.get("id");

	                kendo.setter(resources.field)(task, new ObservableArray([]));

	                for (var i = 0, length = assigments.length; i < length; i++) {
	                    if (assigments[i].value === taskId) {
	                        action(task, assigments[i].items);
	                    }
	                }
	            };
	            var wrapTask = function(task, items) {
	                for (var j = 0, length = items.length; j < length; j++) {
	                    var item = items[j];
	                    var resource = resources.dataSource.get(item.get(assignments.dataResourceIdField));
	                    var resourceValue = item.get(assignments.dataValueField);
	                    var resourcedId = item.get(assignments.dataResourceIdField);
	                    var valueFormat = resource.get(resources.dataFormatField) || PERCENTAGE_FORMAT;
	                    var formatedValue = kendo.toString(resourceValue, valueFormat);

	                    task[resources.field].push(new ObservableObject({
	                        id: resourcedId,
	                        name: resource.get(resources.dataTextField),
	                        color: resource.get(resources.dataColorField),
	                        value: resourceValue,
	                        formatedValue: formatedValue
	                    }));
	                }
	            };

	            for (var i = 0, length = taskTree.length; i < length; i++) {
	                applyTaskResource(taskTree[i], wrapTask);
	            }
	        },

	        _wrapResourceData: function(id) {
	            var that = this;
	            var result = [];
	            var resource;
	            var resources = this.resources.dataSource.view();
	            var assignments = this.assignments.dataSource.view();
	            var taskAssignments = new Query(assignments).filter({
	                field: that.assignments.dataTaskIdField,
	                operator: "eq",
	                value: id
	            }).toArray();
	            var valuePerResource = function(id) {
	                var resourceValue = null;

	                new Query(taskAssignments).filter({
	                    field: that.assignments.dataResourceIdField,
	                    operator: "eq",
	                    value: id
	                }).select(function(assignment) {
	                    resourceValue += assignment.get(that.assignments.dataValueField);
	                });

	                return resourceValue;
	            };

	            for (var i = 0, length = resources.length; i < length; i++) {
	                resource = resources[i];
	                result.push({
	                    id: resource.get("id"),
	                    name: resource.get(that.resources.dataTextField),
	                    format: resource.get(that.resources.dataFormatField) || PERCENTAGE_FORMAT,
	                    value: valuePerResource(resource.id)
	                });
	            }

	            return result;
	        },

	        _syncDataSource: function() {
	            this._preventRefresh = false;
	            this._requestStart();
	            this.dataSource.sync();
	        },

	        _requestStart: function() {
	            this._progress(true);
	        },

	        _error: function() {
	            this._progress(false);
	        },

	        _progress: function(toggle) {
	            kendo.ui.progress(this.element, toggle);
	        },

	        _resizable: function() {
	            var that = this;
	            var wrapper = this.wrapper;
	            var ganttStyles = Gantt.styles;
	            var contentSelector = DOT + ganttStyles.gridContent;
	            var treeListWrapper = wrapper.find(DOT + ganttStyles.list);
	            var timelineWrapper = wrapper.find(DOT + ganttStyles.timeline);
	            var treeListWidth;
	            var timelineWidth;
	            var timelineScroll;

	            this._resizeDraggable = wrapper
	                .find(DOT + ganttStyles.splitBar)
	                .height(treeListWrapper.height())
	                .hover(function () {
	                    $(this).addClass(ganttStyles.splitBarHover);
	                }, function () {
	                    $(this).removeClass(ganttStyles.splitBarHover);
	                })
	                .end()
	                .kendoResizable({
	                    orientation: "horizontal",
	                    handle: DOT + ganttStyles.splitBar,
	                    "start": function () {
	                        treeListWidth = treeListWrapper.width();
	                        timelineWidth = timelineWrapper.width();
	                        timelineScroll = kendo.scrollLeft(timelineWrapper.find(contentSelector));
	                    },
	                    "resize": function(e) {
	                        var delta = e.x.initialDelta;

	                        if (kendo.support.isRtl(wrapper)) {
	                            delta *= -1;
	                        }

	                        if (treeListWidth + delta < 0 || timelineWidth - delta < 0) {
	                            return;
	                        }

	                        treeListWrapper.width(treeListWidth + delta);
	                        timelineWrapper.width(timelineWidth - delta);
	                        kendo.scrollLeft(timelineWrapper.find(contentSelector), (timelineScroll + delta));

	                        that.timeline.view()._renderCurrentTime();
	                    }
	                }).data("kendoResizable");
	        },

	        _scrollable: function() {
	            var that = this;
	            var ganttStyles = Gantt.styles;
	            var contentSelector = DOT + ganttStyles.gridContent;
	            var headerSelector = DOT + ganttStyles.gridHeaderWrap;
	            var timelineHeader = this.timeline.element.find(headerSelector);
	            var timelineContent = this.timeline.element.find(contentSelector);
	            var treeListHeader = this.list.element.find(headerSelector);
	            var treeListContent = this.list.element.find(contentSelector);

	            if (mobileOS) {
	                treeListContent.css("overflow-y", "auto");
	            }

	            timelineContent.on("scroll", function() {
	                that.scrollTop = this.scrollTop;
	                kendo.scrollLeft(timelineHeader, this.scrollLeft);
	                treeListContent.scrollTop(this.scrollTop);
	            });

	            treeListContent
	                .on("scroll", function() {
	                    kendo.scrollLeft(treeListHeader, this.scrollLeft);
	                })
	                .on("DOMMouseScroll" + NS + " mousewheel" + NS, function(e) {
	                    var scrollTop = timelineContent.scrollTop();
	                    var delta = kendo.wheelDeltaY(e);

	                    if (delta) {
	                        e.preventDefault();
	                        //In Firefox DOMMouseScroll event cannot be canceled
	                        $(e.currentTarget).one("wheel" + NS, false);

	                        timelineContent.scrollTop(scrollTop + (-delta));
	                    }
	                });
	        },

	        _navigatable: function() {
	            var that = this;
	            var navigatable = this.options.navigatable;
	            var editable = this.options.editable;
	            var ganttStyles = Gantt.styles;
	            var contentSelector = DOT + ganttStyles.gridContent;
	            var headerSelector = DOT + ganttStyles.gridHeaderWrap;
	            var headerTable = this.list.element.find(headerSelector).find("table");
	            var contentTable = this.list.element.find(contentSelector).find("table");
	            var isRtl = kendo.support.isRtl(this.wrapper);
	            var timelineContent = this.timeline.element.find(DOT + ganttStyles.gridContent);
	            var tables = headerTable.add(contentTable);
	            var attr = selector();
	            var cellIndex;
	            var expandState = {
	                collapse: false,
	                expand: true
	            };

	            var scroll = function(reverse) {
	                var width = that.timeline.view()._timeSlots()[0].offsetWidth;
	                kendo.scrollLeft(timelineContent, kendo.scrollLeft(timelineContent) + (reverse ? -width : width));
	            };

	            var scrollVertical = function(reverse) {
	                var height = that.timeline.view()._rowHeight;
	                timelineContent.scrollTop(timelineContent.scrollTop() + (reverse ? -height : height));
	            };

	            var moveVertical = function(method) {
	                var parent = that.current.parent("tr" + selector());
	                var index = that.current.index();
	                var sibling = parent[method]('tr:visible').first();

	                if (that.select().length !== 0) {
	                    that.clearSelection();
	                }

	                if (sibling.length !== 0) {
	                    that._current(sibling.children("td:eq(" + index + ")"));
	                    that._scrollTo(that.current);
	                } else {
	                    if (that.current.is("td") && method == "prevAll") {
	                        focusTable(headerTable);
	                    } else if (that.current.is("th") && method == "nextAll") {
	                        focusTable(contentTable);
	                    }
	                }
	            };
	            var moveHorizontal = function(method) {
	                var subling = that.current[method]();

	                if (subling.length !== 0) {
	                    that._current(subling);
	                    cellIndex = that.current.index();
	                }
	            };
	            var toggleExpandedState = function(value) {
	                var model = that.dataItem(that.current);

	                if (model.summary && model.expanded !== value) {
	                    model.set("expanded", value);
	                }
	            };
	            var deleteAction = function() {
	                var editable = that.options.editable;

	                if (!editable || editable.destroy === false || that.list.editor) {
	                    return;
	                }

	                var selectedTask = that.select();
	                var uid = kendo.attr("uid");

	                if (selectedTask.length) {
	                    that.removeTask(selectedTask.attr(uid));
	                }
	            };

	            $(this.wrapper)
	                .on("mousedown" + NS, "tr" + attr + ", div" + attr + ":not(" + DOT + ganttStyles.line + ")", function(e) {
	                    var currentTarget = $(e.currentTarget);
	                    var isInput = $(e.target).is(":button,a,:input,a>.k-icon,textarea,span.k-icon:not(.k-i-none),span.k-link,.k-input,.k-multiselect-wrap");
	                    var current;

	                    if (e.ctrlKey) {
	                        return;
	                    }

	                    if (navigatable) {
	                        if (currentTarget.is("tr")) {
	                            current = $(e.target).closest("td");
	                        } else {
	                            current = that.list
	                                .content.find("tr" + selector(currentTarget.attr(kendo.attr("uid"))) + " > td:first");
	                        }

	                        that._current(current);
	                    }

	                    if ((navigatable || editable) && !isInput) {
	                        that._focusTimeout = setTimeout(function() {
	                            focusTable(that.list.content.find("table"), true);
	                        }, 2);
	                    }
	                })

	                .on("keydown" + NS, function (e) {
	                    var key = e.keyCode;
	                    var that = this;
	                    var focusableItems = $(that._getToolbarItems());
	                    var idx = focusableItems.index(that.toolbar.find(DOT + ganttStyles.focused)[0]);
	                    if (idx === -1 && $(e.target).closest(DOT + ganttStyles.toolbar.views).length) {
	                        idx = focusableItems.index(that.toolbar.find(".k-gantt-views > .k-state-selected:visible, .k-views-dropdown:visible")[0]);
	                    }
	                    var itemToFocus = e.shiftKey ? focusableItems[idx -  1] : focusableItems[idx +  1];

	                    if (key === keys.F10) {
	                        that.toolbar.find(".k-button:visible:first").addClass(ganttStyles.focused).focus();
	                        e.preventDefault();
	                    } else if (key == keys.TAB && $(e.target).closest(DOT + ganttStyles.toolbar.toolbar).length) {
	                        that.toolbar.find(DOT + ganttStyles.focused).removeClass(ganttStyles.focused).blur();
	                        if (itemToFocus) {
	                            $(itemToFocus).addClass(ganttStyles.focused).focus();
	                            e.preventDefault();
	                            return;
	                        }
	                        if (this.list.element.is(":visible")) {
	                            this.list.element.find("table[role=treegrid]").focus();
	                        } else {
	                            this.element.find(DOT + ganttStyles.tasks)[0].focus();
	                        }
	                        e.preventDefault();
	                    }

	                }.bind(this));

	            if (navigatable !== true) {
	                contentTable
	                    .on("keydown" + NS, function(e) {
	                        if (e.keyCode == keys.DELETE) {
	                            deleteAction();
	                        }
	                    });

	                return;
	            }

	            tables
	                .on("focus" + NS, function() {
	                    var selector = this === contentTable.get(0) ? "td" : "th";
	                    var selection = that.select();
	                    var current = that.current || $((selection.length ? selection : this))
	                        .find(selector + ":eq(" + (cellIndex || 0) + ")");

	                    that._current(current);
	                    $(that.toolbar.find(DOT + ganttStyles.focused)).removeClass(ganttStyles.focused);
	                })
	                .on("blur" + NS, function() {
	                    that._current();

	                    if (this == headerTable) {
	                        $(this).attr(TABINDEX, -1);
	                    }
	                })
	                .on("keydown" + NS, function(e) {
	                    var key = e.keyCode;
	                    var isCell;

	                    if (!that.current) {
	                        return;
	                    }

	                    isCell = that.current.is("td");

	                    switch (key) {
	                        case keys.RIGHT:
	                            e.preventDefault();
	                            if (e.altKey) {
	                                scroll();
	                            } else if (e.ctrlKey) {
	                                toggleExpandedState(isRtl ? expandState.collapse : expandState.expand);
	                            } else {
	                                moveHorizontal(isRtl ? "prev" : "next");
	                            }
	                            break;
	                        case keys.LEFT:
	                            e.preventDefault();
	                            if (e.altKey) {
	                                scroll(true);
	                            } else if (e.ctrlKey) {
	                                toggleExpandedState(isRtl ? expandState.expand : expandState.collapse);
	                            } else {
	                                moveHorizontal(isRtl ? "next" : "prev");
	                            }
	                            break;
	                        case keys.UP:
	                            e.preventDefault();
	                            if (e.altKey) {
	                                scrollVertical(true);
	                            } else {
	                                moveVertical("prevAll");
	                            }
	                            break;
	                        case keys.DOWN:
	                            e.preventDefault();
	                            if (e.altKey) {
	                                scrollVertical();
	                            } else {
	                                moveVertical("nextAll");
	                            }
	                            break;
	                        case keys.SPACEBAR:
	                            e.preventDefault();
	                            if (isCell) {
	                                that.select(that.current.closest("tr"));
	                            }
	                            break;
	                        case keys.ENTER:
	                            e.preventDefault();
	                            if (isCell) {
	                                if (that.options.editable && that.options.editable.update !== false) {
	                                    that.list._startEditHandler(that.current);
	                                    $(this).one("keyup", function(e) {
	                                        /* Stop the event propagation so that the list widget won't close its editor immediately */
	                                        e.stopPropagation();
	                                    });
	                                }
	                            } else {
	                                /* Sort */
	                                that.current
	                                    .children("a.k-link")
	                                    .click();
	                            }
	                            break;
	                        case keys.DELETE:
	                            if (isCell) {
	                                deleteAction();
	                            }
	                            break;
	                        default:
	                            if (key >= 49 && key <= 57 && e.target.tagName.toLowerCase() !== "input") {
	                               that.view(that.timeline._viewByIndex(key - 49));
	                            }
	                            break;
	                    }
	                });
	        },

	        _getToolbarItems: function () {
	            return this.toolbar.find("> .k-button:visible").toArray().concat(
	                this.toolbar.find(".k-views-dropdown:visible").toArray(),
	                this.toolbar.find(".k-gantt-views > .k-state-selected:visible").toArray()
	            );
	        },

	        _current: function(element) {
	            var ganttStyles = Gantt.styles;
	            var activeElement;

	            if (this.current && this.current.length) {
	                this.current
	                    .removeClass(ganttStyles.focused)
	                    .removeAttr("id");
	            }

	            if (element && element.length) {
	                this.current = element
	                    .addClass(ganttStyles.focused)
	                    .attr("id", ACTIVE_CELL);

	                activeElement = $(kendo._activeElement());

	                if (activeElement.is("table") && this.wrapper.find(activeElement).length > 0) {
	                    activeElement
	                        .removeAttr(ARIA_DESCENDANT)
	                        .attr(ARIA_DESCENDANT, ACTIVE_CELL);
	                }
	            } else {
	                this.current = null;
	            }
	        },

	        _dataBind: function() {
	            var that = this;

	            if (that.options.autoBind) {
	                this._preventRefresh = true;
	                this._preventDependencyRefresh = true;

	                var promises = $.map([
	                    this.dataSource,
	                    this.dependencies,
	                    this.resources.dataSource,
	                    this.assignments.dataSource
	                ],
	                function(dataSource) {
	                    return dataSource.fetch();
	                });

	                $.when.apply(null, promises)
	                    .done(function() {
	                        that._preventRefresh = false;
	                        that._preventDependencyRefresh = false;
	                        that.refresh();
	                    });
	            }
	        },

	        _resize: function() {
	            this._adjustDimensions();
	            this.timeline.view()._adjustHeight();
	            this.timeline.view()._renderCurrentTime();
	            this.list._adjustHeight();
	        },

	        _createPlannedTasksSwitch: function() {
	            var that = this;
	            var switchLabel = that.options.messages.plannedTasks.switchText;
	            var toggeSwitchWrap = $("<span class='k-gantt-planned-wrap'><label>" + switchLabel + "</label></span>");
	            var plannedToggle = new kendo.ui.Switch($("<input id='planned-switch' class='k-gantt-planned-switch'>"), {
	                checked: that.options.showPlannedTasks,
	                change: proxy(that._togglePlannedTasks, that),
	                messages: {
	                    checked: "",
	                    unchecked: ""
	                }
	            });

	            toggeSwitchWrap.append(plannedToggle.wrapper);

	            that.toggeSwitchWrap = toggeSwitchWrap;
	            that.toggleSwitch = plannedToggle;
	        },

	        _togglePlannedTasks: function(e) {
	            var timeline = this.timeline;

	            if (!this.trigger("togglePlannedTasks", { showPlannedTasks: !timeline.options.showPlannedTasks })) {
	                this.wrapper.toggleClass(ganttStyles.plannedTasks);
	                timeline._setPlanned(!timeline.options.showPlannedTasks);
	                timeline._render(this.dataSource.taskTree());
	                timeline._renderDependencies(this.dependencies.view());
	            } else {
	                e.preventDefault();
	            }
	        }
	    });

	    if (kendo.PDFMixin) {
	        kendo.PDFMixin.extend(Gantt.fn);

	        Gantt.fn._drawPDF = function() {
	            var ganttStyles = Gantt.styles;
	            var listTableWidth = this.wrapper.find(DOT + ganttStyles.list + " " + DOT + ganttStyles.gridContent + ">table").width();
	            var content = this.wrapper.clone();

	            content.find(DOT + ganttStyles.list).css("width", listTableWidth);

	            return this._drawPDFShadow({
	                content: content
	            }, {
	                avoidLinks: this.options.pdf.avoidLinks
	            });
	        };
	    }

	    kendo.ui.plugin(Gantt);

	    extend(true, Gantt, { styles: ganttStyles });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ }),

/***/ 1252:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("HQQe");

/***/ }),

/***/ 1253:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("n1t0");

/***/ }),

/***/ 1254:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("U8qt");

/***/ }),

/***/ 1255:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("QI4T");

/***/ }),

/***/ 1256:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("vGlF");

/***/ }),

/***/ 1257:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("rbj2");

/***/ })

/******/ });

/***/ }),

/***/ "CxVc":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1580);
	module.exports = __webpack_require__(1580);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1580:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var Axis = kendo.Class.extend({
	        init: function(count, value) {
	            this._value = value;
	            this._count = count;
	            this.values = new kendo.spreadsheet.RangeList(0, count - 1, value);
	            this._hidden = new kendo.spreadsheet.RangeList(0, count - 1, 0);

	            this.scrollBarSize = kendo.support.scrollbar();
	            this._refresh();
	        },

	        adjust: function(start, delta) {
	            // adjust this axis for insert/remove rows/cols operation
	            if (delta < 0) {
	                // removing -- copy from start+|delta| to start
	                this.values.copy(start - delta, this._count - 1, start);
	                this._hidden.copy(start - delta, this._count - 1, start);
	            } else {
	                // adding -- copy from start to start+delta, and set
	                // values for inserted things to default.
	                this.values.copy(start, this._count, start + delta);
	                this._hidden.copy(start, this._count, start + delta);
	                this.values.value(start, start + delta - 1, this._value);
	                this._hidden.value(start, start + delta - 1, 0);
	            }
	            this._refresh();
	        },

	        toJSON: function(field, positions) {
	            var values = [];

	            var iterator = this.values.iterator(0, this._count - 1);

	            for (var idx = 0; idx < this._count; idx++) {
	                var value = iterator.at(idx);
	                var hidden = this._hidden.value(idx, idx);

	                if (value === this._value && !hidden) {
	                    continue;
	                }

	                var position = positions[idx];

	                if (position === undefined) {
	                    position = values.length;

	                    var item = { index: idx };

	                    item[field] = value;
	                    if (hidden) {
	                        item.hidden = hidden;
	                    }

	                    values.push(item);

	                    positions[idx] = position;
	                }
	            }

	            return values;
	        },

	        fromJSON: function(field, values) {
	            for (var idx = 0; idx < values.length; idx++) {
	                var el = values[idx];

	                var index = el.index;
	                if (index === undefined) {
	                    index = idx;
	                }

	                // when this particular axis is hidden, the value for
	                // the field ("height" or "width") will be zero, and
	                // in the "hidden" field we'll have the actual value
	                // before it was hidden.
	                // https://github.com/telerik/kendo-ui-core/issues/3523
	                var value = el[field];

	                if (value === 0) {
	                    this._hidden.value(index, index, el.hidden || this._value);
	                    this.value(index, index, 0);
	                } else {
	                    this.value(index, index, value);
	                }
	            }
	        },

	        hide: function(index) {
	            if (!this.hidden(index)) {
	                var value = this.value(index, index);
	                this._hidden.value(index, index, value);
	                this.value(index, index, 0);
	            }
	        },

	        hidden: function(index) {
	            return this._hidden.value(index, index) !== 0;
	        },

	        includesHidden: function(start, end) {
	             return this._hidden.intersecting(start, end).length > 1;
	        },

	        nextVisible: function(index) {
	            var end = this._count - 1, i = index;
	            while (++i <= end) {
	                if (!this.hidden(i)) {
	                    return i;
	                }
	            }
	            return index;
	        },

	        nextUntil: function(index, pred) {
	            var end = this._count - 1, i = index, advanced = false;
	            while (++i <= end) {
	                var val = pred(i, advanced, this.hidden(i));
	                if (typeof val == "number") {
	                    return val;
	                } else if (val) {
	                    break;
	                }
	                advanced = true;
	            }
	            return i - 1;
	        },

	        nextPage: function(index, pageSize) {
	            return this.index(this.sum(0, index - 1) + pageSize);
	        },

	        prevPage: function(index, pageSize) {
	            return this.index(this.sum(0, index) - pageSize);
	        },

	        firstVisible: function() {
	            var firstHidden = this._hidden.first();
	            if (firstHidden.value === 0) {
	                return 0;
	            } else {
	                return firstHidden.end + 1;
	            }
	        },

	        lastVisible: function() {
	            var lastHidden = this._hidden.last();
	            if (lastHidden.value === 0) {
	                return this._count - 1;
	            } else {
	                return lastHidden.start - 1;
	            }
	        },

	        prevVisible: function(index) {
	            var i = index;
	            while (--i >= 0) {
	                if (!this.hidden(i)) {
	                    return i;
	                }
	            }
	            return index;
	        },

	        prevUntil: function(index, pred) {
	            var i = index, advanced = false;
	            while (--i >= 0) {
	                var val = pred(i, advanced, this.hidden(i));
	                if (typeof val == "number") {
	                    return val;
	                } else if (val) {
	                    break;
	                }
	                advanced = true;
	            }
	            return i + 1;
	        },

	        unhide: function(index) {
	            if (this.hidden(index)) {
	                var value = this._hidden.value(index, index);
	                this._hidden.value(index, index, 0);
	                this.value(index, index, value);
	            }
	        },

	        value: function(start, end, value) {
	            if (value !== undefined) {
	                this.values.value(start, end, value);
	                this._refresh();
	            } else {
	                return this.values.iterator(start, end).at(0);
	            }
	        },

	        sum: function(start, end) {
	            var values = this.values.iterator(start, end);

	            var sum = 0;

	            for (var idx = start; idx <= end; idx ++) {
	                sum += values.at(idx);
	            }

	            return sum;
	        },

	        locate: function(start, end, predicate) {
	            var values = this.values.iterator(start, end);
	            var sum = 0;
	            for (var idx = start; idx <= end; idx++) {
	                sum += values.at(idx);
	                var val = predicate(sum);
	                if (val) {
	                    return idx;
	                }
	            }
	            return null;
	        },

	        visible: function(start, end) {
	            var startSegment = null;
	            var endSegment = null;
	            var lastPage = false;

	            if (end >= this.total + this.scrollBarSize) {
	                lastPage = true;
	            }

	            var ranges = this._pixelValues.intersecting(start, end);

	            startSegment = ranges[0];
	            endSegment = ranges[ranges.length - 1];

	            if (!startSegment) {
	                return { values: this.values.iterator(0, 0), offset: 0 };
	            }

	            var startOffset = start - startSegment.start;

	            var startIndex = ((startOffset / startSegment.value.value) >> 0) + startSegment.value.start;

	            var offset = startOffset - (startIndex - startSegment.value.start) * startSegment.value.value;

	            var endOffset = end - endSegment.start;
	            var endIndex = ((endOffset / endSegment.value.value) >> 0) + endSegment.value.start;

	            if (endIndex > endSegment.value.end) {
	                endIndex = endSegment.value.end;
	            }

	            if (lastPage) {
	                offset += endSegment.value.value - (endOffset - (endIndex - endSegment.value.start) * endSegment.value.value);
	            }

	            offset = Math.min(-offset, 0);

	            return {
	                values: this.values.iterator(startIndex, endIndex),
	                offset: offset
	            };
	        },

	        index: function(value) {
	            var index = 0;
	            var iterator = this.values.iterator(0, this._count - 1);
	            var current = iterator.at(0);

	            while (current < value && index < this._count - 1) {
	                current += iterator.at(++index);
	            }

	            return index;
	        },

	        indexVisible: function(value) {
	            var index = this.index(value);
	            if (this.hidden(index)) {
	                index = this.prevVisible(index);
	            }
	            return index;
	        },

	        _refresh: function() {
	            var current = 0;
	            this._pixelValues = this.values.map(function(range) {
	                var start = current;

	                current += (range.end - range.start + 1) * range.value;

	                var end = current - 1;

	                return new kendo.spreadsheet.ValueRange(start, end, range);
	            });

	            this.total = current;
	        },

	        getState: function() {
	            return {
	                values: this.values.getState(),
	                hidden: this._hidden.getState()
	            };
	        },

	        setState: function(state) {
	            this.values.setState(state.values);
	            this._hidden.setState(state.hidden);
	            this._refresh();
	        }
	    });

	    var PaneAxis = kendo.Class.extend({
	        init: function(axis, start, count, headerSize) {
	           this._axis = axis;
	           this._start = start;
	           this._count = count;
	           this.hasHeader = start === 0;
	           this.headerSize = headerSize;
	           this.defaultValue = axis._value;
	           this.frozen = count > 0;
	        },

	        viewSize: function(viewSize) {
	            this._viewSize = viewSize;
	        },

	        sum: function(start, end) {
	            return this._axis.sum(start, end - 1);
	        },

	        start: function() {
	            return this.sum(0, this._start);
	        },

	        size: function() {
	            return this.sum(this._start, this._start + this._count);
	        },

	        index: function(value, offset) {
	            return this._axis.index(value + (this.frozen ? 0 : offset) - this.headerSize);
	        },

	        indexVisible: function(value, offset) {
	            return this._axis.indexVisible(value + (this.frozen ? 0 : offset) - this.headerSize);
	        },

	        //XXX: rename this method
	        paneSegment: function() {
	            var offset = this.start();
	            var length;

	            if (!this.hasHeader) {
	                offset += this.headerSize;
	            }

	            if (this.frozen) {
	                length = this.size();
	                if (this.hasHeader) {
	                    length += this.headerSize;
	                } else {
	                    length -= this.headerSize;
	                }
	            } else {
	                length = this._viewSize - offset;
	            }

	            return {
	                offset: offset,
	                length: length
	            };
	        },

	        visible: function(offset) {
	            var start = this.start();
	            var size;

	            if (this.frozen) {
	                size = this.size();
	                if (!this.hasHeader) {
	                    size -= this.headerSize;
	                }
	            } else {
	                size = this._viewSize - start - this.headerSize;
	                start += offset;
	            }

	            var result = this._axis.visible(start, start + size - 1);

	            if (this.frozen) {
	                result.offset = 0;
	            }

	            result.start = start;

	            if (this.hasHeader) {
	                result.offset += this.headerSize;
	                result.start -= this.headerSize;
	            }

	            return result;
	        },

	        contains: function(start, end) {
	            if (this.frozen) {
	                if (start > this._start + this._count) {
	                    return false;
	                }
	                if (end < this._start) {
	                    return false;
	                }
	                return true;
	            } else {
	                return end >= this._start;
	            }
	        }
	    });

	    kendo.spreadsheet.Axis = Axis;
	    kendo.spreadsheet.PaneAxis = PaneAxis;

	})(kendo);
	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "Cyi2":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1373);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1369:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("dWoE");

/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1369) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	    var __meta__ = { // jshint ignore:line
	        id: "scheduler.agendaview",
	        name: "Scheduler Agenda View",
	        category: "web",
	        description: "The Scheduler Agenda View",
	        depends: [ "scheduler.view" ],
	        hidden: true
	    };

	    (function($){
	        var kendo = window.kendo,
	            ui = kendo.ui,
	            NS = ".kendoAgendaView";

	        var EVENT_WRAPPER_FORMAT = '<div class="k-task" title="#:(data.title || "").replace(/"/g,"\'")#" data-#=kendo.ns#uid="#=uid#">' +
	                                   '# if (resources[0]) {#' +
	                                   '<span class="k-scheduler-mark" style="background-color:#=resources[0].color#"></span>' +
	                                   "# } #" +
	                                   "# if (data.isException()) { #" +
	                                   '<span class="k-icon k-i-non-recurrence"></span>' +
	                                   '# } else if (data.isRecurring()) {#' +
	                                   '<span class="k-icon k-i-reload"></span>' +
	                                   "# } #" +
	                                   '<span class="k-scheduler-task-text">{0}</span>' +
	                                   '#if (showDelete) {#' +
	                                       '<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>' +
	                                   '#}#' +
	                               '</div>';

	        var EVENT_DATE_TEMPLATE = "# if (!isMobile) { #" +
	                                    '<strong class="k-scheduler-agendaday">' +
	                                        '#=kendo.toString(date, "dd")#' +
	                                    '</strong>' +
	                                    '<em class="k-scheduler-agendaweek">' +
	                                        '#=kendo.toString(date,"dddd")#' +
	                                    '</em>' +
	                                    '<span class="k-scheduler-agendadate">' +
	                                        '#=kendo.toString(date, "y")#' +
	                                    '</span>' +
	                                '# } else { #' +
	                                    '<div class="k-scheduler-datecolumn-wrap">' +
	                                        '<span class="k-mobile-scheduler-agendadate">' +
	                                            '<span class="k-mobile-scheduler-agendaday">#=kendo.toString(date, "dd")#</span>' +
	                                            '&nbsp' +
	                                            '<span class="k-mobile-scheduler-agendamonth">#=kendo.toString(date, "MMMM")#</span>' +
	                                        '</span>' +
	                                        '<span class="k-mobile-scheduler-agendaweekday">' +
	                                            '#=kendo.toString(date, "dddd")#' +
	                                        '</span>' +
	                                    '</div>' +
	                                '# } #';

	        var EVENT_GROUP_TEMPLATE = "# if (!isMobile) { #" +
	                                        '<strong class="k-scheduler-adgendagroup">' +
	                                            '#=value#' +
	                                        '</strong>' +
	                                    '# } else { #' +
	                                        '<span class="k-scheduler-group-text">' +
	                                            '#=value#' +
	                                        '</span>' +
	                                    '# } #';

	            var AgendaGroupedView = kendo.Class.extend({
	    	        init: function(view) {
	    		        this._view = view;
	    	        },

	                _getColumns: function(groupHeaders, columns){
	                    return groupHeaders.concat(columns);
	                },
	                _getGroupsInDay: function(){
	                    return [];
	                },

	                _getSumOfItemsForDate: function(){
	                    return 0;
	                },

	                _renderTaskGroupsCells: function(headerCells, groups, taskGroupIndex, taskIndex){
	                    var view = this._view;

	                    if (taskGroupIndex === 0 && taskIndex === 0 && groups.length) {
	                         view._renderTaskGroupsCells(headerCells, groups);
	                    }
	                },

	                _renderDateCell: function(tableRow, groups, tasks, date, taskGroupIndex, tasksGroups){
	                     var view = this._view;
	                     var isMobile = view._isMobile();

	                     tableRow.push(kendo.format(
	                        '<td class="k-scheduler-datecolumn{3}{2}" rowspan="{0}">{1}</td>',
	                        tasks.length,
	                        view._dateTemplate({ date: date, isMobile: isMobile }),
	                        taskGroupIndex == tasksGroups.length - 1 && !groups.length ? " k-last" : "",
	                        !groups.length ? " k-first" : ""
	                    ));
	                },

	                _renderDates: function (){
	                     return undefined;
	                },

	                _getParents: function (parentGroups){
	                    return parentGroups.splice(0);
	                },

	                _getGroupsByDate: function(){
	                    return undefined;
	                },

	                _renderTaskGroups: function(table, items, parents){
	                    var view = this._view;

	                    table.append(view._renderTaskGroups(items, parents));
	                }

	            });

		        var AgendaGroupedByDateView = kendo.Class.extend({
	                init: function(view) {
	    	            this._view = view;
	                },

	                _getColumns: function(groupHeaders, columns){
	                    var view = this._view;

	                    if (view._isMobile()) {
	                        return groupHeaders.concat(columns);
	                    } else {
	                        var date = columns.slice(0, 1);
	                        var columnsWithoutDate = columns.slice(1);

	                        return date.concat(groupHeaders).concat(columnsWithoutDate);
	                    }
	                },

	                _compareDateGroups: function(currentGroup, prevGroup, index){
	                    if (currentGroup[index].text == prevGroup[index].text) {
	                        if (index === 0) {
	                            return true;
	                        }else {
	                            return this._compareDateGroups(currentGroup, prevGroup, index - 1);
	                        }
	                    }

	                    return false;
	                },

	                _getGroupsInDay: function(tasksGroups, groups){
	                      var groupsInDay = [];
	                      var prevGroup = null;

	                       for (var tasksGroupIdx = 0; tasksGroupIdx < tasksGroups.length; tasksGroupIdx++) {
	                            for (var itemsIdx = 0; itemsIdx < tasksGroups[tasksGroupIdx].items.length; itemsIdx++) {
	                                var idx = 0;

	                                if (groupsInDay.length === 0) {
	                                    for (idx; idx < groups[tasksGroupIdx].length; idx++) {
	                                        groupsInDay.push([1]);
	                                    }
	                                } else {
	                                    for (idx; idx < groups[tasksGroupIdx].length; idx++) {

	                                        if (this._compareDateGroups(groups[tasksGroupIdx], prevGroup, idx)) {
	                                            groupsInDay[idx][groupsInDay[idx].length - 1]++;
	                                        } else {
	                                            var lastItemValue = groupsInDay[idx][groupsInDay[idx].length - 1] - 1;
	                                            for (var i = 0; i < lastItemValue; i++) {
	                                                groupsInDay[idx].push(0);
	                                            }
	                                            groupsInDay[idx].push(1);
	                                        }
	                                    }
	                                }
	                                prevGroup = groups[tasksGroupIdx];
	                            }
	                        }

	                        return groupsInDay;
	                },

	                _getSumOfItemsForDate: function(tasksGroups){
	                    var sumOfItemsForDate = 0;

	                    for (var i = 0; i < tasksGroups.length; i++) {

	                        sumOfItemsForDate += tasksGroups[i].items.length;
	                    }
	                    return sumOfItemsForDate;
	                },

	                _renderTaskGroupsCells: function(headerCells, groups, taskGroupIndex, taskIndex, groupsInDay, sumOfItemsForDate, date, groupsRowSpanIndex){
	                    var view = this._view;
	                    var isMobile = view._isMobile();

	                     if(!isMobile){
	                        if (taskGroupIndex === 0 && taskIndex === 0 ) {
	                            headerCells.push(kendo.format(
	                                '<td class="k-scheduler-datecolumn k-first" rowspan="{0}">{1}</td>',
	                                sumOfItemsForDate,
	                                view._dateTemplate({ date: date, isMobile: isMobile })
	                            ));
	                        }

	                        for (var idx = 0; idx < groups[taskGroupIndex].length; idx++) {
	                            if (groupsInDay[idx][groupsRowSpanIndex]) {
	                                headerCells.push(kendo.format(
	                                    '<td class="k-scheduler-groupcolumn" rowspan="{0}">{1}</td>',
	                                    groupsInDay[idx][groupsRowSpanIndex],
	                                    view._groupTemplate({ value: groups[taskGroupIndex][idx].text, isMobile: isMobile }),
	                                    groups[taskGroupIndex][idx].className
	                                ));
	                            }
	                        }
	                    }else{
	                        if (taskGroupIndex === 0 && taskIndex === 0 && groups.length) {
	                            view._renderTaskGroupsCells(headerCells, groups);
	                        }
	                    }
	                },

	                _renderDateCell: function(){
	                   return undefined;
	                },

	                _renderDates: function(table){
	                    var view = this._view;
	                    var sortedArray = view._groupsByDate.sort(function(a, b) {
	                        return a.array[0].value.getTime() - b.array[0].value.getTime();
	                    });

	                    for (var i = 0; i < sortedArray.length; i++) {
	                        table.append(view._renderTaskGroups(sortedArray[i].array, sortedArray[i].groups));
	                    }
	                },

	                _getParents: function(parentGroups){
	                    return parentGroups.slice(0);
	                },

	                _getGroupsByDate: function(groups, idx, parents){
	                    var view = this._view;

	                    if (groups[idx].items) {
	                        for (var taskGroupIndex = 0; taskGroupIndex < groups[idx].items.length; taskGroupIndex++) {
	                            var date = groups[idx].items[taskGroupIndex].value;
	                            var dateExists = false;

	                            for (var i = 0; i < view._groupsByDate.length; i++) {
	                                if (view._groupsByDate[i].array[0].value.getTime() === date.getTime()) {
	                                    dateExists = true;
	                                    view._groupsByDate[i].array.push(groups[idx].items[taskGroupIndex]);
	                                    view._groupsByDate[i].groups.push(parents);
	                                }
	                            }

	                            if (!dateExists) {
	                                view._groupsByDate.push({
	                                    array: [groups[idx].items[taskGroupIndex]],
	                                    groups: [parents]
	                                });
	                            }
	                        }
	                    }
	                },

	                _renderTaskGroups: function(){
	                    return undefined;
	                }

		        });

		        kendo.ui.scheduler.AgendaGroupedView = AgendaGroupedView;
		        kendo.ui.scheduler.AgendaGroupedByDateView = AgendaGroupedByDateView;


	        ui.AgendaView = ui.SchedulerView.extend({
	            init: function(element, options) {
	                ui.SchedulerView.fn.init.call(this, element, options);

	                this._groupedView = this._getGroupedView();

	                options = this.options;

	                if (options.editable) {
	                    options.editable = $.extend(
	                        { "delete": true },
	                        options.editable,
	                        { create: false, update: false },
	                        { messages: options.messages }
	                    );
	                }

	                this.title = options.title;

	                this._eventTemplate = this._eventTmpl(options.eventTemplate, EVENT_WRAPPER_FORMAT);
	                this._dateTemplate = kendo.template(options.eventDateTemplate);
	                this._groupTemplate = kendo.template(options.eventGroupTemplate);
	                this._timeTemplate = kendo.template(options.eventTimeTemplate);

	                this.element.on("mouseenter" + NS, ".k-scheduler-agenda .k-scheduler-content tr", "_mouseenter")
	                            .on("mouseleave" + NS, ".k-scheduler-agenda .k-scheduler-content tr", "_mouseleave")
	                            .on("click" + NS, ".k-scheduler-agenda .k-scheduler-content .k-link:has(.k-i-close)", "_remove");

	                this._renderLayout(options.date);
	            },

	            name: "agenda",

	            _isVirtualized: function () {
	                return false;
	            },
	             _getGroupedView: function() {
	                if (this._isGroupedByDate()) {
	                       return new kendo.ui.scheduler.AgendaGroupedByDateView(this);
	                } else {
	                       return new kendo.ui.scheduler.AgendaGroupedView(this);
	                }
	            },

	            _mouseenter: function(e) {
	                $(e.currentTarget).addClass("k-state-hover");
	            },

	            _mouseleave: function(e) {
	                $(e.currentTarget).removeClass("k-state-hover");
	            },

	            _remove: function(e) {
	                e.preventDefault();

	                this.trigger("remove", {
	                    uid: $(e.currentTarget).closest(".k-task").attr(kendo.attr("uid"))
	                });
	            },

	            nextDate: function() {
	                return kendo.date.nextDay(this.startDate());
	            },

	            startDate: function() {
	                return this._startDate;
	            },

	            endDate: function() {
	                return this._endDate;
	            },

	            previousDate: function() {
	                return kendo.date.previousDay(this.startDate());
	            },

	            _renderLayout: function(date) {
	                this._startDate = date;
	                this._endDate = kendo.date.addDays(date, 7);
	                this.createLayout(this._layout());
	                this._footer();
	                this.table.addClass("k-scheduler-agenda");
	            },

	            _layout: function() {
	                var columns = [
	                        { text: this.options.messages.time, className: "k-scheduler-timecolumn" },
	                        { text: this.options.messages.event }
	                ];

	                if (!this._isMobile()) {
	                    columns.splice(0, 0, { text: this.options.messages.date, className: "k-scheduler-datecolumn" });
	                }

	                var resources = this.groupedResources;
	                if (resources.length) {
	                    var groupHeaders = [];
	                    for (var idx = 0; idx < resources.length; idx++) {
	                        groupHeaders.push({ text: "", className: "k-scheduler-groupcolumn"});
	                    }

	                    columns = this._groupedView._getColumns(groupHeaders, columns);
	                }

	                return {
	                    columns: columns
	                };
	            },

	            _tasks: function(events) {
	                var tasks = [];

	                for (var idx = 0; idx < events.length; idx++) {
	                    var event = events[idx];
	                    var start = event.start;
	                    var end = event.isAllDay ? kendo.date.getDate(event.end) : event.end;

	                    var eventDurationInDays = Math.ceil((end - kendo.date.getDate(start)) / kendo.date.MS_PER_DAY);

	                    if (event.isAllDay) {
	                        eventDurationInDays += 1;
	                    }

	                    var task = event.clone();
	                    task.startDate = kendo.date.getDate(start);

	                    if (task.startDate >= this.startDate()) {
	                        tasks.push(task);
	                    }

	                    if (eventDurationInDays > 1) {
	                        task.end = kendo.date.nextDay(start);
	                        task.head = true;
	                        for (var day = 1; day < eventDurationInDays; day++) {
	                            start = task.end;
	                            task = event.clone();
	                            task.start = task.startDate = kendo.date.getDate(start);
	                            task.end = kendo.date.nextDay(start);
	                            if (day == eventDurationInDays - 1) {
	                                task.end = new Date(task.start.getFullYear(), task.start.getMonth(), task.start.getDate(), end.getHours(), end.getMinutes(), end.getSeconds(), end.getMilliseconds());
	                                task.tail = true;
	                            } else {
	                                task.isAllDay = true;
	                                task.middle = true;
	                            }

	                            if ((kendo.date.getDate(task.end) <= this.endDate() && task.start >= this.startDate()) || kendo.date.getDate(task.start).getTime() == this.endDate().getTime()) {
	                                tasks.push(task);
	                            }
	                        }
	                    }
	                }

	                return new kendo.data.Query(tasks).sort([{ field: "start", dir: "asc" },{ field: "end", dir: "asc" }]).groupBy({field: "startDate"}).toArray();
	            },

	            _renderTaskGroups: function(tasksGroups, groups) {
	                var tableRows = [];
	                var editable = this.options.editable;
	                var showDelete = editable && editable.destroy !== false && !this._isMobile();
	                var isMobile = this._isMobile();
	                var sumOfItemsForDate = this._groupedView._getSumOfItemsForDate(tasksGroups);
	                var groupsInDay = this._groupedView._getGroupsInDay(tasksGroups, groups);
	                var groupsRowSpanIndex = 0;

	                for (var taskGroupIndex = 0; taskGroupIndex < tasksGroups.length; taskGroupIndex++) {
	                    var date = tasksGroups[taskGroupIndex].value;

	                    var tasks = tasksGroups[taskGroupIndex].items;

	                    var today = kendo.date.isToday(date);

	                    for (var taskIndex = 0; taskIndex < tasks.length; taskIndex++) {
	                        var task = tasks[taskIndex];

	                        var tableRow = [];

	                        var headerCells = !isMobile ? tableRow : [];

	                        this._groupedView._renderTaskGroupsCells(headerCells, groups, taskGroupIndex, taskIndex, groupsInDay, sumOfItemsForDate, date, groupsRowSpanIndex);

	                        groupsRowSpanIndex++;
	                        if (taskIndex === 0) {
	                            if (isMobile) {
	                                headerCells.push(kendo.format(
	                                    '<td class="k-scheduler-datecolumn {1}" colspan="2">{0}</td>',
	                                    this._dateTemplate({ date: date, isMobile: isMobile }),
	                                    !this.groupedResources.length ? "k-first" : ""
	                                ));

	                                tableRows.push('<tr role="row" aria-selected="false"' + (today ? ' class="k-today">' : ">") + headerCells.join("")  + "</tr>");
	                            } else {
	                                this._groupedView._renderDateCell(tableRow, groups, tasks, date, taskGroupIndex, tasksGroups);
	                            }
	                        }

	                        if (task.head) {
	                            task.format = "{0:t}";
	                        } else if (task.tail) {
	                            task.format = "{1:t}";
	                        } else {
	                            task.format = "{0:t}-{1:t}";
	                        }

	                        task.resources = this.eventResources(task);

	                        tableRow.push(kendo.format(
	                            '<td class="k-scheduler-timecolumn {4}"><div>{0}{1}{2}</div></td><td>{3}</td>',
	                            task.tail || task.middle ? '<span class="k-icon k-i-arrow-60-left"></span>' : "",
	                            this._timeTemplate(task.clone({ start: task._startTime || task.start, end: task.endTime || task.end })),
	                            task.head || task.middle ? '<span class="k-icon k-i-arrow-60-right"></span>' : "",
	                            this._eventTemplate(task.clone({ showDelete: showDelete, messages: this.options.messages })),
	                            !this.groupedResources.length && isMobile ? "k-first" : ""
	                        ));

	                        tableRows.push('<tr role="row" aria-selected="false"' + (today ? ' class="k-today">' : ">") + tableRow.join("") + "</tr>");
	                    }
	                }

	                return tableRows.join("");
	            },

	            _renderTaskGroupsCells: function (headerCells, groups){
	                var isMobile = this._isMobile();

	                 for (var idx = 0; idx < groups.length; idx++) {
	                    headerCells.push(kendo.format(
	                        '<td class="k-scheduler-groupcolumn{2}" rowspan="{0}">{1}</td>',
	                        groups[idx].rowSpan,
	                        this._groupTemplate({ value: groups[idx].text, isMobile: isMobile }),
	                        groups[idx].className
	                    ));
	                }
	            },

	            render: function(events) {
	                var table = this.content.find("table").empty();
	                var groups = [];

	                if (events.length > 0) {
	                    var resources = this.groupedResources;

	                    if (resources.length) {
	                        groups = this._createGroupConfiguration(events, resources, null);
	                        this._groupsByDate = [];
	                        this._renderGroups(groups, table, []);
	                        this._groupedView._renderDates(table);
	                    } else {
	                        groups = this._tasks(events);
	                        table.append(this._renderTaskGroups(groups, []));
	                    }
	                }

	                var items = this._eventsList = flattenTaskGroups(groups);
	                this._angularItems(table, items);

	                this.refreshLayout();
	                this.trigger("activate");
	            },

	            _angularItems: function(table, items) {
	                this.angular("compile", function(){
	                    var data = [], elements = items.map(function(item){
	                        data.push({ dataItem: item });
	                        return table.find(".k-task[" + kendo.attr("uid") + "=" + item.uid + "]");
	                    });
	                    return { elements: elements, data: data };
	                });
	            },

	            _renderGroups: function(groups, table, parentGroups) {
	                for (var idx = 0, length = groups.length; idx < length; idx++) {
	                    var parents = this._groupedView._getParents(parentGroups);

	                    parents.push(groups[idx]);
	                    this._groupedView._getGroupsByDate(groups, idx, parents);

	                    if (groups[idx].groups) {
	                        this._renderGroups(groups[idx].groups, table, parents);
	                    } else {
	                        this._groupedView._renderTaskGroups(table, groups[idx].items, parents);
	                    }
	                }
	            },

	            _createGroupConfiguration: function(events, resources, parent) {
	                var resource = resources[0];
	                var configuration = [];
	                var data = resource.dataSource.view();
	                var isMobile = this._isMobile();

	                for (var dataIndex = 0; dataIndex < data.length; dataIndex++) {
	                    var value = resourceValue(resource, data[dataIndex]);

	                    var tmp = new kendo.data.Query(events).filter({ field: resource.field, operator: ui.SchedulerView.groupEqFilter(value) }).toArray();

	                    if (tmp.length) {
	                        var tasks = this._tasks(tmp);
	                        var className = parent ? "" : " k-first";

	                        if (dataIndex === data.length - 1 && (!parent || parent.className.indexOf("k-last") > -1)) {
	                            className += " k-last";
	                        }

	                        var obj = {
	                            text: kendo.getter(resource.dataTextField)(data[dataIndex]),
	                            value: value,
	                            rowSpan: 0,
	                            className: className
	                        };

	                        if (resources.length > 1) {
	                            obj.groups = this._createGroupConfiguration(tmp, resources.slice(1), obj);
	                            if (parent) {
	                                parent.rowSpan += obj.rowSpan;
	                            }
	                        } else {
	                            obj.items = tasks;
	                            var span = rowSpan(obj.items);

	                            if (isMobile) {
	                                span += obj.items.length;
	                            }

	                            obj.rowSpan = span;
	                            if (parent) {
	                                parent.rowSpan += span;
	                            }
	                        }
	                        configuration.push(obj);
	                    }
	                }

	                return configuration;
	            },

	            selectionByElement: function(cell) {
	                var index, event;
	                cell = $(cell);
	                if (cell.hasClass("k-scheduler-datecolumn") || !this._eventsList.length) {
	                    return;
	                }

	                if (cell.is(".k-task")) {
	                    cell = cell.closest("td");
	                }

	                if (this._isMobile()) {
	                    var parent = cell.parent();
	                    index = parent.parent().children()
	                        .filter(function() {
	                            return $(this).children(":not(.k-scheduler-datecolumn)").length;
	                        })
	                        .index(parent);
	                } else {
	                    index = cell.parent().index();
	                }

	                event = this._eventsList[index];

	                return {
	                    index: index,
	                    start: event.start,
	                    end: event.end,
	                    isAllDay: event.isAllDay,
	                    uid: event.uid
	                };
	            },

	            select: function(selection) {
	                this.clearSelection();

	                var row = this.table
	                    .find(".k-task")
	                    .eq(selection.index)
	                    .closest("tr")
	                    .addClass("k-state-selected")
	                    .attr("aria-selected", true)[0];

	                this.current(row);
	            },

	            move: function(selection, key) {
	                var handled = false;
	                var index = selection.index;

	                if (key == kendo.keys.UP) {
	                    index --;
	                    handled = true;
	                } else  if (key == kendo.keys.DOWN) {
	                    index ++;
	                    handled = true;
	                }

	                if (handled) {
	                    var event = this._eventsList[index];
	                    if (event) {
	                        selection.start = event.start;
	                        selection.end = event.end;
	                        selection.isAllDay = event.isAllDay;
	                        selection.events = [ event.uid ];
	                        selection.index = index;
	                    }
	                }

	                return handled;
	            },

	            moveToEvent: function() {
	                return false;
	            },

	            constrainSelection: function(selection) {
	                var event = this._eventsList[0];
	                if (event) {
	                    selection.start = event.start;
	                    selection.end = event.end;
	                    selection.isAllDay = event.isAllDay;
	                    selection.events = [ event.uid ];
	                    selection.index = 0;
	                }
	            },

	            isInRange: function() {
	                return true;
	            },

	            destroy: function(){
	                if (this.element) {
	                    this.element.off(NS);
	                }

	                ui.SchedulerView.fn.destroy.call(this);
	            },

	            options: {
	                title: "Agenda",
	                name: "agenda",
	                editable: true,
	                selectedDateFormat: "{0:D}-{1:D}",
	                selectedShortDateFormat: "{0:d} - {1:d}",
	                selectedMobileDateFormat: "{0: MMM} {0:dd} - {1:dd}",
	                eventTemplate: "#:title#",
	                eventTimeTemplate: "#if(data.isAllDay) {#" +
	                                '#=this.options.messages.allDay#' +
	                              "#} else { #" +
	                                '#=kendo.format(format, start, end)#' +
	                              "# } #",
	                eventDateTemplate: EVENT_DATE_TEMPLATE,
	                eventGroupTemplate: EVENT_GROUP_TEMPLATE,
	                messages: {
	                    event: "Event",
	                    date: "Date",
	                    time: "Time",
	                    allDay: "all day"
	                }
	            }
	        });

	        function rowSpan(tasks) {
	            var result = 0;

	            for (var idx = 0, length = tasks.length; idx < length; idx++) {
	                result += tasks[idx].items.length;
	            }

	            return result;
	        }

	        function resourceValue(resource, item) {
	            if (resource.valuePrimitive) {
	                item = kendo.getter(resource.dataValueField)(item);
	            }
	            return item;
	        }

	        function flattenTaskGroups(groups) {
	            var idx = 0,
	                length = groups.length,
	                item,
	                result = [];

	            for ( ; idx < length; idx ++) {
	                item = groups[idx];
	                if (item.groups) {
	                    item = flattenGroup(item.groups);
	                    result = result.concat(item);
	                } else {
	                    result = result.concat(flattenGroup(item.items));
	                }
	            }

	            return result;
	        }

	        function flattenGroup(groups) {
	            var items = [].concat(groups),
	                item = items.shift(),
	                result = [],
	                push = [].push;
	            while (item) {
	                if (item.groups) {
	                    push.apply(items, item.groups);
	                } else if (item.items) {
	                    push.apply(items, item.items);
	                } else {
	                    push.call(result, item);
	                }

	                item = items.shift();
	            }

	            return result;
	        }

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "Cz2g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var constants_1 = __webpack_require__("ZZFX");
var columnController_1 = __webpack_require__("77lH");
var utils_1 = __webpack_require__("IRr6");
var gridRow_1 = __webpack_require__("piWI");
var gridCell_1 = __webpack_require__("hie4");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var pinnedRowModel_1 = __webpack_require__("xRx6");
var CellNavigationService = (function () {
    function CellNavigationService() {
    }
    // returns null if no cell to focus on, ie at the end of the grid
    CellNavigationService.prototype.getNextCellToFocus = function (key, lastCellToFocus) {
        // starting with the provided cell, we keep moving until we find a cell we can
        // focus on.
        var pointer = lastCellToFocus;
        var finished = false;
        // finished will be true when either:
        // a) cell found that we can focus on
        // b) run out of cells (ie the method returns null)
        while (!finished) {
            switch (key) {
                case constants_1.Constants.KEY_UP:
                    pointer = this.getCellAbove(pointer);
                    break;
                case constants_1.Constants.KEY_DOWN:
                    pointer = this.getCellBelow(pointer);
                    break;
                case constants_1.Constants.KEY_RIGHT:
                    if (this.gridOptionsWrapper.isEnableRtl()) {
                        pointer = this.getCellToLeft(pointer);
                    }
                    else {
                        pointer = this.getCellToRight(pointer);
                    }
                    break;
                case constants_1.Constants.KEY_LEFT:
                    if (this.gridOptionsWrapper.isEnableRtl()) {
                        pointer = this.getCellToRight(pointer);
                    }
                    else {
                        pointer = this.getCellToLeft(pointer);
                    }
                    break;
                default:
                    console.log('ag-Grid: unknown key for navigation ' + key);
                    pointer = null;
                    break;
            }
            if (pointer) {
                finished = this.isCellGoodToFocusOn(pointer);
            }
            else {
                finished = true;
            }
        }
        return pointer;
    };
    CellNavigationService.prototype.isCellGoodToFocusOn = function (gridCell) {
        var column = gridCell.column;
        var rowNode;
        switch (gridCell.floating) {
            case constants_1.Constants.PINNED_TOP:
                rowNode = this.pinnedRowModel.getPinnedTopRow(gridCell.rowIndex);
                break;
            case constants_1.Constants.PINNED_BOTTOM:
                rowNode = this.pinnedRowModel.getPinnedBottomRow(gridCell.rowIndex);
                break;
            default:
                rowNode = this.rowModel.getRow(gridCell.rowIndex);
                break;
        }
        var suppressNavigable = column.isSuppressNavigable(rowNode);
        return !suppressNavigable;
    };
    CellNavigationService.prototype.getCellToLeft = function (lastCell) {
        var colToLeft = this.columnController.getDisplayedColBefore(lastCell.column);
        if (!colToLeft) {
            return null;
        }
        else {
            var gridCellDef = { rowIndex: lastCell.rowIndex, column: colToLeft, floating: lastCell.floating };
            return new gridCell_1.GridCell(gridCellDef);
        }
    };
    CellNavigationService.prototype.getCellToRight = function (lastCell) {
        var colToRight = this.columnController.getDisplayedColAfter(lastCell.column);
        // if already on right, do nothing
        if (!colToRight) {
            return null;
        }
        else {
            var gridCellDef = { rowIndex: lastCell.rowIndex, column: colToRight, floating: lastCell.floating };
            return new gridCell_1.GridCell(gridCellDef);
        }
    };
    CellNavigationService.prototype.getRowBelow = function (lastRow) {
        // if already on top row, do nothing
        if (this.isLastRowInContainer(lastRow)) {
            if (lastRow.isFloatingBottom()) {
                return null;
            }
            else if (lastRow.isNotFloating()) {
                if (this.pinnedRowModel.isRowsToRender(constants_1.Constants.PINNED_BOTTOM)) {
                    return new gridRow_1.GridRow(0, constants_1.Constants.PINNED_BOTTOM);
                }
                else {
                    return null;
                }
            }
            else {
                if (this.rowModel.isRowsToRender()) {
                    return new gridRow_1.GridRow(0, null);
                }
                else if (this.pinnedRowModel.isRowsToRender(constants_1.Constants.PINNED_BOTTOM)) {
                    return new gridRow_1.GridRow(0, constants_1.Constants.PINNED_BOTTOM);
                }
                else {
                    return null;
                }
            }
        }
        else {
            return new gridRow_1.GridRow(lastRow.rowIndex + 1, lastRow.floating);
        }
    };
    CellNavigationService.prototype.getCellBelow = function (lastCell) {
        var rowBelow = this.getRowBelow(lastCell.getGridRow());
        if (rowBelow) {
            var gridCellDef = { rowIndex: rowBelow.rowIndex, column: lastCell.column, floating: rowBelow.floating };
            return new gridCell_1.GridCell(gridCellDef);
        }
        else {
            return null;
        }
    };
    CellNavigationService.prototype.isLastRowInContainer = function (gridRow) {
        if (gridRow.isFloatingTop()) {
            var lastTopIndex = this.pinnedRowModel.getPinnedTopRowData().length - 1;
            return lastTopIndex <= gridRow.rowIndex;
        }
        else if (gridRow.isFloatingBottom()) {
            var lastBottomIndex = this.pinnedRowModel.getPinnedBottomRowData().length - 1;
            return lastBottomIndex <= gridRow.rowIndex;
        }
        else {
            var lastBodyIndex = this.rowModel.getPageLastRow();
            return lastBodyIndex <= gridRow.rowIndex;
        }
    };
    CellNavigationService.prototype.getRowAbove = function (lastRow) {
        // if already on top row, do nothing
        if (lastRow.rowIndex === 0) {
            if (lastRow.isFloatingTop()) {
                return null;
            }
            else if (lastRow.isNotFloating()) {
                if (this.pinnedRowModel.isRowsToRender(constants_1.Constants.PINNED_TOP)) {
                    return this.getLastFloatingTopRow();
                }
                else {
                    return null;
                }
            }
            else {
                // last floating bottom
                if (this.rowModel.isRowsToRender()) {
                    return this.getLastBodyCell();
                }
                else if (this.pinnedRowModel.isRowsToRender(constants_1.Constants.PINNED_TOP)) {
                    return this.getLastFloatingTopRow();
                }
                else {
                    return null;
                }
            }
        }
        else {
            return new gridRow_1.GridRow(lastRow.rowIndex - 1, lastRow.floating);
        }
    };
    CellNavigationService.prototype.getCellAbove = function (lastCell) {
        var rowAbove = this.getRowAbove(lastCell.getGridRow());
        if (rowAbove) {
            var gridCellDef = { rowIndex: rowAbove.rowIndex, column: lastCell.column, floating: rowAbove.floating };
            return new gridCell_1.GridCell(gridCellDef);
        }
        else {
            return null;
        }
    };
    CellNavigationService.prototype.getLastBodyCell = function () {
        var lastBodyRow = this.rowModel.getPageLastRow();
        return new gridRow_1.GridRow(lastBodyRow, null);
    };
    CellNavigationService.prototype.getLastFloatingTopRow = function () {
        var lastFloatingRow = this.pinnedRowModel.getPinnedTopRowData().length - 1;
        return new gridRow_1.GridRow(lastFloatingRow, constants_1.Constants.PINNED_TOP);
    };
    CellNavigationService.prototype.getNextTabbedCell = function (gridCell, backwards) {
        if (backwards) {
            return this.getNextTabbedCellBackwards(gridCell);
        }
        else {
            return this.getNextTabbedCellForwards(gridCell);
        }
    };
    CellNavigationService.prototype.getNextTabbedCellForwards = function (gridCell) {
        var displayedColumns = this.columnController.getAllDisplayedColumns();
        var newRowIndex = gridCell.rowIndex;
        var newFloating = gridCell.floating;
        // move along to the next cell
        var newColumn = this.columnController.getDisplayedColAfter(gridCell.column);
        // check if end of the row, and if so, go forward a row
        if (!newColumn) {
            newColumn = displayedColumns[0];
            var rowBelow = this.getRowBelow(gridCell.getGridRow());
            if (utils_1.Utils.missing(rowBelow)) {
                return;
            }
            newRowIndex = rowBelow.rowIndex;
            newFloating = rowBelow.floating;
        }
        var gridCellDef = { rowIndex: newRowIndex, column: newColumn, floating: newFloating };
        return new gridCell_1.GridCell(gridCellDef);
    };
    CellNavigationService.prototype.getNextTabbedCellBackwards = function (gridCell) {
        var displayedColumns = this.columnController.getAllDisplayedColumns();
        var newRowIndex = gridCell.rowIndex;
        var newFloating = gridCell.floating;
        // move along to the next cell
        var newColumn = this.columnController.getDisplayedColBefore(gridCell.column);
        // check if end of the row, and if so, go forward a row
        if (!newColumn) {
            newColumn = displayedColumns[displayedColumns.length - 1];
            var rowAbove = this.getRowAbove(gridCell.getGridRow());
            if (utils_1.Utils.missing(rowAbove)) {
                return;
            }
            newRowIndex = rowAbove.rowIndex;
            newFloating = rowAbove.floating;
        }
        var gridCellDef = { rowIndex: newRowIndex, column: newColumn, floating: newFloating };
        return new gridCell_1.GridCell(gridCellDef);
    };
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], CellNavigationService.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('rowModel'),
        __metadata("design:type", Object)
    ], CellNavigationService.prototype, "rowModel", void 0);
    __decorate([
        context_1.Autowired('pinnedRowModel'),
        __metadata("design:type", pinnedRowModel_1.PinnedRowModel)
    ], CellNavigationService.prototype, "pinnedRowModel", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], CellNavigationService.prototype, "gridOptionsWrapper", void 0);
    CellNavigationService = __decorate([
        context_1.Bean('cellNavigationService')
    ], CellNavigationService);
    return CellNavigationService;
}());
exports.CellNavigationService = CellNavigationService;


/***/ }),

/***/ "D1eD":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1095);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1048:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("BOhp");

/***/ }),

/***/ 1095:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1048)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "core",
	    name: "Core",
	    category: "framework",
	    description: "The core of the Kendo framework."
	};

	/*jshint eqnull: true, loopfunc: true, evil: true, boss: true, freeze: false*/
	(function($, window, undefined) {
	    var kendo = window.kendo = window.kendo || { cultures: {} },
	        extend = $.extend,
	        each = $.each,
	        isArray = $.isArray,
	        proxy = $.proxy,
	        noop = $.noop,
	        math = Math,
	        Template,
	        JSON = window.JSON || {},
	        support = {},
	        percentRegExp = /%/,
	        formatRegExp = /\{(\d+)(:[^\}]+)?\}/g,
	        boxShadowRegExp = /(\d+(?:\.?)\d*)px\s*(\d+(?:\.?)\d*)px\s*(\d+(?:\.?)\d*)px\s*(\d+)?/i,
	        numberRegExp = /^(\+|-?)\d+(\.?)\d*$/,
	        FUNCTION = "function",
	        STRING = "string",
	        NUMBER = "number",
	        OBJECT = "object",
	        NULL = "null",
	        BOOLEAN = "boolean",
	        UNDEFINED = "undefined",
	        getterCache = {},
	        setterCache = {},
	        slice = [].slice,
	        // avoid extending the depricated properties in latest verions of jQuery
	        noDepricateExtend = function() {
	            var src, copyIsArray, copy, name, options, clone,
	                target = arguments[ 0 ] || {},
	                i = 1,
	                length = arguments.length,
	                deep = false;

	            // Handle a deep copy situation
	            if ( typeof target === "boolean" ) {
	                deep = target;

	                // skip the boolean and the target
	                target = arguments[ i ] || {};
	                i++;
	            }

	            // Handle case when target is a string or something (possible in deep copy)
	            if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
	                target = {};
	            }

	            // extend jQuery itself if only one argument is passed
	            if ( i === length ) {
	                target = this;
	                i--;
	            }

	            for ( ; i < length; i++ ) {

	                // Only deal with non-null/undefined values
	                if ( ( options = arguments[ i ] ) != null ) {

	                    // Extend the base object
	                    for ( name in options ) {
	                        // filters, concat and : properties are depricated in the jQuery 3.3.0
	                        // accessing these properties throw a warning when jQuery migrate is included
	                        if (name == "filters" || name == "concat" || name == ":") {
	                            continue;
	                        }
	                        src = target[ name ];
	                        copy = options[ name ];

	                        // Prevent never-ending loop
	                        if ( target === copy ) {
	                            continue;
	                        }

	                        // Recurse if we're merging plain objects or arrays
	                        if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
	                            ( copyIsArray = jQuery.isArray( copy ) ) ) ) {

	                            if ( copyIsArray ) {
	                                copyIsArray = false;
	                                clone = src && jQuery.isArray( src ) ? src : [];

	                            } else {
	                                clone = src && jQuery.isPlainObject( src ) ? src : {};
	                            }

	                            // Never move original objects, clone them
	                            target[ name ] = noDepricateExtend( deep, clone, copy );

	                        // Don't bring in undefined values
	                        } else if ( copy !== undefined ) {
	                            target[ name ] = copy;
	                        }
	                    }
	                }
	            }

	            // Return the modified object
	            return target;
	        };

	    kendo.version = "2020.3.1118".replace(/^\s+|\s+$/g, '');

	    function Class() {}

	    Class.extend = function(proto) {
	        var base = function() {},
	            member,
	            that = this,
	            subclass = proto && proto.init ? proto.init : function () {
	                that.apply(this, arguments);
	            },
	            fn;

	        base.prototype = that.prototype;
	        fn = subclass.fn = subclass.prototype = new base();

	        for (member in proto) {
	            if (proto[member] != null && proto[member].constructor === Object) {
	                // Merge object members
	                fn[member] = extend(true, {}, base.prototype[member], proto[member]);
	            } else {
	                fn[member] = proto[member];
	            }
	        }

	        fn.constructor = subclass;
	        subclass.extend = that.extend;

	        return subclass;
	    };

	    Class.prototype._initOptions = function(options) {
	        this.options = deepExtend({}, this.options, options);
	    };

	    var isFunction = kendo.isFunction = function(fn) {
	        return typeof fn === "function";
	    };

	    var preventDefault = function() {
	        this._defaultPrevented = true;
	    };

	    var isDefaultPrevented = function() {
	        return this._defaultPrevented === true;
	    };

	    var Observable = Class.extend({
	        init: function() {
	            this._events = {};
	        },

	        bind: function(eventName, handlers, one) {
	            var that = this,
	                idx,
	                eventNames = typeof eventName === STRING ? [eventName] : eventName,
	                length,
	                original,
	                handler,
	                handlersIsFunction = typeof handlers === FUNCTION,
	                events;

	            if (handlers === undefined) {
	                for (idx in eventName) {
	                    that.bind(idx, eventName[idx]);
	                }
	                return that;
	            }

	            for (idx = 0, length = eventNames.length; idx < length; idx++) {
	                eventName = eventNames[idx];

	                handler = handlersIsFunction ? handlers : handlers[eventName];

	                if (handler) {
	                    if (one) {
	                        original = handler;
	                        handler = function() {
	                            that.unbind(eventName, handler);
	                            original.apply(that, arguments);
	                        };
	                        handler.original = original;
	                    }
	                    events = that._events[eventName] = that._events[eventName] || [];
	                    events.push(handler);
	                }
	            }

	            return that;
	        },

	        one: function(eventNames, handlers) {
	            return this.bind(eventNames, handlers, true);
	        },

	        first: function(eventName, handlers) {
	            var that = this,
	                idx,
	                eventNames = typeof eventName === STRING ? [eventName] : eventName,
	                length,
	                handler,
	                handlersIsFunction = typeof handlers === FUNCTION,
	                events;

	            for (idx = 0, length = eventNames.length; idx < length; idx++) {
	                eventName = eventNames[idx];

	                handler = handlersIsFunction ? handlers : handlers[eventName];

	                if (handler) {
	                    events = that._events[eventName] = that._events[eventName] || [];
	                    events.unshift(handler);
	                }
	            }

	            return that;
	        },

	        trigger: function(eventName, e) {
	            var that = this,
	                events = that._events[eventName],
	                idx,
	                length;

	            if (events) {
	                e = e || {};

	                e.sender = that;

	                e._defaultPrevented = false;

	                e.preventDefault = preventDefault;

	                e.isDefaultPrevented = isDefaultPrevented;

	                events = events.slice();

	                for (idx = 0, length = events.length; idx < length; idx++) {
	                    events[idx].call(that, e);
	                }

	                return e._defaultPrevented === true;
	            }

	            return false;
	        },

	        unbind: function(eventName, handler) {
	            var that = this,
	                events = that._events[eventName],
	                idx;

	            if (eventName === undefined) {
	                that._events = {};
	            } else if (events) {
	                if (handler) {
	                    for (idx = events.length - 1; idx >= 0; idx--) {
	                        if (events[idx] === handler || events[idx].original === handler) {
	                            events.splice(idx, 1);
	                        }
	                    }
	                } else {
	                    that._events[eventName] = [];
	                }
	            }

	            return that;
	        }
	    });


	     function compilePart(part, stringPart) {
	         if (stringPart) {
	             return "'" +
	                 part.split("'").join("\\'")
	                     .split('\\"').join('\\\\\\"')
	                     .replace(/\n/g, "\\n")
	                     .replace(/\r/g, "\\r")
	                     .replace(/\t/g, "\\t") + "'";
	         } else {
	             var first = part.charAt(0),
	                 rest = part.substring(1);

	             if (first === "=") {
	                 return "+(" + rest + ")+";
	             } else if (first === ":") {
	                 return "+$kendoHtmlEncode(" + rest + ")+";
	             } else {
	                 return ";" + part + ";$kendoOutput+=";
	             }
	         }
	     }

	    var argumentNameRegExp = /^\w+/,
	        encodeRegExp = /\$\{([^}]*)\}/g,
	        escapedCurlyRegExp = /\\\}/g,
	        curlyRegExp = /__CURLY__/g,
	        escapedSharpRegExp = /\\#/g,
	        sharpRegExp = /__SHARP__/g,
	        zeros = ["", "0", "00", "000", "0000"];

	    Template = {
	        paramName: "data", // name of the parameter of the generated template
	        useWithBlock: true, // whether to wrap the template in a with() block
	        render: function(template, data) {
	            var idx,
	                length,
	                html = "";

	            for (idx = 0, length = data.length; idx < length; idx++) {
	                html += template(data[idx]);
	            }

	            return html;
	        },
	        compile: function(template, options) {
	            var settings = extend({}, this, options),
	                paramName = settings.paramName,
	                argumentName = paramName.match(argumentNameRegExp)[0],
	                useWithBlock = settings.useWithBlock,
	                functionBody = "var $kendoOutput, $kendoHtmlEncode = kendo.htmlEncode;",
	                fn,
	                parts,
	                idx;

	            if (isFunction(template)) {
	                return template;
	            }

	            functionBody += useWithBlock ? "with(" + paramName + "){" : "";

	            functionBody += "$kendoOutput=";

	            parts = template
	                .replace(escapedCurlyRegExp, "__CURLY__")
	                .replace(encodeRegExp, "#=$kendoHtmlEncode($1)#")
	                .replace(curlyRegExp, "}")
	                .replace(escapedSharpRegExp, "__SHARP__")
	                .split("#");

	            for (idx = 0; idx < parts.length; idx ++) {
	                functionBody += compilePart(parts[idx], idx % 2 === 0);
	            }

	            functionBody += useWithBlock ? ";}" : ";";

	            functionBody += "return $kendoOutput;";

	            functionBody = functionBody.replace(sharpRegExp, "#");

	            try {
	                fn = new Function(argumentName, functionBody);
	                fn._slotCount = Math.floor(parts.length / 2);
	                return fn;
	            } catch(e) {
	                throw new Error(kendo.format("Invalid template:'{0}' Generated code:'{1}'", template, functionBody));
	            }
	        }
	    };

	function pad(number, digits, end) {
	    number = number + "";
	    digits = digits || 2;
	    end = digits - number.length;

	    if (end) {
	        return zeros[digits].substring(0, end) + number;
	    }

	    return number;
	}

	    //JSON stringify
	(function() {
	    var escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
	        gap,
	        indent,
	        meta = {
	            "\b": "\\b",
	            "\t": "\\t",
	            "\n": "\\n",
	            "\f": "\\f",
	            "\r": "\\r",
	            "\"" : '\\"',
	            "\\": "\\\\"
	        },
	        rep,
	        toString = {}.toString;


	    if (typeof Date.prototype.toJSON !== FUNCTION) {

	        Date.prototype.toJSON = function () {
	            var that = this;

	            return isFinite(that.valueOf()) ?
	                pad(that.getUTCFullYear(), 4) + "-" +
	                pad(that.getUTCMonth() + 1)   + "-" +
	                pad(that.getUTCDate())        + "T" +
	                pad(that.getUTCHours())       + ":" +
	                pad(that.getUTCMinutes())     + ":" +
	                pad(that.getUTCSeconds())     + "Z" : null;
	        };

	        String.prototype.toJSON = Number.prototype.toJSON = Boolean.prototype.toJSON = function () {
	            return this.valueOf();
	        };
	    }

	    function quote(string) {
	        escapable.lastIndex = 0;
	        return escapable.test(string) ? "\"" + string.replace(escapable, function (a) {
	            var c = meta[a];
	            return typeof c === STRING ? c :
	                "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
	        }) + "\"" : "\"" + string + "\"";
	    }

	    function str(key, holder) {
	        var i,
	            k,
	            v,
	            length,
	            mind = gap,
	            partial,
	            value = holder[key],
	            type;

	        if (value && typeof value === OBJECT && typeof value.toJSON === FUNCTION) {
	            value = value.toJSON(key);
	        }

	        if (typeof rep === FUNCTION) {
	            value = rep.call(holder, key, value);
	        }

	        type = typeof value;
	        if (type === STRING) {
	            return quote(value);
	        } else if (type === NUMBER) {
	            return isFinite(value) ? String(value) : NULL;
	        } else if (type === BOOLEAN || type === NULL) {
	            return String(value);
	        } else if (type === OBJECT) {
	            if (!value) {
	                return NULL;
	            }
	            gap += indent;
	            partial = [];
	            if (toString.apply(value) === "[object Array]") {
	                length = value.length;
	                for (i = 0; i < length; i++) {
	                    partial[i] = str(i, value) || NULL;
	                }
	                v = partial.length === 0 ? "[]" : gap ?
	                    "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" :
	                    "[" + partial.join(",") + "]";
	                gap = mind;
	                return v;
	            }
	            if (rep && typeof rep === OBJECT) {
	                length = rep.length;
	                for (i = 0; i < length; i++) {
	                    if (typeof rep[i] === STRING) {
	                        k = rep[i];
	                        v = str(k, value);
	                        if (v) {
	                            partial.push(quote(k) + (gap ? ": " : ":") + v);
	                        }
	                    }
	                }
	            } else {
	                for (k in value) {
	                    if (Object.hasOwnProperty.call(value, k)) {
	                        v = str(k, value);
	                        if (v) {
	                            partial.push(quote(k) + (gap ? ": " : ":") + v);
	                        }
	                    }
	                }
	            }

	            v = partial.length === 0 ? "{}" : gap ?
	                "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}" :
	                "{" + partial.join(",") + "}";
	            gap = mind;
	            return v;
	        }
	    }

	    if (typeof JSON.stringify !== FUNCTION) {
	        JSON.stringify = function (value, replacer, space) {
	            var i;
	            gap = "";
	            indent = "";

	            if (typeof space === NUMBER) {
	                for (i = 0; i < space; i += 1) {
	                    indent += " ";
	                }

	            } else if (typeof space === STRING) {
	                indent = space;
	            }

	            rep = replacer;
	            if (replacer && typeof replacer !== FUNCTION && (typeof replacer !== OBJECT || typeof replacer.length !== NUMBER)) {
	                throw new Error("JSON.stringify");
	            }

	            return str("", {"": value});
	        };
	    }
	})();

	// Date and Number formatting
	(function() {
	    var dateFormatRegExp = /dddd|ddd|dd|d|MMMM|MMM|MM|M|yyyy|yy|HH|H|hh|h|mm|m|fff|ff|f|tt|ss|s|zzz|zz|z|"[^"]*"|'[^']*'/g,
	        standardFormatRegExp =  /^(n|c|p|e)(\d*)$/i,
	        literalRegExp = /(\\.)|(['][^']*[']?)|(["][^"]*["]?)/g,
	        commaRegExp = /\,/g,
	        EMPTY = "",
	        POINT = ".",
	        COMMA = ",",
	        SHARP = "#",
	        ZERO = "0",
	        PLACEHOLDER = "??",
	        EN = "en-US",
	        objectToString = {}.toString;

	    //cultures
	    kendo.cultures["en-US"] = {
	        name: EN,
	        numberFormat: {
	            pattern: ["-n"],
	            decimals: 2,
	            ",": ",",
	            ".": ".",
	            groupSize: [3],
	            percent: {
	                pattern: ["-n %", "n %"],
	                decimals: 2,
	                ",": ",",
	                ".": ".",
	                groupSize: [3],
	                symbol: "%"
	            },
	            currency: {
	                name: "US Dollar",
	                abbr: "USD",
	                pattern: ["($n)", "$n"],
	                decimals: 2,
	                ",": ",",
	                ".": ".",
	                groupSize: [3],
	                symbol: "$"
	            }
	        },
	        calendars: {
	            standard: {
	                days: {
	                    names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	                    namesAbbr: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	                    namesShort: [ "Su", "Mo", "Tu", "We", "Th", "Fr", "Sa" ]
	                },
	                months: {
	                    names: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	                    namesAbbr: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	                },
	                AM: [ "AM", "am", "AM" ],
	                PM: [ "PM", "pm", "PM" ],
	                patterns: {
	                    d: "M/d/yyyy",
	                    D: "dddd, MMMM dd, yyyy",
	                    F: "dddd, MMMM dd, yyyy h:mm:ss tt",
	                    g: "M/d/yyyy h:mm tt",
	                    G: "M/d/yyyy h:mm:ss tt",
	                    m: "MMMM dd",
	                    M: "MMMM dd",
	                    s: "yyyy'-'MM'-'ddTHH':'mm':'ss",
	                    t: "h:mm tt",
	                    T: "h:mm:ss tt",
	                    u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'",
	                    y: "MMMM, yyyy",
	                    Y: "MMMM, yyyy"
	                },
	                "/": "/",
	                ":": ":",
	                firstDay: 0,
	                twoDigitYearMax: 2029
	            }
	        }
	    };


	     function findCulture(culture) {
	        if (culture) {
	            if (culture.numberFormat) {
	                return culture;
	            }

	            if (typeof culture === STRING) {
	                var cultures = kendo.cultures;
	                return cultures[culture] || cultures[culture.split("-")[0]] || null;
	            }

	            return null;
	        }

	        return null;
	    }

	    function getCulture(culture) {
	        if (culture) {
	            culture = findCulture(culture);
	        }

	        return culture || kendo.cultures.current;
	    }

	    kendo.culture = function(cultureName) {
	        var cultures = kendo.cultures, culture;

	        if (cultureName !== undefined) {
	            culture = findCulture(cultureName) || cultures[EN];
	            culture.calendar = culture.calendars.standard;
	            cultures.current = culture;
	        } else {
	            return cultures.current;
	        }
	    };

	    kendo.findCulture = findCulture;
	    kendo.getCulture = getCulture;

	    //set current culture to en-US.
	    kendo.culture(EN);

	    function formatDate(date, format, culture) {
	        culture = getCulture(culture);

	        var calendar = culture.calendars.standard,
	            days = calendar.days,
	            months = calendar.months;

	        format = calendar.patterns[format] || format;

	        return format.replace(dateFormatRegExp, function (match) {
	            var minutes;
	            var result;
	            var sign;

	            if (match === "d") {
	                result = date.getDate();
	            } else if (match === "dd") {
	                result = pad(date.getDate());
	            } else if (match === "ddd") {
	                result = days.namesAbbr[date.getDay()];
	            } else if (match === "dddd") {
	                result = days.names[date.getDay()];
	            } else if (match === "M") {
	                result = date.getMonth() + 1;
	            } else if (match === "MM") {
	                result = pad(date.getMonth() + 1);
	            } else if (match === "MMM") {
	                result = months.namesAbbr[date.getMonth()];
	            } else if (match === "MMMM") {
	                result = months.names[date.getMonth()];
	            } else if (match === "yy") {
	                result = pad(date.getFullYear() % 100);
	            } else if (match === "yyyy") {
	                result = pad(date.getFullYear(), 4);
	            } else if (match === "h" ) {
	                result = date.getHours() % 12 || 12;
	            } else if (match === "hh") {
	                result = pad(date.getHours() % 12 || 12);
	            } else if (match === "H") {
	                result = date.getHours();
	            } else if (match === "HH") {
	                result = pad(date.getHours());
	            } else if (match === "m") {
	                result = date.getMinutes();
	            } else if (match === "mm") {
	                result = pad(date.getMinutes());
	            } else if (match === "s") {
	                result = date.getSeconds();
	            } else if (match === "ss") {
	                result = pad(date.getSeconds());
	            } else if (match === "f") {
	                result = math.floor(date.getMilliseconds() / 100);
	            } else if (match === "ff") {
	                result = date.getMilliseconds();
	                if (result > 99) {
	                    result = math.floor(result / 10);
	                }
	                result = pad(result);
	            } else if (match === "fff") {
	                result = pad(date.getMilliseconds(), 3);
	            } else if (match === "tt") {
	                result = date.getHours() < 12 ? calendar.AM[0] : calendar.PM[0];
	            } else if (match === "zzz") {
	                minutes = date.getTimezoneOffset();
	                sign = minutes < 0;

	                result = math.abs(minutes / 60).toString().split(".")[0];
	                minutes = math.abs(minutes) - (result * 60);

	                result = (sign ? "+" : "-") + pad(result);
	                result += ":" + pad(minutes);
	            } else if (match === "zz" || match === "z") {
	                result = date.getTimezoneOffset() / 60;
	                sign = result < 0;

	                result = math.abs(result).toString().split(".")[0];
	                result = (sign ? "+" : "-") + (match === "zz" ? pad(result) : result);
	            }

	            return result !== undefined ? result : match.slice(1, match.length - 1);
	        });
	    }

	    //number formatting
	    function formatNumber(number, format, culture) {
	        culture = getCulture(culture);

	        var numberFormat = culture.numberFormat,
	            decimal = numberFormat[POINT],
	            precision = numberFormat.decimals,
	            pattern = numberFormat.pattern[0],
	            literals = [],
	            symbol,
	            isCurrency, isPercent,
	            customPrecision,
	            formatAndPrecision,
	            negative = number < 0,
	            integer,
	            fraction,
	            integerLength,
	            fractionLength,
	            replacement = EMPTY,
	            value = EMPTY,
	            idx,
	            length,
	            ch,
	            hasGroup,
	            hasNegativeFormat,
	            decimalIndex,
	            sharpIndex,
	            zeroIndex,
	            hasZero, hasSharp,
	            percentIndex,
	            currencyIndex,
	            startZeroIndex,
	            start = -1,
	            end;

	        //return empty string if no number
	        if (number === undefined) {
	            return EMPTY;
	        }

	        if (!isFinite(number)) {
	            return number;
	        }

	        //if no format then return number.toString() or number.toLocaleString() if culture.name is not defined
	        if (!format) {
	            return culture.name.length ? number.toLocaleString() : number.toString();
	        }

	        formatAndPrecision = standardFormatRegExp.exec(format);

	        // standard formatting
	        if (formatAndPrecision) {
	            format = formatAndPrecision[1].toLowerCase();

	            isCurrency = format === "c";
	            isPercent = format === "p";

	            if (isCurrency || isPercent) {
	                //get specific number format information if format is currency or percent
	                numberFormat = isCurrency ? numberFormat.currency : numberFormat.percent;
	                decimal = numberFormat[POINT];
	                precision = numberFormat.decimals;
	                symbol = numberFormat.symbol;
	                pattern = numberFormat.pattern[negative ? 0 : 1];
	            }

	            customPrecision = formatAndPrecision[2];

	            if (customPrecision) {
	                precision = +customPrecision;
	            }

	            //return number in exponential format
	            if (format === "e") {
	                var exp = customPrecision ? number.toExponential(precision) : number.toExponential(); // toExponential() and toExponential(undefined) differ in FF #653438.

	                return exp.replace(POINT, numberFormat[POINT]);
	            }

	            // multiply if format is percent
	            if (isPercent) {
	                number *= 100;
	            }

	            number = round(number, precision);
	            negative = number < 0;
	            number = number.split(POINT);

	            integer = number[0];
	            fraction = number[1];

	            //exclude "-" if number is negative.
	            if (negative) {
	                integer = integer.substring(1);
	            }

	            value = groupInteger(integer, 0, integer.length, numberFormat);

	            if (fraction) {
	                value += decimal + fraction;
	            }

	            if (format === "n" && !negative) {
	                return value;
	            }

	            number = EMPTY;

	            for (idx = 0, length = pattern.length; idx < length; idx++) {
	                ch = pattern.charAt(idx);

	                if (ch === "n") {
	                    number += value;
	                } else if (ch === "$" || ch === "%") {
	                    number += symbol;
	                } else {
	                    number += ch;
	                }
	            }

	            return number;
	        }

	        //custom formatting
	        //
	        //separate format by sections.

	        if (format.indexOf("'") > -1 || format.indexOf("\"") > -1 || format.indexOf("\\") > -1) {
	            format = format.replace(literalRegExp, function (match) {
	                var quoteChar = match.charAt(0).replace("\\", ""),
	                    literal = match.slice(1).replace(quoteChar, "");

	                literals.push(literal);

	                return PLACEHOLDER;
	            });
	        }

	        format = format.split(";");
	        if (negative && format[1]) {
	            //get negative format
	            format = format[1];
	            hasNegativeFormat = true;
	        } else if (number === 0 && format[2]) {
	            //format for zeros
	            format = format[2];
	            if (format.indexOf(SHARP) == -1 && format.indexOf(ZERO) == -1) {
	                //return format if it is string constant.
	                return format;
	            }
	        } else {
	            format = format[0];
	        }

	        percentIndex = format.indexOf("%");
	        currencyIndex = format.indexOf("$");

	        isPercent = percentIndex != -1;
	        isCurrency = currencyIndex != -1;

	        //multiply number if the format has percent
	        if (isPercent) {
	            number *= 100;
	        }

	        if (isCurrency && format[currencyIndex - 1] === "\\") {
	            format = format.split("\\").join("");
	            isCurrency = false;
	        }

	        if (isCurrency || isPercent) {
	            //get specific number format information if format is currency or percent
	            numberFormat = isCurrency ? numberFormat.currency : numberFormat.percent;
	            decimal = numberFormat[POINT];
	            precision = numberFormat.decimals;
	            symbol = numberFormat.symbol;
	        }

	        hasGroup = format.indexOf(COMMA) > -1;
	        if (hasGroup) {
	            format = format.replace(commaRegExp, EMPTY);
	        }

	        decimalIndex = format.indexOf(POINT);
	        length = format.length;

	        if (decimalIndex != -1) {
	            fraction = number.toString().split("e");
	            if (fraction[1]) {
	                fraction = round(number, Math.abs(fraction[1]));
	            } else {
	                fraction = fraction[0];
	            }
	            fraction = fraction.split(POINT)[1] || EMPTY;
	            zeroIndex = format.lastIndexOf(ZERO) - decimalIndex;
	            sharpIndex = format.lastIndexOf(SHARP) - decimalIndex;
	            hasZero = zeroIndex > -1;
	            hasSharp = sharpIndex > -1;
	            idx = fraction.length;

	            if (!hasZero && !hasSharp) {
	                format = format.substring(0, decimalIndex) + format.substring(decimalIndex + 1);
	                length = format.length;
	                decimalIndex = -1;
	                idx = 0;
	            }

	            if (hasZero && zeroIndex > sharpIndex) {
	                idx = zeroIndex;
	            } else if (sharpIndex > zeroIndex) {
	                if (hasSharp && idx > sharpIndex) {
	                    var rounded = round(number, sharpIndex, negative);

	                    while (rounded.charAt(rounded.length - 1) === ZERO && sharpIndex > 0 && sharpIndex > zeroIndex) {
	                        sharpIndex--;

	                        rounded = round(number, sharpIndex, negative);
	                    }

	                    idx = sharpIndex;
	                } else if (hasZero && idx < zeroIndex) {
	                    idx = zeroIndex;
	                }
	            }
	        }

	        number = round(number, idx, negative);

	        sharpIndex = format.indexOf(SHARP);
	        startZeroIndex = zeroIndex = format.indexOf(ZERO);

	        //define the index of the first digit placeholder
	        if (sharpIndex == -1 && zeroIndex != -1) {
	            start = zeroIndex;
	        } else if (sharpIndex != -1 && zeroIndex == -1) {
	            start = sharpIndex;
	        } else {
	            start = sharpIndex > zeroIndex ? zeroIndex : sharpIndex;
	        }

	        sharpIndex = format.lastIndexOf(SHARP);
	        zeroIndex = format.lastIndexOf(ZERO);

	        //define the index of the last digit placeholder
	        if (sharpIndex == -1 && zeroIndex != -1) {
	            end = zeroIndex;
	        } else if (sharpIndex != -1 && zeroIndex == -1) {
	            end = sharpIndex;
	        } else {
	            end = sharpIndex > zeroIndex ? sharpIndex : zeroIndex;
	        }

	        if (start == length) {
	            end = start;
	        }

	        if (start != -1) {
	            value = number.toString().split(POINT);
	            integer = value[0];
	            fraction = value[1] || EMPTY;

	            integerLength = integer.length;
	            fractionLength = fraction.length;

	            if (negative && (number * -1) >= 0) {
	                negative = false;
	            }

	            number = format.substring(0, start);

	            if (negative && !hasNegativeFormat) {
	                number += "-";
	            }

	            for (idx = start; idx < length; idx++) {
	                ch = format.charAt(idx);

	                if (decimalIndex == -1) {
	                    if (end - idx < integerLength) {
	                        number += integer;
	                        break;
	                    }
	                } else {
	                    if (zeroIndex != -1 && zeroIndex < idx) {
	                        replacement = EMPTY;
	                    }

	                    if ((decimalIndex - idx) <= integerLength && decimalIndex - idx > -1) {
	                        number += integer;
	                        idx = decimalIndex;
	                    }

	                    if (decimalIndex === idx) {
	                        number += (fraction ? decimal : EMPTY) + fraction;
	                        idx += end - decimalIndex + 1;
	                        continue;
	                    }
	                }

	                if (ch === ZERO) {
	                    number += ch;
	                    replacement = ch;
	                } else if (ch === SHARP) {
	                    number += replacement;
	                }
	            }

	            if (hasGroup) {
	                number = groupInteger(number, start + (negative && !hasNegativeFormat ? 1 : 0), Math.max(end, (integerLength + start)), numberFormat);
	            }

	            if (end >= start) {
	                number += format.substring(end + 1);
	            }

	            //replace symbol placeholders
	            if (isCurrency || isPercent) {
	                value = EMPTY;
	                for (idx = 0, length = number.length; idx < length; idx++) {
	                    ch = number.charAt(idx);
	                    value += (ch === "$" || ch === "%") ? symbol : ch;
	                }
	                number = value;
	            }

	            length = literals.length;

	            if (length) {
	                for (idx = 0; idx < length; idx++) {
	                    number = number.replace(PLACEHOLDER, literals[idx]);
	                }
	            }
	        }

	        return number;
	    }

	    var groupInteger = function(number, start, end, numberFormat) {
	        var decimalIndex = number.indexOf(numberFormat[POINT]);
	        var groupSizes = numberFormat.groupSize.slice();
	        var groupSize = groupSizes.shift();
	        var integer, integerLength;
	        var idx, parts, value;
	        var newGroupSize;

	        end = decimalIndex !== -1 ? decimalIndex : end + 1;

	        integer = number.substring(start, end);
	        integerLength = integer.length;

	        if (integerLength >= groupSize) {
	            idx = integerLength;
	            parts = [];

	            while (idx > -1) {
	                value = integer.substring(idx - groupSize, idx);
	                if (value) {
	                    parts.push(value);
	                }
	                idx -= groupSize;
	                newGroupSize = groupSizes.shift();
	                groupSize = newGroupSize !== undefined ? newGroupSize : groupSize;

	                if (groupSize === 0) {
	                    if (idx > 0) {
	                        parts.push(integer.substring(0, idx));
	                    }
	                    break;
	                }
	            }

	            integer = parts.reverse().join(numberFormat[COMMA]);
	            number = number.substring(0, start) + integer + number.substring(end);
	        }

	        return number;
	    };

	    var round = function(value, precision, negative) {
	        precision = precision || 0;

	        value = value.toString().split('e');
	        value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + precision) : precision)));

	        if (negative) {
	            value = -value;
	        }

	        value = value.toString().split('e');
	        value = +(value[0] + 'e' + (value[1] ? (+value[1] - precision) : -precision));

	        return value.toFixed(Math.min(precision, 20));
	    };

	    var toString = function(value, fmt, culture) {
	        if (fmt) {
	            if (objectToString.call(value) === "[object Date]") {
	                return formatDate(value, fmt, culture);
	            } else if (typeof value === NUMBER) {
	                return formatNumber(value, fmt, culture);
	            }
	        }

	        return value !== undefined ? value : "";
	    };

	    kendo.format = function(fmt) {
	        var values = arguments;

	        return fmt.replace(formatRegExp, function(match, index, placeholderFormat) {
	            var value = values[parseInt(index, 10) + 1];

	            return toString(value, placeholderFormat ? placeholderFormat.substring(1) : "");
	        });
	    };

	    kendo._extractFormat = function (format) {
	        if (format.slice(0,3) === "{0:") {
	            format = format.slice(3, format.length - 1);
	        }

	        return format;
	    };

	    kendo._activeElement = function() {
	        try {
	            return document.activeElement;
	        } catch(e) {
	            return document.documentElement.activeElement;
	        }
	    };

	    kendo._round = round;
	    kendo._outerWidth = function (element, includeMargin) { return $(element).outerWidth(includeMargin || false) || 0; };
	    kendo._outerHeight = function (element, includeMargin) { return $(element).outerHeight(includeMargin || false) || 0; };
	    kendo.toString = toString;
	})();


	(function() {
	    var nonBreakingSpaceRegExp = /\u00A0/g,
	        exponentRegExp = /[eE][\-+]?[0-9]+/,
	        shortTimeZoneRegExp = /[+|\-]\d{1,2}/,
	        longTimeZoneRegExp = /[+|\-]\d{1,2}:?\d{2}/,
	        dateRegExp = /^\/Date\((.*?)\)\/$/,
	        offsetRegExp = /[+-]\d*/,
	        FORMATS_SEQUENCE = [ [], [ "G", "g", "F" ], [ "D", "d", "y", "m", "T", "t" ] ],
	        STANDARD_FORMATS = [
	            [
	            "yyyy-MM-ddTHH:mm:ss.fffffffzzz",
	            "yyyy-MM-ddTHH:mm:ss.fffffff",
	            "yyyy-MM-ddTHH:mm:ss.fffzzz",
	            "yyyy-MM-ddTHH:mm:ss.fff",
	            "ddd MMM dd yyyy HH:mm:ss",
	            "yyyy-MM-ddTHH:mm:sszzz",
	            "yyyy-MM-ddTHH:mmzzz",
	            "yyyy-MM-ddTHH:mmzz",
	            "yyyy-MM-ddTHH:mm:ss",
	            "yyyy-MM-dd HH:mm:ss",
	            "yyyy/MM/dd HH:mm:ss"
	            ], [
	            "yyyy-MM-ddTHH:mm",
	            "yyyy-MM-dd HH:mm",
	            "yyyy/MM/dd HH:mm"
	            ], [
	            "yyyy/MM/dd",
	            "yyyy-MM-dd",
	            "HH:mm:ss",
	            "HH:mm"
	            ]
	        ],
	        numberRegExp = {
	            2: /^\d{1,2}/,
	            3: /^\d{1,3}/,
	            4: /^\d{4}/
	        },
	        objectToString = {}.toString;

	    function outOfRange(value, start, end) {
	        return !(value >= start && value <= end);
	    }

	    function designatorPredicate(designator) {
	        return designator.charAt(0);
	    }

	    function mapDesignators(designators) {
	        return $.map(designators, designatorPredicate);
	    }

	    //if date's day is different than the typed one - adjust
	    function adjustDST(date, hours) {
	        if (!hours && date.getHours() === 23) {
	            date.setHours(date.getHours() + 2);
	        }
	    }

	    function lowerArray(data) {
	        var idx = 0,
	            length = data.length,
	            array = [];

	        for (; idx < length; idx++) {
	            array[idx] = (data[idx] + "").toLowerCase();
	        }

	        return array;
	    }

	    function lowerLocalInfo(localInfo) {
	        var newLocalInfo = {}, property;

	        for (property in localInfo) {
	            newLocalInfo[property] = lowerArray(localInfo[property]);
	        }

	        return newLocalInfo;
	    }

	    function parseExact(value, format, culture, strict) {
	        if (!value) {
	            return null;
	        }

	        var lookAhead = function (match) {
	                var i = 0;
	                while (format[idx] === match) {
	                    i++;
	                    idx++;
	                }
	                if (i > 0) {
	                    idx -= 1;
	                }
	                return i;
	            },
	            getNumber = function(size) {
	                var rg = numberRegExp[size] || new RegExp('^\\d{1,' + size + '}'),
	                    match = value.substr(valueIdx, size).match(rg);

	                if (match) {
	                    match = match[0];
	                    valueIdx += match.length;
	                    return parseInt(match, 10);
	                }
	                return null;
	            },
	            getIndexByName = function (names, lower) {
	                var i = 0,
	                    length = names.length,
	                    name, nameLength,
	                    matchLength = 0,
	                    matchIdx = 0,
	                    subValue;

	                for (; i < length; i++) {
	                    name = names[i];
	                    nameLength = name.length;
	                    subValue = value.substr(valueIdx, nameLength);

	                    if (lower) {
	                        subValue = subValue.toLowerCase();
	                    }

	                    if (subValue == name && nameLength > matchLength) {
	                        matchLength = nameLength;
	                        matchIdx = i;
	                    }
	                }

	                if (matchLength) {
	                    valueIdx += matchLength;
	                    return matchIdx + 1;
	                }

	                return null;
	            },
	            checkLiteral = function() {
	                var result = false;
	                if (value.charAt(valueIdx) === format[idx]) {
	                    valueIdx++;
	                    result = true;
	                }
	                return result;
	            },
	            calendar = culture.calendars.standard,
	            year = null,
	            month = null,
	            day = null,
	            hours = null,
	            minutes = null,
	            seconds = null,
	            milliseconds = null,
	            idx = 0,
	            valueIdx = 0,
	            literal = false,
	            date = new Date(),
	            twoDigitYearMax = calendar.twoDigitYearMax || 2029,
	            defaultYear = date.getFullYear(),
	            ch, count, length, pattern,
	            pmHour, UTC, matches,
	            amDesignators, pmDesignators,
	            hoursOffset, minutesOffset,
	            hasTime, match;

	        if (!format) {
	            format = "d"; //shord date format
	        }

	        //if format is part of the patterns get real format
	        pattern = calendar.patterns[format];
	        if (pattern) {
	            format = pattern;
	        }

	        format = format.split("");
	        length = format.length;

	        for (; idx < length; idx++) {
	            ch = format[idx];

	            if (literal) {
	                if (ch === "'") {
	                    literal = false;
	                } else {
	                    checkLiteral();
	                }
	            } else {
	                if (ch === "d") {
	                    count = lookAhead("d");
	                    if (!calendar._lowerDays) {
	                        calendar._lowerDays = lowerLocalInfo(calendar.days);
	                    }

	                    if (day !== null && count > 2) {
	                        continue;
	                    }

	                    day = count < 3 ? getNumber(2) : getIndexByName(calendar._lowerDays[count == 3 ? "namesAbbr" : "names"], true);

	                    if (day === null || outOfRange(day, 1, 31)) {
	                        return null;
	                    }
	                } else if (ch === "M") {
	                    count = lookAhead("M");
	                    if (!calendar._lowerMonths) {
	                        calendar._lowerMonths = lowerLocalInfo(calendar.months);
	                    }
	                    month = count < 3 ? getNumber(2) : getIndexByName(calendar._lowerMonths[count == 3 ? 'namesAbbr' : 'names'], true);

	                    if (month === null || outOfRange(month, 1, 12)) {
	                        return null;
	                    }
	                    month -= 1; //because month is zero based
	                } else if (ch === "y") {
	                    count = lookAhead("y");
	                    year = getNumber(count);

	                    if (year === null) {
	                        return null;
	                    }

	                    if (count == 2) {
	                        if (typeof twoDigitYearMax === "string") {
	                            twoDigitYearMax = defaultYear + parseInt(twoDigitYearMax, 10);
	                        }

	                        year = (defaultYear - defaultYear % 100) + year;
	                        if (year > twoDigitYearMax) {
	                            year -= 100;
	                        }
	                    }
	                } else if (ch === "h" ) {
	                    lookAhead("h");
	                    hours = getNumber(2);
	                    if (hours == 12) {
	                        hours = 0;
	                    }
	                    if (hours === null || outOfRange(hours, 0, 11)) {
	                        return null;
	                    }
	                } else if (ch === "H") {
	                    lookAhead("H");
	                    hours = getNumber(2);
	                    if (hours === null || outOfRange(hours, 0, 23)) {
	                        return null;
	                    }
	                } else if (ch === "m") {
	                    lookAhead("m");
	                    minutes = getNumber(2);
	                    if (minutes === null || outOfRange(minutes, 0, 59)) {
	                        return null;
	                    }
	                } else if (ch === "s") {
	                    lookAhead("s");
	                    seconds = getNumber(2);
	                    if (seconds === null || outOfRange(seconds, 0, 59)) {
	                        return null;
	                    }
	                } else if (ch === "f") {
	                    count = lookAhead("f");

	                    match = value.substr(valueIdx, count).match(numberRegExp[3]);
	                    milliseconds = getNumber(count); //move value index position

	                    if (milliseconds !== null) {
	                        milliseconds = parseFloat("0." + match[0], 10);
	                        milliseconds = kendo._round(milliseconds, 3);
	                        milliseconds *= 1000;
	                    }

	                    if (milliseconds === null || outOfRange(milliseconds, 0, 999)) {
	                        return null;
	                    }

	                } else if (ch === "t") {
	                    count = lookAhead("t");
	                    amDesignators = calendar.AM;
	                    pmDesignators = calendar.PM;

	                    if (count === 1) {
	                        amDesignators = mapDesignators(amDesignators);
	                        pmDesignators = mapDesignators(pmDesignators);
	                    }

	                    pmHour = getIndexByName(pmDesignators);
	                    if (!pmHour && !getIndexByName(amDesignators)) {
	                        return null;
	                    }
	                }
	                else if (ch === "z") {
	                    UTC = true;
	                    count = lookAhead("z");

	                    if (value.substr(valueIdx, 1) === "Z") {
	                        checkLiteral();
	                        continue;
	                    }

	                    matches = value.substr(valueIdx, 6)
	                                   .match(count > 2 ? longTimeZoneRegExp : shortTimeZoneRegExp);

	                    if (!matches) {
	                        return null;
	                    }

	                    matches = matches[0].split(":");

	                    hoursOffset = matches[0];
	                    minutesOffset = matches[1];

	                    if (!minutesOffset && hoursOffset.length > 3) { //(+|-)[hh][mm] format is used
	                        valueIdx = hoursOffset.length - 2;
	                        minutesOffset = hoursOffset.substring(valueIdx);
	                        hoursOffset = hoursOffset.substring(0, valueIdx);
	                    }

	                    hoursOffset = parseInt(hoursOffset, 10);
	                    if (outOfRange(hoursOffset, -12, 13)) {
	                        return null;
	                    }

	                    if (count > 2) {
	                        minutesOffset = matches[0][0] + minutesOffset;
	                        minutesOffset = parseInt(minutesOffset, 10);
	                        if (isNaN(minutesOffset) || outOfRange(minutesOffset, -59, 59)) {
	                            return null;
	                        }
	                    }
	                } else if (ch === "'") {
	                    literal = true;
	                    checkLiteral();
	                } else if (!checkLiteral()) {
	                    return null;
	                }
	            }
	        }

	        // if more characters follow, assume wrong format
	        // https://github.com/telerik/kendo-ui-core/issues/3476
	        if (strict && !/^\s*$/.test(value.substr(valueIdx))) {
	            return null;
	        }

	        hasTime = hours !== null || minutes !== null || seconds || null;

	        if (year === null && month === null && day === null && hasTime) {
	            year = defaultYear;
	            month = date.getMonth();
	            day = date.getDate();
	        } else {
	            if (year === null) {
	                year = defaultYear;
	            }

	            if (day === null) {
	                day = 1;
	            }
	        }

	        if (pmHour && hours < 12) {
	            hours += 12;
	        }

	        if (UTC) {
	            if (hoursOffset) {
	                hours += -hoursOffset;
	            }

	            if (minutesOffset) {
	                minutes += -minutesOffset;
	            }

	            value = new Date(Date.UTC(year, month, day, hours, minutes, seconds, milliseconds));
	        } else {
	            value = new Date(year, month, day, hours, minutes, seconds, milliseconds);
	            adjustDST(value, hours);
	        }

	        if (year < 100) {
	            value.setFullYear(year);
	        }

	        if (value.getDate() !== day && UTC === undefined) {
	            return null;
	        }

	        return value;
	    }

	    function parseMicrosoftFormatOffset(offset) {
	        var sign = offset.substr(0, 1) === "-" ? -1 : 1;

	        offset = offset.substring(1);
	        offset = (parseInt(offset.substr(0, 2), 10) * 60) + parseInt(offset.substring(2), 10);

	        return sign * offset;
	    }

	    function getDefaultFormats(culture) {
	        var length = math.max(FORMATS_SEQUENCE.length, STANDARD_FORMATS.length);
	        var calendar = culture.calendar || culture.calendars.standard;
	        var patterns = calendar.patterns;
	        var cultureFormats, formatIdx, idx;
	        var formats = [];

	        for (idx = 0; idx < length; idx++) {
	            cultureFormats = FORMATS_SEQUENCE[idx];
	            for (formatIdx = 0; formatIdx < cultureFormats.length; formatIdx++) {
	                formats.push(patterns[cultureFormats[formatIdx]]);
	            }
	            formats = formats.concat(STANDARD_FORMATS[idx]);
	        }

	        return formats;
	    }

	    function internalParseDate(value, formats, culture, strict) {
	        if (objectToString.call(value) === "[object Date]") {
	            return value;
	        }

	        var idx = 0;
	        var date = null;
	        var length;
	        var tzoffset;

	        if (value && value.indexOf("/D") === 0) {
	            date = dateRegExp.exec(value);
	            if (date) {
	                date = date[1];
	                tzoffset = offsetRegExp.exec(date.substring(1));

	                date = new Date(parseInt(date, 10));

	                if (tzoffset) {
	                    tzoffset = parseMicrosoftFormatOffset(tzoffset[0]);
	                    date = kendo.timezone.apply(date, 0);
	                    date = kendo.timezone.convert(date, 0, -1 * tzoffset);
	                }

	                return date;
	            }
	        }

	        culture = kendo.getCulture(culture);

	        if (!formats) {
	            formats = getDefaultFormats(culture);
	        }

	        formats = isArray(formats) ? formats: [formats];
	        length = formats.length;

	        for (; idx < length; idx++) {
	            date = parseExact(value, formats[idx], culture, strict);
	            if (date) {
	                return date;
	            }
	        }

	        return date;
	    }

	    kendo.parseDate = function(value, formats, culture) {
	        return internalParseDate(value, formats, culture, false);
	    };

	    kendo.parseExactDate = function(value, formats, culture) {
	        return internalParseDate(value, formats, culture, true);
	    };

	    kendo.parseInt = function(value, culture) {
	        var result = kendo.parseFloat(value, culture);
	        if (result) {
	            result = result | 0;
	        }
	        return result;
	    };

	    kendo.parseFloat = function(value, culture, format) {
	        if (!value && value !== 0) {
	           return null;
	        }

	        if (typeof value === NUMBER) {
	           return value;
	        }

	        value = value.toString();
	        culture = kendo.getCulture(culture);

	        var number = culture.numberFormat,
	            percent = number.percent,
	            currency = number.currency,
	            symbol = currency.symbol,
	            percentSymbol = percent.symbol,
	            negative = value.indexOf("-"),
	            parts, isPercent;

	        //handle exponential number
	        if (exponentRegExp.test(value)) {
	            value = parseFloat(value.replace(number["."], "."));
	            if (isNaN(value)) {
	                value = null;
	            }
	            return value;
	        }

	        if (negative > 0) {
	            return null;
	        } else {
	            negative = negative > -1;
	        }

	        if (value.indexOf(symbol) > -1 || (format && format.toLowerCase().indexOf("c") > -1)) {
	            number = currency;
	            parts = number.pattern[0].replace("$", symbol).split("n");
	            if (value.indexOf(parts[0]) > -1 && value.indexOf(parts[1]) > -1) {
	                value = value.replace(parts[0], "").replace(parts[1], "");
	                negative = true;
	            }
	        } else if (value.indexOf(percentSymbol) > -1) {
	            isPercent = true;
	            number = percent;
	            symbol = percentSymbol;
	        }

	        value = value.replace("-", "")
	                     .replace(symbol, "")
	                     .replace(nonBreakingSpaceRegExp, " ")
	                     .split(number[","].replace(nonBreakingSpaceRegExp, " ")).join("")
	                     .replace(number["."], ".");

	        value = parseFloat(value);

	        if (isNaN(value)) {
	            value = null;
	        } else if (negative) {
	            value *= -1;
	        }

	        if (value && isPercent) {
	            value /= 100;
	        }

	        return value;
	    };
	})();

	    function getShadows(element) {
	        var shadow = element.css(kendo.support.transitions.css + "box-shadow") || element.css("box-shadow"),
	            radius = shadow ? shadow.match(boxShadowRegExp) || [ 0, 0, 0, 0, 0 ] : [ 0, 0, 0, 0, 0 ],
	            blur = math.max((+radius[3]), +(radius[4] || 0));

	        return {
	            left: (-radius[1]) + blur,
	            right: (+radius[1]) + blur,
	            bottom: (+radius[2]) + blur
	        };
	    }

	    function wrap(element, autosize) {
	        var browser = support.browser,
	            percentage,
	            outerWidth = kendo._outerWidth,
	            outerHeight = kendo._outerHeight,
	            parent = element.parent(),
	            windowOuterWidth = outerWidth(window);

	        parent.removeClass("k-animation-container-sm");

	        if (!parent.hasClass("k-animation-container")) {
	            var width = element[0].style.width,
	                height = element[0].style.height,
	                percentWidth = percentRegExp.test(width),
	                percentHeight = percentRegExp.test(height),
	                forceWidth = element.hasClass("k-tooltip") || element.is(".k-menu-horizontal.k-context-menu");

	            percentage = percentWidth || percentHeight;

	            if (!percentWidth && (!autosize || (autosize && width) || forceWidth)) { width = autosize ? outerWidth(element) + 1 : outerWidth(element); }
	            if (!percentHeight && (!autosize || (autosize && height)) || element.is(".k-menu-horizontal.k-context-menu")) { height = outerHeight(element); }

	            element.wrap(
	                         $("<div/>")
	                         .addClass("k-animation-container")
	                         .css({
	                             width: width,
	                             height: height
	                         }));
	            parent = element.parent();

	            if (percentage) {
	                element.css({
	                    width: "100%",
	                    height: "100%",
	                    boxSizing: "border-box",
	                    mozBoxSizing: "border-box",
	                    webkitBoxSizing: "border-box"
	                });
	            }
	        } else {
	            wrapResize(element, autosize);
	        }

	        if(windowOuterWidth < outerWidth(parent)){
	            parent.addClass("k-animation-container-sm");

	            wrapResize(element, autosize);
	        }

	        if (browser.msie && math.floor(browser.version) <= 7) {
	            element.css({ zoom: 1 });
	            element.children(".k-menu").width(element.width());
	        }

	        return parent;
	    }

	    function wrapResize(element, autosize) {
	        var percentage,
	            outerWidth = kendo._outerWidth,
	            outerHeight = kendo._outerHeight,
	            wrapper = element.parent(".k-animation-container"),
	            wrapperStyle = wrapper[0].style;

	        if (wrapper.is(":hidden")) {
	            wrapper.css({
	                display: "",
	                position: ""
	            });
	        }

	        percentage = percentRegExp.test(wrapperStyle.width) || percentRegExp.test(wrapperStyle.height);

	        if (!percentage) {
	            wrapper.css({
	                width: autosize ? outerWidth(element) + 1 : outerWidth(element),
	                height: outerHeight(element),
	                boxSizing: "content-box",
	                mozBoxSizing: "content-box",
	                webkitBoxSizing: "content-box"
	            });
	        }
	    }

	    function deepExtend(destination) {
	        var i = 1,
	            length = arguments.length;

	        for (i = 1; i < length; i++) {
	            deepExtendOne(destination, arguments[i]);
	        }

	        return destination;
	    }

	    function deepExtendOne(destination, source) {
	        var ObservableArray = kendo.data.ObservableArray,
	            LazyObservableArray = kendo.data.LazyObservableArray,
	            DataSource = kendo.data.DataSource,
	            HierarchicalDataSource = kendo.data.HierarchicalDataSource,
	            property,
	            propValue,
	            propType,
	            propInit,
	            destProp;

	        for (property in source) {
	            propValue = source[property];
	            propType = typeof propValue;

	            if (propType === OBJECT && propValue !== null) {
	                propInit = propValue.constructor;
	            } else {
	                propInit = null;
	            }

	            if (propInit &&
	                propInit !== Array && propInit !== ObservableArray && propInit !== LazyObservableArray &&
	                propInit !== DataSource && propInit !== HierarchicalDataSource && propInit !== RegExp &&
	                (!kendo.isFunction(window.ArrayBuffer) || propInit !== ArrayBuffer)) {

	                if (propValue instanceof Date) {
	                    destination[property] = new Date(propValue.getTime());
	                } else if (isFunction(propValue.clone)) {
	                    destination[property] = propValue.clone();
	                } else {
	                    destProp = destination[property];
	                    if (typeof (destProp) === OBJECT) {
	                        destination[property] = destProp || {};
	                    } else {
	                        destination[property] = {};
	                    }
	                    deepExtendOne(destination[property], propValue);
	                }
	            } else if (propType !== UNDEFINED) {
	                destination[property] = propValue;
	            }
	        }

	        return destination;
	    }

	    function testRx(agent, rxs, dflt) {
	        for (var rx in rxs) {
	            if (rxs.hasOwnProperty(rx) && rxs[rx].test(agent)) {
	                return rx;
	            }
	        }
	        return dflt !== undefined ? dflt : agent;
	    }

	    function toHyphens(str) {
	        return str.replace(/([a-z][A-Z])/g, function (g) {
	            return g.charAt(0) + '-' + g.charAt(1).toLowerCase();
	        });
	    }

	    function toCamelCase(str) {
	        return str.replace(/\-(\w)/g, function (strMatch, g1) {
	            return g1.toUpperCase();
	        });
	    }

	    function getComputedStyles(element, properties) {
	        var styles = {}, computedStyle;

	        if (document.defaultView && document.defaultView.getComputedStyle) {
	            computedStyle = document.defaultView.getComputedStyle(element, "");

	            if (properties) {
	                $.each(properties, function(idx, value) {
	                    styles[value] = computedStyle.getPropertyValue(value);
	                });
	            }
	        } else {
	            computedStyle = element.currentStyle;

	            if (properties) {
	                $.each(properties, function(idx, value) {
	                    styles[value] = computedStyle[toCamelCase(value)];
	                });
	            }
	        }

	        if (!kendo.size(styles)) {
	            styles = computedStyle;
	        }

	        return styles;
	    }

	    function isScrollable(element) {
	        if (element && element.className && typeof(element.className) === "string" && element.className.indexOf("k-auto-scrollable") > -1) {
	            return true;
	        }

	        var overflow = getComputedStyles(element, ["overflow"]).overflow;
	        return overflow == "auto" || overflow == "scroll";
	    }

	    function scrollLeft(element, value) {
	        var webkit = support.browser.webkit;
	        var mozila = support.browser.mozilla;
	        var browserVersion = support.browser.version;
	        var el, isRtl;

	        if(element instanceof $ && value !== undefined) {
	            element.each(function(i, e) {
	                scrollLeft(e, value);
	            });

	            return;
	        } else {
	            el = element instanceof $ ? element[0] : element;
	        }

	        if (!el) {
	            return;
	        }

	        isRtl = support.isRtl(element);

	        // After updating browser detection,
	        // Test in which if should the Safari browsers go
	        if (value !== undefined) {
	            if (isRtl && webkit && (browserVersion < 85 || support.browser.safari)) {
	                el.scrollLeft = el.scrollWidth - el.clientWidth - value;
	            } else if (isRtl && (mozila || webkit) && value > 0) {
	                el.scrollLeft = -value;
	            } else {
	                el.scrollLeft = value;
	            }
	        } else {
	            if (isRtl && webkit && (browserVersion < 85 || support.browser.safari)) {
	                return el.scrollWidth - el.clientWidth - el.scrollLeft;
	            } else {
	                return Math.abs(el.scrollLeft);
	            }
	        }
	    }

	    (function () {
	        support._scrollbar = undefined;

	        support.scrollbar = function (refresh) {
	            if (!isNaN(support._scrollbar) && !refresh) {
	                return support._scrollbar;
	            } else {
	                var div = document.createElement("div"),
	                    result;

	                div.style.cssText = "overflow:scroll;overflow-x:hidden;zoom:1;clear:both;display:block";
	                div.innerHTML = "&nbsp;";
	                document.body.appendChild(div);

	                support._scrollbar = result = div.offsetWidth - div.scrollWidth;

	                document.body.removeChild(div);

	                return result;
	            }
	        };

	        support.isRtl = function(element) {
	            return $(element).closest(".k-rtl").length > 0;
	        };

	        var table = document.createElement("table");

	        // Internet Explorer does not support setting the innerHTML of TBODY and TABLE elements
	        try {
	            table.innerHTML = "<tr><td></td></tr>";

	            support.tbodyInnerHtml = true;
	        } catch (e) {
	            support.tbodyInnerHtml = false;
	        }

	        support.touch = "ontouchstart" in window;

	        var docStyle = document.documentElement.style;
	        var transitions = support.transitions = false,
	            transforms = support.transforms = false,
	            elementProto = "HTMLElement" in window ? HTMLElement.prototype : [];

	        support.hasHW3D = ("WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix()) || "MozPerspective" in docStyle || "msPerspective" in docStyle;
	        support.cssFlexbox = ("flexWrap" in docStyle) || ("WebkitFlexWrap" in docStyle) || ("msFlexWrap" in docStyle);

	        each([ "Moz", "webkit", "O", "ms" ], function () {
	            var prefix = this.toString(),
	                hasTransitions = typeof table.style[prefix + "Transition"] === STRING;

	            if (hasTransitions || typeof table.style[prefix + "Transform"] === STRING) {
	                var lowPrefix = prefix.toLowerCase();

	                transforms = {
	                    css: (lowPrefix != "ms") ? "-" + lowPrefix + "-" : "",
	                    prefix: prefix,
	                    event: (lowPrefix === "o" || lowPrefix === "webkit") ? lowPrefix : ""
	                };

	                if (hasTransitions) {
	                    transitions = transforms;
	                    transitions.event = transitions.event ? transitions.event + "TransitionEnd" : "transitionend";
	                }

	                return false;
	            }
	        });

	        table = null;

	        support.transforms = transforms;
	        support.transitions = transitions;

	        support.devicePixelRatio = window.devicePixelRatio === undefined ? 1 : window.devicePixelRatio;

	        try {
	            support.screenWidth = window.outerWidth || window.screen ? window.screen.availWidth : window.innerWidth;
	            support.screenHeight = window.outerHeight || window.screen ? window.screen.availHeight : window.innerHeight;
	        } catch(e) {
	            //window.outerWidth throws error when in IE showModalDialog.
	            support.screenWidth = window.screen.availWidth;
	            support.screenHeight = window.screen.availHeight;
	        }

	        support.detectOS = function (ua) {
	            var os = false, minorVersion, match = [],
	                notAndroidPhone = !/mobile safari/i.test(ua),
	                agentRxs = {
	                    wp: /(Windows Phone(?: OS)?)\s(\d+)\.(\d+(\.\d+)?)/,
	                    fire: /(Silk)\/(\d+)\.(\d+(\.\d+)?)/,
	                    android: /(Android|Android.*(?:Opera|Firefox).*?\/)\s*(\d+)\.?(\d+(\.\d+)?)?/,
	                    iphone: /(iPhone|iPod).*OS\s+(\d+)[\._]([\d\._]+)/,
	                    ipad: /(iPad).*OS\s+(\d+)[\._]([\d_]+)/,
	                    meego: /(MeeGo).+NokiaBrowser\/(\d+)\.([\d\._]+)/,
	                    webos: /(webOS)\/(\d+)\.(\d+(\.\d+)?)/,
	                    blackberry: /(BlackBerry|BB10).*?Version\/(\d+)\.(\d+(\.\d+)?)/,
	                    playbook: /(PlayBook).*?Tablet\s*OS\s*(\d+)\.(\d+(\.\d+)?)/,
	                    windows: /(MSIE)\s+(\d+)\.(\d+(\.\d+)?)/,
	                    tizen: /(tizen).*?Version\/(\d+)\.(\d+(\.\d+)?)/i,
	                    sailfish: /(sailfish).*rv:(\d+)\.(\d+(\.\d+)?).*firefox/i,
	                    ffos: /(Mobile).*rv:(\d+)\.(\d+(\.\d+)?).*Firefox/
	                },
	                osRxs = {
	                    ios: /^i(phone|pad|pod)$/i,
	                    android: /^android|fire$/i,
	                    blackberry: /^blackberry|playbook/i,
	                    windows: /windows/,
	                    wp: /wp/,
	                    flat: /sailfish|ffos|tizen/i,
	                    meego: /meego/
	                },
	                formFactorRxs = {
	                    tablet: /playbook|ipad|fire/i
	                },
	                browserRxs = {
	                    omini: /Opera\sMini/i,
	                    omobile: /Opera\sMobi/i,
	                    firefox: /Firefox|Fennec/i,
	                    mobilesafari: /version\/.*safari/i,
	                    ie: /MSIE|Windows\sPhone/i,
	                    chrome: /chrome|crios/i,
	                    webkit: /webkit/i
	                };

	            for (var agent in agentRxs) {
	                if (agentRxs.hasOwnProperty(agent)) {
	                    match = ua.match(agentRxs[agent]);
	                    if (match) {
	                        if (agent == "windows" && "plugins" in navigator) { return false; } // Break if not Metro/Mobile Windows

	                        os = {};
	                        os.device = agent;
	                        os.tablet = testRx(agent, formFactorRxs, false);
	                        os.browser = testRx(ua, browserRxs, "default");
	                        os.name = testRx(agent, osRxs);
	                        os[os.name] = true;
	                        os.majorVersion = match[2];
	                        os.minorVersion = (match[3] || "0").replace("_", ".");
	                        minorVersion = os.minorVersion.replace(".", "").substr(0, 2);
	                        os.flatVersion = os.majorVersion + minorVersion + (new Array(3 - (minorVersion.length < 3 ? minorVersion.length : 2)).join("0"));
	                        os.cordova = typeof window.PhoneGap !== UNDEFINED || typeof window.cordova !== UNDEFINED; // Use file protocol to detect appModes.
	                        os.appMode = window.navigator.standalone || (/file|local|wmapp/).test(window.location.protocol) || os.cordova; // Use file protocol to detect appModes.

	                        if (os.android && (support.devicePixelRatio < 1.5 && os.flatVersion < 400 || notAndroidPhone) && (support.screenWidth > 800 || support.screenHeight > 800)) {
	                            os.tablet = agent;
	                        }

	                        break;
	                    }
	                }
	            }
	            return os;
	        };

	        var mobileOS = support.mobileOS = support.detectOS(navigator.userAgent);

	        support.wpDevicePixelRatio = mobileOS.wp ? screen.width / 320 : 0;

	        support.hasNativeScrolling = false;

	        if (mobileOS.ios || (mobileOS.android && mobileOS.majorVersion > 2) || mobileOS.wp) {
	            support.hasNativeScrolling = mobileOS;
	        }

	        support.delayedClick = function() {

	            // only the mobile devices with touch events do this.
	            if (support.touch) {
	                // All iOS devices so far (by the time I am writing this, iOS 9.0.2 is the latest),
	                // delay their click events.
	                if (mobileOS.ios) {
	                    return true;
	                }

	                if (mobileOS.android) {

	                    if (!support.browser.chrome) { // older webkits and webviews delay the click
	                        return true;
	                    }

	                    // from here on, we deal with Chrome on Android.
	                    if (support.browser.version < 32) {
	                        return false;
	                    }

	                    // Chrome 32+ does conditional fast clicks if the view port is not user scalable.
	                    return !($("meta[name=viewport]").attr("content") || "").match(/user-scalable=no/i);
	                }
	            }

	            return false;
	        };

	        support.mouseAndTouchPresent = support.touch && !(support.mobileOS.ios || support.mobileOS.android);

	        support.detectBrowser = function(ua) {
	            var browser = false, match = [],
	                browserRxs = {
	                    edge: /(edge)[ \/]([\w.]+)/i,
	                    webkit: /(chrome|crios)[ \/]([\w.]+)/i,
	                    safari: /(webkit)[ \/]([\w.]+)/i,
	                    opera: /(opera)(?:.*version|)[ \/]([\w.]+)/i,
	                    msie: /(msie\s|trident.*? rv:)([\w.]+)/i,
	                    mozilla: /(mozilla)(?:.*? rv:([\w.]+)|)/i
	                };

	            for (var agent in browserRxs) {
	                if (browserRxs.hasOwnProperty(agent)) {
	                    match = ua.match(browserRxs[agent]);
	                    if (match) {
	                        browser = {};
	                        browser[agent] = true;
	                        browser[match[1].toLowerCase().split(" ")[0].split("/")[0]] = true;
	                        browser.version = parseInt(document.documentMode || match[2], 10);

	                        break;
	                    }
	                }
	            }

	            return browser;
	        };

	        support.browser = support.detectBrowser(navigator.userAgent);

	        support.detectClipboardAccess = function() {
	            var commands = {
	                copy: document.queryCommandSupported ? document.queryCommandSupported("copy") : false,
	                cut: document.queryCommandSupported ? document.queryCommandSupported("cut") : false,
	                paste : document.queryCommandSupported ? document.queryCommandSupported("paste") : false
	            };

	            if (support.browser.chrome) {
	                //not using queryCommandSupported due to chromium issues 476508 and 542948
	                commands.paste = false;
	                if(support.browser.version >= 43) {
	                    commands.copy = true;
	                    commands.cut = true;
	                }
	            }

	            return commands;
	        };

	        support.clipboard = support.detectClipboardAccess();

	        support.zoomLevel = function() {
	            try {
	                var browser = support.browser;
	                var ie11WidthCorrection = 0;
	                var docEl = document.documentElement;

	                if (browser.msie && browser.version == 11 && docEl.scrollHeight > docEl.clientHeight && !support.touch) {
	                    ie11WidthCorrection = support.scrollbar();
	                }

	                return support.touch ? (docEl.clientWidth / window.innerWidth) :
	                       browser.msie && browser.version >= 10 ? (((top || window).document.documentElement.offsetWidth + ie11WidthCorrection) / (top || window).innerWidth) : 1;
	            } catch(e) {
	                return 1;
	            }
	        };

	        support.cssBorderSpacing = typeof docStyle.borderSpacing != "undefined" && !(support.browser.msie && support.browser.version < 8);

	        (function(browser) {
	            // add browser-specific CSS class
	            var cssClass = "",
	                docElement = $(document.documentElement),
	                majorVersion = parseInt(browser.version, 10);

	            if (browser.msie) {
	                cssClass = "ie";
	            } else if (browser.mozilla) {
	                cssClass = "ff";
	            } else if (browser.safari) {
	                cssClass = "safari";
	            } else if (browser.webkit) {
	                cssClass = "webkit";
	            } else if (browser.opera) {
	                cssClass = "opera";
	            } else if (browser.edge) {
	                cssClass = "edge";
	            }

	            if (cssClass) {
	                cssClass = "k-" + cssClass + " k-" + cssClass + majorVersion;
	            }
	            if (support.mobileOS) {
	                cssClass += " k-mobile";
	            }

	            if (!support.cssFlexbox) {
	                cssClass += " k-no-flexbox";
	            }

	            docElement.addClass(cssClass);
	        })(support.browser);

	        support.eventCapture = document.documentElement.addEventListener;

	        var input = document.createElement("input");

	        support.placeholder = "placeholder" in input;
	        support.propertyChangeEvent = "onpropertychange" in input;

	        support.input = (function() {
	            var types = ["number", "date", "time", "month", "week", "datetime", "datetime-local"];
	            var length = types.length;
	            var value = "test";
	            var result = {};
	            var idx = 0;
	            var type;

	            for (;idx < length; idx++) {
	                type = types[idx];
	                input.setAttribute("type", type);
	                input.value = value;

	                result[type.replace("-", "")] = input.type !== "text" && input.value !== value;
	            }

	            return result;
	        })();

	        input.style.cssText = "float:left;";

	        support.cssFloat = !!input.style.cssFloat;

	        input = null;

	        support.stableSort = (function() {
	            // Chrome sort is not stable for more than *10* items
	            // IE9+ sort is not stable for than *512* items
	            var threshold = 513;

	            var sorted = [{
	                index: 0,
	                field: "b"
	            }];

	            for (var i = 1; i < threshold; i++) {
	                sorted.push({
	                    index: i,
	                    field: "a"
	                });
	            }

	            sorted.sort(function(a, b) {
	                return a.field > b.field ? 1 : (a.field < b.field ? -1 : 0);
	            });

	            return sorted[0].index === 1;
	        })();

	        support.matchesSelector = elementProto.webkitMatchesSelector || elementProto.mozMatchesSelector ||
	                                  elementProto.msMatchesSelector || elementProto.oMatchesSelector ||
	                                  elementProto.matchesSelector || elementProto.matches ||
	          function( selector ) {
	              var nodeList = document.querySelectorAll ? ( this.parentNode || document ).querySelectorAll( selector ) || [] : $(selector),
	                  i = nodeList.length;

	              while (i--) {
	                  if (nodeList[i] == this) {
	                      return true;
	                  }
	              }

	              return false;
	          };

	        support.matchMedia = "matchMedia" in window;

	        support.pushState = window.history && window.history.pushState;

	        var documentMode = document.documentMode;

	        support.hashChange = ("onhashchange" in window) && !(support.browser.msie && (!documentMode || documentMode <= 8)); // old IE detection

	        support.customElements = ("registerElement" in window.document);

	        var chrome = support.browser.chrome,
	            mobileChrome = support.browser.crios,
	            mozilla = support.browser.mozilla,
	            safari = support.browser.safari;
	        support.msPointers = !chrome && window.MSPointerEvent;
	        support.pointers = !chrome && !mobileChrome && !mozilla && !safari && window.PointerEvent;
	        support.kineticScrollNeeded = mobileOS && (support.touch || support.msPointers || support.pointers);
	    })();


	    function size(obj) {
	        var result = 0, key;
	        for (key in obj) {
	            if (obj.hasOwnProperty(key) && key != "toJSON") { // Ignore fake IE7 toJSON.
	                result++;
	            }
	        }

	        return result;
	    }

	    function getOffset(element, type, positioned) {
	        if (!type) {
	            type = "offset";
	        }

	        var offset = element[type]();
	        // clone ClientRect object to JS object (jQuery3)
	        var result = {
	            top: offset.top,
	            right: offset.right,
	            bottom: offset.bottom,
	            left: offset.left
	        };

	        // IE10 touch zoom is living in a separate viewport
	        if (support.browser.msie && (support.pointers || support.msPointers) && !positioned) {
	            var sign = support.isRtl(element) ? 1 : -1;

	            result.top -= (window.pageYOffset - (document.documentElement.scrollTop));
	            result.left -= (window.pageXOffset + (sign * document.documentElement.scrollLeft));
	        }

	        return result;
	    }

	    var directions = {
	        left: { reverse: "right" },
	        right: { reverse: "left" },
	        down: { reverse: "up" },
	        up: { reverse: "down" },
	        top: { reverse: "bottom" },
	        bottom: { reverse: "top" },
	        "in": { reverse: "out" },
	        out: { reverse: "in" }
	    };

	    function parseEffects(input) {
	        var effects = {};

	        each((typeof input === "string" ? input.split(" ") : input), function(idx) {
	            effects[idx] = this;
	        });

	        return effects;
	    }

	    function fx(element) {
	        return new kendo.effects.Element(element);
	    }

	    var effects = {};

	    $.extend(effects, {
	        enabled: true,
	        Element: function(element) {
	            this.element = $(element);
	        },

	        promise: function(element, options) {
	            if (!element.is(":visible")) {
	                element.css({ display: element.data("olddisplay") || "block" }).css("display");
	            }

	            if (options.hide) {
	                element.data("olddisplay", element.css("display")).hide();
	            }

	            if (options.init) {
	                options.init();
	            }

	            if (options.completeCallback) {
	                options.completeCallback(element); // call the external complete callback with the element
	            }

	            element.dequeue();
	        },

	        disable: function() {
	            this.enabled = false;
	            this.promise = this.promiseShim;
	        },

	        enable: function() {
	            this.enabled = true;
	            this.promise = this.animatedPromise;
	        }
	    });

	    effects.promiseShim = effects.promise;

	    function prepareAnimationOptions(options, duration, reverse, complete) {
	        if (typeof options === STRING) {
	            // options is the list of effect names separated by space e.g. animate(element, "fadeIn slideDown")

	            // only callback is provided e.g. animate(element, options, function() {});
	            if (isFunction(duration)) {
	                complete = duration;
	                duration = 400;
	                reverse = false;
	            }

	            if (isFunction(reverse)) {
	                complete = reverse;
	                reverse = false;
	            }

	            if (typeof duration === BOOLEAN){
	                reverse = duration;
	                duration = 400;
	            }

	            options = {
	                effects: options,
	                duration: duration,
	                reverse: reverse,
	                complete: complete
	            };
	        }

	        return extend({
	            //default options
	            effects: {},
	            duration: 400, //jQuery default duration
	            reverse: false,
	            init: noop,
	            teardown: noop,
	            hide: false
	        }, options, { completeCallback: options.complete, complete: noop }); // Move external complete callback, so deferred.resolve can be always executed.

	    }

	    function animate(element, options, duration, reverse, complete) {
	        var idx = 0,
	            length = element.length,
	            instance;

	        for (; idx < length; idx ++) {
	            instance = $(element[idx]);
	            instance.queue(function() {
	                effects.promise(instance, prepareAnimationOptions(options, duration, reverse, complete));
	            });
	        }

	        return element;
	    }

	    function toggleClass(element, classes, options, add) {
	        if (classes) {
	            classes = classes.split(" ");

	            each(classes, function(idx, value) {
	                element.toggleClass(value, add);
	            });
	        }

	        return element;
	    }

	    if (!("kendoAnimate" in $.fn)) {
	        extend($.fn, {
	            kendoStop: function(clearQueue, gotoEnd) {
	                return this.stop(clearQueue, gotoEnd);
	            },

	            kendoAnimate: function(options, duration, reverse, complete) {
	                return animate(this, options, duration, reverse, complete);
	            },

	            kendoAddClass: function(classes, options){
	                return kendo.toggleClass(this, classes, options, true);
	            },

	            kendoRemoveClass: function(classes, options){
	                return kendo.toggleClass(this, classes, options, false);
	            },
	            kendoToggleClass: function(classes, options, toggle){
	                return kendo.toggleClass(this, classes, options, toggle);
	            }
	        });
	    }

	    var ampRegExp = /&/g,
	        ltRegExp = /</g,
	        quoteRegExp = /"/g,
	        aposRegExp = /'/g,
	        gtRegExp = />/g;
	    function htmlEncode(value) {
	        return ("" + value).replace(ampRegExp, "&amp;").replace(ltRegExp, "&lt;").replace(gtRegExp, "&gt;").replace(quoteRegExp, "&quot;").replace(aposRegExp, "&#39;");
	    }

	    function unescape(value) {
	        var template;

	        try {
	            template = window.decodeURIComponent(value);
	        } catch(error) {
	            // If the string contains Unicode characters
	            // the decodeURIComponent() will throw an error.
	            // Therefore: convert to UTF-8 character
	            template = value.replace(/%u([\dA-F]{4})|%([\dA-F]{2})/gi, function(_, m1, m2) {
	                return String.fromCharCode(parseInt("0x" + (m1 || m2), 16));
	            });
	        }

	        return template;
	    }

	    var eventTarget = function (e) {
	        return e.target;
	    };

	    if (support.touch) {

	        eventTarget = function(e) {
	            var touches = "originalEvent" in e ? e.originalEvent.changedTouches : "changedTouches" in e ? e.changedTouches : null;

	            return touches ? document.elementFromPoint(touches[0].clientX, touches[0].clientY) : e.target;
	        };

	        each(["swipe", "swipeLeft", "swipeRight", "swipeUp", "swipeDown", "doubleTap", "tap"], function(m, value) {
	            $.fn[value] = function(callback) {
	                return this.bind(value, callback);
	            };
	        });
	    }

	    if (support.touch) {
	        if (!support.mobileOS) {
	            support.mousedown = "mousedown touchstart";
	            support.mouseup = "mouseup touchend";
	            support.mousemove = "mousemove touchmove";
	            support.mousecancel = "mouseleave touchcancel";
	            support.click = "click";
	            support.resize = "resize";
	        } else {
	            support.mousedown = "touchstart";
	            support.mouseup = "touchend";
	            support.mousemove = "touchmove";
	            support.mousecancel = "touchcancel";
	            support.click = "touchend";
	            support.resize = "orientationchange";
	        }
	    } else if (support.pointers) {
	        support.mousemove = "pointermove";
	        support.mousedown = "pointerdown";
	        support.mouseup = "pointerup";
	        support.mousecancel = "pointercancel";
	        support.click = "pointerup";
	        support.resize = "orientationchange resize";
	    } else if (support.msPointers) {
	        support.mousemove = "MSPointerMove";
	        support.mousedown = "MSPointerDown";
	        support.mouseup = "MSPointerUp";
	        support.mousecancel = "MSPointerCancel";
	        support.click = "MSPointerUp";
	        support.resize = "orientationchange resize";
	    } else {
	        support.mousemove = "mousemove";
	        support.mousedown = "mousedown";
	        support.mouseup = "mouseup";
	        support.mousecancel = "mouseleave";
	        support.click = "click";
	        support.resize = "resize";
	    }

	    var wrapExpression = function(members, paramName) {
	        var result = paramName || "d",
	            index,
	            idx,
	            length,
	            member,
	            count = 1;

	        for (idx = 0, length = members.length; idx < length; idx++) {
	            member = members[idx];
	            if (member !== "") {
	                index = member.indexOf("[");

	                if (index !== 0) {
	                    if (index == -1) {
	                        member = "." + member;
	                    } else {
	                        count++;
	                        member = "." + member.substring(0, index) + " || {})" + member.substring(index);
	                    }
	                }

	                count++;
	                result += member + ((idx < length - 1) ? " || {})" : ")");
	            }
	        }
	        return new Array(count).join("(") + result;
	    },
	    localUrlRe = /^([a-z]+:)?\/\//i;

	    extend(kendo, {
	        widgets: [],
	        _widgetRegisteredCallbacks: [],
	        ui: kendo.ui || {},
	        fx: kendo.fx || fx,
	        effects: kendo.effects || effects,
	        mobile: kendo.mobile || { },
	        data: kendo.data || {},
	        dataviz: kendo.dataviz || {},
	        drawing: kendo.drawing || {},
	        spreadsheet: { messages: {} },
	        keys: {
	            INSERT: 45,
	            DELETE: 46,
	            BACKSPACE: 8,
	            TAB: 9,
	            ENTER: 13,
	            ESC: 27,
	            LEFT: 37,
	            UP: 38,
	            RIGHT: 39,
	            DOWN: 40,
	            END: 35,
	            HOME: 36,
	            SPACEBAR: 32,
	            PAGEUP: 33,
	            PAGEDOWN: 34,
	            F2: 113,
	            F10: 121,
	            F12: 123,
	            NUMPAD_PLUS: 107,
	            NUMPAD_MINUS: 109,
	            NUMPAD_DOT: 110
	        },
	        support: kendo.support || support,
	        animate: kendo.animate || animate,
	        ns: "",
	        attr: function(value) {
	            return "data-" + kendo.ns + value;
	        },
	        getShadows: getShadows,
	        wrap: wrap,
	        deepExtend: deepExtend,
	        getComputedStyles: getComputedStyles,
	        isScrollable: isScrollable,
	        scrollLeft: scrollLeft,
	        size: size,
	        toCamelCase: toCamelCase,
	        toHyphens: toHyphens,
	        getOffset: kendo.getOffset || getOffset,
	        parseEffects: kendo.parseEffects || parseEffects,
	        toggleClass: kendo.toggleClass || toggleClass,
	        directions: kendo.directions || directions,
	        Observable: Observable,
	        Class: Class,
	        Template: Template,
	        template: proxy(Template.compile, Template),
	        render: proxy(Template.render, Template),
	        stringify: proxy(JSON.stringify, JSON),
	        eventTarget: eventTarget,
	        htmlEncode: htmlEncode,
	        unescape: unescape,
	        isLocalUrl: function(url) {
	            return url && !localUrlRe.test(url);
	        },

	        expr: function(expression, safe, paramName) {
	            expression = expression || "";

	            if (typeof safe == STRING) {
	                paramName = safe;
	                safe = false;
	            }

	            paramName = paramName || "d";

	            if (expression && expression.charAt(0) !== "[") {
	                expression = "." + expression;
	            }

	            if (safe) {
	                expression = expression.replace(/"([^.]*)\.([^"]*)"/g,'"$1_$DOT$_$2"');
	                expression = expression.replace(/'([^.]*)\.([^']*)'/g,"'$1_$DOT$_$2'");
	                expression = wrapExpression(expression.split("."), paramName);
	                expression = expression.replace(/_\$DOT\$_/g, ".");
	            } else {
	                expression = paramName + expression;
	            }

	            return expression;
	        },

	        getter: function(expression, safe) {
	            var key = expression + safe;
	            return getterCache[key] = getterCache[key] || new Function("d", "return " + kendo.expr(expression, safe));
	        },

	        setter: function(expression) {
	            return setterCache[expression] = setterCache[expression] || new Function("d,value", kendo.expr(expression) + "=value");
	        },

	        accessor: function(expression) {
	            return {
	                get: kendo.getter(expression),
	                set: kendo.setter(expression)
	            };
	        },

	        guid: function() {
	            var id = "", i, random;

	            for (i = 0; i < 32; i++) {
	                random = math.random() * 16 | 0;

	                if (i == 8 || i == 12 || i == 16 || i == 20) {
	                    id += "-";
	                }
	                id += (i == 12 ? 4 : (i == 16 ? (random & 3 | 8) : random)).toString(16);
	            }

	            return id;
	        },

	        roleSelector: function(role) {
	            return role.replace(/(\S+)/g, "[" + kendo.attr("role") + "=$1],").slice(0, -1);
	        },

	        directiveSelector: function(directives) {
	            var selectors = directives.split(" ");

	            if (selectors) {
	                for (var i = 0; i < selectors.length; i++) {
	                    if (selectors[i] != "view") {
	                        selectors[i] = selectors[i].replace(/(\w*)(view|bar|strip|over)$/, "$1-$2");
	                    }
	                }
	            }

	            return selectors.join(" ").replace(/(\S+)/g, "kendo-mobile-$1,").slice(0, -1);
	        },

	        triggeredByInput: function(e) {
	            return (/^(label|input|textarea|select)$/i).test(e.target.tagName);
	        },

	        onWidgetRegistered: function(callback) {
	            for (var i = 0, len = kendo.widgets.length; i < len; i++) {
	                callback(kendo.widgets[i]);
	            }

	            kendo._widgetRegisteredCallbacks.push(callback);
	        },

	        logToConsole: function(message, type) {
	            var console = window.console;

	            if (!kendo.suppressLog && typeof(console) != "undefined" && console.log) {
	                console[type || "log"](message);
	            }
	        }
	    });

	    var Widget = Observable.extend( {
	        init: function(element, options) {
	            var that = this;

	            that.element = kendo.jQuery(element).handler(that);

	            that.angular("init", options);

	            Observable.fn.init.call(that);

	            var dataSource = options ? options.dataSource : null;
	            var props;

	            if (options) {
	                props = (that.componentTypes || {})[(options || {}).componentType];
	            }

	            if (dataSource) {
	                // avoid deep cloning the data source
	                options = extend({}, options, { dataSource: {} });
	            }

	            options = that.options = extend(true, {}, that.options, that.defaults, props || {}, options);

	            if (dataSource) {
	                options.dataSource = dataSource;
	            }

	            if (!that.element.attr(kendo.attr("role"))) {
	                that.element.attr(kendo.attr("role"), (options.name || "").toLowerCase());
	            }

	            that.element.data("kendo" + options.prefix + options.name, that);

	            that.bind(that.events, options);
	        },

	        events: [],

	        options: {
	            prefix: ""
	        },

	        _hasBindingTarget: function() {
	            return !!this.element[0].kendoBindingTarget;
	        },

	        _tabindex: function(target) {
	            target = target || this.wrapper;

	            var element = this.element,
	                TABINDEX = "tabindex",
	                tabindex = target.attr(TABINDEX) || element.attr(TABINDEX);

	            element.removeAttr(TABINDEX);

	            target.attr(TABINDEX, !isNaN(tabindex) ? tabindex : 0);
	        },

	        setOptions: function(options) {
	            this._setEvents(options);
	            $.extend(this.options, options);
	        },

	        _setEvents: function(options) {
	            var that = this,
	                idx = 0,
	                length = that.events.length,
	                e;

	            for (; idx < length; idx ++) {
	                e = that.events[idx];
	                if (that.options[e] && options[e]) {
	                    that.unbind(e, that.options[e]);
	                    if (that._events && that._events[e]) {
	                        delete that._events[e];
	                    }
	                }
	            }

	            that.bind(that.events, options);
	        },

	        resize: function(force) {
	            var size = this.getSize(),
	                currentSize = this._size;

	            if (force || (size.width > 0 || size.height > 0) && (!currentSize || size.width !== currentSize.width || size.height !== currentSize.height)) {
	                this._size = size;
	                this._resize(size, force);
	                this.trigger("resize", size);
	            }
	        },

	        getSize: function() {
	            return kendo.dimensions(this.element);
	        },

	        size: function(size) {
	            if (!size) {
	                return this.getSize();
	            } else {
	                this.setSize(size);
	            }
	        },

	        setSize: $.noop,
	        _resize: $.noop,

	        destroy: function() {
	            var that = this;

	            that.element.removeData("kendo" + that.options.prefix + that.options.name);
	            that.element.removeData("handler");
	            that.unbind();
	        },
	        _destroy: function() {
	            this.destroy();
	        },
	        angular: function(){},

	        _muteAngularRebind: function(callback) {
	            this._muteRebind = true;

	            callback.call(this);

	            this._muteRebind = false;
	        }
	    });

	    var DataBoundWidget = Widget.extend({
	        // Angular consumes these.
	        dataItems: function() {
	            return this.dataSource.flatView();
	        },

	        _angularItems: function(cmd) {
	            var that = this;
	            that.angular(cmd, function(){
	                return {
	                    elements: that.items(),
	                    data: $.map(that.dataItems(), function(dataItem){
	                        return { dataItem: dataItem };
	                    })
	                };
	            });
	        }
	    });

	    kendo.dimensions = function(element, dimensions) {
	        var domElement = element[0];

	        if (dimensions) {
	            element.css(dimensions);
	        }

	        return { width: domElement.offsetWidth, height: domElement.offsetHeight };
	    };

	    kendo.notify = noop;

	    var templateRegExp = /template$/i,
	        jsonRegExp = /^\s*(?:\{(?:.|\r\n|\n)*\}|\[(?:.|\r\n|\n)*\])\s*$/,
	        jsonFormatRegExp = /^\{(\d+)(:[^\}]+)?\}|^\[[A-Za-z_]+\]$/,
	        dashRegExp = /([A-Z])/g;

	    function parseOption(element, option) {
	        var value;

	        if (option.indexOf("data") === 0) {
	            option = option.substring(4);
	            option = option.charAt(0).toLowerCase() + option.substring(1);
	        }

	        option = option.replace(dashRegExp, "-$1");
	        value = element.getAttribute("data-" + kendo.ns + option);

	        if (value === null) {
	            value = undefined;
	        } else if (value === "null") {
	            value = null;
	        } else if (value === "true") {
	            value = true;
	        } else if (value === "false") {
	            value = false;
	        } else if (numberRegExp.test(value) && option != "mask") {
	            value = parseFloat(value);
	        } else if (jsonRegExp.test(value) && !jsonFormatRegExp.test(value)) {
	            value = new Function("return (" + value + ")")();
	        }

	        return value;
	    }

	    function parseOptions(element, options, source) {
	        var result = {},
	            option,
	            value,
	            role = element.getAttribute("data-" + kendo.ns + "role");

	        for (option in options) {
	            value = parseOption(element, option);

	            if (value !== undefined) {

	                if (templateRegExp.test(option) && role != "drawer") {
	                    if(typeof value === "string") {
	                        if($("#" + value).length){
	                            value = kendo.template($("#" + value).html());
	                        }else if (source){
	                            value = kendo.template(source[value]);
	                        }
	                    } else {
	                        value = element.getAttribute(option);
	                    }
	                }

	                result[option] = value;
	            }
	        }

	        return result;
	    }

	    kendo.initWidget = function(element, options, roles) {
	        var result,
	            option,
	            widget,
	            idx,
	            length,
	            role,
	            value,
	            dataSource,
	            fullPath,
	            widgetKeyRegExp;

	        // Preserve backwards compatibility with (element, options, namespace) signature, where namespace was kendo.ui
	        if (!roles) {
	            roles = kendo.ui.roles;
	        } else if (roles.roles) {
	            roles = roles.roles;
	        }

	        element = element.nodeType ? element : element[0];

	        role = element.getAttribute("data-" + kendo.ns + "role");

	        if (!role) {
	            return;
	        }

	        fullPath = role.indexOf(".") === -1;

	        // look for any widget that may be already instantiated based on this role.
	        // The prefix used is unknown, hence the regexp
	        //

	        if (fullPath) {
	            widget = roles[role];
	        } else { // full namespace path - like kendo.ui.Widget
	            widget = kendo.getter(role)(window);
	        }

	        var data = $(element).data(),
	            widgetKey = widget ? "kendo" + widget.fn.options.prefix + widget.fn.options.name : "";

	        if (fullPath) {
	            widgetKeyRegExp = new RegExp("^kendo.*" + role + "$", "i");
	        } else { // full namespace path - like kendo.ui.Widget
	            widgetKeyRegExp = new RegExp("^" + widgetKey + "$", "i");
	        }

	        for(var key in data) {
	            if (key.match(widgetKeyRegExp)) {
	                // we have detected a widget of the same kind - save its reference, we will set its options
	                if (key === widgetKey) {
	                    result = data[key];
	                } else {
	                    return data[key];
	                }
	            }
	        }

	        if (!widget) {
	            return;
	        }

	        dataSource = parseOption(element, "dataSource");

	        options = $.extend({}, parseOptions(element, $.extend({}, widget.fn.options, widget.fn.defaults) ), options);

	        if (dataSource) {
	            if (typeof dataSource === STRING) {
	                options.dataSource = kendo.getter(dataSource)(window);
	            } else {
	                options.dataSource = dataSource;
	            }
	        }

	        for (idx = 0, length = widget.fn.events.length; idx < length; idx++) {
	            option = widget.fn.events[idx];

	            value = parseOption(element, option);

	            if (value !== undefined) {
	                options[option] = kendo.getter(value)(window);
	            }
	        }

	        if (!result) {
	            result = new widget(element, options);
	        } else if (!$.isEmptyObject(options)) {
	            result.setOptions(options);
	        }

	        return result;
	    };

	    kendo.rolesFromNamespaces = function(namespaces) {
	        var roles = [],
	            idx,
	            length;

	        if (!namespaces[0]) {
	            namespaces = [kendo.ui, kendo.dataviz.ui];
	        }

	        for (idx = 0, length = namespaces.length; idx < length; idx ++) {
	            roles[idx] = namespaces[idx].roles;
	        }

	        return extend.apply(null, [{}].concat(roles.reverse()));
	    };

	    kendo.init = function(element) {
	        var roles = kendo.rolesFromNamespaces(slice.call(arguments, 1));

	        $(element).find("[data-" + kendo.ns + "role]").addBack().each(function(){
	            kendo.initWidget(this, {}, roles);
	        });
	    };

	    kendo.destroy = function(element) {
	        $(element).find("[data-" + kendo.ns + "role]").addBack().each(function(){
	            var data = $(this).data();

	            for (var key in data) {
	                if (key.indexOf("kendo") === 0 && typeof data[key].destroy === FUNCTION) {
	                    data[key].destroy();
	                }
	            }
	        });
	    };

	    function containmentComparer(a, b) {
	        return $.contains(a, b) ? -1 : 1;
	    }

	    function resizableWidget() {
	        var widget = $(this);
	        return ($.inArray(widget.attr("data-" + kendo.ns + "role"), ["slider", "rangeslider", "breadcrumb"]) > -1) || widget.is(":visible");
	    }

	    kendo.resize = function(element, force) {
	        var widgets = $(element).find("[data-" + kendo.ns + "role]").addBack().filter(resizableWidget);

	        if (!widgets.length) {
	            return;
	        }

	        // sort widgets based on their parent-child relation
	        var widgetsArray = $.makeArray(widgets);
	        widgetsArray.sort(containmentComparer);

	        // resize widgets
	        $.each(widgetsArray, function () {
	            var widget = kendo.widgetInstance($(this));
	            if (widget) {
	                widget.resize(force);
	            }
	        });
	    };

	    kendo.parseOptions = parseOptions;

	    extend(kendo.ui, {
	        Widget: Widget,
	        DataBoundWidget: DataBoundWidget,
	        roles: {},
	        progress: function(container, toggle, options) {
	            var mask = container.find(".k-loading-mask"),
	                support = kendo.support,
	                browser = support.browser,
	                isRtl, leftRight, webkitCorrection, containerScrollLeft, cssClass;

	                options = $.extend({}, {
	                    width: "100%",
	                    height: "100%",
	                    top: container.scrollTop(),
	                    opacity: false
	                }, options);

	                cssClass = options.opacity ? 'k-loading-mask k-opaque' : 'k-loading-mask';

	            if (toggle) {
	                if (!mask.length) {
	                    isRtl = support.isRtl(container);
	                    leftRight = isRtl ? "right" : "left";
	                    containerScrollLeft = kendo.scrollLeft(container);
	                    webkitCorrection = browser.webkit ? (!isRtl ? 0 : container[0].scrollWidth - container.width() - 2 * containerScrollLeft) : 0;

	                    mask = $(kendo.format("<div class='{0}'><span class='k-loading-text'>{1}</span><div class='k-loading-image'></div><div class='k-loading-color'></div></div>", cssClass, kendo.ui.progress.messages.loading))
	                        .width(options.width).height(options.height)
	                        .css("top", options.top)
	                        .css(leftRight, Math.abs(containerScrollLeft) + webkitCorrection)
	                        .prependTo(container);
	                }
	            } else if (mask) {
	                mask.remove();
	            }
	        },
	        plugin: function(widget, register, prefix) {
	            var name = widget.fn.options.name,
	                getter;

	            register = register || kendo.ui;
	            prefix = prefix || "";

	            register[name] = widget;

	            register.roles[name.toLowerCase()] = widget;

	            getter = "getKendo" + prefix + name;
	            name = "kendo" + prefix + name;

	            var widgetEntry = { name: name, widget: widget, prefix: prefix || "" };
	            kendo.widgets.push(widgetEntry);

	            for (var i = 0, len = kendo._widgetRegisteredCallbacks.length; i < len; i++) {
	                kendo._widgetRegisteredCallbacks[i](widgetEntry);
	            }

	            $.fn[name] = function(options) {
	                var value = this,
	                    args;

	                if (typeof options === STRING) {
	                    args = slice.call(arguments, 1);

	                    this.each(function(){
	                        var widget = $.data(this, name),
	                            method,
	                            result;

	                        if (!widget) {
	                            throw new Error(kendo.format("Cannot call method '{0}' of {1} before it is initialized", options, name));
	                        }

	                        method = widget[options];

	                        if (typeof method !== FUNCTION) {
	                            throw new Error(kendo.format("Cannot find method '{0}' of {1}", options, name));
	                        }

	                        result = method.apply(widget, args);

	                        if (result !== undefined) {
	                            value = result;
	                            return false;
	                        }
	                    });
	                } else {
	                    this.each(function() {
	                        return new widget(this, options);
	                    });
	                }

	                return value;
	            };

	            $.fn[name].widget = widget;

	            $.fn[getter] = function() {
	                return this.data(name);
	            };
	        }
	    });

	    kendo.ui.progress.messages = {
	        loading: "Loading..."
	    };

	    var ContainerNullObject = { bind: function () { return this; }, nullObject: true, options: {} };

	    var MobileWidget = Widget.extend({
	        init: function(element, options) {
	            Widget.fn.init.call(this, element, options);
	            this.element.autoApplyNS();
	            this.wrapper = this.element;
	            this.element.addClass("km-widget");
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            this.element.kendoDestroy();
	        },

	        options: {
	            prefix: "Mobile"
	        },

	        events: [],

	        view: function() {
	            var viewElement = this.element.closest(kendo.roleSelector("view splitview modalview drawer"));
	            return kendo.widgetInstance(viewElement, kendo.mobile.ui) || ContainerNullObject;
	        },

	        viewHasNativeScrolling: function() {
	            var view = this.view();
	            return view && view.options.useNativeScrolling;
	        },

	        container: function() {
	            var element = this.element.closest(kendo.roleSelector("view layout modalview drawer splitview"));
	            return kendo.widgetInstance(element.eq(0), kendo.mobile.ui) || ContainerNullObject;
	        }
	    });

	    extend(kendo.mobile, {
	        init: function(element) {
	            kendo.init(element, kendo.mobile.ui, kendo.ui, kendo.dataviz.ui);
	        },

	        appLevelNativeScrolling: function() {
	            return kendo.mobile.application && kendo.mobile.application.options && kendo.mobile.application.options.useNativeScrolling;
	        },

	        roles: {},

	        ui: {
	            Widget: MobileWidget,
	            DataBoundWidget: DataBoundWidget.extend(MobileWidget.prototype),
	            roles: {},
	            plugin: function(widget) {
	                kendo.ui.plugin(widget, kendo.mobile.ui, "Mobile");
	            }
	        }
	    });

	    deepExtend(kendo.dataviz, {
	        init: function(element) {
	            kendo.init(element, kendo.dataviz.ui);
	        },
	        ui: {
	            roles: {},
	            themes: {},
	            views: [],
	            plugin: function(widget) {
	                kendo.ui.plugin(widget, kendo.dataviz.ui);
	            }
	        },
	        roles: {}
	    });

	    kendo.touchScroller = function(elements, options) {
	        // return the first touch scroller
	        if (!options){ options = {}; }

	        options.useNative = true;

	        return $(elements).map(function(idx, element) {
	            element = $(element);
	            if (support.kineticScrollNeeded && kendo.mobile.ui.Scroller && !element.data("kendoMobileScroller")) {
	                element.kendoMobileScroller(options);
	                return element.data("kendoMobileScroller");
	            } else {
	                return false;
	            }
	        })[0];
	    };

	    kendo.preventDefault = function(e) {
	        e.preventDefault();
	    };

	    kendo.widgetInstance = function(element, suites) {
	        var role = element.data(kendo.ns + "role"),
	            widgets = [], i, length,
	            elementData = element.data("kendoView");

	        if (role) {
	            // HACK!!! mobile view scroller widgets are instantiated on data-role="content" elements. We need to discover them when resizing.
	            if (role === "content") {
	                role = "scroller";
	            }

	            // kendoEditorToolbar is not a public plugin, thus it does not exist in kendo.ui.roles.
	            // Therefore, this is needed in order to be resized when placed in Kendo Window.
	            if (role === "editortoolbar") {
	                var editorToolbar = element.data("kendoEditorToolbar");
	                if (editorToolbar) {
	                    return editorToolbar;
	                }
	            }

	            // kendo.View is not a ui plugin

	            if (role === "view" && elementData) {
	                return elementData;
	            }

	            if (suites) {
	                if (suites[0]) {
	                    for (i = 0, length = suites.length; i < length; i ++) {
	                        widgets.push(suites[i].roles[role]);
	                    }
	                } else {
	                    widgets.push(suites.roles[role]);
	                }
	            }
	            else {
	                widgets = [ kendo.ui.roles[role], kendo.dataviz.ui.roles[role],  kendo.mobile.ui.roles[role] ];
	            }

	            if (role.indexOf(".") >= 0) {
	                widgets = [ kendo.getter(role)(window) ];
	            }

	            for (i = 0, length = widgets.length; i < length; i ++) {
	                var widget = widgets[i];
	                if (widget) {
	                    var instance = element.data("kendo" + widget.fn.options.prefix + widget.fn.options.name);
	                    if (instance) {
	                        return instance;
	                    }
	                }
	            }
	        }
	    };

	    kendo.onResize = function(callback) {
	        var handler = callback;
	        if (support.mobileOS.android) {
	            handler = function() { setTimeout(callback, 600); };
	        }

	        $(window).on(support.resize, handler);
	        return handler;
	    };

	    kendo.unbindResize = function(callback) {
	        $(window).off(support.resize, callback);
	    };

	    kendo.attrValue = function(element, key) {
	        return element.data(kendo.ns + key);
	    };

	    kendo.days = {
	        Sunday: 0,
	        Monday: 1,
	        Tuesday: 2,
	        Wednesday: 3,
	        Thursday: 4,
	        Friday: 5,
	        Saturday: 6
	    };

	    function focusable(element, isTabIndexNotNaN) {
	        var nodeName = element.nodeName.toLowerCase();

	        return (/input|select|textarea|button|object/.test(nodeName) ?
	                !element.disabled :
	                "a" === nodeName ?
	                element.href || isTabIndexNotNaN :
	                isTabIndexNotNaN
	               ) &&
	            visible(element);
	    }

	    function visible(element) {
	        return $.expr.pseudos.visible(element) &&
	            !$(element).parents().addBack().filter(function() {
	                return $.css(this,"visibility") === "hidden";
	            }).length;
	    }

	    $.extend($.expr.pseudos, {
	        kendoFocusable: function(element) {
	            var idx = $.attr(element, "tabindex");
	            return focusable(element, !isNaN(idx) && idx > -1);
	        }
	    });

	    var MOUSE_EVENTS = ["mousedown", "mousemove", "mouseenter", "mouseleave", "mouseover", "mouseout", "mouseup", "click"];
	    var EXCLUDE_BUST_CLICK_SELECTOR = "label, input, [data-rel=external]";

	    var MouseEventNormalizer = {
	        setupMouseMute: function() {
	            var idx = 0,
	                length = MOUSE_EVENTS.length,
	                element = document.documentElement;

	            if (MouseEventNormalizer.mouseTrap || !support.eventCapture) {
	                return;
	            }

	            MouseEventNormalizer.mouseTrap = true;

	            MouseEventNormalizer.bustClick = false;
	            MouseEventNormalizer.captureMouse = false;

	            var handler = function(e) {
	                if (MouseEventNormalizer.captureMouse) {
	                    if (e.type === "click") {
	                        if (MouseEventNormalizer.bustClick && !$(e.target).is(EXCLUDE_BUST_CLICK_SELECTOR)) {
	                            e.preventDefault();
	                            e.stopPropagation();
	                        }
	                    } else {
	                        e.stopPropagation();
	                    }
	                }
	            };

	            for (; idx < length; idx++) {
	                element.addEventListener(MOUSE_EVENTS[idx], handler, true);
	            }
	        },

	        muteMouse: function(e) {
	            MouseEventNormalizer.captureMouse = true;
	            if (e.data.bustClick) {
	                MouseEventNormalizer.bustClick = true;
	            }
	            clearTimeout(MouseEventNormalizer.mouseTrapTimeoutID);
	        },

	        unMuteMouse: function() {
	            clearTimeout(MouseEventNormalizer.mouseTrapTimeoutID);
	            MouseEventNormalizer.mouseTrapTimeoutID = setTimeout(function() {
	                MouseEventNormalizer.captureMouse = false;
	                MouseEventNormalizer.bustClick = false;
	            }, 400);
	        }
	    };

	    var eventMap = {
	        down: "touchstart mousedown",
	        move: "mousemove touchmove",
	        up: "mouseup touchend touchcancel",
	        cancel: "mouseleave touchcancel"
	    };

	    if (support.touch && (support.mobileOS.ios || support.mobileOS.android)) {
	        eventMap = {
	            down: "touchstart",
	            move: "touchmove",
	            up: "touchend touchcancel",
	            cancel: "touchcancel"
	        };
	    } else if (support.pointers) {
	        eventMap = {
	            down: "pointerdown",
	            move: "pointermove",
	            up: "pointerup",
	            cancel: "pointercancel pointerleave"
	        };
	    } else if (support.msPointers) {
	        eventMap = {
	            down: "MSPointerDown",
	            move: "MSPointerMove",
	            up: "MSPointerUp",
	            cancel: "MSPointerCancel MSPointerLeave"
	        };
	    }

	    if (support.msPointers && !("onmspointerenter" in window)) { // IE10
	        // Create MSPointerEnter/MSPointerLeave events using mouseover/out and event-time checks
	        $.each({
	            MSPointerEnter: "MSPointerOver",
	            MSPointerLeave: "MSPointerOut"
	        }, function( orig, fix ) {
	            $.event.special[ orig ] = {
	                delegateType: fix,
	                bindType: fix,

	                handle: function( event ) {
	                    var ret,
	                        target = this,
	                        related = event.relatedTarget,
	                        handleObj = event.handleObj;

	                    // For mousenter/leave call the handler if related is outside the target.
	                    // NB: No relatedTarget if the mouse left/entered the browser window
	                    if ( !related || (related !== target && !$.contains( target, related )) ) {
	                        event.type = handleObj.origType;
	                        ret = handleObj.handler.apply( this, arguments );
	                        event.type = fix;
	                    }
	                    return ret;
	                }
	            };
	        });
	    }


	    var getEventMap = function(e) { return (eventMap[e] || e); },
	        eventRegEx = /([^ ]+)/g;

	    kendo.applyEventMap = function(events, ns) {
	        events = events.replace(eventRegEx, getEventMap);

	        if (ns) {
	            events = events.replace(eventRegEx, "$1." + ns);
	        }

	        return events;
	    };

	    kendo.keyDownHandler = function(e, widget) {
	        var events = widget._events.kendoKeydown;

	        if(!events){
	            return true;
	        }

	        events = events.slice();
	        e.sender = widget;
	        e.preventKendoKeydown = false;
	        for (var idx = 0, length = events.length; idx < length; idx++) {
	            events[idx].call(widget, e);
	        }

	        return !e.preventKendoKeydown;
	    };

	    var on = $.fn.on;

	    function kendoJQuery(selector, context) {
	        return new kendoJQuery.fn.init(selector, context);
	    }

	    noDepricateExtend(true, kendoJQuery, $);

	    kendoJQuery.fn = kendoJQuery.prototype = new $();

	    kendoJQuery.fn.constructor = kendoJQuery;

	    kendoJQuery.fn.init = function(selector, context) {
	        if (context && context instanceof $ && !(context instanceof kendoJQuery)) {
	            context = kendoJQuery(context);
	        }

	        return $.fn.init.call(this, selector, context, rootjQuery);
	    };

	    kendoJQuery.fn.init.prototype = kendoJQuery.fn;

	    var rootjQuery = kendoJQuery(document);

	    extend(kendoJQuery.fn, {
	        handler: function(handler) {
	            this.data("handler", handler);
	            return this;
	        },

	        autoApplyNS: function(ns) {
	            this.data("kendoNS", ns || kendo.guid());
	            return this;
	        },

	        on: function() {
	            var that = this,
	                ns = that.data("kendoNS");

	            // support for event map signature
	            if (arguments.length === 1) {
	                return on.call(that, arguments[0]);
	            }

	            var context = that,
	                args = slice.call(arguments);

	            if (typeof args[args.length -1] === UNDEFINED) {
	                args.pop();
	            }

	            var callback =  args[args.length - 1],
	                events = kendo.applyEventMap(args[0], ns);

	            // setup mouse trap
	            if (support.mouseAndTouchPresent && events.search(/mouse|click/) > -1 && this[0] !== document.documentElement) {
	                MouseEventNormalizer.setupMouseMute();

	                var selector = args.length === 2 ? null : args[1],
	                    bustClick = events.indexOf("click") > -1 && events.indexOf("touchend") > -1;

	                on.call(this,
	                    {
	                        touchstart: MouseEventNormalizer.muteMouse,
	                        touchend: MouseEventNormalizer.unMuteMouse
	                    },
	                    selector,
	                    {
	                        bustClick: bustClick
	                    });
	            }

	            if(arguments[0].indexOf("keydown") !== -1 && args[1] && args[1].options){
	                args[0] = events;
	                var widget = args[1];
	                var keyDownCallBack = args[args.length - 1];
	                args[args.length - 1]= function(e){
	                    if(kendo.keyDownHandler(e, widget)){
	                       return keyDownCallBack.apply(this, [e]);
	                    }
	                };
	                on.apply(that, args);
	                return that;
	            }

	            if (typeof callback === STRING) {
	                context = that.data("handler");
	                callback = context[callback];

	                args[args.length - 1] = function(e) {
	                    callback.call(context, e);
	                };
	            }

	            args[0] = events;

	            on.apply(that, args);

	            return that;
	        },

	        kendoDestroy: function(ns) {
	            ns = ns || this.data("kendoNS");

	            if (ns) {
	                this.off("." + ns);
	            }

	            return this;
	        }
	    });

	    kendo.jQuery = kendoJQuery;
	    kendo.eventMap = eventMap;

	    kendo.timezone = (function(){
	        var months =  { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };
	        var days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

	        function ruleToDate(year, rule) {
	            var date;
	            var targetDay;
	            var ourDay;
	            var month = rule[3];
	            var on = rule[4];
	            var time = rule[5];
	            var cache = rule[8];

	            if (!cache) {
	                rule[8] = cache = {};
	            }

	            if (cache[year]) {
	                return cache[year];
	            }

	            if (!isNaN(on)) {
	                date = new Date(Date.UTC(year, months[month], on, time[0], time[1], time[2], 0));
	            } else if (on.indexOf("last") === 0) {
	                date = new Date(Date.UTC(year, months[month] + 1, 1, time[0] - 24, time[1], time[2], 0));

	                targetDay = days[on.substr(4, 3)];
	                ourDay = date.getUTCDay();

	                date.setUTCDate(date.getUTCDate() + targetDay - ourDay - (targetDay > ourDay ? 7 : 0));
	            } else if (on.indexOf(">=") >= 0) {
	                date = new Date(Date.UTC(year, months[month], on.substr(5), time[0], time[1], time[2], 0));

	                targetDay = days[on.substr(0, 3)];
	                ourDay = date.getUTCDay();

	                date.setUTCDate(date.getUTCDate() + targetDay - ourDay + (targetDay < ourDay ? 7 : 0));
	            } else if (on.indexOf("<=") >= 0) {
	                date = new Date(Date.UTC(year, months[month], on.substr(5), time[0], time[1], time[2], 0));

	                targetDay = days[on.substr(0, 3)];
	                ourDay = date.getUTCDay();

	                date.setUTCDate(date.getUTCDate() + targetDay - ourDay - (targetDay > ourDay ? 7 : 0));
	            }

	            return cache[year] = date;
	        }

	        function findRule(utcTime, rules, zone) {
	            rules = rules[zone];

	            if (!rules) {
	                var time = zone.split(":");
	                var offset = 0;

	                if (time.length > 1) {
	                    offset = time[0] * 60 + Number(time[1]);
	                }

	                return [-1000000, 'max', '-', 'Jan', 1, [0, 0, 0], offset, '-'];
	            }

	            var year = new Date(utcTime).getUTCFullYear();

	            rules = jQuery.grep(rules, function(rule) {
	                var from = rule[0];
	                var to = rule[1];

	                return from <= year && (to >= year || (from == year && to == "only") || to == "max");
	            });

	            rules.push(utcTime);

	            rules.sort(function(a, b) {
	                if (typeof a != "number") {
	                    a = Number(ruleToDate(year, a));
	                }

	                if (typeof b != "number") {
	                    b = Number(ruleToDate(year, b));
	                }

	                return a - b;
	            });

	            var rule = rules[jQuery.inArray(utcTime, rules) - 1] || rules[rules.length - 1];

	            return isNaN(rule) ? rule : null;
	        }

	        function findZone(utcTime, zones, timezone) {
	            var zoneRules = zones[timezone];

	            if (typeof zoneRules === "string") {
	                zoneRules = zones[zoneRules];
	            }

	            if (!zoneRules) {
	                throw new Error('Timezone "' + timezone + '" is either incorrect, or kendo.timezones.min.js is not included.');
	            }

	            for (var idx = zoneRules.length - 1; idx >= 0; idx--) {
	                var until = zoneRules[idx][3];

	                if (until && utcTime > until) {
	                    break;
	                }
	            }

	            var zone = zoneRules[idx + 1];

	            if (!zone) {
	                throw new Error('Timezone "' + timezone + '" not found on ' + utcTime + ".");
	            }

	            return zone;
	        }

	        function zoneAndRule(utcTime, zones, rules, timezone) {
	            if (typeof utcTime != NUMBER) {
	                utcTime = Date.UTC(utcTime.getFullYear(), utcTime.getMonth(),
	                    utcTime.getDate(), utcTime.getHours(), utcTime.getMinutes(),
	                    utcTime.getSeconds(), utcTime.getMilliseconds());
	            }

	            var zone = findZone(utcTime, zones, timezone);

	            return {
	                zone: zone,
	                rule: findRule(utcTime, rules, zone[1])
	            };
	        }

	        function offset(utcTime, timezone) {
	            if (timezone == "Etc/UTC" || timezone == "Etc/GMT") {
	                return 0;
	            }

	            var info = zoneAndRule(utcTime, this.zones, this.rules, timezone);
	            var zone = info.zone;
	            var rule = info.rule;

	            return kendo.parseFloat(rule? zone[0] - rule[6] : zone[0]);
	        }

	        function abbr(utcTime, timezone) {
	            var info = zoneAndRule(utcTime, this.zones, this.rules, timezone);
	            var zone = info.zone;
	            var rule = info.rule;

	            var base = zone[2];

	            if (base.indexOf("/") >= 0) {
	                return base.split("/")[rule && +rule[6] ? 1 : 0];
	            } else if (base.indexOf("%s") >= 0) {
	                return base.replace("%s", (!rule || rule[7] == "-") ? '' : rule[7]);
	            }

	            return base;
	        }

	        function convert(date, fromOffset, toOffset) {
	            var tempToOffset = toOffset;
	            var diff;

	            if (typeof fromOffset == STRING) {
	                fromOffset = this.offset(date, fromOffset);
	            }

	            if (typeof toOffset == STRING) {
	                toOffset = this.offset(date, toOffset);
	            }

	            var fromLocalOffset = date.getTimezoneOffset();

	            date = new Date(date.getTime() + (fromOffset - toOffset) * 60000);

	            var toLocalOffset = date.getTimezoneOffset();

	            if (typeof tempToOffset == STRING) {
	                tempToOffset = this.offset(date, tempToOffset);
	            }

	            diff = (toLocalOffset - fromLocalOffset) + (toOffset - tempToOffset);

	            return new Date(date.getTime() + diff * 60000);
	        }

	        function apply(date, timezone) {
	           return this.convert(date, date.getTimezoneOffset(), timezone);
	        }

	        function remove(date, timezone) {
	           return this.convert(date, timezone, date.getTimezoneOffset());
	        }

	        function toLocalDate(time) {
	            return this.apply(new Date(time), "Etc/UTC");
	        }

	        return {
	           zones: {},
	           rules: {},
	           offset: offset,
	           convert: convert,
	           apply: apply,
	           remove: remove,
	           abbr: abbr,
	           toLocalDate: toLocalDate
	        };
	    })();

	    kendo.date = (function(){
	        var MS_PER_MINUTE = 60000,
	            MS_PER_DAY = 86400000;

	        function adjustDST(date, hours) {
	            if (hours === 0 && date.getHours() === 23) {
	                date.setHours(date.getHours() + 2);
	                return true;
	            }

	            return false;
	        }

	        function setDayOfWeek(date, day, dir) {
	            var hours = date.getHours();

	            dir = dir || 1;
	            day = ((day - date.getDay()) + (7 * dir)) % 7;

	            date.setDate(date.getDate() + day);
	            adjustDST(date, hours);
	        }

	        function dayOfWeek(date, day, dir) {
	            date = new Date(date);
	            setDayOfWeek(date, day, dir);
	            return date;
	        }

	        function firstDayOfMonth(date) {
	            return new Date(
	                date.getFullYear(),
	                date.getMonth(),
	                1
	            );
	        }

	        function lastDayOfMonth(date) {
	            var last = new Date(date.getFullYear(), date.getMonth() + 1, 0),
	                first = firstDayOfMonth(date),
	                timeOffset = Math.abs(last.getTimezoneOffset() - first.getTimezoneOffset());

	            if (timeOffset) {
	                last.setHours(first.getHours() + (timeOffset / 60));
	            }

	            return last;
	        }

	        function moveDateToWeekStart(date, weekStartDay) {
	            if (weekStartDay !== 1) {
	                return addDays(dayOfWeek(date, weekStartDay, -1), 4);
	            }

	            return addDays(date, (4 - (date.getDay() || 7)));
	        }

	        function calcWeekInYear(date, weekStartDay) {
	            var firstWeekInYear = new Date(date.getFullYear(), 0, 1, -6);

	            var newDate = moveDateToWeekStart(date, weekStartDay);

	            var diffInMS = newDate.getTime() - firstWeekInYear.getTime();

	            var days = Math.floor(diffInMS / MS_PER_DAY);

	            return 1 + Math.floor(days / 7);
	        }

	        function weekInYear(date, weekStartDay) {
	            if(weekStartDay === undefined) {
	                weekStartDay = kendo.culture().calendar.firstDay;
	            }

	            var prevWeekDate = addDays(date, -7);
	            var nextWeekDate = addDays(date, 7);

	            var weekNumber = calcWeekInYear(date, weekStartDay);

	            if (weekNumber === 0) {
	                return calcWeekInYear(prevWeekDate, weekStartDay) + 1;
	            }

	            if (weekNumber === 53 && calcWeekInYear(nextWeekDate, weekStartDay) > 1) {
	                return 1;
	            }

	            return weekNumber;
	        }

	        function getDate(date) {
	            date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
	            adjustDST(date, 0);
	            return date;
	        }

	        function toUtcTime(date) {
	            return Date.UTC(date.getFullYear(), date.getMonth(),
	                        date.getDate(), date.getHours(), date.getMinutes(),
	                        date.getSeconds(), date.getMilliseconds());
	        }

	        function getMilliseconds(date) {
	            return toInvariantTime(date).getTime() - getDate(toInvariantTime(date));
	        }

	        function isInTimeRange(value, min, max) {
	            var msMin = getMilliseconds(min),
	                msMax = getMilliseconds(max),
	                msValue;

	            if (!value || msMin == msMax) {
	                return true;
	            }

	            if (min >= max) {
	                max += MS_PER_DAY;
	            }

	            msValue = getMilliseconds(value);

	            if (msMin > msValue) {
	                msValue += MS_PER_DAY;
	            }

	            if (msMax < msMin) {
	                msMax += MS_PER_DAY;
	            }

	            return msValue >= msMin && msValue <= msMax;
	        }

	        function isInDateRange(value, min, max) {
	            var msMin = min.getTime(),
	                msMax = max.getTime(),
	                msValue;

	            if (msMin >= msMax) {
	                msMax += MS_PER_DAY;
	            }

	            msValue = value.getTime();

	            return msValue >= msMin && msValue <= msMax;
	        }

	        function addDays(date, offset) {
	            var hours = date.getHours();
	                date = new Date(date);

	            setTime(date, offset * MS_PER_DAY);
	            adjustDST(date, hours);
	            return date;
	        }

	        function setTime(date, milliseconds, ignoreDST) {
	            var offset = date.getTimezoneOffset();
	            var difference;

	            date.setTime(date.getTime() + milliseconds);

	            if (!ignoreDST) {
	                difference = date.getTimezoneOffset() - offset;
	                date.setTime(date.getTime() + difference * MS_PER_MINUTE);
	            }
	        }

	        function setHours(date, time) {
	            date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds());
	            adjustDST(date, time.getHours());
	            return date;
	        }

	        function today() {
	            return getDate(new Date());
	        }

	        function isToday(date) {
	           return getDate(date).getTime() == today().getTime();
	        }

	        function toInvariantTime(date) {
	            var staticDate = new Date(1980, 1, 1, 0, 0, 0);

	            if (date) {
	                staticDate.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
	            }

	            return staticDate;
	        }

	        return {
	            adjustDST: adjustDST,
	            dayOfWeek: dayOfWeek,
	            setDayOfWeek: setDayOfWeek,
	            getDate: getDate,
	            isInDateRange: isInDateRange,
	            isInTimeRange: isInTimeRange,
	            isToday: isToday,
	            nextDay: function(date) {
	                return addDays(date, 1);
	            },
	            previousDay: function(date) {
	                return addDays(date, -1);
	            },
	            toUtcTime: toUtcTime,
	            MS_PER_DAY: MS_PER_DAY,
	            MS_PER_HOUR: 60 * MS_PER_MINUTE,
	            MS_PER_MINUTE: MS_PER_MINUTE,
	            setTime: setTime,
	            setHours: setHours,
	            addDays: addDays,
	            today: today,
	            toInvariantTime: toInvariantTime,
	            firstDayOfMonth: firstDayOfMonth,
	            lastDayOfMonth: lastDayOfMonth,
	            weekInYear: weekInYear,
	            getMilliseconds: getMilliseconds
	        };
	    })();


	    kendo.stripWhitespace = function(element) {
	        if (document.createNodeIterator) {
	            var iterator = document.createNodeIterator(element, NodeFilter.SHOW_TEXT, function(node) {
	                    return node.parentNode == element ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
	                }, false);

	            while (iterator.nextNode()) {
	                if (iterator.referenceNode && !iterator.referenceNode.textContent.trim()) {
	                    iterator.referenceNode.parentNode.removeChild(iterator.referenceNode);
	                }
	            }
	        } else { // IE7/8 support
	            for (var i = 0; i < element.childNodes.length; i++) {
	                var child = element.childNodes[i];

	                if (child.nodeType == 3 && !/\S/.test(child.nodeValue)) {
	                    element.removeChild(child);
	                    i--;
	                }

	                if (child.nodeType == 1) {
	                    kendo.stripWhitespace(child);
	                }
	            }
	        }
	    };

	    var animationFrame  = window.requestAnimationFrame       ||
	                          window.webkitRequestAnimationFrame ||
	                          window.mozRequestAnimationFrame    ||
	                          window.oRequestAnimationFrame      ||
	                          window.msRequestAnimationFrame     ||
	                          function(callback){ setTimeout(callback, 1000 / 60); };

	    kendo.animationFrame = function(callback) {
	        animationFrame.call(window, callback);
	    };

	    var animationQueue = [];

	    kendo.queueAnimation = function(callback) {
	        animationQueue[animationQueue.length] = callback;
	        if (animationQueue.length === 1) {
	            kendo.runNextAnimation();
	        }
	    };

	    kendo.runNextAnimation = function() {
	        kendo.animationFrame(function() {
	            if (animationQueue[0]) {
	                animationQueue.shift()();
	                if (animationQueue[0]) {
	                    kendo.runNextAnimation();
	                }
	            }
	        });
	    };

	    kendo.parseQueryStringParams = function(url) {
	        var queryString = url.split('?')[1] || "",
	            params = {},
	            paramParts = queryString.split(/&|=/),
	            length = paramParts.length,
	            idx = 0;

	        for (; idx < length; idx += 2) {
	            if(paramParts[idx] !== "") {
	                params[decodeURIComponent(paramParts[idx])] = decodeURIComponent(paramParts[idx + 1]);
	            }
	        }

	        return params;
	    };

	    kendo.elementUnderCursor = function(e) {
	        if (typeof e.x.client != "undefined") {
	            return document.elementFromPoint(e.x.client, e.y.client);
	        }
	    };

	    kendo.wheelDeltaY = function(jQueryEvent) {
	        var e = jQueryEvent.originalEvent,
	            deltaY = e.wheelDeltaY,
	            delta;

	            if (e.wheelDelta) { // Webkit and IE
	                if (deltaY === undefined || deltaY) { // IE does not have deltaY, thus always scroll (horizontal scrolling is treated as vertical)
	                    delta = e.wheelDelta;
	                }
	            } else if (e.detail && e.axis === e.VERTICAL_AXIS) { // Firefox and Opera
	                delta = (-e.detail) * 10;
	            }

	        return delta;
	    };

	    kendo.throttle = function(fn, delay) {
	        var timeout;
	        var lastExecTime = 0;

	        if (!delay || delay <= 0) {
	            return fn;
	        }

	        var throttled = function() {
	            var that = this;
	            var elapsed = +new Date() - lastExecTime;
	            var args = arguments;

	            function exec() {
	                fn.apply(that, args);
	                lastExecTime = +new Date();
	            }

	            // first execution
	            if (!lastExecTime) {
	                return exec();
	            }

	            if (timeout) {
	                clearTimeout(timeout);
	            }

	            if (elapsed > delay) {
	                exec();
	            } else {
	                timeout = setTimeout(exec, delay - elapsed);
	            }
	        };

	        throttled.cancel = function() {
	            clearTimeout(timeout);
	        };

	        return throttled;
	    };


	    kendo.caret = function (element, start, end) {
	        var rangeElement;
	        var isPosition = start !== undefined;

	        if (end === undefined) {
	            end = start;
	        }

	        if (element[0]) {
	            element = element[0];
	        }

	        if (isPosition && element.disabled) {
	            return;
	        }

	        try {
	            if (element.selectionStart !== undefined) {
	                if (isPosition) {
	                    element.focus();
	                    var mobile = support.mobileOS;
	                    if(mobile.wp || mobile.android) {// without the timeout the caret is at the end of the input
	                        setTimeout(function() { element.setSelectionRange(start, end); }, 0);
	                    }
	                    else {
	                        element.setSelectionRange(start, end);
	                    }
	                } else {
	                    start = [element.selectionStart, element.selectionEnd];
	                }
	            } else if (document.selection) {
	                if ($(element).is(":visible")) {
	                    element.focus();
	                }

	                rangeElement = element.createTextRange();

	                if (isPosition) {
	                    rangeElement.collapse(true);
	                    rangeElement.moveStart("character", start);
	                    rangeElement.moveEnd("character", end - start);
	                    rangeElement.select();
	                } else {
	                    var rangeDuplicated = rangeElement.duplicate(),
	                        selectionStart, selectionEnd;

	                        rangeElement.moveToBookmark(document.selection.createRange().getBookmark());
	                        rangeDuplicated.setEndPoint('EndToStart', rangeElement);
	                        selectionStart = rangeDuplicated.text.length;
	                        selectionEnd = selectionStart + rangeElement.text.length;

	                    start = [selectionStart, selectionEnd];
	                }
	            }
	        } catch(e) {
	            /* element is not focused or it is not in the DOM */
	            start = [];
	        }

	        return start;
	    };

	    kendo.compileMobileDirective = function(element, scope) {
	        var angular = window.angular;

	        element.attr("data-" + kendo.ns + "role", element[0].tagName.toLowerCase().replace('kendo-mobile-', '').replace('-', ''));

	        angular.element(element).injector().invoke(["$compile", function($compile) {
	            $compile(element)(scope);

	            if (!/^\$(digest|apply)$/.test(scope.$$phase)) {
	                scope.$digest();
	            }
	        }]);

	        return kendo.widgetInstance(element, kendo.mobile.ui);
	    };

	    kendo.antiForgeryTokens = function() {
	        var tokens = { },
	            csrf_token = $("meta[name=csrf-token],meta[name=_csrf]").attr("content"),
	            csrf_param = $("meta[name=csrf-param],meta[name=_csrf_header]").attr("content");

	        $("input[name^='__RequestVerificationToken']").each(function() {
	            tokens[this.name] = this.value;
	        });

	        if (csrf_param !== undefined && csrf_token !== undefined) {
	          tokens[csrf_param] = csrf_token;
	        }

	        return tokens;
	    };

	    kendo.cycleForm = function(form) {
	        var firstElement = form.find("input, .k-widget").first();
	        var lastElement = form.find("button, .k-button").last();

	        function focus(el) {
	            var widget = kendo.widgetInstance(el);

	            if (widget && widget.focus) {
	              widget.focus();
	            } else {
	              el.focus();
	            }
	        }

	        lastElement.on("keydown", function(e) {
	          if (e.keyCode == kendo.keys.TAB && !e.shiftKey) {
	            e.preventDefault();
	            focus(firstElement);
	          }
	        });

	        firstElement.on("keydown", function(e) {
	          if (e.keyCode == kendo.keys.TAB && e.shiftKey) {
	            e.preventDefault();
	            focus(lastElement);
	          }
	        });
	    };

	    kendo.focusElement = function(element) {
	        var scrollTopPositions = [];
	        var scrollableParents = element.parentsUntil("body")
	                .filter(function(index, element) {
	                    var computedStyle = kendo.getComputedStyles(element, ["overflow"]);
	                    return computedStyle.overflow !== "visible";
	                })
	                .add(window);

	        scrollableParents.each(function(index, parent) {
	            scrollTopPositions[index] = $(parent).scrollTop();
	        });

	        try {
	            //The setActive method does not cause the document to scroll to the active object in the current page
	            element[0].setActive();
	        } catch (e) {
	            element[0].focus();
	        }

	        scrollableParents.each(function(index, parent) {
	            $(parent).scrollTop(scrollTopPositions[index]);
	        });
	    };

	    kendo.focusNextElement = function () {
	        if (document.activeElement) {
	            var focussable = $(":kendoFocusable");
	            var index = focussable.index(document.activeElement);

	            if(index > -1) {
	               var nextElement = focussable[index + 1] || focussable[0];
	               nextElement.focus();
	            }
	        }
	    };

	    kendo.trim = function(value) {
	        if(!!value) {
	            return value.toString().trim();
	        } else {
	            return "";
	        }
	    };

	    kendo.getWidgetFocusableElement = function(element) {
	        var nextFocusable = element.closest(":kendoFocusable"),
	            widgetInstance = kendo.widgetInstance(element),
	            target;

	        if (nextFocusable.length) {
	            target = nextFocusable;
	        } else if (widgetInstance) {
	            target = widgetInstance.options.name === 'Editor' ?
	                $(widgetInstance.body) :
	                widgetInstance.wrapper.find(":kendoFocusable").first();
	        } else {
	            target = element;
	        }

	        return target;
	    };

	    kendo.addAttribute =  function(element, attribute, value) {
	        var current = element.attr(attribute) || "";

	        if (current.indexOf(value) < 0) {
	            element.attr(attribute, (current + " " + value).trim());
	        }
	    };

	    kendo.removeAttribute = function(element, attribute, value) {
	        var current = element.attr(attribute) || "";

	        element.attr(attribute, current.replace(value, "").trim());
	    };

	    kendo.toggleAttribute = function(element, attribute, value) {
	        var current = element.attr(attribute) || "";

	        if (current.indexOf(value) < 0) {
	            kendo.addAttribute(element, attribute, value);
	        } else {
	            kendo.removeAttribute(element, attribute, value);
	        }
	    };

	    kendo.matchesMedia = function(mediaQuery) {
	        var media = kendo._bootstrapToMedia(mediaQuery) || mediaQuery;
	        return support.matchMedia && window.matchMedia(media).matches;
	    };

	    kendo._bootstrapToMedia = function(bootstrapMedia) {
	        return {
	            "xs": "(max-width: 576px)",
	            "sm": "(min-width: 576px)",
	            "md": "(min-width: 768px)",
	            "lg": "(min-width: 992px)",
	            "xl": "(min-width: 1200px)"
	        }[bootstrapMedia];
	    };

	    kendo.fileGroupMap = {
	        audio: [".aif", ".iff", ".m3u", ".m4a", ".mid", ".mp3", ".mpa", ".wav", ".wma", ".ogg", ".wav", ".wma", ".wpl"],
	        video: [".3g2", ".3gp", ".avi", ".asf", ".flv", ".m4u", ".rm", ".h264", ".m4v", ".mkv", ".mov", ".mp4", ".mpg",
	                ".rm", ".swf", ".vob", ".wmv"],
	        image: [".ai", ".dds", ".heic", ".jpe", "jfif", ".jif", ".jp2", ".jps", ".eps", ".bmp", ".gif", ".jpeg",
	                ".jpg", ".png", ".ps", ".psd", ".svg", ".svgz", ".tif", ".tiff"],
	        txt: [".doc", ".docx", ".log", ".pages", ".tex", ".wpd", ".wps", ".odt", ".rtf", ".text", ".txt", ".wks"],
	        presentation: [".key", ".odp", ".pps", ".ppt", ".pptx"],
	        data: [".xlr", ".xls", ".xlsx"],
	        programming: [".tmp", ".bak", ".msi", ".cab", ".cpl", ".cur", ".dll", ".dmp", ".drv", ".icns", ".ico", ".link",
	                      ".sys", ".cfg", ".ini", ".asp", ".aspx", ".cer", ".csr", ".css", ".dcr", ".htm", ".html", ".js",
	                      ".php", ".rss", ".xhtml"],
	        pdf: [".pdf"],
	        config: [".apk", ".app", ".bat", ".cgi", ".com", ".exe", ".gadget", ".jar", ".wsf"],
	        zip: [".7z", ".cbr", ".gz", ".sitx", ".arj", ".deb", ".pkg", ".rar", ".rpm", ".tar.gz", ".z", ".zip", ".zipx"],
	        "disc-image": [".dmg", ".iso", ".toast", ".vcd", ".bin", ".cue", ".mdf"]
	    };

	    kendo.getFileGroup = function(extension, withPrefix) {
	        var fileTypeMap = kendo.fileGroupMap;
	        var groups = Object.keys(fileTypeMap);
	        var type = "file";

	        if (extension === undefined || !extension.length) {
	            return type;
	        }

	        for (var i = 0; i < groups.length; i += 1) {
	            var extensions = fileTypeMap[groups[i]];

	            if (extensions.indexOf(extension.toLowerCase()) > -1) {
	               return withPrefix ? "file-" + groups[i] : groups[i];
	            }
	        }

	        return type;
	    };

	    kendo.getFileSizeMessage = function(size) {
	        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

	        if (size === 0) {
	            return '0 Byte';
	        }

	        var i = parseInt(Math.floor(Math.log(size) / Math.log(1024)), 10);
	        return Math.round(size / Math.pow(1024, i), 2) + ' ' + sizes[i];
	    };

	    kendo.selectorFromClasses = function(classes) {
	        return "."+classes.split(" ").join(".");
	    };

	    // jQuery deferred helpers

	    // influenced from: https://gist.github.com/fearphage/4341799
	    kendo.whenAll = function(array) {
	        var resolveValues = arguments.length == 1 && $.isArray(array) ? array : Array.prototype.slice.call(arguments),
	            length = resolveValues.length,
	            remaining = length,
	            deferred = $.Deferred(),
	            i = 0,
	            failed = 0,
	            rejectContexts = Array(length),
	            rejectValues = Array(length),
	            resolveContexts = Array(length),
	            value;

	        function updateFunc (index, contexts, values) {
	            return function() {
	                if(values != resolveValues) {
	                    failed++;
	                }

	                deferred.notifyWith(
	                    contexts[index] = this,
	                    values[index] = Array.prototype.slice.call(arguments)
	                );

	                if (!(--remaining)) {
	                    deferred[(!failed ? 'resolve' : 'reject') + 'With'](contexts, values);
	                }
	            };
	        }

	        for (; i < length; i++) {
	            if ((value = resolveValues[i]) && $.isFunction(value.promise)) {
	                value.promise()
	                    .done(updateFunc(i, resolveContexts, resolveValues))
	                    .fail(updateFunc(i, rejectContexts, rejectValues));
	            }

	            else {
	                deferred.notifyWith(this, value);
	                --remaining;
	            }
	        }

	        if (!remaining) {
	            deferred.resolveWith(resolveContexts, resolveValues);
	        }

	        return deferred.promise();
	    };

	    // kendo.saveAs -----------------------------------------------
	    (function() {
	        function postToProxy(dataURI, fileName, proxyURL, proxyTarget) {
	            var form = $("<form>").attr({
	                action: proxyURL,
	                method: "POST",
	                target: proxyTarget
	            });

	            var data = kendo.antiForgeryTokens();
	            data.fileName = fileName;

	            var parts = dataURI.split(";base64,");
	            data.contentType = parts[0].replace("data:", "");
	            data.base64 = parts[1];

	            for (var name in data) {
	                if (data.hasOwnProperty(name)) {
	                    $('<input>').attr({
	                        value: data[name],
	                        name: name,
	                        type: "hidden"
	                    }).appendTo(form);
	                }
	            }

	            form.appendTo("body").submit().remove();
	        }

	        var fileSaver = document.createElement("a");
	        var downloadAttribute = "download" in fileSaver && !kendo.support.browser.edge;

	        function saveAsBlob(dataURI, fileName) {
	            var blob = dataURI; // could be a Blob object

	            if (typeof dataURI == "string") {
	                var parts = dataURI.split(";base64,");
	                var contentType = parts[0];
	                var base64 = atob(parts[1]);
	                var array = new Uint8Array(base64.length);

	                for (var idx = 0; idx < base64.length; idx++) {
	                    array[idx] = base64.charCodeAt(idx);
	                }
	                blob = new Blob([array.buffer], { type: contentType });
	            }

	            navigator.msSaveBlob(blob, fileName);
	        }

	        function saveAsDataURI(dataURI, fileName) {
	            if (window.Blob && dataURI instanceof Blob) {
	                dataURI = URL.createObjectURL(dataURI);
	            }

	            fileSaver.download = fileName;
	            fileSaver.href = dataURI;

	            var e = document.createEvent("MouseEvents");
	            e.initMouseEvent("click", true, false, window,
	                0, 0, 0, 0, 0, false, false, false, false, 0, null);

	            fileSaver.dispatchEvent(e);
	            setTimeout(function(){
	                URL.revokeObjectURL(dataURI);
	            });
	        }

	        kendo.saveAs = function(options) {
	            var save = postToProxy;

	            if (!options.forceProxy) {
	                if (downloadAttribute) {
	                    save = saveAsDataURI;
	                } else if (navigator.msSaveBlob) {
	                    save = saveAsBlob;
	                }
	            }

	            save(options.dataURI, options.fileName, options.proxyURL, options.proxyTarget);
	        };
	    })();

	    // kendo proxySetters
	    kendo.proxyModelSetters = function proxyModelSetters(data) {
	        var observable = {};

	        Object.keys(data || {}).forEach(function(property) {
	          Object.defineProperty(observable, property, {
	            get: function() {
	              return data[property];
	            },
	            set: function(value) {
	              data[property] = value;
	              data.dirty = true;
	            }
	          });
	        });

	        return observable;
	    };


	    // Kendo defaults
	    (function() {

	        kendo.defaults = kendo.defaults || {};
	        kendo.setDefaults = function(key, value) {
	            var path = key.split(".");
	            var curr = kendo.defaults;

	            key = path.pop();

	            path.forEach(function(part) {
	                if (curr[part] === undefined) {
	                    curr[part] = {};
	                }

	                curr = curr[part];
	            });

	            if (value.constructor === Object) {
	                curr[key] = deepExtend({}, curr[key], value);
	            } else {
	                curr[key] = value;
	            }
	        };

	    })();

	})(jQuery, window);

	return window.kendo;

	}, __webpack_require__(3));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1048)))

/***/ })

/******/ });

/***/ }),

/***/ "D2L2":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "D4cr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var context_1 = __webpack_require__("RQ1/");
var context_2 = __webpack_require__("RQ1/");
var logger_1 = __webpack_require__("U9Xd");
var eventService_1 = __webpack_require__("k5uU");
var events_1 = __webpack_require__("3ok8");
var context_3 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var context_4 = __webpack_require__("RQ1/");
var constants_1 = __webpack_require__("ZZFX");
var columnApi_1 = __webpack_require__("E/Wy");
var gridApi_1 = __webpack_require__("BAow");
var SelectionController = (function () {
    function SelectionController() {
    }
    SelectionController.prototype.setBeans = function (loggerFactory) {
        this.logger = loggerFactory.create('SelectionController');
        this.reset();
        if (this.gridOptionsWrapper.isRowModelDefault()) {
            this.eventService.addEventListener(events_1.Events.EVENT_ROW_DATA_CHANGED, this.reset.bind(this));
        }
        else {
            this.logger.log('dont know what to do here');
        }
    };
    SelectionController.prototype.init = function () {
        this.groupSelectsChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
        this.eventService.addEventListener(events_1.Events.EVENT_ROW_SELECTED, this.onRowSelected.bind(this));
    };
    SelectionController.prototype.setLastSelectedNode = function (rowNode) {
        this.lastSelectedNode = rowNode;
    };
    SelectionController.prototype.getLastSelectedNode = function () {
        return this.lastSelectedNode;
    };
    SelectionController.prototype.getSelectedNodes = function () {
        var selectedNodes = [];
        utils_1.Utils.iterateObject(this.selectedNodes, function (key, rowNode) {
            if (rowNode) {
                selectedNodes.push(rowNode);
            }
        });
        return selectedNodes;
    };
    SelectionController.prototype.getSelectedRows = function () {
        var selectedRows = [];
        utils_1.Utils.iterateObject(this.selectedNodes, function (key, rowNode) {
            if (rowNode && rowNode.data) {
                selectedRows.push(rowNode.data);
            }
        });
        return selectedRows;
    };
    SelectionController.prototype.removeGroupsFromSelection = function () {
        var _this = this;
        utils_1.Utils.iterateObject(this.selectedNodes, function (key, rowNode) {
            if (rowNode && rowNode.group) {
                _this.selectedNodes[rowNode.id] = undefined;
            }
        });
    };
    // should only be called if groupSelectsChildren=true
    SelectionController.prototype.updateGroupsFromChildrenSelections = function () {
        if (this.rowModel.getType() !== constants_1.Constants.ROW_MODEL_TYPE_IN_MEMORY) {
            console.warn('updateGroupsFromChildrenSelections not available when rowModel is not normal');
        }
        var inMemoryRowModel = this.rowModel;
        inMemoryRowModel.getTopLevelNodes().forEach(function (rowNode) {
            rowNode.depthFirstSearch(function (rowNode) {
                if (rowNode.group) {
                    rowNode.calculateSelectedFromChildren();
                }
            });
        });
    };
    SelectionController.prototype.getNodeForIdIfSelected = function (id) {
        return this.selectedNodes[id];
    };
    SelectionController.prototype.clearOtherNodes = function (rowNodeToKeepSelected) {
        var _this = this;
        var groupsToRefresh = {};
        var updatedCount = 0;
        utils_1.Utils.iterateObject(this.selectedNodes, function (key, otherRowNode) {
            if (otherRowNode && otherRowNode.id !== rowNodeToKeepSelected.id) {
                var rowNode = _this.selectedNodes[otherRowNode.id];
                updatedCount += rowNode.setSelectedParams({ newValue: false, clearSelection: false, tailingNodeInSequence: true });
                if (_this.groupSelectsChildren && otherRowNode.parent) {
                    groupsToRefresh[otherRowNode.parent.id] = otherRowNode.parent;
                }
            }
        });
        utils_1.Utils.iterateObject(groupsToRefresh, function (key, group) {
            group.calculateSelectedFromChildren();
        });
        return updatedCount;
    };
    SelectionController.prototype.onRowSelected = function (event) {
        var rowNode = event.node;
        // we do not store the group rows when the groups select children
        if (this.groupSelectsChildren && rowNode.group) {
            return;
        }
        if (rowNode.isSelected()) {
            this.selectedNodes[rowNode.id] = rowNode;
        }
        else {
            this.selectedNodes[rowNode.id] = undefined;
        }
    };
    SelectionController.prototype.syncInRowNode = function (rowNode, oldNode) {
        this.syncInOldRowNode(rowNode, oldNode);
        this.syncInNewRowNode(rowNode);
    };
    // if the id has changed for the node, then this means the rowNode
    // is getting used for a different data item, which breaks
    // our selectedNodes, as the node now is mapped by the old id
    // which is inconsistent. so to keep the old node as selected,
    // we swap in the clone (with the old id and old data). this means
    // the oldNode is effectively a daemon we keep a reference to,
    // so if client calls api.getSelectedNodes(), it gets the daemon
    // in the result. when the client un-selects, the reference to the
    // daemon is removed. the daemon, because it's an oldNode, is not
    // used by the grid for rendering, it's a copy of what the node used
    // to be like before the id was changed.
    SelectionController.prototype.syncInOldRowNode = function (rowNode, oldNode) {
        var oldNodeHasDifferentId = utils_1.Utils.exists(oldNode) && (rowNode.id !== oldNode.id);
        if (oldNodeHasDifferentId) {
            var oldNodeSelected = utils_1.Utils.exists(this.selectedNodes[oldNode.id]);
            if (oldNodeSelected) {
                this.selectedNodes[oldNode.id] = oldNode;
            }
        }
    };
    SelectionController.prototype.syncInNewRowNode = function (rowNode) {
        if (utils_1.Utils.exists(this.selectedNodes[rowNode.id])) {
            rowNode.setSelectedInitialValue(true);
            this.selectedNodes[rowNode.id] = rowNode;
        }
        else {
            rowNode.setSelectedInitialValue(false);
        }
    };
    SelectionController.prototype.reset = function () {
        this.logger.log('reset');
        this.selectedNodes = {};
        this.lastSelectedNode = null;
    };
    // returns a list of all nodes at 'best cost' - a feature to be used
    // with groups / trees. if a group has all it's children selected,
    // then the group appears in the result, but not the children.
    // Designed for use with 'children' as the group selection type,
    // where groups don't actually appear in the selection normally.
    SelectionController.prototype.getBestCostNodeSelection = function () {
        if (this.rowModel.getType() !== constants_1.Constants.ROW_MODEL_TYPE_IN_MEMORY) {
            console.warn('getBestCostNodeSelection is only avilable when using normal row model');
        }
        var inMemoryRowModel = this.rowModel;
        var topLevelNodes = inMemoryRowModel.getTopLevelNodes();
        if (topLevelNodes === null) {
            console.warn('selectAll not available doing rowModel=virtual');
            return;
        }
        var result = [];
        // recursive function, to find the selected nodes
        function traverse(nodes) {
            for (var i = 0, l = nodes.length; i < l; i++) {
                var node = nodes[i];
                if (node.isSelected()) {
                    result.push(node);
                }
                else {
                    // if not selected, then if it's a group, and the group
                    // has children, continue to search for selections
                    if (node.group && node.children) {
                        traverse(node.children);
                    }
                }
            }
        }
        traverse(topLevelNodes);
        return result;
    };
    SelectionController.prototype.setRowModel = function (rowModel) {
        this.rowModel = rowModel;
    };
    SelectionController.prototype.isEmpty = function () {
        var count = 0;
        utils_1.Utils.iterateObject(this.selectedNodes, function (nodeId, rowNode) {
            if (rowNode) {
                count++;
            }
        });
        return count === 0;
    };
    SelectionController.prototype.deselectAllRowNodes = function (justFiltered) {
        if (justFiltered === void 0) { justFiltered = false; }
        var callback = function (rowNode) { return rowNode.selectThisNode(false); };
        var rowModelInMemory = this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_IN_MEMORY;
        if (justFiltered) {
            if (!rowModelInMemory) {
                console.error('ag-Grid: selecting just filtered only works with In Memory Row Model');
                return;
            }
            var inMemoryRowModel = this.rowModel;
            inMemoryRowModel.forEachNodeAfterFilter(callback);
        }
        else {
            utils_1.Utils.iterateObject(this.selectedNodes, function (id, rowNode) {
                // remember the reference can be to null, as we never 'delete' from the map
                if (rowNode) {
                    callback(rowNode);
                }
            });
            // this clears down the map (whereas above only sets the items in map to 'undefined')
            this.reset();
        }
        // the above does not clean up the parent rows if they are selected
        if (rowModelInMemory && this.groupSelectsChildren) {
            this.updateGroupsFromChildrenSelections();
        }
        var event = {
            type: events_1.Events.EVENT_SELECTION_CHANGED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(event);
    };
    SelectionController.prototype.selectAllRowNodes = function (justFiltered) {
        if (justFiltered === void 0) { justFiltered = false; }
        if (this.rowModel.getType() !== constants_1.Constants.ROW_MODEL_TYPE_IN_MEMORY) {
            throw "selectAll only available with normal row model, ie not " + this.rowModel.getType();
        }
        var inMemoryRowModel = this.rowModel;
        var callback = function (rowNode) { return rowNode.selectThisNode(true); };
        if (justFiltered) {
            inMemoryRowModel.forEachNodeAfterFilter(callback);
        }
        else {
            inMemoryRowModel.forEachNode(callback);
        }
        // the above does not clean up the parent rows if they are selected
        if (this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_IN_MEMORY && this.groupSelectsChildren) {
            this.updateGroupsFromChildrenSelections();
        }
        var event = {
            type: events_1.Events.EVENT_SELECTION_CHANGED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(event);
    };
    // Deprecated method
    SelectionController.prototype.selectNode = function (rowNode, tryMulti) {
        rowNode.setSelectedParams({ newValue: true, clearSelection: !tryMulti });
    };
    // Deprecated method
    SelectionController.prototype.deselectIndex = function (rowIndex) {
        var node = this.rowModel.getRow(rowIndex);
        this.deselectNode(node);
    };
    // Deprecated method
    SelectionController.prototype.deselectNode = function (rowNode) {
        rowNode.setSelectedParams({ newValue: false, clearSelection: false });
    };
    // Deprecated method
    SelectionController.prototype.selectIndex = function (index, tryMulti) {
        var node = this.rowModel.getRow(index);
        this.selectNode(node, tryMulti);
    };
    __decorate([
        context_3.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], SelectionController.prototype, "eventService", void 0);
    __decorate([
        context_3.Autowired('rowModel'),
        __metadata("design:type", Object)
    ], SelectionController.prototype, "rowModel", void 0);
    __decorate([
        context_3.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], SelectionController.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_3.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], SelectionController.prototype, "columnApi", void 0);
    __decorate([
        context_3.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], SelectionController.prototype, "gridApi", void 0);
    __decorate([
        __param(0, context_2.Qualifier('loggerFactory')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
        __metadata("design:returntype", void 0)
    ], SelectionController.prototype, "setBeans", null);
    __decorate([
        context_4.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SelectionController.prototype, "init", null);
    SelectionController = __decorate([
        context_1.Bean('selectionController')
    ], SelectionController);
    return SelectionController;
}());
exports.SelectionController = SelectionController;


/***/ }),

/***/ "DGeU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var sortService_1 = __webpack_require__("mLPx");
var SortStage = (function () {
    function SortStage() {
    }
    SortStage.prototype.execute = function (params) {
        // if the sorting is already done by the server, then we should not do it here
        if (this.gridOptionsWrapper.isEnableServerSideSorting()) {
            this.sortService.sort(params.rowNode, null);
        }
        else {
            this.sortService.sortAccordingToColumnsState(params.rowNode);
        }
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], SortStage.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('sortService'),
        __metadata("design:type", sortService_1.SortService)
    ], SortStage.prototype, "sortService", void 0);
    SortStage = __decorate([
        context_1.Bean('sortStage')
    ], SortStage);
    return SortStage;
}());
exports.SortStage = SortStage;


/***/ }),

/***/ "DJye":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(21);
	module.exports = __webpack_require__(21);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {

	    var kendo = window.kendo;
	    var Widget = kendo.ui.Widget;
	    var extend = $.extend;
	    var proxy = $.proxy;
	    var DOT = ".";
	    var NS = ".kendoChat";

	    var DATA_K_BUTTON_NAME = "kButtonName";
	    var SCROLL_LEFT_NAME = "chatToolbarScrollLeft";
	    var SCROLL_RIGHT_NAME = "chatToolbarScrollRight";
	    var VISIBLE = ":visible";
	    var DEFAULT_ANIMATION = {
	        effects: "expand:vertical",
	        duration: 200
	    };
	    var NO_ANIMATION = {
	        expand: {
	            show: true
	        },
	        collapse: {
	            hide: true
	        }
	    };

	    var toolbarStyles = {
	        button: "k-button",
	        buttonFlat: "k-flat",
	        buttonList: "k-button-list",
	        scrollButton: "k-scroll-button",
	        scrollButtonLeft: "k-scroll-button-left",
	        scrollButtonRight: "k-scroll-button-right",
	        scrollButtonLeftIcon: "k-icon k-i-arrow-chevron-left",
	        scrollButtonRightIcon: "k-icon k-i-arrow-chevron-right",
	        buttonIcon: "k-button-icon"
	    };

	    var ChatToolBar = Widget.extend({
	        init: function(element, options) {
	            options = extend({}, options, { name: "ChatToolbar" });
	            var toolbarOptions = options.toolbar;
	            var buttonsDefined = toolbarOptions.buttons && toolbarOptions.buttons.length;

	            Widget.fn.init.call(this, element, options);

	            if (buttonsDefined) {
	                this._createButtonList();
	            }

	            if (buttonsDefined && toolbarOptions.scrollable &&
	                    this.buttonsWidth() > this.element.width()) {
	                this._initScrolling();
	            }

	            this._setupAnimation();

	            if(buttonsDefined && toolbarOptions.toggleable) {
	                this.toggle(true);
	            }

	            this.element.on("click" + NS, proxy(this._onClick, this));
	        },

	        events: [
	            "click"
	        ],

	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            this.element.off(NS);
	            this.element.empty();
	        },

	        _createButtonList: function () {
	            var that = this;
	            var styles = ChatToolBar.styles;
	            var buttons = that.options.toolbar.buttons;
	            var buttonList = $("<div class='" + styles.buttonList + "'></div>");

	            for(var i = 0; i < buttons.length; i++) {
	                var button = that._createButton(buttons[i]);
	                buttonList.append(button);
	            }

	            buttonList.appendTo(this.element);

	            this.buttonList = buttonList;
	        },

	        _createButton: function (btnOptions) {
	            var styles = ChatToolBar.styles;
	            var buttonElm = $("<button>");

	            if (typeof btnOptions === "string") {
	                btnOptions = {
	                    name: btnOptions
	                };
	            }

	            buttonElm
	                .attr(btnOptions.attr || {})
	                .attr("title", btnOptions.text || btnOptions.name)
	                .attr("aria-label", btnOptions.text || btnOptions.name)
	                .attr("type", "button")
	                .addClass(btnOptions.name)
	                .data(DATA_K_BUTTON_NAME, btnOptions.name)
	                .addClass(styles.button);

	            if (btnOptions.iconClass) {
	                buttonElm.addClass(styles.buttonIcon);
	                buttonElm.prepend("<span class='" + btnOptions.iconClass + "'></span>");
	            }

	            return buttonElm;
	        },

	        _onClick: function (ev) {
	            var styles = ChatToolBar.styles;
	            var target = $(ev.target).closest(DOT + styles.button);

	            if (target.is(DOT + styles.scrollButton) && !this._scrolling) {
	                this._scroll(target.data(DATA_K_BUTTON_NAME));
	            }

	            if(target.data(DATA_K_BUTTON_NAME)) {
	                this.trigger("click", {
	                    button: target[0],
	                    name: target.data(DATA_K_BUTTON_NAME),
	                    originalEvent: ev
	                });
	            }
	        },

	        _initScrolling: function () {
	            var styles = ChatToolBar.styles;

	            this.scrollButtonLeft = this._createButton({
	                name: SCROLL_LEFT_NAME,
	                iconClass: styles.scrollButtonLeftIcon,
	                attr: {
	                    "class": styles.scrollButton + " " + styles.scrollButtonLeft
	                }
	            });

	            this.scrollButtonRight = this._createButton({
	                name: SCROLL_RIGHT_NAME,
	                iconClass: styles.scrollButtonRightIcon,
	                attr: {
	                    "class": styles.scrollButton + " " + styles.scrollButtonRight
	                }
	            });

	            this.element.prepend(this.scrollButtonLeft);
	            this.element.append(this.scrollButtonRight);
	            this._refreshScrollButtons();

	            this.element.on("keydown" + NS, proxy(this._refreshScrollButtons, this));
	        },

	        _scroll: function (commandName) {
	            var that = this;
	            var buttonWidth = that.buttonWidth();
	            var maxScrollSize = this.maxScrollSize();
	            var scrollAmmount = commandName === SCROLL_LEFT_NAME ? buttonWidth * -1 : buttonWidth;
	            var currentScroll = this.currentScrollLeft();
	            var scrollValue = currentScroll + scrollAmmount;
	            scrollValue = Math.min(Math.max(scrollValue, 0), maxScrollSize);

	            if(commandName !== SCROLL_LEFT_NAME && commandName !== SCROLL_RIGHT_NAME) {
	                return;
	            }

	            kendo.scrollLeft(that.buttonList, scrollValue);
	            that._refreshScrollButtons(scrollValue);
	        },

	        _refreshScrollButtons: function (value) {
	            var maxScrollSize = this.maxScrollSize();
	            var currentScrollLeft = value === undefined || isNaN(parseInt(value, 10)) ? this.currentScrollLeft() : value;

	            if(!this.scrollButtonLeft && !this.scrollButtonRight) {
	                return;
	            }

	            this.scrollButtonLeft.toggle(currentScrollLeft !== 0);
	            this.scrollButtonRight.toggle(currentScrollLeft !== maxScrollSize);
	        },

	        _setupAnimation: function () {
	            var animation = this.options.toolbar.animation;
	            var defaultExpandAnimation = extend({}, DEFAULT_ANIMATION);
	            var defaultCollapseAnimation = extend({
	                reverse: true,
	                hide: true
	            }, DEFAULT_ANIMATION);

	            if (animation === false){
	                animation = extend(true, {}, NO_ANIMATION);
	            }  else {
	                animation = extend(true, {
	                    expand: defaultExpandAnimation,
	                    collapse: defaultCollapseAnimation
	                }, animation);
	            }

	            this.options.toolbar.animation = animation;
	        },

	        _animationComplete: function () {
	            this._refreshScrollButtons();
	        },

	        currentScrollLeft: function () {
	            return Math.round(kendo.scrollLeft(this.buttonList));
	        },

	        maxScrollSize: function () {
	            return Math.round(this.buttonList[0].scrollWidth - this.buttonList[0].clientWidth);
	        },

	        buttons: function () {
	            var styles = ChatToolBar.styles;
	            return this.buttonList ? this.buttonList.children(DOT + styles.button) : null;
	        },

	        buttonWidth: function () {
	            return Math.round(this.buttons().last().outerWidth(true));
	        },

	        buttonsWidth: function () {
	            var width = 0;

	            if(this.buttons()) {
	                width = this.buttonWidth() * this.buttons().length;
	            }

	            return width;
	        },

	        toggle: function (skipAnimation) {
	            var animation = this.options.toolbar.animation;

	            if (skipAnimation) {
	                animation = extend(true, {}, NO_ANIMATION);
	            }

	            animation.expand.complete = proxy(this._animationComplete, this);
	            animation.collapse.complete = proxy(this._animationComplete, this);

	            if(this.element.is(VISIBLE)) {
	                this.element.kendoStop().kendoAnimate(animation.collapse);
	            } else {
	                this.element.kendoStop().kendoAnimate(animation.expand);
	            }

	        }
	    });

	    extend(true, ChatToolBar, { styles: toolbarStyles });
	    extend(kendo.chat, {
	        ChatToolBar: ChatToolBar
	    });
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "DQCr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "DfTB":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1626);
	module.exports = __webpack_require__(1626);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1626:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20), __webpack_require__(1627) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	    (function(kendo) {
	        if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	            return;
	        }

	        var $ = kendo.jQuery;
	        var outerWidth = kendo._outerWidth;
	        var DOT = ".";
	        var EMPTYCHAR = " ";
	        var sheetsBarClassNames = {
	            sheetsBarWrapper: "k-widget k-header",
	            sheetsBarSheetsWrapper: "k-tabstrip k-floatwrap k-tabstrip-bottom",
	            sheetsBarActive: "k-spreadsheet-sheets-bar-active",
	            sheetsBarInactive: "k-spreadsheet-sheets-bar-inactive",
	            sheetsBarAdd: "k-spreadsheet-sheets-bar-add",
	            sheetsBarRemove: "k-spreadsheet-sheets-remove",
	            sheetsBarItems: "k-spreadsheet-sheets-items",
	            sheetsBarEditor: "k-spreadsheet-sheets-editor",
	            sheetsBarScrollable: "k-tabstrip-scrollable",
	            sheetsBarNext: "k-tabstrip-next",
	            sheetsBarPrev: "k-tabstrip-prev",
	            sheetsBarKItem: "k-item k-state-default",
	            sheetsBarKActive: "k-state-active k-state-tab-on-top",
	            sheetsBarKTextbox: "k-textbox",
	            sheetsBarKLink: "k-link",
	            sheetsBarKIcon: "k-icon",
	            sheetsBarKFontIcon: "k-icon",
	            sheetsBarKButton: "k-button k-button-icon",
	            sheetsBarKButtonBare: "k-flat",
	            sheetsBarKArrowW: "k-i-arrow-60-left",
	            sheetsBarKArrowE: "k-i-arrow-60-right",
	            sheetsBarKReset: "k-reset k-tabstrip-items",
	            sheetsBarKIconX: "k-i-close",
	            sheetsBarKSprite: "k-sprite",
	            sheetsBarKIconPlus: "k-i-plus",
	            sheetsBarHintWrapper: "k-widget k-tabstrip k-tabstrip-bottom k-spreadsheet-sheets-items-hint",
	            sheetsBarKResetItems: "k-reset k-tabstrip-items"
	        };

	        var SheetsBar = kendo.ui.Widget.extend({
	            init: function(element, options) {
	                var classNames = SheetsBar.classNames;

	                kendo.ui.Widget.call(this, element, options);

	                element = this.element;

	                element.addClass(classNames.sheetsBarWrapper);

	                this._openDialog = options.openDialog;

	                this._tree = new kendo.dom.Tree(element[0]);

	                this._tree.render([this._addButton(), this._createSheetsWrapper([])]);

	                this._toggleScrollEvents(true);

	                this._createSortable();

	                this._sortable.bind("start", this._onSheetReorderStart.bind(this));

	                this._sortable.bind("end", this._onSheetReorderEnd.bind(this));

	                element.on("click", DOT + classNames.sheetsBarRemove, this._onSheetRemove.bind(this));

	                element.on("click", "li", this._onSheetSelect.bind(this));

	                element.on("dblclick", "li" + DOT + classNames.sheetsBarActive, this._createEditor.bind(this));

	                element.on("click", DOT + classNames.sheetsBarAdd, this._onAddSelect.bind(this));
	            },

	            options: {
	                name: "SheetsBar",
	                scrollable: {
	                    distance: 200
	                }
	            },

	            events: [
	                "select",
	                "reorder",
	                "rename"
	            ],

	            _createEditor: function () {
	                if (this._editor) {
	                    return;
	                }

	                this._renderSheets(this._sheets, this._selectedIndex, true);
	                this._editor = this.element
	                    .find(kendo.format("input{0}{1}",DOT,SheetsBar.classNames.sheetsBarEditor))
	                    .focus()
	                    .on("keydown", this._onEditorKeydown.bind(this))
	                    .on("blur", this._onEditorBlur.bind(this));
	            },

	            _destroyEditor: function(canceled) {
	                var newSheetName = canceled ? null : this._editor.val();
	                this._editor.off();
	                this._editor = null;
	                this._renderSheets(this._sheets, this._selectedIndex, false);
	                this._onSheetRename(newSheetName);
	            },

	            renderSheets: function(sheets, selectedIndex) {
	                if (!sheets || selectedIndex < 0) {
	                    return;
	                }

	                this._renderSheets(sheets, selectedIndex, false);
	            },

	            _renderSheets: function(sheets, selectedIndex, isInEditMode) {
	                var that = this;
	                var wrapperOffsetWidth;
	                var sheetsGroupScrollWidth;
	                var classNames = SheetsBar.classNames;

	                that._isRtl = kendo.support.isRtl(that.element);
	                that._sheets = sheets;
	                that._selectedIndex = selectedIndex;

	                that._renderHtml(isInEditMode, true);

	                if (!that._scrollableAllowed()) {
	                    return;
	                }

	                var sheetsWrapper = that._sheetsWrapper();
	                var scrollPrevButton = sheetsWrapper.children(DOT + classNames.sheetsBarPrev);
	                var scrollNextButton = sheetsWrapper.children(DOT + classNames.sheetsBarNext);
	                var gapWidth = 2;
	                var addButton = that.element.find(DOT + classNames.sheetsBarAdd);
	                var addButtonWidth = outerWidth(addButton) + addButton.position().left + gapWidth;
	                var scrollPrevButtonWidth = outerWidth(scrollPrevButton) + gapWidth;
	                var sheetsGroup = that._sheetsGroup();

	                scrollPrevButton.css({ left: addButtonWidth });

	                sheetsWrapper.addClass(classNames.sheetsBarScrollable + EMPTYCHAR + classNames.sheetsBarSheetsWrapper);

	                sheetsGroup.css({ marginLeft: addButtonWidth });

	                wrapperOffsetWidth = sheetsWrapper[0].offsetWidth;
	                sheetsGroupScrollWidth = sheetsGroup[0].scrollWidth;

	                if (sheetsGroupScrollWidth + addButtonWidth > wrapperOffsetWidth) {
	                    var scrollNextButtonRight = Math.ceil(kendo.parseFloat(scrollNextButton.css("right")));

	                    if (!that._scrollableModeActive) {
	                        that._nowScrollingSheets = false;
	                        that._scrollableModeActive = true;
	                    }

	                    sheetsGroup.css({
	                        marginLeft: scrollPrevButtonWidth + addButtonWidth,
	                        marginRight: outerWidth(scrollNextButton) + scrollNextButtonRight + gapWidth
	                    });
	                } else {
	                    if (that._scrollableModeActive && sheetsGroupScrollWidth <= wrapperOffsetWidth) {
	                        that._scrollableModeActive = false;
	                        sheetsGroup.css({ marginLeft: addButtonWidth, marginRight: "" });
	                    } else {
	                        sheetsGroup.css({ marginLeft: addButtonWidth });
	                    }
	                }

	                that._toggleScrollButtons();
	            },

	            _toggleScrollButtons: function (toggle) {
	                var that = this;
	                var ul = that._sheetsGroup();
	                var wrapper = that._sheetsWrapper();
	                var scrollLeft = kendo.scrollLeft(ul);
	                var prev = wrapper.find(DOT + SheetsBar.classNames.sheetsBarPrev);
	                var next = wrapper.find(DOT + SheetsBar.classNames.sheetsBarNext);

	                if (toggle === false) {
	                    prev.toggle(false);
	                    next.toggle(false);
	                } else {
	                    prev.toggle(that._isRtl ? scrollLeft < ul[0].scrollWidth - ul[0].offsetWidth - 1 : scrollLeft !== 0);
	                    next.toggle(that._isRtl ? scrollLeft !== 0 : scrollLeft < ul[0].scrollWidth - ul[0].offsetWidth - 1);
	                }

	            },

	            _toggleScrollEvents: function(toggle) {
	                var that = this;
	                var classNames = SheetsBar.classNames;
	                var options = that.options;
	                var scrollPrevButton;
	                var scrollNextButton;
	                var sheetsWrapper = that._sheetsWrapper();
	                scrollPrevButton = sheetsWrapper.children(DOT + classNames.sheetsBarPrev);
	                scrollNextButton = sheetsWrapper.children(DOT + classNames.sheetsBarNext);

	                if (toggle) {
	                    scrollPrevButton.on("mousedown", function () {
	                        that._nowScrollingSheets = true;
	                        that._scrollSheetsByDelta(options.scrollable.distance * (that._isRtl ? 1 : -1));
	                    });

	                    scrollNextButton.on("mousedown", function () {
	                        that._nowScrollingSheets = true;
	                        that._scrollSheetsByDelta(options.scrollable.distance * (that._isRtl ? -1 : 1));
	                    });

	                    scrollPrevButton.add(scrollNextButton).on("mouseup", function () {
	                        that._nowScrollingSheets = false;
	                    });
	                } else {
	                    scrollPrevButton.off();
	                    scrollNextButton.off();
	                }
	            },

	            _renderHtml: function(isInEditMode, renderScrollButtons) {
	                var idx;
	                var sheetElements = [];
	                var dom = kendo.dom;
	                var element = dom.element;
	                var sheets = this._sheets;
	                var selectedIndex = this._selectedIndex;
	                var classNames = SheetsBar.classNames;

	                for (idx = 0; idx < sheets.length; idx++) {
	                    var sheet = sheets[idx];
	                    var isSelectedSheet = (idx === selectedIndex);
	                    var attr = { className: classNames.sheetsBarKItem + EMPTYCHAR };
	                    var elementContent = [];

	                    if (isSelectedSheet) {
	                        attr.className += classNames.sheetsBarKActive + EMPTYCHAR + classNames.sheetsBarActive;
	                    } else {
	                        attr.className += classNames.sheetsBarInactive;
	                    }

	                    if (isSelectedSheet && isInEditMode) {
	                        elementContent.push(element("input", {
	                            type: "text",
	                            value: sheet.name(),
	                            className: classNames.sheetsBarKTextbox + EMPTYCHAR + classNames.sheetsBarEditor,
	                            maxlength: 50
	                        }, []));
	                    } else {
	                        elementContent.push(element("span", {
	                            className: classNames.sheetsBarKLink,
	                            title: sheet.name()
	                        }, [dom.text(sheet.name())]));

	                        if (sheets.length > 1) {
	                            var deleteIcon = element("span", {
	                                className: classNames.sheetsBarKIcon + EMPTYCHAR + classNames.sheetsBarKFontIcon + EMPTYCHAR + classNames.sheetsBarKIconX
	                            }, []);

	                            elementContent.push(element("span", {
	                                className: classNames.sheetsBarKLink + EMPTYCHAR + classNames.sheetsBarRemove
	                            }, [deleteIcon]));
	                        }
	                    }

	                    sheetElements.push(element("li", attr, elementContent));
	                }

	                this._tree.render([this._addButton(),  this._createSheetsWrapper(sheetElements, renderScrollButtons)]);
	            },

	            _createSheetsWrapper: function(sheetElements, renderScrollButtons) {
	                var element = kendo.dom.element;
	                var classNames = SheetsBar.classNames;
	                var childrenElements = [element("ul", {
	                    className: classNames.sheetsBarKReset
	                }, sheetElements)];
	                renderScrollButtons = true;

	                if (renderScrollButtons) {
	                    var baseButtonClass = classNames.sheetsBarKButton + EMPTYCHAR + classNames.sheetsBarKButtonBare + EMPTYCHAR;

	                    childrenElements.push(element("span", {className: baseButtonClass + classNames.sheetsBarPrev }, [
	                        element("span", {className: classNames.sheetsBarKIcon + EMPTYCHAR + classNames.sheetsBarKArrowW}, [])
	                    ]));

	                    childrenElements.push(element("span", {className: baseButtonClass + classNames.sheetsBarNext }, [
	                        element("span", {className: classNames.sheetsBarKIcon + EMPTYCHAR + classNames.sheetsBarKArrowE}, [])
	                    ]));
	                }

	                return element("div", { className: classNames.sheetsBarItems }, childrenElements);
	            },

	            _createSortable: function() {
	                var classNames = SheetsBar.classNames;
	                this._sortable = new kendo.ui.Sortable(this.element, {
	                    filter: kendo.format("ul li.{0},ul li.{1}", classNames.sheetsBarActive, classNames.sheetsBarInactive),
	                    container: DOT + classNames.sheetsBarItems,
	                    axis: "x",
	                    animation: false,
	                    ignore: "input",
	                    end: function () {
	                        if (this.draggable.hint) {
	                            this.draggable.hint.remove();
	                        }
	                    },
	                    hint: function (element) {
	                        var hint = $(element).clone();
	                        return hint.wrap("<div class='" + classNames.sheetsBarHintWrapper + "'><ul class='" + classNames.sheetsBarKResetItems + "'></ul></div>").closest("div");
	                    }
	                });
	            },

	            _onEditorKeydown: function(e) {
	                if (this._editor) {
	                    if (e.which === 13) {
	                        this._destroyEditor();
	                    }

	                    if (e.which === 27) {
	                        this._destroyEditor(true);
	                    }
	                }
	            },

	            _onEditorBlur: function() {
	                if (this._editor) {
	                    this._destroyEditor();
	                }
	            },

	            _onSheetReorderEnd: function(e) {
	                e.preventDefault();
	                this.trigger("reorder", {oldIndex: e.oldIndex, newIndex: e.newIndex});
	            },

	            _onSheetReorderStart: function(e) {
	                if (this._editor) {
	                    e.preventDefault();
	                }
	            },

	            _onSheetRemove: function(e) {
	                var removedSheetName = $(e.target).closest("li").text();

	                if (this._editor) {
	                    this._destroyEditor();
	                }

	                var closeCallback = function(e) {
	                    var dlg = e.sender;

	                    if (dlg.isConfirmed()) {
	                        this.trigger("remove", { name: removedSheetName, confirmation: true });
	                    }
	                }.bind(this);

	                this._openDialog("confirmation", {
	                    close: closeCallback
	                });
	            },

	            _onSheetSelect: function(e) {
	                var selectedSheetText = $(e.target).text();

	                if ($(e.target).is(DOT + SheetsBar.classNames.sheetsBarEditor) || !selectedSheetText) {
	                    e.preventDefault();
	                    return;
	                }

	                if (this._editor) {
	                    this._destroyEditor();
	                }

	                this._scrollSheetsToItem($(e.target).closest("li"));

	                this.trigger("select", {name: selectedSheetText, isAddButton: false});
	            },

	            _onSheetRename: function(newSheetName) {
	                if (this._sheets[this._selectedIndex].name() === newSheetName || newSheetName === null) {
	                    return;
	                }

	                this.trigger("rename", {name: newSheetName, sheetIndex: this._selectedIndex });
	            },

	            _onAddSelect: function() {
	                this.trigger("select", {isAddButton: true});
	            },

	            _addButton: function() {
	                var element = kendo.dom.element;
	                var classNames = SheetsBar.classNames;
	                return element("a", {
	                    className: classNames.sheetsBarAdd + EMPTYCHAR + classNames.sheetsBarKButton
	                }, [element("span", {className: classNames.sheetsBarKIcon + EMPTYCHAR + classNames.sheetsBarKFontIcon + EMPTYCHAR + classNames.sheetsBarKIconPlus}, [])]);
	            },

	            destroy: function() {
	                this._sortable.destroy();
	            },

	            _scrollableAllowed: function() {
	                var options = this.options;
	                return options.scrollable && !isNaN(options.scrollable.distance);
	            },

	            _scrollSheetsToItem: function (item) {
	                var that = this;

	                if (!that._scrollableModeActive) {
	                    return;
	                }

	                var sheetsGroup = that._sheetsGroup();

	                var currentScrollOffset = kendo.scrollLeft(sheetsGroup);
	                var itemWidth = outerWidth(item);
	                var itemOffset = that._isRtl ? item.position().left : item.position().left - sheetsGroup.children().first().position().left;
	                var sheetsGroupWidth = sheetsGroup[0].offsetWidth;
	                var sheetsGroupPadding = Math.ceil(parseFloat(sheetsGroup.css("padding-left")));
	                var itemPosition;

	                if (that._isRtl) {
	                    if (itemOffset < 0) {
	                        itemPosition = currentScrollOffset + itemOffset - (sheetsGroupWidth - currentScrollOffset) - sheetsGroupPadding;
	                    } else if (itemOffset + itemWidth > sheetsGroupWidth) {
	                        itemPosition = currentScrollOffset + itemOffset - itemWidth + sheetsGroupPadding * 2;
	                    }
	                } else {
	                    if (currentScrollOffset + sheetsGroupWidth < itemOffset + itemWidth) {
	                        itemPosition = itemOffset + itemWidth - sheetsGroupWidth + sheetsGroupPadding * 2;
	                    } else if (currentScrollOffset > itemOffset) {
	                        itemPosition = itemOffset - sheetsGroupPadding;
	                    }
	                }

	                sheetsGroup.finish().animate({ "scrollLeft": itemPosition }, "fast", "linear", function () {
	                    that._toggleScrollButtons();
	                });
	            },

	            _sheetsGroup: function() {
	                return this._sheetsWrapper().children("ul");
	            },

	            _sheetsWrapper: function() {
	                return this.element.find(DOT + SheetsBar.classNames.sheetsBarItems);
	            },

	            _scrollSheetsByDelta: function (delta) {
	                var that = this;
	                var sheetsGroup = that._sheetsGroup();
	                var scrLeft = kendo.scrollLeft(sheetsGroup);

	                sheetsGroup.finish().animate({ "scrollLeft": scrLeft + delta }, "fast", "linear", function () {
	                    if (that._nowScrollingSheets) {
	                        that._scrollSheetsByDelta(delta);
	                    } else {
	                        that._toggleScrollButtons();
	                    }
	                });
	            }
	        });

	        kendo.spreadsheet.SheetsBar = SheetsBar;
	        $.extend(true, SheetsBar, { classNames: sheetsBarClassNames });
	    })(window.kendo);
	}, __webpack_require__(3));


/***/ }),

/***/ 1627:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MiQa");

/***/ })

/******/ });

/***/ }),

/***/ "DhwM":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1632);
	module.exports = __webpack_require__(1632);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1027:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("apSr");

/***/ }),

/***/ 1612:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Iu+f");

/***/ }),

/***/ 1632:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20), __webpack_require__(1027), __webpack_require__(1633), __webpack_require__(1612) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var $ = kendo.jQuery;
	    var CellRef = kendo.spreadsheet.CellRef;
	    var DOT = ".";
	    var RESIZE_HANDLE_WIDTH = 7;
	    var EDIT_BUTTON_WIDTH = 20;
	    var ERROR = "Error";
	    var viewClassNames = {
	        view: "k-spreadsheet-view",
	        fixedContainer: "k-spreadsheet-fixed-container",
	        editContainer: "k-spreadsheet-edit-container",
	        scroller: "k-spreadsheet-scroller",
	        viewSize: "k-spreadsheet-view-size",
	        clipboard: "k-spreadsheet-clipboard",
	        cellEditor: "k-spreadsheet-cell-editor",
	        barEditor: "k-spreadsheet-editor",
	        topCorner: "k-spreadsheet-top-corner",
	        filterHeadersWrapper: "k-filter-wrapper",
	        filterRange: "k-filter-range",
	        filterButton: "k-spreadsheet-filter",
	        filterButtonActive: "k-state-active",
	        horizontalResize: "k-horizontal-resize",
	        verticalResize: "k-vertical-resize",
	        icon: "k-icon",
	        iconFilterDefault: "k-i-arrow-60-down",
	        sheetsBar: "k-spreadsheet-sheets-bar",
	        sheetsBarActive: "k-spreadsheet-sheets-bar-active",
	        sheetsBarInactive: "k-spreadsheet-sheets-bar-inactive",
	        cellContextMenu: "k-spreadsheet-cell-context-menu",
	        rowHeaderContextMenu: "k-spreadsheet-row-header-context-menu",
	        colHeaderContextMenu: "k-spreadsheet-col-header-context-menu",
	        drawingContextMenu: "k-spreadsheet-drawing-context-menu"
	    };

	    kendo.spreadsheet.messages.view = {
	        nameBox: "Name Box",
	        errors: {
	            openUnsupported: "Unsupported format. Please select an .xlsx file.",
	            shiftingNonblankCells: "Cannot insert cells due to data loss possibility. Select another insert location or delete the data from the end of your worksheet.",
	            insertColumnWhenRowIsSelected: "Cannot insert column when all columns are selected.",
	            insertRowWhenColumnIsSelected: "Cannot insert row when all rows are selected.",
	            filterRangeContainingMerges: "Cannot create a filter within a range containing merges",
	            sortRangeContainingMerges: "Cannot sort a range containing merges",
	            cantSortMultipleSelection: "Cannot sort multiple selection",
	            cantSortNullRef: "Cannot sort empty selection",
	            cantSortMixedCells: "Cannot sort range containing cells of mixed shapes",
	            validationError: "The value that you entered violates the validation rules set on the cell.",
	            cannotModifyDisabled: "Cannot modify disabled cells.",
	            insertRowBelowLastRow: "Cannot insert row below the last row.",
	            insertColAfterLastCol: "Cannot insert column to the right of the last column."
	        },
	        tabs: {
	            home: "Home",
	            insert: "Insert",
	            data: "Data"
	        }
	    };

	    kendo.spreadsheet.messages.menus = {
	        "cut"          : "Cut",
	        "copy"         : "Copy",
	        "paste"        : "Paste",
	        "merge"        : "Merge",
	        "unmerge"      : "Unmerge",
	        "delete"       : "Delete",
	        "hide"         : "Hide",
	        "unhide"       : "Unhide",
	        "bringToFront" : "Bring to front",
	        "sendToBack"   : "Send to back"
	    };

	    function selectElementContents(el) {
	        var sel = window.getSelection();
	        sel.removeAllRanges();

	        var range = document.createRange();
	        range.selectNodeContents(el);

	        sel.addRange(range);
	    }

	    function cellBefore(table, row) {
	        var cells = table.trs[row].children;
	        return cells[cells.length - 2];
	    }

	    function cellAbove(table, row) {
	        var prevRow = table.trs[row-1];
	        var index = table.trs[row].children.length-1;

	        if (prevRow && index >= 0) {
	            return prevRow.children[index];
	        }
	    }

	    function cellBorder(value) {
	        return (value.size || 1) + "px solid " + (value.color || "#000");
	    }

	    function asURL(link) {
	        if (!/:\/\//.test(link)) {
	            link = "http://" + link;
	        }
	        return link;
	    }

	    function drawCell(collection, cell, cls, showGrid) {
	        function maybeLink(el) {
	            var link = cell.link;
	            if (!link) {
	                if (typeof cell.value == "object") {
	                    link = cell.value.link;
	                }
	            }
	            if (link) {
	                var style = {
	                    textDecoration: "none"
	                };
	                if (cell.color) {
	                    style.color = cell.color;
	                }
	                if (cell.underline) {
	                    style.textDecoration = "underline";
	                }
	                return kendo.dom.element("a", {
	                    href   : asURL(link),
	                    style  : style,
	                    target : "_blank" // XXX: customizable?
	                }, el ? [ el ] : []);
	            }
	            return el;
	        }

	        var shouldDraw = (cell.value != null || (cell.validation != null && !cell.validation.value) || // jshint ignore:line
	                          cell.background || cell.merged || cell.comment);
	        if (!cls && !shouldDraw) {
	            return;
	        }

	        var style = {};
	        var background = cell.background;
	        if (background) {
	            var defaultBorder = background;
	            if (showGrid) {
	                // darken
	                defaultBorder = kendo.parseColor(defaultBorder).toHSV();
	                defaultBorder.v *= 0.9;
	                defaultBorder = defaultBorder.toCssRgba();
	            }
	            defaultBorder = cellBorder({ color: defaultBorder });
	            style.outline = defaultBorder;
	        }

	        if (background) {
	            style.backgroundColor = background;
	        }

	        if (cell.color) {
	            style.color = cell.color;
	        }

	        if (cell.fontFamily) {
	            style.fontFamily = cell.fontFamily;
	        }

	        if (cell.underline) {
	            style.textDecoration = "underline";
	        }

	        if (cell.italic) {
	            style.fontStyle = "italic";
	        }

	        if (cell.textAlign) {
	            style.textAlign = cell.textAlign;
	        }

	        if (cell.bold) {
	            style.fontWeight = "bold";
	        }

	        if (cell.fontSize) {
	            style.fontSize = cell.fontSize + "px";
	        }

	        if (cell.wrap === true) {
	            style.whiteSpace = "pre-wrap";
	            style.overflowWrap = "break-word";
	            style.wordWrap = "break-word";
	        } else {
	            style.whiteSpace = "pre";
	            style.overflowWrap = "normal";
	            style.wordWrap = "normal";
	        }

	        style.left = (cell.left + 1) + "px";
	        style.top = (cell.top + 1) + "px";
	        style.width = (cell.width - 1) + "px";
	        style.height = (cell.height - 1) + "px";

	        var data = cell.value, type = typeof data, format = cell.format;
	        if (!format && type == "number" && data != Math.floor(data)) {
	            format = "0.##############";
	        }
	        if (format && data != null) { // jshint ignore:line
	            data = kendo.spreadsheet.formatting.format(data, format);
	            if (data.__dataType) {
	                type = data.__dataType;
	            }
	        } else if (data !== null && data !== undefined) {
	            if(cell.html){
	                data = kendo.dom.html(data);
	            } else {
	                data = kendo.dom.text(data);
	            }
	        }

	        if (!style.textAlign) {
	            switch (type) {
	              case "number":
	              case "date":
	              case "percent":
	              case "currency":
	                style.textAlign = "right";
	                break;
	              case "boolean":
	                style.textAlign = "center";
	                break;
	            }
	        }

	        // defined in print.js
	        kendo.spreadsheet.draw.applyIndent(cell, style);

	        var classNames = [ paneClassNames.cell ];

	        if (cls) {
	            classNames.push(cls);
	        }
	        if (cell.enable === false) {
	            classNames.push("k-state-disabled");
	        }
	        if (cell.merged) {
	            classNames.push("k-spreadsheet-merged-cell");
	        }
	        if (cell.comment) {
	            classNames.push("k-spreadsheet-has-comment");
	        }

	        var verticalAlign = cell.verticalAlign || "bottom";

	        if (verticalAlign && data) {
	            data = kendo.dom.element("div", { className: "k-vertical-align-" + verticalAlign }, [ maybeLink(data) ]);
	        } else {
	            data = maybeLink(data);
	        }

	        var children = data ? [ data ] : [];
	        var properties = {
	            style: style
	        };
	        var validation = cell.validation;
	        if (validation && !validation.value) {
	            children.push(kendo.dom.element("span", { className: "k-dirty" }));
	            classNames.push("k-dirty-cell");

	            properties.title = validation.message;
	        }
	        properties.className = classNames.join(" ");

	        var div = kendo.dom.element("div", properties, children);
	        collection.push(div);
	        return div;
	    }

	    function addCell(table, row, cell) {
	        var style = {};

	        if (cell.background) {
	            style.backgroundColor = cell.background;
	        }

	        if (cell.color) {
	            style.color = cell.color;
	        }

	        if (cell.fontFamily) {
	            style.fontFamily = cell.fontFamily;
	        }

	        if (cell.underline) {
	            style.textDecoration = "underline";
	        }

	        if (cell.italic) {
	            style.fontStyle = "italic";
	        }

	        if (cell.textAlign) {
	            style.textAlign = cell.textAlign;
	        }

	        if (cell.verticalAlign) {
	            style.verticalAlign = (cell.verticalAlign === "center") ? "middle" : cell.verticalAlign;
	        }

	        if (cell.bold) {
	            style.fontWeight = "bold";
	        }

	        if (cell.fontSize) {
	            style.fontSize = cell.fontSize + "px";
	        }

	        if (cell.wrap === true) {
	            style.whiteSpace = "pre-wrap";
	        }

	        if (cell.borderRight) {
	            style.borderRight = cellBorder(cell.borderRight);
	        } else if (cell.background) {
	            style.borderRightColor = cell.background;
	        }

	        if (cell.borderBottom) {
	            style.borderBottom = cellBorder(cell.borderBottom);
	        } else if (cell.background) {
	            style.borderBottomColor = cell.background;
	        }

	        var data = cell.value, type = typeof data, format = cell.format;
	        if (!format && type == "number" && data != Math.floor(data)) {
	            format = "0.##############";
	        }
	        if (format && data != null) { // jshint ignore:line
	            data = kendo.spreadsheet.formatting.format(data, format);
	            if (data.__dataType) {
	                type = data.__dataType;
	            }
	        }

	        if (!style.textAlign) {
	            switch (type) {
	              case "number":
	              case "date":
	              case "percent":
	              case "currency":
	                style.textAlign = "right";
	                break;
	              case "boolean":
	                style.textAlign = "center";
	                break;
	            }
	        }

	        var className = null;

	        if (cell.enable === false) {
	            className = "k-state-disabled";
	        }

	        var td = table.addCell(row, data, style, className, cell.validation);

	        var border, sibling;

	        if (cell.borderLeft) {
	            sibling = cellBefore(table, row);
	            border = cellBorder(cell.borderLeft);
	            if (sibling && border) {
	                sibling.attr.style.borderRight = border;
	            }
	        } else if (cell.background) {
	            style.borderLeftColor = cell.background;
	        }

	        if (cell.borderTop) {
	            sibling = cellAbove(table, row);
	            border = cellBorder(cell.borderTop);
	            if (sibling && border) {
	                sibling.attr.style.borderBottom = border;
	            }
	        } else if (cell.background) {
	            style.borderTopColor = cell.background;
	        }

	        return td;
	    }

	    var HtmlTable = kendo.Class.extend({
	        init: function() {
	            this.cols = [];
	            this.trs = [];
	            this._height = 0;
	            this._width = 0;
	        },

	        addColumn: function(width) {
	            this._width += width;

	            var col = kendo.dom.element("col", { style: { width: width + "px" } });

	            col.visible = width > 0;

	            this.cols.push(col);
	        },

	        addRow: function(height) {
	            var attr = null;

	            attr = { style: { height: height + "px" } };

	            this._height += height;

	            var tr = kendo.dom.element("tr", attr);

	            tr.visible = height > 0;

	            this.trs.push(tr);
	        },

	        addCell: function(rowIndex, text, style, className, validation) {
	            if (text === null || text === undefined) {
	                text = "";
	            }
	            if (!(text instanceof kendo.dom.Node)) {
	                text = kendo.dom.text(text);
	            }

	            var children = [ text ];
	            var properties = { style: style };

	            if (validation && !validation.value) {
	                children.push(kendo.dom.element("span", { className: "k-dirty" }));

	                className = (className || "") + (className ? " " : "") + "k-dirty-cell";
	                properties.title = validation.message;
	            }

	            if (className) {
	                properties.className = className;
	            }
	            var td = kendo.dom.element("td", properties, children);

	            this.trs[rowIndex].children.push(td);
	            return td;
	        },

	        toDomTree: function(x, y, className) {
	            this.trs = this.trs.filter(function(tr) {
	                return tr.visible;
	            });

	            var offset = 0;
	            this.cols = this.cols.filter(function(col, ci) {
	                if (!col.visible) {
	                    this.trs.forEach(function(tr) {
	                        tr.children.splice(ci - offset, 1);
	                    });
	                    offset++;
	                }

	                return col.visible;
	            }, this);

	            return kendo.dom.element("table", {
	                style: { left: x + "px", top: y + "px", height: this._height + "px", width: this._width + "px" },
	                className: className,
	                role: "presentation"
	            },[
	                kendo.dom.element("colgroup", null, this.cols),
	                kendo.dom.element("tbody", null, this.trs)
	            ]);
	        }
	    });

	    var CELL_CONTEXT_MENU = '<ul class="#=classNames.cellContextMenu#">' +
	        '<li data-action=cut>#: messages.cut #</li>' +
	        '<li data-action=copy>#: messages.copy #</li>' +
	        '<li data-action=paste>#: messages.paste #</li>' +
	        '<li class="k-separator"></li>' +
	        '<li data-action=merge>#: messages.merge #</li>' +
	        '<li data-action=unmerge>#: messages.unmerge #</li>' +
	    '</ul>';

	    var ROW_HEADER_CONTEXT_MENU = '<ul class="#=classNames.rowHeaderContextMenu#">' +
	        '<li data-action=cut>#: messages.cut #</li>' +
	        '<li data-action=copy>#: messages.copy #</li>' +
	        '<li data-action=paste>#: messages.paste #</li>' +
	        '<li class="k-separator"></li>' +
	        '<li data-action="delete-row">#: messages.delete #</li>'+
	        '<li data-action="hide-row">#: messages.hide #</li>'+
	        '<li data-action="unhide-row">#: messages.unhide #</li>'+
	    '</ul>';

	    var COL_HEADER_CONTEXT_MENU = '<ul class="#=classNames.colHeaderContextMenu#">' +
	        '<li data-action=cut>#: messages.cut #</li>' +
	        '<li data-action=copy>#: messages.copy #</li>' +
	        '<li data-action=paste>#: messages.paste #</li>' +
	        '<li class="k-separator"></li>' +
	        '<li data-action="delete-column">#: messages.delete #</li>'+
	        '<li data-action="hide-column">#: messages.hide #</li>'+
	        '<li data-action="unhide-column">#: messages.unhide #</li>'+
	    '</ul>';

	    var DRAWING_CONTEXT_MENU = '<ul class="#=classNames.drawingContextMenu#">' +
	        // '<li data-action=cut>#: messages.cut #</li>' +
	        // '<li data-action=copy>#: messages.copy #</li>' +
	        // '<li data-action=paste>#: messages.paste #</li>' +
	        // '<li class="k-separator"></li>' +
	        '<li data-action="bring-to-front">#: messages.bringToFront #</li>' +
	        '<li data-action="send-to-back">#: messages.sendToBack #</li>' +
	        '<li class="k-separator"></li>' +
	        '<li data-action="delete-drawing">#: messages.delete #</li>' +
	    '</ul>';

	    kendo.spreadsheet.ContextMenu = kendo.ui.ContextMenu;

	    var VIEW_CONTENTS = kendo.template('<div class="#=classNames.view#"><div class="#=classNames.fixedContainer#"></div><div class="#=classNames.scroller#"><div class="#=classNames.viewSize#"></div></div>' +
	        '<div tabindex="0" class="#=classNames.clipboard#" contenteditable=true></div><div class="#=classNames.cellEditor#"></div></div><div class="#=classNames.sheetsBar#"></div>' +
	        CELL_CONTEXT_MENU + ROW_HEADER_CONTEXT_MENU + COL_HEADER_CONTEXT_MENU + DRAWING_CONTEXT_MENU
	    );

	    function within(value, min, max) {
	        return value >= min && value <= max;
	    }

	    var View = kendo.Class.extend({
	        init: function(element, options) {
	            var classNames = View.classNames;

	            this.element = element;

	            this.options = $.extend(true, {
	                messages: kendo.spreadsheet.messages.view
	            }, this.options, options);

	            this._chrome();

	            this._dialogs = [];

	            element.append(VIEW_CONTENTS({
	                classNames: classNames,
	                messages: kendo.spreadsheet.messages.menus
	            }));

	            this._formulaInput();

	            this.wrapper =      element.find(DOT + classNames.view);
	            this.container =    element.find(DOT + classNames.fixedContainer)[0];
	            this.scroller =     element.find(DOT + classNames.scroller)[0];
	            this.clipboard =    element.find(DOT + classNames.clipboard);

	            this.viewSize = $(this.scroller.firstChild);

	            this.tree = new kendo.dom.Tree(this.container);
	            this.clipboardContents = new kendo.dom.Tree(this.clipboard[0]);

	            this.editor = new kendo.spreadsheet.SheetEditor(this);

	            this._sheetsbar();

	            var contextMenuConfig = {
	                target: element,
	                animation: false,
	                showOn: "never" // this is just an invalid event name to prevent the show
	            };

	            this.cellContextMenu = new kendo.spreadsheet.ContextMenu(element.find(DOT + classNames.cellContextMenu), contextMenuConfig);

	            this.colHeaderContextMenu = new kendo.spreadsheet.ContextMenu(element.find(DOT + classNames.colHeaderContextMenu), contextMenuConfig);

	            this.rowHeaderContextMenu = new kendo.spreadsheet.ContextMenu(element.find(DOT + classNames.rowHeaderContextMenu), contextMenuConfig);

	            this.drawingContextMenu = new kendo.spreadsheet.ContextMenu(element.find(DOT + classNames.drawingContextMenu), contextMenuConfig);
	        },

	        enableClipboard: function(enable) {
	            this.isClipboardDeactivated = !enable;

	            if (enable) {
	                this.clipboard.attr("contenteditable", enable);
	            } else {
	                this.clipboard.removeAttr("contenteditable");
	            }
	        },

	        _resize: function() {
	            var actionBar = $(this.formulaBar.element).parents(".k-spreadsheet-action-bar");
	            var outerHeight = kendo._outerHeight;
	            var tabstripHeight = this.tabstrip ? outerHeight(this.tabstrip.element) : 0;
	            var formulaBarHeight = actionBar ? outerHeight(actionBar) : 0;
	            var sheetsBarHeight = this.sheetsbar ? outerHeight(this.sheetsbar.element) : 0;

	            this.wrapper.height(
	                this.element.height() -
	                    (tabstripHeight + formulaBarHeight + sheetsBarHeight)
	            );

	            if (this.tabstrip) {
	                this.tabstrip.quickAccessAdjust();
	            }
	        },

	        _chrome: function() {
	            var wrapper = $("<div class='k-spreadsheet-action-bar' />").prependTo(this.element);

	            var nameEditor = $("<div class='k-spreadsheet-name-editor' />").appendTo(wrapper);
	            this.nameEditor = new kendo.spreadsheet.NameEditor(nameEditor, this.options);

	            var formulaBar = $("<div />").appendTo(wrapper);
	            this.formulaBar = new kendo.spreadsheet.FormulaBar(formulaBar);

	            if (this.options.toolbar) {
	                this._tabstrip();
	            }
	        },

	        _formulaInput: function() {
	            var editor = this.element.find(DOT + View.classNames.cellEditor);

	            this.formulaInput = new kendo.spreadsheet.FormulaInput(editor, {
	                autoScale: true
	            });
	        },

	        _sheetsbar: function() {
	            if (this.options.sheetsbar) {
	                var options = $.extend(true, {
	                    openDialog: this.openDialog.bind(this)
	                }, this.options.sheetsbar);

	                this.sheetsbar = new kendo.spreadsheet.SheetsBar(this.element.find(DOT + View.classNames.sheetsBar), options);
	            }
	        },

	        _tabstrip: function() {
	            var messages = this.options.messages.tabs;
	            var options = $.extend(true, { home: true, insert: true, data: true }, this.options.toolbar);
	            var tabs = [];

	            if (this.tabstrip) {
	                this.tabstrip.destroy();
	                this.element.children(".k-tabstrip").remove();
	            }

	            for (var name in options) {
	                if (options[name] === true || options[name] instanceof Array) {
	                    tabs.push({ id: name, text: messages[name], content: "" });
	                }
	            }

	            this.tabstrip = new kendo.spreadsheet.TabStrip($("<div />").prependTo(this.element), {
	                animation: false,
	                dataTextField: "text",
	                dataContentField: "content",
	                dataSource: tabs,
	                toolbarOptions: options,
	                view: this
	            });

	            this.tabstrip.select(0);
	        },

	        _executeCommand: function(e) {
	            this._sheet.trigger("commandRequest", e);
	        },

	        workbook: function(workbook) {
	            this._workbook = workbook;
	            workbook._view = this;
	            this.nameEditor._workbook = workbook;
	        },

	        sheet: function(sheet) {
	            this._sheet = sheet;
	        },

	        activeCellRectangle: function() {
	            return this.cellRectangle(this._sheet._viewActiveCell());
	        },

	        _rectangle: function(pane, ref) {
	            return pane._grid.boundingRectangle(ref.toRangeRef());
	        },

	        isColumnResizer: function(x, pane, col) {
	            // relative to content
	            x -= this._sheet._grid._headerWidth;

	            // add scroll if pane is not frozen
	            if (!pane._grid.columns.frozen) {
	                x += this.scroller.scrollLeft;
	            }

	            col = this._sheet._grid._columns.locate(0, col, function(w){
	                return Math.abs(x - w) <= RESIZE_HANDLE_WIDTH/2;
	            });

	            return col !== null && !this._sheet.isHiddenColumn(col) ? col : null;
	        },

	        isRowResizer: function(y, pane, row) {
	            // relative to content
	            y -= this._sheet._grid._headerHeight;

	            // add scroll if pane is not frozen
	            if (!pane._grid.rows.frozen) {
	                y += this.scroller.scrollTop;
	            }

	            row = this._sheet._grid._rows.locate(0, row, function(h){
	                return Math.abs(y - h) <= RESIZE_HANDLE_WIDTH/2;
	            });

	            return row !== null && !this._sheet.isHiddenRow(row) ? row : null;
	        },

	        isFilterIcon: function(x, y, pane, ref) {
	            var self = this;
	            var theGrid = pane._grid;
	            var scrollTop = theGrid.rows.frozen ? 0 : self.scroller.scrollTop;
	            var scrollLeft = theGrid.columns.frozen ? 0 : self.scroller.scrollLeft;

	            x -= self._sheet._grid._headerWidth - scrollLeft;
	            y -= self._sheet._grid._headerHeight - scrollTop;

	            return kendo.util.withExit(function(exit){
	                self._sheet.forEachFilterHeader(ref, function(ref) {
	                    var rect = self._rectangle(pane, ref);
	                    if (pane.filterIconRect(rect).intersects(x, y)) {
	                        exit(true);
	                    }
	                });
	            });
	        },

	        isAutoFill: function(x, y, pane) {
	            var selection = this._sheet.select();

	            if (selection.size > 1) {
	                return false;
	            }

	            x -= this._sheet._grid._headerWidth;
	            y -= this._sheet._grid._headerHeight;

	            if (!pane._grid.columns.frozen) {
	                x += this.scroller.scrollLeft;
	            }

	            if (!pane._grid.rows.frozen) {
	                y += this.scroller.scrollTop;
	            }

	            var rectangle = this._rectangle(pane, selection);

	            return Math.abs(rectangle.right - x) < 8 && Math.abs(rectangle.bottom - y) < 8;
	        },

	        isEditButton: function(x, y, pane) {
	            var ed = this._sheet.activeCellCustomEditor();
	            if (ed) {
	                var r = this.activeCellRectangle();
	                // XXX: hard-coded button width (20)

	                if (y >= r.top && y <= r.bottom) {
	                    return pane._editorInLastColumn ? x < r.left && x >= r.left - EDIT_BUTTON_WIDTH
	                        : x > r.right && x <= r.right + EDIT_BUTTON_WIDTH;
	                }
	            }
	        },

	        drawingAt: function(x, y, pane) {
	            x -= this._sheet._grid._headerWidth;
	            y -= this._sheet._grid._headerHeight;

	            if (!pane._grid.columns.frozen) {
	                x += this.scroller.scrollLeft;
	            }

	            if (!pane._grid.rows.frozen) {
	                y += this.scroller.scrollTop;
	            }

	            var sheet = this._sheet;
	            var drawings = this._sheet._drawings;
	            for (var i = drawings.length; --i >= 0;) {
	                var d = drawings[i];
	                var box = sheet.drawingBoundingBox(d);
	                if (box.intersects(x, y)) {
	                    return {
	                        drawing: d,

	                        // also include how far is the drawing's
	                        // top-left from the mouse position, as it's
	                        // not easy to compute some place else.
	                        drx: box.left - x,
	                        dry: box.top - y
	                    };
	                }
	            }
	        },

	        objectAt: function(x, y, noDrawing) {
	            var grid = this._sheet._grid;
	            var object, pane;

	            if (x < 0 || y < 0 || x > this.scroller.clientWidth || y > this.scroller.clientHeight) {
	                object = { type: "outside" };
	            } else if (x < grid._headerWidth && y < grid._headerHeight) {
	                object = { type: "topcorner" };
	            } else {
	                pane = this.paneAt(x, y);

	                if (!pane) {
	                    object = { type: "outside" };
	                } else {
	                    if (!noDrawing) {
	                        var drawing = this.drawingAt(x, y, pane);
	                        if (drawing) {
	                            return {
	                                type: "drawing",
	                                drawing: drawing.drawing,
	                                drx: drawing.drx,
	                                dry: drawing.dry,
	                                pane: pane,
	                                startX: x,
	                                startY: y
	                            };
	                        }
	                    }

	                    var row = pane._grid.rows.indexVisible(y, this.scroller.scrollTop);
	                    var column = pane._grid.columns.indexVisible(x, this.scroller.scrollLeft);

	                    var type = "cell";
	                    var ref = new CellRef(row, column);
	                    var selecting = this._sheet.selectionInProgress();

	                    if (this.isAutoFill(x, y, pane)) {
	                        type = "autofill";
	                    } else if (this.isFilterIcon(x, y, pane, ref)) {
	                        type = "filtericon";
	                    } else if (!selecting && x < grid._headerWidth) {
	                        type = "rowheader";
	                        if ((row = this.isRowResizer(y, pane, row)) !== null) {
	                            ref = new CellRef(row, -Infinity);
	                            type = "rowresizehandle";
	                        }
	                    } else if (!selecting && y < grid._headerHeight) {
	                        type = "columnheader";
	                        if ((column = this.isColumnResizer(x, pane, column)) !== null) {
	                            ref = new CellRef(-Infinity, column);
	                            type = "columnresizehandle";
	                        }
	                    } else if (this.isEditButton(x, y, pane)) {
	                        type = "editor";
	                    }

	                    object = { type: type, ref: ref };
	                }
	            }

	            object.pane = pane;
	            object.x = x;
	            object.y = y;
	            return object;
	        },

	        paneAt: function(x, y) {
	            return this.panes.filter(function paneLocationWithin(pane) {
	                var grid = pane._grid;
	                return within(y, grid.top, grid.bottom) && within(x, grid.left, grid.right);
	            })[0];
	        },

	        containingPane: function(cell) {
	            return this.panes.filter(function(pane) {
	                if (pane._grid.contains(cell)) {
	                    return true;
	                }
	                return false;
	            })[0];
	        },

	        cellRectangle: function(cell) {
	            var theGrid = this.containingPane(cell)._grid;
	            var rectangle = this._sheet._grid.rectangle(cell);

	            return rectangle.offset(
	                theGrid.headerWidth - (theGrid.columns.frozen ? 0 : this.scroller.scrollLeft),
	                theGrid.headerHeight - (theGrid.rows.frozen ? 0 : this.scroller.scrollTop)
	            );
	        },

	        refresh: function(reason) {
	            var sheet = this._sheet;

	            if (this.tabstrip) {
	                this.tabstrip.refreshTools(sheet.range(sheet.activeCell()));
	            }

	            if (reason.sheetSelection && this.sheetsbar) {
	                this.sheetsbar.renderSheets(this._workbook.sheets(), this._workbook.sheetIndex(this._sheet));
	            }

	            this._resize();

	            //TODO: refresh sheets list on sheetSelection
	            this.viewSize[0].style.height = sheet._grid.totalHeight() + "px";
	            this.viewSize[0].style.width = sheet._grid.totalWidth() + "px";

	            if (reason.layout) {
	                var frozenColumns = sheet.frozenColumns();
	                var frozenRows = sheet.frozenRows();

	                // main or bottom or right pane
	                this.panes = [ this._pane(frozenRows, frozenColumns) ];

	                // left pane
	                if (frozenColumns > 0) {
	                    this.panes.push(this._pane(frozenRows, 0, null, frozenColumns));
	                }

	                // top pane
	                if (frozenRows > 0) {
	                    this.panes.push(this._pane(0, frozenColumns, frozenRows, null));
	                }

	                // left-top "fixed" pane
	                if (frozenRows > 0 && frozenColumns > 0) {
	                    this.panes.push(this._pane(0, 0, frozenRows, frozenColumns));
	                }
	            }

	            if (reason.filter) {
	                this._destroyFilterMenu();
	            }

	            if (reason.activeCell) {
	                this._focus = sheet.activeCell().toRangeRef();
	            }
	        },

	        createFilterMenu: function(column) {
	            if (this._filterMenu && this._filterMenu.options.column == column) {
	                return this._filterMenu;
	            }

	            this._destroyFilterMenu();

	            var sheet = this._sheet;
	            var ref = sheet.filter().ref;
	            var range = new kendo.spreadsheet.Range(ref, sheet);
	            var element = $("<div />").appendTo(this.element);
	            var options = { column: column, range: range };
	            var filterMenu = new kendo.spreadsheet.FilterMenu(element, options);

	            this._filterMenu = filterMenu;

	            return filterMenu;
	        },

	        selectClipboardContents: function() {
	            if (!this.isClipboardDeactivated) {
	                this.clipboard.focus();
	                selectElementContents(this.clipboard[0]);
	            }
	        },

	        scrollIntoView: function(cell) {
	            var willScroll = false;
	            var theGrid = this.containingPane(cell)._grid;

	            var boundaries = theGrid.scrollBoundaries(cell);

	            var scroller = this.scroller;
	            var scrollTop = theGrid.rows.frozen ? 0 : scroller.scrollTop;
	            var scrollLeft = theGrid.columns.frozen ? 0 : scroller.scrollLeft;

	            if (boundaries.top < scrollTop) {
	                willScroll = true;
	                scroller.scrollTop = boundaries.scrollTop;
	            }

	            if (boundaries.bottom > scrollTop) {
	                willScroll = true;
	                scroller.scrollTop = boundaries.scrollBottom;
	            }

	            if (boundaries.left < scrollLeft) {
	                willScroll = true;
	                scroller.scrollLeft = boundaries.scrollLeft;
	            }

	            if (boundaries.right > scrollLeft) {
	                willScroll = true;
	                scroller.scrollLeft = boundaries.scrollRight;
	            }

	            return willScroll;
	        },

	        _destroyDialog: function() {
	            this._dialogs.pop();
	        },

	        openCustomEditor: function() {
	            var self = this;
	            var cell = self._sheet.activeCell().first();
	            var editor = self._sheet.activeCellCustomEditor();
	            var range = self._sheet.range(cell);
	            editor.edit({
	                range      : range,
	                rect       : self.activeCellRectangle(),
	                view       : this,
	                validation : this._sheet.validation(cell),
	                callback   : function(value, parse){
	                    self._executeCommand({
	                        command: "EditCommand",
	                        options: {
	                            operatingRange: range,
	                            editRange: range,
	                            property: parse ? "input" : "value",
	                            value: value
	                        }
	                    });
	                }
	            });
	        },

	        openDialog: function(name, options) {
	            var sheet = this._sheet;
	            return sheet.withCultureDecimals(function(){
	                var dialog = kendo.spreadsheet.dialogs.create(name, options);

	                if (dialog) {
	                    dialog.bind("action", this._executeCommand.bind(this));
	                    dialog.bind("deactivate", this._destroyDialog.bind(this));
	                    this._dialogs.push(dialog);

	                    var ref = sheet.activeCell();
	                    var range = new kendo.spreadsheet.Range(ref, sheet);

	                    dialog.open(range);
	                    return dialog;
	                }
	            }.bind(this));
	        },

	        showError: function(options, reopenEditor) {
	            var currentDialogs = this._dialogs;
	            var errorMessages = this.options.messages.errors;
	            var hasOpenedError = false;

	            if (currentDialogs.length > 0) {
	                currentDialogs.forEach(function(dialog) {
	                    if (dialog.options && dialog.options.title === ERROR) {
	                        hasOpenedError = true;
	                    }
	                });
	            }
	            if (hasOpenedError) {
	                return;
	            }

	            var focusButton = function(e) {
	                var cont = e.sender.dialog().element;
	                cont.find(".k-button:first").focus();
	                cont.find(".k-button, input").on("keydown", function(ev){
	                    if (ev.keyCode == kendo.keys.ESC) {
	                        e.sender.close();
	                    }
	                });
	            };

	            var onClose = function(e) {
	                var dlg = e.sender;
	                this.selectClipboardContents();
	                if (dlg._retry && reopenEditor) {
	                    reopenEditor();
	                }
	            }.bind(this);

	            if (kendo.spreadsheet.dialogs.registered(options.type)) {
	                var dialogOptions = {
	                    close: onClose
	                };

	                if (options.type === "validationError") {
	                    dialogOptions = $.extend(dialogOptions, {
	                        title: options.title || "Error",
	                        text: options.body ? options.body : errorMessages[options.type],
	                        activate: focusButton
	                    });
	                }

	                this.openDialog(options.type, dialogOptions);
	            } else {
	                this.openDialog("message", {
	                    title : options.title || "Error",
	                    text  : options.body ? options.body : errorMessages[options.type],
	                    activate: focusButton,
	                    close: onClose
	                });
	            }
	        },

	        destroy: function() {
	            this._dialogs.forEach(function(dialog) {
	                dialog.destroy();
	            });

	            this.cellContextMenu.destroy();
	            this.rowHeaderContextMenu.destroy();
	            this.colHeaderContextMenu.destroy();
	            this.drawingContextMenu.destroy();

	            this.cellContextMenu = this.rowHeaderContextMenu =
	                                   this.colHeaderContextMenu =
	                                   this.drawingContextMenu = null;

	            if (this.tabstrip) {
	                this.tabstrip.destroy();
	                this.tabstrip = null;
	            }

	            this._destroyFilterMenu();
	        },

	        _destroyFilterMenu: function() {
	            if (this._filterMenu) {
	                this._filterMenu.destroy();
	                this._filterMenu = undefined;
	                this._filterMenuColumn = undefined;
	            }
	        },

	        render: function(reason) {
	            if (!this.element.is(":visible")) {
	                return;
	            }
	            var sheet = this._sheet;
	            var focus = sheet.focus();
	            var scrollbarSize = kendo.support.scrollbar();
	            var contentWidth = this.wrapper[0].clientWidth - scrollbarSize;
	            var contentHeight = this.wrapper[0].clientHeight - scrollbarSize;

	            if (focus && this.scrollIntoView(focus)) {
	                return;
	            }

	            var resizeDirection =
	                !sheet.resizingInProgress() ? "none" :
	                sheet.resizeHandlePosition().col === -Infinity ? "column" :
	                "row";

	            this.wrapper
	                .toggleClass(viewClassNames.editContainer, this.editor.isActive())
	                .toggleClass(viewClassNames.horizontalResize, resizeDirection == "row")
	                .toggleClass(viewClassNames.verticalResize, resizeDirection == "column");

	            var grid = sheet._grid;
	            var content = [];
	            var args = {
	                scroller: this.scroller,
	                toplevelElements: content,
	                contentWidth: contentWidth,
	                contentHeight: contentHeight
	            };
	            this.panes.forEach(function(pane) {
	                content.push(pane.render(args));
	            });

	            var topCorner = kendo.dom.element("div", {
	                style: { width: grid._headerWidth + "px", height: grid._headerHeight + "px" },
	                className: View.classNames.topCorner
	            });

	            content.push(topCorner);

	            if (sheet.resizeHandlePosition() && sheet.resizeHintPosition()) {
	                content.push(this.renderResizeHint());
	            }

	            this.tree.render(content);

	            $(this.container).css({
	                width: contentWidth,
	                height: contentHeight
	            });

	            if (this.editor.isActive()) {
	                this.editor.toggleTooltip(this.activeCellRectangle());
	            } else if (!(reason.resize ||
	                         reason.comment ||
	                         sheet.selectionInProgress() ||
	                         sheet.resizingInProgress() ||
	                         sheet.draggingInProgress() ||
	                         sheet.isInEditMode())) {
	                this.renderClipboardContents();
	            }
	        },

	        // this renders the big blue line during resizing
	        renderResizeHint: function() {
	            var sheet = this._sheet;
	            var ref = sheet.resizeHandlePosition();

	            var horizontal = ref.col !== -Infinity;

	            var style;
	            if (horizontal) {
	                style = {
	                    height: this.scroller.clientHeight + "px",
	                    width: RESIZE_HANDLE_WIDTH + "px",
	                    left: sheet.resizeHintPosition().x + "px",
	                    top: "0px"
	                };
	            } else {
	                style = {
	                    height: RESIZE_HANDLE_WIDTH + "px",
	                    width: this.scroller.clientWidth + "px",
	                    top: sheet.resizeHintPosition().y + "px",
	                    left: "0px"
	                };
	            }

	            var classNames = Pane.classNames;

	            return kendo.dom.element("div", {
	                className: classNames.resizeHint + (!horizontal ? " " + classNames.resizeHintVertical : ""),
	                style: style
	            },[
	                kendo.dom.element("div", { className: classNames.resizeHintHandle }),
	                kendo.dom.element("div", { className: classNames.resizeHintMarker })
	            ]);
	        },

	        renderClipboardContents: function() {
	            var sheet = this._sheet;
	            var grid = sheet._grid;

	            // if (sheet._activeDrawing && sheet._activeDrawing.image) {
	            //     var url = this._workbook.imageUrl(sheet._activeDrawing.image);
	            //     var img = kendo.dom.element("img", {
	            //         src: url,
	            //         style: {
	            //             width: sheet._activeDrawing.width + "px",
	            //             height: sheet._activeDrawing.height + "px"
	            //         }
	            //     });
	            //     this.clipboardContents.render([ img ]);
	            //     this.selectClipboardContents();
	            //     return;
	            // }

	            var selection = grid.normalize(sheet.select().toRangeRef());
	            var status = this._workbook.clipboard().canCopy();
	            if(status.canCopy === false && status.multiSelection) {
	                this.clipboardContents.render([]);
	                this.selectClipboardContents();
	                return;
	            }

	            selection = sheet.trim(selection);

	            var table = new HtmlTable();

	            var selectionView = grid.rangeDimensions(selection);

	            selectionView.rows.forEach(function(height) {
	                table.addRow(height);
	            });

	            selectionView.columns.forEach(function(width) {
	                table.addColumn(width);
	            });

	            var tmp = sheet._getMergedCells(selection);
	            var primaryMergedCells = tmp.primary;
	            var secondaryMergedCells = tmp.secondary;

	            sheet.forEach(selection, function(row, col, cell) {
	                var location = new CellRef(row, col).print();

	                if (!secondaryMergedCells[location]) {
	                    var td = addCell(table, row - selection.topLeft.row, cell);

	                    var mergedCell = primaryMergedCells[location];

	                    if (mergedCell) {
	                        td.attr.colspan = mergedCell.width();
	                        td.attr.rowspan = mergedCell.height();
	                    }
	                }
	            });
	            this.clipboardContents.render([ table.toDomTree(0, 0, "kendo-clipboard-" + this._workbook.clipboard()._uid) ]);

	            this.selectClipboardContents();
	        },

	        _pane: function(row, column, rowCount, columnCount) {
	            var pane = new Pane(this._sheet, this._sheet._grid.pane({ row: row, column: column, rowCount: rowCount, columnCount: columnCount }));
	            pane.refresh(this.scroller.clientWidth, this.scroller.clientHeight);
	            return pane;
	        }
	    });

	    var paneClassNames = {
	        cell: "k-spreadsheet-cell",
	        vaxis: "k-spreadsheet-vaxis",
	        haxis: "k-spreadsheet-haxis",
	        vborder: "k-spreadsheet-vborder",
	        hborder: "k-spreadsheet-hborder",
	        rowHeader: "k-spreadsheet-row-header",
	        columnHeader: "k-spreadsheet-column-header",
	        pane: "k-spreadsheet-pane",
	        data: "k-spreadsheet-data",
	        mergedCell: "k-spreadsheet-merged-cell",
	        mergedCellsWrapper: "k-merged-cells-wrapper",
	        activeCell: "k-spreadsheet-active-cell",
	        selection: "k-spreadsheet-selection",
	        selectionWrapper: "k-selection-wrapper",
	        autoFillWrapper: "k-auto-fill-wrapper",
	        single: "k-single",
	        top: "k-top",
	        right: "k-right",
	        bottom: "k-bottom",
	        left: "k-left",
	        resizeHandle: "k-resize-handle",
	        columnResizeHandle: "k-column-resize-handle",
	        rowResizeHandle: "k-row-resize-handle",
	        resizeHint: "k-resize-hint",
	        resizeHintHandle: "k-resize-hint-handle",
	        resizeHintMarker: "k-resize-hint-marker",
	        resizeHintVertical: "k-resize-hint-vertical",
	        selectionHighlight: "k-spreadsheet-selection-highlight",
	        series: [
	            "k-series-a",
	            "k-series-b",
	            "k-series-c",
	            "k-series-d",
	            "k-series-e",
	            "k-series-f"
	        ]
	    };

	    var Pane = kendo.Class.extend({
	        init: function(sheet, grid) {
	            this._sheet = sheet;
	            this._grid = grid;
	        },

	        refresh: function(width, height) {
	            this._grid.refresh(width, height);
	        },

	        isVisible: function(scrollLeft, scrollTop, ref) {
	            return this._grid.view(scrollLeft, scrollTop).ref.intersects(ref);
	        },

	        render: function(args) {
	            var scroller = args.scroller;
	            var scrollLeft = scroller.scrollLeft;
	            var scrollTop = scroller.scrollTop;

	            if (scrollTop < 0) {
	                scrollTop = 0;
	            }

	            if (scrollLeft < 0) {
	                scrollLeft = 0;
	            }

	            var classNames = Pane.classNames;
	            var sheet = this._sheet;
	            var grid = this._grid;
	            var view = grid.view(scrollLeft, scrollTop);
	            this._currentView = view;
	            this._currentRect = this._rectangle(view.ref);
	            this._selectedHeaders = sheet.selectedHeaders();

	            var children = [];

	            children.push(this.renderData(args));

	            if (!sheet._activeDrawing) {
	                children.push(this.renderSelection(scroller));
	            }

	            children.push(this.renderAutoFill());

	            children.push(this.renderEditorSelection());

	            children.push(this.renderFilterHeaders());

	            if (grid.hasRowHeader) {
	                var rowHeader = kendo.dom.element("div", {
	                    className: classNames.rowHeader,
	                    style: {
	                        width: grid.headerWidth + "px",
	                        top: view.rowOffset + "px"
	                    }
	                });
	                children.push(rowHeader);
	                sheet.forEach(view.ref.leftColumn(), function(row){
	                    if (!sheet.isHiddenRow(row)) {
	                        var text = row + 1, height = sheet.rowHeight(row);
	                        rowHeader.children.push(kendo.dom.element("div", {
	                            className: this.headerClassName(row, "row"),
	                            style: {
	                                width: grid.headerWidth + "px",
	                                height: height + "px"
	                            }
	                        }, [ kendo.dom.element("div", {
	                            className: "k-vertical-align-center"
	                        }, [ kendo.dom.text(text+"") ])]));
	                    }
	                }.bind(this));
	            }

	            if (grid.hasColumnHeader) {
	                var columnHeader = kendo.dom.element("div", {
	                    className: classNames.columnHeader,
	                    style: {
	                        top: "0px",
	                        left: view.columnOffset + "px",
	                        width: this._currentRect.width + "px",
	                        height: grid.headerHeight + "px"
	                    }
	                });
	                children.push(columnHeader);
	                var left = 0;
	                sheet.forEach(view.ref.topRow(), function(row, col){
	                    if (!sheet.isHiddenColumn(col)) {
	                        var text = kendo.spreadsheet.Ref.display(null, Infinity, col),
	                            width = sheet.columnWidth(col);
	                        columnHeader.children.push(kendo.dom.element("div", {
	                            className: this.headerClassName(col, "col"),
	                            style: {
	                                position: "absolute",
	                                left: left + "px",
	                                width: width + "px",
	                                height: grid.headerHeight + "px"
	                            }
	                        }, [ kendo.dom.element("div", {
	                            className: "k-vertical-align-center"
	                        }, [ kendo.dom.text(text+"") ])]));
	                        left += width;
	                    }
	                }.bind(this));
	            }

	            if (sheet.resizeHandlePosition() && (grid.hasColumnHeader || grid.hasRowHeader)) {
	                if (!sheet.resizeHintPosition()) {
	                    this.renderResizeHandle(children);
	                }
	            }

	            var paneClasses = [classNames.pane];

	            if (grid.hasColumnHeader) {
	                paneClasses.push(classNames.top);
	            }

	            if (grid.hasRowHeader) {
	                paneClasses.push(classNames.left);
	            }

	            return kendo.dom.element("div", {
	                style: grid.style,
	                className: paneClasses.join(" ")
	            }, children);
	        },

	        headerClassName: function(index, type) {
	            var selectedHeaders = this._selectedHeaders;

	            var itemSelection;
	            var allHeaders;

	            if (type === "row") {
	                itemSelection = selectedHeaders.rows[index];
	                allHeaders = selectedHeaders.allRows;
	            } else {
	                itemSelection = selectedHeaders.cols[index];
	                allHeaders = selectedHeaders.allCols;
	            }

	            var className = itemSelection || (selectedHeaders.all ? "full" : (allHeaders ? "partial" : "none"));

	            if (className) {
	                className = "k-selection-" + className;
	            }

	            return className;
	        },

	        renderData: function(args) {
	            var sheet = this._sheet;
	            var view = this._currentView;
	            var cont = kendo.dom.element("div", {
	                className: Pane.classNames.data,
	                style: {
	                    position: "relative",
	                    left: view.columnOffset + "px",
	                    top: view.rowOffset + "px"
	                }
	            });
	            var rect = this._currentRect;
	            var layout = kendo.spreadsheet.draw.doLayout(sheet, view.ref, { forScreen: true }), prev;
	            var grid = this._grid;
	            var showGridLines = sheet._showGridLines;
	            if (showGridLines) {
	                // draw axis first
	                prev = null;
	                layout.xCoords.forEach(function(x){
	                    if (x !== prev) {
	                        prev = x;
	                        cont.children.push(kendo.dom.element("div", {
	                            className: paneClassNames.vaxis,
	                            style: {
	                                left: x + "px",
	                                height: rect.height + "px",
	                                borderColor: sheet.gridLinesColor()
	                            }
	                        }));
	                    }
	                });
	                prev = null;
	                layout.yCoords.forEach(function(y){
	                    if (y !== prev) {
	                        prev = y;
	                        cont.children.push(kendo.dom.element("div", {
	                            className: paneClassNames.haxis,
	                            style: {
	                                top: y + "px",
	                                width: rect.width + "px",
	                                borderColor: sheet.gridLinesColor()
	                            }
	                        }));
	                    }
	                });
	            }
	            var borders = kendo.spreadsheet.draw.Borders();
	            var activeCellRange = sheet.activeCell().toRangeRef();
	            var activeCell = activeCellRange.topLeft;

	            layout.cells.forEach(function(cell){
	                var cls = null;
	                var absRow = cell.row + view.ref.topLeft.row;
	                var absCol = cell.col + view.ref.topLeft.col;
	                if (sheet._activeDrawing) {
	                    var ref = sheet._activeDrawing.topLeftCell;
	                    if (ref && ref.row == absRow && ref.col == absCol) {
	                        cls = "k-spreadsheet-drawing-anchor-cell";
	                    }
	                } else if (absRow == activeCell.row && absCol == activeCell.col) {
	                    // active cell.  normally we enter here only once.
	                    cls = [
	                        Pane.classNames.activeCell
	                    ].concat(this._activeFormulaColor(),
	                             this._directionClasses(activeCellRange));
	                    if (sheet.singleCellSelection()) {
	                        cls.push(Pane.classNames.single);
	                    }
	                    cls = cls.join(" ");
	                }
	                borders.add(cell);
	                drawCell(cont.children, cell, cls, showGridLines);
	                if (cell.comment && sheet._commentRef &&
	                    absRow == sheet._commentRef.row && absCol == sheet._commentRef.col) {
	                    var ttOffset = 4;
	                    var left = cell.right + grid.left + view.columnOffset + ttOffset;
	                    var style = { top: (cell.top + grid.top + view.rowOffset) + "px" };
	                    if (left + 200 > args.contentWidth) {
	                        style.right = (args.contentWidth - grid.left - cell.left - view.columnOffset + ttOffset) + "px";
	                    } else {
	                        style.left = left + "px";
	                    }
	                    var div = kendo.dom.element("div", {
	                        className: "k-tooltip k-spreadsheet-cell-comment",
	                        style: style
	                    }, [ kendo.dom.text(cell.comment) ]);
	                    args.toplevelElements.push(div);
	                }
	            }, this);
	            borders.vert.forEach(function(a){
	                a.forEach(function(b){
	                    if (!b.rendered) {
	                        b.rendered = true;
	                        var style = {
	                            left        : b.x + "px",
	                            top         : b.top + "px",
	                            height      : (b.bottom - b.top + 1) + "px",
	                            borderWidth : b.size + "px",
	                            borderColor : b.color
	                        };
	                        if (b.size != 1) {
	                            style.transform = "translateX(-" + (b.size-1)/2 + "px)";
	                        }
	                        cont.children.push(kendo.dom.element("div", {
	                            className: paneClassNames.vborder,
	                            style: style
	                        }));
	                    }
	                });
	            });
	            borders.horiz.forEach(function(a){
	                a.forEach(function(b){
	                    if (!b.rendered) {
	                        b.rendered = true;
	                        var style = {
	                            top         : b.y + "px",
	                            left        : b.left + "px",
	                            width       : (b.right - b.left) + "px",
	                            borderWidth : b.size + "px",
	                            borderColor : b.color
	                        };
	                        if (b.size != 1) {
	                            style.transform = "translateY(-" + (b.size-1)/2 + "px)";
	                        }
	                        cont.children.push(kendo.dom.element("div", {
	                            className: paneClassNames.hborder,
	                            style: style
	                        }));
	                    }
	                });
	            });
	            this.renderDrawings(layout, cont.children);
	            return cont;
	        },

	        renderDrawings: function(layout, container) {
	            var sheet = this._sheet;
	            var workbook = sheet._workbook;
	            layout.drawings.forEach(function(d){
	                var drawing = d.drawing;
	                var box = d.box;
	                var div = box.toDiv("k-spreadsheet-drawing");
	                if (drawing.image) {
	                    div.children.push(kendo.dom.element("div", {
	                        className: "k-spreadsheet-drawing-image",
	                        style: {
	                            backgroundImage: "url('" + workbook.imageUrl(drawing.image) + "')",
	                            opacity: drawing.opacity
	                        }
	                    }));
	                }
	                if (drawing === sheet._activeDrawing) {
	                    div.attr.className += " k-spreadsheet-active-drawing";
	                    drawingResizeHandles(div.children);
	                }
	                container.push(div);
	            });
	        },

	        renderResizeHandle: function(container) {
	            var sheet = this._sheet;
	            var ref = sheet.resizeHandlePosition();
	            var rectangle = this._rectangle(ref);
	            var classNames = [ Pane.classNames.resizeHandle ];

	            var style;
	            if (ref.col !== -Infinity) {
	                if (this._grid.rows._start > 0) {
	                    return;
	                }
	                style = {
	                    height: this._grid.headerHeight + "px",
	                    width: RESIZE_HANDLE_WIDTH + "px",
	                    left: rectangle.right - RESIZE_HANDLE_WIDTH/2  + "px",
	                    top: "0px"
	                };
	                classNames.push(viewClassNames.horizontalResize);
	            } else {
	                if (this._grid.columns._start > 0) {
	                    return;
	                }
	                style = {
	                    height: RESIZE_HANDLE_WIDTH + "px",
	                    width:  this._grid.headerWidth + "px",
	                    top: rectangle.bottom - RESIZE_HANDLE_WIDTH/2  + "px",
	                    left: "0px"
	                };
	                classNames.push(viewClassNames.verticalResize);
	            }

	            container.push(kendo.dom.element("div", {
	                className: classNames.join(" "),
	                style: style
	            }));
	        },

	        filterIconRect: function(rect) {
	            var BUTTON_SIZE = 16;
	            var BUTTON_OFFSET = 3;

	            return new kendo.spreadsheet.Rectangle(
	                rect.right - BUTTON_SIZE - BUTTON_OFFSET,
	                rect.top + BUTTON_OFFSET,
	                BUTTON_SIZE,
	                BUTTON_SIZE
	            );
	        },

	        renderFilterHeaders: function() {
	            var sheet = this._sheet;
	            var children = [];
	            var classNames = View.classNames;
	            var filter = sheet.filter();

	            function icon(className) {
	                return kendo.dom.element("span", {
	                    className: classNames.icon + " " + className
	                });
	            }

	            function filterButton(classNames, position, index) {
	                var style = {
	                    left: position.left + "px",
	                    top: position.top + "px"
	                };
	                var filtered = filter && filter.columns.some(function(c) {
	                    return c.index === index;
	                });
	                var classes = classNames.filterButton;

	                if (filtered) {
	                    classes += " " + classNames.filterButtonActive;
	                }

	                var button = kendo.dom.element(
	                    "span",
	                    { className: classes, style: style },
	                    [ icon(classNames.iconFilterDefault) ]
	                );

	                return button;
	            }

	            if (filter) {
	                this._addDiv(children, filter.ref, classNames.filterRange);
	            }

	            sheet.forEachFilterHeader(this._currentView.ref, function(ref) {
	                var rect = this._rectangle(ref);
	                var position = this.filterIconRect(rect);
	                var column = this._sheet.filterColumn(ref);
	                var button = filterButton(classNames, position, column);

	                children.push(button);
	            }.bind(this));

	            return kendo.dom.element("div", {
	                className: classNames.filterHeadersWrapper
	            }, children);

	        },

	        renderEditorSelection: function() {
	            var classNames = Pane.classNames;
	            var sheet = this._sheet;
	            var selections = [];

	            sheet._formulaSelections.forEach(function(range) {
	                var ref = range.ref;

	                if (ref === kendo.spreadsheet.NULLREF) {
	                    return;
	                }

	                this._addDiv(selections, ref, classNames.selectionHighlight + " " + range.colorClass);
	            }.bind(this));

	            return kendo.dom.element("div", { className: classNames.selectionWrapper }, selections);

	        },

	        renderSelection: function(scroller) {
	            var classNames = Pane.classNames;
	            var selections = [];
	            var selectionClasses = [classNames.selection];
	            var sheet = this._sheet;
	            var activeCell = sheet.activeCell().toRangeRef();
	            var selection = sheet.select();

	            selectionClasses = selectionClasses.concat(this._activeFormulaColor());

	            if (selection.size() === 1) {
	                selectionClasses.push("k-single-selection");
	            }

	            if (this._sheet.autoFillPunch()) {
	                selectionClasses.push("k-dim-auto-fill-handle");
	            }

	            selection.forEach(function(ref) {
	                if (ref !== kendo.spreadsheet.NULLREF) {
	                    this._addDiv(selections, ref, selectionClasses.join(" "));
	                }
	            }.bind(this));

	            this._renderCustomEditorButton(selections, activeCell, scroller);

	            return kendo.dom.element("div", { className: classNames.selectionWrapper }, selections);
	        },

	        renderAutoFill: function() {
	            var autoFillRectangle = [];

	            if (this._sheet.autoFillInProgress()) {
	                var autoFillRef = this._sheet.autoFillRef();
	                var punch = this._sheet.autoFillPunch();
	                var direction = this._sheet._autoFillDirection;

	                this._addDiv(autoFillRectangle, autoFillRef, "k-auto-fill");

	                if (punch) { // collapsing, add overlay
	                    this._addDiv(autoFillRectangle, punch, "k-auto-fill-punch");
	                } else if (direction !== undefined) { // expanding - add hint
	                    var ref, cssClass;

	                    switch(direction) {
	                        case 0:
	                            ref = autoFillRef.bottomRight;
	                            cssClass = "k-auto-fill-br-hint";
	                            break;
	                        case 1:
	                            ref = autoFillRef.bottomRight;
	                            cssClass = "k-auto-fill-br-hint";
	                            break;
	                        case 2:
	                            ref = new CellRef(autoFillRef.topLeft.row, autoFillRef.bottomRight.col);
	                            cssClass = "k-auto-fill-tr-hint";
	                            break;
	                        case 3:
	                            ref = new CellRef(autoFillRef.bottomRight.row, autoFillRef.topLeft.col);
	                            cssClass = "k-auto-fill-bl-hint";
	                            break;
	                    }

	                    var rectangle = this._addDiv(autoFillRectangle, ref, cssClass);
	                    if (rectangle) {
	                        var hint = kendo.dom.element("span", { className: "k-tooltip" }, [ kendo.dom.text(this._sheet._autoFillHint) ]);
	                        rectangle.children.push(hint);
	                    }
	                }
	            }

	            return kendo.dom.element("div", { className: Pane.classNames.autoFillWrapper }, autoFillRectangle);
	        },

	        _addDiv: function(collection, ref, className) {
	            var view = this._currentView, div;

	            if (view.ref.intersects(ref)) {
	                div = this._rectangle(ref).resize(1, 1).toDiv(className);
	                collection.push(div);
	            }
	            return div;
	        },

	        _renderCustomEditorButton: function(collection, ref, scroller) {
	            var self = this;
	            var sheet = self._sheet;
	            var view = self._currentView;
	            var columnCount = self._grid.columns._axis._count;
	            var ed = sheet.activeCellCustomEditor();

	            if (ed && view.ref.intersects(ref)) {
	                var rectangle = self._rectangle(ref);
	                sheet.forEach(ref.collapse(), function(row, col, cell) {
	                    cell.left = rectangle.left;
	                    cell.top = rectangle.top;
	                    cell.width = rectangle.width;
	                    cell.height = rectangle.height;

	                    var btnClass = "k-button k-spreadsheet-editor-button";
	                    var isLastColumn = col == columnCount - 1 || self._buttonOutOfVisiblePane(row, col, scroller);
	                    if (isLastColumn) {
	                        btnClass += " k-spreadsheet-last-column";
	                    }
	                    self._editorInLastColumn = isLastColumn;
	                    var btn = kendo.dom.element("div", {
	                        className: btnClass,
	                        style: {
	                            left   : (cell.left + (isLastColumn ? 0 : cell.width)) + "px",
	                            top    : cell.top + "px",
	                            height : cell.height + "px"
	                        }
	                    });
	                    if (ed.icon) {
	                        btn.children.push(kendo.dom.element("span", {
	                            className: "k-icon " + ed.icon
	                        }));
	                    }
	                    collection.push(btn);
	                });
	            }
	        },

	        _activeFormulaColor: function() {
	            var activeFormulaSelection;
	            var colorClasses = [];

	            if (this._sheet.isInEditMode()) {
	                activeFormulaSelection = this._sheet._formulaSelections.filter(function(sel) { return sel.active && sel.type == "ref"; })[0];

	                if (activeFormulaSelection) {
	                    colorClasses.push(activeFormulaSelection.colorClass);
	                }
	            }

	            return colorClasses;
	        },

	        _directionClasses: function(cell) {
	            var cellClasses = [];
	            var classNames = Pane.classNames;
	            var view = this._currentView.ref;

	            if (!cell.move(0, -1).intersects(view)) {
	                cellClasses.push(classNames.left);
	            }

	            if (!cell.move(-1, 0).intersects(view)) {
	                cellClasses.push(classNames.top);
	            }

	            if (!cell.move(0, 1).intersects(view)) {
	                cellClasses.push(classNames.right);
	            }

	            if (!cell.move(1, 0).intersects(view)) {
	                cellClasses.push(classNames.bottom);
	            }

	            return cellClasses;
	        },

	        _rectangle: function(ref) {
	            return this._grid.boundingRectangle(ref.toRangeRef()).offset(-this._currentView.mergedCellLeft, -this._currentView.mergedCellTop);
	        },

	        _buttonOutOfVisiblePane: function(row, col, scroller) {
	            var self = this;
	            var theGrid = self._grid;
	            var sheet = self._sheet;
	            var ref = sheet.range(row, col)._ref;
	            var boundaries = theGrid.scrollBoundaries(ref);
	            var scrollLeft = theGrid.columns.frozen ? 0 : scroller.scrollLeft;

	            if (boundaries.right + EDIT_BUTTON_WIDTH > scrollLeft || col + 1 === sheet.frozenColumns()) {
	                return true;
	            }
	        }
	    });

	    function drawingResizeHandles(container) {
	        [ "N", "NE", "E", "SE", "S", "SW", "W", "NW" ].forEach(function(direction) {
	            container.push(kendo.dom.element("div", {
	                "className": "k-spreadsheet-drawing-handle " + direction,
	                "data-direction": direction
	            }));
	        });
	    }

	    kendo.spreadsheet.View = View;
	    kendo.spreadsheet.Pane = Pane;
	    kendo.spreadsheet.drawCell = drawCell;

	    $.extend(true, View, { classNames: viewClassNames });
	    $.extend(true, Pane, { classNames: paneClassNames });

	})(window.kendo);
	}, __webpack_require__(3));


/***/ }),

/***/ 1633:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("DfTB");

/***/ })

/******/ });

/***/ }),

/***/ "DuR2":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "DwXV":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1313);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1105:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ef9w");

/***/ }),

/***/ 1301:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Yz+S");

/***/ }),

/***/ 1313:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1301), __webpack_require__(1105) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.application",
	    name: "Application",
	    category: "mobile",
	    description: "The Mobile application provides a framework to build native looking web applications on mobile devices.",
	    depends: [ "mobile.pane", "router" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        mobile = kendo.mobile,
	        support = kendo.support,
	        Widget = mobile.ui.Widget,
	        Pane = mobile.ui.Pane,

	        DEFAULT_OS = "ios7",
	        OS = support.mobileOS,
	        BERRYPHONEGAP = OS.device == "blackberry" && OS.flatVersion >= 600 && OS.flatVersion < 1000 && OS.appMode,
	        FONT_SIZE_COEF = 0.93,
	        VERTICAL = "km-vertical",
	        CHROME =  OS.browser === "chrome",
	        BROKEN_WEBVIEW_RESIZE = OS.ios && OS.flatVersion >= 700 && OS.flatVersion < 800 && (OS.appMode || CHROME),
	        INITIALLY_HORIZONTAL = (Math.abs(window.orientation) / 90 == 1),
	        HORIZONTAL = "km-horizontal",

	        MOBILE_PLATFORMS = {
	            ios7: { ios: true, browser: "default", device: "iphone", flatVersion: "700", majorVersion: "7", minorVersion: "0.0", name: "ios", tablet: false },
	            ios: { ios: true, browser: "default", device: "iphone", flatVersion: "612", majorVersion: "6", minorVersion: "1.2", name: "ios", tablet: false },
	            android: { android: true, browser: "default", device: "android", flatVersion: "442", majorVersion: "4", minorVersion: "4.2", name: "android", tablet: false },
	            blackberry: { blackberry: true, browser: "default", device: "blackberry", flatVersion: "710", majorVersion: "7", minorVersion: "1.0", name: "blackberry", tablet: false },
	            meego: { meego: true, browser: "default", device: "meego", flatVersion: "850", majorVersion: "8", minorVersion: "5.0", name: "meego", tablet: false },
	            wp: { wp: true, browser: "default", device: "wp", flatVersion: "800", majorVersion: "8", minorVersion: "0.0", name: "wp", tablet: false }
	        },

	        viewportTemplate = kendo.template('<meta content="initial-scale=#: data.scale #, maximum-scale=#: data.scale #, user-scalable=no#=data.height#" name="viewport" />', {usedWithBlock: false}),
	        systemMeta = kendo.template('<meta name="apple-mobile-web-app-capable" content="#= data.webAppCapable === false ? \'no\' : \'yes\' #" /> ' +
	                     '<meta name="apple-mobile-web-app-status-bar-style" content="#=data.statusBarStyle#" /> ' +
	                     '<meta name="msapplication-tap-highlight" content="no" /> ', {usedWithBlock: false}),
	        clipTemplate = kendo.template('<style>.km-view { clip: rect(0 #= data.width #px #= data.height #px 0); }</style>', {usedWithBlock: false}),
	        ENABLE_CLIP = OS.android && OS.browser != "chrome" || OS.blackberry,

	        iconMeta = kendo.template('<link rel="apple-touch-icon' + (OS.android ? '-precomposed' : '') + '" # if(data.size) { # sizes="#=data.size#" #}# href="#=data.icon#" />', {usedWithBlock: false}),

	        HIDEBAR = (OS.device == "iphone" || OS.device == "ipod") && OS.majorVersion < 7,
	        SUPPORT_SWIPE_TO_GO_BACK = (OS.device == "iphone" || OS.device == "ipod") && OS.majorVersion >= 7,
	        HISTORY_TRANSITION = SUPPORT_SWIPE_TO_GO_BACK ? "none" : null,
	        BARCOMPENSATION = OS.browser == "mobilesafari" ? 60 : 0,
	        STATUS_BAR_HEIGHT = 20,
	        WINDOW = $(window),
	        SCREEN = window.screen,
	        HEAD = $("head"),

	        // mobile app events
	        INIT = "init",
	        proxy = $.proxy;

	    function osCssClass(os, options) {
	        var classes = [];

	        if (OS) {
	            classes.push("km-on-" + OS.name);
	        }

	        if (os.skin) {
	            classes.push("km-" + os.skin);
	        } else {
	            if (os.name == "ios" && os.majorVersion > 6) {
	                classes.push("km-ios7");
	            } else {
	                classes.push("km-" + os.name);
	            }
	        }
	        if ((os.name == "ios" && os.majorVersion < 7) || os.name != "ios") {
	            classes.push("km-" + os.name + os.majorVersion);
	        }
	        classes.push("km-" + os.majorVersion);
	        classes.push("km-m" + (os.minorVersion ? os.minorVersion[0] : 0));

	        if (os.variant && ((os.skin && os.skin === os.name) || !os.skin || os.setDefaultPlatform === false)) {
	            classes.push("km-" + (os.skin ? os.skin : os.name) + "-" + os.variant);
	        }

	        if (os.cordova) {
	            classes.push("km-cordova");
	        }
	        if (os.appMode) {
	            classes.push("km-app");
	        } else {
	            classes.push("km-web");
	        }

	        if (options && options.statusBarStyle) {
	            classes.push("km-" + options.statusBarStyle + "-status-bar");
	        }

	        return classes.join(" ");
	    }

	    function wp8Background(os) {
	        return 'km-wp-' + (os.noVariantSet ?
	                            (parseInt($("<div style='background: Background' />").css("background-color").split(",")[1], 10) === 0 ? 'dark' : 'light') :
	                            os.variant + " km-wp-" + os.variant + "-force");
	    }

	    function isOrientationHorizontal(element) {
	        return OS.wp ? element.css("animation-name") == "-kendo-landscape" : (Math.abs(window.orientation) / 90 == 1);
	    }

	    function getOrientationClass(element) {
	        return isOrientationHorizontal(element) ? HORIZONTAL : VERTICAL;
	    }

	    function setMinimumHeight(pane) {
	        pane.parent().addBack()
	               .css("min-height", window.innerHeight);
	    }

	    function applyViewportHeight() {
	        $("meta[name=viewport]").remove();
	            HEAD.append(viewportTemplate({
	            height: ", width=device-width" +  // width=device-width was removed for iOS6, but this should stay for BB PhoneGap.
	                        (isOrientationHorizontal() ?
	                            ", height=" + window.innerHeight + "px"  :
	                            (support.mobileOS.flatVersion >= 600 && support.mobileOS.flatVersion < 700) ?
	                                ", height=" + window.innerWidth + "px" :
	                                ", height=device-height")
	        }));
	    }

	    var Application = Widget.extend({
	        init: function(element, options) {
	            // global reference to current application
	            mobile.application = this;
	            $($.proxy(this, 'bootstrap', element, options));
	        },

	        bootstrap: function(element, options) {
	            element = $(element);

	            if (!element[0]) {
	                element = $(document.body);
	            }

	            Widget.fn.init.call(this, element, options);
	            this.element.removeAttr("data-" + kendo.ns + "role");

	            this._setupPlatform();
	            this._attachMeta();
	            this._setupElementClass();
	            this._attachHideBarHandlers();
	            var paneOptions = $.extend({}, this.options);
	            delete paneOptions.name;

	            var that = this,
	                startHistory = function() {
	                    that.pane = new Pane(that.element, paneOptions);
	                    that.pane.navigateToInitial();

	                    if (that.options.updateDocumentTitle) {
	                        that._setupDocumentTitle();
	                    }

	                    that._startHistory();
	                    that.trigger(INIT);
	                };

	            if (this.options.$angular) {
	                setTimeout(startHistory);
	            } else {
	                startHistory();
	            }
	        },

	        options: {
	            name: "Application",
	            hideAddressBar: true,
	            browserHistory: true,
	            historyTransition: HISTORY_TRANSITION,
	            modelScope: window,
	            statusBarStyle: "black",
	            transition: "",
	            retina: false,
	            platform: null,
	            skin: null,
	            updateDocumentTitle: true,
	            useNativeScrolling: false
	        },

	        events: [
	            INIT
	        ],

	        navigate: function(url, transition) {
	            this.pane.navigate(url, transition);
	        },

	        replace: function(url, transition) {
	            this.pane.replace(url, transition);
	        },

	        scroller: function() {
	            return this.view().scroller;
	        },

	        hideLoading: function() {
	            if (this.pane) {
	                this.pane.hideLoading();
	            } else {
	                throw new Error("The mobile application instance is not fully instantiated. Please consider activating loading in the application init event handler.");
	            }
	        },

	        showLoading: function() {
	            if (this.pane) {
	                this.pane.showLoading();
	            } else {
	                throw new Error("The mobile application instance is not fully instantiated. Please consider activating loading in the application init event handler.");
	            }
	        },

	        changeLoadingMessage: function(message) {
	            if (this.pane) {
	                this.pane.changeLoadingMessage(message);
	            } else {
	                throw new Error("The mobile application instance is not fully instantiated. Please consider changing the message in the application init event handler.");
	            }
	        },

	        view: function() {
	            return this.pane.view();
	        },

	        skin: function(skin) {
	            var that = this;

	            if (!arguments.length) {
	                return that.options.skin;
	            }

	            that.options.skin = skin || "";
	            that.element[0].className = "km-pane";
	            that._setupPlatform();
	            that._setupElementClass();

	            return that.options.skin;
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            this.pane.destroy();
	            if (this.options.browserHistory) {
	                this.router.destroy();
	            }
	        },

	        _setupPlatform: function() {
	            var that = this,
	                platform = that.options.platform,
	                skin = that.options.skin,
	                split = [],
	                os = OS || MOBILE_PLATFORMS[DEFAULT_OS];

	            if (platform) {
	                os.setDefaultPlatform = true;
	                if (typeof platform === "string") {
	                    split = platform.split("-");
	                    os = $.extend({ variant: split[1] }, os, MOBILE_PLATFORMS[split[0]]);
	                } else {
	                    os = platform;
	                }
	            }

	            if (skin) {
	                split = skin.split("-");
	                if (!OS) {
	                    os.setDefaultPlatform = false;
	                }
	                os = $.extend({}, os, { skin: split[0], variant: split[1] });
	            }

	            if (!os.variant) {
	                os.noVariantSet = true;
	                os.variant = "dark";
	            }

	            that.os = os;

	            that.osCssClass = osCssClass(that.os, that.options);

	            if (os.name == "wp") {
	                if (!that.refreshBackgroundColorProxy) {
	                    that.refreshBackgroundColorProxy = $.proxy(function () {
	                        if (that.os.variant && (that.os.skin && that.os.skin === that.os.name) || !that.os.skin) {
	                            that.element.removeClass("km-wp-dark km-wp-light km-wp-dark-force km-wp-light-force").addClass(wp8Background(that.os));
	                        }
	                    }, that);
	                }

	                $(document).off("visibilitychange", that.refreshBackgroundColorProxy);
	                $(document).off("resume", that.refreshBackgroundColorProxy);

	                if (!os.skin) {
	                    that.element.parent().css("overflow", "hidden");

	                    $(document).on("visibilitychange", that.refreshBackgroundColorProxy); // Restore theme on browser focus (using the Visibility API).
	                    $(document).on("resume", that.refreshBackgroundColorProxy); // PhoneGap fires resume.

	                    that.refreshBackgroundColorProxy();
	                }
	            }
	        },

	        _startHistory: function() {
	            if (this.options.browserHistory) {
	                this.router = new kendo.Router({ pushState: this.options.pushState, root: this.options.root, hashBang: this.options.hashBang });
	                this.pane.bindToRouter(this.router);
	                this.router.start();
	            } else {
	                if (!this.options.initial) {
	                    this.pane.navigate("");
	                }
	            }
	        },

	        _resizeToScreenHeight: function() {
	            var includeStatusBar = $("meta[name=apple-mobile-web-app-status-bar-style]").attr("content").match(/black-translucent|hidden/),
	                element = this.element,
	                height;

	            if (CHROME) {
	                height = window.innerHeight;
	            } else {
	                if (isOrientationHorizontal(element)) {
	                    if (includeStatusBar) {
	                        if (INITIALLY_HORIZONTAL) {
	                            height = SCREEN.availWidth + STATUS_BAR_HEIGHT;
	                        } else {
	                            height = SCREEN.availWidth;
	                        }
	                    } else {
	                        if (INITIALLY_HORIZONTAL) {
	                            height = SCREEN.availWidth;
	                        } else {
	                            height = SCREEN.availWidth - STATUS_BAR_HEIGHT;
	                        }
	                    }
	                } else {
	                    if (includeStatusBar) {
	                        if (INITIALLY_HORIZONTAL) {
	                            height = SCREEN.availHeight;
	                        } else {
	                            height = SCREEN.availHeight + STATUS_BAR_HEIGHT;
	                        }
	                    } else {
	                        if (INITIALLY_HORIZONTAL) {
	                            height = SCREEN.availHeight - STATUS_BAR_HEIGHT;
	                        } else {
	                            height = SCREEN.availHeight;
	                        }
	                    }
	                }
	            }

	            element.height(height);
	        },

	        _setupElementClass: function() {
	            var that = this, size,
	                element = that.element;

	            element.parent().addClass("km-root km-" + (that.os.tablet ? "tablet" : "phone"));
	            element.addClass(that.osCssClass + " " + getOrientationClass(element));
	            if (this.options.useNativeScrolling) {
	                element.parent().addClass("km-native-scrolling");
	            }

	            if (CHROME) {
	                element.addClass("km-ios-chrome");
	            }

	            if (support.wpDevicePixelRatio) {
	                element.parent().css("font-size", support.wpDevicePixelRatio + "em");
	            }

	            if (this.options.retina) {
	                element.parent().addClass("km-retina");
	                element.parent().css("font-size", (support.devicePixelRatio * FONT_SIZE_COEF) + "em");
	            }

	            if (BERRYPHONEGAP) {
	                applyViewportHeight();
	            }
	            if (that.options.useNativeScrolling) {
	                element.parent().addClass("km-native-scrolling");
	            } else if (ENABLE_CLIP) {
	                size = (screen.availWidth > screen.availHeight ? screen.availWidth : screen.availHeight) + 200;
	                $(clipTemplate({ width: size, height: size })).appendTo(HEAD);
	            }

	            if (BROKEN_WEBVIEW_RESIZE) {
	                that._resizeToScreenHeight();
	            }

	            kendo.onResize(function() {
	                element
	                    .removeClass("km-horizontal km-vertical")
	                    .addClass(getOrientationClass(element));

	                if (that.options.useNativeScrolling) {
	                    setMinimumHeight(element);
	                }

	                if (BROKEN_WEBVIEW_RESIZE) {
	                    that._resizeToScreenHeight();
	                }

	                if (BERRYPHONEGAP) {
	                    applyViewportHeight();
	                }

	                kendo.resize(element);
	            });
	        },

	        _clearExistingMeta: function() {
	            HEAD.find("meta")
	                .filter("[name|='apple-mobile-web-app'],[name|='msapplication-tap'],[name='viewport']")
	                .remove();
	        },

	        _attachMeta: function() {
	            var options = this.options,
	                icon = options.icon, size;

	            this._clearExistingMeta();

	            if (!BERRYPHONEGAP) {
	                HEAD.prepend(viewportTemplate({ height: "", scale : this.options.retina ? 1 / support.devicePixelRatio : "1.0" }));
	            }

	            HEAD.prepend(systemMeta(options));

	            if (icon) {
	                if (typeof icon === "string") {
	                    icon = { "" : icon };
	                }

	                for(size in icon) {
	                    HEAD.prepend(iconMeta({ icon: icon[size], size: size }));
	                }
	            }

	            if (options.useNativeScrolling) {
	                setMinimumHeight(this.element);
	            }
	        },

	        _attachHideBarHandlers: function() {
	            var that = this,
	                hideBar = proxy(that, "_hideBar");

	            if (support.mobileOS.appMode || !that.options.hideAddressBar || !HIDEBAR || that.options.useNativeScrolling) {
	                return;
	            }

	            that._initialHeight = {};

	            WINDOW.on("load", hideBar);

	            kendo.onResize(function() {
	                setTimeout(window.scrollTo, 0, 0, 1);
	            });
	        },

	        _setupDocumentTitle: function() {
	            var that = this,
	                defaultTitle = document.title;

	            that.pane.bind("viewShow", function(e) {
	                var title = e.view.title;
	                document.title = title !== undefined ? title : defaultTitle;
	            });
	        },

	        _hideBar: function() {
	            var that = this,
	                element = that.element;

	            element.height(kendo.support.transforms.css + "calc(100% + " + BARCOMPENSATION + "px)");
	            $(window).trigger(kendo.support.resize);
	        }
	    });

	    kendo.mobile.Application = Application;
	    kendo.ui.plugin(Application, kendo.mobile, 'Mobile');
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "Dz7c":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1250);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1250:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "fx",
	    name: "Effects",
	    category: "framework",
	    description: "Required for animation effects in all Kendo UI widgets.",
	    depends: [ "core" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        fx = kendo.effects,
	        each = $.each,
	        extend = $.extend,
	        proxy = $.proxy,
	        support = kendo.support,
	        browser = support.browser,
	        transforms = support.transforms,
	        transitions = support.transitions,
	        scaleProperties = { scale: 0, scalex: 0, scaley: 0, scale3d: 0 },
	        translateProperties = { translate: 0, translatex: 0, translatey: 0, translate3d: 0 },
	        hasZoom = (typeof document.documentElement.style.zoom !== "undefined") && !transforms,
	        matrix3dRegExp = /matrix3?d?\s*\(.*,\s*([\d\.\-]+)\w*?,\s*([\d\.\-]+)\w*?,\s*([\d\.\-]+)\w*?,\s*([\d\.\-]+)\w*?/i,
	        cssParamsRegExp = /^(-?[\d\.\-]+)?[\w\s]*,?\s*(-?[\d\.\-]+)?[\w\s]*/i,
	        translateXRegExp = /translatex?$/i,
	        oldEffectsRegExp = /(zoom|fade|expand)(\w+)/,
	        singleEffectRegExp = /(zoom|fade|expand)/,
	        unitRegExp = /[xy]$/i,
	        transformProps = ["perspective", "rotate", "rotatex", "rotatey", "rotatez", "rotate3d", "scale", "scalex", "scaley", "scalez", "scale3d", "skew", "skewx", "skewy", "translate", "translatex", "translatey", "translatez", "translate3d", "matrix", "matrix3d"],
	        transform2d = ["rotate", "scale", "scalex", "scaley", "skew", "skewx", "skewy", "translate", "translatex", "translatey", "matrix"],
	        transform2units = { "rotate": "deg", scale: "", skew: "px", translate: "px" },
	        cssPrefix = transforms.css,
	        round = Math.round,
	        BLANK = "",
	        PX = "px",
	        NONE = "none",
	        AUTO = "auto",
	        WIDTH = "width",
	        HEIGHT = "height",
	        HIDDEN = "hidden",
	        ORIGIN = "origin",
	        ABORT_ID = "abortId",
	        OVERFLOW = "overflow",
	        TRANSLATE = "translate",
	        POSITION = "position",
	        COMPLETE_CALLBACK = "completeCallback",
	        TRANSITION = cssPrefix + "transition",
	        TRANSFORM = cssPrefix + "transform",
	        BACKFACE = cssPrefix + "backface-visibility",
	        PERSPECTIVE = cssPrefix + "perspective",
	        DEFAULT_PERSPECTIVE = "1500px",
	        TRANSFORM_PERSPECTIVE = "perspective(" + DEFAULT_PERSPECTIVE + ")",
	        directions = {
	            left: {
	                reverse: "right",
	                property: "left",
	                transition: "translatex",
	                vertical: false,
	                modifier: -1
	            },
	            right: {
	                reverse: "left",
	                property: "left",
	                transition: "translatex",
	                vertical: false,
	                modifier: 1
	            },
	            down: {
	                reverse: "up",
	                property: "top",
	                transition: "translatey",
	                vertical: true,
	                modifier: 1
	            },
	            up: {
	                reverse: "down",
	                property: "top",
	                transition: "translatey",
	                vertical: true,
	                modifier: -1
	            },
	            top: {
	                reverse: "bottom"
	            },
	            bottom: {
	                reverse: "top"
	            },
	            "in": {
	                reverse: "out",
	                modifier: -1
	            },
	            out: {
	                reverse: "in",
	                modifier: 1
	            },

	            vertical: {
	                reverse: "vertical"
	            },

	            horizontal: {
	                reverse: "horizontal"
	            }
	        };

	    kendo.directions = directions;

	    extend($.fn, {
	        kendoStop: function(clearQueue, gotoEnd) {
	            if (transitions) {
	                return fx.stopQueue(this, clearQueue || false, gotoEnd || false);
	            } else {
	                return this.stop(clearQueue, gotoEnd);
	            }
	        }
	    });

	    /* jQuery support for all transform animations (FF 3.5/3.6, Opera 10.x, IE9 */

	    if (transforms && !transitions) {
	        each(transform2d, function(idx, value) {
	            $.fn[value] = function(val) {
	                if (typeof val == "undefined") {
	                    return animationProperty(this, value);
	                } else {
	                    var that = $(this)[0],
	                        transformValue = value + "(" + val + transform2units[value.replace(unitRegExp, "")] + ")";

	                    if (that.style.cssText.indexOf(TRANSFORM) == -1) {
	                        $(this).css(TRANSFORM, transformValue);
	                    } else {
	                        that.style.cssText = that.style.cssText.replace(new RegExp(value + "\\(.*?\\)", "i"), transformValue);
	                    }
	                }
	                return this;
	            };

	            $.fx.step[value] = function (fx) {
	                $(fx.elem)[value](fx.now);
	            };
	        });

	        var curProxy = $.fx.prototype.cur;
	        $.fx.prototype.cur = function () {
	            if (transform2d.indexOf(this.prop) != -1) {
	                return parseFloat($(this.elem)[this.prop]());
	            }

	            return curProxy.apply(this, arguments);
	        };
	    }

	    kendo.toggleClass = function(element, classes, options, add) {
	        if (classes) {
	            classes = classes.split(" ");

	            if (transitions) {
	                options = extend({
	                    exclusive: "all",
	                    duration: 400,
	                    ease: "ease-out"
	                }, options);

	                element.css(TRANSITION, options.exclusive + " " + options.duration + "ms " + options.ease);
	                setTimeout(function() {
	                    element.css(TRANSITION, "").css(HEIGHT);
	                }, options.duration); // TODO: this should fire a kendoAnimate session instead.
	            }

	            each(classes, function(idx, value) {
	                element.toggleClass(value, add);
	            });
	        }

	        return element;
	    };

	    kendo.parseEffects = function(input, mirror) {
	        var effects = {};

	        if (typeof input === "string") {
	            each(input.split(" "), function(idx, value) {
	                var redirectedEffect = !singleEffectRegExp.test(value),
	                    resolved = value.replace(oldEffectsRegExp, function(match, $1, $2) {
	                        return $1 + ":" + $2.toLowerCase();
	                    }), // Support for old zoomIn/fadeOut style, now deprecated.
	                    effect = resolved.split(":"),
	                    direction = effect[1],
	                    effectBody = {};

	                if (effect.length > 1) {
	                    effectBody.direction = (mirror && redirectedEffect ? directions[direction].reverse : direction);
	                }

	                effects[effect[0]] = effectBody;
	            });
	        } else {
	            each(input, function(idx) {
	                var direction = this.direction;

	                if (direction && mirror && !singleEffectRegExp.test(idx)) {
	                    this.direction = directions[direction].reverse;
	                }

	                effects[idx] = this;
	            });
	        }

	        return effects;
	    };

	    function parseInteger(value) {
	        return parseInt(value, 10);
	    }

	    function parseCSS(element, property) {
	        return parseInteger(element.css(property));
	    }

	    function keys(obj) {
	        var acc = [];
	        for (var propertyName in obj) {
	            acc.push(propertyName);
	        }
	        return acc;
	    }

	    function strip3DTransforms(properties) {
	        for (var key in properties) {
	            if (transformProps.indexOf(key) != -1 && transform2d.indexOf(key) == -1) {
	                delete properties[key];
	            }
	        }

	        return properties;
	    }

	    function normalizeCSS(element, properties) {
	        var transformation = [], cssValues = {}, lowerKey, key, value, isTransformed;

	        for (key in properties) {
	            lowerKey = key.toLowerCase();
	            isTransformed = transforms && transformProps.indexOf(lowerKey) != -1;

	            if (!support.hasHW3D && isTransformed && transform2d.indexOf(lowerKey) == -1) {
	                delete properties[key];
	            } else {
	                value = properties[key];

	                if (isTransformed) {
	                    transformation.push(key + "(" + value + ")");
	                } else {
	                    cssValues[key] = value;
	                }
	            }
	        }

	        if (transformation.length) {
	            cssValues[TRANSFORM] = transformation.join(" ");
	        }

	        return cssValues;
	    }

	    if (transitions) {
	        extend(fx, {
	            transition: function(element, properties, options) {
	                var css,
	                    delay = 0,
	                    oldKeys = element.data("keys") || [],
	                    timeoutID;

	                options = extend({
	                        duration: 200,
	                        ease: "ease-out",
	                        complete: null,
	                        exclusive: "all"
	                    },
	                    options
	                );

	                var stopTransitionCalled = false;

	                var stopTransition = function() {
	                    if (!stopTransitionCalled) {
	                        stopTransitionCalled = true;

	                        if (timeoutID) {
	                            clearTimeout(timeoutID);
	                            timeoutID = null;
	                        }

	                        element
	                        .removeData(ABORT_ID)
	                        .dequeue()
	                        .css(TRANSITION, "")
	                        .css(TRANSITION);

	                        options.complete.call(element);
	                    }
	                };

	                options.duration = $.fx ? $.fx.speeds[options.duration] || options.duration : options.duration;

	                css = normalizeCSS(element, properties);

	                $.merge(oldKeys, keys(css));

	                if ($.hasOwnProperty("uniqueSort")) {
	                    element
	                        .data("keys", $.uniqueSort(oldKeys))
	                        .height();
	                } else {
	                    element
	                        .data("keys", $.unique(oldKeys))
	                        .height();
	                }

	                element.css(TRANSITION, options.exclusive + " " + options.duration + "ms " + options.ease).css(TRANSITION);
	                element.css(css).css(TRANSFORM);

	                /**
	                 * Use transitionEnd event for browsers who support it - but duplicate it with setTimeout, as the transitionEnd event will not be triggered if no CSS properties change.
	                 * This should be cleaned up at some point (widget by widget), and refactored to widgets not relying on the complete callback if no transition occurs.
	                 *
	                 * For IE9 and below, resort to setTimeout.
	                 */
	                if (transitions.event) {
	                    element.one(transitions.event, stopTransition);
	                    if (options.duration !== 0) {
	                        delay = 500;
	                    }
	                }

	                timeoutID = setTimeout(stopTransition, options.duration + delay);
	                element.data(ABORT_ID, timeoutID);
	                element.data(COMPLETE_CALLBACK, stopTransition);
	            },

	            stopQueue: function(element, clearQueue, gotoEnd) {
	                var cssValues,
	                    taskKeys = element.data("keys"),
	                    retainPosition = (!gotoEnd && taskKeys),
	                    completeCallback = element.data(COMPLETE_CALLBACK);

	                if (retainPosition) {
	                    cssValues = kendo.getComputedStyles(element[0], taskKeys);
	                }

	                if (completeCallback) {
	                    completeCallback();
	                }

	                if (retainPosition) {
	                    element.css(cssValues);
	                }

	                return element
	                        .removeData("keys")
	                        .stop(clearQueue);
	            }
	        });
	    }

	    function animationProperty(element, property) {
	        if (transforms) {
	            var transform = element.css(TRANSFORM);
	            if (transform == NONE) {
	                return property == "scale" ? 1 : 0;
	            }

	            var match = transform.match(new RegExp(property + "\\s*\\(([\\d\\w\\.]+)")),
	                computed = 0;

	            if (match) {
	                computed = parseInteger(match[1]);
	            } else {
	                match = transform.match(matrix3dRegExp) || [0, 0, 0, 0, 0];
	                property = property.toLowerCase();

	                if (translateXRegExp.test(property)) {
	                    computed = parseFloat(match[3] / match[2]);
	                } else if (property == "translatey") {
	                    computed = parseFloat(match[4] / match[2]);
	                } else if (property == "scale") {
	                    computed = parseFloat(match[2]);
	                } else if (property == "rotate") {
	                    computed = parseFloat(Math.atan2(match[2], match[1]));
	                }
	            }

	            return computed;
	        } else {
	            return parseFloat(element.css(property));
	        }
	    }

	    var EffectSet = kendo.Class.extend({
	        init: function(element, options) {
	            var that = this;

	            that.element = element;
	            that.effects = [];
	            that.options = options;
	            that.restore = [];
	        },

	        run: function(effects) {
	            var that = this,
	                effect,
	                idx, jdx,
	                length = effects.length,
	                element = that.element,
	                options = that.options,
	                deferred = $.Deferred(),
	                start = {},
	                end = {},
	                target,
	                children,
	                childrenLength;

	            that.effects = effects;

	            deferred.done($.proxy(that, "complete"));

	            element.data("animating", true);

	            for (idx = 0; idx < length; idx ++) {
	                effect = effects[idx];

	                effect.setReverse(options.reverse);
	                effect.setOptions(options);

	                that.addRestoreProperties(effect.restore);

	                effect.prepare(start, end);

	                children = effect.children();

	                for (jdx = 0, childrenLength = children.length; jdx < childrenLength; jdx ++) {
	                    children[jdx].duration(options.duration).run();
	                }
	            }

	            // legacy support for options.properties
	            for (var effectName in options.effects) {
	                extend(end, options.effects[effectName].properties);
	            }

	            // Show the element initially
	            if (!element.is(":visible")) {
	                extend(start, { display: element.data("olddisplay") || "block" });
	            }

	            if (transforms && !options.reset) {
	                target = element.data("targetTransform");

	                if (target) {
	                    start = extend(target, start);
	                }
	            }

	            start = normalizeCSS(element, start);

	            if (transforms && !transitions) {
	                start = strip3DTransforms(start);
	            }

	            element.css(start)
	                   .css(TRANSFORM); // Nudge

	            for (idx = 0; idx < length; idx ++) {
	                effects[idx].setup();
	            }

	            if (options.init) {
	                options.init();
	            }

	            element.data("targetTransform", end);
	            fx.animate(element, end, extend({}, options, { complete: deferred.resolve }));

	            return deferred.promise();
	        },

	        stop: function() {
	            $(this.element).kendoStop(true, true);
	        },

	        addRestoreProperties: function(restore) {
	            var element = this.element,
	                value,
	                i = 0,
	                length = restore.length;

	            for (; i < length; i ++) {
	                value = restore[i];

	                this.restore.push(value);

	                if (!element.data(value)) {
	                    element.data(value, element.css(value));
	                }
	            }
	        },

	        restoreCallback: function() {
	            var element = this.element;

	            for (var i = 0, length = this.restore.length; i < length; i ++) {
	                var value = this.restore[i];
	                element.css(value, element.data(value));
	            }
	        },

	        complete: function() {
	            var that = this,
	                idx = 0,
	                element = that.element,
	                options = that.options,
	                effects = that.effects,
	                length = effects.length;

	            element
	                .removeData("animating")
	                .dequeue(); // call next animation from the queue

	            if (options.hide) {
	                element.data("olddisplay", element.css("display")).hide();
	            }

	            this.restoreCallback();

	            if (hasZoom && !transforms) {
	                setTimeout($.proxy(this, "restoreCallback"), 0); // Again jQuery callback in IE8-
	            }

	            for (; idx < length; idx ++) {
	                effects[idx].teardown();
	            }

	            if (options.completeCallback) {
	                options.completeCallback(element);
	            }
	        }
	    });

	    fx.promise = function(element, options) {
	        var effects = [],
	            effectClass,
	            effectSet = new EffectSet(element, options),
	            parsedEffects = kendo.parseEffects(options.effects),
	            effect;

	        options.effects = parsedEffects;

	        for (var effectName in parsedEffects) {
	            effectClass = fx[capitalize(effectName)];

	            if (effectClass) {
	                effect = new effectClass(element, parsedEffects[effectName].direction);
	                effects.push(effect);
	           }
	        }

	        if (effects[0]) {
	            effectSet.run(effects);
	        } else { // Not sure how would an fx promise reach this state - means that you call kendoAnimate with no valid effects? Why?
	            if (!element.is(":visible")) {
	                element.css({ display: element.data("olddisplay") || "block" }).css("display");
	            }

	            if (options.init) {
	                options.init();
	            }

	            element.dequeue();
	            effectSet.complete();
	        }
	    };

	    extend(fx, {
	        animate: function(elements, properties, options) {
	            var useTransition = options.transition !== false;
	            delete options.transition;

	            if (transitions && "transition" in fx && useTransition) {
	                fx.transition(elements, properties, options);
	            } else {
	                if (transforms) {
	                    elements.animate(strip3DTransforms(properties), { queue: false, show: false, hide: false, duration: options.duration, complete: options.complete }); // Stop animate from showing/hiding the element to be able to hide it later on.
	                } else {
	                    elements.each(function() {
	                        var element = $(this),
	                            multiple = {};

	                        each(transformProps, function(idx, value) { // remove transforms to avoid IE and older browsers confusion
	                            var params,
	                                currentValue = properties ? properties[value]+ " " : null; // We need to match

	                            if (currentValue) {
	                                var single = properties;

	                                if (value in scaleProperties && properties[value] !== undefined) {
	                                    params = currentValue.match(cssParamsRegExp);
	                                    if (transforms) {
	                                        extend(single, { scale: +params[0] });
	                                    }
	                                } else {
	                                    if (value in translateProperties && properties[value] !== undefined) {
	                                        var position = element.css(POSITION),
	                                            isFixed = (position == "absolute" || position == "fixed");

	                                        if (!element.data(TRANSLATE)) {
	                                            if (isFixed) {
	                                                element.data(TRANSLATE, {
	                                                    top: parseCSS(element, "top") || 0,
	                                                    left: parseCSS(element, "left") || 0,
	                                                    bottom: parseCSS(element, "bottom"),
	                                                    right: parseCSS(element, "right")
	                                                });
	                                            } else {
	                                                element.data(TRANSLATE, {
	                                                    top: parseCSS(element, "marginTop") || 0,
	                                                    left: parseCSS(element, "marginLeft") || 0
	                                                });
	                                            }
	                                        }

	                                        var originalPosition = element.data(TRANSLATE);

	                                        params = currentValue.match(cssParamsRegExp);
	                                        if (params) {

	                                            var dX = value == TRANSLATE + "y" ? +null : +params[1],
	                                                dY = value == TRANSLATE + "y" ? +params[1] : +params[2];

	                                            if (isFixed) {
	                                                if (!isNaN(originalPosition.right)) {
	                                                    if (!isNaN(dX)) { extend(single, { right: originalPosition.right - dX }); }
	                                                } else {
	                                                    if (!isNaN(dX)) { extend(single, { left: originalPosition.left + dX }); }
	                                                }

	                                                if (!isNaN(originalPosition.bottom)) {
	                                                    if (!isNaN(dY)) { extend(single, { bottom: originalPosition.bottom - dY }); }
	                                                } else {
	                                                    if (!isNaN(dY)) { extend(single, { top: originalPosition.top + dY }); }
	                                                }
	                                            } else {
	                                                if (!isNaN(dX)) { extend(single, { marginLeft: originalPosition.left + dX }); }
	                                                if (!isNaN(dY)) { extend(single, { marginTop: originalPosition.top + dY }); }
	                                            }
	                                        }
	                                    }
	                                }

	                                if (!transforms && value != "scale" && value in single) {
	                                    delete single[value];
	                                }

	                                if (single) {
	                                    extend(multiple, single);
	                                }
	                            }
	                        });

	                        if (browser.msie) {
	                            delete multiple.scale;
	                        }

	                        element.animate(multiple, { queue: false, show: false, hide: false, duration: options.duration, complete: options.complete }); // Stop animate from showing/hiding the element to be able to hide it later on.
	                    });
	                }
	            }
	        }
	    });

	    fx.animatedPromise = fx.promise;

	    var Effect = kendo.Class.extend({
	        init: function(element, direction) {
	            var that = this;
	            that.element = element;
	            that._direction = direction;
	            that.options = {};
	            that._additionalEffects = [];

	            if (!that.restore) {
	                that.restore = [];
	            }
	        },

	// Public API
	        reverse: function() {
	            this._reverse = true;
	            return this.run();
	        },

	        play: function() {
	            this._reverse = false;
	            return this.run();
	        },

	        add: function(additional) {
	            this._additionalEffects.push(additional);
	            return this;
	        },

	        direction: function(value) {
	            this._direction = value;
	            return this;
	        },

	        duration: function(duration) {
	            this._duration = duration;
	            return this;
	        },

	        compositeRun: function() {
	            var that = this,
	                effectSet = new EffectSet(that.element, { reverse: that._reverse, duration: that._duration }),
	                effects = that._additionalEffects.concat([ that ]);

	            return effectSet.run(effects);
	        },

	        run: function() {
	            if (this._additionalEffects && this._additionalEffects[0]) {
	                return this.compositeRun();
	            }

	            var that = this,
	                element = that.element,
	                idx = 0,
	                restore = that.restore,
	                length = restore.length,
	                value,
	                deferred = $.Deferred(),
	                start = {},
	                end = {},
	                target,
	                children = that.children(),
	                childrenLength = children.length;

	            deferred.done($.proxy(that, "_complete"));

	            element.data("animating", true);

	            for (idx = 0; idx < length; idx ++) {
	                value = restore[idx];

	                if (!element.data(value)) {
	                    element.data(value, element.css(value));
	                }
	            }

	            for (idx = 0; idx < childrenLength; idx ++) {
	                children[idx].duration(that._duration).run();
	            }

	            that.prepare(start, end);

	            if (!element.is(":visible")) {
	                extend(start, { display: element.data("olddisplay") || "block" });
	            }

	            if (transforms) {
	                target = element.data("targetTransform");

	                if (target) {
	                    start = extend(target, start);
	                }
	            }

	            start = normalizeCSS(element, start);

	            if (transforms && !transitions) {
	                start = strip3DTransforms(start);
	            }

	            element.css(start).css(TRANSFORM); // Trick webkit into re-rendering

	            that.setup();

	            element.data("targetTransform", end);
	            fx.animate(element, end, { duration: that._duration, complete: deferred.resolve });

	            return deferred.promise();
	        },

	        stop: function() {
	            var idx = 0,
	                children = this.children(),
	                childrenLength = children.length;

	            for (idx = 0; idx < childrenLength; idx ++) {
	                children[idx].stop();
	            }

	            $(this.element).kendoStop(true, true);
	            return this;
	        },

	        restoreCallback: function() {
	            var element = this.element;

	            for (var i = 0, length = this.restore.length; i < length; i ++) {
	                var value = this.restore[i];
	                element.css(value, element.data(value));
	            }
	        },

	        _complete: function() {
	            var that = this,
	                element = that.element;

	            element
	                .removeData("animating")
	                .dequeue(); // call next animation from the queue

	            that.restoreCallback();

	            if (that.shouldHide()) {
	                element.data("olddisplay", element.css("display")).hide();
	            }

	            if (hasZoom && !transforms) {
	                setTimeout($.proxy(that, "restoreCallback"), 0); // Again jQuery callback in IE8-
	            }

	            that.teardown();
	        },

	        /////////////////////////// Support for kendo.animate;
	        setOptions: function(options) {
	            extend(true, this.options, options);
	        },

	        children: function() {
	            return [];
	        },

	        shouldHide: $.noop,

	        setup: $.noop,
	        prepare: $.noop,
	        teardown: $.noop,
	        directions: [],

	        setReverse: function(reverse) {
	            this._reverse = reverse;
	            return this;
	        }
	    });

	    function capitalize(word) {
	        return word.charAt(0).toUpperCase() + word.substring(1);
	    }

	    function createEffect(name, definition) {
	        var effectClass = Effect.extend(definition),
	            directions = effectClass.prototype.directions;

	        fx[capitalize(name)] = effectClass;

	        fx.Element.prototype[name] = function(direction, opt1, opt2, opt3) {
	            return new effectClass(this.element, direction, opt1, opt2, opt3);
	        };

	        each(directions, function(idx, theDirection) {
	            fx.Element.prototype[name + capitalize(theDirection)] = function(opt1, opt2, opt3) {
	                return new effectClass(this.element, theDirection, opt1, opt2, opt3);
	            };
	        });
	    }

	    var FOUR_DIRECTIONS = ["left", "right", "up", "down"],
	        IN_OUT = ["in", "out"];

	    createEffect("slideIn", {
	        directions: FOUR_DIRECTIONS,

	        divisor: function(value) {
	            this.options.divisor = value;
	            return this;
	        },

	        prepare: function(start, end) {
	            var that = this,
	                tmp,
	                element = that.element,
	                outerWidth = kendo._outerWidth,
	                outerHeight = kendo._outerHeight,
	                direction = directions[that._direction],
	                offset = -direction.modifier * (direction.vertical ? outerHeight(element) : outerWidth(element)),
	                startValue = offset / (that.options && that.options.divisor || 1) + PX,
	                endValue = "0px";

	            if (that._reverse) {
	                tmp = start;
	                start = end;
	                end = tmp;
	            }

	            if (transforms) {
	                start[direction.transition] = startValue;
	                end[direction.transition] = endValue;
	            } else {
	                start[direction.property] = startValue;
	                end[direction.property] = endValue;
	            }
	        }
	    });

	    createEffect("tile", {
	        directions: FOUR_DIRECTIONS,

	        init: function(element, direction, previous) {
	            Effect.prototype.init.call(this, element, direction);
	            this.options = { previous: previous };
	        },

	        previousDivisor: function(value) {
	            this.options.previousDivisor = value;
	            return this;
	        },

	        children: function() {
	            var that = this,
	                reverse = that._reverse,
	                previous = that.options.previous,
	                divisor = that.options.previousDivisor || 1,
	                dir = that._direction;

	            var children = [ kendo.fx(that.element).slideIn(dir).setReverse(reverse) ];

	            if (previous) {
	                children.push( kendo.fx(previous).slideIn(directions[dir].reverse).divisor(divisor).setReverse(!reverse) );
	            }

	            return children;
	        }
	    });

	    function createToggleEffect(name, property, defaultStart, defaultEnd) {
	        createEffect(name, {
	            directions: IN_OUT,

	            startValue: function(value) {
	                this._startValue = value;
	                return this;
	            },

	            endValue: function(value) {
	                this._endValue = value;
	                return this;
	            },

	            shouldHide: function() {
	               return this._shouldHide;
	            },

	            prepare: function(start, end) {
	                var that = this,
	                    startValue,
	                    endValue,
	                    out = this._direction === "out",
	                    startDataValue = that.element.data(property),
	                    startDataValueIsSet = !(isNaN(startDataValue) || startDataValue == defaultStart);

	                if (startDataValueIsSet) {
	                    startValue = startDataValue;
	                } else if (typeof this._startValue !== "undefined") {
	                    startValue = this._startValue;
	                } else {
	                    startValue = out ? defaultStart : defaultEnd;
	                }

	                if (typeof this._endValue !== "undefined") {
	                    endValue = this._endValue;
	                } else {
	                    endValue = out ? defaultEnd : defaultStart;
	                }

	                if (this._reverse) {
	                    start[property] = endValue;
	                    end[property] = startValue;
	                } else {
	                    start[property] = startValue;
	                    end[property] = endValue;
	                }

	                that._shouldHide = end[property] === defaultEnd;
	            }
	        });
	    }

	    createToggleEffect("fade", "opacity", 1, 0);
	    createToggleEffect("zoom", "scale", 1, 0.01);

	    createEffect("slideMargin", {
	        prepare: function(start, end) {
	            var that = this,
	                element = that.element,
	                options = that.options,
	                origin = element.data(ORIGIN),
	                offset = options.offset,
	                margin,
	                reverse = that._reverse;

	            if (!reverse && origin === null) {
	                element.data(ORIGIN, parseFloat(element.css("margin-" + options.axis)));
	            }

	            margin = (element.data(ORIGIN) || 0);
	            end["margin-" + options.axis] = !reverse ? margin + offset : margin;
	        }
	    });

	    createEffect("slideTo", {
	        prepare: function(start, end) {
	            var that = this,
	                element = that.element,
	                options = that.options,
	                offset = options.offset.split(","),
	                reverse = that._reverse;

	            if (transforms) {
	                end.translatex = !reverse ? offset[0] : 0;
	                end.translatey = !reverse ? offset[1] : 0;
	            } else {
	                end.left = !reverse ? offset[0] : 0;
	                end.top = !reverse ? offset[1] : 0;
	            }
	            element.css("left");
	        }
	    });

	    createEffect("expand", {
	        directions: ["horizontal", "vertical"],

	        restore: [ OVERFLOW ],

	        prepare: function(start, end) {
	            var that = this,
	                element = that.element,
	                options = that.options,
	                reverse = that._reverse,
	                property = that._direction === "vertical" ? HEIGHT : WIDTH,
	                setLength = element[0].style[property],
	                oldLength = element.data(property),
	                length = parseFloat(oldLength || setLength),
	                realLength = round(element.css(property, AUTO)[property]());

	            start.overflow = HIDDEN;

	            length = (options && options.reset) ? realLength || length : length || realLength;

	            end[property] = (reverse ? 0 : length) + PX;
	            start[property] = (reverse ? length : 0) + PX;

	            if (oldLength === undefined) {
	                element.data(property, setLength);
	            }
	        },

	        shouldHide: function() {
	           return this._reverse;
	        },

	        teardown: function() {
	            var that = this,
	                element = that.element,
	                property = that._direction === "vertical" ? HEIGHT : WIDTH,
	                length = element.data(property);

	            if (length == AUTO || length === BLANK) {
	                setTimeout(function() { element.css(property, AUTO).css(property); }, 0); // jQuery animate complete callback in IE is called before the last animation step!
	            }
	        }
	    });

	    var TRANSFER_START_STATE = { position: "absolute", marginLeft: 0, marginTop: 0, scale: 1 };
	    /**
	     * Intersection point formulas are taken from here - http://zonalandeducation.com/mmts/intersections/intersectionOfTwoLines1/intersectionOfTwoLines1.html
	     * Formula for a linear function from two points from here - http://demo.activemath.org/ActiveMath2/search/show.cmd?id=mbase://AC_UK_calculus/functions/ex_linear_equation_two_points
	     * The transform origin point is the intersection point of the two lines from the top left corners/top right corners of the element and target.
	     * The math and variables below MAY BE SIMPLIFIED (zeroes removed), but this would make the formula too cryptic.
	     */
	    createEffect("transfer", {
	        init: function(element, target) {
	            this.element = element;
	            this.options = { target: target };
	            this.restore = [];
	        },

	        setup: function() {
	            this.element.appendTo(document.body);
	        },

	        prepare: function(start, end) {
	            var that = this,
	                element = that.element,
	                outerBox = fx.box(element),
	                innerBox = fx.box(that.options.target),
	                currentScale = animationProperty(element, "scale"),
	                scale = fx.fillScale(innerBox, outerBox),
	                transformOrigin = fx.transformOrigin(innerBox, outerBox);

	            extend(start, TRANSFER_START_STATE);
	            end.scale = 1;

	            element.css(TRANSFORM, "scale(1)").css(TRANSFORM);
	            element.css(TRANSFORM, "scale(" + currentScale + ")");

	            start.top = outerBox.top;
	            start.left = outerBox.left;
	            start.transformOrigin = transformOrigin.x + PX + " " + transformOrigin.y + PX;

	            if (that._reverse) {
	                start.scale = scale;
	            } else {
	                end.scale = scale;
	            }
	        }
	    });


	    var CLIPS = {
	        top: "rect(auto auto $size auto)",
	        bottom: "rect($size auto auto auto)",
	        left: "rect(auto $size auto auto)",
	        right: "rect(auto auto auto $size)"
	    };

	    var ROTATIONS = {
	        top:    { start: "rotatex(0deg)", end: "rotatex(180deg)" },
	        bottom: { start: "rotatex(-180deg)", end: "rotatex(0deg)" },
	        left:   { start: "rotatey(0deg)", end: "rotatey(-180deg)" },
	        right:  { start: "rotatey(180deg)", end: "rotatey(0deg)" }
	    };

	    function clipInHalf(container, direction) {
	        var vertical = kendo.directions[direction].vertical,
	            size = (container[vertical ? HEIGHT : WIDTH]() / 2) + "px";

	        return CLIPS[direction].replace("$size", size);
	    }

	    createEffect("turningPage", {
	        directions: FOUR_DIRECTIONS,

	        init: function(element, direction, container) {
	            Effect.prototype.init.call(this, element, direction);
	            this._container = container;
	        },

	        prepare: function(start, end) {
	            var that = this,
	                reverse = that._reverse,
	                direction = reverse ? directions[that._direction].reverse : that._direction,
	                rotation = ROTATIONS[direction];

	            start.zIndex = 1;

	            if (that._clipInHalf) {
	               start.clip = clipInHalf(that._container, kendo.directions[direction].reverse);
	            }

	            start[BACKFACE] = HIDDEN;

	            end[TRANSFORM] = TRANSFORM_PERSPECTIVE + (reverse ? rotation.start : rotation.end);
	            start[TRANSFORM] = TRANSFORM_PERSPECTIVE + (reverse ? rotation.end : rotation.start);
	        },

	        setup: function() {
	            this._container.append(this.element);
	        },

	        face: function(value) {
	            this._face = value;
	            return this;
	        },

	        shouldHide: function() {
	            var that = this,
	                reverse = that._reverse,
	                face = that._face;

	            return (reverse && !face) || (!reverse && face);
	        },

	        clipInHalf: function(value) {
	            this._clipInHalf = value;
	            return this;
	        },

	        temporary: function() {
	            this.element.addClass('temp-page');
	            return this;
	        }
	    });

	    createEffect("staticPage", {
	        directions: FOUR_DIRECTIONS,

	        init: function(element, direction, container) {
	            Effect.prototype.init.call(this, element, direction);
	            this._container = container;
	        },

	        restore: ["clip"],

	        prepare: function(start, end) {
	            var that = this,
	                direction = that._reverse ? directions[that._direction].reverse : that._direction;

	            start.clip = clipInHalf(that._container, direction);
	            start.opacity = 0.999;
	            end.opacity = 1;
	        },

	        shouldHide: function() {
	            var that = this,
	                reverse = that._reverse,
	                face = that._face;

	            return (reverse && !face) || (!reverse && face);
	        },

	        face: function(value) {
	            this._face = value;
	            return this;
	        }
	    });

	    createEffect("pageturn", {
	        directions: ["horizontal", "vertical"],

	        init: function(element, direction, face, back) {
	            Effect.prototype.init.call(this, element, direction);
	            this.options = {};
	            this.options.face = face;
	            this.options.back = back;
	        },

	        children: function() {
	            var that = this,
	                options = that.options,
	                direction = that._direction === "horizontal" ? "left" : "top",
	                reverseDirection = kendo.directions[direction].reverse,
	                reverse = that._reverse,
	                temp,
	                faceClone = options.face.clone(true).removeAttr("id"),
	                backClone = options.back.clone(true).removeAttr("id"),
	                element = that.element;

	            if (reverse) {
	                temp = direction;
	                direction = reverseDirection;
	                reverseDirection = temp;
	            }

	            return [
	                kendo.fx(options.face).staticPage(direction, element).face(true).setReverse(reverse),
	                kendo.fx(options.back).staticPage(reverseDirection, element).setReverse(reverse),
	                kendo.fx(faceClone).turningPage(direction, element).face(true).clipInHalf(true).temporary().setReverse(reverse),
	                kendo.fx(backClone).turningPage(reverseDirection, element).clipInHalf(true).temporary().setReverse(reverse)
	            ];
	        },

	        prepare: function(start, end) {
	            start[PERSPECTIVE] = DEFAULT_PERSPECTIVE;
	            start.transformStyle = "preserve-3d";
	            // hack to trigger transition end.
	            start.opacity = 0.999;
	            end.opacity = 1;
	        },

	        teardown: function() {
	            this.element.find(".temp-page").remove();
	        }
	    });

	    createEffect("flip", {
	        directions: ["horizontal", "vertical"],

	        init: function(element, direction, face, back) {
	            Effect.prototype.init.call(this, element, direction);
	            this.options = {};
	            this.options.face = face;
	            this.options.back = back;
	        },

	        children: function() {
	            var that = this,
	                options = that.options,
	                direction = that._direction === "horizontal" ? "left" : "top",
	                reverseDirection = kendo.directions[direction].reverse,
	                reverse = that._reverse,
	                temp,
	                element = that.element;

	            if (reverse) {
	                temp = direction;
	                direction = reverseDirection;
	                reverseDirection = temp;
	            }

	            return [
	                kendo.fx(options.face).turningPage(direction, element).face(true).setReverse(reverse),
	                kendo.fx(options.back).turningPage(reverseDirection, element).setReverse(reverse)
	            ];
	        },

	        prepare: function(start) {
	            start[PERSPECTIVE] = DEFAULT_PERSPECTIVE;
	            start.transformStyle = "preserve-3d";
	        }
	    });

	    var RESTORE_OVERFLOW = !support.mobileOS.android;
	    var IGNORE_TRANSITION_EVENT_SELECTOR = ".km-touch-scrollbar, .km-actionsheet-wrapper";

	    createEffect("replace", {
	        _before: $.noop,
	        _after: $.noop,
	        init: function(element, previous, transitionClass) {
	            Effect.prototype.init.call(this, element);
	            this._previous = $(previous);
	            this._transitionClass = transitionClass;
	        },

	        duration: function() {
	            throw new Error("The replace effect does not support duration setting; the effect duration may be customized through the transition class rule");
	        },

	        beforeTransition: function(callback) {
	            this._before = callback;
	            return this;
	        },

	        afterTransition: function(callback) {
	            this._after = callback;
	            return this;
	        },

	        _both: function() {
	            return $().add(this._element).add(this._previous);
	        },

	        _containerClass: function() {
	            var direction = this._direction,
	                containerClass = "k-fx k-fx-start k-fx-" + this._transitionClass;

	            if (direction) {
	                containerClass += " k-fx-" + direction;
	            }

	            if (this._reverse) {
	                containerClass += " k-fx-reverse";
	            }

	            return containerClass;
	        },

	        complete: function(e) {
	            if (!this.deferred || (e && $(e.target).is(IGNORE_TRANSITION_EVENT_SELECTOR))) {
	                return;
	            }

	            var container = this.container;

	            container
	                .removeClass("k-fx-end")
	                .removeClass(this._containerClass())
	                .off(transitions.event, this.completeProxy);

	            this._previous.hide().removeClass("k-fx-current");
	            this.element.removeClass("k-fx-next");

	            if (RESTORE_OVERFLOW) {
	                container.css(OVERFLOW, "");
	            }

	            if (!this.isAbsolute) {
	                this._both().css(POSITION, "");
	            }

	            this.deferred.resolve();
	            delete this.deferred;
	        },

	        run: function() {
	            if (this._additionalEffects && this._additionalEffects[0]) {
	                return this.compositeRun();
	            }

	            var that = this,
	                element = that.element,
	                previous = that._previous,
	                container = element.parents().filter(previous.parents()).first(),
	                both = that._both(),
	                deferred = $.Deferred(),
	                originalPosition = element.css(POSITION),
	                originalOverflow;

	            // edge case for grid/scheduler, where the previous is already destroyed.
	            if (!container.length) {
	                container = element.parent();
	            }

	            this.container = container;
	            this.deferred = deferred;
	            this.isAbsolute = originalPosition  == "absolute";

	            if (!this.isAbsolute) {
	                both.css(POSITION, "absolute");
	            }

	            if (RESTORE_OVERFLOW) {
	                originalOverflow = container.css(OVERFLOW);
	                container.css(OVERFLOW, "hidden");
	            }

	            if (!transitions) {
	                this.complete();
	            } else {
	                element.addClass("k-fx-hidden");

	                container.addClass(this._containerClass());

	                this.completeProxy = $.proxy(this, "complete");
	                container.on(transitions.event, this.completeProxy);

	                kendo.animationFrame(function() {
	                    element.removeClass("k-fx-hidden").addClass("k-fx-next");
	                    previous.css("display", "").addClass("k-fx-current");
	                    that._before(previous, element);
	                    kendo.animationFrame(function() {
	                        container.removeClass("k-fx-start").addClass("k-fx-end");
	                        that._after(previous, element);
	                    });
	                });
	            }

	            return deferred.promise();
	        },

	        stop: function() {
	            this.complete();
	        }
	    });

	    var Animation = kendo.Class.extend({
	        init: function() {
	            var that = this;
	            that._tickProxy = proxy(that._tick, that);
	            that._started = false;
	        },

	        tick: $.noop,
	        done: $.noop,
	        onEnd: $.noop,
	        onCancel: $.noop,

	        start: function() {
	            if (!this.enabled()) {
	                return;
	            }

	            if (!this.done()) {
	                this._started = true;
	                kendo.animationFrame(this._tickProxy);
	            } else {
	                this.onEnd();
	            }
	        },

	        enabled: function() {
	            return true;
	        },

	        cancel: function() {
	            this._started = false;
	            this.onCancel();
	        },

	        _tick: function() {
	            var that = this;
	            if (!that._started) { return; }

	            that.tick();

	            if (!that.done()) {
	                kendo.animationFrame(that._tickProxy);
	            } else {
	                that._started = false;
	                that.onEnd();
	            }
	        }
	    });

	    var Transition = Animation.extend({
	        init: function(options) {
	            var that = this;
	            extend(that, options);
	            Animation.fn.init.call(that);
	        },

	        done: function() {
	            return this.timePassed() >= this.duration;
	        },

	        timePassed: function() {
	            return Math.min(this.duration, (new Date()) - this.startDate);
	        },

	        moveTo: function(options) {
	            var that = this,
	                movable = that.movable;

	            that.initial = movable[that.axis];
	            that.delta = options.location - that.initial;

	            that.duration = typeof options.duration == "number" ? options.duration : 300;

	            that.tick = that._easeProxy(options.ease);

	            that.startDate = new Date();
	            that.start();
	        },

	        _easeProxy: function(ease) {
	            var that = this;

	            return function() {
	                that.movable.moveAxis(that.axis, ease(that.timePassed(), that.initial, that.delta, that.duration));
	            };
	        }
	    });

	    extend(Transition, {
	        easeOutExpo: function (t, b, c, d) {
	            return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
	        },

	        easeOutBack: function (t, b, c, d, s) {
	            s = 1.70158;
	            return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
	        }
	    });

	    fx.Animation = Animation;
	    fx.Transition = Transition;
	    fx.createEffect = createEffect;

	    fx.box = function(element) {
	        element = $(element);
	        var result = element.offset();
	        result.width = kendo._outerWidth(element);
	        result.height = kendo._outerHeight(element);
	        return result;
	    };

	    fx.transformOrigin = function(inner, outer) {
	        var x = (inner.left - outer.left) * outer.width / (outer.width - inner.width),
	            y = (inner.top - outer.top) * outer.height / (outer.height - inner.height);

	        return {
	            x: isNaN(x) ? 0 : x,
	            y: isNaN(y) ? 0 : y
	        };
	    };

	    fx.fillScale = function(inner, outer) {
	        return Math.min(inner.width / outer.width, inner.height / outer.height);
	    };

	    fx.fitScale = function(inner, outer) {
	        return Math.max(inner.width / outer.width, inner.height / outer.height);
	    };
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "E+tE":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1279);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1280) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "imagebrowser",
	    name: "ImageBrowser",
	    category: "web",
	    description: "",
	    hidden: true,
	    depends: [ "filebrowser" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        FileBrowser = kendo.ui.FileBrowser,
	        isPlainObject = $.isPlainObject,
	        proxy = $.proxy,
	        extend = $.extend,
	        browser = kendo.support.browser,
	        isFunction = kendo.isFunction,
	        trimSlashesRegExp = /(^\/|\/$)/g,
	        ERROR = "error",
	        NS = ".kendoImageBrowser",
	        NAMEFIELD = "name",
	        SIZEFIELD = "size",
	        TYPEFIELD = "type",
	        DEFAULTSORTORDER = { field: TYPEFIELD, dir: "asc" },
	        EMPTYTILE = kendo.template('<div class="k-listview-item k-listview-item-empty"><span class="k-file-preview"><span class="k-file-icon k-icon k-i-none"></span></span><span class="k-file-name">${text}</span></div>');

	    extend(true, kendo.data, {
	        schemas: {
	            "imagebrowser": {
	                data: function(data) {
	                    return data.items || data || [];
	                },
	                model: {
	                    id: "name",
	                    fields: {
	                        name: "name",
	                        size: "size",
	                        type: "type"
	                    }
	                }
	            }
	        }
	    });

	    extend(true, kendo.data, {
	        transports: {
	            "imagebrowser": kendo.data.RemoteTransport.extend({
	                init: function(options) {
	                    kendo.data.RemoteTransport.fn.init.call(this, $.extend(true, {}, this.options, options));
	                },
	                _call: function(type, options) {
	                    options.data = $.extend({}, options.data, { path: this.options.path() });

	                    if (isFunction(this.options[type])) {
	                        this.options[type].call(this, options);
	                    } else {
	                        kendo.data.RemoteTransport.fn[type].call(this, options);
	                    }
	                },
	                read: function(options) {
	                    this._call("read", options);
	                },
	                create: function(options) {
	                    this._call("create", options);
	                },
	                destroy: function(options) {
	                    this._call("destroy", options);
	                },
	                update: function() {
	                    //updates are handled by the upload
	                },
	                options: {
	                    read: {
	                        type: "POST"
	                    },
	                    update: {
	                        type: "POST"
	                    },
	                    create: {
	                        type: "POST"
	                    },
	                    destroy: {
	                        type: "POST"
	                    }
	                }
	            })
	        }
	    });

	    var offsetTop;
	    if (browser.msie && browser.version < 8) {
	        offsetTop = function (element) {
	            return element.offsetTop;
	        };
	    } else {
	        offsetTop = function (element) {
	            return element.offsetTop - $(element).height();
	        };
	    }

	    function concatPaths(path, name) {
	        if(path === undefined || !path.match(/\/$/)) {
	            path = (path || "") + "/";
	        }
	        return path + name;
	    }

	    function sizeFormatter(value) {
	        if(!value) {
	            return "";
	        }

	        var suffix = " bytes";

	        if (value >= 1073741824) {
	            suffix = " GB";
	            value /= 1073741824;
	        } else if (value >= 1048576) {
	            suffix = " MB";
	            value /= 1048576;
	        } else  if (value >= 1024) {
	            suffix = " KB";
	            value /= 1024;
	        }

	        return Math.round(value * 100) / 100 + suffix;
	    }

	    var ImageBrowser = FileBrowser.extend({
	        init: function(element, options) {
	            var that = this;

	            options = options || {};

	            FileBrowser.fn.init.call(that, element, options);

	            that.element.addClass("k-imagebrowser");
	        },

	        options: {
	            name: "ImageBrowser",
	            fileTypes: "*.png,*.gif,*.jpg,*.jpeg"
	        },

	        value: function () {
	            var that = this,
	                selected = that._selectedItem(),
	                path,
	                imageUrl = that.options.transport.imageUrl;

	            if (selected && selected.get(TYPEFIELD) === "f") {
	                path = concatPaths(that.path(), selected.get(NAMEFIELD)).replace(trimSlashesRegExp, "");
	                if (imageUrl) {
	                    path = isFunction(imageUrl) ? imageUrl(path) : kendo.format(imageUrl, encodeURIComponent(path));
	                }
	                return path;
	            }
	        },

	        _fileUpload: function(e) {
	            var that = this,
	                options = that.options,
	                fileTypes = options.fileTypes,
	                filterRegExp = new RegExp(("(" + fileTypes.split(",").join(")|(") + ")").replace(/\*\./g , ".*."), "i"),
	                fileName = e.files[0].name,
	                fileSize = e.files[0].size,
	                fileNameField = NAMEFIELD,
	                sizeField = SIZEFIELD,
	                file;

	            if (filterRegExp.test(fileName)) {
	                e.data = { path: that.path() };

	                file = that._createFile(fileName, fileSize);

	                if (!file) {
	                    e.preventDefault();
	                } else {
	                    file._uploading = true;

	                    that.upload.one("error", function() {
	                        file = undefined;
	                    });

	                    that.upload.one("success", function(e) {
	                        if (file) {
	                            delete file._uploading;

	                            var model = that._insertFileToList(file);

	                            model.set(fileNameField, e.response[that._getFieldName(fileNameField)]);
	                            model.set(sizeField, e.response[that._getFieldName(sizeField)]);

	                            that._tiles = that.listView.items().filter("[" + kendo.attr("type") + "=f]");
	                            that._scroll();
	                        }
	                    });
	                }
	            } else {
	                e.preventDefault();
	                that._showMessage(kendo.format(options.messages.invalidFileType, fileName, fileTypes));
	            }
	        },

	        _content: function() {
	            var that = this;

	            that.list = $('<div class="k-filemanager-listview" />')
	                .appendTo(that.element)
	                .on("dblclick" + NS, ".k-listview-item", proxy(that._dblClick, that));

	            that.listView = new kendo.ui.ListView(that.list, {
	                layout: "flex",
	                flex: {
	                    direction: "row",
	                    wrap: "wrap"
	                },
	                dataSource: that.dataSource,
	                template: that._itemTmpl(),
	                editTemplate: that._editTmpl(),
	                selectable: true,
	                autoBind: false,
	                dataBinding: function(e) {

	                    that.toolbar.find(".k-i-close").parent().addClass("k-state-disabled");

	                    if (e.action === "remove" || e.action === "sync") {
	                        e.preventDefault();
	                        kendo.ui.progress(that.listView.content, false);
	                    }
	                },
	                dataBound: function() {
	                    if (that.dataSource.view().length) {
	                        that._tiles = this.items().filter("[" + kendo.attr("type") + "=f]");
	                        that._scroll();
	                    } else {
	                        this.content.append(EMPTYTILE({ text: that.options.messages.emptyFolder }));
	                    }
	                },
	                change: proxy(that._listViewChange, that)
	            });

	            that.listView.content.on("scroll" + NS, proxy(that._scroll, that));
	        },

	        _dataSource: function() {
	            var that = this,
	                options = that.options,
	                transport = options.transport,
	                typeSortOrder = extend({}, DEFAULTSORTORDER),
	                nameSortOrder = { field: NAMEFIELD, dir: "asc" },
	                schema,
	                dataSource = {
	                    type: transport.type || "imagebrowser",
	                    sort: [typeSortOrder, nameSortOrder]
	                };

	            if (isPlainObject(transport)) {
	                transport.path = proxy(that.path, that);
	                dataSource.transport = transport;
	            }

	            if (isPlainObject(options.schema)) {
	                dataSource.schema = options.schema;
	            } else if (transport.type && isPlainObject(kendo.data.schemas[transport.type])) {
	                schema = kendo.data.schemas[transport.type];
	            }

	            if (that.dataSource && that._errorHandler) {
	                that.dataSource.unbind(ERROR, that._errorHandler);
	            } else {
	                that._errorHandler = proxy(that._error, that);
	            }

	            that.dataSource = kendo.data.DataSource.create(dataSource)
	                .bind(ERROR, that._errorHandler);
	        },

	        _loadImage: function(li) {
	            var that = this,
	                element = $(li),
	                dataItem = that.dataSource.getByUid(element.attr(kendo.attr("uid"))),
	                name = dataItem.get(NAMEFIELD),
	                thumbnailUrl = that.options.transport.thumbnailUrl,
	                img = $("<img />", { alt: name }),
	                urlJoin = "?";

	            if (dataItem._uploading) {
	                return;
	            }

	            img.hide()
	               .on("load" + NS, function() {
	                   $(this).prev().remove().end().addClass("k-image k-file-image").fadeIn();
	               });

	            element.find(".k-i-loading").after(img);

	            if (isFunction(thumbnailUrl)) {
	                thumbnailUrl = thumbnailUrl(that.path(), encodeURIComponent(name));
	            } else {
	                if (thumbnailUrl.indexOf("?") >= 0) {
	                    urlJoin = "&";
	                }

	                thumbnailUrl = thumbnailUrl + urlJoin + "path=" + encodeURIComponent(that.path() + name);
	                if (dataItem._override) {
	                    thumbnailUrl += "&_=" + new Date().getTime();
	                    delete dataItem._override;
	                }
	            }

	            // IE8 will trigger the load event immediately when the src is assigned
	            // if the image is loaded from the cache
	            img.attr("src", thumbnailUrl);

	            li.loaded = true;
	        },

	        _scroll: function() {
	            var that = this;
	            if (that.options.transport && that.options.transport.thumbnailUrl) {
	                clearTimeout(that._timeout);

	                that._timeout = setTimeout(function() {

	                    var height = kendo._outerHeight(that.listView.content),
	                        viewTop = that.listView.content.scrollTop(),
	                        viewBottom = viewTop + height;

	                    that._tiles.each(function() {
	                        var top = offsetTop(this),
	                            bottom = top + this.offsetHeight;

	                        if ((top >= viewTop && top < viewBottom) || (bottom >= viewTop && bottom < viewBottom)) {
	                            that._loadImage(this);
	                        }

	                        if (top > viewBottom) {
	                            return false;
	                        }
	                    });

	                    that._tiles = that._tiles.filter(function() {
	                        return !this.loaded;
	                    });

	                }, 250);
	            }
	        },

	        _itemTmpl: function() {
	            var that = this,
	                html = '<div class="k-listview-item" ' + kendo.attr("uid") + '="#=uid#" ';

	            html += kendo.attr("type") + '="${' + TYPEFIELD + '}">';
	            html += '#if(' + TYPEFIELD + ' == "d") { #';
	            html += '<div class="k-file-preview"><span class="k-file-icon k-icon k-i-folder"></span></div>';
	            html += "#}else{#";
	            if (that.options.transport && that.options.transport.thumbnailUrl) {
	                html += '<div class="k-file-preview"><span class="k-file-icon k-icon k-i-loading"></span></div>';
	            } else {
	                html += '<div class="k-file-preview"><span class="k-file-icon k-icon k-i-file"></span></div>';
	            }
	            html += "#}#";
	            html += '<span class="k-file-name">${' + NAMEFIELD + '}</span>';
	            html += '#if(' + TYPEFIELD + ' == "f") { # <span class="k-file-size">${this.sizeFormatter(' + SIZEFIELD + ')}</span> #}#';
	            html += '</div>';

	            return proxy(kendo.template(html), { sizeFormatter: sizeFormatter } );
	        }
	    });

	    kendo.ui.plugin(ImageBrowser);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1280:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("qrfa");

/***/ })

/******/ });

/***/ }),

/***/ "E/Wy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var columnController_1 = __webpack_require__("77lH");
var context_1 = __webpack_require__("RQ1/");
var ColumnApi = (function () {
    function ColumnApi() {
    }
    ColumnApi.prototype.sizeColumnsToFit = function (gridWidth) { this.columnController.sizeColumnsToFit(gridWidth); };
    ColumnApi.prototype.setColumnGroupOpened = function (group, newValue) { this.columnController.setColumnGroupOpened(group, newValue); };
    ColumnApi.prototype.getColumnGroup = function (name, instanceId) { return this.columnController.getColumnGroup(name, instanceId); };
    ColumnApi.prototype.getOriginalColumnGroup = function (name) { return this.columnController.getOriginalColumnGroup(name); };
    ColumnApi.prototype.getDisplayNameForColumn = function (column, location) { return this.columnController.getDisplayNameForColumn(column, location); };
    ColumnApi.prototype.getDisplayNameForColumnGroup = function (columnGroup, location) { return this.columnController.getDisplayNameForColumnGroup(columnGroup, location); };
    ColumnApi.prototype.getColumn = function (key) { return this.columnController.getPrimaryColumn(key); };
    ColumnApi.prototype.setColumnState = function (columnState) { return this.columnController.setColumnState(columnState); };
    ColumnApi.prototype.getColumnState = function () { return this.columnController.getColumnState(); };
    ColumnApi.prototype.resetColumnState = function () { this.columnController.resetColumnState(); };
    ColumnApi.prototype.getColumnGroupState = function () { return this.columnController.getColumnGroupState(); };
    ColumnApi.prototype.setColumnGroupState = function (stateItems) { this.columnController.setColumnGroupState(stateItems); };
    ColumnApi.prototype.resetColumnGroupState = function () { this.columnController.resetColumnGroupState(); };
    ColumnApi.prototype.isPinning = function () { return this.columnController.isPinningLeft() || this.columnController.isPinningRight(); };
    ColumnApi.prototype.isPinningLeft = function () { return this.columnController.isPinningLeft(); };
    ColumnApi.prototype.isPinningRight = function () { return this.columnController.isPinningRight(); };
    ColumnApi.prototype.getDisplayedColAfter = function (col) { return this.columnController.getDisplayedColAfter(col); };
    ColumnApi.prototype.getDisplayedColBefore = function (col) { return this.columnController.getDisplayedColBefore(col); };
    ColumnApi.prototype.setColumnVisible = function (key, visible) { this.columnController.setColumnVisible(key, visible); };
    ColumnApi.prototype.setColumnsVisible = function (keys, visible) { this.columnController.setColumnsVisible(keys, visible); };
    ColumnApi.prototype.setColumnPinned = function (key, pinned) { this.columnController.setColumnPinned(key, pinned); };
    ColumnApi.prototype.setColumnsPinned = function (keys, pinned) { this.columnController.setColumnsPinned(keys, pinned); };
    ColumnApi.prototype.getAllColumns = function () { return this.columnController.getAllPrimaryColumns(); };
    ColumnApi.prototype.getAllGridColumns = function () { return this.columnController.getAllGridColumns(); };
    ColumnApi.prototype.getDisplayedLeftColumns = function () { return this.columnController.getDisplayedLeftColumns(); };
    ColumnApi.prototype.getDisplayedCenterColumns = function () { return this.columnController.getDisplayedCenterColumns(); };
    ColumnApi.prototype.getDisplayedRightColumns = function () { return this.columnController.getDisplayedRightColumns(); };
    ColumnApi.prototype.getAllDisplayedColumns = function () { return this.columnController.getAllDisplayedColumns(); };
    ColumnApi.prototype.getAllDisplayedVirtualColumns = function () { return this.columnController.getAllDisplayedVirtualColumns(); };
    ColumnApi.prototype.moveColumn = function (key, toIndex) {
        if (typeof key === 'number') {
            // moveColumn used to take indexes, so this is advising user who hasn't moved to new method name
            console.log('ag-Grid: you are using moveColumn(fromIndex, toIndex) - moveColumn takes a column key and a destination index, not two indexes, to move with indexes use moveColumnByIndex(from,to) instead');
            this.columnController.moveColumnByIndex(key, toIndex);
        }
        else {
            this.columnController.moveColumn(key, toIndex);
        }
    };
    ColumnApi.prototype.moveColumnByIndex = function (fromIndex, toIndex) { this.columnController.moveColumnByIndex(fromIndex, toIndex); };
    ColumnApi.prototype.moveColumns = function (columnsToMoveKeys, toIndex) { this.columnController.moveColumns(columnsToMoveKeys, toIndex); };
    ColumnApi.prototype.moveRowGroupColumn = function (fromIndex, toIndex) { this.columnController.moveRowGroupColumn(fromIndex, toIndex); };
    ColumnApi.prototype.setColumnAggFunc = function (column, aggFunc) { this.columnController.setColumnAggFunc(column, aggFunc); };
    ColumnApi.prototype.setColumnWidth = function (key, newWidth, finished) {
        if (finished === void 0) { finished = true; }
        this.columnController.setColumnWidth(key, newWidth, finished);
    };
    ColumnApi.prototype.setPivotMode = function (pivotMode, source) {
        if (source === void 0) { source = "api"; }
        this.columnController.setPivotMode(pivotMode);
    };
    ColumnApi.prototype.isPivotMode = function () { return this.columnController.isPivotMode(); };
    ColumnApi.prototype.getSecondaryPivotColumn = function (pivotKeys, valueColKey) { return this.columnController.getSecondaryPivotColumn(pivotKeys, valueColKey); };
    ColumnApi.prototype.setValueColumns = function (colKeys) { this.columnController.setValueColumns(colKeys); };
    ColumnApi.prototype.getValueColumns = function () { return this.columnController.getValueColumns(); };
    ColumnApi.prototype.removeValueColumn = function (colKey) { this.columnController.removeValueColumn(colKey); };
    ColumnApi.prototype.removeValueColumns = function (colKeys) { this.columnController.removeValueColumns(colKeys); };
    ColumnApi.prototype.addValueColumn = function (colKey) { this.columnController.addValueColumn(colKey); };
    ColumnApi.prototype.addValueColumns = function (colKeys) { this.columnController.addValueColumns(colKeys); };
    ColumnApi.prototype.setRowGroupColumns = function (colKeys) { this.columnController.setRowGroupColumns(colKeys); };
    ColumnApi.prototype.removeRowGroupColumn = function (colKey) { this.columnController.removeRowGroupColumn(colKey); };
    ColumnApi.prototype.removeRowGroupColumns = function (colKeys) { this.columnController.removeRowGroupColumns(colKeys); };
    ColumnApi.prototype.addRowGroupColumn = function (colKey) { this.columnController.addRowGroupColumn(colKey); };
    ColumnApi.prototype.addRowGroupColumns = function (colKeys) { this.columnController.addRowGroupColumns(colKeys); };
    ColumnApi.prototype.getRowGroupColumns = function () { return this.columnController.getRowGroupColumns(); };
    ColumnApi.prototype.setPivotColumns = function (colKeys) { this.columnController.setPivotColumns(colKeys); };
    ColumnApi.prototype.removePivotColumn = function (colKey) { this.columnController.removePivotColumn(colKey); };
    ColumnApi.prototype.removePivotColumns = function (colKeys) { this.columnController.removePivotColumns(colKeys); };
    ColumnApi.prototype.addPivotColumn = function (colKey) { this.columnController.addPivotColumn(colKey); };
    ColumnApi.prototype.addPivotColumns = function (colKeys) { this.columnController.addPivotColumns(colKeys); };
    ColumnApi.prototype.getPivotColumns = function () { return this.columnController.getPivotColumns(); };
    ColumnApi.prototype.getLeftDisplayedColumnGroups = function () { return this.columnController.getLeftDisplayedColumnGroups(); };
    ColumnApi.prototype.getCenterDisplayedColumnGroups = function () { return this.columnController.getCenterDisplayedColumnGroups(); };
    ColumnApi.prototype.getRightDisplayedColumnGroups = function () { return this.columnController.getRightDisplayedColumnGroups(); };
    ColumnApi.prototype.getAllDisplayedColumnGroups = function () { return this.columnController.getAllDisplayedColumnGroups(); };
    ColumnApi.prototype.autoSizeColumn = function (key) { return this.columnController.autoSizeColumn(key); };
    ColumnApi.prototype.autoSizeColumns = function (keys) { return this.columnController.autoSizeColumns(keys); };
    ColumnApi.prototype.autoSizeAllColumns = function () { this.columnController.autoSizeAllColumns(); };
    ColumnApi.prototype.setSecondaryColumns = function (colDefs) { this.columnController.setSecondaryColumns(colDefs); };
    // below goes through deprecated items, prints message to user, then calls the new version of the same method
    ColumnApi.prototype.columnGroupOpened = function (group, newValue) {
        console.error('ag-Grid: columnGroupOpened no longer exists, use setColumnGroupOpened');
        this.setColumnGroupOpened(group, newValue);
    };
    ColumnApi.prototype.hideColumns = function (colIds, hide) {
        console.error('ag-Grid: hideColumns is deprecated, use setColumnsVisible');
        this.columnController.setColumnsVisible(colIds, !hide);
    };
    ColumnApi.prototype.hideColumn = function (colId, hide) {
        console.error('ag-Grid: hideColumn is deprecated, use setColumnVisible');
        this.columnController.setColumnVisible(colId, !hide);
    };
    ColumnApi.prototype.setState = function (columnState) {
        console.error('ag-Grid: setState is deprecated, use setColumnState');
        return this.setColumnState(columnState);
    };
    ColumnApi.prototype.getState = function () {
        console.error('ag-Grid: getState is deprecated, use getColumnState');
        return this.getColumnState();
    };
    ColumnApi.prototype.resetState = function () {
        console.error('ag-Grid: resetState is deprecated, use resetColumnState');
        this.resetColumnState();
    };
    ColumnApi.prototype.getAggregationColumns = function () {
        console.error('ag-Grid: getAggregationColumns is deprecated, use getValueColumns');
        return this.columnController.getValueColumns();
    };
    ColumnApi.prototype.removeAggregationColumn = function (colKey) {
        console.error('ag-Grid: removeAggregationColumn is deprecated, use removeValueColumn');
        this.columnController.removeValueColumn(colKey);
    };
    ColumnApi.prototype.removeAggregationColumns = function (colKeys) {
        console.error('ag-Grid: removeAggregationColumns is deprecated, use removeValueColumns');
        this.columnController.removeValueColumns(colKeys);
    };
    ColumnApi.prototype.addAggregationColumn = function (colKey) {
        console.error('ag-Grid: addAggregationColumn is deprecated, use addValueColumn');
        this.columnController.addValueColumn(colKey);
    };
    ColumnApi.prototype.addAggregationColumns = function (colKeys) {
        console.error('ag-Grid: addAggregationColumns is deprecated, use addValueColumns');
        this.columnController.addValueColumns(colKeys);
    };
    ColumnApi.prototype.setColumnAggFunction = function (column, aggFunc) {
        console.error('ag-Grid: setColumnAggFunction is deprecated, use setColumnAggFunc');
        this.columnController.setColumnAggFunc(column, aggFunc);
    };
    ColumnApi.prototype.getDisplayNameForCol = function (column) {
        console.error('ag-Grid: getDisplayNameForCol is deprecated, use getDisplayNameForColumn');
        return this.getDisplayNameForColumn(column, null);
    };
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], ColumnApi.prototype, "columnController", void 0);
    ColumnApi = __decorate([
        context_1.Bean('columnApi')
    ], ColumnApi);
    return ColumnApi;
}());
exports.ColumnApi = ColumnApi;


/***/ }),

/***/ "E02g":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(19);
	module.exports = __webpack_require__(19);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {

	    var kendo = window.kendo;
	    var Widget = kendo.ui.Widget;
	    var extend = $.extend;
	    var proxy = $.proxy;
	    var DOT = ".";
	    var NS = ".kendoChat";
	    var keys = kendo.keys;
	    var SEND_ICON = '<svg version="1.1" ixmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" xml:space="preserve"><path d="M0,14.3c-0.1,0.6,0.3,0.8,0.8,0.6l14.8-6.5c0.5-0.2,0.5-0.6,0-0.8L0.8,1.1C0.3,0.9-0.1,1.1,0,1.7l0.7,4.2C0.8,6.5,1.4,7,1.9,7.1l8.8,0.8c0.6,0.1,0.6,0.1,0,0.2L1.9,8.9C1.4,9,0.8,9.5,0.7,10.1L0,14.3z"/></svg>';
	    var TOGGLE_ICON = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g>   <path d="M128,240c0-26.4-21.6-48-48-48s-48,21.6-48,48s21.6,48,48,48S128,266.4,128,240z"/>   <path d="M192,240c0,26.4,21.6,48,48,48c26.4,0,48-21.6,48-48s-21.6-48-48-48C213.6,192,192,213.6,192,240z"/>   <path d="M352,240c0,26.4,21.6,48,48,48c26.4,0,48-21.6,48-48s-21.6-48-48-48C373.6,192,352,213.6,352,240z"/></g></svg>';

	    var messageBoxStyles = {
	        input: "k-input",
	        button: "k-button",
	        buttonFlat: "k-flat",
	        buttonIcon: "k-button-icon",
	        buttonSend: "k-button-send",
	        buttonToggle: "k-button-toggle",
	        iconAdd: "k-icon k-i-add",
	        hidden: "k-hidden"
	    };

	    var ChatMessageBox = Widget.extend({
	        init: function(element, options) {
	            Widget.fn.init.call(this, element, options);

	            this._wrapper();

	            this._attachEvents();

	            this._typing = false;
	        },

	        events: [
	        ],

	        options: {
	            messages: {
	                placeholder: "Type a message...",
	                toggleButton: "Toggle toolbar",
	                sendButton: "Send message"
	            }
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            if (this.input) {
	                this.input.off(NS);
	                this.input.remove();
	                this.input = null;
	            }

	            this.element.off(NS);
	            this.element.empty();
	        },

	        _wrapper: function() {
	            var styles = ChatMessageBox.styles;
	            var options = this.options;
	            var messages = options.messages;
	            var inputId = "inputId_" + kendo.guid();

	            $("<label>")
	                .addClass(styles.hidden)
	                .html(messages.placeholder)
	                .attr("for", inputId)
	                .appendTo(this.element);

	            this.input = $("<input type='text'>")
	                .addClass(styles.input)
	                .attr("id", inputId)
	                .attr("placeholder", messages.placeholder)
	                .appendTo(this.element);

	            if (options.toolbar && options.toolbar.toggleable && options.toolbar.buttons && options.toolbar.buttons.length) {
	                $("<button>")
	                    .addClass(styles.button)
	                    .addClass(styles.buttonFlat)
	                    .addClass(styles.buttonIcon)
	                    .addClass(styles.buttonToggle)
	                    .attr("type", "button")
	                    .append($(TOGGLE_ICON))
	                    .appendTo(this.element)
	                    .attr("title", messages.toggleButton)
	                    .attr("aria-label", messages.toggleButton);
	            }

	            $("<button>")
	                .addClass(styles.button)
	                .addClass(styles.buttonFlat)
	                .addClass(styles.buttonIcon)
	                .addClass(styles.buttonSend)
	                .append($(SEND_ICON))
	                .appendTo(this.element)
	                .attr("title", messages.sendButton)
	                .attr("aria-label", messages.sendButton);
	        },

	        _attachEvents: function() {
	            var styles = ChatMessageBox.styles;

	            this.input
	                .on("keydown" + NS, proxy(this._keydown, this))
	                .on("input" + NS, proxy(this._input, this))
	                .on("focusout" + NS, proxy(this._inputFocusout, this));

	            this.element
	                .on("click" + NS, DOT + styles.buttonSend, proxy(this._buttonClick, this));

	            this.element
	                .on("click" + NS, DOT + styles.buttonToggle, proxy(this._toggleToolbar, this));
	        },

	        _input: function() {
	            var currentValue = this.input.val();
	            var start = currentValue.length > 0;

	            this._triggerTyping(start);
	        },

	        _keydown: function(e) {
	            var key = e.keyCode;

	            switch (key) {
	                case keys.ENTER:
	                    e.preventDefault();

	                    this._sendMessage();
	                    break;
	            }
	        },

	        _buttonClick: function(e) {
	            e.preventDefault();

	            this._sendMessage();
	        },

	        _sendMessage: function() {
	            var value = this.input.val();

	            if (!value.length) {
	                return;
	            }

	            this._triggerTyping(false);

	            var args = {
	                text: value
	            };

	            this.trigger("sendMessage", args);

	            this.input.val("");
	        },

	        _inputFocusout: function() {
	            this._triggerTyping(false);
	        },

	        _triggerTyping: function(start) {
	            if (start) {
	                if (!this._typing) {
	                    this.trigger("typingStart", {});
	                    this._typing = true;
	                }
	            } else {
	                if (this._typing) {
	                    this.trigger("typingEnd", {});
	                    this._typing = false;
	                }
	            }
	        },

	        _toggleToolbar: function (ev) {
	            this.trigger("toggleToolbar", { originalEvent: ev });
	        }
	    });

	    extend(true, ChatMessageBox, { styles: messageBoxStyles });
	    extend(kendo, {
	        chat: {
	            ChatMessageBox: ChatMessageBox
	        }
	    });
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ })

/******/ });

/***/ }),

/***/ "E1oU":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1156);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1156:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1157), __webpack_require__(1158) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "dataviz.stockchart",
	    name: "StockChart",
	    category: "dataviz",
	    description: "StockChart widget and associated financial series.",
	    depends: [ "dataviz.chart" ]
	};

	}, __webpack_require__(3));


/***/ }),

/***/ 1157:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("rdB9");

/***/ }),

/***/ 1158:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("86I2");

/***/ })

/******/ });

/***/ }),

/***/ "EBHW":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(972);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(973) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {

	var kendo = window.kendo,
	    extend = $.extend,
	    proxy = $.proxy,
	    Editor = kendo.ui.editor,
	    EditorUtils = Editor.EditorUtils,
	    Command = Editor.Command,
	    Tool = Editor.Tool,
	    registerTool = EditorUtils.registerTool,
	    ToolTemplate = Editor.ToolTemplate,
	    defaultExportAsItems = [
	        { text: 'Docx', value: 'docx' },
	        { text: 'Rtf', value: 'rtf' },
	        { text: 'Pdf', value: 'pdf' },
	        { text: 'Html', value: 'html' },
	        { text: 'Plain Text', value: 'txt' }
	    ];

	var ExportAsCommand = Command.extend({
	    init: function(options) {
	        var cmd = this;
	        cmd.options = options;
	        Command.fn.init.call(cmd, options);
	        cmd.attributes = null;
	        cmd.exportType = options.exportType;
	    },

	    exec: function() {
	        var cmd = this;
	        var range = this.lockRange(true);
	        cmd.postToProxy();
	        cmd.releaseRange(range);
	    },

	    postToProxy: function() {
	        this.generateForm().appendTo('body').submit().remove();
	    },

	    generateForm: function() {
	        var cmd = this;
	        var exportAsOptions = cmd.editor.options.exportAs;
	        var form = $('<form>').attr({
	            action: exportAsOptions && exportAsOptions.proxyURL || "",
	            method: 'POST'
	        });

	        form.append([
	            cmd.valueInput(),
	            cmd.exportTypeInput(),
	            cmd.fileNameInput()
	        ]);

	        return form;
	    },

	    valueInput: function() {
	        var editor = this.editor;
	        return $('<input>').attr({
	            value: editor.encodedValue(),
	            name: 'value',
	            type: 'hidden'
	        });
	    },

	    exportTypeInput: function() {
	        var cmd = this;
	        return $('<input>').attr({
	            value: cmd.exportType,
	            name: 'exportType',
	            type: 'hidden'
	        });

	    },

	    fileNameInput: function() {
	        var editor = this.editor;
	        var exportAsOptions = editor.options.exportAs;
	        var fileName = exportAsOptions && exportAsOptions.fileName || editor.element.attr("id") || "editor";
	        return $('<input>').attr({
	            value: fileName,
	            name: 'fileName',
	            type: 'hidden'
	        });
	    }
	});

	var ExportAsTool = Tool.extend({
	    init: function(options) {
	        var tool = this;
	        Tool.fn.init.call(tool, kendo.deepExtend({}, tool.options, options));
	        tool.type = 'kendoSelectBox';
	    },

	    options: {
	        items: defaultExportAsItems,
	        width: 115
	    },

	    command: function(args) {
	        var value = args.value;
	        return new Editor.ExportAsCommand({
	            range: args.range,
	            exportType: value.exportType
	        });
	    },

	    initialize: function(ui, initOptions) {
	        var tool = this;
	        var editor = initOptions.editor;
	        var options = tool.options;
	        var toolName = options.name;
	        var changeHandler = proxy(tool.changeHandler, tool);
	        var dataSource = options.items || editor.options[toolName];
	        var selectBox;

	        dataSource.unshift({
	            text: editor.options.messages[toolName],
	            value: ""
	        });
	        tool.editor = editor;
	        ui.width(options.width);
	        selectBox = ui.kendoSelectBox({
	            dataTextField: 'text',
	            dataValueField: 'value',
	            dataSource: dataSource,
	            autoSize: true,
	            change: changeHandler,
	            open: function(e) {
	                var sender = e.sender;
	                sender.items()[0].style.display = "none";
	                sender.unbind("open");
	            },
	            highlightFirst: false,
	            template: kendo.template('<span unselectable="on" style="display:block;#=(data.style||"")#">#:data.text#</span>')
	        }).data("kendoSelectBox");

	        ui.attr("title", initOptions.title);
	        selectBox.wrapper.attr("title", initOptions.title);

	        ui.addClass('k-decorated').closest('.k-widget').removeClass('k-' + toolName).find('*').addBack().attr('unselectable', 'on');
	    },

	    changeHandler: function(e) {
	        var sender = e.sender;
	        var dataItem = sender.dataItem();
	        var value = dataItem && dataItem.value;

	        this._exec(value);
	        sender.value("");
	    },

	    _exec: function(value) {
	        if (value) {
	            Tool.exec(this.editor, this.options.name, { exportType: value } );
	        }
	    },

	    destroy: function() {
	        this._ancestor = null;
	    }
	});

	extend(Editor, {
	    ExportAsTool: ExportAsTool,
	    ExportAsCommand: ExportAsCommand
	});

	registerTool('exportAs', new ExportAsTool({
	    template: new ToolTemplate({
	        template: EditorUtils.dropDownListTemplate,
	        title: 'Export As'
	    })
	}));

	}(window.kendo.jQuery));

	}, __webpack_require__(3));


/***/ }),

/***/ 973:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2UxK");

/***/ })

/******/ });

/***/ }),

/***/ "EBTw":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1020);
	module.exports = __webpack_require__(1020);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1020:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/***********************************************************************
	 * WARNING: this file is auto-generated.  If you change it directly,
	 * your modifications will eventually be lost.  The source code is in
	 * `kendo-ooxml` repository, you should make your changes there and
	 * run `src-modules/sync.sh` in this repository.
	 */
	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(20)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {

	window.kendo.excel = window.kendo.excel || {};

	var getter = kendo.getter;
	var map = $.map;

	var current = {
	    compile: function(template) {
	        return template;
	    }
	};

	var TemplateService = kendo.Class.extend({

	});

	TemplateService.register = function(userImplementation) {
	    current = userImplementation;
	};

	TemplateService.compile = function(template) {
	    return current.compile(template);
	};

	function defaultGroupHeaderTemplate(data) {
	    return ((data.title) + ": " + (data.value));
	}

	function createArray(length, callback) {
	    var result = [];

	    for (var idx = 0; idx < length; idx++) {
	        result.push(callback(idx));
	    }

	    return result;
	}

	var ExcelExporter = kendo.Class.extend({
	    init: function(options) {
	        options.columns = this._trimColumns(options.columns || []);

	        this.allColumns = map(this._leafColumns(options.columns || []), this._prepareColumn);

	        this.columns = this.allColumns.filter(function(column) { return !column.hidden; });

	        this.options = options;
	        this.data = options.data || [];
	        this.aggregates = options.aggregates || {};
	        this.groups = [].concat(options.groups || []);
	        this.hierarchy = options.hierarchy;
	    },

	    workbook: function() {
	        var workbook = {
	            sheets: [ {
	                columns: this._columns(),
	                rows: this.hierarchy ? this._hierarchyRows() : this._rows(),
	                freezePane: this._freezePane(),
	                filter: this._filter()
	            } ]
	        };

	        return workbook;
	    },

	    _trimColumns: function(columns) {
	        var this$1 = this;

	        return columns.filter(function (column) {
	            var result = Boolean(column.field);

	            if (!result && column.columns) {
	                result = this$1._trimColumns(column.columns).length > 0;
	            }

	            return result;
	        });
	    },

	    _leafColumns: function(columns) {
	        var this$1 = this;

	        var result = [];

	        for (var idx = 0; idx < columns.length; idx++) {
	            if (!columns[idx].columns) {
	                result.push(columns[idx]);
	            } else {
	                result = result.concat(this$1._leafColumns(columns[idx].columns));
	            }
	        }

	        return result;
	    },

	    _prepareColumn: function(column) {
	        if (!column.field) {
	            return null;
	        }

	        var value = function(dataItem) {
	            return getter(column.field, true)(dataItem);
	        };

	        var values = null;

	        if (column.values) {
	            values = {};

	            column.values.forEach(function(item) {
	                values[item.value] = item.text;
	            });

	            value = function(dataItem) {
	                return values[getter(column.field, true)(dataItem)];
	            };
	        }

	        return $.extend({}, column, {
	            value: value,
	            values: values,
	            groupHeaderTemplate: column.groupHeaderTemplate ? TemplateService.compile(column.groupHeaderTemplate) : defaultGroupHeaderTemplate,
	            groupFooterTemplate: column.groupFooterTemplate ? TemplateService.compile(column.groupFooterTemplate) : null,
	            footerTemplate: column.footerTemplate ? TemplateService.compile(column.footerTemplate) : null
	        });
	    },

	    _filter: function() {
	        if (!this.options.filterable) {
	            return null;
	        }

	        var depth = this._depth();

	        return {
	            from: depth,
	            to: depth + this.columns.length - 1
	        };
	    },

	    _createPaddingCells: function(length) {
	        var this$1 = this;

	        return createArray(length, function () { return $.extend({
	            background: "#dfdfdf",
	            color: "#333"
	        }, this$1.options.paddingCellOptions); });
	    },

	    _dataRow: function(dataItem, level, depth) {
	        var this$1 = this;

	        var cells = this._createPaddingCells(level);

	        // grouped
	        if (depth && dataItem.items) {
	            var column = this.allColumns.filter(function(column) {
	                return column.field === dataItem.field;
	            })[0];

	            var title = column && column.title ? column.title : dataItem.field;
	            var template = column ? column.groupHeaderTemplate : null;
	            var group = $.extend({
	                title: title,
	                field: dataItem.field,
	                value: column && column.values ? column.values[dataItem.value] : dataItem.value,
	                aggregates: dataItem.aggregates,
	                items: dataItem.items
	            }, dataItem.aggregates[dataItem.field]);

	            var value = title + ": " + (dataItem.value);

	            if (template) {
	                value = template(group);
	            }

	            cells.push($.extend({
	                value: value,
	                background: "#dfdfdf",
	                color: "#333",
	                colSpan: this.columns.length + depth - level
	            }, (column || {}).groupHeaderCellOptions));

	            var rows = this._dataRows(dataItem.items, level + 1);

	            rows.unshift({
	                type: "group-header",
	                cells: cells,
	                level: this.options.collapsible ? level : null
	            });

	            return rows.concat(this._footer(dataItem, level));
	        }

	        var dataCells = [];

	        for (var cellIdx = 0; cellIdx < this.columns.length; cellIdx++) {
	            dataCells[cellIdx] = this$1._cell(dataItem, this$1.columns[cellIdx]);
	        }

	        if (this.hierarchy) {
	            dataCells[0].colSpan = depth - level + 1;
	        }

	        return [ {
	            type: "data",
	            cells: cells.concat(dataCells),
	            level: this.options.collapsible ? level : null
	        } ];
	    },

	    _dataRows: function(dataItems, level) {
	        var this$1 = this;

	        var depth = this._depth();
	        var rows = [];

	        for (var idx = 0; idx < dataItems.length; idx++) {
	            rows.push.apply(rows, this$1._dataRow(dataItems[idx], level, depth));
	        }

	        return rows;
	    },

	    _hierarchyRows: function() {
	        var this$1 = this;

	        var depth = this._depth();
	        var data = this.data;
	        var itemLevel = this.hierarchy.itemLevel;
	        var hasFooter = this._hasFooterTemplate();
	        var rows = [];
	        var parents = [];
	        var previousLevel = 0;
	        var previousItemId;

	        for (var idx = 0; idx < data.length; idx++) {
	            var item = data[idx];
	            var level = itemLevel(item);

	            if (hasFooter) {
	                if (level > previousLevel) {
	                    parents.push({ id: previousItemId, level: previousLevel });
	                } else if (level < previousLevel) {
	                    rows.push.apply(rows, this$1._hierarchyFooterRows(parents, level, depth));
	                }

	                previousLevel = level;
	                previousItemId = item.id;
	            }

	            rows.push.apply(rows, this$1._dataRow(item, level + 1, depth));
	        }

	        if (hasFooter) {
	            rows.push.apply(rows, this._hierarchyFooterRows(parents, 0, depth));

	            var rootAggregate = data.length ? this.aggregates[data[0].parentId] : {};
	            rows.push(this._hierarchyFooter(rootAggregate, 0, depth));
	        }

	        this._prependHeaderRows(rows);

	        return rows;
	    },

	    _hierarchyFooterRows: function(parents, currentLevel, depth) {
	        var this$1 = this;

	        var rows = [];
	        while (parents.length && parents[parents.length - 1].level >= currentLevel) {
	            var parent = parents.pop();
	            rows.push(this$1._hierarchyFooter(this$1.aggregates[parent.id], parent.level + 1, depth));
	        }

	        return rows;
	    },

	    _hasFooterTemplate: function() {
	        var columns = this.columns;
	        for (var idx = 0; idx < columns.length; idx++) {
	            if (columns[idx].footerTemplate) {
	                return true;
	            }
	        }
	    },

	    _hierarchyFooter: function(aggregates, level, depth) {
	        var cells = this.columns.map(function(column, index) {
	            var colSpan = index ? 1 : depth - level + 1;
	            if (column.footerTemplate) {
	                return $.extend({
	                    background: "#dfdfdf",
	                    color: "#333",
	                    colSpan: colSpan,
	                    value: column.footerTemplate($.extend({}, (aggregates || {})[column.field]))
	                }, column.footerCellOptions);
	            }

	            return $.extend({
	                background: "#dfdfdf",
	                color: "#333",
	                colSpan: colSpan
	            }, column.footerCellOptions);
	        });

	        return {
	            type: "footer",
	            cells: this._createPaddingCells(level).concat(cells)
	        };
	    },

	    _footer: function(dataItem, level) {
	        var rows = [];
	        var footer = this.columns.some(function (column) { return column.groupFooterTemplate; });

	        var templateData, group;
	        if (footer) {
	            group = {
	                group: { items: dataItem.items,
	                         field: dataItem.field,
	                         value: dataItem.value }
	            };
	            templateData = {};
	            Object.keys(dataItem.aggregates).forEach(function (key) {
	                templateData[key] = $.extend({}, dataItem.aggregates[key], group);
	            });
	        }

	        var cells = this.columns.map(function (column) {
	            if (column.groupFooterTemplate) {
	                var data = $.extend({}, templateData, dataItem.aggregates[column.field], group);
	                return $.extend({
	                    background: "#dfdfdf",
	                    color: "#333",
	                    value: column.groupFooterTemplate(data)
	                }, column.groupFooterCellOptions);
	            }

	            return $.extend({
	                background: "#dfdfdf",
	                color: "#333"
	            }, column.groupFooterCellOptions);
	        });

	        if (footer) {
	            rows.push({
	                type: "group-footer",
	                cells: this._createPaddingCells(this.groups.length).concat(cells),
	                level: this.options.collapsible ? level : null
	            });
	        }

	        return rows;
	    },

	    _isColumnVisible: function(column) {
	        return this._visibleColumns([ column ]).length > 0 && (column.field || column.columns);
	    },

	    _visibleColumns: function(columns) {
	        var this$1 = this;

	        return columns.filter(function (column) {
	            var result = !column.hidden;
	            if (result && column.columns) {
	                result = this$1._visibleColumns(column.columns).length > 0;
	            }
	            return result;
	        });
	    },

	    _headerRow: function(row, groups) {
	        var this$1 = this;

	        var headers = row.cells.map(function(cell) {
	            return $.extend(cell, {
	                colSpan: cell.colSpan > 1 ? cell.colSpan : 1,
	                rowSpan: row.rowSpan > 1 && !cell.colSpan ? row.rowSpan : 1
	            });
	        });

	        if (this.hierarchy) {
	            headers[0].colSpan = this._depth() + 1;
	        }

	        return {
	            type: "header",
	            cells: createArray(groups.length, function () { return $.extend({
	                background: "#7a7a7a",
	                color: "#fff"
	            }, this$1.options.headerPaddingCellOptions); }).concat(headers)
	        };
	    },

	    _prependHeaderRows: function(rows) {
	        var this$1 = this;

	        var groups = this.groups;

	        var headerRows = [ { rowSpan: 1, cells: [], index: 0 } ];

	        this._prepareHeaderRows(headerRows, this.options.columns);

	        for (var idx = headerRows.length - 1; idx >= 0; idx--) {
	            rows.unshift(this$1._headerRow(headerRows[idx], groups));
	        }
	    },

	    _prepareHeaderRows: function(rows, columns, parentCell, parentRow) {
	        var this$1 = this;

	        var row = parentRow || rows[rows.length - 1];
	        var childRow = rows[row.index + 1];
	        var totalColSpan = 0;

	        for (var idx = 0; idx < columns.length; idx++) {
	            var column = columns[idx];
	            if (this$1._isColumnVisible(column)) {

	                var cell = $.extend({
	                    background: "#7a7a7a",
	                    color: "#fff",
	                    value: column.title || column.field,
	                    colSpan: 0
	                }, column.headerCellOptions);
	                row.cells.push(cell);

	                if (column.columns && column.columns.length) {
	                    if (!childRow) {
	                        childRow = { rowSpan: 0, cells: [], index: rows.length };
	                        rows.push(childRow);
	                    }
	                    cell.colSpan = this$1._trimColumns(this$1._visibleColumns(column.columns)).length;
	                    this$1._prepareHeaderRows(rows, column.columns, cell, childRow);
	                    totalColSpan += cell.colSpan - 1;
	                    row.rowSpan = rows.length - row.index;
	                }
	            }
	        }

	        if (parentCell) {
	            parentCell.colSpan += totalColSpan;
	        }
	    },

	    _rows: function() {
	        var this$1 = this;

	        var rows = this._dataRows(this.data, 0);

	        if (this.columns.length) {
	            this._prependHeaderRows(rows);
	            var footer = false;

	            var cells = this.columns.map(function (column) {
	                if (column.footerTemplate) {
	                    footer = true;

	                    return $.extend({
	                        background: "#dfdfdf",
	                        color: "#333",
	                        value: column.footerTemplate($.extend({}, this$1.aggregates, this$1.aggregates[column.field]))
	                    }, column.footerCellOptions);
	                }

	                return $.extend({
	                    background: "#dfdfdf",
	                    color: "#333"
	                }, column.footerCellOptions);
	            });

	            if (footer) {
	                rows.push({
	                    type: "footer",
	                    cells: this._createPaddingCells(this.groups.length).concat(cells)
	                });
	            }
	        }

	        return rows;
	    },

	    _headerDepth: function(columns) {
	        var this$1 = this;

	        var result = 1;
	        var max = 0;

	        for (var idx = 0; idx < columns.length; idx++) {
	            if (columns[idx].columns) {
	                var temp = this$1._headerDepth(columns[idx].columns);
	                if (temp > max) {
	                    max = temp;
	                }
	            }
	        }
	        return result + max;
	    },

	    _freezePane: function() {
	        var columns = this._visibleColumns(this.options.columns || []);

	        var colSplit = this._visibleColumns(this._trimColumns(this._leafColumns(columns.filter(function(column) {
	            return column.locked;
	        })))).length;

	        return {
	            rowSplit: this._headerDepth(columns),
	            colSplit: colSplit ? colSplit + this.groups.length : 0
	        };
	    },

	    _cell: function(dataItem, column) {
	        return $.extend({
	            value: column.value(dataItem)
	        }, column.cellOptions);
	    },

	    _depth: function() {
	        var depth = 0;

	        if (this.hierarchy) {
	            depth = this.hierarchy.depth;
	        } else {
	            depth = this.groups.length;
	        }

	        return depth;
	    },

	    _columns: function() {
	        var depth = this._depth();
	        var columns = createArray(depth, function () { return ({ width: 20 }); });

	        return columns.concat(this.columns.map(function(column) {
	            return {
	                width: parseInt(column.width, 10),
	                autoWidth: column.width ? false : true
	            };
	        }));
	    }
	});

	kendo.deepExtend(kendo.excel, {
	    ExcelExporter: ExcelExporter,
	    TemplateService: TemplateService
	});

	})(window.kendo.jQuery);

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "EBqR":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(933);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/***********************************************************************
	 * WARNING: this file is auto-generated.  If you change it directly,
	 * your modifications will eventually be lost.  The source code is in
	 * `kendo-charts` repository, you should make your changes there and
	 * run `src-modules/sync.sh` in this repository.
	 */
	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(934)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function () {

	window.kendo.dataviz = window.kendo.dataviz || {};
	var dataviz = kendo.dataviz;
	var constants = dataviz.constants;
	var Chart = dataviz.Chart;
	var elementSize = dataviz.elementSize;
	var deepExtend = dataviz.deepExtend;

	var TOP_OFFSET = -2;

	var SharedTooltip$1 = dataviz.SharedTooltip.extend({
	    _slotAnchor: function(coords, slot) {
	        var axis = this.plotArea.categoryAxis;
	        var vertical = axis.options.vertical;
	        var align = vertical ? {
	            horizontal: "left",
	            vertical: "center"
	        } : {
	            horizontal: "center",
	            vertical: "bottom"
	        };

	        var point;

	        if (vertical) {
	            point = new dataviz.Point(this.plotArea.box.x2, slot.center().y);
	        } else {
	            point = new dataviz.Point(slot.center().x, TOP_OFFSET);
	        }

	        return {
	            point: point,
	            align: align
	        };
	    },

	    _defaultAnchor: function(point, slot) {
	        return this._slotAnchor({}, slot);
	    }
	});

	var DEAULT_BAR_WIDTH = 150;
	var DEAULT_BULLET_WIDTH = 150;
	var NO_CROSSHAIR = [ constants.BAR, constants.BULLET ];

	function hide(children) {
	    var state = [];
	    for (var idx = 0; idx < children.length; idx++) {
	        var child = children[idx];
	        state[idx] = child.style.display;
	        child.style.display = "none";
	    }

	    return state;
	}

	function show(children, state) {
	    for (var idx = 0; idx < children.length; idx++) {
	        children[idx].style.display = state[idx];
	    }
	}

	function wrapNumber(value) {
	    return dataviz.isNumber(value) ? [ value ] : value;
	}

	var Sparkline = Chart.extend({
	    _setElementClass: function(element) {
	        dataviz.addClass(element, 'k-sparkline');
	    },

	    _initElement: function(element) {
	        Chart.fn._initElement.call(this, element);

	        this._initialWidth = Math.floor(elementSize(element).width);
	    },

	    _resize: function() {
	        var element = this.element;
	        var state = hide(element.childNodes);

	        this._initialWidth = Math.floor(elementSize(element).width);

	        show(element.childNodes, state);

	        Chart.fn._resize.call(this);
	    },

	    _modelOptions: function() {
	        var chartOptions = this.options;
	        var stage = this._surfaceWrap();
	        var displayState = hide(stage.childNodes);

	        var space = document.createElement('span');
	        space.innerHTML = '&nbsp;';

	        stage.appendChild(space);

	        var options = deepExtend({
	            width: this._autoWidth,
	            height: elementSize(stage).height,
	            transitions: chartOptions.transitions
	        }, chartOptions.chartArea, {
	            inline: true,
	            align: false
	        });

	        elementSize(stage, {
	            width: options.width,
	            height: options.height
	        });

	        stage.removeChild(space);

	        show(stage.childNodes, displayState);

	        if (this.surface) {
	            this.surface.resize();
	        }

	        return options;
	    },

	    _surfaceWrap: function() {
	        if (!this.stage) {
	            var stage = this.stage = document.createElement('span');
	            this.element.appendChild(stage);
	        }
	        return this.stage;
	    },

	    _createPlotArea: function(skipSeries) {
	        var plotArea = Chart.fn._createPlotArea.call(this, skipSeries);
	        this._autoWidth = this._initialWidth || this._calculateWidth(plotArea);

	        return plotArea;
	    },

	    _calculateWidth: function(plotArea) {
	        var options = this.options;
	        var margin = dataviz.getSpacing(options.chartArea.margin);
	        var charts = plotArea.charts;
	        var stage = this._surfaceWrap();
	        var total = 0;

	        for (var i = 0; i < charts.length; i++) {
	            var currentChart = charts[i];
	            var firstSeries = (currentChart.options.series || [])[0];
	            if (!firstSeries) {
	                continue;
	            }

	            if (firstSeries.type === constants.BAR) {
	                return DEAULT_BAR_WIDTH;
	            }

	            if (firstSeries.type === constants.BULLET) {
	                return DEAULT_BULLET_WIDTH;
	            }

	            if (firstSeries.type === constants.PIE) {
	                return elementSize(stage).height;
	            }

	            var categoryAxis = currentChart.categoryAxis;
	            if (categoryAxis) {
	                var pointsCount = categoryAxis.categoriesCount() *
	                    (!currentChart.options.isStacked && dataviz.inArray(firstSeries.type, [ constants.COLUMN, constants.VERTICAL_BULLET ]) ? currentChart.seriesOptions.length : 1);

	                total = Math.max(total, pointsCount);
	            }
	        }

	        var size = total * options.pointWidth;
	        if (size > 0) {
	            size += margin.left + margin.right;
	        }

	        return size;
	    },

	    _createSharedTooltip: function(options) {
	        return new SharedTooltip$1(this._plotArea, options);
	    }
	});

	Sparkline.normalizeOptions = function(userOptions) {
	    var options = wrapNumber(userOptions);

	    if (dataviz.isArray(options)) {
	        options = { seriesDefaults: { data: options } };
	    } else {
	        options = deepExtend({}, options);
	    }

	    if (!options.series) {
	        options.series = [ { data: wrapNumber(options.data) } ];
	    }

	    deepExtend(options, {
	        seriesDefaults: {
	            type: options.type
	        }
	    });

	    if (dataviz.inArray(options.series[0].type, NO_CROSSHAIR) ||
	        dataviz.inArray(options.seriesDefaults.type, NO_CROSSHAIR)) {
	        options = deepExtend({}, {
	            categoryAxis: {
	                crosshair: {
	                    visible: false
	                }
	            }
	        }, options);
	    }

	    return options;
	};

	dataviz.setDefaultOptions(Sparkline, {
	    chartArea: {
	        margin: 2
	    },
	    axisDefaults: {
	        visible: false,
	        majorGridLines: {
	            visible: false
	        },
	        valueAxis: {
	            narrowRange: true
	        }
	    },
	    seriesDefaults: {
	        type: "line",
	        area: {
	            line: {
	                width: 0.5
	            }
	        },
	        bar: {
	            stack: true
	        },
	        padding: 2,
	        width: 0.5,
	        overlay: {
	            gradient: null
	        },
	        highlight: {
	            visible: false
	        },
	        border: {
	            width: 0
	        },
	        markers: {
	            size: 2,
	            visible: false
	        }
	    },
	    tooltip: {
	        visible: true,
	        shared: true
	    },
	    categoryAxis: {
	        crosshair: {
	            visible: true,
	            tooltip: {
	                visible: false
	            }
	        }
	    },
	    legend: {
	        visible: false
	    },
	    transitions: false,

	    pointWidth: 5,

	    panes: [ { clip: false } ]
	});

	kendo.deepExtend(kendo.dataviz, {
	    Sparkline: Sparkline
	});

	})();

	}, __webpack_require__(3));

/***/ }),

/***/ 934:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("IPyL");

/***/ })

/******/ });

/***/ }),

/***/ "EDhZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1171);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1170:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("zQRd");

/***/ }),

/***/ 1171:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1170), __webpack_require__(1172) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "datetimepicker",
	    name: "DateTimePicker",
	    category: "web",
	    description: "The DateTimePicker allows the end user to select a value from a calendar or a time drop-down list.",
	    depends: [ "datepicker", "timepicker" ]
	};

	(function($, undefined) {

	    var kendo = window.kendo,
	        TimeView = kendo.TimeView,
	        parse = kendo.parseDate,
	        support = kendo.support,
	        activeElement = kendo._activeElement,
	        extractFormat = kendo._extractFormat,
	        calendar = kendo.calendar,
	        isInRange = calendar.isInRange,
	        restrictValue = calendar.restrictValue,
	        isEqualDatePart = calendar.isEqualDatePart,
	        getMilliseconds = TimeView.getMilliseconds,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        OPEN = "open",
	        CLOSE = "close",
	        CHANGE = "change",
	        ns = ".kendoDateTimePicker",
	        CLICK = "click" + ns,
	        UP = support.mouseAndTouchPresent ? kendo.applyEventMap("up", ns.slice(1)) : CLICK,
	        DISABLED = "disabled",
	        READONLY = "readonly",
	        DEFAULT = "k-state-default",
	        FOCUSED = "k-state-focused",
	        HOVER = "k-state-hover",
	        STATEDISABLED = "k-state-disabled",
	        HOVEREVENTS = "mouseenter" + ns + " mouseleave" + ns,
	        MOUSEDOWN = "mousedown" + ns,
	        MONTH = "month",
	        SPAN = "<span/>",
	        ARIA_ACTIVEDESCENDANT = "aria-activedescendant",
	        ARIA_EXPANDED = "aria-expanded",
	        ARIA_HIDDEN = "aria-hidden",
	        ARIA_OWNS = "aria-owns",
	        ARIA_DISABLED = "aria-disabled",
	        ARIA_READONLY = "aria-readonly",
	        DATE = Date,
	        MIN = new DATE(1800, 0, 1),
	        MAX = new DATE(2099, 11, 31),
	        dateViewParams = { view: "date" },
	        timeViewParams = { view: "time" },
	        extend = $.extend,
	        SINGLE_POPUP_TEMPLATE = '<div class="k-date-tab k-datetime-wrap">' +
	                                    '<div class="k-datetime-buttongroup">'+
	                                        '<div class="k-button-group k-button-group-stretched">'+
	                                            '<button class="k-button k-state-active k-group-start">#=messages.date#</button>'+
	                                            '<button class="k-button k-group-end">#=messages.time#</button>'+
	                                        '</div>'+
	                                    '</div>'+
	                                    '<div class="k-datetime-selector">'+
	                                        '<div class="k-datetime-calendar-wrap">'+
	                                        '</div>'+
	                                        '<div class="k-datetime-time-wrap">'+
	                                        '</div>'+
	                                    '</div>'+
	                                    '<div class="k-datetime-footer k-action-buttons">'+
	                                        '<button class="k-button k-time-cancel" title="Cancel" aria-label="Cancel">#=messages.cancel#</button>'+
	                                        '<button class="k-time-accept k-button k-primary" title="Set" aria-label="Set">#=messages.set#</button>'+
	                                    '</div>'+
	                                '</div>',
	        STATE_ACTIVE = "k-state-active";

	    var DateTimePicker = Widget.extend({
	        init: function(element, options) {
	            var that = this, disabled;

	            options = options || {};
	            options.componentType = options.componentType || "classic";
	            Widget.fn.init.call(that, element, options);

	            element = that.element;
	            options = that.options;

	            options.disableDates = kendo.calendar.disabled(options.disableDates);
	            options.min = parse(element.attr("min")) || parse(options.min);
	            options.max = parse(element.attr("max")) || parse(options.max);

	            if (+options.max != +MAX || +options.min != +MIN) {
	                this._specifiedRange = true;
	            }

	            normalize(options);

	            that._initialOptions = extend({}, options);

	            that._wrapper();

	            if(options.singlePopup){
	                that._popup();
	            }

	            that._views();

	            that._icons();

	            that._reset();
	            that._template();

	            try {
	                element[0].setAttribute("type", "text");
	            } catch(e) {
	                element[0].type = "text";
	            }

	            element.addClass("k-input")
	                   .attr({
	                       "role": "combobox",
	                       "aria-expanded": false,
	                       "autocomplete": "off"
	                   });


	            that._midnight = that._calculateMidnight(options.min, options.max);

	            disabled = element.is("[disabled]") || $(that.element).parents("fieldset").is(':disabled');
	            if (disabled) {
	                that.enable(false);
	            } else {
	                that.readonly(element.is("[readonly]"));
	            }

	            that._createDateInput(options);

	            that._old = that._update(options.value || that.element.val());
	            that._oldText = element.val();

	            kendo.notify(that);
	        },

	        options: {
	            name: "DateTimePicker",
	            value: null,
	            format: "",
	            timeFormat: "",
	            culture: "",
	            parseFormats: [],
	            dates: [],
	            disableDates: null,
	            min: new DATE(MIN),
	            max: new DATE(MAX),
	            interval: 30,
	            height: 200,
	            footer: "",
	            start: MONTH,
	            depth: MONTH,
	            animation: {},
	            month : {},
	            ARIATemplate: 'Current focused date is #=kendo.toString(data.current, "d")#',
	            dateButtonText: "Open the date view",
	            timeButtonText: "Open the time view",
	            dateInput: false,
	            weekNumber: false,
	            messages: {
	                set: "Set",
	                cancel: "Cancel",
	                hour: "hour",
	                minute: "minute",
	                second: "second",
	                millisecond: "millisecond",
	                now: "Now",
	                date: "Date",
	                time: "Time",
	                today: "Today"
	            },
	            componentType: "classic"
	        },

	        events: [
	            OPEN,
	            CLOSE,
	            CHANGE
	        ],

	        componentTypes: {
	            "classic": {
	                singlePopup: false,
	                timeView: {
	                    list: "list"
	                }
	            },
	            "modern": {
	                singlePopup: true,
	                timeView: {
	                    list: "scroll"
	                }
	            }
	        },

	        setOptions: function(options) {
	            var that = this,
	                value = that._value,
	                min, max, currentValue;

	            Widget.fn.setOptions.call(that, options);

	            options = that.options;

	            options.min = min = parse(options.min);
	            options.max = max = parse(options.max);

	            normalize(options);

	            that._midnight = that._calculateMidnight(options.min, options.max);

	            currentValue = options.value || that._value || that.dateView._current;

	            if (min && !isEqualDatePart(min, currentValue)) {
	                min = new DATE(MIN);
	            }

	            if (max && !isEqualDatePart(max, currentValue)) {
	                max = new DATE(MAX);
	            }

	            that.dateView.setOptions(options);

	            that.timeView.setOptions(extend({}, options, {
	                format: options.timeFormat,
	                min: min,
	                max: max
	            }));

	            that._createDateInput(options);

	            if (!that._dateInput) {
	                that.element.val(kendo.toString(value, options.format, options.culture));
	            }

	            if (value) {
	                that._updateARIA(value);
	            }
	        },

	        _editable: function(options) {
	            var that = this,
	                element = that.element.off(ns),
	                dateIcon = that._dateIcon.off(ns),
	                timeIcon = that._timeIcon.off(ns),
	                wrapper = that._inputWrapper.off(ns),
	                readonly = options.readonly,
	                disable = options.disable;

	            if (!readonly && !disable) {
	                wrapper
	                    .addClass(DEFAULT)
	                    .removeClass(STATEDISABLED)
	                    .on(HOVEREVENTS, that._toggleHover);
	                if(element && element.length) {
	                    element[0].removeAttribute(DISABLED);
	                    element[0].removeAttribute(READONLY, false);
	                    element[0].removeAttribute(ARIA_DISABLED, false);
	                    element[0].removeAttribute(ARIA_READONLY, false);
	                }
	                element.on("keydown" + ns, $.proxy(that._keydown, that))
	                       .on("focus" + ns, function() {
	                           that._inputWrapper.addClass(FOCUSED);
	                       })
	                       .on("focusout" + ns, function() {
	                           that._inputWrapper.removeClass(FOCUSED);
	                           if (element.val() !== that._oldText) {
	                               that._change(element.val());
	                               if (!element.val()) {
	                                   that.dateView.current(kendo.calendar.getToday());
	                               }
	                           }
	                           if (that.options.singlePopup) {
	                               return;
	                           }
	                           that.close("date");
	                           that.close("time");
	                       });

	               dateIcon.on(MOUSEDOWN, preventDefault)
	                        .on(UP, function(e) {
	                            that.toggle("date");
	                            that._focusElement(e.type);
	                        });

	               timeIcon.on(MOUSEDOWN, preventDefault)
	                        .on(UP, function(e) {
	                            that.toggle("time");
	                            that._focusElement(e.type);
	                        });

	            } else {
	                wrapper
	                    .addClass(disable ? STATEDISABLED : DEFAULT)
	                    .removeClass(disable ? DEFAULT : STATEDISABLED);

	                element.attr(DISABLED, disable)
	                       .attr(READONLY, readonly)
	                       .attr(ARIA_DISABLED, disable)
	                       .attr(ARIA_READONLY, readonly);
	            }
	        },

	        _focusElement: function(eventType) {
	            var element = this.element;

	            if ((!support.touch || (support.mouseAndTouchPresent && !(eventType || "").match(/touch/i))) && element[0] !== activeElement()) {
	                element.trigger("focus");
	            }
	        },

	        readonly: function(readonly) {
	            this._editable({
	                readonly: readonly === undefined ? true : readonly,
	                disable: false
	            });
	        },

	        enable: function(enable) {
	            this._editable({
	                readonly: false,
	                disable: !(enable = enable === undefined ? true : enable)
	            });
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);
	            that.dateView.destroy();
	            that.timeView.destroy();

	            if (that.options.singlePopup) {
	                that.popup.element.off(ns);
	                that.popup.destroy();
	            }

	            that.element.off(ns);
	            that._dateIcon.off(ns);
	            that._timeIcon.off(ns);
	            that._inputWrapper.off(ns);

	            if (that._form) {
	                that._form.off("reset", that._resetHandler);
	            }
	        },

	        close: function(view) {
	            if (this.options.singlePopup) {
	                this.popup.close();
	            } else {
	                if (view !== "time") {
	                    view = "date";
	                }

	                this[view + "View"].close();
	            }
	        },

	        open: function(view) {
	            var that = this;
	            var popupHovered;

	            if (that.options.singlePopup) {

	                that.dateView._calendar();

	                if (that.timeView.ul.find("li").length < 1) {
	                    that.timeView.bind();
	                }

	                // In some cases when the popup is opened resize is triggered which will cause it to close
	                // Setting the below flag will prevent this from happening
	                // Reference: https://github.com/telerik/kendo/pull/7553
	                popupHovered = that.popup._hovered;
	                that.popup._hovered = true;

	                that.popup.open();

	                if (view === "time") {
	                    that._switchToTimeView();
	                } else {
	                    that._switchToDateView();
	                }

	                this._dateIcon.toggle(view !== "time");
	                this._timeIcon.toggle(view === "time");

	                setTimeout(function() {
	                    that.popup._hovered = popupHovered;
	                }, 1);

	            } else {
	                if (view !== "time") {
	                    view = "date";
	                }

	                this[view + "View"].open();
	            }
	        },

	        min: function(value) {
	            return this._option("min", value);
	        },

	        max: function(value) {
	            return this._option("max", value);
	        },

	        toggle: function(view) {
	            if (this.options.singlePopup) {
	                if (this.popup.visible()) {
	                    this.close();
	                } else {
	                    this.open(view);
	                }
	            } else {
	                var secondView = "timeView";

	                if (view !== "time") {
	                    view = "date";
	                } else {
	                    secondView = "dateView";
	                }

	                this[view + "View"].toggle();
	                this[secondView].close();
	            }

	        },

	        value: function(value) {
	            var that = this;

	            if (value === undefined) {
	                return that._value;
	            }

	            that._old = that._update(value);
	            if (that._old === null) {
	                that.element.val("");
	            }

	            that._oldText = that.element.val();
	        },

	        _change: function(value) {
	            var that = this,
	            oldValue = that.element.val(),
	            dateChanged;

	            value = that._update(value);
	            dateChanged = +that._old != +value;

	            var valueUpdated = dateChanged && !that._typing;
	            var textFormatted = oldValue !== that.element.val();

	            if (valueUpdated || textFormatted) {
	                that.element.trigger(CHANGE);
	            }

	            if (dateChanged) {
	                that._old = value;
	                that._oldText = that.element.val();

	                that.trigger(CHANGE);
	            }

	            that._typing = false;
	        },

	        _option: function(option, value) {
	            var that = this;
	            var options = that.options;
	            var timeView = that.timeView;
	            var timeViewOptions = timeView.options;
	            var current = that._value || that._old;
	            var minDateEqual;
	            var maxDateEqual;

	            if (value === undefined) {
	                return options[option];
	            }

	            value = parse(value, options.parseFormats, options.culture);
	            timeViewOptions.maxSet = false;

	            if (!value) {
	                return;
	            }

	            if (options.min.getTime() === options.max.getTime()) {
	                timeViewOptions.dates = [];
	            }

	            options[option] = new DATE(value.getTime());
	            that.dateView[option](value);

	            that._midnight = that._calculateMidnight(options.min, options.max);

	            if (current) {
	                minDateEqual = isEqualDatePart(options.min, current);
	                maxDateEqual = isEqualDatePart(options.max, current);
	            }

	            if (minDateEqual || maxDateEqual) {
	                timeViewOptions[option] = value;

	                if (minDateEqual && !maxDateEqual) {
	                    timeViewOptions.max = lastTimeOption(options.interval);
	                }

	                if (maxDateEqual) {
	                    if (that._midnight) {
	                        timeView.dataBind([MAX]);
	                        return;
	                    } else if (!minDateEqual) {
	                        timeViewOptions.min = MIN;
	                        timeViewOptions.maxSet = true;
	                    }
	                }
	            } else {
	                timeViewOptions.max = MAX;
	                timeViewOptions.min = MIN;
	            }

	            timeView.bind();
	        },

	        _toggleHover: function(e) {
	            $(e.currentTarget).toggleClass(HOVER, e.type === "mouseenter");
	        },

	        _update: function(value) {
	            var that = this,
	                options = that.options,
	                min = options.min,
	                max = options.max,
	                dates = options.dates,
	                timeView = that.timeView,
	                current = that._value,
	                date = parse(value, options.parseFormats, options.culture),
	                isSameType = (date === null && current === null) || (date instanceof Date && current instanceof Date),
	                rebind, timeViewOptions, old, skip, formattedValue;

	            if (options.disableDates && options.disableDates(date)) {
	                date = null;
	                if (!that._old && !that.element.val()) {
	                    value = null;
	                }
	            }

	            if (+date === +current && isSameType) {
	                formattedValue = kendo.toString(date, options.format, options.culture);

	                if (formattedValue !== value ) {
	                    that.element.val(date === null ? value : formattedValue);
	                    if (value instanceof String) {
	                        that.element.trigger(CHANGE);
	                    }
	                }

	                return date;
	            }

	            if (date !== null && isEqualDatePart(date, min)) {
	                date = restrictValue(date, min, max);
	            } else if (!isInRange(date, min, max)) {
	                date = null;
	            }

	            that._value = date;
	            timeView.value(date);
	            that.dateView.value(date);

	            if (date) {
	                old = that._old;
	                timeViewOptions = timeView.options;
	                timeViewOptions.maxSet = false;

	                if (dates[0]) {
	                    dates = $.grep(dates, function(d) { return isEqualDatePart(date, d); });

	                    if (dates[0]) {
	                        timeView.dataBind(dates);
	                        skip = true;
	                    }
	                }

	                if (!skip) {
	                    if (isEqualDatePart(date, min)) {
	                        timeViewOptions.min = min;
	                        timeViewOptions.max = lastTimeOption(options.interval);
	                        rebind = true;
	                    }

	                    if (isEqualDatePart(date, max)) {
	                        if (that._midnight) {
	                            timeView.dataBind([MAX]);
	                            skip = true;
	                        } else {
	                            timeViewOptions.max = max;
	                            timeViewOptions.maxSet = true;
	                            if (!rebind) {
	                                timeViewOptions.min = MIN;
	                            }
	                            rebind = true;
	                        }
	                    }
	                }

	                if (!skip && ((!old && rebind) || (old && !isEqualDatePart(old, date)))) {
	                    if (!rebind) {
	                        timeViewOptions.max = MAX;
	                        timeViewOptions.min = MIN;
	                    }

	                    timeView.bind();
	                }
	            }
	            if (that._dateInput && date) {
	                that._dateInput.value(date || value);
	            } else {
	                that.element.val(kendo.toString(date || value, options.format, options.culture));
	            }
	            that._updateARIA(date);

	            return date;
	        },

	        _keydown: function(e) {
	            var that = this,
	                dateView = that.dateView,
	                timeView = that.timeView,
	                value = that.element.val(),
	                isDateViewVisible = that.options.singlePopup ? that.popup.visible() : dateView.popup.visible();
	            var stopPropagation = that._dateInput && e.stopImmediatePropagation;
	            if (e.altKey && e.keyCode === kendo.keys.DOWN) {
	                that.toggle(isDateViewVisible ? "time" : "date");
	            } else if (isDateViewVisible) {
	                dateView.move(e);
	                that._updateARIA(dateView._current);
	            } else if (!that.options.singlePopup && timeView.popup.visible()) {
	                timeView.move(e);
	            } else if (e.keyCode === kendo.keys.ENTER && value !== that._oldText) {
	                that._change(value);
	            } else {
	                that._typing = true;
	                stopPropagation = false;
	            }
	            if (stopPropagation) {
	                e.stopImmediatePropagation();
	            }
	        },

	        _views: function() {
	            var that = this,
	                element = that.element,
	                options = that.options,
	                id = element.attr("id"),
	                dateView, timeView,
	                div, ul, msMin,
	                date,
	                timeDiv,
	                omitPopup,
	                timeViewOptions;

	            if (options.singlePopup) {
	                options.dateDiv = that.popup.element.find(".k-datetime-calendar-wrap");
	                timeDiv = that.popup.element.find(".k-datetime-time-wrap");
	                options.omitPopup = omitPopup = true;
	                timeViewOptions = options.timeView;
	            }

	            that.dateView = dateView = new kendo.DateView(extend({}, options, {
	                id: id,
	                anchor: that.wrapper,
	                change: function() {
	                    var value = that._applyDateValue();

	                    if(options.singlePopup){
	                        if (!that.timeView._currentlySelected) {
	                            that.timeView._currentlySelected = new Date();
	                        }
	                        that.timeView._currentlySelected.setFullYear(value.getFullYear());
	                        that.timeView._currentlySelected.setMonth(value.getMonth());
	                        that.timeView._currentlySelected.setDate(value.getDate());
	                        that._switchToTimeView();
	                        that._toggleIcons();
	                    } else {
	                        that._change(value);
	                        that.close("date");
	                    }
	                },
	                close: function(e) {
	                    if (that.trigger(CLOSE, dateViewParams)) {
	                        e.preventDefault();
	                    } else {
	                        element.attr(ARIA_EXPANDED, false);
	                        div.attr(ARIA_HIDDEN, true);

	                        if (!that.options.singlePopup && !timeView.popup.visible()) {
	                            if(element && element.length) {
	                                element[0].removeAttribute(ARIA_OWNS);
	                            }
	                        }
	                    }
	                },
	                open:  function(e) {
	                    if (that.trigger(OPEN, dateViewParams)) {
	                        e.preventDefault();
	                    } else {

	                        if (element.val() !== that._oldText) {
	                            date = parse(element.val(), options.parseFormats, options.culture);

	                            that.dateView[date ? "current" : "value"](date);
	                        }

	                        div.attr(ARIA_HIDDEN, false);
	                        element.attr(ARIA_EXPANDED, true)
	                               .attr(ARIA_OWNS, dateView._dateViewID);

	                        that._updateARIA(date);
	                    }
	                }
	            }));
	            div = dateView.div;

	            msMin = options.min.getTime();
	            that.timeView = timeView = new TimeView({
	                id: id,
	                value: options.value,
	                anchor: that.wrapper,
	                animation: options.animation,
	                format: options.timeFormat,
	                culture: options.culture,
	                height: options.componentType === "modern" ? null : options.height,
	                interval: options.interval,
	                min: options.componentType === "modern" ? options.min : new DATE(MIN),
	                max: options.componentType === "modern" ? options.max : new DATE(MAX),
	                dates: msMin === options.max.getTime() ? [new Date(msMin)] : [],
	                parseFormats: options.parseFormats,
	                validateDate: true,
	                change: function(value, trigger) {
	                    value = that._applyTimeValue(value);

	                    if (trigger) {
	                        that._timeSelected = true;
	                        that._change(value);
	                    } else {
	                        element.val(kendo.toString(value, options.format, options.culture));
	                        dateView.value(value);
	                        that._updateARIA(value);
	                    }
	                },
	                close: function(e) {
	                    if (that.trigger(CLOSE, timeViewParams)) {
	                        e.preventDefault();
	                    } else {
	                        ul.attr(ARIA_HIDDEN, true);
	                        element.attr(ARIA_EXPANDED, false);

	                        if (!dateView.popup.visible()) {
	                            if(element && element.length) {
	                                element[0].removeAttribute(ARIA_OWNS);
	                            }
	                        }
	                    }
	                },
	                open:  function(e) {
	                    if (that.options.componentType !=="modern") {
	                        timeView._adjustListWidth();
	                    } else {
	                        that.timeView._updateTitle();
	                    }

	                    if (that.trigger(OPEN, timeViewParams)) {
	                        e.preventDefault();
	                    } else {
	                        if (element.val() !== that._oldText) {
	                            date = parse(element.val(), options.parseFormats, options.culture);

	                            that.timeView.value(date);
	                        }

	                        ul.attr(ARIA_HIDDEN, false);
	                        element.attr(ARIA_EXPANDED, true)
	                               .attr(ARIA_OWNS, timeView._timeViewID);

	                        timeView.options.active(timeView.current());
	                    }
	                },
	                active: function(current) {
	                    if(element && element.length) {
	                        element[0].removeAttribute(ARIA_ACTIVEDESCENDANT);
	                    }
	                    if (current) {
	                        element.attr(ARIA_ACTIVEDESCENDANT, timeView._optionID);
	                    }
	                },
	                popup: options.popup,
	                useValueToRender: true,
	                specifiedRange: that._specifiedRange,
	                omitPopup: omitPopup,
	                timeDiv: timeDiv,
	                timeView: timeViewOptions,
	                messages: that.options.messages
	            });
	            ul = timeView.ul;
	        },

	        _applyDateValue: function () {
	            var that = this;
	            var options = that.options;
	            var dateView = that.dateView;
	            var value = dateView.calendar.value();
	            var msValue = +value;
	            var msMin = +options.min;
	            var msMax = +options.max;
	            var current, adjustedDate;

	            if (msValue === msMin || msValue === msMax) {
	                current = msValue === msMin ? msMin : msMax;
	                current = new DATE(that._value || current);
	                current.setFullYear(value.getFullYear(), value.getMonth(), value.getDate());

	                if (isInRange(current, msMin, msMax)) {
	                    value = current;
	                }
	            }

	            if (that._value) {

	                adjustedDate = kendo.date.setHours(new Date(value), that._value);

	                if (isInRange(adjustedDate, msMin, msMax)) {
	                    value = adjustedDate;
	                }
	            }

	            return value;
	        },

	        _applyTimeValue: function(value){
	            var timeView = this.timeView;
	            var options = this.options;

	            value = timeView._parse(value);

	            if (value < options.min) {
	                value = new DATE(+options.min);
	                timeView.options.min = value;
	            } else if (value > options.max) {
	                value = new DATE(+options.max);
	                timeView.options.max = value;
	            }

	            return value;
	        },

	        _icons: function() {
	            var that = this;
	            var element = that.element;
	            var options = that.options;
	            var icons;

	            icons = element.next("span.k-select");

	            if (!icons[0]) {
	                icons = $('<span unselectable="on" class="k-select">' +
	                            '<span class="k-link k-link-date" aria-label="' + options.dateButtonText + '"><span unselectable="on" class="k-icon k-i-calendar"></span></span>' +
	                            '<span class="k-link k-link-time" aria-label="' + options.timeButtonText + '"><span unselectable="on" class="k-icon k-i-clock"></span></span>' +
	                          '</span>'
	                         ).insertAfter(element);
	            }

	            icons = icons.children();

	            that._dateIcon = icons.eq(0).attr("aria-controls", that.dateView._dateViewID);
	            that._timeIcon = icons.eq(1).attr("aria-controls", that.timeView._timeViewID);

	            if (options.singlePopup) {
	                that._timeIcon.hide();
	            }
	        },

	        _wrapper: function() {
	            var that = this,
	            element = that.element,
	            wrapper;

	            wrapper = element.parents(".k-datetimepicker");

	            if (!wrapper[0]) {
	                wrapper = element.wrap(SPAN).parent().addClass("k-picker-wrap k-state-default");
	                wrapper = wrapper.wrap(SPAN).parent();
	            }

	            wrapper[0].style.cssText = element[0].style.cssText;
	            element.css({
	                width: "100%",
	                height: element[0].style.height
	            });

	            that.wrapper = wrapper.addClass("k-widget k-datetimepicker")
	                .addClass(element[0].className).removeClass('input-validation-error');

	            that._inputWrapper = $(wrapper[0].firstChild);
	        },

	        _reset: function() {
	            var that = this,
	                element = that.element,
	                formId = element.attr("form"),
	                form = formId ? $("#" + formId) : element.closest("form"),
	                options = that.options,
	                disabledDate = options.disableDates,
	                parseFormats = options.parseFormats.length ? options.parseFormats : null,
	                optionsValue = that._initialOptions.value,
	                initialValue = element[0].defaultValue;

	            if (optionsValue && (disabledDate && disabledDate(optionsValue))) {
	                optionsValue = null;
	            }

	            if ((!initialValue || !kendo.parseDate(initialValue, parseFormats, options.culture)) && optionsValue) {
	                element.attr("value", kendo.toString(optionsValue, options.format, options.culture));
	            }

	            if (form[0]) {
	                that._resetHandler = function() {
	                    that.value(optionsValue || element[0].defaultValue);
	                    that.max(that._initialOptions.max);
	                    that.min(that._initialOptions.min);
	                };

	                that._form = form.on("reset", that._resetHandler);
	            }
	        },

	        _template: function() {
	            this._ariaTemplate = kendo.template(this.options.ARIATemplate);
	        },

	        _createDateInput: function(options) {
	            if (this._dateInput) {
	                this._dateInput.destroy();
	                this._dateInput = null;
	            }

	            if (options.dateInput ) {
	                this._dateInput = new ui.DateInput(this.element, {
	                    culture: options.culture,
	                    format: options.format,
	                    min: options.min,
	                    max: options.max,
	                    interval: options.interval
	                });
	            }
	        },

	        _calculateMidnight: function(min, max) {
	            return getMilliseconds(min) + getMilliseconds(max) === 0;
	        },

	        _updateARIA: function(date) {
	            var cell;
	            var that = this;
	            var calendar = that.dateView.calendar;

	            if(that.element && that.element.length) {
	                that.element[0].removeAttribute(ARIA_ACTIVEDESCENDANT);
	            }

	            if (calendar) {
	                cell = calendar._cell;
	                cell.attr("aria-label", that._ariaTemplate({ current: date || calendar.current() }));

	                that.element.attr(ARIA_ACTIVEDESCENDANT, cell.attr("id"));
	            }
	        },
	        _popup: function(){
	            var that = this;
	            var options = that.options;
	            var div = $("<div></div>").attr(ARIA_HIDDEN, "true")
	                .addClass("k-datetime-container k-group k-reset")
	                .appendTo(document.body);

	            div.append(kendo.template(SINGLE_POPUP_TEMPLATE)(that.options));
	            that.popup = new ui.Popup(div, extend(options.popup, options, { 
	                name: "Popup", 
	                isRtl: kendo.support.isRtl(that.wrapper),
	                anchor: that.wrapper,
	                activate: function () {
	                    if (that.options.timeView && that.options.timeView.list === "scroll") {
	                        that.timeView.addTranslate();
	                        that.timeView.applyValue(that._value);
	                        that.timeView._updateRanges();
	                    }
	                },
	                open: function(){
	                    that.timeView._updateTitle();
	                }
	            }));

	            div.on(CLICK + ns, ".k-datetime-buttongroup .k-button", $.proxy(that._groupChangeClick, that));
	            div.on(CLICK + ns, ".k-datetime-footer button.k-time-cancel", $.proxy(that._cancelClickHandler, that));
	            div.on(CLICK + ns, ".k-datetime-footer button.k-time-accept", $.proxy(that._setClickHandler, that));
	        },

	        _groupChangeClick: function(e) {
	            preventDefault(e);
	            var button =  $(e.currentTarget);
	            var index = button.index();

	            if (index) {
	                this._switchToTimeView();
	            } else {
	                this._switchToDateView();
	            }
	            this._toggleIcons();
	        },

	        _switchToDateView: function() {
	            this.popup.element.find(".k-group-start, .k-group-end").removeClass(STATE_ACTIVE).eq(0).addClass(STATE_ACTIVE);
	            this.popup.element.find(".k-datetime-wrap").removeClass("k-time-tab").addClass("k-date-tab");
	        },

	        _switchToTimeView: function() {
	            this.timeView._updateRanges();
	            this.popup.element.find(".k-group-start, .k-group-end").removeClass(STATE_ACTIVE).eq(1).addClass(STATE_ACTIVE);
	            this.popup.element.find(".k-datetime-wrap").removeClass("k-date-tab").addClass("k-time-tab");
	        },

	        _toggleIcons: function() {
	            this._dateIcon.toggle();
	            this._timeIcon.toggle();
	        },

	        _cancelClickHandler: function () {
	            if (this._value) {
	                this.value(this._value);
	                this.dateView.value(this._value);
	            }
	            this.popup.close();
	        },

	        _setClickHandler: function() {
	            var value = this._applyDateValue();
	            var time = this.timeView._currentlySelected || new Date();

	            value = value || new Date();
	            this.timeView._updateCurrentlySelected();
	            value.setHours(time.getHours());
	            value.setMinutes(time.getMinutes());
	            value.setSeconds(time.getSeconds());
	            value = this._applyTimeValue(value);

	            this._change(value);
	            this.popup.close();
	        }
	    });

	    function lastTimeOption(interval) {
	        var date = new Date(2100, 0, 1);
	        date.setMinutes(-interval);
	        return date;
	    }

	    function preventDefault(e) {
	        e.preventDefault();
	    }

	    function normalize(options) {
	        var patterns = kendo.getCulture(options.culture).calendars.standard.patterns,
	            parseFormats = !options.parseFormats.length,
	            timeFormat;

	        options.format = extractFormat(options.format || patterns.g);
	        options.timeFormat = timeFormat = extractFormat(options.timeFormat || patterns.t);
	        kendo.DateView.normalize(options);

	        if (parseFormats) {
	           options.parseFormats.unshift("yyyy-MM-ddTHH:mm:ss");
	        }

	        if ($.inArray(timeFormat, options.parseFormats) === -1) {
	            options.parseFormats.push(timeFormat);
	        }
	    }

	    ui.plugin(DateTimePicker);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1172:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("oX25");

/***/ })

/******/ });

/***/ }),

/***/ "EFuj":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1589);
	module.exports = __webpack_require__(1589);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 953:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1033:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("wIIu");

/***/ }),

/***/ 1589:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20), __webpack_require__(953), __webpack_require__(1590), __webpack_require__(1033), __webpack_require__(1591) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {

	    "use strict";

	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    // jshint eqnull:true

	    var $ = kendo.jQuery;

	    var EDITORS = {};

	    var registerEditor = kendo.spreadsheet.registerEditor = function(name, editor) {
	        EDITORS[name] = editor;
	    };

	    kendo.spreadsheet.Sheet.prototype.activeCellCustomEditor = function() {
	        var cell = this.activeCell().first();

	        if (this.range(cell).enable()) {
	            var val = this.validation(cell);
	            var key = this._properties.get("editor", this._grid.cellRefIndex(cell));
	            var editor;

	            if (key != null) {
	                editor = EDITORS[key];
	            }
	            else if (val && val.showButton) {
	                key = "_validation_" + val.dataType;
	                editor = EDITORS[key];
	            }

	            if (typeof editor == "function") {
	                editor = EDITORS[key] = editor();
	            }

	            return editor;
	        }
	    };

	    registerEditor("_validation_date", function(){
	        var context, calendar, popup;

	        function create() {
	            if (!calendar) {
	                calendar = $("<div>").kendoCalendar();
	                popup = $("<div>").kendoPopup();
	                calendar.appendTo(popup);
	                calendar = calendar.getKendoCalendar();
	                popup = popup.getKendoPopup();

	                calendar.bind("change", function(){
	                    popup.close();
	                    var date = calendar.value();
	                    if (!context.range.format()) {
	                        context.range.format("yyyy-mm-dd");
	                    }
	                    context.callback(kendo.spreadsheet.dateToNumber(date));
	                });
	            }
	            popup.setOptions({
	                anchor: context.view.element.find(".k-spreadsheet-editor-button")
	            });
	        }

	        function open() {
	            create();

	            var date = context.range.value();
	            var sheet = context.range.sheet();
	            if (date != null) {
	                calendar.value(kendo.spreadsheet.numberToDate(date));
	            } else {
	                calendar.value(null);
	            }
	            var val = context.validation;
	            if (val) {
	                var min = kendo.ui.Calendar.fn.options.min;
	                var max = kendo.ui.Calendar.fn.options.max;
	                var fromValidation = val.from;
	                var toValidation = val.to;
	                var formula = kendo.spreadsheet.calc.runtime.Formula;

	                if (/^(?:greaterThan|between)/.test(val.comparerType)) {
	                    if(fromValidation instanceof formula && _rowAndColPresent(fromValidation.value)) {
	                        min = kendo.spreadsheet.numberToDate(sheet.range(fromValidation.value.row, fromValidation.value.col).value());
	                    } else {
	                        min = kendo.spreadsheet.numberToDate(fromValidation.value);
	                    }
	                }
	                if (val.comparerType == "between") {
	                    if(toValidation instanceof formula && _rowAndColPresent(toValidation.value)) {
	                        max = kendo.spreadsheet.numberToDate(sheet.range(toValidation.value.row, toValidation.value.col).value());
	                    } else {
	                        max = kendo.spreadsheet.numberToDate(val.to.value);
	                    }
	                }
	                if (val.comparerType == "lessThan" || val.comparerType == "lessThanOrEqualTo") {
	                    if(fromValidation instanceof formula && _rowAndColPresent(fromValidation.value)) {
	                        max = kendo.spreadsheet.numberToDate(sheet.range(fromValidation.value.row, fromValidation.value.col).value());
	                    } else {
	                        max = kendo.spreadsheet.numberToDate(val.from.value);
	                    }
	                }
	                calendar.setOptions({
	                    disableDates: function(date) {
	                        var from, to;

	                        if(fromValidation && fromValidation instanceof formula && _rowAndColPresent(fromValidation.value)) {
	                            from = sheet.range(fromValidation.value.row, fromValidation.value.col).value();
	                        } else {
	                            from = fromValidation ? fromValidation.value|0 : 0;
	                        }

	                        if(toValidation && toValidation instanceof formula && _rowAndColPresent(toValidation.value)) {
	                            to = sheet.range(toValidation.value.row, toValidation.value.col).value();
	                        } else {
	                            to = toValidation ? toValidation.value|0 : 0;
	                        }

	                        date = kendo.spreadsheet.dateToNumber(date) | 0;
	                        return !kendo.spreadsheet.validation
	                            .validationComparers[val.comparerType](date, from, to);
	                    },
	                    min: min,
	                    max: max
	                });
	            } else {
	                calendar.setOptions({ disableDates: null, min: null, max: null });
	            }
	            popup.open();
	        }

	        function _rowAndColPresent(value) {
	            return (value && value.row !== null && value.col !== null && value.row > -1 && value.col > -1);
	        }

	        return {
	            edit: function(options) {
	                context = options;
	                open();
	            },
	            icon: "k-i-calendar"
	        };
	    });

	    registerEditor("_validation_list", function(){
	        var context, list, popup;
	        function create() {
	            if (!list) {
	                list = $("<ul class='k-list k-reset'/>").kendoStaticList({
	                    template   : "#:value#",
	                    selectable : true,
	                    autoBind   : false
	                });
	                popup = $("<div class='k-spreadsheet-list-popup'>").kendoPopup();
	                list.appendTo(popup);
	                popup = popup.getKendoPopup();
	                list = list.getKendoStaticList();

	                list.bind("change", function(){
	                    popup.close();
	                    var item = list.value()[0];
	                    if (item) {
	                        context.callback(item.value);
	                    }
	                });
	            }
	            popup.setOptions({
	                anchor: context.view.element.find(".k-spreadsheet-editor-button")
	            });
	        }
	        function open() {
	            create();
	            var items = context.validation.from.value;
	            var data = [], add = function(el){ data.push({ value: el }); };
	            if (items instanceof kendo.spreadsheet.calc.runtime.Matrix) {
	                items.each(add);
	            } else {
	                // actually Excel expects a simple string for list
	                // validation (comma-separated labels).
	                (items+"").split(/\s*,\s*/).forEach(add);
	            }
	            var dataSource = new kendo.data.DataSource({ data: data });
	            list.setDataSource(dataSource);
	            dataSource.read();
	            popup.open();
	        }
	        return {
	            edit: function(options) {
	                context = options;
	                open();
	            },
	            icon: "k-i-arrow-60-down"
	        };
	    });

	})(window.kendo);
	}, __webpack_require__(3));


/***/ }),

/***/ 1590:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("f1E8");

/***/ }),

/***/ 1591:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("+FHp");

/***/ })

/******/ });

/***/ }),

/***/ "EOXx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var floatingFilter_1 = __webpack_require__("MwUU");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var floatingFilterWrapper_1 = __webpack_require__("RoH2");
var filterManager_1 = __webpack_require__("Up6z");
var componentResolver_1 = __webpack_require__("migL");
var utils_1 = __webpack_require__("IRr6");
var overlayWrapperComponent_1 = __webpack_require__("SOT/");
var gridApi_1 = __webpack_require__("BAow");
var columnApi_1 = __webpack_require__("E/Wy");
var ComponentType;
(function (ComponentType) {
    ComponentType[ComponentType["AG_GRID"] = 0] = "AG_GRID";
    ComponentType[ComponentType["FRAMEWORK"] = 1] = "FRAMEWORK";
})(ComponentType || (ComponentType = {}));
var ComponentRecipes = (function () {
    function ComponentRecipes() {
    }
    ComponentRecipes_1 = ComponentRecipes;
    ComponentRecipes.prototype.newDateComponent = function (params) {
        return this.componentResolver.createAgGridComponent(this.gridOptions, params, "dateComponent", {
            api: this.gridApi,
            columnApi: this.columnApi
        }, "agDateInput");
    };
    ComponentRecipes.prototype.newHeaderComponent = function (params) {
        return this.componentResolver.createAgGridComponent(params.column.getColDef(), params, "headerComponent", {
            api: this.gridApi,
            columnApi: this.columnApi,
            column: params.column,
            colDef: params.column.getColDef()
        }, "agColumnHeader");
    };
    ComponentRecipes.prototype.newHeaderGroupComponent = function (params) {
        return this.componentResolver.createAgGridComponent(params.columnGroup.getColGroupDef(), params, "headerGroupComponent", {
            api: this.gridApi,
            columnApi: this.columnApi
        }, "agColumnGroupHeader");
    };
    ComponentRecipes.prototype.newFloatingFilterWrapperComponent = function (column, params) {
        var _this = this;
        var colDef = column.getColDef();
        if (colDef.suppressFilter) {
            return this.newEmptyFloatingFilterWrapperComponent(column);
        }
        var defaultFloatingFilterType;
        if (!colDef.filter) {
            defaultFloatingFilterType = this.gridOptionsWrapper.isEnterprise() ? 'agSetColumnFloatingFilter' : 'agTextColumnFloatingFilter';
        }
        else if (typeof colDef.filter === 'string' && Object.keys(ComponentRecipes_1.filterToFloatingFilterNames).indexOf(colDef.filter) > -1) {
            defaultFloatingFilterType = ComponentRecipes_1.filterToFloatingFilterNames[colDef.filter];
        }
        var dynamicComponentParams = {
            column: column,
            colDef: colDef,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        var floatingFilter = this.componentResolver.createAgGridComponent(colDef, params, "floatingFilterComponent", dynamicComponentParams, defaultFloatingFilterType, false);
        var floatingFilterWrapperComponentParams = {
            column: column,
            floatingFilterComp: floatingFilter,
            suppressFilterButton: this.componentResolver.mergeParams(colDef, 'floatingFilterComponent', dynamicComponentParams, params).suppressFilterButton
        };
        if (!floatingFilter) {
            var filterComponent = this.getFilterComponentPrototype(colDef);
            if (filterComponent && !filterComponent.component.prototype.getModelAsString) {
                return this.newEmptyFloatingFilterWrapperComponent(column);
            }
            var rawModelFn_1 = params.currentParentModel;
            params.currentParentModel = function () {
                var parentPromise = _this.filterManager.getFilterComponent(column);
                return parentPromise.resolveNow(null, function (parent) { return parent.getModelAsString ? parent.getModelAsString(rawModelFn_1()) : null; });
            };
            floatingFilterWrapperComponentParams.floatingFilterComp = utils_1.Promise.resolve(this.componentResolver.createInternalAgGridComponent(floatingFilter_1.ReadModelAsStringFloatingFilterComp, params));
        }
        return this.componentResolver.createInternalAgGridComponent(floatingFilterWrapper_1.FloatingFilterWrapperComp, floatingFilterWrapperComponentParams);
    };
    ComponentRecipes.prototype.newFullWidthGroupRowInnerCellRenderer = function (params) {
        return this.componentResolver.createAgGridComponent(this.gridOptions, params, "groupRowInnerRenderer", params, null, false);
    };
    ComponentRecipes.prototype.newCellRenderer = function (target, params) {
        return this.componentResolver.createAgGridComponent(target, params, "cellRenderer", params, null, false);
    };
    ComponentRecipes.prototype.newInnerCellRenderer = function (target, params) {
        return this.componentResolver.createAgGridComponent(target, params, "innerRenderer", params, null);
    };
    ComponentRecipes.prototype.newFullRowGroupRenderer = function (params) {
        return this.componentResolver.createAgGridComponent(this.gridOptionsWrapper, params, "fullWidthCellRenderer", params, null);
    };
    ComponentRecipes.prototype.newOverlayWrapperComponent = function () {
        return this.componentResolver.createInternalAgGridComponent(overlayWrapperComponent_1.OverlayWrapperComponent, null);
    };
    ComponentRecipes.prototype.newLoadingOverlayComponent = function () {
        return this.componentResolver.createAgGridComponent(this.gridOptions, null, "loadingOverlayComponent", {
            api: this.gridApi,
            columnApi: this.columnApi
        }, "agLoadingOverlay");
    };
    ComponentRecipes.prototype.newNoRowsOverlayComponent = function () {
        return this.componentResolver.createAgGridComponent(this.gridOptions, null, "noRowsOverlayComponent", {
            api: this.gridApi,
            columnApi: this.columnApi
        }, "agNoRowsOverlay");
    };
    ComponentRecipes.prototype.getFilterComponentPrototype = function (colDef) {
        return this.componentResolver.getComponentToUse(colDef, "filter", {
            api: this.gridApi,
            columnApi: this.columnApi,
            colDef: colDef
        });
    };
    ComponentRecipes.prototype.newEmptyFloatingFilterWrapperComponent = function (column) {
        var floatingFilterWrapperComponentParams = {
            column: column,
            floatingFilterComp: null
        };
        return this.componentResolver.createInternalAgGridComponent(floatingFilterWrapper_1.EmptyFloatingFilterWrapperComp, floatingFilterWrapperComponentParams);
    };
    ComponentRecipes.filterToFloatingFilterNames = {
        set: 'agSetColumnFloatingFilter',
        agSetColumnFilter: 'agSetColumnFloatingFilter',
        number: 'agNumberColumnFloatingFilter',
        agNumberColumnFilter: 'agNumberColumnFloatingFilter',
        date: 'agDateColumnFloatingFilter',
        agDateColumnFilter: 'agDateColumnFloatingFilter',
        text: 'agTextColumnFloatingFilter',
        agTextColumnFilter: 'agTextColumnFloatingFilter'
    };
    __decorate([
        context_1.Autowired("componentResolver"),
        __metadata("design:type", componentResolver_1.ComponentResolver)
    ], ComponentRecipes.prototype, "componentResolver", void 0);
    __decorate([
        context_1.Autowired("gridOptions"),
        __metadata("design:type", Object)
    ], ComponentRecipes.prototype, "gridOptions", void 0);
    __decorate([
        context_1.Autowired("gridApi"),
        __metadata("design:type", gridApi_1.GridApi)
    ], ComponentRecipes.prototype, "gridApi", void 0);
    __decorate([
        context_1.Autowired("columnApi"),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], ComponentRecipes.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired("gridOptionsWrapper"),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], ComponentRecipes.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('filterManager'),
        __metadata("design:type", filterManager_1.FilterManager)
    ], ComponentRecipes.prototype, "filterManager", void 0);
    ComponentRecipes = ComponentRecipes_1 = __decorate([
        context_1.Bean('componentRecipes')
    ], ComponentRecipes);
    return ComponentRecipes;
    var ComponentRecipes_1;
}());
exports.ComponentRecipes = ComponentRecipes;


/***/ }),

/***/ "EqjI":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "Ewux":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var expressionService_1 = __webpack_require__("1aUC");
var StylingService = (function () {
    function StylingService() {
    }
    StylingService.prototype.processAllCellClasses = function (colDef, params, onApplicableClass, onNotApplicableClass) {
        this.processClassRules(colDef.cellClassRules, params, onApplicableClass, onNotApplicableClass);
        this.processStaticCellClasses(colDef, params, onApplicableClass);
    };
    StylingService.prototype.processClassRules = function (classRules, params, onApplicableClass, onNotApplicableClass) {
        if (typeof classRules === 'object' && classRules !== null) {
            var classNames = Object.keys(classRules);
            for (var i = 0; i < classNames.length; i++) {
                var className = classNames[i];
                var rule = classRules[className];
                var resultOfRule = void 0;
                if (typeof rule === 'string') {
                    resultOfRule = this.expressionService.evaluate(rule, params);
                }
                else if (typeof rule === 'function') {
                    resultOfRule = rule(params);
                }
                if (resultOfRule) {
                    onApplicableClass(className);
                }
                else if (onNotApplicableClass) {
                    onNotApplicableClass(className);
                }
            }
        }
    };
    StylingService.prototype.processStaticCellClasses = function (colDef, params, onApplicableClass) {
        var cellClass = colDef.cellClass;
        if (cellClass) {
            var classOrClasses = void 0;
            if (typeof colDef.cellClass === 'function') {
                var cellClassFunc = colDef.cellClass;
                classOrClasses = cellClassFunc(params);
            }
            else {
                classOrClasses = colDef.cellClass;
            }
            if (typeof classOrClasses === 'string') {
                onApplicableClass(classOrClasses);
            }
            else if (Array.isArray(classOrClasses)) {
                classOrClasses.forEach(function (cssClassItem) {
                    onApplicableClass(cssClassItem);
                });
            }
        }
    };
    __decorate([
        context_1.Autowired('expressionService'),
        __metadata("design:type", expressionService_1.ExpressionService)
    ], StylingService.prototype, "expressionService", void 0);
    StylingService = __decorate([
        context_1.Bean('stylingService')
    ], StylingService);
    return StylingService;
}());
exports.StylingService = StylingService;


/***/ }),

/***/ "F4EX":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1328);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FZAa");

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Dz7c");

/***/ }),

/***/ 1328:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* jshint multistr: true */
	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1104), __webpack_require__(1088) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.switch",
	    name: "Switch",
	    category: "mobile",
	    description: "The mobile Switch widget is used to display two exclusive choices.",
	    depends: [ "fx", "userevents" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.mobile.ui,
	        outerWidth = kendo._outerWidth,
	        Widget = ui.Widget,
	        support = kendo.support,
	        CHANGE = "change",
	        SWITCHON = "switch-on",
	        SWITCHOFF = "switch-off",
	        MARGINLEFT = "margin-left",
	        ACTIVE_STATE = "state-active",
	        DISABLED_STATE = "state-disabled",
	        DISABLED = "disabled",
	        RESOLVEDPREFIX = support.transitions.css === undefined ? "" : support.transitions.css,
	        TRANSFORMSTYLE = RESOLVEDPREFIX + "transform",
	        proxy = $.proxy;

	    function className(name) {
	        return "km-" + name;
	    }

	    function limitValue(value, minLimit, maxLimit) {
	        return Math.max(minLimit, Math.min(maxLimit, value));
	    }

	    var SWITCH_MARKUP = '<span class="' + className("switch") + ' ' + className("widget") + '">\
	        <span class="' + className("switch-wrapper") + '">\
	            <span class="' + className("switch-background") + '"></span>\
	        </span> \
	        <span class="' + className("switch-container") + '">\
	            <span class="' + className("switch-handle") + '"> \
	                <span class="' + className("switch-label-on") + '">{0}</span> \
	                <span class="' + className("switch-label-off") + '">{1}</span> \
	            </span> \
	        </span>\
	    </span>';

	    var Switch = Widget.extend({
	        init: function(element, options) {
	            var that = this, checked;

	            Widget.fn.init.call(that, element, options);

	            options = that.options;

	            that.wrapper = $(kendo.format(SWITCH_MARKUP, options.onLabel, options.offLabel));
	            that.handle = that.wrapper.find(".km-switch-handle");
	            that.background = that.wrapper.find(".km-switch-background");
	            that.wrapper.insertBefore(that.element).prepend(that.element);

	            that._drag();

	            that.origin = parseInt(that.background.css(MARGINLEFT), 10);

	            that.constrain = 0;
	            that.snapPoint = 0;

	            element = that.element[0];
	            element.type = "checkbox";
	            that._animateBackground = true;

	            checked = that.options.checked;

	            if (checked === null) {
	                checked = element.checked;
	            }

	            that.check(checked);

	            that.options.enable = that.options.enable && !that.element.attr(DISABLED);
	            that.enable(that.options.enable);

	            that.refresh();
	            kendo.notify(that, kendo.mobile.ui);
	        },

	        refresh: function() {
	            var that = this,
	                handleWidth = outerWidth(that.handle, true);

	            that.width = that.wrapper.width();

	            that.constrain  = that.width - handleWidth;
	            that.snapPoint = that.constrain / 2;

	            if (typeof that.origin != "number") {
	                that.origin = parseInt(that.background.css(MARGINLEFT), 10);
	            }

	            that.background.data("origin", that.origin);

	            that.check(that.element[0].checked);
	        },

	        events: [
	            CHANGE
	        ],

	        options: {
	            name: "Switch",
	            onLabel: "on",
	            offLabel: "off",
	            checked: null,
	            enable: true
	        },

	        check: function(check) {
	            var that = this,
	                element = that.element[0];

	            if (check === undefined) {
	                return element.checked;
	            }

	            that._position(check ? that.constrain : 0);
	            element.checked = check;
	            that.wrapper
	                .toggleClass(className(SWITCHON), check)
	                .toggleClass(className(SWITCHOFF), !check);
	        },

	        // alias for check, NG support
	        value: function() {
	            return this.check.apply(this, arguments);
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            this.userEvents.destroy();
	        },

	        toggle: function() {
	            var that = this;

	            that.check(!that.element[0].checked);
	        },

	        enable: function(enable) {
	            var element = this.element,
	                wrapper = this.wrapper;

	            if(typeof enable == "undefined") {
	                enable = true;
	            }

	            this.options.enable = enable;

	            if(enable) {
	                element.removeAttr(DISABLED);
	            } else {
	                element.attr(DISABLED, DISABLED);
	            }

	            wrapper.toggleClass(className(DISABLED_STATE), !enable);
	        },

	        _resize: function() {
	            this.refresh();
	        },

	        _move: function(e) {
	            var that = this;
	            e.preventDefault();
	            that._position(limitValue(that.position + e.x.delta, 0, that.width - outerWidth(that.handle, true)));
	        },

	        _position: function(position) {
	            var that = this;

	            that.position = position;
	            that.handle.css(TRANSFORMSTYLE, "translatex(" + position + "px)");

	            if (that._animateBackground) {
	                that.background.css(MARGINLEFT, that.origin + position);
	            }
	        },

	        _start: function() {
	            if(!this.options.enable) {
	                this.userEvents.cancel();
	            } else {
	                this.userEvents.capture();
	                this.handle.addClass(className(ACTIVE_STATE));
	            }
	        },

	        _stop: function() {
	            var that = this;

	            that.handle.removeClass(className(ACTIVE_STATE));
	            that._toggle(that.position > that.snapPoint);
	        },

	        _toggle: function (checked) {
	            var that = this,
	                handle = that.handle,
	                element = that.element[0],
	                value = element.checked,
	                duration = kendo.mobile.application && kendo.mobile.application.os.wp ? 100 : 200,
	                distance;

	            that.wrapper
	                .toggleClass(className(SWITCHON), checked)
	                .toggleClass(className(SWITCHOFF), !checked);

	            that.position = distance = checked * that.constrain;

	            if (that._animateBackground) {
	                that.background
	                    .kendoStop(true, true)
	                    .kendoAnimate({ effects: "slideMargin", offset: distance, reset: true, reverse: !checked, axis: "left", duration: duration });
	            }

	            handle
	                .kendoStop(true, true)
	                .kendoAnimate({
	                    effects: "slideTo",
	                    duration: duration,
	                    offset: distance + "px,0",
	                    reset: true,
	                    complete: function () {
	                        if (value !== checked) {
	                            element.checked = checked;
	                            that.trigger(CHANGE, { checked: checked });
	                        }
	                    }
	                });
	        },

	        _drag: function() {
	            var that = this;

	            that.userEvents = new kendo.UserEvents(that.wrapper, {
	                fastTap: true,
	                tap: function() {
	                    if(that.options.enable) {
	                        that._toggle(!that.element[0].checked);
	                    }
	                },
	                start: proxy(that._start, that),
	                move: proxy(that._move, that),
	                end: proxy(that._stop, that)
	            });
	        }
	    });

	    ui.plugin(Switch);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "F6Mk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

// to satisfy server side compilation
Object.defineProperty(exports, "__esModule", { value: true });
var globalObj = typeof global === 'undefined' ? {} : global;
globalObj.HTMLElement = typeof HTMLElement === 'undefined' ? {} : HTMLElement;
globalObj.HTMLButtonElement = typeof HTMLButtonElement === 'undefined' ? {} : HTMLButtonElement;
globalObj.HTMLSelectElement = typeof HTMLSelectElement === 'undefined' ? {} : HTMLSelectElement;
globalObj.HTMLInputElement = typeof HTMLInputElement === 'undefined' ? {} : HTMLInputElement;
globalObj.Node = typeof Node === 'undefined' ? {} : Node;
// columnController
var balancedColumnTreeBuilder_1 = __webpack_require__("WPdJ");
exports.BalancedColumnTreeBuilder = balancedColumnTreeBuilder_1.BalancedColumnTreeBuilder;
var columnController_1 = __webpack_require__("77lH");
exports.ColumnController = columnController_1.ColumnController;
var columnKeyCreator_1 = __webpack_require__("oPvZ");
exports.ColumnKeyCreator = columnKeyCreator_1.ColumnKeyCreator;
var columnUtils_1 = __webpack_require__("PAC5");
exports.ColumnUtils = columnUtils_1.ColumnUtils;
var displayedGroupCreator_1 = __webpack_require__("Tttz");
exports.DisplayedGroupCreator = displayedGroupCreator_1.DisplayedGroupCreator;
var groupInstanceIdCreator_1 = __webpack_require__("cERj");
exports.GroupInstanceIdCreator = groupInstanceIdCreator_1.GroupInstanceIdCreator;
// components
var componentUtil_1 = __webpack_require__("f42d");
exports.ComponentUtil = componentUtil_1.ComponentUtil;
var colDefUtil_1 = __webpack_require__("pVp3");
exports.ColDefUtil = colDefUtil_1.ColDefUtil;
var componentProvider_1 = __webpack_require__("evUn");
exports.ComponentProvider = componentProvider_1.ComponentProvider;
var agGridNg1_1 = __webpack_require__("lkJ8");
exports.initialiseAgGridWithAngular1 = agGridNg1_1.initialiseAgGridWithAngular1;
var agGridWebComponent_1 = __webpack_require__("gv34");
exports.initialiseAgGridWithWebComponents = agGridWebComponent_1.initialiseAgGridWithWebComponents;
// context
var beanStub_1 = __webpack_require__("xffp");
exports.BeanStub = beanStub_1.BeanStub;
var context_1 = __webpack_require__("RQ1/");
exports.Context = context_1.Context;
exports.Autowired = context_1.Autowired;
exports.PostConstruct = context_1.PostConstruct;
exports.PreConstruct = context_1.PreConstruct;
exports.Optional = context_1.Optional;
exports.Bean = context_1.Bean;
exports.Qualifier = context_1.Qualifier;
exports.PreDestroy = context_1.PreDestroy;
var componentAnnotations_1 = __webpack_require__("x5ih");
exports.QuerySelector = componentAnnotations_1.QuerySelector;
exports.Listener = componentAnnotations_1.Listener;
exports.RefSelector = componentAnnotations_1.RefSelector;
// dragAndDrop
var dragAndDropService_1 = __webpack_require__("I/uN");
exports.DragAndDropService = dragAndDropService_1.DragAndDropService;
exports.DragSourceType = dragAndDropService_1.DragSourceType;
exports.HDirection = dragAndDropService_1.HDirection;
exports.VDirection = dragAndDropService_1.VDirection;
var dragService_1 = __webpack_require__("ytBa");
exports.DragService = dragService_1.DragService;
// entities
var column_1 = __webpack_require__("hDyE");
exports.Column = column_1.Column;
var columnGroup_1 = __webpack_require__("YX13");
exports.ColumnGroup = columnGroup_1.ColumnGroup;
var gridCell_1 = __webpack_require__("hie4");
exports.GridCell = gridCell_1.GridCell;
var gridRow_1 = __webpack_require__("piWI");
exports.GridRow = gridRow_1.GridRow;
var originalColumnGroup_1 = __webpack_require__("pOb1");
exports.OriginalColumnGroup = originalColumnGroup_1.OriginalColumnGroup;
var rowNode_1 = __webpack_require__("bP2e");
exports.RowNode = rowNode_1.RowNode;
// filter
var baseFilter_1 = __webpack_require__("5yUf");
exports.BaseFilter = baseFilter_1.BaseFilter;
var dateFilter_1 = __webpack_require__("TgGN");
exports.DateFilter = dateFilter_1.DateFilter;
var filterManager_1 = __webpack_require__("Up6z");
exports.FilterManager = filterManager_1.FilterManager;
var numberFilter_1 = __webpack_require__("6cDV");
exports.NumberFilter = numberFilter_1.NumberFilter;
var textFilter_1 = __webpack_require__("G5+n");
exports.TextFilter = textFilter_1.TextFilter;
// gridPanel
var gridPanel_1 = __webpack_require__("inOk");
exports.GridPanel = gridPanel_1.GridPanel;
var scrollVisibleService_1 = __webpack_require__("5AnZ");
exports.ScrollVisibleService = scrollVisibleService_1.ScrollVisibleService;
var mouseEventService_1 = __webpack_require__("BY3/");
exports.MouseEventService = mouseEventService_1.MouseEventService;
// headerRendering
var bodyDropPivotTarget_1 = __webpack_require__("PobA");
exports.BodyDropPivotTarget = bodyDropPivotTarget_1.BodyDropPivotTarget;
var bodyDropTarget_1 = __webpack_require__("0B0E");
exports.BodyDropTarget = bodyDropTarget_1.BodyDropTarget;
var cssClassApplier_1 = __webpack_require__("NRBX");
exports.CssClassApplier = cssClassApplier_1.CssClassApplier;
var headerContainer_1 = __webpack_require__("NtVV");
exports.HeaderContainer = headerContainer_1.HeaderContainer;
var headerRenderer_1 = __webpack_require__("U9s4");
exports.HeaderRenderer = headerRenderer_1.HeaderRenderer;
var headerRowComp_1 = __webpack_require__("vuuZ");
exports.HeaderRowComp = headerRowComp_1.HeaderRowComp;
var horizontalDragService_1 = __webpack_require__("jJge");
exports.HorizontalDragService = horizontalDragService_1.HorizontalDragService;
var moveColumnController_1 = __webpack_require__("7JmM");
exports.MoveColumnController = moveColumnController_1.MoveColumnController;
var standardMenu_1 = __webpack_require__("aXhp");
exports.StandardMenuFactory = standardMenu_1.StandardMenuFactory;
// layout
var borderLayout_1 = __webpack_require__("twlb");
exports.BorderLayout = borderLayout_1.BorderLayout;
var tabbedLayout_1 = __webpack_require__("TM1e");
exports.TabbedLayout = tabbedLayout_1.TabbedLayout;
var verticalStack_1 = __webpack_require__("RnIf");
exports.VerticalStack = verticalStack_1.VerticalStack;
// misc
var simpleHttpRequest_1 = __webpack_require__("CF4A");
exports.simpleHttpRequest = simpleHttpRequest_1.simpleHttpRequest;
var largeTextCellEditor_1 = __webpack_require__("USml");
exports.LargeTextCellEditor = largeTextCellEditor_1.LargeTextCellEditor;
var popupEditorWrapper_1 = __webpack_require__("KnXB");
exports.PopupEditorWrapper = popupEditorWrapper_1.PopupEditorWrapper;
var popupSelectCellEditor_1 = __webpack_require__("33E9");
exports.PopupSelectCellEditor = popupSelectCellEditor_1.PopupSelectCellEditor;
var popupTextCellEditor_1 = __webpack_require__("Nrvl");
exports.PopupTextCellEditor = popupTextCellEditor_1.PopupTextCellEditor;
var selectCellEditor_1 = __webpack_require__("POfv");
exports.SelectCellEditor = selectCellEditor_1.SelectCellEditor;
var textCellEditor_1 = __webpack_require__("U6ln");
exports.TextCellEditor = textCellEditor_1.TextCellEditor;
var animateShowChangeCellRenderer_1 = __webpack_require__("jeRM");
exports.AnimateShowChangeCellRenderer = animateShowChangeCellRenderer_1.AnimateShowChangeCellRenderer;
var animateSlideCellRenderer_1 = __webpack_require__("Vn5t");
exports.AnimateSlideCellRenderer = animateSlideCellRenderer_1.AnimateSlideCellRenderer;
var groupCellRenderer_1 = __webpack_require__("sYFB");
exports.GroupCellRenderer = groupCellRenderer_1.GroupCellRenderer;
// features
var setLeftFeature_1 = __webpack_require__("yLI2");
exports.SetLeftFeature = setLeftFeature_1.SetLeftFeature;
// rendering
var autoWidthCalculator_1 = __webpack_require__("y9Zr");
exports.AutoWidthCalculator = autoWidthCalculator_1.AutoWidthCalculator;
var cellEditorFactory_1 = __webpack_require__("x4W5");
exports.CellEditorFactory = cellEditorFactory_1.CellEditorFactory;
var cellRendererFactory_1 = __webpack_require__("9WGm");
exports.CellRendererFactory = cellRendererFactory_1.CellRendererFactory;
var cellRendererService_1 = __webpack_require__("sr48");
exports.CellRendererService = cellRendererService_1.CellRendererService;
var checkboxSelectionComponent_1 = __webpack_require__("B21I");
exports.CheckboxSelectionComponent = checkboxSelectionComponent_1.CheckboxSelectionComponent;
var cellComp_1 = __webpack_require__("wTNE");
exports.CellComp = cellComp_1.CellComp;
var rowComp_1 = __webpack_require__("ci/Y");
exports.RowComp = rowComp_1.RowComp;
var rowRenderer_1 = __webpack_require__("3RUv");
exports.RowRenderer = rowRenderer_1.RowRenderer;
var valueFormatterService_1 = __webpack_require__("vFc7");
exports.ValueFormatterService = valueFormatterService_1.ValueFormatterService;
// rowControllers/inMemory
var filterStage_1 = __webpack_require__("Zn08");
exports.FilterStage = filterStage_1.FilterStage;
var flattenStage_1 = __webpack_require__("/PKt");
exports.FlattenStage = flattenStage_1.FlattenStage;
var sortStage_1 = __webpack_require__("DGeU");
exports.SortStage = sortStage_1.SortStage;
// row models
var pinnedRowModel_1 = __webpack_require__("xRx6");
exports.PinnedRowModel = pinnedRowModel_1.PinnedRowModel;
var inMemoryRowModel_1 = __webpack_require__("2Le/");
exports.InMemoryRowModel = inMemoryRowModel_1.InMemoryRowModel;
var changedPath_1 = __webpack_require__("ODdY");
exports.ChangedPath = changedPath_1.ChangedPath;
var inMemoryNodeManager_1 = __webpack_require__("mhUy");
exports.InMemoryNodeManager = inMemoryNodeManager_1.InMemoryNodeManager;
var infiniteRowModel_1 = __webpack_require__("NTM1");
exports.InfiniteRowModel = infiniteRowModel_1.InfiniteRowModel;
var rowNodeBlock_1 = __webpack_require__("8wuL");
exports.RowNodeBlock = rowNodeBlock_1.RowNodeBlock;
var rowNodeBlockLoader_1 = __webpack_require__("NFvU");
exports.RowNodeBlockLoader = rowNodeBlockLoader_1.RowNodeBlockLoader;
var rowNodeCache_1 = __webpack_require__("sc2Y");
exports.RowNodeCache = rowNodeCache_1.RowNodeCache;
//styling
var stylingService_1 = __webpack_require__("Ewux");
exports.StylingService = stylingService_1.StylingService;
// widgets
var agCheckbox_1 = __webpack_require__("0Gxk");
exports.AgCheckbox = agCheckbox_1.AgCheckbox;
var component_1 = __webpack_require__("pQ38");
exports.Component = component_1.Component;
var popupService_1 = __webpack_require__("LnC7");
exports.PopupService = popupService_1.PopupService;
var touchListener_1 = __webpack_require__("G4uV");
exports.TouchListener = touchListener_1.TouchListener;
// root
var baseFrameworkFactory_1 = __webpack_require__("FpOn");
exports.BaseFrameworkFactory = baseFrameworkFactory_1.BaseFrameworkFactory;
var cellNavigationService_1 = __webpack_require__("Cz2g");
exports.CellNavigationService = cellNavigationService_1.CellNavigationService;
var alignedGridsService_1 = __webpack_require__("sHqg");
exports.AlignedGridsService = alignedGridsService_1.AlignedGridsService;
var constants_1 = __webpack_require__("ZZFX");
exports.Constants = constants_1.Constants;
var csvCreator_1 = __webpack_require__("SdeK");
exports.CsvCreator = csvCreator_1.CsvCreator;
exports.BaseCreator = csvCreator_1.BaseCreator;
var downloader_1 = __webpack_require__("/d84");
exports.Downloader = downloader_1.Downloader;
var grid_1 = __webpack_require__("5ela");
exports.Grid = grid_1.Grid;
var gridApi_1 = __webpack_require__("BAow");
exports.GridApi = gridApi_1.GridApi;
var events_1 = __webpack_require__("3ok8");
exports.Events = events_1.Events;
var focusedCellController_1 = __webpack_require__("4Sr9");
exports.FocusedCellController = focusedCellController_1.FocusedCellController;
var functions_1 = __webpack_require__("JCBf");
exports.defaultGroupComparator = functions_1.defaultGroupComparator;
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
exports.GridOptionsWrapper = gridOptionsWrapper_1.GridOptionsWrapper;
var eventService_1 = __webpack_require__("k5uU");
exports.EventService = eventService_1.EventService;
var gridCore_1 = __webpack_require__("b9np");
exports.GridCore = gridCore_1.GridCore;
var logger_1 = __webpack_require__("U9Xd");
exports.Logger = logger_1.Logger;
var selectionController_1 = __webpack_require__("D4cr");
exports.SelectionController = selectionController_1.SelectionController;
var sortController_1 = __webpack_require__("fxGZ");
exports.SortController = sortController_1.SortController;
var templateService_1 = __webpack_require__("0vz1");
exports.TemplateService = templateService_1.TemplateService;
var utils_1 = __webpack_require__("IRr6");
exports.Utils = utils_1.Utils;
exports.NumberSequence = utils_1.NumberSequence;
exports._ = utils_1._;
exports.Promise = utils_1.Promise;
var valueService_1 = __webpack_require__("5JVC");
exports.ValueService = valueService_1.ValueService;
var expressionService_1 = __webpack_require__("1aUC");
exports.ExpressionService = expressionService_1.ExpressionService;
var xmlFactory_1 = __webpack_require__("XBCZ");
exports.XmlFactory = xmlFactory_1.XmlFactory;
var gridSerializer_1 = __webpack_require__("39p0");
exports.GridSerializer = gridSerializer_1.GridSerializer;
exports.BaseGridSerializingSession = gridSerializer_1.BaseGridSerializingSession;
exports.RowType = gridSerializer_1.RowType;
var logger_2 = __webpack_require__("U9Xd");
exports.LoggerFactory = logger_2.LoggerFactory;
var columnApi_1 = __webpack_require__("E/Wy");
exports.ColumnApi = columnApi_1.ColumnApi;
var frameworkComponentWrapper_1 = __webpack_require__("sM3J");
exports.BaseComponentWrapper = frameworkComponentWrapper_1.BaseComponentWrapper;
var environment_1 = __webpack_require__("JLYF");
exports.Environment = environment_1.Environment;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "F92I":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(889);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(890)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {

	    var dataviz = kendo.dataviz;
	    var services = dataviz.services;
	    var draw = kendo.drawing;

	    dataviz.SASS_THEMES = ["sass", "default-v2", "bootstrap-v4", "material-v2"];

	    dataviz.ExportMixin = {
	        extend: function(proto, skipLegacy) {
	            if (!proto.exportVisual) {
	                throw new Error("Mixin target has no exportVisual method defined.");
	            }

	            proto.exportSVG = this.exportSVG;
	            proto.exportImage = this.exportImage;
	            proto.exportPDF = this.exportPDF;

	            if (!skipLegacy) {
	                proto.svg = this.svg;
	                proto.imageDataURL = this.imageDataURL;
	            }
	        },

	        exportSVG: function(options) {
	            return draw.exportSVG(this.exportVisual(), options);
	        },

	        exportImage: function(options) {
	            return draw.exportImage(this.exportVisual(options), options);
	        },

	        exportPDF: function(options) {
	            return draw.exportPDF(this.exportVisual(), options);
	        },

	        svg: function() {
	            if (draw.svg.Surface) {
	                return draw.svg.exportGroup(this.exportVisual());
	            } else {
	                throw new Error("SVG Export failed. Unable to export instantiate kendo.drawing.svg.Surface");
	            }
	        },

	        imageDataURL: function() {
	            if (!kendo.support.canvas) {
	                return null;
	            }

	            if (draw.canvas.Surface) {
	                var container = $("<div />").css({
	                    display: "none",
	                    width: this.element.width(),
	                    height: this.element.height()
	                }).appendTo(document.body);

	                var surface = new draw.canvas.Surface(container[0]);
	                surface.draw(this.exportVisual());
	                var image = surface._rootElement.toDataURL();

	                surface.destroy();
	                container.remove();

	                return image;
	            } else {
	                throw new Error("Image Export failed. Unable to export instantiate kendo.drawing.canvas.Surface");
	            }
	        }
	    };

	    services.IntlService.register({
	       format: function(format) {
	           return kendo.format.apply(null, [format].concat(Array.prototype.slice.call(arguments, 1)));
	       },
	       toString: kendo.toString,
	       parseDate: kendo.parseDate,
	       firstDay: function() {
	           return kendo.culture().calendars.standard.firstDay;
	       }
	    });

	    services.TemplateService.register({
	       compile: kendo.template
	    });

	    dataviz.Point2D = dataviz.Point;
	    dataviz.Box2D = dataviz.Box;
	    dataviz.mwDelta = function(e) {
	        return dataviz.mousewheelDelta(e.originalEvent);
	    };

	})(window.kendo.jQuery);

	}, __webpack_require__(3));

/***/ }),

/***/ 890:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("rs+d");

/***/ })

/******/ });

/***/ }),

/***/ "FPoQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1425);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1048:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("BOhp");

/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1425:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1059) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "tabstrip",
	    name: "TabStrip",
	    category: "web",
	    description: "The TabStrip widget displays a collection of tabs with associated tab content.",
	    depends: [ "data" ],
	    features: [ {
	        id: "tabstrip-fx",
	        name: "Animation",
	        description: "Support for animation",
	        depends: [ "fx" ]
	    } ]
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        keys = kendo.keys,
	        map = $.map,
	        each = $.each,
	        trim = kendo.trim,
	        extend = $.extend,
	        isFunction = kendo.isFunction,
	        template = kendo.template,
	        outerWidth = kendo._outerWidth,
	        outerHeight = kendo._outerHeight,
	        Widget = ui.Widget,
	        excludedNodesRegExp = /^(a|div)$/i,
	        NS = ".kendoTabStrip",
	        IMG = "img",
	        HREF = "href",
	        PREV = "prev",
	        NEXT = "next",
	        SHOW = "show",
	        LINK = "k-link",
	        LAST = "k-last",
	        CLICK = "click",
	        ERROR = "error",
	        EMPTY = ":empty",
	        IMAGE = "k-image",
	        FIRST = "k-first",
	        SELECT = "select",
	        ACTIVATE = "activate",
	        CONTENT = "k-content",
	        CONTENTURL = "contentUrl",
	        MOUSEENTER = "mouseenter",
	        MOUSELEAVE = "mouseleave",
	        CONTENTLOAD = "contentLoad",
	        DISABLEDSTATE = "k-state-disabled",
	        DEFAULTSTATE = "k-state-default",
	        ACTIVESTATE = "k-state-active",
	        FOCUSEDSTATE = "k-state-focused",
	        HOVERSTATE = "k-state-hover",
	        TABONTOP = "k-tab-on-top",
	        NAVIGATABLEITEMS = ".k-item:not(." + DISABLEDSTATE + ")",
	        KEYBOARDNAVIGATABLEITEMS = ".k-item",
	        HOVERABLEITEMS = ".k-tabstrip-items > " + NAVIGATABLEITEMS + ":not(." + ACTIVESTATE + ")",
	        DEFAULTDISTANCE = 200,

	        templates = {
	            content: template(
	                "<div class='k-content'#= contentAttributes(data) # role='tabpanel' tabindex='0'>#= content(item) #</div>"
	            ),
	            itemWrapper: template(
	                "<#= tag(item) # class='k-link'#= contentUrl(item) ##= textAttributes(item) #>" +
	                    "#= image(item) ##= sprite(item) ##= text(item) #" +
	                "</#= tag(item) #>"
	            ),
	            item: template(
	                "<li class='#= wrapperCssClass(group, item) #' role='tab' #=item.active ? \"aria-selected='true'\" : ''#>" +
	                    "#= itemWrapper(data) #" +
	                "</li>"
	            ),
	            image: template("<img class='k-image' alt='' src='#= imageUrl #' />"),
	            sprite: template("<span class='k-sprite #= spriteCssClass #'></span>"),
	            empty: template("")
	        },

	        rendering = {
	            wrapperCssClass: function (group, item) {
	                var result = "k-item",
	                    index = item.index;

	                if (item.enabled === false) {
	                    result += " k-state-disabled";
	                } else {
	                    result += " k-state-default";
	                }

	                if (index === 0) {
	                    result += " k-first";
	                }

	                if (index == group.length-1) {
	                    result += " k-last";
	                }

	                return result;
	            },
	            textAttributes: function(item) {
	                return item.url ? " href='" + item.url + "'" : "";
	            },
	            text: function(item) {
	                return item.encoded === false ? item.text : kendo.htmlEncode(item.text);
	            },
	            tag: function(item) {
	                return item.url ? "a" : "span";
	            },
	            contentAttributes: function(content) {
	                return content.active !== true ? " style='display:none' aria-hidden='true' aria-expanded='false'" : "";
	            },
	            content: function(item) {
	                return item.content ? item.content : item.contentUrl ? "" : "&nbsp;";
	            },
	            contentUrl: function(item) {
	                return item.contentUrl ? kendo.attr("content-url") + '="' + item.contentUrl + '"' : "";
	            }
	        };

	    function updateTabClasses (tabs) {
	        tabs.children(IMG)
	            .addClass(IMAGE);

	        tabs.children("a")
	            .addClass(LINK)
	            .children(IMG)
	            .addClass(IMAGE);

	        tabs.filter(":not([disabled]):not([class*=k-state-disabled])")
	            .addClass(DEFAULTSTATE);

	        tabs.filter("li[disabled]")
	            .addClass(DISABLEDSTATE)
	            .attr("aria-disabled", "true")
	            .removeAttr("disabled");

	        tabs.filter(":not([class*=k-state])")
	            .children("a")
	            .filter(":focus")
	            .parent()
	            .addClass(ACTIVESTATE + " " + TABONTOP);

	        tabs.attr("role", "tab");
	        tabs.filter("." + ACTIVESTATE)
	            .attr("aria-selected", true);


	        tabs.each(function() {
	            var item = $(this);

	            if (!item.children("." + LINK).length) {
	                item
	                    .contents()      // exclude groups, real links, templates and empty text nodes
	                    .filter(function() { return (!this.nodeName.match(excludedNodesRegExp) && !(this.nodeType == 3 && !trim(this.nodeValue))); })
	                    .wrapAll("<span UNSELECTABLE='on' class='" + LINK + "'/>");
	            }
	        });

	    }

	    function updateFirstLast (tabGroup) {
	        var tabs = tabGroup.children(".k-item");

	        tabs.filter(".k-first:not(:first-child)").removeClass(FIRST);
	        tabs.filter(".k-last:not(:last-child)").removeClass(LAST);
	        tabs.filter(":first-child").addClass(FIRST);
	        tabs.filter(":last-child").addClass(LAST);
	    }

	    function scrollButtonHtml(buttonClass, iconClass) {
	        return "<span class='k-button k-button-icon k-flat k-tabstrip-" + buttonClass + "' unselectable='on'><span class='k-icon " + iconClass + "'></span></span>";
	    }

	    var TabStrip = Widget.extend({
	        init: function(element, options) {
	            var that = this, value;

	            Widget.fn.init.call(that, element, options);

	            that._animations(that.options);

	            options = that.options;

	            that._contentUrls = options.contentUrls || [];

	            that._wrapper();

	            that._isRtl = kendo.support.isRtl(that.wrapper);

	            that._tabindex();

	            that._updateClasses();

	            that._dataSource();

	            if (options.dataSource) {
	                that.dataSource.fetch();
	            }

	            that._tabPosition();

	            that._scrollable();

	            if (that._contentUrls.length) {
	                that.wrapper.find(".k-tabstrip-items > .k-item")
	                    .each(function(index, item) {
	                        var url = that._contentUrls[index];

	                        if (typeof url === 'string') {
	                            $(item).find(">." + LINK).data(CONTENTURL, url);
	                        }
	                    });
	            } else {
	                that._contentUrls.length = that.tabGroup.find("li.k-item").length;
	            }

	            that.wrapper
	                .on(MOUSEENTER + NS + " " + MOUSELEAVE + NS, HOVERABLEITEMS, that._toggleHover)
	                .on("focus" + NS, $.proxy(that._active, that))
	                .on("blur" + NS, function() { that._current(null); });

	            that._keyDownProxy = $.proxy(that._keydown, that);

	            if (options.navigatable) {
	                that.wrapper.on("keydown" + NS, that._keyDownProxy);
	            }

	            if (that.options.value) {
	                value = that.options.value;
	            }

	            that.wrapper.children(".k-tabstrip-items")
	                .on(CLICK + NS, ".k-state-disabled .k-link", false)
	                .on(CLICK + NS, " > " + NAVIGATABLEITEMS, function (e) {
	                    var wr = that.wrapper[0];
	                    if (wr !== document.activeElement) {
	                        var msie = kendo.support.browser.msie;
	                        if (msie) {
	                            try {
	                                // does not scroll to the active element
	                                wr.setActive();
	                            } catch (j) {
	                                wr.focus();
	                            }
	                        } else {
	                            wr.focus();
	                        }
	                    }

	                    if (that._click($(e.currentTarget))) {
	                        e.preventDefault();
	                    }
	                });

	            var selectedItems = that.tabGroup.children("li." + ACTIVESTATE),
	                content = that.contentHolder(selectedItems.index());

	            if (selectedItems[0] && content.length > 0 && content[0].childNodes.length === 0) {
	                that.activateTab(selectedItems.eq(0));
	            }

	            that.element.attr("role", "tablist");

	            that.value(value);
	            kendo.notify(that);
	        },

	        _active: function () {
	            var item = this.tabGroup.children().filter("." + ACTIVESTATE);

	            item = item[0] ? item : this._endItem("first");
	            if (item[0]) {
	                this._current(item);
	            }
	        },

	        _endItem: function(action) {
	            return this.tabGroup.children(NAVIGATABLEITEMS)[action]();
	        },

	        _getItem: function(action) {
	            return this.tabGroup.children(KEYBOARDNAVIGATABLEITEMS)[action]();
	        },

	        _item: function(item, action) {
	            var endItem;
	            if (action === PREV) {
	                endItem = "last";
	            } else {
	                endItem = "first";
	            }

	            if (!item) {
	                return this._endItem(endItem);
	            }

	            item = item[action]();

	            if (!item[0]) {
	                item = this.tabGroup.children(KEYBOARDNAVIGATABLEITEMS)[endItem]();
	            }

	            if (item.hasClass(DISABLEDSTATE)) {
	                item.addClass(FOCUSEDSTATE);
	            }
	            if (item.hasClass(DISABLEDSTATE) || item.hasClass(ACTIVESTATE)) {
	                this._focused = item;
	            }

	            return item;
	        },

	        _current: function (candidate) {
	            var that = this,
	                focused = that._focused;

	            if (candidate === undefined) {
	                return focused;
	            }

	            if (focused) {
	                focused.removeClass(FOCUSEDSTATE);
	            }

	            if (candidate) {
	                if (!candidate.hasClass(ACTIVESTATE)) {
	                    candidate.addClass(FOCUSEDSTATE);
	                }

	                if (candidate[0].id) {
	                    that.element.attr("aria-activedescendant", candidate[0].id);
	                }
	            }

	            that._focused = candidate;
	        },

	        _keydown: function(e) {
	            var that = this,
	                key = e.keyCode,
	                current = that._current(),
	                rtl = that._isRtl,
	                isHorizontal = /top|bottom/.test(that.options.tabPosition),
	                action;

	            if (e.target != e.currentTarget || !current) {
	                return;
	            }

	            if (key === keys.DOWN && !isHorizontal) {
	                action = NEXT;
	            } else if (key === keys.UP && !isHorizontal) {
	                action = PREV;
	            } else if (key === keys.RIGHT && isHorizontal) {
	                action = rtl ? PREV : NEXT;
	            } else if (key === keys.LEFT && isHorizontal) {
	                action = rtl ? NEXT : PREV;
	            } else if (key == keys.ENTER || key == keys.SPACEBAR) {
	                that._click(current);
	                e.preventDefault();
	            } else if (key == keys.HOME) {
	                that._click(that._getItem("first"));
	                e.preventDefault();
	                return;
	            } else if (key == keys.END) {
	                that._click(that._getItem("last"));
	                e.preventDefault();
	                return;
	            }

	            if (action) {
	                that._click(that._item(current, action));
	                e.preventDefault();
	            }
	        },

	        _dataSource: function() {
	            var that = this;

	            if (that.dataSource && that._refreshHandler) {
	                that.dataSource.unbind("change", that._refreshHandler);
	            } else {
	                that._refreshHandler = $.proxy(that.refresh, that);
	            }

	            that.dataSource = kendo.data.DataSource.create(that.options.dataSource)
	                                .bind("change", that._refreshHandler);
	        },

	        setDataSource: function(dataSource) {
	            var that = this;

	            that.options.dataSource = dataSource;
	            that._dataSource();
	            that.dataSource.fetch();
	        },

	        _animations: function(options) {
	            if (options && ("animation" in options) && !options.animation) {
	                options.animation = { open: { effects: {} }, close: { effects: {} } }; // No animation
	            }
	        },

	        refresh: function(e) {
	            var that = this,
	                options = that.options,
	                encoded = kendo.getter(options.dataEncodedField),
	                text = kendo.getter(options.dataTextField),
	                content = kendo.getter(options.dataContentField),
	                contentUrl = kendo.getter(options.dataContentUrlField),
	                image = kendo.getter(options.dataImageUrlField),
	                url = kendo.getter(options.dataUrlField),
	                sprite = kendo.getter(options.dataSpriteCssClass),
	                idx,
	                tabs = [],
	                tab,
	                action,
	                view = that.dataSource.view(),
	                length;


	            e = e || {};
	            action = e.action;

	            if (action) {
	               view = e.items;
	            }

	            for (idx = 0, length = view.length; idx < length; idx ++) {
	                tab = {
	                    text: text(view[idx])
	                };

	                if (options.dataEncodedField) {
	                    tab.encoded = encoded(view[idx]);
	                }

	                if (options.dataContentField) {
	                    tab.content = content(view[idx]);
	                }

	                if (options.dataContentUrlField) {
	                    tab.contentUrl = contentUrl(view[idx]);
	                }

	                if (options.dataUrlField) {
	                    tab.url = url(view[idx]);
	                }

	                if (options.dataImageUrlField) {
	                    tab.imageUrl = image(view[idx]);
	                }

	                if (options.dataSpriteCssClass) {
	                    tab.spriteCssClass = sprite(view[idx]);
	                }

	                tabs[idx] = tab;
	            }

	            if (e.action == "add") {
	                if (e.index < that.tabGroup.children().length) {
	                    that.insertBefore(tabs, that.tabGroup.children().eq(e.index));
	                } else {
	                    that.append(tabs);
	                }
	            } else if (e.action == "remove") {
	                for (idx = 0; idx < view.length; idx++) {
	                   that.remove(e.index);
	                }
	            } else if (e.action == "itemchange") {
	                idx = that.dataSource.view().indexOf(view[0]);
	                if (e.field === options.dataTextField) {
	                    that.tabGroup.children().eq(idx).find(".k-link").text(view[0].get(e.field));
	                }

	                if (e.field === options.dataUrlField) {
	                    that._contentUrls[idx] = view[0].get(e.field);
	                }
	            } else {
	                that.trigger("dataBinding");
	                that.remove("li");
	                that._contentUrls = [];
	                that.append(tabs);
	                that.trigger("dataBound");
	            }
	        },

	        value: function(value) {
	            var that = this;

	            if (value !== undefined) {
	                if (value != that.value()) {
	                   that.tabGroup.children().each(function() {
	                        if (kendo.trim($(this).text()) == value) {
	                            that.select(this);
	                        }
	                   });
	                }
	            } else {
	                return that.select().text();
	            }
	        },

	        items: function() {
	            return this.tabGroup[0].children;
	        },

	        setOptions: function(options) {
	            var that = this,
	                animation = that.options.animation;

	            that._animations(options);

	            if (options.contentUrls) {
	                that._contentUrls = options.contentUrls;
	            }

	            options.animation = extend(true, animation, options.animation);

	            if (options.navigatable) {
	                that.wrapper.on("keydown" + NS,  that._keyDownProxy);
	            } else {
	                that.wrapper.off("keydown" + NS,  that._keyDownProxy);
	            }

	            Widget.fn.setOptions.call(that, options);
	        },

	        events: [
	            SELECT,
	            ACTIVATE,
	            SHOW,
	            ERROR,
	            CONTENTLOAD,
	            "change",
	            "dataBinding",
	            "dataBound"
	        ],

	        options: {
	            name: "TabStrip",
	            dataEncodedField: "",
	            dataTextField: "",
	            dataContentField: "",
	            dataImageUrlField: "",
	            dataUrlField: "",
	            dataSpriteCssClass: "",
	            dataContentUrlField: "",
	            tabPosition: "top",
	            animation: {
	                open: {
	                    effects: "expand:vertical fadeIn",
	                    duration: 200
	                },
	                close: { // if close animation effects are defined, they will be used instead of open.reverse
	                    duration: 200
	                }
	            },
	            collapsible: false,
	            navigatable: true,
	            contentUrls: false,
	            scrollable: {
	                distance: DEFAULTDISTANCE
	            }
	        },

	        destroy: function() {
	            var that = this,
	            scrollWrap = that.scrollWrap;

	            Widget.fn.destroy.call(that);

	            if (that._refreshHandler) {
	                that.dataSource.unbind("change", that._refreshHandler);
	            }

	            that.wrapper.off(NS);
	            that.wrapper.children(".k-tabstrip-items").off(NS);

	            if (that._scrollableModeActive) {
	                that._scrollPrevButton.off().remove();
	                that._scrollNextButton.off().remove();
	            }

	            kendo.destroy(that.wrapper);
	            scrollWrap.children(".k-tabstrip").unwrap();
	        },

	        select: function (element) {
	            var that = this;

	            if (arguments.length === 0) {
	                return that.tabGroup.children("li." + ACTIVESTATE);
	            }

	            if (!isNaN(element)) {
	                element = that.tabGroup.children().get(element);
	            }

	            element = that.tabGroup.find(element);
	            $(element).each(function (index, item) {
	                item = $(item);
	                if (!item.hasClass(ACTIVESTATE) && !that.trigger(SELECT, { item: item[0], contentElement: that.contentHolder(item.index())[0] })) {
	                    that.activateTab(item);
	                }
	            });

	            return that;
	        },

	        enable: function (element, state) {
	            this._toggleDisabled(element, state !== false);

	            return this;
	        },

	        disable: function (element) {
	            this._toggleDisabled(element, false);

	            return this;
	        },

	        reload: function (element) {
	            element = this.tabGroup.find(element);
	            var that = this;
	            var contentUrls = that._contentUrls;

	            element.each(function () {
	                var item = $(this),
	                    contentUrl = item.find("." + LINK).data(CONTENTURL) || contentUrls[item.index()],
	                    content = that.contentHolder(item.index());

	                if (contentUrl) {
	                    that.ajaxRequest(item, content, null, contentUrl);
	                }
	            });

	            return that;
	        },

	        append: function (tab) {
	            var that = this,
	                inserted = that._create(tab);

	            each(inserted.tabs, function (idx) {
	                var contents = inserted.contents[idx];
	                that.tabGroup.append(this);
	                if (that.options.tabPosition == "bottom") {
	                    that.tabGroup.before(contents);
	                } else if (that._scrollableModeActive) {
	                    that._scrollPrevButton.before(contents);
	                } else {
	                    that.wrapper.append(contents);
	                }
	                that.angular("compile", function(){ return { elements: [ contents ] }; });
	            });

	            updateFirstLast(that.tabGroup);
	            that._updateContentElements();
	            that.resize(true);

	            return that;
	        },

	        _appendUrlItem: function(url) {
	            this._contentUrls.push(url);
	        },

	        _moveUrlItem: function(from, to) {
	            this._contentUrls.splice(to, 0, this._contentUrls.splice(from, 1)[0]);
	        },

	        _removeUrlItem: function(index) {
	            this._contentUrls.splice(index, 1);
	        },

	        insertBefore: function (tab, referenceTab) {
	            if ($(tab).is($(referenceTab))) {
	                referenceTab = this.tabGroup.find(referenceTab).next();
	            } else {
	                referenceTab = this.tabGroup.find(referenceTab);
	            }

	            var that = this,
	                inserted = that._create(tab),
	                referenceContent = that.element.find("[id='" + referenceTab.attr("aria-controls") + "']");

	            each(inserted.tabs, function (idx) {
	                var contents = inserted.contents[idx];
	                var fromIndex = inserted.newTabsCreated ? that._contentUrls.length - (inserted.tabs.length - idx) : $(contents).index() - 1;

	                referenceTab.before(this);
	                referenceContent.before(contents);

	                that._moveUrlItem(fromIndex, $(this).index());
	                that.angular("compile", function(){ return { elements: [ contents ] }; });
	            });

	            updateFirstLast(that.tabGroup);
	            that._updateContentElements(inserted.newTabsCreated);
	            that.resize(true);

	            return that;
	        },

	        insertAfter: function (tab, referenceTab) {
	            if ($(tab).is($(referenceTab))) {
	                referenceTab = this.tabGroup.find(referenceTab).prev();
	            } else {
	                referenceTab = this.tabGroup.find(referenceTab);
	            }

	            var that = this,
	                inserted = that._create(tab),
	                referenceContent = that.element.find("[id='" + referenceTab.attr("aria-controls") + "']");

	            each(inserted.tabs, function (idx) {
	                var contents = inserted.contents[idx];
	                var fromIndex = inserted.newTabsCreated ? that._contentUrls.length - (inserted.tabs.length - idx) : $(contents).index() - 1;

	                referenceTab.after(this);
	                referenceContent.after(contents);

	                that._moveUrlItem(fromIndex, $(this).index());
	                that.angular("compile", function(){ return { elements: [ contents ] }; });
	            });

	            updateFirstLast(that.tabGroup);
	            that._updateContentElements(inserted.newTabsCreated);
	            that.resize(true);

	            return that;
	        },

	        remove: function (elements) {
	            var that = this;
	            var type = typeof elements;
	            var contents;

	            if (type === "string") {
	                elements = that.tabGroup.find(elements);
	            } else if (type === "number") {
	                elements = that.tabGroup.children().eq(elements);
	            }

	            contents = elements.map(function () {
	                var idx = $(this).index();
	                var content = that.contentElement(idx);

	                kendo.destroy(content);
	                that._removeUrlItem(idx);

	                return content;
	            });

	            elements.remove();
	            contents.empty();
	            contents.remove();

	            that._updateContentElements();
	            that.resize(true);

	            return that;
	        },

	        _create: function (tab) {
	            var that = this,
	            tabs,
	            contents,
	            content,
	            newTabsCreated = false;

	            tab = tab instanceof kendo.data.ObservableArray ? tab.toJSON() : tab;

	            if ($.isPlainObject(tab) || $.isArray(tab)) {
	                tab = $.isArray(tab) ? tab : [tab];
	                newTabsCreated = true;

	                tabs = map(tab, function (value, idx) {
	                            that._appendUrlItem(tab[idx].contentUrl || null);

	                            return $(TabStrip.renderItem({
	                                group: that.tabGroup,
	                                item: extend(value, { index: idx })
	                            }));
	                        });

	                contents = map( tab, function (value, idx) {
	                            if (typeof value.content == "string" || value.contentUrl) {
	                                return $(TabStrip.renderContent({
	                                    item: extend(value, { index: idx })
	                                }));
	                            }
	                        });
	            } else {
	                if (typeof tab == "string" && tab[0] != "<") {
	                    tabs = that.element.find(tab);
	                } else {
	                    tabs = $(tab);
	                }
	                contents = $();
	                tabs.each(function () {
	                    if (/k-tabstrip-items/.test(this.parentNode.className)) {
	                        var element = that.element.find("[id='" + this.getAttribute("aria-controls") + "']");
	                        content = element;
	                    } else {
	                        content = $("<div class='" + CONTENT + "'/>");
	                    }

	                    contents = contents.add(content);
	                });

	                updateTabClasses(tabs);
	            }

	            return { tabs: tabs, contents: contents, newTabsCreated: newTabsCreated };
	        },

	        _toggleDisabled: function(element, enable) {
	            element = this.tabGroup.find(element);
	            element.each(function () {
	                $(this)
	                    .toggleClass(DEFAULTSTATE, enable)
	                    .toggleClass(DISABLEDSTATE, !enable)
	                    .attr("aria-disabled", !enable);
	            });
	        },

	        _updateClasses: function() {
	            var that = this,
	                tabs, activeItem, activeTab;

	            that.wrapper.addClass("k-widget k-header k-tabstrip");

	            that.tabGroup = that.wrapper.children("ul").addClass("k-tabstrip-items k-reset");

	            if (!that.tabGroup[0]) {
	                that.tabGroup = $("<ul class='k-tabstrip-items k-reset'/>").appendTo(that.wrapper);
	            }

	            tabs = that.tabGroup.find("li").addClass("k-item");

	            if (tabs.length) {
	                activeItem = tabs.filter("." + ACTIVESTATE).index();
	                activeTab = activeItem >= 0 ? activeItem : undefined;

	                that.tabGroup // Remove empty text nodes
	                    .contents()
	                    .filter(function () { return (this.nodeType == 3 && !trim(this.nodeValue)); })
	                    .remove();
	            }

	            if (activeItem >= 0) {
	                tabs.eq(activeItem).addClass(TABONTOP);
	            }

	            that.contentElements = that.wrapper.children("div");

	            that.contentElements
	                .addClass(CONTENT)
	                .eq(activeTab)
	                .addClass(ACTIVESTATE)
	                .css({ display: "block" });

	            if (tabs.length) {
	                updateTabClasses(tabs);

	                updateFirstLast(that.tabGroup);
	                that._updateContentElements(true);
	            }
	        },

	        _elementId: function(element, idx, tab) {
	            var elementId = element.attr("id");
	            var wrapperId = this.element.attr("id") || kendo.guid();

	            if (!elementId) {
	                var tabStripID = wrapperId + "-";

	                if(tab) {
	                    tabStripID += "tab-";
	                }

	                return tabStripID + (idx + 1);
	            }

	            return elementId;
	        },

	        _updateContentElements: function(isInitialUpdate) {
	            var that = this,
	                contentUrls = that._contentUrls,
	                items = that.tabGroup.children(".k-item"),
	                contentElements = that.wrapper.children("div"),
	                _elementId = that._elementId.bind(that);

	            if (contentElements.length && (items.length > contentElements.length)) {
	                contentElements.each(function(idx) {
	                    // Generate an ID for each content element
	                    var contentId = _elementId($(this), idx),
	                        item = items.filter("[aria-controls=" + (contentId || 0) + "]")[0],
	                        tabId;

	                    if (!item && isInitialUpdate) {
	                        // On initialization of the widget get the tab by its index
	                        item = items[idx];
	                    }

	                    if (item) {
	                        // set the tab aria-controls attribute to the content ID
	                        item.setAttribute("aria-controls", contentId);
	                        tabId = item.id = _elementId($(item), idx, true);
	                        this.setAttribute("aria-labelledby", tabId);
	                    }

	                    // set the get (possibly existing) ID on the content element
	                    this.setAttribute("id", contentId);
	                });
	            } else {
	                items.each(function(idx) {
	                    var currentContent = contentElements.eq(idx),
	                        contentId = _elementId(currentContent, idx),
	                        tabId;

	                    // set the tab aria-controls attribute to the content ID
	                    this.setAttribute("aria-controls", contentId);

	                    tabId = this.id = _elementId($(this), idx, true);

	                    if (!currentContent.length && contentUrls[idx]) {
	                        // Append content element in case contentUrl is used
	                        $("<div class='" + CONTENT + "'/>").appendTo(that.wrapper).attr("id", contentId);
	                    } else {
	                        // set the ID on the content element
	                        currentContent.attr("id", contentId);

	                        if (!$(this).children(".k-loading")[0] && !contentUrls[idx]) {
	                            $("<span class='k-loading k-complete'/>").prependTo(this);
	                        }
	                    }

	                    currentContent.attr("role", "tabpanel");
	                    currentContent.attr("tabindex", "0");
	                    currentContent.attr("aria-labelledby", tabId);
	                    currentContent.filter(":not(." + ACTIVESTATE + ")").attr("aria-hidden", true).attr("aria-expanded", false);
	                    currentContent.filter("." + ACTIVESTATE).attr("aria-expanded", true);
	                });
	            }

	            that.contentElements = that.contentAnimators = that.wrapper.children("div"); // refresh the contents

	            that.tabsHeight = outerHeight(that.tabGroup) +
	                              parseInt(that.wrapper.css("border-top-width"), 10) +
	                              parseInt(that.wrapper.css("border-bottom-width"), 10);

	            if (kendo.kineticScrollNeeded && kendo.mobile.ui.Scroller) {
	                kendo.touchScroller(that.contentElements);
	                that.contentElements = that.contentElements.children(".km-scroll-container");
	            }
	        },

	        _wrapper: function() {
	            var that = this;

	            if (that.element.is("ul")) {
	                that.wrapper = that.element.wrapAll("<div />").parent();
	            } else {
	                that.wrapper = that.element;
	            }

	            that.scrollWrap = that.wrapper.parent(".k-tabstrip-wrapper");

	            if (!that.scrollWrap[0]) {
	                that.scrollWrap = that.wrapper.wrapAll("<div class='k-tabstrip-wrapper' />").parent();
	            }
	        },

	        _tabPosition: function() {
	            var that = this,
	                tabPosition = that.options.tabPosition;

	            that.wrapper.addClass("k-floatwrap k-tabstrip-" + tabPosition);

	            if (tabPosition == "bottom") {
	                that.tabGroup.appendTo(that.wrapper);
	            }

	            that.resize(true);
	        },

	        _setContentElementsDimensions: function () {
	            var that = this,
	                tabPosition = that.options.tabPosition;

	            if (tabPosition == "left" || tabPosition == "right") {
	                var contentDivs = that.wrapper.children(".k-content"),
	                    activeDiv = contentDivs.filter(":visible"),
	                    marginStyleProperty = "margin-" + tabPosition,
	                    tabGroup = that.tabGroup,
	                    margin = outerWidth(tabGroup);

	                var minHeight = Math.ceil(tabGroup.height()) -
	                    parseInt(activeDiv.css("padding-top"), 10) -
	                    parseInt(activeDiv.css("padding-bottom"), 10) -
	                    parseInt(activeDiv.css("border-top-width"), 10) -
	                    parseInt(activeDiv.css("border-bottom-width"), 10);

	                setTimeout(function () {
	                    contentDivs.css(marginStyleProperty, margin).css("min-height", minHeight);
	                });
	            }
	        },

	        _resize: function() {
	            this._setContentElementsDimensions();
	            this._scrollable();
	        },

	        _sizeScrollWrap: function (element) {
	            if (element.is(":visible")) {
	                var tabPosition = this.options.tabPosition;
	                var h = Math.floor(outerHeight(element, true)) + (tabPosition === "left" || tabPosition === "right" ? 2 : this.tabsHeight);

	                this.scrollWrap.css("height", h).css("height");
	            }
	        },

	        _toggleHover: function(e) {
	            $(e.currentTarget).toggleClass(HOVERSTATE, e.type == MOUSEENTER);
	        },

	        _click: function (item) {
	            var that = this,
	                link = item.find("." + LINK),
	                href = link.attr(HREF),
	                collapse = that.options.collapsible,
	                index = item.index(),
	                contentHolder = that.contentHolder(index),
	                prevent, isAnchor,
	                neighbours = item.parent().children(),
	                oldFocusedTab = neighbours.filter("." + FOCUSEDSTATE);

	            if (item.closest(".k-widget")[0] != that.wrapper[0]) {
	                return;
	            }

	            if (item.is("." + DISABLEDSTATE + (!collapse ? ",." + ACTIVESTATE : ""))) {
	                oldFocusedTab.removeClass(FOCUSEDSTATE);
	                that._focused = item;

	                item.addClass(FOCUSEDSTATE);
	                that._current(item);

	                if (that._scrollableModeActive) {
	                    that._scrollTabsToItem(item);
	                }
	                return true;
	            }

	            isAnchor = link.data(CONTENTURL) || that._contentUrls[index] || (href && (href.charAt(href.length - 1) == "#" || href.indexOf("#" + that.element[0].id + "-") != -1));
	            prevent = !href || isAnchor;

	            if (that.tabGroup.children("[data-animating]").length) {
	                return prevent;
	            }

	            if (that.trigger(SELECT, { item: item[0], contentElement: contentHolder[0] })) {
	                return true;
	            }

	            if (prevent === false) {
	                return;
	            }

	            if (collapse && item.is("." + ACTIVESTATE)) {
	                that.deactivateTab(item);
	                return true;
	            }

	            if (that.activateTab(item)) {
	                prevent = true;
	            }

	            return prevent;
	        },

	        _scrollable: function() {
	            var that = this,
	                options = that.options,
	                wrapperOffsetWidth,
	                tabGroupScrollWidth,
	                scrollPrevButton,
	                scrollNextButton;

	            if (that._scrollableAllowed()) {

	                that.wrapper.addClass("k-tabstrip-scrollable");

	                wrapperOffsetWidth = that.wrapper[0].offsetWidth;
	                tabGroupScrollWidth = that.tabGroup[0].scrollWidth;

	                if (tabGroupScrollWidth > wrapperOffsetWidth && !that._scrollableModeActive) {
	                    that._nowScrollingTabs = false;
	                    that._isRtl = kendo.support.isRtl(that.element);
	                    var mouseDown = kendo.support.touch ? "touchstart" : "mousedown";
	                    var mouseUp = kendo.support.touch ? "touchend" : "mouseup";
	                    var browser = kendo.support.browser;
	                    var isRtlScrollDirection = that._isRtl && !browser.msie && !browser.edge;

	                    that.wrapper.append(scrollButtonHtml("prev", "k-i-arrow-60-left") + scrollButtonHtml("next", "k-i-arrow-60-right"));

	                    scrollPrevButton = that._scrollPrevButton = that.wrapper.children(".k-tabstrip-prev");
	                    scrollNextButton = that._scrollNextButton = that.wrapper.children(".k-tabstrip-next");

	                    that.tabGroup.css({ marginLeft: outerWidth(scrollPrevButton) + 9, marginRight: outerWidth(scrollNextButton) + 12 });

	                    scrollPrevButton.on(mouseDown + NS, function () {
	                        that._nowScrollingTabs = true;
	                        that._scrollTabsByDelta(options.scrollable.distance * (isRtlScrollDirection ? 1 : -1));
	                    });

	                    scrollNextButton.on(mouseDown + NS, function () {
	                        that._nowScrollingTabs = true;
	                        that._scrollTabsByDelta(options.scrollable.distance * (isRtlScrollDirection ? -1 : 1));
	                    });

	                    scrollPrevButton.add(scrollNextButton).on(mouseUp + NS, function () {
	                        that._nowScrollingTabs = false;
	                    });

	                    that._scrollableModeActive = true;

	                    that._toggleScrollButtons();
	                } else if (that._scrollableModeActive && tabGroupScrollWidth <= wrapperOffsetWidth) {
	                    that._scrollableModeActive = false;

	                    that.wrapper.removeClass("k-tabstrip-scrollable");

	                    that._scrollPrevButton.off().remove();
	                    that._scrollNextButton.off().remove();
	                    that.tabGroup.css({ marginLeft: "", marginRight: "" });
	                } else if (!that._scrollableModeActive) {
	                    that.wrapper.removeClass("k-tabstrip-scrollable");
	                } else {
	                    that._toggleScrollButtons();
	                }
	            }
	        },

	        _scrollableAllowed: function() {
	            var options = this.options;

	            if(options.scrollable && !options.scrollable.distance){
	                options.scrollable = {distance: DEFAULTDISTANCE};
	            }

	            return options.scrollable && !isNaN(options.scrollable.distance) && (options.tabPosition == "top" || options.tabPosition == "bottom");
	        },

	        _scrollTabsToItem: function (item) {
	            var that = this,
	                tabGroup = that.tabGroup,
	                currentScrollOffset = kendo.scrollLeft(tabGroup),
	                itemWidth = outerWidth(item),
	                itemOffset = that._isRtl ? item.position().left : item.position().left - tabGroup.children().first().position().left,
	                tabGroupWidth = tabGroup[0].offsetWidth,
	                tabGroupPadding = Math.ceil(parseFloat(tabGroup.css("padding-left"))),
	                browser = kendo.support.browser,
	                itemPosition;

	            if(that._isRtl && (browser.mozilla || (browser.webkit && browser.version >= 85))) {
	                currentScrollOffset = currentScrollOffset * -1;
	            }

	            if (that._isRtl) {
	                if (itemOffset < 0) {
	                    itemPosition = currentScrollOffset + itemOffset - (tabGroupWidth - currentScrollOffset) - tabGroupPadding;
	                } else if (itemOffset + itemWidth > tabGroupWidth) {
	                    itemPosition = currentScrollOffset + itemOffset - itemWidth + tabGroupPadding * 2;
	                }
	            } else {
	                if (currentScrollOffset + tabGroupWidth < itemOffset + itemWidth) {
	                    itemPosition = itemOffset + itemWidth - tabGroupWidth + tabGroupPadding * 2;
	                } else if (currentScrollOffset > itemOffset) {
	                    itemPosition = itemOffset - tabGroupPadding;
	                }
	            }

	            tabGroup.finish().animate({ "scrollLeft": itemPosition }, "fast", "linear", function () {
	                that._toggleScrollButtons();
	            });
	        },

	        _scrollTabsByDelta: function (delta) {
	            var that = this;
	            var tabGroup = that.tabGroup;
	            var scrLeft = kendo.scrollLeft(tabGroup);
	            var browser = kendo.support.browser;

	            if(that._isRtl && (browser.mozilla || (browser.webkit && browser.version >= 85))) {
	                scrLeft = scrLeft * -1;
	            }

	            tabGroup.finish().animate({ "scrollLeft": scrLeft + delta }, "fast", "linear", function () {
	                if (that._nowScrollingTabs && !jQuery.fx.off) {
	                    that._scrollTabsByDelta(delta);
	                } else {
	                    that._toggleScrollButtons();
	                }
	            });
	        },

	        _toggleScrollButtons: function () {
	            var that = this,
	                ul = that.tabGroup,
	                scrollLeft = kendo.scrollLeft(ul);

	                that._scrollPrevButton.toggle(scrollLeft !== 0);
	                that._scrollNextButton.toggle(scrollLeft < ul[0].scrollWidth - ul[0].offsetWidth - 1);
	        },

	        deactivateTab: function (item) {
	            var that = this,
	                animationSettings = that.options.animation,
	                animation = animationSettings.open,
	                close = extend({}, animationSettings.close),
	                hasCloseAnimation = close && "effects" in close;
	            item = that.tabGroup.find(item);

	            close = extend( hasCloseAnimation ? close : extend({ reverse: true }, animation), { hide: true });

	            if (kendo.size(animation.effects)) {
	                item.kendoAddClass(DEFAULTSTATE, { duration: animation.duration });
	                item.kendoRemoveClass(ACTIVESTATE, { duration: animation.duration });
	            } else {
	                item.addClass(DEFAULTSTATE);
	                item.removeClass(ACTIVESTATE);
	            }

	            item.removeAttr("aria-selected");

	            that.contentAnimators
	                    .filter("." + ACTIVESTATE)
	                    .kendoStop(true, true)
	                    .kendoAnimate( close )
	                    .removeClass(ACTIVESTATE)
	                    .attr("aria-hidden", true);
	        },

	        activateTab: function (item) {
	            if (this.tabGroup.children("[data-animating]").length) { return; }

	            item = this.tabGroup.find(item);

	            var that = this,
	                animationSettings = that.options.animation,
	                animation = animationSettings.open,
	                close = extend({}, animationSettings.close),
	                hasCloseAnimation = close && "effects" in close,
	                neighbours = item.parent().children(),
	                oldTab = neighbours.filter("." + ACTIVESTATE),
	                itemIndex = neighbours.index(item),
	                isAnimationEnabled = animation && "duration" in animation && "effects" in animation;

	            close = extend( hasCloseAnimation ? close : extend({ reverse: true }, animation), { hide: true });
	            // deactivate previously active tab
	            if (kendo.size(animation.effects)) {
	                oldTab.kendoRemoveClass(ACTIVESTATE, { duration: close.duration });
	                item.kendoRemoveClass(HOVERSTATE, { duration: close.duration });
	            } else {
	                oldTab.removeClass(ACTIVESTATE);
	                item.removeClass(HOVERSTATE);
	            }

	            // handle content elements
	            var contentAnimators = that.contentAnimators;

	            if (that.inRequest) {
	                that.xhr.abort();
	                that.inRequest = false;
	            }

	            if (contentAnimators.length === 0) {
	                that.tabGroup.find("." + TABONTOP).removeClass(TABONTOP);
	                item.addClass(TABONTOP) // change these directly to bring the tab on top.
	                    .css("z-index");

	                item.addClass(ACTIVESTATE);
	                that._current(item);

	                that.trigger("change");

	                if (that._scrollableModeActive) {
	                    that._scrollTabsToItem(item);
	                }

	                return false;
	            }

	            var visibleContents = contentAnimators.filter("." + ACTIVESTATE),
	                contentHolder = that.contentHolder(itemIndex),
	                contentElement = contentHolder.closest(".k-content");

	            that.tabsHeight = outerHeight(that.tabGroup) +
	                              parseInt(that.wrapper.css("border-top-width"), 10) +
	                              parseInt(that.wrapper.css("border-bottom-width"), 10);

	            that._sizeScrollWrap(visibleContents);

	            if (contentHolder.length === 0) {
	                visibleContents
	                    .removeClass( ACTIVESTATE )
	                    .attr("aria-hidden", true)
	                    .kendoStop(true, true)
	                    .kendoAnimate( close );
	                return false;
	            }

	            item.attr("data-animating", true);

	            var isAjaxContent = (item.children("." + LINK).data(CONTENTURL) || that._contentUrls[itemIndex] || false) && contentHolder.is(EMPTY),
	                showContentElement = function () {
	                    oldTab.removeAttr("aria-selected");
	                    item.attr("aria-selected", true);

	                    that._current(item);

	                    that._sizeScrollWrap(contentElement);

	                    contentElement
	                        .addClass(ACTIVESTATE)
	                        .removeAttr("aria-hidden")
	                        .kendoStop(true, true)
	                        .attr("aria-expanded", true)
	                        .kendoAnimate( extend({ init: function () {
	                            that.trigger(SHOW, { item: item[0], contentElement: contentHolder[0] });
	                            kendo.resize(contentHolder);
	                        } }, animation, {
	                            complete: function () {
	                                item.removeAttr("data-animating");

	                                that.trigger(ACTIVATE, { item: item[0], contentElement: contentHolder[0] });
	                                kendo.resize(contentHolder);

	                                that.scrollWrap.css("height", "").css("height");

	                                // Force IE and Edge rendering to fix visual glitches telerik/kendo-ui-core#2777.
	                                if (isAnimationEnabled && (kendo.support.browser.msie || kendo.support.browser.edge)) {
	                                    contentHolder.finish().animate({
	                                        opacity: 0.9
	                                    },"fast", "linear", function(){
	                                        contentHolder.finish().animate({
	                                            opacity: 1
	                                        },"fast", "linear");
	                                    });
	                                }
	                            }
	                        } ) );
	                },
	                showContent = function() {
	                    if (!isAjaxContent) {
	                        showContentElement();
	                        that.trigger("change");
	                    } else {
	                        item.removeAttr("data-animating");
	                        that.ajaxRequest(item, contentHolder, function () {
	                            item.attr("data-animating", true);
	                            showContentElement();
	                            that.trigger("change");
	                        });
	                    }

	                    if (that._scrollableModeActive) {
	                        that._scrollTabsToItem(item);
	                    }

	                };

	            visibleContents
	                    .removeClass(ACTIVESTATE);

	            that.tabGroup.find("." + TABONTOP).removeClass(TABONTOP);
	                    item.addClass(TABONTOP) // change these directly to bring the tab on top.
	                        .css("z-index");

	            if (kendo.size(animation.effects)) {
	                oldTab.kendoAddClass(DEFAULTSTATE, { duration: animation.duration });
	                item.kendoAddClass(ACTIVESTATE, { duration: animation.duration });
	            } else {
	                oldTab.addClass(DEFAULTSTATE);
	                item.addClass(ACTIVESTATE);
	            }

	            visibleContents.attr("aria-hidden", true);
	            visibleContents.attr("aria-expanded", false);

	            if (visibleContents.length) {
	                visibleContents
	                    .kendoStop(true, true)
	                    .kendoAnimate(extend( {
	                        complete: showContent
	                   }, close ));
	            } else {
	                showContent();
	            }

	            return true;
	        },

	        contentElement: function (itemIndex) {
	            if (isNaN(itemIndex - 0)) {
	                return undefined;
	            }

	            var contentElements = this.contentElements && this.contentElements[0] && !kendo.kineticScrollNeeded ? this.contentElements : this.contentAnimators;
	            var id = $(this.tabGroup.children()[itemIndex]).attr("aria-controls");

	            if (contentElements) {
	                for (var i = 0, len = contentElements.length; i < len; i++) {
	                    if (contentElements.eq(i).closest(".k-content")[0].id == id) {
	                        return contentElements[i];
	                    }
	                }
	            }

	            return undefined;
	        },

	        contentHolder: function (itemIndex) {
	            var contentElement = $(this.contentElement(itemIndex)),
	                scrollContainer = contentElement.children(".km-scroll-container");

	            return kendo.support.touch && scrollContainer[0] ? scrollContainer : contentElement;
	        },

	        ajaxRequest: function (element, content, complete, url) {
	            element = this.tabGroup.find(element);

	            var that = this,
	                xhr = $.ajaxSettings.xhr,
	                link = element.find("." + LINK),
	                data = {},
	                halfWidth = element.width() / 2,
	                fakeProgress = false,
	                statusIcon = element.find(".k-loading").removeClass("k-complete");

	            if (!statusIcon[0]) {
	                statusIcon = $("<span class='k-loading'/>").prependTo(element);
	            }

	            var endState = halfWidth * 2 - statusIcon.width();

	            var oldProgressAnimation = function() {
	                statusIcon.animate({ marginLeft: (parseInt(statusIcon.css("marginLeft"), 10) || 0) < halfWidth ? endState : 0 }, 500, oldProgressAnimation);
	            };

	            if (kendo.support.browser.msie && kendo.support.browser.version < 10) {
	                setTimeout(oldProgressAnimation, 40);
	            }

	             url = url || link.data(CONTENTURL) || that._contentUrls[element.index()] || link.attr(HREF);
	            that.inRequest = true;

	            var ajaxOptions = {
	                type: "GET",
	                cache: false,
	                url: url,
	                dataType: "html",
	                data: data,
	                xhr: function() {
	                    var current = this,
	                        request = xhr(),
	                        event = current.progressUpload ? "progressUpload" : current.progress ? "progress" : false;

	                    if (request) {
	                        $.each([ request, request.upload ], function () {
	                            if (this.addEventListener) {
	                                this.addEventListener("progress", function(evt) {
	                                    if (event) {
	                                        current[event](evt);
	                                    }
	                                }, false);
	                            }
	                        });
	                    }

	                    current.noProgress = !(window.XMLHttpRequest && ('upload' in new XMLHttpRequest()));
	                    return request;
	                },

	                progress: function(evt) {
	                    if (evt.lengthComputable) {
	                        var percent = parseInt((evt.loaded / evt.total * 100), 10) + "%";
	                        statusIcon
	                            .stop(true)
	                            .addClass("k-progress")
	                            .css({
	                                "width": percent,
	                                "marginLeft": 0
	                            });
	                    }
	                },

	                error: function (xhr, status) {
	                    if (that.trigger("error", { xhr: xhr, status: status })) {
	                        this.complete();
	                    }
	                },

	                stopProgress: function () {
	                    clearInterval(fakeProgress);
	                    statusIcon
	                        .stop(true)
	                        .addClass("k-progress")
	                        [0].style.cssText = "";
	                },

	                complete: function (xhr) {
	                    that.inRequest = false;
	                    if (this.noProgress) {
	                        setTimeout(this.stopProgress, 500);
	                    } else {
	                        this.stopProgress();
	                    }

	                    if (xhr.statusText == "abort") {
	                        statusIcon.remove();
	                    }
	                },

	                success: function (data) {
	                    statusIcon.addClass("k-complete");
	                    try {
	                        var current = this,
	                            loaded = 10;

	                        if (current.noProgress) {
	                            statusIcon.width(loaded+"%");
	                            fakeProgress = setInterval(function () {
	                                current.progress({ lengthComputable: true, loaded: Math.min(loaded, 100), total: 100 });
	                                loaded += 10;
	                            }, 40);
	                        }

	                        that.angular("cleanup", function () { return { elements: content.get() }; });
	                        kendo.destroy(content);
	                        content.html(data);
	                    } catch (e) {
	                        var console = window.console;

	                        if (console && console.error) {
	                            console.error(e.name + ": " + e.message + " in " + url);
	                        }
	                        this.error(this.xhr, "error");
	                    }

	                    if (complete) {
	                        complete.call(that, content);
	                    }

	                    that.angular("compile", function(){ return { elements: content.get() }; });

	                    that.trigger(CONTENTLOAD, { item: element[0], contentElement: content[0] });
	                }
	            };

	            if (typeof url === "object") {
	                ajaxOptions = $.extend(true, {}, ajaxOptions, url);

	                if (isFunction(ajaxOptions.url)) {
	                    ajaxOptions.url = ajaxOptions.url();
	                }
	            }

	            that.xhr = $.ajax(ajaxOptions);
	        }
	    });

	    // client-side rendering
	    extend(TabStrip, {
	        renderItem: function (options) {
	            options = extend({ tabStrip: {}, group: {} }, options);

	            var empty = templates.empty,
	                item = options.item;

	            return templates.item(extend(options, {
	                image: item.imageUrl ? templates.image : empty,
	                sprite: item.spriteCssClass ? templates.sprite : empty,
	                itemWrapper: templates.itemWrapper
	            }, rendering));
	        },

	        renderContent: function (options) {
	            return templates.content(extend(options, rendering));
	        }
	    });

	    kendo.ui.plugin(TabStrip);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1048)))

/***/ })

/******/ });

/***/ }),

/***/ "FSs7":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(944);
	module.exports = __webpack_require__(944);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(945) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {
	    
	    var kendo = window.kendo;
	    var drawing = kendo.drawing;
	    var drawDOM = drawing.drawDOM;

	    drawing.drawDOM = function(element, options) {
	        return drawDOM($(element)[0], options);
	    };

	    drawing.drawDOM.drawText = drawDOM.drawText;
	    drawing.drawDOM.getFontFaces = drawDOM.getFontFaces;

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 945:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("KBs5");

/***/ })

/******/ });

/***/ }),

/***/ "FTkt":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1177);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1177:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1178),
	        __webpack_require__(1179),
	        __webpack_require__(1180),
	        __webpack_require__(1181),
	        __webpack_require__(1182)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	    var __meta__ = { // jshint ignore:line
	        id: "drawing",
	        name: "Drawing API",
	        category: "framework",
	        description: "The Kendo UI low-level drawing API",
	        depends: [ "core", "color", "popup" ]
	    };

	}, __webpack_require__(3));

/***/ }),

/***/ 1178:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("IlyZ");

/***/ }),

/***/ 1179:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("KBs5");

/***/ }),

/***/ 1180:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("b8bx");

/***/ }),

/***/ 1181:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("mJs/");

/***/ }),

/***/ 1182:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FSs7");

/***/ })

/******/ });

/***/ }),

/***/ "FZ+f":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "FZAa":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1450);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1450:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "userevents",
	    name: "User Events",
	    category: "framework",
	    depends: [ "core" ],
	    hidden: true
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        support = kendo.support,
	        Class = kendo.Class,
	        Observable = kendo.Observable,
	        now = $.now,
	        extend = $.extend,
	        OS = support.mobileOS,
	        invalidZeroEvents = OS && OS.android,
	        DEFAULT_MIN_HOLD = 800,
	        CLICK_DELAY = 300,
	        DEFAULT_THRESHOLD = support.browser.msie ? 5 : 0, // WP8 and W8 are very sensitive and always report move.

	        // UserEvents events
	        PRESS = "press",
	        HOLD = "hold",
	        SELECT = "select",
	        START = "start",
	        MOVE = "move",
	        END = "end",
	        CANCEL = "cancel",
	        TAP = "tap",
	        DOUBLETAP = "doubleTap",
	        RELEASE = "release",
	        GESTURESTART = "gesturestart",
	        GESTURECHANGE = "gesturechange",
	        GESTUREEND = "gestureend",
	        GESTURETAP = "gesturetap";

	    var THRESHOLD = {
	        "api": 0,
	        "touch": 0,
	        "mouse": 9,
	        "pointer": 9
	    };

	    var ENABLE_GLOBAL_SURFACE = (!support.touch || support.mouseAndTouchPresent);

	    function touchDelta(touch1, touch2) {
	        var x1 = touch1.x.location,
	            y1 = touch1.y.location,
	            x2 = touch2.x.location,
	            y2 = touch2.y.location,
	            dx = x1 - x2,
	            dy = y1 - y2;

	        return {
	            center: {
	               x: (x1 + x2) / 2,
	               y: (y1 + y2) / 2
	            },

	            distance: Math.sqrt(dx*dx + dy*dy)
	        };
	    }

	    function getTouches(e) {
	        var touches = [],
	            originalEvent = e.originalEvent,
	            currentTarget = e.currentTarget,
	            idx = 0, length,
	            changedTouches,
	            touch;

	        if (e.api) {
	            touches.push({
	                id: 2,  // hardcoded ID for API call;
	                event: e,
	                target: e.target,
	                currentTarget: e.target,
	                location: e,
	                type: "api"
	            });
	        }
	        else if (e.type.match(/touch/)) {
	            changedTouches = originalEvent ? originalEvent.changedTouches : [];
	            for (length = changedTouches.length; idx < length; idx ++) {
	                touch = changedTouches[idx];
	                touches.push({
	                    location: touch,
	                    event: e,
	                    target: touch.target,
	                    currentTarget: currentTarget,
	                    id: touch.identifier,
	                    type: "touch"
	                });
	            }
	        }
	        else if (support.pointers || support.msPointers) {
	            touches.push({
	                location: originalEvent,
	                event: e,
	                target: e.target,
	                currentTarget: currentTarget,
	                id: originalEvent.pointerId,
	                type: "pointer"
	            });
	        } else {
	            touches.push({
	                id: 1, // hardcoded ID for mouse event;
	                event: e,
	                target: e.target,
	                currentTarget: currentTarget,
	                location: e,
	                type: "mouse"
	            });
	        }

	        return touches;
	    }

	    var TouchAxis = Class.extend({
	        init: function(axis, location) {
	            var that = this;

	            that.axis = axis;

	            that._updateLocationData(location);

	            that.startLocation = that.location;
	            that.velocity = that.delta = 0;
	            that.timeStamp = now();
	        },

	        move: function(location) {
	            var that = this,
	                offset = location["page" + that.axis],
	                timeStamp = now(),
	                timeDelta = (timeStamp - that.timeStamp) || 1; // Firing manually events in tests can make this 0;

	            if (!offset && invalidZeroEvents) {
	                return;
	            }

	            that.delta = offset - that.location;

	            that._updateLocationData(location);

	            that.initialDelta = offset - that.startLocation;
	            that.velocity = that.delta / timeDelta;
	            that.timeStamp = timeStamp;
	        },

	        _updateLocationData: function(location) {
	            var that = this, axis = that.axis;

	            that.location = location["page" + axis];
	            that.client = location["client" + axis];
	            that.screen = location["screen" + axis];
	        }
	    });

	    var Touch = Class.extend({
	        init: function(userEvents, target, touchInfo) {
	            extend(this, {
	                x: new TouchAxis("X", touchInfo.location),
	                y: new TouchAxis("Y", touchInfo.location),
	                type: touchInfo.type,
	                useClickAsTap: userEvents.useClickAsTap,
	                threshold: userEvents.threshold || THRESHOLD[touchInfo.type],
	                userEvents: userEvents,
	                target: target,
	                currentTarget: touchInfo.currentTarget,
	                initialTouch: touchInfo.target,
	                id: touchInfo.id,
	                pressEvent: touchInfo,
	                _clicks: userEvents._clicks,
	                supportDoubleTap: userEvents.supportDoubleTap,
	                _moved: false,
	                _finished: false
	            });
	        },

	        press: function() {
	            this._holdTimeout = setTimeout($.proxy(this, "_hold"), this.userEvents.minHold);
	            this._trigger(PRESS, this.pressEvent);
	        },

	        _tap: function(touchInfo) {
	            var that = this;
	            that.userEvents._clicks++;
	            if (that.userEvents._clicks == 1) {
	                that._clickTimeout = setTimeout(function() {
	                    if (that.userEvents._clicks == 1) {
	                        that._trigger(TAP, touchInfo);
	                    }
	                    else {
	                        that._trigger(DOUBLETAP, touchInfo);
	                    }
	                    that.userEvents._clicks = 0;
	                }, CLICK_DELAY);
	            }
	        },

	        _hold: function() {
	            this._trigger(HOLD, this.pressEvent);
	        },

	        move: function(touchInfo) {
	            var that = this;
	            var preventMove = touchInfo.type !== "api" && that.userEvents._shouldNotMove;

	            if (that._finished || preventMove) { return; }

	            that.x.move(touchInfo.location);
	            that.y.move(touchInfo.location);

	            if (!that._moved) {
	                if (that._withinIgnoreThreshold()) {
	                    return;
	                }

	                if (!UserEvents.current || UserEvents.current === that.userEvents) {
	                    that._start(touchInfo);
	                } else {
	                    return that.dispose();
	                }
	            }

	            // Event handlers may cancel the drag in the START event handler, hence the double check for pressed.
	            if (!that._finished) {
	                that._trigger(MOVE, touchInfo);
	            }
	        },

	        end: function(touchInfo) {
	            this.endTime = now();

	            if (this._finished) { return; }

	            // Mark the object as finished if there are blocking operations in the event handlers (alert/confirm)
	            this._finished = true;

	            this._trigger(RELEASE, touchInfo); // Release should be fired before TAP (as click is after mouseup/touchend)

	            if (this._moved) {
	                this._trigger(END, touchInfo);
	            } else {
	                if (!this.useClickAsTap) {
	                    if (this.supportDoubleTap) {
	                        this._tap(touchInfo);
	                    }
	                    else {
	                        this._trigger(TAP, touchInfo);
	                    }
	                }
	            }

	            clearTimeout(this._holdTimeout);

	            this.dispose();
	        },

	        dispose: function() {
	            var userEvents = this.userEvents,
	                activeTouches = userEvents.touches;

	            this._finished = true;
	            this.pressEvent = null;
	            clearTimeout(this._holdTimeout);

	            activeTouches.splice($.inArray(this, activeTouches), 1);
	        },

	        skip: function() {
	            this.dispose();
	        },

	        cancel: function() {
	            this.dispose();
	        },

	        isMoved: function() {
	            return this._moved;
	        },

	        _start: function(touchInfo) {
	            clearTimeout(this._holdTimeout);

	            this.startTime = now();
	            this._moved = true;
	            this._trigger(START, touchInfo);
	        },

	        _trigger: function(name, touchInfo) {
	            var that = this,
	                jQueryEvent = touchInfo.event,
	                data = {
	                    touch: that,
	                    x: that.x,
	                    y: that.y,
	                    target: that.target,
	                    event: jQueryEvent
	                };

	            if(that.userEvents.notify(name, data)) {
	                jQueryEvent.preventDefault();
	            }
	        },

	        _withinIgnoreThreshold: function() {
	            var xDelta = this.x.initialDelta,
	                yDelta = this.y.initialDelta;

	            return Math.sqrt(xDelta * xDelta + yDelta * yDelta) <= this.threshold;
	        }
	    });

	    function withEachUpEvent(callback) {
	        var downEvents = kendo.eventMap.up.split(" "),
	            idx = 0,
	            length = downEvents.length;

	        for(; idx < length; idx ++) {
	            callback(downEvents[idx]);
	        }
	    }

	    var UserEvents = Observable.extend({
	        init: function(element, options) {
	            var that = this,
	                filter,
	                ns = kendo.guid();

	            options = options || {};
	            filter = that.filter = options.filter;
	            that.threshold = options.threshold || DEFAULT_THRESHOLD;
	            that.minHold = options.minHold || DEFAULT_MIN_HOLD;
	            that.touches = [];
	            that._maxTouches = options.multiTouch ? 2 : 1;
	            that.allowSelection = options.allowSelection;
	            that.captureUpIfMoved = options.captureUpIfMoved;
	            that.useClickAsTap = !options.fastTap && !support.delayedClick();
	            that.eventNS = ns;
	            that._clicks = 0;
	            that.supportDoubleTap = options.supportDoubleTap;

	            element = $(element).handler(that);
	            Observable.fn.init.call(that);

	            extend(that, {
	                element: element,
	                // the touch events lock to the element anyway, so no need for the global setting
	                surface: options.global && ENABLE_GLOBAL_SURFACE ? $(element[0].ownerDocument.documentElement) : $(options.surface || element),
	                stopPropagation: options.stopPropagation,
	                pressed: false
	            });

	            that.surface.handler(that)
	                .on(kendo.applyEventMap("move", ns), "_move")
	                .on(kendo.applyEventMap("up cancel", ns), "_end");

	            element.on(kendo.applyEventMap("down", ns), filter, "_start");

	            if (that.useClickAsTap) {
	                element.on(kendo.applyEventMap("click", ns), filter, "_click");
	            }

	            if (support.pointers || support.msPointers) {
	                //touch-action:none will not work for IE10
	                if (support.browser.version < 11) {
	                    var defaultAction = "pinch-zoom double-tap-zoom";
	                    element.css("-ms-touch-action", options.touchAction && options.touchAction != "none" ? defaultAction + " " + options.touchAction : defaultAction);
	                } else {
	                    element.css("touch-action", options.touchAction || "none");
	                }
	            }

	            if (options.preventDragEvent) {
	                element.on(kendo.applyEventMap("dragstart", ns), kendo.preventDefault);
	            }

	            element.on(kendo.applyEventMap("mousedown", ns), filter, { root: element }, "_select");

	            if (that.captureUpIfMoved && support.eventCapture) {
	                var surfaceElement = that.surface[0],
	                    preventIfMovingProxy = $.proxy(that.preventIfMoving, that);

	                withEachUpEvent(function(eventName) {
	                    surfaceElement.addEventListener(eventName, preventIfMovingProxy, true);
	                });
	            }

	            that.bind([
	            PRESS,
	            HOLD,
	            TAP,
	            DOUBLETAP,
	            START,
	            MOVE,
	            END,
	            RELEASE,
	            CANCEL,
	            GESTURESTART,
	            GESTURECHANGE,
	            GESTUREEND,
	            GESTURETAP,
	            SELECT
	            ], options);
	        },

	        preventIfMoving: function(e) {
	            if (this._isMoved()) {
	                e.preventDefault();
	            }
	        },

	        destroy: function() {
	            var that = this;

	            if (that._destroyed) {
	                return;
	            }

	            that._destroyed = true;

	            if (that.captureUpIfMoved && support.eventCapture) {
	                var surfaceElement = that.surface[0];
	                withEachUpEvent(function(eventName) {
	                    surfaceElement.removeEventListener(eventName, that.preventIfMoving);
	                });
	            }

	            that.element.kendoDestroy(that.eventNS);
	            that.surface.kendoDestroy(that.eventNS);
	            that.element.removeData("handler");
	            that.surface.removeData("handler");
	            that._disposeAll();

	            that.unbind();
	            delete that.surface;
	            delete that.element;
	            delete that.currentTarget;
	        },

	        capture: function() {
	            UserEvents.current = this;
	        },

	        cancel: function() {
	            this._disposeAll();
	            this.trigger(CANCEL);
	        },

	        notify: function(eventName, data) {
	            var that = this,
	                touches = that.touches;

	            if (this._isMultiTouch()) {
	                switch(eventName) {
	                    case MOVE:
	                        eventName = GESTURECHANGE;
	                        break;
	                    case END:
	                        eventName = GESTUREEND;
	                        break;
	                    case TAP:
	                        eventName = GESTURETAP;
	                        break;
	                }

	                extend(data, {touches: touches}, touchDelta(touches[0], touches[1]));
	            }

	            return this.trigger(eventName, extend(data, {type: eventName}));
	        },

	        // API
	        press: function(x, y, target) {
	            this._apiCall("_start", x, y, target);
	        },

	        move: function(x, y) {
	            this._apiCall("_move", x, y);
	        },

	        end: function(x, y) {
	            this._apiCall("_end", x, y);
	        },

	        _isMultiTouch: function() {
	            return this.touches.length > 1;
	        },

	        _maxTouchesReached: function() {
	            return this.touches.length >= this._maxTouches;
	        },

	        _disposeAll: function() {
	            var touches = this.touches;
	            while (touches.length > 0) {
	                touches.pop().dispose();
	            }
	        },

	        _isMoved: function() {
	            return $.grep(this.touches, function(touch) {
	                return touch.isMoved();
	            }).length;
	        },

	        _select: function(e) {
	           if (!this.allowSelection || this.trigger(SELECT, { event: e })) {
	               e.preventDefault();
	           }
	        },

	        _start: function(e) {
	            var that = this,
	                idx = 0,
	                filter = that.filter,
	                target,
	                touches = getTouches(e),
	                length = touches.length,
	                touch,
	                which = e.which;

	            if ((which && which > 1) || (that._maxTouchesReached())){
	                return;
	            }

	            UserEvents.current = null;

	            that.currentTarget = e.currentTarget;

	            if (that.stopPropagation) {
	                e.stopPropagation();
	            }

	            for (; idx < length; idx ++) {
	                if (that._maxTouchesReached()) {
	                    break;
	                }

	                touch = touches[idx];

	                if (filter) {
	                    target = $(touch.currentTarget); // target.is(filter) ? target : target.closest(filter, that.element);
	                } else {
	                    target = that.element;
	                }

	                if (!target.length) {
	                    continue;
	                }

	                touch = new Touch(that, target, touch);
	                that.touches.push(touch);
	                touch.press();

	                if (that._isMultiTouch()) {
	                    that.notify("gesturestart", {});
	                }
	            }
	        },

	        _move: function(e) {
	            this._eachTouch("move", e);
	        },

	        _end: function(e) {
	            this._eachTouch("end", e);
	        },

	        _click: function(e) {
	            var data = {
	                touch: {
	                    initialTouch: e.target,
	                    target: $(e.currentTarget),
	                    endTime: now(),
	                    x: {
	                        location: e.pageX,
	                        client: e.clientX
	                    },
	                    y: {
	                        location: e.pageY,
	                        client: e.clientY
	                    }
	                },
	                x: e.pageX,
	                y: e.pageY,
	                target: $(e.currentTarget),
	                event: e,
	                type: "tap"
	            };

	            if (this.trigger("tap", data)) {
	                e.preventDefault();
	            }
	        },

	        _eachTouch: function(methodName, e) {
	            var that = this,
	                dict = {},
	                touches = getTouches(e),
	                activeTouches = that.touches,
	                idx,
	                touch,
	                touchInfo,
	                matchingTouch;

	            for (idx = 0; idx < activeTouches.length; idx ++) {
	                touch = activeTouches[idx];
	                dict[touch.id] = touch;
	            }

	            for (idx = 0; idx < touches.length; idx ++) {
	                touchInfo = touches[idx];
	                matchingTouch = dict[touchInfo.id];

	                if (matchingTouch) {
	                    matchingTouch[methodName](touchInfo);
	                }
	            }
	        },

	        _apiCall: function(type, x, y, target) {
	            this[type]({
	                api: true,
	                pageX: x,
	                pageY: y,
	                clientX: x,
	                clientY: y,
	                target: $(target || this.element)[0],
	                stopPropagation: $.noop,
	                preventDefault: $.noop
	            });
	        }
	    });

	    UserEvents.defaultThreshold = function(value) {
	        DEFAULT_THRESHOLD = value;
	    };

	    UserEvents.minHold = function(value) {
	        DEFAULT_MIN_HOLD = value;
	    };

	    kendo.getTouches = getTouches;
	    kendo.touchDelta = touchDelta;
	    kendo.UserEvents = UserEvents;
	 })(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "FeBl":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "Fjmu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ag_grid_1 = __webpack_require__("F6Mk");
var menuItemComponent_1 = __webpack_require__("CN4P");
var MenuList = (function (_super) {
    __extends(MenuList, _super);
    function MenuList() {
        var _this = _super.call(this, MenuList.TEMPLATE) || this;
        _this.timerCount = 0;
        _this.removeChildFuncs = [];
        return _this;
        // console.log('MenuList->constructor() ' + this.instance);
    }
    MenuList.prototype.clearActiveItem = function () {
        this.removeActiveItem();
        this.removeChildPopup();
    };
    MenuList.prototype.addMenuItems = function (menuItems) {
        var _this = this;
        if (ag_grid_1.Utils.missing(menuItems)) {
            return;
        }
        menuItems.forEach(function (menuItemOrString) {
            if (menuItemOrString === 'separator') {
                _this.addSeparator();
            }
            else if (typeof menuItemOrString === 'string') {
                console.log("ag-Grid: unrecognised menu item " + menuItemOrString);
            }
            else {
                var menuItem = menuItemOrString;
                _this.addItem(menuItem);
            }
        });
    };
    MenuList.prototype.addItem = function (menuItemDef) {
        var _this = this;
        var cMenuItem = new menuItemComponent_1.MenuItemComponent(menuItemDef);
        this.context.wireBean(cMenuItem);
        this.getGui().appendChild(cMenuItem.getGui());
        this.addDestroyFunc(function () { return cMenuItem.destroy(); });
        cMenuItem.addEventListener(menuItemComponent_1.MenuItemComponent.EVENT_ITEM_SELECTED, function (event) {
            if (menuItemDef.subMenu) {
                _this.showChildMenu(menuItemDef, cMenuItem, event.mouseEvent);
            }
            else {
                _this.dispatchEvent(event);
            }
        });
        cMenuItem.addGuiEventListener('mouseenter', this.mouseEnterItem.bind(this, menuItemDef, cMenuItem));
        cMenuItem.addGuiEventListener('mouseleave', function () { return _this.timerCount++; });
    };
    MenuList.prototype.mouseEnterItem = function (menuItemParams, menuItem) {
        if (menuItemParams.disabled) {
            return;
        }
        if (this.activeMenuItemParams !== menuItemParams) {
            this.removeChildPopup();
        }
        this.removeActiveItem();
        this.activeMenuItemParams = menuItemParams;
        this.activeMenuItem = menuItem;
        ag_grid_1.Utils.addCssClass(this.activeMenuItem.getGui(), 'ag-menu-option-active');
        if (menuItemParams.subMenu) {
            this.addHoverForChildPopup(menuItemParams, menuItem);
        }
    };
    MenuList.prototype.removeActiveItem = function () {
        if (this.activeMenuItem) {
            ag_grid_1.Utils.removeCssClass(this.activeMenuItem.getGui(), 'ag-menu-option-active');
            this.activeMenuItem = null;
            this.activeMenuItemParams = null;
        }
    };
    MenuList.prototype.addHoverForChildPopup = function (menuItemDef, menuItemComp) {
        var _this = this;
        var timerCountCopy = this.timerCount;
        setTimeout(function () {
            var shouldShow = timerCountCopy === _this.timerCount;
            var showingThisMenu = _this.subMenuParentDef === menuItemDef;
            if (shouldShow && !showingThisMenu) {
                _this.showChildMenu(menuItemDef, menuItemComp, null);
            }
        }, 500);
    };
    MenuList.prototype.addSeparator = function () {
        this.getGui().appendChild(ag_grid_1.Utils.loadTemplate(MenuList.SEPARATOR_TEMPLATE));
    };
    MenuList.prototype.showChildMenu = function (menuItemDef, menuItemComp, mouseEvent) {
        var _this = this;
        this.removeChildPopup();
        var childMenu = new MenuList();
        this.context.wireBean(childMenu);
        childMenu.addMenuItems(menuItemDef.subMenu);
        var ePopup = ag_grid_1.Utils.loadTemplate('<div class="ag-menu"></div>');
        ePopup.appendChild(childMenu.getGui());
        var hidePopupFunc = this.popupService.addAsModalPopup(ePopup, true, null, mouseEvent);
        this.popupService.positionPopupForMenu({
            eventSource: menuItemComp.getGui(),
            ePopup: ePopup
        });
        this.subMenuParentDef = menuItemDef;
        var selectedListener = function (event) {
            _this.dispatchEvent(event);
        };
        childMenu.addEventListener(menuItemComponent_1.MenuItemComponent.EVENT_ITEM_SELECTED, selectedListener);
        this.removeChildFuncs.push(function () {
            childMenu.clearActiveItem();
            childMenu.destroy();
            _this.subMenuParentDef = null;
            childMenu.removeEventListener(menuItemComponent_1.MenuItemComponent.EVENT_ITEM_SELECTED, selectedListener);
            hidePopupFunc();
        });
    };
    MenuList.prototype.removeChildPopup = function () {
        this.removeChildFuncs.forEach(function (func) { return func(); });
        this.removeChildFuncs = [];
    };
    MenuList.prototype.destroy = function () {
        // console.log('MenuList->destroy() ' + this.instance);
        this.removeChildPopup();
        _super.prototype.destroy.call(this);
    };
    // private instance = Math.random();
    MenuList.TEMPLATE = '<div class="ag-menu-list"></div>';
    MenuList.SEPARATOR_TEMPLATE = '<div class="ag-menu-separator">' +
        '  <span class="ag-menu-separator-cell"></span>' +
        '  <span class="ag-menu-separator-cell"></span>' +
        '  <span class="ag-menu-separator-cell"></span>' +
        '  <span class="ag-menu-separator-cell"></span>' +
        '</div>';
    __decorate([
        ag_grid_1.Autowired('context'),
        __metadata("design:type", ag_grid_1.Context)
    ], MenuList.prototype, "context", void 0);
    __decorate([
        ag_grid_1.Autowired('popupService'),
        __metadata("design:type", ag_grid_1.PopupService)
    ], MenuList.prototype, "popupService", void 0);
    return MenuList;
}(ag_grid_1.Component));
exports.MenuList = MenuList;


/***/ }),

/***/ "FpOn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
/** The base frameworks, eg React & Angular 2, override this bean with implementations specific to their requirement. */
var BaseFrameworkFactory = (function () {
    function BaseFrameworkFactory() {
    }
    BaseFrameworkFactory.prototype.dateComponent = function (gridOptions) {
        return gridOptions.dateComponent;
    };
    BaseFrameworkFactory.prototype.colDefFloatingCellRenderer = function (colDef) {
        return colDef.pinnedRowCellRenderer;
    };
    BaseFrameworkFactory.prototype.colDefCellRenderer = function (colDef) {
        return colDef.cellRenderer;
    };
    BaseFrameworkFactory.prototype.colDefCellEditor = function (colDef) {
        return colDef.cellEditor;
    };
    BaseFrameworkFactory.prototype.colDefFilter = function (colDef) {
        return colDef.filter;
    };
    BaseFrameworkFactory.prototype.gridOptionsFullWidthCellRenderer = function (gridOptions) {
        return gridOptions.fullWidthCellRenderer;
    };
    BaseFrameworkFactory.prototype.gridOptionsGroupRowRenderer = function (gridOptions) {
        return gridOptions.groupRowRenderer;
    };
    BaseFrameworkFactory.prototype.gridOptionsGroupRowInnerRenderer = function (gridOptions) {
        return gridOptions.groupRowInnerRenderer;
    };
    BaseFrameworkFactory.prototype.setTimeout = function (action, timeout) {
        setTimeout(action, timeout);
    };
    return BaseFrameworkFactory;
}());
exports.BaseFrameworkFactory = BaseFrameworkFactory;


/***/ }),

/***/ "FtD3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("t8qj");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "Fv0e":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1083);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1083:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/***********************************************************************
	 * WARNING: this file is auto-generated.  If you change it directly,
	 * your modifications will eventually be lost.  The source code is in
	 * `kendo-drawing` repository, you should make your changes there and
	 * run `src-modules/sync.sh` in this repository.
	 */
	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	    var __meta__ = { // jshint ignore:line
	        id: "color",
	        name: "Color utils",
	        category: "framework",
	        advanced: true,
	        description: "Color utilities used across components",
	        depends: [ "core" ]
	    };

	/*jshint eqnull:true  */

	window.kendo = window.kendo || {};

	var Class = kendo.Class;
	var support = kendo.support;

	var namedColors = {
	    aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff",
	    aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc",
	    bisque: "ffe4c4", black: "000000", blanchedalmond: "ffebcd",
	    blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a",
	    burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00",
	    chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed",
	    cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff",
	    darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b",
	    darkgray: "a9a9a9", darkgrey: "a9a9a9", darkgreen: "006400",
	    darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f",
	    darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000",
	    darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b",
	    darkslategray: "2f4f4f", darkslategrey: "2f4f4f", darkturquoise: "00ced1",
	    darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff",
	    dimgray: "696969", dimgrey: "696969", dodgerblue: "1e90ff",
	    firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22",
	    fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff",
	    gold: "ffd700", goldenrod: "daa520", gray: "808080",
	    grey: "808080", green: "008000", greenyellow: "adff2f",
	    honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c",
	    indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c",
	    lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00",
	    lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080",
	    lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgray: "d3d3d3",
	    lightgrey: "d3d3d3", lightgreen: "90ee90", lightpink: "ffb6c1",
	    lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa",
	    lightslategray: "778899", lightslategrey: "778899", lightsteelblue: "b0c4de",
	    lightyellow: "ffffe0", lime: "00ff00", limegreen: "32cd32",
	    linen: "faf0e6", magenta: "ff00ff", maroon: "800000",
	    mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3",
	    mediumpurple: "9370d8", mediumseagreen: "3cb371", mediumslateblue: "7b68ee",
	    mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585",
	    midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1",
	    moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080",
	    oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23",
	    orange: "ffa500", orangered: "ff4500", orchid: "da70d6",
	    palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee",
	    palevioletred: "d87093", papayawhip: "ffefd5", peachpuff: "ffdab9",
	    peru: "cd853f", pink: "ffc0cb", plum: "dda0dd",
	    powderblue: "b0e0e6", purple: "800080", red: "ff0000",
	    rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513",
	    salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57",
	    seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0",
	    skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090",
	    slategrey: "708090", snow: "fffafa", springgreen: "00ff7f",
	    steelblue: "4682b4", tan: "d2b48c", teal: "008080",
	    thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0",
	    violet: "ee82ee", wheat: "f5deb3", white: "ffffff",
	    whitesmoke: "f5f5f5", yellow: "ffff00", yellowgreen: "9acd32"
	};

	var browser = support.browser;

	var matchNamedColor = function (color) {
	    var colorNames = Object.keys(namedColors);
	    colorNames.push("transparent");

	    var regexp = new RegExp("^(" + colorNames.join("|") + ")(\\W|$)", "i");
	    matchNamedColor = function (color) { return regexp.exec(color); };

	    return regexp.exec(color);
	};

	var BaseColor = Class.extend({
	    init: function() {  },

	    toHSV: function() { return this; },

	    toRGB: function() { return this; },

	    toHex: function() { return this.toBytes().toHex(); },

	    toBytes: function() { return this; },

	    toCss: function() { return "#" + this.toHex(); },

	    toCssRgba: function() {
	        var rgb = this.toBytes();
	        return ("rgba(" + (rgb.r) + ", " + (rgb.g) + ", " + (rgb.b) + ", " + (parseFloat((Number(this.a)).toFixed(3))) + ")");
	    },

	    toDisplay: function() {
	        if (browser.msie && browser.version < 9) {
	            return this.toCss(); // no RGBA support; does it support any opacity in colors?
	        }
	        return this.toCssRgba();
	    },

	    equals: function(c) {
	        return c === this || c !== null && this.toCssRgba() === parseColor(c).toCssRgba();
	    },

	    diff: function(other) {
	        if (other === null) {
	            return NaN;
	        }

	        var c1 = this.toBytes();
	        var c2 = other.toBytes();

	        return Math.sqrt(Math.pow((c1.r - c2.r) * 0.30, 2) +
	                         Math.pow((c1.g - c2.g) * 0.59, 2) +
	                         Math.pow((c1.b - c2.b) * 0.11, 2));
	    },

	    clone: function() {
	        var c = this.toBytes();
	        if (c === this) {
	            c = new Bytes(c.r, c.g, c.b, c.a);
	        }

	        return c;
	    }
	});

	var RGB = BaseColor.extend({
	    init: function(r, g, b, a) {
	        BaseColor.fn.init.call(this);

	        this.r = r;
	        this.g = g;
	        this.b = b;
	        this.a = a;
	    },

	    toHSV: function() {
	        var ref = this;
	        var r = ref.r;
	        var g = ref.g;
	        var b = ref.b;
	        var min = Math.min(r, g, b);
	        var max = Math.max(r, g, b);
	        var delta = max - min;
	        var v = max;
	        var h, s;

	        if (delta === 0) {
	            return new HSV(0, 0, v, this.a);
	        }

	        if (max !== 0) {
	            s = delta / max;
	            if (r === max) {
	                h = (g - b) / delta;
	            } else if (g === max) {
	                h = 2 + (b - r) / delta;
	            } else {
	                h = 4 + (r - g) / delta;
	            }

	            h *= 60;
	            if (h < 0) {
	                h += 360;
	            }
	        } else {
	            s = 0;
	            h = -1;
	        }

	        return new HSV(h, s, v, this.a);
	    },

	    toHSL: function() {
	        var ref = this;
	        var r = ref.r;
	        var g = ref.g;
	        var b = ref.b;
	        var max = Math.max(r, g, b);
	        var min = Math.min(r, g, b);
	        var h, s, l = (max + min) / 2;

	        if (max === min) {
	            h = s = 0;
	        } else {
	            var d = max - min;
	            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	            switch (max) {
	                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	                case g: h = (b - r) / d + 2; break;
	                case b: h = (r - g) / d + 4; break;
	                default: break;
	            }
	        }

	        return new HSL(h * 60, s * 100, l * 100, this.a);
	    },

	    toBytes: function() {
	        return new Bytes(this.r * 255, this.g * 255, this.b * 255, this.a);
	    }
	});

	var Bytes = RGB.extend({
	    init: function(r, g, b, a) {
	        RGB.fn.init.call(this, Math.round(r), Math.round(g), Math.round(b), a);
	    },

	    toRGB: function() {
	        return new RGB(this.r / 255, this.g / 255, this.b / 255, this.a);
	    },

	    toHSV: function() {
	        return this.toRGB().toHSV();
	    },

	    toHSL: function() {
	        return this.toRGB().toHSL();
	    },

	    toHex: function() {
	        return hex(this.r, 2) + hex(this.g, 2) + hex(this.b, 2);
	    },

	    toBytes: function() {
	        return this;
	    }
	});

	function hex(n, width, pad) {
	    if (pad === void 0) { pad = "0"; }

	    var result = n.toString(16);
	    while (width > result.length) {
	        result = pad + result;
	    }

	    return result;
	}

	var HSV = BaseColor.extend({
	    init: function(h, s, v, a) {
	        BaseColor.fn.init.call(this);

	        this.h = h;
	        this.s = s;
	        this.v = v;
	        this.a = a;
	    },

	    toRGB: function() {
	        var ref = this;
	        var h = ref.h;
	        var s = ref.s;
	        var v = ref.v;
	        var r, g, b;

	        if (s === 0) {
	            r = g = b = v;
	        } else {
	            h /= 60;

	            var i = Math.floor(h);
	            var f = h - i;
	            var p = v * (1 - s);
	            var q = v * (1 - s * f);
	            var t = v * (1 - s * (1 - f));

	            switch (i) {
	                case 0: r = v; g = t; b = p; break;
	                case 1: r = q; g = v; b = p; break;
	                case 2: r = p; g = v; b = t; break;
	                case 3: r = p; g = q; b = v; break;
	                case 4: r = t; g = p; b = v; break;
	                default: r = v; g = p; b = q; break;
	            }
	        }

	        return new RGB(r, g, b, this.a);
	    },

	    toHSL: function() {
	        return this.toRGB().toHSL();
	    },

	    toBytes: function() {
	        return this.toRGB().toBytes();
	    }
	});

	var HSL = BaseColor.extend({
	    init: function(h, s, l, a) {
	        BaseColor.fn.init.call(this);

	        this.h = h;
	        this.s = s;
	        this.l = l;
	        this.a = a;
	    },

	    toRGB: function() {
	        var h = this.h / 360;
	        var s = this.s / 100;
	        var l = this.l / 100;
	        var r, g, b;

	        if (s === 0) {
	            r = g = b = l; // achromatic
	        } else {
	            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	            var p = 2 * l - q;
	            r = hue2rgb(p, q, h + 1 / 3);
	            g = hue2rgb(p, q, h);
	            b = hue2rgb(p, q, h - 1 / 3);
	        }

	        return new RGB(r, g, b, this.a);
	    },

	    toHSV: function() {
	        return this.toRGB().toHSV();
	    },

	    toBytes: function() {
	        return this.toRGB().toBytes();
	    }
	});

	function hue2rgb(p, q, s) {
	    var t = s;

	    if (t < 0) {
	        t += 1;
	    }

	    if (t > 1) {
	        t -= 1;
	    }

	    if (t < 1 / 6) {
	        return p + (q - p) * 6 * t;
	    }

	    if (t < 1 / 2) {
	        return q;
	    }

	    if (t < 2 / 3) {
	        return p + (q - p) * (2 / 3 - t) * 6;
	    }

	    return p;
	}

	function parseColor(value, safe) {
	    var m, ret;

	    if (value == null || value === "none") {
	        return null;
	    }

	    if (value instanceof BaseColor) {
	        return value;
	    }

	    var color = value.toLowerCase();
	    if ((m = matchNamedColor(color))) {
	        if (m[1] === "transparent") {
	            color = new RGB(1, 1, 1, 0);
	        } else {
	            color = parseColor(namedColors[m[1]], safe);
	        }
	        color.match = [ m[1] ];
	        return color;
	    }
	    if ((m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})\b/i.exec(color))) {
	        ret = new Bytes(parseInt(m[1], 16),
	                        parseInt(m[2], 16),
	                        parseInt(m[3], 16), 1);
	    } else if ((m = /^#?([0-9a-f])([0-9a-f])([0-9a-f])\b/i.exec(color))) {
	        ret = new Bytes(parseInt(m[1] + m[1], 16),
	                        parseInt(m[2] + m[2], 16),
	                        parseInt(m[3] + m[3], 16), 1);
	    } else if ((m = /^rgb\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/.exec(color))) {
	        ret = new Bytes(parseInt(m[1], 10),
	                        parseInt(m[2], 10),
	                        parseInt(m[3], 10), 1);
	    } else if ((m = /^rgba\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9.]+)\s*\)/.exec(color))) {
	        ret = new Bytes(parseInt(m[1], 10),
	                        parseInt(m[2], 10),
	                        parseInt(m[3], 10), parseFloat(m[4]));
	    } else if ((m = /^rgb\(\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*\)/.exec(color))) {
	        ret = new RGB(parseFloat(m[1]) / 100,
	                      parseFloat(m[2]) / 100,
	                      parseFloat(m[3]) / 100, 1);
	    } else if ((m = /^rgba\(\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9.]+)\s*\)/.exec(color))) {
	        ret = new RGB(parseFloat(m[1]) / 100,
	                      parseFloat(m[2]) / 100,
	                      parseFloat(m[3]) / 100, parseFloat(m[4]));
	    }

	    if (ret) {
	        ret.match = m;
	    } else if (!safe) {
	        throw new Error("Cannot parse color: " + color);
	    }

	    return ret;
	}

	var DARK_TRESHOLD = 180;

	var Color = Class.extend({
	    init: function(value) {
	        var this$1 = this;

	        if (arguments.length === 1) {
	            var formats = Color.formats;
	            var resolvedColor = this.resolveColor(value);

	            for (var idx = 0; idx < formats.length; idx++) {
	                var formatRegex = formats[idx].re;
	                var processor = formats[idx].process;
	                var parts = formatRegex.exec(resolvedColor);

	                if (parts) {
	                    var channels = processor(parts);
	                    this$1.r = channels[0];
	                    this$1.g = channels[1];
	                    this$1.b = channels[2];
	                }
	            }
	        } else {
	            this.r = arguments[0];
	            this.g = arguments[1];
	            this.b = arguments[2];
	        }

	        this.r = this.normalizeByte(this.r);
	        this.g = this.normalizeByte(this.g);
	        this.b = this.normalizeByte(this.b);
	    },

	    toHex: function() {
	        var pad = this.padDigit;
	        var r = this.r.toString(16);
	        var g = this.g.toString(16);
	        var b = this.b.toString(16);

	        return "#" + pad(r) + pad(g) + pad(b);
	    },

	    resolveColor: function(value) {
	        var color = value || "black";

	        if (color.charAt(0) === "#") {
	            color = color.substr(1, 6);
	        }

	        color = color.replace(/ /g, "");
	        color = color.toLowerCase();
	        color = Color.namedColors[color] || color;

	        return color;
	    },

	    normalizeByte: function(value) {
	        if (value < 0 || isNaN(value)) {
	            return 0;
	        }

	        return value > 255 ? 255 : value;
	    },

	    padDigit: function(value) {
	        return (value.length === 1) ? "0" + value : value;
	    },

	    brightness: function(value) {
	        var round = Math.round;

	        this.r = round(this.normalizeByte(this.r * value));
	        this.g = round(this.normalizeByte(this.g * value));
	        this.b = round(this.normalizeByte(this.b * value));

	        return this;
	    },

	    percBrightness: function() {
	        return Math.sqrt(0.241 * this.r * this.r + 0.691 * this.g * this.g + 0.068 * this.b * this.b);
	    },

	    isDark: function() {
	        return this.percBrightness() < DARK_TRESHOLD;
	    }
	});

	Color.fromBytes = function(r, g, b, a) {
	    return new Bytes(r, g, b, a != null ? a : 1);
	};

	Color.fromRGB = function(r, g, b, a) {
	    return new RGB(r, g, b, a != null ? a : 1);
	};

	Color.fromHSV = function(h, s, v, a) {
	    return new HSV(h, s, v, a != null ? a : 1);
	};

	Color.fromHSL = function(h, s, l, a) {
	    return new HSL(h, s, l, a != null ? a : 1);
	};

	Color.formats = [ {
	    re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
	    process: function(parts) {
	        return [
	            parseInt(parts[1], 10), parseInt(parts[2], 10), parseInt(parts[3], 10)
	        ];
	    }
	}, {
	    re: /^(\w{2})(\w{2})(\w{2})$/,
	    process: function(parts) {
	        return [
	            parseInt(parts[1], 16), parseInt(parts[2], 16), parseInt(parts[3], 16)
	        ];
	    }
	}, {
	    re: /^(\w{1})(\w{1})(\w{1})$/,
	    process: function(parts) {
	        return [
	            parseInt(parts[1] + parts[1], 16),
	            parseInt(parts[2] + parts[2], 16),
	            parseInt(parts[3] + parts[3], 16)
	        ];
	    }
	} ];

	Color.namedColors = namedColors;

	kendo.deepExtend(kendo, {
	    parseColor: parseColor,
	    namedColors: namedColors,
	    Color: Color
	});

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "G4uV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var eventService_1 = __webpack_require__("k5uU");
var utils_1 = __webpack_require__("IRr6");
var TouchListener = (function () {
    function TouchListener(eElement, preventMouseClick) {
        if (preventMouseClick === void 0) { preventMouseClick = false; }
        var _this = this;
        this.destroyFuncs = [];
        this.touching = false;
        this.eventService = new eventService_1.EventService();
        this.eElement = eElement;
        this.preventMouseClick = preventMouseClick;
        var startListener = this.onTouchStart.bind(this);
        var moveListener = this.onTouchMove.bind(this);
        var endListener = this.onTouchEnd.bind(this);
        this.eElement.addEventListener('touchstart', startListener, { passive: true });
        this.eElement.addEventListener('touchmove', moveListener, { passive: true });
        // we set passive=false, as we want to prevent default on this event
        this.eElement.addEventListener('touchend', endListener, { passive: false });
        this.destroyFuncs.push(function () {
            _this.eElement.addEventListener('touchstart', startListener, { passive: true });
            _this.eElement.addEventListener('touchmove', moveListener, { passive: true });
            _this.eElement.addEventListener('touchend', endListener, { passive: false });
        });
    }
    TouchListener.prototype.getActiveTouch = function (touchList) {
        for (var i = 0; i < touchList.length; i++) {
            var matches = touchList[i].identifier === this.touchStart.identifier;
            if (matches) {
                return touchList[i];
            }
        }
        return null;
    };
    TouchListener.prototype.addEventListener = function (eventType, listener) {
        this.eventService.addEventListener(eventType, listener);
    };
    TouchListener.prototype.removeEventListener = function (eventType, listener) {
        this.eventService.removeEventListener(eventType, listener);
    };
    TouchListener.prototype.onTouchStart = function (touchEvent) {
        var _this = this;
        // only looking at one touch point at any time
        if (this.touching) {
            return;
        }
        this.touchStart = touchEvent.touches[0];
        this.touching = true;
        this.moved = false;
        var touchStartCopy = this.touchStart;
        setTimeout(function () {
            var touchesMatch = _this.touchStart === touchStartCopy;
            if (_this.touching && touchesMatch && !_this.moved) {
                _this.moved = true;
                var event_1 = {
                    type: TouchListener.EVENT_LONG_TAP,
                    touchStart: _this.touchStart,
                    touchEvent: touchEvent
                };
                _this.eventService.dispatchEvent(event_1);
            }
        }, 500);
    };
    TouchListener.prototype.onTouchMove = function (touchEvent) {
        if (!this.touching) {
            return;
        }
        var touch = this.getActiveTouch(touchEvent.touches);
        if (!touch) {
            return;
        }
        var eventIsFarAway = !utils_1.Utils.areEventsNear(touch, this.touchStart, 4);
        if (eventIsFarAway) {
            this.moved = true;
        }
    };
    TouchListener.prototype.onTouchEnd = function (touchEvent) {
        if (!this.touching) {
            return;
        }
        if (!this.moved) {
            var event_2 = {
                type: TouchListener.EVENT_TAP,
                touchStart: this.touchStart
            };
            this.eventService.dispatchEvent(event_2);
            // stops the tap from also been processed as a mouse click
            if (this.preventMouseClick) {
                touchEvent.preventDefault();
            }
        }
        this.touching = false;
    };
    TouchListener.prototype.destroy = function () {
        this.destroyFuncs.forEach(function (func) { return func(); });
    };
    // private mostRecentTouch: Touch;
    TouchListener.EVENT_TAP = 'tap';
    TouchListener.EVENT_LONG_TAP = 'longTap';
    return TouchListener;
}());
exports.TouchListener = TouchListener;


/***/ }),

/***/ "G5+n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var baseFilter_1 = __webpack_require__("5yUf");
var componentAnnotations_1 = __webpack_require__("x5ih");
var TextFilter = (function (_super) {
    __extends(TextFilter, _super);
    function TextFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextFilter.prototype.getDefaultType = function () {
        return baseFilter_1.BaseFilter.CONTAINS;
    };
    TextFilter.prototype.customInit = function () {
        this.comparator = this.filterParams.textCustomComparator ? this.filterParams.textCustomComparator : TextFilter.DEFAULT_COMPARATOR;
        this.formatter =
            this.filterParams.textFormatter ? this.filterParams.textFormatter :
                this.filterParams.caseSensitive == true ? TextFilter.DEFAULT_FORMATTER :
                    TextFilter.DEFAULT_LOWERCASE_FORMATTER;
        _super.prototype.customInit.call(this);
    };
    TextFilter.prototype.modelFromFloatingFilter = function (from) {
        return {
            type: this.filter,
            filter: from,
            filterType: 'text'
        };
    };
    TextFilter.prototype.getApplicableFilterTypes = function () {
        return [baseFilter_1.BaseFilter.EQUALS, baseFilter_1.BaseFilter.NOT_EQUAL, baseFilter_1.BaseFilter.STARTS_WITH, baseFilter_1.BaseFilter.ENDS_WITH,
            baseFilter_1.BaseFilter.CONTAINS, baseFilter_1.BaseFilter.NOT_CONTAINS];
    };
    TextFilter.prototype.bodyTemplate = function () {
        var translate = this.translate.bind(this);
        return "<div class=\"ag-filter-body\">\n            <input class=\"ag-filter-filter\" id=\"filterText\" type=\"text\" placeholder=\"" + translate('filterOoo', 'Filter...') + "\"/>\n        </div>";
    };
    TextFilter.prototype.initialiseFilterBodyUi = function () {
        _super.prototype.initialiseFilterBodyUi.call(this);
        var debounceMs = this.getDebounceMs(this.filterParams);
        var toDebounce = utils_1.Utils.debounce(this.onFilterTextFieldChanged.bind(this), debounceMs);
        this.addDestroyableEventListener(this.eFilterTextField, 'input', toDebounce);
    };
    TextFilter.prototype.refreshFilterBodyUi = function () { };
    TextFilter.prototype.afterGuiAttached = function () {
        this.eFilterTextField.focus();
    };
    TextFilter.prototype.filterValues = function () {
        return this.filterText;
    };
    TextFilter.prototype.doesFilterPass = function (params) {
        if (!this.filterText) {
            return true;
        }
        var value = this.filterParams.valueGetter(params.node);
        if (!value) {
            if (this.filter === baseFilter_1.BaseFilter.NOT_EQUAL || this.filter === baseFilter_1.BaseFilter.NOT_CONTAINS) {
                // if there is no value, but the filter type was 'not equals',
                // then it should pass, as a missing value is not equal whatever
                // the user is filtering on
                return true;
            }
            else {
                // otherwise it's some type of comparison, to which empty value
                // will always fail
                return false;
            }
        }
        var valueFormatted = this.formatter(value);
        return this.comparator(this.filter, valueFormatted, this.filterText);
    };
    TextFilter.prototype.onFilterTextFieldChanged = function () {
        var filterText = utils_1.Utils.makeNull(this.eFilterTextField.value);
        if (filterText && filterText.trim() === '') {
            filterText = null;
        }
        if (this.filterText !== filterText) {
            var newLowerCase = filterText && this.filterParams.caseSensitive != true ? filterText.toLowerCase() :
                filterText;
            var previousLowerCase = this.filterText && this.filterParams.caseSensitive != true ? this.filterText.toLowerCase() :
                this.filterText;
            this.filterText = this.formatter(filterText);
            if (previousLowerCase !== newLowerCase) {
                this.onFilterChanged();
            }
        }
    };
    TextFilter.prototype.setFilter = function (filter) {
        filter = utils_1.Utils.makeNull(filter);
        if (filter) {
            this.filterText = this.formatter(filter);
            this.eFilterTextField.value = filter;
        }
        else {
            this.filterText = null;
            this.eFilterTextField.value = null;
        }
    };
    TextFilter.prototype.getFilter = function () {
        return this.filterText;
    };
    TextFilter.prototype.resetState = function () {
        this.setFilter(null);
        this.setFilterType(this.defaultFilter);
    };
    TextFilter.prototype.serialize = function () {
        return {
            type: this.filter ? this.filter : this.defaultFilter,
            filter: this.filterText,
            filterType: 'text'
        };
    };
    TextFilter.prototype.parse = function (model) {
        this.setFilterType(model.type);
        this.setFilter(model.filter);
    };
    TextFilter.prototype.setType = function (filterType) {
        this.setFilterType(filterType);
    };
    TextFilter.DEFAULT_FORMATTER = function (from) {
        return from;
    };
    TextFilter.DEFAULT_LOWERCASE_FORMATTER = function (from) {
        if (from == null)
            return null;
        return from.toString().toLowerCase();
    };
    TextFilter.DEFAULT_COMPARATOR = function (filter, value, filterText) {
        switch (filter) {
            case TextFilter.CONTAINS:
                return value.indexOf(filterText) >= 0;
            case TextFilter.NOT_CONTAINS:
                return value.indexOf(filterText) === -1;
            case TextFilter.EQUALS:
                return value === filterText;
            case TextFilter.NOT_EQUAL:
                return value != filterText;
            case TextFilter.STARTS_WITH:
                return value.indexOf(filterText) === 0;
            case TextFilter.ENDS_WITH:
                var index = value.lastIndexOf(filterText);
                return index >= 0 && index === (value.length - filterText.length);
            default:
                // should never happen
                console.warn('invalid filter type ' + filter);
                return false;
        }
    };
    __decorate([
        componentAnnotations_1.QuerySelector('#filterText'),
        __metadata("design:type", HTMLInputElement)
    ], TextFilter.prototype, "eFilterTextField", void 0);
    return TextFilter;
}(baseFilter_1.ComparableBaseFilter));
exports.TextFilter = TextFilter;


/***/ }),

/***/ "G5x9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiColumnComboBoxColumn = exports.KendoMultiColumnComboBoxColumn = exports.MultiColumnComboBox = exports.KendoMultiColumnComboBox = exports.DropdownsInstaller = exports.KendoDropdownsInstaller = exports.MultiSelect = exports.KendoMultiSelect = exports.ComboBox = exports.KendoComboBox = exports.DropDownList = exports.KendoDropDownList = exports.AutoComplete = exports.KendoAutoComplete = undefined;

var _KendoAutoComplete = __webpack_require__("/0gA");

var _KendoAutoComplete2 = _interopRequireDefault(_KendoAutoComplete);

var _KendoDropDownList = __webpack_require__("CiAW");

var _KendoDropDownList2 = _interopRequireDefault(_KendoDropDownList);

var _KendoComboBox = __webpack_require__("Gr0w");

var _KendoComboBox2 = _interopRequireDefault(_KendoComboBox);

var _KendoMultiColumnComboBox = __webpack_require__("Os2y");

var _KendoMultiColumnComboBox2 = _interopRequireDefault(_KendoMultiColumnComboBox);

var _KendoMultiColumnComboBoxColumn = __webpack_require__("Yjjl");

var _KendoMultiColumnComboBoxColumn2 = _interopRequireDefault(_KendoMultiColumnComboBoxColumn);

var _KendoMultiSelect = __webpack_require__("02+g");

var _KendoMultiSelect2 = _interopRequireDefault(_KendoMultiSelect);

var _kendoDropdownsInstaller = __webpack_require__("XRen");

var _kendoDropdownsInstaller2 = _interopRequireDefault(_kendoDropdownsInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoAutoComplete = _KendoAutoComplete2.default;
exports.AutoComplete = _KendoAutoComplete2.default;
exports.KendoDropDownList = _KendoDropDownList2.default;
exports.DropDownList = _KendoDropDownList2.default;
exports.KendoComboBox = _KendoComboBox2.default;
exports.ComboBox = _KendoComboBox2.default;
exports.KendoMultiSelect = _KendoMultiSelect2.default;
exports.MultiSelect = _KendoMultiSelect2.default;
exports.KendoDropdownsInstaller = _kendoDropdownsInstaller2.default;
exports.DropdownsInstaller = _kendoDropdownsInstaller2.default;
exports.KendoMultiColumnComboBox = _KendoMultiColumnComboBox2.default;
exports.MultiColumnComboBox = _KendoMultiColumnComboBox2.default;
exports.KendoMultiColumnComboBoxColumn = _KendoMultiColumnComboBoxColumn2.default;
exports.MultiColumnComboBoxColumn = _KendoMultiColumnComboBoxColumn2.default;

/***/ }),

/***/ "GGMy":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1625);
	module.exports = __webpack_require__(1625);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1591:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("+FHp");

/***/ }),

/***/ 1625:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20), __webpack_require__(5), __webpack_require__(1591) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var identity = function(o) { return o; };

	    var SheetDataSourceBinder = kendo.Class.extend({
	        init: function(options) {

	            this.options = kendo.jQuery.extend({}, this.options, options);

	            this.columns = this._normalizeColumns(this.options.columns);

	            this._sheet();
	            this._dataSource();

	            this._header();

	            this._boundRowsCount = 0;

	            this.dataSource.fetch();
	        },

	        _sheet: function() {
	            this.sheet = this.options.sheet;

	            this._sheetChangeHandler = this._sheetChange.bind(this);
	            this._sheetDeleteRowHandler = this._sheetDeleteRow.bind(this);
	            this._sheetInsertRowHandler = this._sheetInsertRow.bind(this);

	            this.sheet.bind("change", this._sheetChangeHandler)
	                .bind("afterDeleteRow", this._sheetDeleteRowHandler)
	                .bind("afterInsertRow", this._sheetInsertRowHandler);
	        },

	        _sheetInsertRow: function(e) {
	            if (e.index !== undefined) {
	                this.dataSource.insert(Math.max(e.index - 1, 0), {});
	            }
	        },

	        _sheetDeleteRow: function(e) {
	            if (e.index !== undefined) {
	                var dataSource = this.dataSource;
	                var model = dataSource.view()[e.index - 1];

	                if (model) {
	                    dataSource.remove(model);
	                }
	            }
	        },

	        _header: function() {
	            this.sheet.batch(function() {
	                this.columns.forEach(function(column, index) {
	                    this.sheet.range(0,index).value(column.title);
	                }.bind(this));
	            }.bind(this));
	        },

	        _sheetChange: function(e) {
	            if (e.insertRow || e.deleteRow) {
	                // these actions are handled via custom events
	                return;
	            }

	            if (e.recalc && e.ref) {
	                var dataSource = this.dataSource;
	                var data = dataSource.view();
	                var columns = this.columns;
	                var fields;

	                if (dataSource.reader.model) {
	                    fields = dataSource.reader.model.fields;
	                }

	                if (!columns.length && data.length) {
	                    columns = Object.keys(data[0].toJSON());
	                }

	                var getters = columns.map(function(column) {
	                    var field = column.field;
	                    if (field && fields && fields[field] && fields[field].type == "date") {
	                        return kendo.spreadsheet.numberToDate;
	                    }
	                    return identity;
	                });

	                this._skipRebind = true;
	                var normalizedRef = this.sheet._grid.normalize(e.ref);
	                var values = this.sheet.range(normalizedRef).values();

	                normalizedRef.forEach(function(ref) {
	                    ref = ref.toRangeRef();
	                    var record;
	                    var valueIndex = 0;
	                    for (var ri = ref.topLeft.row; ri <= ref.bottomRight.row; ri++) {
	                        record = data[ri - 1]; // skip header row

	                        if (!record) {
	                            record = dataSource.insert(ri - 1, {});
	                            data = dataSource.view();
	                        }

	                        var colValueIndex = 0;
	                        for (var ci = ref.topLeft.col; ci <= ref.bottomRight.col && ci < columns.length; ci++) {
	                            record.set(columns[ci].field, getters[ci](values[valueIndex][colValueIndex++]));
	                        }
	                        valueIndex++;
	                    }
	                });

	                this._boundRowsCount = dataSource.view().length;

	                this._skipRebind = false;
	            }
	        },

	        _normalizeColumns: function(columns) {
	            return columns.map(function(column) {
	                var field = column.field || column;
	                return {
	                    field: field,
	                    title: column.title || field
	                };
	            });
	        },

	        _dataSource: function() {
	            var options = this.options;
	            var dataSource = options.dataSource;

	            dataSource = Array.isArray(dataSource) ? { data: dataSource } : dataSource;

	            if (this.dataSource && this._changeHandler) {
	                this.dataSource.unbind("change", this._changeHandler);
	            } else {
	                this._changeHandler = this._change.bind(this);
	            }

	            this.dataSource = kendo.data.DataSource.create(dataSource)
	                .bind("change", this._changeHandler);
	        },

	        _change: function() {
	            if (this._skipRebind) {
	                return;
	            }

	            if (this.sheet.trigger("dataBinding")) {
	                return;
	            }

	            var data = this.dataSource.view();
	            var columns = this.columns;

	            if (!columns.length && data.length) {
	                this.columns = columns = this._normalizeColumns(Object.keys(data[0].toJSON()));
	                this._header();
	            }

	            var getters = columns.map(function(column) {
	                return kendo.getter(column.field);
	            });

	            this.sheet.batch(function() {
	                var length = Math.max(data.length, this._boundRowsCount, this.sheet._grid.rowCount - 1);

	                for (var idx = 0; idx < length; idx++) {
	                    for (var getterIdx = 0; getterIdx < getters.length; getterIdx++) {
	                        var value = data[idx] ? getters[getterIdx](data[idx]) : null;

	                        //skip header row
	                        this.sheet.range(idx + 1, getterIdx).value(value);
	                    }
	                }
	            }.bind(this));

	            this._boundRowsCount = data.length;

	            this.sheet.trigger("dataBound");
	        },

	        destroy: function() {
	            this.dataSource.unbind("change", this._changeHandler);

	            this.sheet.unbind("change", this._sheetChangeHandler)
	                .unbind("deleteRow", this._sheetDeleteRowHandler)
	                .unbind("insertRow", this._sheetInsertRowHandler);
	        },

	        options: {
	            columns: []
	        }
	    });

	    kendo.spreadsheet.SheetDataSourceBinder = SheetDataSourceBinder;
	})(kendo);
	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "GHBc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "Gr0w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("7+uW");

var Vue = _interopRequireWildcard(_vue);

var _KendoComboBoxMixin = __webpack_require__("fJYQ");

var _KendoComboBoxMixin2 = _interopRequireDefault(_KendoComboBoxMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-combobox',
    mixins: [_KendoComboBoxMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('input', [this.$slots['kendo-datasource']]);
    }
};

/***/ }),

/***/ "Gu7T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("c/Tr");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ "GwMd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__("ungA");

var _MultiColumnComboBoxProps = __webpack_require__("Vaij");

var _MultiColumnComboBoxProps2 = _interopRequireDefault(_MultiColumnComboBoxProps);

var _KendoMultiColumnComboBoxColumn = __webpack_require__("Yjjl");

var _KendoMultiColumnComboBoxColumn2 = _interopRequireDefault(_KendoMultiColumnComboBoxColumn);

var _Animation = __webpack_require__("dGGS");

var _Animation2 = _interopRequireDefault(_Animation);

var _Popup = __webpack_require__("rQ4N");

var _Popup2 = _interopRequireDefault(_Popup);

var _Virtual = __webpack_require__("ZSoY");

var _Virtual2 = _interopRequireDefault(_Virtual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: _MultiColumnComboBoxProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _Animation2.default, _Popup2.default, _Virtual2.default],
    model: {
        event: 'changemodel'
    },
    mounted: function mounted() {
        var that = this;
        var widgetElement = that.$el;
        that._resolveChildren();
        kendo.jQuery(this.$el).kendoMultiColumnComboBox(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', widgetElement.value);
            } else {
                that.$emit('changemodel', widgetElement.value);
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            var widgetElement = this.$el;
            return kendo.jQuery(widgetElement).getKendoMultiColumnComboBox();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('columns', _KendoMultiColumnComboBoxColumn2.default.name);
        }
    }
};

/***/ }),

/***/ "H/kR":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1360);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1109) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "reorderable",
	    name: "Reorderable",
	    category: "framework",
	    depends: [ "core", "draganddrop" ],
	    advanced: true
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        outerWidth = kendo._outerWidth,
	        outerHeight = kendo._outerHeight,
	        getOffset = kendo.getOffset,
	        Widget = kendo.ui.Widget,
	        CHANGE =  "change",
	        KREORDERABLE = "k-reorderable";

	    function toggleHintClass(hint, denied) {
	        hint = $(hint);

	        if (denied) {
	            hint.find(".k-drag-status").removeClass("k-i-plus").addClass("k-i-cancel");
	        } else {
	            hint.find(".k-drag-status").removeClass("k-i-cancel").addClass("k-i-plus");
	        }
	    }

	    var Reorderable = Widget.extend({
	        init: function(element, options) {
	            var that = this,
	                draggable,
	                group = kendo.guid() + "-reorderable";

	            Widget.fn.init.call(that, element, options);

	            element = that.element.addClass(KREORDERABLE);
	            options = that.options;

	            that.draggable = draggable = options.draggable || new kendo.ui.Draggable(element, {
	                group: group,
	                autoScroll: true,
	                filter: options.filter,
	                hint: options.hint
	            });

	            that.reorderDropCue = $('<div class="k-reorder-cue"></div></div>');

	            element.find(draggable.options.filter).kendoDropTarget({
	                group: draggable.options.group,
	                dragenter: function(e) {
	                    if (!that._draggable) {
	                        return;
	                    }

	                    var dropTarget = this.element, offset;
	                    var denied = !that._dropTargetAllowed(dropTarget) || that._isLastDraggable();

	                    toggleHintClass(e.draggable.hint, denied);
	                    if (!denied) {
	                        offset = getOffset(dropTarget);
	                        var left = offset.left;

	                        if (options.inSameContainer && !options.inSameContainer({
	                            source: dropTarget,
	                            target: that._draggable,
	                            sourceIndex: that._index(dropTarget),
	                            targetIndex: that._index(that._draggable)
	                        })) {
	                            that._dropTarget = dropTarget;
	                        } else {
	                            if (that._index(dropTarget) > that._index(that._draggable)) {
	                                left += outerWidth(dropTarget);
	                            }
	                        }

	                        that.reorderDropCue.css({
	                             height: outerHeight(dropTarget),
	                             top: offset.top,
	                             left: left
	                        })
	                        .appendTo(document.body);
	                    }
	                },
	                dragleave: function(e) {
	                    toggleHintClass(e.draggable.hint, true);
	                    that.reorderDropCue.remove();
	                    that._dropTarget = null;
	                },
	                drop: function() {
	                    that._dropTarget = null;
	                    if (!that._draggable) {
	                        return;
	                    }
	                    var dropTarget = this.element;
	                    var draggable = that._draggable;

	                    if (that._dropTargetAllowed(dropTarget) && !that._isLastDraggable()) {
	                        that.trigger(CHANGE, {
	                            element: that._draggable,
	                            target: dropTarget,
	                            oldIndex: that._index(draggable),
	                            newIndex: that._index(dropTarget),
	                            position: getOffset(that.reorderDropCue).left > getOffset(dropTarget).left ? "after" : "before"
	                        });
	                    }
	                }
	            });

	            draggable.bind([ "dragcancel", "dragend", "dragstart", "drag" ],
	                {
	                    dragcancel: function() {
	                        that.reorderDropCue.remove();
	                        that._draggable = null;
	                        that._elements = null;
	                    },
	                    dragend: function() {
	                        that.reorderDropCue.remove();
	                        that._draggable = null;
	                        that._elements = null;
	                    },
	                    dragstart: function(e) {
	                        that._draggable = e.currentTarget;
	                        that._elements = that.element.find(that.draggable.options.filter);
	                    },
	                    drag: function(e) {
	                        if (!that._dropTarget || this.hint.find(".k-drag-status").hasClass("k-i-cancel")) {
	                            return;
	                        }

	                        var dropStartOffset = getOffset(that._dropTarget).left;
	                        var width = outerWidth(that._dropTarget);

	                        if (e.pageX > dropStartOffset + width / 2) {
	                            that.reorderDropCue.css({ left: dropStartOffset + width });
	                        } else {
	                            that.reorderDropCue.css({ left: dropStartOffset });
	                        }
	                    }
	                }
	            );
	        },

	        options: {
	            name: "Reorderable",
	            filter: "*"
	        },

	        events: [
	            CHANGE
	        ],

	        _isLastDraggable: function() {
	            var inSameContainer = this.options.inSameContainer,
	                draggable = this._draggable[0],
	                elements = this._elements.get(),
	                found = false,
	                item;

	            if (!inSameContainer) {
	                return false;
	            }

	            while (!found && elements.length > 0) {
	                item = elements.pop();
	                found = draggable !== item && inSameContainer({
	                    source: draggable,
	                    target: item,
	                    sourceIndex: this._index(draggable),
	                    targetIndex: this._index(item)
	                });
	            }

	            return !found;
	        },

	        _dropTargetAllowed: function(dropTarget) {
	            var inSameContainer = this.options.inSameContainer,
	                dragOverContainers = this.options.dragOverContainers,
	                draggable = this._draggable;

	            if (draggable[0] === dropTarget[0]) {
	                return false;
	            }

	            if (!inSameContainer || !dragOverContainers) {
	                return true;
	            }

	            if (inSameContainer({ source: draggable,
	                target: dropTarget,
	                sourceIndex: this._index(draggable),
	                targetIndex: this._index(dropTarget)
	            })) {
	                return true;
	            }

	            return dragOverContainers(this._index(draggable), this._index(dropTarget));
	        },

	        _index: function(element) {
	            return this._elements.index(element);
	        },

	        destroy: function() {
	           var that = this;

	           Widget.fn.destroy.call(that);

	           that.element.find(that.draggable.options.filter).each(function() {
	               var item = $(this);
	               if (item.data("kendoDropTarget")) {
	                   item.data("kendoDropTarget").destroy();
	               }
	           });

	           if (that.draggable) {
	               that.draggable.destroy();

	               that.draggable.element = that.draggable = null;
	           }
	           that.elements = that.reorderDropCue = that._elements = that._draggable = null;
	       }
	    });

	    kendo.ui.plugin(Reorderable);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));



/***/ })

/******/ });

/***/ }),

/***/ "H99H":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1281);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1281:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1282),
	        __webpack_require__(1283)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function () {

	var __meta__ = {// jshint ignore:line
	    id: "imageeditor",
	    name: "ImageEditor",
	    category: "web",
	    depends: ["core"]
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        extend = $.extend,
	        isPlainObject = $.isPlainObject,
	        Widget = kendo.ui.Widget,
	        ui = kendo.ui,

	        NS = ".kendoImageEditor",

	        outerHeight = kendo._outerHeight,

	        ERROR = "error",
	        IMAGELOADED = "imageLoaded",
	        IMAGERENDERED = "imageRendered",
	        EXECUTE = "execute";

	    var imageEditorStyles = {
	        wrapper: "k-widget k-imageeditor",
	        header: "k-imageeditor-header",
	        toolbar: "k-imageeditor-toolbar",
	        paneWrapper: "k-imageeditor-action-pane",
	        contentWrapper: "k-imageeditor-content",
	        canvasWrapper: "k-imageeditor-canvas-container",
	        canvasContainer: "k-imageeditor-canvas"
	    };

	    var ImageEditor = Widget.extend({
	        init: function (element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);
	            options = $.extend(true, {}, options);

	            that._wrapper();
	            that._renderHeader();
	            that._contentWrapper();
	            that._keyHandler();

	            if(options.imageUrl) {
	                that._drawCanvas();
	            }

	            that._initUndoRedoStack();
	            that._toggleTools();

	            kendo.notify(that);
	        },

	        options: {
	            name: 'ImageEditor',
	            width: "100%",
	            height: 570,
	            imageUrl: "",
	            toolbar: {
	            },
	            saveAs: {
	                fileName: "image.png"
	            },
	            messages: {
	                toolbar: {
	                    open: "Open Image",
	                    save: "Save Image",
	                    undo: "Undo",
	                    redo: "Redo",
	                    crop: "Crop",
	                    resize: "Resize",
	                    zoomIn: "Zoom In",
	                    zoomOut: "Zoom Out",
	                    zoomDropdown: "Zoom options",
	                    zoomActualSize: "Show actual size",
	                    zoomFitToScreen: "Fit to screen"
	                },
	                panes: {
	                    crop: {
	                        title: "Crop Image",
	                        aspectRatio: "Aspect Ratio:",
	                        aspectRatioItems: {
	                            "originalRatio": "Original ratio",
	                            "1:1": "1:1 (Square)",
	                            "4:5": "4:5 (8:10)",
	                            "5:7": "5:7",
	                            "2:3": "2:3 (4:6)",
	                            "16:9": "16:9"
	                        },
	                        orientation: "Orientation:",
	                        portrait: "Portrait",
	                        landscape: "Landscape"
	                    },
	                    resize: {
	                        title: "Resize image",
	                        pixels: "Pixels",
	                        percents: "Percents"
	                    }
	                },
	                common: {
	                    width: "Width:",
	                    height: "Height:",
	                    cancel: "Cancel",
	                    confirm: "Confirm",
	                    lockAspectRatio: "Lock aspect ratio"
	                }
	            }
	        },

	        events: [
	            ERROR,
	            IMAGELOADED,
	            IMAGERENDERED,
	            EXECUTE
	        ],

	        _wrapper: function() {
	            var that = this,
	                options = that.options,
	                width = options.width,
	                height = options.height;

	            that.wrapper = that.element
	                .addClass(imageEditorStyles.wrapper);

	            if (width) {
	                that.wrapper.width(width);
	            }

	            if (height) {
	                that.wrapper.height(height);
	            }

	            that._resizeHandler = kendo.onResize(function() {
	                that.resize(true);
	            });
	        },

	        _renderHeader: function () {
	            var that = this,
	                options = that.options;

	            that.header = $("<div />").addClass(imageEditorStyles.header);

	            if (options.toolbar) {
	                that.header.append(that._initToolbar().element);
	            }

	            that.wrapper.append(that.header);
	        },

	        _initToolbar: function () {
	            var that = this,
	                options = that.options,
	                toolbarElement = $("<div></div>").addClass(imageEditorStyles.toolbar),
	                toolbarOptions = extend({}, options.toolbar, {
	                    messages: options.messages.toolbar,
	                    action: that.executeCommand.bind(that)
	                });

	            that.toolbar = new ui.imageeditor.ToolBar(toolbarElement, toolbarOptions);

	            return that.toolbar;
	        },

	        _contentWrapper: function () {
	            var that = this,
	                contentWrapper = $("<div></div>").addClass(imageEditorStyles.contentWrapper),
	                canvasWrapper = $("<div></div>").addClass(imageEditorStyles.canvasWrapper),
	                canvasContainer = $("<div></div>").addClass(imageEditorStyles.canvasContainer),
	                paneWrapper = $("<div></div>").addClass(imageEditorStyles.paneWrapper).hide(),
	                toolbarHeight = outerHeight(that.header);

	            that.canvasWrapper = canvasWrapper;
	            that.canvasContainer = canvasContainer;
	            that.paneWrapper = paneWrapper;

	            canvasWrapper.append(canvasContainer);

	            contentWrapper.height(outerHeight(that.wrapper) - toolbarHeight);

	            contentWrapper.append(canvasWrapper).append(paneWrapper);
	            that.wrapper.append(contentWrapper);
	        },

	        _keyHandler: function () {
	            var that = this,
	                prevent = false;

	            that.wrapper.on("keydown" + NS, function(ev){
	                if(ev.ctrlKey){
	                    switch (ev.keyCode) {
	                        case 48: // ctrl+0
	                            that.executeCommand({ command: "ZoomImageEditorCommand", options: "fitToScreen" });
	                            prevent = true;
	                            break;
	                        case 189: // ctrl+-
	                            that.executeCommand({ command: "ZoomImageEditorCommand", options: "zoomOut" });
	                            prevent = true;
	                            break;
	                        case 187: // ctrl++
	                            that.executeCommand({ command: "ZoomImageEditorCommand", options: "zoomIn" });
	                            prevent = true;
	                            break;
	                        case 90: // ctrl+z
	                            that.executeCommand({ command: "UndoImageEditorCommand" });
	                            prevent = true;
	                            break;
	                        case 89: // ctrl+y
	                            that.executeCommand({ command: "RedoImageEditorCommand" });
	                            prevent = true;
	                            break;
	                    }

	                    if(prevent) {
	                        ev.preventDefault();
	                    }
	                }
	            });
	        },

	        _drawCanvas: function () {
	            var that = this;
	            var imageUrl = that.options.imageUrl;

	            that.drawImage(imageUrl).done(function (image) {
	                if(!that.trigger(IMAGELOADED, {image: image})){
	                    that.drawCanvas(image);
	                }
	            }).fail(function (ev) {
	                that.trigger(ERROR, ev);
	            });
	        },

	        _initUndoRedoStack: function () {
	            var that = this;

	            that.undoStack = [];
	            that.redoStack = [];
	        },

	        _toggleTools: function () {
	            var that = this,
	                canRedo = that.redoStack.length > 0,
	                canUndo = that.undoStack.length > 0,
	                hasImage = !!that._image,
	                canExport = true;

	            try {
	                that._canvas.toDataURL();
	            } catch (error) {
	                canExport = false;
	            }

	            that.toolbar.toggleTools({
	                redo: canRedo,
	                undo: canUndo,
	                enable: hasImage,
	                canExport: canExport
	            });
	        },

	        drawImage: function (imageUrl) {
	            var that = this,
	                deferred = new $.Deferred(),
	                image = new Image();

	            image.onload = function() {
	                kendo.ui.progress(that.canvasContainer, false);
	                deferred.resolve(image);
	            };

	            image.onerror = function() {
	                kendo.ui.progress(that.canvasContainer, false);
	                deferred.reject(arguments);
	            };

	            kendo.ui.progress(that.canvasContainer, true);

	            image.src = imageUrl;

	            return deferred.promise();
	        },

	        drawCanvas: function (image) {
	            var that = this;
	            var canvas = $("<canvas>Canvas element</canvas>")[0];
	            var ctx = canvas.getContext('2d');

	            if (that._canvas) {
	                $(that._canvas).remove();
	            }

	            if(that._image) {
	                that.undoStack.push(that._image);
	            }

	            that._canvas = canvas;
	            that._ctx = ctx;
	            that._image = image;

	            canvas.width = image.width;
	            canvas.height = image.height;

	            ctx.drawImage(image, 0, 0);

	            that.canvasContainer.append(canvas);

	            if(image.height > that.canvasWrapper.height()) {
	                that.executeCommand({ command: "ZoomImageEditorCommand", options: "fitToScreen" });
	            } else {
	                that.executeCommand({ command: "ZoomImageEditorCommand", options: that.getZoomLevel() });
	            }

	            that.trigger(IMAGERENDERED, {
	                canvas: canvas,
	                ctx: ctx,
	                image: image
	            });

	            that._toggleTools();
	        },

	        getCanvasElement: function () {
	            return this._canvas;
	        },

	        getCurrent2dContext: function () {
	            return this._ctx;
	        },

	        getCurrentImage: function () {
	            return this._image;
	        },

	        executeCommand: function(args) {
	            var commandName = args.command,
	                commandOptions = extend({ imageeditor: this }, isPlainObject(args.options) ? args.options : {value: args.options}),
	                command = new ui.imageeditor.commands[commandName](commandOptions);

	            if(!this.trigger(EXECUTE, args)) {
	                this._toggleTools();
	                return command.exec();
	            }
	        },

	        getZoomLevel: function(){
	            return this._zoomLevel || 1;
	        },

	        destroy: function() {
	            var that = this;

	            that.element.off(NS);

	            if (that.currentPaneTool) {
	                that.currentPaneTool.destroy();
	            }

	            if(that.toolbar) {
	                that.toolbar.destroy();
	            }

	            if(that._upload) {
	                that._upload.destroy();
	            }


	            Widget.fn.destroy.call(that);
	        }
	    });
	    ui.plugin(ImageEditor);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1282:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("4/sQ");

/***/ }),

/***/ 1283:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7Jyx");

/***/ })

/******/ });

/***/ }),

/***/ "H9AQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = __webpack_require__("pQ38");
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var componentAnnotations_1 = __webpack_require__("x5ih");
var utils_1 = __webpack_require__("IRr6");
var eventService_1 = __webpack_require__("k5uU");
var events_1 = __webpack_require__("3ok8");
var rowRenderer_1 = __webpack_require__("3RUv");
var paginationProxy_1 = __webpack_require__("wYvi");
var PaginationComp = (function (_super) {
    __extends(PaginationComp, _super);
    function PaginationComp() {
        return _super.call(this) || this;
    }
    PaginationComp.prototype.postConstruct = function () {
        this.setTemplate(this.getTemplate());
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this));
        this.addDestroyableEventListener(this.btFirst, 'click', this.onBtFirst.bind(this));
        this.addDestroyableEventListener(this.btLast, 'click', this.onBtLast.bind(this));
        this.addDestroyableEventListener(this.btNext, 'click', this.onBtNext.bind(this));
        this.addDestroyableEventListener(this.btPrevious, 'click', this.onBtPrevious.bind(this));
        this.onPaginationChanged();
    };
    PaginationComp.prototype.onPaginationChanged = function () {
        this.enableOrDisableButtons();
        this.updateRowLabels();
        this.setCurrentPageLabel();
        this.setTotalLabels();
    };
    PaginationComp.prototype.setCurrentPageLabel = function () {
        var pagesExist = this.paginationProxy.getTotalPages() > 0;
        var currentPage = this.paginationProxy.getCurrentPage();
        var toDisplay = pagesExist ? currentPage + 1 : 0;
        this.lbCurrent.innerHTML = this.formatNumber(toDisplay);
    };
    PaginationComp.prototype.formatNumber = function (value) {
        var userFunc = this.gridOptionsWrapper.getPaginationNumberFormatterFunc();
        if (userFunc) {
            return userFunc({ value: value });
        }
        else {
            return utils_1._.formatNumberCommas(value);
        }
    };
    PaginationComp.prototype.getTemplate = function () {
        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
        var strPage = localeTextFunc('page', 'Page');
        var strTo = localeTextFunc('to', 'to');
        var strOf = localeTextFunc('of', 'of');
        var strFirst = localeTextFunc('first', 'First');
        var strPrevious = localeTextFunc('previous', 'Previous');
        var strNext = localeTextFunc('next', 'Next');
        var strLast = localeTextFunc('last', 'Last');
        return "<div class=\"ag-paging-panel ag-font-style\">\n                <span ref=\"eSummaryPanel\" class=\"ag-paging-row-summary-panel\">\n                    <span ref=\"lbFirstRowOnPage\"></span> " + strTo + " <span ref=\"lbLastRowOnPage\"></span> " + strOf + " <span ref=\"lbRecordCount\"></span>\n                </span>\n                <span class=\"ag-paging-page-summary-panel\">\n                    <button class=\"ag-paging-button\" ref=\"btFirst\">" + strFirst + "</button>\n                    <button class=\"ag-paging-button\" ref=\"btPrevious\">" + strPrevious + "</button>\n                    " + strPage + " <span ref=\"lbCurrent\"></span> " + strOf + " <span ref=\"lbTotal\"></span>\n                    <button class=\"ag-paging-button\" ref=\"btNext\">" + strNext + "</button>\n                    <button class=\"ag-paging-button\" ref=\"btLast\">" + strLast + "</button>\n                </span>\n            </div>";
    };
    PaginationComp.prototype.onBtNext = function () {
        this.paginationProxy.goToNextPage();
    };
    PaginationComp.prototype.onBtPrevious = function () {
        this.paginationProxy.goToPreviousPage();
    };
    PaginationComp.prototype.onBtFirst = function () {
        this.paginationProxy.goToFirstPage();
    };
    PaginationComp.prototype.onBtLast = function () {
        this.paginationProxy.goToLastPage();
    };
    PaginationComp.prototype.enableOrDisableButtons = function () {
        var currentPage = this.paginationProxy.getCurrentPage();
        var maxRowFound = this.paginationProxy.isLastPageFound();
        var totalPages = this.paginationProxy.getTotalPages();
        var disablePreviousAndFirst = currentPage === 0;
        this.btPrevious.disabled = disablePreviousAndFirst;
        this.btFirst.disabled = disablePreviousAndFirst;
        var zeroPagesToDisplay = this.isZeroPagesToDisplay();
        var onLastPage = maxRowFound && currentPage === (totalPages - 1);
        var disableNext = onLastPage || zeroPagesToDisplay;
        this.btNext.disabled = disableNext;
        var disableLast = !maxRowFound || zeroPagesToDisplay || currentPage === (totalPages - 1);
        this.btLast.disabled = disableLast;
    };
    PaginationComp.prototype.updateRowLabels = function () {
        var currentPage = this.paginationProxy.getCurrentPage();
        var pageSize = this.paginationProxy.getPageSize();
        var maxRowFound = this.paginationProxy.isLastPageFound();
        var rowCount = this.paginationProxy.isLastPageFound() ?
            this.paginationProxy.getTotalRowCount() : null;
        var startRow;
        var endRow;
        if (this.isZeroPagesToDisplay()) {
            startRow = 0;
            endRow = 0;
        }
        else {
            startRow = (pageSize * currentPage) + 1;
            endRow = startRow + pageSize - 1;
            if (maxRowFound && endRow > rowCount) {
                endRow = rowCount;
            }
        }
        this.lbFirstRowOnPage.innerHTML = this.formatNumber(startRow);
        this.lbLastRowOnPage.innerHTML = this.formatNumber(endRow);
    };
    PaginationComp.prototype.isZeroPagesToDisplay = function () {
        var maxRowFound = this.paginationProxy.isLastPageFound();
        var totalPages = this.paginationProxy.getTotalPages();
        return maxRowFound && totalPages === 0;
    };
    PaginationComp.prototype.setTotalLabels = function () {
        var lastPageFound = this.paginationProxy.isLastPageFound();
        var totalPages = this.paginationProxy.getTotalPages();
        var rowCount = this.paginationProxy.isLastPageFound() ?
            this.paginationProxy.getTotalRowCount() : null;
        if (lastPageFound) {
            this.lbTotal.innerHTML = this.formatNumber(totalPages);
            this.lbRecordCount.innerHTML = this.formatNumber(rowCount);
        }
        else {
            var moreText = this.gridOptionsWrapper.getLocaleTextFunc()('more', 'more');
            this.lbTotal.innerHTML = moreText;
            this.lbRecordCount.innerHTML = moreText;
        }
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], PaginationComp.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], PaginationComp.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('paginationProxy'),
        __metadata("design:type", paginationProxy_1.PaginationProxy)
    ], PaginationComp.prototype, "paginationProxy", void 0);
    __decorate([
        context_1.Autowired('rowRenderer'),
        __metadata("design:type", rowRenderer_1.RowRenderer)
    ], PaginationComp.prototype, "rowRenderer", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('btFirst'),
        __metadata("design:type", HTMLButtonElement)
    ], PaginationComp.prototype, "btFirst", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('btPrevious'),
        __metadata("design:type", HTMLButtonElement)
    ], PaginationComp.prototype, "btPrevious", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('btNext'),
        __metadata("design:type", HTMLButtonElement)
    ], PaginationComp.prototype, "btNext", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('btLast'),
        __metadata("design:type", HTMLButtonElement)
    ], PaginationComp.prototype, "btLast", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('lbRecordCount'),
        __metadata("design:type", Object)
    ], PaginationComp.prototype, "lbRecordCount", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('lbFirstRowOnPage'),
        __metadata("design:type", Object)
    ], PaginationComp.prototype, "lbFirstRowOnPage", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('lbLastRowOnPage'),
        __metadata("design:type", Object)
    ], PaginationComp.prototype, "lbLastRowOnPage", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('eSummaryPanel'),
        __metadata("design:type", Object)
    ], PaginationComp.prototype, "eSummaryPanel", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('lbCurrent'),
        __metadata("design:type", Object)
    ], PaginationComp.prototype, "lbCurrent", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('lbTotal'),
        __metadata("design:type", Object)
    ], PaginationComp.prototype, "lbTotal", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PaginationComp.prototype, "postConstruct", null);
    return PaginationComp;
}(component_1.Component));
exports.PaginationComp = PaginationComp;


/***/ }),

/***/ "HD9n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var rowNode_1 = __webpack_require__("bP2e");
var inMemoryNodeManager_1 = __webpack_require__("mhUy");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var eventService_1 = __webpack_require__("k5uU");
var context_1 = __webpack_require__("RQ1/");
var columnController_1 = __webpack_require__("77lH");
var RowNodeFactory = (function () {
    function RowNodeFactory() {
    }
    RowNodeFactory.prototype.create = function (data) {
        var rootNode = new rowNode_1.RowNode();
        var nodeManager = new inMemoryNodeManager_1.InMemoryNodeManager(rootNode, this.gridOptionsWrapper, this.context, this.eventService, this.columnController);
        this.context.wireBean(rootNode);
        nodeManager.setRowData(data);
        return rootNode;
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], RowNodeFactory.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], RowNodeFactory.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], RowNodeFactory.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], RowNodeFactory.prototype, "columnController", void 0);
    RowNodeFactory = __decorate([
        context_1.Bean("rowNodeFactory")
    ], RowNodeFactory);
    return RowNodeFactory;
}());
exports.RowNodeFactory = RowNodeFactory;


/***/ }),

/***/ "HDwJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var columnComponent_1 = __webpack_require__("jUST");
var AbstractColumnDropPanel = (function (_super) {
    __extends(AbstractColumnDropPanel, _super);
    function AbstractColumnDropPanel(horizontal, valueColumn, name) {
        var _this = _super.call(this, "<div class=\"ag-column-drop ag-font-style ag-column-drop-" + (horizontal ? 'horizontal' : 'vertical') + " ag-column-drop-" + name + "\"></div>") || this;
        _this.state = AbstractColumnDropPanel.STATE_NOT_DRAGGING;
        _this.guiDestroyFunctions = [];
        _this.childColumnComponents = [];
        _this.horizontal = horizontal;
        _this.valueColumn = valueColumn;
        return _this;
    }
    AbstractColumnDropPanel.prototype.isHorizontal = function () {
        return this.horizontal;
    };
    AbstractColumnDropPanel.prototype.setBeans = function (beans) {
        this.beans = beans;
    };
    AbstractColumnDropPanel.prototype.destroy = function () {
        this.destroyGui();
        _super.prototype.destroy.call(this);
    };
    AbstractColumnDropPanel.prototype.destroyGui = function () {
        this.guiDestroyFunctions.forEach(function (func) { return func(); });
        this.guiDestroyFunctions.length = 0;
        this.childColumnComponents.length = 0;
        main_1.Utils.removeAllChildren(this.getGui());
    };
    AbstractColumnDropPanel.prototype.init = function (params) {
        this.params = params;
        this.logger = this.beans.loggerFactory.create('AbstractColumnDropPanel');
        this.beans.eventService.addEventListener(main_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.refreshGui.bind(this));
        this.addDestroyableEventListener(this.beans.gridOptionsWrapper, 'functionsReadOnly', this.refreshGui.bind(this));
        this.setupDropTarget();
        // we don't know if this bean will be initialised before columnController.
        // if columnController first, then below will work
        // if columnController second, then below will put blank in, and then above event gets first when columnController is set up
        this.refreshGui();
    };
    AbstractColumnDropPanel.prototype.setupDropTarget = function () {
        this.dropTarget = {
            getContainer: this.getGui.bind(this),
            getIconName: this.getIconName.bind(this),
            onDragging: this.onDragging.bind(this),
            onDragEnter: this.onDragEnter.bind(this),
            onDragLeave: this.onDragLeave.bind(this),
            onDragStop: this.onDragStop.bind(this),
            isInterestedIn: this.isInterestedIn.bind(this)
        };
        this.beans.dragAndDropService.addDropTarget(this.dropTarget);
    };
    AbstractColumnDropPanel.prototype.isInterestedIn = function (type) {
        // not interested in row drags
        return type === main_1.DragSourceType.HeaderCell || type === main_1.DragSourceType.ToolPanel;
    };
    AbstractColumnDropPanel.prototype.checkInsertIndex = function (draggingEvent) {
        var newIndex;
        if (this.horizontal) {
            newIndex = this.getNewHorizontalInsertIndex(draggingEvent);
        }
        else {
            newIndex = this.getNewVerticalInsertIndex(draggingEvent);
        }
        // <0 happens when drag is no a direction we are interested in, eg drag is up/down but in horizontal panel
        if (newIndex < 0) {
            return false;
        }
        var changed = newIndex !== this.insertIndex;
        if (changed) {
            this.insertIndex = newIndex;
        }
        return changed;
    };
    AbstractColumnDropPanel.prototype.getNewHorizontalInsertIndex = function (draggingEvent) {
        if (main_1.Utils.missing(draggingEvent.hDirection)) {
            return -1;
        }
        var newIndex = 0;
        var mouseEvent = draggingEvent.event;
        var enableRtl = this.beans.gridOptionsWrapper.isEnableRtl();
        var goingLeft = draggingEvent.hDirection === main_1.HDirection.Left;
        var mouseX = mouseEvent.clientX;
        this.childColumnComponents.forEach(function (childColumn) {
            var rect = childColumn.getGui().getBoundingClientRect();
            var rectX = goingLeft ? rect.right : rect.left;
            var horizontalFit = enableRtl ? (mouseX <= rectX) : (mouseX >= rectX);
            if (horizontalFit) {
                newIndex++;
            }
        });
        return newIndex;
    };
    AbstractColumnDropPanel.prototype.getNewVerticalInsertIndex = function (draggingEvent) {
        if (main_1.Utils.missing(draggingEvent.vDirection)) {
            return -1;
        }
        var newIndex = 0;
        var mouseEvent = draggingEvent.event;
        this.childColumnComponents.forEach(function (childColumn) {
            var rect = childColumn.getGui().getBoundingClientRect();
            if (draggingEvent.vDirection === main_1.VDirection.Down) {
                var verticalFit = mouseEvent.clientY >= rect.top;
                if (verticalFit) {
                    newIndex++;
                }
            }
            else {
                var verticalFit = mouseEvent.clientY >= rect.bottom;
                if (verticalFit) {
                    newIndex++;
                }
            }
        });
        return newIndex;
    };
    AbstractColumnDropPanel.prototype.checkDragStartedBySelf = function (draggingEvent) {
        if (this.state !== AbstractColumnDropPanel.STATE_NOT_DRAGGING) {
            return;
        }
        this.state = AbstractColumnDropPanel.STATE_REARRANGE_COLUMNS;
        this.potentialDndColumns = draggingEvent.dragSource.dragItemCallback().columns;
        this.refreshGui();
        this.checkInsertIndex(draggingEvent);
        this.refreshGui();
    };
    AbstractColumnDropPanel.prototype.onDragging = function (draggingEvent) {
        this.checkDragStartedBySelf(draggingEvent);
        var positionChanged = this.checkInsertIndex(draggingEvent);
        if (positionChanged) {
            this.refreshGui();
        }
    };
    AbstractColumnDropPanel.prototype.onDragEnter = function (draggingEvent) {
        // this will contain all columns that are potential drops
        var dragColumns = draggingEvent.dragSource.dragItemCallback().columns;
        this.state = AbstractColumnDropPanel.STATE_NEW_COLUMNS_IN;
        // take out columns that are not groupable
        var goodDragColumns = main_1.Utils.filter(dragColumns, this.isColumnDroppable.bind(this));
        var weHaveColumnsToDrag = goodDragColumns.length > 0;
        if (weHaveColumnsToDrag) {
            this.potentialDndColumns = goodDragColumns;
            this.checkInsertIndex(draggingEvent);
            this.refreshGui();
        }
    };
    AbstractColumnDropPanel.prototype.isPotentialDndColumns = function () {
        return main_1.Utils.existsAndNotEmpty(this.potentialDndColumns);
    };
    AbstractColumnDropPanel.prototype.onDragLeave = function (draggingEvent) {
        // if the dragging started from us, we remove the group, however if it started
        // someplace else, then we don't, as it was only 'asking'
        if (this.state === AbstractColumnDropPanel.STATE_REARRANGE_COLUMNS) {
            var columns = draggingEvent.dragSource.dragItemCallback().columns;
            this.removeColumns(columns);
        }
        if (this.potentialDndColumns) {
            this.potentialDndColumns = null;
            this.refreshGui();
        }
        this.state = AbstractColumnDropPanel.STATE_NOT_DRAGGING;
    };
    AbstractColumnDropPanel.prototype.onDragStop = function () {
        if (this.potentialDndColumns) {
            var success = void 0;
            if (this.state === AbstractColumnDropPanel.STATE_NEW_COLUMNS_IN) {
                this.addColumns(this.potentialDndColumns);
                success = true;
            }
            else {
                success = this.rearrangeColumns(this.potentialDndColumns);
            }
            this.potentialDndColumns = null;
            // if the function is passive, then we don't refresh, as we assume the client application
            // is going to call setRowGroups / setPivots / setValues at a later point which will then
            // cause a refresh. this gives a nice gui where the ghost stays until the app has caught
            // up with the changes.
            if (this.beans.gridOptionsWrapper.isFunctionsPassive()) {
                // when functions are passive, we don't refresh,
                // unless there was no change in the order, then we
                // do need to refresh to reset the columns
                if (!success) {
                    this.refreshGui();
                }
            }
            else {
                this.refreshGui();
            }
        }
        this.state = AbstractColumnDropPanel.STATE_NOT_DRAGGING;
    };
    AbstractColumnDropPanel.prototype.removeColumns = function (columnsToRemove) {
        var newColumnList = this.getExistingColumns().slice();
        columnsToRemove.forEach(function (column) { return main_1.Utils.removeFromArray(newColumnList, column); });
        this.updateColumns(newColumnList);
    };
    AbstractColumnDropPanel.prototype.addColumns = function (columnsToAdd) {
        var newColumnList = this.getExistingColumns().slice();
        main_1.Utils.insertArrayIntoArray(newColumnList, columnsToAdd, this.insertIndex);
        this.updateColumns(newColumnList);
    };
    AbstractColumnDropPanel.prototype.rearrangeColumns = function (columnsToAdd) {
        var newColumnList = this.getNonGhostColumns().slice();
        main_1.Utils.insertArrayIntoArray(newColumnList, columnsToAdd, this.insertIndex);
        var noChangeDetected = main_1.Utils.shallowCompare(newColumnList, this.getExistingColumns());
        if (noChangeDetected) {
            return false;
        }
        else {
            this.updateColumns(newColumnList);
            return true;
        }
    };
    AbstractColumnDropPanel.prototype.refreshGui = function () {
        this.destroyGui();
        this.addIconAndTitleToGui();
        this.addEmptyMessageToGui();
        this.addColumnsToGui();
    };
    AbstractColumnDropPanel.prototype.getNonGhostColumns = function () {
        var _this = this;
        var existingColumns = this.getExistingColumns();
        var nonGhostColumns;
        if (main_1.Utils.exists(this.potentialDndColumns)) {
            nonGhostColumns = main_1.Utils.filter(existingColumns, function (column) { return _this.potentialDndColumns.indexOf(column) < 0; });
        }
        else {
            nonGhostColumns = existingColumns;
        }
        return nonGhostColumns;
    };
    AbstractColumnDropPanel.prototype.addColumnsToGui = function () {
        var _this = this;
        var nonGhostColumns = this.getNonGhostColumns();
        var itemsToAddToGui = [];
        var addingGhosts = main_1.Utils.exists(this.potentialDndColumns);
        nonGhostColumns.forEach(function (column, index) {
            if (addingGhosts && index >= _this.insertIndex) {
                return;
            }
            var columnComponent = _this.createColumnComponent(column, false);
            itemsToAddToGui.push(columnComponent);
        });
        if (this.potentialDndColumns) {
            this.potentialDndColumns.forEach(function (column) {
                var columnComponent = _this.createColumnComponent(column, true);
                itemsToAddToGui.push(columnComponent);
            });
            nonGhostColumns.forEach(function (column, index) {
                if (index < _this.insertIndex) {
                    return;
                }
                var columnComponent = _this.createColumnComponent(column, false);
                itemsToAddToGui.push(columnComponent);
            });
        }
        itemsToAddToGui.forEach(function (columnComponent, index) {
            var needSeparator = index !== 0;
            if (needSeparator) {
                _this.addArrowToGui();
            }
            _this.getGui().appendChild(columnComponent.getGui());
        });
    };
    AbstractColumnDropPanel.prototype.createColumnComponent = function (column, ghost) {
        var columnComponent = new columnComponent_1.ColumnComponent(column, this.dropTarget, ghost, this.valueColumn);
        columnComponent.addEventListener(columnComponent_1.ColumnComponent.EVENT_COLUMN_REMOVE, this.removeColumns.bind(this, [column]));
        this.beans.context.wireBean(columnComponent);
        this.guiDestroyFunctions.push(function () { return columnComponent.destroy(); });
        if (!ghost) {
            this.childColumnComponents.push(columnComponent);
        }
        return columnComponent;
    };
    AbstractColumnDropPanel.prototype.addIconAndTitleToGui = function () {
        var iconFaded = this.horizontal && this.isExistingColumnsEmpty();
        var eGroupIcon = this.params.icon;
        main_1.Utils.addCssClass(eGroupIcon, 'ag-column-drop-icon');
        main_1.Utils.addOrRemoveCssClass(eGroupIcon, 'ag-faded', iconFaded);
        this.getGui().appendChild(eGroupIcon);
        if (!this.horizontal) {
            var eTitle = document.createElement('span');
            eTitle.innerHTML = this.params.title;
            main_1.Utils.addCssClass(eTitle, 'ag-column-drop-title');
            main_1.Utils.addOrRemoveCssClass(eTitle, 'ag-faded', iconFaded);
            this.getGui().appendChild(eTitle);
        }
    };
    AbstractColumnDropPanel.prototype.isExistingColumnsEmpty = function () {
        return this.getExistingColumns().length === 0;
    };
    AbstractColumnDropPanel.prototype.addEmptyMessageToGui = function () {
        var showEmptyMessage = this.isExistingColumnsEmpty() && !this.potentialDndColumns;
        if (!showEmptyMessage) {
            return;
        }
        var eMessage = document.createElement('span');
        eMessage.innerHTML = this.params.emptyMessage;
        main_1.Utils.addCssClass(eMessage, 'ag-column-drop-empty-message');
        this.getGui().appendChild(eMessage);
    };
    AbstractColumnDropPanel.prototype.addArrowToGui = function () {
        // only add the arrows if the layout is horizontal
        if (this.horizontal) {
            // for RTL it's a left arrow, otherwise it's a right arrow
            var enableRtl = this.beans.gridOptionsWrapper.isEnableRtl();
            var charCode = enableRtl ?
                AbstractColumnDropPanel.CHAR_LEFT_ARROW : AbstractColumnDropPanel.CHAR_RIGHT_ARROW;
            var spanClass = enableRtl ? 'ag-left-arrow' : 'ag-right-arrow';
            var eArrow = document.createElement('span');
            eArrow.className = spanClass;
            eArrow.innerHTML = charCode;
            this.getGui().appendChild(eArrow);
        }
    };
    AbstractColumnDropPanel.STATE_NOT_DRAGGING = 'notDragging';
    AbstractColumnDropPanel.STATE_NEW_COLUMNS_IN = 'newColumnsIn';
    AbstractColumnDropPanel.STATE_REARRANGE_COLUMNS = 'rearrangeColumns';
    AbstractColumnDropPanel.CHAR_LEFT_ARROW = '&#8592;';
    AbstractColumnDropPanel.CHAR_RIGHT_ARROW = '&#8594;';
    return AbstractColumnDropPanel;
}(main_1.Component));
exports.AbstractColumnDropPanel = AbstractColumnDropPanel;


/***/ }),

/***/ "HF1M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var ToolPanelGroupComp = (function (_super) {
    __extends(ToolPanelGroupComp, _super);
    function ToolPanelGroupComp(columnGroup, columnDept, expandedCallback, allowDragging) {
        var _this = _super.call(this) || this;
        _this.expanded = true;
        _this.processingColumnStateChange = false;
        _this.columnGroup = columnGroup;
        _this.columnDept = columnDept;
        _this.expandedCallback = expandedCallback;
        _this.allowDragging = allowDragging;
        return _this;
    }
    ToolPanelGroupComp.prototype.init = function () {
        this.setTemplate(ToolPanelGroupComp.TEMPLATE);
        this.instantiate(this.context);
        var eText = this.queryForHtmlElement('#eText');
        this.displayName = this.columnGroup.getColGroupDef() ? this.columnGroup.getColGroupDef().headerName : null;
        if (main_1.Utils.missing(this.displayName)) {
            this.displayName = '>>';
        }
        eText.innerHTML = this.displayName;
        this.setupExpandContract();
        this.addCssClass('ag-toolpanel-indent-' + this.columnDept);
        this.addDestroyableEventListener(eText, 'click', this.onClick.bind(this));
        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onColumnStateChanged.bind(this));
        this.addDestroyableEventListener(this.cbSelect, main_1.AgCheckbox.EVENT_CHANGED, this.onCheckboxChanged.bind(this));
        var eCheckboxAndText = this.queryForHtmlElement('#eCheckboxAndText');
        var touchListener = new main_1.TouchListener(eCheckboxAndText, true);
        this.addDestroyableEventListener(touchListener, main_1.TouchListener.EVENT_TAP, this.onClick.bind(this));
        this.addDestroyFunc(touchListener.destroy.bind(touchListener));
        this.setOpenClosedIcons();
        if (this.allowDragging) {
            this.addDragSource();
        }
        this.onColumnStateChanged();
        this.addVisibilityListenersToAllChildren();
        main_1.CssClassApplier.addToolPanelClassesFromColDef(this.columnGroup.getColGroupDef(), this.getGui(), this.gridOptionsWrapper, null, this.columnGroup);
    };
    ToolPanelGroupComp.prototype.addVisibilityListenersToAllChildren = function () {
        var _this = this;
        this.columnGroup.getLeafColumns().forEach(function (column) {
            _this.addDestroyableEventListener(column, main_1.Column.EVENT_VISIBLE_CHANGED, _this.onColumnStateChanged.bind(_this));
            _this.addDestroyableEventListener(column, main_1.Column.EVENT_VALUE_CHANGED, _this.onColumnStateChanged.bind(_this));
            _this.addDestroyableEventListener(column, main_1.Column.EVENT_PIVOT_CHANGED, _this.onColumnStateChanged.bind(_this));
            _this.addDestroyableEventListener(column, main_1.Column.EVENT_ROW_GROUP_CHANGED, _this.onColumnStateChanged.bind(_this));
        });
    };
    ToolPanelGroupComp.prototype.addDragSource = function () {
        var _this = this;
        var dragSource = {
            type: main_1.DragSourceType.ToolPanel,
            eElement: this.getGui(),
            dragItemName: this.displayName,
            dragItemCallback: function () { return _this.createDragItem(); }
        };
        this.dragAndDropService.addDragSource(dragSource, true);
        this.addDestroyFunc(function () { return _this.dragAndDropService.removeDragSource(dragSource); });
    };
    ToolPanelGroupComp.prototype.createDragItem = function () {
        var visibleState = {};
        this.columnGroup.getLeafColumns().forEach(function (col) {
            visibleState[col.getId()] = col.isVisible();
        });
        return {
            columns: this.columnGroup.getLeafColumns(),
            visibleState: visibleState
        };
    };
    ToolPanelGroupComp.prototype.setupExpandContract = function () {
        this.eGroupClosedIcon = this.queryForHtmlElement('#eGroupClosedIcon');
        this.eGroupOpenedIcon = this.queryForHtmlElement('#eGroupOpenedIcon');
        this.eGroupClosedIcon.appendChild(main_1.Utils.createIcon('columnSelectClosed', this.gridOptionsWrapper, null));
        this.eGroupOpenedIcon.appendChild(main_1.Utils.createIcon('columnSelectOpen', this.gridOptionsWrapper, null));
        this.addDestroyableEventListener(this.eGroupClosedIcon, 'click', this.onExpandOrContractClicked.bind(this));
        this.addDestroyableEventListener(this.eGroupOpenedIcon, 'click', this.onExpandOrContractClicked.bind(this));
        var eColumnGroupIcons = this.queryForHtmlElement('#eColumnGroupIcons');
        var touchListener = new main_1.TouchListener(eColumnGroupIcons, true);
        this.addDestroyableEventListener(touchListener, main_1.TouchListener.EVENT_TAP, this.onExpandOrContractClicked.bind(this));
        this.addDestroyFunc(touchListener.destroy.bind(touchListener));
    };
    ToolPanelGroupComp.prototype.onClick = function () {
        if (!this.cbSelect.isReadOnly()) {
            this.cbSelect.setSelected(!this.cbSelect.isSelected());
        }
    };
    ToolPanelGroupComp.prototype.onCheckboxChanged = function () {
        if (this.processingColumnStateChange) {
            return;
        }
        var childColumns = this.columnGroup.getLeafColumns();
        var selected = this.cbSelect.isSelected();
        if (this.columnController.isPivotMode()) {
            if (selected) {
                this.actionCheckedReduce(childColumns);
            }
            else {
                this.actionUnCheckedReduce(childColumns);
            }
        }
        else {
            var allowedColumns = childColumns.filter(function (c) { return !c.isLockVisible(); });
            this.columnController.setColumnsVisible(allowedColumns, selected, "toolPanelUi");
        }
    };
    ToolPanelGroupComp.prototype.actionUnCheckedReduce = function (columns) {
        var columnsToUnPivot = [];
        var columnsToUnValue = [];
        var columnsToUnGroup = [];
        columns.forEach(function (column) {
            if (column.isPivotActive()) {
                columnsToUnPivot.push(column);
            }
            if (column.isRowGroupActive()) {
                columnsToUnGroup.push(column);
            }
            if (column.isValueActive()) {
                columnsToUnValue.push(column);
            }
        });
        if (columnsToUnPivot.length > 0) {
            this.columnController.removePivotColumns(columnsToUnPivot, "toolPanelUi");
        }
        if (columnsToUnGroup.length > 0) {
            this.columnController.removeRowGroupColumns(columnsToUnGroup, "toolPanelUi");
        }
        if (columnsToUnValue.length > 0) {
            this.columnController.removeValueColumns(columnsToUnValue, "toolPanelUi");
        }
    };
    ToolPanelGroupComp.prototype.actionCheckedReduce = function (columns) {
        var columnsToAggregate = [];
        var columnsToGroup = [];
        var columnsToPivot = [];
        columns.forEach(function (column) {
            // don't change any column that's already got a function active
            if (column.isAnyFunctionActive()) {
                return;
            }
            if (column.isAllowValue()) {
                columnsToAggregate.push(column);
            }
            else if (column.isAllowRowGroup()) {
                columnsToGroup.push(column);
            }
            else if (column.isAllowRowGroup()) {
                columnsToPivot.push(column);
            }
        });
        if (columnsToAggregate.length > 0) {
            this.columnController.addValueColumns(columnsToAggregate, "toolPanelUi");
        }
        if (columnsToGroup.length > 0) {
            this.columnController.addRowGroupColumns(columnsToGroup, "toolPanelUi");
        }
        if (columnsToPivot.length > 0) {
            this.columnController.addPivotColumns(columnsToPivot, "toolPanelUi");
        }
    };
    ToolPanelGroupComp.prototype.onColumnStateChanged = function () {
        var selectedValue = this.workOutSelectedValue();
        var readOnlyValue = this.workOutReadOnlyValue();
        this.processingColumnStateChange = true;
        this.cbSelect.setSelected(selectedValue);
        this.cbSelect.setReadOnly(readOnlyValue);
        this.processingColumnStateChange = false;
    };
    ToolPanelGroupComp.prototype.workOutReadOnlyValue = function () {
        var pivotMode = this.columnController.isPivotMode();
        var colsThatCanAction = 0;
        this.columnGroup.getLeafColumns().forEach(function (col) {
            if (pivotMode) {
                if (col.isAnyFunctionAllowed()) {
                    colsThatCanAction++;
                }
            }
            else {
                if (!col.isLockVisible()) {
                    colsThatCanAction++;
                }
            }
        });
        return colsThatCanAction === 0;
    };
    ToolPanelGroupComp.prototype.workOutSelectedValue = function () {
        var _this = this;
        var pivotMode = this.columnController.isPivotMode();
        var visibleChildCount = 0;
        var hiddenChildCount = 0;
        this.columnGroup.getLeafColumns().forEach(function (column) {
            if (_this.isColumnVisible(column, pivotMode)) {
                visibleChildCount++;
            }
            else {
                hiddenChildCount++;
            }
        });
        var selectedValue;
        if (visibleChildCount > 0 && hiddenChildCount > 0) {
            selectedValue = null;
        }
        else if (visibleChildCount > 0) {
            selectedValue = true;
        }
        else {
            selectedValue = false;
        }
        return selectedValue;
    };
    ToolPanelGroupComp.prototype.isColumnVisible = function (column, pivotMode) {
        if (pivotMode) {
            var pivoted = column.isPivotActive();
            var grouped = column.isRowGroupActive();
            var aggregated = column.isValueActive();
            return pivoted || grouped || aggregated;
        }
        else {
            return column.isVisible();
        }
    };
    ToolPanelGroupComp.prototype.onExpandOrContractClicked = function () {
        this.expanded = !this.expanded;
        this.setOpenClosedIcons();
        this.expandedCallback();
    };
    ToolPanelGroupComp.prototype.setOpenClosedIcons = function () {
        var folderOpen = this.expanded;
        main_1.Utils.setVisible(this.eGroupClosedIcon, !folderOpen);
        main_1.Utils.setVisible(this.eGroupOpenedIcon, folderOpen);
    };
    ToolPanelGroupComp.prototype.isExpanded = function () {
        return this.expanded;
    };
    ToolPanelGroupComp.TEMPLATE = '<div class="ag-column-select-column-group">' +
        '  <span id="eColumnGroupIcons" class="ag-column-group-icons">' +
        '    <span id="eGroupOpenedIcon" class="ag-column-group-closed-icon"></span>' +
        '    <span id="eGroupClosedIcon" class="ag-column-group-opened-icon"></span>' +
        '  </span>' +
        '  <span id="eCheckboxAndText">' +
        '    <ag-checkbox class="ag-column-select-checkbox"></ag-checkbox>' +
        '    <span id="eText" class="ag-column-select-column-group-label"></span>' +
        '  </span>' +
        '</div>';
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], ToolPanelGroupComp.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        main_1.Autowired('columnController'),
        __metadata("design:type", main_1.ColumnController)
    ], ToolPanelGroupComp.prototype, "columnController", void 0);
    __decorate([
        main_1.Autowired('gridPanel'),
        __metadata("design:type", main_1.GridPanel)
    ], ToolPanelGroupComp.prototype, "gridPanel", void 0);
    __decorate([
        main_1.Autowired('context'),
        __metadata("design:type", main_1.Context)
    ], ToolPanelGroupComp.prototype, "context", void 0);
    __decorate([
        main_1.Autowired('dragAndDropService'),
        __metadata("design:type", main_1.DragAndDropService)
    ], ToolPanelGroupComp.prototype, "dragAndDropService", void 0);
    __decorate([
        main_1.Autowired('eventService'),
        __metadata("design:type", main_1.EventService)
    ], ToolPanelGroupComp.prototype, "eventService", void 0);
    __decorate([
        main_1.QuerySelector('.ag-column-select-checkbox'),
        __metadata("design:type", main_1.AgCheckbox)
    ], ToolPanelGroupComp.prototype, "cbSelect", void 0);
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ToolPanelGroupComp.prototype, "init", null);
    return ToolPanelGroupComp;
}(main_1.Component));
exports.ToolPanelGroupComp = ToolPanelGroupComp;


/***/ }),

/***/ "HPXr":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1560);
	module.exports = __webpack_require__(1560);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1560:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1561)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($, undefined) {
	    
	kendo.PDFMixin = {
	    extend: function(proto) {
	        proto.events.push("pdfExport");
	        proto.options.pdf = this.options;
	        proto.saveAsPDF = this.saveAsPDF;
	        proto._drawPDF = this._drawPDF;
	        proto._drawPDFShadow = this._drawPDFShadow;
	    },
	    options: {
	        fileName  : "Export.pdf",
	        proxyURL  : "",

	        // paperSize can be an usual name, i.e. "A4", or an array of two Number-s specifying the
	        // width/height in points (1pt = 1/72in), or strings including unit, i.e. "10mm".  Supported
	        // units are "mm", "cm", "in" and "pt".  The default "auto" means paper size is determined
	        // by content.
	        paperSize : "auto",

	        // Export all pages, if applicable
	        allPages: false,

	        // True to reverse the paper dimensions if needed such that width is the larger edge.
	        landscape : false,

	        // An object containing { left, top, bottom, right } margins with units.
	        margin    : null,

	        // Optional information for the PDF Info dictionary; all strings except for the date.
	        title     : null,
	        author    : null,
	        subject   : null,
	        keywords  : null,
	        creator   : "Kendo UI PDF Generator v." + kendo.version,

	        // Creation Date; defaults to new Date()
	        date      : null
	    },

	    saveAsPDF: function() {
	        var progress = new $.Deferred();
	        var promise = progress.promise();
	        var args = { promise: promise };

	        if (this.trigger("pdfExport", args)) {
	            return;
	        }

	        var options = this.options.pdf;
	        options.multiPage = options.multiPage || options.allPages;

	        this._drawPDF(progress)
	        .then(function(root) {
	            return kendo.drawing.exportPDF(root, options);
	        })
	        .done(function(dataURI) {
	            kendo.saveAs({
	                dataURI: dataURI,
	                fileName: options.fileName,
	                proxyURL: options.proxyURL,
	                forceProxy: options.forceProxy,
	                proxyTarget: options.proxyTarget
	            });

	            progress.resolve();
	        })
	        .fail(function(err) {
	            progress.reject(err);
	        });

	        return promise;
	    },

	    _drawPDF: function(progress) {
	        var promise = new $.Deferred();

	        kendo.drawing.drawDOM(this.wrapper)
	        .done(function(group) {
	            var args = {
	                page: group,
	                pageNumber: 1,
	                progress: 1,
	                totalPages: 1
	            };

	            progress.notify(args);
	            promise.resolve(args.page);
	        })
	        .fail(function(err) {
	            promise.reject(err);
	        });

	        return promise;
	    },

	    _drawPDFShadow: function(settings, drawOptions) {
	        settings = settings || {};
	        var wrapper = this.wrapper;
	        var shadow = $("<div class='k-pdf-export-shadow'>");

	        // Content will be allowed to take up to 200" if no width is given.
	        if (settings.width) {
	            shadow.css({
	                width: settings.width,
	                overflow: "visible"
	            });
	        }

	        wrapper.before(shadow);
	        shadow.append(settings.content || wrapper.clone(true, true));

	        var defer = $.Deferred();

	        /* https://github.com/telerik/kendo/issues/4790 -- We need to
	         * allow a small timeout so that the browser finalizes the
	         * layout of any images here.  Another option would be to pass
	         * forcePageBreak: "-" to drawDOM, but that would make it
	         * clone the content as well and look for page breaks;
	         * needless work, so better do it here.
	         */
	        setTimeout(function(){
	            var promise = kendo.drawing.drawDOM(shadow, drawOptions);
	            promise.always(function() {
	                shadow.remove();
	            }).then(function(){
	                defer.resolve.apply(defer, arguments);
	            }).fail(function(){
	                defer.reject.apply(defer, arguments);
	            }).progress(function(){
	                defer.progress.apply(defer, arguments);
	            });
	        }, 15);

	        return defer.promise();
	    }
	};

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ }),

/***/ 1561:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("5dnc");

/***/ })

/******/ });

/***/ }),

/***/ "HQQe":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1424);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1424:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "switch",
	    name: "Switch",
	    category: "web",
	    description: "The Switch widget is used to display two exclusive choices.",
	    depends: [ "core" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        NS = ".kendoSwitch",
	        Widget = ui.Widget,
	        support = kendo.support,
	        CHANGE = "change",
	        switchStyles = {
	            widget: "k-switch k-widget",
	            container: "k-switch-container",
	            handle: "k-switch-handle",
	            checked: "k-switch-on",
	            checkedLabel: "k-switch-label-on",
	            unchecked: "k-switch-off",
	            uncheckedLabel: "k-switch-label-off",
	            disabled: "k-state-disabled",
	            readonly: "k-state-readonly",
	            active: "k-state-active"
	        },
	        DISABLED = "disabled",
	        ARIA_DISABLED = "aria-disabled",
	        READONLY = "readonly",
	        ARIA_READONLY = "aria-readonly",
	        ARIA_CHECKED = "aria-checked",
	        CHECKED = "checked",
	        CLICK = support.click + NS,
	        TOUCHEND = support.pointers ? "pointerup" : "touchend",
	        KEYDOWN = "keydown" + NS,
	        LABELIDPART = "_label",
	        proxy = $.proxy;

	    var SWITCH_TEMPLATE = kendo.template('<span class="#=styles.widget#" role="switch"></span>');

	    var SWITCH_CONTAINER_TEMPLATE = kendo.template("<span class='#=styles.container#'>" +
	        "<span class='#=styles.checkedLabel#'>#=checked#</span>" +
	        "<span class='#=styles.uncheckedLabel#'>#=unchecked#</span>" +
	        "<span class='#=styles.handle#'></span>" +
	        "</span>");

	    var Switch = Widget.extend({
	        init: function(element, options) {
	            var that = this,
	                wrapper;

	            Widget.fn.init.call(that, element, options);

	            options = that.options;
	            element = that.element[0];
	            element.type = "checkbox";

	            wrapper = $(SWITCH_TEMPLATE({
	                styles: switchStyles
	            }));

	            that.wrapper = that.element.wrap(wrapper).parent();

	            that.wrapper
	                    .append($(SWITCH_CONTAINER_TEMPLATE({
	                        styles: switchStyles,
	                        checked: options.messages.checked,
	                        unchecked: options.messages.unchecked
	                    })))
	                    .addClass(element.className).removeClass('input-validation-error');

	            that.wrapper
	                    .on(CLICK, proxy(that._click, that))
	                    .on(TOUCHEND, proxy(that._touchEnd, that))
	                    .on(KEYDOWN, proxy(that._keydown, that));

	            if (that.options.enabled) {
	                that._tabindex();
	            }

	            that._initSettings();

	            that._aria();

	            kendo.notify(that, kendo.ui);
	        },

	        setOptions: function (options) {
	            var that = this,
	                messages = options.messages,
	                checkedLabel,
	                uncheckedLabel;

	            that.options = $.extend(that.options, options);

	            if (messages && messages.checked !== undefined) {
	                checkedLabel = that.wrapper.find("." + switchStyles.checkedLabel);
	                checkedLabel.text(messages.checked);
	            }

	            if (messages && messages.unchecked !== undefined) {
	                uncheckedLabel = that.wrapper.find("." + switchStyles.uncheckedLabel);
	                uncheckedLabel.text(messages.unchecked);
	            }

	            if (options.width) {
	                that.wrapper.css({
	                    width: options.width
	                });
	            }

	            if (options.enabled !== undefined) {
	                that.enable(options.enabled);
	            }

	            if (options.readonly !== undefined) {
	                that.readonly(options.readonly);
	            }

	            that.check(options.checked);
	        },

	        _initSettings: function () {
	            var that = this,
	                element = that.element[0],
	                options = that.options;

	            if (options.width) {
	                that.wrapper.css({
	                    width: options.width
	                });
	            }

	            if (options.checked === null) {
	                options.checked = element.checked;
	            }

	            that.check(options.checked);

	            options.enabled = options.enabled && !that.element.attr(DISABLED);
	            that.enable(options.enabled);

	            options.readonly = options.readonly || !!that.element.attr(READONLY);
	            that.readonly(options.readonly);
	        },

	        _aria: function () {
	            var that = this,
	                element = that.element,
	                wrapper = that.wrapper,
	                id = element.attr("id"),
	                labelFor = $("label[for=\"" + id  + "\"]"),
	                ariaLabel = element.attr("aria-label"),
	                ariaLabelledBy = element.attr("aria-labelledby");

	            if (ariaLabel) {
	                wrapper.attr("aria-label", ariaLabel);
	            } else if (ariaLabelledBy){
	                wrapper.attr("aria-labelledby", ariaLabelledBy);
	            } else if (labelFor.length){
	                var labelId = labelFor.attr("id");

	                if (!labelId) {
	                    labelId = (id || kendo.guid()) + LABELIDPART;
	                    labelFor.attr("id", labelId);
	                }

	                wrapper.attr("aria-labelledby", labelId);
	            }
	        },

	        events: [
	            CHANGE
	        ],

	        options: {
	            name: "Switch",
	            messages: {
	                checked: "On",
	                unchecked: "Off"
	            },
	            width: null,
	            checked: null,
	            enabled: true,
	            readonly: false
	        },

	        check: function(checked) {
	            var that = this,
	                element = that.element[0];

	            if (checked === undefined) {
	                return element.checked;
	            }

	            if (element.checked !== checked) {
	                that.options.checked = element.checked = checked;
	            }

	            that.wrapper
	                    .attr(ARIA_CHECKED, checked)
	                    .toggleClass(switchStyles.checked, checked)
	                    .toggleClass(switchStyles.unchecked, !checked);

	            if (checked) {
	                that.element
	                        .attr(CHECKED, CHECKED);
	            } else {
	                that.element
	                        .removeAttr(CHECKED);
	            }
	        },

	        // alias for check, NG support
	        value: function(value) {
	            if (typeof value === "string") {
	            value = (value === "true");
	            }
	            return this.check.apply(this, [value]);
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            this.wrapper.off(NS);
	        },

	        toggle: function() {
	            var that = this;

	            that.check(!that.element[0].checked);
	        },

	        enable: function(enable) {
	            var element = this.element,
	                wrapper = this.wrapper;

	            if(typeof enable == "undefined") {
	                enable = true;
	            }

	            this.options.enabled = enable;

	            if(enable) {
	                element.removeAttr(DISABLED);
	                wrapper.removeAttr(ARIA_DISABLED);
	            } else {
	                element.attr(DISABLED, DISABLED);
	                wrapper.attr(ARIA_DISABLED, true);
	            }

	            wrapper.toggleClass(switchStyles.disabled, !enable);
	        },

	        readonly: function(readonly) {
	            var that = this,
	                element = that.element,
	                wrapper = that.wrapper;

	            if(typeof readonly == "undefined") {
	                readonly = true;
	            }

	            that.options.readonly = readonly;

	            if(readonly) {
	                element.attr(READONLY, true);
	                wrapper.attr(ARIA_READONLY, true);
	            } else {
	                element.removeAttr(READONLY);
	                wrapper.removeAttr(ARIA_READONLY);
	            }

	            wrapper.toggleClass(switchStyles.readonly, readonly);
	        },

	        _check: function () {
	            var that = this,
	                checked = that.element[0].checked = !that.element[0].checked;

	            that.wrapper.focus();

	            if (!that.options.enabled || that.options.readonly ||
	                that.trigger(CHANGE, { checked: checked })) {
	                that.element[0].checked = !checked;
	                return;
	            }

	            that.check(checked);
	        },

	        _keydown: function (e) {
	            if (e.keyCode === kendo.keys.SPACEBAR) {
	                this._check();
	                e.preventDefault();
	            }
	        },

	        _isTouch: function(event) {
	            return /touch/.test(event.type) || (event.originalEvent && /touch/.test(event.originalEvent.pointerType));
	        },

	        _click: function (e) {
	            if (!this._isTouch(e) && e.which === 1) {
	                this._check();
	            }
	        },

	        _touchEnd: function (e) {
	            if (this._isTouch(e)) {
	                this._check();
	                e.preventDefault();
	            }
	        }

	    });

	    ui.plugin(Switch);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "Hehg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var columnSelectComp_1 = __webpack_require__("LE8v");
var rowGroupColumnsPanel_1 = __webpack_require__("Ygk/");
var pivotColumnsPanel_1 = __webpack_require__("dbIj");
var pivotModePanel_1 = __webpack_require__("xchs");
var valueColumnsPanel_1 = __webpack_require__("K4Qs");
var ag_grid_1 = __webpack_require__("F6Mk");
var ToolPanelComp = (function (_super) {
    __extends(ToolPanelComp, _super);
    function ToolPanelComp() {
        var _this = _super.call(this, ToolPanelComp_1.TEMPLATE) || this;
        _this.initialised = false;
        _this.childDestroyFuncs = [];
        return _this;
    }
    ToolPanelComp_1 = ToolPanelComp;
    // lazy initialise the toolPanel
    ToolPanelComp.prototype.setVisible = function (visible) {
        _super.prototype.setVisible.call(this, visible);
        if (visible && !this.initialised) {
            this.init();
        }
    };
    ToolPanelComp.prototype.init = function () {
        if (!this.gridOptionsWrapper.isToolPanelSuppressPivotMode()) {
            this.addComponent(new pivotModePanel_1.PivotModePanel());
        }
        this.addComponent(new columnSelectComp_1.ColumnSelectComp(true));
        if (!this.gridOptionsWrapper.isToolPanelSuppressRowGroups()) {
            this.addComponent(new rowGroupColumnsPanel_1.RowGroupColumnsPanel(false));
        }
        if (!this.gridOptionsWrapper.isToolPanelSuppressValues()) {
            this.addComponent(new valueColumnsPanel_1.ValuesColumnPanel(false));
        }
        if (!this.gridOptionsWrapper.isToolPanelSuppressPivots()) {
            this.addComponent(new pivotColumnsPanel_1.PivotColumnsPanel(false));
        }
        this.initialised = true;
    };
    ToolPanelComp.prototype.addComponent = function (component) {
        this.context.wireBean(component);
        this.getGui().appendChild(component.getGui());
        this.childDestroyFuncs.push(component.destroy.bind(component));
    };
    ToolPanelComp.prototype.destroyChildren = function () {
        this.childDestroyFuncs.forEach(function (func) { return func(); });
        this.childDestroyFuncs.length = 0;
        ag_grid_1._.removeAllChildren(this.getGui());
    };
    ToolPanelComp.prototype.refresh = function () {
        this.destroyChildren();
        this.init();
    };
    ToolPanelComp.prototype.destroy = function () {
        this.destroyChildren();
        _super.prototype.destroy.call(this);
    };
    ToolPanelComp.TEMPLATE = '<div class="ag-tool-panel"></div>';
    __decorate([
        main_1.Autowired('context'),
        __metadata("design:type", main_1.Context)
    ], ToolPanelComp.prototype, "context", void 0);
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], ToolPanelComp.prototype, "gridOptionsWrapper", void 0);
    ToolPanelComp = ToolPanelComp_1 = __decorate([
        main_1.Bean('toolPanel'),
        __metadata("design:paramtypes", [])
    ], ToolPanelComp);
    return ToolPanelComp;
    var ToolPanelComp_1;
}(main_1.Component));
exports.ToolPanelComp = ToolPanelComp;


/***/ }),

/***/ "HgYs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {/* unused harmony export SnotifyPosition */
/* unused harmony export SnotifyStyle */
/* unused harmony export SnotifyToast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/**
 * vue-snotify v3.0.4
 * (c) 2017 artemsky <mr.artemsky@gmail.com>
 * @license MIT
 */


/**
 * Toast position
 */
var SnotifyPosition;
(function (SnotifyPosition) {
    SnotifyPosition["leftTop"] = "leftTop";
    SnotifyPosition["leftCenter"] = "leftCenter";
    SnotifyPosition["leftBottom"] = "leftBottom";
    SnotifyPosition["rightTop"] = "rightTop";
    SnotifyPosition["rightCenter"] = "rightCenter";
    SnotifyPosition["rightBottom"] = "rightBottom";
    SnotifyPosition["centerTop"] = "centerTop";
    SnotifyPosition["centerCenter"] = "centerCenter";
    SnotifyPosition["centerBottom"] = "centerBottom";
})(SnotifyPosition || (SnotifyPosition = {}));

/**
 * Toast style.
 */
var SnotifyStyle = {
    simple: 'simple',
    success: 'success',
    error: 'error',
    warning: 'warning',
    info: 'info',
    async: 'async',
    confirm: 'confirm',
    prompt: 'prompt'
};

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};



function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var vueClassComponent_common = createCommonjsModule(function (module, exports) {
/**
  * vue-class-component v6.1.1
  * (c) 2015-2017 Evan You
  * @license MIT
  */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue$$1 = _interopDefault(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]);

var hasProto = { __proto__: [] } instanceof Array;
function createDecorator(factory) {
    return function (target, key, index) {
        var Ctor = typeof target === 'function'
            ? target
            : target.constructor;
        if (!Ctor.__decorators__) {
            Ctor.__decorators__ = [];
        }
        if (typeof index !== 'number') {
            index = undefined;
        }
        Ctor.__decorators__.push(function (options) { return factory(options, key, index); });
    };
}
function isPrimitive(value) {
    var type = typeof value;
    return value == null || (type !== "object" && type !== "function");
}
function warn(message) {
    if (typeof console !== 'undefined') {
        console.warn('[vue-class-component] ' + message);
    }
}

function collectDataFromConstructor(vm, Component) {
    Component.prototype._init = function () {
        var _this = this;
        var keys = Object.getOwnPropertyNames(vm);
        if (vm.$options.props) {
            for (var key in vm.$options.props) {
                if (!vm.hasOwnProperty(key)) {
                    keys.push(key);
                }
            }
        }
        keys.forEach(function (key) {
            if (key.charAt(0) !== '_') {
                Object.defineProperty(_this, key, {
                    get: function () { return vm[key]; },
                    set: function (value) { return vm[key] = value; },
                    configurable: true
                });
            }
        });
    };
    var data = new Component();
    var plainData = {};
    Object.keys(data).forEach(function (key) {
        if (data[key] !== undefined) {
            plainData[key] = data[key];
        }
    });
    return plainData;
}

var $internalHooks = [
    'data',
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeDestroy',
    'destroyed',
    'beforeUpdate',
    'updated',
    'activated',
    'deactivated',
    'render',
    'errorCaptured'
];
function componentFactory(Component, options) {
    if (options === void 0) { options = {}; }
    options.name = options.name || Component._componentTag || Component.name;
    var proto = Component.prototype;
    Object.getOwnPropertyNames(proto).forEach(function (key) {
        if (key === 'constructor') {
            return;
        }
        if ($internalHooks.indexOf(key) > -1) {
            options[key] = proto[key];
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(proto, key);
        if (typeof descriptor.value === 'function') {
            (options.methods || (options.methods = {}))[key] = descriptor.value;
        }
        else if (descriptor.get || descriptor.set) {
            (options.computed || (options.computed = {}))[key] = {
                get: descriptor.get,
                set: descriptor.set
            };
        }
    });
    (options.mixins || (options.mixins = [])).push({
        data: function () {
            return collectDataFromConstructor(this, Component);
        }
    });
    var decorators = Component.__decorators__;
    if (decorators) {
        decorators.forEach(function (fn) { return fn(options); });
        delete Component.__decorators__;
    }
    var superProto = Object.getPrototypeOf(Component.prototype);
    var Super = superProto instanceof Vue$$1
        ? superProto.constructor
        : Vue$$1;
    var Extended = Super.extend(options);
    forwardStaticMembers(Extended, Component, Super);
    return Extended;
}
var reservedPropertyNames = [
    'cid',
    'super',
    'options',
    'superOptions',
    'extendOptions',
    'sealedOptions',
    'component',
    'directive',
    'filter'
];
function forwardStaticMembers(Extended, Original, Super) {
    Object.getOwnPropertyNames(Original).forEach(function (key) {
        if (key === 'prototype') {
            return;
        }
        var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);
        if (extendedDescriptor && !extendedDescriptor.configurable) {
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(Original, key);
        if (!hasProto) {
            if (key === 'cid') {
                return;
            }
            var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);
            if (!isPrimitive(descriptor.value)
                && superDescriptor
                && superDescriptor.value === descriptor.value) {
                return;
            }
        }
        if (false) {
            warn("Static property name '" + key + "' declared on class '" + Original.name + "' " +
                'conflicts with reserved property name of Vue internal. ' +
                'It may cause unexpected behavior of the component. Consider renaming the property.');
        }
        Object.defineProperty(Extended, key, descriptor);
    });
}

function Component(options) {
    if (typeof options === 'function') {
        return componentFactory(options);
    }
    return function (Component) {
        return componentFactory(Component, options);
    };
}
(function (Component) {
    function registerHooks(keys) {
        $internalHooks.push.apply($internalHooks, keys);
    }
    Component.registerHooks = registerHooks;
})(Component || (Component = {}));
var Component$1 = Component;

exports['default'] = Component$1;
exports.createDecorator = createDecorator;
});

unwrapExports(vueClassComponent_common);

/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var Reflect$1;
(function (Reflect) {
    "use strict";
    var hasOwn = Object.prototype.hasOwnProperty;
    // feature test for Symbol support
    var supportsSymbol = typeof Symbol === "function";
    var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
    var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
    var HashMap;
    (function (HashMap) {
        var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support
        var supportsProto = { __proto__: [] } instanceof Array; // feature test for __proto__ support
        var downLevel = !supportsCreate && !supportsProto;
        // create an object in dictionary mode (a.k.a. "slow" mode in v8)
        HashMap.create = supportsCreate
            ? function () { return MakeDictionary(Object.create(null)); }
            : supportsProto
                ? function () { return MakeDictionary({ __proto__: null }); }
                : function () { return MakeDictionary({}); };
        HashMap.has = downLevel
            ? function (map, key) { return hasOwn.call(map, key); }
            : function (map, key) { return key in map; };
        HashMap.get = downLevel
            ? function (map, key) { return hasOwn.call(map, key) ? map[key] : undefined; }
            : function (map, key) { return map[key]; };
    })(HashMap || (HashMap = {}));
    // Load global or shim versions of Map, Set, and WeakMap
    var functionPrototype = Object.getPrototypeOf(Function);
    var usePolyfill = typeof process === "object" && Object({"NODE_ENV":"production"}) && Object({"NODE_ENV":"production"})["REFLECT_METADATA_USE_MAP_POLYFILL"] === "true";
    var _Map = !usePolyfill && typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
    var _Set = !usePolyfill && typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
    var _WeakMap = !usePolyfill && typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
    // [[Metadata]] internal slot
    // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
    var Metadata = new _WeakMap();
    /**
      * Applies a set of decorators to a property of a target object.
      * @param decorators An array of decorators.
      * @param target The target object.
      * @param propertyKey (Optional) The property key to decorate.
      * @param attributes (Optional) The property descriptor for the target key.
      * @remarks Decorators are applied in reverse order.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     Example = Reflect.decorate(decoratorsArray, Example);
      *
      *     // property (on constructor)
      *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
      *
      *     // property (on prototype)
      *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
      *
      *     // method (on constructor)
      *     Object.defineProperty(Example, "staticMethod",
      *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
      *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
      *
      *     // method (on prototype)
      *     Object.defineProperty(Example.prototype, "method",
      *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
      *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
      *
      */
    function decorate(decorators, target, propertyKey, attributes) {
        if (!IsUndefined(propertyKey)) {
            if (!IsArray(decorators))
                throw new TypeError();
            if (!IsObject(target))
                throw new TypeError();
            if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes))
                throw new TypeError();
            if (IsNull(attributes))
                attributes = undefined;
            propertyKey = ToPropertyKey(propertyKey);
            return DecorateProperty(decorators, target, propertyKey, attributes);
        }
        else {
            if (!IsArray(decorators))
                throw new TypeError();
            if (!IsConstructor(target))
                throw new TypeError();
            return DecorateConstructor(decorators, target);
        }
    }
    Reflect.decorate = decorate;
    // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
    // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
    /**
      * A default metadata decorator factory that can be used on a class, class member, or parameter.
      * @param metadataKey The key for the metadata entry.
      * @param metadataValue The value for the metadata entry.
      * @returns A decorator function.
      * @remarks
      * If `metadataKey` is already defined for the target and target key, the
      * metadataValue for that key will be overwritten.
      * @example
      *
      *     // constructor
      *     @Reflect.metadata(key, value)
      *     class Example {
      *     }
      *
      *     // property (on constructor, TypeScript only)
      *     class Example {
      *         @Reflect.metadata(key, value)
      *         static staticProperty;
      *     }
      *
      *     // property (on prototype, TypeScript only)
      *     class Example {
      *         @Reflect.metadata(key, value)
      *         property;
      *     }
      *
      *     // method (on constructor)
      *     class Example {
      *         @Reflect.metadata(key, value)
      *         static staticMethod() { }
      *     }
      *
      *     // method (on prototype)
      *     class Example {
      *         @Reflect.metadata(key, value)
      *         method() { }
      *     }
      *
      */
    function metadata(metadataKey, metadataValue) {
        function decorator(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey))
                throw new TypeError();
            OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
        }
        return decorator;
    }
    Reflect.metadata = metadata;
    /**
      * Define a unique metadata entry on the target.
      * @param metadataKey A key used to store and retrieve metadata.
      * @param metadataValue A value that contains attached metadata.
      * @param target The target object on which to define metadata.
      * @param propertyKey (Optional) The property key for the target.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     Reflect.defineMetadata("custom:annotation", options, Example);
      *
      *     // property (on constructor)
      *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
      *
      *     // property (on prototype)
      *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
      *
      *     // method (on constructor)
      *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
      *
      *     // method (on prototype)
      *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
      *
      *     // decorator factory as metadata-producing annotation.
      *     function MyAnnotation(options): Decorator {
      *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
      *     }
      *
      */
    function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(propertyKey))
            propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
    }
    Reflect.defineMetadata = defineMetadata;
    /**
      * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
      * @param metadataKey A key used to store and retrieve metadata.
      * @param target The target object on which the metadata is defined.
      * @param propertyKey (Optional) The property key for the target.
      * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.hasMetadata("custom:annotation", Example);
      *
      *     // property (on constructor)
      *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
      *
      */
    function hasMetadata(metadataKey, target, propertyKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(propertyKey))
            propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryHasMetadata(metadataKey, target, propertyKey);
    }
    Reflect.hasMetadata = hasMetadata;
    /**
      * Gets a value indicating whether the target object has the provided metadata key defined.
      * @param metadataKey A key used to store and retrieve metadata.
      * @param target The target object on which the metadata is defined.
      * @param propertyKey (Optional) The property key for the target.
      * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
      *
      *     // property (on constructor)
      *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
      *
      */
    function hasOwnMetadata(metadataKey, target, propertyKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(propertyKey))
            propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
    }
    Reflect.hasOwnMetadata = hasOwnMetadata;
    /**
      * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
      * @param metadataKey A key used to store and retrieve metadata.
      * @param target The target object on which the metadata is defined.
      * @param propertyKey (Optional) The property key for the target.
      * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.getMetadata("custom:annotation", Example);
      *
      *     // property (on constructor)
      *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
      *
      */
    function getMetadata(metadataKey, target, propertyKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(propertyKey))
            propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryGetMetadata(metadataKey, target, propertyKey);
    }
    Reflect.getMetadata = getMetadata;
    /**
      * Gets the metadata value for the provided metadata key on the target object.
      * @param metadataKey A key used to store and retrieve metadata.
      * @param target The target object on which the metadata is defined.
      * @param propertyKey (Optional) The property key for the target.
      * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.getOwnMetadata("custom:annotation", Example);
      *
      *     // property (on constructor)
      *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
      *
      */
    function getOwnMetadata(metadataKey, target, propertyKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(propertyKey))
            propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
    }
    Reflect.getOwnMetadata = getOwnMetadata;
    /**
      * Gets the metadata keys defined on the target object or its prototype chain.
      * @param target The target object on which the metadata is defined.
      * @param propertyKey (Optional) The property key for the target.
      * @returns An array of unique metadata keys.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.getMetadataKeys(Example);
      *
      *     // property (on constructor)
      *     result = Reflect.getMetadataKeys(Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.getMetadataKeys(Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.getMetadataKeys(Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.getMetadataKeys(Example.prototype, "method");
      *
      */
    function getMetadataKeys(target, propertyKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(propertyKey))
            propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryMetadataKeys(target, propertyKey);
    }
    Reflect.getMetadataKeys = getMetadataKeys;
    /**
      * Gets the unique metadata keys defined on the target object.
      * @param target The target object on which the metadata is defined.
      * @param propertyKey (Optional) The property key for the target.
      * @returns An array of unique metadata keys.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.getOwnMetadataKeys(Example);
      *
      *     // property (on constructor)
      *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
      *
      */
    function getOwnMetadataKeys(target, propertyKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(propertyKey))
            propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryOwnMetadataKeys(target, propertyKey);
    }
    Reflect.getOwnMetadataKeys = getOwnMetadataKeys;
    /**
      * Deletes the metadata entry from the target object with the provided key.
      * @param metadataKey A key used to store and retrieve metadata.
      * @param target The target object on which the metadata is defined.
      * @param propertyKey (Optional) The property key for the target.
      * @returns `true` if the metadata entry was found and deleted; otherwise, false.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.deleteMetadata("custom:annotation", Example);
      *
      *     // property (on constructor)
      *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
      *
      */
    function deleteMetadata(metadataKey, target, propertyKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(propertyKey))
            propertyKey = ToPropertyKey(propertyKey);
        var metadataMap = GetOrCreateMetadataMap(target, propertyKey, /*Create*/ false);
        if (IsUndefined(metadataMap))
            return false;
        if (!metadataMap.delete(metadataKey))
            return false;
        if (metadataMap.size > 0)
            return true;
        var targetMetadata = Metadata.get(target);
        targetMetadata.delete(propertyKey);
        if (targetMetadata.size > 0)
            return true;
        Metadata.delete(target);
        return true;
    }
    Reflect.deleteMetadata = deleteMetadata;
    function DecorateConstructor(decorators, target) {
        for (var i = decorators.length - 1; i >= 0; --i) {
            var decorator = decorators[i];
            var decorated = decorator(target);
            if (!IsUndefined(decorated) && !IsNull(decorated)) {
                if (!IsConstructor(decorated))
                    throw new TypeError();
                target = decorated;
            }
        }
        return target;
    }
    function DecorateProperty(decorators, target, propertyKey, descriptor) {
        for (var i = decorators.length - 1; i >= 0; --i) {
            var decorator = decorators[i];
            var decorated = decorator(target, propertyKey, descriptor);
            if (!IsUndefined(decorated) && !IsNull(decorated)) {
                if (!IsObject(decorated))
                    throw new TypeError();
                descriptor = decorated;
            }
        }
        return descriptor;
    }
    function GetOrCreateMetadataMap(O, P, Create) {
        var targetMetadata = Metadata.get(O);
        if (IsUndefined(targetMetadata)) {
            if (!Create)
                return undefined;
            targetMetadata = new _Map();
            Metadata.set(O, targetMetadata);
        }
        var metadataMap = targetMetadata.get(P);
        if (IsUndefined(metadataMap)) {
            if (!Create)
                return undefined;
            metadataMap = new _Map();
            targetMetadata.set(P, metadataMap);
        }
        return metadataMap;
    }
    // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
    function OrdinaryHasMetadata(MetadataKey, O, P) {
        var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
        if (hasOwn)
            return true;
        var parent = OrdinaryGetPrototypeOf(O);
        if (!IsNull(parent))
            return OrdinaryHasMetadata(MetadataKey, parent, P);
        return false;
    }
    // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
    function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
        var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
        if (IsUndefined(metadataMap))
            return false;
        return ToBoolean(metadataMap.has(MetadataKey));
    }
    // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
    function OrdinaryGetMetadata(MetadataKey, O, P) {
        var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
        if (hasOwn)
            return OrdinaryGetOwnMetadata(MetadataKey, O, P);
        var parent = OrdinaryGetPrototypeOf(O);
        if (!IsNull(parent))
            return OrdinaryGetMetadata(MetadataKey, parent, P);
        return undefined;
    }
    // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
    function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
        var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
        if (IsUndefined(metadataMap))
            return undefined;
        return metadataMap.get(MetadataKey);
    }
    // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
    function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
        var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
        metadataMap.set(MetadataKey, MetadataValue);
    }
    // 3.1.6.1 OrdinaryMetadataKeys(O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
    function OrdinaryMetadataKeys(O, P) {
        var ownKeys = OrdinaryOwnMetadataKeys(O, P);
        var parent = OrdinaryGetPrototypeOf(O);
        if (parent === null)
            return ownKeys;
        var parentKeys = OrdinaryMetadataKeys(parent, P);
        if (parentKeys.length <= 0)
            return ownKeys;
        if (ownKeys.length <= 0)
            return parentKeys;
        var set = new _Set();
        var keys = [];
        for (var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++) {
            var key = ownKeys_1[_i];
            var hasKey = set.has(key);
            if (!hasKey) {
                set.add(key);
                keys.push(key);
            }
        }
        for (var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++) {
            var key = parentKeys_1[_a];
            var hasKey = set.has(key);
            if (!hasKey) {
                set.add(key);
                keys.push(key);
            }
        }
        return keys;
    }
    // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
    function OrdinaryOwnMetadataKeys(O, P) {
        var keys = [];
        var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
        if (IsUndefined(metadataMap))
            return keys;
        var keysObj = metadataMap.keys();
        var iterator = GetIterator(keysObj);
        var k = 0;
        while (true) {
            var next = IteratorStep(iterator);
            if (!next) {
                keys.length = k;
                return keys;
            }
            var nextValue = IteratorValue(next);
            try {
                keys[k] = nextValue;
            }
            catch (e) {
                try {
                    IteratorClose(iterator);
                }
                finally {
                    throw e;
                }
            }
            k++;
        }
    }
    // 6 ECMAScript Data Typ0es and Values
    // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
    function Type(x) {
        if (x === null)
            return 1 /* Null */;
        switch (typeof x) {
            case "undefined": return 0 /* Undefined */;
            case "boolean": return 2 /* Boolean */;
            case "string": return 3 /* String */;
            case "symbol": return 4 /* Symbol */;
            case "number": return 5 /* Number */;
            case "object": return x === null ? 1 /* Null */ : 6 /* Object */;
            default: return 6 /* Object */;
        }
    }
    // 6.1.1 The Undefined Type
    // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
    function IsUndefined(x) {
        return x === undefined;
    }
    // 6.1.2 The Null Type
    // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
    function IsNull(x) {
        return x === null;
    }
    // 6.1.5 The Symbol Type
    // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
    function IsSymbol(x) {
        return typeof x === "symbol";
    }
    // 6.1.7 The Object Type
    // https://tc39.github.io/ecma262/#sec-object-type
    function IsObject(x) {
        return typeof x === "object" ? x !== null : typeof x === "function";
    }
    // 7.1 Type Conversion
    // https://tc39.github.io/ecma262/#sec-type-conversion
    // 7.1.1 ToPrimitive(input [, PreferredType])
    // https://tc39.github.io/ecma262/#sec-toprimitive
    function ToPrimitive(input, PreferredType) {
        switch (Type(input)) {
            case 0 /* Undefined */: return input;
            case 1 /* Null */: return input;
            case 2 /* Boolean */: return input;
            case 3 /* String */: return input;
            case 4 /* Symbol */: return input;
            case 5 /* Number */: return input;
        }
        var hint = PreferredType === 3 /* String */ ? "string" : PreferredType === 5 /* Number */ ? "number" : "default";
        var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
        if (exoticToPrim !== undefined) {
            var result = exoticToPrim.call(input, hint);
            if (IsObject(result))
                throw new TypeError();
            return result;
        }
        return OrdinaryToPrimitive(input, hint === "default" ? "number" : hint);
    }
    // 7.1.1.1 OrdinaryToPrimitive(O, hint)
    // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
    function OrdinaryToPrimitive(O, hint) {
        if (hint === "string") {
            var toString_1 = O.toString;
            if (IsCallable(toString_1)) {
                var result = toString_1.call(O);
                if (!IsObject(result))
                    return result;
            }
            var valueOf = O.valueOf;
            if (IsCallable(valueOf)) {
                var result = valueOf.call(O);
                if (!IsObject(result))
                    return result;
            }
        }
        else {
            var valueOf = O.valueOf;
            if (IsCallable(valueOf)) {
                var result = valueOf.call(O);
                if (!IsObject(result))
                    return result;
            }
            var toString_2 = O.toString;
            if (IsCallable(toString_2)) {
                var result = toString_2.call(O);
                if (!IsObject(result))
                    return result;
            }
        }
        throw new TypeError();
    }
    // 7.1.2 ToBoolean(argument)
    // https://tc39.github.io/ecma262/2016/#sec-toboolean
    function ToBoolean(argument) {
        return !!argument;
    }
    // 7.1.12 ToString(argument)
    // https://tc39.github.io/ecma262/#sec-tostring
    function ToString(argument) {
        return "" + argument;
    }
    // 7.1.14 ToPropertyKey(argument)
    // https://tc39.github.io/ecma262/#sec-topropertykey
    function ToPropertyKey(argument) {
        var key = ToPrimitive(argument, 3 /* String */);
        if (IsSymbol(key))
            return key;
        return ToString(key);
    }
    // 7.2 Testing and Comparison Operations
    // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
    // 7.2.2 IsArray(argument)
    // https://tc39.github.io/ecma262/#sec-isarray
    function IsArray(argument) {
        return Array.isArray
            ? Array.isArray(argument)
            : argument instanceof Object
                ? argument instanceof Array
                : Object.prototype.toString.call(argument) === "[object Array]";
    }
    // 7.2.3 IsCallable(argument)
    // https://tc39.github.io/ecma262/#sec-iscallable
    function IsCallable(argument) {
        // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
        return typeof argument === "function";
    }
    // 7.2.4 IsConstructor(argument)
    // https://tc39.github.io/ecma262/#sec-isconstructor
    function IsConstructor(argument) {
        // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
        return typeof argument === "function";
    }
    // 7.2.7 IsPropertyKey(argument)
    // https://tc39.github.io/ecma262/#sec-ispropertykey
    function IsPropertyKey(argument) {
        switch (Type(argument)) {
            case 3 /* String */: return true;
            case 4 /* Symbol */: return true;
            default: return false;
        }
    }
    // 7.3 Operations on Objects
    // https://tc39.github.io/ecma262/#sec-operations-on-objects
    // 7.3.9 GetMethod(V, P)
    // https://tc39.github.io/ecma262/#sec-getmethod
    function GetMethod(V, P) {
        var func = V[P];
        if (func === undefined || func === null)
            return undefined;
        if (!IsCallable(func))
            throw new TypeError();
        return func;
    }
    // 7.4 Operations on Iterator Objects
    // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
    function GetIterator(obj) {
        var method = GetMethod(obj, iteratorSymbol);
        if (!IsCallable(method))
            throw new TypeError(); // from Call
        var iterator = method.call(obj);
        if (!IsObject(iterator))
            throw new TypeError();
        return iterator;
    }
    // 7.4.4 IteratorValue(iterResult)
    // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
    function IteratorValue(iterResult) {
        return iterResult.value;
    }
    // 7.4.5 IteratorStep(iterator)
    // https://tc39.github.io/ecma262/#sec-iteratorstep
    function IteratorStep(iterator) {
        var result = iterator.next();
        return result.done ? false : result;
    }
    // 7.4.6 IteratorClose(iterator, completion)
    // https://tc39.github.io/ecma262/#sec-iteratorclose
    function IteratorClose(iterator) {
        var f = iterator["return"];
        if (f)
            f.call(iterator);
    }
    // 9.1 Ordinary Object Internal Methods and Internal Slots
    // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
    // 9.1.1.1 OrdinaryGetPrototypeOf(O)
    // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
    function OrdinaryGetPrototypeOf(O) {
        var proto = Object.getPrototypeOf(O);
        if (typeof O !== "function" || O === functionPrototype)
            return proto;
        // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
        // Try to determine the superclass constructor. Compatible implementations
        // must either set __proto__ on a subclass constructor to the superclass constructor,
        // or ensure each class has a valid `constructor` property on its prototype that
        // points back to the constructor.
        // If this is not the same as Function.[[Prototype]], then this is definately inherited.
        // This is the case when in ES6 or when using __proto__ in a compatible browser.
        if (proto !== functionPrototype)
            return proto;
        // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
        var prototype = O.prototype;
        var prototypeProto = prototype && Object.getPrototypeOf(prototype);
        if (prototypeProto == null || prototypeProto === Object.prototype)
            return proto;
        // If the constructor was not a function, then we cannot determine the heritage.
        var constructor = prototypeProto.constructor;
        if (typeof constructor !== "function")
            return proto;
        // If we have some kind of self-reference, then we cannot determine the heritage.
        if (constructor === O)
            return proto;
        // we have a pretty good guess at the heritage.
        return constructor;
    }
    // naive Map shim
    function CreateMapPolyfill() {
        var cacheSentinel = {};
        var arraySentinel = [];
        var MapIterator = (function () {
            function MapIterator(keys, values, selector) {
                this._index = 0;
                this._keys = keys;
                this._values = values;
                this._selector = selector;
            }
            MapIterator.prototype["@@iterator"] = function () { return this; };
            MapIterator.prototype[iteratorSymbol] = function () { return this; };
            MapIterator.prototype.next = function () {
                var index = this._index;
                if (index >= 0 && index < this._keys.length) {
                    var result = this._selector(this._keys[index], this._values[index]);
                    if (index + 1 >= this._keys.length) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    else {
                        this._index++;
                    }
                    return { value: result, done: false };
                }
                return { value: undefined, done: true };
            };
            MapIterator.prototype.throw = function (error) {
                if (this._index >= 0) {
                    this._index = -1;
                    this._keys = arraySentinel;
                    this._values = arraySentinel;
                }
                throw error;
            };
            MapIterator.prototype.return = function (value) {
                if (this._index >= 0) {
                    this._index = -1;
                    this._keys = arraySentinel;
                    this._values = arraySentinel;
                }
                return { value: value, done: true };
            };
            return MapIterator;
        }());
        return (function () {
            function Map() {
                this._keys = [];
                this._values = [];
                this._cacheKey = cacheSentinel;
                this._cacheIndex = -2;
            }
            Object.defineProperty(Map.prototype, "size", {
                get: function () { return this._keys.length; },
                enumerable: true,
                configurable: true
            });
            Map.prototype.has = function (key) { return this._find(key, /*insert*/ false) >= 0; };
            Map.prototype.get = function (key) {
                var index = this._find(key, /*insert*/ false);
                return index >= 0 ? this._values[index] : undefined;
            };
            Map.prototype.set = function (key, value) {
                var index = this._find(key, /*insert*/ true);
                this._values[index] = value;
                return this;
            };
            Map.prototype.delete = function (key) {
                var index = this._find(key, /*insert*/ false);
                if (index >= 0) {
                    var size = this._keys.length;
                    for (var i = index + 1; i < size; i++) {
                        this._keys[i - 1] = this._keys[i];
                        this._values[i - 1] = this._values[i];
                    }
                    this._keys.length--;
                    this._values.length--;
                    if (key === this._cacheKey) {
                        this._cacheKey = cacheSentinel;
                        this._cacheIndex = -2;
                    }
                    return true;
                }
                return false;
            };
            Map.prototype.clear = function () {
                this._keys.length = 0;
                this._values.length = 0;
                this._cacheKey = cacheSentinel;
                this._cacheIndex = -2;
            };
            Map.prototype.keys = function () { return new MapIterator(this._keys, this._values, getKey); };
            Map.prototype.values = function () { return new MapIterator(this._keys, this._values, getValue); };
            Map.prototype.entries = function () { return new MapIterator(this._keys, this._values, getEntry); };
            Map.prototype["@@iterator"] = function () { return this.entries(); };
            Map.prototype[iteratorSymbol] = function () { return this.entries(); };
            Map.prototype._find = function (key, insert) {
                if (this._cacheKey !== key) {
                    this._cacheIndex = this._keys.indexOf(this._cacheKey = key);
                }
                if (this._cacheIndex < 0 && insert) {
                    this._cacheIndex = this._keys.length;
                    this._keys.push(key);
                    this._values.push(undefined);
                }
                return this._cacheIndex;
            };
            return Map;
        }());
        function getKey(key, _) {
            return key;
        }
        function getValue(_, value) {
            return value;
        }
        function getEntry(key, value) {
            return [key, value];
        }
    }
    // naive Set shim
    function CreateSetPolyfill() {
        return (function () {
            function Set() {
                this._map = new _Map();
            }
            Object.defineProperty(Set.prototype, "size", {
                get: function () { return this._map.size; },
                enumerable: true,
                configurable: true
            });
            Set.prototype.has = function (value) { return this._map.has(value); };
            Set.prototype.add = function (value) { return this._map.set(value, value), this; };
            Set.prototype.delete = function (value) { return this._map.delete(value); };
            Set.prototype.clear = function () { this._map.clear(); };
            Set.prototype.keys = function () { return this._map.keys(); };
            Set.prototype.values = function () { return this._map.values(); };
            Set.prototype.entries = function () { return this._map.entries(); };
            Set.prototype["@@iterator"] = function () { return this.keys(); };
            Set.prototype[iteratorSymbol] = function () { return this.keys(); };
            return Set;
        }());
    }
    // naive WeakMap shim
    function CreateWeakMapPolyfill() {
        var UUID_SIZE = 16;
        var keys = HashMap.create();
        var rootKey = CreateUniqueKey();
        return (function () {
            function WeakMap() {
                this._key = CreateUniqueKey();
            }
            WeakMap.prototype.has = function (target) {
                var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                return table !== undefined ? HashMap.has(table, this._key) : false;
            };
            WeakMap.prototype.get = function (target) {
                var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                return table !== undefined ? HashMap.get(table, this._key) : undefined;
            };
            WeakMap.prototype.set = function (target, value) {
                var table = GetOrCreateWeakMapTable(target, /*create*/ true);
                table[this._key] = value;
                return this;
            };
            WeakMap.prototype.delete = function (target) {
                var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                return table !== undefined ? delete table[this._key] : false;
            };
            WeakMap.prototype.clear = function () {
                // NOTE: not a real clear, just makes the previous data unreachable
                this._key = CreateUniqueKey();
            };
            return WeakMap;
        }());
        function CreateUniqueKey() {
            var key;
            do
                key = "@@WeakMap@@" + CreateUUID();
            while (HashMap.has(keys, key));
            keys[key] = true;
            return key;
        }
        function GetOrCreateWeakMapTable(target, create) {
            if (!hasOwn.call(target, rootKey)) {
                if (!create)
                    return undefined;
                Object.defineProperty(target, rootKey, { value: HashMap.create() });
            }
            return target[rootKey];
        }
        function FillRandomBytes(buffer, size) {
            for (var i = 0; i < size; ++i)
                buffer[i] = Math.random() * 0xff | 0;
            return buffer;
        }
        function GenRandomBytes(size) {
            if (typeof Uint8Array === "function") {
                if (typeof crypto !== "undefined")
                    return crypto.getRandomValues(new Uint8Array(size));
                if (typeof msCrypto !== "undefined")
                    return msCrypto.getRandomValues(new Uint8Array(size));
                return FillRandomBytes(new Uint8Array(size), size);
            }
            return FillRandomBytes(new Array(size), size);
        }
        function CreateUUID() {
            var data = GenRandomBytes(UUID_SIZE);
            // mark as random - RFC 4122 § 4.4
            data[6] = data[6] & 0x4f | 0x40;
            data[8] = data[8] & 0xbf | 0x80;
            var result = "";
            for (var offset = 0; offset < UUID_SIZE; ++offset) {
                var byte = data[offset];
                if (offset === 4 || offset === 6 || offset === 8)
                    result += "-";
                if (byte < 16)
                    result += "0";
                result += byte.toString(16).toLowerCase();
            }
            return result;
        }
    }
    // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
    function MakeDictionary(obj) {
        obj.__ = undefined;
        delete obj.__;
        return obj;
    }
    // patch global Reflect
    (function (__global) {
        if (typeof __global.Reflect !== "undefined") {
            if (__global.Reflect !== Reflect) {
                for (var p in Reflect) {
                    if (hasOwn.call(Reflect, p)) {
                        __global.Reflect[p] = Reflect[p];
                    }
                }
            }
        }
        else {
            __global.Reflect = Reflect;
        }
    })(typeof commonjsGlobal !== "undefined" ? commonjsGlobal :
        typeof self !== "undefined" ? self :
            Function("return this;")());
})(Reflect$1 || (Reflect$1 = {}));


var _Reflect = {

};

var vuePropertyDecorator_umd$1 = createCommonjsModule(function (module, exports) {
(function (global, factory) {
	factory(exports, __WEBPACK_IMPORTED_MODULE_0_vue__["default"], vueClassComponent_common, _Reflect);
}(commonjsGlobal, (function (exports,vue,vueClassComponent) { 'use strict';

vue = vue && vue.hasOwnProperty('default') ? vue['default'] : vue;
var vueClassComponent__default = 'default' in vueClassComponent ? vueClassComponent['default'] : vueClassComponent;

/** vue-property-decorator verson 6.0.0 MIT LICENSE copyright 2017 kaorun343 */
'use strict';
/**
 * decorator of an inject
 * @param key key
 * @return PropertyDecorator
 */
function Inject(key) {
    return vueClassComponent.createDecorator(function (componentOptions, k) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject[k] = key || k;
        }
    });
}
/**
 * decorator of a provide
 * @param key key
 * @return PropertyDecorator | void
 */
function Provide(key) {
    return vueClassComponent.createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        if (typeof provide !== 'function' || !provide.managed) {
            var original_1 = componentOptions.provide;
            provide = componentOptions.provide = function () {
                var rv = Object.create((typeof original_1 === 'function' ? original_1.call(this) : original_1) || null);
                for (var i in provide.managed)
                    rv[provide.managed[i]] = this[i];
                return rv;
            };
            provide.managed = {};
        }
        provide.managed[k] = key || k;
    });
}
/**
 * decorator of model
 * @param  event event name
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        if (!Array.isArray(options) && typeof options.type === 'undefined') {
            options.type = Reflect.getMetadata('design:type', target, key);
        }
        vueClassComponent.createDecorator(function (componentOptions, k) {
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}
/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        if (!Array.isArray(options) && typeof options.type === 'undefined') {
            options.type = Reflect.getMetadata('design:type', target, key);
        }
        vueClassComponent.createDecorator(function (componentOptions, k) {
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}
/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return vueClassComponent.createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        componentOptions.watch[path] = { handler: handler, deep: deep, immediate: immediate };
    });
}
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (target, key, descriptor) {
        key = hyphenate(key);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (original.apply(this, args) !== false)
                this.$emit.apply(this, [event || key].concat(args));
        };
    };
}

exports.Component = vueClassComponent__default;
exports.Vue = vue;
exports.Inject = Inject;
exports.Provide = Provide;
exports.Model = Model;
exports.Prop = Prop;
exports.Watch = Watch;
exports.Emit = Emit;

Object.defineProperty(exports, '__esModule', { value: true });

})));
});

unwrapExports(vuePropertyDecorator_umd$1);
var vuePropertyDecorator_umd_1 = vuePropertyDecorator_umd$1.Component;

var __extends$2 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate$2 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SnotifyPrompt = /** @class */ (function (_super) {
    __extends$2(SnotifyPrompt, _super);
    function SnotifyPrompt() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isPromptFocused = false;
        return _this;
    }
    SnotifyPrompt.prototype.valueChanged = function (e) {
        this.toast.value = e.target.value;
        this.toast.eventEmitter.$emit('input');
    };
    SnotifyPrompt = __decorate$2([
        vuePropertyDecorator_umd_1({
            template: "<span class=\"snotifyToast__input\" :class=\"{'snotifyToast__input--filled': isPromptFocused}\"> <input @input=\"valueChanged\" class=\"snotifyToast__input__field\" type=\"text\" :id=\"toast.id\" @focus=\"isPromptFocused = true\" @blur=\"isPromptFocused = !!toast.value.length\"/> <label class=\"snotifyToast__input__label\" :for=\"toast.id\"> <span class=\"snotifyToast__input__labelContent\">{{toast.config.placeholder | truncate}}</span> </label> </span> ",
            props: ['toast']
        })
    ], SnotifyPrompt);
    return SnotifyPrompt;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));

var __extends$3 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate$3 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SnotifyButton = /** @class */ (function (_super) {
    __extends$3(SnotifyButton, _super);
    function SnotifyButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SnotifyButton.prototype.remove = function () {
        this.$snotify.remove(this.toast.id);
    };
    SnotifyButton = __decorate$3([
        vuePropertyDecorator_umd_1({
            template: "<div class=\"snotifyToast__buttons\"> <button type=\"button\" v-for=\"button in toast.config.buttons\" :class=\"{'snotifyToast__buttons--bold': button.bold}\" @click=\"button.action ? button.action(toast) : remove()\"> {{button.text}} </button> </div> ",
            props: ['toast']
        })
    ], SnotifyButton);
    return SnotifyButton;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));

var __extends$1 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate$1 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Toast = /** @class */ (function (_super) {
    __extends$1(Toast, _super);
    function Toast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toast = _this.toastData;
        _this.animationFrame = null;
        _this.state = {
            paused: false,
            progress: 0,
            animation: '',
            isDestroying: false,
            promptType: SnotifyStyle.prompt
        };
        return _this;
    }
    /**
     * Initialize base toast config
     */
    Toast.prototype.initToast = function () {
        if (this.toast.config.timeout > 0) {
            this.startTimeout(0);
        }
    };
    Toast.prototype.onClick = function () {
        this.toast.eventEmitter.$emit('click');
        if (this.toast.config.closeOnClick) {
            this.$snotify.remove(this.toast.id);
        }
    };
    Toast.prototype.onMouseEnter = function () {
        this.toast.eventEmitter.$emit('mouseenter');
        if (this.toast.config.pauseOnHover) {
            this.state.paused = true;
        }
    };
    Toast.prototype.onMouseLeave = function () {
        if (this.toast.config.pauseOnHover && this.toast.config.timeout) {
            this.state.paused = false;
            this.startTimeout(this.toast.config.timeout * this.state.progress);
        }
        this.toast.eventEmitter.$emit('mouseleave');
    };
    /**
     * Remove toast completely after animation
     */
    Toast.prototype.onExitTransitionEnd = function () {
        if (this.state.isDestroying) {
            return;
        }
        this.initToast();
        this.toast.eventEmitter.$emit('shown');
    };
    /**
     * Start progress bar
     * @param startTime {number}
     * @default 0
     */
    Toast.prototype.startTimeout = function (startTime) {
        var _this = this;
        if (startTime === void 0) { startTime = 0; }
        var start = performance.now();
        var calculate = function () {
            _this.animationFrame = requestAnimationFrame(function (timestamp) {
                var runtime = timestamp + startTime - start;
                var progress = Math.min(runtime / _this.toast.config.timeout, 1);
                if (_this.state.paused) {
                    cancelAnimationFrame(_this.animationFrame);
                }
                else if (runtime < _this.toast.config.timeout) {
                    _this.state.progress = progress;
                    calculate();
                }
                else {
                    _this.state.progress = 1;
                    cancelAnimationFrame(_this.animationFrame);
                    _this.$snotify.emitter.$emit('remove', _this.toast.id);
                }
            });
        };
        calculate();
    };
    /**
     * Trigger beforeDestroy lifecycle. Removes toast
     */
    Toast.prototype.onRemove = function () {
        var _this = this;
        this.state.isDestroying = true;
        this.$emit('stateChanged', 'beforeHide');
        this.toast.eventEmitter.$emit('beforeHide');
        this.state.animation = this.toast.config.animation.exit;
        setTimeout(function () {
            _this.$emit('stateChanged', 'hidden');
            _this.state.animation = 'snotifyToast--out';
            _this.toast.eventEmitter.$emit('hidden');
            setTimeout(function () { return _this.$snotify.remove(_this.toast.id, true); }, _this.toast.config.animation.time / 2);
        }, this.toast.config.animation.time / 2);
    };
    Toast.prototype.created = function () {
        var _this = this;
        this.$snotify.emitter.$on('toastChanged', function (toast) {
            if (_this.toast.id === toast.id) {
                _this.initToast();
            }
        });
        this.$snotify.emitter.$on('remove', function (id) {
            if (_this.toast.id === id) {
                _this.onRemove();
            }
        });
    };
    Toast.prototype.mounted = function () {
        var _this = this;
        this.$nextTick(function () {
            _this.toast.eventEmitter.$emit('mounted');
            _this.state.animation = 'snotifyToast--in';
            _this.$nextTick(function () {
                setTimeout(function () {
                    _this.$emit('stateChanged', 'beforeShow');
                    _this.toast.eventEmitter.$emit('beforeShow');
                    _this.state.animation = _this.toast.config.animation.enter;
                }, _this.toast.config.animation.time / 5); // time to show toast push animation (snotifyToast--in)
            });
        });
    };
    Toast.prototype.destroyed = function () {
        cancelAnimationFrame(this.animationFrame);
        this.toast.eventEmitter.$emit('destroyed');
    };
    Toast = __decorate$1([
        vuePropertyDecorator_umd_1({
            template: "<div class=\"snotifyToast animated\" :class=\"['snotify-' + toast.config.type, state.animation, toast.valid === undefined ? '' : (toast.valid ? 'snotifyToast--valid' : 'snotifyToast--invalid') ]\" :style=\"{ '-webkit-animation-duration': toast.config.animation.time + 'ms', 'animation-duration': toast.config.animation.time + 'ms', '-webkit-transition': toast.config.animation.time + 'ms', transition: toast.config.animation.time + 'ms' }\" @click=\"onClick\" @mouseenter=\"onMouseEnter\" @mouseleave=\"onMouseLeave\" @animationend=\"onExitTransitionEnd\"> <div class=\"snotifyToast__progressBar\" v-if=\"toast.config.showProgressBar && toast.config.timeout > 0\"> <span class=\"snotifyToast__progressBar__percentage\" :style=\"{'width': (state.progress * 100) + '%'}\"></span> </div> <div class=\"snotifyToast__inner\" v-if=\"!toast.config.html\"> <div class=\"snotifyToast__title\" v-if=\"toast.title\">{{toast.title | truncate(toast.config.titleMaxLength)}}</div> <div class=\"snotifyToast__body\" v-if=\"toast.body\">{{toast.body | truncate(toast.config.bodyMaxLength)}}</div> <snotify-prompt v-if=\"toast.config.type === state.promptType\" :toast=\"toast\"> </snotify-prompt> <div v-if=\"!toast.config.icon\" :class=\"['snotify-icon', 'snotify-icon--' + toast.config.type]\"></div> <div v-else> <img class=\"snotify-icon\" :src='toast.config.icon'/> </div> </div> <div class=\"snotifyToast__inner\" v-html=\"toast.config.html\" v-else></div> <snotify-button v-if=\"toast.config.buttons\" :toast=\"toast\"></snotify-button> </div> ",
            props: ['toastData'],
            components: {
                SnotifyPrompt: SnotifyPrompt,
                SnotifyButton: SnotifyButton
            }
        })
    ], Toast);
    return Toast;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Snotify = /** @class */ (function (_super) {
    __extends(Snotify, _super);
    function Snotify() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Toasts array
         */
        _this.notifications = {
            left_top: [],
            left_center: [],
            left_bottom: [],
            right_top: [],
            right_center: [],
            right_bottom: [],
            center_top: [],
            center_center: [],
            center_bottom: []
        };
        /**
         * Helper for slice pipe (maxOnScreen)
         */
        _this.dockSize_a = 0;
        /**
         * Helper for slice pipe (maxOnScreen)
         */
        _this.dockSize_b = 0;
        /**
         * Helper for slice pipe (maxAtPosition)
         */
        _this.blockSize_a = 0;
        /**
         * Helper for slice pipe (maxAtPosition)
         */
        _this.blockSize_b = 0;
        /**
         * Backdrop Opacity
         */
        _this.backdrop = -1;
        /**
         * How many toasts with backdrop in current queue
         */
        _this.withBackdrop = [];
        return _this;
    }
    Snotify.prototype.setOptions = function (toasts) {
        if (this.$snotify.config.global.newOnTop) {
            this.dockSize_a = -this.$snotify.config.global.maxOnScreen;
            this.dockSize_b = undefined;
            this.blockSize_a = -this.$snotify.config.global.maxAtPosition;
            this.blockSize_b = undefined;
            this.withBackdrop = toasts.filter(function (toast) { return toast.config.backdrop >= 0; });
        }
        else {
            this.dockSize_a = 0;
            this.dockSize_b = this.$snotify.config.global.maxOnScreen;
            this.blockSize_a = 0;
            this.blockSize_b = this.$snotify.config.global.maxAtPosition;
            this.withBackdrop = toasts.filter(function (toast) { return toast.config.backdrop >= 0; }).reverse();
        }
        this.notifications = this.splitToasts(toasts.slice(this.dockSize_a, this.dockSize_b));
        this.stateChanged('mounted');
    };
    // TODO: fix backdrop if more than one toast called in a row
    /**
     * Changes the backdrop opacity
     * @param {SnotifyEvent} event
     */
    Snotify.prototype.stateChanged = function (event) {
        if (!this.withBackdrop.length) {
            return;
        }
        switch (event) {
            case 'mounted':
                if (this.backdrop < 0) {
                    this.backdrop = 0;
                }
                break;
            case 'beforeShow':
                this.backdrop = this.withBackdrop[this.withBackdrop.length - 1].config.backdrop;
                break;
            case 'beforeHide':
                if (this.withBackdrop.length === 1) {
                    this.backdrop = 0;
                }
                break;
            case 'hidden':
                if (this.withBackdrop.length === 1) {
                    this.backdrop = -1;
                }
                break;
        }
    };
    /**
     * Split toasts toasts into different objects
     * @param {SnotifyToast[]} toasts
     * @returns {SnotifyNotifications}
     */
    Snotify.prototype.splitToasts = function (toasts) {
        var result = {};
        for (var property in SnotifyPosition) {
            if (SnotifyPosition.hasOwnProperty(property)) {
                result[SnotifyPosition[property]] = [];
            }
        }
        toasts.forEach(function (toast) {
            result[toast.config.position].push(toast);
        });
        return result;
    };
    Snotify.prototype.created = function () {
        var _this = this;
        this.$snotify.emitter.$on('snotify', function (toasts) {
            _this.setOptions(toasts);
        });
    };
    Snotify = __decorate([
        vuePropertyDecorator_umd_1({
            template: "<div> <div class=\"snotify-backdrop\" v-if=\"backdrop >= 0\" :style=\"{opacity: backdrop}\"></div> <div v-for=\"(position, index) in notifications\" class=\"snotify\" :class=\"'snotify-' + index\"> <toast v-for=\"toast in notifications[index].slice(blockSize_a, blockSize_b)\" :toastData=\"toast\" :key=\"toast.id\" @stateChanged=\"stateChanged\"> </toast> </div> </div> ",
            components: {
                Toast: Toast
            }
        })
    ], Snotify);
    return Snotify;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));

/**
 * Toast model
 */
var SnotifyToast = /** @class */ (function () {
    /**
     *
     * @param {number|string} id
     * @param {string} title
     * @param {string} body
     * @param {SnotifyToastConfig} [config]
     */
    function SnotifyToast(id, title, body, config) {
        var _this = this;
        this.id = id;
        this.title = title;
        this.body = body;
        this.config = config;
        /**
         * Emits {SnotifyEvent}
         * @type {Vue}
         */
        this.eventEmitter = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
        /**
         * Holds all subscribers because we need to unsubscribe from all before toast get destroyed
         * @type {Vue[]}
         * @private
         */
        this._eventsHolder = [];
        /**
         * Toast validator
         */
        this.valid = undefined;
        if (this.config.type === SnotifyStyle.prompt) {
            this.value = '';
        }
        this.on('hidden', function () {
            _this._eventsHolder.forEach(function (o) {
                _this.eventEmitter.$off(o.event, o.action);
            });
        });
    }
    /**
     * This callback is displayed as a global member.
     * @callback action
     * @param {toast} responseCode
     * @returns {void}
     */
    /**
     * Subscribe to toast events
     * @param {String<SnotifyEvent>} event
     * @param  {SnotifyToast~action} action
     * @returns {SnotifyToast}
     */
    SnotifyToast.prototype.on = function (event, action) {
        var _this = this;
        this._eventsHolder.push({ event: event, action: action });
        this.eventEmitter.$on(event, function () { return action(_this); });
        return this;
    };
    return SnotifyToast;
}());

/**
 * Snotify default configuration object
 * @type {SnotifyDefaults}
 */
var ToastDefaults = {
    global: {
        newOnTop: true,
        maxOnScreen: 8,
        maxAtPosition: 8
    },
    toast: {
        type: SnotifyStyle.simple,
        showProgressBar: true,
        timeout: 2000,
        closeOnClick: true,
        pauseOnHover: true,
        bodyMaxLength: 150,
        titleMaxLength: 16,
        backdrop: -1,
        icon: null,
        html: null,
        position: SnotifyPosition.rightBottom,
        animation: { enter: 'fadeIn', exit: 'fadeOut', time: 400 }
    },
    type: (_a = {},
        _a[SnotifyStyle.prompt] = {
            timeout: 0,
            closeOnClick: false,
            buttons: [
                { text: 'Ok', action: null, bold: true },
                { text: 'Cancel', action: null, bold: false },
            ],
            placeholder: 'Enter answer here...',
            type: SnotifyStyle.prompt,
        },
        _a[SnotifyStyle.confirm] = {
            timeout: 0,
            closeOnClick: false,
            buttons: [
                { text: 'Ok', action: null, bold: true },
                { text: 'Cancel', action: null, bold: false },
            ],
            type: SnotifyStyle.confirm,
        },
        _a[SnotifyStyle.simple] = {
            type: SnotifyStyle.simple
        },
        _a[SnotifyStyle.success] = {
            type: SnotifyStyle.success
        },
        _a[SnotifyStyle.error] = {
            type: SnotifyStyle.error
        },
        _a[SnotifyStyle.warning] = {
            type: SnotifyStyle.warning
        },
        _a[SnotifyStyle.info] = {
            type: SnotifyStyle.info
        },
        _a[SnotifyStyle.async] = {
            pauseOnHover: false,
            closeOnClick: false,
            timeout: 0,
            showProgressBar: false,
            type: SnotifyStyle.async
        },
        _a)
};
var _a;

/**
 * Transform arguments to Snotify object
 * @param target
 * @param {SnotifyType} propertyKey
 * @param {PropertyDescriptor} descriptor
 * @returns {Snotify}
 * @constructor
 */
function TransformArgument(target, propertyKey, descriptor) {
    if (propertyKey === SnotifyStyle.async) {
        return {
            value: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var result;
                if (args.length === 2) {
                    result = {
                        title: null,
                        body: args[0],
                        config: null,
                        action: args[1]
                    };
                }
                else if (args.length === 3) {
                    if (typeof args[1] === 'string') {
                        result = {
                            title: args[1],
                            body: args[0],
                            config: null,
                            action: args[2]
                        };
                    }
                    else {
                        result = {
                            title: null,
                            body: args[0],
                            config: args[2],
                            action: args[1]
                        };
                    }
                }
                else {
                    result = {
                        title: args[1],
                        body: args[0],
                        config: args[3],
                        action: args[2]
                    };
                }
                return descriptor.value.apply(this, [result]);
            }
        };
    }
    else {
        return {
            value: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var result;
                if (args.length === 1) {
                    result = {
                        title: null,
                        body: args[0],
                        config: null
                    };
                }
                else if (args.length === 3) {
                    result = {
                        title: args[1],
                        body: args[0],
                        config: args[2]
                    };
                }
                else {
                    result = (_a = {
                            title: null,
                            config: null,
                            body: args[0]
                        },
                        _a[typeof args[1] === 'string' ? 'title' : 'config'] = args[1],
                        _a);
                }
                return descriptor.value.apply(this, [result]);
                var _a;
            }
        };
    }
}

/**
 * Generates random id
 * @return {number}
 */
function uuid() {
    return Math.floor(Math.random() * (Date.now() - 1)) + 1;
}
/**
 * Simple is object check.
 * @param item {Object<any>}
 * @returns {boolean}
 */
function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item) && item !== null);
}
/**
 * Deep merge objects.
 * @param sources {Array<Object<any>>}
 * @returns {Object<any>}
 */
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var target = {};
    if (!sources.length) {
        return target;
    }
    while (sources.length > 0) {
        var source = sources.shift();
        if (isObject(source)) {
            for (var key in source) {
                if (isObject(source[key])) {
                    target[key] = mergeDeep(target[key], source[key]);
                }
                else {
                    Object.assign(target, (_a = {}, _a[key] = source[key], _a));
                }
            }
        }
    }
    return target;
    var _a;
}

var __assign$1 = (undefined && undefined.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
/**
 * Defines toast style depending on method name
 * @param target
 * @param {SnotifyType} propertyKey
 * @param {PropertyDescriptor} descriptor
 * @returns {{value: ((...args: any[]) => any)}}
 * @constructor
 */
function SetToastType(target, propertyKey, descriptor) {
    return {
        value: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            args[0].config = __assign$1({}, args[0].config, { type: propertyKey });
            return descriptor.value.apply(this, args);
        }
    };
}

var __assign = (undefined && undefined.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate$4 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * this - create, remove, config toasts
 */
// tslint:disable:unified-signatures
var SnotifyService = /** @class */ (function () {
    function SnotifyService() {
        this.emitter = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
        this.notifications = [];
        this.config = ToastDefaults;
    }
    /**
     * emit changes in notifications array
     */
    SnotifyService.prototype.emit = function () {
        this.emitter.$emit('snotify', this.notifications.slice());
    };
    /**
     * returns SnotifyToast object
     * @param id {Number}
     * @return {SnotifyToast|undefined}
     */
    SnotifyService.prototype.get = function (id) {
        return this.notifications.find(function (toast) { return toast.id === id; });
    };
    /**
     * add SnotifyToast to notifications array
     * @param toast {SnotifyToast}
     */
    SnotifyService.prototype.add = function (toast) {
        if (this.config.global.newOnTop) {
            this.notifications.unshift(toast);
        }
        else {
            this.notifications.push(toast);
        }
        this.emit();
    };
    /**
     * If ID passed, emits toast animation remove, if ID & REMOVE passed, removes toast from notifications array
     * @param id {number}
     * @param remove {boolean}
     */
    SnotifyService.prototype.remove = function (id, remove) {
        if (!id) {
            return this.clear();
        }
        else if (remove) {
            this.notifications = this.notifications.filter(function (toast) { return toast.id !== id; });
            return this.emit();
        }
        this.emitter.$emit('remove', id);
    };
    /**
     * Clear notifications array
     */
    SnotifyService.prototype.clear = function () {
        this.notifications = [];
        this.emit();
    };
    SnotifyService.prototype.button = function (text, closeOnClick, action, bold) {
        var _this = this;
        if (closeOnClick === void 0) { closeOnClick = true; }
        if (action === void 0) { action = null; }
        if (bold === void 0) { bold = false; }
        return {
            text: text,
            action: closeOnClick ? function (toast) {
                action(toast);
                _this.remove(toast.id);
            } : action,
            bold: bold
        };
    };
    /**
     * Creates toast and add it to array, returns toast id
     * @param snotify {Snotify}
     * @return {number}
     */
    SnotifyService.prototype.create = function (snotify) {
        var config = mergeDeep(this.config.toast, this.config.type[snotify.config.type], snotify.config);
        var toast = new SnotifyToast(config.id ? config.id : uuid(), snotify.title, snotify.body, config);
        this.add(toast);
        return toast;
    };
    SnotifyService.prototype.setDefaults = function (defaults) {
        return this.config = mergeDeep(this.config, defaults);
    };
    /**
     * Transform toast arguments into {Snotify} object
     */
    SnotifyService.prototype.simple = function (args) {
        return this.create(args);
    };
    /**
     * Transform toast arguments into {Snotify} object
     */
    SnotifyService.prototype.success = function (args) {
        return this.create(args);
    };
    /**
     * Transform toast arguments into {Snotify} object
     */
    SnotifyService.prototype.error = function (args) {
        return this.create(args);
    };
    /**
     * Transform toast arguments into {Snotify} object
     */
    SnotifyService.prototype.info = function (args) {
        return this.create(args);
    };
    /**
     * Transform toast arguments into {Snotify} object
     */
    SnotifyService.prototype.warning = function (args) {
        return this.create(args);
    };
    /**
     * Transform toast arguments into {Snotify} object
     */
    SnotifyService.prototype.confirm = function (args) {
        return this.create(args);
    };
    /**
     * Transform toast arguments into {Snotify} object
     */
    SnotifyService.prototype.prompt = function (args) {
        return this.create(args);
    };
    /**
     * Transform toast arguments into {Snotify} object
     */
    SnotifyService.prototype.async = function (args) {
        var _this = this;
        var async = args.action;
        var toast = this.create(args);
        toast.on('mounted', function () {
            async()
                .then(function (next) { return _this.mergeToast(toast, next, SnotifyStyle.success); })
                .catch(function (error) { return _this.mergeToast(toast, error, SnotifyStyle.error); });
        });
        return toast;
    };
    SnotifyService.prototype.mergeToast = function (toast, next, type) {
        if (next.body) {
            toast.body = next.body;
        }
        if (next.title) {
            toast.title = next.title;
        }
        if (type) {
            toast.config = mergeDeep(toast.config, this.config.global, this.config.toast[type], { type: type }, next.config);
        }
        else {
            toast.config = mergeDeep(toast.config, next.config);
        }
        if (next.html) {
            toast.config.html = next.html;
        }
        this.emit();
    };
    /**
     * Creates empty toast with html string inside
     * @param {string} html
     * @param {SnotifyToastConfig} config
     * @returns {number}
     */
    SnotifyService.prototype.html = function (html, config) {
        return this.create({
            title: null,
            body: null,
            config: __assign({}, config, { html: html })
        });
    };
    __decorate$4([
        TransformArgument
        /**
         * Determines current toast type and collects default configuration
         */
        ,
        SetToastType,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", SnotifyToast)
    ], SnotifyService.prototype, "simple", null);
    __decorate$4([
        TransformArgument
        /**
         * Determines current toast type and collects default configuration
         */
        ,
        SetToastType,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", SnotifyToast)
    ], SnotifyService.prototype, "success", null);
    __decorate$4([
        TransformArgument
        /**
         * Determines current toast type and collects default configuration
         */
        ,
        SetToastType,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", SnotifyToast)
    ], SnotifyService.prototype, "error", null);
    __decorate$4([
        TransformArgument
        /**
         * Determines current toast type and collects default configuration
         */
        ,
        SetToastType,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", SnotifyToast)
    ], SnotifyService.prototype, "info", null);
    __decorate$4([
        TransformArgument
        /**
         * Determines current toast type and collects default configuration
         */
        ,
        SetToastType,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", SnotifyToast)
    ], SnotifyService.prototype, "warning", null);
    __decorate$4([
        TransformArgument
        /**
         * Determines current toast type and collects default configuration
         */
        ,
        SetToastType,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", SnotifyToast)
    ], SnotifyService.prototype, "confirm", null);
    __decorate$4([
        TransformArgument
        /**
         * Determines current toast type and collects default configuration
         */
        ,
        SetToastType,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", SnotifyToast)
    ], SnotifyService.prototype, "prompt", null);
    __decorate$4([
        TransformArgument
        /**
         * Determines current toast type and collects default configuration
         */
        ,
        SetToastType,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", SnotifyToast)
    ], SnotifyService.prototype, "async", null);
    return SnotifyService;
}());

var Plugin = {
    install: function (Vue$$1, options) {
        if (options === void 0) { options = {}; }
        Vue$$1.filter('truncate', function (value, limit, trail) {
            if (limit === void 0) { limit = 40; }
            if (trail === void 0) { trail = '...'; }
            return value.length > limit ? value.substring(0, limit) + trail : value;
        });
        var service = new SnotifyService();
        service.setDefaults(options);
        Vue$$1.prototype.$snotify = service;
        Vue$$1.component('vue-snotify', Snotify);
    }
};
// auto install
if (typeof window !== 'undefined' && window.hasOwnProperty('Vue')) {
    window.Vue.use(Plugin.install);
}


/* harmony default export */ __webpack_exports__["a"] = (Plugin);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "Hjpe":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1384);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1194:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("xTQk");

/***/ }),

/***/ 1257:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("rbj2");

/***/ }),

/***/ 1275:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("mxBz");

/***/ }),

/***/ 1277:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("SDgz");

/***/ }),

/***/ 1384:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1194),
	        __webpack_require__(1386),
	        __webpack_require__(1387),
	        __webpack_require__(1275),
	        __webpack_require__(1277),
	        __webpack_require__(1257),
	        __webpack_require__(1388),
	        __webpack_require__(1389),
	        __webpack_require__(1390),
	        __webpack_require__(1391),
	        __webpack_require__(1392),
	        __webpack_require__(1393),
	        __webpack_require__(1394),
	        __webpack_require__(1395),
	        __webpack_require__(1396),
	        __webpack_require__(1397),
	        __webpack_require__(1398),
	        __webpack_require__(1399),
	        __webpack_require__(1400),
	        __webpack_require__(1401),
	        __webpack_require__(1402),
	        __webpack_require__(1385),
	        __webpack_require__(1403),
	        __webpack_require__(1404),
	        __webpack_require__(1405),
	        __webpack_require__(1406),
	        __webpack_require__(1407),
	        __webpack_require__(1408),
	        __webpack_require__(1409),
	        __webpack_require__(1410),
	        __webpack_require__(1411),
	        __webpack_require__(1412),
	        __webpack_require__(1413),
	        __webpack_require__(1414),
	        __webpack_require__(1415),
	        __webpack_require__(1416),
	        __webpack_require__(1417),
	        __webpack_require__(1418),
	        __webpack_require__(1419),
	        __webpack_require__(1420),
	        __webpack_require__(1421),
	        __webpack_require__(1422)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	    var __meta__ = { // jshint ignore:line
	        id: "spreadsheet",
	        name: "Spreadsheet",
	        category: "web",
	        description: "Spreadsheet component",
	        depends: [
	            "core", "binder", "colorpicker", "combobox", "data", "dom", "dropdownlist",
	            "menu", "ooxml", "popup", "sortable", "tabstrip", "toolbar", "treeview",
	            "window", "validator", "excel", "pdf", "drawing" ]
	    };

	    (function(kendo, undefined) {
	        if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	            return;
	        }

	        var $ = kendo.jQuery;
	        var keys = $.extend({F10: 121, F11: 122, B: 66, I: 73, U: 85, N: 78, H: 72, A: 65, PAGEDOWN: 34, PAGEUP: 33, DELETE: 46, R: 82}, kendo.keys);
	        var Widget = kendo.ui.Widget;
	        var Workbook = kendo.spreadsheet.Workbook;
	        var Controller = kendo.spreadsheet.Controller;
	        var View = kendo.spreadsheet.View;
	        var NS = ".kendoSpreadsheet";

	        var ALL_REASONS = {
	            recalc: true,
	            selection: true,
	            activeCell: true,
	            layout: true,
	            sheetSelection: true,
	            resize: true,
	            editorChange: false,
	            editorClose: false
	        };

	        var classNames = {
	            wrapper: "k-widget k-spreadsheet"
	        };

	        var Spreadsheet = kendo.ui.Widget.extend({
	            init: function(element, options) {
	                Widget.fn.init.call(this, element, options);

	                this.element.addClass(Spreadsheet.classNames.wrapper);

	                this._view = new View(this.element, {
	                    messages: this.options.messages.view,
	                    toolbar: this.options.toolbar,
	                    sheetsbar:this.options.sheetsbar
	                });

	                this._workbook = new Workbook(this.options, this._view);

	                this._controller = new Controller(this._view, this._workbook);

	                this._autoRefresh = true;

	                this._bindWorkbookEvents();

	                this._view.workbook(this._workbook);

	                this._view.enableClipboard(false);
	                this.refresh();
	                this._view.enableClipboard(true);

	                this._resizeHandler = function() { this.resize(); }.bind(this);
	                $(window).on("resize" + NS, this._resizeHandler);

	                this.element.on("keydown" + NS, this._keyDown.bind(this));
	            },

	            _keyDown: function(e) {
	                var key = e.keyCode;
	                var redoTool = $(".k-spreadsheet-quick-access-toolbar [title=Redo]");
	                if (key === keys.F11 && e.shiftKey) {
	                    this._view.sheetsbar._onAddSelect();
	                    e.preventDefault();
	                    return;
	                } else if (e.altKey && key === keys.PAGEDOWN) {
	                    this._view.sheetsbar.trigger("select", {
	                                    name: this._view.sheetsbar._sheets[this._view.sheetsbar._selectedIndex + 1].name(),
	                                    isAddButton: false
	                    });
	                } else if (e.altKey && key === keys.PAGEUP) {
	                    this._view.sheetsbar.trigger("select", {
	                                    name: this._view.sheetsbar._sheets[this._view.sheetsbar._selectedIndex - 1].name(),
	                                    isAddButton: false
	                    });
	                } else if (e.altKey && key === keys.DELETE) {
	                    var closeCallback = function(e) {
	                        var dlg = e.sender;

	                        if (dlg.isConfirmed()) {
	                            this._view.sheetsbar.trigger("remove", { name: this.activeSheet()._name(), confirmation: true });
	                        }
	                    }.bind(this);

	                    this._view.sheetsbar._openDialog("confirmation", {
	                        close: closeCallback
	                    });
	                    e.preventDefault();
	                    return;
	                } else if (e.altKey && key === keys.R) {
	                    this._view.sheetsbar._createEditor();
	                    e.preventDefault();
	                    return;
	                } else if (key === keys.F10 && this._view.tabstrip || (key === keys.TAB && !e.shiftKey && $(document.activeElement).is(redoTool))) {
	                    this._view.tabstrip.toolbars[this._view.tabstrip.element.find("li.k-state-active").text().toLowerCase()].element.find(":not(.k-overflow-anchor):kendoFocusable:first").focus();
	                    this._view.tabstrip.toolbars[this._view.tabstrip.element.find("li.k-state-active").text().toLowerCase()].element.find(".k-toolbar-first-visible").addClass("k-state-focused");
	                    e.preventDefault();
	                    return;
	                } else if (e.ctrlKey && key === keys.B) {
	                    $("[data-tool=bold]")[0].click();
	                } else if (e.ctrlKey && key === keys.I) {
	                    $("[data-tool=italic]")[0].click();
	                } else if (e.ctrlKey && key === keys.U) {
	                    $("[data-tool=underline]")[0].click();
	                } else if (e.altKey && key === keys.H) {
	                    this._view.tabstrip.select(0);
	                    e.preventDefault();
	                    return;
	                } else if (e.altKey && key === keys.N) {
	                    this._view.tabstrip.select(1);
	                    e.preventDefault();
	                    return;
	                } else if (e.altKey && key === keys.A) {
	                    this._view.tabstrip.select(2);
	                    e.preventDefault();
	                    return;
	                }
	            },

	            _resize: function() {
	                this.refresh({ layout: true });
	            },

	            _workbookChanging: function(e) {
	                if (this.trigger("changing", e)) {
	                    e.preventDefault();
	                }
	            },

	            _workbookChange: function(e) {
	                if (this._autoRefresh) {
	                    this.refresh(e);
	                }

	                if (e.recalc && e.ref) {
	                    var range = e.range || new kendo.spreadsheet.Range(e.ref, this.activeSheet());
	                    this.trigger("change", { range: range });
	                }
	            },

	            _workbookCut: function(e) {
	                this.trigger("cut", e);
	            },

	            _workbookCopy: function(e) {
	                this.trigger("copy", e);
	            },

	            _workbookPaste: function(e) {
	                this.trigger("paste", e);
	            },

	            activeSheet: function(sheet) {
	                return this._workbook.activeSheet(sheet);
	            },

	            moveSheetToIndex: function (sheet, index) {
	                return this._workbook.moveSheetToIndex(sheet, index);
	            },

	            insertSheet: function(options) {
	                return this._workbook.insertSheet(options);
	            },

	            sheets: function() {
	                return this._workbook.sheets();
	            },

	            removeSheet: function(sheet) {
	                return this._workbook.removeSheet(sheet);
	            },

	            sheetByName: function(sheetName) {
	                return this._workbook.sheetByName(sheetName);
	            },

	            sheetIndex: function(sheet) {
	                return this._workbook.sheetIndex(sheet);
	            },

	            sheetByIndex: function(index) {
	                return this._workbook.sheetByIndex(index);
	            },

	            renameSheet: function(sheet, newSheetName) {
	                return this._workbook.renameSheet(sheet, newSheetName);
	            },

	            refresh: function(reason) {
	                if (!reason) {
	                    reason = ALL_REASONS;
	                }

	                if (!reason.editorClose) {
	                    this._view.sheet(this._workbook.activeSheet());
	                    this._controller.sheet(this._workbook.activeSheet());

	                    this._workbook.refresh(reason);
	                }

	                if (!reason.editorChange) {
	                    this._view.refresh(reason);
	                    this._controller.refresh();

	                    this._view.render(reason);
	                    this.trigger("render");
	                }

	                return this;
	            },

	            openDialog: function(name, options) {
	                return this._view.openDialog(name, options);
	            },

	            autoRefresh: function(value) {
	                if (value !== undefined) {
	                    this._autoRefresh = value;

	                    if (value === true) {
	                        this.refresh();
	                    }

	                    return this;
	                }

	                return this._autoRefresh;
	            },

	            toJSON: function() {
	                return this._workbook.toJSON();
	            },

	            fromJSON: function(json) {
	                if (json.sheets) {
	                    this._workbook.destroy();

	                    this._workbook = new Workbook($.extend({}, this.options, json));

	                    this._bindWorkbookEvents();

	                    this._view.workbook(this._workbook);
	                    this._controller.workbook(this._workbook);

	                    this.activeSheet(this.activeSheet());
	                } else {
	                    this.refresh();
	                }
	            },

	            saveJSON: function() {
	                return this._workbook.saveJSON();
	            },

	            fromFile: function(blob, name) {
	                return this._workbook.fromFile(blob, name);
	            },

	            saveAsPDF: function(options) {
	                this._workbook.saveAsPDF(
	                    $.extend({}, this.options.pdf, options, { workbook: this._workbook })
	                );
	            },

	            saveAsExcel: function(options) {
	                this._workbook.saveAsExcel(options);
	            },

	            draw: function(options, callback) {
	                this._workbook.draw(options, callback);
	            },

	            _workbookExcelExport: function(e) {
	                if (this.trigger("excelExport", e)) {
	                    e.preventDefault();
	                }
	            },

	            _workbookExcelImport: function(e) {
	                if (this.trigger("excelImport", e)) {
	                    e.preventDefault();
	                } else {
	                    this._initProgress(e.promise);
	                }
	            },

	            _initProgress: function(deferred) {
	                var loading =
	                    $("<div class='k-loading-mask' " +
	                           "style='width: 100%; height: 100%; top: 0;'>" +
	                        "<div class='k-loading-color'></div>" +
	                    "</div>")
	                    .appendTo(this.element);

	                var pb = $("<div class='k-loading-progress'>")
	                .appendTo(loading)
	                .kendoProgressBar({
	                    type: "chunk", chunkCount: 10,
	                    min: 0, max: 1, value: 0
	                }).data("kendoProgressBar");

	                deferred.progress(function(e) {
	                    pb.value(e.progress);
	                })
	                .always(function() {
	                    kendo.destroy(loading);
	                    loading.remove();
	                });
	            },

	            _workbookPdfExport: function(e) {
	                if (this.trigger("pdfExport", e)) {
	                    e.preventDefault();
	                }
	            },

	            _workbookInsertSheet: function(e) {
	                if (this.trigger("insertSheet", e)) {
	                    e.preventDefault();
	                }
	            },

	            _workbookRemoveSheet: function(e) {
	                if (this.trigger("removeSheet", e)) {
	                    e.preventDefault();
	                }
	            },

	            _workbookSelectSheet: function(e) {
	                if (this.trigger("selectSheet", e)) {
	                    e.preventDefault();
	                }
	            },

	            _workbookRenameSheet: function(e) {
	                if (this.trigger("renameSheet", e)) {
	                    e.preventDefault();
	                }
	            },

	            _workbookInsertRow: function(e) {
	                if (this.trigger("insertRow", e)) {
	                    e.preventDefault();
	                }
	            },

	            _workbookInsertColumn: function(e) {
	                if (this.trigger("insertColumn", e)) {
	                    e.preventDefault();
	                }
	            },

	            _workbookDeleteRow: function(e) {
	                if (this.trigger("deleteRow", e)) {
	                    e.preventDefault();
	                }
	            },

	            _workbookDeleteColumn: function(e) {
	                if (this.trigger("deleteColumn", e)) {
	                    e.preventDefault();
	                }
	            },

	            _workbookHideRow: function(e) {
	                if (this.trigger("hideRow", e)) {
	                    e.preventDefault();
	                }
	            },

	            _workbookHideColumn: function(e) {
	                if (this.trigger("hideColumn", e)) {
	                    e.preventDefault();
	                }
	            },

	            _workbookUnhideRow: function(e) {
	                if (this.trigger("unhideRow", e)) {
	                    e.preventDefault();
	                }
	            },

	            _workbookUnhideColumn: function(e) {
	                if (this.trigger("unhideColumn", e)) {
	                    e.preventDefault();
	                }
	            },

	            _workbookSelect: function(e) {
	                this.trigger("select", e);
	            },

	            _workbookChangeFormat: function(e) {
	               this.trigger("changeFormat", e);
	            },

	            _workbookDataBinding: function(e) {
	                if (this.trigger("dataBinding", e)) {
	                    e.preventDefault();
	                }
	            },

	            _workbookDataBound: function(e) {
	                this.trigger("dataBound", e);
	            },

	            _bindWorkbookEvents: function() {
	                this._workbook.bind("cut", this._workbookCut.bind(this));
	                this._workbook.bind("copy", this._workbookCopy.bind(this));
	                this._workbook.bind("paste", this._workbookPaste.bind(this));
	                this._workbook.bind("changing", this._workbookChanging.bind(this));
	                this._workbook.bind("change", this._workbookChange.bind(this));
	                this._workbook.bind("excelExport", this._workbookExcelExport.bind(this));
	                this._workbook.bind("excelImport", this._workbookExcelImport.bind(this));
	                this._workbook.bind("pdfExport", this._workbookPdfExport.bind(this));
	                this._workbook.bind("insertSheet", this._workbookInsertSheet.bind(this));
	                this._workbook.bind("removeSheet", this._workbookRemoveSheet.bind(this));
	                this._workbook.bind("selectSheet", this._workbookSelectSheet.bind(this));
	                this._workbook.bind("renameSheet", this._workbookRenameSheet.bind(this));
	                this._workbook.bind("insertRow", this._workbookInsertRow.bind(this));
	                this._workbook.bind("insertColumn", this._workbookInsertColumn.bind(this));
	                this._workbook.bind("deleteRow", this._workbookDeleteRow.bind(this));
	                this._workbook.bind("deleteColumn", this._workbookDeleteColumn.bind(this));
	                this._workbook.bind("hideRow", this._workbookHideRow.bind(this));
	                this._workbook.bind("hideColumn", this._workbookHideColumn.bind(this));
	                this._workbook.bind("unhideRow", this._workbookUnhideRow.bind(this));
	                this._workbook.bind("unhideColumn", this._workbookUnhideColumn.bind(this));
	                this._workbook.bind("select", this._workbookSelect.bind(this));
	                this._workbook.bind("changeFormat", this._workbookChangeFormat.bind(this));
	                this._workbook.bind("dataBinding", this._workbookDataBinding.bind(this));
	                this._workbook.bind("dataBound", this._workbookDataBound.bind(this));
	            },

	            destroy: function() {
	                kendo.ui.Widget.fn.destroy.call(this);

	                this._workbook.destroy();
	                this._controller.destroy();
	                this._view.destroy();

	                if (this._resizeHandler) {
	                    $(window).off("resize" + NS, this._resizeHandler);
	                }
	            },

	            options: {
	                name: "Spreadsheet",
	                toolbar: true,
	                sheetsbar: true,
	                rows: 200,
	                columns: 50,
	                rowHeight: 20,
	                columnWidth: 64,
	                headerHeight: 20,
	                headerWidth: 32,
	                excel: {
	                    proxyURL: "",
	                    fileName: "Workbook.xlsx"
	                },
	                messages: {},
	                pdf: {
	                    // which part of the workbook to be exported
	                    area      : "workbook",
	                    fileName  : "Workbook.pdf",
	                    proxyURL  : "",
	                    // paperSize can be an usual name, i.e. "A4", or an array of two Number-s specifying the
	                    // width/height in points (1pt = 1/72in), or strings including unit, i.e. "10mm".  Supported
	                    // units are "mm", "cm", "in" and "pt".  The default "auto" means paper size is determined
	                    // by content.
	                    paperSize : "a4",
	                    // True to reverse the paper dimensions if needed such that width is the larger edge.
	                    landscape : true,
	                    // An object containing { left, top, bottom, right } margins with units.
	                    margin    : null,
	                    // Optional information for the PDF Info dictionary; all strings except for the date.
	                    title     : null,
	                    author    : null,
	                    subject   : null,
	                    keywords  : null,
	                    creator   : "Kendo UI PDF Generator v." + kendo.version,
	                    // Creation Date; defaults to new Date()
	                    date      : null
	                },
	                defaultCellStyle: {
	                    fontFamily: "Arial",
	                    fontSize: 12
	                },
	                useCultureDecimals: false
	            },

	            defineName: function(name, value, hidden) {
	                return this._workbook.defineName(name, value, hidden);
	            },

	            undefineName: function(name) {
	                return this._workbook.undefineName(name);
	            },

	            nameValue: function(name) {
	                return this._workbook.nameValue(name);
	            },

	            forEachName: function(func) {
	                return this._workbook.forEachName(func);
	            },

	            cellContextMenu: function() {
	                return this._view.cellContextMenu;
	            },

	            rowHeaderContextMenu: function() {
	                return this._view.rowHeaderContextMenu;
	            },

	            colHeaderContextMenu: function() {
	                return this._view.colHeaderContextMenu;
	            },

	            addImage: function(image) {
	                return this._workbook.addImage(image);
	            },

	            cleanupImages: function() {
	                return this._workbook.cleanupImages();
	            },

	            events: [
	                "cut",
	                "copy",
	                "paste",
	                "pdfExport",
	                "excelExport",
	                "excelImport",
	                "changing",
	                "change",
	                "render",
	                "removeSheet",
	                "selectSheet",
	                "renameSheet",
	                "insertRow",
	                "insertColumn",
	                "deleteRow",
	                "insertSheet",
	                "deleteColumn",
	                "hideRow",
	                "hideColumn",
	                "unhideRow",
	                "unhideColumn",
	                "select",
	                "changeFormat",
	                "dataBinding",
	                "dataBound"
	            ]
	        });

	        kendo.spreadsheet.ALL_REASONS = ALL_REASONS;
	        kendo.ui.plugin(Spreadsheet);
	        $.extend(true, Spreadsheet, { classNames: classNames });
	    })(window.kendo);

	    return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1385:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("mn2W");

/***/ }),

/***/ 1386:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ZruT");

/***/ }),

/***/ 1387:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("OmDj");

/***/ }),

/***/ 1388:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("I3sU");

/***/ }),

/***/ 1389:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("hmKk");

/***/ }),

/***/ 1390:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("fNSn");

/***/ }),

/***/ 1391:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("zFpm");

/***/ }),

/***/ 1392:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("KVbc");

/***/ }),

/***/ 1393:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("tAgt");

/***/ }),

/***/ 1394:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7Ygf");

/***/ }),

/***/ 1395:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("4fFG");

/***/ }),

/***/ 1396:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Uo1E");

/***/ }),

/***/ 1397:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Xs6l");

/***/ }),

/***/ 1398:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("QbYn");

/***/ }),

/***/ 1399:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("+FHp");

/***/ }),

/***/ 1400:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("DfTB");

/***/ }),

/***/ 1401:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nky/");

/***/ }),

/***/ 1402:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("KK9P");

/***/ }),

/***/ 1403:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Zo25");

/***/ }),

/***/ 1404:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("DhwM");

/***/ }),

/***/ 1405:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("EFuj");

/***/ }),

/***/ 1406:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("TLGp");

/***/ }),

/***/ 1407:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CxVc");

/***/ }),

/***/ 1408:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("vAMl");

/***/ }),

/***/ 1409:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Oxt1");

/***/ }),

/***/ 1410:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("I2Wh");

/***/ }),

/***/ 1411:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("oTNd");

/***/ }),

/***/ 1412:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("yoqx");

/***/ }),

/***/ 1413:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("5MhB");

/***/ }),

/***/ 1414:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("dB3r");

/***/ }),

/***/ 1415:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("bWAB");

/***/ }),

/***/ 1416:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("bgyk");

/***/ }),

/***/ 1417:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("GGMy");

/***/ }),

/***/ 1418:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CLj3");

/***/ }),

/***/ 1419:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("6LjV");

/***/ }),

/***/ 1420:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("z7nc");

/***/ }),

/***/ 1421:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("kF9J");

/***/ }),

/***/ 1422:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MDpr");

/***/ })

/******/ });

/***/ }),

/***/ "HykO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ag_grid_1 = __webpack_require__("F6Mk");
var enterpriseBlock_1 = __webpack_require__("c4fk");
var EnterpriseCache = (function (_super) {
    __extends(EnterpriseCache, _super);
    function EnterpriseCache(cacheParams, parentRowNode) {
        var _this = _super.call(this, cacheParams) || this;
        // this will always be zero for the top level cache only,
        // all the other ones change as the groups open and close
        _this.displayIndexStart = 0;
        _this.displayIndexEnd = 0; // not sure if setting this one to zero is necessary
        _this.cacheTop = 0;
        _this.blockHeights = {};
        _this.parentRowNode = parentRowNode;
        return _this;
    }
    EnterpriseCache.prototype.setBeans = function (loggerFactory) {
        this.logger = loggerFactory.create('EnterpriseCache');
    };
    EnterpriseCache.prototype.init = function () {
        _super.prototype.init.call(this);
    };
    EnterpriseCache.prototype.getRowBounds = function (index) {
        var _this = this;
        this.logger.log("getRowBounds(" + index + ")");
        // we return null if row not found
        var result;
        var blockFound = false;
        var lastBlock;
        this.forEachBlockInOrder(function (block) {
            if (blockFound)
                return;
            if (block.isDisplayIndexInBlock(index)) {
                result = block.getRowBounds(index, _this.getVirtualRowCount());
                blockFound = true;
            }
            else if (block.isBlockBefore(index)) {
                lastBlock = block;
            }
        });
        if (!blockFound) {
            var nextRowTop = void 0;
            var nextRowIndex = void 0;
            if (lastBlock) {
                nextRowTop = lastBlock.getBlockTop() + lastBlock.getBlockHeight();
                nextRowIndex = lastBlock.getDisplayIndexEnd();
            }
            else {
                nextRowTop = this.cacheTop;
                nextRowIndex = this.displayIndexStart;
            }
            var rowsBetween = index - nextRowIndex;
            result = {
                rowHeight: this.cacheParams.rowHeight,
                rowTop: nextRowTop + rowsBetween * this.cacheParams.rowHeight
            };
        }
        //TODO: what about purged blocks
        this.logger.log("getRowBounds(" + index + "), result = " + result);
        return result;
    };
    EnterpriseCache.prototype.destroyBlock = function (block) {
        _super.prototype.destroyBlock.call(this, block);
    };
    EnterpriseCache.prototype.getRowIndexAtPixel = function (pixel) {
        var _this = this;
        this.logger.log("getRowIndexAtPixel(" + pixel + ")");
        // we return null if row not found
        var result;
        var blockFound = false;
        var lastBlock;
        this.forEachBlockInOrder(function (block) {
            if (blockFound)
                return;
            if (block.isPixelInRange(pixel)) {
                result = block.getRowIndexAtPixel(pixel, _this.getVirtualRowCount());
                blockFound = true;
            }
            else if (block.getBlockTop() > pixel) {
                lastBlock = block;
            }
        });
        if (!blockFound) {
            var nextRowTop = void 0;
            var nextRowIndex = void 0;
            if (lastBlock) {
                nextRowTop = lastBlock.getBlockTop() + lastBlock.getBlockHeight();
                nextRowIndex = lastBlock.getDisplayIndexEnd();
            }
            else {
                nextRowTop = this.cacheTop;
                nextRowIndex = this.displayIndexStart;
            }
            var pixelsBetween = pixel - nextRowTop;
            var rowsBetween = (pixelsBetween / this.cacheParams.rowHeight) | 0;
            result = nextRowIndex + rowsBetween;
        }
        var lastAllowedIndex = this.getDisplayIndexEnd() - 1;
        if (result > lastAllowedIndex) {
            result = lastAllowedIndex;
        }
        //TODO: purged
        this.logger.log("getRowIndexAtPixel(" + pixel + ") result = " + result);
        return result;
    };
    EnterpriseCache.prototype.clearRowTops = function () {
        var _this = this;
        this.forEachBlockInOrder(function (block) { return block.clearRowTops(_this.getVirtualRowCount()); });
    };
    EnterpriseCache.prototype.setDisplayIndexes = function (displayIndexSeq, nextRowTop) {
        var _this = this;
        this.displayIndexStart = displayIndexSeq.peek();
        this.cacheTop = nextRowTop.value;
        var lastBlockId = -1;
        this.forEachBlockInOrder(function (currentBlock, blockId) {
            // if we skipped blocks, then we need to skip the row indexes. we assume that all missing
            // blocks are made up of closed RowNodes only (if they were groups), as we never expire from
            // the cache if any row nodes are open.
            var blocksSkippedCount = blockId - lastBlockId - 1;
            var rowsSkippedCount = blocksSkippedCount * _this.cacheParams.blockSize;
            if (rowsSkippedCount > 0) {
                displayIndexSeq.skip(rowsSkippedCount);
            }
            for (var i = 1; i <= blocksSkippedCount; i++) {
                var blockToAddId = blockId - i;
                if (ag_grid_1._.exists(_this.blockHeights[blockToAddId])) {
                    nextRowTop.value += _this.blockHeights[blockToAddId];
                }
                else {
                    nextRowTop.value += _this.cacheParams.blockSize * _this.cacheParams.rowHeight;
                }
            }
            lastBlockId = blockId;
            currentBlock.setDisplayIndexes(displayIndexSeq, _this.getVirtualRowCount(), nextRowTop);
            _this.blockHeights[blockId] = currentBlock.getBlockHeight();
        });
        // if any blocks missing at the end, need to increase the row index for them also
        // eg if block size = 10, we have total rows of 25 (indexes 0 .. 24), but first 2 blocks loaded (because
        // last row was ejected from cache), then:
        // lastVisitedRow = 19, virtualRowCount = 25, rows not accounted for = 5 (24 - 19)
        var lastVisitedRow = ((lastBlockId + 1) * this.cacheParams.blockSize) - 1;
        var rowCount = this.getVirtualRowCount();
        var rowsNotAccountedFor = rowCount - lastVisitedRow - 1;
        if (rowsNotAccountedFor > 0) {
            displayIndexSeq.skip(rowsNotAccountedFor);
            nextRowTop.value += rowsNotAccountedFor * this.cacheParams.rowHeight;
        }
        this.displayIndexEnd = displayIndexSeq.peek();
        this.cacheHeight = nextRowTop.value - this.cacheTop;
    };
    // gets called in a) init() above and b) by the grid
    EnterpriseCache.prototype.getRow = function (displayRowIndex) {
        var _this = this;
        // this can happen if asking for a row that doesn't exist in the model,
        // eg if a cell range is selected, and the user filters so rows no longer
        // exist
        if (!this.isDisplayIndexInCache(displayRowIndex)) {
            return null;
        }
        // if we have the block, then this is the block
        var block = null;
        // this is the last block that we have BEFORE the right block
        var beforeBlock = null;
        this.forEachBlockInOrder(function (currentBlock) {
            if (currentBlock.isDisplayIndexInBlock(displayRowIndex)) {
                block = currentBlock;
            }
            else if (currentBlock.isBlockBefore(displayRowIndex)) {
                // this will get assigned many times, but the last time will
                // be the closest block to the required block that is BEFORE
                beforeBlock = currentBlock;
            }
        });
        // if block not found, we need to load it
        if (ag_grid_1._.missing(block)) {
            var blockNumber = void 0;
            var displayIndexStart_1;
            var nextRowTop = void 0;
            // because missing blocks are always fully closed, we can work out
            // the start index of the block we want by hopping from the closest block,
            // as we know the row count in closed blocks is equal to the page size
            if (beforeBlock) {
                blockNumber = beforeBlock.getBlockNumber() + 1;
                displayIndexStart_1 = beforeBlock.getDisplayIndexEnd();
                nextRowTop = beforeBlock.getBlockHeight() + beforeBlock.getBlockTop();
                var isInRange = function () {
                    return displayRowIndex >= displayIndexStart_1 && displayRowIndex < (displayIndexStart_1 + _this.cacheParams.blockSize);
                };
                while (!isInRange()) {
                    displayIndexStart_1 += this.cacheParams.blockSize;
                    var cachedBlockHeight = this.blockHeights[blockNumber];
                    if (ag_grid_1._.exists(cachedBlockHeight)) {
                        nextRowTop += cachedBlockHeight;
                    }
                    else {
                        nextRowTop += this.cacheParams.rowHeight * this.cacheParams.blockSize;
                    }
                    blockNumber++;
                }
            }
            else {
                var localIndex = displayRowIndex - this.displayIndexStart;
                blockNumber = Math.floor(localIndex / this.cacheParams.blockSize);
                displayIndexStart_1 = this.displayIndexStart + (blockNumber * this.cacheParams.blockSize);
                nextRowTop = this.cacheTop + (blockNumber * this.cacheParams.blockSize * this.cacheParams.rowHeight);
            }
            block = this.createBlock(blockNumber, displayIndexStart_1, { value: nextRowTop });
            this.logger.log("block missing, rowIndex = " + displayRowIndex + ", creating #" + blockNumber + ", displayIndexStart = " + displayIndexStart_1);
        }
        var rowNode = block.getRow(displayRowIndex);
        return rowNode;
    };
    EnterpriseCache.prototype.createBlock = function (blockNumber, displayIndex, nextRowTop) {
        var newBlock = new enterpriseBlock_1.EnterpriseBlock(blockNumber, this.parentRowNode, this.cacheParams, this);
        this.context.wireBean(newBlock);
        var displayIndexSequence = new ag_grid_1.NumberSequence(displayIndex);
        newBlock.setDisplayIndexes(displayIndexSequence, this.getVirtualRowCount(), nextRowTop);
        this.postCreateBlock(newBlock);
        return newBlock;
    };
    EnterpriseCache.prototype.getDisplayIndexEnd = function () {
        return this.displayIndexEnd;
    };
    EnterpriseCache.prototype.isDisplayIndexInCache = function (displayIndex) {
        if (this.getVirtualRowCount() === 0) {
            return false;
        }
        return displayIndex >= this.displayIndexStart && displayIndex < this.displayIndexEnd;
    };
    EnterpriseCache.prototype.getChildCache = function (keys) {
        var _this = this;
        if (ag_grid_1._.missingOrEmpty(keys)) {
            return this;
        }
        var nextKey = keys[0];
        var nextEnterpriseCache = null;
        this.forEachBlockInOrder(function (block) {
            // callback: (rowNode: RowNode, index: number) => void, sequence: NumberSequence, rowCount: number
            block.forEachNodeShallow(function (rowNode) {
                if (rowNode.key === nextKey) {
                    nextEnterpriseCache = rowNode.childrenCache;
                }
            }, new ag_grid_1.NumberSequence(), _this.getVirtualRowCount());
        });
        if (nextEnterpriseCache) {
            var keyListForNextLevel = keys.slice(1, keys.length);
            return nextEnterpriseCache.getChildCache(keyListForNextLevel);
        }
        else {
            return null;
        }
    };
    EnterpriseCache.prototype.isPixelInRange = function (pixel) {
        if (this.getVirtualRowCount() === 0) {
            return false;
        }
        return pixel >= this.cacheTop && pixel < (this.cacheTop + this.cacheHeight);
    };
    __decorate([
        ag_grid_1.Autowired('eventService'),
        __metadata("design:type", ag_grid_1.EventService)
    ], EnterpriseCache.prototype, "eventService", void 0);
    __decorate([
        ag_grid_1.Autowired('context'),
        __metadata("design:type", ag_grid_1.Context)
    ], EnterpriseCache.prototype, "context", void 0);
    __decorate([
        __param(0, ag_grid_1.Qualifier('loggerFactory')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ag_grid_1.LoggerFactory]),
        __metadata("design:returntype", void 0)
    ], EnterpriseCache.prototype, "setBeans", null);
    __decorate([
        ag_grid_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], EnterpriseCache.prototype, "init", null);
    return EnterpriseCache;
}(ag_grid_1.RowNodeCache));
exports.EnterpriseCache = EnterpriseCache;


/***/ }),

/***/ "I/uN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = __webpack_require__("U9Xd");
var context_1 = __webpack_require__("RQ1/");
var utils_1 = __webpack_require__("IRr6");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var dragService_1 = __webpack_require__("ytBa");
var columnController_1 = __webpack_require__("77lH");
var environment_1 = __webpack_require__("JLYF");
var DragSourceType;
(function (DragSourceType) {
    DragSourceType[DragSourceType["ToolPanel"] = 0] = "ToolPanel";
    DragSourceType[DragSourceType["HeaderCell"] = 1] = "HeaderCell";
    DragSourceType[DragSourceType["RowDrag"] = 2] = "RowDrag";
})(DragSourceType = exports.DragSourceType || (exports.DragSourceType = {}));
var VDirection;
(function (VDirection) {
    VDirection[VDirection["Up"] = 0] = "Up";
    VDirection[VDirection["Down"] = 1] = "Down";
})(VDirection = exports.VDirection || (exports.VDirection = {}));
var HDirection;
(function (HDirection) {
    HDirection[HDirection["Left"] = 0] = "Left";
    HDirection[HDirection["Right"] = 1] = "Right";
})(HDirection = exports.HDirection || (exports.HDirection = {}));
var DragAndDropService = (function () {
    function DragAndDropService() {
        this.dragSourceAndParamsList = [];
        this.dropTargets = [];
    }
    DragAndDropService_1 = DragAndDropService;
    DragAndDropService.prototype.init = function () {
        this.ePinnedIcon = utils_1.Utils.createIcon('columnMovePin', this.gridOptionsWrapper, null);
        this.ePlusIcon = utils_1.Utils.createIcon('columnMoveAdd', this.gridOptionsWrapper, null);
        this.eHiddenIcon = utils_1.Utils.createIcon('columnMoveHide', this.gridOptionsWrapper, null);
        this.eMoveIcon = utils_1.Utils.createIcon('columnMoveMove', this.gridOptionsWrapper, null);
        this.eLeftIcon = utils_1.Utils.createIcon('columnMoveLeft', this.gridOptionsWrapper, null);
        this.eRightIcon = utils_1.Utils.createIcon('columnMoveRight', this.gridOptionsWrapper, null);
        this.eGroupIcon = utils_1.Utils.createIcon('columnMoveGroup', this.gridOptionsWrapper, null);
        this.eAggregateIcon = utils_1.Utils.createIcon('columnMoveValue', this.gridOptionsWrapper, null);
        this.ePivotIcon = utils_1.Utils.createIcon('columnMovePivot', this.gridOptionsWrapper, null);
        this.eDropNotAllowedIcon = utils_1.Utils.createIcon('dropNotAllowed', this.gridOptionsWrapper, null);
    };
    DragAndDropService.prototype.setBeans = function (loggerFactory) {
        this.logger = loggerFactory.create('OldToolPanelDragAndDropService');
    };
    DragAndDropService.prototype.getStringType = function (type) {
        switch (type) {
            case DragSourceType.RowDrag: return 'row';
            case DragSourceType.HeaderCell: return 'headerCell';
            case DragSourceType.ToolPanel: return 'toolPanel';
            default:
                console.warn("ag-Grid: bug - unknown drag type " + type);
                return null;
        }
    };
    DragAndDropService.prototype.addDragSource = function (dragSource, allowTouch) {
        if (allowTouch === void 0) { allowTouch = false; }
        var params = {
            type: this.getStringType(dragSource.type),
            eElement: dragSource.eElement,
            dragStartPixels: dragSource.dragStartPixels,
            onDragStart: this.onDragStart.bind(this, dragSource),
            onDragStop: this.onDragStop.bind(this),
            onDragging: this.onDragging.bind(this)
        };
        this.dragSourceAndParamsList.push({ params: params, dragSource: dragSource });
        this.dragService.addDragSource(params, allowTouch);
    };
    DragAndDropService.prototype.removeDragSource = function (dragSource) {
        var sourceAndParams = utils_1.Utils.find(this.dragSourceAndParamsList, function (item) { return item.dragSource === dragSource; });
        if (sourceAndParams) {
            this.dragService.removeDragSource(sourceAndParams.params);
            utils_1.Utils.removeFromArray(this.dragSourceAndParamsList, sourceAndParams);
        }
    };
    DragAndDropService.prototype.destroy = function () {
        var _this = this;
        this.dragSourceAndParamsList.forEach(function (sourceAndParams) {
            _this.dragService.removeDragSource(sourceAndParams.params);
        });
        this.dragSourceAndParamsList.length = 0;
    };
    DragAndDropService.prototype.nudge = function () {
        if (this.dragging) {
            this.onDragging(this.eventLastTime, true);
        }
    };
    DragAndDropService.prototype.onDragStart = function (dragSource, mouseEvent) {
        this.dragging = true;
        this.dragSource = dragSource;
        this.eventLastTime = mouseEvent;
        this.dragItem = this.dragSource.dragItemCallback();
        this.lastDropTarget = this.dragSource.dragSourceDropTarget;
        if (this.dragSource.dragStarted) {
            this.dragSource.dragStarted();
        }
        this.createGhost();
    };
    DragAndDropService.prototype.onDragStop = function (mouseEvent) {
        this.eventLastTime = null;
        this.dragging = false;
        if (this.dragSource.dragStopped) {
            this.dragSource.dragStopped();
        }
        if (this.lastDropTarget && this.lastDropTarget.onDragStop) {
            var draggingEvent = this.createDropTargetEvent(this.lastDropTarget, mouseEvent, null, null, false);
            this.lastDropTarget.onDragStop(draggingEvent);
        }
        this.lastDropTarget = null;
        this.dragItem = null;
        this.removeGhost();
    };
    DragAndDropService.prototype.onDragging = function (mouseEvent, fromNudge) {
        var hDirection = this.workOutHDirection(mouseEvent);
        var vDirection = this.workOutVDirection(mouseEvent);
        this.eventLastTime = mouseEvent;
        this.positionGhost(mouseEvent);
        // check if mouseEvent intersects with any of the drop targets
        var dropTarget = utils_1.Utils.find(this.dropTargets, this.isMouseOnDropTarget.bind(this, mouseEvent));
        if (dropTarget !== this.lastDropTarget) {
            this.leaveLastTargetIfExists(mouseEvent, hDirection, vDirection, fromNudge);
            this.enterDragTargetIfExists(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            this.lastDropTarget = dropTarget;
        }
        else if (dropTarget) {
            var draggingEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            dropTarget.onDragging(draggingEvent);
        }
    };
    DragAndDropService.prototype.enterDragTargetIfExists = function (dropTarget, mouseEvent, hDirection, vDirection, fromNudge) {
        if (!dropTarget) {
            return;
        }
        var dragEnterEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
        dropTarget.onDragEnter(dragEnterEvent);
        this.setGhostIcon(dropTarget.getIconName ? dropTarget.getIconName() : null);
    };
    DragAndDropService.prototype.leaveLastTargetIfExists = function (mouseEvent, hDirection, vDirection, fromNudge) {
        if (!this.lastDropTarget) {
            return;
        }
        var dragLeaveEvent = this.createDropTargetEvent(this.lastDropTarget, mouseEvent, hDirection, vDirection, fromNudge);
        this.lastDropTarget.onDragLeave(dragLeaveEvent);
        this.setGhostIcon(null);
    };
    DragAndDropService.prototype.getAllContainersFromDropTarget = function (dropTarget) {
        var containers = [dropTarget.getContainer()];
        var secondaryContainers = dropTarget.getSecondaryContainers ? dropTarget.getSecondaryContainers() : null;
        if (secondaryContainers) {
            containers = containers.concat(secondaryContainers);
        }
        return containers;
    };
    // checks if the mouse is on the drop target. it checks eContainer and eSecondaryContainers
    DragAndDropService.prototype.isMouseOnDropTarget = function (mouseEvent, dropTarget) {
        var allContainers = this.getAllContainersFromDropTarget(dropTarget);
        var mouseOverTarget = false;
        allContainers.forEach(function (eContainer) {
            if (!eContainer) {
                return;
            } // secondary can be missing
            var rect = eContainer.getBoundingClientRect();
            // if element is not visible, then width and height are zero
            if (rect.width === 0 || rect.height === 0) {
                return;
            }
            var horizontalFit = mouseEvent.clientX >= rect.left && mouseEvent.clientX <= rect.right;
            var verticalFit = mouseEvent.clientY >= rect.top && mouseEvent.clientY <= rect.bottom;
            //console.log(`rect.width = ${rect.width} || rect.height = ${rect.height} ## verticalFit = ${verticalFit}, horizontalFit = ${horizontalFit}, `);
            if (horizontalFit && verticalFit) {
                mouseOverTarget = true;
            }
        });
        if (mouseOverTarget) {
            var mouseOverTargetAndInterested = dropTarget.isInterestedIn(this.dragSource.type);
            return mouseOverTargetAndInterested;
        }
        else {
            return false;
        }
    };
    DragAndDropService.prototype.addDropTarget = function (dropTarget) {
        this.dropTargets.push(dropTarget);
    };
    DragAndDropService.prototype.workOutHDirection = function (event) {
        if (this.eventLastTime.clientX > event.clientX) {
            return HDirection.Left;
        }
        else if (this.eventLastTime.clientX < event.clientX) {
            return HDirection.Right;
        }
        else {
            return null;
        }
    };
    DragAndDropService.prototype.workOutVDirection = function (event) {
        if (this.eventLastTime.clientY > event.clientY) {
            return VDirection.Up;
        }
        else if (this.eventLastTime.clientY < event.clientY) {
            return VDirection.Down;
        }
        else {
            return null;
        }
    };
    DragAndDropService.prototype.createDropTargetEvent = function (dropTarget, event, hDirection, vDirection, fromNudge) {
        // localise x and y to the target component
        var rect = dropTarget.getContainer().getBoundingClientRect();
        var x = event.clientX - rect.left;
        var y = event.clientY - rect.top;
        var dropTargetEvent = {
            event: event,
            x: x,
            y: y,
            vDirection: vDirection,
            hDirection: hDirection,
            dragSource: this.dragSource,
            fromNudge: fromNudge,
            dragItem: this.dragItem
        };
        return dropTargetEvent;
    };
    DragAndDropService.prototype.positionGhost = function (event) {
        var ghostRect = this.eGhost.getBoundingClientRect();
        var ghostHeight = ghostRect.height;
        // for some reason, without the '-2', it still overlapped by 1 or 2 pixels, which
        // then brought in scrollbars to the browser. no idea why, but putting in -2 here
        // works around it which is good enough for me.
        var browserWidth = utils_1.Utils.getBodyWidth() - 2;
        var browserHeight = utils_1.Utils.getBodyHeight() - 2;
        // put ghost vertically in middle of cursor
        var top = event.pageY - (ghostHeight / 2);
        // horizontally, place cursor just right of icon
        var left = event.pageX - 30;
        var usrDocument = this.gridOptionsWrapper.getDocument();
        var windowScrollY = window.pageYOffset || usrDocument.documentElement.scrollTop;
        var windowScrollX = window.pageXOffset || usrDocument.documentElement.scrollLeft;
        // check ghost is not positioned outside of the browser
        if (browserWidth > 0) {
            if ((left + this.eGhost.clientWidth) > (browserWidth + windowScrollX)) {
                left = browserWidth + windowScrollX - this.eGhost.clientWidth;
            }
        }
        if (left < 0) {
            left = 0;
        }
        if (browserHeight > 0) {
            if ((top + this.eGhost.clientHeight) > (browserHeight + windowScrollY)) {
                top = browserHeight + windowScrollY - this.eGhost.clientHeight;
            }
        }
        if (top < 0) {
            top = 0;
        }
        this.eGhost.style.left = left + 'px';
        this.eGhost.style.top = top + 'px';
    };
    DragAndDropService.prototype.removeGhost = function () {
        if (this.eGhost && this.eGhostParent) {
            this.eGhostParent.removeChild(this.eGhost);
        }
        this.eGhost = null;
    };
    DragAndDropService.prototype.createGhost = function () {
        this.eGhost = utils_1.Utils.loadTemplate(DragAndDropService_1.GHOST_TEMPLATE);
        utils_1.Utils.addCssClass(this.eGhost, this.environment.getTheme());
        this.eGhostIcon = this.eGhost.querySelector('.ag-dnd-ghost-icon');
        this.setGhostIcon(null);
        var eText = this.eGhost.querySelector('.ag-dnd-ghost-label');
        eText.innerHTML = this.dragSource.dragItemName;
        this.eGhost.style.height = '25px';
        this.eGhost.style.top = '20px';
        this.eGhost.style.left = '20px';
        var usrDocument = this.gridOptionsWrapper.getDocument();
        this.eGhostParent = usrDocument.querySelector('body');
        if (!this.eGhostParent) {
            console.warn('ag-Grid: could not find document body, it is needed for dragging columns');
        }
        else {
            this.eGhostParent.appendChild(this.eGhost);
        }
    };
    DragAndDropService.prototype.setGhostIcon = function (iconName, shake) {
        if (shake === void 0) { shake = false; }
        utils_1.Utils.removeAllChildren(this.eGhostIcon);
        var eIcon;
        switch (iconName) {
            case DragAndDropService_1.ICON_ADD:
                eIcon = this.ePlusIcon;
                break;
            case DragAndDropService_1.ICON_PINNED:
                eIcon = this.ePinnedIcon;
                break;
            case DragAndDropService_1.ICON_MOVE:
                eIcon = this.eMoveIcon;
                break;
            case DragAndDropService_1.ICON_LEFT:
                eIcon = this.eLeftIcon;
                break;
            case DragAndDropService_1.ICON_RIGHT:
                eIcon = this.eRightIcon;
                break;
            case DragAndDropService_1.ICON_GROUP:
                eIcon = this.eGroupIcon;
                break;
            case DragAndDropService_1.ICON_AGGREGATE:
                eIcon = this.eAggregateIcon;
                break;
            case DragAndDropService_1.ICON_PIVOT:
                eIcon = this.ePivotIcon;
                break;
            case DragAndDropService_1.ICON_NOT_ALLOWED:
                eIcon = this.eDropNotAllowedIcon;
                break;
            default:
                eIcon = this.eHiddenIcon;
                break;
        }
        this.eGhostIcon.appendChild(eIcon);
        utils_1.Utils.addOrRemoveCssClass(this.eGhostIcon, 'ag-shake-left-to-right', shake);
    };
    DragAndDropService.ICON_PINNED = 'pinned';
    DragAndDropService.ICON_ADD = 'add';
    DragAndDropService.ICON_MOVE = 'move';
    DragAndDropService.ICON_LEFT = 'left';
    DragAndDropService.ICON_RIGHT = 'right';
    DragAndDropService.ICON_GROUP = 'group';
    DragAndDropService.ICON_AGGREGATE = 'aggregate';
    DragAndDropService.ICON_PIVOT = 'pivot';
    DragAndDropService.ICON_NOT_ALLOWED = 'notAllowed';
    DragAndDropService.GHOST_TEMPLATE = '<div class="ag-dnd-ghost">' +
        '  <span class="ag-dnd-ghost-icon ag-shake-left-to-right"></span>' +
        '  <div class="ag-dnd-ghost-label">' +
        '  </div>' +
        '</div>';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], DragAndDropService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('dragService'),
        __metadata("design:type", dragService_1.DragService)
    ], DragAndDropService.prototype, "dragService", void 0);
    __decorate([
        context_1.Autowired('environment'),
        __metadata("design:type", environment_1.Environment)
    ], DragAndDropService.prototype, "environment", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], DragAndDropService.prototype, "columnController", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DragAndDropService.prototype, "init", null);
    __decorate([
        __param(0, context_1.Qualifier('loggerFactory')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
        __metadata("design:returntype", void 0)
    ], DragAndDropService.prototype, "setBeans", null);
    __decorate([
        context_1.PreDestroy,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DragAndDropService.prototype, "destroy", null);
    DragAndDropService = DragAndDropService_1 = __decorate([
        context_1.Bean('dragAndDropService')
    ], DragAndDropService);
    return DragAndDropService;
    var DragAndDropService_1;
}());
exports.DragAndDropService = DragAndDropService;


/***/ }),

/***/ "I2Wh":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1620);
	module.exports = __webpack_require__(1620);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1606:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7Ygf");

/***/ }),

/***/ 1620:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// -*- fill-column: 100 -*-

	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1606) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	    "use strict";

	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    // WARNING: removing the following jshint declaration and turning
	    // == into === to make JSHint happy will break functionality.
	    /* jshint eqnull:true, newcap:false, laxbreak:true, shadow:true, validthis:true, -W054, loopfunc: true */
	    /* global console */
	    /* jshint latedef: nofunc */

	    var calc = {};
	    var spreadsheet = kendo.spreadsheet;
	    spreadsheet.calc = calc;
	    var exports = calc.runtime = {};
	    var Class = kendo.Class;

	    var Ref = spreadsheet.Ref;
	    var CellRef = spreadsheet.CellRef;
	    var RangeRef = spreadsheet.RangeRef;
	    var UnionRef = spreadsheet.UnionRef;
	    var NULL = spreadsheet.NULLREF;

	    /* -----[ Errors ]----- */

	    function CalcError(code) {
	        if (code instanceof CalcError) {
	            return code;
	        }
	        this.code = code;
	    }

	    CalcError.prototype.toString = function() {
	        return "#" + this.code + (this.code == "NAME" ? "?" : "!");
	    };

	    /* -----[ Context ]----- */

	    var Context = Class.extend({
	        init: function Context(callback, formula, ss, parent) {
	            this.callback = callback;
	            this.formula = formula;
	            this.ss = ss;
	            this.parent = parent;
	        },

	        resolve: function(val) {
	            var self = this;
	            if (val instanceof Ref) {
	                self.resolveCells([ val ], function(){
	                    self._resolve(val);
	                });
	            } else {
	                self._resolve(val);
	            }
	        },

	        error: function(val) {
	            return new CalcError(val);
	        },

	        _resolve: function(val) {
	            if (val === undefined) {
	                val = null;
	            } else if (Array.isArray(val)) {
	                val = this.asMatrix(val);
	            } else {
	                val = maybeRoundFloatErrors(val);
	            }
	            var f = this.formula;
	            if (f.arrayFormulaRange) {
	                // when this is an array formula, make sure we return a Matrix.  The value already
	                // *should* be a Matrix, so this won't incur speed penalty in normal cases.
	                val = this.asMatrix(val) || this.asMatrix([[ val ]]);
	            } else if (val instanceof RangeRef) {
	                val = this._arrayArg(val);
	            }
	            f.value = val;
	            if (this.ss.onFormula(f) && this.callback) {
	                this.callback.call(f, val);
	            }
	        },

	        resolveCells: function(a, f) {
	            var context = this, formulas = [];

	            (function loop(a){
	                for (var i = 0; i < a.length; ++i) {
	                    var x = a[i];
	                    if (x instanceof Ref) {
	                        add(context.getRefCells(x));
	                    }
	                    if (Array.isArray(x)) {
	                        // make sure we resolve cells in literal matrices
	                        loop(x);
	                    }
	                }
	            })(a);

	            if (!formulas.length) {
	                return f.call(context);
	            }

	            for (var pending = formulas.length, i = 0; i < formulas.length; ++i) {
	                fetch(formulas[i]);
	            }
	            function fetch(formula) { // jshint ignore:line, because you are stupid.
	                formula.exec(context.ss, function(){
	                    if (!--pending) {
	                        f.call(context);
	                    }
	                }, context);
	            }
	            function add(a) {
	                for (var i = 0; i < a.length; ++i) {
	                    var cell = a[i];
	                    if (cell.formula) {
	                        formulas.push(cell.formula);
	                    }
	                }
	                return true;
	            }
	        },

	        cellValues: function(a, wantNulls) {
	            var ret = [];
	            for (var i = 0; i < a.length; ++i) {
	                var val = a[i];
	                if (val instanceof Ref) {
	                    val = this.getRefData(val, wantNulls);
	                    ret = ret.concat(val);
	                } else if (Array.isArray(val)) {
	                    ret = ret.concat(this.cellValues(val, wantNulls));
	                } else if (val instanceof Matrix) {
	                    ret = ret.concat(this.cellValues(val.data, wantNulls));
	                } else {
	                    ret.push(val);
	                }
	            }
	            return ret;
	        },

	        fetchName: function(ref, callback) {
	            var f = this.formula;
	            var val = this.ss.nameValue(ref, f.sheet, f.row, f.col);
	            if (val instanceof Formula) {
	                // clone and relocate to calling formula, so that relative references in a named
	                // formula would work as expected.
	                val = val.clone(f.sheet, f.row, f.col, true);

	                // XXX: I don't like this dependency here; basically we only need ss.onFormula to
	                // return true and do nothing else.
	                var ss = new spreadsheet.ValidationFormulaContext(this.ss.workbook);

	                val.exec(ss, callback, this);
	            } else {
	                if (val instanceof Ref) {
	                    // relocate for relative refs
	                    val = val.absolute(f.row, f.col);
	                    if (!val.sheet) {
	                        val.sheet = f.sheet;
	                    }
	                }
	                callback(val == null ? new CalcError("NAME") : val);
	            }
	        },

	        force: function(val) {
	            if (val instanceof Ref) {
	                return this.getRefData(val);
	            }
	            return val;
	        },

	        func: function(fname, callback, args) {
	            fname = fname.toLowerCase();
	            var f = FUNCS[fname];
	            if (f) {
	                return f.call(this, callback, args);
	            }
	            callback(new CalcError("NAME"));
	        },

	        bool: function(val) {
	            if (val instanceof Ref) {
	                val = this.getRefData(val);
	            }
	            if (typeof val == "string") {
	                return val.toLowerCase() == "true";
	            }
	            if (typeof val == "number") {
	                return val !== 0;
	            }
	            if (typeof val == "boolean") {
	                return val;
	            }
	            return val != null;
	        },

	        _arrayArg: function(ref) { // not necessarily a reference though
	            var f = this.formula;
	            if (!f.arrayFormulaRange && ref instanceof RangeRef) {
	                // if formula wasn't saved with Ctrl-Shift-Enter but a range is passed, Excel does
	                // something special:
	                //
	                // - if range is Wx1 (horizontal array) and current formula resides within the
	                //   horizontal bounds of the range, the appropriate cell is selected.  Example:
	                //   A1..D1 contain 1, 2, 3, 4 and we have in B2: =A1:D1, then B2 will get 2 (the
	                //   value in A2).  If the same formula is typed outside the horizontal span of the
	                //   range, say in E2: =A1:D1, then #VALUE! is returned.
	                //
	                // - similarly, if the range is 1xH (vertical array), the formula must reside within
	                //   the vertical bounds of the range and it gets the corresponding cell; otherwise,
	                //   #VALUE!.
	                if (ref.height() == 1 && f.col >= ref.topLeft.col && f.col <= ref.bottomRight.col) {
	                    return this.getRefData(new CellRef(ref.topLeft.row, f.col).setSheet(ref.sheet));
	                }
	                if (ref.width() == 1 && f.row >= ref.topLeft.row && f.row <= ref.bottomRight.row) {
	                    return this.getRefData(new CellRef(f.row, ref.topLeft.col).setSheet(ref.sheet));
	                }
	                return new CalcError("VALUE");
	            } else {
	                return this.asMatrix(ref);
	            }
	        },

	        asMatrix: function(range) {
	            if (range instanceof Matrix) {
	                return range;
	            }
	            var self = this;
	            if (range instanceof RangeRef) {
	                var tl = range.topLeft;
	                var top = tl.row, left = tl.col;
	                var cells = self.getRefCells(range);
	                var m = new Matrix(self);
	                if (isFinite(range.width())) {
	                    m.width = range.width();
	                }
	                if (isFinite(range.height())) {
	                    m.height = range.height();
	                }
	                if (!isFinite(top)) {
	                    top = 0;
	                }
	                if (!isFinite(left)) {
	                    left = 0;
	                }
	                cells.forEach(function(cell){
	                    m.set(cell.row - top,
	                          cell.col - left,
	                          cell.value);
	                });
	                return m;
	            }
	            if (Array.isArray(range) && range.length > 0) {
	                var m = new Matrix(self), row = 0;
	                range.forEach(function(line){
	                    var col = 0;
	                    var h = 1;
	                    line.forEach(function(el){
	                        var isRange = el instanceof RangeRef;
	                        if (el instanceof Ref && !isRange) {
	                            el = self.getRefData(el);
	                        }
	                        if (isRange || Array.isArray(el)) {
	                            el = self.asMatrix(el);
	                        }
	                        if (el instanceof Matrix) {
	                            el.each(function(el, r, c){
	                                m.set(row + r, col + c, el);
	                            });
	                            h = Math.max(h, el.height);
	                            col += el.width;
	                        } else {
	                            if(typeof el === "string" && el.length && !isNaN(el)) {
	                                el = Number(el);
	                            }

	                            m.set(row, col++, el);
	                        }
	                    });
	                    row += h;
	                });
	                return m;
	            }
	        },

	        getRefCells: function(refs, hiddenInfo, wantNulls) {
	            var f = this.formula;
	            return this.ss.getRefCells(refs, hiddenInfo, f.sheet, f.row, f.col, wantNulls);
	        },

	        getRefData: function(ref, wantNulls) {
	            var f = this.formula;
	            return this.ss.getData(ref, f.sheet, f.row, f.col, wantNulls);
	        },

	        workbook: function() {
	            return this.ss.workbook;
	        }
	    });

	    var Matrix = Class.extend({
	        init: function Matrix(context) {
	            this.context = context;
	            this.height = 0;
	            this.width = 0;
	            this.data = [];
	        },
	        clone: function() {
	            var m = new Matrix(this.context);
	            m.height = this.height;
	            m.width = this.width;
	            m.data = this.data.map(function(row){ return row.slice(); });
	            return m;
	        },
	        get: function(row, col) {
	            var line = this.data[row];
	            var val = line ? line[col] : null;
	            return val instanceof Ref ? this.context.getRefData(val) : val;
	        },
	        getNA: function(row, col) {
	            if (row < this.height && col < this.width) {
	                return this.get(row, col);
	            }
	            return new CalcError("N/A");
	        },
	        set: function(row, col, data) {
	            var line = this.data[row];
	            if (line == null) {
	                line = this.data[row] = [];
	            }
	            line[col] = data;
	            if (row >= this.height) {
	                this.height = row + 1;
	            }
	            if (col >= this.width) {
	                this.width = col + 1;
	            }
	        },
	        each: function(f, includeEmpty) {
	            for (var row = 0; row < this.height; ++row) {
	                for (var col = 0; col < this.width; ++col) {
	                    var val = this.get(row, col);
	                    if (includeEmpty || val != null) {
	                        val = f.call(this.context, val, row, col);
	                        if (val !== undefined) {
	                            return val;
	                        }
	                    }
	                }
	            }
	        },
	        map: function(f, includeEmpty) {
	            var m = new Matrix(this.context);
	            this.each(function(el, row, col){
	                // here `this` is actually the context
	                m.set(row, col, f.call(this, el, row, col));
	            }, includeEmpty);
	            return m;
	        },
	        eachRow: function(f) {
	            for (var row = 0; row < this.height; ++row) {
	                var val = f.call(this.context, row);
	                if (val !== undefined) {
	                    return val;
	                }
	            }
	        },
	        eachCol: function(f) {
	            for (var col = 0; col < this.width; ++col) {
	                var val = f.call(this.context, col);
	                if (val !== undefined) {
	                    return val;
	                }
	            }
	        },
	        mapRow: function(f) {
	            var m = new Matrix(this.context);
	            this.eachRow(function(row){
	                m.set(row, 0, f.call(this.context, row));
	            });
	            return m;
	        },
	        mapCol: function(f) {
	            var m = new Matrix(this.context);
	            this.eachCol(function(col){
	                m.set(0, col, f.call(this.context, col));
	            });
	            return m;
	        },
	        toString: function() {
	            return JSON.stringify(this.data);
	        },
	        transpose: function() {
	            var m = new Matrix(this.context);
	            this.each(function(el, row, col){
	                m.set(col, row, el);
	            });
	            return m;
	        },
	        unit: function(n) {
	            this.width = this.height = n;
	            var a = this.data = new Array(n);
	            for (var i = n; --i >= 0;) {
	                var row = a[i] = new Array(n);
	                for (var j = n; --j >= 0;) {
	                    row[j] = i == j ? 1 : 0;
	                }
	            }
	            return this;
	        },
	        multiply: function(b) {
	            var a = this, m = new Matrix(a.context);
	            for (var row = 0; row < a.height; ++row) {
	                for (var col = 0; col < b.width; ++col) {
	                    var s = 0;
	                    for (var i = 0; i < a.width; ++i) {
	                        var va = a.get(row, i);
	                        var vb = b.get(i, col);
	                        if (typeof va != "number" || typeof vb != "number") {
	                            throw new CalcError("VALUE");
	                        }
	                        s += va * vb;
	                    }
	                    m.set(row, col, s);
	                }
	            }
	            return m;
	        },
	        adds: function(b, s) {
	            var a = this, m = new Matrix(a.context);
	            var sign = s ? -1 : 1;
	            for (var row = 0; row < a.height; ++row) {
	                for (var col = 0; col < a.width; ++col) {
	                    var x = a.get(row, col),
	                        y = b.get(row, col);
	                    m.set(row, col, x + sign * y);
	                }
	            }
	            return m;
	        },
	        determinant: function() {
	            var a = this.clone().data;
	            var n = a.length;
	            var d = 1, C, L, i, k;
	            for (C = 0; C < n; C++) {
	                for (L = C; (L < n) && (!a[L][C]); L++) {}
	                if (L == n) {
	                    return 0;
	                }
	                if (L != C) {
	                    d = -d;
	                    for (k = C; k < n; k++) {
	                        var t = a[C][k];
	                        a[C][k] = a[L][k];
	                        a[L][k] = t;
	                    }
	                }
	                for (i = C+1; i < n; i++) {
	                    for (k = C+1; k < n; k++) {
	                        a[i][k] -= a[C][k] * a[i][C] / a[C][C];
	                    }
	                }
	                d *= a[C][C];
	            }
	            return d;
	        },
	        inverse: function() {
	            var n = this.width;
	            var m = this.augment(new Matrix(this.context).unit(n));
	            var a = m.data;
	            var tmp;

	            // Gaussian elimination
	            // https://en.wikipedia.org/wiki/Gaussian_elimination#Finding_the_inverse_of_a_matrix

	            // 1. Get zeros below main diagonal
	            for (var k = 0; k < n; ++k) {
	                var imax = argmax(k, n, function(i){ return a[i][k]; });
	                if (!a[imax][k]) {
	                    return null; // singular matrix
	                }
	                if (k != imax) {
	                    tmp = a[k];
	                    a[k] = a[imax];
	                    a[imax] = tmp;
	                }
	                for (var i = k+1; i < n; ++i) {
	                    for (var j = k+1; j < 2*n; ++j) {
	                        a[i][j] -= a[k][j] * a[i][k] / a[k][k];
	                    }
	                    a[i][k] = 0;
	                }
	            }

	            // 2. Get 1-s on main diagonal, dividing by pivot
	            for (var i = 0; i < n; ++i) {
	                for (var f = a[i][i], j = 0; j < 2*n; ++j) {
	                    a[i][j] /= f;
	                }
	            }

	            // 3. Get zeros above main diagonal.  Actually, we only care to compute the right side
	            // here (that will be the inverse), so in the inner loop below we go while j >= n,
	            // instead of j >= k.
	            for (var k = n; --k >= 0;) {
	                for (var i = k; --i >= 0;) {
	                    if (a[i][k]) {
	                        for (var j = 2*n; --j >= n;) {
	                            a[i][j] -= a[k][j] * a[i][k];
	                        }
	                    }
	                }
	            }

	            return m.slice(0, n, n, n);
	        },
	        augment: function(m) {
	            var ret = this.clone(), n = ret.width;
	            m.each(function(val, row, col){
	                ret.set(row, col + n, val);
	            });
	            return ret;
	        },
	        slice: function(row, col, height, width) {
	            var m = new Matrix(this.context);
	            for (var i = 0; i < height; ++i) {
	                for (var j = 0; j < width; ++j) {
	                    m.set(i, j, this.get(row + i, col + j));
	                }
	            }
	            return m;
	        }

	        // XXX: debug
	        // dump: function() {
	        //     this.data.forEach(function(row){
	        //         console.log(row.map(function(val){
	        //             var str = val.toFixed(3).replace(/\.?0*$/, function(s){
	        //                 return [ "", " ", "  ", "   ", "    " ][s.length];
	        //             });
	        //             if (val >= 0) { str = " " + str; }
	        //             return str;
	        //         }).join("  "));
	        //     });
	        // }
	    });

	    function argmax(i, end, f) {
	        var max = f(i), pos = i;
	        while (++i < end) {
	            var v = f(i);
	            if (v > max) {
	                max = v;
	                pos = i;
	            }
	        }
	        return pos;
	    }

	    /* -----[ Formula ]----- */

	    var Formula = Class.extend({
	        init: function Formula(refs, handler, printer, sheet, row, col, arrayFormulaRange){
	            this.refs = refs;
	            this.handler = handler;
	            this.print = printer;
	            this.absrefs = null;
	            this.sheet = sheet;
	            this.row = row;
	            this.col = col;
	            this.onReady = [];
	            this.pending = false;
	            this.arrayFormulaRange = arrayFormulaRange;
	        },
	        setArrayFormulaRange: function(ref) {
	            this.arrayFormulaRange = ref.clone().setSheet(this.sheet);
	        },
	        clone: function(sheet, row, col, forceRefs) {
	            var lcsheet = sheet.toLowerCase();
	            var refs = this.refs;
	            var range = this.arrayFormulaRange;
	            if (forceRefs || lcsheet != this.sheet.toLowerCase()) {
	                refs = refs.map(function(ref){
	                    if (!ref.hasSheet() && (!ref.sheet || ref.sheet.toLowerCase() != lcsheet)) {
	                        ref = ref.clone().setSheet(sheet);
	                    }
	                    return ref;
	                });
	                if (range) {
	                    range = range.clone().setSheet(sheet);
	                }
	            }
	            return new Formula(refs, this.handler, this.print, sheet, row, col, range);
	        },
	        deepClone: function() {
	            var refs = this.refs.map(function(ref){ return ref.clone(); });
	            return new Formula(refs, this.handler, this.print, this.sheet, this.row, this.col, this.arrayFormulaRange);
	        },
	        resolve: function(val) {
	            this.pending = false;
	            this.onReady.forEach(function(callback){
	                callback(val);
	            });
	        },
	        exec: function(ss, callback, parentContext) {
	            if ("value" in this) {
	                if (callback) {
	                    callback(this.value);
	                }
	            } else {
	                if (callback) {
	                    this.onReady.push(callback);
	                }

	                var ctx = new Context(this.resolve, this, ss, parentContext);
	                var level = 0;
	                // if the call chain leads back to this same formula, we have a circular dependency.
	                while (parentContext) {
	                    if (parentContext.formula === this) {
	                        this.pending = false;
	                        ctx.resolve(new CalcError("CIRCULAR"));
	                        return;
	                    }
	                    parentContext = parentContext.parent;
	                    ++level;
	                }

	                // pending is still useful for ASYNC formulas
	                if (this.pending) {
	                    return;
	                }
	                this.pending = true;

	                var next = function() {
	                    // compute and cache the absolute references
	                    if (!this.absrefs) {
	                        this.absrefs = this.refs.map(function(ref){
	                            return ref.absolute(this.row, this.col);
	                        }, this);
	                    }

	                    // finally invoke the handler given to us by the compiler in calc.js
	                    this.handler.call(ctx);
	                }.bind(this);

	                if (level < 20) {
	                    next();
	                } else {
	                    setTimeout(next, 0);
	                }
	            }
	        },
	        reset: function() {
	            this.onReady = [];
	            this.pending = false;
	            delete this.value;
	        },
	        renameSheet: function(oldSheetName, newSheetName) {
	            oldSheetName = oldSheetName.toLowerCase();
	            this.absrefs = null;
	            if (this.sheet.toLowerCase() == oldSheetName) {
	                this.sheet = newSheetName;
	            }
	            this.refs.forEach(function(ref){
	                ref.renameSheet(oldSheetName, newSheetName);
	            });
	        },
	        adjust: function(affectedSheet, operation, start, delta) {
	            affectedSheet = affectedSheet.toLowerCase();
	            var formulaRow = this.row;
	            var formulaCol = this.col;
	            var formulaSheet = this.sheet.toLowerCase();
	            var formulaMoves = false;
	            if (formulaSheet == affectedSheet) {
	                // move formula if it's after the change point
	                if (operation == "row" && formulaRow >= start) {
	                    this.row += delta;
	                    formulaMoves = true;
	                }
	                if (operation == "col" && formulaCol >= start) {
	                    this.col += delta;
	                    formulaMoves = true;
	                }
	            }
	            var newFormulaRow = this.row;
	            var newFormulaCol = this.col;
	            this.absrefs = null;
	            var prevRefs = this.refs;
	            var modified = formulaMoves;
	            this.refs = prevRefs.map(function(ref){
	                var newRef = adjust(ref);
	                if (!modified && !sameRef(newRef, ref)) {
	                    modified = true;
	                }
	                return newRef;
	            });

	            var prevRange = this.arrayFormulaRange;
	            if (prevRange) {
	                this.arrayFormulaRange = adjust(prevRange);
	                if (!modified && !sameRef(prevRange, this.arrayFormulaRange)) {
	                    modified = true;
	                }
	            }

	            if (modified) {
	                // return a clone of the original formula.  needed to undo operations like
	                // deleteRow, which can transform a reference into NULL.
	                return new Formula(prevRefs, this.handler, this.print, this.sheet, formulaRow, formulaCol, prevRange);
	            }

	            function adjust(ref){
	                if (ref === NULL) {
	                    return ref;
	                }
	                if (ref.sheet.toLowerCase() != affectedSheet) {
	                    if (formulaMoves) {
	                        // a reference to another sheet should still point to the same location
	                        // after adjustment; thus if row/col was removed before formula, relative
	                        // references must be adjusted by delta.
	                        if (operation == "row" && formulaRow >= start) {
	                            ref = ref.relative(delta, 0);
	                        }
	                        if (operation == "col" && formulaCol >= start) {
	                            ref = ref.relative(0, delta);
	                        }
	                    }
	                    return ref;
	                }
	                return ref.adjust(
	                    formulaRow, formulaCol,
	                    newFormulaRow, newFormulaCol,
	                    operation == "row",
	                    start, delta
	                );
	            }
	        },
	        toString: function() {
	            return this.print(this.row, this.col);
	        }
	    });

	    function sameRef(r1, r2) {
	        // note: r1.eq(r2) will not do, because it returns true for A1 and A1:A1 (CellRef
	        // vs. RangeRef).  To properly undo we need to assert that the references are exactly the
	        // same (including type).
	        if (r1.constructor !== r2.constructor) {
	            return false;
	        }
	        if (r1 instanceof CellRef) {
	            return r1.sheet == r2.sheet
	                && r1.row == r2.row
	                && r1.col == r2.col
	                && r1.rel == r2.rel;
	        }
	        if (r1 instanceof RangeRef) {
	            return sameRef(r1.topLeft     , r2.topLeft)
	                && sameRef(r1.bottomRight , r2.bottomRight)
	                && r1.endSheet == r2.endSheet;
	        }
	        if (r1 instanceof UnionRef) {
	            var i = r1.refs.length;
	            if (i != r2.refs.length) {
	                return false;
	            }
	            while (--i >= 0) {
	                if (!sameRef(r1.refs[i], r2.refs[i])) {
	                    return false;
	                }
	            }
	        }
	        return true;
	    }

	    // spreadsheet functions --------
	    var FUNCS = Object.create(null);

	    FUNCS["if"] = function(callback, args) {
	        var self = this;
	        var co = args[0], th = args[1], el = args[2];
	        // XXX: I don't like this resolveCells here.  We should try to declare IF with
	        // defineFunction.
	        this.resolveCells([ co ], function(){
	            var comatrix = self.asMatrix(co);
	            if (comatrix) {
	                // XXX: calling both branches in this case, since we'll typically need values from
	                // both.  We could optimize and call them only when first needed, but oh well.
	                th(function(th){
	                    el(function(el){
	                        var thmatrix = self.asMatrix(th);
	                        var elmatrix = self.asMatrix(el);
	                        callback(comatrix.map(function(val, row, col){
	                            if (val instanceof CalcError) {
	                                return val;
	                            } else if (self.bool(val)) {
	                                return thmatrix ? thmatrix.get(row, col) : th;
	                            } else {
	                                return elmatrix ? elmatrix.get(row, col) : el;
	                            }
	                        }));
	                    });
	                });
	            } else {
	                co = this.force(co);
	                if (co instanceof CalcError) {
	                    callback(co);
	                } else if (self.bool(co)) {
	                    th(callback);
	                } else {
	                    el(callback);
	                }
	            }
	        });
	    };

	    FUNCS["φ"] = function(callback) {
	        callback((1+Math.sqrt(5))/2);
	    };

	    // Lasciate ogni speranza, voi ch'entrate.
	    //
	    // XXX: document this function.
	    function compileArgumentChecks(functionName, args) {
	        var arrayArgs = "function arrayArgs(args) { var xargs = [], width = 0, height = 0, arrays = [], i = 0; ";
	        var resolve = "function resolve(args, callback) { var toResolve = [], i = 0; ";
	        var name, forced, main = "'use strict'; function check(args) { var stack = [], tmp, xargs = [], i = 0, m, err = 'VALUE'; ", haveForced = false;
	        var canBeArrayArg = false, hasArrayArgs = false;
	        main += args.map(comp).join("");
	        main += "if (i < args.length) return new CalcError('N/A'); ";
	        main += "return xargs; } ";
	        arrayArgs += "return { args: xargs, width: width, height: height, arrays: arrays }; } ";

	        var f;
	        if (haveForced) {
	            resolve += "this.resolveCells(toResolve, callback); } ";
	            f = new Function("CalcError", "round", main + resolve + arrayArgs + " return { resolve: resolve, check: check, arrayArgs: arrayArgs };");
	        } else {
	            f = new Function("CalcError", "round", main + " return { check: check };");
	        }
	        f = f(CalcError, limitPrecision);
	        if (!hasArrayArgs) {
	            delete f.arrayArgs;
	        }
	        return f;

	        function comp(x) {
	            name = x[0];
	            var code = "{ ";
	            if (Array.isArray(name)) {
	                arrayArgs += "while (i < args.length) { ";
	                resolve += "while (i < args.length) { ";
	                code += "xargs.push(tmp = []); stack.push(xargs); xargs = tmp; ";
	                code += "while (i < args.length) { ";
	                code += x.map(comp).join("");
	                code += "} ";
	                code += "xargs = stack.pop(); ";
	                resolve += "} ";
	                arrayArgs += "} ";
	            } else if (name == "+") {
	                arrayArgs += "while (i < args.length) { ";
	                resolve += "while (i < args.length) { ";
	                code += "if (i >= args.length) return new CalcError('N/A'); ";
	                code += "xargs.push(tmp = []); stack.push(xargs); xargs = tmp; ";
	                code += "do { ";
	                code += x.slice(1).map(comp).join("");
	                code += "} while (i < args.length); ";
	                code += "xargs = stack.pop(); ";
	                resolve += "} ";
	                arrayArgs += "} ";
	            } else if (name == "?") {
	                // standalone assertion without a new argument
	                code += "if (!(" + cond(x[1]) + ")) return new CalcError(err); ";
	            } else {
	                var type = x[1];
	                if (Array.isArray(type) && /^#?collect/.test(type[0])) {
	                    var wantNulls = /!$/.test(type[0]);
	                    var n = type[2];
	                    force();
	                    code += "try {"
	                        + "var $" + name + " = this.cellValues(args.slice(i";
	                    if (n) {
	                        code += ", i + " + n;
	                    }
	                    code += ")" + (wantNulls ? ",true" : "") + ").reduce(function(ret, $"+name+"){ ";
	                    if (type[0].charAt(0) != "#") {
	                        code += "if ($"+name+" instanceof CalcError) throw $"+name+"; ";
	                    }
	                    code += "if (" + cond(type[1]) + ") ret.push($"+name+"); ";
	                    code += "return ret; ";
	                    code += "}.bind(this), []); ";
	                    if (n) {
	                        code += "i += " + n + "; ";
	                    } else {
	                        code += "i = args.length; ";
	                    }
	                    code += "xargs.push($"+name+")"
	                        + "} catch(ex) { if (ex instanceof CalcError) return ex; throw ex; } ";
	                    resolve += "toResolve.push(args.slice(i)); ";
	                } else if (type == "rest") {
	                    code += "xargs.push(args.slice(i)); i = args.length; ";
	                } else {
	                    if ((canBeArrayArg = /^\*/.test(name))) {
	                        hasArrayArgs = true;
	                        name = name.substr(1);
	                    }
	                    code += "var $" + name + " = args[i++]; ";
	                    var allowError = false;
	                    if (/!$/.test(type)) {
	                        type = type.substr(0, type.length - 1);
	                        allowError = true;
	                    } else {
	                        code += "if ($"+name+" instanceof CalcError) return $"+name+"; ";
	                    }
	                    code += typeCheck(type, allowError) + "xargs.push($"+name+"); ";
	                }
	            }
	            code += "} ";
	            return code;
	        }

	        function force() {
	            if (forced) {
	                return "$"+name+"";
	            }
	            haveForced = true;
	            forced = true;
	            resolve += "toResolve.push(args[i++]); ";
	            return "($"+name+" = this.force($"+name+"))";
	        }

	        function forceNum(round) {
	            return "("
	                +     (round
	                       ? ("(typeof " + force() + " == 'number' ? ($"+name+" = round($"+name+"), true) : false) || ")
	                       : ("(typeof " + force() + " == 'number') || "))
	                +     "(typeof $"+name+" == 'boolean' ? ($"+name+" = +$" + name + ", true) : false) || "
	                +     "(typeof $"+name+" == 'string' && !/^(?:=|true|false)/i.test($"+name+") ? ("
	                +       "tmp = kendo.spreadsheet.calc.parse(0, 0, 0, $"+name+"), "
	                +       "/^date|number|percent$/.test(tmp.type) ? ($"+name+" = +tmp.value, true) : false"
	                +     ") : false)"
	                +  ")";
	        }

	        function typeCheck(type, allowError) {
	            forced = false;
	            var ret = "if (!(" + cond(type) + ")) { ";
	            if (forced && !allowError) {
	                ret += " if ($" + name + " instanceof CalcError) return $" + name + "; ";
	            }
	            ret += "return new CalcError(err); } ";
	            if (!forced) {
	                resolve += "i++; ";
	            }
	            if (canBeArrayArg) {
	                arrayArgs += "var $" + name + " = this._arrayArg(args[i]); "
	                    + "if ($" + name + ") { "
	                    + "xargs.push($" + name + "); "
	                    + "width = Math.max(width, $" + name + ".width); "
	                    + "height = Math.max(height, $" + name + ".height); "
	                    + "arrays.push(true) } else { "
	                    + "xargs.push(args[i]); "
	                    + "arrays.push(false); } i++; ";
	            } else {
	                arrayArgs += "xargs.push(args[i++]); arrays.push(false); ";
	            }
	            return ret;
	        }

	        function cond(type) {
	            if (Array.isArray(type)) {
	                if (type[0] == "or") {
	                    return "(" + type.slice(1).map(cond).join(") || (") + ")";
	                }
	                if (type[0] == "and") {
	                    return "(" + type.slice(1).map(cond).join(") && (") + ")";
	                }
	                if (type[0] == "values") {
	                    return "(" + type.slice(1).map(function(val){
	                        return force() + " === " + val;
	                    }).join(") || (") + ")";
	                }
	                if (type[0] == "null") {
	                    return "(" + cond("null") + " ? (($"+name+" = " + type[1] + "), true) : false)";
	                }
	                if (type[0] == "between" || type[0] == "[between]") {
	                    return "(" + force() + " >= " + type[1] + " && " + "$"+name+" <= " + type[2] + " ? true : ((err = 'NUM'), false))";
	                }
	                if (type[0] == "(between)") {
	                    return "(" + force() + " > " + type[1] + " && " + "$"+name+" < " + type[2] + " ? true : ((err = 'NUM'), false))";
	                }
	                if (type[0] == "(between]") {
	                    return "(" + force() + " > " + type[1] + " && " + "$"+name+" <= " + type[2] + " ? true : ((err = 'NUM'), false))";
	                }
	                if (type[0] == "[between)") {
	                    return "(" + force() + " >= " + type[1] + " && " + "$"+name+" < " + type[2] + " ? true : ((err = 'NUM'), false))";
	                }
	                if (type[0] == "assert") {
	                    var err = type[2] || "N/A";
	                    return "((" + type[1] + ") ? true : (err = " + JSON.stringify(err) + ", false))";
	                }
	                if (type[0] == "not") {
	                    return "!(" + cond(type[1]) + ")";
	                }
	                throw new Error("Unknown array type condition: " + type[0]);
	            }
	            if (type == "number" || type == "datetime") {
	                return forceNum(true);
	            }
	            if (type == "number!") {
	                return "(typeof " + force() + " == 'number' ? ($"+name+" = round($"+name+"), true) : false)";
	            }
	            if (type == "integer" || type == "date") {
	                return "(" + forceNum() + " && (($"+name+" |= 0), true))";
	            }
	            if (type == "divisor") {
	                return "(" + forceNum(true) + " && ($"+name+" == 0 ? ((err = 'DIV/0'), false) : true))";
	            }
	            if (type == "number+") {
	                return "(" + forceNum(true) + " && ($"+name+" >= 0 ? true : ((err = 'NUM'), false)))";
	            }
	            if (type == "integer+") {
	                return "(" + forceNum() + " && (($"+name+" |= 0) >= 0 ? true : ((err = 'NUM'), false)))";
	            }
	            if (type == "number++") {
	                return "(" + forceNum(true) + " && ($"+name+" > 0 ? true : ((err = 'NUM'), false)))";
	            }
	            if (type == "integer++") {
	                return "(" + forceNum() + " && (($"+name+" |= 0) > 0 ? true : ((err = 'NUM'), false)))";
	            }
	            if (type == "string") {
	                return "((typeof " + force() + " == 'string' || typeof $"+name+" == 'boolean' || typeof $"+name+" == 'number') ? ($"+name+" += '', true) : ($"+name+" === undefined ? (($"+name+" = ''), true) : false))";
	            }
	            if (type == "boolean") {
	                return "(typeof " + force() + " == 'boolean')";
	            }
	            if (type == "logical") {
	                return "(typeof " + force() + " == 'boolean' || (typeof $"+name+" == 'number' ? ($"+name+" = !!$"+name+", true) : false))";
	            }
	            if (type == "matrix") {
	                force();
	                return "((m = this.asMatrix($"+name+")) ? ($"+name+" = m) : false)";
	            }
	            if (type == "#matrix") {
	                return "((m = this.asMatrix($"+name+")) ? ($"+name+" = m) : false)";
	            }
	            if (type == "ref") {
	                return "($"+name+" instanceof kendo.spreadsheet.Ref)";
	            }
	            if (type == "area") {
	                return "($"+name+" instanceof kendo.spreadsheet.CellRef || $"+name+" instanceof kendo.spreadsheet.RangeRef)";
	            }
	            if (type == "cell") {
	                return "($"+name+" instanceof kendo.spreadsheet.CellRef)";
	            }
	            if (type == "null") {
	                return "(" + force() + " == null)";
	            }
	            if (type == "anyvalue") {
	                return "(" + force() + " != null && i <= args.length)";
	            }
	            if (type == "forced") {
	                return "(" + force() + ", i <= args.length)";
	            }
	            if (type == "anything") {
	                return "(i <= args.length)";
	            }
	            if (type == "blank") {
	                return "(" + force() + " == null || $"+name+" === '')";
	            }
	            throw new Error("Can't check for type: " + type);
	        }
	    }

	    function limitPrecision(num) {
	        return num === parseInt(num, 10) ? num : +num.toPrecision(14);
	    }

	    function maybeRoundFloatErrors(num) {
	        if (typeof num == "number") {
	            return limitPrecision(num);
	        } else {
	            return num;
	        }
	    }

	    function withErrorHandling(obj, f, args) {
	        if (args instanceof CalcError) {
	            return args;
	        }
	        try {
	            return f.apply(obj, args);
	        } catch(ex) {
	            if (ex instanceof CalcError) {
	                return ex;
	            } else {
	                throw ex;
	            }
	        }
	    }

	    function makeSyncFunction(handler, resolve, check, arrayArgs) {
	        return function(callback, args) {
	            function doit() {
	                if (arrayArgs) {
	                    var x = arrayArgs.call(this, args);
	                    args = x.args;
	                    if (x.width > 0 && x.height > 0) {
	                        var result = new Matrix(this);
	                        for (var row = 0; row < x.height; ++row) {
	                            for (var col = 0; col < x.width; ++col) {
	                                var xargs = [];
	                                for (var i = 0; i < args.length; ++i) {
	                                    if (x.arrays[i]) {
	                                        xargs[i] = args[i].getNA(row, col);
	                                    } else {
	                                        xargs[i] = args[i];
	                                    }
	                                }
	                                xargs = check.call(this, xargs);
	                                result.set(row, col, withErrorHandling(this, handler, xargs));
	                            }
	                        }
	                        return callback(result);
	                    }
	                }
	                var xargs = check.call(this, args);
	                callback(withErrorHandling(this, handler, xargs));
	            }
	            if (resolve) {
	                resolve.call(this, args, doit);
	            } else {
	                doit.call(this);
	            }
	        };
	    }

	    function makeAsyncFunction(handler, resolve, check, arrayArgs) {
	        return function(callback, args) {
	            function doit() {
	                if (arrayArgs) {
	                    var x = arrayArgs.call(this, args);
	                    args = x.args;
	                    if (x.width > 0 && x.height > 0) {
	                        var result = new Matrix(this);
	                        var count = x.width * x.height;
	                        var makeCallback = function(row, col) {
	                            return function(value) {
	                                result.set(row, col, value);
	                                --count;
	                                if (count === 0) {
	                                    return callback(result);
	                                }
	                            };
	                        };
	                        for (var row = 0; row < x.height && count > 0; ++row) {
	                            for (var col = 0; col < x.width && count > 0; ++col) {
	                                var xargs = [];
	                                for (var i = 0; i < args.length; ++i) {
	                                    if (x.arrays[i]) {
	                                        xargs[i] = args[i].getNA(row, col);
	                                    } else {
	                                        xargs[i] = args[i];
	                                    }
	                                }
	                                xargs = check.call(this, xargs);
	                                if (xargs instanceof CalcError) {
	                                    result.set(row, col, xargs);
	                                    --count;
	                                    if (count === 0) {
	                                        return callback(result);
	                                    }
	                                } else {
	                                    xargs.unshift(makeCallback(row, col));
	                                    handler.apply(this, xargs);
	                                }
	                            }
	                        }
	                        return;
	                    }
	                }
	                var x = check.call(this, args);
	                if (x instanceof CalcError) {
	                    callback(x);
	                } else {
	                    x.unshift(callback);
	                    handler.apply(this, x);
	                }
	            }
	            if (resolve) {
	                resolve.call(this, args, doit);
	            } else {
	                doit.call(this);
	            }
	        };
	    }

	    function defineFunction(name, func) {
	        name = name.toLowerCase();
	        FUNCS[name] = func;
	        return {
	            args: function(args, log) {
	                var code = compileArgumentChecks(name, args);
	                // XXX: DEBUG
	                if (log) {
	                    if (code.arrayArgs) {console.log(code.arrayArgs.toString());}
	                    if (code.resolve) {console.log(code.resolve.toString());}
	                    if (code.check) {console.log(code.check.toString());}
	                }
	                var f = FUNCS[name] = makeSyncFunction(func, code.resolve, code.check, code.arrayArgs);
	                f.kendoSpreadsheetArgs = args;
	                return this;
	            },
	            argsAsync: function(args, log) {
	                var code = compileArgumentChecks(name, args);
	                // XXX: DEBUG
	                if (log) {
	                    if (code.arrayArgs) {console.log(code.arrayArgs.toString());}
	                    if (code.resolve) {console.log(code.resolve.toString());}
	                    if (code.check) {console.log(code.check.toString());}
	                }
	                var f = FUNCS[name] = makeAsyncFunction(func, code.resolve, code.check, code.arrayArgs);
	                f.kendoSpreadsheetArgs = args;
	                return this;
	            }
	        };
	    }

	    /* -----[ date calculations ]----- */

	    // Julian days algorithms from http://www.hermetic.ch/cal_stud/jdn.htm#comp

	    function dateToJulianDays(y, m, d) {
	        m++;
	        return ((1461 * (y + 4800 + ((m - 14) / 12 | 0))) / 4 | 0) +
	            ((367 * (m - 2 - 12 * ((m - 14) / 12 | 0))) / 12 | 0) -
	            ((3 * (((y + 4900 + ((m - 14) / 12 | 0)) / 100 | 0))) / 4 | 0) +
	            d - 32075;
	    }

	    function julianDaysToDate(jd) {
	        var l, n, j, i, m, d, y;
	        l = jd + 68569;
	        n = (4 * l) / 146097 | 0;
	        l = l - ((146097 * n + 3) / 4 | 0);
	        i = (4000 * (l + 1) / 1461001) | 0;
	        l = l - ((1461 * i) / 4 | 0) + 31;
	        j = (80 * l) / 2447 | 0;
	        d = l - ((2447 * j) / 80 | 0);
	        l = j / 11 | 0;
	        m = j + 2 - (12 * l);
	        y = 100 * (n - 49) + i + l;
	        m--;
	        return {
	            year  : y,
	            month : m,
	            date  : d,
	            day   : (jd + 1) % 7,
	            ord   : ORDINAL_ADD_DAYS[isLeapYear(y)][m] + d
	        };
	    }

	    // This uses the Google Spreadsheet approach: treat 1899-12-31 as day 1, allowing to avoid
	    // implementing the "Leap Year Bug" yet still be Excel compatible for dates starting 1900-03-01.
	    var BASE_DATE = dateToJulianDays(1900, 0, -1);

	    var DAYS_IN_MONTH = [ 31, 28, 31,
	                          30, 31, 30,
	                          31, 31, 30,
	                          31, 30, 31 ];

	    var ORDINAL_ADD_DAYS = [
	        [ 0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334 ], // non-leap year
	        [ 0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335 ]  // leap year
	    ];

	    function isLeapYear(yr) {
	        if (yr % 4) {
	            return 0;
	        }
	        if (yr % 100) {
	            return 1;
	        }
	        if (yr % 400) {
	            return 0;
	        }
	        return 1;
	    }

	    function daysInYear(yr) {
	        return isLeapYear(yr) ? 366 : 365;
	    }

	    function daysInMonth(yr, mo) {
	        return (isLeapYear(yr) && mo == 1) ? 29 : DAYS_IN_MONTH[mo];
	    }

	    function validDate(yr, mo, da) {
	        return mo >= 1 && mo <= 12 && da >= 1 && da <= daysInMonth(yr, mo - 1);
	    }

	    function unpackDate(serial) {
	        return julianDaysToDate((serial | 0) + BASE_DATE);
	    }

	    function packDate(year, month, date) {
	        return dateToJulianDays(year, month, date) - BASE_DATE;
	    }

	    var MS_IN_MIN = 60 * 1000;
	    var MS_IN_HOUR = 60 * MS_IN_MIN;
	    var MS_IN_DAY = 24 * MS_IN_HOUR;

	    function unpackTime(serial) {
	        var frac = serial - (serial|0);
	        if (frac < 0) {
	            frac++;
	        }
	        var ms = Math.round(MS_IN_DAY * frac);
	        var hours = Math.floor(ms / MS_IN_HOUR);
	        ms -= hours * MS_IN_HOUR;
	        var minutes = Math.floor(ms / MS_IN_MIN);
	        ms -= minutes * MS_IN_MIN;
	        var seconds = Math.floor(ms / 1000);
	        ms -= seconds * 1000;
	        return {
	            hours: hours,
	            minutes: minutes,
	            seconds: seconds,
	            milliseconds: ms
	        };
	    }

	    function serialToDate(serial) {
	        var d = unpackDate(serial), t = unpackTime(serial);
	        return new Date(d.year, d.month, d.date,
	                        t.hours, t.minutes, t.seconds, t.milliseconds);
	    }

	    function packTime(hh, mm, ss, ms) {
	        return (hh+(mm+(ss+ms/1000)/60)/60)/24;
	    }

	    function dateToSerial(date) {
	        var time = packTime(date.getHours(),
	                            date.getMinutes(),
	                            date.getSeconds(),
	                            date.getMilliseconds());
	        date = packDate(date.getFullYear(),
	                        date.getMonth(),
	                        date.getDate());
	        if (date < 0) {
	            return date - 1 + time;
	        } else {
	            return date + time;
	        }
	    }

	    function parseDate(str, format) {
	        if (format) {
	            format = kendo.spreadsheet.formatting.makeDateFormat(format);
	        }
	        return kendo.parseExactDate(str, format)
	            || kendo.parseExactDate(str)
	            || kendo.parseExactDate(str, [
	                "MMMM dd yyyy",
	                "MMMM dd yy",
	                "MMM dd yyyy",
	                "MMM dd yy",
	                "dd MMMM yyyy",
	                "dd MMMM yy",
	                "dd MMM yyyy",
	                "dd MMM yy",
	                "MMMM dd, yyyy",
	                "MMMM dd, yy",
	                "MMM dd, yyyy",
	                "MMM dd, yy",
	                "MMMM dd",
	                "MMM dd",
	                "MMMM yyyy",
	                "MMM yyyy",
	                "dd MMMM",
	                "dd MMM"
	            ]);
	    }

	    /* -----[ exports ]----- */

	    exports.CalcError = CalcError;
	    exports.Formula = Formula;
	    exports.Matrix = Matrix;

	    exports.packDate = packDate;
	    exports.unpackDate = unpackDate;
	    exports.packTime = packTime;
	    exports.unpackTime = unpackTime;
	    exports.serialToDate = serialToDate;
	    exports.dateToSerial = dateToSerial;
	    exports.daysInMonth = daysInMonth;
	    exports.validDate = validDate;
	    exports.isLeapYear = isLeapYear;
	    exports.daysInYear = daysInYear;
	    exports.parseDate = parseDate;
	    exports.limitPrecision = limitPrecision;

	    spreadsheet.dateToNumber = dateToSerial;
	    spreadsheet.numberToDate = serialToDate;
	    spreadsheet.defineFunction = defineFunction;
	    spreadsheet.CalcError = CalcError;

	    exports.defineFunction = defineFunction;
	    exports.defineAlias = function(alias, name) {
	        var orig = FUNCS[name];
	        if (!orig) {
	            throw new Error("Function " + name + " is not yet defined");
	        }
	        if (!orig.kendoSpreadsheetAliases) {
	            orig.kendoSpreadsheetAliases = [ name ];
	        }
	        orig.kendoSpreadsheetAliases.push(alias);
	        FUNCS[alias] = orig;
	    };
	    exports.FUNCS = FUNCS;

	    /* -----[ Excel operators ]----- */

	    var NUMBER_OR_ZERO = [ "or", "number", [ "null", 0 ] ];

	    var ARGS_NUMERIC = [
	        [ "*a", NUMBER_OR_ZERO ],
	        [ "*b", NUMBER_OR_ZERO ]
	    ];

	    var ARGS_ANYVALUE = [
	        [ "*a", "forced" ],
	        [ "*b", "forced" ]
	    ];

	    defineFunction("binary+", function(a, b){
	        return a + b;
	    }).args(ARGS_NUMERIC);

	    defineFunction("binary-", function(a, b){
	        return a - b;
	    }).args(ARGS_NUMERIC);

	    defineFunction("binary*", function(a, b){
	        return a * b;
	    }).args(ARGS_NUMERIC);

	    defineFunction("binary/", function(a, b){
	        return a / b;
	    }).args([
	        [ "*a", NUMBER_OR_ZERO ],
	        [ "*b", "divisor" ]
	    ]);

	    defineFunction("binary^", function(a, b){
	        return Math.pow(a, b);
	    }).args(ARGS_NUMERIC);

	    defineFunction("binary&", function(a, b){
	        if (a == null) { a = ""; }
	        if (b == null) { b = ""; }
	        return "" + a + b;
	    }).args([
	        [ "*a", [ "or", "number", "string", "boolean", "null" ] ],
	        [ "*b", [ "or", "number", "string", "boolean", "null" ] ]
	    ]);

	    function equals(a, b){
	        a = typeof(a) === "string" ? a.toLowerCase() : a;
	        b = typeof(b) === "string" ? b.toLowerCase() : b;

	        // special cases
	        if (a === false && b == null) { return true; }
	        if (b === false && a == null) { return true; }
	        if (a === 0     && b == null) { return true; }
	        if (b === 0     && a == null) { return true; }
	        if (a === ""    && b == null) { return true; }
	        if (b === ""    && a == null) { return true; }

	        return a === b;
	    }

	    defineFunction("binary=", equals).args(ARGS_ANYVALUE);

	    defineFunction("binary<>", function(a, b){
	        return !equals(a, b);
	    }).args(ARGS_ANYVALUE);

	    defineFunction("binary<", binaryCompare(function(a, b){
	        return a < b;
	    })).args(ARGS_ANYVALUE);

	    defineFunction("binary<=", binaryCompare(function(a, b){
	        return a <= b;
	    })).args(ARGS_ANYVALUE);

	    defineFunction("binary>", binaryCompare(function(a, b){
	        return a > b;
	    })).args(ARGS_ANYVALUE);

	    defineFunction("binary>=", binaryCompare(function(a, b){
	        return a >= b;
	    })).args(ARGS_ANYVALUE);

	    defineFunction("unary+", function(a){
	        return a;
	    }).args([
	        [ "*a", NUMBER_OR_ZERO ]
	    ]);

	    defineFunction("unary-", function(a){
	        return -a;
	    }).args([
	        [ "*a", NUMBER_OR_ZERO ]
	    ]);

	    defineFunction("unary%", function(a){
	        return a / 100;
	    }).args([
	        [ "*a", NUMBER_OR_ZERO ]
	    ]);

	    // range operator
	    defineFunction("binary:", function(a, b){
	        return new RangeRef(a, b)
	            .setSheet(a.sheet || this.formula.sheet, a.hasSheet());
	    }).args([
	        [ "a", "cell" ],
	        [ "b", "cell" ]
	    ]);

	    // union operator
	    defineFunction("binary,", function(a, b){
	        return new UnionRef([ a, b ]);
	    }).args([
	        [ "a", "ref" ],
	        [ "b", "ref" ]
	    ]);

	    // intersection operator
	    defineFunction("binary ", function(a, b){
	        return a.intersect(b);
	    }).args([
	        [ "a", "ref" ],
	        [ "b", "ref" ]
	    ]);

	    /* -----[ conditionals ]----- */

	    defineFunction("not", function(a){
	        return !this.bool(a);
	    }).args([
	        [ "*a", [ "or", "anyvalue", [ "null", 0 ] ] ]
	    ]);

	    /* -----[ the IS* functions ]----- */

	    defineFunction("isblank", function(val){
	        if (val instanceof CellRef) {
	            val = this.getRefData(val);
	            return val == null;
	        }
	        return false;
	    }).args([
	        [ "*value", "anything!" ]
	    ]);

	    defineFunction("iserror", function(val){
	        return val instanceof CalcError;
	    }).args([
	        [ "*value", "forced!" ]
	    ]);

	    defineFunction("iserr", function(val){
	        return val instanceof CalcError && val.code != "N/A";
	    }).args([
	        [ "*value", "forced!" ]
	    ]);

	    defineFunction("isna", function(val){
	        return val instanceof CalcError && val.code == "N/A";
	    }).args([
	        [ "*value", "forced!" ]
	    ]);

	    defineFunction("islogical", function(val){
	        return typeof val == "boolean";
	    }).args([
	        [ "*value", "forced!" ]
	    ]);

	    defineFunction("isnontext", function(val){
	        return typeof val != "string";
	    }).args([
	        [ "*value", "forced!" ]
	    ]);

	    defineFunction("istext", function(val){
	        return typeof val == "string";
	    }).args([
	        [ "*value", "forced!" ]
	    ]);

	    defineFunction("isnumber", function(val){
	        return typeof val == "number";
	    }).args([
	        [ "*value", "forced!" ]
	    ]);

	    defineFunction("isref", function(val){
	        // apparently should return true only for cell and range
	        return val instanceof CellRef || val instanceof RangeRef;
	    }).args([
	        [ "*value", "anything!" ]
	    ]);

	    /* -----[ resolve NameRef-s ]----- */

	    FUNCS[",getname"] = function(callback, args) {
	        this.fetchName(args[0], callback);
	    };

	    /// utils

	    function binaryCompare(func) {
	        return function(left, right){
	            if (typeof left == "string" && typeof right != "string") {
	                right = right == null ? "" : right + "";
	            }
	            if (typeof left != "string" && typeof right == "string") {
	                left = left == null ? "" : left + "";
	            }
	            if (typeof left == "number" && right == null) {
	                right = 0;
	            }
	            if (typeof right == "number" && left == null) {
	                left = 0;
	            }
	            if (typeof left == "string" && typeof right == "string") {
	                // string comparison is case insensitive
	                left = left.toLowerCase();
	                right = right.toLowerCase();
	            }
	            if (typeof right == typeof left) {
	                return func(left, right);
	            } else {
	                return new CalcError("VALUE");
	            }
	        };
	    }

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "I3sU":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1585);
	module.exports = __webpack_require__(1585);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 968:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1Z35");

/***/ }),

/***/ 1566:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ydSV");

/***/ }),

/***/ 1585:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(20),
	        __webpack_require__(1566),
	        __webpack_require__(968),
	        __webpack_require__(1586),
	        __webpack_require__(1587)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    /* jshint laxbreak:true */

	    var $ = kendo.jQuery;

	    var COMMAND_TYPES = {
	        AUTO_FILL: "autoFill",
	        CLEAR: "clear",
	        CUT: "cut",
	        EDIT: "edit",
	        PASTE: "paste",
	        VALIDATION: "validation"
	    };

	    var Command = kendo.spreadsheet.Command = kendo.Class.extend({
	        init: function(options) {
	            this.options = options;
	            this._workbook = options.workbook;
	            this._property = options && options.property;
	            this._state = {};
	        },
	        range: function(range) {
	            if (range !== undefined) {
	                this._setRange(range);
	            }

	            return this._range;
	        },
	        _setRange: function(range) {
	            this._range = range;
	        },
	        redo: function() {
	            this.range().select();
	            this.exec();
	        },
	        undo: function() {
	            this.setState(this._state);
	        },
	        getState: function() {
	            this._state = this.range().getState(this._property);
	        },
	        setState: function(state) {
	            this.range().setState(state);
	        },
	        rejectState: function(validationState) {
	            this.undo();
	            return {
	                title: validationState.title,
	                body: validationState.message,
	                reason: "error",
	                type: "validationError"
	            };
	        },
	        _forEachCell: function(callback) {
	            var range = this.range();
	            var ref = range._ref;

	            ref.forEach(function(ref) {
	                range.sheet().forEach(ref.toRangeRef(), callback.bind(this));
	            }.bind(this));
	        },
	        usesImage: function(/* image id from workbook._images */) {
	            return false;
	        }
	    });

	    kendo.spreadsheet.DrawingUpdateCommand = Command.extend({
	        init: function(options) {
	            this._sheet = options.sheet;
	            this._drawing = options.drawing;
	            this._orig = this._drawing.clone();
	            this._previous = options.previous;
	        },
	        exec: function() {},
	        undo: function() {
	            this._drawing.reset(this._previous);
	            this._sheet._activeDrawing = this._drawing;
	            this._sheet.triggerChange({ layout: true });
	        },
	        redo: function() {
	            this._drawing.reset(this._orig);
	            this._sheet._activeDrawing = this._drawing;
	            this._sheet.triggerChange({ layout: true });
	        },
	        usesImage: function(img) {
	            return this._drawing.image === img
	                || this._orig.image === img
	                || this._previous.image === img;
	        }
	    });

	    var DrawingCommand = Command.extend({
	        init: function(options) {
	            Command.fn.init.call(this, options);
	            this._drawing = options.drawing;
	        },
	        usesImage: function(img) {
	            return this._drawing.image === img;
	        }
	    });

	    kendo.spreadsheet.InsertImageCommand = DrawingCommand.extend({
	        init: function(options) {
	            DrawingCommand.fn.init.call(this, options);
	            this._blob = options.blob;
	            this._width = options.width;
	            this._height = options.height;
	        },
	        exec: function() {
	            var range = this.range();
	            var sheet = range.sheet();
	            var width = this._width;
	            var height = this._height;
	            var aspect = width / height;
	            if (width > height) {
	                width = Math.min(width, 300);
	                height = width / aspect;
	            } else {
	                height = Math.min(height, 300);
	                width = height * aspect;
	            }
	            this._drawing = sheet.addDrawing({
	                topLeftCell : range.topLeft(),
	                offsetX     : 5,
	                offsetY     : 5,
	                width       : width,
	                height      : height,
	                opacity     : 1,
	                image       : this._workbook.addImage(this._blob)
	            }, true);
	            this._blob = null;
	        },
	        undo: function() {
	            var sheet = this.range().sheet();
	            sheet._activeDrawing = null;
	            sheet.removeDrawing(this._drawing);
	        },
	        redo: function() {
	            var sheet = this.range().sheet();
	            sheet._activeDrawing = this._drawing;
	            sheet.addDrawing(this._drawing);
	        }
	    });

	    kendo.spreadsheet.DeleteDrawingCommand = DrawingCommand.extend({
	        exec: function() {
	            var sheet = this.range().sheet();
	            sheet._activeDrawing = null;
	            sheet.removeDrawing(this._drawing);
	        },
	        undo: function() {
	            var sheet = this.range().sheet();
	            sheet._activeDrawing = this._drawing;
	            sheet.addDrawing(this._drawing);
	        },
	        redo: function() {
	            this.exec();
	        }
	    });

	    var ReorderDrawingsCommand = DrawingCommand.extend({
	        exec: function() {
	            var sheet = this.range().sheet();
	            this._origIndex = sheet._drawings.indexOf(this._drawing);
	            sheet._drawings.splice(this._origIndex, 1);
	            this._newIndex = this._reorder();
	            sheet._drawings.splice(this._newIndex, 0, this._drawing);
	            sheet.triggerChange({ drawings: true });
	        },
	        undo: function() {
	            var sheet = this.range().sheet();
	            sheet._drawings.splice(this._newIndex, 1);
	            sheet._drawings.splice(this._origIndex, 0, this._drawing);
	            sheet.triggerChange({ drawings: true });
	        }
	    });

	    kendo.spreadsheet.BringToFrontCommand = ReorderDrawingsCommand.extend({
	        _reorder: function() {
	            return this.range().sheet()._drawings.length;
	        }
	    });

	    kendo.spreadsheet.SendToBackCommand = ReorderDrawingsCommand.extend({
	        _reorder: function() {
	            return 0;
	        }
	    });

	    var TargetValueCommand = Command.extend({
	        init: function(options) {
	            Command.fn.init.call(this, options);
	            this._target = options.target;
	            this._value = options.value;
	        },
	        exec: function() {
	            this.getState();
	            this.setState(this._value);
	        }
	    });

	    kendo.spreadsheet.ColumnWidthCommand = TargetValueCommand.extend({
	        getState: function() {
	            this._state = this.range().sheet().columnWidth(this._target);
	        },
	        setState: function(state) {
	            this.range().sheet().columnWidth(this._target, state);
	        }
	    });

	    kendo.spreadsheet.RowHeightCommand = TargetValueCommand.extend({
	        getState: function() {
	            this._state = this.range().sheet().rowHeight(this._target);
	        },
	        setState: function(state) {
	            this.range().sheet().rowHeight(this._target, state);
	        }
	    });

	    kendo.spreadsheet.HyperlinkCommand = Command.extend({
	        init: function(options) {
	            Command.fn.init.call(this, options);
	            this._link = options.link;
	        },
	        exec: function() {
	            var range = this.range();
	            this._prevLink = range.link();
	            this._prevUnderline = range.underline();
	            range.link(this._link);
	            range.underline(true);
	            if (range.value() == null) { // jshint ignore:line
	                this._hasSetValue = true;
	                range.value(this._link);
	            }
	        },
	        undo: function() {
	            var range = this.range();
	            range.link(this._prevLink);
	            range.underline(this._prevUnderline);
	            if (this._hasSetValue) {
	                range.value(null);
	            }
	        }
	    });

	    kendo.spreadsheet.GridLinesChangeCommand = TargetValueCommand.extend({
	        getState: function() {
	            this._state = this._range.sheet().showGridLines();
	        },
	        setState: function(v) {
	            this._range.sheet().showGridLines(v);
	        }
	    });

	    var PropertyChangeCommand = kendo.spreadsheet.PropertyChangeCommand = Command.extend({
	        _setRange: function(range) {
	            Command.prototype._setRange.call(this, range.skipHiddenCells());
	        },
	        init: function(options) {
	            Command.fn.init.call(this, options);
	            this._value = options.value;
	        },
	        exec: function() {
	            var range = this.range();
	            if (range.enable()) {
	                this.getState();

	                if (this.options.property === "format") {
	                    this._workbook.trigger("changeFormat", { range: range });
	                }

	                range[this._property](this._value);
	            }
	        }
	    });

	    kendo.spreadsheet.ClearContentCommand = Command.extend({
	        exec: function() {
	            var values = [], range, rowValues, nullValues, validationState, currentRange;
	            if (!this.range().enable()) {
	                return { reason: "error", type: "cannotModifyDisabled" };
	            }
	            if (!this.range().canEditArrayFormula()) {
	                return { reason: "error", type: "intersectsArray" };
	            }
	            this.getState();
	            range = this.range().skipHiddenCells();

	            if(range._ref.refs && range._ref.refs.length > 1) {
	                range._ref.refs.forEach(function(ref) {
	                    currentRange = range.sheet().range(ref);
	                    values = values.concat(currentRange.values());
	                });
	            } else {
	                values = range.values();
	            }
	            nullValues = [];
	            values.forEach(function(row) {
	                rowValues = [];
	                row.forEach(function() {
	                    rowValues.push(null);
	                });
	                nullValues.push(rowValues);
	            });
	            if (range.sheet().trigger("changing", { data: nullValues, range: range, changeType: COMMAND_TYPES.CLEAR })) {
	                return;
	            }
	            range.clearContent();
	            validationState = range._getValidationState();
	            if (validationState) {
	                return this.rejectState(validationState);
	            }
	        },
	        undo: function() {
	            var range = this.range().skipHiddenCells();
	            var sheet = range.sheet();
	            var data = this._state.data;
	            var values = [];
	            var rowValues;
	            data.forEach(function(row) {
	                rowValues = [];
	                row.forEach(function(cell) {
	                    rowValues.push(cell.value);
	                });
	                values.push(rowValues);
	            });
	            if (sheet.trigger("changing", { data: values, range: range, changeType: COMMAND_TYPES.CLEAR })) {
	                return;
	            }
	            this.setState(this._state);
	        }
	    });

	    kendo.spreadsheet.EditCommand = PropertyChangeCommand.extend({
	        init: function(options) {
	            options.property = options.property || "input";
	            PropertyChangeCommand.fn.init.call(this, options);
	        },
	        _setRange: function(range) {
	            PropertyChangeCommand.prototype._setRange.apply(this, arguments);
	            this._editRange = this.options.arrayFormula ? range : range.sheet().activeCellSelection();
	        },
	        getState: function() {
	            this._state = this.range().getState();
	        },
	        exec: function() {
	            return this.range().sheet().withCultureDecimals(this._exec.bind(this));
	        },
	        undo: function() {
	            var editRange = this._editRange;
	            var state = this._state;
	            if (editRange.sheet().trigger("changing", { data: state.data[0][0].value, range: editRange, changeType: COMMAND_TYPES.EDIT })) {
	                return;
	            }
	            this.setState(this._state);
	        },
	        _exec: function() {
	            var arrayFormula = this.options.arrayFormula;
	            var editRange = this._editRange;

	            if (!editRange.enable()) {
	                return { reason: "error", type: "rangeDisabled" };
	            }

	            if (!editRange.canEditArrayFormula()) {
	                return { reason: "error", type: "intersectsArray" };
	            }

	            var value = this._value;
	            this.getState();
	            if (this.range().sheet().trigger("changing", { data: value, range: this._editRange, changeType: COMMAND_TYPES.EDIT })) {
	                return;
	            }

	            if (this._property == "value") {
	                editRange.value(value);
	                return;
	            }

	            try {
	                editRange.link(null);
	                if (value === "") {
	                    editRange.value(null);
	                } else {
	                    editRange.input(value, { arrayFormula: arrayFormula });
	                    if (/\n/.test(editRange.value())) {
	                        editRange.wrap(true);
	                    }
	                }
	                editRange._adjustRowHeight();

	                var validationState = editRange._getValidationState();
	                if (validationState) {
	                    return this.rejectState(validationState);
	                }
	            } catch(ex) {
	                if (ex instanceof kendo.spreadsheet.calc.ParseError) {
	                    return {
	                        title : "Error in formula",
	                        body  : ex+"",
	                        reason: "error"
	                    };
	                } else {
	                    throw ex;
	                }
	            }
	        }
	    });

	    kendo.spreadsheet.InsertCommentCommand = PropertyChangeCommand.extend({
	        init: function(options) {
	            options.property = "comment";
	            PropertyChangeCommand.fn.init.call(this, options);
	        }
	    });

	    kendo.spreadsheet.TextWrapCommand = PropertyChangeCommand.extend({
	        init: function(options) {
	            options.property = "wrap";
	            PropertyChangeCommand.fn.init.call(this, options);

	            this._value = options.value;
	        },
	        getState: function() {
	            var rowHeight = {};
	            this.range().forEachRow(function(range) {
	                var index = range.topLeft().row;

	                rowHeight[index] = range.sheet().rowHeight(index);
	            });

	            this._state = this.range().getState(this._property);
	            this._rowHeight = rowHeight;
	        },
	        undo: function() {
	            var sheet = this.range().sheet();
	            var rowHeight = this._rowHeight;

	            this.range().setState(this._state);

	            for (var row in rowHeight) {
	                sheet.rowHeight(row, rowHeight[row]);
	            }
	        }
	    });

	    kendo.spreadsheet.AdjustDecimalsCommand = Command.extend({
	        init: function(options) {
	            this._delta = options.value;
	            options.property = "format";
	            Command.fn.init.call(this, options);
	        },
	        exec: function() {
	            var sheet = this.range().sheet();
	            var delta = this._delta;
	            var formatting = kendo.spreadsheet.formatting;

	            this.getState();

	            sheet.batch(function() {
	                this.range().forEachCell(function(row, col, cell) {
	                    var format = cell.format;

	                    if (!format) {
	                        var value = cell.value;
	                        if (typeof value == "number" && /\./.test(value)) {
	                            format = "0." + String(value).split(".")[1].replace(/\d/g, "0");
	                        }
	                    }

	                    if (format || delta > 0) {
	                        format = formatting.adjustDecimals(format || "0", delta);
	                        sheet.range(row, col).format(format);
	                    }
	                });
	            }.bind(this));
	        }
	    });

	    kendo.spreadsheet.BorderChangeCommand = Command.extend({
	        init: function(options) {
	            options.property = "border";
	            Command.fn.init.call(this, options);
	            this._type = options.border;
	            this._style = options.style;
	        },
	        _batch: function(f) {
	            return this.range().sheet().batch(f, {});
	        },
	        exec: function() {
	            var self = this;
	            self.getState();
	            self._batch(function(){
	                self[self._type](self._style);
	            });
	        },
	        noBorders: function() {
	            this.range().insideBorders(null);
	            this.outsideBorders(null);
	        },
	        allBorders: function(style) {
	            this.range().insideBorders(style);
	            this.outsideBorders(style);
	        },
	        leftBorder: function(style) {
	            this.range().leftColumn().borderLeft(style);
	        },
	        rightBorder: function(style) {
	            this.range().rightColumn().borderRight(style);
	        },
	        topBorder: function(style) {
	            this.range().topRow().borderTop(style);
	        },
	        bottomBorder: function(style) {
	            this.range().bottomRow().borderBottom(style);
	        },
	        outsideBorders: function(style) {
	            var range = this.range();
	            range.leftColumn().borderLeft(style);
	            range.topRow().borderTop(style);
	            range.rightColumn().borderRight(style);
	            range.bottomRow().borderBottom(style);
	        },
	        insideBorders: function(style) {
	            this.range().insideBorders(style);
	            this.outsideBorders(null);
	        },
	        insideHorizontalBorders: function(style) {
	            this.range().insideHorizontalBorders(style);
	        },
	        insideVerticalBorders: function(style) {
	            this.range().insideVerticalBorders(style);
	        }
	    });

	    kendo.spreadsheet.MergeCellCommand = Command.extend({
	        init: function(options) {
	            Command.fn.init.call(this, options);
	            this._type = options.value;
	        },
	        exec: function() {
	            this.getState();
	            this[this._type]();
	        },
	        activate: function(ref) {
	            this.range().sheet().activeCell(ref);
	        },
	        getState: function() {
	            this._state = this.range().getState();
	        },
	        undo: function() {
	            if (this._type !== "unmerge") {
	                this.range().unmerge();
	                this.activate(this.range().topLeft());
	            }
	            this.range().setState(this._state);
	        },
	        cells: function() {
	            var range = this.range();
	            var ref = range._ref;

	            range.merge();
	            this.activate(ref);
	        },
	        horizontally: function() {
	            var ref = this.range().topRow()._ref;

	            this.range().forEachRow(function(range) {
	                range.merge();
	            });

	            this.activate(ref);
	        },
	        vertically: function() {
	            var ref = this.range().leftColumn()._ref;

	            this.range().forEachColumn(function(range) {
	                range.merge();
	            });

	            this.activate(ref);
	        },
	        unmerge: function() {
	            var range = this.range();
	            var ref = range._ref.topLeft;

	            range.unmerge();
	            this.activate(ref);
	        }
	    });

	    kendo.spreadsheet.FreezePanesCommand = Command.extend({
	        init: function(options) {
	            Command.fn.init.call(this, options);
	            this._type = options.value;
	        },
	        exec: function() {
	            this.getState();
	            this._topLeft = this.range().topLeft();
	            this[this._type]();
	        },
	        getState: function() {
	            this._state = this.range().sheet().getState();
	        },
	        undo: function() {
	            this.range().sheet().setState(this._state);
	        },
	        panes: function() {
	            var topLeft = this._topLeft;
	            var sheet = this.range().sheet();

	            sheet.frozenColumns(topLeft.col).frozenRows(topLeft.row);
	        },
	        rows: function() {
	            var topLeft = this._topLeft;
	            var sheet = this.range().sheet();

	            sheet.frozenRows(topLeft.row);
	        },
	        columns: function() {
	            var topLeft = this._topLeft;
	            var sheet = this.range().sheet();

	            sheet.frozenColumns(topLeft.col);
	        },
	        unfreeze: function() {
	            var sheet = this.range().sheet();
	            sheet.frozenRows(0).frozenColumns(0);
	        }
	    });

	    kendo.spreadsheet.PasteCommand = Command.extend({
	        init: function(options) {
	            Command.fn.init.call(this, options);
	            this._clipboard = options.workbook.clipboard();
	            this._clipboard.parse();
	            this._event = options.event;
	            this._clipboardContent = this._clipboard._content;
	            this._clipboardPasteRef = this._clipboard.pasteRef();
	            this._sheet = this._workbook.activeSheet();
	            this._range = this._sheet.range(this._clipboard.pasteRef());
	            this._state = this._range.getState();
	        },
	        exec: function() {
	            return this.range().sheet().withCultureDecimals(this._exec.bind(this));
	        },
	        undo: function() {
	            var sheet = this._sheet;
	            var range = sheet.range(this._clipboardPasteRef);
	            if (sheet.trigger("changing", { data: this._state.data, range: range, changeType: COMMAND_TYPES.PASTE })) {
	                return;
	            }
	            this.setState(this._state);
	        },
	        _exec: function() {
	            var status = this._clipboard.canPaste();
	            if (!status.canPaste) {
	                if (status.menuInvoked) {
	                    return { reason: "error", type: "useKeyboard" };
	                }
	                if (status.pasteOnMerged) {
	                    return { reason: "error", type: "modifyMerged" };
	                }
	                if (status.overflow) {
	                    return { reason: "error", type: "overflow" };
	                }
	                if (status.pasteOnDisabled) {
	                    this._event.preventDefault();
	                    return { reason: "error", type: "cannotModifyDisabled" };
	                }
	                return { reason: "error" };
	            }
	            var range = this._sheet.range(this._clipboardPasteRef);
	            if(this._workbook.trigger("paste", {range: range, clipboardContent: this._clipboardContent}) ||
	                this._sheet.trigger("changing", { data: this._clipboardContent.data, range: range, changeType: COMMAND_TYPES.PASTE })) {
	                this._event.preventDefault();
	                return;
	            } else {
	                this._sheet.range(this._clipboardPasteRef).setState(this._clipboardContent, this._clipboard);
	                range._adjustRowHeight();
	            }
	        }
	    });

	    kendo.spreadsheet.AdjustRowHeightCommand = Command.extend({
	        exec: function() {
	            var options = this.options;
	            var sheet = this._workbook.activeSheet();
	            var range = options.range || sheet.range(options.rowIndex);

	            range._adjustRowHeight();
	        }
	    });

	    kendo.spreadsheet.ToolbarPasteCommand = Command.extend({
	        exec: function() {
	            if (kendo.support.clipboard.paste) {
	                this._workbook._view.clipboard.focus().select();
	                //reason : focusclipbord
	                document.execCommand('paste');
	            } else {
	                return { reason: "error", type: "useKeyboard" };
	            }
	        }
	    });

	    kendo.spreadsheet.CutCommand = Command.extend({
	        _eventType: "cut",
	        init: function(options) {
	            Command.fn.init.call(this, options);
	            this._clipboard = options.workbook.clipboard();
	            this._event = options.event;
	        },
	        exec: function() {
	            var status = this._clipboard.canCopy();
	            var data = [], rangeValues, currentRow;
	            if (!status.canCopy) {
	                if (status.menuInvoked) {
	                    return { reason: "error", type: "useKeyboard" };
	                } else if (status.multiSelection) {
	                    return { reason: "error", type: "unsupportedSelection" };
	                }
	                return;
	            }
	            var range = this._workbook.activeSheet().selection();
	            if (this._eventType == "cut") {
	                if (!range.enable()) {
	                    this._event.preventDefault();
	                    return { reason: "error", type: "cannotModifyDisabled" };
	                }
	                this.getState();
	            }
	            if (this._workbook.trigger(this._eventType, { range: range })) {
	                this._event.preventDefault();
	            } else if (this._eventType == "cut") {
	                rangeValues = range.values();
	                rangeValues.forEach(function(row){
	                    currentRow = [];
	                    row.forEach(function(){
	                        currentRow.push({});
	                    });
	                    data.push(currentRow);
	                });
	                if (range.sheet().trigger("changing", { data: data, range: range, changeType: COMMAND_TYPES.CUT })) {
	                    return;
	                }
	                this._clipboard.cut();
	            } else {
	                this._clipboard.copy();
	            }
	        },
	        undo: function() {
	            var range = this.range();
	            if (range.sheet().trigger("changing", { data: this._state.data, range: range, changeType: COMMAND_TYPES.CUT })) {
	                return;
	            }
	            this.setState(this._state);
	        }
	    });

	    kendo.spreadsheet.CopyCommand = kendo.spreadsheet.CutCommand.extend({
	        _eventType: "copy",
	        undo: $.noop
	    });

	    function copyToClipboard(html) {
	        var textarea = document.createElement('textarea');
	        $(textarea).addClass("k-spreadsheet-clipboard")
	            .val(html)
	            .appendTo(document.body)
	            .focus()
	            .select();

	        document.execCommand('copy');

	        $(textarea).remove();
	    }

	    kendo.spreadsheet.ToolbarCopyCommand = Command.extend({
	        init: function(options) {
	            Command.fn.init.call(this, options);
	            this._clipboard = options.workbook.clipboard();
	        },
	        undo: $.noop,
	        exec: function() {
	            if (kendo.support.clipboard.copy) {
	                var clipboard = this._workbook._view.clipboard;
	                copyToClipboard(clipboard.html());
	                clipboard.trigger("copy");
	            } else {
	                return { reason: "error", type: "useKeyboard" };
	            }
	        }
	    });

	    kendo.spreadsheet.AutoFillCommand = Command.extend({
	        init: function(options) {
	            Command.fn.init.call(this, options);
	        },
	        origin: function(origin) {
	            this._origin = origin;
	        },
	        exec: function() {
	            var range = this.range(), autoFillData;
	            if (!range.enable()) {
	                return { reason: "error", type: "rangeDisabled" };
	            }
	            if (range.intersectingArrayFormula()) {
	                return { reason: "error", type: "intersectsArray" };
	            }
	            this.getState();
	            try {
	                autoFillData = range._previewFillFrom(this._origin);
	                if (range.sheet().trigger("changing", { data: autoFillData.props, range: autoFillData.dest, changeType: COMMAND_TYPES.AUTO_FILL })) {
	                    return;
	                }
	                autoFillData.dest._properties(autoFillData.props, true);
	            } catch(ex) {
	                if (ex instanceof kendo.spreadsheet.Range.FillError) {
	                    return { reason: "error", type: ex.code };
	                }
	                throw ex;
	            }
	        },
	        undo: function() {
	            var range = this.range();
	            var state = this._state;
	            if (range.sheet().trigger("changing", { data: state.data, range: range, changeType: COMMAND_TYPES.AUTO_FILL })) {
	                return;
	            }
	            this.setState(this._state);
	        }
	    });

	    kendo.spreadsheet.ToolbarCutCommand = Command.extend({
	        cannotUndo: true,
	        init: function(options) {
	            Command.fn.init.call(this, options);
	            this._clipboard = options.workbook.clipboard();
	        },
	        exec: function() {
	            if (kendo.support.clipboard.copy) {
	                var clipboard = this._workbook._view.clipboard;
	                copyToClipboard(clipboard.html());
	                clipboard.trigger("cut");
	            } else {
	                return { reason: "error", type: "useKeyboard" };
	            }
	        }
	    });

	    kendo.spreadsheet.FilterCommand = Command.extend({
	        undo: function() {
	            this.range().filter(this._state);
	        },
	        exec: function() {
	            var range = this.range();
	            this._state = range.hasFilter();
	            range.filter(!this._state);
	        }
	    });

	    kendo.spreadsheet.SortCommand = Command.extend({
	        undo: function() {
	            var sheet = this.range().sheet();
	            sheet.setState(this._state);
	        },
	        exec: function() {
	            var range = this.range();
	            var sheet = range.sheet();
	            var activeCell = sheet.activeCell();
	            var col = this.options.sheet ? activeCell.topLeft.col : (this.options.column || 0);
	            var ascending = this.options.value === "asc" ? true : false;

	            this._state = sheet.getState();

	            if (this.options.sheet) {
	                range = this.expandRange();
	            }

	            var reason = range.cantSort();
	            if (reason) {
	                return { reason: "error", type: reason.code };
	            }

	            range.sort({ column: col, ascending: ascending });
	        },
	        expandRange: function() {
	            var sheet = this.range().sheet();
	            return new kendo.spreadsheet.Range(sheet._sheetRef, sheet);
	        }
	    });

	    var ApplyFilterCommand = kendo.spreadsheet.ApplyFilterCommand = Command.extend({
	        column: function() {
	            return this.options.column || 0;
	        },
	        undo: function() {
	            var sheet = this.range().sheet();

	            sheet.clearFilter(this.column());

	            if (this._state.length) {
	                this.range().filter(this._state);
	            }
	        },
	        getState: function() {
	            var sheet = this.range().sheet();
	            var current = sheet.filter();

	            if (current) {
	                this._state = current.columns.filter(function(c) {
	                    return c.index == this.column();
	                }.bind(this));
	            }
	        },
	        exec: function() {
	            var range = this.range();
	            var column = this.column();
	            var current = range.sheet().filter();
	            var options;
	            var filterRule;
	            var exists = false;

	            if (this.options.valueFilter) {
	                filterRule = { column: column, filter: new kendo.spreadsheet.ValueFilter(this.options.valueFilter) };
	            } else if (this.options.customFilter) {
	                filterRule = { column: column, filter: new kendo.spreadsheet.CustomFilter(this.options.customFilter) };
	            }

	            this.getState();

	            if (current && current.ref.eq(range._ref) && current.columns.length) {
	                current.columns.forEach(function(element) {
	                    if (element.index === column) {
	                        exists = true;
	                    }
	                });

	                options = current.columns.map(function(element) {
	                    return element.index === column ? filterRule : { column: element.index, filter: element.filter };
	                });

	                if (!exists) {
	                    options.push(filterRule);
	                }
	            } else {
	                options = filterRule;
	            }

	            range.filter(options);
	        }
	    });

	    kendo.spreadsheet.ClearFilterCommand = ApplyFilterCommand.extend({
	        exec: function() {
	            var range = this.range();
	            var column = this.column();

	            this.getState();
	            range.clearFilter(column);
	        }
	    });

	    kendo.spreadsheet.HideLineCommand = Command.extend({
	        init: function(options) {
	            Command.fn.init.call(this, options);
	            this.axis = options.axis;
	        },

	        undo: function() {
	            var sheet = this.range().sheet();
	            sheet.setAxisState(this._state);
	        },

	        exec: function() {
	            var sheet = this.range().sheet();
	            this._state = sheet.getAxisState();

	            if (this.axis == "row") {
	                sheet.axisManager().hideSelectedRows();
	            } else {
	                sheet.axisManager().hideSelectedColumns();
	            }
	        }
	    });

	    kendo.spreadsheet.UnHideLineCommand = kendo.spreadsheet.HideLineCommand.extend({
	        exec: function() {
	            var sheet = this.range().sheet();
	            this._state = sheet.getAxisState();

	            if (this.axis == "row") {
	                sheet.axisManager().unhideSelectedRows();
	            } else {
	                sheet.axisManager().unhideSelectedColumns();
	            }
	        }
	    });

	    var DeleteCommand = Command.extend({
	        exec: function() {
	            this._expandedRange = this._expand(this.range());
	            this._state = this._expandedRange.getState();
	            this._indexes = this._exec(this._expandedRange.sheet());
	        },
	        undo: function() {
	            var self = this;
	            var range = self._expandedRange;
	            var sheet = range.sheet();
	            sheet.batch(function(){
	                self._indexes.forEach(function(x){
	                    self._undoOne(sheet, x);
	                    sheet._restoreModifiedFormulas(x.formulas);
	                });
	                range.setState(self._state);
	            }, { layout: true, recalc: true, ref: range._ref });
	        }
	    });

	    kendo.spreadsheet.DeleteRowCommand = DeleteCommand.extend({
	        _expand: function(range) {
	            return range.resize({ left: -Infinity, right: +Infinity });
	        },
	        _exec: function(sheet) {
	            return sheet.axisManager().deleteSelectedRows();
	        },
	        _undoOne: function(sheet, x) {
	            sheet.insertRow(x.index);
	            sheet.rowHeight(x.index, x.height);
	        }
	    });

	    kendo.spreadsheet.DeleteColumnCommand = DeleteCommand.extend({
	        _expand: function(range) {
	            return range.resize({ top: -Infinity, bottom: +Infinity });
	        },
	        _exec: function(sheet) {
	            return sheet.axisManager().deleteSelectedColumns();
	        },
	        _undoOne: function(sheet, x) {
	            sheet.insertColumn(x.index);
	            sheet.columnWidth(x.index, x.width);
	        }
	    });

	    var AddCommand = Command.extend({
	        init: function(options) {
	            Command.fn.init.call(this, options);
	            this._value = options.value;
	        },
	        undo: function() {
	            var self = this;
	            var sheet = self.range().sheet();
	            sheet.batch(function(){
	                for (var i = self._pos.count; --i >= 0;) {
	                    self._undoOne(sheet, self._pos.base);
	                }
	            }, { layout: true, recalc: true });
	        }
	    });

	    kendo.spreadsheet.AddColumnCommand = AddCommand.extend({
	        exec: function() {
	            var value = this._value;
	            var sheet = this.range().sheet();
	            var result = sheet.axisManager().preventAddColumn();

	            if(!result && value === "right") {
	                result = sheet.axisManager().preventAddColumnAfterLast();
	            }

	            if (result) {
	                return result;
	            }

	            if (value === "left") {
	                this._pos = sheet.axisManager().addColumnLeft();
	            } else {
	                this._pos = sheet.axisManager().addColumnRight();
	            }
	        },
	        _undoOne: function(sheet, index) {
	            sheet.deleteColumn(index);
	        }
	    });

	    kendo.spreadsheet.AddRowCommand = AddCommand.extend({
	        exec: function() {
	            var value = this._value;
	            var sheet = this.range().sheet();
	            var result = sheet.axisManager().preventAddRow();

	            if(!result && value === "below") {
	                result = sheet.axisManager().preventAddRowAfterLast();
	            }

	            if (result) {
	                return result;
	            }

	            if (value === "above") {
	                this._pos = sheet.axisManager().addRowAbove();
	            } else {
	                this._pos = sheet.axisManager().addRowBelow();
	            }
	        },
	        _undoOne: function(sheet, index) {
	            sheet.deleteRow(index);
	        }
	    });

	    kendo.spreadsheet.EditValidationCommand = Command.extend({
	        init: function(options) {
	            Command.fn.init.call(this, options);
	            this._value = options.value;
	        },
	        exec: function() {
	            var self = this, sheet = self.range().sheet();
	            this.getState();
	            if (sheet.trigger("changing", { data: self._value, range: self.range(), changeType: COMMAND_TYPES.VALIDATION })) {
	                return;
	            }
	            sheet.withCultureDecimals(function(){
	                self.range().validation(self._value);
	            });
	        },
	        undo: function() {
	            var editRange = this.range();
	            var state = this._state;
	            if (editRange.sheet().trigger("changing", { data: state.data[0][0].validation, range: editRange, changeType: COMMAND_TYPES.VALIDATION })) {
	                return;
	            }
	            this.setState(this._state);
	        }
	    });

	    kendo.spreadsheet.OpenCommand = Command.extend({
	        cannotUndo: true,
	        exec: function() {
	            var file = this.options.file;
	            if (file.name.match(/.xlsx$/i) === null) {
	                return { reason: "error", type: "openUnsupported" };
	            }

	            var workbook = this.options.workbook;
	            workbook.fromFile(this.options.file).then(function(){
	                var errors = workbook.excelImportErrors;
	                if (errors && errors.length) {
	                    workbook._view.openDialog("importError", {
	                        errors: errors
	                    });
	                }
	            });
	        }
	    });

	    kendo.spreadsheet.SaveAsCommand = Command.extend({
	        cannotUndo: true,
	        exec: function() {
	            var fileName = this.options.name + this.options.extension;
	            if (this.options.extension === ".xlsx") {
	                this.options.workbook.saveAsExcel({
	                    fileName: fileName
	                });
	            } else if (this.options.extension === ".pdf") {
	                this.options.workbook.saveAsPDF($.extend(this.options.pdf, {workbook: this.options.workbook, fileName: fileName}));
	            }
	        }
	    });

	    var NameCommand = Command.extend({
	        init: function(options) {
	            Command.fn.init.call(this, options);
	            this._name = options.name;
	            this._value = options.value;
	        },
	        getState: function() {
	            this._state = this._workbook.nameDefinition(this._name);
	        },
	        setState: function() {
	            this._workbook.nameDefinition(this._name, this._state);
	            this._workbook.trigger("change", { recalc: true });
	        }
	    });

	    kendo.spreadsheet.DefineNameCommand = NameCommand.extend({
	        exec: function() {
	            this.getState();
	            try {
	                this._workbook.defineName(this._name, this._value);
	                this._workbook.trigger("change", { recalc: true });
	            } catch(ex) {
	                return {
	                    title: "Error",
	                    body: ex+"",
	                    reason: "error"
	                };
	            }
	        }
	    });

	    kendo.spreadsheet.DeleteNameCommand = NameCommand.extend({
	        exec: function() {
	            this.getState();
	            this._workbook.undefineName(this._name);
	            this._workbook.trigger("change", { recalc: true });
	        }
	    });

	})(kendo);

	}, __webpack_require__(3));


/***/ }),

/***/ 1586:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("S/9S");

/***/ }),

/***/ 1587:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FPoQ");

/***/ })

/******/ });

/***/ }),

/***/ "IPwA":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(981);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 971:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("cmba");

/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(971) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($) {

	var kendo = window.kendo,
	    Editor = kendo.ui.editor,
	    Tool = Editor.Tool,
	    Command = Editor.Command,
	    ToolTemplate = Editor.ToolTemplate,
	    EditorUtils = Editor.EditorUtils,
	    dom = Editor.Dom,
	    RangeUtils = Editor.RangeUtils,
	    registerTool = EditorUtils.registerTool;

	var CopyFormatCommand = Command.extend({
	    init: function (options) {
	        Command.fn.init.call(this, options);
	    },

	    exec: function(){
	        var range = this.lockRange(true);
	        this.inlineStyles = [];
	        this.blockStyles = [];
	        this.collectStyles(range);
	        this.editor.inlineStyles = this.inlineStyles;
	        this.editor.blockStyles = this.blockStyles;
	        this.releaseRange(range);
	    },

	    collectStyles: function(range) {
	        var rangeNodes = RangeUtils.nodes(range);
	        var node;

	        if(rangeNodes.length === 1) {
	            node = rangeNodes[0].parentNode;
	        } else {
	            node = range.startContainer;
	        }

	        while(node && !dom.is(node, "body") && node.getAttribute("data-role") !== "editor") {
	            if(dom.isBlock(node)) {
	                this.populateStyles(node, "blockStyles");
	                if (dom.is(node, "li")) {
	                    node = node.parentNode;
	                } else {
	                    node = null;
	                }
	            } else {
	                this.populateStyles(node, "inlineStyles");
	                node = node.parentNode;
	            }
	        }
	    },

	    populateStyles: function(node, destination) {
	        var styles = node.style;
	        var attributes = node.attributes;
	        var nodeStyles = {
	            tags: [ node.tagName ],
	            attr: {
	                style: {}
	            }
	        };
	        var styleValue, styleKey, attributeKey, attributeValue, i;

	        for(i = 0; styles && i < styles.length; i++) {
	            styleKey = styles[i];
	            styleValue = styles[styleKey];
	            nodeStyles.attr.style[styleKey] = styleValue;
	        }

	        for(i = 0; attributes && i < attributes.length; i++) {
	            attributeKey = attributes[i].nodeName;
	            attributeValue = attributes[i].nodeValue;
	            if(attributeKey === "style") {
	                continue;
	            } else if(attributeKey === "class") {
	                nodeStyles.attr.className = attributeValue;
	            } else {
	                nodeStyles.attr[attributeKey] = attributeValue;
	            }
	        }

	        this[destination].push(nodeStyles);
	    }
	});

	var ApplyFormatCommand = Command.extend({
	    init: function (options) {
	        Command.fn.init.call(this, options);
	    },

	    exec: function(){
	        var range = this.lockRange(true);
	        var markers = RangeUtils.getMarkers(range);
	        var editor = this.editor;
	        var inlineStyles = editor.inlineStyles;
	        var blockStyles = editor.blockStyles;
	        var nodes;

	        if((!inlineStyles || inlineStyles.length === 0) && (!blockStyles || blockStyles.length === 0)) {
	            return;
	        }

	        if(markers.length === 3) {
	            this.marker.removeCaret(range);
	            this.marker.caret = null;
	        }

	        this.removeEmptyElementsFromRange(range);
	        nodes = RangeUtils.nodes(range);
	        this.cleanInlineParents(nodes);
	        dom.normalize(range.commonAncestorContainer);

	        if(markers.length === 2) {
	            range.setStartAfter(markers[0]);
	            range.setEndBefore(markers[1]);
	        } else {
	            range.setStartBefore(nodes[0]);
	            range.setEndAfter(nodes[0]);
	        }

	        nodes = RangeUtils.nodes(range);

	        if(nodes && blockStyles && blockStyles.length) {
	            this.applyBlockStyles(nodes, blockStyles);
	        }

	        if(nodes && inlineStyles && inlineStyles.length) {
	            this.applyInlineStyles(nodes, inlineStyles);
	        }

	        this.releaseRange(range);
	    },

	    removeEmptyElementsFromRange: function(range) {
	        var isEmptyInline = function(node) {
	            return dom.isInline(node) && !node.firstChild && !dom.isMarker(node);
	        };
	        var emptyElements, i;

	        emptyElements = RangeUtils.getAll(range, isEmptyInline);

	        if (emptyElements && emptyElements.length > 0) {
	            for(i = 0; i < emptyElements.length; i++) {
	                emptyElements[i].parentNode.removeChild(emptyElements[i]);
	            }
	        }
	    },

	    cleanInlineParents: function(nodes) {
	        var i, node, parent, children, j, child, newNode;

	        for(i = 0; i < nodes.length; i++) {
	            node = nodes[i];
	            parent = node.parentNode;

	            if(this.immutableParent(node)) {
	                continue;
	            }

	            while(parent && dom.isInline(parent)) {
	                children = parent.childNodes;

	                for(j = 0; j < children.length; j++) {
	                    child = children[j];

	                    if(!dom.isMarker(child) && child !== node) {
	                        newNode = parent.cloneNode(true);
	                        newNode.innerHTML = "";
	                        dom.wrap(child, newNode);
	                    }
	                }

	                dom.unwrap(parent);
	                parent = node.parentNode;
	            }
	        }
	    },

	    applyBlockStyles: function(nodes, blockStyles) {
	        var formatTag = blockStyles[0].tags[0];
	        var attr = blockStyles[0].attr;
	        var document = this.editor.document;
	        var i, len, node, wrapper, blockParent, outerWrapper;
	        var previousNodes, nextNodes, previous, next, prevWrapper, nextWrapper, child, j, listItems;

	        for (i = 0, len = nodes.length; i < len; i++) {
	            node = nodes[i];

	            if(dom.isWhitespace(node) || this.immutableParent(node)) {
	                continue;
	            }

	            blockParent = dom.blockParentOrBody(node);

	            if (blockParent.tagName !== "BODY" && blockParent.tagName !== formatTag) {
	                if(blockParent.tagName !== "LI" && blockParent.tagName !== "TD" && blockParent.tagName !== "TH") {
	                    previousNodes = [];
	                    nextNodes = [];
	                    previous = node.previousSibling;
	                    next = node.nextSibling;

	                    while(previous) {
	                        if(!dom.isMarker(previous)) {
	                            previousNodes.push(previous);
	                        }

	                        previous = previous.previousSibling;
	                    }

	                    if(previousNodes.length) {
	                        prevWrapper = blockParent.cloneNode(true);
	                        prevWrapper.innerHTML = "";
	                        dom.insertBefore(prevWrapper, previousNodes[0]);

	                        for(j = 0; j < previousNodes.length; j++) {
	                            child = previousNodes[j];
	                            dom.insertAt(prevWrapper, child, 0);
	                        }
	                    }

	                    while(next) {
	                        if(!dom.isMarker(next)) {
	                            nextNodes.push(next);
	                        }

	                        next = next.nextSibling;
	                    }

	                    if(nextNodes.length) {
	                        nextWrapper = blockParent.cloneNode(true);
	                        nextWrapper.innerHTML = "";
	                        dom.insertBefore(nextWrapper, nextNodes[0]);

	                        for(j = 0; j < nextNodes.length; j++) {
	                            child = nextNodes[j];
	                            nextWrapper.appendChild(child);
	                        }
	                    }

	                    dom.unwrap(blockParent);
	                }

	                wrapper = dom.create(document, formatTag, attr);
	                dom.wrap(node, wrapper);
	            } else if (blockParent.tagName === formatTag) {
	                dom.attr(blockParent, attr);
	            }
	        }

	        if(blockParent && blockStyles.length === 2 && blockParent.tagName !== "LI" && formatTag === "LI") {
	            listItems = [];

	            while(dom.is(wrapper, "li")) {
	                listItems.push(wrapper);
	                wrapper = dom.prev(wrapper);
	            }

	            outerWrapper = dom.create(document, blockStyles[1].tags[0], blockStyles[1].attr);
	            dom.insertBefore(outerWrapper, listItems[listItems.length - 1]);
	            outerWrapper.appendChild(listItems[0]);

	            for (i = 1, len = listItems.length; i < len; i++) {
	                dom.insertBefore(listItems[i], outerWrapper.firstChild);
	            }
	        } else if(blockParent && blockStyles.length === 2 && blockParent.tagName !== "LI") {
	            outerWrapper = dom.create(document, blockStyles[1].tags[0], blockStyles[1].attr);
	            dom.wrap(wrapper, outerWrapper);
	        }
	    },

	    applyInlineStyles: function(nodes, inlineStyles) {
	        var document = this.editor.document;
	        var currentStyle, createdNode, topNode, i, newNode, node;

	        for(i = 0; i < inlineStyles.length; i++) {
	            currentStyle = inlineStyles[i];
	            createdNode = dom.create(document, currentStyle.tags[0], currentStyle.attr);

	            if(topNode) {
	                createdNode.appendChild(topNode);
	            }

	            topNode = createdNode;
	        }

	        if(topNode) {
	            for(i = 0; i < nodes.length; i++) {
	                node = nodes[i];
	                if(dom.isWhitespace(node) || this.immutableParent(node)) {
	                    continue;
	                }
	                newNode = topNode.cloneNode(true);
	                dom.insertBefore(newNode, node);

	                while(newNode.children && newNode.children.length) {
	                    newNode = newNode.children[0];
	                }

	                newNode.appendChild(node);
	            }
	        }
	    },

	    immutables: function() {
	        return this.editor && this.editor.options.immutables;
	    },

	    immutableParent: function(node) {
	        return this.immutables() && Editor.Immutables.immutableParent(node);
	    }
	});

	var CopyFormatTool = Tool.extend({
	    init: function (options) {
	        Tool.fn.init.call(this, options);
	    },

	    command: function (commandArguments) {
	        return new CopyFormatCommand(commandArguments);
	    }
	});

	var ApplyFormatTool = Tool.extend({
	    init: function (options) {
	        Tool.fn.init.call(this, options);
	    },

	    command: function (commandArguments) {
	        return new ApplyFormatCommand(commandArguments);
	    }
	});

	$.extend(Editor, {
	    CopyFormatCommand: CopyFormatCommand,
	    ApplyFormatCommand: ApplyFormatCommand,
	    CopyFormatTool: CopyFormatTool,
	    ApplyFormatTool: ApplyFormatTool
	});

	registerTool("copyFormat", new CopyFormatTool({ template: new ToolTemplate({ template: EditorUtils.buttonTemplate, title: "Copy format" }) }));
	registerTool("applyFormat", new ApplyFormatTool({ template: new ToolTemplate({ template: EditorUtils.buttonTemplate, title: "Apply format" }) }));

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "IPyL":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1123);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1123:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1124),
	        __webpack_require__(1125)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "dataviz.chart",
	    name: "Chart",
	    category: "dataviz",
	    description: "The Chart widget uses modern browser technologies to render high-quality data visualizations in the browser.",
	    depends: [ "data", "userevents", "drawing", "dataviz.core", "dataviz.themes" ],
	    features: [{
	        id: "dataviz.chart-pdf-export",
	        name: "PDF export",
	        description: "Export Chart as PDF",
	        depends: [ "pdf" ]
	    }]
	};

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1124:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ralJ");

/***/ }),

/***/ 1125:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("K8Pb");

/***/ })

/******/ });

/***/ }),

/***/ "IRr6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__("ZZFX");
var FUNCTION_STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
var FUNCTION_ARGUMENT_NAMES = /([^\s,]+)/g;
var AG_GRID_STOP_PROPAGATION = '__ag_Grid_Stop_Propagation';
// util class, only used when debugging, for printing time to console
var Timer = (function () {
    function Timer() {
        this.timestamp = new Date().getTime();
    }
    Timer.prototype.print = function (msg) {
        var duration = (new Date().getTime()) - this.timestamp;
        console.log(msg + " = " + duration);
        this.timestamp = new Date().getTime();
    };
    return Timer;
}());
exports.Timer = Timer;
/** HTML Escapes. */
var HTML_ESCAPES = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
var reUnescapedHtml = /[&<>"']/g;
var Utils = (function () {
    function Utils() {
    }
    // if the key was passed before, then doesn't execute the func
    Utils.doOnce = function (func, key) {
        if (this.doOnceFlags[key]) {
            return;
        }
        func();
        this.doOnceFlags[key] = true;
    };
    // returns true if the event is close to the original event by X pixels either vertically or horizontally.
    // we only start dragging after X pixels so this allows us to know if we should start dragging yet.
    Utils.areEventsNear = function (e1, e2, pixelCount) {
        // by default, we wait 4 pixels before starting the drag
        if (pixelCount === 0) {
            return false;
        }
        var diffX = Math.abs(e1.clientX - e2.clientX);
        var diffY = Math.abs(e1.clientY - e2.clientY);
        return Math.max(diffX, diffY) <= pixelCount;
    };
    Utils.shallowCompare = function (arr1, arr2) {
        // if both are missing, then they are the same
        if (this.missing(arr1) && this.missing(arr2)) {
            return true;
        }
        // if one is present, but other is missing, then then are different
        if (this.missing(arr1) || this.missing(arr2)) {
            return false;
        }
        if (arr1.length !== arr2.length) {
            return false;
        }
        for (var i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) {
                return false;
            }
        }
        return true;
    };
    Utils.getNameOfClass = function (TheClass) {
        var funcNameRegex = /function (.{1,})\(/;
        var funcAsString = TheClass.toString();
        var results = (funcNameRegex).exec(funcAsString);
        return (results && results.length > 1) ? results[1] : "";
    };
    Utils.values = function (object) {
        var result = [];
        this.iterateObject(object, function (key, value) {
            result.push(value);
        });
        return result;
    };
    Utils.getValueUsingField = function (data, field, fieldContainsDots) {
        if (!field || !data) {
            return;
        }
        // if no '.', then it's not a deep value
        if (!fieldContainsDots) {
            return data[field];
        }
        else {
            // otherwise it is a deep value, so need to dig for it
            var fields = field.split('.');
            var currentObject = data;
            for (var i = 0; i < fields.length; i++) {
                currentObject = currentObject[fields[i]];
                if (this.missing(currentObject)) {
                    return null;
                }
            }
            return currentObject;
        }
    };
    Utils.getScrollLeft = function (element, rtl) {
        var scrollLeft = element.scrollLeft;
        if (rtl) {
            // Absolute value - for FF that reports RTL scrolls in negative numbers
            scrollLeft = Math.abs(scrollLeft);
            // Get Chrome and Safari to return the same value as well
            if (this.isBrowserSafari() || this.isBrowserChrome()) {
                scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
            }
        }
        return scrollLeft;
    };
    Utils.cleanNumber = function (value) {
        if (typeof value === 'string') {
            value = parseInt(value);
        }
        if (typeof value === 'number') {
            value = Math.floor(value);
        }
        else {
            value = null;
        }
        return value;
    };
    Utils.setScrollLeft = function (element, value, rtl) {
        if (rtl) {
            // Chrome and Safari when doing RTL have the END position of the scroll as zero, not the start
            if (this.isBrowserSafari() || this.isBrowserChrome()) {
                value = element.scrollWidth - element.clientWidth - value;
            }
            // Firefox uses negative numbers when doing RTL scrolling
            if (this.isBrowserFirefox()) {
                value *= -1;
            }
        }
        element.scrollLeft = value;
    };
    Utils.iterateObject = function (object, callback) {
        if (this.missing(object)) {
            return;
        }
        var keys = Object.keys(object);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = object[key];
            callback(key, value);
        }
    };
    Utils.cloneObject = function (object) {
        var copy = {};
        var keys = Object.keys(object);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = object[key];
            copy[key] = value;
        }
        return copy;
    };
    Utils.map = function (array, callback) {
        var result = [];
        for (var i = 0; i < array.length; i++) {
            var item = array[i];
            var mappedItem = callback(item);
            result.push(mappedItem);
        }
        return result;
    };
    Utils.mapObject = function (object, callback) {
        var result = [];
        Utils.iterateObject(object, function (key, value) {
            result.push(callback(value));
        });
        return result;
    };
    Utils.forEach = function (array, callback) {
        if (!array) {
            return;
        }
        for (var i = 0; i < array.length; i++) {
            var value = array[i];
            callback(value, i);
        }
    };
    Utils.filter = function (array, callback) {
        var result = [];
        array.forEach(function (item) {
            if (callback(item)) {
                result.push(item);
            }
        });
        return result;
    };
    Utils.getAllKeysInObjects = function (objects) {
        var allValues = {};
        objects.forEach(function (obj) {
            if (obj) {
                Object.keys(obj).forEach(function (key) { return allValues[key] = null; });
            }
        });
        return Object.keys(allValues);
    };
    Utils.mergeDeep = function (dest, source) {
        if (this.exists(source)) {
            this.iterateObject(source, function (key, newValue) {
                var oldValue = dest[key];
                if (oldValue === newValue) {
                    return;
                }
                if (typeof oldValue === 'object' && typeof newValue === 'object') {
                    Utils.mergeDeep(oldValue, newValue);
                }
                else {
                    dest[key] = newValue;
                }
            });
        }
    };
    Utils.assign = function (object) {
        var _this = this;
        var sources = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            sources[_i - 1] = arguments[_i];
        }
        sources.forEach(function (source) {
            if (_this.exists(source)) {
                _this.iterateObject(source, function (key, value) {
                    object[key] = value;
                });
            }
        });
        return object;
    };
    Utils.parseYyyyMmDdToDate = function (yyyyMmDd, separator) {
        try {
            if (!yyyyMmDd)
                return null;
            if (yyyyMmDd.indexOf(separator) === -1)
                return null;
            var fields = yyyyMmDd.split(separator);
            if (fields.length != 3)
                return null;
            return new Date(Number(fields[0]), Number(fields[1]) - 1, Number(fields[2]));
        }
        catch (e) {
            return null;
        }
    };
    Utils.serializeDateToYyyyMmDd = function (date, separator) {
        if (!date)
            return null;
        return date.getFullYear() + separator + Utils.pad(date.getMonth() + 1, 2) + separator + Utils.pad(date.getDate(), 2);
    };
    Utils.pad = function (num, totalStringSize) {
        var asString = num + "";
        while (asString.length < totalStringSize)
            asString = "0" + asString;
        return asString;
    };
    Utils.pushAll = function (target, source) {
        if (this.missing(source) || this.missing(target)) {
            return;
        }
        source.forEach(function (func) { return target.push(func); });
    };
    Utils.createArrayOfNumbers = function (first, last) {
        var result = [];
        for (var i = first; i <= last; i++) {
            result.push(i);
        }
        return result;
    };
    Utils.getFunctionParameters = function (func) {
        var fnStr = func.toString().replace(FUNCTION_STRIP_COMMENTS, '');
        var result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(FUNCTION_ARGUMENT_NAMES);
        if (result === null) {
            return [];
        }
        else {
            return result;
        }
    };
    Utils.find = function (collection, predicate, value) {
        if (collection === null || collection === undefined) {
            return null;
        }
        if (!Array.isArray(collection)) {
            var objToArray = this.values(collection);
            return this.find(objToArray, predicate, value);
        }
        var collectionAsArray = collection;
        var firstMatchingItem;
        for (var i = 0; i < collectionAsArray.length; i++) {
            var item = collectionAsArray[i];
            if (typeof predicate === 'string') {
                if (item[predicate] === value) {
                    firstMatchingItem = item;
                    break;
                }
            }
            else {
                var callback = predicate;
                if (callback(item)) {
                    firstMatchingItem = item;
                    break;
                }
            }
        }
        return firstMatchingItem;
    };
    Utils.toStrings = function (array) {
        return this.map(array, function (item) {
            if (item === undefined || item === null || !item.toString) {
                return null;
            }
            else {
                return item.toString();
            }
        });
    };
    Utils.iterateArray = function (array, callback) {
        for (var index = 0; index < array.length; index++) {
            var value = array[index];
            callback(value, index);
        }
    };
    //Returns true if it is a DOM node
    //taken from: http://stackoverflow.com/questions/384286/javascript-isdom-how-do-you-check-if-a-javascript-object-is-a-dom-object
    Utils.isNode = function (o) {
        return (typeof Node === "function" ? o instanceof Node :
            o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName === "string");
    };
    //Returns true if it is a DOM element
    //taken from: http://stackoverflow.com/questions/384286/javascript-isdom-how-do-you-check-if-a-javascript-object-is-a-dom-object
    Utils.isElement = function (o) {
        return (typeof HTMLElement === "function" ? o instanceof HTMLElement :
            o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string");
    };
    Utils.isNodeOrElement = function (o) {
        return this.isNode(o) || this.isElement(o);
    };
    Utils.isEventFromPrintableCharacter = function (event) {
        var pressedChar = String.fromCharCode(event.charCode);
        // newline is an exception, as it counts as a printable character, but we don't
        // want to start editing when it is pressed. without this check, if user is in chrome
        // and editing a cell, and they press ctrl+enter, the cell stops editing, and then
        // starts editing again with a blank value (two 'key down' events are fired). to
        // test this, remove the line below, edit a cell in chrome and hit ctrl+enter while editing.
        // https://ag-grid.atlassian.net/browse/AG-605
        if (this.isKeyPressed(event, constants_1.Constants.KEY_NEW_LINE)) {
            return false;
        }
        if (exports._.exists(event.key)) {
            // modern browser will implement key, so we return if key is length 1, eg if it is 'a' for the
            // a key, or '2' for the '2' key. non-printable characters have names, eg 'Enter' or 'Backspace'.
            return event.key.length === 1;
        }
        else {
            // otherwise, for older browsers, we test against a list of characters, which doesn't include
            // accents for non-English, but don't care much, as most users are on modern browsers
            return Utils.PRINTABLE_CHARACTERS.indexOf(pressedChar) >= 0;
        }
    };
    //adds all type of change listeners to an element, intended to be a text field
    Utils.addChangeListener = function (element, listener) {
        element.addEventListener("changed", listener);
        element.addEventListener("paste", listener);
        element.addEventListener("input", listener);
        // IE doesn't fire changed for special keys (eg delete, backspace), so need to
        // listen for this further ones
        element.addEventListener("keydown", listener);
        element.addEventListener("keyup", listener);
    };
    //if value is undefined, null or blank, returns null, otherwise returns the value
    Utils.makeNull = function (value) {
        var valueNoType = value;
        if (value === null || value === undefined || valueNoType === "") {
            return null;
        }
        else {
            return value;
        }
    };
    Utils.missing = function (value) {
        return !this.exists(value);
    };
    Utils.missingOrEmpty = function (value) {
        return this.missing(value) || value.length === 0;
    };
    Utils.missingOrEmptyObject = function (value) {
        return this.missing(value) || Object.keys(value).length === 0;
    };
    Utils.exists = function (value) {
        if (value === null || value === undefined || value === '') {
            return false;
        }
        else {
            return true;
        }
    };
    Utils.firstExistingValue = function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        for (var i = 0; i < values.length; i++) {
            var value = values[i];
            if (exports._.exists(value))
                return value;
        }
        return null;
    };
    Utils.anyExists = function (values) {
        if (values) {
            for (var i = 0; i < values.length; i++) {
                if (this.exists(values[i])) {
                    return true;
                }
            }
        }
        return false;
    };
    Utils.existsAndNotEmpty = function (value) {
        return this.exists(value) && value.length > 0;
    };
    Utils.removeAllChildren = function (node) {
        if (node) {
            while (node.hasChildNodes()) {
                node.removeChild(node.lastChild);
            }
        }
    };
    Utils.removeElement = function (parent, cssSelector) {
        this.removeFromParent(parent.querySelector(cssSelector));
    };
    Utils.removeFromParent = function (node) {
        if (node && node.parentNode) {
            node.parentNode.removeChild(node);
        }
    };
    Utils.isVisible = function (element) {
        return (element.offsetParent !== null);
    };
    /**
     * loads the template and returns it as an element. makes up for no simple way in
     * the dom api to load html directly, eg we cannot do this: document.createElement(template)
     */
    Utils.loadTemplate = function (template) {
        var tempDiv = document.createElement("div");
        tempDiv.innerHTML = template;
        return tempDiv.firstChild;
    };
    Utils.appendHtml = function (eContainer, htmlTemplate) {
        if (eContainer.lastChild) {
            // https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentHTML
            // we put the items at the start, so new items appear underneath old items,
            // so when expanding/collapsing groups, the new rows don't go on top of the
            // rows below that are moving our of the way
            eContainer.insertAdjacentHTML('afterbegin', htmlTemplate);
        }
        else {
            eContainer.innerHTML = htmlTemplate;
        }
    };
    Utils.addOrRemoveCssClass = function (element, className, addOrRemove) {
        if (addOrRemove) {
            this.addCssClass(element, className);
        }
        else {
            this.removeCssClass(element, className);
        }
    };
    Utils.callIfPresent = function (func) {
        if (func) {
            func();
        }
    };
    Utils.addCssClass = function (element, className) {
        var _this = this;
        if (!className || className.length === 0) {
            return;
        }
        if (className.indexOf(' ') >= 0) {
            className.split(' ').forEach(function (value) { return _this.addCssClass(element, value); });
            return;
        }
        if (element.classList) {
            if (!element.classList.contains(className)) {
                element.classList.add(className);
            }
        }
        else {
            if (element.className && element.className.length > 0) {
                var cssClasses = element.className.split(' ');
                if (cssClasses.indexOf(className) < 0) {
                    cssClasses.push(className);
                    element.className = cssClasses.join(' ');
                }
            }
            else {
                element.className = className;
            }
        }
    };
    Utils.containsClass = function (element, className) {
        if (element.classList) {
            // for modern browsers
            return element.classList.contains(className);
        }
        else if (element.className) {
            // for older browsers, check against the string of class names
            // if only one class, can check for exact match
            var onlyClass = element.className === className;
            // if many classes, check for class name, we have to pad with ' ' to stop other
            // class names that are a substring of this class
            var contains = element.className.indexOf(' ' + className + ' ') >= 0;
            // the padding above then breaks when it's the first or last class names
            var startsWithClass = element.className.indexOf(className + ' ') === 0;
            var endsWithClass = element.className.lastIndexOf(' ' + className) === (element.className.length - className.length - 1);
            return onlyClass || contains || startsWithClass || endsWithClass;
        }
        else {
            // if item is not a node
            return false;
        }
    };
    Utils.getElementAttribute = function (element, attributeName) {
        if (element.attributes) {
            if (element.attributes[attributeName]) {
                var attribute = element.attributes[attributeName];
                return attribute.value;
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    };
    Utils.offsetHeight = function (element) {
        return element && element.clientHeight ? element.clientHeight : 0;
    };
    Utils.offsetWidth = function (element) {
        return element && element.clientWidth ? element.clientWidth : 0;
    };
    Utils.sortNumberArray = function (numberArray) {
        numberArray.sort(function (a, b) { return a - b; });
    };
    Utils.removeCssClass = function (element, className) {
        if (element.classList) {
            if (element.classList.contains(className)) {
                element.classList.remove(className);
            }
        }
        else {
            if (element.className && element.className.length > 0) {
                var cssClasses = element.className.split(' ');
                if (cssClasses.indexOf(className) >= 0) {
                    // remove all instances of the item, not just the first, in case it's in more than once
                    while (cssClasses.indexOf(className) >= 0) {
                        cssClasses.splice(cssClasses.indexOf(className), 1);
                    }
                    element.className = cssClasses.join(' ');
                }
            }
        }
    };
    Utils.removeRepeatsFromArray = function (array, object) {
        if (!array) {
            return;
        }
        for (var index = array.length - 2; index >= 0; index--) {
            var thisOneMatches = array[index] === object;
            var nextOneMatches = array[index + 1] === object;
            if (thisOneMatches && nextOneMatches) {
                array.splice(index + 1, 1);
            }
        }
    };
    Utils.removeFromArray = function (array, object) {
        if (array.indexOf(object) >= 0) {
            array.splice(array.indexOf(object), 1);
        }
    };
    Utils.removeAllFromArray = function (array, toRemove) {
        toRemove.forEach(function (item) {
            if (array.indexOf(item) >= 0) {
                array.splice(array.indexOf(item), 1);
            }
        });
    };
    Utils.insertIntoArray = function (array, object, toIndex) {
        array.splice(toIndex, 0, object);
    };
    Utils.insertArrayIntoArray = function (dest, src, toIndex) {
        if (this.missing(dest) || this.missing(src)) {
            return;
        }
        // put items in backwards, otherwise inserted items end up in reverse order
        for (var i = src.length - 1; i >= 0; i--) {
            var item = src[i];
            this.insertIntoArray(dest, item, toIndex);
        }
    };
    Utils.moveInArray = function (array, objectsToMove, toIndex) {
        var _this = this;
        // first take out it items from the array
        objectsToMove.forEach(function (obj) {
            _this.removeFromArray(array, obj);
        });
        // now add the objects, in same order as provided to us, that means we start at the end
        // as the objects will be pushed to the right as they are inserted
        objectsToMove.slice().reverse().forEach(function (obj) {
            _this.insertIntoArray(array, obj, toIndex);
        });
    };
    Utils.defaultComparator = function (valueA, valueB, accentedCompare) {
        if (accentedCompare === void 0) { accentedCompare = false; }
        var valueAMissing = valueA === null || valueA === undefined;
        var valueBMissing = valueB === null || valueB === undefined;
        // this is for aggregations sum and avg, where the result can be a number that is wrapped.
        // if we didn't do this, then the toString() value would be used, which would result in
        // the strings getting used instead of the numbers.
        if (valueA && valueA.toNumber) {
            valueA = valueA.toNumber();
        }
        if (valueB && valueB.toNumber) {
            valueB = valueB.toNumber();
        }
        if (valueAMissing && valueBMissing) {
            return 0;
        }
        if (valueAMissing) {
            return -1;
        }
        if (valueBMissing) {
            return 1;
        }
        if (typeof valueA === "string") {
            if (!accentedCompare) {
                return doQuickCompare(valueA, valueB);
            }
            else {
                try {
                    // using local compare also allows chinese comparisons
                    return valueA.localeCompare(valueB);
                }
                catch (e) {
                    // if something wrong with localeCompare, eg not supported
                    // by browser, then just continue with the quick one
                    return doQuickCompare(valueA, valueB);
                }
            }
        }
        if (valueA < valueB) {
            return -1;
        }
        else if (valueA > valueB) {
            return 1;
        }
        else {
            return 0;
        }
        function doQuickCompare(a, b) {
            return (a > b ? 1 : (a < b ? -1 : 0));
        }
    };
    Utils.compareArrays = function (array1, array2) {
        if (this.missing(array1) && this.missing(array2)) {
            return true;
        }
        if (this.missing(array1) || this.missing(array2)) {
            return false;
        }
        if (array1.length !== array2.length) {
            return false;
        }
        for (var i = 0; i < array1.length; i++) {
            if (array1[i] !== array2[i]) {
                return false;
            }
        }
        return true;
    };
    Utils.ensureDomOrder = function (eContainer, eChild, eChildBefore) {
        // if already in right order, do nothing
        if (eChildBefore && eChildBefore.nextSibling === eChild) {
            return;
        }
        if (eChildBefore) {
            if (eChildBefore.nextSibling) {
                // insert between the eRowBefore and the row after it
                eContainer.insertBefore(eChild, eChildBefore.nextSibling);
            }
            else {
                // if nextSibling is missing, means other row is at end, so just append new row at the end
                eContainer.appendChild(eChild);
            }
        }
        else {
            // otherwise put at start
            if (eContainer.firstChild) {
                // insert it at the first location
                eContainer.insertBefore(eChild, eContainer.firstChild);
            }
        }
    };
    Utils.insertWithDomOrder = function (eContainer, eChild, eChildBefore) {
        if (eChildBefore) {
            if (eChildBefore.nextSibling) {
                // insert between the eRowBefore and the row after it
                eContainer.insertBefore(eChild, eChildBefore.nextSibling);
            }
            else {
                // if nextSibling is missing, means other row is at end, so just append new row at the end
                eContainer.appendChild(eChild);
            }
        }
        else {
            if (eContainer.firstChild) {
                // insert it at the first location
                eContainer.insertBefore(eChild, eContainer.firstChild);
            }
            else {
                // otherwise eContainer is empty, so just append it
                eContainer.appendChild(eChild);
            }
        }
    };
    Utils.insertTemplateWithDomOrder = function (eContainer, htmlTemplate, eChildBefore) {
        var res;
        if (eChildBefore) {
            // if previous element exists, just slot in after the previous element
            eChildBefore.insertAdjacentHTML('afterend', htmlTemplate);
            res = eChildBefore.nextSibling;
        }
        else {
            if (eContainer.firstChild) {
                // insert it at the first location
                eContainer.insertAdjacentHTML('afterbegin', htmlTemplate);
            }
            else {
                // otherwise eContainer is empty, so just append it
                eContainer.innerHTML = htmlTemplate;
            }
            res = eContainer.firstChild;
        }
        return res;
    };
    Utils.toStringOrNull = function (value) {
        if (this.exists(value) && value.toString) {
            return value.toString();
        }
        else {
            return null;
        }
    };
    Utils.formatWidth = function (width) {
        if (typeof width === "number") {
            return width + "px";
        }
        else {
            return width;
        }
    };
    Utils.formatNumberTwoDecimalPlacesAndCommas = function (value) {
        if (typeof value !== 'number') {
            return '';
        }
        // took this from: http://blog.tompawlak.org/number-currency-formatting-javascript
        return (Math.round(value * 100) / 100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    };
    // the native method number.toLocaleString(undefined, {minimumFractionDigits: 0}) puts in decimal places in IE,
    // so we use this method instead
    Utils.formatNumberCommas = function (value) {
        if (typeof value !== 'number') {
            return '';
        }
        // took this from: http://blog.tompawlak.org/number-currency-formatting-javascript
        return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    };
    Utils.prependDC = function (parent, documentFragment) {
        if (this.exists(parent.firstChild)) {
            parent.insertBefore(documentFragment, parent.firstChild);
        }
        else {
            parent.appendChild(documentFragment);
        }
    };
    /**
     * If icon provided, use this (either a string, or a function callback).
     * if not, then use the default icon from the theme
     */
    Utils.createIcon = function (iconName, gridOptionsWrapper, column) {
        var iconContents = this.createIconNoSpan(iconName, gridOptionsWrapper, column);
        if (iconContents.className.indexOf('ag-icon') > -1) {
            return iconContents;
        }
        else {
            var eResult = document.createElement('span');
            eResult.appendChild(iconContents);
            return eResult;
        }
    };
    Utils.createIconNoSpan = function (iconName, gridOptionsWrapper, column) {
        var userProvidedIcon;
        // check col for icon first
        if (column && column.getColDef().icons) {
            userProvidedIcon = column.getColDef().icons[iconName];
        }
        // it not in col, try grid options
        if (!userProvidedIcon && gridOptionsWrapper.getIcons()) {
            userProvidedIcon = gridOptionsWrapper.getIcons()[iconName];
        }
        // now if user provided, use it
        if (userProvidedIcon) {
            var rendererResult = void 0;
            if (typeof userProvidedIcon === 'function') {
                rendererResult = userProvidedIcon();
            }
            else if (typeof userProvidedIcon === 'string') {
                rendererResult = userProvidedIcon;
            }
            else {
                throw 'icon from grid options needs to be a string or a function';
            }
            if (typeof rendererResult === 'string') {
                return this.loadTemplate(rendererResult);
            }
            else if (this.isNodeOrElement(rendererResult)) {
                return rendererResult;
            }
            else {
                throw 'iconRenderer should return back a string or a dom object';
            }
        }
        else {
            var span = document.createElement('span');
            var cssClass = this.iconNameClassMap[iconName];
            if (!cssClass) {
                throw new Error(iconName + " did not find class");
            }
            span.setAttribute("class", "ag-icon ag-icon-" + cssClass);
            return span;
        }
    };
    Utils.addStylesToElement = function (eElement, styles) {
        var _this = this;
        if (!styles) {
            return;
        }
        Object.keys(styles).forEach(function (key) {
            var keyCamelCase = _this.hyphenToCamelCase(key);
            eElement.style[keyCamelCase] = styles[key];
        });
    };
    Utils.isHorizontalScrollShowing = function (element) {
        return element.clientWidth < element.scrollWidth;
    };
    Utils.isVerticalScrollShowing = function (element) {
        return element.clientHeight < element.scrollHeight;
    };
    Utils.getScrollbarWidth = function () {
        var outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.width = "100px";
        outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
        document.body.appendChild(outer);
        var widthNoScroll = outer.offsetWidth;
        // force scrollbars
        outer.style.overflow = "scroll";
        // add innerdiv
        var inner = document.createElement("div");
        inner.style.width = "100%";
        outer.appendChild(inner);
        var widthWithScroll = inner.offsetWidth;
        // remove divs
        outer.parentNode.removeChild(outer);
        return widthNoScroll - widthWithScroll;
    };
    Utils.isKeyPressed = function (event, keyToCheck) {
        var pressedKey = event.which || event.keyCode;
        return pressedKey === keyToCheck;
    };
    Utils.setVisible = function (element, visible) {
        this.addOrRemoveCssClass(element, 'ag-hidden', !visible);
    };
    Utils.setHidden = function (element, hidden) {
        this.addOrRemoveCssClass(element, 'ag-visibility-hidden', hidden);
    };
    Utils.isBrowserIE = function () {
        if (this.isIE === undefined) {
            this.isIE = false || !!document.documentMode; // At least IE6
        }
        return this.isIE;
    };
    Utils.isBrowserEdge = function () {
        if (this.isEdge === undefined) {
            this.isEdge = !this.isBrowserIE() && !!window.StyleMedia;
        }
        return this.isEdge;
    };
    Utils.isBrowserSafari = function () {
        if (this.isSafari === undefined) {
            var anyWindow = window;
            // taken from https://github.com/ag-grid/ag-grid/issues/550
            this.isSafari = Object.prototype.toString.call(anyWindow.HTMLElement).indexOf('Constructor') > 0
                || (function (p) {
                    return p.toString() === "[object SafariRemoteNotification]";
                })(!anyWindow.safari || anyWindow.safari.pushNotification);
        }
        return this.isSafari;
    };
    Utils.isBrowserChrome = function () {
        if (this.isChrome === undefined) {
            var anyWindow = window;
            this.isChrome = !!anyWindow.chrome && !!anyWindow.chrome.webstore;
        }
        return this.isChrome;
    };
    Utils.isBrowserFirefox = function () {
        if (this.isFirefox === undefined) {
            var anyWindow = window;
            this.isFirefox = typeof anyWindow.InstallTrigger !== 'undefined';
        }
        return this.isFirefox;
    };
    Utils.isUserAgentIPad = function () {
        if (this.isIPad === undefined) {
            // taken from https://davidwalsh.name/detect-ipad
            this.isIPad = navigator.userAgent.match(/iPad/i) != null;
        }
        return this.isIPad;
    };
    // srcElement is only available in IE. In all other browsers it is target
    // http://stackoverflow.com/questions/5301643/how-can-i-make-event-srcelement-work-in-firefox-and-what-does-it-mean
    Utils.getTarget = function (event) {
        var eventNoType = event;
        return eventNoType.target || eventNoType.srcElement;
    };
    Utils.isElementInEventPath = function (element, event) {
        if (!event || !element) {
            return false;
        }
        var path = exports._.getEventPath(event);
        return path.indexOf(element) >= 0;
    };
    Utils.createEventPath = function (event) {
        var res = [];
        var pointer = exports._.getTarget(event);
        while (pointer) {
            res.push(pointer);
            pointer = pointer.parentElement;
        }
        return res;
    };
    // firefox doesn't have event.path set, or any alternative to it, so we hack
    // it in. this is needed as it's to late to work out the path when the item is
    // removed from the dom. used by MouseEventService, where it works out if a click
    // was from the current grid, or a detail grid (master / detail).
    Utils.addAgGridEventPath = function (event) {
        event.__agGridEventPath = this.getEventPath(event);
    };
    Utils.getEventPath = function (event) {
        // https://stackoverflow.com/questions/39245488/event-path-undefined-with-firefox-and-vue-js
        // https://developer.mozilla.org/en-US/docs/Web/API/Event
        var eventNoType = event;
        if (event.deepPath) {
            // IE supports deep path
            return event.deepPath();
        }
        else if (eventNoType.path) {
            // Chrome supports path
            return eventNoType.path;
        }
        else if (eventNoType.composedPath) {
            // Firefox supports composePath
            return eventNoType.composedPath();
        }
        else if (eventNoType.__agGridEventPath) {
            // Firefox supports composePath
            return eventNoType.__agGridEventPath;
        }
        else {
            // and finally, if none of the above worked,
            // we create the path ourselves
            return this.createEventPath(event);
        }
    };
    Utils.forEachSnapshotFirst = function (list, callback) {
        if (list) {
            var arrayCopy = list.slice(0);
            arrayCopy.forEach(callback);
        }
    };
    // taken from: http://stackoverflow.com/questions/1038727/how-to-get-browser-width-using-javascript-code
    Utils.getBodyWidth = function () {
        if (document.body) {
            return document.body.clientWidth;
        }
        if (window.innerHeight) {
            return window.innerWidth;
        }
        if (document.documentElement && document.documentElement.clientWidth) {
            return document.documentElement.clientWidth;
        }
        return -1;
    };
    // taken from: http://stackoverflow.com/questions/1038727/how-to-get-browser-width-using-javascript-code
    Utils.getBodyHeight = function () {
        if (document.body) {
            return document.body.clientHeight;
        }
        if (window.innerHeight) {
            return window.innerHeight;
        }
        if (document.documentElement && document.documentElement.clientHeight) {
            return document.documentElement.clientHeight;
        }
        return -1;
    };
    Utils.setCheckboxState = function (eCheckbox, state) {
        if (typeof state === 'boolean') {
            eCheckbox.checked = state;
            eCheckbox.indeterminate = false;
        }
        else {
            // isNodeSelected returns back undefined if it's a group and the children
            // are a mix of selected and unselected
            eCheckbox.indeterminate = true;
        }
    };
    Utils.traverseNodesWithKey = function (nodes, callback) {
        var keyParts = [];
        recursiveSearchNodes(nodes);
        function recursiveSearchNodes(nodes) {
            nodes.forEach(function (node) {
                if (node.group) {
                    keyParts.push(node.key);
                    var key = keyParts.join('|');
                    callback(node, key);
                    recursiveSearchNodes(node.childrenAfterGroup);
                    keyParts.pop();
                }
            });
        }
    };
    // from https://gist.github.com/youssman/745578062609e8acac9f
    Utils.camelCaseToHyphen = function (str) {
        if (str === null || str === undefined) {
            return null;
        }
        return str.replace(/([A-Z])/g, function (g) { return '-' + g[0].toLowerCase(); });
    };
    // from https://stackoverflow.com/questions/6660977/convert-hyphens-to-camel-case-camelcase
    Utils.hyphenToCamelCase = function (str) {
        if (str === null || str === undefined) {
            return null;
        }
        return str.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
    };
    // pas in an object eg: {color: 'black', top: '25px'} and it returns "color: black; top: 25px;" for html
    Utils.cssStyleObjectToMarkup = function (stylesToUse) {
        var _this = this;
        if (!stylesToUse) {
            return '';
        }
        var resParts = [];
        this.iterateObject(stylesToUse, function (styleKey, styleValue) {
            var styleKeyDashed = _this.camelCaseToHyphen(styleKey);
            resParts.push(styleKeyDashed + ": " + styleValue + ";");
        });
        return resParts.join(' ');
    };
    /**
     * From http://stackoverflow.com/questions/9716468/is-there-any-function-like-isnumeric-in-javascript-to-validate-numbers
     */
    Utils.isNumeric = function (value) {
        if (value === '')
            return false;
        return !isNaN(parseFloat(value)) && isFinite(value);
    };
    Utils.escape = function (toEscape) {
        if (toEscape === null || toEscape === undefined || !toEscape.replace) {
            return toEscape;
        }
        return toEscape.replace(reUnescapedHtml, function (chr) { return HTML_ESCAPES[chr]; });
    };
    // Taken from here: https://github.com/facebook/fixed-data-table/blob/master/src/vendor_upstream/dom/normalizeWheel.js
    /**
     * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
     * complicated, thus this doc is long and (hopefully) detailed enough to answer
     * your questions.
     *
     * If you need to react to the mouse wheel in a predictable way, this code is
     * like your bestest friend. * hugs *
     *
     * As of today, there are 4 DOM event types you can listen to:
     *
     *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
     *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
     *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
     *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
     *
     * So what to do?  The is the best:
     *
     *   normalizeWheel.getEventType();
     *
     * In your event callback, use this code to get sane interpretation of the
     * deltas.  This code will return an object with properties:
     *
     *   spinX   -- normalized spin speed (use for zoom) - x plane
     *   spinY   -- " - y plane
     *   pixelX  -- normalized distance (to pixels) - x plane
     *   pixelY  -- " - y plane
     *
     * Wheel values are provided by the browser assuming you are using the wheel to
     * scroll a web page by a number of lines or pixels (or pages).  Values can vary
     * significantly on different platforms and browsers, forgetting that you can
     * scroll at different speeds.  Some devices (like trackpads) emit more events
     * at smaller increments with fine granularity, and some emit massive jumps with
     * linear speed or acceleration.
     *
     * This code does its best to normalize the deltas for you:
     *
     *   - spin is trying to normalize how far the wheel was spun (or trackpad
     *     dragged).  This is super useful for zoom support where you want to
     *     throw away the chunky scroll steps on the PC and make those equal to
     *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
     *     resolve a single slow step on a wheel to 1.
     *
     *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
     *     get the crazy differences between browsers, but at least it'll be in
     *     pixels!
     *
     *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
     *     should translate to positive value zooming IN, negative zooming OUT.
     *     This matches the newer 'wheel' event.
     *
     * Why are there spinX, spinY (or pixels)?
     *
     *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
     *     with a mouse.  It results in side-scrolling in the browser by default.
     *
     *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
     *
     *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
     *     probably is by browsers in conjunction with fancy 3D controllers .. but
     *     you know.
     *
     * Implementation info:
     *
     * Examples of 'wheel' event if you scroll slowly (down) by one step with an
     * average mouse:
     *
     *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
     *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
     *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
     *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
     *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
     *
     * On the trackpad:
     *
     *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
     *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
     *
     * On other/older browsers.. it's more complicated as there can be multiple and
     * also missing delta values.
     *
     * The 'wheel' event is more standard:
     *
     * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
     *
     * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
     * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
     * backward compatibility with older events.  Those other values help us
     * better normalize spin speed.  Example of what the browsers provide:
     *
     *                          | event.wheelDelta | event.detail
     *        ------------------+------------------+--------------
     *          Safari v5/OS X  |       -120       |       0
     *          Safari v5/Win7  |       -120       |       0
     *         Chrome v17/OS X  |       -120       |       0
     *         Chrome v17/Win7  |       -120       |       0
     *                IE9/Win7  |       -120       |   undefined
     *         Firefox v4/OS X  |     undefined    |       1
     *         Firefox v4/Win7  |     undefined    |       3
     *
     */
    Utils.normalizeWheel = function (event) {
        var PIXEL_STEP = 10;
        var LINE_HEIGHT = 40;
        var PAGE_HEIGHT = 800;
        // spinX, spinY
        var sX = 0;
        var sY = 0;
        // pixelX, pixelY
        var pX = 0;
        var pY = 0;
        // Legacy
        if ('detail' in event) {
            sY = event.detail;
        }
        if ('wheelDelta' in event) {
            sY = -event.wheelDelta / 120;
        }
        if ('wheelDeltaY' in event) {
            sY = -event.wheelDeltaY / 120;
        }
        if ('wheelDeltaX' in event) {
            sX = -event.wheelDeltaX / 120;
        }
        // side scrolling on FF with DOMMouseScroll
        if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in event) {
            pY = event.deltaY;
        }
        if ('deltaX' in event) {
            pX = event.deltaX;
        }
        if ((pX || pY) && event.deltaMode) {
            if (event.deltaMode == 1) {
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            }
            else {
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) {
            sX = (pX < 1) ? -1 : 1;
        }
        if (pY && !sY) {
            sY = (pY < 1) ? -1 : 1;
        }
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    };
    /**
     * https://stackoverflow.com/questions/24004791/can-someone-explain-the-debounce-function-in-javascript
     */
    Utils.debounce = function (func, wait, immediate) {
        if (immediate === void 0) { immediate = false; }
        // 'private' variable for instance
        // The returned function will be able to reference this due to closure.
        // Each call to the returned function will share this common timer.
        var timeout;
        // Calling debounce returns a new anonymous function
        return function () {
            // reference the context and args for the setTimeout function
            var context = this, args = arguments;
            // Should the function be called now? If immediate is true
            //   and not already in a timeout then the answer is: Yes
            var callNow = immediate && !timeout;
            // This is the basic debounce behaviour where you can call this
            //   function several times, but it will only execute once
            //   [before or after imposing a delay].
            //   Each time the returned function is called, the timer starts over.
            clearTimeout(timeout);
            // Set the new timeout
            timeout = setTimeout(function () {
                // Inside the timeout function, clear the timeout variable
                // which will let the next execution run when in 'immediate' mode
                timeout = null;
                // Check if the function already ran with the immediate flag
                if (!immediate) {
                    // Call the original function with apply
                    // apply lets you define the 'this' object as well as the arguments
                    //    (both captured before setTimeout)
                    func.apply(context, args);
                }
            }, wait);
            // Immediate mode and no wait timer? Execute the function..
            if (callNow)
                func.apply(context, args);
        };
    };
    ;
    // a user once raised an issue - they said that when you opened a popup (eg context menu)
    // and then clicked on a selection checkbox, the popup wasn't closed. this is because the
    // popup listens for clicks on the body, however ag-grid WAS stopping propagation on the
    // checkbox clicks (so the rows didn't pick them up as row selection selection clicks).
    // to get around this, we have a pattern to stop propagation for the purposes of ag-Grid,
    // but we still let the event pass back to teh body.
    Utils.stopPropagationForAgGrid = function (event) {
        event[AG_GRID_STOP_PROPAGATION] = true;
    };
    Utils.isStopPropagationForAgGrid = function (event) {
        return event[AG_GRID_STOP_PROPAGATION] === true;
    };
    Utils.executeInAWhile = function (funcs) {
        this.executeAfter(funcs, 400);
    };
    Utils.executeNextVMTurn = function (funcs) {
        this.executeAfter(funcs, 0);
    };
    Utils.executeAfter = function (funcs, millis) {
        if (funcs.length > 0) {
            setTimeout(function () {
                funcs.forEach(function (func) { return func(); });
            }, millis);
        }
    };
    Utils.referenceCompare = function (left, right) {
        if (left == null && right == null)
            return true;
        if (left == null && right)
            return false;
        if (left && right == null)
            return false;
        return left === right;
    };
    Utils.get = function (source, expression, defaultValue) {
        if (source == null)
            return defaultValue;
        if (expression.indexOf('.') > -1) {
            var fields = expression.split('.');
            var thisKey = fields[0];
            var nextValue = source[thisKey];
            if (nextValue != null) {
                return Utils.get(nextValue, fields.slice(1, fields.length).join('.'), defaultValue);
            }
            else {
                return defaultValue;
            }
        }
        else {
            var nextValue = source[expression];
            return nextValue != null ? nextValue : defaultValue;
        }
    };
    Utils.addSafePassiveEventListener = function (eElement, event, listener) {
        eElement.addEventListener(event, listener, (Utils.passiveEvents.indexOf(event) > -1 ? { passive: true } : undefined));
    };
    Utils.camelCaseToHumanText = function (camelCase) {
        if (camelCase == null)
            return null;
        // Who needs to learn how to code when you have stack overflow!
        // from: https://stackoverflow.com/questions/15369566/putting-space-in-camel-case-string-using-regular-expression
        var rex = /([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g;
        var words = camelCase.replace(rex, '$1$4 $2$3$5').replace('.', ' ').split(' ');
        return words.map(function (word) { return word.substring(0, 1).toUpperCase() + ((word.length > 1) ? word.substring(1, word.length) : ''); }).join(' ');
    };
    // displays a message to the browser. this is useful in iPad, where you can't easily see the console.
    // so the javascript code can use this to give feedback. this is NOT intended to be called in production.
    // it is intended the ag-Grid developer calls this to troubleshoot, but then takes out the calls before
    // checking in.
    Utils.message = function (msg) {
        var eMessage = document.createElement('div');
        eMessage.innerHTML = msg;
        var eBox = document.querySelector('#__ag__message');
        if (!eBox) {
            var template = "<div id=\"__ag__message\" style=\"display: inline-block; position: absolute; top: 0px; left: 0px; color: white; background-color: black; z-index: 20; padding: 2px; border: 1px solid darkred; height: 200px; overflow-y: auto;\"></div>";
            eBox = this.loadTemplate(template);
            if (document.body) {
                document.body.appendChild(eBox);
            }
        }
        eBox.appendChild(eMessage);
    };
    // gets called by: a) InMemoryRowNodeManager and b) GroupStage to do sorting.
    // when in InMemoryRowNodeManager we always have indexes (as this sorts the items the
    // user provided) but when in GroupStage, the nodes can contain filler nodes that
    // don't have order id's
    Utils.sortRowNodesByOrder = function (rowNodes, rowNodeOrder) {
        if (!rowNodes) {
            return;
        }
        rowNodes.sort(function (nodeA, nodeB) {
            var positionA = rowNodeOrder[nodeA.id];
            var positionB = rowNodeOrder[nodeB.id];
            var aHasIndex = positionA !== undefined;
            var bHasIndex = positionB !== undefined;
            var bothNodesAreUserNodes = aHasIndex && bHasIndex;
            var bothNodesAreFillerNodes = !aHasIndex && !bHasIndex;
            if (bothNodesAreUserNodes) {
                // when comparing two nodes the user has provided, they always
                // have indexes
                return positionA - positionB;
            }
            else if (bothNodesAreFillerNodes) {
                // when comparing two filler nodes, we have no index to compare them
                // against, however we want this sorting to be deterministic, so that
                // the rows don't jump around as the user does delta updates. so we
                // want the same sort result. so we use the id - which doesn't make sense
                // from a sorting point of view, but does give consistent behaviour between
                // calls. otherwise groups jump around as delta updates are done.
                return nodeA.id > nodeB.id ? 1 : -1;
            }
            else if (aHasIndex) {
                return 1;
            }
            else {
                return -1;
            }
        });
    };
    Utils.PRINTABLE_CHARACTERS = 'qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890!"£$%^&*()_+-=[];\'#,./\\|<>?:@~{}';
    Utils.doOnceFlags = {};
    // static prepend(parent: HTMLElement, child: HTMLElement): void {
    //     if (this.exists(parent.firstChild)) {
    //         parent.insertBefore(child, parent.firstChild);
    //     } else {
    //         parent.appendChild(child);
    //     }
    // }
    Utils.iconNameClassMap = {
        'columnMovePin': 'pin',
        'columnMoveAdd': 'plus',
        'columnMoveHide': 'eye-slash',
        'columnMoveMove': 'arrows',
        'columnMoveLeft': 'left',
        'columnMoveRight': 'right',
        'columnMoveGroup': 'group',
        'columnMoveValue': 'aggregation',
        'columnMovePivot': 'pivot',
        'dropNotAllowed': 'not-allowed',
        'groupContracted': 'expanded',
        'groupExpanded': 'contracted',
        'checkboxChecked': 'checkbox-checked',
        'checkboxUnchecked': 'checkbox-unchecked',
        'checkboxIndeterminate': 'checkbox-indeterminate',
        'checkboxCheckedReadOnly': 'checkbox-checked-readonly',
        'checkboxUncheckedReadOnly': 'checkbox-unchecked-readonly',
        'checkboxIndeterminateReadOnly': 'checkbox-indeterminate-readonly',
        'groupLoading': 'loading',
        'menu': 'menu',
        'filter': 'filter',
        'columns': 'columns',
        'menuPin': 'pin',
        'menuValue': 'aggregation',
        'menuAddRowGroup': 'group',
        'menuRemoveRowGroup': 'group',
        'clipboardCopy': 'copy',
        'clipboardCut': 'cut',
        'clipboardPaste': 'paste',
        'pivotPanel': 'pivot',
        'rowGroupPanel': 'group',
        'valuePanel': 'aggregation',
        'columnGroupOpened': 'expanded',
        'columnGroupClosed': 'contracted',
        'columnSelectClosed': 'tree-closed',
        'columnSelectOpen': 'tree-open',
        // from deprecated header, remove at some point
        'sortAscending': 'asc',
        'sortDescending': 'desc',
        'sortUnSort': 'none'
    };
    Utils.passiveEvents = ['touchstart', 'touchend', 'touchmove', 'touchcancel'];
    return Utils;
}());
exports.Utils = Utils;
var NumberSequence = (function () {
    function NumberSequence(initValue, step) {
        if (initValue === void 0) { initValue = 0; }
        if (step === void 0) { step = 1; }
        this.nextValue = initValue;
        this.step = step;
    }
    NumberSequence.prototype.next = function () {
        var valToReturn = this.nextValue;
        this.nextValue += this.step;
        return valToReturn;
    };
    NumberSequence.prototype.peek = function () {
        return this.nextValue;
    };
    NumberSequence.prototype.skip = function (count) {
        this.nextValue += count;
    };
    return NumberSequence;
}());
exports.NumberSequence = NumberSequence;
exports._ = Utils;
var PromiseStatus;
(function (PromiseStatus) {
    PromiseStatus[PromiseStatus["IN_PROGRESS"] = 0] = "IN_PROGRESS";
    PromiseStatus[PromiseStatus["RESOLVED"] = 1] = "RESOLVED";
})(PromiseStatus = exports.PromiseStatus || (exports.PromiseStatus = {}));
var Promise = (function () {
    function Promise(callback) {
        this.status = PromiseStatus.IN_PROGRESS;
        this.resolution = null;
        this.listOfWaiters = [];
        callback(this.onDone.bind(this), this.onReject.bind(this));
    }
    Promise.all = function (toCombine) {
        return new Promise(function (resolve) {
            var combinedValues = [];
            var remainingToResolve = toCombine.length;
            toCombine.forEach(function (source, index) {
                source.then(function (sourceResolved) {
                    remainingToResolve--;
                    combinedValues[index] = sourceResolved;
                    if (remainingToResolve == 0) {
                        resolve(combinedValues);
                    }
                });
                combinedValues.push(null);
            });
        });
    };
    Promise.resolve = function (value) {
        return new Promise(function (resolve) { return resolve(value); });
    };
    Promise.external = function () {
        var capture;
        var promise = new Promise(function (resolve) {
            capture = resolve;
        });
        return {
            promise: promise,
            resolve: function (value) {
                capture(value);
            }
        };
    };
    Promise.prototype.then = function (func) {
        if (this.status === PromiseStatus.IN_PROGRESS) {
            this.listOfWaiters.push(func);
        }
        else {
            func(this.resolution);
        }
    };
    Promise.prototype.firstOneOnly = function (func) {
        if (this.status === PromiseStatus.IN_PROGRESS) {
            if (this.listOfWaiters.length === 0) {
                this.listOfWaiters.push(func);
            }
        }
        else {
            func(this.resolution);
        }
    };
    Promise.prototype.map = function (adapter) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.then(function (unmapped) {
                resolve(adapter(unmapped));
            });
        });
    };
    Promise.prototype.resolveNow = function (ifNotResolvedValue, ifResolved) {
        if (this.status == PromiseStatus.IN_PROGRESS)
            return ifNotResolvedValue;
        return ifResolved(this.resolution);
    };
    Promise.prototype.onDone = function (value) {
        this.status = PromiseStatus.RESOLVED;
        this.resolution = value;
        this.listOfWaiters.forEach(function (waiter) { return waiter(value); });
    };
    Promise.prototype.onReject = function (params) {
        console.warn('TBI');
    };
    return Promise;
}());
exports.Promise = Promise;


/***/ }),

/***/ "Ibhu":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("D2L2");
var toIObject = __webpack_require__("TcQ7");
var arrayIndexOf = __webpack_require__("vFc/")(false);
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "IfdU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var PropertyKeys = (function () {
    function PropertyKeys() {
    }
    PropertyKeys.STRING_PROPERTIES = [
        'sortingOrder', 'rowClass', 'rowSelection', 'overlayLoadingTemplate',
        'overlayNoRowsTemplate', 'quickFilterText', 'rowModelType',
        'editType', 'domLayout', 'clipboardDeliminator', 'rowGroupPanelShow'
    ];
    PropertyKeys.OBJECT_PROPERTIES = [
        'components', 'frameworkComponents', 'rowStyle', 'context', 'autoGroupColumnDef', 'groupColumnDef', 'localeText',
        'icons', 'datasource', 'enterpriseDatasource', 'viewportDatasource', 'groupRowRendererParams', 'aggFuncs',
        'fullWidthCellRendererParams', 'defaultColGroupDef', 'defaultColDef', 'defaultExportParams', 'columnTypes',
        'rowClassRules', 'detailGridOptions', 'detailCellRendererParams', 'loadingOverlayComponentParams',
        'noRowsOverlayComponentParams', 'popupParent'
        //,'cellRenderers','cellEditors'
    ];
    PropertyKeys.ARRAY_PROPERTIES = [
        'slaveGrids', 'alignedGrids', 'rowData',
        'columnDefs', 'excelStyles', 'pinnedTopRowData', 'pinnedBottomRowData'
        // deprecated
    ];
    PropertyKeys.NUMBER_PROPERTIES = [
        'rowHeight', 'detailRowHeight', 'rowBuffer', 'colWidth', 'headerHeight', 'groupHeaderHeight',
        'floatingFiltersHeight', 'pivotHeaderHeight', 'pivotGroupHeaderHeight', 'groupDefaultExpanded',
        'minColWidth', 'maxColWidth', 'viewportRowModelPageSize', 'viewportRowModelBufferSize',
        'layoutInterval', 'autoSizePadding', 'maxBlocksInCache', 'maxConcurrentDatasourceRequests',
        'cacheOverflowSize', 'paginationPageSize', 'cacheBlockSize', 'infiniteInitialRowCount',
        'scrollbarWidth', 'paginationStartPage', 'infiniteBlockSize'
    ];
    PropertyKeys.BOOLEAN_PROPERTIES = [
        'toolPanelSuppressRowGroups', 'toolPanelSuppressValues', 'toolPanelSuppressPivots', 'toolPanelSuppressPivotMode',
        'suppressRowClickSelection', 'suppressCellSelection', 'suppressHorizontalScroll', 'debug',
        'enableColResize', 'enableCellExpressions', 'enableSorting', 'enableServerSideSorting',
        'enableFilter', 'enableServerSideFilter', 'angularCompileRows', 'angularCompileFilters',
        'angularCompileHeaders', 'groupSuppressAutoColumn', 'groupSelectsChildren',
        'groupIncludeFooter', 'groupUseEntireRow', 'groupSuppressRow', 'groupSuppressBlankHeader', 'forPrint',
        'suppressMenuHide', 'rowDeselection', 'unSortIcon', 'suppressMultiSort',
        'singleClickEdit', 'suppressLoadingOverlay', 'suppressNoRowsOverlay', 'suppressAutoSize',
        'suppressParentsInRowNodes', 'showToolPanel', 'suppressColumnMoveAnimation', 'suppressMovableColumns',
        'suppressFieldDotNotation', 'enableRangeSelection',
        'pivotPanelShow', 'suppressTouch', 'suppressAsyncEvents', 'allowContextMenuWithControlKey',
        'suppressContextMenu', 'suppressMenuFilterPanel', 'suppressMenuMainPanel', 'suppressMenuColumnPanel',
        'enableStatusBar', 'alwaysShowStatusBar', 'rememberGroupStateWhenNewData', 'enableCellChangeFlash', 'suppressDragLeaveHidesColumns',
        'suppressMiddleClickScrolls', 'suppressPreventDefaultOnMouseWheel', 'suppressUseColIdForGroups',
        'suppressCopyRowsToClipboard', 'pivotMode', 'suppressAggFuncInHeader', 'suppressColumnVirtualisation', 'suppressAggAtRootLevel',
        'suppressFocusAfterRefresh', 'functionsPassive', 'functionsReadOnly',
        'animateRows', 'groupSelectsFiltered', 'groupRemoveSingleChildren', 'groupRemoveLowestSingleChildren',
        'enableRtl', 'suppressClickEdit', 'rowDragManaged', 'suppressRowDrag',
        'enableGroupEdit', 'embedFullWidthRows', 'suppressTabbing', 'suppressPaginationPanel', 'floatingFilter',
        'groupHideOpenParents', 'groupMultiAutoColumn', 'pagination', 'stopEditingWhenGridLosesFocus',
        'paginationAutoPageSize', 'suppressScrollOnNewData', 'purgeClosedRowNodes', 'cacheQuickFilter',
        'deltaRowDataMode', 'ensureDomOrder', 'accentedSort', 'pivotTotals', 'suppressChangeDetection',
        'valueCache', 'valueCacheNeverExpires', 'aggregateOnlyChangedColumns', 'suppressAnimationFrame',
        'suppressExcelExport', 'suppressCsvExport', 'treeData', 'masterDetail', 'isRowMaster',
        'suppressMultiRangeSelection', 'enterMovesDownAfterEdit'
    ];
    PropertyKeys.FUNCTION_PROPERTIES = ['localeTextFunc', 'groupRowInnerRenderer', 'groupRowInnerRendererFramework',
        'dateComponent', 'dateComponentFramework', 'groupRowRenderer', 'groupRowRendererFramework', 'isExternalFilterPresent',
        'getRowHeight', 'doesExternalFilterPass', 'getRowClass', 'getRowStyle', 'getRowClassRules',
        'traverseNode', 'getContextMenuItems', 'getMainMenuItems', 'processRowPostCreate', 'processCellForClipboard',
        'getNodeChildDetails', 'groupRowAggNodes', 'getRowNodeId', 'isFullWidthCell', 'fullWidthCellRenderer',
        'fullWidthCellRendererFramework', 'doesDataFlower', 'processSecondaryColDef', 'processSecondaryColGroupDef',
        'getBusinessKeyForNode', 'sendToClipboard', 'navigateToNextCell', 'tabToNextCell', 'getDetailRowData',
        'processCellFromClipboard', 'getDocument', 'postProcessPopup', 'getChildCount', 'getDataPath', 'loadingOverlayComponent',
        'loadingOverlayComponentFramework', 'noRowsOverlayComponent', 'noRowsOverlayComponentFramework', 'detailCellRenderer', 'detailCellRendererFramework'];
    PropertyKeys.ALL_PROPERTIES = PropertyKeys.ARRAY_PROPERTIES
        .concat(PropertyKeys.OBJECT_PROPERTIES)
        .concat(PropertyKeys.STRING_PROPERTIES)
        .concat(PropertyKeys.NUMBER_PROPERTIES)
        .concat(PropertyKeys.FUNCTION_PROPERTIES)
        .concat(PropertyKeys.BOOLEAN_PROPERTIES);
    return PropertyKeys;
}());
exports.PropertyKeys = PropertyKeys;


/***/ }),

/***/ "IlyZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(954);
	module.exports = __webpack_require__(954);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($) {

	    function createPromise() {
	        return $.Deferred();
	    }

	    function promiseAll(promises) {
	        return $.when.apply($, promises);
	    }

	    kendo.drawing.util = kendo.drawing.util || {};
	    kendo.deepExtend(kendo.drawing.util, {
	        createPromise: createPromise,
	        promiseAll: promiseAll
	    });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "Iu+f":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1636);
	module.exports = __webpack_require__(1636);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1636:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(20)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function() {

	(function () {
	    // Imports ================================================================
	    var kendo = window.kendo,
	        deepExtend = kendo.deepExtend;

	    function sqr(value) {
	        return value * value;
	    }

	    var now = Date.now;
	    if (!now) {
	        now = function() {
	            return new Date().getTime();
	        };
	    }

	    // Template helpers =======================================================

	    function renderSize(size) {
	        if (typeof size !== "string") {
	            size += "px";
	        }

	        return size;
	    }

	    function renderPos(pos) {
	        var result = [];

	        if (pos) {
	            var parts = kendo.toHyphens(pos).split("-");

	            for (var i = 0; i < parts.length; i++) {
	                result.push("k-pos-" + parts[i]);
	            }
	        }

	        return result.join(" ");
	    }

	    function arabicToRoman(n) {
	        var literals = {
	            1    : "i",       10   : "x",       100  : "c",
	            2    : "ii",      20   : "xx",      200  : "cc",
	            3    : "iii",     30   : "xxx",     300  : "ccc",
	            4    : "iv",      40   : "xl",      400  : "cd",
	            5    : "v",       50   : "l",       500  : "d",
	            6    : "vi",      60   : "lx",      600  : "dc",
	            7    : "vii",     70   : "lxx",     700  : "dcc",
	            8    : "viii",    80   : "lxxx",    800  : "dccc",
	            9    : "ix",      90   : "xc",      900  : "cm",
	            1000 : "m"
	        };
	        var values = [ 1000,
	                       900 , 800, 700, 600, 500, 400, 300, 200, 100,
	                       90  , 80 , 70 , 60 , 50 , 40 , 30 , 20 , 10 ,
	                       9   , 8  , 7  , 6  , 5  , 4  , 3  , 2  , 1 ];
	        var roman = "";
	        while (n > 0) {
	            if (n < values[0]) {
	                values.shift();
	            } else {
	                roman += literals[values[0]];
	                n -= values[0];
	            }
	        }
	        return roman;
	    }

	    function romanToArabic(r) {
	        r = r.toLowerCase();
	        var digits = {
	            i: 1,
	            v: 5,
	            x: 10,
	            l: 50,
	            c: 100,
	            d: 500,
	            m: 1000
	        };
	        var value = 0, prev = 0;
	        for (var i = 0; i < r.length; ++i) {
	            var v = digits[r.charAt(i)];
	            if (!v) {
	                return null;
	            }
	            value += v;
	            if (v > prev) {
	                value -= 2 * prev;
	            }
	            prev = v;
	        }
	        return value;
	    }

	    function memoize(f) {
	        var cache = Object.create(null);
	        return function() {
	            var id = "";
	            for (var i = arguments.length; --i >= 0;) {
	                id += ":" + arguments[i];
	            }
	            return id in cache ? cache[id] : (cache[id] = f.apply(this, arguments));
	        };
	    }

	    function isUnicodeLetter(ch) {
	        return RX_UNICODE_LETTER.test(ch);
	    }

	    function withExit(f, obj) {
	        try {
	            return f.call(obj, function(value){
	                throw new Return(value);
	            });
	        } catch(ex) {
	            if (ex instanceof Return) {
	                return ex.value;
	            }
	            throw ex;
	        }
	        function Return(value) {
	            this.value = value;
	        }
	    }

	    // Exports ================================================================
	    deepExtend(kendo, {
	        util: {
	            now: now,
	            renderPos: renderPos,
	            renderSize: renderSize,
	            sqr: sqr,
	            romanToArabic: romanToArabic,
	            arabicToRoman: arabicToRoman,
	            memoize: memoize,
	            isUnicodeLetter: isUnicodeLetter,
	            withExit: withExit
	        }
	    });

	    var RX_UNICODE_LETTER = new RegExp("[\\u0041-\\u005A\\u0061-\\u007A\\u00AA\\u00B5\\u00BA\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0370-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0620-\\u064A\\u066E\\u066F\\u0671-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE\\u06EF\\u06FA-\\u06FC\\u06FF\\u0710\\u0712-\\u072F\\u074D-\\u07A5\\u07B1\\u07CA-\\u07EA\\u07F4\\u07F5\\u07FA\\u0800-\\u0815\\u081A\\u0824\\u0828\\u0840-\\u0858\\u08A0-\\u08B2\\u0904-\\u0939\\u093D\\u0950\\u0958-\\u0961\\u0971-\\u0980\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BD\\u09CE\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AD0\\u0AE0\\u0AE1\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B71\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BD0\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D\\u0C58\\u0C59\\u0C60\\u0C61\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBD\\u0CDE\\u0CE0\\u0CE1\\u0CF1\\u0CF2\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D\\u0D4E\\u0D60\\u0D61\\u0D7A-\\u0D7F\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0E01-\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E46\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EDC-\\u0EDF\\u0F00\\u0F40-\\u0F47\\u0F49-\\u0F6C\\u0F88-\\u0F8C\\u1000-\\u102A\\u103F\\u1050-\\u1055\\u105A-\\u105D\\u1061\\u1065\\u1066\\u106E-\\u1070\\u1075-\\u1081\\u108E\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176C\\u176E-\\u1770\\u1780-\\u17B3\\u17D7\\u17DC\\u1820-\\u1877\\u1880-\\u18A8\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1950-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19C1-\\u19C7\\u1A00-\\u1A16\\u1A20-\\u1A54\\u1AA7\\u1B05-\\u1B33\\u1B45-\\u1B4B\\u1B83-\\u1BA0\\u1BAE\\u1BAF\\u1BBA-\\u1BE5\\u1C00-\\u1C23\\u1C4D-\\u1C4F\\u1C5A-\\u1C7D\\u1CE9-\\u1CEC\\u1CEE-\\u1CF1\\u1CF5\\u1CF6\\u1D00-\\u1DBF\\u1E00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2071\\u207F\\u2090-\\u209C\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CEE\\u2CF2\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2E2F\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA61F\\uA62A\\uA62B\\uA640-\\uA66E\\uA67F-\\uA69D\\uA6A0-\\uA6EF\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA801\\uA803-\\uA805\\uA807-\\uA80A\\uA80C-\\uA822\\uA840-\\uA873\\uA882-\\uA8B3\\uA8F2-\\uA8F7\\uA8FB\\uA90A-\\uA925\\uA930-\\uA946\\uA960-\\uA97C\\uA984-\\uA9B2\\uA9CF\\uA9E0-\\uA9E4\\uA9E6-\\uA9EF\\uA9FA-\\uA9FE\\uAA00-\\uAA28\\uAA40-\\uAA42\\uAA44-\\uAA4B\\uAA60-\\uAA76\\uAA7A\\uAA7E-\\uAAAF\\uAAB1\\uAAB5\\uAAB6\\uAAB9-\\uAABD\\uAAC0\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEA\\uAAF2-\\uAAF4\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABE2\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D\\uFB1F-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF21-\\uFF3A\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]");

	})();

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "IxVs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var eventService_1 = __webpack_require__("k5uU");
var events_1 = __webpack_require__("3ok8");
var logger_1 = __webpack_require__("U9Xd");
var infiniteBlock_1 = __webpack_require__("uQOo");
var rowNodeCache_1 = __webpack_require__("sc2Y");
var gridApi_1 = __webpack_require__("BAow");
var columnApi_1 = __webpack_require__("E/Wy");
var InfiniteCache = (function (_super) {
    __extends(InfiniteCache, _super);
    function InfiniteCache(params) {
        return _super.call(this, params) || this;
    }
    InfiniteCache.prototype.setBeans = function (loggerFactory) {
        this.logger = loggerFactory.create('InfiniteCache');
    };
    InfiniteCache.prototype.init = function () {
        _super.prototype.init.call(this);
        // start load of data, as the virtualRowCount will remain at 0 otherwise,
        // so we need this to kick things off, otherwise grid would never call getRow()
        this.getRow(0);
    };
    InfiniteCache.prototype.moveItemsDown = function (page, moveFromIndex, moveCount) {
        var startRow = page.getStartRow();
        var endRow = page.getEndRow();
        var indexOfLastRowToMove = moveFromIndex + moveCount;
        // all rows need to be moved down below the insertion index
        for (var currentRowIndex = endRow - 1; currentRowIndex >= startRow; currentRowIndex--) {
            // don't move rows at or before the insertion index
            if (currentRowIndex < indexOfLastRowToMove) {
                continue;
            }
            var indexOfNodeWeWant = currentRowIndex - moveCount;
            var nodeForThisIndex = this.getRow(indexOfNodeWeWant, true);
            if (nodeForThisIndex) {
                page.setRowNode(currentRowIndex, nodeForThisIndex);
            }
            else {
                page.setBlankRowNode(currentRowIndex);
                page.setDirty();
            }
        }
    };
    InfiniteCache.prototype.insertItems = function (block, indexToInsert, items) {
        var pageStartRow = block.getStartRow();
        var pageEndRow = block.getEndRow();
        var newRowNodes = [];
        // next stage is insert the rows into this page, if applicable
        for (var index = 0; index < items.length; index++) {
            var rowIndex = indexToInsert + index;
            var currentRowInThisPage = rowIndex >= pageStartRow && rowIndex < pageEndRow;
            if (currentRowInThisPage) {
                var dataItem = items[index];
                var newRowNode = block.setNewData(rowIndex, dataItem);
                newRowNodes.push(newRowNode);
            }
        }
        return newRowNodes;
    };
    InfiniteCache.prototype.insertItemsAtIndex = function (indexToInsert, items) {
        // get all page id's as NUMBERS (not strings, as we need to sort as numbers) and in descending order
        var _this = this;
        var newNodes = [];
        this.forEachBlockInReverseOrder(function (block) {
            var pageEndRow = block.getEndRow();
            // if the insertion is after this page, then this page is not impacted
            if (pageEndRow <= indexToInsert) {
                return;
            }
            _this.moveItemsDown(block, indexToInsert, items.length);
            var newNodesThisPage = _this.insertItems(block, indexToInsert, items);
            newNodesThisPage.forEach(function (rowNode) { return newNodes.push(rowNode); });
        });
        if (this.isMaxRowFound()) {
            this.hack_setVirtualRowCount(this.getVirtualRowCount() + items.length);
        }
        this.onCacheUpdated();
        var event = {
            type: events_1.Events.EVENT_ROW_DATA_UPDATED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(event);
    };
    // the rowRenderer will not pass dontCreatePage, meaning when rendering the grid,
    // it will want new pages in the cache as it asks for rows. only when we are inserting /
    // removing rows via the api is dontCreatePage set, where we move rows between the pages.
    InfiniteCache.prototype.getRow = function (rowIndex, dontCreatePage) {
        if (dontCreatePage === void 0) { dontCreatePage = false; }
        var blockId = Math.floor(rowIndex / this.cacheParams.blockSize);
        var block = this.getBlock(blockId);
        if (!block) {
            if (dontCreatePage) {
                return null;
            }
            else {
                block = this.createBlock(blockId);
            }
        }
        return block.getRow(rowIndex);
    };
    InfiniteCache.prototype.createBlock = function (blockNumber) {
        var newBlock = new infiniteBlock_1.InfiniteBlock(blockNumber, this.cacheParams);
        this.context.wireBean(newBlock);
        this.postCreateBlock(newBlock);
        return newBlock;
    };
    // we have this on infinite row model only, not enterprise row model,
    // because for enterprise, it would leave the children in inconsistent
    // state - eg if a node had children, but after the refresh it had data
    // for a different row, then the children would be with the wrong row node.
    InfiniteCache.prototype.refreshCache = function () {
        this.forEachBlockInOrder(function (block) { return block.setDirty(); });
        this.checkBlockToLoad();
    };
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], InfiniteCache.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], InfiniteCache.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], InfiniteCache.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], InfiniteCache.prototype, "gridApi", void 0);
    __decorate([
        __param(0, context_1.Qualifier('loggerFactory')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
        __metadata("design:returntype", void 0)
    ], InfiniteCache.prototype, "setBeans", null);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], InfiniteCache.prototype, "init", null);
    return InfiniteCache;
}(rowNodeCache_1.RowNodeCache));
exports.InfiniteCache = InfiniteCache;


/***/ }),

/***/ "JCBf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
function defaultGroupComparator(valueA, valueB, nodeA, nodeB, accentedCompare) {
    if (accentedCompare === void 0) { accentedCompare = false; }
    console.warn('ag-Grid: Since ag-grid 11.0.0 defaultGroupComparator is not necessary. You can remove this from your colDef');
    var nodeAIsGroup = utils_1.Utils.exists(nodeA) && nodeA.group;
    var nodeBIsGroup = utils_1.Utils.exists(nodeB) && nodeB.group;
    var bothAreGroups = nodeAIsGroup && nodeBIsGroup;
    var bothAreNormal = !nodeAIsGroup && !nodeBIsGroup;
    if (bothAreGroups) {
        return utils_1.Utils.defaultComparator(nodeA.key, nodeB.key, accentedCompare);
    }
    else if (bothAreNormal) {
        return utils_1.Utils.defaultComparator(valueA, valueB, accentedCompare);
    }
    else if (nodeAIsGroup) {
        return 1;
    }
    else {
        return -1;
    }
}
exports.defaultGroupComparator = defaultGroupComparator;


/***/ }),

/***/ "JHp9":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(907);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 887:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(887) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($, undefined) {
	    var kendo = window.kendo,
	        diagram = kendo.dataviz.diagram = {},
	        deepExtend = kendo.deepExtend,
	        isArray = $.isArray,
	        EPSILON = 1e-06;

	    /*-------------------Diverse utilities----------------------------*/
	    var Utils = {
	    };

	    deepExtend(Utils, {
	        isNearZero: function (num) {
	            return Math.abs(num) < EPSILON;
	        },
	        isDefined: function (obj) {
	            return typeof obj !== 'undefined';
	        },

	        isUndefined: function (obj) {
	            return (typeof obj === 'undefined') || obj === null;
	        },
	        /**
	         * Returns whether the given object is an object or a value.
	         */
	        isObject: function (obj) {
	            return obj === Object(obj);
	        },
	        /**
	         * Returns whether the object has a property with the given name.
	         */
	        has: function (obj, key) {
	            return Object.hasOwnProperty.call(obj, key);
	        },
	        /**
	         * Returns whether the given object is a string.
	         */
	        isString: function (obj) {
	            return Object.prototype.toString.call(obj) == '[object String]';
	        },
	        isBoolean: function (obj) {
	            return Object.prototype.toString.call(obj) == '[object Boolean]';
	        },
	        isType: function (obj, type) {
	            return Object.prototype.toString.call(obj) == '[object ' + type + ']';
	        },
	        /**
	         * Returns whether the given object is a number.
	         */
	        isNumber: function (obj) {
	            return !isNaN(parseFloat(obj)) && isFinite(obj);
	        },
	        /**
	         * Return whether the given object (array or dictionary).
	         */
	        isEmpty: function (obj) {
	            if (obj === null) {
	                return true;
	            }
	            if (isArray(obj) || Utils.isString(obj)) {
	                return obj.length === 0;
	            }
	            for (var key in obj) {
	                if (Utils.has(obj, key)) {
	                    return false;
	                }
	            }
	            return true;
	        },
	        simpleExtend: function(destination, source) {
	            if(!Utils.isObject(source)) {
	                return;
	            }

	            for(var name in source) {
	                destination[name] = source[name];
	            }
	        },
	        /**
	         * Returns an array of the specified size and with each entry set to the given value.
	         * @param size
	         * @param value
	         * @returns {Array}
	         */
	        initArray: function createIdArray(size, value) {
	            var array = [];
	            for (var i = 0; i < size; ++i) {
	                array[i] = value;
	            }
	            return array;
	        },
	        serializePoints: function (points) {
	            var res = [];
	            for (var i = 0; i < points.length; i++) {
	                var p = points[i];
	                res.push(p.x + ";" + p.y);
	            }
	            return res.join(";");
	        },
	        deserializePoints: function (s) {
	            var v = s.split(";"), points = [];
	            if (v.length % 2 !== 0) {
	                throw "Not an array of points.";
	            }
	            for (var i = 0; i < v.length; i += 2) {
	                points.push(new diagram.Point(
	                    parseInt(v[i], 10),
	                    parseInt(v[i + 1], 10)
	                ));
	            }
	            return points;
	        },
	        /**
	         * Returns an integer within the given bounds.
	         * @param lower The inclusive lower bound.
	         * @param upper The exclusive upper bound.
	         * @returns {number}
	         */
	        randomInteger: function (lower, upper) {
	            return parseInt(Math.floor(Math.random() * upper) + lower, 10);
	        } ,
	        /*
	         Depth-first traversal of the given node.
	         */
	        DFT: function (el, func) {
	            func(el);
	            if (el.childNodes) {
	                for (var i = 0; i < el.childNodes.length; i++) {
	                    var item = el.childNodes[i];
	                    this.DFT(item, func);
	                }
	            }
	        },
	        /*
	         Returns the angle in degrees for the given matrix
	         */
	        getMatrixAngle: function (m) {
	            if (m === null || m.d === 0) {
	                return 0;
	            }
	            return Math.atan2(m.b, m.d) * 180 / Math.PI;
	        },

	        /*
	         Returns the scaling factors for the given matrix.
	         */
	        getMatrixScaling: function (m) {
	            var sX = Math.sqrt(m.a * m.a + m.c * m.c);
	            var sY = Math.sqrt(m.b * m.b + m.d * m.d);
	            return [sX, sY];
	        }

	    });

	    /**
	     * The Range defines an array of equally separated numbers.
	     * @param start The start-value of the Range.
	     * @param stop The end-value of the Range.
	     * @param step The separation between the values (default:1).
	     * @returns {Array}
	     */
	    function Range(start, stop, step) {
	        if (typeof start == 'undefined' || typeof stop == 'undefined') {
	            return [];
	        }
	        if (step && Utils.sign(stop - start) != Utils.sign(step)) {
	            throw "The sign of the increment should allow to reach the stop-value.";
	        }
	        step = step || 1;
	        start = start || 0;
	        stop = stop || start;
	        if ((stop - start) / step === Infinity) {
	            throw "Infinite range defined.";
	        }
	        var range = [], i = -1, j;

	        function rangeIntegerScale(x) {
	            var k = 1;
	            while (x * k % 1) {
	                k *= 10;
	            }
	            return k;
	        }

	        var k = rangeIntegerScale(Math.abs(step));
	        start *= k;
	        stop *= k;
	        step *= k;
	        if (start > stop && step > 0) {
	            step = -step;
	        }
	        if (step < 0) {
	            while ((j = start + step * ++i) >= stop) {
	                range.push(j / k);
	            }
	        }
	        else {
	            while ((j = start + step * ++i) <= stop) {
	                range.push(j / k);
	            }
	        }
	        return range;
	    }

	    /*-------------------Diverse math functions----------------------------*/

	    function findRadian(start, end) {
	        if (start == end) {
	            return 0;
	        }
	        var sngXComp = end.x - start.x,
	            sngYComp = start.y - end.y,
	            atan = Math.atan(sngXComp / sngYComp);
	        if (sngYComp >= 0) {
	            return sngXComp < 0 ? atan + (2 * Math.PI) : atan;
	        }
	        return atan + Math.PI;
	    }

	    Utils.sign = function(number) {
	        return number ? number < 0 ? -1 : 1 : 0;
	    };

	    Utils.findAngle = function(center, end) {
	        return findRadian(center, end) * 180 / Math.PI;
	    };

	    /*-------------------Array Helpers ----------------------------*/

	    Utils.forEach = function(arr, iterator, thisRef) {
	        for (var i = 0; i < arr.length; i++) {
	            iterator.call(thisRef, arr[i], i, arr);
	        }
	    };

	    Utils.any = function(arr, predicate) {
	        for (var i = 0; i < arr.length; ++i) {
	            if (predicate(arr[i])) {
	                return arr[i];
	            }
	        }
	        return null;
	    };

	    Utils.remove = function (arr, what) {
	        var ax;
	        while ((ax = Utils.indexOf(arr, what)) !== -1) {
	            arr.splice(ax, 1);
	        }
	        return arr;
	    };

	    Utils.contains = function (arr, obj) {
	        return Utils.indexOf(arr, obj) !== -1;
	    };

	    Utils.indexOf = function(arr, what) {
	        return $.inArray(what, arr);
	    };

	    Utils.fold = function (list, iterator, acc, context) {
	        var initial = arguments.length > 2;

	        for (var i = 0; i < list.length; i++) {
	            var value = list[i];
	            if (!initial) {
	                acc = value;
	                initial = true;
	            }
	            else {
	                acc = iterator.call(context, acc, value, i, list);
	            }
	        }

	        if (!initial) {
	            throw 'Reduce of empty array with no initial value';
	        }

	        return acc;
	    };

	    Utils.find = function (arr, iterator, context) {
	        var result;
	        Utils.any(arr, function (value, index, list) {
	            if (iterator.call(context, value, index, list)) {
	                result = value;
	                return true;
	            }
	            return false;
	        });
	        return result;
	    };

	    Utils.first = function (arr, constraint, context) {
	        if (arr.length === 0) {
	            return null;
	        }
	        if (Utils.isUndefined(constraint)) {
	            return arr[0];
	        }

	        return Utils.find(arr, constraint, context);
	    };

	    /**
	     * Inserts the given element at the specified position and returns the result.
	     */
	    Utils.insert = function (arr, element, position) {
	        arr.splice(position, 0, element);
	        return arr;
	    };

	    Utils.all = function (arr, iterator, context) {
	        var result = true;
	        var value;

	        for (var i = 0; i < arr.length; i++) {
	            value = arr[i];
	            result = result && iterator.call(context, value, i, arr);

	            if (!result) {
	                break;
	            }
	        }

	        return result;
	    };

	    Utils.clear = function (arr) {
	        arr.splice(0, arr.length);
	    };

	    /**
	     * Sort the arrays on the basis of the first one (considered as keys and the other array as values).
	     * @param a
	     * @param b
	     * @param sortfunc (optiona) sorting function for the values in the first array
	     */
	    Utils.bisort = function (a, b, sortfunc) {
	        if (Utils.isUndefined(a)) {
	            throw "First array is not specified.";
	        }
	        if (Utils.isUndefined(b)) {
	            throw "Second array is not specified.";
	        }
	        if (a.length != b.length) {
	            throw "The two arrays should have equal length";
	        }

	        var all = [], i;

	        for (i = 0; i < a.length; i++) {
	            all.push({ 'x': a[i], 'y': b[i] });
	        }
	        if (Utils.isUndefined(sortfunc)) {
	            all.sort(function (m, n) {
	                return m.x - n.x;
	            });
	        }
	        else {
	            all.sort(function (m, n) {
	                return sortfunc(m.x, n.x);
	            });
	        }

	        Utils.clear(a);
	        Utils.clear(b);

	        for (i = 0; i < all.length; i++) {
	            a.push(all[i].x);
	            b.push(all[i].y);
	        }
	    };

	    Utils.addRange = function (arr, range) {
	        arr.push.apply(arr, range);
	    };

	    var Easing = {
	        easeInOut: function (pos) {
	            return ((-Math.cos(pos * Math.PI) / 2) + 0.5);
	        }
	    };

	    /**
	     * An animation ticker driving an adapter which sets a particular
	     * property in function of the tick.
	     * @type {*}
	     */
	    var Ticker = kendo.Class.extend({
	        init: function () {
	            this.adapters = [];
	            this.target = 0;
	            this.tick = 0;
	            this.interval = 20;
	            this.duration = 800;
	            this.lastTime = null;
	            this.handlers = [];
	            var _this = this;
	            this.transition = Easing.easeInOut;
	            this.timerDelegate = function () {
	                _this.onTimerEvent();
	            };
	        },
	        addAdapter: function (a) {
	            this.adapters.push(a);
	        },
	        onComplete: function (handler) {
	            this.handlers.push(handler);
	        },
	        removeHandler: function (handler) {
	            this.handlers = $.grep(this.handlers, function (h) {
	                return h !== handler;
	            });
	        },
	        trigger: function () {
	            var _this = this;
	            if (this.handlers) {
	                Utils.forEach(this.handlers, function (h) {
	                    return h.call(_this.caller !== null ? _this.caller : _this);
	                });
	            }
	        },
	        onStep: function () {
	        },
	        seekTo: function (to) {
	            this.seekFromTo(this.tick, to);
	        },
	        seekFromTo: function (from, to) {
	            this.target = Math.max(0, Math.min(1, to));
	            this.tick = Math.max(0, Math.min(1, from));
	            this.lastTime = new Date().getTime();
	            if (!this.intervalId) {
	                this.intervalId = window.setInterval(this.timerDelegate, this.interval);
	            }
	        },
	        stop: function () {
	            if (this.intervalId) {
	                window.clearInterval(this.intervalId);
	                this.intervalId = null;

	                //this.trigger.call(this);
	                this.trigger();
	                // this.next();
	            }
	        },
	        play: function (origin) {
	            if (this.adapters.length === 0) {
	                return;
	            }
	            if (origin !== null) {
	                this.caller = origin;
	            }
	            this.initState();
	            this.seekFromTo(0, 1);
	        },
	        reverse: function () {
	            this.seekFromTo(1, 0);
	        },
	        initState: function () {
	            if (this.adapters.length === 0) {
	                return;
	            }
	            for (var i = 0; i < this.adapters.length; i++) {
	                this.adapters[i].initState();
	            }
	        },
	        propagate: function () {
	            var value = this.transition(this.tick);

	            for (var i = 0; i < this.adapters.length; i++) {
	                this.adapters[i].update(value);
	            }
	        },
	        onTimerEvent: function () {
	            var now = new Date().getTime();
	            var timePassed = now - this.lastTime;
	            this.lastTime = now;
	            var movement = (timePassed / this.duration) * (this.tick < this.target ? 1 : -1);
	            if (Math.abs(movement) >= Math.abs(this.tick - this.target)) {
	                this.tick = this.target;
	            } else {
	                this.tick += movement;
	            }

	            try {
	                this.propagate();
	            } finally {
	                this.onStep.call(this);
	                if (this.target == this.tick) {
	                    this.stop();
	                }
	            }
	        }
	    });

	    kendo.deepExtend(diagram, {
	        init: function (element) {
	            kendo.init(element, diagram.ui);
	        },

	        Utils: Utils,
	        Range: Range,
	        Ticker: Ticker
	    });
	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "JKVm":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1361);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1361:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1109) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "resizable",
	    name: "Resizable",
	    category: "framework",
	    depends: [ "core", "draganddrop" ],
	    advanced: true
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        proxy = $.proxy,
	        isFunction = kendo.isFunction,
	        extend = $.extend,
	        HORIZONTAL = "horizontal",
	        VERTICAL = "vertical",
	        START = "start",
	        RESIZE = "resize",
	        RESIZEEND = "resizeend";

	    var Resizable = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            that.orientation = that.options.orientation.toLowerCase() != VERTICAL ? HORIZONTAL : VERTICAL;
	            that._positionMouse = that.orientation == HORIZONTAL ? "x" : "y";
	            that._position = that.orientation == HORIZONTAL ? "left" : "top";
	            that._sizingDom = that.orientation == HORIZONTAL ? "outerWidth" : "outerHeight";

	            that.draggable = new ui.Draggable(options.draggableElement || element, {
	                distance: 1,
	                filter: options.handle,
	                drag: proxy(that._resize, that),
	                dragcancel: proxy(that._cancel, that),
	                dragstart: proxy(that._start, that),
	                dragend: proxy(that._stop, that)
	            });

	            that.userEvents = that.draggable.userEvents;
	        },

	        events: [
	            RESIZE,
	            RESIZEEND,
	            START
	        ],

	        options: {
	            name: "Resizable",
	            orientation: HORIZONTAL
	        },

	        resize: function() {
	            // Overrides base widget resize
	        },

	        _max: function(e) {
	            var that = this,
	                hintSize = that.hint ? that.hint[that._sizingDom]() : 0,
	                size = that.options.max;

	            return isFunction(size) ? size(e) : size !== undefined ? (that._initialElementPosition + size) - hintSize : size;
	        },

	        _min: function(e) {
	            var that = this,
	                size = that.options.min;

	            return isFunction(size) ? size(e) : size !== undefined ? that._initialElementPosition + size : size;
	        },

	        _start: function(e) {
	            var that = this,
	                hint = that.options.hint,
	                el = $(e.currentTarget);

	            that._initialElementPosition = el.position()[that._position];
	            that._initialMousePosition = e[that._positionMouse].startLocation;

	            if (hint) {
	                that.hint = isFunction(hint) ? $(hint(el)) : hint;

	                that.hint.css({
	                    position: "absolute"
	                })
	                .css(that._position, that._initialElementPosition)
	                .appendTo(that.element);
	            }

	            that.trigger(START, e);

	            that._maxPosition = that._max(e);
	            that._minPosition = that._min(e);

	            $(document.body).css("cursor", el.css("cursor"));
	        },

	        _resize: function(e) {
	            var that = this,
	                maxPosition = that._maxPosition,
	                minPosition = that._minPosition,
	                currentPosition = that._initialElementPosition + (e[that._positionMouse].location - that._initialMousePosition),
	                position;

	            position = minPosition !== undefined ? Math.max(minPosition, currentPosition) : currentPosition;
	            that.position = position =  maxPosition !== undefined ? Math.min(maxPosition, position) : position;

	            if(that.hint) {
	                that.hint.toggleClass(that.options.invalidClass || "", position == maxPosition || position == minPosition)
	                         .css(that._position, position);
	            }

	            that.resizing = true;
	            that.trigger(RESIZE, extend(e, { position: position }));
	        },

	        _stop: function(e) {
	            var that = this;

	            if(that.hint) {
	                that.hint.remove();
	            }

	            that.resizing = false;
	            that.trigger(RESIZEEND, extend(e, { position: that.position }));
	            $(document.body).css("cursor", "");
	        },

	        _cancel: function(e) {
	            var that = this;

	            if (that.hint) {
	                that.position = undefined;
	                that.hint.css(that._position, that._initialElementPosition);
	                that._stop(e);
	            }
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            if (that.draggable) {
	                that.draggable.destroy();
	            }
	        },

	        press: function(target) {
	            if (!target) {
	                return;
	            }

	            var position = target.position(),
	                that = this;

	            that.userEvents.press(position.left, position.top, target[0]);
	            that.targetPosition = position;
	            that.target = target;
	        },

	        move: function(delta) {
	            var that = this,
	                orientation = that._position,
	                position = that.targetPosition,
	                current = that.position;

	            if (current === undefined) {
	                current = position[orientation];
	            }

	            position[orientation] = current + delta;

	            that.userEvents.move(position.left, position.top);
	        },

	        end: function() {
	            this.userEvents.end();
	            this.target = this.position = undefined;
	        }
	    });

	    kendo.ui.plugin(Resizable);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "JLYF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var themeNames = ['fresh', 'dark', 'blue', 'bootstrap', 'material'];
var themes = themeNames.concat(themeNames.map(function (name) { return "theme-" + name; }));
var themeClass = new RegExp("ag-(" + themes.join('|') + ")");
var matGridSize = 8;
var freshGridSize = 4;
var HARD_CODED_SIZES = {
    'ag-theme-material': {
        headerHeight: matGridSize * 7,
        virtualItemHeight: matGridSize * 5,
        rowHeight: matGridSize * 6
    },
    'ag-theme-classic': {
        headerHeight: 25,
        virtualItemHeight: freshGridSize * 5,
        rowHeight: 25
    }
};
var Environment = (function () {
    function Environment() {
        this.sassVariables = {};
    }
    // Approach described here:
    // https://www.ofcodeandcolor.com/2017/04/02/encoding-data-in-css/
    Environment.prototype.loadSassVariables = function () {
        /*
        var element = document.createElement('div');
        element.className = 'sass-variables';
        this.eGridDiv.appendChild(element);

        var content = window.getComputedStyle(element, '::after').content;

        try {
            this.sassVariables = JSON.parse(JSON.parse(content));
        } catch (e) {
            throw new Error("Failed loading the theme sizing - check that you have the theme set up correctly.");
        }

        this.eGridDiv.removeChild(element);
        */
    };
    Environment.prototype.getSassVariable = function (theme, key) {
        if (theme == 'ag-theme-material') {
            return HARD_CODED_SIZES['ag-theme-material'][key];
        }
        return HARD_CODED_SIZES['ag-theme-classic'][key];
        /*
        const result = parseInt(this.sassVariables[key]);
        if (!result || isNaN(result)) {
            throw new Error(`Failed loading ${key} Sass variable from ${this.sassVariables}`);
        }
        return result;
        */
    };
    Environment.prototype.getTheme = function () {
        var themeMatch;
        var element = this.eGridDiv;
        while (element != document.documentElement && themeMatch == null) {
            themeMatch = element.className.match(themeClass);
            element = element.parentElement;
            if (element == null) {
                break;
            }
        }
        if (themeMatch) {
            return themeMatch[0];
        }
        else {
            return 'ag-fresh';
        }
    };
    __decorate([
        context_1.Autowired('eGridDiv'),
        __metadata("design:type", HTMLElement)
    ], Environment.prototype, "eGridDiv", void 0);
    Environment = __decorate([
        context_1.Bean('environment')
    ], Environment);
    return Environment;
}());
exports.Environment = Environment;


/***/ }),

/***/ "JP+z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "Jrhv":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(921);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 916:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("pV45");

/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(922), __webpack_require__(916),
	             __webpack_require__(923), __webpack_require__(924) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($, undefined) {
	    // Imports ================================================================
	    var doc = document,
	        math = Math,
	        indexOf = $.inArray,
	        proxy = $.proxy,

	        kendo = window.kendo,
	        Class = kendo.Class,
	        DataSource = kendo.data.DataSource,
	        Tooltip = kendo.ui.Tooltip,

	        dataviz = kendo.dataviz,
	        deepExtend = kendo.deepExtend,

	        map = dataviz.map,
	        Location = map.Location,
	        Layer = map.layers.Layer;

	    // Implementation =========================================================
	    var MarkerLayer = Layer.extend({
	        init: function(map, options) {
	            Layer.fn.init.call(this, map, options);

	            this._markerClick = proxy(this._markerClick, this);
	            this.element.on("click", ".k-marker", this._markerClick);

	            this.items = [];
	            this._initDataSource();
	        },

	        destroy: function() {
	            Layer.fn.destroy.call(this);

	            this.element.off("click", ".k-marker", this._markerClick);

	            this.dataSource.unbind("change", this._dataChange);
	            this.clear();
	        },

	        options: {
	            zIndex: 1000,
	            autoBind: true,
	            dataSource: {},
	            locationField: "location",
	            titleField: "title"
	        },

	        add: function(arg) {
	            if ($.isArray(arg)) {
	                for (var i = 0; i < arg.length; i++) {
	                    this._addOne(arg[i]);
	                }
	            } else {
	                return this._addOne(arg);
	            }
	        },

	        remove: function(marker) {
	            marker.destroy();

	            var index = indexOf(marker, this.items);
	            if (index > -1) {
	                this.items.splice(index, 1);
	            }
	        },

	        clear: function() {
	            for (var i = 0; i < this.items.length; i++) {
	                this.items[i].destroy();
	            }

	            this.items = [];
	        },

	        update: function(marker) {
	            var loc = marker.location();
	            if (loc) {
	                marker.showAt(this.map.locationToView(loc));

	                var args = { marker: marker, layer: this };
	                this.map.trigger("markerActivate", args);
	            }
	        },

	        _reset: function() {
	            Layer.fn._reset.call(this);
	            var items = this.items;
	            for (var i = 0; i < items.length; i++) {
	                this.update(items[i]);
	            }
	        },

	        bind: function (options, dataItem) {
	            var marker = map.Marker.create(options, this.options);
	            marker.dataItem = dataItem;

	            var args = { marker: marker, layer: this };
	            var cancelled = this.map.trigger("markerCreated", args);
	            if (!cancelled) {
	                this.add(marker);
	                return marker;
	            }
	        },

	        setDataSource: function(dataSource) {
	            if (this.dataSource) {
	                this.dataSource.unbind("change", this._dataChange);
	            }

	            this.dataSource = kendo.data.DataSource.create(dataSource);
	            this.dataSource.bind("change", this._dataChange);

	            if (this.options.autoBind) {
	                this.dataSource.fetch();
	            }
	        },

	        _addOne: function(arg) {
	            var marker = Marker.create(arg, this.options);
	            marker.addTo(this);

	            return marker;
	        },

	        _initDataSource: function() {
	            var dsOptions = this.options.dataSource;
	            this._dataChange = proxy(this._dataChange, this);
	            this.dataSource = DataSource
	                .create(dsOptions)
	                .bind("change", this._dataChange);

	            if (dsOptions && this.options.autoBind) {
	                this.dataSource.fetch();
	            }
	        },

	        _dataChange: function(e) {
	            this._load(e.sender.view());
	        },

	        _load: function(data) {
	            this._data = data;
	            this.clear();

	            var getLocation = kendo.getter(this.options.locationField);
	            var getTitle = kendo.getter(this.options.titleField);
	            for (var i = 0; i < data.length; i++) {
	                var dataItem = data[i];
	                this.bind({
	                    location: getLocation(dataItem),
	                    title: getTitle(dataItem)
	                }, dataItem);
	            }
	        },

	        _markerClick: function(e) {
	            var args = { marker: $(e.target).data("kendoMarker"), layer: this };
	            this.map.trigger("markerClick", args);
	        }
	    });

	    var Marker = Class.extend({
	        init: function(options) {
	            this.options = options || {};
	        },

	        addTo: function(parent) {
	            this.layer = parent.markers || parent;
	            this.layer.items.push(this);
	            this.layer.update(this);
	        },

	        location: function(value) {
	            if (value) {
	                this.options.location = Location.create(value).toArray();

	                if (this.layer) {
	                    this.layer.update(this);
	                }

	                return this;
	            } else {
	                return Location.create(this.options.location);
	            }
	        },

	        showAt: function(point) {
	            this.render();
	            this.element.css({
	                left: math.round(point.x),
	                top: math.round(point.y)
	            });

	            if (this.tooltip && this.tooltip.popup) {
	                // TODO: Expose popup/tooltip updatePosition? method
	                this.tooltip.popup._position();
	            }
	        },

	        hide: function() {
	            if (this.element) {
	                this.element.remove();
	                this.element = null;
	            }

	            if (this.tooltip) {
	                this.tooltip.destroy();
	                this.tooltip = null;
	            }
	        },

	        destroy: function() {
	            this.layer = null;
	            this.hide();
	        },

	        render: function() {
	            if (!this.element) {
	                var options = this.options;
	                var layer = this.layer;

	                this.element = $(doc.createElement("span"))
	                    .addClass("k-marker k-icon k-i-marker-" + kendo.toHyphens(options.shape || "pin"))
	                    .attr("title", options.title)
	                    .attr(options.attributes || {})
	                    .data("kendoMarker", this)
	                    .css("zIndex", options.zIndex);

	                if (layer) {
	                    layer.element.append(this.element);
	                }

	                this.renderTooltip();
	            }
	        },

	        renderTooltip: function() {
	            var marker = this;
	            var title = marker.options.title;
	            var options = marker.options.tooltip || {};

	            if (options && Tooltip) {
	                var template = options.template;
	                if (template) {
	                    var contentTemplate = kendo.template(template);
	                    options.content = function(e) {
	                        e.location = marker.location();
	                        e.marker = marker;
	                        return contentTemplate(e);
	                    };
	                }

	                if (title || options.content || options.contentUrl) {
	                    this.tooltip = new Tooltip(this.element, options);
	                    this.tooltip.marker = this;
	                }
	            }
	        }
	    });

	    Marker.create = function(arg, defaults) {
	        if (arg instanceof Marker) {
	            return arg;
	        }

	        return new Marker(deepExtend({}, defaults, arg));
	    };

	    // Exports ================================================================
	    deepExtend(dataviz, {
	        map: {
	            layers: {
	                marker: MarkerLayer,
	                MarkerLayer: MarkerLayer
	            },
	            Marker: Marker
	        }
	    });

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 922:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Rqq1");

/***/ }),

/***/ 923:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 924:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7Omp");

/***/ })

/******/ });

/***/ }),

/***/ "Jrwt":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1318);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FZAa");

/***/ }),

/***/ 1304:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MlFQ");

/***/ }),

/***/ 1318:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1059), __webpack_require__(1088), __webpack_require__(1304) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.listview",
	    name: "ListView",
	    category: "mobile",
	    description: "The Kendo Mobile ListView widget is used to display flat or grouped list of items.",
	    depends: [ "data", "userevents", "mobile.button" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        Node = window.Node,
	        mobile = kendo.mobile,
	        ui = mobile.ui,
	        outerHeight = kendo._outerHeight,
	        DataSource = kendo.data.DataSource,
	        Widget = ui.DataBoundWidget,
	        ITEM_SELECTOR = ".km-list > li, > li:not(.km-group-container)",
	        HIGHLIGHT_SELECTOR = ".km-listview-link, .km-listview-label",
	        ICON_SELECTOR = "[" + kendo.attr("icon") + "]",
	        proxy = $.proxy,
	        attrValue = kendo.attrValue,
	        GROUP_CLASS = "km-group-title",
	        ACTIVE_CLASS = "km-state-active",
	        GROUP_WRAPPER = '<div class="' + GROUP_CLASS + '"><div class="km-text"></div></div>',
	        GROUP_TEMPLATE = kendo.template('<li><div class="' + GROUP_CLASS + '"><div class="km-text">#= this.headerTemplate(data) #</div></div><ul>#= kendo.render(this.template, data.items)#</ul></li>'),
	        WRAPPER = '<div class="km-listview-wrapper"></div>',
	        SEARCH_TEMPLATE = kendo.template('<form class="km-filter-form"><div class="km-filter-wrap"><input type="search" placeholder="#=placeholder#"/><a href="\\#" class="km-filter-reset" title="Clear"><span class="km-icon km-clear"></span><span class="km-text">Clear</span></a></div></form>'),
	        NS = ".kendoMobileListView",
	        STYLED = "styled",
	        DATABOUND = "dataBound",
	        DATABINDING = "dataBinding",
	        ITEM_CHANGE = "itemChange",
	        CLICK = "click",
	        CHANGE = "change",
	        PROGRESS = "progress",
	        FUNCTION = "function",

	        whitespaceRegExp = /^\s+$/,
	        buttonRegExp = /button/;

	    function whitespace() {
	        return this.nodeType === Node.TEXT_NODE && this.nodeValue.match(whitespaceRegExp);
	    }

	    function addIcon(item, icon) {
	        if (icon && !item[0].querySelector(".km-icon")) {
	            item.prepend('<span class="km-icon km-' + icon + '"/>');
	        }
	    }

	    function enhanceItem(item) {
	        addIcon(item, attrValue(item, "icon"));
	        addIcon(item, attrValue(item.children(ICON_SELECTOR), "icon"));
	    }

	    function enhanceLinkItem(item) {
	        var parent = item.parent(),
	            itemAndDetailButtons = item.add(parent.children(kendo.roleSelector("detailbutton"))),
	            otherNodes = parent.contents().not(itemAndDetailButtons).not(whitespace);

	        if (otherNodes.length) {
	            return;
	        }

	        item.addClass("km-listview-link")
	            .attr(kendo.attr("role"), "listview-link");

	        addIcon(item, attrValue(parent, "icon"));
	        addIcon(item, attrValue(item, "icon"));
	    }

	    function enhanceCheckBoxItem(label) {
	        if (!label[0].querySelector("input[type=checkbox],input[type=radio]")) {
	            return;
	        }

	        var item = label.parent();

	        if (item.contents().not(label).not(function() { return this.nodeType == 3; })[0]) {
	            return;
	        }

	        label.addClass("km-listview-label");

	        label.children("[type=checkbox],[type=radio]").addClass("km-widget km-icon km-check");
	    }

	    function putAt(element, top) {
	        $(element).css('transform', 'translate3d(0px, ' + top + 'px, 0px)');
	    }

	    var HeaderFixer = kendo.Class.extend({
	        init: function(listView) {
	            var scroller = listView.scroller();

	            if (!scroller) {
	                return;
	            }

	            this.options = listView.options;
	            this.element = listView.element;
	            this.scroller = listView.scroller();
	            this._shouldFixHeaders();

	            var headerFixer = this;

	            var cacheHeaders = function() {
	                headerFixer._cacheHeaders();
	            };

	            listView.bind("resize", cacheHeaders);

	            listView.bind(STYLED, cacheHeaders);
	            listView.bind(DATABOUND, cacheHeaders);

	            this._scrollHandler = function(e) {
	                headerFixer._fixHeader(e);
	            };
	            scroller.bind("scroll", this._scrollHandler);
	        },

	        destroy: function() {
	            var that = this;
	            if (that.scroller) {
	                that.scroller.unbind("scroll", that._scrollHandler);
	            }
	        },

	        _fixHeader: function(e) {
	            if (!this.fixedHeaders) {
	                return;
	            }

	            var i = 0,
	                scroller = this.scroller,
	                headers = this.headers,
	                scrollTop = e.scrollTop,
	                headerPair,
	                offset,
	                header;

	            do {
	                headerPair = headers[i++];
	                if (!headerPair) {
	                    header = $("<div />");
	                    break;
	                }
	                offset = headerPair.offset;
	                header = headerPair.header;
	            } while (offset + 1 > scrollTop);

	            if (this.currentHeader != i) {
	                scroller.fixedContainer.html(header.clone());
	                this.currentHeader = i;
	            }
	        },

	        _shouldFixHeaders: function() {
	            this.fixedHeaders = this.options.type === "group" && this.options.fixedHeaders;
	        },

	        _cacheHeaders: function() {
	            this._shouldFixHeaders();

	            if (!this.fixedHeaders) {
	                return;
	            }

	            var headers = [], offset = this.scroller.scrollTop;

	            this.element.find("." + GROUP_CLASS).each(function(_, header) {
	                header = $(header);
	                headers.unshift({
	                    offset: header.position().top + offset,
	                    header: header
	                });
	            });

	            this.headers = headers;
	            this._fixHeader({ scrollTop: offset });
	        }
	    });

	    var DEFAULT_PULL_PARAMETERS = function() {
	        return { page: 1 };
	    };

	    var RefreshHandler = kendo.Class.extend({
	        init: function(listView) {
	            var handler = this,
	                options = listView.options,
	                scroller = listView.scroller(),
	                pullParameters = options.pullParameters || DEFAULT_PULL_PARAMETERS;

	            this.listView = listView;
	            this.scroller = scroller;

	            listView.bind("_dataSource", function(e) {
	                handler.setDataSource(e.dataSource);
	            });

	            scroller.setOptions({
	                pullToRefresh: true,
	                pull: function() {
	                    if (!handler._pulled) {
	                        handler._pulled = true;
	                        handler.dataSource.read(pullParameters.call(listView, handler._first));
	                    }
	                },
	                messages: {
	                    pullTemplate: options.messages.pullTemplate,
	                    releaseTemplate: options.messages.releaseTemplate,
	                    refreshTemplate: options.messages.refreshTemplate
	                }
	            });
	        },

	        setDataSource: function(dataSource) {
	            var handler = this;

	            this._first = dataSource.view()[0];
	            this.dataSource = dataSource;

	            dataSource.bind("change", function() {
	                handler._change();
	            });

	            dataSource.bind("error", function() {
	                handler._change();
	            });
	        },

	        _change: function() {
	            var scroller = this.scroller,
	                dataSource = this.dataSource;

	            if (this._pulled) {
	                scroller.pullHandled();
	            }

	            if (this._pulled || !this._first) {
	                var view = dataSource.view();

	                if (view[0]) {
	                    this._first = view[0];
	                }
	            }

	            this._pulled = false;
	        }
	    });

	    var VirtualList = kendo.Observable.extend({
	        init: function(options) {
	            var list = this;

	            kendo.Observable.fn.init.call(list);

	            list.buffer = options.buffer;
	            list.height = options.height;
	            list.item = options.item;
	            list.items = [];
	            list.footer = options.footer;

	            list.buffer.bind("reset", function() {
	                list.refresh();
	            });

	        },

	        refresh: function() {
	            var buffer = this.buffer,
	                items = this.items,
	                endReached = false;

	            while(items.length) {
	                items.pop().destroy();
	            }

	            this.offset = buffer.offset;

	            var itemConstructor = this.item,
	                prevItem,
	                item;

	            for (var idx = 0; idx < buffer.viewSize; idx ++) {
	                if (idx === buffer.total()) {
	                    endReached = true;
	                    break;
	                }
	                item = itemConstructor(this.content(this.offset + items.length));
	                item.below(prevItem);
	                prevItem = item;
	                items.push(item);
	            }

	            this.itemCount = items.length;

	            this.trigger("reset");

	            this._resize();

	            if (endReached) {
	                this.trigger("endReached");
	            }
	        },

	        totalHeight: function() {
	            if (!this.items[0]) {
	                return 0;
	            }

	            var list = this,
	                items = list.items,
	                top = items[0].top,
	                bottom = items[items.length - 1].bottom,
	                averageItemHeight = (bottom - top) / list.itemCount,
	                remainingItemsCount = list.buffer.length - list.offset - list.itemCount;

	            return (this.footer ? this.footer.height : 0) + bottom + remainingItemsCount * averageItemHeight;
	        },

	        batchUpdate: function(top) {
	            var height = this.height(),
	                items = this.items,
	                item,
	                initialOffset = this.offset;

	            if (!items[0]) {
	                return;
	            }

	            if (this.lastDirection) { // scrolling up
	                while(items[items.length - 1].bottom > top + height * 2) {
	                    if (this.offset === 0) {
	                        break;
	                    }

	                    this.offset --;
	                    item = items.pop();
	                    item.update(this.content(this.offset));
	                    item.above(items[0]);
	                    items.unshift(item);
	                }
	            } else { // scrolling down
	                while (items[0].top < top - height) {
	                    var nextIndex = this.offset + this.itemCount; // here, it should be offset + 1 + itemCount - 1.

	                    if (nextIndex === this.buffer.total()) {
	                        this.trigger("endReached");
	                        break;
	                    }

	                    if (nextIndex === this.buffer.length) {
	                        break;
	                    }

	                    item = items.shift();
	                    item.update(this.content(this.offset + this.itemCount));
	                    item.below(items[items.length - 1]);
	                    items.push(item);
	                    this.offset ++;
	                }
	            }

	            if (initialOffset !== this.offset) {
	                this._resize();
	            }
	        },

	        update: function(top) {
	            var list = this,
	                items = this.items,
	                item,
	                firstItem,
	                lastItem,
	                height = this.height(),
	                itemCount = this.itemCount,
	                padding = height / 2,
	                up = (this.lastTop || 0) > top,
	                topBorder = top - padding,
	                bottomBorder = top + height + padding;

	            if (!items[0]) {
	                return;
	            }

	            this.lastTop = top;
	            this.lastDirection = up;

	            if (up) { // scrolling up
	               if (items[0].top > topBorder &&  // needs reorder
	                   items[items.length - 1].bottom > bottomBorder + padding && // enough padding below
	                   this.offset > 0 // we are not at the top
	                  )
	               {
	                    this.offset --;
	                    item = items.pop();
	                    firstItem = items[0];
	                    item.update(this.content(this.offset));
	                    items.unshift(item);

	                    item.above(firstItem);
	                    list._resize();
	               }
	            } else { // scrolling down
	                if (
	                    items[items.length - 1].bottom < bottomBorder && // needs reorder
	                    items[0].top < topBorder - padding // enough padding above
	                )
	                {
	                    var nextIndex = this.offset + itemCount; // here, it should be offset + 1 + itemCount - 1.

	                    if (nextIndex === this.buffer.total()) {
	                        this.trigger("endReached");
	                    } else if (nextIndex !== this.buffer.length) {
	                        item = items.shift();
	                        lastItem = items[items.length - 1];
	                        items.push(item);
	                        item.update(this.content(this.offset + this.itemCount));
	                        list.offset ++;

	                        item.below(lastItem);
	                        list._resize();
	                    }
	                }
	            }
	        },

	        content: function(index) {
	            return this.buffer.at(index);
	        },

	        destroy: function() {
	            this.unbind();
	        },

	        _resize: function() {
	            var items = this.items,
	                top = 0,
	                bottom = 0,
	                firstItem = items[0],
	                lastItem = items[items.length - 1];

	            if (firstItem) {
	                top = firstItem.top;
	                bottom = lastItem.bottom;
	            }

	            this.trigger("resize", { top: top, bottom: bottom });

	            if (this.footer) {
	                this.footer.below(lastItem);
	            }
	        }
	    });

	    // export for testing purposes
	    kendo.mobile.ui.VirtualList = VirtualList;

	    var VirtualListViewItem = kendo.Class.extend({
	        init: function(listView, dataItem) {
	            var element = listView.append([dataItem], true)[0],
	                height = element.offsetHeight;

	            $.extend(this, {
	                top: 0,
	                element: element,
	                listView: listView,
	                height: height,
	                bottom: height
	            });
	        },

	        update: function(dataItem) {
	            this.element = this.listView.setDataItem(this.element, dataItem);
	        },

	        above: function(item) {
	            if (item) {
	                this.height = this.element.offsetHeight;
	                this.top = item.top - this.height;
	                this.bottom = item.top;
	                putAt(this.element, this.top);
	            }
	        },

	        below: function(item) {
	            if (item) {
	                this.height = this.element.offsetHeight;
	                this.top = item.bottom;
	                this.bottom = this.top + this.height;
	                putAt(this.element, this.top);
	            }
	        },

	        destroy: function() {
	            kendo.destroy(this.element);
	            $(this.element).remove();
	        }
	    });

	    var LOAD_ICON = '<div><span class="km-icon"></span><span class="km-loading-left"></span><span class="km-loading-right"></span></div>';
	    var VirtualListViewLoadingIndicator = kendo.Class.extend({
	        init: function(listView) {
	            this.element = $('<li class="km-load-more km-scroller-refresh" style="display: none"></li>').appendTo(listView.element);
	            this._loadIcon = $(LOAD_ICON).appendTo(this.element);
	        },

	        enable: function() {
	            this.element.show();
	            this.height = outerHeight(this.element, true);
	        },

	        disable: function() {
	            this.element.hide();
	            this.height = 0;
	        },

	        below: function(item) {
	            if (item) {
	                this.top = item.bottom;
	                this.bottom = this.height + this.top;
	                putAt(this.element, this.top);
	            }
	        }
	    });

	    var VirtualListViewPressToLoadMore = VirtualListViewLoadingIndicator.extend({
	        init: function(listView, buffer) {

	            this._loadIcon = $(LOAD_ICON).hide();
	            this._loadButton = $('<a class="km-load">' + listView.options.messages.loadMoreText + '</a>').hide();
	            this.element = $('<li class="km-load-more" style="display: none"></li>').append(this._loadIcon).append(this._loadButton).appendTo(listView.element);

	            var loadMore = this;

	            this._loadButton.kendoMobileButton().data("kendoMobileButton").bind("click", function() {
	                loadMore._hideShowButton();
	                buffer.next();
	            });

	            buffer.bind("resize", function() {
	                loadMore._showLoadButton();
	            });

	            this.height = outerHeight(this.element, true);
	            this.disable();
	        },

	        _hideShowButton: function() {
	            this._loadButton.hide();
	            this.element.addClass("km-scroller-refresh");
	            this._loadIcon.css('display', 'block');
	        },

	        _showLoadButton: function() {
	            this._loadButton.show();
	            this.element.removeClass("km-scroller-refresh");
	            this._loadIcon.hide();
	        }
	    });

	    var VirtualListViewItemBinder = kendo.Class.extend({
	        init: function(listView) {
	            var binder = this;

	            this.chromeHeight = outerHeight(listView.wrapper.children().not(listView.element));
	            this.listView = listView;
	            this.scroller = listView.scroller();
	            this.options = listView.options;

	            listView.bind("_dataSource", function(e) {
	                binder.setDataSource(e.dataSource, e.empty);
	            });

	            listView.bind("resize", function() {
	                if (!binder.list.items.length) {
	                    return;
	                }

	                binder.scroller.reset();
	                binder.buffer.range(0);
	                binder.list.refresh();
	            });

	            this.scroller.makeVirtual();

	            this._scroll = function(e) {
	                binder.list.update(e.scrollTop);
	            };
	            this.scroller.bind('scroll', this._scroll);
	            this._scrollEnd = function(e) {
	                binder.list.batchUpdate(e.scrollTop);
	            };
	            this.scroller.bind('scrollEnd', this._scrollEnd);
	        },

	        destroy: function() {
	            this.list.unbind();
	            this.buffer.unbind();
	            this.scroller.unbind('scroll', this._scroll);
	            this.scroller.unbind('scrollEnd', this._scrollEnd);
	        },

	        setDataSource: function(dataSource, empty) {
	            var binder = this,
	                options = this.options,
	                listView = this.listView,
	                scroller = listView.scroller(),
	                pressToLoadMore = options.loadMore,
	                pageSize,
	                buffer,
	                footer;

	            this.dataSource = dataSource;

	            pageSize = dataSource.pageSize() || options.virtualViewSize;

	            if (!pageSize && !empty) {
	                throw new Error("the DataSource does not have page size configured. Page Size setting is mandatory for the mobile listview virtual scrolling to work as expected.");
	            }

	            if (this.buffer) {
	                this.buffer.destroy();
	            }

	            buffer = new kendo.data.Buffer(dataSource, Math.floor(pageSize / 2), pressToLoadMore);

	            if (pressToLoadMore) {
	                footer = new VirtualListViewPressToLoadMore(listView, buffer);
	            } else {
	                footer = new VirtualListViewLoadingIndicator(listView);
	            }

	            if (this.list) {
	                this.list.destroy();
	            }

	            var list = new VirtualList({
	                buffer: buffer,
	                footer: footer,
	                item: function(dataItem) { return new VirtualListViewItem(listView, dataItem); },
	                height: function() { return scroller.height(); }
	            });

	            list.bind("resize", function() {
	                binder.updateScrollerSize();
	                listView.updateSize();
	            });

	            list.bind("reset", function() {
	                binder.footer.enable();
	            });

	            list.bind("endReached", function() {
	                footer.disable();
	                binder.updateScrollerSize();
	            });

	            buffer.bind("expand", function() {
	                list.lastDirection = false; // expand down
	                list.batchUpdate(scroller.scrollTop);
	            });

	            $.extend(this, {
	                buffer: buffer,
	                scroller: scroller,
	                list: list,
	                footer: footer
	            });
	        },

	        updateScrollerSize: function() {
	            this.scroller.virtualSize(0, this.list.totalHeight() + this.chromeHeight);
	        },

	        refresh: function() {
	            this.list.refresh();
	        },

	        reset: function() {
	            this.buffer.range(0);
	            this.list.refresh();
	        }
	    });

	    var ListViewItemBinder = kendo.Class.extend({
	        init: function(listView) {
	            var binder = this;
	            this.listView = listView;
	            this.options = listView.options;

	            var itemBinder = this;

	            this._refreshHandler = function(e) {
	                itemBinder.refresh(e);
	            };

	            this._progressHandler = function() {
	                listView.showLoading();
	            };

	            listView.bind("_dataSource", function(e) {
	                binder.setDataSource(e.dataSource);
	            });
	        },

	        destroy: function() {
	            this._unbindDataSource();
	        },

	        reset: function() { },

	        refresh: function(e) {
	            var action = e && e.action,
	                dataItems = e && e.items,
	                listView = this.listView,
	                dataSource = this.dataSource,
	                prependOnRefresh = this.options.appendOnRefresh,
	                view = dataSource.view(),
	                groups = dataSource.group(),
	                groupedMode = groups && groups[0],
	                item;


	            if (action === "itemchange") {
	                if(!listView._hasBindingTarget()) {
	                    item = listView.findByDataItem(dataItems)[0];
	                    if (item) {
	                        listView.setDataItem(item, dataItems[0]);
	                    }
	                }
	                return;
	            }

	            var removedItems, addedItems, addedDataItems;
	            var adding = (action === "add" && !groupedMode) || (prependOnRefresh && !listView._filter);
	            var removing = action === "remove" && !groupedMode;

	            if (adding) {
	                // no need to unbind anything
	                removedItems = [];
	            } else if (removing) {
	                // unbind the items about to be removed;
	                removedItems = listView.findByDataItem(dataItems);
	            }

	            if (listView.trigger(DATABINDING, { action: action || "rebind", items: dataItems, removedItems: removedItems, index: e && e.index })) {
	                if (this._shouldShowLoading()) {
	                    listView.hideLoading();
	                }
	                return;
	            }

	            if (action === "add" && !groupedMode) {
	                var index = view.indexOf(dataItems[0]);
	                if (index > -1) {
	                    addedItems = listView.insertAt(dataItems, index);
	                    addedDataItems = dataItems;
	                }
	            } else if (action === "remove" && !groupedMode) {
	                addedItems = [];
	                listView.remove(dataItems);
	            } else if (groupedMode) {
	                listView.replaceGrouped(view);
	            }
	            else if (prependOnRefresh && !listView._filter) {
	                addedItems = listView.prepend(view);
	                addedDataItems = view;
	            }
	            else {
	                listView.replace(view);
	            }

	            if (this._shouldShowLoading()) {
	                listView.hideLoading();
	            }

	            listView.trigger(DATABOUND, { ns: ui, addedItems: addedItems, addedDataItems: addedDataItems });
	        },

	        setDataSource: function(dataSource) {
	            if (this.dataSource) {
	                this._unbindDataSource();
	            }

	            this.dataSource = dataSource;
	            dataSource.bind(CHANGE, this._refreshHandler);

	            if (this._shouldShowLoading()) {
	                this.dataSource.bind(PROGRESS, this._progressHandler);
	            }
	        },

	        _unbindDataSource: function() {
	            this.dataSource.unbind(CHANGE, this._refreshHandler).unbind(PROGRESS, this._progressHandler);
	        },

	        _shouldShowLoading: function() {
	            var options = this.options;
	            return !options.pullToRefresh && !options.loadMore && !options.endlessScroll;
	        }
	    });

	    var ListViewFilter = kendo.Class.extend({
	        init: function(listView) {
	            var filter = this,
	                filterable = listView.options.filterable,
	                events = "change paste",
	                that = this;

	            this.listView = listView;
	            this.options = filterable;

	            listView.element.before(SEARCH_TEMPLATE({ placeholder: filterable.placeholder || "Search..." }));

	            if (filterable.autoFilter !== false) {
	                events += " keyup";
	            }

	            this.element = listView.wrapper.find(".km-search-form");

	            this.searchInput = listView.wrapper.find("input[type=search]")
	                .closest("form").on("submit" + NS, function(e) {
	                    e.preventDefault();
	                })
	                .end()
	                .on("focus" + NS, function() {
	                    filter._oldFilter = filter.searchInput.val();
	                })
	                .on(events.split(" ").join(NS + " ") + NS, proxy(this._filterChange, this));

	            this.clearButton = listView.wrapper.find(".km-filter-reset")
	                .on(CLICK, proxy(this, "_clearFilter"))
	                .hide();

	             this._dataSourceChange = $.proxy(this._refreshInput, this);
	             listView.bind("_dataSource", function(e) {
	                 e.dataSource.bind("change", that._dataSourceChange);
	             });
	        },

	        _refreshInput: function() {
	            var appliedFilters = this.listView.dataSource.filter();
	            var searchInput = this.listView._filter.searchInput;

	            if (!appliedFilters || appliedFilters.filters[0].field !== this.listView.options.filterable.field)  {
	                searchInput.val("");
	            } else {
	                searchInput.val(appliedFilters.filters[0].value);
	            }
	        },

	        _search: function(expr) {
	            this._filter = true;
	            this.clearButton[expr ? "show" : "hide"]();
	            this.listView.dataSource.filter(expr);
	        },

	        _filterChange: function(e) {
	            var filter = this;
	            if (e.type == "paste" && this.options.autoFilter !== false) {
	                setTimeout(function() {
	                    filter._applyFilter();
	                }, 1);
	            } else {
	                this._applyFilter();
	            }
	        },

	        _applyFilter: function() {
	            var options = this.options,
	                value = this.searchInput.val(),
	                expr = value.length ? {
	                    field: options.field,
	                    operator: options.operator || "startswith",
	                    ignoreCase: options.ignoreCase,
	                    value: value
	                } : null;

	            if (value === this._oldFilter) {
	                return;
	            }

	            this._oldFilter = value;
	            this._search(expr);
	        },

	        _clearFilter: function(e) {
	            this.searchInput.val("");
	            this._search(null);

	            e.preventDefault();
	        }
	    });

	    var ListView = Widget.extend({
	        init: function(element, options) {
	            var listView = this;

	            Widget.fn.init.call(this, element, options);

	            element = this.element;

	            options = this.options;

	            // support for legacy typo in configuration options: scrollTreshold -> scrollThreshold.
	            if (options.scrollTreshold) {
	                options.scrollThreshold = options.scrollTreshold;
	            }

	            element
	                .on("down", HIGHLIGHT_SELECTOR, "_highlight")
	                .on("move up cancel", HIGHLIGHT_SELECTOR, "_dim");

	            this._userEvents = new kendo.UserEvents(element, {
	                fastTap: true,
	                filter: ITEM_SELECTOR,
	                allowSelection: true,
	                tap: function(e) {
	                    listView._click(e);
	                }
	            });

	            // HACK!!! to negate the ms touch action from the user events.
	            element.css("-ms-touch-action", "auto");

	            element.wrap(WRAPPER);

	            this.wrapper = this.element.parent();

	            this._headerFixer = new HeaderFixer(this);

	            this._itemsCache = {};
	            this._templates();

	            this.virtual = options.endlessScroll || options.loadMore;

	            this._style();

	            if (this.options.$angular && (this.virtual || this.options.pullToRefresh)) {
	                setTimeout($.proxy(this, "_start"));
	            } else {
	                this._start();
	            }

	        },

	        _start: function() {
	            var options = this.options;

	            if (this.options.filterable) {
	                this._filter = new ListViewFilter(this);
	            }

	            if (this.virtual) {
	                this._itemBinder = new VirtualListViewItemBinder(this);
	            } else {
	                this._itemBinder = new ListViewItemBinder(this);
	            }

	            if (this.options.pullToRefresh) {
	                this._pullToRefreshHandler = new RefreshHandler(this);
	            }

	            this.setDataSource(options.dataSource);

	            this._enhanceItems(this.items());

	            kendo.notify(this, ui);
	        },

	        events: [
	            CLICK,
	            DATABINDING,
	            DATABOUND,
	            ITEM_CHANGE
	        ],

	        options: {
	            name: "ListView",
	            style: "",
	            type: "flat",
	            autoBind: true,
	            fixedHeaders: false,
	            template: "#:data#",
	            headerTemplate: '<span class="km-text">#:value#</span>',
	            appendOnRefresh: false,
	            loadMore: false,
	            endlessScroll: false,
	            scrollThreshold: 30,
	            pullToRefresh: false,
	            messages: {
	                loadMoreText: "Press to load more",
	                pullTemplate: "Pull to refresh",
	                releaseTemplate: "Release to refresh",
	                refreshTemplate: "Refreshing"
	            },
	            pullOffset: 140,
	            filterable: false,
	            virtualViewSize: null
	        },

	        refresh: function() {
	            this._itemBinder.refresh();
	        },

	        reset: function() {
	            this._itemBinder.reset();
	        },

	        setDataSource: function(dataSource) {
	            // the listView should have a ready datasource for MVVM to function properly. But an empty datasource should not empty the element
	            var emptyDataSource = !dataSource;
	            this.dataSource = DataSource.create(dataSource);

	            this.trigger("_dataSource", { dataSource: this.dataSource, empty: emptyDataSource });

	            if (this.options.autoBind && !emptyDataSource) {
	                this.items().remove();
	                this.dataSource.fetch();
	            }
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            kendo.destroy(this.element);
	            this._userEvents.destroy();
	            if (this._itemBinder) {
	                this._itemBinder.destroy();
	            }

	            if(this._headerFixer) {
	                this._headerFixer.destroy();
	            }

	            this.element.unwrap();
	            delete this.element;
	            delete this.wrapper;
	            delete this._userEvents;
	        },

	        items: function() {
	            if (this.options.type === "group") {
	                return this.element.find(".km-list").children();
	            } else {
	                return this.element.children().not('.km-load-more');
	            }
	        },

	        scroller: function() {
	            if (!this._scrollerInstance) {
	                this._scrollerInstance = this.element.closest(".km-scroll-wrapper").data("kendoMobileScroller");
	            }

	            return this._scrollerInstance;
	        },

	        showLoading: function() {
	            var view = this.view();
	            if (view && view.loader) {
	                view.loader.show();
	            }
	        },

	        hideLoading: function() {
	            var view = this.view();
	            if (view && view.loader) {
	                view.loader.hide();
	            }
	        },

	        insertAt: function(dataItems, index, triggerChange) {
	            var listView = this;
	            return listView._renderItems(dataItems, function(items) {
	                if (index === 0) {
	                    listView.element.prepend(items);
	                }
	                else if (index === -1) {
	                    listView.element.append(items);
	                } else {
	                    listView.items().eq(index - 1).after(items);
	                }

	                if (triggerChange) {
	                    for (var i = 0; i < items.length; i ++) {
	                        listView.trigger(ITEM_CHANGE, { item: items.eq(i), data: dataItems[i], ns: ui });
	                    }
	                }
	            });
	        },

	        append: function(dataItems, triggerChange) {
	            return this.insertAt(dataItems, -1, triggerChange);
	        },

	        prepend: function(dataItems, triggerChange) {
	            return this.insertAt(dataItems, 0, triggerChange);
	        },

	        replace: function(dataItems) {
	            this.options.type = "flat";
	            this._angularItems("cleanup");
	            kendo.destroy(this.element.children());
	            this.element.empty();
	            this._userEvents.cancel();
	            this._style();
	            return this.insertAt(dataItems, 0);
	        },

	        replaceGrouped: function(groups) {
	            this.options.type = "group";
	            this._angularItems("cleanup");
	            this.element.empty();
	            var items = $(kendo.render(this.groupTemplate, groups));

	            this._enhanceItems(items.children("ul").children("li"));
	            this.element.append(items);
	            mobile.init(items);
	            this._style();
	            this._angularItems("compile");
	        },

	        remove: function(dataItems) {
	            var items = this.findByDataItem(dataItems);
	            this.angular("cleanup", function(){
	                return { elements: items };
	            });
	            kendo.destroy(items);
	            items.remove();
	        },

	        findByDataItem: function(dataItems) {
	            var selectors = [];

	            for (var idx = 0, length = dataItems.length; idx < length; idx ++) {
	                selectors[idx] = "[data-" + kendo.ns + "uid=" + dataItems[idx].uid + "]";
	            }

	            return this.element.find(selectors.join(","));
	        },

	        // item is a DOM element, not jQuery object.
	        setDataItem: function(item, dataItem) {
	            var listView = this,
	                replaceItem = function(items) {
	                    var newItem = $(items[0]);
	                    kendo.destroy(item);
	                    listView.angular("cleanup", function(){ return { elements: [ $(item) ] }; });
	                    $(item).replaceWith(newItem);
	                    listView.trigger(ITEM_CHANGE, { item: newItem, data: dataItem, ns: ui });
	                };

	            return this._renderItems([dataItem], replaceItem)[0];
	        },

	        updateSize: function() {
	            this._size = this.getSize();
	        },

	        _renderItems: function(dataItems, callback) {
	            var items = $(kendo.render(this.template, dataItems));

	            callback(items);

	            this.angular("compile", function() {
	                return {
	                    elements: items,
	                    data: dataItems.map(function(data){
	                        return { dataItem: data };
	                    })
	                };
	            });

	            mobile.init(items);
	            this._enhanceItems(items);

	            return items;
	        },

	        _dim: function(e) {
	            this._toggle(e, false);
	        },

	        _highlight: function(e) {
	            this._toggle(e, true);
	        },

	        _toggle: function(e, highlight) {
	            if (e.which > 1) {
	                return;
	            }

	            var clicked = $(e.currentTarget),
	                item = clicked.parent(),
	                role = attrValue(clicked, "role") || "",
	                plainItem = (!role.match(buttonRegExp)),
	                prevented = e.isDefaultPrevented();

	            if (plainItem) {
	                item.toggleClass(ACTIVE_CLASS, highlight && !prevented);
	            }
	        },

	        _templates: function() {
	            var template = this.options.template,
	                headerTemplate = this.options.headerTemplate,
	                dataIDAttribute = ' data-uid="#=arguments[0].uid || ""#"',
	                templateProxy = {},
	                groupTemplateProxy = {};

	            if (typeof template === FUNCTION) {
	                templateProxy.template = template;
	                template = "#=this.template(data)#";
	            }

	            this.template = proxy(kendo.template("<li" + dataIDAttribute + ">" + template + "</li>"), templateProxy);

	            groupTemplateProxy.template = this.template;

	            if (typeof headerTemplate === FUNCTION) {
	                groupTemplateProxy._headerTemplate = headerTemplate;
	                headerTemplate = "#=this._headerTemplate(data)#";
	            }

	            groupTemplateProxy.headerTemplate = kendo.template(headerTemplate);

	            this.groupTemplate = proxy(GROUP_TEMPLATE, groupTemplateProxy);
	        },

	        _click: function(e) {
	            if (e.event.which > 1 || e.event.isDefaultPrevented()) {
	                return;
	            }

	            var dataItem,
	                item = e.target,
	                target = $(e.event.target),
	                buttonElement = target.closest(kendo.roleSelector("button", "detailbutton", "backbutton")),
	                button = kendo.widgetInstance(buttonElement, ui),
	                id = item.attr(kendo.attr("uid"));

	            if (id) {
	                dataItem = this.dataSource.getByUid(id);
	            }

	            if (this.trigger(CLICK, {target: target, item: item, dataItem: dataItem, button: button})) {
	                e.preventDefault();
	            }
	        },

	        _styleGroups: function() {
	            var rootItems = this.element.children();

	            rootItems.children("ul").addClass("km-list");

	            rootItems.each(function() {
	                var li = $(this),
	                    groupHeader = li.contents().first();

	                li.addClass("km-group-container");
	                if (!groupHeader.is("ul") && !groupHeader.is("div." + GROUP_CLASS)) {
	                    groupHeader.wrap(GROUP_WRAPPER);
	                }
	            });
	        },

	        _style: function() {
	            var options = this.options,
	                grouped = options.type === "group",
	                element = this.element,
	                inset = options.style === "inset";

	            element.addClass("km-listview")
	                .toggleClass("km-list", !grouped)
	                .toggleClass("km-virtual-list", this.virtual)
	                .toggleClass("km-listinset", !grouped && inset)
	                .toggleClass("km-listgroup", grouped && !inset)
	                .toggleClass("km-listgroupinset", grouped && inset);

	            if (!element.parents(".km-listview")[0]) {
	                element.closest(".km-content").toggleClass("km-insetcontent", inset); // iOS has white background when the list is not inset.
	            }

	            if (grouped) {
	                this._styleGroups();
	            }

	            this.trigger(STYLED);
	        },

	        _enhanceItems: function(items) {
	            items.each(function() {
	                var item = $(this),
	                    child,
	                    enhanced = false;

	                item.children().each(function() {
	                    child = $(this);
	                    if (child.is("a")) {
	                        enhanceLinkItem(child);
	                        enhanced = true;
	                    } else if (child.is("label")) {
	                        enhanceCheckBoxItem(child);
	                        enhanced = true;
	                    }
	                });

	                if (!enhanced) {
	                    enhanceItem(item);
	                }
	            });
	        }
	    });

	    ui.plugin(ListView);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "K4Qs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var abstractColumnDropPanel_1 = __webpack_require__("HDwJ");
var ValuesColumnPanel = (function (_super) {
    __extends(ValuesColumnPanel, _super);
    function ValuesColumnPanel(horizontal) {
        return _super.call(this, horizontal, true, 'values') || this;
    }
    ValuesColumnPanel.prototype.passBeansUp = function () {
        _super.prototype.setBeans.call(this, {
            gridOptionsWrapper: this.gridOptionsWrapper,
            eventService: this.eventService,
            context: this.context,
            loggerFactory: this.loggerFactory,
            dragAndDropService: this.dragAndDropService
        });
        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
        var emptyMessage = localeTextFunc('valueColumnsEmptyMessage', 'Drag here to aggregate');
        var title = localeTextFunc('values', 'Values');
        _super.prototype.init.call(this, {
            dragAndDropIcon: main_1.DragAndDropService.ICON_AGGREGATE,
            icon: main_1.Utils.createIconNoSpan('valuePanel', this.gridOptionsWrapper, null),
            emptyMessage: emptyMessage,
            title: title
        });
        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.refreshGui.bind(this));
    };
    ValuesColumnPanel.prototype.getIconName = function () {
        return this.isPotentialDndColumns() ? main_1.DragAndDropService.ICON_AGGREGATE : main_1.DragAndDropService.ICON_NOT_ALLOWED;
    };
    ValuesColumnPanel.prototype.isColumnDroppable = function (column) {
        if (this.gridOptionsWrapper.isFunctionsReadOnly()) {
            return false;
        }
        // we never allow grouping of secondary columns
        if (!column.isPrimary()) {
            return false;
        }
        var columnValue = column.isAllowValue();
        var columnNotValue = !column.isValueActive();
        return columnValue && columnNotValue;
    };
    ValuesColumnPanel.prototype.updateColumns = function (columns) {
        if (this.gridOptionsWrapper.isFunctionsPassive()) {
            var event_1 = {
                type: main_1.Events.EVENT_COLUMN_VALUE_CHANGE_REQUEST,
                columns: columns,
                api: this.gridApi,
                columnApi: this.columnApi
            };
            this.eventService.dispatchEvent(event_1);
        }
        else {
            this.columnController.setValueColumns(columns, "toolPanelUi");
        }
    };
    ValuesColumnPanel.prototype.getExistingColumns = function () {
        return this.columnController.getValueColumns();
    };
    __decorate([
        main_1.Autowired('columnController'),
        __metadata("design:type", main_1.ColumnController)
    ], ValuesColumnPanel.prototype, "columnController", void 0);
    __decorate([
        main_1.Autowired('eventService'),
        __metadata("design:type", main_1.EventService)
    ], ValuesColumnPanel.prototype, "eventService", void 0);
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], ValuesColumnPanel.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        main_1.Autowired('context'),
        __metadata("design:type", main_1.Context)
    ], ValuesColumnPanel.prototype, "context", void 0);
    __decorate([
        main_1.Autowired('loggerFactory'),
        __metadata("design:type", main_1.LoggerFactory)
    ], ValuesColumnPanel.prototype, "loggerFactory", void 0);
    __decorate([
        main_1.Autowired('dragAndDropService'),
        __metadata("design:type", main_1.DragAndDropService)
    ], ValuesColumnPanel.prototype, "dragAndDropService", void 0);
    __decorate([
        main_1.Autowired('columnApi'),
        __metadata("design:type", main_1.ColumnApi)
    ], ValuesColumnPanel.prototype, "columnApi", void 0);
    __decorate([
        main_1.Autowired('gridApi'),
        __metadata("design:type", main_1.GridApi)
    ], ValuesColumnPanel.prototype, "gridApi", void 0);
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ValuesColumnPanel.prototype, "passBeansUp", null);
    return ValuesColumnPanel;
}(abstractColumnDropPanel_1.AbstractColumnDropPanel));
exports.ValuesColumnPanel = ValuesColumnPanel;


/***/ }),

/***/ "K8Pb":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(879);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(880),
	        __webpack_require__(881),
	        __webpack_require__(882),
	        __webpack_require__(883),
	        __webpack_require__(884),
	        __webpack_require__(885)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($, undefined) {

	    var NS = ".kendoChart";
	    var kendo = window.kendo;
	    var Class = kendo.Class;
	    var outerWidth = kendo._outerWidth;
	    var outerHeight = kendo._outerHeight;
	    var dataviz = kendo.dataviz;
	    var constants = dataviz.constants;
	    var KendoChart = dataviz.Chart;
	    var SeriesBinder = dataviz.SeriesBinder;
	    var Widget = kendo.ui.Widget;
	    var DataSource = kendo.data.DataSource;
	    var deepExtend = kendo.deepExtend;
	    var defined = dataviz.defined;
	    var getField = dataviz.getField;
	    var InstanceObserver = dataviz.InstanceObserver;
	    var inArray = dataviz.inArray;
	    var services = dataviz.services;
	    var proxy = $.proxy;
	    var isArray = $.isArray;
	    var extend = $.extend;
	    var template = kendo.template;

	    var MOUSELEAVE_NS = "mouseleave" + NS;
	    var AXIS_LABEL_CLICK = constants.AXIS_LABEL_CLICK;
	    var LEGEND_ITEM_CLICK = constants.LEGEND_ITEM_CLICK;
	    var LEGEND_ITEM_HOVER = constants.LEGEND_ITEM_HOVER;
	    var LEGEND_ITEM_LEAVE = constants.LEGEND_ITEM_LEAVE;
	    var SERIES_CLICK = constants.SERIES_CLICK;
	    var SERIES_HOVER = constants.SERIES_HOVER;
	    var SERIES_OVER = constants.SERIES_OVER;
	    var SERIES_LEAVE = constants.SERIES_LEAVE;
	    var PANE_RENDER = constants.PANE_RENDER;
	    var PLOT_AREA_CLICK = constants.PLOT_AREA_CLICK;
	    var PLOT_AREA_HOVER = constants.PLOT_AREA_HOVER;
	    var PLOT_AREA_LEAVE = constants.PLOT_AREA_LEAVE;
	    var DRAG = constants.DRAG;
	    var DRAG_END = constants.DRAG_END;
	    var DRAG_START = constants.DRAG_START;
	    var ZOOM_START = constants.ZOOM_START;
	    var ZOOM = constants.ZOOM;
	    var ZOOM_END = constants.ZOOM_END;
	    var SELECT_START = constants.SELECT_START;
	    var SELECT = constants.SELECT;
	    var SELECT_END = constants.SELECT_END;
	    var RENDER = constants.RENDER;
	    var NOTE_CLICK = constants.NOTE_CLICK;
	    var NOTE_HOVER = constants.NOTE_HOVER;
	    var NOTE_LEAVE = constants.NOTE_LEAVE;
	    var DOCUMENT_ELEMENT = $(document.documentElement);

	    var CHANGE = "change";
	    var DATABOUND = "dataBound";
	    var LEAVE = "leave";
	    var MOUSEDOWN = "down";

	    var VALUE = constants.VALUE;
	    var PIE = constants.PIE;
	    var DONUT = constants.DONUT;
	    var FUNNEL = constants.FUNNEL;

	    var Observable = kendo.Observable;
	    var TOOLTIP_ANIMATION_DURATION = 150;
	    var TOOLTIP_SHOW_DELAY = 100;
	    var TOOLTIP_INVERSE = "k-chart-tooltip-inverse";
	    var SHARED_TOOLTIP_CLASS = "k-chart-shared-tooltip";
	    var RTL = "rtl";

	    services.DomEventsBuilder.register({
	        create: function(element, events) {
	             return new kendo.UserEvents(element, deepExtend({
	                 global: true,
	                 multiTouch: true,
	                 fastTap: true
	             }, events));
	        }
	    });

	    var ChartInstanceObserver = InstanceObserver.extend({
	        handlerMap: {
	            showTooltip: '_showTooltip',
	            hideTooltip: '_hideTooltip',
	            legendItemClick: '_onLegendItemClick',
	            render: '_onRender',
	            init: '_onInit'
	        }
	    });

	    var Chart = Widget.extend({
	        init: function(element, userOptions) {
	            var dataSource;

	            kendo.destroy(element);

	            Widget.fn.init.call(this, element);

	            if (userOptions) {
	                dataSource = userOptions.dataSource;
	                delete userOptions.dataSource;
	            }

	            this.options =  deepExtend({}, this.options, userOptions);

	            this.wrapper = this.element;
	            this._attachEvents();

	            if (userOptions) {
	                userOptions.dataSource = dataSource;
	            }

	            this._seriesVisibility = new SeriesVisibilityState();

	            this.bind(this.events, this.options);
	            this._initDataSource(userOptions);

	            kendo.notify(this, dataviz.ui);
	        },

	        events:[
	            DATABOUND,
	            SERIES_CLICK,
	            SERIES_HOVER,
	            SERIES_OVER,
	            SERIES_LEAVE,
	            AXIS_LABEL_CLICK,
	            LEGEND_ITEM_CLICK,
	            LEGEND_ITEM_HOVER,
	            LEGEND_ITEM_LEAVE,
	            PANE_RENDER,
	            PLOT_AREA_CLICK,
	            PLOT_AREA_HOVER,
	            PLOT_AREA_LEAVE,
	            DRAG_START,
	            DRAG,
	            DRAG_END,
	            ZOOM_START,
	            ZOOM,
	            ZOOM_END,
	            SELECT_START,
	            SELECT,
	            SELECT_END,
	            NOTE_CLICK,
	            NOTE_HOVER,
	            NOTE_LEAVE,
	            RENDER
	        ],

	        options: {
	            name: "Chart",
	            renderAs: "",
	            theme: "default",
	            axisDefaults: {},
	            chartArea: {},
	            legend: {},
	            categoryAxis: {},
	            autoBind: true,
	            seriesDefaults: {},
	            series: [],
	            seriesColors: null,
	            tooltip: {},
	            transitions: true,
	            valueAxis: {},
	            plotArea: {},
	            title: {},
	            xAxis: {},
	            yAxis: {},
	            panes: [{}],
	            pannable: false,
	            zoomable: false
	        },

	        items: function() {
	            return $();
	        },

	        refresh: function() {
	            var chart = this;
	            var instance = chart._instance;
	            instance.applyDefaults(chart.options);
	            instance.applySeriesColors();

	            chart._bindSeries();
	            chart._bindCategories();

	            chart.trigger(DATABOUND);
	            chart._redraw();
	        },

	        getSize: function() {
	            return kendo.dimensions(this.element);
	        },

	        redraw: function(paneName) {
	            this._size = null;
	            this._instance.redraw(paneName);
	        },

	        setOptions: function(options) {
	            var chart = this,
	                dataSource = options.dataSource;

	            delete options.dataSource;

	            Widget.fn._setEvents.call(chart, options);

	            this._instance.applyOptions(options, this._getThemeOptions(options));
	            this.options = this._instance.options;
	            this._tooltip.setOptions(this.options.tooltip);
	            this._seriesVisibility.setOptions(this.options);
	            this._sourceSeries = null;

	            if (dataSource) {
	                chart.setDataSource(dataSource);
	            }

	            if (chart._hasDataSource) {
	                chart._onDataChanged();
	            } else {
	                chart._bindCategories();
	                chart.redraw();
	            }

	            chart._instance.updateMouseMoveHandler();

	        },

	        setDataSource: function(dataSource) {
	            var chart = this;

	            chart.dataSource.unbind(CHANGE, chart._dataChangeHandler);
	            chart.dataSource = dataSource = DataSource.create(dataSource);
	            chart._hasDataSource = true;
	            chart._hasData = false;

	            dataSource.bind(CHANGE, chart._dataChangeHandler);

	            if (chart.options.autoBind) {
	                dataSource.fetch();
	            }
	        },

	        destroy: function() {
	            var chart = this,
	                dataSource = chart.dataSource;

	            chart.element.off(NS);

	            if (dataSource) {
	                dataSource.unbind(CHANGE, chart._dataChangeHandler);
	            }

	            if (chart._instance) {
	                chart._instance.destroy();
	                delete this._instance;
	            }

	            if (this._tooltip) {
	                this._tooltip.destroy();
	                delete this._tooltip;
	            }

	            this._destroyCrosshairTooltips();

	            Widget.fn.destroy.call(chart);
	        },

	        findPaneByName: function(name) {
	            var panes = this._plotArea.panes;

	            for (var idx = 0; idx < panes.length; idx++) {
	                if (panes[idx].options.name === name) {
	                    return new ChartPane(this, panes[idx]);
	                }
	            }
	        },

	        findPaneByIndex: function(idx) {
	            var panes = this._plotArea.panes;
	            if (panes[idx]) {
	                return new ChartPane(this, panes[idx]);
	            }
	        },

	        findSeries: function(callback) {
	            var plotArea = this._plotArea;
	            var series = plotArea.srcSeries || plotArea.series;
	            for (var idx = 0; idx < series.length; idx++) {
	                if (callback(series[idx])) {
	                    return new ChartSeries(this, series[idx]);
	                }
	            }
	        },

	        findSeriesByName: function(name) {
	            return this._createSeries({ name: name });
	        },

	        findSeriesByIndex: function(index) {
	            return this._createSeries({ index: index });
	        },

	        exportVisual: function(options) {
	            var instance = this._instance;
	            if (!instance) {
	                return;
	            }

	            var visual;

	            //TO DO: support for setting any options. already available in kendo-charts
	            if (options && (options.width || options.height)) {
	                var chartArea = instance.options.chartArea;
	                var originalChartArea = instance._originalOptions.chartArea;

	                deepExtend(chartArea, options);

	                var model = instance._getModel();

	                chartArea.width = originalChartArea.width;
	                chartArea.height = originalChartArea.height;

	                model.renderVisual();

	                triggerPaneRender(model._plotArea.panes);

	                visual = model.visual;
	            } else {
	                visual = instance.exportVisual();
	            }

	            return visual;
	        },

	        _createSeries: function(options) {
	            var seriesOptions = this._seriesOptions(options);
	            if (seriesOptions) {
	                return new ChartSeries(this, seriesOptions);
	            }
	        },

	        _seriesOptions: function(options) {
	            var plotArea = this._plotArea;
	            var series = plotArea.srcSeries || plotArea.series;
	            var seriesOptions;

	            if (defined(options.index)) {
	                seriesOptions = series[options.index];
	            } else if (defined(options.name)) {
	                for (var idx = 0; idx < series.length; idx++) {
	                    if (series[idx].name === options.name) {
	                        seriesOptions = series[idx];
	                        break;
	                    }
	                }
	            }

	            return seriesOptions;
	        },

	        _attachEvents: function() {
	             this.element.on(MOUSELEAVE_NS, proxy(this._mouseleave, this));
	        },

	        _mouseleave: function(e) {
	            var instance = this._instance;
	            var tooltip = this._tooltip;
	            var target = e.relatedTarget;

	            if (!(target && $(target).closest(tooltip.element).length) && instance && !instance.handlingTap) {
	                instance.hideElements({
	                    keepTooltipOpen: !tooltip.options.autoHide
	                });
	            }
	        },

	        _getThemeOptions: function(userOptions) {
	            var themeName = (userOptions || {}).theme;

	            if (themeName && dataviz.SASS_THEMES.indexOf(themeName.toLowerCase()) !== -1) {
	                return dataviz.autoTheme().chart;
	            }

	            if (defined(themeName)) {
	                var themes = dataviz.ui.themes || {};
	                var theme = themes[themeName] || themes[themeName.toLowerCase()] || {};
	                return theme.chart || {};
	            }
	        },

	        _initChart: function() {
	            this._createChart(this.options, this._getThemeOptions(this.options));
	            this.options = this._instance.options;
	            this._seriesVisibility.setOptions(this.options);
	        },

	        _createChart: function(options, themeOptions) {
	            this._instance = new KendoChart(this.element[0], options, themeOptions, {
	                observer: new ChartInstanceObserver(this),
	                sender: this,
	                rtl: this._isRtl()
	            });
	        },

	        _onInit: function(e) {
	            this._instance = e.sender;
	        },

	        _initDataSource: function(userOptions) {
	            var chart = this,
	                dataSource = (userOptions || {}).dataSource;

	            chart._dataChangeHandler = proxy(chart._onDataChanged, chart);

	            chart.dataSource = DataSource
	                .create(dataSource)
	                .bind("change", chart._dataChangeHandler);

	            chart._bindCategories();

	            if (dataSource) {
	                chart._hasDataSource = true;
	            }

	            this._initChart();
	            this._initTooltip();

	            if (dataSource) {
	                if (chart.options.autoBind) {
	                    chart.dataSource.fetch();
	                }
	            }
	        },

	        _destroyCrosshairTooltips: function() {
	            var tooltips = this._crosshairTooltips;
	            if (tooltips) {
	                for (var key in tooltips) {
	                    tooltips[key].destroy();
	                }
	            }
	            this._crosshairTooltips = {};
	        },

	        _getCrosshairTooltip: function(name, index) {
	            var tooltips = this._crosshairTooltips = this._crosshairTooltips || {};
	            var key = name + index;
	            var tooltip = tooltips[key];
	            if (!tooltip) {
	                tooltip = tooltips[key] = new CrosshairTooltip(this.element);
	            }
	            return tooltip;
	        },

	        _showTooltip: function(e) {
	            if (e.crosshair) {
	                var tooltip = this._getCrosshairTooltip(e.axisName, e.axisIndex);
	                tooltip.show(e);
	            } else if (this._tooltip) {
	                this._tooltip.show(e);
	            }
	        },

	        _hideTooltip: function(e) {
	            if (e.crosshair) {
	                 var tooltip = this._getCrosshairTooltip(e.axisName, e.axisIndex);
	                 tooltip.hide();
	            } else if (this._tooltip) {
	                this._tooltip.hide(e);
	            }
	        },

	        _onRender: function(e) {
	            this._destroyCrosshairTooltips();
	            this._copyMembers(e.sender);
	            if (!this._hasDataSource || this._hasData || !this.options.autoBind) {
	                this.trigger(RENDER);
	            }
	        },

	        _copyMembers: function(instance) {
	            this.options = instance.options;
	            this._originalOptions = instance._originalOptions;
	            this.surface = instance.surface;
	            this._plotArea = instance._plotArea;
	            this._model = instance._model;
	            this._highlight = instance._highlight;
	            this._selections = instance._selections;
	            this._pannable = instance._pannable;
	            this._zoomSelection = instance._zoomSelection;
	            this._mousewheelZoom = instance._mousewheelZoom;
	        },

	        requiresHandlers: function(names) {
	           var events = this._events;
	           for (var idx = 0; idx < names.length; idx++) {
	               if (defined(events[names[idx]])) {
	                   return true;
	               }
	           }
	        },

	        _initTooltip: function() {
	            this._tooltip = this._createTooltip();

	            this._tooltip.bind(LEAVE, proxy(this._tooltipleave, this));
	        },

	        _onLegendItemClick: function(e) {
	            if (!this.trigger(LEGEND_ITEM_CLICK, e)) {
	                this._legendItemClick(e.seriesIndex, e.pointIndex);
	            }
	        },

	        _legendItemClick: function(seriesIndex, pointIndex) {
	            var chart = this._instance,
	                plotArea = chart._plotArea,
	                currentSeries = (plotArea.srcSeries || plotArea.series)[seriesIndex];

	            if ($.inArray(currentSeries.type, [PIE, DONUT, FUNNEL]) >= 0) {
	                var point = currentSeries.data[pointIndex];
	                if (point && defined(point.visible)) {
	                    point.visible = !point.visible;
	                } else {
	                    var pointVisibility = currentSeries.pointVisibility = currentSeries.pointVisibility || {};
	                    var visible = pointVisibility[pointIndex];
	                    pointVisibility[pointIndex] = defined(visible) ? !visible : false;
	                }
	            } else {
	                currentSeries.visible = !currentSeries.visible;
	                this._seriesVisibility.save(currentSeries);
	            }

	            chart._noTransitionsRedraw();
	        },

	        _createTooltip: function() {
	            return new Tooltip(this.element, extend({}, this.options.tooltip, {
	                rtl: this._isRtl()
	            }));
	        },

	        _tooltipleave: function() {
	            if (this._instance) {
	                this._instance.hideElements();
	            }
	        },

	        _bindData: function(e) {
	            var chart = this,
	                options = chart.options,
	                series = chart._sourceSeries || options.series,
	                seriesIx,
	                seriesLength = series.length,
	                data = chart.dataSource.view(),
	                grouped = (chart.dataSource.group() || []).length > 0,
	                processedSeries = [],
	                seriesVisibility = this._seriesVisibility,
	                currentSeries,
	                groupedSeries;

	            seriesVisibility.read();

	            for (seriesIx = 0; seriesIx < seriesLength; seriesIx++) {
	                currentSeries = series[seriesIx];

	                if (chart._isBindable(currentSeries) && grouped) {
	                    groupedSeries = groupSeries(currentSeries, data);
	                    processedSeries = processedSeries.concat(groupedSeries);

	                    seriesVisibility.applyByGroup(groupedSeries, e);
	                } else {
	                    currentSeries = extend({}, currentSeries);
	                    processedSeries.push(currentSeries);

	                    seriesVisibility.applyByIndex(currentSeries, e);
	                }
	            }

	            chart._sourceSeries = series;
	            options.series = processedSeries;
	            this._instance.applySeriesColors();

	            chart._bindSeries();
	            chart._bindCategories();

	            this._hasData = true;
	        },

	        _onDataChanged: function(e) {
	            this._bindData(e);

	            this.trigger(DATABOUND);
	            if (this._instance && this._instance.fontLoaded) {
	                this._redraw();
	            }
	        },

	        _bindSeries: function() {
	            var chart = this,
	                data = chart.dataSource.view(),
	                series = chart.options.series,
	                seriesIx,
	                seriesLength = series.length,
	                currentSeries,
	                groupIx,
	                seriesData;

	            for (seriesIx = 0; seriesIx < seriesLength; seriesIx++) {
	                currentSeries = series[seriesIx];

	                if (chart._isBindable(currentSeries)) {
	                    groupIx = currentSeries._groupIx;
	                    seriesData = defined(groupIx) ? (data[groupIx] || {}).items : data;

	                    if (currentSeries.autoBind !== false) {
	                        currentSeries.data = seriesData;
	                    }
	                }
	            }
	        },

	        _bindCategories: function() {
	            var chart = this,
	                data = chart.dataSource.view() || [],
	                grouped = (chart.dataSource.group() || []).length > 0,
	                categoriesData = data,
	                options = chart.options,
	                definitions = [].concat(options.categoryAxis),
	                axisIx,
	                axis;

	            if (grouped) {
	                if (data.length) {
	                    categoriesData = data[0].items;
	                }
	            }

	            for (axisIx = 0; axisIx < definitions.length; axisIx++) {
	                axis = definitions[axisIx];
	                if (axis.autoBind !== false) {
	                    chart._bindCategoryAxis(axis, categoriesData, axisIx);
	                }
	            }
	        },

	        _bindCategoryAxis: function(axis, data, axisIx) {
	            var count = (data || []).length,
	                categoryIx,
	                category,
	                row;

	            if (axis.field) {
	                axis.categories = [];
	                for (categoryIx = 0; categoryIx < count; categoryIx++) {
	                    row = data[categoryIx];

	                    category = getField(axis.field, row);
	                    if (categoryIx === 0) {
	                        axis.categories = [category];
	                        axis.dataItems = [row];
	                    } else {
	                        axis.categories.push(category);
	                        axis.dataItems.push(row);
	                    }
	                }
	            } else if (this._instance) {
	                this._instance.bindCategoryAxisFromSeries(axis, axisIx);
	            }
	        },

	        _isBindable: function(series) {
	            var valueFields = SeriesBinder.current.valueFields(series),
	                result = true,
	                field, i;

	            for (i = 0; i < valueFields.length; i++) {
	                field = valueFields[i];
	                if (field === VALUE) {
	                    field = "field";
	                } else {
	                    field = field + "Field";
	                }

	                if (!defined(series[field])) {
	                    result = false;
	                    break;
	                }
	            }

	            return result;
	        },

	        _isRtl: function() {
	            return kendo.support.isRtl(this.element) && this.element.css("direction") === RTL;
	        }
	    });

	    var proxyMembers = ["getAxis", "findAxisByName", "plotArea", "toggleHighlight", "showTooltip",
	        "hideTooltip", "_resize", "_redraw", "_noTransitionsRedraw", "_legendItemHover", "_eventCoordinates"];

	    function createProxyMember(name) {
	        Chart.fn[name] = function() {
	            var instance = this._instance;
	            if (instance) {
	                return instance[name].apply(instance, arguments);
	            }
	        };
	    }

	    for (var idx = 0; idx < proxyMembers.length; idx++) {
	        createProxyMember(proxyMembers[idx]);
	    }

	    function groupSeries(series, data) {
	        var result = [],
	            nameTemplate,
	            legacyTemplate = series.groupNameTemplate,
	            groupIx,
	            dataLength = data.length,
	            seriesClone;

	        if (dataLength === 0) {
	            seriesClone = deepExtend({}, series);
	            seriesClone.visibleInLegend = false;
	            return [seriesClone];
	        }

	        if (defined(legacyTemplate)) {
	            kendo.logToConsole(
	                "'groupNameTemplate' is obsolete and will be removed in future versions. " +
	                "Specify the group name template as 'series.name'"
	            );

	            if (legacyTemplate) {
	                nameTemplate = template(legacyTemplate);
	            }
	        } else {
	            nameTemplate = template(series.name || "");
	            if (nameTemplate._slotCount === 0) {
	                nameTemplate = template(defined(series.name) ?
	                    "#= group.value #: #= series.name #" :
	                    "#= group.value #"
	                );
	            }
	        }

	        for (groupIx = 0; groupIx < dataLength; groupIx++) {
	            seriesClone = deepExtend({}, series);

	            if (!kendo.isFunction(seriesClone.color)) {
	                seriesClone.color = undefined;
	            }

	            seriesClone._groupIx = groupIx;
	            seriesClone._groupValue = data[groupIx].value;
	            result.push(seriesClone);

	            if (nameTemplate) {
	                seriesClone.name = nameTemplate({
	                    series: seriesClone, group: data[groupIx]
	                });
	            }
	        }

	        return result;
	    }

	    dataviz.ExportMixin.extend(Chart.fn);

	    if (kendo.PDFMixin) {
	        kendo.PDFMixin.extend(Chart.fn);
	    }

	    dataviz.ui.plugin(Chart);

	    var SeriesVisibilityState = Class.extend({
	        init: function() {
	            this.groups = {};
	            this.index = {};
	            this.options = {};
	        },

	        applyByGroup: function(series, e) {
	            if ((e && e.action) || this.options.persistSeriesVisibility) {
	                for (var idx = 0; idx < series.length; idx++) {
	                    if (this.groups[series[idx]._groupValue] === false) {
	                        series[idx].visible = false;
	                    }
	                }
	            } else {
	                this.groups = {};
	            }
	        },

	        applyByIndex: function(series, e) {
	            if ((e && e.action) || this.options.persistSeriesVisibility) {
	                if (this.index[series.index] === false) {
	                    series.visible = false;
	                }
	            } else {
	                this.index = {};
	            }
	        },

	        save: function(series) {
	            if (!series) {
	                return;
	            }

	            if (this.options.persistSeriesVisibility) {
	                this.options.series[series.index].visible = series.visible;
	            } else {
	                this.saveState(series);
	            }
	        },

	        setOptions: function(options) {
	            this.options = options;
	            this.groups = {};
	            this.index = {};
	        },

	        read: function() {
	            var options = this.options;
	            if (options.persistSeriesVisibility) {
	                var series = options.series;
	                for (var idx = 0; idx < series.length; idx++) {
	                    this.saveState(series[idx]);
	                }
	            }
	        },

	        saveState: function(series) {
	            if (defined(series._groupValue)) {
	                this.groups[series._groupValue] = series.visible;
	            } else {
	                this.index[series.index] = series.visible;
	            }
	        }
	    });

	    var geom = kendo.geometry;

	    function normalizeStyle(style) {
	        for (var field in style) {
	            if (style[field] === undefined) {
	                style[field] = '';
	            }
	        }

	        return style;
	    }

	    var Tooltip = Observable.extend({
	        init: function(chartElement, options) {
	            var tooltip = this;

	            Observable.fn.init.call(tooltip);

	            this.setOptions(options);

	            tooltip.chartElement = chartElement;

	            tooltip.template = Tooltip.template;
	            if (!tooltip.template) {
	                tooltip.template = Tooltip.template = kendo.template(
	                    "<div class='k-tooltip #if (!d.autoHide) {# k-tooltip-closable#}# k-chart-tooltip#= d.rtl ? \" k-rtl\" : \"\"#' " +
	                    "style='display:none; position: absolute; font: #= d.font #;" +
	                    "#if (d.border) {# border: #= d.border.width #px solid; #}#" +
	                    "opacity: #= d.opacity #; filter: alpha(opacity=#= d.opacity * 100 #);'>" +
	                    '<div class="k-tooltip-content"></div>' +
	                    '#if (!d.autoHide) {# <div class="k-tooltip-button"><a href="\\#" class="k-icon k-i-close" title="Close"></a></div> #}#' +
	                    "</div>", { useWithBlock: false, paramName: "d"});
	            }

	            tooltip.element = $(tooltip.template(tooltip.options));

	            tooltip.move = proxy(tooltip.move, tooltip);
	            tooltip._mouseleave = proxy(tooltip._mouseleave, tooltip);

	            var mobileScrollerSelector = kendo.format("[{0}='content'],[{0}='scroller']", kendo.attr("role"));
	            tooltip._mobileScroller = chartElement.closest(mobileScrollerSelector).data("kendoMobileScroller");
	            tooltip.downEvent = kendo.applyEventMap(MOUSEDOWN, kendo.guid());
	            tooltip._closeTooltipHandler = proxy(tooltip._closeTooltip, tooltip);            
	        },

	        destroy: function() {
	            var tooltip = this;

	            this._clearShowTimeout();
	            DOCUMENT_ELEMENT.off(tooltip.downEvent, tooltip._closeTooltipHandler);
	            if (this.element) {
	                this.element.off(MOUSELEAVE_NS).remove();
	                this.element = null;
	            }
	        },

	        setOptions: function(options) {
	            this.options = deepExtend({}, this.options, options);
	        },

	        options: {
	            opacity: 1,
	            animation: {
	                duration: TOOLTIP_ANIMATION_DURATION
	            },
	            sharedTemplate:
	                "<table>" +
	                "<th colspan='#= colspan #'>#= categoryText #</th>" +
	                "# for(var i = 0; i < points.length; i++) { #" +
	                "# var point = points[i]; #" +
	                "<tr>" +
	                    "# if(colorMarker) { # " +
	                        "<td><span class='k-chart-shared-tooltip-marker' style='background-color:#:point.series.color#'></span></td>" +
	                    "# } #" +
	                    "# if(nameColumn) { # " +
	                        "<td> #if (point.series.name) {# #: point.series.name #: #} else {# &nbsp; #}#</td>" +
	                    "# } #" +
	                    "<td>#= content(point) #</td>" +
	                "</tr>" +
	                "# } #" +
	                "</table>",
	            categoryFormat: "{0:d}",
	            autoHide: true
	        },

	        move: function() {
	            var tooltip = this,
	                options = tooltip.options,
	                element = tooltip.element,
	                offset;

	            if (!tooltip.anchor || !tooltip.element) {
	                return;
	            }

	            offset = tooltip._offset();
	            if (!tooltip.visible) {
	                element.css({ top: offset.top, left: offset.left });
	            }

	            tooltip.visible = true;
	            tooltip._ensureElement(document.body);
	            element
	                .stop(true, true)
	                .show()
	                .animate({
	                    left: offset.left,
	                    top: offset.top
	                }, options.animation.duration);
	        },

	        _clearShowTimeout: function() {
	            if (this.showTimeout) {
	                clearTimeout(this.showTimeout);
	                this.showTimeout = null;
	            }
	        },

	        getAnchor: function(size) {
	            var anchor = this.anchor;
	            var point = anchor.point;
	            var align = anchor.align;
	            var x = point.left;
	            var y = point.top;
	            if (align.horizontal === "center") {
	                x -= size.width / 2;
	            } else if (align.horizontal === "right") {
	                x -= size.width;
	            }

	            if (align.vertical === "center") {
	                y -= size.height / 2;
	            } else if (align.vertical === "bottom") {
	                y -= size.height;
	            }

	            return {
	                x: x,
	                y: y
	            };
	        },

	        _offset: function() {
	            var tooltip = this,
	                size = tooltip._measure(),
	                anchor = tooltip.getAnchor(size),
	                top = anchor.y,
	                left = anchor.x,
	                zoomLevel = kendo.support.zoomLevel(),
	                viewport = $(window),
	                scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0,
	                scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || 0,
	                movable = (this._mobileScroller || {}).movable;

	            if (!movable || movable.scale === 1) {
	                top += tooltip._fit(top - scrollTop, size.height, outerHeight(viewport) / zoomLevel);
	                left += tooltip._fit(left - scrollLeft, size.width, outerWidth(viewport) / zoomLevel);
	            } else {
	                var transform = geom.transform().scale(movable.scale, movable.scale, [movable.x, movable.y]);
	                var point = new geom.Point(left, top).transform(transform);
	                left = point.x;
	                top = point.y;
	            }

	            return {
	                top: top,
	                left: left
	            };
	        },

	        show: function(e) {
	            var tooltip  = this;

	            this.anchor = e.anchor;
	            this.element.css(normalizeStyle(e.style));
	            this.element.toggleClass(TOOLTIP_INVERSE, !!e.className);
	            this.element.toggleClass(SHARED_TOOLTIP_CLASS, !!e.shared);

	            var content = e.shared ? this._sharedContent(e) : this._pointContent(e.point);
	            this.element.find('.k-tooltip-content').html(content);

	            if (!tooltip.options.autoHide) {
	                tooltip.element.off("click" + NS).on("click" + NS, ".k-tooltip-button", tooltip._closeTooltipHandler);
	                DOCUMENT_ELEMENT.off(tooltip.downEvent, tooltip._closeTooltipHandler)
	                    .on(tooltip.downEvent, tooltip._closeTooltipHandler);
	            }

	            this._clearShowTimeout();
	            this.showTimeout = setTimeout(this.move, TOOLTIP_SHOW_DELAY);
	        },

	        hide: function() {
	            var tooltip = this;

	            clearTimeout(tooltip.showTimeout);
	            tooltip._hideElement();

	            if (tooltip.visible) {
	                tooltip.point = null;
	                tooltip.visible = false;
	                tooltip.index = null;
	                DOCUMENT_ELEMENT.off(tooltip.downEvent, tooltip._closeTooltipHandler);
	            }
	        },

	        _closeTooltip: function (e) {
	            var target = $(e.target);

	            if (!target.is(".k-chart-tooltip, .k-tooltip-content")) {
	                e.preventDefault();
	                this.chartElement.data("kendoChart")._instance.hideElements();
	                this.hide();
	            }
	        },

	        _sharedContent: function(e) {
	            var points = e.points;
	            var nameColumn = dataviz.grep(points, function(point) {
	                return defined(point.series.name);
	            }).length;

	            var colorMarker = e.series.length > 1;
	            var colspan = 1;
	            if (nameColumn) {
	                colspan++;
	            }
	            if (colorMarker) {
	                colspan++;
	            }

	            var template = kendo.template(this.options.sharedTemplate);
	            var content = template({
	                points: points,
	                category: e.category,
	                categoryText: e.categoryText,
	                content: this._pointContent,
	                colorMarker: colorMarker,
	                nameColumn: nameColumn,
	                colspan: colspan
	            });

	            return content;
	        },

	        _measure: function() {
	            this._ensureElement();

	            var size = {
	                width: outerWidth(this.element),
	                height: outerHeight(this.element)
	            };

	            return size;
	        },

	        _ensureElement: function() {
	            if (this.element) {
	                this.element
	                    .appendTo(document.body)
	                    .on(MOUSELEAVE_NS, this._mouseleave);
	            }
	        },

	        _mouseleave: function(e) {
	            var target = e.relatedTarget;
	            var chart = this.chartElement[0];
	            if (target && target !== chart && !$.contains(chart, target)) {
	                this.trigger(LEAVE);
	            }
	        },

	        _hideElement: function() {
	            var tooltip = this;
	            var element = this.element;
	            if (element) {
	                element.fadeOut({
	                    always: function(){
	                        if (!tooltip.visible) {
	                            element.off(MOUSELEAVE_NS).remove();
	                        }
	                    }
	                });
	            }
	        },

	        _pointContent: function(point) {
	            var tooltip = this,
	                options = deepExtend({}, tooltip.options, point.options.tooltip),
	                content, tooltipTemplate;

	            if (defined(point.value)) {
	                content = point.value.toString();
	            }

	            if (options.template) {
	                tooltipTemplate = template(options.template);
	                content = tooltipTemplate({
	                    value: point.value,
	                    category: point.category,
	                    series: point.series,
	                    dataItem: point.dataItem,
	                    percentage: point.percentage,
	                    runningTotal: point.runningTotal,
	                    total: point.total,
	                    low: point.low,
	                    high: point.high,
	                    xLow: point.xLow,
	                    xHigh: point.xHigh,
	                    yLow: point.yLow,
	                    yHigh: point.yHigh
	                });
	            } else if (options.format) {
	                content = point.formatValue(options.format);
	            }

	            return content;
	        },

	        _fit: function(offset, size, viewPortSize) {
	            var output = 0;

	            if (offset + size > viewPortSize) {
	                output = viewPortSize - (offset + size);
	            }

	            if (offset < 0) {
	                output = -offset;
	            }

	            return output;
	        }
	    });

	    var CrosshairTooltip = Tooltip.extend({
	        init: function(chartElement, options) {
	            Tooltip.fn.init.call(this, chartElement, options);
	            this.element.addClass("k-chart-crosshair-tooltip");
	        },

	        show: function(e) {
	            var element = this.element;

	            if (element) {
	                this.anchor = e.anchor;
	                this.element.css(e.style);
	                this.element.html(this.content(e));

	                this.move();
	            }
	        },

	        move: function() {
	            var tooltip = this,
	                element = tooltip.element,
	                offset = tooltip._offset();

	            tooltip._ensureElement();
	            element.css({ top: offset.top, left: offset.left }).show();
	        },

	        content: function(e) {
	            var content = e.value,
	                options = e.crosshair.options.tooltip;

	            if (options.template) {
	                content = template(options.template)({
	                    value: content
	                });
	            }

	            return content;
	        },

	        hide: function() {
	            this.element.hide();
	        }
	    });

	    var ChartPane = Class.extend({
	        init: function(chart, pane) {
	            this._chart = chart;
	            this._pane = pane;
	            this.visual = pane.visual;
	            this.chartsVisual = pane.chartContainer.visual;
	            this.name = pane.options.name;
	        },

	        series: function() {
	            var chart = this._chart;
	            var seriesByPane = chart._plotArea.groupSeriesByPane();
	            var series = seriesByPane[this.name || "default"];

	            var result = [];
	            if (series) {
	                for (var idx = 0; idx < series.length; idx++) {
	                    result.push(new ChartSeries(chart, series[idx]));
	                }
	            }

	            return result;
	        }
	    });

	    var ChartSeries = Class.extend({
	        init: function(chart, options) {
	            this._chart = chart;
	            this._options = options;
	        },

	        points: function(filter) {
	            var points = this._points;
	            if (!points) {
	                var series = this._seriesOptions();
	                var plotArea = this._chart._plotArea;
	                this._points = points = plotArea.pointsBySeriesIndex(series.index);
	            }
	            if (kendo.isFunction(filter)) {
	                points = this._filterPoints(points, filter);
	            }


	            return points;
	        },

	        data: function(data) {
	            var series = this._seriesOptions();
	            if (data) {
	                var chart = this._chart;
	                var plotArea = chart._plotArea;

	                series.data = data;

	                if (series.categoryField) {
	                    var axis = plotArea.seriesCategoryAxis(series);
	                    var options = [].concat(chart.options.categoryAxis);

	                    chart._instance.bindCategoryAxisFromSeries(options[axis.axisIndex], axis.axisIndex);
	                }

	                chart._noTransitionsRedraw();
	                this._clearFields();
	            }

	            return series.data;
	        },

	        findPoint: function(filter) {
	            var points = this.points();
	            for (var idx = 0; idx < points.length; idx++) {
	                if (filter(points[idx])) {
	                    return points[idx];
	                }
	            }
	        },

	        toggleHighlight: function(show, elements) {
	            if (!elements) {
	                elements = this.points();
	            } else if (kendo.isFunction(elements)) {
	                elements = this.points(elements);
	            } else {
	                elements = isArray(elements) ? elements : [elements];
	            }

	            this._chart._instance.togglePointsHighlight(show, elements);
	        },

	        toggleVisibility: function(visible, filter) {
	            var chart = this._chart;
	            var seriesOptions = this._seriesOptions();
	            var hasFilter = kendo.isFunction(filter);
	            if (!hasFilter) {
	                seriesOptions.visible = visible;
	                chart._seriesVisibility.save(seriesOptions);
	            } else {
	                if (inArray(seriesOptions.type, [PIE, DONUT, FUNNEL])) {
	                    var data = this._filterData(filter);
	                    for (var idx = 0; idx < data.length; idx++) {
	                        data[idx].visible = visible;
	                    }
	                } else {
	                    seriesOptions.visible = function(data) {
	                        return filter(data.dataItem) ? visible : true;
	                    };
	                }
	            }

	            chart._noTransitionsRedraw();

	            this._clearFields();
	        },

	        _filterData: function(filter) {
	            var data = this._seriesOptions().data;
	            var length = data.length;
	            var result = [];

	            for (var idx = 0; idx < length; idx++) {
	                if (filter(data[idx])) {
	                    result.push(data[idx]);
	                }
	            }
	            return result;
	        },

	        _filterPoints: function(points, filter) {
	            var result = [];
	            var length = points.length;
	            for (var idx = 0; idx < length; idx++) {
	                if (filter(points[idx])) {
	                    result.push(points[idx]);
	                }
	            }
	            return result;
	        },

	        _seriesOptions: function() {
	            var series = this._series;
	            if (!series) {
	                series = this._series = this._chart._seriesOptions(this._options);
	            }
	            return series;
	        },

	        _clearFields: function() {
	            delete this._points;
	            delete this._series;
	        }
	    });

	    function triggerPaneRender(panes) {
	        for (var idx = 0; idx < panes.length; idx++) {
	            panes[idx].notifyRender();
	        }
	    }

	    dataviz.Tooltip = Tooltip;
	    dataviz.CrosshairTooltip = CrosshairTooltip;
	    dataviz.ChartInstanceObserver = ChartInstanceObserver;
	    dataviz.ChartPane = ChartPane;
	    dataviz.ChartSeries = ChartSeries;

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 880:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ralJ");

/***/ }),

/***/ 881:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 882:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nzx/");

/***/ }),

/***/ 883:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nK46");

/***/ }),

/***/ 884:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FTkt");

/***/ }),

/***/ 885:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FZAa");

/***/ })

/******/ });

/***/ }),

/***/ "KBs5":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(946);
	module.exports = __webpack_require__(946);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/***********************************************************************
	 * WARNING: this file is auto-generated.  If you change it directly,
	 * your modifications will eventually be lost.  The source code is in
	 * `kendo-drawing` repository, you should make your changes there and
	 * run `src-modules/sync.sh` in this repository.
	 */
	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(947), __webpack_require__(948), __webpack_require__(949) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {

	/* jshint eqnull:true */
	/* jshint -W058 */
	/* jshint -W069 */
	/* jshint latedef: nofunc */

	window.kendo = window.kendo || {};
	var kendoDrawing = kendo.drawing;
	var kendoDrawingUtil = kendoDrawing.util;
	var Class = kendo.Class;
	var kendoUtil = kendo.util;
	var support = kendo.support;
	var supportBrowser = support.browser;

	var createPromise = kendoDrawingUtil.createPromise;
	var promiseAll = kendoDrawingUtil.promiseAll;

	var ObserversMixin = {
	    extend: function(proto) {
	        var this$1 = this;

	        for (var method in this) {
	            if (method !== "extend") {
	                proto[method] = this$1[method];
	            }
	        }
	    },

	    observers: function() {
	        this._observers = this._observers || [];
	        return this._observers;
	    },

	    addObserver: function(element) {
	        if (!this._observers) {
	            this._observers = [ element ];
	        } else {
	            this._observers.push(element);
	        }
	        return this;
	    },

	    removeObserver: function(element) {
	        var observers = this.observers();
	        var index = observers.indexOf(element);
	        if (index !== -1) {
	            observers.splice(index, 1);
	        }
	        return this;
	    },

	    trigger: function(methodName, event) {
	        var observers = this._observers;

	        if (observers && !this._suspended) {
	            for (var idx = 0; idx < observers.length; idx++) {
	                var observer = observers[idx];
	                if (observer[methodName]) {
	                    observer[methodName](event);
	                }
	            }
	        }
	        return this;
	    },

	    optionsChange: function(e) {
	        if (e === void 0) { e = {}; }

	        e.element = this;
	        this.trigger("optionsChange", e);
	    },

	    geometryChange: function() {
	        this.trigger("geometryChange", {
	            element: this
	        });
	    },

	    suspend: function() {
	        this._suspended = (this._suspended || 0) + 1;
	        return this;
	    },

	    resume: function() {
	        this._suspended = Math.max((this._suspended || 0) - 1, 0);
	        return this;
	    },

	    _observerField: function(field, value) {
	        if (this[field]) {
	            this[field].removeObserver(this);
	        }
	        this[field] = value;
	        value.addObserver(this);
	    }
	};

	function append(first, second) {
	    first.push.apply(first, second);
	    return first;
	}

	/* eslint-disable key-spacing,no-multi-spaces,no-param-reassign */

	var literals = {
	    1    : "i",       10   : "x",       100  : "c",
	    2    : "ii",      20   : "xx",      200  : "cc",
	    3    : "iii",     30   : "xxx",     300  : "ccc",
	    4    : "iv",      40   : "xl",      400  : "cd",
	    5    : "v",       50   : "l",       500  : "d",
	    6    : "vi",      60   : "lx",      600  : "dc",
	    7    : "vii",     70   : "lxx",     700  : "dcc",
	    8    : "viii",    80   : "lxxx",    800  : "dccc",
	    9    : "ix",      90   : "xc",      900  : "cm",
	    1000 : "m"
	};

	function arabicToRoman(n) {
	    var values = [ 1000,
	                   900 , 800, 700, 600, 500, 400, 300, 200, 100,
	                   90  , 80 , 70 , 60 , 50 , 40 , 30 , 20 , 10 ,
	                   9   , 8  , 7  , 6  , 5  , 4  , 3  , 2  , 1 ];

	    var roman = "";
	    while (n > 0) {
	        if (n < values[0]) {
	            values.shift();
	        } else {
	            roman += literals[values[0]];
	            n -= values[0];
	        }
	    }
	    return roman;
	}

	var UNDEFINED = "undefined";

	function defined(value) {
	    return typeof value !== UNDEFINED;
	}

	var defId = 1;

	function definitionId() {
	    return "kdef" + defId++;
	}

	var DEG_TO_RAD = Math.PI / 180;
	var MAX_NUM = Number.MAX_VALUE;
	var MIN_NUM = -Number.MAX_VALUE;

	function deg(radians) {
	    return radians / DEG_TO_RAD;
	}

	var fromCharCode = String.fromCharCode;

	// Encodes a string as UTF-8
	function encodeUTF8(input) {
	    var output = "";

	    for (var i = 0; i < input.length; i++) {
	        var c = input.charCodeAt(i);

	        if (c < 0x80) {
	            // One byte
	            output += fromCharCode(c);
	        } else if (c < 0x800) {
	            // Two bytes
	            output += fromCharCode(0xC0 | (c >>> 6));
	            output += fromCharCode(0x80 | (c & 0x3f));
	        } else if (c < 0x10000) {
	            // Three bytes
	            output += fromCharCode(0xE0 | (c >>> 12));
	            output += fromCharCode(0x80 | (c >>> 6 & 0x3f));
	            output += fromCharCode(0x80 | (c & 0x3f));
	        }
	    }

	    return output;
	}

	// Encodes a string as UTF-16 big-endian

	var KEY_STR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

	function encodeBase64(input) {
	    var output = "";
	    var i = 0;

	    var utfInput = encodeUTF8(input);

	    while (i < utfInput.length) {
	        var chr1 = utfInput.charCodeAt(i++);
	        var chr2 = utfInput.charCodeAt(i++);
	        var chr3 = utfInput.charCodeAt(i++);

	        var enc1 = chr1 >> 2;
	        var enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        var enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        var enc4 = chr3 & 63;

	        if (isNaN(chr2)) {
	            enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	            enc4 = 64;
	        }

	        output = output +
	            KEY_STR.charAt(enc1) + KEY_STR.charAt(enc2) +
	            KEY_STR.charAt(enc3) + KEY_STR.charAt(enc4);
	    }

	    return output;
	}

	function eventCoordinates(e) {
	    if (defined((e.x || {}).location)) {
	        return {
	            x: e.x.location,
	            y: e.y.location
	        };
	    }

	    return {
	        x: e.pageX || e.clientX || 0,
	        y: e.pageY || e.clientY || 0
	    };
	}

	function eventElement(e) {
	    if (e === void 0) { e = {}; }

	    return e.touch ? e.touch.initialTouch : e.target;
	}

	function isTransparent(color) {
	    return color === "" || color === null || color === "none" || color === "transparent" || !defined(color);
	}

	function last(array) {
	    if (array) {
	        return array[array.length - 1];
	    }
	}

	function limitValue(value, min, max) {
	    return Math.max(Math.min(value, max), min);
	}

	/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
	/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
	/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
	/* eslint-disable no-param-reassign, no-var, block-scoped-var */

	// mergeSort is stable.
	function mergeSort(a, cmp) {
	    if (a.length < 2) {
	        return a.slice();
	    }
	    function merge(a, b) {
	        var r = [], ai = 0, bi = 0, i = 0;
	        while (ai < a.length && bi < b.length) {
	            if (cmp(a[ai], b[bi]) <= 0) {
	                r[i++] = a[ai++];
	            } else {
	                r[i++] = b[bi++];
	            }
	        }
	        if (ai < a.length) {
	            r.push.apply(r, a.slice(ai));
	        }
	        if (bi < b.length) {
	            r.push.apply(r, b.slice(bi));
	        }
	        return r;
	    }
	    return (function sort(a) {
	        if (a.length <= 1) {
	            return a;
	        }
	        var m = Math.floor(a.length / 2);
	        var left = a.slice(0, m);
	        var right = a.slice(m);
	        left = sort(left);
	        right = sort(right);
	        return merge(left, right);
	    })(a);
	}

	function rad(degrees) {
	    return degrees * DEG_TO_RAD;
	}

	function pow(p) {
	    if (p) {
	        return Math.pow(10, p);
	    }

	    return 1;
	}

	function round(value, precision) {
	    var power = pow(precision);
	    return Math.round(value * power) / power;
	}

	function valueOrDefault(value, defaultValue) {
	    return defined(value) ? value : defaultValue;
	}

	function bindEvents(element, events) {
	    for (var eventName in events) {
	        var eventNames = eventName.trim().split(" ");
	        for (var idx = 0; idx < eventNames.length; idx++) {
	            element.addEventListener(eventNames[idx], events[eventName], false);
	        }
	    }
	}

	function elementOffset(element) {
	    var box = element.getBoundingClientRect();

	    var documentElement = document.documentElement;

	    return {
	        top: box.top + (window.pageYOffset || documentElement.scrollTop) - (documentElement.clientTop || 0),
	        left: box.left + (window.pageXOffset || documentElement.scrollLeft) - (documentElement.clientLeft || 0)
	    };
	}

	function elementStyles(element, styles) {
	    var result = {};
	    var style = window.getComputedStyle(element) || {};
	    var stylesArray = Array.isArray(styles) ? styles : [ styles ];

	    for (var idx = 0; idx < stylesArray.length; idx++) {
	        var field = stylesArray[idx];
	        result[field] = style[field];
	    }

	    return result;
	}

	function getPixels(value) {
	    if (isNaN(value)) {
	        return value;
	    }
	    return value + "px";
	}

	function elementSize(element, size) {
	    if (size) {
	        var width = size.width;
	        var height = size.height;

	        if (defined(width)) {
	            element.style.width = getPixels(width);
	        }

	        if (defined(height)) {
	            element.style.height = getPixels(height);
	        }

	    } else {
	        var size$1 = elementStyles(element, [ 'width', 'height' ]);

	        return {
	            width: parseInt(size$1.width, 10),
	            height: parseInt(size$1.height, 10)
	        };
	    }
	}

	function unbindEvents(element, events) {
	    if (events === void 0) { events = {}; }

	    for (var name in events) {
	        var eventNames = name.trim().split(" ");
	        for (var idx = 0; idx < eventNames.length; idx++) {
	            element.removeEventListener(eventNames[idx], events[name], false);
	        }
	    }
	}

	function elementPadding(element) {
	    var ref = elementStyles(element, [ "paddingLeft", "paddingTop" ]);
	    var paddingLeft = ref.paddingLeft;
	    var paddingTop = ref.paddingTop;
	    return {
	        top: parseFloat(paddingTop),
	        left: parseFloat(paddingLeft)
	    };
	}

	function setAccessor(field) {
	    return function(value) {
	        if (this[field] !== value) {
	            this[field] = value;
	            this.geometryChange();
	        }

	        return this;
	    };
	}

	function getAccessor(field) {
	    return function() {
	        return this[field];
	    };
	}

	function defineAccessors(fn, fields) {
	    for (var i = 0; i < fields.length; i++) {
	        var name = fields[i];
	        var capitalized = name.charAt(0).toUpperCase() +
	                          name.substring(1, name.length);

	        fn["set" + capitalized] = setAccessor(name);
	        fn["get" + capitalized] = getAccessor(name);
	    }
	}

	var Matrix = Class.extend({
	    init: function(a, b, c, d, e, f) {
	        if (a === void 0) { a = 0; }
	        if (b === void 0) { b = 0; }
	        if (c === void 0) { c = 0; }
	        if (d === void 0) { d = 0; }
	        if (e === void 0) { e = 0; }
	        if (f === void 0) { f = 0; }

	        this.a = a;
	        this.b = b;
	        this.c = c;
	        this.d = d;
	        this.e = e;
	        this.f = f;
	    },

	    multiplyCopy: function(matrix) {
	        return new Matrix(
	            this.a * matrix.a + this.c * matrix.b,
	            this.b * matrix.a + this.d * matrix.b,
	            this.a * matrix.c + this.c * matrix.d,
	            this.b * matrix.c + this.d * matrix.d,
	            this.a * matrix.e + this.c * matrix.f + this.e,
	            this.b * matrix.e + this.d * matrix.f + this.f
	        );
	    },

	    invert: function() {
	        var ref = this;
	        var a = ref.a;
	        var b = ref.b;
	        var d = ref.c;
	        var e = ref.d;
	        var g = ref.e;
	        var h = ref.f;
	        var det = a * e - b * d;

	        if (det === 0) {
	            return null;
	        }

	        return new Matrix(e / det, -b / det, -d / det, a / det,
	                          (d * h - e * g) / det, (b * g - a * h) / det);
	    },

	    clone: function() {
	        return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
	    },

	    equals: function(other) {
	        if (!other) {
	            return false;
	        }

	        return this.a === other.a && this.b === other.b &&
	               this.c === other.c && this.d === other.d &&
	               this.e === other.e && this.f === other.f;
	    },

	    round: function(precision) {
	        this.a = round(this.a, precision);
	        this.b = round(this.b, precision);
	        this.c = round(this.c, precision);
	        this.d = round(this.d, precision);
	        this.e = round(this.e, precision);
	        this.f = round(this.f, precision);

	        return this;
	    },

	    toArray: function(precision) {
	        var result = [ this.a, this.b, this.c, this.d, this.e, this.f ];

	        if (defined(precision)) {
	            for (var i = 0; i < result.length; i++) {
	                result[i] = round(result[i], precision);
	            }
	        }

	        return result;
	    },

	    toString: function(precision, separator) {
	        if (separator === void 0) { separator = ","; }

	        return this.toArray(precision).join(separator);
	    }
	});

	Matrix.translate = function(x, y) {
	    return new Matrix(1, 0, 0, 1, x, y);
	};

	Matrix.unit = function() {
	    return new Matrix(1, 0, 0, 1, 0, 0);
	};

	Matrix.rotate = function(angle, x, y) {
	    var matrix = new Matrix();
	    matrix.a = Math.cos(rad(angle));
	    matrix.b = Math.sin(rad(angle));
	    matrix.c = -matrix.b;
	    matrix.d = matrix.a;
	    matrix.e = (x - x * matrix.a + y * matrix.b) || 0;
	    matrix.f = (y - y * matrix.a - x * matrix.b) || 0;

	    return matrix;
	};

	Matrix.scale = function(scaleX, scaleY) {
	    return new Matrix(scaleX, 0, 0, scaleY, 0, 0);
	};

	Matrix.IDENTITY = Matrix.unit();

	function toMatrix(transformation) {
	    if (transformation && typeof transformation.matrix === "function") {
	        return transformation.matrix();
	    }

	    return transformation;
	}

	var Point = Class.extend({
	    init: function(x, y) {

	        this.x = x || 0;
	        this.y = y || 0;
	    },

	    equals: function(other) {
	        return other && other.x === this.x && other.y === this.y;
	    },

	    clone: function() {
	        return new Point(this.x, this.y);
	    },

	    rotate: function(angle, origin) {
	        var originPoint = Point.create(origin) || Point.ZERO;

	        return this.transform(Matrix.rotate(angle, originPoint.x, originPoint.y));
	    },

	    translate: function(x, y) {
	        this.x += x;
	        this.y += y;

	        this.geometryChange();

	        return this;
	    },

	    translateWith: function(point) {
	        return this.translate(point.x, point.y);
	    },

	    move: function(x, y) {
	        this.x = this.y = 0;
	        return this.translate(x, y);
	    },

	    scale: function(scaleX, scaleY) {
	        if (scaleY === void 0) { scaleY = scaleX; }

	        this.x *= scaleX;
	        this.y *= scaleY;

	        this.geometryChange();

	        return this;
	    },

	    scaleCopy: function(scaleX, scaleY) {
	        return this.clone().scale(scaleX, scaleY);
	    },

	    transform: function(transformation) {
	        var matrix = toMatrix(transformation);
	        var ref = this;
	        var x = ref.x;
	        var y = ref.y;

	        this.x = matrix.a * x + matrix.c * y + matrix.e;
	        this.y = matrix.b * x + matrix.d * y + matrix.f;

	        this.geometryChange();

	        return this;
	    },

	    transformCopy: function(transformation) {
	        var point = this.clone();

	        if (transformation) {
	            point.transform(transformation);
	        }

	        return point;
	    },

	    distanceTo: function(point) {
	        var dx = this.x - point.x;
	        var dy = this.y - point.y;

	        return Math.sqrt(dx * dx + dy * dy);
	    },

	    round: function(digits) {
	        this.x = round(this.x, digits);
	        this.y = round(this.y, digits);

	        this.geometryChange();

	        return this;
	    },

	    toArray: function(digits) {
	        var doRound = defined(digits);
	        var x = doRound ? round(this.x, digits) : this.x;
	        var y = doRound ? round(this.y, digits) : this.y;

	        return [ x, y ];
	    },

	    toString: function(digits, separator) {
	        if (separator === void 0) { separator = " "; }

	        var ref = this;
	        var x = ref.x;
	        var y = ref.y;

	        if (defined(digits)) {
	            x = round(x, digits);
	            y = round(y, digits);
	        }

	        return x + separator + y;
	    }
	});

	Point.create = function(arg0, arg1) {
	    if (defined(arg0)) {
	        if (arg0 instanceof Point) {
	            return arg0;
	        } else if (arguments.length === 1 && arg0.length === 2) {
	            return new Point(arg0[0], arg0[1]);
	        }

	        return new Point(arg0, arg1);
	    }
	};

	Point.min = function() {
	    var arguments$1 = arguments;

	    var minX = MAX_NUM;
	    var minY = MAX_NUM;

	    for (var i = 0; i < arguments.length; i++) {
	        var point = arguments$1[i];
	        minX = Math.min(point.x, minX);
	        minY = Math.min(point.y, minY);
	    }

	    return new Point(minX, minY);
	};

	Point.max = function() {
	    var arguments$1 = arguments;

	    var maxX = MIN_NUM;
	    var maxY = MIN_NUM;

	    for (var i = 0; i < arguments.length; i++) {
	        var point = arguments$1[i];
	        maxX = Math.max(point.x, maxX);
	        maxY = Math.max(point.y, maxY);
	    }

	    return new Point(maxX, maxY);
	};

	Point.minPoint = function() {
	    return new Point(MIN_NUM, MIN_NUM);
	};

	Point.maxPoint = function() {
	    return new Point(MAX_NUM, MAX_NUM);
	};

	if (Object.defineProperties) {
	    Object.defineProperties(Point, {
	        ZERO: {
	            get: function() {
	                return new Point(0, 0);
	            }
	        }
	    });
	}

	defineAccessors(Point.prototype, [ "x", "y" ]);
	ObserversMixin.extend(Point.prototype);

	var Size = Class.extend({
	    init: function(width, height) {

	        this.width = width || 0;
	        this.height = height || 0;
	    },

	    equals: function(other) {
	        return other && other.width === this.width && other.height === this.height;
	    },

	    clone: function() {
	        return new Size(this.width, this.height);
	    },

	    toArray: function(digits) {
	        var doRound = defined(digits);
	        var width = doRound ? round(this.width, digits) : this.width;
	        var height = doRound ? round(this.height, digits) : this.height;

	        return [ width, height ];
	    }
	});

	Size.create = function(arg0, arg1) {
	    if (defined(arg0)) {
	        if (arg0 instanceof Size) {
	            return arg0;
	        } else if (arguments.length === 1 && arg0.length === 2) {
	            return new Size(arg0[0], arg0[1]);
	        }

	        return new Size(arg0, arg1);
	    }
	};

	if (Object.defineProperties) {
	    Object.defineProperties(Size, {
	        ZERO: {
	            get: function() {
	                return new Size(0, 0);
	            }
	        }
	    });
	}

	defineAccessors(Size.prototype, [ "width", "height" ]);
	ObserversMixin.extend(Size.prototype);

	var Rect = Class.extend({
	    init: function(origin, size) {
	        if (origin === void 0) { origin = new Point(); }
	        if (size === void 0) { size = new Size(); }

	        this.setOrigin(origin);
	        this.setSize(size);
	    },

	    clone: function() {
	        return new Rect(
	            this.origin.clone(),
	            this.size.clone()
	        );
	    },

	    equals: function(other) {
	        return other &&
	               other.origin.equals(this.origin) &&
	               other.size.equals(this.size);
	    },

	    setOrigin: function(value) {
	        this._observerField("origin", Point.create(value));
	        this.geometryChange();
	        return this;
	    },

	    getOrigin: function() {
	        return this.origin;
	    },

	    setSize: function(value) {
	        this._observerField("size", Size.create(value));
	        this.geometryChange();
	        return this;
	    },

	    getSize: function() {
	        return this.size;
	    },

	    width: function() {
	        return this.size.width;
	    },

	    height: function() {
	        return this.size.height;
	    },

	    topLeft: function() {
	        return this.origin.clone();
	    },

	    bottomRight: function() {
	        return this.origin.clone().translate(this.width(), this.height());
	    },

	    topRight: function() {
	        return this.origin.clone().translate(this.width(), 0);
	    },

	    bottomLeft: function() {
	        return this.origin.clone().translate(0, this.height());
	    },

	    center: function() {
	        return this.origin.clone().translate(this.width() / 2, this.height() / 2);
	    },

	    bbox: function(matrix) {
	        var tl = this.topLeft().transformCopy(matrix);
	        var tr = this.topRight().transformCopy(matrix);
	        var br = this.bottomRight().transformCopy(matrix);
	        var bl = this.bottomLeft().transformCopy(matrix);

	        return Rect.fromPoints(tl, tr, br, bl);
	    },

	    transformCopy: function(m) {
	        return Rect.fromPoints(
	            this.topLeft().transform(m),
	            this.bottomRight().transform(m)
	        );
	    },

	    expand: function(x, y) {
	        if (y === void 0) { y = x; }

	        this.size.width += 2 * x;
	        this.size.height += 2 * y;

	        this.origin.translate(-x, -y);

	        return this;
	    },

	    expandCopy: function(x, y) {
	        return this.clone().expand(x, y);
	    },

	    containsPoint: function(point) {
	        var origin = this.origin;
	        var bottomRight = this.bottomRight();
	        return !(point.x < origin.x || point.y < origin.y || bottomRight.x < point.x || bottomRight.y < point.y);
	    },

	    _isOnPath: function(point, width) {
	        var rectOuter = this.expandCopy(width, width);
	        var rectInner = this.expandCopy(-width, -width);

	        return rectOuter.containsPoint(point) && !rectInner.containsPoint(point);
	    }
	});

	Rect.fromPoints = function() {
	    var topLeft = Point.min.apply(null, arguments);
	    var bottomRight = Point.max.apply(null, arguments);
	    var size = new Size(
	        bottomRight.x - topLeft.x,
	        bottomRight.y - topLeft.y
	    );

	    return new Rect(topLeft, size);
	};

	Rect.union = function(a, b) {
	    return Rect.fromPoints(
	        Point.min(a.topLeft(), b.topLeft()),
	        Point.max(a.bottomRight(), b.bottomRight())
	    );
	};

	Rect.intersect = function(a, b) {
	    var rect1 = {
	        left: a.topLeft().x,
	        top: a.topLeft().y,
	        right: a.bottomRight().x,
	        bottom: a.bottomRight().y
	    };

	    var rect2 = {
	        left: b.topLeft().x,
	        top: b.topLeft().y,
	        right: b.bottomRight().x,
	        bottom: b.bottomRight().y
	    };

	    if (rect1.left <= rect2.right &&
	        rect2.left <= rect1.right &&
	        rect1.top <= rect2.bottom &&
	        rect2.top <= rect1.bottom) {
	        return Rect.fromPoints(
	            new Point(Math.max(rect1.left, rect2.left), Math.max(rect1.top, rect2.top)),
	            new Point(Math.min(rect1.right, rect2.right), Math.min(rect1.bottom, rect2.bottom))
	        );
	    }
	};

	ObserversMixin.extend(Rect.prototype);

	function ellipseExtremeAngles(center, rx, ry, matrix) {
	    var extremeX = 0;
	    var extremeY = 0;

	    if (matrix) {
	        extremeX = Math.atan2(matrix.c * ry, matrix.a * rx);
	        if (matrix.b !== 0) {
	            extremeY = Math.atan2(matrix.d * ry, matrix.b * rx);
	        }
	    }

	    return {
	        x: extremeX,
	        y: extremeY
	    };
	}

	var PI_DIV_2 = Math.PI / 2;

	var Circle = Class.extend({
	    init: function(center, radius) {
	        if (center === void 0) { center = new Point(); }
	        if (radius === void 0) { radius = 0; }

	        this.setCenter(center);
	        this.setRadius(radius);
	    },

	    setCenter: function(value) {
	        this._observerField("center", Point.create(value));
	        this.geometryChange();
	        return this;
	    },

	    getCenter: function() {
	        return this.center;
	    },

	    equals: function(other) {
	        return other &&
	               other.center.equals(this.center) &&
	               other.radius === this.radius;
	    },

	    clone: function() {
	        return new Circle(this.center.clone(), this.radius);
	    },

	    pointAt: function(angle) {
	        return this._pointAt(rad(angle));
	    },

	    bbox: function(matrix) {
	        var this$1 = this;

	        var extremeAngles = ellipseExtremeAngles(this.center, this.radius, this.radius, matrix);
	        var minPoint = Point.maxPoint();
	        var maxPoint = Point.minPoint();

	        for (var i = 0; i < 4; i++) {
	            var currentPointX = this$1._pointAt(extremeAngles.x + i * PI_DIV_2).transformCopy(matrix);
	            var currentPointY = this$1._pointAt(extremeAngles.y + i * PI_DIV_2).transformCopy(matrix);
	            var currentPoint = new Point(currentPointX.x, currentPointY.y);

	            minPoint = Point.min(minPoint, currentPoint);
	            maxPoint = Point.max(maxPoint, currentPoint);
	        }

	        return Rect.fromPoints(minPoint, maxPoint);
	    },

	    _pointAt: function(angle) {
	        var ref = this;
	        var center = ref.center;
	        var radius = ref.radius;

	        return new Point(
	            center.x + radius * Math.cos(angle),
	            center.y + radius * Math.sin(angle)
	        );
	    },

	    containsPoint: function(point) {
	        var ref = this;
	        var center = ref.center;
	        var radius = ref.radius;
	        var inCircle = Math.pow(point.x - center.x, 2) +
	            Math.pow(point.y - center.y, 2) <= Math.pow(radius, 2);
	        return inCircle;
	    },

	    _isOnPath: function(point, width) {
	        var ref = this;
	        var center = ref.center;
	        var radius = ref.radius;
	        var pointDistance = center.distanceTo(point);

	        return radius - width <= pointDistance && pointDistance <= radius + width;
	    }
	});

	defineAccessors(Circle.prototype, [ "radius" ]);
	ObserversMixin.extend(Circle.prototype);

	var PRECISION = 10;

	function close(a, b, tolerance) {
	    if (tolerance === void 0) { tolerance = PRECISION; }

	    return round(Math.abs(a - b), tolerance) === 0;
	}

	function closeOrLess(a, b, tolerance) {
	    return a < b || close(a, b, tolerance);
	}

	function lineIntersection(p0, p1, p2, p3) {
	    var s1x = p1.x - p0.x;
	    var s2x = p3.x - p2.x;
	    var s1y = p1.y - p0.y;
	    var s2y = p3.y - p2.y;
	    var nx = p0.x - p2.x;
	    var ny = p0.y - p2.y;
	    var d = s1x * s2y - s2x * s1y;
	    var s = (s1x * ny - s1y * nx) / d;
	    var t = (s2x * ny - s2y * nx) / d;

	    if (s >= 0 && s <= 1 && t >= 0 && t <= 1) {
	        return new Point(p0.x + t * s1x, p0.y + t * s1y);
	    }
	}

	var Transformation = Class.extend({
	    init: function(matrix) {
	        if (matrix === void 0) { matrix = Matrix.unit(); }

	        this._matrix = matrix;
	    },

	    clone: function() {
	        return new Transformation(
	            this._matrix.clone()
	        );
	    },

	    equals: function(other) {
	        return other &&
	               other._matrix.equals(this._matrix);
	    },

	    translate: function(x, y) {
	        this._matrix = this._matrix.multiplyCopy(Matrix.translate(x, y));

	        this._optionsChange();
	        return this;
	    },

	    scale: function(scaleX, scaleY, origin) {
	        if (scaleY === void 0) { scaleY = scaleX; }
	        if (origin === void 0) { origin = null; }

	        var originPoint = origin;

	        if (originPoint) {
	            originPoint = Point.create(originPoint);
	            this._matrix = this._matrix.multiplyCopy(Matrix.translate(originPoint.x, originPoint.y));
	        }

	        this._matrix = this._matrix.multiplyCopy(Matrix.scale(scaleX, scaleY));

	        if (originPoint) {
	            this._matrix = this._matrix.multiplyCopy(Matrix.translate(-originPoint.x, -originPoint.y));
	        }

	        this._optionsChange();
	        return this;
	    },

	    rotate: function(angle, origin) {
	        var originPoint = Point.create(origin) || Point.ZERO;

	        this._matrix = this._matrix.multiplyCopy(Matrix.rotate(angle, originPoint.x, originPoint.y));

	        this._optionsChange();
	        return this;
	    },

	    multiply: function(transformation) {
	        var matrix = toMatrix(transformation);

	        this._matrix = this._matrix.multiplyCopy(matrix);

	        this._optionsChange();
	        return this;
	    },

	    matrix: function(value) {
	        if (value) {
	            this._matrix = value;
	            this._optionsChange();
	            return this;
	        }

	        return this._matrix;
	    },

	    _optionsChange: function() {
	        this.optionsChange({
	            field: "transform",
	            value: this
	        });
	    }
	});

	ObserversMixin.extend(Transformation.prototype);

	function transform(matrix) {
	    if (matrix === null) {
	        return null;
	    }

	    if (matrix instanceof Transformation) {
	        return matrix;
	    }

	    return new Transformation(matrix);
	}

	var MAX_INTERVAL = 45;
	var pow$1 = Math.pow;

	var Arc = Class.extend({
	    init: function(center, options) {
	        if (center === void 0) { center = new Point(); }
	        if (options === void 0) { options = {}; }

	        this.setCenter(center);

	        this.radiusX = options.radiusX;
	        this.radiusY = options.radiusY || options.radiusX;
	        this.startAngle = options.startAngle;
	        this.endAngle = options.endAngle;
	        this.anticlockwise = options.anticlockwise || false;
	        this.xRotation = options.xRotation;
	    },

	    clone: function() {
	        return new Arc(this.center, {
	            radiusX: this.radiusX,
	            radiusY: this.radiusY,
	            startAngle: this.startAngle,
	            endAngle: this.endAngle,
	            anticlockwise: this.anticlockwise
	        });
	    },

	    setCenter: function(value) {
	        this._observerField("center", Point.create(value));
	        this.geometryChange();
	        return this;
	    },

	    getCenter: function() {
	        return this.center;
	    },

	    pointAt: function(angle) {
	        var center = this.center;
	        var radian = rad(angle);

	        return new Point(
	            center.x + this.radiusX * Math.cos(radian),
	            center.y + this.radiusY * Math.sin(radian)
	        );
	    },

	    curvePoints: function() {
	        var this$1 = this;

	        var startAngle = this.startAngle;
	        var dir = this.anticlockwise ? -1 : 1;
	        var curvePoints = [ this.pointAt(startAngle) ];
	        var interval = this._arcInterval();
	        var intervalAngle = interval.endAngle - interval.startAngle;
	        var subIntervalsCount = Math.ceil(intervalAngle / MAX_INTERVAL);
	        var subIntervalAngle = intervalAngle / subIntervalsCount;
	        var currentAngle = startAngle;
	        var transformation;
	        if (this.xRotation) {
	            transformation = transform().rotate(this.xRotation, this.center);
	        }

	        for (var i = 1; i <= subIntervalsCount; i++) {
	            var nextAngle = currentAngle + dir * subIntervalAngle;
	            var points = this$1._intervalCurvePoints(currentAngle, nextAngle, transformation);

	            curvePoints.push(points.cp1, points.cp2, points.p2);
	            currentAngle = nextAngle;
	        }

	        return curvePoints;
	    },

	    bbox: function(matrix) {
	        var this$1 = this;

	        var interval = this._arcInterval();
	        var startAngle = interval.startAngle;
	        var endAngle = interval.endAngle;
	        var extremeAngles = ellipseExtremeAngles(this.center, this.radiusX, this.radiusY, matrix);
	        var extremeX = deg(extremeAngles.x);
	        var extremeY = deg(extremeAngles.y);
	        var endPoint = this.pointAt(endAngle).transformCopy(matrix);
	        var currentAngleX = bboxStartAngle(extremeX, startAngle);
	        var currentAngleY = bboxStartAngle(extremeY, startAngle);
	        var currentPoint = this.pointAt(startAngle).transformCopy(matrix);
	        var minPoint = Point.min(currentPoint, endPoint);
	        var maxPoint = Point.max(currentPoint, endPoint);

	        while (currentAngleX < endAngle || currentAngleY < endAngle) {
	            var currentPointX = (void 0);
	            if (currentAngleX < endAngle) {
	                currentPointX = this$1.pointAt(currentAngleX).transformCopy(matrix);
	                currentAngleX += 90;
	            }

	            var currentPointY = (void 0);
	            if (currentAngleY < endAngle) {
	                currentPointY = this$1.pointAt(currentAngleY).transformCopy(matrix);
	                currentAngleY += 90;
	            }

	            currentPoint = new Point(currentPointX.x, currentPointY.y);
	            minPoint = Point.min(minPoint, currentPoint);
	            maxPoint = Point.max(maxPoint, currentPoint);
	        }

	        return Rect.fromPoints(minPoint, maxPoint);
	    },

	    _arcInterval: function() {
	        var ref = this;
	        var startAngle = ref.startAngle;
	        var endAngle = ref.endAngle;
	        var anticlockwise = ref.anticlockwise;

	        if (anticlockwise) {
	            var oldStart = startAngle;
	            startAngle = endAngle;
	            endAngle = oldStart;
	        }

	        if (startAngle > endAngle || (anticlockwise && startAngle === endAngle)) {
	            endAngle += 360;
	        }

	        return {
	            startAngle: startAngle,
	            endAngle: endAngle
	        };
	    },

	    _intervalCurvePoints: function(startAngle, endAngle, transformation) {
	        var p1 = this.pointAt(startAngle);
	        var p2 = this.pointAt(endAngle);
	        var p1Derivative = this._derivativeAt(startAngle);
	        var p2Derivative = this._derivativeAt(endAngle);
	        var t = (rad(endAngle) - rad(startAngle)) / 3;
	        var cp1 = new Point(p1.x + t * p1Derivative.x, p1.y + t * p1Derivative.y);
	        var cp2 = new Point(p2.x - t * p2Derivative.x, p2.y - t * p2Derivative.y);
	        if (transformation) {
	            p1.transform(transformation);
	            p2.transform(transformation);
	            cp1.transform(transformation);
	            cp2.transform(transformation);
	        }

	        return {
	            p1: p1,
	            cp1: cp1,
	            cp2: cp2,
	            p2: p2
	        };
	    },

	    _derivativeAt: function(angle) {
	        var radian = rad(angle);

	        return new Point(-this.radiusX * Math.sin(radian), this.radiusY * Math.cos(radian));
	    },

	    containsPoint: function(point) {
	        var interval = this._arcInterval();
	        var intervalAngle = interval.endAngle - interval.startAngle;
	        var ref = this;
	        var center = ref.center;
	        var radiusX = ref.radiusX;
	        var radiusY = ref.radiusY;
	        var distance = center.distanceTo(point);
	        var angleRad = Math.atan2(point.y - center.y, point.x - center.x);
	        var pointRadius = (radiusX * radiusY) /
	            Math.sqrt(pow$1(radiusX, 2) * pow$1(Math.sin(angleRad), 2) + pow$1(radiusY, 2) * pow$1(Math.cos(angleRad), 2));
	        var startPoint = this.pointAt(this.startAngle).round(PRECISION);
	        var endPoint = this.pointAt(this.endAngle).round(PRECISION);
	        var intersection = lineIntersection(center, point.round(PRECISION), startPoint, endPoint);
	        var containsPoint;

	        if (intervalAngle < 180) {
	            containsPoint = intersection && closeOrLess(center.distanceTo(intersection), distance) && closeOrLess(distance, pointRadius);
	        } else {
	            var angle = calculateAngle(center.x, center.y, radiusX, radiusY, point.x, point.y);
	            if (angle !== 360) {
	                angle = (360 + angle) % 360;
	            }

	            var inAngleRange = interval.startAngle <= angle && angle <= interval.endAngle;
	            containsPoint = (inAngleRange && closeOrLess(distance, pointRadius)) || (!inAngleRange && (!intersection || intersection.equals(point)));
	        }
	        return containsPoint;
	    },

	    _isOnPath: function(point, width) {
	        var interval = this._arcInterval();
	        var center = this.center;
	        var angle = calculateAngle(center.x, center.y, this.radiusX, this.radiusY, point.x, point.y);
	        if (angle !== 360) {
	            angle = (360 + angle) % 360;
	        }

	        var inAngleRange = interval.startAngle <= angle && angle <= interval.endAngle;

	        return inAngleRange && this.pointAt(angle).distanceTo(point) <= width;
	    }
	});

	Arc.fromPoints = function(start, end, rx, ry, largeArc, swipe, rotation) {// eslint-disable-line max-params
	    var arcParameters = normalizeArcParameters({
	        x1: start.x,
	        y1: start.y,
	        x2: end.x,
	        y2: end.y,
	        rx: rx,
	        ry: ry,
	        largeArc: largeArc,
	        swipe: swipe,
	        rotation: rotation
	    });

	    return new Arc(arcParameters.center, {
	        startAngle: arcParameters.startAngle,
	        endAngle: arcParameters.endAngle,
	        radiusX: arcParameters.radiusX,
	        radiusY: arcParameters.radiusY,
	        xRotation: arcParameters.xRotation,
	        anticlockwise: swipe === 0
	    });
	};

	defineAccessors(Arc.prototype, [ "radiusX", "radiusY", "startAngle", "endAngle", "anticlockwise" ]);
	ObserversMixin.extend(Arc.prototype);

	function calculateAngle(cx, cy, rx, ry, x, y) {
	    var cos = round((x - cx) / rx, 3);
	    var sin = round((y - cy) / ry, 3);

	    return round(deg(Math.atan2(sin, cos)));
	}

	function normalizeArcParameters(parameters) {
	    var x1 = parameters.x1;
	    var y1 = parameters.y1;
	    var x2 = parameters.x2;
	    var y2 = parameters.y2;
	    var rx = parameters.rx;
	    var ry = parameters.ry;
	    var largeArc = parameters.largeArc;
	    var swipe = parameters.swipe;
	    var rotation = parameters.rotation; if (rotation === void 0) { rotation = 0; }

	    var radians = rad(rotation);
	    var cosine = Math.cos(radians);
	    var sine = Math.sin(radians);

	    var xT = cosine * (x1 - x2) / 2 + sine * (y1 - y2) / 2;
	    var yT = -sine * (x1 - x2) / 2 + cosine * (y1 - y2) / 2;

	    var sign = largeArc !== swipe ? 1 : -1;

	    var xt2 = Math.pow(xT, 2);
	    var yt2 = Math.pow(yT, 2);
	    var rx2 = Math.pow(rx, 2);
	    var ry2 = Math.pow(ry, 2);

	    var delta = xt2 / rx2 + yt2 / ry2;

	    if (delta > 1) {
	        delta = Math.sqrt(xt2 / rx2 + yt2 / ry2);
	        rx = delta * rx;
	        rx2 = Math.pow(rx, 2);

	        ry = delta * ry;
	        ry2 = Math.pow(ry, 2);
	    }

	    var constT = sign * Math.sqrt((rx2 * ry2 - rx2 * yt2 - ry2 * xt2) / (rx2 * yt2 + ry2 * xt2));
	    // due to rounding errors the value could become NaN even after radii correction
	    if (isNaN(constT)) {
	        constT = 0;
	    }

	    var cxT = constT * (rx * yT) / ry;
	    var cyT = - constT * (ry * xT) / rx;

	    var cx = cosine * cxT - sine * cyT + (x1 + x2) / 2;
	    var cy = sine * cxT + cosine * cyT + (y1 + y2) / 2;

	    var uX = (xT - cxT) / rx;
	    var uY = (yT - cyT) / ry;
	    var vX = -(xT + cxT) / rx;
	    var vY = -(yT + cyT) / ry;

	    var startAngle = (uY >= 0 ? 1 : -1) * deg(Math.acos(uX / Math.sqrt(uX * uX + uY * uY)));

	    var angleCosine = round((uX * vX + uY * vY) / (Math.sqrt(uX * uX + uY * uY) * Math.sqrt(vX * vX + vY * vY)), 10);
	    var angle = (uX * vY - uY * vX >= 0 ? 1 : -1) * deg(Math.acos(angleCosine));

	    if (!swipe && angle > 0) {
	        angle -= 360;
	    }

	    if (swipe && angle < 0) {
	        angle += 360;
	    }
	    var endAngle = startAngle + angle;
	    var signEndAngle = endAngle >= 0 ? 1 : -1;
	    endAngle = (Math.abs(endAngle) % 360) * signEndAngle;

	    return {
	        center: new Point(cx, cy),
	        startAngle: startAngle,
	        endAngle: endAngle,
	        radiusX: rx,
	        radiusY: ry,
	        xRotation: rotation
	    };
	}

	function bboxStartAngle(angle, start) {
	    var startAngle = angle;

	    while (startAngle < start) {
	        startAngle += 90;
	    }

	    return startAngle;
	}

	function pointAccessor(name) {
	    var fieldName = "_" + name;
	    return function(value) {
	        if (defined(value)) {
	            this._observerField(fieldName, Point.create(value));
	            this.geometryChange();
	            return this;
	        }

	        return this[fieldName];
	    };
	}

	function definePointAccessors(fn, names) {
	    for (var i = 0; i < names.length; i++) {
	        fn[names[i]] = pointAccessor(names[i]);
	    }
	}

	function isOutOfEndPoint(endPoint, controlPoint, point) {
	    var angle = deg(Math.atan2(controlPoint.y - endPoint.y, controlPoint.x - endPoint.x));
	    var rotatedPoint = point.transformCopy(transform().rotate(-angle, endPoint));

	    return rotatedPoint.x < endPoint.x;
	}

	function calculateCurveAt(t, field, points) {
	    var t1 = 1 - t;
	    return Math.pow(t1, 3) * points[0][field] +
	        3 * Math.pow(t1, 2) * t * points[1][field] +
	        3 * Math.pow(t, 2) * t1 * points[2][field] +
	        Math.pow(t, 3) * points[3][field];
	}

	function toCubicPolynomial(points, field) {
	    return [ -points[0][field] + 3 * points[1][field] - 3 * points[2][field] + points[3][field],
	        3 * (points[0][field] - 2 * points[1][field] + points[2][field]),
	        3 * (-points[0][field] + points[1][field]),
	        points[0][field]
	    ];
	}

	var ComplexNumber = Class.extend({
	    init: function(real, img) {
	        if (real === void 0) { real = 0; }
	        if (img === void 0) { img = 0; }

	        this.real = real;
	        this.img = img;
	    },

	    add: function(cNumber) {
	        return new ComplexNumber(round(this.real + cNumber.real, PRECISION), round(this.img + cNumber.img, PRECISION));
	    },

	    addConstant: function(value) {
	        return new ComplexNumber(this.real + value, this.img);
	    },

	    negate: function() {
	        return new ComplexNumber(-this.real, -this.img);
	    },

	    multiply: function(cNumber) {
	        return new ComplexNumber(this.real * cNumber.real - this.img * cNumber.img,
	            this.real * cNumber.img + this.img * cNumber.real);
	    },

	    multiplyConstant: function(value) {
	        return new ComplexNumber(this.real * value, this.img * value);
	    },

	    nthRoot: function(n) {
	        var rad$$1 = Math.atan2(this.img, this.real);
	        var r = Math.sqrt(Math.pow(this.img, 2) + Math.pow(this.real, 2));
	        var nthR = Math.pow(r, 1 / n);

	        return new ComplexNumber(nthR * Math.cos(rad$$1 / n), nthR * Math.sin(rad$$1 / n)); //Moivre's formula
	    },

	    equals: function(cNumber) {
	        return this.real === cNumber.real && this.img === cNumber.img;
	    },

	    isReal: function() {
	        return this.img === 0;
	    }
	});

	function numberSign(x) {
	    return x < 0 ? -1 : 1;
	}

	function solveQuadraticEquation(a, b, c) {
	    var squareRoot = Math.sqrt(Math.pow(b, 2) - 4 * a * c);
	    return [
	        (-b + squareRoot) / (2 * a),
	        (-b - squareRoot) / (2 * a)
	    ];
	}

	//Cardano's formula
	function solveCubicEquation(a, b, c, d) {
	    if (a === 0) {
	        return solveQuadraticEquation(b, c, d);
	    }

	    var p = (3 * a * c - Math.pow(b, 2)) / (3 * Math.pow(a, 2));
	    var q = (2 * Math.pow(b, 3) - 9 * a * b * c + 27 * Math.pow(a, 2) * d) / (27 * Math.pow(a, 3));
	    var Q = Math.pow(p / 3, 3) + Math.pow(q / 2, 2);
	    var i = new ComplexNumber(0,1);
	    var b3a = -b / (3 * a);
	    var x1, x2, y1, y2, y3, z1, z2;

	    if (Q < 0) {
	        x1 = new ComplexNumber(-q / 2, Math.sqrt(-Q)).nthRoot(3);
	        x2 = new ComplexNumber(-q / 2, - Math.sqrt(-Q)).nthRoot(3);
	    } else {
	        x1 = -q / 2 + Math.sqrt(Q);
	        x1 = new ComplexNumber(numberSign(x1) * Math.pow(Math.abs(x1), 1 / 3));
	        x2 = -q / 2 - Math.sqrt(Q);
	        x2 = new ComplexNumber(numberSign(x2) * Math.pow(Math.abs(x2), 1 / 3));
	    }

	    y1 = x1.add(x2);

	    z1 = x1.add(x2).multiplyConstant(-1 / 2);
	    z2 = x1.add(x2.negate()).multiplyConstant(Math.sqrt(3) / 2);

	    y2 = z1.add(i.multiply(z2));
	    y3 = z1.add(i.negate().multiply(z2));

	    var result = [];

	    if (y1.isReal()) {
	        result.push(round(y1.real + b3a, PRECISION));
	    }
	    if (y2.isReal()) {
	        result.push(round(y2.real + b3a, PRECISION));
	    }
	    if (y3.isReal()) {
	        result.push(round(y3.real + b3a, PRECISION));
	    }

	    return result;
	}

	function hasRootsInRange(points, point, field, rootField, range) {
	    var polynomial = toCubicPolynomial(points, rootField);
	    var roots = solveCubicEquation(polynomial[0], polynomial[1], polynomial[2], polynomial[3] - point[rootField]);
	    var intersection;

	    for (var idx = 0; idx < roots.length; idx++) {
	        if (0 <= roots[idx] && roots[idx] <= 1) {
	            intersection = calculateCurveAt(roots[idx], field, points);
	            if (Math.abs(intersection - point[field]) <= range) {
	                return true;
	            }
	        }
	    }
	}

	function curveIntersectionsCount(points, point, bbox) {
	    var polynomial = toCubicPolynomial(points, "x");
	    var roots = solveCubicEquation(polynomial[0], polynomial[1], polynomial[2], polynomial[3] - point.x);
	    var rayIntersection, intersectsRay;
	    var count = 0;
	    for (var i = 0; i < roots.length; i++) {
	        rayIntersection = calculateCurveAt(roots[i], "y", points);
	        intersectsRay = close(rayIntersection, point.y) || rayIntersection > point.y;
	        if (intersectsRay && (((roots[i] === 0 || roots[i] === 1) && bbox.bottomRight().x > point.x) || (0 < roots[i] && roots[i] < 1))) {
	            count++;
	        }
	    }

	    return count;
	}

	function lineIntersectionsCount(a, b, point) {
	    var intersects;
	    if (a.x !== b.x) {
	        var minX = Math.min(a.x, b.x);
	        var maxX = Math.max(a.x, b.x);
	        var minY = Math.min(a.y, b.y);
	        var maxY = Math.max(a.y, b.y);
	        var inRange = minX <= point.x && point.x < maxX;

	        if (minY === maxY) {
	            intersects = point.y <= minY && inRange;
	        } else {
	            intersects = inRange && (((maxY - minY) * ((a.x - b.x) * (a.y - b.y) > 0 ? point.x - minX : maxX - point.x)) / (maxX - minX) + minY - point.y) >= 0;
	        }
	    }

	    return intersects ? 1 : 0;
	}

	var Segment = Class.extend({
	    init: function(anchor, controlIn, controlOut) {

	        this.anchor(anchor || new Point());
	        this.controlIn(controlIn);
	        this.controlOut(controlOut);
	    },

	    bboxTo: function(toSegment, matrix) {
	        var segmentAnchor = this.anchor().transformCopy(matrix);
	        var toSegmentAnchor = toSegment.anchor().transformCopy(matrix);
	        var rect;

	        if (this.controlOut() && toSegment.controlIn()) {
	            rect = this._curveBoundingBox(
	                segmentAnchor, this.controlOut().transformCopy(matrix),
	                toSegment.controlIn().transformCopy(matrix), toSegmentAnchor
	            );
	        } else {
	            rect = this._lineBoundingBox(segmentAnchor, toSegmentAnchor);
	        }

	        return rect;
	    },

	    _lineBoundingBox: function(p1, p2) {
	        return Rect.fromPoints(p1, p2);
	    },

	    _curveBoundingBox: function(p1, cp1, cp2, p2) {
	        var points = [ p1, cp1, cp2, p2 ];
	        var extremesX = this._curveExtremesFor(points, "x");
	        var extremesY = this._curveExtremesFor(points, "y");
	        var xLimits = arrayLimits([ extremesX.min, extremesX.max, p1.x, p2.x ]);
	        var yLimits = arrayLimits([ extremesY.min, extremesY.max, p1.y, p2.y ]);

	        return Rect.fromPoints(new Point(xLimits.min, yLimits.min), new Point(xLimits.max, yLimits.max));
	    },

	    _curveExtremesFor: function(points, field) {
	        var extremes = this._curveExtremes(
	            points[0][field], points[1][field],
	            points[2][field], points[3][field]
	        );

	        return {
	            min: calculateCurveAt(extremes.min, field, points),
	            max: calculateCurveAt(extremes.max, field, points)
	        };
	    },

	    _curveExtremes: function(x1, x2, x3, x4) {
	        var a = x1 - 3 * x2 + 3 * x3 - x4;
	        var b = - 2 * (x1 - 2 * x2 + x3);
	        var c = x1 - x2;
	        var sqrt = Math.sqrt(b * b - 4 * a * c);
	        var t1 = 0;
	        var t2 = 1;

	        if (a === 0) {
	            if (b !== 0) {
	                t1 = t2 = -c / b;
	            }
	        } else if (!isNaN(sqrt)) {
	            t1 = (- b + sqrt) / (2 * a);
	            t2 = (- b - sqrt) / (2 * a);
	        }

	        var min = Math.max(Math.min(t1, t2), 0);
	        if (min < 0 || min > 1) {
	            min = 0;
	        }

	        var max = Math.min(Math.max(t1, t2), 1);
	        if (max > 1 || max < 0) {
	            max = 1;
	        }

	        return {
	            min: min,
	            max: max
	        };
	    },

	    _intersectionsTo: function(segment, point) {
	        var intersectionsCount;
	        if (this.controlOut() && segment.controlIn()) {
	            intersectionsCount = curveIntersectionsCount([ this.anchor(), this.controlOut(), segment.controlIn(), segment.anchor() ], point, this.bboxTo(segment));
	        } else {
	            intersectionsCount = lineIntersectionsCount(this.anchor(), segment.anchor(), point);
	        }
	        return intersectionsCount;
	    },

	    _isOnCurveTo: function(segment, point, width, endSegment) {
	        var bbox = this.bboxTo(segment).expand(width, width);
	        if (bbox.containsPoint(point)) {
	            var p1 = this.anchor();
	            var p2 = this.controlOut();
	            var p3 = segment.controlIn();
	            var p4 = segment.anchor();

	            if (endSegment === "start" && p1.distanceTo(point) <= width) {
	                return !isOutOfEndPoint(p1, p2, point);
	            } else if (endSegment === "end" && p4.distanceTo(point) <= width) {
	                return !isOutOfEndPoint(p4, p3, point);
	            }

	            //the approach is not entirely correct but is close and the alternatives are solving a 6th degree polynomial or testing the segment points
	            var points = [ p1, p2, p3, p4 ];
	            if (hasRootsInRange(points, point, "x", "y", width) || hasRootsInRange(points, point, "y", "x", width)) {
	                return true;
	            }
	            var rotation = transform().rotate(45, point);
	            var rotatedPoints = [ p1.transformCopy(rotation), p2.transformCopy(rotation), p3.transformCopy(rotation), p4.transformCopy(rotation) ];
	            return hasRootsInRange(rotatedPoints, point, "x", "y", width) || hasRootsInRange(rotatedPoints, point, "y", "x", width);
	        }
	    },

	    _isOnLineTo: function(segment, point, width) {
	        var p1 = this.anchor();
	        var p2 = segment.anchor();
	        var angle = deg(Math.atan2(p2.y - p1.y, p2.x - p1.x));
	        var rect = new Rect([ p1.x, p1.y - width / 2 ], [ p1.distanceTo(p2), width ]);
	        return rect.containsPoint(point.transformCopy(transform().rotate(-angle, p1)));
	    },

	    _isOnPathTo: function(segment, point, width, endSegment) {
	        var isOnPath;
	        if (this.controlOut() && segment.controlIn()) {
	            isOnPath = this._isOnCurveTo(segment, point, width / 2, endSegment);
	        } else {
	            isOnPath = this._isOnLineTo(segment, point, width);
	        }
	        return isOnPath;
	    }
	});

	definePointAccessors(Segment.prototype, [ "anchor", "controlIn", "controlOut" ]);
	ObserversMixin.extend(Segment.prototype);

	function arrayLimits(arr) {
	    var length = arr.length;
	    var min = MAX_NUM;
	    var max = MIN_NUM;

	    for (var i = 0; i < length; i ++) {
	        max = Math.max(max, arr[i]);
	        min = Math.min(min, arr[i]);
	    }

	    return {
	        min: min,
	        max: max
	    };
	}

	var geometry = {
		Circle: Circle,
		Arc: Arc,
		Rect: Rect,
		Point: Point,
		Segment: Segment,
		Matrix: Matrix,
		Size: Size,
		toMatrix: toMatrix,
		Transformation: Transformation,
		transform: transform
	};

	var matrixRegexp = /matrix\((.*)\)/;

	function parseMatrix(matrixString) {
	    var match = matrixString.match(matrixRegexp);
	    if (match === null || match.length !== 2) {
	        return Matrix.unit();
	    }

	    var members = match[1].split(',').map(function (x) { return parseFloat(x); });
	    return new (Function.prototype.bind.apply( Matrix, [ null ].concat( members) ));
	}

	function transformMatrix(element) {
	    var transform$$1 = getComputedStyle(element).transform;

	    if (transform$$1 === 'none') {
	        return Matrix.unit();
	    }

	    return parseMatrix(transform$$1);
	}

	function elementScale(element) {
	    if (!element) {
	        return Matrix.unit();
	    }

	    var matrix = transformMatrix(element);
	    var parent = element.parentElement;
	    while (parent) {
	        var parentMatrix = transformMatrix(parent);
	        matrix = matrix.multiplyCopy(parentMatrix);
	        parent = parent.parentElement;
	    }

	    matrix.b = matrix.c = matrix.e = matrix.f = 0;
	    return matrix;
	}

	var util = {
		append: append,
		arabicToRoman: arabicToRoman,
		createPromise: createPromise,
		defined: defined,
		definitionId: definitionId,
		deg: deg,
		encodeBase64: encodeBase64,
		eventCoordinates: eventCoordinates,
		eventElement: eventElement,
		isTransparent: isTransparent,
		last: last,
		limitValue: limitValue,
		mergeSort: mergeSort,
		promiseAll: promiseAll,
		rad: rad,
		round: round,
		valueOrDefault: valueOrDefault,
		bindEvents: bindEvents,
		elementOffset: elementOffset,
		elementSize: elementSize,
		elementStyles: elementStyles,
		unbindEvents: unbindEvents,
		elementPadding: elementPadding,
		elementScale: elementScale,
		DEG_TO_RAD: DEG_TO_RAD,
		MAX_NUM: MAX_NUM,
		MIN_NUM: MIN_NUM
	};

	var toString = {}.toString;

	var OptionsStore = Class.extend({
	    init: function(options, prefix) {
	        var this$1 = this;
	        if (prefix === void 0) { prefix = ""; }

	        this.prefix = prefix;

	        for (var field in options) {
	            var member = options[field];
	            member = this$1._wrap(member, field);
	            this$1[field] = member;
	        }
	    },

	    get: function(field) {
	        var parts = field.split(".");
	        var result = this;

	        while (parts.length && result) {
	            var part = parts.shift();
	            result = result[part];
	        }

	        return result;
	    },

	    set: function(field, value) {
	        var current = this.get(field);

	        if (current !== value) {
	            this._set(field, this._wrap(value, field));
	            this.optionsChange({
	                field: this.prefix + field,
	                value: value
	            });
	        }
	    },

	    _set: function(field, value) {
	        var this$1 = this;

	        var composite = field.indexOf(".") >= 0;
	        var parentObj = this;
	        var fieldName = field;

	        if (composite) {
	            var parts = fieldName.split(".");
	            var prefix = this.prefix;

	            while (parts.length > 1) {
	                fieldName = parts.shift();
	                prefix += fieldName + ".";

	                var obj = parentObj[fieldName];

	                if (!obj) {
	                    obj = new OptionsStore({}, prefix);
	                    obj.addObserver(this$1);
	                    parentObj[fieldName] = obj;
	                }
	                parentObj = obj;
	            }
	            fieldName = parts[0];
	        }

	        parentObj._clear(fieldName);
	        parentObj[fieldName] = value;
	    },

	    _clear: function(field) {
	        var current = this[field];
	        if (current && current.removeObserver) {
	            current.removeObserver(this);
	        }
	    },

	    _wrap: function(object, field) {
	        var type = toString.call(object);
	        var wrapped = object;

	        if (wrapped !== null && defined(wrapped) && type === "[object Object]") {
	            if (!(object instanceof OptionsStore) && !(object instanceof Class)) {
	                wrapped = new OptionsStore(wrapped, this.prefix + field + ".");
	            }

	            wrapped.addObserver(this);
	        }

	        return wrapped;
	    }
	});

	ObserversMixin.extend(OptionsStore.prototype);

	var Element$1 = Class.extend({
	    init: function(options) {

	        this._initOptions(options);
	    },

	    _initOptions: function(options) {
	        if (options === void 0) { options = {}; }

	        var clip = options.clip;
	        var transform$$1 = options.transform;

	        if (transform$$1) {
	            options.transform = transform(transform$$1);
	        }

	        if (clip && !clip.id) {
	            clip.id = definitionId();
	        }

	        this.options = new OptionsStore(options);
	        this.options.addObserver(this);
	    },

	    transform: function(value) {
	        if (defined(value)) {
	            this.options.set("transform", transform(value));
	        } else {
	            return this.options.get("transform");
	        }
	    },

	    parentTransform: function() {
	        var element = this;
	        var parentMatrix;

	        while (element.parent) {
	            element = element.parent;
	            var transformation = element.transform();
	            if (transformation) {
	                parentMatrix = transformation.matrix().multiplyCopy(parentMatrix || Matrix.unit());
	            }
	        }

	        if (parentMatrix) {
	            return transform(parentMatrix);
	        }
	    },

	    currentTransform: function(parentTransform) {
	        if (parentTransform === void 0) { parentTransform = this.parentTransform(); }

	        var elementTransform = this.transform();
	        var elementMatrix = toMatrix(elementTransform);

	        var parentMatrix = toMatrix(parentTransform);
	        var combinedMatrix;

	        if (elementMatrix && parentMatrix) {
	            combinedMatrix = parentMatrix.multiplyCopy(elementMatrix);
	        } else {
	            combinedMatrix = elementMatrix || parentMatrix;
	        }

	        if (combinedMatrix) {
	            return transform(combinedMatrix);
	        }
	    },

	    visible: function(value) {
	        if (defined(value)) {
	            this.options.set("visible", value);
	            return this;
	        }

	        return this.options.get("visible") !== false;
	    },

	    clip: function(value) {
	        var options = this.options;
	        if (defined(value)) {
	            if (value && !value.id) {
	                value.id = definitionId();
	            }
	            options.set("clip", value);
	            return this;
	        }

	        return options.get("clip");
	    },

	    opacity: function(value) {
	        if (defined(value)) {
	            this.options.set("opacity", value);
	            return this;
	        }

	        return valueOrDefault(this.options.get("opacity"), 1);
	    },

	    clippedBBox: function(transformation) {
	        var bbox = this._clippedBBox(transformation);
	        if (bbox) {
	            var clip = this.clip();
	            return clip ? Rect.intersect(bbox, clip.bbox(transformation)) : bbox;
	        }
	    },

	    containsPoint: function(point, parentTransform) {
	        if (this.visible()) {
	            var transform$$1 = this.currentTransform(parentTransform);
	            var transformedPoint = point;
	            if (transform$$1) {
	                transformedPoint = point.transformCopy(transform$$1.matrix().invert());
	            }
	            return (this._hasFill() && this._containsPoint(transformedPoint)) || (this._isOnPath && this._hasStroke() && this._isOnPath(transformedPoint));
	        }
	        return false;
	    },

	    _hasFill: function() {
	        var fill = this.options.fill;
	        return fill && !isTransparent(fill.color);
	    },

	    _hasStroke: function() {
	        var stroke = this.options.stroke;
	        return stroke && stroke.width > 0 && !isTransparent(stroke.color);
	    },

	    _clippedBBox: function(transformation) {
	        return this.bbox(transformation);
	    }
	});

	Element$1.prototype.nodeType = "Element";

	ObserversMixin.extend(Element$1.prototype);

	var GRADIENT = "Gradient";

	var Paintable = {
	    extend: function(proto) {
	        proto.fill = this.fill;
	        proto.stroke = this.stroke;
	    },

	    fill: function(color, opacity) {
	        var options = this.options;

	        if (defined(color)) {
	            if (color && color.nodeType !== GRADIENT) {
	                var newFill = {
	                    color: color
	                };
	                if (defined(opacity)) {
	                    newFill.opacity = opacity;
	                }
	                options.set("fill", newFill);
	            } else {
	                options.set("fill", color);
	            }

	            return this;
	        }

	        return options.get("fill");
	    },

	    stroke: function(color, width, opacity) {
	        if (defined(color)) {
	            this.options.set("stroke.color", color);

	            if (defined(width)) {
	                this.options.set("stroke.width", width);
	            }

	            if (defined(opacity)) {
	                this.options.set("stroke.opacity", opacity);
	            }

	            return this;
	        }

	        return this.options.get("stroke");
	    }
	};

	var IDENTITY_MATRIX_HASH = Matrix.IDENTITY.toString();

	var Measurable = {
	    extend: function(proto) {
	        proto.bbox = this.bbox;
	        proto.geometryChange = this.geometryChange;
	    },

	    bbox: function(transformation) {
	        var combinedMatrix = toMatrix(this.currentTransform(transformation));
	        var matrixHash = combinedMatrix ? combinedMatrix.toString() : IDENTITY_MATRIX_HASH;
	        var bbox;

	        if (this._bboxCache && this._matrixHash === matrixHash) {
	            bbox = this._bboxCache.clone();
	        } else {
	            bbox = this._bbox(combinedMatrix);
	            this._bboxCache = bbox ? bbox.clone() : null;
	            this._matrixHash = matrixHash;
	        }

	        var strokeWidth = this.options.get("stroke.width");
	        if (strokeWidth && bbox) {
	            bbox.expand(strokeWidth / 2);
	        }

	        return bbox;
	    },

	    geometryChange: function() {
	        delete this._bboxCache;
	        this.trigger("geometryChange", {
	            element: this
	        });
	    }
	};

	function geometryAccessor(name) {
	    var fieldName = "_" + name;
	    return function(value) {
	        if (defined(value)) {
	            this._observerField(fieldName, value);
	            this.geometryChange();
	            return this;
	        }

	        return this[fieldName];
	    };
	}

	function defineGeometryAccessors(fn, names) {
	    for (var i = 0; i < names.length; i++) {
	        fn[names[i]] = geometryAccessor(names[i]);
	    }
	}

	var DEFAULT_STROKE = "#000";

	var Circle$1 = Element$1.extend({
	    init: function(geometry, options) {
	        if (geometry === void 0) { geometry = new Circle(); }
	        if (options === void 0) { options = {}; }

	        Element$1.fn.init.call(this, options);
	        this.geometry(geometry);

	        if (!defined(this.options.stroke)) {
	            this.stroke(DEFAULT_STROKE);
	        }
	    },

	    rawBBox: function() {
	        return this._geometry.bbox();
	    },

	    _bbox: function(matrix) {
	        return this._geometry.bbox(matrix);
	    },

	    _containsPoint: function(point) {
	        return this.geometry().containsPoint(point);
	    },

	    _isOnPath: function(point) {
	        return this.geometry()._isOnPath(point, this.options.stroke.width / 2);
	    }
	});

	Circle$1.prototype.nodeType = "Circle";

	Paintable.extend(Circle$1.prototype);
	Measurable.extend(Circle$1.prototype);
	defineGeometryAccessors(Circle$1.prototype, [ "geometry" ]);

	var push = [].push;
	var pop = [].pop;
	var splice = [].splice;
	var shift = [].shift;
	var slice = [].slice;
	var unshift = [].unshift;

	var ElementsArray = Class.extend({
	    init: function(array) {
	        if (array === void 0) { array = []; }

	        this.length = 0;
	        this._splice(0, array.length, array);
	    },

	    elements: function(value) {
	        if (value) {
	            this._splice(0, this.length, value);

	            this._change();
	            return this;
	        }

	        return this.slice(0);
	    },

	    push: function() {
	        var elements = arguments;
	        var result = push.apply(this, elements);

	        this._add(elements);

	        return result;
	    },

	    slice: function() {
	        return slice.call(this);
	    },

	    pop: function() {
	        var length = this.length;
	        var result = pop.apply(this);

	        if (length) {
	            this._remove([ result ]);
	        }

	        return result;
	    },

	    splice: function(index, howMany) {
	        var elements = slice.call(arguments, 2);
	        var result = this._splice(index, howMany, elements);

	        this._change();

	        return result;
	    },

	    shift: function() {
	        var length = this.length;
	        var result = shift.apply(this);

	        if (length) {
	            this._remove([ result ]);
	        }

	        return result;
	    },

	    unshift: function() {
	        var elements = arguments;
	        var result = unshift.apply(this, elements);

	        this._add(elements);

	        return result;
	    },

	    indexOf: function(element) {
	        var this$1 = this;

	        var length = this.length;

	        for (var idx = 0; idx < length; idx++) {
	            if (this$1[idx] === element) {
	                return idx;
	            }
	        }
	        return -1;
	    },

	    _splice: function(index, howMany, elements) {
	        var result = splice.apply(this, [ index, howMany ].concat(elements));

	        this._clearObserver(result);
	        this._setObserver(elements);

	        return result;
	    },

	    _add: function(elements) {
	        this._setObserver(elements);
	        this._change();
	    },

	    _remove: function(elements) {
	        this._clearObserver(elements);
	        this._change();
	    },

	    _setObserver: function(elements) {
	        var this$1 = this;

	        for (var idx = 0; idx < elements.length; idx++) {
	            elements[idx].addObserver(this$1);
	        }
	    },

	    _clearObserver: function(elements) {
	        var this$1 = this;

	        for (var idx = 0; idx < elements.length; idx++) {
	            elements[idx].removeObserver(this$1);
	        }
	    },

	    _change: function() {}
	});

	ObserversMixin.extend(ElementsArray.prototype);

	var GeometryElementsArray = ElementsArray.extend({
	    _change: function() {
	        this.geometryChange();
	    }
	});

	function elementsBoundingBox(elements, applyTransform, transformation) {
	    var boundingBox;

	    for (var i = 0; i < elements.length; i++) {
	        var element = elements[i];
	        if (element.visible()) {
	            var elementBoundingBox = applyTransform ? element.bbox(transformation) : element.rawBBox();
	            if (elementBoundingBox) {
	                if (boundingBox) {
	                    boundingBox = Rect.union(boundingBox, elementBoundingBox);
	                } else {
	                    boundingBox = elementBoundingBox;
	                }
	            }
	        }
	    }

	    return boundingBox;
	}

	function elementsClippedBoundingBox(elements, transformation) {
	    var boundingBox;

	    for (var i = 0; i < elements.length; i++) {
	        var element = elements[i];
	        if (element.visible()) {
	            var elementBoundingBox = element.clippedBBox(transformation);
	            if (elementBoundingBox) {
	                if (boundingBox) {
	                    boundingBox = Rect.union(boundingBox, elementBoundingBox);
	                } else {
	                    boundingBox = elementBoundingBox;
	                }
	            }
	        }
	    }

	    return boundingBox;
	}

	var MultiPath = Element$1.extend({
	    init: function(options) {
	        Element$1.fn.init.call(this, options);
	        this.paths = new GeometryElementsArray();
	        this.paths.addObserver(this);

	        if (!defined(this.options.stroke)) {
	            this.stroke("#000");
	        }
	    },

	    moveTo: function(x, y) {
	        var path = new Path();
	        path.moveTo(x, y);

	        this.paths.push(path);

	        return this;
	    },

	    lineTo: function(x, y) {
	        if (this.paths.length > 0) {
	            last(this.paths).lineTo(x, y);
	        }

	        return this;
	    },

	    curveTo: function(controlOut, controlIn, point) {
	        if (this.paths.length > 0) {
	            last(this.paths).curveTo(controlOut, controlIn, point);
	        }

	        return this;
	    },

	    arc: function(startAngle, endAngle, radiusX, radiusY, anticlockwise) {
	        if (this.paths.length > 0) {
	            last(this.paths).arc(startAngle, endAngle, radiusX, radiusY, anticlockwise);
	        }

	        return this;
	    },

	    arcTo: function(end, rx, ry, largeArc, swipe, rotation) {
	        if (this.paths.length > 0) {
	            last(this.paths).arcTo(end, rx, ry, largeArc, swipe, rotation);
	        }

	        return this;
	    },

	    close: function() {
	        if (this.paths.length > 0) {
	            last(this.paths).close();
	        }

	        return this;
	    },

	    _bbox: function(matrix) {
	        return elementsBoundingBox(this.paths, true, matrix);
	    },

	    rawBBox: function() {
	        return elementsBoundingBox(this.paths, false);
	    },

	    _containsPoint: function(point) {
	        var paths = this.paths;

	        for (var idx = 0; idx < paths.length; idx++) {
	            if (paths[idx]._containsPoint(point)) {
	                return true;
	            }
	        }
	        return false;
	    },

	    _isOnPath: function(point) {
	        var paths = this.paths;
	        var width = this.options.stroke.width;

	        for (var idx = 0; idx < paths.length; idx++) {
	            if (paths[idx]._isOnPath(point, width)) {
	                return true;
	            }
	        }
	        return false;
	    },

	    _clippedBBox: function(transformation) {
	        return elementsClippedBoundingBox(this.paths, this.currentTransform(transformation));
	    }
	});

	MultiPath.prototype.nodeType = "MultiPath";

	Paintable.extend(MultiPath.prototype);
	Measurable.extend(MultiPath.prototype);

	var ShapeMap = {
	    l: function(path, options) {
	        var parameters = options.parameters;
	        var position = options.position;

	        for (var i = 0; i < parameters.length; i += 2) {
	            var point = new Point(parameters[i], parameters[i + 1]);

	            if (options.isRelative) {
	                point.translateWith(position);
	            }

	            path.lineTo(point.x, point.y);

	            position.x = point.x;
	            position.y = point.y;
	        }
	    },

	    c: function(path, options) {
	        var parameters = options.parameters;
	        var position = options.position;

	        for (var i = 0; i < parameters.length; i += 6) {
	            var controlOut = new Point(parameters[i], parameters[i + 1]);
	            var controlIn = new Point(parameters[i + 2], parameters[i + 3]);
	            var point = new Point(parameters[i + 4], parameters[i + 5]);
	            if (options.isRelative) {
	                controlIn.translateWith(position);
	                controlOut.translateWith(position);
	                point.translateWith(position);
	            }

	            path.curveTo(controlOut, controlIn, point);

	            position.x = point.x;
	            position.y = point.y;
	        }
	    },

	    v: function(path, options) {
	        var value = options.isRelative ? 0 : options.position.x;

	        toLineParamaters(options.parameters, true, value);
	        this.l(path, options);
	    },

	    h: function(path, options) {
	        var value = options.isRelative ? 0 : options.position.y;

	        toLineParamaters(options.parameters, false, value);
	        this.l(path, options);
	    },

	    a: function(path, options) {
	        var parameters = options.parameters;
	        var position = options.position;

	        for (var i = 0; i < parameters.length; i += 7) {
	            var radiusX = parameters[i];
	            var radiusY = parameters[i + 1];
	            var rotation = parameters[i + 2];
	            var largeArc = parameters[i + 3];
	            var swipe = parameters[i + 4];
	            var endPoint = new Point(parameters[i + 5], parameters[i + 6]);

	            if (options.isRelative) {
	                endPoint.translateWith(position);
	            }
	            if (position.x !== endPoint.x || position.y !== endPoint.y) {
	                path.arcTo(endPoint, radiusX, radiusY, largeArc, swipe, rotation);

	                position.x = endPoint.x;
	                position.y = endPoint.y;
	            }
	        }
	    },

	    s: function(path, options) {
	        var parameters = options.parameters;
	        var position = options.position;
	        var previousCommand = options.previousCommand;
	        var lastControlIn;

	        if (previousCommand === "s" || previousCommand === "c") {
	            lastControlIn = last(last(path.paths).segments).controlIn();
	        }

	        for (var i = 0; i < parameters.length; i += 4) {
	            var controlIn = new Point(parameters[i], parameters[i + 1]);
	            var endPoint = new Point(parameters[i + 2], parameters[i + 3]);
	            var controlOut = (void 0);

	            if (options.isRelative) {
	                controlIn.translateWith(position);
	                endPoint.translateWith(position);
	            }

	            if (lastControlIn) {
	                controlOut = reflectionPoint(lastControlIn, position);
	            } else {
	                controlOut = position.clone();
	            }

	            lastControlIn = controlIn;

	            path.curveTo(controlOut, controlIn, endPoint);

	            position.x = endPoint.x;
	            position.y = endPoint.y;
	        }
	    },

	    q: function(path, options) {
	        var parameters = options.parameters;
	        var position = options.position;

	        for (var i = 0; i < parameters.length; i += 4) {
	            var controlPoint = new Point(parameters[i], parameters[i + 1]);
	            var endPoint = new Point(parameters[i + 2], parameters[i + 3]);

	            if (options.isRelative) {
	                controlPoint.translateWith(position);
	                endPoint.translateWith(position);
	            }

	            var cubicControlPoints = quadraticToCubicControlPoints(position, controlPoint, endPoint);

	            path.curveTo(cubicControlPoints.controlOut, cubicControlPoints.controlIn, endPoint);

	            position.x = endPoint.x;
	            position.y = endPoint.y;
	        }
	    },

	    t: function(path, options) {
	        var parameters = options.parameters;
	        var position = options.position;
	        var previousCommand = options.previousCommand;
	        var controlPoint;

	        if (previousCommand === "q" || previousCommand === "t") {
	            var lastSegment = last(last(path.paths).segments);
	            controlPoint = lastSegment.controlIn().clone()
	                .translateWith(position.scaleCopy(-1 / 3))
	                .scale(3 / 2);
	        }

	        for (var i = 0; i < parameters.length; i += 2) {
	            var endPoint = new Point(parameters[i], parameters[i + 1]);
	            if (options.isRelative) {
	                endPoint.translateWith(position);
	            }

	            if (controlPoint) {
	                controlPoint = reflectionPoint(controlPoint, position);
	            } else {
	                controlPoint = position.clone();
	            }

	            var cubicControlPoints = quadraticToCubicControlPoints(position, controlPoint, endPoint);

	            path.curveTo(cubicControlPoints.controlOut, cubicControlPoints.controlIn, endPoint);

	            position.x = endPoint.x;
	            position.y = endPoint.y;
	        }
	    }
	};

	function toLineParamaters(parameters, isVertical, value) {
	    var insertPosition = isVertical ? 0 : 1;

	    for (var i = 0; i < parameters.length; i += 2) {
	        parameters.splice(i + insertPosition, 0, value);
	    }
	}

	function reflectionPoint(point, center) {
	    if (point && center) {
	        return center.scaleCopy(2).translate(-point.x, -point.y);
	    }
	}

	var third = 1 / 3;

	function quadraticToCubicControlPoints(position, controlPoint, endPoint) {
	    var scaledPoint = controlPoint.clone().scale(2 / 3);
	    return {
	        controlOut: scaledPoint.clone().translateWith(position.scaleCopy(third)),
	        controlIn: scaledPoint.translateWith(endPoint.scaleCopy(third))
	    };
	}

	var SEGMENT_REGEX = /([a-df-z]{1})([^a-df-z]*)(z)?/gi;
	var SPLIT_REGEX = /[,\s]?([+\-]?(?:\d*\.\d+|\d+)(?:[eE][+\-]?\d+)?)/g;
	var MOVE = "m";
	var CLOSE = "z";

	function parseParameters(str) {
	    var parameters = [];
	    str.replace(SPLIT_REGEX, function(match, number) {
	        parameters.push(parseFloat(number));
	    });
	    return parameters;
	}

	var PathParser = Class.extend({
	    parse: function(str, options) {
	        var multiPath = new MultiPath(options);
	        var position = new Point();
	        var previousCommand;

	        str.replace(SEGMENT_REGEX, function (match, element, params, closePath) {
	            var command = element.toLowerCase();
	            var isRelative = command === element;
	            var parameters = parseParameters(params.trim());

	            if (command === MOVE) {
	                if (isRelative) {
	                    position.x += parameters[0];
	                    position.y += parameters[1];
	                } else {
	                    position.x = parameters[0];
	                    position.y = parameters[1];
	                }

	                multiPath.moveTo(position.x, position.y);

	                if (parameters.length > 2) {
	                    command = "l";
	                    parameters.splice(0, 2);
	                }
	            }

	            if (ShapeMap[command]) {
	                ShapeMap[command](
	                    multiPath, {
	                        parameters: parameters,
	                        position: position,
	                        isRelative: isRelative,
	                        previousCommand: previousCommand
	                    }
	                );

	                if (closePath && closePath.toLowerCase() === CLOSE) {
	                    multiPath.close();
	                }
	            } else if (command !== MOVE) {
	                throw new Error("Error while parsing SVG path. Unsupported command: " + command);
	            }

	            previousCommand = command;
	        });

	        return multiPath;
	    }
	});

	PathParser.current = new PathParser();

	var Path = Element$1.extend({
	    init: function(options) {
	        Element$1.fn.init.call(this, options);
	        this.segments = new GeometryElementsArray();
	        this.segments.addObserver(this);

	        if (!defined(this.options.stroke)) {
	            this.stroke("#000");

	            if (!defined(this.options.stroke.lineJoin)) {
	                this.options.set("stroke.lineJoin", "miter");
	            }
	        }
	    },

	    moveTo: function(x, y) {
	        this.suspend();
	        this.segments.elements([]);
	        this.resume();

	        this.lineTo(x, y);

	        return this;
	    },

	    lineTo: function(x, y) {
	        var point = defined(y) ? new Point(x, y) : x;
	        var segment = new Segment(point);

	        this.segments.push(segment);

	        return this;
	    },

	    curveTo: function(controlOut, controlIn, point) {
	        if (this.segments.length > 0) {
	            var lastSegment = last(this.segments);
	            var segment = new Segment(point, controlIn);
	            this.suspend();
	            lastSegment.controlOut(controlOut);
	            this.resume();

	            this.segments.push(segment);
	        }

	        return this;
	    },

	    arc: function(startAngle, endAngle, radiusX, radiusY, anticlockwise) {
	        if (this.segments.length > 0) {
	            var lastSegment = last(this.segments);
	            var anchor = lastSegment.anchor();
	            var start = rad(startAngle);
	            var center = new Point(anchor.x - radiusX * Math.cos(start),
	                anchor.y - radiusY * Math.sin(start));
	            var arc = new Arc(center, {
	                startAngle: startAngle,
	                endAngle: endAngle,
	                radiusX: radiusX,
	                radiusY: radiusY,
	                anticlockwise: anticlockwise
	            });

	            this._addArcSegments(arc);
	        }

	        return this;
	    },

	    arcTo: function(end, rx, ry, largeArc, swipe, rotation) {
	        if (this.segments.length > 0) {
	            var lastSegment = last(this.segments);
	            var anchor = lastSegment.anchor();
	            var arc = Arc.fromPoints(anchor, end, rx, ry, largeArc, swipe, rotation);

	            this._addArcSegments(arc);
	        }
	        return this;
	    },

	    _addArcSegments: function(arc) {
	        var this$1 = this;

	        this.suspend();

	        var curvePoints = arc.curvePoints();

	        for (var i = 1; i < curvePoints.length; i += 3) {
	            this$1.curveTo(curvePoints[i], curvePoints[i + 1], curvePoints[i + 2]);
	        }

	        this.resume();
	        this.geometryChange();
	    },

	    close: function() {
	        this.options.closed = true;
	        this.geometryChange();

	        return this;
	    },

	    rawBBox: function() {
	        return this._bbox();
	    },

	    _containsPoint: function(point) {
	        var segments = this.segments;
	        var length = segments.length;
	        var intersectionsCount = 0;
	        var previous, current;

	        for (var idx = 1; idx < length; idx++) {
	            previous = segments[idx - 1];
	            current = segments[idx];
	            intersectionsCount += previous._intersectionsTo(current, point);
	        }

	        if (this.options.closed || !segments[0].anchor().equals(segments[length - 1].anchor())) {
	            intersectionsCount += lineIntersectionsCount(segments[0].anchor(), segments[length - 1].anchor(), point);
	        }

	        return intersectionsCount % 2 !== 0;
	    },

	    _isOnPath: function(point, width) {
	        var segments = this.segments;
	        var length = segments.length;
	        var pathWidth = width || this.options.stroke.width;

	        if (length > 1) {
	            if (segments[0]._isOnPathTo(segments[1], point, pathWidth, "start")) {
	                return true;
	            }

	            for (var idx = 2; idx <= length - 2; idx++) {
	                if (segments[idx - 1]._isOnPathTo(segments[idx], point, pathWidth)) {
	                    return true;
	                }
	            }

	            if (segments[length - 2]._isOnPathTo(segments[length - 1], point, pathWidth, "end")) {
	                return true;
	            }
	        }
	        return false;
	    },

	    _bbox: function(matrix) {
	        var segments = this.segments;
	        var length = segments.length;
	        var boundingBox;

	        if (length === 1) {
	            var anchor = segments[0].anchor().transformCopy(matrix);
	            boundingBox = new Rect(anchor, Size.ZERO);
	        } else if (length > 0) {
	            for (var i = 1; i < length; i++) {
	                var segmentBox = segments[i - 1].bboxTo(segments[i], matrix);
	                if (boundingBox) {
	                    boundingBox = Rect.union(boundingBox, segmentBox);
	                } else {
	                    boundingBox = segmentBox;
	                }
	            }
	        }

	        return boundingBox;
	    }
	});

	Path.fromRect = function(rect, options) {
	    return new Path(options)
	        .moveTo(rect.topLeft())
	        .lineTo(rect.topRight())
	        .lineTo(rect.bottomRight())
	        .lineTo(rect.bottomLeft())
	        .close();
	};

	Path.fromPoints = function(points, options) {
	    if (points) {
	        var path = new Path(options);

	        for (var i = 0; i < points.length; i++) {
	            var point = Point.create(points[i]);
	            if (point) {
	                if (i === 0) {
	                    path.moveTo(point);
	                } else {
	                    path.lineTo(point);
	                }
	            }
	        }

	        return path;
	    }
	};

	Path.fromArc = function(arc, options) {
	    var path = new Path(options);
	    var startAngle = arc.startAngle;
	    var start = arc.pointAt(startAngle);
	    path.moveTo(start.x, start.y);
	    path.arc(startAngle, arc.endAngle, arc.radiusX, arc.radiusY, arc.anticlockwise);
	    return path;
	};

	Path.prototype.nodeType = "Path";

	Paintable.extend(Path.prototype);
	Measurable.extend(Path.prototype);

	Path.parse = function(str, options) {
	    return PathParser.current.parse(str, options);
	};

	var DEFAULT_STROKE$1 = "#000";

	var Arc$2 = Element$1.extend({
	    init: function(geometry, options) {
	        if (geometry === void 0) { geometry = new Arc(); }
	        if (options === void 0) { options = {}; }

	        Element$1.fn.init.call(this, options);

	        this.geometry(geometry);

	        if (!defined(this.options.stroke)) {
	            this.stroke(DEFAULT_STROKE$1);
	        }
	    },

	    _bbox: function(matrix) {
	        return this._geometry.bbox(matrix);
	    },

	    rawBBox: function() {
	        return this.geometry().bbox();
	    },

	    toPath: function() {
	        var path = new Path();
	        var curvePoints = this.geometry().curvePoints();

	        if (curvePoints.length > 0) {
	            path.moveTo(curvePoints[0].x, curvePoints[0].y);

	            for (var i = 1; i < curvePoints.length; i += 3) {
	                path.curveTo(curvePoints[i], curvePoints[i + 1], curvePoints[i + 2]);
	            }
	        }

	        return path;
	    },

	    _containsPoint: function(point) {
	        return this.geometry().containsPoint(point);
	    },

	    _isOnPath: function(point) {
	        return this.geometry()._isOnPath(point, this.options.stroke.width / 2);
	    }
	});

	Arc$2.prototype.nodeType = "Arc";

	Paintable.extend(Arc$2.prototype);
	Measurable.extend(Arc$2.prototype);
	defineGeometryAccessors(Arc$2.prototype, [ "geometry" ]);

	var DEFAULT_FONT = "12px sans-serif";
	var DEFAULT_FILL = "#000";

	var Text = Element$1.extend({
	    init: function(content, position, options) {
	        if (position === void 0) { position = new Point(); }
	        if (options === void 0) { options = {}; }

	        Element$1.fn.init.call(this, options);

	        this.content(content);
	        this.position(position);

	        if (!this.options.font) {
	            this.options.font = DEFAULT_FONT;
	        }

	        if (!defined(this.options.fill)) {
	            this.fill(DEFAULT_FILL);
	        }
	    },

	    content: function(value) {
	        if (defined(value)) {
	            this.options.set("content", value);
	            return this;
	        }

	        return this.options.get("content");
	    },

	    measure: function() {
	        var metrics = kendoUtil.measureText(this.content(), {
	            font: this.options.get("font")
	        });

	        return metrics;
	    },

	    rect: function() {
	        var size = this.measure();
	        var pos = this.position().clone();
	        return new Rect(pos, [ size.width, size.height ]);
	    },

	    bbox: function(transformation) {
	        var combinedMatrix = toMatrix(this.currentTransform(transformation));
	        return this.rect().bbox(combinedMatrix);
	    },

	    rawBBox: function() {
	        return this.rect().bbox();
	    },

	    _containsPoint: function(point) {
	        return this.rect().containsPoint(point);
	    }
	});

	Text.prototype.nodeType = "Text";

	Paintable.extend(Text.prototype);

	definePointAccessors(Text.prototype, [ "position" ]);

	var Image$1 = Element$1.extend({
	    init: function(src, rect, options) {
	        if (rect === void 0) { rect = new Rect(); }
	        if (options === void 0) { options = {}; }

	        Element$1.fn.init.call(this, options);

	        this.src(src);
	        this.rect(rect);
	    },

	    src: function(value) {
	        if (defined(value)) {
	            this.options.set("src", value);
	            return this;
	        }

	        return this.options.get("src");
	    },

	    bbox: function(transformation) {
	        var combinedMatrix = toMatrix(this.currentTransform(transformation));
	        return this._rect.bbox(combinedMatrix);
	    },

	    rawBBox: function() {
	        return this._rect.bbox();
	    },

	    _containsPoint: function(point) {
	        return this._rect.containsPoint(point);
	    },

	    _hasFill: function() {
	        return this.src();
	    }
	});

	Image$1.prototype.nodeType = "Image";

	defineGeometryAccessors(Image$1.prototype, [ "rect" ]);

	var Traversable = {
	    extend: function(proto, childrenField) {
	        proto.traverse = function(callback) {
	            var children = this[childrenField];

	            for (var i = 0; i < children.length; i++) {
	                var child = children[i];

	                if (child.traverse) {
	                    child.traverse(callback);
	                } else {
	                    callback(child);
	                }
	            }

	            return this;
	        };
	    }
	};

	var Group = Element$1.extend({
	    init: function(options) {
	        Element$1.fn.init.call(this, options);
	        this.children = [];
	    },

	    childrenChange: function(action, items, index) {
	        this.trigger("childrenChange",{
	            action: action,
	            items: items,
	            index: index
	        });
	    },

	    append: function() {
	        append(this.children, arguments);
	        this._reparent(arguments, this);

	        this.childrenChange("add", arguments);

	        return this;
	    },

	    insert: function(index, element) {
	        this.children.splice(index, 0, element);
	        element.parent = this;

	        this.childrenChange("add", [ element ], index);

	        return this;
	    },

	    insertAt: function(element, index) {
	        return this.insert(index, element);
	    },

	    remove: function(element) {
	        var index = this.children.indexOf(element);
	        if (index >= 0) {
	            this.children.splice(index, 1);
	            element.parent = null;
	            this.childrenChange("remove", [ element ], index);
	        }

	        return this;
	    },

	    removeAt: function(index) {
	        if (0 <= index && index < this.children.length) {
	            var element = this.children[index];
	            this.children.splice(index, 1);
	            element.parent = null;
	            this.childrenChange("remove", [ element ], index);
	        }

	        return this;
	    },

	    clear: function() {
	        var items = this.children;
	        this.children = [];
	        this._reparent(items, null);

	        this.childrenChange("remove", items, 0);

	        return this;
	    },

	    bbox: function(transformation) {
	        return elementsBoundingBox(this.children, true, this.currentTransform(transformation));
	    },

	    rawBBox: function() {
	        return elementsBoundingBox(this.children, false);
	    },

	    _clippedBBox: function(transformation) {
	        return elementsClippedBoundingBox(this.children, this.currentTransform(transformation));
	    },

	    currentTransform: function(transformation) {
	        return Element$1.prototype.currentTransform.call(this, transformation) || null;
	    },

	    containsPoint: function(point, parentTransform) {
	        if (this.visible()) {
	            var children = this.children;
	            var transform = this.currentTransform(parentTransform);
	            for (var idx = 0; idx < children.length; idx++) {
	                if (children[idx].containsPoint(point, transform)) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    },

	    _reparent: function(elements, newParent) {
	        var this$1 = this;

	        for (var i = 0; i < elements.length; i++) {
	            var child = elements[i];
	            var parent = child.parent;
	            if (parent && parent !== this$1 && parent.remove) {
	                parent.remove(child);
	            }

	            child.parent = newParent;
	        }
	    }
	});

	Group.prototype.nodeType = "Group";

	Traversable.extend(Group.prototype, "children");

	function translateToPoint(point, bbox, element) {
	    var transofrm = element.transform() || transform();
	    var matrix = transofrm.matrix();
	    matrix.e += point.x - bbox.origin.x;
	    matrix.f += point.y - bbox.origin.y;

	    transofrm.matrix(matrix);
	    element.transform(transofrm);
	}

	function alignStart(size, rect, align, axis, sizeField) {
	    var start;
	    if (align === "start") {
	        start = rect.origin[axis];
	    } else if (align === "end") {
	        start = rect.origin[axis] + rect.size[sizeField] - size;
	    } else {
	        start = rect.origin[axis] + (rect.size[sizeField] - size) / 2;
	    }

	    return start;
	}

	function alignStartReverse(size, rect, align, axis, sizeField) {
	    var start;
	    if (align === "start") {
	        start = rect.origin[axis] + rect.size[sizeField] - size;
	    } else if (align === "end") {
	        start = rect.origin[axis];
	    } else {
	        start = rect.origin[axis] + (rect.size[sizeField] - size) / 2;
	    }

	    return start;
	}

	var DEFAULT_OPTIONS = {
	    alignContent: "start",
	    justifyContent: "start",
	    alignItems: "start",
	    spacing: 0,
	    orientation: "horizontal",
	    lineSpacing: 0,
	    wrap: true,
	    revers: false
	};

	var forEach = function (elements, callback) {
	    elements.forEach(callback);
	};

	var forEachReverse = function (elements, callback) {
	    var length = elements.length;

	    for (var idx = length - 1; idx >= 0; idx--) {
	        callback(elements[idx], idx);
	    }
	};

	var Layout = Group.extend({
	    init: function(rect, options) {
	        Group.fn.init.call(this, $.extend({}, DEFAULT_OPTIONS, options));
	        this._rect = rect;
	        this._fieldMap = {};
	    },

	    rect: function(value) {
	        if (value) {
	            this._rect = value;
	            return this;
	        }

	        return this._rect;
	    },

	    _initMap: function() {
	        var options = this.options;
	        var fieldMap = this._fieldMap;
	        if (options.orientation === "horizontal") {
	            fieldMap.sizeField = "width";
	            fieldMap.groupsSizeField = "height";
	            fieldMap.groupAxis = "x";
	            fieldMap.groupsAxis = "y";
	        } else {
	            fieldMap.sizeField = "height";
	            fieldMap.groupsSizeField = "width";
	            fieldMap.groupAxis = "y";
	            fieldMap.groupsAxis = "x";
	        }

	        if (options.reverse) {
	            this.forEach = forEachReverse;
	            this.justifyAlign = alignStartReverse;
	        } else {
	            this.forEach = forEach;
	            this.justifyAlign = alignStart;
	        }
	    },

	    reflow: function() {
	        var this$1 = this;

	        if (!this._rect || this.children.length === 0) {
	            return;
	        }
	        this._initMap();

	        if (this.options.transform) {
	            this.transform(null);
	        }

	        var options = this.options;
	        var rect = this._rect;
	        var ref = this._initGroups();
	        var groups = ref.groups;
	        var groupsSize = ref.groupsSize;
	        var ref$1 = this._fieldMap;
	        var sizeField = ref$1.sizeField;
	        var groupsSizeField = ref$1.groupsSizeField;
	        var groupAxis = ref$1.groupAxis;
	        var groupsAxis = ref$1.groupsAxis;
	        var groupOrigin = new Point();
	        var elementOrigin = new Point();
	        var size = new Size();
	        var groupStart = alignStart(groupsSize, rect, options.alignContent, groupsAxis, groupsSizeField);
	        var elementStart, group, groupBox;

	        var arrangeElements = function (bbox, idx) {
	            var element = group.elements[idx];

	            elementOrigin[groupAxis] = elementStart;
	            elementOrigin[groupsAxis] = alignStart(bbox.size[groupsSizeField], groupBox, options.alignItems, groupsAxis, groupsSizeField);
	            translateToPoint(elementOrigin, bbox, element);
	            elementStart += bbox.size[sizeField] + options.spacing;
	        };

	        for (var groupIdx = 0; groupIdx < groups.length; groupIdx++) {
	            group = groups[groupIdx];
	            groupOrigin[groupAxis] = elementStart = this$1.justifyAlign(group.size, rect, options.justifyContent, groupAxis, sizeField);
	            groupOrigin[groupsAxis] = groupStart;
	            size[sizeField] = group.size;
	            size[groupsSizeField] = group.lineSize;
	            groupBox = new Rect(groupOrigin, size);
	            this$1.forEach(group.bboxes, arrangeElements);

	            groupStart += group.lineSize + options.lineSpacing;
	        }

	        if (!options.wrap && group.size > rect.size[sizeField]) {
	            var scale = rect.size[sizeField] / groupBox.size[sizeField];
	            var scaledStart = groupBox.topLeft().scale(scale, scale);
	            var scaledSize = groupBox.size[groupsSizeField] * scale;
	            var newStart = alignStart(scaledSize, rect, options.alignContent, groupsAxis, groupsSizeField);
	            var transform$$1 = transform();
	            if (groupAxis === "x") {
	                transform$$1.translate(rect.origin.x - scaledStart.x, newStart - scaledStart.y);
	            } else {
	                transform$$1.translate(newStart - scaledStart.x, rect.origin.y - scaledStart.y);
	            }
	            transform$$1.scale(scale, scale);

	            this.transform(transform$$1);
	        }
	    },

	    _initGroups: function() {
	        var this$1 = this;

	        var ref = this;
	        var options = ref.options;
	        var children = ref.children;
	        var lineSpacing = options.lineSpacing;
	        var wrap = options.wrap;
	        var spacing = options.spacing;
	        var sizeField = this._fieldMap.sizeField;
	        var group = this._newGroup();
	        var groups = [];
	        var addGroup = function() {
	            groups.push(group);
	            groupsSize += group.lineSize + lineSpacing;
	        };
	        var groupsSize = -lineSpacing;

	        for (var idx = 0; idx < children.length; idx++) {
	            var element = children[idx];
	            var bbox = children[idx].clippedBBox();
	            if (element.visible() && bbox) {
	                if (wrap && group.size + bbox.size[sizeField] + spacing > this$1._rect.size[sizeField]) {
	                    if (group.bboxes.length === 0) {
	                        this$1._addToGroup(group, bbox, element);
	                        addGroup();
	                        group = this$1._newGroup();
	                    } else {
	                        addGroup();
	                        group = this$1._newGroup();
	                        this$1._addToGroup(group, bbox, element);
	                    }
	                } else {
	                    this$1._addToGroup(group, bbox, element);
	                }
	            }
	        }

	        if (group.bboxes.length) {
	            addGroup();
	        }

	        return {
	            groups: groups,
	            groupsSize: groupsSize
	        };
	    },

	    _addToGroup: function(group, bbox, element) {
	        group.size += bbox.size[this._fieldMap.sizeField] + this.options.spacing;
	        group.lineSize = Math.max(bbox.size[this._fieldMap.groupsSizeField], group.lineSize);
	        group.bboxes.push(bbox);
	        group.elements.push(element);
	    },

	    _newGroup: function() {
	        return {
	            lineSize: 0,
	            size: -this.options.spacing,
	            bboxes: [],
	            elements: []
	        };
	    }
	});

	var Rect$2 = Element$1.extend({
	    init: function(geometry, options) {
	        if (geometry === void 0) { geometry = new Rect(); }
	        if (options === void 0) { options = {}; }

	        Element$1.fn.init.call(this, options);
	        this.geometry(geometry);

	        if (!defined(this.options.stroke)) {
	            this.stroke("#000");
	        }
	    },

	    _bbox: function(matrix) {
	        return this._geometry.bbox(matrix);
	    },

	    rawBBox: function() {
	        return this._geometry.bbox();
	    },

	    _containsPoint: function(point) {
	        return this._geometry.containsPoint(point);
	    },

	    _isOnPath: function(point) {
	        return this.geometry()._isOnPath(point, this.options.stroke.width / 2);
	    }
	});

	Rect$2.prototype.nodeType = "Rect";

	Paintable.extend(Rect$2.prototype);
	Measurable.extend(Rect$2.prototype);
	defineGeometryAccessors(Rect$2.prototype, [ "geometry" ]);

	function alignElements(elements, rect, alignment, axis, sizeField) {
	    for (var idx = 0; idx < elements.length; idx++) {
	        var bbox = elements[idx].clippedBBox();
	        if (bbox) {
	            var point = bbox.origin.clone();
	            point[axis] = alignStart(bbox.size[sizeField], rect, alignment || "start", axis, sizeField);
	            translateToPoint(point, bbox, elements[idx]);
	        }
	    }
	}

	function align(elements, rect, alignment) {
	    alignElements(elements, rect, alignment, "x", "width");
	}

	function vAlign(elements, rect, alignment) {
	    alignElements(elements, rect, alignment, "y", "height");
	}

	function stackElements(elements, stackAxis, otherAxis, sizeField) {
	    if (elements.length > 1) {
	        var origin = new Point();
	        var previousBBox = elements[0].bbox;

	        for (var idx = 1; idx < elements.length; idx++) {
	            var element = elements[idx].element;
	            var bbox = elements[idx].bbox;
	            origin[stackAxis] = previousBBox.origin[stackAxis] + previousBBox.size[sizeField];
	            origin[otherAxis] = bbox.origin[otherAxis];
	            translateToPoint(origin, bbox, element);
	            bbox.origin[stackAxis] = origin[stackAxis];
	            previousBBox = bbox;
	        }
	    }
	}

	function createStackElements(elements) {
	    var stackElements = [];

	    for (var idx = 0; idx < elements.length; idx++) {
	        var element = elements[idx];
	        var bbox = element.clippedBBox();
	        if (bbox) {
	            stackElements.push({
	                element: element,
	                bbox: bbox
	            });
	        }
	    }

	    return stackElements;
	}

	function stack(elements) {
	    stackElements(createStackElements(elements), "x", "y", "width");
	}

	function vStack(elements) {
	    stackElements(createStackElements(elements), "y", "x", "height");
	}

	function getStacks(elements, rect, sizeField) {
	    var maxSize = rect.size[sizeField];
	    var stacks = [];
	    var stack = [];
	    var stackSize = 0;
	    var element, bbox;

	    var addElementToStack = function() {
	        stack.push({
	            element: element,
	            bbox: bbox
	        });
	    };

	    for (var idx = 0; idx < elements.length; idx++) {
	        element = elements[idx];

	        bbox = element.clippedBBox();
	        if (bbox) {
	            var size = bbox.size[sizeField];
	            if (stackSize + size > maxSize) {
	                if (stack.length) {
	                    stacks.push(stack);
	                    stack = [];
	                    addElementToStack();
	                    stackSize = size;
	                } else {
	                    addElementToStack();
	                    stacks.push(stack);
	                    stack = [];
	                    stackSize = 0;
	                }
	            } else {
	                addElementToStack();
	                stackSize += size;
	            }
	        }
	    }

	    if (stack.length) {
	        stacks.push(stack);
	    }

	    return stacks;
	}

	function wrapElements(elements, rect, axis, otherAxis, sizeField) {
	    var stacks = getStacks(elements, rect, sizeField);
	    var origin = rect.origin.clone();
	    var result = [];

	    for (var idx = 0; idx < stacks.length; idx++) {
	        var stack = stacks[idx];
	        var startElement = stack[0];
	        origin[otherAxis] = startElement.bbox.origin[otherAxis];
	        translateToPoint(origin, startElement.bbox, startElement.element);
	        startElement.bbox.origin[axis] = origin[axis];
	        stackElements(stack, axis, otherAxis, sizeField);
	        result.push([]);
	        for (var elementIdx = 0; elementIdx < stack.length; elementIdx++) {
	            result[idx].push(stack[elementIdx].element);
	        }
	    }
	    return result;
	}

	function wrap(elements, rect) {
	    return wrapElements(elements, rect, "x", "y", "width");
	}

	function vWrap(elements, rect) {
	    return wrapElements(elements, rect, "y", "x", "height");
	}

	function fit(element, rect) {
	    var bbox = element.clippedBBox();
	    if (bbox) {
	        var elementSize = bbox.size;
	        var rectSize = rect.size;
	        if (rectSize.width < elementSize.width || rectSize.height < elementSize.height) {
	            var scale = Math.min(rectSize.width / elementSize.width, rectSize.height / elementSize.height);
	            var transform$$1 = element.transform() || transform();
	            transform$$1.scale(scale, scale);
	            element.transform(transform$$1);
	        }
	    }
	}

	var StopsArray = ElementsArray.extend({
	    _change: function() {
	        this.optionsChange({
	            field: "stops"
	        });
	    }
	});

	function optionsAccessor(name) {
	    return function(value) {
	        if (defined(value)) {
	            this.options.set(name, value);
	            return this;
	        }

	        return this.options.get(name);
	    };
	}

	function defineOptionsAccessors(fn, names) {
	    for (var i = 0; i < names.length; i++) {
	        fn[names[i]] = optionsAccessor(names[i]);
	    }
	}

	var GradientStop = Class.extend({
	    init: function(offset, color, opacity) {

	        this.options = new OptionsStore({
	            offset: offset,
	            color: color,
	            opacity: defined(opacity) ? opacity : 1
	        });
	        this.options.addObserver(this);
	    }
	});

	GradientStop.create = function(arg) {
	    if (defined(arg)) {
	        var stop;
	        if (arg instanceof GradientStop) {
	            stop = arg;
	        } else if (arg.length > 1) {
	            stop = new GradientStop(arg[0], arg[1], arg[2]);
	        } else {
	            stop = new GradientStop(arg.offset, arg.color, arg.opacity);
	        }

	        return stop;
	    }
	};

	defineOptionsAccessors(GradientStop.prototype, [ "offset", "color", "opacity" ]);
	ObserversMixin.extend(GradientStop.prototype);

	var Gradient = Class.extend({
	    init: function(options) {
	        if (options === void 0) { options = {}; }

	        this.stops = new StopsArray(this._createStops(options.stops));
	        this.stops.addObserver(this);
	        this._userSpace = options.userSpace;
	        this.id = definitionId();
	    },

	    userSpace: function(value) {
	        if (defined(value)) {
	            this._userSpace = value;
	            this.optionsChange();
	            return this;
	        }

	        return this._userSpace;
	    },

	    _createStops: function(stops) {
	        if (stops === void 0) { stops = []; }

	        var result = [];
	        for (var idx = 0; idx < stops.length; idx++) {
	            result.push(GradientStop.create(stops[idx]));
	        }

	        return result;
	    },

	    addStop: function(offset, color, opacity) {
	        this.stops.push(new GradientStop(offset, color, opacity));
	    },

	    removeStop: function(stop) {
	        var index = this.stops.indexOf(stop);
	        if (index >= 0) {
	            this.stops.splice(index, 1);
	        }
	    }
	});

	Gradient.prototype.nodeType = "Gradient";

	ObserversMixin.extend(Gradient.prototype);

	$.extend(Gradient.prototype, {
	    optionsChange: function(e) {
	        this.trigger("optionsChange", {
	            field: "gradient" + (e ? "." + e.field : ""),
	            value: this
	        });
	    },

	    geometryChange: function() {
	        this.optionsChange();
	    }
	});

	var LinearGradient = Gradient.extend({
	    init: function(options) {
	        if (options === void 0) { options = {}; }

	        Gradient.fn.init.call(this, options);

	        this.start(options.start || new Point());

	        this.end(options.end || new Point(1, 0));
	    }
	});

	definePointAccessors(LinearGradient.prototype, [ "start", "end" ]);

	var RadialGradient = Gradient.extend({
	    init: function(options) {
	        if (options === void 0) { options = {}; }

	        Gradient.fn.init.call(this, options);

	        this.center(options.center || new Point());
	        this._radius = defined(options.radius) ? options.radius : 1;
	        this._fallbackFill = options.fallbackFill;
	    },

	    radius: function(value) {
	        if (defined(value)) {
	            this._radius = value;
	            this.geometryChange();
	            return this;
	        }

	        return this._radius;
	    },

	    fallbackFill: function(value) {
	        if (defined(value)) {
	            this._fallbackFill = value;
	            this.optionsChange();
	            return this;
	        }

	        return this._fallbackFill;
	    }
	});

	definePointAccessors(RadialGradient.prototype, [ "center" ]);

	function swing(position) {
	    return 0.5 - Math.cos(position * Math.PI) / 2;
	}

	function linear(position) {
	    return position;
	}

	function easeOutElastic(position, time, start, diff) {
	    var s = 1.70158,
	        p = 0,
	        a = diff;

	    if (position === 0) {
	        return start;
	    }

	    if (position === 1) {
	        return start + diff;
	    }

	    if (!p) {
	        p = 0.5;
	    }

	    if (a < Math.abs(diff)) {
	        a = diff;
	        s = p / 4;
	    } else {
	        s = p / (2 * Math.PI) * Math.asin(diff / a);
	    }

	    return a * Math.pow(2, -10 * position) *
	           Math.sin((Number(position) - s) * (1.1 * Math.PI) / p) + diff + start;
	}

	var easingFunctions = {
		swing: swing,
		linear: linear,
		easeOutElastic: easeOutElastic
	};

	var AnimationFactory = Class.extend({
	    init: function() {

	        this._items = [];
	    },

	    register: function(name, type) {
	        this._items.push({
	            name: name,
	            type: type
	        });
	    },

	    create: function(element, options) {
	        var items = this._items;
	        var match;

	        if (options && options.type) {
	            var type = options.type.toLowerCase();
	            for (var i = 0; i < items.length; i++) {
	                if (items[i].name.toLowerCase() === type) {
	                    match = items[i];
	                    break;
	                }
	            }
	        }

	        if (match) {
	            return new match.type(element, options);
	        }
	    }
	});

	AnimationFactory.current = new AnimationFactory();

	var now = Date.now || function() {
	    return new Date().getTime();
	};

	var Animation = Class.extend({
	    init: function(element, options) {

	        this.options = $.extend({}, this.options, options);
	        this.element = element;
	    },

	    setup: function() {},

	    step: function() {},

	    play: function() {
	        var this$1 = this;

	        var options = this.options;
	        var duration = options.duration;
	        var delay = options.delay; if (delay === void 0) { delay = 0; }
	        var easing = easingFunctions[options.easing];
	        var start = now() + delay;
	        var finish = start + duration;

	        if (duration === 0) {
	            this.step(1);
	            this.abort();
	        } else {
	            setTimeout(function () {
	                var loop = function () {
	                    if (this$1._stopped) {
	                        return;
	                    }

	                    var wallTime = now();

	                    var time = limitValue(wallTime - start, 0, duration);
	                    var position = time / duration;
	                    var easingPosition = easing(position, time, 0, 1, duration);

	                    this$1.step(easingPosition);

	                    if (wallTime < finish) {
	                        kendo.animationFrame(loop);
	                    } else {
	                        this$1.abort();
	                    }
	                };

	                loop();
	            }, delay);
	        }
	    },

	    abort: function() {
	        this._stopped = true;
	    },

	    destroy: function() {
	        this.abort();
	    }
	});

	Animation.prototype.options = {
	    duration: 500,
	    easing: "swing"
	};

	Animation.create = function(type, element, options) {
	    return AnimationFactory.current.create(type, element, options);
	};

	var SurfaceFactory = Class.extend({
	    init: function() {

	        this._items = [];
	    },

	    register: function(name, type, order) {
	        var items = this._items;
	        var first = items[0];
	        var entry = {
	            name: name,
	            type: type,
	            order: order
	        };

	        if (!first || order < first.order) {
	            items.unshift(entry);
	        } else {
	            items.push(entry);
	        }
	    },

	    create: function(element, options) {
	        var items = this._items;
	        var match = items[0];

	        if (options && options.type) {
	            var preferred = options.type.toLowerCase();
	            for (var i = 0; i < items.length; i++) {
	                if (items[i].name === preferred) {
	                    match = items[i];
	                    break;
	                }
	            }
	        }

	        if (match) {
	            return new match.type(element, options);
	        }

	        kendo.logToConsole(
	            "Warning: Unable to create Kendo UI Drawing Surface. Possible causes:\n" +
	            "- The browser does not support SVG and Canvas. User agent: " + (navigator.userAgent));
	    }
	});

	SurfaceFactory.current = new SurfaceFactory();

	var events = [
	    "click",
	    "mouseenter",
	    "mouseleave",
	    "mousemove",
	    "resize"
	];

	var Surface = kendo.Observable.extend({
	    init: function(element, options) {
	        kendo.Observable.fn.init.call(this);

	        this.options = $.extend({}, options);
	        this.element = element;
	        this.element._kendoExportVisual = this.exportVisual.bind(this);

	        this._click = this._handler("click");
	        this._mouseenter = this._handler("mouseenter");
	        this._mouseleave = this._handler("mouseleave");
	        this._mousemove = this._handler("mousemove");

	        this._visual = new Group();

	        elementSize(element, this.options);

	        this.bind(events, this.options);

	        this._enableTracking();
	    },

	    draw: function(element) {
	        this._visual.children.push(element);
	    },

	    clear: function() {
	        this._visual.children = [];
	    },

	    destroy: function() {
	        this._visual = null;
	        this.element._kendoExportVisual = null;
	        this.unbind();
	    },

	    eventTarget: function(e) {
	        var this$1 = this;

	        var domNode = eventElement(e);
	        var node;

	        while (!node && domNode) {
	            node = domNode._kendoNode;
	            if (domNode === this$1.element) {
	                break;
	            }

	            domNode = domNode.parentElement;
	        }

	        if (node) {
	            return node.srcElement;
	        }
	    },

	    exportVisual: function() {
	        return this._visual;
	    },

	    getSize: function() {
	        return elementSize(this.element);
	    },

	    currentSize: function(size) {
	        if (size) {
	            this._size = size;
	        } else {
	            return this._size;
	        }
	    },

	    setSize: function(size) {
	        elementSize(this.element, size);

	        this.currentSize(size);
	        this._resize();
	    },

	    resize: function(force) {
	        var size = this.getSize();
	        var currentSize = this.currentSize();

	        if (force || (size.width > 0 || size.height > 0) && (!currentSize || size.width !== currentSize.width || size.height !== currentSize.height)) {
	            this.currentSize(size);
	            this._resize(size, force);
	            this.trigger("resize", size);
	        }
	    },

	    size: function(value) {
	        if (!value) {
	            return this.getSize();
	        }

	        this.setSize(value);
	    },

	    suspendTracking: function() {
	        this._suspendedTracking = true;
	    },

	    resumeTracking: function() {
	        this._suspendedTracking = false;
	    },

	    _enableTracking: function() {},

	    _resize: function() {},

	    _handler: function(eventName) {
	        var this$1 = this;

	        return function (e) {
	            var node = this$1.eventTarget(e);
	            if (node && !this$1._suspendedTracking) {
	                this$1.trigger(eventName, {
	                    element: node,
	                    originalEvent: e,
	                    type: eventName
	                });
	            }
	        };
	    },

	    _elementOffset: function() {
	        var element = this.element;
	        var padding = elementPadding(element);
	        var ref = elementOffset(element);
	        var left = ref.left;
	        var top = ref.top;

	        return {
	            left: left + padding.left,
	            top: top + padding.top
	        };
	    },

	    _surfacePoint: function(e) {
	        var offset = this._elementOffset();
	        var coord = eventCoordinates(e);
	        var x = coord.x - offset.left;
	        var y = coord.y - offset.top;

	        var inverseTransform = elementScale(this.element).invert();
	        var point = new Point(
	            x,
	            y
	        ).transform(inverseTransform);

	        return point;
	    }
	});

	Surface.create = function(element, options) {
	    return SurfaceFactory.current.create(element, options);
	};

	Surface.support = {};

	var BaseNode = Class.extend({
	    init: function(srcElement) {

	        this.childNodes = [];
	        this.parent = null;

	        if (srcElement) {
	            this.srcElement = srcElement;
	            this.observe();
	        }
	    },

	    destroy: function() {
	        var this$1 = this;

	        if (this.srcElement) {
	            this.srcElement.removeObserver(this);
	        }

	        var children = this.childNodes;
	        for (var i = 0; i < children.length; i++) {
	            this$1.childNodes[i].destroy();
	        }

	        this.parent = null;
	    },

	    load: function() {},

	    observe: function() {
	        if (this.srcElement) {
	            this.srcElement.addObserver(this);
	        }
	    },

	    append: function(node) {
	        this.childNodes.push(node);
	        node.parent = this;
	    },

	    insertAt: function(node, pos) {
	        this.childNodes.splice(pos, 0, node);
	        node.parent = this;
	    },

	    remove: function(index, count) {
	        var this$1 = this;

	        var end = index + count;
	        for (var i = index; i < end; i++) {
	            this$1.childNodes[i].removeSelf();
	        }
	        this.childNodes.splice(index, count);
	    },

	    removeSelf: function() {
	        this.clear();
	        this.destroy();
	    },

	    clear: function() {
	        this.remove(0, this.childNodes.length);
	    },

	    invalidate: function() {
	        if (this.parent) {
	            this.parent.invalidate();
	        }
	    },

	    geometryChange: function() {
	        this.invalidate();
	    },

	    optionsChange: function() {
	        this.invalidate();
	    },

	    childrenChange: function(e) {
	        if (e.action === "add") {
	            this.load(e.items, e.index);
	        } else if (e.action === "remove") {
	            this.remove(e.index, e.items.length);
	        }

	        this.invalidate();
	    }
	});

	function renderAttr(name, value) {
	    return (defined(value) && value !== null) ? (" " + name + "=\"" + value + "\" ") : "";
	}

	function renderAllAttr(attrs) {
	    var output = "";
	    for (var i = 0; i < attrs.length; i++) {
	        output += renderAttr(attrs[i][0], attrs[i][1]);
	    }

	    return output;
	}

	function renderStyle(attrs) {
	    var output = "";
	    for (var i = 0; i < attrs.length; i++) {
	        var value = attrs[i][1];
	        if (defined(value)) {
	            output += attrs[i][0] + ":" + value + ";";
	        }
	    }

	    if (output !== "") {
	        return output;
	    }
	}

	var NODE_MAP = {};

	var SVG_NS = "http://www.w3.org/2000/svg";
	var NONE = "none";

	var renderSVG = function(container, svg) {
	    container.innerHTML = svg;
	};

	if (typeof document !== "undefined") {
	    var testFragment = "<svg xmlns='" + SVG_NS + "'></svg>";
	    var testContainer = document.createElement("div");
	    var hasParser = typeof DOMParser !== "undefined";

	    testContainer.innerHTML = testFragment;

	    if (hasParser && testContainer.firstChild.namespaceURI !== SVG_NS) {
	        renderSVG = function(container, svg) {
	            var parser = new DOMParser();
	            var chartDoc = parser.parseFromString(svg, "text/xml");
	            var importedDoc = document.adoptNode(chartDoc.documentElement);

	            container.innerHTML = "";
	            container.appendChild(importedDoc);
	        };
	    }
	}

	var renderSVG$1 = renderSVG;

	var TRANSFORM = "transform";
	var DefinitionMap = {
	    clip: "clip-path",
	    fill: "fill"
	};

	function isDefinition(type, value) {
	    return type === "clip" || (type === "fill" && (!value || value.nodeType === "Gradient"));
	}

	function baseUrl() {
	    var base = document.getElementsByTagName("base")[0];
	    var href = document.location.href;
	    var url = "";

	    if (base && !(supportBrowser || {}).msie) {
	        var hashIndex = href.indexOf("#");
	        if (hashIndex !== -1) {
	            href = href.substring(0, hashIndex);
	        }

	        url = href;
	    }

	    return url;
	}

	var Node = BaseNode.extend({
	    init: function(srcElement, options) {
	        BaseNode.fn.init.call(this, srcElement);
	        this.definitions = {};

	        this.options = options;
	    },

	    destroy: function() {
	        if (this.element) {
	            this.element._kendoNode = null;
	            this.element = null;
	        }

	        this.clearDefinitions();
	        BaseNode.fn.destroy.call(this);
	    },

	    load: function(elements, pos) {
	        var this$1 = this;

	        for (var i = 0; i < elements.length; i++) {
	            var srcElement = elements[i];
	            var children = srcElement.children;

	            var childNode = new NODE_MAP[srcElement.nodeType](srcElement, this$1.options);

	            if (defined(pos)) {
	                this$1.insertAt(childNode, pos);
	            } else {
	                this$1.append(childNode);
	            }

	            childNode.createDefinitions();

	            if (children && children.length > 0) {
	                childNode.load(children);
	            }

	            var element = this$1.element;
	            if (element) {
	                childNode.attachTo(element, pos);
	            }
	        }
	    },

	    root: function() {
	        var root = this;

	        while (root.parent) {
	            root = root.parent;
	        }

	        return root;
	    },

	    attachTo: function(domElement, pos) {
	        var container = document.createElement("div");
	        renderSVG$1(container,
	            "<svg xmlns='" + SVG_NS + "' version='1.1'>" +
	                this.render() +
	            "</svg>"
	        );

	        var element = container.firstChild.firstChild;
	        if (element) {
	            if (defined(pos)) {
	                domElement.insertBefore(element, domElement.childNodes[pos] || null);
	            } else {
	                domElement.appendChild(element);
	            }
	            this.setElement(element);
	        }
	    },

	    setElement: function(element) {
	        if (this.element) {
	            this.element._kendoNode = null;
	        }

	        this.element = element;
	        this.element._kendoNode = this;

	        var nodes = this.childNodes;
	        for (var i = 0; i < nodes.length; i++) {
	            var childElement = element.childNodes[i];
	            nodes[i].setElement(childElement);
	        }
	    },

	    clear: function() {
	        this.clearDefinitions();

	        if (this.element) {
	            this.element.innerHTML = "";
	        }

	        var children = this.childNodes;
	        for (var i = 0; i < children.length; i++) {
	            children[i].destroy();
	        }

	        this.childNodes = [];
	    },

	    removeSelf: function() {
	        if (this.element) {
	            var parentNode = this.element.parentNode;
	            if (parentNode) {
	                parentNode.removeChild(this.element);
	            }
	            this.element = null;
	        }

	        BaseNode.fn.removeSelf.call(this);
	    },

	    template: function() {
	        return this.renderChildren();
	    },

	    render: function() {
	        return this.template();
	    },

	    renderChildren: function() {
	        var nodes = this.childNodes;
	        var output = "";

	        for (var i = 0; i < nodes.length; i++) {
	            output += nodes[i].render();
	        }

	        return output;
	    },

	    optionsChange: function(e) {
	        var field = e.field;
	        var value = e.value;

	        if (field === "visible") {
	            this.css("display", value ? "" : NONE);
	        } else if (DefinitionMap[field] && isDefinition(field, value)) {
	            this.updateDefinition(field, value);
	        } else if (field === "opacity") {
	            this.attr("opacity", value);
	        } else if (field === "cursor") {
	            this.css("cursor", value);
	        } else if (field === "id") {
	            if (value) {
	                this.attr("id", value);
	            } else {
	                this.removeAttr("id");
	            }
	        }

	        BaseNode.fn.optionsChange.call(this, e);
	    },

	    attr: function(name, value) {
	        if (this.element) {
	            this.element.setAttribute(name, value);
	        }
	    },

	    allAttr: function(attrs) {
	        var this$1 = this;

	        for (var i = 0; i < attrs.length; i++) {
	            this$1.attr(attrs[i][0], attrs[i][1]);
	        }
	    },

	    css: function(name, value) {
	        if (this.element) {
	            this.element.style[name] = value;
	        }
	    },

	    allCss: function(styles) {
	        var this$1 = this;

	        for (var i = 0; i < styles.length; i++) {
	            this$1.css(styles[i][0], styles[i][1]);
	        }
	    },

	    removeAttr: function(name) {
	        if (this.element) {
	            this.element.removeAttribute(name);
	        }
	    },

	    mapTransform: function(transform) {
	        var attrs = [];
	        if (transform) {
	            attrs.push([
	                TRANSFORM,
	                "matrix(" + transform.matrix().toString(6) + ")"
	            ]);
	        }

	        return attrs;
	    },

	    renderTransform: function() {
	        return renderAllAttr(
	            this.mapTransform(this.srcElement.transform())
	        );
	    },

	    transformChange: function(value) {
	        if (value) {
	            this.allAttr(this.mapTransform(value));
	        } else {
	            this.removeAttr(TRANSFORM);
	        }
	    },

	    mapStyle: function() {
	        var options = this.srcElement.options;
	        var style = [ [ "cursor", options.cursor ] ];

	        if (options.visible === false) {
	            style.push([ "display", NONE ]);
	        }

	        return style;
	    },

	    renderStyle: function() {
	        return renderAttr("style", renderStyle(this.mapStyle(true)));
	    },

	    renderOpacity: function() {
	        return renderAttr("opacity", this.srcElement.options.opacity);
	    },

	    renderId: function() {
	        return renderAttr("id", this.srcElement.options.id);
	    },

	    createDefinitions: function() {
	        var srcElement = this.srcElement;
	        var definitions = this.definitions;
	        if (srcElement) {
	            var options = srcElement.options;
	            var hasDefinitions;

	            for (var field in DefinitionMap) {
	                var definition = options.get(field);
	                if (definition && isDefinition(field, definition)) {
	                    definitions[field] = definition;
	                    hasDefinitions = true;
	                }
	            }
	            if (hasDefinitions) {
	                this.definitionChange({
	                    action: "add",
	                    definitions: definitions
	                });
	            }
	        }
	    },

	    definitionChange: function(e) {
	        if (this.parent) {
	            this.parent.definitionChange(e);
	        }
	    },

	    updateDefinition: function(type, value) {
	        var definitions = this.definitions;
	        var current = definitions[type];
	        var attr = DefinitionMap[type];
	        var definition = {};
	        if (current) {
	            definition[type] = current;
	            this.definitionChange({
	                action: "remove",
	                definitions: definition
	            });
	            delete definitions[type];
	        }

	        if (!value) {
	            if (current) {
	                this.removeAttr(attr);
	            }
	        } else {
	            definition[type] = value;
	            this.definitionChange({
	                action: "add",
	                definitions: definition
	            });
	            definitions[type] = value;
	            this.attr(attr, this.refUrl(value.id));
	        }
	    },

	    clearDefinitions: function() {
	        var definitions = this.definitions;

	        this.definitionChange({
	            action: "remove",
	            definitions: definitions
	        });
	        this.definitions = {};
	    },

	    renderDefinitions: function() {
	        return renderAllAttr(this.mapDefinitions());
	    },

	    mapDefinitions: function() {
	        var this$1 = this;

	        var definitions = this.definitions;
	        var attrs = [];

	        for (var field in definitions) {
	            attrs.push([ DefinitionMap[field], this$1.refUrl(definitions[field].id) ]);
	        }

	        return attrs;
	    },

	    refUrl: function(id) {
	        var skipBaseHref = (this.options || {}).skipBaseHref;
	        var baseHref = this.baseUrl().replace(/'/g, "\\'");
	        var base = skipBaseHref ? '' : baseHref;
	        return ("url(" + base + "#" + id + ")");
	    },

	    baseUrl: function() {
	        return baseUrl();
	    }
	});

	var GradientStopNode = Node.extend({
	    template: function() {
	        return ("<stop " + (this.renderOffset()) + " " + (this.renderStyle()) + " />");
	    },

	    renderOffset: function() {
	        return renderAttr("offset", this.srcElement.offset());
	    },

	    mapStyle: function() {
	        var srcElement = this.srcElement;
	        return [
	            [ "stop-color", srcElement.color() ],
	            [ "stop-opacity", srcElement.opacity() ]
	        ];
	    },

	    optionsChange: function(e) {
	        if (e.field === "offset") {
	            this.attr(e.field, e.value);
	        } else if (e.field === "color" || e.field === "opacity") {
	            this.css("stop-" + e.field, e.value);
	        }
	    }
	});

	var GradientNode = Node.extend({
	    init: function(srcElement) {
	        Node.fn.init.call(this, srcElement);

	        this.id = srcElement.id;

	        this.loadStops();
	    },

	    loadStops: function() {
	        var this$1 = this;

	        var stops = this.srcElement.stops;
	        var element = this.element;

	        for (var idx = 0; idx < stops.length; idx++) {
	            var stopNode = new GradientStopNode(stops[idx]);
	            this$1.append(stopNode);
	            if (element) {
	                stopNode.attachTo(element);
	            }
	        }
	    },

	    optionsChange: function(e) {
	        if (e.field === "gradient.stops") {
	            BaseNode.prototype.clear.call(this);
	            this.loadStops();
	        } else if (e.field === "gradient") {
	            this.allAttr(this.mapCoordinates());
	        }
	    },

	    renderCoordinates: function() {
	        return renderAllAttr(this.mapCoordinates());
	    },

	    mapSpace: function() {
	        return [ "gradientUnits", this.srcElement.userSpace() ? "userSpaceOnUse" : "objectBoundingBox" ];
	    }
	});

	var LinearGradientNode = GradientNode.extend({
	    template: function() {
	        return ("<linearGradient id='" + (this.id) + "' " + (this.renderCoordinates()) + ">" + (this.renderChildren()) + "</linearGradient>");
	    },

	    mapCoordinates: function() {
	        var srcElement = this.srcElement;
	        var start = srcElement.start();
	        var end = srcElement.end();
	        var attrs = [
	            [ "x1", start.x ],
	            [ "y1", start.y ],
	            [ "x2", end.x ],
	            [ "y2", end.y ],
	            this.mapSpace()
	        ];

	        return attrs;
	    }
	});

	var RadialGradientNode = GradientNode.extend({
	    template: function() {
	        return ("<radialGradient id='" + (this.id) + "' " + (this.renderCoordinates()) + ">" + (this.renderChildren()) + "</radialGradient>");
	    },

	    mapCoordinates: function() {
	        var srcElement = this.srcElement;
	        var center = srcElement.center();
	        var radius = srcElement.radius();
	        var attrs = [
	            [ "cx", center.x ],
	            [ "cy", center.y ],
	            [ "r", radius ],
	            this.mapSpace()
	        ];
	        return attrs;
	    }
	});

	var ClipNode = Node.extend({
	    init: function(srcElement) {
	        Node.fn.init.call(this);

	        this.srcElement = srcElement;
	        this.id = srcElement.id;

	        this.load([ srcElement ]);
	    },

	    template: function() {
	        return ("<clipPath id='" + (this.id) + "'>" + (this.renderChildren()) + "</clipPath>");
	    }
	});

	var DefinitionNode = Node.extend({
	    init: function() {
	        Node.fn.init.call(this);
	        this.definitionMap = {};
	    },

	    attachTo: function(domElement) {
	        this.element = domElement;
	    },

	    template: function() {
	        return ("<defs>" + (this.renderChildren()) + "</defs>");
	    },

	    definitionChange: function(e) {
	        var definitions = e.definitions;
	        var action = e.action;

	        if (action === "add") {
	            this.addDefinitions(definitions);
	        } else if (action === "remove") {
	            this.removeDefinitions(definitions);
	        }
	    },

	    createDefinition: function(type, item) {
	        var nodeType;
	        if (type === "clip") {
	            nodeType = ClipNode;
	        } else if (type === "fill") {
	            if (item instanceof LinearGradient) {
	                nodeType = LinearGradientNode;
	            } else if (item instanceof RadialGradient) {
	                nodeType = RadialGradientNode;
	            }
	        }
	        return new nodeType(item);
	    },

	    addDefinitions: function(definitions) {
	        var this$1 = this;

	        for (var field in definitions) {
	            this$1.addDefinition(field, definitions[field]);
	        }
	    },

	    addDefinition: function(type, srcElement) {
	        var ref = this;
	        var element = ref.element;
	        var definitionMap = ref.definitionMap;
	        var id = srcElement.id;
	        var mapItem = definitionMap[id];
	        if (!mapItem) {
	            var node = this.createDefinition(type, srcElement);
	            definitionMap[id] = {
	                element: node,
	                count: 1
	            };
	            this.append(node);
	            if (element) {
	                node.attachTo(this.element);
	            }
	        } else {
	            mapItem.count++;
	        }
	    },

	    removeDefinitions: function(definitions) {
	        var this$1 = this;

	        for (var field in definitions) {
	            this$1.removeDefinition(definitions[field]);
	        }
	    },

	    removeDefinition: function(srcElement) {
	        var definitionMap = this.definitionMap;
	        var id = srcElement.id;
	        var mapItem = definitionMap[id];

	        if (mapItem) {
	            mapItem.count--;
	            if (mapItem.count === 0) {
	                this.remove(this.childNodes.indexOf(mapItem.element), 1);
	                delete definitionMap[id];
	            }
	        }
	    }
	});

	var RootNode = Node.extend({
	    init: function(options) {
	        Node.fn.init.call(this);
	        this.options = options;
	        this.defs = new DefinitionNode();
	    },

	    attachTo: function(domElement) {
	        this.element = domElement;
	        this.defs.attachTo(domElement.firstElementChild);
	    },

	    clear: function() {
	        BaseNode.prototype.clear.call(this);
	    },

	    template: function() {
	        return this.defs.render() + this.renderChildren();
	    },

	    definitionChange: function(e) {
	        this.defs.definitionChange(e);
	    }
	});

	var RTL = 'rtl';

	function alignToScreen(element) {
	    var ctm;

	    try {
	        ctm = element.getScreenCTM ? element.getScreenCTM() : null;
	    } catch (e) { } // eslint-disable-line no-empty

	    if (ctm) {
	        var left = - ctm.e % 1;
	        var top = - ctm.f % 1;
	        var style = element.style;

	        if (left !== 0 || top !== 0) {
	            style.left = left + "px";
	            style.top = top + "px";
	        }
	    }
	}

	var Surface$1 = Surface.extend({
	    init: function(element, options) {
	        Surface.fn.init.call(this, element, options);

	        this._root = new RootNode($.extend({
	            rtl: elementStyles(element, 'direction').direction === RTL
	        }, this.options));

	        renderSVG$1(this.element, this._template());

	        this._rootElement = this.element.firstElementChild;

	        alignToScreen(this._rootElement);

	        this._root.attachTo(this._rootElement);

	        bindEvents(this.element, {
	            click: this._click,
	            mouseover: this._mouseenter,
	            mouseout: this._mouseleave,
	            mousemove: this._mousemove
	        });

	        this.resize();
	    },

	    destroy: function() {
	        if (this._root) {
	            this._root.destroy();
	            this._root = null;
	            this._rootElement = null;
	            unbindEvents(this.element, {
	                click: this._click,
	                mouseover: this._mouseenter,
	                mouseout: this._mouseleave,
	                mousemove: this._mousemove
	            });
	        }

	        Surface.fn.destroy.call(this);
	    },

	    translate: function(offset) {
	        var viewBox = (Math.round(offset.x)) + " " + (Math.round(offset.y)) + " " + (this._size.width) + " " + (this._size.height);

	        this._offset = offset;
	        this._rootElement.setAttribute("viewBox", viewBox);
	    },

	    draw: function(element) {
	        Surface.fn.draw.call(this, element);
	        this._root.load([ element ]);
	    },

	    clear: function() {
	        Surface.fn.clear.call(this);
	        this._root.clear();
	    },

	    svg: function() {
	        return "<?xml version='1.0' ?>" + this._template();
	    },

	    exportVisual: function() {
	        var ref = this;
	        var visual = ref._visual;
	        var offset = ref._offset;

	        if (offset) {
	            var wrap = new Group();
	            wrap.children.push(visual);

	            wrap.transform(
	                transform().translate(-offset.x, -offset.y)
	            );

	            visual = wrap;
	        }

	        return visual;
	    },

	    _resize: function() {
	        if (this._offset) {
	            this.translate(this._offset);
	        }
	    },

	    _template: function() {
	        return ("<svg style='width: 100%; height: 100%; overflow: hidden;' xmlns='" + SVG_NS + "' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1'>" + (this._root.render()) + "</svg>");
	    }
	});

	Surface$1.prototype.type = "svg";

	if (typeof document !== "undefined" && document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1")) {
	    Surface.support.svg = true;
	    SurfaceFactory.current.register("svg", Surface$1, 10);
	}

	var GroupNode = Node.extend({
	    template: function() {
	        return ("<g" + (this.renderId() + this.renderTransform() + this.renderStyle() + this.renderOpacity() + this.renderDefinitions()) + ">" + (this.renderChildren()) + "</g>");
	    },

	    optionsChange: function(e) {
	        if (e.field === "transform") {
	            this.transformChange(e.value);
	        }

	        Node.fn.optionsChange.call(this, e);
	    }
	});

	NODE_MAP.Group = GroupNode;

	var DASH_ARRAYS = {
	    dot: [ 1.5, 3.5 ],
	    dash: [ 4, 3.5 ],
	    longdash: [ 8, 3.5 ],
	    dashdot: [ 3.5, 3.5, 1.5, 3.5 ],
	    longdashdot: [ 8, 3.5, 1.5, 3.5 ],
	    longdashdotdot: [ 8, 3.5, 1.5, 3.5, 1.5, 3.5 ]
	};

	var SOLID = "solid";
	var BUTT = "butt";

	var ATTRIBUTE_MAP = {
	    "fill.opacity": "fill-opacity",
	    "stroke.color": "stroke",
	    "stroke.width": "stroke-width",
	    "stroke.opacity": "stroke-opacity"
	};
	var SPACE = " ";

	var PathNode = Node.extend({
	    geometryChange: function() {
	        this.attr("d", this.renderData());
	        this.invalidate();
	    },

	    optionsChange: function(e) {
	        switch (e.field) {
	            case "fill":
	                if (e.value) {
	                    this.allAttr(this.mapFill(e.value));
	                } else {
	                    this.removeAttr("fill");
	                }
	                break;

	            case "fill.color":
	                this.allAttr(this.mapFill({ color: e.value }));
	                break;

	            case "stroke":
	                if (e.value) {
	                    this.allAttr(this.mapStroke(e.value));
	                } else {
	                    this.removeAttr("stroke");
	                }
	                break;

	            case "transform":
	                this.transformChange(e.value);
	                break;

	            default:
	                var name = ATTRIBUTE_MAP[e.field];
	                if (name) {
	                    this.attr(name, e.value);
	                }
	                break;
	        }

	        Node.fn.optionsChange.call(this, e);
	    },

	    content: function() {
	        if (this.element) {
	            this.element.textContent = this.srcElement.content();
	        }
	    },

	    renderData: function() {
	        return this.printPath(this.srcElement);
	    },

	    printPath: function(path) {
	        var this$1 = this;

	        var segments = path.segments;
	        var length = segments.length;
	        if (length > 0) {
	            var parts = [];
	            var output, currentType;

	            for (var i = 1; i < length; i++) {
	                var segmentType = this$1.segmentType(segments[i - 1], segments[i]);
	                if (segmentType !== currentType) {
	                    currentType = segmentType;
	                    parts.push(segmentType);
	                }

	                if (segmentType === "L") {
	                    parts.push(this$1.printPoints(segments[i].anchor()));
	                } else {
	                    parts.push(this$1.printPoints(segments[i - 1].controlOut(), segments[i].controlIn(), segments[i].anchor()));
	                }
	            }

	            output = "M" + this.printPoints(segments[0].anchor()) + SPACE + parts.join(SPACE);
	            if (path.options.closed) {
	                output += "Z";
	            }

	            return output;
	        }
	    },

	    printPoints: function() {
	        var points = arguments;
	        var length = points.length;
	        var result = [];

	        for (var i = 0; i < length; i++) {
	            result.push(points[i].toString(3));
	        }

	        return result.join(" ");
	    },

	    segmentType: function(segmentStart, segmentEnd) {
	        return segmentStart.controlOut() && segmentEnd.controlIn() ? "C" : "L";
	    },

	    mapStroke: function(stroke) {
	        var attrs = [];

	        if (stroke && !isTransparent(stroke.color)) {
	            attrs.push([ "stroke", stroke.color ]);
	            attrs.push([ "stroke-width", stroke.width ]);
	            attrs.push([ "stroke-linecap", this.renderLinecap(stroke) ]);
	            attrs.push([ "stroke-linejoin", stroke.lineJoin ]);

	            if (defined(stroke.opacity)) {
	                attrs.push([ "stroke-opacity", stroke.opacity ]);
	            }

	            if (defined(stroke.dashType)) {
	                attrs.push([ "stroke-dasharray", this.renderDashType(stroke) ]);
	            }
	        } else {
	            attrs.push([ "stroke", NONE ]);
	        }

	        return attrs;
	    },

	    renderStroke: function() {
	        return renderAllAttr(
	            this.mapStroke(this.srcElement.options.stroke)
	        );
	    },

	    renderDashType: function(stroke) {
	        var dashType = stroke.dashType;
	        var width = stroke.width; if (width === void 0) { width = 1; }

	        if (dashType && dashType !== SOLID) {
	            var dashArray = DASH_ARRAYS[dashType.toLowerCase()];
	            var result = [];

	            for (var i = 0; i < dashArray.length; i++) {
	                result.push(dashArray[i] * width);
	            }

	            return result.join(" ");
	        }
	    },

	    renderLinecap: function(stroke) {
	        var dashType = stroke.dashType;
	        var lineCap = stroke.lineCap;

	        return (dashType && dashType !== "solid") ? BUTT : lineCap;
	    },

	    mapFill: function(fill) {
	        var attrs = [];
	        if (!(fill && fill.nodeType === "Gradient")) {
	            if (fill && !isTransparent(fill.color)) {
	                attrs.push([ "fill", fill.color ]);

	                if (defined(fill.opacity)) {
	                    attrs.push([ "fill-opacity", fill.opacity ]);
	                }
	            } else {
	                attrs.push([ "fill", NONE ]);
	            }
	        }

	        return attrs;
	    },

	    renderFill: function() {
	        return renderAllAttr(
	            this.mapFill(this.srcElement.options.fill)
	        );
	    },

	    template: function() {
	        return "<path " + (this.renderId()) + " " + (this.renderStyle()) + " " + (this.renderOpacity()) + " " + (renderAttr('d', this.renderData())) +
	                    "" + (this.renderStroke()) + (this.renderFill()) + (this.renderDefinitions()) + (this.renderTransform()) + "></path>";
	    }
	});

	NODE_MAP.Path = PathNode;

	var ArcNode = PathNode.extend({
	    renderData: function() {
	        return this.printPath(this.srcElement.toPath());
	    }
	});

	NODE_MAP.Arc = ArcNode;

	var CircleNode = PathNode.extend({
	    geometryChange: function() {
	        var center = this.center();
	        this.attr("cx", center.x);
	        this.attr("cy", center.y);
	        this.attr("r", this.radius());
	        this.invalidate();
	    },

	    center: function() {
	        return this.srcElement.geometry().center;
	    },

	    radius: function() {
	        return this.srcElement.geometry().radius;
	    },

	    template: function() {
	        return "<circle " + (this.renderId()) + " " + (this.renderStyle()) + " " + (this.renderOpacity()) +
	                    "cx='" + (this.center().x) + "' cy='" + (this.center().y) + "' r='" + (this.radius()) + "'" +
	                    (this.renderStroke()) + " " + (this.renderFill()) + " " + (this.renderDefinitions()) +
	                    (this.renderTransform()) + " ></circle>";
	    }
	});

	NODE_MAP.Circle = CircleNode;

	var RectNode = PathNode.extend({
	    geometryChange: function() {
	        var geometry = this.srcElement.geometry();
	        this.attr("x", geometry.origin.x);
	        this.attr("y", geometry.origin.y);
	        this.attr("width", geometry.size.width);
	        this.attr("height", geometry.size.height);
	        this.invalidate();
	    },

	    size: function() {
	        return this.srcElement.geometry().size;
	    },

	    origin: function() {
	        return this.srcElement.geometry().origin;
	    },

	    template: function() {
	        return "<rect " + (this.renderId()) + " " + (this.renderStyle()) + " " + (this.renderOpacity()) + " x='" + (this.origin().x) + "' y='" + (this.origin().y) + "' " +
	                    "width='" + (this.size().width) + "' height='" + (this.size().height) + "' " + (this.renderStroke()) + " " +
	                    (this.renderFill()) + " " + (this.renderDefinitions()) + " " + (this.renderTransform()) + " />";
	    }
	});

	NODE_MAP.Rect = RectNode;

	var ImageNode = PathNode.extend({
	    geometryChange: function() {
	        this.allAttr(this.mapPosition());
	        this.invalidate();
	    },

	    optionsChange: function(e) {
	        if (e.field === "src") {
	            this.allAttr(this.mapSource());
	        }

	        PathNode.fn.optionsChange.call(this, e);
	    },

	    mapPosition: function() {
	        var rect = this.srcElement.rect();
	        var tl = rect.topLeft();

	        return [
	            [ "x", tl.x ],
	            [ "y", tl.y ],
	            [ "width", rect.width() + "px" ],
	            [ "height", rect.height() + "px" ]
	        ];
	    },

	    renderPosition: function() {
	        return renderAllAttr(this.mapPosition());
	    },

	    mapSource: function(encode) {
	        var src = this.srcElement.src();

	        if (encode) {
	            src = kendo.htmlEncode(src);
	        }

	        return [ [ "xlink:href", src ] ];
	    },

	    renderSource: function() {
	        return renderAllAttr(this.mapSource(true));
	    },

	    template: function() {
	        return "<image preserveAspectRatio='none' " + (this.renderId()) + " " + (this.renderStyle()) + " " + (this.renderTransform()) + " " + (this.renderOpacity()) +
	               (this.renderPosition()) + " " + (this.renderSource()) + " " + (this.renderDefinitions()) + ">" +
	               "</image>";
	    }
	});

	NODE_MAP.Image = ImageNode;

	var ENTITY_REGEX = /&(?:[a-zA-Z]+|#\d+);/g;

	function decodeEntities(text) {
	    if (!text || typeof text !== "string" || !ENTITY_REGEX.test(text)) {
	        return text;
	    }

	    var element = decodeEntities._element;
	    ENTITY_REGEX.lastIndex = 0;

	    return text.replace(ENTITY_REGEX, function (match) {
	        element.innerHTML = match;

	        return element.textContent || element.innerText;
	    });
	}

	if (typeof document !== "undefined") {
	    decodeEntities._element = document.createElement("span");
	}

	var TextNode = PathNode.extend({
	    geometryChange: function() {
	        var pos = this.pos();
	        this.attr("x", pos.x);
	        this.attr("y", pos.y);
	        this.invalidate();
	    },

	    optionsChange: function(e) {
	        if (e.field === "font") {
	            this.attr("style", renderStyle(this.mapStyle()));
	            this.geometryChange();
	        } else if (e.field === "content") {
	            PathNode.fn.content.call(this, this.srcElement.content());
	        }

	        PathNode.fn.optionsChange.call(this, e);
	    },

	    mapStyle: function(encode) {
	        var style = PathNode.fn.mapStyle.call(this, encode);
	        var font = this.srcElement.options.font;

	        if (encode) {
	            font = kendo.htmlEncode(font);
	        }

	        style.push([ "font", font ], [ "white-space", "pre" ]);

	        return style;
	    },

	    pos: function() {
	        var pos = this.srcElement.position();
	        var size = this.srcElement.measure();
	        return pos.clone().setY(pos.y + size.baseline);
	    },

	    renderContent: function() {
	        var content = this.srcElement.content();
	        content = decodeEntities(content);
	        content = kendo.htmlEncode(content);

	        return kendoUtil.normalizeText(content);
	    },

	    renderTextAnchor: function() {
	        var anchor;

	        if ((this.options || {}).rtl && !(supportBrowser.msie || supportBrowser.edge)) {
	            anchor = 'end';
	        }

	        return renderAttr("text-anchor", anchor);
	    },

	    template: function() {
	        return "<text " + (this.renderId()) + " " + (this.renderTextAnchor()) + " " + (this.renderStyle()) + " " + (this.renderOpacity()) +
	                    "x='" + (this.pos().x) + "' y='" + (this.pos().y) + "' " + (this.renderStroke()) + " " + (this.renderTransform()) + " " + (this.renderDefinitions()) +
	                    (this.renderFill()) + ">" + (this.renderContent()) + "</text>";
	    }
	});

	NODE_MAP.Text = TextNode;

	var MultiPathNode = PathNode.extend({
	    renderData: function() {
	        var this$1 = this;

	        var paths = this.srcElement.paths;

	        if (paths.length > 0) {
	            var result = [];

	            for (var i = 0; i < paths.length; i++) {
	                result.push(this$1.printPath(paths[i]));
	            }

	            return result.join(" ");
	        }
	    }
	});

	NODE_MAP.MultiPath = MultiPathNode;

	function exportGroup(group) {
	    var root = new RootNode({
	        skipBaseHref: true
	    });
	    var bbox = group.clippedBBox();
	    var rootGroup = group;

	    if (bbox) {
	        var origin = bbox.getOrigin();
	        var exportRoot = new Group();
	        exportRoot.transform(transform().translate(-origin.x, -origin.y));
	        exportRoot.children.push(group);
	        rootGroup = exportRoot;
	    }

	    root.load([ rootGroup ]);

	    var svg = "<?xml version='1.0' ?><svg xmlns='" + SVG_NS + "' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1'>" + (root.render()) + "</svg>";

	    root.destroy();

	    return svg;
	}

	var svg = {
		Surface: Surface$1,
		RootNode: RootNode,
		Node: Node,
		GroupNode: GroupNode,
		ArcNode: ArcNode,
		CircleNode: CircleNode,
		RectNode: RectNode,
		ImageNode: ImageNode,
		TextNode: TextNode,
		PathNode: PathNode,
		MultiPathNode: MultiPathNode,
		DefinitionNode: DefinitionNode,
		ClipNode: ClipNode,
		GradientStopNode: GradientStopNode,
		LinearGradientNode: LinearGradientNode,
		RadialGradientNode: RadialGradientNode,
		exportGroup: exportGroup
	};

	var NODE_MAP$2 = {};

	function renderPath(ctx, path) {
	    var segments = path.segments;

	    if (segments.length === 0) {
	        return;
	    }

	    var segment = segments[0];
	    var anchor = segment.anchor();
	    ctx.moveTo(anchor.x, anchor.y);

	    for (var i = 1; i < segments.length; i++) {
	        segment = segments[i];
	        anchor = segment.anchor();

	        var prevSeg = segments[i - 1];
	        var prevOut = prevSeg.controlOut();
	        var controlIn = segment.controlIn();

	        if (prevOut && controlIn) {
	            ctx.bezierCurveTo(prevOut.x, prevOut.y,
	                              controlIn.x, controlIn.y,
	                              anchor.x, anchor.y);
	        } else {
	            ctx.lineTo(anchor.x, anchor.y);
	        }
	    }

	    if (path.options.closed) {
	        ctx.closePath();
	    }
	}

	var Node$2 = BaseNode.extend({
	    init: function(srcElement) {
	        BaseNode.fn.init.call(this, srcElement);
	        if (srcElement) {
	            this.initClip();
	        }
	    },

	    initClip: function() {
	        var clip = this.srcElement.clip();
	        if (clip) {
	            this.clip = clip;
	            clip.addObserver(this);
	        }
	    },

	    clear: function() {
	        if (this.srcElement) {
	            this.srcElement.removeObserver(this);
	        }

	        this.clearClip();

	        BaseNode.fn.clear.call(this);
	    },

	    clearClip: function() {
	        if (this.clip) {
	            this.clip.removeObserver(this);
	            delete this.clip;
	        }
	    },

	    setClip: function(ctx) {
	        if (this.clip) {
	            ctx.beginPath();
	            renderPath(ctx, this.clip);
	            ctx.clip();
	        }
	    },

	    optionsChange: function(e) {
	        if (e.field === "clip") {
	            this.clearClip();
	            this.initClip();
	        }

	        BaseNode.fn.optionsChange.call(this, e);
	    },

	    setTransform: function(ctx) {
	        if (this.srcElement) {
	            var transform = this.srcElement.transform();
	            if (transform) {
	                ctx.transform.apply(ctx, transform.matrix().toArray(6));
	            }
	        }
	    },

	    loadElements: function(elements, pos, cors) {
	        var this$1 = this;

	        for (var i = 0; i < elements.length; i++) {
	            var srcElement = elements[i];
	            var children = srcElement.children;

	            var childNode = new NODE_MAP$2[srcElement.nodeType](srcElement, cors);

	            if (children && children.length > 0) {
	                childNode.load(children, pos, cors);
	            }

	            if (defined(pos)) {
	                this$1.insertAt(childNode, pos);
	            } else {
	                this$1.append(childNode);
	            }
	        }
	    },

	    load: function(elements, pos, cors) {
	        this.loadElements(elements, pos, cors);

	        this.invalidate();
	    },

	    setOpacity: function(ctx) {
	        if (this.srcElement) {
	            var opacity = this.srcElement.opacity();
	            if (defined(opacity)) {
	                this.globalAlpha(ctx, opacity);
	            }
	        }
	    },

	    globalAlpha: function(ctx, value) {
	        var opactity = value;
	        if (opactity && ctx.globalAlpha) {
	            opactity *= ctx.globalAlpha;
	        }
	        ctx.globalAlpha = opactity;
	    },

	    visible: function() {
	        var src = this.srcElement;
	        return !src || (src && src.options.visible !== false);
	    }
	});

	var GroupNode$2 = Node$2.extend({
	    renderTo: function(ctx) {
	        if (!this.visible()) {
	            return;
	        }

	        ctx.save();

	        this.setTransform(ctx);
	        this.setClip(ctx);
	        this.setOpacity(ctx);

	        var childNodes = this.childNodes;
	        for (var i = 0; i < childNodes.length; i++) {
	            var child = childNodes[i];
	            if (child.visible()) {
	                child.renderTo(ctx);
	            }
	        }

	        ctx.restore();
	    }
	});

	Traversable.extend(GroupNode$2.prototype, "childNodes");

	NODE_MAP$2.Group = GroupNode$2;

	var FRAME_DELAY = 1000 / 60;

	var RootNode$2 = GroupNode$2.extend({
	    init: function(canvas, size) {
	        GroupNode$2.fn.init.call(this);

	        this.canvas = canvas;
	        this.size = size;
	        this.ctx = canvas.getContext("2d");

	        var invalidateHandler = this._invalidate.bind(this);
	        this.invalidate = kendo.throttle(function () {
	            kendo.animationFrame(invalidateHandler);
	        }, FRAME_DELAY);
	    },

	    destroy: function() {
	        GroupNode$2.fn.destroy.call(this);
	        this.canvas = null;
	        this.ctx = null;
	    },

	    load: function(elements, pos, cors) {
	        this.loadElements(elements, pos, cors);
	        this._invalidate();
	    },

	    _rescale: function(scale) {
	        var ref = this;
	        var canvas = ref.canvas;
	        var size = ref.size;
	        canvas.width = size.width * scale;
	        canvas.height = size.height * scale;
	        this.ctx.scale(scale, scale);
	    },

	    _devicePixelRatio: function() {
	        if (window.devicePixelRatio === 'number') {
	            return window.devicePixelRatio;
	        }

	        return 1;
	    },

	    _invalidate: function(options) {
	        if (!this.ctx) {
	            return;
	        }

	        var fixedScale = options && options.fixedScale;
	        var scale = fixedScale ? 1 : this._devicePixelRatio();
	        this._rescale(scale);

	        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
	        this.renderTo(this.ctx);
	    }
	});

	Traversable.extend(RootNode$2.prototype, "childNodes");

	var QuadRoot = Class.extend({
	    init: function() {

	        this.shapes = [];
	    },

	    _add: function(shape, bbox) {
	        this.shapes.push({
	            bbox: bbox,
	            shape: shape
	        });
	        shape._quadNode = this;
	    },

	    pointShapes: function(point) {
	        var shapes = this.shapes;
	        var length = shapes.length;
	        var result = [];
	        for (var idx = 0; idx < length; idx++) {
	            if (shapes[idx].bbox.containsPoint(point)) {
	                result.push(shapes[idx].shape);
	            }
	        }
	        return result;
	    },

	    insert: function(shape, bbox) {
	        this._add(shape, bbox);
	    },

	    remove: function(shape) {
	        var shapes = this.shapes;
	        var length = shapes.length;

	        for (var idx = 0; idx < length; idx++) {
	            if (shapes[idx].shape === shape) {
	                shapes.splice(idx, 1);
	                break;
	            }
	        }
	    }
	});

	var QuadNode = QuadRoot.extend({
	    init: function(rect) {
	        QuadRoot.fn.init.call(this);
	        this.children = [];
	        this.rect = rect;
	    },

	    inBounds: function(rect) {
	        var nodeRect = this.rect;
	        var nodeBottomRight = nodeRect.bottomRight();
	        var bottomRight = rect.bottomRight();
	        var inBounds = nodeRect.origin.x <= rect.origin.x && nodeRect.origin.y <= rect.origin.y && bottomRight.x <= nodeBottomRight.x &&
	            bottomRight.y <= nodeBottomRight.y;
	        return inBounds;
	    },

	    pointShapes: function(point) {
	        var children = this.children;
	        var length = children.length;
	        var result = QuadRoot.fn.pointShapes.call(this, point);
	        for (var idx = 0; idx < length; idx++) {
	            append(result, children[idx].pointShapes(point));
	        }
	        return result;
	    },

	    insert: function(shape, bbox) {
	        var children = this.children;
	        var inserted = false;

	        if (this.inBounds(bbox)) {
	            if (this.shapes.length < 4) {
	                this._add(shape, bbox);
	            } else {
	                if (!children.length) {
	                    this._initChildren();
	                }

	                for (var idx = 0; idx < children.length; idx++) {
	                    if (children[idx].insert(shape, bbox)) {
	                        inserted = true;
	                        break;
	                    }
	                }

	                if (!inserted) {
	                    this._add(shape, bbox);
	                }
	            }
	            inserted = true;
	        }

	        return inserted;
	    },

	    _initChildren: function() {
	        var ref = this;
	        var rect = ref.rect;
	        var children = ref.children;
	        var center = rect.center();
	        var halfWidth = rect.width() / 2;
	        var halfHeight = rect.height() / 2;

	        children.push(
	            new QuadNode(new Rect([ rect.origin.x, rect.origin.y ], [ halfWidth, halfHeight ])),
	            new QuadNode(new Rect([ center.x, rect.origin.y ], [ halfWidth, halfHeight ])),
	            new QuadNode(new Rect([ rect.origin.x, center.y ], [ halfWidth, halfHeight ])),
	            new QuadNode(new Rect([ center.x, center.y ], [ halfWidth, halfHeight ]))
	        );
	    }
	});

	var ROOT_SIZE = 3000;
	var LEVEL_STEP = 10000;
	var MAX_LEVEL = 75;

	var ShapesQuadTree = Class.extend({
	    init: function() {

	        this.initRoots();
	    },

	    initRoots: function() {
	        this.rootMap = {};
	        this.root = new QuadRoot();
	        this.rootElements = [];
	    },

	    clear: function() {
	        var this$1 = this;

	        var rootElements = this.rootElements;
	        for (var idx = 0; idx < rootElements.length; idx++) {
	            this$1.remove(rootElements[idx]);
	        }
	        this.initRoots();
	    },

	    pointShape: function(point) {
	        var sectorRoot = ( this.rootMap[ Math.floor( point.x / ROOT_SIZE ) ] || {} )[ Math.floor( point.y / ROOT_SIZE ) ];
	        var result = this.root.pointShapes(point);

	        if (sectorRoot) {
	            result = result.concat(sectorRoot.pointShapes(point));
	        }

	        this.assignZindex(result);

	        result.sort(zIndexComparer);
	        for (var idx = 0; idx < result.length; idx++) {
	            if (result[idx].containsPoint(point)) {
	                return result[idx];
	            }
	        }
	    },

	    assignZindex: function(elements) {
	        var this$1 = this;

	        for (var idx = 0; idx < elements.length; idx++) {
	            var element = elements[idx];
	            var zIndex = 0;
	            var levelWeight = Math.pow(LEVEL_STEP, MAX_LEVEL);
	            var parents = [];

	            while (element) {
	                parents.push(element);
	                element = element.parent;
	            }

	            while (parents.length) {
	                element = parents.pop();
	                zIndex += ((element.parent ? element.parent.children : this$1.rootElements).indexOf(element) + 1) * levelWeight;
	                levelWeight /= LEVEL_STEP;
	            }

	            elements[idx]._zIndex = zIndex;
	        }
	    },

	    optionsChange: function(e) {
	        if (e.field === "transform" || e.field === "stroke.width") {
	            this.bboxChange(e.element);
	        }
	    },

	    geometryChange: function(e) {
	        this.bboxChange(e.element);
	    },

	    bboxChange: function(element) {
	        var this$1 = this;

	        if (element.nodeType === "Group") {
	            for (var idx = 0; idx < element.children.length; idx++) {
	                this$1.bboxChange(element.children[idx]);
	            }
	        } else {
	            if (element._quadNode) {
	                element._quadNode.remove(element);
	            }
	            this._insertShape(element);
	        }
	    },

	    add: function(elements) {
	        var elementsArray = Array.isArray(elements) ? elements.slice(0) : [ elements ];

	        append(this.rootElements, elementsArray);
	        this._insert(elementsArray);
	    },

	    childrenChange: function(e) {
	        var this$1 = this;

	        if (e.action === "remove") {
	            for (var idx = 0; idx < e.items.length; idx++) {
	                this$1.remove(e.items[idx]);
	            }
	        } else {
	            this._insert(Array.prototype.slice.call(e.items, 0));
	        }
	    },

	    _insert: function(elements) {
	        var this$1 = this;

	        var element;

	        while (elements.length > 0) {
	            element = elements.pop();
	            element.addObserver(this$1);
	            if (element.nodeType === "Group") {
	                append(elements, element.children);
	            } else {
	                this$1._insertShape(element);
	            }
	        }
	    },

	    _insertShape: function(shape) {
	        var bbox = shape.bbox();
	        if (bbox) {
	            var sectors = this.getSectors(bbox);
	            var x = sectors[0][0];
	            var y = sectors[1][0];

	            if (this.inRoot(sectors)) {
	                this.root.insert(shape, bbox);
	            } else {
	                var rootMap = this.rootMap;
	                if (!rootMap[x]) {
	                    rootMap[x] = {};
	                }

	                if (!rootMap[x][y]) {
	                    rootMap[x][y] = new QuadNode(
	                        new Rect([ x * ROOT_SIZE, y * ROOT_SIZE ], [ ROOT_SIZE, ROOT_SIZE ])
	                    );
	                }

	                rootMap[x][y].insert(shape, bbox);
	            }
	        }
	    },

	    remove: function(element) {
	        var this$1 = this;

	        element.removeObserver(this);

	        if (element.nodeType === "Group") {
	            var children = element.children;
	            for (var idx = 0; idx < children.length; idx++) {
	                this$1.remove(children[idx]);
	            }
	        } else if (element._quadNode) {
	            element._quadNode.remove(element);
	            delete element._quadNode;
	        }
	    },

	    inRoot: function(sectors) {
	        return sectors[0].length > 1 || sectors[1].length > 1;
	    },

	    getSectors: function(rect) {
	        var bottomRight = rect.bottomRight();
	        var bottomX = Math.floor(bottomRight.x / ROOT_SIZE);
	        var bottomY = Math.floor(bottomRight.y / ROOT_SIZE);
	        var sectors = [ [], [] ];
	        for (var x = Math.floor(rect.origin.x / ROOT_SIZE); x <= bottomX; x++) {
	            sectors[0].push(x);
	        }
	        for (var y = Math.floor(rect.origin.y / ROOT_SIZE); y <= bottomY; y++) {
	            sectors[1].push(y);
	        }
	        return sectors;
	    }
	});

	function zIndexComparer(x1, x2) {
	    if (x1._zIndex < x2._zIndex) {
	        return 1;
	    }
	    if (x1._zIndex > x2._zIndex) {
	        return -1;
	    }

	    return 0;
	}

	var SurfaceCursor = Class.extend({
	    init: function(surface) {
	        surface.bind("mouseenter", this._mouseenter.bind(this));
	        surface.bind("mouseleave", this._mouseleave.bind(this));

	        this.element = surface.element;
	    },

	    clear: function() {
	        this._resetCursor();
	    },

	    destroy: function() {
	        this._resetCursor();
	        delete this.element;
	    },

	    _mouseenter: function(e) {
	        var cursor = this._shapeCursor(e);

	        if (!cursor) {
	            this._resetCursor();
	        } else {
	            if (!this._current) {
	                this._defaultCursor = this._getCursor();
	            }

	            this._setCursor(cursor);
	        }
	    },

	    _mouseleave: function() {
	        this._resetCursor();
	    },

	    _shapeCursor: function(e) {
	        var shape = e.element;

	        while (shape && !defined(shape.options.cursor)) {
	            shape = shape.parent;
	        }

	        if (shape) {
	            return shape.options.cursor;
	        }
	    },

	    _getCursor: function() {
	        if (this.element) {
	            return this.element.style.cursor;
	        }
	    },

	    _setCursor: function(cursor) {
	        if (this.element) {
	            this.element.style.cursor = cursor;
	            this._current = cursor;
	        }
	    },

	    _resetCursor: function() {
	        if (this._current) {
	            this._setCursor(this._defaultCursor || "");
	            delete this._current;
	        }
	    }
	});

	var Surface$3 = Surface.extend({
	    init: function(element, options) {
	        Surface.fn.init.call(this, element, options);

	        this.element.innerHTML = this._template(this);

	        var canvas = this.element.firstElementChild;
	        var size = elementSize(element);

	        canvas.width = size.width;
	        canvas.height = size.height;

	        this._rootElement = canvas;

	        this._root = new RootNode$2(canvas, size);

	        this._mouseTrackHandler = this._trackMouse.bind(this);

	        bindEvents(this.element, {
	            click: this._mouseTrackHandler,
	            mousemove: this._mouseTrackHandler
	        });
	    },

	    destroy: function() {
	        Surface.fn.destroy.call(this);

	        if (this._root) {
	            this._root.destroy();
	            this._root = null;
	        }

	        if (this._searchTree) {
	            this._searchTree.clear();
	            delete this._searchTree;
	        }

	        if (this._cursor) {
	            this._cursor.destroy();
	            delete this._cursor;
	        }

	        unbindEvents(this.element, {
	            click: this._mouseTrackHandler,
	            mousemove: this._mouseTrackHandler
	        });
	    },

	    draw: function(element) {
	        Surface.fn.draw.call(this, element);
	        this._root.load([ element ], undefined, this.options.cors);

	        if (this._searchTree) {
	            this._searchTree.add([ element ]);
	        }
	    },

	    clear: function() {
	        Surface.fn.clear.call(this);
	        this._root.clear();

	        if (this._searchTree) {
	            this._searchTree.clear();
	        }

	        if (this._cursor) {
	            this._cursor.clear();
	        }
	    },

	    eventTarget: function(e) {
	        if (this._searchTree) {
	            var point = this._surfacePoint(e);
	            var shape = this._searchTree.pointShape(point);
	            return shape;
	        }
	    },

	    image: function() {
	        var ref = this;
	        var root = ref._root;
	        var rootElement = ref._rootElement;
	        var loadingStates = [];

	        root.traverse(function (childNode) {
	            if (childNode.loading) {
	                loadingStates.push(childNode.loading);
	            }
	        });

	        var promise = createPromise();
	        var resolveDataURL = function () {
	            root._invalidate({ fixedScale: true });

	            try {
	                var data = rootElement.toDataURL();
	                promise.resolve(data);
	            } catch (e) {
	                promise.reject(e);
	            }
	        };

	        promiseAll(loadingStates).then(resolveDataURL, resolveDataURL);

	        return promise;
	    },

	    suspendTracking: function() {
	        Surface.fn.suspendTracking.call(this);
	        if (this._searchTree) {
	            this._searchTree.clear();
	            delete this._searchTree;
	        }
	    },

	    resumeTracking: function() {
	        Surface.fn.resumeTracking.call(this);
	        if (!this._searchTree) {
	            this._searchTree = new ShapesQuadTree();

	            var childNodes = this._root.childNodes;
	            var rootElements = [];
	            for (var idx = 0; idx < childNodes.length; idx++) {
	                rootElements.push(childNodes[idx].srcElement);
	            }
	            this._searchTree.add(rootElements);
	        }
	    },

	    _resize: function() {
	        this._rootElement.width = this._size.width;
	        this._rootElement.height = this._size.height;

	        this._root.size = this._size;
	        this._root.invalidate();
	    },

	    _template: function() {
	        return "<canvas style='width: 100%; height: 100%;'></canvas>";
	    },

	    _enableTracking: function() {
	        this._searchTree = new ShapesQuadTree();
	        this._cursor = new SurfaceCursor(this);

	        Surface.fn._enableTracking.call(this);
	    },

	    _trackMouse: function(e) {
	        if (this._suspendedTracking) {
	            return;
	        }

	        var shape = this.eventTarget(e);

	        if (e.type !== "click") {
	            var currentShape = this._currentShape;
	            if (currentShape && currentShape !== shape) {
	                this.trigger("mouseleave", {
	                    element: currentShape,
	                    originalEvent: e,
	                    type: "mouseleave"
	                });
	            }

	            if (shape && currentShape !== shape) {
	                this.trigger("mouseenter", {
	                    element: shape,
	                    originalEvent: e,
	                    type: "mouseenter"
	                });
	            }

	            this.trigger("mousemove", {
	                element: shape,
	                originalEvent: e,
	                type: "mousemove"
	            });

	            this._currentShape = shape;
	        } else if (shape) {
	            this.trigger("click", {
	                element: shape,
	                originalEvent: e,
	                type: "click"
	            });
	        }
	    }
	});

	Surface$3.prototype.type = "canvas";

	if (typeof document !== "undefined" && document.createElement("canvas").getContext) {
	    Surface.support.canvas = true;
	    SurfaceFactory.current.register("canvas", Surface$3, 20);
	}

	function addGradientStops(gradient, stops) {
	    for (var idx = 0; idx < stops.length; idx++) {
	        var stop = stops[idx];
	        var color = kendo.parseColor(stop.color());

	        color.a *= stop.opacity();

	        gradient.addColorStop(stop.offset(), color.toCssRgba());
	    }
	}

	var PathNode$2 = Node$2.extend({
	    renderTo: function(ctx) {
	        ctx.save();

	        this.setTransform(ctx);
	        this.setClip(ctx);
	        this.setOpacity(ctx);

	        ctx.beginPath();

	        this.renderPoints(ctx, this.srcElement);

	        this.setLineDash(ctx);
	        this.setLineCap(ctx);
	        this.setLineJoin(ctx);

	        this.setFill(ctx);
	        this.setStroke(ctx);

	        ctx.restore();
	    },

	    setFill: function(ctx) {
	        var fill = this.srcElement.options.fill;
	        var hasFill = false;

	        if (fill) {
	            if (fill.nodeType === "Gradient") {
	                this.setGradientFill(ctx, fill);
	                hasFill = true;
	            } else if (!isTransparent(fill.color)) {
	                ctx.fillStyle = fill.color;

	                ctx.save();
	                this.globalAlpha(ctx, fill.opacity);
	                ctx.fill();
	                ctx.restore();

	                hasFill = true;
	            }
	        }

	        return hasFill;
	    },

	    setGradientFill: function(ctx, fill) {
	        var bbox = this.srcElement.rawBBox();
	        var gradient;

	        if (fill instanceof LinearGradient) {
	            var start = fill.start();
	            var end = fill.end();
	            gradient = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
	        } else if (fill instanceof RadialGradient) {
	            var center = fill.center();
	            gradient = ctx.createRadialGradient(center.x, center.y, 0, center.x, center.y, fill.radius());
	        }

	        addGradientStops(gradient, fill.stops);

	        ctx.save();

	        if (!fill.userSpace()) {
	            ctx.transform(bbox.width(), 0, 0, bbox.height(), bbox.origin.x, bbox.origin.y);
	        }
	        ctx.fillStyle = gradient;
	        ctx.fill();

	        ctx.restore();
	    },

	    setStroke: function(ctx) {
	        var stroke = this.srcElement.options.stroke;
	        if (stroke && !isTransparent(stroke.color) && stroke.width > 0) {
	            ctx.strokeStyle = stroke.color;
	            ctx.lineWidth = valueOrDefault(stroke.width, 1);

	            ctx.save();
	            this.globalAlpha(ctx, stroke.opacity);
	            ctx.stroke();
	            ctx.restore();

	            return true;
	        }
	    },

	    dashType: function() {
	        var stroke = this.srcElement.options.stroke;
	        if (stroke && stroke.dashType) {
	            return stroke.dashType.toLowerCase();
	        }
	    },

	    setLineDash: function(ctx) {
	        var dashType = this.dashType();
	        if (dashType && dashType !== SOLID) {
	            var dashArray = DASH_ARRAYS[dashType];
	            if (ctx.setLineDash) {
	                ctx.setLineDash(dashArray);
	            } else {
	                ctx.mozDash = dashArray;
	                ctx.webkitLineDash = dashArray;
	            }
	        }
	    },

	    setLineCap: function(ctx) {
	        var dashType = this.dashType();
	        var stroke = this.srcElement.options.stroke;
	        if (dashType && dashType !== SOLID) {
	            ctx.lineCap = BUTT;
	        } else if (stroke && stroke.lineCap) {
	            ctx.lineCap = stroke.lineCap;
	        }
	    },

	    setLineJoin: function(ctx) {
	        var stroke = this.srcElement.options.stroke;
	        if (stroke && stroke.lineJoin) {
	            ctx.lineJoin = stroke.lineJoin;
	        }
	    },

	    renderPoints: function(ctx, path) {
	        renderPath(ctx, path);
	    }
	});

	NODE_MAP$2.Path = PathNode$2;

	var ArcNode$2 = PathNode$2.extend({
	    renderPoints: function(ctx) {
	        var path = this.srcElement.toPath();
	        renderPath(ctx, path);
	    }
	});

	NODE_MAP$2.Arc = ArcNode$2;

	var CircleNode$2 = PathNode$2.extend({
	    renderPoints: function(ctx) {
	        var ref = this.srcElement.geometry();
	        var center = ref.center;
	        var radius = ref.radius;

	        ctx.arc(center.x, center.y, radius, 0, Math.PI * 2);
	    }
	});

	NODE_MAP$2.Circle = CircleNode$2;

	var RectNode$2 = PathNode$2.extend({
	    renderPoints: function(ctx) {
	        var ref = this.srcElement.geometry();
	        var origin = ref.origin;
	        var size = ref.size;

	        ctx.rect(origin.x, origin.y, size.width, size.height);
	    }
	});

	NODE_MAP$2.Rect = RectNode$2;

	var ImageNode$2 = PathNode$2.extend({
	    init: function(srcElement, cors) {
	        PathNode$2.fn.init.call(this, srcElement);

	        this.onLoad = this.onLoad.bind(this);
	        this.onError = this.onError.bind(this);

	        this.loading = createPromise();

	        var img = this.img = new Image();

	        if (cors && !(/^data:/i.test(srcElement.src()))) {
	            img.crossOrigin = cors;
	        }

	        img.src = srcElement.src();

	        if (img.complete) {
	            this.onLoad();
	        } else {
	            img.onload = this.onLoad;
	            img.onerror = this.onError;
	        }
	    },

	    renderTo: function(ctx) {
	        if (this.loading.state() === "resolved") {
	            ctx.save();

	            this.setTransform(ctx);
	            this.setClip(ctx);

	            this.drawImage(ctx);

	            ctx.restore();
	        }
	    },

	    optionsChange: function(e) {
	        if (e.field === "src") {
	            this.loading = createPromise();
	            this.img.src = this.srcElement.src();
	        } else {
	            PathNode$2.fn.optionsChange.call(this, e);
	        }
	    },

	    onLoad: function() {
	        this.loading.resolve();
	        this.invalidate();
	    },

	    onError: function() {
	        this.loading.reject(new Error(
	            "Unable to load image '" + this.img.src +
	            "'. Check for connectivity and verify CORS headers."
	        ));
	    },

	    drawImage: function(ctx) {
	        var rect = this.srcElement.rect();
	        var topLeft = rect.topLeft();

	        ctx.drawImage(
	            this.img, topLeft.x, topLeft.y, rect.width(), rect.height()
	        );
	    }
	});

	NODE_MAP$2.Image = ImageNode$2;

	var TextNode$2 = PathNode$2.extend({
	    renderTo: function(ctx) {
	        var text = this.srcElement;
	        var pos = text.position();
	        var size = text.measure();

	        ctx.save();

	        this.setTransform(ctx);
	        this.setClip(ctx);
	        this.setOpacity(ctx);

	        ctx.beginPath();

	        ctx.font = text.options.font;
	        ctx.textAlign = 'left';

	        if (this.setFill(ctx)) {
	            ctx.fillText(text.content(), pos.x, pos.y + size.baseline);
	        }

	        if (this.setStroke(ctx)) {
	            this.setLineDash(ctx);
	            ctx.strokeText(text.content(), pos.x, pos.y + size.baseline);
	        }

	        ctx.restore();
	    }
	});

	NODE_MAP$2.Text = TextNode$2;

	var MultiPathNode$2 = PathNode$2.extend({
	    renderPoints: function(ctx) {
	        var paths = this.srcElement.paths;
	        for (var i = 0; i < paths.length; i++) {
	            renderPath(ctx, paths[i]);
	        }
	    }
	});

	NODE_MAP$2.MultiPath = MultiPathNode$2;

	var canvas = {
		Surface: Surface$3,
		RootNode: RootNode$2,
		Node: Node$2,
		GroupNode: GroupNode$2,
		ArcNode: ArcNode$2,
		CircleNode: CircleNode$2,
		RectNode: RectNode$2,
		ImageNode: ImageNode$2,
		TextNode: TextNode$2,
		PathNode: PathNode$2,
		MultiPathNode: MultiPathNode$2
	};

	function exportImage(group, options) {
	    var defaults = {
	        width: "800px", height: "600px",
	        cors: "Anonymous"
	    };

	    var exportRoot = group;
	    var bbox = group.clippedBBox();

	    if (bbox) {
	        var origin = bbox.getOrigin();
	        exportRoot = new Group();
	        exportRoot.transform(transform().translate(-origin.x, -origin.y));
	        exportRoot.children.push(group);

	        var size = bbox.getSize();
	        defaults.width = size.width + "px";
	        defaults.height = size.height + "px";
	    }

	    var surfaceOptions = $.extend(defaults, options);

	    var container = document.createElement("div");
	    var style = container.style;

	    style.display = "none";
	    style.width = surfaceOptions.width;
	    style.height = surfaceOptions.height;
	    document.body.appendChild(container);

	    var surface = new Surface$3(container, surfaceOptions);
	    surface.suspendTracking();
	    surface.draw(exportRoot);

	    var promise = surface.image();
	    var destroy = function () {
	        surface.destroy();
	        document.body.removeChild(container);
	    };
	    promise.then(destroy, destroy);

	    return promise;
	}

	function exportSVG(group, options) {
	    var svg = exportGroup(group);

	    if (!options || !options.raw) {
	        svg = "data:image/svg+xml;base64," + encodeBase64(svg);
	    }

	    return createPromise().resolve(svg);
	}

	/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
	/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
	/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty, yoda */
	/* eslint-disable no-param-reassign, no-var, block-scoped-var */

	var browser = supportBrowser || {};
	/*

	  XXX: to test:

	  - cloneNodes function:
	    - drawing document containing canvas with page breaking
	    - drawing document with named radio <input>-s (should not clear selection)
	    - IE9/IE10 don't support el.dataset; do they copy user data?

	  - repeating table headers/footers on page breaking

	  - forceBreak, keepTogether

	  - avoidLinks

	 */

	/* -----[ local vars ]----- */

	function slice$1(thing) {
	    return Array.prototype.slice.call(thing);
	}

	var KENDO_PSEUDO_ELEMENT = "KENDO-PSEUDO-ELEMENT";

	var IMAGE_CACHE = {};

	var nodeInfo = {};
	nodeInfo._root = nodeInfo;

	/* -----[ Custom Text node to speed up rendering in kendo.pdf ]----- */

	var inBrowser = typeof window !== 'undefined';
	var microsoft = inBrowser ? browser.msie || browser.edge : false;

	var TextRect = Text.extend({
	    init: function(str, rect, options) {
	        Text.fn.init.call(this, str, rect.getOrigin(), options);
	        this._pdfRect = rect;
	    },

	    rect: function() {
	        // this is the crux of it: we can avoid a call to
	        // measure(), which is what the base class does, since we
	        // already know the rect.  measure() is s-l-o-w.
	        return this._pdfRect;
	    },

	    rawBBox: function() {
	        // also let's avoid creating a new rectangle.
	        return this._pdfRect;
	    }
	});

	function addClass(el, cls) {
	    if (el.classList) {
	        el.classList.add(cls);
	    } else {
	        el.className += " " + cls;
	    }
	}

	function removeClass(el, cls) {
	    if (el.classList) {
	        el.classList.remove(cls);
	    } else {
	        el.className = el.className.split(/\s+/).reduce(function(a, word){
	            if (word != cls) {
	                a.push(word);
	            }
	            return a;
	        }, []).join(" ");
	    }
	}

	function setCSS(el, styles) {
	    Object.keys(styles).forEach(function(key){
	        el.style[key] = styles[key];
	    });
	}

	var matches = typeof Element !== "undefined" && Element.prototype && (function(p){
	    if (p.matches) {
	        return function(el, selector) { return el.matches(selector); };
	    }
	    if (p.webkitMatchesSelector) {
	        return function(el, selector) { return el.webkitMatchesSelector(selector); };
	    }
	    if (p.mozMatchesSelector) {
	        return function(el, selector) { return el.mozMatchesSelector(selector); };
	    }
	    if (p.msMatchesSelector) {
	        return function(el, selector) { return el.msMatchesSelector(selector); };
	    }
	    return function(s) {
		return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
	    };
	})(Element.prototype);

	function closest(el, selector) {
	    if (el.closest) {
	        return el.closest(selector);
	    }
	    // IE: stringifying rather than simply comparing with `document`,
	    // which is not iframe-proof and fails in editor export —
	    // https://github.com/telerik/kendo/issues/6721
	    while (el && !/^\[object (?:HTML)?Document\]$/.test(String(el))) {
	        if (el.nodeType == 1 /* Element */ && matches(el, selector)) {
	            return el;
	        }
	        el = el.parentNode;
	    }
	}

	// clone nodes ourselves, so that we redraw <canvas> (DOM or
	// jQuery clone will not)
	var cloneNodes = (function($){
	    if ($) {
	        // if we have Kendo and jQuery, use this version as it will
	        // maintain proper links between cloned element and Kendo
	        // widgets (i.e. it clones jQuery data(), which isn't the same
	        // as element's data attributes).
	        // https://github.com/telerik/kendo-ui-core/issues/2750
	        return function cloneNodes(el) {
	            var clone = el.cloneNode(false);
	            if (el.nodeType == 1 /* Element */) {
	                var $el = $(el), $clone = $(clone), i;
	                var data = $el.data();
	                for (i in data) {
	                    $clone.data(i, data[i]);
	                }
	                if (/^canvas$/i.test(el.tagName)) {
	                    clone.getContext("2d").drawImage(el, 0, 0);
	                } else if (/^(?:input|select|textarea|option)$/i.test(el.tagName)) {
	                    // drop the name attributes so that we don't affect the selection of the
	                    // original nodes (i.e. checked status of radio buttons) when we insert our copy
	                    // into the DOM.  https://github.com/telerik/kendo/issues/5409
	                    clone.removeAttribute("id");
	                    clone.removeAttribute("name");
	                    if (!/^textarea$/i.test(el.tagName)) {
	                        clone.value = el.value;
	                    }
	                    clone.checked = el.checked;
	                    clone.selected = el.selected;
	                }
	                for (i = el.firstChild; i; i = i.nextSibling) {
	                    clone.appendChild(cloneNodes(i));
	                }
	            }
	            return clone;
	        };
	    } else {
	        // the no-jQuery version
	        return function cloneNodes(el) {
	            var clone = (function dive(node){
	                var clone = node.cloneNode(false);
	                if (node._kendoExportVisual) {
	                    clone._kendoExportVisual = node._kendoExportVisual;
	                }
	                for (var i = node.firstChild; i; i = i.nextSibling) {
	                    clone.appendChild(dive(i));
	                }
	                return clone;
	            })(el);

	            // re-draw canvases - https://github.com/telerik/kendo/issues/4872
	            var canvases = el.querySelectorAll("canvas");
	            if (canvases.length) {
	                slice$1(clone.querySelectorAll("canvas")).forEach(function (canvas$$1, i) {
	                    canvas$$1.getContext("2d").drawImage(canvases[i], 0, 0);
	                });
	            }

	            // remove "name" attributes from <input> elements -
	            // https://github.com/telerik/kendo/issues/5409
	            var orig = el.querySelectorAll("input, select, textarea, option");
	            slice$1(clone.querySelectorAll("input, select, textarea, option")).forEach(function (el, i) {
	                el.removeAttribute("id");
	                el.removeAttribute("name");
	                if (!/^textarea$/i.test(el.tagName)) {
	                    el.value = orig[i].value;
	                }
	                el.checked = orig[i].checked;
	                el.selected = orig[i].selected;
	            });

	            return clone;
	        };
	    }
	})(typeof window !== "undefined" && window.kendo && window.kendo.jQuery);

	function getXY(thing) {
	    if (typeof thing == "number") {
	        return { x: thing, y: thing };
	    }
	    if (Array.isArray(thing)) {
	        return { x: thing[0], y: thing[1] };
	    }
	    return { x: thing.x, y: thing.y };
	}

	function drawDOM(element, options) {
	    if (!options) {
	        options = {};
	    }
	    var promise = createPromise();

	    if (!element) {
	        return promise.reject("No element to export");
	    }

	    if (typeof window.getComputedStyle != "function") {
	        throw new Error("window.getComputedStyle is missing.  You are using an unsupported browser, or running in IE8 compatibility mode.  Drawing HTML is supported in Chrome, Firefox, Safari and IE9+.");
	    }

	    kendo.pdf.defineFont(getFontFaces(element.ownerDocument));

	    var scale = getXY(options.scale || 1);

	    function doOne(element) {
	        var group = new Group();

	        // translate to start of page
	        var pos = element.getBoundingClientRect();
	        setTransform(group, [
	            scale.x,
	            0,
	            0,
	            scale.y,
	            (-pos.left * scale.x),
	            (-pos.top * scale.y)
	        ]);

	        nodeInfo._clipbox = false;
	        nodeInfo._matrix = Matrix.unit();
	        nodeInfo._stackingContext = {
	            element: element,
	            group: group
	        };

	        if (options.avoidLinks === true) {
	            nodeInfo._avoidLinks = "a";
	        } else {
	            nodeInfo._avoidLinks = options.avoidLinks;
	        }

	        addClass(element, "k-pdf-export");
	        renderElement(element, group);
	        removeClass(element, "k-pdf-export");

	        return group;
	    }

	    cacheImages(element, function(){
	        var forceBreak = options && options.forcePageBreak;
	        var hasPaperSize = options && options.paperSize && options.paperSize != "auto";
	        var paperOptions = kendo.pdf.getPaperOptions(function(key, def){
	            if (key == "paperSize") {
	                // PDF.getPaperOptions croaks on "auto", just pass dummy A4 as we might
	                // still be interested in margins.
	                return hasPaperSize ? options[key] : "A4";
	            }
	            return key in options ? options[key] : def;
	        });
	        var pageWidth = hasPaperSize && paperOptions.paperSize[0];
	        var pageHeight = hasPaperSize && paperOptions.paperSize[1];
	        var margin = options.margin && paperOptions.margin;
	        var hasMargin = Boolean(margin);
	        if (forceBreak || pageHeight) {
	            if (!margin) {
	                margin = { left: 0, top: 0, right: 0, bottom: 0 };
	            }

	            // we want paper size and margin to be unaffected by
	            // scaling in the output, so we have to reverse-scale
	            // before our calculations begin.
	            if (pageWidth)  { pageWidth  /= scale.x; }
	            if (pageHeight) { pageHeight /= scale.y; }
	            margin.left   /= scale.x;
	            margin.right  /= scale.x;
	            margin.top    /= scale.y;
	            margin.bottom /= scale.y;

	            var group = new Group({
	                pdf: {
	                    multiPage     : true,
	                    paperSize     : hasPaperSize ? paperOptions.paperSize : "auto",
	                    _ignoreMargin : hasMargin // HACK!  see exportPDF in pdf/drawing.js
	                }
	            });
	            handlePageBreaks(
	                function(x) {
	                    if (options.progress) {
	                        var canceled = false, pageNum = 0;
	                        (function next(){
	                            if (pageNum < x.pages.length) {
	                                var page = doOne(x.pages[pageNum]);
	                                group.append(page);
	                                options.progress({
	                                    page: page,
	                                    pageNum: ++pageNum,
	                                    totalPages: x.pages.length,
	                                    cancel: function() {
	                                        canceled = true;
	                                    }
	                                });
	                                if (!canceled) {
	                                    setTimeout(next);
	                                } else {
	                                    // XXX: should we also fail() the deferred object?
	                                    x.container.parentNode.removeChild(x.container);
	                                }
	                            } else {
	                                x.container.parentNode.removeChild(x.container);
	                                promise.resolve(group);
	                            }
	                        })();
	                    } else {
	                        x.pages.forEach(function(page){
	                            group.append(doOne(page));
	                        });
	                        x.container.parentNode.removeChild(x.container);
	                        promise.resolve(group);
	                    }
	                },
	                element,
	                forceBreak,
	                pageWidth ? pageWidth - margin.left - margin.right : null,
	                pageHeight ? pageHeight - margin.top - margin.bottom : null,
	                margin,
	                options
	            );
	        } else {
	            promise.resolve(doOne(element));
	        }
	    });

	    function makeTemplate(template$$1) {
	        if (template$$1 != null) {
	            if (typeof template$$1 == "string") {
	                template$$1 = kendo.template(template$$1.replace(/^\s+|\s+$/g, ""));
	            }
	            if (typeof template$$1 == "function") {
	                return function(data) {
	                    var el = template$$1(data);
	                    if (el && typeof el == "string") {
	                        var div = document.createElement("div");
	                        div.innerHTML = el;
	                        el = div.firstElementChild;
	                    }
	                    return el;
	                };
	            }
	            // assumed DOM element
	            return function() {
	                return template$$1.cloneNode(true);
	            };
	        }
	    }

	    function handlePageBreaks(callback, element, forceBreak, pageWidth, pageHeight, margin, options) {
	        var template$$1 = makeTemplate(options.template);
	        var doc = element.ownerDocument;
	        var pages = [];
	        var copy = options._destructive ? element : cloneNodes(element);
	        var container = doc.createElement("KENDO-PDF-DOCUMENT");
	        var adjust = 0;

	        // make sure <tfoot> elements are at the end (Grid widget
	        // places TFOOT before TBODY, tricking our algorithm to
	        // insert a page break right after the header).
	        // https://github.com/telerik/kendo/issues/4699
	        slice$1(copy.querySelectorAll("tfoot")).forEach(function(tfoot){
	            tfoot.parentNode.appendChild(tfoot);
	        });

	        // remember the index of each LI from an ordered list.
	        // we'll use it to reconstruct the proper numbering.
	        slice$1(copy.querySelectorAll("ol")).forEach(function(ol){
	            slice$1(ol.children).forEach(function(li, index){
	                li.setAttribute("kendo-split-index", index);
	            });
	        });

	        setCSS(container, {
	            display   : "block",
	            position  : "absolute",
	            boxSizing : "content-box",
	            left      : "-10000px",
	            top       : "-10000px"
	        });

	        if (pageWidth) {
	            // subtle: if we don't set the width *and* margins here, the layout in this
	            // container will be different from the one in our final page elements, and we'll
	            // split at the wrong places.
	            setCSS(container, {
	                width        : pageWidth + "px",
	                paddingLeft  : margin.left + "px",
	                paddingRight : margin.right + "px"
	            });

	            // when the first element has a margin-top (i.e. a <h1>) the page will be
	            // inadvertently enlarged by that number (the browser will report the container's
	            // bounding box top to start at the element's top, rather than including its
	            // margin).  Adding overflow: hidden seems to fix it.
	            //
	            // to understand the difference, try the following snippets in your browser:
	            //
	            // 1. <div style="background: yellow">
	            //      <h1 style="margin: 3em">Foo</h1>
	            //    </div>
	            //
	            // 2. <div style="background: yellow; overflow: hidden">
	            //      <h1 style="margin: 3em">Foo</h1>
	            //    </div>
	            //
	            // this detail is not important when automatic page breaking is not requested, hence
	            // doing it only if pageWidth is defined.
	            setCSS(copy, { overflow: "hidden" });
	        }

	        element.parentNode.insertBefore(container, element);
	        container.appendChild(copy);

	        // we need the timeouts here, so that images dimensions are
	        // properly computed in DOM when we start our thing.
	        if (options.beforePageBreak) {
	            setTimeout(function(){
	                options.beforePageBreak(container, doPageBreak);
	            }, 15);
	        } else {
	            setTimeout(doPageBreak, 15);
	        }

	        function doPageBreak() {
	            if (forceBreak != "-" || pageHeight) {
	                splitElement(copy);
	            }

	            {
	                var page = makePage();
	                copy.parentNode.insertBefore(page, copy);
	                page.appendChild(copy);
	            }

	            if (template$$1) {
	                pages.forEach(function(page, i){
	                    var el = template$$1({
	                        element    : page,
	                        pageNum    : i + 1,
	                        totalPages : pages.length
	                    });
	                    if (el) {
	                        page.appendChild(el);
	                    }
	                });
	            }

	            cacheImages(pages, function() {
	                // Even though we already cached images, they simply won't be available
	                // immediately in the newly created DOM.  Previously we'd allow a 10ms timeout,
	                // but that's arbitrary and clearly not working in all cases
	                // (https://github.com/telerik/kendo/issues/5399), so this function will wait
	                // for their .complete attribute.
	                whenImagesAreActuallyLoaded(pages, function(){
	                    callback({ pages: pages, container: container });
	                });
	            });
	        }

	        function keepTogether(el) {
	            if (options.keepTogether && matches(el, options.keepTogether) && el.offsetHeight <= pageHeight - adjust) {
	                return true;
	            }

	            var tag = el.tagName;
	            if (/^h[1-6]$/i.test(tag) && el.offsetHeight >= pageHeight - adjust) {
	                return false;
	            }

	            return (el.getAttribute("data-kendo-chart") ||
	                    /^(?:img|tr|thead|th|tfoot|iframe|svg|object|canvas|input|textarea|select|video|h[1-6])/i.test(el.tagName));
	        }

	        function splitElement(element) {
	            if (element.tagName == "TABLE") {
	                setCSS(element, { tableLayout: "fixed" });
	            }
	            if (keepTogether(element)) {
	                return;
	            }
	            var style = getComputedStyle$1(element);
	            var bottomPadding = parseFloat(getPropertyValue(style, "padding-bottom"));
	            var bottomBorder = parseFloat(getPropertyValue(style, "border-bottom-width"));
	            var saveAdjust = adjust;
	            adjust += bottomPadding + bottomBorder;
	            var isFirst = true;
	            for (var el = element.firstChild; el; el = el.nextSibling) {
	                if (el.nodeType == 1 /* Element */) {
	                    isFirst = false;
	                    if (matches(el, forceBreak)) {
	                        breakAtElement(el);
	                        continue;
	                    }
	                    if (!pageHeight) {
	                        // we're in "manual breaks mode"
	                        splitElement(el);
	                        continue;
	                    }
	                    if (!/^(?:static|relative)$/.test(getPropertyValue(getComputedStyle$1(el), "position"))) {
	                        continue;
	                    }
	                    var fall = fallsOnMargin(el);
	                    if (fall == 1) {
	                        // element starts on next page, break before anyway.
	                        breakAtElement(el);
	                    }
	                    else if (fall) {
	                        // elements ends up on next page, or possibly doesn't fit on a page at
	                        // all.  break before it anyway if it's an <img> or <tr>, otherwise
	                        // attempt to split.
	                        if (keepTogether(el)) {
	                            breakAtElement(el);
	                        } else {
	                            splitElement(el);
	                        }
	                    }
	                    else {
	                        splitElement(el);
	                    }
	                }
	                else if (el.nodeType == 3 /* Text */ && pageHeight) {
	                    splitText(el, isFirst);
	                    isFirst = false;
	                }
	            }
	            adjust = saveAdjust;
	        }

	        function firstInParent(el) {
	            var p = el.parentNode, first = p.firstChild;
	            if (el === first) {
	                return true;
	            }
	            if (el === p.children[0]) {
	                if (first.nodeType == 7 /* comment */ ||
	                    first.nodeType == 8 /* processing instruction */) {
	                    return true;
	                }
	                if (first.nodeType == 3 /* text */) {
	                    // if whitespace only we can probably consider it's first
	                    return !/\S/.test(first.data);
	                }
	            }
	            return false;
	        }

	        function breakAtElement(el) {
	            if (el.nodeType == 1 && el !== copy && firstInParent(el)) {
	                return breakAtElement(el.parentNode);
	            }
	            var table, colgroup, thead, grid, gridHead;
	            table = closest(el, "table");
	            colgroup = table && table.querySelector("colgroup");
	            if (options.repeatHeaders) {
	                thead = table && table.querySelector("thead");

	                // If we break page in a Kendo Grid, repeat its header.  This ugly hack is
	                // necessary because a scrollable grid will keep the header in a separate
	                // <table> element from its content.
	                //
	                // XXX: This is likely to break as soon as the widget HTML is modified.
	                grid = closest(el, ".k-grid.k-widget");
	                if (grid && grid.querySelector(".k-auto-scrollable")) {
	                    gridHead = grid.querySelector(".k-grid-header");
	                }
	            }
	            var page = makePage();
	            var range = doc.createRange();
	            range.setStartBefore(copy);
	            range.setEndBefore(el);
	            page.appendChild(range.extractContents());
	            copy.parentNode.insertBefore(page, copy);
	            preventBulletOnListItem(el.parentNode);
	            if (table) {
	                table = closest(el, "table"); // that's the <table> on next page!
	                if (options.repeatHeaders && thead) {
	                    table.insertBefore(thead.cloneNode(true), table.firstChild);
	                }
	                if (colgroup) {
	                    table.insertBefore(colgroup.cloneNode(true), table.firstChild);
	                }
	            }
	            if (options.repeatHeaders && gridHead) {
	                grid = closest(el, ".k-grid.k-widget");
	                grid.insertBefore(gridHead.cloneNode(true), grid.firstChild);
	            }
	        }

	        function makePage() {
	            var page = doc.createElement("KENDO-PDF-PAGE");
	            setCSS(page, {
	                display  : "block",
	                boxSizing: "content-box",
	                width    : pageWidth ? (pageWidth + "px") : "auto",
	                padding  : (margin.top + "px " +
	                            margin.right + "px " +
	                            margin.bottom + "px " +
	                            margin.left + "px"),

	                // allow absolutely positioned elements to be relative to current page
	                position : "relative",

	                // without the following we might affect layout of subsequent pages
	                height   : pageHeight ? (pageHeight + "px") : "auto",
	                overflow : pageHeight || pageWidth ? "hidden" : "visible",
	                clear    : "both"
	            });

	            // debug
	            // $("<div>").css({
	            //     position  : "absolute",
	            //     left      : margin.left,
	            //     top       : margin.top,
	            //     width     : pageWidth,
	            //     height    : pageHeight,
	            //     boxSizing : "border-box",
	            //     background: "rgba(255, 255, 0, 0.5)"
	            //     //border    : "1px solid red"
	            // }).appendTo(page);

	            if (options && options.pageClassName) {
	                page.className = options.pageClassName;
	            }
	            pages.push(page);
	            return page;
	        }

	        function fallsOnMargin(thing) {
	            var box = thing.getBoundingClientRect();
	            if (box.width === 0 || box.height === 0) {
	                // I'd say an element with dimensions zero fits on current page.
	                return 0;
	            }
	            var top = copy.getBoundingClientRect().top;
	            var available = pageHeight - adjust;
	            return (box.height > available) ? 3
	                : (box.top - top > available) ? 1
	                : (box.bottom - top > available) ? 2
	                : 0;
	        }

	        function splitText(node, isFirst) {
	            if (!/\S/.test(node.data)) {
	                return;
	            }

	            var len = node.data.length;
	            var range = doc.createRange();
	            range.selectNodeContents(node);
	            var fall = fallsOnMargin(range);
	            if (!fall) {
	                return;     // the whole text fits on current page
	            }

	            var nextnode = node;
	            if (fall == 1) {
	                // starts on next page, break before anyway.
	                if (isFirst) {
	                    // avoid leaving an empty <p>, <li>, etc. on previous page.
	                    breakAtElement(node.parentNode);
	                } else {
	                    breakAtElement(node);
	                }
	            }
	            else {
	                (function findEOP(min, pos, max) {
	                    range.setEnd(node, pos);
	                    if (min == pos || pos == max) {
	                        return pos;
	                    }
	                    if (fallsOnMargin(range)) {
	                        return findEOP(min, (min + pos) >> 1, pos);
	                    } else {
	                        return findEOP(pos, (pos + max) >> 1, max);
	                    }
	                })(0, len >> 1, len);

	                if (!/\S/.test(range.toString()) && isFirst) {
	                    // avoid leaving an empty <p>, <li>, etc. on previous page.
	                    breakAtElement(node.parentNode);
	                } else {
	                    // This is only needed for IE, but it feels cleaner to do it anyway.  Without
	                    // it, IE will truncate a very long text (playground/pdf-long-text-2.html).
	                    nextnode = node.splitText(range.endOffset);

	                    var page = makePage();
	                    range.setStartBefore(copy);
	                    page.appendChild(range.extractContents());
	                    copy.parentNode.insertBefore(page, copy);
	                    preventBulletOnListItem(nextnode.parentNode);
	                }
	            }

	            splitText(nextnode);
	        }

	        function preventBulletOnListItem(el) {
	            // set a hint on continued LI elements, to tell the
	            // renderer not to draw the bullet again.
	            // https://github.com/telerik/kendo-ui-core/issues/2732
	            var li = closest(el, "li");
	            if (li) {
	                li.setAttribute("kendo-no-bullet", "1");
	                preventBulletOnListItem(li.parentNode);
	            }
	        }
	    }

	    return promise;
	}

	drawDOM.getFontFaces = getFontFaces;

	// This is needed for the Spreadsheet print functionality.  Since
	// there we only need to draw text, this cuts through the ceremony
	// of drawDOM/renderElement and renders the text node directly.
	drawDOM.drawText = function(element) {
	    var group = new Group();
	    nodeInfo._clipbox = false;
	    nodeInfo._matrix = Matrix.unit();
	    nodeInfo._stackingContext = {
	        element: element,
	        group: group
	    };
	    pushNodeInfo(element, getComputedStyle$1(element), group);
	    if (element.firstChild.nodeType == 3 /* Text */) {
	        // avoid the penalty of renderElement
	        renderText(element, element.firstChild, group);
	    } else {
	        _renderElement(element, group);
	    }
	    popNodeInfo();
	    return group;
	};

	var parseBackgroundImage = (function(){
	    var tok_linear_gradient  = /^((-webkit-|-moz-|-o-|-ms-)?linear-gradient\s*)\(/;
	    //var tok_radial_gradient  = /^((-webkit-|-moz-|-o-|-ms-)?radial-gradient\s*)\(/;
	    var tok_percent          = /^([-0-9.]+%)/;
	    var tok_length           = /^([-0-9.]+px)/;
	    var tok_keyword          = /^(left|right|top|bottom|to|center)\W/;
	    var tok_angle            = /^([-0-9.]+(deg|grad|rad|turn)|0)/;
	    var tok_whitespace       = /^(\s+)/;
	    var tok_popen            = /^(\()/;
	    var tok_pclose           = /^(\))/;
	    var tok_comma            = /^(,)/;
	    var tok_url              = /^(url)\(/;
	    var tok_content          = /^(.*?)\)/;

	    var cache1 = {}, cache2 = {};

	    function parse(input) {
	        var orig = input;
	        if (hasOwnProperty(cache1, orig)) {
	            return cache1[orig];
	        }
	        function skip_ws() {
	            var m = tok_whitespace.exec(input);
	            if (m) {
	                input = input.substr(m[1].length);
	            }
	        }
	        function read(token) {
	            skip_ws();
	            var m = token.exec(input);
	            if (m) {
	                input = input.substr(m[1].length);
	                return m[1];
	            }
	        }

	        function read_stop() {
	            var color = kendo.parseColor(input, true);
	            var length, percent;
	            if (color) {
	                var match =
	                    /^#[0-9a-f]+/i.exec(input) ||
	                    /^rgba?\(.*?\)/i.exec(input) ||
	                    /^..*?\b/.exec(input); // maybe named color
	                input = input.substr(match[0].length);
	                color = color.toRGB();
	                if (!(length = read(tok_length))) {
	                    percent = read(tok_percent);
	                }
	                return { color: color, length: length, percent: percent };
	            }
	        }

	        function read_linear_gradient(propName) {
	            var angle;
	            var to1, to2;
	            var stops = [];
	            var reverse = false;

	            if (read(tok_popen)) {
	                // 1. [ <angle> || to <side-or-corner>, ]?
	                angle = read(tok_angle);
	                if (angle == "0") {
	                    angle = "0deg"; // Edge
	                }
	                if (angle) {
	                    angle = parseAngle(angle);
	                    read(tok_comma);
	                }
	                else {
	                    to1 = read(tok_keyword);
	                    if (to1 == "to") {
	                        to1 = read(tok_keyword);
	                    } else if (to1 && /^-/.test(propName)) {
	                        reverse = true;
	                    }
	                    to2 = read(tok_keyword);
	                    read(tok_comma);
	                }

	                if (/-moz-/.test(propName) && angle == null && to1 == null) {
	                    var x = read(tok_percent), y = read(tok_percent);
	                    reverse = true;
	                    if (x == "0%") {
	                        to1 = "left";
	                    } else if (x == "100%") {
	                        to1 = "right";
	                    }
	                    if (y == "0%") {
	                        to2 = "top";
	                    } else if (y == "100%") {
	                        to2 = "bottom";
	                    }
	                    read(tok_comma);
	                }

	                // 2. color stops
	                while (input && !read(tok_pclose)) {
	                    var stop = read_stop();
	                    if (!stop) {
	                        break;
	                    }
	                    stops.push(stop);
	                    read(tok_comma);
	                }

	                return {
	                    type    : "linear",
	                    angle   : angle,
	                    to      : to1 && to2 ? to1 + " " + to2 : to1 ? to1 : to2 ? to2 : null,
	                    stops   : stops,
	                    reverse : reverse
	                };
	            }
	        }

	        function read_url() {
	            if (read(tok_popen)) {
	                var url = read(tok_content);
	                url = url.replace(/^['"]+|["']+$/g, "");
	                read(tok_pclose);
	                return { type: "url", url: url };
	            }
	        }

	        var tok;

	        if ((tok = read(tok_linear_gradient))) {
	            tok = read_linear_gradient(tok);
	        }
	        else if ((tok = read(tok_url))) {
	            tok = read_url();
	        }

	        return (cache1[orig] = tok || { type: "none" });
	    }

	    return function(input) {
	        if (hasOwnProperty(cache2, input)) {
	            return cache2[input];
	        }
	        return (cache2[input] = splitProperty(input).map(parse));
	    };
	})();

	var splitProperty = (function(){
	    var cache = {};
	    return function(input, separator) {
	        if (!separator) {
	            separator = /^\s*,\s*/;
	        }

	        var cacheKey = input + separator;

	        if (hasOwnProperty(cache, cacheKey)) {
	            return cache[cacheKey];
	        }

	        var ret = [];
	        var last$$1 = 0, pos = 0;
	        var in_paren = 0;
	        var in_string = false;
	        var m;

	        function looking_at(rx) {
	            return (m = rx.exec(input.substr(pos)));
	        }

	        function trim(str) {
	            return str.replace(/^\s+|\s+$/g, "");
	        }

	        while (pos < input.length) {
	            if (!in_string && looking_at(/^[\(\[\{]/)) {
	                in_paren++;
	                pos++;
	            }
	            else if (!in_string && looking_at(/^[\)\]\}]/)) {
	                in_paren--;
	                pos++;
	            }
	            else if (!in_string && looking_at(/^[\"\']/)) {
	                in_string = m[0];
	                pos++;
	            }
	            else if (in_string == "'" && looking_at(/^\\\'/)) {
	                pos += 2;
	            }
	            else if (in_string == '"' && looking_at(/^\\\"/)) {
	                pos += 2;
	            }
	            else if (in_string == "'" && looking_at(/^\'/)) {
	                in_string = false;
	                pos++;
	            }
	            else if (in_string == '"' && looking_at(/^\"/)) {
	                in_string = false;
	                pos++;
	            }
	            else if (looking_at(separator)) {
	                if (!in_string && !in_paren && pos > last$$1) {
	                    ret.push(trim(input.substring(last$$1, pos)));
	                    last$$1 = pos + m[0].length;
	                }
	                pos += m[0].length;
	            }
	            else {
	                pos++;
	            }
	        }
	        if (last$$1 < pos) {
	            ret.push(trim(input.substring(last$$1, pos)));
	        }
	        return (cache[cacheKey] = ret);
	    };
	})();

	var getFontURL = (function(cache){
	    return function(el){
	        // XXX: for IE we get here the whole cssText of the rule,
	        // because the computedStyle.src is empty.  Next time we need
	        // to fix these regexps we better write a CSS parser. :-\
	        var url = cache[el];
	        if (!url) {
	            var m;
	            if ((m = /url\((['"]?)([^'")]*?)\1\)\s+format\((['"]?)truetype\3\)/.exec(el))) {
	                url = cache[el] = m[2];
	            } else if ((m = /url\((['"]?)([^'")]*?\.ttf)\1\)/.exec(el))) {
	                url = cache[el] = m[2];
	            }
	        }
	        return url;
	    };
	})(Object.create ? Object.create(null) : {});

	var getFontHeight = (function(cache){
	    return function(font) {
	        var height = cache[font];
	        if (height == null) {
	            height = cache[font] = kendoUtil.measureText("Mapq", { font: font }).height;
	        }
	        return height;
	    };
	})(Object.create ? Object.create(null) : {});

	function getFontFaces(doc) {
	    if (doc == null) {
	        doc = document;
	    }
	    var result = {};
	    for (var i = 0; i < doc.styleSheets.length; ++i) {
	        doStylesheet(doc.styleSheets[i]);
	    }
	    return result;
	    function doStylesheet(ss) {
	        if (ss) {
	            var rules = null;
	            try {
	                rules = ss.cssRules;
	            } catch (ex) {}
	            if (rules) {
	                addRules(ss, rules);
	            }
	        }
	    }
	    function findFonts(rule) {
	        var src = getPropertyValue(rule.style, "src");
	        if (src) {
	            return splitProperty(src).reduce(function(a, el){
	                var font = getFontURL(el);
	                if (font) {
	                    a.push(font);
	                }
	                return a;
	            }, []);
	        } else {
	            // Internet Explorer
	            // XXX: this is gross.  should work though for valid CSS.
	            var font = getFontURL(rule.cssText);
	            return font ? [ font ] : [];
	        }
	    }
	    function addRules(styleSheet, rules) {
	        for (var i = 0; i < rules.length; ++i) {
	            var r = rules[i];
	            switch (r.type) {
	              case 3:       // CSSImportRule
	                doStylesheet(r.styleSheet);
	                break;
	              case 5:       // CSSFontFaceRule
	                var style  = r.style;
	                var family = splitProperty(getPropertyValue(style, "font-family"));
	                var bold   = /^([56789]00|bold)$/i.test(getPropertyValue(style, "font-weight"));
	                var italic = "italic" == getPropertyValue(style, "font-style");
	                var src    = findFonts(r);
	                if (src.length > 0) {
	                    addRule(styleSheet, family, bold, italic, src[0]);
	                }
	            }
	        }
	    }
	    function addRule(styleSheet, names, bold, italic, url) {
	        // We get full resolved absolute URLs in Chrome, but sadly
	        // not in Firefox.
	        if (!(/^data:/i.test(url))) {
	            if (!(/^[^\/:]+:\/\//.test(url) || /^\//.test(url))) {
	                url = String(styleSheet.href).replace(/[^\/]*$/, "") + url;
	            }
	        }
	        names.forEach(function(name){
	            name = name.replace(/^(['"]?)(.*?)\1$/, "$2"); // it's quoted
	            if (bold) {
	                name += "|bold";
	            }
	            if (italic) {
	                name += "|italic";
	            }
	            result[name] = url;
	        });
	    }
	}

	function hasOwnProperty(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}

	function getCounter(name) {
	    name = "_counter_" + name;
	    return nodeInfo[name];
	}

	function getAllCounters(name) {
	    var values = [], p = nodeInfo;
	    name = "_counter_" + name;
	    while (p) {
	        if (hasOwnProperty(p, name)) {
	            values.push(p[name]);
	        }
	        p = Object.getPrototypeOf(p);
	    }
	    return values.reverse();
	}

	function incCounter(name, inc) {
	    var p = nodeInfo;
	    name = "_counter_" + name;
	    while (p && !hasOwnProperty(p, name)) {
	        p = Object.getPrototypeOf(p);
	    }
	    if (!p) {
	        p = nodeInfo._root;
	    }
	    p[name] = (p[name] || 0) + (inc == null ? 1 : inc);
	}

	function resetCounter(name, val) {
	    name = "_counter_" + name;
	    nodeInfo[name] = val == null ? 0 : val;
	}

	function doCounters(a, f, def) {
	    for (var i = 0; i < a.length;) {
	        var name = a[i++];
	        var val = parseFloat(a[i]);
	        if (isNaN(val)) {
	            f(name, def);
	        } else {
	            f(name, val);
	            ++i;
	        }
	    }
	}

	function updateCounters(style) {
	    var counterReset = getPropertyValue(style, "counter-reset");
	    if (counterReset) {
	        doCounters(splitProperty(counterReset, /^\s+/), resetCounter, 0);
	    }
	    var counterIncrement = getPropertyValue(style, "counter-increment");
	    if (counterIncrement) {
	        doCounters(splitProperty(counterIncrement, /^\s+/), incCounter, 1);
	    }
	}

	function parseColor$1(str, css) {
	    var color = kendo.parseColor(str, true);
	    if (color) {
	        color = color.toRGB();
	        if (css) {
	            color = color.toCssRgba();
	        } else if (color.a === 0) {
	            color = null;
	        }
	    }
	    return color;
	}

	function whenImagesAreActuallyLoaded(elements, callback) {
	    var pending = 0;
	    elements.forEach(function(el){
	        var images = el.querySelectorAll("img");
	        for (var i = 0; i < images.length; ++i) {
	            var img = images[i];
	            if (!img.complete) {
	                pending++;
	                img.onload = img.onerror = next;
	            }
	        }
	    });
	    if (!pending) {
	        next();
	    }
	    function next() {
	        if (--pending <= 0) {
	            callback();
	        }
	    }
	}

	function cacheImages(element, callback) {
	    var urls = [];
	    function add(url) {
	        if (!IMAGE_CACHE[url]) {
	            IMAGE_CACHE[url] = true;
	            urls.push(url);
	        }
	    }
	    function dive(element){
	        if (/^img$/i.test(element.tagName)) {
	            add(element.src);
	        }
	        parseBackgroundImage(
	            getPropertyValue(
	                getComputedStyle$1(element), "background-image"
	            )
	        ).forEach(function(bg){
	            if (bg.type == "url") {
	                add(bg.url);
	            }
	        });

	        if (element.children) {
	            slice$1(element.children).forEach(dive);
	        }
	    }

	    if (Array.isArray(element)) {
	        element.forEach(dive);
	    } else {
	        dive(element);
	    }

	    var count = urls.length;
	    function next() {
	        if (--count <= 0) {
	            callback();
	        }
	    }
	    if (count === 0) {
	        next();
	    }
	    urls.forEach(function(url){
	        var img = IMAGE_CACHE[url] = new window.Image();
	        if (!(/^data:/i.test(url))) {
	            img.crossOrigin = "Anonymous";
	        }
	        img.src = url;
	        if (img.complete) {
	            next();
	        } else {
	            img.onload = next;
	            img.onerror = function() {
	                IMAGE_CACHE[url] = null;
	                next();
	            };
	        }
	    });
	}

	function alphaNumeral(n) {
	    var result = "";
	    do {
	        var r = n % 26;
	        result = String.fromCharCode(97 + r) + result;
	        n = Math.floor(n / 26);
	    } while (n > 0);
	    return result;
	}

	function pushNodeInfo(element, style, group) {
	    nodeInfo = Object.create(nodeInfo);
	    nodeInfo[element.tagName.toLowerCase()] = {
	        element: element,
	        style: style
	    };
	    var decoration = getPropertyValue(style, "text-decoration");
	    if (decoration && decoration != "none") {
	        var color = getPropertyValue(style, "color");
	        decoration.split(/\s+/g).forEach(function(name){
	            if (!nodeInfo[name]) {
	                nodeInfo[name] = color;
	            }
	        });
	    }

	    if (createsStackingContext(style)) {
	        nodeInfo._stackingContext = {
	            element: element,
	            group: group
	        };
	    }
	}

	function popNodeInfo() {
	    nodeInfo = Object.getPrototypeOf(nodeInfo);
	}

	function updateClipbox(path) {
	    if (nodeInfo._clipbox != null) {
	        var box = path.bbox(nodeInfo._matrix);
	        if (nodeInfo._clipbox) {
	            nodeInfo._clipbox = Rect.intersect(nodeInfo._clipbox, box);
	        } else {
	            nodeInfo._clipbox = box;
	        }
	    }
	}

	function emptyClipbox() {
	    var cb = nodeInfo._clipbox;
	    if (cb == null) {
	        return true;
	    }
	    if (cb) {
	        return cb.width() === 0 || cb.height() === 0;
	    }
	}

	function createsStackingContext(style) {
	    function prop(name) { return getPropertyValue(style, name); }
	    if (prop("transform") != "none" ||
	        prop("position") != "static" ||
	        prop("z-index") != "auto" ||
	        prop("opacity") < 1) {
	        return true;
	    }
	}

	function getComputedStyle$1(element, pseudoElt) {
	    return window.getComputedStyle(element, pseudoElt || null);
	}

	function getPropertyValue(style, prop, defa) {
	    var val = style.getPropertyValue(prop);
	    if (val == null || val === "") {
	        if (browser.webkit) {
	            val = style.getPropertyValue("-webkit-" + prop );
	        } else if (browser.mozilla) {
	            val = style.getPropertyValue("-moz-" + prop );
	        } else if (browser.opera) {
	            val = style.getPropertyValue("-o-" + prop);
	        } else if (microsoft) {
	            val = style.getPropertyValue("-ms-" + prop);
	        }
	    }
	    if (arguments.length > 2 && (val == null || val === "")) {
	        return defa;
	    } else {
	        return val;
	    }
	}

	function pleaseSetPropertyValue(style, prop, value, important) {
	    style.setProperty(prop, value, important);
	    if (browser.webkit) {
	        style.setProperty("-webkit-" + prop, value, important);
	    } else if (browser.mozilla) {
	        style.setProperty("-moz-" + prop, value, important);
	    } else if (browser.opera) {
	        style.setProperty("-o-" + prop, value, important);
	    } else if (microsoft) {
	        style.setProperty("-ms-" + prop, value, important);
	        prop = "ms" + prop.replace(/(^|-)([a-z])/g, function(s, p1, p2){
	            return p1 + p2.toUpperCase();
	        });
	        style[prop] = value;
	    }
	}

	function getBorder(style, side) {
	    side = "border-" + side;
	    return {
	        width: parseFloat(getPropertyValue(style, side + "-width")),
	        style: getPropertyValue(style, side + "-style"),
	        color: parseColor$1(getPropertyValue(style, side + "-color"), true)
	    };
	}

	function saveStyle(element, func) {
	    var prev = element.style.cssText;
	    var result = func();
	    element.style.cssText = prev;
	    return result;
	}

	function getBorderRadius(style, side) {
	    var r = getPropertyValue(style, "border-" + side + "-radius").split(/\s+/g).map(parseFloat);
	    if (r.length == 1) {
	        r.push(r[0]);
	    }
	    return sanitizeRadius({ x: r[0], y: r[1] });
	}

	function getContentBox(element) {
	    var box = element.getBoundingClientRect();
	    box = innerBox(box, "border-*-width", element);
	    box = innerBox(box, "padding-*", element);
	    return box;
	}

	function innerBox(box, prop, element) {
	    var style, wt, wr, wb, wl;
	    if (typeof prop == "string") {
	        style = getComputedStyle$1(element);
	        wt = parseFloat(getPropertyValue(style, prop.replace("*", "top")));
	        wr = parseFloat(getPropertyValue(style, prop.replace("*", "right")));
	        wb = parseFloat(getPropertyValue(style, prop.replace("*", "bottom")));
	        wl = parseFloat(getPropertyValue(style, prop.replace("*", "left")));
	    }
	    else if (typeof prop == "number") {
	        wt = wr = wb = wl = prop;
	    }
	    return {
	        top    : box.top + wt,
	        right  : box.right - wr,
	        bottom : box.bottom - wb,
	        left   : box.left + wl,
	        width  : box.right - box.left - wr - wl,
	        height : box.bottom - box.top - wb - wt
	    };
	}

	function getTransform(style) {
	    var transform$$1 = getPropertyValue(style, "transform");
	    if (transform$$1 == "none") {
	        return null;
	    }
	    var matrix = /^\s*matrix\(\s*(.*?)\s*\)\s*$/.exec(transform$$1);
	    if (matrix) {
	        var origin = getPropertyValue(style, "transform-origin");
	        matrix = matrix[1].split(/\s*,\s*/g).map(parseFloat);
	        origin = origin.split(/\s+/g).map(parseFloat);
	        return {
	            matrix: matrix,
	            origin: origin
	        };
	    }
	}

	function radiansToDegrees(radians) {
	    return ((180 * radians) / Math.PI) % 360;
	}

	function parseAngle(angle) {
	    var num = parseFloat(angle);
	    if (/grad$/.test(angle)) {
	        return Math.PI * num / 200;
	    }
	    else if (/rad$/.test(angle)) {
	        return num;
	    }
	    else if (/turn$/.test(angle)) {
	        return Math.PI * num * 2;
	    }
	    else if (/deg$/.test(angle)) {
	        return Math.PI * num / 180;
	    }
	}

	function setTransform(shape, m) {
	    m = new Matrix(m[0], m[1], m[2], m[3], m[4], m[5]);
	    shape.transform(m);
	    return m;
	}

	function setClipping(shape, clipPath) {
	    shape.clip(clipPath);
	}

	function addArcToPath(path, x, y, options) {
	    var points = new Arc([ x, y ], options).curvePoints(), i = 1;
	    while (i < points.length) {
	        path.curveTo(points[i++], points[i++], points[i++]);
	    }
	}

	function sanitizeRadius(r) {
	    if (r.x <= 0 || r.y <= 0) {
	        r.x = r.y = 0;
	    }
	    return r;
	}

	function adjustBorderRadiusForBox(box, rTL, rTR, rBR, rBL) {
	    // adjust border radiuses such that the sum of adjacent
	    // radiuses is not bigger than the length of the side.
	    // seems the correct algorithm is variant (3) from here:
	    // http://www.w3.org/Style/CSS/Tracker/issues/29?changelog
	    var tl_x = Math.max(0, rTL.x), tl_y = Math.max(0, rTL.y);
	    var tr_x = Math.max(0, rTR.x), tr_y = Math.max(0, rTR.y);
	    var br_x = Math.max(0, rBR.x), br_y = Math.max(0, rBR.y);
	    var bl_x = Math.max(0, rBL.x), bl_y = Math.max(0, rBL.y);

	    var f = Math.min(
	        box.width / (tl_x + tr_x),
	        box.height / (tr_y + br_y),
	        box.width / (br_x + bl_x),
	        box.height / (bl_y + tl_y)
	    );

	    if (f < 1) {
	        tl_x *= f; tl_y *= f;
	        tr_x *= f; tr_y *= f;
	        br_x *= f; br_y *= f;
	        bl_x *= f; bl_y *= f;
	    }

	    return {
	        tl: { x: tl_x, y: tl_y },
	        tr: { x: tr_x, y: tr_y },
	        br: { x: br_x, y: br_y },
	        bl: { x: bl_x, y: bl_y }
	    };
	}

	function elementRoundBox(element, box, type) {
	    var style = getComputedStyle$1(element);

	    var rTL = getBorderRadius(style, "top-left");
	    var rTR = getBorderRadius(style, "top-right");
	    var rBL = getBorderRadius(style, "bottom-left");
	    var rBR = getBorderRadius(style, "bottom-right");

	    if (type == "padding" || type == "content") {
	        var bt = getBorder(style, "top");
	        var br = getBorder(style, "right");
	        var bb = getBorder(style, "bottom");
	        var bl = getBorder(style, "left");
	        rTL.x -= bl.width; rTL.y -= bt.width;
	        rTR.x -= br.width; rTR.y -= bt.width;
	        rBR.x -= br.width; rBR.y -= bb.width;
	        rBL.x -= bl.width; rBL.y -= bb.width;
	        if (type == "content") {
	            var pt = parseFloat(getPropertyValue(style, "padding-top"));
	            var pr = parseFloat(getPropertyValue(style, "padding-right"));
	            var pb = parseFloat(getPropertyValue(style, "padding-bottom"));
	            var pl = parseFloat(getPropertyValue(style, "padding-left"));
	            rTL.x -= pl; rTL.y -= pt;
	            rTR.x -= pr; rTR.y -= pt;
	            rBR.x -= pr; rBR.y -= pb;
	            rBL.x -= pl; rBL.y -= pb;
	        }
	    }

	    if (typeof type == "number") {
	        rTL.x -= type; rTL.y -= type;
	        rTR.x -= type; rTR.y -= type;
	        rBR.x -= type; rBR.y -= type;
	        rBL.x -= type; rBL.y -= type;
	    }

	    return roundBox(box, rTL, rTR, rBR, rBL);
	}

	// Create a drawing.Path for a rounded rectangle.  Receives the
	// bounding box and the border-radiuses in CSS order (top-left,
	// top-right, bottom-right, bottom-left).  The radiuses must be
	// objects containing x (horiz. radius) and y (vertical radius).
	function roundBox(box, rTL0, rTR0, rBR0, rBL0) {
	    var tmp = adjustBorderRadiusForBox(box, rTL0, rTR0, rBR0, rBL0);
	    var rTL = tmp.tl;
	    var rTR = tmp.tr;
	    var rBR = tmp.br;
	    var rBL = tmp.bl;
	    var path = new Path({ fill: null, stroke: null });
	    path.moveTo(box.left, box.top + rTL.y);
	    if (rTL.x) {
	        addArcToPath(path, box.left + rTL.x, box.top + rTL.y, {
	            startAngle: -180,
	            endAngle: -90,
	            radiusX: rTL.x,
	            radiusY: rTL.y
	        });
	    }
	    path.lineTo(box.right - rTR.x, box.top);
	    if (rTR.x) {
	        addArcToPath(path, box.right - rTR.x, box.top + rTR.y, {
	            startAngle: -90,
	            endAngle: 0,
	            radiusX: rTR.x,
	            radiusY: rTR.y
	        });
	    }
	    path.lineTo(box.right, box.bottom - rBR.y);
	    if (rBR.x) {
	        addArcToPath(path, box.right - rBR.x, box.bottom - rBR.y, {
	            startAngle: 0,
	            endAngle: 90,
	            radiusX: rBR.x,
	            radiusY: rBR.y
	        });
	    }
	    path.lineTo(box.left + rBL.x, box.bottom);
	    if (rBL.x) {
	        addArcToPath(path, box.left + rBL.x, box.bottom - rBL.y, {
	            startAngle: 90,
	            endAngle: 180,
	            radiusX: rBL.x,
	            radiusY: rBL.y
	        });
	    }
	    return path.close();
	}

	function formatCounter(val, style) {
	    var str = String(parseFloat(val));
	    switch (style) {
	      case "decimal-leading-zero":
	        if (str.length < 2) {
	            str = "0" + str;
	        }
	        return str;
	      case "lower-roman":
	        return arabicToRoman(val).toLowerCase();
	      case "upper-roman":
	        return arabicToRoman(val).toUpperCase();
	      case "lower-latin":
	      case "lower-alpha":
	        return alphaNumeral(val - 1);
	      case "upper-latin":
	      case "upper-alpha":
	        return alphaNumeral(val - 1).toUpperCase();
	      default:
	        return str;
	    }
	}

	function evalPseudoElementContent(element, content) {
	    function displayCounter(name, style, separator) {
	        if (!separator) {
	            return formatCounter(getCounter(name) || 0, style);
	        }
	        separator = separator.replace(/^\s*(["'])(.*)\1\s*$/, "$2");
	        return getAllCounters(name).map(function(val){
	            return formatCounter(val, style);
	        }).join(separator);
	    }
	    var a = splitProperty(content, /^\s+/);
	    var result = [], m;
	    a.forEach(function(el){
	        var tmp;
	        if ((m = /^\s*(["'])(.*)\1\s*$/.exec(el))) {
	            result.push(m[2].replace(/\\([0-9a-f]{4})/gi, function(s, p){
	                return String.fromCharCode(parseInt(p, 16));
	            }));
	        }
	        else if ((m = /^\s*counter\((.*?)\)\s*$/.exec(el))) {
	            tmp = splitProperty(m[1]);
	            result.push(displayCounter(tmp[0], tmp[1]));
	        }
	        else if ((m = /^\s*counters\((.*?)\)\s*$/.exec(el))) {
	            tmp = splitProperty(m[1]);
	            result.push(displayCounter(tmp[0], tmp[2], tmp[1]));
	        }
	        else if ((m = /^\s*attr\((.*?)\)\s*$/.exec(el))) {
	            result.push(element.getAttribute(m[1]) || "");
	        }
	        else {
	            result.push(el);
	        }
	    });
	    return result.join("");
	}

	function getCssText(style) {
	    if (style.cssText) {
	        return style.cssText;
	    }
	    // Status: NEW.  Report year: 2002.  Current year: 2014.
	    // Nice played, Mozillians.
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=137687
	    var result = [];
	    for (var i = 0; i < style.length; ++i) {
	        result.push(style[i] + ": " + getPropertyValue(style, style[i]));
	    }
	    return result.join(";\n");
	}

	function _renderWithPseudoElements(element, group) {
	    if (element.tagName == KENDO_PSEUDO_ELEMENT) {
	        _renderElement(element, group);
	        return;
	    }
	    var fake = [];
	    function pseudo(kind, place) {
	        var style = getComputedStyle$1(element, kind), content = style.content;
	        updateCounters(style);
	        if (content && content != "normal" && content != "none" && style.width != "0px") {
	            var psel = element.ownerDocument.createElement(KENDO_PSEUDO_ELEMENT);
	            psel.style.cssText = getCssText(style);
	            psel.textContent = evalPseudoElementContent(element, content);
	            element.insertBefore(psel, place);
	            fake.push(psel);
	        }
	    }
	    pseudo(":before", element.firstChild);
	    pseudo(":after", null);
	    if (fake.length > 0) {
	        var saveClass = element.className;
	        element.className += " kendo-pdf-hide-pseudo-elements";
	        _renderElement(element, group);
	        element.className = saveClass;
	        fake.forEach(function(el){ element.removeChild(el); });
	    } else {
	        _renderElement(element, group);
	    }
	}

	function _renderElement(element, group) {
	    var style = getComputedStyle$1(element);

	    var top = getBorder(style, "top");
	    var right = getBorder(style, "right");
	    var bottom = getBorder(style, "bottom");
	    var left = getBorder(style, "left");

	    var rTL0 = getBorderRadius(style, "top-left");
	    var rTR0 = getBorderRadius(style, "top-right");
	    var rBL0 = getBorderRadius(style, "bottom-left");
	    var rBR0 = getBorderRadius(style, "bottom-right");

	    var dir = getPropertyValue(style, "direction");

	    var backgroundColor = getPropertyValue(style, "background-color");
	    backgroundColor = parseColor$1(backgroundColor);

	    var backgroundImage = parseBackgroundImage( getPropertyValue(style, "background-image") );
	    var backgroundRepeat = splitProperty( getPropertyValue(style, "background-repeat") );
	    var backgroundPosition = splitProperty( getPropertyValue(style, "background-position") );
	    var backgroundOrigin = splitProperty( getPropertyValue(style, "background-origin") );
	    var backgroundSize = splitProperty( getPropertyValue(style, "background-size") );

	    // IE shrinks the text with text-overflow: ellipsis,
	    // apparently because the returned bounding box for the range
	    // is limited to the visible area minus space for the dots,
	    // instead of being the full width of the text.
	    //
	    // https://github.com/telerik/kendo/issues/5232
	    // https://github.com/telerik/kendo-ui-core/issues/1868
	    //
	    // We have to test it here rather than in renderText because
	    // text-overflow: ellipsis could be set on a parent element (not
	    // necessarily the one containing the text); in this case,
	    // getComputedStyle(elementWithTheText) will return "clip", not
	    // "ellipsis" (which is probably a bug, but oh well...)
	    var textOverflow, saveTextOverflow;
	    if (microsoft) {
	        textOverflow = style.textOverflow;             // computed style
	        if (textOverflow == "ellipsis") {
	            saveTextOverflow = element.style.textOverflow; // own style.
	            element.style.textOverflow = "clip";
	        }
	    }

	    if (browser.msie && browser.version < 10) {
	        // IE9 hacks.  getPropertyValue won't return the correct
	        // value.  Sucks that we have to do it here, I'd prefer to
	        // move it in getPropertyValue, but we don't have the
	        // element.
	        backgroundPosition = splitProperty(element.currentStyle.backgroundPosition);
	    }

	    var innerbox = innerBox(element.getBoundingClientRect(), "border-*-width", element);

	    // CSS "clip" property - if present, replace the group with a
	    // new one which is clipped.  This must happen before drawing
	    // the borders and background.
	    (function(){
	        var clip = getPropertyValue(style, "clip");
	        var m = /^\s*rect\((.*)\)\s*$/.exec(clip);
	        if (m) {
	            var a = m[1].split(/[ ,]+/g);
	            var top = a[0] == "auto" ? innerbox.top : parseFloat(a[0]) + innerbox.top;
	            var right = a[1] == "auto" ? innerbox.right : parseFloat(a[1]) + innerbox.left;
	            var bottom = a[2] == "auto" ? innerbox.bottom : parseFloat(a[2]) + innerbox.top;
	            var left = a[3] == "auto" ? innerbox.left : parseFloat(a[3]) + innerbox.left;
	            var tmp = new Group();
	            var clipPath = new Path()
	                .moveTo(left, top)
	                .lineTo(right, top)
	                .lineTo(right, bottom)
	                .lineTo(left, bottom)
	                .close();
	            setClipping(tmp, clipPath);
	            group.append(tmp);
	            group = tmp;
	            updateClipbox(clipPath);
	        }
	    })();

	    var boxes, i, cells;
	    var display = getPropertyValue(style, "display");

	    if (display == "table-row") {
	        // because of rowspan/colspan, we shouldn't draw background of table row elements on the
	        // box given by its getBoundingClientRect, because if we do we risk overwritting a
	        // previously rendered cell.  https://github.com/telerik/kendo/issues/4881
	        boxes = [];
	        for (i = 0, cells = element.children; i < cells.length; ++i) {
	            boxes.push(cells[i].getBoundingClientRect());
	        }
	    } else {
	        boxes = element.getClientRects();
	        if (boxes.length == 1) {
	            // Workaround the missing borders in Chrome!  getClientRects() boxes contains values
	            // rounded to integer.  getBoundingClientRect() appears to work fine.  We still need
	            // getClientRects() to support cases where there are more boxes (continued inline
	            // elements that might have border/background).
	            boxes = [ element.getBoundingClientRect() ];
	        }
	    }

	    // This function workarounds another Chrome bug, where boxes returned for a table with
	    // border-collapse: collapse will overlap the table border.  Our rendering is not perfect in
	    // such case anyway, but with this is better than without it.
	    boxes = adjustBoxes(boxes);

	    for (i = 0; i < boxes.length; ++i) {
	        drawOneBox(boxes[i], i === 0, i == boxes.length - 1);
	    }

	    // Render links as separate groups.  We can't use boxes returned by element's getClientRects
	    // because if display type is "inline" (default for <a>), boxes will not include the height of
	    // images inside.  https://github.com/telerik/kendo-ui-core/issues/3359
	    if (element.tagName == "A" && element.href && !/^#?$/.test(element.getAttribute("href"))) {
	        if (!nodeInfo._avoidLinks || !matches(element, nodeInfo._avoidLinks)) {
	            var r = document.createRange();
	            r.selectNodeContents(element);
	            slice$1(r.getClientRects()).forEach(function(box){
	                var g = new Group();
	                g._pdfLink = {
	                    url    : element.href,
	                    top    : box.top,
	                    right  : box.right,
	                    bottom : box.bottom,
	                    left   : box.left
	                };
	                group.append(g);
	            });
	        }
	    }

	    if (boxes.length > 0 && display == "list-item" && !element.getAttribute("kendo-no-bullet")) {
	        drawBullet(boxes[0]);
	    }

	    // overflow: hidden/auto - if present, replace the group with
	    // a new one clipped by the inner box.
	    (function(){
	        function clipit() {
	            var clipPath = elementRoundBox(element, innerbox, "padding");
	            var tmp = new Group();
	            setClipping(tmp, clipPath);
	            group.append(tmp);
	            group = tmp;
	            updateClipbox(clipPath);
	        }
	        if (isFormField(element)) {
	            clipit();
	        } else if (/^(hidden|auto|scroll)/.test(getPropertyValue(style, "overflow"))) {
	            clipit();
	        } else if (/^(hidden|auto|scroll)/.test(getPropertyValue(style, "overflow-x"))) {
	            clipit();
	        } else if (/^(hidden|auto|scroll)/.test(getPropertyValue(style, "overflow-y"))) {
	            clipit();
	        }
	    })();

	    if (!maybeRenderWidget(element, group)) {
	        renderContents(element, group);
	    }

	    if (microsoft && textOverflow == "ellipsis") {
	        element.style.textOverflow = saveTextOverflow;
	    }

	    return group; // only utility functions after this line.

	    function adjustBoxes(boxes) {
	        if (/^td$/i.test(element.tagName)) {
	            var table = nodeInfo.table;
	            if (table && getPropertyValue(table.style, "border-collapse") == "collapse") {
	                var tableBorderLeft = getBorder(table.style, "left").width;
	                var tableBorderTop = getBorder(table.style, "top").width;
	                // check if we need to adjust
	                if (tableBorderLeft === 0 && tableBorderTop === 0) {
	                    return boxes; // nope
	                }
	                var tableBox = table.element.getBoundingClientRect();
	                var firstCell = table.element.rows[0].cells[0];
	                var firstCellBox = firstCell.getBoundingClientRect();
	                if (firstCellBox.top == tableBox.top || firstCellBox.left == tableBox.left) {
	                    return slice$1(boxes).map(function(box){
	                        return {
	                            left   : box.left + tableBorderLeft,
	                            top    : box.top + tableBorderTop,
	                            right  : box.right + tableBorderLeft,
	                            bottom : box.bottom + tableBorderTop,
	                            height : box.height,
	                            width  : box.width
	                        };
	                    });
	                }
	            }
	        }
	        return boxes;
	    }

	    // this function will be called to draw each border.  it
	    // draws starting at origin and the resulted path must be
	    // translated/rotated to be placed in the proper position.
	    //
	    // arguments are named as if it draws the top border:
	    //
	    //    - `len` the length of the edge
	    //    - `Wtop` the width of the edge (i.e. border-top-width)
	    //    - `Wleft` the width of the left edge (border-left-width)
	    //    - `Wright` the width of the right edge
	    //    - `rl` and `rl` -- the border radius on the left and right
	    //      (objects containing x and y, for horiz/vertical radius)
	    //    - `transform` -- transformation to apply
	    //
	    function drawEdge(color, len, Wtop, Wleft, Wright, rl, rr, transform$$1) {
	        if (Wtop <= 0) {
	            return;
	        }

	        var path, edge = new Group();
	        setTransform(edge, transform$$1);
	        group.append(edge);

	        sanitizeRadius(rl);
	        sanitizeRadius(rr);

	        // draw main border.  this is the area without the rounded corners
	        path = new Path({
	            fill: { color: color },
	            stroke: null
	        });
	        edge.append(path);
	        path.moveTo(rl.x ? Math.max(rl.x, Wleft) : 0, 0)
	            .lineTo(len - (rr.x ? Math.max(rr.x, Wright) : 0), 0)
	            .lineTo(len - Math.max(rr.x, Wright), Wtop)
	            .lineTo(Math.max(rl.x, Wleft), Wtop)
	            .close();

	        if (rl.x) {
	            drawRoundCorner(Wleft, rl, [ -1, 0, 0, 1, rl.x, 0 ]);
	        }

	        if (rr.x) {
	            drawRoundCorner(Wright, rr, [ 1, 0, 0, 1, len - rr.x, 0 ]);
	        }

	        // draws one round corner, starting at origin (needs to be
	        // translated/rotated to be placed properly).
	        function drawRoundCorner(Wright, r, transform$$1) {
	            var angle = Math.PI/2 * Wright / (Wright + Wtop);

	            // not sanitizing this one, because negative values
	            // are useful to fill the box correctly.
	            var ri = {
	                x: r.x - Wright,
	                y: r.y - Wtop
	            };

	            var path = new Path({
	                fill: { color: color },
	                stroke: null
	            }).moveTo(0, 0);

	            setTransform(path, transform$$1);

	            addArcToPath(path, 0, r.y, {
	                startAngle: -90,
	                endAngle: -radiansToDegrees(angle),
	                radiusX: r.x,
	                radiusY: r.y
	            });

	            if (ri.x > 0 && ri.y > 0) {
	                path.lineTo(ri.x * Math.cos(angle), r.y - ri.y * Math.sin(angle));
	                addArcToPath(path, 0, r.y, {
	                    startAngle: -radiansToDegrees(angle),
	                    endAngle: -90,
	                    radiusX: ri.x,
	                    radiusY: ri.y,
	                    anticlockwise: true
	                });
	            }
	            else if (ri.x > 0) {
	                path.lineTo(ri.x, Wtop)
	                    .lineTo(0, Wtop);
	            }
	            else {
	                path.lineTo(ri.x, Wtop)
	                    .lineTo(ri.x, 0);
	            }

	            edge.append(path.close());
	        }
	    }

	    function drawBackground(box) {
	        var background = new Group();
	        setClipping(background, roundBox(box, rTL0, rTR0, rBR0, rBL0));
	        group.append(background);

	        if (backgroundColor) {
	            var path = new Path({
	                fill: { color: backgroundColor.toCssRgba() },
	                stroke: null
	            });
	            path.moveTo(box.left, box.top)
	                .lineTo(box.right, box.top)
	                .lineTo(box.right, box.bottom)
	                .lineTo(box.left, box.bottom)
	                .close();
	            background.append(path);
	        }

	        for (var i = backgroundImage.length; --i >= 0;) {
	            drawOneBackground(
	                background, box,
	                backgroundImage[i],
	                backgroundRepeat[i % backgroundRepeat.length],
	                backgroundPosition[i % backgroundPosition.length],
	                backgroundOrigin[i % backgroundOrigin.length],
	                backgroundSize[i % backgroundSize.length]
	            );
	        }
	    }

	    function drawOneBackground(group, box, background, backgroundRepeat, backgroundPosition, backgroundOrigin, backgroundSize) {
	        if (!background || (background == "none")) {
	            return;
	        }

	        if (background.type == "url") {
	            // SVG taints the canvas, can't draw it.
	            if (/^url\(\"data:image\/svg/i.test(background.url)) {
	                return;
	            }
	            var img = IMAGE_CACHE[background.url];
	            if (img && img.width > 0 && img.height > 0) {
	                drawBackgroundImage(group, box, img.width, img.height, function(group, rect){
	                    group.append(new Image$1(background.url, rect));
	                });
	            }
	        } else if (background.type == "linear") {
	            drawBackgroundImage(group, box, box.width, box.height, gradientRenderer(background));
	        } else {
	            return;
	        }

	        function drawBackgroundImage(group, box, img_width, img_height, renderBG) {
	            var aspect_ratio = img_width / img_height, f;

	            // for background-origin: border-box the box is already appropriate
	            var orgBox = box;
	            if (backgroundOrigin == "content-box") {
	                orgBox = innerBox(orgBox, "border-*-width", element);
	                orgBox = innerBox(orgBox, "padding-*", element);
	            } else if (backgroundOrigin == "padding-box") {
	                orgBox = innerBox(orgBox, "border-*-width", element);
	            }

	            if (!/^\s*auto(\s+auto)?\s*$/.test(backgroundSize)) {
	                if (backgroundSize == "contain") {
	                    f = Math.min(orgBox.width / img_width,
	                                 orgBox.height / img_height);
	                    img_width *= f;
	                    img_height *= f;
	                }
	                else if (backgroundSize == "cover") {
	                    f = Math.max(orgBox.width / img_width,
	                                 orgBox.height / img_height);
	                    img_width *= f;
	                    img_height *= f;
	                }
	                else {
	                    var size = backgroundSize.split(/\s+/g);
	                    // compute width
	                    if (/%$/.test(size[0])) {
	                        img_width = orgBox.width * parseFloat(size[0]) / 100;
	                    } else {
	                        img_width = parseFloat(size[0]);
	                    }
	                    // compute height
	                    if (size.length == 1 || size[1] == "auto") {
	                        img_height = img_width / aspect_ratio;
	                    } else if (/%$/.test(size[1])) {
	                        img_height = orgBox.height * parseFloat(size[1]) / 100;
	                    } else {
	                        img_height = parseFloat(size[1]);
	                    }
	                }
	            }

	            var pos = String(backgroundPosition);

	            // IE sometimes reports single-word positions
	            // https://github.com/telerik/kendo-ui-core/issues/2786
	            //
	            // it seems to switch to percentages when the horizontal
	            // position is not "center", therefore we don't handle
	            // multi-word cases here.  All other browsers return
	            // percentages or pixels instead of keywords.  At least
	            // for now...
	            switch (pos) {
	              case "bottom" : pos = "50% 100%"; break;
	              case "top"    : pos = "50% 0"; break;
	              case "left"   : pos = "0 50%"; break;
	              case "right"  : pos = "100% 50%"; break;
	              case "center" : pos = "50% 50%"; break;
	            }

	            pos = pos.split(/\s+/);
	            if (pos.length == 1) {
	                pos[1] = "50%";
	            }

	            if (/%$/.test(pos[0])) {
	                pos[0] = parseFloat(pos[0]) / 100 * (orgBox.width - img_width);
	            } else {
	                pos[0] = parseFloat(pos[0]);
	            }
	            if (/%$/.test(pos[1])) {
	                pos[1] = parseFloat(pos[1]) / 100 * (orgBox.height - img_height);
	            } else {
	                pos[1] = parseFloat(pos[1]);
	            }

	            var rect = new Rect([ orgBox.left + pos[0], orgBox.top + pos[1] ], [ img_width, img_height ]);

	            // XXX: background-repeat could be implemented more
	            //      efficiently as a fill pattern (at least for PDF
	            //      output, probably SVG too).

	            function rewX() {
	                while (rect.origin.x > box.left) {
	                    rect.origin.x -= img_width;
	                }
	            }

	            function rewY() {
	                while (rect.origin.y > box.top) {
	                    rect.origin.y -= img_height;
	                }
	            }

	            function repeatX() {
	                while (rect.origin.x < box.right) {
	                    renderBG(group, rect.clone());
	                    rect.origin.x += img_width;
	                }
	            }

	            if (backgroundRepeat == "no-repeat") {
	                renderBG(group, rect);
	            }
	            else if (backgroundRepeat == "repeat-x") {
	                rewX();
	                repeatX();
	            }
	            else if (backgroundRepeat == "repeat-y") {
	                rewY();
	                while (rect.origin.y < box.bottom) {
	                    renderBG(group, rect.clone());
	                    rect.origin.y += img_height;
	                }
	            }
	            else if (backgroundRepeat == "repeat") {
	                rewX();
	                rewY();
	                var origin = rect.origin.clone();
	                while (rect.origin.y < box.bottom) {
	                    rect.origin.x = origin.x;
	                    repeatX();
	                    rect.origin.y += img_height;
	                }
	            }
	        }
	    }

	    function drawBullet() {
	        var listStyleType = getPropertyValue(style, "list-style-type");
	        if (listStyleType == "none") {
	            return;
	        }
	        var listStylePosition = getPropertyValue(style, "list-style-position");

	        function _drawBullet(f) {
	            saveStyle(element, function(){
	                element.style.position = "relative";
	                var bullet = element.ownerDocument.createElement(KENDO_PSEUDO_ELEMENT);
	                bullet.style.position = "absolute";
	                bullet.style.boxSizing = "border-box";
	                if (listStylePosition == "outside") {
	                    bullet.style.width = "6em";
	                    bullet.style.left = "-6.8em";
	                    bullet.style.textAlign = "right";
	                } else {
	                    bullet.style.left = "0px";
	                }
	                f(bullet);
	                element.insertBefore(bullet, element.firstChild);
	                renderElement(bullet, group);
	                element.removeChild(bullet);
	            });
	        }

	        function elementIndex(f) {
	            var a = element.parentNode.children;
	            var k = element.getAttribute("kendo-split-index");
	            if (k != null) {
	                return f(k|0, a.length);
	            }
	            for (var i = 0; i < a.length; ++i) {
	                if (a[i] === element) {
	                    return f(i, a.length);
	                }
	            }
	        }

	        switch (listStyleType) {
	          case "circle":
	          case "disc":
	          case "square":
	            _drawBullet(function(bullet){
	                // XXX: the science behind these values is called "trial and error".
	                bullet.style.fontSize = "60%";
	                bullet.style.lineHeight = "200%";
	                bullet.style.paddingRight = "0.5em";
	                bullet.style.fontFamily = "DejaVu Serif";
	                bullet.innerHTML = {
	                    "disc"   : "\u25cf",
	                    "circle" : "\u25ef",
	                    "square" : "\u25a0"
	                }[listStyleType];
	            });
	            break;

	          case "decimal":
	          case "decimal-leading-zero":
	            _drawBullet(function(bullet){
	                elementIndex(function(idx){
	                    ++idx;
	                    if (listStyleType == "decimal-leading-zero" && idx < 10) {
	                        idx = "0" + idx;
	                    }
	                    bullet.innerHTML = idx + ".";
	                });
	            });
	            break;

	          case "lower-roman":
	          case "upper-roman":
	            _drawBullet(function(bullet){
	                elementIndex(function(idx){
	                    idx = arabicToRoman(idx + 1);
	                    if (listStyleType == "upper-roman") {
	                        idx = idx.toUpperCase();
	                    }
	                    bullet.innerHTML = idx + ".";
	                });
	            });
	            break;

	          case "lower-latin":
	          case "lower-alpha":
	          case "upper-latin":
	          case "upper-alpha":
	            _drawBullet(function(bullet){
	                elementIndex(function(idx){
	                    idx = alphaNumeral(idx);
	                    if (/^upper/i.test(listStyleType)) {
	                        idx = idx.toUpperCase();
	                    }
	                    bullet.innerHTML = idx + ".";
	                });
	            });
	            break;
	        }
	    }

	    // draws a single border box
	    function drawOneBox(box, isFirst, isLast) {
	        if (box.width === 0 || box.height === 0) {
	            return;
	        }

	        drawBackground(box);

	        var shouldDrawLeft = (left.width > 0 && ((isFirst && dir == "ltr") || (isLast && dir == "rtl")));
	        var shouldDrawRight = (right.width > 0 && ((isLast && dir == "ltr") || (isFirst && dir == "rtl")));

	        // The most general case is that the 4 borders have different widths and border
	        // radiuses.  The way that is handled is by drawing 3 Paths for each border: the
	        // straight line, and two round corners which represent half of the entire rounded
	        // corner.  To simplify code those shapes are drawed at origin (by the drawEdge
	        // function), then translated/rotated into the right position.
	        //
	        // However, this leads to poor results due to rounding in the simpler cases where
	        // borders are straight lines.  Therefore we handle a few such cases separately with
	        // straight lines. C^wC^wC^w -- nope, scratch that.  poor rendering was because of a bug
	        // in Chrome (getClientRects() returns rounded integer values rather than exact floats.
	        // web dev is still a ghetto.)

	        // first, just in case there is no border...
	        if (top.width === 0 && left.width === 0 && right.width === 0 && bottom.width === 0) {
	            return;
	        }

	        // START paint borders
	        // if all borders have equal colors...
	        if (top.color == right.color && top.color == bottom.color && top.color == left.color) {

	            // if same widths too, we can draw the whole border by stroking a single path.
	            if (top.width == right.width && top.width == bottom.width && top.width == left.width)
	            {
	                if (shouldDrawLeft && shouldDrawRight) {
	                    // reduce box by half the border width, so we can draw it by stroking.
	                    box = innerBox(box, top.width/2);

	                    // adjust the border radiuses, again by top.width/2, and make the path element.
	                    var path = elementRoundBox(element, box, top.width/2);
	                    path.options.stroke = {
	                        color: top.color,
	                        width: top.width
	                    };
	                    group.append(path);
	                    return;
	                }
	            }
	        }

	        // if border radiuses are zero and widths are at most one pixel, we can again use simple
	        // paths.
	        if (rTL0.x === 0 && rTR0.x === 0 && rBR0.x === 0 && rBL0.x === 0) {
	            // alright, 1.9px will do as well.  the difference in color blending should not be
	            // noticeable.
	            if (top.width < 2 && left.width < 2 && right.width < 2 && bottom.width < 2) {
	                // top border
	                if (top.width > 0) {
	                    group.append(
	                        new Path({
	                            stroke: { width: top.width, color: top.color }
	                        })
	                            .moveTo(box.left, box.top + top.width/2)
	                            .lineTo(box.right, box.top + top.width/2)
	                    );
	                }

	                // bottom border
	                if (bottom.width > 0) {
	                    group.append(
	                        new Path({
	                            stroke: { width: bottom.width, color: bottom.color }
	                        })
	                            .moveTo(box.left, box.bottom - bottom.width/2)
	                            .lineTo(box.right, box.bottom - bottom.width/2)
	                    );
	                }

	                // left border
	                if (shouldDrawLeft) {
	                    group.append(
	                        new Path({
	                            stroke: { width: left.width, color: left.color }
	                        })
	                            .moveTo(box.left + left.width/2, box.top)
	                            .lineTo(box.left + left.width/2, box.bottom)
	                    );
	                }

	                // right border
	                if (shouldDrawRight) {
	                    group.append(
	                        new Path({
	                            stroke: { width: right.width, color: right.color }
	                        })
	                            .moveTo(box.right - right.width/2, box.top)
	                            .lineTo(box.right - right.width/2, box.bottom)
	                    );
	                }

	                return;
	            }
	        }
	        // END paint borders

	        var tmp = adjustBorderRadiusForBox(box, rTL0, rTR0, rBR0, rBL0);
	        var rTL = tmp.tl;
	        var rTR = tmp.tr;
	        var rBR = tmp.br;
	        var rBL = tmp.bl;

	        // top border
	        drawEdge(top.color,
	                 box.width, top.width, left.width, right.width,
	                 rTL, rTR,
	                 [ 1, 0, 0, 1, box.left, box.top ]);

	        // bottom border
	        drawEdge(bottom.color,
	                 box.width, bottom.width, right.width, left.width,
	                 rBR, rBL,
	                 [ -1, 0, 0, -1, box.right, box.bottom ]);

	        // for left/right borders we need to invert the border-radiuses
	        function inv(p) {
	            return { x: p.y, y: p.x };
	        }

	        // left border
	        drawEdge(left.color,
	                 box.height, left.width, bottom.width, top.width,
	                 inv(rBL), inv(rTL),
	                 [ 0, -1, 1, 0, box.left, box.bottom ]);

	        // right border
	        drawEdge(right.color,
	                 box.height, right.width, top.width, bottom.width,
	                 inv(rTR), inv(rBR),
	                 [ 0, 1, -1, 0, box.right, box.top ]);
	    }
	}

	function gradientRenderer(gradient) {
	    return function(group, rect) {
	        var width = rect.width(), height = rect.height();

	        switch (gradient.type) {
	          case "linear":

	            // figure out the angle.
	            var angle = gradient.angle != null ? gradient.angle : Math.PI;
	            switch (gradient.to) {
	              case "top":
	                angle = 0;
	                break;
	              case "left":
	                angle = -Math.PI / 2;
	                break;
	              case "bottom":
	                angle = Math.PI;
	                break;
	              case "right":
	                angle = Math.PI / 2;
	                break;
	              case "top left": case "left top":
	                angle = -Math.atan2(height, width);
	                break;
	              case "top right": case "right top":
	                angle = Math.atan2(height, width);
	                break;
	              case "bottom left": case "left bottom":
	                angle = Math.PI + Math.atan2(height, width);
	                break;
	              case "bottom right": case "right bottom":
	                angle = Math.PI - Math.atan2(height, width);
	                break;
	            }

	            if (gradient.reverse) {
	                angle -= Math.PI;
	            }

	            // limit the angle between 0..2PI
	            angle %= 2 * Math.PI;
	            if (angle < 0) {
	                angle += 2 * Math.PI;
	            }

	            // compute gradient's start/end points.  here len is the length of the gradient line
	            // and x,y is the end point relative to the center of the rectangle in conventional
	            // (math) axis direction.

	            // this is the original (unscaled) length of the gradient line.  needed to deal with
	            // absolutely positioned color stops.  formula from the CSS spec:
	            // http://dev.w3.org/csswg/css-images-3/#linear-gradient-syntax
	            var pxlen = Math.abs(width * Math.sin(angle)) + Math.abs(height * Math.cos(angle));

	            // The math below is pretty simple, but it took a while to figure out.  We compute x
	            // and y, the *end* of the gradient line.  However, we want to transform them into
	            // element-based coordinates (SVG's gradientUnits="objectBoundingBox").  That means,
	            // x=0 is the left edge, x=1 is the right edge, y=0 is the top edge and y=1 is the
	            // bottom edge.
	            //
	            // A naive approach would use the original angle for these calculations.  Say we'd
	            // like to draw a gradient angled at 45deg in a 100x400 box.  When we use
	            // objectBoundingBox, the renderer will draw it in a 1x1 *square* box, and then
	            // scale that to the desired dimensions.  The 45deg angle will look more like 70deg
	            // after scaling.  SVG (http://www.w3.org/TR/SVG/pservers.html#LinearGradients) says
	            // the following:
	            //
	            //     When gradientUnits="objectBoundingBox" and 'gradientTransform' is the
	            //     identity matrix, the normal of the linear gradient is perpendicular to the
	            //     gradient vector in object bounding box space (i.e., the abstract coordinate
	            //     system where (0,0) is at the top/left of the object bounding box and (1,1) is
	            //     at the bottom/right of the object bounding box). When the object's bounding
	            //     box is not square, the gradient normal which is initially perpendicular to
	            //     the gradient vector within object bounding box space may render
	            //     non-perpendicular relative to the gradient vector in user space. If the
	            //     gradient vector is parallel to one of the axes of the bounding box, the
	            //     gradient normal will remain perpendicular. This transformation is due to
	            //     application of the non-uniform scaling transformation from bounding box space
	            //     to user space.
	            //
	            // which is an extremely long and confusing way to tell what I just said above.
	            //
	            // For this reason we need to apply the reverse scaling to the original angle, so
	            // that when it'll finally be rendered it'll actually be at the desired slope.  Now
	            // I'll let you figure out the math yourself.

	            var scaledAngle = Math.atan(width * Math.tan(angle) / height);
	            var sin = Math.sin(scaledAngle), cos = Math.cos(scaledAngle);
	            var len = Math.abs(sin) + Math.abs(cos);
	            var x = len/2 * sin;
	            var y = len/2 * cos;

	            // Because of the arctangent, our scaledAngle ends up between -PI/2..PI/2, possibly
	            // losing the intended direction of the gradient.  The following fixes it.
	            if (angle > Math.PI/2 && angle <= 3*Math.PI/2) {
	                x = -x;
	                y = -y;
	            }

	            // compute the color stops.
	            var implicit = [], right = 0;
	            var stops = gradient.stops.map(function(s, i){
	                var offset = s.percent;
	                if (offset) {
	                    offset = parseFloat(offset) / 100;
	                } else if (s.length) {
	                    offset = parseFloat(s.length) / pxlen;
	                } else if (i === 0) {
	                    offset = 0;
	                } else if (i == gradient.stops.length - 1) {
	                    offset = 1;
	                }
	                var stop = {
	                    color: s.color.toCssRgba(),
	                    offset: offset
	                };
	                if (offset != null) {
	                    right = offset;
	                    // fix implicit offsets
	                    implicit.forEach(function(s, i){
	                        var stop = s.stop;
	                        stop.offset = s.left + (right - s.left) * (i + 1) / (implicit.length + 1);
	                    });
	                    implicit = [];
	                } else {
	                    implicit.push({ left: right, stop: stop });
	                }
	                return stop;
	            });

	            var start = [ 0.5 - x, 0.5 + y ];
	            var end = [ 0.5 + x, 0.5 - y ];

	            // finally, draw it.
	            group.append(
	                Path.fromRect(rect)
	                    .stroke(null)
	                    .fill(new LinearGradient({
	                        start     : start,
	                        end       : end,
	                        stops     : stops,
	                        userSpace : false
	                    }))
	            );
	            break;
	          case "radial":
	            // XXX:
	            if (window.console && window.console.log) {
	                window.console.log("Radial gradients are not yet supported in HTML renderer");
	            }
	            break;
	        }
	    };
	}

	function maybeRenderWidget(element, group) {
	    var visual;

	    if (element._kendoExportVisual) {
	        visual = element._kendoExportVisual();
	    } else if (window.kendo && window.kendo.jQuery && element.getAttribute(window.kendo.attr("role"))) {
	        var widget = window.kendo.widgetInstance(window.kendo.jQuery(element));
	        if (widget && (widget.exportDOMVisual || widget.exportVisual)) {
	            if (widget.exportDOMVisual) {
	                visual = widget.exportDOMVisual();
	            } else {
	                visual = widget.exportVisual();
	            }
	        }
	    }

	    if (!visual) {
	        return false;
	    }

	    var wrap$$1 = new Group();
	    wrap$$1.children.push(visual);

	    var bbox = element.getBoundingClientRect();
	    wrap$$1.transform(transform().translate(bbox.left, bbox.top));

	    group.append(wrap$$1);

	    return true;
	}

	function renderImage(element, url, group) {
	    var box = getContentBox(element);
	    var rect = new Rect([ box.left, box.top ], [ box.width, box.height ]);
	    var image = new Image$1(url, rect);
	    setClipping(image, elementRoundBox(element, box, "content"));
	    group.append(image);
	}

	function zIndexSort(a, b) {
	    var sa = getComputedStyle$1(a);
	    var sb = getComputedStyle$1(b);
	    var za = parseFloat(getPropertyValue(sa, "z-index"));
	    var zb = parseFloat(getPropertyValue(sb, "z-index"));
	    var pa = getPropertyValue(sa, "position");
	    var pb = getPropertyValue(sb, "position");
	    if (isNaN(za) && isNaN(zb)) {
	        if ((/static|absolute/.test(pa)) && (/static|absolute/.test(pb))) {
	            return 0;
	        }
	        if (pa == "static") {
	            return -1;
	        }
	        if (pb == "static") {
	            return 1;
	        }
	        return 0;
	    }
	    if (isNaN(za)) {
	        return zb === 0 ? 0 : zb > 0 ? -1 : 1;
	    }
	    if (isNaN(zb)) {
	        return za === 0 ? 0 : za > 0 ? 1 : -1;
	    }
	    return parseFloat(za) - parseFloat(zb);
	}

	function isFormField(element) {
	    return /^(?:textarea|select|input)$/i.test(element.tagName);
	}

	function getSelectedOption(element) {
	    if (element.selectedOptions && element.selectedOptions.length > 0) {
	        return element.selectedOptions[0];
	    }
	    return element.options[element.selectedIndex];
	}

	function renderCheckbox(element, group) {
	    var style = getComputedStyle$1(element);
	    var color = getPropertyValue(style, "color");
	    var box = element.getBoundingClientRect();
	    if (element.type == "checkbox") {
	        group.append(
	            Path.fromRect(
	                new Rect([ box.left+1, box.top+1 ],
	                             [ box.width-2, box.height-2 ])
	            ).stroke(color, 1)
	        );
	        if (element.checked) {
	            // fill a rectangle inside?  looks kinda ugly.
	            // group.append(
	            //     Path.fromRect(
	            //         new geo.Rect([ box.left+4, box.top+4 ],
	            //                      [ box.width-8, box.height-8])
	            //     ).fill(color).stroke(null)
	            // );

	            // let's draw a checkmark instead.  artistic, eh?
	            group.append(
	                new Path()
	                    .stroke(color, 1.2)
	                    .moveTo(box.left + 0.22 * box.width,
	                            box.top + 0.55 * box.height)
	                    .lineTo(box.left + 0.45 * box.width,
	                            box.top + 0.75 * box.height)
	                    .lineTo(box.left + 0.78 * box.width,
	                            box.top + 0.22 * box.width)
	            );
	        }
	    } else {
	        group.append(
	            new Circle$1(
	                new Circle([
	                    (box.left + box.right) / 2,
	                    (box.top + box.bottom) / 2
	                ], Math.min(box.width-2, box.height-2) / 2)
	            ).stroke(color, 1)
	        );
	        if (element.checked) {
	            group.append(
	                new Circle$1(
	                    new Circle([
	                        (box.left + box.right) / 2,
	                        (box.top + box.bottom) / 2
	                    ], Math.min(box.width-8, box.height-8) / 2)
	                ).fill(color).stroke(null)
	            );
	        }
	    }
	}

	function renderFormField(element, group) {
	    var tag = element.tagName.toLowerCase();
	    if (tag == "input" && (element.type == "checkbox" || element.type == "radio")) {
	        return renderCheckbox(element, group);
	    }
	    var p = element.parentNode;
	    var doc = element.ownerDocument;
	    var el = doc.createElement(KENDO_PSEUDO_ELEMENT);
	    var option;
	    el.style.cssText = getCssText(getComputedStyle$1(element));
	    if (tag == "input") {
	        el.style.whiteSpace = "pre";
	    }
	    if (tag == "select" || tag == "textarea") {
	        el.style.overflow = "auto";
	    }
	    if (tag == "select") {
	        if (element.multiple) {
	            for (var i = 0; i < element.options.length; ++i) {
	                option = doc.createElement(KENDO_PSEUDO_ELEMENT);
	                option.style.cssText = getCssText(getComputedStyle$1(element.options[i]));
	                option.style.display = "block"; // IE9 messes up without this
	                option.textContent = element.options[i].textContent;
	                el.appendChild(option);
	            }
	        } else {
	            option = getSelectedOption(element);
	            if (option) {
	                el.textContent = option.textContent;
	            }
	        }
	    } else {
	        el.textContent = element.value;
	    }
	    p.insertBefore(el, element);
	    el.scrollLeft = element.scrollLeft;
	    el.scrollTop = element.scrollTop;

	    // must temporarily hide the original element, otherwise it
	    // may affect layout of the fake element we want to render.
	    element.style.display = "none";

	    renderContents(el, group);
	    element.style.display = "";
	    p.removeChild(el);
	}

	function renderContents(element, group) {
	    if (nodeInfo._stackingContext.element === element) {
	        // the group that was set in pushNodeInfo might have
	        // changed due to clipping/transforms, update it here.
	        nodeInfo._stackingContext.group = group;
	    }
	    switch (element.tagName.toLowerCase()) {
	      case "img":
	        renderImage(element, element.src, group);
	        break;

	      case "canvas":
	        try {
	            renderImage(element, element.toDataURL("image/png"), group);
	        } catch (ex) {
	            // tainted; can't draw it, ignore.
	        }
	        break;

	      case "textarea":
	      case "input":
	      case "select":
	        renderFormField(element, group);
	        break;

	      default:
	        var children = [], floats = [], positioned = [];
	        for (var i = element.firstChild; i; i = i.nextSibling) {
	            switch (i.nodeType) {
	              case 3:         // Text
	                if (/\S/.test(i.data)) {
	                    renderText(element, i, group);
	                }
	                break;
	              case 1:         // Element
	                var style = getComputedStyle$1(i);
	                var floating = getPropertyValue(style, "float");
	                var position = getPropertyValue(style, "position");
	                if (position != "static") {
	                    positioned.push(i);
	                }
	                else if (floating != "none") {
	                    floats.push(i);
	                } else {
	                    children.push(i);
	                }
	                break;
	            }
	        }

	        mergeSort(children, zIndexSort).forEach(function(el){ renderElement(el, group); });
	        mergeSort(floats, zIndexSort).forEach(function(el){ renderElement(el, group); });
	        mergeSort(positioned, zIndexSort).forEach(function(el){ renderElement(el, group); });
	    }
	}

	function renderText(element, node, group) {
	    if (emptyClipbox()) {
	        return;
	    }
	    var style = getComputedStyle$1(element);

	    if (parseFloat(getPropertyValue(style, "text-indent")) < -500) {
	        // assume it should not be displayed.  the slider's
	        // draggable handle displays a Drag text for some reason,
	        // having text-indent: -3333px.
	        return;
	    }

	    var text = node.data;
	    var start = 0;
	    var end = text.search(/\S\s*$/) + 1;

	    if (!end) {
	        return; // whitespace-only node
	    }

	    var fontSize = getPropertyValue(style, "font-size");
	    var lineHeight = getPropertyValue(style, "line-height");

	    // simply getPropertyValue("font") doesn't work in Firefox :-\
	    var font = [
	        getPropertyValue(style, "font-style"),
	        getPropertyValue(style, "font-variant"),
	        getPropertyValue(style, "font-weight"),
	        fontSize, // no need for line height here; it breaks layout in FF
	        getPropertyValue(style, "font-family")
	    ].join(" ");

	    fontSize = parseFloat(fontSize);
	    lineHeight = parseFloat(lineHeight);

	    if (fontSize === 0) {
	        return;
	    }

	    var color = getPropertyValue(style, "color");
	    var range = element.ownerDocument.createRange();
	    var align$$1 = getPropertyValue(style, "text-align");
	    var isJustified = align$$1 == "justify";
	    var columnCount = getPropertyValue(style, "column-count", 1);
	    var whiteSpace = getPropertyValue(style, "white-space");
	    var textTransform = getPropertyValue(style, "text-transform");

	    // A line of 500px, with a font of 12px, contains an average of 80 characters, but since we
	    // err, we'd like to guess a bigger number rather than a smaller one.  Multiplying by 5
	    // seems to be a good option.
	    var estimateLineLength = element.getBoundingClientRect().width / fontSize * 5;
	    if (estimateLineLength === 0) {
	        estimateLineLength = 500;
	    }

	    // we'll maintain this so we can workaround bugs in Chrome's Range.getClientRects
	    // https://github.com/telerik/kendo/issues/5740
	    var prevLineBottom = null;

	    var underline = nodeInfo["underline"];
	    var lineThrough = nodeInfo["line-through"];
	    var overline = nodeInfo["overline"];
	    var hasDecoration = underline || lineThrough || overline;

	    // doChunk returns true when all text has been rendered
	    while (!doChunk()) {}

	    if (hasDecoration) {
	        range.selectNode(node);
	        slice$1(range.getClientRects()).forEach(decorate);
	    }

	    return;                 // only function declarations after this line

	    function actuallyGetRangeBoundingRect(range) {
	        // XXX: to be revised when this Chrome bug is fixed:
	        // https://bugs.chromium.org/p/chromium/issues/detail?id=612459
	        if (microsoft || browser.chrome) {
	            // Workaround browser bugs: IE and Chrome would sometimes
	            // return 0 or 1-width rectangles before or after the main
	            // one.  https://github.com/telerik/kendo/issues/4674

	            // Actually Chrome 50 got worse, since the rectangles can now have the width of a
	            // full character, making it hard to tell whether it's a bogus rectangle or valid
	            // selection location.  The workaround is to ignore rectangles that fall on the
	            // previous line.  https://github.com/telerik/kendo/issues/5740
	            var rectangles = range.getClientRects(), box = {
	                top    :  Infinity,
	                right  : -Infinity,
	                bottom : -Infinity,
	                left   :  Infinity
	            }, done = false;
	            for (var i = 0; i < rectangles.length; ++i) {
	                var b = rectangles[i];
	                if (b.width <= 1 || b.bottom === prevLineBottom) {
	                    continue;   // bogus rectangle
	                }
	                box.left   = Math.min(b.left   , box.left);
	                box.top    = Math.min(b.top    , box.top);
	                box.right  = Math.max(b.right  , box.right);
	                box.bottom = Math.max(b.bottom , box.bottom);
	                done = true;
	            }
	            if (!done) {
	                return range.getBoundingClientRect();
	            }
	            box.width = box.right - box.left;
	            box.height = box.bottom - box.top;
	            return box;
	        }
	        return range.getBoundingClientRect();
	    }

	    // Render a chunk of text, typically one line (but for justified text we render each word as
	    // a separate Text object, because spacing is variable).  Returns true when it finished the
	    // current node.  After each chunk it updates `start` to just after the last rendered
	    // character.
	    function doChunk() {
	        var origStart = start;
	        var box, pos = text.substr(start).search(/\S/);
	        start += pos;
	        if (pos < 0 || start >= end) {
	            return true;
	        }

	        // Select a single character to determine the height of a line of text.  The box.bottom
	        // will be essential for us to figure out where the next line begins.
	        range.setStart(node, start);
	        range.setEnd(node, start + 1);
	        box = actuallyGetRangeBoundingRect(range);

	        // for justified text we must split at each space, because space has variable width.
	        var found = false;
	        if (isJustified || columnCount > 1) {
	            pos = text.substr(start).search(/\s/);
	            if (pos >= 0) {
	                // we can only split there if it's on the same line, otherwise we'll fall back
	                // to the default mechanism (see findEOL below).
	                range.setEnd(node, start + pos);
	                var r = actuallyGetRangeBoundingRect(range);
	                if (r.bottom == box.bottom) {
	                    box = r;
	                    found = true;
	                    start += pos;
	                }
	            }
	        }

	        if (!found) {
	            // This code does three things: (1) it selects one line of text in `range`, (2) it
	            // leaves the bounding rect of that line in `box` and (3) it returns the position
	            // just after the EOL.  We know where the line starts (`start`) but we don't know
	            // where it ends.  To figure this out, we select a piece of text and look at the
	            // bottom of the bounding box.  If it changes, we have more than one line selected
	            // and should retry with a smaller selection.
	            //
	            // To speed things up, we first try to select all text in the node (`start` ->
	            // `end`).  If there's more than one line there, then select only half of it.  And
	            // so on.  When we find a value for `end` that fits in one line, we try increasing
	            // it (also in halves) until we get to the next line.  The algorithm stops when the
	            // right side of the bounding box does not change.
	            //
	            // One more thing to note is that everything happens in a single Text DOM node.
	            // There's no other tags inside it, therefore the left/top coordinates of the
	            // bounding box will not change.
	            pos = (function findEOL(min, eol, max){
	                range.setEnd(node, eol);
	                var r = actuallyGetRangeBoundingRect(range);
	                if (r.bottom != box.bottom && min < eol) {
	                    return findEOL(min, (min + eol) >> 1, eol);
	                } else if (r.right != box.right) {
	                    box = r;
	                    if (eol < max) {
	                        return findEOL(eol, (eol + max) >> 1, max);
	                    } else {
	                        return eol;
	                    }
	                } else {
	                    return eol;
	                }
	            })(start, Math.min(end, start + estimateLineLength), end);

	            if (pos == start) {
	                // if EOL is at the start, then no more text fits on this line.  Skip the
	                // remainder of this node entirely to avoid a stack overflow.
	                return true;
	            }
	            start = pos;

	            pos = range.toString().search(/\s+$/);
	            if (pos === 0) {
	                return false; // whitespace only; we should not get here.
	            }
	            if (pos > 0) {
	                // eliminate trailing whitespace
	                range.setEnd(node, range.startOffset + pos);
	                box = actuallyGetRangeBoundingRect(range);
	            }
	        }

	        // another workaround for IE: if we rely on getBoundingClientRect() we'll overlap with the bullet for LI
	        // elements.  Calling getClientRects() and using the *first* rect appears to give us the correct location.
	        // Note: not to be used in Chrome as it randomly returns a zero-width rectangle from the previous line.
	        if (microsoft) {
	            box = range.getClientRects()[0];
	        }

	        var str = range.toString();
	        if (!/^(?:pre|pre-wrap)$/i.test(whiteSpace)) {
	            // node with non-significant space -- collapse whitespace.
	            str = str.replace(/\s+/g, " ");
	        }
	        else if (/\t/.test(str)) {
	            // with significant whitespace we need to do something about literal TAB characters.
	            // There's no TAB glyph in a font so they would be rendered in PDF as an empty box,
	            // and the whole text will stretch to fill the original width.  The core PDF lib
	            // does not have sufficient context to deal with it.

	            // calculate the starting column here, since we initially discarded any whitespace.
	            var cc = 0;
	            for (pos = origStart; pos < range.startOffset; ++pos) {
	                var code = text.charCodeAt(pos);
	                if (code == 9) {
	                    // when we meet a TAB we must round up to the next tab stop.
	                    // in all browsers TABs seem to be 8 characters.
	                    cc += 8 - cc % 8;
	                } else if (code == 10 || code == 13) {
	                    // just in case we meet a newline we must restart.
	                    cc = 0;
	                } else {
	                    // ordinary character --> advance one column
	                    cc++;
	                }
	            }

	            // based on starting column, replace any TAB characters in the string we actually
	            // have to display with spaces so that they align to columns multiple of 8.
	            while ((pos = str.search("\t")) >= 0) {
	                var indent = "        ".substr(0, 8 - (cc + pos) % 8);
	                str = str.substr(0, pos) + indent + str.substr(pos + 1);
	            }
	        }

	        if (!found) {
	            prevLineBottom = box.bottom;
	        }
	        drawText(str, box);
	    }

	    function drawText(str, box) {
	        // In IE the box height will be approximately lineHeight, while in
	        // other browsers it'll (correctly) be the height of the bounding
	        // box for the current text/font.  Which is to say, IE sucks again.
	        // The only good solution I can think of is to measure the text
	        // ourselves and center the bounding box.
	        if (microsoft && !isNaN(lineHeight)) {
	            var height = getFontHeight(font);
	            var top = (box.top + box.bottom - height) / 2;
	            box = {
	                top    : top,
	                right  : box.right,
	                bottom : top + height,
	                left   : box.left,
	                height : height,
	                width  : box.right - box.left
	            };
	        }

	        // var path = new Path({ stroke: { color: "red" }});
	        // path.moveTo(box.left, box.top)
	        //     .lineTo(box.right, box.top)
	        //     .lineTo(box.right, box.bottom)
	        //     .lineTo(box.left, box.bottom)
	        //     .close();
	        // group.append(path);

	        switch (textTransform) {
	          case "uppercase":
	            str = str.toUpperCase();
	            break;
	          case "lowercase":
	            str = str.toLowerCase();
	            break;
	          case "capitalize":
	            str = str.replace(/(?:^|\s)\S/g, function (l) { return l.toUpperCase(); });
	            break;
	        }

	        var text = new TextRect(
	            str, new Rect([ box.left, box.top ],
	                              [ box.width, box.height ]),
	            {
	                font: font,
	                fill: { color: color }
	            }
	        );
	        group.append(text);
	    }

	    function decorate(box) {
	        line(underline, box.bottom);
	        line(lineThrough, box.bottom - box.height / 2.7);
	        line(overline, box.top);
	        function line(color, ypos) {
	            if (color) {
	                var width = fontSize / 12;
	                var path = new Path({ stroke: {
	                    width: width,
	                    color: color
	                }});

	                ypos -= width;
	                path.moveTo(box.left, ypos)
	                    .lineTo(box.right, ypos);
	                group.append(path);
	            }
	        }
	    }
	}

	function groupInStackingContext(element, group, zIndex) {
	    var main;
	    if (zIndex != "auto") {
	        // use the current stacking context
	        main = nodeInfo._stackingContext.group;
	        zIndex = parseFloat(zIndex);
	    } else {
	        // normal flow — use given container.  we still have to
	        // figure out where should we insert this element with the
	        // assumption that its z-index is zero, as the group might
	        // already contain elements with higher z-index.
	        main = group;
	        zIndex = 0;
	    }
	    var a = main.children;
	    for (var i = 0; i < a.length; ++i) {
	        if (a[i]._dom_zIndex != null && a[i]._dom_zIndex > zIndex) {
	            break;
	        }
	    }

	    var tmp = new Group();
	    main.insert(i, tmp);
	    tmp._dom_zIndex = zIndex;

	    if (main !== group) {
	        // console.log("Placing", element, "in", nodeInfo._stackingContext.element, "at position", i, " / ", a.length);
	        // console.log(a.slice(i+1));

	        // if (nodeInfo._matrix) {
	        //     tmp.transform(nodeInfo._matrix);
	        // }
	        if (nodeInfo._clipbox) {
	            var m = nodeInfo._matrix.invert();
	            var r = nodeInfo._clipbox.transformCopy(m);
	            setClipping(tmp, Path.fromRect(r));
	            // console.log(r);
	            // tmp.append(Path.fromRect(r));
	            // tmp.append(new Text(element.className || element.id, r.topLeft()));
	        }
	    }

	    return tmp;
	}

	function renderElement(element, container) {
	    var style = getComputedStyle$1(element);

	    updateCounters(style);

	    if (/^(style|script|link|meta|iframe|svg|col|colgroup)$/i.test(element.tagName)) {
	        return;
	    }

	    if (nodeInfo._clipbox == null) {
	        return;
	    }

	    var opacity = parseFloat(getPropertyValue(style, "opacity"));
	    var visibility = getPropertyValue(style, "visibility");
	    var display = getPropertyValue(style, "display");

	    if (opacity === 0 || visibility == "hidden" || display == "none") {
	        return;
	    }

	    var tr = getTransform(style);
	    var group;

	    var zIndex = getPropertyValue(style, "z-index");
	    if ((tr || opacity < 1) && zIndex == "auto") {
	        zIndex = 0;
	    }
	    group = groupInStackingContext(element, container, zIndex);

	    // XXX: remove at some point
	    // group._pdfElement = element;
	    // group.options._pdfDebug = "";
	    // if (element.id) {
	    //     group.options._pdfDebug = "#" + element.id;
	    // }
	    // if (element.className) {
	    //     group.options._pdfDebug += "." + element.className.split(" ").join(".");
	    // }

	    if (opacity < 1) {
	        group.opacity(opacity * group.opacity());
	    }

	    pushNodeInfo(element, style, group);

	    if (!tr) {
	        _renderWithPseudoElements(element, group);
	    }
	    else {
	        saveStyle(element, function(){
	            // must clear transform, so getBoundingClientRect returns correct values.
	            pleaseSetPropertyValue(element.style, "transform", "none", "important");

	            // must also clear transitions, so correct values are returned *immediately*
	            pleaseSetPropertyValue(element.style, "transition", "none", "important");

	            // the presence of any transform makes it behave like it had position: relative,
	            // because why not.
	            // http://meyerweb.com/eric/thoughts/2011/09/12/un-fixing-fixed-elements-with-css-transforms/
	            if (getPropertyValue(style, "position") == "static") {
	                // but only if it's not already positioned. :-/
	                pleaseSetPropertyValue(element.style, "position", "relative", "important");
	            }

	            // must translate to origin before applying the CSS
	            // transformation, then translate back.
	            var bbox = element.getBoundingClientRect();
	            var x = bbox.left + tr.origin[0];
	            var y = bbox.top + tr.origin[1];
	            var m = [ 1, 0, 0, 1, -x, -y ];
	            m = mmul(m, tr.matrix);
	            m = mmul(m, [ 1, 0, 0, 1, x, y ]);
	            m = setTransform(group, m);

	            nodeInfo._matrix = nodeInfo._matrix.multiplyCopy(m);

	            _renderWithPseudoElements(element, group);
	        });
	    }

	    popNodeInfo();

	    //drawDebugBox(element.getBoundingClientRect(), container);
	}

	// function drawDebugBox(box, group, color) {
	//     var path = Path.fromRect(new geo.Rect([ box.left, box.top ], [ box.width, box.height ]));
	//     if (color) {
	//         path.stroke(color);
	//     }
	//     group.append(path);
	// }

	// function dumpTextNode(node) {
	//     var txt = node.data.replace(/^\s+/, "");
	//     if (txt.length < 100) {
	//         console.log(node.data.length + ": |" + txt);
	//     } else {
	//         console.log(node.data.length + ": |" + txt.substr(0, 50) + "|...|" + txt.substr(-50));
	//     }
	// }

	function mmul(a, b) {
	    var a1 = a[0], b1 = a[1], c1 = a[2], d1 = a[3], e1 = a[4], f1 = a[5];
	    var a2 = b[0], b2 = b[1], c2 = b[2], d2 = b[3], e2 = b[4], f2 = b[5];
	    return [
	        a1*a2 + b1*c2,          a1*b2 + b1*d2,
	        c1*a2 + d1*c2,          c1*b2 + d1*d2,
	        e1*a2 + f1*c2 + e2,     e1*b2 + f1*d2 + f2
	    ];
	}

	var drawing = {
		svg: svg,
		canvas: canvas,
		util: util,
		PathParser: PathParser,
		Surface: Surface,
		BaseNode: BaseNode,
		SurfaceFactory: SurfaceFactory,
		OptionsStore: OptionsStore,
		exportImage: exportImage,
		exportSVG: exportSVG,
		QuadNode: QuadNode,
		ShapesQuadTree: ShapesQuadTree,
		ObserversMixin: ObserversMixin,
		Element: Element$1,
		Circle: Circle$1,
		Arc: Arc$2,
		Path: Path,
		MultiPath: MultiPath,
		Text: Text,
		Image: Image$1,
		Group: Group,
		Layout: Layout,
		Rect: Rect$2,
		align: align,
		vAlign: vAlign,
		stack: stack,
		vStack: vStack,
		wrap: wrap,
		vWrap: vWrap,
		fit: fit,
		LinearGradient: LinearGradient,
		RadialGradient: RadialGradient,
		GradientStop: GradientStop,
		Gradient: Gradient,
		Animation: Animation,
		AnimationFactory: AnimationFactory,
		drawDOM: drawDOM
	};

	kendo.deepExtend(kendo, {
	    drawing: drawing,
	    geometry: geometry
	});

	kendo.drawing.Segment = kendo.geometry.Segment;
	kendo.dataviz.drawing = kendo.drawing;
	kendo.dataviz.geometry = kendo.geometry;
	kendo.drawing.util.measureText = kendo.util.measureText;
	kendo.drawing.util.objectKey = kendo.util.objectKey;
	kendo.drawing.Color = kendo.Color;
	kendo.util.encodeBase64 = kendo.drawing.util.encodeBase64;

	})(window.kendo.jQuery);

	}, __webpack_require__(3));

/***/ }),

/***/ 947:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("IlyZ");

/***/ }),

/***/ 948:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Fv0e");

/***/ }),

/***/ 949:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ZruT");

/***/ })

/******/ });

/***/ }),

/***/ "KCLY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("cGG2");
var normalizeHeaderName = __webpack_require__("5VQ+");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("7GwW");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__("7GwW");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "KEjV":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1152);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1045:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FTkt");

/***/ }),

/***/ 1110:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nzx/");

/***/ }),

/***/ 1152:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1110), __webpack_require__(1045) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "dataviz.qrcode",
	    name: "QRCode",
	    category: "dataviz",
	    description: "QRCode widget.",
	    depends: [ "dataviz.core", "drawing" ]
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        extend = $.extend,
	        draw = kendo.drawing,
	        dataviz = kendo.dataviz,
	        Widget = kendo.ui.Widget,
	        Box2D = dataviz.Box2D,
	        terminator = "0000",
	        NUMERIC = "numeric",
	        ALPHA_NUMERIC = "alphanumeric",
	        BYTE = "byte",
	        powersOfTwo = {"1": 0},
	        powersOfTwoResult = {"0": 1},
	        generatorPolynomials = [[1,0],[1,25,0]],
	        irregularAlignmentPatternsStartDistance = {15:20,16:20,18:24,19:24,22:20,24:22,26:24,28:20,30:20,31:24,32:28,33:24,36:18,37:22,39:20,40:24},
	        versionsCodewordsInformation = [{L:{groups:[[1,19]],totalDataCodewords:19,errorCodewordsPerBlock:7},M:{groups:[[1,16]],totalDataCodewords:16,errorCodewordsPerBlock:10},Q:{groups:[[1,13]],totalDataCodewords:13,errorCodewordsPerBlock:13},H:{groups:[[1,9]],totalDataCodewords:9,errorCodewordsPerBlock:17}},{L:{groups:[[1,34]],totalDataCodewords:34,errorCodewordsPerBlock:10},M:{groups:[[1,28]],totalDataCodewords:28,errorCodewordsPerBlock:16},Q:{groups:[[1,22]],totalDataCodewords:22,errorCodewordsPerBlock:22},H:{groups:[[1,16]],totalDataCodewords:16,errorCodewordsPerBlock:28}},{L:{groups:[[1,55]],totalDataCodewords:55,errorCodewordsPerBlock:15},M:{groups:[[1,44]],totalDataCodewords:44,errorCodewordsPerBlock:26},Q:{groups:[[2,17]],totalDataCodewords:34,errorCodewordsPerBlock:18},H:{groups:[[2,13]],totalDataCodewords:26,errorCodewordsPerBlock:22}},{L:{groups:[[1,80]],totalDataCodewords:80,errorCodewordsPerBlock:20},M:{groups:[[2,32]],totalDataCodewords:64,errorCodewordsPerBlock:18},Q:{groups:[[2,24]],totalDataCodewords:48,errorCodewordsPerBlock:26},H:{groups:[[4,9]],totalDataCodewords:36,errorCodewordsPerBlock:16}},{L:{groups:[[1,108]],totalDataCodewords:108,errorCodewordsPerBlock:26},M:{groups:[[2,43]],totalDataCodewords:86,errorCodewordsPerBlock:24},Q:{groups:[[2,15],[2,16]],totalDataCodewords:62,errorCodewordsPerBlock:18},H:{groups:[[2,11],[2,12]],totalDataCodewords:46,errorCodewordsPerBlock:22}},{L:{groups:[[2,68]],totalDataCodewords:136,errorCodewordsPerBlock:18},M:{groups:[[4,27]],totalDataCodewords:108,errorCodewordsPerBlock:16},Q:{groups:[[4,19]],totalDataCodewords:76,errorCodewordsPerBlock:24},H:{groups:[[4,15]],totalDataCodewords:60,errorCodewordsPerBlock:28}},{L:{groups:[[2,78]],totalDataCodewords:156,errorCodewordsPerBlock:20},M:{groups:[[4,31]],totalDataCodewords:124,errorCodewordsPerBlock:18},Q:{groups:[[2,14],[4,15]],totalDataCodewords:88,errorCodewordsPerBlock:18},H:{groups:[[4,13],[1,14]],totalDataCodewords:66,errorCodewordsPerBlock:26}},{L:{groups:[[2,97]],totalDataCodewords:194,errorCodewordsPerBlock:24},M:{groups:[[2,38],[2,39]],totalDataCodewords:154,errorCodewordsPerBlock:22},Q:{groups:[[4,18],[2,19]],totalDataCodewords:110,errorCodewordsPerBlock:22},H:{groups:[[4,14],[2,15]],totalDataCodewords:86,errorCodewordsPerBlock:26}},{L:{groups:[[2,116]],totalDataCodewords:232,errorCodewordsPerBlock:30},M:{groups:[[3,36],[2,37]],totalDataCodewords:182,errorCodewordsPerBlock:22},Q:{groups:[[4,16],[4,17]],totalDataCodewords:132,errorCodewordsPerBlock:20},H:{groups:[[4,12],[4,13]],totalDataCodewords:100,errorCodewordsPerBlock:24}},{L:{groups:[[2,68],[2,69]],totalDataCodewords:274,errorCodewordsPerBlock:18},M:{groups:[[4,43],[1,44]],totalDataCodewords:216,errorCodewordsPerBlock:26},Q:{groups:[[6,19],[2,20]],totalDataCodewords:154,errorCodewordsPerBlock:24},H:{groups:[[6,15],[2,16]],totalDataCodewords:122,errorCodewordsPerBlock:28}},{L:{groups:[[4,81]],totalDataCodewords:324,errorCodewordsPerBlock:20},M:{groups:[[1,50],[4,51]],totalDataCodewords:254,errorCodewordsPerBlock:30},Q:{groups:[[4,22],[4,23]],totalDataCodewords:180,errorCodewordsPerBlock:28},H:{groups:[[3,12],[8,13]],totalDataCodewords:140,errorCodewordsPerBlock:24}},{L:{groups:[[2,92],[2,93]],totalDataCodewords:370,errorCodewordsPerBlock:24},M:{groups:[[6,36],[2,37]],totalDataCodewords:290,errorCodewordsPerBlock:22},Q:{groups:[[4,20],[6,21]],totalDataCodewords:206,errorCodewordsPerBlock:26},H:{groups:[[7,14],[4,15]],totalDataCodewords:158,errorCodewordsPerBlock:28}},{L:{groups:[[4,107]],totalDataCodewords:428,errorCodewordsPerBlock:26},M:{groups:[[8,37],[1,38]],totalDataCodewords:334,errorCodewordsPerBlock:22},Q:{groups:[[8,20],[4,21]],totalDataCodewords:244,errorCodewordsPerBlock:24},H:{groups:[[12,11],[4,12]],totalDataCodewords:180,errorCodewordsPerBlock:22}},{L:{groups:[[3,115],[1,116]],totalDataCodewords:461,errorCodewordsPerBlock:30},M:{groups:[[4,40],[5,41]],totalDataCodewords:365,errorCodewordsPerBlock:24},Q:{groups:[[11,16],[5,17]],totalDataCodewords:261,errorCodewordsPerBlock:20},H:{groups:[[11,12],[5,13]],totalDataCodewords:197,errorCodewordsPerBlock:24}},{L:{groups:[[5,87],[1,88]],totalDataCodewords:523,errorCodewordsPerBlock:22},M:{groups:[[5,41],[5,42]],totalDataCodewords:415,errorCodewordsPerBlock:24},Q:{groups:[[5,24],[7,25]],totalDataCodewords:295,errorCodewordsPerBlock:30},H:{groups:[[11,12],[7,13]],totalDataCodewords:223,errorCodewordsPerBlock:24}},{L:{groups:[[5,98],[1,99]],totalDataCodewords:589,errorCodewordsPerBlock:24},M:{groups:[[7,45],[3,46]],totalDataCodewords:453,errorCodewordsPerBlock:28},Q:{groups:[[15,19],[2,20]],totalDataCodewords:325,errorCodewordsPerBlock:24},H:{groups:[[3,15],[13,16]],totalDataCodewords:253,errorCodewordsPerBlock:30}},{L:{groups:[[1,107],[5,108]],totalDataCodewords:647,errorCodewordsPerBlock:28},M:{groups:[[10,46],[1,47]],totalDataCodewords:507,errorCodewordsPerBlock:28},Q:{groups:[[1,22],[15,23]],totalDataCodewords:367,errorCodewordsPerBlock:28},H:{groups:[[2,14],[17,15]],totalDataCodewords:283,errorCodewordsPerBlock:28}},{L:{groups:[[5,120],[1,121]],totalDataCodewords:721,errorCodewordsPerBlock:30},M:{groups:[[9,43],[4,44]],totalDataCodewords:563,errorCodewordsPerBlock:26},Q:{groups:[[17,22],[1,23]],totalDataCodewords:397,errorCodewordsPerBlock:28},H:{groups:[[2,14],[19,15]],totalDataCodewords:313,errorCodewordsPerBlock:28}},{L:{groups:[[3,113],[4,114]],totalDataCodewords:795,errorCodewordsPerBlock:28},M:{groups:[[3,44],[11,45]],totalDataCodewords:627,errorCodewordsPerBlock:26},Q:{groups:[[17,21],[4,22]],totalDataCodewords:445,errorCodewordsPerBlock:26},H:{groups:[[9,13],[16,14]],totalDataCodewords:341,errorCodewordsPerBlock:26}},{L:{groups:[[3,107],[5,108]],totalDataCodewords:861,errorCodewordsPerBlock:28},M:{groups:[[3,41],[13,42]],totalDataCodewords:669,errorCodewordsPerBlock:26},Q:{groups:[[15,24],[5,25]],totalDataCodewords:485,errorCodewordsPerBlock:30},H:{groups:[[15,15],[10,16]],totalDataCodewords:385,errorCodewordsPerBlock:28}},{L:{groups:[[4,116],[4,117]],totalDataCodewords:932,errorCodewordsPerBlock:28},M:{groups:[[17,42]],totalDataCodewords:714,errorCodewordsPerBlock:26},Q:{groups:[[17,22],[6,23]],totalDataCodewords:512,errorCodewordsPerBlock:28},H:{groups:[[19,16],[6,17]],totalDataCodewords:406,errorCodewordsPerBlock:30}},{L:{groups:[[2,111],[7,112]],totalDataCodewords:1006,errorCodewordsPerBlock:28},M:{groups:[[17,46]],totalDataCodewords:782,errorCodewordsPerBlock:28},Q:{groups:[[7,24],[16,25]],totalDataCodewords:568,errorCodewordsPerBlock:30},H:{groups:[[34,13]],totalDataCodewords:442,errorCodewordsPerBlock:24}},{L:{groups:[[4,121],[5,122]],totalDataCodewords:1094,errorCodewordsPerBlock:30},M:{groups:[[4,47],[14,48]],totalDataCodewords:860,errorCodewordsPerBlock:28},Q:{groups:[[11,24],[14,25]],totalDataCodewords:614,errorCodewordsPerBlock:30},H:{groups:[[16,15],[14,16]],totalDataCodewords:464,errorCodewordsPerBlock:30}},{L:{groups:[[6,117],[4,118]],totalDataCodewords:1174,errorCodewordsPerBlock:30},M:{groups:[[6,45],[14,46]],totalDataCodewords:914,errorCodewordsPerBlock:28},Q:{groups:[[11,24],[16,25]],totalDataCodewords:664,errorCodewordsPerBlock:30},H:{groups:[[30,16],[2,17]],totalDataCodewords:514,errorCodewordsPerBlock:30}},{L:{groups:[[8,106],[4,107]],totalDataCodewords:1276,errorCodewordsPerBlock:26},M:{groups:[[8,47],[13,48]],totalDataCodewords:1000,errorCodewordsPerBlock:28},Q:{groups:[[7,24],[22,25]],totalDataCodewords:718,errorCodewordsPerBlock:30},H:{groups:[[22,15],[13,16]],totalDataCodewords:538,errorCodewordsPerBlock:30}},{L:{groups:[[10,114],[2,115]],totalDataCodewords:1370,errorCodewordsPerBlock:28},M:{groups:[[19,46],[4,47]],totalDataCodewords:1062,errorCodewordsPerBlock:28},Q:{groups:[[28,22],[6,23]],totalDataCodewords:754,errorCodewordsPerBlock:28},H:{groups:[[33,16],[4,17]],totalDataCodewords:596,errorCodewordsPerBlock:30}},{L:{groups:[[8,122],[4,123]],totalDataCodewords:1468,errorCodewordsPerBlock:30},M:{groups:[[22,45],[3,46]],totalDataCodewords:1128,errorCodewordsPerBlock:28},Q:{groups:[[8,23],[26,24]],totalDataCodewords:808,errorCodewordsPerBlock:30},H:{groups:[[12,15],[28,16]],totalDataCodewords:628,errorCodewordsPerBlock:30}},{L:{groups:[[3,117],[10,118]],totalDataCodewords:1531,errorCodewordsPerBlock:30},M:{groups:[[3,45],[23,46]],totalDataCodewords:1193,errorCodewordsPerBlock:28},Q:{groups:[[4,24],[31,25]],totalDataCodewords:871,errorCodewordsPerBlock:30},H:{groups:[[11,15],[31,16]],totalDataCodewords:661,errorCodewordsPerBlock:30}},{L:{groups:[[7,116],[7,117]],totalDataCodewords:1631,errorCodewordsPerBlock:30},M:{groups:[[21,45],[7,46]],totalDataCodewords:1267,errorCodewordsPerBlock:28},Q:{groups:[[1,23],[37,24]],totalDataCodewords:911,errorCodewordsPerBlock:30},H:{groups:[[19,15],[26,16]],totalDataCodewords:701,errorCodewordsPerBlock:30}},{L:{groups:[[5,115],[10,116]],totalDataCodewords:1735,errorCodewordsPerBlock:30},M:{groups:[[19,47],[10,48]],totalDataCodewords:1373,errorCodewordsPerBlock:28},Q:{groups:[[15,24],[25,25]],totalDataCodewords:985,errorCodewordsPerBlock:30},H:{groups:[[23,15],[25,16]],totalDataCodewords:745,errorCodewordsPerBlock:30}},{L:{groups:[[13,115],[3,116]],totalDataCodewords:1843,errorCodewordsPerBlock:30},M:{groups:[[2,46],[29,47]],totalDataCodewords:1455,errorCodewordsPerBlock:28},Q:{groups:[[42,24],[1,25]],totalDataCodewords:1033,errorCodewordsPerBlock:30},H:{groups:[[23,15],[28,16]],totalDataCodewords:793,errorCodewordsPerBlock:30}},{L:{groups:[[17,115]],totalDataCodewords:1955,errorCodewordsPerBlock:30},M:{groups:[[10,46],[23,47]],totalDataCodewords:1541,errorCodewordsPerBlock:28},Q:{groups:[[10,24],[35,25]],totalDataCodewords:1115,errorCodewordsPerBlock:30},H:{groups:[[19,15],[35,16]],totalDataCodewords:845,errorCodewordsPerBlock:30}},{L:{groups:[[17,115],[1,116]],totalDataCodewords:2071,errorCodewordsPerBlock:30},M:{groups:[[14,46],[21,47]],totalDataCodewords:1631,errorCodewordsPerBlock:28},Q:{groups:[[29,24],[19,25]],totalDataCodewords:1171,errorCodewordsPerBlock:30},H:{groups:[[11,15],[46,16]],totalDataCodewords:901,errorCodewordsPerBlock:30}},{L:{groups:[[13,115],[6,116]],totalDataCodewords:2191,errorCodewordsPerBlock:30},M:{groups:[[14,46],[23,47]],totalDataCodewords:1725,errorCodewordsPerBlock:28},Q:{groups:[[44,24],[7,25]],totalDataCodewords:1231,errorCodewordsPerBlock:30},H:{groups:[[59,16],[1,17]],totalDataCodewords:961,errorCodewordsPerBlock:30}},{L:{groups:[[12,121],[7,122]],totalDataCodewords:2306,errorCodewordsPerBlock:30},M:{groups:[[12,47],[26,48]],totalDataCodewords:1812,errorCodewordsPerBlock:28},Q:{groups:[[39,24],[14,25]],totalDataCodewords:1286,errorCodewordsPerBlock:30},H:{groups:[[22,15],[41,16]],totalDataCodewords:986,errorCodewordsPerBlock:30}},{L:{groups:[[6,121],[14,122]],totalDataCodewords:2434,errorCodewordsPerBlock:30},M:{groups:[[6,47],[34,48]],totalDataCodewords:1914,errorCodewordsPerBlock:28},Q:{groups:[[46,24],[10,25]],totalDataCodewords:1354,errorCodewordsPerBlock:30},H:{groups:[[2,15],[64,16]],totalDataCodewords:1054,errorCodewordsPerBlock:30}},{L:{groups:[[17,122],[4,123]],totalDataCodewords:2566,errorCodewordsPerBlock:30},M:{groups:[[29,46],[14,47]],totalDataCodewords:1992,errorCodewordsPerBlock:28},Q:{groups:[[49,24],[10,25]],totalDataCodewords:1426,errorCodewordsPerBlock:30},H:{groups:[[24,15],[46,16]],totalDataCodewords:1096,errorCodewordsPerBlock:30}},{L:{groups:[[4,122],[18,123]],totalDataCodewords:2702,errorCodewordsPerBlock:30},M:{groups:[[13,46],[32,47]],totalDataCodewords:2102,errorCodewordsPerBlock:28},Q:{groups:[[48,24],[14,25]],totalDataCodewords:1502,errorCodewordsPerBlock:30},H:{groups:[[42,15],[32,16]],totalDataCodewords:1142,errorCodewordsPerBlock:30}},{L:{groups:[[20,117],[4,118]],totalDataCodewords:2812,errorCodewordsPerBlock:30},M:{groups:[[40,47],[7,48]],totalDataCodewords:2216,errorCodewordsPerBlock:28},Q:{groups:[[43,24],[22,25]],totalDataCodewords:1582,errorCodewordsPerBlock:30},H:{groups:[[10,15],[67,16]],totalDataCodewords:1222,errorCodewordsPerBlock:30}},{L:{groups:[[19,118],[6,119]],totalDataCodewords:2956,errorCodewordsPerBlock:30},M:{groups:[[18,47],[31,48]],totalDataCodewords:2334,errorCodewordsPerBlock:28},Q:{groups:[[34,24],[34,25]],totalDataCodewords:1666,errorCodewordsPerBlock:30},H:{groups:[[20,15],[61,16]],totalDataCodewords:1276,errorCodewordsPerBlock:30}}],
	        finderPattern = [1,0,1,1,1],
	        alignmentPattern = [1,0,1],
	        errorCorrectionPatterns = {L: "01", M: "00", Q: "11", H: "10"},
	        formatMaskPattern = "101010000010010",
	        formatGeneratorPolynomial = "10100110111",
	        versionGeneratorPolynomial = "1111100100101",
	        paddingCodewords = ["11101100", "00010001"],
	        finderPatternValue = 93,
	        maskPatternConditions = [
	            function(row,column){return (row + column) % 2 === 0;},
	            function(row){return row % 2 === 0;},
	            function(row,column){return column % 3 === 0;},
	            function(row,column){return (row + column) % 3 === 0;},
	            function(row,column){return (Math.floor(row/2) + Math.floor(column/3)) % 2 === 0;},
	            function(row,column){return ((row * column) % 2) + ((row * column) % 3) === 0;},
	            function(row,column){return (((row * column) % 2) + ((row * column) % 3)) % 2 === 0;},
	            function(row,column){return (((row + column) % 2) + ((row * column) % 3)) % 2 === 0;}
	        ],
	        numberRegex = /^\d+/,
	        alphaPattern = "A-Z0-9 $%*+./:-",
	        alphaExclusiveSet = "A-Z $%*+./:-",
	        alphaRegex = new RegExp("^[" + alphaExclusiveSet + "]+"),
	        alphaNumericRegex = new RegExp("^[" + alphaPattern+ "]+"),
	        byteRegex = new RegExp("^[^" + alphaPattern+ "]+"),
	        initMinNumericBeforeAlpha = 8,
	        initMinNumericBeforeByte = 5,
	        initMinAlphaBeforeByte = 8,
	        minNumericBeforeAlpha = 17,
	        minNumericBeforeByte = 9,
	        minAlphaBeforeByte =  16,
	        round = Math.round;

	        function toDecimal(value){
	            return parseInt(value, 2);
	        }

	        function toBitsString(value, length){
	            var result = Number(value).toString(2);
	            if(result.length < length){
	                result = new Array(length - result.length + 1).join(0) + result;
	            }
	            return result;
	        }

	        function splitInto(str, n){
	            var result = [],
	                idx = 0;
	            while(idx < str.length){
	                result.push(str.substring(idx, idx + n));
	                idx+= n;
	            }
	            return result;
	        }

	        var QRDataMode = kendo.Class.extend({
	            getVersionIndex: function(version){
	                if(version < 10){
	                    return 0;
	                }
	                else if(version > 26){
	                    return 2;
	                }

	                return 1;
	            },
	            getBitsCharacterCount: function(version){
	                var mode = this;
	                return mode.bitsInCharacterCount[mode.getVersionIndex(version || 40)];
	            },
	            getModeCountString: function(length, version){
	                var mode = this;
	                return mode.modeIndicator + toBitsString(length, mode.getBitsCharacterCount(version));
	            },
	            encode: function(){},
	            getStringBitsLength: function(){},
	            getValue: function(){},
	            modeIndicator: "",
	            bitsInCharacterCount: []
	        });

	        var modes = {};
	        modes[NUMERIC] = QRDataMode.extend({
	            bitsInCharacterCount: [10, 12, 14],
	            modeIndicator: "0001",
	            getValue: function(character){
	                return parseInt(character, 10);
	            },
	            encode: function(str, version){
	                var mode = this,
	                    parts = splitInto(str, 3),
	                    result = mode.getModeCountString(str.length, version);

	                for(var i = 0; i < parts.length - 1; i++){
	                    result += toBitsString(parts[i], 10);
	                }
	                return result + toBitsString(parts[i], 1 + 3 * parts[i].length);
	            },
	            getStringBitsLength: function(inputLength, version){
	                var mod3 = inputLength % 3;
	                return 4 + this.getBitsCharacterCount(version) + 10 * Math.floor(inputLength / 3) + 3 * mod3 + (mod3 === 0 ? 0 : 1);
	            }
	        });

	        modes[ALPHA_NUMERIC] = QRDataMode.extend({
	            characters: {"0":0,"1": 1,"2": 2,"3": 3,"4": 4,"5": 5,"6": 6,"7": 7,"8": 8,"9": 9,"A": 10,"B": 11,"C": 12,"D": 13,"E": 14,"F": 15,"G": 16,"H": 17,"I": 18,"J": 19,"K": 20,"L": 21,"M": 22,"N": 23,"O": 24,"P": 25,"Q": 26,"R": 27,"S": 28,"T": 29,"U": 30,"V": 31,"W": 32,"X": 33,"Y": 34,"Z": 35," ": 36,"$": 37,"%": 38,"*": 39,"+": 40,"-": 41,".": 42,"/": 43,":": 44},
	            bitsInCharacterCount: [9,11,13],
	            modeIndicator: "0010",
	            getValue: function(character){
	                return this.characters[character];
	            },
	            encode: function(str, version){
	                var mode = this,
	                    parts = splitInto(str, 2),
	                    result = mode.getModeCountString(str.length, version),
	                    value;
	                for(var i = 0; i < parts.length - 1; i++){
	                    value = 45 * mode.getValue(parts[i].charAt(0)) + mode.getValue(parts[i].charAt(1));
	                    result += toBitsString(value, 11);
	                }
	                value = parts[i].length == 2 ?
	                    45 * mode.getValue(parts[i].charAt(0)) + mode.getValue(parts[i].charAt(1)) :
	                    mode.getValue(parts[i].charAt(0));
	                return result + toBitsString(value, 1 + 5 * parts[i].length);
	            },
	            getStringBitsLength: function(inputLength, version){
	                return 4 + this.getBitsCharacterCount(version) + 11 * Math.floor(inputLength / 2) + 6 * (inputLength % 2);
	            }
	        });

	        modes[BYTE] = QRDataMode.extend({
	            bitsInCharacterCount: [8,16,16],
	            modeIndicator: "0100",
	            getValue: function(character){
	                var code = character.charCodeAt(0);
	                if(code <= 127 || (160 <= code && code <= 255)){
	                    return code;
	                }
	                else{
	                    throw new Error("Unsupported character: " + character);
	                }
	            },
	            encode: function(str, version){
	                var mode = this,
	                    result = mode.getModeCountString(str.length, version);

	                for(var i = 0; i < str.length; i++){
	                    result += toBitsString(mode.getValue(str.charAt(i)), 8);
	                }
	                return result;
	            },
	            getStringBitsLength: function(inputLength, version){
	                return 4 + this.getBitsCharacterCount(version) + 8 * inputLength;
	            }
	        });

	        var modeInstances = {};
	        for(var mode in modes){
	            modeInstances[mode] = new modes[mode]();
	        }

	        var FreeCellVisitor = function (matrix){
	            var that = this,
	                row = matrix.length - 1,
	                column = matrix.length - 1,
	                startColumn = column,
	                dir = -1,
	                c = 0;
	            that.move = function(){
	                row += dir * c;
	                c^=1;
	                column = startColumn - c;
	            };
	            that.getNextCell = function(){
	                while(matrix[row][column] !== undefined){
	                    that.move();
	                    if(row < 0 || row >= matrix.length){
	                        dir = -dir;
	                        startColumn-= startColumn != 8 ? 2 : 3;
	                        column = startColumn;
	                        row = dir < 0 ? matrix.length - 1 : 0;
	                    }
	                }
	                return {row: row, column: column};
	            };
	            that.getNextRemainderCell = function(){
	                that.move();
	                if(matrix[row][column] === undefined){
	                     return {row: row, column: column};
	                }
	            };
	        };

	        function fillFunctionCell(matrices, bit, x, y){
	            for(var i = 0; i< matrices.length;i++){
	                matrices[i][x][y] = bit;
	            }
	        }

	        function fillDataCell(matrices, bit, x, y){
	            for(var i = 0; i < maskPatternConditions.length;i++){
	                matrices[i][x][y] = maskPatternConditions[i](x,y) ? bit ^ 1 : parseInt(bit, 10);
	            }
	        }

	        var fillData = function (matrices, blocks){
	            var cellVisitor = new FreeCellVisitor(matrices[0]),
	                block,
	                codewordIdx,
	                cell;

	            for(var blockIdx = 0; blockIdx < blocks.length;blockIdx++){
	                block = blocks[blockIdx];
	                codewordIdx = 0;
	                while(block.length > 0){
	                    for(var i = 0; i< block.length; i++){
	                         for(var j = 0; j < 8;j++){
	                            cell = cellVisitor.getNextCell();
	                            fillDataCell(matrices, block[i][codewordIdx].charAt(j), cell.row, cell.column);
	                        }
	                    }

	                    codewordIdx++;
	                    while(block[0] && codewordIdx == block[0].length){
	                        block.splice(0,1);
	                    }
	                }
	            }

	            while((cell = cellVisitor.getNextRemainderCell())){
	                fillDataCell(matrices, 0, cell.row, cell.column);
	            }
	        };

	        var padDataString = function (dataString, totalDataCodewords){
	            var dataBitsCount = totalDataCodewords * 8,
	                terminatorIndex = 0,
	                paddingCodewordIndex = 0;
	            while(dataString.length < dataBitsCount && terminatorIndex < terminator.length){
	                dataString+=terminator.charAt(terminatorIndex++);
	            }

	            if(dataString.length % 8 !== 0){
	                dataString+= new Array(9 - dataString.length % 8).join("0");
	            }

	            while(dataString.length < dataBitsCount){
	                dataString+= paddingCodewords[paddingCodewordIndex];
	                paddingCodewordIndex ^= 1;
	            }
	            return dataString;
	        };

	        function generatePowersOfTwo(){
	            var result;
	            for(var power = 1; power < 255; power++){

	                result =  powersOfTwoResult[power - 1] * 2;
	                if(result > 255){
	                    result = result ^ 285;
	                }

	                powersOfTwoResult[power] = result;
	                powersOfTwo[result] = power;
	            }

	            result = (powersOfTwoResult[power - 1] * 2) ^ 285;
	            powersOfTwoResult[power] =   result;
	            powersOfTwoResult[-1] = 0;
	        }

	        var xorPolynomials = function (x,y){
	            var result = [],
	                idx = x.length - 2;
	            for(var i = idx; i>=0; i--){
	                 result[i] = x[i] ^ y[i];
	            }

	            return result;
	        };

	        var multiplyPolynomials = function (x, y){
	            var result = [];
	            for(var i = 0; i < x.length; i++){
	                for(var j = 0; j < y.length; j++){
	                    if(result[i+j] === undefined){
	                         result[i+j] = (x[i] + (y[j] >= 0 ? y[j] : 0)) % 255;
	                    }
	                    else{
	                       result[i+j] = powersOfTwo[powersOfTwoResult[result[i+j]] ^ powersOfTwoResult[(x[i] + y[j]) % 255]];
	                    }
	                }
	            }

	            return result;
	        };

	        function generateGeneratorPolynomials(){
	            var maxErrorCorrectionCodeWordsCount = 68;
	            for(var idx = 2; idx <= maxErrorCorrectionCodeWordsCount; idx++){
	                var firstPolynomial = generatorPolynomials[idx - 1],
	                    secondPolynomial = [idx, 0];
	                generatorPolynomials[idx] =  multiplyPolynomials(firstPolynomial, secondPolynomial);
	            }
	        }

	        //possibly generate on demand
	        generatePowersOfTwo();
	        generateGeneratorPolynomials();

	        function multiplyByConstant(polynomial, power){
	            var result = [],
	                idx = polynomial.length - 1;
	            do{
	                result[idx] = powersOfTwoResult[(polynomial[idx] + power) % 255];
	                idx--;
	            }while(polynomial[idx] !== undefined);

	            return result;
	        }

	        var generateErrorCodewords = function (data, errorCodewordsCount){
	            var generator = generatorPolynomials[errorCodewordsCount - 1],
	                result = new Array(errorCodewordsCount).concat(data),
	                generatorPolynomial = new Array(result.length - generator.length).concat(generator),
	                steps = data.length,
	                errorCodewords = [],
	                divisor,
	                idx;

	            for(idx = 0; idx < steps; idx++){
	                divisor = multiplyByConstant(generatorPolynomial, powersOfTwo[result[result.length - 1]]);
	                generatorPolynomial.splice(0,1);

	                result = xorPolynomials(divisor, result);
	            }

	            for(idx = result.length - 1; idx >= 0;idx--){
	                errorCodewords[errorCodewordsCount - 1 - idx] = toBitsString(result[idx], 8);
	            }

	            return errorCodewords;
	        };

	        var getBlocks = function (dataStream, versionCodewordsInformation){
	            var codewordStart = 0,
	                dataBlocks = [],
	                errorBlocks = [],
	                dataBlock,
	                versionGroups = versionCodewordsInformation.groups,
	                blockCodewordsCount,
	                groupBlocksCount,
	                messagePolynomial,
	                codeword;

	            for(var groupIdx = 0; groupIdx < versionGroups.length; groupIdx++){
	                groupBlocksCount = versionGroups[groupIdx][0];
	                for(var blockIdx = 0; blockIdx < groupBlocksCount;blockIdx++){
	                    blockCodewordsCount = versionGroups[groupIdx][1];
	                    dataBlock = [];
	                    messagePolynomial = [];
	                    for(var codewordIdx = 1; codewordIdx <= blockCodewordsCount; codewordIdx++){
	                        codeword = dataStream.substring(codewordStart, codewordStart + 8);
	                        dataBlock.push(codeword);
	                        messagePolynomial[blockCodewordsCount - codewordIdx] = toDecimal(codeword);
	                        codewordStart+=8;
	                    }
	                    dataBlocks.push(dataBlock);
	                    errorBlocks.push(generateErrorCodewords(messagePolynomial,
	                        versionCodewordsInformation.errorCodewordsPerBlock));
	                }
	            }
	            return [dataBlocks, errorBlocks];
	        };

	        var chooseMode = function (str, minNumericBeforeAlpha, minNumericBeforeByte, minAlphaBeforeByte, previousMode){
	             var numeric = numberRegex.exec(str),
	                numericMatch = numeric ? numeric[0] : "",
	                alpha = alphaRegex.exec(str),
	                alphaMatch = alpha ? alpha[0] : "",
	                alphaNumeric = alphaNumericRegex.exec(str),
	                alphaNumericMatch = alphaNumeric ? alphaNumeric[0] : "",
	                mode,
	                modeString;

	             if(numericMatch && (numericMatch.length >= minNumericBeforeAlpha ||
	                     str.length == numericMatch.length || (numericMatch.length >= minNumericBeforeByte &&
	                     !alphaNumericRegex.test(str.charAt(numericMatch.length))))){
	                mode = NUMERIC;
	                modeString = numericMatch;
	             }
	             else if(alphaNumericMatch && (str.length == alphaNumericMatch.length ||
	                alphaNumericMatch.length >= minAlphaBeforeByte || previousMode == ALPHA_NUMERIC)){
	                mode = ALPHA_NUMERIC;
	                modeString =  numericMatch || alphaMatch;
	             }
	             else {
	                mode = BYTE;
	                if(alphaNumericMatch){
	                    modeString = alphaNumericMatch + byteRegex.exec(str.substring(alphaNumericMatch.length))[0];
	                }
	                else{
	                    modeString = byteRegex.exec(str)[0];
	                }
	             }

	             return {
	                mode: mode,
	                modeString: modeString
	             };
	        };

	        var getModes = function (str){
	            var modes = [],
	                previousMode,
	                idx = 0;
	            modes.push(chooseMode(str, initMinNumericBeforeAlpha, initMinNumericBeforeByte, initMinAlphaBeforeByte, previousMode));
	            previousMode = modes[0].mode;
	            str = str.substr(modes[0].modeString.length);

	            while(str.length > 0){
	               var nextMode = chooseMode(str, minNumericBeforeAlpha, minNumericBeforeByte, minAlphaBeforeByte, previousMode);
	               if(nextMode.mode != previousMode){
	                    previousMode = nextMode.mode;
	                    modes.push(nextMode);
	                    idx++;
	               }
	               else{
	                    modes[idx].modeString += nextMode.modeString;
	               }
	               str = str.substr(nextMode.modeString.length);
	            }

	            return modes;
	        };

	        var getDataCodewordsCount = function (modes){
	            var length = 0,
	                mode;
	            for(var i = 0; i < modes.length; i++){
	                mode = modeInstances[modes[i].mode];
	                length+= mode.getStringBitsLength(modes[i].modeString.length);
	            }

	            return Math.ceil(length / 8);
	        };

	        var getVersion = function (dataCodewordsCount, errorCorrectionLevel){
	            var x = 0,
	                y = versionsCodewordsInformation.length - 1,
	                version = Math.floor(versionsCodewordsInformation.length / 2);

	            do{
	                if(dataCodewordsCount < versionsCodewordsInformation[version][errorCorrectionLevel].totalDataCodewords){
	                    y = version;
	                }
	                else{
	                    x = version;
	                }
	                version = x + Math.floor((y - x) / 2);

	            }while(y - x > 1);

	            if(dataCodewordsCount <= versionsCodewordsInformation[x][errorCorrectionLevel].totalDataCodewords){
	                return version + 1;
	            }
	            return y + 1;
	        };

	        var getDataString = function (modes, version){
	            var dataString = "",
	                mode;
	            for(var i = 0; i < modes.length; i++){
	                mode = modeInstances[modes[i].mode];
	                dataString+= mode.encode(modes[i].modeString, version);
	            }

	            return dataString;
	        };

	        //fix case all zeros
	        var encodeFormatInformation = function (format){
	            var formatNumber = toDecimal(format),
	                encodedString,
	                result = "";
	            if(formatNumber === 0){
	                return "101010000010010";
	            }
	            else{
	                encodedString = encodeBCH(toDecimal(format), formatGeneratorPolynomial, 15);
	            }
	            for(var i = 0; i < encodedString.length; i++){
	                result += encodedString.charAt(i) ^ formatMaskPattern.charAt(i);
	            }

	            return result;
	        };

	        var encodeBCH = function (value, generatorPolynomial, codeLength){
	            var generatorNumber = toDecimal(generatorPolynomial),
	                polynomialLength = generatorPolynomial.length - 1,
	                valueNumber = value << polynomialLength,
	                length = codeLength - polynomialLength,
	                valueString = toBitsString(value, length),
	                result = dividePolynomials(valueNumber, generatorNumber);
	            result = valueString + toBitsString(result, polynomialLength);
	            return result;
	        };

	        var dividePolynomials = function (numberX,numberY){
	                var yLength = numberY.toString(2).length,
	                    xLength = numberX.toString(2).length;
	                do{
	                    numberX ^= numberY << xLength - yLength;
	                    xLength = numberX.toString(2).length;
	                }
	                while(xLength >= yLength);

	                return numberX;
	        };

	        function getNumberAt(str, idx){
	            return parseInt(str.charAt(idx), 10);
	        }

	        var initMatrices = function (version){
	            var matrices = [],
	                modules =  17 + 4 * version;
	            for(var i = 0; i < maskPatternConditions.length; i++){
	                matrices[i] = new Array(modules);
	                for(var j = 0; j < modules; j++){
	                    matrices[i][j] = new Array(modules);
	                }
	            }

	            return matrices;
	        };

	        var addFormatInformation =function (matrices, formatString){
	            var matrix = matrices[0],
	                x,
	                y,
	                idx = 0,
	                length = formatString.length;

	            for(x=0, y=8; x <= 8;x++){
	                if(x!== 6){
	                    fillFunctionCell(matrices, getNumberAt(formatString, length - 1 - idx++), x, y);
	                }
	            }

	            for(x=8, y=7; y>=0;y--){
	                if(y!== 6){
	                    fillFunctionCell(matrices, getNumberAt(formatString, length - 1 - idx++), x, y);
	                }
	            }
	            idx=0;
	            for(y = matrix.length - 1, x = 8; y >= matrix.length - 8;y--){
	                fillFunctionCell(matrices,getNumberAt(formatString, length - 1 - idx++), x, y);
	            }

	            fillFunctionCell(matrices, 1, matrix.length - 8, 8);

	            for(x = matrix.length - 7, y = 8; x < matrix.length;x++){
	                fillFunctionCell(matrices, getNumberAt(formatString, length - 1 - idx++), x, y);
	            }
	        };

	        var encodeVersionInformation = function (version){
	            return encodeBCH(version, versionGeneratorPolynomial, 18);
	        };

	        var addVersionInformation = function (matrices, dataString){
	            var matrix = matrices[0],
	                modules = matrix.length,
	                x1 = 0,
	                y1 = modules - 11,
	                x2 = modules - 11,
	                y2 = 0,
	                quotient,
	                mod,
	                value;

	            for(var idx =0; idx < dataString.length; idx++){
	                quotient = Math.floor(idx / 3);
	                mod = idx % 3;
	                value = getNumberAt(dataString, dataString.length - idx - 1);
	                fillFunctionCell(matrices, value, x1 + quotient, y1 + mod);
	                fillFunctionCell(matrices, value, x2 + mod, y2 + quotient);
	            }
	        };

	        var addCentricPattern = function (matrices, pattern, x, y){
	            var size = pattern.length + 2,
	                length = pattern.length + 1,
	                value;

	            for(var i = 0; i < pattern.length; i++){
	                for(var j = i; j < size - i; j++){
	                    value = pattern[i];
	                    fillFunctionCell(matrices, value, x + j, y + i);
	                    fillFunctionCell(matrices, value, x + i, y + j);
	                    fillFunctionCell(matrices, value, x + length - j, y + length - i);
	                    fillFunctionCell(matrices, value, x + length - i, y + length - j);
	                }
	            }
	        };

	        var addFinderSeparator = function (matrices, direction, x, y){
	            var nextX = x,
	                nextY = y,
	                matrix = matrices[0];
	            do{
	                fillFunctionCell(matrices, 0, nextX, y);
	                fillFunctionCell(matrices, 0, x, nextY);
	                nextX+= direction[0];
	                nextY+= direction[1];
	            }
	            while(nextX >=0 && nextX < matrix.length);
	        };

	        var addFinderPatterns = function (matrices){
	            var modules = matrices[0].length;
	            addCentricPattern(matrices, finderPattern, 0, 0);
	            addFinderSeparator(matrices, [-1,-1], 7,7);
	            addCentricPattern(matrices, finderPattern, modules - 7, 0);
	            addFinderSeparator(matrices, [1,-1], modules - 8, 7);
	            addCentricPattern(matrices, finderPattern, 0 , modules - 7);
	            addFinderSeparator(matrices, [-1,1],7, modules - 8);
	        };

	        var addAlignmentPatterns = function (matrices, version){
	            if(version < 2) {
	                return;
	            }

	            var matrix = matrices[0],
	                modules = matrix.length,
	                pointsCount = Math.floor(version / 7),
	                points = [6],
	                startDistance,
	                distance,
	                idx = 0;

	            if((startDistance = irregularAlignmentPatternsStartDistance[version])){
	                distance = (modules - 13 - startDistance) / pointsCount;
	            }
	            else{
	                startDistance = distance = (modules - 13) / (pointsCount + 1);
	            }
	            points.push(points[idx++] + startDistance);
	            while((points[idx] + distance) < modules){
	                points.push(points[idx++] + distance);
	            }
	            for(var i = 0; i < points.length;i++){
	                for(var j = 0; j < points.length; j++){
	                    if(matrix[points[i]][points[j]] === undefined){
	                        addCentricPattern(matrices, alignmentPattern, points[i] - 2, points[j] - 2);
	                    }
	                }
	            }
	        };

	        var addTimingFunctions = function (matrices){
	            var row = 6,
	                column = 6,
	                value = 1,
	                modules = matrices[0].length;
	            for(var i = 8; i < modules - 8;i++){
	                fillFunctionCell(matrices, value, row, i);
	                fillFunctionCell(matrices, value, i, column);
	                value ^= 1;
	            }
	        };

	        var scoreMaskMatrixes = function (matrices){
	            var scores = [],
	                previousBits = [],
	                darkModules =  [],
	                patterns = [],
	                adjacentSameBits = [],
	                matrix,
	                i,
	                row = 0,
	                column = 1,
	                modules = matrices[0].length;


	            for(i = 0; i < matrices.length; i++){
	                scores[i] = 0;
	                darkModules[i] = 0;
	                adjacentSameBits[i] = [0,0];
	                patterns[i] = [0, 0];
	                previousBits[i] = [];
	            }
	            for(i = 0; i < modules; i++){
	                for(var j = 0; j < modules; j++){
	                    for(var k = 0; k < matrices.length; k++){
	                        matrix = matrices[k];
	                        darkModules[k]+= parseInt(matrix[i][j], 10);
	                        if(previousBits[k][row] === matrix[i][j] && i + 1 < modules && j - 1 >= 0 &&
	                            matrix[i + 1][j] == previousBits[k][row] && matrix[i + 1][j - 1] == previousBits[k][row]){
	                            scores[k]+=3;
	                        }
	                        scoreFinderPatternOccurance(k, patterns, scores, row, matrix[i][j]);
	                        scoreFinderPatternOccurance(k, patterns, scores, column, matrix[j][i]);
	                        scoreAdjacentSameBits(k,scores,previousBits,matrix[i][j],adjacentSameBits,row);
	                        scoreAdjacentSameBits(k,scores,previousBits,matrix[j][i],adjacentSameBits,column);
	                    }
	                }
	            }
	            var total = modules * modules,
	                minIdx,
	                min = Number.MAX_VALUE;

	            for(i = 0; i < scores.length; i++){
	                scores[i]+= calculateDarkModulesRatioScore(darkModules[i], total);
	                if(scores[i] < min){
	                    min = scores[i];
	                    minIdx = i;
	                }
	            }

	            return minIdx;
	        };

	        function scoreFinderPatternOccurance(idx, patterns, scores, rowColumn, bit){
	            patterns[idx][rowColumn] = ((patterns[idx][rowColumn] << 1) ^ bit) % 128;
	            if(patterns[idx][rowColumn] == finderPatternValue){
	                scores[idx] += 40;
	            }
	        }

	        function scoreAdjacentSameBits(idx, scores, previousBits, bit, adjacentBits, rowColumn){
	            if(previousBits[idx][rowColumn] == bit){
	                adjacentBits[idx][rowColumn]++;
	            }
	            else{
	                previousBits[idx][rowColumn] = bit;
	                if(adjacentBits[idx][rowColumn] >= 5){
	                    scores[idx]+= 3 + adjacentBits[idx][rowColumn] - 5;
	                }
	                adjacentBits[idx][rowColumn] = 1;
	            }
	        }

	        function calculateDarkModulesRatioScore(darkModules, total){
	            var percent = Math.floor((darkModules / total) * 100),
	                mod5 = percent % 5,
	                previous = Math.abs(percent - mod5 - 50),
	                next = Math.abs(percent +  5 - mod5 - 50),
	                score = 10 * Math.min(previous / 5, next / 5);
	            return score;
	        }

	        var EncodingResult = function(dataString, version){
	            this.dataString = dataString;
	            this.version = version;
	        };

	        var IsoEncoder = function(){
	            this.getEncodingResult = function(inputString, errorCorrectionLevel){
	                var modes = getModes(inputString),
	                dataCodewordsCount = getDataCodewordsCount(modes),
	                version = getVersion(dataCodewordsCount, errorCorrectionLevel),
	                dataString = getDataString(modes, version);

	                return new EncodingResult(dataString, version);
	            };
	        };

	        var UTF8Encoder = function(){
	            this.mode = modeInstances[this.encodingMode];
	        };

	        UTF8Encoder.fn = UTF8Encoder.prototype = {
	            encodingMode: BYTE,
	            utfBOM: "111011111011101110111111",
	            initialModeCountStringLength: 20,
	            getEncodingResult: function(inputString, errorCorrectionLevel){
	                var that = this,
	                    data = that.encode(inputString),
	                    dataCodewordsCount = that.getDataCodewordsCount(data),
	                    version = getVersion(dataCodewordsCount, errorCorrectionLevel),
	                    dataString = that.mode.getModeCountString(data.length / 8, version) + data;

	                return new EncodingResult(dataString, version);
	            },
	            getDataCodewordsCount: function(data){
	                var that = this,
	                    dataLength = data.length,
	                    dataCodewordsCount = Math.ceil(( that.initialModeCountStringLength + dataLength) / 8);

	                return dataCodewordsCount;
	            },
	            encode: function(str){
	                var that = this,
	                    result = that.utfBOM;
	                for(var i = 0; i < str.length; i++){
	                    result += that.encodeCharacter(str.charCodeAt(i));
	                }
	                return result;
	            },
	            encodeCharacter: function(code){
	                var bytesCount = this.getBytesCount(code),
	                    bc = bytesCount - 1,
	                    result = "";

	                if(bytesCount == 1){
	                    result = toBitsString(code, 8);
	                }
	                else{
	                    var significantOnes = 8 - bytesCount;

	                    for(var i = 0; i < bc; i++){
	                        result = toBitsString(code >> (i * 6) & 63 | 128, 8) + result;
	                    }

	                    result = ((code >> bc * 6) | ((255 >> significantOnes) << significantOnes)).toString(2) + result;
	                }
	                return result;
	            },
	            getBytesCount: function(code){
	                var ranges = this.ranges;
	                for(var i = 0; i < ranges.length;i++){
	                    if(code < ranges[i]){
	                        return i + 1;
	                    }
	                }
	            },
	            ranges: [128,2048,65536,2097152,67108864]
	        };

	        var QRCodeDataEncoder = function(encoding){
	            if(encoding && encoding.toLowerCase().indexOf("utf_8") >= 0){
	                return new UTF8Encoder();
	            }
	            else{
	                return new IsoEncoder();
	            }
	        };

	        var encodeData = function (inputString, errorCorrectionLevel, encoding){
	            var encoder = new QRCodeDataEncoder(encoding),
	                encodingResult = encoder.getEncodingResult(inputString, errorCorrectionLevel),
	                version = encodingResult.version,
	                versionInformation = versionsCodewordsInformation[version - 1][errorCorrectionLevel],
	                dataString = padDataString(encodingResult.dataString, versionInformation.totalDataCodewords),
	                blocks = getBlocks(dataString, versionInformation),
	                matrices = initMatrices(version);

	            addFinderPatterns(matrices);
	            addAlignmentPatterns(matrices, version);
	            addTimingFunctions(matrices);

	            if(version >= 7){
	                addVersionInformation(matrices, toBitsString(0, 18));
	            }

	            addFormatInformation(matrices, toBitsString(0, 15));
	            fillData(matrices, blocks);

	            var minIdx = scoreMaskMatrixes(matrices),
	                optimalMatrix = matrices[minIdx];

	            if(version >= 7){
	                addVersionInformation([optimalMatrix], encodeVersionInformation(version));
	            }

	            var formatString = errorCorrectionPatterns[errorCorrectionLevel] + toBitsString(minIdx, 3);
	            addFormatInformation([optimalMatrix], encodeFormatInformation(formatString));

	            return optimalMatrix;
	        };

	        var QRCodeDefaults= {
	            DEFAULT_SIZE: 200,
	            QUIET_ZONE_LENGTH: 4,
	            DEFAULT_ERROR_CORRECTION_LEVEL:"L",
	            DEFAULT_BACKGROUND: "#fff",
	            DEFAULT_DARK_MODULE_COLOR: "#000",
	            MIN_BASE_UNIT_SIZE: 1
	        };

	        var QRCode = Widget.extend({
	            init: function (element, options) {
	                var that = this;

	                Widget.fn.init.call(that, element, options);

	                that.element = $(element);
	                that.wrapper = that.element;
	                that.element.addClass("k-qrcode");
	                that.surfaceWrap = $("<div />").css("position", "relative").appendTo(this.element);
	                that.surface = draw.Surface.create(that.surfaceWrap, {
	                    type: that.options.renderAs
	                });
	                that.setOptions(options);
	            },

	            redraw: function(){
	                var size = this._getSize();

	                this.surfaceWrap.css({
	                    width: size,
	                    height: size
	                });
	                this.surface.clear();
	                this.surface.resize();

	                this.createVisual();
	                this.surface.draw(this.visual);
	            },

	            getSize: function() {
	                return kendo.dimensions(this.element);
	            },

	            _resize: function() {
	                this.redraw();
	            },

	            createVisual: function() {
	                this.visual = this._render();
	            },

	            exportVisual: function() {
	                return this._render();
	            },

	            _render: function() {
	                var that = this,
	                    value = that._value,
	                    baseUnit,
	                    border = that.options.border || {},
	                    padding = that.options.padding || 0,
	                    borderWidth = border.width || 0,
	                    quietZoneSize,
	                    matrix,
	                    size,
	                    dataSize,
	                    contentSize;

	                border.width = borderWidth;

	                var visual = new draw.Group();

	                if (value){
	                    matrix = encodeData(value, that.options.errorCorrection, that.options.encoding);
	                    size = that._getSize();
	                    contentSize = size - 2  * (borderWidth + padding);
	                    baseUnit = that._calculateBaseUnit(contentSize, matrix.length);
	                    dataSize = matrix.length * baseUnit;
	                    quietZoneSize = borderWidth + padding + (contentSize - dataSize) / 2;

	                    visual.append(that._renderBackground(size, border));
	                    visual.append(that._renderMatrix(matrix, baseUnit, quietZoneSize));
	                }

	                return visual;
	            },

	            _getSize: function(){
	                var that = this,
	                    size;

	                if (that.options.size){
	                   size = parseInt(that.options.size, 10);
	                } else {
	                    var element = that.element,
	                        min = Math.min(element.width(), element.height());

	                    if (min > 0){
	                        size = min;
	                    } else {
	                        size = QRCodeDefaults.DEFAULT_SIZE;
	                    }
	                }

	                return size;
	            },

	            _calculateBaseUnit: function(size, matrixSize){
	                var baseUnit = Math.floor(size/ matrixSize);

	                if(baseUnit < QRCodeDefaults.MIN_BASE_UNIT_SIZE){
	                    throw new Error("Insufficient size.");
	                }

	                if(baseUnit * matrixSize >= size &&
	                    baseUnit - 1 >= QRCodeDefaults.MIN_BASE_UNIT_SIZE){
	                    baseUnit--;
	                }

	                return baseUnit;
	            },

	            _renderMatrix: function(matrix, baseUnit, quietZoneSize){
	                var path = new draw.MultiPath({
	                    fill: {
	                        color: this.options.color
	                    },
	                    stroke: null
	                });

	                for (var row = 0; row < matrix.length; row++){
	                    var y = quietZoneSize + row * baseUnit;
	                    var column = 0;

	                    while (column < matrix.length){
	                        while (matrix[row][column] === 0 && column < matrix.length){
	                            column++;
	                        }

	                        if (column < matrix.length){
	                            var x = column;
	                            while (matrix[row][column] == 1){
	                                column++;
	                            }

	                            var x1 = round(quietZoneSize + x * baseUnit);
	                            var y1 = round(y);
	                            var x2 = round(quietZoneSize + column * baseUnit);
	                            var y2 = round(y + baseUnit);

	                            path.moveTo(x1, y1)
	                                .lineTo(x1, y2)
	                                .lineTo(x2, y2)
	                                .lineTo(x2, y1)
	                                .close();
	                        }
	                    }
	                }

	                return path;
	            },

	            _renderBackground: function (size, border) {
	                var box = new Box2D(0,0, size, size).unpad(border.width / 2);
	                return draw.Path.fromRect(box.toRect(), {
	                    fill: {
	                        color: this.options.background
	                    },
	                    stroke: {
	                        color: border.color,
	                        width: border.width
	                    }
	                });
	            },

	            setOptions: function (options) {
	                var that = this;
	                options = options || {};
	                that.options = extend(that.options, options);
	                if (options.value !== undefined) {
	                    that._value = that.options.value + "";
	                }
	                that.redraw();
	            },
	            value: function(value){
	                var that = this;
	                if (value === undefined) {
	                    return that._value;
	                }
	                that._value = value + "";
	                that.redraw();
	            },
	            options: {
	                name: "QRCode",
	                renderAs: "svg",
	                encoding: "ISO_8859_1",
	                value: "",
	                errorCorrection: QRCodeDefaults.DEFAULT_ERROR_CORRECTION_LEVEL,
	                background: QRCodeDefaults.DEFAULT_BACKGROUND,
	                color: QRCodeDefaults.DEFAULT_DARK_MODULE_COLOR,
	                size: "",
	                padding: 0,
	                border: {
	                    color: "",
	                    width: 0
	                }
	            }
	        });

	        dataviz.ExportMixin.extend(QRCode.fn);
	        dataviz.ui.plugin(QRCode);

	      kendo.deepExtend(dataviz, {
	            QRCode: QRCode,
	            QRCodeDefaults: QRCodeDefaults,
	            QRCodeFunctions: {
	                FreeCellVisitor: FreeCellVisitor,
	                fillData: fillData,
	                padDataString: padDataString,
	                generateErrorCodewords: generateErrorCodewords,
	                xorPolynomials: xorPolynomials,
	                getBlocks: getBlocks,
	                multiplyPolynomials: multiplyPolynomials,
	                chooseMode: chooseMode,
	                getModes: getModes,
	                getDataCodewordsCount: getDataCodewordsCount,
	                getVersion: getVersion,
	                getDataString: getDataString,
	                encodeFormatInformation: encodeFormatInformation,
	                encodeBCH: encodeBCH,
	                dividePolynomials: dividePolynomials,
	                initMatrices: initMatrices,
	                addFormatInformation: addFormatInformation,
	                encodeVersionInformation: encodeVersionInformation,
	                addVersionInformation: addVersionInformation,
	                addCentricPattern: addCentricPattern,
	                addFinderSeparator: addFinderSeparator,
	                addFinderPatterns: addFinderPatterns,
	                addAlignmentPatterns: addAlignmentPatterns,
	                addTimingFunctions: addTimingFunctions,
	                scoreMaskMatrixes: scoreMaskMatrixes,
	                encodeData: encodeData,
	                UTF8Encoder: UTF8Encoder
	            },
	            QRCodeFields: {
	                modes: modeInstances,
	                powersOfTwo: powersOfTwo,
	                powersOfTwoResult: powersOfTwoResult,
	                generatorPolynomials: generatorPolynomials
	            }
	      });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "KK9P":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1634);
	module.exports = __webpack_require__(1634);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1578:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("I2Wh");

/***/ }),

/***/ 1606:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7Ygf");

/***/ }),

/***/ 1634:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20), __webpack_require__(1578), __webpack_require__(1606), __webpack_require__(1635) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    // jshint latedef: nofunc
	    // jshint eqnull: true, laxbreak: true

	    var $ = kendo.jQuery;
	    var Formula = kendo.spreadsheet.calc.runtime.Formula;
	    var Ref = kendo.spreadsheet.Ref;
	    var CalcError = kendo.spreadsheet.CalcError;

	    kendo.spreadsheet.messages.workbook = {
	        defaultSheetName: "Sheet"
	    };

	    function loadBinary(url, callback) {
	        var xhr = new XMLHttpRequest();
	        xhr.onload = function() {
	            callback(xhr.response, xhr.getResponseHeader("Content-Type"));
	        };
	        xhr.onerror = function() {
	            callback(null);
	        };
	        xhr.open("GET", url);
	        xhr.responseType = "arraybuffer";
	        xhr.send();
	    }

	    var Workbook = kendo.Observable.extend({
	        options: {},

	        init: function(options, view) {
	            kendo.Observable.fn.init.call(this);

	            this.options = options;

	            this._view = view;
	            this._sheets = [];
	            this._images = {};
	            this._imgID = 0;

	            this._sheetsSearchCache = {};

	            this._sheet = this.insertSheet({
	                rows: this.options.rows,
	                columns: this.options.columns,
	                rowHeight: this.options.rowHeight,
	                columnWidth: this.options.columnWidth,
	                headerHeight: this.options.headerHeight,
	                headerWidth: this.options.headerWidth,
	                dataSource: this.options.dataSource
	            });

	            this.undoRedoStack = new kendo.util.UndoRedoStack();
	            this.undoRedoStack.bind(["undo", "redo"], this._onUndoRedo.bind(this));

	            this._context = new kendo.spreadsheet.FormulaContext(this);
	            this._validationContext = new kendo.spreadsheet.ValidationFormulaContext(this);
	            this._names = Object.create(null);

	            this.fromJSON(this.options);
	        },

	        clipboard: function() {
	            if(!this._clipboard) {
	                 this._clipboard = new kendo.spreadsheet.Clipboard(this);
	            }
	            return this._clipboard;
	        },

	        destroy: function() {
	            this.unbind();

	            if (this._clipboard) {
	                this._clipboard.destroy();
	            }
	        },

	        events: [
	            "cut",
	            "copy",
	            "paste",
	            "changing",
	            "change",
	            "excelImport",
	            "excelExport",
	            "insertSheet",
	            "removeSheet",
	            "selectSheet",
	            "renameSheet",
	            "insertRow",
	            "insertColumn",
	            "deleteRow",
	            "deleteColumn",
	            "hideRow",
	            "hideColumn",
	            "unhideRow",
	            "unhideColumn",
	            "select",
	            "changeFormat",
	            "dataBinding",
	            "dataBound"
	        ],

	        _sheetChanging: function(e) {
	            if (this.trigger("changing", e)) {
	                e.preventDefault();
	            }
	        },

	        _sheetChange: function(e) {
	            this.trigger("change", e);
	        },

	        _sheetInsertRow: function(e) {
	            if (this.trigger("insertRow", {
	                sheet: e.sender,
	                index: e.index
	            })) {
	                e.preventDefault();
	            }
	        },

	        _sheetInsertColumn: function(e) {
	            if (this.trigger("insertColumn", {
	                sheet: e.sender,
	                index: e.index
	            })) {
	                e.preventDefault();
	            }
	        },

	        _sheetDeleteRow: function(e) {
	            if (this.trigger("deleteRow", {
	                sheet: e.sender,
	                index: e.index
	            })) {
	                e.preventDefault();
	            }
	        },

	        _sheetDeleteColumn: function(e) {
	            if (this.trigger("deleteColumn", {
	                sheet: e.sender,
	                index: e.index
	            })) {
	                e.preventDefault();
	            }
	        },

	        _sheetHideRow: function(e) {
	            if (this.trigger("hideRow", {
	                sheet: e.sender,
	                index: e.index
	            })) {
	                e.preventDefault();
	            }
	        },

	        _sheetHideColumn: function(e) {
	            if (this.trigger("hideColumn", {
	                sheet: e.sender,
	                index: e.index
	            })) {
	                e.preventDefault();
	            }
	        },

	        _sheetUnhideRow: function(e) {
	            if (this.trigger("unhideRow", {
	                sheet: e.sender,
	                index: e.index
	            })) {
	                e.preventDefault();
	            }
	        },

	        _sheetUnhideColumn: function(e) {
	            if (this.trigger("unhideColumn", {
	                sheet: e.sender,
	                index: e.index
	            })) {
	                e.preventDefault();
	            }
	        },

	        _sheetSelect: function(e) {
	            this.trigger("select", e);
	        },

	        _sheetDataBinding: function(e) {
	            if (this.trigger("dataBinding", {
	                sheet: e.sender
	            })) {
	                e.preventDefault();
	            }
	        },

	        _sheetDataBound: function(e) {
	            this.trigger("dataBound", {
	                sheet: e.sender
	            });
	        },

	        _sheetCommandRequest: function(e) {
	            this.trigger("commandRequest", e);
	        },

	        _inputForRef: function(ref) {
	            var self = this;
	            return self._sheet.withCultureDecimals(function(){
	                return new kendo.spreadsheet.Range(ref, self._sheet).input();
	            });
	        },

	        _onUndoRedo: function(e) {
	            e.command.range().select();
	        },

	        execute: function(options) {
	            var commandOptions = $.extend({ workbook: this }, options.options);
	            var command = new kendo.spreadsheet[options.command](commandOptions);
	            var sheet = this.activeSheet();

	            if (commandOptions.origin) {
	                command.origin(commandOptions.origin);
	            }

	            if (commandOptions.operatingRange) {
	                command.range(commandOptions.operatingRange);
	            } else {
	                command.range(sheet.selection());
	            }

	            if (commandOptions.editRange) {
	                command._editRange = commandOptions.editRange;
	            }

	            var result = command.exec();

	            if (!result || result.reason !== "error") {
	                if (!command.cannotUndo) {
	                    this.undoRedoStack.push(command);
	                }
	            }

	            // when the undo/redo stack is truncated (by e.g. adding a
	            // non-redo command after undoing) it's possible to
	            // discard images from the dropped commands.
	            this.cleanupImages();

	            return result;
	        },

	        resetFormulas: function() {
	            this._sheets.forEach(function(sheet){
	                sheet.resetFormulas();
	            });
	        },

	        resetValidations: function() {
	            this._sheets.forEach(function(sheet){
	                sheet.resetValidations();
	            });
	        },

	        refresh: function(reason) {
	            if (reason.recalc) {
	                this.resetFormulas();
	                this.resetValidations();
	                this._sheet.recalc(this._context);
	                this._sheet.revalidate(this._validationContext);
	            }
	        },

	        activeSheet: function(sheet) {
	            if (sheet === undefined) {
	                return this._sheet;
	            }

	            if (!this.sheetByName(sheet.name())) {
	                return;
	            }

	            this._sheet = sheet;

	            //TODO: better way to get all reasons?
	            sheet.triggerChange(kendo.spreadsheet.ALL_REASONS);
	        },

	        moveSheetToIndex: function(sheet, toIndex) {
	            var fromIndex = this.sheetIndex(sheet);
	            var sheets = this._sheets;

	            if (fromIndex === -1) {
	                return;
	            }

	            this._sheetsSearchCache = {};

	            sheets.splice(toIndex, 0, sheets.splice(fromIndex, 1)[0]);

	            this.trigger("change", { sheetSelection: true });
	        },

	        insertSheet: function(options) {
	            options = options || {};
	            var that = this;
	            var insertIndex = typeof options.index === "number" ? options.index : that._sheets.length;
	            var sheetName;
	            var sheets = that._sheets;

	            var getUniqueSheetName = function(sheetNameSuffix) {
	                sheetNameSuffix = sheetNameSuffix ? sheetNameSuffix : 1;

	                var name = kendo.spreadsheet.messages.workbook.defaultSheetName + sheetNameSuffix;

	                if (!that.sheetByName(name)) {
	                    return name;
	                }

	                return getUniqueSheetName(sheetNameSuffix + 1);
	            };

	            if (options.name && that.sheetByName(options.name)) {
	                return;
	            }

	            this._sheetsSearchCache = {};

	            sheetName = options.name || getUniqueSheetName();

	            var sheet = new kendo.spreadsheet.Sheet(
	                options.rows || this.options.rows,
	                options.columns || this.options.columns,
	                options.rowHeight || this.options.rowHeight,
	                options.columnWidth || this.options.columnWidth,
	                options.headerHeight || this.options.headerHeight,
	                options.headerWidth || this.options.headerWidth,
	                options.defaultCellStyle || this.options.defaultCellStyle
	            );

	            sheet._workbook = this;

	            sheet._name(sheetName);

	            this._bindSheetEvents(sheet);

	            sheets.splice(insertIndex, 0, sheet);

	            if (options.data) {
	                sheet.fromJSON(options.data);
	            }

	            if (options.dataSource) {
	                sheet.setDataSource(options.dataSource);
	            }

	            this.trigger("change", { sheetSelection: true });

	            return sheet;
	        },

	        _bindSheetEvents: function(sheet) {
	            sheet.bind("changing", this._sheetChanging.bind(this));
	            sheet.bind("change", this._sheetChange.bind(this));
	            sheet.bind("insertRow", this._sheetInsertRow.bind(this));
	            sheet.bind("insertColumn", this._sheetInsertColumn.bind(this));
	            sheet.bind("deleteRow", this._sheetDeleteRow.bind(this));
	            sheet.bind("deleteColumn", this._sheetDeleteColumn.bind(this));
	            sheet.bind("hideRow", this._sheetHideRow.bind(this));
	            sheet.bind("hideColumn", this._sheetHideColumn.bind(this));
	            sheet.bind("unhideRow", this._sheetUnhideRow.bind(this));
	            sheet.bind("unhideColumn", this._sheetUnhideColumn.bind(this));
	            sheet.bind("select", this._sheetSelect.bind(this));
	            sheet.bind("commandRequest", this._sheetCommandRequest.bind(this));
	            sheet.bind("dataBinding", this._sheetDataBinding.bind(this));
	            sheet.bind("dataBound", this._sheetDataBound.bind(this));
	        },

	        sheets: function() {
	            return this._sheets.slice();
	        },

	        sheetByName: function (sheetName) {
	            return this._sheets[this.sheetIndex(sheetName)];
	        },

	        sheetByIndex: function(index) {
	            return this._sheets[index];
	        },

	        sheetIndex: function(sheet) {
	            var sheets = this._sheets;
	            var sheetName = (typeof sheet == "string" ? sheet : sheet.name()).toLowerCase();
	            var idx = this._sheetsSearchCache[sheetName];

	            if (idx >= 0) {
	                return idx;
	            }

	            for(idx = 0; idx < sheets.length; idx++) {
	                var name = sheets[idx].name().toLowerCase();
	                this._sheetsSearchCache[name] = idx;

	                if (name === sheetName) {
	                    return idx;
	                }
	            }

	            return -1;
	        },

	        renameSheet: function(sheet, newSheetName) {
	            var oldSheetName = sheet.name().toLowerCase();

	            if (!newSheetName ||
	                oldSheetName === newSheetName.toLowerCase() ||
	                this.sheetByName(newSheetName)) {
	                return;
	            }

	            sheet = this.sheetByName(oldSheetName);

	            if (!sheet) {
	                return;
	            }

	            this._sheetsSearchCache = {};

	            if (this.trigger("renameSheet", {
	                sheet: sheet,
	                newSheetName: newSheetName
	            })) {
	                return;
	            }

	            // update references
	            this._sheets.forEach(function(sheet){
	                sheet._forFormulas(function(formula){
	                    formula.renameSheet(oldSheetName, newSheetName);
	                });
	            });

	            this.forEachName(function(def, name){
	                // 1. redefine sheet-local names
	                if (def.nameref.renameSheet(oldSheetName, newSheetName)) {
	                    this.undefineName(name);
	                    def.name = def.nameref.print();
	                    this.nameDefinition(def.name, def);
	                }
	                // 2. if the value is reference or formula, update it
	                if (def.value instanceof Ref || def.value instanceof Formula) {
	                    def.value.renameSheet(oldSheetName, newSheetName);
	                }
	            }.bind(this));

	            sheet._name(newSheetName);

	            this.trigger("change", { sheetSelection: true });

	            return sheet;
	        },

	        removeSheet: function(sheet) {
	            var that = this;
	            var sheets = that._sheets;
	            var name = sheet.name();
	            var index = that.sheetIndex(sheet);

	            if (sheets.length === 1) {
	                return;
	            }

	            if (this.trigger("removeSheet", { sheet: sheet })) {
	                return;
	            }

	            this._sheetsSearchCache = {};

	            if (index > -1) {
	                sheet.unbind();

	                sheets.splice(index, 1);

	                if (that.activeSheet().name() === name) {
	                    var newSheet = sheets[index === sheets.length ? index-1 : index];
	                    that.activeSheet(newSheet);
	                } else {
	                    this.trigger("change", { recalc: true,  sheetSelection: true });
	                }
	            }
	        },

	        _clearSheets: function() {
	            for (var i = 0; i < this._sheets.length; i++) {
	                this._sheets[i]._activeDrawing = [];
	                this._sheets[i]._drawings = [];
	                this._sheets[i].unbind();
	            }
	            this._sheets = [];
	            this._sheetsSearchCache = {};
	            this._names = {};
	            this._images = {};
	            this._imgID = 0;
	        },

	        // _loadImages: function() {
	        //     var self = this;
	        //     var ids = Object.keys(self._images);
	        //     var count = ids.length;
	        //     if (count) {
	        //         ids.forEach(function(id){
	        //             var img = self._images[id];
	        //             if (!img.blob) {
	        //                 loadBinary(img.url, function(data, type) {
	        //                     // XXX: can we do something better in case of error?
	        //                     if (data != null) {
	        //                         img.blob = new Blob([ data ], { type: type });
	        //                         delete img.url;
	        //                     }
	        //                     next();
	        //                 });
	        //             }
	        //         });
	        //     } else {
	        //         next();
	        //     }
	        //     function next() {
	        //         if (--count <= 0) {
	        //             self.activeSheet().triggerChange({ layout: true });
	        //         }
	        //     }
	        // },

	        fromJSON: function(json) {
	            if (json.sheets) {
	                this._clearSheets();

	                if (json.images) {
	                    this._imgID = 0;
	                    this._images = {};
	                    Object.keys(json.images).forEach(function(id){
	                        if (!isNaN(id)) {
	                            var num = parseFloat(id);
	                            if (isFinite(num)) {
	                                this._imgID = Math.max(this._imgID, num);
	                            }
	                        }
	                        this._images[id] = { url: json.images[id] };
	                    }, this);
	                    // this._loadImages();
	                }

	                for (var idx = 0; idx < json.sheets.length; idx++) {
	                    var data = json.sheets[idx];
	                    var args = sheetParamsFromJSON(data, this.options);
	                    var sheet = this.insertSheet({
	                        rows         : args.rowCount,
	                        columns      : args.columnCount,
	                        rowHeight    : args.rowHeight,
	                        columnWidth  : args.columnWidth,
	                        headerHeight : args.headerHeight,
	                        headerWidth  : args.headerWidth,
	                        data         : data
	                    });

	                    if (data.dataSource) {
	                        sheet.setDataSource(data.dataSource);
	                    }
	                }
	            }

	            if (json.activeSheet) {
	                this.activeSheet(this.sheetByName(json.activeSheet));
	            } else {
	                this.activeSheet(this._sheets[0]);
	            }

	            if (json.names) {
	                json.names.forEach(function(def){
	                    this.defineName(def.name, def.value, def.hidden);
	                }, this);
	            }
	        },

	        toJSON: function() {
	            this.resetFormulas();
	            this.resetValidations();
	            var names = Object.keys(this._names).map(function(name){
	                var def = this._names[name];
	                var val = def.value;
	                if (val instanceof Ref || val instanceof Formula) {
	                    val = val.print(0, 0, true);
	                } else if (val instanceof CalcError) {
	                    val = val + "";
	                } else {
	                    val = JSON.stringify(val);
	                }
	                return {
	                    value     : val,
	                    hidden    : def.hidden,
	                    name      : def.name,

	                    // these two are not really useful in
	                    // deserialization, but are handy in OOXML export.
	                    sheet     : def.nameref.sheet,
	                    localName : def.nameref.name
	                };
	            }, this);
	            return {
	                activeSheet: this.activeSheet().name(),
	                sheets: this._sheets.map(function(sheet) {
	                    sheet.recalc(this._context);
	                    sheet.revalidate(this._validationContext);
	                    return sheet.toJSON();
	                }, this),
	                names: names,
	                columnWidth: this.options.columnWidth,
	                rowHeight: this.options.rowHeight
	            };
	        },

	        saveJSON: function() {
	            var self = this;
	            var deferred = new $.Deferred();
	            var data = self.toJSON();
	            var ids = Object.keys(self._images).filter(function(id){
	                return self.usesImage(id) === 1;
	            });
	            var count = ids.length;
	            data.images = {};
	            if (count) {
	                ids.forEach(function(id){
	                    var img = self._images[id];
	                    if (img.blob) {
	                        var reader = new FileReader();
	                        reader.onload = function() {
	                            data.images[id] = reader.result;
	                            next();
	                        };
	                        reader.readAsDataURL(img.blob);
	                    } else {
	                        data.images[id] = img.url;
	                        next();
	                    }
	                });
	            } else {
	                next();
	            }
	            return deferred.promise();

	            function next() {
	                if (--count <= 0) {
	                    deferred.resolve(data);
	                }
	            }
	        },

	        fromFile: function(file) {
	            var deferred = new $.Deferred();
	            var promise = deferred.promise();
	            var args = { file: file, promise: promise };

	            if (file && !this.trigger("excelImport", args)) {
	                this._clearSheets();
	                kendo.spreadsheet.readExcel(file, this, deferred);
	            } else {
	                deferred.reject();
	            }

	            return promise;
	        },

	        saveAsExcel: function(options) {
	            var self = this;
	            options = $.extend({}, self.options.excel, options);
	            var data = self.toJSON();

	            if (self.trigger("excelExport", { workbook: data })) {
	                return;
	            }

	            var ids = Object.keys(self._images).filter(function(id){
	                return self.usesImage(id) === 1;
	            });
	            var count = ids.length;
	            var images = count ? {} : null;
	            if (count) {
	                ids.forEach(function(id){
	                    var img = self._images[id];
	                    if (img.blob) {
	                        var reader = new FileReader();
	                        reader.onload = function() {
	                            images[id] = {
	                                type: img.blob.type,
	                                name: img.blob.name,
	                                data: reader.result
	                            };
	                            next();
	                        };
	                        reader.readAsArrayBuffer(img.blob);
	                    } else {
	                        loadBinary(img.url, function(data, type){
	                            images[id] = { type: type, data: data };
	                            next();
	                        });
	                    }
	                });
	            } else {
	                next();
	            }

	            function next() {
	                if (--count <= 0) {
	                    data.images = images;
	                    var workbook = new kendo.ooxml.Workbook(data);
	                    kendo.saveAs({
	                        dataURI: options.forceProxy ? workbook.toDataURL() : workbook.toBlob(),
	                        fileName: data.fileName || options.fileName,
	                        proxyURL: options.proxyURL,
	                        forceProxy: options.forceProxy
	                    });
	                }
	            }
	        },

	        draw: function(options, callback) {
	            if (typeof options == "function" && !callback) {
	                callback = options;
	                options = {};
	            }
	            var parts = [], sheets = this._sheets;
	            (function loop(i){
	                if (i < sheets.length) {
	                    sheets[i].draw(kendo.spreadsheet.SHEETREF, options, function(group){
	                        parts.push(group);
	                        loop(i + 1);
	                    });
	                } else {
	                    var group = parts[0];
	                    for (i = 1; i < parts.length; ++i) {
	                        group.children = group.children.concat(parts[i].children);
	                    }
	                    callback(group);
	                }
	            })(0);
	        },

	        nameForRef: function(ref, sheet) {
	            if (sheet === undefined) {
	                sheet = ref.sheet;
	            }
	            sheet = sheet.toLowerCase();
	            var str = ref + "";
	            for (var name in this._names) {
	                var def = this._names[name];
	                var val = def.value;
	                if (val instanceof Ref) {
	                    if (!val.sheet || (val.sheet && sheet == val.sheet.toLowerCase())) {
	                        if (val + "" == str) {
	                            return def;
	                        }
	                    }
	                }
	            }
	            return { name: str };
	        },

	        defineName: function(name, value, hidden) {
	            var x = kendo.spreadsheet.calc.parseNameDefinition(name, value);
	            name = x.name.print();
	            this._names[name.toLowerCase()] = {
	                value   : x.value,
	                hidden  : hidden,
	                name    : name,
	                nameref : x.name
	            };
	        },

	        undefineName: function(name) {
	            delete this._names[name.toLowerCase()];
	        },

	        nameValue: function(name) {
	            name = name.toLowerCase();
	            if (name in this._names) {
	                return this._names[name].value;
	            }
	            return null;
	        },

	        nameDefinition: function(name, def) {
	            name = name.toLowerCase();
	            if (arguments.length > 1) {
	                if (def === undefined) {
	                    delete this._names[name];
	                } else {
	                    this._names[name] = def;
	                }
	            }
	            return this._names[name];
	        },

	        forEachName: function(func) {
	            Object.keys(this._names).forEach(function(name){
	                func(this._names[name], name);
	            }, this);
	        },

	        adjustNames: function(affectedSheet, forRow, start, delta) {
	            affectedSheet = affectedSheet.toLowerCase();
	            Object.keys(this._names).forEach(function(name){
	                var def = this._names[name];
	                var x = def.value;
	                if (x instanceof Ref &&
	                    x.sheet.toLowerCase() == affectedSheet) {
	                    def.value = x.adjust(null, null, null, null, forRow, start, delta);
	                }
	                else if (x instanceof Formula) {
	                    x.adjust(affectedSheet, forRow ? "row" : "col", start, delta);
	                }
	            }, this);
	        },

	        addImage: function(image) {
	            var id = String(++this._imgID);
	            if (typeof image == "string") {
	                this._images[id] = { url: image };
	            } else {
	                this._images[id] = { blob: image };
	            }
	            return id;
	        },

	        imageUrl: function(id) {
	            var img = this._images[id];
	            var url = img.url;
	            if (!url) {
	                url = img.url = window.URL.createObjectURL(img.blob);
	            }
	            return url;
	        },

	        cleanupImages: function() {
	            Object.keys(this._images).forEach(function(id){
	                if (!this.usesImage(id)) {
	                    var url = this._images[id].url;
	                    if (url) {
	                        window.URL.revokeObjectURL(url);
	                    }
	                    delete this._images[id];
	                }
	            }, this);
	        },

	        usesImage: function(img) {
	            var i;
	            var sheets = this._sheets;
	            for (i = sheets.length; --i >= 0;) {
	                if (sheets[i].usesImage(img)) {
	                    return 1;
	                }
	            }
	            var stack = this.undoRedoStack.stack;
	            for (i = stack.length; --i >= 0;) {
	                if (stack[i].usesImage(img)) {
	                    return 2; // signal that it's only in the undo stack
	                }
	            }
	            return false;
	        }

	    });

	    function sheetParamsFromJSON(data, options) {
	        function or(a, b, c) {
	            return a !== undefined ? a : b !== undefined ? b : c;
	        }

	        var rowCount     = or(data.rowCount, options.rows, 200),
	            columnCount  = or(data.columnCount, options.columns, 50),
	            rowHeight    = or(data.rowHeight, options.rowHeight, 20),
	            columnWidth  = or(data.columnWidth, options.columnWidth, 64),
	            headerHeight = or(data.headerHeight, options.headerHeight, 20),
	            headerWidth  = or(data.headerWidth, options.headerWidth, 32);

	        if (data.rows !== undefined) {
	            for (var i = 0; i < data.rows.length; ++i) {
	                var row = data.rows[i];
	                var ri = or(row.index, i);
	                if (ri >= rowCount) { rowCount = ri + 1; }
	                if (row.cells) {
	                    for (var j = 0; j < row.cells.length; ++j) {
	                        var cell = row.cells[j];
	                        var ci = or(cell.index, j);
	                        if (ci >= columnCount) { columnCount = ci + 1; }
	                    }
	                }
	            }
	        }

	        return {
	            rowCount     : rowCount,
	            columnCount  : columnCount,
	            rowHeight    : rowHeight,
	            columnWidth  : columnWidth,
	            headerHeight : headerHeight,
	            headerWidth  : headerWidth
	        };
	    }

	    kendo.spreadsheet.Workbook = Workbook;
	    if (kendo.PDFMixin) {
	        kendo.PDFMixin.extend(Workbook.prototype);

	        Workbook.prototype.saveAsPDF = function(options) {
	            var progress = new $.Deferred();
	            var promise = progress.promise();
	            var args = { promise: promise };
	            if (this.trigger("pdfExport", args)) {
	                return;
	            }

	            this._drawPDF(options, progress)
	            .then(function(root) {
	                return options.forceProxy
	                    ? kendo.pdf.exportPDF(root) // produce data URI for proxy
	                    : kendo.pdf.exportPDFToBlob(root);
	            })
	            .done(function(dataURI) {
	                kendo.saveAs({
	                    dataURI: dataURI,
	                    fileName: options.fileName,
	                    proxyURL: options.proxyURL,
	                    forceProxy: options.forceProxy,
	                    proxyTarget: options.proxyTarget
	                });

	                progress.resolve();
	            })
	            .fail(function(err) {
	                progress.reject(err);
	            });

	            return promise;
	        };

	        Workbook.prototype._drawPDF = function(options) {
	            var result = new $.Deferred();
	            var callback = function(group) {
	                result.resolve(group);
	            };
	            switch(options.area) {
	            case "workbook":
	                options.workbook.draw(options, callback);
	                break;
	            case "sheet":
	                options.workbook.activeSheet().draw(options, callback);
	                break;
	            case "selection":
	                options.workbook.activeSheet().selection().draw(options, callback);
	                break;
	            }

	            return result.promise();
	        };
	    }
	})(kendo);

	}, __webpack_require__(3));


/***/ }),

/***/ 1635:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nky/");

/***/ })

/******/ });

/***/ }),

/***/ "KVbc":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1618);
	module.exports = __webpack_require__(1618);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1618:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var RangeTreeNode = kendo.Class.extend({
	        init: function Node(level, value, left, right) {
	            this.level = level;
	            this.value = value;
	            this.left = left;
	            this.right = right;
	        }
	    });

	    var NilNode = new (function NIL() { // jshint ignore:line
	        this.left = this;
	        this.right = this;
	        this.level = 0;
	    })();

	    function skew(node) {
	        if (node.left.level === node.level) {
	            var temp = node;
	            node = node.left;
	            temp.left = node.right;
	            node.right = temp;
	        }

	        return node;
	    }

	    function split(node) {
	        if (node.right.right.level === node.level) {
	            var temp = node;
	            node = node.right;
	            temp.right = node.left;
	            node.left = temp;
	            node.level += 1;
	        }

	        return node;
	    }

	    function insert(node, value) {
	        if (node === NilNode) {
	            return new RangeTreeNode(1, value, NilNode, NilNode);
	        } else if (node.value.start > value.start) {
	            node.left = insert(node.left, value);
	        } else {
	            node.right = insert(node.right, value);
	        }

	        return split(skew(node));
	    }

	    function remove(node, value) {
	        if (node === NilNode) {
	            return node;
	        }

	        var diff = node.value.start - value.start;
	        if (diff === 0) {
	            if (node.left !== NilNode && node.right !== NilNode) {
	                var heir = node.left;

	                while (heir.right !== NilNode) {
	                    heir = heir.right;
	                }

	                node.value = heir.value;
	                node.left = remove(node.left, node.value);
	            } else if (node.left === NilNode) {
	                node = node.right;
	            } else {
	                node = node.left;
	            }
	        } else if (diff > 0) {
	            node.left = remove(node.left, value);
	        } else {
	            node.right = remove(node.right, value);
	        }

	        if (node.left.level < (node.level - 1) || node.right.level < (node.level - 1)) {
	            node.level -= 1;
	            if (node.right.level > node.level) {
	                node.right.level = node.level;
	            }

	            node = skew(node);
	            node.right = skew(node.right);
	            node.right.right = skew(node.right.right);
	            node = split(node);
	            node.right = split(node.right);
	        }

	        return node;
	    }

	    var Range = kendo.Class.extend({
	        init: function ValueRange(start, end, value) {
	            this.start = start;
	            this.end = end;
	            this.value = value;
	        },

	        intersects: function(range) {
	            return range.start <= this.end && range.end >= this.start;
	        },

	        clone: function() {
	            return new Range(this.start, this.end, this.value);
	        }
	    });

	    var RangeTree = kendo.Class.extend({
	        init: function() {
	            this.root = NilNode;
	        },

	        insert: function(value) {
	            this.root = insert(this.root, value);
	        },

	        remove: function(value) {
	            this.root = remove(this.root, value);
	        },

	        findrange: function(value) {
	            var node = this.root;

	            while (node != NilNode) {
	                if (value < node.value.start) {
	                    node = node.left;
	                } else if (value > node.value.end) {
	                    node = node.right;
	                } else {
	                    return node.value;
	                }
	            }

	            return null;
	        },

	        values: function() {
	            var result = [];
	            values(this.root, result);
	            return result;
	        },

	        intersecting: function(start, end) {
	            var ranges = [];
	            intersecting(this.root, new Range(start, end), ranges);
	            return ranges;
	        },

	        map: function(callback) {
	            var tree = new RangeTree();
	            map(tree, this.root, callback);
	            return tree;
	        },

	        clone: function() {
	            return this.map(function(value) {
	                return value.clone();
	            });
	        },

	        first: function() {
	            var first = this.root;
	            while(first.left != NilNode) {
	                first = first.left;
	            }

	            return first;
	        },

	        last: function() {
	            var last = this.root;
	            while(last.right != NilNode) {
	                last = last.right;
	            }

	            return last;
	        }
	    });

	    function values(node, result) {
	        if (node === NilNode) {
	            return;
	        }

	        values(node.left, result);
	        result.push(node.value);
	        values(node.right, result);
	    }

	    function intersecting(node, range, ranges) {
	        if (node === NilNode) {
	            return;
	        }

	        var value = node.value;

	        if (range.start < value.start) {
	            intersecting(node.left, range, ranges);
	        }

	        if (value.intersects(range)) {
	            ranges.push(value);
	        }

	        if (range.end > value.end) {
	            intersecting(node.right, range, ranges);
	        }
	    }

	    function map(tree, root, callback) {
	        if (root === NilNode) {
	            return;
	        }

	        map(tree, root.left, callback);
	        tree.insert(callback(root.value));
	        map(tree, root.right, callback);
	    }

	    var RangeList = kendo.Class.extend({
	        init: function(start, end, value) {
	            if (end === undefined) {
	                this.tree = start;
	            } else {
	                this.tree = new RangeTree();
	                this.tree.insert(new Range(start, end, value));
	            }
	        },

	        values: function() {
	            return this.tree.values();
	        },

	        map: function(callback) {
	            return new RangeList(this.tree.map(callback));
	        },

	        intersecting: function(start, end) {
	            return this.tree.intersecting(start, end);
	        },

	        first: function() {
	            return this.tree.first().value;
	        },

	        last: function() {
	            return this.tree.last().value;
	        },

	        insert: function(start, end, value) {
	            return this.tree.insert(new Range(start, end, value));
	        },

	        value: function(start, end, value) {
	            if (value === undefined) {
	                if (end === undefined) {
	                    end = start;
	                }
	                return this.intersecting(start, end)[0].value;
	            }

	            var ranges = this.tree.intersecting(start - 1, end + 1);

	            if (ranges.length) {
	                var firstRange = ranges[0], lastRange = ranges[ranges.length - 1];

	                if (firstRange.end < start) {
	                    if (firstRange.value === value) {
	                        start = firstRange.start;
	                    } else {
	                        ranges.shift();
	                    }
	                }

	                if (lastRange.start > end) {
	                    if (lastRange.value === value) {
	                        end = lastRange.end;
	                    } else {
	                        ranges.pop();
	                    }
	                }

	                for (var i = 0, length = ranges.length; i < length; i++) {
	                    var range = ranges[i];
	                    var rangeValue = range.value;
	                    var rangeStart = range.start;
	                    var rangeEnd = range.end;

	                    this.tree.remove(range);

	                    if (rangeStart < start) {
	                        if (rangeValue !== value) {
	                            this.insert(rangeStart, start - 1, rangeValue);
	                        } else {
	                            start = rangeStart;
	                        }
	                    }

	                    if (rangeEnd > end) {
	                        if (rangeValue !== value) {
	                            this.insert(end + 1, rangeEnd, rangeValue);
	                        } else {
	                            end = rangeEnd;
	                        }
	                    }
	                }
	            }

	            this.insert(start, end, value);
	        },

	        expandedValues: function(start, end) {
	            var ranges = this.intersecting(start, end);
	            var result = [];

	            var rangeIndex = 0;

	            for (var i = start; i <= end; i++) {
	                if (ranges[rangeIndex].end < i) {
	                    rangeIndex ++;
	                }

	                result.push({ index: i - start, value: ranges[rangeIndex].value });
	            }

	            return result;
	        },

	        sortedIndices: function(start, end, valueComparer, indices) {
	            var result = this.expandedValues(start, end);

	            var comparer = function(a, b) {
	                if (a.value === b.value) {
	                    return a.index - b.index;
	                }

	                return valueComparer(a.value, b.value);
	            };

	            if (indices) {
	                comparer = function(a, b) {
	                    var x = indices[a.index];
	                    var y = indices[b.index];

	                    if (x.value === y.value) {
	                        return valueComparer(a.value, b.value);
	                    }

	                    return a.index - b.index;
	                };
	            }

	            result.sort(comparer);

	            return result;
	        },

	        sort: function(start, end, indices) {
	            if (this.intersecting(start, end).length === 1) {
	                return;
	            }

	            var values = this.expandedValues(start, end);

	            for (var i = 0, len = indices.length; i < len; i++) {
	                this.value(i + start, i + start, values[indices[i].index].value);
	            }
	        },

	        copy: function(sourceStart, sourceEnd, targetStart) {
	            var values = this.intersecting(sourceStart, sourceEnd);

	            var start = targetStart;
	            var end;

	            for (var i = 0, len = values.length; i < len; i++) {
	                var rangeStart = values[i].start;

	                if (rangeStart < sourceStart) {
	                    rangeStart = sourceStart;
	                }

	                var rangeEnd = values[i].end;

	                if (rangeEnd > sourceEnd) {
	                    rangeEnd = sourceEnd;
	                }

	                end = start + (rangeEnd - rangeStart);

	                this.value(start, end, values[i].value);

	                start = ++end;
	            }
	        },

	        iterator: function(start, end) {
	            return new Iterator(start, end, this.intersecting(start, end));
	        },

	        getState: function() {
	            return this.tree.clone();
	        },

	        setState: function(state) {
	            this.tree = state.clone();
	        },

	        toJSON: function() {
	            return this.values();
	        },

	        fromJSON: function(values) {
	            values.forEach(function(v){
	                this.value(v.start, v.end, v.value);
	            }, this);
	        }
	    });

	    var Iterator = kendo.Class.extend({
	        init: function(start, end, ranges) {
	            this.start = start;
	            this.end = end;
	            this.index = 0;
	            this.ranges = ranges;
	        },

	        unique: function() {
	            return this.ranges.map(function(range) {
	                return range.value;
	            });
	        },

	        at: function(index) {
	            while (this.ranges[this.index] && this.ranges[this.index].end < index) {
	                this.index ++;
	            }

	            return this.ranges[this.index] && this.ranges[this.index].value;
	        },

	        forEach: function(callback) {
	            for (var i = this.start; i <= this.end; i++) {
	                callback(this.at(i), i);
	            }

	            this.index = 0;
	        }
	    });

	    var SparseRangeList = RangeList.extend({
	        init: function(start, end, value) {
	            this.tree = new RangeTree();
	            this.range = new Range(start, end, value);
	        },

	        intersecting: function(start, end) {
	            var ranges = this.tree.intersecting(start, end);
	            var result = [];
	            var range;

	            if (!ranges.length) {
	                return [this.range];
	            }

	            for (var i = 0, len = ranges.length; i < len; i++) {
	                range = ranges[i];
	                if (range.start > start) {
	                    result.push(new Range(start, range.start - 1, this.range.value));
	                }

	                result.push(range);
	                start = range.end + 1;
	            }

	            if (range.end < end) {
	                result.push(new Range(range.end + 1, end, this.range.value));
	            }

	            return result;
	        },

	        insert: function(start, end, value) {
	            if (value !== this.range.value) {
	                this.tree.insert(new Range(start, end, value));
	            }
	        },

	        lastRangeStart: function() {
	            var node = this.tree.root;

	            if (node === NilNode) {
	                return this.range.start;
	            }

	            while(node.right !== NilNode) {
	                node = node.right;
	            }

	            return node.value.end + 1;
	        }
	    });


	    kendo.spreadsheet.RangeTree = RangeTree;
	    kendo.spreadsheet.RangeList = RangeList;
	    kendo.spreadsheet.SparseRangeList = SparseRangeList;
	    kendo.spreadsheet.ValueRange = Range;
	})(kendo);
	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "KYVy":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1168);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1168:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1169),  __webpack_require__(1170)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "daterangepicker",
	    name: "DateRangePicker",
	    category: "web",
	    description: "Date range picker.",
	    depends: [ "core", "multiviewcalendar", "datepicker"]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        keys = kendo.keys,
	        Widget = ui.Widget,
	        MONTH = "month",
	        OPEN = "open",
	        CLOSE = "close",
	        CHANGE = "change",
	        DIV = "<div />",
	        MIN = "min",
	        MAX = "max",
	        template = kendo.template,
	        extend = $.extend,
	        ID = "id",
	        support = kendo.support,
	        mobileOS = support.mobileOS,
	        SELECTED = "k-state-selected",
	        ARIA_EXPANDED = "aria-expanded",
	        ARIA_DISABLED = "aria-disabled",
	        STATEDISABLED = "k-state-disabled",
	        DISABLED = "disabled",
	        READONLY = "readonly",
	        DEFAULT = "k-state-default",
	        ARIA_HIDDEN = "aria-hidden",
	        ns = ".kendoDateRangePicker",
	        CLICK = "click" + ns,
	        MOUSEDOWN = "mousedown" + ns,
	        UP = support.mouseAndTouchPresent ? kendo.applyEventMap("up", ns.slice(1)) : CLICK,
	        proxy = $.proxy,
	        parse = kendo.parseDate;

	    var DateRangeView = function(options) {
	        kendo.DateView.call(this, options);
	    };

	    DateRangeView.prototype = Object.create(kendo.DateView.prototype);

	    function preventDefault(e) {
	        e.preventDefault();
	    }

	    DateRangeView.prototype._calendar = function() {
	        var that = this;
	        var calendar = that.calendar;
	        var options = that.options;
	        var div;

	        if (!calendar) {
	            div = $(DIV).attr(ID, kendo.guid())
	                        .appendTo(that.popup.element)
	                        .on(MOUSEDOWN, preventDefault)
	                        .on(CLICK, "td:has(.k-link)", proxy(that._click, that));

	            that.calendar = calendar = new ui.MultiViewCalendar(div);
	            that._setOptions(options);

	            kendo.calendar.makeUnselectable(calendar.element);

	            calendar.navigate(that._value || that._current, options.start);

	            that.calendar.selectRange(that._range || options.range || {});
	        }
	    };

	    DateRangeView.prototype._setOptions =  function(options) {
	        this.calendar.setOptions({
	            focusOnNav: false,
	            change: options.change,
	            culture: options.culture,
	            dates: options.dates,
	            depth: options.depth,
	            footer: options.footer,
	            format: options.format,
	            selectable: options.selectable,
	            max: options.max,
	            min: options.min,
	            month: options.month,
	            weekNumber: options.weekNumber,
	            start: options.start,
	            disableDates: options.disableDates,
	            range: options.range
	        });
	    };

	    DateRangeView.prototype.range = function (range) {
	        this._range = range;

	        if (this.calendar) {
	            if (!range.start && !range.end) {
	                this.calendar.selectRange(range);
	                this.calendar.rangeSelectable.clear(true);
	            } else {
	                this.calendar.selectRange(range);
	            }
	        }
	    };

	    DateRangeView.prototype.move = function(e) {
	        var that = this;
	        var key = e.keyCode;
	        var calendar = that.calendar;
	        var selectIsClicked = e.ctrlKey && key == keys.DOWN || key == keys.ENTER;
	        var handled = false;

	        if (e.altKey) {
	            if (key == keys.DOWN) {
	                that.open();
	                e.preventDefault();
	                handled = true;
	            } else if (key == keys.UP) {
	                that.close();
	                e.preventDefault();
	                handled = true;
	            }

	        } else if (that.popup.visible()) {

	            if (key == keys.ESC || (selectIsClicked && calendar._cell.hasClass(SELECTED))) {
	                that.close();
	                e.preventDefault();
	                return true;
	            }

	            that._current = calendar._move(e, true);

	            handled = true;
	        }

	        return handled;
	    };

	    DateRangeView.prototype._click = function(e) {

	        if (mobileOS.ios || (mobileOS.android && (mobileOS.browser == "firefox" || mobileOS.browser == "chrome"))) {
	            if (this._range && this._range.end) {
	                this.close();
	            }
	        }
	        else if (this._range && this._range.end === null && e.currentTarget.className.indexOf("k-state-selected") !== -1) {
	            this.close();
	        }
	    };

	    kendo.DateRangeView = DateRangeView;

	    var DateRangePicker = Widget.extend({
	        init: function(element, options) {
	            var that = this;
	            var div;
	            var disabled;

	            Widget.fn.init.call(that, element, options);
	            element = that.element;
	            options = that.options;
	            options.disableDates = kendo.calendar.disabled(options.disableDates);

	            options.min = parse(element.attr("min")) || parse(options.min);
	            options.max = parse(element.attr("max")) || parse(options.max);

	            that._initialOptions = extend({}, options);

	            that._buildHTML();

	            that._range = that.options.range;
	            that._changeTriggered = false;

	            that.dateView = new DateRangeView(extend({}, options, {
	                id: element.attr(ID),
	                anchor: that.wrapper,
	                views: 2,
	                selectable: "range",
	                range: that._range,
	                change: function() {
	                    var range = this.selectRange();
	                    that.range(range);
	                    that.trigger(CHANGE);
	                    that._changeTriggered = true;
	                    that._startDateInput.trigger(CHANGE);
	                    that._endDateInput.trigger(CHANGE);
	                    that._changeTriggered = false;
	                },
	                close: function(e) {
	                    if (that.trigger(CLOSE)) {
	                        e.preventDefault();
	                    } else {
	                        that.wrapper.attr(ARIA_EXPANDED, false);
	                        div.attr(ARIA_HIDDEN, true);
	                    }
	                },
	                open: function(e) {
	                    if (that.trigger(OPEN)) {
	                        e.preventDefault();
	                    } else {
	                        that.wrapper.attr(ARIA_EXPANDED, true);
	                        div.attr(ARIA_HIDDEN, false);
	                        that._updateARIA();
	                    }
	                }
	            }));
	            div = that.dateView.div;
	            that._ariaTemplate = template(this.options.ARIATemplate);
	            that._reset();
	            that.wrapper
	                .attr({
	                    role: "combobox",
	                    "aria-expanded": false,
	                    "aria-owns": that.dateView._dateViewID,
	                    "autocomplete": "off"
	                });

	            that._inputs
	                .on(UP + ns, proxy(that._click, that))
	                .on("keydown" + ns, proxy(that._keydown, that));

	            that._initializeDateInputs();

	            disabled = element.is("[disabled]");
	            if (disabled) {
	                that.enable(false);
	            } else {
	                that.readonly(element.is("[readonly]"));
	            }
	        },

	        options: {
	            name: "DateRangePicker",
	            labels: true,
	            footer: "",
	            format: "",
	            culture: "",
	            min: new Date(1900, 0, 1),
	            max: new Date(2099, 11, 31),
	            start: MONTH,
	            depth: MONTH,
	            animation: {},
	            month: {},
	            startField: "",
	            endField: "",
	            dates: [],
	            disableDates: null,
	            range: null,
	            ARIATemplate: 'Current focused date is #=kendo.toString(data.current, "D")#',
	            weekNumber: false,
	            messages: {
	                startLabel: "Start",
	                endLabel: "End"
	            }
	        },

	        events: [
	            OPEN,
	            CLOSE,
	            CHANGE
	        ],

	        setOptions: function(options) {
	            var that = this;

	            Widget.fn.setOptions.call(that, options);

	            options = that.options;

	            options.min = parse(options.min);
	            options.max = parse(options.max);
	            that._inputs.off(ns);

	            this._initializeDateInputs();
	            that.dateView.setOptions(options);
	            that._range = options.range;
	        },

	        _click: function() {
	            var that = this;

	            if (!that._preventInputAction && !that.dateView.popup.visible()) {
	                that.dateView.open();
	            }
	        },

	        _keydown: function(e) {
	            var that = this,
	                dateView = that.dateView,
	                handled = false;

	            if (that._preventInputAction) {
	                e.stopImmediatePropagation();
	                return;
	            }

	            handled = dateView.move(e);
	            that._updateARIA(dateView._current);

	            if (handled && e.stopImmediatePropagation) {
	                e.stopImmediatePropagation();
	            }
	        },

	        _updateARIA: function(date) {
	            var cell;
	            var that = this;
	            var calendar = that.dateView.calendar;

	            if(that.element && that.element.length) {
	                that.element[0].removeAttribute("aria-activedescendant");
	            }

	            if (calendar) {
	                if (date && !calendar._dateInViews(date)) {
	                    calendar.navigate(date);
	                }
	                cell = calendar._cellByDate(date || calendar.current());
	                calendar._focusCell(cell);
	                cell.attr("aria-label", that._ariaTemplate({ current: date || calendar.current() }));

	                that.element.attr("aria-activedescendant", cell.attr("id"));
	            }
	        },

	        _startChange: function (e) {
	            var that = this;
	            var input = e.sender;
	            var startValue = input.value();
	            var endValue = that._endDateInput.value();

	            if (that.options.disableDates(startValue)) {
	                e.sender.value(null);
	                startValue = null;
	            }

	            that.range({ start: startValue, end: endValue });

	            if (!that._changeTriggered) {
	                that.trigger(CHANGE);
	            }
	        },

	        _endChange: function (e) {
	            var that = this;
	            var input = e.sender;
	            var endValue = input.value();
	            var startValue = that._startDateInput.value();

	            if (that.options.disableDates(endValue)) {
	                e.sender.value(null);
	                endValue = null;
	            }

	            that.range({ start: startValue, end: endValue });

	            if (!that._changeTriggered) {
	                that.trigger(CHANGE);
	            }
	        },

	        _initializeDateInputs: function () {
	            var that = this;
	            var options = that.options;
	            var range = options.range || {};
	            var inputOptions = {
	                footer: options.footer,
	                format: options.format,
	                culture: options.culture,
	                min: options.min,
	                max: options.max,
	                start: options.start,
	                startField: options.startField,
	                endField: options.endField,
	                depth: options.depth,
	                animation: options.animation,
	                month: options.month,
	                dates: options.dates,
	                disableDates: options.disableDates,
	                ARIATemplate: options.ARIATemplate,
	                weekNumber: options.weekNumber
	            };

	            if (that._startDateInput) {
	                that._startDateInput.destroy();
	                that._endDateInput.destroy();
	                that.wrapper.empty();
	                that._buildHTML();
	                that._inputs
	                    .on(UP + ns, proxy(that._click, that))
	                    .on("keydown" + ns, proxy(that._keydown, that));
	            }
	            that._startDateInput = that._startInput.kendoDateInput(extend(true, inputOptions, { value: range.start })).getKendoDateInput();
	            that._endDateInput = that._endInput.kendoDateInput(extend(true, inputOptions, { value: range.end })).getKendoDateInput();

	            that._startChangeHandler = proxy(that._startChange, that);
	            that._startDateInput.bind(CHANGE, that._startChangeHandler);

	            that._endChangeHandler = proxy(that._endChange, that);
	            that._endDateInput.bind(CHANGE, that._endChangeHandler);

	        },

	        _buildHTML: function() {
	            var that = this;
	            var element = that.element;

	            if (!that.wrapper) {
	                that.wrapper = element.addClass("k-widget k-daterangepicker");
	            }

	            if (that.options.labels) {
	                $('<span class="k-textbox-container"><input/><label class="k-label">'+ that.options.messages.startLabel + '</label></span>').appendTo(that.wrapper);
	                $('<span>&nbsp;</span><span class="k-textbox-container"><input/><label class="k-label">'+ that.options.messages.endLabel + '</label></span>').appendTo(that.wrapper);
	            } else {
	                $('<input/><span>&nbsp;</span><input/>').appendTo(that.wrapper);
	            }

	            that._startInput = that.wrapper.find("input").eq(0);
	            that._endInput = that.wrapper.find("input").eq(1);
				
	            if (that.options.startField !== ""){
	                that._startInput.attr(kendo.attr("bind"), "value: " + that.options.startField);
					that._startInput.attr("name", that.options.startField);
	            }
	            
	            if (that.options.endField !== ""){
	                that._endInput.attr(kendo.attr("bind"), "value: " + that.options.endField);
					that._endInput.attr("name", that.options.endField);
	            }
				
	            that._inputs = that._startInput.add(that._endInput);
	        },

	        _option: function(option, value) {
	            var that = this,
	                options = that.options;

	            if (value === undefined) {
	                return options[option];
	            }

	            value = parse(value, options.parseFormats, options.culture);

	            if (!value) {
	                return;
	            }

	            options[option] = new Date(+value);
	            that.dateView[option](value);
	        },

	        _reset: function() {
	            var that = this,
	                element = that.element,
	                formId = element.attr("form"),
	                form = formId ? $("#" + formId) : element.closest("form");

	            if (form[0]) {
	                that._resetHandler = function() {
	                    that.max(that._initialOptions.max);
	                    that.min(that._initialOptions.min);
	                };

	                that._form = form.on("reset", that._resetHandler);
	            }
	        },

	        _editable: function(options) {
	            var that = this,
	                inputs = that._inputs,
	                readonly = options.readonly,
	                disable = options.disable;

	            if (!readonly && !disable) {
	                that.wrapper
	                    .addClass(DEFAULT)
	                    .removeClass(STATEDISABLED);

	                $.each(inputs, function(key, item) {
	                    item.removeAttribute(DISABLED);
	                    item.removeAttribute(READONLY);
	                });

	                inputs.attr(ARIA_DISABLED, false);
	                that._preventInputAction = false;
	            } else {
	                that.wrapper
	                    .addClass(disable ? STATEDISABLED : DEFAULT)
	                    .removeClass(disable ? DEFAULT : STATEDISABLED);

	                    inputs.attr(DISABLED, disable)
	                       .attr(READONLY, readonly)
	                       .attr(ARIA_DISABLED, disable);

	                that._preventInputAction = true;
	            }
	        },

	        destroy: function() {
	            var that = this;

	            if (that._startDateInput) {
	                that._startDateInput.unbind(CHANGE, that._startChangeHandler);
	                that._startDateInput.destroy();
	                that._startChangeHandler = null;
	            }

	            if (that._endDateInput) {
	                that._endDateInput.unbind(CHANGE, that._endChangeHandler);
	                that._endDateInput.destroy();
	                that._endChangeHandler = null;
	            }

	            if (that._form) {
	                that._form.off("reset", that._resetHandler);
	            }

	            that._inputs.off(ns);
	            that._inputs = null;

	            that.dateView.destroy();

	            that.element.off(ns);

	            Widget.fn.destroy.call(that);
	        },

	        range: function(range) {
	            var that = this;

	            if (range === undefined) {
	                return that._range;
	            }

	            that._range = range;
	            that.dateView.range({ start: null, end: null });
	            if (!range) {
	                that._startDateInput.value(null);
	                that._endDateInput.value(null);
	            }

	            that._startDateInput.value(range.start ? range.start : null);
	            that._endDateInput.value(range.end ? range.end : null);            
				
	            if (range.start && !range.end) {
	                that.dateView.range({ start: range.start, end: null });
	            } else if (range.start && range.start && +range.start <= +range.end) {
	                that.dateView.range({ start: range.start, end: range.end });
	            }
	        },

	        open: function() {
	            this.dateView.open();
	        },

	        close: function() {
	            this.dateView.close();
	        },

	        min: function(value) {
	            return this._option(MIN, value);
	        },

	        max: function(value) {
	            return this._option(MAX, value);
	        },

	        readonly: function(readonly) {
	            this._startDateInput.readonly(readonly);
	            this._endDateInput.readonly(readonly);

	            this._editable({
	                readonly: readonly === undefined ? true : readonly,
	                disable: false
	            });
	        },

	        enable: function(enable) {
	            this._startDateInput.enable(enable);
	            this._endDateInput.enable(enable);

	            if (!enable) {
	                this.close();
	            }

	            this._editable({
	                readonly: false,
	                disable: !(enable = enable === undefined ? true : enable)
	            });
	        }
	    });

	    kendo.ui.plugin(DateRangePicker);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1169:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ismk");

/***/ }),

/***/ 1170:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("zQRd");

/***/ })

/******/ });

/***/ }),

/***/ "KnXB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = __webpack_require__("pQ38");
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var PopupEditorWrapper = (function (_super) {
    __extends(PopupEditorWrapper, _super);
    function PopupEditorWrapper(cellEditor) {
        var _this = _super.call(this, "<div class=\"ag-popup-editor\" tabindex=\"-1\"/>") || this;
        _this.getGuiCalledOnChild = false;
        _this.cellEditor = cellEditor;
        return _this;
    }
    PopupEditorWrapper.prototype.onKeyDown = function (event) {
        this.params.onKeyDown(event);
    };
    PopupEditorWrapper.prototype.getGui = function () {
        // we call getGui() on child here (rather than in the constructor)
        // as we should wait for 'init' to be called on child first.
        if (!this.getGuiCalledOnChild) {
            this.appendChild(this.cellEditor.getGui());
            this.getGuiCalledOnChild = true;
        }
        return _super.prototype.getGui.call(this);
    };
    PopupEditorWrapper.prototype.init = function (params) {
        var _this = this;
        this.params = params;
        this.gridOptionsWrapper.setDomData(this.getGui(), PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER, true);
        this.addDestroyFunc(function () {
            if (_this.cellEditor.destroy) {
                _this.cellEditor.destroy();
            }
        });
        this.addDestroyableEventListener(
        // this needs to be 'super' and not 'this' as if we call 'this',
        // it ends up called 'getGui()' on the child before 'init' was called,
        // which is not good
        _super.prototype.getGui.call(this), 'keydown', this.onKeyDown.bind(this));
    };
    PopupEditorWrapper.prototype.afterGuiAttached = function () {
        if (this.cellEditor.afterGuiAttached) {
            this.cellEditor.afterGuiAttached();
        }
    };
    PopupEditorWrapper.prototype.getValue = function () {
        return this.cellEditor.getValue();
    };
    PopupEditorWrapper.prototype.isPopup = function () {
        return true;
    };
    PopupEditorWrapper.prototype.isCancelBeforeStart = function () {
        if (this.cellEditor.isCancelBeforeStart) {
            return this.cellEditor.isCancelBeforeStart();
        }
    };
    PopupEditorWrapper.prototype.isCancelAfterEnd = function () {
        if (this.cellEditor.isCancelAfterEnd) {
            return this.cellEditor.isCancelAfterEnd();
        }
    };
    PopupEditorWrapper.prototype.focusIn = function () {
        if (this.cellEditor.focusIn) {
            this.cellEditor.focusIn();
        }
    };
    PopupEditorWrapper.prototype.focusOut = function () {
        if (this.cellEditor.focusOut) {
            this.cellEditor.focusOut();
        }
    };
    PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER = 'popupEditorWrapper';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], PopupEditorWrapper.prototype, "gridOptionsWrapper", void 0);
    return PopupEditorWrapper;
}(component_1.Component));
exports.PopupEditorWrapper = PopupEditorWrapper;


/***/ }),

/***/ "KpOV":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(970);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(971) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($) {

	    // Imports ================================================================
	    var kendo = window.kendo,
	        Class = kendo.Class,
	        editorNS = kendo.ui.editor,
	        RangeUtils = editorNS.RangeUtils,
	        dom = editorNS.Dom,
	        RestorePoint = editorNS.RestorePoint,
	        Marker = editorNS.Marker,
	        browser = kendo.support.browser,
	        extend = $.extend;

	var Clipboard = Class.extend({
	    init: function(editor) {
	        this.editor = editor;
	        var pasteCleanup = editor.options.pasteCleanup;
	        this.cleaners = [
	            new ScriptCleaner(pasteCleanup),
	            new TabCleaner(pasteCleanup),
	            new MSWordFormatCleaner(pasteCleanup),
	            new WebkitFormatCleaner(pasteCleanup),
	            new HtmlTagsCleaner(pasteCleanup),
	            new HtmlAttrCleaner(pasteCleanup),
	            new HtmlContentCleaner(pasteCleanup),
	            new CustomCleaner(pasteCleanup) //always keep at end
	        ];
	    },

	    htmlToFragment: function(html) {
	        var editor = this.editor,
	            doc = editor.document,
	            container = dom.create(doc, 'div'),
	            fragment = doc.createDocumentFragment();

	        container.innerHTML = html;

	        while (container.firstChild) {
	            fragment.appendChild(container.firstChild);
	        }

	        return fragment;
	    },

	    isBlock: function(html) {
	        return (/<(div|p|ul|ol|table|h[1-6])/i).test(html);
	    },

	    _startModification: function() {
	        var range;
	        var restorePoint;
	        var editor = this.editor;

	        if (this._inProgress) {
	            return;
	        }

	        this._inProgress = true;

	        range = editor.getRange();
	        restorePoint = new RestorePoint(range, editor.body);

	        dom.persistScrollTop(editor.document);

	        return { range: range, restorePoint: restorePoint };
	    },

	    _endModification: function(modificationInfo) {
	        editorNS._finishUpdate(this.editor, modificationInfo.restorePoint);

	        this.editor._selectionChange();

	        this._inProgress = false;
	    },

	    _contentModification: function(before, after) {
	        var that = this;
	        var editor = that.editor;
	        var modificationInfo = that._startModification();

	        if (!modificationInfo) {
	            return;
	        }

	        before.call(that, editor, modificationInfo.range);

	        setTimeout(function() {
	            after.call(that, editor, modificationInfo.range);

	            that._endModification(modificationInfo);
	        });
	    },

	    _removeBomNodes: function(range) {
	        var nodes = RangeUtils.textNodes(range);

	        for (var i = 0; i < nodes.length; i++) {
	            nodes[i].nodeValue = dom.stripBom(nodes[i].nodeValue) || nodes[i].nodeValue;
	        }
	    },

	    _onBeforeCopy: function(range) {
	        var marker = new Marker();
	        marker.add(range);

	        this._removeBomNodes(range);

	        marker.remove(range);

	        this.editor.selectRange(range);
	    },

	    oncopy: function() {
	        this._onBeforeCopy(this.editor.getRange());
	    },

	    oncut: function() {
	        this._onBeforeCopy(this.editor.getRange());
	        this._contentModification($.noop, $.noop);
	    },

	    _fileToDataURL: function(blob) {
	        var deferred = $.Deferred();

	        var reader = new FileReader();

	        if (!(blob instanceof window.File) && blob.getAsFile) {
	            blob = blob.getAsFile();
	        }

	        reader.onload = $.proxy(deferred.resolve, deferred);

	        reader.readAsDataURL(blob);

	        return deferred.promise();
	    },

	    _triggerPaste: function(html, options) {
	        var args = { html: html || "" };

	        args.html = args.html.replace(/\ufeff/g, "");

	        this.editor.trigger("paste", args);

	        this.paste(args.html, options || {});
	    },

	    _handleImagePaste: function(e) {
	        if (!('FileReader' in window) || (browser.msie && browser.version > 10)) {
	            return;
	        }

	        var clipboardData = e.clipboardData || e.originalEvent.clipboardData ||
	                    window.clipboardData || {};

	        var items = clipboardData.items || clipboardData.files;

	        return this._insertImages(items);
	    },

	    _insertImages: function(items){
	        if (!items) {
	            return;
	        }

	        var images = $.grep(items, function(item) { return (/^image\//i).test(item.type); });
	        var html = $.grep(items, function(item) { return (/^text\/html/i).test(item.type); });

	        if (html.length || !images.length) {
	            return;
	        }

	        var modificationInfo = this._startModification();

	        if (!modificationInfo) {
	            return;
	        }

	        $.when.apply($, $.map(images, this._fileToDataURL))
	            .done($.proxy(function() {
	                var results = Array.prototype.slice.call(arguments);
	                var html = $.map(results, function(e) {
	                    return '<img src="' + e.target.result + '" />';
	                }).join("");

	                this._triggerPaste(html);

	                this._endModification(modificationInfo);
	            }, this));

	        return true;
	    },

	    onpaste: function(e) {
	        if (this.editor.body.contentEditable === "false") {
	            return;
	        }

	        if (this._handleImagePaste(e)) {
	            e.preventDefault();
	            return;
	        }

	        this.expandImmutablesIn();

	        this._contentModification(
	            function beforePaste(editor, range) {
	                var clipboardNode = dom.create(editor.document, 'div', {
	                        className:'k-paste-container',
	                        innerHTML: "\ufeff"
	                    });
	                var browser = kendo.support.browser;
	                var body = editor.body;

	                this._decoreateClipboardNode(clipboardNode, body);

	                body.appendChild(clipboardNode);

	                //Browser scrolls to clipboardNode
	                if (browser.webkit) {
	                    this._moveToCaretPosition(clipboardNode, range);
	                }

	                // text ranges are slow in IE10-, DOM ranges are buggy in IE9-10
	                if (browser.msie && browser.version < 11) {
	                    e.preventDefault();
	                    var r = editor.createRange();
	                    r.selectNodeContents(clipboardNode);
	                    editor.selectRange(r);
	                    var textRange = editor.document.body.createTextRange();
	                    textRange.moveToElementText(clipboardNode);
	                    $(body).unbind('paste');
	                    textRange.execCommand('Paste');
	                    $(body).bind('paste', $.proxy(this.onpaste, this));
	                } else {
	                    var clipboardRange = editor.createRange();
	                    clipboardRange.selectNodeContents(clipboardNode);
	                    editor.selectRange(clipboardRange);
	                }

	                range.deleteContents();
	            },
	            function afterPaste(editor, range) {
	                var html = "", containers;

	                editor.selectRange(range);

	                containers = $(editor.body).children(".k-paste-container");

	                containers.each(function() {
	                    var lastChild = this.lastChild;

	                    if (lastChild && dom.is(lastChild, 'br')) {
	                        dom.remove(lastChild);
	                    }

	                    html += this.innerHTML;
	                });

	                containers.remove();

	                this._triggerPaste(html, { clean: true });
	            }
	        );
	    },
	    ondragover: function(e){
	        if (browser.msie || browser.edge) {
	            e.stopPropagation();
	            e.preventDefault();
	        }
	    },
	    ondrop: function(e){
	        if (!('FileReader' in window)) {
	            return;
	        }

	        var dataTransfer = (e.originalEvent || e).dataTransfer || {};
	        var items = dataTransfer.items || dataTransfer.files;

	        if (this._insertImages(items)) {
	            e.preventDefault();
	        }
	    },
	    _decoreateClipboardNode: function(node, body) {
	        if (!browser.msie && !browser.webkit) {
	            return;
	        }

	        node = $(node);
	        node.css({
	            borderWidth : "0px",
	            width : "0px",
	            height : "0px",
	            overflow: "hidden",
	            margin : "0",
	            padding : "0"
	        });

	        if (browser.msie) {
	            //node inherits BODY styles and this causes the browser to add additional
	            var documentElement = $(body.ownerDocument.documentElement);

	            node.css({
	                fontVariant : "normal",
	                fontWeight : "normal",
	                lineSpacing : "normal",
	                lineHeight : "normal",
	                textDecoration : "none"
	            });
	            var color = documentElement.css("color");
	            if (color) {
	                node.css("color", color);
	            }
	            var fontFamily = documentElement.css("fontFamily");
	            if (fontFamily) {
	                node.css("fontFamily", fontFamily);
	            }
	            var fontSize = documentElement.css("fontSize");
	            if (fontSize) {
	                node.css("fontSize", fontSize);
	            }
	        }
	    },
	    _moveToCaretPosition: function(node, range) {
	        var that = this;
	        var body = that.editor.body;
	        var nodeOffset = dom.offset(node, body);
	        var caretOffset = that._caretOffset(range, body);
	        var translateX = caretOffset.left - nodeOffset.left;
	        var translateY = caretOffset.top - nodeOffset.top;
	        var translate = "translate(" + translateX + "px," + translateY + "px)";

	        $(node).css({
	            "-webkit-transform": translate,
	            "transform" : translate
	        });
	    },
	    _caretOffset: function (range, body) {
	        var editor = this.editor;
	        var caret = dom.create(editor.document, 'span', { innerHTML: "\ufeff" });
	        var startContainer = range.startContainer;
	        var rangeChanged;

	        if (range.collapsed) {
	            var isStartTextNode = dom.isDataNode(startContainer);
	            if (isStartTextNode && (dom.isBom(startContainer) || range.startOffset === 0)) {
	                dom.insertBefore(caret, startContainer);
	            } else if(isStartTextNode && range.startOffset === startContainer.length) {
	                dom.insertAfter(caret, startContainer);
	            } else {
	                range.insertNode(caret);
	                rangeChanged = true;
	            }
	        } else {
	            startContainer = startContainer === body ?
	                startContainer.childNodes[range.startOffset] : startContainer;
	            dom.insertBefore(caret, startContainer);
	        }

	        var offset = dom.offset(caret, body);
	        var prev = caret.previousSibling;
	        var next = caret.nextSibling;

	        dom.remove(caret);

	        if(rangeChanged && dom.isDataNode(prev) && dom.isDataNode(next) && !dom.isBom(prev) && !dom.isBom(next)) {
	            var prevLength = prev.length;
	            next.data = prev.data + next.data;
	            range.setStart(next, prevLength);
	            dom.remove(prev);

	            range.collapse(true);
	            editor.selectRange(range);
	        }

	        return offset;
	    },

	    expandImmutablesIn: function(range){
	        var editor = this.editor;
	        if (editor && editor.options.immutables) {
	            var body = editor.body;
	            range = range || editor.getRange();
	            kendo.ui.editor.Immutables.expandImmutablesIn(range);
	            if (range.startContainer === body && range.startOffset === 0) {
	                var doc = body.ownerDocument;
	                var bomNode = doc.createTextNode("\ufeff");
	                body.insertBefore(bomNode, body.childNodes[0]);
	                range.setStartBefore(bomNode);
	            }
	            editor.selectRange(range);
	        }
	    },

	    splittableParent: function(block, node) {
	        var parentNode, body;

	        if (block) {
	            return dom.closestEditableOfType(node, ['p', 'ul', 'ol']) || node.parentNode;
	        }

	        parentNode = node.parentNode;
	        body = node.ownerDocument.body;

	        if (dom.isInline(parentNode)) {
	            while (parentNode.parentNode != body && !dom.isBlock(parentNode.parentNode)) {
	                parentNode = parentNode.parentNode;
	            }
	        }

	        return parentNode;
	    },

	    paste: function (html, options) {
	        var editor = this.editor,
	            i, l, childNodes;

	        this.expandImmutablesIn();

	        options = extend({ clean: false, split: true }, options);

	        if(!options.skipCleaners) {
	            for (i = 0, l = this.cleaners.length; i < l; i++) {
	                if (this.cleaners[i].applicable(html)) {
	                    html = this.cleaners[i].clean(html);
	                }
	            }
	        }

	        if (options.clean) {
	            // remove br elements which immediately precede block elements
	            html = html.replace(/(<br>(\s|&nbsp;)*)+(<\/?(div|p|li|col|t))/ig, "$3");
	            // remove empty inline elements
	            html = html.replace(/<(a|span)[^>]*><\/\1>/ig, "");
	        }

	        html = html.replace(/<(a|span|font)([^>]*)> <\/\1>/ig, "<$1$2>&nbsp;</$1>");

	        // It is possible in IE to copy just <li> tags
	        html = html.replace(/^<li/i, '<ul><li').replace(/li>$/g, 'li></ul>');

	        var block = this.isBlock(html);

	        editor.focus();
	        var range = editor.getRange();
	        range.deleteContents();

	        if (range.startContainer == editor.document) {
	            range.selectNodeContents(editor.body);
	        }

	        var marker = new Marker();
	        var caret = marker.addCaret(range);

	        var parent = this.splittableParent(block, caret);
	        var unwrap = false;
	        var splittable = parent != editor.body && !dom.is(parent, "td");

	        if (options.split && splittable && (block || dom.isInline(parent))) {
	            range.selectNode(caret);
	            RangeUtils.split(range, parent, true);
	            unwrap = true;
	        }

	        var fragment = this.htmlToFragment(html);

	        if (fragment.firstChild && fragment.firstChild.className === "k-paste-container") {
	            var fragmentsHtml = [];
	            for (i = 0, l = fragment.childNodes.length; i < l; i++) {
	                fragmentsHtml.push(fragment.childNodes[i].innerHTML);
	            }

	            fragment = this.htmlToFragment(fragmentsHtml.join('<br />'));
	        }

	        childNodes = fragment.childNodes;

	        $(childNodes)
	            .filter("table").addClass("k-table").end()
	            .find("table").addClass("k-table");

	        $(childNodes).each(function(index, elm){
	           if (dom.isBlock(elm) && !dom.isSelfClosing(elm) && elm.innerHTML === "") {
	                elm.appendChild(editor.document.createTextNode("\ufeff"));
	           }
	        });

	        range.insertNode(fragment);

	        parent = this.splittableParent(block, caret);
	        if (unwrap) {
	            while (caret.parentNode != parent) {
	                dom.unwrap(caret.parentNode);
	            }

	            dom.unwrap(caret.parentNode);
	        }

	        dom.normalize(range.commonAncestorContainer);
	        caret.style.display = 'inline';
	        dom.restoreScrollTop(editor.document);
	        dom.scrollTo(caret);
	        marker.removeCaret(range);

	        var rangeEnd = range.commonAncestorContainer.parentNode;
	        if (range.collapsed && dom.name(rangeEnd) == "tbody" || range.collapsed && dom.name(rangeEnd) == "thead") {
	            range.setStartAfter($(rangeEnd).closest("table")[0]);
	            range.collapse(true);
	        }

	        var focusedTable = $(range.commonAncestorContainer.parentNode).closest("table");

	        if(focusedTable.get(0)) {
	            var siblingNodes = focusedTable.parent().contents();
	            var lastSiblingIndex = siblingNodes.length - 1;
	            var lastSibling = siblingNodes.get(lastSiblingIndex);

	            while(lastSibling.nodeValue !== null && (lastSibling.nodeValue === " " || lastSibling.nodeValue === "")) {
	                lastSiblingIndex -= 1;
	                lastSibling = siblingNodes.get(lastSiblingIndex);
	            }

	            if(lastSibling === focusedTable.get(0) && !focusedTable.parents("table").length) {
	                dom.insertAfter(dom.createEmptyNode(editor.document, "p"), focusedTable[0]);
	            }
	        }

	        editor.selectRange(range);
	    }
	});

	var Cleaner = Class.extend({
	    init: function(options) {
	        this.options = options || {};
	        this.replacements = [];
	    },

	    clean: function(html, customReplacements) {
	        var that = this,
	            replacements = customReplacements || that.replacements,
	            i, l;

	        for (i = 0, l = replacements.length; i < l; i += 2) {
	            html = html.replace(replacements[i], replacements[i+1]);
	        }

	        return html;
	    }
	});

	var ScriptCleaner = Cleaner.extend({
	    init: function(options) {
	        Cleaner.fn.init.call(this, options);

	        this.replacements = [
	            /<(\/?)script([^>]*)>/i, "<$1telerik:script$2>"
	        ];
	    },

	    applicable: function(html) {
	        return !this.options.none && (/<script[^>]*>/i).test(html);
	    }
	});

	var TabCleaner = Cleaner.extend({
	    init: function(options) {
	        Cleaner.fn.init.call(this, options);

	        var replacement = ' ';
	        this.replacements = [
	            /<span\s+class="Apple-tab-span"[^>]*>\s*<\/span>/gi, replacement,
	            /\t/gi, replacement,
	            /&nbsp;&nbsp; &nbsp;/gi, replacement
	        ];
	    },

	    applicable: function(html) {
	        return (/&nbsp;&nbsp; &nbsp;|class="?Apple-tab-span/i).test(html);
	    }
	});

	var MSWordFormatCleaner = Cleaner.extend({
	    init: function(options) {
	        Cleaner.fn.init.call(this, options);

	        this.junkReplacements = [
	            /<\?xml[^>]*>/gi, '',
	            /<!--(.|\n)*?-->/g, '', /* comments */
	            /&quot;/g, "'", /* encoded quotes (in attributes) */
	            /<o:p>&nbsp;<\/o:p>/ig, '&nbsp;',
	            /<\/?(meta|link|style|o:|v:|x:)[^>]*>((?:.|\n)*?<\/(meta|link|style|o:|v:|x:)[^>]*>)?/ig, '', /* external references and namespaced tags */
	            /<\/o>/g, ''
	        ];
	        this.replacements = this.junkReplacements.concat([
	            /(?:<br>&nbsp;[\s\r\n]+|<br>)*(<\/?(h[1-6]|hr|p|div|table|tbody|thead|tfoot|th|tr|td|li|ol|ul|caption|address|pre|form|blockquote|dl|dt|dd|dir|fieldset)[^>]*>)(?:<br>&nbsp;[\s\r\n]+|<br>)*/g, '$1',
	            /<br><br>/g, '<BR><BR>',
	            /<br>(?!\n)/g, ' ',
	            /<table([^>]*)>(\s|&nbsp;)+<t/gi, '<table$1><t',
	            /<tr[^>]*>(\s|&nbsp;)*<\/tr>/gi, '',
	            /<tbody[^>]*>(\s|&nbsp;)*<\/tbody>/gi, '',
	            /<table[^>]*>(\s|&nbsp;)*<\/table>/gi, '',
	            /<BR><BR>/g, '<br>',
	            /^\s*(&nbsp;)+/gi, '',
	            /(&nbsp;|<br[^>]*>)+\s*$/gi, '',
	            /mso-[^;"]*;?/ig, '', /* office-related CSS attributes */
	            /<(\/?)b(\s[^>]*)?>/ig, '<$1strong$2>',
	            /<(\/?)font(\s[^>]*)?>/ig, this.convertFontMatch,
	            /<(\/?)i(\s[^>]*)?>/ig, '<$1em$2>',
	            /style=(["|'])\s*\1/g, '', /* empty style attributes */
	            /(<br[^>]*>)?\n/g, function ($0, $1) { return $1 ? $0 : ' '; } /* phantom extra line feeds */
	        ]);
	    },

	    convertFontMatch: function(match, closing, args) {
	        var faceRe = /face=['"]([^'"]+)['"]/i;
	        var face = faceRe.exec(args);
	        var family = args && face && face[1];

	        if (closing) {
	            return '</span>';
	        } else if (family) {
	            return '<span style="font-family:' + family + '">';
	        } else {
	            return '<span>';
	        }
	    },

	    applicable: function(html) {
	        return (/class="?Mso/i).test(html) ||
	               (/style="[^"]*mso-/i).test(html) ||
	               (/urn:schemas-microsoft-com:office/).test(html);
	    },

	    stripEmptyAnchors: function(html) {
	        return html.replace(/<a([^>]*)>\s*<\/a>/ig, function(a, attributes) {
	            if (!attributes || attributes.indexOf("href") < 0) {
	                return "";
	            }

	            return a;
	        });
	    },

	    listType: function(p, listData) {
	        var html = p.innerHTML;
	        var text = dom.innerText(p);

	        var startingSymbol;
	        var matchSymbol = html.match(/^(?:<span [^>]*texhtml[^>]*>)?<span [^>]*(?:Symbol|Wingdings)[^>]*>([^<]+)/i);
	        var symbol = matchSymbol && matchSymbol[1];
	        var isNumber = /^[a-z\d]/i.test(symbol);//including alpha-numeric and roman numerals

	        var trimStartText = function(text) {
	            return text.replace(/^(?:&nbsp;|[\u00a0\n\r\s])+/, '');
	        };

	        if (matchSymbol) {
	            startingSymbol = true;
	        }

	        html = html.replace(/<\/?\w+[^>]*>/g, '').replace(/&nbsp;/g, '\u00a0');

	        if ((!startingSymbol && /^[\u2022\u00b7\u00a7\u00d8o]\u00a0+/.test(html)) ||
	            (startingSymbol && /^.\u00a0+/.test(html)) ||
	            (symbol && !isNumber && listData)) {
	            return {
	                tag: 'ul',
	                style: this._guessUnorderedListStyle(trimStartText(text))
	            };
	        }

	        if (/^\s*\w+[\.\)][\u00a0 ]{2,}/.test(html)) {
	            return {
	                tag: 'ol',
	                style: this._guessOrderedListStyle(trimStartText(text))
	            };
	        }
	    },

	    _convertToLi: function(p) {
	        var content;

	        if (p.childNodes.length == 1) {
	            content = p.firstChild.nodeType === dom.nodeTypes.TEXT_NODE ? dom.innerText(p) : p.firstChild.innerHTML.replace(/^\w+[\.\)](&nbsp;)+ /, "");
	            content = this._checkForBullet(content);
	        } else {
	            content = this._getHtmlNoBullet(p);
	        }

	        dom.remove(p);

	        return dom.create(document, 'li', { innerHTML: content });
	    },

	    _checkForBullet: function (html) {
	        var p = dom.create(document, 'p', { innerHTML: html });
	        var bulletRgx = /^\s*\w+[\.\)]\s+/;

	        if(bulletRgx.test(p.innerText)) {
	            return this._getHtmlNoBullet(p);
	        }

	        return html;
	    },

	    _getHtmlNoBullet: function (element) {
	        var content,
	            name = dom.name(element);

	        dom.remove(element.firstChild);

	        // check for roman numerals
	        if (element.firstChild.nodeType == 3) {
	            if (/^[ivxlcdm]+\.$/i.test(element.firstChild.nodeValue)) {
	                dom.remove(element.firstChild);
	            }
	        }

	        if (/^(&nbsp;|\s)+$/i.test(element.firstChild.innerHTML)) {
	            dom.remove(element.firstChild);
	        }

	        if (name != "p") {
	            content = "<" + name + ">" + element.innerHTML + "</" + name + ">";
	        } else {
	            content = element.innerHTML;
	        }

	        return content;
	    },

	    _guessUnorderedListStyle: function(symbol) {
	        if (/^[\u2022\u00b7\u00FC\u00D8\u002dv-]/.test(symbol)) {
	            return null;//return "disc"; //default CSS value
	        } else if (/^o/.test(symbol)) {
	            return "circle";
	        } else {
	            return "square";
	        }
	    },
	    _guessOrderedListStyle: function(symbol) {
	        var listType = null;
	        if (!/^\d/.test(symbol)) {
	            listType = (/^[a-z]/.test(symbol) ? 'lower-' : 'upper-') +
	                       (/^[ivxlcdm]/i.test(symbol) ? 'roman' : 'alpha');
	        }

	        return listType;
	    },

	    extractListLevels: function(html) {
	        var msoListRegExp = /style=['"]?[^'"]*?mso-list:\s?[a-zA-Z]+(\d+)\s[a-zA-Z]+(\d+)\s(\w+)/gi;

	        html = html.replace(msoListRegExp, function(match, list, level) {
	            return kendo.format('data-list="{0}" data-level="{1}" {2}', list, level, match);
	        });

	        return html;
	    },

	    _createList: function(type, styleType) {
	        return dom.create(document, type, {
	            style: { listStyleType: styleType }
	        });
	    },

	    lists: function(placeholder) {
	        var blockChildren = $(placeholder).find(dom.blockElements.join(',')),
	            lastMargin = -1,
	            name,
	            levels = {},
	            li,
	            rootMargin,
	            rootIndex,
	            lastRootLi,
	            isLastRootLi,
	            rootList,
	            i, p, type, margin, list, listData,
	            acceptedNameTags = ["p", "h1", "h2", "h3", "h4", "h5", "h6"],
	            isParentTable = false;

	        for (i = 0; i < blockChildren.length; i++) {
	            p = blockChildren[i];
	            listData = $(p).data();
	            var listIndex = listData.list;
	            name = dom.name(p);
	            isParentTable = !!$(p).parents("table").length;

	            if (isParentTable) {
	                continue;
	            }

	            var listType = this.listType(p, listData);
	            type = listType && listType.tag;

	            if (!type || acceptedNameTags.indexOf(name) < 0) {
	                if (!p.innerHTML) {
	                    dom.remove(p);
	                } else if (li && !isLastRootLi) {
	                    li.appendChild(p);
	                }
	                continue;
	            }

	            // not supported list levels in ie
	            if (browser.msie) {
	                continue;
	            }

	            margin = listData.level || parseFloat(p.style.marginLeft || 0);

	            var levelType = type + listIndex;
	            if (!levels[margin]) {
	                levels[margin] = {};
	            }

	            if (!rootMargin || rootMargin < 0) {
	                rootMargin = margin;
	                rootIndex = listIndex;
	                lastRootLi = $(placeholder).find("[data-list='" + rootIndex + "']:last")[0];
	                rootList = this._createList(type, listType.style);
	                dom.insertBefore(rootList, p);
	                lastMargin = margin;
	                levels[margin][levelType] = rootList;
	            }

	            isLastRootLi = lastRootLi === p;

	            list = levels[margin][levelType];

	            if (margin > lastMargin || !list) {
	                list = this._createList(type, listType.style);
	                levels[margin][levelType] = list;
	                li.appendChild(list);
	            }

	            li = this._convertToLi(p);
	            list.appendChild(li);

	            if (isLastRootLi) {
	                rootMargin = lastMargin = -1;
	            } else {
	                lastMargin = margin;
	            }
	        }
	    },

	    removeAttributes: function(element) {
	        var attributes = element.attributes,
	            i = attributes.length;

	        while (i--) {
	            if (dom.name(attributes[i]) != "colspan") {
	                element.removeAttributeNode(attributes[i]);
	            }
	        }
	    },

	    createColGroup: function(row) {
	        var cells = row.cells;
	        var table = $(row).closest("table");
	        var colgroup = table.children("colgroup");

	        if (cells.length < 2) {
	            return;
	        } else if (colgroup.length) {
	            cells = colgroup.children();
	            colgroup[0].parentNode.removeChild(colgroup[0]);
	        }

	        colgroup = $($.map(cells, function(cell) {
	                var width = cell.width;
	                if (width && parseInt(width, 10) !== 0) {
	                    return kendo.format('<col style="width:{0}px;"/>', width);
	                }

	                return "<col />";
	            }).join(""));

	        // jquery 1.9/2.0 discrepancy
	        if (!colgroup.is("colgroup")) {
	            colgroup = $("<colgroup/>").append(colgroup);
	        }

	        colgroup.prependTo(table);
	    },

	    convertHeaders: function(row) {
	        var cells = row.cells,
	            i,
	            boldedCells = $.map(cells, function(cell) {
	                var child = $(cell).children("p").children("strong")[0];

	                if (child && dom.name(child) == "strong") {
	                    return child;
	                }
	            });

	        if (boldedCells.length == cells.length) {
	            for (i = 0; i < boldedCells.length; i++) {
	                dom.unwrap(boldedCells[i]);
	            }

	            $(row).closest("table")
	                .find("colgroup").after("<thead></thead>").end()
	                .find("thead").append(row);

	            for (i = 0; i < cells.length; i++) {
	                dom.changeTag(cells[i], "th");
	            }
	        }
	    },

	    removeParagraphs: function(cells) {
	        var i, j, len, cell, paragraphs;

	        for (i = 0; i < cells.length; i++) {
	            this.removeAttributes(cells[i]);

	            // remove paragraphs and insert line breaks between them
	            cell = $(cells[i]);
	            paragraphs = cell.children("p");

	            for (j = 0, len = paragraphs.length; j < len; j++) {
	                if (j < len - 1) {
	                    dom.insertAfter(dom.create(document, "br"), paragraphs[j]);
	                }

	                dom.unwrap(paragraphs[j]);
	            }
	        }
	    },

	    removeDefaultColors: function(spans) {
	        for (var i = 0; i < spans.length; i++) {
	            if (/^\s*color:\s*[^;]*;?$/i.test(spans[i].style.cssText)) {
	                dom.unwrap(spans[i]);
	            }
	        }
	    },

	    tables: function(placeholder) {
	        var tables = $(placeholder).find("table"),
	            that = this,
	            rows,
	            firstRow, longestRow, i, j;

	        for (i = 0; i < tables.length; i++) {
	            rows = tables[i].rows;
	            longestRow = firstRow = rows[0];

	            for (j = 1; j < rows.length; j++) {
	                if (rows[j].cells.length > longestRow.cells.length) {
	                    longestRow = rows[j];
	                }
	            }

	            that.createColGroup(longestRow);
	            that.convertHeaders(firstRow);

	            that.removeAttributes(tables[i]);

	            that.removeParagraphs(tables.eq(i).find("td,th"));
	            that.removeDefaultColors(tables.eq(i).find("span"));
	        }
	    },

	    headers: function(placeholder) {
	        var titles = $(placeholder).find("p.MsoTitle");

	        for (var i = 0; i < titles.length; i++) {
	            dom.changeTag(titles[i], "h1");
	        }
	    },

	    removeFormatting: function (placeholder) {
	        $(placeholder).find("*").each(function() {
	            $(this).css({
	                fontSize: "",
	                fontFamily: ""
	            });

	            if (!this.getAttribute("style") && !this.style.cssText) {
	                this.removeAttribute("style");
	            }
	        });
	    },

	    clean: function(html) {
	        var that = this, placeholder;
	        var filters = this.options;

	        if (filters.none) {
	            html = Cleaner.fn.clean.call(that, html, this.junkReplacements);
	            html = that.stripEmptyAnchors(html);
	        } else {

	            html = filters.msConvertLists ? this.extractListLevels(html) : html;
	            html = Cleaner.fn.clean.call(that, html);
	            html = that.stripEmptyAnchors(html);

	            placeholder = dom.create(document, 'div', {innerHTML: html});
	            that.headers(placeholder);

	            if (filters.msConvertLists) {
	                that.lists(placeholder);
	            }
	            that.tables(placeholder);

	            if (filters.msAllFormatting) {
	                that.removeFormatting(placeholder);
	            }

	            html = placeholder.innerHTML.replace(/(<[^>]*)\s+class="?[^"\s>]*"?/ig, '$1');
	        }

	        return html;
	    }
	});

	var WebkitFormatCleaner = Cleaner.extend({
	    init: function(options) {
	        Cleaner.fn.init.call(this, options);

	        this.replacements = [
	            /\s+class="Apple-style-span[^"]*"/gi, '',
	            /<(div|p|h[1-6])\s+style="[^"]*"/gi, '<$1',
	            /^<div>(.*)<\/div>$/, '$1'
	        ];
	    },

	    applicable: function(html) {
	        return (/class="?Apple-style-span|style="[^"]*-webkit-nbsp-mode/i).test(html);
	    }
	});

	var DomCleaner = Cleaner.extend({
	    clean: function(html) {
	        var container = dom.create(document, 'div', {innerHTML: html});
	        container = this.cleanDom(container);
	        return container.innerHTML;
	    },

	    cleanDom: function(container) {
	        return container;
	    }
	});

	var HtmlTagsCleaner = DomCleaner.extend({
	    cleanDom: function(container) {
	        var tags = this.collectTags();

	        $(container).find(tags).each(function() {
	            dom.unwrap(this);
	        });

	        return container;
	    },

	    collectTags: function() {
	        if (this.options.span) {
	            return "span";
	        }
	    },

	    applicable: function() {
	        return this.options.span;
	    }
	});

	var HtmlAttrCleaner = DomCleaner.extend({
	    cleanDom: function(container) {
	        var attributes = this.collectAttr();
	        var nodes = $(container).find("[" + attributes.join("],[") + "]");
	        nodes.removeAttr(attributes.join(" "));

	        return container;
	    },

	    collectAttr: function() {
	        if (this.options.css) {
	            return ["class", "style"];
	        }

	        return [];
	    },

	    applicable: function() {
	        return this.options.css;
	    }
	});

	var TextContainer = function() {
	    this.text = "";
	    this.add = function(text) {
	        this.text += text;
	    };
	};

	var HtmlTextLines = Class.extend({
	    init: function(separators) {
	        this.separators = separators || {
	                text: " ",
	                line: "<br/>"
	            };
	        this.lines = [];
	        this.inlineBlockText = [];
	        this.resetLine();
	    },

	    appendText: function(text) {
	        if (text.nodeType === 3) {
	            text = text.nodeValue;
	        }

	        this.textContainer.add(text);
	    },

	    appendInlineBlockText: function(text) {
	        this.inlineBlockText.push(text);
	    },

	    flashInlineBlockText: function() {
	        if (this.inlineBlockText.length) {
	            this.appendText(this.inlineBlockText.join(" "));
	            this.inlineBlockText = [];
	        }
	    },

	    endLine: function() {
	        this.flashInlineBlockText();
	        this.resetLine();
	    },

	    html: function() {
	        var separators = this.separators;
	        var result = "";
	        var lines = this.lines;

	        this.flashInlineBlockText();

	        for (var i = 0, il = lines.length, il1 = il - 1; i < il; i++) {
	            var line = lines[i];
	            for (var j = 0, jl = line.length, jl1 = jl - 1; j < jl; j++) {
	                var text = line[j].text;
	                result += text;
	                if (j !== jl1) {
	                    result += separators.text;
	                }
	            }
	            if (i !== il1) {
	                result += separators.line;
	            }
	        }

	        return result;
	    },

	    resetLine: function() {
	        this.textContainer = new TextContainer();
	        this.line = [];
	        this.line.push(this.textContainer);
	        this.lines.push(this.line);
	    }
	});

	var DomEnumerator = Class.extend({
	    init: function(callback) {
	        this.callback = callback;
	    },
	    enumerate: function(node) {
	        if (!node) {
	            return;
	        }

	        var preventDown = this.callback(node);

	        var child = node.firstChild;
	        if (!preventDown && child) {
	            this.enumerate(child);
	        }

	        this.enumerate(node.nextSibling);
	    }
	});

	var HtmlContentCleaner = Cleaner.extend({
	    init: function(options) {
	        Cleaner.fn.init.call(this, options);
	        this.hasText = false; //unpleasant flag to prevent an empty line at the beginning of the generated content.
	        this.enumerator = new DomEnumerator($.proxy(this.buildText, this));
	    },

	    clean: function(html) {
	        var container = dom.create(document, 'div', {innerHTML: html});

	        return this.cleanDom(container);
	    },

	    cleanDom: function(container) {
	        this.separators = this.getDefaultSeparators();
	        this.htmlLines = new HtmlTextLines(this.separators);
	        this.enumerator.enumerate(container.firstChild);
	        this.hasText = false;

	        return this.htmlLines.html();
	    },

	    buildText: function(node) {
	        if (dom.isDataNode(node)) {
	            if (dom.isEmptyspace(node)) {
	                return;
	            }
	            this.htmlLines.appendText(node.nodeValue.replace('\n', this.separators.line));
	            this.hasText = true;
	        } else if (dom.isBlock(node) && this.hasText) {
	            var action = this.actions[dom.name(node)] || this.actions.block;
	            return action(this, node);
	        } else if (dom.isBr(node)) {
	            this.htmlLines.appendText(this.separators.line);
	        }
	    },

	    applicable: function() {
	        var o = this.options;
	        return o.all || o.keepNewLines;
	    },

	    getDefaultSeparators: function() {
	        if (this.options.all) {
	            return {text: " ", line: " "};
	        } else {
	            return {text: " ", line: "<br/>"};
	        }
	    },

	    actions: {
	        ul: $.noop,
	        ol: $.noop,
	        table: $.noop,
	        thead: $.noop,
	        tbody: $.noop,
	        td: function(cleaner, node) {
	            var tdCleaner = new HtmlContentCleaner({all: true});

	            var cellText = tdCleaner.cleanDom(node);
	            cleaner.htmlLines.appendInlineBlockText(cellText);

	            return true;
	        },

	        block: function(cleaner) {
	            cleaner.htmlLines.endLine();
	        }
	    }
	});

	var CustomCleaner = Cleaner.extend({
	    clean: function(html) {
	        return this.options.custom(html);
	    },

	    applicable: function() {
	        return typeof(this.options.custom) === "function";
	    }
	});

	extend(editorNS, {
	    Clipboard: Clipboard,
	    Cleaner: Cleaner,
	    ScriptCleaner: ScriptCleaner,
	    TabCleaner: TabCleaner,
	    MSWordFormatCleaner: MSWordFormatCleaner,
	    WebkitFormatCleaner: WebkitFormatCleaner,
	    HtmlTagsCleaner: HtmlTagsCleaner,
	    HtmlAttrCleaner: HtmlAttrCleaner,
	    HtmlContentCleaner: HtmlContentCleaner,
	    HtmlTextLines: HtmlTextLines,
	    CustomCleaner: CustomCleaner
	});

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 971:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("cmba");

/***/ })

/******/ });

/***/ }),

/***/ "L414":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(996);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 988:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Ytuf");

/***/ }),

/***/ 996:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(988), __webpack_require__(997) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {

	var kendo = window.kendo,
	    extend = $.extend,
	    proxy = $.proxy,
	    Editor = kendo.ui.editor,
	    dom = Editor.Dom,
	    EditorUtils = Editor.EditorUtils,
	    RangeUtils = Editor.RangeUtils,
	    Command = Editor.Command,

	    NS = "kendoEditor",
	    ACTIVESTATE = "k-state-active",
	    SELECTEDSTATE = "k-state-selected",
	    SCOPE = "scope",
	    ROW = "row",
	    COL = "col",
	    ROWGROUP = "rowgroup",
	    COLGROUP = "colgroup",
	    COLSPAN = "colspan",
	    ROWSPAN = "rowspan",
	    TABLE = "table",
	    THEAD = "thead",
	    TBODY = "tbody",
	    TR = "tr",
	    TD = "td",
	    TH = "th",

	    Tool = Editor.Tool,
	    ToolTemplate = Editor.ToolTemplate,
	    InsertHtmlCommand = Editor.InsertHtmlCommand,
	    BlockFormatFinder = Editor.BlockFormatFinder,
	    registerTool = Editor.EditorUtils.registerTool,
	    getTouches = kendo.getTouches;
	var template = kendo.template;

	var columnTemplate = "<td style='width:#=width#%;'>#=content#</td>";

	var tableFormatFinder = new BlockFormatFinder([{tags:[TABLE]}]);

	var TableCommand = InsertHtmlCommand.extend({
	    init: function(options) {
	        var o = $.extend({
	            postProcess: this.postProcess,
	            skipCleaners: true
	        }, options || {});

	        InsertHtmlCommand.fn.init.call(this, o);
	    },
	    _tableHtml: function(rows, columns) {
	        rows = rows || 1;
	        columns = columns || 1;
	        var columnHtml = template(columnTemplate)({ width: 100 / columns, content: Editor.emptyTableCellContent });
	        var rowHeight = 100 / rows;

	        return "<table class='k-table' data-last>" +
	                    new Array(rows + 1).join(
	                    "<tr style='height:" + rowHeight + "%;'>" +
	                        new Array(columns + 1).join(columnHtml) +
	                    "</tr>") +
	               "</table>";
	    },

	    postProcess: function(editor, range) {
	        var insertedTable = $("table[data-last]", editor.document).removeAttr("data-last");

	        range.setStart(insertedTable.find(TD)[0], 0);
	        range.collapse(true);

	        editor.selectRange(range);
	    },

	    exec: function() {
	        var options = this.options;
	        options.html = this._tableHtml(options.rows, options.columns);

	        InsertHtmlCommand.fn.exec.call(this);
	    }
	});

	var PopupTool = Tool.extend({
	    initialize: function(ui, options) {
	        Tool.fn.initialize.call(this, ui, options);

	        var popup = $(this.options.popupTemplate).appendTo("body").kendoPopup({
	            anchor: ui,
	            copyAnchorStyles: false,
	            open: proxy(this._open, this),
	            activate: proxy(this._activate, this),
	            close: proxy(this._close, this)
	        }).data("kendoPopup");

	        ui.click(proxy(this._toggle, this))
	          .keydown(proxy(this._keydown, this));

	        var editor = this._editor = options.editor;
	        this._popup = popup;

	        var tableWizard = new Editor.TableWizardTool({
	            template: new ToolTemplate({ template: EditorUtils.tableWizardButtonTemplate, title: editor.options.messages.tableWizard }),
	            command: Editor.TableWizardCommand,
	            insertNewTable: true
	        });

	        registerTool("tableWizardInsert", tableWizard);

	        var twTool = $("<div>" + tableWizard.options.template.getHtml() + "</div>");
	        twTool.appendTo(popup.element);

	        if (editor.toolbar) {
	            editor.toolbar.attachToolsEvents(twTool);
	        }
	    },

	    popup: function() {
	        return this._popup;
	    },

	    _activate: $.noop,

	    _open: function() {
	        this._popup.options.anchor.addClass(ACTIVESTATE);
	    },

	    _close: function() {
	        this._popup.options.anchor.removeClass(ACTIVESTATE);
	    },

	    _keydown: function(e) {
	        var keys = kendo.keys;
	        var key = e.keyCode;

	        if (key == keys.DOWN && e.altKey) {
	            this._popup.open();
	        } else if (key == keys.ESC) {
	            this._popup.close();
	        }
	    },

	    _toggle: function(e) {
	        var button = $(e.target).closest(".k-tool");

	        if (!button.hasClass("k-state-disabled")) {
	            this.popup().toggle();
	        }
	    },

	    update: function(ui) {
	        var popup = this.popup();

	        if (popup.wrapper && popup.wrapper.css("display") == "block") {
	            popup.close();
	        }

	        ui.removeClass("k-state-hover");
	    },

	    destroy: function() {
	        this._popup.destroy();
	    }
	});

	var InsertTableTool = PopupTool.extend({
	    init: function(options) {
	        this.cols = 8;
	        this.rows = 6;

	        PopupTool.fn.init.call(this, $.extend(options, {
	            command: TableCommand,
	            popupTemplate:
	                "<div class='k-ct-popup'>" +
	                    "<div>" +
	                        new Array(this.cols * this.rows + 1).join("<span class='k-ct-cell k-state-disabled'></span>") +
	                    "</div>" +
	                    "<div class='k-status'></div>" +
	                "</div>"
	        }));
	    },

	    _activate: function() {
	        var that = this,
	            element = that._popup.element,
	            cells = element.find(".k-ct-cell"),
	            firstCell = cells.eq(0),
	            lastCell = cells.eq(cells.length - 1),
	            start = kendo.getOffset(firstCell),
	            end = kendo.getOffset(lastCell),
	            cols = that.cols,
	            rows = that.rows,
	            cellWidth, cellHeight;

	        element.find("*").addBack().attr("unselectable", "on");

	        end.left += lastCell[0].offsetWidth;
	        end.top += lastCell[0].offsetHeight;

	        cellWidth = (end.left - start.left) / cols;
	        cellHeight = (end.top - start.top) / rows;

	        function tableFromLocation(e) {
	            var w = $(window);
	            return {
	                row: Math.floor((e.clientY + w.scrollTop() - start.top) / cellHeight) + 1,
	                col: Math.floor((e.clientX + w.scrollLeft() - start.left) / cellWidth) + 1
	            };
	        }

	        element.autoApplyNS(NS)
	            .on("mousemove", ".k-ct-cell", function(e) {
	                that._setTableSize(tableFromLocation(e));
	            })
	            .on("mouseleave", ".k-ct-cell", function() {
	                that._setTableSize();
	            })
	            .on("down", ".k-ct-cell", function(e) {
	                e.preventDefault();
	                var touch = getTouches(e)[0];
	                that._exec(tableFromLocation(touch.location));
	            });
	    },

	    _valid: function(size) {
	        return size && size.row > 0 && size.col > 0 && size.row <= this.rows && size.col <= this.cols;
	    },

	    _exec: function(size) {
	        if (this._valid(size)) {
	            this._editor.exec("createTable", {
	                rows: size.row,
	                columns: size.col
	            });
	            this._popup.close();
	        }
	    },

	    _setTableSize: function(size) {
	        var element = this._popup.element;
	        var status = element.find(".k-status");
	        var cells = element.find(".k-ct-cell");
	        var cols = this.cols;
	        var messages = this._editor.options.messages;

	        if (this._valid(size)) {
	            status.text(kendo.format(messages.createTableHint, size.row, size.col));

	            cells.each(function(i) {
	                $(this).toggleClass(
	                    SELECTEDSTATE,
	                    i % cols < size.col && i / cols < size.row
	                );
	            });
	        } else {
	            status.text(messages.createTable);
	            cells.removeClass(SELECTEDSTATE);
	        }
	    },

	    _keydown: function(e) {
	        PopupTool.fn._keydown.call(this, e);

	        if (!this._popup.visible()) {
	            return;
	        }

	        var keys = kendo.keys;
	        var key = e.keyCode;
	        var cells = this._popup.element.find(".k-ct-cell");
	        var focus = Math.max(cells.filter(".k-state-selected").last().index(), 0);
	        var selectedRows = Math.floor(focus / this.cols);
	        var selectedColumns = focus % this.cols;

	        var changed = false;

	        if (key == keys.DOWN && !e.altKey) {
	            changed = true;
	            selectedRows++;
	        } else if (key == keys.UP) {
	            changed = true;
	            selectedRows--;
	        } else if (key == keys.RIGHT) {
	            changed = true;
	            selectedColumns++;
	        } else if (key == keys.LEFT) {
	            changed = true;
	            selectedColumns--;
	        }

	        var tableSize = {
	            row: Math.max(1, Math.min(this.rows, selectedRows + 1)),
	            col: Math.max(1, Math.min(this.cols, selectedColumns + 1))
	        };

	        if (key == keys.ENTER) {
	            this._exec(tableSize);
	        } else {
	            this._setTableSize(tableSize);
	        }

	        if (changed) {
	            e.preventDefault();
	            e.stopImmediatePropagation();
	        }
	    },

	    _open: function() {
	        var messages = this._editor.options.messages;

	        PopupTool.fn._open.call(this);

	        this.popup().element
	            .find(".k-status").text(messages.createTable).end()
	            .find(".k-ct-cell").removeClass(SELECTEDSTATE);
	    },

	    _close: function() {
	        PopupTool.fn._close.call(this);
	        this.popup().element.off("." + NS);
	    }
	});

	var TableModificationCommand = Command.extend({
	    undo: function() {
	        var point = this.restorePoint;
	        point.restoreHtml();

	        $(this.editor.body).find(".k-table-resize-handle-wrapper")
	            .each(function(index,el){
	                el.remove();
	            });

	        this.editor.selectRange(point.toRange());
	    },
	    _clearColIndexAttr: function (table) {
	        dom.clearTableMappings(table, "col-index");
	    },
	    _mapColIndices: function (table) {
	        dom.reMapTableColumns(table, "col-index");
	    },
	    _findRowSpanCell: function(parent, rowIndex, colIndex) {
	        var row, cell;

	        for (var i = rowIndex; i >= 0; i--) {
	            row = parent.rows[i];
	            cell = $(row).find("[col-index=" + colIndex +"]");

	            if(cell.length) {
	                return cell;
	            }
	        }
	    },
	    _resetTableResizing: function (editor) {
	        editor._destroyResizings();
	        editor._initializeColumnResizing();
	        editor._initializeRowResizing();
	        editor._initializeTableResizing();
	    },
	    _findNextTdInRow: function (row, colIndex){
	        var lastTd = row.find("td:last-child"),
	            lastIndex = parseInt(lastTd.attr("col-index"), 10) + lastTd.prop("colSpan") - 1,
	            td;

	        for (var i = colIndex; i <= lastIndex; i++) {
	            td = row.find("[col-index=" + i  +"]");
	            if(td.length) {
	                return td;
	            }
	        }
	    },
	    _adjustColgroups: function(row, table) {
	        var colElements = table.getElementsByTagName(COL),
	            colgroupElements = table.getElementsByTagName(COLGROUP),
	            cells = row.cells,
	            numberOfCells = cells.length,
	            i, colgroup, cell;

	        while(colElements.length > 0) {
	            colElements[0].remove();
	        }
	        while(colgroupElements.length > 0) {
	            colgroupElements[0].remove();
	        }

	        for(i = numberOfCells - 1; i >= 0; i--) {
	            cell = cells[i];
	            if(cell.getAttribute(SCOPE) === COLGROUP) {
	                colgroup = dom.createEmptyNode(this.editor.document, COLGROUP);
	                colgroup.setAttribute("span", cell.getAttribute(COLSPAN));
	                table.prepend(colgroup);
	            } else {
	                table.prepend(dom.createEmptyNode(this.editor.document, COL));
	            }
	        }
	    },
	    _associateHeaderIds: function(table) {
	        dom.clearTableMappings(table, "col-index");
	        dom.reMapTableColumns(table, "col-index");
	        $(table).find("th, td").removeAttr("id headers");
	        dom.associateWithIds(table);
	    },
	    _getNumberOfColumns: function(table) {
	        return dom._getNumberOfColumns(table, "td, th");
	    }
	});

	var InsertRowCommand = TableModificationCommand.extend({
	    exec: function () {
	        var range = this.lockRange(true),
	            td = dom.closest(range.endContainer, [TD, TH]),
	            table = dom.closest(td, TABLE),
	            position = this.options.position || "after",
	            cellCount, row, cell,
	            newRow, rowIndex, rowSpanIndex, createdCell;

	        if (!table || (this.immutables() && Editor.Immutables.immutableParent(td))) {
	            this.releaseRange(range);
	            return;
	        }

	        this._mapColIndices(table);

	        row = td.parentNode;
	        rowIndex = dom.findNodeIndex(row, true);

	        if(td.rowSpan > 1 && position === "after") {
	            row = table.rows[rowIndex + td.rowSpan - 1];
	        }

	        cellCount = this._getNumberOfColumns(table);
	        newRow = row.cloneNode(true);
	        $(newRow).empty();

	        for (var i = 0; i < cellCount; i = i + cell.prop("colSpan")) {
	            cell = $(row).find("[col-index=" + i +"]");

	            if (cell.length) {
	                if(cell.prop("rowSpan") > 1 && position === "after" && cell) {
	                    cell.attr(ROWSPAN, cell.prop("rowSpan") + 1);
	                } else {
	                    this._appendCell(newRow, cell);
	                }
	            } else {
	                rowIndex = dom.findNodeIndex(row, true);
	                cell = this._findRowSpanCell(row.parentElement, rowIndex, i);
	                rowSpanIndex = cell.closest(TR).index();

	                if(rowSpanIndex + cell.prop("rowSpan") - 1 === rowIndex && position === "after") {
	                    this._appendCell(newRow, cell);
	                } else {
	                    cell.attr(ROWSPAN, cell.prop("rowSpan") + 1);
	                }
	            }

	            createdCell = $(newRow).find("[col-index=" + i +"]");
	            if(createdCell.attr(SCOPE) === ROWGROUP && !createdCell.attr(ROWSPAN)) {
	                createdCell.attr(SCOPE, ROW);
	            }
	        }

	        if (position == "before") {
	            dom.insertBefore(newRow, row);
	        } else {
	            dom.insertAfter(newRow, row);
	        }

	        if ($(table).find("[headers]").length > 0) {
	            this._associateHeaderIds(table);
	        }

	        this._clearColIndexAttr(table);
	        this.releaseRange(range);

	        this._resetTableResizing(this.editor);
	    },
	    _appendCell: function(row, cell){
	        var newCell;

	        newCell = cell.clone();
	        newCell.html(Editor.emptyTableCellContent);
	        newCell.removeAttr(ROWSPAN);
	        newCell.appendTo(row);
	    }
	});

	var InsertColumnCommand = TableModificationCommand.extend({
	    exec: function () {
	        var range = this.lockRange(true),
	            td = dom.closest(range.endContainer, [TD, TH]),
	            table = dom.closest(td, TABLE),
	            colElements = table.getElementsByTagName(COL),
	            colgroupElements = table.getElementsByTagName(COLGROUP),
	            columnIndex,
	            i,
	            rows = table && table.rows,
	            cell,
	            newCell,
	            position = this.options.position || "after";


	        if (!td || (this.immutables() && Editor.Immutables.immutableParent(td))) {
	            this.releaseRange(range);
	            return;
	        }

	        this._mapColIndices(table);

	        columnIndex = parseInt(td.getAttribute("col-index"),10);

	        if (td.colSpan > 1 && position === "after") {
	            td.setAttribute("col-index", columnIndex + td.colSpan - 1);
	            columnIndex = columnIndex + td.colSpan - 1;
	        }

	        for (i = 0; i < rows.length; i++) {
	            cell = this._processForColSpan(rows[i], columnIndex, position, td);

	            if (!cell){
	                continue;
	            }

	            newCell = cell.cloneNode();
	            newCell.innerHTML = Editor.emptyTableCellContent;
	            newCell.removeAttribute(COLSPAN);

	            if(newCell.getAttribute(SCOPE) && newCell.getAttribute(SCOPE) === COLGROUP) {
	                newCell.setAttribute(SCOPE, COL);
	            }

	            if (position == "before") {
	                dom.insertBefore(newCell, cell);
	            } else {
	                dom.insertAfter(newCell, cell);
	            }

	            this._resizeCells(newCell, cell);
	        }

	        if(colElements.length > 0 || colgroupElements.length > 0) {
	            this._adjustColgroups(rows[0], table);
	        }

	        if ($(table).find("[headers]").length > 0) {
	            this._associateHeaderIds(table);
	        }

	        this._clearColIndexAttr(table);
	        this.releaseRange(range);

	        this._resetTableResizing(this.editor);
	    },
	    _processForColSpan: function (row, columnIndex, position, selectedCell) {
	        var cell,
	            colSpanEffect,
	            index = columnIndex - 1;

	        cell = $(row).find("[col-index=" + columnIndex +"]")[0];

	        if (cell && cell.colSpan > 1 && position === "after" && cell !== selectedCell) {
	            cell.colSpan += 1;
	            return;
	        }

	        if (cell) {
	            return cell;
	        }

	        for (index; index >= 0; index--) {
	            cell = $(row).find("[col-index=" + index +"]")[0];

	            if(cell && cell.colSpan > 1) {
	                break;
	            }
	        }

	        if(!cell) {
	            return;
	        }

	        colSpanEffect = parseInt(cell.getAttribute("col-index"),10) + cell.colSpan - 1;

	        if(colSpanEffect === columnIndex && position === "after") {
	            return cell;
	        } else if (columnIndex <= colSpanEffect){
	            cell.setAttribute(COLSPAN, cell.colSpan + 1);
	        }
	    },
	    _resizeCells: function(newCell, cell) {
	        var width = newCell.style.width,
	        parsedWidth, unit, calculatedWidth;

	        if(!width) {
	            return;
	        }

	        parsedWidth = parseFloat(width);
	        unit = width.slice(parsedWidth.toString().length);
	        calculatedWidth = (parsedWidth / 2) + unit;

	        newCell.style.width = calculatedWidth;
	        cell.style.width = calculatedWidth;
	    }
	});

	var DeleteRowCommand = TableModificationCommand.extend({
	    exec: function () {
	        var range = this.lockRange();
	        var rows = RangeUtils.mapAll(range, function(node) {
	            return $(node).closest(TR)[0];
	        });
	        var td = dom.closest(range.endContainer, [TD, TH]);
	        var row = rows[0];
	        var rowSpan = td ? td.rowSpan : 1;
	        var rowIndex = $(rows[0]).index();
	        var table = dom.closest(row, TABLE);
	        var rowParent = row.parentElement;
	        var focusElement;

	        if (!table || (this.immutables() && Editor.Immutables.immutableParent(row))) {
	            this.releaseRange(range);
	            return;
	        }

	        for (var x = 0; x < rowSpan; x++) {
	            if(rows.indexOf(rowParent.rows[rowIndex + x]) < 0) {
	                rows.push(rowParent.rows[rowIndex + x]);
	            }
	        }

	        if (table.rows.length <= rows.length) {
	            focusElement = dom.next(table);
	            if (!focusElement || dom.insignificant(focusElement)) {
	                focusElement = dom.prev(table);
	            }

	            dom.remove(table);
	            this._resetTableResizing(this.editor);
	        } else if(rowParent.rows.length <= rows.length) {
	            focusElement = rowParent.nextSibling;

	            if(!focusElement) {
	                focusElement = rowParent.previousSibling;
	            }

	            dom.remove(rowParent);
	        } else {
	            this._mapColIndices(table);

	            for (var i = 0; i < rows.length; i++) {
	                row = rows[i];
	                dom.removeTextSiblings(row);
	                focusElement = dom.next(row) || dom.prev(row);
	                focusElement = focusElement.cells[0];

	                // IE needs to focus the new row before removing the old one
	                this._focusElement(range, focusElement);
	                focusElement = null;

	                this._handleRowSpanCells(table, row);

	                dom.remove(row);
	            }

	            this._clearColIndexAttr(table);
	        }

	        if ($(table).find("[headers]").length > 0) {
	            this._associateHeaderIds(table);
	        } else if (dom.is(rowParent, THEAD) && $(table).find("[scope]").length > 0) {
	            this._adjustColgroups(rowParent.rows[0], table);
	        }

	        if (focusElement) {
	            this._focusElement(range, focusElement);
	        }

	        this._resetTableResizing(this.editor);
	    },
	    _focusElement: function (range, node) {
	        range.setStart(node, 0);
	        range.collapse(true);
	        this.editor.selectRange(range);
	    },
	    _handleRowSpanCells: function (table, row) {
	        var index, cell, adjacentCell, nextRow, rowIndex = dom.findNodeIndex(row, true),
	            firstRow = table.rows[0],
	            lastCell = firstRow.cells[firstRow.cells.length - 1],
	            lastIndex = parseInt(lastCell.getAttribute("col-index"),10) + lastCell.colSpan - 1;

	        for (index = 0; index <= lastIndex; index = index + cell.prop("colSpan")) {
	            cell = $(row).find("[col-index=" + index + "]");

	            if(cell.length && cell.prop("rowSpan") > 1) {
	                nextRow = table.rows[rowIndex+1];
	                adjacentCell = $(nextRow).find("[col-index=" + (index + 1) + "]");

	                if(adjacentCell.length) {
	                    adjacentCell.before(cell);
	                } else {
	                    $(nextRow).append(cell);
	                }
	                this._reduceRowSpan(cell);
	            }

	            if(!cell.length) {
	                cell = this._findRowSpanCell(row.parentElement, rowIndex, index);
	                this._reduceRowSpan(cell);
	            }
	        }
	    },
	    _reduceRowSpan: function (td) {
	        var rowSpanValue = td.prop("rowSpan") - 1;

	        if(rowSpanValue <= 1) {
	            td.removeAttr(ROWSPAN);
	            if(td.attr(SCOPE) === ROWGROUP) {
	                td.attr(SCOPE, ROW);
	            }
	        } else {
	            td.attr(ROWSPAN, rowSpanValue);
	        }
	    }
	});

	var DeleteColumnCommand = TableModificationCommand.extend({
	    exec: function () {
	        var range = this.lockRange(),
	            td = dom.closest(range.endContainer, [TD, TH]),
	            table = dom.closest(td, TABLE),
	            rows = table && table.rows,
	            columnIndex = dom.findNodeIndex(td, true),
	            columnCount = rows && rows[0].cells.length,
	            colElements = table.getElementsByTagName(COL),
	            colgroupElements = table.getElementsByTagName(COLGROUP),
	            focusElement, i, cell, x;

	        if (!td || (this.immutables() && Editor.Immutables.immutableParent(td))) {
	            this.releaseRange(range);
	            return;
	        }

	        if (columnCount == 1 || td.colSpan == columnCount) {
	            focusElement = dom.next(table);
	            if (!focusElement || dom.insignificant(focusElement)) {
	                focusElement = dom.prev(table);
	            }

	            dom.remove(table);
	            this._resetTableResizing(this.editor);
	        } else {
	            dom.removeTextSiblings(td);

	            focusElement = dom.next(td) || dom.prev(td);

	            this._mapColIndices(table);

	            columnIndex = parseInt(td.getAttribute("col-index"), 10);

	            for (x = 0; x < td.colSpan; x++) {
	                for (i = 0; i < rows.length; i = i + (cell.prop("rowSpan") || 1)) {
	                    cell = $(rows[i]).find("[col-index=" + (columnIndex + x) + "]");

	                    if(cell.length && cell.prop("colSpan") <= 1) {
	                        cell.remove();
	                    } else {
	                        this._handleColSpanCells(rows[i], columnIndex + x);
	                    }
	                }
	            }

	            this._clearColIndexAttr(table);
	        }

	        if(colElements.length > 0 || colgroupElements.length > 0) {
	            this._adjustColgroups(rows[0], table);
	        }

	        if ($(table).find("[headers]").length > 0) {
	            this._associateHeaderIds(table);
	        }

	        if (focusElement) {
	            range.setStart(focusElement, 0);
	            range.collapse(true);
	            this.editor.selectRange(range);
	        }

	        this._resetTableResizing(this.editor);
	    },
	    _handleColSpanCells: function (row, colIndex) {
	        var cell = $(row).find("[col-index=" + colIndex + "]");

	        if(cell.length && cell.prop("colSpan") > 1) {
	            var clone = cell.clone(true);
	            cell.after(clone);
	            this._reduceColSpan(clone);
	            clone.attr("col-index", parseInt(cell.attr("col-index"),10) + 1);
	            cell.remove();
	            return;
	        }

	        for (var i = colIndex; i >= 0; i--) {
	            cell = $(row).find("[col-index=" + i + "]");

	            if(cell.length) {
	                this._reduceColSpan(cell);
	                cell.attr("col-index", parseInt(cell.attr("col-index"),10) + 1);
	                return;
	            }
	        }
	    },
	    _reduceColSpan: function (td) {
	        var colSpanValue = td.prop("colSpan") - 1;

	        if(colSpanValue <= 1) {
	            td.removeAttr(COLSPAN);
	            if(td.attr(SCOPE) === COLGROUP) {
	                td.attr(SCOPE, COL);
	            }
	        } else {
	            td.attr(COLSPAN, colSpanValue);
	        }
	    }
	});

	var MergeCellsHorizontallyCommand = TableModificationCommand.extend({
	    exec: function () {
	        var range = this.lockRange(),
	            td = dom.closest(range.endContainer, [TD, TH]),
	            table, row, columnIndex, nextTd, colspan;

	            if(!td) {
	                this.releaseRange(range);
	                return;
	            }

	            table = dom.closest(td, TABLE);
	            row = td.parentNode;
	            columnIndex = dom.findNodeIndex(td, true);
	            nextTd = row.children[columnIndex + 1];

	            if (this.immutables() && Editor.Immutables.immutableParent(td)) {
	                this.releaseRange(range);
	                return;
	            }

	            this._mapColIndices(table);

	            columnIndex = parseInt($(td).attr("col-index"), 10);
	            nextTd = $(row).find("[col-index=" + (columnIndex + 1 + this._getColspan(td) - 1) + "]").get(0);

	            if(!nextTd || nextTd.rowSpan !== td.rowSpan || td.tagName !== nextTd.tagName) {
	                this._clearColIndexAttr(table);
	                this.releaseRange(range);
	                return;
	            }

	            colspan = this._getColspan(td) + this._getColspan(nextTd);

	            $(td).prop(COLSPAN, colspan)
	                 .append(dom.emptyNode(nextTd) ? "" : "<br/>" + nextTd.innerHTML);

	            $(td).width(td.offsetWidth);
	            $(nextTd).remove();

	            if(td.getAttribute(SCOPE) === COL) {
	                td.setAttribute(SCOPE, COLGROUP);
	            }
	            if(td.getAttribute(SCOPE) === COLGROUP) {
	                this._adjustColgroups(row, table);
	            }

	            if ($(table).find("[headers]").length > 0) {
	                this._associateHeaderIds(table);
	            }

	            this._clearColIndexAttr(table);
	            this.releaseRange(range);
	            this._resetTableResizing(this.editor);
	    },
	    _getColspan: function (td) {
	        return parseInt(td.getAttribute(COLSPAN), 10) || 1;
	    }
	});

	var MergeCellsVerticallyCommand = TableModificationCommand.extend({
	    exec: function () {
	        var range = this.lockRange(),
	            td = dom.closest(range.endContainer, [TD, TH]),
	            tr, parent, table, columnIndex, rowIndex, targetRow,  bottomTd;

	            if(!td) {
	                this.releaseRange(range);
	                return;
	            }

	            tr = dom.closest(td, TR);
	            parent = dom.closest(td, [THEAD, TBODY]);
	            table = dom.closest(td, TABLE);
	            columnIndex = dom.findNodeIndex(td, true);
	            rowIndex = dom.findNodeIndex(tr, true);

	            if (rowIndex + 1 === parent.rows.length) {
	                this.releaseRange(range);
	                return;
	            }

	            targetRow = parent.rows[rowIndex + this._getRowspan(td)];
	            bottomTd = targetRow && targetRow.children[columnIndex];

	            if (this.immutables() && Editor.Immutables.immutableParent(td)) {
	                this.releaseRange(range);
	                return;
	            }

	            this._mapColIndices(table);

	            columnIndex = $(td).attr("col-index");
	            bottomTd = $(targetRow).find("[col-index=" + columnIndex + "]").get(0);

	            if(!bottomTd || bottomTd.colSpan !== td.colSpan || td.tagName !== bottomTd.tagName) {
	                this._clearColIndexAttr(table);
	                this.releaseRange(range);
	                return;
	            }

	            $(td).prop(ROWSPAN, this._getRowspan(td) + this._getRowspan(bottomTd))
	                 .append(dom.emptyNode(bottomTd) ? "" : "<br/>" + bottomTd.innerHTML);

	            if(td.getAttribute(SCOPE) === ROW) {
	                td.setAttribute(SCOPE, ROWGROUP);
	            }

	            $(bottomTd).remove();

	            if ($(table).find("[headers]").length > 0) {
	                this._associateHeaderIds(table);
	            }

	            this._clearColIndexAttr(table);
	            this.releaseRange(range);
	    },
	    _getRowspan: function (td) {
	        return parseInt(td.getAttribute(ROWSPAN), 10) || 1;
	    }
	});

	var SplitCellCommand = TableModificationCommand.extend({
	    exec: function () {
	        var range = this.lockRange(),
	            type = this.options.type,
	            attr = type === "row" ? COLSPAN : ROWSPAN,
	            td = dom.closest(range.endContainer, [TD, TH]),
	            parent = dom.closest(td, [THEAD, TBODY]),
	            table = dom.closest(td, TABLE),
	            emptyTd = dom.createEmptyNode(this.editor.document, td.nodeName.toLowerCase());

	        if (!td || (this.immutables() && Editor.Immutables.immutableParent(td))) {
	            this.releaseRange(range);
	            return;
	        }

	        this._mapColIndices(table);

	        if(type === "row" && $(td).is("[" + attr + "]")) {
	            this._splitCellHorizontally(td, parent, attr, emptyTd);
	        } else if (type === "column" && $(td).is("[" + attr + "]")){
	            this._splitCellVertically(td, parent, attr, emptyTd);
	        }

	        if($(td).prop(attr.toLowerCase()) <= 1) {
	            $(td).removeAttr(attr);
	        }

	        if ($(table).find("[headers]").length > 0) {
	            this._associateHeaderIds(table);
	        }

	        this._clearColIndexAttr(table);
	        this.releaseRange(range);
	    },
	    _getRowspanValue: function (td) {
	        return parseInt(td.getAttribute(ROWSPAN), 10);
	    },
	    _getColspanValue: function (td) {
	        return parseInt(td.getAttribute(COLSPAN), 10);
	    },
	    _splitCellHorizontally: function (td, parent, attr, emptyTd) {
	        var rowSpan = td.rowSpan,
	            colSpan = td.colSpan,
	            tdToAdd = $(emptyTd),
	            colSpanResult = Math.floor(colSpan/2);

	            if(colSpanResult > 1) {
	                tdToAdd.attr(COLSPAN, colSpanResult);
	            }

	            if(rowSpan > 1) {
	                tdToAdd.attr(ROWSPAN, rowSpan);
	            }

	            $(td).prop(attr, colSpan - colSpanResult)
	                .after(tdToAdd);

	            $(td).width(td.offsetWidth);
	            tdToAdd.width(tdToAdd[0].offsetWidth);

	            if(td.hasAttribute(SCOPE)) {
	                if(td.getAttribute(SCOPE) === COLGROUP) {
	                    tdToAdd.attr(SCOPE, COL);
	                    if(!td.getAttribute(COLSPAN) || td.getAttribute(COLSPAN) === "1") {
	                        td.setAttribute(SCOPE, COL);
	                    }

	                    this._adjustColgroups(td.parentNode, parent.parentNode);
	                } else {
	                    tdToAdd.attr(SCOPE, td.getAttribute(SCOPE));
	                }
	            }
	    },
	    _splitCellVertically: function (td, parent, attr, emptyTd) {
	        var tr = dom.closest(td,TR),
	            columnIndex = parseInt($(td).attr("col-index"), 10),
	            rowIndex = dom.findNodeIndex(tr, true),
	            rowSpan = td.rowSpan,
	            colSpan = td.colSpan,
	            rowSpanResult = Math.floor(rowSpan/2),
	            targetRow = $(parent).find(TR).eq(rowIndex + rowSpan - rowSpanResult),
	            nextTd = this._findNextTdInRow(targetRow, columnIndex + colSpan),
	            tdToAdd = $(emptyTd);

	            if(rowSpanResult > 1) {
	                tdToAdd.attr(ROWSPAN, rowSpanResult);
	            }
	            if(colSpan > 1) {
	                tdToAdd.attr(COLSPAN, colSpan);
	            }

	            if(nextTd && nextTd.length) {
	                nextTd.before(tdToAdd);
	            } else {
	                targetRow.append(tdToAdd);
	            }

	            $(td).prop(attr, rowSpan - rowSpanResult);

	            if(td.hasAttribute(SCOPE)) {
	                if(td.getAttribute(SCOPE) === ROWGROUP) {
	                    tdToAdd.attr(SCOPE, ROW);
	                    if(!td.getAttribute(ROWSPAN) || td.getAttribute(ROWSPAN) === "1"){
	                        td.setAttribute(SCOPE, ROW);
	                    }
	                } else {
	                    tdToAdd.attr(SCOPE, td.getAttribute(SCOPE));
	                }
	            }
	    }
	});

	var TableModificationTool = Tool.extend({
	    command: function (options) {
	        var commandsMap = {
	            row: {
	                insert: InsertRowCommand,
	                "delete": DeleteRowCommand,
	                merge: MergeCellsHorizontallyCommand,
	                split: SplitCellCommand
	            },
	            column: {
	                insert: InsertColumnCommand,
	                "delete": DeleteColumnCommand,
	                merge: MergeCellsVerticallyCommand,
	                split: SplitCellCommand
	            }
	        };

	        options = extend(options, this.options);
	        options.action = options.action || "insert";

	        return new commandsMap[options.type][options.action](options);
	    },

	    initialize: function(ui, options) {
	        Tool.fn.initialize.call(this, ui, options);
	        ui.addClass("k-state-disabled");
	        ui.attr("disabled", "disabled");
	    },

	    update: function(ui, nodes) {
	        var isFormatted = !tableFormatFinder.isFormatted(nodes);

	        if (isFormatted === true) {
	            ui.parent().addClass("k-hidden k-state-disabled");
	            ui.attr("disabled", "disabled");
	            ui.addClass("k-state-disabled");
	        } else {
	            ui.parent().removeClass("k-hidden k-state-disabled");
	            ui.removeAttr("disabled");
	            ui.removeClass("k-state-disabled");
	        }
	    }
	});

	extend(kendo.ui.editor, {
	    PopupTool: PopupTool,
	    TableCommand: TableCommand,
	    InsertTableTool: InsertTableTool,
	    TableModificationTool: TableModificationTool,
	    InsertRowCommand: InsertRowCommand,
	    InsertColumnCommand: InsertColumnCommand,
	    DeleteRowCommand: DeleteRowCommand,
	    DeleteColumnCommand: DeleteColumnCommand,
	    MergeCellsHorizontallyCommand: MergeCellsHorizontallyCommand,
	    MergeCellsVerticallyCommand: MergeCellsVerticallyCommand,
	    SplitCellCommand: SplitCellCommand
	});

	registerTool("createTable", new InsertTableTool({ template: new ToolTemplate({template: EditorUtils.buttonTemplate, popup: true, title: "Create table"})}));

	registerTool("addColumnLeft", new TableModificationTool({ type: "column", position: "before", template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Add column on the left"})}));
	registerTool("addColumnRight", new TableModificationTool({ type: "column", template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Add column on the right"})}));
	registerTool("addRowAbove", new TableModificationTool({ type: "row", position: "before", template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Add row above"})}));
	registerTool("addRowBelow", new TableModificationTool({ type: "row", template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Add row below"})}));
	registerTool("deleteRow", new TableModificationTool({ type: "row", action: "delete", template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Delete row"})}));
	registerTool("deleteColumn", new TableModificationTool({ type: "column", action: "delete", template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Delete column"})}));
	registerTool("mergeCellsHorizontally", new TableModificationTool({type: "row", action: "merge", template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Merge Cell Right"})}));
	registerTool("mergeCellsVertically", new TableModificationTool({type: "column", action: "merge", template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Merge Cell Down"})}));
	registerTool("splitCellHorizontally", new TableModificationTool({type: "row", action: "split", template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Split Cell"})}));
	registerTool("splitCellVertically", new TableModificationTool({type: "column", action: "split", template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Split Cell"})}));

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 997:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("sWXg");

/***/ })

/******/ });

/***/ }),

/***/ "LE8v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var toolPanelGroupComp_1 = __webpack_require__("HF1M");
var toolPanelColumnComp_1 = __webpack_require__("V1aE");
var ColumnSelectComp = (function (_super) {
    __extends(ColumnSelectComp, _super);
    // we allow dragging in the toolPanel, but not when this component appears in the column menu
    function ColumnSelectComp(allowDragging) {
        var _this = _super.call(this, ColumnSelectComp.TEMPLATE) || this;
        _this.allowDragging = allowDragging;
        return _this;
    }
    ColumnSelectComp.prototype.init = function () {
        this.addDestroyableEventListener(this.globalEventService, main_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.onColumnsChanged.bind(this));
        if (this.columnController.isReady()) {
            this.onColumnsChanged();
        }
    };
    ColumnSelectComp.prototype.onColumnsChanged = function () {
        this.destroyAllRenderedElements();
        this.columnTree = this.columnController.getPrimaryColumnTree();
        this.recursivelyRenderComponents(this.columnTree, 0);
    };
    ColumnSelectComp.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.destroyAllRenderedElements();
    };
    ColumnSelectComp.prototype.destroyAllRenderedElements = function () {
        main_1.Utils.removeAllChildren(this.getGui());
        if (this.renderedItems) {
            main_1.Utils.iterateObject(this.renderedItems, function (key, renderedItem) { return renderedItem.destroy(); });
        }
        this.renderedItems = {};
    };
    ColumnSelectComp.prototype.recursivelyRenderGroupComponent = function (columnGroup, dept) {
        // only render group if user provided the definition
        var newDept;
        if (columnGroup.getColGroupDef() && columnGroup.getColGroupDef().suppressToolPanel) {
            return;
        }
        if (!columnGroup.isPadding()) {
            var renderedGroup = new toolPanelGroupComp_1.ToolPanelGroupComp(columnGroup, dept, this.onGroupExpanded.bind(this), this.allowDragging);
            this.context.wireBean(renderedGroup);
            this.appendChild(renderedGroup.getGui());
            // we want to indent on the gui for the children
            newDept = dept + 1;
            this.renderedItems[columnGroup.getId()] = renderedGroup;
        }
        else {
            // no children, so no indent
            newDept = dept;
        }
        this.recursivelyRenderComponents(columnGroup.getChildren(), newDept);
    };
    ColumnSelectComp.prototype.recursivelyRenderColumnComponent = function (column, dept) {
        if (column.getColDef() && column.getColDef().suppressToolPanel) {
            return;
        }
        var renderedColumn = new toolPanelColumnComp_1.ToolPanelColumnComp(column, dept, this.allowDragging);
        this.context.wireBean(renderedColumn);
        this.appendChild(renderedColumn.getGui());
        this.renderedItems[column.getId()] = renderedColumn;
    };
    ColumnSelectComp.prototype.recursivelyRenderComponents = function (tree, dept) {
        var _this = this;
        tree.forEach(function (child) {
            if (child instanceof main_1.OriginalColumnGroup) {
                _this.recursivelyRenderGroupComponent(child, dept);
            }
            else {
                _this.recursivelyRenderColumnComponent(child, dept);
            }
        });
    };
    ColumnSelectComp.prototype.recursivelySetVisibility = function (columnTree, visible) {
        var _this = this;
        columnTree.forEach(function (child) {
            var component = _this.renderedItems[child.getId()];
            if (component) {
                component.setVisible(visible);
            }
            if (child instanceof main_1.OriginalColumnGroup) {
                var columnGroup = child;
                var newVisible = void 0;
                if (component) {
                    var expanded = component.isExpanded();
                    newVisible = visible ? expanded : false;
                }
                else {
                    newVisible = visible;
                }
                var newChildren = columnGroup.getChildren();
                _this.recursivelySetVisibility(newChildren, newVisible);
            }
        });
    };
    ColumnSelectComp.prototype.onGroupExpanded = function () {
        this.recursivelySetVisibility(this.columnTree, true);
    };
    ColumnSelectComp.TEMPLATE = '<div class="ag-column-select-panel"></div>';
    __decorate([
        main_1.Autowired('columnController'),
        __metadata("design:type", main_1.ColumnController)
    ], ColumnSelectComp.prototype, "columnController", void 0);
    __decorate([
        main_1.Autowired('eventService'),
        __metadata("design:type", main_1.EventService)
    ], ColumnSelectComp.prototype, "globalEventService", void 0);
    __decorate([
        main_1.Autowired('context'),
        __metadata("design:type", main_1.Context)
    ], ColumnSelectComp.prototype, "context", void 0);
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ColumnSelectComp.prototype, "init", null);
    return ColumnSelectComp;
}(main_1.Component));
exports.ColumnSelectComp = ColumnSelectComp;


/***/ }),

/***/ "LGr7":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(942);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 942:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(943) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {

	    // Imports ================================================================
	    var kendo = window.kendo,
	        ui = kendo.dataviz.ui,
	        deepExtend = kendo.deepExtend;

	    // Constants ==============================================================
	    var BLACK = "#000",
	        SANS = "Arial,Helvetica,sans-serif",
	        SANS12 = "12px " + SANS,
	        WHITE = "#fff";

	    var chartBaseTheme = kendo.dataviz.chartBaseTheme({
	        gradients: true
	    });

	    var gaugeBaseTheme = {
	        scale: {
	            labels: {
	                font: SANS12
	            }
	        }
	    };

	    var diagramBaseTheme = {
	        shapeDefaults: {
	            hover: {
	                opacity: 0.2
	            },
	            stroke: {
	                width: 0
	            }
	        },
	        editable: {
	            resize: {
	                handles: {
	                    width: 7,
	                    height: 7
	                }
	            }
	        },
	        selectable: {
	            stroke: {
	                width: 1,
	                dashType: "dot"
	            }
	        },
	        connectionDefaults: {
	            stroke: {
	                width: 2
	            },
	            selection: {
	                handles: {
	                    width: 8,
	                    height: 8
	                }
	            },
	            editable: {
	                tools: ["edit", "delete"]
	            }
	        }
	    };

	    var themes = ui.themes,
	        registerTheme = ui.registerTheme = function(themeName, options) {
	            var result = {};
	            // Apply base theme
	            result.chart = deepExtend({}, chartBaseTheme, options.chart);
	            result.gauge = deepExtend({}, gaugeBaseTheme, options.gauge);
	            result.diagram = deepExtend({}, diagramBaseTheme, options.diagram);
	            result.treeMap = deepExtend({}, options.treeMap);

	            // Copy the line/area chart settings for their vertical counterparts
	            var defaults = result.chart.seriesDefaults;
	            defaults.verticalLine = deepExtend({}, defaults.line);
	            defaults.verticalArea = deepExtend({}, defaults.area);
	            defaults.rangeArea = deepExtend({}, defaults.area);
	            defaults.verticalRangeArea = deepExtend({}, defaults.rangeArea);
	            defaults.verticalBoxPlot = deepExtend({}, defaults.boxPlot);
	            defaults.polarArea = deepExtend({}, defaults.radarArea);
	            defaults.polarLine = deepExtend({}, defaults.radarLine);

	            themes[themeName] = result;
	        };

	    registerTheme("black", {
	        chart: {
	            title: {
	                color: WHITE
	            },
	            legend: {
	                labels: {
	                    color: WHITE
	                },
	                inactiveItems: {
	                    labels: {
	                        color: "#919191"
	                    },
	                    markers: {
	                        color: "#919191"
	                    }
	                }
	            },
	            seriesDefaults: {
	                labels: {
	                    color: WHITE
	                },
	                errorBars: {
	                    color: WHITE
	                },
	                notes: {
	                    icon: {
	                        background: "#3b3b3b",
	                        border: {
	                            color: "#8e8e8e"
	                        }
	                    },
	                    label: {
	                        color: WHITE
	                    },
	                    line: {
	                        color: "#8e8e8e"
	                    }
	                },
	                pie: {
	                    overlay: {
	                        gradient: "sharpBevel"
	                    }
	                },
	                donut: {
	                    overlay: {
	                        gradient: "sharpGlass"
	                    }
	                },
	                line: {
	                    markers: {
	                        background: "#3d3d3d"
	                    }
	                },
	                scatter: {
	                    markers: {
	                        background: "#3d3d3d"
	                    }
	                },
	                scatterLine: {
	                    markers: {
	                        background: "#3d3d3d"
	                    }
	                },
	                waterfall: {
	                    line: {
	                        color: "#8e8e8e"
	                    }
	                },
	                horizontalWaterfall: {
	                    line: {
	                        color: "#8e8e8e"
	                    }
	                },
	                candlestick: {
	                    downColor: "#555",
	                    line: {
	                        color: WHITE
	                    },
	                    border: {
	                        _brightness: 1.5,
	                        opacity: 1
	                    },
	                    highlight: {
	                        border: {
	                            color: WHITE,
	                            opacity: 0.2
	                        }
	                    }
	                },
	                ohlc: {
	                    line: {
	                        color: WHITE
	                    }
	                }
	            },
	            chartArea: {
	                background: "#3d3d3d"
	            },
	            seriesColors: ["#0081da", "#3aafff", "#99c900", "#ffeb3d", "#b20753", "#ff4195"],
	            axisDefaults: {
	                line: {
	                    color: "#8e8e8e"
	                },
	                labels: {
	                    color: WHITE
	                },
	                majorGridLines: {
	                    color: "#545454"
	                },
	                minorGridLines: {
	                    color: "#454545"
	                },
	                title: {
	                    color: WHITE
	                },
	                crosshair: {
	                    color: "#8e8e8e"
	                },
	                notes: {
	                    icon: {
	                        background: "#3b3b3b",
	                        border: {
	                            color: "#8e8e8e"
	                        }
	                    },
	                    label: {
	                        color: WHITE
	                    },
	                    line: {
	                        color: "#8e8e8e"
	                    }
	                }
	            }
	        },
	        gauge: {
	            pointer: {
	                color: "#0070e4"
	            },
	            scale: {
	                rangePlaceholderColor: "#1d1d1d",
	                labels: {
	                    color: WHITE
	                },
	                minorTicks: {
	                    color: WHITE
	                },
	                majorTicks: {
	                    color: WHITE
	                },
	                line: {
	                    color: WHITE
	                }
	            }
	        },
	        diagram: {
	            shapeDefaults: {
	                fill: {
	                    color: "#0066cc"
	                },
	                connectorDefaults: {
	                    fill: {
	                        color: WHITE
	                    },
	                    stroke: {
	                        color: "#384049"
	                    },
	                    hover: {
	                        fill: {
	                            color: "#3d3d3d"
	                        },
	                        stroke: {
	                            color: "#efefef"
	                        }
	                    }
	                },
	                content: {
	                    color: WHITE
	                }
	            },
	            editable: {
	                resize: {
	                    handles: {
	                        fill: {
	                            color: "#3d3d3d"
	                        },
	                        stroke: {
	                            color: WHITE
	                        },
	                        hover: {
	                            fill: {
	                                color: WHITE
	                            },
	                            stroke: {
	                                color: WHITE
	                            }
	                        }
	                    }
	                },
	                rotate: {
	                    thumb: {
	                        stroke: {
	                            color: WHITE
	                        },
	                        fill: {
	                            color: WHITE
	                        }
	                    }
	                }
	            },
	            selectable: {
	                stroke: {
	                    color: WHITE
	                }
	            },
	            connectionDefaults: {
	                stroke: {
	                    color: WHITE
	                },
	                content: {
	                    color: WHITE
	                },
	                selection: {
	                    handles: {
	                        fill: {
	                            color: "#3d3d3d"
	                        },
	                        stroke: {
	                            color: "#efefef"
	                        }
	                    }
	                }
	            }
	        },
	        treeMap: {
	            colors: [
	                ["#0081da", "#314b5c"],
	                ["#3aafff", "#3c5464"],
	                ["#99c900", "#4f5931"],
	                ["#ffeb3d", "#64603d"],
	                ["#b20753", "#543241"],
	                ["#ff4195", "#643e4f"]]
	        }
	    });

	    registerTheme("blueopal", {
	        chart: {
	            title: {
	                color: "#293135"
	            },
	            legend: {
	                labels: {
	                    color: "#293135"
	                },
	                inactiveItems: {
	                    labels: {
	                        color: "#27A5BA"
	                    },
	                    markers: {
	                        color: "#27A5BA"
	                    }
	                }
	            },
	            seriesDefaults: {
	                labels: {
	                    color: BLACK,
	                    background: WHITE,
	                    opacity: 0.5
	                },
	                errorBars: {
	                    color: "#293135"
	                },
	                candlestick: {
	                    downColor: "#c4d0d5",
	                    line: {
	                        color: "#9aabb2"
	                    }
	                },
	                waterfall: {
	                    line: {
	                        color: "#9aabb2"
	                    }
	                },
	                horizontalWaterfall: {
	                    line: {
	                        color: "#9aabb2"
	                    }
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#9aabb2"
	                        }
	                    },
	                    label: {
	                        color: "#293135"
	                    },
	                    line: {
	                        color: "#9aabb2"
	                    }
	                }
	            },
	            seriesColors: ["#0069a5", "#0098ee", "#7bd2f6", "#ffb800", "#ff8517", "#e34a00"],
	            axisDefaults: {
	                line: {
	                    color: "#9aabb2"
	                },
	                labels: {
	                    color: "#293135"
	                },
	                majorGridLines: {
	                    color: "#c4d0d5"
	                },
	                minorGridLines: {
	                    color: "#edf1f2"
	                },
	                title: {
	                    color: "#293135"
	                },
	                crosshair: {
	                    color: "#9aabb2"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#9aabb2"
	                        }
	                    },
	                    label: {
	                        color: "#293135"
	                    },
	                    line: {
	                        color: "#9aabb2"
	                    }
	                }
	            }
	        },
	        gauge: {
	            pointer: {
	                color: "#005c83"
	            },
	            scale: {
	                rangePlaceholderColor: "#daecf4",

	                labels: {
	                    color: "#293135"
	                },
	                minorTicks: {
	                    color: "#293135"
	                },
	                majorTicks: {
	                    color: "#293135"
	                },
	                line: {
	                    color: "#293135"
	                }
	            }
	        },
	        diagram: {
	            shapeDefaults: {
	                fill: {
	                    color: "#7ec6e3"
	                },
	                connectorDefaults: {
	                    fill: {
	                        color: "#003f59"
	                    },
	                    stroke: {
	                        color: WHITE
	                    },
	                    hover: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#003f59"
	                        }
	                    }
	                },
	                content: {
	                    color: "#293135"
	                }
	            },
	            editable: {
	                resize: {
	                    handles: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#003f59"
	                        },
	                        hover: {
	                            fill: {
	                                color: "#003f59"
	                            },
	                            stroke: {
	                                color: "#003f59"
	                            }
	                        }
	                    }
	                },
	                rotate: {
	                    thumb: {
	                        stroke: {
	                            color: "#003f59"
	                        },
	                        fill: {
	                            color: "#003f59"
	                        }
	                    }
	                }
	            },
	            selectable: {
	                stroke: {
	                    color: "#003f59"
	                }
	            },
	            connectionDefaults: {
	                stroke: {
	                    color: "#003f59"
	                },
	                content: {
	                    color: "#293135"
	                },
	                selection: {
	                    handles: {
	                        fill: {
	                            color: "#3d3d3d"
	                        },
	                        stroke: {
	                            color: "#efefef"
	                        }
	                    }
	                }
	            }
	        },
	        treeMap: {
	            colors: [
	                ["#0069a5", "#bad7e7"],
	                ["#0098ee", "#b9e0f5"],
	                ["#7bd2f6", "#ceeaf6"],
	                ["#ffb800", "#e6e3c4"],
	                ["#ff8517", "#e4d8c8"],
	                ["#e34a00", "#ddccc2"]
	            ]
	        }
	    });

	    registerTheme("highcontrast", {
	        chart: {
	            title: {
	                color: "#ffffff"
	            },
	            legend: {
	                labels: {
	                    color: "#ffffff"
	                },
	                inactiveItems: {
	                    labels: {
	                        color: "#66465B"
	                    },
	                    markers: {
	                        color: "#66465B"
	                    }
	                }
	            },
	            seriesDefaults: {
	                labels: {
	                    color: "#ffffff"
	                },
	                errorBars: {
	                    color: "#ffffff"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#ffffff"
	                        }
	                    },
	                    label: {
	                        color: "#ffffff"
	                    },
	                    line: {
	                        color: "#ffffff"
	                    }
	                },
	                pie: {
	                    overlay: {
	                        gradient: "sharpGlass"
	                    }
	                },
	                donut: {
	                    overlay: {
	                        gradient: "sharpGlass"
	                    }
	                },
	                line: {
	                    markers: {
	                        background: "#2c232b"
	                    }
	                },
	                scatter: {
	                    markers: {
	                        background: "#2c232b"
	                    }
	                },
	                scatterLine: {
	                    markers: {
	                        background: "#2c232b"
	                    }
	                },
	                area: {
	                    opacity: 0.5
	                },
	                waterfall: {
	                    line: {
	                        color: "#ffffff"
	                    }
	                },
	                horizontalWaterfall: {
	                    line: {
	                        color: "#ffffff"
	                    }
	                },
	                candlestick: {
	                    downColor: "#664e62",
	                    line: {
	                        color: "#ffffff"
	                    },
	                    border: {
	                        _brightness: 1.5,
	                        opacity: 1
	                    },
	                    highlight: {
	                        border: {
	                            color: "#ffffff",
	                            opacity: 1
	                        }
	                    }
	                },
	                ohlc: {
	                    line: {
	                        color: "#ffffff"
	                    }
	                }
	            },
	            chartArea: {
	                background: "#2c232b"
	            },
	            seriesColors: ["#a7008f", "#ffb800", "#3aafff", "#99c900", "#b20753", "#ff4195"],
	            axisDefaults: {
	                line: {
	                    color: "#ffffff"
	                },
	                labels: {
	                    color: "#ffffff"
	                },
	                majorGridLines: {
	                    color: "#664e62"
	                },
	                minorGridLines: {
	                    color: "#4f394b"
	                },
	                title: {
	                    color: "#ffffff"
	                },
	                crosshair: {
	                    color: "#ffffff"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#ffffff"
	                        }
	                    },
	                    label: {
	                        color: "#ffffff"
	                    },
	                    line: {
	                        color: "#ffffff"
	                    }
	                }
	            }
	        },
	        gauge: {
	            pointer: {
	                color: "#a7008f"
	            },
	            scale: {
	                rangePlaceholderColor: "#2c232b",

	                labels: {
	                    color: "#ffffff"
	                },
	                minorTicks: {
	                    color: "#2c232b"
	                },
	                majorTicks: {
	                    color: "#664e62"
	                },
	                line: {
	                    color: "#ffffff"
	                }
	            }
	        },
	        diagram: {
	            shapeDefaults: {
	                fill: {
	                    color: "#a7018f"
	                },
	                connectorDefaults: {
	                    fill: {
	                        color: WHITE
	                    },
	                    stroke: {
	                        color: "#2c232b"
	                    },
	                    hover: {
	                        fill: {
	                            color: "#2c232b"
	                        },
	                        stroke: {
	                            color: WHITE
	                        }
	                    }
	                },
	                content: {
	                    color: WHITE
	                }
	            },
	            editable: {
	                resize: {
	                    handles: {
	                        fill: {
	                            color: "#2c232b"
	                        },
	                        stroke: {
	                            color: WHITE
	                        },
	                        hover: {
	                            fill: {
	                                color: WHITE
	                            },
	                            stroke: {
	                                color: WHITE
	                            }
	                        }
	                    }
	                },
	                rotate: {
	                    thumb: {
	                        stroke: {
	                            color: WHITE
	                        },
	                        fill: {
	                            color: WHITE
	                        }
	                    }
	                }
	            },
	            selectable: {
	                stroke: {
	                    color: WHITE
	                }
	            },
	            connectionDefaults: {
	                stroke: {
	                    color: WHITE
	                },
	                content: {
	                    color: WHITE
	                },
	                selection: {
	                    handles: {
	                        fill: {
	                            color: "#2c232b"
	                        },
	                        stroke: {
	                            color: WHITE
	                        }
	                    }
	                }
	            }
	        },
	        treeMap: {
	            colors: [
	                ["#a7008f", "#451c3f"],
	                ["#ffb800", "#564122"],
	                ["#3aafff", "#2f3f55"],
	                ["#99c900", "#424422"],
	                ["#b20753", "#471d33"],
	                ["#ff4195", "#562940"]
	            ]
	        }
	    });

	    registerTheme("default", {
	        chart: {
	            title: {
	                color: "#8e8e8e"
	            },
	            legend: {
	                labels: {
	                    color: "#232323"
	                },
	                inactiveItems: {
	                    labels: {
	                        color: "#919191"
	                    },
	                    markers: {
	                        color: "#919191"
	                    }
	                }
	            },
	            seriesDefaults: {
	                labels: {
	                    color: BLACK,
	                    background: WHITE,
	                    opacity: 0.5
	                },
	                errorBars: {
	                    color: "#232323"
	                },
	                candlestick: {
	                    downColor: "#dedede",
	                    line: {
	                        color: "#8d8d8d"
	                    }
	                },
	                waterfall: {
	                    line: {
	                        color: "#8e8e8e"
	                    }
	                },
	                horizontalWaterfall: {
	                    line: {
	                        color: "#8e8e8e"
	                    }
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#8e8e8e"
	                        }
	                    },
	                    label: {
	                        color: "#232323"
	                    },
	                    line: {
	                        color: "#8e8e8e"
	                    }
	                }
	            },
	            seriesColors: ["#ff6800", "#a0a700", "#ff8d00", "#678900", "#ffb53c", "#396000"],
	            axisDefaults: {
	                line: {
	                    color: "#8e8e8e"
	                },
	                labels: {
	                    color: "#232323"
	                },
	                minorGridLines: {
	                    color: "#f0f0f0"
	                },
	                majorGridLines: {
	                    color: "#dfdfdf"
	                },
	                title: {
	                    color: "#232323"
	                },
	                crosshair: {
	                    color: "#8e8e8e"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#8e8e8e"
	                        }
	                    },
	                    label: {
	                        color: "#232323"
	                    },
	                    line: {
	                        color: "#8e8e8e"
	                    }
	                }
	            }
	        },
	        gauge: {
	            pointer: {
	                color: "#ea7001"
	            },
	            scale: {
	                rangePlaceholderColor: "#dedede",

	                labels: {
	                    color: "#2e2e2e"
	                },
	                minorTicks: {
	                    color: "#2e2e2e"
	                },
	                majorTicks: {
	                    color: "#2e2e2e"
	                },
	                line: {
	                    color: "#2e2e2e"
	                }
	            }
	        },
	        diagram: {
	            shapeDefaults: {
	                fill: {
	                    color: "#e15613"
	                },
	                connectorDefaults: {
	                    fill: {
	                        color: "#282828"
	                    },
	                    stroke: {
	                        color: WHITE
	                    },
	                    hover: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#282828"
	                        }
	                    }
	                },
	                content: {
	                    color: "#2e2e2e"
	                }
	            },
	            editable: {
	                resize: {
	                    handles: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#282828"
	                        },
	                        hover: {
	                            fill: {
	                                color: "#282828"
	                            },
	                            stroke: {
	                                color: "#282828"
	                            }
	                        }
	                    }
	                },
	                rotate: {
	                    thumb: {
	                        stroke: {
	                            color: "#282828"
	                        },
	                        fill: {
	                            color: "#282828"
	                        }
	                    }
	                }
	            },
	            selectable: {
	                stroke: {
	                    color: "#a7018f"
	                }
	            },
	            connectionDefaults: {
	                stroke: {
	                    color: "#282828"
	                },
	                content: {
	                    color: "#2e2e2e"
	                },
	                selection: {
	                    handles: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#282828"
	                        }
	                    }
	                }
	            }
	        },
	        treeMap: {
	            colors: [
	                ["#ff6800", "#edcfba"],
	                ["#a0a700", "#dadcba"],
	                ["#ff8d00", "#edd7ba"],
	                ["#678900", "#cfd6ba"],
	                ["#ffb53c", "#eddfc6"],
	                ["#396000", "#c6ceba"]
	            ]
	        }
	    });

	    registerTheme("silver", {
	        chart: {
	            title: {
	                color: "#4e5968"
	            },
	            legend: {
	                labels: {
	                    color: "#4e5968"
	                },
	                inactiveItems: {
	                    labels: {
	                        color: "#B1BCC8"
	                    },
	                    markers: {
	                        color: "#B1BCC8"
	                    }
	                }
	            },
	            seriesDefaults: {
	                labels: {
	                    color: "#293135",
	                    background: "#eaeaec",
	                    opacity: 0.5
	                },
	                errorBars: {
	                    color: "#4e5968"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#4e5968"
	                        }
	                    },
	                    label: {
	                        color: "#4e5968"
	                    },
	                    line: {
	                        color: "#4e5968"
	                    }
	                },
	                line: {
	                    markers: {
	                        background: "#eaeaec"
	                    }
	                },
	                scatter: {
	                    markers: {
	                        background: "#eaeaec"
	                    }
	                },
	                scatterLine: {
	                    markers: {
	                        background: "#eaeaec"
	                    }
	                },
	                pie: {
	                    connectors: {
	                        color: "#A6B1C0"
	                    }
	                },
	                donut: {
	                    connectors: {
	                        color: "#A6B1C0"
	                    }
	                },
	                waterfall: {
	                    line: {
	                        color: "#a6b1c0"
	                    }
	                },
	                horizontalWaterfall: {
	                    line: {
	                        color: "#a6b1c0"
	                    }
	                },
	                candlestick: {
	                    downColor: "#a6afbe"
	                }
	            },
	            chartArea: {
	                background: "#eaeaec"
	            },
	            seriesColors: ["#007bc3", "#76b800", "#ffae00", "#ef4c00", "#a419b7", "#430B62"],
	            axisDefaults: {
	                line: {
	                    color: "#a6b1c0"
	                },
	                labels: {
	                    color: "#4e5968"
	                },
	                majorGridLines: {
	                    color: "#dcdcdf"
	                },
	                minorGridLines: {
	                    color: "#eeeeef"
	                },
	                title: {
	                    color: "#4e5968"
	                },
	                crosshair: {
	                    color: "#a6b1c0"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#4e5968"
	                        }
	                    },
	                    label: {
	                        color: "#4e5968"
	                    },
	                    line: {
	                        color: "#4e5968"
	                    }
	                }
	            }
	        },
	        gauge: {
	            pointer: {
	                color: "#0879c0"
	            },
	            scale: {
	                rangePlaceholderColor: "#f3f3f4",

	                labels: {
	                    color: "#515967"
	                },
	                minorTicks: {
	                    color: "#515967"
	                },
	                majorTicks: {
	                    color: "#515967"
	                },
	                line: {
	                    color: "#515967"
	                }
	            }
	        },
	        diagram: {
	            shapeDefaults: {
	                fill: {
	                    color: "#1c82c2"
	                },
	                connectorDefaults: {
	                    fill: {
	                        color: "#515967"
	                    },
	                    stroke: {
	                        color: WHITE
	                    },
	                    hover: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#282828"
	                        }
	                    }
	                },
	                content: {
	                    color: "#515967"
	                }
	            },
	            editable: {
	                resize: {
	                    handles: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#515967"
	                        },
	                        hover: {
	                            fill: {
	                                color: "#515967"
	                            },
	                            stroke: {
	                                color: "#515967"
	                            }
	                        }
	                    }
	                },
	                rotate: {
	                    thumb: {
	                        stroke: {
	                            color: "#515967"
	                        },
	                        fill: {
	                            color: "#515967"
	                        }
	                    }
	                }
	            },
	            selectable: {
	                stroke: {
	                    color: "#515967"
	                }
	            },
	            connectionDefaults: {
	                stroke: {
	                    color: "#515967"
	                },
	                content: {
	                    color: "#515967"
	                },
	                selection: {
	                    handles: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#515967"
	                        }
	                    }
	                }
	            }
	        },
	        treeMap: {
	            colors: [
	                ["#007bc3", "#c2dbea"],
	                ["#76b800", "#dae7c3"],
	                ["#ffae00", "#f5e5c3"],
	                ["#ef4c00", "#f2d2c3"],
	                ["#a419b7", "#e3c7e8"],
	                ["#430b62", "#d0c5d7"]
	            ]
	        }
	    });

	    registerTheme("metro", {
	        chart: {
	            title: {
	                color: "#777777"
	            },
	            legend: {
	                labels: {
	                    color: "#777777"
	                },
	                inactiveItems: {
	                    labels: {
	                        color: "#CBCBCB"
	                    },
	                    markers: {
	                        color: "#CBCBCB"
	                    }
	                }
	            },
	            seriesDefaults: {
	                labels: {
	                    color: BLACK
	                },
	                errorBars: {
	                    color: "#777777"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#777777"
	                        }
	                    },
	                    label: {
	                        color: "#777777"
	                    },
	                    line: {
	                        color: "#777777"
	                    }
	                },
	                candlestick: {
	                    downColor: "#c7c7c7",
	                    line: {
	                        color: "#787878"
	                    }
	                },
	                waterfall: {
	                    line: {
	                        color: "#c7c7c7"
	                    }
	                },
	                horizontalWaterfall: {
	                    line: {
	                        color: "#c7c7c7"
	                    }
	                },
	                overlay: {
	                    gradient: "none"
	                },
	                border: {
	                    _brightness: 1
	                }
	            },
	            seriesColors: ["#8ebc00", "#309b46", "#25a0da", "#ff6900", "#e61e26", "#d8e404", "#16aba9", "#7e51a1", "#313131", "#ed1691"],
	            axisDefaults: {
	                line: {
	                    color: "#c7c7c7"
	                },
	                labels: {
	                    color: "#777777"
	                },
	                minorGridLines: {
	                    color: "#c7c7c7"
	                },
	                majorGridLines: {
	                    color: "#c7c7c7"
	                },
	                title: {
	                    color: "#777777"
	                },
	                crosshair: {
	                    color: "#c7c7c7"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#777777"
	                        }
	                    },
	                    label: {
	                        color: "#777777"
	                    },
	                    line: {
	                        color: "#777777"
	                    }
	                }
	            }
	        },
	        gauge: {
	            pointer: {
	                color: "#8ebc00"
	            },
	            scale: {
	                rangePlaceholderColor: "#e6e6e6",

	                labels: {
	                    color: "#777"
	                },
	                minorTicks: {
	                    color: "#777"
	                },
	                majorTicks: {
	                    color: "#777"
	                },
	                line: {
	                    color: "#777"
	                }
	            }
	        },
	        diagram: {
	            shapeDefaults: {
	                fill: {
	                    color: "#8ebc00"
	                },
	                connectorDefaults: {
	                    fill: {
	                        color: BLACK
	                    },
	                    stroke: {
	                        color: WHITE
	                    },
	                    hover: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: BLACK
	                        }
	                    }
	                },
	                content: {
	                    color: "#777"
	                }
	            },
	            editable: {
	                resize: {
	                    handles: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#787878"
	                        },
	                        hover: {
	                            fill: {
	                                color: "#787878"
	                            },
	                            stroke: {
	                                color: "#787878"
	                            }
	                        }
	                    }
	                },
	                rotate: {
	                    thumb: {
	                        stroke: {
	                            color: "#787878"
	                        },
	                        fill: {
	                            color: "#787878"
	                        }
	                    }
	                }
	            },
	            selectable: {
	                stroke: {
	                    color: "#515967"
	                }
	            },
	            connectionDefaults: {
	                stroke: {
	                    color: "#787878"
	                },
	                content: {
	                    color: "#777"
	                },
	                selection: {
	                    handles: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#787878"
	                        }
	                    }
	                }
	            }
	        },
	        treeMap: {
	            colors: [
	                ["#8ebc00", "#e8f2cc"],
	                ["#309b46", "#d6ebda"],
	                ["#25a0da", "#d3ecf8"],
	                ["#ff6900", "#ffe1cc"],
	                ["#e61e26", "#fad2d4"],
	                ["#d8e404", "#f7facd"],
	                ["#16aba9", "#d0eeee"],
	                ["#7e51a1", "#e5dcec"],
	                ["#313131", "#d6d6d6"],
	                ["#ed1691", "#fbd0e9"]
	            ]
	        }
	    });

	    registerTheme("metroblack", {
	        chart: {
	            title: {
	                color: "#ffffff"
	            },
	            legend: {
	                labels: {
	                    color: "#ffffff"
	                },
	                inactiveItems: {
	                    labels: {
	                        color: "#797979"
	                    },
	                    markers: {
	                        color: "#797979"
	                    }
	                }
	            },
	            seriesDefaults: {
	                border: {
	                    _brightness: 1
	                },
	                labels: {
	                    color: "#ffffff"
	                },
	                errorBars: {
	                    color: "#ffffff"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#cecece"
	                        }
	                    },
	                    label: {
	                        color: "#ffffff"
	                    },
	                    line: {
	                        color: "#cecece"
	                    }
	                },
	                line: {
	                    markers: {
	                        background: "#0e0e0e"
	                    }
	                },
	                bubble: {
	                    opacity: 0.6
	                },
	                scatter: {
	                    markers: {
	                        background: "#0e0e0e"
	                    }
	                },
	                scatterLine: {
	                    markers: {
	                        background: "#0e0e0e"
	                    }
	                },
	                candlestick: {
	                    downColor: "#828282",
	                    line: {
	                        color: "#ffffff"
	                    }
	                },
	                waterfall: {
	                    line: {
	                        color: "#cecece"
	                    }
	                },
	                horizontalWaterfall: {
	                    line: {
	                        color: "#cecece"
	                    }
	                },
	                overlay: {
	                    gradient: "none"
	                }
	            },
	            chartArea: {
	                background: "#0e0e0e"
	            },
	            seriesColors: ["#00aba9", "#309b46", "#8ebc00", "#ff6900", "#e61e26", "#d8e404", "#25a0da", "#7e51a1", "#313131", "#ed1691"],
	            axisDefaults: {
	                line: {
	                    color: "#cecece"
	                },
	                labels: {
	                    color: "#ffffff"
	                },
	                minorGridLines: {
	                    color: "#2d2d2d"
	                },
	                majorGridLines: {
	                    color: "#333333"
	                },
	                title: {
	                    color: "#ffffff"
	                },
	                crosshair: {
	                    color: "#cecece"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#cecece"
	                        }
	                    },
	                    label: {
	                        color: "#ffffff"
	                    },
	                    line: {
	                        color: "#cecece"
	                    }
	                }
	            }
	        },
	        gauge: {
	            pointer: {
	                color: "#00aba9"
	            },
	            scale: {
	                rangePlaceholderColor: "#2d2d2d",

	                labels: {
	                    color: "#ffffff"
	                },
	                minorTicks: {
	                    color: "#333333"
	                },
	                majorTicks: {
	                    color: "#cecece"
	                },
	                line: {
	                    color: "#cecece"
	                }
	            }
	        },
	        diagram: {
	            shapeDefaults: {
	                fill: {
	                    color: "#00aba9"
	                },
	                connectorDefaults: {
	                    fill: {
	                        color: WHITE
	                    },
	                    stroke: {
	                        color: "#0e0e0e"
	                    },
	                    hover: {
	                        fill: {
	                            color: "#0e0e0e"
	                        },
	                        stroke: {
	                            color: WHITE
	                        }
	                    }
	                },
	                content: {
	                    color: WHITE
	                }
	            },
	            editable: {
	                resize: {
	                    handles: {
	                        fill: {
	                            color: "#0e0e0e"
	                        },
	                        stroke: {
	                            color: "#787878"
	                        },
	                        hover: {
	                            fill: {
	                                color: "#787878"
	                            },
	                            stroke: {
	                                color: "#787878"
	                            }
	                        }
	                    }
	                },
	                rotate: {
	                    thumb: {
	                        stroke: {
	                            color: WHITE
	                        },
	                        fill: {
	                            color: WHITE
	                        }
	                    }
	                }
	            },
	            selectable: {
	                stroke: {
	                    color: "#787878"
	                }
	            },
	            connectionDefaults: {
	                stroke: {
	                    color: WHITE
	                },
	                content: {
	                    color: WHITE
	                },
	                selection: {
	                    handles: {
	                        fill: {
	                            color: "#0e0e0e"
	                        },
	                        stroke: {
	                            color: WHITE
	                        }
	                    }
	                }
	            }
	        },
	        treeMap: {
	            colors: [
	                ["#00aba9", "#0b2d2d"],
	                ["#309b46", "#152a19"],
	                ["#8ebc00", "#28310b"],
	                ["#ff6900", "#3e200b"],
	                ["#e61e26", "#391113"],
	                ["#d8e404", "#36390c"],
	                ["#25a0da", "#132b37"],
	                ["#7e51a1", "#241b2b"],
	                ["#313131", "#151515"],
	                ["#ed1691", "#3b1028"]
	            ]
	        }
	    });

	    registerTheme("moonlight", {
	        chart: {
	            title: {
	                color: "#ffffff"
	            },
	            legend: {
	                labels: {
	                    color: "#ffffff"
	                },
	                inactiveItems: {
	                    labels: {
	                        color: "#A1A7AB"
	                    },
	                    markers: {
	                        color: "#A1A7AB"
	                    }
	                }
	            },
	            seriesDefaults: {
	                labels: {
	                    color: "#ffffff"
	                },
	                errorBars: {
	                    color: "#ffffff"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#8c909e"
	                        }
	                    },
	                    label: {
	                        color: "#ffffff"
	                    },
	                    line: {
	                        color: "#8c909e"
	                    }
	                },
	                pie: {
	                    overlay: {
	                        gradient: "sharpBevel"
	                    }
	                },
	                donut: {
	                    overlay: {
	                        gradient: "sharpGlass"
	                    }
	                },
	                line: {
	                    markers: {
	                        background: "#212a33"
	                    }
	                },
	                bubble: {
	                    opacity: 0.6
	                },
	                scatter: {
	                    markers: {
	                        background: "#212a33"
	                    }
	                },
	                scatterLine: {
	                    markers: {
	                        background: "#212a33"
	                    }
	                },
	                area: {
	                    opacity: 0.3
	                },
	                candlestick: {
	                    downColor: "#757d87",
	                    line: {
	                        color: "#ea9d06"
	                    },
	                    border: {
	                        _brightness: 1.5,
	                        opacity: 1
	                    },
	                    highlight: {
	                        border: {
	                            color: WHITE,
	                            opacity: 0.2
	                        }
	                    }
	                },
	                waterfall: {
	                    line: {
	                        color: "#8c909e"
	                    }
	                },
	                horizontalWaterfall: {
	                    line: {
	                        color: "#8c909e"
	                    }
	                },
	                ohlc: {
	                    line: {
	                        color: "#ea9d06"
	                    }
	                }
	            },
	            chartArea: {
	                background: "#212a33"
	            },
	            seriesColors: ["#ffca08", "#ff710f", "#ed2e24", "#ff9f03", "#e13c02", "#a00201"],
	            axisDefaults: {
	                line: {
	                    color: "#8c909e"
	                },
	                minorTicks: {
	                    color: "#8c909e"
	                },
	                majorTicks: {
	                    color: "#8c909e"
	                },
	                labels: {
	                    color: "#ffffff"
	                },
	                majorGridLines: {
	                    color: "#3e424d"
	                },
	                minorGridLines: {
	                    color: "#2f3640"
	                },
	                title: {
	                    color: "#ffffff"
	                },
	                crosshair: {
	                    color: "#8c909e"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#8c909e"
	                        }
	                    },
	                    label: {
	                        color: "#ffffff"
	                    },
	                    line: {
	                        color: "#8c909e"
	                    }
	                }
	            }
	        },
	        gauge: {
	            pointer: {
	                color: "#f4af03"
	            },
	            scale: {
	                rangePlaceholderColor: "#2f3640",

	                labels: {
	                    color: WHITE
	                },
	                minorTicks: {
	                    color: "#8c909e"
	                },
	                majorTicks: {
	                    color: "#8c909e"
	                },
	                line: {
	                    color: "#8c909e"
	                }
	            }
	        },
	        diagram: {
	            shapeDefaults: {
	                fill: {
	                    color: "#f3ae03"
	                },
	                connectorDefaults: {
	                    fill: {
	                        color: WHITE
	                    },
	                    stroke: {
	                        color: "#414550"
	                    },
	                    hover: {
	                        fill: {
	                            color: "#414550"
	                        },
	                        stroke: {
	                            color: WHITE
	                        }
	                    }
	                },
	                content: {
	                    color: WHITE
	                }
	            },
	            editable: {
	                resize: {
	                    handles: {
	                        fill: {
	                            color: "#414550"
	                        },
	                        stroke: {
	                            color: WHITE
	                        },
	                        hover: {
	                            fill: {
	                                color: WHITE
	                            },
	                            stroke: {
	                                color: WHITE
	                            }
	                        }
	                    }
	                },
	                rotate: {
	                    thumb: {
	                        stroke: {
	                            color: WHITE
	                        },
	                        fill: {
	                            color: WHITE
	                        }
	                    }
	                }
	            },
	            selectable: {
	                stroke: {
	                    color: WHITE
	                }
	            },
	            connectionDefaults: {
	                stroke: {
	                    color: WHITE
	                },
	                content: {
	                    color: WHITE
	                },
	                selection: {
	                    handles: {
	                        fill: {
	                            color: "#414550"
	                        },
	                        stroke: {
	                            color: WHITE
	                        }
	                    }
	                }
	            }
	        },
	        treeMap: {
	            colors: [
	                ["#ffca08", "#4e4b2b"],
	                ["#ff710f", "#4e392d"],
	                ["#ed2e24", "#4b2c31"],
	                ["#ff9f03", "#4e422a"],
	                ["#e13c02", "#482e2a"],
	                ["#a00201", "#3b232a"]
	            ]
	        }
	    });

	    registerTheme("uniform", {
	        chart: {
	            title: {
	                color: "#686868"
	            },
	            legend: {
	                labels: {
	                    color: "#686868"
	                },
	                inactiveItems: {
	                    labels: {
	                        color: "#B6B6B6"
	                    },
	                    markers: {
	                        color: "#B6B6B6"
	                    }
	                }
	            },
	            seriesDefaults: {
	                labels: {
	                    color: "#686868"
	                },
	                errorBars: {
	                    color: "#686868"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#9e9e9e"
	                        }
	                    },
	                    label: {
	                        color: "#686868"
	                    },
	                    line: {
	                        color: "#9e9e9e"
	                    }
	                },
	                pie: {
	                    overlay: {
	                        gradient: "sharpBevel"
	                    }
	                },
	                donut: {
	                    overlay: {
	                        gradient: "sharpGlass"
	                    }
	                },
	                line: {
	                    markers: {
	                        background: "#ffffff"
	                    }
	                },
	                bubble: {
	                    opacity: 0.6
	                },
	                scatter: {
	                    markers: {
	                        background: "#ffffff"
	                    }
	                },
	                scatterLine: {
	                    markers: {
	                        background: "#ffffff"
	                    }
	                },
	                area: {
	                    opacity: 0.3
	                },
	                candlestick: {
	                    downColor: "#cccccc",
	                    line: {
	                        color: "#cccccc"
	                    },
	                    border: {
	                        _brightness: 1.5,
	                        opacity: 1
	                    },
	                    highlight: {
	                        border: {
	                            color: "#cccccc",
	                            opacity: 0.2
	                        }
	                    }
	                },
	                waterfall: {
	                    line: {
	                        color: "#9e9e9e"
	                    }
	                },
	                horizontalWaterfall: {
	                    line: {
	                        color: "#9e9e9e"
	                    }
	                },
	                ohlc: {
	                    line: {
	                        color: "#cccccc"
	                    }
	                }
	            },
	            chartArea: {
	                background: "#ffffff"
	            },
	            seriesColors: ["#527aa3", "#6f91b3", "#8ca7c2", "#a8bdd1", "#c5d3e0", "#e2e9f0"],
	            axisDefaults: {
	                line: {
	                    color: "#9e9e9e"
	                },
	                minorTicks: {
	                    color: "#aaaaaa"
	                },
	                majorTicks: {
	                    color: "#888888"
	                },
	                labels: {
	                    color: "#686868"
	                },
	                majorGridLines: {
	                    color: "#dadada"
	                },
	                minorGridLines: {
	                    color: "#e7e7e7"
	                },
	                title: {
	                    color: "#686868"
	                },
	                crosshair: {
	                    color: "#9e9e9e"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#9e9e9e"
	                        }
	                    },
	                    label: {
	                        color: "#686868"
	                    },
	                    line: {
	                        color: "#9e9e9e"
	                    }
	                }
	            }
	        },
	        gauge: {
	            pointer: {
	                color: "#527aa3"
	            },
	            scale: {
	                rangePlaceholderColor: "#e7e7e7",

	                labels: {
	                    color: "#686868"
	                },
	                minorTicks: {
	                    color: "#aaaaaa"
	                },
	                majorTicks: {
	                    color: "#888888"
	                },
	                line: {
	                    color: "#9e9e9e"
	                }
	            }
	        },
	        diagram: {
	            shapeDefaults: {
	                fill: {
	                    color: "#d1d1d1"
	                },
	                connectorDefaults: {
	                    fill: {
	                        color: "#686868"
	                    },
	                    stroke: {
	                        color: WHITE
	                    },
	                    hover: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#686868"
	                        }
	                    }
	                },
	                content: {
	                    color: "#686868"
	                }
	            },
	            editable: {
	                resize: {
	                    handles: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#686868"
	                        },
	                        hover: {
	                            fill: {
	                                color: "#686868"
	                            },
	                            stroke: {
	                                color: "#686868"
	                            }
	                        }
	                    }
	                },
	                rotate: {
	                    thumb: {
	                        stroke: {
	                            color: "#686868"
	                        },
	                        fill: {
	                            color: "#686868"
	                        }
	                    }
	                }
	            },
	            selectable: {
	                stroke: {
	                    color: "#686868"
	                }
	            },
	            connectionDefaults: {
	                stroke: {
	                    color: "#686868"
	                },
	                content: {
	                    color: "#686868"
	                },
	                selection: {
	                    handles: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#686868"
	                        }
	                    }
	                }
	            }
	        },
	        treeMap: {
	            colors: [
	                ["#527aa3", "#d0d8e1"],
	                ["#6f91b3", "#d6dde4"],
	                ["#8ca7c2", "#dce1e7"],
	                ["#a8bdd1", "#e2e6ea"],
	                ["#c5d3e0", "#e7eaed"],
	                ["#e2e9f0", "#edeff0"]
	            ]
	        }
	    });

	    registerTheme("bootstrap", {
	        chart: {
	            title: {
	                color: "#333333"
	            },
	            legend: {
	                labels: {
	                    color: "#333333"
	                },
	                inactiveItems: {
	                    labels: {
	                        color: "#999999"
	                    },
	                    markers: {
	                        color: "#9A9A9A"
	                    }
	                }
	            },
	            seriesDefaults: {
	                labels: {
	                    color: "#333333"
	                },
	                overlay: {
	                    gradient: "none"
	                },
	                errorBars: {
	                    color: "#343434"
	                },
	                notes: {
	                    icon: {
	                        background: "#000000",
	                        border: {
	                            color: "#000000"
	                        }
	                    },
	                    label: {
	                        color: "#333333"
	                    },
	                    line: {
	                        color: "#000000"
	                    }
	                },
	                pie: {
	                    overlay: {
	                        gradient: "none"
	                    }
	                },
	                donut: {
	                    overlay: {
	                        gradient: "none"
	                    }
	                },
	                line: {
	                    markers: {
	                        background: "#ffffff"
	                    }
	                },
	                bubble: {
	                    opacity: 0.6
	                },
	                scatter: {
	                    markers: {
	                        background: "#ffffff"
	                    }
	                },
	                scatterLine: {
	                    markers: {
	                        background: "#ffffff"
	                    }
	                },
	                area: {
	                    opacity: 0.8
	                },
	                candlestick: {
	                    downColor: "#d0d0d0",
	                    line: {
	                        color: "#333333"
	                    },
	                    border: {
	                        _brightness: 1.5,
	                        opacity: 1
	                    },
	                    highlight: {
	                        border: {
	                            color: "#b8b8b8",
	                            opacity: 0.2
	                        }
	                    }
	                },
	                waterfall: {
	                    line: {
	                        color: "#cccccc"
	                    }
	                },
	                horizontalWaterfall: {
	                    line: {
	                        color: "#cccccc"
	                    }
	                },
	                ohlc: {
	                    line: {
	                        color: "#333333"
	                    }
	                }
	            },
	            chartArea: {
	                background: "#ffffff"
	            },
	            seriesColors: ["#428bca", "#5bc0de", "#5cb85c", "#f2b661", "#e67d4a", "#da3b36"],
	            axisDefaults: {
	                line: {
	                    color: "#cccccc"
	                },
	                minorTicks: {
	                    color: "#ebebeb"
	                },
	                majorTicks: {
	                    color: "#cccccc"
	                },
	                labels: {
	                    color: "#333333"
	                },
	                majorGridLines: {
	                    color: "#cccccc"
	                },
	                minorGridLines: {
	                    color: "#ebebeb"
	                },
	                title: {
	                    color: "#333333"
	                },
	                crosshair: {
	                    color: "#000000"
	                },
	                notes: {
	                    icon: {
	                        background: "#000000",
	                        border: {
	                            color: "#000000"
	                        }
	                    },
	                    label: {
	                        color: "#ffffff"
	                    },
	                    line: {
	                        color: "#000000"
	                    }
	                }
	            }
	        },
	        gauge: {
	            pointer: {
	                color: "#428bca"
	            },
	            scale: {
	                rangePlaceholderColor: "#cccccc",
	                labels: {
	                    color: "#333333"
	                },
	                minorTicks: {
	                    color: "#ebebeb"
	                },
	                majorTicks: {
	                    color: "#cccccc"
	                },
	                line: {
	                    color: "#cccccc"
	                }
	            }
	        },
	        diagram: {
	            shapeDefaults: {
	                fill: {
	                    color: "#428bca"
	                },
	                connectorDefaults: {
	                    fill: {
	                        color: "#333333"
	                    },
	                    stroke: {
	                        color: WHITE
	                    },
	                    hover: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#333333"
	                        }
	                    }
	                },
	                content: {
	                    color: "#333333"
	                }
	            },
	            editable: {
	                resize: {
	                    handles: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#333333"
	                        },
	                        hover: {
	                            fill: {
	                                color: "#333333"
	                            },
	                            stroke: {
	                                color: "#333333"
	                            }
	                        }
	                    }
	                },
	                rotate: {
	                    thumb: {
	                        stroke: {
	                            color: "#333333"
	                        },
	                        fill: {
	                            color: "#333333"
	                        }
	                    }
	                }
	            },
	            selectable: {
	                stroke: {
	                    color: "#333333"
	                }
	            },
	            connectionDefaults: {
	                stroke: {
	                    color: "#c4c4c4"
	                },
	                content: {
	                    color: "#333333"
	                },
	                selection: {
	                    handles: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#333333"
	                        }
	                    },
	                    stroke: {
	                        color: "#333333"
	                    }
	                }
	            }
	        },
	        treeMap: {
	            colors: [
	                ["#428bca", "#d1e0ec"],
	                ["#5bc0de", "#d6eaf0"],
	                ["#5cb85c", "#d6e9d6"],
	                ["#5cb85c", "#f4e8d7"],
	                ["#e67d4a", "#f2ddd3"],
	                ["#da3b36", "#f0d0cf"]
	            ]
	        }
	    });

	    registerTheme("flat", {
	            chart: {
	            title: {
	                color: "#4c5356"
	            },
	            legend: {
	                labels: {
	                    color: "#4c5356"
	                },
	                inactiveItems: {
	                    labels: {
	                        color: "#CBCBCB"
	                    },
	                    markers: {
	                        color: "#CBCBCB"
	                    }
	                }
	            },
	            seriesDefaults: {
	                labels: {
	                    color: "#4c5356"
	                },
	                errorBars: {
	                    color: "#4c5356"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#cdcdcd"
	                        }
	                    },
	                    label: {
	                        color: "#4c5356"
	                    },
	                    line: {
	                        color: "#cdcdcd"
	                    }
	                },
	                candlestick: {
	                    downColor: "#c7c7c7",
	                    line: {
	                        color: "#787878"
	                    }
	                },
	                area: {
	                    opacity: 0.9
	                },
	                waterfall: {
	                    line: {
	                        color: "#cdcdcd"
	                    }
	                },
	                horizontalWaterfall: {
	                    line: {
	                        color: "#cdcdcd"
	                    }
	                },
	                overlay: {
	                    gradient: "none"
	                },
	                border: {
	                    _brightness: 1
	                }
	            },
	            seriesColors: ["#10c4b2", "#ff7663", "#ffb74f", "#a2df53", "#1c9ec4", "#ff63a5", "#1cc47b"],
	            axisDefaults: {
	                line: {
	                    color: "#cdcdcd"
	                },
	                labels: {
	                    color: "#4c5356"
	                },
	                minorGridLines: {
	                    color: "#cdcdcd"
	                },
	                majorGridLines: {
	                    color: "#cdcdcd"
	                },
	                title: {
	                    color: "#4c5356"
	                },
	                crosshair: {
	                    color: "#cdcdcd"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#cdcdcd"
	                        }
	                    },
	                    label: {
	                        color: "#4c5356"
	                    },
	                    line: {
	                        color: "#cdcdcd"
	                    }
	                }
	            }
	        },
	        gauge: {
	            pointer: {
	                color: "#10c4b2"
	            },
	            scale: {
	                rangePlaceholderColor: "#cdcdcd",

	                labels: {
	                    color: "#4c5356"
	                },
	                minorTicks: {
	                    color: "#4c5356"
	                },
	                majorTicks: {
	                    color: "#4c5356"
	                },
	                line: {
	                    color: "#4c5356"
	                }
	            }
	        },
	        diagram: {
	            shapeDefaults: {
	                fill: {
	                    color: "#10c4b2"
	                },
	                connectorDefaults: {
	                    fill: {
	                        color: "#363940"
	                    },
	                    stroke: {
	                        color: WHITE
	                    },
	                    hover: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#363940"
	                        }
	                    }
	                },
	                content: {
	                    color: "#4c5356"
	                }
	            },
	            editable: {
	                resize: {
	                    handles: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#363940"
	                        },
	                        hover: {
	                            fill: {
	                                color: "#363940"
	                            },
	                            stroke: {
	                                color: "#363940"
	                            }
	                        }
	                    }
	                },
	                rotate: {
	                    thumb: {
	                        stroke: {
	                            color: "#363940"
	                        },
	                        fill: {
	                            color: "#363940"
	                        }
	                    }
	                }
	            },
	            selectable: {
	                stroke: {
	                    color: "#363940"
	                }
	            },
	            connectionDefaults: {
	                stroke: {
	                    color: "#cdcdcd"
	                },
	                content: {
	                    color: "#4c5356"
	                },
	                selection: {
	                    handles: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#363940"
	                        }
	                    },
	                    stroke: {
	                        color: "#363940"
	                    }
	                }
	            }
	        },
	        treeMap: {
	            colors: [
	                ["#10c4b2", "#cff3f0"],
	                ["#ff7663", "#ffe4e0"],
	                ["#ffb74f", "#fff1dc"],
	                ["#a2df53", "#ecf9dd"],
	                ["#1c9ec4", "#d2ecf3"],
	                ["#ff63a5", "#ffe0ed"],
	                ["#1cc47b", "#d2f3e5"]
	            ]
	        }
	    });


	     registerTheme("material", {
	       chart: {
	            title: {
	                color: "#444444"
	            },
	            legend: {
	                labels: {
	                    color: "#444444"
	                },
	                inactiveItems: {
	                    labels: {
	                        color: "#CBCBCB"
	                    },
	                    markers: {
	                        color: "#CBCBCB"
	                    }
	                }
	            },
	            seriesDefaults: {
	                labels: {
	                    color: "#444444"
	                },
	                errorBars: {
	                    color: "#444444"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#e5e5e5"
	                        }
	                    },
	                    label: {
	                        color: "#444444"
	                    },
	                    line: {
	                        color: "#e5e5e5"
	                    }
	                },
	                candlestick: {
	                    downColor: "#c7c7c7",
	                    line: {
	                        color: "#787878"
	                    }
	                },
	                area: {
	                    opacity: 0.9
	                },
	                waterfall: {
	                    line: {
	                        color: "#e5e5e5"
	                    }
	                },
	                horizontalWaterfall: {
	                    line: {
	                        color: "#e5e5e5"
	                    }
	                },
	                overlay: {
	                    gradient: "none"
	                },
	                border: {
	                    _brightness: 1
	                }
	            },
	            seriesColors: ["#3f51b5", "#03a9f4", "#4caf50", "#f9ce1d", "#ff9800", "#ff5722"],
	            axisDefaults: {
	                line: {
	                    color: "#e5e5e5"
	                },
	                labels: {
	                    color: "#444444"
	                },
	                minorGridLines: {
	                    color: "#e5e5e5"
	                },
	                majorGridLines: {
	                    color: "#e5e5e5"
	                },
	                title: {
	                    color: "#444444"
	                },
	                crosshair: {
	                    color: "#7f7f7f"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#e5e5e5"
	                        }
	                    },
	                    label: {
	                        color: "#444444"
	                    },
	                    line: {
	                        color: "#e5e5e5"
	                    }
	                }
	            }
	        },
	        gauge: {
	            pointer: {
	                color: "#3f51b5"
	            },
	            scale: {
	                rangePlaceholderColor: "#e5e5e5",

	                labels: {
	                    color: "#444444"
	                },
	                minorTicks: {
	                    color: "#444444"
	                },
	                majorTicks: {
	                    color: "#444444"
	                },
	                line: {
	                    color: "#444444"
	                }
	            }
	        },
	        diagram: {
	            shapeDefaults: {
	                fill: {
	                    color: "#3f51b5"
	                },
	                connectorDefaults: {
	                    fill: {
	                        color: "#7f7f7f"
	                    },
	                    stroke: {
	                        color: WHITE
	                    },
	                    hover: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#7f7f7f"
	                        }
	                    }
	                },
	                content: {
	                    color: "#444444"
	                }
	            },
	            editable: {
	                resize: {
	                    handles: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#444444"
	                        },
	                        hover: {
	                            fill: {
	                                color: "#444444"
	                            },
	                            stroke: {
	                                color: "#444444"
	                            }
	                        }
	                    }
	                },
	                rotate: {
	                    thumb: {
	                        stroke: {
	                            color: "#444444"
	                        },
	                        fill: {
	                            color: "#444444"
	                        }
	                    }
	                }
	            },
	            selectable: {
	                stroke: {
	                    color: "#444444"
	                }
	            },
	            connectionDefaults: {
	                stroke: {
	                    color: "#7f7f7f"
	                },
	                content: {
	                    color: "#444444"
	                },
	                selection: {
	                    handles: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#444444"
	                        }
	                    },
	                    stroke: {
	                        color: "#444444"
	                    }
	                }
	            }
	        },
	        treeMap: {
	            colors: [
	                ["#3f51b5", "#cff3f0"],
	                ["#03a9f4", "#e5f6fe"],
	                ["#4caf50", "#edf7ed"],
	                ["#f9ce1d", "#fefae8"],
	                ["#ff9800", "#fff4e5"],
	                ["#ff5722", "#ffeee8"]
	            ]
	        }
	    });

	    registerTheme("materialblack", {
	       chart: {
	            title: {
	                color: "#fff"
	            },
	            legend: {
	                labels: {
	                    color: "#fff"
	                },
	                inactiveItems: {
	                    labels: {
	                        color: "#CBCBCB"
	                    },
	                    markers: {
	                        color: "#CBCBCB"
	                    }
	                }
	            },
	            seriesDefaults: {
	                labels: {
	                    color: "#fff"
	                },
	                errorBars: {
	                    color: "#fff"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#e5e5e5"
	                        }
	                    },
	                    label: {
	                        color: "#fff"
	                    },
	                    line: {
	                        color: "#e5e5e5"
	                    }
	                },
	                candlestick: {
	                    downColor: "#c7c7c7",
	                    line: {
	                        color: "#787878"
	                    }
	                },
	                area: {
	                    opacity: 0.9
	                },
	                waterfall: {
	                    line: {
	                        color: "#4d4d4d"
	                    }
	                },
	                horizontalWaterfall: {
	                    line: {
	                        color: "#4d4d4d"
	                    }
	                },
	                overlay: {
	                    gradient: "none"
	                },
	                border: {
	                    _brightness: 1
	                }
	            },
	            chartArea: {
	                background: "#1c1c1c"
	            },
	            seriesColors: ["#3f51b5", "#03a9f4", "#4caf50", "#f9ce1d", "#ff9800", "#ff5722"],
	            axisDefaults: {
	                line: {
	                    color: "#4d4d4d"
	                },
	                labels: {
	                    color: "#fff"
	                },
	                minorGridLines: {
	                    color: "#4d4d4d"
	                },
	                majorGridLines: {
	                    color: "#4d4d4d"
	                },
	                title: {
	                    color: "#fff"
	                },
	                crosshair: {
	                    color: "#7f7f7f"
	                },
	                notes: {
	                    icon: {
	                        background: "transparent",
	                        border: {
	                            color: "#4d4d4d"
	                        }
	                    },
	                    label: {
	                        color: "#fff"
	                    },
	                    line: {
	                        color: "#4d4d4d"
	                    }
	                }
	            }
	        },
	        gauge: {
	            pointer: {
	                color: "#3f51b5"
	            },
	            scale: {
	                rangePlaceholderColor: "#4d4d4d",

	                labels: {
	                    color: "#fff"
	                },
	                minorTicks: {
	                    color: "#fff"
	                },
	                majorTicks: {
	                    color: "#fff"
	                },
	                line: {
	                    color: "#fff"
	                }
	            }
	        },
	        diagram: {
	            shapeDefaults: {
	                fill: {
	                    color: "#3f51b5"
	                },
	                connectorDefaults: {
	                    fill: {
	                        color: "#7f7f7f"
	                    },
	                    stroke: {
	                        color: WHITE
	                    },
	                    hover: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#7f7f7f"
	                        }
	                    }
	                },
	                content: {
	                    color: "#fff"
	                }
	            },
	            editable: {
	                resize: {
	                    handles: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#fff"
	                        },
	                        hover: {
	                            fill: {
	                                color: "#fff"
	                            },
	                            stroke: {
	                                color: "#fff"
	                            }
	                        }
	                    }
	                },
	                rotate: {
	                    thumb: {
	                        stroke: {
	                            color: "#fff"
	                        },
	                        fill: {
	                            color: "#fff"
	                        }
	                    }
	                }
	            },
	            selectable: {
	                stroke: {
	                    color: "#fff"
	                }
	            },
	            connectionDefaults: {
	                stroke: {
	                    color: "#7f7f7f"
	                },
	                content: {
	                    color: "#fff"
	                },
	                selection: {
	                    handles: {
	                        fill: {
	                            color: WHITE
	                        },
	                        stroke: {
	                            color: "#fff"
	                        }
	                    },
	                    stroke: {
	                        color: "#fff"
	                    }
	                }
	            }
	        },
	        treeMap: {
	            colors: [
	                ["#3f51b5", "#cff3f0"],
	                ["#03a9f4", "#e5f6fe"],
	                ["#4caf50", "#edf7ed"],
	                ["#f9ce1d", "#fefae8"],
	                ["#ff9800", "#fff4e5"],
	                ["#ff5722", "#ffeee8"]
	            ]
	        }
	    });

	    (function () {
	        var TEXT = "#333333";
	        var INACTIVE = "#7f7f7f";
	        var INACTIVE_SHAPE = "#bdbdbd";
	        var AXIS = "#c8c8c8";
	        var AXIS_MINOR = "#dddddd";
	        var SERIES = ["#008fd3", "#99d101", "#f39b02", "#f05662", "#c03c53", "#acacac"];
	        var SERIES_LIGHT = ["#cbe8f5", "#eaf5cb", "#fceacc", "#fbdcdf", "#f2d7dc", "#eeeeee"];
	        var PRIMARY = SERIES[0];
	        var DIAGRAM_HOVER = WHITE;

	        function noteStyle() {
	            return {
	                icon: {
	                    background: "#007cc0",
	                    border: {
	                        color: "#007cc0"
	                    }
	                },
	                label: {
	                    color: "#ffffff"
	                },
	                line: {
	                    color: AXIS
	                }
	            };
	        }

	        registerTheme("fiori", {
	            chart: {
	                title: {
	                    color: TEXT
	                },
	                legend: {
	                    labels: {
	                        color: TEXT
	                    },
	                    inactiveItems: {
	                        labels: {
	                            color: INACTIVE
	                        },
	                        markers: {
	                            color: INACTIVE
	                        }
	                    }
	                },
	                seriesDefaults: {
	                    labels: {
	                        color: TEXT
	                    },
	                    errorBars: {
	                        color: TEXT
	                    },
	                    notes: noteStyle(),
	                    candlestick: {
	                        downColor: AXIS,
	                        line: {
	                            color: INACTIVE_SHAPE
	                        }
	                    },
	                    area: {
	                        opacity: 0.8
	                    },
	                    waterfall: {
	                        line: {
	                            color: AXIS
	                        }
	                    },
	                    horizontalWaterfall: {
	                        line: {
	                            color: AXIS
	                        }
	                    },
	                    overlay: {
	                        gradient: "none"
	                    },
	                    border: {
	                        _brightness: 1
	                    }
	                },
	                seriesColors: SERIES,
	                axisDefaults: {
	                    line: {
	                        color: AXIS
	                    },
	                    labels: {
	                        color: TEXT
	                    },
	                    minorGridLines: {
	                        color: AXIS_MINOR
	                    },
	                    majorGridLines: {
	                        color: AXIS
	                    },
	                    title: {
	                        color: TEXT
	                    },
	                    crosshair: {
	                        color: INACTIVE
	                    },
	                    notes: noteStyle()
	                }
	            },
	            gauge: {
	                pointer: {
	                    color: PRIMARY
	                },
	                scale: {
	                    rangePlaceholderColor: AXIS,
	                    labels: {
	                        color: TEXT
	                    },
	                    minorTicks: {
	                        color: TEXT
	                    },
	                    majorTicks: {
	                        color: TEXT
	                    },
	                    line: {
	                        color: TEXT
	                    }
	                }
	            },
	            diagram: {
	                shapeDefaults: {
	                    fill: {
	                        color: PRIMARY
	                    },
	                    connectorDefaults: {
	                        fill: {
	                            color: TEXT
	                        },
	                        stroke: {
	                            color: DIAGRAM_HOVER
	                        },
	                        hover: {
	                            fill: {
	                                color: DIAGRAM_HOVER
	                            },
	                            stroke: {
	                                color: TEXT
	                            }
	                        }
	                    },
	                    content: {
	                        color: TEXT
	                    }
	                },
	                editable: {
	                    resize: {
	                        handles: {
	                            fill: {
	                                color: DIAGRAM_HOVER
	                            },
	                            stroke: {
	                                color: INACTIVE_SHAPE
	                            },
	                            hover: {
	                                fill: {
	                                    color: INACTIVE_SHAPE
	                                },
	                                stroke: {
	                                    color: INACTIVE_SHAPE
	                                }
	                            }
	                        }
	                    },
	                    rotate: {
	                        thumb: {
	                            stroke: {
	                                color: INACTIVE_SHAPE
	                            },
	                            fill: {
	                                color: INACTIVE_SHAPE
	                            }
	                        }
	                    }
	                },
	                selectable: {
	                    stroke: {
	                        color: INACTIVE_SHAPE
	                    }
	                },
	                connectionDefaults: {
	                    stroke: {
	                        color: INACTIVE_SHAPE
	                    },
	                    content: {
	                        color: INACTIVE_SHAPE
	                    },
	                    selection: {
	                        handles: {
	                            fill: {
	                                color: DIAGRAM_HOVER
	                            },
	                            stroke: {
	                                color: INACTIVE_SHAPE
	                            }
	                        },
	                        stroke: {
	                            color: INACTIVE_SHAPE
	                        }
	                    }
	                }
	            },
	            treeMap: {
	                colors: fuse(SERIES, SERIES_LIGHT)
	            }
	        });
	    })();

	    (function() {
	        var TEXT            = "#4e4e4e";
	        var INACTIVE        = "#7f7f7f";
	        var INACTIVE_SHAPE  = "#bdbdbd";
	        var AXIS            = "#c8c8c8";
	        var AXIS_MINOR      = "#e5e5e5";
	        var SERIES          = ["#0072c6", "#5db2ff", "#008a17", "#82ba00", "#ff8f32", "#ac193d"];
	        var SERIES_LIGHT    = ["#cbe2f3", "#deeffe", "#cbe7d0", "#e5f0cb", "#fee8d5", "#eed0d7"];
	        var PRIMARY         = SERIES[0];
	        var DIAGRAM_HOVER   = WHITE;

	        function noteStyle() {
	            return {
	                icon: {
	                    background: "#00b0ff",
	                    border: {
	                        color: "#00b0ff"
	                    }
	                },
	                label: {
	                    color: "#ffffff"
	                },
	                line: {
	                    color: AXIS
	                }
	            };
	        }

	        registerTheme("office365", {
	            chart: {
	                title: {
	                    color: TEXT
	                },
	                legend: {
	                    labels: {
	                        color: TEXT
	                    },
	                    inactiveItems: {
	                        labels: {
	                            color: INACTIVE
	                        },
	                        markers: {
	                            color: INACTIVE
	                        }
	                    }
	                },
	                seriesDefaults: {
	                    labels: {
	                        color: TEXT
	                    },
	                    errorBars: {
	                        color: TEXT
	                    },
	                    notes: noteStyle(),
	                    candlestick: {
	                        downColor: AXIS,
	                        line: {
	                            color: INACTIVE_SHAPE
	                        }
	                    },
	                    area: {
	                        opacity: 0.8
	                    },
	                    waterfall: {
	                        line: {
	                            color: AXIS
	                        }
	                    },
	                    horizontalWaterfall: {
	                        line: {
	                            color: AXIS
	                        }
	                    },
	                    overlay: {
	                        gradient: "none"
	                    },
	                    border: {
	                        _brightness: 1
	                    }
	                },
	                seriesColors: SERIES,
	                axisDefaults: {
	                    line: {
	                        color: AXIS
	                    },
	                    labels: {
	                        color: TEXT
	                    },
	                    minorGridLines: {
	                        color: AXIS_MINOR
	                    },
	                    majorGridLines: {
	                        color: AXIS
	                    },
	                    title: {
	                        color: TEXT
	                    },
	                    crosshair: {
	                        color: INACTIVE
	                    },
	                    notes: noteStyle()
	                }
	            },
	            gauge: {
	                pointer: {
	                    color: PRIMARY
	                },
	                scale: {
	                    rangePlaceholderColor: AXIS,
	                    labels: {
	                        color: TEXT
	                    },
	                    minorTicks: {
	                        color: TEXT
	                    },
	                    majorTicks: {
	                        color: TEXT
	                    },
	                    line: {
	                        color: TEXT
	                    }
	                }
	            },
	            diagram: {
	                shapeDefaults: {
	                    fill: {
	                        color: PRIMARY
	                    },
	                    connectorDefaults: {
	                        fill: {
	                            color: TEXT
	                        },
	                        stroke: {
	                            color: DIAGRAM_HOVER
	                        },
	                        hover: {
	                            fill: {
	                                color: DIAGRAM_HOVER
	                            },
	                            stroke: {
	                                color: TEXT
	                            }
	                        }
	                    },
	                    content: {
	                        color: TEXT
	                    }
	                },
	                editable: {
	                    resize: {
	                        handles: {
	                            fill: {
	                                color: DIAGRAM_HOVER
	                            },
	                            stroke: {
	                                color: INACTIVE_SHAPE
	                            },
	                            hover: {
	                                fill: {
	                                    color: INACTIVE_SHAPE
	                                },
	                                stroke: {
	                                    color: INACTIVE_SHAPE
	                                }
	                            }
	                        }
	                    },
	                    rotate: {
	                        thumb: {
	                            stroke: {
	                                color: INACTIVE_SHAPE
	                            },
	                            fill: {
	                                color: INACTIVE_SHAPE
	                            }
	                        }
	                    }
	                },
	                selectable: {
	                    stroke: {
	                        color: INACTIVE_SHAPE
	                    }
	                },
	                connectionDefaults: {
	                    stroke: {
	                        color: INACTIVE_SHAPE
	                    },
	                    content: {
	                        color: INACTIVE_SHAPE
	                    },
	                    selection: {
	                        handles: {
	                            fill: {
	                                color: DIAGRAM_HOVER
	                            },
	                            stroke: {
	                                color: INACTIVE_SHAPE
	                            }
	                        },
	                        stroke: {
	                            color: INACTIVE_SHAPE
	                        }
	                    }
	                }
	            },
	            treeMap: {
	                colors: fuse(SERIES, SERIES_LIGHT)
	            }
	        });
	    })();

	        (function () {
	        var TEXT = "#32364c";
	        var INACTIVE = "#7f7f7f";
	        var INACTIVE_SHAPE = "#bdbdbd";
	        var AXIS = "#dfe0e1";
	        var AXIS_MINOR = "#dfe0e1";
	        var SERIES = ["#ff4350", "#ff9ea5", "#00acc1", "#80deea", "#ffbf46", "#ffd78c"];
	        var SERIES_LIGHT = ["#ffd9dc", "#ffeced", "#cceef3", "#e6f8fb", "#fff2da", "#fff7e8"];
	        var PRIMARY = SERIES[0];
	        var DIAGRAM_HOVER = WHITE;

	        function noteStyle() {
	            return {
	                icon: {
	                    background: "#007cc0",
	                    border: {
	                        color: "#007cc0"
	                    }
	                },
	                label: {
	                    color: "#ffffff"
	                },
	                line: {
	                    color: AXIS
	                }
	            };
	        }

	        registerTheme("nova", {
	            chart: {
	                title: {
	                    color: TEXT
	                },
	                legend: {
	                    labels: {
	                        color: TEXT
	                    },
	                    inactiveItems: {
	                        labels: {
	                            color: INACTIVE
	                        },
	                        markers: {
	                            color: INACTIVE
	                        }
	                    }
	                },
	                seriesDefaults: {
	                    labels: {
	                        color: TEXT
	                    },
	                    errorBars: {
	                        color: TEXT
	                    },
	                    notes: noteStyle(),
	                    candlestick: {
	                        downColor: AXIS,
	                        line: {
	                            color: INACTIVE_SHAPE
	                        }
	                    },
	                    area: {
	                        opacity: 0.8
	                    },
	                    waterfall: {
	                        line: {
	                            color: AXIS
	                        }
	                    },
	                    horizontalWaterfall: {
	                        line: {
	                            color: AXIS
	                        }
	                    },
	                    overlay: {
	                        gradient: "none"
	                    },
	                    border: {
	                        _brightness: 1
	                    }
	                },
	                seriesColors: SERIES,
	                axisDefaults: {
	                    line: {
	                        color: AXIS
	                    },
	                    labels: {
	                        color: TEXT
	                    },
	                    minorGridLines: {
	                        color: AXIS_MINOR
	                    },
	                    majorGridLines: {
	                        color: AXIS
	                    },
	                    title: {
	                        color: TEXT
	                    },
	                    crosshair: {
	                        color: TEXT
	                    },
	                    notes: noteStyle()
	                }
	            },
	            gauge: {
	                pointer: {
	                    color: PRIMARY
	                },
	                scale: {
	                    rangePlaceholderColor: AXIS,
	                    labels: {
	                        color: TEXT
	                    },
	                    minorTicks: {
	                        color: TEXT
	                    },
	                    majorTicks: {
	                        color: TEXT
	                    },
	                    line: {
	                        color: TEXT
	                    }
	                }
	            },
	            diagram: {
	                shapeDefaults: {
	                    fill: {
	                        color: PRIMARY
	                    },
	                    connectorDefaults: {
	                        fill: {
	                            color: TEXT
	                        },
	                        stroke: {
	                            color: DIAGRAM_HOVER
	                        },
	                        hover: {
	                            fill: {
	                                color: DIAGRAM_HOVER
	                            },
	                            stroke: {
	                                color: TEXT
	                            }
	                        }
	                    },
	                    content: {
	                        color: TEXT
	                    }
	                },
	                editable: {
	                    resize: {
	                        handles: {
	                            fill: {
	                                color: DIAGRAM_HOVER
	                            },
	                            stroke: {
	                                color: INACTIVE_SHAPE
	                            },
	                            hover: {
	                                fill: {
	                                    color: INACTIVE_SHAPE
	                                },
	                                stroke: {
	                                    color: INACTIVE_SHAPE
	                                }
	                            }
	                        }
	                    },
	                    rotate: {
	                        thumb: {
	                            stroke: {
	                                color: INACTIVE_SHAPE
	                            },
	                            fill: {
	                                color: INACTIVE_SHAPE
	                            }
	                        }
	                    }
	                },
	                selectable: {
	                    stroke: {
	                        color: INACTIVE_SHAPE
	                    }
	                },
	                connectionDefaults: {
	                    stroke: {
	                        color: INACTIVE_SHAPE
	                    },
	                    content: {
	                        color: INACTIVE_SHAPE
	                    },
	                    selection: {
	                        handles: {
	                            fill: {
	                                color: DIAGRAM_HOVER
	                            },
	                            stroke: {
	                                color: INACTIVE_SHAPE
	                            }
	                        },
	                        stroke: {
	                            color: INACTIVE_SHAPE
	                        }
	                    }
	                }
	            },
	            treeMap: {
	                colors: fuse(SERIES, SERIES_LIGHT)
	            }
	        });
	    })();

	    (function () {
	        var SERIES = ["#ff6358", "#ffd246", "#78d237", "#28b4c8", "#2d73f5", "#aa46be"];
	        var SERIES_LIGHT = ["#ffd9dc", "#ffeced", "#cceef3", "#e6f8fb", "#fff2da", "#fff7e8"];

	        registerTheme("default-v2", {
	            chart: { /* read from DOM */ },
	            gauge: { /* read from DOM */ },
	            diagram: { /* read from DOM */ },
	            treeMap: {
	                colors: fuse(SERIES, SERIES_LIGHT)
	            }
	        });

	        themes.sass = themes["default-v2"];
	    })();



	    (function () {
	        var TEXT = "#292b2c";
	        var AXIS = "rgba(0, 0, 0, .04)";
	        var SERIES = ["#0275d8", "#5bc0de", "#5cb85c", "#f0ad4e", "#e67d4a", "#d9534f"];
	        var SERIES_LIGHT = ["#ffd9dc", "#ffeced", "#cceef3", "#e6f8fb", "#fff2da", "#fff7e8"];
	        var PRIMARY = SERIES[0];

	        registerTheme("bootstrap-v4", {
	            chart: { /* read from DOM */ },
	            gauge: {
	                pointer: {
	                    color: PRIMARY
	                },
	                scale: {
	                    rangePlaceholderColor: AXIS,
	                    labels: {
	                        color: TEXT
	                    },
	                    minorTicks: {
	                        color: TEXT
	                    },
	                    majorTicks: {
	                        color: TEXT
	                    },
	                    line: {
	                        color: TEXT
	                    }
	                }
	            },
	            diagram: { /* read from DOM */ },
	            treeMap: {
	                colors: fuse(SERIES, SERIES_LIGHT)
	            }
	        });
	    })();

	    function fuse(arr1, arr2) {
	        return $.map(arr1, function(item, index) {
	            return [
	                [item, arr2[index]]
	            ];
	        });
	    }

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 943:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("vkLX");

/***/ })

/******/ });

/***/ }),

/***/ "LT3F":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1175);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FZAa");

/***/ }),

/***/ 1175:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1088) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "draganddrop",
	    name: "Drag & drop",
	    category: "framework",
	    description: "Drag & drop functionality for any DOM element.",
	    depends: [ "core", "userevents" ]
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        support = kendo.support,
	        document = window.document,
	        $window = $(window),
	        Class = kendo.Class,
	        Widget = kendo.ui.Widget,
	        Observable = kendo.Observable,
	        UserEvents = kendo.UserEvents,
	        proxy = $.proxy,
	        extend = $.extend,
	        getOffset = kendo.getOffset,
	        draggables = {},
	        dropTargets = {},
	        dropAreas = {},
	        lastDropTarget,
	        elementUnderCursor = kendo.elementUnderCursor,
	        KEYUP = "keyup",
	        CHANGE = "change",

	        // Draggable events
	        DRAGSTART = "dragstart",
	        HOLD = "hold",
	        DRAG = "drag",
	        DRAGEND = "dragend",
	        DRAGCANCEL = "dragcancel",
	        HINTDESTROYED = "hintDestroyed",

	        // DropTarget events
	        DRAGENTER = "dragenter",
	        DRAGLEAVE = "dragleave",
	        DROP = "drop";

	    function contains(parent, child) {
	        try {
	            return $.contains(parent, child) || parent == child;
	        } catch (e) {
	            return false;
	        }
	    }

	    function numericCssPropery(element, property) {
	        return parseInt(element.css(property), 10) || 0;
	    }

	    function within(value, range) {
	        return Math.min(Math.max(value, range.min), range.max);
	    }

	    function containerBoundaries(container, element) {
	        var offset = getOffset(container),
	            outerWidth = kendo._outerWidth,
	            outerHeight = kendo._outerHeight,
	            minX = offset.left + numericCssPropery(container, "borderLeftWidth") + numericCssPropery(container, "paddingLeft"),
	            minY = offset.top + numericCssPropery(container, "borderTopWidth") + numericCssPropery(container, "paddingTop"),
	            maxX = minX + container.width() - outerWidth(element, true),
	            maxY = minY + container.height() - outerHeight(element, true);

	        return {
	            x: { min: minX, max: maxX },
	            y: { min: minY, max: maxY }
	        };
	    }

	    function checkTarget(target, targets, areas) {
	        var theTarget, theFilter, i = 0,
	            targetLen = targets && targets.length,
	            areaLen = areas && areas.length;

	        while (target && target.parentNode) {
	            for (i = 0; i < targetLen; i ++) {
	                theTarget = targets[i];
	                if (theTarget.element[0] === target) {
	                    return { target: theTarget, targetElement: target };
	                }
	            }

	            for (i = 0; i < areaLen; i ++) {
	                theFilter = areas[i];
	                if ($.contains(theFilter.element[0], target) && support.matchesSelector.call(target, theFilter.options.filter)) {
	                    return { target: theFilter, targetElement: target };
	                }
	            }

	            target = target.parentNode;
	        }

	        return undefined;
	    }

	    var TapCapture = Observable.extend({
	        init: function(element, options) {
	            var that = this,
	                domElement = element[0];

	            that.capture = false;

	            if (domElement.addEventListener) {
	                $.each(kendo.eventMap.down.split(" "), function() {
	                    domElement.addEventListener(this, proxy(that._press, that), true);
	                });
	                $.each(kendo.eventMap.up.split(" "), function() {
	                    domElement.addEventListener(this, proxy(that._release, that), true);
	                });
	            } else {
	                $.each(kendo.eventMap.down.split(" "), function() {
	                    domElement.attachEvent(this, proxy(that._press, that));
	                });
	                $.each(kendo.eventMap.up.split(" "), function() {
	                    domElement.attachEvent(this, proxy(that._release, that));
	                });
	            }

	            Observable.fn.init.call(that);

	            that.bind(["press", "release"], options || {});
	        },

	        captureNext: function() {
	            this.capture = true;
	        },

	        cancelCapture: function() {
	            this.capture = false;
	        },

	        _press: function(e) {
	            var that = this;
	            that.trigger("press");
	            if (that.capture) {
	                e.preventDefault();
	            }
	        },

	        _release: function(e) {
	            var that = this;
	            that.trigger("release");

	            if (that.capture) {
	                e.preventDefault();
	                that.cancelCapture();
	            }
	        }
	    });

	    var PaneDimension = Observable.extend({
	        init: function(options) {
	            var that = this;
	            Observable.fn.init.call(that);

	            that.forcedEnabled = false;

	            $.extend(that, options);

	            that.scale = 1;

	            if (that.horizontal) {
	                that.measure = "offsetWidth";
	                that.scrollSize = "scrollWidth";
	                that.axis = "x";
	            } else {
	                that.measure = "offsetHeight";
	                that.scrollSize = "scrollHeight";
	                that.axis = "y";
	            }
	        },

	        makeVirtual: function() {
	            $.extend(this, {
	                virtual: true,
	                forcedEnabled: true,
	                _virtualMin: 0,
	                _virtualMax: 0
	            });
	        },

	        virtualSize: function(min, max) {
	            if (this._virtualMin !== min || this._virtualMax !== max) {
	                this._virtualMin = min;
	                this._virtualMax = max;
	                this.update();
	            }
	        },

	        outOfBounds: function(offset) {
	            return offset > this.max || offset < this.min;
	        },

	        forceEnabled: function() {
	            this.forcedEnabled = true;
	        },

	        getSize: function() {
	            return this.container[0][this.measure];
	        },

	        getTotal: function() {
	            return this.element[0][this.scrollSize];
	        },

	        rescale: function(scale) {
	            this.scale = scale;
	        },

	        update: function(silent) {
	            var that = this,
	                total = that.virtual ? that._virtualMax : that.getTotal(),
	                scaledTotal = total * that.scale,
	                size = that.getSize();

	            if (total === 0 && !that.forcedEnabled) {
	                return; // we are not visible.
	            }

	            that.max = that.virtual ? -that._virtualMin : 0;
	            that.size = size;
	            that.total = scaledTotal;
	            that.min = Math.min(that.max, size - scaledTotal);
	            that.minScale = size / total;
	            that.centerOffset = (scaledTotal - size) / 2;

	            that.enabled = that.forcedEnabled || (scaledTotal > size);

	            if (!silent) {
	                that.trigger(CHANGE, that);
	            }
	        }
	    });

	    var PaneDimensions = Observable.extend({
	        init: function(options) {
	            var that = this;

	            Observable.fn.init.call(that);

	            that.x = new PaneDimension(extend({horizontal: true}, options));
	            that.y = new PaneDimension(extend({horizontal: false}, options));
	            that.container = options.container;
	            that.forcedMinScale = options.minScale;
	            that.maxScale = options.maxScale || 100;

	            that.bind(CHANGE, options);
	        },

	        rescale: function(newScale) {
	            this.x.rescale(newScale);
	            this.y.rescale(newScale);
	            this.refresh();
	        },

	        centerCoordinates: function() {
	            return { x: Math.min(0, -this.x.centerOffset), y: Math.min(0, -this.y.centerOffset) };
	        },

	        refresh: function() {
	            var that = this;
	            that.x.update();
	            that.y.update();
	            that.enabled = that.x.enabled || that.y.enabled;
	            that.minScale = that.forcedMinScale || Math.min(that.x.minScale, that.y.minScale);
	            that.fitScale = Math.max(that.x.minScale, that.y.minScale);
	            that.trigger(CHANGE);
	        }
	    });

	    var PaneAxis = Observable.extend({
	        init: function(options) {
	            var that = this;
	            extend(that, options);
	            Observable.fn.init.call(that);
	        },

	        outOfBounds: function() {
	            return this.dimension.outOfBounds(this.movable[this.axis]);
	        },

	        dragMove: function(delta) {
	            var that = this,
	                dimension = that.dimension,
	                axis = that.axis,
	                movable = that.movable,
	                position = movable[axis] + delta;

	            if (!dimension.enabled) {
	                return;
	            }

	            if ((position < dimension.min && delta < 0) || (position > dimension.max && delta > 0)) {
	                delta *= that.resistance;
	            }

	            movable.translateAxis(axis, delta);
	            that.trigger(CHANGE, that);
	        }
	    });

	    var Pane = Class.extend({

	        init: function(options) {
	            var that = this,
	                x,
	                y,
	                resistance,
	                movable;

	            extend(that, {elastic: true}, options);

	            resistance = that.elastic ? 0.5 : 0;
	            movable = that.movable;

	            that.x = x = new PaneAxis({
	                axis: "x",
	                dimension: that.dimensions.x,
	                resistance: resistance,
	                movable: movable
	            });

	            that.y = y = new PaneAxis({
	                axis: "y",
	                dimension: that.dimensions.y,
	                resistance: resistance,
	                movable: movable
	            });

	            that.userEvents.bind(["press", "move", "end", "gesturestart", "gesturechange"], {
	                gesturestart: function(e) {
	                    that.gesture = e;
	                    that.offset = that.dimensions.container.offset();
	                },

	                press: function(e) {
	                    if ($(e.event.target).closest("a").is("[data-navigate-on-press=true]")) {
	                        e.sender.cancel();
	                    }
	                },

	                gesturechange: function(e) {
	                    var previousGesture = that.gesture,
	                        previousCenter = previousGesture.center,

	                        center = e.center,

	                        scaleDelta = e.distance / previousGesture.distance,

	                        minScale = that.dimensions.minScale,
	                        maxScale = that.dimensions.maxScale,
	                        coordinates;

	                    if (movable.scale <= minScale && scaleDelta < 1) {
	                        // Resist shrinking. Instead of shrinking from 1 to 0.5, it will shrink to 0.5 + (1 /* minScale */ - 0.5) * 0.8 = 0.9;
	                        scaleDelta += (1 - scaleDelta) * 0.8;
	                    }

	                    if (movable.scale * scaleDelta >= maxScale) {
	                        scaleDelta = maxScale / movable.scale;
	                    }

	                    var offsetX = movable.x + that.offset.left,
	                        offsetY = movable.y + that.offset.top;

	                    coordinates = {
	                        x: (offsetX - previousCenter.x) * scaleDelta + center.x - offsetX,
	                        y: (offsetY - previousCenter.y) * scaleDelta + center.y - offsetY
	                    };

	                    movable.scaleWith(scaleDelta);

	                    x.dragMove(coordinates.x);
	                    y.dragMove(coordinates.y);

	                    that.dimensions.rescale(movable.scale);
	                    that.gesture = e;
	                    e.preventDefault();
	                },

	                move: function(e) {
	                    if (e.event.target.tagName.match(/textarea|input/i)) {
	                        return;
	                    }

	                    if (x.dimension.enabled || y.dimension.enabled) {
	                        x.dragMove(e.x.delta);
	                        y.dragMove(e.y.delta);
	                        e.preventDefault();
	                    } else {
	                        e.touch.skip();
	                    }
	                },

	                end: function(e) {
	                    e.preventDefault();
	                }
	            });
	        }
	    });

	    var TRANSFORM_STYLE = support.transitions.prefix + "Transform",
	        translate;


	    if (support.hasHW3D) {
	        translate = function(x, y, scale) {
	            return "translate3d(" + x + "px," + y +"px,0) scale(" + scale + ")";
	        };
	    } else {
	        translate = function(x, y, scale) {
	            return "translate(" + x + "px," + y +"px) scale(" + scale + ")";
	        };
	    }

	    var Movable = Observable.extend({
	        init: function(element) {
	            var that = this;

	            Observable.fn.init.call(that);

	            that.element = $(element);
	            that.element[0].style.webkitTransformOrigin = "left top";
	            that.x = 0;
	            that.y = 0;
	            that.scale = 1;
	            that._saveCoordinates(translate(that.x, that.y, that.scale));
	        },

	        translateAxis: function(axis, by) {
	            this[axis] += by;
	            this.refresh();
	        },

	        scaleTo: function(scale) {
	            this.scale = scale;
	            this.refresh();
	        },

	        scaleWith: function(scaleDelta) {
	            this.scale *= scaleDelta;
	            this.refresh();
	        },

	        translate: function(coordinates) {
	            this.x += coordinates.x;
	            this.y += coordinates.y;
	            this.refresh();
	        },

	        moveAxis: function(axis, value) {
	            this[axis] = value;
	            this.refresh();
	        },

	        moveTo: function(coordinates) {
	            extend(this, coordinates);
	            this.refresh();
	        },

	        refresh: function() {
	            var that = this,
	                x = that.x,
	                y = that.y,
	                newCoordinates;

	            if (that.round) {
	                x = Math.round(x);
	                y = Math.round(y);
	            }

	            newCoordinates = translate(x, y, that.scale);

	            if (newCoordinates != that.coordinates) {
	                if (kendo.support.browser.msie && kendo.support.browser.version < 10) {
	                    that.element[0].style.position = "absolute";
	                    that.element[0].style.left = that.x + "px";
	                    that.element[0].style.top = that.y + "px";

	                } else {
	                    that.element[0].style[TRANSFORM_STYLE] = newCoordinates;
	                }
	                that._saveCoordinates(newCoordinates);
	                that.trigger(CHANGE);
	            }
	        },

	        _saveCoordinates: function(coordinates) {
	            this.coordinates = coordinates;
	        }
	    });

	    function destroyDroppable(collection, widget) {
	        var groupName = widget.options.group,
	        droppables = collection[groupName],
	        i;

	        Widget.fn.destroy.call(widget);

	        if (droppables.length > 1) {
	            for (i = 0; i < droppables.length; i++) {
	                if (droppables[i] == widget) {
	                    droppables.splice(i, 1);
	                    break;
	                }
	            }
	        } else {
	            droppables.length = 0; // WTF, porting this from the previous destroyGroup
	            delete collection[groupName];
	        }
	    }

	    var DropTarget = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            var group = that.options.group;

	            if (!(group in dropTargets)) {
	                dropTargets[group] = [ that ];
	            } else {
	                dropTargets[group].push( that );
	            }
	        },

	        events: [
	            DRAGENTER,
	            DRAGLEAVE,
	            DROP
	        ],

	        options: {
	            name: "DropTarget",
	            group: "default"
	        },

	        destroy: function() {
	            destroyDroppable(dropTargets, this);
	        },

	        _trigger: function(eventName, e) {
	            var that = this,
	                draggable = draggables[that.options.group];

	            if (draggable) {
	                return that.trigger(eventName, extend({}, e.event, {
	                           draggable: draggable,
	                           dropTarget: e.dropTarget
	                       }));
	            }
	        },

	        _over: function(e) {
	            this._trigger(DRAGENTER, e);
	        },

	        _out: function(e) {
	            this._trigger(DRAGLEAVE, e);
	        },

	        _drop: function(e) {
	            var that = this,
	                draggable = draggables[that.options.group];

	            if (draggable) {
	                draggable.dropped = !that._trigger(DROP, e);
	            }
	        }
	    });

	    DropTarget.destroyGroup = function(groupName) {
	        var group = dropTargets[groupName] || dropAreas[groupName],
	            i;

	        if (group) {
	            for (i = 0; i < group.length; i++) {
	                Widget.fn.destroy.call(group[i]);
	            }

	            group.length = 0;
	            delete dropTargets[groupName];
	            delete dropAreas[groupName];
	        }
	    };

	    DropTarget._cache = dropTargets;

	    var DropTargetArea = DropTarget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            var group = that.options.group;

	            if (!(group in dropAreas)) {
	                dropAreas[group] = [ that ];
	            } else {
	                dropAreas[group].push( that );
	            }
	        },

	        destroy: function() {
	            destroyDroppable(dropAreas, this);
	        },

	        options: {
	            name: "DropTargetArea",
	            group: "default",
	            filter: null
	        }
	    });

	    var Draggable = Widget.extend({
	        init: function (element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            that._activated = false;

	            that.userEvents = new UserEvents(that.element, {
	                global: true,
	                allowSelection: true,
	                filter: that.options.filter,
	                threshold: that.options.distance,
	                start: proxy(that._start, that),
	                hold: proxy(that._hold, that),
	                move: proxy(that._drag, that),
	                end: proxy(that._end, that),
	                cancel: proxy(that._cancel, that),
	                select: proxy(that._select, that)
	            });

	            if (kendo.support.touch) {
	                that.element.find(that.options.filter).css('touch-action', 'none');
	            }

	            that._afterEndHandler = proxy(that._afterEnd, that);
	            that._captureEscape = proxy(that._captureEscape, that);
	        },

	        events: [
	            HOLD,
	            DRAGSTART,
	            DRAG,
	            DRAGEND,
	            DRAGCANCEL,
	            HINTDESTROYED
	        ],

	        options: {
	            name: "Draggable",
	            distance: ( kendo.support.touch ? 0 : 5),
	            group: "default",
	            cursorOffset: null,
	            axis: null,
	            container: null,
	            filter: null,
	            ignore: null,
	            holdToDrag: false,
	            autoScroll: false,
	            dropped: false
	        },

	        cancelHold: function() {
	            this._activated = false;
	        },

	        _captureEscape: function(e) {
	            var that = this;

	            if (e.keyCode === kendo.keys.ESC) {
	                that._trigger(DRAGCANCEL, { event: e });
	                that.userEvents.cancel();
	            }
	        },

	        _updateHint: function(e) {
	            var that = this,
	                coordinates,
	                options = that.options,
	                boundaries = that.boundaries,
	                axis = options.axis,
	                cursorOffset = that.options.cursorOffset;

	            if (cursorOffset) {
	               coordinates = { left: e.x.location + cursorOffset.left, top: e.y.location + cursorOffset.top };
	            } else {
	                that.hintOffset.left += e.x.delta;
	                that.hintOffset.top += e.y.delta;
	                coordinates = $.extend({}, that.hintOffset);
	            }

	            if (boundaries) {
	                coordinates.top = within(coordinates.top, boundaries.y);
	                coordinates.left = within(coordinates.left, boundaries.x);
	            }

	            if (axis === "x") {
	                delete coordinates.top;
	            } else if (axis === "y") {
	                delete coordinates.left;
	            }

	            that.hint.css(coordinates);
	        },

	        _shouldIgnoreTarget: function(target) {
	            var ignoreSelector = this.options.ignore;
	            return ignoreSelector && $(target).is(ignoreSelector);
	        },

	        _select: function(e) {
	            if (!this._shouldIgnoreTarget(e.event.target)) {
	                e.preventDefault();
	            }
	        },

	        _start: function(e) {
	            var that = this,
	                options = that.options,
	                container = options.container ? $(options.container): null,
	                hint = options.hint;

	            if (this._shouldIgnoreTarget(e.touch.initialTouch) || (options.holdToDrag && !that._activated)) {
	                that.userEvents.cancel();
	                return;
	            }

	            that.currentTarget = e.target;
	            that.currentTargetOffset = getOffset(that.currentTarget);

	            if (hint) {
	                if (that.hint) {
	                    that.hint.stop(true, true).remove();
	                }

	                that.hint = kendo.isFunction(hint) ? $(hint.call(that, that.currentTarget)) : hint;

	                var offset = getOffset(that.currentTarget);
	                that.hintOffset = offset;

	                that.hint.css( {
	                    position: "absolute",
	                    zIndex: 20000, // the Window's z-index is 10000 and can be raised because of z-stacking
	                    left: offset.left,
	                    top: offset.top
	                })
	                .appendTo(document.body);

	                that.angular("compile", function(){
	                    that.hint.removeAttr("ng-repeat");
	                    var scopeTarget = $(e.target);

	                    while (!scopeTarget.data("$$kendoScope") && scopeTarget.length) {
	                        scopeTarget = scopeTarget.parent();
	                    }

	                    return {
	                        elements: that.hint.get(),
	                        scopeFrom: scopeTarget.data("$$kendoScope")
	                    };
	                });
	            }

	            draggables[options.group] = that;

	            that.dropped = false;

	            if (container) {
	                that.boundaries = containerBoundaries(container, that.hint);
	            }

	            $(document).on(KEYUP, that._captureEscape);

	            if (that._trigger(DRAGSTART, e)) {
	                that.userEvents.cancel();
	                that._afterEnd();
	            }

	            that.userEvents.capture();
	        },

	        _hold: function(e) {
	            this.currentTarget = e.target;

	            if (this._trigger(HOLD, e)) {
	                this.userEvents.cancel();
	            } else {
	                this._activated = true;
	            }
	        },

	        _drag: function(e) {
	            e.preventDefault();

	            var cursorElement = this._elementUnderCursor(e);

	            if (this.options.autoScroll && this._cursorElement !== cursorElement) {
	                this._scrollableParent = findScrollableParent(cursorElement);
	                this._cursorElement = cursorElement;
	            }

	            this._lastEvent = e;
	            this._processMovement(e, cursorElement);

	            if (this.options.autoScroll) {
	                // chrome seems to trigger mousemove when mouse is moved outside of the window (over the Chrome), too.
	                if (this._scrollableParent[0]) {
	                    var velocity = autoScrollVelocity(e.x.location, e.y.location, scrollableViewPort(this._scrollableParent));


	                    this._scrollCompenstation = $.extend({}, this.hintOffset);
	                    this._scrollVelocity = velocity;

	                    if (velocity.y === 0 && velocity.x === 0) {
	                        clearInterval(this._scrollInterval);
	                        this._scrollInterval = null;
	                    } else if(!this._scrollInterval) {
	                        this._scrollInterval = setInterval($.proxy(this, "_autoScroll"), 50);
	                    }
	                }
	            }

	            if (this.hint) {
	                this._updateHint(e);
	            }
	        },

	        _processMovement: function(e, cursorElement) {
	            this._withDropTarget(cursorElement, function(target, targetElement) {
	                if (!target) {
	                    if (lastDropTarget) {
	                        lastDropTarget._trigger(DRAGLEAVE, extend(e, { dropTarget: $(lastDropTarget.targetElement) }));
	                        lastDropTarget = null;
	                    }
	                    return;
	                }

	                if (lastDropTarget) {
	                    if (targetElement === lastDropTarget.targetElement) {
	                        return;
	                    }

	                    lastDropTarget._trigger(DRAGLEAVE, extend(e, { dropTarget: $(lastDropTarget.targetElement) }));
	                }

	                target._trigger(DRAGENTER, extend(e, { dropTarget: $(targetElement) }));
	                lastDropTarget = extend(target, { targetElement: targetElement });
	            });

	            this._trigger(DRAG, extend(e, { dropTarget: lastDropTarget, elementUnderCursor: cursorElement }));
	        },

	        _autoScroll: function() {
	            var parent = this._scrollableParent[0],
	                velocity = this._scrollVelocity,
	                compensation = this._scrollCompenstation;

	            if (!parent) {
	                return;
	            }

	            var cursorElement = this._elementUnderCursor(this._lastEvent);
	            this._processMovement(this._lastEvent, cursorElement);

	            var yIsScrollable, xIsScrollable;

	            var isRootNode = parent === scrollableRoot()[0];

	            if (isRootNode) {
	                yIsScrollable = document.body.scrollHeight > $window.height();
	                xIsScrollable = document.body.scrollWidth > $window.width();
	            } else {
	                yIsScrollable = parent.offsetHeight <= parent.scrollHeight;
	                xIsScrollable = parent.offsetWidth <= parent.scrollWidth;
	            }

	            var yDelta = parent.scrollTop + velocity.y;
	            var yInBounds = yIsScrollable && yDelta > 0 && yDelta < parent.scrollHeight;

	            var xDelta = parent.scrollLeft + velocity.x;
	            var xInBounds = xIsScrollable && xDelta > 0 && xDelta < parent.scrollWidth;

	            if (yInBounds) {
	                parent.scrollTop += velocity.y;
	            }

	            if (xInBounds) {
	                parent.scrollLeft += velocity.x;
	            }

	            if (this.hint && isRootNode && (xInBounds || yInBounds)) {
	                if (yInBounds) {
	                    compensation.top += velocity.y;
	                }

	                if (xInBounds) {
	                    compensation.left += velocity.x;
	                }

	                this.hint.css(compensation);
	            }
	        },

	        _end: function(e) {
	            this._withDropTarget(this._elementUnderCursor(e), function(target, targetElement) {
	                if (target) {
	                    target._drop(extend({}, e, { dropTarget: $(targetElement) }));
	                    lastDropTarget = null;
	                }
	            });

	            this._cancel(this._trigger(DRAGEND, e));
	        },

	        _cancel: function(isDefaultPrevented) {
	            var that = this;

	            that._scrollableParent = null;
	            this._cursorElement = null;
	            clearInterval(this._scrollInterval);
	            that._activated = false;

	            if (that.hint && !that.dropped) {
	                setTimeout(function() {
	                    that.hint.stop(true, true);

	                    if (isDefaultPrevented) {
	                        that._afterEndHandler();
	                    } else {
	                        that.hint.animate(that.currentTargetOffset, "fast", that._afterEndHandler);
	                    }
	                }, 0);

	            } else {
	                that._afterEnd();
	            }
	        },

	        _trigger: function(eventName, e) {
	            var that = this;

	            return that.trigger(
	                eventName, extend(
	                {},
	                e.event,
	                {
	                    x: e.x,
	                    y: e.y,
	                    currentTarget: that.currentTarget,
	                    initialTarget: e.touch ? e.touch.initialTouch : null,
	                    dropTarget: e.dropTarget,
	                    elementUnderCursor: e.elementUnderCursor
	                }
	            ));
	        },

	        _elementUnderCursor: function(e) {
	            var target = elementUnderCursor(e),
	                hint = this.hint;

	            if (hint && contains(hint[0], target)) {
	                hint.hide();
	                target = elementUnderCursor(e);
	                // IE8 does not return the element in iframe from first attempt
	                if (!target) {
	                    target = elementUnderCursor(e);
	                }
	                hint.show();
	            }

	            return target;
	        },

	        _withDropTarget: function(element, callback) {
	            var result,
	                group = this.options.group,
	                targets = dropTargets[group],
	                areas = dropAreas[group];

	            if (targets && targets.length || areas && areas.length) {
	                result = checkTarget(element, targets, areas);

	                if (result) {
	                    callback(result.target, result.targetElement);
	                } else {
	                    callback();
	                }
	            }
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            that._afterEnd();

	            that.userEvents.destroy();

	            this._scrollableParent = null;
	            this._cursorElement = null;
	            clearInterval(this._scrollInterval);

	            that.currentTarget = null;
	        },

	        _afterEnd: function() {
	            var that = this;

	            if (that.hint) {
	                that.hint.remove();
	            }

	            delete draggables[that.options.group];

	            that.trigger("destroy");
	            that.trigger(HINTDESTROYED);
	            $(document).off(KEYUP, that._captureEscape);
	        }
	    });

	    kendo.ui.plugin(DropTarget);
	    kendo.ui.plugin(DropTargetArea);
	    kendo.ui.plugin(Draggable);
	    kendo.TapCapture = TapCapture;
	    kendo.containerBoundaries = containerBoundaries;

	    extend(kendo.ui, {
	        Pane: Pane,
	        PaneDimensions: PaneDimensions,
	        Movable: Movable
	    });

	    function scrollableViewPort(element) {
	        var root = scrollableRoot()[0],
	            offset,
	            top,
	            left;

	        if (element[0] === root) {
	            top = root.scrollTop;
	            left = root.scrollLeft;

	            return {
	                top: top,
	                left: left,
	                bottom: top + $window.height(),
	                right: left + $window.width()
	            };
	        } else {
	            offset = element.offset();
	            offset.bottom = offset.top + element.height();
	            offset.right =  offset.left + element.width();
	            return offset;
	        }
	    }

	    function scrollableRoot() {
	        return $(kendo.support.browser.edge || kendo.support.browser.safari ? document.body : document.documentElement);
	    }

	    function findScrollableParent(element) {
	        var root = scrollableRoot();

	        if (!element || element === document.body || element === document.documentElement) {
	            return root;
	        }

	        var parent = $(element)[0];

	        while (parent && !kendo.isScrollable(parent) && parent !== document.body) {
	            parent = parent.parentNode;
	        }

	        if (parent === document.body) {
	            return root;
	        }

	        return $(parent);
	    }

	    function autoScrollVelocity(mouseX, mouseY, rect) {
	        var velocity = { x: 0, y: 0 };

	        var AUTO_SCROLL_AREA = 50;

	        if (mouseX - rect.left < AUTO_SCROLL_AREA) {
	            velocity.x = -(AUTO_SCROLL_AREA - (mouseX - rect.left));
	        } else if (rect.right - mouseX < AUTO_SCROLL_AREA) {
	            velocity.x = AUTO_SCROLL_AREA - (rect.right - mouseX);
	        }

	        if (mouseY - rect.top < AUTO_SCROLL_AREA) {
	            velocity.y = -(AUTO_SCROLL_AREA - (mouseY - rect.top));
	        } else if (rect.bottom - mouseY < AUTO_SCROLL_AREA) {
	            velocity.y = AUTO_SCROLL_AREA - (rect.bottom - mouseY);
	        }

	        return velocity;
	    }

	    // export for testing
	    kendo.ui.Draggable.utils = {
	        autoScrollVelocity: autoScrollVelocity,
	        scrollableViewPort: scrollableViewPort,
	        findScrollableParent: findScrollableParent
	    };

	 })(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "LUKJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1023);
	module.exports = __webpack_require__(1023);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 962:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("oSV6");

/***/ }),

/***/ 1023:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(962), __webpack_require__(1024) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, kendo){


	kendo.ExcelMixin = {
	    extend: function(proto) {
	       proto.events.push("excelExport");
	       proto.options.excel = $.extend(proto.options.excel, this.options);
	       proto.saveAsExcel = this.saveAsExcel;
	    },
	    options: {
	        proxyURL: "",
	        allPages: false,
	        filterable: false,
	        fileName: "Export.xlsx",
	        collapsible: false
	    },
	    saveAsExcel: function() {
	        var excel = this.options.excel || {};

	        var exporter = new kendo.ExcelExporter({
	            columns: this.columns,
	            dataSource: this.dataSource,
	            allPages: excel.allPages,
	            filterable: excel.filterable,
	            hierarchy: excel.hierarchy,
	            collapsible: excel.collapsible
	        });

	        exporter.workbook().then($.proxy(function(book, data) {
	            if (!this.trigger("excelExport", { workbook: book, data: data })) {
	                var workbook = new kendo.ooxml.Workbook(book);

	                if(!workbook.options) {
	                    workbook.options = {};
	                }
	                workbook.options.skipCustomHeight = true;

	                workbook.toDataURLAsync().then(function(dataURI) {
	                    kendo.saveAs({
	                        dataURI: dataURI,
	                        fileName: book.fileName || excel.fileName,
	                        proxyURL: excel.proxyURL,
	                        forceProxy: excel.forceProxy
	                    });
	                });

	            }
	        }, this));
	    }
	};

	})(kendo.jQuery, kendo);

	return kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1024:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("tHOz");

/***/ })

/******/ });

/***/ }),

/***/ "Lgyv":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * vue-material v1.0.0-beta-7
 * Made with <3 by marcosmoura 2017
 * Released under the MIT License.
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__("7+uW"));
	else if(typeof define === 'function' && define.amd)
		define(["vue"], factory);
	else if(typeof exports === 'object')
		exports["VueMaterial"] = factory(require("vue"));
	else
		root["VueMaterial"] = factory(root["Vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_7__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 54);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(56);

var _MdReactive = __webpack_require__(28);

var _MdReactive2 = _interopRequireDefault(_MdReactive);

var _MdTheme = __webpack_require__(29);

var _MdTheme2 = _interopRequireDefault(_MdTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = function init() {
  var material = new _MdReactive2.default({
    ripple: true,
    theming: {},
    locale: {
      startYear: 1900,
      endYear: 2099,
      dateFormat: 'YYYY-MM-DD',
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      shorterDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      shorterMonths: ['J', 'F', 'M', 'A', 'M', 'Ju', 'Ju', 'A', 'Se', 'O', 'N', 'D']
    }
  });

  Object.defineProperties(material.theming, {
    metaColors: {
      get: function get() {
        return _MdTheme2.default.metaColors;
      },
      set: function set(metaColors) {
        _MdTheme2.default.metaColors = metaColors;
      }
    },
    theme: {
      get: function get() {
        return _MdTheme2.default.theme;
      },
      set: function set(theme) {
        _MdTheme2.default.theme = theme;
      }
    },
    enabled: {
      get: function get() {
        return _MdTheme2.default.enabled;
      },
      set: function set(enabled) {
        _MdTheme2.default.enabled = enabled;
      }
    }
  });

  return material;
};

exports.default = function (Vue) {
  if (!Vue.material) {
    Vue.material = init();
    Vue.prototype.$material = Vue.material;
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (newComponent) {
  var defaults = {
    props: {
      mdTheme: null
    },
    computed: {
      $mdActiveTheme: function $mdActiveTheme() {
        var enabled = _MdTheme2.default.enabled,
            getThemeName = _MdTheme2.default.getThemeName,
            getAncestorTheme = _MdTheme2.default.getAncestorTheme;


        if (enabled && this.mdTheme !== false) {
          return getThemeName(this.mdTheme || getAncestorTheme(this));
        }

        return null;
      }
    }
  };

  return (0, _deepmerge2.default)(defaults, newComponent);
};

var _MdTheme = __webpack_require__(29);

var _MdTheme2 = _interopRequireDefault(_MdTheme);

var _deepmerge = __webpack_require__(30);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__(36)

var MILLISECONDS_IN_HOUR = 3600000
var MILLISECONDS_IN_MINUTE = 60000
var DEFAULT_ADDITIONAL_DIGITS = 2

var parseTokenDateTimeDelimeter = /[T ]/
var parseTokenPlainTime = /:/

// year tokens
var parseTokenYY = /^(\d{2})$/
var parseTokensYYY = [
  /^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
]

var parseTokenYYYY = /^(\d{4})/
var parseTokensYYYYY = [
  /^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
]

// date tokens
var parseTokenMM = /^-(\d{2})$/
var parseTokenDDD = /^-?(\d{3})$/
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
var parseTokenWww = /^-?W(\d{2})$/
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/

// time tokens
var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/

// timezone tokens
var parseTokenTimezone = /([Z+-].*)$/
var parseTokenTimezoneZ = /^(Z)$/
var parseTokenTimezoneHH = /^([+-])(\d{2})$/
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/

/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function parse (argument, dirtyOptions) {
  if (isDate(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var options = dirtyOptions || {}
  var additionalDigits = options.additionalDigits
  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
  } else {
    additionalDigits = Number(additionalDigits)
  }

  var dateStrings = splitDateString(argument)

  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
  var year = parseYearResult.year
  var restDateString = parseYearResult.restDateString

  var date = parseDate(restDateString, year)

  if (date) {
    var timestamp = date.getTime()
    var time = 0
    var offset

    if (dateStrings.time) {
      time = parseTime(dateStrings.time)
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone)
    } else {
      // get offset accurate to hour in timezones that change offset
      offset = new Date(timestamp + time).getTimezoneOffset()
      offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset()
    }

    return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {}
  var array = dateString.split(parseTokenDateTimeDelimeter)
  var timeString

  if (parseTokenPlainTime.test(array[0])) {
    dateStrings.date = null
    timeString = array[0]
  } else {
    dateStrings.date = array[0]
    timeString = array[1]
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString)
    if (token) {
      dateStrings.time = timeString.replace(token[1], '')
      dateStrings.timezone = token[1]
    } else {
      dateStrings.time = timeString
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits]
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]

  var token

  // YYYY or ±YYYYY
  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
  if (token) {
    var yearString = token[1]
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
  if (token) {
    var centuryString = token[1]
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token
  var date
  var month
  var week

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0)
    date.setUTCFullYear(year)
    return date
  }

  // YYYY-MM
  token = parseTokenMM.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    date.setUTCFullYear(year, month)
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = parseTokenDDD.exec(dateString)
  if (token) {
    date = new Date(0)
    var dayOfYear = parseInt(token[1], 10)
    date.setUTCFullYear(year, 0, dayOfYear)
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = parseTokenMMDD.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    var day = parseInt(token[2], 10)
    date.setUTCFullYear(year, month, day)
    return date
  }

  // YYYY-Www or YYYYWww
  token = parseTokenWww.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = parseTokenWwwD.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    var dayOfWeek = parseInt(token[2], 10) - 1
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token
  var hours
  var minutes

  // hh
  token = parseTokenHH.exec(timeString)
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = parseTokenHHMM.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseFloat(token[2].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = parseTokenHHMMSS.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseInt(token[2], 10)
    var seconds = parseFloat(token[3].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token
  var absoluteOffset

  // Z
  token = parseTokenTimezoneZ.exec(timezoneString)
  if (token) {
    return 0
  }

  // ±hh
  token = parseTokenTimezoneHH.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = parseTokenTimezoneHHMM.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0
  day = day || 0
  var date = new Date(0)
  date.setUTCFullYear(isoYear, 0, 4)
  var fourthOfJanuaryDay = date.getUTCDay() || 7
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
  date.setUTCDate(date.getUTCDate() + diff)
  return date
}

module.exports = parse


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(7);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (name, options) {
  return {
    validator: function validator(value) {
      if (options.includes(value)) {
        return true;
      }

      _vue2.default.util.warn('The ' + name + ' prop is invalid. Given value: ' + value + '. Available options: ' + options.join(', ') + '.', undefined);

      return false;
    }
  };
};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdIcon/MdIcon.vue
var MdIcon = __webpack_require__(150);
var MdIcon_default = /*#__PURE__*/__webpack_require__.n(MdIcon);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59c14b8f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdIcon/MdIcon.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mdSrc
    ? _c("md-svg-loader", {
        staticClass: "md-icon md-icon-image",
        class: [_vm.$mdActiveTheme],
        attrs: { "md-src": _vm.mdSrc },
        on: {
          "md-loaded": function($event) {
            _vm.$emit("md-loaded")
          }
        }
      })
    : _c(
        "i",
        { staticClass: "md-icon md-icon-font", class: [_vm.$mdActiveTheme] },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdIcon_MdIcon = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59c14b8f", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdIcon/MdIcon.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(149)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdIcon_default.a,
  MdIcon_MdIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdIcon/MdIcon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-59c14b8f", Component.options)
  } else {
    hotAPI.reload("data-v-59c14b8f", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdIcon_MdIcon = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MdUuid = function MdUuid() {
  return Math.random().toString(36).slice(4);
};

exports.default = MdUuid;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdRipple/MdRipple.vue
var MdRipple = __webpack_require__(93);
var MdRipple_default = /*#__PURE__*/__webpack_require__.n(MdRipple);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7692b1af","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdRipple/MdRipple.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "md-ripple",
      class: _vm.rippleClasses,
      on: {
        "&touchstart": function($event) {
          $event.stopPropagation()
          _vm.touchStartCheck($event)
        },
        "&touchmove": function($event) {
          $event.stopPropagation()
          _vm.touchMoveCheck($event)
        },
        "&mousedown": function($event) {
          $event.stopPropagation()
          _vm.startRipple($event)
        }
      }
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      !_vm.isDisabled
        ? _c(
            "transition",
            {
              attrs: { name: "md-ripple" },
              on: { "after-enter": _vm.clearWave }
            },
            [
              _vm.animating
                ? _c("span", {
                    ref: "rippleWave",
                    staticClass: "md-ripple-wave",
                    class: _vm.waveClasses,
                    style: _vm.waveStyles
                  })
                : _vm._e()
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdRipple_MdRipple = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7692b1af", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdRipple/MdRipple.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(92)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdRipple_default.a,
  MdRipple_MdRipple,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdRipple/MdRipple.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7692b1af", Component.options)
  } else {
    hotAPI.reload("data-v-7692b1af", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdRipple_MdRipple = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(65)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdDialog/MdDialog.vue
var MdDialog = __webpack_require__(205);
var MdDialog_default = /*#__PURE__*/__webpack_require__.n(MdDialog);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f080a6a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdDialog/MdDialog.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-portal",
    [
      _c("transition", { attrs: { name: "md-dialog" } }, [
        _vm.mdActive
          ? _c(
              "div",
              _vm._g(
                {
                  staticClass: "md-dialog",
                  class: [_vm.dialogClasses, _vm.$mdActiveTheme],
                  on: {
                    keydown: function($event) {
                      if (
                        !("button" in $event) &&
                        _vm._k($event.keyCode, "esc", 27, $event.key)
                      ) {
                        return null
                      }
                      _vm.onEsc($event)
                    }
                  }
                },
                _vm.$listeners
              ),
              [
                _c("md-focus-trap", [
                  _c(
                    "div",
                    { staticClass: "md-dialog-container" },
                    [
                      _vm._t("default"),
                      _vm._v(" "),
                      _c(
                        "keep-alive",
                        [
                          _vm.mdBackdrop
                            ? _c("md-overlay", {
                                class: _vm.mdBackdropClass,
                                attrs: {
                                  "md-fixed": "",
                                  "md-active": _vm.mdActive
                                },
                                on: { click: _vm.onClick }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    2
                  )
                ])
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdDialog_MdDialog = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f080a6a2", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdDialog/MdDialog.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(204)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdDialog_default.a,
  MdDialog_MdDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdDialog/MdDialog.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f080a6a2", Component.options)
  } else {
    hotAPI.reload("data-v-f080a6a2", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdDialog_MdDialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdRipple = __webpack_require__(19);

var _MdRipple2 = _interopRequireDefault(_MdRipple);

var _MdListItemContent = __webpack_require__(282);

var _MdListItemContent2 = _interopRequireDefault(_MdListItemContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_MdRipple2.default],
  components: {
    MdListItemContent: _MdListItemContent2.default
  },
  props: {
    disabled: Boolean
  },
  computed: {
    isDisabled: function isDisabled() {
      return !this.mdRipple || this.disabled;
    }
  }
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (context, props) {
  return _extends({}, props, context.$options.components['router-link'].options.props);
};

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdButton_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdButton_vue__);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(97)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdButton_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdButton/MdButton.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7d2cd822", Component.options)
  } else {
    hotAPI.reload("data-v-7d2cd822", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdField/MdInput/MdInput.vue
var MdInput = __webpack_require__(158);
var MdInput_default = /*#__PURE__*/__webpack_require__.n(MdInput);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69de42aa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdField/MdInput/MdInput.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "input",
    _vm._g(
      _vm._b(
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.model,
              expression: "model"
            }
          ],
          staticClass: "md-input",
          domProps: { value: _vm.model },
          on: {
            focus: _vm.onFocus,
            blur: _vm.onBlur,
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.model = $event.target.value
            }
          }
        },
        "input",
        _vm.attributes,
        false
      ),
      _vm.listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdInput_MdInput = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69de42aa", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdField/MdInput/MdInput.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdInput_default.a,
  MdInput_MdInput,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdField/MdInput/MdInput.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-69de42aa", Component.options)
  } else {
    hotAPI.reload("data-v-69de42aa", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdField_MdInput_MdInput = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = {
  props: {
    value: {},
    placeholder: String,
    maxlength: [String, Number],
    readonly: Boolean,
    required: Boolean,
    disabled: Boolean,
    mdCounter: [String, Number]
  },
  data: function data() {
    return {
      localValue: this.value,
      textareaHeight: false
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.localValue;
      },
      set: function set(value) {
        var _this = this;

        if (value.constructor.name.toLowerCase() !== 'inputevent') {
          this.$nextTick(function () {
            _this.localValue = value;
          });
        }
      }
    },
    clear: function clear() {
      return this.MdField.clear;
    },
    attributes: function attributes() {
      return _extends({}, this.$attrs, {
        type: this.type,
        id: this.id,
        name: this.name,
        disabled: this.disabled,
        required: this.required,
        placeholder: this.placeholder,
        readonly: this.readonly,
        maxlength: this.maxlength
      });
    }
  },
  watch: {
    model: function model() {
      this.setFieldValue();
    },
    clear: function clear(_clear) {
      if (_clear) {
        this.clearField();
      }
    },
    placeholder: function placeholder() {
      this.setPlaceholder();
    },
    disabled: function disabled() {
      this.setDisabled();
    },
    required: function required() {
      this.setRequired();
    },
    maxlength: function maxlength() {
      this.setMaxlength();
    },
    mdCounter: function mdCounter() {
      this.setMaxlength();
    },
    localValue: function localValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.localValue = val;
    }
  },
  methods: {
    clearField: function clearField() {
      this.$el.value = '';
      this.model = '';
      this.setFieldValue();
    },
    setLabelFor: function setLabelFor() {
      if (this.$el.parentNode) {
        var label = this.$el.parentNode.querySelector('label');

        if (label) {
          var forAttribute = label.getAttribute('for');

          if (!forAttribute || forAttribute.indexOf('md-') >= 0) {
            label.setAttribute('for', this.id);
          }
        }
      }
    },
    setFieldValue: function setFieldValue() {
      this.MdField.value = this.model;
    },
    setPlaceholder: function setPlaceholder() {
      this.MdField.placeholder = Boolean(this.placeholder);
    },
    setDisabled: function setDisabled() {
      this.MdField.disabled = Boolean(this.disabled);
    },
    setRequired: function setRequired() {
      this.MdField.required = Boolean(this.required);
    },
    setMaxlength: function setMaxlength() {
      if (this.mdCounter) {
        this.MdField.counter = parseInt(this.mdCounter, 10);
      } else {
        this.MdField.maxlength = parseInt(this.maxlength, 10);
      }
    },
    onFocus: function onFocus() {
      this.MdField.focused = true;
    },
    onBlur: function onBlur() {
      this.MdField.focused = false;
    }
  },
  created: function created() {
    this.setFieldValue();
    this.setPlaceholder();
    this.setDisabled();
    this.setRequired();
    this.setMaxlength();
  },
  mounted: function mounted() {
    this.setLabelFor();
  }
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(7);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: 'MdPortal',
  abstract: true,
  props: {
    mdAttachToParent: Boolean,
    mdTarget: {
      type: null,
      validator: function validator(value) {
        if (HTMLElement && value && value instanceof HTMLElement) {
          return true;
        }

        _vue2.default.util.warn('The md-target-el prop is invalid. You should pass a valid HTMLElement.', this);

        return false;
      }
    }
  },
  data: function data() {
    return {
      leaveTimeout: null,
      originalParentEl: null
    };
  },
  computed: {
    transitionName: function transitionName() {
      var childrenComponent = this._vnode.componentOptions.children[0];

      if (childrenComponent) {
        var transition = childrenComponent.data.transition;

        if (transition) {
          return transition.name;
        } else {
          var _transition = childrenComponent.componentOptions.propsData.name;

          if (_transition) {
            return _transition;
          }
        }
      }

      return 'v';
    },
    leaveClass: function leaveClass() {
      return this.transitionName + '-leave';
    },
    leaveActiveClass: function leaveActiveClass() {
      return this.transitionName + '-leave-active';
    },
    leaveToClass: function leaveToClass() {
      return this.transitionName + '-leave-to';
    }
  },
  watch: {
    mdTarget: function mdTarget(newTarget, oldTarget) {
      this.changeParentEl(newTarget);

      if (oldTarget) {
        this.$forceUpdate();
      }
    }
  },
  methods: {
    getTransitionDuration: function getTransitionDuration(el) {
      var duration = getComputedStyle(el).transitionDuration;
      var num = parseFloat(duration, 10);
      var unit = duration.match(/m?s/);
      var milliseconds = null;

      if (unit) {
        unit = unit[0];
      }

      switch (unit) {
        case 's':
          milliseconds = num * 1000;
          break;

        case 'ms':
          milliseconds = num;
          break;

        default:
          milliseconds = 0;
          break;
      }

      return milliseconds;
    },
    killGhostElement: function killGhostElement(el) {
      if (el.parentNode) {
        this.changeParentEl(this.originalParentEl);
        this.$options._parentElm = this.originalParentEl;
        el.parentNode.removeChild(el);
      }
    },
    initDestroy: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(manualCall) {
        var _this = this;

        var el;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                el = this.$el;


                if (manualCall && this.$el.constructor.name.toLowerCase() === 'comment') {
                  el = this.$vnode.elm;
                }

                el.classList.add(this.leaveClass);
                el.classList.add(this.leaveActiveClass);
                _context.next = 6;
                return this.$nextTick();

              case 6:
                el.classList.add(this.leaveToClass);

                clearTimeout(this.leaveTimeout);
                this.leaveTimeout = setTimeout(function () {
                  _this.destroyElement(el);
                }, this.getTransitionDuration(el));

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initDestroy(_x) {
        return _ref.apply(this, arguments);
      }

      return initDestroy;
    }(),
    destroyElement: function destroyElement(el) {
      var _this2 = this;

      requestAnimationFrame(function () {
        el.classList.remove(_this2.leaveClass);
        el.classList.remove(_this2.leaveActiveClass);
        el.classList.remove(_this2.leaveToClass);
        _this2.$emit('md-destroy');
        _this2.killGhostElement(el);
      });
    },
    changeParentEl: function changeParentEl(newTarget) {
      newTarget && newTarget.appendChild(this.$el);
    }
  },
  mounted: function mounted() {
    if (!this.originalParentEl) {
      this.originalParentEl = this.$el.parentNode;
      this.$emit('md-initial-parent', this.$el.parentNode);
    }

    if (this.mdAttachToParent && this.$el.parentNode.parentNode) {
      this.changeParentEl(this.$el.parentNode.parentNode);
    } else if (document) {
      this.changeParentEl(this.mdTarget || document.body);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$el.classList) {
      this.initDestroy();
    } else {
      this.killGhostElement(this.$el);
    }
  },
  render: function render(createElement) {
    var defaultSlot = this.$slots.default;

    if (defaultSlot && defaultSlot[0]) {
      return defaultSlot[0];
    }
  }
};

/***/ }),
/* 17 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  methods: {
    isAssetIcon: function isAssetIcon(icon) {
      return (/\w+[/\\.]\w+/.test(icon)
      );
    }
  }
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdRipple = __webpack_require__(8);

var _MdRipple2 = _interopRequireDefault(_MdRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MdRipple: _MdRipple2.default
  },
  props: {
    mdRipple: {
      type: Boolean,
      default: true
    }
  }
};

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdField/MdField.vue
var MdField = __webpack_require__(147);
var MdField_default = /*#__PURE__*/__webpack_require__.n(MdField);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ecd7b97","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdField/MdField.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "md-field",
      class: [_vm.$mdActiveTheme, _vm.fieldClasses],
      on: { blur: _vm.onBlur }
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.hasCounter
        ? _c("span", { staticClass: "md-count" }, [
            _vm._v(
              _vm._s(_vm.valueLength) +
                " / " +
                _vm._s(_vm.MdField.maxlength || _vm.MdField.counter)
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "md-input-action", appear: "" } },
        [
          _vm.hasValue && _vm.mdClearable
            ? _c(
                "md-button",
                {
                  staticClass:
                    "md-icon-button md-dense md-input-action md-clear",
                  attrs: { tabindex: "-1" },
                  on: { click: _vm.clearInput }
                },
                [_c("md-clear-icon")],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "md-input-action", appear: "" } },
        [
          _vm.hasPasswordToggle
            ? _c(
                "md-button",
                {
                  staticClass:
                    "md-icon-button md-dense md-input-action md-toggle-password",
                  attrs: { tabindex: "-1" },
                  on: { click: _vm.togglePassword }
                },
                [
                  _vm.MdField.togglePassword
                    ? _c("md-password-off-icon")
                    : _c("md-password-on-icon")
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdField_MdField = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ecd7b97", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdField/MdField.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(146)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdField_default.a,
  MdField_MdField,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdField/MdField.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2ecd7b97", Component.options)
  } else {
    hotAPI.reload("data-v-2ecd7b97", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdField_MdField = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfDay


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(174)

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate) {
  return startOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = startOfISOWeek


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdOverlay/MdOverlay.vue
var MdOverlay = __webpack_require__(181);
var MdOverlay_default = /*#__PURE__*/__webpack_require__.n(MdOverlay);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e05c97a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdOverlay/MdOverlay.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-portal",
    { attrs: { "md-attach-to-parent": _vm.mdAttachToParent } },
    [
      _c("transition", { attrs: { name: "md-overlay" } }, [
        _vm.mdActive
          ? _c(
              "div",
              _vm._g(
                { staticClass: "md-overlay", class: _vm.overlayClasses },
                _vm.$listeners
              )
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdOverlay_MdOverlay = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e05c97a", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdOverlay/MdOverlay.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(180)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdOverlay_default.a,
  MdOverlay_MdOverlay,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdOverlay/MdOverlay.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0e05c97a", Component.options)
  } else {
    hotAPI.reload("data-v-0e05c97a", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdOverlay_MdOverlay = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  var monthIndex = date.getMonth()
  var lastDayOfMonth = new Date(0)
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0)
  lastDayOfMonth.setHours(0, 0, 0, 0)
  return lastDayOfMonth.getDate()
}

module.exports = getDaysInMonth


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdPopover_vue__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdPopover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdPopover_vue__);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(197)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdPopover_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdPopover/MdPopover.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d36236a6", Component.options)
  } else {
    hotAPI.reload("data-v-d36236a6", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (el, config, cb) {
  if ('MutationObserver' in window) {
    var observer = new window.MutationObserver(cb);

    observer.observe(el, config);

    return {
      disconnect: function disconnect() {
        observer.disconnect();
      }
    };
  }
};

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdTable/MdTableHead.vue
var MdTableHead = __webpack_require__(360);
var MdTableHead_default = /*#__PURE__*/__webpack_require__.n(MdTableHead);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98ddc082","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdTable/MdTableHead.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "th",
    {
      staticClass: "md-table-head",
      class: _vm.headClasses,
      style: _vm.headStyles,
      on: { click: _vm.changeSort }
    },
    [
      _vm.$slots.default
        ? _c("div", { staticClass: "md-table-head-container" }, [
            _c(
              "div",
              { staticClass: "md-table-head-label" },
              [_vm._t("default")],
              2
            )
          ])
        : _c(
            "md-ripple",
            {
              staticClass: "md-table-head-container",
              attrs: { "md-disabled": !_vm.hasSort }
            },
            [
              _c(
                "div",
                { staticClass: "md-table-head-label" },
                [
                  _vm.hasSort
                    ? _c(
                        "md-upward-icon",
                        { staticClass: "md-table-sortable-icon" },
                        [_vm._v("arrow_upward")]
                      )
                    : _vm._e(),
                  _vm._v("\n\n      " + _vm._s(_vm.label) + "\n\n      "),
                  _vm.tooltip
                    ? _c("md-tooltip", [_vm._v(_vm._s(_vm.tooltip))])
                    : _vm._e()
                ],
                1
              )
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdTable_MdTableHead = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-98ddc082", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdTable/MdTableHead.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(359)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdTableHead_default.a,
  MdTable_MdTableHead,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdTable/MdTableHead.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-98ddc082", Component.options)
  } else {
    hotAPI.reload("data-v-98ddc082", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdTable_MdTableHead = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (data) {
  var Instance = {};

  _vue2.default.util.defineReactive(Instance, 'reactive', data);

  return Instance.reactive;
};

var _vue = __webpack_require__(7);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(7);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msColor = null;
var themeColor = null;
var maskIcon = null;

exports.default = new _vue2.default({
  data: function data() {
    return {
      prefix: 'md-theme-',
      theme: 'default',
      enabled: true,
      metaColors: false
    };
  },
  computed: {
    themeTarget: function themeTarget() {
      if (!this.$isServer) {
        return document.documentElement;
      }

      return false;
    },
    fullThemeName: function fullThemeName() {
      return this.getThemeName();
    }
  },
  watch: {
    enabled: {
      immediate: true,
      handler: function handler() {
        var fullThemeName = this.fullThemeName,
            themeTarget = this.themeTarget,
            enabled = this.enabled;


        if (themeTarget) {
          if (enabled) {
            themeTarget.classList.add(fullThemeName);
            this.metaColors && this.setHtmlMetaColors(fullThemeName);
          } else {
            themeTarget.classList.remove(fullThemeName);
            this.metaColors && this.setHtmlMetaColors();
          }
        }
      }
    },
    theme: function theme(newTheme, oldTheme) {
      var getThemeName = this.getThemeName,
          themeTarget = this.themeTarget;


      newTheme = getThemeName(newTheme);

      themeTarget.classList.remove(getThemeName(oldTheme));
      themeTarget.classList.add(newTheme);

      if (this.metaColors) {
        this.setHtmlMetaColors(newTheme);
      }
    },
    metaColors: function metaColors(meta) {
      if (meta) {
        this.setHtmlMetaColors(this.fullThemeName);
      } else {
        this.setHtmlMetaColors();
      }
    }
  },
  methods: {
    getAncestorTheme: function getAncestorTheme(component) {
      var _this = this;

      if (component) {
        var currentTheme = component.mdTheme;
        var getParentThemeName = function getParentThemeName(parent) {
          if (parent) {
            var mdTheme = parent.mdTheme,
                $parent = parent.$parent;


            if (mdTheme && mdTheme !== currentTheme) {
              return mdTheme;
            }

            return getParentThemeName($parent);
          }

          return _this.theme;
        };

        return getParentThemeName(component.$parent);
      }

      return null;
    },
    getThemeName: function getThemeName(theme) {
      var themeName = theme || this.theme;

      return this.prefix + themeName;
    },
    setMicrosoftColors: function setMicrosoftColors(primaryColor) {
      if (msColor) {
        msColor.setAttribute('content', primaryColor);
      }
    },
    setThemeColors: function setThemeColors(primaryColor) {
      if (themeColor) {
        themeColor.setAttribute('content', primaryColor);
      }
    },
    setMaskColors: function setMaskColors(primaryColor) {
      if (maskIcon) {
        maskIcon.setAttribute('color', primaryColor);
      }
    },
    setHtmlMetaColors: function setHtmlMetaColors(themeName) {
      var primaryColor = '#fff';

      if (themeName) {
        var computedStyle = window.getComputedStyle(document.documentElement);

        primaryColor = computedStyle.getPropertyValue('--' + themeName + '-primary');
      }

      if (primaryColor) {
        this.setMicrosoftColors(primaryColor);
        this.setThemeColors(primaryColor);
        this.setMaskColors(primaryColor);
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    msColor = document.querySelector('[name="msapplication-TileColor"]');
    themeColor = document.querySelector('[name="theme-color"]');
    maskIcon = document.querySelector('[rel="mask-icon"]');

    if (this.enabled && this.metaColors) {
      window.addEventListener('load', function () {
        _this2.setHtmlMetaColors(_this2.fullThemeName);
      });
    }
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, optionsArgument) {
	var clone = !optionsArgument || optionsArgument.clone !== false;

	return (clone && isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, optionsArgument)
		: value
}

function defaultArrayMerge(target, source, optionsArgument) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, optionsArgument)
	})
}

function mergeObject(target, source, optionsArgument) {
	var destination = {};
	if (isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], optionsArgument);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], optionsArgument);
		} else {
			destination[key] = deepmerge(target[key], source[key], optionsArgument);
		}
	});
	return destination
}

function deepmerge(target, source, optionsArgument) {
	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, optionsArgument)
	} else if (sourceIsArray) {
		var arrayMerge = options.arrayMerge || defaultArrayMerge;
		return arrayMerge(target, source, optionsArgument)
	} else {
		return mergeObject(target, source, optionsArgument)
	}
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, optionsArgument)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["default"] = (deepmerge_1);


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _raf = __webpack_require__(9);

var _raf2 = _interopRequireDefault(_raf);

var _MdPropValidator = __webpack_require__(4);

var _MdPropValidator2 = _interopRequireDefault(_MdPropValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mdAppModes = ['fixed', 'fixed-last', 'reveal', 'overlap', 'flexible'];

exports.default = {
  props: {
    mdMode: _extends({
      type: String
    }, (0, _MdPropValidator2.default)('md-mode', mdAppModes)),
    mdWaterfall: Boolean,
    mdScrollbar: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      revealTimer: null,
      revealLastPos: 0,
      manualTick: false,
      MdApp: {
        options: {
          mode: null,
          waterfall: false,
          flexible: false
        },
        toolbar: {
          element: null,
          titleElement: null,
          height: '0px',
          initialHeight: 0,
          top: 0,
          titleSize: 20,
          hasElevation: true,
          revealActive: false,
          fixedLastActive: false,
          fixedLastHeight: false,
          overlapOff: false
        },
        drawer: {
          initialWidth: 0,
          active: false,
          mode: 'temporary',
          width: 0
        }
      }
    };
  },
  provide: function provide() {
    return {
      MdApp: this.MdApp
    };
  },

  computed: {
    contentStyles: function contentStyles() {
      var drawer = this.MdApp.drawer;

      if (drawer.active && drawer.mode === 'persistent' && drawer.submode === 'full') {
        return {
          'padding-left': drawer.width
        };
      }
    },
    containerStyles: function containerStyles() {
      var drawer = this.MdApp.drawer;
      var styles = {};

      if (this.mdMode && this.mdMode !== 'fixed') {
        styles['margin-top'] = this.MdApp.toolbar.initialHeight + 'px';
      }

      if (drawer.mode === 'persistent' && drawer.submode === 'mini') {
        styles['padding-left'] = !drawer.active ? drawer.initialWidth + 'px' : 0;
      }

      return styles;
    },
    scrollerClasses: function scrollerClasses() {
      if (this.mdScrollbar) {
        return 'md-scrollbar';
      }
    },
    appClasses: function appClasses() {
      return {
        'md-waterfall': this.mdWaterfall,
        'md-flexible': this.mdMode === 'flexible',
        'md-fixed': this.mdMode === 'fixed',
        'md-fixed-last': this.mdMode === 'fixed-last',
        'md-reveal': this.mdMode === 'reveal',
        'md-overlap': this.mdMode === 'overlap',
        'md-drawer-active': this.MdApp.drawer.active
      };
    }
  },
  watch: {
    mdMode: function mdMode(mode) {
      this.MdApp.options.mode = mode;
    },
    mdWaterfall: function mdWaterfall(waterfall) {
      this.MdApp.options.waterfall = waterfall;
      this.setToolbarElevation();
    }
  },
  methods: {
    setToolbarElevation: function setToolbarElevation() {
      this.MdApp.toolbar.hasElevation = !this.mdWaterfall;
    },
    setToolbarTimer: function setToolbarTimer(scrollTop) {
      var _this = this;

      window.clearTimeout(this.revealTimer);

      this.revealTimer = window.setTimeout(function () {
        _this.revealLastPos = scrollTop;
      }, 100);
    },
    setToolbarMarginAndHeight: function setToolbarMarginAndHeight(margin, height) {
      this.MdApp.toolbar.top = margin;
      this.MdApp.toolbar.height = height;
    },
    getToolbarConstrants: function getToolbarConstrants($event) {
      var toolbarHeight = this.MdApp.toolbar.element.offsetHeight;
      var safeAmount = 10;
      var threshold = toolbarHeight + safeAmount;
      var scrollTop = $event.target.scrollTop;

      if (!this.MdApp.toolbar.initialHeight) {
        this.MdApp.toolbar.initialHeight = toolbarHeight;
      }

      return {
        toolbarHeight: toolbarHeight,
        safeAmount: safeAmount,
        threshold: threshold,
        scrollTop: scrollTop,
        initialHeight: this.MdApp.toolbar.initialHeight
      };
    },
    handleWaterfallScroll: function handleWaterfallScroll($event) {
      var _getToolbarConstrants = this.getToolbarConstrants($event),
          threshold = _getToolbarConstrants.threshold,
          scrollTop = _getToolbarConstrants.scrollTop;

      var elevationMark = 4;

      if (this.mdMode === 'reveal') {
        elevationMark = threshold;
      }

      this.MdApp.toolbar.hasElevation = scrollTop >= elevationMark;
    },
    handleFlexibleMode: function handleFlexibleMode($event) {
      var _getToolbarConstrants2 = this.getToolbarConstrants($event),
          scrollTop = _getToolbarConstrants2.scrollTop,
          initialHeight = _getToolbarConstrants2.initialHeight;

      var toolbar = this.MdApp.toolbar.element;
      var firstRow = toolbar.querySelector('.md-toolbar-row:first-child');
      var firstRowHeight = firstRow.offsetHeight;
      var scrollAmount = initialHeight - scrollTop;
      var shouldKeepFlexible = scrollTop < initialHeight - firstRowHeight;

      if (firstRowHeight) {
        if (shouldKeepFlexible) {
          toolbar.style.height = scrollAmount + 'px';
        } else {
          toolbar.style.height = firstRowHeight + 'px';
        }
      }

      var titleElement = this.MdApp.toolbar.titleElement;
      if (titleElement) {
        var targetSize = 20;
        var initialSize = this.MdApp.toolbar.titleSize;

        if (shouldKeepFlexible) {
          var newSize = Math.max(0, 1 - (scrollTop - initialSize) / (scrollAmount + initialSize + 0.000001)) * (initialSize - targetSize) + targetSize;

          titleElement.style.fontSize = newSize + 'px';
        } else {
          titleElement.style.fontSize = '20px';
        }
      }

      var _getToolbarConstrants3 = this.getToolbarConstrants($event),
          threshold = _getToolbarConstrants3.threshold,
          toolbarHeight = _getToolbarConstrants3.toolbarHeight;

      this.setToolbarMarginAndHeight(scrollTop - threshold, toolbarHeight);
    },
    handleRevealMode: function handleRevealMode($event) {
      var _getToolbarConstrants4 = this.getToolbarConstrants($event),
          toolbarHeight = _getToolbarConstrants4.toolbarHeight,
          safeAmount = _getToolbarConstrants4.safeAmount,
          threshold = _getToolbarConstrants4.threshold,
          scrollTop = _getToolbarConstrants4.scrollTop;

      this.setToolbarTimer(scrollTop);
      this.setToolbarMarginAndHeight(scrollTop - threshold, toolbarHeight);

      if (scrollTop >= threshold) {
        this.MdApp.toolbar.revealActive = this.revealLastPos > scrollTop + safeAmount;
      } else {
        this.MdApp.toolbar.revealActive = true;
      }
    },
    handleFixedLastMode: function handleFixedLastMode($event) {
      var _getToolbarConstrants5 = this.getToolbarConstrants($event),
          scrollTop = _getToolbarConstrants5.scrollTop,
          toolbarHeight = _getToolbarConstrants5.toolbarHeight,
          safeAmount = _getToolbarConstrants5.safeAmount;

      var toolbar = this.MdApp.toolbar.element;
      var firstRow = toolbar.querySelector('.md-toolbar-row:first-child');
      var firstRowHeight = firstRow.offsetHeight;

      this.setToolbarTimer(scrollTop);
      this.setToolbarMarginAndHeight(scrollTop - firstRowHeight, toolbarHeight);
      this.MdApp.toolbar.fixedLastHeight = firstRowHeight;

      if (scrollTop >= firstRowHeight) {
        this.MdApp.toolbar.fixedLastActive = this.revealLastPos > scrollTop + safeAmount;
      } else {
        this.MdApp.toolbar.fixedLastActive = true;
      }
    },
    handleOverlapMode: function handleOverlapMode($event) {
      var _getToolbarConstrants6 = this.getToolbarConstrants($event),
          toolbarHeight = _getToolbarConstrants6.toolbarHeight,
          scrollTop = _getToolbarConstrants6.scrollTop,
          initialHeight = _getToolbarConstrants6.initialHeight;

      var toolbar = this.MdApp.toolbar.element;
      var firstRow = toolbar.querySelector('.md-toolbar-row:first-child');
      var firstRowHeight = firstRow.offsetHeight;
      var newHeight = initialHeight - scrollTop - scrollTop * 100 / (initialHeight - firstRowHeight - firstRowHeight / 1.5);

      if (firstRowHeight) {
        if (scrollTop < initialHeight - firstRowHeight && newHeight >= firstRowHeight) {
          this.MdApp.toolbar.overlapOff = false;
          toolbar.style.height = newHeight + 'px';
        } else {
          this.MdApp.toolbar.overlapOff = true;
          toolbar.style.height = firstRowHeight + 'px';
        }
      }

      this.setToolbarMarginAndHeight(scrollTop, toolbarHeight);
    },
    handleModeScroll: function handleModeScroll($event) {
      if (this.mdMode === 'reveal') {
        this.handleRevealMode($event);
      } else if (this.mdMode === 'fixed-last') {
        this.handleFixedLastMode($event);
      } else if (this.mdMode === 'overlap') {
        this.handleOverlapMode($event);
      } else if (this.mdMode === 'flexible') {
        this.handleFlexibleMode($event);
      }
    },
    handleScroll: function handleScroll($event) {
      var _this2 = this;

      if (this.MdApp.toolbar.element) {
        (0, _raf2.default)(function () {
          if (_this2.mdWaterfall) {
            _this2.handleWaterfallScroll($event);
          }

          if (_this2.mdMode) {
            _this2.handleModeScroll($event);
          }
        });
      }
    }
  },
  created: function created() {
    this.MdApp.options.mode = this.mdMode;
    this.MdApp.options.waterfall = this.mdWaterfall;
    this.setToolbarElevation();
  },
  mounted: function mounted() {
    var fakeEvent = {
      target: {
        scrollTop: 0
      }
    };

    if (this.mdMode === 'reveal') {
      this.MdApp.toolbar.revealActive = true;
      this.handleRevealMode(fakeEvent);
    }

    if (this.mdMode === 'flexible') {
      this.MdApp.toolbar.revealActive = true;
      this.handleFlexibleMode(fakeEvent);
    }

    if (this.mdMode === 'fixed-last') {
      this.MdApp.toolbar.fixedLastActive = true;
      this.handleFixedLastMode(fakeEvent);
    }

    if (this.mdMode === 'overlap') {
      this.handleOverlapMode(fakeEvent);
    }
  }
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdReactive = __webpack_require__(28);

var _MdReactive2 = _interopRequireDefault(_MdReactive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasEvents = false;
var eventTarget = null;
var supportsPassiveEvent = false;
var MdFocused = new _MdReactive2.default({
  currentElement: null
});

function checkPassiveEventSupport() {
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassiveEvent = { passive: true };
      }
    });
    window.addEventListener('ghost', null, opts);
  } catch (e) {}
}

function setKeyboardInteraction(_ref) {
  var keyCode = _ref.keyCode,
      target = _ref.target;

  MdFocused.currentElement = target;
}

function setMouseAndTouchInteraction(event) {
  MdFocused.currentElement = null;
}

function createKeyboardEvents() {
  eventTarget.addEventListener('keyup', setKeyboardInteraction);
}

function createPointerEvents() {
  eventTarget.addEventListener('pointerup', setMouseAndTouchInteraction);
}

function createMSPointerEvents() {
  eventTarget.addEventListener('MSPointerUp', setMouseAndTouchInteraction);
}

function createMouseAndTouchEvents() {
  eventTarget.addEventListener('mouseup', setMouseAndTouchInteraction);

  if ('ontouchend' in window) {
    eventTarget.addEventListener('touchend', setMouseAndTouchInteraction, supportsPassiveEvent);
  }
}

function bindEvents() {
  if (window.PointerEvent) {
    createPointerEvents();
  } else if (window.MSPointerEvent) {
    createMSPointerEvents();
  } else {
    createMouseAndTouchEvents();
  }

  createKeyboardEvents();
}

function createEvents() {
  if (!hasEvents) {
    eventTarget = document.body;
    checkPassiveEventSupport();
    bindEvents();
    hasEvents = true;
  }
}

exports.default = {
  data: function data() {
    return {
      mdHasFocus: false
    };
  },
  computed: {
    focusedElement: function focusedElement() {
      return MdFocused.currentElement;
    }
  },
  watch: {
    focusedElement: function focusedElement(el) {
      this.mdHasFocus = el === this.$el;
    }
  },
  mounted: function mounted() {
    createEvents();
  }
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdRipple = __webpack_require__(8);

var _MdRipple2 = _interopRequireDefault(_MdRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MdRipple: _MdRipple2.default
  },
  props: {
    model: [String, Number, Boolean, Array],
    value: {
      type: [String, Number, Boolean],
      default: 'on'
    },
    name: [String, Number],
    required: Boolean,
    disabled: Boolean
  },
  model: {
    prop: 'model',
    event: 'change'
  },
  data: function data() {
    return {
      rippleActive: false
    };
  },
  computed: {
    isSelected: function isSelected() {
      if (this.isModelArray) {
        return this.model.includes(this.value);
      }

      if (this.isModelBoolean && this.value === 'on') {
        return this.model;
      }

      return this.model === this.value;
    },
    isModelArray: function isModelArray() {
      return Array.isArray(this.model);
    },
    isModelBoolean: function isModelBoolean() {
      return typeof this.model === 'boolean';
    },
    checkClasses: function checkClasses() {
      return {
        'md-checked': this.isSelected,
        'md-disabled': this.disabled,
        'md-required': this.required
      };
    }
  },
  methods: {
    removeItemFromModel: function removeItemFromModel(newModel) {
      var index = newModel.indexOf(this.value);

      if (index !== -1) {
        newModel.splice(index, 1);
      }
    },
    handleArrayCheckbox: function handleArrayCheckbox() {
      var newModel = this.model;

      if (!this.isSelected) {
        newModel.push(this.value);
      } else {
        this.removeItemFromModel(newModel);
      }

      this.$emit('change', newModel);
    },
    handleStringCheckbox: function handleStringCheckbox() {
      if (!this.isSelected) {
        this.$emit('change', this.value);
      } else {
        this.$emit('change', null);
      }
    },
    handleBooleanCheckbox: function handleBooleanCheckbox() {
      this.$emit('change', !this.model);
    },
    toggleCheck: function toggleCheck() {
      if (!this.disabled) {
        this.rippleActive = true;

        if (this.isModelArray) {
          this.handleArrayCheckbox();
        } else if (this.isModelBoolean) {
          this.handleBooleanCheckbox();
        } else {
          this.handleStringCheckbox();
        }
      }
    }
  }
};

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/core/icons/MdClearIcon.vue
var MdClearIcon = __webpack_require__(148);
var MdClearIcon_default = /*#__PURE__*/__webpack_require__.n(MdClearIcon);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f53126ba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/core/icons/MdClearIcon.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(1)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "svg",
      {
        attrs: {
          height: "24",
          viewBox: "0 0 24 24",
          width: "24",
          xmlns: "http://www.w3.org/2000/svg"
        }
      },
      [
        _c("path", {
          attrs: {
            d:
              "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          }
        }),
        _vm._v(" "),
        _c("path", { attrs: { d: "M0 0h24v24H0z", fill: "none" } })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("md-icon", { staticClass: "md-icon-image" }, [_vm._m(0)])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var icons_MdClearIcon = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f53126ba", esExports)
  }
}
// CONCATENATED MODULE: ./src/core/icons/MdClearIcon.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdClearIcon_default.a,
  icons_MdClearIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/core/icons/MdClearIcon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f53126ba", Component.options)
  } else {
    hotAPI.reload("data-v-f53126ba", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var core_icons_MdClearIcon = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdContent_vue__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdContent_vue__);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdContent_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdContent/MdContent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-500cc355", Component.options)
  } else {
    hotAPI.reload("data-v-500cc355", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 36 */
/***/ (function(module, exports) {

/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */
function isDate (argument) {
  return argument instanceof Date
}

module.exports = isDate


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var startOfISOWeek = __webpack_require__(22)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()

  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear)

  var fourthOfJanuaryOfThisYear = new Date(0)
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear)

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

module.exports = getISOYear


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__(36)

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate) {
  if (isDate(dirtyDate)) {
    return !isNaN(dirtyDate)
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
  }
}

module.exports = isValid


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var getDaysInMonth = __webpack_require__(24)

/**
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  var desiredMonth = date.getMonth() + amount
  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()))
  return date
}

module.exports = addMonths


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(7);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdFocusTrap',
  abstract: true,
  methods: {
    setFocus: function setFocus() {
      var _this = this;

      window.setTimeout(function () {
        if (_this.$el.tagName) {
          _this.$el.setAttribute('tabindex', '-1');
          _this.$el.focus();
        }
      }, 20);
    }
  },
  mounted: function mounted() {
    this.setFocus();
  },
  render: function render() {
    try {
      var defaultSlot = this.$slots.default;

      if (!defaultSlot) {
        return null;
      }

      if (defaultSlot.length > 1) {
        throw new Error();
      }

      return defaultSlot[0];
    } catch (e) {
      _vue2.default.util.warn('MdFocusTrap can only render one, and exactly one child component.', this);
    }

    return null;
  }
};

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdEmptyState/MdEmptyState.vue
var MdEmptyState = __webpack_require__(239);
var MdEmptyState_default = /*#__PURE__*/__webpack_require__.n(MdEmptyState);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8a893a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdEmptyState/MdEmptyState.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "md-empty-state", appear: "" } }, [
    _c(
      "div",
      {
        staticClass: "md-empty-state",
        class: [_vm.emptyStateClasses, _vm.$mdActiveTheme],
        style: _vm.emptyStateStyles
      },
      [
        _c(
          "div",
          { staticClass: "md-empty-state-container" },
          [
            _vm.mdIcon
              ? [
                  _vm.isAssetIcon(_vm.mdIcon)
                    ? _c("md-icon", {
                        staticClass: "md-empty-state-icon",
                        attrs: { "md-src": _vm.mdIcon }
                      })
                    : _c("md-icon", { staticClass: "md-empty-state-icon" }, [
                        _vm._v(_vm._s(_vm.mdIcon))
                      ])
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.mdLabel
              ? _c("strong", { staticClass: "md-empty-state-label" }, [
                  _vm._v(_vm._s(_vm.mdLabel))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.mdDescription
              ? _c("p", { staticClass: "md-empty-state-description" }, [
                  _vm._v(_vm._s(_vm.mdDescription))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._t("default")
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdEmptyState_MdEmptyState = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8a893a2", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdEmptyState/MdEmptyState.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(238)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdEmptyState_default.a,
  MdEmptyState_MdEmptyState,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdEmptyState/MdEmptyState.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d8a893a2", Component.options)
  } else {
    hotAPI.reload("data-v-d8a893a2", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdEmptyState_MdEmptyState = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  mdRounded: Boolean,
  mdSize: {
    type: Number,
    default: 420
  },
  mdIcon: String,
  mdLabel: String,
  mdDescription: String
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdIcon = __webpack_require__(5);

var _MdIcon2 = _interopRequireDefault(_MdIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdIcon2.default.name, _MdIcon2.default);
};

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdMenu/MdMenu.vue
var MdMenu = __webpack_require__(248);
var MdMenu_default = /*#__PURE__*/__webpack_require__.n(MdMenu);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-577c0662","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdMenu/MdMenu.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g({ staticClass: "md-menu" }, _vm.$listeners),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdMenu_MdMenu = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-577c0662", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdMenu/MdMenu.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(247)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdMenu_default.a,
  MdMenu_MdMenu,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdMenu/MdMenu.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-577c0662", Component.options)
  } else {
    hotAPI.reload("data-v-577c0662", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdMenu_MdMenu = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdMenu/MdMenuContent.vue
var MdMenuContent = __webpack_require__(250);
var MdMenuContent_default = /*#__PURE__*/__webpack_require__.n(MdMenuContent);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c16774c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdMenu/MdMenuContent.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-popover",
    {
      attrs: {
        "md-settings": _vm.popperSettings,
        "md-active": _vm.shouldRender
      }
    },
    [
      _vm.shouldRender
        ? _c(
            "transition",
            { attrs: { name: "md-menu-content", css: _vm.didMount } },
            [
              _c(
                "div",
                {
                  class: [
                    _vm.menuClasses,
                    _vm.mdContentClass,
                    _vm.$mdActiveTheme
                  ],
                  style: _vm.menuStyles,
                  on: {
                    keydown: [
                      function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "arrow-down",
                            undefined,
                            $event.key
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        _vm.setHighlight("down")
                      },
                      function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "arrow-up",
                            undefined,
                            $event.key
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        _vm.setHighlight("up")
                      },
                      function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k($event.keyCode, "space", 32, $event.key)
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        _vm.setSelection($event)
                      },
                      function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k($event.keyCode, "enter", 13, $event.key)
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        _vm.setSelection($event)
                      }
                    ]
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "md-menu-content-container md-scrollbar",
                      class: _vm.$mdActiveTheme
                    },
                    [
                      _c(
                        "md-list",
                        _vm._b(
                          {
                            class: _vm.listClasses,
                            on: {
                              keydown: function($event) {
                                if (
                                  !("button" in $event) &&
                                  _vm._k($event.keyCode, "esc", 27, $event.key)
                                ) {
                                  return null
                                }
                                _vm.onEsc($event)
                              }
                            }
                          },
                          "md-list",
                          _vm.$attrs,
                          false
                        ),
                        [_vm._t("default")],
                        2
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdMenu_MdMenuContent = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c16774c", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdMenu/MdMenuContent.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(249)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdMenuContent_default.a,
  MdMenu_MdMenuContent,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdMenu/MdMenuContent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2c16774c", Component.options)
  } else {
    hotAPI.reload("data-v-2c16774c", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdMenu_MdMenuContent = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (el, eventName, observerFn, options) {
  function killObserver() {
    el.removeEventListener(eventName, observerFn);
  }

  el.addEventListener(eventName, observerFn, options || false);

  return {
    destroy: killObserver
  };
};

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdList/MdList.vue
var MdList = __webpack_require__(253);
var MdList_default = /*#__PURE__*/__webpack_require__.n(MdList);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16ed17ef","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdList/MdList.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    _vm._g(
      _vm._b(
        { staticClass: "md-list", class: [_vm.$mdActiveTheme] },
        "ul",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdList_MdList = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16ed17ef", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdList/MdList.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(252)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdList_default.a,
  MdList_MdList,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdList/MdList.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-16ed17ef", Component.options)
  } else {
    hotAPI.reload("data-v-16ed17ef", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdList_MdList = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdListItem_vue__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdListItem_vue__);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(278)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdListItem_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdList/MdListItem/MdListItem.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-cff46336", Component.options)
  } else {
    hotAPI.reload("data-v-cff46336", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['click', 'dblclick', 'mousedown', 'mouseup'];

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdSteppers/MdStepHeader.vue
var MdStepHeader = __webpack_require__(332);
var MdStepHeader_default = /*#__PURE__*/__webpack_require__.n(MdStepHeader);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43e95866","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdSteppers/MdStepHeader.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-button",
    _vm._g(
      _vm._b(
        {
          staticClass: "md-stepper-header",
          class: _vm.classes,
          attrs: { disabled: _vm.shouldDisable },
          nativeOn: {
            click: function($event) {
              _vm.MdSteppers.setActiveStep(_vm.index)
            }
          }
        },
        "md-button",
        _vm.data.props,
        false
      ),
      _vm.data.events
    ),
    [
      _vm.data.error
        ? _c("md-warning-icon", { staticClass: "md-stepper-icon" })
        : _c(
            "div",
            { staticClass: "md-stepper-number" },
            [
              _vm.data.done && _vm.data.editable
                ? _c("md-edit-icon", { staticClass: "md-stepper-editable" })
                : _vm.data.done
                  ? _c("md-check-icon", { staticClass: "md-stepper-done" })
                  : [_vm._v(_vm._s(_vm.MdSteppers.getStepperNumber(_vm.index)))]
            ],
            2
          ),
      _vm._v(" "),
      _c("div", { staticClass: "md-stepper-text" }, [
        _c("span", { staticClass: "md-stepper-label" }, [
          _vm._v(_vm._s(_vm.data.label))
        ]),
        _vm._v(" "),
        _vm.data.error
          ? _c("span", { staticClass: "md-stepper-error" }, [
              _vm._v(_vm._s(_vm.data.error))
            ])
          : _vm.data.description
            ? _c("span", { staticClass: "md-stepper-description" }, [
                _vm._v(_vm._s(_vm.data.description))
              ])
            : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdSteppers_MdStepHeader = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43e95866", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdSteppers/MdStepHeader.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdStepHeader_default.a,
  MdSteppers_MdStepHeader,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdSteppers/MdStepHeader.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-43e95866", Component.options)
  } else {
    hotAPI.reload("data-v-43e95866", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdSteppers_MdStepHeader = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdTable/MdTableRow.vue
var MdTableRow = __webpack_require__(369);
var MdTableRow_default = /*#__PURE__*/__webpack_require__.n(MdTableRow);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00a4496a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdTable/MdTableRow.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    {
      staticClass: "md-table-row",
      class: _vm.rowClasses,
      on: { click: _vm.onClick }
    },
    [
      _vm.selectableCount
        ? _c("md-table-cell-selection", {
            attrs: {
              "md-disabled": _vm.mdDisabled,
              "md-selectable": _vm.mdSelectable === "multiple",
              "md-row-id": _vm.mdIndex
            },
            model: {
              value: _vm.isSelected,
              callback: function($$v) {
                _vm.isSelected = $$v
              },
              expression: "isSelected"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdTable_MdTableRow = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00a4496a", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdTable/MdTableRow.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(368)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdTableRow_default.a,
  MdTable_MdTableRow,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdTable/MdTableRow.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-00a4496a", Component.options)
  } else {
    hotAPI.reload("data-v-00a4496a", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdTable_MdTableRow = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdTable/MdTableCellSelection.vue
var MdTableCellSelection = __webpack_require__(371);
var MdTableCellSelection_default = /*#__PURE__*/__webpack_require__.n(MdTableCellSelection);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50a4b70a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdTable/MdTableCellSelection.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mdSelectable
    ? _c("td", { staticClass: "md-table-cell md-table-cell-selection" }, [
        _c(
          "div",
          { staticClass: "md-table-cell-container" },
          [
            _c("md-checkbox", {
              attrs: { disabled: !_vm.mdSelectable || _vm.mdDisabled },
              on: { change: _vm.onChange },
              model: {
                value: _vm.isSelected,
                callback: function($$v) {
                  _vm.isSelected = $$v
                },
                expression: "isSelected"
              }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdTable_MdTableCellSelection = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50a4b70a", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdTable/MdTableCellSelection.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(370)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdTableCellSelection_default.a,
  MdTable_MdTableCellSelection,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdTable/MdTableCellSelection.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-50a4b70a", Component.options)
  } else {
    hotAPI.reload("data-v-50a4b70a", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdTable_MdTableCellSelection = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdToolbar/MdToolbar.vue
var MdToolbar = __webpack_require__(378);
var MdToolbar_default = /*#__PURE__*/__webpack_require__.n(MdToolbar);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38a0b4d9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdToolbar/MdToolbar.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "md-toolbar",
      class: [_vm.$mdActiveTheme, "md-elevation-" + _vm.mdElevation]
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdToolbar_MdToolbar = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38a0b4d9", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdToolbar/MdToolbar.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(377)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdToolbar_default.a,
  MdToolbar_MdToolbar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdToolbar/MdToolbar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-38a0b4d9", Component.options)
  } else {
    hotAPI.reload("data-v-38a0b4d9", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdToolbar_MdToolbar = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(55);

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _components = __webpack_require__(57);

var MdComponents = _interopRequireWildcard(_components);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VueMaterial = function VueMaterial(Vue) {
  (0, _material2.default)(Vue);

  Object.values(MdComponents).forEach(function (MdComponent) {
    Vue.use(MdComponent);
  });
};

VueMaterial.version = '__VERSION__';

exports.default = VueMaterial;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MdTooltip = exports.MdToolbar = exports.MdTabs = exports.MdTable = exports.MdSwitch = exports.MdSubheader = exports.MdSteppers = exports.MdSpeedDial = exports.MdSnackbar = exports.MdRipple = exports.MdRadio = exports.MdProgress = exports.MdMenu = exports.MdList = exports.MdLayout = exports.MdImage = exports.MdIcon = exports.MdHighlightText = exports.MdField = exports.MdEmptyState = exports.MdElevation = exports.MdDrawer = exports.MdDivider = exports.MdDialogPrompt = exports.MdDialogConfirm = exports.MdDialogAlert = exports.MdDialog = exports.MdDatepicker = exports.MdContent = exports.MdChips = exports.MdCheckbox = exports.MdCard = exports.MdButton = exports.MdBottomBar = exports.MdAvatar = exports.MdAutocomplete = exports.MdApp = undefined;

var _MdApp = __webpack_require__(58);

var _MdApp2 = _interopRequireDefault(_MdApp);

var _MdAutocomplete = __webpack_require__(78);

var _MdAutocomplete2 = _interopRequireDefault(_MdAutocomplete);

var _MdAvatar = __webpack_require__(84);

var _MdAvatar2 = _interopRequireDefault(_MdAvatar);

var _MdBottomBar = __webpack_require__(88);

var _MdBottomBar2 = _interopRequireDefault(_MdBottomBar);

var _MdButton = __webpack_require__(96);

var _MdButton2 = _interopRequireDefault(_MdButton);

var _MdCard = __webpack_require__(102);

var _MdCard2 = _interopRequireDefault(_MdCard);

var _MdCheckbox = __webpack_require__(138);

var _MdCheckbox2 = _interopRequireDefault(_MdCheckbox);

var _MdChips = __webpack_require__(142);

var _MdChips2 = _interopRequireDefault(_MdChips);

var _MdContent = __webpack_require__(162);

var _MdContent2 = _interopRequireDefault(_MdContent);

var _MdDatepicker = __webpack_require__(164);

var _MdDatepicker2 = _interopRequireDefault(_MdDatepicker);

var _MdDialog = __webpack_require__(208);

var _MdDialog2 = _interopRequireDefault(_MdDialog);

var _MdDialogAlert = __webpack_require__(218);

var _MdDialogAlert2 = _interopRequireDefault(_MdDialogAlert);

var _MdDialogConfirm = __webpack_require__(221);

var _MdDialogConfirm2 = _interopRequireDefault(_MdDialogConfirm);

var _MdDialogPrompt = __webpack_require__(224);

var _MdDialogPrompt2 = _interopRequireDefault(_MdDialogPrompt);

var _MdDivider = __webpack_require__(227);

var _MdDivider2 = _interopRequireDefault(_MdDivider);

var _MdDrawer = __webpack_require__(231);

var _MdDrawer2 = _interopRequireDefault(_MdDrawer);

var _MdElevation = __webpack_require__(235);

var _MdElevation2 = _interopRequireDefault(_MdElevation);

var _MdEmptyState = __webpack_require__(237);

var _MdEmptyState2 = _interopRequireDefault(_MdEmptyState);

var _MdField = __webpack_require__(240);

var _MdField2 = _interopRequireDefault(_MdField);

var _MdHighlightText = __webpack_require__(267);

var _MdHighlightText2 = _interopRequireDefault(_MdHighlightText);

var _MdIcon = __webpack_require__(43);

var _MdIcon2 = _interopRequireDefault(_MdIcon);

var _MdImage = __webpack_require__(271);

var _MdImage2 = _interopRequireDefault(_MdImage);

var _MdLayout = __webpack_require__(275);

var _MdLayout2 = _interopRequireDefault(_MdLayout);

var _MdList = __webpack_require__(277);

var _MdList2 = _interopRequireDefault(_MdList);

var _MdMenu = __webpack_require__(295);

var _MdMenu2 = _interopRequireDefault(_MdMenu);

var _MdProgress = __webpack_require__(298);

var _MdProgress2 = _interopRequireDefault(_MdProgress);

var _MdRadio = __webpack_require__(306);

var _MdRadio2 = _interopRequireDefault(_MdRadio);

var _MdRipple = __webpack_require__(310);

var _MdRipple2 = _interopRequireDefault(_MdRipple);

var _MdSnackbar = __webpack_require__(311);

var _MdSnackbar2 = _interopRequireDefault(_MdSnackbar);

var _MdSpeedDial = __webpack_require__(318);

var _MdSpeedDial2 = _interopRequireDefault(_MdSpeedDial);

var _MdSteppers = __webpack_require__(328);

var _MdSteppers2 = _interopRequireDefault(_MdSteppers);

var _MdSubheader = __webpack_require__(342);

var _MdSubheader2 = _interopRequireDefault(_MdSubheader);

var _MdSwitch = __webpack_require__(346);

var _MdSwitch2 = _interopRequireDefault(_MdSwitch);

var _MdTable = __webpack_require__(350);

var _MdTable2 = _interopRequireDefault(_MdTable);

var _MdTabs = __webpack_require__(388);

var _MdTabs2 = _interopRequireDefault(_MdTabs);

var _MdToolbar = __webpack_require__(394);

var _MdToolbar2 = _interopRequireDefault(_MdToolbar);

var _MdTooltip = __webpack_require__(395);

var _MdTooltip2 = _interopRequireDefault(_MdTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.MdApp = _MdApp2.default;
exports.MdAutocomplete = _MdAutocomplete2.default;
exports.MdAvatar = _MdAvatar2.default;
exports.MdBottomBar = _MdBottomBar2.default;
exports.MdButton = _MdButton2.default;
exports.MdCard = _MdCard2.default;
exports.MdCheckbox = _MdCheckbox2.default;
exports.MdChips = _MdChips2.default;
exports.MdContent = _MdContent2.default;
exports.MdDatepicker = _MdDatepicker2.default;
exports.MdDialog = _MdDialog2.default;
exports.MdDialogAlert = _MdDialogAlert2.default;
exports.MdDialogConfirm = _MdDialogConfirm2.default;
exports.MdDialogPrompt = _MdDialogPrompt2.default;
exports.MdDivider = _MdDivider2.default;
exports.MdDrawer = _MdDrawer2.default;
exports.MdElevation = _MdElevation2.default;
exports.MdEmptyState = _MdEmptyState2.default;
exports.MdField = _MdField2.default;
exports.MdHighlightText = _MdHighlightText2.default;
exports.MdIcon = _MdIcon2.default;
exports.MdImage = _MdImage2.default;
exports.MdLayout = _MdLayout2.default;
exports.MdList = _MdList2.default;
exports.MdMenu = _MdMenu2.default;
exports.MdProgress = _MdProgress2.default;
exports.MdRadio = _MdRadio2.default;
exports.MdRipple = _MdRipple2.default;
exports.MdSnackbar = _MdSnackbar2.default;
exports.MdSpeedDial = _MdSpeedDial2.default;
exports.MdSteppers = _MdSteppers2.default;
exports.MdSubheader = _MdSubheader2.default;
exports.MdSwitch = _MdSwitch2.default;
exports.MdTable = _MdTable2.default;
exports.MdTabs = _MdTabs2.default;
exports.MdToolbar = _MdToolbar2.default;
exports.MdTooltip = _MdTooltip2.default;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdApp = __webpack_require__(59);

var _MdApp2 = _interopRequireDefault(_MdApp);

var _MdAppToolbar = __webpack_require__(70);

var _MdAppToolbar2 = _interopRequireDefault(_MdAppToolbar);

var _MdAppContent = __webpack_require__(73);

var _MdAppContent2 = _interopRequireDefault(_MdAppContent);

var _MdAppDrawer = __webpack_require__(76);

var _MdAppDrawer2 = _interopRequireDefault(_MdAppDrawer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdApp2.default.name, _MdApp2.default);
  Vue.component(_MdAppToolbar2.default.name, _MdAppToolbar2.default);
  Vue.component(_MdAppContent2.default.name, _MdAppContent2.default);
  Vue.component(_MdAppDrawer2.default.name, _MdAppDrawer2.default);
};

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdApp_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdApp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdApp_vue__);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(60)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdApp_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdApp/MdApp.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8b7389b6", Component.options)
  } else {
    hotAPI.reload("data-v-8b7389b6", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdAppSideDrawer = __webpack_require__(62);

var _MdAppSideDrawer2 = _interopRequireDefault(_MdAppSideDrawer);

var _MdAppInternalDrawer = __webpack_require__(67);

var _MdAppInternalDrawer2 = _interopRequireDefault(_MdAppInternalDrawer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var componentTypes = ['md-app-toolbar', 'md-app-drawer', 'md-app-content'];

function buildSlots(children, context, functionalContext, options) {
  var slots = [];

  if (children) {
    children.forEach(function (child) {
      var opts = child.componentOptions;

      if (opts && componentTypes.includes(opts.tag)) {
        child.data.slot = opts.tag;
        child.data.provide = options.Ctor.options.provide;
        child.context = context;
        child.functionalContext = functionalContext;

        slots.push(child);
      }
    });
  }

  return slots;
}

function getDrawers(children) {
  var drawerVnodes = children.filter(function (child) {
    return child.componentOptions.tag === 'md-app-drawer';
  });

  return drawerVnodes.length ? drawerVnodes : [];
}

function hasInternalDrawer(attrs) {
  var mdPermanent = attrs && attrs['md-permanent'];

  return mdPermanent && (mdPermanent === 'clipped' || mdPermanent === 'card');
}

exports.default = {
  name: 'MdApp',
  functional: true,
  render: function render(createElement, _ref) {
    var children = _ref.children,
        props = _ref.props;

    var appComponent = _MdAppSideDrawer2.default;

    var _createElement = createElement(appComponent),
        context = _createElement.context,
        functionalContext = _createElement.functionalContext,
        componentOptions = _createElement.componentOptions;

    var slots = buildSlots(children, context, functionalContext, componentOptions);
    var drawers = getDrawers(slots);

    drawers.forEach(function (drawer) {
      if (drawer && hasInternalDrawer(drawer.data.attrs)) {
        appComponent = _MdAppInternalDrawer2.default;
      }
    });

    return createElement(appComponent, {
      attrs: props
    }, slots);
  }
};

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdApp/MdAppSideDrawer.vue
var MdAppSideDrawer = __webpack_require__(64);
var MdAppSideDrawer_default = /*#__PURE__*/__webpack_require__.n(MdAppSideDrawer);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aaa67a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdApp/MdAppSideDrawer.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "md-app md-app-side-drawer md-layout-row",
      class: [_vm.appClasses, _vm.$mdActiveTheme]
    },
    [
      _vm._t("md-app-drawer"),
      _vm._v(" "),
      _c(
        "main",
        {
          staticClass: "md-app-container md-flex md-layout-column",
          class: [_vm.$mdActiveTheme, _vm.scrollerClasses],
          style: _vm.contentStyles,
          on: {
            "&scroll": function($event) {
              _vm.handleScroll($event)
            }
          }
        },
        [
          _vm._t("md-app-toolbar"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "md-app-scroller md-layout-column md-flex",
              class: [_vm.$mdActiveTheme, _vm.scrollerClasses],
              style: _vm.containerStyles,
              on: {
                "&scroll": function($event) {
                  _vm.handleScroll($event)
                }
              }
            },
            [_vm._t("md-app-content")],
            2
          )
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdApp_MdAppSideDrawer = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2aaa67a6", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdApp/MdAppSideDrawer.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(63)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdAppSideDrawer_default.a,
  MdApp_MdAppSideDrawer,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdApp/MdAppSideDrawer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2aaa67a6", Component.options)
  } else {
    hotAPI.reload("data-v-2aaa67a6", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdApp_MdAppSideDrawer = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdAppMixin = __webpack_require__(31);

var _MdAppMixin2 = _interopRequireDefault(_MdAppMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = new _MdComponent2.default({
  name: 'MdAppInternalSideDrawer',
  mixins: [_MdAppMixin2.default]
});

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 66 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdApp/MdAppInternalDrawer.vue
var MdAppInternalDrawer = __webpack_require__(69);
var MdAppInternalDrawer_default = /*#__PURE__*/__webpack_require__.n(MdAppInternalDrawer);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f33ea0da","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdApp/MdAppInternalDrawer.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "md-app md-app-internal-drawer md-layout-column",
      class: [_vm.appClasses, _vm.$mdActiveTheme]
    },
    [
      _vm._t("md-app-toolbar"),
      _vm._v(" "),
      _c(
        "main",
        {
          staticClass: "md-app-container md-flex md-layout-row",
          class: [_vm.$mdActiveTheme, _vm.scrollerClasses],
          style: [_vm.containerStyles, _vm.contentStyles]
        },
        [
          _vm._t("md-app-drawer"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "md-app-scroller md-layout-column md-flex",
              class: [_vm.$mdActiveTheme, _vm.scrollerClasses]
            },
            [_vm._t("md-app-content")],
            2
          )
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdApp_MdAppInternalDrawer = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f33ea0da", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdApp/MdAppInternalDrawer.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(68)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdAppInternalDrawer_default.a,
  MdApp_MdAppInternalDrawer,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdApp/MdAppInternalDrawer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f33ea0da", Component.options)
  } else {
    hotAPI.reload("data-v-f33ea0da", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdApp_MdAppInternalDrawer = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdAppMixin = __webpack_require__(31);

var _MdAppMixin2 = _interopRequireDefault(_MdAppMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = new _MdComponent2.default({
  name: 'MdAppInternalDrawer',
  mixins: [_MdAppMixin2.default]
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdApp/MdAppToolbar.vue
var MdAppToolbar = __webpack_require__(72);
var MdAppToolbar_default = /*#__PURE__*/__webpack_require__.n(MdAppToolbar);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d3e4174","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdApp/MdAppToolbar.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-toolbar",
    _vm._g(
      _vm._b(
        {
          staticClass: "md-app-toolbar",
          class: _vm.toolbarClasses,
          style: _vm.toolbarStyles
        },
        "md-toolbar",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdApp_MdAppToolbar = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d3e4174", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdApp/MdAppToolbar.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(71)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdAppToolbar_default.a,
  MdApp_MdAppToolbar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdApp/MdAppToolbar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2d3e4174", Component.options)
  } else {
    hotAPI.reload("data-v-2d3e4174", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdApp_MdAppToolbar = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'MdAppToolbar',
  inject: ['MdApp'],
  computed: {
    toolbarClasses: function toolbarClasses() {
      return {
        'md-no-elevation': !this.MdApp.toolbar.hasElevation,
        'md-reveal-active': this.MdApp.toolbar.revealActive,
        'md-fixed-last-active': this.MdApp.toolbar.fixedLastActive,
        'md-overlap-off': this.MdApp.toolbar.overlapOff
      };
    },
    toolbarStyles: function toolbarStyles() {
      var styles = {
        'top': this.MdApp.toolbar.top + 'px'
      };

      if (this.MdApp.toolbar.fixedLastActive) {
        styles['transform'] = 'translate3D(0, ' + this.MdApp.toolbar.fixedLastHeight + 'px, 0)';
      }

      return styles;
    }
  },
  mounted: function mounted() {
    var title = this.$el.querySelector('.md-title, .md-display-1, .md-display-2');

    this.MdApp.toolbar.element = this.$el;
    this.MdApp.toolbar.titleElement = title;

    if (title) {
      this.MdApp.toolbar.titleSize = parseInt(window.getComputedStyle(title).fontSize, 10);
    }
  }
};

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdApp/MdAppContent.vue
var MdAppContent = __webpack_require__(75);
var MdAppContent_default = /*#__PURE__*/__webpack_require__.n(MdAppContent);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65f3d944","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdApp/MdAppContent.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showCard
    ? _c(
        "md-card",
        _vm._g(
          _vm._b(
            { staticClass: "md-app-content md-flex" },
            "md-card",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [_vm._t("default")],
        2
      )
    : _c(
        "md-content",
        _vm._g(
          _vm._b(
            { staticClass: "md-app-content md-flex" },
            "md-content",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdApp_MdAppContent = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65f3d944", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdApp/MdAppContent.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(74)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdAppContent_default.a,
  MdApp_MdAppContent,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdApp/MdAppContent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-65f3d944", Component.options)
  } else {
    hotAPI.reload("data-v-65f3d944", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdApp_MdAppContent = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'MdAppContent',
  inject: ['MdApp'],
  computed: {
    showCard: function showCard() {
      return this.MdApp.options && this.MdApp.options.mode === 'overlap';
    }
  }
};

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdApp/MdAppDrawer.vue
var MdAppDrawer = __webpack_require__(77);
var MdAppDrawer_default = /*#__PURE__*/__webpack_require__.n(MdAppDrawer);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d41d1f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdApp/MdAppDrawer.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-drawer",
    _vm._g(
      _vm._b({ staticClass: "md-app-drawer" }, "md-drawer", _vm.$attrs, false),
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdApp_MdAppDrawer = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d41d1f6", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdApp/MdAppDrawer.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdAppDrawer_default.a,
  MdApp_MdAppDrawer,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdApp/MdAppDrawer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1d41d1f6", Component.options)
  } else {
    hotAPI.reload("data-v-1d41d1f6", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdApp_MdAppDrawer = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//

exports.default = {
  name: 'MdAppDrawer',
  inject: ['MdApp'],
  data: function data() {
    return {
      drawerElement: {
        mdActive: null,
        mode: null,
        submode: null
      }
    };
  },
  computed: {
    visible: function visible() {
      return this.drawerElement.mdActive;
    },
    mode: function mode() {
      return this.drawerElement.mode;
    },
    submode: function submode() {
      return this.drawerElement.submode;
    }
  },
  watch: {
    visible: function visible(_visible) {
      this.MdApp.drawer.width = this.getDrawerWidth();
      this.MdApp.drawer.active = _visible;
    },
    mode: function mode(_mode) {
      this.MdApp.drawer.mode = _mode;
    },
    submode: function submode(_submode) {
      this.MdApp.drawer.submode = _submode;
    }
  },
  methods: {
    getDrawerWidth: function getDrawerWidth() {
      if (this.$el) {
        return window.getComputedStyle(this.$el).width;
      }

      return 0;
    }
  },
  mounted: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$nextTick();

            case 2:
              this.drawerElement = this.$children[0];
              this.MdApp.drawer.width = this.getDrawerWidth();
              this.MdApp.drawer.active = this.visible;
              this.MdApp.drawer.mode = this.mode;
              this.MdApp.drawer.submode = this.submode;
              this.MdApp.drawer.initialWidth = this.$el.offsetWidth;

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }()
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdAutocomplete = __webpack_require__(79);

var _MdAutocomplete2 = _interopRequireDefault(_MdAutocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdAutocomplete2.default.name, _MdAutocomplete2.default);
};

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdAutocomplete/MdAutocomplete.vue
var MdAutocomplete = __webpack_require__(81);
var MdAutocomplete_default = /*#__PURE__*/__webpack_require__.n(MdAutocomplete);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-130e5ea2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdAutocomplete/MdAutocomplete.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-field",
    {
      staticClass: "md-autocomplete",
      class: _vm.fieldClasses,
      attrs: { "md-clearable": "", "md-inline": _vm.isBoxLayout }
    },
    [
      _c(
        "md-menu",
        {
          attrs: {
            "md-direction": "bottom-start",
            "md-dense": _vm.mdDense,
            "md-align-trigger": "",
            "md-full-width": "",
            "md-active": _vm.showMenu
          },
          on: {
            "update:mdActive": function($event) {
              _vm.showMenu = $event
            }
          }
        },
        [
          _c(
            "md-input",
            _vm._b(
              {
                attrs: {
                  id: _vm.mdInputId,
                  name: _vm.mdInputName,
                  maxlength: _vm.mdInputMaxlength,
                  placeholder: _vm.mdInputPlaceholder
                },
                on: {
                  focus: function($event) {
                    $event.stopPropagation()
                    _vm.openOnFocus($event)
                  },
                  blur: _vm.hideOptions,
                  input: _vm.onInput,
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    _vm.openOnFocus($event)
                  }
                },
                model: {
                  value: _vm.searchTerm,
                  callback: function($$v) {
                    _vm.searchTerm = $$v
                  },
                  expression: "searchTerm"
                }
              },
              "md-input",
              _vm.$attrs,
              false
            )
          ),
          _vm._v(" "),
          _c(
            "md-menu-content",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.hasScopedEmptySlot || _vm.hasFilteredItems,
                  expression: "hasScopedEmptySlot || hasFilteredItems"
                }
              ],
              class: _vm.contentClasses
            },
            [
              _vm.isPromisePending
                ? _c(
                    "div",
                    { staticClass: "md-autocomplete-loading" },
                    [
                      _c("md-progress-spinner", {
                        attrs: {
                          "md-diameter": 40,
                          "md-stroke": 4,
                          "md-mode": "indeterminate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasFilteredItems
                ? _c(
                    "div",
                    { staticClass: "md-autocomplete-items" },
                    _vm._l(_vm.getOptions(), function(item, index) {
                      return _c(
                        "md-menu-item",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              _vm.selectItem(item, $event)
                            }
                          }
                        },
                        [
                          _vm.$scopedSlots["md-autocomplete-item"]
                            ? _vm._t("md-autocomplete-item", null, {
                                item: item,
                                term: _vm.searchTerm
                              })
                            : [_vm._v(_vm._s(item))]
                        ],
                        2
                      )
                    })
                  )
                : _vm.hasScopedEmptySlot
                  ? _c("md-menu-item", [
                      _c(
                        "div",
                        { staticClass: "md-autocomplete-empty" },
                        [
                          _vm._t("md-autocomplete-empty", null, {
                            term: _vm.searchTerm
                          })
                        ],
                        2
                      )
                    ])
                  : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdAutocomplete_MdAutocomplete = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-130e5ea2", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdAutocomplete/MdAutocomplete.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(80)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdAutocomplete_default.a,
  MdAutocomplete_MdAutocomplete,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdAutocomplete/MdAutocomplete.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-130e5ea2", Component.options)
  } else {
    hotAPI.reload("data-v-130e5ea2", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdAutocomplete_MdAutocomplete = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _fuzzysearch = __webpack_require__(82);

var _fuzzysearch2 = _interopRequireDefault(_fuzzysearch);

var _isPromise2 = __webpack_require__(83);

var _isPromise3 = _interopRequireDefault(_isPromise2);

var _MdPropValidator = __webpack_require__(4);

var _MdPropValidator2 = _interopRequireDefault(_MdPropValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: 'MdAutocomplete',
  props: {
    value: {
      type: null,
      required: true
    },
    mdDense: Boolean,
    mdLayout: _extends({
      type: String,
      default: 'floating'
    }, (0, _MdPropValidator2.default)('md-layout', ['floating', 'box'])),
    mdOpenOnFocus: {
      type: Boolean,
      default: true
    },
    mdFuzzySearch: {
      type: Boolean,
      default: true
    },
    mdOptions: {
      type: [Array, Promise],
      required: true
    },
    mdInputName: String,
    mdInputId: String,
    mdInputMaxlength: [String, Number],
    mdInputPlaceholder: [String, Number]
  },
  data: function data() {
    return {
      searchTerm: this.value,
      showMenu: false,
      triggerPopover: false,
      isPromisePending: false,
      filteredAsyncOptions: []
    };
  },

  computed: {
    isBoxLayout: function isBoxLayout() {
      return this.mdLayout === 'box';
    },
    fieldClasses: function fieldClasses() {
      if (this.isBoxLayout) {
        return 'md-autocomplete-box';
      }
    },
    contentClasses: function contentClasses() {
      if (this.isBoxLayout) {
        return 'md-autocomplete-box-content';
      }
    },
    filteredStaticOptions: function filteredStaticOptions() {
      if (this.isPromise(this.mdOptions)) {
        return false;
      }

      var firstItem = this.mdOptions[0];

      if (this.mdOptions[0] && this.searchTerm) {
        if (typeof firstItem === 'string') {
          return this.filterByString();
        } else if ((typeof firstItem === 'undefined' ? 'undefined' : _typeof(firstItem)) === 'object') {
          return this.filterByObject();
        }
      }

      return this.mdOptions;
    },
    hasFilteredItems: function hasFilteredItems() {
      return this.filteredStaticOptions.length > 0 || this.filteredAsyncOptions.length > 0;
    },
    hasScopedEmptySlot: function hasScopedEmptySlot() {
      return this.$scopedSlots['md-autocomplete-empty'];
    }
  },
  watch: {
    mdOptions: {
      deep: true,
      immediate: true,
      handler: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!this.isPromise(this.mdOptions)) {
                    _context.next = 6;
                    break;
                  }

                  this.isPromisePending = true;
                  _context.next = 4;
                  return this.mdOptions;

                case 4:
                  this.filteredAsyncOptions = _context.sent;

                  this.isPromisePending = false;

                case 6:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function handler() {
          return _ref.apply(this, arguments);
        }

        return handler;
      }()
    },

    value: function value(val) {
      this.searchTerm = val;
    }
  },
  methods: {
    getOptions: function getOptions() {
      if (this.isPromise(this.mdOptions)) {
        return this.filteredAsyncOptions;
      }

      return this.filteredStaticOptions;
    },
    isPromise: function isPromise(obj) {
      return (0, _isPromise3.default)(obj);
    },
    matchText: function matchText(item) {
      var target = item.toLowerCase();
      var search = this.searchTerm.toLowerCase();

      if (this.mdFuzzySearch) {
        return (0, _fuzzysearch2.default)(search, target);
      }

      return target.includes(search);
    },
    filterByString: function filterByString() {
      var _this = this;

      return this.mdOptions.filter(function (item) {
        return _this.matchText(item);
      });
    },
    filterByObject: function filterByObject() {
      var _this2 = this;

      return this.mdOptions.filter(function (item) {
        var values = Object.values(item);
        var valuesCount = values.length;

        for (var i = 0; i <= valuesCount; i++) {
          if (typeof values[i] === 'string' && _this2.matchText(values[i])) {
            return true;
          }
        }
      });
    },
    openOnFocus: function openOnFocus() {
      if (this.mdOpenOnFocus) {
        this.showOptions();
      }
    },
    onInput: function onInput() {
      if (!this.mdOpenOnFocus) {
        this.showOptions();
      }

      if (this.searchTerm.constructor.name.toLowerCase() !== 'inputevent') {
        this.$emit('md-changed', this.searchTerm);
      }
    },
    showOptions: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.showMenu = true;
                _context2.next = 3;
                return this.$nextTick();

              case 3:
                this.triggerPopover = true;
                this.$emit('md-opened');

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function showOptions() {
        return _ref2.apply(this, arguments);
      }

      return showOptions;
    }(),
    hideOptions: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.$nextTick();

              case 2:
                this.showMenu = false;
                _context3.next = 5;
                return this.$nextTick();

              case 5:
                this.triggerPopover = false;
                this.$emit('md-closed');

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function hideOptions() {
        return _ref3.apply(this, arguments);
      }

      return hideOptions;
    }(),
    selectItem: function selectItem(item, $event) {
      var content = $event.target.textContent.trim();

      this.searchTerm = content;
      this.$emit('input', item);
      this.$emit('md-selected', item);
      this.hideOptions();
    }
  }
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function fuzzysearch (needle, haystack) {
  var tlen = haystack.length;
  var qlen = needle.length;
  if (qlen > tlen) {
    return false;
  }
  if (qlen === tlen) {
    return needle === haystack;
  }
  outer: for (var i = 0, j = 0; i < qlen; i++) {
    var nch = needle.charCodeAt(i);
    while (j < tlen) {
      if (haystack.charCodeAt(j++) === nch) {
        continue outer;
      }
    }
    return false;
  }
  return true;
}

module.exports = fuzzysearch;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdAvatar = __webpack_require__(85);

var _MdAvatar2 = _interopRequireDefault(_MdAvatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdAvatar2.default.name, _MdAvatar2.default);
};

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdAvatar/MdAvatar.vue
var MdAvatar = __webpack_require__(87);
var MdAvatar_default = /*#__PURE__*/__webpack_require__.n(MdAvatar);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bc61fcf","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdAvatar/MdAvatar.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-avatar", class: [_vm.$mdActiveTheme] },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdAvatar_MdAvatar = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2bc61fcf", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdAvatar/MdAvatar.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(86)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdAvatar_default.a,
  MdAvatar_MdAvatar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdAvatar/MdAvatar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2bc61fcf", Component.options)
  } else {
    hotAPI.reload("data-v-2bc61fcf", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdAvatar_MdAvatar = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdAvatar'
}); //
//
//
//
//
//

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdBottomBar = __webpack_require__(89);

var _MdBottomBar2 = _interopRequireDefault(_MdBottomBar);

var _MdBottomBarItem = __webpack_require__(94);

var _MdBottomBarItem2 = _interopRequireDefault(_MdBottomBarItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdBottomBar2.default.name, _MdBottomBar2.default);
  Vue.component(_MdBottomBarItem2.default.name, _MdBottomBarItem2.default);
};

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdBottomBar/MdBottomBar.vue
var MdBottomBar = __webpack_require__(91);
var MdBottomBar_default = /*#__PURE__*/__webpack_require__.n(MdBottomBar);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fac6773","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdBottomBar/MdBottomBar.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "md-bottom-bar",
      class: [_vm.$mdActiveTheme, _vm.barClasses]
    },
    [
      _c(
        "md-ripple",
        {
          attrs: {
            "md-disabled": _vm.mdType === "fixed",
            "md-active": _vm.MdBottomBar.mouseEvent
          }
        },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdBottomBar_MdBottomBar = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fac6773", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdBottomBar/MdBottomBar.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(90)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdBottomBar_default.a,
  MdBottomBar_MdBottomBar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdBottomBar/MdBottomBar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0fac6773", Component.options)
  } else {
    hotAPI.reload("data-v-0fac6773", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdBottomBar_MdBottomBar = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdPropValidator = __webpack_require__(4);

var _MdPropValidator2 = _interopRequireDefault(_MdPropValidator);

var _MdRipple = __webpack_require__(8);

var _MdRipple2 = _interopRequireDefault(_MdRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = new _MdComponent2.default({
  name: 'MdBottomBar',
  components: {
    MdRipple: _MdRipple2.default
  },
  props: {
    mdSyncRoute: Boolean,
    mdActiveItem: [String, Number],
    mdType: _extends({
      type: String,
      default: 'fixed'
    }, (0, _MdPropValidator2.default)('md-type', ['fixed', 'shift']))
  },
  data: function data() {
    return {
      MdBottomBar: {
        mouseEvent: null,
        activeItem: null,
        items: {}
      }
    };
  },
  provide: function provide() {
    return {
      MdBottomBar: this.MdBottomBar
    };
  },

  computed: {
    activeItem: function activeItem() {
      return this.MdBottomBar.activeItem;
    },
    barClasses: function barClasses() {
      return _defineProperty({}, 'md-type-' + this.mdType, true);
    }
  },
  watch: {
    activeItem: function activeItem() {
      this.$emit('md-changed', this.activeItem);
    }
  },
  methods: {
    setupWatchers: function setupWatchers() {
      if (this.mdSyncRoute) {
        this.$watch('$route', {
          deep: true,
          handler: function handler() {
            if (this.mdSyncRoute) {
              this.setActiveItemByRoute();
            }
          }
        });
      }
    },
    hasActiveItem: function hasActiveItem() {
      return this.MdBottomBar.activeItem || this.mdActiveItem;
    },
    getItemsAndKeys: function getItemsAndKeys() {
      var items = this.MdBottomBar.items;

      return {
        items: items,
        keys: Object.keys(items)
      };
    },
    setActiveItemByIndex: function setActiveItemByIndex(index) {
      var _getItemsAndKeys = this.getItemsAndKeys(),
          keys = _getItemsAndKeys.keys;

      if (!this.mdActiveItem) {
        this.MdBottomBar.activeItem = keys[index];
      } else {
        this.MdBottomBar.activeItem = this.mdActiveItem;
      }
    },
    setActiveItemByRoute: function setActiveItemByRoute() {
      var _this = this;

      var _getItemsAndKeys2 = this.getItemsAndKeys(),
          items = _getItemsAndKeys2.items,
          keys = _getItemsAndKeys2.keys;

      var tabIndex = null;

      if (this.$router) {
        keys.forEach(function (key, index) {
          var item = items[key];
          var toProp = item.props.to;

          if (toProp && toProp === _this.$route.path) {
            tabIndex = index;
          }
        });
      }

      if (!this.hasActiveItem()) {
        if (keys[tabIndex]) {
          this.MdBottomBar.activeItem = keys[tabIndex];
        } else {
          this.MdBottomBar.activeItem = keys[0];
        }
      } else if (keys[tabIndex]) {
        this.MdBottomBar.activeItem = keys[tabIndex];
      }
    }
  },
  created: function created() {
    this.MdBottomBar.type = this.mdType;
  },
  mounted: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this2 = this;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$nextTick();

            case 2:

              if (this.mdSyncRoute) {
                this.setActiveItemByRoute();
              } else {
                this.setActiveItemByIndex(0);
              }

              window.setTimeout(function () {
                _this2.setupWatchers();
              }, 100);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref2.apply(this, arguments);
    }

    return mounted;
  }()
});

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _raf = __webpack_require__(9);

var _raf2 = _interopRequireDefault(_raf);

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = new _MdComponent2.default({
  name: 'MdRipple',
  props: {
    mdActive: null,
    mdDisabled: Boolean,
    mdCentered: Boolean
  },
  data: function data() {
    return {
      eventType: null,
      waveStyles: null,
      animating: false,
      touchTimeout: null
    };
  },
  computed: {
    isDisabled: function isDisabled() {
      return !this.$material.ripple || this.mdDisabled;
    },
    rippleClasses: function rippleClasses() {
      return {
        'md-disabled': this.isDisabled
      };
    },
    waveClasses: function waveClasses() {
      return {
        'md-centered': this.mdCentered
      };
    }
  },
  watch: {
    mdActive: function mdActive(active) {
      var isBoolean = typeof active === 'boolean';
      var isEvent = active.constructor.name.toLowerCase() === 'mouseevent';

      if (isBoolean && this.mdCentered && active) {
        this.startRipple({
          type: 'mousedown'
        });
        this.$emit('update:mdActive', false);
      } else if (isEvent) {
        this.startRipple(active);
        this.$emit('update:mdActive', false);
      }
    }
  },
  methods: {
    touchMoveCheck: function touchMoveCheck() {
      window.clearTimeout(this.touchTimeout);
    },
    touchStartCheck: function touchStartCheck($event) {
      var _this = this;

      this.touchTimeout = window.setTimeout(function () {
        _this.startRipple($event);
      }, 100);
    },
    startRipple: function startRipple($event) {
      var _this2 = this;

      (0, _raf2.default)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var eventType, isDisabled, mdCentered, size, position;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                eventType = _this2.eventType, isDisabled = _this2.isDisabled, mdCentered = _this2.mdCentered;

                if (!(!isDisabled && (!eventType || eventType === $event.type))) {
                  _context.next = 10;
                  break;
                }

                size = _this2.getSize();
                position = null;


                if (mdCentered) {
                  position = _this2.getCenteredPosition(size);
                } else {
                  position = _this2.getHitPosition($event, size);
                }

                _context.next = 7;
                return _this2.clearWave();

              case 7:

                _this2.eventType = $event.type;
                _this2.animating = true;
                _this2.applyStyles(position, size);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      })));
    },
    applyStyles: function applyStyles(position, size) {
      size += 'px';

      this.waveStyles = _extends({}, position, {
        width: size,
        height: size
      });
    },
    clearWave: function clearWave() {
      this.waveStyles = null;
      this.animating = false;

      return this.$nextTick();
    },
    getSize: function getSize() {
      var _$el = this.$el,
          offsetWidth = _$el.offsetWidth,
          offsetHeight = _$el.offsetHeight;


      return Math.round(Math.max(offsetWidth, offsetHeight));
    },
    getCenteredPosition: function getCenteredPosition(size) {
      var halfSize = -size / 2 + 'px';

      return {
        'margin-top': halfSize,
        'margin-left': halfSize
      };
    },
    getHitPosition: function getHitPosition($event, elementSize) {
      var rect = this.$el.getBoundingClientRect();
      var top = $event.pageY;
      var left = $event.pageX;

      if ($event.type === 'touchstart') {
        top = $event.changedTouches[0].pageY;
        left = $event.changedTouches[0].pageX;
      }

      return {
        top: top - rect.top - elementSize / 2 - document.documentElement.scrollTop + 'px',
        left: left - rect.left - elementSize / 2 - document.documentElement.scrollLeft + 'px'
      };
    }
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdBottomBar/MdBottomBarItem.vue
var MdBottomBarItem = __webpack_require__(95);
var MdBottomBarItem_default = /*#__PURE__*/__webpack_require__.n(MdBottomBarItem);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba29fa6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdBottomBar/MdBottomBarItem.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-button",
    _vm._g(
      _vm._b(
        {
          staticClass: "md-bottom-bar-item",
          class: _vm.itemClasses,
          attrs: {
            id: _vm.id,
            disabled: _vm.mdDisabled,
            "md-ripple": _vm.MdBottomBar.type === "fixed"
          },
          on: { click: _vm.setActiveItem }
        },
        "md-button",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.$slots.default
        ? _vm._t("default")
        : [
            _vm.isAssetIcon(_vm.mdIcon)
              ? _c("md-icon", {
                  staticClass: "md-bottom-bar-icon",
                  attrs: { "md-src": _vm.mdIcon }
                })
              : _c("md-icon", { staticClass: "md-bottom-bar-icon" }, [
                  _vm._v(_vm._s(_vm.mdIcon))
                ]),
            _vm._v(" "),
            _c("span", { staticClass: "md-bottom-bar-label" }, [
              _vm._v(_vm._s(_vm.mdLabel))
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdBottomBar_MdBottomBarItem = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba29fa6", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdBottomBar/MdBottomBarItem.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdBottomBarItem_default.a,
  MdBottomBar_MdBottomBarItem,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdBottomBar/MdBottomBarItem.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ba29fa6", Component.options)
  } else {
    hotAPI.reload("data-v-7ba29fa6", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdBottomBar_MdBottomBarItem = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdAssetIcon = __webpack_require__(18);

var _MdAssetIcon2 = _interopRequireDefault(_MdAssetIcon);

var _MdUuid = __webpack_require__(6);

var _MdUuid2 = _interopRequireDefault(_MdUuid);

var _MdRouterLinkProps = __webpack_require__(12);

var _MdRouterLinkProps2 = _interopRequireDefault(_MdRouterLinkProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ignoredProps = ['id', 'mdLabel', 'mdIcon', 'mdDisabled']; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'MdBottomBarItem',
  mixins: [_MdAssetIcon2.default],
  props: {
    id: {
      type: String,
      default: function _default() {
        return 'md-bottom-bar-item-' + (0, _MdUuid2.default)();
      }
    },
    to: null,
    mdLabel: String,
    mdIcon: String,
    mdDisabled: Boolean
  },
  inject: ['MdBottomBar'],
  watch: {
    $props: {
      deep: true,
      handler: function handler() {
        this.setItemData();
      }
    },
    $attrs: {
      deep: true,
      handler: function handler() {
        this.setItemData();
      }
    }
  },
  computed: {
    itemClasses: function itemClasses() {
      return {
        'md-active': this.id === this.MdBottomBar.activeItem
      };
    }
  },
  methods: {
    getPropValues: function getPropValues() {
      var _this = this;

      var propNames = Object.keys(this.$options.props);
      var values = {};

      propNames.forEach(function (prop) {
        if (!ignoredProps.includes(prop)) {
          if (_this[prop]) {
            values[prop] = _this[prop];
          } else if (_this.$attrs && _this.$attrs.hasOwnProperty(prop)) {
            if (prop) {
              values[prop] = _this.$attrs[prop];
            } else {
              values[prop] = true;
            }
          }
        }
      });

      return values;
    },
    setItemData: function setItemData() {
      this.$set(this.MdBottomBar.items, this.id, {
        disabled: this.mdDisabled,
        options: this.mdTemplateOptions,
        props: this.getPropValues()
      });
    },
    setActiveItem: function setActiveItem($event) {
      this.MdBottomBar.activeItem = this.id;

      if (this.MdBottomBar.type === 'shift') {
        this.MdBottomBar.mouseEvent = $event;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    var _this2 = this;

    if (this.$router && this.$options.propsData.to) {
      var componentProps = (0, _MdRouterLinkProps2.default)(this, this.$options.props);
      var propNames = Object.keys(this.$options.propsData);

      this.$options.props = componentProps;
      propNames.forEach(function (prop) {
        if (!ignoredProps.includes(prop)) {
          _this2.$attrs[prop] = _this2.$options.propsData[prop];
        }
      });
    }
  },
  created: function created() {
    this.setItemData();
  },
  beforeDestroy: function beforeDestroy() {
    this.$delete(this.MdBottomBar.items, this.id);
  }
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdButton = __webpack_require__(13);

var _MdButton2 = _interopRequireDefault(_MdButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdButton2.default.name, _MdButton2.default);
};

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdFocused = __webpack_require__(32);

var _MdFocused2 = _interopRequireDefault(_MdFocused);

var _MdRipple = __webpack_require__(19);

var _MdRipple2 = _interopRequireDefault(_MdRipple);

var _MdRouterLinkProps = __webpack_require__(12);

var _MdRouterLinkProps2 = _interopRequireDefault(_MdRouterLinkProps);

var _MdButtonContent = __webpack_require__(99);

var _MdButtonContent2 = _interopRequireDefault(_MdButtonContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdButton',
  components: {
    MdButtonContent: _MdButtonContent2.default
  },
  mixins: [_MdRipple2.default, _MdFocused2.default],
  props: {
    href: String,
    type: {
      type: String,
      default: 'button'
    },
    disabled: Boolean,
    to: null
  },
  render: function render(createElement) {
    var buttonContent = createElement('md-button-content', {
      attrs: {
        mdRipple: this.mdRipple,
        disabled: this.disabled
      }
    }, this.$slots.default);
    var buttonAttrs = {
      staticClass: 'md-button',
      class: [this.$mdActiveTheme, {
        'md-ripple-off': !this.mdRipple,
        'md-focused': this.mdHasFocus
      }],
      attrs: _extends({}, this.attrs, {
        href: this.href,
        disabled: this.disabled,
        type: !this.href && (this.type || 'button')
      }),
      on: this.$listeners
    };
    var tag = 'button';

    if (this.href) {
      tag = 'a';
    } else if (this.$router && this.to) {
      this.$options.props = (0, _MdRouterLinkProps2.default)(this, this.$options.props);

      tag = 'router-link';
      buttonAttrs.props = this.$props;
      delete buttonAttrs.props.type;
      delete buttonAttrs.attrs.type;
      delete buttonAttrs.props.href;
      delete buttonAttrs.attrs.href;
    }

    return createElement(tag, buttonAttrs, [buttonContent]);
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdButton/MdButtonContent.vue
var MdButtonContent = __webpack_require__(101);
var MdButtonContent_default = /*#__PURE__*/__webpack_require__.n(MdButtonContent);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-008ae93a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdButton/MdButtonContent.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-ripple",
    { attrs: { "md-disabled": !_vm.mdRipple || _vm.disabled } },
    [_c("div", { staticClass: "md-button-content" }, [_vm._t("default")], 2)]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdButton_MdButtonContent = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-008ae93a", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdButton/MdButtonContent.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(100)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdButtonContent_default.a,
  MdButton_MdButtonContent,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdButton/MdButtonContent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-008ae93a", Component.options)
  } else {
    hotAPI.reload("data-v-008ae93a", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdButton_MdButtonContent = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdRipple = __webpack_require__(8);

var _MdRipple2 = _interopRequireDefault(_MdRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdButtonContent',
  components: {
    MdRipple: _MdRipple2.default
  },
  props: {
    mdRipple: Boolean,
    disabled: Boolean
  }
}; //
//
//
//
//
//
//
//

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdCard = __webpack_require__(103);

var _MdCard2 = _interopRequireDefault(_MdCard);

var _MdCardArea = __webpack_require__(106);

var _MdCardArea2 = _interopRequireDefault(_MdCardArea);

var _MdCardHeader = __webpack_require__(109);

var _MdCardHeader2 = _interopRequireDefault(_MdCardHeader);

var _MdCardHeaderText = __webpack_require__(112);

var _MdCardHeaderText2 = _interopRequireDefault(_MdCardHeaderText);

var _MdCardMedia = __webpack_require__(114);

var _MdCardMedia2 = _interopRequireDefault(_MdCardMedia);

var _MdCardMediaActions = __webpack_require__(117);

var _MdCardMediaActions2 = _interopRequireDefault(_MdCardMediaActions);

var _MdCardMediaCover = __webpack_require__(120);

var _MdCardMediaCover2 = _interopRequireDefault(_MdCardMediaCover);

var _MdCardContent = __webpack_require__(123);

var _MdCardContent2 = _interopRequireDefault(_MdCardContent);

var _MdCardExpand = __webpack_require__(126);

var _MdCardExpand2 = _interopRequireDefault(_MdCardExpand);

var _MdCardExpandTrigger = __webpack_require__(129);

var _MdCardExpandTrigger2 = _interopRequireDefault(_MdCardExpandTrigger);

var _MdCardExpandContent = __webpack_require__(132);

var _MdCardExpandContent2 = _interopRequireDefault(_MdCardExpandContent);

var _MdCardActions = __webpack_require__(135);

var _MdCardActions2 = _interopRequireDefault(_MdCardActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdCard2.default.name, _MdCard2.default);
  Vue.component(_MdCardArea2.default.name, _MdCardArea2.default);
  Vue.component(_MdCardHeader2.default.name, _MdCardHeader2.default);
  Vue.component(_MdCardHeaderText2.default.name, _MdCardHeaderText2.default);
  Vue.component(_MdCardMedia2.default.name, _MdCardMedia2.default);
  Vue.component(_MdCardMediaActions2.default.name, _MdCardMediaActions2.default);
  Vue.component(_MdCardMediaCover2.default.name, _MdCardMediaCover2.default);
  Vue.component(_MdCardContent2.default.name, _MdCardContent2.default);
  Vue.component(_MdCardExpand2.default.name, _MdCardExpand2.default);
  Vue.component(_MdCardExpandTrigger2.default.name, _MdCardExpandTrigger2.default);
  Vue.component(_MdCardExpandContent2.default.name, _MdCardExpandContent2.default);
  Vue.component(_MdCardActions2.default.name, _MdCardActions2.default);
};

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdCard/MdCard.vue
var MdCard = __webpack_require__(105);
var MdCard_default = /*#__PURE__*/__webpack_require__.n(MdCard);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24f7f3af","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdCard/MdCard.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-card", class: [_vm.$mdActiveTheme, _vm.cardClasses] },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdCard_MdCard = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24f7f3af", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdCard/MdCard.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(104)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdCard_default.a,
  MdCard_MdCard,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdCard/MdCard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-24f7f3af", Component.options)
  } else {
    hotAPI.reload("data-v-24f7f3af", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdCard_MdCard = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdCard',
  props: {
    mdWithHover: Boolean
  },
  data: function data() {
    return {
      MdCard: {
        expand: false
      }
    };
  },
  provide: function provide() {
    return {
      MdCard: this.MdCard
    };
  },

  computed: {
    cardClasses: function cardClasses() {
      return {
        'md-with-hover': this.mdWithHover,
        'md-expand-active': this.MdCard.expand
      };
    }
  }
}); //
//
//
//
//
//

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdCard/MdCardArea/MdCardArea.vue
var MdCardArea = __webpack_require__(108);
var MdCardArea_default = /*#__PURE__*/__webpack_require__.n(MdCardArea);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132f02d7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdCard/MdCardArea/MdCardArea.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-card-area", class: _vm.areaClasses },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdCardArea_MdCardArea = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-132f02d7", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdCard/MdCardArea/MdCardArea.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(107)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdCardArea_default.a,
  MdCardArea_MdCardArea,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdCard/MdCardArea/MdCardArea.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-132f02d7", Component.options)
  } else {
    hotAPI.reload("data-v-132f02d7", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdCard_MdCardArea_MdCardArea = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'MdCardArea',
  props: {
    mdInset: Boolean
  },
  computed: {
    areaClasses: function areaClasses() {
      return {
        'md-inset': this.mdInset
      };
    }
  }
};

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdCard/MdCardHeader/MdCardHeader.vue
var MdCardHeader = __webpack_require__(111);
var MdCardHeader_default = /*#__PURE__*/__webpack_require__.n(MdCardHeader);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d103817","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdCard/MdCardHeader/MdCardHeader.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "md-card-header" }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdCardHeader_MdCardHeader = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d103817", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdCard/MdCardHeader/MdCardHeader.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(110)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdCardHeader_default.a,
  MdCardHeader_MdCardHeader,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdCard/MdCardHeader/MdCardHeader.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4d103817", Component.options)
  } else {
    hotAPI.reload("data-v-4d103817", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdCard_MdCardHeader_MdCardHeader = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'MdCardHeader'
};

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdCard/MdCardHeader/MdCardHeaderText.vue
var MdCardHeaderText = __webpack_require__(113);
var MdCardHeaderText_default = /*#__PURE__*/__webpack_require__.n(MdCardHeaderText);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49a3ab64","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdCard/MdCardHeader/MdCardHeaderText.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-card-header-text" },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdCardHeader_MdCardHeaderText = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49a3ab64", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdCard/MdCardHeader/MdCardHeaderText.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdCardHeaderText_default.a,
  MdCardHeader_MdCardHeaderText,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdCard/MdCardHeader/MdCardHeaderText.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-49a3ab64", Component.options)
  } else {
    hotAPI.reload("data-v-49a3ab64", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdCard_MdCardHeader_MdCardHeaderText = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'MdCardHeaderText',
  data: function data() {
    return {
      parentClasses: null
    };
  },
  mounted: function mounted() {
    this.parentClasses = this.$parent.$el.classList;

    if (this.parentClasses.contains('md-card-header')) {
      this.parentClasses.add('md-card-header-flex');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.parentClasses.remove('md-card-header-flex');
  }
};

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdCard/MdCardMedia/MdCardMedia.vue
var MdCardMedia = __webpack_require__(116);
var MdCardMedia_default = /*#__PURE__*/__webpack_require__.n(MdCardMedia);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33e1f253","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdCard/MdCardMedia/MdCardMedia.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-card-media", class: _vm.mediaClasses },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdCardMedia_MdCardMedia = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33e1f253", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdCard/MdCardMedia/MdCardMedia.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(115)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdCardMedia_default.a,
  MdCardMedia_MdCardMedia,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdCard/MdCardMedia/MdCardMedia.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-33e1f253", Component.options)
  } else {
    hotAPI.reload("data-v-33e1f253", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdCard_MdCardMedia_MdCardMedia = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//

var _MdPropValidator = __webpack_require__(4);

var _MdPropValidator2 = _interopRequireDefault(_MdPropValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdCardMedia',
  props: {
    mdRatio: _extends({
      type: String
    }, (0, _MdPropValidator2.default)('md-ratio', ['16-9', '16/9', '16:9', '4-3', '4/3', '4:3', '1-1', '1/1', '1:1'])),
    mdMedium: Boolean,
    mdBig: Boolean
  },
  computed: {
    mediaClasses: function mediaClasses() {
      var classes = {};

      if (this.mdRatio) {
        var ratio = this.getAspectRatio();

        if (ratio) {
          var _ratio = _slicedToArray(ratio, 2),
              horiz = _ratio[0],
              vert = _ratio[1];

          classes['md-ratio-' + horiz + '-' + vert] = true;
        }
      }

      if (this.mdMedium || this.mdBig) {
        classes = {
          'md-medium': this.mdMedium,
          'md-big': this.mdBig
        };
      }

      return classes;
    }
  },
  methods: {
    getAspectRatio: function getAspectRatio() {
      var ratio = [];

      if (this.mdRatio.indexOf(':') !== -1) {
        ratio = this.mdRatio.split(':');
      } else if (this.mdRatio.indexOf('/') !== -1) {
        ratio = this.mdRatio.split('/');
      } else if (this.mdRatio.indexOf('-') !== -1) {
        ratio = this.mdRatio.split('-');
      }

      return ratio.length === 2 ? ratio : null;
    }
  }
};

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdCard/MdCardMedia/MdCardMediaActions.vue
var MdCardMediaActions = __webpack_require__(119);
var MdCardMediaActions_default = /*#__PURE__*/__webpack_require__.n(MdCardMediaActions);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-102584da","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdCard/MdCardMedia/MdCardMediaActions.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-card-media-actions" },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdCardMedia_MdCardMediaActions = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-102584da", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdCard/MdCardMedia/MdCardMediaActions.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(118)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdCardMediaActions_default.a,
  MdCardMedia_MdCardMediaActions,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdCard/MdCardMedia/MdCardMediaActions.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-102584da", Component.options)
  } else {
    hotAPI.reload("data-v-102584da", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdCard_MdCardMedia_MdCardMediaActions = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'MdCardMediaActions'
};

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdCard/MdCardMedia/MdCardMediaCover.vue
var MdCardMediaCover = __webpack_require__(122);
var MdCardMediaCover_default = /*#__PURE__*/__webpack_require__.n(MdCardMediaCover);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20dfcfd4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdCard/MdCardMedia/MdCardMediaCover.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-card-media-cover", class: _vm.coverClasses },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.mdTextScrim
        ? _c("div", {
            ref: "backdrop",
            staticClass: "md-card-backdrop",
            style: _vm.coverStyles
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdCardMedia_MdCardMediaCover = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20dfcfd4", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdCard/MdCardMedia/MdCardMediaCover.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(121)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdCardMediaCover_default.a,
  MdCardMedia_MdCardMediaCover,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdCard/MdCardMedia/MdCardMediaCover.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-20dfcfd4", Component.options)
  } else {
    hotAPI.reload("data-v-20dfcfd4", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdCard_MdCardMedia_MdCardMediaCover = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//

exports.default = {
  name: 'MdCardMediaCover',
  props: {
    mdTextScrim: Boolean,
    mdSolid: Boolean
  },
  data: function data() {
    return {
      backdropBackground: {}
    };
  },
  computed: {
    coverClasses: function coverClasses() {
      return {
        'md-text-scrim': this.mdTextScrim,
        'md-solid': this.mdSolid
      };
    },
    coverStyles: function coverStyles() {
      return {
        background: this.backdropBackground
      };
    }
  },
  methods: {
    applyScrimColor: function applyScrimColor(darkness) {
      if (this.$refs.backdrop) {
        this.backdropBackground = 'linear-gradient(to bottom, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, ' + darkness / 2 + ') 66%, rgba(0, 0, 0, ' + darkness + ') 100%)';
      }
    },
    applySolidColor: function applySolidColor(darkness) {
      var area = this.$el.querySelector('.md-card-area');

      if (area) {
        area.style.background = 'rgba(0, 0, 0, ' + darkness + ')';
      }
    },
    getImageLightness: function getImageLightness(image, onLoad, onError) {
      var canvas = document.createElement('canvas');

      image.crossOrigin = 'Anonymous';

      image.onload = function () {
        var colorSum = 0;
        var ctx = void 0;
        var imageData = void 0;
        var imageMetadata = void 0;
        var r = void 0;
        var g = void 0;
        var b = void 0;
        var average = void 0;

        canvas.width = this.width;
        canvas.height = this.height;
        ctx = canvas.getContext('2d');

        ctx.drawImage(this, 0, 0);

        imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        imageMetadata = imageData.data;

        for (var x = 0, len = imageMetadata.length; x < len; x += 4) {
          r = imageMetadata[x];
          g = imageMetadata[x + 1];
          b = imageMetadata[x + 2];

          average = Math.floor((r + g + b) / 3);
          colorSum += average;
        }

        onLoad(Math.floor(colorSum / (this.width * this.height)));
      };

      image.onerror = onError;
    }
  },
  mounted: function mounted() {
    var _this = this;

    var applyBackground = function applyBackground() {
      var darkness = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.6;

      if (_this.mdTextScrim) {
        _this.applyScrimColor(darkness);
      } else if (_this.mdSolid) {
        _this.applySolidColor(darkness);
      }
    };
    var image = this.$el.querySelector('img');

    if (image && (this.mdTextScrim || this.mdSolid)) {
      this.getImageLightness(image, function (lightness) {
        var limit = 256;
        var darkness = (Math.abs(limit - lightness) * 100 / limit + 15) / 100;

        if (darkness >= 0.7) {
          darkness = 0.7;
        }

        applyBackground(darkness);
      }, applyBackground);
    }
  }
};

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdCard/MdCardContent/MdCardContent.vue
var MdCardContent = __webpack_require__(125);
var MdCardContent_default = /*#__PURE__*/__webpack_require__.n(MdCardContent);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36a98486","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdCard/MdCardContent/MdCardContent.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "md-card-content" }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdCardContent_MdCardContent = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36a98486", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdCard/MdCardContent/MdCardContent.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(124)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdCardContent_default.a,
  MdCardContent_MdCardContent,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdCard/MdCardContent/MdCardContent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-36a98486", Component.options)
  } else {
    hotAPI.reload("data-v-36a98486", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdCard_MdCardContent_MdCardContent = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'MdCardContent'
};

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdCard/MdCardExpand/MdCardExpand.vue
var MdCardExpand = __webpack_require__(128);
var MdCardExpand_default = /*#__PURE__*/__webpack_require__.n(MdCardExpand);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d46d3592","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdCard/MdCardExpand/MdCardExpand.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "md-card-expand" }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdCardExpand_MdCardExpand = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d46d3592", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdCard/MdCardExpand/MdCardExpand.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(127)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdCardExpand_default.a,
  MdCardExpand_MdCardExpand,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdCard/MdCardExpand/MdCardExpand.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d46d3592", Component.options)
  } else {
    hotAPI.reload("data-v-d46d3592", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdCard_MdCardExpand_MdCardExpand = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'MdCardExpand',
  inject: ['MdCard']
};

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdCardExpandTrigger_vue__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdCardExpandTrigger_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdCardExpandTrigger_vue__);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(130)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdCardExpandTrigger_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdCard/MdCardExpand/MdCardExpandTrigger.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4ede00b1", Component.options)
  } else {
    hotAPI.reload("data-v-4ede00b1", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = {
  name: 'MdCardExpandTrigger',
  inject: ['MdCard'],
  render: function render(createElement) {
    var _this = this;

    var _$slots$default = _slicedToArray(this.$slots.default, 1),
        trigger = _$slots$default[0];

    var staticClass = ' md-card-expand-trigger';
    var listeners = {
      click: function click() {
        _this.MdCard.expand = !_this.MdCard.expand;
      }
    };

    if (trigger) {
      trigger.componentOptions.listeners = _extends({}, trigger.componentOptions.listeners, listeners);
      trigger.data.staticClass += staticClass;

      return trigger;
    }

    return createElement('div', {
      staticClass: staticClass,
      on: listeners
    });
  }
};

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdCard/MdCardExpand/MdCardExpandContent.vue
var MdCardExpandContent = __webpack_require__(134);
var MdCardExpandContent_default = /*#__PURE__*/__webpack_require__.n(MdCardExpandContent);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-604296f2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdCard/MdCardExpand/MdCardExpandContent.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-card-expand-content", style: _vm.contentStyles },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdCardExpand_MdCardExpandContent = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-604296f2", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdCard/MdCardExpand/MdCardExpandContent.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(133)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdCardExpandContent_default.a,
  MdCardExpand_MdCardExpandContent,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdCard/MdCardExpand/MdCardExpandContent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-604296f2", Component.options)
  } else {
    hotAPI.reload("data-v-604296f2", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdCard_MdCardExpand_MdCardExpandContent = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'MdCardExpandContent',
  inject: ['MdCard'],
  data: function data() {
    return {
      marginTop: 0
    };
  },
  computed: {
    expand: function expand() {
      return this.MdCard.expand;
    },
    contentStyles: function contentStyles() {
      return {
        'margin-top': '-' + this.marginTop + 'px',
        'opacity': this.marginTop === 0 ? 1 : 0
      };
    }
  },
  watch: {
    expand: function expand(_expand) {
      if (!_expand) {
        this.marginTop = this.$el.children[0].offsetHeight;
      } else {
        this.marginTop = 0;
      }
    }
  },
  mounted: function mounted() {
    this.marginTop = this.$el.children[0].offsetHeight;
  }
};

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdCard/MdCardActions/MdCardActions.vue
var MdCardActions = __webpack_require__(137);
var MdCardActions_default = /*#__PURE__*/__webpack_require__.n(MdCardActions);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2894ebc5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdCard/MdCardActions/MdCardActions.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "md-card-actions",
      class: "md-alignment-" + _vm.mdAlignment
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdCardActions_MdCardActions = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2894ebc5", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdCard/MdCardActions/MdCardActions.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(136)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdCardActions_default.a,
  MdCardActions_MdCardActions,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdCard/MdCardActions/MdCardActions.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2894ebc5", Component.options)
  } else {
    hotAPI.reload("data-v-2894ebc5", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdCard_MdCardActions_MdCardActions = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//

var _MdPropValidator = __webpack_require__(4);

var _MdPropValidator2 = _interopRequireDefault(_MdPropValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alignments = ['left', 'right', 'space-between'];

exports.default = {
  name: 'MdCardActions',
  props: {
    mdAlignment: _extends({
      type: String,
      default: 'right'
    }, (0, _MdPropValidator2.default)('md-alignment', alignments))
  }
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdCheckbox = __webpack_require__(139);

var _MdCheckbox2 = _interopRequireDefault(_MdCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdCheckbox2.default.name, _MdCheckbox2.default);
};

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdCheckbox/MdCheckbox.vue
var MdCheckbox = __webpack_require__(141);
var MdCheckbox_default = /*#__PURE__*/__webpack_require__.n(MdCheckbox);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c2899cf","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdCheckbox/MdCheckbox.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "md-checkbox",
      class: [_vm.$mdActiveTheme, _vm.checkClasses]
    },
    [
      _c(
        "div",
        {
          staticClass: "md-checkbox-container",
          on: {
            click: function($event) {
              $event.stopPropagation()
              _vm.toggleCheck($event)
            }
          }
        },
        [
          _c(
            "md-ripple",
            {
              attrs: {
                "md-centered": "",
                "md-active": _vm.rippleActive,
                "md-disabled": _vm.disabled
              },
              on: {
                "update:mdActive": function($event) {
                  _vm.rippleActive = $event
                }
              }
            },
            [
              _c(
                "input",
                _vm._b(
                  { attrs: { type: "checkbox" } },
                  "input",
                  {
                    id: _vm.id,
                    name: _vm.name,
                    disabled: _vm.disabled,
                    required: _vm.required,
                    value: _vm.value
                  },
                  false
                )
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.$slots.default
        ? _c(
            "label",
            {
              staticClass: "md-checkbox-label",
              attrs: { for: _vm.id },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.toggleCheck($event)
                }
              }
            },
            [_vm._t("default")],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdCheckbox_MdCheckbox = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c2899cf", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdCheckbox/MdCheckbox.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(140)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdCheckbox_default.a,
  MdCheckbox_MdCheckbox,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdCheckbox/MdCheckbox.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7c2899cf", Component.options)
  } else {
    hotAPI.reload("data-v-7c2899cf", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdCheckbox_MdCheckbox = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdCheckboxMixin = __webpack_require__(33);

var _MdCheckboxMixin2 = _interopRequireDefault(_MdCheckboxMixin);

var _MdUuid = __webpack_require__(6);

var _MdUuid2 = _interopRequireDefault(_MdUuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdCheckbox',
  mixins: [_MdCheckboxMixin2.default],
  props: {
    id: {
      type: String,
      default: function _default() {
        return 'md-checkbox-' + (0, _MdUuid2.default)();
      }
    }
  }
}); //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdChips = __webpack_require__(143);

var _MdChips2 = _interopRequireDefault(_MdChips);

var _MdChip = __webpack_require__(159);

var _MdChip2 = _interopRequireDefault(_MdChip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdChips2.default.name, _MdChips2.default);
  Vue.component(_MdChip2.default.name, _MdChip2.default);
};

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdChips/MdChips.vue
var MdChips = __webpack_require__(145);
var MdChips_default = /*#__PURE__*/__webpack_require__.n(MdChips);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b3d2a1e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdChips/MdChips.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-field",
    { staticClass: "md-chips", class: [_vm.$mdActiveTheme, _vm.chipsClasses] },
    [
      !_vm.mdStatic ? _vm._t("default") : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.value, function(chip, key) {
        return _c(
          "md-chip",
          {
            key: key,
            attrs: {
              "md-deletable": !_vm.mdStatic,
              "md-clickable": !_vm.mdStatic
            },
            on: {
              keydown: function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "enter", 13, $event.key)
                ) {
                  return null
                }
                _vm.$emit("md-click", chip, key)
              },
              "md-delete": function($event) {
                $event.stopPropagation()
                _vm.removeChip(chip)
              }
            },
            nativeOn: {
              click: function($event) {
                _vm.$emit("md-click", chip, key)
              }
            }
          },
          [
            _vm.$scopedSlots["md-chip"]
              ? _vm._t("md-chip", [_vm._v(_vm._s(chip))], { chip: chip })
              : [_vm._v(_vm._s(chip))]
          ],
          2
        )
      }),
      _vm._v(" "),
      !_vm.mdStatic && _vm.modelRespectLimit
        ? _c("md-input", {
            ref: "input",
            attrs: {
              type: _vm.mdInputType,
              id: _vm.id,
              placeholder: _vm.mdPlaceholder
            },
            on: {
              keydown: [
                function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key)
                  ) {
                    return null
                  }
                  _vm.insertChip($event)
                },
                function($event) {
                  if (!("button" in $event) && $event.keyCode !== 8) {
                    return null
                  }
                  _vm.handleBackRemove($event)
                }
              ]
            },
            model: {
              value: _vm.inputValue,
              callback: function($$v) {
                _vm.inputValue = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "inputValue"
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdChips_MdChips = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b3d2a1e", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdChips/MdChips.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(144)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdChips_default.a,
  MdChips_MdChips,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdChips/MdChips.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0b3d2a1e", Component.options)
  } else {
    hotAPI.reload("data-v-0b3d2a1e", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdChips_MdChips = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdField = __webpack_require__(20);

var _MdField2 = _interopRequireDefault(_MdField);

var _MdInput = __webpack_require__(14);

var _MdInput2 = _interopRequireDefault(_MdInput);

var _MdUuid = __webpack_require__(6);

var _MdUuid2 = _interopRequireDefault(_MdUuid);

var _MdPropValidator = __webpack_require__(4);

var _MdPropValidator2 = _interopRequireDefault(_MdPropValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdChips',
  components: {
    MdField: _MdField2.default,
    MdInput: _MdInput2.default
  },
  props: {
    value: Array,
    id: {
      type: [String, Number],
      default: function _default() {
        return 'md-chips-' + (0, _MdUuid2.default)();
      }
    },
    mdInputType: _extends({
      type: [String, Number]
    }, (0, _MdPropValidator2.default)('md-input-type', ['email', 'number', 'password', 'search', 'tel', 'text', 'url'])),
    mdPlaceholder: [String, Number],
    mdStatic: Boolean,
    mdLimit: Number
  },
  data: function data() {
    return {
      inputValue: ''
    };
  },
  computed: {
    chipsClasses: function chipsClasses() {
      return {
        'md-has-value': this.value && this.value.length
      };
    },
    modelRespectLimit: function modelRespectLimit() {
      return !this.mdLimit || this.value.length < this.mdLimit;
    }
  },
  methods: {
    insertChip: function insertChip(_ref) {
      var target = _ref.target;

      if (!this.inputValue || this.value.includes(this.inputValue) || !this.modelRespectLimit) {
        return;
      }
      this.value.push(this.inputValue);
      this.$emit('input', this.value);
      this.$emit('md-insert', this.inputValue);
      this.inputValue = '';
    },
    removeChip: function removeChip(chip) {
      var _this = this;

      var index = this.value.indexOf(chip);

      this.value.splice(index, 1);
      this.$emit('input', this.value);
      this.$emit('md-delete', chip, index);
      this.$nextTick(function () {
        return _this.$refs.input.$el.focus();
      });
    },
    handleBackRemove: function handleBackRemove() {
      if (!this.inputValue) {
        this.removeChip(this.value[this.value.length - 1]);
      }
    }
  }
});

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdClearIcon = __webpack_require__(34);

var _MdClearIcon2 = _interopRequireDefault(_MdClearIcon);

var _MdPasswordOffIcon = __webpack_require__(154);

var _MdPasswordOffIcon2 = _interopRequireDefault(_MdPasswordOffIcon);

var _MdPasswordOnIcon = __webpack_require__(156);

var _MdPasswordOnIcon2 = _interopRequireDefault(_MdPasswordOnIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = new _MdComponent2.default({
  name: 'MdField',
  components: {
    MdClearIcon: _MdClearIcon2.default,
    MdPasswordOffIcon: _MdPasswordOffIcon2.default,
    MdPasswordOnIcon: _MdPasswordOnIcon2.default
  },
  props: {
    mdInline: Boolean,
    mdClearable: Boolean,
    mdCounter: {
      type: Boolean,
      default: true
    },
    mdTogglePassword: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      showPassword: false,
      MdField: {
        value: null,
        focused: false,
        highlighted: false,
        disabled: false,
        required: false,
        placeholder: false,
        textarea: false,
        autogrow: false,
        maxlength: null,
        counter: null,
        password: null,
        togglePassword: false,
        clear: false,
        file: false
      }
    };
  },
  provide: function provide() {
    return {
      MdField: this.MdField
    };
  },

  computed: {
    stringValue: function stringValue() {
      return this.MdField.value && this.MdField.value.toString();
    },
    hasCounter: function hasCounter() {
      return this.mdCounter && (this.MdField.maxlength || this.MdField.counter);
    },
    hasPasswordToggle: function hasPasswordToggle() {
      return this.mdTogglePassword && this.MdField.password;
    },
    hasValue: function hasValue() {
      return this.stringValue && this.stringValue.length > 0;
    },
    valueLength: function valueLength() {
      if (this.stringValue) {
        return this.stringValue.length;
      }

      return 0;
    },
    fieldClasses: function fieldClasses() {
      return {
        'md-inline': this.mdInline,
        'md-clearable': this.mdClearable,
        'md-focused': this.MdField.focused,
        'md-highlight': this.MdField.highlighted,
        'md-disabled': this.MdField.disabled,
        'md-required': this.MdField.required,
        'md-has-value': this.hasValue,
        'md-has-placeholder': this.MdField.placeholder,
        'md-has-textarea': this.MdField.textarea,
        'md-has-password': this.MdField.password,
        'md-has-file': this.MdField.file,
        'md-has-select': this.MdField.select,
        'md-autogrow': this.MdField.autogrow
      };
    }
  },
  methods: {
    clearInput: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.MdField.clear = true;
                _context.next = 3;
                return this.$nextTick();

              case 3:
                this.MdField.clear = false;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function clearInput() {
        return _ref.apply(this, arguments);
      }

      return clearInput;
    }(),
    togglePassword: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.MdField.togglePassword = !this.MdField.togglePassword;

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function togglePassword() {
        return _ref2.apply(this, arguments);
      }

      return togglePassword;
    }(),
    onBlur: function onBlur() {
      this.MdField.highlighted = false;
    }
  }
});

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdIcon = __webpack_require__(5);

var _MdIcon2 = _interopRequireDefault(_MdIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdClearIcon',
  components: {
    MdIcon: _MdIcon2.default
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdSvgLoader = __webpack_require__(151);

var _MdSvgLoader2 = _interopRequireDefault(_MdSvgLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//

exports.default = new _MdComponent2.default({
  name: 'MdIcon',
  components: {
    MdSvgLoader: _MdSvgLoader2.default
  },
  props: {
    mdSrc: String
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdSvgLoader/MdSvgLoader.vue
var MdSvgLoader = __webpack_require__(153);
var MdSvgLoader_default = /*#__PURE__*/__webpack_require__.n(MdSvgLoader);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0db3655e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdSvgLoader/MdSvgLoader.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("i", {
    staticClass: "md-svg-loader",
    domProps: { innerHTML: _vm._s(_vm.html) }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdSvgLoader_MdSvgLoader = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0db3655e", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdSvgLoader/MdSvgLoader.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(152)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdSvgLoader_default.a,
  MdSvgLoader_MdSvgLoader,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdSvgLoader/MdSvgLoader.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0db3655e", Component.options)
  } else {
    hotAPI.reload("data-v-0db3655e", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdSvgLoader_MdSvgLoader = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//

var mdSVGStore = {};

exports.default = {
  name: 'MdSVGLoader',
  props: {
    mdSrc: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      html: null,
      error: null
    };
  },
  watch: {
    mdSrc: function mdSrc() {
      this.html = null;
      this.loadSVG();
    }
  },
  methods: {
    isSVG: function isSVG(mimetype) {
      return mimetype.indexOf('svg') >= 0;
    },
    setHtml: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return mdSVGStore[this.mdSrc];

              case 2:
                this.html = _context.sent;
                _context.next = 5;
                return this.$nextTick();

              case 5:

                this.$emit('md-loaded');

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setHtml(_x) {
        return _ref.apply(this, arguments);
      }

      return setHtml;
    }(),
    unexpectedError: function unexpectedError(reject) {
      this.error = 'Something bad happened trying to fetch ' + this.mdSrc + '.';
      reject(this.error);
    },
    loadSVG: function loadSVG() {
      var _this = this;

      if (!mdSVGStore.hasOwnProperty(this.mdSrc)) {
        mdSVGStore[this.mdSrc] = new Promise(function (resolve, reject) {
          var request = new window.XMLHttpRequest();

          request.open('GET', _this.mdSrc, true);

          request.onload = function () {
            var mimetype = request.getResponseHeader('content-type');

            if (request.status === 200) {
              if (_this.isSVG(mimetype)) {
                resolve(request.response);
                _this.setHtml();
              } else {
                _this.error = 'The file ' + _this.mdSrc + ' is not a valid SVG.';
                reject(_this.error);
              }
            } else if (request.status >= 400 && request.status < 500) {
              _this.error = 'The file ' + _this.mdSrc + ' do not exists.';
              reject(_this.error);
            } else {
              _this.unexpectedError(reject);
            }
          };

          request.onerror = function () {
            return _this.unexpectedError(reject);
          };
          request.onabort = function () {
            return _this.unexpectedError(reject);
          };
          request.send();
        });
      } else {
        this.setHtml();
      }
    }
  },
  mounted: function mounted() {
    this.loadSVG();
  }
};

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/core/icons/MdPasswordOffIcon.vue
var MdPasswordOffIcon = __webpack_require__(155);
var MdPasswordOffIcon_default = /*#__PURE__*/__webpack_require__.n(MdPasswordOffIcon);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4113206a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/core/icons/MdPasswordOffIcon.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("md-icon", { staticClass: "md-icon-image" }, [
      _c(
        "svg",
        {
          attrs: {
            height: "24",
            viewBox: "0 0 24 24",
            width: "24",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("path", {
            attrs: {
              d: "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z",
              fill: "none"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
            }
          })
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var icons_MdPasswordOffIcon = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4113206a", esExports)
  }
}
// CONCATENATED MODULE: ./src/core/icons/MdPasswordOffIcon.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdPasswordOffIcon_default.a,
  icons_MdPasswordOffIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/core/icons/MdPasswordOffIcon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4113206a", Component.options)
  } else {
    hotAPI.reload("data-v-4113206a", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var core_icons_MdPasswordOffIcon = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdIcon = __webpack_require__(5);

var _MdIcon2 = _interopRequireDefault(_MdIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdPasswordOffIcon',
  components: {
    MdIcon: _MdIcon2.default
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/core/icons/MdPasswordOnIcon.vue
var MdPasswordOnIcon = __webpack_require__(157);
var MdPasswordOnIcon_default = /*#__PURE__*/__webpack_require__.n(MdPasswordOnIcon);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71ec8df4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/core/icons/MdPasswordOnIcon.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("md-icon", { staticClass: "md-icon-image" }, [
      _c(
        "svg",
        {
          attrs: {
            height: "24",
            viewBox: "0 0 24 24",
            width: "24",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("path", { attrs: { d: "M0 0h24v24H0z", fill: "none" } }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
            }
          })
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var icons_MdPasswordOnIcon = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71ec8df4", esExports)
  }
}
// CONCATENATED MODULE: ./src/core/icons/MdPasswordOnIcon.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdPasswordOnIcon_default.a,
  icons_MdPasswordOnIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/core/icons/MdPasswordOnIcon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-71ec8df4", Component.options)
  } else {
    hotAPI.reload("data-v-71ec8df4", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var core_icons_MdPasswordOnIcon = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdIcon = __webpack_require__(5);

var _MdIcon2 = _interopRequireDefault(_MdIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdPasswordOnIcon',
  components: {
    MdIcon: _MdIcon2.default
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdUuid = __webpack_require__(6);

var _MdUuid2 = _interopRequireDefault(_MdUuid);

var _MdFieldMixin = __webpack_require__(15);

var _MdFieldMixin2 = _interopRequireDefault(_MdFieldMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdInput',
  mixins: [_MdFieldMixin2.default],
  inject: ['MdField'],
  props: {
    id: {
      type: String,
      default: function _default() {
        return 'md-input-' + (0, _MdUuid2.default)();
      }
    },
    type: {
      type: String,
      default: 'text'
    }
  },
  computed: {
    toggleType: function toggleType() {
      return this.MdField.togglePassword;
    },
    isPassword: function isPassword() {
      return this.type === 'password';
    },
    listeners: function listeners() {
      var _this = this;

      return _extends({}, this.$listeners, {
        input: function input(event) {
          return _this.$emit('input', event.target.value);
        }
      });
    }
  },
  watch: {
    type: function type(_type) {
      this.setPassword(this.isPassword);
    },
    toggleType: function toggleType(toggle) {
      if (toggle) {
        this.setTypeText();
      } else {
        this.setTypePassword();
      }
    }
  },
  methods: {
    setPassword: function setPassword(state) {
      this.MdField.password = state;
      this.MdField.togglePassword = false;
    },
    setTypePassword: function setTypePassword() {
      this.$el.type = 'password';
    },
    setTypeText: function setTypeText() {
      this.$el.type = 'text';
    }
  },
  created: function created() {
    this.setPassword(this.isPassword);
  },
  beforeDestroy: function beforeDestroy() {
    this.setPassword(false);
  }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdChips/MdChip.vue
var MdChip = __webpack_require__(161);
var MdChip_default = /*#__PURE__*/__webpack_require__.n(MdChip);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84ba771c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdChips/MdChip.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "md-chip", appear: "" } }, [
    _c(
      "div",
      _vm._g(
        {
          staticClass: "md-chip",
          class: [_vm.$mdActiveTheme, _vm.chipClasses],
          attrs: { tabindex: "0" }
        },
        _vm.$listeners
      ),
      [
        _vm.mdClickable || !_vm.mdRipple
          ? _c(
              "md-ripple",
              { attrs: { "md-disabled": _vm.mdDisabled } },
              [_vm._t("default")],
              2
            )
          : _vm._t("default"),
        _vm._v(" "),
        _c(
          "transition",
          { attrs: { name: "md-input-action", appear: "" } },
          [
            _vm.mdDeletable
              ? _c(
                  "md-button",
                  {
                    staticClass:
                      "md-icon-button md-dense md-input-action md-clear",
                    attrs: { tabindex: "-1" },
                    on: {
                      click: function($event) {
                        _vm.$emit("md-delete", $event)
                      }
                    }
                  },
                  [_c("md-clear-icon")],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdChips_MdChip = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-84ba771c", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdChips/MdChip.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(160)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdChip_default.a,
  MdChips_MdChip,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdChips/MdChip.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-84ba771c", Component.options)
  } else {
    hotAPI.reload("data-v-84ba771c", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdChips_MdChip = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdFocused = __webpack_require__(32);

var _MdFocused2 = _interopRequireDefault(_MdFocused);

var _MdRipple = __webpack_require__(19);

var _MdRipple2 = _interopRequireDefault(_MdRipple);

var _MdClearIcon = __webpack_require__(34);

var _MdClearIcon2 = _interopRequireDefault(_MdClearIcon);

var _MdButton = __webpack_require__(13);

var _MdButton2 = _interopRequireDefault(_MdButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdChip',
  components: {
    MdButton: _MdButton2.default,
    MdClearIcon: _MdClearIcon2.default
  },
  mixins: [_MdFocused2.default, _MdRipple2.default],
  props: {
    mdDisabled: Boolean,
    mdDeletable: Boolean,
    mdClickable: Boolean
  },
  computed: {
    chipClasses: function chipClasses() {
      return {
        'md-disabled': this.mdDisabled,
        'md-deletable': this.mdDeletable,
        'md-clickable': this.mdClickable,
        'md-focused': this.mdHasFocus
      };
    }
  }
}); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdContent = __webpack_require__(35);

var _MdContent2 = _interopRequireDefault(_MdContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdContent2.default.name, _MdContent2.default);
};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdContent',
  props: {
    mdTag: {
      type: String,
      default: 'div'
    }
  },
  render: function render(createElement) {
    return createElement(this.mdTag, {
      staticClass: 'md-content',
      class: [this.$mdActiveTheme],
      attrs: this.$attrs,
      on: this.$listeners
    }, this.$slots.default);
  }
});

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdDatepicker = __webpack_require__(165);

var _MdDatepicker2 = _interopRequireDefault(_MdDatepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdDatepicker2.default.name, _MdDatepicker2.default);
};

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdDatepicker/MdDatepicker.vue
var MdDatepicker = __webpack_require__(167);
var MdDatepicker_default = /*#__PURE__*/__webpack_require__.n(MdDatepicker);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37fe792f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdDatepicker/MdDatepicker.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-field",
    { staticClass: "md-datepicker" },
    [
      _c("md-date-icon", {
        staticClass: "md-date-icon",
        nativeOn: {
          click: function($event) {
            _vm.toggleDialog($event)
          }
        }
      }),
      _vm._v(" "),
      _c("md-input", {
        ref: "input",
        attrs: { type: "date", pattern: "[0-9]{4}-[0-9]{2}-[0-9]{2}" },
        nativeOn: {
          focus: function($event) {
            _vm.onFocus($event)
          }
        },
        model: {
          value: _vm.modelDate,
          callback: function($$v) {
            _vm.modelDate = $$v
          },
          expression: "modelDate"
        }
      }),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "keep-alive",
        [
          _vm.showDialog
            ? _c("md-datepicker-dialog", {
                attrs: {
                  "md-date": _vm.selectedDate,
                  "md-disabled-dates": _vm.mdDisabledDates
                },
                on: {
                  "update:mdDate": function($event) {
                    _vm.selectedDate = $event
                  },
                  "md-closed": _vm.toggleDialog
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("md-overlay", {
        staticClass: "md-datepicker-overlay",
        attrs: { "md-fixed": "", "md-active": _vm.showDialog },
        on: { click: _vm.toggleDialog }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdDatepicker_MdDatepicker = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37fe792f", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdDatepicker/MdDatepicker.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(166)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdDatepicker_default.a,
  MdDatepicker_MdDatepicker,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdDatepicker/MdDatepicker.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-37fe792f", Component.options)
  } else {
    hotAPI.reload("data-v-37fe792f", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdDatepicker_MdDatepicker = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(7);

var _vue2 = _interopRequireDefault(_vue);

var _isFirefox = __webpack_require__(168);

var _isFirefox2 = _interopRequireDefault(_isFirefox);

var _format = __webpack_require__(169);

var _format2 = _interopRequireDefault(_format);

var _parse = __webpack_require__(3);

var _parse2 = _interopRequireDefault(_parse);

var _is_valid = __webpack_require__(38);

var _is_valid2 = _interopRequireDefault(_is_valid);

var _MdOverlay = __webpack_require__(23);

var _MdOverlay2 = _interopRequireDefault(_MdOverlay);

var _MdDatepickerDialog = __webpack_require__(182);

var _MdDatepickerDialog2 = _interopRequireDefault(_MdDatepickerDialog);

var _MdDateIcon = __webpack_require__(206);

var _MdDateIcon2 = _interopRequireDefault(_MdDateIcon);

var _MdField = __webpack_require__(20);

var _MdField2 = _interopRequireDefault(_MdField);

var _MdInput = __webpack_require__(14);

var _MdInput2 = _interopRequireDefault(_MdInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'MdDatepicker',
  components: {
    MdOverlay: _MdOverlay2.default,
    MdDateIcon: _MdDateIcon2.default,
    MdField: _MdField2.default,
    MdInput: _MdInput2.default,
    MdDatepickerDialog: _MdDatepickerDialog2.default
  },
  props: {
    value: [String, Date],
    mdDisabledDates: [Array, Function],
    mdOpenOnFocus: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      showDialog: false,
      modelDate: null,
      selectedDate: null
    };
  },
  watch: {
    selectedDate: function selectedDate(_selectedDate) {
      if (_selectedDate) {
        this.modelDate = this.dateToHTMLString(_selectedDate);
        this.$emit('input', _selectedDate);
      }
    },
    value: function value() {
      if (this.value) {
        this.modelDate = this.dateToHTMLString(this.value);
      }
    },
    modelDate: function modelDate(value) {
      if (value) {
        var parsedDate = (0, _parse2.default)(value);

        if ((0, _is_valid2.default)(parsedDate)) {
          this.selectedDate = parsedDate;
        }
      }
    }
  },
  methods: {
    toggleDialog: function toggleDialog() {
      if (!_isFirefox2.default) {
        this.showDialog = !this.showDialog;
      } else {
        this.$refs.input.$el.click();
      }
    },
    onFocus: function onFocus() {
      if (this.mdOpenOnFocus) {
        this.toggleDialog();
      }
    },
    dateToHTMLString: function dateToHTMLString(date) {
      if (date) {
        var formattedDate = null;

        try {
          formattedDate = (0, _format2.default)(date, 'YYYY-MM-DD');
        } catch (error) {
          _vue2.default.util.warn('The datepicker value is not a valid date. Given value: ' + date + '.', this);
        }

        return formattedDate;
      }
    }
  },
  created: function created() {
    this.modelDate = this.dateToHTMLString(this.value);
    this.selectedDate = this.value;
  }
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = typeof navigator !== 'undefined' && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var getDayOfYear = __webpack_require__(170)
var getISOWeek = __webpack_require__(173)
var getISOYear = __webpack_require__(37)
var parse = __webpack_require__(3)
var isValid = __webpack_require__(38)
var enLocale = __webpack_require__(176)

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
  var options = dirtyOptions || {}

  var locale = options.locale
  var localeFormatters = enLocale.format.formatters
  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp
    }
  }

  var date = parse(dirtyDate)

  if (!isValid(date)) {
    return 'Invalid Date'
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp)

  return formatFn(date)
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getMonth() + 1
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getMonth() + 1, 2)
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getMonth() + 1) / 3)
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getDate()
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return getDayOfYear(date)
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(getDayOfYear(date), 3)
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getDay()
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return getISOWeek(date)
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(getISOWeek(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(getISOYear(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return getISOYear(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getHours()
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date) {
    return formatTimezone(date.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date) {
    return formatTimezone(date.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date) {
    return Math.floor(date.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date) {
    return date.getTime()
  }
}

function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
  var array = formatStr.match(formattingTokensRegExp)
  var length = array.length

  var i
  var formatter
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array[i]] || formatters[array[i]]
    if (formatter) {
      array[i] = formatter
    } else {
      array[i] = removeFormattingTokens(array[i])
    }
  }

  return function (date) {
    var output = ''
    for (var i = 0; i < length; i++) {
      if (array[i] instanceof Function) {
        output += array[i](date, formatters)
      } else {
        output += array[i]
      }
    }
    return output
  }
}

function removeFormattingTokens (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || ''
  var sign = offset > 0 ? '-' : '+'
  var absOffset = Math.abs(offset)
  var hours = Math.floor(absOffset / 60)
  var minutes = absOffset % 60
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString()
  while (output.length < targetLength) {
    output = '0' + output
  }
  return output
}

module.exports = format


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var startOfYear = __webpack_require__(171)
var differenceInCalendarDays = __webpack_require__(172)

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = differenceInCalendarDays(date, startOfYear(date))
  var dayOfYear = diff + 1
  return dayOfYear
}

module.exports = getDayOfYear


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse(dirtyDate)
  var date = new Date(0)
  date.setFullYear(cleanDate.getFullYear(), 0, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYear


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(21)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_DAY = 86400000

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = startOfDay(dirtyDateLeft)
  var startOfDayRight = startOfDay(dirtyDateRight)

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}

module.exports = differenceInCalendarDays


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var startOfISOWeek = __webpack_require__(22)
var startOfISOYear = __webpack_require__(175)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime()

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

module.exports = getISOWeek


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

  date.setDate(date.getDate() - diff)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfWeek


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(37)
var startOfISOWeek = __webpack_require__(22)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  return date
}

module.exports = startOfISOYear


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var buildDistanceInWordsLocale = __webpack_require__(177)
var buildFormatLocale = __webpack_require__(178)

/**
 * @category Locales
 * @summary English locale.
 */
module.exports = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
}


/***/ }),
/* 177 */
/***/ (function(module, exports) {

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  }

  function localize (token, count, options) {
    options = options || {}

    var result
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token]
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result
      } else {
        return result + ' ago'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

module.exports = buildDistanceInWordsLocale


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var buildFormattingTokensRegExp = __webpack_require__(179)

function buildFormatLocale () {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  var meridiemUppercase = ['AM', 'PM']
  var meridiemLowercase = ['am', 'pm']
  var meridiemFull = ['a.m.', 'p.m.']

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  }

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    }
  })

  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  }
}

function ordinal (number) {
  var rem100 = number % 100
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

module.exports = buildFormatLocale


/***/ }),
/* 179 */
/***/ (function(module, exports) {

var commonFormatterKeys = [
  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
  'H', 'HH', 'h', 'hh', 'm', 'mm',
  's', 'ss', 'S', 'SS', 'SSS',
  'Z', 'ZZ', 'X', 'x'
]

function buildFormattingTokensRegExp (formatters) {
  var formatterKeys = []
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key)
    }
  }

  var formattingTokens = commonFormatterKeys
    .concat(formatterKeys)
    .sort()
    .reverse()
  var formattingTokensRegExp = new RegExp(
    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
  )

  return formattingTokensRegExp
}

module.exports = buildFormattingTokensRegExp


/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdPortal = __webpack_require__(16);

var _MdPortal2 = _interopRequireDefault(_MdPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdOverlay',
  components: {
    MdPortal: _MdPortal2.default
  },
  props: {
    mdActive: Boolean,
    mdAttachToParent: Boolean,
    mdFixed: Boolean
  },
  computed: {
    overlayClasses: function overlayClasses() {
      return {
        'md-fixed': this.mdFixed
      };
    }
  }
}; //
//
//
//
//
//
//
//

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdDatepicker/MdDatepickerDialog.vue
var MdDatepickerDialog = __webpack_require__(184);
var MdDatepickerDialog_default = /*#__PURE__*/__webpack_require__.n(MdDatepickerDialog);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f0a3d52","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdDatepicker/MdDatepickerDialog.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-popover",
    { attrs: { "md-settings": _vm.popperSettings, "md-active": "" } },
    [
      _c(
        "transition",
        { attrs: { name: "md-datepicker-dialog", appear: "" } },
        [
          _c(
            "div",
            {
              staticClass: "md-datepicker-dialog",
              class: [_vm.$mdActiveTheme]
            },
            [
              _c("div", { staticClass: "md-datepicker-header" }, [
                _c(
                  "span",
                  {
                    staticClass: "md-datepicker-year-select",
                    class: { "md-selected": _vm.currentView === "year" },
                    on: {
                      click: function($event) {
                        _vm.currentView = "year"
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.selectedYear))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "md-datepicker-date-select",
                    class: { "md-selected": _vm.currentView !== "year" },
                    on: {
                      click: function($event) {
                        _vm.currentView = "day"
                      }
                    }
                  },
                  [
                    _c("strong", { staticClass: "md-datepicker-dayname" }, [
                      _vm._v(_vm._s(_vm.shortDayName) + ", ")
                    ]),
                    _vm._v(" "),
                    _c("strong", { staticClass: "md-datepicker-monthname" }, [
                      _vm._v(_vm._s(_vm.shortMonthName))
                    ]),
                    _vm._v(" "),
                    _c("strong", { staticClass: "md-datepicker-day" }, [
                      _vm._v(_vm._s(_vm.currentDay))
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "md-datepicker-body" },
                [
                  _c(
                    "transition",
                    { attrs: { name: "md-datepicker-body-header" } },
                    [
                      _vm.currentView === "day"
                        ? _c(
                            "div",
                            { staticClass: "md-datepicker-body-header" },
                            [
                              _c(
                                "md-button",
                                {
                                  staticClass: "md-dense md-icon-button",
                                  on: { click: _vm.previousMonth }
                                },
                                [_c("md-arrow-left-icon")],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "md-button",
                                {
                                  staticClass: "md-dense md-icon-button",
                                  on: { click: _vm.nextMonth }
                                },
                                [_c("md-arrow-right-icon")],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "md-datepicker-body-content",
                      style: _vm.contentStyles
                    },
                    [
                      _c(
                        "transition",
                        { attrs: { name: "md-datepicker-view" } },
                        [
                          _vm.currentView === "day"
                            ? _c(
                                "transition-group",
                                {
                                  staticClass:
                                    "md-datepicker-panel md-datepicker-calendar",
                                  class: _vm.calendarClasses,
                                  attrs: {
                                    tag: "div",
                                    name: "md-datepicker-month"
                                  }
                                },
                                _vm._l([_vm.currentDate], function(
                                  month,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: month.getMonth(),
                                      staticClass:
                                        "md-datepicker-panel md-datepicker-month"
                                    },
                                    [
                                      _c(
                                        "md-button",
                                        {
                                          staticClass:
                                            "md-dense md-datepicker-month-trigger",
                                          on: {
                                            click: function($event) {
                                              _vm.currentView = "month"
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.currentMonthName) +
                                              " " +
                                              _vm._s(_vm.currentYear)
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "md-datepicker-week" },
                                        _vm._l(_vm.locale.shorterDays, function(
                                          day,
                                          index
                                        ) {
                                          return _c("span", { key: index }, [
                                            _vm._v(_vm._s(day))
                                          ])
                                        })
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "md-datepicker-days" },
                                        [
                                          _vm._l(_vm.firstDayOfMonth, function(
                                            day
                                          ) {
                                            return _c("span", {
                                              key: day,
                                              staticClass: "md-datepicker-empty"
                                            })
                                          }),
                                          _vm._v(" "),
                                          _vm._l(_vm.daysInMonth, function(
                                            day
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: day,
                                                staticClass: "md-datepicker-day"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "md-datepicker-day-button",
                                                    class: {
                                                      "md-datepicker-selected": _vm.isSelectedDay(
                                                        day
                                                      ),
                                                      "md-datepicker-today": _vm.isToday(
                                                        day
                                                      ),
                                                      "md-datepicker-disabled": _vm.isDisabled(
                                                        day
                                                      )
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.selectDate(day)
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(day))]
                                                )
                                              ]
                                            )
                                          })
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                })
                              )
                            : _vm.currentView === "month"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "md-datepicker-panel md-datepicker-month-selector"
                                  },
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "md-datepicker-year-trigger",
                                        on: {
                                          click: function($event) {
                                            _vm.currentView = "year"
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.currentYear))]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.locale.months, function(
                                      month,
                                      index
                                    ) {
                                      return _c(
                                        "span",
                                        {
                                          key: month,
                                          staticClass:
                                            "md-datepicker-month-button",
                                          class: {
                                            "md-datepicker-selected":
                                              _vm.currentMonthName === month
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.switchMonth(index)
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(month))]
                                      )
                                    })
                                  ],
                                  2
                                )
                              : _vm.currentView === "year"
                                ? _c(
                                    "keep-alive",
                                    [
                                      _c(
                                        "md-content",
                                        {
                                          staticClass:
                                            "md-datepicker-panel md-datepicker-year-selector md-scrollbar"
                                        },
                                        _vm._l(_vm.availableYears, function(
                                          year
                                        ) {
                                          return _c(
                                            "span",
                                            {
                                              key: year,
                                              staticClass:
                                                "md-datepicker-year-button",
                                              class: {
                                                "md-datepicker-selected":
                                                  _vm.currentYear === year
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.switchYear(year)
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(year))]
                                          )
                                        })
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-dialog-actions",
                    { staticClass: "md-datepicker-body-footer" },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-primary",
                          on: { click: _vm.onCancel }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "md-button",
                        {
                          staticClass: "md-primary",
                          on: { click: _vm.onConfirm }
                        },
                        [_vm._v("Ok")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdDatepicker_MdDatepickerDialog = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f0a3d52", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdDatepicker/MdDatepickerDialog.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(183)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdDatepickerDialog_default.a,
  MdDatepicker_MdDatepickerDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdDatepicker/MdDatepickerDialog.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4f0a3d52", Component.options)
  } else {
    hotAPI.reload("data-v-4f0a3d52", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdDatepicker_MdDatepickerDialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _add_months = __webpack_require__(39);

var _add_months2 = _interopRequireDefault(_add_months);

var _start_of_month = __webpack_require__(185);

var _start_of_month2 = _interopRequireDefault(_start_of_month);

var _sub_months = __webpack_require__(186);

var _sub_months2 = _interopRequireDefault(_sub_months);

var _get_date = __webpack_require__(187);

var _get_date2 = _interopRequireDefault(_get_date);

var _get_day = __webpack_require__(188);

var _get_day2 = _interopRequireDefault(_get_day);

var _get_days_in_month = __webpack_require__(24);

var _get_days_in_month2 = _interopRequireDefault(_get_days_in_month);

var _get_month = __webpack_require__(189);

var _get_month2 = _interopRequireDefault(_get_month);

var _get_year = __webpack_require__(190);

var _get_year2 = _interopRequireDefault(_get_year);

var _is_equal = __webpack_require__(191);

var _is_equal2 = _interopRequireDefault(_is_equal);

var _is_same_day = __webpack_require__(192);

var _is_same_day2 = _interopRequireDefault(_is_same_day);

var _is_today = __webpack_require__(193);

var _is_today2 = _interopRequireDefault(_is_today);

var _set_date = __webpack_require__(194);

var _set_date2 = _interopRequireDefault(_set_date);

var _set_month = __webpack_require__(195);

var _set_month2 = _interopRequireDefault(_set_month);

var _set_year = __webpack_require__(196);

var _set_year2 = _interopRequireDefault(_set_year);

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdPopover = __webpack_require__(25);

var _MdPopover2 = _interopRequireDefault(_MdPopover);

var _MdArrowRightIcon = __webpack_require__(200);

var _MdArrowRightIcon2 = _interopRequireDefault(_MdArrowRightIcon);

var _MdArrowLeftIcon = __webpack_require__(202);

var _MdArrowLeftIcon2 = _interopRequireDefault(_MdArrowLeftIcon);

var _MdDialog = __webpack_require__(10);

var _MdDialog2 = _interopRequireDefault(_MdDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var getElements = function getElements(el, selector) {
  if (el && el.querySelector) {
    return el.querySelectorAll(selector);
  }

  return false;
};

exports.default = new _MdComponent2.default({
  name: 'MdDatepickerDialog',
  components: {
    MdPopover: _MdPopover2.default,
    MdArrowRightIcon: _MdArrowRightIcon2.default,
    MdArrowLeftIcon: _MdArrowLeftIcon2.default,
    MdDialog: _MdDialog2.default
  },
  props: {
    mdDate: Date,
    mdDisabledDates: [Array, Function]
  },
  data: function data() {
    return {
      currentDate: null,
      selectedDate: null,
      showDialog: false,
      monthAction: null,
      currentView: 'day',
      contentStyles: {},
      availableYears: null
    };
  },
  computed: {
    locale: function locale() {
      return this.$material.locale;
    },
    popperSettings: function popperSettings() {
      return {
        placement: 'bottom-start',
        modifiers: {
          keepTogether: {
            enabled: true
          },
          flip: {
            enabled: false
          }
        }
      };
    },
    calendarClasses: function calendarClasses() {
      if (this.monthAction === 'next') {
        return 'md-next';
      }

      return 'md-previous';
    },
    firstDayOfMonth: function firstDayOfMonth() {
      return (0, _start_of_month2.default)(this.currentDate).getDay();
    },
    daysInMonth: function daysInMonth() {
      return (0, _get_days_in_month2.default)(this.currentDate);
    },
    currentDay: function currentDay() {
      if (this.selectedDate) {
        return (0, _get_date2.default)(this.selectedDate);
      }

      return (0, _get_date2.default)(this.currentDate);
    },
    currentMonth: function currentMonth() {
      return (0, _get_month2.default)(this.currentDate);
    },
    currentMonthName: function currentMonthName() {
      return this.locale.months[this.currentMonth];
    },
    currentYear: function currentYear() {
      return (0, _get_year2.default)(this.currentDate);
    },
    selectedYear: function selectedYear() {
      if (this.selectedDate) {
        return (0, _get_year2.default)(this.selectedDate);
      }

      return (0, _get_year2.default)(this.currentDate);
    },
    shortDayName: function shortDayName() {
      if (this.selectedDate) {
        return this.locale.shortDays[(0, _get_day2.default)(this.selectedDate)];
      }

      return this.locale.shortDays[(0, _get_day2.default)(this.currentDate)];
    },
    shortMonthName: function shortMonthName() {
      if (this.selectedDate) {
        return this.locale.shortMonths[(0, _get_month2.default)(this.selectedDate)];
      }

      return this.locale.shortMonths[(0, _get_month2.default)(this.currentDate)];
    }
  },
  watch: {
    mdDate: function mdDate() {
      this.currentDate = this.mdDate || new Date();
      this.selectedDate = this.mdDate;
    },
    currentDate: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(next, previous) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$nextTick();

              case 2:

                if (previous) {
                  this.setContentStyles();
                }

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function currentDate(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return currentDate;
    }(),
    currentView: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var activeYear;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$nextTick();

              case 2:

                if (this.currentView === 'year') {
                  activeYear = getElements(this.$el, '.md-datepicker-year-button.md-datepicker-selected');


                  if (activeYear.length) {
                    activeYear[0].scrollIntoView({
                      behavior: 'instant',
                      block: 'center',
                      inline: 'center'
                    });
                  }
                }

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function currentView() {
        return _ref2.apply(this, arguments);
      }

      return currentView;
    }()
  },
  methods: {
    setContentStyles: function setContentStyles() {
      var months = getElements(this.$el, '.md-datepicker-month');

      if (months.length) {
        var nextMonth = months[months.length - 1];

        this.contentStyles = {
          height: nextMonth.offsetHeight + 10 + 'px'
        };
      }
    },
    setAvailableYears: function setAvailableYears() {
      var _locale = this.locale,
          startYear = _locale.startYear,
          endYear = _locale.endYear;

      var counter = startYear;
      var years = [];

      while (counter <= endYear) {
        years.push(counter++);
      }

      this.availableYears = years;
    },
    handleDisabledDateByArray: function handleDisabledDateByArray(date) {
      return this.mdDisabledDates.some(function (disabledDate) {
        return (0, _is_same_day2.default)(disabledDate, date);
      });
    },
    isDisabled: function isDisabled(day) {
      if (this.mdDisabledDates) {
        var targetDate = (0, _set_date2.default)(this.currentDate, day);

        if (Array.isArray(this.mdDisabledDates)) {
          return this.handleDisabledDateByArray(targetDate);
        } else if (typeof this.mdDisabledDates === 'function') {
          return this.mdDisabledDates(targetDate);
        }
      }
    },
    isSelectedDay: function isSelectedDay(day) {
      return (0, _is_equal2.default)(this.selectedDate, (0, _set_date2.default)(this.currentDate, day));
    },
    isToday: function isToday(day) {
      return (0, _is_today2.default)((0, _set_date2.default)(this.currentDate, day));
    },
    previousMonth: function previousMonth() {
      this.monthAction = 'previous';
      this.currentDate = (0, _sub_months2.default)(this.currentDate, 1);
    },
    nextMonth: function nextMonth() {
      this.monthAction = 'next';
      this.currentDate = (0, _add_months2.default)(this.currentDate, 1);
    },
    switchMonth: function switchMonth(index) {
      this.currentDate = (0, _set_month2.default)(this.currentDate, index);
      this.currentView = 'day';
    },
    switchYear: function switchYear(year) {
      this.currentDate = (0, _set_year2.default)(this.currentDate, year);
      this.currentView = 'month';
    },
    selectDate: function selectDate(day) {
      this.currentDate = (0, _set_date2.default)(this.currentDate, day);
      this.selectedDate = this.currentDate;
    },
    closeDialog: function closeDialog() {
      this.$emit('md-closed');
    },
    onClose: function onClose() {
      this.closeDialog();
    },
    onCancel: function onCancel() {
      this.closeDialog();
    },
    onConfirm: function onConfirm() {
      this.closeDialog();
      this.$emit('update:mdDate', this.selectedDate);
    }
  },
  created: function created() {
    var _this = this;

    this.setAvailableYears();
    this.currentDate = this.mdDate || new Date();
    this.selectedDate = this.mdDate;
    this.currentView = 'day';

    window.setTimeout(function () {
      _this.setContentStyles();
    }, 50);
  }
});

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  date.setDate(1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfMonth


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(39)

/**
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted
 * @returns {Date} the new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * var result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, -amount)
}

module.exports = subMonths


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * var result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate (dirtyDate) {
  var date = parse(dirtyDate)
  var dayOfMonth = date.getDate()
  return dayOfMonth
}

module.exports = getDate


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of week
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * var result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day
}

module.exports = getDay


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the month
 *
 * @example
 * // Which month is 29 February 2012?
 * var result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  return month
}

module.exports = getMonth


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the year
 *
 * @example
 * // Which year is 2 July 2014?
 * var result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year
}

module.exports = getYear


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual (dirtyLeftDate, dirtyRightDate) {
  var dateLeft = parse(dirtyLeftDate)
  var dateRight = parse(dirtyRightDate)
  return dateLeft.getTime() === dateRight.getTime()
}

module.exports = isEqual


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(21)

/**
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 18, 0)
 * )
 * //=> true
 */
function isSameDay (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
  var dateRightStartOfDay = startOfDay(dirtyDateRight)

  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
}

module.exports = isSameDay


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(21)

/**
 * @category Day Helpers
 * @summary Is the given date today?
 *
 * @description
 * Is the given date today?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday (dirtyDate) {
  return startOfDay(dirtyDate).getTime() === startOfDay(new Date()).getTime()
}

module.exports = isToday


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month setted
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * var result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */
function setDate (dirtyDate, dirtyDayOfMonth) {
  var date = parse(dirtyDate)
  var dayOfMonth = Number(dirtyDayOfMonth)
  date.setDate(dayOfMonth)
  return date
}

module.exports = setDate


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var getDaysInMonth = __webpack_require__(24)

/**
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month setted
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth (dirtyDate, dirtyMonth) {
  var date = parse(dirtyDate)
  var month = Number(dirtyMonth)
  var year = date.getFullYear()
  var day = date.getDate()

  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(year, month, 15)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth))
  return date
}

module.exports = setMonth


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year setted
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * var result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear (dirtyDate, dirtyYear) {
  var date = parse(dirtyDate)
  var year = Number(dirtyYear)
  date.setFullYear(year)
  return date
}

module.exports = setYear


/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _popper = __webpack_require__(199);

var _popper2 = _interopRequireDefault(_popper);

var _deepmerge = __webpack_require__(30);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _MdPortal = __webpack_require__(16);

var _MdPortal2 = _interopRequireDefault(_MdPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: 'MdPopover',
  abstract: true,
  components: {
    MdPortal: _MdPortal2.default
  },
  props: {
    mdActive: Boolean,
    mdSettings: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      popperInstance: null,
      originalParentEl: null,
      shouldRender: false,
      shouldActivate: false
    };
  },
  computed: {
    popoverClasses: function popoverClasses() {
      if (this.shouldActivate) {
        return 'md-active';
      } else if (this.shouldRender) {
        return 'md-rendering';
      }
    }
  },
  watch: {
    mdActive: {
      immediate: true,
      handler: function handler(shouldRender) {
        this.shouldRender = shouldRender;

        if (shouldRender) {
          this.bindPopper();
        } else {
          this.shouldActivate = false;
        }
      }
    },
    mdSettings: function mdSettings() {
      if (this.popperInstance) {
        this.createPopper();
      }
    }
  },
  methods: {
    getPopperOptions: function getPopperOptions() {
      var _this = this;

      return {
        placement: 'bottom',
        modifiers: {
          preventOverflow: {
            boundariesElement: 'viewport',
            padding: 16
          },
          computeStyle: {
            gpuAcceleration: false
          }
        },
        onCreate: function onCreate() {
          _this.shouldActivate = true;
          _this.$emit('md-active');
        }
      };
    },
    setOriginalParent: function setOriginalParent(el) {
      if (!this.originalParentEl) {
        this.originalParentEl = el;
      }
    },
    killPopper: function killPopper() {
      if (this.popperInstance) {
        this.popperInstance.destroy();
        this.popperInstance = null;
      }
    },
    bindPopper: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$nextTick();

              case 2:

                if (this.originalParentEl) {
                  this.createPopper();
                }

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function bindPopper() {
        return _ref.apply(this, arguments);
      }

      return bindPopper;
    }(),
    createPopper: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var options;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.mdSettings) {
                  options = (0, _deepmerge2.default)(this.getPopperOptions(), this.mdSettings);


                  if (this.$el.constructor.name.toLowerCase() !== 'comment') {
                    this.popperInstance = new _popper2.default(this.originalParentEl, this.$el, options);
                  }
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createPopper() {
        return _ref2.apply(this, arguments);
      }

      return createPopper;
    }(),
    resetPopper: function resetPopper() {
      if (this.popperInstance) {
        this.killPopper();
        this.createPopper();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.killPopper();
  },
  mounted: function mounted() {
    this.resetPopper();
  },
  render: function render(createElement) {
    return createElement(_MdPortal2.default, {
      props: _extends({}, this.$attrs),
      on: _extends({}, this.$listeners, {
        'md-initial-parent': this.setOriginalParent,
        'md-destroy': this.killPopper
      })
    }, this.$slots.default);
  }
};

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.12.6
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return window.document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  // NOTE: 1 DOM access here
  var offsetParent = element && element.offsetParent;
  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    if (element) {
      return element.ownerDocument.documentElement;
    }

    return window.document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return window.document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return +styles['border' + sideA + 'Width'].split('px')[0] + +styles['border' + sideB + 'Width'].split('px')[0];
}

/**
 * Tells if you are running Internet Explorer 10
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean} isIE10
 */
var isIE10 = undefined;

var isIE10$1 = function () {
  if (isIE10 === undefined) {
    isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1;
  }
  return isIE10;
};

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE10$1() ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
}

function getWindowSizes() {
  var body = window.document.body;
  var html = window.document.documentElement;
  var computedStyle = isIE10$1() && window.getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  if (isIE10$1()) {
    try {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } catch (err) {}
  } else {
    rect = element.getBoundingClientRect();
  }

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var isIE10 = isIE10$1();
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = +styles.borderTopWidth.split('px')[0];
  var borderLeftWidth = +styles.borderLeftWidth.split('px')[0];

  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = +styles.marginTop.split('px')[0];
    var marginLeft = +styles.marginLeft.split('px')[0];

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = getScroll(html);
  var scrollLeft = getScroll(html, 'left');

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  // NOTE: 1 DOM access here
  var boundaries = { top: 0, left: 0 };
  var offsetParent = findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(popper));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  boundaries.left += padding;
  boundaries.top += padding;
  boundaries.right -= padding;
  boundaries.bottom -= padding;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var commonOffsetParent = findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length - 1; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof window.document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroy the popper
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.left = '';
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger onUpdate callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    window.cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper.
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // floor sides to avoid blurry text
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.floor(popper.top),
    bottom: Math.floor(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    top = -offsetParentRect.height + offsets.bottom;
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    left = -offsetParentRect.width + offsets.right;
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjuction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var popperMarginSide = getStyleComputedProperty(data.instance.popper, 'margin' + sideCapitalized).replace('px', '');
  var sideValue = center - getClientRect(data.offsets.popper)[side] - popperMarginSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = {};
  data.offsets.arrow[side] = Math.round(sideValue);
  data.offsets.arrow[altSide] = ''; // make sure to unset any eventual altSide value from the DOM node

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-right` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement);
  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unitless, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the height.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * An scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper this makes sure the popper has always a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier, can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near eachothers
   * without leaving any gap between the two. Expecially useful when the arrow is
   * enabled and you want to assure it to point to its reference element.
   * It cares only about the first axis, you can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjuction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations).
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position,
     * the popper will never be placed outside of the defined boundaries
     * (except if keepTogether is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define you own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the informations used by Popper.js
 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overriden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass as 3rd argument an object with the same
 * structure of this object, example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Whether events (resize, scroll) are initially enabled
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated, this callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Create a new Popper.js instance
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as popper.
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedule an update, it will run on the next UI update available
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(17)))

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/core/icons/MdArrowRightIcon.vue
var MdArrowRightIcon = __webpack_require__(201);
var MdArrowRightIcon_default = /*#__PURE__*/__webpack_require__.n(MdArrowRightIcon);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e23e1bf","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/core/icons/MdArrowRightIcon.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("md-icon", { staticClass: "md-icon-image" }, [
      _c(
        "svg",
        {
          attrs: {
            height: "24",
            viewBox: "0 0 24 24",
            width: "24",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("path", {
            attrs: { d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" }
          }),
          _vm._v(" "),
          _c("path", { attrs: { d: "M0-.25h24v24H0z", fill: "none" } })
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var icons_MdArrowRightIcon = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e23e1bf", esExports)
  }
}
// CONCATENATED MODULE: ./src/core/icons/MdArrowRightIcon.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdArrowRightIcon_default.a,
  icons_MdArrowRightIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/core/icons/MdArrowRightIcon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1e23e1bf", Component.options)
  } else {
    hotAPI.reload("data-v-1e23e1bf", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var core_icons_MdArrowRightIcon = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdIcon = __webpack_require__(5);

var _MdIcon2 = _interopRequireDefault(_MdIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdArrowRightIcon',
  components: {
    MdIcon: _MdIcon2.default
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/core/icons/MdArrowLeftIcon.vue
var MdArrowLeftIcon = __webpack_require__(203);
var MdArrowLeftIcon_default = /*#__PURE__*/__webpack_require__.n(MdArrowLeftIcon);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cc7b6f4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/core/icons/MdArrowLeftIcon.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("md-icon", { staticClass: "md-icon-image" }, [
      _c(
        "svg",
        {
          attrs: {
            height: "24",
            viewBox: "0 0 24 24",
            width: "24",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("path", {
            attrs: { d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z" }
          }),
          _vm._v(" "),
          _c("path", { attrs: { d: "M0-.5h24v24H0z", fill: "none" } })
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var icons_MdArrowLeftIcon = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cc7b6f4", esExports)
  }
}
// CONCATENATED MODULE: ./src/core/icons/MdArrowLeftIcon.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdArrowLeftIcon_default.a,
  icons_MdArrowLeftIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/core/icons/MdArrowLeftIcon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5cc7b6f4", Component.options)
  } else {
    hotAPI.reload("data-v-5cc7b6f4", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var core_icons_MdArrowLeftIcon = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdIcon = __webpack_require__(5);

var _MdIcon2 = _interopRequireDefault(_MdIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdArrowLeftIcon',
  components: {
    MdIcon: _MdIcon2.default
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdPortal = __webpack_require__(16);

var _MdPortal2 = _interopRequireDefault(_MdPortal);

var _MdOverlay = __webpack_require__(23);

var _MdOverlay2 = _interopRequireDefault(_MdOverlay);

var _MdFocusTrap = __webpack_require__(40);

var _MdFocusTrap2 = _interopRequireDefault(_MdFocusTrap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = new _MdComponent2.default({
  name: 'MdDialog',
  components: {
    MdPortal: _MdPortal2.default,
    MdOverlay: _MdOverlay2.default,
    MdFocusTrap: _MdFocusTrap2.default
  },
  props: {
    mdActive: Boolean,
    mdBackdrop: {
      type: Boolean,
      default: true
    },
    mdBackdropClass: {
      type: String,
      default: 'md-dialog-overlay'
    },
    mdCloseOnEsc: {
      type: Boolean,
      default: true
    },
    mdClickOutsideToClose: {
      type: Boolean,
      default: true
    },
    mdFullscreen: {
      type: Boolean,
      default: true
    },
    mdAnimateFromSource: Boolean
  },
  computed: {
    dialogClasses: function dialogClasses() {
      return {
        'md-dialog-fullscreen': this.mdFullscreen
      };
    }
  },
  watch: {
    mdActive: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(isActive) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$nextTick();

              case 2:

                if (isActive) {
                  this.$emit('md-opened');
                } else {
                  this.$emit('md-closed');
                }

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mdActive(_x) {
        return _ref.apply(this, arguments);
      }

      return mdActive;
    }()
  },
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('update:mdActive', false);
    },
    onClick: function onClick() {
      if (this.mdClickOutsideToClose) {
        this.closeDialog();
      }
    },
    onEsc: function onEsc() {
      if (this.mdCloseOnEsc) {
        this.closeDialog();
      }
    }
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/core/icons/MdDateIcon.vue
var MdDateIcon = __webpack_require__(207);
var MdDateIcon_default = /*#__PURE__*/__webpack_require__.n(MdDateIcon);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-644b79cc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/core/icons/MdDateIcon.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("md-icon", { staticClass: "md-icon-image" }, [
      _c(
        "svg",
        {
          attrs: {
            height: "24",
            viewBox: "0 0 24 24",
            width: "24",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
            }
          }),
          _vm._v(" "),
          _c("path", { attrs: { d: "M0 0h24v24H0z", fill: "none" } })
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var icons_MdDateIcon = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-644b79cc", esExports)
  }
}
// CONCATENATED MODULE: ./src/core/icons/MdDateIcon.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdDateIcon_default.a,
  icons_MdDateIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/core/icons/MdDateIcon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-644b79cc", Component.options)
  } else {
    hotAPI.reload("data-v-644b79cc", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var core_icons_MdDateIcon = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdIcon = __webpack_require__(5);

var _MdIcon2 = _interopRequireDefault(_MdIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdDateIcon',
  components: {
    MdIcon: _MdIcon2.default
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdDialog = __webpack_require__(10);

var _MdDialog2 = _interopRequireDefault(_MdDialog);

var _MdDialogTitle = __webpack_require__(209);

var _MdDialogTitle2 = _interopRequireDefault(_MdDialogTitle);

var _MdDialogContent = __webpack_require__(212);

var _MdDialogContent2 = _interopRequireDefault(_MdDialogContent);

var _MdDialogActions = __webpack_require__(215);

var _MdDialogActions2 = _interopRequireDefault(_MdDialogActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdDialog2.default.name, _MdDialog2.default);
  Vue.component(_MdDialogTitle2.default.name, _MdDialogTitle2.default);
  Vue.component(_MdDialogContent2.default.name, _MdDialogContent2.default);
  Vue.component(_MdDialogActions2.default.name, _MdDialogActions2.default);
};

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdDialog/MdDialogTitle.vue
var MdDialogTitle = __webpack_require__(211);
var MdDialogTitle_default = /*#__PURE__*/__webpack_require__.n(MdDialogTitle);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-879275ce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdDialog/MdDialogTitle.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "md-dialog-title md-title" },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdDialog_MdDialogTitle = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-879275ce", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdDialog/MdDialogTitle.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(210)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdDialogTitle_default.a,
  MdDialog_MdDialogTitle,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdDialog/MdDialogTitle.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-879275ce", Component.options)
  } else {
    hotAPI.reload("data-v-879275ce", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdDialog_MdDialogTitle = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'MdDialogTitle'
};

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdDialog/MdDialogContent.vue
var MdDialogContent = __webpack_require__(214);
var MdDialogContent_default = /*#__PURE__*/__webpack_require__.n(MdDialogContent);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dae90f0c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdDialog/MdDialogContent.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "md-dialog-content" }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdDialog_MdDialogContent = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dae90f0c", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdDialog/MdDialogContent.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(213)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdDialogContent_default.a,
  MdDialog_MdDialogContent,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdDialog/MdDialogContent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-dae90f0c", Component.options)
  } else {
    hotAPI.reload("data-v-dae90f0c", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdDialog_MdDialogContent = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'MdDialogContent'
};

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdDialog/MdDialogActions.vue
var MdDialogActions = __webpack_require__(217);
var MdDialogActions_default = /*#__PURE__*/__webpack_require__.n(MdDialogActions);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-092eaafe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdDialog/MdDialogActions.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "md-dialog-actions" }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdDialog_MdDialogActions = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-092eaafe", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdDialog/MdDialogActions.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(216)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdDialogActions_default.a,
  MdDialog_MdDialogActions,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdDialog/MdDialogActions.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-092eaafe", Component.options)
  } else {
    hotAPI.reload("data-v-092eaafe", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdDialog_MdDialogActions = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'MdDialogActions'
};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdDialog = __webpack_require__(10);

var _MdDialog2 = _interopRequireDefault(_MdDialog);

var _MdDialogAlert = __webpack_require__(219);

var _MdDialogAlert2 = _interopRequireDefault(_MdDialogAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdDialog2.default.name, _MdDialog2.default);
  Vue.component(_MdDialogAlert2.default.name, _MdDialogAlert2.default);
};

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdDialog/MdDialogAlert/MdDialogAlert.vue
var MdDialogAlert = __webpack_require__(220);
var MdDialogAlert_default = /*#__PURE__*/__webpack_require__.n(MdDialogAlert);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-197ab94b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdDialog/MdDialogAlert/MdDialogAlert.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    _vm._g(
      _vm._b(
        { attrs: { "md-fullscreen": false } },
        "md-dialog",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.mdTitle
        ? _c("md-dialog-title", [_vm._v(_vm._s(_vm.mdTitle))])
        : _vm._e(),
      _vm._v(" "),
      _vm.mdContent
        ? _c("md-dialog-content", {
            domProps: { innerHTML: _vm._s(_vm.mdContent) }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "md-dialog-actions",
        [
          _c(
            "md-button",
            {
              staticClass: "md-primary",
              on: {
                click: function($event) {
                  _vm.$emit("update:mdActive", false)
                }
              }
            },
            [_vm._v(_vm._s(_vm.mdConfirmText))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdDialogAlert_MdDialogAlert = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-197ab94b", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdDialog/MdDialogAlert/MdDialogAlert.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdDialogAlert_default.a,
  MdDialogAlert_MdDialogAlert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdDialog/MdDialogAlert/MdDialogAlert.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-197ab94b", Component.options)
  } else {
    hotAPI.reload("data-v-197ab94b", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdDialog_MdDialogAlert_MdDialogAlert = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'MdDialogAlert',
  props: {
    mdTitle: String,
    mdContent: String,
    mdConfirmText: {
      type: String,
      default: 'Ok'
    }
  }
};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdDialog = __webpack_require__(10);

var _MdDialog2 = _interopRequireDefault(_MdDialog);

var _MdDialogConfirm = __webpack_require__(222);

var _MdDialogConfirm2 = _interopRequireDefault(_MdDialogConfirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdDialog2.default.name, _MdDialog2.default);
  Vue.component(_MdDialogConfirm2.default.name, _MdDialogConfirm2.default);
};

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdDialog/MdDialogConfirm/MdDialogConfirm.vue
var MdDialogConfirm = __webpack_require__(223);
var MdDialogConfirm_default = /*#__PURE__*/__webpack_require__.n(MdDialogConfirm);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acc7afda","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdDialog/MdDialogConfirm/MdDialogConfirm.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    _vm._g(
      _vm._b(
        { attrs: { "md-fullscreen": false } },
        "md-dialog",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.mdTitle
        ? _c("md-dialog-title", [_vm._v(_vm._s(_vm.mdTitle))])
        : _vm._e(),
      _vm._v(" "),
      _vm.mdContent
        ? _c("md-dialog-content", {
            domProps: { innerHTML: _vm._s(_vm.mdContent) }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "md-dialog-actions",
        [
          _c(
            "md-button",
            { staticClass: "md-primary", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.mdCancelText))]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            { staticClass: "md-primary", on: { click: _vm.onConfirm } },
            [_vm._v(_vm._s(_vm.mdConfirmText))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdDialogConfirm_MdDialogConfirm = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-acc7afda", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdDialog/MdDialogConfirm/MdDialogConfirm.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdDialogConfirm_default.a,
  MdDialogConfirm_MdDialogConfirm,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdDialog/MdDialogConfirm/MdDialogConfirm.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-acc7afda", Component.options)
  } else {
    hotAPI.reload("data-v-acc7afda", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdDialog_MdDialogConfirm_MdDialogConfirm = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'MdDialogConfirm',
  props: {
    mdTitle: String,
    mdContent: String,
    mdConfirmText: {
      type: String,
      default: 'Ok'
    },
    mdCancelText: {
      type: String,
      default: 'Cancel'
    }
  },
  methods: {
    onCancel: function onCancel() {
      this.$emit('md-cancel');
      this.$emit('update:mdActive', false);
    },
    onConfirm: function onConfirm() {
      this.$emit('md-confirm');
      this.$emit('update:mdActive', false);
    }
  }
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdDialog = __webpack_require__(10);

var _MdDialog2 = _interopRequireDefault(_MdDialog);

var _MdDialogPrompt = __webpack_require__(225);

var _MdDialogPrompt2 = _interopRequireDefault(_MdDialogPrompt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdDialog2.default.name, _MdDialog2.default);
  Vue.component(_MdDialogPrompt2.default.name, _MdDialogPrompt2.default);
};

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdDialog/MdDialogPrompt/MdDialogPrompt.vue
var MdDialogPrompt = __webpack_require__(226);
var MdDialogPrompt_default = /*#__PURE__*/__webpack_require__.n(MdDialogPrompt);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b3c8c22","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdDialog/MdDialogPrompt/MdDialogPrompt.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    _vm._b(
      {
        attrs: { "md-fullscreen": false },
        on: { "md-opened": _vm.setInputFocus }
      },
      "md-dialog",
      _vm.$attrs,
      false
    ),
    [
      _vm.mdTitle
        ? _c("md-dialog-title", [_vm._v(_vm._s(_vm.mdTitle))])
        : _vm._e(),
      _vm._v(" "),
      _vm.mdContent
        ? _c("md-dialog-content", {
            domProps: { innerHTML: _vm._s(_vm.mdContent) }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "md-dialog-content",
        [
          _c(
            "md-field",
            [
              _c("md-input", {
                ref: "input",
                attrs: {
                  id: _vm.mdInputId,
                  name: _vm.mdInputName,
                  maxlength: _vm.mdInputMaxlength,
                  placeholder: _vm.mdInputPlaceholder
                },
                nativeOn: {
                  keydown: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key)
                    ) {
                      return null
                    }
                    _vm.onConfirm($event)
                  }
                },
                model: {
                  value: _vm.inputValue,
                  callback: function($$v) {
                    _vm.inputValue = $$v
                  },
                  expression: "inputValue"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-dialog-actions",
        [
          _c(
            "md-button",
            { staticClass: "md-primary", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.mdCancelText))]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            { staticClass: "md-primary", on: { click: _vm.onConfirm } },
            [_vm._v(_vm._s(_vm.mdConfirmText))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdDialogPrompt_MdDialogPrompt = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b3c8c22", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdDialog/MdDialogPrompt/MdDialogPrompt.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdDialogPrompt_default.a,
  MdDialogPrompt_MdDialogPrompt,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdDialog/MdDialogPrompt/MdDialogPrompt.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7b3c8c22", Component.options)
  } else {
    hotAPI.reload("data-v-7b3c8c22", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdDialog_MdDialogPrompt_MdDialogPrompt = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'MdDialogPrompt',
  props: {
    value: {},
    mdTitle: String,
    mdInputName: String,
    mdInputId: String,
    mdInputMaxlength: [String, Number],
    mdInputPlaceholder: [String, Number],
    mdContent: String,
    mdConfirmText: {
      type: String,
      default: 'Ok'
    },
    mdCancelText: {
      type: String,
      default: 'Cancel'
    }
  },
  data: function data() {
    return {
      inputValue: null
    };
  },
  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },
  methods: {
    onCancel: function onCancel() {
      this.$emit('md-cancel');
      this.$emit('update:mdActive', false);
    },
    onConfirm: function onConfirm() {
      this.$emit('input', this.inputValue);
      this.$emit('md-confirm', this.inputValue);
      this.$emit('update:mdActive', false);
    },
    setInputFocus: function setInputFocus() {
      var _this = this;

      window.setTimeout(function () {
        _this.$refs.input.$el.focus();
      }, 50);
    }
  },
  created: function created() {
    this.inputValue = this.value;
  }
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdDivider = __webpack_require__(228);

var _MdDivider2 = _interopRequireDefault(_MdDivider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdDivider2.default.name, _MdDivider2.default);
};

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdDivider/MdDivider.vue
var MdDivider = __webpack_require__(230);
var MdDivider_default = /*#__PURE__*/__webpack_require__.n(MdDivider);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ca7ced6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdDivider/MdDivider.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.insideList
    ? _c("li", { staticClass: "md-divider", class: [_vm.$mdActiveTheme] })
    : _c("hr", { staticClass: "md-divider", class: [_vm.$mdActiveTheme] })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdDivider_MdDivider = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ca7ced6", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdDivider/MdDivider.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(229)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdDivider_default.a,
  MdDivider_MdDivider,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdDivider/MdDivider.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8ca7ced6", Component.options)
  } else {
    hotAPI.reload("data-v-8ca7ced6", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdDivider_MdDivider = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdDivider',
  computed: {
    insideList: function insideList() {
      return this.$parent.$options._componentTag === 'md-list';
    }
  }
}); //
//
//
//
//

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdDrawer = __webpack_require__(232);

var _MdDrawer2 = _interopRequireDefault(_MdDrawer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdDrawer2.default.name, _MdDrawer2.default);
};

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdDrawer/MdDrawer.vue
var MdDrawer = __webpack_require__(234);
var MdDrawer_default = /*#__PURE__*/__webpack_require__.n(MdDrawer);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-801caa62","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdDrawer/MdDrawer.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "md-drawer",
      class: [_vm.$mdActiveTheme, _vm.drawerClasses]
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.mdFixed
        ? _c("md-overlay", {
            attrs: { "md-active": _vm.mdActive },
            on: { click: _vm.closeDrawer }
          })
        : _c("md-overlay", {
            attrs: { "md-active": _vm.mdActive, "md-attach-to-parent": "" },
            on: { click: _vm.closeDrawer }
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdDrawer_MdDrawer = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-801caa62", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdDrawer/MdDrawer.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(233)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdDrawer_default.a,
  MdDrawer_MdDrawer,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdDrawer/MdDrawer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-801caa62", Component.options)
  } else {
    hotAPI.reload("data-v-801caa62", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdDrawer_MdDrawer = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdOverlay = __webpack_require__(23);

var _MdOverlay2 = _interopRequireDefault(_MdOverlay);

var _MdPropValidator = __webpack_require__(4);

var _MdPropValidator2 = _interopRequireDefault(_MdPropValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdDrawer',
  components: {
    MdOverlay: _MdOverlay2.default
  },
  props: {
    mdLeft: Boolean,
    mdRight: Boolean,
    mdPermanent: _extends({
      type: String
    }, (0, _MdPropValidator2.default)('md-permanent', ['full', 'clipped', 'card'])),
    mdPersistent: _extends({
      type: String
    }, (0, _MdPropValidator2.default)('md-persistent', ['mini', 'full'])),
    mdActive: Boolean,
    mdFixed: Boolean
  },
  watch: {
    mdActive: function mdActive(visible) {
      if (visible) {
        this.$emit('md-opened');
      } else {
        this.$emit('md-closed');
      }
    }
  },
  computed: {
    drawerClasses: function drawerClasses() {
      var classes = {
        'md-left': this.mdLeft,
        'md-right': this.mdRight,
        'md-temporary': this.isTemporary,
        'md-persistent': this.mdPersistent,
        'md-permanent': this.mdPermanent,
        'md-active': this.mdActive,
        'md-fixed': this.mdFixed
      };

      if (this.mdPermanent) {
        classes['md-permanent-' + this.mdPermanent] = true;
      }

      if (this.mdPersistent) {
        classes['md-persistent-' + this.mdPersistent] = true;
      }

      return classes;
    },
    isTemporary: function isTemporary() {
      return !this.mdPermanent && !this.mdPersistent;
    },
    mode: function mode() {
      if (this.mdPersistent) {
        return 'persistent';
      }

      if (this.mdPermanent) {
        return 'permanent';
      }

      return 'temporary';
    },
    submode: function submode() {
      if (this.mdPersistent) {
        return this.mdPersistent;
      }

      if (this.mdPermanent) {
        return this.mdPermanent;
      }
    }
  },
  methods: {
    closeDrawer: function closeDrawer() {
      this.$emit('update:mdActive', false);
    }
  }
});

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(236);

exports.default = function (Vue) {};

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdEmptyState = __webpack_require__(41);

var _MdEmptyState2 = _interopRequireDefault(_MdEmptyState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdEmptyState2.default.name, _MdEmptyState2.default);
};

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdEmptyStateProps = __webpack_require__(42);

var _MdEmptyStateProps2 = _interopRequireDefault(_MdEmptyStateProps);

var _MdAssetIcon = __webpack_require__(18);

var _MdAssetIcon2 = _interopRequireDefault(_MdAssetIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdEmptyState',
  mixins: [_MdAssetIcon2.default],
  props: _MdEmptyStateProps2.default,
  computed: {
    emptyStateClasses: function emptyStateClasses() {
      return {
        'md-rounded': this.mdRounded
      };
    },
    emptyStateStyles: function emptyStateStyles() {
      if (this.mdRounded) {
        var size = this.mdSize + 'px';

        return {
          width: size,
          height: size
        };
      }
    }
  }
}); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdIcon = __webpack_require__(43);

var _MdIcon2 = _interopRequireDefault(_MdIcon);

var _MdSelect = __webpack_require__(241);

var _MdSelect2 = _interopRequireDefault(_MdSelect);

var _MdField = __webpack_require__(20);

var _MdField2 = _interopRequireDefault(_MdField);

var _MdFile = __webpack_require__(260);

var _MdFile2 = _interopRequireDefault(_MdFile);

var _MdInput = __webpack_require__(14);

var _MdInput2 = _interopRequireDefault(_MdInput);

var _MdTextarea = __webpack_require__(265);

var _MdTextarea2 = _interopRequireDefault(_MdTextarea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.use(_MdIcon2.default);
  Vue.use(_MdSelect2.default);
  Vue.component(_MdField2.default.name, _MdField2.default);
  Vue.component(_MdFile2.default.name, _MdFile2.default);
  Vue.component(_MdInput2.default.name, _MdInput2.default);
  Vue.component(_MdTextarea2.default.name, _MdTextarea2.default);
};

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdSelect = __webpack_require__(242);

var _MdSelect2 = _interopRequireDefault(_MdSelect);

var _MdOption = __webpack_require__(254);

var _MdOption2 = _interopRequireDefault(_MdOption);

var _MdOptgroup = __webpack_require__(257);

var _MdOptgroup2 = _interopRequireDefault(_MdOptgroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdSelect2.default.name, _MdSelect2.default);
  Vue.component(_MdOption2.default.name, _MdOption2.default);
  Vue.component(_MdOptgroup2.default.name, _MdOptgroup2.default);
};

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdField/MdSelect/MdSelect.vue
var MdSelect = __webpack_require__(244);
var MdSelect_default = /*#__PURE__*/__webpack_require__.n(MdSelect);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e35dfa3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdField/MdSelect/MdSelect.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-menu",
    {
      staticClass: "md-select",
      class: { "md-disabled": _vm.disabled },
      attrs: {
        "md-close-on-select": false,
        "md-active": _vm.showSelect,
        "md-offset-x": _vm.offset.x,
        "md-offset-y": _vm.offset.y
      },
      on: {
        "update:mdActive": function($event) {
          _vm.showSelect = $event
        },
        "md-opened": _vm.onOpen,
        "md-closed": _vm.onClose
      }
    },
    [
      _c(
        "md-input",
        _vm._g(
          _vm._b(
            {
              ref: "input",
              staticClass: "md-input md-select-value",
              attrs: {
                readonly: "",
                disabled: _vm.disabled,
                required: _vm.required,
                placeholder: _vm.placeholder
              },
              on: {
                focus: function($event) {
                  $event.preventDefault()
                  _vm.onFocus($event)
                },
                blur: function($event) {
                  $event.preventDefault()
                  _vm.removeHighlight($event)
                },
                click: _vm.openSelect,
                keydown: [
                  function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "down", 40, $event.key)
                    ) {
                      return null
                    }
                    _vm.openSelect($event)
                  },
                  function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key)
                    ) {
                      return null
                    }
                    _vm.openSelect($event)
                  },
                  function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "space", 32, $event.key)
                    ) {
                      return null
                    }
                    _vm.openSelect($event)
                  }
                ]
              },
              model: {
                value: _vm.MdSelect.label,
                callback: function($$v) {
                  _vm.$set(_vm.MdSelect, "label", $$v)
                },
                expression: "MdSelect.label"
              }
            },
            "md-input",
            _vm.$attrs,
            false
          ),
          _vm.inputListeners
        )
      ),
      _vm._v(" "),
      _c("md-drop-down-icon", {
        nativeOn: {
          click: function($event) {
            _vm.openSelect($event)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "keep-alive",
        [
          _c(
            "md-menu-content",
            {
              ref: "menu",
              staticClass: "md-select-menu",
              style: _vm.menuStyles,
              attrs: {
                "md-content-class": _vm.mdClass,
                "md-list-class": _vm.mdDense && "md-dense",
                id: _vm.uniqueId
              }
            },
            [_vm._t("default")],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.model,
            expression: "model"
          }
        ],
        staticClass: "md-input-fake",
        attrs: { disabled: _vm.disabled, readonly: "", tabindex: "-1" },
        domProps: { value: _vm.model },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.model = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "select",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model,
                expression: "model"
              }
            ],
            attrs: { readonly: "", tabindex: "-1" },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.model = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          "select",
          _vm.attributes,
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdSelect_MdSelect = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e35dfa3", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdField/MdSelect/MdSelect.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(243)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdSelect_default.a,
  MdSelect_MdSelect,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdField/MdSelect/MdSelect.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7e35dfa3", Component.options)
  } else {
    hotAPI.reload("data-v-7e35dfa3", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdField_MdSelect_MdSelect = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _raf = __webpack_require__(9);

var _raf2 = _interopRequireDefault(_raf);

var _MdUuid = __webpack_require__(6);

var _MdUuid2 = _interopRequireDefault(_MdUuid);

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdDropDownIcon = __webpack_require__(245);

var _MdDropDownIcon2 = _interopRequireDefault(_MdDropDownIcon);

var _MdMenu = __webpack_require__(44);

var _MdMenu2 = _interopRequireDefault(_MdMenu);

var _MdMenuContent = __webpack_require__(45);

var _MdMenuContent2 = _interopRequireDefault(_MdMenuContent);

var _MdInput = __webpack_require__(14);

var _MdInput2 = _interopRequireDefault(_MdInput);

var _MdFieldMixin = __webpack_require__(15);

var _MdFieldMixin2 = _interopRequireDefault(_MdFieldMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var defaultOffset = {
  x: -15,
  y: -48
};

exports.default = {
  name: 'MdSelect',
  components: {
    MdInput: _MdInput2.default,
    MdMenu: _MdMenu2.default,
    MdMenuContent: _MdMenuContent2.default,
    MdDropDownIcon: _MdDropDownIcon2.default
  },
  mixins: [_MdFieldMixin2.default],
  props: {
    mdDense: Boolean,
    mdClass: String,
    multiple: Boolean,
    id: String,
    name: String
  },
  inject: ['MdField'],
  data: function data() {
    return {
      uniqueId: 'md-select-menu-' + (0, _MdUuid2.default)(),
      menuStyles: {},
      offset: {
        x: defaultOffset.x,
        y: 0
      },
      showSelect: true,
      didMount: false,
      MdSelect: {
        items: {},
        label: null,
        multiple: false,
        modelValue: this.model,
        setValue: this.setValue,
        setContent: this.setContent,
        setMultipleValue: this.setMultipleValue,
        setMultipleContent: this.setMultipleContent
      }
    };
  },
  provide: function provide() {
    var MdSelect = this.MdSelect;

    return { MdSelect: MdSelect };
  },

  computed: {
    inputListeners: function inputListeners() {
      return _extends({}, this.$listeners, {
        input: undefined
      });
    }
  },
  watch: {
    localValue: {
      immediate: true,
      handler: function handler() {
        this.setFieldContent();
      }
    },
    multiple: {
      immediate: true,
      handler: function handler(isMultiple) {
        var _this = this;

        this.MdSelect.multiple = isMultiple;
        this.$nextTick(function () {
          return _this.initialLocalValueByDefault();
        });
      }
    },
    model: function model() {
      this.MdSelect.modelValue = this.model;
    }
  },
  methods: {
    elHasScroll: function elHasScroll(el) {
      return el.scrollHeight > el.offsetHeight;
    },
    scrollToSelectedOption: function scrollToSelectedOption(el, menu) {
      var top = el.offsetTop;
      var elHeight = el.offsetHeight;
      var menuHeight = menu.offsetHeight;

      menu.scrollTop = top - (menuHeight - elHeight) / 2;
    },
    setOffsets: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(target) {
        var menu, selected;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$nextTick();

              case 2:

                if (!this.$isServer) {
                  menu = document.getElementById(this.uniqueId);


                  if (menu) {
                    selected = target || menu.querySelector('.md-selected');


                    if (selected) {
                      this.scrollToSelectedOption(selected, menu);
                      this.offset.y = defaultOffset.y - selected.offsetTop + menu.scrollTop + 8;
                      this.menuStyles = {
                        'transform-origin': '0 ' + Math.abs(this.offset.y) + 'px'
                      };
                    } else {
                      this.offset.y = defaultOffset.y + 1;
                      this.menuStyles = {};
                    }
                  }
                }

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setOffsets(_x) {
        return _ref.apply(this, arguments);
      }

      return setOffsets;
    }(),
    onOpen: function onOpen() {
      var _this2 = this;

      this.$emit('md-opened');
      if (this.didMount) {
        this.setOffsets();
        window.setTimeout(function () {
          _this2.MdField.focused = true;
        }, 10);
      }
    },
    applyHighlight: function applyHighlight() {
      this.MdField.focused = false;
      this.MdField.highlighted = true;
      this.$refs.input.$el.focus();
    },
    onClose: function onClose() {
      this.$emit('md-closed');
      if (this.didMount) {
        this.applyHighlight();
      }
    },
    onFocus: function onFocus() {
      if (this.didMount) {
        this.applyHighlight();
      }
    },
    removeHighlight: function removeHighlight() {
      this.MdField.highlighted = false;
    },
    openSelect: function openSelect() {
      if (!this.disabled) {
        this.showSelect = true;
      }
    },
    arrayAccessorRemove: function arrayAccessorRemove(arr, index) {
      var before = arr.slice(0, index);
      var after = arr.slice(index + 1, arr.length);
      return before.concat(after);
    },
    toggleArrayValue: function toggleArrayValue(value) {
      var index = this.localValue.indexOf(value);
      var includes = index > -1;
      if (!includes) {
        this.localValue = this.localValue.concat([value]);
      } else {
        this.localValue = this.arrayAccessorRemove(this.localValue, index);
      }
      this.emitSelected(this.localValue);
    },
    setValue: function setValue(newValue) {
      this.model = newValue;
      this.emitSelected(newValue);
      this.setFieldValue();
      this.showSelect = false;
    },
    setContent: function setContent(newLabel) {
      this.MdSelect.label = newLabel;
    },
    setContentByValue: function setContentByValue() {
      var textContent = this.MdSelect.items[this.localValue];

      if (textContent) {
        this.setContent(textContent);
      } else {
        this.setContent('');
      }
    },
    setMultipleValue: function setMultipleValue(value) {
      var newValue = value;
      this.toggleArrayValue(newValue);
      this.setFieldValue();
    },
    setMultipleContentByValue: function setMultipleContentByValue() {
      var _this3 = this;

      if (!this.localValue) {
        this.initialLocalValueByDefault();
      }
      var content = [];

      this.localValue.forEach(function (item) {
        var textContent = _this3.MdSelect.items[item];

        if (textContent) {
          content.push(textContent);
        }
      });

      this.setContent(content.join(', '));
    },
    setFieldContent: function setFieldContent() {
      if (this.multiple) {
        this.setMultipleContentByValue();
      } else {
        this.setContentByValue();
      }
    },
    initialLocalValueByDefault: function initialLocalValueByDefault() {
      var isArray = Array.isArray(this.localValue);
      if (this.multiple && !isArray) {
        var isSet = this.localValue !== undefined && this.localValue !== null;
        this.localValue = isSet ? [this.localValue] : [];
        return;
      }
      if (!this.multiple && isArray) {
        this.localValue = this.localValue.length > 0 ? this.localValue[0] : null;
      }
    },
    emitSelected: function emitSelected(value) {
      this.$emit('md-selected', value);
    }
  },
  mounted: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.showSelect = false;
              this.setFieldContent();

              _context2.next = 4;
              return this.$nextTick();

            case 4:
              this.didMount = true;

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _ref2.apply(this, arguments);
    }

    return mounted;
  }()
};

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/core/icons/MdDropDownIcon.vue
var MdDropDownIcon = __webpack_require__(246);
var MdDropDownIcon_default = /*#__PURE__*/__webpack_require__.n(MdDropDownIcon);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44db031d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/core/icons/MdDropDownIcon.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("md-icon", { staticClass: "md-icon-image" }, [
      _c(
        "svg",
        {
          attrs: {
            height: "24",
            viewBox: "0 0 24 24",
            width: "24",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("path", { attrs: { d: "M7 10l5 5 5-5z" } }),
          _vm._v(" "),
          _c("path", { attrs: { d: "M0 0h24v24H0z", fill: "none" } })
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var icons_MdDropDownIcon = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44db031d", esExports)
  }
}
// CONCATENATED MODULE: ./src/core/icons/MdDropDownIcon.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdDropDownIcon_default.a,
  icons_MdDropDownIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/core/icons/MdDropDownIcon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-44db031d", Component.options)
  } else {
    hotAPI.reload("data-v-44db031d", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var core_icons_MdDropDownIcon = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdIcon = __webpack_require__(5);

var _MdIcon2 = _interopRequireDefault(_MdIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdDropDownIcon',
  components: {
    MdIcon: _MdIcon2.default
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//

var _MdPropValidator = __webpack_require__(4);

var _MdPropValidator2 = _interopRequireDefault(_MdPropValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: 'MdMenu',
  props: {
    mdActive: Boolean,
    mdAlignTrigger: Boolean,
    mdOffsetX: Number,
    mdOffsetY: Number,
    mdFullWidth: Boolean,
    mdDense: Boolean,
    mdDirection: _extends({
      type: String,
      default: 'bottom-start'
    }, (0, _MdPropValidator2.default)('md-direction', ['top-end', 'top-start', 'bottom-end', 'bottom-start'])),
    mdCloseOnSelect: {
      type: Boolean,
      default: true
    },
    mdSize: _extends({
      type: String,
      default: 'small'
    }, (0, _MdPropValidator2.default)('md-size', ['auto', 'small', 'medium', 'big', 'huge']))
  },
  data: function data() {
    return {
      triggerEl: null,
      MdMenu: {
        instance: this,
        active: this.mdActive,
        direction: this.mdDirection,
        size: this.mdSize,
        alignTrigger: this.mdAlignTrigger,
        offsetX: this.mdOffsetX,
        offsetY: this.mdOffsetY,
        fullWidth: this.mdFullWidth,
        dense: this.mdDense,
        closeOnSelect: this.mdCloseOnSelect,
        bodyClickObserver: null,
        windowResizeObserver: null
      }
    };
  },
  provide: function provide() {
    return {
      MdMenu: this.MdMenu
    };
  },

  computed: {
    isActive: function isActive() {
      return this.MdMenu.active;
    }
  },
  watch: {
    mdActive: {
      immediate: true,
      handler: function handler(isActive) {
        this.MdMenu.active = isActive;
      }
    },
    mdDirection: function mdDirection(direction) {
      this.MdMenu.direction = direction;
    },
    mdSize: function mdSize(size) {
      this.MdMenu.size = size;
    },
    mdAlignTrigger: function mdAlignTrigger(aligned) {
      this.MdMenu.alignTrigger = aligned;
    },
    mdOffsetX: function mdOffsetX(offset) {
      this.MdMenu.offsetX = offset;
    },
    mdOffsetY: function mdOffsetY(offset) {
      this.MdMenu.offsetY = offset;
    },
    isActive: function isActive(_isActive) {
      this.$emit('update:mdActive', _isActive);

      if (!_isActive) {
        this.$emit('md-closed');
      } else {
        this.$emit('md-opened');
      }
    }
  },
  methods: {
    toggleContent: function toggleContent($event) {
      $event.stopPropagation();
      this.MdMenu.active = !this.MdMenu.active;
    }
  },
  mounted: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$nextTick();

            case 2:

              this.triggerEl = this.$el.querySelector('[md-menu-trigger]');

              if (this.triggerEl) {
                this.triggerEl.addEventListener('click', this.toggleContent);
              }

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    if (this.triggerEl) {
      this.triggerEl.removeEventListener('click', this.toggleContent);
    }
  }
};

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdPropValidator = __webpack_require__(4);

var _MdPropValidator2 = _interopRequireDefault(_MdPropValidator);

var _MdObserveEvent = __webpack_require__(46);

var _MdObserveEvent2 = _interopRequireDefault(_MdObserveEvent);

var _MdResizeObserver = __webpack_require__(251);

var _MdResizeObserver2 = _interopRequireDefault(_MdResizeObserver);

var _MdPopover = __webpack_require__(25);

var _MdPopover2 = _interopRequireDefault(_MdPopover);

var _MdFocusTrap = __webpack_require__(40);

var _MdFocusTrap2 = _interopRequireDefault(_MdFocusTrap);

var _MdList = __webpack_require__(47);

var _MdList2 = _interopRequireDefault(_MdList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = new _MdComponent2.default({
  name: 'MdMenuContent',
  components: {
    MdPopover: _MdPopover2.default,
    MdFocusTrap: _MdFocusTrap2.default,
    MdList: _MdList2.default
  },
  props: {
    mdListClass: [String, Boolean],
    mdContentClass: [String, Boolean]
  },
  inject: ['MdMenu'],
  data: function data() {
    return {
      highlightIndex: -1,
      didMount: false,
      highlightItems: [],
      popperSettings: null,
      menuStyles: ''
    };
  },
  computed: {
    highlightedItem: function highlightedItem() {
      return this.highlightItems[this.highlightIndex];
    },
    shouldRender: function shouldRender() {
      return this.MdMenu.active;
    },
    menuClasses: function menuClasses() {
      var _ref;

      var prefix = 'md-menu-content-';

      return _ref = {}, _defineProperty(_ref, prefix + this.MdMenu.direction, true), _defineProperty(_ref, prefix + this.MdMenu.size, true), _defineProperty(_ref, 'md-menu-content', this.didMount), _defineProperty(_ref, 'md-shallow', !this.didMount), _ref;
    },
    listClasses: function listClasses() {
      return _extends({
        'md-dense': this.MdMenu.dense
      }, this.mdListClass);
    }
  },
  watch: {
    shouldRender: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_shouldRender) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_shouldRender) {
                  _context.next = 7;
                  break;
                }

                this.setPopperSettings();
                _context.next = 4;
                return this.$nextTick();

              case 4:
                this.setInitialHighlightIndex();
                this.createClickEventObserver();
                this.createResizeObserver();

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function shouldRender(_x) {
        return _ref2.apply(this, arguments);
      }

      return shouldRender;
    }()
  },
  methods: {
    setPopperSettings: function setPopperSettings() {
      var _MdMenu = this.MdMenu,
          direction = _MdMenu.direction,
          alignTrigger = _MdMenu.alignTrigger;

      var _getOffsets = this.getOffsets(),
          offsetX = _getOffsets.offsetX,
          offsetY = _getOffsets.offsetY;

      if (!this.hasCustomOffsets()) {
        if (this.MdMenu.instance.$el && this.MdMenu.instance.$el.offsetHeight) {
          offsetY = -this.MdMenu.instance.$el.offsetHeight - 11;
        }

        if (direction.includes('start')) {
          offsetX = -8;
        } else if (direction.includes('end')) {
          offsetX = 8;
        }
      }

      this.popperSettings = {
        placement: direction,
        modifiers: {
          keepTogether: {
            enabled: true
          },
          flip: {
            enabled: false
          },
          offset: {
            offset: offsetX + ', ' + offsetY
          }
        }
      };
    },
    setInitialHighlightIndex: function setInitialHighlightIndex() {
      var _this = this;

      this.setHighlightItems();
      this.highlightItems.forEach(function (item, index) {
        if (item.classList.contains('md-selected')) {
          _this.highlightIndex = index - 1;
        }
      });
    },
    setHighlightItems: function setHighlightItems() {
      if (this.$el.querySelectorAll) {
        var items = this.$el.querySelectorAll('.md-list-item-container:not(.md-list-item-default):not([disabled])');

        this.highlightItems = Array.from(items);
      }
    },
    setHighlight: function setHighlight(direction) {
      this.setHighlightItems();

      if (this.highlightItems.length) {
        if (direction === 'down') {
          if (this.highlightIndex === this.highlightItems.length - 1) {
            this.highlightIndex = 0;
          } else {
            this.highlightIndex++;
          }
        } else {
          if (this.highlightIndex === 0) {
            this.highlightIndex = this.highlightItems.length - 1;
          } else {
            this.highlightIndex--;
          }
        }

        this.clearAllHighlights();
        this.setItemHighlight();
      }
    },
    clearAllHighlights: function clearAllHighlights() {
      this.highlightItems.forEach(function (item) {
        item.parentNode.__vue__.highlighted = false;
      });
    },
    setItemHighlight: function setItemHighlight() {
      if (this.highlightedItem) {
        this.highlightedItem.parentNode.__vue__.highlighted = true;
        if (this.$parent.$parent.setOffsets) {
          this.$parent.$parent.setOffsets(this.highlightedItem.parentNode);
        }
      }
    },
    setSelection: function setSelection() {
      if (this.highlightedItem) {
        this.highlightedItem.parentNode.click();
      }
    },
    onEsc: function onEsc() {
      this.MdMenu.active = false;
    },
    getOffsets: function getOffsets() {
      return {
        offsetX: this.MdMenu.offsetX || 0,
        offsetY: this.MdMenu.offsetY || 0
      };
    },
    hasCustomOffsets: function hasCustomOffsets() {
      var _MdMenu2 = this.MdMenu,
          offsetX = _MdMenu2.offsetX,
          offsetY = _MdMenu2.offsetY,
          alignTrigger = _MdMenu2.alignTrigger;


      return Boolean(alignTrigger || offsetY || offsetX);
    },
    createClickEventObserver: function createClickEventObserver() {
      var _this2 = this;

      if (document) {
        this.MdMenu.bodyClickObserver = new _MdObserveEvent2.default(document.body, 'click', function ($event) {
          $event.stopPropagation();

          if (!_this2.$el.contains($event.target)) {
            _this2.MdMenu.active = false;
            _this2.MdMenu.bodyClickObserver.destroy();
            _this2.MdMenu.windowResizeObserver.destroy();
          }
        });
      }
    },
    createResizeObserver: function createResizeObserver() {
      this.MdMenu.windowResizeObserver = new _MdResizeObserver2.default(window, this.setStyles);
    },
    setupWatchers: function setupWatchers() {
      this.$watch('MdMenu.direction', this.setPopperSettings);
      this.$watch('MdMenu.alignTrigger', this.setPopperSettings);
      this.$watch('MdMenu.offsetX', this.setPopperSettings);
      this.$watch('MdMenu.offsetY', this.setPopperSettings);
    },
    setStyles: function setStyles() {
      if (this.MdMenu.fullWidth) {
        this.menuStyles = '\n          width: ' + this.MdMenu.instance.$el.offsetWidth + 'px;\n          max-width: ' + this.MdMenu.instance.$el.offsetWidth + 'px\n        ';
      }
    }
  },
  mounted: function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.$nextTick();

            case 2:
              this.setHighlightItems();
              this.setupWatchers();
              this.setStyles();
              this.didMount = true;

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _ref3.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    if (this.MdMenu.bodyClickObserver) {
      this.MdMenu.bodyClickObserver.destroy();
    }

    if (this.MdMenu.windowResizeObserver) {
      this.MdMenu.windowResizeObserver.destroy();
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _raf = __webpack_require__(9);

var _raf2 = _interopRequireDefault(_raf);

var _MdObserveEvent = __webpack_require__(46);

var _MdObserveEvent2 = _interopRequireDefault(_MdObserveEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  var observerFn = arguments[1];

  var observer = (0, _MdObserveEvent2.default)(el, 'resize', function () {
    (0, _raf2.default)(observerFn);
  }, { passive: true });

  return {
    destroy: function destroy() {
      return observer.destroy;
    }
  };
};

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdList'
}); //
//
//
//
//
//

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdField/MdSelect/MdOption.vue
var MdOption = __webpack_require__(256);
var MdOption_default = /*#__PURE__*/__webpack_require__.n(MdOption);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32c8ce9c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdField/MdSelect/MdOption.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-menu-item",
    {
      class: _vm.optionClasses,
      attrs: { disabled: _vm.isDisabled },
      on: { click: _vm.setSelection }
    },
    [
      _vm.MdSelect.multiple
        ? _c("md-checkbox", {
            staticClass: "md-primary",
            model: {
              value: _vm.isChecked,
              callback: function($$v) {
                _vm.isChecked = $$v
              },
              expression: "isChecked"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        { ref: "text", staticClass: "md-list-item-text" },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdSelect_MdOption = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32c8ce9c", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdField/MdSelect/MdOption.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(255)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdOption_default.a,
  MdSelect_MdOption,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdField/MdSelect/MdOption.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-32c8ce9c", Component.options)
  } else {
    hotAPI.reload("data-v-32c8ce9c", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdField_MdSelect_MdOption = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdUuid = __webpack_require__(6);

var _MdUuid2 = _interopRequireDefault(_MdUuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdOption',
  props: {
    value: [String, Number, Boolean],
    disabled: Boolean
  },
  inject: {
    MdSelect: {},
    MdOptgroup: {
      default: {}
    }
  },
  data: function data() {
    return {
      uniqueId: 'md-option-' + (0, _MdUuid2.default)(),
      isSelected: false,
      isChecked: false
    };
  },
  computed: {
    selectValue: function selectValue() {
      return this.MdSelect.modelValue;
    },
    isMultiple: function isMultiple() {
      return this.MdSelect.multiple;
    },
    isDisabled: function isDisabled() {
      return this.MdOptgroup.disabled || this.disabled;
    },
    key: function key() {
      var isSet = this.value || this.value === 0;
      return isSet ? this.value : this.uniqueId;
    },
    inputLabel: function inputLabel() {
      return this.MdSelect.label;
    },
    optionClasses: function optionClasses() {
      return {
        'md-selected': this.isSelected || this.isChecked
      };
    }
  },
  watch: {
    inputLabel: function inputLabel() {
      this.setIsSelected();
    }
  },
  methods: {
    getTextContent: function getTextContent() {
      if (this.$el) {
        return this.$el.textContent.trim();
      }

      var slot = this.$slots.default;

      return slot ? slot[0].text.trim() : '';
    },
    setIsSelected: function setIsSelected() {
      this.isSelected = this.inputLabel === this.getTextContent();
    },
    setSingleSelection: function setSingleSelection() {
      this.MdSelect.setValue(this.value);
    },
    setMultipleSelection: function setMultipleSelection() {
      this.isChecked = !this.isChecked;
      this.MdSelect.setMultipleValue(this.value);
    },
    setSelection: function setSelection() {
      if (!this.disabled) {
        if (this.isMultiple) {
          this.setMultipleSelection();
        } else {
          this.setSingleSelection();
        }
      }
    },
    setItem: function setItem() {
      this.$set(this.MdSelect.items, this.key, this.getTextContent());
    }
  },
  updated: function updated() {
    this.setItem();
  },
  created: function created() {
    this.setItem();
    this.setIsSelected();

    if (this.isMultiple && this.selectValue && this.selectValue.length) {
      this.isChecked = this.selectValue.includes(this.value);
    }
  }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdField/MdSelect/MdOptgroup.vue
var MdOptgroup = __webpack_require__(259);
var MdOptgroup_default = /*#__PURE__*/__webpack_require__.n(MdOptgroup);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60840a93","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdField/MdSelect/MdOptgroup.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-optgroup" },
    [
      _c("md-subheader", [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdSelect_MdOptgroup = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60840a93", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdField/MdSelect/MdOptgroup.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(258)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdOptgroup_default.a,
  MdSelect_MdOptgroup,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdField/MdSelect/MdOptgroup.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-60840a93", Component.options)
  } else {
    hotAPI.reload("data-v-60840a93", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdField_MdSelect_MdOptgroup = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//

exports.default = {
  name: 'MdOptgroup',
  props: {
    label: String,
    disabled: Boolean
  },
  provide: function provide() {
    return {
      MdOptgroup: {
        disabled: this.disabled
      }
    };
  }
};

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdField/MdFile/MdFile.vue
var MdFile = __webpack_require__(262);
var MdFile_default = /*#__PURE__*/__webpack_require__.n(MdFile);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16fac4a3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdField/MdFile/MdFile.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-file" },
    [
      _c("md-file-icon", {
        nativeOn: {
          click: function($event) {
            _vm.openPicker($event)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "input",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model,
                expression: "model"
              }
            ],
            staticClass: "md-input",
            attrs: { readonly: "" },
            domProps: { value: _vm.model },
            on: {
              focus: _vm.openPicker,
              blur: _vm.onBlur,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.model = $event.target.value
              }
            }
          },
          "input",
          {
            disabled: _vm.disabled,
            required: _vm.required,
            placeholder: _vm.placeholder
          },
          false
        )
      ),
      _vm._v(" "),
      _c(
        "input",
        _vm._g(
          _vm._b(
            {
              ref: "inputFile",
              attrs: { type: "file" },
              on: { change: _vm.onChange }
            },
            "input",
            _vm.attributes,
            false
          ),
          _vm.$listeners
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdFile_MdFile = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16fac4a3", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdField/MdFile/MdFile.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(261)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdFile_default.a,
  MdFile_MdFile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdField/MdFile/MdFile.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-16fac4a3", Component.options)
  } else {
    hotAPI.reload("data-v-16fac4a3", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdField_MdFile_MdFile = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdUuid = __webpack_require__(6);

var _MdUuid2 = _interopRequireDefault(_MdUuid);

var _MdFileIcon = __webpack_require__(263);

var _MdFileIcon2 = _interopRequireDefault(_MdFileIcon);

var _MdFieldMixin = __webpack_require__(15);

var _MdFieldMixin2 = _interopRequireDefault(_MdFieldMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'MdFile',
  components: {
    MdFileIcon: _MdFileIcon2.default
  },
  props: {
    id: {
      type: String,
      default: function _default() {
        return 'md-file-' + (0, _MdUuid2.default)();
      }
    },
    name: String
  },
  mixins: [_MdFieldMixin2.default],
  inject: ['MdField'],
  methods: {
    getMultipleName: function getMultipleName(files) {
      var names = [];

      [].concat(_toConsumableArray(files)).forEach(function (_ref) {
        var name = _ref.name;
        return names.push(name);
      });

      return names.join(', ');
    },
    getFileName: function getFileName(files, target) {
      if (!files) {
        return target.value.split('\\').pop();
      }

      if (files.length > 1) {
        return this.getMultipleName(files);
      }

      if (files.length === 1) {
        return files[0].name;
      }

      return null;
    },
    openPicker: function openPicker() {
      this.onFocus();
      this.$refs.inputFile.click();
    },
    onChange: function onChange($event) {
      this.onFileSelected($event);
    },
    onFileSelected: function onFileSelected(_ref2) {
      var target = _ref2.target,
          dataTransfer = _ref2.dataTransfer;

      var files = target.files || dataTransfer.files;

      this.model = this.getFileName(files, target);
      this.$emit('md-change', files || target.value);
    }
  },
  created: function created() {
    this.MdField.file = true;
  },
  beforeDestroy: function beforeDestroy() {
    this.MdField.file = false;
  }
};

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/core/icons/MdFileIcon.vue
var MdFileIcon = __webpack_require__(264);
var MdFileIcon_default = /*#__PURE__*/__webpack_require__.n(MdFileIcon);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bd0ca30","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/core/icons/MdFileIcon.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("md-icon", { staticClass: "md-icon-image" }, [
      _c(
        "svg",
        {
          attrs: {
            height: "24",
            viewBox: "0 0 24 24",
            width: "24",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
            }
          }),
          _vm._v(" "),
          _c("path", { attrs: { d: "M0 0h24v24H0z", fill: "none" } })
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var icons_MdFileIcon = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bd0ca30", esExports)
  }
}
// CONCATENATED MODULE: ./src/core/icons/MdFileIcon.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdFileIcon_default.a,
  icons_MdFileIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/core/icons/MdFileIcon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3bd0ca30", Component.options)
  } else {
    hotAPI.reload("data-v-3bd0ca30", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var core_icons_MdFileIcon = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdIcon = __webpack_require__(5);

var _MdIcon2 = _interopRequireDefault(_MdIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdFileIcon',
  components: {
    MdIcon: _MdIcon2.default
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdField/MdTextarea/MdTextarea.vue
var MdTextarea = __webpack_require__(266);
var MdTextarea_default = /*#__PURE__*/__webpack_require__.n(MdTextarea);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-445d103a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdField/MdTextarea/MdTextarea.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "textarea",
    _vm._g(
      _vm._b(
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.model,
              expression: "model"
            }
          ],
          staticClass: "md-textarea",
          style: _vm.textareaStyles,
          domProps: { value: _vm.model },
          on: {
            focus: _vm.onFocus,
            blur: _vm.onBlur,
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.model = $event.target.value
            }
          }
        },
        "textarea",
        _vm.attributes,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdTextarea_MdTextarea = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-445d103a", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdField/MdTextarea/MdTextarea.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdTextarea_default.a,
  MdTextarea_MdTextarea,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdField/MdTextarea/MdTextarea.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-445d103a", Component.options)
  } else {
    hotAPI.reload("data-v-445d103a", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdField_MdTextarea_MdTextarea = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdUuid = __webpack_require__(6);

var _MdUuid2 = _interopRequireDefault(_MdUuid);

var _MdFieldMixin = __webpack_require__(15);

var _MdFieldMixin2 = _interopRequireDefault(_MdFieldMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//

function calculateContentHeight(el, lineHeight) {
  var origHeight = el.style.height;
  var height = el.offsetHeight;
  var scrollHeight = el.scrollHeight;

  el.style.overflow = 'hidden';

  if (height >= scrollHeight) {
    el.style.height = height + lineHeight + 'px';

    if (scrollHeight < el.scrollHeight) {
      el.style.height = origHeight;

      return height;
    }
  }

  return scrollHeight;
}

exports.default = new _MdComponent2.default({
  name: 'MdTextarea',
  mixins: [_MdFieldMixin2.default],
  inject: ['MdField'],
  props: {
    id: {
      type: String,
      default: function _default() {
        return 'md-textarea-' + (0, _MdUuid2.default)();
      }
    },
    mdAutogrow: Boolean
  },
  computed: {
    textareaStyles: function textareaStyles() {
      return {
        height: this.textareaHeight
      };
    }
  },
  methods: {
    getTextAreaLineSize: function getTextAreaLineSize() {
      var style = window.getComputedStyle(this.$el);

      return parseInt(style.lineHeight, 10);
    },
    setTextAreaSize: function setTextAreaSize(height) {
      var newHeight = height;

      if (!height) {
        var size = this.getTextAreaLineSize();

        newHeight = calculateContentHeight(this.$el, size);
      }

      this.textareaHeight = newHeight + 'px';
    },
    applyStyles: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.mdAutogrow) {
                  _context.next = 6;
                  break;
                }

                this.setTextAreaSize(32);
                _context.next = 4;
                return this.$nextTick();

              case 4:
                this.setTextAreaSize();
                window.setTimeout(function () {
                  _this.$el.style.overflow = 'auto';
                }, 10);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function applyStyles() {
        return _ref.apply(this, arguments);
      }

      return applyStyles;
    }(),
    setTextarea: function setTextarea() {
      this.MdField.textarea = true;
    },
    setAutogrow: function setAutogrow() {
      this.MdField.autogrow = this.mdAutogrow;
    },
    onInput: function onInput() {
      this.setFieldValue();
      this.applyStyles();
    }
  },
  created: function created() {
    this.setTextarea();
    this.setAutogrow();
  },
  mounted: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.$nextTick();

            case 2:
              this.applyStyles();

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _ref2.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    this.setTextarea(false);
  }
});

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdHighlightText = __webpack_require__(268);

var _MdHighlightText2 = _interopRequireDefault(_MdHighlightText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdHighlightText2.default.name, _MdHighlightText2.default);
};

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdHighlightText_vue__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdHighlightText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdHighlightText_vue__);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(269)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdHighlightText_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdHighlightText/MdHighlightText.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-41eb36a5", Component.options)
  } else {
    hotAPI.reload("data-v-41eb36a5", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(7);

var _vue2 = _interopRequireDefault(_vue);

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getHTMLOutput(str) {
  var text = str;

  if (!text) {
    text = '$&';
  }

  return '<span class="md-highlight-text-match">' + text + '</span>';
}

function fuzzyHighlight(text, term) {
  if (term.length === 0) {
    return text;
  }

  var offset = text.toLowerCase().indexOf(term[0].toLowerCase());

  if (offset === -1) {
    return null;
  }

  var last = 0;
  for (var i = 1; i < term.length; i++) {
    if (text[offset + i] !== term[i]) {
      break;
    }

    last = i;
  }

  var before = text.slice(0, offset);
  var match = getHTMLOutput(text.slice(offset, offset + last + 1));
  var after = fuzzyHighlight(text.slice(offset + last + 1), term.slice(last + 1));

  return before + match + after;
}

function normalHighlight(text, term) {
  var matches = new RegExp(term + '(?!([^<]+)?<)', 'gi');

  return text.replace(matches, getHTMLOutput());
}

function generateHighlight(_ref, term, isFuzzy) {
  var text = _ref.text;

  if (text && term && term[0]) {
    if (isFuzzy) {
      return fuzzyHighlight(text, term) || text;
    }

    return normalHighlight(text, term);
  }

  return text;
}

exports.default = new _MdComponent2.default({
  name: 'MdHighlightText',
  abstract: true,
  props: {
    mdTerm: String,
    mdFuzzySearch: {
      type: Boolean,
      default: true
    }
  },
  render: function render(createElement) {
    try {
      var defaultSlot = this.$slots.default;

      if (!defaultSlot) {
        return null;
      }

      if (defaultSlot.length > 1 || defaultSlot[0].tag) {
        throw new Error();
      }

      var HTMLContent = generateHighlight(defaultSlot[0], this.mdTerm, this.mdFuzzySearch);

      return createElement('div', {
        staticClass: 'md-highlight-text',
        class: this.$mdActiveTheme,
        domProps: {
          innerHTML: HTMLContent
        }
      });
    } catch (e) {
      _vue2.default.util.warn('MdHighlightText can only render text nodes.', this);
    }

    return null;
  }
});

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdImage = __webpack_require__(272);

var _MdImage2 = _interopRequireDefault(_MdImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdImage2.default.name, _MdImage2.default);
};

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdImage/MdImage.vue
var MdImage = __webpack_require__(274);
var MdImage_default = /*#__PURE__*/__webpack_require__.n(MdImage);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4511ea59","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdImage/MdImage.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-image", class: [_vm.$mdActiveTheme] },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdImage_MdImage = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4511ea59", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdImage/MdImage.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(273)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdImage_default.a,
  MdImage_MdImage,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdImage/MdImage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4511ea59", Component.options)
  } else {
    hotAPI.reload("data-v-4511ea59", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdImage_MdImage = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdImage',
  props: {
    mdSrc: String
  }
});

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(276);

exports.default = function (Vue) {};

/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdList = __webpack_require__(47);

var _MdList2 = _interopRequireDefault(_MdList);

var _MdListItem = __webpack_require__(48);

var _MdListItem2 = _interopRequireDefault(_MdListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdList2.default.name, _MdList2.default);
  Vue.component(_MdListItem2.default.name, _MdListItem2.default);
};

/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _MdInteractionEvents = __webpack_require__(49);

var _MdInteractionEvents2 = _interopRequireDefault(_MdInteractionEvents);

var _MdRouterLinkProps = __webpack_require__(12);

var _MdRouterLinkProps2 = _interopRequireDefault(_MdRouterLinkProps);

var _MdListItemDefault = __webpack_require__(280);

var _MdListItemDefault2 = _interopRequireDefault(_MdListItemDefault);

var _MdListItemButton = __webpack_require__(284);

var _MdListItemButton2 = _interopRequireDefault(_MdListItemButton);

var _MdListItemLink = __webpack_require__(286);

var _MdListItemLink2 = _interopRequireDefault(_MdListItemLink);

var _MdListItemRouter = __webpack_require__(288);

var _MdListItemRouter2 = _interopRequireDefault(_MdListItemRouter);

var _MdListItemExpand = __webpack_require__(290);

var _MdListItemExpand2 = _interopRequireDefault(_MdListItemExpand);

var _MdButton = __webpack_require__(13);

var _MdButton2 = _interopRequireDefault(_MdButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasExpansion(props) {
  return props.hasOwnProperty('mdExpand') && props.mdExpand !== false;
}

function resolveScopedSlot(props, children) {
  if (hasExpansion(props)) {
    return {
      'md-expand': function mdExpand() {
        return children['md-expand'][0];
      }
    };
  }
}

exports.default = {
  name: 'MdListItem',
  functional: true,
  components: {
    MdButton: _MdButton2.default
  },
  render: function render(createElement, _ref) {
    var parent = _ref.parent,
        props = _ref.props,
        listeners = _ref.listeners,
        data = _ref.data,
        slots = _ref.slots;

    var children = slots();
    var listComponent = _MdListItemDefault2.default;
    var staticClass = 'md-list-item';

    if (hasExpansion(props)) {
      listComponent = _MdListItemExpand2.default;
    } else if (parent && parent.$router && props.to) {
      listComponent = _MdListItemRouter2.default;
      listComponent.props = (0, _MdRouterLinkProps2.default)(parent, {
        target: String
      });
      delete listComponent.props.href;
    } else if (props.href) {
      listComponent = _MdListItemLink2.default;
    } else {
      var listenerNames = Object.keys(listeners);

      listenerNames.forEach(function (listener) {
        if (_MdInteractionEvents2.default.includes(listener)) {
          listComponent = _MdListItemButton2.default;
        }
      });
    }

    if (data.staticClass) {
      staticClass += ' ' + data.staticClass;
    }

    return createElement('li', _extends({}, data, {
      staticClass: staticClass,
      on: listeners
    }), [createElement(listComponent, {
      props: props,
      scopedSlots: resolveScopedSlot(props, children),
      staticClass: 'md-list-item-container md-button-clean'
    }, children.default)]);
  }
};

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdList/MdListItem/MdListItemDefault.vue
var MdListItemDefault = __webpack_require__(281);
var MdListItemDefault_default = /*#__PURE__*/__webpack_require__.n(MdListItemDefault);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4eac868","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdList/MdListItem/MdListItemDefault.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-list-item-default", on: { click: _vm.toggleControl } },
    [
      _c(
        "md-list-item-content",
        { attrs: { "md-disabled": "" } },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdListItem_MdListItemDefault = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4eac868", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdList/MdListItem/MdListItemDefault.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdListItemDefault_default.a,
  MdListItem_MdListItemDefault,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdList/MdListItem/MdListItemDefault.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b4eac868", Component.options)
  } else {
    hotAPI.reload("data-v-b4eac868", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdList_MdListItem_MdListItemDefault = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdListItemMixin = __webpack_require__(11);

var _MdListItemMixin2 = _interopRequireDefault(_MdListItemMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdListItemDefault',
  mixins: [_MdListItemMixin2.default],
  methods: {
    toggleControl: function toggleControl() {
      var control = this.$el.querySelector('.md-checkbox-container, .md-switch-container, .md-radio-container');

      if (control) {
        control.click();
      }
    }
  }
}; //
//
//
//
//
//
//
//

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdList/MdListItem/MdListItemContent.vue
var MdListItemContent = __webpack_require__(283);
var MdListItemContent_default = /*#__PURE__*/__webpack_require__.n(MdListItemContent);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af37c3f8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdList/MdListItem/MdListItemContent.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-ripple",
    {
      staticClass: "md-list-item-content",
      attrs: { "md-disabled": _vm.mdDisabled }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdListItem_MdListItemContent = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af37c3f8", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdList/MdListItem/MdListItemContent.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdListItemContent_default.a,
  MdListItem_MdListItemContent,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdList/MdListItem/MdListItemContent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-af37c3f8", Component.options)
  } else {
    hotAPI.reload("data-v-af37c3f8", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdList_MdListItem_MdListItemContent = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdRipple = __webpack_require__(8);

var _MdRipple2 = _interopRequireDefault(_MdRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdListItemContent',
  components: {
    MdRipple: _MdRipple2.default
  },
  props: {
    mdDisabled: Boolean
  }
}; //
//
//
//
//
//

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdList/MdListItem/MdListItemButton.vue
var MdListItemButton = __webpack_require__(285);
var MdListItemButton_default = /*#__PURE__*/__webpack_require__.n(MdListItemButton);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d27ca12","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdList/MdListItem/MdListItemButton.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "md-list-item-button",
      attrs: { type: "button", disabled: _vm.disabled }
    },
    [
      _c(
        "md-list-item-content",
        { attrs: { "md-disabled": _vm.isDisabled } },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdListItem_MdListItemButton = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d27ca12", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdList/MdListItem/MdListItemButton.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdListItemButton_default.a,
  MdListItem_MdListItemButton,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdList/MdListItem/MdListItemButton.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4d27ca12", Component.options)
  } else {
    hotAPI.reload("data-v-4d27ca12", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdList_MdListItem_MdListItemButton = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdListItemMixin = __webpack_require__(11);

var _MdListItemMixin2 = _interopRequireDefault(_MdListItemMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdListItemButton',
  mixins: [_MdListItemMixin2.default]
}; //
//
//
//
//
//
//
//

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdList/MdListItem/MdListItemLink.vue
var MdListItemLink = __webpack_require__(287);
var MdListItemLink_default = /*#__PURE__*/__webpack_require__.n(MdListItemLink);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49acb202","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdList/MdListItem/MdListItemLink.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    _vm._b(
      { staticClass: "md-list-item-link" },
      "a",
      { href: _vm.href, disabled: _vm.disabled, target: _vm.target },
      false
    ),
    [
      _c(
        "md-list-item-content",
        { attrs: { "md-disabled": _vm.isDisabled } },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdListItem_MdListItemLink = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49acb202", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdList/MdListItem/MdListItemLink.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdListItemLink_default.a,
  MdListItem_MdListItemLink,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdList/MdListItem/MdListItemLink.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-49acb202", Component.options)
  } else {
    hotAPI.reload("data-v-49acb202", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdList_MdListItem_MdListItemLink = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdListItemMixin = __webpack_require__(11);

var _MdListItemMixin2 = _interopRequireDefault(_MdListItemMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdListItemLink',
  mixins: [_MdListItemMixin2.default],
  props: {
    href: String,
    target: String
  }
}; //
//
//
//
//
//
//
//

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdList/MdListItem/MdListItemRouter.vue
var MdListItemRouter = __webpack_require__(289);
var MdListItemRouter_default = /*#__PURE__*/__webpack_require__.n(MdListItemRouter);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-091cb0e4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdList/MdListItem/MdListItemRouter.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    _vm._b(
      { staticClass: "md-list-item-router" },
      "router-link",
      _vm.routerProps,
      false
    ),
    [
      _c(
        "md-list-item-content",
        { attrs: { "md-disabled": _vm.isDisabled } },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdListItem_MdListItemRouter = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-091cb0e4", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdList/MdListItem/MdListItemRouter.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdListItemRouter_default.a,
  MdListItem_MdListItemRouter,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdList/MdListItem/MdListItemRouter.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-091cb0e4", Component.options)
  } else {
    hotAPI.reload("data-v-091cb0e4", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdList_MdListItem_MdListItemRouter = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdListItemMixin = __webpack_require__(11);

var _MdListItemMixin2 = _interopRequireDefault(_MdListItemMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdListItemRouter',
  mixins: [_MdListItemMixin2.default],
  computed: {
    routerProps: function routerProps() {
      return this.$props;
    }
  }
}; //
//
//
//
//
//
//
//

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdList/MdListItem/MdListItemExpand.vue
var MdListItemExpand = __webpack_require__(292);
var MdListItemExpand_default = /*#__PURE__*/__webpack_require__.n(MdListItemExpand);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-378e4342","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdList/MdListItem/MdListItemExpand.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-list-item-expand", class: _vm.expandClasses },
    [
      _c(
        "md-list-item-content",
        {
          attrs: { "md-disabled": _vm.isDisabled },
          nativeOn: {
            click: function($event) {
              _vm.toggleExpand($event)
            }
          }
        },
        [
          _vm._t("default"),
          _vm._v(" "),
          _c("md-arrow-down-icon", { staticClass: "md-list-expand-icon" })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "listExpand",
          staticClass: "md-list-expand",
          style: _vm.expandStyles
        },
        [_vm._t("md-expand")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdListItem_MdListItemExpand = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-378e4342", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdList/MdListItem/MdListItemExpand.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(291)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdListItemExpand_default.a,
  MdListItem_MdListItemExpand,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdList/MdListItem/MdListItemExpand.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-378e4342", Component.options)
  } else {
    hotAPI.reload("data-v-378e4342", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdList_MdListItem_MdListItemExpand = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _raf = __webpack_require__(9);

var _raf2 = _interopRequireDefault(_raf);

var _MdArrowDownIcon = __webpack_require__(293);

var _MdArrowDownIcon2 = _interopRequireDefault(_MdArrowDownIcon);

var _MdListItemMixin = __webpack_require__(11);

var _MdListItemMixin2 = _interopRequireDefault(_MdListItemMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdListItemExpand',
  components: {
    MdArrowDownIcon: _MdArrowDownIcon2.default
  },
  mixins: [_MdListItemMixin2.default],
  data: function data() {
    return {
      expandStyles: {},
      showContent: false
    };
  },
  computed: {
    expandClasses: function expandClasses() {
      return {
        'md-active': this.showContent
      };
    }
  },
  methods: {
    getChildrenSize: function getChildrenSize() {
      var expandEl = this.$refs.listExpand;
      var size = 0;

      Array.from(expandEl.children).forEach(function (child) {
        size += child.offsetHeight;
      });

      return size;
    },
    toggleExpand: function toggleExpand() {
      var _this = this;

      (0, _raf2.default)(function () {
        var fullHeight = 0;

        if (!_this.showContent) {
          fullHeight = 'auto'; // this.getChildrenSize() + 'px'
        }

        _this.expandStyles = { height: fullHeight };
        _this.showContent = !_this.showContent;
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/core/icons/MdArrowDownIcon.vue
var MdArrowDownIcon = __webpack_require__(294);
var MdArrowDownIcon_default = /*#__PURE__*/__webpack_require__.n(MdArrowDownIcon);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2443de21","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/core/icons/MdArrowDownIcon.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("md-icon", { staticClass: "md-icon-image" }, [
      _c(
        "svg",
        {
          attrs: {
            height: "24",
            viewBox: "0 0 24 24",
            width: "24",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("path", {
            attrs: { d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" }
          }),
          _vm._v(" "),
          _c("path", { attrs: { d: "M0-.75h24v24H0z", fill: "none" } })
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var icons_MdArrowDownIcon = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2443de21", esExports)
  }
}
// CONCATENATED MODULE: ./src/core/icons/MdArrowDownIcon.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdArrowDownIcon_default.a,
  icons_MdArrowDownIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/core/icons/MdArrowDownIcon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2443de21", Component.options)
  } else {
    hotAPI.reload("data-v-2443de21", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var core_icons_MdArrowDownIcon = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdIcon = __webpack_require__(5);

var _MdIcon2 = _interopRequireDefault(_MdIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdArrowDownIcon',
  components: {
    MdIcon: _MdIcon2.default
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdMenu = __webpack_require__(44);

var _MdMenu2 = _interopRequireDefault(_MdMenu);

var _MdMenuContent = __webpack_require__(45);

var _MdMenuContent2 = _interopRequireDefault(_MdMenuContent);

var _MdMenuItem = __webpack_require__(296);

var _MdMenuItem2 = _interopRequireDefault(_MdMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdMenu2.default.name, _MdMenu2.default);
  Vue.component(_MdMenuContent2.default.name, _MdMenuContent2.default);
  Vue.component(_MdMenuItem2.default.name, _MdMenuItem2.default);
};

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdMenu/MdMenuItem.vue
var MdMenuItem = __webpack_require__(297);
var MdMenuItem_default = /*#__PURE__*/__webpack_require__.n(MdMenuItem);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26762702","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdMenu/MdMenuItem.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-list-item",
    _vm._g(
      _vm._b(
        {
          staticClass: "md-menu-item",
          class: [_vm.itemClasses, _vm.$mdActiveTheme],
          attrs: { disabled: _vm.disabled, tabindex: _vm.highlighted && -1 }
        },
        "md-list-item",
        _vm.$attrs,
        false
      ),
      _vm.listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdMenu_MdMenuItem = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26762702", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdMenu/MdMenuItem.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdMenuItem_default.a,
  MdMenu_MdMenuItem,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdMenu/MdMenuItem.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-26762702", Component.options)
  } else {
    hotAPI.reload("data-v-26762702", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdMenu_MdMenuItem = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdInteractionEvents = __webpack_require__(49);

var _MdInteractionEvents2 = _interopRequireDefault(_MdInteractionEvents);

var _MdListItem = __webpack_require__(48);

var _MdListItem2 = _interopRequireDefault(_MdListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdMenuItem',
  props: {
    disabled: Boolean
  },
  inject: ['MdMenu'],
  data: function data() {
    return {
      listeners: {},
      highlighted: false
    };
  },
  computed: {
    itemClasses: function itemClasses() {
      return {
        'md-highlight': this.highlighted
      };
    }
  },
  created: function created() {
    var _this = this;

    if (this.MdMenu.closeOnSelect) {
      var listenerNames = Object.keys(this.$listeners);
      var hasInteraction = false;

      listenerNames.forEach(function (listener) {
        if (_MdInteractionEvents2.default.includes(listener)) {
          _this.listeners[listener] = function ($event) {
            if (!_this.disabled) {
              _this.$listeners[listener]($event);
              _this.MdMenu.active = false;

              if (_this.MdMenu.eventObserver) {
                _this.MdMenu.eventObserver.destroy();
              }
            }
          };
        } else {
          _this.listeners[listener] = _this.$listeners[listener];
        }
      });
    } else {
      this.listeners = this.$listeners;
    }
  }
}); //
//
//
//
//
//

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdProgressBar = __webpack_require__(299);

var _MdProgressBar2 = _interopRequireDefault(_MdProgressBar);

var _MdProgressSpinner = __webpack_require__(302);

var _MdProgressSpinner2 = _interopRequireDefault(_MdProgressSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdProgressBar2.default.name, _MdProgressBar2.default);
  Vue.component(_MdProgressSpinner2.default.name, _MdProgressSpinner2.default);
};

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdProgress/MdProgressBar/MdProgressBar.vue
var MdProgressBar = __webpack_require__(301);
var MdProgressBar_default = /*#__PURE__*/__webpack_require__.n(MdProgressBar);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec82e758","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdProgress/MdProgressBar/MdProgressBar.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "md-progress-bar", appear: "" } }, [
    _c(
      "div",
      {
        staticClass: "md-progress-bar",
        class: [_vm.progressClasses, _vm.$mdActiveTheme]
      },
      [
        _c("div", {
          staticClass: "md-progress-bar-track",
          style: _vm.progressTrackStyle
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "md-progress-bar-fill",
          style: _vm.progressValueStyle
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "md-progress-bar-buffer",
          attrs: { Style: _vm.progressBufferStyle }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdProgressBar_MdProgressBar = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ec82e758", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdProgress/MdProgressBar/MdProgressBar.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(300)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdProgressBar_default.a,
  MdProgressBar_MdProgressBar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdProgress/MdProgressBar/MdProgressBar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ec82e758", Component.options)
  } else {
    hotAPI.reload("data-v-ec82e758", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdProgress_MdProgressBar_MdProgressBar = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdPropValidator = __webpack_require__(4);

var _MdPropValidator2 = _interopRequireDefault(_MdPropValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdProgressBar',
  props: {
    mdValue: {
      type: Number,
      default: 0
    },
    mdBuffer: {
      type: Number,
      default: 0
    },
    mdMode: _extends({
      type: String,
      default: 'determinate'
    }, (0, _MdPropValidator2.default)('md-mode', ['determinate', 'indeterminate', 'query', 'buffer']))
  },
  computed: {
    isDeterminate: function isDeterminate() {
      return this.mdMode === 'determinate';
    },
    isBuffer: function isBuffer() {
      return this.mdMode === 'buffer';
    },
    hasAmountFill: function hasAmountFill() {
      return this.isBuffer || this.isDeterminate;
    },
    progressClasses: function progressClasses() {
      return 'md-' + this.mdMode;
    },
    progressValueStyle: function progressValueStyle() {
      if (this.hasAmountFill) {
        return 'width: ' + this.mdValue + '%';
      }
    },
    progressTrackStyle: function progressTrackStyle() {
      if (this.hasAmountFill) {
        return 'width: ' + this.mdBuffer + '%';
      }
    },
    progressBufferStyle: function progressBufferStyle() {
      if (this.hasAmountFill) {
        return 'left: calc(' + this.mdBuffer + '% + 8px)';
      }
    }
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdProgress/MdProgressSpinner/MdProgressSpinner.vue
var MdProgressSpinner = __webpack_require__(304);
var MdProgressSpinner_default = /*#__PURE__*/__webpack_require__.n(MdProgressSpinner);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0abf13e0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdProgress/MdProgressSpinner/MdProgressSpinner.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "md-progress-spinner", appear: "" } },
    [
      _c(
        "div",
        {
          staticClass: "md-progress-spinner",
          class: [_vm.progressClasses, _vm.$mdActiveTheme]
        },
        [
          _c(
            "svg",
            {
              staticClass: "md-progress-spinner-draw",
              style: _vm.svgStyles,
              attrs: {
                preserveAspectRatio: "xMidYMid meet",
                focusable: "false",
                viewBox: "0 0 " + _vm.mdDiameter + " " + _vm.mdDiameter
              }
            },
            [
              _c("circle", {
                staticClass: "md-progress-spinner-circle",
                style: _vm.circleStyles,
                attrs: { cx: "50%", cy: "50%", r: _vm.circleRadius }
              })
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdProgressSpinner_MdProgressSpinner = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0abf13e0", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdProgress/MdProgressSpinner/MdProgressSpinner.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(303)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdProgressSpinner_default.a,
  MdProgressSpinner_MdProgressSpinner,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdProgress/MdProgressSpinner/MdProgressSpinner.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0abf13e0", Component.options)
  } else {
    hotAPI.reload("data-v-0abf13e0", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var MdProgress_MdProgressSpinner_MdProgressSpinner = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdPropValidator = __webpack_require__(4);

var _MdPropValidator2 = _interopRequireDefault(_MdPropValidator);

var _MdProgressSpinnerAnimation = __webpack_require__(305);

var _MdProgressSpinnerAnimation2 = _interopRequireDefault(_MdProgressSpinnerAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MdProgressSpinner = {
  styleTag: null,
  diameters: new Set()
};

exports.default = new _MdComponent2.default({
  name: 'MdProgressSpinner',
  props: {
    mdValue: {
      type: Number,
      default: 0
    },
    mdDiameter: {
      type: Number,
      default: 60
    },
    mdStroke: {
      type: Number,
      default: 6
    },
    mdMode: _extends({
      type: String,
      default: 'determinate'
    }, (0, _MdPropValidator2.default)('md-mode', ['determinate', 'indeterminate']))
  },
  computed: {
    isDeterminate: function isDeterminate() {
      return this.mdMode === 'determinate';
    },
    isIndeterminate: function isIndeterminate() {
      return this.mdMode === 'indeterminate';
    },
    isIE: function isIE() {
      return navigator.userAgent.toLowerCase().includes('trident');
    },
    progressClasses: function progressClasses() {
      var _ref;

      var animationClass = 'md-progress-spinner-indeterminate';

      if (this.isIE) {
        animationClass += '-fallback';
      }

      return _ref = {}, _defineProperty(_ref, animationClass, true), _defineProperty(_ref, 'md-' + this.mdMode, true), _ref;
    },
    svgStyles: function svgStyles() {
      var size = this.mdDiameter + 'px';

      return {
        width: size,
        height: size
      };
    },
    circleStyles: function circleStyles() {
      return {
        'stroke-dashoffset': this.circleStrokeDashOffset,
        'stroke-dasharray': this.circleStrokeDashArray,
        'stroke-width': this.circleStrokeWidth,
        'animation-name': 'md-progress-spinner-stroke-rotate-' + this.mdDiameter
      };
    },
    circleRadius: function circleRadius() {
      return (this.mdDiameter - this.mdStroke) / 2;
    },
    circleStrokeWidth: function circleStrokeWidth() {
      return this.mdStroke + 'px';
    },
    circleCircumference: function circleCircumference() {
      return 2 * Math.PI * this.circleRadius;
    },
    circleStrokeDashArray: function circleStrokeDashArray() {
      return this.circleCircumference + 'px';
    },
    circleStrokeDashOffset: function circleStrokeDashOffset() {
      if (this.isDeterminate) {
        return this.circleCircumference * (100 - this.mdValue) / 100 + 'px';
      }

      if (this.isIndeterminate && this.isIE) {
        return this.circleCircumference * 0.2 + 'px';
      }

      return null;
    }
  },
  watch: {
    mdDiameter: function mdDiameter() {
      this.attachStyleTag();
    }
  },
  methods: {
    getAnimationCSS: function getAnimationCSS() {
      return _MdProgressSpinnerAnimation2.default.replace(/START_VALUE/g, '' + 0.95 * this.circleCircumference).replace(/END_VALUE/g, '' + 0.2 * this.circleCircumference).replace(/DIAMETER/g, '' + this.mdDiameter);
    },
    attachStyleTag: function attachStyleTag() {
      var styleTag = MdProgressSpinner.styleTag;

      if (!styleTag) {
        styleTag = document.getElementById('md-progress-spinner-styles');
      }

      if (!styleTag) {
        styleTag = document.createElement('style');

        styleTag.id = 'md-progress-spinner-styles';
        document.head.appendChild(styleTag);
        MdProgressSpinner.styleTag = styleTag;
      }

      if (styleTag && styleTag.sheet) {
        styleTag.sheet.insertRule(this.getAnimationCSS(), 0);
      }

      MdProgressSpinner.diameters.add(this.mdDiameter);
    }
  },
  mounted: function mounted() {
    this.attachStyleTag();
  }
});

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = "\n  @keyframes md-progress-spinner-stroke-rotate-DIAMETER {\n    0% {\n      stroke-dashoffset: START_VALUE;\n      transform: rotate(0);\n    }\n\n    12.5% {\n      stroke-dashoffset: END_VALUE;\n      transform: rotate(0);\n    }\n\n    12.51% {\n      stroke-dashoffset: END_VALUE;\n      transform: rotateX(180deg) rotate(72.5deg);\n    }\n\n    25% {\n      stroke-dashoffset: START_VALUE;\n      transform: rotateX(180deg) rotate(72.5deg);\n    }\n\n    25.1% {\n      stroke-dashoffset: START_VALUE;\n      transform: rotate(270deg);\n    }\n\n    37.5% {\n      stroke-dashoffset: END_VALUE;\n      transform: rotate(270deg);\n    }\n\n    37.51% {\n      stroke-dashoffset: END_VALUE;\n      transform: rotateX(180deg) rotate(161.5deg);\n    }\n\n    50% {\n      stroke-dashoffset: START_VALUE;\n      transform: rotateX(180deg) rotate(161.5deg);\n    }\n\n    50.01% {\n      stroke-dashoffset: START_VALUE;\n      transform: rotate(180deg);\n    }\n\n    62.5% {\n      stroke-dashoffset: END_VALUE;\n      transform: rotate(180deg);\n    }\n\n    62.51% {\n      stroke-dashoffset: END_VALUE;\n      transform: rotateX(180deg) rotate(251.5deg);\n    }\n\n    75% {\n      stroke-dashoffset: START_VALUE;\n      transform: rotateX(180deg) rotate(251.5deg);\n    }\n\n    75.01% {\n      stroke-dashoffset: START_VALUE;\n      transform: rotate(90deg);\n    }\n\n    87.5% {\n      stroke-dashoffset: END_VALUE;\n      transform: rotate(90deg);\n    }\n\n    87.51% {\n      stroke-dashoffset: END_VALUE;\n      transform: rotateX(180deg) rotate(341.5deg);\n    }\n\n    100% {\n      stroke-dashoffset: START_VALUE;\n      transform: rotateX(180deg) rotate(341.5deg);\n    }\n  }\n";

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdRadio = __webpack_require__(307);

var _MdRadio2 = _interopRequireDefault(_MdRadio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdRadio2.default.name, _MdRadio2.default);
};

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdRadio/MdRadio.vue
var MdRadio = __webpack_require__(309);
var MdRadio_default = /*#__PURE__*/__webpack_require__.n(MdRadio);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5b900ce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdRadio/MdRadio.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-radio", class: [_vm.$mdActiveTheme, _vm.radioClasses] },
    [
      _c(
        "div",
        {
          staticClass: "md-radio-container",
          on: {
            click: function($event) {
              $event.stopPropagation()
              _vm.toggleCheck($event)
            }
          }
        },
        [
          _c(
            "md-ripple",
            {
              attrs: {
                "md-centered": "",
                "md-active": _vm.rippleActive,
                "md-disabled": _vm.disabled
              },
              on: {
                "update:mdActive": function($event) {
                  _vm.rippleActive = $event
                }
              }
            },
            [
              _c(
                "input",
                _vm._b(
                  { attrs: { type: "radio" } },
                  "input",
                  {
                    id: _vm.id,
                    name: _vm.name,
                    disabled: _vm.disabled,
                    required: _vm.required,
                    value: _vm.value
                  },
                  false
                )
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.$slots.default
        ? _c(
            "label",
            {
              staticClass: "md-radio-label",
              attrs: { for: _vm.id },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.toggleCheck($event)
                }
              }
            },
            [_vm._t("default")],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdRadio_MdRadio = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b5b900ce", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdRadio/MdRadio.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(308)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdRadio_default.a,
  MdRadio_MdRadio,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdRadio/MdRadio.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b5b900ce", Component.options)
  } else {
    hotAPI.reload("data-v-b5b900ce", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdRadio_MdRadio = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdUuid = __webpack_require__(6);

var _MdUuid2 = _interopRequireDefault(_MdUuid);

var _MdRipple = __webpack_require__(8);

var _MdRipple2 = _interopRequireDefault(_MdRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdRadio',
  components: {
    MdRipple: _MdRipple2.default
  },
  props: {
    model: [String, Number, Boolean],
    value: {
      type: [String, Number, Boolean],
      default: 'on'
    },
    id: {
      type: String,
      default: function _default() {
        return 'md-radio-' + (0, _MdUuid2.default)();
      }
    },
    name: [String, Number],
    required: Boolean,
    disabled: Boolean
  },
  model: {
    prop: 'model',
    event: 'change'
  },
  data: function data() {
    return {
      rippleActive: false
    };
  },
  computed: {
    isSelected: function isSelected() {
      return this.model === this.value;
    },
    radioClasses: function radioClasses() {
      return {
        'md-checked': this.isSelected,
        'md-disabled': this.disabled,
        'md-required': this.required
      };
    }
  },
  methods: {
    toggleCheck: function toggleCheck() {
      if (!this.disabled) {
        this.rippleActive = true;
        this.$emit('change', this.value);
      }
    }
  }
}); //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdRipple = __webpack_require__(8);

var _MdRipple2 = _interopRequireDefault(_MdRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdRipple2.default.name, _MdRipple2.default);
};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdSnackbar = __webpack_require__(312);

var _MdSnackbar2 = _interopRequireDefault(_MdSnackbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdSnackbar2.default.name, _MdSnackbar2.default);
};

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdSnackbar/MdSnackbar.vue
var MdSnackbar = __webpack_require__(314);
var MdSnackbar_default = /*#__PURE__*/__webpack_require__.n(MdSnackbar);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7063bc8f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdSnackbar/MdSnackbar.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mdPersistent && _vm.mdDuration !== Infinity
    ? _c(
        "md-portal",
        [
          _c(
            "keep-alive",
            [
              _vm.mdActive
                ? _c(
                    "md-snackbar-content",
                    {
                      attrs: {
                        "md-classes": [_vm.snackbarClasses, _vm.$mdActiveTheme]
                      }
                    },
                    [_vm._t("default")],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _c(
        "md-portal",
        [
          _vm.mdActive
            ? _c(
                "md-snackbar-content",
                {
                  attrs: {
                    "md-classes": [_vm.snackbarClasses, _vm.$mdActiveTheme]
                  }
                },
                [_vm._t("default")],
                2
              )
            : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdSnackbar_MdSnackbar = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7063bc8f", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdSnackbar/MdSnackbar.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(313)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdSnackbar_default.a,
  MdSnackbar_MdSnackbar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdSnackbar/MdSnackbar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7063bc8f", Component.options)
  } else {
    hotAPI.reload("data-v-7063bc8f", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdSnackbar_MdSnackbar = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdPropValidator = __webpack_require__(4);

var _MdPropValidator2 = _interopRequireDefault(_MdPropValidator);

var _MdPortal = __webpack_require__(16);

var _MdPortal2 = _interopRequireDefault(_MdPortal);

var _MdSnackbarContent = __webpack_require__(315);

var _MdSnackbarContent2 = _interopRequireDefault(_MdSnackbarContent);

var _MdSnackbarQueue = __webpack_require__(317);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = new _MdComponent2.default({
  name: 'MdSnackbar',
  components: {
    MdPortal: _MdPortal2.default,
    MdSnackbarContent: _MdSnackbarContent2.default
  },
  props: {
    mdActive: Boolean,
    mdPersistent: Boolean,
    mdDuration: {
      type: Number,
      default: 4000
    },
    mdPosition: _extends({
      type: String,
      default: 'center'
    }, (0, _MdPropValidator2.default)('md-position', ['center', 'left']))
  },
  computed: {
    snackbarClasses: function snackbarClasses() {
      return _defineProperty({}, 'md-position-' + this.mdPosition, true);
    }
  },
  watch: {
    mdActive: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(isActive) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!isActive) {
                  _context.next = 7;
                  break;
                }

                _context.next = 3;
                return (0, _MdSnackbarQueue.createSnackbar)(this.mdDuration, this);

              case 3:

                this.$emit('update:mdActive', false);
                this.$emit('md-opened');
                _context.next = 9;
                break;

              case 7:
                (0, _MdSnackbarQueue.destroySnackbar)();
                this.$emit('md-closed');

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mdActive(_x) {
        return _ref2.apply(this, arguments);
      }

      return mdActive;
    }()
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdSnackbar/MdSnackbarContent.vue
var MdSnackbarContent = __webpack_require__(316);
var MdSnackbarContent_default = /*#__PURE__*/__webpack_require__.n(MdSnackbarContent);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffe066cc","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdSnackbar/MdSnackbarContent.vue
var render = function(_h, _vm) {
  var _c = _vm._c
  return _c("transition", { attrs: { name: "md-snackbar", appear: "" } }, [
    _c("div", { staticClass: "md-snackbar", class: _vm.props.mdClasses }, [
      _c("div", { staticClass: "md-snackbar-content" }, [_vm._t("default")], 2)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdSnackbar_MdSnackbarContent = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ffe066cc", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdSnackbar/MdSnackbarContent.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = true
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdSnackbarContent_default.a,
  MdSnackbar_MdSnackbarContent,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdSnackbar/MdSnackbarContent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ffe066cc", Component.options)
  } else {
    hotAPI.rerender("data-v-ffe066cc", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdSnackbar_MdSnackbarContent = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'MdSnackbarContent',
  props: {
    mdClasses: Array
  }
};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var currentSnackbar = null;
var timeout = null;

function createPromise(duration, context) {
  return new Promise(function (resolve) {
    currentSnackbar = {
      destroy: function destroy() {
        currentSnackbar = null;
        resolve();
      }
    };

    if (duration !== Infinity) {
      timeout = window.setTimeout(function () {
        destroySnackbar();
        context._vnode.componentInstance.initDestroy(true);
      }, duration);
    }
  });
}

var destroySnackbar = exports.destroySnackbar = function destroySnackbar() {
  return new Promise(function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (currentSnackbar) {
                window.clearTimeout(timeout);
                currentSnackbar.destroy();
                window.setTimeout(resolve, 400);
              } else {
                resolve();
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
};

var createSnackbar = exports.createSnackbar = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(duration, context) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!currentSnackbar) {
              _context2.next = 4;
              break;
            }

            _context2.next = 3;
            return destroySnackbar();

          case 3:
            return _context2.abrupt("return", createPromise(duration, context));

          case 4:
            return _context2.abrupt("return", createPromise(duration, context));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function createSnackbar(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdSpeedDial = __webpack_require__(319);

var _MdSpeedDial2 = _interopRequireDefault(_MdSpeedDial);

var _MdSpeedDialTarget = __webpack_require__(322);

var _MdSpeedDialTarget2 = _interopRequireDefault(_MdSpeedDialTarget);

var _MdSpeedDialContent = __webpack_require__(325);

var _MdSpeedDialContent2 = _interopRequireDefault(_MdSpeedDialContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdSpeedDial2.default.name, _MdSpeedDial2.default);
  Vue.component(_MdSpeedDialTarget2.default.name, _MdSpeedDialTarget2.default);
  Vue.component(_MdSpeedDialContent2.default.name, _MdSpeedDialContent2.default);
};

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdSpeedDial/MdSpeedDial.vue
var MdSpeedDial = __webpack_require__(321);
var MdSpeedDial_default = /*#__PURE__*/__webpack_require__.n(MdSpeedDial);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-470f76d1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdSpeedDial/MdSpeedDial.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "md-speed-dial",
      class: [_vm.$mdActiveTheme, _vm.speedDialClasses]
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdSpeedDial_MdSpeedDial = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-470f76d1", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdSpeedDial/MdSpeedDial.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(320)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdSpeedDial_default.a,
  MdSpeedDial_MdSpeedDial,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdSpeedDial/MdSpeedDial.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-470f76d1", Component.options)
  } else {
    hotAPI.reload("data-v-470f76d1", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdSpeedDial_MdSpeedDial = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdPropValidator = __webpack_require__(4);

var _MdPropValidator2 = _interopRequireDefault(_MdPropValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = new _MdComponent2.default({
  name: 'MdSpeedDial',
  props: {
    mdEvent: _extends({
      type: String,
      default: 'hover'
    }, (0, _MdPropValidator2.default)('md-event', ['click', 'hover'])),
    mdDirection: _extends({
      type: String,
      default: 'top'
    }, (0, _MdPropValidator2.default)('md-direction', ['top', 'bottom'])),
    mdEffect: _extends({
      type: String,
      default: 'fling'
    }, (0, _MdPropValidator2.default)('md-effect', ['fling', 'scale', 'opacity']))
  },
  data: function data() {
    return {
      MdSpeedDial: {
        active: false,
        event: this.mdEvent,
        direction: this.mdDirection
      }
    };
  },
  provide: function provide() {
    return {
      MdSpeedDial: this.MdSpeedDial
    };
  },

  computed: {
    speedDialClasses: function speedDialClasses() {
      var _ref;

      return _ref = {
        'md-active': this.MdSpeedDial.active,
        'md-with-hover': this.mdEvent === 'hover'
      }, _defineProperty(_ref, 'md-direction-' + this.mdDirection, true), _defineProperty(_ref, 'md-effect-' + this.mdEffect, true), _ref;
    }
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdSpeedDial/MdSpeedDialTarget.vue
var MdSpeedDialTarget = __webpack_require__(324);
var MdSpeedDialTarget_default = /*#__PURE__*/__webpack_require__.n(MdSpeedDialTarget);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-654a757c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdSpeedDial/MdSpeedDialTarget.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-button",
    _vm._g(
      _vm._b(
        {
          staticClass: "md-speed-dial-target md-fab",
          on: { click: _vm.handleClick }
        },
        "md-button",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdSpeedDial_MdSpeedDialTarget = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-654a757c", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdSpeedDial/MdSpeedDialTarget.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(323)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdSpeedDialTarget_default.a,
  MdSpeedDial_MdSpeedDialTarget,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdSpeedDial/MdSpeedDialTarget.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-654a757c", Component.options)
  } else {
    hotAPI.reload("data-v-654a757c", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdSpeedDial_MdSpeedDialTarget = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdButton = __webpack_require__(13);

var _MdButton2 = _interopRequireDefault(_MdButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdSpeedDialTarget',
  components: {
    MdButton: _MdButton2.default
  },
  inject: ['MdSpeedDial'],
  methods: {
    handleClick: function handleClick() {
      if (this.MdSpeedDial.event === 'click') {
        this.MdSpeedDial.active = !this.MdSpeedDial.active;
      }
    }
  }
}; //
//
//
//
//
//

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdSpeedDial/MdSpeedDialContent.vue
var MdSpeedDialContent = __webpack_require__(327);
var MdSpeedDialContent_default = /*#__PURE__*/__webpack_require__.n(MdSpeedDialContent);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ac6418","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdSpeedDial/MdSpeedDialContent.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-speed-dial-content" },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdSpeedDial_MdSpeedDialContent = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45ac6418", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdSpeedDial/MdSpeedDialContent.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(326)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdSpeedDialContent_default.a,
  MdSpeedDial_MdSpeedDialContent,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdSpeedDial/MdSpeedDialContent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-45ac6418", Component.options)
  } else {
    hotAPI.reload("data-v-45ac6418", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdSpeedDial_MdSpeedDialContent = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//

function getChildIndex(direction, index, count) {
  if (direction === 'top') {
    return count - index - 1;
  }

  return index;
}

exports.default = {
  name: 'MdSpeedDialContent',
  inject: ['MdSpeedDial'],
  methods: {
    setChildrenIndexes: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var countChild;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$nextTick();

              case 2:
                countChild = this.$children.length;


                this.$children.forEach(function (child, index) {
                  if (child._vnode.tag === 'button') {
                    var childIndex = getChildIndex(_this.MdSpeedDial.direction, index, countChild);

                    child.$el.setAttribute('md-button-index', childIndex);
                    child.$el.classList.add('md-raised');
                  }
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setChildrenIndexes() {
        return _ref.apply(this, arguments);
      }

      return setChildrenIndexes;
    }()
  },
  mounted: function mounted() {
    this.setChildrenIndexes();
  },
  updated: function updated() {
    this.setChildrenIndexes();
  }
};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdSteppers = __webpack_require__(329);

var _MdSteppers2 = _interopRequireDefault(_MdSteppers);

var _MdStep = __webpack_require__(339);

var _MdStep2 = _interopRequireDefault(_MdStep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdSteppers2.default.name, _MdSteppers2.default);
  Vue.component(_MdStep2.default.name, _MdStep2.default);
};

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdSteppers/MdSteppers.vue
var MdSteppers = __webpack_require__(331);
var MdSteppers_default = /*#__PURE__*/__webpack_require__.n(MdSteppers);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95acb722","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdSteppers/MdSteppers.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "md-steppers",
      class: [_vm.steppersClasses, _vm.$mdActiveTheme]
    },
    [
      !_vm.mdVertical
        ? _c(
            "div",
            { staticClass: "md-steppers-navigation" },
            _vm._l(_vm.MdSteppers.items, function(_, index) {
              return _c("md-step-header", {
                key: index,
                attrs: { index: index }
              })
            })
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "md-steppers-wrapper", style: _vm.contentStyles },
        [
          _c(
            "div",
            {
              staticClass: "md-steppers-container",
              style: _vm.containerStyles
            },
            [_vm._t("default")],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdSteppers_MdSteppers = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-95acb722", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdSteppers/MdSteppers.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(330)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdSteppers_default.a,
  MdSteppers_MdSteppers,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdSteppers/MdSteppers.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-95acb722", Component.options)
  } else {
    hotAPI.reload("data-v-95acb722", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdSteppers_MdSteppers = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdObserveElement = __webpack_require__(26);

var _MdObserveElement2 = _interopRequireDefault(_MdObserveElement);

var _MdStepHeader = __webpack_require__(50);

var _MdStepHeader2 = _interopRequireDefault(_MdStepHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = new _MdComponent2.default({
  name: 'MdSteppers',
  components: {
    MdStepHeader: _MdStepHeader2.default
  },
  props: {
    mdSyncRoute: Boolean,
    mdDynamicHeight: Boolean,
    mdVertical: Boolean,
    mdLinear: Boolean,
    mdAlternative: Boolean,
    mdActiveStep: [String, Number]
  },
  data: function data() {
    return {
      activeStepIndex: 0,
      noTransition: true,
      containerStyles: {},
      contentStyles: {},
      MdSteppers: {
        activeStep: 0,
        isLinear: false,
        isVertical: false,
        items: {}
      }
    };
  },
  provide: function provide() {
    var MdSteppers = this.MdSteppers;

    MdSteppers.getStepperNumber = this.getStepperNumber;
    MdSteppers.setActiveStep = this.setActiveStep;
    MdSteppers.isPreviousStepperDone = this.isPreviousStepperDone;

    return { MdSteppers: MdSteppers };
  },

  computed: {
    steppersClasses: function steppersClasses() {
      return {
        'md-no-transition': this.noTransition,
        'md-alternative': this.mdAlternative,
        'md-horizontal': !this.mdVertical,
        'md-vertical': this.mdVertical,
        'md-dynamic-height': this.mdDynamicHeight
      };
    },
    activeIndex: function activeIndex() {
      return this.MdSteppers.activeStep;
    }
  },
  watch: {
    mdActiveStep: function mdActiveStep(stepper) {
      this.MdSteppers.activeStep = stepper;
      this.$emit('md-changed', stepper);
    },
    mdLinear: function mdLinear(isLinear) {
      this.MdSteppers.isLinear = isLinear;
    },
    mdVertical: function mdVertical(isVertical) {
      this.MdSteppers.isVertical = isVertical;
    },
    activeIndex: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$nextTick();

              case 2:
                this.setActiveStepIndex();
                this.calculateStepperPos();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function activeIndex() {
        return _ref.apply(this, arguments);
      }

      return activeIndex;
    }()
  },
  methods: {
    hasActiveStep: function hasActiveStep() {
      return this.MdSteppers.activeStep || this.mdActiveStep;
    },
    getItemsAndKeys: function getItemsAndKeys() {
      var items = this.MdSteppers.items;

      return {
        items: items,
        keys: Object.keys(items)
      };
    },
    getStepperNumber: function getStepperNumber(id) {
      var stepperNames = Object.keys(this.MdSteppers.items);

      return stepperNames.indexOf(id) + 1;
    },
    isStepperDone: function isStepperDone(id) {
      return this.MdSteppers.items[id].done;
    },
    isPreviousStepperDone: function isPreviousStepperDone(id) {
      var items = this.MdSteppers.items;

      var stepperNames = Object.keys(items);
      var activeIndex = this.getStepperNumber(id) - 2;
      var previousIndex = stepperNames[activeIndex];

      if (!previousIndex) {
        return true;
      }

      return items[previousIndex].done;
    },
    isStepperEditable: function isStepperEditable(id) {
      return this.MdSteppers.items[id].editable;
    },
    setStepperAsDone: function setStepperAsDone(id) {
      this.MdSteppers.items[id].done = true;
    },
    setPreviousStepperAsDone: function setPreviousStepperAsDone(newId) {
      var activeIndex = this.getStepperNumber(this.MdSteppers.activeStep);
      var newIndex = this.getStepperNumber(newId);

      if (newIndex > activeIndex) {
        this.setStepperAsDone(this.MdSteppers.activeStep);
      }
    },
    setActiveStep: function setActiveStep(id) {
      if (this.mdLinear && !this.isPreviousStepperDone(id)) {
        return false;
      }

      if (id !== this.MdSteppers.activeStep && (this.isStepperEditable(id) || !this.isStepperDone(id))) {
        this.setPreviousStepperAsDone(id);
        this.MdSteppers.activeStep = id;
        this.$emit('md-changed', id);
        this.$emit('update:mdActiveStep', id);
        this.MdSteppers.items[id].error = null;
      }
    },
    setActiveStepIndex: function setActiveStepIndex() {
      var activeButton = this.$el.querySelector('.md-button.md-active');

      if (activeButton) {
        this.activeStepIndex = [].indexOf.call(activeButton.parentNode.childNodes, activeButton);
      }
    },
    setActiveStepByIndex: function setActiveStepByIndex(index) {
      var _getItemsAndKeys = this.getItemsAndKeys(),
          keys = _getItemsAndKeys.keys;

      if (!this.hasActiveStep()) {
        this.MdSteppers.activeStep = keys[index];
      }
    },
    setActiveStepByRoute: function setActiveStepByRoute() {
      var _this = this;

      var _getItemsAndKeys2 = this.getItemsAndKeys(),
          items = _getItemsAndKeys2.items,
          keys = _getItemsAndKeys2.keys;

      var stepperIndex = null;

      if (this.$router) {
        keys.forEach(function (key, index) {
          var item = items[key];
          var toProp = item.props.to;

          if (toProp && toProp === _this.$route.path) {
            stepperIndex = index;
          }
        });
      }

      if (!this.hasActiveStep() && !stepperIndex) {
        this.MdSteppers.activeStep = keys[0];
      } else {
        this.MdSteppers.activeStep = keys[stepperIndex];

        for (var i = 0; i < stepperIndex; i++) {
          this.setStepperAsDone(keys[i]);
        }
      }
    },
    setupObservers: function setupObservers() {
      var steppersContent = this.$el.querySelector('.md-steppers-wrapper');

      if ('ResizeObserver' in window) {
        this.resizeObserver = new window.ResizeObserver(this.calculateStepperPos);
        this.resizeObserver.observe(this.$el);
      }

      if (steppersContent) {
        this.resizeObserver = (0, _MdObserveElement2.default)(this.$el.querySelector('.md-steppers-wrapper'), {
          childList: true,
          characterData: true,
          subtree: true
        }, this.calculateStepperPos);
      }
    },
    calculateStepperPos: function calculateStepperPos() {
      if (!this.mdVertical) {
        var stepperElement = this.$el.querySelector('.md-stepper:nth-child(' + (this.activeStepIndex + 1) + ')');

        this.contentStyles = {
          height: stepperElement.offsetHeight + 'px'
        };

        this.containerStyles = {
          transform: 'translate3D(' + -this.activeStepIndex * 100 + '%, 0, 0)'
        };
      }
    },
    setupWatchers: function setupWatchers() {
      if (this.mdSyncRoute) {
        this.$watch('$route', {
          deep: true,
          handler: function handler() {
            this.setActiveStepByRoute();
          }
        });
      }
    }
  },
  created: function created() {
    this.MdSteppers.activeStep = this.mdActiveStep;
    this.MdSteppers.isLinear = this.mdLinear;
    this.MdSteppers.isVertical = this.mdVertical;
  },
  mounted: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this2 = this;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.$nextTick();

            case 2:

              if (this.mdSyncRoute) {
                this.setActiveStepByRoute();
              } else {
                this.setActiveStepByIndex(0);
              }

              _context2.next = 5;
              return this.$nextTick();

            case 5:

              this.setActiveStepIndex();
              this.calculateStepperPos();

              window.setTimeout(function () {
                _this2.noTransition = false;
                _this2.setupObservers();
                _this2.setupWatchers();
              }, 100);

            case 8:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _ref2.apply(this, arguments);
    }

    return mounted;
  }()
});

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdWarningIcon = __webpack_require__(333);

var _MdWarningIcon2 = _interopRequireDefault(_MdWarningIcon);

var _MdCheckIcon = __webpack_require__(335);

var _MdCheckIcon2 = _interopRequireDefault(_MdCheckIcon);

var _MdEditIcon = __webpack_require__(337);

var _MdEditIcon2 = _interopRequireDefault(_MdEditIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdStepperHeader',
  components: {
    MdWarningIcon: _MdWarningIcon2.default,
    MdCheckIcon: _MdCheckIcon2.default,
    MdEditIcon: _MdEditIcon2.default
  },
  props: {
    index: {
      type: String,
      required: true
    }
  },
  inject: ['MdSteppers'],
  computed: {
    data: function data() {
      return this.MdSteppers.items[this.index];
    },
    shouldDisable: function shouldDisable() {
      var data = this.data,
          index = this.index,
          MdSteppers = this.MdSteppers;


      if (data.done && !data.editable) {
        return true;
      }

      return MdSteppers.isLinear && !MdSteppers.isPreviousStepperDone(index);
    },
    classes: function classes() {
      return {
        'md-active': this.index === this.MdSteppers.activeStep,
        'md-error': this.data.error,
        'md-done': this.data.done
      };
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/core/icons/MdWarningIcon.vue
var MdWarningIcon = __webpack_require__(334);
var MdWarningIcon_default = /*#__PURE__*/__webpack_require__.n(MdWarningIcon);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8993dc9c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/core/icons/MdWarningIcon.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("md-icon", { staticClass: "md-icon-image" }, [
      _c(
        "svg",
        {
          attrs: {
            height: "24",
            viewBox: "0 0 24 24",
            width: "24",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("path", { attrs: { d: "M0 0h24v24H0z", fill: "none" } }),
          _vm._v(" "),
          _c("path", {
            attrs: { d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" }
          })
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var icons_MdWarningIcon = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8993dc9c", esExports)
  }
}
// CONCATENATED MODULE: ./src/core/icons/MdWarningIcon.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdWarningIcon_default.a,
  icons_MdWarningIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/core/icons/MdWarningIcon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8993dc9c", Component.options)
  } else {
    hotAPI.reload("data-v-8993dc9c", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var core_icons_MdWarningIcon = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdIcon = __webpack_require__(5);

var _MdIcon2 = _interopRequireDefault(_MdIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdWarningIcon',
  components: {
    MdIcon: _MdIcon2.default
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/core/icons/MdCheckIcon.vue
var MdCheckIcon = __webpack_require__(336);
var MdCheckIcon_default = /*#__PURE__*/__webpack_require__.n(MdCheckIcon);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4154b05e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/core/icons/MdCheckIcon.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("md-icon", { staticClass: "md-icon-image" }, [
      _c(
        "svg",
        {
          attrs: {
            height: "24",
            viewBox: "0 0 24 24",
            width: "24",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("path", { attrs: { d: "M0 0h24v24H0z", fill: "none" } }),
          _vm._v(" "),
          _c("path", {
            attrs: { d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" }
          })
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var icons_MdCheckIcon = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4154b05e", esExports)
  }
}
// CONCATENATED MODULE: ./src/core/icons/MdCheckIcon.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdCheckIcon_default.a,
  icons_MdCheckIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/core/icons/MdCheckIcon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4154b05e", Component.options)
  } else {
    hotAPI.reload("data-v-4154b05e", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var core_icons_MdCheckIcon = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdIcon = __webpack_require__(5);

var _MdIcon2 = _interopRequireDefault(_MdIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdDoneIcon',
  components: {
    MdIcon: _MdIcon2.default
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/core/icons/MdEditIcon.vue
var MdEditIcon = __webpack_require__(338);
var MdEditIcon_default = /*#__PURE__*/__webpack_require__.n(MdEditIcon);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75d6b514","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/core/icons/MdEditIcon.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("md-icon", { staticClass: "md-icon-image" }, [
      _c(
        "svg",
        {
          attrs: {
            height: "24",
            viewBox: "0 0 24 24",
            width: "24",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
            }
          }),
          _vm._v(" "),
          _c("path", { attrs: { d: "M0 0h24v24H0z", fill: "none" } })
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var icons_MdEditIcon = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75d6b514", esExports)
  }
}
// CONCATENATED MODULE: ./src/core/icons/MdEditIcon.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdEditIcon_default.a,
  icons_MdEditIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/core/icons/MdEditIcon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-75d6b514", Component.options)
  } else {
    hotAPI.reload("data-v-75d6b514", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var core_icons_MdEditIcon = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdIcon = __webpack_require__(5);

var _MdIcon2 = _interopRequireDefault(_MdIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdEditIcon',
  components: {
    MdIcon: _MdIcon2.default
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdSteppers/MdStep.vue
var MdStep = __webpack_require__(341);
var MdStep_default = /*#__PURE__*/__webpack_require__.n(MdStep);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8624960e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdSteppers/MdStep.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-stepper" },
    [
      _vm.MdSteppers.isVertical
        ? _c("md-step-header", { attrs: { index: _vm.id } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "md-stepper-content",
          class: { "md-active": _vm.id === _vm.MdSteppers.activeStep }
        },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdSteppers_MdStep = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8624960e", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdSteppers/MdStep.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(340)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdStep_default.a,
  MdSteppers_MdStep,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdSteppers/MdStep.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8624960e", Component.options)
  } else {
    hotAPI.reload("data-v-8624960e", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdSteppers_MdStep = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//

var _MdUuid = __webpack_require__(6);

var _MdUuid2 = _interopRequireDefault(_MdUuid);

var _MdStepHeader = __webpack_require__(50);

var _MdStepHeader2 = _interopRequireDefault(_MdStepHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdStep',
  components: {
    MdStepHeader: _MdStepHeader2.default
  },
  props: {
    id: {
      type: String,
      default: function _default() {
        return 'md-stepper-' + (0, _MdUuid2.default)();
      }
    },
    href: [String, Number],
    to: null,
    mdLabel: String,
    mdDescription: String,
    mdError: String,
    mdDone: Boolean,
    mdEditable: {
      type: Boolean,
      default: true
    }
  },
  inject: ['MdSteppers'],
  watch: {
    $props: {
      deep: true,
      handler: function handler() {
        this.setStepperData();
      }
    }
  },
  methods: {
    getPropValues: function getPropValues() {
      var _this = this;

      var propNames = Object.keys(this.$options.props);
      var ignoredProps = ['id', 'mdLabel', 'mdDescription', 'mdError', 'mdEditable'];
      var values = {};

      propNames.forEach(function (prop) {
        if (!ignoredProps.includes(prop)) {
          if (_this[prop]) {
            values[prop] = _this[prop];
          } else if (_this.$attrs.hasOwnProperty(prop)) {
            if (prop) {
              values[prop] = _this.$attrs[prop];
            } else {
              values[prop] = true;
            }
          }
        }
      });

      return values;
    },
    setStepperData: function setStepperData() {
      this.$set(this.MdSteppers.items, this.id, {
        label: this.mdLabel,
        description: this.mdDescription,
        error: this.mdError,
        done: this.mdDone,
        editable: this.mdEditable,
        props: this.getPropValues(),
        events: this.$listeners
      });
    },
    setupWatchers: function setupWatchers() {
      var _this2 = this;

      var getProp = function getProp(prop) {
        if (_this2.MdSteppers.items[_this2.id]) {
          return _this2.MdSteppers.items[_this2.id][prop];
        }
      };

      this.$watch(function () {
        return getProp('error');
      }, function () {
        return _this2.$emit('update:mdError', getProp('error'));
      });

      this.$watch(function () {
        return getProp('done');
      }, function () {
        return _this2.$emit('update:mdDone', getProp('done'));
      });
    }
  },
  created: function created() {
    this.setStepperData();
    this.setupWatchers();
  },
  beforeDestroy: function beforeDestroy() {
    this.$delete(this.MdSteppers.items, this.id);
  },
  render: function render(createElement) {
    var stepperAttrs = {
      staticClass: 'md-stepper',
      attrs: _extends({}, this.$attrs, {
        id: this.id
      }),
      on: this.$listeners
    };

    if (this.href) {
      this.buttonProps = this.$options.props;
    } else if (this.$router && this.to) {
      this.$options.props = MdRouterLinkProps(this, this.$options.props);

      stepperAttrs.props = this.$props;
    }

    return createElement('div', stepperAttrs, this.$slots.default);
  }
};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdSubheader = __webpack_require__(343);

var _MdSubheader2 = _interopRequireDefault(_MdSubheader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdSubheader2.default.name, _MdSubheader2.default);
};

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdSubheader/MdSubheader.vue
var MdSubheader = __webpack_require__(345);
var MdSubheader_default = /*#__PURE__*/__webpack_require__.n(MdSubheader);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ff30e86","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdSubheader/MdSubheader.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.insideList
    ? _c(
        "li",
        { staticClass: "md-subheader", class: [_vm.$mdActiveTheme] },
        [_vm._t("default")],
        2
      )
    : _c(
        "div",
        { staticClass: "md-subheader", class: [_vm.$mdActiveTheme] },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdSubheader_MdSubheader = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ff30e86", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdSubheader/MdSubheader.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(344)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdSubheader_default.a,
  MdSubheader_MdSubheader,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdSubheader/MdSubheader.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ff30e86", Component.options)
  } else {
    hotAPI.reload("data-v-7ff30e86", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdSubheader_MdSubheader = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdSubheader',
  computed: {
    insideList: function insideList() {
      return this.$parent.$options._componentTag === 'md-list';
    }
  }
}); //
//
//
//
//
//
//
//
//
//

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdSwitch = __webpack_require__(347);

var _MdSwitch2 = _interopRequireDefault(_MdSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdSwitch2.default.name, _MdSwitch2.default);
};

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdSwitch/MdSwitch.vue
var MdSwitch = __webpack_require__(349);
var MdSwitch_default = /*#__PURE__*/__webpack_require__.n(MdSwitch);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ff953a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdSwitch/MdSwitch.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-switch", class: [_vm.$mdActiveTheme, _vm.checkClasses] },
    [
      _c(
        "div",
        {
          staticClass: "md-switch-container",
          on: {
            click: function($event) {
              $event.stopPropagation()
              _vm.toggleCheck($event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "md-switch-thumb" },
            [
              _c(
                "md-ripple",
                {
                  attrs: {
                    "md-centered": "",
                    "md-active": _vm.rippleActive,
                    "md-disabled": _vm.disabled
                  },
                  on: {
                    "update:mdActive": function($event) {
                      _vm.rippleActive = $event
                    }
                  }
                },
                [
                  _c(
                    "input",
                    _vm._b(
                      { attrs: { type: "checkbox" } },
                      "input",
                      {
                        id: _vm.id,
                        name: _vm.name,
                        disabled: _vm.disabled,
                        required: _vm.required,
                        value: _vm.value
                      },
                      false
                    )
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.$slots.default
        ? _c(
            "label",
            {
              staticClass: "md-switch-label",
              attrs: { for: _vm.id },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.toggleCheck($event)
                }
              }
            },
            [_vm._t("default")],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdSwitch_MdSwitch = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ff953a2", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdSwitch/MdSwitch.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(348)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdSwitch_default.a,
  MdSwitch_MdSwitch,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdSwitch/MdSwitch.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5ff953a2", Component.options)
  } else {
    hotAPI.reload("data-v-5ff953a2", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdSwitch_MdSwitch = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdCheckboxMixin = __webpack_require__(33);

var _MdCheckboxMixin2 = _interopRequireDefault(_MdCheckboxMixin);

var _MdUuid = __webpack_require__(6);

var _MdUuid2 = _interopRequireDefault(_MdUuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdSwitch',
  mixins: [_MdCheckboxMixin2.default],
  props: {
    id: {
      type: String,
      default: function _default() {
        return 'md-switch-' + (0, _MdUuid2.default)();
      }
    }
  }
}); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdTableContainer = __webpack_require__(351);

var _MdTableContainer2 = _interopRequireDefault(_MdTableContainer);

var _MdTableToolbar = __webpack_require__(374);

var _MdTableToolbar2 = _interopRequireDefault(_MdTableToolbar);

var _MdTableEmptyState = __webpack_require__(379);

var _MdTableEmptyState2 = _interopRequireDefault(_MdTableEmptyState);

var _MdTableRow = __webpack_require__(51);

var _MdTableRow2 = _interopRequireDefault(_MdTableRow);

var _MdTableHead = __webpack_require__(27);

var _MdTableHead2 = _interopRequireDefault(_MdTableHead);

var _MdTableCell = __webpack_require__(382);

var _MdTableCell2 = _interopRequireDefault(_MdTableCell);

var _MdTablePagination = __webpack_require__(385);

var _MdTablePagination2 = _interopRequireDefault(_MdTablePagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component('MdTable', _MdTableContainer2.default);
  Vue.component(_MdTableToolbar2.default.name, _MdTableToolbar2.default);
  Vue.component(_MdTableEmptyState2.default.name, _MdTableEmptyState2.default);
  Vue.component(_MdTableRow2.default.name, _MdTableRow2.default);
  Vue.component(_MdTableHead2.default.name, _MdTableHead2.default);
  Vue.component(_MdTableCell2.default.name, _MdTableCell2.default);
  Vue.component(_MdTablePagination2.default.name, _MdTablePagination2.default);
};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _MdTable = __webpack_require__(352);

var _MdTable2 = _interopRequireDefault(_MdTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function processChildren(children, createElement) {
  var slotNames = ['md-table-toolbar', 'md-table-empty-state', 'md-table-pagination'];
  var nodes = Array.from(children);
  var namedSlots = {};

  nodes.forEach(function (node, index) {
    if (node && node.tag) {
      var tag = node.componentOptions && node.componentOptions.tag;

      if (tag && slotNames.includes(tag)) {
        node.data.slot = tag;
        node.data.attrs = node.data.attrs || {};
        namedSlots[tag] = function () {
          return node;
        };
        nodes.splice(index, 1);
      }
    }
  });

  return {
    childNodes: nodes,
    slots: namedSlots
  };
}

exports.default = {
  name: 'MdTableContainer',
  functional: true,
  render: function render(createElement, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    var slotChildren = [];
    var scopedSlots = data.scopedSlots;

    if (children) {
      var _processChildren = processChildren(children, createElement),
          childNodes = _processChildren.childNodes,
          slots = _processChildren.slots;

      slotChildren = childNodes;
      scopedSlots = _extends({}, scopedSlots, slots);
    }

    return createElement(_MdTable2.default, _extends({}, data, {
      props: props,
      scopedSlots: scopedSlots
    }), [slotChildren]);
  }
};

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdTable/MdTable.vue
var MdTable = __webpack_require__(354);
var MdTable_default = /*#__PURE__*/__webpack_require__.n(MdTable);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aaeced82","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdTable/MdTable.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-tag-switcher",
    { staticClass: "md-table", attrs: { "md-tag": _vm.contentTag } },
    [
      _vm._t("md-table-toolbar"),
      _vm._v(" "),
      _c(
        "keep-alive",
        [
          _vm.$scopedSlots["md-table-alternate-header"] && _vm.selectedCount
            ? _c(
                "md-table-alternate-header",
                [
                  _vm._t("md-table-alternate-header", null, {
                    count: _vm.selectedCount
                  })
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.mdFixedHeader
        ? _c(
            "div",
            {
              staticClass: "md-table-fixed-header",
              class: _vm.headerClasses,
              style: _vm.headerStyles
            },
            [_c("table", [_c("md-table-thead")], 1)]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "md-content",
        {
          staticClass: "md-table-content md-scrollbar",
          class: _vm.contentClasses,
          style: _vm.contentStyles,
          on: { scroll: _vm.setScroll }
        },
        [
          _c(
            "table",
            [
              !_vm.mdFixedHeader && _vm.$scopedSlots["md-table-row"]
                ? _c("md-table-thead", { class: _vm.headerClasses })
                : _vm._e(),
              _vm._v(" "),
              !_vm.$scopedSlots["md-table-row"]
                ? _c("tbody", [_vm._t("default")], 2)
                : _vm.value.length
                  ? _c(
                      "tbody",
                      _vm._l(_vm.value, function(item, index) {
                        return _c(
                          "md-table-row-ghost",
                          {
                            key: _vm.getRowId(item[_vm.mdModelId]),
                            attrs: {
                              "md-id": _vm.getRowId(item[_vm.mdModelId]),
                              "md-index": index
                            }
                          },
                          [_vm._t("md-table-row", null, { item: item })],
                          2
                        )
                      })
                    )
                  : _vm.$scopedSlots["md-table-empty-state"]
                    ? _c("tbody", [
                        _c("tr", [
                          _c(
                            "td",
                            { attrs: { colspan: _vm.headerCount } },
                            [_vm._t("md-table-empty-state")],
                            2
                          )
                        ])
                      ])
                    : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm._t("md-table-pagination")
        ],
        2
      ),
      _vm._v(" "),
      _vm.value ? _vm._t("default") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdTable_MdTable = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aaeced82", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdTable/MdTable.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(353)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdTable_default.a,
  MdTable_MdTable,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdTable/MdTable.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-aaeced82", Component.options)
  } else {
    hotAPI.reload("data-v-aaeced82", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdTable_MdTable = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _raf = __webpack_require__(9);

var _raf2 = _interopRequireDefault(_raf);

var _MdTagSwitcher = __webpack_require__(355);

var _MdTagSwitcher2 = _interopRequireDefault(_MdTagSwitcher);

var _MdUuid = __webpack_require__(6);

var _MdUuid2 = _interopRequireDefault(_MdUuid);

var _MdPropValidator = __webpack_require__(4);

var _MdPropValidator2 = _interopRequireDefault(_MdPropValidator);

var _MdTableThead = __webpack_require__(357);

var _MdTableThead2 = _interopRequireDefault(_MdTableThead);

var _MdTableAlternateHeader = __webpack_require__(365);

var _MdTableAlternateHeader2 = _interopRequireDefault(_MdTableAlternateHeader);

var _MdTableRow = __webpack_require__(51);

var _MdTableRow2 = _interopRequireDefault(_MdTableRow);

var _MdTableRowGhost = __webpack_require__(372);

var _MdTableRowGhost2 = _interopRequireDefault(_MdTableRowGhost);

var _MdTableCellSelection = __webpack_require__(52);

var _MdTableCellSelection2 = _interopRequireDefault(_MdTableCellSelection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdTable',
  components: {
    MdTagSwitcher: _MdTagSwitcher2.default,
    MdTableAlternateHeader: _MdTableAlternateHeader2.default,
    MdTableThead: _MdTableThead2.default,
    MdTableRow: _MdTableRow2.default,
    MdTableRowGhost: _MdTableRowGhost2.default,
    MdTableCellSelection: _MdTableCellSelection2.default
  },
  props: {
    value: [Array, Object],
    mdModelId: {
      type: String,
      default: 'id'
    },
    mdCard: Boolean,
    mdFixedHeader: Boolean,
    mdHeight: {
      type: Number,
      default: 400
    },
    mdSort: String,
    mdSortOrder: _extends({
      type: String,
      default: 'asc'
    }, (0, _MdPropValidator2.default)('md-sort-order', ['asc', 'desc'])),
    mdSortFn: {
      type: Function,
      default: function _default(value) {
        var _this = this;

        return value.sort(function (a, b) {
          var sortBy = _this.MdTable.sort;

          if (_this.MdTable.sortOrder === 'desc') {
            return a[sortBy].localeCompare(b[sortBy]);
          }

          return b[sortBy].localeCompare(a[sortBy]);
        });
      }
    }
  },
  data: function data() {
    return {
      fixedHeaderPadding: 0,
      hasContentScroll: false,
      MdTable: {
        items: {},
        sort: null,
        sortOrder: null,
        singleSelection: null,
        selectedItems: {},
        selectable: {},
        fixedHeader: null,
        contentPadding: null,
        contentEl: null,
        // computed
        hasValue: this.hasValue,
        // methods
        emitEvent: this.emitEvent,
        sortTable: this.sortTable,
        manageItemSelection: this.manageItemSelection,
        getModel: this.getModel,
        getModelItem: this.getModelItem
      }
    };
  },

  computed: {
    contentTag: function contentTag() {
      if (this.mdCard) {
        return 'md-card';
      }

      return 'md-content';
    },
    headerCount: function headerCount() {
      return Object.keys(this.MdTable.items).length;
    },
    selectedCount: function selectedCount() {
      return Object.keys(this.MdTable.selectedItems).length;
    },
    headerStyles: function headerStyles() {
      if (this.mdFixedHeader) {
        return 'padding-right: ' + this.fixedHeaderPadding + 'px';
      }
    },
    hasValue: function hasValue() {
      return this.value && this.value.length !== 0;
    },
    headerClasses: function headerClasses() {
      if (this.mdFixedHeader && this.hasContentScroll || !this.hasValue) {
        return 'md-table-fixed-header-active';
      }
    },
    contentStyles: function contentStyles() {
      if (this.mdFixedHeader) {
        return 'height: ' + this.mdHeight + 'px';
      }
    },
    contentClasses: function contentClasses() {
      if (this.mdFixedHeader && this.value.length === 0) {
        return 'md-table-empty';
      }
    }
  },
  provide: function provide() {
    var MdTable = this.MdTable;

    return { MdTable: MdTable };
  },

  watch: {
    mdSort: {
      immediate: true,
      handler: function handler() {
        this.MdTable.sort = this.mdSort;
      }
    },
    mdSortOrder: {
      immediate: true,
      handler: function handler() {
        this.MdTable.sortOrder = this.mdSortOrder;
      }
    },
    mdFixedHeader: {
      immediate: true,
      handler: function handler() {
        this.MdTable.fixedHeader = this.mdFixedHeader;
      }
    },
    hasValue: {
      immediate: true,
      handler: function handler() {
        this.MdTable.hasValue = this.hasValue;
      }
    }
  },
  methods: {
    emitEvent: function emitEvent(eventName, value) {
      this.$emit(eventName, value);
    },
    getRowId: function getRowId(id) {
      if (id) {
        return id;
      }

      return 'md-row-' + (0, _MdUuid2.default)();
    },
    setScroll: function setScroll($event) {
      var _this2 = this;

      (0, _raf2.default)(function () {
        _this2.hasContentScroll = $event.target.scrollTop > 0;
      });
    },
    getContentEl: function getContentEl() {
      return this.$el.querySelector('.md-table-content');
    },
    setContentEl: function setContentEl() {
      this.MdTable.contentEl = this.getContentEl();
    },
    setHeaderPadding: function setHeaderPadding() {
      this.setContentEl();

      var contentEl = this.MdTable.contentEl;

      var tableEl = contentEl.childNodes[0];

      this.fixedHeaderPadding = contentEl.offsetWidth - tableEl.offsetWidth;
    },
    getModel: function getModel() {
      return this.value;
    },
    getModelItem: function getModelItem(index) {
      return this.value[index];
    },
    manageItemSelection: function manageItemSelection(index) {
      if (this.MdTable.selectedItems[index]) {
        this.$delete(this.MdTable.selectedItems, index);
      } else {
        this.$set(this.MdTable.selectedItems, index, this.value[index]);
      }

      this.sendSelectionEvent();
    },
    sendSelectionEvent: function sendSelectionEvent() {
      this.$emit('md-selected', Object.values(this.MdTable.selectedItems));
    },
    sortTable: function sortTable() {
      if (Array.isArray(this.value)) {
        this.$emit('input', this.mdSortFn(this.value));
      }
    }
  },
  mounted: function mounted() {
    this.setContentEl();

    if (this.mdFixedHeader) {
      this.setHeaderPadding();
    }
  }
};

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdTagSwitcher_vue__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdTagSwitcher_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdTagSwitcher_vue__);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdTagSwitcher_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdTagSwitcher/MdTagSwitcher.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6f07a399", Component.options)
  } else {
    hotAPI.reload("data-v-6f07a399", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = {
  functional: true,
  props: {
    mdTag: {
      type: String,
      default: 'div'
    }
  },
  render: function render(createElement, _ref) {
    var props = _ref.props,
        children = _ref.children,
        data = _ref.data,
        listeners = _ref.listeners;

    return createElement(props.mdTag, _extends({}, data, {
      on: listeners
    }), children);
  }
};

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdTable/MdTableThead.vue
var MdTableThead = __webpack_require__(358);
var MdTableThead_default = /*#__PURE__*/__webpack_require__.n(MdTableThead);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a8392f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdTable/MdTableThead.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("thead", [
    _c(
      "tr",
      [
        _c("md-table-head-selection"),
        _vm._v(" "),
        _vm._l(_vm.MdTable.items, function(item, index) {
          return _c(
            "md-table-head",
            _vm._b({ key: index }, "md-table-head", item, false)
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdTable_MdTableThead = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8a8392f6", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdTable/MdTableThead.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdTableThead_default.a,
  MdTable_MdTableThead,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdTable/MdTableThead.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8a8392f6", Component.options)
  } else {
    hotAPI.reload("data-v-8a8392f6", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdTable_MdTableThead = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdTableHead = __webpack_require__(27);

var _MdTableHead2 = _interopRequireDefault(_MdTableHead);

var _MdTableHeadSelection = __webpack_require__(363);

var _MdTableHeadSelection2 = _interopRequireDefault(_MdTableHeadSelection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'MdTableThead',
  inject: ['MdTable'],
  components: {
    MdTableHead: _MdTableHead2.default,
    MdTableHeadSelection: _MdTableHeadSelection2.default
  }
};

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdUpwardIcon = __webpack_require__(361);

var _MdUpwardIcon2 = _interopRequireDefault(_MdUpwardIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'MdTableHead',
  components: {
    MdUpwardIcon: _MdUpwardIcon2.default
  },
  props: {
    mdNumeric: Boolean,
    numeric: Boolean,
    label: String,
    tooltip: String,
    sortBy: String
  },
  inject: ['MdTable'],
  data: function data() {
    return {
      width: null
    };
  },
  computed: {
    hasSort: function hasSort() {
      return this.MdTable.sort && this.sortBy;
    },
    isSorted: function isSorted() {
      if (this.MdTable.sort) {
        return this.MdTable.sort === this.sortBy;
      }
    },
    isDescSorted: function isDescSorted() {
      return this.isSorted && this.MdTable.sortOrder === 'desc';
    },
    isAscSorted: function isAscSorted() {
      return this.isSorted && this.MdTable.sortOrder === 'asc';
    },
    headStyles: function headStyles() {
      return {
        width: this.width + 'px'
      };
    },
    headClasses: function headClasses() {
      return {
        'md-numeric': this.numeric || this.mdNumeric,
        'md-sortable': this.hasSort,
        'md-sorted': this.isSorted,
        'md-sorted-desc': this.isDescSorted
      };
    }
  },
  methods: {
    changeSort: function changeSort() {
      if (this.hasSort) {
        if (this.isAscSorted) {
          this.MdTable.sortOrder = 'desc';
        } else {
          this.MdTable.sortOrder = 'asc';
        }

        this.MdTable.sort = this.sortBy;
        this.MdTable.emitEvent('md-sorted', this.MdTable.sort);
        this.MdTable.emitEvent('update:mdSort', this.MdTable.sort);
        this.MdTable.emitEvent('update:mdSortOrder', this.MdTable.sortOrder);
        this.MdTable.sortTable();
      }
    },
    getChildNodesBySelector: function getChildNodesBySelector(el, selector) {
      return Array.from(el.childNodes).filter(function (_ref) {
        var classList = _ref.classList;
        return classList && classList.contains(selector);
      });
    },
    getNodeIndex: function getNodeIndex(nodes, el) {
      return [].indexOf.call(nodes, el);
    },
    setWidth: function setWidth() {
      if (this.MdTable.fixedHeader) {
        var cellSelector = 'md-table-cell';
        var thEls = this.getChildNodesBySelector(this.$el.parentNode, 'md-table-head');
        var tdEls = this.MdTable.contentEl.querySelectorAll('tr:first-child .' + cellSelector);
        var nodeIndex = this.getNodeIndex(thEls, this.$el);

        this.width = tdEls[nodeIndex].offsetWidth;
      }
    }
  },
  updated: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$nextTick();

            case 2:
              this.setWidth();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function updated() {
      return _ref2.apply(this, arguments);
    }

    return updated;
  }(),
  mounted: function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.$nextTick();

            case 2:
              this.setWidth();

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _ref3.apply(this, arguments);
    }

    return mounted;
  }()
};

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/core/icons/MdUpwardIcon.vue
var MdUpwardIcon = __webpack_require__(362);
var MdUpwardIcon_default = /*#__PURE__*/__webpack_require__.n(MdUpwardIcon);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-235f197a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/core/icons/MdUpwardIcon.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("md-icon", { staticClass: "md-icon-image" }, [
      _c(
        "svg",
        {
          attrs: {
            height: "24",
            viewBox: "0 0 24 24",
            width: "24",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("path", { attrs: { d: "M0 0h24v24H0V0z", fill: "none" } }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
            }
          })
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var icons_MdUpwardIcon = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-235f197a", esExports)
  }
}
// CONCATENATED MODULE: ./src/core/icons/MdUpwardIcon.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdUpwardIcon_default.a,
  icons_MdUpwardIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/core/icons/MdUpwardIcon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-235f197a", Component.options)
  } else {
    hotAPI.reload("data-v-235f197a", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var core_icons_MdUpwardIcon = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdIcon = __webpack_require__(5);

var _MdIcon2 = _interopRequireDefault(_MdIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdArrowDownIcon',
  components: {
    MdIcon: _MdIcon2.default
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdTable/MdTableHeadSelection.vue
var MdTableHeadSelection = __webpack_require__(364);
var MdTableHeadSelection_default = /*#__PURE__*/__webpack_require__.n(MdTableHeadSelection);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fa31cbd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdTable/MdTableHeadSelection.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectableCount
    ? _c("md-table-head", { staticClass: "md-table-cell-selection" }, [
        _c(
          "div",
          { staticClass: "md-table-cell-container" },
          [
            _c("md-checkbox", {
              attrs: { disabled: _vm.isDisabled },
              on: { change: _vm.onChange },
              model: {
                value: _vm.allSelected,
                callback: function($$v) {
                  _vm.allSelected = $$v
                },
                expression: "allSelected"
              }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdTable_MdTableHeadSelection = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fa31cbd", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdTable/MdTableHeadSelection.vue
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdTableHeadSelection_default.a,
  MdTable_MdTableHeadSelection,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdTable/MdTableHeadSelection.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7fa31cbd", Component.options)
  } else {
    hotAPI.reload("data-v-7fa31cbd", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdTable_MdTableHeadSelection = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdTableHead = __webpack_require__(27);

var _MdTableHead2 = _interopRequireDefault(_MdTableHead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdTableHeadSelection',
  components: {
    MdTableHead: _MdTableHead2.default
  },
  inject: ['MdTable'],
  data: function data() {
    return {
      allSelected: false
    };
  },
  computed: {
    selectableCount: function selectableCount() {
      return Object.keys(this.selectable).length;
    },
    isDisabled: function isDisabled() {
      return !this.selectableCount;
    },
    selectable: function selectable() {
      return this.MdTable.selectable;
    },
    selectedItems: function selectedItems() {
      return this.MdTable.selectedItems;
    }
  },
  watch: {
    selectedItems: {
      immediate: true,
      deep: true,
      handler: function handler(items) {
        var _this = this;

        window.setTimeout(function () {
          var countSelected = Object.keys(items).length;

          if (_this.selectableCount > 0 && countSelected > 0) {
            _this.allSelected = countSelected === _this.selectableCount;
          }
        }, 10);
      }
    }
  },
  methods: {
    onChange: function onChange() {
      var _this2 = this;

      Object.values(this.MdTable.selectable).forEach(function (callback) {
        callback(_this2.allSelected);
      });
    }
  }
}; //
//
//
//
//
//
//
//

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdTable/MdTableAlternateHeader.vue
var MdTableAlternateHeader = __webpack_require__(367);
var MdTableAlternateHeader_default = /*#__PURE__*/__webpack_require__.n(MdTableAlternateHeader);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4241c118","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdTable/MdTableAlternateHeader.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "md-table-alternate-header" } }, [
    _c(
      "div",
      { staticClass: "md-table-alternate-header" },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdTable_MdTableAlternateHeader = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4241c118", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdTable/MdTableAlternateHeader.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(366)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdTableAlternateHeader_default.a,
  MdTable_MdTableAlternateHeader,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdTable/MdTableAlternateHeader.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4241c118", Component.options)
  } else {
    hotAPI.reload("data-v-4241c118", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdTable_MdTableAlternateHeader = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//

exports.default = {
  name: 'MdTableAlternateHeader'
};

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//

var _MdPropValidator = __webpack_require__(4);

var _MdPropValidator2 = _interopRequireDefault(_MdPropValidator);

var _MdTableCellSelection = __webpack_require__(52);

var _MdTableCellSelection2 = _interopRequireDefault(_MdTableCellSelection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdTableRow',
  components: {
    MdTableCellSelection: _MdTableCellSelection2.default
  },
  props: {
    mdIndex: [Number, String],
    mdId: [Number, String],
    mdSelectable: _extends({
      type: [String]
    }, (0, _MdPropValidator2.default)('md-selectable', ['multiple', 'single'])),
    mdDisabled: Boolean,
    mdAutoSelect: Boolean
  },
  inject: ['MdTable'],
  data: function data() {
    return {
      index: null,
      isSelected: false
    };
  },
  computed: {
    selectableCount: function selectableCount() {
      return Object.keys(this.MdTable.selectable).length;
    },
    isSingleSelected: function isSingleSelected() {
      return this.MdTable.singleSelection === this.mdId;
    },
    hasMultipleSelection: function hasMultipleSelection() {
      return this.MdTable.hasValue && this.mdSelectable === 'multiple';
    },
    hasSingleSelection: function hasSingleSelection() {
      return this.MdTable.hasValue && this.mdSelectable === 'single';
    },
    rowClasses: function rowClasses() {
      if (this.MdTable.hasValue) {
        return {
          'md-has-selection': !this.mdDisabled && (this.mdAutoSelect || this.hasSingleSelection),
          'md-selected': this.isSelected,
          'md-selected-single': this.isSingleSelected
        };
      }
    }
  },
  watch: {
    mdDisabled: function mdDisabled() {
      if (this.mdDisabled) {
        this.removeSelectableItem();
      } else {
        this.addSelectableItem();
      }
    },
    mdId: function mdId(newId, oldId) {
      this.removeSelectableItem(oldId);
      this.addSelectableItem(newId);
    },
    isSelected: function isSelected() {
      this.MdTable.manageItemSelection(this.mdIndex);
    }
  },
  methods: {
    onClick: function onClick() {
      if (this.MdTable.hasValue && !this.mdDisabled) {
        if (this.hasMultipleSelection) {
          this.selectRowIfMultiple();
        } else if (this.hasSingleSelection) {
          this.selectRowIfSingle();
        }
      }
    },
    toggleSelection: function toggleSelection() {
      this.isSelected = !this.isSelected;
    },
    selectRowIfSingle: function selectRowIfSingle() {
      if (this.MdTable.singleSelection === this.mdId) {
        this.MdTable.singleSelection = null;
        this.$emit('md-selected', null);
      } else {
        this.MdTable.singleSelection = this.mdId;
        this.$emit('md-selected', this.MdTable.getModelItem(this.mdIndex));
      }
    },
    selectRowIfMultiple: function selectRowIfMultiple() {
      if (this.mdAutoSelect) {
        this.toggleSelection();
      }
    },
    addSelectableItem: function addSelectableItem(id) {
      var _this = this;

      if (this.hasMultipleSelection && !this.mdDisabled) {
        this.$set(this.MdTable.selectable, id || this.mdId, function (isSelected) {
          _this.isSelected = isSelected;
        });
      }
    },
    removeSelectableItem: function removeSelectableItem(id) {
      if (this.hasMultipleSelection) {
        this.$delete(this.MdTable.selectable, id || this.mdId);
      }
    }
  },
  created: function created() {
    this.addSelectableItem();
  },
  beforeDestroy: function beforeDestroy() {
    this.removeSelectableItem();
  }
};

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//

exports.default = {
  name: 'MdTableCellSelection',
  props: {
    value: Boolean,
    mdRowId: [Number, String],
    mdSelectable: Boolean,
    mdDisabled: Boolean
  },
  inject: ['MdTable'],
  data: function data() {
    return {
      isSelected: false
    };
  },
  watch: {
    value: function value() {
      this.isSelected = this.value;
    }
  },
  methods: {
    onChange: function onChange() {
      this.$emit('input', this.isSelected);
    }
  }
};

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdTableRowGhost_vue__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdTableRowGhost_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdTableRowGhost_vue__);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdTableRowGhost_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdTable/MdTableRowGhost.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b1d6a698", Component.options)
  } else {
    hotAPI.reload("data-v-b1d6a698", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'MdTableRowGhost',
  abstract: true,
  props: {
    mdIndex: [String, Number],
    mdId: [String, Number]
  },
  render: function render() {
    this.$slots.default[0].componentOptions.propsData.mdIndex = this.mdIndex;
    this.$slots.default[0].componentOptions.propsData.mdId = this.mdId;

    return this.$slots.default[0];
  }
};

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdTable/MdTableToolbar.vue
var MdTableToolbar = __webpack_require__(376);
var MdTableToolbar_default = /*#__PURE__*/__webpack_require__.n(MdTableToolbar);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f6f4028","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdTable/MdTableToolbar.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-toolbar",
    {
      staticClass: "md-table-toolbar md-transparent",
      attrs: { "md-elevation": 0 }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdTable_MdTableToolbar = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f6f4028", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdTable/MdTableToolbar.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(375)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdTableToolbar_default.a,
  MdTable_MdTableToolbar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdTable/MdTableToolbar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3f6f4028", Component.options)
  } else {
    hotAPI.reload("data-v-3f6f4028", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdTable_MdTableToolbar = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdToolbar = __webpack_require__(53);

var _MdToolbar2 = _interopRequireDefault(_MdToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdTableToolbar',
  components: {
    MdToolbar: _MdToolbar2.default
  },
  inject: ['MdTable']
}; //
//
//
//
//
//

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _MdComponent2.default({
  name: 'MdToolbar',
  props: {
    mdElevation: {
      type: [String, Number],
      default: 4
    }
  }
}); //
//
//
//
//
//

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdTable/MdTableEmptyState.vue
var MdTableEmptyState = __webpack_require__(381);
var MdTableEmptyState_default = /*#__PURE__*/__webpack_require__.n(MdTableEmptyState);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f84743a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdTable/MdTableEmptyState.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-empty-state",
    _vm._b(
      { staticClass: "md-table-empty-state" },
      "md-empty-state",
      _vm.$props,
      false
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdTable_MdTableEmptyState = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f84743a", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdTable/MdTableEmptyState.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(380)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdTableEmptyState_default.a,
  MdTable_MdTableEmptyState,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdTable/MdTableEmptyState.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6f84743a", Component.options)
  } else {
    hotAPI.reload("data-v-6f84743a", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdTable_MdTableEmptyState = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MdEmptyState = __webpack_require__(41);

var _MdEmptyState2 = _interopRequireDefault(_MdEmptyState);

var _MdEmptyStateProps = __webpack_require__(42);

var _MdEmptyStateProps2 = _interopRequireDefault(_MdEmptyStateProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//

exports.default = {
  name: 'MdTableEmptyState',
  props: _MdEmptyStateProps2.default,
  inject: ['MdTable']
};

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdTable/MdTableCell.vue
var MdTableCell = __webpack_require__(384);
var MdTableCell_default = /*#__PURE__*/__webpack_require__.n(MdTableCell);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-813d6b7e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdTable/MdTableCell.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("td", { staticClass: "md-table-cell", class: _vm.cellClasses }, [
    _c(
      "div",
      { staticClass: "md-table-cell-container" },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdTable_MdTableCell = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-813d6b7e", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdTable/MdTableCell.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(383)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdTableCell_default.a,
  MdTable_MdTableCell,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdTable/MdTableCell.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-813d6b7e", Component.options)
  } else {
    hotAPI.reload("data-v-813d6b7e", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdTable_MdTableCell = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//

exports.default = {
  name: 'MdTableCell',
  props: {
    mdLabel: String,
    mdNumeric: Boolean,
    mdTooltip: String,
    mdSortBy: String
  },
  inject: ['MdTable'],
  data: function data() {
    return {
      index: null
    };
  },
  computed: {
    cellClasses: function cellClasses() {
      return {
        'md-numeric': this.mdNumeric
      };
    }
  },
  watch: {
    mdSortBy: function mdSortBy() {
      this.setCellData();
    },
    mdNumeric: function mdNumeric() {
      this.setCellData();
    },
    mdLabel: function mdLabel() {
      this.setCellData();
    },
    mdTooltip: function mdTooltip() {
      this.setCellData();
    }
  },
  methods: {
    setCellData: function setCellData() {
      var $vm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;

      this.$set(this.MdTable.items, $vm.index, {
        label: $vm.mdLabel,
        numeric: $vm.mdNumeric,
        tooltip: $vm.mdTooltip,
        sortBy: $vm.mdSortBy
      });
    },
    updateAllCellData: function updateAllCellData() {
      var _this = this;

      var cells = Array.from(this.$el.parentNode.childNodes).filter(function (_ref) {
        var tagName = _ref.tagName,
            classList = _ref.classList;

        var isSelection = classList && classList.contains('md-table-cell-selection');
        var isTd = tagName && tagName.toLowerCase() === 'td';

        return isTd && !isSelection;
      });

      cells.forEach(function (cell, index) {
        var $vm = cell.__vue__;

        $vm.index = index;

        _this.setCellData($vm);
      });
    }
  },
  mounted: function mounted() {
    this.updateAllCellData();
  }
};

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdTable/MdTablePagination.vue
var MdTablePagination = __webpack_require__(387);
var MdTablePagination_default = /*#__PURE__*/__webpack_require__.n(MdTablePagination);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4165698e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdTable/MdTablePagination.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-table-pagination" },
    [
      _vm.mdPageOptions !== false
        ? [
            _c("span", { staticClass: "md-table-pagination-label" }, [
              _vm._v(_vm._s(_vm.mdLabel))
            ]),
            _vm._v(" "),
            _c(
              "md-field",
              [
                _c(
                  "md-select",
                  {
                    attrs: {
                      "md-dense": "",
                      "md-class": "md-pagination-select"
                    },
                    on: { changed: _vm.setPageSize },
                    model: {
                      value: _vm.currentPageSize,
                      callback: function($$v) {
                        _vm.currentPageSize = $$v
                      },
                      expression: "currentPageSize"
                    }
                  },
                  _vm._l(_vm.mdPageOptions, function(amount) {
                    return _c(
                      "md-option",
                      { key: amount, attrs: { value: amount } },
                      [_vm._v(_vm._s(amount))]
                    )
                  })
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          _vm._s(_vm.currentItemCount) +
            "-" +
            _vm._s(_vm.currentPageCount) +
            " " +
            _vm._s(_vm.mdSeparator) +
            " " +
            _vm._s(_vm.mdTotal)
        )
      ]),
      _vm._v(" "),
      _c(
        "md-button",
        {
          staticClass: "md-icon-button md-table-pagination-previous",
          attrs: { disabled: _vm.mdPage === 1 },
          on: {
            click: function($event) {
              _vm.goToPrevious()
            }
          }
        },
        [_c("md-icon", [_vm._v("keyboard_arrow_left")])],
        1
      ),
      _vm._v(" "),
      _c(
        "md-button",
        {
          staticClass: "md-icon-button md-table-pagination-next",
          on: {
            click: function($event) {
              _vm.goToNext()
            }
          }
        },
        [_c("md-icon", [_vm._v("keyboard_arrow_right")])],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdTable_MdTablePagination = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4165698e", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdTable/MdTablePagination.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(386)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdTablePagination_default.a,
  MdTable_MdTablePagination,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdTable/MdTablePagination.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4165698e", Component.options)
  } else {
    hotAPI.reload("data-v-4165698e", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdTable_MdTablePagination = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'MdTablePagination',
  inject: ['MdTable'],
  props: {
    mdPageSize: {
      type: [String, Number],
      default: 10
    },
    mdPageOptions: {
      type: Array,
      default: function _default() {
        return [10, 25, 50, 100];
      }
    },
    mdPage: {
      type: Number,
      default: 1
    },
    mdTotal: {
      type: [String, Number],
      default: 'Many'
    },
    mdLabel: {
      type: String,
      default: 'Rows per page:'
    },
    mdSeparator: {
      type: String,
      default: 'of'
    }
  },
  data: function data() {
    return {
      currentPageSize: 0
    };
  },
  computed: {
    currentItemCount: function currentItemCount() {
      return (this.mdPage - 1) * this.mdPageSize + 1;
    },
    currentPageCount: function currentPageCount() {
      return this.mdPage * this.mdPageSize;
    }
  },
  watch: {
    mdPageSize: {
      immediate: true,
      handler: function handler(pageSize) {
        this.currentPageSize = this.pageSize;
      }
    }
  },
  methods: {
    setPageSize: function setPageSize() {
      this.$emit('update:mdPageSize', this.currentPageSize);
    },
    goToPrevious: function goToPrevious() {},
    goToNext: function goToNext() {}
  },
  created: function created() {
    this.currentPageSize = this.mdPageSize;
  }
};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdTabs = __webpack_require__(389);

var _MdTabs2 = _interopRequireDefault(_MdTabs);

var _MdTab = __webpack_require__(392);

var _MdTab2 = _interopRequireDefault(_MdTab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdTabs2.default.name, _MdTabs2.default);
  Vue.component(_MdTab2.default.name, _MdTab2.default);
};

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdTabs/MdTabs.vue
var MdTabs = __webpack_require__(391);
var MdTabs_default = /*#__PURE__*/__webpack_require__.n(MdTabs);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-733c1bef","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdTabs/MdTabs.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-tabs", class: [_vm.tabsClasses, _vm.$mdActiveTheme] },
    [
      _c(
        "div",
        { staticClass: "md-tabs-navigation", class: _vm.navigationClasses },
        [
          _vm._l(_vm.MdTabs.items, function(ref, index) {
            var label = ref.label
            var props = ref.props
            var icon = ref.icon
            var disabled = ref.disabled
            var data = ref.data
            var events = ref.events
            return _c(
              "md-button",
              _vm._g(
                _vm._b(
                  {
                    key: index,
                    class: {
                      "md-active": index === _vm.activeTab,
                      "md-icon-label": icon && label
                    },
                    attrs: { disabled: disabled },
                    nativeOn: {
                      click: function($event) {
                        _vm.setActiveTab(index)
                      }
                    }
                  },
                  "md-button",
                  props,
                  false
                ),
                events
              ),
              [
                _vm.$scopedSlots["md-tab"]
                  ? _vm._t("md-tab", null, {
                      tab: { label: label, icon: icon, data: data }
                    })
                  : [
                      !icon
                        ? [_vm._v(_vm._s(label))]
                        : [
                            _vm.isAssetIcon(icon)
                              ? _c("md-icon", {
                                  staticClass: "md-tab-icon",
                                  attrs: { "md-src": icon }
                                })
                              : _c("md-icon", { staticClass: "md-tab-icon" }, [
                                  _vm._v(_vm._s(icon))
                                ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "md-tab-label" }, [
                              _vm._v(_vm._s(label))
                            ])
                          ]
                    ]
              ],
              2
            )
          }),
          _vm._v(" "),
          _c("span", {
            ref: "indicator",
            staticClass: "md-tabs-indicator",
            class: _vm.indicatorClass,
            style: _vm.indicatorStyles
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "md-content",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasContent,
              expression: "hasContent"
            }
          ],
          staticClass: "md-tabs-content",
          style: _vm.contentStyles
        },
        [
          _c(
            "div",
            { staticClass: "md-tabs-container", style: _vm.containerStyles },
            [_vm._t("default")],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdTabs_MdTabs = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-733c1bef", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdTabs/MdTabs.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(390)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdTabs_default.a,
  MdTabs_MdTabs,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdTabs/MdTabs.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-733c1bef", Component.options)
  } else {
    hotAPI.reload("data-v-733c1bef", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdTabs_MdTabs = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdAssetIcon = __webpack_require__(18);

var _MdAssetIcon2 = _interopRequireDefault(_MdAssetIcon);

var _MdPropValidator = __webpack_require__(4);

var _MdPropValidator2 = _interopRequireDefault(_MdPropValidator);

var _MdObserveElement = __webpack_require__(26);

var _MdObserveElement2 = _interopRequireDefault(_MdObserveElement);

var _MdContent = __webpack_require__(35);

var _MdContent2 = _interopRequireDefault(_MdContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = new _MdComponent2.default({
  name: 'MdTabs',
  mixins: [_MdAssetIcon2.default],
  components: {
    MdContent: _MdContent2.default
  },
  props: {
    mdAlignment: _extends({
      type: String,
      default: 'left'
    }, (0, _MdPropValidator2.default)('md-alignment', ['left', 'right', 'centered', 'fixed'])),
    mdElevation: {
      type: [Number, String],
      default: 0
    },
    mdSyncRoute: Boolean,
    mdDynamicHeight: Boolean,
    mdActiveTab: [String, Number]
  },
  data: function data() {
    return {
      resizeObserver: null,
      activeTab: 0,
      activeTabIndex: 0,
      indicatorStyles: {},
      indicatorClass: null,
      noTransition: true,
      containerStyles: {},
      contentStyles: {
        height: '0px'
      },
      hasContent: false,
      MdTabs: {
        items: {}
      }
    };
  },
  provide: function provide() {
    return {
      MdTabs: this.MdTabs
    };
  },

  computed: {
    tabsClasses: function tabsClasses() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, 'md-alignment-' + this.mdAlignment, true), _defineProperty(_ref, 'md-no-transition', this.noTransition), _defineProperty(_ref, 'md-dynamic-height', this.mdDynamicHeight), _ref;
    },
    navigationClasses: function navigationClasses() {
      return 'md-elevation-' + this.mdElevation;
    }
  },
  watch: {
    MdTabs: {
      deep: true,
      handler: function handler() {
        this.setHasContent();
      }
    },
    activeTab: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$nextTick();

              case 2:
                this.setIndicatorStyles();
                this.setActiveTabIndex();
                this.calculateTabPos();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function activeTab() {
        return _ref2.apply(this, arguments);
      }

      return activeTab;
    }(),
    mdActiveTab: function mdActiveTab(tab) {
      this.activeTab = tab;
      this.$emit('md-changed', tab);
    },
    mdAlignment: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$nextTick();

              case 2:
                this.setIndicatorStyles();

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function mdAlignment() {
        return _ref3.apply(this, arguments);
      }

      return mdAlignment;
    }()
  },
  methods: {
    hasActiveTab: function hasActiveTab() {
      return this.activeTab || this.mdActiveTab;
    },
    getItemsAndKeys: function getItemsAndKeys() {
      var items = this.MdTabs.items;

      return {
        items: items,
        keys: Object.keys(items)
      };
    },
    setActiveTab: function setActiveTab(index) {
      this.activeTab = index;
      this.$emit('md-changed', index);
    },
    setActiveTabIndex: function setActiveTabIndex() {
      var activeButton = this.$el.querySelector('.md-button.md-active');

      if (activeButton) {
        this.activeTabIndex = [].indexOf.call(activeButton.parentNode.childNodes, activeButton);
      }
    },
    setActiveTabByIndex: function setActiveTabByIndex(index) {
      var _getItemsAndKeys = this.getItemsAndKeys(),
          keys = _getItemsAndKeys.keys;

      if (!this.hasActiveTab()) {
        this.activeTab = keys[index];
      }
    },
    setActiveTabByRoute: function setActiveTabByRoute() {
      var _this = this;

      var _getItemsAndKeys2 = this.getItemsAndKeys(),
          items = _getItemsAndKeys2.items,
          keys = _getItemsAndKeys2.keys;

      var tabIndex = null;

      if (this.$router) {
        keys.forEach(function (key, index) {
          var item = items[key];
          var toProp = item.props.to;

          if (toProp && toProp === _this.$route.path) {
            tabIndex = index;
          }
        });
      }

      if (!this.hasActiveTab() && !tabIndex) {
        this.activeTab = keys[0];
      } else {
        this.activeTab = keys[tabIndex];
      }
    },
    setHasContent: function setHasContent() {
      var _getItemsAndKeys3 = this.getItemsAndKeys(),
          items = _getItemsAndKeys3.items,
          keys = _getItemsAndKeys3.keys;

      this.hasContent = keys.some(function (key) {
        return items[key].hasContent;
      });
    },
    setIndicatorStyles: function setIndicatorStyles() {
      var _this2 = this;

      window.requestAnimationFrame(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var activeButton, buttonWidth, buttonLeft, indicatorLeft;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.$nextTick();

              case 2:
                activeButton = _this2.$el.querySelector('.md-button.md-active');


                if (activeButton && _this2.$refs.indicator) {
                  buttonWidth = activeButton.offsetWidth;
                  buttonLeft = activeButton.offsetLeft;
                  indicatorLeft = _this2.$refs.indicator.offsetLeft;


                  if (indicatorLeft < buttonLeft) {
                    _this2.indicatorClass = 'md-tabs-indicator-right';
                  } else {
                    _this2.indicatorClass = 'md-tabs-indicator-left';
                  }

                  _this2.indicatorStyles = {
                    left: buttonLeft + 'px',
                    right: 'calc(100% - ' + (buttonWidth + buttonLeft) + 'px)'
                  };
                }

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      })));
    },
    calculateTabPos: function calculateTabPos() {
      if (this.hasContent) {
        var tabElement = this.$el.querySelector('.md-tab:nth-child(' + (this.activeTabIndex + 1) + ')');

        this.contentStyles = {
          height: tabElement.offsetHeight + 'px'
        };

        this.containerStyles = {
          transform: 'translate3D(' + -this.activeTabIndex * 100 + '%, 0, 0)'
        };
      }
    },
    setupObservers: function setupObservers() {
      var _this3 = this;

      if ('ResizeObserver' in window) {
        this.resizeObserver = new window.ResizeObserver(this.setIndicatorStyles);
        this.resizeObserver.observe(this.$el);
      } else {
        this.resizeObserver = (0, _MdObserveElement2.default)(this.$el.querySelector('.md-tabs-content'), {
          childList: true,
          characterData: true,
          subtree: true
        }, function () {
          _this3.setIndicatorStyles();
          _this3.calculateTabPos();
        });

        window.addEventListener('resize', this.setIndicatorStyles);
      }
    },
    setupWatchers: function setupWatchers() {
      if (this.mdSyncRoute) {
        this.$watch('$route', {
          deep: true,
          handler: function handler() {
            if (this.mdSyncRoute) {
              this.setActiveTabByRoute();
            }
          }
        });
      }
    }
  },
  created: function created() {
    this.setHasContent();
    this.activeTab = this.mdActiveTab;
  },
  mounted: function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var _this4 = this;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.$nextTick();

            case 2:

              if (this.mdSyncRoute) {
                this.setActiveTabByRoute();
              } else {
                this.setActiveTabByIndex(0);
              }

              _context4.next = 5;
              return this.$nextTick();

            case 5:

              this.setActiveTabIndex();
              this.calculateTabPos();

              window.setTimeout(function () {
                _this4.noTransition = false;
                _this4.setupObservers();
                _this4.setupWatchers();
              }, 100);

            case 8:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function mounted() {
      return _ref5.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    window.removeEventListener('resize', this.setIndicatorStyles);
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdTab_vue__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdTab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdTab_vue__);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_MdTab_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdTabs/MdTab.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4b620898", Component.options)
  } else {
    hotAPI.reload("data-v-4b620898", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _MdUuid = __webpack_require__(6);

var _MdUuid2 = _interopRequireDefault(_MdUuid);

var _MdObserveElement = __webpack_require__(26);

var _MdObserveElement2 = _interopRequireDefault(_MdObserveElement);

var _MdRouterLinkProps = __webpack_require__(12);

var _MdRouterLinkProps2 = _interopRequireDefault(_MdRouterLinkProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MdTab',
  props: {
    id: {
      type: String,
      default: function _default() {
        return 'md-tab-' + (0, _MdUuid2.default)();
      }
    },
    href: [String, Number],
    to: null,
    mdDisabled: Boolean,
    mdLabel: [String, Number],
    mdIcon: String,
    mdTemplateData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  inject: ['MdTabs'],
  data: function data() {
    return {
      observer: null
    };
  },
  watch: {
    $props: {
      deep: true,
      handler: function handler() {
        this.setTabData();
      }
    },
    $attrs: {
      deep: true,
      handler: function handler() {
        this.setTabData();
      }
    }
  },
  methods: {
    setTabContent: function setTabContent() {
      this.$set(this.MdTabs.items[this.id], 'hasContent', !!this.$slots.default);
    },
    setupObserver: function setupObserver() {
      this.observer = (0, _MdObserveElement2.default)(this.$el, {
        childList: true
      }, this.setTabContent);
    },
    setTabData: function setTabData() {
      this.$set(this.MdTabs.items, this.id, {
        hasContent: !!this.$slots.default,
        label: this.mdLabel,
        icon: this.mdIcon,
        disabled: this.mdDisabled,
        data: this.mdTemplateData,
        props: this.getPropValues(),
        events: this.$listeners
      });
    },
    getPropValues: function getPropValues() {
      var _this = this;

      var propNames = Object.keys(this.$options.props);
      var ignoredProps = ['id', 'mdLabel', 'mdDisabled', 'mdTemplateData'];
      var values = {};

      propNames.forEach(function (prop) {
        if (!ignoredProps.includes(prop)) {
          if (_this[prop]) {
            values[prop] = _this[prop];
          } else if (_this.$attrs.hasOwnProperty(prop)) {
            if (prop) {
              values[prop] = _this.$attrs[prop];
            } else {
              values[prop] = true;
            }
          }
        }
      });

      return values;
    }
  },
  mounted: function mounted() {
    this.setupObserver();
    this.setTabData();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }

    this.$delete(this.MdTabs.items, this.id);
  },
  render: function render(createElement) {
    var tabAttrs = {
      staticClass: 'md-tab',
      attrs: _extends({}, this.$attrs, {
        id: this.id
      }),
      on: this.$listeners
    };

    if (this.href) {
      this.buttonProps = this.$options.props;
    } else if (this.$router && this.to) {
      this.$options.props = (0, _MdRouterLinkProps2.default)(this, this.$options.props);

      tabAttrs.props = this.$props;
    }

    return createElement('div', tabAttrs, this.$slots.default);
  }
};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdToolbar = __webpack_require__(53);

var _MdToolbar2 = _interopRequireDefault(_MdToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdToolbar2.default.name, _MdToolbar2.default);
};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _material = __webpack_require__(1);

var _material2 = _interopRequireDefault(_material);

var _MdTooltip = __webpack_require__(396);

var _MdTooltip2 = _interopRequireDefault(_MdTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  (0, _material2.default)(Vue);
  Vue.component(_MdTooltip2.default.name, _MdTooltip2.default);
};

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/MdTooltip/MdTooltip.vue
var MdTooltip = __webpack_require__(398);
var MdTooltip_default = /*#__PURE__*/__webpack_require__.n(MdTooltip);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03252be9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/MdTooltip/MdTooltip.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-popover",
    {
      attrs: {
        "md-settings": _vm.popperSettings,
        "md-active": _vm.shouldRender
      }
    },
    [
      _vm.shouldRender
        ? _c("transition", { attrs: { name: "md-tooltip" } }, [
            _c(
              "div",
              {
                staticClass: "md-tooltip",
                class: [_vm.tooltipClasses, _vm.$mdActiveTheme],
                style: _vm.tooltipStyles
              },
              [_vm._t("default")],
              2
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MdTooltip_MdTooltip = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03252be9", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/MdTooltip/MdTooltip.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(397)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MdTooltip_default.a,
  MdTooltip_MdTooltip,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MdTooltip/MdTooltip.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-03252be9", Component.options)
  } else {
    hotAPI.reload("data-v-03252be9", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_MdTooltip_MdTooltip = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//

var _MdComponent = __webpack_require__(2);

var _MdComponent2 = _interopRequireDefault(_MdComponent);

var _MdPropValidator = __webpack_require__(4);

var _MdPropValidator2 = _interopRequireDefault(_MdPropValidator);

var _MdPopover = __webpack_require__(25);

var _MdPopover2 = _interopRequireDefault(_MdPopover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = new _MdComponent2.default({
  name: 'MdTooltip',
  components: {
    MdPopover: _MdPopover2.default
  },
  props: {
    mdActive: Boolean,
    mdDelay: {
      type: [String, Number],
      default: 0
    },
    mdDirection: _extends({
      type: String,
      default: 'bottom'
    }, (0, _MdPropValidator2.default)('md-direction', ['top', 'right', 'bottom', 'left']))
  },
  data: function data() {
    return {
      shouldRender: false,
      targetEl: null
    };
  },
  computed: {
    tooltipClasses: function tooltipClasses() {
      return 'md-tooltip-' + this.mdDirection;
    },
    tooltipStyles: function tooltipStyles() {
      return 'transition-delay: ' + this.mdDelay + 'ms';
    },
    popperSettings: function popperSettings() {
      return {
        placement: this.mdDirection,
        modifiers: {
          offset: {
            offset: '0, 16'
          }
        }
      };
    }
  },
  watch: {
    mdActive: function mdActive() {
      this.shouldRender = this.mdActive;
    }
  },
  methods: {
    show: function show() {
      this.shouldRender = true;
    },
    hide: function hide() {
      this.$emit('update:mdActive', false);
      this.shouldRender = false;
    }
  },
  mounted: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$nextTick();

            case 2:

              this.shouldRender = this.mdActive;
              this.targetEl = this._vnode.componentInstance.originalParentEl;

              if (this.targetEl) {
                this.targetEl.addEventListener('mouseenter', this.show, false);
                this.targetEl.addEventListener('mouseleave', this.hide, false);
              }

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    if (this.targetEl) {
      this.targetEl.removeEventListener('mouseenter', this.show);
      this.targetEl.removeEventListener('mouseleave', this.hide);
    }
  }
});

/***/ })
/******/ ]);
});

/***/ }),

/***/ "LmCc":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1331);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1053:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1kkP");

/***/ }),

/***/ 1331:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1053) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "multicolumncombobox",
	    name: "MultiColumnComboBox",
	    category: "web",
	    description: "The MultiColumnComboBox widget allows the selection from pre-defined values or entering a new value where the list popup is rendered in table layout.",
	    depends: [ "combobox" ],
	    features: [ {
	        id: "mobile-scroller",
	        name: "Mobile scroller",
	        description: "Support for kinetic scrolling in mobile device",
	        depends: [ "mobile.scroller" ]
	    }, {
	        id: "virtualization",
	        name: "VirtualList",
	        description: "Support for virtualization",
	        depends: [ "virtuallist" ]
	    } ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        ComboBox = ui.ComboBox,
	        percentageUnitsRegex = /^\d+(\.\d+)?%$/i,
	        MCCOMBOBOX = "k-dropdowngrid",
	        POPUPCLASS = "k-dropdowngrid-popup k-popup-flush";

	    var MultiColumnComboBox = ComboBox.extend({
	        init: function(element, options) {
	            ComboBox.fn.init.call(this, element, options);
	            this.list.addClass(POPUPCLASS);

	            if (this._allColumnsWidthsAreSet(this.options)) {
	                this.list.width(this._calculateDropDownWidth(this.options));
	            } else if (this.options.dropDownWidth) {
	                this.list.width(this.options.dropDownWidth);
	            }
	        },

	        options: {
	            name: "MultiColumnComboBox",
	            ns: ".kendoMultiColumnComboBox",
	            columns: [],
	            dropDownWidth: null,
	            filterFields: []
	        },

	        setOptions: function(options) {
	            ComboBox.fn.setOptions.call(this, options);
	            if (this._allColumnsWidthsAreSet(options)) {
	                this.list.width(this._calculateDropDownWidth(options));
	            } else if (this.options.dropDownWidth) {
	                this.list.width(this.options.dropDownWidth);
	            }
	        },

	        _allColumnsWidthsAreSet: function (options) {
	            var columns = options.columns;

	            if (!columns || !columns.length) {
	                return false;
	            }

	            for (var i = 0; i < columns.length; i++) {
	                var currentWidth = columns[i].width;
	                if(!currentWidth  || isNaN(parseInt(currentWidth, 10)) || percentageUnitsRegex.test(currentWidth)){
	                    return false;
	                }
	            }

	            return true;
	        },

	        _calculateDropDownWidth: function (options) {
	            var columns = options.columns;
	            var totalWidth = kendo.support.scrollbar();

	            for (var i = 0; i < columns.length; i++) {
	                var currentWidth = columns[i].width;
	                totalWidth = totalWidth + parseInt(currentWidth, 10);
	            }

	            return totalWidth;
	        },

	        _wrapper: function() {
	            ComboBox.fn._wrapper.call(this);
	            this.wrapper.addClass(MCCOMBOBOX);
	        }
	    });

	    ui.plugin(MultiColumnComboBox);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "LnC7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var constants_1 = __webpack_require__("ZZFX");
var context_1 = __webpack_require__("RQ1/");
var gridCore_1 = __webpack_require__("b9np");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var environment_1 = __webpack_require__("JLYF");
var PopupService = (function () {
    function PopupService() {
        this.activePopupElements = [];
    }
    PopupService.prototype.getPopupParent = function () {
        var ePopupParent = this.gridOptionsWrapper.getPopupParent();
        if (ePopupParent) {
            // user provided popup parent, may not have the right theme applied
            return ePopupParent;
        }
        else {
            return this.gridCore.getRootGui();
        }
    };
    PopupService.prototype.positionPopupForMenu = function (params) {
        var sourceRect = params.eventSource.getBoundingClientRect();
        var parentRect = this.getPopupParent().getBoundingClientRect();
        var y = sourceRect.top - parentRect.top;
        y = this.keepYWithinBounds(params, y);
        var minWidth = (params.ePopup.clientWidth > 0) ? params.ePopup.clientWidth : 200;
        var widthOfParent = parentRect.right - parentRect.left;
        var maxX = widthOfParent - minWidth;
        // the x position of the popup depends on RTL or LTR. for normal cases, LTR, we put the child popup
        // to the right, unless it doesn't fit and we then put it to the left. for RTL it's the other way around,
        // we try place it first to the left, and then if not to the right.
        var x;
        if (this.gridOptionsWrapper.isEnableRtl()) {
            // for RTL, try left first
            x = xLeftPosition();
            if (x < 0) {
                x = xRightPosition();
            }
            if (x > maxX) {
                x = 0;
            }
        }
        else {
            // for LTR, try right first
            x = xRightPosition();
            if (x > maxX) {
                x = xLeftPosition();
            }
            if (x < 0) {
                x = 0;
            }
        }
        params.ePopup.style.left = x + "px";
        params.ePopup.style.top = y + "px";
        function xRightPosition() {
            return sourceRect.right - parentRect.left - 2;
        }
        function xLeftPosition() {
            return sourceRect.left - parentRect.left - minWidth;
        }
    };
    PopupService.prototype.positionPopupUnderMouseEvent = function (params) {
        var parentRect = this.getPopupParent().getBoundingClientRect();
        this.positionPopup({
            ePopup: params.ePopup,
            x: params.mouseEvent.clientX - parentRect.left,
            y: params.mouseEvent.clientY - parentRect.top,
            keepWithinBounds: true
        });
        this.callPostProcessPopup(params.ePopup, null, params.mouseEvent, params.type, params.column, params.rowNode);
    };
    PopupService.prototype.positionPopupUnderComponent = function (params) {
        var sourceRect = params.eventSource.getBoundingClientRect();
        var parentRect = this.getPopupParent().getBoundingClientRect();
        this.positionPopup({
            ePopup: params.ePopup,
            minWidth: params.minWidth,
            nudgeX: params.nudgeX,
            nudgeY: params.nudgeY,
            x: sourceRect.left - parentRect.left,
            y: sourceRect.top - parentRect.top + sourceRect.height,
            keepWithinBounds: params.keepWithinBounds
        });
        this.callPostProcessPopup(params.ePopup, params.eventSource, null, params.type, params.column, params.rowNode);
    };
    PopupService.prototype.callPostProcessPopup = function (ePopup, eventSource, mouseEvent, type, column, rowNode) {
        var callback = this.gridOptionsWrapper.getPostProcessPopupFunc();
        if (callback) {
            var params = {
                column: column,
                rowNode: rowNode,
                ePopup: ePopup,
                type: type,
                eventSource: eventSource,
                mouseEvent: mouseEvent
            };
            callback(params);
        }
    };
    PopupService.prototype.positionPopupOverComponent = function (params) {
        var sourceRect = params.eventSource.getBoundingClientRect();
        var parentRect = this.getPopupParent().getBoundingClientRect();
        this.positionPopup({
            ePopup: params.ePopup,
            minWidth: params.minWidth,
            nudgeX: params.nudgeX,
            nudgeY: params.nudgeY,
            x: sourceRect.left - parentRect.left,
            y: sourceRect.top - parentRect.top,
            keepWithinBounds: params.keepWithinBounds
        });
        this.callPostProcessPopup(params.ePopup, params.eventSource, null, params.type, params.column, params.rowNode);
    };
    PopupService.prototype.positionPopup = function (params) {
        var x = params.x;
        var y = params.y;
        if (params.nudgeX) {
            x += params.nudgeX;
        }
        if (params.nudgeY) {
            y += params.nudgeY;
        }
        // if popup is overflowing to the bottom, move it up
        if (params.keepWithinBounds) {
            x = this.keepXWithinBounds(params, x);
            y = this.keepYWithinBounds(params, y);
        }
        params.ePopup.style.left = x + "px";
        params.ePopup.style.top = y + "px";
    };
    PopupService.prototype.keepYWithinBounds = function (params, y) {
        var parentRect = this.getPopupParent().getBoundingClientRect();
        var minHeight;
        if (params.ePopup.clientHeight > 0) {
            minHeight = params.ePopup.clientHeight;
        }
        else {
            minHeight = 200;
        }
        var heightOfParent = parentRect.bottom - parentRect.top;
        var maxY = heightOfParent - minHeight - 5;
        if (y > maxY) {
            return maxY;
        }
        else if (y < 0) {
            return 0;
        }
        else {
            return y;
        }
    };
    PopupService.prototype.keepXWithinBounds = function (params, x) {
        var parentRect = this.getPopupParent().getBoundingClientRect();
        var minWidth;
        if (params.minWidth > 0) {
            minWidth = params.minWidth;
        }
        else if (params.ePopup.clientWidth > 0) {
            minWidth = params.ePopup.clientWidth;
        }
        else {
            minWidth = 200;
        }
        var widthOfParent = parentRect.right - parentRect.left;
        var maxX = widthOfParent - minWidth - 5;
        if (x > maxX) {
            return maxX;
        }
        else if (x < 0) {
            return 0;
        }
        else {
            return x;
        }
    };
    //adds an element to a div, but also listens to background checking for clicks,
    //so that when the background is clicked, the child is removed again, giving
    //a model look to popups.
    PopupService.prototype.addAsModalPopup = function (eChild, closeOnEsc, closedCallback, click) {
        var _this = this;
        var eBody = this.gridOptionsWrapper.getDocument();
        if (!eBody) {
            console.warn('ag-grid: could not find the body of the document, document.body is empty');
            return;
        }
        eChild.style.top = '0px';
        eChild.style.left = '0px';
        var popupAlreadyShown = utils_1.Utils.isVisible(eChild);
        if (popupAlreadyShown) {
            return;
        }
        var ePopupParent = this.getPopupParent();
        // add env CSS class to child, in case user provided a popup parent, which means
        // theme class may be missing
        var eWrapper = document.createElement('div');
        utils_1.Utils.addCssClass(eWrapper, this.environment.getTheme());
        eWrapper.appendChild(eChild);
        ePopupParent.appendChild(eWrapper);
        this.activePopupElements.push(eChild);
        var popupHidden = false;
        var hidePopupOnKeyboardEvent = function (event) {
            var key = event.which || event.keyCode;
            if (key === constants_1.Constants.KEY_ESCAPE) {
                hidePopup(null);
            }
        };
        var hidePopupOnMouseEvent = function (event) {
            hidePopup(event);
        };
        var hidePopupOnTouchEvent = function (event) {
            hidePopup(null, event);
        };
        var hidePopup = function (mouseEvent, touchEvent) {
            // we don't hide popup if the event was on the child, or any
            // children of this child
            if (_this.isEventFromCurrentPopup(mouseEvent, touchEvent, eChild)) {
                return;
            }
            // if the event to close is actually the open event, then ignore it
            if (_this.isEventSameChainAsOriginalEvent(click, mouseEvent, touchEvent)) {
                return;
            }
            // this method should only be called once. the client can have different
            // paths, each one wanting to close, so this method may be called multiple times.
            if (popupHidden) {
                return;
            }
            popupHidden = true;
            ePopupParent.removeChild(eWrapper);
            utils_1.Utils.removeFromArray(_this.activePopupElements, eChild);
            eBody.removeEventListener('keydown', hidePopupOnKeyboardEvent);
            eBody.removeEventListener('click', hidePopupOnMouseEvent);
            eBody.removeEventListener('touchstart', hidePopupOnTouchEvent);
            eBody.removeEventListener('contextmenu', hidePopupOnMouseEvent);
            if (closedCallback) {
                closedCallback();
            }
        };
        // if we add these listeners now, then the current mouse
        // click will be included, which we don't want
        setTimeout(function () {
            if (closeOnEsc) {
                eBody.addEventListener('keydown', hidePopupOnKeyboardEvent);
            }
            eBody.addEventListener('click', hidePopupOnMouseEvent);
            eBody.addEventListener('touchstart', hidePopupOnTouchEvent);
            eBody.addEventListener('contextmenu', hidePopupOnMouseEvent);
        }, 0);
        return hidePopup;
    };
    PopupService.prototype.isEventFromCurrentPopup = function (mouseEvent, touchEvent, eChild) {
        var event = mouseEvent ? mouseEvent : touchEvent;
        if (event) {
            var indexOfThisChild = this.activePopupElements.indexOf(eChild);
            for (var i = indexOfThisChild; i < this.activePopupElements.length; i++) {
                var element = this.activePopupElements[i];
                if (utils_1.Utils.isElementInEventPath(element, event)) {
                    return true;
                }
            }
        }
        return false;
    };
    // in some browsers, the context menu event can be fired before the click event, which means
    // the context menu event could open the popup, but then the click event closes it straight away.
    PopupService.prototype.isEventSameChainAsOriginalEvent = function (originalClick, mouseEvent, touchEvent) {
        // we check the coordinates of the event, to see if it's the same event. there is a 1 / 1000 chance that
        // the event is a different event, however that is an edge case that is not very relevant (the user clicking
        // twice on the same location isn't a normal path).
        // event could be mouse event or touch event.
        var mouseEventOrTouch;
        if (mouseEvent) {
            // mouse event can be used direction, it has coordinates
            mouseEventOrTouch = mouseEvent;
        }
        else if (touchEvent) {
            // touch event doesn't have coordinates, need it's touch object
            mouseEventOrTouch = touchEvent.touches[0];
        }
        if (mouseEventOrTouch && originalClick) {
            // for x, allow 4px margin, to cover iPads, where touch (which opens menu) is followed
            // by browser click (when you life finger up, touch is interrupted as click in browser)
            var xMatch = Math.abs(originalClick.screenX - mouseEvent.screenX) < 5;
            var yMatch = Math.abs(originalClick.screenY - mouseEvent.screenY) < 5;
            if (xMatch && yMatch) {
                return true;
            }
        }
        return false;
    };
    __decorate([
        context_1.Autowired('gridCore'),
        __metadata("design:type", gridCore_1.GridCore)
    ], PopupService.prototype, "gridCore", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], PopupService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('environment'),
        __metadata("design:type", environment_1.Environment)
    ], PopupService.prototype, "environment", void 0);
    PopupService = __decorate([
        context_1.Bean('popupService')
    ], PopupService);
    return PopupService;
}());
exports.PopupService = PopupService;


/***/ }),

/***/ "M6Jv":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(932);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 887:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(887) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {
	    var kendo = window.kendo;
	    var Widget = kendo.ui.Widget;
	    var keys = kendo.keys;
	    var proxy = $.proxy;

	    // Helper functions =======================================================
	    function button(dir, iconClass) {
	       return kendo.format(
	           '<button class="k-button k-button-icon k-zoom-{0}" title="zoom-{0}" aria-label="zoom-{0}"><span class="k-icon {1}"></span></button>',
	           dir, iconClass);
	    }

	    var NS = ".kendoZoomControl";
	    var BUTTONS = button("in", "k-i-plus") + button("out", "k-i-minus");

	    var PLUS = 187;
	    var MINUS = 189;
	    var FF_PLUS = 61;
	    var FF_MINUS = 173;


	    var ZoomControl = Widget.extend({
	        init: function(element, options) {
	            Widget.fn.init.call(this, element, options);
	            this._initOptions(options);

	            this.element.addClass("k-widget k-zoom-control k-button-group k-group-horizontal")
	                        .append(BUTTONS)
	                        .on("click" + NS, ".k-button", proxy(this, "_click"));

	            var parentElement = this.element.parent().closest("[" + kendo.attr("role") + "]");
	            this._keyroot = parentElement.length > 0 ? parentElement : this.element;

	            this._tabindex(this._keyroot);

	            this._keydown = proxy(this._keydown, this);
	            this._keyroot.on("keydown", this._keydown);
	        },

	        options: {
	            name: "ZoomControl",
	            zoomStep: 1
	        },

	        events: [
	            "change"
	        ],

	        _change: function(dir) {
	            var zoomStep = this.options.zoomStep;
	            this.trigger("change", {
	                delta: dir * zoomStep
	            });
	        },

	        _click: function(e) {
	            var button = $(e.currentTarget);
	            var dir = 1;

	            if (button.is(".k-zoom-out")) {
	                dir = -1;
	            }

	            this._change(dir);
	            e.preventDefault();
	        },

	        _keydown: function(e) {
	            switch (e.which) {
	                case keys.NUMPAD_PLUS:
	                case PLUS:
	                case FF_PLUS:
	                    this._change(1);
	                    break;

	                case keys.NUMPAD_MINUS:
	                case MINUS:
	                case FF_MINUS:
	                    this._change(-1);
	                    break;
	            }
	        }
	    });


	    // Exports ================================================================
	    kendo.dataviz.ui.plugin(ZoomControl);

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "MCuu":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1357);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "popup",
	    name: "Pop-up",
	    category: "framework",
	    depends: [ "core" ],
	    advanced: true
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        Class = kendo.Class,
	        support = kendo.support,
	        getOffset = kendo.getOffset,
	        outerWidth = kendo._outerWidth,
	        outerHeight = kendo._outerHeight,
	        OPEN = "open",
	        CLOSE = "close",
	        DEACTIVATE = "deactivate",
	        ACTIVATE = "activate",
	        CENTER = "center",
	        LEFT = "left",
	        RIGHT = "right",
	        TOP = "top",
	        BOTTOM = "bottom",
	        ABSOLUTE = "absolute",
	        HIDDEN = "hidden",
	        BODY = "body",
	        LOCATION = "location",
	        POSITION = "position",
	        VISIBLE = "visible",
	        EFFECTS = "effects",
	        ACTIVE = "k-state-active",
	        ACTIVEBORDER = "k-state-border",
	        ACTIVEBORDERREGEXP = /k-state-border-(\w+)/,
	        ACTIVECHILDREN = ".k-picker-wrap, .k-dropdown-wrap, .k-link",
	        MOUSEDOWN = "down",
	        DOCUMENT_ELEMENT = $(document.documentElement),
	        proxy = $.proxy,
	        WINDOW = $(window),
	        SCROLL = "scroll",
	        cssPrefix = support.transitions.css,
	        TRANSFORM = cssPrefix + "transform",
	        extend = $.extend,
	        NS = ".kendoPopup",
	        styles = ["font-size",
	                  "font-family",
	                  "font-stretch",
	                  "font-style",
	                  "font-weight",
	                  "line-height"];

	    function contains(container, target) {
	        if (!container || !target) {
	            return false;
	        }
	        return container === target || $.contains(container, target);
	    }

	    var Popup = Widget.extend({
	        init: function(element, options) {
	            var that = this, parentPopup;

	            options = options || {};

	            if (options.isRtl) {
	                options.origin = options.origin || BOTTOM + " " + RIGHT;
	                options.position = options.position || TOP + " " + RIGHT;
	            }

	            Widget.fn.init.call(that, element, options);

	            element = that.element;
	            options = that.options;

	            that.collisions = options.collision ? options.collision.split(" ") : [];
	            that.downEvent = kendo.applyEventMap(MOUSEDOWN, kendo.guid());

	            if (that.collisions.length === 1) {
	                that.collisions.push(that.collisions[0]);
	            }

	            parentPopup = $(that.options.anchor).closest(".k-popup,.k-group").filter(":not([class^=km-])"); // When popup is in another popup, make it relative.

	            options.appendTo = $($(options.appendTo)[0] || parentPopup[0] || document.body);

	            that.element.hide()
	                .addClass("k-popup k-group k-reset")
	                .toggleClass("k-rtl", !!options.isRtl)
	                .css({ position : ABSOLUTE })
	                .appendTo(options.appendTo)
	                .attr("aria-hidden", true)
	                .on("mouseenter" + NS, function() {
	                    that._hovered = true;
	                })
	                .on("wheel" + NS, function(e) {
	                    var list = $(e.target).find(".k-list");
	                    var scrollArea = list.parent();
	                    if (list.length && list.is(":visible") && ((scrollArea.scrollTop() === 0 && e.originalEvent.deltaY < 0) ||
	                        (scrollArea.scrollTop() === scrollArea.prop('scrollHeight') - scrollArea.prop('offsetHeight') && e.originalEvent.deltaY > 0))) {
	                           e.preventDefault();
	                    }
	                })
	                .on("mouseleave" + NS, function() {
	                    that._hovered = false;
	                });

	            that.wrapper = $();

	            if (options.animation === false) {
	                options.animation = { open: { effects: {} }, close: { hide: true, effects: {} } };
	            }

	            extend(options.animation.open, {
	                complete: function() {
	                    that.wrapper.css({ overflow: VISIBLE }); // Forcing refresh causes flickering in mobile.
	                    that._activated = true;
	                    that._trigger(ACTIVATE);
	                }
	            });

	            extend(options.animation.close, {
	                complete: function() {
	                    that._animationClose();
	                }
	            });

	            that._mousedownProxy = function(e) {
	                that._mousedown(e);
	            };

	            if (support.mobileOS.android) {
	                that._resizeProxy = function(e) {
	                    setTimeout(function() {
	                        that._resize(e);
	                    }, 600); //Logic from kendo.onResize
	                };
	            } else {
	                that._resizeProxy = function(e) {
	                    that._resize(e);
	                };
	            }

	            if (options.toggleTarget) {
	                $(options.toggleTarget).on(options.toggleEvent + NS, $.proxy(that.toggle, that));
	            }
	        },

	        events: [
	            OPEN,
	            ACTIVATE,
	            CLOSE,
	            DEACTIVATE
	        ],

	        options: {
	            name: "Popup",
	            toggleEvent: "click",
	            origin: BOTTOM + " " + LEFT,
	            position: TOP + " " + LEFT,
	            anchor: BODY,
	            appendTo: null,
	            collision: "flip fit",
	            viewport: window,
	            copyAnchorStyles: true,
	            autosize: false,
	            modal: false,
	            adjustSize: {
	                width: 0,
	                height: 0
	            },
	            animation: {
	                open: {
	                    effects: "slideIn:down",
	                    transition: true,
	                    duration: 200
	                },
	                close: { // if close animation effects are defined, they will be used instead of open.reverse
	                    duration: 100,
	                    hide: true
	                }
	            }
	        },

	        _animationClose: function() {
	            var that = this;
	            var location = that.wrapper.data(LOCATION);

	            that.wrapper.hide();

	            if (location) {
	                that.wrapper.css(location);
	            }

	            if (that.options.anchor != BODY) {
	                that._hideDirClass();
	            }

	            that._closing = false;
	            that._trigger(DEACTIVATE);
	        },

	        destroy: function() {
	            var that = this,
	                options = that.options,
	                element = that.element.off(NS),
	                parent;

	            Widget.fn.destroy.call(that);

	            if (options.toggleTarget) {
	                $(options.toggleTarget).off(NS);
	            }

	            if (!options.modal) {
	                DOCUMENT_ELEMENT.off(that.downEvent, that._mousedownProxy);
	                that._toggleResize(false);
	            }

	            kendo.destroy(that.element.children());
	            element.removeData();

	            if (options.appendTo[0] === document.body) {
	                parent = element.parent(".k-animation-container");

	                if (parent[0]) {
	                    parent.remove();
	                } else {
	                    element.remove();
	                }
	            }
	        },

	        open: function(x, y) {
	            var that = this,
	                fixed = { isFixed: !isNaN(parseInt(y,10)), x: x, y: y },
	                element = that.element,
	                options = that.options,
	                animation, wrapper,
	                anchor = $(options.anchor),
	                mobile = element[0] && element.hasClass("km-widget");

	            if (!that.visible()) {
	                if (options.copyAnchorStyles) {
	                    if (mobile && styles[0] == "font-size") {
	                        styles.shift();
	                    }
	                    element.css(kendo.getComputedStyles(anchor[0], styles));
	                }

	                if (element.data("animating") || that._trigger(OPEN)) {
	                    return;
	                }

	                that._activated = false;

	                if (!options.modal) {
	                    DOCUMENT_ELEMENT.off(that.downEvent, that._mousedownProxy)
	                                .on(that.downEvent, that._mousedownProxy);

	                    // this binding hangs iOS in editor
	                    // all elements in IE7/8 fire resize event, causing mayhem
	                    that._toggleResize(false);
	                    that._toggleResize(true);
	                }

	                that.wrapper = wrapper = kendo.wrap(element, options.autosize)
	                                        .css({
	                                            overflow: HIDDEN,
	                                            display: "block",
	                                            position: ABSOLUTE
	                                        })
	                                        .attr("aria-hidden", false);

	                if (support.mobileOS.android) {
	                    wrapper.css(TRANSFORM, "translatez(0)"); // Android is VERY slow otherwise. Should be tested in other droids as well since it may cause blur.
	                }

	                wrapper.css(POSITION);

	                if ($(options.appendTo)[0] == document.body) {
	                    wrapper.css(TOP, "-10000px");
	                }

	                that.flipped = that._position(fixed);
	                animation = that._openAnimation();

	                if (options.anchor != BODY) {
	                    that._showDirClass(animation);
	                }

	                if (!element.is(":visible") && element.data("olddisplay") === undefined) {
	                    element.show();
	                    element.data("olddisplay", element.css("display"));
	                    element.hide();
	                }

	                element.data(EFFECTS, animation.effects)
	                       .kendoStop(true)
	                       .kendoAnimate(animation)
	                       .attr("aria-hidden", false);
	            }
	        },

	        _location: function(isFixed) {
	            var that = this,
	                element = that.element,
	                options = that.options,
	                wrapper,
	                anchor = $(options.anchor),
	                mobile = element[0] && element.hasClass("km-widget");

	            if (options.copyAnchorStyles) {
	                if (mobile && styles[0] == "font-size") {
	                    styles.shift();
	                }
	                element.css(kendo.getComputedStyles(anchor[0], styles));
	            }

	            that.wrapper = wrapper = kendo.wrap(element, options.autosize)
	                                    .css({
	                                        overflow: HIDDEN,
	                                        display: "block",
	                                        position: ABSOLUTE
	                                    });

	            if (support.mobileOS.android) {
	                wrapper.css(TRANSFORM, "translatez(0)"); // Android is VERY slow otherwise. Should be tested in other droids as well since it may cause blur.
	            }

	            wrapper.css(POSITION);

	            if ($(options.appendTo)[0] == document.body) {
	                wrapper.css(TOP, "-10000px");
	            }

	            that._position(isFixed || {});

	            var offset = wrapper.offset();
	            return {
	                width: kendo._outerWidth(wrapper),
	                height: kendo._outerHeight(wrapper),
	                left: offset.left,
	                top: offset.top
	            };
	        },

	        _openAnimation: function() {
	            var animation = extend(true, {}, this.options.animation.open);
	            animation.effects = kendo.parseEffects(animation.effects, this.flipped);

	            return animation;
	        },

	        _hideDirClass: function() {
	            var anchor = $(this.options.anchor);
	            var direction = ((anchor.attr("class") || "").match(ACTIVEBORDERREGEXP) || ["", "down"])[1];
	            var dirClass = ACTIVEBORDER + "-" + direction;

	            anchor
	                .removeClass(dirClass)
	                .children(ACTIVECHILDREN)
	                .removeClass(ACTIVE)
	                .removeClass(dirClass);

	            this.element.removeClass(ACTIVEBORDER + "-" + kendo.directions[direction].reverse);
	        },

	        _showDirClass: function(animation) {
	            var direction = animation.effects.slideIn ? animation.effects.slideIn.direction : "down";
	            var dirClass = ACTIVEBORDER + "-" + direction;

	            $(this.options.anchor)
	                .addClass(dirClass)
	                .children(ACTIVECHILDREN)
	                .addClass(ACTIVE)
	                .addClass(dirClass);

	            this.element.addClass(ACTIVEBORDER + "-" + kendo.directions[direction].reverse);
	        },

	        position: function() {
	            if (this.visible()) {
	                this.flipped = this._position();
	                //this._hideDirClass();
	                //this._showDirClass(this._openAnimation());
	            }
	        },

	        toggle: function() {
	            var that = this;

	            that[that.visible() ? CLOSE : OPEN]();
	        },

	        visible: function() {
	            return this.element.is(":" + VISIBLE);
	        },

	        close: function(skipEffects) {
	            var that = this,
	                options = that.options, wrap,
	                animation, openEffects, closeEffects;

	            if (that.visible()) {
	                wrap = (that.wrapper[0] ? that.wrapper : kendo.wrap(that.element).hide());

	                that._toggleResize(false);

	                if (that._closing || that._trigger(CLOSE)) {
	                    that._toggleResize(true);
	                    return;
	                }

	                // Close all inclusive popups.
	                that.element.find(".k-popup").each(function () {
	                    var that = $(this),
	                        popup = that.data("kendoPopup");

	                    if (popup) {
	                        popup.close(skipEffects);
	                    }
	                });

	                DOCUMENT_ELEMENT.off(that.downEvent, that._mousedownProxy);

	                if (skipEffects) {
	                    animation = { hide: true, effects: {} };
	                } else {
	                    animation = extend(true, {}, options.animation.close);
	                    openEffects = that.element.data(EFFECTS);
	                    closeEffects = animation.effects;

	                    if (!closeEffects && !kendo.size(closeEffects) && openEffects && kendo.size(openEffects)) {
	                        animation.effects = openEffects;
	                        animation.reverse = true;
	                    }

	                    that._closing = true;
	                }

	                that.element
	                        .kendoStop(true)
	                        .attr("aria-hidden", true);
	                wrap
	                    .css({ overflow: HIDDEN }) // stop callback will remove hidden overflow
	                    .attr("aria-hidden", true);
	                that.element.kendoAnimate(animation);

	                if (skipEffects) {
	                    that._animationClose();
	                }
	            }
	        },

	        _trigger: function(ev) {
	            return this.trigger(ev, { type: ev });
	        },

	        _resize: function(e) {
	            var that = this;

	            if (support.resize.indexOf(e.type) !== -1) {
	                clearTimeout(that._resizeTimeout);
	                that._resizeTimeout = setTimeout(function() {
	                    that._position();
	                    that._resizeTimeout = null;
	                }, 50);
	            } else {
	                if (!that._hovered || (that._activated && that.element.hasClass("k-list-container"))) {
	                    that.close();
	                }
	            }
	        },

	        _toggleResize: function(toggle) {
	            var method = toggle ? "on" : "off";
	            var eventNames = support.resize;

	            if (!(support.mobileOS.ios || support.mobileOS.android || support.browser.safari)) {
	                eventNames += " " + SCROLL;
	            }

	            if (toggle && !this.scrollableParents) {
	                this.scrollableParents = this._scrollableParents();
	            }

	            if (this.scrollableParents && this.scrollableParents.length) {
	                this.scrollableParents[method](SCROLL, this._resizeProxy);
	            }

	            WINDOW[method](eventNames, this._resizeProxy);
	        },

	        _mousedown: function(e) {
	            var that = this,
	                container = that.element[0],
	                options = that.options,
	                anchor = $(options.anchor)[0],
	                toggleTarget = options.toggleTarget,
	                target = kendo.eventTarget(e),
	                popup = $(target).closest(".k-popup"),
	                mobile = popup.parent().parent(".km-shim").length;

	            popup = popup[0];
	            if (!mobile && popup && popup !== that.element[0]){
	                return;
	            }

	            // This MAY result in popup not closing in certain cases.
	            if ($(e.target).closest("a").data("rel") === "popover") {
	                return;
	            }

	            if (!contains(container, target) && !contains(anchor, target) && !(toggleTarget && contains($(toggleTarget)[0], target))) {
	                that.close();
	            }
	        },

	        _fit: function(position, size, viewPortSize) {
	            var output = 0;

	            if (position + size > viewPortSize) {
	                output = viewPortSize - (position + size);
	            }

	            if (position < 0) {
	                output = -position;
	            }

	            return output;
	        },

	        _flip: function(offset, size, anchorSize, viewPortSize, origin, position, boxSize) {
	            var output = 0;
	                boxSize = boxSize || size;

	            if (position !== origin && position !== CENTER && origin !== CENTER) {
	                if (offset + boxSize > viewPortSize) {
	                    output += -(anchorSize + size);
	                }

	                if (offset + output < 0) {
	                    output += anchorSize + size;
	                }
	            }
	            return output;
	        },

	        _scrollableParents: function() {
	            return $(this.options.anchor)
	                       .parentsUntil("body")
	                       .filter(function(index, element) {
	                           return kendo.isScrollable(element);
	                       });
	        },

	        _position: function(fixed) {
	            var that = this,
	                //element = that.element.css(POSITION, ""), /* fixes telerik/kendo-ui-core#790, comes from telerik/kendo#615 */
	                element = that.element,
	                wrapper = that.wrapper,
	                options = that.options,
	                viewport = $(options.viewport),
	                zoomLevel = support.zoomLevel(),
	                isWindow = !!((viewport[0] == window) && window.innerWidth && (zoomLevel <= 1.02)),
	                anchor = $(options.anchor),
	                origins = options.origin.toLowerCase().split(" "),
	                positions = options.position.toLowerCase().split(" "),
	                collisions = that.collisions,
	                siblingContainer, parents,
	                parentZIndex, zIndex = 10002,
	                idx = 0,
	                docEl = document.documentElement,
	                length, viewportOffset, viewportWidth, viewportHeight;

	            if (options.viewport === window) {
	                viewportOffset = {
	                    top: (window.pageYOffset || document.documentElement.scrollTop || 0),
	                    left: (window.pageXOffset || document.documentElement.scrollLeft || 0)
	                };
	            } else {
	                viewportOffset = viewport.offset();
	            }

	            if (isWindow) {
	                viewportWidth = window.innerWidth;
	                viewportHeight = window.innerHeight;
	            } else {
	                viewportWidth = viewport.width();
	                viewportHeight = viewport.height();
	            }

	            if (isWindow && docEl.scrollHeight - docEl.clientHeight > 0) {
	                 var sign = options.isRtl ? -1 : 1;

	                 viewportWidth -= sign * kendo.support.scrollbar();
	            }

	            siblingContainer = anchor.parents().filter(wrapper.siblings());

	            if (siblingContainer[0]) {
	                parentZIndex = Math.max(Number(siblingContainer.css("zIndex")), 0);

	                // set z-index to be more than that of the container/sibling
	                // compensate with more units for window z-stack
	                if (parentZIndex) {
	                    zIndex = parentZIndex + 10;
	                } else {
	                    parents = anchor.parentsUntil(siblingContainer);
	                    for (length = parents.length; idx < length; idx++) {
	                        parentZIndex = Number($(parents[idx]).css("zIndex"));
	                        if (parentZIndex && zIndex < parentZIndex) {
	                            zIndex = parentZIndex + 10;
	                        }
	                    }
	                }
	            }

	            wrapper.css("zIndex", zIndex);

	            if (fixed && fixed.isFixed) {
	                wrapper.css({ left: fixed.x, top: fixed.y });
	            } else {
	                wrapper.css(that._align(origins, positions));
	            }

	            var pos = getOffset(wrapper, POSITION, anchor[0] === wrapper.offsetParent()[0]),
	                offset = getOffset(wrapper),
	                anchorParent = anchor.offsetParent().parent(".k-animation-container,.k-popup,.k-group"); // If the parent is positioned, get the current positions

	            if (anchorParent.length) {
	                pos = getOffset(wrapper, POSITION, true);
	                offset = getOffset(wrapper);
	            }

	            offset.top -= viewportOffset.top;
	            offset.left -= viewportOffset.left;

	            if (!that.wrapper.data(LOCATION)) { // Needed to reset the popup location after every closure - fixes the resize bugs.
	                wrapper.data(LOCATION, extend({}, pos));
	            }

	            var offsets = extend({}, offset),
	                location = extend({}, pos),
	                adjustSize = options.adjustSize;

	            if (collisions[0] === "fit") {
	                location.top += that._fit(offsets.top, outerHeight(wrapper) + adjustSize.height, viewportHeight / zoomLevel);
	            }

	            if (collisions[1] === "fit") {
	                location.left += that._fit(offsets.left, outerWidth(wrapper) + adjustSize.width, viewportWidth / zoomLevel);
	            }

	            var flipPos = extend({}, location);
	            var elementHeight = outerHeight(element);
	            var wrapperHeight =  outerHeight(wrapper);

	            if (!wrapper.height() && elementHeight) {
	                wrapperHeight = wrapperHeight + elementHeight;
	            }

	            if (collisions[0] === "flip") {
	                location.top += that._flip(offsets.top, elementHeight, outerHeight(anchor), viewportHeight / zoomLevel, origins[0], positions[0], wrapperHeight);
	            }

	            if (collisions[1] === "flip") {
	                location.left += that._flip(offsets.left, outerWidth(element), outerWidth(anchor), viewportWidth / zoomLevel, origins[1], positions[1], outerWidth(wrapper));
	            }

	            element.css(POSITION, ABSOLUTE);
	            wrapper.css(location);

	            return (location.left != flipPos.left || location.top != flipPos.top);
	        },

	        _align: function(origin, position) {
	            var that = this,
	                element = that.wrapper,
	                anchor = $(that.options.anchor),
	                verticalOrigin = origin[0],
	                horizontalOrigin = origin[1],
	                verticalPosition = position[0],
	                horizontalPosition = position[1],
	                anchorOffset = getOffset(anchor),
	                appendTo = $(that.options.appendTo),
	                appendToOffset,
	                width = outerWidth(element),
	                height = outerHeight(element) || outerHeight(element.children().first()),
	                anchorWidth = outerWidth(anchor),
	                anchorHeight = outerHeight(anchor),
	                top = anchorOffset.top,
	                left = anchorOffset.left,
	                round = Math.round;

	            if (appendTo[0] != document.body) {
	                appendToOffset = getOffset(appendTo);
	                top -= appendToOffset.top;
	                left -= appendToOffset.left;
	            }


	            if (verticalOrigin === BOTTOM) {
	                top += anchorHeight;
	            }

	            if (verticalOrigin === CENTER) {
	                top += round(anchorHeight / 2);
	            }

	            if (verticalPosition === BOTTOM) {
	                top -= height;
	            }

	            if (verticalPosition === CENTER) {
	                top -= round(height / 2);
	            }

	            if (horizontalOrigin === RIGHT) {
	                left += anchorWidth;
	            }

	            if (horizontalOrigin === CENTER) {
	                left += round(anchorWidth / 2);
	            }

	            if (horizontalPosition === RIGHT) {
	                left -= width;
	            }

	            if (horizontalPosition === CENTER) {
	                left -= round(width / 2);
	            }

	            return {
	                top: top,
	                left: left
	            };
	        }
	    });

	    ui.plugin(Popup);

	    var stableSort = kendo.support.stableSort;
	    var tabKeyTrapNS = "kendoTabKeyTrap";
	    var focusableNodesSelector = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex], *[contenteditable]";
	    var TabKeyTrap = Class.extend({
	        init: function(element) {
	            this.element = $(element);
	            this.element.autoApplyNS(tabKeyTrapNS);
	        },

	        trap: function() {
	            this.element.on("keydown", proxy(this._keepInTrap, this));
	        },

	        removeTrap: function() {
	            this.element.kendoDestroy(tabKeyTrapNS);
	        },

	        destroy: function() {
	            this.element.kendoDestroy(tabKeyTrapNS);
	            this.element = undefined;
	        },

	        shouldTrap: function () {
	            return true;
	        },

	        _keepInTrap: function(e) {
	            if (e.which !== 9 || !this.shouldTrap() || e.isDefaultPrevented()) {
	                return;
	            }

	            var elements = this._focusableElements();
	            var sortedElements = this._sortFocusableElements(elements);
	            var next = this._nextFocusable(e, sortedElements);

	            this._focus(next);

	            e.preventDefault();
	        },
	        _focusableElements: function(){
	            var elements = this.element.find(focusableNodesSelector).filter(function(i, item){
	                return item.tabIndex >= 0 && $(item).is(':visible') && !$(item).is('[disabled]');
	            });

	            if (this.element.is("[tabindex]")) {
	                elements.push(this.element[0]);
	            }

	            return elements;
	        },
	        _sortFocusableElements: function(elements){
	            var sortedElements;

	            if (stableSort) {
	                sortedElements = elements.sort(function(prev, next) {
	                    return prev.tabIndex - next.tabIndex;
	                });
	            } else {
	                var attrName = "__k_index";
	                elements.each(function(i, item){
	                    item.setAttribute(attrName, i);
	                });

	                sortedElements = elements.sort(function(prev, next) {
	                    return prev.tabIndex === next.tabIndex ?
	                        parseInt(prev.getAttribute(attrName), 10) - parseInt(next.getAttribute(attrName), 10) :
	                        prev.tabIndex - next.tabIndex;
	                });

	                elements.removeAttr(attrName);
	            }

	            return sortedElements;
	        },
	        _nextFocusable: function(e, elements){
	            var count = elements.length;
	            var current = elements.index(e.target);

	            return elements.get((current + (e.shiftKey ? -1 : 1)) % count);
	        },
	        _focus: function(element){
	            if (element.nodeName == "IFRAME") {
	                element.contentWindow.document.body.focus();
	                return;
	            }

	            element.focus();

	            if (element.nodeName == "INPUT" && element.setSelectionRange && this._haveSelectionRange(element)) {
	                element.setSelectionRange(0, element.value.length);
	            }
	        },
	        _haveSelectionRange: function(element){
	            var elementType = element.type.toLowerCase();

	            return elementType === "text" || elementType === "search" ||
	            elementType === "url" || elementType === "tel" ||
	            elementType === "password";
	        }
	    });
	    ui.Popup.TabKeyTrap = TabKeyTrap;
	})(window.kendo.jQuery);



	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "MDpr":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1613);
	module.exports = __webpack_require__(1613);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 949:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ZruT");

/***/ }),

/***/ 964:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("QbYn");

/***/ }),

/***/ 1591:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("+FHp");

/***/ }),

/***/ 1606:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7Ygf");

/***/ }),

/***/ 1613:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1614), __webpack_require__(1591), __webpack_require__(964), __webpack_require__(1606), __webpack_require__(1615), __webpack_require__(949) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	    "use strict";

	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var spreadsheet = kendo.spreadsheet;
	    var CellRef = spreadsheet.CellRef;
	    var kdrw = kendo.drawing;
	    var formatting = spreadsheet.formatting;
	    var geo = kendo.geometry;

	    var GUIDELINE_WIDTH = 0.8;

	    /* jshint eqnull:true, laxbreak:true, shadow:true, -W054 */
	    /* jshint latedef: nofunc */

	    // This takes a list of row heights and the page height, and
	    // produces a list of Y coordinates for each row, such that rows
	    // are not truncated across pages.  However, the algorithm will
	    // decide to truncate a row in the event that more than
	    // `maxEmpty` (default 0.2) of the available space would
	    // otherwise be left blank.
	    //
	    // It will be used for horizontal splitting too (will receive
	    // column widths and page width, and produce a list of X coords).
	    //
	    // If the third argument (headerRows) is not null, it specifies a
	    // number of rows to repeat on each page.  On pages other than the
	    // first, the necessary space will be skipped at the top.  Header
	    // coordinates (except for the first page) are pushed in
	    // headerCoords.
	    function distributeCoords(heights, pageHeight, maxEmpty, headerRows, headerCoords) {
	        var curr = 0;
	        var out = [];
	        var bottom = pageHeight;
	        var header = 0;
	        if (pageHeight && maxEmpty) {
	            maxEmpty *= pageHeight;
	        }
	        heights.forEach(function(h, i){
	            if (headerRows != null && i < headerRows) {
	                header += h;
	            }
	            if (pageHeight && curr + h > bottom) {
	                if (bottom - curr < maxEmpty) {
	                    // align to next page
	                    curr = pageHeight * Math.ceil(curr / pageHeight) + header;
	                    if (header > 0) {
	                        headerCoords.push(curr - header);
	                    }
	                }
	                // update bottom anyway; don't just add pageHeight, as
	                // we might need multiple pages for the pathological
	                // case of one row higher than the page.
	                bottom += pageHeight * Math.ceil(h / pageHeight);
	            }
	            out.push(curr);
	            curr += h;
	        });
	        out.push(curr);
	        return out;
	    }

	    function doLayout(sheet, range, options) {
	        // normalize reference so we don't have to deal with Infinity here.
	        var grid = sheet._grid;
	        range = grid.normalize(range);

	        var wholeRect = grid.rectangle(range);
	        var drawings = [];
	        sheet._drawings.forEach(function(d) {
	            var box = sheet.drawingBoundingBox(d);
	            if (box.intersects(wholeRect)) {
	                drawings.push({
	                    drawing: d,
	                    box: box.offset(-wholeRect.left, -wholeRect.top)
	                });
	            }
	        });

	        // 1. obtain the list of cells that need to be printed, the
	        //    row heights and column widths.  Place in each cell row,
	        //    col (relative to range, i.e. first is 0,0), rowspan,
	        //    colspan and merged.  also place a list of drawings
	        //    anchored to that cell.
	        var cells = [];
	        var rowHeights = [];
	        var colWidths = [];
	        var mergedCells = sheet._getMergedCells(range);

	        var maxRow = -1, maxCol = -1;
	        sheet.forEach(range, function(row, col, cell){
	            var relrow = row - range.topLeft.row;
	            var relcol = col - range.topLeft.col;
	            var rh = sheet.rowHeight(row);
	            var cw = sheet.columnWidth(col);
	            if (!options.forScreen) {
	                // for printing we'll need the list of anchored
	                // drawings so that we can adjust them after page
	                // splitting.
	                cell.drawings = drawings.filter(function(d){
	                    var tl = d.drawing.topLeftCell;
	                    if (tl && tl.row == row && tl.col == col) {
	                        maxRow = Math.max(maxRow, sheet._rows.index(d.box.bottom));
	                        maxCol = Math.max(maxCol, sheet._columns.index(d.box.right));
	                        return true;
	                    }
	                });
	            }
	            if (!relcol) {
	                rowHeights.push(rh);
	            }
	            if (!relrow) {
	                colWidths.push(cw);
	            }
	            if (sheet.isHiddenColumn(col) || sheet.isHiddenRow(row) || !rh || !cw) {
	                return;
	            }
	            var nonEmpty = options.forScreen || shouldDrawCell(cell);
	            if (!(options.emptyCells || nonEmpty)) {
	                return;
	            }
	            var id = new CellRef(row, col).print();
	            if (mergedCells.secondary[id]) {
	                return;
	            }
	            if (nonEmpty) {
	                maxRow = Math.max(maxRow, relrow);
	                maxCol = Math.max(maxCol, relcol);
	            } else {
	                cell.empty = true;
	            }
	            cell.row = relrow;
	            cell.col = relcol;
	            var m = mergedCells.primary[id];
	            if (m) {
	                delete mergedCells.primary[id];
	                cell.merged = true;
	                cell.rowspan = m.height();
	                cell.colspan = m.width();
	                if (options.forScreen) {
	                    cell.width = sheet._columns.sum(m.topLeft.col, m.bottomRight.col);
	                    cell.height = sheet._rows.sum(m.topLeft.row, m.bottomRight.row);
	                }
	            } else {
	                cell.rowspan = 1;
	                cell.colspan = 1;
	            }
	            cells.push(cell);
	        });

	        // keep only the drawable area
	        rowHeights = rowHeights.slice(0, maxRow + 1);
	        colWidths = colWidths.slice(0, maxCol + 1);

	        var pageWidth = options.pageWidth;
	        var pageHeight = options.pageHeight;
	        var scaleFactor = options.scale || 1;

	        // when fitWidth is requested, we must update the page size
	        // with the corresponding scale factor; the algorithm below
	        // (2) will continue to work, just drawing on a bigger page.
	        if (options.fitWidth) {
	            var width = colWidths.reduce(sum, 0);
	            if (width > pageWidth) {
	                scaleFactor = pageWidth / width;
	            }
	        }
	        pageWidth = Math.ceil(pageWidth / scaleFactor);
	        pageHeight = Math.ceil(pageHeight / scaleFactor);

	        // 2. calculate top, left, bottom, right, width and height for
	        //    printable cells.  Merged cells will be split across
	        //    pages, unless the first row/col is shifted to next page.
	        //    boxWidth and boxHeight get the complete drawing size.
	        //    Note that cell coordinates keep increasing, i.e. they
	        //    are not reset to zero for a new page.  The print
	        //    function translates the view to current page.
	        var hyCoords = []; // will receive header Y coordinates, if needed
	        var yCoords = distributeCoords(rowHeights, pageHeight || 0, options.maxEmpty,
	                                       options.headerRows, hyCoords);
	        var xCoords = distributeCoords(colWidths, pageWidth || 0, options.maxEmpty);
	        var boxWidth = 0;
	        var boxHeight = 0;
	        var headerCells = [];
	        cells = cells.filter(function(cell){
	            if (cell.empty && (cell.row > maxRow || cell.col > maxCol)) {
	                return false;
	            }
	            if (options.headerRows && cell.row < options.headerRows) {
	                headerCells.push(cell);
	            }
	            cell.left = xCoords[cell.col];
	            cell.top = yCoords[cell.row];
	            if (cell.merged) {
	                if (!options.forScreen) {
	                    cell.right = orlast(xCoords, cell.col + cell.colspan);
	                    cell.bottom = orlast(yCoords, cell.row + cell.rowspan);
	                    cell.width = cell.right - cell.left;
	                    cell.height = cell.bottom - cell.top;
	                } else {
	                    cell.right = cell.left + cell.width;
	                    cell.bottom = cell.top + cell.height;
	                }
	            } else {
	                cell.width = colWidths[cell.col];
	                cell.height = rowHeights[cell.row];
	                cell.bottom = cell.top + cell.height;
	                cell.right = cell.left + cell.width;
	            }
	            if (!options.forScreen) {
	                // page breaking will shift cell coordinates.  adjust
	                // anchored drawings.
	                cell.drawings.forEach(function(d){
	                    var box = d.box;
	                    box.left = cell.left + d.drawing.offsetX;
	                    box.top = cell.top + d.drawing.offsetY;
	                    box.right = box.left + box.width;
	                    box.bottom = box.top + box.height;
	                });
	            }
	            boxWidth = Math.max(boxWidth, cell.right);
	            boxHeight = Math.max(boxHeight, cell.bottom);
	            return true;
	        });

	        // 3. if any merged cells remain in "primary", they start
	        //    outside the printed range and we should still display
	        //    them partially.
	        Object.keys(mergedCells.primary).forEach(function(id){
	            var ref = mergedCells.primary[id];
	            sheet.forEach(ref.topLeft.toRangeRef(), function(row, col, cell){
	                var relrow = row - range.topLeft.row;
	                var relcol = col - range.topLeft.col;
	                cell.merged = true;
	                cell.colspan = ref.width();
	                cell.rowspan = ref.height();
	                if (relrow < 0) {
	                    cell.top = -sheet._rows.sum(row, row - relrow - 1);
	                } else {
	                    cell.top = yCoords[relrow];
	                }
	                if (relcol < 0) {
	                    cell.left = -sheet._columns.sum(col, col - relcol - 1);
	                } else {
	                    cell.left = xCoords[relcol];
	                }
	                cell.height = sheet._rows.sum(ref.topLeft.row, ref.bottomRight.row);
	                cell.width = sheet._columns.sum(ref.topLeft.col, ref.bottomRight.col);
	                if (cell.height > 0 && cell.width > 0) {
	                    // zero means a fully hidden merged cell (all rows/columns are hidden)
	                    // https://github.com/telerik/kendo-ui-core/issues/1794
	                    cell.right = cell.left + cell.width;
	                    cell.bottom = cell.top + cell.height;
	                    cell.row = relrow;
	                    cell.col = relcol;
	                    cells.push(cell);
	                }
	            });
	        });

	        // 4. replicate header rows on all pages
	        if (options.headerRows) {
	            hyCoords.forEach(function(y){
	                headerCells.forEach(function(cell){
	                    cell = clone(cell);
	                    cell.top += y;
	                    cell.bottom = cell.top + cell.height;
	                    cells.push(cell);
	                });
	                yCoords.push(y);
	            });
	            yCoords.sort(orderCoords);
	        }

	        return {
	            width    : boxWidth,
	            height   : boxHeight,
	            cells    : cells.sort(orderCells),
	            scale    : scaleFactor,
	            xCoords  : xCoords,
	            yCoords  : yCoords,
	            drawings : drawings
	        };
	    }

	    function clone(hash, target) {
	        if (!target) {
	            target = {};
	        }
	        if (Object.assign) {
	            return Object.assign(target, hash);
	        }
	        return Object.keys(hash).reduce(function(copy, key){
	            copy[key] = hash[key];
	            return copy;
	        }, target);
	    }

	    function sameBorder(a, b) {
	        return a.size === b.size && a.color === b.color;
	    }

	    function sum(a, b) {
	        return a + b;
	    }

	    function orlast(a, i) {
	        return i < a.length ? a[i] : a[a.length - 1];
	    }

	    function shouldDrawCell(cell) {
	        return cell.value != null
	            || cell.merged
	            || cell.background != null
	            || cell.borderRight != null
	            || cell.borderBottom != null
	            || (cell.validation != null && !cell.validation.value)
	            || (cell.drawings && cell.drawings.length);
	    }

	    function orderCells(a, b) {
	        if (a.top < b.top) {
	            return -1;
	        } else if (a.top == b.top) {
	            if (a.left < b.left) {
	                return -1;
	            } else if (a.left == b.left) {
	                return 0;
	            } else {
	                return 1;
	            }
	        } else {
	            return 1;
	        }
	    }

	    function orderCoords(a, b) {
	        return a < b ? -1 : a > b ? 1 : 0;
	    }

	    function drawLayout(sheet, layout, group, options) {
	        // options:
	        // - pageWidth
	        // - pageHeight
	        // - fitWidth
	        // - hCenter
	        // - vCenter
	        var ncols = Math.ceil(layout.width / options.pageWidth);
	        var nrows = Math.ceil(layout.height / options.pageHeight);
	        var pageWidth = Math.ceil(options.pageWidth / layout.scale);
	        var pageHeight = Math.ceil(options.pageHeight / layout.scale);

	        for (var j = 0; j < nrows; ++j) {
	            for (var i = 0; i < ncols; ++i) {
	                addPage(j, i);
	            }
	        }

	        function addPage(row, col) {
	            var left = col * pageWidth;
	            var right = left + pageWidth;
	            var top = row * pageHeight;
	            var bottom = top + pageHeight;
	            var endbottom = 0, endright = 0;

	            function isInside(box) {
	                if (box.right <= left || box.left >= right ||
	                    box.bottom <= top || box.top >= bottom) {
	                    return false;
	                }
	                endbottom = Math.max(box.bottom, endbottom);
	                endright = Math.max(box.right, endright);
	                return true;
	            }

	            // XXX: this can be optimized - discard cells that won't
	            // be used again, and don't walk cells that stand no
	            // chance to fit.
	            var cells = layout.cells.filter(isInside);

	            var drawings = layout.drawings.filter(function(d){
	                return isInside(d.box);
	            });

	            // merged cells might stretch beyond page; limit to that
	            endbottom = Math.min(endbottom, bottom);
	            endright = Math.min(endright, right);

	            if (cells.length || drawings.length) {
	                var page = new kdrw.Group();
	                group.append(page);
	                // page.clip(drawing.Path.fromRect(
	                //     new geo.Rect([ 0, 0 ],
	                //                  [ options.pageWidth, options.pageHeight ])));

	                var content = new kdrw.Group();
	                page.append(content);

	                content.clip(kdrw.Path.fromRect(
	                    new geo.Rect([ left - 1, top - 1 ], [ endright + 1, endbottom + 1 ])
	                ));

	                var matrix = geo.Matrix.scale(layout.scale, layout.scale)
	                    .multiplyCopy(geo.Matrix.translate(-left, -top));

	                if (options.hCenter || options.vCenter) {
	                    matrix = matrix.multiplyCopy(
	                        geo.Matrix.translate(
	                            options.hCenter ? (right - endright) / 2 : 0,
	                            options.vCenter ? (bottom - endbottom) / 2 : 0)
	                    );
	                }

	                content.transform(matrix);

	                if (options.guidelines) {
	                    var prev = null;
	                    layout.xCoords.forEach(function(x){
	                        x = Math.min(x, endright);
	                        if (x !== prev && x >= left && x <= right) {
	                            prev = x;
	                            content.append(
	                                new kdrw.Path()
	                                    .moveTo(x, top)
	                                    .lineTo(x, endbottom)
	                                    .close()
	                                    .stroke(options.guideColor, GUIDELINE_WIDTH)
	                            );
	                        }
	                    });
	                    var prev = null;
	                    layout.yCoords.forEach(function(y){
	                        y = Math.min(y, endbottom);
	                        if (y !== prev && y >= top && y <= bottom) {
	                            prev = y;
	                            content.append(
	                                new kdrw.Path()
	                                    .moveTo(left, y)
	                                    .lineTo(endright, y)
	                                    .close()
	                                    .stroke(options.guideColor, GUIDELINE_WIDTH)
	                            );
	                        }
	                    });
	                }

	                var borders = Borders(); // jshint ignore: line
	                cells.forEach(function(cell){
	                    drawCell(cell, content, options);
	                    borders.add(cell, sheet);
	                });

	                var bordersGroup = new kdrw.Group();
	                borders.vert.forEach(function(a){
	                    a.forEach(function(b){
	                        if (!b.rendered) {
	                            b.rendered = true;
	                            bordersGroup.append(
	                                new kdrw.Path()
	                                    .moveTo(b.x, b.top)
	                                    .lineTo(b.x, b.bottom)
	                                    .close()
	                                    .stroke(b.color, b.size)
	                            );
	                        }
	                    });
	                });
	                borders.horiz.forEach(function(a){
	                    a.forEach(function(b){
	                        if (!b.rendered) {
	                            b.rendered = true;
	                            bordersGroup.append(
	                                new kdrw.Path()
	                                    .moveTo(b.left, b.y)
	                                    .lineTo(b.right, b.y)
	                                    .close()
	                                    .stroke(b.color, b.size)
	                            );
	                        }
	                    });
	                });
	                content.append(bordersGroup);

	                drawings.forEach(function(d){
	                    var drawing = d.drawing;
	                    var image = drawing.image;
	                    if (image != null) {
	                        var box = d.box;
	                        var url = sheet._workbook.imageUrl(image);
	                        content.append(
	                            new kdrw.Image(url, new geo.Rect(
	                                [ box.left, box.top ],
	                                [ box.width, box.height ]
	                            )).opacity(drawing.opacity)
	                        );
	                    }
	                });
	            }
	        }
	    }

	    function drawCell(cell, content, options) {
	        var g = new kdrw.Group();
	        content.append(g);
	        var rect = new geo.Rect([ cell.left, cell.top ],
	                                [ cell.width, cell.height ]);
	        if (cell.background || cell.merged) {
	            var r2d2 = rect;
	            if (options.guidelines) {
	                r2d2 = rect.clone();
	                r2d2.origin.x += GUIDELINE_WIDTH/2 + 0.1;
	                r2d2.origin.y += GUIDELINE_WIDTH/2 + 0.1;
	                r2d2.size.width -= GUIDELINE_WIDTH + 0.2;
	                r2d2.size.height -= GUIDELINE_WIDTH + 0.2;
	            }
	            g.append(
	                new kdrw.Rect(r2d2)
	                    .fill(cell.background || "#fff")
	                    .stroke(null)
	            );
	        }
	        var val = cell.value;
	        if (val != null) {
	            var type = typeof val == "number" ? "number" : null;
	            var clip = new kdrw.Group();
	            clip.clip(kdrw.Path.fromRect(rect));
	            g.append(clip);
	            var f, format = cell.format;
	            if (!format && type == "number" && val != Math.floor(val)) {
	                format = "0.##############";
	            }
	            if (format) {
	                f = formatting.textAndColor(val, format);
	                val = f.text;
	                if (f.type) {
	                    type = f.type;
	                }
	            } else {
	                val += "";
	            }
	            if (!cell.textAlign) {
	                switch (type) {
	                  case "number":
	                  case "date":
	                  case "percent":
	                  case "currency":
	                    cell.textAlign = "right";
	                    break;
	                  case "boolean":
	                    cell.textAlign = "center";
	                    break;
	                }
	            }
	            drawText(val, (f && f.color) || cell.color || "#000", cell, clip);
	        }
	    }

	    function applyIndent(cell, style) {
	        if (cell.indent) {
	            // OOXML spec states the indent is "An integer value,
	            // where an increment of 1 represents 3 spaces".  This, of
	            // course, bears no resemblance to what Excel actually
	            // does, so we need magic numbers here.
	            var indent = 1.4 * cell.indent;
	            switch (style.textAlign) {
	              case null:
	              case "left":
	                style.paddingLeft = indent + "ch";
	                break;
	              case "right":
	                style.paddingRight = indent + "ch";
	                break;
	              case "center":
	                style.paddingLeft = indent/2 + "ch";
	                style.paddingRight = indent/2 + "ch";
	                break;
	            }
	        }
	    }

	    var CONT;
	    function drawText(text, color, cell, group) {
	        if (!CONT) {
	            CONT = document.createElement("div");
	            CONT.style.position = "fixed";
	            CONT.style.left = "0px";
	            CONT.style.top = "0px";
	            CONT.style.visibility = "hidden";
	            CONT.style.overflow = "hidden";
	            CONT.style.boxSizing = "border-box";
	            CONT.style.lineHeight = "normal";
	            document.body.appendChild(CONT);
	        }

	        if (CONT.firstChild) {
	            CONT.removeChild(CONT.firstChild);
	        }

	        CONT.style.padding = "2px 4px";
	        CONT.style.color = color;
	        CONT.style.font = makeFontDef(cell);
	        CONT.style.width = cell.width + "px";
	        CONT.style.textAlign = cell.textAlign || "left";
	        CONT.style.textDecoration = cell.underline ? "underline" : "none";

	        applyIndent(cell, CONT.style);

	        if (cell.wrap) {
	            CONT.style.whiteSpace = "pre-wrap";
	            CONT.style.overflowWrap = CONT.style.wordWrap = "break-word";
	        } else {
	            CONT.style.whiteSpace = "pre";
	            CONT.style.overflowWrap = CONT.style.wordWrap = "normal";
	        }

	        CONT.appendChild(document.createTextNode(text));

	        var vtrans = 0;
	        switch (cell.verticalAlign) {
	          case "center":
	            vtrans = (cell.height - CONT.offsetHeight) >> 1;
	            break;

	          case undefined:
	          case null:
	          case "bottom":
	            vtrans = (cell.height - CONT.offsetHeight);
	            break;
	        }
	        if (vtrans < 0) { vtrans = 0; }

	        var text_group  = kendo.drawing.drawDOM.drawText(CONT);
	        text_group.transform(geo.Matrix.translate(cell.left, cell.top + vtrans));
	        group.append(text_group);
	    }

	    function makeFontDef(cell) {
	        var font = [];
	        if (cell.italic) {
	            font.push("italic");
	        }
	        if (cell.bold) {
	            font.push("bold");
	        }
	        font.push((cell.fontSize || 12) + "px");
	        font.push((cell.fontFamily || "Arial"));
	        return font.join(" ");
	    }

	    function draw(sheet, range, options, callback) {
	        if (options == null && callback == null) {
	            callback = range;
	            options = {};
	            range = spreadsheet.SHEETREF;
	        }
	        if (callback == null) {
	            callback = options;
	            if (range instanceof spreadsheet.Range
	                || range instanceof spreadsheet.Ref
	                || typeof range == "string") {
	                options = {};
	            } else {
	                options = range;
	                range = spreadsheet.SHEETREF;
	            }
	        }
	        options = kendo.jQuery.extend({
	            paperSize  : "A4",
	            landscape  : true,
	            margin     : "1cm",
	            guidelines : true,
	            guideColor : "#aaa",
	            emptyCells : true,
	            fitWidth   : false,
	            center     : false,
	            headerRows : null,
	            maxEmpty   : 0.2,
	            scale      : 1
	        }, options);
	        var group = new kdrw.Group();
	        var paper = kendo.pdf.getPaperOptions(options);
	        group.options.set("pdf", {
	            author    : options.author,
	            creator   : options.creator,
	            date      : options.date,
	            keywords  : options.keywords,
	            margin    : paper.margin,
	            multiPage : true,
	            paperSize : paper.paperSize,
	            subject   : options.subject,
	            title     : options.title
	        });
	        var pageWidth = paper.paperSize[0];
	        var pageHeight = paper.paperSize[1];
	        if (paper.margin) {
	            pageWidth -= paper.margin.left + paper.margin.right + 1;
	            pageHeight -= paper.margin.top + paper.margin.bottom + 1;
	        }
	        options.pageWidth = pageWidth;
	        options.pageHeight = pageHeight;
	        var layout = doLayout(sheet, sheet._ref(range), options);
	        drawLayout(sheet, layout, group, options);
	        callback(group);
	    }

	    spreadsheet.Sheet.prototype.draw = function(range, options, callback) {
	        var sheet = this;
	        if (sheet._workbook) {
	            sheet.recalc(sheet._workbook._context, function(){
	                draw(sheet, range, options, callback);
	            });
	        } else {
	            draw(sheet, range, options, callback);
	        }
	    };

	    // Hack: since we index the border arrays by relative row/col we
	    // could end up with negative indexes, i.e. horiz[-2] = border.
	    // Array forEach will ignore these, so we provide a simple
	    // container here (outside code only needs forEach at this time).
	    function Container() {}
	    Container.prototype = {
	        forEach: function(f) {
	            Object.keys(this).forEach(function(key){
	                f(this[key], key, this);
	            }, this);
	        }
	    };

	    function Borders() {
	        var horiz = new Container();
	        var vert = new Container();
	        function add(cell, sheet) {
	            if (sheet) {
	                // reset borders here; the propertybag doesn't keep track of merged cells :-/ this
	                // is ugly, but the inner details of data storage have leaked everywhere anyway.
	                var pb = sheet._properties;
	                var grid = sheet._grid;
	                cell.borderLeft    = pb.get("vBorders", grid.index(cell.row, cell.col));
	                cell.borderRight   = pb.get("vBorders", grid.index(cell.row, cell.col + cell.colspan));
	                cell.borderTop     = pb.get("hBorders", grid.index(cell.row, cell.col));
	                cell.borderBottom  = pb.get("hBorders", grid.index(cell.row + cell.rowspan, cell.col));
	            }
	            if (cell.borderLeft) {
	                addVert(cell.row, cell.col, cell.borderLeft,
	                        cell.left, cell.top, cell.bottom);
	            }
	            if (cell.borderRight) {
	                addVert(cell.row, cell.col + cell.colspan, cell.borderRight,
	                        cell.right, cell.top, cell.bottom);
	            }
	            if (cell.borderTop) {
	                addHoriz(cell.row, cell.col, cell.borderTop,
	                         cell.top, cell.left, cell.right);
	            }
	            if (cell.borderBottom) {
	                addHoriz(cell.row + cell.rowspan, cell.col, cell.borderBottom,
	                         cell.bottom, cell.left, cell.right);
	            }
	        }
	        function addVert(row, col, border, x, top, bottom) {
	            var a = vert[col] || (vert[col] = new Container());
	            var prev = row > 0 && a[row - 1];
	            if (prev && sameBorder(prev, border)) {
	                a[row] = prev;
	                prev.bottom = bottom;
	            } else {
	                a[row] = {
	                    size: border.size,
	                    color: border.color,
	                    x: x,
	                    top: top,
	                    bottom: bottom
	                };
	            }
	        }
	        function addHoriz(row, col, border, y, left, right) {
	            var a = horiz[row] || (horiz[row] = new Container());
	            var prev = col > 0 && a[col - 1];
	            if (prev && sameBorder(prev, border)) {
	                a[col] = prev;
	                prev.right = right;
	            } else {
	                a[col] = {
	                    size: border.size,
	                    color: border.color,
	                    y: y,
	                    left: left,
	                    right: right
	                };
	            }
	        }
	        return { add: add, horiz: horiz, vert: vert };
	    }

	    function drawTabularData(options) {
	        var progress = new $.Deferred();
	        var promise = progress.promise();

	        options = clone(options, {
	            dataSource       : null,
	            guidelines       : true,
	            guideColor       : "#000",
	            columns          : null,
	            headerBackground : "#999",
	            headerColor      : "#000",
	            oddBackground    : null,
	            evenBackground   : null,
	            fontFamily       : "Arial",
	            fontSize         : 12,
	            paperSize        : "A4",
	            margin           : "1cm",
	            landscape        : true,
	            fitWidth         : false,
	            scale            : 1,
	            rowHeight        : 20,
	            maxEmpty         : 1,
	            useGridFormat    : true
	        });

	        // retrieve fonts; custom fonts should be already loaded
	        kendo.drawing.pdf.defineFont(
	            kendo.drawing.drawDOM.getFontFaces(document)
	        );

	        var charWidth = charWidthFunction(options.fontFamily, options.fontSize);

	        function textWidth(value) {
	            if (value != null) {
	                var width = 12;         // magic numbers :-/
	                for (var i = value.length; --i >= 0;) {
	                    width += charWidth(value.charAt(i));
	                }
	                return width;
	            }
	            return 0;
	        }

	        var border = options.guidelines ? { size: 1, color: options.guideColor } : null;

	        function mkCell(data) {
	            if (!border) {
	                return data;
	            }
	            return clone(data, {
	                borderLeft: border,
	                borderTop: border,
	                borderRight: border,
	                borderBottom: border
	            });
	        }

	        options.dataSource.fetch(function(){
	            var data = options.dataSource.data();
	            if (!data.length) {
	                return progress.reject("Empty dataset");
	            }

	            // this really must be present
	            var columns = options.columns.map(function(col){
	                if (typeof col == "string") {
	                    return { title: col, field: col };
	                } else {
	                    return col;
	                }
	            });
	            var columnTitles = columns.map(function(col){
	                return col.title || col.field;
	            });
	            var columnWidths = columnTitles.map(textWidth);

	            // prepare data for a Sheet object's fromJSON method
	            var rows = data.map(function(row, rowIndex){
	                return {
	                    cells: columns.map(function(col, colIndex){
	                        var value = row[col.field];

	                        // NOTE: value might not be string.  I added option useGridFormat (default
	                        // true), which will use a column's format, if present, to convert the value
	                        // to a string, so that we can measure the width right now.
	                        if (options.useGridFormat) {
	                            if (value != null) {
	                                if (col.format) {
	                                    value = kendo.format(col.format, value);
	                                } else {
	                                    value += "";
	                                }
	                            }
	                            // adjust the column widths while we're at it
	                            columnWidths[colIndex] = Math.max(
	                                textWidth(value),
	                                columnWidths[colIndex]
	                            );
	                        }

	                        // if options.useGridFormat is false and col.format is present, pass it over
	                        // to the spreadsheet.  In that case we should calculate the widths after
	                        // the spreadsheet is created (XXX to be implemented when someone needs it).
	                        return mkCell({
	                            value: value,
	                            format: options.useGridFormat ? null : col.format,
	                            background: rowIndex % 2 ? options.evenBackground : options.oddBackground
	                        });
	                    })
	                };
	            });

	            // insert header line
	            rows.unshift({
	                cells: columnTitles.map(function(label){
	                    return mkCell({
	                        value: label,
	                        background: options.headerBackground,
	                        color: options.headerColor
	                    });
	                })
	            });

	            // init a Sheet object.  Note that we have to add one
	            // extra-row and column, because the very last ones can't
	            // have right/bottom borders (known limitation).
	            var sheet = new kendo.spreadsheet.Sheet(
	                rows.length + 1,        // rows
	                columns.length + 1,     // columns
	                options.rowHeight,      // row height
	                50,                     // column width
	                20,                     // header height
	                20,                     // header width,
	                {                       // default cell style
	                    fontFamily: options.fontFamily,
	                    fontSize: options.fontSize,
	                    verticalAlign: "center"
	                }
	            );

	            // load data
	            sheet.fromJSON({
	                name: "Sheet1",
	                rows: rows,
	                columns: columnWidths.map(function(w, i){
	                    return { index: i, width: w };
	                })
	            });

	            sheet.draw({
	                paperSize  : options.paperSize,
	                landscape  : options.landscape,
	                margin     : options.margin,
	                guidelines : false, // using borders instead (better contrast)
	                scale      : options.scale,
	                fitWidth   : options.fitWidth,
	                maxEmpty   : options.maxEmpty,
	                headerRows : 1
	            }, progress.resolve.bind(progress));
	        });

	        return promise;
	    }

	    var CACHE_CHAR_WIDTH = {};

	    var charWidthFunction = function(fontFamily, fontSize) {
	        var id = fontSize + ":" + fontFamily;
	        var func = CACHE_CHAR_WIDTH[id];
	        if (!func) {
	            var span, div = document.createElement("div");
	            div.style.position = "fixed";
	            div.style.left = "-10000px";
	            div.style.top = "-10000px";
	            div.style.fontFamily = fontFamily;
	            div.style.fontSize = fontSize + "px";
	            div.style.whiteSpace = "pre";
	            for (var i = 32; i < 128; ++i) {
	                span = document.createElement("span");
	                span.appendChild(document.createTextNode(String.fromCharCode(i)));
	                div.appendChild(span);
	            }
	            document.body.appendChild(div);
	            var widths = {};
	            for (i = 32, span = div.firstChild; i < 128 && span; ++i, span = span.nextSibling) {
	                widths[i] = span.offsetWidth;
	            }
	            while ((span = div.firstChild)) {
	                div.removeChild(span);
	            }
	            func = CACHE_CHAR_WIDTH[id] = function(ch) {
	                var code = ch.charCodeAt(0);
	                var width = widths[code];
	                if (width == null) {
	                    // probably not an ASCII character, let's cache its width as well
	                    span = document.createElement("span");
	                    span.appendChild(document.createTextNode(String.fromCharCode(code)));
	                    div.appendChild(span);
	                    width = widths[code] = span.offsetWidth;
	                    div.removeChild(span);
	                }
	                return width;
	            };
	        }
	        return func;
	    };

	    spreadsheet.draw = {
	        Borders         : Borders,
	        doLayout        : doLayout,
	        applyIndent     : applyIndent
	    };

	    spreadsheet.drawTabularData = drawTabularData;

	}, __webpack_require__(3));


/***/ }),

/***/ 1614:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("rbj2");

/***/ }),

/***/ 1615:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("yoqx");

/***/ })

/******/ });

/***/ }),

/***/ "MPcG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var MD5 = (function () {
    function MD5() {
        this.ieCompatibility = false;
    }
    MD5.prototype.init = function () {
        this.ieCompatibility = (this.md5('hello') != '5d41402abc4b2a76b9719d911017c592');
    };
    MD5.prototype.md5cycle = function (x, k) {
        var a = x[0], b = x[1], c = x[2], d = x[3];
        a = this.ff(a, b, c, d, k[0], 7, -680876936);
        d = this.ff(d, a, b, c, k[1], 12, -389564586);
        c = this.ff(c, d, a, b, k[2], 17, 606105819);
        b = this.ff(b, c, d, a, k[3], 22, -1044525330);
        a = this.ff(a, b, c, d, k[4], 7, -176418897);
        d = this.ff(d, a, b, c, k[5], 12, 1200080426);
        c = this.ff(c, d, a, b, k[6], 17, -1473231341);
        b = this.ff(b, c, d, a, k[7], 22, -45705983);
        a = this.ff(a, b, c, d, k[8], 7, 1770035416);
        d = this.ff(d, a, b, c, k[9], 12, -1958414417);
        c = this.ff(c, d, a, b, k[10], 17, -42063);
        b = this.ff(b, c, d, a, k[11], 22, -1990404162);
        a = this.ff(a, b, c, d, k[12], 7, 1804603682);
        d = this.ff(d, a, b, c, k[13], 12, -40341101);
        c = this.ff(c, d, a, b, k[14], 17, -1502002290);
        b = this.ff(b, c, d, a, k[15], 22, 1236535329);
        a = this.gg(a, b, c, d, k[1], 5, -165796510);
        d = this.gg(d, a, b, c, k[6], 9, -1069501632);
        c = this.gg(c, d, a, b, k[11], 14, 643717713);
        b = this.gg(b, c, d, a, k[0], 20, -373897302);
        a = this.gg(a, b, c, d, k[5], 5, -701558691);
        d = this.gg(d, a, b, c, k[10], 9, 38016083);
        c = this.gg(c, d, a, b, k[15], 14, -660478335);
        b = this.gg(b, c, d, a, k[4], 20, -405537848);
        a = this.gg(a, b, c, d, k[9], 5, 568446438);
        d = this.gg(d, a, b, c, k[14], 9, -1019803690);
        c = this.gg(c, d, a, b, k[3], 14, -187363961);
        b = this.gg(b, c, d, a, k[8], 20, 1163531501);
        a = this.gg(a, b, c, d, k[13], 5, -1444681467);
        d = this.gg(d, a, b, c, k[2], 9, -51403784);
        c = this.gg(c, d, a, b, k[7], 14, 1735328473);
        b = this.gg(b, c, d, a, k[12], 20, -1926607734);
        a = this.hh(a, b, c, d, k[5], 4, -378558);
        d = this.hh(d, a, b, c, k[8], 11, -2022574463);
        c = this.hh(c, d, a, b, k[11], 16, 1839030562);
        b = this.hh(b, c, d, a, k[14], 23, -35309556);
        a = this.hh(a, b, c, d, k[1], 4, -1530992060);
        d = this.hh(d, a, b, c, k[4], 11, 1272893353);
        c = this.hh(c, d, a, b, k[7], 16, -155497632);
        b = this.hh(b, c, d, a, k[10], 23, -1094730640);
        a = this.hh(a, b, c, d, k[13], 4, 681279174);
        d = this.hh(d, a, b, c, k[0], 11, -358537222);
        c = this.hh(c, d, a, b, k[3], 16, -722521979);
        b = this.hh(b, c, d, a, k[6], 23, 76029189);
        a = this.hh(a, b, c, d, k[9], 4, -640364487);
        d = this.hh(d, a, b, c, k[12], 11, -421815835);
        c = this.hh(c, d, a, b, k[15], 16, 530742520);
        b = this.hh(b, c, d, a, k[2], 23, -995338651);
        a = this.ii(a, b, c, d, k[0], 6, -198630844);
        d = this.ii(d, a, b, c, k[7], 10, 1126891415);
        c = this.ii(c, d, a, b, k[14], 15, -1416354905);
        b = this.ii(b, c, d, a, k[5], 21, -57434055);
        a = this.ii(a, b, c, d, k[12], 6, 1700485571);
        d = this.ii(d, a, b, c, k[3], 10, -1894986606);
        c = this.ii(c, d, a, b, k[10], 15, -1051523);
        b = this.ii(b, c, d, a, k[1], 21, -2054922799);
        a = this.ii(a, b, c, d, k[8], 6, 1873313359);
        d = this.ii(d, a, b, c, k[15], 10, -30611744);
        c = this.ii(c, d, a, b, k[6], 15, -1560198380);
        b = this.ii(b, c, d, a, k[13], 21, 1309151649);
        a = this.ii(a, b, c, d, k[4], 6, -145523070);
        d = this.ii(d, a, b, c, k[11], 10, -1120210379);
        c = this.ii(c, d, a, b, k[2], 15, 718787259);
        b = this.ii(b, c, d, a, k[9], 21, -343485551);
        x[0] = this.add32(a, x[0]);
        x[1] = this.add32(b, x[1]);
        x[2] = this.add32(c, x[2]);
        x[3] = this.add32(d, x[3]);
    };
    MD5.prototype.cmn = function (q, a, b, x, s, t) {
        a = this.add32(this.add32(a, q), this.add32(x, t));
        return this.add32((a << s) | (a >>> (32 - s)), b);
    };
    MD5.prototype.ff = function (a, b, c, d, x, s, t) {
        return this.cmn((b & c) | ((~b) & d), a, b, x, s, t);
    };
    MD5.prototype.gg = function (a, b, c, d, x, s, t) {
        return this.cmn((b & d) | (c & (~d)), a, b, x, s, t);
    };
    MD5.prototype.hh = function (a, b, c, d, x, s, t) {
        return this.cmn(b ^ c ^ d, a, b, x, s, t);
    };
    MD5.prototype.ii = function (a, b, c, d, x, s, t) {
        return this.cmn(c ^ (b | (~d)), a, b, x, s, t);
    };
    MD5.prototype.md51 = function (s) {
        var n = s.length, state = [1732584193, -271733879, -1732584194, 271733878], i;
        for (i = 64; i <= s.length; i += 64) {
            this.md5cycle(state, this.md5blk(s.substring(i - 64, i)));
        }
        s = s.substring(i - 64);
        var tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        for (i = 0; i < s.length; i++)
            tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
        if (i > 55) {
            this.md5cycle(state, tail);
            for (i = 0; i < 16; i++)
                tail[i] = 0;
        }
        tail[14] = n * 8;
        this.md5cycle(state, tail);
        return state;
    };
    /* there needs to be support for Unicode here, * unless we pretend that we can redefine the MD-5
     * algorithm for multi-byte characters (perhaps by adding every four 16-bit characters and
     * shortening the sum to 32 bits). Otherwise I suthis.ggest performing MD-5 as if every character
     * was two bytes--e.g., 0040 0025 = @%--but then how will an ordinary MD-5 sum be matched?
     * There is no way to standardize text to something like UTF-8 before transformation; speed cost is
     * utterly prohibitive. The JavaScript standard itself needs to look at this: it should start
     * providing access to strings as preformed UTF-8 8-bit unsigned value arrays.
     */
    MD5.prototype.md5blk = function (s) {
        var md5blks = [], i;
        /* Andy King said do it this way. */
        for (i = 0; i < 64; i += 4) {
            md5blks[i >> 2] = s.charCodeAt(i)
                + (s.charCodeAt(i + 1) << 8)
                + (s.charCodeAt(i + 2) << 16)
                + (s.charCodeAt(i + 3) << 24);
        }
        return md5blks;
    };
    MD5.prototype.rhex = function (n) {
        var hex_chr = '0123456789abcdef'.split('');
        var s = '', j = 0;
        for (; j < 4; j++)
            s += hex_chr[(n >> (j * 8 + 4)) & 0x0F]
                + hex_chr[(n >> (j * 8)) & 0x0F];
        return s;
    };
    MD5.prototype.hex = function (x) {
        for (var i = 0; i < x.length; i++)
            x[i] = this.rhex(x[i]);
        return x.join('');
    };
    MD5.prototype.md5 = function (s) {
        return this.hex(this.md51(s));
    };
    MD5.prototype.add32 = function (a, b) {
        return this.ieCompatibility ? this.add32Compat(a, b) : this.add32Std(a, b);
    };
    /* this function is much faster, so if possible we use it. Some IEs are the only ones I know of that
     need the idiotic second function, generated by an if clause.  */
    MD5.prototype.add32Std = function (a, b) {
        return (a + b) & 0xFFFFFFFF;
    };
    MD5.prototype.add32Compat = function (x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF), msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return (msw << 16) | (lsw & 0xFFFF);
    };
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MD5.prototype, "init", null);
    MD5 = __decorate([
        main_1.Bean('md5')
    ], MD5);
    return MD5;
}());
exports.MD5 = MD5;


/***/ }),

/***/ "MRGr":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1176);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FZAa");

/***/ }),

/***/ 1176:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1088) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "drawer",
	    name: "Drawer",
	    category: "web",
	    description: "The Kendo Drawer widget provides slide to reveal sidebar",
	    depends: [ "userevents" ]
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        SHOW = "show",
	        HIDE = "hide",
	        ITEMCLICK = "itemClick",
	        PUSH = "push",
	        OVERLAY = "overlay",
	        LEFT = "left",
	        RIGHT ="right";

	    var Drawer = kendo.ui.Widget.extend({
	        init: function(element, options) {
	            var that = this;
	            var userEvents;

	            Widget.fn.init.call(this, element, options);

	            options = that.options;

	            that._element(element);

	            that._wrapper(element);

	            that.position();

	            that._mode();

	            if (options.mini) {
	                that._miniMode();
	            }

	            that._initDrawerItems();

	            if (options.mini && options.mode != PUSH) {
	                that._setBodyOffset();
	            }

	            userEvents = this.userEvents = new kendo.UserEvents(options.mode != PUSH ? $(document.body) : this.drawerContainer, { fastTap: true, allowSelection: true });

	            var tap = function(e) {
	                if ($.contains(that.drawerItemsWrapper[0], e.event.target)) {
	                    that._itemClick(e);
	                }
	                if (that.visible && !that.trigger("hide", { sender: this})) {
	                    that.hide();
	                    e.preventDefault();
	                }
	            };

	            if (this.options.swipeToOpen) {
	                userEvents.bind("start", function(e) { that._start(e); });
	                userEvents.bind("move", function(e) { that._update(e); });
	                userEvents.bind("end", function(e) {  that._end(e); });
	                userEvents.bind("tap", tap);
	            } else {
	                userEvents.bind("press", tap);
	            }

	            if (options.minHeight && options.mode == PUSH) {
	                that.drawerContainer.css("min-height", options.minHeight);
	            }
	        },

	        _element: function() {
	            var that = this;

	            var element = that.element;
	            var options = that.options;
	            var contentElement = that.contentElement = element.children().first();
	            that.drawerElement = $(options.template);

	            contentElement.addClass("k-drawer-content");
	            element.addClass("k-widget k-drawer");
	        },

	        _wrapper: function() {
	            var options = this.options;
	            var drawerElement = this.drawerElement;
	            var element = this.element;
	            var contentElement = this.contentElement;
	            var drawerItemsWrapper = this.drawerItemsWrapper =  drawerElement.wrapAll("<div class='k-drawer-items'></div>").parent();
	            var drawerWrapper = this.drawerWrapper = drawerItemsWrapper.wrap("<div class='k-drawer-wrapper'></div>").parent();
	            var drawerContainer = this.drawerContainer = element.wrap("<div class='k-drawer-container'></div>").parent();

	            if (options.mini) {
	                if (options.mini.width) {
	                    drawerWrapper.width(options.mini.width);
	                }
	            } else {
	                drawerWrapper.width(0);
	            }


	            if (options.mode === PUSH) {
	                drawerContainer.append(contentElement);
	            }
	            else if (options.mode === OVERLAY) {
	                drawerContainer.after(contentElement);
	                $(document.body).prepend(drawerContainer);
	            }

	            element.append( drawerWrapper );
	        },

	        _setBodyOffset: function() {
	            var overlayMiniOffset = this.element.outerWidth();

	            if (this.leftPositioned) {
	                $(document.body).css("padding-left", overlayMiniOffset);
	            }
	            else {
	                $(document.body).css("padding-right", overlayMiniOffset);
	            }
	        },

	        _initDrawerItems: function() {
	            var drawerItemsWrapper = this.drawerItemsWrapper;
	            var drawerItems = drawerItemsWrapper.find("[data-role='drawer-item']");
	            var separatorItems = drawerItemsWrapper.find("[data-role='drawer-separator']");

	            drawerItems.addClass("k-drawer-item");
	            separatorItems.addClass("k-drawer-item k-drawer-separator");

	            if (this._selectedItemIndex >= 0) {
	                drawerItems.removeClass("k-state-selected");
	                drawerItems.eq(this._selectedItemIndex).addClass("k-state-selected");
	            }

	        },

	        _mode: function() {
	            var options = this.options;
	            var drawerContainer = this.drawerContainer;
	            var overlayContainer;

	            if (options.mode == PUSH) {
	                drawerContainer.addClass('k-drawer-' + PUSH);
	            }
	            else {
	                drawerContainer.addClass('k-drawer-' + OVERLAY);
	                overlayContainer = this.overlayContainer = $('<div class="k-overlay"></div>');
	                overlayContainer.hide();
	                drawerContainer.prepend(overlayContainer);
	            }
	        },

	        _miniMode: function() {
	            var options = this.options;
	            var drawerContainer = this.drawerContainer;
	            var miniWidth = options.mini.width;
	            var miniTemplate = this._miniTemplate = options.mini.template && $(options.mini.template);
	            var drawerItemsWrapper = this.drawerItemsWrapper;
	            var drawerWrapper = this.drawerWrapper;

	            drawerContainer.addClass("k-drawer-mini");

	            if (miniTemplate) {
	                drawerItemsWrapper.html(miniTemplate);
	            }

	            if (miniWidth) {
	                drawerWrapper.width(miniWidth);
	            }

	            this.minWidth = options.mini.width || this.drawerWrapper.width();
	        },

	        show: function() {
	            var drawerWrapper = this.drawerWrapper;
	            var drawerContainer = this.drawerContainer;
	            var options = this.options;
	            var isExpanded = drawerContainer.hasClass("k-drawer-expanded");
	            var miniTemplate = this._miniTemplate;
	            var drawerElement = this.drawerElement;
	            var drawerItemsWrapper = this.drawerItemsWrapper;

	            if (!isExpanded) {
	                drawerContainer.addClass('k-drawer-expanded');
	                this.visible = true;
	            }

	            if (miniTemplate) {
	                drawerItemsWrapper.html(drawerElement);
	                this._initDrawerItems();
	                this._selectItem();
	            }

	            drawerWrapper.width(options.width);

	            if (options.mode === OVERLAY) {
	                this.overlayContainer.show();
	                this.visible = true;
	            }
	        },

	        hide: function() {
	            var that = this;
	            var drawerWrapper = that.drawerWrapper;
	            var drawerContainer = that.drawerContainer;
	            var options = this.options;
	            var drawerItemsWrapper = this.drawerItemsWrapper;
	            var miniTemplate = this._miniTemplate;
	            var miniWidth = options.mini && options.mini.width;

	            if (this._miniTemplate) {
	                drawerItemsWrapper.html(miniTemplate);
	                that._initDrawerItems();
	                this._selectItem();
	            }

	            if(options.mini) {
	                if (miniWidth) {
	                    drawerWrapper.width(miniWidth);
	                } else {
	                    drawerWrapper.width("");
	                }
	            } else {
	                drawerWrapper.width(0);
	            }

	            if (this.visible) {
	                drawerContainer.removeClass('k-drawer-expanded');
	                this.visible = false;
	            }

	            if (options.mode === OVERLAY) {
	                this.overlayContainer.hide();
	            }
	        },

	        position: function(value) {
	            var that = this;
	            var options = that.options;
	            var position = value || options.position;
	            var drawerContainer = that.drawerContainer;

	            if (position == RIGHT) {
	                drawerContainer.removeClass('k-drawer-'+ LEFT);
	                drawerContainer.addClass('k-drawer-'+ RIGHT);
	            }
	            else {
	                drawerContainer.removeClass('k-drawer-'+ RIGHT);
	                drawerContainer.addClass('k-drawer-'+ LEFT);
	            }

	            this.leftPositioned = position === LEFT;
	        },

	        _start: function(e) {
	            var that = this;
	            var options = this.options;
	            var drawerWrapper = this.drawerWrapper;
	            var drawerItemsWrapper = this.drawerItemsWrapper;
	            var userEvents = e.sender;


	            // ignore non-horizontal swipes
	            if (Math.abs(e.x.velocity) < Math.abs(e.y.velocity) || kendo.triggeredByInput(e.event)) {
	                userEvents.cancel();
	                return;
	            }


	            if (this.drawerMini) {
	                drawerItemsWrapper.html(that.drawerElement);
	            }

	            drawerWrapper.css("transition", "none");

	            if (options.mode != PUSH) {
	                this.overlayContainer.show();
	            }
	        },

	        _update: function(e) {
	            var options = this.options;
	            var mode = options.mode;

	                if (mode == PUSH) {
	                    this._push(e);
	                }
	                else {
	                    this._overlay(e);
	                }
	        },

	        _end: function(e) {
	            var velocity = e.x.velocity;
	            var options = this.options;
	            var drawerWrapper = this.drawerWrapper;
	            var elementWidth = drawerWrapper.width();
	            var pastHalf = elementWidth > options.width / 2;
	            var velocityThreshold = 0.8;
	            var shouldShow;

	            drawerWrapper.css("transition", "all .3s ease-out");

	            if (this.leftPositioned) {
	                shouldShow = velocity > -velocityThreshold && (velocity > velocityThreshold || pastHalf);
	            }
	             else {
	                shouldShow = velocity < velocityThreshold && (velocity < -velocityThreshold || pastHalf);
	            }

	            if(shouldShow) {
	                if (this.trigger("show", { sender: this})) {
	                    e.preventDefault();
	                    this.hide();
	                } else {
	                    this.show();
	                }
	            } else {
	                if (this.trigger("hide", { sender: this})) {
	                    e.preventDefault();
	                    this.show();
	                } else {
	                    this.hide();
	                }
	            }
	        },

	        _overlay: function(moveEventArgs) {
	            var options = this.options;
	            var minWidth = (options.mini && options.mini.width) || this.minWidth || 0;
	            var drawerWrapper = this.drawerWrapper;
	            var elementWidth = drawerWrapper.width();
	            var limitedPosition;
	            var updatedPosition;

	            updatedPosition = elementWidth + (this.leftPositioned ? moveEventArgs.x.delta : -moveEventArgs.x.delta);

	            limitedPosition = Math.min(Math.max(updatedPosition, minWidth), options.width);

	            moveEventArgs.event.preventDefault();
	            moveEventArgs.event.stopPropagation();

	            drawerWrapper.width(limitedPosition);
	        },

	        _push: function(moveEventArgs) {
	            var options = this.options;
	            var minWidth = (options.mini && options.mini.width) || this.minWidth || 0;
	            var drawerWrapper = this.drawerWrapper;
	            var elementWidth = drawerWrapper.width();
	            var limitedPosition;
	            var updatedPosition;

	            updatedPosition = elementWidth + (this.leftPositioned ? moveEventArgs.x.delta : -moveEventArgs.x.delta);

	            limitedPosition = Math.min(Math.max(updatedPosition, minWidth), options.width);

	            moveEventArgs.event.preventDefault();
	            moveEventArgs.event.stopPropagation();

	            drawerWrapper.width(limitedPosition);
	        },

	        _selectItem: function(item) {
	            var selectedItemIndex;

	            if (item) {
	                item.addClass("k-state-selected");
	                this.trigger("itemClick", {item: item, sender: this});
	                this._selectedItemIndex = item.index();
	                return;
	            }

	            selectedItemIndex = this._selectedItemIndex;

	            if (selectedItemIndex) {
	                this.drawerItemsWrapper.find("[data-role='drawer-item']").eq(selectedItemIndex).addClass("k-state-selected");
	            }
	        },

	        _itemClick: function(e) {
	            var that = this;
	            var item;
	            if ($(e.event.target).find(".k-drawer-item").length > 0) {
	                item = $(e.event.target).find(".k-drawer-item");
	            }
	            else if ($(e.event.target).closest(".k-drawer-item").length > 0) {
	                item = $(e.event.target).closest(".k-drawer-item");
	            }
	            else if ($(e.event.target).hasClass(".k-drawer-item")) {
	                item = $(e.event.target);
	            }
	            that.drawerItemsWrapper.find(".k-drawer-item").removeClass("k-state-selected");
	            that._selectItem(item);
	        },

	        destroy: function() {
	            var options = this.options;

	            if (options.mode != PUSH) {
	                if (this.leftPositioned) {
	                    $(document.body).css("padding-left", 0);
	                }
	                else {
	                    $(document.body).css("padding-right", 0);
	                }
	            }

	            Widget.fn.destroy.call(this);

	            this.userEvents.destroy();

	            kendo.destroy(this.element);
	            this.element = this.drawerWrapper = this.drawerElement = this.drawerContainer = this.drawerItemsWrapper = this._miniTemplate = null;
	        },

	        options: {
	            name: "Drawer",
	            position: LEFT,
	            mode: "overlay",
	            swipeToOpen: true,
	            width: 280,
	            mini: false,
	            template: ""
	        },

	        events: [
	            HIDE,
	            SHOW,
	            ITEMCLICK
	        ]

	    });
	    kendo.ui.plugin(Drawer);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "MU5D":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("R9M2");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "MU8w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');

module.exports = __webpack_require__("hKoQ").polyfill();


/***/ }),

/***/ "MWyb":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1100);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1100:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1059) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "data.signalr",
	    name: "SignalR",
	    category: "framework",
	    depends: [ "data" ],
	    hidden: true
	};

	(function($) {
	    var kendo = window.kendo;
	    var isFunction = kendo.isFunction;

	    function isJQueryPromise(promise) {
	        return promise && isFunction(promise.done) && isFunction(promise.fail);
	    }

	    function isNativePromise(promise) {
	        return promise && isFunction(promise.then) && isFunction(promise.catch); // jshint ignore:line
	    }

	    var transport = kendo.data.RemoteTransport.extend({
	        init: function (options) {
	            var signalr = options && options.signalr ? options.signalr : {};

	            var promise = signalr.promise;

	            if (!promise) {
	                throw new Error('The "promise" option must be set.');
	            }

	            if (!isJQueryPromise(promise) && !isNativePromise(promise)) {
	                throw new Error('The "promise" option must be a Promise.');
	            }

	            this.promise = promise;

	            var hub = signalr.hub;

	            if (!hub) {
	                throw new Error('The "hub" option must be set.');
	            }

	            if (typeof hub.on != "function" || typeof hub.invoke != "function") {
	                throw new Error('The "hub" option is not a valid SignalR hub proxy.');
	            }

	            this.hub = hub;

	            kendo.data.RemoteTransport.fn.init.call(this, options);
	        },

	        push: function(callbacks) {
	            var client = this.options.signalr.client || {};

	            if (client.create) {
	                this.hub.on(client.create, callbacks.pushCreate);
	            }

	            if (client.update) {
	                this.hub.on(client.update, callbacks.pushUpdate);
	            }

	            if (client.destroy) {
	                this.hub.on(client.destroy, callbacks.pushDestroy);
	            }
	        },

	        _crud: function(options, type) {
	            var hub = this.hub;
	            var promise = this.promise;
	            var server = this.options.signalr.server;

	            if (!server || !server[type]) {
	                throw new Error(kendo.format('The "server.{0}" option must be set.', type));
	            }

	            var args = [server[type]];

	            var data = this.parameterMap(options.data, type);

	            if (!$.isEmptyObject(data)) {
	                args.push(data);
	            }

	            if (isJQueryPromise(promise)) {
	                promise.done(function() {
	                    hub.invoke.apply(hub, args)
	                              .done(options.success)
	                              .fail(options.error);
	                });
	            } else if (isNativePromise(promise)) {
	                promise.then(function() {
	                    hub.invoke.apply(hub, args)
	                              .then(options.success)
	                              .catch(options.error); // jshint ignore:line
	                });
	            }
	        },

	        read: function(options) {
	            this._crud(options, "read");
	        },

	        create: function(options) {
	            this._crud(options, "create");
	        },

	        update: function(options) {
	            this._crud(options, "update");
	        },

	        destroy: function(options) {
	            this._crud(options, "destroy");
	        }
	    });

	    $.extend(true, kendo.data, {
	        transports: {
	            signalr: transport
	        }
	    });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "MXce":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var StatusItem = (function (_super) {
    __extends(StatusItem, _super);
    function StatusItem(label) {
        var _this = _super.call(this, StatusItem.TEMPLATE) || this;
        _this.queryForHtmlElement('#_label').innerHTML = label;
        return _this;
    }
    StatusItem.prototype.init = function () {
        this.lbValue = this.queryForHtmlElement('#_value');
    };
    StatusItem.prototype.setValue = function (value) {
        this.lbValue.innerHTML = main_1.Utils.formatNumberTwoDecimalPlacesAndCommas(value);
    };
    StatusItem.TEMPLATE = '<span class="ag-status-bar-item">' +
        '  <span id="_label"></span>' +
        '  <span id="_value"></span>' +
        '</span>';
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], StatusItem.prototype, "init", null);
    return StatusItem;
}(main_1.Component));
exports.StatusItem = StatusItem;


/***/ }),

/***/ "Mhyx":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("/bQp");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "MiQa":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1382);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1048:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("BOhp");

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {/* jshint eqnull: true */
	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1109) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "sortable",
	    name: "Sortable",
	    category: "framework",
	    depends: [ "draganddrop" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        outerWidth = kendo._outerWidth,
	        outerHeight = kendo._outerHeight,

	        START = "start",
	        BEFORE_MOVE = "beforeMove",
	        MOVE = "move",
	        END = "end",
	        CHANGE = "change",
	        CANCEL = "cancel",

	        ACTION_SORT = "sort",
	        ACTION_REMOVE = "remove",
	        ACTION_RECEIVE = "receive",

	        DEFAULT_FILTER = ">*",
	        MISSING_INDEX = -1;

	    function containsOrEqualTo(parent, child) {
	        try {
	            return $.contains(parent, child) || parent == child;
	        } catch (e) {
	            return false;
	        }
	    }

	    function defaultHint(element) {
	        return element.clone();
	    }

	    function defaultPlaceholder(element) {
	        return element.clone().removeAttr("id").css("visibility", "hidden");
	    }

	    var Sortable = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            if(!that.options.placeholder) {
	                that.options.placeholder = defaultPlaceholder;
	            }

	            if(!that.options.hint) {
	                that.options.hint = defaultHint;
	            }

	            that.draggable = that._createDraggable();
	        },

	        events: [
	            START,
	            BEFORE_MOVE,
	            MOVE,
	            END,
	            CHANGE,
	            CANCEL
	        ],

	        options: {
	            name: "Sortable",
	            hint: null,
	            placeholder: null,
	            filter: DEFAULT_FILTER,
	            holdToDrag: false,
	            disabled: null,
	            container: null,
	            connectWith: null,
	            handler: null,
	            cursorOffset: null,
	            axis: null,
	            ignore: null,
	            autoScroll: false,
	            cursor: "auto",
	            moveOnDragEnter: false
	        },

	        destroy: function() {
	            this.draggable.destroy();
	            Widget.fn.destroy.call(this);
	        },

	        _createDraggable: function() {
	            var that = this,
	                element = that.element,
	                options = that.options;

	            return new kendo.ui.Draggable(element, {
	                filter: options.filter,
	                hint: kendo.isFunction(options.hint) ? options.hint : $(options.hint),
	                holdToDrag: options.holdToDrag,
	                container: options.container ? $(options.container) : null,
	                cursorOffset: options.cursorOffset,
	                axis: options.axis,
	                ignore: options.ignore,
	                autoScroll: options.autoScroll,
	                dragstart: $.proxy(that._dragstart, that),
	                dragcancel: $.proxy(that._dragcancel, that),
	                drag: $.proxy(that._drag, that),
	                dragend: $.proxy(that._dragend, that)
	            });
	        },

	        _dragstart: function(e) {
	            var draggedElement = this.draggedElement = e.currentTarget,
	                disabled = this.options.disabled,
	                handler = this.options.handler,
	                _placeholder = this.options.placeholder,
	                placeholder = this.placeholder = kendo.isFunction(_placeholder) ? $(_placeholder.call(this, draggedElement)) : $(_placeholder);

	            if(disabled && draggedElement.is(disabled)) {
	                e.preventDefault();
	            } else if(handler && !$(e.initialTarget).is(handler)) {
	                e.preventDefault();
	            } else {

	                if(this.trigger(START, { item: draggedElement, draggableEvent: e })) {
	                    e.preventDefault();
	                } else {
	                    draggedElement.css("display", "none");
	                    draggedElement.before(placeholder);

	                    this._setCursor();
	                }

	            }
	        },

	        _dragcancel: function() {
	            this._cancel();
	            this.trigger(CANCEL, { item: this.draggedElement });

	            this._resetCursor();
	        },

	        _drag: function(e) {
	            var draggedElement = this.draggedElement,
	                target = this._findTarget(e),
	                targetCenter,
	                cursorOffset = { left: e.x.location, top: e.y.location },
	                offsetDelta,
	                axisDelta = { x: e.x.delta, y: e.y.delta },
	                direction,
	                sibling,
	                getSibling,
	                axis = this.options.axis,
	                moveOnDragEnter= this.options.moveOnDragEnter,
	                eventData = { item: draggedElement, list: this, draggableEvent: e };

	            if(axis === "x" || axis === "y") {
	                this._movementByAxis(axis, cursorOffset, axisDelta[axis], eventData);
	                return;
	            }

	            if(target) {
	                targetCenter = this._getElementCenter(target.element);

	                offsetDelta = {
	                    left: Math.round(cursorOffset.left - targetCenter.left),
	                    top: Math.round(cursorOffset.top - targetCenter.top)
	                };

	                $.extend(eventData, { target: target.element });

	                if(target.appendToBottom) {
	                    this._movePlaceholder(target, null, eventData);
	                    return;
	                }

	                if(target.appendAfterHidden) {
	                    this._movePlaceholder(target, "next", eventData);
	                }

	                if(this._isFloating(target.element)) { //horizontal
	                    if((axisDelta.x < 0 && moveOnDragEnter) || (!moveOnDragEnter && offsetDelta.left < 0)) {
	                        direction = "prev";
	                    } else if((axisDelta.x > 0 && moveOnDragEnter) || (!moveOnDragEnter &&  offsetDelta.left > 0)) {
	                        direction = "next";
	                    }
	                } else { //vertical
	                    if((axisDelta.y < 0  && moveOnDragEnter) || (!moveOnDragEnter &&  offsetDelta.top < 0)) {
	                        direction = "prev";
	                    } else if((axisDelta.y > 0  && moveOnDragEnter) || (!moveOnDragEnter &&  offsetDelta.top > 0)) {
	                        direction = "next";
	                    }
	                }

	                if(direction) {
	                    getSibling = (direction === "prev") ? jQuery.fn.prev : jQuery.fn.next;

	                    sibling = getSibling.call(target.element);

	                    //find the prev/next visible sibling
	                    while(sibling.length && !sibling.is(":visible")) {
	                        sibling = getSibling.call(sibling);
	                    }

	                    if(sibling[0] != this.placeholder[0]) {
	                        this._movePlaceholder(target, direction, eventData);
	                    }
	                }
	            }
	        },

	        _dragend: function(e) {
	            var placeholder = this.placeholder,
	                draggedElement = this.draggedElement,
	                draggedIndex = this.indexOf(draggedElement),
	                placeholderIndex = this.indexOf(placeholder),
	                connectWith = this.options.connectWith,
	                connectedList,
	                isDefaultPrevented,
	                eventData,
	                connectedListEventData;

	            this._resetCursor();

	            eventData = {
	                action: ACTION_SORT,
	                item: draggedElement,
	                oldIndex: draggedIndex,
	                newIndex: placeholderIndex,
	                draggableEvent: e
	            };

	            if(placeholderIndex >= 0) {
	                isDefaultPrevented = this.trigger(END, eventData);
	            } else {
	                connectedList = placeholder.parents(connectWith).getKendoSortable();

	                eventData.action = ACTION_REMOVE;
	                connectedListEventData = $.extend({}, eventData, {
	                    action: ACTION_RECEIVE,
	                    oldIndex: MISSING_INDEX,
	                    newIndex: connectedList.indexOf(placeholder)
	                });

	                isDefaultPrevented = !(!this.trigger(END, eventData) && !connectedList.trigger(END, connectedListEventData));
	            }

	            if(isDefaultPrevented || placeholderIndex === draggedIndex) {
	                this._cancel();
	                return;
	            }

	            placeholder.replaceWith(draggedElement);

	            draggedElement.show();
	            this.draggable.dropped = true;

	            eventData = {
	                action: this.indexOf(draggedElement) != MISSING_INDEX ? ACTION_SORT : ACTION_REMOVE,
	                item: draggedElement,
	                oldIndex: draggedIndex,
	                newIndex: this.indexOf(draggedElement),
	                draggableEvent: e
	            };

	            this.trigger(CHANGE, eventData);

	            if(connectedList) {
	                connectedListEventData = $.extend({}, eventData, {
	                    action: ACTION_RECEIVE,
	                    oldIndex: MISSING_INDEX,
	                    newIndex: connectedList.indexOf(draggedElement)
	                });

	                connectedList.trigger(CHANGE, connectedListEventData);
	            }

	        },

	        _findTarget: function(e) {
	            var element = this._findElementUnderCursor(e),
	                items,
	                connectWith = this.options.connectWith,
	                node;

	            if($.contains(this.element[0], element)) { //the element is part of the sortable container
	                items = this.items();
	                node = items.filter(element)[0] || items.has(element)[0];

	                return node ? { element: $(node), sortable: this } : null;
	            } else if (this.element[0] == element && this._isEmpty()) {
	                return { element: this.element, sortable: this, appendToBottom: true };
	            } else if (this.element[0] == element && this._isLastHidden()) {
	                node = this.items().eq(0);
	                return { element: node , sortable: this, appendAfterHidden: true };
	            } else if (connectWith) { //connected lists are present
	                return this._searchConnectedTargets(element, e);
	            }
	        },

	        _findElementUnderCursor: function(e) {
	            var elementUnderCursor = kendo.elementUnderCursor(e),
	                draggable = e.sender;

	            if(containsOrEqualTo(draggable.hint[0], elementUnderCursor)) {
	                draggable.hint.hide();
	                elementUnderCursor = kendo.elementUnderCursor(e);
	                // IE8 does not return the element in iframe from first attempt
	                if (!elementUnderCursor) {
	                    elementUnderCursor = kendo.elementUnderCursor(e);
	                }
	                draggable.hint.show();
	            }

	            return elementUnderCursor;
	        },

	        _searchConnectedTargets: function(element, e) {
	            var connected = $(this.options.connectWith),
	                sortableInstance,
	                items,
	                node;

	            for (var i = 0; i < connected.length; i++) {
	                sortableInstance = connected.eq(i).getKendoSortable();

	                if($.contains(connected[i], element)) {
	                    if(sortableInstance) {
	                        items = sortableInstance.items();
	                        node = items.filter(element)[0] || items.has(element)[0];

	                        if(node) {
	                            sortableInstance.placeholder = this.placeholder;
	                            return { element: $(node), sortable: sortableInstance };
	                        } else {
	                            return null;
	                        }
	                    }
	                } else if(connected[i] == element) {
	                    if(sortableInstance && sortableInstance._isEmpty()) {
	                        return { element: connected.eq(i), sortable: sortableInstance, appendToBottom: true };
	                    } else if (this._isCursorAfterLast(sortableInstance, e)) {
	                        node = sortableInstance.items().last();
	                        return { element: node, sortable: sortableInstance };
	                    }
	                }
	            }

	        },

	        _isCursorAfterLast: function(sortable, e) {
	            var lastItem = sortable.items().last(),
	                cursorOffset = { left: e.x.location, top: e.y.location },
	                lastItemOffset,
	                delta;

	            lastItemOffset = kendo.getOffset(lastItem);
	            lastItemOffset.top += outerHeight(lastItem);
	            lastItemOffset.left += outerWidth(lastItem);

	            if(this._isFloating(lastItem)) { //horizontal
	                delta = lastItemOffset.left - cursorOffset.left;
	            } else { //vertical
	                delta = lastItemOffset.top - cursorOffset.top;
	            }

	            return delta < 0 ? true : false;
	        },

	        _movementByAxis: function(axis, cursorOffset, delta, eventData) {
	            var cursorPosition = (axis === "x") ? cursorOffset.left : cursorOffset.top,
	                target = (delta < 0) ? this.placeholder.prev() : this.placeholder.next(),
	                items = this.items(),
	                targetCenter;

	            if (target.length && !target.is(":visible")) {
	                target = (delta <0) ? target.prev() : target.next();
	            }

	            if (!items.filter(target).length) {
	                return;
	            }

	            $.extend(eventData, { target: target });
	            targetCenter = this._getElementCenter(target);

	            if (targetCenter) {
	                targetCenter = (axis === "x") ? targetCenter.left : targetCenter.top;
	            }

	            if (target.length && delta < 0 && cursorPosition - targetCenter < 0) { //prev
	                this._movePlaceholder({ element: target, sortable: this }, "prev", eventData);
	            } else if (target.length && delta > 0 && cursorPosition - targetCenter > 0) { //next
	                this._movePlaceholder({ element: target, sortable: this }, "next", eventData);
	            }
	        },

	        _movePlaceholder: function(target, direction, eventData) {
	            var placeholder = this.placeholder;

	            if (!target.sortable.trigger(BEFORE_MOVE, eventData)) {

	                if (!direction) {
	                    target.element.append(placeholder);
	                } else if (direction === "prev") {
	                    target.element.before(placeholder);
	                } else if (direction === "next") {
	                    target.element.after(placeholder);
	                }

	                target.sortable.trigger(MOVE, eventData);
	            }
	        },

	        _setCursor: function() {
	            var cursor = this.options.cursor,
	                body;

	            if(cursor && cursor !== "auto") {
	                body = $(document.body);

	                this._originalCursorType = body.css("cursor");
	                body.css({ "cursor": cursor });

	                if(!this._cursorStylesheet) {
	                    this._cursorStylesheet = $("<style>* { cursor: " + cursor + " !important; }</style>");
	                }

	                this._cursorStylesheet.appendTo(body);
	            }
	        },

	        _resetCursor: function() {
	            if(this._originalCursorType) {
	                $(document.body).css("cursor", this._originalCursorType);
	                this._originalCursorType = null;

	                this._cursorStylesheet.remove();
	            }
	        },

	        _getElementCenter: function(element) {
	            var center = element.length ? kendo.getOffset(element) : null;
	            if(center) {
	                center.top += outerHeight(element) / 2;
	                center.left += outerWidth(element) / 2;
	            }

	            return center;
	        },

	        _isFloating: function (item) {
	            var isFloating = /left|right/.test(item.css('float'));
	            var isTable = /inline|table-cell/.test(item.css('display'));
	            var isHorizontalFlex = /flex/.test(item.parent().css('display')) && (/row|row-reverse/.test(item.parent().css('flex-direction')) || !item.parent().css('flex-direction'));
	            return isFloating || isTable || isHorizontalFlex;
	        },

	        _cancel: function() {
	            this.draggedElement.show();
	            this.placeholder.remove();
	            this.draggable.dropped = true;
	        },

	        _items: function() {
	            var filter = this.options.filter,
	                items;

	            if(filter) {
	                items = this.element.find(filter);
	            } else {
	                items = this.element.children();
	            }

	            return items;
	        },

	        indexOf: function(element) {
	            var items = this._items(),
	                placeholder = this.placeholder,
	                draggedElement = this.draggedElement;

	            if(placeholder && element[0] == placeholder[0]) {
	                return items.not(draggedElement).index(element);
	            } else {
	                return items.not(placeholder).index(element);
	            }
	        },

	        items: function() {
	            var placeholder = this.placeholder,
	                items = this._items();

	            if(placeholder) {
	                items = items.not(placeholder);
	            }

	            return items;
	        },

	        _isEmpty: function() {
	            return !this.items().length;
	        },

	        _isLastHidden: function() {
	            return this.items().length === 1 && this.items().is(":hidden");
	        }

	    });

	    kendo.ui.plugin(Sortable);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1048)))

/***/ })

/******/ });

/***/ }),

/***/ "MlFQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1314);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FZAa");

/***/ }),

/***/ 1314:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1088) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.button",
	    name: "Button",
	    category: "mobile",
	    description: "The Button widget navigates between mobile Application views when pressed.",
	    depends: [ "userevents" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        mobile = kendo.mobile,
	        ui = mobile.ui,
	        Widget = ui.Widget,
	        support = kendo.support,
	        os = support.mobileOS,
	        ANDROID3UP = os.android && os.flatVersion >= 300,
	        CLICK = "click",
	        DISABLED = "disabled",
	        DISABLEDSTATE = "km-state-disabled";

	    function highlightButton(widget, event, highlight) {
	        $(event.target).closest(".km-button,.km-detail").toggleClass("km-state-active", highlight);

	        if (ANDROID3UP && widget.deactivateTimeoutID) {
	            clearTimeout(widget.deactivateTimeoutID);
	            widget.deactivateTimeoutID = 0;
	        }
	    }

	    function createBadge(value) {
	        return $('<span class="km-badge">' + value + '</span>');
	    }

	    var Button = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);
	            var useTap = that.options.clickOn === "up";

	            that._wrap();
	            that._style();

	            if (!useTap) {
	                that.element.attr("data-navigate-on-press", true);
	            }

	            that.options.enable = that.options.enable && !that.element.attr(DISABLED);
	            that.enable(that.options.enable);

	            that._userEvents = new kendo.UserEvents(that.element, {
	                allowSelection: !useTap,
	                fastTap: true,
	                press: function(e) {
	                    that._activate(e);
	                },
	                release: function(e) {
	                    highlightButton(that, e, false);
	                    if (!useTap) { e.event.stopPropagation(); }
	                }
	            });

	            that._userEvents.bind(useTap ? "tap" : "press", function(e) {
	                that._release(e);
	            });


	            if (ANDROID3UP) {
	                that.element.on("move", function(e) { that._timeoutDeactivate(e); });
	            }
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            this._userEvents.destroy();
	        },

	        events: [
	            CLICK
	        ],

	        options: {
	            name: "Button",
	            icon: "",
	            style: "",
	            badge: "",
	            clickOn: "up",
	            enable: true
	        },

	        badge: function (value) {
	            var badge = this.badgeElement = this.badgeElement || createBadge(value).appendTo(this.element);

	            if (value || value === 0) {
	                badge.html(value);
	                return this;
	            }

	            if (value === false) {
	                badge.empty().remove();
	                this.badgeElement = false;
	                return this;
	            }

	            return badge.html();
	        },

	        enable: function(enable) {
	            var element = this.element;

	            if(typeof enable == "undefined") {
	                enable = true;
	            }

	            this.options.enable = enable;

	            if(enable) {
	                element.removeAttr(DISABLED);
	            } else {
	                element.attr(DISABLED, DISABLED);
	            }

	            element.toggleClass(DISABLEDSTATE, !enable);
	        },

	        _timeoutDeactivate: function(e) {
	            if (!this.deactivateTimeoutID) {
	                this.deactivateTimeoutID = setTimeout(highlightButton, 500, this, e, false);
	            }
	        },

	        _activate: function(e) {
	            var activeElement = document.activeElement,
	                nodeName = activeElement ? activeElement.nodeName : "";

	            if(this.options.enable) {
	                highlightButton(this, e, true);

	                if (nodeName == "INPUT" || nodeName == "TEXTAREA") {
	                    activeElement.blur(); // Hide device keyboard
	                }
	            }
	        },

	        _release: function(e) {
	            var that = this;

	            if (e.which > 1) {
	                return;
	            }

	            if(!that.options.enable) {
	                e.preventDefault();
	                return;
	            }

	            if (that.trigger(CLICK, {target: $(e.target), button: that.element})) {
	                e.preventDefault();
	            }
	        },

	        _style: function() {
	            var style = this.options.style,
	                element = this.element,
	                styles;

	            if (style) {
	                styles = style.split(" ");
	                $.each(styles, function() {
	                    element.addClass("km-" + this);
	                });
	            }
	        },

	        _wrap: function() {
	            var that = this,
	                icon = that.options.icon,
	                badge = that.options.badge,
	                iconSpan = '<span class="km-icon km-' + icon,
	                element = that.element.addClass("km-button"),
	                span = element.children("span:not(.km-icon)").addClass("km-text"),
	                image = element.find("img").addClass("km-image");

	            if (!span[0] && element.html()) {
	                span = element.wrapInner('<span class="km-text" />').children("span.km-text");
	            }

	            if (!image[0] && icon) {
	                if (!span[0]) {
	                    iconSpan += " km-notext";
	                }
	                that.iconElement = element.prepend($(iconSpan + '" />'));
	            }

	            if (badge || badge === 0) {
	                that.badgeElement = createBadge(badge).appendTo(element);
	            }
	        }
	    });

	    var BackButton = Button.extend({
	        options: {
	            name: "BackButton",
	            style: "back"
	        },

	        init: function(element, options) {
	            var that = this;
	            Button.fn.init.call(that, element, options);

	            if (typeof that.element.attr("href") === "undefined") {
	                that.element.attr("href", "#:back");
	            }
	        }
	    });

	    var DetailButton = Button.extend({
	        options: {
	            name: "DetailButton",
	            style: ""
	        },

	        init: function(element, options) {
	            Button.fn.init.call(this, element, options);
	        },

	        _style: function() {
	            var style = this.options.style + " detail",
	                element = this.element;

	            if (style) {
	                var styles = style.split(" ");
	                $.each(styles, function() {
	                    element.addClass("km-" + this);
	                });
	            }
	        },

	        _wrap: function() {
	            var that = this,
	                icon = that.options.icon,
	                iconSpan = '<span class="km-icon km-' + icon,
	                element = that.element,
	                span = element.children("span"),
	                image = element.find("img").addClass("km-image");

	            if (!image[0] && icon) {
	                if (!span[0]) {
	                    iconSpan += " km-notext";
	                }
	                element.prepend($(iconSpan + '" />'));
	            }
	        }

	    });

	    ui.plugin(Button);
	    ui.plugin(BackButton);
	    ui.plugin(DetailButton);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "MmMw":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("EqjI");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "MwUU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var dateFilter_1 = __webpack_require__("TgGN");
var componentAnnotations_1 = __webpack_require__("x5ih");
var utils_1 = __webpack_require__("IRr6");
var componentRecipes_1 = __webpack_require__("EOXx");
var component_1 = __webpack_require__("pQ38");
var constants_1 = __webpack_require__("ZZFX");
var InputTextFloatingFilterComp = (function (_super) {
    __extends(InputTextFloatingFilterComp, _super);
    function InputTextFloatingFilterComp() {
        var _this = _super.call(this, "<div><input  ref=\"eColumnFloatingFilter\" class=\"ag-floating-filter-input\"></div>") || this;
        _this.lastKnownModel = null;
        return _this;
    }
    InputTextFloatingFilterComp.prototype.init = function (params) {
        this.onFloatingFilterChanged = params.onFloatingFilterChanged;
        this.currentParentModel = params.currentParentModel;
        var debounceMs = params.debounceMs != null ? params.debounceMs : 500;
        var toDebounce = utils_1._.debounce(this.syncUpWithParentFilter.bind(this), debounceMs);
        this.addDestroyableEventListener(this.eColumnFloatingFilter, 'input', toDebounce);
        this.addDestroyableEventListener(this.eColumnFloatingFilter, 'keypress', toDebounce);
        this.addDestroyableEventListener(this.eColumnFloatingFilter, 'keydown', toDebounce);
        var columnDef = params.column.getDefinition();
        if (columnDef.filterParams && columnDef.filterParams.filterOptions && columnDef.filterParams.filterOptions.length === 1 && columnDef.filterParams.filterOptions[0] === 'inRange') {
            this.eColumnFloatingFilter.readOnly = true;
        }
    };
    InputTextFloatingFilterComp.prototype.onParentModelChanged = function (parentModel) {
        if (this.equalModels(this.lastKnownModel, parentModel)) {
            // ensure column floating filter text is blanked out when both ranges are empty
            if (!this.lastKnownModel && !parentModel) {
                this.eColumnFloatingFilter.value = '';
            }
            return;
        }
        this.lastKnownModel = parentModel;
        var incomingTextValue = this.asFloatingFilterText(parentModel);
        if (incomingTextValue === this.eColumnFloatingFilter.value)
            return;
        this.eColumnFloatingFilter.value = incomingTextValue;
    };
    InputTextFloatingFilterComp.prototype.syncUpWithParentFilter = function (e) {
        var model = this.asParentModel();
        if (this.equalModels(this.lastKnownModel, model))
            return;
        var modelUpdated = null;
        if (utils_1._.isKeyPressed(e, constants_1.Constants.KEY_ENTER)) {
            modelUpdated = this.onFloatingFilterChanged({
                model: model,
                apply: true
            });
        }
        else {
            modelUpdated = this.onFloatingFilterChanged({
                model: model,
                apply: false
            });
        }
        if (modelUpdated) {
            this.lastKnownModel = model;
        }
    };
    InputTextFloatingFilterComp.prototype.equalModels = function (left, right) {
        if (utils_1._.referenceCompare(left, right))
            return true;
        if (!left || !right)
            return false;
        if (Array.isArray(left) || Array.isArray(right))
            return false;
        return (utils_1._.referenceCompare(left.type, right.type) &&
            utils_1._.referenceCompare(left.filter, right.filter) &&
            utils_1._.referenceCompare(left.filterTo, right.filterTo) &&
            utils_1._.referenceCompare(left.filterType, right.filterType));
    };
    __decorate([
        componentAnnotations_1.RefSelector('eColumnFloatingFilter'),
        __metadata("design:type", HTMLInputElement)
    ], InputTextFloatingFilterComp.prototype, "eColumnFloatingFilter", void 0);
    return InputTextFloatingFilterComp;
}(component_1.Component));
exports.InputTextFloatingFilterComp = InputTextFloatingFilterComp;
var TextFloatingFilterComp = (function (_super) {
    __extends(TextFloatingFilterComp, _super);
    function TextFloatingFilterComp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextFloatingFilterComp.prototype.asFloatingFilterText = function (parentModel) {
        if (!parentModel)
            return '';
        return parentModel.filter;
    };
    TextFloatingFilterComp.prototype.asParentModel = function () {
        var currentParentModel = this.currentParentModel();
        return {
            type: currentParentModel.type,
            filter: this.eColumnFloatingFilter.value,
            filterType: 'text'
        };
    };
    return TextFloatingFilterComp;
}(InputTextFloatingFilterComp));
exports.TextFloatingFilterComp = TextFloatingFilterComp;
var DateFloatingFilterComp = (function (_super) {
    __extends(DateFloatingFilterComp, _super);
    function DateFloatingFilterComp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lastKnownModel = null;
        return _this;
    }
    DateFloatingFilterComp.prototype.init = function (params) {
        this.onFloatingFilterChanged = params.onFloatingFilterChanged;
        this.currentParentModel = params.currentParentModel;
        var debounceMs = params.debounceMs != null ? params.debounceMs : 500;
        var toDebounce = utils_1._.debounce(this.onDateChanged.bind(this), debounceMs);
        var dateComponentParams = {
            onDateChanged: toDebounce
        };
        this.dateComponentPromise = this.componentRecipes.newDateComponent(dateComponentParams);
        var body = utils_1._.loadTemplate("<div></div>");
        this.dateComponentPromise.then(function (dateComponent) {
            body.appendChild(dateComponent.getGui());
        });
        this.setTemplateFromElement(body);
    };
    DateFloatingFilterComp.prototype.onDateChanged = function () {
        var parentModel = this.currentParentModel();
        var model = this.asParentModel();
        if (this.equalModels(parentModel, model))
            return;
        this.onFloatingFilterChanged({
            model: model,
            apply: true
        });
        this.lastKnownModel = model;
    };
    DateFloatingFilterComp.prototype.equalModels = function (left, right) {
        if (utils_1._.referenceCompare(left, right))
            return true;
        if (!left || !right)
            return false;
        if (Array.isArray(left) || Array.isArray(right))
            return false;
        return (utils_1._.referenceCompare(left.type, right.type) &&
            utils_1._.referenceCompare(left.dateFrom, right.dateFrom) &&
            utils_1._.referenceCompare(left.dateTo, right.dateTo) &&
            utils_1._.referenceCompare(left.filterType, right.filterType));
    };
    DateFloatingFilterComp.prototype.asParentModel = function () {
        var currentParentModel = this.currentParentModel();
        var filterValueDate = this.dateComponentPromise.resolveNow(null, function (dateComponent) { return dateComponent.getDate(); });
        var filterValueText = utils_1._.serializeDateToYyyyMmDd(dateFilter_1.DateFilter.removeTimezone(filterValueDate), "-");
        return {
            type: currentParentModel.type,
            dateFrom: filterValueText,
            dateTo: currentParentModel ? currentParentModel.dateTo : null,
            filterType: 'date'
        };
    };
    DateFloatingFilterComp.prototype.onParentModelChanged = function (parentModel) {
        this.lastKnownModel = parentModel;
        this.dateComponentPromise.then(function (dateComponent) {
            if (!parentModel || !parentModel.dateFrom) {
                dateComponent.setDate(null);
                return;
            }
            dateComponent.setDate(utils_1._.parseYyyyMmDdToDate(parentModel.dateFrom, '-'));
        });
    };
    __decorate([
        context_1.Autowired('componentRecipes'),
        __metadata("design:type", componentRecipes_1.ComponentRecipes)
    ], DateFloatingFilterComp.prototype, "componentRecipes", void 0);
    return DateFloatingFilterComp;
}(component_1.Component));
exports.DateFloatingFilterComp = DateFloatingFilterComp;
var NumberFloatingFilterComp = (function (_super) {
    __extends(NumberFloatingFilterComp, _super);
    function NumberFloatingFilterComp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NumberFloatingFilterComp.prototype.asFloatingFilterText = function (parentModel) {
        var rawParentModel = this.currentParentModel();
        if (parentModel == null && rawParentModel == null)
            return '';
        if (parentModel == null && rawParentModel != null && rawParentModel.type !== 'inRange') {
            this.eColumnFloatingFilter.readOnly = false;
            return '';
        }
        if (rawParentModel != null && rawParentModel.type === 'inRange') {
            this.eColumnFloatingFilter.readOnly = true;
            var number_1 = this.asNumber(rawParentModel.filter);
            var numberTo = this.asNumber(rawParentModel.filterTo);
            return (number_1 ? number_1 + '' : '') +
                '-' +
                (numberTo ? numberTo + '' : '');
        }
        var number = this.asNumber(parentModel.filter);
        this.eColumnFloatingFilter.readOnly = false;
        return number != null ? number + '' : '';
    };
    NumberFloatingFilterComp.prototype.asParentModel = function () {
        var currentParentModel = this.currentParentModel();
        var filterValueNumber = this.asNumber(this.eColumnFloatingFilter.value);
        var filterValueText = this.eColumnFloatingFilter.value;
        var modelFilterValue = null;
        if (filterValueNumber == null && filterValueText === '') {
            modelFilterValue = null;
        }
        else if (filterValueNumber == null) {
            modelFilterValue = currentParentModel.filter;
        }
        else {
            modelFilterValue = filterValueNumber;
        }
        return {
            type: currentParentModel.type,
            filter: modelFilterValue,
            filterTo: !currentParentModel ? null : currentParentModel.filterTo,
            filterType: 'number'
        };
    };
    NumberFloatingFilterComp.prototype.asNumber = function (value) {
        if (value == null)
            return null;
        if (value === '')
            return null;
        var asNumber = Number(value);
        var invalidNumber = !utils_1._.isNumeric(asNumber);
        return invalidNumber ? null : asNumber;
    };
    return NumberFloatingFilterComp;
}(InputTextFloatingFilterComp));
exports.NumberFloatingFilterComp = NumberFloatingFilterComp;
var SetFloatingFilterComp = (function (_super) {
    __extends(SetFloatingFilterComp, _super);
    function SetFloatingFilterComp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetFloatingFilterComp.prototype.init = function (params) {
        _super.prototype.init.call(this, params);
        this.eColumnFloatingFilter.readOnly = true;
    };
    SetFloatingFilterComp.prototype.asFloatingFilterText = function (parentModel) {
        if (!parentModel || parentModel.length === 0)
            return '';
        var arrayToDisplay = parentModel.length > 10 ? parentModel.slice(0, 10).concat(['...']) : parentModel;
        return "(" + parentModel.length + ") " + arrayToDisplay.join(",");
    };
    SetFloatingFilterComp.prototype.asParentModel = function () {
        if (this.eColumnFloatingFilter.value == null || this.eColumnFloatingFilter.value === '')
            return null;
        return this.eColumnFloatingFilter.value.split(",");
    };
    return SetFloatingFilterComp;
}(InputTextFloatingFilterComp));
exports.SetFloatingFilterComp = SetFloatingFilterComp;
var ReadModelAsStringFloatingFilterComp = (function (_super) {
    __extends(ReadModelAsStringFloatingFilterComp, _super);
    function ReadModelAsStringFloatingFilterComp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReadModelAsStringFloatingFilterComp.prototype.init = function (params) {
        _super.prototype.init.call(this, params);
        this.eColumnFloatingFilter.readOnly = true;
    };
    ReadModelAsStringFloatingFilterComp.prototype.onParentModelChanged = function (parentModel) {
        this.eColumnFloatingFilter.value = this.asFloatingFilterText(this.currentParentModel());
    };
    ReadModelAsStringFloatingFilterComp.prototype.asFloatingFilterText = function (parentModel) {
        return parentModel;
    };
    ReadModelAsStringFloatingFilterComp.prototype.asParentModel = function () {
        return null;
    };
    return ReadModelAsStringFloatingFilterComp;
}(InputTextFloatingFilterComp));
exports.ReadModelAsStringFloatingFilterComp = ReadModelAsStringFloatingFilterComp;


/***/ }),

/***/ "N+Bk":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(978);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 971:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("cmba");

/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(971) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($) {

	var kendo = window.kendo,
	    extend = $.extend,
	    Editor = kendo.ui.editor,
	    Tool = Editor.Tool,
	    Command = Editor.Command,
	    EditorUtils = Editor.EditorUtils;

	var FormatCommand = Command.extend({
	    init: function (options) {
	        options.formatter = options.formatter();
	        var finder = options.formatter.finder;
	        if (finder && EditorUtils.formatByName("immutable", finder.format)) {
	            finder._initOptions({immutables: options.immutables});
	        }
	        Command.fn.init.call(this, options);
	    }
	});

	var FormatTool = Tool.extend({
	    init: function (options) {
	        Tool.fn.init.call(this, options);
	    },

	    command: function (commandArguments) {
	        var that = this;
	        return new FormatCommand(extend(commandArguments, {
	                formatter: that.options.formatter
	            }));
	    },

	    update: function(ui, nodes) {
	        var isFormatted = this.options.finder.isFormatted(nodes);

	        ui.toggleClass("k-state-selected", isFormatted);
	        ui.attr("aria-pressed", isFormatted);
	    }
	});

	$.extend(Editor, {
	    FormatCommand: FormatCommand,
	    FormatTool: FormatTool
	});

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "N4JJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = __webpack_require__("pQ38");
var column_1 = __webpack_require__("hDyE");
var utils_1 = __webpack_require__("IRr6");
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var sortController_1 = __webpack_require__("fxGZ");
var touchListener_1 = __webpack_require__("G4uV");
var eventService_1 = __webpack_require__("k5uU");
var componentAnnotations_1 = __webpack_require__("x5ih");
var events_1 = __webpack_require__("3ok8");
var HeaderComp = (function (_super) {
    __extends(HeaderComp, _super);
    function HeaderComp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderComp.prototype.init = function (params) {
        var template = utils_1.Utils.firstExistingValue(params.template, HeaderComp.TEMPLATE);
        this.setTemplate(template);
        this.params = params;
        this.setupTap();
        this.setupIcons(params.column);
        this.setupMenu();
        this.setupSort();
        this.setupFilterIcon();
        this.setupText(params.displayName);
    };
    HeaderComp.prototype.setupText = function (displayName) {
        if (this.eText) {
            this.eText.innerHTML = displayName;
        }
    };
    HeaderComp.prototype.setupIcons = function (column) {
        this.addInIcon('sortAscending', this.eSortAsc, column);
        this.addInIcon('sortDescending', this.eSortDesc, column);
        this.addInIcon('sortUnSort', this.eSortNone, column);
        this.addInIcon('menu', this.eMenu, column);
        this.addInIcon('filter', this.eFilter, column);
    };
    HeaderComp.prototype.addInIcon = function (iconName, eParent, column) {
        if (eParent == null)
            return;
        var eIcon = utils_1.Utils.createIconNoSpan(iconName, this.gridOptionsWrapper, column);
        eParent.appendChild(eIcon);
    };
    HeaderComp.prototype.setupTap = function () {
        var _this = this;
        if (this.gridOptionsWrapper.isSuppressTouch()) {
            return;
        }
        var touchListener = new touchListener_1.TouchListener(this.getGui());
        if (this.params.enableMenu) {
            var longTapListener = function (event) {
                _this.gridOptionsWrapper.getApi().showColumnMenuAfterMouseClick(_this.params.column, event.touchStart);
            };
            this.addDestroyableEventListener(touchListener, touchListener_1.TouchListener.EVENT_LONG_TAP, longTapListener);
        }
        if (this.params.enableSorting) {
            var tapListener = function () {
                _this.sortController.progressSort(_this.params.column, false, "uiColumnSorted");
            };
            this.addDestroyableEventListener(touchListener, touchListener_1.TouchListener.EVENT_TAP, tapListener);
        }
        this.addDestroyFunc(function () { return touchListener.destroy(); });
    };
    HeaderComp.prototype.setupMenu = function () {
        var _this = this;
        // if no menu provided in template, do nothing
        if (!this.eMenu) {
            return;
        }
        // we don't show the menu if on an ipad, as the user cannot have a mouse on the ipad, so
        // makes no sense. instead the user must long-tap if on an ipad.
        var dontShowMenu = !this.params.enableMenu || utils_1.Utils.isUserAgentIPad();
        if (dontShowMenu) {
            utils_1.Utils.removeFromParent(this.eMenu);
            return;
        }
        this.eMenu.addEventListener('click', function () { return _this.showMenu(_this.eMenu); });
        if (!this.gridOptionsWrapper.isSuppressMenuHide()) {
            this.eMenu.style.opacity = '0';
            this.addGuiEventListener('mouseover', function () {
                _this.eMenu.style.opacity = '1';
            });
            this.addGuiEventListener('mouseout', function () {
                _this.eMenu.style.opacity = '0';
            });
        }
        var style = this.eMenu.style;
        style['transition'] = 'opacity 0.2s, border 0.2s';
        style['-webkit-transition'] = 'opacity 0.2s, border 0.2s';
    };
    HeaderComp.prototype.showMenu = function (eventSource) {
        this.menuFactory.showMenuAfterButtonClick(this.params.column, eventSource);
    };
    HeaderComp.prototype.removeSortIcons = function () {
        utils_1.Utils.removeFromParent(this.eSortAsc);
        utils_1.Utils.removeFromParent(this.eSortDesc);
        utils_1.Utils.removeFromParent(this.eSortNone);
        utils_1.Utils.removeFromParent(this.eSortOrder);
    };
    HeaderComp.prototype.setupSort = function () {
        var _this = this;
        var enableSorting = this.params.enableSorting;
        if (!enableSorting) {
            this.removeSortIcons();
            return;
        }
        // add the event on the header, so when clicked, we do sorting
        if (this.eLabel) {
            this.addDestroyableEventListener(this.eLabel, 'click', function (event) {
                _this.params.progressSort(event.shiftKey);
            });
        }
        this.addDestroyableEventListener(this.params.column, column_1.Column.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
        this.onSortChanged();
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_SORT_CHANGED, this.setMultiSortOrder.bind(this));
        this.setMultiSortOrder();
    };
    HeaderComp.prototype.onSortChanged = function () {
        utils_1.Utils.addOrRemoveCssClass(this.getGui(), 'ag-header-cell-sorted-asc', this.params.column.isSortAscending());
        utils_1.Utils.addOrRemoveCssClass(this.getGui(), 'ag-header-cell-sorted-desc', this.params.column.isSortDescending());
        utils_1.Utils.addOrRemoveCssClass(this.getGui(), 'ag-header-cell-sorted-none', this.params.column.isSortNone());
        if (this.eSortAsc) {
            utils_1.Utils.addOrRemoveCssClass(this.eSortAsc, 'ag-hidden', !this.params.column.isSortAscending());
        }
        if (this.eSortDesc) {
            utils_1.Utils.addOrRemoveCssClass(this.eSortDesc, 'ag-hidden', !this.params.column.isSortDescending());
        }
        if (this.eSortNone) {
            var alwaysHideNoSort = !this.params.column.getColDef().unSortIcon && !this.gridOptionsWrapper.isUnSortIcon();
            utils_1.Utils.addOrRemoveCssClass(this.eSortNone, 'ag-hidden', alwaysHideNoSort || !this.params.column.isSortNone());
        }
    };
    // we listen here for global sort events, NOT column sort events, as we want to do this
    // when sorting has been set on all column (if we listened just for our col (where we
    // set the asc / desc icons) then it's possible other cols are yet to get their sorting state.
    HeaderComp.prototype.setMultiSortOrder = function () {
        if (!this.eSortOrder) {
            return;
        }
        var col = this.params.column;
        var allColumnsWithSorting = this.sortController.getColumnsWithSortingOrdered();
        var indexThisCol = allColumnsWithSorting.indexOf(col);
        var moreThanOneColSorting = allColumnsWithSorting.length > 1;
        var showIndex = col.isSorting() && moreThanOneColSorting;
        utils_1.Utils.setVisible(this.eSortOrder, showIndex);
        if (indexThisCol >= 0) {
            this.eSortOrder.innerHTML = (indexThisCol + 1).toString();
        }
        else {
            this.eSortOrder.innerHTML = '';
        }
    };
    HeaderComp.prototype.setupFilterIcon = function () {
        if (!this.eFilter) {
            return;
        }
        this.addDestroyableEventListener(this.params.column, column_1.Column.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
        this.onFilterChanged();
    };
    HeaderComp.prototype.onFilterChanged = function () {
        var filterPresent = this.params.column.isFilterActive();
        utils_1.Utils.addOrRemoveCssClass(this.eFilter, 'ag-hidden', !filterPresent);
    };
    HeaderComp.TEMPLATE = '<div class="ag-cell-label-container" role="presentation">' +
        '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>' +
        '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
        '    <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
        '    <span ref="eFilter" class="ag-header-icon ag-filter-icon" aria-hidden="true"></span>' +
        '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" aria-hidden="true"></span>' +
        '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" aria-hidden="true"></span>' +
        '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" aria-hidden="true"></span>' +
        '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" aria-hidden="true"></span>' +
        '  </div>' +
        '</div>';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], HeaderComp.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('sortController'),
        __metadata("design:type", sortController_1.SortController)
    ], HeaderComp.prototype, "sortController", void 0);
    __decorate([
        context_1.Autowired('menuFactory'),
        __metadata("design:type", Object)
    ], HeaderComp.prototype, "menuFactory", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], HeaderComp.prototype, "eventService", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('eFilter'),
        __metadata("design:type", HTMLElement)
    ], HeaderComp.prototype, "eFilter", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('eSortAsc'),
        __metadata("design:type", HTMLElement)
    ], HeaderComp.prototype, "eSortAsc", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('eSortDesc'),
        __metadata("design:type", HTMLElement)
    ], HeaderComp.prototype, "eSortDesc", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('eSortNone'),
        __metadata("design:type", HTMLElement)
    ], HeaderComp.prototype, "eSortNone", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('eSortOrder'),
        __metadata("design:type", HTMLElement)
    ], HeaderComp.prototype, "eSortOrder", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('eMenu'),
        __metadata("design:type", HTMLElement)
    ], HeaderComp.prototype, "eMenu", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('eLabel'),
        __metadata("design:type", HTMLElement)
    ], HeaderComp.prototype, "eLabel", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('eText'),
        __metadata("design:type", HTMLElement)
    ], HeaderComp.prototype, "eText", void 0);
    return HeaderComp;
}(component_1.Component));
exports.HeaderComp = HeaderComp;


/***/ }),

/***/ "N5PI":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(961);
	module.exports = __webpack_require__(961);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 961:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(962) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($) {

	var kendo = window.kendo,
	    map = $.map,
	    extend = $.extend,
	    browser = kendo.support.browser,
	    STYLE = "style",
	    FLOAT = "float",
	    CSSFLOAT = "cssFloat",
	    STYLEFLOAT = "styleFloat",
	    CLASS = "class",
	    KMARKER = "k-marker";

	function makeMap(items) {
	    var obj = {},
	        i, len;

	    for (i = 0, len = items.length; i < len; i++) {
	        obj[items[i]] = true;
	    }
	    return obj;
	}

	var empty = makeMap("area,base,basefont,br,col,frame,hr,img,input,isindex,link,meta,param,embed".split(",")),
	    nonListBlockElements = "p,div,h1,h2,h3,h4,h5,h6,address,applet,blockquote,button,center,dd,dir,dl,dt,fieldset,form,frameset,hr,iframe,isindex,map,menu,noframes,noscript,object,pre,script,table,tbody,td,tfoot,th,thead,tr,header,article,nav,footer,section,aside,main,figure,figcaption".split(","),
	    blockElements = nonListBlockElements.concat(["ul","ol","li"]),
	    block = makeMap(blockElements),
	    selfClosing = makeMap("area,base,br,col,command,embed,hr,img,input,keygen,link,menuitem,meta,param,source,track,wbr".split(",")),
	    inlineElements = "span,em,a,abbr,acronym,applet,b,basefont,bdo,big,br,button,cite,code,del,dfn,font,i,iframe,img,input,ins,kbd,label,map,object,q,s,samp,script,select,small,strike,strong,sub,sup,textarea,tt,u,var,data,time,mark,ruby".split(","),
	    inline = makeMap(inlineElements),
	    fillAttrs = makeMap("checked,compact,declare,defer,disabled,ismap,multiple,nohref,noresize,noshade,nowrap,readonly,selected".split(","));

	var normalize = function (node) {
	    if (node.nodeType == 1) {
	        node.normalize();
	    }
	};

	if (browser.msie && browser.version >= 8) {
	    normalize = function(parent) {
	        if (parent.nodeType == 1 && parent.firstChild) {
	            var prev = parent.firstChild,
	                node = prev;

	            normalize(node);

	            while (true) {
	                node = node.nextSibling;

	                if (!node) {
	                    break;
	                }

	                normalize(node);

	                if (node.nodeType == 3 && prev.nodeType == 3) {
	                    node.nodeValue = prev.nodeValue + node.nodeValue;
	                    Dom.remove(prev);
	                }

	                prev = node;
	            }
	        }
	    };
	}

	var whitespace = /^\s+$/,
	    emptyspace = /^[\n\r\t]+$/,
	    rgb = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/i,
	    bom = /\ufeff/g,
	    whitespaceOrBom = /^(\s+|\ufeff)$/,
	    persistedScrollTop,
	    cssAttributes =
	           ("color,padding-left,padding-right,padding-top,padding-bottom," +
	            "background-color,background-attachment,background-image,background-position,background-repeat," +
	            "border-top-style,border-top-width,border-top-color," +
	            "border-bottom-style,border-bottom-width,border-bottom-color," +
	            "border-left-style,border-left-width,border-left-color," +
	            "border-right-style,border-right-width,border-right-color," +
	            "font-family,font-size,font-style,font-variant,font-weight,line-height"
	           ).split(","),
	    htmlRe = /[<>\&]/g,
	    entityRe = /[\u00A0-\u2666<>\&]/g,
	    entityTable = {
	            34: 'quot', 38: 'amp', 39: 'apos', 60: 'lt', 62: 'gt',
	            160: 'nbsp', 161: 'iexcl', 162: 'cent', 163: 'pound', 164: 'curren',
	            165: 'yen', 166: 'brvbar', 167: 'sect', 168: 'uml', 169: 'copy',
	            170: 'ordf', 171: 'laquo', 172: 'not', 173: 'shy', 174: 'reg',
	            175: 'macr', 176: 'deg', 177: 'plusmn', 178: 'sup2', 179: 'sup3',
	            180: 'acute', 181: 'micro', 182: 'para', 183: 'middot', 184: 'cedil',
	            185: 'sup1', 186: 'ordm', 187: 'raquo', 188: 'frac14', 189: 'frac12',
	            190: 'frac34', 191: 'iquest', 192: 'Agrave', 193: 'Aacute', 194: 'Acirc',
	            195: 'Atilde', 196: 'Auml', 197: 'Aring', 198: 'AElig', 199: 'Ccedil',
	            200: 'Egrave', 201: 'Eacute', 202: 'Ecirc', 203: 'Euml', 204: 'Igrave',
	            205: 'Iacute', 206: 'Icirc', 207: 'Iuml', 208: 'ETH', 209: 'Ntilde',
	            210: 'Ograve', 211: 'Oacute', 212: 'Ocirc', 213: 'Otilde', 214: 'Ouml',
	            215: 'times', 216: 'Oslash', 217: 'Ugrave', 218: 'Uacute', 219: 'Ucirc',
	            220: 'Uuml', 221: 'Yacute', 222: 'THORN', 223: 'szlig', 224: 'agrave',
	            225: 'aacute', 226: 'acirc', 227: 'atilde', 228: 'auml', 229: 'aring',
	            230: 'aelig', 231: 'ccedil', 232: 'egrave', 233: 'eacute', 234: 'ecirc',
	            235: 'euml', 236: 'igrave', 237: 'iacute', 238: 'icirc', 239: 'iuml',
	            240: 'eth', 241: 'ntilde', 242: 'ograve', 243: 'oacute', 244: 'ocirc',
	            245: 'otilde', 246: 'ouml', 247: 'divide', 248: 'oslash', 249: 'ugrave',
	            250: 'uacute', 251: 'ucirc', 252: 'uuml', 253: 'yacute', 254: 'thorn',
	            255: 'yuml', 402: 'fnof', 913: 'Alpha', 914: 'Beta', 915: 'Gamma',
	            916: 'Delta', 917: 'Epsilon', 918: 'Zeta', 919: 'Eta', 920: 'Theta',
	            921: 'Iota', 922: 'Kappa', 923: 'Lambda', 924: 'Mu', 925: 'Nu',
	            926: 'Xi', 927: 'Omicron', 928: 'Pi', 929: 'Rho', 931: 'Sigma',
	            932: 'Tau', 933: 'Upsilon', 934: 'Phi', 935: 'Chi', 936: 'Psi',
	            937: 'Omega', 945: 'alpha', 946: 'beta', 947: 'gamma', 948: 'delta',
	            949: 'epsilon', 950: 'zeta', 951: 'eta', 952: 'theta', 953: 'iota',
	            954: 'kappa', 955: 'lambda', 956: 'mu', 957: 'nu', 958: 'xi',
	            959: 'omicron', 960: 'pi', 961: 'rho', 962: 'sigmaf', 963: 'sigma',
	            964: 'tau', 965: 'upsilon', 966: 'phi', 967: 'chi', 968: 'psi',
	            969: 'omega', 977: 'thetasym', 978: 'upsih', 982: 'piv', 8226: 'bull',
	            8230: 'hellip', 8242: 'prime', 8243: 'Prime', 8254: 'oline', 8260: 'frasl',
	            8472: 'weierp', 8465: 'image', 8476: 'real', 8482: 'trade', 8501: 'alefsym',
	            8592: 'larr', 8593: 'uarr', 8594: 'rarr', 8595: 'darr', 8596: 'harr',
	            8629: 'crarr', 8656: 'lArr', 8657: 'uArr', 8658: 'rArr', 8659: 'dArr',
	            8660: 'hArr', 8704: 'forall', 8706: 'part', 8707: 'exist', 8709: 'empty',
	            8711: 'nabla', 8712: 'isin', 8713: 'notin', 8715: 'ni', 8719: 'prod',
	            8721: 'sum', 8722: 'minus', 8727: 'lowast', 8730: 'radic', 8733: 'prop',
	            8734: 'infin', 8736: 'ang', 8743: 'and', 8744: 'or', 8745: 'cap',
	            8746: 'cup', 8747: 'int', 8756: 'there4', 8764: 'sim', 8773: 'cong',
	            8776: 'asymp', 8800: 'ne', 8801: 'equiv', 8804: 'le', 8805: 'ge',
	            8834: 'sub', 8835: 'sup', 8836: 'nsub', 8838: 'sube', 8839: 'supe',
	            8853: 'oplus', 8855: 'otimes', 8869: 'perp', 8901: 'sdot', 8968: 'lceil',
	            8969: 'rceil', 8970: 'lfloor', 8971: 'rfloor', 9001: 'lang', 9002: 'rang',
	            9674: 'loz', 9824: 'spades', 9827: 'clubs', 9829: 'hearts', 9830: 'diams',
	            338: 'OElig', 339: 'oelig', 352: 'Scaron', 353: 'scaron', 376: 'Yuml',
	            710: 'circ', 732: 'tilde', 8194: 'ensp', 8195: 'emsp', 8201: 'thinsp',
	            8204: 'zwnj', 8205: 'zwj', 8206: 'lrm', 8207: 'rlm', 8211: 'ndash',
	            8212: 'mdash', 8216: 'lsquo', 8217: 'rsquo', 8218: 'sbquo', 8220: 'ldquo',
	            8221: 'rdquo', 8222: 'bdquo', 8224: 'dagger', 8225: 'Dagger', 8240: 'permil',
	            8249: 'lsaquo', 8250: 'rsaquo', 8364: 'euro'
	        };

	var Dom = {
	    block: block,
	    inline: inline,

	    findNodeIndex: function(node, skipText) {
	        var i = 0;

	        if (!node) {
	            return -1;
	        }

	        while (true) {
	            node = node.previousSibling;

	            if (!node) {
	                break;
	            }

	            if (!(skipText && node.nodeType == 3)) {
	                i++;
	            }
	        }

	        return i;
	    },

	    isDataNode: function(node) {
	        return node && node.nodeValue !== null && node.data !== null;
	    },

	    isAncestorOf: function(parent, node) {
	        try {
	            return !Dom.isDataNode(parent) && ($.contains(parent, Dom.isDataNode(node) ? node.parentNode : node) || node.parentNode == parent);
	        } catch (e) {
	            return false;
	        }
	    },

	    isAncestorOrSelf: function(root, node) {
	        return Dom.isAncestorOf(root, node) || root == node;
	    },

	    findClosestAncestor: function(root, node) {
	        if (Dom.isAncestorOf(root, node)) {
	            while (node && node.parentNode != root) {
	                node = node.parentNode;
	            }
	        }

	        return node;
	    },

	    getAllComments: function (rootElem) {
	        var comments = [];
	        // Fourth argument, which is actually obsolete according to the DOM4 standard, is required in IE 11
	        var iterator = document.createNodeIterator(rootElem,
	            NodeFilter.SHOW_COMMENT,
	            function () {
	                return NodeFilter.FILTER_ACCEPT;
	            }, false);

	        var curNode = iterator.nextNode();
	        while (curNode) {
	            comments.push(curNode.nodeValue);
	            curNode = iterator.nextNode();
	        }
	        return comments;
	    },

	    getNodeLength: function(node) {
	        return Dom.isDataNode(node) ? node.length : node.childNodes.length;
	    },

	    splitDataNode: function(node, offset) {
	        var newNode = node.cloneNode(false);
	        var denormalizedText = "";
	        var iterator = node.nextSibling;
	        var temp;

	        while (iterator && iterator.nodeType == 3 && iterator.nodeValue) {
	            denormalizedText += iterator.nodeValue;
	            temp = iterator;
	            iterator = iterator.nextSibling;
	            Dom.remove(temp);
	        }

	        node.deleteData(offset, node.length);
	        newNode.deleteData(0, offset);
	        newNode.nodeValue += denormalizedText;
	        Dom.insertAfter(newNode, node);
	    },

	    attrEquals: function(node, attributes) {
	        for (var key in attributes) {
	            var value = node[key];

	            if (key == FLOAT) {
	                value = node[kendo.support.cssFloat ? CSSFLOAT : STYLEFLOAT];
	            }

	            if (typeof value == "object") {
	                if (!Dom.attrEquals(value, attributes[key])) {
	                    return false;
	                }
	            } else if (value != attributes[key]) {
	                return false;
	            }
	        }

	        return true;
	    },

	    blockParentOrBody: function(node) {
	        return Dom.parentOfType(node, blockElements) || node.ownerDocument.body;
	    },

	    blockParents: function(nodes) {
	        var blocks = [],
	            i, len;

	        for (i = 0, len = nodes.length; i < len; i++) {
	            var block = Dom.parentOfType(nodes[i], Dom.blockElements);
	            if (block && $.inArray(block, blocks) < 0) {
	                blocks.push(block);
	            }
	        }

	        return blocks;
	    },

	    windowFromDocument: function(document) {
	        return document.defaultView || document.parentWindow;
	    },

	    normalize: normalize,
	    blockElements: blockElements,
	    nonListBlockElements: nonListBlockElements,
	    inlineElements: inlineElements,
	    empty: empty,
	    fillAttrs: fillAttrs,
	    nodeTypes: {
	        ELEMENT_NODE: 1,
	        ATTRIBUTE_NODE: 2,
	        TEXT_NODE: 3,
	        CDATA_SECTION_NODE: 4,
	        ENTITY_REFERENCE_NODE: 5,
	        ENTITY_NODE: 6,
	        PROCESSING_INSTRUCTION_NODE: 7,
	        COMMENT_NODE: 8,
	        DOCUMENT_NODE: 9,
	        DOCUMENT_TYPE_NODE: 10,
	        DOCUMENT_FRAGMENT_NODE: 11,
	        NOTATION_NODE: 12
	    },

	    toHex: function (color) {
	        var matches = rgb.exec(color);

	        if (!matches) {
	            return color;
	        }

	        return "#" + map(matches.slice(1), function (x) {
	            x = parseInt(x, 10).toString(16);
	            return x.length > 1 ? x : "0" + x;
	        }).join("");
	    },

	    encode: function (value, options) {
	        var encodableChars = (!options || options.entities) ? entityRe : htmlRe;
	        return value.replace(encodableChars, function(c) {
	            var charCode = c.charCodeAt(0);
	            var entity = entityTable[charCode];
	            return entity ? '&'+entity+';' : c;
	        });
	    },
	    isBom: function(node) {
	        return node && node.nodeType === 3 && /^[\ufeff]+$/.test(node.nodeValue);
	    },
	    stripBom: function(text) {
	        return (text || "").replace(bom, "");
	    },

	    stripBomNode: function(node) {
	        if(Dom.isBom(node)) {
	            node.parentNode.removeChild(node);
	        }
	    },

	    insignificant: function(node) {
	        var attr = node.attributes;

	        return node.className == "k-marker" || (Dom.is(node, 'br') && (node.className == "k-br" || attr._moz_dirty || attr._moz_editor_bogus_node)) || (Dom.is(node, 'span') && (node.className == "k-br"));
	    },
	    tableCell: function(node) {
	        return Dom.is(node, "td") || Dom.is(node, "th");
	    },
	    significantNodes: function(nodes) {
	        return $.grep(nodes, function(child) {
	            var name = Dom.name(child);

	            if (name == 'br') {
	                return false;
	            } else if (Dom.insignificant(child)) {
	                return false;
	            } else if (Dom.emptyTextNode(child)) {
	                return false;
	            } else if (child.nodeType == 1 && !empty[name] && Dom.emptyNode(child)) {
	                return false;
	            }

	            return true;
	        });
	    },

	    emptyTextNode: function(node) {
	        return node && node.nodeType == 3 && whitespaceOrBom.test(node.nodeValue);
	    },

	    emptyNode: function(node) {
	        return node.nodeType == 1 && !Dom.significantNodes(node.childNodes).length;
	    },

	    name: function (node) {
	        return node.nodeName.toLowerCase();
	    },

	    significantChildNodes: function(node) {
	        return $.grep(node.childNodes, function(child) {
	            return child.nodeType != 3 || !Dom.isWhitespace(child);
	        });
	    },

	    lastTextNode: function(node) {
	        var result = null;

	        if (node.nodeType == 3) {
	            return node;
	        }

	        for (var child = node.lastChild; child; child = child.previousSibling) {
	            result = Dom.lastTextNode(child);

	            if (result) {
	                return result;
	            }
	        }

	        return result;
	    },

	    is: function (node, nodeName) {
	        return node && Dom.name(node) == nodeName;
	    },

	    isMarker: function(node) {
	        return node.className == KMARKER;
	    },

	    isWhitespace: function(node) {
	        return whitespace.test(node.nodeValue);
	    },

	    allWhitespaceContent: function(node) {
	        var child = node.firstChild;
	        while(child && Dom.isWhitespace(child)) {
	            child = child.nextSibling;
	        }

	        return !child;
	    },


	    isEmptyspace: function(node) {
	        return emptyspace.test(node.nodeValue);
	    },

	    htmlIndentSpace: function (node){
	        if (!(Dom.isDataNode(node) && Dom.isWhitespace(node))) {
	            return false;
	        }

	        if (emptyspace.test(node.nodeValue)) {
	            return true;
	        }

	        var sibling = function(el, direction) {
	            while (el[direction]) {
	                el = el[direction];
	                if (Dom.significantNodes([el]).length  > 0) {
	                    return el;
	                }
	            }
	        };

	        var parent = node.parentNode;
	        var prev = sibling(node, "previousSibling");
	        var next = sibling(node, "nextSibling");

	        if (bom.test(node.nodeValue)) {
	            return !!(prev || next);
	        }

	        if ($(parent).is("tr,tbody,thead,tfoot,table,ol,ul")) {
	            return true;
	        }

	        if (Dom.isBlock(parent) || Dom.is(parent, "body")) {
	            var isPrevBlock = prev && Dom.isBlock(prev);
	            var isNextBlock = next && Dom.isBlock(next);
	            if ((!next && isPrevBlock) || (!prev && isNextBlock) || (isPrevBlock && isNextBlock)) {
	                return true;
	            }
	        }

	        return false;
	    },

	    isBlock: function(node) {
	        return block[Dom.name(node)];
	    },

	    isSelfClosing: function(node) {
	        return selfClosing[Dom.name(node)];
	    },

	    isEmpty: function(node) {
	        return empty[Dom.name(node)];
	    },

	    isInline: function(node) {
	        return inline[Dom.name(node)];
	    },

	    isBr: function(node) {
	        return Dom.name(node) == "br";
	    },

	    list: function(node) {
	        var name = node ? Dom.name(node) : "";
	        return name == "ul" || name == "ol" || name == "dl";
	    },

	    scrollContainer: function(doc) {
	        var wnd = Dom.windowFromDocument(doc),
	            scrollContainer = (wnd.contentWindow || wnd).document || wnd.ownerDocument || wnd;

	        if (scrollContainer.compatMode == 'BackCompat') {
	            scrollContainer = scrollContainer.body;
	        } else {
	            scrollContainer = scrollContainer.scrollingElement || scrollContainer.documentElement;
	        }

	        return scrollContainer;
	    },

	    scrollTo: function (node, toStart) {
	        var doc = node.ownerDocument;
	        var wnd = Dom.windowFromDocument(doc);
	        var windowHeight = wnd.innerHeight;
	        var scrollContainer = Dom.scrollContainer(doc);
	        var element, elementTop, elementHeight, marker;

	        if (Dom.isDataNode(node)) {
	            if (toStart) {
	                marker = Dom.create(doc, "span", {"innerHTML": "&#xfeff;"});
	                Dom.insertBefore(marker, node);
	                element = $(marker);
	            } else {
	                element = $(node.parentNode);
	            }
	        } else {
	            element = $(node);
	        }

	        elementTop = element.offset().top;
	        elementHeight = element[0].offsetHeight;

	        if (toStart || !elementHeight) {
	            elementHeight = parseInt(element.css("line-height"), 10) ||
	                            Math.ceil(1.2 * parseInt(element.css("font-size"), 10)) ||
	                            15;
	        }

	        if (marker) {
	            Dom.remove(marker);
	        }

	        if (elementHeight + elementTop > scrollContainer.scrollTop + windowHeight) {
	            scrollContainer.scrollTop = elementHeight + elementTop - windowHeight;
	        }
	    },

	    persistScrollTop: function(doc) {
	        persistedScrollTop = Dom.scrollContainer(doc).scrollTop;
	    },

	    offset: function (target, offsetParent) {
	        var result = {top: target.offsetTop, left: target.offsetLeft};
	        var parent = target.offsetParent;

	        while (parent && (!offsetParent || Dom.isAncestorOf(offsetParent, parent))) {
	            result.top += parent.offsetTop;
	            result.left += parent.offsetLeft;
	            parent = parent.offsetParent;
	        }

	        return result;
	    },

	    restoreScrollTop: function(doc) {
	        if (typeof persistedScrollTop == "number") {
	            Dom.scrollContainer(doc).scrollTop = persistedScrollTop;
	            persistedScrollTop = undefined;
	        }
	    },

	    insertAt: function (parent, newElement, position) {
	        parent.insertBefore(newElement, parent.childNodes[position] || null);
	    },

	    insertBefore: function (newElement, referenceElement) {
	        if (referenceElement.parentNode) {
	            return referenceElement.parentNode.insertBefore(newElement, referenceElement);
	        } else {
	            return referenceElement;
	        }
	    },

	    insertAfter: function (newElement, referenceElement) {
	        return referenceElement.parentNode.insertBefore(newElement, referenceElement.nextSibling);
	    },

	    remove: function (node) {
	        if(node.parentNode) {
	            node.parentNode.removeChild(node);
	        }
	    },

	    removeChildren: function(node){
	        while(node.firstChild) {
	            node.removeChild(node.firstChild);
	        }
	    },

	    removeTextSiblings: function(node) {
	        var parentNode = node.parentNode;

	        while (node.nextSibling && node.nextSibling.nodeType == 3) {
	            parentNode.removeChild(node.nextSibling);
	        }

	        while (node.previousSibling && node.previousSibling.nodeType == 3) {
	            parentNode.removeChild(node.previousSibling);
	        }
	    },

	    trim: function (parent) {
	        for (var i = parent.childNodes.length - 1; i >= 0; i--) {
	            var node = parent.childNodes[i];
	            if (Dom.isDataNode(node)) {
	                if (!Dom.stripBom(node.nodeValue).length) {
	                    Dom.remove(node);
	                }
	            } else if (node.className != KMARKER) {
	                Dom.trim(node);

	                if ((!Dom.isEmpty(node) && node.childNodes.length === 0) ||
	                    (Dom.isBlock(node) && Dom.allWhitespaceContent(node))) {
	                    Dom.remove(node);
	                }
	            }
	        }

	        return parent;
	    },

	    closest: function(node, tags) {
	        if(typeof tags === "string") {
	            tags = [tags];
	        }

	        while (node && tags.indexOf(Dom.name(node)) < 0) {
	            node = node.parentNode;
	        }

	        return node;
	    },

	    closestBy: function(node, condition, rootCondition) {
	        while (node && !condition(node)) {
	            if (rootCondition && rootCondition(node)){
	                return null;
	            }
	            node = node.parentNode;
	        }
	        return node;
	    },

	    sibling: function(node, direction) {
	        do {
	            node = node[direction];
	        } while (node && node.nodeType != 1);

	        return node;
	    },

	    next: function(node) {
	        return Dom.sibling(node, "nextSibling");
	    },

	    prev: function(node) {
	        return Dom.sibling(node, "previousSibling");
	    },

	    parentOfType: function (node, tags) {
	        do {
	            node = node.parentNode;
	        } while (node && !(Dom.ofType(node, tags)));

	        return node;
	    },

	    ofType: function (node, tags) {
	        return $.inArray(Dom.name(node), tags) >= 0;
	    },

	    changeTag: function (referenceElement, tagName, skipAttributes) {
	        var newElement = Dom.create(referenceElement.ownerDocument, tagName),
	            attributes = referenceElement.attributes,
	            i, len, name, value, attribute;

	        if (!skipAttributes) {
	            for (i = 0, len = attributes.length; i < len; i++) {
	                attribute = attributes[i];
	                if (attribute.specified) {
	                    // IE < 8 cannot set class or style via setAttribute
	                    name = attribute.nodeName;
	                    value = attribute.nodeValue;
	                    if (name == CLASS) {
	                        newElement.className = value;
	                    } else if (name == STYLE) {
	                        newElement.style.cssText = referenceElement.style.cssText;
	                    } else {
	                        newElement.setAttribute(name, value);
	                    }
	                }
	            }
	        }

	        while (referenceElement.firstChild) {
	            newElement.appendChild(referenceElement.firstChild);
	        }

	        Dom.insertBefore(newElement, referenceElement);
	        Dom.remove(referenceElement);
	        return newElement;
	    },

	    editableParent: function(node) {
	        while (node && (node.nodeType == 3 || node.contentEditable !== 'true')) {
	            node = node.parentNode;
	        }

	        return node;
	    },

	    wrap: function (node, wrapper) {
	        Dom.insertBefore(wrapper, node);
	        wrapper.appendChild(node);
	        return wrapper;
	    },

	    unwrap: function (node) {
	        var parent = node.parentNode;
	        while (node.firstChild) {
	            parent.insertBefore(node.firstChild, node);
	        }

	        parent.removeChild(node);
	    },

	    wrapper: function(node) {
	        var wrapper = Dom.closestBy(node, function (el) {
	            return el.parentNode && Dom.significantNodes(el.parentNode.childNodes).length > 1;
	        });

	        return $(wrapper).is("body,.k-editor") ? undefined : wrapper;
	    },

	    create: function (document, tagName, attributes) {
	        return Dom.attr(document.createElement(tagName), attributes);
	    },

	    createEmptyNode: function (document, tagName, attributes) {
	        var node = Dom.attr(document.createElement(tagName), attributes);
	        node.innerHTML = "\ufeff";
	        return node;
	    },

	    attr: function (element, attributes) {
	        attributes = extend({}, attributes);

	        if (attributes && STYLE in attributes) {
	            Dom.style(element, attributes.style);
	            delete attributes.style;
	        }

	        for (var attr in attributes) {
	            if (attributes[attr] === null) {
	                element.removeAttribute(attr);
	                delete attributes[attr];
	            } else if (attr == "className") {
	                element[attr] = attributes[attr];
	            }
	        }

	        return extend(element, attributes);
	    },

	    mergeAttributes: function (origin, target) {
	        if (!origin.attributes.length) {
	            return;
	        }

	        $.each(origin.attributes, function() {
	            if(this.name !== "contenteditable") {
	                $(target).attr(this.name, this.value);
	            }
	        });
	    },

	    style: function (node, value) {
	        $(node).css(value || {});
	    },

	    unstyle: function (node, value) {
	        for (var key in value) {
	            if (key == FLOAT) {
	                key = kendo.support.cssFloat ? CSSFLOAT : STYLEFLOAT;
	            }

	            node.style[key] = "";
	        }

	        if (node.style.cssText === "") {
	            node.removeAttribute(STYLE);
	        }
	    },

	    inlineStyle: function(body, name, attributes) {
	        var span = $(Dom.create(body.ownerDocument, name, attributes)),
	            style;

	        body.appendChild(span[0]);

	        style = map(cssAttributes, function(value) {
	            if (browser.msie && value == "line-height" && span.css(value) == "1px") {
	                return "line-height:1.5";
	            } else {
	                return value + ":" + span.css(value);
	            }
	        }).join(";");

	        span.remove();

	        return style;
	    },

	    getEffectiveBackground: function(element) {
	        var backgroundStyle = element.css("background-color") || "";

	        if (backgroundStyle.indexOf("rgba(0, 0, 0, 0") < 0 && backgroundStyle !== "transparent") {
	            return backgroundStyle;
	        } else if (element[0].tagName.toLowerCase() === "html") {
	            return "Window";
	        } else {
	            return Dom.getEffectiveBackground(element.parent());
	        }
	    },

	    innerText: function(node) {
	        var text = node.innerHTML;
	        text = text.replace(/<!--(.|\s)*?-->/gi, "");
	        text = text.replace(/<\/?[^>]+?\/?>/gm, "");

	        return text;
	    },

	    removeClass: function(node, classNames) {
	        var className = " " + node.className + " ",
	            classes = classNames.split(" "),
	            i, len;

	        for (i = 0, len = classes.length; i < len; i++) {
	            className = className.replace(" " + classes[i] + " ", " ");
	        }

	        className = kendo.trim(className);

	        if (className.length) {
	            node.className = className;
	        } else {
	            node.removeAttribute(CLASS);
	        }
	    },

	    commonAncestor: function () {
	        var count = arguments.length,
	            paths = [],
	            minPathLength = Infinity,
	            output = null,
	            i, ancestors, node, first, j;

	        if (!count) {
	            return null;
	        }

	        if (count == 1) {
	            return arguments[0];
	        }

	        for (i = 0; i < count; i++) {
	            ancestors = [];
	            node = arguments[i];
	            while (node) {
	                ancestors.push(node);
	                node = node.parentNode;
	            }
	            paths.push(ancestors.reverse());
	            minPathLength = Math.min(minPathLength, ancestors.length);
	        }

	        if (count == 1) {
	            return paths[0][0];
	        }

	        for (i = 0; i < minPathLength; i++) {
	            first = paths[0][i];

	            for (j = 1; j < count; j++) {
	                if (first != paths[j][i]) {
	                    return output;
	                }
	            }

	            output = first;
	        }
	        return output;
	    },

	    closestSplittableParent: function(nodes) {
	        var result;

	        if (nodes.length == 1) {
	            result = Dom.parentOfType(nodes[0], ["ul","ol"]);
	        } else {
	            result = Dom.commonAncestor.apply(null, nodes);
	        }

	        if (!result) {
	            result = Dom.parentOfType(nodes[0], ["p", "td"]) || nodes[0].ownerDocument.body;
	        }

	        if (Dom.isInline(result)) {
	            result = Dom.blockParentOrBody(result);
	        }

	        var editableParents = map(nodes, Dom.editableParent);
	        var editableAncestor = Dom.commonAncestor(editableParents)[0];

	        if ($.contains(result, editableAncestor)) {
	            result = editableAncestor;
	        }

	        return result;
	    },

	    closestEditable: function(node, types) {
	        var closest;
	        var editable = Dom.editableParent(node);

	        if (Dom.ofType(node, types)) {
	            closest = node;
	        } else {
	            closest = Dom.parentOfType(node, types);
	        }

	        if (closest && editable && $.contains(closest, editable)) {
	            closest = editable;
	        } else if (!closest && editable) {
	            closest = editable;
	        }

	        return closest;
	    },

	    closestEditableOfType: function(node, types) {
	        var editable = Dom.closestEditable(node, types);

	        if (editable && Dom.ofType(editable, types) && !$(editable).is(".k-editor")) {
	            return editable;
	        }
	    },

	    filter: function(tagName, nodes, invert) {
	        var filterFn = function (node) {
	            return Dom.name(node) == tagName;
	        };

	        return Dom.filterBy(nodes, filterFn, invert);
	    },

	    filterBy: function(nodes, condition, invert) {
	        var i = 0;
	        var len = nodes.length;
	        var result = [];
	        var match;

	        for (; i < len; i++) {
	            match = condition(nodes[i]);
	            if ((match && !invert) || (!match && invert)) {
	                result.push(nodes[i]);
	            }
	        }

	        return result;
	    },

	    ensureTrailingBreaks: function(node) {
	        var elements = $(node).find("p,td,th");
	        var length = elements.length;
	        var i = 0;

	        if (length) {
	            for (; i < length; i++) {
	                Dom.ensureTrailingBreak(elements[i]);
	            }
	        } else {
	            Dom.ensureTrailingBreak(node);
	        }
	    },

	    removeTrailingBreak: function(node) {
	        $(node).find("br[type=_moz],.k-br").remove();
	    },

	    ensureTrailingBreak: function(node) {
	        Dom.removeTrailingBreak(node);

	        var lastChild = node.lastChild;
	        var name = lastChild && Dom.name(lastChild);
	        var br;

	        if (!name ||
	            (name != "br" && name != "img") ||
	            (name == "br" && lastChild.className != "k-br")) {
	            br = node.ownerDocument.createElement("br");
	            br.className = "k-br";
	            node.appendChild(br);
	        }
	    },

	    // Start: Table Utilities

	    reMapTableColumns: function (table, colAttr) {
	        Dom._mapColIndices(table, colAttr);
	    },

	    clearTableMappings: function (table, colAttr) {
	        $(table).find("["+ colAttr + "]").removeAttr(colAttr);
	    },

	    _mapColIndices: function (table, colAttr) {
	        var registeredColumns = {};

	        for (var rowIndex = 0; rowIndex < table.rows.length; rowIndex++) {
	            var cells = table.rows[rowIndex].cells;
	            var colIndex = 0;
	            for (var cellIndex = 0; cellIndex < cells.length; cellIndex++, colIndex++) {
	                var cell = cells[cellIndex];

	                if(cell.rowSpan > 1) {
	                    this._mapColspan(cell, rowIndex, colIndex, registeredColumns);
	                }

	                if(registeredColumns[rowIndex]) {
	                    while(registeredColumns[rowIndex][colIndex]) {
	                        colIndex++;
	                    }
	                }

	                cell.setAttribute(colAttr, colIndex);

	                if(cell.colSpan > 1) {
	                    colIndex = colIndex + cell.colSpan - 1;
	                }
	            }
	        }
	    },

	    _mapColspan: function (cell, rowIndex, colIndex, registeredColumns) {
	        var rowSpan = cell.rowSpan,
	            colSpan = cell.colSpan,
	            index;

	        for (var ci = 0; ci < colSpan; ci++) {
	            index = colIndex + ci;

	            for (var ri = rowIndex + 1; ri < rowIndex + rowSpan; ri++) {

	                if(!registeredColumns[ri]) {
	                    registeredColumns[ri] = {};
	                    registeredColumns[ri].length = 0;
	                }

	                if(registeredColumns[rowIndex]) {
	                    while(registeredColumns[rowIndex][index]) {
	                        index++;
	                    }
	                }

	                registeredColumns[ri][index] = true;
	                registeredColumns[ri].length++;
	            }
	        }

	    },

	    associateWithIds: function(table) {
	        var that = this;
	        var numberOfTheadRows = 0;
	        var tableRows = table.rows;
	        var numberOfTableRows = tableRows.length;
	        var theadMatrix = [];
	        var tbodyMatrix = [];
	        var theadRows, i;

	        if(table.tHead) {
	            theadRows = table.tHead.rows;
	            numberOfTheadRows = theadRows.length;
	        } else {
	            numberOfTheadRows = that._getNumberOfHeaderRows(table);
	            theadRows = [];
	            for (i = 0; i < numberOfTheadRows; i++) {
	                theadRows.push(tableRows[i]);
	            }
	        }
	        for (i = 0; i < numberOfTheadRows; i++) {
	            theadMatrix.push([]);
	        }
	        for (i = 0; i < numberOfTableRows; i++) {
	            tbodyMatrix.push([]);
	        }

	        that._generateIdsForColumns(theadMatrix, theadRows);
	        that._generateIdsForRows(theadMatrix, tbodyMatrix, numberOfTheadRows, tableRows);
	        that._assignIds(theadMatrix, tbodyMatrix, numberOfTheadRows, tableRows);
	    },

	    _generateIdsForColumns: function(theadMatrix, theadRows) {
	        var timestamp = new Date().getTime();
	        var numberOfTheadRows = theadRows ? theadRows.length : 0;
	        var row, cells, cell, col, id, colspan, rowspan, i, j, k, l;

	        for (i = 0; i < numberOfTheadRows; i++) {
	            row = theadRows[i];
	            cells = row.cells;
	            col = 0;

	            for(j = 0; j < cells.length; j++) {
	                cell = cells[j];
	                id = "table" + i + j + (++timestamp);
	                cell.setAttribute("id", id);
	                colspan = cell.getAttribute("colspan") || 1;
	                rowspan = cell.getAttribute("rowspan") || 1;

	                while(theadMatrix[i][j + col]) {
	                    col += 1;
	                }

	                for(k = 0; k < rowspan; k++) {
	                    for(l = 0; l < colspan; l++) {
	                        theadMatrix[i + k][j + col + l] = id;
	                    }
	                }
	            }
	        }
	    },

	    _generateIdsForRows: function(theadMatrix, tbodyMatrix, numberOfTheadRows, tableRows) {
	        var that = this;
	        var timestamp = new Date().getTime();
	        var numberOfTableRows = tableRows.length;
	        var row, cells, cell, col, id, colspan, rowspan, i, j, k, l, colIndex, headers;

	        var pushHeaderId = function(row){
	            headers.push(row[colIndex]);
	        };

	        for (i = numberOfTheadRows; i < numberOfTableRows; i++) {
	            row = tableRows[i];
	            cells = $(row.cells).filter("th");
	            col = 0;

	            for(j = 0; j < cells.length; j++) {
	                cell = cells[j];
	                id = "table" + i + j + (++timestamp);
	                cell.setAttribute("id", id);
	                colspan = cell.getAttribute("colspan") || 1;
	                rowspan = cell.getAttribute("rowspan") || 1;

	                while(tbodyMatrix[i][j + col]) {
	                    col += 1;
	                }

	                for(k = 0; k < rowspan; k++) {
	                    for(l = 0; l < colspan; l++) {
	                        tbodyMatrix[i + k][j + col + l] = id;
	                    }
	                }

	                colIndex = cell.getAttribute("col-index");
	                headers = [];
	                theadMatrix.forEach(pushHeaderId);
	                headers = headers.filter(that._onlyUnique);
	                cell.setAttribute("headers", headers.join(" ").trim());
	            }
	        }
	    },

	    _assignIds: function(theadMatrix, tbodyMatrix, numberOfTheadRows, tableRows) {
	        var that = this;
	        var numberOfTableRows = tableRows.length;
	        var row, cells, cell, i, j, colIndex, headers;

	        var pushHeaderId = function(row){
	            headers.push(row[colIndex]);
	        };

	        for (i = numberOfTheadRows; i < numberOfTableRows; i++) {
	            row = tableRows[i];
	            cells = $(row.cells).filter("td");

	            for(j = 0; j < cells.length; j++) {
	                cell = cells[j];
	                colIndex = cell.getAttribute("col-index");
	                headers = tbodyMatrix[i].slice();

	                theadMatrix.forEach(pushHeaderId);
	                headers = headers.filter(that._onlyUnique);
	                cell.setAttribute("headers", headers.join(" ").trim());
	            }
	        }
	    },

	    _getNumberOfColumns: function(table) {
	        var cells = $(table).find("th, td");
	        var numberOfCols = 0;
	        var cell, i, currentIndex;

	        for(i = 0; i < cells.length; i++) {
	            cell = cells[i];
	            currentIndex = Number(cell.getAttribute("col-index")) + 1;
	            if(currentIndex > numberOfCols) {
	                numberOfCols = currentIndex;
	            }
	        }

	        return numberOfCols;
	    },

	    _getNumberOfHeaderColumns: function(table, numberOfHeaderRows) {
	        var rows = table.rows;
	        var numberOfCols = 0;
	        var currentIndex, row, i, j, cell;

	        for(i = numberOfHeaderRows; i < rows.length; i++) {
	            row = rows[i];

	            for(j = 0; j < row.cells.length; j++) {
	                cell = row.cells[j];

	                if(this.is(cell, "th")) {
	                    currentIndex = Number(cell.getAttribute("col-index")) + 1;
	                    if(currentIndex > numberOfCols) {
	                        numberOfCols = currentIndex;
	                    }
	                }
	            }
	        }

	        return numberOfCols;
	    },

	    _getNumberOfHeaderRows: function(table) {
	        var rows = table.rows;
	        var thead = table.tHead;
	        var number = thead && table.tHead.rows ? table.tHead.rows.length : 0;
	        var j, row, cell, length;

	        if(number === 0) {
	            row = rows[0];
	            length = row.cells && row.cells.length;

	            while(row && length && this.is(row.cells[0], "th")) {
	                for(j = 0; j < length; j++) {
	                    cell = row ? row.cells[j] : null;

	                    if(!this.is(cell, "th")) {
	                        row = null;
	                    }
	                }

	                if(row) {
	                    number += 1;
	                    row = this.next(row);
	                    length = row && row.cells && row.cells.length;
	                }
	            }
	        }

	        return number ;
	    },

	    // End: Table Utilities

	    _onlyUnique: function(value, index, self) {
	        return self.indexOf(value) === index;
	    }
	};

	kendo.ui.editor.Dom = Dom;

	})(window.kendo.jQuery);

	}, __webpack_require__(3));




/***/ }),

/***/ 962:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2UxK");

/***/ })

/******/ });

/***/ }),

/***/ "NFvU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var rowNodeBlock_1 = __webpack_require__("8wuL");
var logger_1 = __webpack_require__("U9Xd");
var context_1 = __webpack_require__("RQ1/");
var utils_1 = __webpack_require__("IRr6");
var RowNodeBlockLoader = (function () {
    function RowNodeBlockLoader(maxConcurrentRequests) {
        this.activeBlockLoadsCount = 0;
        this.blocks = [];
        this.active = true;
        this.maxConcurrentRequests = maxConcurrentRequests;
    }
    RowNodeBlockLoader.prototype.setBeans = function (loggerFactory) {
        this.logger = loggerFactory.create('RowNodeBlockLoader');
    };
    RowNodeBlockLoader.prototype.addBlock = function (block) {
        this.blocks.push(block);
    };
    RowNodeBlockLoader.prototype.removeBlock = function (block) {
        utils_1._.removeFromArray(this.blocks, block);
    };
    RowNodeBlockLoader.prototype.destroy = function () {
        this.active = false;
    };
    RowNodeBlockLoader.prototype.loadComplete = function () {
        this.activeBlockLoadsCount--;
    };
    RowNodeBlockLoader.prototype.checkBlockToLoad = function () {
        if (!this.active) {
            return;
        }
        this.printCacheStatus();
        if (this.activeBlockLoadsCount >= this.maxConcurrentRequests) {
            this.logger.log("checkBlockToLoad: max loads exceeded");
            return;
        }
        var blockToLoad = null;
        this.blocks.forEach(function (block) {
            if (block.getState() === rowNodeBlock_1.RowNodeBlock.STATE_DIRTY) {
                blockToLoad = block;
            }
        });
        if (blockToLoad) {
            blockToLoad.load();
            this.activeBlockLoadsCount++;
            this.logger.log("checkBlockToLoad: loading page " + blockToLoad.getBlockNumber());
            this.printCacheStatus();
        }
        else {
            this.logger.log("checkBlockToLoad: no pages to load");
        }
    };
    RowNodeBlockLoader.prototype.getBlockState = function () {
        var result = {};
        this.blocks.forEach(function (block) {
            var nodeIdPrefix = block.getNodeIdPrefix();
            var stateItem = {
                blockNumber: block.getBlockNumber(),
                startRow: block.getStartRow(),
                endRow: block.getEndRow(),
                pageStatus: block.getState()
            };
            if (utils_1._.exists(nodeIdPrefix)) {
                result[nodeIdPrefix + block.getBlockNumber()] = stateItem;
            }
            else {
                result[block.getBlockNumber()] = stateItem;
            }
        });
        return result;
    };
    RowNodeBlockLoader.prototype.printCacheStatus = function () {
        if (this.logger.isLogging()) {
            this.logger.log("printCacheStatus: activePageLoadsCount = " + this.activeBlockLoadsCount + ","
                + (" blocks = " + JSON.stringify(this.getBlockState())));
        }
    };
    __decorate([
        __param(0, context_1.Qualifier('loggerFactory')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
        __metadata("design:returntype", void 0)
    ], RowNodeBlockLoader.prototype, "setBeans", null);
    return RowNodeBlockLoader;
}());
exports.RowNodeBlockLoader = RowNodeBlockLoader;


/***/ }),

/***/ "NGcw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var setFilter_1 = __webpack_require__("46fC");
var richSelectCellEditor_1 = __webpack_require__("xUPt");
var licenseManager_1 = __webpack_require__("7uAN");
var detailCellRenderer_1 = __webpack_require__("YEid");
var EnterpriseBoot = (function () {
    function EnterpriseBoot() {
    }
    EnterpriseBoot.prototype.init = function () {
        this.componentProvider.registerDefaultComponent('agRichSelect', richSelectCellEditor_1.RichSelectCellEditor);
        this.componentProvider.registerDefaultComponent('agRichSelectCellEditor', richSelectCellEditor_1.RichSelectCellEditor);
        this.componentProvider.registerDefaultComponent('agSetColumnFilter', setFilter_1.SetFilter);
        this.componentProvider.registerDefaultComponent('agDetailCellRenderer', detailCellRenderer_1.DetailCellRenderer);
        this.licenseManager.validateLicense();
    };
    __decorate([
        main_1.Autowired('filterManager'),
        __metadata("design:type", main_1.FilterManager)
    ], EnterpriseBoot.prototype, "filterManager", void 0);
    __decorate([
        main_1.Autowired('cellEditorFactory'),
        __metadata("design:type", main_1.CellEditorFactory)
    ], EnterpriseBoot.prototype, "cellEditorFactory", void 0);
    __decorate([
        main_1.Autowired('licenseManager'),
        __metadata("design:type", licenseManager_1.LicenseManager)
    ], EnterpriseBoot.prototype, "licenseManager", void 0);
    __decorate([
        main_1.Autowired('componentProvider'),
        __metadata("design:type", main_1.ComponentProvider)
    ], EnterpriseBoot.prototype, "componentProvider", void 0);
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], EnterpriseBoot.prototype, "init", null);
    EnterpriseBoot = __decorate([
        main_1.Bean('enterpriseBoot')
    ], EnterpriseBoot);
    return EnterpriseBoot;
}());
exports.EnterpriseBoot = EnterpriseBoot;


/***/ }),

/***/ "NJlX":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1007);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 973:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2UxK");

/***/ }),

/***/ 1002:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lysN");

/***/ }),

/***/ 1007:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(973), __webpack_require__(1008), __webpack_require__(1002)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function() {

	(function(kendo, undefined) {
	    var $ = kendo.jQuery;
	    var extend = $.extend;
	    var noop = $.noop;
	    var proxy = $.proxy;

	    var Editor = kendo.ui.editor;
	    var Class = kendo.Class;

	    var KEY_DOWN = "keydown";
	    var MOUSE_DOWN = "mousedown";
	    var MOUSE_ENTER = "mouseenter";
	    var MOUSE_LEAVE = "mouseleave";
	    var MOUSE_MOVE = "mousemove";
	    var MOUSE_UP = "mouseup";

	    var COMMA = ",";
	    var DOT = ".";
	    var LAST_CHILD = ":last-child";

	    var TABLE = "table";

	    var TableElementResizing = Class.extend({
	        init: function(element, options) {
	            var that = this;

	            that.options = extend({}, that.options, options);

	            that.options.tags = $.isArray(that.options.tags) ? that.options.tags : [that.options.tags];

	            if ($(element).is(TABLE)) {
	                that.element = element;
	                that._attachEventHandlers();
	            }
	        },

	        destroy: function() {
	            var that = this;
	            var eventNamespace = that.options.eventNamespace;

	            if (that.element) {
	                $(that.element).off(eventNamespace);
	                that.element = null;
	            }

	            $(that.options.rootElement).off(KEY_DOWN + eventNamespace);

	            that._destroyResizeHandle();
	        },

	        options: {
	            tags: [],
	            min: 0,
	            rootElement: null,
	            eventNamespace: "",
	            rtl: false,
	            handle: {
	                dataAttribute: "",
	                height: 0,
	                width: 0,
	                classNames: {},
	                template: ""
	            }
	        },

	        _attachEventHandlers: function() {
	            var that = this;
	            var options = that.options;

	            $(that.element).on(MOUSE_MOVE + options.eventNamespace, options.tags.join(COMMA), proxy(that.detectElementBorderHovering, that));
	        },

	        resizingInProgress: function() {
	            var that = this;
	            var resizable = that._resizable;

	            if (resizable) {
	                return !!resizable.resizing;
	            }

	            return false;
	        },

	        resize: noop,

	        detectElementBorderHovering: function(e) {
	            var that = this;
	            var options = that.options;
	            var handleOptions = options.handle;
	            var tableElement = $(e.currentTarget);
	            var resizeHandle = that.resizeHandle;
	            var dataAttribute = handleOptions.dataAttribute;

	            if (!that.resizingInProgress()) {
	                if (!tableElement.is(LAST_CHILD) && that.elementBorderHovered(tableElement, e)) {
	                    if (resizeHandle) {
	                        if (resizeHandle.data(dataAttribute) && resizeHandle.data(dataAttribute) !== tableElement[0]) {
	                            that.showResizeHandle(tableElement, e);
	                        }
	                    }
	                    else {
	                        that.showResizeHandle(tableElement, e);
	                    }
	                }
	                else {
	                    if (resizeHandle) {
	                        that._destroyResizeHandle();
	                    }
	                }
	            }
	        },

	        elementBorderHovered: noop,

	        showResizeHandle: function(tableElement, e) {
	            var that = this;

	            if (e.buttons !== 0) {
	                //prevent showing when a mouse button is still being pressed
	                return;
	            }

	            that._initResizeHandle();
	            that.setResizeHandlePosition(tableElement);
	            that.setResizeHandleDimensions();
	            that.setResizeHandleDataAttributes(tableElement[0]);
	            that._attachResizeHandleEventHandlers();

	            that._initResizable(tableElement);

	            that._hideResizeMarker();
	            that.resizeHandle.show();
	        },

	        _initResizeHandle: function() {
	            var that = this;
	            var options = that.options;

	            that._destroyResizeHandle();

	            that.resizeHandle = $(options.handle.template).appendTo(options.rootElement);
	        },

	        setResizeHandlePosition: noop,

	        setResizeHandleDimensions: noop,

	        setResizeHandleDataAttributes: function(tableElement) {
	            var that = this;

	            that.resizeHandle.data(that.options.handle.dataAttribute, tableElement);
	        },

	        _attachResizeHandleEventHandlers: function() {
	            var that = this;
	            var options = that.options;
	            var eventNamespace = options.eventNamespace;
	            var markerClass = options.handle.classNames.marker;
	            var resizeHandle = that.resizeHandle;

	            that.resizeHandle
	                .on(MOUSE_DOWN + eventNamespace, function() {
	                    resizeHandle.find(DOT + markerClass).show();
	                })
	                .on(MOUSE_UP + eventNamespace, function() {
	                    resizeHandle.find(DOT + markerClass).hide();
	                });
	        },

	        _hideResizeMarker: function() {
	            var that = this;

	            that.resizeHandle.find(DOT + that.options.handle.classNames.marker).hide();
	        },

	        _destroyResizeHandle: function() {
	            var that = this;

	            if (that.resizeHandle) {
	                that._destroyResizable();
	                that.resizeHandle.off(that.options.eventNamespace).remove();
	                that.resizeHandle = null;
	            }
	        },

	        _initResizable: function(tableElement) {
	            var that = this;

	            if (!that.resizeHandle) {
	                return;
	            }

	            that._destroyResizable();

	            that._resizable = new kendo.ui.Resizable(tableElement, {
	                draggableElement: that.resizeHandle[0],
	                start: proxy(that.onResizeStart, that),
	                resize: proxy(that.onResize, that),
	                resizeend: proxy(that.onResizeEnd, that)
	            });
	        },

	        _destroyResizable: function() {
	            var that = this;

	            if (that._resizable) {
	                that._resizable.destroy();
	                that._resizable = null;
	            }
	        },

	        onResizeStart: function() {
	            this._disableKeyboard();
	        },

	        onResize: function(e) {
	            this.setResizeHandleDragPosition(e);
	        },

	        setResizeHandleDragPosition: noop,

	        onResizeEnd: function(e) {
	            var that = this;

	            that.resize(e);
	            that._destroyResizeHandle();
	            that._enableKeyboard();
	        },

	        _enableKeyboard: function() {
	            var options = this.options;

	            $(options.rootElement).off(KEY_DOWN + options.eventNamespace);
	        },

	        _disableKeyboard: function() {
	            var options = this.options;

	            $(options.rootElement).on(KEY_DOWN + options.eventNamespace, function(e) {
	                e.preventDefault();
	            });
	        },

	        _forceResizing: function(e) {
	            var resizable = this._resizable;

	            if (resizable && resizable.userEvents) {
	                resizable.userEvents._end(e);
	            }
	        }
	    });

	    var ResizingFactory = Class.extend({
	        create: function(editor, options) {
	            var that = this;
	            var resizingName = options.name;
	            var NS = options.eventNamespace;

	            $(editor.body)
	                .on(MOUSE_ENTER + NS, TABLE, function(e) {
	                    var table = e.currentTarget;
	                    var resizing = editor[resizingName];

	                    e.stopPropagation();

	                    if (resizing) {
	                        if (resizing.element !== table && !resizing.resizingInProgress()) {
	                            that._destroyResizing(editor, options);
	                            that._initResizing(editor, table, options);
	                        }
	                    }
	                    else {
	                        that._initResizing(editor, table, options);
	                    }
	                })
	                .on(MOUSE_LEAVE + NS, TABLE, function(e) {
	                    var parentTable;
	                    var resizing = editor[resizingName];

	                    e.stopPropagation();

	                    if (resizing && !resizing.resizingInProgress() && !resizing.resizeHandle) {
	                        parentTable = $(resizing.element).parents(TABLE)[0];

	                        if (parentTable) {
	                            that._destroyResizing(editor, options);
	                            that._initResizing(editor, parentTable, options);
	                        }
	                    }
	                })
	                .on(MOUSE_LEAVE + NS, function() {
	                    var resizing = editor[resizingName];

	                    if (resizing && !resizing.resizingInProgress()) {
	                        that._destroyResizing(editor, options);
	                    }
	                })
	                .on(MOUSE_UP + NS, function(e) {
	                    var resizing = editor[resizingName];
	                    var parentTable;

	                    if (resizing && resizing.resizingInProgress()) {
	                        parentTable = $(e.target).parents(TABLE)[0];

	                        if (parentTable) {
	                            resizing._forceResizing(e);
	                            that._destroyResizing(editor, options);
	                            that._initResizing(editor, parentTable, options);
	                        }
	                    }
	                });
	        },

	        dispose: function(editor, options) {
	            $(editor.body).off(options.eventNamespace);
	        },

	        _initResizing: function(editor, tableElement, options) {
	            var resizingName = options.name;
	            var resizingType = options.type;

	            editor[resizingName] = new resizingType(tableElement, {
	                rtl: kendo.support.isRtl(editor.element),
	                rootElement: editor.body
	            });
	        },

	        _destroyResizing: function(editor, options) {
	            var resizingName = options.name;

	            if (editor[resizingName]) {
	                editor[resizingName].destroy();
	                editor[resizingName] = null;
	            }
	        }
	    });
	    ResizingFactory.current = new ResizingFactory();

	    TableElementResizing.create = function(editor, options) {
	        ResizingFactory.current.create(editor, options);
	    };

	    TableElementResizing.dispose = function(editor, options) {
	        ResizingFactory.current.dispose(editor, options);
	    };

	    extend(Editor, {
	        TableElementResizing: TableElementResizing
	    });

	})(window.kendo);

	}, __webpack_require__(3));


/***/ }),

/***/ 1008:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("JKVm");

/***/ })

/******/ });

/***/ }),

/***/ "NRBX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var CssClassApplier = (function () {
    function CssClassApplier() {
    }
    CssClassApplier.addHeaderClassesFromColDef = function (abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup) {
        if (utils_1.Utils.missing(abstractColDef)) {
            return;
        }
        this.addColumnClassesFromCollDef(abstractColDef.headerClass, abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup);
    };
    CssClassApplier.addToolPanelClassesFromColDef = function (abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup) {
        if (utils_1.Utils.missing(abstractColDef)) {
            return;
        }
        this.addColumnClassesFromCollDef(abstractColDef.toolPanelClass, abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup);
    };
    CssClassApplier.addColumnClassesFromCollDef = function (classesOrFunc, abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup) {
        if (utils_1.Utils.missing(classesOrFunc)) {
            return;
        }
        var classToUse;
        if (typeof classesOrFunc === 'function') {
            var params = {
                // bad naming, as colDef here can be a group or a column,
                // however most people won't appreciate the difference,
                // so keeping it as colDef to avoid confusion.
                colDef: abstractColDef,
                column: column,
                columnGroup: columnGroup,
                context: gridOptionsWrapper.getContext(),
                api: gridOptionsWrapper.getApi()
            };
            var headerClassFunc = classesOrFunc;
            classToUse = headerClassFunc(params);
        }
        else {
            classToUse = classesOrFunc;
        }
        if (typeof classToUse === 'string') {
            utils_1.Utils.addCssClass(eHeaderCell, classToUse);
        }
        else if (Array.isArray(classToUse)) {
            classToUse.forEach(function (cssClassItem) {
                utils_1.Utils.addCssClass(eHeaderCell, cssClassItem);
            });
        }
    };
    return CssClassApplier;
}());
exports.CssClassApplier = CssClassApplier;


/***/ }),

/***/ "NTM1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var context_1 = __webpack_require__("RQ1/");
var eventService_1 = __webpack_require__("k5uU");
var selectionController_1 = __webpack_require__("D4cr");
var events_1 = __webpack_require__("3ok8");
var sortController_1 = __webpack_require__("fxGZ");
var filterManager_1 = __webpack_require__("Up6z");
var constants_1 = __webpack_require__("ZZFX");
var infiniteCache_1 = __webpack_require__("IxVs");
var beanStub_1 = __webpack_require__("xffp");
var rowNodeCache_1 = __webpack_require__("sc2Y");
var rowNodeBlockLoader_1 = __webpack_require__("NFvU");
var gridApi_1 = __webpack_require__("BAow");
var columnApi_1 = __webpack_require__("E/Wy");
var InfiniteRowModel = (function (_super) {
    __extends(InfiniteRowModel, _super);
    function InfiniteRowModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InfiniteRowModel.prototype.getRowBounds = function (index) {
        return {
            rowHeight: this.rowHeight,
            rowTop: this.rowHeight * index
        };
    };
    InfiniteRowModel.prototype.init = function () {
        var _this = this;
        if (!this.gridOptionsWrapper.isRowModelInfinite()) {
            return;
        }
        this.rowHeight = this.gridOptionsWrapper.getRowHeightAsNumber();
        this.addEventListeners();
        this.setDatasource(this.gridOptionsWrapper.getDatasource());
        this.addDestroyFunc(function () { return _this.destroyCache(); });
    };
    InfiniteRowModel.prototype.isLastRowFound = function () {
        return this.infiniteCache ? this.infiniteCache.isMaxRowFound() : false;
    };
    InfiniteRowModel.prototype.addEventListeners = function () {
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.onColumnEverything.bind(this));
    };
    InfiniteRowModel.prototype.onFilterChanged = function () {
        if (this.gridOptionsWrapper.isEnableServerSideFilter()) {
            this.reset();
        }
    };
    InfiniteRowModel.prototype.onSortChanged = function () {
        if (this.gridOptionsWrapper.isEnableServerSideSorting()) {
            this.reset();
        }
    };
    InfiniteRowModel.prototype.onColumnEverything = function () {
        // if the columns get reset, then this means the sort order could be impacted
        if (this.gridOptionsWrapper.isEnableServerSideSorting()) {
            this.reset();
        }
    };
    InfiniteRowModel.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    InfiniteRowModel.prototype.getType = function () {
        return constants_1.Constants.ROW_MODEL_TYPE_INFINITE;
    };
    InfiniteRowModel.prototype.setDatasource = function (datasource) {
        this.datasource = datasource;
        // only reset if we have a valid datasource to working with
        if (datasource) {
            this.checkForDeprecated();
            this.reset();
        }
    };
    InfiniteRowModel.prototype.checkForDeprecated = function () {
        var ds = this.datasource;
        // the number of concurrent loads we are allowed to the server
        if (utils_1.Utils.exists(ds.maxConcurrentRequests)) {
            console.error('ag-Grid: since version 5.1.x, maxConcurrentRequests is replaced with grid property maxConcurrentDatasourceRequests');
        }
        if (utils_1.Utils.exists(ds.maxPagesInCache)) {
            console.error('ag-Grid: since version 5.1.x, maxPagesInCache is replaced with grid property maxPagesInPaginationCache');
        }
        if (utils_1.Utils.exists(ds.overflowSize)) {
            console.error('ag-Grid: since version 5.1.x, overflowSize is replaced with grid property paginationOverflowSize');
        }
        if (utils_1.Utils.exists(ds.blockSize)) {
            console.error('ag-Grid: since version 5.1.x, pageSize/blockSize is replaced with grid property infinitePageSize');
        }
    };
    InfiniteRowModel.prototype.isEmpty = function () {
        return utils_1.Utils.missing(this.infiniteCache);
    };
    InfiniteRowModel.prototype.isRowsToRender = function () {
        return utils_1.Utils.exists(this.infiniteCache);
    };
    InfiniteRowModel.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
        return this.infiniteCache.getRowNodesInRange(firstInRange, lastInRange);
    };
    InfiniteRowModel.prototype.reset = function () {
        // important to return here, as the user could be setting filter or sort before
        // data-source is set
        if (utils_1.Utils.missing(this.datasource)) {
            return;
        }
        // if user is providing id's, then this means we can keep the selection between datsource hits,
        // as the rows will keep their unique id's even if, for example, server side sorting or filtering
        // is done.
        var userGeneratingIds = utils_1.Utils.exists(this.gridOptionsWrapper.getRowNodeIdFunc());
        if (!userGeneratingIds) {
            this.selectionController.reset();
        }
        this.resetCache();
        var event = this.createModelUpdatedEvent();
        this.eventService.dispatchEvent(event);
    };
    InfiniteRowModel.prototype.createModelUpdatedEvent = function () {
        return {
            type: events_1.Events.EVENT_MODEL_UPDATED,
            api: this.gridApi,
            columnApi: this.columnApi,
            // not sure if these should all be false - noticed if after implementing,
            // maybe they should be true?
            newPage: false,
            newData: false,
            keepRenderedRows: false,
            animate: false
        };
    };
    InfiniteRowModel.prototype.resetCache = function () {
        // if not first time creating a cache, need to destroy the old one
        this.destroyCache();
        var maxConcurrentRequests = this.gridOptionsWrapper.getMaxConcurrentDatasourceRequests();
        // there is a bi-directional dependency between the loader and the cache,
        // so we create loader here, and then pass dependencies in setDependencies() method later
        this.rowNodeBlockLoader = new rowNodeBlockLoader_1.RowNodeBlockLoader(maxConcurrentRequests);
        this.context.wireBean(this.rowNodeBlockLoader);
        var cacheSettings = {
            // the user provided datasource
            datasource: this.datasource,
            // sort and filter model
            filterModel: this.filterManager.getFilterModel(),
            sortModel: this.sortController.getSortModel(),
            rowNodeBlockLoader: this.rowNodeBlockLoader,
            // properties - this way we take a snapshot of them, so if user changes any, they will be
            // used next time we create a new cache, which is generally after a filter or sort change,
            // or a new datasource is set
            maxConcurrentRequests: maxConcurrentRequests,
            overflowSize: this.gridOptionsWrapper.getCacheOverflowSize(),
            initialRowCount: this.gridOptionsWrapper.getInfiniteInitialRowCount(),
            maxBlocksInCache: this.gridOptionsWrapper.getMaxBlocksInCache(),
            blockSize: this.gridOptionsWrapper.getCacheBlockSize(),
            rowHeight: this.gridOptionsWrapper.getRowHeightAsNumber(),
            // the cache could create this, however it is also used by the pages, so handy to create it
            // here as the settings are also passed to the pages
            lastAccessedSequence: new utils_1.NumberSequence()
        };
        // set defaults
        if (!(cacheSettings.maxConcurrentRequests >= 1)) {
            cacheSettings.maxConcurrentRequests = 2;
        }
        // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
        // server for one page at a time. so the default if not specified is 100.
        if (!(cacheSettings.blockSize >= 1)) {
            cacheSettings.blockSize = 100;
        }
        // if user doesn't give initial rows to display, we assume zero
        if (!(cacheSettings.initialRowCount >= 1)) {
            cacheSettings.initialRowCount = 0;
        }
        // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
        // the current page and request first row of next page
        if (!(cacheSettings.overflowSize >= 1)) {
            cacheSettings.overflowSize = 1;
        }
        this.infiniteCache = new infiniteCache_1.InfiniteCache(cacheSettings);
        this.context.wireBean(this.infiniteCache);
        this.infiniteCache.addEventListener(rowNodeCache_1.RowNodeCache.EVENT_CACHE_UPDATED, this.onCacheUpdated.bind(this));
    };
    InfiniteRowModel.prototype.destroyCache = function () {
        if (this.infiniteCache) {
            this.infiniteCache.destroy();
            this.infiniteCache = null;
        }
        if (this.rowNodeBlockLoader) {
            this.rowNodeBlockLoader.destroy();
            this.rowNodeBlockLoader = null;
        }
    };
    InfiniteRowModel.prototype.onCacheUpdated = function () {
        var event = this.createModelUpdatedEvent();
        this.eventService.dispatchEvent(event);
    };
    InfiniteRowModel.prototype.getRow = function (rowIndex) {
        return this.infiniteCache ? this.infiniteCache.getRow(rowIndex) : null;
    };
    InfiniteRowModel.prototype.forEachNode = function (callback) {
        if (this.infiniteCache) {
            this.infiniteCache.forEachNodeDeep(callback, new utils_1.NumberSequence());
        }
    };
    InfiniteRowModel.prototype.getCurrentPageHeight = function () {
        return this.getRowCount() * this.rowHeight;
    };
    InfiniteRowModel.prototype.getRowIndexAtPixel = function (pixel) {
        if (this.rowHeight !== 0) {
            var rowIndexForPixel = Math.floor(pixel / this.rowHeight);
            if (rowIndexForPixel > this.getPageLastRow()) {
                return this.getPageLastRow();
            }
            else {
                return rowIndexForPixel;
            }
        }
        else {
            return 0;
        }
    };
    InfiniteRowModel.prototype.getPageFirstRow = function () {
        return 0;
    };
    InfiniteRowModel.prototype.getPageLastRow = function () {
        return this.infiniteCache ? this.infiniteCache.getVirtualRowCount() - 1 : 0;
    };
    InfiniteRowModel.prototype.getRowCount = function () {
        return this.infiniteCache ? this.infiniteCache.getVirtualRowCount() : 0;
    };
    InfiniteRowModel.prototype.updateRowData = function (transaction) {
        if (utils_1.Utils.exists(transaction.remove) || utils_1.Utils.exists(transaction.update)) {
            console.warn('ag-Grid: updateRowData for InfiniteRowModel does not support remove or update, only add');
            return;
        }
        if (utils_1.Utils.missing(transaction.addIndex)) {
            console.warn('ag-Grid: updateRowData for InfiniteRowModel requires add and addIndex to be set');
            return;
        }
        if (this.infiniteCache) {
            this.infiniteCache.insertItemsAtIndex(transaction.addIndex, transaction.add);
        }
    };
    InfiniteRowModel.prototype.isRowPresent = function (rowNode) {
        return false;
    };
    InfiniteRowModel.prototype.refreshCache = function () {
        if (this.infiniteCache) {
            this.infiniteCache.refreshCache();
        }
    };
    InfiniteRowModel.prototype.purgeCache = function () {
        if (this.infiniteCache) {
            this.infiniteCache.purgeCache();
        }
    };
    InfiniteRowModel.prototype.getVirtualRowCount = function () {
        if (this.infiniteCache) {
            return this.infiniteCache.getVirtualRowCount();
        }
        else {
            return null;
        }
    };
    InfiniteRowModel.prototype.isMaxRowFound = function () {
        if (this.infiniteCache) {
            return this.infiniteCache.isMaxRowFound();
        }
    };
    InfiniteRowModel.prototype.setVirtualRowCount = function (rowCount, maxRowFound) {
        if (this.infiniteCache) {
            this.infiniteCache.setVirtualRowCount(rowCount, maxRowFound);
        }
    };
    InfiniteRowModel.prototype.getBlockState = function () {
        if (this.rowNodeBlockLoader) {
            return this.rowNodeBlockLoader.getBlockState();
        }
        else {
            return null;
        }
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], InfiniteRowModel.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('filterManager'),
        __metadata("design:type", filterManager_1.FilterManager)
    ], InfiniteRowModel.prototype, "filterManager", void 0);
    __decorate([
        context_1.Autowired('sortController'),
        __metadata("design:type", sortController_1.SortController)
    ], InfiniteRowModel.prototype, "sortController", void 0);
    __decorate([
        context_1.Autowired('selectionController'),
        __metadata("design:type", selectionController_1.SelectionController)
    ], InfiniteRowModel.prototype, "selectionController", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], InfiniteRowModel.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], InfiniteRowModel.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], InfiniteRowModel.prototype, "gridApi", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], InfiniteRowModel.prototype, "columnApi", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], InfiniteRowModel.prototype, "init", null);
    __decorate([
        context_1.PreDestroy,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], InfiniteRowModel.prototype, "destroy", null);
    InfiniteRowModel = __decorate([
        context_1.Bean('rowModel')
    ], InfiniteRowModel);
    return InfiniteRowModel;
}(beanStub_1.BeanStub));
exports.InfiniteRowModel = InfiniteRowModel;


/***/ }),

/***/ "NYxO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* unused harmony export install */
/* unused harmony export mapState */
/* unused harmony export mapMutations */
/* unused harmony export mapGetters */
/* unused harmony export mapActions */
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v3.0.1
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (false) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '3.0.1',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["a"] = (index_esm);


/***/ }),

/***/ "Nrvl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var textCellEditor_1 = __webpack_require__("U6ln");
var PopupTextCellEditor = (function (_super) {
    __extends(PopupTextCellEditor, _super);
    function PopupTextCellEditor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopupTextCellEditor.prototype.isPopup = function () {
        return true;
    };
    return PopupTextCellEditor;
}(textCellEditor_1.TextCellEditor));
exports.PopupTextCellEditor = PopupTextCellEditor;


/***/ }),

/***/ "NtVV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var context_1 = __webpack_require__("RQ1/");
var dragAndDropService_1 = __webpack_require__("I/uN");
var columnController_1 = __webpack_require__("77lH");
var gridPanel_1 = __webpack_require__("inOk");
var eventService_1 = __webpack_require__("k5uU");
var events_1 = __webpack_require__("3ok8");
var headerRowComp_1 = __webpack_require__("vuuZ");
var bodyDropTarget_1 = __webpack_require__("0B0E");
var column_1 = __webpack_require__("hDyE");
var scrollVisibleService_1 = __webpack_require__("5AnZ");
var HeaderContainer = (function () {
    function HeaderContainer(eContainer, eViewport, eRoot, pinned) {
        this.headerRowComps = [];
        this.eContainer = eContainer;
        this.eRoot = eRoot;
        this.pinned = pinned;
        this.eViewport = eViewport;
    }
    HeaderContainer.prototype.forEachHeaderElement = function (callback) {
        this.headerRowComps.forEach(function (headerRowComp) { return headerRowComp.forEachHeaderElement(callback); });
    };
    HeaderContainer.prototype.init = function () {
        this.setupDragAndDrop();
        // if value changes, then if not pivoting, we at least need to change the label eg from sum() to avg(),
        // if pivoting, then the columns have changed
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.onColumnValueChanged.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onColumnRowGroupChanged.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
    };
    // if row group changes, that means we may need to add aggFunc's to the column headers,
    // if the grid goes from no aggregation (ie no grouping) to grouping
    HeaderContainer.prototype.onColumnRowGroupChanged = function () {
        this.onGridColumnsChanged();
    };
    // if the agg func of a column changes, then we may need to update the agg func in columns header
    HeaderContainer.prototype.onColumnValueChanged = function () {
        this.onGridColumnsChanged();
    };
    HeaderContainer.prototype.onColumnResized = function () {
        this.setWidthIfPinnedContainer();
    };
    HeaderContainer.prototype.onDisplayedColumnsChanged = function () {
        this.setWidthIfPinnedContainer();
    };
    HeaderContainer.prototype.onScrollVisibilityChanged = function () {
        this.setWidthIfPinnedContainer();
    };
    HeaderContainer.prototype.setWidthIfPinnedContainer = function () {
        if (this.pinned === column_1.Column.PINNED_LEFT) {
            var pinnedLeftWidthWithScroll = this.scrollVisibleService.getPinnedLeftWithScrollWidth();
            this.eContainer.style.width = pinnedLeftWidthWithScroll + 'px';
        }
        else if (this.pinned === column_1.Column.PINNED_RIGHT) {
            var pinnedRightWidthWithScroll = this.scrollVisibleService.getPinnedRightWithScrollWidth();
            this.eContainer.style.width = pinnedRightWidthWithScroll + 'px';
        }
    };
    HeaderContainer.prototype.destroy = function () {
        this.removeHeaderRowComps();
    };
    // grid cols have changed - this also means the number of rows in the header can have
    // changed. so we remove all the old rows and insert new ones for a complete refresh
    HeaderContainer.prototype.onGridColumnsChanged = function () {
        this.removeHeaderRowComps();
        this.createHeaderRowComps();
    };
    // we expose this for gridOptions.api.refreshHeader() to call
    HeaderContainer.prototype.refresh = function () {
        this.onGridColumnsChanged();
    };
    HeaderContainer.prototype.setupDragAndDrop = function () {
        var dropContainer = this.eViewport ? this.eViewport : this.eContainer;
        var bodyDropTarget = new bodyDropTarget_1.BodyDropTarget(this.pinned, dropContainer);
        this.context.wireBean(bodyDropTarget);
    };
    HeaderContainer.prototype.removeHeaderRowComps = function () {
        this.headerRowComps.forEach(function (headerRowComp) {
            headerRowComp.destroy();
        });
        this.headerRowComps.length = 0;
        utils_1.Utils.removeAllChildren(this.eContainer);
    };
    HeaderContainer.prototype.createHeaderRowComps = function () {
        // if we are displaying header groups, then we have many rows here.
        // go through each row of the header, one by one.
        var rowCount = this.columnController.getHeaderRowCount();
        for (var dept = 0; dept < rowCount; dept++) {
            var groupRow = dept !== (rowCount - 1);
            var type = groupRow ? headerRowComp_1.HeaderRowType.COLUMN_GROUP : headerRowComp_1.HeaderRowType.COLUMN;
            var headerRowComp = new headerRowComp_1.HeaderRowComp(dept, type, this.pinned, this.eRoot, this.dropTarget);
            this.context.wireBean(headerRowComp);
            this.headerRowComps.push(headerRowComp);
            this.eContainer.appendChild(headerRowComp.getGui());
        }
        var includeFloatingFilterRow = this.gridOptionsWrapper.isFloatingFilter() && !this.columnController.isPivotMode();
        if (includeFloatingFilterRow) {
            var headerRowComp = new headerRowComp_1.HeaderRowComp(rowCount, headerRowComp_1.HeaderRowType.FLOATING_FILTER, this.pinned, this.eRoot, this.dropTarget);
            this.context.wireBean(headerRowComp);
            this.headerRowComps.push(headerRowComp);
            this.eContainer.appendChild(headerRowComp.getGui());
        }
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], HeaderContainer.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], HeaderContainer.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('$scope'),
        __metadata("design:type", Object)
    ], HeaderContainer.prototype, "$scope", void 0);
    __decorate([
        context_1.Autowired('dragAndDropService'),
        __metadata("design:type", dragAndDropService_1.DragAndDropService)
    ], HeaderContainer.prototype, "dragAndDropService", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], HeaderContainer.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('gridPanel'),
        __metadata("design:type", gridPanel_1.GridPanel)
    ], HeaderContainer.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], HeaderContainer.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('scrollVisibleService'),
        __metadata("design:type", scrollVisibleService_1.ScrollVisibleService)
    ], HeaderContainer.prototype, "scrollVisibleService", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], HeaderContainer.prototype, "init", null);
    return HeaderContainer;
}());
exports.HeaderContainer = HeaderContainer;


/***/ }),

/***/ "O4g8":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "O5Ud":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(905);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 884:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FTkt");

/***/ }),

/***/ 898:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("UZBu");

/***/ }),

/***/ 905:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(884), __webpack_require__(898) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function () {

	    (function ($, undefined) {
	        // Imports ================================================================
	        var kendo = window.kendo,
	            dataviz = kendo.dataviz,
	            diagram = dataviz.diagram,
	            Class = kendo.Class,
	            Group = diagram.Group,
	            Rect = diagram.Rect,
	            Rectangle = diagram.Rectangle,
	            Utils = diagram.Utils,
	            isUndefined = Utils.isUndefined,
	            Point = diagram.Point,
	            Circle = diagram.Circle,
	            Ticker = diagram.Ticker,
	            deepExtend = kendo.deepExtend,
	            Movable = kendo.ui.Movable,
	            browser = kendo.support.browser,
	            util = kendo.drawing.util,
	            defined = util.defined,
	            inArray = $.inArray,
	            proxy = $.proxy;

	        // Constants ==============================================================
	        var Cursors = {
	                arrow: "default",
	                grip: "pointer",
	                cross: "pointer",
	                add: "pointer",
	                move: "move",
	                select: "pointer",
	                south: "s-resize",
	                east: "e-resize",
	                west: "w-resize",
	                north: "n-resize",
	                rowresize: "row-resize",
	                colresize: "col-resize"
	            },
	            HIT_TEST_DISTANCE = 10,
	            AUTO = "Auto",
	            TOP = "Top",
	            RIGHT = "Right",
	            LEFT = "Left",
	            BOTTOM = "Bottom",
	            DEFAULT_SNAP_SIZE = 10,
	            DEFAULT_SNAP_ANGLE = 10,
	            DRAG_START = "dragStart",
	            DRAG = "drag",
	            DRAG_END = "dragEnd",
	            ITEMROTATE = "itemRotate",
	            ITEMBOUNDSCHANGE = "itemBoundsChange",
	            MIN_SNAP_SIZE = 5,
	            MIN_SNAP_ANGLE = 5,
	            MOUSE_ENTER = "mouseEnter",
	            MOUSE_LEAVE = "mouseLeave",
	            ZOOM_START = "zoomStart",
	            ZOOM_END = "zoomEnd",
	            SCROLL_MIN = -20000,
	            SCROLL_MAX = 20000,
	            FRICTION = 0.90,
	            FRICTION_MOBILE = 0.93,
	            VELOCITY_MULTIPLIER = 5,
	            TRANSPARENT = "transparent",
	            PAN = "pan",
	            ROTATED = "rotated",
	            SOURCE = "source",
	            TARGET = "target",
	            HANDLE_NAMES = {
	                "-1": SOURCE,
	                "1": TARGET
	            };

	        diagram.Cursors = Cursors;

	        var PositionAdapter = kendo.Class.extend({
	            init: function (layoutState) {
	                this.layoutState = layoutState;
	                this.diagram = layoutState.diagram;
	            },
	            initState: function () {
	                this.froms = [];
	                this.tos = [];
	                this.subjects = [];
	                function pusher(id, bounds) {
	                    var shape = this.diagram.getShapeById(id);
	                    if (shape) {
	                        this.subjects.push(shape);
	                        this.froms.push(shape.bounds().topLeft());
	                        this.tos.push(bounds.topLeft());
	                    }
	                }

	                this.layoutState.nodeMap.forEach(pusher, this);
	            },
	            update: function (tick) {
	                if (this.subjects.length <= 0) {
	                    return;
	                }
	                for (var i = 0; i < this.subjects.length; i++) {
	                    //todo: define a Lerp function instead
	                    this.subjects[i].position(
	                        new Point(this.froms[i].x + (this.tos[i].x - this.froms[i].x) * tick, this.froms[i].y + (this.tos[i].y - this.froms[i].y) * tick)
	                    );
	                }
	            }
	        });

	        var LayoutUndoUnit = Class.extend({
	            init: function (initialState, finalState, animate) {
	                if (isUndefined(animate)) {
	                    this.animate = false;
	                }
	                else {
	                    this.animate = animate;
	                }
	                this._initialState = initialState;
	                this._finalState = finalState;
	                this.title = "Diagram layout";
	            },
	            undo: function () {
	                this.setState(this._initialState);
	            },
	            redo: function () {
	                this.setState(this._finalState);
	            },
	            setState: function (state) {
	                var diagram = state.diagram;
	                if (this.animate) {
	                    state.linkMap.forEach(
	                        function (id, points) {
	                            var conn = diagram.getShapeById(id);
	                            conn.visible(false);
	                            if (conn) {
	                                conn.points(points);
	                            }
	                        }
	                    );
	                    var ticker = new Ticker();
	                    ticker.addAdapter(new PositionAdapter(state));
	                    ticker.onComplete(function () {
	                        state.linkMap.forEach(
	                            function (id) {
	                                var conn = diagram.getShapeById(id);
	                                conn.visible(true);
	                            }
	                        );
	                    });
	                    ticker.play();
	                }
	                else {
	                    state.nodeMap.forEach(function (id, bounds) {
	                        var shape = diagram.getShapeById(id);
	                        if (shape) {
	                            shape.position(bounds.topLeft());
	                        }
	                    });
	                    state.linkMap.forEach(
	                        function (id, points) {
	                            var conn = diagram.getShapeById(id);
	                            if (conn) {
	                                conn.points(points);
	                            }
	                        }
	                    );
	                }
	            }
	        });

	        var CompositeUnit = Class.extend({
	            init: function (unit) {
	                this.units = [];
	                this.title = "Composite unit";
	                if (unit !== undefined) {
	                    this.units.push(unit);
	                }
	            },
	            add: function (undoUnit) {
	                this.units.push(undoUnit);
	            },
	            undo: function () {
	                for (var i = 0; i < this.units.length; i++) {
	                    this.units[i].undo();
	                }
	            },
	            redo: function () {
	                for (var i = 0; i < this.units.length; i++) {
	                    this.units[i].redo();
	                }
	            }
	        });

	        var ConnectionEditUnit = Class.extend({
	            init: function (item, redoSource, redoTarget) {
	                this.item = item;
	                this._redoSource = redoSource;
	                this._redoTarget = redoTarget;
	                if (defined(redoSource)) {
	                    this._undoSource = item.source();
	                }

	                if (defined(redoTarget)) {
	                    this._undoTarget = item.target();
	                }
	                this.title = "Connection Editing";
	            },
	            undo: function () {
	                if (this._undoSource !== undefined) {
	                    this.item._updateConnector(this._undoSource, "source");
	                }

	                if (this._undoTarget !== undefined) {
	                    this.item._updateConnector(this._undoTarget, "target");
	                }

	                this.item.updateModel();
	            },
	            redo: function () {
	                if (this._redoSource !== undefined) {
	                    this.item._updateConnector(this._redoSource, "source");
	                }

	                if (this._redoTarget !== undefined) {
	                    this.item._updateConnector(this._redoTarget, "target");
	                }

	                this.item.updateModel();
	            }
	        });

	        var ConnectionEditUndoUnit = Class.extend({
	            init: function (item, undoSource, undoTarget) {
	                this.item = item;
	                this._undoSource = undoSource;
	                this._undoTarget = undoTarget;
	                this._redoSource = item.source();
	                this._redoTarget = item.target();
	                this.title = "Connection Editing";
	            },
	            undo: function () {
	                this.item._updateConnector(this._undoSource, "source");
	                this.item._updateConnector(this._undoTarget, "target");
	                this.item.updateModel();
	            },
	            redo: function () {
	                this.item._updateConnector(this._redoSource, "source");
	                this.item._updateConnector(this._redoTarget, "target");
	                this.item.updateModel();
	            }
	        });

	        var DeleteConnectionUnit = Class.extend({
	            init: function (connection) {
	                this.connection = connection;
	                this.diagram = connection.diagram;
	                this.targetConnector = connection.targetConnector;
	                this.title = "Delete connection";
	            },
	            undo: function () {
	                this.diagram._addConnection(this.connection, false);
	            },
	            redo: function () {
	                this.diagram.remove(this.connection, false);
	            }
	        });

	        var DeleteShapeUnit = Class.extend({
	            init: function (shape) {
	                this.shape = shape;
	                this.diagram = shape.diagram;
	                this.title = "Deletion";
	            },
	            undo: function () {
	                this.diagram._addShape(this.shape, false);
	                this.shape.select(false);
	            },
	            redo: function () {
	                this.shape.select(false);
	                this.diagram.remove(this.shape, false);
	            }
	        });
	        /**
	         * Holds the undoredo state when performing a rotation, translation or scaling. The adorner is optional.
	         * @type {*}
	         */
	        var TransformUnit = Class.extend({
	            init: function (shapes, undoStates, adorner) {
	                this.shapes = shapes;
	                this.undoStates = undoStates;
	                this.title = "Transformation";
	                this.redoStates = [];
	                this.adorner = adorner;
	                for (var i = 0; i < this.shapes.length; i++) {
	                    var shape = this.shapes[i];
	                    this.redoStates.push(shape.bounds());
	                }
	            },
	            undo: function () {
	                for (var i = 0; i < this.shapes.length; i++) {
	                    var shape = this.shapes[i];
	                    shape.bounds(this.undoStates[i]);
	                    if (shape.hasOwnProperty("layout")) {
	                        shape.layout(shape, this.redoStates[i], this.undoStates[i]);
	                    }
	                    shape.updateModel();
	                }
	                if (this.adorner) {
	                    this.adorner.refreshBounds();
	                    this.adorner.refresh();
	                }
	            },
	            redo: function () {
	                for (var i = 0; i < this.shapes.length; i++) {
	                    var shape = this.shapes[i];
	                    shape.bounds(this.redoStates[i]);
	                    // the 'layout' property, if implemented, lets the shape itself work out what to do with the new bounds
	                    if (shape.hasOwnProperty("layout")) {
	                        shape.layout(shape, this.undoStates[i], this.redoStates[i]);
	                    }
	                    shape.updateModel();
	                }

	                if (this.adorner) {
	                    this.adorner.refreshBounds();
	                    this.adorner.refresh();
	                }
	            }
	        });

	        var AddConnectionUnit = Class.extend({
	            init: function (connection, diagram) {
	                this.connection = connection;
	                this.diagram = diagram;
	                this.title = "New connection";
	            },

	            undo: function () {
	                this.diagram.remove(this.connection, false);
	            },

	            redo: function () {
	                this.diagram._addConnection(this.connection, false);
	            }
	        });

	        var AddShapeUnit = Class.extend({
	            init: function (shape, diagram) {
	                this.shape = shape;
	                this.diagram = diagram;
	                this.title = "New shape";
	            },

	            undo: function () {
	                this.diagram.deselect();
	                this.diagram.remove(this.shape, false);
	            },

	            redo: function () {
	                this.diagram._addShape(this.shape, false);
	            }
	        });

	        var PanUndoUnit = Class.extend({
	            init: function (initialPosition, finalPosition, diagram) {
	                this.initial = initialPosition;
	                this.finalPos = finalPosition;
	                this.diagram = diagram;
	                this.title = "Pan Unit";
	            },
	            undo: function () {
	                this.diagram.pan(this.initial);
	            },
	            redo: function () {
	                this.diagram.pan(this.finalPos);
	            }
	        });

	        var RotateUnit = Class.extend({
	            init: function (adorner, shapes, undoRotates) {
	                this.shapes = shapes;
	                this.undoRotates = undoRotates;
	                this.title = "Rotation";
	                this.redoRotates = [];
	                this.redoAngle = adorner._angle;
	                this.adorner = adorner;
	                this.center = adorner._innerBounds.center();
	                for (var i = 0; i < this.shapes.length; i++) {
	                    var shape = this.shapes[i];
	                    this.redoRotates.push(shape.rotate().angle);
	                }
	            },
	            undo: function () {
	                var i, shape;
	                for (i = 0; i < this.shapes.length; i++) {
	                    shape = this.shapes[i];
	                    shape.rotate(this.undoRotates[i], this.center, false);
	                    if (shape.hasOwnProperty("layout")) {
	                        shape.layout(shape);
	                    }
	                    shape.updateModel();
	                }
	                if (this.adorner) {
	                    this.adorner._initialize();
	                    this.adorner.refresh();
	                }
	            },
	            redo: function () {
	                var i, shape;
	                for (i = 0; i < this.shapes.length; i++) {
	                    shape = this.shapes[i];
	                    shape.rotate(this.redoRotates[i], this.center, false);
	                    if (shape.hasOwnProperty("layout")) {
	                        shape.layout(shape);
	                    }
	                    shape.updateModel();
	                }
	                if (this.adorner) {
	                    this.adorner._initialize();
	                    this.adorner.refresh();
	                }
	            }
	        });

	        var ToFrontUnit = Class.extend({
	            init: function (diagram, items, initialIndices) {
	                this.diagram = diagram;
	                this.indices = initialIndices;
	                this.items = items;
	                this.title = "Rotate Unit";
	            },
	            undo: function () {
	                this.diagram._toIndex(this.items, this.indices);
	            },
	            redo: function () {
	                this.diagram.toFront(this.items, false);
	            }
	        });

	        var ToBackUnit = Class.extend({
	            init: function (diagram, items, initialIndices) {
	                this.diagram = diagram;
	                this.indices = initialIndices;
	                this.items = items;
	                this.title = "Rotate Unit";
	            },
	            undo: function () {
	                this.diagram._toIndex(this.items, this.indices);
	            },
	            redo: function () {
	                this.diagram.toBack(this.items, false);
	            }
	        });

	        /**
	         * Undo-redo service.
	         */
	        var UndoRedoService = kendo.Observable.extend({
	            init: function (options) {
	                kendo.Observable.fn.init.call(this, options);
	                this.bind(this.events, options);
	                this.stack = [];
	                this.index = 0;
	                this.capacity = 100;
	            },

	            events: ["undone", "redone"],

	            /**
	             * Starts the collection of units. Add those with
	             * the addCompositeItem method and call commit. Or cancel to forget about it.
	             */
	            begin: function () {
	                this.composite = new CompositeUnit();
	            },

	            /**
	             * Cancels the collection process of unit started with 'begin'.
	             */
	            cancel: function () {
	                this.composite = undefined;
	            },

	            /**
	             * Commits a batch of units.
	             */
	            commit: function (execute) {
	                if (this.composite.units.length > 0) {
	                    this._restart(this.composite, execute);
	                }
	                this.composite = undefined;
	            },

	            /**
	             * Adds a unit as part of the begin-commit batch.
	             * @param undoUnit
	             */
	            addCompositeItem: function (undoUnit) {
	                if (this.composite) {
	                    this.composite.add(undoUnit);
	                } else {
	                    this.add(undoUnit);
	                }
	            },

	            /**
	             * Standard addition of a unit. See also the batch version; begin-addCompositeUnit-commit methods.
	             * @param undoUnit The unit to be added.
	             * @param execute If false, the unit will be added but not executed.
	             */
	            add: function (undoUnit, execute) {
	                this._restart(undoUnit, execute);
	            },

	            /**
	             * Returns the number of undoable unit in the stack.
	             * @returns {Number}
	             */

	            pop: function() {
	                if (this.index > 0) {
	                    this.stack.pop();
	                    this.index--;
	                }
	            },

	            count: function () {
	                return this.stack.length;
	            },

	            /**
	             * Rollback of the unit on top of the stack.
	             */
	            undo: function () {
	                if (this.index > 0) {
	                    this.index--;
	                    this.stack[this.index].undo();
	                    this.trigger("undone");
	                }
	            },

	            /**
	             * Redo of the last undone action.
	             */
	            redo: function () {
	                if (this.stack.length > 0 && this.index < this.stack.length) {
	                    this.stack[this.index].redo();
	                    this.index++;
	                    this.trigger("redone");
	                }
	            },

	            _restart: function (composite, execute) {
	                // throw away anything beyond this point if this is a new branch
	                this.stack.splice(this.index, this.stack.length - this.index);
	                this.stack.push(composite);
	                if (execute !== false) {
	                    this.redo();
	                } else {
	                    this.index++;
	                }
	                // check the capacity
	                if (this.stack.length > this.capacity) {
	                    this.stack.splice(0, this.stack.length - this.capacity);
	                    this.index = this.capacity; //points to the end of the stack
	                }
	            },

	            /**
	             * Clears the stack.
	             */
	            clear: function () {
	                this.stack = [];
	                this.index = 0;
	            }
	        });

	// Tools =========================================

	        var EmptyTool = Class.extend({
	            init: function (toolService) {
	                this.toolService = toolService;
	            },
	            start: function () {
	            },
	            move: function () {
	            },
	            end: function () {
	            },
	            tryActivate: function () {
	                return false;
	            },
	            getCursor: function () {
	                return Cursors.arrow;
	            }
	        });

	        var ScrollerTool = EmptyTool.extend({
	            init: function (toolService) {
	                var tool = this;
	                var friction = kendo.support.mobileOS ? FRICTION_MOBILE : FRICTION;
	                EmptyTool.fn.init.call(tool, toolService);

	                var diagram = tool.toolService.diagram,
	                    canvas = diagram.canvas;

	                var scroller = diagram.scroller = tool.scroller = $(diagram.scrollable).kendoMobileScroller({
	                    friction: friction,
	                    velocityMultiplier: VELOCITY_MULTIPLIER,
	                    mousewheelScrolling: false,
	                    zoom: false,
	                    scroll: proxy(tool._move, tool)
	                }).data("kendoMobileScroller");

	                if (canvas.translate) {
	                    tool.movableCanvas = new Movable(canvas.element);
	                }

	                var virtualScroll = function (dimension, min, max) {
	                    dimension.makeVirtual();
	                    dimension.virtualSize(min || SCROLL_MIN, max || SCROLL_MAX);
	                };

	                virtualScroll(scroller.dimensions.x);
	                virtualScroll(scroller.dimensions.y);
	                scroller.disable();
	            },

	            tryActivate: function (p, meta) {
	                var toolService = this.toolService;
	                var options = toolService.diagram.options.pannable;
	                var enabled = meta.ctrlKey;

	                if (defined(options.key)) {
	                    if (!options.key || options.key == "none") {
	                        enabled = noMeta(meta) && !defined(toolService.hoveredItem);
	                    } else {
	                        enabled = meta[options.key + "Key"];
	                    }
	                }

	                return  options !== false && enabled && !defined(toolService.hoveredAdorner) && !defined(toolService._hoveredConnector);
	            },

	            start: function () {
	                this.scroller.enable();
	            },
	            move: function () {
	            },//the tool itself should not handle the scrolling. Let kendo scroller take care of this part. Check _move
	            _move: function (args) {
	                var tool = this,
	                    diagram = tool.toolService.diagram,
	                    canvas = diagram.canvas,
	                    scrollPos = new Point(args.scrollLeft, args.scrollTop);

	                if (canvas.translate) {
	                    diagram._storePan(scrollPos.times(-1));
	                    tool.movableCanvas.moveTo(scrollPos);
	                    canvas.translate(scrollPos.x, scrollPos.y);
	                } else {
	                    scrollPos = scrollPos.plus(diagram._pan.times(-1));
	                }

	                diagram.trigger(PAN, {pan: scrollPos});
	            },
	            end: function () {
	                this.scroller.disable();
	            },
	            getCursor: function () {
	                return Cursors.move;
	            }
	        });

	        /**
	         * The tool handling the transformations via the adorner.
	         * @type {*}
	         */
	        var PointerTool = Class.extend({
	            init: function (toolService) {
	                this.toolService = toolService;
	            },
	            tryActivate: function () {
	                return true; // the pointer tool is last and handles all others requests.
	            },
	            start: function (p, meta) {
	                var toolService = this.toolService,
	                    diagram = toolService.diagram,
	                    hoveredItem = toolService.hoveredItem;

	                if (hoveredItem) {
	                    toolService.selectSingle(hoveredItem, meta);
	                    if (hoveredItem.adorner) { //connection
	                        this.adorner = hoveredItem.adorner;
	                        this.handle = this.adorner._hitTest(p);
	                    }
	                }

	                if (!this.handle) {
	                    this.handle = diagram._resizingAdorner._hitTest(p);
	                    if (this.handle) {
	                        this.adorner = diagram._resizingAdorner;
	                    }
	                }

	                if (this.adorner) {
	                    if (!this.adorner.isDragHandle(this.handle) || !diagram.trigger(DRAG_START, { shapes: this.adorner.shapes, connections: [] })) {
	                        this.adorner.start(p);
	                    } else {
	                        toolService.startPoint = p;
	                        toolService.end(p);
	                    }
	                }
	            },

	            move: function (p) {
	                if (this.adorner) {
	                    this.adorner.move(this.handle, p);
	                    if (this.adorner.isDragHandle(this.handle)) {
	                        this.toolService.diagram.trigger(DRAG, { shapes: this.adorner.shapes, connections: [] });
	                    }
	                }
	            },

	            end: function () {
	                var diagram = this.toolService.diagram,
	                    adorner = this.adorner,
	                    unit;

	                if (adorner) {
	                    if (!adorner.isDragHandle(this.handle) || !diagram.trigger(DRAG_END, { shapes: adorner.shapes, connections: [] })) {
	                        unit = adorner.stop();
	                        if (unit) {
	                            diagram.undoRedoService.add(unit, false);
	                        }
	                    } else {
	                        adorner.cancel();
	                    }
	                }

	                this.adorner = undefined;
	                this.handle = undefined;
	            },
	            getCursor: function (p) {
	                return this.toolService.hoveredItem ? this.toolService.hoveredItem._getCursor(p) : Cursors.arrow;
	            }
	        });

	        var SelectionTool = Class.extend({
	            init: function (toolService) {
	                this.toolService = toolService;
	            },
	            tryActivate: function (p, meta) {
	                var toolService = this.toolService;
	                var selectable = toolService.diagram.options.selectable;
	                var enabled = selectable && selectable.multiple !== false;

	                if (enabled) {
	                    if (selectable.key && selectable.key != "none") {
	                        enabled = meta[selectable.key + "Key"];
	                    } else {
	                        enabled = noMeta(meta);
	                    }
	                }

	                return enabled && !defined(toolService.hoveredItem) && !defined(toolService.hoveredAdorner);
	            },
	            start: function (p) {
	                var diagram = this.toolService.diagram;
	                diagram.deselect();
	                diagram.selector.start(p);
	            },
	            move: function (p) {
	                var diagram = this.toolService.diagram;
	                diagram.selector.move(p);
	            },
	            end: function (p, meta) {
	                var diagram = this.toolService.diagram, hoveredItem = this.toolService.hoveredItem;
	                var rect = diagram.selector.bounds();
	                if ((!hoveredItem || !hoveredItem.isSelected) && !meta.ctrlKey) {
	                    diagram.deselect();
	                }
	                if (!rect.isEmpty()) {
	                    diagram.selectArea(rect);
	                }
	                diagram.selector.end();
	            },
	            getCursor: function () {
	                return Cursors.arrow;
	            }
	        });

	        var ConnectionTool = Class.extend({
	            init: function (toolService) {
	                this.toolService = toolService;
	                this.type = "ConnectionTool";
	            },
	            tryActivate: function() {
	                return this.toolService._hoveredConnector;
	            },
	            start: function (p, meta) {
	                var toolService = this.toolService,
	                    diagram = toolService.diagram,
	                    connector = toolService._hoveredConnector,
	                    connection = diagram._createConnection({}, connector._c, p);

	                if (canDrag(connection) && !diagram.trigger(DRAG_START, { shapes: [], connections: [connection], connectionHandle: TARGET }) && diagram._addConnection(connection)) {
	                    toolService._connectionManipulation(connection, connector._c.shape, true);
	                    toolService._removeHover();
	                    toolService.selectSingle(toolService.activeConnection, meta);
	                    if (meta.type == "touchmove") {
	                        diagram._cachedTouchTarget = connector.visual;
	                    }
	                } else {
	                    connection.source(null);
	                    toolService.end(p);
	                }
	            },

	            move: function (p) {
	                var toolService = this.toolService;
	                var connection = toolService.activeConnection;

	                connection.target(p);
	                toolService.diagram.trigger(DRAG, { shapes: [], connections: [connection], connectionHandle: TARGET  });
	                return true;
	            },

	            end: function (p) {
	                var toolService = this.toolService,
	                    d = toolService.diagram,
	                    connection = toolService.activeConnection,
	                    hoveredItem = toolService.hoveredItem,
	                    connector = toolService._hoveredConnector,
	                    target,
	                    cachedTouchTarget = d._cachedTouchTarget;

	                if (!connection) {
	                    return;
	                }

	                if (connector && connector._c != connection.sourceConnector) {
	                    target = connector._c;
	                } else if (hoveredItem && hoveredItem instanceof diagram.Shape) {
	                    target = hoveredItem.getConnector(AUTO) || hoveredItem.getConnector(p);
	                } else {
	                    target = p;
	                }

	                connection.target(target);

	                if (!d.trigger(DRAG_END, { shapes: [], connections: [connection], connectionHandle: TARGET })) {
	                    connection.updateModel();
	                    d._syncConnectionChanges();
	                } else {
	                    d.remove(connection, false);
	                    d.undoRedoService.pop();
	                }
	                toolService._connectionManipulation();

	                if(cachedTouchTarget) {
	                    d._connectorsAdorner.visual.remove(cachedTouchTarget);
	                    d._cachedTouchTarget = null;
	                }
	            },

	            getCursor: function () {
	                return Cursors.arrow;
	            }
	        });

	        var ConnectionEditTool = Class.extend({
	            init: function (toolService) {
	                this.toolService = toolService;
	                this.type = "ConnectionTool";
	            },

	            tryActivate: function (p, meta) {
	                var toolService = this.toolService,
	                    diagram = toolService.diagram,
	                    selectable =  diagram.options.selectable,
	                    item = toolService.hoveredItem,
	                    isActive = selectable !== false &&
	                               item && item.path && !(item.isSelected && meta.ctrlKey);

	                if (isActive) {
	                    this._c = item;
	                }

	                return isActive;
	            },

	            start: function (p, meta) {
	                var toolService = this.toolService;
	                var connection = this._c;

	                toolService.selectSingle(connection, meta);

	                var adorner = connection.adorner;

	                var handle, name;
	                if (adorner) {
	                    handle = adorner._hitTest(p);
	                    name = HANDLE_NAMES[handle];
	                }

	                if (canDrag(connection) && adorner && !toolService.diagram.trigger(DRAG_START, { shapes: [], connections: [connection], connectionHandle: name })) {
	                    this.handle = handle;
	                    this.handleName = name;
	                    adorner.start(p);
	                } else {
	                    toolService.startPoint = p;
	                    toolService.end(p);
	                }
	            },

	            move: function (p) {
	                var adorner = this._c.adorner;
	                if (canDrag(this._c) && adorner) {
	                    adorner.move(this.handle, p);
	                    this.toolService.diagram.trigger(DRAG, { shapes: [], connections: [this._c], connectionHandle: this.handleName });

	                    return true;
	                }
	            },

	            end: function (p) {
	                var connection = this._c;
	                var adorner = connection.adorner;
	                var toolService = this.toolService;
	                var diagram = toolService.diagram;

	                if (adorner) {
	                    if (canDrag(connection)) {
	                        var unit = adorner.stop(p);
	                        if (!diagram.trigger(DRAG_END, { shapes: [], connections: [connection], connectionHandle: this.handleName })) {
	                            diagram.undoRedoService.add(unit, false);
	                            connection.updateModel();
	                            diagram._syncConnectionChanges();
	                        } else {
	                            unit.undo();
	                        }
	                    }
	                }
	            },

	            getCursor: function () {
	                return Cursors.move;
	            }
	        });

	        function testKey(key, str) {
	            return str.charCodeAt(0) == key || str.toUpperCase().charCodeAt(0) == key;
	        }

	        /**
	         * The service managing the tools.
	         * @type {*}
	         */
	        var ToolService = Class.extend({
	            init: function (diagram) {
	                this.diagram = diagram;
	                this.tools = [
	                    new ScrollerTool(this),
	                    new ConnectionEditTool(this),
	                    new ConnectionTool(this),
	                    new SelectionTool(this),
	                    new PointerTool(this)
	                ]; // the order matters.

	                this.activeTool = undefined;
	            },

	            start: function (p, meta) {
	                meta = deepExtend({}, meta);
	                if (this.activeTool) {
	                    this.activeTool.end(p, meta);
	                }
	                this._updateHoveredItem(p);
	                this._activateTool(p, meta);
	                this.activeTool.start(p, meta);
	                this._updateCursor(p);
	                this.diagram.focus();
	                this.diagram.canvas.surface.suspendTracking();
	                this.startPoint = p;
	                return true;
	            },

	            move: function (p, meta) {
	                meta = deepExtend({}, meta);
	                var updateHovered = true;
	                if (this.activeTool) {
	                    updateHovered = this.activeTool.move(p, meta);
	                }
	                if (updateHovered) {
	                    this._updateHoveredItem(p);
	                }
	                this._updateCursor(p);
	                return true;
	            },

	            end: function (p, meta) {
	                meta = deepExtend({}, meta);
	                if (this.activeTool) {
	                    this.activeTool.end(p, meta);
	                }
	                this.diagram.canvas.surface.resumeTracking();
	                this.activeTool = undefined;
	                this._updateCursor(p);
	                return true;
	            },

	            keyDown: function (key, meta) {
	                var diagram = this.diagram;
	                meta = deepExtend({ ctrlKey: false, metaKey: false, altKey: false }, meta);
	                if ((meta.ctrlKey || meta.metaKey) && !meta.altKey) {// ctrl or option
	                    if (testKey(key, "a")) {// A: select all
	                        diagram.selectAll();
	                        diagram._destroyToolBar();
	                        return true;
	                    } else if (testKey(key, "z")) {// Z: undo
	                        diagram.undo();
	                        diagram._destroyToolBar();
	                        return true;
	                    } else if (testKey(key, "y")) {// y: redo
	                        diagram.redo();
	                        diagram._destroyToolBar();
	                        return true;
	                    } else if (testKey(key, "c")) {
	                        diagram.copy();
	                        diagram._destroyToolBar();
	                    } else if (testKey(key, "x")) {
	                        diagram.cut();
	                        diagram._destroyToolBar();
	                    } else if (testKey(key, "v")) {
	                        diagram.paste();
	                        diagram._destroyToolBar();
	                    } else if (testKey(key, "l")) {
	                        diagram.layout();
	                        diagram._destroyToolBar();
	                    } else if (testKey(key, "d")) {
	                        diagram._destroyToolBar();
	                        diagram.copy();
	                        diagram.paste();
	                    }
	                } else if (key === 46 || key === 8) {// del: deletion
	                    var toRemove = this.diagram._triggerRemove(diagram.select());
	                    if (toRemove.length) {
	                        this.diagram.remove(toRemove, true);
	                        this.diagram._syncChanges();
	                        this.diagram._destroyToolBar();
	                    }

	                    return true;
	                } else if (key === 27) {// ESC: stop any action
	                    this._discardNewConnection();
	                    diagram.deselect();
	                    diagram._destroyToolBar();
	                    return true;
	                }

	            },
	            wheel: function (p, meta) {
	                var diagram = this.diagram,
	                    delta = meta.delta,
	                    z = diagram.zoom(),
	                    options = diagram.options,
	                    zoomRate = options.zoomRate,
	                    zoomOptions = { point: p, meta: meta, zoom: z };

	                if (diagram.trigger(ZOOM_START, zoomOptions)) {
	                    return;
	                }

	                if (delta < 0) {
	                    z += zoomRate;
	                } else {
	                    z -= zoomRate;
	                }

	                z = kendo.dataviz.round(Math.max(options.zoomMin, Math.min(options.zoomMax, z)), 2);
	                zoomOptions.zoom = z;

	                diagram.zoom(z, zoomOptions);
	                diagram.trigger(ZOOM_END, zoomOptions);

	                return true;
	            },
	            setTool: function (tool, index) {
	                tool.toolService = this;
	                this.tools[index] = tool;
	            },

	            selectSingle: function(item, meta) {
	                var diagram = this.diagram;
	                var selectable = diagram.options.selectable;
	                if (selectable && !item.isSelected && item.options.selectable !== false) {
	                    var addToSelection = meta.ctrlKey && selectable.multiple !== false;
	                    diagram.select(item, { addToSelection: addToSelection });
	                }
	            },

	            _discardNewConnection: function () {
	                if (this.newConnection) {
	                    this.diagram.remove(this.newConnection);
	                    this.newConnection = undefined;
	                }
	            },
	            _activateTool: function (p, meta) {
	                for (var i = 0; i < this.tools.length; i++) {
	                    var tool = this.tools[i];
	                    if (tool.tryActivate(p, meta)) {
	                        this.activeTool = tool;
	                        break; // activating the first available tool in the loop.
	                    }
	                }
	            },
	            _updateCursor: function (p) {
	                var element = this.diagram.element;
	                var cursor = this.activeTool ? this.activeTool.getCursor(p) : (this.hoveredAdorner ? this.hoveredAdorner._getCursor(p) : (this.hoveredItem ? this.hoveredItem._getCursor(p) : Cursors.arrow));

	                element.css({cursor: cursor});
	                // workaround for IE 7 issue in which the elements overflow the container after setting cursor
	                if (browser.msie && browser.version == 7) {
	                    element[0].style.cssText = element[0].style.cssText;
	                }
	            },
	            _connectionManipulation: function (connection, disabledShape, isNew) {
	                this.activeConnection = connection;
	                this.disabledShape = disabledShape;
	                if (isNew) {
	                    this.newConnection = this.activeConnection;
	                } else {
	                    this.newConnection = undefined;
	                }
	            },
	            _updateHoveredItem: function (p) {
	                var hit = this._hitTest(p);
	                var diagram = this.diagram;

	                if (hit != this.hoveredItem && (!this.disabledShape || hit != this.disabledShape)) {
	                    if (this.hoveredItem) {
	                        diagram.trigger(MOUSE_LEAVE, { item: this.hoveredItem });
	                        this.hoveredItem._hover(false);
	                    }

	                    if (hit && hit.options.enable) {
	                        diagram.trigger(MOUSE_ENTER, { item: hit });

	                        this.hoveredItem = hit; // Shape, connection or connector
	                        this.hoveredItem._hover(true);
	                    } else {
	                        this.hoveredItem = undefined;
	                    }
	                }
	            },
	            _removeHover: function () {
	                if (this.hoveredItem) {
	                    this.hoveredItem._hover(false);
	                    this.hoveredItem = undefined;
	                }
	            },
	            _hitTest: function (point) {
	                var hit, d = this.diagram, item, i;

	                // connectors
	                if (this._hoveredConnector) {
	                    this._hoveredConnector._hover(false);
	                    this._hoveredConnector = undefined;
	                }
	                if (d._connectorsAdorner._visible) {
	                    hit = d._connectorsAdorner._hitTest(point);
	                    if (hit) {
	                        return hit;
	                    }
	                }

	                hit = this.diagram._resizingAdorner._hitTest(point);
	                if (hit) {
	                    this.hoveredAdorner = d._resizingAdorner;
	                    if (hit.x !== 0 || hit.y !== 0) { // hit testing for resizers or rotator, otherwise if (0,0) than pass through.
	                        return;
	                    }
	                    hit = undefined;
	                } else {
	                    this.hoveredAdorner = undefined;
	                }

	                if (!this.activeTool || this.activeTool.type !== "ConnectionTool") {
	                    var selectedConnections = []; // only the connections should have higher presence because the connection edit point is on top of connector.
	                    // TODO: This should be reworked. The connection adorner should be one for all selected connections and should be hit tested prior the connections and shapes itself.
	                    for (i = 0; i < d._selectedItems.length; i++) {
	                        item = d._selectedItems[i];
	                        if (item instanceof diagram.Connection) {
	                            selectedConnections.push(item);
	                        }
	                    }
	                    hit = this._hitTestItems(selectedConnections, point);
	                }

	                return hit || this._hitTestElements(point);
	            },

	            _hitTestElements: function(point) {
	                var diagram = this.diagram;
	                var shapeHit = this._hitTestItems(diagram.shapes, point);
	                var connectionHit = this._hitTestItems(diagram.connections, point);
	                var hit;

	                if ((!this.activeTool || this.activeTool.type != "ConnectionTool") && shapeHit && connectionHit && !hitTestShapeConnectors(shapeHit, point)) {
	                    var mainLayer = diagram.mainLayer;
	                    var shapeIdx = inArray(shapeHit.visual, mainLayer.children);
	                    var connectionIdx = inArray(connectionHit.visual, mainLayer.children);
	                    hit = shapeIdx > connectionIdx ? shapeHit : connectionHit;
	                }
	                return hit || shapeHit || connectionHit;
	            },

	            _hitTestItems: function (array, point) {
	                var i, item, hit;
	                for (i = array.length - 1; i >= 0; i--) {
	                    item = array[i];
	                    hit = item._hitTest(point);
	                    if (hit) {
	                        return hit;
	                    }
	                }
	            }
	        });

	// Routing =========================================

	        /**
	         * Base class for connection routers.
	         */
	        var ConnectionRouterBase = kendo.Class.extend({
	            init: function () {
	            }
	            /*route: function (connection) {
	             },
	             hitTest: function (p) {

	             },
	             getBounds: function () {

	             }*/
	        });

	        /**
	         * Base class for polyline and cascading routing.
	         */
	        var LinearConnectionRouter = ConnectionRouterBase.extend({
	            init: function (connection) {
	                var that = this;
	                ConnectionRouterBase.fn.init.call(that);
	                this.connection = connection;
	            },
	            /**
	             * Hit testing for polyline paths.
	             */
	            hitTest: function (p) {
	                var rec = this.getBounds().inflate(HIT_TEST_DISTANCE);
	                if (!rec.contains(p)) {
	                    return false;
	                }
	                return diagram.Geometry.distanceToPolyline(p, this.connection.allPoints()) < HIT_TEST_DISTANCE;
	            },

	            /**
	             * Bounds of a polyline.
	             * @returns {kendo.dataviz.diagram.Rect}
	             */
	            getBounds: function () {
	                var points = this.connection.allPoints(),
	                    s = points[0],
	                    e = points[points.length - 1],
	                    right = Math.max(s.x, e.x),
	                    left = Math.min(s.x, e.x),
	                    top = Math.min(s.y, e.y),
	                    bottom = Math.max(s.y, e.y);

	                for (var i = 1; i < points.length - 1; ++i) {
	                    right = Math.max(right, points[i].x);
	                    left = Math.min(left, points[i].x);
	                    top = Math.min(top, points[i].y);
	                    bottom = Math.max(bottom, points[i].y);
	                }

	                return new Rect(left, top, right - left, bottom - top);
	            }
	        });

	        /**
	         * A simple poly-linear routing which does not alter the intermediate points.
	         * Does hold the underlying hit, bounds....logic.
	         * @type {*|Object|void|extend|Zepto.extend|b.extend}
	         */
	        var PolylineRouter = LinearConnectionRouter.extend({
	            init: function (connection) {
	                var that = this;
	                LinearConnectionRouter.fn.init.call(that);
	                this.connection = connection;
	            },
	            route: function () {
	                // just keep the points as is
	            }
	        });

	        var CascadingRouter = LinearConnectionRouter.extend({
	            SAME_SIDE_DISTANCE_RATIO: 5,

	            init: function (connection) {
	                var that = this;
	                LinearConnectionRouter.fn.init.call(that);
	                this.connection = connection;
	            },

	            routePoints: function(start, end, sourceConnector, targetConnector) {
	                var result;

	                if (sourceConnector && targetConnector) {
	                    result = this._connectorPoints(start, end, sourceConnector, targetConnector);
	                } else {
	                    result = this._floatingPoints(start, end, sourceConnector);
	                }
	                return result;
	            },

	            route: function () {
	                var sourceConnector = this.connection._resolvedSourceConnector;
	                var targetConnector = this.connection._resolvedTargetConnector;
	                var start = this.connection.sourcePoint();
	                var end = this.connection.targetPoint();
	                var points = this.routePoints(start, end, sourceConnector, targetConnector);
	                this.connection.points(points);
	            },

	            _connectorSides: [{
	                name: "Top",
	                axis: "y",
	                boundsPoint: "topLeft",
	                secondarySign: 1
	            }, {
	                name: "Left",
	                axis: "x",
	                boundsPoint: "topLeft",
	                secondarySign: 1
	            }, {
	                name: "Bottom",
	                axis: "y",
	                boundsPoint: "bottomRight",
	                secondarySign: -1
	            }, {
	                name: "Right",
	                axis: "x",
	                boundsPoint: "bottomRight",
	                secondarySign: -1
	            }],

	            _connectorSide: function(connector, targetPoint) {
	                var position = connector.position();
	                var shapeBounds = connector.shape.bounds(ROTATED);
	                var bounds = {
	                    topLeft: shapeBounds.topLeft(),
	                    bottomRight: shapeBounds.bottomRight()
	                };
	                var sides = this._connectorSides;
	                var min = util.MAX_NUM;
	                var sideDistance;
	                var minSide;
	                var axis;
	                var side;
	                for (var idx = 0; idx < sides.length; idx++) {
	                    side = sides[idx];
	                    axis = side.axis;
	                    sideDistance = Math.round(Math.abs(position[axis] - bounds[side.boundsPoint][axis]));
	                    if (sideDistance < min) {
	                        min = sideDistance;
	                        minSide = side;
	                    } else if (sideDistance === min &&
	                        (position[axis] - targetPoint[axis]) * side.secondarySign > (position[minSide.axis] - targetPoint[minSide.axis]) * minSide.secondarySign) {
	                        minSide = side;
	                    }
	                }
	                return minSide.name;
	            },

	            _sameSideDistance: function(connector) {
	                var bounds = connector.shape.bounds(ROTATED);
	                return Math.min(bounds.width, bounds.height) / this.SAME_SIDE_DISTANCE_RATIO;
	            },

	            _connectorPoints: function(start, end, sourceConnector, targetConnector) {
	                var sourceConnectorSide = this._connectorSide(sourceConnector, end);
	                var targetConnectorSide = this._connectorSide(targetConnector, start);
	                var deltaX = end.x - start.x;
	                var deltaY = end.y - start.y;
	                var sameSideDistance = this._sameSideDistance(sourceConnector);
	                var result = [];
	                var pointX, pointY;

	                if (sourceConnectorSide === TOP || sourceConnectorSide == BOTTOM) {
	                    if (targetConnectorSide == TOP || targetConnectorSide == BOTTOM) {
	                        if (sourceConnectorSide == targetConnectorSide) {
	                            if (sourceConnectorSide == TOP) {
	                                pointY = Math.min(start.y, end.y) - sameSideDistance;
	                            } else {
	                                pointY = Math.max(start.y, end.y) + sameSideDistance;
	                            }
	                            result = [new Point(start.x, pointY), new Point(end.x, pointY)];
	                        } else {
	                            result = [new Point(start.x, start.y + deltaY / 2), new Point(end.x, start.y + deltaY / 2)];
	                        }
	                    } else {
	                        result = [new Point(start.x, end.y)];
	                    }
	                } else {
	                    if (targetConnectorSide == LEFT || targetConnectorSide == RIGHT) {
	                        if (sourceConnectorSide == targetConnectorSide) {
	                            if (sourceConnectorSide == LEFT) {
	                                pointX = Math.min(start.x, end.x) - sameSideDistance;
	                            } else {
	                                pointX = Math.max(start.x, end.x) + sameSideDistance;
	                            }
	                            result = [new Point(pointX, start.y), new Point(pointX, end.y)];
	                        } else {
	                            result = [new Point(start.x + deltaX / 2, start.y), new Point(start.x + deltaX / 2, start.y + deltaY)];
	                        }
	                    } else {
	                        result = [new Point(end.x, start.y)];
	                    }
	                }
	                return result;
	            },

	            _floatingPoints: function(start, end, sourceConnector) {
	                var sourceConnectorSide = sourceConnector ? this._connectorSide(sourceConnector, end) : null;
	                var cascadeStartHorizontal = this._startHorizontal(start, end, sourceConnectorSide);
	                var points = [start, start, end, end];
	                var deltaX = end.x - start.x;
	                var deltaY = end.y - start.y;
	                var length = points.length;
	                var shiftX;
	                var shiftY;

	                // note that this is more generic than needed for only two intermediate points.
	                for (var idx = 1; idx < length - 1; ++idx) {
	                    if (cascadeStartHorizontal) {
	                        if (idx % 2 !== 0) {
	                            shiftX = deltaX / (length / 2);
	                            shiftY = 0;
	                        }
	                        else {
	                            shiftX = 0;
	                            shiftY = deltaY / ((length - 1) / 2);
	                        }
	                    }
	                    else {
	                        if (idx % 2 !== 0) {
	                            shiftX = 0;
	                            shiftY = deltaY / (length / 2);
	                        }
	                        else {
	                            shiftX = deltaX / ((length - 1) / 2);
	                            shiftY = 0;
	                        }
	                    }
	                    points[idx] = new Point(points[idx - 1].x + shiftX, points[idx - 1].y + shiftY);
	                }
	                // need to fix the wrong 1.5 factor of the last intermediate point
	                idx--;
	                if ((cascadeStartHorizontal && (idx % 2 !== 0)) || (!cascadeStartHorizontal && (idx % 2 === 0))) {
	                    points[length - 2] = new Point(points[length - 1].x, points[length - 2].y);
	                } else {
	                    points[length - 2] = new Point(points[length - 2].x, points[length - 1].y);
	                }

	                return [points[1], points[2]];
	            },

	            _startHorizontal: function (start, end, sourceSide) {
	                var horizontal;
	                if (sourceSide !== null && (sourceSide === RIGHT || sourceSide === LEFT)) {
	                    horizontal = true;
	                } else {
	                    horizontal = Math.abs(start.x - end.x) > Math.abs(start.y - end.y);
	                }

	                return horizontal;
	            }
	        });

	// Adorners =========================================

	        var AdornerBase = Class.extend({
	            init: function (diagram, options) {
	                var that = this;
	                that.diagram = diagram;
	                that.options = deepExtend({}, that.options, options);
	                that.visual = new Group();
	                that.diagram._adorners.push(that);
	            },
	            refresh: function () {

	            }
	        });

	        var ConnectionEditAdorner = AdornerBase.extend({
	            init: function (connection, options) {
	                var that = this, diagram;
	                that.connection = connection;
	                diagram = that.connection.diagram;
	                that._ts = diagram.toolService;
	                AdornerBase.fn.init.call(that, diagram, options);
	                var sp = that.connection.sourcePoint();
	                var tp = that.connection.targetPoint();
	                that.spVisual = new Circle(deepExtend(that.options.handles, { center: sp }));
	                that.epVisual = new Circle(deepExtend(that.options.handles, { center: tp }));
	                that.visual.append(that.spVisual);
	                that.visual.append(that.epVisual);
	            },

	            options: {
	                handles: {}
	            },

	            _getCursor: function () {
	                return Cursors.move;
	            },

	            start: function (p) {
	                this.handle = this._hitTest(p);
	                this.startPoint = p;
	                this._initialSource = this.connection.source();
	                this._initialTarget = this.connection.target();
	                switch (this.handle) {
	                    case -1:
	                        if (this.connection.targetConnector) {
	                            this._ts._connectionManipulation(this.connection, this.connection.targetConnector.shape);
	                        }
	                        break;
	                    case 1:
	                        if (this.connection.sourceConnector) {
	                            this._ts._connectionManipulation(this.connection, this.connection.sourceConnector.shape);
	                        }
	                        break;
	                }
	            },

	            move: function (handle, p) {
	                switch (handle) {
	                    case -1:
	                        this.connection.source(p);
	                        break;
	                    case 1:
	                        this.connection.target(p);
	                        break;
	                    default:
	                        var delta = p.minus(this.startPoint);
	                        this.startPoint = p;
	                        if (!this.connection.sourceConnector) {
	                            this.connection.source(this.connection.sourcePoint().plus(delta));
	                        }
	                        if (!this.connection.targetConnector) {
	                            this.connection.target(this.connection.targetPoint().plus(delta));
	                        }
	                        break;
	                }
	                this.refresh();
	                return true;
	            },

	            stop: function (p) {
	                var ts = this.diagram.toolService, item = ts.hoveredItem, target;
	                if (ts._hoveredConnector) {
	                    target = ts._hoveredConnector._c;
	                } else if (item && item instanceof diagram.Shape) {
	                    target = item.getConnector(AUTO) || item.getConnector(p);
	                } else {
	                    target = p;
	                }

	                if (this.handle === -1) {
	                    this.connection.source(target);
	                } else if (this.handle === 1) {
	                    this.connection.target(target);
	                }

	                this.handle = undefined;
	                this._ts._connectionManipulation();
	                return new ConnectionEditUndoUnit(this.connection, this._initialSource, this._initialTarget);
	            },

	            _hitTest: function (point) {
	                var sourcePoint = this.connection.sourcePoint();
	                var targetPoint = this.connection.targetPoint();
	                var radiusX = this.options.handles.width / 2 + HIT_TEST_DISTANCE;
	                var radiusY = this.options.handles.height / 2 + HIT_TEST_DISTANCE;
	                var sourcePointDistance = sourcePoint.distanceTo(point);
	                var targetPointDistance = targetPoint.distanceTo(point);
	                var sourceHandle = new Rect(sourcePoint.x, sourcePoint.y).inflate(radiusX, radiusY).contains(point);
	                var targetHandle = new Rect(targetPoint.x, targetPoint.y).inflate(radiusX, radiusY).contains(point);
	                var handle = 0;

	                if (sourceHandle && (!targetHandle || sourcePointDistance < targetPointDistance)) {
	                    handle = -1;
	                } else if (targetHandle && (!sourceHandle || targetPointDistance < sourcePointDistance)) {
	                    handle = 1;
	                }

	                return handle;
	            },

	            refresh: function () {
	                this.spVisual.redraw({ center: this.diagram.modelToLayer(this.connection.sourcePoint()) });
	                this.epVisual.redraw({ center: this.diagram.modelToLayer(this.connection.targetPoint()) });
	            }
	        });

	        var ConnectorsAdorner = AdornerBase.extend({
	            init: function (diagram, options) {
	                var that = this;
	                AdornerBase.fn.init.call(that, diagram, options);
	                that._refreshHandler = function (e) {
	                    if (e.item == that.shape) {
	                        that.refresh();
	                    }
	                };
	            },

	            show: function (shape) {
	                var that = this, len, i, ctr;
	                that._visible = true;
	                that.shape = shape;
	                that.diagram.bind(ITEMBOUNDSCHANGE, that._refreshHandler);
	                len = shape.connectors.length;
	                that.connectors = [];
	                that._clearVisual();
	                for (i = 0; i < len; i++) {
	                    ctr = new ConnectorVisual(shape.connectors[i]);
	                    that.connectors.push(ctr);
	                    that.visual.append(ctr.visual);
	                }
	                that.visual.visible(true);
	                that.refresh();
	            },

	            _clearVisual: function() {
	                var that = this;
	                if(that.diagram._cachedTouchTarget) {
	                    that._keepCachedTouchTarget();
	                } else {
	                    that.visual.clear();
	                }
	            },

	            _keepCachedTouchTarget: function () {
	                var that = this,
	                    visualChildren = that.visual.children;
	                var childrenCount = visualChildren.length;
	                var index = inArray(that.diagram._cachedTouchTarget, visualChildren);
	                for (var i = childrenCount - 1; i >= 0; i--) {
	                    if(i == index) {
	                        continue;
	                    }
	                    that.visual.remove(visualChildren[i]);
	                }
	            },

	            destroy: function () {
	                var that = this;
	                that.diagram.unbind(ITEMBOUNDSCHANGE, that._refreshHandler);
	                that.shape = undefined;
	                that._visible = undefined;
	                that.visual.visible(false);
	            },

	            _hitTest: function (p) {
	                var ctr, i;
	                for (i = 0; i < this.connectors.length; i++) {
	                    ctr = this.connectors[i];
	                    if (ctr._hitTest(p)) {
	                        ctr._hover(true);
	                        this.diagram.toolService._hoveredConnector = ctr;
	                        break;
	                    }
	                }
	            },

	            refresh: function () {
	                if (this.shape) {
	                    var bounds = this.shape.bounds();
	                        bounds = this.diagram.modelToLayer(bounds);
	                    this.visual.position(bounds.topLeft());
	                    $.each(this.connectors, function () {
	                        this.refresh();
	                    });
	                }
	            }
	        });

	        function hitToOppositeSide(hit, bounds) {
	            var result;

	            if (hit.x == -1 && hit.y == -1) {
	                result = bounds.bottomRight();
	            } else if (hit.x == 1 && hit.y == 1) {
	                result = bounds.topLeft();
	            } else if (hit.x == -1 && hit.y == 1) {
	                result = bounds.topRight();
	            } else if (hit.x == 1 && hit.y == -1) {
	                result = bounds.bottomLeft();
	            } else if (hit.x === 0 && hit.y == -1) {
	                result = bounds.bottom();
	            } else if (hit.x === 0 && hit.y == 1) {
	                result = bounds.top();
	            } else if (hit.x == 1 && hit.y === 0) {
	                result = bounds.left();
	            } else if (hit.x == -1 && hit.y === 0) {
	                result = bounds.right();
	            }

	            return result;
	        }

	        var ResizingAdorner = AdornerBase.extend({
	            init: function (diagram, options) {
	                var that = this;
	                AdornerBase.fn.init.call(that, diagram, options);
	                that._manipulating = false;
	                that.map = [];
	                that.shapes = [];

	                that._initSelection();
	                that._createHandles();
	                that.redraw();
	                that.diagram.bind("select", function (e) {
	                    that._initialize(e.selected);
	                });

	                that._refreshHandler = function () {
	                    if (!that._internalChange) {
	                        that.refreshBounds();
	                        that.refresh();
	                    }
	                };

	                that._rotatedHandler = function () {
	                    if (that.shapes.length == 1) {
	                        that._angle = that.shapes[0].rotate().angle;
	                    }
	                    that._refreshHandler();
	                };

	                that.diagram.bind(ITEMBOUNDSCHANGE, that._refreshHandler).bind(ITEMROTATE, that._rotatedHandler);
	                that.refreshBounds();
	                that.refresh();
	            },

	            options: {
	                handles: {
	                    fill: {
	                        color: "#fff"
	                    },
	                    stroke: {
	                        color: "#282828"
	                    },
	                    height: 7,
	                    width: 7,
	                    hover: {
	                        fill: {
	                            color: "#282828"
	                        },
	                        stroke: {
	                            color: "#282828"
	                        }
	                    }
	                },
	                selectable: {
	                    stroke: {
	                        color: "#778899",
	                        width: 1,
	                        dashType: "dash"
	                    },
	                    fill: {
	                        color: TRANSPARENT
	                    }
	                },
	                offset: 10
	            },

	            _initSelection: function() {
	                var that = this;
	                var diagram = that.diagram;
	                var selectable = diagram.options.selectable;
	                var options = deepExtend({}, that.options.selectable, selectable);
	                that.rect = new Rectangle(options);
	                that.visual.append(that.rect);
	            },

	            _resizable: function() {
	                return this.options.editable && this.options.editable.resize !== false;
	            },

	            _handleOptions: function() {
	                return (this.options.editable.resize || {}).handles || this.options.handles;
	            },

	            _createHandles: function() {
	                var handles, item, y, x;

	                if (this._resizable()) {
	                    handles = this._handleOptions();
	                    for (x = -1; x <= 1; x++) {
	                        for (y = -1; y <= 1; y++) {
	                            if ((x !== 0) || (y !== 0)) { // (0, 0) element, (-1, -1) top-left, (+1, +1) bottom-right
	                                item = new Rectangle(handles);
	                                item.drawingElement._hover = proxy(this._hover, this);
	                                this.map.push({ x: x, y: y, visual: item });
	                                this.visual.append(item);
	                            }
	                        }
	                    }
	                }
	            },

	            bounds: function (value) {
	                if (value) {
	                    this._innerBounds = value.clone();
	                    this._bounds = this.diagram.modelToLayer(value).inflate(this.options.offset, this.options.offset);
	                } else {
	                    return this._bounds;
	                }
	            },

	            _hitTest: function (p) {
	                var tp = this.diagram.modelToLayer(p),
	                    i, hit, handleBounds, handlesCount = this.map.length, handle;

	                if (this._angle) {
	                    tp = tp.clone().rotate(this._bounds.center(), this._angle);
	                }

	                if (this._resizable()) {
	                    for (i = 0; i < handlesCount; i++) {
	                        handle = this.map[i];
	                        hit = new Point(handle.x, handle.y);
	                        handleBounds = this._getHandleBounds(hit); //local coordinates
	                        handleBounds.offset(this._bounds.x, this._bounds.y);
	                        if (handleBounds.contains(tp)) {
	                            return hit;
	                        }
	                    }
	                }

	                if (this._bounds.contains(tp)) {
	                    return new Point(0, 0);
	                }
	            },

	            _getHandleBounds: function (p) {
	                if (this._resizable()) {
	                    var handles = this._handleOptions(),
	                        w = handles.width,
	                        h = handles.height,
	                        r = new Rect(0, 0, w, h);

	                    if (p.x < 0) {
	                        r.x = - w / 2;
	                    } else if (p.x === 0) {
	                        r.x = Math.floor(this._bounds.width / 2) - w / 2;
	                    } else if (p.x > 0) {
	                        r.x = this._bounds.width + 1.0 - w / 2;
	                    } if (p.y < 0) {
	                        r.y = - h / 2;
	                    } else if (p.y === 0) {
	                        r.y = Math.floor(this._bounds.height / 2) - h / 2;
	                    } else if (p.y > 0) {
	                        r.y = this._bounds.height + 1.0 - h / 2;
	                    }

	                    return r;
	                }
	            },

	            _getCursor: function (point) {
	                var hit = this._hitTest(point);
	                if (hit && (hit.x >= -1) && (hit.x <= 1) && (hit.y >= -1) && (hit.y <= 1) && this._resizable()) {
	                    var angle = this._angle;
	                    if (angle) {
	                        angle = 360 - angle;
	                        hit.rotate(new Point(0, 0), angle);
	                        hit = new Point(Math.round(hit.x), Math.round(hit.y));
	                    }

	                    if (hit.x == -1 && hit.y == -1) {
	                        return "nw-resize";
	                    }
	                    if (hit.x == 1 && hit.y == 1) {
	                        return "se-resize";
	                    }
	                    if (hit.x == -1 && hit.y == 1) {
	                        return "sw-resize";
	                    }
	                    if (hit.x == 1 && hit.y == -1) {
	                        return "ne-resize";
	                    }
	                    if (hit.x === 0 && hit.y == -1) {
	                        return "n-resize";
	                    }
	                    if (hit.x === 0 && hit.y == 1) {
	                        return "s-resize";
	                    }
	                    if (hit.x == 1 && hit.y === 0) {
	                        return "e-resize";
	                    }
	                    if (hit.x == -1 && hit.y === 0) {
	                        return "w-resize";
	                    }
	                }
	                return this._manipulating ? Cursors.move : Cursors.select;
	            },

	            _initialize: function() {
	                var that = this, i, item,
	                    items = that.diagram.select();

	                that.shapes = [];
	                for (i = 0; i < items.length; i++) {
	                    item = items[i];
	                    if (item instanceof diagram.Shape) {
	                        that.shapes.push(item);
	                        item._rotationOffset = new Point();
	                    }
	                }

	                that._angle = that.shapes.length == 1 ? that.shapes[0].rotate().angle : 0;
	                that._startAngle = that._angle;
	                that._rotates();
	                that._positions();
	                that.refreshBounds();
	                that.refresh();
	                that.redraw();
	            },

	            _rotates: function () {
	                var that = this, i, shape;
	                that.initialRotates = [];
	                for (i = 0; i < that.shapes.length; i++) {
	                    shape = that.shapes[i];
	                    that.initialRotates.push(shape.rotate().angle);
	                }
	            },

	            _positions: function () {
	                var that = this, i, shape;
	                that.initialStates = [];
	                for (i = 0; i < that.shapes.length; i++) {
	                    shape = that.shapes[i];
	                    that.initialStates.push(shape.bounds());
	                }
	            },

	            _hover: function(value, element) {
	                if (this._resizable()) {
	                    var handleOptions = this._handleOptions(),
	                        hover = handleOptions.hover,
	                        stroke = handleOptions.stroke,
	                        fill = handleOptions.fill;

	                    if (value && Utils.isDefined(hover.stroke)) {
	                        stroke = deepExtend({}, stroke, hover.stroke);
	                    }

	                    if (value && Utils.isDefined(hover.fill)) {
	                        fill = hover.fill;
	                    }
	                    element.stroke(stroke.color, stroke.width, stroke.opacity);
	                    element.fill(fill.color, fill.opacity);
	                }
	            },

	            start: function (p) {
	                this._sp = p;
	                this._cp = p;
	                this._lp = p;
	                this._manipulating = true;
	                this._internalChange = true;
	                this.shapeStates = [];
	                for (var i = 0; i < this.shapes.length; i++) {
	                    var shape = this.shapes[i];
	                    this.shapeStates.push(shape.bounds());
	                }
	            },

	            redraw: function () {
	                var i, handle,
	                    visibleHandles = this._resizable();

	                for (i = 0; i < this.map.length; i++) {
	                    handle = this.map[i];
	                    handle.visual.visible(visibleHandles);
	                }
	            },

	            angle: function(value) {
	                if (defined(value)) {
	                    this._angle = value;
	                }

	                return this._angle;
	            },

	            rotate: function() {
	                var center = this._innerBounds.center();
	                var currentAngle = this.angle();
	                this._internalChange = true;
	                for (var i = 0; i < this.shapes.length; i++) {
	                    var shape = this.shapes[i];
	                    currentAngle = (currentAngle + this.initialRotates[i] - this._startAngle) % 360;
	                    shape.rotate(currentAngle, center);
	                }
	                this.refresh();
	            },

	            move: function (handle, p) {
	                var delta, dragging,
	                    dtl = new Point(),
	                    dbr = new Point(),
	                    bounds, center, shape,
	                    i, angle, newBounds,
	                    changed = 0, staticPoint,
	                    scaleX, scaleY;

	                if (handle.y === -2 && handle.x === -1) {
	                    center = this._innerBounds.center();
	                    this._angle = this._truncateAngle(Utils.findAngle(center, p));
	                    for (i = 0; i < this.shapes.length; i++) {
	                        shape = this.shapes[i];
	                        angle = (this._angle + this.initialRotates[i] - this._startAngle) % 360;
	                        shape.rotate(angle, center);
	                        if (shape.hasOwnProperty("layout")) {
	                            shape.layout(shape);
	                        }
	                        this._rotating = true;
	                    }
	                    this.refresh();
	                } else {
	                    if (this.shouldSnap()) {
	                        var thr = this._truncateDistance(p.minus(this._lp));
	                        // threshold
	                        if (thr.x === 0 && thr.y === 0) {
	                            this._cp = p;
	                            return;
	                        }
	                        delta = thr;
	                        this._lp = new Point(this._lp.x + thr.x, this._lp.y + thr.y);
	                    } else {
	                        delta = p.minus(this._cp);
	                    }

	                    if (this.isDragHandle(handle)) {
	                        dbr = dtl = delta; // dragging
	                        dragging = true;
	                    } else {
	                        if (this._angle) { // adjust the delta so that resizers resize in the correct direction after rotation.
	                            delta.rotate(new Point(0, 0), this._angle);
	                        }
	                        if (handle.x == -1) {
	                            dtl.x = delta.x;
	                        } else if (handle.x == 1) {
	                            dbr.x = delta.x;
	                        }
	                        if (handle.y == -1) {
	                            dtl.y = delta.y;
	                        } else if (handle.y == 1) {
	                            dbr.y = delta.y;
	                        }
	                    }

	                    if (!dragging) {
	                        staticPoint = hitToOppositeSide(handle, this._innerBounds);
	                        scaleX = (this._innerBounds.width + delta.x * handle.x) / this._innerBounds.width;
	                        scaleY = (this._innerBounds.height + delta.y * handle.y) / this._innerBounds.height;
	                    }

	                    for (i = 0; i < this.shapes.length; i++) {
	                        shape = this.shapes[i];
	                        bounds = shape.bounds();
	                        if (dragging) {
	                            if (!canDrag(shape)) {
	                                continue;
	                            }
	                            newBounds = this._displaceBounds(bounds, dtl, dbr, dragging);
	                        } else {
	                            newBounds = bounds.clone();
	                            newBounds.scale(scaleX, scaleY, staticPoint, this._innerBounds.center(), shape.rotate().angle);
	                            var newCenter = newBounds.center(); // fixes the new rotation center.
	                            newCenter.rotate(bounds.center(), -this._angle);
	                            newBounds = new Rect(newCenter.x - newBounds.width / 2, newCenter.y - newBounds.height / 2, newBounds.width, newBounds.height);
	                        }
	                        if (newBounds.width >= shape.options.minWidth && newBounds.height >= shape.options.minHeight) { // if we up-size very small shape
	                            var oldBounds = bounds;
	                            shape.bounds(newBounds);
	                            if (shape.hasOwnProperty("layout")) {
	                                shape.layout(shape, oldBounds, newBounds);
	                            }
	                            if (oldBounds.width !== newBounds.width || oldBounds.height !== newBounds.height) {
	                                shape.rotate(shape.rotate().angle); // forces the rotation to update it's rotation center
	                            }
	                            changed += 1;
	                        }
	                    }

	                    if (changed) {
	                        if (changed == i) {
	                            newBounds = this._displaceBounds(this._innerBounds, dtl, dbr, dragging);
	                            this.bounds(newBounds);
	                        } else {
	                            this.refreshBounds();
	                        }
	                        this.refresh();
	                    }

	                    this._positions();
	                }

	                this._cp = p;
	            },

	            isDragHandle: function(handle) {
	                return handle.x === 0 && handle.y === 0;
	            },

	            cancel: function() {
	                var shapes = this.shapes;
	                var states = this.shapeStates;
	                for (var idx = 0; idx < shapes.length; idx++) {
	                    shapes[idx].bounds(states[idx]);
	                }
	                this.refreshBounds();
	                this.refresh();
	                this._manipulating = undefined;
	                this._internalChange = undefined;
	                this._rotating = undefined;
	            },

	            _truncatePositionToGuides: function (bounds) {
	                if (this.diagram.ruler) {
	                    return this.diagram.ruler.truncatePositionToGuides(bounds);
	                }
	                return bounds;
	            },

	            _truncateSizeToGuides: function (bounds) {
	                if (this.diagram.ruler) {
	                    return this.diagram.ruler.truncateSizeToGuides(bounds);
	                }
	                return bounds;
	            },

	            _truncateAngle: function (a) {
	                var snap = this.snapOptions();
	                var snapAngle = Math.max(snap.angle || DEFAULT_SNAP_ANGLE, MIN_SNAP_ANGLE);
	                return snap ? Math.floor((a % 360) / snapAngle) * snapAngle : (a % 360);
	            },

	            _truncateDistance: function (d) {
	                if (d instanceof diagram.Point) {
	                    return new diagram.Point(this._truncateDistance(d.x), this._truncateDistance(d.y));
	                } else {
	                    var snap = this.snapOptions() || {};
	                    var snapSize = Math.max(snap.size || DEFAULT_SNAP_SIZE, MIN_SNAP_SIZE);
	                    return snap ? Math.floor(d / snapSize) * snapSize : d;
	                }
	            },

	            snapOptions: function() {
	                var editable = this.diagram.options.editable;
	                var snap = ((editable || {}).drag || {}).snap || {};
	                return snap;
	            },

	            shouldSnap: function() {
	                var editable = this.diagram.options.editable;
	                var drag = (editable || {}).drag;
	                var snap = (drag || {}).snap;
	                return editable !== false && drag !== false && snap !== false;
	            },

	            _displaceBounds: function (bounds, dtl, dbr, dragging) {
	                var tl = bounds.topLeft().plus(dtl),
	                    br = bounds.bottomRight().plus(dbr),
	                    newBounds = Rect.fromPoints(tl, br),
	                    newCenter;
	                if (!dragging) {
	                    newCenter = newBounds.center();
	                    newCenter.rotate(bounds.center(), -this._angle);
	                    newBounds = new Rect(newCenter.x - newBounds.width / 2, newCenter.y - newBounds.height / 2, newBounds.width, newBounds.height);
	                }
	                return newBounds;
	            },

	            stop: function () {
	                var unit, i, shape;
	                if (this._cp != this._sp) {
	                    if (this._rotating) {
	                        unit = new RotateUnit(this, this.shapes, this.initialRotates);
	                        this._rotating = false;
	                    } else if (this._diffStates()) {
	                        if (this.diagram.ruler) {
	                            for (i = 0; i < this.shapes.length; i++) {
	                                shape = this.shapes[i];
	                                var bounds = shape.bounds();
	                                bounds = this._truncateSizeToGuides(this._truncatePositionToGuides(bounds));
	                                shape.bounds(bounds);
	                                this.refreshBounds();
	                                this.refresh();
	                            }
	                        }
	                        for (i = 0; i < this.shapes.length; i++) {
	                            shape = this.shapes[i];
	                            shape.updateModel();
	                        }
	                        unit = new TransformUnit(this.shapes, this.shapeStates, this);
	                        this.diagram._syncShapeChanges();
	                    }
	                }

	                this._manipulating = undefined;
	                this._internalChange = undefined;
	                this._rotating = undefined;
	                return unit;
	            },

	            _diffStates: function() {
	                var shapes = this.shapes;
	                var states = this.shapeStates;
	                for (var idx = 0; idx < shapes.length; idx++) {
	                    if (!shapes[idx].bounds().equals(states[idx])) {
	                        return true;
	                    }
	                }
	                return false;
	            },

	            refreshBounds: function () {
	                var bounds = this.shapes.length == 1 ?
	                    this.shapes[0].bounds().clone() :
	                    this.diagram.boundingBox(this.shapes, true);

	                this.bounds(bounds);
	            },

	            refresh: function () {
	                var that = this, b, bounds;
	                if (this.shapes.length > 0) {
	                    bounds = this.bounds();
	                    this.visual.visible(true);
	                    this.visual.position(bounds.topLeft());
	                    $.each(this.map, function () {
	                        b = that._getHandleBounds(new Point(this.x, this.y));
	                        this.visual.position(b.topLeft());
	                    });
	                    this.visual.position(bounds.topLeft());

	                    var center = new Point(bounds.width / 2, bounds.height / 2);
	                    this.visual.rotate(this._angle, center);
	                    this.rect.redraw({ width: bounds.width, height: bounds.height });
	                    if (this.rotationThumb) {
	                        var thumb = this.options.editable.rotate.thumb;
	                        this._rotationThumbBounds = new Rect(bounds.center().x, bounds.y + thumb.y, 0, 0).inflate(thumb.width);
	                        this.rotationThumb.redraw({ x: bounds.width / 2 - thumb.width / 2 });
	                    }
	                } else {
	                    this.visual.visible(false);
	                }
	            }
	        });

	        var Selector = Class.extend({
	            init: function (diagram) {
	                var selectable = diagram.options.selectable;
	                this.options = deepExtend({}, this.options, selectable);

	                this.visual = new Rectangle(this.options);
	                this.diagram = diagram;
	            },
	            options: {
	                stroke: {
	                    color: "#778899",
	                    width: 1,
	                    dashType: "dash"
	                },
	                fill: {
	                    color: TRANSPARENT
	                }
	            },
	            start: function (p) {
	                this._sp = this._ep = p;
	                this.refresh();
	                this.diagram._adorn(this, true);
	            },
	            end: function () {
	                this._sp = this._ep = undefined;
	                this.diagram._adorn(this, false);
	            },
	            bounds: function (value) {
	                if (value) {
	                    this._bounds = value;
	                }
	                return this._bounds;
	            },
	            move: function (p) {
	                this._ep = p;
	                this.refresh();
	            },
	            refresh: function () {
	                if (this._sp) {
	                    var visualBounds = Rect.fromPoints(this.diagram.modelToLayer(this._sp), this.diagram.modelToLayer(this._ep));
	                    this.bounds(Rect.fromPoints(this._sp, this._ep));
	                    this.visual.position(visualBounds.topLeft());
	                    this.visual.redraw({ height: visualBounds.height + 1, width: visualBounds.width + 1 });
	                }
	            }
	        });

	        var ConnectorVisual = Class.extend({
	            init: function (connector) {
	                this.options = deepExtend({}, connector.options);
	                this._c = connector;
	                this.visual = new Circle(this.options);
	                this.refresh();
	            },
	            _hover: function (value) {
	                var options = this.options,
	                    hover = options.hover,
	                    stroke = options.stroke,
	                    fill = options.fill;

	                if (value && Utils.isDefined(hover.stroke)) {
	                    stroke = deepExtend({}, stroke, hover.stroke);
	                }

	                if (value && Utils.isDefined(hover.fill)) {
	                    fill = hover.fill;
	                }

	                this.visual.redraw({
	                    stroke: stroke,
	                    fill: fill
	                });
	            },
	            refresh: function () {
	                var p = this._c.shape.diagram.modelToView(this._c.position()),
	                    relative = p.minus(this._c.shape.bounds("transformed").topLeft()),
	                    value = new Rect(p.x, p.y, 0, 0);
	                value.inflate(this.options.width / 2, this.options.height / 2);
	                this._visualBounds = value;
	                this.visual.redraw({ center: new Point(relative.x, relative.y) });
	            },
	            _hitTest: function (p) {
	                var tp = this._c.shape.diagram.modelToView(p);
	                return this._visualBounds.contains(tp);
	            }
	        });

	        function canDrag(element) {
	            var editable = element.options.editable;
	            return editable && editable.drag !== false;
	        }

	        function hitTestShapeConnectors(shape, point) {
	            var connector, position, rect;
	            for (var idx = 0; idx < shape.connectors.length; idx++) {
	                connector = shape.connectors[idx];
	                position = connector.position();
	                rect = new Rect(position.x, position.y);
	                rect.inflate(HIT_TEST_DISTANCE, HIT_TEST_DISTANCE);
	                if (rect.contains(point)) {
	                    return connector;
	                }
	            }
	        }

	        function noMeta(meta) {
	            return meta.ctrlKey === false && meta.altKey === false && meta.shiftKey === false;
	        }

	        deepExtend(diagram, {
	            CompositeUnit: CompositeUnit,
	            TransformUnit: TransformUnit,
	            PanUndoUnit: PanUndoUnit,
	            AddShapeUnit: AddShapeUnit,
	            AddConnectionUnit: AddConnectionUnit,
	            DeleteShapeUnit: DeleteShapeUnit,
	            DeleteConnectionUnit: DeleteConnectionUnit,
	            ConnectionEditAdorner: ConnectionEditAdorner,
	            ConnectionTool: ConnectionTool,
	            ConnectorVisual: ConnectorVisual,
	            UndoRedoService: UndoRedoService,
	            ResizingAdorner: ResizingAdorner,
	            Selector: Selector,
	            ToolService: ToolService,
	            ConnectorsAdorner: ConnectorsAdorner,
	            LayoutUndoUnit: LayoutUndoUnit,
	            ConnectionEditUnit: ConnectionEditUnit,
	            ToFrontUnit: ToFrontUnit,
	            ToBackUnit: ToBackUnit,
	            ConnectionRouterBase: ConnectionRouterBase,
	            PolylineRouter: PolylineRouter,
	            CascadingRouter: CascadingRouter,
	            SelectionTool: SelectionTool,
	            ScrollerTool: ScrollerTool,
	            PointerTool: PointerTool,
	            ConnectionEditTool: ConnectionEditTool,
	            RotateUnit: RotateUnit
	        });
	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "O8Rq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var excelXmlFactory_1 = __webpack_require__("Bx8k");
var ExcelGridSerializingSession = (function (_super) {
    __extends(ExcelGridSerializingSession, _super);
    function ExcelGridSerializingSession(columnController, valueService, gridOptionsWrapper, processCellCallback, processHeaderCallback, sheetName, excelXmlFactory, baseExcelStyles, styleLinker) {
        var _this = _super.call(this, columnController, valueService, gridOptionsWrapper, processCellCallback, processHeaderCallback, function (raw) { return main_1.Utils.escape(raw); }) || this;
        _this.excelXmlFactory = excelXmlFactory;
        _this.styleLinker = styleLinker;
        _this.mixedStyles = {};
        _this.mixedStyleCounter = 0;
        _this.rows = [];
        _this.stylesByIds = {};
        if (!baseExcelStyles) {
            _this.excelStyles = [];
        }
        else {
            baseExcelStyles.forEach(function (it) {
                _this.stylesByIds[it.id] = it;
            });
            _this.excelStyles = baseExcelStyles.slice();
        }
        _this.sheetName = sheetName;
        return _this;
    }
    ExcelGridSerializingSession.prototype.addCustomHeader = function (customHeader) {
        this.customHeader = customHeader;
    };
    ExcelGridSerializingSession.prototype.addCustomFooter = function (customFooter) {
        this.customFooter = customFooter;
    };
    ExcelGridSerializingSession.prototype.prepare = function (columnsToExport) {
        this.cols = main_1.Utils.map(columnsToExport, function (it) {
            it.getColDef().cellStyle;
            return {
                width: it.getActualWidth()
            };
        });
    };
    ExcelGridSerializingSession.prototype.onNewHeaderGroupingRow = function () {
        var currentCells = [];
        var that = this;
        this.rows.push({
            cells: currentCells
        });
        return {
            onColumn: function (header, index, span) {
                var styleIds = that.styleLinker(main_1.RowType.HEADER_GROUPING, 1, index, "grouping-" + header, null, null);
                currentCells.push(that.createMergedCell(styleIds.length > 0 ? styleIds[0] : null, "String", header, span));
            }
        };
    };
    ExcelGridSerializingSession.prototype.onNewHeaderRow = function () {
        return this.onNewRow(this.onNewHeaderColumn);
    };
    ExcelGridSerializingSession.prototype.onNewBodyRow = function () {
        return this.onNewRow(this.onNewBodyColumn);
    };
    ExcelGridSerializingSession.prototype.onNewRow = function (onNewColumnAccumulator) {
        var currentCells = [];
        this.rows.push({
            cells: currentCells
        });
        return {
            onColumn: onNewColumnAccumulator.bind(this, this.rows.length, currentCells)()
        };
    };
    ExcelGridSerializingSession.prototype.onNewHeaderColumn = function (rowIndex, currentCells) {
        var _this = this;
        var that = this;
        return function (column, index, node) {
            var nameForCol = _this.extractHeaderValue(column);
            var styleIds = that.styleLinker(main_1.RowType.HEADER, rowIndex, index, nameForCol, column, null);
            currentCells.push(_this.createCell(styleIds.length > 0 ? styleIds[0] : null, 'String', nameForCol));
        };
    };
    ExcelGridSerializingSession.prototype.parse = function () {
        function join(header, body, footer) {
            var all = [];
            if (header) {
                header.forEach(function (rowArray) { return all.push({ cells: rowArray }); });
            }
            body.forEach(function (it) { return all.push(it); });
            if (footer) {
                footer.forEach(function (rowArray) { return all.push({ cells: rowArray }); });
            }
            return all;
        }
        var data = [{
                name: this.sheetName,
                table: {
                    columns: this.cols,
                    rows: join(this.customHeader, this.rows, this.customFooter)
                }
            }];
        return this.excelXmlFactory.createExcelXml(this.excelStyles, data);
    };
    ExcelGridSerializingSession.prototype.onNewBodyColumn = function (rowIndex, currentCells) {
        var _this = this;
        var that = this;
        return function (column, index, node) {
            var valueForCell = _this.extractRowCellValue(column, index, main_1.Constants.EXPORT_TYPE_EXCEL, node);
            var styleIds = that.styleLinker(main_1.RowType.BODY, rowIndex, index, valueForCell, column, node);
            var excelStyleId = null;
            if (styleIds && styleIds.length == 1) {
                excelStyleId = styleIds[0];
            }
            else if (styleIds && styleIds.length > 1) {
                var key = styleIds.join("-");
                if (!_this.mixedStyles[key]) {
                    _this.addNewMixedStyle(styleIds);
                }
                excelStyleId = _this.mixedStyles[key].excelID;
            }
            var type = main_1.Utils.isNumeric(valueForCell) ? 'Number' : 'String';
            currentCells.push(that.createCell(excelStyleId, type, valueForCell));
        };
    };
    ExcelGridSerializingSession.prototype.addNewMixedStyle = function (styleIds) {
        var _this = this;
        this.mixedStyleCounter += 1;
        var excelId = 'mixedStyle' + this.mixedStyleCounter;
        var resultantStyle = {};
        styleIds.forEach(function (styleId) {
            _this.excelStyles.forEach(function (excelStyle) {
                if (excelStyle.id === styleId) {
                    main_1.Utils.mergeDeep(resultantStyle, excelStyle);
                }
            });
        });
        resultantStyle['id'] = excelId;
        resultantStyle['name'] = excelId;
        var key = styleIds.join("-");
        this.mixedStyles[key] = {
            excelID: excelId,
            key: key,
            result: resultantStyle
        };
        this.excelStyles.push(resultantStyle);
        this.stylesByIds[excelId] = resultantStyle;
    };
    ExcelGridSerializingSession.prototype.styleExists = function (styleId) {
        if (styleId == null)
            return false;
        return this.stylesByIds[styleId];
    };
    ExcelGridSerializingSession.prototype.createCell = function (styleId, type, value) {
        var actualStyle = this.stylesByIds[styleId];
        var styleExists = actualStyle != null;
        function getType() {
            if (styleExists &&
                actualStyle.dataType)
                switch (actualStyle.dataType) {
                    case 'string':
                        return 'String';
                    case 'number':
                        return 'Number';
                    case 'dateTime':
                        return 'DateTime';
                    case 'error':
                        return 'Error';
                    case 'boolean':
                        return 'Boolean';
                    default:
                        console.warn("ag-grid: Unrecognized data type for excel export [" + actualStyle.id + ".dataType=" + actualStyle.dataType + "]");
                }
            return type;
        }
        return {
            styleId: styleExists ? styleId : null,
            data: {
                type: getType(),
                value: value
            }
        };
    };
    ExcelGridSerializingSession.prototype.createMergedCell = function (styleId, type, value, numOfCells) {
        return {
            styleId: this.styleExists(styleId) ? styleId : null,
            data: {
                type: type,
                value: value
            },
            mergeAcross: numOfCells
        };
    };
    return ExcelGridSerializingSession;
}(main_1.BaseGridSerializingSession));
exports.ExcelGridSerializingSession = ExcelGridSerializingSession;
var ExcelCreator = (function (_super) {
    __extends(ExcelCreator, _super);
    function ExcelCreator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExcelCreator.prototype.postConstruct = function () {
        this.setBeans({
            downloader: this.downloader,
            gridSerializer: this.gridSerializer,
            gridOptionsWrapper: this.gridOptionsWrapper
        });
    };
    ExcelCreator.prototype.exportDataAsExcel = function (params) {
        return this.export(params);
    };
    ExcelCreator.prototype.getDataAsExcelXml = function (params) {
        return this.getData(params);
    };
    ExcelCreator.prototype.getMimeType = function () {
        return "application/vnd.ms-excel";
    };
    ExcelCreator.prototype.getDefaultFileName = function () {
        return 'export.xls';
    };
    ExcelCreator.prototype.getDefaultFileExtension = function () {
        return 'xls';
    };
    ExcelCreator.prototype.createSerializingSession = function (params) {
        return new ExcelGridSerializingSession(this.columnController, this.valueService, this.gridOptionsWrapper, params ? params.processCellCallback : null, params ? params.processHeaderCallback : null, params && params.sheetName != null && params.sheetName != "" ? params.sheetName : 'ag-grid', this.excelXmlFactory, this.gridOptions.excelStyles, this.styleLinker.bind(this));
    };
    ExcelCreator.prototype.styleLinker = function (rowType, rowIndex, colIndex, value, column, node) {
        if ((rowType === main_1.RowType.HEADER) || (rowType === main_1.RowType.HEADER_GROUPING))
            return ["header"];
        if (!this.gridOptions.excelStyles || this.gridOptions.excelStyles.length === 0)
            return null;
        var styleIds = this.gridOptions.excelStyles.map(function (it) {
            return it.id;
        });
        var applicableStyles = [];
        this.stylingService.processAllCellClasses(column.getColDef(), {
            value: value,
            data: node.data,
            node: node,
            colDef: column.getColDef(),
            rowIndex: rowIndex,
            api: this.gridOptionsWrapper.getApi(),
            context: this.gridOptionsWrapper.getContext()
        }, function (className) {
            if (styleIds.indexOf(className) > -1) {
                applicableStyles.push(className);
            }
        });
        return applicableStyles.sort(function (left, right) {
            return (styleIds.indexOf(left) < styleIds.indexOf(right)) ? -1 : 1;
        });
    };
    ExcelCreator.prototype.isExportSuppressed = function () {
        return this.gridOptionsWrapper.isSuppressExcelExport();
    };
    __decorate([
        main_1.Autowired('excelXmlFactory'),
        __metadata("design:type", excelXmlFactory_1.ExcelXmlFactory)
    ], ExcelCreator.prototype, "excelXmlFactory", void 0);
    __decorate([
        main_1.Autowired('columnController'),
        __metadata("design:type", main_1.ColumnController)
    ], ExcelCreator.prototype, "columnController", void 0);
    __decorate([
        main_1.Autowired('valueService'),
        __metadata("design:type", main_1.ValueService)
    ], ExcelCreator.prototype, "valueService", void 0);
    __decorate([
        main_1.Autowired('gridOptions'),
        __metadata("design:type", Object)
    ], ExcelCreator.prototype, "gridOptions", void 0);
    __decorate([
        main_1.Autowired('stylingService'),
        __metadata("design:type", main_1.StylingService)
    ], ExcelCreator.prototype, "stylingService", void 0);
    __decorate([
        main_1.Autowired('downloader'),
        __metadata("design:type", main_1.Downloader)
    ], ExcelCreator.prototype, "downloader", void 0);
    __decorate([
        main_1.Autowired('gridSerializer'),
        __metadata("design:type", main_1.GridSerializer)
    ], ExcelCreator.prototype, "gridSerializer", void 0);
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], ExcelCreator.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ExcelCreator.prototype, "postConstruct", null);
    ExcelCreator = __decorate([
        main_1.Bean('excelCreator')
    ], ExcelCreator);
    return ExcelCreator;
}(main_1.BaseCreator));
exports.ExcelCreator = ExcelCreator;


/***/ }),

/***/ "O8ob":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(994);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 988:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Ytuf");

/***/ }),

/***/ 994:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(988) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($) {

	// Imports ================================================================
	var kendo = window.kendo,
	    Class = kendo.Class,
	    extend = $.extend,
	    Editor = kendo.ui.editor,
	    dom = Editor.Dom,
	    RangeUtils = Editor.RangeUtils,
	    EditorUtils = Editor.EditorUtils,
	    Command = Editor.Command,
	    ToolTemplate = Editor.ToolTemplate,
	    FormatTool = Editor.FormatTool,
	    BlockFormatFinder = Editor.BlockFormatFinder,
	    textNodes = RangeUtils.textNodes,
	    registerTool = Editor.EditorUtils.registerTool;

	var ListFormatFinder = BlockFormatFinder.extend({
	    init: function(tag) {
	        this.tag = tag;
	        var tags = this.tags = [tag == 'ul' ? 'ol' : 'ul', tag];

	        BlockFormatFinder.fn.init.call(this, [{ tags: tags}]);
	    },

	    isFormatted: function (nodes) {
	        var formatNodes = [];
	        var formatNode, i;

	        for (i = 0; i < nodes.length; i++) {
	            formatNode = this.findFormat(nodes[i]);

	            if (formatNode && dom.name(formatNode) == this.tag) {
	                formatNodes.push(formatNode);
	            }
	        }

	        if (formatNodes.length < 1) {
	            return false;
	        }

	        if (formatNodes.length != nodes.length) {
	            return false;
	        }

	        // check if sequential lists are selected
	        for (i = 0; i < formatNodes.length; i++) {
	            if (formatNodes[i].parentNode != formatNode.parentNode) {
	                break;
	            }

	            if (formatNodes[i] != formatNode) {
	                return false;
	            }
	        }

	        return true;
	    },

	    findSuitable: function (nodes) {
	        var candidate = this.findFormat(nodes[0]);

	        if (candidate && dom.name(candidate) == this.tag) {
	            return candidate;
	        }

	        return null;
	    }

	});

	var ListFormatter = Class.extend({
	    init: function(tag, unwrapTag) {
	        var that = this;
	        that.finder = new ListFormatFinder(tag);
	        that.tag = tag;
	        that.unwrapTag = unwrapTag;
	    },

	    isList: function(node) {
	        return dom.list(node);
	    },

	    immutables: function () {
	        return this.editor && !!this.editor.options.immutables;
	    },

	    wrap: function(list, nodes) {
	        var li = dom.create(list.ownerDocument, "li"),
	            i, node,
	            isImmutable = this.immutables() ? Editor.Immutables.immutable : $.noop;

	        for (i = 0; i < nodes.length; i++) {
	            node = nodes[i];

	            if (dom.is(node, 'li')) {
	                list.appendChild(node);
	                continue;
	            }

	            if (this.isList(node)) {
	                while (node.firstChild) {
	                    list.appendChild(node.firstChild);
	                }
	                continue;
	            }

	            if (dom.is(node, "td")) {
	                while (node.firstChild) {
	                    li.appendChild(node.firstChild);
	                }
	                list.appendChild(li);
	                node.appendChild(list);
	                list = list.cloneNode(false);
	                li = li.cloneNode(false);
	                continue;
	            }

	            li.appendChild(node);

	            if (dom.isBlock(node)) {
	                list.appendChild(li);
	                if (!isImmutable(node)) {
	                    dom.unwrap(node);
	                }
	                li = li.cloneNode(false);
	            }
	        }

	        if (li.firstChild) {
	            list.appendChild(li);
	        }
	    },

	    containsAny: function(parent, nodes) {
	        for (var i = 0; i < nodes.length; i++) {
	            if (dom.isAncestorOrSelf(parent, nodes[i])) {
	                return true;
	            }
	        }

	        return false;
	    },

	    suitable: function (candidate, nodes) {
	        if (candidate.className == "k-marker") {
	            var sibling = candidate.nextSibling;

	            if (sibling && dom.isBlock(sibling)) {
	                return false;
	            }

	            sibling = candidate.previousSibling;

	            if (sibling && dom.isBlock(sibling)) {
	                return false;
	            }
	        }

	        return this.containsAny(candidate, nodes) || dom.isInline(candidate) || candidate.nodeType == 3;
	    },

	    _parentLists: function(node) {
	        var editable = dom.closestEditable(node);

	        return $(node).parentsUntil(editable, "ul,ol");
	    },

	    split: function (range) {
	        var nodes = textNodes(range);
	        var start, end, parents;

	        if (nodes.length) {
	            start = dom.parentOfType(nodes[0], ['li']);
	            end = dom.parentOfType(nodes[nodes.length - 1], ['li']);
	            range.setStartBefore(start);
	            range.setEndAfter(end);

	            for (var i = 0, l = nodes.length; i < l; i++) {
	                var formatNode = this.finder.findFormat(nodes[i]);
	                if (formatNode) {
	                    parents = this._parentLists(formatNode);
	                    if (parents.length) {
	                        RangeUtils.split(range, parents.last()[0], true);
	                    } else {
	                        RangeUtils.split(range, formatNode, true);
	                    }
	                }
	            }
	        }
	    },

	    merge: function(tag, formatNode) {
	        var prev = formatNode.previousSibling, next;

	        while (prev && (prev.className == "k-marker" || (prev.nodeType == 3 && dom.isWhitespace(prev)))) {
	            prev = prev.previousSibling;
	        }

	        // merge with previous list
	        if (prev && dom.name(prev) == tag) {
	            while(formatNode.firstChild) {
	                prev.appendChild(formatNode.firstChild);
	            }
	            dom.remove(formatNode);
	            formatNode = prev;
	        }

	        next = formatNode.nextSibling;
	        while (next && (next.className == "k-marker" || (next.nodeType == 3 && dom.isWhitespace(next)))) {
	            next = next.nextSibling;
	        }

	        // merge with next list
	        if (next && dom.name(next) == tag) {
	            while(formatNode.lastChild) {
	                next.insertBefore(formatNode.lastChild, next.firstChild);
	            }
	            dom.remove(formatNode);
	        }
	    },

	    breakable: function(node) {
	        return (
	            node != node.ownerDocument.body &&
	            !/table|tbody|thead|tr|td/.test(dom.name(node)) &&
	            !node.attributes.contentEditable
	        );
	    },

	    applyOnSection: function (section, nodes) {
	        var tag = this.tag;
	        var commonAncestor = dom.closestSplittableParent(nodes);

	        var ancestors = [];

	        var formatNode = this.finder.findSuitable(nodes);

	        if (!formatNode) {
	            formatNode = new ListFormatFinder(tag == "ul" ? "ol" : "ul").findSuitable(nodes);
	        }

	        var childNodes;

	        if (/table|tbody|thead/.test(dom.name(commonAncestor))) {
	            childNodes = $.map(nodes, function(node) {
	                return dom.parentOfType(node, ["td"]);
	            });
	        } else {
	            childNodes = dom.significantChildNodes(commonAncestor);

	            if ($.grep(childNodes, dom.isBlock).length) {
	                childNodes = $.grep(childNodes, $.proxy(function(node) {
	                    return this.containsAny(node, nodes);
	                }, this));
	            }

	            if (!childNodes.length) {
	                childNodes = nodes;
	            }
	        }

	        function pushAncestor() {
	            ancestors.push(this);
	        }

	        for (var i = 0; i < childNodes.length; i++) {
	            var child = childNodes[i];
	            var suitable = (!formatNode || !dom.isAncestorOrSelf(formatNode, child)) && this.suitable(child, nodes);

	            if (!suitable) {
	                continue;
	            }

	            if (formatNode && this.isList(child)) {
	                // merging lists
	                $.each(child.children, pushAncestor);
	                dom.remove(child);
	            } else {
	                ancestors.push(child);
	            }
	        }

	        if (ancestors.length == childNodes.length && this.breakable(commonAncestor)) {
	            ancestors = [commonAncestor];
	        }

	        if (!formatNode) {
	            formatNode = dom.create(commonAncestor.ownerDocument, tag);
	            if(dom.isBlock(ancestors[0])) {
	                dom.mergeAttributes(ancestors[0], formatNode);
	            }
	            dom.insertBefore(formatNode, ancestors[0]);
	        }

	        this.wrap(formatNode, ancestors);

	        while (dom.isBom(formatNode.nextSibling)) {
	            dom.remove(formatNode.nextSibling);
	        }

	        if (!dom.is(formatNode, tag)) {
	            dom.changeTag(formatNode, tag);
	        }

	        this.merge(tag, formatNode);
	    },

	    apply: function (nodes) {
	        var i = 0,
	            sections = [],
	            lastSection,
	            lastNodes,
	            section,
	            node,
	            l = nodes.length,
	            immutableParent = this.immutables() ? Editor.Immutables.immutableParent : $.noop;

	        function addLastSection() {
	            if (lastSection) {
	                sections.push({
	                    section: lastSection,
	                    nodes: lastNodes
	                });
	            }
	        }

	        // split nodes into sections that need to be different lists
	        for (i = 0; i < l; i++) {
	            node = immutableParent(nodes[i]) || nodes[i];
	            section = dom.closestEditable(node, ["td","th","body"]);
	            if (!lastSection || section != lastSection) {
	                addLastSection();
	                lastNodes = [node];
	                lastSection = section;
	            } else {
	                lastNodes.push(node);
	            }
	        }

	        addLastSection();

	        for (i = 0; i < sections.length; i++) {
	            this.applyOnSection(sections[i].section, sections[i].nodes);
	        }
	    },

	    unwrap: function(ul) {
	        var fragment = ul.ownerDocument.createDocumentFragment(),
	            unwrapTag = this.unwrapTag,
	            parents,
	            li,
	            p,
	            child;

	        for (li = ul.firstChild; li; li = li.nextSibling) {
	            p = dom.create(ul.ownerDocument, unwrapTag || 'p');

	            while(li.firstChild) {
	                child = li.firstChild;

	                if (dom.isBlock(child)) {

	                    if (p.firstChild) {
	                        fragment.appendChild(p);
	                        p = dom.create(ul.ownerDocument, unwrapTag || 'p');
	                    }

	                    fragment.appendChild(child);
	                } else {
	                    p.appendChild(child);
	                }
	            }

	            if (p.firstChild) {
	                fragment.appendChild(p);
	            }
	        }

	        parents = this._parentLists(ul);

	        if (parents[0]) {
	            dom.insertAfter(fragment, parents.last()[0]);
	            parents.last().remove();
	        } else {
	            dom.insertAfter(fragment, ul);
	        }

	        dom.remove(ul);
	    },

	    remove: function (nodes) {
	        var formatNode;
	        for (var i = 0, l = nodes.length; i < l; i++) {
	            formatNode = this.finder.findFormat(nodes[i]);

	            if (formatNode) {
	                this.unwrap(formatNode);
	            }
	        }
	    },

	    toggle: function (range) {
	        var that = this,
	            nodes = textNodes(range),
	            ancestor = range.commonAncestorContainer;

	        if (!nodes.length) {
	            range.selectNodeContents(ancestor);
	            nodes = textNodes(range);
	            if (!nodes.length) {
	                var text = ancestor.ownerDocument.createTextNode("");
	                range.startContainer.appendChild(text);
	                nodes = [text];
	                range.selectNode(text.parentNode);
	            }
	        }
	        nodes = dom.filterBy(nodes, dom.htmlIndentSpace, true);
	        if (that.finder.isFormatted(nodes)) {
	            that.split(range);
	            that.remove(nodes);
	        } else {
	            that.apply(nodes);
	        }
	    }

	});

	var ListCommand = Command.extend({
	    init: function(options) {
	        options.formatter = new ListFormatter(options.tag);
	        Command.fn.init.call(this, options);
	    }
	});

	var ListTool = FormatTool.extend({
	    init: function(options) {
	        this.options = options;
	        FormatTool.fn.init.call(this, extend(options, {
	            finder: new ListFormatFinder(options.tag)
	        }));
	    },

	    command: function (commandArguments) {
	        return new ListCommand(extend(commandArguments, { tag: this.options.tag }));
	    }
	});

	extend(Editor, {
	    ListFormatFinder: ListFormatFinder,
	    ListFormatter: ListFormatter,
	    ListCommand: ListCommand,
	    ListTool: ListTool
	});

	registerTool("insertUnorderedList", new ListTool({tag:'ul', template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Insert unordered list"})}));
	registerTool("insertOrderedList", new ListTool({tag:'ol', template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Insert ordered list"})}));

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "ODdY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var ChangedPath = (function () {
    function ChangedPath(keepingColumns) {
        this.nodeIdsToBoolean = {};
        this.nodeIdsToColumns = {};
        this.keepingColumns = keepingColumns;
    }
    ChangedPath.prototype.addParentNode = function (rowNode, columns) {
        var _this = this;
        var pointer = rowNode;
        while (pointer) {
            // add this item to the path, all the way to parent
            this.nodeIdsToBoolean[pointer.id] = true;
            // if columns, add the columns in all the way to parent, merging
            // in any other columns that might be there already
            if (this.keepingColumns && columns) {
                if (!this.nodeIdsToColumns[pointer.id]) {
                    this.nodeIdsToColumns[pointer.id] = {};
                }
                columns.forEach(function (col) { return _this.nodeIdsToColumns[pointer.id][col.getId()] = true; });
            }
            pointer = pointer.parent;
        }
    };
    ChangedPath.prototype.isInPath = function (rowNode) {
        return this.nodeIdsToBoolean[rowNode.id];
    };
    ChangedPath.prototype.getValueColumnsForNode = function (rowNode, valueColumns) {
        if (!this.keepingColumns) {
            return valueColumns;
        }
        var colsForThisNode = this.nodeIdsToColumns[rowNode.id];
        var result = valueColumns.filter(function (col) { return colsForThisNode[col.getId()]; });
        return result;
    };
    ChangedPath.prototype.getNotValueColumnsForNode = function (rowNode, valueColumns) {
        if (!this.keepingColumns) {
            return null;
        }
        var colsForThisNode = this.nodeIdsToColumns[rowNode.id];
        var result = valueColumns.filter(function (col) { return !colsForThisNode[col.getId()]; });
        return result;
    };
    return ChangedPath;
}());
exports.ChangedPath = ChangedPath;


/***/ }),

/***/ "OHIl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: [String, Number],
        default: undefined
    },
    animation: {
        type: Object,
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    autoWidth: {
        type: Boolean,
        default: undefined
    },
    cascadeFrom: {
        type: String,
        default: undefined
    },
    cascadeFromField: {
        type: String,
        default: undefined
    },
    cascadeFromParentField: {
        type: String,
        default: undefined
    },
    clearButton: {
        type: Boolean,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    dataValueField: {
        type: String,
        default: undefined
    },
    delay: {
        type: Number,
        default: undefined
    },
    enable: {
        type: Boolean,
        default: undefined
    },
    enforceMinLength: {
        type: Boolean,
        default: undefined
    },
    filter: {
        type: String,
        default: undefined
    },
    fixedGroupTemplate: {
        type: [String, Function],
        default: undefined
    },
    footerTemplate: {
        type: [String, Function],
        default: undefined
    },
    groupTemplate: {
        type: [String, Function],
        default: undefined
    },
    height: {
        type: Number,
        default: undefined
    },
    highlightFirst: {
        type: Boolean,
        default: undefined
    },
    ignoreCase: {
        type: Boolean,
        default: undefined
    },
    index: {
        type: Number,
        default: undefined
    },
    minLength: {
        type: Number,
        default: undefined
    },
    noDataTemplate: {
        type: [String, Function],
        default: undefined
    },
    placeholder: {
        type: String,
        default: undefined
    },
    popup: {
        type: Object,
        default: undefined
    },
    suggest: {
        type: Boolean,
        default: undefined
    },
    syncValueAndText: {
        type: Boolean,
        default: undefined
    },
    headerTemplate: {
        type: [String, Function],
        default: undefined
    },
    template: {
        type: [String, Function],
        default: undefined
    },
    text: {
        type: String,
        default: undefined
    },
    value: {
        type: [String, Number],
        default: undefined
    },
    valuePrimitive: {
        type: Boolean,
        default: undefined
    },
    virtual: {
        type: [Boolean, Object],
        default: undefined
    },

    // Events
    change: {
        type: Function,
        default: undefined
    },
    close: {
        type: Function,
        default: undefined
    },
    dataBound: {
        type: Function,
        default: undefined
    },
    filtering: {
        type: Function,
        default: undefined
    },
    open: {
        type: Function,
        default: undefined
    },
    select: {
        type: Function,
        default: undefined
    },
    cascade: Function
};

/***/ }),

/***/ "OJgz":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(919);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 919:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(920) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($, undefined) {
	    // Imports ================================================================
	    var kendo = window.kendo,
	        getter = kendo.getter,

	        dataviz = kendo.dataviz,
	        deepExtend = kendo.deepExtend,

	        g = kendo.geometry,
	        d = kendo.drawing,

	        util = d.util,
	        defined = util.defined,

	        map = dataviz.map,
	        Location = map.Location,
	        ShapeLayer = map.layers.ShapeLayer;

	    // Implementation =========================================================
	    var BubbleLayer = ShapeLayer.extend({
	        options: {
	            autoBind: true,
	            locationField: "location",
	            valueField: "value",
	            minSize: 0,
	            maxSize: 100,
	            scale: "sqrt",
	            symbol: "circle"
	        },

	        _load: function(data) {
	            this.surface.clear();

	            if (data.length === 0) {
	                return;
	            }

	            var opt = this.options;
	            var getValue = getter(opt.valueField);

	            data = data.slice(0);
	            data.sort(function(a, b) {
	                return getValue(b) - getValue(a);
	            });

	            var scaleType = this._scaleType();
	            var scale;
	            for (var i = 0; i < data.length; i++) {
	                var dataItem = data[i];
	                var location = getter(opt.locationField)(dataItem);
	                var value = getter(opt.valueField)(dataItem);

	                if (defined(location) && defined(value)) {
	                    if (!scale) {
	                        scale = new scaleType([0, value], [opt.minSize, opt.maxSize]);
	                    }

	                    location = Location.create(location);
	                    var center = this.map.locationToView(location);
	                    var size = scale.map(value);

	                    var symbol = this._createSymbol({
	                        center: center,
	                        size: size,
	                        style: opt.style,
	                        dataItem: dataItem,
	                        location: location
	                    });

	                    symbol.dataItem = dataItem;
	                    symbol.location = location;
	                    symbol.value = value;

	                    this._drawSymbol(symbol);
	                }
	            }
	        },

	        _scaleType: function() {
	            var scale = this.options.scale;

	            if (kendo.isFunction(scale)) {
	                return scale;
	            }

	            return dataviz.map.scales[scale];
	        },

	        _createSymbol: function(args) {
	            var symbol = this.options.symbol;
	            if (!kendo.isFunction(symbol)) {
	                symbol = dataviz.map.symbols[symbol];
	            }

	            return symbol(args);
	        },

	        _drawSymbol: function(shape) {
	            var args = { layer: this, shape: shape };
	            var cancelled = this.map.trigger("shapeCreated", args);
	            if (!cancelled) {
	                this.surface.draw(shape);
	            }
	        }
	    });

	    var SqrtScale = kendo.Class.extend({
	        init: function(domain, range) {
	            this._domain = domain;
	            this._range = range;

	            var domainRange = Math.sqrt(domain[1]) - Math.sqrt(domain[0]);
	            var outputRange = range[1] - range[0];
	            this._ratio = outputRange / domainRange;
	        },

	        map: function(value) {
	            var rel = (Math.sqrt(value) - Math.sqrt(this._domain[0])) * this._ratio;
	            return this._range[0] + rel;
	        }
	    });

	    var Symbols = {
	        circle: function (args) {
	            var geo = new g.Circle(args.center, args.size / 2);
	            return new d.Circle(geo, args.style);
	        },

	        square: function(args) {
	            var path = new d.Path(args.style);
	            var halfSize = args.size / 2;
	            var center = args.center;

	            path.moveTo(center.x - halfSize, center.y - halfSize)
	                .lineTo(center.x + halfSize, center.y - halfSize)
	                .lineTo(center.x + halfSize, center.y + halfSize)
	                .lineTo(center.x - halfSize, center.y + halfSize)
	                .close();

	            return path;
	        }
	    };

	    // Exports ================================================================
	    deepExtend(dataviz, {
	        map: {
	            layers: {
	                bubble: BubbleLayer,
	                BubbleLayer: BubbleLayer
	            },
	            scales: {
	                sqrt: SqrtScale
	            },
	            symbols: Symbols
	        }
	    });

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 920:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("5Y6m");

/***/ })

/******/ });

/***/ }),

/***/ "ON07":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("EqjI");
var document = __webpack_require__("7KvD").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "OjAt":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var
    ArrayProto = Array.prototype,
    ObjProto = Object.prototype;

var
    slice = ArrayProto.slice,
    toString = ObjProto.toString;

var util = {};

util.isArray = function(obj) {
    return Array.isArray(obj);
};

var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
util.isArrayLike = function(obj) {
    if(typeof obj !== 'object' || !obj){
        return false;
    }
    var length = obj.length;
    return typeof length === 'number'
        && length % 1 === 0 && length >= 0 && length <= MAX_ARRAY_INDEX;
};

util.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
};


util.each = function(obj, callback) {
    var i,
        len;
    if (util.isArray(obj)) {
        for (i = 0, len = obj.length; i < len; i++) {
            if (callback(obj[i], i, obj) === false) {
                break;
            }
        }
    } else {
        for (i in obj) {
            if (callback(obj[i], i, obj) === false) {
                break;
            }
        }
    }
    return obj;
};

util.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    util['is' + name] = function(obj) {
        return toString.call(obj) === '[object ' + name + ']';
    };
});

util.toArray = function(list, start) {
  start = start || 0
  var i = list.length - start
  var ret = new Array(i)
  while (i--) {
    ret[i] = list[i + start]
  }
  return ret
}

util.toNumber = function(value) {
  if (typeof value !== 'string') {
    return value
  } else {
    var parsed = Number(value)
    return isNaN(parsed)
      ? value
      : parsed
  }
};

util.convertArray = function (value) {
    if (util.isArray(value)) {
      return value
    } else if (util.isPlainObject(value)) {
      // convert plain object to array.
      var keys = Object.keys(value)
      var i = keys.length
      var res = new Array(i)
      var key
      while (i--) {
        key = keys[i]
        res[i] = {
          $key: key,
          $value: value[key]
        }
      }
      return res
    } else {
      return value || []
    }
}

function multiIndex(obj,is) {  // obj,['1','2','3'] -> ((obj['1'])['2'])['3']
    return is.length ? multiIndex(obj[is[0]],is.slice(1)) : obj
}

util.getPath = function(obj,is) {   // obj,'1.2.3' -> multiIndex(obj,['1','2','3'])
    return multiIndex(obj,is.split('.'))
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 *
 * @param {*} obj
 * @return {Boolean}
 */

var toString = Object.prototype.toString
var OBJECT_STRING = '[object Object]'
util.isPlainObject = function (obj) {
  return toString.call(obj) === OBJECT_STRING
}

/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_index__ = __webpack_require__(0);


/**
 * Filter filter for arrays
 *
 * @param {Array} arr
 * @param {String} prop
 * @param {String|Number} search
 */

function filterBy (arr, search) {
  var arr = __WEBPACK_IMPORTED_MODULE_0__util_index__["a" /* default */].convertArray(arr)
  if (search == null) {
    return arr
  }
  if (typeof search === 'function') {
    return arr.filter(search)
  }
  // cast to lowercase string
  search = ('' + search).toLowerCase()
  var n = 2
  // extract and flatten keys
  var keys = Array.prototype.concat.apply([], __WEBPACK_IMPORTED_MODULE_0__util_index__["a" /* default */].toArray(arguments, n))
  var res = []
  var item, key, val, j
  for (var i = 0, l = arr.length; i < l; i++) {
    item = arr[i]
    val = (item && item.$value) || item
    j = keys.length
    if (j) {
      while (j--) {
        key = keys[j]
        if ((key === '$key' && contains(item.$key, search)) ||
            contains(__WEBPACK_IMPORTED_MODULE_0__util_index__["a" /* default */].getPath(val, key), search)) {
          res.push(item)
          break
        }
      }
    } else if (contains(item, search)) {
      res.push(item)
    }
  }
  return res
}

function contains (val, search) {
  var i
  if (__WEBPACK_IMPORTED_MODULE_0__util_index__["a" /* default */].isPlainObject(val)) {
    var keys = Object.keys(val)
    i = keys.length
    while (i--) {
      if (contains(val[keys[i]], search)) {
        return true
      }
    }
  } else if (__WEBPACK_IMPORTED_MODULE_0__util_index__["a" /* default */].isArray(val)) {
    i = val.length
    while (i--) {
      if (contains(val[i], search)) {
        return true
      }
    }
  } else if (val != null) {
    return val.toString().toLowerCase().indexOf(search) > -1
  }
}

/* harmony default export */ __webpack_exports__["a"] = (filterBy);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_index__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__string_index__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__other_index__ = __webpack_require__(13);





var Vue2Filters = {
  install: function(Vue) {
    __WEBPACK_IMPORTED_MODULE_0__util_index__["a" /* default */].each(__WEBPACK_IMPORTED_MODULE_1__string_index__, function(value, key) {
        Vue.filter(key, value)
    })

    __WEBPACK_IMPORTED_MODULE_0__util_index__["a" /* default */].each(__WEBPACK_IMPORTED_MODULE_3__other_index__, function(value, key) {
        Vue.filter(key, value)
    })

    Vue.mixin({
      methods: {
        limitBy: __WEBPACK_IMPORTED_MODULE_2__array_index__["c" /* limitBy */],
        filterBy: __WEBPACK_IMPORTED_MODULE_2__array_index__["a" /* filterBy */],
        orderBy: __WEBPACK_IMPORTED_MODULE_2__array_index__["d" /* orderBy */],
        find: __WEBPACK_IMPORTED_MODULE_2__array_index__["b" /* find */]
      }
    })
  }
}

/* harmony default export */ __webpack_exports__["default"] = (Vue2Filters);

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Vue2Filters);
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__capitalize__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uppercase__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lowercase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__placeholder__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__truncate__ = __webpack_require__(8);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "capitalize", function() { return __WEBPACK_IMPORTED_MODULE_0__capitalize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "uppercase", function() { return __WEBPACK_IMPORTED_MODULE_1__uppercase__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lowercase", function() { return __WEBPACK_IMPORTED_MODULE_2__lowercase__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "placeholder", function() { return __WEBPACK_IMPORTED_MODULE_3__placeholder__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "truncate", function() { return __WEBPACK_IMPORTED_MODULE_4__truncate__["a"]; });








/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 *  Converts a string into Capitalize
 * 
 * 'abc' => 'Abc'
 */

function capitalize (value) {
  if (!value && value !== 0) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
}

/* harmony default export */ __webpack_exports__["a"] = (capitalize);


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts a string to UPPERCASE
 * 
 * 'abc' => 'ABC'
 */

function uppercase (value) {
  return (value || value === 0)
    ? value.toString().toUpperCase()
    : ''
}

/* harmony default export */ __webpack_exports__["a"] = (uppercase);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts a string to lowercase
 * 
 * 'AbC' => 'abc'
 */

function lowercase (value) {
  return (value || value === 0)
    ? value.toString().toLowerCase()
    : ''
}

/* harmony default export */ __webpack_exports__["a"] = (lowercase);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 *  If the value is missing outputs the placeholder text
 * 
 * '' => {placeholder}
 * 'foo' => 'foo'
 */

function placeholder (input, property) {
  return ( input === undefined || input === '' || input === null ) ? property : input;
}

/* harmony default export */ __webpack_exports__["a"] = (placeholder);


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 *  Truncate at the given || default length
 *
 * 'lorem ipsum dolor' => 'lorem ipsum dol...'
 */

function truncate (value, length) {
  length = length || 15
  if( !value || typeof value !== 'string' ) return ''
  if( value.length <= length) return value
  return value.substring(0, length) + '...'
}

/* harmony default export */ __webpack_exports__["a"] = (truncate);


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__limitBy__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filterBy__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orderBy__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__find__ = __webpack_require__(12);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__limitBy__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__filterBy__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__orderBy__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__find__["a"]; });








/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_index__ = __webpack_require__(0);


/**
 * Limit filter for arrays
 *
 * @param {Number} n
 * @param {Number} offset (Decimal expected)
 */

function limitBy (arr, n, offset) {
  offset = offset ? parseInt(offset, 10) : 0
  n = __WEBPACK_IMPORTED_MODULE_0__util_index__["a" /* default */].toNumber(n)
  return typeof n === 'number'
    ? arr.slice(offset, offset + n)
    : arr
}

/* harmony default export */ __webpack_exports__["a"] = (limitBy);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_index__ = __webpack_require__(0);


/**
 * Filter filter for arrays
 *
 * @param {String|Array<String>|Function} ...sortKeys
 * @param {Number} [order]
 */

function orderBy (arr) {
  var comparator = null
  var sortKeys
  arr = __WEBPACK_IMPORTED_MODULE_0__util_index__["a" /* default */].convertArray(arr)

  // determine order (last argument)
  var args = __WEBPACK_IMPORTED_MODULE_0__util_index__["a" /* default */].toArray(arguments, 1)
  var order = args[args.length - 1]
  if (typeof order === 'number') {
    order = order < 0 ? -1 : 1
    args = args.length > 1 ? args.slice(0, -1) : args
  } else {
    order = 1
  }

  // determine sortKeys & comparator
  var firstArg = args[0]
  if (!firstArg) {
    return arr
  } else if (typeof firstArg === 'function') {
    // custom comparator
    comparator = function (a, b) {
      return firstArg(a, b) * order
    }
  } else {
    // string keys. flatten first
    sortKeys = Array.prototype.concat.apply([], args)
    comparator = function (a, b, i) {
      i = i || 0
      return i >= sortKeys.length - 1
        ? baseCompare(a, b, i)
        : baseCompare(a, b, i) || comparator(a, b, i + 1)
    }
  }

  function baseCompare (a, b, sortKeyIndex) {
    var sortKey = sortKeys[sortKeyIndex]
    if (sortKey) {
      if (sortKey !== '$key') {
        if (__WEBPACK_IMPORTED_MODULE_0__util_index__["a" /* default */].isObject(a) && '$value' in a) a = a.$value
        if (__WEBPACK_IMPORTED_MODULE_0__util_index__["a" /* default */].isObject(b) && '$value' in b) b = b.$value
      }
      a = __WEBPACK_IMPORTED_MODULE_0__util_index__["a" /* default */].isObject(a) ? __WEBPACK_IMPORTED_MODULE_0__util_index__["a" /* default */].getPath(a, sortKey) : a
      b = __WEBPACK_IMPORTED_MODULE_0__util_index__["a" /* default */].isObject(b) ? __WEBPACK_IMPORTED_MODULE_0__util_index__["a" /* default */].getPath(b, sortKey) : b
    }
    return a === b ? 0 : a > b ? order : -order
  }

  // sort on a copy to avoid mutating original array
  return arr.slice().sort(comparator)
}

/* harmony default export */ __webpack_exports__["a"] = (orderBy);

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filterBy__ = __webpack_require__(1);


/**
 * Get first matching element from a filtered array
 *
 * @param {Array} arr
 * @param {String|Number} search
 * @returns {mixed}
 */
function find(arr, search) 
{
  var array = __WEBPACK_IMPORTED_MODULE_0__filterBy__["a" /* default */].apply(this, arguments);
  array.splice(1);
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (find);


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__currency__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pluralize__ = __webpack_require__(15);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "currency", function() { return __WEBPACK_IMPORTED_MODULE_0__currency__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pluralize", function() { return __WEBPACK_IMPORTED_MODULE_1__pluralize__["a"]; });






/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 
 * 12345 => $12,345.00
 *
 * @param {String} sign
 * @param {Number} decimals Decimal places
 */

function currency (value, currency, decimals) {
  var digitsRE = /(\d{3})(?=\d)/g
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  currency = currency != null ? currency : '$'
  decimals = decimals != null ? decimals : 2
  var stringified = Math.abs(value).toFixed(decimals)
  var _int = decimals
    ? stringified.slice(0, -1 - decimals)
    : stringified
  var i = _int.length % 3
  var head = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
    : ''
  var _float = decimals
    ? stringified.slice(-1 - decimals)
    : ''
  var sign = value < 0 ? '-' : ''
  return sign + currency + head +
    _int.slice(i).replace(digitsRE, '$1,') +
    _float
}

/* harmony default export */ __webpack_exports__["a"] = (currency);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_index__ = __webpack_require__(0);


/**
 * 'item' => 'items'
 *
 * @params
 *  an array of strings corresponding to
 *  the single, double, triple ... forms of the word to
 *  be pluralized. When the number to be pluralized
 *  exceeds the length of the args, it will use the last
 *  entry in the array.
 *
 *  e.g. ['single', 'double', 'triple', 'multiple']
 */

function pluralize (value) {
  var args = __WEBPACK_IMPORTED_MODULE_0__util_index__["a" /* default */].toArray(arguments, 1)
  return args.length > 1
    ? (args[value % 10 - 1] || args[args.length - 1])
    : (args[0] + (value === 1 ? '' : 's'))
}

/* harmony default export */ __webpack_exports__["a"] = (pluralize);

/***/ })
/******/ ]);
});

/***/ }),

/***/ "OmDj":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1637);
	module.exports = __webpack_require__(1637);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 962:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Iu+f");

/***/ }),

/***/ 1637:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20), __webpack_require__(962) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	    "use strict";

	    // SAX-style XML parser ====================================================
	    var STRING = String.fromCharCode;

	    // XXX: add more here?
	    var ENTITIES = {
	        "amp"  : 38,
	        "lt"   : 60,
	        "gt"   : 62,
	        "quot" : 34,
	        "apos" : 39,
	        "nbsp" : 160
	    };

	    function CODE(str) {
	        var out = [];
	        for (var i = 0; i < str.length; ++i) {
	            out.push(str.charCodeAt(i));
	        }
	        return out;
	    }

	    function UCS2(out, code) {
	        if (code > 0xFFFF) {
	            code -= 0x10000;
	            out.push(code >>> 10 & 0x3FF | 0xD800,
	                     0xDC00 | code & 0x3FF);
	        } else {
	            out.push(code);
	        }
	    }

	    var START_CDATA     = CODE("<![CDATA[");
	    var END_CDATA       = CODE("]]>");
	    var END_COMMENT     = CODE("-->");
	    var START_COMMENT   = CODE("!--");
	    var END_SHORT_TAG   = CODE("/>");
	    var END_TAG         = CODE("</");
	    var END_DECLARATION = CODE("?>");
	    var QUESTION_MARK   = CODE("?");
	    var LESS_THAN       = CODE("<");
	    var GREATER_THAN    = CODE(">");
	    var SEMICOLON       = CODE(";");
	    var EQUAL           = CODE("=");
	    var AMPERSAND       = CODE("&");
	    var QUOTE           = CODE('"');
	    var APOSTROPHE      = CODE("'");
	    var SHARP           = CODE("#");
	    var LOWERCASE_X     = CODE("x");
	    var UPPERCASE_X     = CODE("X");

	    var EXIT = {};

	    function parse(data, callbacks) {
	        var index = 0;
	        var stack = [];
	        var object = {
	            is: function(selector) {
	                var i = stack.length, j = selector.length;
	                while (--i >= 0 && --j >= 0) {
	                    if (stack[i].$tag != selector[j] && selector[j] != "*") {
	                        return false;
	                    }
	                }
	                return j < 0 ? stack[stack.length - 1] : null;
	            },
	            exit: function() {
	                throw EXIT;
	            },
	            stack: stack
	        };

	        function readChar(body) {
	            var code = data[index++];
	            if (!(code & 0xF0 ^ 0xF0)) {// 4 bytes
	                UCS2(body,
	                     ((code & 0x03) << 18) |
	                     ((data[index++] & 0x3F) << 12) |
	                     ((data[index++] & 0x3F) << 6) |
	                     (data[index++] & 0x3F));
	            } else if (!(code & 0xE0 ^ 0xE0)) {// 3 bytes
	                UCS2(body,
	                     ((code & 0x0F) << 12) |
	                     ((data[index++] & 0x3F) << 6) |
	                     (data[index++] & 0x3F));
	            } else if (!(code & 0xC0 ^ 0xC0)) {// 2 bytes
	                UCS2(body,
	                     ((code & 0x1F) << 6) |
	                     (data[index++] & 0x3F));
	            } else {
	                body.push(code);
	            }
	        }

	        function croak(msg) {
	            throw new Error(msg + ", at " + index);
	        }

	        function readWhile(pred) {
	            var a = [];
	            while (index < data.length && pred(data[index])) {
	                a.push(data[index++]);
	            }
	            return a;
	        }

	        function readAsciiWhile(pred) {
	            return STRING.apply(0, readWhile(pred));
	        }

	        function skipWhitespace() {
	            readWhile(isWhitespace);
	        }

	        function eat(a) {
	            var save = index;
	            for (var i = 0; i < a.length; ++i) {
	                if (data[index++] != a[i]) {
	                    index = save;
	                    return false;
	                }
	            }
	            return a;
	        }

	        function skip(code) {
	            if (!eat(code)) {
	                croak("Expecting " + code.join(", "));
	            }
	        }

	        function isWhitespace(code) {
	            return code == 9 || code == 10 || code == 13 || code == 32;
	        }

	        function isDigit(code) {
	            return code >= 48 && code <= 57;
	        }

	        function isHexDigit(code) {
	            return (code >= 48 && code <= 57) ||
	                   ((code|=32) >= 97 && code <= 102); // a..f or A..F
	        }

	        function isNameStart(code) {
	            return code == 58 ||                      // :
	                   code == 95 ||                      // _
	                   ((code|=32) >= 97 && code <= 122); // a..z or A..Z
	        }

	        function isName(code) {
	            return code == 45 ||                      // -
	                   isDigit(code) ||
	                   isNameStart(code);
	        }

	        function xmlComment() {
	            var body = [];
	            while (index < data.length) {
	                if (eat(END_COMMENT)) {
	                    return call("comment", STRING.apply(0, body));
	                }
	                readChar(body);
	            }
	        }

	        function xmlTag() {
	            var name, attrs;
	            if (eat(QUESTION_MARK)) {
	                xmlDecl();
	            } else if (eat(START_COMMENT)) {
	                xmlComment();
	            } else {
	                name = xmlName();
	                attrs = xmlAttrs(name);
	                stack.push(attrs);
	                if (eat(END_SHORT_TAG)) {
	                    call("enter", name, attrs, true);
	                } else {
	                    skip(GREATER_THAN);
	                    call("enter", name, attrs);
	                    xmlContent(name);
	                    if (name != xmlName()) {
	                        croak("Bad closing tag");
	                    }
	                    call("leave", name, attrs);
	                    skipWhitespace();
	                    skip(GREATER_THAN);
	                }
	                stack.pop();
	            }
	        }

	        function xmlContent(name) {
	            var body = [];
	            while (index < data.length) {
	                if (eat(END_TAG)) {
	                    return body.length && call("text", STRING.apply(0, body));
	                } else if (eat(START_CDATA)) {
	                    while (index < data.length && !eat(END_CDATA)) {
	                        readChar(body);
	                    }
	                } else if (eat(LESS_THAN)) {
	                    if (body.length) {
	                        call("text", STRING.apply(0, body));
	                    }
	                    xmlTag();
	                    body = [];
	                } else if (eat(AMPERSAND)) {
	                    xmlEntity(body);
	                } else {
	                    readChar(body);
	                }
	            }
	            croak("Unclosed tag " + name);
	        }

	        function xmlName() {
	            if (!isNameStart(data[index])) {
	                croak("Expecting XML name");
	            }
	            return readAsciiWhile(isName);
	        }

	        function xmlString() {
	            var quote = eat(QUOTE) || eat(APOSTROPHE);
	            if (!quote) {
	                croak("Expecting string");
	            }
	            var body = [];
	            while (index < data.length) {
	                if (eat(quote)) {
	                    return STRING.apply(0, body);
	                } else if (eat(AMPERSAND)) {
	                    xmlEntity(body);
	                } else {
	                    readChar(body);
	                }
	            }
	            croak("Unfinished string");
	        }

	        function xmlEntity(body) {
	            var code;
	            if (eat(SHARP)) {
	                if (eat(LOWERCASE_X) || eat(UPPERCASE_X)) {
	                    code = parseInt(readAsciiWhile(isHexDigit), 16);
	                } else {
	                    code = parseInt(readAsciiWhile(isDigit), 10);
	                }
	                if (isNaN(code)) {
	                    croak("Bad numeric entity");
	                }
	            } else {
	                var name = xmlName();
	                code = ENTITIES[name];
	                if (code === undefined) {
	                    croak("Unknown entity " + name);
	                }
	            }
	            UCS2(body, code);
	            skip(SEMICOLON);
	        }

	        function xmlDecl() {
	            call("decl", xmlName(), xmlAttrs());
	            skip(END_DECLARATION);
	        }

	        function xmlAttrs(name) {
	            var map = { $tag: name };
	            while (index < data.length) {
	                skipWhitespace();
	                var code = data[index];
	                if (code == 63 || code == 62 || code == 47) { // ?, > or /
	                    break;
	                }
	                map[xmlName()] = ( skip(EQUAL), xmlString() );
	            }
	            return map;
	        }

	        function call(what, thing, arg1, arg2) {
	            var f = callbacks && callbacks[what];
	            if (f) {
	                f.call(object, thing, arg1, arg2);
	            }
	        }

	        // skip BOM
	        var tmp = [];
	        readChar(tmp);
	        if (tmp[0] != 65279) {
	            index = 0;
	        }

	        while (index < data.length) {
	            skipWhitespace();
	            skip(LESS_THAN);
	            xmlTag();
	            skipWhitespace();
	        }
	    }

	    // Exports ================================================================
	    kendo.util.parseXML = function parseXML() {
	        try {
	            return parse.apply(this, arguments);
	        } catch(ex) {
	            if (ex !== EXIT) {
	                throw ex;
	            }
	        }
	    };

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "OrSY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var constants_1 = __webpack_require__("ZZFX");
var utils_1 = __webpack_require__("IRr6");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var ImmutableService = (function () {
    function ImmutableService() {
    }
    ImmutableService.prototype.postConstruct = function () {
        if (this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_IN_MEMORY) {
            this.inMemoryRowModel = this.rowModel;
        }
    };
    // converts the setRowData() command to a transaction
    ImmutableService.prototype.createTransactionForRowData = function (data) {
        if (utils_1._.missing(this.inMemoryRowModel)) {
            console.error('ag-Grid: ImmutableService only works with InMemoryRowModel');
            return;
        }
        var getRowNodeIdFunc = this.gridOptionsWrapper.getRowNodeIdFunc();
        if (utils_1._.missing(getRowNodeIdFunc)) {
            console.error('ag-Grid: ImmutableService requires getRowNodeId() callback to be implemented, your row data need IDs!');
            return;
        }
        // convert the data into a transaction object by working out adds, removes and updates
        var transaction = {
            remove: [],
            update: [],
            add: []
        };
        var existingNodesMap = this.inMemoryRowModel.getCopyOfNodesMap();
        var orderMap = {};
        if (utils_1._.exists(data)) {
            // split all the new data in the following:
            // if new, push to 'add'
            // if update, push to 'update'
            // if not changed, do not include in the transaction
            data.forEach(function (dataItem, index) {
                var id = getRowNodeIdFunc(dataItem);
                var existingNode = existingNodesMap[id];
                orderMap[id] = index;
                if (existingNode) {
                    var dataHasChanged = existingNode.data !== dataItem;
                    if (dataHasChanged) {
                        transaction.update.push(dataItem);
                    }
                    // otherwise, if data not changed, we just don't include it anywhere, as it's not a delta
                    // remove from list, so we know the item is not to be removed
                    existingNodesMap[id] = undefined;
                }
                else {
                    transaction.add.push(dataItem);
                }
            });
        }
        // at this point, all rows that are left, should be removed
        utils_1._.iterateObject(existingNodesMap, function (id, rowNode) {
            if (rowNode) {
                transaction.remove.push(rowNode.data);
            }
        });
        return [transaction, orderMap];
    };
    __decorate([
        context_1.Autowired('rowModel'),
        __metadata("design:type", Object)
    ], ImmutableService.prototype, "rowModel", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], ImmutableService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ImmutableService.prototype, "postConstruct", null);
    ImmutableService = __decorate([
        context_1.Bean('immutableService')
    ], ImmutableService);
    return ImmutableService;
}());
exports.ImmutableService = ImmutableService;


/***/ }),

/***/ "Os2y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("7+uW");

var Vue = _interopRequireWildcard(_vue);

var _KendoMultiColumnComboBoxMixin = __webpack_require__("GwMd");

var _KendoMultiColumnComboBoxMixin2 = _interopRequireDefault(_KendoMultiColumnComboBoxMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-multicolumncombobox',
    mixins: [_KendoMultiColumnComboBoxMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('input', [this.$slots['kendo-datasource'], defaultSlot]);
    }
};

/***/ }),

/***/ "Owf0":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1173);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1173:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1049), __webpack_require__(1086)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function() {

	    var __meta__ = { // jshint ignore:line
	        id: "dialog",
	        name: "Dialog",
	        category: "web", // suite
	        description: "The dialog widget is a modal popup that brings information to the user.",
	        depends: ["core", "popup"] // dependencies
	    };

	    (function($, undefined) {
	        var kendo = window.kendo,
	            Widget = kendo.ui.Widget,
	            TabKeyTrap = kendo.ui.Popup.TabKeyTrap,
	            proxy = $.proxy,
	            template = kendo.template,
	            keys = kendo.keys,
	            isFunction = $.isFunction,
	            NS = "kendoWindow",
	            KDIALOG = ".k-dialog",
	            KWINDOW = ".k-window",
	            KICONCLOSE = ".k-dialog-close",
	            KCONTENTCLASS = "k-window-content k-dialog-content",
	            KCONTENTSELECTOR = ".k-window-content",
	            KSCROLL = "k-scroll",
	            KTITLELESS = "k-dialog-titleless",
	            KDIALOGTITLE = ".k-dialog-title",
	            KDIALOGTITLEBAR = KDIALOGTITLE + "bar",
	            KBUTTONGROUP = ".k-dialog-buttongroup",
	            KBUTTON = ".k-button",
	            KALERT = "k-alert",
	            KCONFIRM = "k-confirm",
	            KPROMPT = "k-prompt",
	            KTEXTBOX = ".k-textbox",
	            KOVERLAY = ".k-overlay",
	            VISIBLE = ":visible",
	            ZINDEX = "zIndex",
	            BODY = "body",
	            INITOPEN = "initOpen",
	            TOUCHSTART = "touchstart",
	            TOUCHMOVE = "touchmove",
	            OPEN = "open",
	            CLOSE = "close",
	            SHOW = "show",
	            HIDE = "hide",
	            SIZE = {
	                small: "k-window-sm",
	                medium: "k-window-md",
	                large: "k-window-lg"
	            },
	            HIDDEN = "hidden",
	            OVERFLOW = "overflow",
	            DATADOCOVERFLOWRULE = "original-overflow-rule",
	            DATAHTMLTAPYRULE = "tap-y",
	            messages = {
	                okText  : "OK",
	                cancel : "Cancel",
	                promptInput: "Input"
	            },
	            ceil = Math.ceil,
	            templates,
	            overlaySelector = ":not(link,meta,script,style)";

	        function defined(x) {
	            return (typeof x != "undefined");
	        }

	        function constrain(value, low, high) {
	            return Math.max(Math.min(parseInt(value, 10), high === Infinity ? high : parseInt(high, 10)), parseInt(low, 10));
	        }

	        function buttonKeyTrigger(e) {
	            return e.keyCode == keys.ENTER || e.keyCode == keys.SPACEBAR;
	        }

	        var DialogBase = Widget.extend({
	            init: function(element, options) {
	                var that = this;
	                Widget.fn.init.call(that, element, options);
	                that._init(that.element, that.options);
	                kendo.notify(that);
	            },

	            _init: function(element, options) {
	                var that = this,
	                    wrapper;

	                that._centerCallback = proxy(that._center, that);

	                that.appendTo = $(BODY);
	                if (!defined(options.visible) || options.visible === null) {
	                    options.visible = element.is(VISIBLE);
	                }

	                if (that.wrapperTemplate === undefined) {
	                    that.wrapperTemplate = templates.wrapper;
	                }

	                that._createDialog();
	                wrapper = that.wrapper = element.closest(KDIALOG);

	                if (options._defaultFocus === undefined) {
	                    that._defaultFocus = element[0];
	                }

	                that._tabindex(element);
	                that._dimensions();

	                this._tabKeyTrap = new TabKeyTrap(wrapper);

	                if (!that.options.visible) {
	                    that.wrapper.hide();
	                } else {
	                    that._triggerOpen();
	                }
	            },

	            setOptions: function(options) {
	                var that = this;
	                var sizeClass = that.options.size;

	                options = $.extend(that.options, options);

	                Widget.fn.setOptions.call(that, options);

	                if (options.title !== undefined) {
	                    that.title(options.title);
	                }

	                if (options.content) {
	                    kendo.destroy(that.element.children());
	                    that.element.html(options.content);
	                }

	                if (options.actions) {
	                    that.wrapper.children(KBUTTONGROUP).remove();
	                    that._createActionbar(that.wrapper);
	                }

	                that.wrapper.show();
	                that._closable(that.wrapper);

	                that.wrapper.removeClass(SIZE[sizeClass]);
	                that._dimensions();

	                if (!options.visible) {
	                    that.wrapper.hide();
	                } else {
	                    that._triggerOpen();
	                }

	                if (typeof options.modal !== "undefined") {
	                    var visible = that.options.visible !== false;
	                    that._enableDocumentScrolling();
	                    that._overlay(options.modal && visible);
	                }
	            },

	            _dimensions: function() {
	                var that = this,
	                    wrapper = that.wrapper,
	                    options = that.options,
	                    width = options.width,
	                    height = options.height,
	                    sizeClass = options.size,
	                    dimensions = ["minWidth", "minHeight", "maxWidth", "maxHeight"];

	                for (var i = 0; i < dimensions.length; i++) {
	                    var value = options[dimensions[i]];
	                    if (value && value != Infinity) {
	                        wrapper.css(dimensions[i], value);
	                    }
	                }

	                this._setElementMaxHeight();

	                if (width) {
	                    if (width.toString().indexOf("%") > 0) {
	                        wrapper.width(width);
	                    } else {
	                        wrapper.outerWidth(constrain(width, options.minWidth, options.maxWidth));
	                    }
	                }

	                if (height) {
	                    if (height.toString().indexOf("%") > 0) {
	                        wrapper.height(height);
	                    } else {
	                        wrapper.outerHeight(constrain(height, options.minHeight, options.maxHeight));
	                    }

	                    this._setElementHeight();
	                }

	                if (sizeClass && SIZE[sizeClass]) {
	                    wrapper.addClass(SIZE[sizeClass]);
	                }
	            },

	            _setElementMaxHeight: function() {
	                var that = this,
	                    element = that.element,
	                    maxHeight = that.options.maxHeight,
	                    elementMaxHeight;

	                if (maxHeight != Infinity) {
	                    elementMaxHeight = parseFloat(maxHeight, 10) - that._uiHeight();
	                    if (elementMaxHeight > 0) {
	                        element.css({
	                            maxHeight: ceil(elementMaxHeight) + "px"
	                        });
	                    }
	                }

	            },

	            _setElementHeight: function() {
	                var that = this,
	                    element = that.element,
	                    height = that.wrapper.outerHeight(true),
	                    elementHeight = parseFloat(height, 10) - that._uiHeight();

	                if (elementHeight < 0) {
	                    elementHeight = 0;
	                }

	                element.css({
	                    height: ceil(elementHeight) + "px"
	                });

	                this._applyScrollClassName(element);

	            },

	            _applyScrollClassName: function(element) {
	                    var hasScroll = element.get(0).scrollHeight > element.outerHeight();

	                    if (hasScroll){
	                        element.addClass(KSCROLL);
	                    } else {
	                        element.removeClass(KSCROLL);
	                    }
	            },

	            _uiHeight: function() {
	                var that = this,
	                    wrapper = that.wrapper,
	                    actionbar = wrapper.children(KBUTTONGROUP),
	                    actionbarHeight = actionbar[0] && actionbar[0].offsetHeight || 0,
	                    titlebar = wrapper.children(KDIALOGTITLEBAR),
	                    titlebarHeight = titlebar[0] && titlebar[0].offsetHeight || 0;

	                return actionbarHeight + titlebarHeight;
	            },

	            _overlay: function(visible) {
	                var overlay = this.appendTo.children(KOVERLAY),
	                    wrapper = this.wrapper;


	                if (!overlay.length) {
	                    overlay = $(templates.overlay);
	                }

	                overlay
	                    .insertBefore(wrapper[0])
	                    .toggle(visible)
	                    .css(ZINDEX, parseInt(wrapper.css(ZINDEX), 10) - 1);

	                if (visible) {
	                    this._waiAriaOverlay();
	                }
	                else {
	                    this._removeWaiAriaOverlay();
	                }

	                if (this.options.modal.preventScroll) {
	                    this._stopDocumentScrolling();
	                }

	                return overlay;
	            },

	            _waiAriaOverlay: function() {
	                var node = this.wrapper;

	                this._overlayedNodes = node.prevAll(overlaySelector).add(node.nextAll(overlaySelector))
	                    .each(function() {
	                        var jthis = $(this);
	                        jthis.data("ariaHidden", jthis.attr("aria-hidden"));
	                        jthis.attr("aria-hidden", "true");
	                    });
	            },

	            _removeWaiAriaOverlay: function() {
	                return this._overlayedNodes && this._overlayedNodes.each(function() {
	                    var node = $(this);
	                    var hiddenValue = node.data("ariaHidden");
	                    if (hiddenValue) {
	                        node.attr("aria-hidden", hiddenValue);
	                    }
	                    else {
	                        node.removeAttr("aria-hidden");
	                    }
	                });
	            },

	            _closeClick: function(e) {
	                e.preventDefault();
	                this.close(false);
	            },

	            _closeKeyHandler: function(e) {
	                if (buttonKeyTrigger(e) || e.keyCode == keys.ESC) {
	                    this.close(false);
	                }
	            },

	            _keydown: function(e) {
	                var that = this,
	                    options = that.options,
	                    keyCode = e.keyCode;

	                if (keyCode == keys.ESC && !that._closing && options.closable) {
	                    that.close(false);
	                }
	            },

	            _createDialog: function() {
	                var that = this,
	                    content = that.element,
	                    options = that.options,
	                    isRtl = kendo.support.isRtl(content),
	                    titlebar = $(templates.titlebar(options)),
	                    titleId = (content.id || kendo.guid()) + "_title",
	                    wrapper = $(that.wrapperTemplate(options));

	                wrapper.toggleClass("k-rtl", isRtl);

	                content.addClass(KCONTENTCLASS);
	                that.appendTo.append(wrapper);

	                if (options.title !== false) {
	                    wrapper.append(titlebar);
	                    titlebar.attr("id", titleId);
	                    wrapper.attr("aria-labelledby", titleId);
	                } else {
	                    wrapper.addClass(KTITLELESS);
	                }

	                that._closable(wrapper);

	                wrapper.append(content);

	                if (options.content) {
	                    kendo.destroy(content.children());
	                    content.html(options.content);
	                }

	                if (options.actions.length) {
	                    that._createActionbar(wrapper);
	                }
	            },

	            _closable: function (wrapper) {
	                var that = this;
	                var options = that.options;
	                var titlebar = wrapper.children(KDIALOGTITLEBAR);
	                var titlebarActions = titlebar.find(".k-window-actions");
	                var closeAction = titlebarActions.length ? titlebarActions.find(".k-dialog-close") : wrapper.find(".k-dialog-close");

	                closeAction.remove();

	                if (options.closable !== false) {
	                    if (options.title !== false && titlebarActions.length) {
	                        titlebarActions.append(templates.close(options));
	                    }
	                    else {
	                        wrapper.prepend(templates.close(options));
	                    }

	                    wrapper.autoApplyNS(NS);
	                    that.element.autoApplyNS(NS);

	                    wrapper.find(KICONCLOSE)
	                        .on("click", proxy(that._closeClick, that))
	                        .on("keydown", proxy(that._closeKeyHandler, that));

	                    that.element.on("keydown", proxy(that._keydown, that));
	                }
	            },

	            _createActionbar: function(wrapper) {
	                var isStretchedLayout = (this.options.buttonLayout === "stretched");
	                var buttonLayout = isStretchedLayout ? "stretched" : "normal";
	                var actionbar = $(templates.actionbar({ buttonLayout: buttonLayout }));

	                this._addButtons(actionbar);
	                wrapper.append(actionbar);
	            },

	            _addButtons: function(actionbar) {
	                var that = this,
	                    actionClick = proxy(that._actionClick, that),
	                    actionKeyHandler = proxy(that._actionKeyHandler, that),
	                    actions = that.options.actions,
	                    length = actions.length,
	                    action,
	                    text;

	                for (var i = 0; i < length; i++) {
	                    action = actions[i];
	                    text = that._mergeTextWithOptions(action);

	                    $(templates.action(action))
	                        .autoApplyNS(NS)
	                        .html(text)
	                        .appendTo(actionbar)
	                        .addClass(action.cssClass)
	                        .data("action", action.action)
	                        .on("click", actionClick)
	                        .on("keydown", actionKeyHandler);
	                }
	            },

	            _mergeTextWithOptions : function(action) {
	                var text = action.text;
	                return text ? template(text)(this.options) : "";
	            },

	            _tabindex: function(target) {
	                var that = this;
	                var wrapper = that.wrapper;
	                var closeBtn = wrapper.find(KICONCLOSE);
	                var actionButtons = wrapper.find(KBUTTONGROUP + " " + KBUTTON);

	                Widget.fn._tabindex.call(this, target);

	                var tabIndex = target.attr("tabindex");

	                closeBtn.attr("tabIndex", tabIndex);
	                actionButtons.attr("tabIndex", tabIndex);
	            },

	            _actionClick: function(e) {
	                if (this.wrapper.is(VISIBLE)) {
	                    this._runActionBtn(e.currentTarget);
	                }
	            },

	            _actionKeyHandler: function(e) {
	                if (buttonKeyTrigger(e)) {
	                    e.preventDefault();
	                    this._runActionBtn(e.currentTarget);
	                } else if (e.keyCode == keys.ESC) {
	                    this.close(false);
	                }
	            },

	            _runActionBtn: function(target) {
	                var that = this;
	                if (that._closing) {
	                    return;
	                }

	                var action = $(target).data("action"),
	                    preventClose = (isFunction(action) && action({ sender: that }) === false);

	                if (!preventClose) {
	                    that.close(false);
	                }
	            },

	            _triggerOpen: function() {
	                var that = this;
	                var options = that.options;
	                var wrapper = that.wrapper;

	                that.toFront();
	                that._triggerInitOpen();
	                that.trigger(OPEN);
	                if (options.modal) {
	                    that._overlay(wrapper.is(VISIBLE)).css({ opacity: 0.5 });
	                    that._focusDialog();
	                }
	            },

	            open: function() {
	                var that = this,
	                    wrapper = that.wrapper,
	                    showOptions = this._animationOptions(OPEN),
	                    options = that.options,
	                    overlay, otherModalsVisible;

	                this._triggerInitOpen();

	                if (!that.trigger(OPEN)) {
	                    if (that._closing) {
	                        wrapper.kendoStop(true, true);
	                    }

	                    that._closing = false;

	                    that.toFront();
	                    options.visible = true;
	                    if (options.modal) {
	                        otherModalsVisible = !!that._modals().length;
	                        overlay = that._overlay(otherModalsVisible);

	                        overlay.kendoStop(true, true);

	                        if (showOptions.duration && kendo.effects.Fade && !otherModalsVisible) {
	                            var overlayFx = kendo.fx(overlay).fadeIn();
	                            overlayFx.duration(showOptions.duration || 0);
	                            overlayFx.endValue(0.5);
	                            overlayFx.play();
	                        } else {
	                            overlay.css("opacity", 0.5);
	                        }

	                        overlay.show();
	                    }

	                    wrapper.show().kendoStop().kendoAnimate({
	                        effects: showOptions.effects,
	                        duration: showOptions.duration,
	                        complete: proxy(that._openAnimationEnd, that)
	                    });
	                    wrapper.show();

	                }

	                return that;
	            },

	            _animationOptions: function(id) {
	                var animation = this.options.animation;
	                var basicAnimation = {
	                    open: { effects: {} },
	                    close: { hide: true, effects: {} }
	                };

	                return animation && animation[id] || basicAnimation[id];
	            },

	            _openAnimationEnd: function() {
	                if (this.options.modal) {
	                    this._focusDialog();
	                }
	                this.trigger(SHOW);
	            },

	            _triggerInitOpen: function() {
	                if (!defined(this._initOpenTriggered)) {
	                    this._initOpenTriggered = true;
	                    this.trigger(INITOPEN);
	                }
	            },

	            toFront: function() {
	                var that = this,
	                    wrapper = that.wrapper,
	                    zIndex = +wrapper.css(ZINDEX),
	                    originalZIndex = zIndex;

	                that.center();

	                $(KWINDOW).each(function(i, element) {
	                    var windowObject = $(element),
	                        zIndexNew = windowObject.css(ZINDEX);

	                    if (!isNaN(zIndexNew)) {
	                        zIndex = Math.max(+zIndexNew, zIndex);
	                    }
	                });

	                if (!wrapper[0].style.zIndex || originalZIndex < zIndex) {
	                    wrapper.css(ZINDEX, zIndex + 2);
	                }

	                that.element.find("> .k-overlay").remove();
	                wrapper = null;

	                return that;
	            },

	            close: function(systemTriggered) {
	                if(!arguments.length) {
	                    systemTriggered = true;
	                }

	                this._close(systemTriggered);
	                this._stopCenterOnResize();
	                return this;
	            },

	            _close: function(systemTriggered) {
	                var that = this,
	                    wrapper = that.wrapper,
	                    options = that.options,
	                    showOptions = this._animationOptions("open"),
	                    hideOptions = this._animationOptions("close");

	                if (wrapper.is(VISIBLE) && !that.trigger(CLOSE, { userTriggered: !systemTriggered })) {
	                    if (that._closing) {
	                        return;
	                    }
	                    that._closing = true;

	                    options.visible = false;
	                    this._removeOverlay();

	                    wrapper.kendoStop().kendoAnimate({
	                        effects: hideOptions.effects || showOptions.effects,
	                        reverse: hideOptions.reverse === true,
	                        duration: hideOptions.duration,
	                        complete: proxy(this._closeAnimationEnd, this)
	                    });
	                }

	                return that;
	            },

	            center: function() {
	                this._center();
	                this._centerOnResize();
	            },

	            _center: function() {
	                var that = this,
	                    wrapper = that.wrapper,
	                    documentWindow = $(window),
	                    scrollTop = 0,
	                    scrollLeft = 0,
	                    newLeft = scrollLeft + Math.max(0, (documentWindow.width() - wrapper.width()) / 2),
	                    newTop = scrollTop + Math.max(0, (documentWindow.height() - wrapper.height() - parseInt(wrapper.css("paddingTop"), 10)) / 2);

	                wrapper.css({
	                    left: newLeft,
	                    top: newTop
	                });

	                return that;
	            },

	            _centerOnResize: function() {
	                if (this._trackResize) {
	                    return;
	                }

	                kendo.onResize(this._centerCallback);
	                this._trackResize = true;
	            },

	            _stopCenterOnResize: function() {
	                kendo.unbindResize(this._centerCallback);
	                this._trackResize = false;
	            },

	            _removeOverlay: function() {
	                var modals = this._modals();
	                var options = this.options;
	                var hideOverlay = options.modal && !modals.length;

	                if (hideOverlay) {
	                    this._overlay(false).remove();

	                    if (options.modal.preventScroll) {
	                        this._enableDocumentScrolling();
	                    }
	                } else if (modals.length) {
	                    this._object(modals.last())._overlay(true);

	                    if (options.modal.preventScroll) {
	                        this._stopDocumentScrolling();
	                    }
	                }
	            },

	            _stopDocumentScrolling: function(){
	                var that = this;

	                var $body = $("body");
	                that._storeOverflowRule($body);
	                $body.css(OVERFLOW, HIDDEN);

	                var $html = $("html");
	                var html = $html[0];
	                that._storeOverflowRule($html);
	                $html.css(OVERFLOW, HIDDEN);

	                // prevent touch due to bug in ios
	                if (kendo.support.mobileOS.ios) {
	                    html.addEventListener(TOUCHSTART, that._touchStart, { passive: false });
	                    html.addEventListener(TOUCHMOVE, that._touchMove, { passive: false });
	                }
	            },

	            _touchStart: function (e) {
	                $(this).data(DATAHTMLTAPYRULE, e.changedTouches[0].pageY);
	            },

	            _touchMove: function (e) {
	                var target = e.target;
	                var $target = $(e.target);
	                var upScroll = e.changedTouches[0].pageY - $(this).data(DATAHTMLTAPYRULE) > 0;
	                var preventYScroll = $target.is(KCONTENTSELECTOR) &&
	                    (upScroll && $target.scrollTop() === 0) ||
	                    (!upScroll && $target.scrollTop() === target.scrollHeight - target.clientHeight);
	                if (!$target.is(KCONTENTSELECTOR) || preventYScroll) {
	                    e.preventDefault();
	                }
	            },

	            _enableDocumentScrolling: function(){
	                var that = this;
	                var $body = $(document.body);
	                var $html = $("html");
	                var html = $html[0];

	                that._restoreOverflowRule($body);
	                that._restoreOverflowRule($html);

	                if (kendo.support.mobileOS.ios) {
	                    $html.removeData(DATAHTMLTAPYRULE);
	                    html.removeEventListener(TOUCHSTART, that._touchStart, { passive: false });
	                    html.removeEventListener(TOUCHMOVE, that._touchMove, { passive: false });
	                }
	            },

	            _storeOverflowRule: function($element){
	                if(this._isOverflowStored($element)){
	                    return;
	                }

	                var overflowRule = $element.get(0).style.overflow;

	                if(typeof overflowRule === "string"){
	                    $element.data(DATADOCOVERFLOWRULE, overflowRule);
	                }
	            },

	            _isOverflowStored: function ($element){
	                return typeof $element.data(DATADOCOVERFLOWRULE) === "string";
	            },

	            _restoreOverflowRule: function($element){
	                var overflowRule = $element.data(DATADOCOVERFLOWRULE);

	                if(overflowRule !== null && overflowRule !== undefined){
	                    $element.css(OVERFLOW, overflowRule);
	                    $element.removeData(DATADOCOVERFLOWRULE);
	                } else {
	                    $element.css(OVERFLOW, "");
	                }
	            },

	            _closeAnimationEnd: function() {
	                var that = this;

	                that._closing = false;
	                that.wrapper.hide().css("opacity", "");
	                that.trigger(HIDE);

	                if (that.options.modal) {
	                    var lastModal = that._object(that._modals().last());
	                    if (lastModal) {
	                        lastModal.toFront();
	                    }
	                }
	            },

	            _modals: function() {
	                var that = this;

	                var zStack = $(KWINDOW).filter(function() {
	                    var dom = $(this);
	                    var object = that._object(dom);
	                    var options = object && object.options;

	                    return options && options.modal && that.options.appendTo == options.appendTo && options.visible && dom.is(VISIBLE);
	                }).sort(function(a, b) {
	                    return +$(a).css("zIndex") - +$(b).css("zIndex");
	                });

	                that = null;

	                return zStack;
	            },

	            _object: function(element) {
	                var content = element.children(KCONTENTSELECTOR);
	                var widget = kendo.widgetInstance(content);

	                if (widget) {
	                    return widget;
	                }

	                return undefined;
	            },

	            destroy: function() {
	                var that = this;
	                that._destroy();

	                Widget.fn.destroy.call(that);

	                kendo.destroy(that.wrapper);

	                that.wrapper.remove();
	                that.wrapper = that.element = $();
	            },

	            _destroy: function() {
	                var that = this;
	                var ns = "." + NS;

	                that.wrapper.off(ns);
	                that.element.off(ns);
	                that.wrapper.find(KICONCLOSE + "," + KBUTTONGROUP + " > " + KBUTTON).off(ns);
	                that._stopCenterOnResize();
	            },

	            title: function(html) {
	                var that = this,
	                    wrapper = that.wrapper,
	                    options = that.options,
	                    titlebar = wrapper.children(KDIALOGTITLEBAR),
	                    title = titlebar.children(KDIALOGTITLE),
	                    encodedHtml = kendo.htmlEncode(html);

	                if (!arguments.length) {
	                    return title.html();
	                }

	                if (html === false) {
	                    titlebar.remove();
	                    wrapper.addClass(KTITLELESS);
	                } else {
	                    if (!titlebar.length) {
	                        titlebar = $(templates.titlebar(options)).prependTo(wrapper);
	                        title = titlebar.children(KDIALOGTITLE);
	                        wrapper.removeClass(KTITLELESS);
	                    }
	                    title.html(encodedHtml);
	                }

	                that.options.title = encodedHtml;

	                return that;
	            },

	            content: function(html, data) {
	                var that = this,
	                    content = that.wrapper.children(KCONTENTSELECTOR);

	                if (!defined(html)) {
	                    return content.html();
	                }

	                this.angular("cleanup", function(){
	                    return { elements: content.children() };
	                });

	                kendo.destroy(content.children());
	                content.html(html);

	                this.angular("compile", function(){
	                    var a = [];
	                    for (var i = content.length; --i >= 0;) {
	                        a.push({ dataItem: data });
	                    }
	                    return {
	                        elements: content.children(),
	                        data: a
	                    };
	                });

	                that.options.content = html;

	                return that;
	            },

	            _focusDialog: function() {
	                if (this._defaultFocus) {
	                    this._focus(this._defaultFocus);
	                }
	                this._tabKeyTrap.trap();
	            },

	            _focus: function(node) {
	                if (node) {
	                    node.focus();
	                }
	            },

	            events: [
	                INITOPEN,
	                OPEN,
	                CLOSE,
	                SHOW,
	                HIDE
	            ],

	            options: {
	                title: "",
	                buttonLayout: "stretched",
	                actions: [],
	                modal: true,
	                size: "auto",
	                width: null,
	                height: null,
	                minWidth: 0,
	                minHeight: 0,
	                maxWidth: Infinity,
	                maxHeight: Infinity,
	                content: null,
	                visible: null,
	                appendTo: BODY,
	                closable: true
	            }
	        });

	        var Dialog = DialogBase.extend({
	            options: {
	                name: "Dialog",
	                messages: {
	                    close: "Close"
	                }
	            }
	        });

	        kendo.ui.plugin(Dialog);

	        var PopupBox = DialogBase.extend({
	            _init: function(element, options) {
	                var that = this;

	                that.wrapperTemplate = templates.alertWrapper;
	                options._defaultFocus = null;
	                that._ensureContentId(element);

	                DialogBase.fn._init.call(that, element, options);

	                that.bind(HIDE, proxy(that.destroy, that));

	                that._ariaDescribedBy();
	                that._initFocus();
	            },

	            _ensureContentId: function(element) {
	                var node = $(element);
	                if(!node.attr("id")) {
	                    node.attr("id", kendo.guid() + "_k-popup");
	                }
	            },

	            _ariaDescribedBy: function() {
	                this.wrapper.attr("aria-describedby", this.element.attr("id"));
	            },

	            _initFocus: function() {
	                var o = this.options;

	                this._defaultFocus = this._chooseEntryFocus();
	                if (this._defaultFocus && o.visible && o.modal) {
	                    this._focusDialog();
	                }
	            },

	            _chooseEntryFocus: function() {
	                return this.wrapper.find(KBUTTONGROUP + " > " + KBUTTON)[0];
	            },

	            options: {
	                title: window.location.host,
	                closable: false,
	                messages: messages
	            }
	        });

	        var Alert = PopupBox.extend({
	            _init: function(element, options) {
	                var that = this;
	                PopupBox.fn._init.call(that, element, options);
	                that.wrapper.addClass(KALERT);
	            },

	            options: {
	                name: "Alert",
	                modal: true,
	                actions: [{
	                    text: "#: messages.okText #"
	                }]
	            }
	        });

	        kendo.ui.plugin(Alert);

	        var kendoAlert = function(text) {
	            return $(templates.alert).kendoAlert({ content: text }).data("kendoAlert").open();
	        };

	        var Confirm = PopupBox.extend({
	            _init: function(element, options) {
	                var that = this;
	                PopupBox.fn._init.call(that, element, options);
	                that.wrapper.addClass(KCONFIRM);
	                that.result = $.Deferred();
	            },

	            options: {
	                name: "Confirm",
	                modal: true,
	                actions: [{
	                    text: "#: messages.okText #",
	                    primary: true,
	                    action: function(e) {
	                        e.sender.result.resolve();
	                    }
	                }, {
	                    text: "#: messages.cancel #",
	                    action: function(e) {
	                        e.sender.result.reject();
	                    }
	                }]
	            }
	        });

	        kendo.ui.plugin(Confirm);

	        var kendoConfirm = function(text) {
	            var confirmDialog = $(templates.confirm).kendoConfirm({ content: text }).data("kendoConfirm").open();
	            return confirmDialog.result;
	        };

	        var Prompt = PopupBox.extend({
	            _init: function(element, options) {
	                var that = this;
	                PopupBox.fn._init.call(that, element, options);
	                that.wrapper.addClass(KPROMPT);
	                that._createPrompt();
	                that.result = $.Deferred();
	            },

	            _createPrompt: function() {
	                var value = this.options.value,
	                    promptContainer = $(templates.promptInputContainer(this.options)).insertAfter(this.element);

	                if (value) {
	                    promptContainer.children(KTEXTBOX).val(value);
	                }

	                this._defaultFocus = this._chooseEntryFocus();
	                this._focusDialog();
	            },

	            _chooseEntryFocus: function() {
	                return this.wrapper.find(KTEXTBOX)[0];
	            },

	            options: {
	                name: "Prompt",
	                modal: true,
	                value: "",
	                actions: [{
	                    text: "#: messages.okText #",
	                    primary: true,
	                    action: function(e) {
	                        var sender = e.sender,
	                            value = sender.wrapper.find(KTEXTBOX).val();

	                        sender.result.resolve(value);
	                    }
	                }, {
	                    text: "#: messages.cancel #",
	                    action: function(e) {
	                        var sender = e.sender,
	                            value = sender.wrapper.find(KTEXTBOX).val();

	                        e.sender.result.reject(value);
	                    }
	                }]
	            }
	        });

	        kendo.ui.plugin(Prompt);

	        var kendoPrompt = function(text, value) {
	            var promptDialog = $(templates.prompt).kendoPrompt({
	                content: text,
	                value: value
	            }).data("kendoPrompt").open();

	            return promptDialog.result;
	        };

	        templates = {
	            wrapper: template("<div class='k-widget k-window k-dialog' role='dialog'></div>"),
	            action: template("<button type='button' class='k-button# if (data.primary) { # k-primary# } role='button' #'></button>"),
	            titlebar: template(
	                "<div class='k-window-titlebar k-dialog-titlebar'>" +
	                    "<span class='k-window-title k-dialog-title'>#: title #</span>" +
	                    "<div class='k-window-actions k-dialog-actions'></div>" +
	                "</div>"
	            ),
	            close: template("<a role='button' href='\\#' class='k-button k-flat k-button-icon k-window-action k-dialog-action k-dialog-close' title='#: messages.close #' aria-label='#: messages.close #' tabindex='-1'><span class='k-icon k-i-close'></span></a>"),
	            actionbar: template("<div class='k-dialog-buttongroup k-dialog-button-layout-#: buttonLayout #' role='toolbar'></div>"),
	            overlay: "<div class='k-overlay'></div>",
	            alertWrapper: template("<div class='k-widget k-window k-dialog' role='alertdialog'></div>"),
	            alert: "<div></div>",
	            confirm: "<div></div>",
	            prompt: "<div></div>",
	            promptInputContainer: template("<div class='k-prompt-container'><input type='text' class='k-textbox' title='#: messages.promptInput #' aria-label='#: messages.promptInput #' /></div>")
	        };

	        kendo.alert = kendoAlert;
	        kendo.confirm = kendoConfirm;
	        kendo.prompt = kendoPrompt;

	    })(window.kendo.jQuery);

	    return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "Oxt1":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1628);
	module.exports = __webpack_require__(1628);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1628:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var Sorter = kendo.Class.extend({
	        init: function(grid, lists) {
	            this._grid = grid;
	            this._lists = lists;
	        },

	        indices: function(rangeRef, list, ascending, indices) {
	            var comparer = Sorter.ascendingComparer;

	            if (ascending === false) {
	                comparer = Sorter.descendingComparer;
	            }

	            return list.sortedIndices(this._grid.cellRefIndex(rangeRef.topLeft),
	                this._grid.cellRefIndex(rangeRef.bottomRight), comparer, indices);
	        },

	        sortBy: function(ref, column, list, ascending, indices) {
	            var sortedIndices = this.indices(ref.toColumn(column), list, ascending, indices);

	            for (var ci = ref.topLeft.col; ci <= ref.bottomRight.col; ci++) {
	                var start = this._grid.index(ref.topLeft.row, ci);
	                var end = this._grid.index(ref.bottomRight.row, ci);

	                for (var li = 0; li < this._lists.length; li++) {
	                    if (start < this._lists[li].lastRangeStart()) {
	                        this._lists[li].sort(start, end, sortedIndices);
	                    }
	                }
	            }

	            return sortedIndices;
	        }
	    });

	    Sorter.ascendingComparer = function(a, b) {
	        if (a === null && b === null) {
	            return 0;
	        }

	        if (a === null) {
	            return 1;
	        }

	        if (b === null) {
	            return -1;
	        }

	        var typeA = typeof a;
	        var typeB = typeof b;

	        if (typeA === "number") {
	            if (typeB === "number") {
	                return a - b;
	            } else {
	               return -1;
	            }
	        }

	        if (typeA === "string") {
	            switch (typeB) {
	                case "number":
	                    return 1;
	                case "string":
	                    return a.localeCompare(b);
	                default:
	                    return -1;
	            }
	        }

	        if (typeA === "boolean") {
	            switch (typeB) {
	                case "number":
	                    return 1;
	                case "string":
	                    return 1;
	                case "boolean":
	                    return a - b;
	                default:
	                    return -1;
	            }
	        }

	        if (a instanceof kendo.spreadsheet.calc.runtime.CalcError) {
	            if (b instanceof kendo.spreadsheet.calc.runtime.CalcError) {
	                return 0;
	            } else {
	                return 1;
	            }
	        }

	        throw new Error("Cannot compare " + a + " and " + b);
	    };

	    Sorter.descendingComparer = function(a, b) {
	        if (a === null && b === null) {
	            return 0;
	        }

	        if (a === null) {
	            return 1;
	        }

	        if (b === null) {
	            return -1;
	        }

	        return Sorter.ascendingComparer(b, a);
	    };

	    kendo.spreadsheet.Sorter = Sorter;
	})(kendo);
	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "P0KY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var context_1 = __webpack_require__("RQ1/");
var component_1 = __webpack_require__("pQ38");
var NoRowsOverlayComponent = (function (_super) {
    __extends(NoRowsOverlayComponent, _super);
    function NoRowsOverlayComponent() {
        return _super.call(this) || this;
    }
    NoRowsOverlayComponent.prototype.init = function (params) {
        var template = this.gridOptionsWrapper.getOverlayNoRowsTemplate() ?
            this.gridOptionsWrapper.getOverlayNoRowsTemplate() : NoRowsOverlayComponent.DEFAULT_NO_ROWS_TEMPLATE;
        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
        var localisedTemplate = template.replace('[NO_ROWS_TO_SHOW]', localeTextFunc('noRowsToShow', 'No Rows To Show'));
        this.setTemplate(localisedTemplate);
    };
    NoRowsOverlayComponent.DEFAULT_NO_ROWS_TEMPLATE = '<span class="ag-overlay-no-rows-center">[NO_ROWS_TO_SHOW]</span>';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], NoRowsOverlayComponent.prototype, "gridOptionsWrapper", void 0);
    return NoRowsOverlayComponent;
}(component_1.Component));
exports.NoRowsOverlayComponent = NoRowsOverlayComponent;


/***/ }),

/***/ "P886":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1574);
	module.exports = __webpack_require__(1574);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1574:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {
	    var Class = kendo.Class,
	        extend = $.extend,
	        isArray = $.isArray;

	    var SearchDOM = Class.extend({
	        init: function(options) {
	            var that = this;

	            that.options = extend({}, that.options, options);

	            that.processDom();
	        },

	        options: {
	            highlightClass: "k-search-highlight",
	            charClass: "k-text-char"
	        },

	        processDom: function () {
	            var that = this;

	            that.targets = isArray(that.options.target) ? that.options.target : [that.options.target];
	            that.textNodes = [];
	            that.charIndex = 0;
	            that.text = "";

	            that.targets.forEach(function (target) {
	                that.traverseToTextNode(target);
	            });

	            for (var i = 0; i < that.textNodes.length; i++) {
	                that.processTextNode(that.textNodes[i]);
	            }
	        },

	        traverseToTextNode: function (node) {
	            var that = this;

	            if(node.nodeType === 3) {
	                that.textNodes.push(node);
	            } else {
	                for (var i = 0; i < node.childNodes.length; i++) {
	                    that.traverseToTextNode(node.childNodes[i]);
	                }
	            }
	        },

	        processTextNode: function (node) {
	            var that = this;
	            var text = node.textContent;
	            var span;

	            that.text = that.text + text;

	            if(text.length > 0){
	                span = $(node).wrap("<span>").parent();
	                span.empty();
	                that.splitChars(span.get(0), text);
	                span.children().unwrap();
	            }
	        },

	        splitChars: function (span, text) {
	            var that = this;
	            var newHtml = "";

	            for (var i = 0; i < text.length; i++) {
	                newHtml = newHtml + "<span class='"+ that.options.charClass + "' " + kendo.attr("char-index") + "=" + that.charIndex + ">" + text[i] + "</span>";
	                that.charIndex++;
	            }

	            span.innerHTML = newHtml;
	        },

	        search: function (value, matchCase) {
	            var that = this;
	            var expression = new RegExp(value, !matchCase ? "gi" : "g");
	            var match;

	            that.matches = [];

	            that.resetMark();
	            that.resetHighlight();
	            that.resetMatchIndex();

	            if(value === "") {
	                return;
	            }

	            match = expression.exec(that.text);

	            while(match){
	                that.matches.push({
	                    startOffset: match.index,
	                    endOffset: match.index + match[0].length
	                });

	                match = expression.exec(that.text);
	            }

	            that.highlightAll();
	            that.mark();
	        },

	        highlightAll: function () {
	            var that = this;

	            that.matches.forEach(function (match, index) {
	                var start = match.startOffset;
	                var end = match.endOffset;

	                that.highlight(start, end, index + 1);
	            });
	        },

	        highlight: function (start, end, matchIndex) {
	            var that = this;

	            for (var i = start; i < end; i++) {
	                $(that.targets)
	                    .find("." + that.options.charClass + "[" + kendo.attr("char-index")  + "=" + i + "]")
	                    .addClass(that.options.highlightClass)
	                    .attr(kendo.attr("match-index"), matchIndex);
	            }
	        },

	        resetHighlight: function () {
	            var that = this;

	            $(that.targets)
	                .find("." + that.options.highlightClass)
	                .removeClass(that.options.highlightClass);
	        },

	        resetMatchIndex: function () {
	            var that = this;

	            $(that.targets)
	                .find("." + that.options.charClass + "[" + kendo.attr("match-index")  + "]")
	                .removeAttr(kendo.attr("match-index"));
	        },

	        mark: function () {
	            var that = this;

	            if(!that.currentIndex && that.currentIndex !== 0) {
	                that.currentIndex = 0;
	            } else if (that.currentIndex > that.matches.length) {
	                that.currentIndex = that.matches.length;
	            } else {
	                that.resetMark();
	            }

	            $(that.targets)
	                .find("." + that.options.charClass + "[" + kendo.attr("match-index")  + "=" + that.currentIndex + "]")
	                .wrapInner("<mark>");
	        },

	        resetMark: function () {
	            var that = this;
	            $(that.targets).find("mark").contents().unwrap();
	        },

	        nextMatch: function () {
	            var that = this;

	            that.currentIndex++;

	            if(that.currentIndex > that.matches.length) {
	                that.currentIndex = 1;
	            }

	            that.mark();
	        },

	        previousMatch: function () {
	            var that = this;

	            that.currentIndex--;

	            if(that.currentIndex < 1) {
	                that.currentIndex = that.matches.length;
	            }

	            that.mark();
	        },

	        getMarkedIndex: function () {
	            return this.matches.length ? this.currentIndex : 0;
	        },

	        getFirstMarked: function () {
	            return $(this.targets).find("mark").eq(0);
	        },

	        destroy: function () {
	            var that = this;

	            that.resetMark();
	            $(that.targets).children("span:not(." + that.options.charClass + ")").each(function(i, item){
	                $(item).text($(item).text());
	            });
	        }
	    });

	    extend(kendo.pdfviewer, {
	        SearchDOM: SearchDOM
	    });
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "PAC5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var columnGroup_1 = __webpack_require__("YX13");
var originalColumnGroup_1 = __webpack_require__("pOb1");
var context_1 = __webpack_require__("RQ1/");
var context_2 = __webpack_require__("RQ1/");
// takes in a list of columns, as specified by the column definitions, and returns column groups
var ColumnUtils = (function () {
    function ColumnUtils() {
    }
    ColumnUtils.prototype.calculateColInitialWidth = function (colDef) {
        if (!colDef.width) {
            // if no width defined in colDef, use default
            return this.gridOptionsWrapper.getColWidth();
        }
        else if (colDef.width < this.gridOptionsWrapper.getMinColWidth()) {
            // if width in col def to small, set to min width
            return this.gridOptionsWrapper.getMinColWidth();
        }
        else {
            // otherwise use the provided width
            return colDef.width;
        }
    };
    ColumnUtils.prototype.getOriginalPathForColumn = function (column, originalBalancedTree) {
        var result = [];
        var found = false;
        recursePath(originalBalancedTree, 0);
        // we should always find the path, but in case there is a bug somewhere, returning null
        // will make it fail rather than provide a 'hard to track down' bug
        if (found) {
            return result;
        }
        else {
            return null;
        }
        function recursePath(balancedColumnTree, dept) {
            for (var i = 0; i < balancedColumnTree.length; i++) {
                if (found) {
                    // quit the search, so 'result' is kept with the found result
                    return;
                }
                var node = balancedColumnTree[i];
                if (node instanceof originalColumnGroup_1.OriginalColumnGroup) {
                    var nextNode = node;
                    recursePath(nextNode.getChildren(), dept + 1);
                    result[dept] = node;
                }
                else {
                    if (node === column) {
                        found = true;
                    }
                }
            }
        }
    };
    /*    public getPathForColumn(column: Column, allDisplayedColumnGroups: ColumnGroupChild[]): ColumnGroup[] {
            let result: ColumnGroup[] = [];
            let found = false;
    
            recursePath(allDisplayedColumnGroups, 0);
    
            // we should always find the path, but in case there is a bug somewhere, returning null
            // will make it fail rather than provide a 'hard to track down' bug
            if (found) {
                return result;
            } else {
                return null;
            }
    
            function recursePath(balancedColumnTree: ColumnGroupChild[], dept: number): void {
    
                for (let i = 0; i<balancedColumnTree.length; i++) {
                    if (found) {
                        // quit the search, so 'result' is kept with the found result
                        return;
                    }
                    let node = balancedColumnTree[i];
                    if (node instanceof ColumnGroup) {
                        let nextNode = <ColumnGroup> node;
                        recursePath(nextNode.getChildren(), dept+1);
                        result[dept] = node;
                    } else {
                        if (node === column) {
                            found = true;
                        }
                    }
                }
            }
        }*/
    ColumnUtils.prototype.depthFirstOriginalTreeSearch = function (tree, callback) {
        var _this = this;
        if (!tree) {
            return;
        }
        tree.forEach(function (child) {
            if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
                _this.depthFirstOriginalTreeSearch(child.getChildren(), callback);
            }
            callback(child);
        });
    };
    ColumnUtils.prototype.depthFirstAllColumnTreeSearch = function (tree, callback) {
        var _this = this;
        if (!tree) {
            return;
        }
        tree.forEach(function (child) {
            if (child instanceof columnGroup_1.ColumnGroup) {
                _this.depthFirstAllColumnTreeSearch(child.getChildren(), callback);
            }
            callback(child);
        });
    };
    ColumnUtils.prototype.depthFirstDisplayedColumnTreeSearch = function (tree, callback) {
        var _this = this;
        if (!tree) {
            return;
        }
        tree.forEach(function (child) {
            if (child instanceof columnGroup_1.ColumnGroup) {
                _this.depthFirstDisplayedColumnTreeSearch(child.getDisplayedChildren(), callback);
            }
            callback(child);
        });
    };
    __decorate([
        context_2.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], ColumnUtils.prototype, "gridOptionsWrapper", void 0);
    ColumnUtils = __decorate([
        context_1.Bean('columnUtils')
    ], ColumnUtils);
    return ColumnUtils;
}());
exports.ColumnUtils = ColumnUtils;


/***/ }),

/***/ "PH8O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var RangeController = (function () {
    function RangeController() {
        this.bodyScrollListener = this.onBodyScroll.bind(this);
        this.dragging = false;
    }
    RangeController.prototype.init = function () {
        this.logger = this.loggerFactory.create('RangeController');
        this.eventService.addEventListener(main_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.clearSelection.bind(this));
        this.eventService.addEventListener(main_1.Events.EVENT_COLUMN_GROUP_OPENED, this.clearSelection.bind(this));
        this.eventService.addEventListener(main_1.Events.EVENT_COLUMN_MOVED, this.clearSelection.bind(this));
        this.eventService.addEventListener(main_1.Events.EVENT_COLUMN_PINNED, this.clearSelection.bind(this));
        this.eventService.addEventListener(main_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.clearSelection.bind(this));
        this.eventService.addEventListener(main_1.Events.EVENT_COLUMN_VISIBLE, this.clearSelection.bind(this));
    };
    RangeController.prototype.setRangeToCell = function (cell) {
        if (!this.gridOptionsWrapper.isEnableRangeSelection()) {
            return;
        }
        var columns = this.updateSelectedColumns(cell.column, cell.column);
        if (!columns) {
            return;
        }
        var gridCellDef = { rowIndex: cell.rowIndex, floating: cell.floating, column: cell.column };
        var newRange = {
            start: new main_1.GridCell(gridCellDef),
            end: new main_1.GridCell(gridCellDef),
            columns: columns
        };
        this.cellRanges = [];
        this.cellRanges.push(newRange);
        this.activeRange = null;
        this.dispatchChangedEvent(true, false);
    };
    RangeController.prototype.setRange = function (rangeSelection) {
        if (!this.gridOptionsWrapper.isEnableRangeSelection()) {
            return;
        }
        this.cellRanges = [];
        this.addRange(rangeSelection);
    };
    RangeController.prototype.addRange = function (rangeSelection) {
        if (!this.gridOptionsWrapper.isEnableRangeSelection()) {
            return;
        }
        var columnStart = this.columnController.getColumnWithValidation(rangeSelection.columnStart);
        var columnEnd = this.columnController.getPrimaryColumn(rangeSelection.columnEnd);
        if (!columnStart || !columnEnd) {
            return;
        }
        var columns = this.updateSelectedColumns(columnStart, columnEnd);
        if (!columns) {
            return;
        }
        var startGridCellDef = { column: columnStart, rowIndex: rangeSelection.rowStart, floating: rangeSelection.floatingStart };
        var endGridCellDef = { column: columnEnd, rowIndex: rangeSelection.rowEnd, floating: rangeSelection.floatingEnd };
        var newRange = {
            start: new main_1.GridCell(startGridCellDef),
            end: new main_1.GridCell(endGridCellDef),
            columns: columns
        };
        if (!this.cellRanges) {
            this.cellRanges = [];
        }
        this.cellRanges.push(newRange);
        this.dispatchChangedEvent(true, false);
    };
    RangeController.prototype.getCellRanges = function () {
        return this.cellRanges;
    };
    RangeController.prototype.isEmpty = function () {
        return main_1.Utils.missingOrEmpty(this.cellRanges);
    };
    RangeController.prototype.isMoreThanOneCell = function () {
        if (main_1.Utils.missingOrEmpty(this.cellRanges)) {
            return false;
        }
        else {
            if (this.cellRanges.length > 1) {
                return true;
            }
            else {
                var onlyRange = this.cellRanges[0];
                var onlyOneCellInRange = onlyRange.start.column === onlyRange.end.column &&
                    onlyRange.start.rowIndex === onlyRange.end.rowIndex;
                return !onlyOneCellInRange;
            }
        }
    };
    RangeController.prototype.clearSelection = function () {
        if (main_1.Utils.missing(this.cellRanges)) {
            return;
        }
        this.activeRange = null;
        this.cellRanges = null;
        this.dispatchChangedEvent(true, false);
    };
    // as the user is dragging outside of the panel, the div starts to scroll, which in turn
    // means we are selection more (or less) cells, but the mouse isn't moving, so we recalculate
    // the selection my mimicking a new mouse event
    RangeController.prototype.onBodyScroll = function () {
        this.onDragging(this.lastMouseEvent);
    };
    RangeController.prototype.isCellInAnyRange = function (cell) {
        return this.getCellRangeCount(cell) > 0;
    };
    RangeController.prototype.isCellInSpecificRange = function (cell, range) {
        var columnInRange = range.columns.indexOf(cell.column) >= 0;
        var rowInRange = this.isRowInRange(cell.rowIndex, cell.floating, range);
        return columnInRange && rowInRange;
    };
    // returns the number of ranges this cell is in
    RangeController.prototype.getCellRangeCount = function (cell) {
        var _this = this;
        if (main_1.Utils.missingOrEmpty(this.cellRanges)) {
            return 0;
        }
        var matchingCount = 0;
        this.cellRanges.forEach(function (cellRange) {
            if (_this.isCellInSpecificRange(cell, cellRange)) {
                matchingCount++;
            }
        });
        return matchingCount;
    };
    RangeController.prototype.isRowInRange = function (rowIndex, floating, cellRange) {
        var row1 = new main_1.GridRow(cellRange.start.rowIndex, cellRange.start.floating);
        var row2 = new main_1.GridRow(cellRange.end.rowIndex, cellRange.end.floating);
        var firstRow = row1.before(row2) ? row1 : row2;
        var lastRow = row1.before(row2) ? row2 : row1;
        var thisRow = new main_1.GridRow(rowIndex, floating);
        if (thisRow.equals(firstRow) || thisRow.equals(lastRow)) {
            return true;
        }
        else {
            var afterFirstRow = !thisRow.before(firstRow);
            var beforeLastRow = thisRow.before(lastRow);
            return afterFirstRow && beforeLastRow;
        }
    };
    RangeController.prototype.onDragStart = function (mouseEvent) {
        if (!this.gridOptionsWrapper.isEnableRangeSelection()) {
            return;
        }
        // ctrlKey for windows, metaKey for Apple
        var multiKeyPressed = mouseEvent.ctrlKey || mouseEvent.metaKey;
        var allowMulti = !this.gridOptionsWrapper.isSuppressMultiRangeSelection();
        var multiSelectKeyPressed = allowMulti ? multiKeyPressed : false;
        if (main_1.Utils.missing(this.cellRanges) || !multiSelectKeyPressed) {
            this.cellRanges = [];
        }
        var cell = this.mouseEventService.getGridCellForEvent(mouseEvent);
        if (main_1.Utils.missing(cell)) {
            // if drag wasn't on cell, then do nothing, including do not set dragging=true,
            // (which them means onDragging and onDragStop do nothing)
            return;
        }
        this.createNewActiveRange(cell);
        this.gridPanel.addScrollEventListener(this.bodyScrollListener);
        this.dragging = true;
        this.lastMouseEvent = mouseEvent;
        this.selectionChanged(false, true);
    };
    RangeController.prototype.createNewActiveRange = function (cell) {
        var gridCellDef = { column: cell.column, rowIndex: cell.rowIndex, floating: cell.floating };
        this.activeRange = {
            start: new main_1.GridCell(gridCellDef),
            end: new main_1.GridCell(gridCellDef),
            columns: [cell.column]
        };
        this.cellRanges.push(this.activeRange);
    };
    RangeController.prototype.selectionChanged = function (finished, started) {
        this.activeRange.columns = this.updateSelectedColumns(this.activeRange.start.column, this.activeRange.end.column);
        this.dispatchChangedEvent(finished, started);
    };
    RangeController.prototype.dispatchChangedEvent = function (finished, started) {
        var event = {
            type: main_1.Events.EVENT_RANGE_SELECTION_CHANGED,
            api: this.gridApi,
            columnApi: this.columnApi,
            finished: finished,
            started: started
        };
        this.eventService.dispatchEvent(event);
    };
    RangeController.prototype.onDragStop = function () {
        if (!this.dragging) {
            return;
        }
        this.gridPanel.removeScrollEventListener(this.bodyScrollListener);
        this.lastMouseEvent = null;
        this.dragging = false;
        this.dispatchChangedEvent(true, false);
    };
    RangeController.prototype.onDragging = function (mouseEvent) {
        if (!this.dragging || !this.activeRange) {
            return;
        }
        this.lastMouseEvent = mouseEvent;
        var cell = this.mouseEventService.getGridCellForEvent(mouseEvent);
        if (main_1.Utils.missing(cell)) {
            return;
        }
        var columnChanged = false;
        if (cell.column !== this.activeRange.end.column) {
            this.activeRange.end.column = cell.column;
            columnChanged = true;
        }
        var rowChanged = false;
        if (cell.rowIndex !== this.activeRange.end.rowIndex || cell.floating !== this.activeRange.end.floating) {
            this.activeRange.end.rowIndex = cell.rowIndex;
            this.activeRange.end.floating = cell.floating;
            rowChanged = true;
        }
        if (columnChanged || rowChanged) {
            this.selectionChanged(false, false);
        }
    };
    RangeController.prototype.updateSelectedColumns = function (columnFrom, columnTo) {
        var allColumns = this.columnController.getAllDisplayedColumns();
        var fromIndex = allColumns.indexOf(columnFrom);
        var toIndex = allColumns.indexOf(columnTo);
        if (fromIndex < 0) {
            console.log('ag-Grid: column ' + columnFrom.getId() + ' is not visible');
            return null;
        }
        if (toIndex < 0) {
            console.log('ag-Grid: column ' + columnTo.getId() + ' is not visible');
            return null;
        }
        var firstIndex = Math.min(fromIndex, toIndex);
        var lastIndex = Math.max(fromIndex, toIndex);
        var columns = [];
        for (var i = firstIndex; i <= lastIndex; i++) {
            columns.push(allColumns[i]);
        }
        return columns;
    };
    __decorate([
        main_1.Autowired('loggerFactory'),
        __metadata("design:type", main_1.LoggerFactory)
    ], RangeController.prototype, "loggerFactory", void 0);
    __decorate([
        main_1.Autowired('gridPanel'),
        __metadata("design:type", main_1.GridPanel)
    ], RangeController.prototype, "gridPanel", void 0);
    __decorate([
        main_1.Autowired('rowModel'),
        __metadata("design:type", Object)
    ], RangeController.prototype, "rowModel", void 0);
    __decorate([
        main_1.Autowired('eventService'),
        __metadata("design:type", main_1.EventService)
    ], RangeController.prototype, "eventService", void 0);
    __decorate([
        main_1.Autowired('columnController'),
        __metadata("design:type", main_1.ColumnController)
    ], RangeController.prototype, "columnController", void 0);
    __decorate([
        main_1.Autowired('rowRenderer'),
        __metadata("design:type", main_1.RowRenderer)
    ], RangeController.prototype, "rowRenderer", void 0);
    __decorate([
        main_1.Autowired('focusedCellController'),
        __metadata("design:type", main_1.FocusedCellController)
    ], RangeController.prototype, "focusedCellController", void 0);
    __decorate([
        main_1.Autowired('mouseEventService'),
        __metadata("design:type", main_1.MouseEventService)
    ], RangeController.prototype, "mouseEventService", void 0);
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], RangeController.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        main_1.Autowired('columnApi'),
        __metadata("design:type", main_1.ColumnApi)
    ], RangeController.prototype, "columnApi", void 0);
    __decorate([
        main_1.Autowired('gridApi'),
        __metadata("design:type", main_1.GridApi)
    ], RangeController.prototype, "gridApi", void 0);
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RangeController.prototype, "init", null);
    RangeController = __decorate([
        main_1.Bean('rangeController')
    ], RangeController);
    return RangeController;
}());
exports.RangeController = RangeController;


/***/ }),

/***/ "PIXw":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1366);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1054:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CRfZ");

/***/ }),

/***/ 1056:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("TC33");

/***/ }),

/***/ 1191:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1Z35");

/***/ }),

/***/ 1241:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Owf0");

/***/ }),

/***/ 1249:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("9fcU");

/***/ }),

/***/ 1252:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("HQQe");

/***/ }),

/***/ 1257:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("rbj2");

/***/ }),

/***/ 1262:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("EDhZ");

/***/ }),

/***/ 1276:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7IF8");

/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1054), __webpack_require__(1249), __webpack_require__(1056), __webpack_require__(1191), __webpack_require__(1262), __webpack_require__(1368), __webpack_require__(1369), __webpack_require__(1367), __webpack_require__(1370), __webpack_require__(1371), __webpack_require__(1372), __webpack_require__(1241), __webpack_require__(1276), __webpack_require__(1257), __webpack_require__(1252) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "scheduler",
	    name: "Scheduler",
	    category: "web",
	    description: "The Scheduler is an event calendar.",
	    depends: [ "dropdownlist", "editable", "multiselect", "window", "datepicker", "datetimepicker", "scheduler.recurrence", "scheduler.view" ],
	    features: [ {
	        id: "scheduler-dayview",
	        name: "Scheduler Day View",
	        description: "Scheduler Day View",
	        depends: [ "scheduler.dayview" ]
	    }, {
	        id: "scheduler-agendaview",
	        name: "Scheduler Agenda View",
	        description: "Scheduler Agenda View",
	        depends: [ "scheduler.agendaview" ]
	    }, {
	        id: "scheduler-monthview",
	        name: "Scheduler Month View",
	        description: "Scheduler Month View",
	        depends: [ "scheduler.monthview" ]
	    }, {
	        id: "scheduler-timelineview",
	        name: "Scheduler Timeline View",
	        description: "Scheduler Timeline View",
	        depends: [ "scheduler.timelineview" ]
	    }, {
	        id: "scheduler-mobile",
	        name: "Scheduler adaptive rendering",
	        description: "Support for adaptive rendering",
	        depends: [ "dialog", "pane", "switch" ]
	    }, {
	        id: "scheduler-pdf-export",
	        name: "PDF export",
	        description: "Export the scheduler events as PDF",
	        depends: [ "pdf", "drawing" ]
	    }, {
	        id: "scheduler-timezones",
	        name: "Timezones",
	        description: "Allow selecting timezones different than Etc/UTC",
	        depends: [ "timezones" ]
	    }]
	};

	/*jshint eqnull: true */
	(function($, undefined) {
	    var kendo = window.kendo,
	        date = kendo.date,
	        MS_PER_DAY = date.MS_PER_DAY,
	        getDate = date.getDate,
	        getMilliseconds = kendo.date.getMilliseconds,
	        recurrence = kendo.recurrence,
	        keys = $.extend({F10: 121}, kendo.keys),
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        DataBoundWidget = ui.DataBoundWidget,
	        STRING = "string",
	        Popup = ui.Popup,
	        Calendar = ui.Calendar,
	        DataSource = kendo.data.DataSource,
	        isPlainObject = $.isPlainObject,
	        extend = $.extend,
	        proxy = $.proxy,
	        toString = Object.prototype.toString,
	        isArray = $.isArray,
	        NS = ".kendoScheduler",
	        CLICK = "click",
	        MOUSEDOWN = "mousedown",
	        TOUCHSTART = kendo.support.pointers ? "pointerdown" : "touchstart",
	        TOUCHMOVE = kendo.support.pointers ? "pointermove" : "touchmove",
	        TOUCHEND = kendo.support.pointers ? "pointerup" : "touchend",
	        MOUSEMOVE = kendo.support.mousemove,
	        CHANGE = "change",
	        PROGRESS = "progress",
	        ERROR = "error",
	        CANCEL = "cancel",
	        REMOVE = "remove",
	        RESET = "resetSeries",
	        SAVE = "save",
	        ADD = "add",
	        EDIT = "edit",
	        FOCUSEDSTATE = "k-state-focused",
	        EXPANDEDSTATE = "k-state-expanded",
	        VIEWSSELECTOR = ".k-scheduler-views",
	        INVERSECOLORCLASS = "k-event-inverse",
	        valueStartEndBoundRegex = /(?:value:start|value:end)(?:,|$)/,
	        TODAY = getDate(new Date()),
	        EXCEPTION_SEPARATOR = ",",
	        OLD_EXCEPTION_SEPARATOR_REGEXP = /\;/g,
	        RECURRENCE_EXCEPTION = "recurrenceException",
	        DELETECONFIRM = "Are you sure you want to delete this event?",
	        DELETERECURRING = "Do you want to delete only this event occurrence or the whole series?",
	        EDITRECURRING = "Do you want to edit only this event occurrence or the whole series?",
	        DELETERECURRINGCONFIRM = "Are you sure you want to delete this event occurrence?",
	        RESETSERIESCONFIRM = "Are you sure you want to reset the whole series?",
	        DELETESERIESCONFIRM = "Are you sure you want to delete the whole series?",
	        COMMANDBUTTONTMPL = '<button type="button" class="k-button #=className#" #=attr#><span class="k-button-text">#=text#</span></button>',
	        VIEWS_DROPDOWN_TEMPLATE = kendo.template('' +
	            '<select class="k-dropdown k-views-dropdown">' +
	                '#for (var view in views) {#' +
	                    '<option value="#= view #">${views[view].title}</option>' +
	                '#}#'  +
	            '</select>'
	        ),
	        TOOLBARTEMPLATE = kendo.template('' +
	            '<div class="k-scheduler-toolbar k-toolbar">' +
	                '# if (pdf) { #' +
	                    '<button class="k-button k-pdf"><span class="k-icon k-i-file-pdf"></span><span class="k-button-text">${messages.pdf}</span></button>' +
	                '# } #' +
	                '<span class="k-scheduler-navigation k-button-group">' +
	                    '<button class="k-button k-nav-today" title="${messages.today}"><span class="k-button-text">${messages.today}</span></button>' +
	                    '<button class="k-button k-button-icon k-icon-button k-nav-prev" title="${messages.previous}" aria-label="${messages.previous}"><span class="k-icon k-i-arrow-60-left"></span></button>' +
	                    '<button class="k-button k-button-icon k-icon-button k-nav-next" title="${messages.next}" aria-label="${messages.next}"><span class="k-icon k-i-arrow-60-right"></span></button>' +
	                '</span>' +
	                '<a role="button" href="\\#" class="k-nav-current">' +
	                    '<span class="k-icon k-i-calendar"></span>' +
	                    '<span class="k-sm-date-format" data-#=ns#bind="text: formattedShortDate"></span>' +
	                    '<span class="k-lg-date-format" data-#=ns#bind="text: formattedDate"></span>' +
	                '</a>' +
	                '<span class="k-spacer k-toolbar-spacer"></span>' +
	                '# if (search) { #' +
	                    '<span class="k-scheduler-search k-textbox">' +
	                        '<input autocomplete="off" placeholder="Search..." title="Search..." class="k-input k-scheduler-search-input" />' +
	                        '<span class="k-input-icon"><span class="k-icon k-i-search"></span></span>' +
	                    '</span>' +
	                '# } #' +
	                '# if (viewsCount === 1) { #' +
	                    '<a role="button" data-#=ns#name="#=view#" href="\\#" class="k-button k-button-icon k-icon-button k-scheduler-refresh">' +
	                        '<span class="k-icon k-i-reload"></span>' +
	                    '</a>' +
	                '# } else { #' +
	                    '<span class="k-scheduler-views-wrapper">' +
	                        '<span class="k-scheduler-views k-button-group">' +
	                            '# for (var view in views) { #' +
	                                '<button type="button" class="k-button k-view-#= view.toLowerCase() #" data-#=ns#name="#=view#">${views[view].title}</button>' +
	                            '# } #'  +
	                        '</span>' +
	                    '</span>' +
	                '# } #' +
	            '</div>'),
	        MOBILETOOLBARTEMPLATE = kendo.template('<div class="k-scheduler-toolbar k-toolbar">' +
	            '<span class="k-scheduler-tools k-button-group">' +
	                '# if (pdf) { #' +
	                    '<button type="button" class="k-button k-icon-button k-button-icon k-pdf"><span class="k-icon k-i-file-pdf"></span></button>' +
	                '# } #' +
	                '<button type="button" class="k-button k-icon-button k-button-icon k-nav-calendar"><span class="k-icon k-i-calendar"></span></button>' +
	                "# if (editable) { #" +
	                    '<button type="button" class="k-button k-icon-button k-button-icon k-create-event"><span class="k-icon k-i-plus"></span></button>' +
	                "# } #" +
	            '</span>' +
	            '<span class="k-spacer k-toolbar-spacer"></span>' +
	            '# if (search) { #' +
	                '<span class="k-scheduler-search k-textbox">' +
	                    '<input autocomplete="off" placeholder="Search..." title="Search..." class="k-scheduler-search-input" />' +
	                    '<span class="k-input-icon"><span class="k-icon k-i-search"></span></span>' +
	                '</span>' +
	            '# } #' +
	            '#if(viewsCount === 1){#' +
	                '<a role="button" data-#=ns#name="#=view#" href="\\#" class="k-button k-button-icon k-icon-button k-scheduler-refresh">' +
	                    '<span class="k-icon k-i-reload"></span>' +
	                '</a>' +
	            '#} else {#' +
	                '<select class="k-dropdown k-scheduler-mobile-views">' +
	                    '#for(var view in views){#' +
	                        '<option class="k-view-#= view.toLowerCase() #" value="#=view#">${views[view].title}</option>' +
	                    '#}#'  +
	                '</select>' +
	            '#}#' +
	            '</div>'+
	            '<div class="k-scheduler-toolbar k-toolbar">' +
	                '<span class="k-scheduler-navigation">' +
	                   '<button class="k-button k-button-icon k-icon-button k-nav-prev"><span class="k-icon k-i-arrow-chevron-left"></span></button>' +
	                   '<span class="k-state-default k-nav-current">' +
	                        '<span class="k-m-date-format" data-#=ns#bind="text: formattedMobileDate"></span>' +
	                        '<span class="k-y-date-format" data-#=ns#bind="text: formattedYear"></span>' +
	                    '</span>' +
	                   '<button class="k-button k-button-icon k-icon-button k-nav-next"><span class="k-icon k-i-arrow-chevron-right"></span></button>' +
	                '</span>' +
	            '</div>'),
	        MOBILEDATERANGEEDITOR = function(container, options) {
	            var attr = { name: options.field, title: options.title };
	            var isAllDay = options.model.isAllDay;
	            var dateTimeValidate = kendo.attr("validate") + "='" + (!isAllDay) + "'";
	            var dateValidate = kendo.attr("validate") + "='" + isAllDay + "'";

	            appendTimezoneAttr(attr, options);
	            appendValidDateValidator(attr, options);
	            appendDateCompareValidator(attr, options);

	            $('<input type="datetime-local" required ' + kendo.attr("type") + '="datetime-local" ' + kendo.attr("bind") + '="value:' + options.field +', invisible:isAllDay" ' + dateTimeValidate + '/>')
	                .attr(attr)
	                .appendTo(container);

	            $('<input type="date" required ' + kendo.attr("type") + '="date" ' + kendo.attr("bind") + '="value:' + options.field +',visible:isAllDay" ' +
	                dateValidate + '/>')
	                .attr(attr).appendTo(container);

	            $('<span ' + kendo.attr("for") + '="' + options.field + '" class="k-invalid-msg"/>').hide().appendTo(container);
	        },
	        DATERANGEEDITOR = function(container, options) {
	            var attr = { name: options.field, title: options.title },
	                isAllDay = options.model.isAllDay,
	                dateTimeValidate = kendo.attr("validate") + "='" + (!isAllDay) + "' ",
	                dateValidate = kendo.attr("validate") + "='" + isAllDay + "' ";

	            appendTimezoneAttr(attr, options);
	            appendValidDateValidator(attr, options);
	            appendDateCompareValidator(attr, options);

	            $('<input type="text" required ' + kendo.attr("type") + '="date"' + ' ' + kendo.attr("role") + '="datetimepicker" ' + kendo.attr("bind") + '="value:' + options.field +',invisible:isAllDay" ' +
	                dateTimeValidate + '/>')
	            .attr(attr).appendTo(container);

	            $('<input type="text" required ' + kendo.attr("type") + '="date"' + ' '  + kendo.attr("role") + '="datepicker" ' + kendo.attr("bind") + '="value:' + options.field +',visible:isAllDay" ' +
	                dateValidate + '/>')
	            .attr(attr).appendTo(container);

	            $('<span ' + kendo.attr("bind") + '="text: ' + options.field + 'Timezone"></span>').appendTo(container);

	            if (options.field === "end") {
	                $('<span ' + kendo.attr("bind") + '="text: startTimezone, invisible: endTimezone"></span>').appendTo(container);
	            }

	            $('<span ' + kendo.attr("for") + '="' + options.field + '" class="k-invalid-msg"/>').hide().appendTo(container);
	        },
	        RECURRENCEEDITOR = function(container, options) {
	            $('<div ' + kendo.attr("bind") + '="value:' + options.field +'" />')
	                .attr({
	                    name: options.field
	                })
	                .appendTo(container)
	                .kendoRecurrenceEditor({
	                    start: options.model.start,
	                    timezone: options.timezone,
	                    messages: options.messages
	                });
	        },
	        MOBILERECURRENCEEDITOR = function(container, options) {
	            $('<div ' + kendo.attr("bind") + '="value:' + options.field +'" />')
	                .attr({
	                    name: options.field
	                })
	                .appendTo(container)
	                .kendoMobileRecurrenceEditor({
	                    start: options.model.start,
	                    timezone: options.timezone,
	                    messages: options.messages,
	                    pane: options.pane,
	                    value: options.model[options.field]
	                });
	        },
	        MOBILEISALLDAYEDITOR = function (container, options) {
	            $('<input type="checkbox" data-role="switch"' + kendo.attr("bind") + '="value:' + options.field +'" />').appendTo(container);
	        },
	        MOBILETIMEZONEPOPUP = function(container, options) {
	            var text = timezoneButtonText(options.model, options.messages.noTimezone);
	            $('<span class="k-timezone-label"></span>').text(text).appendTo(container);
	            $('<span class="k-icon k-i-arrow-chevron-right"></span>').appendTo(container);
	            container.closest("li.k-item label").click(options.click);
	        },
	        TIMEZONEPOPUP = function(container, options) {
	            $('<a href="#" class="k-button" data-bind="invisible:isAllDay">' + options.messages.timezoneEditorButton + '</a>').click(options.click).appendTo(container);
	        },
	        MOBILETIMEZONEEDITOR = function(container, options) {
	            $('<div class="k-mobiletimezoneeditor" ' + kendo.attr("bind") + '="value:' + options.field +'" />')
	                .attr({
	                    name: options.field
	                })
	                .appendTo(container)
	                .kendoMobileTimezoneEditor({
	                    optionLabel: options.noTimezone
	                });
	        },
	        TIMEZONEEDITOR = function(container, options) {
	            var visible = options.visible || options.visible === undefined;
	            $('<div ' + kendo.attr("bind") + '="value:' + options.field +'" />')
	                .attr({ name: options.field })
	                .toggle(visible)
	                .appendTo(container)
	                .kendoTimezoneEditor({
	                    optionLabel: options.noTimezone,
	                    title: options.title
	                });
	        };

	    function timezoneButtonText(model, message) {
	        message = message || "";

	        if (model.startTimezone) {
	            message = model.startTimezone;

	            if (model.endTimezone) {
	                message += " | " + model.endTimezone;
	            }
	        }

	        return message;
	    }

	    function appendTimezoneAttr(attrs, options) {
	        var timezone = options.timezone;

	        if (timezone) {
	            attrs[kendo.attr("timezone")] = timezone;
	        }
	    }

	    function appendValidDateValidator(attrs, options) {
	        var validationRules = options.model.fields[options.field].validation;

	        if (validationRules) {
	            var validDateRule = validationRules.validDateValidator;
	            if (validDateRule && isPlainObject(validDateRule) && validDateRule.message) {
	                attrs[kendo.attr("validDate-msg")] = validDateRule.message;
	            }
	        }
	    }

	    function appendDateCompareValidator(attrs, options) {
	        var validationRules = options.model.fields[options.field].validation;

	        if (validationRules) {
	            var dateCompareRule = validationRules.dateCompare;
	            if (dateCompareRule && isPlainObject(dateCompareRule) && dateCompareRule.message) {
	                attrs[kendo.attr("dateCompare-msg")] = dateCompareRule.message;
	            }
	        }
	    }

	    function wrapDataAccess(originalFunction, timezone) {
	        return function(data) {
	            data = originalFunction(data);

	            convertData(data, "apply",  timezone);

	            return data || [];
	        };
	    }

	    function wrapDataSerialization(originalFunction, timezone) {
	        return function(data) {

	            if (data) {
	                if (toString.call(data) !== "[object Array]" && !(data instanceof kendo.data.ObservableArray)) {
	                    data = [data];
	                }
	            }

	            convertData(data, "remove",  timezone, true);

	            data = originalFunction(data);

	            return data || [];
	        };
	    }

	    function convertData(data, method, timezone, removeUid) {
	        var event,
	            idx,
	            length;

	        data = data || [];

	        for (idx = 0, length = data.length; idx < length; idx++) {
	            event = data[idx];

	            if (removeUid) {
	                if (event.startTimezone || event.endTimezone) {
	                    if (timezone) {
	                        event.start = kendo.timezone.convert(event.start, event.startTimezone || event.endTimezone, timezone);
	                        event.end = kendo.timezone.convert(event.end, event.endTimezone || event.startTimezone, timezone);

	                        event.start = kendo.timezone[method](event.start, timezone);
	                        event.end = kendo.timezone[method](event.end, timezone);
	                    } else {
	                        event.start = kendo.timezone[method](event.start, event.startTimezone || event.endTimezone);
	                        event.end = kendo.timezone[method](event.end, event.endTimezone || event.startTimezone);
	                    }

	                } else if (timezone) {
	                    event.start = kendo.timezone[method](event.start, timezone);
	                    event.end = kendo.timezone[method](event.end, timezone);
	                }
	            } else {
	                if (event.startTimezone || event.endTimezone) {
	                    event.start = kendo.timezone[method](event.start, event.startTimezone || event.endTimezone);
	                    event.end = kendo.timezone[method](event.end, event.endTimezone || event.startTimezone);

	                    if (timezone) {
	                        event.start = kendo.timezone.convert(event.start, event.startTimezone || event.endTimezone, timezone);
	                        event.end = kendo.timezone.convert(event.end, event.endTimezone || event.startTimezone, timezone);
	                    }

	                } else if (timezone) {
	                    event.start = kendo.timezone[method](event.start, timezone);
	                    event.end = kendo.timezone[method](event.end, timezone);
	                }
	            }

	            if (removeUid) {
	                delete event.uid;
	            }
	        }
	        return data;
	    }

	    function getOccurrenceByUid(data, uid) {
	        var length = data.length,
	            idx = 0,
	            event;

	        for (; idx < length; idx++) {
	            event = data[idx];

	            if (event.uid === uid) {
	                return event;
	            }
	        }
	    }

	    var SchedulerDataReader = kendo.Class.extend({
	        init: function(schema, reader) {
	            var timezone = schema.timezone;

	            this.reader = reader;

	            if (reader.model) {
	                this.model = reader.model;
	            }

	            this.timezone = timezone;
	            this.data = wrapDataAccess($.proxy(this.data, this), timezone);
	            this.serialize = wrapDataSerialization($.proxy(this.serialize, this), timezone);
	        },
	        errors: function(data) {
	            return this.reader.errors(data);
	        },
	        parse: function(data) {
	            return this.reader.parse(data);
	        },
	        data: function(data) {
	            return this.reader.data(data);
	        },
	        total: function(data) {
	            return this.reader.total(data);
	        },
	        groups: function(data) {
	            return this.reader.groups(data);
	        },
	        aggregates: function(data) {
	            return this.reader.aggregates(data);
	        },
	        serialize: function(data) {
	            return this.reader.serialize(data);
	        }
	    });

	    function applyZone(date, fromZone, toZone) {
	        if (toZone) {
	            date = kendo.timezone.convert(date, fromZone, toZone);
	        } else {
	            date = kendo.timezone.remove(date, fromZone);
	        }

	        return date;
	    }

	    function validDateValidator(input) {
	        if ((input.filter("[name=start]").length && input.filter("[title=Start]").length) ||
	            (input.filter("[name=end]").length && input.filter("[title=End]").length) ||
	            input.filter(".k-recur-until").length) {
	            var date;
	            var picker = kendo.widgetInstance(input, kendo.ui);

	            if (picker) {
	                date = kendo.parseDate(input.val(), picker.options.format);
	                return !!date && picker.value();
	            } else {
	                date = kendo.parseDate(input.val());
	                return !!date;
	            }
	        }

	        return true;
	    }

	    function dateCompareValidator(input) {
	        if (input.filter("[name=end]").length) {
	            var container = input.closest(".k-scheduler-edit-form");
	            var startInput = container.find("[name=start]:visible");
	            var endInput = container.find("[name=end]:visible");

	            if (endInput[0] && startInput[0]) {
	                var start, end;
	                var startPicker = kendo.widgetInstance(startInput, kendo.ui);
	                var endPicker = kendo.widgetInstance(endInput, kendo.ui);

	                var editable = container.data("kendoEditable");
	                var model = editable ? editable.options.model : null;

	                if (startPicker && endPicker) {
	                    start = startPicker.value();
	                    end = endPicker.value();
	                } else {
	                    start = kendo.parseDate(startInput.val());
	                    end = kendo.parseDate(endInput.val());
	                }

	                if (start && end) {
	                    if (model) {
	                        var timezone = startInput.attr(kendo.attr("timezone"));
	                        var startTimezone = model.startTimezone;
	                        var endTimezone = model.endTimezone;

	                        startTimezone = startTimezone || endTimezone;
	                        endTimezone = endTimezone || startTimezone;

	                        if (startTimezone) {
	                            start = applyZone(start, startTimezone, timezone);
	                            end = applyZone(end, endTimezone, timezone);
	                        }
	                    }

	                    return start <= end;
	                }
	            }
	        }

	        return true;
	    }

	    function untilDateCompareValidator(input) {
	        var untilPicker, until,
	            container, startInput, start, startPicker;

	        if(input.filter(".k-recur-until").length) {
	            untilPicker = kendo.widgetInstance(input, kendo.ui);
	            until = untilPicker.value();
	            container = input.closest(".k-scheduler-edit-form");
	            startInput = container.find("[name=start]:visible");

	            if (startInput[0]) {
	                startPicker = kendo.widgetInstance(startInput, kendo.ui);

	                if (startPicker) {
	                    start = startPicker.value();
	                } else {
	                    start = kendo.parseDate(startInput.val());
	                }

	                if (start && until) {
	                    return start <= until;
	                }
	            }
	        }

	        return true;
	    }

	    var SchedulerEvent = kendo.data.Model.define({
	        init: function(value) {
	            var that = this;

	            kendo.data.Model.fn.init.call(that, value);

	            that._defaultId = that.defaults[that.idField];
	        },

	        _time: function(field) {
	            var date = this[field];
	            var fieldTime = "_" + field + "Time";

	            if (this[fieldTime]) {
	                return this[fieldTime] - kendo.date.toUtcTime(kendo.date.getDate(date));
	            }

	            return getMilliseconds(date);
	        },

	        _date: function(field) {
	            var fieldTime = "_" + field + "Time";

	            if (this[fieldTime]) {
	                return this[fieldTime] - this._time(field);
	            }

	            return kendo.date.getDate(this[field]);
	        },

	        clone: function(options, updateUid) {
	            var uid = this.uid,
	                event = new this.constructor($.extend({}, this.toJSON(), options));

	            if (!updateUid) {
	                event.uid = uid;
	            }

	            return event;
	        },

	        duration: function() {
	            var end = this.end;
	            var start = this.start;
	            var offset = (end.getTimezoneOffset() - start.getTimezoneOffset()) * kendo.date.MS_PER_MINUTE;

	            return end - start - offset;
	        },

	        expand: function(start, end, zone) {
	            return recurrence ? recurrence.expand(this, start, end, zone) : [this];
	        },

	        update: function(eventInfo) {
	            for (var field in eventInfo) {
	                this.set(field, eventInfo[field]);
	            }

	            if (this._startTime) {
	                this.set("_startTime", kendo.date.toUtcTime(this.start));
	            }

	            if (this._endTime) {
	                this.set("_endTime", kendo.date.toUtcTime(this.end));
	            }
	        },

	        isMultiDay: function() {
	            return this.isAllDay || this.duration() >= kendo.date.MS_PER_DAY;
	        },

	        isException: function() {
	            return !this.isNew() && this.recurrenceId;
	        },

	        isOccurrence: function() {
	            return this.isNew() && this.recurrenceId;
	        },

	        isRecurring: function() {
	            return !!(this.recurrenceRule || this.recurrenceId);
	        },

	        isRecurrenceHead: function() {
	            return !!(this.id && this.recurrenceRule);
	        },

	        toOccurrence: function(options) {
	            options = $.extend(options, {
	                recurrenceException: null,
	                recurrenceRule: null,
	                recurrenceId: this.id || this.recurrenceId
	            });

	            options[this.idField] = this.defaults[this.idField];

	            return this.clone(options, true);
	        },

	        toJSON: function() {
	            var obj = kendo.data.Model.fn.toJSON.call(this);
	            obj.uid = this.uid;

	            delete obj._startTime;
	            delete obj._endTime;

	            return obj;
	        },

	        shouldSerialize: function(field) {
	            return kendo.data.Model.fn.shouldSerialize.call(this, field) && field !== "_defaultId";
	        },

	        set: function(key, value) {
	            var isAllDay = this.isAllDay || false;

	            kendo.data.Model.fn.set.call(this, key, value);

	            if (key == "isAllDay" && value != isAllDay) {
	                var start = kendo.date.getDate(this.start);
	                var end = new Date(this.end);
	                var milliseconds = kendo.date.getMilliseconds(end);

	                if (milliseconds === 0 && value) {
	                    milliseconds = MS_PER_DAY;
	                }

	                this.set("start", start);

	                if (value === true) {
	                    kendo.date.setTime(end, -milliseconds);

	                    if (end < start) {
	                        end = start;
	                    }
	                } else {
	                    kendo.date.setTime(end, MS_PER_DAY - milliseconds);
	                }

	                this.set("end", end);
	            }
	        },
	        id: "id",
	        fields: {
	            id: { type: "number" },
	            title: { defaultValue: "", type: "string" },
	            start: { type: "date", validation: { required: true, validDate: { value: validDateValidator } } },
	            startTimezone: { type: "string" },
	            end: {
	                type: "date",
	                validation: {
	                    required: true,
	                    validDate: { value: validDateValidator },
	                    dateCompare: { value: dateCompareValidator }
	                }
	            },
	            endTimezone: { type: "string" },
	            recurrenceRule: {
	                defaultValue: "",
	                type: "string",
	                validation: {
	                    validDate: { value: validDateValidator },
	                    untilDateCompare: { value: untilDateCompareValidator }
	                }
	            },
	            recurrenceException: { defaultValue: "", type: "string" },
	            isAllDay: { type: "boolean", defaultValue: false },
	            description: { type: "string" }
	        }
	    });

	    var SchedulerDataSource = DataSource.extend({
	        init: function(options) {

	            DataSource.fn.init.call(this, extend(true, {}, {
	                schema: {
	                    modelBase: SchedulerEvent,
	                    model: SchedulerEvent
	                }
	            }, options));

	            this.reader = new SchedulerDataReader(this.options.schema, this.reader);
	        },

	        expand: function(start, end) {
	            var data = this.view(),
	                filter = {},
	                endOffset;

	            if (start && end) {
	                endOffset = end.getTimezoneOffset();
	                end = new Date(end.getTime() + MS_PER_DAY - 1);

	                if(end.getTimezoneOffset() !== endOffset){
	                    end = kendo.timezone.apply(end, endOffset);
	                }

	                filter = {
	                    logic: "or",
	                    filters: [
	                        {
	                            logic: "and",
	                            filters: [
	                                { field: "start", operator: "gte", value: start },
	                                { field: "end", operator: "gte", value: start },
	                                { field: "start", operator: "lte", value: end }
	                            ]
	                        },
	                        {
	                            logic: "and",
	                            filters: [
	                                { field: "start", operator: "lte", value: new Date(start.getTime() + MS_PER_DAY - 1) },
	                                { field: "end", operator: "gte", value: start }
	                            ]
	                        }
	                    ]
	                };

	                data = new kendo.data.Query(expandAll(data, start, end, this.reader.timezone)).filter(filter).toArray();
	            }

	            return data;
	        },

	        cancelChanges: function(model) {
	            if (model && model.isOccurrence()) {
	                this._removeExceptionDate(model);
	            }

	            DataSource.fn.cancelChanges.call(this, model);
	        },

	        insert: function(index, model) {
	            if (!model) {
	                return;
	            }

	            if (!(model instanceof SchedulerEvent)) {
	                var eventInfo = model;

	                model = this._createNewModel();
	                model.accept(eventInfo);
	            }

	            if ((!this._pushCreated && model.isRecurrenceHead()) || model.recurrenceId) {
	                model = model.recurrenceId ? model : model.toOccurrence();
	                this._addExceptionDate(model);
	            }

	            return DataSource.fn.insert.call(this, index, model);
	        },

	        pushCreate: function(items) {
	            this._pushCreated = true;
	            DataSource.fn.pushCreate.call(this, items);
	            this._pushCreated = false;
	        },

	        remove: function(model) {
	            if (model.isRecurrenceHead()) {
	                this._removeExceptions(model);
	            } else if (model.isRecurring()) {
	                this._addExceptionDate(model);
	            }

	            return DataSource.fn.remove.call(this, model);
	        },

	        _removeExceptions: function(model) {
	            var data = this.data().slice(0),
	                item = data.shift(),
	                id = model.id;

	            while(item) {
	                if (item.recurrenceId === id) {
	                    DataSource.fn.remove.call(this, item);
	                }

	                item = data.shift();
	            }

	            model.set(RECURRENCE_EXCEPTION, "");
	        },

	        _removeExceptionDate: function(model) {
	            if (model.recurrenceId) {
	                var head = this.get(model.recurrenceId);

	                if (head) {
	                    var start = model.defaults.start;
	                    var replaceRegExp = new RegExp("(\\" + EXCEPTION_SEPARATOR + "?)" + recurrence.toExceptionString(start, this.reader.timezone));
	                    var recurrenceException = (head.recurrenceException || "").replace(OLD_EXCEPTION_SEPARATOR_REGEXP, EXCEPTION_SEPARATOR).replace(/\,$/, "");

	                    if(replaceRegExp.test(recurrenceException)){
	                        head.set(RECURRENCE_EXCEPTION, recurrenceException.replace(replaceRegExp, ""));
	                    }else{
	                        start = model.start;
	                        replaceRegExp = new RegExp("(\\" + EXCEPTION_SEPARATOR + "?)" + recurrence.toExceptionString(start, this.reader.timezone));
	                        head.set(RECURRENCE_EXCEPTION, recurrenceException.replace(replaceRegExp, ""));
	                    }
	                }
	            }
	        },

	        _addExceptionDate: function(model) {
	            var start = model.start;
	            var zone = this.reader.timezone;
	            var head = this.get(model.recurrenceId);
	            var recurrenceException = (head.recurrenceException || "").replace(OLD_EXCEPTION_SEPARATOR_REGEXP, EXCEPTION_SEPARATOR).replace(/\,$/, "");

	            if (!recurrence.isException(recurrenceException, start, zone)) {
	                var newException = recurrence.toExceptionString(start, zone);
	                model.defaults.start = start;
	                head.set(RECURRENCE_EXCEPTION, recurrenceException + (recurrenceException && newException ? EXCEPTION_SEPARATOR : "") + newException);
	            }
	        }
	    });

	    function expandAll(events, start, end, zone) {
	        var length = events.length,
	            data = [],
	            idx = 0;

	        for (; idx < length; idx++) {
	            data = data.concat(events[idx].expand(start, end, zone));
	        }

	        return data;
	    }

	    SchedulerDataSource.create = function(options) {
	        if (isArray(options) || options instanceof kendo.data.ObservableArray) {
	            options = { data: options };
	        }

	        var dataSource = options || {},
	            data = dataSource.data;

	        dataSource.data = data;

	        if (!(dataSource instanceof SchedulerDataSource) && dataSource instanceof kendo.data.DataSource) {
	            throw new Error("Incorrect DataSource type. Only SchedulerDataSource instances are supported");
	        }

	        return dataSource instanceof SchedulerDataSource ? dataSource : new SchedulerDataSource(dataSource);
	    };

	    extend(true, kendo.data, {
	       SchedulerDataSource: SchedulerDataSource,
	       SchedulerDataReader: SchedulerDataReader,
	       SchedulerEvent: SchedulerEvent
	    });

	    var defaultCommands = {
	        update: {
	            text: "Save",
	            className: "k-primary k-scheduler-update"
	        },
	        canceledit: {
	            text: "Cancel",
	            className: "k-scheduler-cancel"
	        },
	        destroy: {
	            text: "Delete",
	            imageClass: "k-i-close",
	            className: "k-primary k-scheduler-delete",
	            iconClass: "k-icon"
	        }
	    };

	    function trimOptions(options, overrideOptions) {
	        delete options.name;
	        delete options.prefix;

	        delete options.remove;
	        delete options.edit;
	        delete options.add;
	        delete options.navigate;

	        for (var key in overrideOptions) {
	            options[key] = overrideOptions[key];
	        }

	        return options;
	    }

	    /*
	    function fieldType(field) {
	        field = field != null ? field : "";
	        return field.type || $.type(field) || "string";
	    }
	    */

	    function createValidationAttributes(model, field) {
	        var modelField = (model.fields || model)[field];
	        var specialRules = ["url", "email", "number", "date", "boolean"];
	        var validation = modelField ? modelField.validation : {};
	        // var type = fieldType(modelField);
	        var datatype = kendo.attr("type");
	        var inArray = $.inArray;
	        var ruleName;
	        var rule;

	        var attr = {};

	        for (ruleName in validation) {
	            rule = validation[ruleName];

	            if (inArray(ruleName, specialRules) >= 0) {
	                attr[datatype] = ruleName;
	            } else if (!kendo.isFunction(rule)) {
	                attr[ruleName] = isPlainObject(rule) ? (rule.value || ruleName) : rule;
	            }

	            attr[kendo.attr(ruleName + "-msg")] = rule.message;
	        }

	        return attr;
	    }

	    function dropDownResourceEditor(resource, model) {
	        var attr = createValidationAttributes(model, resource.field);

	        return function(container) {
	           $(kendo.format('<select data-{0}bind="value:{1}" title="' + model.title + '">', kendo.ns, resource.field))
	             .appendTo(container)
	             .attr(attr)
	             .kendoDropDownList({
	                 dataTextField: resource.dataTextField,
	                 dataValueField: resource.dataValueField,
	                 dataSource: resource.dataSource,
	                 valuePrimitive: resource.valuePrimitive,
	                 optionLabel: "None",
	                 template: kendo.format('<span class="k-scheduler-mark" style="background-color:#= data.{0}?{0}:"none" #"></span>#={1}#', resource.dataColorField, resource.dataTextField)
	             });
	       };
	    }

	    function dropDownResourceEditorMobile(resource, model) {
	        var attr = createValidationAttributes(model, resource.field);

	        return function(container) {
	            var options = "";
	            var view = resource.dataSource.view();

	            for (var idx = 0, length = view.length; idx < length; idx++) {
	                options += kendo.format('<option value="{0}">{1}</option>',
	                    kendo.getter(resource.dataValueField)(view[idx]),
	                    kendo.getter(resource.dataTextField)(view[idx])
	                );
	            }

	            $(kendo.format('<select data-{0}bind="value:{1}">{2}</select>',
	                kendo.ns,
	                resource.field,
	                options,
	                resource.valuePrimitive
	             ))
	             .appendTo(container)
	             .attr(attr);
	       };
	    }

	    function descriptionEditor(options) {
	        var attr = createValidationAttributes(options.model, options.field);

	        return function(container, model) {
	            $('<textarea name="description" class="k-textarea" title="' + model.title + '"/>').attr(attr)
	                .appendTo(container);
	        };
	    }

	    function multiSelectResourceEditor(resource, model) {
	        var attr = createValidationAttributes(model, resource.field);

	        return function(container) {
	           $(kendo.format('<select data-{0}bind="value:{1}">', kendo.ns, resource.field))
	             .appendTo(container)
	             .attr(attr)
	             .kendoMultiSelect({
	                 dataTextField: resource.dataTextField,
	                 dataValueField: resource.dataValueField,
	                 dataSource: resource.dataSource,
	                 valuePrimitive: resource.valuePrimitive,
	                 itemTemplate: kendo.format('<span class="k-scheduler-mark" style="background-color:#= data.{0}?{0}:"none" #"></span>#={1}#', resource.dataColorField, resource.dataTextField),
	                 tagTemplate: kendo.format('<span class="k-scheduler-mark" style="background-color:#= data.{0}?{0}:"none" #"></span>#={1}#', resource.dataColorField, resource.dataTextField)
	             });
	       };
	    }

	    function multiSelectResourceEditorMobile(resource, model) {
	        var attr = createValidationAttributes(model, resource.field);

	        return function(container) {
	            var options = "";
	            var view = resource.dataSource.view();

	            for (var idx = 0, length = view.length; idx < length; idx++) {
	                options += kendo.format('<option value="{0}">{1}</option>',
	                    kendo.getter(resource.dataValueField)(view[idx]),
	                    kendo.getter(resource.dataTextField)(view[idx])
	                );
	            }

	            $(kendo.format('<select data-{0}bind="value:{1}" multiple="multiple" data-{0}value-primitive="{3}">{2}</select>',
	                kendo.ns,
	                resource.field,
	                options,
	                resource.valuePrimitive
	             ))
	             .appendTo(container)
	             .attr(attr);
	       };
	    }

	    function moveEventRange(event, distance) {
	        var duration = event.end.getTime() - event.start.getTime();

	        var start = new Date(event.start.getTime());

	        kendo.date.setTime(start, distance);

	        var end = new Date(start.getTime());

	        kendo.date.setTime(end, duration, true);

	        return {
	            start: start,
	            end: end
	        };
	    }

	    var editors = {
	        mobile: {
	            dateRange: MOBILEDATERANGEEDITOR,
	            timezonePopUp: MOBILETIMEZONEPOPUP,
	            timezone: MOBILETIMEZONEEDITOR,
	            recurrence: MOBILERECURRENCEEDITOR,
	            description: descriptionEditor,
	            multipleResources: multiSelectResourceEditorMobile,
	            resources: dropDownResourceEditorMobile,
	            isAllDay: MOBILEISALLDAYEDITOR
	        },
	        desktop: {
	            dateRange: DATERANGEEDITOR,
	            timezonePopUp: TIMEZONEPOPUP,
	            timezone: TIMEZONEEDITOR,
	            recurrence: RECURRENCEEDITOR,
	            description: descriptionEditor,
	            multipleResources: multiSelectResourceEditor,
	            resources: dropDownResourceEditor
	        }
	    };

	    var Editor = kendo.Observable.extend({
	        init: function(element, options) {

	            kendo.Observable.fn.init.call(this);

	            this.element = element;
	            this.options = extend(true, {}, this.options, options);
	            this.createButton = this.options.createButton;

	            this.toggleDateValidationHandler = proxy(this._toggleDateValidation, this);
	        },

	        _toggleDateValidation: function(e) {
	            if (e.field == "isAllDay") {
	                var container = this.container,
	                    isAllDay = this.editable.options.model.isAllDay,
	                    bindAttribute = kendo.attr("bind"),
	                    element, isDateTimeInput, shouldValidate;
	                container.find("[" + bindAttribute+ "*=end],[" + bindAttribute + "*=start]").each(function() {
	                    element = $(this);
	                    if (valueStartEndBoundRegex.test(element.attr(bindAttribute))) {
	                        isDateTimeInput = element.is("[" + kendo.attr("role") + "=datetimepicker],[type*=datetime]");
	                        shouldValidate = isAllDay !== isDateTimeInput;
	                        element.attr(kendo.attr("validate"), shouldValidate);
	                    }
	                });
	            }
	        },

	        fields: function(editors, model) {
	            var that = this;

	            var messages = that.options.messages;
	            var timezone = that.options.timezone;

	            var click = function(e) {
	                e.preventDefault();
	                that._initTimezoneEditor(model, this);
	            };

	            var fields = [
	                { field: "title", title: messages.editor.title /*, format: field.format, editor: field.editor, values: field.values*/ },
	                { field: "start", title: messages.editor.start, editor: editors.dateRange, timezone: timezone },
	                { field: "end", title: messages.editor.end, editor: editors.dateRange, timezone: timezone },
	                { field: "isAllDay", title: messages.editor.allDayEvent, editor: editors.isAllDay }
	            ];

	            if (kendo.timezone.windows_zones) {
	                fields.push({ field: "timezone", title: messages.editor.timezone, editor: editors.timezonePopUp, click: click, messages: messages.editor, model: model });
	                fields.push({ field: "startTimezone", title: messages.editor.startTimezone, editor: editors.timezone, noTimezone: messages.editor.noTimezone });
	                fields.push({ field: "endTimezone", title: messages.editor.endTimezone, editor: editors.timezone, noTimezone: messages.editor.noTimezone });
	            }

	            if (!model.recurrenceId) {
	                fields.push({ field: "recurrenceRule", title: messages.editor.repeat, editor: editors.recurrence, timezone: timezone, messages: messages.recurrenceEditor, pane: this.pane });
	            }

	            if ("description" in model) {
	                fields.push({ field: "description", title: messages.editor.description, editor: editors.description({model: model, field: "description"}) });
	            }

	            for (var resourceIndex = 0; resourceIndex < this.options.resources.length; resourceIndex++) {
	                var resource = this.options.resources[resourceIndex];
	                fields.push({
	                    field: resource.field,
	                    title: resource.title,
	                    editor: resource.multiple? editors.multipleResources(resource, model) : editors.resources(resource, model)
	                });
	            }

	            return fields;
	        },

	        end: function() {
	            return this.editable.end();
	        },

	        _buildDesktopEditTemplate: function(model, fields, editableFields) {

	            var messages = this.options.messages;
	            var settings = extend({}, kendo.Template, this.options.templateSettings);
	            var paramName = settings.paramName;
	            var html = "";

	            for (var idx = 0, length = fields.length; idx < length; idx++) {
	                var field = fields[idx];

	                if (field.field === "startTimezone") {
	                    html += '<div class="k-popup-edit-form k-scheduler-edit-form k-scheduler-timezones" style="display:none">';
	                    html += '<div class="k-edit-form-container">';
	                    html += '<div class="k-edit-label"></div>';
	                    html += '<div class="k-edit-field"><label class="k-check"><input class="k-timezone-toggle" type="checkbox" />' + messages.editor.separateTimezones + '</label></div>';
	                }

	                html += '<div class="k-edit-label"><label for="' + field.field + '">' + (field.title || field.field || "") + '</label></div>';

	                if ((!model.editable || model.editable(field.field))) {
	                    editableFields.push(field);
	                    html += '<div ' + kendo.attr("container-for") + '="' + field.field + '" class="k-edit-field"></div>';
	                } else {
	                    var tmpl = "#:";

	                    if (field.field) {
	                        field = kendo.expr(field.field, paramName);
	                        tmpl += field + "==null?'':" + field;
	                    } else {
	                        tmpl += "''";
	                    }

	                    tmpl += "#";

	                    tmpl = kendo.template(tmpl, settings);

	                    html += '<div class="k-edit-field">' + tmpl(model) + '</div>';
	                }

	                if (field.field === "endTimezone") {
	                    html += this._createEndTimezoneButton();
	                }
	            }

	            return html;
	        },

	        _buildMobileEditTemplate: function(model, fields, editableFields) {
	            var messages = this.options.messages;
	            var settings = extend({}, kendo.Template, this.options.templateSettings);
	            var paramName = settings.paramName;
	            var html = "";

	            html += '<ul class="k-listgroup k-listgroup-flush">';

	            for (var idx = 0, length = fields.length; idx < length; idx++) {
	                var field = fields[idx];

	                if (field.field === "timezone" || field.field === "recurrenceRule") {
	                    html += '</ul><ul class="k-listgroup k-listgroup-flush">';
	                }

	                if (field.field === "startTimezone") {
	                    html += '<div class="k-popup-edit-form k-scheduler-edit-form k-scheduler-timezones" style="display:none">';
	                    html += '<ul class="k-listgroup k-listgroup-flush">';
	                    html += '<li class="k-item k-listgroup-item">';
	                    html += '<label class="k-label k-listgroup-form-row">';
	                    html += '<span class="k-item-title k-listgroup-form-row">' + messages.editor.separateTimezones + '</span>';
	                    html += '<span class="k-listgroup-form-field-wrapper">';
	                    html += '<input class="k-timezone-toggle" data-role="switch" type="checkbox" />';
	                    html += '</span>';
	                    html += '</label>';
	                    html += '</li>';
	                }

	                if ((!model.editable || model.editable(field.field))) {
	                    html += '<li class="k-item k-listgroup-item">';
	                    if (field.field === "timezone") {
	                        html += '<label class="k-label k-listgroup-form-row" data-bind="css: { k-state-disabled: isAllDay }">';
	                    } else {
	                        html += '<label class="k-label k-listgroup-form-row">';
	                    }
	                    html += '<span class="k-item-title k-listgroup-form-field-label">' + (field.title || field.field || "") + '</span>';

	                    editableFields.push(field);
	                    html += '<div class="k-listgroup-form-field-wrapper" ' + kendo.attr("container-for") + '="' + field.field + '"></div>';

	                    html += '</label></li>';
	                } else {
	                    var tmpl = "#:";

	                    html += '<li class="k-item k-listgroup-item">';
	                    html += '<label class="k-label k-no-click k-listgroup-form-row">';
	                    html += '<span class="k-item-title k-listgroup-form-field-label">' + (field.title || field.field || "") + '</span>';

	                    if (field.field) {
	                        field = kendo.expr(field.field, paramName);
	                        tmpl += field + "==null?'':" + field;
	                    } else {
	                        tmpl += "''";
	                    }

	                    tmpl += "#";

	                    tmpl = kendo.template(tmpl, settings);

	                    html += '<span class="k-no-editor k-listgroup-form-field-wrapper">' + tmpl(model) + '</span>';

	                    html += '</label></li>';
	                }

	                if (field.field === "recurrenceRule") {
	                    html += '</ul><ul class="k-listgroup k-listgroup-flush">';
	                }

	                if (field.field === "endTimezone") {
	                    html += "</ul></div>";
	                }
	            }
	            html += '</ul>';

	            return html;
	        },

	        _buildEditTemplate: function(model, fields, editableFields, isMobile) {
	            var settings = extend({}, kendo.Template, this.options.templateSettings);
	            var template = this.options.editable.template;
	            var html = "";

	            if (template) {
	                if (typeof template === STRING) {
	                    template = kendo.unescape(template);
	                }
	                html += (kendo.template(template, settings))(model);
	            } else if (isMobile) {
	                html += '<div data-role="content">' + this._buildMobileEditTemplate(model, fields, editableFields) + '</div>';
	            } else {
	                html += this._buildDesktopEditTemplate(model, fields, editableFields);
	            }

	            return html;
	        },

	        _createEndTimezoneButton: function() {
	            return '</ul></div>';
	        },

	        _revertTimezones: function(model) {
	            model.set("startTimezone", this._startTimezone);
	            model.set("endTimezone", this._endTimezone);

	            delete this._startTimezone;
	            delete this._endTimezone;
	        }
	    });

	    var MobileEditor = Editor.extend({
	        init: function() {
	            Editor.fn.init.apply(this, arguments);

	            this.pane = kendo.Pane.wrap(this.element, {
	                viewEngine: {
	                    viewOptions: {
	                        renderOnInit: true,
	                        wrap: false,
	                        wrapInSections: true,
	                        detachOnHide: false,
	                        detachOnDestroy: false
	                    }
	                }
	            });
	            this.pane.element.parent().css("height", this.options.height);
	            this.view = this.pane.view();
	        },

	        options: {
	            animations: {
	                left: "slide",
	                right: "slide:right"
	            }
	        },

	        destroy: function() {
	            this.close();
	            this.unbind();
	            this.pane.destroy();
	        },

	        _initTimezoneEditor: function(model) {
	            var that = this;
	            var pane = that.pane;
	            var messages = that.options.messages;
	            var timezoneView = that.timezoneView;
	            var container = timezoneView ? timezoneView.content.find(".k-scheduler-timezones") : that.container.find(".k-scheduler-timezones");
	            var kSwitch = container.find("input.k-timezone-toggle").data("kendoSwitch");
	            var endTimezoneRow = container.find("li.k-item:not(.k-zonepicker):last");
	            var startTimezoneChange = function(e) {
	                if (e.field === "startTimezone") {
	                    var value = model.startTimezone;

	                    kSwitch.enable(value);

	                    if (!value) {
	                        endTimezoneRow.hide();
	                        model.set("endTimezone", "");
	                        kSwitch.value(false);
	                    }
	                }
	            };

	            that._startTimezone = model.startTimezone || "";
	            that._endTimezone = model.endTimezone || "";

	            if (!timezoneView) {
	                var html = '<div data-role="view" class="k-popup-edit-form k-scheduler-edit-form">' +
	                '<div data-role="header" class="k-header">' +
	                    '<a href="\\#" class="k-header-cancel k-scheduler-cancel k-link" title="' + messages.cancel + '"' +
	                    'aria-label="' + messages.cancel + '"><span class="k-icon k-i-arrow-chevron-left"></span></a>' +
	                    messages.editor.timezoneTitle +
	                    '<a href="\\#" class="k-header-done k-scheduler-update k-link" title="' + messages.save + '" ' +
	                    'aria-label="' + messages.save + '"><span class="k-icon k-i-check"></span></a>' +
	                '</div><div data-role="content"></div>';

	                this.timezoneView = timezoneView = pane.append(html);

	                timezoneView.contentElement.append(container.show());

	                timezoneView.element.on(CLICK + NS, ".k-scheduler-cancel, .k-scheduler-update", function(e) {
	                    e.preventDefault();
	                    e.stopPropagation();

	                    if ($(this).hasClass("k-scheduler-cancel")) {
	                        that._revertTimezones(model);
	                    }

	                    var editView = that._editPane;

	                    var text = timezoneButtonText(model, messages.editor.noTimezone);

	                    editView.content.find(".k-timezone-label").text(text);

	                    pane.navigate(editView, that.options.animations.right);
	                });

	                kSwitch.bind("change", function(ev) {
	                    endTimezoneRow.toggle(ev.checked);
	                    model.set("endTimezone", "");
	                });
	                model.bind("change", startTimezoneChange);
	            }

	            kSwitch.value(!!model.endTimezone);
	            kSwitch.enable(!!model.startTimezone);

	            if (model.endTimezone) {
	                endTimezoneRow.show();
	            } else {
	                endTimezoneRow.hide();
	            }

	            pane.navigate(timezoneView, that.options.animations.left);
	        },

	        showDialog: function(options) {
	            var actions = options.buttons.map(function(button){
	                return {
	                    text: button.text,
	                    action: button.click
	                };
	            });

	            actions.push({
	                text: this.options.messages.cancel,
	                primary: true
	            });

	            $("<div />").appendTo(document.body)
	                .kendoDialog({
	                    close: function() {
	                        this.destroy();
	                    },
	                    modal: {
	                        preventScroll: true
	                    },
	                    closable: false,
	                    title: false,
	                    content: options.text,
	                    actions: actions
	                });
	        },

	        editEvent: function(model) {
	            var pane = this.pane;
	            var html = "";

	            var messages = this.options.messages;
	            var updateText = messages.save;
	            var removeText = messages.destroy;
	            var cancelText = messages.cancel;
	            var titleText = messages.editor.editorTitle;
	            var resetSeries = messages.resetSeries;

	            html += '<div data-role="view" class="k-popup-edit-form k-scheduler-edit-form"' + kendo.attr("uid") + '="' + model.uid + '">' +
	                '<div data-role="header" class="k-header">' +
	                    '<a href="\\#" class="k-header-cancel k-scheduler-cancel k-link" title="' + cancelText + '"' +
	                    'aria-label="' + cancelText + '"><span class="k-icon k-i-arrow-chevron-left"></span></a>' +
	                    titleText +
	                    '<a href="\\#" class="k-header-done k-scheduler-update k-link" title="' + updateText + '" ' +
	                    'aria-label="' + updateText + '"><span class="k-icon k-i-check"></span></a>' +
	                '</div>';

	            var fields = this.fields(editors.mobile, model);

	            var that = this;

	            var editableFields = [];

	            html += this._buildEditTemplate(model, fields, editableFields, true);

	            html += "</div>";

	            var view = pane.append(html);

	            if (!model.isNew() && this.options.editable && this.options.editable.destroy !== false && model.isRecurrenceHead() && model.recurrenceException) {
	                var resetSeriesBtn = '<ul class="k-edit-buttons k-listgroup k-listgroup-flush"><li class="k-item k-listgroup-item"><span class="k-scheduler-resetSeries k-link k-label" aria-label="' + resetSeries + '">' + resetSeries + '</span></li></ul>';
	                view.contentElement.append(resetSeriesBtn);
	            }

	            if (!model.isNew() && this.options.editable && this.options.editable.destroy !== false) {
	                var deleteBtn = '<ul class="k-edit-buttons k-listgroup k-listgroup-flush"><li class="k-item k-listgroup-item"><span class="k-scheduler-delete k-link k-label" aria-label="' + removeText + '">' + removeText + '</span></li></ul>';
	                view.contentElement.append(deleteBtn);
	            }

	            this._editPane = view;

	            var container = this.container = view.element;

	            this.editable = container.kendoEditable({
	                fields: editableFields,
	                model: model,
	                clearContainer: false,
	                target: that.options.target,
	                validateOnBlur: true
	            }).data("kendoEditable");

	            if (!this.trigger("edit", { container: container, model: model })) {

	                container.on(CLICK + NS, "a.k-scheduler-edit, a.k-scheduler-cancel, a.k-scheduler-update, span.k-scheduler-delete, span.k-scheduler-resetSeries", function(e) {
	                    e.preventDefault();
	                    e.stopPropagation();

	                    var button = $(this);

	                    if (!button.hasClass("k-scheduler-edit")) {

	                        var name = "cancel";

	                        if (button.hasClass("k-scheduler-update")) {
	                            name = "save";
	                        } else if (button.hasClass("k-scheduler-delete")) {
	                            name = "remove";
	                        } else if (button.hasClass("k-scheduler-resetSeries")) {
	                            name = RESET;
	                        }

	                        that.trigger(name, { container: container, model: model });
	                    } else {
	                        pane.navigate(this._editPane, that.options.animations.right);
	                    }
	                });

	                pane.navigate(view, that.options.animations.left);

	                model.bind("change", that.toggleDateValidationHandler);
	            } else {
	                this.trigger("cancel", { container: container, model: model });
	            }

	            return this.editable;
	        },

	        _views: function() {
	            return this.pane.element
	                    .find(kendo.roleSelector("view"))
	                    .not(this.view.element);
	        },

	        close: function() {
	            if (this.container) {
	                this.pane.navigate("", this.options.animations.right);

	                var views = this._views();
	                var view;

	                for (var idx = 0, length = views.length; idx < length; idx++) {
	                    view = views.eq(idx).data("kendoView");
	                    if (view) {
	                       view.purge();
	                    }
	                }

	                views.remove();

	                this.container = null;
	                if (this.editable) {
	                    this.editable.options.model.unbind("change", this.toggleDateValidationHandler);
	                    this.editable.destroy();
	                    this.editable = null;
	                }
	                this.timezoneView = null;
	            }
	        }
	    });

	    var PopupEditor = Editor.extend({
	        destroy: function() {
	            this.close();
	            this.unbind();
	        },

	        editEvent: function(model) {
	            var that = this;
	            var editable = that.options.editable;
	            var html = '<div ' + kendo.attr("uid") + '="' + model.uid + '" class="k-popup-edit-form k-scheduler-edit-form"><div class="k-edit-form-container">';
	            var messages = that.options.messages;
	            var updateText = messages.save;
	            var cancelText = messages.cancel;
	            var deleteText = messages.destroy;
	            var resetSeries = messages.resetSeries;

	            var fields = this.fields(editors.desktop, model);

	            var editableFields = [];

	            html += this._buildEditTemplate(model, fields, editableFields, false);

	            var attr;
	            var options = isPlainObject(editable) ? editable.window : {};

	            html += '<div class="k-edit-buttons k-state-default">';
	            html += this.createButton({ name: "update", text: updateText, attr: attr }) + this.createButton({ name: "canceledit", text: cancelText, attr: attr });

	            if (!model.isNew() && editable.destroy !== false && model.isRecurrenceHead() && model.recurrenceException) {
	                html += this.createButton({ name: "resetSeries", text: resetSeries, attr: attr });
	            }

	            if ((!model.isNew() || model.isRecurring()) && editable.destroy !== false) {
	                html += this.createButton({ name: "delete", text: deleteText, attr: attr });
	            }

	            html += '</div></div></div>';

	            var container = this.container = $(html)
	                .appendTo(that.element).eq(0)
	                .kendoWindow(extend({
	                    modal: true,
	                    resizable: false,
	                    draggable: true,
	                    title: messages.editor.editorTitle,
	                    visible: false,
	                    close: function(e) {
	                        if (e.userTriggered) {
	                            if (that.trigger(CANCEL, { container: container, model: model })) {
	                                e.preventDefault();
	                            }
	                        }
	                    }
	                }, options));

	            that.editable = container.kendoEditable({
	                fields: editableFields,
	                model: model,
	                clearContainer: false,
	                validateOnBlur: true,
	                target: that.options.target
	            }).data("kendoEditable");

	            if (!that.trigger(EDIT, { container: container, model: model })) {

	                container.data("kendoWindow").center().open();

	                container.on(CLICK + NS, "button.k-scheduler-cancel", function(e) {
	                    e.preventDefault();
	                    e.stopPropagation();

	                    that.trigger(CANCEL, { container: container, model: model });
	                });

	                container.on(CLICK + NS, "button.k-scheduler-update", function(e) {
	                    e.preventDefault();
	                    e.stopPropagation();

	                    that.trigger("save", { container: container, model: model });
	                });

	                container.on(CLICK + NS, "button.k-scheduler-delete", function(e) {
	                    e.preventDefault();
	                    e.stopPropagation();

	                    that.trigger(REMOVE, { container: container, model: model });
	                });

	                container.on(CLICK + NS, "button.k-scheduler-resetSeries", function(e) {
	                    e.preventDefault();
	                    e.stopPropagation();
	                    that.trigger(RESET, { container: container, model: model });
	                });

	                kendo.cycleForm(container);

	                model.bind("change", that.toggleDateValidationHandler);
	            } else {
	                that.trigger(CANCEL, { container: container, model: model });
	            }

	            return that.editable;
	        },

	        close: function() {
	            var that = this;

	            var destroy = function() {
	                if (that.editable) {
	                    that.editable.options.model.unbind("change", that.toggleDateValidationHandler);
	                    that.editable.destroy();
	                    that.editable = null;
	                    that.container = null;
	                }
	                if (that.popup) {
	                    that.popup.destroy();
	                    that.popup = null;
	                }
	            };

	            if (that.editable) {
	                if (that._timezonePopup && that._timezonePopup.data("kendoWindow")) {
	                    that._timezonePopup.data("kendoWindow").destroy();
	                    that._timezonePopup = null;
	                }

	                if (that.container.is(":visible")) {
	                    that.container.data("kendoWindow").bind("deactivate", destroy).close();
	                } else {
	                    destroy();
	                }
	            } else {
	                destroy();
	            }
	        },

	        _createEndTimezoneButton: function() {
	            var messages = this.options.messages;
	            var html = "";

	            html += '<div class="k-edit-buttons k-state-default">';
	            html += this.createButton({ name: "savetimezone", text: messages.save }) + this.createButton({ name: "canceltimezone", text: messages.cancel });
	            html += '</div></div></div>';

	            return html;
	        },

	        showDialog: function(options) {
	            var html = kendo.format("<div class='k-popup-edit-form'><div class='k-edit-form-container'><p class='k-popup-message'>{0}</p>", options.text);

	            html += '<div class="k-edit-buttons k-state-default">';

	            for (var buttonIndex = 0; buttonIndex < options.buttons.length; buttonIndex++) {
	                html+= this.createButton(options.buttons[buttonIndex]);
	            }

	            html += '</div></div></div>';

	            var wrapper = this.element;

	            if (this.popup) {
	                this.popup.destroy();
	            }

	            var popup = this.popup = $(html).appendTo(wrapper)
	                               .eq(0)
	                               .on(CLICK, ".k-button", function(e) {
	                                    e.preventDefault();

	                                    popup.close();

	                                    var buttonIndex = $(e.currentTarget).index();

	                                    options.buttons[buttonIndex].click();
	                               })
	                               .kendoWindow({
	                                   modal: true,
	                                   resizable: false,
	                                   draggable: false,
	                                   title: options.title,
	                                   visible: false,
	                                   close: function() {
	                                       this.destroy();
	                                       wrapper.focus();
	                                   }
	                               })
	                               .getKendoWindow();

	            popup.center().open();
	        },

	        _initTimezoneEditor: function(model, activator) {
	            var that = this;
	            var container = that.container.find(".k-scheduler-timezones");
	            var checkbox = container.find("input.k-timezone-toggle");
	            var endTimezoneRow = container.find(".k-edit-label:last").add(container.find(".k-edit-field:last"));
	            var saveButton = container.find(".k-scheduler-savetimezone");
	            var cancelButton = container.find(".k-scheduler-canceltimezone");
	            var timezonePopup = that._timezonePopup;
	            var startTimezoneChange = function(e) {
	                if (e.field === "startTimezone") {
	                    var value = model.startTimezone;

	                    checkbox.prop("disabled", !value);

	                    if (!value) {
	                        endTimezoneRow.hide();
	                        model.set("endTimezone", "");
	                        checkbox.prop("checked", false);
	                    }
	                }
	            };
	            var wnd;

	            that._startTimezone = model.startTimezone;
	            that._endTimezone = model.endTimezone;

	            if (!timezonePopup) {
	                that._timezonePopup = timezonePopup = container.kendoWindow({
	                    modal: true,
	                    resizable: false,
	                    draggable: true,
	                    title: that.options.messages.editor.timezoneEditorTitle,
	                    visible: false,
	                    close: function(e) {
	                        model.unbind("change", startTimezoneChange);

	                        if (e.userTriggered) {
	                            that._revertTimezones(model);
	                        }

	                        if (activator) {
	                            activator.focus();
	                        }
	                    }
	                });

	                checkbox.click(function() {
	                    endTimezoneRow.toggle(checkbox.prop("checked"));
	                    model.set("endTimezone", "");
	                });

	                saveButton.click(function(e) {
	                    e.preventDefault();
	                    wnd.close();
	                });

	                cancelButton.click(function(e) {
	                    e.preventDefault();
	                    that._revertTimezones(model);
	                    wnd.close();
	                });

	                model.bind("change", startTimezoneChange);
	            }

	            checkbox.prop("checked", model.endTimezone).prop("disabled", !model.startTimezone);

	            if (model.endTimezone) {
	                endTimezoneRow.show();
	            } else {
	                endTimezoneRow.hide();
	            }

	            wnd = timezonePopup.data("kendoWindow");
	            wnd.center().open();
	        }
	    });

	    var Scheduler = DataBoundWidget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            if (!that.options.views || !that.options.views.length) {
	                that.options.views = ["day", "week"];
	            }

	            that.resources = [];

	            that._initModel();

	            that._wrapper();

	            that._views();

	            that._toolbar();

	            that._dataSource();

	            that._resources();

	            that._resizeHandler = function() {
	                that.resize();
	            };

	            that.wrapper.on(MOUSEDOWN + NS + " selectstart" + NS, function(e) {
	                if (!$(e.target).is(":kendoFocusable")) {
	                    e.preventDefault();
	                }
	            });

	            if (that.options.editable && that.options.editable.resize !== false) {
	                that._resizable();
	            }

	            that._movable();

	            that._bindResize();

	            if(that.options.messages && that.options.messages.recurrence) {
	                recurrence.options = that.options.messages.recurrence;
	            }

	            that._selectable();

	            that._touchHandlers();

	            that._ariaId = kendo.guid();

	            that._createEditor();
	        },

	        _bindResize: function() {
	            $(window).on("resize" + NS, this._resizeHandler);
	        },

	        _unbindResize: function() {
	            $(window).off("resize" + NS, this._resizeHandler);
	        },

	        dataItems: function() {
	            var that = this;
	            var items = that.items();
	            var events = that._data;
	            var eventsUids = $.map(items, function(item) {
	                return $(item).attr("data-uid");
	            });
	            var i;
	            var key;

	            var dict = {};
	            var eventsUidsLength = eventsUids.length;
	            for (i = 0; i < eventsUidsLength; i++) {
	                dict[eventsUids[i]] = null;
	            }

	            var eventsCount = events.length;
	            for (i = 0; i < eventsCount; i++) {
	                var event = events[i];
	                if (dict[event.uid] !== undefined) {
	                    dict[event.uid] = event;
	                }
	            }

	            var sortedData = [];
	            for (key in dict) {
	                sortedData.push(dict[key]);
	            }

	            return sortedData;
	        },

	        _isMobile: function() {
	            var options = this.options;
	            return (options.mobile === true && kendo.support.mobileOS) || options.mobile === "phone" || options.mobile === "tablet";
	        },

	        _isTouch: function(event) {
	            return /touch/.test(event.type) || (event.originalEvent && /touch/.test(event.originalEvent.pointerType));
	        },

	        _isInverseColor: function(eventElement) {
	            return eventElement.hasClass(INVERSECOLORCLASS);
	        },

	        _groupsByResource: function(resources, groupIndex, groupsArray, parentFieldValue, parentField) {
	            if (!groupsArray) {
	                groupsArray = [];
	            }

	            var resource = resources[0];
	            if (resource) {
	                var group;
	                var data = resource.dataSource.view();
	                var prevIndex = 0;

	                for (var dataIndex = 0; dataIndex < data.length; dataIndex++) {
	                    var fieldValue = kendo.getter(resource.dataValueField)(data[dataIndex]);
	                    var currentGroupIndex = groupIndex + prevIndex + dataIndex;

	                    group = this._groupsByResource(resources.slice(1), currentGroupIndex, groupsArray, fieldValue, resource.field);
	                    group[resource.field] = fieldValue;
	                    prevIndex = group.groupIndex;

	                    if (parentField && parentFieldValue) {
	                        group[parentField] = parentFieldValue;
	                    }

	                    if (resources.length === 1) {
	                        group.groupIndex = groupIndex + dataIndex;
	                        groupsArray.push(group);
	                    }
	                }
	                return group;
	            } else {
	                return {};
	            }
	        },

	        data: function () {
	            return this._data;
	        },

	        select: function (options) {
	            var that = this;
	            var view = that.view();
	            var selection = that._selection;
	            var groups = view.groups;
	            var selectedGroups;

	            if (options === undefined) {
	                var selectedEvents;
	                var slots = view._selectedSlots;

	                if(!selection) {
	                    return [];
	                }

	                if (selection && selection.events) {
	                    selectedEvents = that._selectedEvents();
	                }

	                return {
	                    start: selection.start,
	                    end: selection.end,
	                    events: selectedEvents,
	                    slots: slots,
	                    resources: view._resourceBySlot(selection)
	                };
	            }

	            if (!options) {
	                that._selection = null;
	                that._old = null;
	                view.clearSelection();

	                return;
	            }

	            if ($.isArray(options)) {
	                options = {
	                    events: options.splice(0)
	                };
	            }

	            if (options.resources) {
	                var fieldName;
	                var filters = [];
	                var groupsByResource = [];

	                if (view.groupedResources) {
	                    that._groupsByResource(view.groupedResources, 0, groupsByResource);
	                }

	                for (fieldName in options.resources) {
	                    filters.push({ field: fieldName, operator: "eq", value: options.resources[fieldName]});
	                }

	                selectedGroups = new kendo.data.Query(groupsByResource)
	                    .filter(filters)
	                    .toArray();
	            }

	            if (options.events && options.events.length) {
	                that._selectEvents(options.events, selectedGroups);
	                that._select();

	                return;
	            }

	            if (groups && (options.start && options.end)) {
	                var rangeStart = getDate(view._startDate);
	                var rangeEnd = kendo.date.addDays(getDate(view._endDate),1);
	                var group;
	                var ranges;

	                if (options.start < rangeEnd && rangeStart <= options.end) {
	                    if (selectedGroups && selectedGroups.length) {
	                        group = groups[selectedGroups[0].groupIndex];
	                    } else {
	                        group = groups[0];
	                    }

	                    if (!group.timeSlotCollectionCount()) {
	                        options.isAllDay = true;
	                    }

	                    ranges = group.ranges(options.start, options.end, options.isAllDay, false);

	                    if (ranges.length) {
	                        that._selection = {
	                            start: kendo.timezone.toLocalDate(ranges[0].start.start),
	                            end: kendo.timezone.toLocalDate(ranges[ranges.length-1].end.end),
	                            groupIndex: ranges[0].start.groupIndex,
	                            index: ranges[0].start.index,
	                            isAllDay: ranges[0].start.isDaySlot,
	                            events: []
	                        };

	                        that._select();
	                    }
	                }
	            }
	        },

	        _selectEvents: function (eventsUids, selectedGroups) {
	            var that = this;
	            var idx;
	            var view = that.view();
	            var groups = view.groups;
	            var eventsLength = eventsUids.length;
	            var isGrouped = selectedGroups && selectedGroups.length;

	            for (idx = 0; idx < eventsLength; idx++) {
	                if (groups && isGrouped) {
	                    var currentGroup = groups[selectedGroups[0].groupIndex];
	                    var events = [];
	                    var timeSlotCollectionCount = currentGroup.timeSlotCollectionCount();
	                    var daySlotCollectionCount = currentGroup.daySlotCollectionCount();

	                    for (var collIdx = 0; collIdx < timeSlotCollectionCount; collIdx++) {
	                        events = events.concat(currentGroup.getTimeSlotCollection(collIdx).events());
	                    }

	                    for (var dayCollIdx = 0; dayCollIdx < daySlotCollectionCount; dayCollIdx++) {
	                        events = events.concat(currentGroup.getDaySlotCollection(dayCollIdx).events());
	                    }

	                    events = new kendo.data.Query(events)
	                        .filter({field: "element[0].getAttribute('data-uid')", operator: "eq", value: eventsUids[idx]})
	                        .toArray();

	                    if (events[0]) {
	                        that._createSelection(events[0].element);
	                    }
	                } else {
	                    var element = view.element.find(kendo.format(".k-event[data-uid={0}], .k-task[data-uid={0}]", eventsUids[idx]));

	                    if (element.length) {
	                        that._createSelection(element[0]);
	                    }
	                }
	            }
	        },

	        _touchHandlers: function() {
	            var that = this;
	            var startX;
	            var startY;
	            var endX;
	            var endY;
	            var timeStamp;
	            var wrapper = that.wrapper;
	            var touchMoveHandler = $.proxy(that._touchMove, that);

	            wrapper.on(TOUCHSTART + NS, ".k-scheduler-header-all-day td, .k-scheduler-content td, .k-event", function(e) {
	                var content = that.wrapper.find(".k-scheduler-content");

	                if (!that._isTouch(e)) {
	                    return;
	                }

	                content.stop(true, false);

	                that._touchPosX = startX = that._tapPosition(e, 'X');
	                that._touchPosY = startY = that._tapPosition(e, 'Y');
	                that._userTouched = true;
	                that.view()._scrolling = false;
	                timeStamp = Date.now();

	                wrapper.on(TOUCHMOVE + NS, ".k-scheduler-header-all-day td, .k-scheduler-content td, .k-event", touchMoveHandler);
	            });

	            wrapper.on(TOUCHEND + NS, ".k-scheduler-header-all-day td, .k-scheduler-content td, .k-event", function(e) {
	                if (!that._isTouch(e)) {
	                    return;
	                }

	                var delta = Date.now() - timeStamp;
	                var content = that.wrapper.find(".k-scheduler-content");
	                var amplitude = -that._amplitude * (3000 / delta);

	                endX = that._tapPosition(e, 'X');
	                endY = that._tapPosition(e, 'Y');

	                if (that._dragging) {
	                    return;
	                }

	                if (that.options.selectable && (Math.abs(endX - startX) <= 10 || Math.abs(endY - startY) <= 10)) {
	                    that._mouseDownSelection(e);
	                }

	                if (!kendo.support.kineticScrollNeeded && delta < 200 && Math.abs(endX - startX) > 10) {
	                    content.animate({
	                        scrollTop: content[0].scrollTop + amplitude
	                    });
	                }

	                wrapper.off(TOUCHMOVE + NS, ".k-scheduler-header-all-day td, .k-scheduler-content td", touchMoveHandler);
	            });
	        },

	        _selectable: function() {
	            var that = this;
	            var wrapper = that.wrapper;

	            if (!that.options.selectable) {
	                return;
	            }

	            that._tabindex();

	            wrapper.on(MOUSEDOWN + NS, ".k-scheduler-header-all-day td, .k-scheduler-content td, .k-event", function (e) {
	                if (that._isTouch(e)) {
	                    return;
	                }
	                that._mouseDownSelection(e);
	            });

	            var mouseMoveHandler = $.proxy(that._mouseMove, that);

	            wrapper.on(MOUSEDOWN + NS, ".k-scheduler-header-all-day td, .k-scheduler-content td", function(e) {
	                var which = e.which;
	                var button = e.button;
	                var isRight = which && which === 3 || button && button == 2;

	                if (that._isTouch(e)) {
	                    return;
	                }

	                if (!isRight) {
	                    wrapper.on(MOUSEMOVE + NS, ".k-scheduler-header-all-day td, .k-scheduler-content td", mouseMoveHandler);
	                }
	            });

	            wrapper.on("mouseup" + NS + " mousecancel" + NS, function() {
	                wrapper.off(MOUSEMOVE + NS, ".k-scheduler-header-all-day td, .k-scheduler-content td", mouseMoveHandler);
	            });

	            wrapper.on("focus" + NS, function() {
	                if (!that._selection && !that._userTouched) {
	                    that._selectFirstSlot();
	                }

	                that._select();
	            });

	            wrapper.on("focusout" + NS, function(e) {
	                that._ctrlKey = that._shiftKey = false;

	                if (!$(e.relatedTarget).closest(VIEWSSELECTOR).length) {
	                    that.toolbar.find(VIEWSSELECTOR).removeClass(EXPANDEDSTATE);
	                }
	            });

	            wrapper.on("keydown" + NS, proxy(that._keydown, that));

	            wrapper.on("keyup" + NS, function(e) {
	                that._ctrlKey = e.ctrlKey;
	                that._shiftKey = e.shiftKey;
	            });
	        },

	        _mouseDownSelection: function(e) {
	            var which = e.which;
	            var button = e.button;
	            var isRight = which && which === 3 || button && button == 2;

	            if (!isRight) {
	                if( e.ctrlKey){
	                    this._ctrlKey = e.ctrlKey;
	                }

	                if(e.shiftKey){
	                    this._shiftKey = e.shiftKey;
	                }
	                this._createSelection(e.currentTarget);
	            }

	            if(kendo._activeElement() !== this.wrapper.get(0)){
	                kendo.focusElement(this.wrapper);
	            } else {
	                this._select();
	            }

	            if(this.toolbar){
	                this.toolbar.find("." + FOCUSEDSTATE).removeClass(FOCUSEDSTATE);
	            }
	        },

	        _selectFirstSlot: function() {
	            this._createSelection(this.wrapper.find(".k-scheduler-content").find("td:first"));
	        },

	        _select: function() {
	            var that = this;
	            var view = that.view();
	            var wrapper = that.wrapper;
	            var current = view.current();
	            var selection = that._selection;
	            var oldSelection = that._old ? that._old.selection : null;
	            var oldEventsLength = that._old ? that._old.eventsLength : null;
	            if (!selection) {
	                return;
	            }

	            if (current) {
	                current.removeAttribute("id");
	                current.removeAttribute("aria-label");
	                wrapper.removeAttr("aria-activedescendant");
	            }

	            view.select(selection);

	            current = view.current();
	            if (current && (oldSelection !== current || (selection.events && (oldEventsLength !== selection.events.length )))) {
	                var currentUid = $(current).data("uid");

	                if (that._old && currentUid &&
	                    currentUid === $(that._old.selection).data("uid") &&
	                    (selection.events && that._old.eventsLength === selection.events.length)) {
	                    return;
	                }

	                var labelFormat;
	                var data = selection;
	                var events = that._selectedEvents();
	                var slots = view._selectedSlots;

	                if (events[0]) {
	                    data = events[0] || selection;
	                    labelFormat = kendo.format(that.options.messages.ariaEventLabel, data.title, data.start, data.start);
	                } else {
	                    labelFormat = kendo.format(that.options.messages.ariaSlotLabel, data.start, data.end);
	                }

	                current.setAttribute("id", that._ariaId);
	                current.setAttribute("aria-label", labelFormat);
	                wrapper.attr("aria-activedescendant", that._ariaId);

	                that._old ={
	                    selection:current,
	                    eventsLength: events.length
	                };

	                that.trigger("change", {
	                    start: selection.start,
	                    end: selection.end,
	                    events: events,
	                    slots: slots,
	                    resources: view._resourceBySlot(selection)
	                });
	            }
	        },

	        _selectedEvents: function() {
	            var uids = this._selection.events;
	            var length = uids.length;
	            var idx = 0;
	            var event;

	            var events = [];

	            for (; idx < length; idx++) {
	                event = this.occurrenceByUid(uids[idx]);
	                if (event) {
	                    events.push(event);
	                }
	            }

	            return events;
	        },

	        _tapPosition: function (event, coordinate) {
	            return /touch/.test(event.type) ? (event.originalEvent || event).changedTouches[0]['page' + coordinate] : event['page' + coordinate];
	        },

	        _touchMove: function (e) {
	            var that = this;
	            var content = that.wrapper.find(".k-scheduler-content");
	            var verticalScroll = content[0].scrollHeight > content[0].clientHeight;
	            var horizontalScroll = content[0].scrollWidth > content[0].clientWidth;
	            var endY = that._tapPosition(e, 'Y');
	            var endX = that._tapPosition(e, 'X');
	            var scrollTop = content[0].scrollTop - Math.round(endY - that._touchPosY);
	            var scrollLeft = content[0].scrollLeft - Math.round(endX - that._touchPosX);
	            var applyVerticalScroll = verticalScroll && Math.abs(endY - that._touchPosY) > 10;
	            var applyhorizontalScroll = horizontalScroll && Math.abs(endY - that._touchPosY) > 10;


	            if (that._dragging || kendo.support.kineticScrollNeeded || !that._isTouch(e)) {
	                return;
	            }

	            if (applyVerticalScroll || applyhorizontalScroll) {
	                that._amplitude = Math.round(endY - that._touchPosY);
	                that._touchPosY = endY;
	                that._touchPosX = endX;
	                content.animate({
	                    scrollTop: scrollTop,
	                    scrollLeft: scrollLeft
	                }, 0);
	                that.view()._scrolling = true;
	            }
	        },

	        _mouseMove: function(e) {
	            var that = this;
	            clearTimeout(that._moveTimer);

	            if (that._isTouch(e)) {
	                return;
	            }

	            that._moveTimer = setTimeout(function() {
	                var view = that.view();
	                var selection = that._selection;

	                if (selection) {
	                    var slot = view.selectionByElement($(e.currentTarget));

	                    if (slot && selection.groupIndex === slot.groupIndex) {
	                        var startDate = slot.startDate();
	                        var endDate = slot.endDate();

	                        if (startDate >= selection.end) {
	                            selection.backward = false;
	                        } else if (endDate <= selection.start) {
	                            selection.backward = true;
	                        }

	                        if (selection.backward) {
	                            selection.start = startDate;
	                        } else {
	                            selection.end = endDate;
	                        }

	                        that._select();
	                    }
	                }
	            }, 5);
	        },

	        _viewByIndex: function(index) {
	            var view, views = this.views;

	            for (view in views) {
	                if (!index) {
	                    return view;
	                }

	                index--;
	            }
	        },

	        _keydown: function(e) {
	            var that = this,
	                key = e.keyCode,
	                view = that.view(),
	                editable = view.options.editable,
	                selection = that._selection,
	                prevSelection = $.extend(selection),
	                isModifier = key === 16 || key === 18 || key === 17 || key === 91 || key === 92,
	                focusableToolBarSelector = "> .k-button," +
	                                    ".k-scheduler-navigation > .k-button," +
	                                    ".k-nav-current," +
	                                    ".k-views-dropdown:visible," +
	                                    ".k-scheduler-views > .k-button",
	                focusableItems = that.toolbar.find(focusableToolBarSelector),
	                viewsWrapper = that.toolbar.find(VIEWSSELECTOR),
	                shouldNavigate = $(e.target).closest(VIEWSSELECTOR).length || that.toolbar.find('.k-scheduler-views .k-state-focused').length,
	                focusedViewIndex = viewsWrapper.children().index(that.toolbar.find("." + FOCUSEDSTATE)),
	                isRtl =  kendo.support.isRtl(that.element),
	                isViewsDropDown = $(e.target).is(".k-views-dropdown"),
	                direction = isRtl ? -1 : 1;

	            if (focusedViewIndex == -1) {
	                focusedViewIndex = viewsWrapper.children().index(that.toolbar.find(".k-state-selected"));
	            }

	            that._ctrlKey = e.ctrlKey;
	            that._shiftKey = e.shiftKey;

	            if (key === keys.F10) {
	                that._focusToolbar();
	                e.preventDefault();
	                return;
	            } else if (key === keys.TAB) {
	                if (that.toolbar.find("." + FOCUSEDSTATE).length) {
	                    var idx = focusableItems.index(that.toolbar.find("." + FOCUSEDSTATE));
	                    var itemToFocus = e.shiftKey ? focusableItems[idx -  1] : focusableItems[idx +  1];
	                    that.toolbar.find("." + FOCUSEDSTATE).removeClass(FOCUSEDSTATE);
	                    if (itemToFocus) {
	                        $(itemToFocus).addClass(FOCUSEDSTATE).focus();
	                        that._focusedView = null;
	                        e.preventDefault();
	                        return;
	                    } else {
	                        that.element.focus();
	                        e.preventDefault();
	                        return;
	                    }
	                }
	            } else if (key === keys.ENTER || key === keys.SPACEBAR) {
	                if (shouldNavigate && that._focusedView && !that._focusedView.hasClass("k-state-selected")) {
	                    var focusedViewName = that._focusedView.data().name;

	                    if (!that.trigger("navigate", { view: focusedViewName, action: "changeView", date: that.date() })) {
	                        that.view(focusedViewName);
	                    }
	                    e.preventDefault();
	                    return;
	                }

	                if (that.toolbar.find("." + FOCUSEDSTATE + ':visible').length) {
	                    that.toolbar.find("." + FOCUSEDSTATE + ':visible').click();
	                    e.preventDefault();
	                    return;
	                }
	            } else if (e.altKey && key === keys.DOWN  && !isViewsDropDown) {
	                if (that.toolbar.find("." + FOCUSEDSTATE + ':visible').length) {
	                    that.toolbar.find("." + FOCUSEDSTATE + ':visible').click();
	                    e.preventDefault();
	                    return;
	                }
	            } else if (key === keys.RIGHT && shouldNavigate) {
	                $(that.toolbar.find("." + FOCUSEDSTATE)).removeClass(FOCUSEDSTATE);
	                if (isRtl) {
	                    that._focusedView = focusedViewIndex - 1 === 0 ? $(viewsWrapper.children(":last")) : $(viewsWrapper.children()[focusedViewIndex + (1 * direction)]);
	                } else {
	                    that._focusedView = focusedViewIndex + 1 === viewsWrapper.children().length ? $(viewsWrapper.children(":first")) : $(viewsWrapper.children()[focusedViewIndex + (1 * direction)]);
	                }
	                that._focusedView.focus().addClass(FOCUSEDSTATE);
	                e.preventDefault();
	                return;
	            } else if (key === keys.LEFT && shouldNavigate) {
	                $(that.toolbar.find("." + FOCUSEDSTATE)).removeClass(FOCUSEDSTATE);
	                if (isRtl) {
	                    that._focusedView = focusedViewIndex + 1 === viewsWrapper.children().length ? $(viewsWrapper.children(":first")) : $(viewsWrapper.children()[focusedViewIndex - (1 * direction)]);
	                } else {
	                    that._focusedView = focusedViewIndex - 1 < 0 ? $(viewsWrapper.children(":last")) : $(viewsWrapper.children()[focusedViewIndex - (1 * direction)]);
	                }
	                that._focusedView.focus().addClass(FOCUSEDSTATE);
	                e.preventDefault();
	                return;
	            } else if (e.altKey && key === keys.DOWN && that.toolbar.find(".k-nav-current").hasClass(FOCUSEDSTATE)) {
	                that._showCalendar();
	                e.preventDefault();
	                return;
	            } else if (e.altKey && key === keys.DOWN && isViewsDropDown) {
	                return;
	            } else if (key === keys.ESC && that.popup && that.popup.visible()) {
	                that.popup.close();
	                e.preventDefault();
	                return;
	            }

	            if (isModifier) {
	                return;
	            }

	            if (!selection) {
	                that._selectFirstSlot();
	                that._select();
	                that.element.focus();

	                return;
	            }

	            if (key === keys.TAB) {
	                if (view.moveToEvent(selection, e.shiftKey)) {
	                    that._select();

	                    // Focus the Scheduler element only if it not the currently focused element
	                    if(document.activeElement.getAttribute("id") !== that.element.attr("id")) {
	                        that.element.focus();
	                    }

	                    e.preventDefault();
	                } else {
	                    that._focusToolbar();
	                    e.preventDefault();
	                    return;
	                }
	            } else if (key === keys.ENTER || key === keys.SPACEBAR) {
	                if (selection.events.length && editable) {
	                    if (editable.update !== false) {
	                        that.editEvent(selection.events[0]);
	                    }
	                } else if (editable && editable.create !== false) {
	                    if (selection.isAllDay) {
	                        selection = $.extend({}, selection, {
	                            end: kendo.date.addDays(selection.end, -1)
	                        });
	                    }

	                    e.preventDefault();
	                    that.addEvent(extend({}, selection, view._resourceBySlot(selection)));
	                }
	            } else if (key === keys.DELETE && editable !== false && editable.destroy !== false) {
	                that.removeEvent(selection.events[0]);
	            } else if (key >= 49 && key <= 57) {
	                // switch to view 1-9
	                var viewByIndex = that._viewByIndex(key - 49);
	                if (viewByIndex && !that.trigger("navigate", { view: viewByIndex, action: "changeView", date: that.date() })) {
	                    that.view(viewByIndex);
	                }
	            } else if (view.move(selection, key, e.shiftKey)) {
	                if (view.inRange(selection)) {
	                    that._select();

	                    // prevents trapping focus in pseudo toolbar - remove when toolbar widget is integrated
	                    $(document.activeElement).blur();
	                    that.toolbar.find("." + FOCUSEDSTATE).removeClass(FOCUSEDSTATE);
	                    that.wrapper.focus();
	                } else {
	                    var action  = that.date().getTime() > selection.start.getTime() ? "previous": "next";
	                    if (!that.trigger("navigate", { view: that._selectedViewName, action: action, date: selection.start })) {
	                        that.date(selection.start);
	                    } else {
	                        selection.start = prevSelection.start;
	                        selection.end = prevSelection.end;
	                    }
	                }

	                e.preventDefault();
	            }

	            that._adjustSelectedDate();
	        },

	        _focusToolbar: function() {
	            this.toolbar.find(".k-button:first")
	                .focus()
	                .addClass(FOCUSEDSTATE);
	        },

	        _createSelection: function (item) {
	            var selection = this._selection;
	            var uid;
	            var slot;

	            item = $(item);

	            if (item.is(".k-event")) {
	                uid = item.attr(kendo.attr("uid"));

	                if (selection && selection.events.indexOf(uid) !== -1 && !this._ctrlKey) {
	                    return;
	                }
	            }

	            if (!selection || (!this._ctrlKey && !this._shiftKey)) {
	                selection = this._selection = {
	                    events: [],
	                    groupIndex: 0
	                };
	            }

	            slot = this.view().selectionByElement(item);

	            if (slot) {
	                selection.groupIndex = slot.groupIndex || 0;
	            }

	            if (uid) {
	                slot = getOccurrenceByUid(this._data, uid);
	            }

	            if (slot && slot.uid) {
	                uid = [slot.uid];
	            }

	            this._updateSelection(slot, uid);
	            this._adjustSelectedDate();
	        },

	        _updateSelection: function(dataItem, events, groupIndex) {
	            var selection = this._selection;

	            if (dataItem && selection) {
	                var view =  this.view();

	                if (dataItem.uid) {
	                    dataItem = view._updateEventForSelection(dataItem);
	                }

	                if (this._shiftKey && selection.start && selection.end) {
	                    var backward = dataItem.end < selection.end;

	                    selection.end = dataItem.endDate ? dataItem.endDate() : dataItem.end;

	                    if (backward && view._timeSlotInterval) {
	                        kendo.date.setTime(selection.end, -view._timeSlotInterval());
	                    }
	                } else {
	                    selection.start = dataItem.startDate ? dataItem.startDate() : dataItem.start;
	                    selection.end = dataItem.endDate ? dataItem.endDate() : dataItem.end;
	                }

	                if ("isDaySlot" in dataItem) {
	                    selection.isAllDay = dataItem.isDaySlot;
	                } else {
	                    selection.isAllDay = dataItem.isAllDay;
	                }

	                if (groupIndex !== null && groupIndex !== undefined) {
	                    selection.groupIndex = groupIndex;
	                }

	                selection.index = dataItem.index;
	                if (this._ctrlKey) {
	                    var indexOfEvent = (events && events.length) ? selection.events.indexOf(events[0]): -1;

	                    if(indexOfEvent > -1){
	                        selection.events.splice(indexOfEvent, 1);
	                    }else{
	                        selection.events = selection.events.concat(events || []);
	                    }
	                } else {
	                        selection.events = events || [];
	                }
	            }
	        },

	        options: {
	            name: "Scheduler",
	            date: TODAY,
	            editable: true,
	            autoBind: true,
	            snap: true,
	            mobile: false,
	            timezone: "",
	            allDaySlot: true,
	            min: new Date(1900, 0, 1),
	            max: new Date(2099, 11, 31),
	            toolbar: null,
	            workWeekStart: 1,
	            workWeekEnd: 5,
	            workDays: null,
	            showWorkHours: false,
	            startTime: TODAY,
	            endTime: TODAY,
	            currentTimeMarker: {
	                updateInterval: 10000,
	                useLocalTimezone: true
	            },
	            footer: {},
	            messages: {
	                today: "Today",
	                pdf: "Export to PDF",
	                save: "Save",
	                cancel: "Cancel",
	                destroy: "Delete",
	                resetSeries: "Reset Series",
	                deleteWindowTitle: "Delete event",
	                next: "Next",
	                previous: "Previous",
	                ariaSlotLabel: "Selected from {0:t} to {1:t}",
	                ariaEventLabel: "{0} on {1:D} at {2:t}",
	                views: {
	                    day: "Day",
	                    week: "Week",
	                    workWeek: "Work Week",
	                    agenda: "Agenda",
	                    month: "Month",
	                    timeline: "Timeline",
	                    timelineWeek: "Timeline Week",
	                    timelineWorkWeek: "Timeline Work Week",
	                    timelineMonth: "Timeline Month"
	                },
	                recurrenceMessages: {
	                    deleteWindowTitle: "Delete Recurring Item",
	                    resetSeriesWindowTitle: "Reset Series",
	                    deleteWindowOccurrence: "Delete current occurrence",
	                    deleteWindowSeries: "Delete the series",
	                    editWindowTitle: "Edit Recurring Item",
	                    editWindowOccurrence: "Edit current occurrence",
	                    editWindowSeries: "Edit the series"
	                },
	                editable: {
	                    confirmation: DELETECONFIRM
	                },
	                editor: {
	                    title: "Title",
	                    start: "Start",
	                    end: "End",
	                    allDayEvent: "All day event",
	                    description: "Description",
	                    repeat: "Repeat",
	                    timezone: "Timezone",
	                    startTimezone: "Start timezone",
	                    endTimezone: "End timezone",
	                    separateTimezones: "Use separate start and end time zones",
	                    timezoneEditorTitle: "Timezones",
	                    timezoneEditorButton: "Time zone",
	                    timezoneTitle: "Time zones",
	                    noTimezone: "No timezone",
	                    editorTitle: "Event"
	                }
	            },
	            height: null,
	            width: null,
	            resources: [],
	            group: {
	                resources: [],
	                orientation: "horizontal"
	            },
	            views: [],
	            selectable: false
	        },

	        events: [
	            REMOVE,
	            EDIT,
	            CANCEL,
	            SAVE,
	            "add",
	            "dataBinding",
	            "dataBound",
	            "moveStart",
	            "move",
	            "moveEnd",
	            "resizeStart",
	            "resize",
	            "resizeEnd",
	            "navigate",
	            "change"
	        ],

	        destroy: function() {
	            var that = this,
	                element;

	            Widget.fn.destroy.call(that);

	            if (that.dataSource) {
	                that.dataSource.unbind(CHANGE, that._refreshHandler);
	                that.dataSource.unbind(PROGRESS, that._progressHandler);
	                that.dataSource.unbind(ERROR, that._errorHandler);
	            }

	            if(that._resourceRefreshHandler) {
	                for (var idx = 0; idx < that.resources.length; idx++) {
	                    var resourceDS = that.resources[idx].dataSource;
	                    resourceDS.unbind(CHANGE, that._resourceRefreshHandler);
	                    resourceDS.unbind(PROGRESS, that._resourceProgressHandler);
	                    resourceDS.unbind(ERROR, that._resourceErrorHandler);
	                }
	            }

	            if (that.calendar) {
	                that.calendar.destroy();
	                that.popup.destroy();
	            }

	            if (that.view()) {
	                that.view().destroy();
	            }

	            if (that._editor) {
	                that._editor.destroy();
	            }

	            if (this._moveDraggable) {
	                this._moveDraggable.destroy();
	            }

	            if (this._resizeDraggable) {
	                this._resizeDraggable.destroy();
	            }

	            element = that.element
	                .add(that.wrapper)
	                .add(that.toolbar)
	                .add(that.popup);

	            element.off(NS);

	            clearTimeout(that._moveTimer);

	            that._model = null;
	            that.toolbar = null;
	            that.element = null;

	            $(window).off("resize" + NS, that._resizeHandler);

	            kendo.destroy(that.wrapper);
	        },

	        setDataSource: function(dataSource) {
	            this.options.dataSource = dataSource;

	            this._dataSource();

	            if (this.options.autoBind && dataSource.fetch) {
	                dataSource.fetch();
	            } else if (isArray(dataSource)) {
	                this.view(this._selectedView);
	            }
	        },

	        items: function() {
	            var content = this.wrapper.find(".k-scheduler-content");
	            var view = this.view();

	            if (view && view.options.name === "agenda") {
	                return content.find(".k-task");
	            } else {
	                return content.find(".k-event")
	                              .add(this.wrapper.find(".k-scheduler-header-wrap")
	                                       .find(".k-scheduler-header-all-day").siblings());
	            }
	        },

	        _movable: function() {
	            var startSlot;
	            var endSlot;
	            var startResources;
	            var startTime;
	            var endTime;
	            var event;
	            var clonedEvent;
	            var that = this;
	            var originSlot;
	            var originStartTime;
	            var originalEvent;
	            var distance = 0;
	            var clonedEvents = [];
	            var cachedEvents = [];

	            var isMobile = that._isMobile();
	            var movable = that.options.editable && that.options.editable.move !== false;
	            var resizable = that.options.editable && that.options.editable.resize !== false;

	            if (movable || (resizable && isMobile)) {
	                that._dragging = false;
	                if (isMobile && kendo.support.mobileOS.android) {
	                    distance = 5;
	                }

	                that._moveDraggable = new kendo.ui.Draggable(that.element, {
	                    distance: distance,
	                    filter: ".k-event",
	                    ignore: ".k-resize-handle",
	                    holdToDrag: isMobile,
	                    autoScroll: true
	                });

	                if (movable) {
	                    that._moveDraggable.bind("dragstart", function(e) {
	                        var view = that.view();
	                        var eventElement = e.currentTarget;
	                        var isTouch = that._isTouch(e);
	                        that._dragging = true;

	                        if (!view.options.editable || view.options.editable.move === false) {
	                            that._dragging = false;
	                            e.preventDefault();
	                            return;
	                        }

	                        if (isTouch && !eventElement.hasClass("k-event-active")) {
	                            that._dragging = false;
	                            that.element.find(".k-event-active").removeClass("k-event-active");
	                            e.preventDefault();
	                            return;
	                        }

	                        event = that.occurrenceByUid(eventElement.attr(kendo.attr("uid")));

	                        clonedEvent = event.clone();
	                        originalEvent = event.clone();

	                        clonedEvent.update(view._eventOptionsForMove(clonedEvent));

	                        clonedEvent.inverseColor = that._isInverseColor(eventElement);

	                        clonedEvents = [];
	                        if (that._selection) {
	                            var events = that._selection.events;

	                            for (var i = 0; i < events.length; i++) {
	                                var evtClone = that.occurrenceByUid(events[i]).clone();
	                                var evtCloneElement = this.element.find('div.k-event[data-uid="' + evtClone.uid + '"]').eq(0);

	                                evtClone.update(view._eventOptionsForMove(evtClone));

	                                if(evtCloneElement.length) {
	                                    evtClone.inverseColor = that._isInverseColor(evtCloneElement);
	                                }

	                                clonedEvents.push(evtClone);
	                            }
	                        } else {
	                            clonedEvents.push(clonedEvent);
	                        }

	                        startSlot = view._slotByPosition(e.x.startLocation, e.y.startLocation);
	                        startResources = view._resourceBySlot(startSlot);

	                        originStartTime = startTime = startSlot.startOffset(e.x.startLocation, e.y.startLocation, that.options.snap);

	                        endSlot = startSlot;

	                        originSlot = startSlot;

	                        if (!startSlot || that.trigger("moveStart", { event: event })) {
	                            e.preventDefault();
	                        }
	                    })
	                    .bind("drag", function(e) {
	                        var view = that.view();
	                        var slot = view._slotByPosition(e.x.location, e.y.location);
	                        var distance;
	                        var range;
	                        var i;

	                        if (!slot) {
	                            return;
	                        }

	                        endTime = slot.startOffset(e.x.location, e.y.location, that.options.snap);

	                        if (slot.isDaySlot !== startSlot.isDaySlot) {

	                            if (slot.isDaySlot !== originSlot.isDaySlot) {
	                                var slotIndex = $(startSlot.element).index();

	                                var targetSlotElement = $(slot.element).parent().children().eq(slotIndex);

	                                startSlot = view._slotByPosition(targetSlotElement.offset().left, targetSlotElement.offset().top);

	                                startTime = startSlot.startOffset(e.x.location, e.y.location, true);

	                                cachedEvents = clonedEvents.map(function(event) { return event.clone(); });

	                                for (i = 0; i < clonedEvents.length; i++) {
	                                    if (clonedEvents[i].isAllDay != slot.isDaySlot) {
	                                        clonedEvents[i].isAllDay = slot.isDaySlot;

	                                        clonedEvents[i].end = kendo.date.getDate(clonedEvents[i].start);
	                                        clonedEvents[i].start = kendo.date.getDate(clonedEvents[i].start);

	                                        if (!slot.isDaySlot) {
	                                            kendo.date.setTime(clonedEvents[i].start, kendo.date.getMilliseconds(view.startTime()));
	                                            kendo.date.setTime(clonedEvents[i].end, kendo.date.getMilliseconds(view.startTime()) + view._timeSlotInterval());
	                                        }
	                                    }
	                                }
	                            } else {
	                                startSlot = $.extend(true, { }, originSlot);
	                                startTime = originStartTime;

	                                clonedEvents = cachedEvents;
	                            }
	                        }

	                        distance = endTime - startTime;

	                        for (i = 0; i < clonedEvents.length; i++) {
	                            view._updateMoveHint(clonedEvents[i], slot.groupIndex, distance);
	                        }

	                        range = moveEventRange(clonedEvent, distance);

	                        if (!that.trigger("move", {
	                            event: event,
	                            slot: { element: slot.element, start: slot.startDate(), end: slot.endDate(), isDaySlot: slot.isDaySlot },
	                            resources: view._resourceBySlot(slot),
	                            start: range.start,
	                            end: range.end
	                        })) {
	                            endSlot = slot;
	                        } else {
	                            for (i = 0; i < clonedEvents.length; i++) {
	                                view._updateMoveHint(clonedEvents[i], slot.groupIndex, distance);
	                            }
	                        }
	                    })
	                    .bind("dragend", function(e) {
	                        that.view()._removeMoveHint();
	                        var distance = endTime - startTime;
	                        var range = moveEventRange(clonedEvent, distance);
	                        var start = range.start;
	                        var end = range.end;
	                        that._dragging = false;

	                        var endResources = that.view()._resourceBySlot(endSlot);

	                        var prevented = that.trigger("moveEnd", {
	                            event: event,
	                            slot: { element: endSlot.element, start: endSlot.startDate(), end: endSlot.endDate() },
	                            start: start,
	                            end: end,
	                            resources: endResources
	                        });

	                        if (!prevented && (event.start.getTime() !== start.getTime() ||
	                            event.end.getTime() !== end.getTime() ||
	                            originSlot.isDaySlot !== endSlot.isDaySlot ||
	                            kendo.stringify(endResources) !== kendo.stringify(startResources))) {

	                            that._isMultiDrag = clonedEvents.length > 1;

	                            for (var i = 0; i < clonedEvents.length; i++) {
	                                var evt = clonedEvents[i];

	                                range = moveEventRange(evt, distance);

	                                var updatedEventOptions = that.view()._eventOptionsForMove(evt);
	                                var eventOptions = $.extend(
	                                    {
	                                        isAllDay: evt.isAllDay,
	                                        start: range.start,
	                                        end: range.end
	                                    },
	                                    updatedEventOptions,
	                                    endResources
	                                );

	                                that._updateEvent(null, evt, eventOptions);
	                            }

	                            if (that._isMultiDrag) {
	                                that.dataSource.sync();
	                                that._isMultiDrag = false;
	                            }
	                        }

	                        e.currentTarget.removeClass("k-event-active");
	                        this.cancelHold();
	                        clonedEvents = [];
	                        cachedEvents = [];
	                    })
	                    .bind("dragcancel", function() {
	                        that.view()._removeMoveHint();
	                        this.cancelHold();
	                        clonedEvents = [];
	                        cachedEvents = [];
	                    });
	                }

	                that._moveDraggable.bind("hold", function(e) {
	                    if (that._isTouch(e)) {
	                        that.element.find(".k-event-active").removeClass("k-event-active");
	                        if (that.options.selectable) {
	                            that._createSelection(e.currentTarget);
	                        }
	                        e.currentTarget.addClass("k-event-active");
	                    }
	                });
	            }
	        },

	        _resizable: function() {
	            var startTime;
	            var endTime;
	            var event;
	            var clonedEvent;
	            var slot;
	            var that = this;
	            var distance = 0;

	            function direction(handle) {
	                var directions = {
	                    "k-resize-e": "east",
	                    "k-resize-w": "west",
	                    "k-resize-n": "north",
	                    "k-resize-s": "south"
	                };

	                for (var key in directions) {
	                    if (handle.hasClass(key)) {
	                        return directions[key];
	                    }
	                }
	            }

	            if (that._isMobile() && kendo.support.mobileOS.android) {
	                distance = 5;
	            }

	            that._resizeDraggable = new kendo.ui.Draggable(that.element, {
	                distance: distance,
	                filter: ".k-resize-handle",
	                autoScroll: true,
	                dragstart: function(e) {
	                    var dragHandle = $(e.currentTarget);

	                    var eventElement = dragHandle.closest(".k-event");

	                    var uid = eventElement.attr(kendo.attr("uid"));

	                    var view = that.view();

	                    that._dragging = true;
	                    event = that.occurrenceByUid(uid);

	                    clonedEvent = event.clone();

	                    view._updateEventForResize(clonedEvent);

	                    slot = view._slotByPosition(e.x.startLocation, e.y.startLocation);

	                    if (that.trigger("resizeStart", { event: event })) {
	                        e.preventDefault();
	                    }

	                    startTime = kendo.date.toUtcTime(clonedEvent.start);

	                    endTime = kendo.date.toUtcTime(clonedEvent.end);
	                },
	                drag: function(e) {
	                    if (!slot) {
	                        return;
	                    }

	                    var dragHandle = $(e.currentTarget);

	                    var dir = direction(dragHandle);

	                    var view = that.view();

	                    var currentSlot = view._slotByPosition(e.x.location, e.y.location);

	                    if (!currentSlot || slot.groupIndex != currentSlot.groupIndex) {
	                        return;
	                    }

	                    slot = currentSlot;

	                    var originalStart = startTime;

	                    var originalEnd = endTime;

	                    if (dir == "south") {
	                        if (!slot.isDaySlot && slot.end - kendo.date.toUtcTime(clonedEvent.start) >= view._timeSlotInterval()) {
	                            if (clonedEvent.isAllDay) {
	                                endTime = slot.startOffset(e.x.location, e.y.location, that.options.snap);
	                            } else {
	                                endTime = slot.endOffset(e.x.location, e.y.location, that.options.snap);
	                            }
	                        }
	                    } else if (dir == "north") {
	                        if (!slot.isDaySlot && kendo.date.toUtcTime(clonedEvent.end) - slot.start >= view._timeSlotInterval()) {
	                            startTime = slot.startOffset(e.x.location, e.y.location, that.options.snap);
	                        }
	                    } else if (dir == "east") {
	                        if (slot.isDaySlot && kendo.date.toUtcTime(kendo.date.getDate(slot.endDate())) >= kendo.date.toUtcTime(kendo.date.getDate(clonedEvent.start))) {
	                            if (clonedEvent.isAllDay) {
	                                endTime = slot.startOffset(e.x.location, e.y.location, that.options.snap);
	                            } else {
	                                endTime = slot.endOffset(e.x.location, e.y.location, that.options.snap);
	                            }
	                        } else if (!slot.isDaySlot && slot.end - kendo.date.toUtcTime(clonedEvent.start) >= view._timeSlotInterval()) {
	                            endTime = slot.endOffset(e.x.location, e.y.location, that.options.snap);
	                        }
	                    } else if (dir == "west") {
	                        if (slot.isDaySlot && kendo.date.toUtcTime(kendo.date.getDate(clonedEvent.end)) >= kendo.date.toUtcTime(kendo.date.getDate(slot.startDate()))) {
	                            startTime = slot.startOffset(e.x.location, e.y.location, that.options.snap);
	                        } else if (!slot.isDaySlot && kendo.date.toUtcTime(clonedEvent.end) - slot.start >= view._timeSlotInterval()) {
	                            startTime = slot.startOffset(e.x.location, e.y.location, that.options.snap);
	                        }
	                    }

	                    if (!that.trigger("resize", {
	                        event: event,
	                        slot: { element: slot.element, start: slot.startDate(), end: slot.endDate() },
	                        start: kendo.timezone.toLocalDate(startTime),
	                        end: kendo.timezone.toLocalDate(endTime),
	                        resources: view._resourceBySlot(slot)
	                    })) {
	                        view._updateResizeHint(clonedEvent, slot.groupIndex, startTime, endTime);
	                    } else {
	                        startTime = originalStart;
	                        endTime = originalEnd;
	                    }
	                },
	                dragend: function(e) {
	                    var dragHandle = $(e.currentTarget);
	                    var start = new Date(clonedEvent.start.getTime());
	                    var end = new Date(clonedEvent.end.getTime());
	                    var dir = direction(dragHandle);

	                    that._dragging = false;
	                    that.view()._removeResizeHint();

	                    if (dir == "south") {
	                        end = kendo.timezone.toLocalDate(endTime);
	                    } else if (dir == "north") {
	                        start = kendo.timezone.toLocalDate(startTime);
	                    } else if (dir == "east") {
	                        if (slot.isDaySlot) {
	                            end = kendo.date.getDate(kendo.timezone.toLocalDate(endTime));
	                        } else {
	                            end = kendo.timezone.toLocalDate(endTime);
	                        }
	                    } else if (dir == "west") {
	                        if (slot.isDaySlot) {
	                            start = new Date(kendo.timezone.toLocalDate(startTime));
	                            start.setHours(0);
	                            start.setMinutes(0);
	                        } else {
	                            start = kendo.timezone.toLocalDate(startTime);
	                        }
	                    }

	                    var prevented = that.trigger("resizeEnd", {
	                        event: event,
	                        slot: { element: slot.element, start: slot.startDate(), end: slot.endDate() },
	                        start: start,
	                        end: end,
	                        resources: that.view()._resourceBySlot(slot)
	                    });

	                    if (!prevented && end.getTime() >= start.getTime()) {
	                        if (clonedEvent.start.getTime() != start.getTime() || clonedEvent.end.getTime() != end.getTime()) {
	                            that.view()._updateEventForResize(event);
	                            that._updateEvent(dir, event, { start: start, end: end });
	                        }
	                    }

	                    slot = null;
	                    event = null;
	                },
	                dragcancel: function() {
	                    that._dragging = false;
	                    that.view()._removeResizeHint();

	                    slot = null;
	                    event = null;
	                }
	            });
	        },

	        _updateEvent: function(dir, event, eventInfo) {
	            var that = this;

	            var updateEvent = function(event, callback) {
	                try {
	                    that._preventRefresh = true;
	                    event.update(eventInfo);
	                    that._convertDates(event);
	                } finally {
	                    that._preventRefresh = false;
	                }

	                if (!that.trigger(SAVE, { event: event })) {
	                    if (callback) {
	                        callback();
	                    }

	                    if (!that._isMultiDrag) {
	                        that.dataSource.sync();
	                    }
	                }
	            };

	            var recurrenceHead = function(event) {
	                if (event.recurrenceRule) {
	                    return that.dataSource.getByUid(event.uid);
	                } else {
	                    return that.dataSource.get(event.recurrenceId);
	                }
	            };

	            var updateSeries = function() {
	                var head = recurrenceHead(event);

	                if (dir == "south" || dir == "north") {
	                    if (eventInfo.start) {
	                        var start = kendo.date.getDate(head.start);
	                        kendo.date.setTime(start, getMilliseconds(eventInfo.start));
	                        eventInfo.start = start;
	                    }
	                    if (eventInfo.end) {
	                        var end = kendo.date.getDate(head.end);
	                        kendo.date.setTime(end, getMilliseconds(eventInfo.end));
	                        eventInfo.end = end;
	                    }
	                }

	                that.dataSource._removeExceptions(head);

	                updateEvent(head);
	            };

	            var updateOccurrence = function() {
	                var head = recurrenceHead(event);
	                var eventUid;

	                var callback = function() {
	                    that._convertDates(head);

	                    if (that._selection) {
	                        that._selection.events.push(eventUid);
	                    }
	                };

	                var exception = head.toOccurrence({ start: event.start, end: event.end });

	                eventUid = exception.uid;

	                updateEvent(that.dataSource.add(exception), callback);
	            };

	            if (event.recurrenceRule || event.isOccurrence()) {
	                var recurrenceMessages = that.options.messages.recurrenceMessages;

	                that._showRecurringDialog(event, updateOccurrence, updateSeries,{
	                    title: recurrenceMessages.editWindowTitle,
	                    text: recurrenceMessages.editRecurring ? recurrenceMessages.editRecurring : EDITRECURRING,
	                    occurrenceText: recurrenceMessages.editWindowOccurrence,
	                    seriesText: recurrenceMessages.editWindowSeries
	                });
	            } else {
	                updateEvent(that.dataSource.getByUid(event.uid));
	            }
	        },

	        _modelForContainer: function(container) {
	            container = $(container).closest("[" + kendo.attr("uid") + "]");

	            return this.dataSource.getByUid(container.attr(kendo.attr("uid")));
	        },

	        showDialog: function(options) {
	            this._editor.showDialog(options);
	        },

	        focus: function() {
	            this.wrapper.focus();
	        },

	        _confirmation: function(callback, model, isResetSeries) {
	            var editable = this.options.editable;

	            if (editable === true || editable.confirmation !== false) {
	                var messages = this.options.messages;
	                var title = messages.deleteWindowTitle;
	                var text = typeof editable.confirmation === STRING ? editable.confirmation : messages.editable.confirmation;

	                if (this._isEditorOpened() && model.isRecurring()) {
	                    var recurrenceMessages = this.options.messages.recurrenceMessages;
	                    title = recurrenceMessages.deleteWindowTitle;

	                    if (model.isException() || model.isNew()) {
	                        text = recurrenceMessages.deleteRecurringConfirmation ? recurrenceMessages.deleteRecurringConfirmation : DELETERECURRINGCONFIRM;
	                    } else {
	                        text = recurrenceMessages.deleteSeriesConfirmation ? recurrenceMessages.deleteSeriesConfirmation : DELETESERIESCONFIRM;
	                    }

	                    if(isResetSeries) {
	                        title = recurrenceMessages.resetSeriesWindowTitle;
	                        text = recurrenceMessages.resetSeriesConfirmation ? recurrenceMessages.resetSeriesConfirmation : RESETSERIESCONFIRM;
	                    }
	                }

	                var buttons = [
	                    { name: "destroy", text: isResetSeries ? messages.resetSeries : messages.destroy, click: function() { callback(); } }
	                ];

	                if (!(this._isMobile() && kendo.Pane)) {
	                    buttons.push({ name: "canceledit", text: messages.cancel, click: function() { callback(true); } });
	                }

	                this._unbindResize();

	                this.showDialog({
	                    model: model,
	                    text: text,
	                    title: title,
	                    buttons: buttons
	                });

	                this._bindResize();
	            } else {
	                callback();
	            }
	        },

	        addEvent: function(eventInfo) {
	            var editable = this._editor.editable;
	            var dataSource = this.dataSource;
	            var event;

	            eventInfo = eventInfo || {};

	            var prevented = this.trigger("add", { event:  eventInfo });

	            if (!prevented && ((editable && editable.end()) || !editable)) {
	                this.cancelEvent();

	                if (eventInfo && eventInfo.toJSON) {
	                    eventInfo = eventInfo.toJSON();
	                }

	                event = dataSource.add(eventInfo);

	                if (event) {
	                    this.cancelEvent();
	                    this._editEvent(event);
	                }
	            }
	       },

	       saveEvent: function() {
	            var that = this;
	            var editor = that._editor;
	            var dataSource = that.dataSource;

	            if (!editor) {
	                return;
	            }

	            var editable = editor.editable;
	            var container = editor.container;
	            var model = that._modelForContainer(container);
	            var events, i, event;

	            if (container && editable && editable.end() &&
	                !that.trigger(SAVE, { container: container, event: model } )) {

	                if(!model.isOccurrence() && !!model.recurrenceException && !model.recurrenceRule) {
	                    events = dataSource.data();

	                    for(i = events.length - 1; i >= 0; i -= 1) {
	                        event = events[i];
	                        if(event && event.recurrenceId === model.id) {
	                            dataSource.remove(event);
	                        }
	                    }

	                    model.set("recurrenceException", "");
	                }

	                if (!model.dirty && !model.isOccurrence()) {
	                    that._convertDates(model, "remove");
	                }

	                dataSource.sync();
	            }
	        },

	        cancelEvent: function() {
	            var editor = this._editor;
	            var container = editor.container;
	            var model;

	            if (container) {
	                model = this._modelForContainer(container);

	                if (model && model.isOccurrence()) {
	                    this._convertDates(model, "remove");
	                    this._convertDates(this.dataSource.get(model.recurrenceId), "remove");
	                }

	                this.dataSource.cancelChanges(model);

	                //TODO: handle the cancel in UI

	                editor.close();
	            }
	        },

	        editEvent: function(uid) {
	            var model = typeof uid == "string" ? this.occurrenceByUid(uid) : uid;

	            if (!model) {
	                return;
	            }

	            this.cancelEvent();

	            if (model.isRecurring()) {
	                this._editRecurringDialog(model);
	            } else {
	                this._editEvent(model);
	            }
	        },

	        _editEvent: function(model) {
	            this._preventRefresh = true;
	            this._unbindResize();

	            this._createPopupEditor(model);

	            this._bindResize();
	        },

	        _editRecurringDialog: function(model) {
	            var that = this;

	            var editOccurrence = function() {
	                if (model.isException()) {
	                    that._editEvent(model);
	                } else {
	                    that.addEvent(model);
	                }
	            };

	            var editSeries = function() {
	                if (model.recurrenceId) {
	                    model = that.dataSource.get(model.recurrenceId);
	                }

	                that._editEvent(model);
	            };

	            var recurrenceMessages = that.options.messages.recurrenceMessages;
	            that._showRecurringDialog(model, editOccurrence, editSeries, {
	                title: recurrenceMessages.editWindowTitle,
	                text: recurrenceMessages.editRecurring ? recurrenceMessages.editRecurring : EDITRECURRING,
	                occurrenceText: recurrenceMessages.editWindowOccurrence,
	                seriesText: recurrenceMessages.editWindowSeries
	            });
	         },

	         _showRecurringDialog: function(model, editOccurrence, editSeries, messages) {
	             var editable = this.options.editable;
	             var editRecurringMode = isPlainObject(editable) ? editable.editRecurringMode : "dialog";

	             if (editRecurringMode ===  "occurrence" || this._isMultiDrag) {
	                 editOccurrence();
	             } else if (editRecurringMode === "series") {
	                 editSeries();
	             } else {
	                 this._unbindResize();

	                 this.showDialog({
	                     model: model,
	                     title: messages.title,
	                     text: messages.text,
	                     buttons: [
	                         { text: messages.occurrenceText, click: editOccurrence },
	                         { text: messages.seriesText, click: editSeries }
	                     ]
	                 });

	                 this._bindResize();
	             }
	        },

	        _createButton: function(command) {
	            var template = command.template || COMMANDBUTTONTMPL,
	                commandName = typeof command === STRING ? command : command.name || command.text,
	                options = { className: "k-scheduler-" + (commandName || "").replace(/\s/g, ""), text: commandName, attr: "" };

	            if (!commandName && !(isPlainObject(command) && command.template))  {
	                throw new Error("Custom commands should have name specified");
	            }

	            if (isPlainObject(command)) {
	                if (command.className) {
	                    command.className += " " + options.className;
	                }

	                if (commandName === "edit" && isPlainObject(command.text)) {
	                    command = extend(true, {}, command);
	                    command.text = command.text.edit;
	                }

	                options = extend(true, options, defaultCommands[commandName], command);
	            } else {
	                options = extend(true, options, defaultCommands[commandName]);
	            }

	            return kendo.template(template)(options);
	        },

	        _convertDates: function(model, method) {
	            var timezone = this.dataSource.reader.timezone;
	            var startTimezone = model.startTimezone;
	            var endTimezone = model.endTimezone;
	            var start = model.start;
	            var end = model.start;

	            method = method || "apply";
	            startTimezone = startTimezone || endTimezone;
	            endTimezone = endTimezone || startTimezone;

	            if (startTimezone) {
	                if (timezone) {
	                    if (method === "apply") {
	                        start = kendo.timezone.convert(model.start, timezone, startTimezone);
	                        end = kendo.timezone.convert(model.end, timezone, endTimezone);
	                    } else {
	                        start = kendo.timezone.convert(model.start, startTimezone, timezone);
	                        end = kendo.timezone.convert(model.end, endTimezone, timezone);
	                    }
	                } else {
	                    start = kendo.timezone[method](model.start, startTimezone);
	                    end = kendo.timezone[method](model.end, endTimezone);
	                }

	                model._set("start", start);
	                model._set("end", end);
	            }
	        },

	        _createEditor: function() {
	            var that = this;

	            var editor;

	            if (this._isMobile() && kendo.Pane) {
	                editor = that._editor = new MobileEditor(this.wrapper, extend({}, this.options, {
	                    target: this,
	                    timezone: that.dataSource.reader.timezone,
	                    resources: that.resources,
	                    createButton: proxy(this._createButton, this)
	                }));
	            } else {
	                editor = that._editor = new PopupEditor(this.wrapper, extend({}, this.options, {
	                    target: this,
	                    createButton: proxy(this._createButton, this),
	                    timezone: that.dataSource.reader.timezone,
	                    resources: that.resources
	                }));
	            }

	            editor.bind("cancel", function(e) {
	                if (that.trigger("cancel", { container: e.container, event: e.model })) {
	                    e.preventDefault();
	                    return;
	                }
	                that._preventRefresh = false;
	                that.cancelEvent();

	                if(that._attemptRefresh) {
	                    that.refresh();
	                }

	                that.focus();
	            });

	            editor.bind("edit", function(e) {
	                if (that.trigger(EDIT, { container: e.container, event: e.model })) {
	                    e.preventDefault();
	                }
	            });

	            editor.bind("save", function() {
	                that._preventRefresh = false;
	                that.saveEvent();
	            });

	            editor.bind("remove", function(e) {
	                that._preventRefresh = false;
	                that.removeEvent(e.model);
	            });

	            editor.bind("resetSeries", function(e) {
	                that._confirmation(function(cancel) {
	                    that._preventRefresh = false;
	                    if (!cancel) {
	                        that.dataSource._removeExceptions(e.model);
	                        that.saveEvent();
	                    }
	                }, e.model, true);
	            });
	        },

	        _createPopupEditor: function(model) {
	            var editor = this._editor;

	            if (!model.isNew() || model.isOccurrence()) {
	                if (model.isOccurrence()) {
	                    this._convertDates(model.recurrenceId ? this.dataSource.get(model.recurrenceId) : model);
	                }
	                this._convertDates(model);
	            }

	            this.editable = editor.editEvent(model);
	        },

	        removeEvent: function(uid) {
	            var that = this,
	                model = typeof uid == "string" ? that.occurrenceByUid(uid) : uid;

	            if (!model) {
	                return;
	            }

	            if (model.isRecurring()) {
	                that._deleteRecurringDialog(model);
	            } else {
	                that._confirmation(function(cancel) {
	                    if (!cancel) {
	                        that._removeEvent(model);
	                    }
	                }, model);
	            }
	        },

	        occurrenceByUid: function(uid) {
	            var occurrence = this.dataSource.getByUid(uid);
	            if (!occurrence) {
	                occurrence = getOccurrenceByUid(this._data, uid);
	            }

	            return occurrence;
	        },

	        occurrencesInRange: function(start, end) {
	            return new kendo.data.Query(this._data).filter({
	                logic: "or",
	                filters: [
	                    {
	                        logic: "and",
	                        filters: [
	                            { field: "start", operator: "gte", value: start },
	                            { field: "end", operator: "gte", value: start },
	                            { field: "start", operator: "lt", value: end }
	                        ]
	                    },
	                    {
	                        logic: "and",
	                        filters: [
	                            { field: "start", operator: "lte", value: start },
	                            { field: "end", operator: "gt", value: start }
	                        ]
	                    }
	                ]
	            }).toArray();
	        },

	        _removeEvent: function(model) {
	            if (!this.trigger(REMOVE, { event: model })) {
	                if (this.dataSource.remove(model)) {
	                    this.dataSource.sync();
	                }
	            }
	        },

	        _deleteRecurringDialog: function(model) {
	            var that = this;
	            var currentModel = model;
	            var editable = that.options.editable;
	            var deleteOccurrence;
	            var deleteSeries;
	            var createException;
	            var deleteOccurrenceConfirmation;
	            var deleteSeriesConfirmation;
	            var createExceptionConfirmation;
	            var editRecurringMode = isPlainObject(editable) ? editable.editRecurringMode : "dialog";

	            deleteOccurrence = function() {
	                var occurrence = currentModel.recurrenceId ? currentModel : currentModel.toOccurrence();
	                var head = that.dataSource.get(occurrence.recurrenceId);

	                that._convertDates(head);
	                that._removeEvent(occurrence);
	            };

	            deleteSeries = function() {
	                if (currentModel.recurrenceId) {
	                    currentModel = that.dataSource.get(currentModel.recurrenceId);
	                }

	                that._removeEvent(currentModel);
	            };

	            createException = function() {
	                that.dataSource.remove(currentModel);
	                that.dataSource.sync();
	            };

	            if (editRecurringMode != "dialog" || that._isEditorOpened()) {
	                deleteOccurrenceConfirmation = function() {
	                    that._confirmation(function(cancel) {
	                        if (!cancel) {
	                            deleteOccurrence();
	                        }
	                    }, currentModel);
	                };

	                deleteSeriesConfirmation = function() {
	                    that._confirmation(function(cancel) {
	                        if (!cancel) {
	                            deleteSeries();
	                        }
	                    }, currentModel);
	                };

	                createExceptionConfirmation = function() {
	                    that._confirmation(function(cancel) {
	                        if (!cancel) {
	                            createException();
	                        }
	                    }, currentModel);
	                };
	            }

	            var seriesCallback = deleteSeriesConfirmation || deleteSeries;
	            var occurrenceCallback = deleteOccurrenceConfirmation || deleteOccurrence;
	            var exeptionCallback = createExceptionConfirmation || createException;

	            if (that._isEditorOpened()) {
	                if (model.isException()) {
	                    occurrenceCallback();
	                } else if (model.isNew()) {
	                    exeptionCallback();
	                } else {
	                    seriesCallback();
	                }
	            } else {
	                var recurrenceMessages = that.options.messages.recurrenceMessages;
	                that._showRecurringDialog(model, occurrenceCallback, seriesCallback, {
	                    title: recurrenceMessages.deleteWindowTitle,
	                    text: recurrenceMessages.deleteRecurring ? recurrenceMessages.deleteRecurring : DELETERECURRING,
	                    occurrenceText: recurrenceMessages.deleteWindowOccurrence,
	                    seriesText: recurrenceMessages.deleteWindowSeries
	                });
	            }
	        },

	        _isEditorOpened: function() {
	            return !!this._editor.container;
	        },

	        _unbindView: function(view) {
	            var that = this;
	            that.angular("cleanup", function(){
	                return { elements: that.items() };
	            });

	            view.destroy();
	        },

	        _bindView: function(view) {
	            var that = this;

	            if (that.options.editable) {
	                if (that._viewRemoveHandler) {
	                    view.unbind(REMOVE, that._viewRemoveHandler);
	                }

	                that._viewRemoveHandler = function(e) {
	                    that.removeEvent(e.uid);
	                };

	                view.bind(REMOVE, that._viewRemoveHandler);

	                if (that._viewAddHandler) {
	                    view.unbind(ADD, that._viewAddHandler);
	                }

	                that._viewAddHandler = function(e) {
	                    that.addEvent(e.eventInfo);
	                };

	                view.bind(ADD, this._viewAddHandler);

	                if (that._viewEditHandler) {
	                    view.unbind(EDIT, that._viewEditHandler);
	                }

	                that._viewEditHandler = function(e) {
	                    that.editEvent(e.uid);
	                };

	                view.bind(EDIT, this._viewEditHandler);
	            }

	            if (that._viewNavigateHandler) {
	                view.unbind("navigate", that._viewNavigateHandler);
	            }

	            that._viewNavigateHandler = function(e) {
	                if (e.view) {
	                    var switchWorkDay = "isWorkDay" in e;
	                    var action = switchWorkDay ? "changeWorkDay" : "changeView";

	                    if (!that.trigger("navigate", { view: e.view, isWorkDay: e.isWorkDay, action: action, date: e.date })) {
	                        if (switchWorkDay) {
	                            that._workDayMode = e.isWorkDay;
	                        }

	                        that._selectView(e.view);
	                        that.date(e.date);
	                    }
	                }
	            };

	            view.bind("navigate", that._viewNavigateHandler);

	            if (that._viewActivateHandler) {
	                view.unbind("activate", that._viewActivateHandler);
	            }

	            that._viewActivateHandler = function() {
	                var view = this;
	                if (that._selection) {
	                    view.constrainSelection(that._selection);

	                    that._select();

	                    that._adjustSelectedDate();
	                }
	            };

	            view.bind("activate", that._viewActivateHandler);
	        },

	        _selectView: function(name) {
	            var that = this;

	            if (name && that.views[name]) {

	                if (that._selectedView) {
	                    that._unbindView(that._selectedView);
	                }

	                that._selectedView = that._renderView(name);
	                that._selectedViewName = name;

	                if (that._viewsCount > 1 && !that._isMobile()) {
	                    var viewsDropdown = that.toolbar.find(".k-views-dropdown");
	                    var viewButtons = that.toolbar.find(".k-scheduler-views > .k-button");

	                    if ( that.toolbar.find(".k-views-dropdown").length === 0 ) {
	                        that.toolbar.find(".k-scheduler-views-wrapper").prepend(VIEWS_DROPDOWN_TEMPLATE({views: that.views, view: name, ns: kendo.ns}));
	                        viewsDropdown = that.toolbar.find(".k-views-dropdown");
	                    }

	                    viewsDropdown.val(name);

	                    viewButtons.removeClass("k-state-selected");
	                    viewButtons.filter(".k-view-" + name.replace(/\./g, "\\.").toLowerCase()).addClass("k-state-selected");
	                } else {
	                    var viewSelect =  that.toolbar.find(".k-scheduler-mobile-views");

	                    viewSelect.find("[value=" + name.replace(/\./g, "\\.") + "]")
	                        .prop("selected", "selected");
	                }
	            }
	        },

	        view: function(name) {
	            var that = this;

	            if (name) {
	                that._selectView(name);
	                that.rebind();

	                return;
	            }

	            return that._selectedView;
	        },

	        viewName: function() {
	            return this.view().name;
	        },

	        _renderView: function(name) {
	            var view = this._initializeView(name);

	            this._bindView(view);

	            if (kendo.support.mouseAndTouchPresent || kendo.support.pointers) {
	                view.content.css("-ms-touch-action", "pinch-zoom");
	                view.content.css("touch-action", "pinch-zoom");
	            }

	            this._model.set("formattedDate", view.dateForTitle());
	            this._model.set("formattedShortDate", view.shortDateForTitle());
	            this._model.set("formattedMobileDate", view.mobileDateForTitle ? view.mobileDateForTitle() : view.shortDateForTitle());
	            this._model.set("formattedYear", kendo.format("{0:yyyy}", view.startDate()));

	            return view;
	        },

	        resize: function(force) {
	            var size = this.getSize();
	            var currentSize = this._size;
	            var view = this.view();

	            if (!view || !view.groups) {
	                return;
	            }

	            if (force || !currentSize || size.width !== currentSize.width || size.height !== currentSize.height) {
	                this.refresh({ action: "resize" });
	                this._size = size;
	            }
	        },

	        _adjustSelectedDate: function() {
	            var date = this._model.selectedDate,
	                selection = this._selection,
	                start = selection.start;

	            if (start && !kendo.date.isInDateRange(date, getDate(start), getDate(selection.end))) {
	                date.setFullYear(start.getFullYear(), start.getMonth(), start.getDate());
	            }
	        },

	        _initializeView: function(name) {
	            var view = this.views[name];

	            if (view) {
	                var isSettings = isPlainObject(view),
	                    overrideOptions = {},
	                    type = view.type;

	                if (typeof type === STRING) {
	                    type = kendo.getter(view.type)(window);
	                }

	                if(isSettings && view.workDays && view.workDays.length) {
	                    overrideOptions.workDays = view.workDays;
	                }

	                if (type) {
	                    view = new type(this.wrapper, trimOptions(extend(true, {}, this.options, isSettings ? view : {}, {
	                        resources: this.resources,
	                        date: this.date(),
	                        startTime: kendo.parseDate(view.startTime) || kendo.parseDate(this.options.startTime),
	                        endTime: kendo.parseDate(view.endTime) || kendo.parseDate(this.options.endTime),
	                        showWorkHours: this._workDayMode
	                    }),overrideOptions));

	                } else {
	                    throw new Error("There is no such view");
	                }
	            }

	            return view;
	        },

	        _views: function() {
	            var views = this.options.views;
	            var view;
	            var defaultView;
	            var selected;
	            var isSettings;
	            var name;
	            var type;
	            var idx;
	            var length;

	            this.views = {};
	            this._viewsCount = 0;

	            for (idx = 0, length = views.length; idx < length; idx++) {
	                var hasType = false;

	                view = views[idx];

	                isSettings = isPlainObject(view);

	                if (isSettings) {
	                    type = name = view.type ? view.type : view;
	                    if (typeof type !== STRING) {
	                        name = view.name || view.title;
	                        hasType = true;
	                    }
	                } else {
	                    type = name = view;
	                }

	                defaultView = defaultViews[name];

	                if (defaultView && !hasType) {

	                    view.type = defaultView.type;
	                    defaultView.title = this.options.messages.views[name];
	                    if (defaultView.type === "day") {
	                        defaultView.messages = { allDay: this.options.messages.allDay };
	                    } else if (defaultView.type === "agenda") {
	                        defaultView.messages = {
	                            event: this.options.messages.event,
	                            date: this.options.messages.date,
	                            time: this.options.messages.time
	                        };
	                    }
	                }

	                view = extend({ title: name }, defaultView, isSettings ? view : {});

	                if (name) {
	                    this.views[name] = view;
	                    this._viewsCount++;

	                    if (!selected || view.selected) {
	                        selected = name;
	                    }
	                }
	            }

	            if (selected) {
	                this._selectedViewName = selected; // toolbar is not rendered yet
	            }
	        },

	        rebind: function() {
	            var that = this,
	                resources = that.resources,
	                resourceFetchArray = [];

	            if(that._preventRebind) {
	                that._preventRebind = false;
	                return;
	            }

	            if(that.options.autoBind === false && resources && resources.length > 0) {
	                resources.forEach(function(resource) {
	                    if(resource.dataSource.data().length === 0) {
	                        that._preventRebind = true;
	                        resourceFetchArray.push(resource.dataSource.fetch());
	                    }
	                });

	                $.when.apply(null, resourceFetchArray).then(function() {
	                    that.dataSource.fetch();
	                    that._preventRebind = false;
	                });
	            } else {
	                that.dataSource.fetch();
	            }
	        },

	        _dataSource: function() {
	            var that = this,
	                options = that.options,
	                dataSource = options.dataSource;

	            dataSource = isArray(dataSource) ? { data: dataSource } : dataSource;

	            if (options.timezone && !(dataSource instanceof SchedulerDataSource)) {
	                dataSource = extend(true, dataSource, { schema: { timezone: options.timezone } });
	            } else if(dataSource instanceof SchedulerDataSource) {
	                options.timezone = dataSource.options.schema ? dataSource.options.schema.timezone : "";
	            }

	            if (that.dataSource && that._refreshHandler) {
	                that.dataSource
	                    .unbind(CHANGE, that._refreshHandler)
	                    .unbind(PROGRESS, that._progressHandler)
	                    .unbind(ERROR, that._errorHandler);
	            } else {
	                that._refreshHandler = proxy(that.refresh, that);
	                that._progressHandler = proxy(that._requestStart, that);
	                that._errorHandler = proxy(that._error, that);
	            }

	            that.dataSource = kendo.data.SchedulerDataSource.create(dataSource)
	                .bind(CHANGE, that._refreshHandler)
	                .bind(PROGRESS, that._progressHandler)
	                .bind(ERROR, that._errorHandler);

	            that.options.dataSource = that.dataSource;
	        },


	        _error: function() {
	            this._progress(false);
	        },

	        _requestStart: function() {
	            this._progress(true);
	        },

	        _progress: function(toggle) {
	            var element = this.element.find(".k-scheduler-content");
	            kendo.ui.progress(element, toggle);
	        },

	        _resources: function() {
	            var that = this;
	            var resources = that.options.resources;
	            var resourcePromises = [];

	            for (var idx = 0; idx < resources.length; idx++) {
	                var resource = resources[idx];
	                var field = resource.field;
	                var name = resource.name || field;
	                var dataSource = resource.dataSource;

	                if (!field || !dataSource) {
	                    throw new Error('The "field" and "dataSource" options of the scheduler resource are mandatory.');
	                }

	                that.resources.push({
	                    field: field,
	                    name: name,
	                    title: resource.title || field,
	                    dataTextField: resource.dataTextField || "text",
	                    dataValueField: resource.dataValueField || "value",
	                    dataColorField: resource.dataColorField || "color",
	                    valuePrimitive: resource.valuePrimitive != null ? resource.valuePrimitive : true,
	                    multiple: resource.multiple || false,
	                    dataSource: that._resourceDataSource(dataSource, name, resourcePromises)
	                });
	            }

	            if (!that.options.autoBind) {
	                that._selectView(that._selectedViewName);
	            } else {
	                $.when.apply(null, resourcePromises)
	                      .then(function () {
	                            that.view(that._selectedViewName);
	                        });
	            }
	        },

	        _resourceDataSource: function(resourceDS, groupName, promises) {
	            var that = this;
	            var dataSource = isArray(resourceDS) ? { data: resourceDS } : resourceDS;
	            var dataSourceInstance = kendo.data.DataSource.create(dataSource);

	            if (that.options.autoBind) {
	                promises.push(dataSourceInstance.fetch(function(){
	                    // 'this' is the DataSource instance not the Scheduler
	                    that._bindResourceEvents(this, groupName);
	                }));
	            } else {
	                that._bindResourceEvents(dataSourceInstance, groupName);
	            }

	            return dataSourceInstance;
	        },

	        _bindResourceEvents: function(resourceDS, groupName){
	            var that = this;
	            var isGrouped = that.options.group && that.options.group.resources.length;
	            var isResourceGrouped = isGrouped && that.options.group.resources.indexOf(groupName) > -1;

	            if (!that._resourceRefreshHandler && isResourceGrouped){
	                that._resourceRefreshHandler = proxy(that._refreshResource, that);
	                that._resourceErrorHandler = proxy(that._error, that);
	            }

	            if(isResourceGrouped) {
	                resourceDS.bind(CHANGE, that._resourceRefreshHandler)
	                    .bind(ERROR, that._resourceErrorHandler);
	            }
	        },

	        _refreshResource: function() {
	            var that = this;
	            var preventRefresh = (that._editor && that._editor.editable) || that._preventRefresh;

	            if(!preventRefresh){
	                that.view(that._selectedViewName);
	            }
	        },

	        _initModel: function() {
	            var that = this;
	            that._model = kendo.observable({
	               selectedDate: new Date(this.options.date),
	               formattedDate: "",
	               formattedShortDate: ""
	           });

	           that._model.bind("change", function(e) {
	                if (e.field === "selectedDate") {
	                    that.view(that._selectedViewName);
	                }
	           });
	        },

	        _wrapper: function() {
	            var that = this;
	            var options = that.options;
	            var height = options.height;
	            var width = options.width;

	            that.wrapper = that.element
	                               .addClass("k-widget k-scheduler k-floatwrap")
	                               .attr("role", "grid")
	                               .attr("aria-multiselectable", true);

	            if (that._isMobile()) {
	               that.wrapper.addClass("k-scheduler-mobile");
	            }

	            if (height) {
	                that.wrapper.height(height);
	            }

	            if (width) {
	                that.wrapper.width(width);
	            }
	        },

	        date: function(value) {
	            if (value != null && getDate(value) >= getDate(this.options.min) && getDate(value) <= getDate(this.options.max)) {
	                this._model.set("selectedDate", value);
	            }
	            return getDate(this._model.get("selectedDate"));
	        },

	        _toolbar: function() {
	            var that = this;
	            var options = that.options;
	            var commands = [];

	            if (options.toolbar) {
	                commands = $.isArray(options.toolbar) ? options.toolbar : [options.toolbar];
	            }

	            var template = this._isMobile() ? MOBILETOOLBARTEMPLATE : TOOLBARTEMPLATE;

	            var toolbar = $(template({
	                    messages: options.messages,
	                    pdf: $.grep(commands, function(item) {
	                            return item == "pdf" || item.name == "pdf";
	                        }).length > 0,
	                    search: $.grep(commands, function(item) {
	                        return item == "search" || item.name == "search";
	                    }).length > 0,
	                    ns: kendo.ns,
	                    view: that._selectedViewName,
	                    views: that.views,
	                    viewsCount: that._viewsCount,
	                    editable: that.options.editable
	                }));

	            that.wrapper.append(toolbar);
	            that.toolbar = toolbar;

	            kendo.bind(that.toolbar, that._model);

	            toolbar.on(CLICK + NS, ".k-pdf", function(e) {
	                e.preventDefault();
	                that.saveAsPDF();
	            });

	            toolbar.on("input" + NS, ".k-scheduler-search-input", kendo.throttle(function(e) {
	                that.dataSource.filter({
	                    logic: "or",
	                    filters: [
	                        {field: "title", operator: "contains", value: e.target.value},
	                        {field: "description", operator: "contains", value: e.target.value}
	                    ]
	                });
	            }, 250));

	            toolbar.on(CLICK + NS, ".k-create-event", function(e) {
	                e.preventDefault();
	                that.addEvent();
	            });

	            toolbar.on(CLICK + NS, ".k-nav-calendar", function(e) {
	                e.preventDefault();
	                that._showCalendar(e.target);
	            });

	            toolbar.on(CLICK + NS, ".k-scheduler-navigation > .k-button", function(e) {
	                var button = $(this);
	                var date = new Date(that.date());
	                var action = "";
	                var currentDate = new Date();
	                var timezone = that.options.timezone;

	                if($(e.target).is("input")) {
	                    return;
	                }

	                e.preventDefault();

	                if (button.hasClass("k-nav-today")) {
	                    action = "today";
	                    if (timezone) {
	                        var timezoneOffset = kendo.timezone.offset(currentDate, timezone);
	                        date = kendo.timezone.convert(currentDate, currentDate.getTimezoneOffset(), timezoneOffset);
	                    } else {
	                        date = currentDate;
	                    }
	                } else if (button.hasClass("k-nav-next")) {
	                    action = "next";
	                    date = that.view().nextDate();
	                } else if (button.hasClass("k-nav-prev")) {
	                    action = "previous";
	                    date = that.view().previousDate();
	                }

	                if (!that.trigger("navigate", { view: that._selectedViewName, action: action, date: date })) {
	                    that.date(date);
	                }
	            });

	            toolbar.on(CLICK + NS, ".k-nav-current", function(e) {
	                e.preventDefault();

	                if (!that._isMobile()) {
	                    that._showCalendar();
	                }
	            });

	            toolbar.on(CLICK + NS, ".k-scheduler-views > .k-button, .k-scheduler-refresh", function(e) {
	                e.preventDefault();

	                var name = $(this).attr(kendo.attr("name"));

	                that.toolbar.find(".k-scheduler-views > .k-button").removeClass(FOCUSEDSTATE);

	                if (!that.trigger("navigate", { view: name, action: "changeView", date: that.date() })) {
	                    that.view(name);
	                }
	            });

	            toolbar.on(CHANGE + NS, ".k-views-dropdown", function() {
	                var name = this.value;

	                if (!that.trigger("navigate", { view: name, action: "changeView", date: that.date() })) {
	                    that.view(name);
	                }
	            });

	            toolbar.find(".k-scheduler-mobile-views").on("change", function (e) {
	                that.view(e.target.value);
	            });
	        },

	        _showCalendar: function(targetElm) {
	            var that = this,
	                target = targetElm || that.toolbar.find(".k-nav-current"),
	                html = $('<div class="k-calendar-container"><div class="k-scheduler-calendar"></div></div>');

	            if (!that.popup) {
	                that.popup = new Popup(html, {
	                    anchor: target,
	                    activate: function() {
	                        if(that.popup && that.calendar){
	                            that.popup._toggleResize(false);
	                            that.calendar.element.find("table").focus();
	                            that.popup._toggleResize(true);
	                        }
	                    },
	                    open: function() {
	                        if (!that.calendar) {
	                            that.calendar = new Calendar(this.element.find(".k-scheduler-calendar"),
	                            {
	                                change: function() {
	                                    var date = this.value();
	                                    if (!that.trigger("navigate", { view: that._selectedViewName, action: "changeDate", date: date })) {
	                                        that.date(date);
	                                        that.popup.close();
	                                    }

	                                    if(!that._isMobile()) {
	                                        that._selectedView.element.focus();
	                                        that.toolbar.find(".k-nav-current").focus().addClass(FOCUSEDSTATE);
	                                    }
	                                },
	                                min: that.options.min,
	                                max: that.options.max
	                            });
	                        }
	                        that.calendar.element.on("keydown" + NS, function (e) {
	                            if (e.keyCode === keys.ESC || e.keyCode === keys.TAB) {
	                                that.popup.close();
	                                that._selectedView.element.focus();
	                                that.toolbar.find(".k-nav-current").focus().addClass(FOCUSEDSTATE);
	                            }
	                        });
	                        that.calendar.value(that.date());
	                    },
	                    copyAnchorStyles: false
	                });
	            }

	            that.popup.open();
	        },

	        refresh: function(e) {
	            var that = this;
	            var view = this.view();
	            var preventRefresh = (e && e.action === "itemchange" && (this._editor.editable || this._preventRefresh)) ||
	                                 (this.dataSource.options.type === "signalr" && this._preventRefresh);

	            this._progress(false);

	            this.angular("cleanup", function(){
	                return { elements: that.items() };
	            });

	            e = e || {};

	            if (!view) {
	                return;
	            }

	            if (preventRefresh) { // skip rebinding if editing is in progress
	                this._attemptRefresh = true && this.dataSource.options.type === "signalr";
	                return;
	            }

	            if (this.trigger("dataBinding", { action: e.action || "rebind", index: e.index, items: e.items })) {
	                return;
	            }

	            if (!(e && e.action === "resize") && this._editor) {
	                this._editor.close();
	            }

	            this._data = this.dataSource.expand(view.startDate(), view.visibleEndDate());

	            view.refreshLayout();

	            view.render(this._data);

	            this.trigger("dataBound");
	            this._attemptRefresh = false;
	        },

	        slotByPosition: function(x, y) {
	            var view = this.view();

	            if(!view._slotByPosition) {
	                return null;
	            }

	            var slot = view._slotByPosition(x, y);

	            if(!slot) {
	                return null;
	            }

	            return {
	                startDate: slot.startDate(),
	                endDate: slot.endDate(),
	                groupIndex: slot.groupIndex,
	                element: slot.element,
	                isDaySlot: slot.isDaySlot
	            };
	        },

	        slotByElement: function(element) {
	            var offset = $(element).offset();
	            return this.slotByPosition(offset.left, offset.top);
	        },

	        resourcesBySlot: function(slot) {
	            return this.view()._resourceBySlot(slot);
	        }
	    });

	    var defaultViews = {
	        day: {
	            type: "kendo.ui.DayView"
	        },
	        week: {
	            type: "kendo.ui.WeekView"
	        },
	        workWeek: {
	            type: "kendo.ui.WorkWeekView"
	        },
	        agenda: {
	            type: "kendo.ui.AgendaView"
	        },
	        month: {
	            type: "kendo.ui.MonthView"
	        },
	        timeline: {
	            type: "kendo.ui.TimelineView"
	        },
	        timelineWeek: {
	            type: "kendo.ui.TimelineWeekView"
	        },
	        timelineWorkWeek: {
	            type: "kendo.ui.TimelineWorkWeekView"
	        },
	        timelineMonth: {
	            type: "kendo.ui.TimelineMonthView"
	        }
	    };

	    ui.plugin(Scheduler);

	    if (kendo.PDFMixin) {
	        kendo.PDFMixin.extend(Scheduler.prototype);

	        var SCHEDULER_EXPORT = "k-scheduler-pdf-export";
	        Scheduler.fn._drawPDF = function(progress) {
	            var wrapper = this.wrapper;
	            var styles = wrapper[0].style.cssText;

	            wrapper.css({
	                width: wrapper.width(),
	                height: wrapper.height()
	            });

	            wrapper.addClass(SCHEDULER_EXPORT);

	            var scheduler = this;
	            var promise = new $.Deferred();
	            var table = wrapper.find(".k-scheduler-content").find("table").css("table-layout", "auto");

	            setTimeout(function() {
	                table.css("table-layout", "fixed");
	                scheduler.resize(true);

	                scheduler._drawPDFShadow({}, {
	                    avoidLinks: scheduler.options.pdf.avoidLinks
	                })
	                .done(function(group) {
	                    var args = {
	                        page: group,
	                        pageNumber: 1,
	                        progress: 1,
	                        totalPages: 1
	                    };

	                    progress.notify(args);
	                    promise.resolve(args.page);
	                })
	                .fail(function(err) {
	                    promise.reject(err);
	                })
	                .always(function() {
	                    wrapper[0].style.cssText = styles;
	                    wrapper.removeClass(SCHEDULER_EXPORT);
	                    scheduler.resize(true);

	                    //Required because slot.offsetLeft is incorrect after first resize
	                    scheduler.resize(true);
	                });
	            });

	            return promise;
	        };
	    }

	    var TimezoneEditor = Widget.extend({
	        init: function(element, options) {
	            var that = this,
	                zones = kendo.timezone.windows_zones;

	            if (!zones || !kendo.timezone.zones_titles) {
	                throw new Error('kendo.timezones.min.js is not included.');
	            }

	            Widget.fn.init.call(that, element, options);

	            that.wrapper = that.element;

	            that._zonesQuery = new kendo.data.Query(zones);
	            that._zoneTitleId = kendo.guid();
	            that._zoneTitlePicker();
	            that._zonePicker();

	            that._zoneTitle.bind("cascade", function() {
	                if (!this.value()) {
	                    that._zone.wrapper.hide();
	                }
	            });

	            that._zone.bind("cascade", function() {
	                that._value = this.value();
	                that.trigger("change");
	            });

	            that.value(that.options.value);
	        },
	        options: {
	            name: "TimezoneEditor",
	            value: "",
	            optionLabel: "No timezone"
	        },
	        events: [ "change" ],

	        _zoneTitlePicker: function() {
	            var that = this,
	                zoneTitle = $('<input id="' + that._zoneTitleId + '" aria-label="' + that.options.title + '"/>').appendTo(that.wrapper);

	            that._zoneTitle = new kendo.ui.DropDownList(zoneTitle, {
	                dataSource: kendo.timezone.zones_titles,
	                dataValueField: "other_zone",
	                dataTextField: "name",
	                optionLabel: that.options.optionLabel
	            });
	        },

	        _zonePicker: function() {
	            var that = this,
	                zone = $('<input aria-label="' + that.options.title + '"/>').appendTo(this.wrapper);

	            that._zone = new kendo.ui.DropDownList(zone, {
	                dataValueField: "zone",
	                dataTextField: "territory",
	                dataSource: that._zonesQuery.data,
	                cascadeFrom: that._zoneTitleId,
	                dataBound: function() {
	                    that._value = this.value();
	                    this.wrapper.toggle(this.dataSource.view().length > 1);
	                }
	            });

	            that._zone.wrapper.hide();
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            kendo.destroy(this.wrapper);
	        },

	        value: function(value) {
	            var that = this,
	                zone;

	            if (value === undefined) {
	                return that._value;
	            }

	            zone = that._zonesQuery.filter({ field: "zone", operator: "eq", value: value }).data[0];

	            if (zone) {
	                that._zoneTitle.value(zone.other_zone);
	                that._zone.value(zone.zone);
	            } else {
	                that._zoneTitle.select(0);
	            }

	        }
	    });

	    ui.plugin(TimezoneEditor);

	    var ZONETITLEOPTIONTEMPLATE = kendo.template('<option value="#=other_zone#">#=name#</option>');
	    var ZONEOPTIONTEMPLATE = kendo.template('<option value="#=zone#">#=territory#</option>');

	    var MobileTimezoneEditor = Widget.extend({
	        init: function(element, options) {
	            var that = this,
	                zones = kendo.timezone.windows_zones;

	            if (!zones || !kendo.timezone.zones_titles) {
	                throw new Error('kendo.timezones.min.js is not included.');
	            }

	            Widget.fn.init.call(that, element, options);

	            that.wrapper = that.element;

	            that._zonesQuery = new kendo.data.Query(zones);
	            that._zoneTitlePicker();
	            that._zonePicker();

	            that.value(that.options.value);
	        },

	        options: {
	            name: "MobileTimezoneEditor",
	            optionLabel: "No timezone",
	            value: ""
	        },

	        events: [ "change" ],

	        _bindZones: function(value) {
	            var data = value ? this._filter(value) : [];

	            this._zone.html(this._options(data, ZONEOPTIONTEMPLATE));
	        },

	        _filter: function(value) {
	            return this._zonesQuery.filter({ field: "other_zone", operator: "eq", value: value }).data;
	        },

	        _options: function(data, template, optionLabel) {
	            var idx = 0;
	            var html = "";
	            var length = data.length;

	            if (optionLabel) {
	                html += template({ other_zone: "", name: optionLabel });
	            }

	            for (; idx < length; idx++) {
	                html += template(data[idx]);
	            }

	            return html;
	        },

	        _zoneTitlePicker: function() {
	            var that = this;
	            var options = that._options(kendo.timezone.zones_titles, ZONETITLEOPTIONTEMPLATE, that.options.optionLabel);

	            that._zoneTitle = $('<select>' + options + '</select>')
	                                .appendTo(that.wrapper)
	                                .change(function() {
	                                    var value = this.value;
	                                    var zone = that._zonePickerLabel;
	                                    var zoneSelect = zone.find("select");

	                                    that._bindZones(value);

	                                    if (value && zoneSelect.children().length > 1) {
	                                        zone.show();
	                                    } else {
	                                        zone.hide();
	                                    }

	                                    that._value = that._zone[0].value;

	                                    that.trigger("change");
	                                });
	        },

	        _zonePicker: function() {
	            var that = this;

	            that._zonePickerLabel = $("<li class='k-item k-listgroup-item k-zonepicker' style='display:none'>" +
	                                        "<label class='k-label k-listgroup-form-row'>" +
	                                            "<span class='k-item-title k-listgroup-form-field-label'></span>" +
	                                            "<div class='k-listgroup-form-field-wrapper'></div>" +
	                                        "</label>" +
	                                    "</li>");

	            that._zone = $('<select></select>')
	                            .appendTo(that._zonePickerLabel.find("div"))
	                            .change(function() {
	                                that._value = this.value;

	                                that.trigger("change");
	                            });

	            this.wrapper.closest(".k-item").after(that._zonePickerLabel);

	            that._bindZones(that._zoneTitle.val());
	            that._value = that._zone[0].value;
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            kendo.destroy(this.wrapper);
	        },

	        value: function(value) {
	            var that = this;
	            var zonePicker = that._zone;
	            var other_zone = "";
	            var zone_value = "";
	            var zone;

	            if (value === undefined) {
	                return that._value;
	            }

	            zone = that._zonesQuery.filter({ field: "zone", operator: "eq", value: value }).data[0];

	            if (zone) {
	                zone_value = zone.zone;
	                other_zone = zone.other_zone;
	            }

	            that._zoneTitle.val(other_zone);
	            that._bindZones(other_zone);

	            zonePicker.val(zone_value);
	            zone_value = zonePicker[0].value;

	            if (zone_value && zonePicker.children.length > 1) {
	                that._zonePickerLabel.show();
	            } else {
	                that._zonePickerLabel.hide();
	            }

	            that._value = zone_value;
	        }
	    });

	    ui.plugin(MobileTimezoneEditor);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1367:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("iVlI");

/***/ }),

/***/ 1368:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("kPaM");

/***/ }),

/***/ 1369:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("dWoE");

/***/ }),

/***/ 1370:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Cyi2");

/***/ }),

/***/ 1371:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("W8+b");

/***/ }),

/***/ 1372:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("AhTV");

/***/ })

/******/ });

/***/ }),

/***/ "POfv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = __webpack_require__("pQ38");
var utils_1 = __webpack_require__("IRr6");
var constants_1 = __webpack_require__("ZZFX");
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var valueFormatterService_1 = __webpack_require__("vFc7");
var SelectCellEditor = (function (_super) {
    __extends(SelectCellEditor, _super);
    function SelectCellEditor() {
        var _this = _super.call(this, '<div class="ag-cell-edit-input"><select class="ag-cell-edit-input"/></div>') || this;
        _this.eSelect = _this.getGui().querySelector('select');
        return _this;
    }
    SelectCellEditor.prototype.init = function (params) {
        var _this = this;
        this.focusAfterAttached = params.cellStartedEdit;
        if (utils_1.Utils.missing(params.values)) {
            console.log('ag-Grid: no values found for select cellEditor');
            return;
        }
        params.values.forEach(function (value) {
            var option = document.createElement('option');
            option.value = value;
            var valueFormatted = _this.valueFormatterService.formatValue(params.column, null, null, value);
            var valueFormattedExits = valueFormatted !== null && valueFormatted !== undefined;
            option.text = valueFormattedExits ? valueFormatted : value;
            if (params.value === value) {
                option.selected = true;
            }
            _this.eSelect.appendChild(option);
        });
        // we don't want to add this if full row editing, otherwise selecting will stop the
        // full row editing.
        if (!this.gridOptionsWrapper.isFullRowEdit()) {
            this.addDestroyableEventListener(this.eSelect, 'change', function () { return params.stopEditing(); });
        }
        this.addDestroyableEventListener(this.eSelect, 'keydown', function (event) {
            var isNavigationKey = event.keyCode === constants_1.Constants.KEY_UP || event.keyCode === constants_1.Constants.KEY_DOWN;
            if (isNavigationKey) {
                event.stopPropagation();
            }
        });
        this.addDestroyableEventListener(this.eSelect, 'mousedown', function (event) {
            event.stopPropagation();
        });
    };
    SelectCellEditor.prototype.afterGuiAttached = function () {
        if (this.focusAfterAttached) {
            this.eSelect.focus();
        }
    };
    SelectCellEditor.prototype.focusIn = function () {
        this.eSelect.focus();
    };
    SelectCellEditor.prototype.getValue = function () {
        return this.eSelect.value;
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], SelectCellEditor.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('valueFormatterService'),
        __metadata("design:type", valueFormatterService_1.ValueFormatterService)
    ], SelectCellEditor.prototype, "valueFormatterService", void 0);
    return SelectCellEditor;
}(component_1.Component));
exports.SelectCellEditor = SelectCellEditor;


/***/ }),

/***/ "PobA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var dragAndDropService_1 = __webpack_require__("I/uN");
var columnController_1 = __webpack_require__("77lH");
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var BodyDropPivotTarget = (function () {
    function BodyDropPivotTarget(pinned) {
        this.columnsToAggregate = [];
        this.columnsToGroup = [];
        this.columnsToPivot = [];
        this.pinned = pinned;
    }
    /** Callback for when drag enters */
    BodyDropPivotTarget.prototype.onDragEnter = function (draggingEvent) {
        var _this = this;
        this.clearColumnsList();
        // in pivot mode, we don't accept any drops if functions are read only
        if (this.gridOptionsWrapper.isFunctionsReadOnly()) {
            return;
        }
        var dragColumns = draggingEvent.dragItem.columns;
        dragColumns.forEach(function (column) {
            // we don't allow adding secondary columns
            if (!column.isPrimary()) {
                return;
            }
            if (column.isAnyFunctionActive()) {
                return;
            }
            if (column.isAllowValue()) {
                _this.columnsToAggregate.push(column);
            }
            else if (column.isAllowRowGroup()) {
                _this.columnsToGroup.push(column);
            }
            else if (column.isAllowRowGroup()) {
                _this.columnsToPivot.push(column);
            }
        });
    };
    BodyDropPivotTarget.prototype.getIconName = function () {
        var totalColumns = this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length;
        if (totalColumns > 0) {
            return this.pinned ? dragAndDropService_1.DragAndDropService.ICON_PINNED : dragAndDropService_1.DragAndDropService.ICON_MOVE;
        }
        else {
            return null;
        }
    };
    /** Callback for when drag leaves */
    BodyDropPivotTarget.prototype.onDragLeave = function (draggingEvent) {
        // if we are taking columns out of the center, then we remove them from the report
        this.clearColumnsList();
    };
    BodyDropPivotTarget.prototype.clearColumnsList = function () {
        this.columnsToAggregate.length = 0;
        this.columnsToGroup.length = 0;
        this.columnsToPivot.length = 0;
    };
    /** Callback for when dragging */
    BodyDropPivotTarget.prototype.onDragging = function (draggingEvent) {
    };
    /** Callback for when drag stops */
    BodyDropPivotTarget.prototype.onDragStop = function (draggingEvent) {
        if (this.columnsToAggregate.length > 0) {
            this.columnController.addValueColumns(this.columnsToAggregate, "toolPanelDragAndDrop");
        }
        if (this.columnsToGroup.length > 0) {
            this.columnController.addRowGroupColumns(this.columnsToGroup, "toolPanelDragAndDrop");
        }
        if (this.columnsToPivot.length > 0) {
            this.columnController.addPivotColumns(this.columnsToPivot, "toolPanelDragAndDrop");
        }
    };
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], BodyDropPivotTarget.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], BodyDropPivotTarget.prototype, "gridOptionsWrapper", void 0);
    return BodyDropPivotTarget;
}());
exports.BodyDropPivotTarget = BodyDropPivotTarget;


/***/ }),

/***/ "PzxK":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("D2L2");
var toObject = __webpack_require__("sB3e");
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "QBqZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(901);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(902) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($, undefined) {
	    var kendo = window.kendo,
	        diagram = kendo.dataviz.diagram,
	        Graph = diagram.Graph,
	        Node = diagram.Node,
	        Link = diagram.Link,
	        deepExtend = kendo.deepExtend,
	        Size = diagram.Size,
	        Rect = diagram.Rect,
	        Dictionary = diagram.Dictionary,
	        Set = diagram.Set,
	        HyperTree = diagram.Graph,
	        Utils = diagram.Utils,
	        Point = diagram.Point,
	        EPSILON = 1e-06,
	        DEG_TO_RAD = Math.PI / 180,
	        contains = Utils.contains,
	        grep = $.grep;

	    /**
	     * Base class for layout algorithms.
	     * @type {*}
	     */
	    var LayoutBase = kendo.Class.extend({
	        defaultOptions: {
	            type: "Tree",
	            subtype: "Down",
	            roots: null,
	            animate: false,
	            //-------------------------------------------------------------------
	            /**
	             * Force-directed option: whether the motion of the nodes should be limited by the boundaries of the diagram surface.
	             */
	            limitToView: false,
	            /**
	             * Force-directed option: the amount of friction applied to the motion of the nodes.
	             */
	            friction: 0.9,
	            /**
	             * Force-directed option: the optimal distance between nodes (minimum energy).
	             */
	            nodeDistance: 50,
	            /**
	             * Force-directed option: the number of time things are being calculated.
	             */
	            iterations: 300,
	            //-------------------------------------------------------------------
	            /**
	             * Tree option: the separation in one direction (depends on the subtype what direction this is).
	             */
	            horizontalSeparation: 90,
	            /**
	             * Tree option: the separation in the complementary direction (depends on the subtype what direction this is).
	             */
	            verticalSeparation: 50,

	            //-------------------------------------------------------------------
	            /**
	             * Tip-over tree option: children-to-parent vertical distance.
	             */
	            underneathVerticalTopOffset: 15,
	            /**
	             * Tip-over tree option: children-to-parent horizontal distance.
	             */
	            underneathHorizontalOffset: 15,
	            /**
	             * Tip-over tree option: leaf-to-next-branch vertical distance.
	             */
	            underneathVerticalSeparation: 15,
	            //-------------------------------------------------------------------
	            /**
	             * Settings object to organize the different components of the diagram in a grid layout structure
	             */
	            grid: {
	                /**
	                 * The width of the grid in which components are arranged. Beyond this width a component will be on the next row.
	                 */
	                width: 1500,
	                /**
	                 * The left offset of the grid.
	                 */
	                offsetX: 50,
	                /**
	                 * The top offset of the grid.
	                 */
	                offsetY: 50,
	                /**
	                 * The horizontal padding within a cell of the grid where a single component resides.
	                 */
	                componentSpacingX: 20,
	                /**
	                 * The vertical padding within a cell of the grid where a single component resides.
	                 */
	                componentSpacingY: 20
	            },

	            //-------------------------------------------------------------------
	            /**
	             * Layered option: the separation height/width between the layers.
	             */
	            layerSeparation: 50,
	            /**
	             * Layered option: how many rounds of shifting and fine-tuning.
	             */
	            layeredIterations: 2,
	            /**
	             * Tree-radial option: the angle at which the layout starts.
	             */
	            startRadialAngle: 0,
	            /**
	             * Tree-radial option: the angle at which the layout starts.
	             */
	            endRadialAngle: 360,
	            /**
	             * Tree-radial option: the separation between levels.
	             */
	            radialSeparation: 150,
	            /**
	             * Tree-radial option: the separation between the root and the first level.
	             */
	            radialFirstLevelSeparation: 200,
	            /**
	             * Tree-radial option: whether a virtual roots bing the components in one radial layout.
	             */
	            keepComponentsInOneRadialLayout: false,
	            //-------------------------------------------------------------------

	            // TODO: ensure to change this to false when containers are around
	            ignoreContainers: true,
	            layoutContainerChildren: false,
	            ignoreInvisible: true,
	            animateTransitions: false
	        },
	        init: function () {
	        },

	        /**
	         * Organizes the components in a grid.
	         * Returns the final set of nodes (not the Graph).
	         * @param components
	         */
	        gridLayoutComponents: function (components) {
	            if (!components) {
	                throw "No components supplied.";
	            }

	            // calculate and cache the bounds of the components
	            Utils.forEach(components, function (c) {
	                c.calcBounds();
	            });

	            // order by decreasing width
	            components.sort(function (a, b) {
	                return b.bounds.width - a.bounds.width;
	            });

	            var maxWidth = this.options.grid.width,
	                offsetX = this.options.grid.componentSpacingX,
	                offsetY = this.options.grid.componentSpacingY,
	                height = 0,
	                startX = this.options.grid.offsetX,
	                startY = this.options.grid.offsetY,
	                x = startX,
	                y = startY,
	                i,
	                resultLinkSet = [],
	                resultNodeSet = [];

	            while (components.length > 0) {
	                if (x >= maxWidth) {
	                    // start a new row
	                    x = startX;
	                    y += height + offsetY;
	                    // reset the row height
	                    height = 0;
	                }
	                var component = components.pop();
	                this.moveToOffset(component, new Point(x, y));
	                for (i = 0; i < component.nodes.length; i++) {
	                    resultNodeSet.push(component.nodes[i]); // to be returned in the end
	                }
	                for (i = 0; i < component.links.length; i++) {
	                    resultLinkSet.push(component.links[i]);
	                }
	                var boundingRect = component.bounds;
	                var currentHeight = boundingRect.height;
	                if (currentHeight <= 0 || isNaN(currentHeight)) {
	                    currentHeight = 0;
	                }
	                var currentWidth = boundingRect.width;
	                if (currentWidth <= 0 || isNaN(currentWidth)) {
	                    currentWidth = 0;
	                }

	                if (currentHeight >= height) {
	                    height = currentHeight;
	                }
	                x += currentWidth + offsetX;
	            }

	            return {
	                nodes: resultNodeSet,
	                links: resultLinkSet
	            };
	        },

	        moveToOffset: function (component, p) {
	            var i, j,
	                bounds = component.bounds,
	                deltax = p.x - bounds.x,
	                deltay = p.y - bounds.y;

	            for (i = 0; i < component.nodes.length; i++) {
	                var node = component.nodes[i];
	                var nodeBounds = node.bounds();
	                if (nodeBounds.width === 0 && nodeBounds.height === 0 && nodeBounds.x === 0 && nodeBounds.y === 0) {
	                    nodeBounds = new Rect(0, 0, 0, 0);
	                }
	                nodeBounds.x += deltax;
	                nodeBounds.y += deltay;
	                node.bounds(nodeBounds);
	            }
	            for (i = 0; i < component.links.length; i++) {
	                var link = component.links[i];
	                if (link.points) {
	                    var newpoints = [];
	                    var points = link.points;
	                    for (j = 0; j < points.length; j++) {
	                        var pt = points[j];
	                        pt.x += deltax;
	                        pt.y += deltay;
	                        newpoints.push(pt);
	                    }
	                    link.points = newpoints;
	                }
	            }
	            this.currentHorizontalOffset += bounds.width + this.options.grid.offsetX;
	            return new Point(deltax, deltay);
	        },

	        transferOptions: function (options) {

	            // Size options lead to stackoverflow and need special handling

	            this.options = kendo.deepExtend({}, this.defaultOptions);
	            if (Utils.isUndefined(options)) {
	                return;
	            }

	            this.options = kendo.deepExtend(this.options, options || {});
	        }
	    });

	    /**
	     * The data bucket a hypertree holds in its nodes.     *
	     * @type {*}
	     */
	    /* var ContainerGraph = kendo.Class.extend({
	     init: function (diagram) {
	     this.diagram = diagram;
	     this.graph = new Graph(diagram);
	     this.container = null;
	     this.containerNode = null;
	     }

	     });*/

	    /**
	     * Adapter between the diagram control and the graph representation. It converts shape and connections to nodes and edges taking into the containers and their collapsef state,
	     * the visibility of items and more. If the layoutContainerChildren is true a hypertree is constructed which holds the hierarchy of containers and many conditions are analyzed
	     * to investigate how the effective graph structure looks like and how the layout has to be performed.
	     * @type {*}
	     */
	    var DiagramToHyperTreeAdapter = kendo.Class.extend({
	        init: function (diagram) {

	            /**
	             * The mapping to/from the original nodes.
	             * @type {Dictionary}
	             */
	            this.nodeMap = new Dictionary();

	            /**
	             * Gets the mapping of a shape to a container in case the shape sits in a collapsed container.
	             * @type {Dictionary}
	             */
	            this.shapeMap = new Dictionary();

	            /**
	             * The nodes being mapped.
	             * @type {Dictionary}
	             */
	            this.nodes = [];

	            /**
	             * The connections being mapped.
	             * @type {Dictionary}
	             */
	            this.edges = [];

	            // the mapping from an edge to all the connections it represents, this can be both because of multiple connections between
	            // two shapes or because a container holds multiple connections to another shape or container.
	            this.edgeMap = new Dictionary();

	            /**
	             * The resulting set of Nodes when the analysis has finished.
	             * @type {Array}
	             */
	            this.finalNodes = [];

	            /**
	             * The resulting set of Links when the analysis has finished.
	             * @type {Array}
	             */
	            this.finalLinks = [];

	            /**
	             * The items being omitted because of multigraph edges.
	             * @type {Array}
	             */
	            this.ignoredConnections = [];

	            /**
	             * The items being omitted because of containers, visibility and other factors.
	             * @type {Array}
	             */
	            this.ignoredShapes = [];

	            /**
	             * The map from a node to the partition/hypernode in which it sits. This hyperMap is null if 'options.layoutContainerChildren' is false.
	             * @type {Dictionary}
	             */
	            this.hyperMap = new Dictionary();

	            /**
	             * The hypertree contains the hierarchy defined by the containers.
	             * It's in essence a Graph of Graphs with a tree structure defined by the hierarchy of containers.
	             * @type {HyperTree}
	             */
	            this.hyperTree = new Graph();

	            /**
	             * The resulting graph after conversion. Note that this does not supply the information contained in the
	             * ignored connection and shape collections.
	             * @type {null}
	             */
	            this.finalGraph = null;

	            this.diagram = diagram;
	        },

	        /**
	         * The hyperTree is used when the 'options.layoutContainerChildren' is true. It contains the hierarchy of containers whereby each node is a ContainerGraph.
	         * This type of node has a Container reference to the container which holds the Graph items. There are three possible situations during the conversion process:
	         *  - Ignore the containers: the container are non-existent and only normal shapes are mapped. If a shape has a connection to a container it will be ignored as well
	         *    since there is no node mapped for the container.
	         *  - Do not ignore the containers and leave the content of the containers untouched: the top-level elements are being mapped and the children within a container are not altered.
	         *  - Do not ignore the containers and organize the content of the containers as well: the hypertree is constructed and there is a partitioning of all nodes and connections into the hypertree.
	         *    The only reason a connection or node is not being mapped might be due to the visibility, which includes the visibility change through a collapsed parent container.
	         * @param options
	         */
	        convert: function (options) {

	            if (Utils.isUndefined(this.diagram)) {
	                throw "No diagram to convert.";
	            }

	            this.options = kendo.deepExtend({
	                    ignoreInvisible: true,
	                    ignoreContainers: true,
	                    layoutContainerChildren: false
	                },
	                options || {}
	            );

	            this.clear();
	            // create the nodes which participate effectively in the graph analysis
	            this._renormalizeShapes();

	            // recreate the incoming and outgoing collections of each and every node
	            this._renormalizeConnections();

	            // export the resulting graph
	            this.finalNodes = new Dictionary(this.nodes);
	            this.finalLinks = new Dictionary(this.edges);

	            this.finalGraph = new Graph();
	            this.finalNodes.forEach(function (n) {
	                this.finalGraph.addNode(n);
	            }, this);
	            this.finalLinks.forEach(function (l) {
	                this.finalGraph.addExistingLink(l);
	            }, this);
	            return this.finalGraph;
	        },

	        /**
	         * Maps the specified connection to an edge of the graph deduced from the given diagram.
	         * @param connection
	         * @returns {*}
	         */
	        mapConnection: function (connection) {
	            return this.edgeMap.get(connection.id);
	        },

	        /**
	         * Maps the specified shape to a node of the graph deduced from the given diagram.
	         * @param shape
	         * @returns {*}
	         */
	        mapShape: function (shape) {
	            return this.nodeMap.get(shape.id);
	        },

	        /**
	         * Gets the edge, if any, between the given nodes.
	         * @param a
	         * @param b
	         */
	        getEdge: function (a, b) {
	            return Utils.first(a.links, function (link) {
	                return link.getComplement(a) === b;
	            });
	        },

	        /**
	         * Clears all the collections used by the conversion process.
	         */
	        clear: function () {
	            this.finalGraph = null;
	            this.hyperTree = (!this.options.ignoreContainers && this.options.layoutContainerChildren) ? new HyperTree() : null;
	            this.hyperMap = (!this.options.ignoreContainers && this.options.layoutContainerChildren) ? new Dictionary() : null;
	            this.nodeMap = new Dictionary();
	            this.shapeMap = new Dictionary();
	            this.nodes = [];
	            this.edges = [];
	            this.edgeMap = new Dictionary();
	            this.ignoredConnections = [];
	            this.ignoredShapes = [];
	            this.finalNodes = [];
	            this.finalLinks = [];
	        },

	        /**
	         * The path from a given ContainerGraph to the root (container).
	         * @param containerGraph
	         * @returns {Array}
	         */
	        listToRoot: function (containerGraph) {
	            var list = [];
	            var s = containerGraph.container;
	            if (!s) {
	                return list;
	            }
	            list.push(s);
	            while (s.parentContainer) {
	                s = s.parentContainer;
	                list.push(s);
	            }
	            list.reverse();
	            return list;
	        },

	        firstNonIgnorableContainer: function (shape) {

	            if (shape.isContainer && !this._isIgnorableItem(shape)) {
	                return shape;
	            }
	            return !shape.parentContainer ? null : this.firstNonIgnorableContainer(shape.parentContainer);
	        },
	        isContainerConnection: function (a, b) {
	            if (a.isContainer && this.isDescendantOf(a, b)) {
	                return true;
	            }
	            return b.isContainer && this.isDescendantOf(b, a);
	        },

	        /**
	         * Returns true if the given shape is a direct child or a nested container child of the given container.
	         * If the given container and shape are the same this will return false since a shape cannot be its own child.
	         * @param scope
	         * @param a
	         * @returns {boolean}
	         */
	        isDescendantOf: function (scope, a) {
	            if (!scope.isContainer) {
	                throw "Expecting a container.";
	            }
	            if (scope === a) {
	                return false;
	            }
	            if (contains(scope.children, a)) {
	                return true;
	            }
	            var containers = [];
	            for (var i = 0, len = scope.children.length; i < len; i++) {
	                var c = scope.children[i];
	                if (c.isContainer && this.isDescendantOf(c, a)) {
	                    containers.push(c);
	                }
	            }

	            return containers.length > 0;
	        },
	        isIgnorableItem: function (shape) {
	            if (this.options.ignoreInvisible) {
	                if (shape.isCollapsed && this._isVisible(shape)) {
	                    return false;
	                }
	                if (!shape.isCollapsed && this._isVisible(shape)) {
	                    return false;
	                }
	                return true;
	            }
	            else {
	                return shape.isCollapsed && !this._isTop(shape);
	            }
	        },

	        /**
	         *  Determines whether the shape is or needs to be mapped to another shape. This occurs essentially when the shape sits in
	         * a collapsed container hierarchy and an external connection needs a node endpoint. This node then corresponds to the mapped shape and is
	         * necessarily a container in the parent hierarchy of the shape.
	         * @param shape
	         */
	        isShapeMapped: function (shape) {
	            return shape.isCollapsed && !this._isVisible(shape) && !this._isTop(shape);
	        },

	        leastCommonAncestor: function (a, b) {
	            if (!a) {
	                throw "Parameter should not be null.";
	            }
	            if (!b) {
	                throw "Parameter should not be null.";
	            }

	            if (!this.hyperTree) {
	                throw "No hypertree available.";
	            }
	            var al = this.listToRoot(a);
	            var bl = this.listToRoot(b);
	            var found = null;
	            if (Utils.isEmpty(al) || Utils.isEmpty(bl)) {
	                return this.hyperTree.root.data;
	            }
	            var xa = al[0];
	            var xb = bl[0];
	            var i = 0;
	            while (xa === xb) {
	                found = al[i];
	                i++;
	                if (i >= al.length || i >= bl.length) {
	                    break;
	                }
	                xa = al[i];
	                xb = bl[i];
	            }
	            if (!found) {
	                return this.hyperTree.root.data;
	            }
	            else {
	                return grep(this.hyperTree.nodes, function (n) {
	                    return  n.data.container === found;
	                });
	            }
	        },
	        /**
	         * Determines whether the specified item is a top-level shape or container.
	         * @param item
	         * @returns {boolean}
	         * @private
	         */
	        _isTop: function (item) {
	            return !item.parentContainer;
	        },

	        /**
	         * Determines iteratively (by walking up the container stack) whether the specified shape is visible.
	         * This does NOT tell whether the item is not visible due to an explicit Visibility change or due to a collapse state.
	         * @param shape
	         * @returns {*}
	         * @private
	         */
	        _isVisible: function (shape) {

	            if (!shape.visible()) {
	                return false;
	            }
	            return !shape.parentContainer ? shape.visible() : this._isVisible(shape.parentContainer);
	        },

	        _isCollapsed: function (shape) {

	            if (shape.isContainer && shape.isCollapsed) {
	                return true;
	            }
	            return shape.parentContainer && this._isCollapsed(shape.parentContainer);
	        },

	        /**
	         * First part of the graph creation; analyzing the shapes and containers and deciding whether they should be mapped to a Node.
	         * @private
	         */
	        _renormalizeShapes: function () {
	            // add the nodes, the adjacency structure will be reconstructed later on
	            if (this.options.ignoreContainers) {
	                for (var i = 0, len = this.diagram.shapes.length; i < len; i++) {
	                    var shape = this.diagram.shapes[i];

	                    // if not visible (and ignoring the invisible ones) or a container we skip
	                    if ((this.options.ignoreInvisible && !this._isVisible(shape)) || shape.isContainer) {
	                        this.ignoredShapes.push(shape);
	                        continue;
	                    }
	                    var node = new Node(shape.id, shape);
	                    node.isVirtual = false;

	                    // the mapping will always contain singletons and the hyperTree will be null
	                    this.nodeMap.add(shape.id, node);
	                    this.nodes.push(node);
	                }
	            }
	            else {
	                throw "Containers are not supported yet, but stay tuned.";
	            }
	        },

	        /**
	         * Second part of the graph creation; analyzing the connections and deciding whether they should be mapped to an edge.
	         * @private
	         */
	        _renormalizeConnections: function () {
	            if (this.diagram.connections.length === 0) {
	                return;
	            }
	            for (var i = 0, len = this.diagram.connections.length; i < len; i++) {
	                var conn = this.diagram.connections[i];

	                if (this.isIgnorableItem(conn)) {
	                    this.ignoredConnections.push(conn);
	                    continue;
	                }

	                var source = !conn.sourceConnector ? null : conn.sourceConnector.shape;
	                var sink = !conn.targetConnector ? null : conn.targetConnector.shape;

	                // no layout for floating connections
	                if (!source || !sink) {
	                    this.ignoredConnections.push(conn);
	                    continue;
	                }

	                if (contains(this.ignoredShapes, source) && !this.shapeMap.containsKey(source)) {
	                    this.ignoredConnections.push(conn);
	                    continue;
	                }
	                if (contains(this.ignoredShapes, sink) && !this.shapeMap.containsKey(sink)) {
	                    this.ignoredConnections.push(conn);
	                    continue;
	                }

	                // if the endpoint sits in a collapsed container we need the container rather than the shape itself
	                if (this.shapeMap.containsKey(source)) {
	                    source = this.shapeMap[source];
	                }
	                if (this.shapeMap.containsKey(sink)) {
	                    sink = this.shapeMap[sink];
	                }

	                var sourceNode = this.mapShape(source);
	                var sinkNode = this.mapShape(sink);
	                if ((sourceNode === sinkNode) || this.areConnectedAlready(sourceNode, sinkNode)) {
	                    this.ignoredConnections.push(conn);
	                    continue;
	                }

	                if (sourceNode === null || sinkNode === null) {
	                    throw "A shape was not mapped to a node.";
	                }
	                if (this.options.ignoreContainers) {
	                    // much like a floating connection here since at least one end is attached to a container
	                    if (sourceNode.isVirtual || sinkNode.isVirtual) {
	                        this.ignoredConnections.push(conn);
	                        continue;
	                    }
	                    var newEdge = new Link(sourceNode, sinkNode, conn.id, conn);

	                    this.edgeMap.add(conn.id, newEdge);
	                    this.edges.push(newEdge);
	                }
	                else {
	                    throw "Containers are not supported yet, but stay tuned.";
	                }
	            }
	        },

	        areConnectedAlready: function (n, m) {
	            return Utils.any(this.edges, function (l) {
	                return l.source === n && l.target === m || l.source === m && l.target === n;
	            });
	        }

	        /**
	         * Depth-first traversal of the given container.
	         * @param container
	         * @param action
	         * @param includeStart
	         * @private
	         */
	        /* _visitContainer: function (container, action, includeStart) {

	         *//*if (container == null) throw new ArgumentNullException("container");
	         if (action == null) throw new ArgumentNullException("action");
	         if (includeStart) action(container);
	         if (container.children.isEmpty()) return;
	         foreach(
	         var item
	         in
	         container.children.OfType < IShape > ()
	         )
	         {
	         var childContainer = item
	         as
	         IContainerShape;
	         if (childContainer != null) this.VisitContainer(childContainer, action);
	         else action(item);
	         }*//*
	         }*/


	    });

	    /**
	     * The classic spring-embedder (aka force-directed, Fruchterman-Rheingold, barycentric) algorithm.
	     * http://en.wikipedia.org/wiki/Force-directed_graph_drawing
	     *  - Chapter 12 of Tamassia et al. "Handbook of graph drawing and visualization".
	     *  - Kobourov on preprint arXiv; http://arxiv.org/pdf/1201.3011.pdf
	     *  - Fruchterman and Rheingold in SOFTWARE-PRACTICE AND EXPERIENCE, VOL. 21(1 1), 1129-1164 (NOVEMBER 1991)
	     * @type {*}
	     */
	    var SpringLayout = LayoutBase.extend({
	        init: function (diagram) {
	            var that = this;
	            LayoutBase.fn.init.call(that);
	            if (Utils.isUndefined(diagram)) {
	                throw "Diagram is not specified.";
	            }
	            this.diagram = diagram;
	        },

	        layout: function (options) {

	            this.transferOptions(options);

	            var adapter = new DiagramToHyperTreeAdapter(this.diagram);
	            var graph = adapter.convert(options);
	            if (graph.isEmpty()) {
	                return;
	            }
	            // split into connected components
	            var components = graph.getConnectedComponents();
	            if (Utils.isEmpty(components)) {
	                return;
	            }
	            for (var i = 0; i < components.length; i++) {
	                var component = components[i];
	                this.layoutGraph(component, options);
	            }
	            var finalNodeSet = this.gridLayoutComponents(components);
	            return new diagram.LayoutState(this.diagram, finalNodeSet);
	        },

	        layoutGraph: function (graph, options) {

	            if (Utils.isDefined(options)) {
	                this.transferOptions(options);
	            }
	            this.graph = graph;

	            var initialTemperature = this.options.nodeDistance * 9;
	            this.temperature = initialTemperature;

	            var guessBounds = this._expectedBounds();
	            this.width = guessBounds.width;
	            this.height = guessBounds.height;

	            for (var step = 0; step < this.options.iterations; step++) {
	                this.refineStage = step >= this.options.iterations * 5 / 6;
	                this.tick();
	                // exponential cooldown
	                this.temperature = this.refineStage ?
	                    initialTemperature / 30 :
	                    initialTemperature * (1 - step / (2 * this.options.iterations ));
	            }
	        },

	        /**
	         * Single iteration of the simulation.
	         */
	        tick: function () {
	            var i;
	            // collect the repulsive forces on each node
	            for (i = 0; i < this.graph.nodes.length; i++) {
	                this._repulsion(this.graph.nodes[i]);
	            }

	            // collect the attractive forces on each node
	            for (i = 0; i < this.graph.links.length; i++) {
	                this._attraction(this.graph.links[i]);
	            }
	            // update the positions
	            for (i = 0; i < this.graph.nodes.length; i++) {
	                var node = this.graph.nodes[i];
	                var offset = Math.sqrt(node.dx * node.dx + node.dy * node.dy);
	                if (offset === 0) {
	                    return;
	                }
	                node.x += Math.min(offset, this.temperature) * node.dx / offset;
	                node.y += Math.min(offset, this.temperature) * node.dy / offset;
	                if (this.options.limitToView) {
	                    node.x = Math.min(this.width, Math.max(node.width / 2, node.x));
	                    node.y = Math.min(this.height, Math.max(node.height / 2, node.y));
	                }
	            }
	        },

	        /**
	         * Shakes the node away from its current position to escape the deadlock.
	         * @param node A Node.
	         * @private
	         */
	        _shake: function (node) {
	            // just a simple polar neighborhood
	            var rho = Math.random() * this.options.nodeDistance / 4;
	            var alpha = Math.random() * 2 * Math.PI;
	            node.x += rho * Math.cos(alpha);
	            node.y -= rho * Math.sin(alpha);
	        },

	        /**
	         * The typical Coulomb-Newton force law F=k/r^2
	         * @remark This only works in dimensions less than three.
	         * @param d
	         * @param n A Node.
	         * @param m Another Node.
	         * @returns {number}
	         * @private
	         */
	        _InverseSquareForce: function (d, n, m) {
	            var force;
	            if (!this.refineStage) {
	                force = Math.pow(d, 2) / Math.pow(this.options.nodeDistance, 2);
	            }
	            else {
	                var deltax = n.x - m.x;
	                var deltay = n.y - m.y;

	                var wn = n.width / 2;
	                var hn = n.height / 2;
	                var wm = m.width / 2;
	                var hm = m.height / 2;

	                force = (Math.pow(deltax, 2) / Math.pow(wn + wm + this.options.nodeDistance, 2)) + (Math.pow(deltay, 2) / Math.pow(hn + hm + this.options.nodeDistance, 2));
	            }
	            return force * 4 / 3;
	        },

	        /**
	         * The typical Hooke force law F=kr^2
	         * @param d
	         * @param n
	         * @param m
	         * @returns {number}
	         * @private
	         */
	        _SquareForce: function (d, n, m) {
	            return 1 / this._InverseSquareForce(d, n, m);
	        },

	        _repulsion: function (n) {
	            n.dx = 0;
	            n.dy = 0;
	            Utils.forEach(this.graph.nodes, function (m) {
	                if (m === n) {
	                    return;
	                }
	                while (n.x === m.x && n.y === m.y) {
	                    this._shake(m);
	                }
	                var vx = n.x - m.x;
	                var vy = n.y - m.y;
	                var distance = Math.sqrt(vx * vx + vy * vy);
	                var r = this._SquareForce(distance, n, m) * 2;
	                n.dx += (vx / distance) * r;
	                n.dy += (vy / distance) * r;
	            }, this);
	        },
	        _attraction: function (link) {
	            var t = link.target;
	            var s = link.source;
	            if (s === t) {
	                // loops induce endless shakes
	                return;
	            }
	            while (s.x === t.x && s.y === t.y) {
	                this._shake(t);
	            }

	            var vx = s.x - t.x;
	            var vy = s.y - t.y;
	            var distance = Math.sqrt(vx * vx + vy * vy);

	            var a = this._InverseSquareForce(distance, s, t) * 5;
	            var dx = (vx / distance) * a;
	            var dy = (vy / distance) * a;
	            t.dx += dx;
	            t.dy += dy;
	            s.dx -= dx;
	            s.dy -= dy;
	        },

	        /**
	         * Calculates the expected bounds after layout.
	         * @returns {*}
	         * @private
	         */
	        _expectedBounds: function () {

	            var size, N = this.graph.nodes.length, /*golden ration optimal?*/ ratio = 1.5, multiplier = 4;
	            if (N === 0) {
	                return size;
	            }
	            size = Utils.fold(this.graph.nodes, function (s, node) {
	                var area = node.width * node.height;
	                if (area > 0) {
	                    s += Math.sqrt(area);
	                    return s;
	                }
	                return 0;
	            }, 0, this);
	            var av = size / N;
	            var squareSize = av * Math.ceil(Math.sqrt(N));
	            var width = squareSize * Math.sqrt(ratio);
	            var height = squareSize / Math.sqrt(ratio);
	            return { width: width * multiplier, height: height * multiplier };
	        }

	    });

	    var TreeLayoutProcessor = kendo.Class.extend({

	        init: function (options) {
	            this.center = null;
	            this.options = options;
	        },
	        layout: function (treeGraph, root) {
	            this.graph = treeGraph;
	            if (!this.graph.nodes || this.graph.nodes.length === 0) {
	                return;
	            }

	            if (!contains(this.graph.nodes, root)) {
	                throw "The given root is not in the graph.";
	            }

	            this.center = root;
	            this.graph.cacheRelationships();
	            /* var nonull = this.graph.nodes.where(function (n) {
	             return n.associatedShape != null;
	             });*/

	            // transfer the rects
	            /*nonull.forEach(function (n) {
	             n.Location = n.associatedShape.Position;
	             n.NodeSize = n.associatedShape.ActualBounds.ToSize();
	             }

	             );*/

	            // caching the children
	            /* nonull.forEach(function (n) {
	             n.children = n.getChildren();
	             });*/

	            this.layoutSwitch();

	            // apply the layout to the actual visuals
	            // nonull.ForEach(n => n.associatedShape.Position = n.Location);
	        },

	        layoutLeft: function (left) {
	            this.setChildrenDirection(this.center, "Left", false);
	            this.setChildrenLayout(this.center, "Default", false);
	            var h = 0, w = 0, y, i, node;
	            for (i = 0; i < left.length; i++) {
	                node = left[i];
	                node.TreeDirection = "Left";
	                var s = this.measure(node, Size.Empty);
	                w = Math.max(w, s.Width);
	                h += s.height + this.options.verticalSeparation;
	            }

	            h -= this.options.verticalSeparation;
	            var x = this.center.x - this.options.horizontalSeparation;
	            y = this.center.y + ((this.center.height - h) / 2);
	            for (i = 0; i < left.length; i++) {
	                node = left[i];
	                var p = new Point(x - node.Size.width, y);

	                this.arrange(node, p);
	                y += node.Size.height + this.options.verticalSeparation;
	            }
	        },

	        layoutRight: function (right) {
	            this.setChildrenDirection(this.center, "Right", false);
	            this.setChildrenLayout(this.center, "Default", false);
	            var h = 0, w = 0, y, i, node;
	            for (i = 0; i < right.length; i++) {
	                node = right[i];
	                node.TreeDirection = "Right";
	                var s = this.measure(node, Size.Empty);
	                w = Math.max(w, s.Width);
	                h += s.height + this.options.verticalSeparation;
	            }

	            h -= this.options.verticalSeparation;
	            var x = this.center.x + this.options.horizontalSeparation + this.center.width;
	            y = this.center.y + ((this.center.height - h) / 2);
	            for (i = 0; i < right.length; i++) {
	                node = right[i];
	                var p = new Point(x, y);
	                this.arrange(node, p);
	                y += node.Size.height + this.options.verticalSeparation;
	            }
	        },

	        layoutUp: function (up) {
	            this.setChildrenDirection(this.center, "Up", false);
	            this.setChildrenLayout(this.center, "Default", false);
	            var w = 0, y, node, i;
	            for (i = 0; i < up.length; i++) {
	                node = up[i];
	                node.TreeDirection = "Up";
	                var s = this.measure(node, Size.Empty);
	                w += s.width + this.options.horizontalSeparation;
	            }

	            w -= this.options.horizontalSeparation;
	            var x = this.center.x + (this.center.width / 2) - (w / 2);

	            // y = this.center.y -verticalSeparation -this.center.height/2 - h;
	            for (i = 0; i < up.length; i++) {
	                node = up[i];
	                y = this.center.y - this.options.verticalSeparation - node.Size.height;
	                var p = new Point(x, y);
	                this.arrange(node, p);
	                x += node.Size.width + this.options.horizontalSeparation;
	            }
	        },

	        layoutDown: function (down) {
	            var node, i;
	            this.setChildrenDirection(this.center, "Down", false);
	            this.setChildrenLayout(this.center, "Default", false);
	            var w = 0, y;
	            for (i = 0; i < down.length; i++) {
	                node = down[i];
	                node.treeDirection = "Down";
	                var s = this.measure(node, Size.Empty);
	                w += s.width + this.options.horizontalSeparation;
	            }

	            w -= this.options.horizontalSeparation;
	            var x = this.center.x + (this.center.width / 2) - (w / 2);
	            y = this.center.y + this.options.verticalSeparation + this.center.height;
	            for (i = 0; i < down.length; i++) {
	                node = down[i];
	                var p = new Point(x, y);
	                this.arrange(node, p);
	                x += node.Size.width + this.options.horizontalSeparation;
	            }
	        },

	        layoutRadialTree: function () {
	            // var rmax = children.Aggregate(0D, (current, node) => Math.max(node.SectorAngle, current));
	            this.setChildrenDirection(this.center, "Radial", false);
	            this.setChildrenLayout(this.center, "Default", false);
	            this.previousRoot = null;
	            var startAngle = this.options.startRadialAngle * DEG_TO_RAD;
	            var endAngle = this.options.endRadialAngle * DEG_TO_RAD;
	            if (endAngle <= startAngle) {
	                throw "Final angle should not be less than the start angle.";
	            }

	            this.maxDepth = 0;
	            this.origin = new Point(this.center.x, this.center.y);
	            this.calculateAngularWidth(this.center, 0);

	            // perform the layout
	            if (this.maxDepth > 0) {
	                this.radialLayout(this.center, this.options.radialFirstLevelSeparation, startAngle, endAngle);
	            }

	            // update properties of the root node
	            this.center.Angle = endAngle - startAngle;
	        },

	        tipOverTree: function (down, startFromLevel) {
	            if (Utils.isUndefined(startFromLevel)) {
	                startFromLevel = 0;
	            }

	            this.setChildrenDirection(this.center, "Down", false);
	            this.setChildrenLayout(this.center, "Default", false);
	            this.setChildrenLayout(this.center, "Underneath", false, startFromLevel);
	            var w = 0, y, node, i;
	            for (i = 0; i < down.length; i++) {
	                node = down[i];

	                // if (node.IsSpecial) continue;
	                node.TreeDirection = "Down";
	                var s = this.measure(node, Size.Empty);
	                w += s.width + this.options.horizontalSeparation;
	            }

	            w -= this.options.horizontalSeparation;

	            // putting the root in the center with respect to the whole diagram is not a nice result, let's put it with respect to the first level only
	            w -= down[down.length - 1].width;
	            w += down[down.length - 1].associatedShape.bounds().width;

	            var x = this.center.x + (this.center.width / 2) - (w / 2);
	            y = this.center.y + this.options.verticalSeparation + this.center.height;
	            for (i = 0; i < down.length; i++) {
	                node = down[i];
	                // if (node.IsSpecial) continue;
	                var p = new Point(x, y);
	                this.arrange(node, p);
	                x += node.Size.width + this.options.horizontalSeparation;
	            }

	            /*//let's place the special node, assuming there is only one
	             if (down.Count(n => n.IsSpecial) > 0)
	             {
	             var special = (from n in down where n.IsSpecial select n).First();
	             if (special.Children.Count > 0)
	             throw new DiagramException("The 'special' element should not have children.");
	             special.Data.Location = new Point(Center.Data.Location.X + Center.AssociatedShape.BoundingRectangle.Width + this.options.HorizontalSeparation, Center.Data.Location.Y);
	             }*/
	        },
	        calculateAngularWidth: function (n, d) {
	            if (d > this.maxDepth) {
	                this.maxDepth = d;
	            }

	            var aw = 0, w = 1000, h = 1000, diameter = d === 0 ? 0 : Math.sqrt((w * w) + (h * h)) / d;

	            if (n.children.length > 0) {
	                // eventually with n.IsExpanded
	                for (var i = 0, len = n.children.length; i < len; i++) {
	                    var child = n.children[i];
	                    aw += this.calculateAngularWidth(child, d + 1);
	                }
	                aw = Math.max(diameter, aw);
	            }
	            else {
	                aw = diameter;
	            }

	            n.sectorAngle = aw;
	            return aw;
	        },
	        sortChildren: function (n) {
	            var basevalue = 0, i;

	            // update basevalue angle for node ordering
	            if (n.parents.length > 1) {
	                throw "Node is not part of a tree.";
	            }
	            var p = n.parents[0];
	            if (p) {
	                var pl = new Point(p.x, p.y);
	                var nl = new Point(n.x, n.y);
	                basevalue = this.normalizeAngle(Math.atan2(pl.y - nl.y, pl.x - nl.x));
	            }

	            var count = n.children.length;
	            if (count === 0) {
	                return null;
	            }

	            var angle = [];
	            var idx = [];

	            for (i = 0; i < count; ++i) {
	                var c = n.children[i];
	                var l = new Point(c.x, c.y);
	                idx[i] = i;
	                angle[i] = this.normalizeAngle(-basevalue + Math.atan2(l.y - l.y, l.x - l.x));
	            }

	            Utils.bisort(angle, idx);
	            var col = []; // list of nodes
	            var children = n.children;
	            for (i = 0; i < count; ++i) {
	                col.push(children[idx[i]]);
	            }

	            return col;
	        },

	        normalizeAngle: function (angle) {
	            while (angle > Math.PI * 2) {
	                angle -= 2 * Math.PI;
	            }
	            while (angle < 0) {
	                angle += Math.PI * 2;
	            }
	            return angle;
	        },
	        radialLayout: function (node, radius, startAngle, endAngle) {
	            var deltaTheta = endAngle - startAngle;
	            var deltaThetaHalf = deltaTheta / 2.0;
	            var parentSector = node.sectorAngle;
	            var fraction = 0;
	            var sorted = this.sortChildren(node);
	            for (var i = 0, len = sorted.length; i < len; i++) {
	                var childNode = sorted[i];
	                var cp = childNode;
	                var childAngleFraction = cp.sectorAngle / parentSector;
	                if (childNode.children.length > 0) {
	                    this.radialLayout(childNode,
	                        radius + this.options.radialSeparation,
	                        startAngle + (fraction * deltaTheta),
	                        startAngle + ((fraction + childAngleFraction) * deltaTheta));
	                }

	                this.setPolarLocation(childNode, radius, startAngle + (fraction * deltaTheta) + (childAngleFraction * deltaThetaHalf));
	                cp.angle = childAngleFraction * deltaTheta;
	                fraction += childAngleFraction;
	            }
	        },
	        setPolarLocation: function (node, radius, angle) {
	            node.x = this.origin.x + (radius * Math.cos(angle));
	            node.y = this.origin.y + (radius * Math.sin(angle));
	            node.BoundingRectangle = new Rect(node.x, node.y, node.width, node.height);
	        },

	        /**
	         * Sets the children direction recursively.
	         * @param node
	         * @param direction
	         * @param includeStart
	         */
	        setChildrenDirection: function (node, direction, includeStart) {
	            var rootDirection = node.treeDirection;
	            this.graph.depthFirstTraversal(node, function (n) {
	                n.treeDirection = direction;
	            });
	            if (!includeStart) {
	                node.treeDirection = rootDirection;
	            }
	        },

	        /**
	         * Sets the children layout recursively.
	         * @param node
	         * @param layout
	         * @param includeStart
	         * @param startFromLevel
	         */
	        setChildrenLayout: function (node, layout, includeStart, startFromLevel) {
	            if (Utils.isUndefined(startFromLevel)) {
	                startFromLevel = 0;
	            }
	            var rootLayout = node.childrenLayout;
	            if (startFromLevel > 0) {
	                // assign levels to the Node.Level property
	                this.graph.assignLevels(node);

	                // assign the layout on the condition that the level is at least the 'startFromLevel'
	                this.graph.depthFirstTraversal(
	                    node, function (s) {
	                        if (s.level >= startFromLevel + 1) {
	                            s.childrenLayout = layout;
	                        }
	                    }
	                );
	            }
	            else {
	                this.graph.depthFirstTraversal(node, function (s) {
	                    s.childrenLayout = layout;
	                });

	                // if the start should not be affected we put the state back
	                if (!includeStart) {
	                    node.childrenLayout = rootLayout;
	                }
	            }
	        },

	        /**
	         * Returns the actual size of the node. The given size is the allowed space wherein the node can lay out itself.
	         * @param node
	         * @param givenSize
	         * @returns {Size}
	         */
	        measure: function (node, givenSize) {
	            var w = 0, h = 0, s;
	            var result = new Size(0, 0);
	            if (!node) {
	                throw "";
	            }
	            var b = node.associatedShape.bounds();
	            var shapeWidth = b.width;
	            var shapeHeight = b.height;
	            if (node.parents.length !== 1) {
	                throw "Node not in a spanning tree.";
	            }

	            var parent = node.parents[0];
	            if (node.treeDirection === "Undefined") {
	                node.treeDirection = parent.treeDirection;
	            }

	            if (Utils.isEmpty(node.children)) {
	                result = new Size(
	                    Math.abs(shapeWidth) < EPSILON ? 50 : shapeWidth,
	                    Math.abs(shapeHeight) < EPSILON ? 25 : shapeHeight);
	            }
	            else if (node.children.length === 1) {
	                switch (node.treeDirection) {
	                    case "Radial":
	                        s = this.measure(node.children[0], givenSize); // child size
	                        w = shapeWidth + (this.options.radialSeparation * Math.cos(node.AngleToParent)) + s.width;
	                        h = shapeHeight + Math.abs(this.options.radialSeparation * Math.sin(node.AngleToParent)) + s.height;
	                        break;
	                    case "Left":
	                    case "Right":
	                        switch (node.childrenLayout) {

	                            case "TopAlignedWithParent":
	                                break;

	                            case "BottomAlignedWithParent":
	                                break;

	                            case "Underneath":
	                                s = this.measure(node.children[0], givenSize);
	                                w = shapeWidth + s.width + this.options.underneathHorizontalOffset;
	                                h = shapeHeight + this.options.underneathVerticalTopOffset + s.height;
	                                break;

	                            case "Default":
	                                s = this.measure(node.children[0], givenSize);
	                                w = shapeWidth + this.options.horizontalSeparation + s.width;
	                                h = Math.max(shapeHeight, s.height);
	                                break;

	                            default:
	                                throw "Unhandled TreeDirection in the Radial layout measuring.";
	                        }
	                        break;
	                    case "Up":
	                    case "Down":
	                        switch (node.childrenLayout) {

	                            case "TopAlignedWithParent":
	                            case "BottomAlignedWithParent":
	                                break;

	                            case "Underneath":
	                                s = this.measure(node.children[0], givenSize);
	                                w = Math.max(shapeWidth, s.width + this.options.underneathHorizontalOffset);
	                                h = shapeHeight + this.options.underneathVerticalTopOffset + s.height;
	                                break;

	                            case "Default":
	                                s = this.measure(node.children[0], givenSize);
	                                h = shapeHeight + this.options.verticalSeparation + s.height;
	                                w = Math.max(shapeWidth, s.width);
	                                break;

	                            default:
	                                throw "Unhandled TreeDirection in the Down layout measuring.";
	                        }
	                        break;
	                    default:
	                        throw "Unhandled TreeDirection in the layout measuring.";
	                }

	                result = new Size(w, h);
	            }
	            else {
	                var i, childNode;
	                switch (node.treeDirection) {
	                    case "Left":
	                    case "Right":
	                        switch (node.childrenLayout) {

	                            case "TopAlignedWithParent":
	                            case "BottomAlignedWithParent":
	                                break;

	                            case "Underneath":
	                                w = shapeWidth;
	                                h = shapeHeight + this.options.underneathVerticalTopOffset;
	                                for (i = 0; i < node.children.length; i++) {
	                                    childNode = node.children[i];
	                                    s = this.measure(childNode, givenSize);
	                                    w = Math.max(w, s.width + this.options.underneathHorizontalOffset);
	                                    h += s.height + this.options.underneathVerticalSeparation;
	                                }

	                                h -= this.options.underneathVerticalSeparation;
	                                break;

	                            case "Default":
	                                w = shapeWidth;
	                                h = 0;
	                                for (i = 0; i < node.children.length; i++) {
	                                    childNode = node.children[i];
	                                    s = this.measure(childNode, givenSize);
	                                    w = Math.max(w, shapeWidth + this.options.horizontalSeparation + s.width);
	                                    h += s.height + this.options.verticalSeparation;
	                                }
	                                h -= this.options.verticalSeparation;
	                                break;

	                            default:
	                                throw "Unhandled TreeDirection in the Right layout measuring.";
	                        }

	                        break;
	                    case "Up":
	                    case "Down":

	                        switch (node.childrenLayout) {

	                            case "TopAlignedWithParent":
	                            case "BottomAlignedWithParent":
	                                break;

	                            case "Underneath":
	                                w = shapeWidth;
	                                h = shapeHeight + this.options.underneathVerticalTopOffset;
	                                for (i = 0; i < node.children.length; i++) {
	                                    childNode = node.children[i];
	                                    s = this.measure(childNode, givenSize);
	                                    w = Math.max(w, s.width + this.options.underneathHorizontalOffset);
	                                    h += s.height + this.options.underneathVerticalSeparation;
	                                }

	                                h -= this.options.underneathVerticalSeparation;
	                                break;

	                            case "Default":
	                                w = 0;
	                                h = 0;
	                                for (i = 0; i < node.children.length; i++) {
	                                    childNode = node.children[i];
	                                    s = this.measure(childNode, givenSize);
	                                    w += s.width + this.options.horizontalSeparation;
	                                    h = Math.max(h, s.height + this.options.verticalSeparation + shapeHeight);
	                                }

	                                w -= this.options.horizontalSeparation;
	                                break;

	                            default:
	                                throw "Unhandled TreeDirection in the Down layout measuring.";
	                        }

	                        break;
	                    default:
	                        throw "Unhandled TreeDirection in the layout measuring.";
	                }

	                result = new Size(w, h);
	            }

	            node.SectorAngle = Math.sqrt((w * w / 4) + (h * h / 4));
	            node.Size = result;
	            return result;
	        },
	        arrange: function (n, p) {
	            var i, pp, child, node, childrenwidth, b = n.associatedShape.bounds();
	            var shapeWidth = b.width;
	            var shapeHeight = b.height;
	            if (Utils.isEmpty(n.children)) {
	                n.x = p.x;
	                n.y = p.y;
	                n.BoundingRectangle = new Rect(p.x, p.y, shapeWidth, shapeHeight);
	            }
	            else {
	                var x, y;
	                var selfLocation;
	                switch (n.treeDirection) {
	                    case "Left":
	                        switch (n.childrenLayout) {
	                            case "TopAlignedWithParent":
	                            case "BottomAlignedWithParent":
	                                break;

	                            case "Underneath":
	                                selfLocation = p;
	                                n.x = selfLocation.x;
	                                n.y = selfLocation.y;
	                                n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
	                                y = p.y + shapeHeight + this.options.underneathVerticalTopOffset;
	                                for (i = 0; i < node.children.length; i++) {
	                                    node = node.children[i];
	                                    x = selfLocation.x - node.associatedShape.width - this.options.underneathHorizontalOffset;
	                                    pp = new Point(x, y);
	                                    this.arrange(node, pp);
	                                    y += node.Size.height + this.options.underneathVerticalSeparation;
	                                }
	                                break;

	                            case "Default":
	                                selfLocation = new Point(p.x + n.Size.width - shapeWidth, p.y + ((n.Size.height - shapeHeight) / 2));
	                                n.x = selfLocation.x;
	                                n.y = selfLocation.y;
	                                n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
	                                x = selfLocation.x - this.options.horizontalSeparation; // alignment of children
	                                y = p.y;
	                                for (i = 0; i < n.children.length; i++) {
	                                    node = n.children[i];
	                                    pp = new Point(x - node.Size.width, y);
	                                    this.arrange(node, pp);
	                                    y += node.Size.height + this.options.verticalSeparation;
	                                }
	                                break;

	                            default:
	                                throw   "Unsupported TreeDirection";
	                        }

	                        break;
	                    case "Right":
	                        switch (n.childrenLayout) {
	                            case "TopAlignedWithParent":
	                            case "BottomAlignedWithParent":
	                                break;

	                            case "Underneath":
	                                selfLocation = p;
	                                n.x = selfLocation.x;
	                                n.y = selfLocation.y;
	                                n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
	                                x = p.x + shapeWidth + this.options.underneathHorizontalOffset;

	                                // alignment of children left-underneath the parent
	                                y = p.y + shapeHeight + this.options.underneathVerticalTopOffset;
	                                for (i = 0; i < n.children.length; i++) {
	                                    node = n.children[i];
	                                    pp = new Point(x, y);
	                                    this.arrange(node, pp);
	                                    y += node.Size.height + this.options.underneathVerticalSeparation;
	                                }

	                                break;

	                            case "Default":
	                                selfLocation = new Point(p.x, p.y + ((n.Size.height - shapeHeight) / 2));
	                                n.x = selfLocation.x;
	                                n.y = selfLocation.y;
	                                n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
	                                x = p.x + shapeWidth + this.options.horizontalSeparation; // alignment of children
	                                y = p.y;
	                                for (i = 0; i < n.children.length; i++) {
	                                    node = n.children[i];
	                                    pp = new Point(x, y);
	                                    this.arrange(node, pp);
	                                    y += node.Size.height + this.options.verticalSeparation;
	                                }
	                                break;

	                            default:
	                                throw   "Unsupported TreeDirection";
	                        }

	                        break;
	                    case "Up":
	                        selfLocation = new Point(p.x + ((n.Size.width - shapeWidth) / 2), p.y + n.Size.height - shapeHeight);
	                        n.x = selfLocation.x;
	                        n.y = selfLocation.y;
	                        n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
	                        if (Math.abs(selfLocation.x - p.x) < EPSILON) {
	                            childrenwidth = 0;
	                            // means there is an aberration due to the oversized Element with respect to the children
	                            for (i = 0; i < n.children.length; i++) {
	                                child = n.children[i];
	                                childrenwidth += child.Size.width + this.options.horizontalSeparation;
	                            }
	                            childrenwidth -= this.options.horizontalSeparation;
	                            x = p.x + ((shapeWidth - childrenwidth) / 2);
	                        }
	                        else {
	                            x = p.x;
	                        }

	                        for (i = 0; i < n.children.length; i++) {
	                            node = n.children[i];
	                            y = selfLocation.y - this.options.verticalSeparation - node.Size.height;
	                            pp = new Point(x, y);
	                            this.arrange(node, pp);
	                            x += node.Size.width + this.options.horizontalSeparation;
	                        }
	                        break;

	                    case "Down":

	                        switch (n.childrenLayout) {
	                            case "TopAlignedWithParent":
	                            case "BottomAlignedWithParent":
	                                break;
	                            case "Underneath":
	                                selfLocation = p;
	                                n.x = selfLocation.x;
	                                n.y = selfLocation.y;
	                                n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
	                                x = p.x + this.options.underneathHorizontalOffset; // alignment of children left-underneath the parent
	                                y = p.y + shapeHeight + this.options.underneathVerticalTopOffset;
	                                for (i = 0; i < n.children.length; i++) {
	                                    node = n.children[i];
	                                    pp = new Point(x, y);
	                                    this.arrange(node, pp);
	                                    y += node.Size.height + this.options.underneathVerticalSeparation;
	                                }
	                                break;

	                            case    "Default":
	                                selfLocation = new Point(p.x + ((n.Size.width - shapeWidth) / 2), p.y);
	                                n.x = selfLocation.x;
	                                n.y = selfLocation.y;
	                                n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
	                                if (Math.abs(selfLocation.x - p.x) < EPSILON) {
	                                    childrenwidth = 0;
	                                    // means there is an aberration due to the oversized Element with respect to the children
	                                    for (i = 0; i < n.children.length; i++) {
	                                        child = n.children[i];
	                                        childrenwidth += child.Size.width + this.options.horizontalSeparation;
	                                    }

	                                    childrenwidth -= this.options.horizontalSeparation;
	                                    x = p.x + ((shapeWidth - childrenwidth) / 2);
	                                }
	                                else {
	                                    x = p.x;
	                                }

	                                for (i = 0; i < n.children.length; i++) {
	                                    node = n.children[i];
	                                    y = selfLocation.y + this.options.verticalSeparation + shapeHeight;
	                                    pp = new Point(x, y);
	                                    this.arrange(node, pp);
	                                    x += node.Size.width + this.options.horizontalSeparation;
	                                }
	                                break;

	                            default:
	                                throw   "Unsupported TreeDirection";
	                        }
	                        break;

	                    case "None":
	                        break;

	                    default:
	                        throw   "Unsupported TreeDirection";
	                }
	            }
	        },
	        layoutSwitch: function () {
	            if (!this.center) {
	                return;
	            }

	            if (Utils.isEmpty(this.center.children)) {
	                return;
	            }

	            var type = this.options.subtype;
	            if (Utils.isUndefined(type)) {
	                type = "Down";
	            }
	            var single, male, female, leftcount;
	            var children = this.center.children;
	            switch (type.toLowerCase()) {
	                case "radial":
	                case "radialtree":
	                    this.layoutRadialTree();
	                    break;

	                case "mindmaphorizontal":
	                case "mindmap":
	                    single = this.center.children;

	                    if (this.center.children.length === 1) {
	                        this.layoutRight(single);
	                    }
	                    else {
	                        // odd number will give one more at the right
	                        leftcount = children.length / 2;
	                        male = grep(this.center.children, function (n) {
	                            return Utils.indexOf(children, n) < leftcount;
	                        });
	                        female = grep(this.center.children, function (n) {
	                            return Utils.indexOf(children, n) >= leftcount;
	                        });

	                        this.layoutLeft(male);
	                        this.layoutRight(female);
	                    }
	                    break;

	                case "mindmapvertical":
	                    single = this.center.children;

	                    if (this.center.children.length === 1) {
	                        this.layoutDown(single);
	                    }
	                    else {
	                        // odd number will give one more at the right
	                        leftcount = children.length / 2;
	                        male = grep(this.center.children, function (n) {
	                            return Utils.indexOf(children, n) < leftcount;
	                        });
	                        female = grep(this.center.children, function (n) {
	                            return Utils.indexOf(children, n) >= leftcount;
	                        });
	                        this.layoutUp(male);
	                        this.layoutDown(female);
	                    }
	                    break;

	                case "right":
	                    this.layoutRight(this.center.children);
	                    break;

	                case "left":
	                    this.layoutLeft(this.center.children);
	                    break;

	                case "up":
	                case "bottom":
	                    this.layoutUp(this.center.children);
	                    break;

	                case "down":
	                case "top":
	                    this.layoutDown(this.center.children);
	                    break;

	                case "tipover":
	                case "tipovertree":
	                    if (this.options.tipOverTreeStartLevel < 0) {
	                        throw  "The tip-over level should be a positive integer.";
	                    }
	                    this.tipOverTree(this.center.children, this.options.tipOverTreeStartLevel);
	                    break;

	                case "undefined":
	                case "none":
	                    break;
	            }
	        }
	    });

	    /**
	     * The various tree layout algorithms.
	     * @type {*}
	     */
	    var TreeLayout = LayoutBase.extend({
	        init: function (diagram) {
	            var that = this;
	            LayoutBase.fn.init.call(that);
	            if (Utils.isUndefined(diagram)) {
	                throw "No diagram specified.";
	            }
	            this.diagram = diagram;
	        },

	        /**
	         * Arranges the diagram in a tree-layout with the specified options and tree subtype.
	         */
	        layout: function (options) {

	            this.transferOptions(options);

	            // transform the diagram into a Graph
	            var adapter = new DiagramToHyperTreeAdapter(this.diagram);

	            /**
	             * The Graph reduction from the given diagram.
	             * @type {*}
	             */
	            this.graph = adapter.convert();

	            var finalNodeSet = this.layoutComponents();

	            // note that the graph contains the original data and
	            // the components are another instance of nodes referring to the same set of shapes
	            return new diagram.LayoutState(this.diagram, finalNodeSet);
	        },

	        layoutComponents: function () {
	            if (this.graph.isEmpty()) {
	                return;
	            }

	            // split into connected components
	            var components = this.graph.getConnectedComponents();
	            if (Utils.isEmpty(components)) {
	                return;
	            }

	            var layout = new TreeLayoutProcessor(this.options);
	            var trees = [];
	            // find a spanning tree for each component
	            for (var i = 0; i < components.length; i++) {
	                var component = components[i];

	                var treeGraph = this.getTree(component);
	                if (!treeGraph) {
	                    throw "Failed to find a spanning tree for the component.";
	                }
	                var root = treeGraph.root;
	                var tree = treeGraph.tree;
	                layout.layout(tree, root);

	                trees.push(tree);
	            }

	            return this.gridLayoutComponents(trees);

	        },

	        /**
	         * Gets a spanning tree (and root) for the given graph.
	         * Ensure that the given graph is connected!
	         * @param graph
	         * @returns {*} A literal object consisting of the found root and the spanning tree.
	         */
	        getTree: function (graph) {
	            var root = null;
	            if (this.options.roots && this.options.roots.length > 0) {
	                for (var i = 0, len = graph.nodes.length; i < len; i++) {
	                    var node = graph.nodes[i];
	                    for (var j = 0; j < this.options.roots.length; j++) {
	                        var givenRootShape = this.options.roots[j];
	                        if (givenRootShape === node.associatedShape) {
	                            root = node;
	                            break;
	                        }
	                    }
	                }
	            }
	            if (!root) {
	                // finds the most probable root on the basis of the longest path in the component
	                root = graph.root();
	                // should not happen really
	                if (!root) {
	                    throw "Unable to find a root for the tree.";
	                }
	            }
	            return this.getTreeForRoot(graph, root);
	        },

	        getTreeForRoot: function (graph, root) {

	            var tree = graph.getSpanningTree(root);
	            if (Utils.isUndefined(tree) || tree.isEmpty()) {
	                return null;
	            }
	            return {
	                tree: tree,
	                root: tree.root
	            };
	        }

	    });

	    /**
	     * The Sugiyama aka layered layout algorithm.
	     * @type {*}
	     */
	    var LayeredLayout = LayoutBase.extend({
	        init: function (diagram) {
	            var that = this;
	            LayoutBase.fn.init.call(that);
	            if (Utils.isUndefined(diagram)) {
	                throw "Diagram is not specified.";
	            }
	            this.diagram = diagram;
	        },

	        layout: function (options) {

	            this.transferOptions(options);

	            var adapter = new DiagramToHyperTreeAdapter(this.diagram);
	            var graph = adapter.convert(options);
	            if (graph.isEmpty()) {
	                return;
	            }
	            // split into connected components
	            var components = graph.getConnectedComponents();
	            if (Utils.isEmpty(components)) {
	                return;
	            }
	            for (var i = 0; i < components.length; i++) {
	                var component = components[i];
	                this.layoutGraph(component, options);
	            }
	            var finalNodeSet = this.gridLayoutComponents(components);
	            return new diagram.LayoutState(this.diagram, finalNodeSet);

	        },

	        /**
	         * Initializes the runtime data properties of the layout.
	         * @private
	         */
	        _initRuntimeProperties: function () {
	            for (var k = 0; k < this.graph.nodes.length; k++) {
	                var node = this.graph.nodes[k];
	                node.layer = -1;
	                node.downstreamLinkCount = 0;
	                node.upstreamLinkCount = 0;

	                node.isVirtual = false;

	                node.uBaryCenter = 0.0;
	                node.dBaryCenter = 0.0;

	                node.upstreamPriority = 0;
	                node.downstreamPriority = 0;

	                node.gridPosition = 0;
	            }
	        },
	        _prepare: function (graph) {
	            var current = [], i, l, link;

	            // defines a mapping of a node to the layer index
	            var layerMap = new Dictionary();
	            var layerCount = 0;
	            var targetLayer, next, target;

	            Utils.forEach(graph.nodes, function (node) {
	                if (node.incoming.length === 0) {
	                    layerMap.set(node, 0);
	                    current.push(node);
	                }
	            });

	            while (current.length > 0) {
	                next = current.shift();
	                for (i = 0; i < next.outgoing.length; i++) {
	                    link = next.outgoing[i];
	                    target = link.target;

	                    if (layerMap.containsKey(target)) {
	                        targetLayer = Math.max(layerMap.get(next) + 1, layerMap.get(target));
	                    } else {
	                        targetLayer = layerMap.get(next) + 1;
	                    }
	                    layerMap.set(target, targetLayer);
	                    if (targetLayer > layerCount) {
	                        layerCount = targetLayer;
	                    }

	                    if (!contains(current, target)) {
	                        current.push(target);
	                    }
	                }
	            }

	            var sortedNodes = layerMap.keys();

	            sortedNodes.sort(function (o1, o2) {
	                var o1layer = layerMap.get(o1);
	                var o2layer = layerMap.get(o2);
	                return Utils.sign(o2layer - o1layer);
	            });

	            for (var n = 0; n < sortedNodes.length; ++n) {
	                var node = sortedNodes[n];
	                var minLayer = Number.MAX_VALUE;

	                if (node.outgoing.length === 0) {
	                    continue;
	                }

	                for (l = 0; l < node.outgoing.length; ++l) {
	                    link = node.outgoing[l];
	                    minLayer = Math.min(minLayer, layerMap.get(link.target));
	                }

	                if (minLayer > 1) {
	                    layerMap.set(node, minLayer - 1);
	                }
	            }

	            this.layers = [];
	            var layer;
	            for (i = 0; i < layerCount + 1; i++) {
	                layer = [];
	                layer.linksTo = {};
	                this.layers.push(layer);
	            }

	            layerMap.forEach(function (node, layer) {
	                node.layer = layer;
	                this.layers[layer].push(node);
	            }, this);

	            // set initial grid positions
	            for (l = 0; l < this.layers.length; l++) {
	                layer = this.layers[l];
	                for (i = 0; i < layer.length; i++) {
	                    layer[i].gridPosition = i;
	                }
	            }
	        },
	        /**
	         * Performs the layout of a single component.
	         */
	        layoutGraph: function (graph, options) {
	            if (Utils.isUndefined(graph)) {
	                throw "No graph given or graph analysis of the diagram failed.";
	            }
	            if (Utils.isDefined(options)) {
	                this.transferOptions(options);
	            }
	            this.graph = graph;

	            // sets unique indices on the nodes
	            graph.setItemIndices();

	            // ensures no cycles present for this layout
	            var reversedEdges = graph.makeAcyclic();

	            // define the runtime props being used by the layout algorithm
	            this._initRuntimeProperties();

	            this._prepare(graph, options);

	            this._dummify();

	            this._optimizeCrossings();

	            this._swapPairs();

	            this.arrangeNodes();

	            this._moveThingsAround();

	            this._dedummify();

	            // re-reverse the links which were switched earlier
	            Utils.forEach(reversedEdges, function (e) {
	                if (e.points) {
	                    e.points.reverse();
	                }
	            });
	        },

	        setMinDist: function (m, n, minDist) {
	            var l = m.layer;
	            var i = m.layerIndex;
	            this.minDistances[l][i] = minDist;
	        },

	        getMinDist: function (m, n) {
	            var dist = 0,
	                i1 = m.layerIndex,
	                i2 = n.layerIndex,
	                l = m.layer,
	                min = Math.min(i1, i2),
	                max = Math.max(i1, i2);
	            // use Sum()?
	            for (var k = min; k < max; ++k) {
	                dist += this.minDistances[l][k];
	            }
	            return dist;
	        },

	        placeLeftToRight: function (leftClasses) {
	            var leftPos = new Dictionary(), n, node;
	            for (var c = 0; c < this.layers.length; ++c) {
	                var classNodes = leftClasses[c];
	                if (!classNodes) {
	                    continue;
	                }

	                for (n = 0; n < classNodes.length; n++) {
	                    node = classNodes[n];
	                    if (!leftPos.containsKey(node)) {
	                        this.placeLeft(node, leftPos, c);
	                    }
	                }

	                // adjust class
	                var d = Number.POSITIVE_INFINITY;
	                for (n = 0; n < classNodes.length; n++) {
	                    node = classNodes[n];
	                    var rightSibling = this.rightSibling(node);
	                    if (rightSibling && this.nodeLeftClass.get(rightSibling) !== c) {
	                        d = Math.min(d, leftPos.get(rightSibling) - leftPos.get(node) - this.getMinDist(node, rightSibling));
	                    }
	                }
	                if (d === Number.POSITIVE_INFINITY) {
	                    var D = [];
	                    for (n = 0; n < classNodes.length; n++) {
	                        node = classNodes[n];
	                        var neighbors = [];
	                        Utils.addRange(neighbors, this.upNodes.get(node));
	                        Utils.addRange(neighbors, this.downNodes.get(node));

	                        for (var e = 0; e < neighbors.length; e++) {
	                            var neighbor = neighbors[e];
	                            if (this.nodeLeftClass.get(neighbor) < c) {
	                                D.push(leftPos.get(neighbor) - leftPos.get(node));
	                            }
	                        }
	                    }
	                    D.sort();
	                    if (D.length === 0) {
	                        d = 0;
	                    }
	                    else if (D.length % 2 === 1) {
	                        d = D[this.intDiv(D.length, 2)];
	                    }
	                    else {
	                        d = (D[this.intDiv(D.length, 2) - 1] + D[this.intDiv(D.length, 2)]) / 2;
	                    }
	                }
	                for (n = 0; n < classNodes.length; n++) {
	                    node = classNodes[n];
	                    leftPos.set(node, leftPos.get(node) + d);
	                }
	            }
	            return leftPos;
	        },

	        placeRightToLeft: function (rightClasses) {
	            var rightPos = new Dictionary(), n, node;
	            for (var c = 0; c < this.layers.length; ++c) {
	                var classNodes = rightClasses[c];
	                if (!classNodes) {
	                    continue;
	                }

	                for (n = 0; n < classNodes.length; n++) {
	                    node = classNodes[n];
	                    if (!rightPos.containsKey(node)) {
	                        this.placeRight(node, rightPos, c);
	                    }
	                }

	                // adjust class
	                var d = Number.NEGATIVE_INFINITY;
	                for (n = 0; n < classNodes.length; n++) {
	                    node = classNodes[n];
	                    var leftSibling = this.leftSibling(node);
	                    if (leftSibling && this.nodeRightClass.get(leftSibling) !== c) {
	                        d = Math.max(d, rightPos.get(leftSibling) - rightPos.get(node) + this.getMinDist(leftSibling, node));
	                    }
	                }
	                if (d === Number.NEGATIVE_INFINITY) {
	                    var D = [];
	                    for (n = 0; n < classNodes.length; n++) {
	                        node = classNodes[n];
	                        var neighbors = [];
	                        Utils.addRange(neighbors, this.upNodes.get(node));
	                        Utils.addRange(neighbors, this.downNodes.get(node));

	                        for (var e = 0; e < neighbors.length; e++) {
	                            var neighbor = neighbors[e];
	                            if (this.nodeRightClass.get(neighbor) < c) {
	                                D.push(rightPos.get(node) - rightPos.get(neighbor));
	                            }
	                        }
	                    }
	                    D.sort();
	                    if (D.length === 0) {
	                        d = 0;
	                    }
	                    else if (D.length % 2 === 1) {
	                        d = D[this.intDiv(D.length, 2)];
	                    }
	                    else {
	                        d = (D[this.intDiv(D.length, 2) - 1] + D[this.intDiv(D.length, 2)]) / 2;
	                    }
	                }
	                for (n = 0; n < classNodes.length; n++) {
	                    node = classNodes[n];
	                    rightPos.set(node, rightPos.get(node) + d);
	                }
	            }
	            return rightPos;
	        },

	        _getLeftWing: function () {
	            var leftWing = { value: null };
	            var result = this.computeClasses(leftWing, 1);
	            this.nodeLeftClass = leftWing.value;
	            return result;
	        },

	        _getRightWing: function () {
	            var rightWing = { value: null };
	            var result = this.computeClasses(rightWing, -1);
	            this.nodeRightClass = rightWing.value;
	            return result;
	        },

	        computeClasses: function (wingPair, d) {
	            var currentWing = 0,
	                wing = wingPair.value = new Dictionary();

	            for (var l = 0; l < this.layers.length; ++l) {
	                currentWing = l;

	                var layer = this.layers[l];
	                for (var n = d === 1 ? 0 : layer.length - 1; 0 <= n && n < layer.length; n += d) {
	                    var node = layer[n];
	                    if (!wing.containsKey(node)) {
	                        wing.set(node, currentWing);
	                        if (node.isVirtual) {
	                            var ndsinl = this._nodesInLink(node);
	                            for (var kk = 0; kk < ndsinl.length; kk++) {
	                                var vnode = ndsinl[kk];
	                                wing.set(vnode, currentWing);
	                            }
	                        }
	                    }
	                    else {
	                        currentWing = wing.get(node);
	                    }
	                }
	            }

	            var wings = [];
	            for (var i = 0; i < this.layers.length; i++) {
	                wings.push(null);
	            }
	            wing.forEach(function (node, classIndex) {
	                if (wings[classIndex] === null) {
	                    wings[classIndex] = [];
	                }
	                wings[classIndex].push(node);
	            });

	            return wings;
	        },
	        _isVerticalLayout: function () {
	            return this.options.subtype.toLowerCase() === "up" || this.options.subtype.toLowerCase() === "down" || this.options.subtype.toLowerCase() === "vertical";
	        },

	        _isHorizontalLayout: function () {
	            return this.options.subtype.toLowerCase() === "right" || this.options.subtype.toLowerCase() === "left" || this.options.subtype.toLowerCase() === "horizontal";
	        },
	        _isIncreasingLayout: function () {
	            // meaning that the visiting of the layers goes in the natural order of increasing layer index
	            return this.options.subtype.toLowerCase() === "right" || this.options.subtype.toLowerCase() === "down";
	        },
	        _moveThingsAround: function () {
	            var i, l, node, layer, n, w;
	            // sort the layers by their grid position
	            for (l = 0; l < this.layers.length; ++l) {
	                layer = this.layers[l];
	                layer.sort(this._gridPositionComparer);
	            }

	            this.minDistances = [];
	            for (l = 0; l < this.layers.length; ++l) {
	                layer = this.layers[l];
	                this.minDistances[l] = [];
	                for (n = 0; n < layer.length; ++n) {
	                    node = layer[n];
	                    node.layerIndex = n;
	                    this.minDistances[l][n] = this.options.nodeDistance;
	                    if (n < layer.length - 1) {
	                        if (this._isVerticalLayout()) {
	                            this.minDistances[l][n] += (node.width + layer[n + 1].width) / 2;
	                        }
	                        else {
	                            this.minDistances[l][n] += (node.height + layer[n + 1].height) / 2;
	                        }
	                    }
	                }
	            }

	            this.downNodes = new Dictionary();
	            this.upNodes = new Dictionary();
	            Utils.forEach(this.graph.nodes, function (node) {
	                this.downNodes.set(node, []);
	                this.upNodes.set(node, []);
	            }, this);
	            Utils.forEach(this.graph.links, function (link) {
	                var origin = link.source;
	                var dest = link.target;
	                var down = null, up = null;
	                if (origin.layer > dest.layer) {
	                    down = link.source;
	                    up = link.target;
	                }
	                else {
	                    up = link.source;
	                    down = link.target;
	                }
	                this.downNodes.get(up).push(down);
	                this.upNodes.get(down).push(up);
	            }, this);
	            this.downNodes.forEachValue(function (list) {
	                list.sort(this._gridPositionComparer);
	            }, this);
	            this.upNodes.forEachValue(function (list) {
	                list.sort(this._gridPositionComparer);
	            }, this);

	            for (l = 0; l < this.layers.length - 1; ++l) {
	                layer = this.layers[l];
	                for (w = 0; w < layer.length - 1; w++) {
	                    var currentNode = layer[w];
	                    if (!currentNode.isVirtual) {
	                        continue;
	                    }

	                    var currDown = this.downNodes.get(currentNode)[0];
	                    if (!currDown.isVirtual) {
	                        continue;
	                    }

	                    for (n = w + 1; n < layer.length; ++n) {
	                        node = layer[n];
	                        if (!node.isVirtual) {
	                            continue;
	                        }

	                        var downNode = this.downNodes.get(node)[0];
	                        if (!downNode.isVirtual) {
	                            continue;
	                        }

	                        if (currDown.gridPosition > downNode.gridPosition) {
	                            var pos = currDown.gridPosition;
	                            currDown.gridPosition = downNode.gridPosition;
	                            downNode.gridPosition = pos;
	                            var i1 = currDown.layerIndex;
	                            var i2 = downNode.layerIndex;
	                            this.layers[l + 1][i1] = downNode;
	                            this.layers[l + 1][i2] = currDown;
	                            currDown.layerIndex = i2;
	                            downNode.layerIndex = i1;
	                        }
	                    }
	                }
	            }


	            var leftClasses = this._getLeftWing();
	            var rightClasses = this._getRightWing();


	            var leftPos = this.placeLeftToRight(leftClasses);
	            var rightPos = this.placeRightToLeft(rightClasses);
	            var x = new Dictionary();
	            Utils.forEach(this.graph.nodes, function (node) {
	                x.set(node, (leftPos.get(node) + rightPos.get(node)) / 2);
	            });


	            var order = new Dictionary();
	            var placed = new Dictionary();
	            for (l = 0; l < this.layers.length; ++l) {
	                layer = this.layers[l];
	                var sequenceStart = -1, sequenceEnd = -1;
	                for (n = 0; n < layer.length; ++n) {
	                    node = layer[n];
	                    order.set(node, 0);
	                    placed.set(node, false);
	                    if (node.isVirtual) {
	                        if (sequenceStart === -1) {
	                            sequenceStart = n;
	                        }
	                        else if (sequenceStart === n - 1) {
	                            sequenceStart = n;
	                        }
	                        else {
	                            sequenceEnd = n;
	                            order.set(layer[sequenceStart], 0);
	                            if (x.get(node) - x.get(layer[sequenceStart]) === this.getMinDist(layer[sequenceStart], node)) {
	                                placed.set(layer[sequenceStart], true);
	                            }
	                            else {
	                                placed.set(layer[sequenceStart], false);
	                            }
	                            sequenceStart = n;
	                        }
	                    }
	                }
	            }
	            var directions = [1, -1];
	            Utils.forEach(directions, function (d) {
	                var start = d === 1 ? 0 : this.layers.length - 1;
	                for (var l = start; 0 <= l && l < this.layers.length; l += d) {
	                    var layer = this.layers[l];
	                    var virtualStartIndex = this._firstVirtualNode(layer);
	                    var virtualStart = null;
	                    var sequence = null;
	                    if (virtualStartIndex !== -1) {
	                        virtualStart = layer[virtualStartIndex];
	                        sequence = [];
	                        for (i = 0; i < virtualStartIndex; i++) {
	                            sequence.push(layer[i]);
	                        }
	                    }
	                    else {
	                        virtualStart = null;
	                        sequence = layer;
	                    }
	                    if (sequence.length > 0) {
	                        this._sequencer(x, null, virtualStart, d, sequence);
	                        for (i = 0; i < sequence.length - 1; ++i) {
	                            this.setMinDist(sequence[i], sequence[i + 1], x.get(sequence[i + 1]) - x.get(sequence[i]));
	                        }
	                        if (virtualStart) {
	                            this.setMinDist(sequence[sequence.length - 1], virtualStart, x.get(virtualStart) - x.get(sequence[sequence.length - 1]));
	                        }
	                    }

	                    while (virtualStart) {
	                        var virtualEnd = this.nextVirtualNode(layer, virtualStart);
	                        if (!virtualEnd) {
	                            virtualStartIndex = virtualStart.layerIndex;
	                            sequence = [];
	                            for (i = virtualStartIndex + 1; i < layer.length; i++) {
	                                sequence.push(layer[i]);
	                            }
	                            if (sequence.length > 0) {
	                                this._sequencer(x, virtualStart, null, d, sequence);
	                                for (i = 0; i < sequence.length - 1; ++i) {
	                                    this.setMinDist(sequence[i], sequence[i + 1], x.get(sequence[i + 1]) - x.get(sequence[i]));
	                                }
	                                this.setMinDist(virtualStart, sequence[0], x.get(sequence[0]) - x.get(virtualStart));
	                            }
	                        }
	                        else if (order.get(virtualStart) === d) {
	                            virtualStartIndex = virtualStart.layerIndex;
	                            var virtualEndIndex = virtualEnd.layerIndex;
	                            sequence = [];
	                            for (i = virtualStartIndex + 1; i < virtualEndIndex; i++) {
	                                sequence.push(layer[i]);
	                            }
	                            if (sequence.length > 0) {
	                                this._sequencer(x, virtualStart, virtualEnd, d, sequence);
	                            }
	                            placed.set(virtualStart, true);
	                        }
	                        virtualStart = virtualEnd;
	                    }
	                    this.adjustDirections(l, d, order, placed);
	                }
	            }, this);


	            var fromLayerIndex = this._isIncreasingLayout() ? 0 : this.layers.length - 1;
	            var reachedFinalLayerIndex = function (k, ctx) {
	                if (ctx._isIncreasingLayout()) {
	                    return k < ctx.layers.length;
	                }
	                else {
	                    return k >= 0;
	                }
	            };
	            var layerIncrement = this._isIncreasingLayout() ? +1 : -1, offset = 0;

	            /**
	             * Calcs the max height of the given layer.
	             */
	            function maximumHeight(layer, ctx) {
	                var height = Number.MIN_VALUE;
	                for (var n = 0; n < layer.length; ++n) {
	                    var node = layer[n];
	                    if (ctx._isVerticalLayout()) {
	                        height = Math.max(height, node.height);
	                    }
	                    else {
	                        height = Math.max(height, node.width);
	                    }
	                }
	                return height;
	            }

	            for (i = fromLayerIndex; reachedFinalLayerIndex(i, this); i += layerIncrement) {
	                layer = this.layers[i];
	                var height = maximumHeight(layer, this);

	                for (n = 0; n < layer.length; ++n) {
	                    node = layer[n];
	                    if (this._isVerticalLayout()) {
	                        node.x = x.get(node);
	                        node.y = offset + height / 2;
	                    }
	                    else {
	                        node.x = offset + height / 2;
	                        node.y = x.get(node);
	                    }
	                }

	                offset += this.options.layerSeparation + height;
	            }
	        },

	        adjustDirections: function (l, d, order, placed) {
	            if (l + d < 0 || l + d >= this.layers.length) {
	                return;
	            }

	            var prevBridge = null, prevBridgeTarget = null;
	            var layer = this.layers[l + d];
	            for (var n = 0; n < layer.length; ++n) {
	                var nextBridge = layer[n];
	                if (nextBridge.isVirtual) {
	                    var nextBridgeTarget = this.getNeighborOnLayer(nextBridge, l);
	                    if (nextBridgeTarget.isVirtual) {
	                        if (prevBridge) {
	                            var p = placed.get(prevBridgeTarget);
	                            var clayer = this.layers[l];
	                            var i1 = prevBridgeTarget.layerIndex;
	                            var i2 = nextBridgeTarget.layerIndex;
	                            for (var i = i1 + 1; i < i2; ++i) {
	                                if (clayer[i].isVirtual) {
	                                    p = p && placed.get(clayer[i]);
	                                }
	                            }
	                            if (p) {
	                                order.set(prevBridge, d);
	                                var j1 = prevBridge.layerIndex;
	                                var j2 = nextBridge.layerIndex;
	                                for (var j = j1 + 1; j < j2; ++j) {
	                                    if (layer[j].isVirtual) {
	                                        order.set(layer[j], d);
	                                    }
	                                }
	                            }
	                        }
	                        prevBridge = nextBridge;
	                        prevBridgeTarget = nextBridgeTarget;
	                    }
	                }
	            }
	        },

	        getNeighborOnLayer: function (node, l) {
	            var neighbor = this.upNodes.get(node)[0];
	            if (neighbor.layer === l) {
	                return neighbor;
	            }
	            neighbor = this.downNodes.get(node)[0];
	            if (neighbor.layer === l) {
	                return neighbor;
	            }
	            return null;
	        },

	        _sequencer: function (x, virtualStart, virtualEnd, dir, sequence) {
	            if (sequence.length === 1) {
	                this._sequenceSingle(x, virtualStart, virtualEnd, dir, sequence[0]);
	            }

	            if (sequence.length > 1) {
	                var r = sequence.length, t = this.intDiv(r, 2);
	                this._sequencer(x, virtualStart, virtualEnd, dir, sequence.slice(0, t));
	                this._sequencer(x, virtualStart, virtualEnd, dir, sequence.slice(t));
	                this.combineSequences(x, virtualStart, virtualEnd, dir, sequence);
	            }
	        },

	        _sequenceSingle: function (x, virtualStart, virtualEnd, dir, node) {
	            var neighbors = dir === -1 ? this.downNodes.get(node) : this.upNodes.get(node);

	            var n = neighbors.length;
	            if (n !== 0) {
	                if (n % 2 === 1) {
	                    x.set(node, x.get(neighbors[this.intDiv(n, 2)]));
	                }
	                else {
	                    x.set(node, (x.get(neighbors[this.intDiv(n, 2) - 1]) + x.get(neighbors[this.intDiv(n, 2)])) / 2);
	                }

	                if (virtualStart) {
	                    x.set(node, Math.max(x.get(node), x.get(virtualStart) + this.getMinDist(virtualStart, node)));
	                }
	                if (virtualEnd) {
	                    x.set(node, Math.min(x.get(node), x.get(virtualEnd) - this.getMinDist(node, virtualEnd)));
	                }
	            }
	        },

	        combineSequences: function (x, virtualStart, virtualEnd, dir, sequence) {
	            var r = sequence.length, t = this.intDiv(r, 2);

	            // collect left changes
	            var leftHeap = [], i, c, n, neighbors, neighbor, pair;
	            for (i = 0; i < t; ++i) {
	                c = 0;
	                neighbors = dir === -1 ? this.downNodes.get(sequence[i]) : this.upNodes.get(sequence[i]);
	                for (n = 0; n < neighbors.length; ++n) {
	                    neighbor = neighbors[n];
	                    if (x.get(neighbor) >= x.get(sequence[i])) {
	                        c++;
	                    }
	                    else {
	                        c--;
	                        leftHeap.push({ k: x.get(neighbor) + this.getMinDist(sequence[i], sequence[t - 1]), v: 2 });
	                    }
	                }
	                leftHeap.push({ k: x.get(sequence[i]) + this.getMinDist(sequence[i], sequence[t - 1]), v: c });
	            }
	            if (virtualStart) {
	                leftHeap.push({ k: x.get(virtualStart) + this.getMinDist(virtualStart, sequence[t - 1]), v: Number.MAX_VALUE });
	            }
	            leftHeap.sort(this._positionDescendingComparer);

	            // collect right changes
	            var rightHeap = [];
	            for (i = t; i < r; ++i) {
	                c = 0;
	                neighbors = dir === -1 ? this.downNodes.get(sequence[i]) : this.upNodes.get(sequence[i]);
	                for (n = 0; n < neighbors.length; ++n) {
	                    neighbor = neighbors[n];
	                    if (x.get(neighbor) <= x.get(sequence[i])) {
	                        c++;
	                    }
	                    else {
	                        c--;
	                        rightHeap.push({ k: x.get(neighbor) - this.getMinDist(sequence[i], sequence[t]), v: 2 });
	                    }
	                }
	                rightHeap.push({ k: x.get(sequence[i]) - this.getMinDist(sequence[i], sequence[t]), v: c });
	            }
	            if (virtualEnd) {
	                rightHeap.push({ k: x.get(virtualEnd) - this.getMinDist(virtualEnd, sequence[t]), v: Number.MAX_VALUE });
	            }
	            rightHeap.sort(this._positionAscendingComparer);

	            var leftRes = 0, rightRes = 0;
	            var m = this.getMinDist(sequence[t - 1], sequence[t]);
	            while (x.get(sequence[t]) - x.get(sequence[t - 1]) < m) {
	                if (leftRes < rightRes) {
	                    if (leftHeap.length === 0) {
	                        x.set(sequence[t - 1], x.get(sequence[t]) - m);
	                        break;
	                    }
	                    else {
	                        pair = leftHeap.shift();
	                        leftRes = leftRes + pair.v;
	                        x.set(sequence[t - 1], pair.k);
	                        x.set(sequence[t - 1], Math.max(x.get(sequence[t - 1]), x.get(sequence[t]) - m));
	                    }
	                }
	                else {
	                    if (rightHeap.length === 0) {
	                        x.set(sequence[t], x.get(sequence[t - 1]) + m);
	                        break;
	                    }
	                    else {
	                        pair = rightHeap.shift();
	                        rightRes = rightRes + pair.v;
	                        x.set(sequence[t], pair.k);
	                        x.set(sequence[t], Math.min(x.get(sequence[t]), x.get(sequence[t - 1]) + m));
	                    }
	                }
	            }
	            for (i = t - 2; i >= 0; i--) {
	                x.set(sequence[i], Math.min(x.get(sequence[i]), x.get(sequence[t - 1]) - this.getMinDist(sequence[i], sequence[t - 1])));
	            }
	            for (i = t + 1; i < r; i++) {
	                x.set(sequence[i], Math.max(x.get(sequence[i]), x.get(sequence[t]) + this.getMinDist(sequence[i], sequence[t])));
	            }
	        },

	        placeLeft: function (node, leftPos, leftClass) {
	            var pos = Number.NEGATIVE_INFINITY;
	            Utils.forEach(this._getComposite(node), function (v) {
	                var leftSibling = this.leftSibling(v);
	                if (leftSibling && this.nodeLeftClass.get(leftSibling) === this.nodeLeftClass.get(v)) {
	                    if (!leftPos.containsKey(leftSibling)) {
	                        this.placeLeft(leftSibling, leftPos, leftClass);
	                    }
	                    pos = Math.max(pos, leftPos.get(leftSibling) + this.getMinDist(leftSibling, v));
	                }
	            }, this);
	            if (pos === Number.NEGATIVE_INFINITY) {
	                pos = 0;
	            }
	            Utils.forEach(this._getComposite(node), function (v) {
	                leftPos.set(v, pos);
	            });
	        },

	        placeRight: function (node, rightPos, rightClass) {
	            var pos = Number.POSITIVE_INFINITY;
	            Utils.forEach(this._getComposite(node), function (v) {
	                var rightSibling = this.rightSibling(v);
	                if (rightSibling && this.nodeRightClass.get(rightSibling) === this.nodeRightClass.get(v)) {
	                    if (!rightPos.containsKey(rightSibling)) {
	                        this.placeRight(rightSibling, rightPos, rightClass);
	                    }
	                    pos = Math.min(pos, rightPos.get(rightSibling) - this.getMinDist(v, rightSibling));
	                }
	            }, this);
	            if (pos === Number.POSITIVE_INFINITY) {
	                pos = 0;
	            }
	            Utils.forEach(this._getComposite(node), function (v) {
	                rightPos.set(v, pos);
	            });
	        },

	        leftSibling: function (node) {
	            var layer = this.layers[node.layer],
	                layerIndex = node.layerIndex;
	            return layerIndex === 0 ? null : layer[layerIndex - 1];
	        },

	        rightSibling: function (node) {
	            var layer = this.layers[node.layer];
	            var layerIndex = node.layerIndex;
	            return layerIndex === layer.length - 1 ? null : layer[layerIndex + 1];

	        },

	        _getComposite: function (node) {
	            return node.isVirtual ? this._nodesInLink(node) : [node];
	        },

	        arrangeNodes: function () {
	            var i, l, ni, layer, node;
	            // Initialize node's base priority
	            for (l = 0; l < this.layers.length; l++) {
	                layer = this.layers[l];

	                for (ni = 0; ni < layer.length; ni++) {
	                    node = layer[ni];
	                    node.upstreamPriority = node.upstreamLinkCount;
	                    node.downstreamPriority = node.downstreamLinkCount;
	                }
	            }

	            // Layout is invoked after MinimizeCrossings
	            // so we may assume node's barycenters are initially correct

	            var maxLayoutIterations = 2;
	            for (var it = 0; it < maxLayoutIterations; it++) {
	                for (i = this.layers.length - 1; i >= 1; i--) {
	                    this.layoutLayer(false, i);
	                }

	                for (i = 0; i < this.layers.length - 1; i++) {
	                    this.layoutLayer(true, i);
	                }
	            }

	            // Offset the whole structure so that there are no gridPositions < 0
	            var gridPos = Number.MAX_VALUE;
	            for (l = 0; l < this.layers.length; l++) {
	                layer = this.layers[l];

	                for (ni = 0; ni < layer.length; ni++) {
	                    node = layer[ni];
	                    gridPos = Math.min(gridPos, node.gridPosition);
	                }
	            }

	            if (gridPos < 0) {
	                for (l = 0; l < this.layers.length; l++) {
	                    layer = this.layers[l];

	                    for (ni = 0; ni < layer.length; ni++) {
	                        node = layer[ni];
	                        node.gridPosition = node.gridPosition - gridPos;
	                    }
	                }
	            }
	        },

	        /// <summary>
	        /// Layout of a single layer.
	        /// </summary>
	        /// <param name="layerIndex">The layer to organize.</param>
	        /// <param name="movingDownwards">If set to <c>true</c> we move down in the layer stack.</param>
	        /// <seealso cref="OptimizeCrossings()"/>
	        layoutLayer: function (down, layer) {
	            var iconsidered;
	            var considered;

	            if (down) {
	                considered = this.layers[iconsidered = layer + 1];
	            }
	            else {
	                considered = this.layers[iconsidered = layer - 1];
	            }

	            // list containing the nodes in the considered layer sorted by priority
	            var sorted = [];
	            for (var n = 0; n < considered.length; n++) {
	                sorted.push(considered[n]);
	            }
	            sorted.sort(function (n1, n2) {
	                var n1Priority = (n1.upstreamPriority + n1.downstreamPriority) / 2;
	                var n2Priority = (n2.upstreamPriority + n2.downstreamPriority) / 2;

	                if (Math.abs(n1Priority - n2Priority) < 0.0001) {
	                    return 0;
	                }
	                if (n1Priority < n2Priority) {
	                    return 1;
	                }
	                return -1;
	            });

	            // each node strives for its barycenter; high priority nodes start first
	            Utils.forEach(sorted, function (node) {
	                var nodeGridPos = node.gridPosition;
	                var nodeBaryCenter = this.calcBaryCenter(node);
	                var nodePriority = (node.upstreamPriority + node.downstreamPriority) / 2;

	                if (Math.abs(nodeGridPos - nodeBaryCenter) < 0.0001) {
	                    // This node is exactly at its barycenter -> perfect
	                    return;
	                }

	                if (Math.abs(nodeGridPos - nodeBaryCenter) < 0.25 + 0.0001) {
	                    // This node is close enough to the barycenter -> should work
	                    return;
	                }

	                if (nodeGridPos < nodeBaryCenter) {
	                    // Try to move the node to the right in an
	                    // attempt to reach its barycenter
	                    while (nodeGridPos < nodeBaryCenter) {
	                        if (!this.moveRight(node, considered, nodePriority)) {
	                            break;
	                        }

	                        nodeGridPos = node.gridPosition;
	                    }
	                }
	                else {
	                    // Try to move the node to the left in an
	                    // attempt to reach its barycenter
	                    while (nodeGridPos > nodeBaryCenter) {
	                        if (!this.moveLeft(node, considered, nodePriority)) {
	                            break;
	                        }

	                        nodeGridPos = node.gridPosition;
	                    }
	                }
	            }, this);

	            // after the layer has been rearranged we need to recalculate the barycenters
	            // of the nodes in the surrounding layers
	            if (iconsidered > 0) {
	                this.calcDownData(iconsidered - 1);
	            }
	            if (iconsidered < this.layers.length - 1) {
	                this.calcUpData(iconsidered + 1);
	            }
	        },

	        /// <summary>
	        /// Moves the node to the right and returns <c>true</c> if this was possible.
	        /// </summary>
	        /// <param name="node">The node.</param>
	        /// <param name="layer">The layer.</param>
	        /// <returns>Returns <c>true</c> if the shift was possible, otherwise <c>false</c>.</returns>
	        moveRight: function (node, layer, priority) {
	            var index = Utils.indexOf(layer, node);
	            if (index === layer.length - 1) {
	                // this is the last node in the layer, so we can move to the right without troubles
	                node.gridPosition = node.gridPosition + 0.5;
	                return true;
	            }

	            var rightNode = layer[index + 1];
	            var rightNodePriority = (rightNode.upstreamPriority + rightNode.downstreamPriority) / 2;

	            // check if there is space between the right and the current node
	            if (rightNode.gridPosition > node.gridPosition + 1) {
	                node.gridPosition = node.gridPosition + 0.5;
	                return true;
	            }

	            // we have reached a node with higher priority; no movement is allowed
	            if (rightNodePriority > priority ||
	                Math.abs(rightNodePriority - priority) < 0.0001) {
	                return false;
	            }

	            // the right node has lower priority - try to move it
	            if (this.moveRight(rightNode, layer, priority)) {
	                node.gridPosition = node.gridPosition + 0.5;
	                return true;
	            }

	            return false;
	        },

	        /// <summary>
	        /// Moves the node to the left and returns <c>true</c> if this was possible.
	        /// </summary>
	        /// <param name="node">The node.</param>
	        /// <param name="layer">The layer.</param>
	        /// <returns>Returns <c>true</c> if the shift was possible, otherwise <c>false</c>.</returns>
	        moveLeft: function (node, layer, priority) {
	            var index = Utils.indexOf(layer, node);
	            if (index === 0) {
	                // this is the last node in the layer, so we can move to the left without troubles
	                node.gridPosition = node.gridPosition - 0.5;
	                return true;
	            }

	            var leftNode = layer[index - 1];
	            var leftNodePriority = (leftNode.upstreamPriority + leftNode.downstreamPriority) / 2;

	            // check if there is space between the left and the current node
	            if (leftNode.gridPosition < node.gridPosition - 1) {
	                node.gridPosition = node.gridPosition - 0.5;
	                return true;
	            }

	            // we have reached a node with higher priority; no movement is allowed
	            if (leftNodePriority > priority ||
	                Math.abs(leftNodePriority - priority) < 0.0001) {
	                return false;
	            }

	            // The left node has lower priority - try to move it
	            if (this.moveLeft(leftNode, layer, priority)) {
	                node.gridPosition = node.gridPosition - 0.5;
	                return true;
	            }

	            return false;
	        },

	        mapVirtualNode: function (node, link) {
	            this.nodeToLinkMap.set(node, link);
	            if (!this.linkToNodeMap.containsKey(link)) {
	                this.linkToNodeMap.set(link, []);
	            }
	            this.linkToNodeMap.get(link).push(node);
	        },

	        _nodesInLink: function (node) {
	            return this.linkToNodeMap.get(this.nodeToLinkMap.get(node));
	        },

	        /// <summary>
	        /// Inserts dummy nodes to break long links.
	        /// </summary>
	        _dummify: function () {
	            this.linkToNodeMap = new Dictionary();
	            this.nodeToLinkMap = new Dictionary();

	            var layer, pos, newNode, node, r, newLink, i, l, links = this.graph.links.slice(0);
	            var layers = this.layers;

	            var addLinkBetweenLayers = function(upLayer, downLayer, link) {
	                layers[upLayer].linksTo[downLayer] = layers[upLayer].linksTo[downLayer] || [];
	                layers[upLayer].linksTo[downLayer].push(link);
	            };

	            for (l = 0; l < links.length; l++) {
	                var link = links[l];
	                var o = link.source;
	                var d = link.target;

	                var oLayer = o.layer;
	                var dLayer = d.layer;
	                var oPos = o.gridPosition;
	                var dPos = d.gridPosition;

	                var step = (dPos - oPos) / Math.abs(dLayer - oLayer);

	                var p = o;
	                if (oLayer - dLayer > 1) {
	                    for (i = oLayer - 1; i > dLayer; i--) {
	                        newNode = new Node();
	                        newNode.x = o.x;
	                        newNode.y = o.y;
	                        newNode.width = o.width / 100;
	                        newNode.height = o.height / 100;

	                        layer = layers[i];
	                        pos = (i - dLayer) * step + oPos;
	                        if (pos > layer.length) {
	                            pos = layer.length;
	                        }

	                        // check if origin and dest are both last
	                        if (oPos >= layers[oLayer].length - 1 &&
	                            dPos >= layers[dLayer].length - 1) {
	                            pos = layer.length;
	                        }

	                        // check if origin and destination are both first
	                        else if (oPos === 0 && dPos === 0) {
	                            pos = 0;
	                        }

	                        newNode.layer = i;
	                        newNode.uBaryCenter = 0.0;
	                        newNode.dBaryCenter = 0.0;
	                        newNode.upstreamLinkCount = 0;
	                        newNode.downstreamLinkCount = 0;
	                        newNode.gridPosition = pos;
	                        newNode.isVirtual = true;

	                        Utils.insert(layer, newNode, pos);

	                        // translate rightwards nodes' positions
	                        for (r = pos + 1; r < layer.length; r++) {
	                            node = layer[r];
	                            node.gridPosition = node.gridPosition + 1;
	                        }

	                        newLink = new Link(p, newNode);
	                        newLink.depthOfDumminess = 0;

	                        addLinkBetweenLayers(i - 1, i, newLink);

	                        p = newNode;

	                        // add the new node and the new link to the graph
	                        this.graph._addNode(newNode);
	                        this.graph.addLink(newLink);

	                        newNode.index = this.graph.nodes.length - 1;
	                        this.mapVirtualNode(newNode, link);
	                    }

	                    // set the origin of the real arrow to the last dummy
	                    addLinkBetweenLayers(dLayer - 1, dLayer, newLink);
	                    link.changeSource(p);
	                    link.depthOfDumminess = oLayer - dLayer - 1;
	                } else if (oLayer - dLayer < -1) {
	                    for (i = oLayer + 1; i < dLayer; i++) {
	                        newNode = new Node();
	                        newNode.x = o.x;
	                        newNode.y = o.y;
	                        newNode.width = o.width / 100;
	                        newNode.height = o.height / 100;

	                        layer = layers[i];
	                        pos = (i - oLayer) * step + oPos;
	                        if (pos > layer.length) {
	                            pos = layer.length;
	                        }

	                        // check if origin and dest are both last
	                        if (oPos >= layers[oLayer].length - 1 &&
	                            dPos >= layers[dLayer].length - 1) {
	                            pos = layer.length;
	                        }

	                        // check if origin and destination are both first
	                        else if (oPos === 0 && dPos === 0) {
	                            pos = 0;
	                        }

	                        newNode.layer = i;
	                        newNode.uBaryCenter = 0.0;
	                        newNode.dBaryCenter = 0.0;
	                        newNode.upstreamLinkCount = 0;
	                        newNode.downstreamLinkCount = 0;
	                        newNode.gridPosition = pos;
	                        newNode.isVirtual = true;

	                        pos &= pos; // truncates to int
	                        Utils.insert(layer, newNode, pos);

	                        // translate rightwards nodes' positions
	                        for (r = pos + 1; r < layer.length; r++) {
	                            node = layer[r];
	                            node.gridPosition = node.gridPosition + 1;
	                        }

	                        newLink = new Link(p, newNode);
	                        newLink.depthOfDumminess = 0;
	                        addLinkBetweenLayers(i - 1, i, newLink);

	                        p = newNode;

	                        // add the new node and the new link to the graph
	                        this.graph._addNode(newNode);
	                        this.graph.addLink(newLink);

	                        newNode.index = this.graph.nodes.length - 1;
	                        this.mapVirtualNode(newNode, link);
	                    }
	                    addLinkBetweenLayers(dLayer - 1, dLayer, link);

	                    // Set the origin of the real arrow to the last dummy
	                    link.changeSource(p);
	                    link.depthOfDumminess = dLayer - oLayer - 1;
	                } else {
	                    addLinkBetweenLayers(oLayer, dLayer, link);
	                }
	            }
	        },

	        /// <summary>
	        /// Removes the dummy nodes inserted earlier to break long links.
	        /// </summary>
	        /// <remarks>The virtual nodes are effectively turned into intermediate connection points.</remarks>
	        _dedummify: function () {
	            var dedum = true;
	            while (dedum) {
	                dedum = false;

	                for (var l = 0; l < this.graph.links.length; l++) {
	                    var link = this.graph.links[l];
	                    if (!link.depthOfDumminess) {
	                        continue;
	                    }

	                    var points = [];

	                    // add points in reverse order
	                    points.unshift({ x: link.target.x, y: link.target.y });
	                    points.unshift({ x: link.source.x, y: link.source.y });

	                    // _dedummify the link
	                    var temp = link;
	                    var depthOfDumminess = link.depthOfDumminess;
	                    for (var d = 0; d < depthOfDumminess; d++) {
	                        var node = temp.source;
	                        var prevLink = node.incoming[0];

	                        points.unshift({ x: prevLink.source.x, y: prevLink.source.y });

	                        temp = prevLink;
	                    }

	                    // restore the original link origin
	                    link.changeSource(temp.source);

	                    // reset dummification flag
	                    link.depthOfDumminess = 0;

	                    // note that we only need the intermediate points, floating links have been dropped in the analysis
	                    if (points.length > 2) {
	                        // first and last are the endpoints
	                        points.splice(0, 1);
	                        points.splice(points.length - 1);
	                        link.points = points;
	                    }
	                    else {
	                        link.points = [];
	                    }

	                    // we are not going to delete the dummy elements;
	                    // they won't be needed anymore anyway.

	                    dedum = true;
	                    break;
	                }
	            }
	        },

	        /// <summary>
	        /// Optimizes/reduces the crossings between the layers by turning the crossing problem into a (combinatorial) number ordering problem.
	        /// </summary>
	        _optimizeCrossings: function () {
	            var moves = -1, i;
	            var maxIterations = 3;
	            var iter = 0;

	            while (moves !== 0) {
	                if (iter++ > maxIterations) {
	                    break;
	                }

	                moves = 0;

	                for (i = this.layers.length - 1; i >= 1; i--) {
	                    moves += this.optimizeLayerCrossings(false, i);
	                }

	                for (i = 0; i < this.layers.length - 1; i++) {
	                    moves += this.optimizeLayerCrossings(true, i);
	                }
	            }
	        },

	        calcUpData: function (layer) {
	            if (layer === 0) {
	                return;
	            }

	            var considered = this.layers[layer], i, l, link;
	            var upLayer = new Set();
	            var temp = this.layers[layer - 1];
	            for (i = 0; i < temp.length; i++) {
	                upLayer.add(temp[i]);
	            }

	            for (i = 0; i < considered.length; i++) {
	                var node = considered[i];

	                // calculate barycenter
	                var sum = 0;
	                var total = 0;

	                for (l = 0; l < node.incoming.length; l++) {
	                    link = node.incoming[l];
	                    if (upLayer.contains(link.source)) {
	                        total++;
	                        sum += link.source.gridPosition;
	                    }
	                }

	                for (l = 0; l < node.outgoing.length; l++) {
	                    link = node.outgoing[l];
	                    if (upLayer.contains(link.target)) {
	                        total++;
	                        sum += link.target.gridPosition;
	                    }
	                }

	                if (total > 0) {
	                    node.uBaryCenter = sum / total;
	                    node.upstreamLinkCount = total;
	                }
	                else {
	                    node.uBaryCenter = i;
	                    node.upstreamLinkCount = 0;
	                }
	            }
	        },

	        calcDownData: function (layer) {
	            if (layer === this.layers.length - 1) {
	                return;
	            }

	            var considered = this.layers[layer], i , l, link;
	            var downLayer = new Set();
	            var temp = this.layers[layer + 1];
	            for (i = 0; i < temp.length; i++) {
	                downLayer.add(temp[i]);
	            }

	            for (i = 0; i < considered.length; i++) {
	                var node = considered[i];

	                // calculate barycenter
	                var sum = 0;
	                var total = 0;

	                for (l = 0; l < node.incoming.length; l++) {
	                    link = node.incoming[l];
	                    if (downLayer.contains(link.source)) {
	                        total++;
	                        sum += link.source.gridPosition;
	                    }
	                }

	                for (l = 0; l < node.outgoing.length; l++) {
	                    link = node.outgoing[l];
	                    if (downLayer.contains(link.target)) {
	                        total++;
	                        sum += link.target.gridPosition;
	                    }
	                }

	                if (total > 0) {
	                    node.dBaryCenter = sum / total;
	                    node.downstreamLinkCount = total;
	                }
	                else {
	                    node.dBaryCenter = i;
	                    node.downstreamLinkCount = 0;
	                }
	            }
	        },

	        /// <summary>
	        /// Optimizes the crossings.
	        /// </summary>
	        /// <remarks>The big trick here is the usage of weights or values attached to connected nodes which turn a problem of crossing links
	        /// to an a problem of ordering numbers.</remarks>
	        /// <param name="layerIndex">The layer index.</param>
	        /// <param name="movingDownwards">If set to <c>true</c> we move down in the layer stack.</param>
	        /// <returns>The number of nodes having moved, i.e. the number of crossings reduced.</returns>
	        optimizeLayerCrossings: function (down, layer) {
	            var iconsidered;
	            var considered;

	            if (down) {
	                considered = this.layers[iconsidered = layer + 1];
	            }
	            else {
	                considered = this.layers[iconsidered = layer - 1];
	            }

	            // remember what it was
	            var presorted = considered.slice(0);

	            // calculate barycenters for all nodes in the considered layer
	            if (down) {
	                this.calcUpData(iconsidered);
	            }
	            else {
	                this.calcDownData(iconsidered);
	            }

	            var that = this;
	            // sort nodes within this layer according to the barycenters
	            considered.sort(function(n1, n2) {
	                var n1BaryCenter = that.calcBaryCenter(n1),
	                    n2BaryCenter = that.calcBaryCenter(n2);
	                if (Math.abs(n1BaryCenter - n2BaryCenter) < 0.0001) {
	                    // in case of coinciding barycenters compare by the count of in/out links
	                    if (n1.degree() === n2.degree()) {
	                        return that.compareByIndex(n1, n2);
	                    }
	                    else if (n1.degree() < n2.degree()) {
	                        return 1;
	                    }
	                    return -1;
	                }
	                var compareValue = (n2BaryCenter - n1BaryCenter) * 1000;
	                if (compareValue > 0) {
	                    return -1;
	                }
	                else if (compareValue < 0) {
	                    return 1;
	                }
	                return that.compareByIndex(n1, n2);
	            });

	            // count relocations
	            var i, moves = 0;
	            for (i = 0; i < considered.length; i++) {
	                if (considered[i] !== presorted[i]) {
	                    moves++;
	                }
	            }

	            if (moves > 0) {
	                // now that the boxes have been arranged, update their grid positions
	                var inode = 0;
	                for (i = 0; i < considered.length; i++) {
	                    var node = considered[i];
	                    node.gridPosition = inode++;
	                }
	            }

	            return moves;
	        },

	        /// <summary>
	        /// Swaps a pair of nodes in a layer.
	        /// </summary>
	        /// <param name="layerIndex">Index of the layer.</param>
	        /// <param name="n">The Nth node in the layer.</param>
	        _swapPairs: function () {
	            var maxIterations = this.options.layeredIterations;
	            var iter = 0;

	            while (true) {
	                if (iter++ > maxIterations) {
	                    break;
	                }

	                var downwards = (iter % 4 <= 1);
	                var secondPass = (iter % 4 === 1);

	                for (var l = (downwards ? 0 : this.layers.length - 1);
	                     downwards ? l <= this.layers.length - 1 : l >= 0; l += (downwards ? 1 : -1)) {
	                    var layer = this.layers[l];
	                    var hasSwapped = false;

	                    // there is no need to recalculate crossings if they were calculated
	                    // on the previous step and nothing has changed
	                    var calcCrossings = true;
	                    var memCrossings = 0;

	                    for (var n = 0; n < layer.length - 1; n++) {
	                        // count crossings
	                        var up = 0;
	                        var down = 0;
	                        var crossBefore = 0;

	                        if (calcCrossings) {
	                            if (l !== 0) {
	                                up = this.countLinksCrossingBetweenTwoLayers(l - 1, l);
	                            }
	                            if (l !== this.layers.length - 1) {
	                                down = this.countLinksCrossingBetweenTwoLayers(l, l + 1);
	                            }
	                            if (downwards) {
	                                up *= 2;
	                            }
	                            else {
	                                down *= 2;
	                            }

	                            crossBefore = up + down;
	                        }
	                        else {
	                            crossBefore = memCrossings;
	                        }

	                        if (crossBefore === 0) {
	                            continue;
	                        }

	                        // Swap nodes
	                        var node1 = layer[n];
	                        var node2 = layer[n + 1];

	                        var node1GridPos = node1.gridPosition;
	                        var node2GridPos = node2.gridPosition;
	                        layer[n] = node2;
	                        layer[n + 1] = node1;
	                        node1.gridPosition = node2GridPos;
	                        node2.gridPosition = node1GridPos;

	                        // count crossings again and if worse than before, restore swapping
	                        up = 0;
	                        if (l !== 0) {
	                            up = this.countLinksCrossingBetweenTwoLayers(l - 1, l);
	                        }
	                        down = 0;
	                        if (l !== this.layers.length - 1) {
	                            down = this.countLinksCrossingBetweenTwoLayers(l, l + 1);
	                        }
	                        if (downwards) {
	                            up *= 2;
	                        }
	                        else {
	                            down *= 2;
	                        }
	                        var crossAfter = up + down;

	                        var revert = false;
	                        if (secondPass) {
	                            revert = crossAfter >= crossBefore;
	                        }
	                        else {
	                            revert = crossAfter > crossBefore;
	                        }

	                        if (revert) {
	                            node1 = layer[n];
	                            node2 = layer[n + 1];

	                            node1GridPos = node1.gridPosition;
	                            node2GridPos = node2.gridPosition;
	                            layer[n] = node2;
	                            layer[n + 1] = node1;
	                            node1.gridPosition = node2GridPos;
	                            node2.gridPosition = node1GridPos;

	                            // nothing has changed, remember the crossings so that
	                            // they are not calculated again on the next step
	                            memCrossings = crossBefore;
	                            calcCrossings = false;
	                        }
	                        else {
	                            hasSwapped = true;
	                            calcCrossings = true;
	                        }
	                    }

	                    if (hasSwapped) {
	                        if (l !== this.layers.length - 1) {
	                            this.calcUpData(l + 1);
	                        }
	                        if (l !== 0) {
	                            this.calcDownData(l - 1);
	                        }
	                    }
	                }
	            }
	        },

	        /// <summary>
	        /// Counts the number of links crossing between two layers.
	        /// </summary>
	        /// <param name="layerIndex1">The layer index.</param>
	        /// <param name="layerIndex2">Another layer index.</param>
	        /// <returns></returns>
	        countLinksCrossingBetweenTwoLayers: function (ulayer, dlayer) {
	            var links = this.layers[ulayer].linksTo[dlayer];
	            var link1, link2, n11, n12, n21, n22, l1, l2;
	            var crossings = 0;
	            var length = links.length;

	            for (l1 = 0; l1 < length; l1++) {
	                link1 = links[l1];
	                for (l2 = l1 + 1; l2 < length; l2++) {

	                    link2 = links[l2];

	                    if (link1.target.layer === dlayer) {
	                        n11 = link1.source;
	                        n12 = link1.target;
	                    }
	                    else {
	                        n11 = link1.target;
	                        n12 = link1.source;
	                    }

	                    if (link2.target.layer === dlayer) {
	                        n21 = link2.source;
	                        n22 = link2.target;
	                    }
	                    else {
	                        n21 = link2.target;
	                        n22 = link2.source;
	                    }

	                    var n11gp = n11.gridPosition;
	                    var n12gp = n12.gridPosition;
	                    var n21gp = n21.gridPosition;
	                    var n22gp = n22.gridPosition;

	                    if ((n11gp - n21gp) * (n12gp - n22gp) < 0) {
	                        crossings++;
	                    }
	                }
	            }

	            return crossings;
	        },

	        calcBaryCenter: function (node) {
	            var upstreamLinkCount = node.upstreamLinkCount;
	            var downstreamLinkCount = node.downstreamLinkCount;
	            var uBaryCenter = node.uBaryCenter;
	            var dBaryCenter = node.dBaryCenter;

	            if (upstreamLinkCount > 0 && downstreamLinkCount > 0) {
	                return (uBaryCenter + dBaryCenter) / 2;
	            }
	            if (upstreamLinkCount > 0) {
	                return uBaryCenter;
	            }
	            if (downstreamLinkCount > 0) {
	                return dBaryCenter;
	            }

	            return 0;
	        },

	        _gridPositionComparer: function (x, y) {
	            if (x.gridPosition < y.gridPosition) {
	                return -1;
	            }
	            if (x.gridPosition > y.gridPosition) {
	                return 1;
	            }
	            return 0;
	        },

	        _positionAscendingComparer: function (x, y) {
	            return x.k < y.k ? -1 : x.k > y.k ? 1 : 0;
	        },

	        _positionDescendingComparer: function (x, y) {
	            return x.k < y.k ? 1 : x.k > y.k ? -1 : 0;
	        },

	        _firstVirtualNode: function (layer) {
	            for (var c = 0; c < layer.length; c++) {
	                if (layer[c].isVirtual) {
	                    return c;
	                }
	            }
	            return -1;
	        },

	        compareByIndex: function (o1, o2) {
	            var i1 = o1.index;
	            var i2 = o2.index;

	            if (i1 < i2) {
	                return 1;
	            }

	            if (i1 > i2) {
	                return -1;
	            }

	            return 0;
	        },

	        intDiv: function (numerator, denominator) {
	            return (numerator - numerator % denominator) / denominator;
	        },

	        nextVirtualNode: function (layer, node) {
	            var nodeIndex = node.layerIndex;
	            for (var i = nodeIndex + 1; i < layer.length; ++i) {
	                if (layer[i].isVirtual) {
	                    return layer[i];
	                }
	            }
	            return null;
	        }

	    });

	    /**
	     * Captures the state of a diagram; node positions, link points and so on.
	     * @type {*}
	     */
	    var LayoutState = kendo.Class.extend({
	        init: function (diagram, graphOrNodes) {
	            if (Utils.isUndefined(diagram)) {
	                throw "No diagram given";
	            }
	            this.diagram = diagram;
	            this.nodeMap = new Dictionary();
	            this.linkMap = new Dictionary();
	            this.capture(graphOrNodes ? graphOrNodes : diagram);
	        },

	        /**
	         * Will capture either
	         * - the state of the shapes and the intermediate points of the connections in the diagram
	         * - the bounds of the nodes contained in the Graph together with the intermediate points of the links in the Graph
	         * - the bounds of the nodes in the Array<Node>
	         * - the links points and node bounds in the literal object
	         * @param diagramOrGraphOrNodes
	         */
	        capture: function (diagramOrGraphOrNodes) {
	            var node,
	                nodes,
	                shape,
	                i,
	                conn,
	                link,
	                links;

	            if (diagramOrGraphOrNodes instanceof diagram.Graph) {

	                for (i = 0; i < diagramOrGraphOrNodes.nodes.length; i++) {
	                    node = diagramOrGraphOrNodes.nodes[i];
	                    shape = node.associatedShape;
	                    //shape.bounds(new Rect(node.x, node.y, node.width, node.height));
	                    this.nodeMap.set(shape.visual.id, new Rect(node.x, node.y, node.width, node.height));
	                }
	                for (i = 0; i < diagramOrGraphOrNodes.links.length; i++) {
	                    link = diagramOrGraphOrNodes.links[i];
	                    conn = link.associatedConnection;
	                    this.linkMap.set(conn.visual.id, link.points());
	                }
	            }
	            else if (diagramOrGraphOrNodes instanceof Array) {
	                nodes = diagramOrGraphOrNodes;
	                for (i = 0; i < nodes.length; i++) {
	                    node = nodes[i];
	                    shape = node.associatedShape;
	                    if (shape) {
	                        this.nodeMap.set(shape.visual.id, new Rect(node.x, node.y, node.width, node.height));
	                    }
	                }
	            }
	            else if (diagramOrGraphOrNodes.hasOwnProperty("links") && diagramOrGraphOrNodes.hasOwnProperty("nodes")) {
	                nodes = diagramOrGraphOrNodes.nodes;
	                links = diagramOrGraphOrNodes.links;
	                for (i = 0; i < nodes.length; i++) {
	                    node = nodes[i];
	                    shape = node.associatedShape;
	                    if (shape) {
	                        this.nodeMap.set(shape.visual.id, new Rect(node.x, node.y, node.width, node.height));
	                    }
	                }
	                for (i = 0; i < links.length; i++) {
	                    link = links[i];
	                    conn = link.associatedConnection;
	                    if (conn) {
	                        this.linkMap.set(conn.visual.id, link.points);
	                    }
	                }
	            }
	            else { // capture the diagram
	                var shapes = this.diagram.shapes;
	                var connections = this.diagram.connections;
	                for (i = 0; i < shapes.length; i++) {
	                    shape = shapes[i];
	                    this.nodeMap.set(shape.visual.id, shape.bounds());
	                }
	                for (i = 0; i < connections.length; i++) {
	                    conn = connections[i];
	                    this.linkMap.set(conn.visual.id, conn.points());
	                }
	            }
	        }
	    });

	    deepExtend(diagram, {
	        init: function (element) {
	            kendo.init(element, diagram.ui);
	        },
	        SpringLayout: SpringLayout,
	        TreeLayout: TreeLayout,
	        GraphAdapter: DiagramToHyperTreeAdapter,
	        LayeredLayout: LayeredLayout,
	        LayoutBase: LayoutBase,
	        LayoutState: LayoutState
	    });
	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 902:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("eykn");

/***/ })

/******/ });

/***/ }),

/***/ "QI4T":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1263);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1259:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("UtsZ");

/***/ }),

/***/ 1263:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1259), __webpack_require__(1264) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function() {

	var __meta__ = { // jshint ignore:line
	    id: "gantt.list",
	    name: "Gantt List",
	    category: "web",
	    description: "The Gantt List",
	    depends: [ "treelist", "treeview.draganddrop" ],
	    hidden: true
	};

	(function($) {
	    var extend = $.extend,
	        map = $.map,
	        proxy = $.proxy,
	        isFunction = $.isFunction,

	        ui = kendo.ui,
	        TreeList = ui.TreeList,
	        outerHeight = kendo._outerHeight,
	        activeElement = kendo._activeElement,
	        keys = kendo.keys,
	        mobileOS = kendo.support.mobileOS,

	        DATATYPE = kendo.attr("type"),
	        BINDING = kendo.attr("bind"),
	        FORMAT = kendo.attr("format"),

	        STRING = "string",
	        NS = ".kendoGanttList",
	        DOUBLE_CLICK = "dblclick",
	        FOCUSIN = "focusin",
	        FOCUSOUT = "focusout",
	        KEYDOWN = "keydown",
	        KEYUP = "keyup",
	        MOUSE_DOWN = "mousedown",
	        BEFORE_EDIT = "beforeEdit",
	        EDIT = "edit",
	        SAVE = "save",
	        CANCEL = "cancel",
	        RENDER = "render",
	        DOT = ".",

	        defaultDateFormat = "{0:" + kendo.getCulture().calendar.patterns.d +"}",

	        titleFromField = {
	            "title": "Title",
	            "start": "Start Time",
	            "end": "End Time",
	            "percentComplete": "% Done",
	            "parentId": "Predecessor ID",
	            "id": "ID",
	            "orderId": "Order ID"
	        },

	        SIZE_CALCULATION_TEMPLATE = "<table style='visibility: hidden;'>" +
	            "<tbody>" +
	                "<tr style='height:{0}'>" +
	                    "<td>&nbsp;</td>" +
	                "</tr>" +
	            "</tbody>" +
	        "</table>",

	        listStyles = {
	            gridHeader: "k-grid-header",
	            gridContentWrap: "k-grid-content",
	            editCell: "k-edit-cell",
	            iconCollapse: "k-i-collapse",
	            iconExpand: "k-i-expand"
	        };

	    var GanttList = ui.GanttList = TreeList.extend({
	        init: function(element, options) {
	            if (this.options.columns.length === 0) {
	                this.options.columns.push("title");
	            }

	            TreeList.fn.init.call(this, element, options);

	            this._unbindDataSource();
	            this._adjustHeight();
	            this._setWidth();
	        },

	        options: {
	            name: "GanttList",
	            autoBind: false,
	            sortable: true,
	            selectable: true,
	            navigatable: false,
	            editable: {
	                move: true,
	                mode: "incell"
	            },
	            resizable: false,
	            renderAllRows: false
	        },

	        destroy: function() {
	            TreeList.fn.destroy.call(this);
	            kendo.destroy(this.element);
	        },

	        closeCell: function(isCancel) {
	            var that = this;
	            var cell = (that.editor || {}).element;
	            var tr;
	            var model;

	            if (!cell || !cell[0] || !that._isIncellEditable()) {
	                return;
	            }

	            model = that.dataItem(cell);
	            that._cancelEditor();
	            cell.removeClass(listStyles.editCell);
	            tr = cell.parent().removeClass(listStyles.editRow);

	            if (that.lockedContent) {
	                that._relatedRow(tr).removeClass(listStyles.editRow);
	            }

	            if (isCancel) {
	                that._render();
	            }

	            that.trigger("itemChange", { item: tr, data: model, ns: ui });

	            if (that.lockedContent) {
	                that._adjustRowHeight(tr.css("height", "")[0], that._relatedRow(tr).css("height", "")[0]);
	            }
	        },

	        insertAfter: function(nodeData, referenceNode) {
	            var orderId = referenceNode.orderId;
	            var taskInfo = {
	                parentId: referenceNode.parentId
	            };

	            if (referenceNode.parentId === nodeData.parentId && referenceNode.orderId > nodeData.orderId) {
	                taskInfo.orderId = orderId;
	            } else {
	                taskInfo.orderId = orderId + 1;
	            }

	            this.trigger("reorder", {
	                task: nodeData,
	                updateInfo: taskInfo
	            });
	        },

	        insertBefore: function(nodeData, referenceNode) {
	            var orderId = referenceNode.orderId;
	            var taskInfo = {
	                parentId: referenceNode.parentId
	            };

	            if (referenceNode.parentId === nodeData.parentId &&
	                referenceNode.orderId > nodeData.orderId) {
	                    taskInfo.orderId = orderId - 1;
	            } else {
	                taskInfo.orderId = orderId;
	            }

	            this.trigger("reorder", {
	                task: nodeData,
	                updateInfo: taskInfo
	            });
	        },

	        _adjustHeight: function() {
	            var element = this.element;
	            var contentWrap = element.find(DOT + listStyles.gridContentWrap);
	            var header = element.find(DOT + listStyles.gridHeader);
	            var height;
	            var scrollbar = kendo.support.scrollbar();

	            if (this._isHeightSet(element)) {
	                height = element.height() - outerHeight(header);

	                contentWrap.height(height);

	                if (this._hasLockedColumns) {
	                    scrollbar = this.table[0].offsetWidth > this.table.parent()[0].clientWidth ? scrollbar : 0;
	                    this.lockedContent.height(height - scrollbar);
	                }
	            }
	        },

	        _adjustRowHeight: function(row1, row2) {
	            var height;
	            var offsetHeight1 = row1.offsetHeight;
	            var offsetHeight2 = row2.offsetHeight;

	            if (offsetHeight1 > offsetHeight2) {
	                height = offsetHeight1 + "px";
	            } else if (offsetHeight1 < offsetHeight2) {
	                height = offsetHeight2 + "px";
	            }

	            if (height) {
	                row1.style.height = row2.style.height = height;
	            }
	         },

	        // identical code found in treelist, grid & scheduler :(
	        _isHeightSet: function(el) {
	            var initialHeight, newHeight;
	            if (el[0].style.height) {
	                return true;
	            } else {
	                initialHeight = el.height();
	            }

	            el.height("auto");
	            newHeight = el.height();
	            el.height("");

	            return (initialHeight != newHeight);
	        },

	        _attachCellEditingEventHandlers: function() {
	            var that = this,
	                editable = that.options.editable;

	            if (that._isIncellEditable() && editable.update !== false) {
	                that._startEditHandler = function(e) {
	                    var td = e.currentTarget ? $(e.currentTarget) : e;
	                    var column = that._columnFromElement(td);

	                    if (that.editable) {
	                        return;
	                    }

	                    if (column && column.editable()) {
	                        that._editCell(td, column, that._modelFromElement(td));
	                    }
	                };

	                that.content
	                    .on(FOCUSIN + NS, proxy(that._focusInEditableHandler, that))
	                    .on(FOCUSOUT + NS, proxy(that._focusoutCellHandler, that))
	                    .on(KEYDOWN + NS, "tr:not(.k-grouping-row) > td", proxy(that._keydownHandler, that))
	                    .on(KEYUP + NS, "tr:not(.k-grouping-row) > td", proxy(that._keyupHandler, that));

	                if (!mobileOS) {
	                    that.content
	                        .on(MOUSE_DOWN + NS, "tr:not(.k-grouping-row) > td", proxy(that._mouseDownHandler, that))
	                        .on(DOUBLE_CLICK + NS, "tr:not(.k-grouping-row) > td", proxy(that._openEditorHandler, that));
	                } else {
	                    that.touch = that.content
	                        .kendoTouch({
	                            filter: "td",
	                            touchstart: function(e) {
	                                that._mouseDownHandler(e.touch);
	                            },
	                            doubletap: function(e) {
	                                if(e.event.target.classList.contains("k-icon")) {
	                                    return;
	                                }
	                                that._openEditorHandler(e.touch);
	                            }
	                        }).data("kendoTouch");
	                }
	            }
	        },

	        _blurActiveElement: function() {
	            var activeElement = kendo._activeElement();

	            if (activeElement && activeElement.nodeName.toLowerCase() !== "body") {
	                $(activeElement).blur();
	            }
	        },

	        _closeCellTimeouted: function() {
	            var that = this,
	                target = activeElement(),
	                editor = that.editor || {},
	                cell = editor.element;

	            if (cell && cell[0] && target && !$.contains(cell[0], target) && cell[0] !== target && !$(target).closest(".k-animation-container").length) {
	                if (editor.end()) {
	                    that.closeCell();
	                }
	            }
	        },

	        _columns: function() {
	            var that = this,
	                columns = this.options.columns;

	            that._hasExpandable = false;

	            columns.forEach(function(item){
	                if(item.expandable) {
	                    that._hasExpandable = true;
	                }
	            });

	            that.columns = that.options.columns = map(columns, proxy(that._eachColumn, that));

	            TreeList.fn._columns.call(that);
	        },

	        _columnEditor: function(column) {
	            var attr = {
	                "name": column.field,
	                "required": true
	            };

	            attr[BINDING] = "value:" + column.field;
	            attr[DATATYPE] = "date";
	            attr[FORMAT] = kendo._extractFormat(column.format);

	            return function(container, options) {
	                var model = options.model,
	                    field = model.fields[column.field] || model[column.field],
	                    validation = field.validation;

	                if (validation && validation.dateCompare && isFunction(validation.dateCompare) && validation.message) {
	                    $('<span ' + kendo.attr("for") + '="' + column.field + '" class="k-invalid-msg"/>')
	                        .hide()
	                        .appendTo(container);

	                    attr[kendo.attr("dateCompare-msg")] = validation.message;
	                }

	                $('<input type="text"/>')
	                    .attr(attr)
	                    .prependTo(container)
	                    .kendoDateTimePicker({ format: options.format });
	            };
	        },

	        _columnFromElement: function(element) {
	            var td = element.closest("td"),
	                tr = td.parent(),
	                idx = tr.children().index(td);

	            return this.columns[idx];
	        },

	        _eachColumn: function(column) {
	            var that = this,
	                resourcesField = that.options.resourcesField,
	                isSortable = this.options.sortable;

	            var model = function() {
	                this.field = "";
	                this.title = "";
	                this.editable = function() { return false; };
	                this.sortable = false;
	            };

	            var formatResources = function(task) {
	                var value = task.get(resourcesField) || [],
	                    formatedValue = [];

	                for (var i = 0; i < value.length; i++) {
	                    formatedValue.push(kendo.format("{0} [{1}]", value[i].get("name"), value[i].get("formatedValue")));
	                }

	                return formatedValue.join(", ");
	            };

	            if(column.columns) {
	                that.hasNestedColumns = true;
	                column.columns = map(column.columns, proxy(this._eachColumn, this));
	            }

	            if(typeof column === STRING) {
	                column = {
	                    field: column,
	                    title: titleFromField[column]
	                };
	            }

	            if (column.editable === true) {
	                column.editable = function() {
	                    return true;
	                };
	            } else {
	                column.editable = function() {
	                    return false;
	                };
	            }

	            if(column.field === "start" || column.field === "end") {
	                column.format = kendo.getCulture().calendar.patterns[column.format] || column.format || defaultDateFormat;

	                if(!column.editor) {
	                    if(column.format === defaultDateFormat || column.format.toLowerCase().indexOf("h") > -1) {
	                        column.editor = that._columnEditor(column);
	                    }
	                }
	            }
	            if (column.field === resourcesField) {
	                column.sortable = false;
	                column.template = formatResources;
	            }
	            if(!that._hasExpandable && column.field === "title") {
	                column.expandable = true;
	            }

	            if(isSortable && !column.sortable) {
	                column.sortable = false;
	            }

	            return extend(new model(), column);
	        },

	        _editCell: function(cell, column, model) {
	            var that = this,
	                resourcesField = that.options.resourcesField,
	                modelCopy = that.dataSource._createNewModel(model.toJSON()),
	                editedCell;

	            if (column.field === resourcesField) {
	                column.editor(cell, modelCopy);
	                return;
	            } else {
	                if (that.trigger(BEFORE_EDIT, { model: model, container: cell })) {
	                    that.dataSource._restorePageSizeAfterAddChild();
	                    return;
	                }

	                that.closeCell();

	                model._edit = true;

	                that._cancelEditor();

	                that._render({
	                    editedColumn: column,
	                    editedColumnIndex: cell.index()
	                });

	                editedCell = that.table.add(that.lockedTable).find(DOT + listStyles.editCell).first();

	                that.editor = that._createIncellEditor(editedCell, {
	                    columns: [column],
	                    model: model,
	                    change: function(e) {
	                        if (that.trigger(SAVE, { values: e.values, container: cell, model: model } )) {
	                            e.preventDefault();
	                        }
	                    }
	                });

	                // refresh the current element as the DOM element reference can be changed after render()
	                that._current = editedCell;

	                that.trigger(EDIT, { container: cell, model: model });
	            }
	        },

	        _focusInEditableHandler: function(e) {
	            var that = this,
	                target = e.target;

	            if (!$.contains(target, activeElement())) {
	                clearTimeout(that._closeCellTimeout);
	                that._closeCellTimeout = null;
	            }
	        },

	        _focusoutCellHandler: function(e) {
	            var that = this;

	            that._closeCellTimeout = setTimeout(function() {
	                that._closeCellTimeouted(e);
	            }, 1);
	        },

	        _keydownHandler: function(e) {
	            if (e.keyCode === keys.ENTER) {
	                e.preventDefault();
	            }
	        },

	        _keyupHandler: function(e) {
	            var that = this,
	                key = e.keyCode,
	                cell, model;

	            switch (key) {
	                case keys.ENTER:
	                    that._blurActiveElement();
	                    that._closeCellTimeouted(e);
	                    break;
	                case keys.ESC:
	                    if (that.editor) {
	                        cell = $(e.target);
	                        model = that._modelFromElement(cell);

	                        that.trigger(CANCEL, { model: model, cell: cell });
	                    }
	                    break;
	            }
	        },

	        _modelFromElement: function(element) {
	            var row = element.closest("tr"),
	                model = this.dataSource.getByUid(row.attr(kendo.attr("uid")));

	            return model;
	        },

	        _mouseDownHandler: function(e) {
	            var currentTarget = $(e.currentTarget);

	            if (!currentTarget.hasClass(listStyles.editCell)) {
	                this._blurActiveElement();
	            }
	        },

	        _openEditorHandler: function(e) {
	            var that = this,
	                td = $(e.currentTarget),
	                isLockedCell = that.lockedTable && td.closest("table")[0] === that.lockedTable[0],
	                selectable = that.selectable && that.selectable.options.multiple;

	            if (td.hasClass(listStyles.editCell) ||
	                td.has("a.k-grid-delete").length ||
	                td.has("button.k-grid-delete").length ||
	                (td.closest("tbody")[0] !== that.tbody[0] && !isLockedCell) ||
	                $(e.target).is(":input") ||
	                $(e.target).hasClass(listStyles.iconExpand) ||
	                $(e.target).hasClass(listStyles.iconCollapse)) {

	                return;
	            }

	            if (that.editor) {
	                if (that.editor.end()) {
	                    if (selectable) {
	                        $(activeElement()).blur();
	                    }
	                    that.closeCell();
	                    that.editCell(td);
	                }
	            } else {
	                that.editCell(td);
	            }
	        },

	        _renderTree: function(taskTree) {
	            TreeList.fn._render.call(this);

	            if(this.hasNestedColumns) {
	                this.element.addClass("k-gantt-treelist-nested-columns");
	            }

	            if(taskTree && taskTree.length && !taskTree.editedColumn) {
	                if (this.options.rowHeight) {
	                    this._rowHeight(taskTree);
	                }

	                this.trigger(RENDER);
	            }
	        },

	        _rowHeight: function(tasks) {
	            var content = this.content,
	                options = this.options,
	                rowHeight = typeof options.rowHeight === STRING ? options.rowHeight : options.rowHeight + "px",
	                table = $(kendo.format(SIZE_CALCULATION_TEMPLATE, rowHeight)),
	                height;

	            content.append(table);
	            height = outerHeight(table.find("tr"));
	            table.remove();

	            this.element.find('[role="treegrid"]').css("height", (tasks.length * height) + "px");
	        },

	        _setData: function(tasks) {
	            this.dataSource.data(tasks);
	        },

	        _setWidth: function() {
	            this.element.find(".k-grid-header table").css("minWidth", this.options.listWidth);
	            this.content.find("table").css("minWidth", this.options.listWidth);
	        }
	    });

	    ui.plugin(GanttList);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1264:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Z9Q2");

/***/ })

/******/ });

/***/ }),

/***/ "QIQM":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(987);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 987:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(988) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {

	// Imports ================================================================
	var kendo = window.kendo,
	    Class = kendo.Class,
	    extend = $.extend,
	    Editor = kendo.ui.editor,
	    dom = Editor.Dom,
	    EditorUtils = Editor.EditorUtils,
	    registerTool = EditorUtils.registerTool,
	    Command = Editor.Command,
	    Tool = Editor.Tool,
	    ToolTemplate = Editor.ToolTemplate,
	    RangeUtils = Editor.RangeUtils,
	    blockElements = dom.blockElements,
	    BlockFormatFinder = Editor.BlockFormatFinder,
	    BlockFormatter = Editor.BlockFormatter;

	function indent(node, value) {
	    var isRtl = $(node).css("direction") == "rtl",
	        indentDirection = isRtl ? "Right" : "Left",
	        property = dom.name(node) != "td" ? "margin" + indentDirection : "padding" + indentDirection;
	    if (value === undefined) {
	        return node.style[property] || 0;
	    } else {
	        if (value > 0) {
	            node.style[property] = value + "px";
	        } else {
	            node.style[property] = "";

	            if (!node.style.cssText) {
	                node.removeAttribute("style");
	            }
	        }
	    }
	}

	var IndentFormatter = Class.extend({
	    init: function() {
	        this.finder = new BlockFormatFinder([{tags:dom.blockElements}]);
	    },

	    apply: function (nodes) {
	        nodes = dom.filterBy(nodes, dom.htmlIndentSpace, true);
	        var formatNodes = this.finder.findSuitable(nodes),
	            targets = [],
	            i, len, formatNode, parentList, sibling;

	        formatNodes = this.mapImmutables(formatNodes);

	        if (formatNodes.length) {
	            for (i = 0, len = formatNodes.length; i < len; i++) {
	                if (dom.is(formatNodes[i], "li")) {
	                    if (!$(formatNodes[i]).index()) {
	                        targets.push(formatNodes[i].parentNode);
	                    } else if ($.inArray(formatNodes[i].parentNode, targets) < 0) {
	                        targets.push(formatNodes[i]);
	                    }
	                } else {
	                    targets.push(formatNodes[i]);
	                }
	            }

	            while (targets.length) {
	                formatNode = targets.shift();
	                if (dom.is(formatNode, "li")) {
	                    parentList = formatNode.parentNode;
	                    sibling = $(formatNode).prev("li");
	                    var siblingList = sibling.find("ul,ol").last();

	                    var nestedList = $(formatNode).children("ul,ol")[0];

	                    if (nestedList && sibling[0]) {
	                        if (siblingList[0]) {
	                           siblingList.append(formatNode);
	                           siblingList.append($(nestedList).children());
	                           dom.remove(nestedList);
	                        } else {
	                            sibling.append(nestedList);
	                            nestedList.insertBefore(formatNode, nestedList.firstChild);
	                        }
	                    } else {
	                        nestedList = sibling.children("ul,ol")[0];
	                        if (!nestedList) {
	                            nestedList = dom.create(formatNode.ownerDocument, dom.name(parentList));
	                            sibling.append(nestedList);
	                        }

	                        while (formatNode && formatNode.parentNode == parentList) {
	                            nestedList.appendChild(formatNode);
	                            formatNode = targets.shift();
	                        }
	                    }
	                } else {
	                    var marginLeft = parseInt(indent(formatNode), 10) + 30;
	                    indent(formatNode, marginLeft);

	                    for (var targetIndex = 0; targetIndex < targets.length; targetIndex++) {
	                        if ($.contains(formatNode, targets[targetIndex])) {
	                            targets.splice(targetIndex, 1);
	                        }
	                    }
	                }
	            }
	        } else {
	            var formatter = new BlockFormatter([{tags:["p"]}], {style:{marginLeft:30}});

	            formatter.apply(nodes);
	        }
	    },

	    mapImmutables: function(nodes){
	        if (!this.immutables) {
	            return nodes;
	        } else {
	            var immutables = [];
	            return $.map(nodes, function (node) {
	                var immutable = Editor.Immutables.immutableParent(node);
	                if (immutable) {
	                    if ($.inArray(immutable, immutables) === -1) {
	                        immutables.push(immutable);
	                    } else {
	                        return null;
	                    }
	                }
	                return immutable || node;
	            });
	        }
	    },

	    remove: function(nodes) {
	        nodes = dom.filterBy(nodes, dom.htmlIndentSpace, true);
	        var formatNodes = this.finder.findSuitable(nodes),
	            targetNode, i, len, list, listParent, siblings,
	            formatNode, marginLeft;

	        formatNodes = this.mapImmutables(formatNodes);

	        for (i = 0, len = formatNodes.length; i < len; i++) {
	            formatNode = $(formatNodes[i]);

	            if (formatNode.is("li")) {
	                list = formatNode.parent();
	                listParent = list.parent();
	                // listParent will be ul or ol in case of invalid dom - <ul><li></li><ul><li></li></ul></ul>
	                if (listParent.is("li,ul,ol") && !indent(list[0])) {
	                    // skip already processed nodes
	                    if (targetNode && $.contains(targetNode, listParent[0])) {
	                        continue;
	                    }

	                    siblings = formatNode.nextAll("li");
	                    if (siblings.length) {
	                        $(list[0].cloneNode(false)).appendTo(formatNode).append(siblings);
	                    }

	                    if (listParent.is("li")) {
	                        formatNode.insertAfter(listParent);
	                    } else {
	                        formatNode.appendTo(listParent);
	                    }

	                    if (!list.children("li").length) {
	                        list.remove();
	                    }

	                    continue;
	                } else {
	                    if (targetNode == list[0]) {
	                        // removing format on sibling LI elements
	                        continue;
	                    }
	                    targetNode = list[0];
	                }
	            } else {
	                targetNode = formatNodes[i];
	            }

	            marginLeft = parseInt(indent(targetNode), 10) - 30;
	            indent(targetNode, marginLeft);
	        }
	    }

	});

	var IndentCommand = Command.extend({
	    init: function(options) {
	        var that = this;
	        options.formatter = /** @ignore */ {
	            toggle : $.proxy(function(range) {
	                var indentFormatter = new IndentFormatter();
	                indentFormatter.immutables = this.editor && this.editor.options.immutables;
	                indentFormatter.apply(RangeUtils.nodes(range));
	            }, that)
	        };
	        Command.fn.init.call(this, options);
	    }
	});

	var OutdentCommand = Command.extend({
	    init: function(options) {
	        var that = this;
	        options.formatter = {
	            toggle : $.proxy(function(range) {
	                var indentFormatter = new IndentFormatter();
	                indentFormatter.immutables = this.editor && this.editor.options.immutables;
	                indentFormatter.remove(RangeUtils.nodes(range));
	            }, that)
	        };
	        Command.fn.init.call(this, options);
	    }
	});

	var OutdentTool = Tool.extend({
	    init: function(options) {
	        Tool.fn.init.call(this, options);

	        this.finder = new BlockFormatFinder([{tags:blockElements}]);
	    },

	    initialize: function(ui, options) {
	        Tool.fn.initialize.call(this, ui, options);

	        $.extend(this.options, {
	            immutables: options.editor && options.editor.options.immutables
	        });

	        ui.addClass("k-state-disabled");
	    },

	    update: function (ui, nodes) {
	        var suitableNodes = this.finder.findSuitable(nodes),
	            isOutdentable, listParentsCount, i, len, suitable, immutableParent;
	        for (i = 0, len = suitableNodes.length; i < len; i++) {
	            suitable = suitableNodes[i];

	            if (this.options.immutables) {
	                immutableParent = Editor.Immutables.immutableParent(suitable);
	                if (immutableParent) {
	                    suitable = immutableParent;
	                }
	            }

	            isOutdentable = indent(suitable);

	            if (!isOutdentable) {
	                listParentsCount = $(suitable).parents("ul,ol").length;
	                isOutdentable = (dom.is(suitable, "li") && (listParentsCount > 1 || indent(suitable.parentNode))) ||
	                                (dom.ofType(suitable, ["ul","ol"]) && listParentsCount > 0);
	            }

	            if (isOutdentable) {
	                ui.removeClass("k-state-disabled");
	                return;
	            }
	        }

	        ui.addClass("k-state-disabled").removeClass("k-state-hover");
	    }
	});

	extend(Editor, {
	    IndentFormatter: IndentFormatter,
	    IndentCommand: IndentCommand,
	    OutdentCommand: OutdentCommand,
	    OutdentTool: OutdentTool
	});

	registerTool("indent", new Tool({ command: IndentCommand, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Indent"}) }));
	registerTool("outdent", new OutdentTool({ command: OutdentCommand, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Outdent"})}));

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 988:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Ytuf");

/***/ })

/******/ });

/***/ }),

/***/ "QRG4":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("UuGF");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "QbYn":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1617);
	module.exports = __webpack_require__(1617);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 949:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ZruT");

/***/ }),

/***/ 1612:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Iu+f");

/***/ }),

/***/ 1617:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20), __webpack_require__(949), __webpack_require__(1612) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var $ = kendo.jQuery;

	    var UnionRef = kendo.spreadsheet.UnionRef;
	    var CellRef = kendo.spreadsheet.CellRef;
	    var RangeRef = kendo.spreadsheet.RangeRef;

	    var PROPERTIES = [
	        "color", "fontFamily", "underline",
	        "italic", "bold", "textAlign", "indent",
	        "verticalAlign", "background", "format", "link", "editor",
	        "borderTop", "borderRight", "borderBottom", "borderLeft",
	        "comment", "html"
	    ];

	    var Range = kendo.Class.extend({
	        init: function(ref, sheet) {
	            this._sheet = sheet;
	            this._ref = ref;
	        },

	        clone: function() {
	            return new Range(this._ref.clone(), this._sheet);
	        },

	        skipHiddenCells: function() {
	            var refs = [];
	            var self = this, sheet = self._sheet;
	            var skipHiddenRows = sheet.isHiddenRow.bind(sheet);
	            var skipHiddenCols = sheet.isHiddenColumn.bind(sheet);
	            self._ref.forEach(function(ref){
	                ref = self._normalize(ref.toRangeRef());
	                var tl = ref.topLeft, br = ref.bottomRight;
	                var rows = partition(tl.row, br.row, skipHiddenRows);
	                var cols = partition(tl.col, br.col, skipHiddenCols);
	                for (var i = 0; i < rows.length; ++i) {
	                    for (var j = 0; j < cols.length; ++j) {
	                        refs.push(new RangeRef(
	                            new CellRef(rows[i].begin, cols[j].begin),
	                            new CellRef(rows[i].end, cols[j].end)
	                        ));
	                    }
	                }
	            });
	            return sheet.range(refs.length > 1 ? new UnionRef(refs) : refs[0]);
	        },

	        _normalize: function(ref) {
	            return this._sheet._grid.normalize(ref);
	        },

	        _set: function(name, value, noTrigger) {
	            var self = this;
	            var sheet = self._sheet;
	            self._ref.forEach(function(ref) {
	                sheet._set(ref.toRangeRef(), name, value);
	            });
	            if (!noTrigger) {
	                sheet.triggerChange({
	                    recalc : name == "formula" || name == "value" || name == "validation",
	                    value  : value,
	                    range  : self,
	                    ref    : self._ref
	                });
	            }
	            return self;
	        },

	        _get: function(name) {
	            return this._sheet._get(this._ref.toRangeRef(), name);
	        },

	        _property: function(name, value) {
	            if (value === undefined) {
	                return this._get(name);
	            } else {
	                return this._set(name, value);
	            }
	        },

	        value: function(value) {
	            if (value !== undefined) {
	                // When value is set through the public API we must clear the
	                // formula.  Don't trigger change (third parameter), it'll be
	                // done when setting the value below
	                this._set("formula", null, true);
	            }
	            return this._property("value", value);
	        },

	        html: function(value) {
	            return this._property("html", value);
	        },

	        resize: function(direction) {
	            var ref = this._resizedRef(direction);
	            return new Range(ref, this._sheet);
	        },

	        _resizedRef: function(direction) {
	            return this._ref.map(function(ref) {
	                return ref.toRangeRef().resize(direction);
	            });
	        },

	        input: function(value, options) {
	            options = $.extend({
	                arrayFormula: false
	            }, options);
	            var existingFormat = this._get("format"), x;
	            if (value !== undefined) {
	                var tl = this._ref.toRangeRef().topLeft;
	                x = kendo.spreadsheet.calc.parse(this._sheet.name(), tl.row, tl.col, value, existingFormat);
	                this._sheet.batch(function() {
	                    var formula = null;
	                    if (x.type == "exp") {
	                        formula = kendo.spreadsheet.calc.compile(x);
	                    } else if (existingFormat != "@") {
	                        var existingFormatType = existingFormat &&
	                            kendo.spreadsheet.formatting.type(x.value, existingFormat);
	                        if (x.type == "date" && existingFormatType != "date") {
	                            this.format(x.format || toExcelFormat(kendo.culture().calendar.patterns.d));
	                        } else if (x.type == "percent" && existingFormatType != "percent") {
	                            this.format(x.value*100 == (x.value*100|0) ? "0%" : "0.00%");
	                        } else if (x.format) {
	                            if (!existingFormat || x.currency ||
	                                (existingFormatType == "number" && x.type == "number" &&
	                                 x.format.length > existingFormat.length)) {
	                                this.format(x.format);
	                            }
	                        }
	                    } else if (x.type != "string") {
	                        x.value = value;
	                    }
	                    this.formula(formula, options.arrayFormula);
	                    if (!formula) {
	                        // value() will clear the formula.  Lucky for us,
	                        // x.value is undefined so it actually won't, but let's
	                        // be explicit and only set value if formula is not
	                        // present.
	                        this.value(x.value);
	                    }
	                }.bind(this), { recalc: true, value: value, ref: this._ref, editorChange: this._sheet.isInEditMode() });

	                return this;
	            } else {
	                value = this._get("value");
	                var formula = this._get("formula");
	                var type = existingFormat && !formula && kendo.spreadsheet.formatting.type(value, existingFormat);

	                if (formula) {
	                    // it's a Formula object which stringifies to the
	                    // formula as text (without the starting `=`).
	                    value = "=" + formula;
	                } else OUT: { // jshint ignore:line
	                    if (existingFormat && type == "date") {
	                        // check if we could parse back the displayed value.
	                        // https://github.com/telerik/kendo/issues/5335
	                        var t1 = kendo.spreadsheet.formatting.text(value, existingFormat);
	                        x = kendo.spreadsheet.calc.parse(null, null, null, t1, existingFormat); // it's not a formula so we don't need sheet/row/col
	                        var t2 = kendo.spreadsheet.formatting.text(x.value, existingFormat);
	                        if (t1 == t2) {
	                            value = t1;
	                            break OUT; // jshint ignore:line
	                        }
	                    }
	                    if (type === "date") {
	                        value = kendo.toString(kendo.spreadsheet.numberToDate(value), kendo.culture().calendar.patterns.d);
	                    } else if (type === "percent") {
	                        value = kendo.spreadsheet.calc.runtime.limitPrecision(value * 100) + "%";
	                    } else if (typeof value == "string" &&
	                               (/^[=']/.test(value) ||
	                                (/^(?:true|false)$/i).test(value) ||
	                                looksLikeANumber(value))) {
	                        value = "'" + value;
	                    } else if (this._sheet._useCultureDecimals() &&
	                               typeof value == "number" &&
	                               value != Math.floor(value)) {
	                        value = String(value).replace(".", kendo.culture().numberFormat["."]);
	                    }
	                }

	                return value;
	            }
	        },

	        enable: function(value) {
	            if (value === undefined) {
	                return !kendo.util.withExit(function(exit){
	                    this._sheet.forEach(this._ref, function(_, __, data) {
	                        if (data.enable === false) {
	                            exit(true);
	                        }
	                    });
	                }, this);
	            }

	            return this._property("enable", value);
	        },

	        formula: function(value, arrayFormula) {
	            var self = this;
	            if (value === undefined) {
	                var f = self._get("formula");
	                return f ? "" + f : null; // stringify if present
	            }
	            if (arrayFormula) {
	                // when setting an array formula, we want to set it on
	                // the first cell only, as it will fill the whole
	                // range.
	                var ref = this._ref.toRangeRef();
	                value = self._sheet.range(ref.topLeft)
	                    ._set("formula", value)
	                    ._get("formula"); // make sure we get the compiled Formula, not a string

	                if (value) {    // could be null.
	                    // this will be used in FormulaContext -- it's the
	                    // range that the formula must populate.
	                    value.setArrayFormulaRange(ref);
	                }
	            } else {
	                self._set("formula", value);
	            }
	            return self;
	        },

	        intersectingArrayFormula: function() {
	            var ref = this._ref.clone().simplify().setSheet(this._sheet.name());
	            return kendo.util.withExit(function(exit){
	                this._sheet._forFormulas(function(f){
	                    var r = f.arrayFormulaRange;
	                    if (r && (r = ref.intersect(r)) !== kendo.spreadsheet.NULLREF) {
	                        exit({ formula: f, intersection: r });
	                    }
	                });
	            }, this);
	        },

	        canEditArrayFormula: function() {
	            var x = this.intersectingArrayFormula();
	            if (x) {
	                // we want to allow editing only when the new range is
	                // at least as big as the original range (i.e. no
	                // cells removed)
	                return x.formula.arrayFormulaRange.eq(x.intersection);
	            }
	            return true;
	        },

	        validation: function(value) {
	            //TODO: Accept objects only?

	            if (value === undefined) {
	                var f = this._get("validation");

	                return f ? f.toJSON() : null; // stringify if present
	            }
	            return this._property("validation", value);
	        },

	        _getValidationState: function() {
	            var ref = this._ref.toRangeRef();
	            var topLeftRow = ref.topLeft.row;
	            var topLeftCol = ref.topLeft.col;
	            var bottomRightRow = ref.bottomRight.row;
	            var bottomRightCol = ref.bottomRight.col;
	            var ci, ri;

	            for (ci = topLeftCol; ci <= bottomRightCol; ci ++) {
	                for (ri = topLeftRow; ri <= bottomRightRow; ri ++) {
	                    var validation = this._sheet._validation(ri, ci);

	                    if (validation && validation.type === "reject" && validation.value === false) {
	                        return validation;
	                    }
	                }
	            }

	            return false;
	        },

	        merge: function() {
	            this._ref = this._sheet._merge(this._ref);
	            return this;
	        },

	        unmerge: function() {
	            var mergedCells = this._sheet._mergedCells;

	            this._ref.forEach(function(ref) {
	                ref.toRangeRef().intersecting(mergedCells).forEach(function(mergedRef) {
	                    mergedCells.splice(mergedCells.indexOf(mergedRef), 1);
	                });
	            });

	            this._sheet.triggerChange({});

	            return this;
	        },

	        select: function() {
	            this._sheet.select(this._ref);

	            return this;
	        },

	        values: function(values) {
	            if (this._ref instanceof UnionRef) {
	                throw new Error("Unsupported for multiple ranges.");
	            }

	            if (this._ref === kendo.spreadsheet.NULLREF) {
	                if (values !== undefined) {
	                    throw new Error("Unsupported for NULLREF.");
	                } else {
	                    return [];
	                }
	            }

	            var ref = this._ref.toRangeRef();
	            var topLeftRow = ref.topLeft.row;
	            var topLeftCol = ref.topLeft.col;
	            var bottomRightRow = ref.bottomRight.row;
	            var bottomRightCol = ref.bottomRight.col;
	            var ci, ri;

	            if (values === undefined) {
	                values = new Array(ref.height());

	                for (var vi = 0; vi < values.length; vi++) {
	                    values[vi] = new Array(ref.width());
	                }

	                for (ci = topLeftCol; ci <= bottomRightCol; ci ++) {
	                    for (ri = topLeftRow; ri <= bottomRightRow; ri ++) {
	                        values[ri - topLeftRow][ci - topLeftCol] = this._sheet._value(ri, ci);
	                    }
	                }

	                return values;
	            } else {
	                this._sheet._set(ref, "formula", null);

	                for (ci = topLeftCol; ci <= bottomRightCol; ci ++) {
	                    for (ri = topLeftRow; ri <= bottomRightRow; ri ++) {
	                        var row = values[ri - topLeftRow];

	                        if (row) {
	                            var value = row[ci - topLeftCol];

	                            if (value !== undefined) {
	                                this._sheet._value(ri, ci, value);
	                            }
	                        }
	                    }
	                }

	                this._sheet.triggerChange({ recalc: true, ref: ref });

	                return this;
	            }
	        },

	        _properties: function(props, isAutofill) {
	            if (this._ref instanceof UnionRef) {
	                throw new Error("Unsupported for multiple ranges.");
	            }

	            if (this._ref === kendo.spreadsheet.NULLREF) {
	                if (props !== undefined) {
	                    throw new Error("Unsupported for NULLREF.");
	                } else {
	                    return [];
	                }
	            }

	            var ref = this._ref.toRangeRef();
	            var topLeftRow = ref.topLeft.row;
	            var topLeftCol = ref.topLeft.col;
	            var bottomRightRow = ref.bottomRight.row;
	            var bottomRightCol = ref.bottomRight.col;
	            var ci, ri;
	            var sheet = this._sheet;

	            if (props === undefined) {
	                props = new Array(ref.height());
	                sheet.forEach(ref, function(row, col, data){
	                    row -= topLeftRow;
	                    col -= topLeftCol;
	                    var line = props[row] || (props[row] = []);
	                    line[col] = data;
	                });
	                return props;
	            }
	            else {
	                var data;
	                ref = ref.clone();
	                var setProp = function(propName) {
	                    var propValue = data[propName];
	                    ref.topLeft.row = ref.bottomRight.row = ri;
	                    ref.topLeft.col = ref.bottomRight.col = ci;

	                    if (propName == "value") {
	                        sheet._set(ref, "formula", null);
	                    }

	                    sheet._set(ref, propName, propValue);
	                };

	                for (ci = topLeftCol; ci <= bottomRightCol; ci ++) {
	                    if (!isAutofill && sheet.isHiddenColumn(ci)) {
	                        continue;
	                    }
	                    for (ri = topLeftRow; ri <= bottomRightRow; ri ++) {
	                        if (!isAutofill && sheet.isHiddenRow(ri)) {
	                            continue;
	                        }
	                        if (isAutofill && sheet.isFilteredRow(ri)) {
	                            continue;
	                        }
	                        var row = props[ri - topLeftRow];
	                        if (row) {
	                            data = row[ci - topLeftCol];
	                            if (data) {
	                                Object.keys(data).forEach(setProp);
	                            }
	                        }
	                    }
	                }
	                sheet.triggerChange({ recalc: true, ref: this._ref });
	                return this;
	            }
	        },

	        clear: function(options) {
	            options = options || {};
	            var clearAll = options.clearAll || !Object.keys(options).length;

	            var sheet = this._sheet;

	            var reason = {
	                recalc: clearAll || options.contentsOnly,
	                ref: this._ref
	            };

	            sheet.batch(function() {

	                if (reason.recalc) {
	                    this.formula(null);
	                }

	                if (clearAll) {
	                    this.validation(null);
	                }

	                if (clearAll || options.formatOnly) {
	                    PROPERTIES.forEach(function(x) {
	                        if (!(options.keepBorders && /^border/i.test(x))) {
	                            this[x](null);
	                        }
	                    }.bind(this));
	                    this.fontSize(null);
	                    this.wrap(null);
	                    this.unmerge();
	                }

	            }.bind(this), reason);

	            return this;
	        },

	        clearContent: function() {
	            return this.clear({ contentsOnly: true });
	        },

	        clearFormat: function() {
	            return this.clear({ formatOnly: true });
	        },

	        isSortable: function() {
	            return !this.cantSort();
	        },

	        cantSort: function() {
	            if (this._ref instanceof UnionRef) {
	                return { code: "cantSortMultipleSelection",
	                         message: "Unsupported for multiple ranges." };
	            }
	            if (this._ref === kendo.spreadsheet.NULLREF) {
	                return { code: "cantSortNullRef",
	                         message: "Unsupported for NULLREF." };
	            }
	            var mc = this._sheet._getMergedCells(this._ref.toRangeRef());
	            var primary = mc.primary;
	            var secondary = mc.secondary;
	            var width = null, height = null;
	            var cant = {};
	            try {
	                this._sheet.forEach(this, function(row, col){
	                    var id = new CellRef(row, col).print();
	                    var merged = primary[id];
	                    if (merged) {
	                        if (width === null) {
	                            width = merged.width();
	                            height = merged.height();
	                        } else if (!(width == merged.width() && height == merged.height())) {
	                            throw cant;
	                        }
	                    }
	                    else if (!secondary[id] && mc.hasMerged) {
	                        throw cant;
	                    }
	                });
	            } catch(ex) {
	                if (ex !== cant) {
	                    throw ex;
	                }
	                return {
	                    code: "cantSortMixedCells",
	                    message: "Unsupported for range containing cells of different shapes."
	                };
	            }
	            return false;
	        },

	        sort: function(spec) {
	            var reason = this.cantSort();
	            if (reason) {
	                throw new Error(reason.message);
	            }

	            if (spec === undefined) {
	                spec = { column: 0 };
	            }

	            spec = spec instanceof Array ? spec : [spec];

	            this._sheet._sortBy(this._ref.toRangeRef(), spec.map(function(spec, index) {
	                if (typeof spec === "number") {
	                    spec = { column: spec };
	                }

	                return {
	                    index: spec.column === undefined ? index : spec.column,
	                    ascending: spec.ascending === undefined ? true : spec.ascending
	                };
	            }));

	            return this;
	        },

	        isFilterable: function() {
	            return !(this._ref instanceof UnionRef);
	        },

	        filter: function(spec) {
	            if (this._ref instanceof UnionRef) {
	                throw new Error("Unsupported for multiple ranges.");
	            }

	            if (spec === false) {
	                this.clearFilters();
	            } else {
	                spec = spec === true ? [] : spec instanceof Array ? spec : [spec];

	                this._sheet._filterBy(this._ref.toRangeRef(), spec.map(function(spec, index) {
	                    return {
	                        index: spec.column === undefined ? index : spec.column,
	                        filter: spec.filter
	                    };
	                }));
	            }

	            return this;
	        },

	        clearFilter: function(spec) {
	            this._sheet.clearFilter(spec);
	        },

	        clearFilters: function() {
	            var filter = this._sheet.filter();
	            var spec = [];

	            if (filter) {
	                for (var i = 0; i < filter.columns.length; i++) {
	                    spec.push(filter.columns[i].index);
	                }

	                this._sheet.batch(function() {
	                    this.clearFilter(spec);
	                    this._filter = null;
	                }, { layout: true, filter: true });
	            }
	        },

	        hasFilter: function() {
	            var filter = this._sheet.filter();
	            return !!filter;
	        },

	        leftColumn: function() {
	            return new Range(this._ref.leftColumn(), this._sheet);
	        },

	        rightColumn: function() {
	            return new Range(this._ref.rightColumn(), this._sheet);
	        },

	        topRow: function() {
	            return new Range(this._ref.topRow(), this._sheet);
	        },

	        bottomRow: function() {
	            return new Range(this._ref.bottomRow(), this._sheet);
	        },

	        column: function(column) {
	            return new Range(this._ref.toColumn(column), this._sheet);
	        },

	        row: function(row) {
	            return new Range(this._ref.toRow(row), this._sheet);
	        },

	        forEachRow: function(callback) {
	            this._ref.forEachRow(function(ref) {
	                callback(new Range(ref, this._sheet));
	            }.bind(this));
	        },

	        forEachColumn: function(callback) {
	            this._ref.forEachColumn(function(ref) {
	                callback(new Range(ref, this._sheet));
	            }.bind(this));
	        },

	        sheet: function() {
	            return this._sheet;
	        },

	        topLeft: function() {
	            return this._ref.toRangeRef().topLeft;
	        },

	        intersectingMerged: function() {
	            var sheet = this._sheet;
	            var mergedCells = [];

	            sheet._mergedCells.forEach(function(ref) {
	                if (ref.intersects(this._ref)) {
	                    mergedCells.push(ref.toString());
	                }
	            }.bind(this));

	            return mergedCells;
	        },

	        getState: function(propertyName) {
	            var topLeft = this._ref.first();
	            var state = {
	                ref     : topLeft,
	                data    : [],
	                origRef : this._ref,

	                // save row heights
	                rows    : this._sheet._rows.getState()
	            };
	            var properties;
	            if (!propertyName) {
	                properties = kendo.spreadsheet.ALL_PROPERTIES;
	                state.mergedCells = this.intersectingMerged();
	            } else if (propertyName === "input") {
	                properties = ["value", "formula"];
	            } else if (propertyName === "border") {
	                properties = ["borderLeft", "borderTop", "borderRight", "borderBottom"];
	            } else {
	                properties = [propertyName];
	            }

	            var data = state.data;
	            this.forEachCell(function(row, col, cell) {
	                var cellState = {};
	                var dr = row - topLeft.row;
	                var dc = col - topLeft.col;
	                if (!data[dr]) {
	                    data[dr] = [];
	                }
	                data[dr][dc] = cellState;

	                properties.forEach(function(property) {
	                    var value = typeof cell[property] == "undefined" ? null : cell[property];
	                    if (value instanceof kendo.spreadsheet.calc.runtime.Formula ||
	                        value instanceof kendo.spreadsheet.validation.Validation)
	                    {
	                        value = value.deepClone();
	                    }
	                    cellState[property] = value;
	                });
	            });

	            return state;
	        },

	        setState: function(state, clipboard) {
	            var sheet = this._sheet;
	            var origin = this._ref.first();
	            var rowDelta = state.ref.row - origin.row;
	            var colDelta = state.ref.col - origin.col;
	            var internalClipboard = clipboard && !clipboard.isExternal();
	            var externalClipboard = clipboard && !internalClipboard;

	            sheet.batch(function() {
	                if (state.mergedCells) {
	                    this.unmerge();
	                }

	                if (!clipboard) {
	                    // restore row heights.  they won't be available
	                    // when this function is called from the clipboard
	                    // code.
	                    this._sheet._rows.setState(state.rows);
	                }

	                var row = origin.row;
	                var hasFilter = this.hasFilter();
	                state.data.forEach(function(data, dr){
	                    if (hasFilter && internalClipboard && sheet.isHiddenRow(state.ref.row + dr)) {
	                        return;
	                    }
	                    var col = origin.col;
	                    data.forEach(function(cellState, dc){
	                        if (hasFilter && internalClipboard && sheet.isHiddenColumn(state.ref.col + dc)) {
	                            return;
	                        }
	                        var range = clipboard ? sheet.range(row, col)
	                            : sheet.range(origin.row + dr, origin.col + dc);
	                        if (range.enable()) {
	                            for (var property in cellState) {
	                                if (property != "value") {
	                                    // make sure value comes last (after the loop),
	                                    // because if we set value here and get get to
	                                    // formula later and cellState.formula is null,
	                                    // it'll clear the value.

	                                    // when pasting, do not copy "disabled" state
	                                    if (!(clipboard && property == "enable")) {
	                                        range._set(property, cellState[property]);
	                                    }
	                                }
	                            }
	                            if (!cellState.formula) {
	                                // only need to set the value if we don't have a
	                                // formula.  Go through the lower level setter rather
	                                // than range.value(...), because range.value will clear
	                                // the formula!  chicken and egg issues.
	                                if (externalClipboard) {
	                                    // https://github.com/telerik/kendo-ui-core/issues/1688
	                                    // if we have a paste from external source, we should parse the
	                                    // value as if it were inputted.  This allows to treat numbers
	                                    // as numbers, or `=sum(a1:b2)` as formula (Google Sheets does
	                                    // the same).  A difference though is that we can't store an
	                                    // invalid Formula and display #ERROR, like G.S. does, so in
	                                    // case of a parse error we'll just set the value as string.
	                                    try {
	                                        if (cellState.value == null) { // jshint ignore:line
	                                            range._set("value", null);
	                                        } else {
	                                            range.input(cellState.value);
	                                        }
	                                    } catch(ex) {
	                                        range._set("value", cellState.value);
	                                    }
	                                } else {
	                                    range._set("value", cellState.value);
	                                }
	                            }
	                        }
	                        col++;
	                    });
	                    row++;
	                });

	                if (state.mergedCells) {
	                    state.mergedCells.forEach(function(merged) {
	                        merged = sheet._ref(merged).relative(rowDelta, colDelta, 3);
	                        sheet.range(merged).merge();
	                    }, this);
	                }
	            }.bind(this), { recalc: true, ref: this._ref });
	        },

	        _adjustRowHeight: function() {
	            var that = this;
	            var sheet = that._sheet;
	            var mc = sheet._getMergedCells(that._ref.toRangeRef());
	            var primary = mc.primary;
	            var secondary = mc.secondary;

	            sheet.batch(function() {
	                that.forEachRow(function(rowRange){
	                    var row = rowRange._ref.topLeft.row;
	                    var height = sheet.rowHeight(row);
	                    rowRange.forEachCell(function(row, col, cell){
	                        var id = new CellRef(row, col).print();
	                        if (secondary[id]) {
	                            return;
	                        }
	                        var merged = primary[id];
	                        var width;
	                        if (merged) {
	                            width = sheet._columns.sum(merged.topLeft.col,
	                                                       merged.bottomRight.col);
	                        } else {
	                            width = sheet.columnWidth(col);
	                        }
	                        var data = cell.value;
	                        if (cell.format && data != null) { // jshint ignore:line
	                            data = kendo.spreadsheet.formatting.format(data, cell.format);
	                        }
	                        var textHeight = kendo.spreadsheet.util.getTextHeight(
	                            data, width, cell.fontFamily, cell.fontSize, cell.wrap);
	                        height = Math.max(height, textHeight);
	                    });
	                    sheet.rowHeight(row, height);
	                });
	            }, { layout: true });
	        },

	        forEachCell: function(callback) {
	            this._ref.forEach(function(ref) {
	                this._sheet.forEach(ref.toRangeRef(), callback.bind(this));
	            }.bind(this));
	        },

	        hasValue: function() {
	            var defStyle = this._sheet._defaultCellStyle;
	            return kendo.util.withExit(function(exit){
	                this.forEachCell(function(row, col, cell) {
	                    // we must not consider cells that only have same values
	                    // as defaultCellStyle, or otherwise we will forbid
	                    // inserting rows/cols in an empty sheet.
	                    for (var key in cell) {
	                        var val = cell[key];
	                        if (val !== undefined && val !== null && val !== defStyle[key]) {
	                            exit(true);
	                        }
	                    }
	                });
	            }, this);
	        },

	        wrap: function(flag) {
	            if (flag === undefined) {
	                return !!this._property("wrap");
	            }
	            this._property("wrap", flag);
	            if (flag !== null) {
	                this._adjustRowHeight();
	            }
	            return this;
	        },

	        fontSize: function(size) {
	            if (size === undefined) {
	                return this._property("fontSize");
	            }
	            this._property("fontSize", size);
	            if (size !== null) {
	                this._adjustRowHeight();
	            }
	            return this;
	        },

	        draw: function(options, callback) {
	            this._sheet.draw(this, options, callback);
	        },

	        insideBorders: function(value) {
	            return this.insideVerticalBorders(value).insideHorizontalBorders(value);
	        },

	        insideVerticalBorders: function(value) {
	            this._ref.forEach(function(ref){
	                if (ref instanceof RangeRef && ref.width() > 1) {
	                    ref = ref.clone();
	                    ref.topLeft.col++;
	                    this._sheet.range(ref)._set("vBorders", value);
	                }
	            }, this);
	            return this;
	        },

	        insideHorizontalBorders: function(value) {
	            this._ref.forEach(function(ref){
	                if (ref instanceof RangeRef && ref.height() > 1) {
	                    ref = ref.clone();
	                    ref.topLeft.row++;
	                    this._sheet.range(ref)._set("hBorders", value);
	                }
	            }, this);
	            return this;
	        }
	    });

	    function partition(begin, end, predicate) {
	        while (begin <= end && predicate(begin)) {
	            begin++;
	        }
	        if (begin > end) {
	            return [];
	        }
	        for (var i = begin + 1; i <= end; ++i) {
	            if (predicate(i)) {
	                return [
	                    { begin: begin, end: i - 1 }
	                ].concat(partition(i + 1, end, predicate));
	            }
	        }
	        return [{ begin: begin, end: end }];
	    }

	    // use $.each instead of forEach to work in oldIE
	    $.each(PROPERTIES, function(i, property) {
	        Range.prototype[property] = function(value) {
	            return this._property(property, value);
	        };
	    });

	    function toExcelFormat(format) {
	        return format.replace(/M/g, "m").replace(/'/g, '"').replace(/tt/, "am/pm");
	    }

	    function looksLikeANumber(str) {
	        // XXX: could do with just a regexp instead of calling parse.
	        return !(/^=/.test(str)) && (/number|percent/).test(kendo.spreadsheet.calc.parse(null, 0, 0, str).type);
	    }

	    var measureBox = $('<div style="position: absolute !important; top: -4000px !important; height: auto !important;' +
	                        'padding: 1px 3px !important; box-sizing: border-box; margin: 0 !important; border: 1px solid black !important;' +
	                        'line-height: normal !important; visibility: hidden !important;' +
	                        'white-space: pre-wrap;"></div>'
	                      )[0];

	    function getTextHeight(text, width, fontFamily, fontSize, wrap) {
	        var styles = {
	            "baselineMarkerSize" : 0,
	            "width" : (wrap === true) ? width + "px" : "auto",
	            "font-size" : (fontSize || 12) + "px",
	            "font-family" : fontFamily || "Arial",
	            "white-space" : (wrap === true) ? "pre-wrap" : "pre",
	            "overflow-wrap" : (wrap === true) ? "break-word" : "normal",
	            "word-wrap" : (wrap === true) ? "break-word" : "normal"
	        };

	        return kendo.util.measureText(text, styles, { box: measureBox, normalizeText: false }).height;
	    }

	    kendo.spreadsheet.util = { getTextHeight: getTextHeight };
	    kendo.spreadsheet.Range = Range;
	})(window.kendo);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "R2J4":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(911);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 884:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FTkt");

/***/ }),

/***/ 911:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(884) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function() {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        template = kendo.template,

	        util = kendo.drawing.util,
	        valueOrDefault = util.valueOrDefault,
	        defined = util.defined;

	    var Attribution = Widget.extend({
	        init: function(element, options) {
	            Widget.fn.init.call(this, element, options);
	            this._initOptions(options);
	            this.items = [];
	            this.element.addClass("k-widget k-attribution");
	        },

	        options: {
	            name: "Attribution",
	            separator: "&nbsp;|&nbsp;",
	            itemTemplate: "#= text #"
	        },

	        filter: function(extent, zoom) {
	            this._extent = extent;
	            this._zoom = zoom;
	            this._render();
	        },

	        add: function(item) {
	            if (defined(item)) {
	                if (typeof item === "string") {
	                    item = { text: item };
	                }

	                this.items.push(item);
	                this._render();
	            }
	        },

	        remove: function(text) {
	            var result = [];
	            for (var i = 0; i < this.items.length; i++) {
	                var item = this.items[i];
	                if (item.text !== text) {
	                    result.push(item);
	                }
	            }

	            this.items = result;

	            this._render();
	        },

	        clear: function() {
	            this.items = [];
	            this.element.empty();
	        },

	        _render: function() {
	            var result = [];
	            var itemTemplate = template(this.options.itemTemplate);

	            for (var i = 0; i < this.items.length; i++) {
	                var item = this.items[i];
	                var text = this._itemText(item);
	                if (text !== "") {
	                    result.push(itemTemplate({
	                        text: text
	                    }));
	                }
	            }

	            if (result.length > 0) {
	                this.element.empty()
	                    .append(result.join(this.options.separator))
	                    .show();
	            } else {
	                this.element.hide();
	            }
	        },

	        _itemText: function(item) {
	            var text = "";
	            var inZoomLevel = this._inZoomLevel(item.minZoom, item.maxZoom);
	            var inArea = this._inArea(item.extent);

	            if (inZoomLevel && inArea) {
	                text += item.text;
	            }

	            return text;
	        },

	        _inZoomLevel: function(min, max) {
	            var result = true;
	            min = valueOrDefault(min, -Number.MAX_VALUE);
	            max = valueOrDefault(max, Number.MAX_VALUE);

	            result = this._zoom > min && this._zoom < max;

	            return result;
	        },

	        _inArea: function(area) {
	            var result = true;

	            if (area) {
	                result = area.contains(this._extent);
	            }

	            return result;
	        }
	    });

	    kendo.dataviz.ui.plugin(Attribution);
	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "R6MX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var AggFuncService = (function () {
    function AggFuncService() {
        this.aggFuncsMap = {};
        this.initialised = false;
    }
    AggFuncService_1 = AggFuncService;
    AggFuncService.prototype.init = function () {
        if (this.initialised) {
            return;
        }
        this.initialised = true;
        this.initialiseWithDefaultAggregations();
        this.addAggFuncs(this.gridOptionsWrapper.getAggFuncs());
    };
    AggFuncService.prototype.initialiseWithDefaultAggregations = function () {
        this.aggFuncsMap[AggFuncService_1.AGG_SUM] = aggSum;
        this.aggFuncsMap[AggFuncService_1.AGG_FIRST] = aggFirst;
        this.aggFuncsMap[AggFuncService_1.AGG_LAST] = aggLast;
        this.aggFuncsMap[AggFuncService_1.AGG_MIN] = aggMin;
        this.aggFuncsMap[AggFuncService_1.AGG_MAX] = aggMax;
        this.aggFuncsMap[AggFuncService_1.AGG_COUNT] = aggCount;
        this.aggFuncsMap[AggFuncService_1.AGG_AVG] = aggAvg;
    };
    AggFuncService.prototype.getDefaultAggFunc = function (column) {
        var allKeys = this.getFuncNames(column);
        // use 'sum' if it's a) allowed for the column and b) still registered
        // (ie not removed by user)
        var sumInKeysList = allKeys.indexOf(AggFuncService_1.AGG_SUM) >= 0;
        var sumInFuncs = main_1._.exists(this.aggFuncsMap[AggFuncService_1.AGG_SUM]);
        var useSum = sumInKeysList && sumInFuncs;
        if (useSum) {
            return AggFuncService_1.AGG_SUM;
        }
        else {
            if (main_1.Utils.existsAndNotEmpty(allKeys)) {
                return allKeys[0];
            }
            else {
                return null;
            }
        }
    };
    AggFuncService.prototype.addAggFuncs = function (aggFuncs) {
        main_1.Utils.iterateObject(aggFuncs, this.addAggFunc.bind(this));
    };
    AggFuncService.prototype.addAggFunc = function (key, aggFunc) {
        this.init();
        this.aggFuncsMap[key] = aggFunc;
    };
    AggFuncService.prototype.getAggFunc = function (name) {
        this.init();
        return this.aggFuncsMap[name];
    };
    AggFuncService.prototype.getFuncNames = function (column) {
        var userAllowedFuncs = column.getColDef().allowedAggFuncs;
        if (main_1._.exists(userAllowedFuncs)) {
            return userAllowedFuncs;
        }
        else {
            return Object.keys(this.aggFuncsMap).sort();
        }
    };
    AggFuncService.prototype.clear = function () {
        this.aggFuncsMap = {};
    };
    AggFuncService.AGG_SUM = 'sum';
    AggFuncService.AGG_FIRST = 'first';
    AggFuncService.AGG_LAST = 'last';
    AggFuncService.AGG_MIN = 'min';
    AggFuncService.AGG_MAX = 'max';
    AggFuncService.AGG_COUNT = 'count';
    AggFuncService.AGG_AVG = 'avg';
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], AggFuncService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AggFuncService.prototype, "init", null);
    AggFuncService = AggFuncService_1 = __decorate([
        main_1.Bean('aggFuncService')
    ], AggFuncService);
    return AggFuncService;
    var AggFuncService_1;
}());
exports.AggFuncService = AggFuncService;
function aggSum(input) {
    var result = null;
    var length = input.length;
    for (var i = 0; i < length; i++) {
        if (typeof input[i] === 'number') {
            if (result === null) {
                result = input[i];
            }
            else {
                result += input[i];
            }
        }
    }
    return result;
}
function aggFirst(input) {
    if (input.length >= 0) {
        return input[0];
    }
    else {
        return null;
    }
}
function aggLast(input) {
    if (input.length >= 0) {
        return input[input.length - 1];
    }
    else {
        return null;
    }
}
function aggMin(input) {
    var result = null;
    var length = input.length;
    for (var i = 0; i < length; i++) {
        if (typeof input[i] === 'number') {
            if (result === null) {
                result = input[i];
            }
            else if (result > input[i]) {
                result = input[i];
            }
        }
    }
    return result;
}
function aggMax(input) {
    var result = null;
    var length = input.length;
    for (var i = 0; i < length; i++) {
        if (typeof input[i] === 'number') {
            if (result === null) {
                result = input[i];
            }
            else if (result < input[i]) {
                result = input[i];
            }
        }
    }
    return result;
}
function aggCount(input) {
    var result = {
        value: 0,
        toString: function () {
            return this.value.toString();
        },
        // used for sorting
        toNumber: function () {
            return this.value;
        }
    };
    var length = input.length;
    for (var i = 0; i < length; i++) {
        var isGroupAgg = main_1.Utils.exists(input[i]) && typeof input[i].value === 'number';
        if (isGroupAgg) {
            result.value += input[i].value;
        }
        else {
            result.value++;
        }
    }
    return result;
}
// the average function is tricky as the multiple levels require weighted averages
// for the non-leaf node aggregations.
function aggAvg(input) {
    // the average will be the sum / count
    var sum = 0;
    var count = 0;
    var length = input.length;
    for (var i = 0; i < length; i++) {
        var currentItem = input[i];
        var itemIsGroupResult = main_1.Utils.exists(currentItem) && typeof currentItem.value === 'number' && typeof currentItem.count === 'number';
        // skip values that are not numbers (ie skip empty values)
        if (typeof currentItem === 'number') {
            sum += currentItem;
            count++;
            // check if it's a group (ie value is a wrapper object)
        }
        else if (itemIsGroupResult) {
            // we are aggregating groups, so we take the
            // aggregated values to calculated a weighted average
            sum += currentItem.value * currentItem.count;
            count += currentItem.count;
        }
    }
    // avoid divide by zero error
    var value = null;
    if (count !== 0) {
        value = sum / count;
    }
    // the result will be an object. when this cell is rendered, only the avg is shown.
    // however when this cell is part of another aggregation, the count is also needed
    // to create a weighted average for the next level.
    var result = {
        count: count,
        value: value,
        // the grid by default uses toString to render values for an object, so this
        // is a trick to get the default cellRenderer to display the avg value
        toString: function () {
            if (typeof this.value === 'number') {
                return this.value.toString();
            }
            else {
                return '';
            }
        },
        // used for sorting
        toNumber: function () {
            return this.value;
        }
    };
    return result;
}


/***/ }),

/***/ "R9M2":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "RAMx":
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){ true?module.exports=n():"function"==typeof define&&define.amd?define(n):(e.__vee_validate_locale__pt_BR=e.__vee_validate_locale__pt_BR||{},e.__vee_validate_locale__pt_BR.js=n())}(this,function(){"use strict";var e={name:"pt_BR",messages:{_default:function(e){return"O valor do campo "+e+" não é válido."},after:function(e,n){return"O campo "+e+" deve estar depois do campo "+n[0]+"."},alpha_dash:function(e){return"O campo "+e+" deve conter letras, números e traços."},alpha_num:function(e){return"O campo "+e+" deve conter somente letras e números."},alpha_spaces:function(e){return"O campo "+e+" só pode conter caracteres alfabéticos e espaços."},alpha:function(e){return"O campo "+e+" deve conter somente letras."},before:function(e,n){return"O campo "+e+" deve estar antes do campo "+n[0]+"."},between:function(e,n){return"O campo "+e+" deve estar entre "+n[0]+" e "+n[1]+"."},confirmed:function(e,n){return"Os campos "+e+" e "+n[0]+" devem ser iguais."},credit_card:function(e){return"O campo "+e+" é inválido."},date_between:function(e,n){return"O campo "+e+" deve estar entre "+n[0]+" e "+n[1]+"."},date_format:function(e,n){return"O campo "+e+" deve estar no formato "+n[0]+"."},decimal:function(e,n){void 0===n&&(n=[]);var o=n[0];return void 0===o&&(o="*"),"O campo "+e+" deve ser numérico e deve conter "+(o&&"*"!==o?o:"")+" casas decimais."},digits:function(e,n){return"O campo "+e+" deve ser numérico e ter exatamente "+n[0]+" dígitos."},dimensions:function(e,n){return"O campo "+e+" deve ter "+n[0]+" pixels de largura por "+n[1]+" pixels de altura."},email:function(e){return"O campo "+e+" deve ser um email válido."},ext:function(e){return"O campo "+e+" deve ser um arquivo válido."},image:function(e){return"O campo "+e+" deve ser uma imagem."},in:function(e){return"O campo "+e+" deve ter um valor válido."},integer:function(e){return"O campo "+e+" deve ser um número inteiro."},ip:function(e){return"O campo "+e+" deve ser um endereço IP válido."},length:function(e,n){var o=n[0],r=n[1];return r?"O tamanho do campo "+e+" está entre "+o+" e "+r+".":"O tamanho do campo "+e+" deve ser "+o+"."},max:function(e,n){return"O campo "+e+" não deve ter mais que "+n[0]+" caracteres."},max_value:function(e,n){return"O campo "+e+" precisa ser "+n[0]+" ou menor."},mimes:function(e){return"O campo "+e+" deve ser um tipo de arquivo válido."},min:function(e,n){return"O campo "+e+" deve conter pelo menos "+n[0]+" caracteres."},min_value:function(e,n){return"O campo "+e+" precisa ser "+n[0]+" ou maior."},not_in:function(e){return"O campo "+e+" deve ser um valor válido."},numeric:function(e){return"O campo "+e+" deve conter apenas números"},regex:function(e){return"O campo "+e+" possui um formato inválido."},required:function(e){return"O campo "+e+" é obrigatório."},size:function(e,n){return"O campo "+e+" deve ser menor que "+function(e){var n=0==(e=1024*Number(e))?0:Math.floor(Math.log(e)/Math.log(1024));return 1*(e/Math.pow(1024,n)).toFixed(2)+" "+["Byte","KB","MB","GB","TB","PB","EB","ZB","YB"][n]}(n[0])+"."},url:function(e){return"O campo "+e+" não é uma URL válida."}},attributes:{}};if("undefined"!=typeof VeeValidate){VeeValidate.Validator.localize((n={},n[e.name]=e,n));var n}return e});

/***/ }),

/***/ "RPLV":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7KvD").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "RQ1/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var Context = (function () {
    function Context(params, logger) {
        this.beans = {};
        this.componentsMappedByName = {};
        this.destroyed = false;
        if (!params || !params.beans) {
            return;
        }
        this.contextParams = params;
        this.logger = logger;
        this.logger.log('>> creating ag-Application Context');
        this.setupComponents();
        this.createBeans();
        var beans = utils_1.Utils.mapObject(this.beans, function (beanEntry) { return beanEntry.beanInstance; });
        this.wireBeans(beans);
        this.logger.log('>> ag-Application Context ready - component is alive');
    }
    Context.prototype.setupComponents = function () {
        var _this = this;
        if (this.contextParams.components) {
            this.contextParams.components.forEach(function (componentMeta) { return _this.addComponent(componentMeta); });
        }
    };
    Context.prototype.addComponent = function (componentMeta) {
        // get name of the class as a string
        // let className = _.getNameOfClass(ComponentClass);
        // insert a dash after every capital letter
        // let classEscaped = className.replace(/([A-Z])/g, "-$1").toLowerCase();
        var classEscaped = componentMeta.componentName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
        // put all to upper case
        var classUpperCase = classEscaped.toUpperCase();
        // finally store
        this.componentsMappedByName[classUpperCase] = componentMeta.theClass;
    };
    Context.prototype.createComponent = function (element) {
        var key = element.nodeName;
        if (this.componentsMappedByName && this.componentsMappedByName[key]) {
            var newComponent = new this.componentsMappedByName[key];
            this.wireBean(newComponent);
            this.copyAttributesFromNode(element, newComponent.getGui());
            newComponent.attributesSet();
            return newComponent;
        }
        else {
            return null;
        }
    };
    Context.prototype.copyAttributesFromNode = function (fromNode, toNode) {
        if (fromNode.attributes) {
            var count = fromNode.attributes.length;
            for (var i = 0; i < count; i++) {
                var attr = fromNode.attributes[i];
                toNode.setAttribute(attr.name, attr.value);
            }
        }
    };
    Context.prototype.wireBean = function (bean) {
        if (!bean)
            throw Error("Can't wire to bean since it is null");
        this.wireBeans([bean]);
    };
    Context.prototype.wireBeans = function (beans) {
        this.autoWireBeans(beans);
        this.methodWireBeans(beans);
        this.preConstruct(beans);
        this.postConstruct(beans);
    };
    Context.prototype.createBeans = function () {
        var _this = this;
        // register all normal beans
        this.contextParams.beans.forEach(this.createBeanEntry.bind(this));
        // register override beans, these will overwrite beans above of same name
        if (this.contextParams.overrideBeans) {
            this.contextParams.overrideBeans.forEach(this.createBeanEntry.bind(this));
        }
        // instantiate all beans - overridden beans will be left out
        utils_1.Utils.iterateObject(this.beans, function (key, beanEntry) {
            var constructorParamsMeta;
            if (beanEntry.bean.__agBeanMetaData
                && beanEntry.bean.__agBeanMetaData.autowireMethods
                && beanEntry.bean.__agBeanMetaData.autowireMethods.agConstructor) {
                constructorParamsMeta = beanEntry.bean.__agBeanMetaData.autowireMethods.agConstructor;
            }
            var constructorParams = _this.getBeansForParameters(constructorParamsMeta, beanEntry.bean.name);
            var newInstance = applyToConstructor(beanEntry.bean, constructorParams);
            beanEntry.beanInstance = newInstance;
            _this.logger.log('bean ' + _this.getBeanName(newInstance) + ' created');
        });
    };
    Context.prototype.createBeanEntry = function (Bean) {
        var metaData = Bean.__agBeanMetaData;
        if (!metaData) {
            var beanName = void 0;
            if (Bean.prototype.constructor) {
                beanName = Bean.prototype.constructor.name;
            }
            else {
                beanName = '' + Bean;
            }
            console.error('context item ' + beanName + ' is not a bean');
            return;
        }
        var beanEntry = {
            bean: Bean,
            beanInstance: null,
            beanName: metaData.beanName
        };
        this.beans[metaData.beanName] = beanEntry;
    };
    Context.prototype.autoWireBeans = function (beans) {
        var _this = this;
        beans.forEach(function (bean) { return _this.autoWireBean(bean); });
    };
    Context.prototype.methodWireBeans = function (beans) {
        var _this = this;
        beans.forEach(function (bean) {
            if (!bean)
                throw Error("Can't wire to bean since it is null");
            return _this.methodWireBean(bean);
        });
    };
    Context.prototype.autoWireBean = function (bean) {
        var _this = this;
        var currentBean = bean;
        var _loop_1 = function () {
            var currentConstructor = currentBean.constructor;
            if (currentConstructor.__agBeanMetaData
                && currentConstructor.__agBeanMetaData.agClassAttributes) {
                var attributes = currentConstructor.__agBeanMetaData.agClassAttributes;
                if (!attributes) {
                    return { value: void 0 };
                }
                var beanName_1 = this_1.getBeanName(currentConstructor);
                attributes.forEach(function (attribute) {
                    var otherBean = _this.lookupBeanInstance(beanName_1, attribute.beanName, attribute.optional);
                    bean[attribute.attributeName] = otherBean;
                });
            }
            currentBean = Object.getPrototypeOf(currentBean) ? Object.getPrototypeOf(currentBean) : null;
        };
        var this_1 = this;
        while (currentBean != null) {
            var state_1 = _loop_1();
            if (typeof state_1 === "object")
                return state_1.value;
        }
    };
    Context.prototype.getBeanName = function (constructor) {
        if (constructor.__agBeanMetaData && constructor.__agBeanMetaData.beanName) {
            return constructor.__agBeanMetaData.beanName;
        }
        var constructorString = constructor.toString();
        var beanName = constructorString.substring(9, constructorString.indexOf('('));
        return beanName;
    };
    Context.prototype.methodWireBean = function (bean) {
        var _this = this;
        var autowiredMethods;
        if (bean.constructor.__agBeanMetaData && bean.constructor.__agBeanMetaData.autowireMethods) {
            autowiredMethods = bean.constructor.__agBeanMetaData.autowireMethods;
        }
        utils_1.Utils.iterateObject(autowiredMethods, function (methodName, wireParams) {
            // skip constructor, as this is dealt with elsewhere
            if (methodName === 'agConstructor') {
                return;
            }
            var beanName = _this.getBeanName(bean.constructor);
            var initParams = _this.getBeansForParameters(wireParams, beanName);
            bean[methodName].apply(bean, initParams);
        });
    };
    Context.prototype.getBeansForParameters = function (parameters, beanName) {
        var _this = this;
        var beansList = [];
        if (parameters) {
            utils_1.Utils.iterateObject(parameters, function (paramIndex, otherBeanName) {
                var otherBean = _this.lookupBeanInstance(beanName, otherBeanName);
                beansList[Number(paramIndex)] = otherBean;
            });
        }
        return beansList;
    };
    Context.prototype.lookupBeanInstance = function (wiringBean, beanName, optional) {
        if (optional === void 0) { optional = false; }
        if (beanName === 'context') {
            return this;
        }
        else if (this.contextParams.seed && this.contextParams.seed.hasOwnProperty(beanName)) {
            return this.contextParams.seed[beanName];
        }
        else {
            var beanEntry = this.beans[beanName];
            if (beanEntry) {
                return beanEntry.beanInstance;
            }
            if (!optional) {
                console.error('ag-Grid: unable to find bean reference ' + beanName + ' while initialising ' + wiringBean);
            }
            return null;
        }
    };
    Context.prototype.postConstruct = function (beans) {
        beans.forEach(function (bean) {
            // try calling init methods
            if (bean.constructor.__agBeanMetaData && bean.constructor.__agBeanMetaData.postConstructMethods) {
                bean.constructor.__agBeanMetaData && bean.constructor.__agBeanMetaData.postConstructMethods.forEach(function (methodName) { return bean[methodName](); });
            }
        });
    };
    Context.prototype.preConstruct = function (beans) {
        beans.forEach(function (bean) {
            // try calling init methods
            if (bean.constructor.__agBeanMetaData && bean.constructor.__agBeanMetaData.preConstructMethods) {
                bean.constructor.__agBeanMetaData.preConstructMethods.forEach(function (methodName) { return bean[methodName](); });
            }
        });
    };
    Context.prototype.getBean = function (name) {
        return this.lookupBeanInstance('getBean', name, true);
    };
    Context.prototype.destroy = function () {
        // should only be able to destroy once
        if (this.destroyed) {
            return;
        }
        this.logger.log('>> Shutting down ag-Application Context');
        // try calling destroy methods
        utils_1.Utils.iterateObject(this.beans, function (key, beanEntry) {
            var bean = beanEntry.beanInstance;
            if (bean.constructor.__agBeanMetaData && bean.constructor.__agBeanMetaData.preDestroyMethods) {
                bean.constructor.__agBeanMetaData.preDestroyMethods.forEach(function (methodName) { return bean[methodName](); });
            }
        });
        this.destroyed = true;
        this.logger.log('>> ag-Application Context shut down - component is dead');
    };
    return Context;
}());
exports.Context = Context;
// taken from: http://stackoverflow.com/questions/3362471/how-can-i-call-a-javascript-constructor-using-call-or-apply
// allows calling 'apply' on a constructor
function applyToConstructor(constructor, argArray) {
    var args = [null].concat(argArray);
    var factoryFunction = constructor.bind.apply(constructor, args);
    return new factoryFunction();
}
function PreConstruct(target, methodName, descriptor) {
    var props = getOrCreateProps(target.constructor);
    if (!props.postConstructMethods) {
        props.preConstructMethods = [];
    }
    props.preConstructMethods.push(methodName);
}
exports.PreConstruct = PreConstruct;
function PostConstruct(target, methodName, descriptor) {
    var props = getOrCreateProps(target.constructor);
    if (!props.postConstructMethods) {
        props.postConstructMethods = [];
    }
    props.postConstructMethods.push(methodName);
}
exports.PostConstruct = PostConstruct;
function PreDestroy(target, methodName, descriptor) {
    var props = getOrCreateProps(target.constructor);
    if (!props.preDestroyMethods) {
        props.preDestroyMethods = [];
    }
    props.preDestroyMethods.push(methodName);
}
exports.PreDestroy = PreDestroy;
function Bean(beanName) {
    return function (classConstructor) {
        var props = getOrCreateProps(classConstructor);
        props.beanName = beanName;
    };
}
exports.Bean = Bean;
function Autowired(name) {
    return function (target, propertyKey, descriptor) {
        autowiredFunc(target, name, false, target, propertyKey, null);
    };
}
exports.Autowired = Autowired;
function Optional(name) {
    return function (target, propertyKey, descriptor) {
        autowiredFunc(target, name, true, target, propertyKey, null);
    };
}
exports.Optional = Optional;
function autowiredFunc(target, name, optional, classPrototype, methodOrAttributeName, index) {
    if (name === null) {
        console.error('ag-Grid: Autowired name should not be null');
        return;
    }
    if (typeof index === 'number') {
        console.error('ag-Grid: Autowired should be on an attribute');
        return;
    }
    // it's an attribute on the class
    var props = getOrCreateProps(target.constructor);
    if (!props.agClassAttributes) {
        props.agClassAttributes = [];
    }
    props.agClassAttributes.push({
        attributeName: methodOrAttributeName,
        beanName: name,
        optional: optional
    });
}
function Qualifier(name) {
    return function (classPrototype, methodOrAttributeName, index) {
        var constructor = (typeof classPrototype == 'function') ? classPrototype : classPrototype.constructor;
        var props;
        if (typeof index === 'number') {
            // it's a parameter on a method
            var methodName = void 0;
            if (methodOrAttributeName) {
                props = getOrCreateProps(constructor);
                methodName = methodOrAttributeName;
            }
            else {
                props = getOrCreateProps(constructor);
                methodName = 'agConstructor';
            }
            if (!props.autowireMethods) {
                props.autowireMethods = {};
            }
            if (!props.autowireMethods[methodName]) {
                props.autowireMethods[methodName] = {};
            }
            props.autowireMethods[methodName][index] = name;
        }
    };
}
exports.Qualifier = Qualifier;
function getOrCreateProps(target) {
    if (!target.hasOwnProperty('__agBeanMetaData')) {
        target.__agBeanMetaData = {};
    }
    return target.__agBeanMetaData;
}


/***/ }),

/***/ "RU0j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var rowGroupColumnsPanel_1 = __webpack_require__("Ygk/");
var RowGroupCompFactory = (function () {
    function RowGroupCompFactory() {
    }
    RowGroupCompFactory.prototype.create = function () {
        var rowGroupComp = new rowGroupColumnsPanel_1.RowGroupColumnsPanel(true);
        this.context.wireBean(rowGroupComp);
        return rowGroupComp;
    };
    __decorate([
        main_1.Autowired('context'),
        __metadata("design:type", main_1.Context)
    ], RowGroupCompFactory.prototype, "context", void 0);
    RowGroupCompFactory = __decorate([
        main_1.Bean('rowGroupCompFactory')
    ], RowGroupCompFactory);
    return RowGroupCompFactory;
}());
exports.RowGroupCompFactory = RowGroupCompFactory;


/***/ }),

/***/ "RUzx":
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.VueMultiselect=e():t.VueMultiselect=e()}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,i){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:i})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/",e(e.s=60)}([function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e,n){var i=n(49)("wks"),r=n(30),o=n(0).Symbol,s="function"==typeof o;(t.exports=function(t){return i[t]||(i[t]=s&&o[t]||(s?o:r)("Symbol."+t))}).store=i},function(t,e,n){var i=n(5);t.exports=function(t){if(!i(t))throw TypeError(t+" is not an object!");return t}},function(t,e,n){var i=n(0),r=n(10),o=n(8),s=n(6),u=n(11),a=function(t,e,n){var l,c,f,p,h=t&a.F,d=t&a.G,v=t&a.S,g=t&a.P,y=t&a.B,m=d?i:v?i[e]||(i[e]={}):(i[e]||{}).prototype,b=d?r:r[e]||(r[e]={}),_=b.prototype||(b.prototype={});d&&(n=e);for(l in n)c=!h&&m&&void 0!==m[l],f=(c?m:n)[l],p=y&&c?u(f,i):g&&"function"==typeof f?u(Function.call,f):f,m&&s(m,l,f,t&a.U),b[l]!=f&&o(b,l,p),g&&_[l]!=f&&(_[l]=f)};i.core=r,a.F=1,a.G=2,a.S=4,a.P=8,a.B=16,a.W=32,a.U=64,a.R=128,t.exports=a},function(t,e,n){t.exports=!n(7)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){var i=n(0),r=n(8),o=n(12),s=n(30)("src"),u=Function.toString,a=(""+u).split("toString");n(10).inspectSource=function(t){return u.call(t)},(t.exports=function(t,e,n,u){var l="function"==typeof n;l&&(o(n,"name")||r(n,"name",e)),t[e]!==n&&(l&&(o(n,s)||r(n,s,t[e]?""+t[e]:a.join(String(e)))),t===i?t[e]=n:u?t[e]?t[e]=n:r(t,e,n):(delete t[e],r(t,e,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[s]||u.call(this)})},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var i=n(13),r=n(25);t.exports=n(4)?function(t,e,n){return i.f(t,e,r(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){var n=t.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},function(t,e,n){var i=n(14);t.exports=function(t,e,n){if(i(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,i){return t.call(e,n,i)};case 3:return function(n,i,r){return t.call(e,n,i,r)}}return function(){return t.apply(e,arguments)}}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){var i=n(2),r=n(41),o=n(29),s=Object.defineProperty;e.f=n(4)?Object.defineProperty:function(t,e,n){if(i(t),e=o(e,!0),i(n),r)try{return s(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e){t.exports={}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){"use strict";var i=n(7);t.exports=function(t,e){return!!t&&i(function(){e?t.call(null,function(){},1):t.call(null)})}},function(t,e,n){var i=n(23),r=n(16);t.exports=function(t){return i(r(t))}},function(t,e,n){var i=n(53),r=Math.min;t.exports=function(t){return t>0?r(i(t),9007199254740991):0}},function(t,e,n){var i=n(11),r=n(23),o=n(28),s=n(19),u=n(64);t.exports=function(t,e){var n=1==t,a=2==t,l=3==t,c=4==t,f=6==t,p=5==t||f,h=e||u;return function(e,u,d){for(var v,g,y=o(e),m=r(y),b=i(u,d,3),_=s(m.length),x=0,w=n?h(e,_):a?h(e,0):void 0;_>x;x++)if((p||x in m)&&(v=m[x],g=b(v,x,y),t))if(n)w[x]=g;else if(g)switch(t){case 3:return!0;case 5:return v;case 6:return x;case 2:w.push(v)}else if(c)return!1;return f?-1:l||c?c:w}}},function(t,e,n){var i=n(5),r=n(0).document,o=i(r)&&i(r.createElement);t.exports=function(t){return o?r.createElement(t):{}}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){var i=n(9);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==i(t)?t.split(""):Object(t)}},function(t,e){t.exports=!1},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){var i=n(13).f,r=n(12),o=n(1)("toStringTag");t.exports=function(t,e,n){t&&!r(t=n?t:t.prototype,o)&&i(t,o,{configurable:!0,value:e})}},function(t,e,n){var i=n(49)("keys"),r=n(30);t.exports=function(t){return i[t]||(i[t]=r(t))}},function(t,e,n){var i=n(16);t.exports=function(t){return Object(i(t))}},function(t,e,n){var i=n(5);t.exports=function(t,e){if(!i(t))return t;var n,r;if(e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;if("function"==typeof(n=t.valueOf)&&!i(r=n.call(t)))return r;if(!e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;throw TypeError("Can't convert object to primitive value")}},function(t,e){var n=0,i=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+i).toString(36))}},function(t,e,n){"use strict";var i=n(0),r=n(12),o=n(9),s=n(67),u=n(29),a=n(7),l=n(77).f,c=n(45).f,f=n(13).f,p=n(51).trim,h=i.Number,d=h,v=h.prototype,g="Number"==o(n(44)(v)),y="trim"in String.prototype,m=function(t){var e=u(t,!1);if("string"==typeof e&&e.length>2){e=y?e.trim():p(e,3);var n,i,r,o=e.charCodeAt(0);if(43===o||45===o){if(88===(n=e.charCodeAt(2))||120===n)return NaN}else if(48===o){switch(e.charCodeAt(1)){case 66:case 98:i=2,r=49;break;case 79:case 111:i=8,r=55;break;default:return+e}for(var s,a=e.slice(2),l=0,c=a.length;l<c;l++)if((s=a.charCodeAt(l))<48||s>r)return NaN;return parseInt(a,i)}}return+e};if(!h(" 0o1")||!h("0b1")||h("+0x1")){h=function(t){var e=arguments.length<1?0:t,n=this;return n instanceof h&&(g?a(function(){v.valueOf.call(n)}):"Number"!=o(n))?s(new d(m(e)),n,h):m(e)};for(var b,_=n(4)?l(d):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),x=0;_.length>x;x++)r(d,b=_[x])&&!r(h,b)&&f(h,b,c(d,b));h.prototype=v,v.constructor=h,n(6)(i,"Number",h)}},function(t,e,n){"use strict";function i(t){return 0!==t&&(!(!Array.isArray(t)||0!==t.length)||!t)}function r(t){return function(){return!t.apply(void 0,arguments)}}function o(t,e){return void 0===t&&(t="undefined"),null===t&&(t="null"),!1===t&&(t="false"),-1!==t.toString().toLowerCase().indexOf(e.trim())}function s(t,e,n,i){return t.filter(function(t){return o(i(t,n),e)})}function u(t){return t.filter(function(t){return!t.$isLabel})}function a(t,e){return function(n){return n.reduce(function(n,i){return i[t]&&i[t].length?(n.push({$groupLabel:i[e],$isLabel:!0}),n.concat(i[t])):n},[])}}function l(t,e,i,r,o){return function(u){return u.map(function(u){var a;if(!u[i])return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."),[];var l=s(u[i],t,e,o);return l.length?(a={},n.i(d.a)(a,r,u[r]),n.i(d.a)(a,i,l),a):[]})}}var c=n(59),f=n(54),p=(n.n(f),n(95)),h=(n.n(p),n(31)),d=(n.n(h),n(58)),v=n(91),g=(n.n(v),n(98)),y=(n.n(g),n(92)),m=(n.n(y),n(88)),b=(n.n(m),n(97)),_=(n.n(b),n(89)),x=(n.n(_),n(96)),w=(n.n(x),n(93)),S=(n.n(w),n(90)),O=(n.n(S),function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return function(t){return e.reduce(function(t,e){return e(t)},t)}});e.a={data:function(){return{search:"",isOpen:!1,preferredOpenDirection:"below",optimizedHeight:this.maxHeight}},props:{internalSearch:{type:Boolean,default:!0},options:{type:Array,required:!0},multiple:{type:Boolean,default:!1},value:{type:null,default:function(){return[]}},trackBy:{type:String},label:{type:String},searchable:{type:Boolean,default:!0},clearOnSelect:{type:Boolean,default:!0},hideSelected:{type:Boolean,default:!1},placeholder:{type:String,default:"Select option"},allowEmpty:{type:Boolean,default:!0},resetAfter:{type:Boolean,default:!1},closeOnSelect:{type:Boolean,default:!0},customLabel:{type:Function,default:function(t,e){return i(t)?"":e?t[e]:t}},taggable:{type:Boolean,default:!1},tagPlaceholder:{type:String,default:"Press enter to create a tag"},tagPosition:{type:String,default:"top"},max:{type:[Number,Boolean],default:!1},id:{default:null},optionsLimit:{type:Number,default:1e3},groupValues:{type:String},groupLabel:{type:String},groupSelect:{type:Boolean,default:!1},blockKeys:{type:Array,default:function(){return[]}},preserveSearch:{type:Boolean,default:!1},preselectFirst:{type:Boolean,default:!1}},mounted:function(){!this.multiple&&this.max&&console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."),this.preselectFirst&&!this.internalValue.length&&this.options.length&&this.select(this.filteredOptions[0])},computed:{internalValue:function(){return this.value||0===this.value?Array.isArray(this.value)?this.value:[this.value]:[]},filteredOptions:function(){var t=this.search||"",e=t.toLowerCase().trim(),n=this.options.concat();return n=this.internalSearch?this.groupValues?this.filterAndFlat(n,e,this.label):s(n,e,this.label,this.customLabel):this.groupValues?a(this.groupValues,this.groupLabel)(n):n,n=this.hideSelected?n.filter(r(this.isSelected)):n,this.taggable&&e.length&&!this.isExistingOption(e)&&("bottom"===this.tagPosition?n.push({isTag:!0,label:t}):n.unshift({isTag:!0,label:t})),n.slice(0,this.optionsLimit)},valueKeys:function(){var t=this;return this.trackBy?this.internalValue.map(function(e){return e[t.trackBy]}):this.internalValue},optionKeys:function(){var t=this;return(this.groupValues?this.flatAndStrip(this.options):this.options).map(function(e){return t.customLabel(e,t.label).toString().toLowerCase()})},currentOptionLabel:function(){return this.multiple?this.searchable?"":this.placeholder:this.internalValue.length?this.getOptionLabel(this.internalValue[0]):this.searchable?"":this.placeholder}},watch:{internalValue:function(){this.resetAfter&&this.internalValue.length&&(this.search="",this.$emit("input",this.multiple?[]:null))},search:function(){this.$emit("search-change",this.search,this.id)}},methods:{getValue:function(){return this.multiple?this.internalValue:0===this.internalValue.length?null:this.internalValue[0]},filterAndFlat:function(t,e,n){return O(l(e,n,this.groupValues,this.groupLabel,this.customLabel),a(this.groupValues,this.groupLabel))(t)},flatAndStrip:function(t){return O(a(this.groupValues,this.groupLabel),u)(t)},updateSearch:function(t){this.search=t},isExistingOption:function(t){return!!this.options&&this.optionKeys.indexOf(t)>-1},isSelected:function(t){var e=this.trackBy?t[this.trackBy]:t;return this.valueKeys.indexOf(e)>-1},isOptionDisabled:function(t){return!!t.$isDisabled},getOptionLabel:function(t){if(i(t))return"";if(t.isTag)return t.label;if(t.$isLabel)return t.$groupLabel;var e=this.customLabel(t,this.label);return i(e)?"":e},select:function(t,e){if(t.$isLabel&&this.groupSelect)return void this.selectGroup(t);if(!(-1!==this.blockKeys.indexOf(e)||this.disabled||t.$isDisabled||t.$isLabel)&&(!this.max||!this.multiple||this.internalValue.length!==this.max)&&("Tab"!==e||this.pointerDirty)){if(t.isTag)this.$emit("tag",t.label,this.id),this.search="",this.closeOnSelect&&!this.multiple&&this.deactivate();else{if(this.isSelected(t))return void("Tab"!==e&&this.removeElement(t));this.$emit("select",t,this.id),this.multiple?this.$emit("input",this.internalValue.concat([t]),this.id):this.$emit("input",t,this.id),this.clearOnSelect&&(this.search="")}this.closeOnSelect&&this.deactivate()}},selectGroup:function(t){var e=this,n=this.options.find(function(n){return n[e.groupLabel]===t.$groupLabel});if(n)if(this.wholeGroupSelected(n)){this.$emit("remove",n[this.groupValues],this.id);var i=this.internalValue.filter(function(t){return-1===n[e.groupValues].indexOf(t)});this.$emit("input",i,this.id)}else{var r=n[this.groupValues].filter(function(t){return!(e.isOptionDisabled(t)||e.isSelected(t))});this.$emit("select",r,this.id),this.$emit("input",this.internalValue.concat(r),this.id)}},wholeGroupSelected:function(t){var e=this;return t[this.groupValues].every(function(t){return e.isSelected(t)||e.isOptionDisabled(t)})},wholeGroupDisabled:function(t){return t[this.groupValues].every(this.isOptionDisabled)},removeElement:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(!this.disabled&&!t.$isDisabled){if(!this.allowEmpty&&this.internalValue.length<=1)return void this.deactivate();var i="object"===n.i(c.a)(t)?this.valueKeys.indexOf(t[this.trackBy]):this.valueKeys.indexOf(t);if(this.$emit("remove",t,this.id),this.multiple){var r=this.internalValue.slice(0,i).concat(this.internalValue.slice(i+1));this.$emit("input",r,this.id)}else this.$emit("input",null,this.id);this.closeOnSelect&&e&&this.deactivate()}},removeLastElement:function(){-1===this.blockKeys.indexOf("Delete")&&0===this.search.length&&Array.isArray(this.internalValue)&&this.internalValue.length&&this.removeElement(this.internalValue[this.internalValue.length-1],!1)},activate:function(){var t=this;this.isOpen||this.disabled||(this.adjustPosition(),this.groupValues&&0===this.pointer&&this.filteredOptions.length&&(this.pointer=1),this.isOpen=!0,this.searchable?(this.preserveSearch||(this.search=""),this.$nextTick(function(){return t.$refs.search.focus()})):this.$el.focus(),this.$emit("open",this.id))},deactivate:function(){this.isOpen&&(this.isOpen=!1,this.searchable?this.$refs.search.blur():this.$el.blur(),this.preserveSearch||(this.search=""),this.$emit("close",this.getValue(),this.id))},toggle:function(){this.isOpen?this.deactivate():this.activate()},adjustPosition:function(){if("undefined"!=typeof window){var t=this.$el.getBoundingClientRect().top,e=window.innerHeight-this.$el.getBoundingClientRect().bottom;e>this.maxHeight||e>t||"below"===this.openDirection||"bottom"===this.openDirection?(this.preferredOpenDirection="below",this.optimizedHeight=Math.min(e-40,this.maxHeight)):(this.preferredOpenDirection="above",this.optimizedHeight=Math.min(t-40,this.maxHeight))}}}}},function(t,e,n){"use strict";var i=n(54),r=(n.n(i),n(31));n.n(r);e.a={data:function(){return{pointer:0,pointerDirty:!1}},props:{showPointer:{type:Boolean,default:!0},optionHeight:{type:Number,default:40}},computed:{pointerPosition:function(){return this.pointer*this.optionHeight},visibleElements:function(){return this.optimizedHeight/this.optionHeight}},watch:{filteredOptions:function(){this.pointerAdjust()},isOpen:function(){this.pointerDirty=!1}},methods:{optionHighlight:function(t,e){return{"multiselect__option--highlight":t===this.pointer&&this.showPointer,"multiselect__option--selected":this.isSelected(e)}},groupHighlight:function(t,e){var n=this;if(!this.groupSelect)return["multiselect__option--group","multiselect__option--disabled"];var i=this.options.find(function(t){return t[n.groupLabel]===e.$groupLabel});return i&&!this.wholeGroupDisabled(i)?["multiselect__option--group",{"multiselect__option--highlight":t===this.pointer&&this.showPointer},{"multiselect__option--group-selected":this.wholeGroupSelected(i)}]:"multiselect__option--disabled"},addPointerElement:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"Enter",e=t.key;this.filteredOptions.length>0&&this.select(this.filteredOptions[this.pointer],e),this.pointerReset()},pointerForward:function(){this.pointer<this.filteredOptions.length-1&&(this.pointer++,this.$refs.list.scrollTop<=this.pointerPosition-(this.visibleElements-1)*this.optionHeight&&(this.$refs.list.scrollTop=this.pointerPosition-(this.visibleElements-1)*this.optionHeight),this.filteredOptions[this.pointer]&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerForward()),this.pointerDirty=!0},pointerBackward:function(){this.pointer>0?(this.pointer--,this.$refs.list.scrollTop>=this.pointerPosition&&(this.$refs.list.scrollTop=this.pointerPosition),this.filteredOptions[this.pointer]&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerBackward()):this.filteredOptions[this.pointer]&&this.filteredOptions[0].$isLabel&&!this.groupSelect&&this.pointerForward(),this.pointerDirty=!0},pointerReset:function(){this.closeOnSelect&&(this.pointer=0,this.$refs.list&&(this.$refs.list.scrollTop=0))},pointerAdjust:function(){this.pointer>=this.filteredOptions.length-1&&(this.pointer=this.filteredOptions.length?this.filteredOptions.length-1:0),this.filteredOptions.length>0&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerForward()},pointerSet:function(t){this.pointer=t,this.pointerDirty=!0}}}},function(t,e,n){"use strict";var i=n(36),r=n(74),o=n(15),s=n(18);t.exports=n(72)(Array,"Array",function(t,e){this._t=s(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,r(1)):"keys"==e?r(0,n):"values"==e?r(0,t[n]):r(0,[n,t[n]])},"values"),o.Arguments=o.Array,i("keys"),i("values"),i("entries")},function(t,e,n){"use strict";var i=n(31),r=(n.n(i),n(32)),o=n(33);e.a={name:"vue-multiselect",mixins:[r.a,o.a],props:{name:{type:String,default:""},selectLabel:{type:String,default:"Press enter to select"},selectGroupLabel:{type:String,default:"Press enter to select group"},selectedLabel:{type:String,default:"Selected"},deselectLabel:{type:String,default:"Press enter to remove"},deselectGroupLabel:{type:String,default:"Press enter to deselect group"},showLabels:{type:Boolean,default:!0},limit:{type:Number,default:99999},maxHeight:{type:Number,default:300},limitText:{type:Function,default:function(t){return"and ".concat(t," more")}},loading:{type:Boolean,default:!1},disabled:{type:Boolean,default:!1},openDirection:{type:String,default:""},showNoOptions:{type:Boolean,default:!0},showNoResults:{type:Boolean,default:!0},tabindex:{type:Number,default:0}},computed:{isSingleLabelVisible:function(){return(this.singleValue||0===this.singleValue)&&(!this.isOpen||!this.searchable)&&!this.visibleValues.length},isPlaceholderVisible:function(){return!(this.internalValue.length||this.searchable&&this.isOpen)},visibleValues:function(){return this.multiple?this.internalValue.slice(0,this.limit):[]},singleValue:function(){return this.internalValue[0]},deselectLabelText:function(){return this.showLabels?this.deselectLabel:""},deselectGroupLabelText:function(){return this.showLabels?this.deselectGroupLabel:""},selectLabelText:function(){return this.showLabels?this.selectLabel:""},selectGroupLabelText:function(){return this.showLabels?this.selectGroupLabel:""},selectedLabelText:function(){return this.showLabels?this.selectedLabel:""},inputStyle:function(){if(this.searchable||this.multiple&&this.value&&this.value.length)return this.isOpen?{width:"100%"}:{width:"0",position:"absolute",padding:"0"}},contentStyle:function(){return this.options.length?{display:"inline-block"}:{display:"block"}},isAbove:function(){return"above"===this.openDirection||"top"===this.openDirection||"below"!==this.openDirection&&"bottom"!==this.openDirection&&"above"===this.preferredOpenDirection},showSearchInput:function(){return this.searchable&&(!this.hasSingleSelectedSlot||!this.visibleSingleValue&&0!==this.visibleSingleValue||this.isOpen)}}}},function(t,e,n){var i=n(1)("unscopables"),r=Array.prototype;void 0==r[i]&&n(8)(r,i,{}),t.exports=function(t){r[i][t]=!0}},function(t,e,n){var i=n(18),r=n(19),o=n(85);t.exports=function(t){return function(e,n,s){var u,a=i(e),l=r(a.length),c=o(s,l);if(t&&n!=n){for(;l>c;)if((u=a[c++])!=u)return!0}else for(;l>c;c++)if((t||c in a)&&a[c]===n)return t||c||0;return!t&&-1}}},function(t,e,n){var i=n(9),r=n(1)("toStringTag"),o="Arguments"==i(function(){return arguments}()),s=function(t,e){try{return t[e]}catch(t){}};t.exports=function(t){var e,n,u;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=s(e=Object(t),r))?n:o?i(e):"Object"==(u=i(e))&&"function"==typeof e.callee?"Arguments":u}},function(t,e,n){"use strict";var i=n(2);t.exports=function(){var t=i(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}},function(t,e,n){var i=n(0).document;t.exports=i&&i.documentElement},function(t,e,n){t.exports=!n(4)&&!n(7)(function(){return 7!=Object.defineProperty(n(21)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){var i=n(9);t.exports=Array.isArray||function(t){return"Array"==i(t)}},function(t,e,n){"use strict";function i(t){var e,n;this.promise=new t(function(t,i){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=i}),this.resolve=r(e),this.reject=r(n)}var r=n(14);t.exports.f=function(t){return new i(t)}},function(t,e,n){var i=n(2),r=n(76),o=n(22),s=n(27)("IE_PROTO"),u=function(){},a=function(){var t,e=n(21)("iframe"),i=o.length;for(e.style.display="none",n(40).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write("<script>document.F=Object<\/script>"),t.close(),a=t.F;i--;)delete a.prototype[o[i]];return a()};t.exports=Object.create||function(t,e){var n;return null!==t?(u.prototype=i(t),n=new u,u.prototype=null,n[s]=t):n=a(),void 0===e?n:r(n,e)}},function(t,e,n){var i=n(79),r=n(25),o=n(18),s=n(29),u=n(12),a=n(41),l=Object.getOwnPropertyDescriptor;e.f=n(4)?l:function(t,e){if(t=o(t),e=s(e,!0),a)try{return l(t,e)}catch(t){}if(u(t,e))return r(!i.f.call(t,e),t[e])}},function(t,e,n){var i=n(12),r=n(18),o=n(37)(!1),s=n(27)("IE_PROTO");t.exports=function(t,e){var n,u=r(t),a=0,l=[];for(n in u)n!=s&&i(u,n)&&l.push(n);for(;e.length>a;)i(u,n=e[a++])&&(~o(l,n)||l.push(n));return l}},function(t,e,n){var i=n(46),r=n(22);t.exports=Object.keys||function(t){return i(t,r)}},function(t,e,n){var i=n(2),r=n(5),o=n(43);t.exports=function(t,e){if(i(t),r(e)&&e.constructor===t)return e;var n=o.f(t);return(0,n.resolve)(e),n.promise}},function(t,e,n){var i=n(10),r=n(0),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});(t.exports=function(t,e){return o[t]||(o[t]=void 0!==e?e:{})})("versions",[]).push({version:i.version,mode:n(24)?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},function(t,e,n){var i=n(2),r=n(14),o=n(1)("species");t.exports=function(t,e){var n,s=i(t).constructor;return void 0===s||void 0==(n=i(s)[o])?e:r(n)}},function(t,e,n){var i=n(3),r=n(16),o=n(7),s=n(84),u="["+s+"]",a="​",l=RegExp("^"+u+u+"*"),c=RegExp(u+u+"*$"),f=function(t,e,n){var r={},u=o(function(){return!!s[t]()||a[t]()!=a}),l=r[t]=u?e(p):s[t];n&&(r[n]=l),i(i.P+i.F*u,"String",r)},p=f.trim=function(t,e){return t=String(r(t)),1&e&&(t=t.replace(l,"")),2&e&&(t=t.replace(c,"")),t};t.exports=f},function(t,e,n){var i,r,o,s=n(11),u=n(68),a=n(40),l=n(21),c=n(0),f=c.process,p=c.setImmediate,h=c.clearImmediate,d=c.MessageChannel,v=c.Dispatch,g=0,y={},m=function(){var t=+this;if(y.hasOwnProperty(t)){var e=y[t];delete y[t],e()}},b=function(t){m.call(t.data)};p&&h||(p=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return y[++g]=function(){u("function"==typeof t?t:Function(t),e)},i(g),g},h=function(t){delete y[t]},"process"==n(9)(f)?i=function(t){f.nextTick(s(m,t,1))}:v&&v.now?i=function(t){v.now(s(m,t,1))}:d?(r=new d,o=r.port2,r.port1.onmessage=b,i=s(o.postMessage,o,1)):c.addEventListener&&"function"==typeof postMessage&&!c.importScripts?(i=function(t){c.postMessage(t+"","*")},c.addEventListener("message",b,!1)):i="onreadystatechange"in l("script")?function(t){a.appendChild(l("script")).onreadystatechange=function(){a.removeChild(this),m.call(t)}}:function(t){setTimeout(s(m,t,1),0)}),t.exports={set:p,clear:h}},function(t,e){var n=Math.ceil,i=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?i:n)(t)}},function(t,e,n){"use strict";var i=n(3),r=n(20)(5),o=!0;"find"in[]&&Array(1).find(function(){o=!1}),i(i.P+i.F*o,"Array",{find:function(t){return r(this,t,arguments.length>1?arguments[1]:void 0)}}),n(36)("find")},function(t,e,n){"use strict";var i,r,o,s,u=n(24),a=n(0),l=n(11),c=n(38),f=n(3),p=n(5),h=n(14),d=n(61),v=n(66),g=n(50),y=n(52).set,m=n(75)(),b=n(43),_=n(80),x=n(86),w=n(48),S=a.TypeError,O=a.process,L=O&&O.versions,k=L&&L.v8||"",P=a.Promise,T="process"==c(O),V=function(){},E=r=b.f,A=!!function(){try{var t=P.resolve(1),e=(t.constructor={})[n(1)("species")]=function(t){t(V,V)};return(T||"function"==typeof PromiseRejectionEvent)&&t.then(V)instanceof e&&0!==k.indexOf("6.6")&&-1===x.indexOf("Chrome/66")}catch(t){}}(),C=function(t){var e;return!(!p(t)||"function"!=typeof(e=t.then))&&e},D=function(t,e){if(!t._n){t._n=!0;var n=t._c;m(function(){for(var i=t._v,r=1==t._s,o=0;n.length>o;)!function(e){var n,o,s,u=r?e.ok:e.fail,a=e.resolve,l=e.reject,c=e.domain;try{u?(r||(2==t._h&&$(t),t._h=1),!0===u?n=i:(c&&c.enter(),n=u(i),c&&(c.exit(),s=!0)),n===e.promise?l(S("Promise-chain cycle")):(o=C(n))?o.call(n,a,l):a(n)):l(i)}catch(t){c&&!s&&c.exit(),l(t)}}(n[o++]);t._c=[],t._n=!1,e&&!t._h&&j(t)})}},j=function(t){y.call(a,function(){var e,n,i,r=t._v,o=N(t);if(o&&(e=_(function(){T?O.emit("unhandledRejection",r,t):(n=a.onunhandledrejection)?n({promise:t,reason:r}):(i=a.console)&&i.error&&i.error("Unhandled promise rejection",r)}),t._h=T||N(t)?2:1),t._a=void 0,o&&e.e)throw e.v})},N=function(t){return 1!==t._h&&0===(t._a||t._c).length},$=function(t){y.call(a,function(){var e;T?O.emit("rejectionHandled",t):(e=a.onrejectionhandled)&&e({promise:t,reason:t._v})})},F=function(t){var e=this;e._d||(e._d=!0,e=e._w||e,e._v=t,e._s=2,e._a||(e._a=e._c.slice()),D(e,!0))},M=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw S("Promise can't be resolved itself");(e=C(t))?m(function(){var i={_w:n,_d:!1};try{e.call(t,l(M,i,1),l(F,i,1))}catch(t){F.call(i,t)}}):(n._v=t,n._s=1,D(n,!1))}catch(t){F.call({_w:n,_d:!1},t)}}};A||(P=function(t){d(this,P,"Promise","_h"),h(t),i.call(this);try{t(l(M,this,1),l(F,this,1))}catch(t){F.call(this,t)}},i=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},i.prototype=n(81)(P.prototype,{then:function(t,e){var n=E(g(this,P));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=T?O.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&D(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),o=function(){var t=new i;this.promise=t,this.resolve=l(M,t,1),this.reject=l(F,t,1)},b.f=E=function(t){return t===P||t===s?new o(t):r(t)}),f(f.G+f.W+f.F*!A,{Promise:P}),n(26)(P,"Promise"),n(83)("Promise"),s=n(10).Promise,f(f.S+f.F*!A,"Promise",{reject:function(t){var e=E(this);return(0,e.reject)(t),e.promise}}),f(f.S+f.F*(u||!A),"Promise",{resolve:function(t){return w(u&&this===s?P:this,t)}}),f(f.S+f.F*!(A&&n(73)(function(t){P.all(t).catch(V)})),"Promise",{all:function(t){var e=this,n=E(e),i=n.resolve,r=n.reject,o=_(function(){var n=[],o=0,s=1;v(t,!1,function(t){var u=o++,a=!1;n.push(void 0),s++,e.resolve(t).then(function(t){a||(a=!0,n[u]=t,--s||i(n))},r)}),--s||i(n)});return o.e&&r(o.v),n.promise},race:function(t){var e=this,n=E(e),i=n.reject,r=_(function(){v(t,!1,function(t){e.resolve(t).then(n.resolve,i)})});return r.e&&i(r.v),n.promise}})},function(t,e,n){"use strict";var i=n(3),r=n(10),o=n(0),s=n(50),u=n(48);i(i.P+i.R,"Promise",{finally:function(t){var e=s(this,r.Promise||o.Promise),n="function"==typeof t;return this.then(n?function(n){return u(e,t()).then(function(){return n})}:t,n?function(n){return u(e,t()).then(function(){throw n})}:t)}})},function(t,e,n){"use strict";function i(t){n(99)}var r=n(35),o=n(101),s=n(100),u=i,a=s(r.a,o.a,!1,u,null,null);e.a=a.exports},function(t,e,n){"use strict";function i(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}e.a=i},function(t,e,n){"use strict";function i(t){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function r(t){return(r="function"==typeof Symbol&&"symbol"===i(Symbol.iterator)?function(t){return i(t)}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":i(t)})(t)}e.a=r},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=n(34),r=(n.n(i),n(55)),o=(n.n(r),n(56)),s=(n.n(o),n(57)),u=n(32),a=n(33);n.d(e,"Multiselect",function(){return s.a}),n.d(e,"multiselectMixin",function(){return u.a}),n.d(e,"pointerMixin",function(){return a.a}),e.default=s.a},function(t,e){t.exports=function(t,e,n,i){if(!(t instanceof e)||void 0!==i&&i in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){var i=n(14),r=n(28),o=n(23),s=n(19);t.exports=function(t,e,n,u,a){i(e);var l=r(t),c=o(l),f=s(l.length),p=a?f-1:0,h=a?-1:1;if(n<2)for(;;){if(p in c){u=c[p],p+=h;break}if(p+=h,a?p<0:f<=p)throw TypeError("Reduce of empty array with no initial value")}for(;a?p>=0:f>p;p+=h)p in c&&(u=e(u,c[p],p,l));return u}},function(t,e,n){var i=n(5),r=n(42),o=n(1)("species");t.exports=function(t){var e;return r(t)&&(e=t.constructor,"function"!=typeof e||e!==Array&&!r(e.prototype)||(e=void 0),i(e)&&null===(e=e[o])&&(e=void 0)),void 0===e?Array:e}},function(t,e,n){var i=n(63);t.exports=function(t,e){return new(i(t))(e)}},function(t,e,n){"use strict";var i=n(8),r=n(6),o=n(7),s=n(16),u=n(1);t.exports=function(t,e,n){var a=u(t),l=n(s,a,""[t]),c=l[0],f=l[1];o(function(){var e={};return e[a]=function(){return 7},7!=""[t](e)})&&(r(String.prototype,t,c),i(RegExp.prototype,a,2==e?function(t,e){return f.call(t,this,e)}:function(t){return f.call(t,this)}))}},function(t,e,n){var i=n(11),r=n(70),o=n(69),s=n(2),u=n(19),a=n(87),l={},c={},e=t.exports=function(t,e,n,f,p){var h,d,v,g,y=p?function(){return t}:a(t),m=i(n,f,e?2:1),b=0;if("function"!=typeof y)throw TypeError(t+" is not iterable!");if(o(y)){for(h=u(t.length);h>b;b++)if((g=e?m(s(d=t[b])[0],d[1]):m(t[b]))===l||g===c)return g}else for(v=y.call(t);!(d=v.next()).done;)if((g=r(v,m,d.value,e))===l||g===c)return g};e.BREAK=l,e.RETURN=c},function(t,e,n){var i=n(5),r=n(82).set;t.exports=function(t,e,n){var o,s=e.constructor;return s!==n&&"function"==typeof s&&(o=s.prototype)!==n.prototype&&i(o)&&r&&r(t,o),t}},function(t,e){t.exports=function(t,e,n){var i=void 0===n;switch(e.length){case 0:return i?t():t.call(n);case 1:return i?t(e[0]):t.call(n,e[0]);case 2:return i?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return i?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return i?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var i=n(15),r=n(1)("iterator"),o=Array.prototype;t.exports=function(t){return void 0!==t&&(i.Array===t||o[r]===t)}},function(t,e,n){var i=n(2);t.exports=function(t,e,n,r){try{return r?e(i(n)[0],n[1]):e(n)}catch(e){var o=t.return;throw void 0!==o&&i(o.call(t)),e}}},function(t,e,n){"use strict";var i=n(44),r=n(25),o=n(26),s={};n(8)(s,n(1)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=i(s,{next:r(1,n)}),o(t,e+" Iterator")}},function(t,e,n){"use strict";var i=n(24),r=n(3),o=n(6),s=n(8),u=n(15),a=n(71),l=n(26),c=n(78),f=n(1)("iterator"),p=!([].keys&&"next"in[].keys()),h=function(){return this};t.exports=function(t,e,n,d,v,g,y){a(n,e,d);var m,b,_,x=function(t){if(!p&&t in L)return L[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},w=e+" Iterator",S="values"==v,O=!1,L=t.prototype,k=L[f]||L["@@iterator"]||v&&L[v],P=k||x(v),T=v?S?x("entries"):P:void 0,V="Array"==e?L.entries||k:k;if(V&&(_=c(V.call(new t)))!==Object.prototype&&_.next&&(l(_,w,!0),i||"function"==typeof _[f]||s(_,f,h)),S&&k&&"values"!==k.name&&(O=!0,P=function(){return k.call(this)}),i&&!y||!p&&!O&&L[f]||s(L,f,P),u[e]=P,u[w]=h,v)if(m={values:S?P:x("values"),keys:g?P:x("keys"),entries:T},y)for(b in m)b in L||o(L,b,m[b]);else r(r.P+r.F*(p||O),e,m);return m}},function(t,e,n){var i=n(1)("iterator"),r=!1;try{var o=[7][i]();o.return=function(){r=!0},Array.from(o,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!r)return!1;var n=!1;try{var o=[7],s=o[i]();s.next=function(){return{done:n=!0}},o[i]=function(){return s},t(o)}catch(t){}return n}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){var i=n(0),r=n(52).set,o=i.MutationObserver||i.WebKitMutationObserver,s=i.process,u=i.Promise,a="process"==n(9)(s);t.exports=function(){var t,e,n,l=function(){var i,r;for(a&&(i=s.domain)&&i.exit();t;){r=t.fn,t=t.next;try{r()}catch(i){throw t?n():e=void 0,i}}e=void 0,i&&i.enter()};if(a)n=function(){s.nextTick(l)};else if(!o||i.navigator&&i.navigator.standalone)if(u&&u.resolve){var c=u.resolve(void 0);n=function(){c.then(l)}}else n=function(){r.call(i,l)};else{var f=!0,p=document.createTextNode("");new o(l).observe(p,{characterData:!0}),n=function(){p.data=f=!f}}return function(i){var r={fn:i,next:void 0};e&&(e.next=r),t||(t=r,n()),e=r}}},function(t,e,n){var i=n(13),r=n(2),o=n(47);t.exports=n(4)?Object.defineProperties:function(t,e){r(t);for(var n,s=o(e),u=s.length,a=0;u>a;)i.f(t,n=s[a++],e[n]);return t}},function(t,e,n){var i=n(46),r=n(22).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return i(t,r)}},function(t,e,n){var i=n(12),r=n(28),o=n(27)("IE_PROTO"),s=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=r(t),i(t,o)?t[o]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?s:null}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},function(t,e,n){var i=n(6);t.exports=function(t,e,n){for(var r in e)i(t,r,e[r],n);return t}},function(t,e,n){var i=n(5),r=n(2),o=function(t,e){if(r(t),!i(e)&&null!==e)throw TypeError(e+": can't set as prototype!")};t.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(t,e,i){try{i=n(11)(Function.call,n(45).f(Object.prototype,"__proto__").set,2),i(t,[]),e=!(t instanceof Array)}catch(t){e=!0}return function(t,n){return o(t,n),e?t.__proto__=n:i(t,n),t}}({},!1):void 0),check:o}},function(t,e,n){"use strict";var i=n(0),r=n(13),o=n(4),s=n(1)("species");t.exports=function(t){var e=i[t];o&&e&&!e[s]&&r.f(e,s,{configurable:!0,get:function(){return this}})}},function(t,e){t.exports="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff"},function(t,e,n){var i=n(53),r=Math.max,o=Math.min;t.exports=function(t,e){return t=i(t),t<0?r(t+e,0):o(t,e)}},function(t,e,n){var i=n(0),r=i.navigator;t.exports=r&&r.userAgent||""},function(t,e,n){var i=n(38),r=n(1)("iterator"),o=n(15);t.exports=n(10).getIteratorMethod=function(t){if(void 0!=t)return t[r]||t["@@iterator"]||o[i(t)]}},function(t,e,n){"use strict";var i=n(3),r=n(20)(2);i(i.P+i.F*!n(17)([].filter,!0),"Array",{filter:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(3),r=n(37)(!1),o=[].indexOf,s=!!o&&1/[1].indexOf(1,-0)<0;i(i.P+i.F*(s||!n(17)(o)),"Array",{indexOf:function(t){return s?o.apply(this,arguments)||0:r(this,t,arguments[1])}})},function(t,e,n){var i=n(3);i(i.S,"Array",{isArray:n(42)})},function(t,e,n){"use strict";var i=n(3),r=n(20)(1);i(i.P+i.F*!n(17)([].map,!0),"Array",{map:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(3),r=n(62);i(i.P+i.F*!n(17)([].reduce,!0),"Array",{reduce:function(t){return r(this,t,arguments.length,arguments[1],!1)}})},function(t,e,n){var i=Date.prototype,r=i.toString,o=i.getTime;new Date(NaN)+""!="Invalid Date"&&n(6)(i,"toString",function(){var t=o.call(this);return t===t?r.call(this):"Invalid Date"})},function(t,e,n){n(4)&&"g"!=/./g.flags&&n(13).f(RegExp.prototype,"flags",{configurable:!0,get:n(39)})},function(t,e,n){n(65)("search",1,function(t,e,n){return[function(n){"use strict";var i=t(this),r=void 0==n?void 0:n[e];return void 0!==r?r.call(n,i):new RegExp(n)[e](String(i))},n]})},function(t,e,n){"use strict";n(94);var i=n(2),r=n(39),o=n(4),s=/./.toString,u=function(t){n(6)(RegExp.prototype,"toString",t,!0)};n(7)(function(){return"/a/b"!=s.call({source:"a",flags:"b"})})?u(function(){var t=i(this);return"/".concat(t.source,"/","flags"in t?t.flags:!o&&t instanceof RegExp?r.call(t):void 0)}):"toString"!=s.name&&u(function(){return s.call(this)})},function(t,e,n){"use strict";n(51)("trim",function(t){return function(){return t(this,3)}})},function(t,e,n){for(var i=n(34),r=n(47),o=n(6),s=n(0),u=n(8),a=n(15),l=n(1),c=l("iterator"),f=l("toStringTag"),p=a.Array,h={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},d=r(h),v=0;v<d.length;v++){var g,y=d[v],m=h[y],b=s[y],_=b&&b.prototype;if(_&&(_[c]||u(_,c,p),_[f]||u(_,f,y),a[y]=p,m))for(g in i)_[g]||o(_,g,i[g],!0)}},function(t,e){},function(t,e){t.exports=function(t,e,n,i,r,o){var s,u=t=t||{},a=typeof t.default;"object"!==a&&"function"!==a||(s=t,u=t.default);var l="function"==typeof u?u.options:u;e&&(l.render=e.render,l.staticRenderFns=e.staticRenderFns,l._compiled=!0),n&&(l.functional=!0),r&&(l._scopeId=r);var c;if(o?(c=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},l._ssrRegister=c):i&&(c=i),c){var f=l.functional,p=f?l.render:l.beforeCreate;f?(l._injectStyles=c,l.render=function(t,e){return c.call(e),p(t,e)}):l.beforeCreate=p?[].concat(p,c):[c]}return{esModule:s,exports:u,options:l}}},function(t,e,n){"use strict";var i=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"multiselect",class:{"multiselect--active":t.isOpen,"multiselect--disabled":t.disabled,"multiselect--above":t.isAbove},attrs:{tabindex:t.searchable?-1:t.tabindex},on:{focus:function(e){t.activate()},blur:function(e){!t.searchable&&t.deactivate()},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"down",40,e.key,["Down","ArrowDown"])?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerForward()):null},function(e){return"button"in e||!t._k(e.keyCode,"up",38,e.key,["Up","ArrowUp"])?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerBackward()):null}],keypress:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")||!t._k(e.keyCode,"tab",9,e.key,"Tab")?(e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27,e.key,"Escape"))return null;t.deactivate()}}},[t._t("caret",[n("div",{staticClass:"multiselect__select",on:{mousedown:function(e){e.preventDefault(),e.stopPropagation(),t.toggle()}}})],{toggle:t.toggle}),t._v(" "),t._t("clear",null,{search:t.search}),t._v(" "),n("div",{ref:"tags",staticClass:"multiselect__tags"},[t._t("selection",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.visibleValues.length>0,expression:"visibleValues.length > 0"}],staticClass:"multiselect__tags-wrap"},[t._l(t.visibleValues,function(e,i){return[t._t("tag",[n("span",{key:i,staticClass:"multiselect__tag"},[n("span",{domProps:{textContent:t._s(t.getOptionLabel(e))}}),t._v(" "),n("i",{staticClass:"multiselect__tag-icon",attrs:{"aria-hidden":"true",tabindex:"1"},on:{keypress:function(n){if(!("button"in n)&&t._k(n.keyCode,"enter",13,n.key,"Enter"))return null;n.preventDefault(),t.removeElement(e)},mousedown:function(n){n.preventDefault(),t.removeElement(e)}}})])],{option:e,search:t.search,remove:t.removeElement})]})],2),t._v(" "),t.internalValue&&t.internalValue.length>t.limit?[t._t("limit",[n("strong",{staticClass:"multiselect__strong",domProps:{textContent:t._s(t.limitText(t.internalValue.length-t.limit))}})])]:t._e()],{search:t.search,remove:t.removeElement,values:t.visibleValues,isOpen:t.isOpen}),t._v(" "),n("transition",{attrs:{name:"multiselect__loading"}},[t._t("loading",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.loading,expression:"loading"}],staticClass:"multiselect__spinner"})])],2),t._v(" "),t.searchable?n("input",{ref:"search",staticClass:"multiselect__input",style:t.inputStyle,attrs:{name:t.name,id:t.id,type:"text",autocomplete:"nope",placeholder:t.placeholder,disabled:t.disabled,tabindex:t.tabindex},domProps:{value:t.search},on:{input:function(e){t.updateSearch(e.target.value)},focus:function(e){e.preventDefault(),t.activate()},blur:function(e){e.preventDefault(),t.deactivate()},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27,e.key,"Escape"))return null;t.deactivate()},keydown:[function(e){if(!("button"in e)&&t._k(e.keyCode,"down",40,e.key,["Down","ArrowDown"]))return null;e.preventDefault(),t.pointerForward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"up",38,e.key,["Up","ArrowUp"]))return null;e.preventDefault(),t.pointerBackward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"delete",[8,46],e.key,["Backspace","Delete"]))return null;e.stopPropagation(),t.removeLastElement()}],keypress:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")?(e.preventDefault(),e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null}}}):t._e(),t._v(" "),t.isSingleLabelVisible?n("span",{staticClass:"multiselect__single",on:{mousedown:function(e){return e.preventDefault(),t.toggle(e)}}},[t._t("singleLabel",[[t._v(t._s(t.currentOptionLabel))]],{option:t.singleValue})],2):t._e(),t._v(" "),t.isPlaceholderVisible?n("span",{staticClass:"multiselect__placeholder",on:{mousedown:function(e){return e.preventDefault(),t.toggle(e)}}},[t._t("placeholder",[t._v("\n          "+t._s(t.placeholder)+"\n        ")])],2):t._e()],2),t._v(" "),n("transition",{attrs:{name:"multiselect"}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t.isOpen,expression:"isOpen"}],ref:"list",staticClass:"multiselect__content-wrapper",style:{maxHeight:t.optimizedHeight+"px"},attrs:{tabindex:"-1"},on:{focus:t.activate,mousedown:function(t){t.preventDefault()}}},[n("ul",{staticClass:"multiselect__content",style:t.contentStyle},[t._t("beforeList"),t._v(" "),t.multiple&&t.max===t.internalValue.length?n("li",[n("span",{staticClass:"multiselect__option"},[t._t("maxElements",[t._v("Maximum of "+t._s(t.max)+" options selected. First remove a selected option to select another.")])],2)]):t._e(),t._v(" "),!t.max||t.internalValue.length<t.max?t._l(t.filteredOptions,function(e,i){return n("li",{key:i,staticClass:"multiselect__element"},[e&&(e.$isLabel||e.$isDisabled)?t._e():n("span",{staticClass:"multiselect__option",class:t.optionHighlight(i,e),attrs:{"data-select":e&&e.isTag?t.tagPlaceholder:t.selectLabelText,"data-selected":t.selectedLabelText,"data-deselect":t.deselectLabelText},on:{click:function(n){n.stopPropagation(),t.select(e)},mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.pointerSet(i)}}},[t._t("option",[n("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2),t._v(" "),e&&(e.$isLabel||e.$isDisabled)?n("span",{staticClass:"multiselect__option",class:t.groupHighlight(i,e),attrs:{"data-select":t.groupSelect&&t.selectGroupLabelText,"data-deselect":t.groupSelect&&t.deselectGroupLabelText},on:{mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.groupSelect&&t.pointerSet(i)},mousedown:function(n){n.preventDefault(),t.selectGroup(e)}}},[t._t("option",[n("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2):t._e()])}):t._e(),t._v(" "),n("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoResults&&0===t.filteredOptions.length&&t.search&&!t.loading,expression:"showNoResults && (filteredOptions.length === 0 && search && !loading)"}]},[n("span",{staticClass:"multiselect__option"},[t._t("noResult",[t._v("No elements found. Consider changing the search query.")],{search:t.search})],2)]),t._v(" "),n("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoOptions&&0===t.options.length&&!t.search&&!t.loading,expression:"showNoOptions && (options.length === 0 && !search && !loading)"}]},[n("span",{staticClass:"multiselect__option"},[t._t("noOptions",[t._v("List is empty.")])],2)]),t._v(" "),t._t("afterList")],2)])])],2)},r=[],o={render:i,staticRenderFns:r};e.a=o}])});

/***/ }),

/***/ "RY/4":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("R9M2");
var TAG = __webpack_require__("dSzd")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "Re3r":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "Rf8U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(o){return typeof o}:function(o){return o&&"function"==typeof Symbol&&o.constructor===Symbol&&o!==Symbol.prototype?"symbol":typeof o};!function(){function o(e,t){if(!o.installed){if(o.installed=!0,!t)return void console.error("You have to install axios");e.axios=t,Object.defineProperties(e.prototype,{axios:{get:function(){return t}},$http:{get:function(){return t}}})}}"object"==( false?"undefined":_typeof(exports))?module.exports=o: true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function(){return o}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):window.Vue&&window.axios&&Vue.use(o,window.axios)}();

/***/ }),

/***/ "RgNN":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(986);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 973:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2UxK");

/***/ }),

/***/ 986:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(973) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	(function($, undefined) {

	var kendo = window.kendo,
	    extend = $.extend,
	    proxy = $.proxy,
	    Editor = kendo.ui.editor,
	    EditorUtils = Editor.EditorUtils,
	    Command = Editor.Command,
	    Tool = Editor.Tool,
	    registerTool = EditorUtils.registerTool,
	    ToolTemplate = Editor.ToolTemplate,
	    loadingOverlay = '<div contenteditable="false" class="k-loading-mask" style="width: 100%; height: 100%; position: absolute; top: 0px; left: 0px;"><div class="k-loading-image"></div><div class="k-loading-color"></div></div>';

	var ImportCommand = Command.extend({
	    exec: function() {
	        (this.editor._uploadWidget || this._initializeUploadWidget()).element.click();
	    },

	    _initializeUploadWidget: function(){
	        var cmd = this;
	        var editor = cmd.editor;
	        var importOptions = editor.options["import"];
	        var upload = $('<input id="editorImport" name="files" type="file" />').kendoUpload({
	            success: proxy(cmd._onUploadSuccess, cmd),
	            progress: proxy(cmd._onUploadProgress, cmd),
	            select: proxy(cmd._onUploadSelect, cmd),
	            error: proxy(cmd._onUploadError, cmd),
	            complete: proxy(cmd._onUploadComplete, cmd),
	            showFileList: false,
	            multiple: false,
	            async: {
	                saveUrl:  importOptions.proxyUrl,
	                autoUpload: true,
	                saveField: "file"
	            },
	            validation: {
	                allowedExtensions: importOptions.allowedExtensions,
	                maxFileSize: importOptions.maxFileSize
	            }
	        }).getKendoUpload();

	        editor._uploadWidget = upload;

	        return upload;
	    },
	    _onUploadComplete: function(ev){
	        this._trigger("complete", ev);
	        ev.sender.clearAllFiles();

	        this._removeLoadingOverlay();
	    },
	    _onUploadSuccess: function(ev){
	        this.editor.value(ev.response.html.replace(/<\/?body>/ig, ""));
	        this._trigger("success", ev);
	    },
	    _onUploadProgress: function(ev){
	        this._trigger("progress", ev);
	    },
	    _onUploadSelect: function(ev){
	        this._trigger("select", ev);
	        if (!ev.files[0].validationErrors) {
	            this._initLoadingOverlay();
	        }
	    },
	    _onUploadError: function(ev){
	        this._trigger("error", ev);
	    },

	    _trigger: function(eventType, uploadEvent) {
	        var editor = this.editor;
	        var importOptions = editor.options["import"];
	        if (typeof importOptions[eventType] === "function") {
	            importOptions[eventType].call(editor, uploadEvent);
	        }
	    },

	    _initLoadingOverlay: function (){
	        var editable = this.editor.body;
	        if (Editor.Dom.is(editable, "body")) {
	            this._iframeWrapper = this._container =
	                this.editor.wrapper.find("iframe").parent()
	                .css({position: "relative"}).append(loadingOverlay);
	        } else {
	            this._container = $(editable).append(loadingOverlay);
	        }

	        kendo.ui.progress(this._container, true);
	    },

	    _removeLoadingOverlay: function(){
	        kendo.ui.progress(this._container, false);
	        $(this._iframeWrapper).css({
	            position: ""
	        });

	        delete this._container;
	        delete this._iframeWrapper;
	    }
	});

	extend(Editor, {
	    ImportCommand: ImportCommand
	});

	registerTool("import", new Tool({ command: ImportCommand, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Import"})}));

	}(window.kendo.jQuery));

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "RnIf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var VerticalStack = (function () {
    function VerticalStack() {
        this.isLayoutPanel = true;
        this.childPanels = [];
        this.eGui = document.createElement('div');
        this.eGui.style.height = '100%';
    }
    VerticalStack.prototype.addPanel = function (panel, height) {
        var component;
        if (panel.isLayoutPanel) {
            this.childPanels.push(panel);
            component = panel.getGui();
        }
        else {
            component = panel;
        }
        if (height) {
            component.style.height = height;
        }
        this.eGui.appendChild(component);
    };
    VerticalStack.prototype.getGui = function () {
        return this.eGui;
    };
    VerticalStack.prototype.doLayout = function () {
        for (var i = 0; i < this.childPanels.length; i++) {
            this.childPanels[i].doLayout();
        }
    };
    return VerticalStack;
}());
exports.VerticalStack = VerticalStack;


/***/ }),

/***/ "RnqI":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1330);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1069:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("jBxA");

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Dz7c");

/***/ }),

/***/ 1106:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("iFTV");

/***/ }),

/***/ 1330:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1104), __webpack_require__(1069), __webpack_require__(1106) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.view",
	    name: "View",
	    category: "mobile",
	    description: "Mobile View",
	    depends: [ "core", "fx", "mobile.scroller", "view" ],
	    hidden: true
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        mobile = kendo.mobile,
	        ui = mobile.ui,
	        attr = kendo.attr,
	        Widget = ui.Widget,
	        ViewClone = kendo.ViewClone,
	        INIT = "init",
	        UI_OVERLAY = '<div style="height: 100%; width: 100%; position: absolute; top: 0; left: 0; z-index: 20000; display: none"></div>',
	        BEFORE_SHOW = "beforeShow",
	        SHOW = "show",
	        AFTER_SHOW = "afterShow",
	        BEFORE_HIDE = "beforeHide",
	        TRANSITION_END = "transitionEnd",
	        TRANSITION_START = "transitionStart",
	        HIDE = "hide",
	        DESTROY = "destroy",
	        attrValue = kendo.attrValue,
	        roleSelector = kendo.roleSelector,
	        directiveSelector = kendo.directiveSelector,
	        compileMobileDirective = kendo.compileMobileDirective;

	    function initPopOvers(element) {
	        var popovers = element.find(roleSelector("popover")),
	            idx, length,
	            roles = ui.roles;

	        for (idx = 0, length = popovers.length; idx < length; idx ++) {
	            kendo.initWidget(popovers[idx], {}, roles);
	        }
	    }

	    function preventScrollIfNotInput(e) {
	        if (!kendo.triggeredByInput(e)) {
	            e.preventDefault();
	        }
	    }

	    var View = Widget.extend({
	        init: function(element, options) {
	            Widget.fn.init.call(this, element, options);
	            this.params = {};

	            $.extend(this, options);

	            this.transition = this.transition || this.defaultTransition;

	            this._id();

	            if (!this.options.$angular) {
	                this._layout();
	                this._overlay();
	                this._scroller();
	                this._model();
	            } else {
	                this._overlay();
	            }
	        },

	        events: [
	            INIT,
	            BEFORE_SHOW,
	            SHOW,
	            AFTER_SHOW,
	            BEFORE_HIDE,
	            HIDE,
	            DESTROY,
	            TRANSITION_START,
	            TRANSITION_END
	        ],

	        options: {
	            name: "View",
	            title: "",
	            layout: null,
	            getLayout: $.noop,
	            reload: false,
	            transition: "",
	            defaultTransition: "",
	            useNativeScrolling: false,
	            stretch: false,
	            zoom: false,
	            model: null,
	            modelScope: window,
	            scroller: {},
	            initWidgets: true
	        },

	        enable: function(enable) {
	            if(typeof enable == "undefined") {
	                enable = true;
	            }

	            if(enable) {
	                this.overlay.hide();
	            } else {
	                this.overlay.show();
	            }
	        },

	        destroy: function() {
	            if (this.layout) {
	                this.layout.detach(this);
	            }

	            this.trigger(DESTROY);


	            Widget.fn.destroy.call(this);

	            if (this.scroller) {
	                this.scroller.destroy();
	            }

	            if (this.options.$angular) {
	                this.element.scope().$destroy();
	            }

	            kendo.destroy(this.element);
	        },

	        purge: function() {
	            this.destroy();
	            this.element.remove();
	        },

	        triggerBeforeShow: function() {
	            if (this.trigger(BEFORE_SHOW, { view: this })) {
	                return false;
	            }
	            return true;
	        },

	        triggerBeforeHide: function() {
	            if (this.trigger(BEFORE_HIDE, { view: this })) {
	                return false;
	            }
	            return true;
	        },

	        showStart: function() {
	            var element = this.element;

	            element.css("display", "");

	            if (!this.inited) {
	                this.inited = true;
	                this.trigger(INIT, {view: this});
	            } else { // skip the initial controller update
	                this._invokeNgController();
	            }

	            if (this.layout) {
	                this.layout.attach(this);
	            }

	            this._padIfNativeScrolling();
	            this.trigger(SHOW, {view: this});
	            kendo.resize(element);
	        },

	        showEnd: function() {
	            this.trigger(AFTER_SHOW, {view: this});
	            this._padIfNativeScrolling();
	        },

	        hideEnd: function() {
	            var that = this;
	            that.element.hide();
	            that.trigger(HIDE, {view: that});

	            if (that.layout) {
	                that.layout.trigger(HIDE, { view : that, layout: that.layout });
	            }
	        },

	        beforeTransition: function(type){
	            this.trigger(TRANSITION_START, { type: type });
	        },

	        afterTransition: function(type){
	            this.trigger(TRANSITION_END, { type: type });
	        },

	        _padIfNativeScrolling: function() {
	            if (mobile.appLevelNativeScrolling()) {
	                var isAndroid = kendo.support.mobileOS && kendo.support.mobileOS.android,
	                    skin = mobile.application.skin() || "",
	                    isAndroidForced = mobile.application.os.android || (skin.indexOf("android") > -1),
	                    hasPlatformIndependentSkin = skin === "flat" || (skin.indexOf("material") > -1),
	                    topContainer = (isAndroid || isAndroidForced) && (!hasPlatformIndependentSkin) ? "footer" : "header",
	                    bottomContainer = (isAndroid || isAndroidForced) && (!hasPlatformIndependentSkin) ? "header" : "footer";

	                this.content.css({
	                    paddingTop: this[topContainer].height(),
	                    paddingBottom: this[bottomContainer].height()
	                });
	            }
	        },

	        contentElement: function() {
	            var that = this;

	            return that.options.stretch ? that.content : that.scrollerContent;
	        },

	        clone: function() {
	            return new ViewClone(this);
	        },

	        _scroller: function() {
	            var that = this;

	            if (mobile.appLevelNativeScrolling()) {
	                return;
	            }
	            if (that.options.stretch) {
	                that.content.addClass("km-stretched-view");
	            } else {
	                that.content.kendoMobileScroller($.extend(that.options.scroller, { zoom: that.options.zoom, useNative: that.options.useNativeScrolling }));

	                that.scroller = that.content.data("kendoMobileScroller");
	                that.scrollerContent = that.scroller.scrollElement;
	            }

	            // prevent accidental address bar display when pulling the header
	            if (kendo.support.kineticScrollNeeded) {
	                $(that.element).on("touchmove", ".km-header", preventScrollIfNotInput);
	                if (!that.options.useNativeScrolling && !that.options.stretch) {
	                    $(that.element).on("touchmove", ".km-content", preventScrollIfNotInput);
	                }
	            }
	        },

	        _model: function() {
	            var that = this,
	                element = that.element,
	                model = that.options.model;

	            if (typeof model === "string") {
	                model = kendo.getter(model)(that.options.modelScope);
	            }

	            that.model = model;

	            initPopOvers(element);

	            that.element.css("display", "");
	            if (that.options.initWidgets) {
	                if (model) {
	                    kendo.bind(element, model, ui, kendo.ui, kendo.dataviz.ui);
	                } else {
	                    mobile.init(element.children());
	                }
	            }
	            that.element.css("display", "none");
	        },

	        _id: function() {
	            var element = this.element,
	                idAttrValue = element.attr("id") || "";

	            this.id = attrValue(element, "url") || "#" + idAttrValue;

	            if (this.id == "#") {
	                this.id = kendo.guid();
	                element.attr("id", this.id);
	            }
	        },

	        _layout: function() {
	            var contentSelector = roleSelector("content"),
	                element = this.element;

	            element.addClass("km-view");

	            this.header = element.children(roleSelector("header")).addClass("km-header");
	            this.footer = element.children(roleSelector("footer")).addClass("km-footer");

	            if (!element.children(contentSelector)[0]) {
	              element.wrapInner("<div " + attr("role") + '="content"></div>');
	            }

	            this.content = element.children(roleSelector("content"))
	                                .addClass("km-content");

	            this.element.prepend(this.header).append(this.footer);


	            this.layout = this.options.getLayout(this.layout);

	            if (this.layout) {
	                this.layout.setup(this);
	            }
	        },

	        _overlay: function() {
	            this.overlay = $(UI_OVERLAY).appendTo(this.element);
	        },

	        _invokeNgController: function() {
	            var controller,
	                scope;

	            if (this.options.$angular) {
	                controller = this.element.controller();
	                scope = this.options.$angular[0];

	                if (controller) {
	                    var callback = $.proxy(this, '_callController', controller, scope);

	                    if (/^\$(digest|apply)$/.test(scope.$$phase)) {
	                        callback();
	                    } else {
	                        scope.$apply(callback);
	                    }
	                }
	            }
	        },

	        _callController: function(controller, scope) {
	            this.element.injector().invoke(controller.constructor, controller, { $scope: scope });
	        }
	    });

	    function initWidgets(collection) {
	        collection.each(function() {
	            kendo.initWidget($(this), {}, ui.roles);
	        });
	    }

	    var Layout = Widget.extend({
	        init: function(element, options) {
	            Widget.fn.init.call(this, element, options);

	            element = this.element;

	            this.header = element.children(this._locate("header")).addClass("km-header");
	            this.footer = element.children(this._locate("footer")).addClass("km-footer");
	            this.elements = this.header.add(this.footer);

	            initPopOvers(element);

	            if (!this.options.$angular) {
	                kendo.mobile.init(this.element.children());
	            }
	            this.element.detach();
	            this.trigger(INIT, {layout: this});
	        },

	        _locate: function(selectors) {
	            return this.options.$angular ? directiveSelector(selectors) : roleSelector(selectors);
	        },

	        options: {
	            name: "Layout",
	            id: null,
	            platform: null
	        },

	        events: [
	            INIT,
	            SHOW,
	            HIDE
	        ],

	        setup: function(view) {
	            if (!view.header[0]) { view.header = this.header; }
	            if (!view.footer[0]) { view.footer = this.footer; }
	        },

	        detach: function(view) {
	            var that = this;
	            if (view.header === that.header && that.header[0]) {
	                view.element.prepend(that.header.detach()[0].cloneNode(true));
	            }

	            if (view.footer === that.footer && that.footer.length) {
	                view.element.append(that.footer.detach()[0].cloneNode(true));
	            }
	        },

	        attach: function(view) {
	            var that = this,
	                previousView = that.currentView;

	            if (previousView) {
	                that.detach(previousView);
	            }

	            if (view.header === that.header) {
	                that.header.detach();
	                view.element.children(roleSelector("header")).remove();
	                view.element.prepend(that.header);
	            }

	            if (view.footer === that.footer) {
	                that.footer.detach();
	                view.element.children(roleSelector("footer")).remove();
	                view.element.append(that.footer);
	            }

	            that.trigger(SHOW, {layout: that, view: view});
	            that.currentView = view;
	        }
	    });

	    var Observable = kendo.Observable,
	        bodyRegExp = /<body[^>]*>(([\u000a\u000d\u2028\u2029]|.)*)<\/body>/i,
	        LOAD_START = "loadStart",
	        LOAD_COMPLETE = "loadComplete",
	        SHOW_START = "showStart",
	        SAME_VIEW_REQUESTED = "sameViewRequested",
	        VIEW_SHOW = "viewShow",
	        VIEW_TYPE_DETERMINED = "viewTypeDetermined",
	        AFTER = "after";

	    var ViewEngine = Observable.extend({
	        init: function(options) {
	            var that = this,
	                views,
	                errorMessage,
	                container,
	                collection;

	            Observable.fn.init.call(that);

	            $.extend(that, options);
	            that.sandbox = $("<div />");
	            container = that.container;

	            views = that._hideViews(container);
	            that.rootView = views.first();

	            if (!that.rootView[0] && options.rootNeeded) {
	                if (container[0] == kendo.mobile.application.element[0]) {
	                    errorMessage = 'Your kendo mobile application element does not contain any direct child elements with data-role="view" attribute set. Make sure that you instantiate the mobile application using the correct container.';
	                } else {
	                    errorMessage = 'Your pane element does not contain any direct child elements with data-role="view" attribute set.';
	                }
	                throw new Error(errorMessage);
	            }

	            that.layouts = {};

	            that.viewContainer = new kendo.ViewContainer(that.container);

	            that.viewContainer.bind("accepted", function(e) {
	                e.view.params = that.params;
	            });

	            that.viewContainer.bind("complete", function(e) {
	                that.trigger(VIEW_SHOW, { view: e.view });
	            });

	            that.viewContainer.bind(AFTER, function() {
	                that.trigger(AFTER);
	            });

	            this.getLayoutProxy = $.proxy(this, "_getLayout");
	            that._setupLayouts(container);

	            collection = container.children(that._locate("modalview drawer"));
	            if (that.$angular) {

	                that.$angular[0].viewOptions = {
	                    defaultTransition: that.transition,
	                    loader: that.loader,
	                    container: that.container,
	                    getLayout: that.getLayoutProxy
	                };

	                collection.each(function(idx, element) {
	                    compileMobileDirective($(element), options.$angular[0]);
	                });
	            } else {
	                initWidgets(collection);
	            }

	            this.bind(this.events, options);
	        },

	        events: [
	            SHOW_START,
	            AFTER,
	            VIEW_SHOW,
	            LOAD_START,
	            LOAD_COMPLETE,
	            SAME_VIEW_REQUESTED,
	            VIEW_TYPE_DETERMINED
	        ],

	        destroy: function() {
	            kendo.destroy(this.container);

	            for (var id in this.layouts) {
	                this.layouts[id].destroy();
	            }
	        },

	        view: function() {
	            return this.viewContainer.view;
	        },

	        showView: function(url, transition, params) {
	            url = url.replace(new RegExp("^" + this.remoteViewURLPrefix), "");
	            if (url === "" && this.remoteViewURLPrefix) {
	                url = "/";
	            }

	            if (url.replace(/^#/, "") === this.url) {
	                this.trigger(SAME_VIEW_REQUESTED);
	                return false;
	            }

	            this.trigger(SHOW_START);

	            var that = this,
	                showClosure = function(view) {
	                    return that.viewContainer.show(view, transition, url);
	                },
	                element = that._findViewElement(url),
	                view = kendo.widgetInstance(element);

	            that.url = url.replace(/^#/, "");

	            that.params = params;

	            if (view && view.reload) {
	                view.purge();
	                element = [];
	            }

	            this.trigger(VIEW_TYPE_DETERMINED, { remote: element.length === 0, url: url });

	            if (element[0]) {
	                if (!view) {
	                    view = that._createView(element);
	                }

	                return showClosure(view);
	            } else {
	                if (this.serverNavigation) {
	                    location.href = url;
	                } else {
	                    that._loadView(url, showClosure);
	                }
	                return true;
	            }
	        },

	        append: function(html, url) {
	            var sandbox = this.sandbox,
	                urlPath = (url || "").split("?")[0],
	                container = this.container,
	                views,
	                modalViews,
	                view;

	            if (bodyRegExp.test(html)) {
	                html = RegExp.$1;
	            }

	            sandbox[0].innerHTML = html;

	            container.append(sandbox.children("script, style"));

	            views = this._hideViews(sandbox);
	            view = views.first();

	            // Generic HTML content found as remote view - no remote view markers
	            if (!view.length) {
	                views = view = sandbox.wrapInner("<div data-role=view />").children(); // one element
	            }

	            if (urlPath) {
	                view.hide().attr(attr("url"), urlPath);
	            }

	            this._setupLayouts(sandbox);

	            modalViews = sandbox.children(this._locate("modalview drawer"));

	            container.append(sandbox.children(this._locate("layout modalview drawer")).add(views));

	            // Initialize the modalviews after they have been appended to the final container
	            initWidgets(modalViews);

	            return this._createView(view);
	        },

	        _locate: function(selectors) {
	            return this.$angular ? directiveSelector(selectors) : roleSelector(selectors);
	        },

	        _findViewElement: function(url) {
	            var element,
	                urlPath = url.split("?")[0];

	            if (!urlPath) {
	                return this.rootView;
	            }

	            element = this.container.children("[" + attr("url") + "='" + urlPath + "']");

	            // do not try to search for "#/foo/bar" id, jQuery throws error
	            if (!element[0] && urlPath.indexOf("/") === -1) {
	                element = this.container.children(urlPath.charAt(0) === "#" ? urlPath : "#" + urlPath);
	            }

	            return element;
	        },

	        _createView: function(element) {
	            if (this.$angular) {
	                return compileMobileDirective(element, this.$angular[0]);
	            } else {
	                return kendo.initWidget(element, {
	                    defaultTransition: this.transition,
	                    loader: this.loader,
	                    container: this.container,
	                    getLayout: this.getLayoutProxy,
	                    modelScope: this.modelScope,
	                    reload: attrValue(element, "reload")
	                }, ui.roles);
	            }
	        },

	        _getLayout: function(name) {
	            if (name === "") {
	                return null;
	            }

	            return name ? this.layouts[name] : this.layouts[this.layout];
	        },

	        _loadView: function(url, callback) {
	            if (this._xhr) {
	                this._xhr.abort();
	            }

	            this.trigger(LOAD_START);

	            this._xhr = $.get(kendo.absoluteURL(url, this.remoteViewURLPrefix), "html")
	                .always($.proxy(this, "_xhrComplete", callback, url));
	        },

	        _xhrComplete: function(callback, url, response) {
	            var success = true;

	            if (typeof response === "object") {
	                if (response.status === 0) {
	                    if (response.responseText && response.responseText.length > 0) {
	                        success = true;
	                        response = response.responseText;
	                    } else { // request has been aborted for real
	                        return;
	                    }
	                }
	            }

	            this.trigger(LOAD_COMPLETE);

	            if (success) {
	                callback(this.append(response, url));
	            }
	        },

	        _hideViews: function(container) {
	            return container.children(this._locate("view splitview")).hide();
	        },

	        _setupLayouts: function(element) {
	            var that = this,
	                layout;

	            element.children(that._locate("layout")).each(function() {
	                if (that.$angular) {
	                    layout = compileMobileDirective($(this), that.$angular[0]);
	                } else {
	                    layout = kendo.initWidget($(this), {}, ui.roles);
	                }

	                var platform = layout.options.platform;

	                if (!platform || platform === mobile.application.os.name) {
	                    that.layouts[layout.options.id] = layout;
	                } else {
	                    layout.destroy();
	                }
	            });

	        }
	    });

	    kendo.mobile.ViewEngine = ViewEngine;

	    ui.plugin(View);
	    ui.plugin(Layout);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "RoH2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var column_1 = __webpack_require__("hDyE");
var utils_1 = __webpack_require__("IRr6");
var setLeftFeature_1 = __webpack_require__("yLI2");
var component_1 = __webpack_require__("pQ38");
var componentAnnotations_1 = __webpack_require__("x5ih");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var beans_1 = __webpack_require__("YaQm");
var BaseFilterWrapperComp = (function (_super) {
    __extends(BaseFilterWrapperComp, _super);
    function BaseFilterWrapperComp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseFilterWrapperComp.prototype.init = function (params) {
        this.column = params.column;
        var base = utils_1._.loadTemplate("<div class=\"ag-header-cell\" aria-hidden=\"true\"><div class=\"ag-floating-filter-body\" aria-hidden=\"true\"></div></div>");
        this.enrichBody(base);
        this.setTemplateFromElement(base);
        this.setupWidth();
        var setLeftFeature = new setLeftFeature_1.SetLeftFeature(this.column, this.getGui(), this.beans);
        setLeftFeature.init();
        this.addDestroyFunc(setLeftFeature.destroy.bind(setLeftFeature));
    };
    BaseFilterWrapperComp.prototype.setupWidth = function () {
        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_WIDTH_CHANGED, this.onColumnWidthChanged.bind(this));
        this.onColumnWidthChanged();
    };
    BaseFilterWrapperComp.prototype.onColumnWidthChanged = function () {
        this.getGui().style.width = this.column.getActualWidth() + 'px';
    };
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], BaseFilterWrapperComp.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('beans'),
        __metadata("design:type", beans_1.Beans)
    ], BaseFilterWrapperComp.prototype, "beans", void 0);
    return BaseFilterWrapperComp;
}(component_1.Component));
exports.BaseFilterWrapperComp = BaseFilterWrapperComp;
var FloatingFilterWrapperComp = (function (_super) {
    __extends(FloatingFilterWrapperComp, _super);
    function FloatingFilterWrapperComp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FloatingFilterWrapperComp.prototype.init = function (params) {
        this.floatingFilterCompPromise = params.floatingFilterComp;
        this.suppressFilterButton = params.suppressFilterButton;
        _super.prototype.init.call(this, params);
        this.addEventListeners();
    };
    FloatingFilterWrapperComp.prototype.addEventListeners = function () {
        if (!this.suppressFilterButton && this.eButtonShowMainFilter) {
            this.addDestroyableEventListener(this.eButtonShowMainFilter, 'click', this.showParentFilter.bind(this));
        }
    };
    FloatingFilterWrapperComp.prototype.enrichBody = function (body) {
        var _this = this;
        this.floatingFilterCompPromise.then(function (floatingFilterComp) {
            var floatingFilterBody = body.querySelector('.ag-floating-filter-body');
            var floatingFilterCompUi = floatingFilterComp.getGui();
            if (_this.suppressFilterButton) {
                floatingFilterBody.appendChild(floatingFilterCompUi);
                utils_1._.removeCssClass(floatingFilterBody, 'ag-floating-filter-body');
                utils_1._.addCssClass(floatingFilterBody, 'ag-floating-filter-full-body');
            }
            else {
                floatingFilterBody.appendChild(floatingFilterCompUi);
                body.appendChild(utils_1._.loadTemplate("<div class=\"ag-floating-filter-button\" aria-hidden=\"true\">\n                        <button ref=\"eButtonShowMainFilter\"></button>\n                </div>"));
                var eIcon = utils_1._.createIconNoSpan('filter', _this.gridOptionsWrapper, _this.column);
                body.querySelector('button').appendChild(eIcon);
            }
            if (floatingFilterComp.afterGuiAttached) {
                floatingFilterComp.afterGuiAttached();
            }
            _this.wireQuerySelectors();
            _this.addEventListeners();
        });
    };
    FloatingFilterWrapperComp.prototype.onParentModelChanged = function (parentModel) {
        this.floatingFilterCompPromise.then(function (floatingFilterComp) {
            floatingFilterComp.onParentModelChanged(parentModel);
        });
    };
    FloatingFilterWrapperComp.prototype.showParentFilter = function () {
        this.menuFactory.showMenuAfterButtonClick(this.column, this.eButtonShowMainFilter, 'filterMenuTab', ['filterMenuTab']);
    };
    __decorate([
        componentAnnotations_1.RefSelector('eButtonShowMainFilter'),
        __metadata("design:type", HTMLInputElement)
    ], FloatingFilterWrapperComp.prototype, "eButtonShowMainFilter", void 0);
    __decorate([
        context_1.Autowired('menuFactory'),
        __metadata("design:type", Object)
    ], FloatingFilterWrapperComp.prototype, "menuFactory", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], FloatingFilterWrapperComp.prototype, "gridOptionsWrapper", void 0);
    return FloatingFilterWrapperComp;
}(BaseFilterWrapperComp));
exports.FloatingFilterWrapperComp = FloatingFilterWrapperComp;
var EmptyFloatingFilterWrapperComp = (function (_super) {
    __extends(EmptyFloatingFilterWrapperComp, _super);
    function EmptyFloatingFilterWrapperComp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmptyFloatingFilterWrapperComp.prototype.enrichBody = function (body) {
    };
    EmptyFloatingFilterWrapperComp.prototype.onParentModelChanged = function (parentModel) {
    };
    return EmptyFloatingFilterWrapperComp;
}(BaseFilterWrapperComp));
exports.EmptyFloatingFilterWrapperComp = EmptyFloatingFilterWrapperComp;


/***/ }),

/***/ "Rqq1":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(914);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 914:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(915), __webpack_require__(916) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($, undefined) {
	    // Imports ================================================================
	    var proxy = $.proxy,

	        kendo = window.kendo,
	        Class = kendo.Class,

	        dataviz = kendo.dataviz,
	        deepExtend = kendo.deepExtend,

	        Extent = dataviz.map.Extent,

	        util = kendo.drawing.util,
	        defined = util.defined;

	    // Implementation =========================================================
	    var Layer = Class.extend({
	        init: function(map, options) {
	            this._initOptions(options);
	            this.map = map;

	            this.element = $("<div class='k-layer'></div>")
	               .css({
	                   "zIndex": this.options.zIndex,
	                   "opacity": this.options.opacity
	               })
	               .appendTo(map.scrollElement);

	            this._beforeReset = proxy(this._beforeReset, this);
	            this._reset = proxy(this._reset, this);
	            this._resize = proxy(this._resize, this);
	            this._panEnd = proxy(this._panEnd, this);
	            this._activate();

	            this._updateAttribution();
	        },

	        destroy: function() {
	            this._deactivate();
	        },

	        show: function() {
	            this.reset();
	            this._activate();
	            this._applyExtent(true);
	        },

	        hide: function() {
	            this._deactivate();
	            this._setVisibility(false);
	        },

	        reset: function() {
	            this._beforeReset();
	            this._reset();
	        },

	        _reset: function() {
	            this._applyExtent();
	        },

	        _beforeReset: $.noop,

	        _resize: $.noop,

	        _panEnd: function() {
	            this._applyExtent();
	        },

	        _applyExtent: function() {
	            var options = this.options;

	            var zoom = this.map.zoom();
	            var matchMinZoom = !defined(options.minZoom) || zoom >= options.minZoom;
	            var matchMaxZoom = !defined(options.maxZoom) || zoom <= options.maxZoom;

	            var extent = Extent.create(options.extent);
	            var inside = !extent || extent.overlaps(this.map.extent());

	            this._setVisibility(matchMinZoom && matchMaxZoom && inside);
	        },

	        _setVisibility: function(visible) {
	            this.element.css("display", visible ? "" : "none");
	        },

	        _activate: function() {
	            var map = this.map;
	            this._deactivate();
	            map.bind("beforeReset", this._beforeReset);
	            map.bind("reset", this._reset);
	            map.bind("resize", this._resize);
	            map.bind("panEnd", this._panEnd);
	        },

	        _deactivate: function() {
	            var map = this.map;
	            map.unbind("beforeReset", this._beforeReset);
	            map.unbind("reset", this._reset);
	            map.unbind("resize", this._resize);
	            map.unbind("panEnd", this._panEnd);
	        },

	        _updateAttribution: function() {
	            var attr = this.map.attribution;

	            if (attr) {
	                attr.add(this.options.attribution);
	            }
	        }
	    });

	    // Exports ================================================================
	    deepExtend(dataviz, {
	        map: {
	            layers: {
	                Layer: Layer
	            }
	        }
	    });

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 915:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 916:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("pV45");

/***/ })

/******/ });

/***/ }),

/***/ "S/9S":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1284);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1284:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1059), __webpack_require__(1086) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "list",
	    name: "List",
	    category: "framework",
	    depends: [ "data", "popup" ],
	    hidden: true
	};

	/*jshint evil: true*/
	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        outerHeight = kendo._outerHeight,
	        percentageUnitsRegex = /^\d+(\.\d+)?%$/i,
	        Widget = ui.Widget,
	        keys = kendo.keys,
	        support = kendo.support,
	        htmlEncode = kendo.htmlEncode,
	        activeElement = kendo._activeElement,
	        outerWidth = kendo._outerWidth,
	        ObservableArray = kendo.data.ObservableArray,
	        ID = "id",
	        CHANGE = "change",
	        FOCUSED = "k-state-focused",
	        HOVER = "k-state-hover",
	        LOADING = "k-i-loading",
	        GROUPHEADER = ".k-group-header",
	        ITEMSELECTOR = ".k-item",
	        LABELIDPART = "_label",
	        OPEN = "open",
	        CLOSE = "close",
	        CASCADE = "cascade",
	        SELECT = "select",
	        SELECTED = "selected",
	        REQUESTSTART = "requestStart",
	        REQUESTEND = "requestEnd",
	        BLUR = "blur",
	        FOCUS = "focus",
	        FOCUSOUT = "focusout",
	        extend = $.extend,
	        proxy = $.proxy,
	        isArray = $.isArray,
	        browser = support.browser,
	        HIDDENCLASS = "k-hidden",
	        WIDTH = "width",
	        isIE = browser.msie,
	        isIE8 = isIE && browser.version < 9,
	        quotRegExp = /"/g,
	        alternativeNames = {
	            "ComboBox": [ "DropDownList", "MultiColumnComboBox" ],
	            "DropDownList": [ "ComboBox", "MultiColumnComboBox" ],
	            "MultiColumnComboBox": [ "ComboBox", "DropDownList" ]
	        };

	    var List = kendo.ui.DataBoundWidget.extend({
	        init: function(element, options) {
	            var that = this,
	                ns = that.ns,
	                id;

	            Widget.fn.init.call(that, element, options);
	            element = that.element;
	            options = that.options;

	            that._isSelect = element.is(SELECT);

	            if (that._isSelect && that.element[0].length) {
	                if (!options.dataSource) {
	                    options.dataTextField = options.dataTextField || "text";
	                    options.dataValueField = options.dataValueField || "value";
	                }
	            }

	            that.ul = $('<ul unselectable="on" class="k-list k-reset"/>')
	                        .attr({
	                            tabIndex: -1,
	                            "aria-hidden": true
	                        });

	            that.list = $("<div class='k-list-container'/>")
	                        .append(that.ul)
	                        .on("mousedown" + ns, proxy(that._listMousedown, that));

	            id = element.attr(ID);

	            if (!id) {
	                id = kendo.guid();
	            }

	            that.list.attr(ID, id + "-list");
	            that.ul.attr(ID, id + "_listbox");

	            if (options.columns && options.columns.length) {
	                that.ul.removeClass("k-list").addClass("k-grid-list");
	                that._columnsHeader();
	            }

	            that._header();
	            that._noData();
	            that._footer();
	            that._accessors();
	            that._initValue();
	        },

	        options: {
	            valuePrimitive: false,
	            footerTemplate: "",
	            headerTemplate: "",
	            noDataTemplate: true,
	            messages: {
	                "noData": "No data found.",
	                "clear": "clear"
	            }
	        },

	        setOptions: function(options) {
	            Widget.fn.setOptions.call(this, options);

	            if (options && options.enable !== undefined) {
	                options.enabled = options.enable;
	            }

	            if (options.columns && options.columns.length) {
	                this._columnsHeader();
	            }

	            this._header();
	            this._noData();
	            this._footer();

	            this._renderFooter();
	            this._renderNoData();
	        },

	        focus: function() {
	            this._focused.focus();
	        },

	        readonly: function(readonly) {
	            this._editable({
	                readonly: readonly === undefined ? true : readonly,
	                disable: false
	            });
	        },

	        enable: function(enable) {
	            this._editable({
	                readonly: false,
	                disable: !(enable = enable === undefined ? true : enable)
	            });
	        },

	        _header: function() {
	            var list = this;
	            var header = $(list.header);
	            var template = list.options.headerTemplate;

	            this._angularElement(header, "cleanup");
	            kendo.destroy(header);
	            header.remove();

	            if (!template) {
	                list.header = null;
	                return;
	            }

	            var headerTemplate = typeof template !== "function" ? kendo.template(template) : template;
	            header = $(headerTemplate({}));

	            list.header = header[0] ? header : null;
	            list.list.prepend(header);

	            this._angularElement(list.header, "compile");
	        },

	        _columnsHeader: function() {
	            var list = this;
	            var columnsHeader = $(list.columnsHeader);

	            this._angularElement(columnsHeader, "cleanup");
	            kendo.destroy(columnsHeader);
	            columnsHeader.remove();

	            var header = "<div class='k-grid-header'><div class='k-grid-header-wrap'><table role='presentation'>";
	            var colGroup = "<colgroup>";
	            var row = "<tr>";

	            for (var idx = 0; idx < this.options.columns.length; idx++) {
	                var currentColumn = this.options.columns[idx];
	                var title = currentColumn.title || currentColumn.field || "";
	                var template = currentColumn.headerTemplate || title;
	                var columnsHeaderTemplate = typeof template !== "function" ? kendo.template(template) : template;
	                var currentWidth = currentColumn.width;
	                var currentWidthInt = parseInt(currentWidth, 10);
	                var widthStyle = '';

	                if (currentWidth && !isNaN(currentWidthInt)) {
	                    widthStyle += "style='width:";
	                    widthStyle += currentWidthInt;
	                    widthStyle += percentageUnitsRegex.test(currentWidth) ? "%" : "px";
	                    widthStyle += ";'";
	                }

	                colGroup += "<col " + widthStyle + "/>";

	                row += "<th class='k-header'>";
	                row += columnsHeaderTemplate(currentColumn);
	                row += "</th>";
	            }
	            colGroup += "</colgroup>";
	            row += "</tr>";
	            header += colGroup;
	            header += row;
	            header += "</table></div></div>";

	            list.columnsHeader = columnsHeader = $(header);
	            list.list.prepend(columnsHeader);

	            this._angularElement(list.columnsHeader, "compile");
	        },

	        _noData: function() {
	            var list = this;
	            var noData = $(list.noData);
	            var template = list.options.noDataTemplate === true ?  list.options.messages.noData : list.options.noDataTemplate;

	            list.angular("cleanup", function() { return { elements: noData }; });
	            kendo.destroy(noData);
	            noData.remove();

	            if (!template) {
	                list.noData = null;
	                return;
	            }

	            list.noData = $('<div class="k-nodata" style="display:none"><div></div></div>').appendTo(list.list);
	            list.noDataTemplate = typeof template !== "function" ? kendo.template(template) : template;
	        },

	        _footer: function() {
	            var list = this;
	            var footer = $(list.footer);
	            var template = list.options.footerTemplate;

	            this._angularElement(footer, "cleanup");
	            kendo.destroy(footer);
	            footer.remove();

	            if (!template) {
	                list.footer = null;
	                return;
	            }

	            list.footer = $('<div class="k-footer"></div>').appendTo(list.list);
	            list.footerTemplate = typeof template !== "function" ? kendo.template(template) : template;
	        },

	        _listOptions: function(options) {
	            var that = this;
	            var currentOptions = that.options;
	            var virtual = currentOptions.virtual;
	            var changeEventOption = {change: proxy(that._listChange, that)};
	            var listBoundHandler = proxy(that._listBound, that);

	            virtual = typeof virtual === "object" ? virtual : {};

	            options = $.extend({
	                autoBind: false,
	                selectable: true,
	                dataSource: that.dataSource,
	                click: proxy(that._click, that),
	                activate: proxy(that._activateItem, that),
	                columns: currentOptions.columns,
	                deactivate: proxy(that._deactivateItem, that),
	                dataBinding: function() {
	                    that.trigger("dataBinding");
	                },
	                dataBound: listBoundHandler,
	                height: currentOptions.height,
	                dataValueField: currentOptions.dataValueField,
	                dataTextField: currentOptions.dataTextField,
	                groupTemplate: currentOptions.groupTemplate,
	                fixedGroupTemplate: currentOptions.fixedGroupTemplate,
	                template: currentOptions.template
	            }, options, virtual, changeEventOption);

	            if (!options.template) {
	                options.template = "#:" + kendo.expr(options.dataTextField, "data") + "#";
	            }

	            if (currentOptions.$angular) {
	                options.$angular = currentOptions.$angular;
	            }

	            return options;
	        },

	        _initList: function() {
	            var that = this;
	            var listOptions = that._listOptions({
	                selectedItemChange: proxy(that._listChange, that)
	            });

	            if (!that.options.virtual) {
	                that.listView = new kendo.ui.StaticList(that.ul, listOptions);
	            } else {
	                that.listView = new kendo.ui.VirtualList(that.ul, listOptions);
	            }

	            that.listView.bind("listBound", proxy(that._listBound, that));
	            that._setListValue();
	        },

	        _setListValue: function(value) {
	            value = value || this.options.value;

	            if (value !== undefined) {
	                this.listView.value(value)
	                    .done(proxy(this._updateSelectionState, this));
	            }
	        },

	        _updateSelectionState: $.noop,

	        _listMousedown: function(e) {
	            if (!this.filterInput || this.filterInput[0] !== e.target) {
	                e.preventDefault();
	            }
	        },

	        _isFilterEnabled: function() {
	            var filter = this.options.filter;
	            return filter && filter !== "none";
	        },

	        _hideClear: function() {
	            var list = this;

	            if (list._clear) {
	                list._clear.addClass(HIDDENCLASS);
	            }
	        },

	        _showClear: function() {
	            if (this._clear) {
	                this._clear.removeClass(HIDDENCLASS);
	            }
	        },

	        _clearValue: function() {
	            this._clearText();
	            this._accessor("");
	            this.listView.value([]);

	            if (this._isSelect) {
	                this._customOption = undefined;
	            }

	            if (this._isFilterEnabled() && !this.options.enforceMinLength) {
	                this._filter({word: "", open: false});

	                if (this.options.highlightFirst) {
	                    this.listView.focus(0);
	                }
	            }
	            this._change();
	        },

	        _clearText: function() {
	            this.text("");
	        },

	        _clearFilter: function() {
	            if (!this.options.virtual) {
	                this.listView.bound(false);
	            }

	            this._filterSource();
	        },

	        _filterSource: function(filter, force) {
	            var that = this;
	            var options = that.options;
	            var isMultiColumnFiltering = options.filterFields && filter && filter.logic && filter.filters && filter.filters.length;
	            var dataSource = that.dataSource;
	            var expression = extend({}, dataSource.filter() || {});
	            var resetPageSettings = filter || (expression.filters && expression.filters.length && !filter);

	            var removed = removeFiltersForField(expression, options.dataTextField);

	            this._clearFilterExpressions(expression);

	            if ((filter || removed) && that.trigger("filtering", { filter: filter })) {
	                return $.Deferred().reject().promise();
	            }

	            var newExpression = {
	                filters: [],
	                logic: "and"
	            };

	            if (isMultiColumnFiltering) {
	                newExpression.filters.push(filter);
	            } else {
	                this._pushFilterExpression(newExpression, filter);
	            }

	            if (isValidFilterExpr(expression)) {
	                if (newExpression.logic === expression.logic) {
	                    newExpression.filters = newExpression.filters.concat(expression.filters);
	                } else {
	                    newExpression.filters.push(expression);
	                }
	            }

	            if (that._cascading) {
	                this.listView.setDSFilter(newExpression);
	            }

	            var dataSourceState = extend({}, {
	                page: resetPageSettings ? 1 : dataSource.page(),
	                pageSize: resetPageSettings ? dataSource.options.pageSize : dataSource.pageSize(),
	                sort: dataSource.sort(),
	                filter: dataSource.filter(),
	                group: dataSource.group(),
	                aggregate: dataSource.aggregate()
	            }, { filter: newExpression });

	            return dataSource[force ? "read" : "query"](dataSource._mergeState(dataSourceState));
	        },

	        _pushFilterExpression: function (newExpression, filter) {
	            if (isValidFilterExpr(filter) && filter.value !== "") {
	                newExpression.filters.push(filter);
	            }
	        },

	        _clearFilterExpressions: function (expression) {
	            if (!expression.filters) {
	                return;
	            }

	            var filtersToRemove;

	            for(var i = 0; i < expression.filters.length; i++) {
	                if ("fromFilter" in expression.filters[i]) {
	                    filtersToRemove = i;
	                }
	            }

	            if (!isNaN(filtersToRemove)){
	                expression.filters.splice(filtersToRemove, 1);
	            }
	        },

	        _angularElement: function(element, action) {
	            if (!element) {
	                return;
	            }

	            this.angular(action, function() {
	                return { elements: element };
	            });
	        },

	        _renderNoData: function() {
	            var list = this;
	            var noData = list.noData;

	            if (!noData) {
	                return;
	            }

	            this._angularElement(noData, "cleanup");
	            noData.children(":first").html(list.noDataTemplate({ instance: list }));
	            this._angularElement(noData, "compile");
	        },

	        _toggleNoData: function(show) {
	            $(this.noData).toggle(show);
	        },

	        _toggleHeader: function(show) {
	            var groupHeader = this.listView.content.prev(GROUPHEADER);
	            groupHeader.toggle(show);
	        },

	        _renderFooter: function() {
	            var list = this;
	            var footer = list.footer;

	            if (!footer) {
	                return;
	            }

	            this._angularElement(footer, "cleanup");
	            footer.html(list.footerTemplate({ instance: list }));
	            this._angularElement(footer, "compile");
	        },

	        _allowOpening: function() {
	            return this.options.noDataTemplate || this.dataSource.flatView().length;
	        },

	        _initValue: function() {
	            var that = this,
	                value = that.options.value;

	            if (value !== null) {
	                that.element.val(value);
	            } else {
	                value = that._accessor();
	                that.options.value = value;
	            }

	            that._old = value;
	        },

	        _ignoreCase: function() {
	            var that = this,
	                model = that.dataSource.reader.model,
	                field;

	            if (model && model.fields) {
	                field = model.fields[that.options.dataTextField];

	                if (field && field.type && field.type !== "string") {
	                    that.options.ignoreCase = false;
	                }
	            }
	        },

	        _focus: function(candidate) {
	            return this.listView.focus(candidate);
	        },

	        _filter: function(options) {
	            var that = this;
	            var widgetOptions = that.options;
	            var word = options.word;
	            var filterFields = widgetOptions.filterFields;
	            var field = widgetOptions.dataTextField;
	            var expression;

	            if (filterFields && filterFields.length) {
	                expression = {
	                    logic: "or",
	                    filters: [],
	                    fromFilter: true
	                };
	                for(var i = 0; i < filterFields.length; i++) {
	                    this._pushFilterExpression(expression, that._buildExpression(word, filterFields[i]));
	                }
	            } else {
	                expression = that._buildExpression(word, field);
	            }

	            that._open = options.open;
	            that._filterSource(expression);
	        },

	        _buildExpression: function(value, field) {
	            var that = this;
	            var widgetOptions = that.options;
	            var ignoreCase = widgetOptions.ignoreCase;
	            var accentFoldingFiltering = that.dataSource.options.accentFoldingFiltering;

	            return {
	                value: ignoreCase ? (accentFoldingFiltering ? value.toLocaleLowerCase(accentFoldingFiltering) : value.toLowerCase()) : value,
	                field: field,
	                operator: widgetOptions.filter,
	                ignoreCase: ignoreCase
	            };
	        },

	        _clearButton: function() {
	            var list = this;
	            var clearTitle = list.options.messages.clear;

	            if (!list._clear){
	                list._clear = $('<span unselectable="on" class="k-icon k-clear-value k-i-close" title="' + clearTitle + '"></span>').attr({
	                    "role": "button",
	                    "tabIndex": -1
	                });
	            }

	            if (!list.options.clearButton) {
	                list._clear.remove();
	            }
	            this._hideClear();
	        },

	        search: function(word) {
	            var options = this.options;

	            word = typeof word === "string" ? word : this._inputValue();

	            clearTimeout(this._typingTimeout);

	            if ((!options.enforceMinLength && !word.length) || word.length >= options.minLength) {
	                this._state = "filter";
	                if (this.listView){
	                    this.listView._emptySearch = !kendo.trim(word).length;
	                }

	                if (!this._isFilterEnabled()) {
	                    this._searchByWord(word);
	                } else {
	                    this._filter({word: word, open: true});
	                }
	            }
	        },

	        current: function(candidate) {
	            return this._focus(candidate);
	        },

	        items: function() {
	            return this.ul[0].children;
	        },

	        destroy: function() {
	            var that = this;
	            var ns = that.ns;

	            Widget.fn.destroy.call(that);

	            that._unbindDataSource();

	            that.listView.destroy();
	            that.list.off(ns);

	            that.popup.destroy();

	            if (that._form) {
	                that._form.off("reset", that._resetHandler);
	            }
	        },

	        dataItem: function(index) {
	            var that = this;

	            if (index === undefined) {
	                return that.listView.selectedDataItems()[0];
	            }

	            if (typeof index !== "number") {
	                if (that.options.virtual) {
	                    return that.dataSource.getByUid($(index).data("uid"));
	                }

	                index = $(that.items()).index(index);
	            }

	            return that.dataSource.flatView()[index];
	        },

	        _activateItem: function() {
	            var current = this.listView.focus();
	            if (current) {
	                this._focused.add(this.filterInput).attr("aria-activedescendant", current.attr("id"));
	            }
	        },

	        _deactivateItem: function() {
	            this._focused.add(this.filterInput).removeAttr("aria-activedescendant");
	        },

	        _accessors: function() {
	            var that = this;
	            var element = that.element;
	            var options = that.options;
	            var getter = kendo.getter;
	            var textField = element.attr(kendo.attr("text-field"));
	            var valueField = element.attr(kendo.attr("value-field"));

	            if (!options.dataTextField && textField) {
	                options.dataTextField = textField;
	            }

	            if (!options.dataValueField && valueField) {
	                options.dataValueField = valueField;
	            }

	            that._text = getter(options.dataTextField);
	            that._value = getter(options.dataValueField);
	        },

	        _aria: function(id) {
	            var that = this,
	                options = that.options,
	                element = that._focused.add(that.filterInput);

	            if (options.suggest !== undefined) {
	                element.attr("aria-autocomplete", options.suggest ? "both" : "list");
	            }

	            id = id ? id + " " + that.ul[0].id : that.ul[0].id;

	            element.attr("aria-owns", id);

	            that.ul.attr("aria-live", !that._isFilterEnabled() ? "off" : "polite");

	            that._ariaLabel();
	        },

	        _ariaLabel: function(){
	            var that = this;
	            var focusedElm = that._focused;
	            var inputElm = that.element;
	            var inputId = inputElm.attr("id");
	            var labelElm = $("label[for=\"" + inputId  + "\"]");
	            var ariaLabel = inputElm.attr("aria-label");
	            var ariaLabelledBy = inputElm.attr("aria-labelledby");

	            if (focusedElm === inputElm) {
	                return;
	            }

	            if (ariaLabel) {
	                focusedElm.attr("aria-label", ariaLabel);
	            } else if (ariaLabelledBy){
	                focusedElm.attr("aria-labelledby", ariaLabelledBy);
	            } else if (labelElm.length){
	                var labelId = labelElm.attr("id") || that._generateLabelId(labelElm, inputId || kendo.guid());
	                focusedElm.attr("aria-labelledby", labelId);
	            }
	        },

	        _generateLabelId: function(label, inputId){
	            var labelId = inputId + LABELIDPART;
	            label.attr("id", labelId);

	            return labelId;
	        },

	        _blur: function() {
	            var that = this;

	            that._change();
	            that.close();
	            that._userTriggered = false;
	        },

	        _isValueChanged: function(value) {
	            return value !== unifyType(this._old, typeof value);
	        },

	        _change: function() {
	            var that = this;
	            var index = that.selectedIndex;
	            var optionValue = that.options.value;
	            var value = that.value();
	            var trigger;

	            if (that._isSelect && !that.listView.bound() && optionValue) {
	                value = optionValue;
	            }

	            if (that._isValueChanged(value)) {
	                trigger = true;
	            } else if (that._valueBeforeCascade !== undefined && that._valueBeforeCascade !== unifyType(that._old, typeof that._valueBeforeCascade) && that._userTriggered) {
	                trigger = true;
	            } else if (index !== undefined && index !== that._oldIndex && !that.listView.isFiltered()) {
	                trigger = true;
	            }

	            if (trigger) {

	                if (that._old === null || that._old === "" || value === "") {
	                    that._valueBeforeCascade = that._old = value;
	                } else {
	                    if (that.dataItem()) {
	                        that._valueBeforeCascade = that._old = that.options.dataValueField ? that.dataItem()[that.options.dataValueField] : that.dataItem();
	                    } else {
	                        that._valueBeforeCascade = that._old = null;
	                    }
	                }
	                that._oldIndex = index;

	                if (!that._typing) {
	                    // trigger the DOM change event so any subscriber gets notified
	                    that.element.trigger(CHANGE);
	                }

	                that.trigger(CHANGE);
	            }

	            that.typing = false;
	        },

	        _data: function() {
	            return this.dataSource.view();
	        },

	        _enable: function() {
	            var that = this,
	                options = that.options,
	                disabled = that.element.is("[disabled]");

	            if (options.enable !== undefined) {
	                options.enabled = options.enable;
	            }

	            if (!options.enabled || disabled) {
	                that.enable(false);
	            } else {
	                that.readonly(that.element.is("[readonly]"));
	            }
	        },

	        _dataValue: function(dataItem) {
	            var value = this._value(dataItem);

	            if (value === undefined) {
	                value = this._text(dataItem);
	            }

	            return value;
	        },

	        _offsetHeight: function() {
	            var offsetHeight = 0;
	            var siblings = this.listView.content.prevAll(":visible");

	            siblings.each(function() {
	                var element = $(this);

	                offsetHeight += outerHeight(element, true);
	            });

	            return offsetHeight;
	        },

	        _height: function(length) {
	            var that = this;
	            var list = that.list;
	            var height = that.options.height;
	            var visible = that.popup.visible();
	            var offsetTop;
	            var popups;
	            var footerHeight;

	            if (length || that.options.noDataTemplate) {
	                popups = list.add(list.parent(".k-animation-container")).show();

	                if (!list.is(":visible")) {
	                    popups.hide();
	                    return;
	                }

	                height = that.listView.content[0].scrollHeight > height ? height : "auto";

	                popups.height(height);

	                if (height !== "auto") {
	                    offsetTop = that._offsetHeight();
	                    footerHeight = outerHeight($(that.footer)) || 0;
	                    height = height - offsetTop - footerHeight;
	                }

	                that.listView.content.height(height);

	                if (!visible) {
	                    popups.hide();
	                }
	            }

	            return height;
	        },

	        _openHandler: function(e) {
	            this._adjustListWidth();

	            if (this.trigger(OPEN)) {
	                e.preventDefault();
	            } else {
	                this._focused.attr("aria-expanded", true);
	                this.ul.attr("aria-hidden", false);
	            }
	        },

	        _adjustListWidth: function() {
	            var that = this,
	                list = that.list,
	                width = list[0].style.width,
	                wrapper = that.wrapper,
	                computedStyle, computedWidth;

	            if (!list.data(WIDTH) && width) {
	                return;
	            }

	            computedStyle = window.getComputedStyle ? window.getComputedStyle(wrapper[0], null) : 0;
	            computedWidth = parseFloat(computedStyle  && computedStyle.width) || outerWidth(wrapper);

	            if (computedStyle && browser.msie) { // getComputedStyle returns different box in IE.
	                computedWidth += parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight) + parseFloat(computedStyle.borderLeftWidth) + parseFloat(computedStyle.borderRightWidth);
	            }

	            if (list.css("box-sizing") !== "border-box") {
	                width = computedWidth - (outerWidth(list) - list.width());
	            } else {
	                width = computedWidth;
	            }

	            list.css({
	                fontFamily: wrapper.css("font-family"),
	                width: that.options.autoWidth ? "auto" : width,
	                minWidth: width,
	                whiteSpace: that.options.autoWidth ? "nowrap" : "normal"
	            })
	            .data(WIDTH, width);

	            return true;
	        },

	        _closeHandler: function(e) {
	            if (this.trigger(CLOSE)) {
	                e.preventDefault();
	            } else {
	                this._focused.attr("aria-expanded", false);
	                this.ul.attr("aria-hidden", true);
	            }
	        },

	        _focusItem: function() {
	            var listView = this.listView;
	            var noFocusedItem = !listView.focus();
	            var index = last(listView.select());

	            if (index === undefined && this.options.highlightFirst && noFocusedItem) {
	                index = 0;
	            }

	            if (index !== undefined) {
	                listView.focus(index);
	            } else if (noFocusedItem) {
	                listView.scrollToIndex(0);
	            }
	        },

	        _calculateGroupPadding: function(height) {
	            var li = this.ul.children(".k-first:first");
	            var groupHeader = this.listView.content.prev(GROUPHEADER);
	            var padding = 0;
	            var direction = 'right';

	            if (groupHeader[0] && groupHeader[0].style.display !== "none") {
	                if (height !== "auto") {
	                    padding = kendo.support.scrollbar();
	                }

	                if(this.element.parents('.k-rtl').length) {
	                    direction = 'left';
	                }

	                padding += parseFloat(li.css("border-" + direction + "-width"), 10) + parseFloat(li.children(".k-group").css("padding-" + direction), 10);
	                groupHeader.css("padding-" + direction, padding);
	            }
	        },

	        _calculatePopupHeight: function(force) {
	            var height = this._height(this.dataSource.flatView().length || force);
	            this._calculateGroupPadding(height);
	            this._calculateColumnsHeaderPadding(height);
	        },

	        _calculateColumnsHeaderPadding: function(height){
	            if (this.options.columns && this.options.columns.length) {
	                var list = this;
	                var isRtl = support.isRtl(list.wrapper);
	                var scrollbar = kendo.support.scrollbar();

	                list.columnsHeader.css((isRtl ? "padding-left" : "padding-right"), height !== "auto" ? scrollbar : 0);
	            }
	        },

	        _refreshScroll: function () {
	            var listView = this.listView;
	            var enableYScroll = listView.element.height() > listView.content.height();

	            if (this.options.autoWidth) {
	                listView.content.css({
	                    overflowX: "hidden",
	                    overflowY: enableYScroll ? "scroll" : "auto"
	                });
	            }
	        },

	        _resizePopup: function(force) {
	            if (this.options.virtual) {
	                return;
	            }

	            if (!this.popup.element.is(":visible")) {
	                this.popup.one("open", (function(force) {
	                    return proxy(function() {
	                        this._calculatePopupHeight(force);
	                    }, this);
	                }).call(this, force));

	                this.popup.one("activate", proxy(this._refreshScroll, this));
	            } else {
	                this._calculatePopupHeight(force);
	            }
	        },

	        _popup: function() {
	            var list = this;

	            list.popup = new ui.Popup(list.list, extend({}, list.options.popup, {
	                anchor: list.wrapper,
	                open: proxy(list._openHandler, list),
	                close: proxy(list._closeHandler, list),
	                animation: list.options.animation,
	                isRtl: support.isRtl(list.wrapper),
	                autosize :list.options.autoWidth
	            }));
	        },

	        _makeUnselectable: function() {
	            if (isIE8) {
	                this.list.find("*").not(".k-textbox").attr("unselectable", "on");
	            }
	        },

	        _toggleHover: function(e) {
	            $(e.currentTarget).toggleClass(HOVER, e.type === "mouseenter");
	        },

	        _toggle: function(open, preventFocus) {
	            var that = this;
	            var touchEnabled = support.mobileOS && (support.touch || support.MSPointers || support.pointers);

	            open = open !== undefined? open : !that.popup.visible();

	            if (!preventFocus && !touchEnabled && that._focused[0] !== activeElement()) {
	                that._prevent = true;
	                that._focused.focus();
	                that._prevent = false;
	            }

	            that[open ? OPEN : CLOSE]();
	        },

	        _triggerCascade: function() {
	            var that = this;

	            if (!that._cascadeTriggered || that.value() !== unifyType(that._cascadedValue, typeof that.value())) {
	                that._cascadedValue = that.value();
	                that._cascadeTriggered = true;
	                that.trigger(CASCADE, { userTriggered: that._userTriggered });
	            }
	        },

	        _triggerChange: function() {
	            if (this._valueBeforeCascade !== this.value()) {
	                this.trigger(CHANGE);
	            }
	        },

	        _unbindDataSource: function() {
	            var that = this;

	            that.dataSource.unbind(REQUESTSTART, that._requestStartHandler)
	                           .unbind(REQUESTEND, that._requestEndHandler)
	                           .unbind("error", that._errorHandler);
	        },

	        requireValueMapper: function(options, value) {
	            var hasValue = (options.value instanceof Array ? options.value.length : options.value) || (value instanceof Array ? value.length : value);
	            if (hasValue && options.virtual && typeof options.virtual.valueMapper !== "function") {
	                throw new Error("ValueMapper is not provided while the value is being set. See http://docs.telerik.com/kendo-ui/controls/editors/combobox/virtualization#the-valuemapper-function");
	            }
	        }
	    });

	    function unifyType(value, type) {
	        if (value !== undefined && value !== "" && value !== null) {
	            if (type === "boolean") {
	                if (typeof value !== "boolean") {
	                    value = value.toString().toLowerCase() === "true";
	                }
	                value = Boolean(value);
	            } else if (type === "number") {
	                value = Number(value);
	            } else if (type === "string") {
	                value = value.toString();
	            }
	        }

	        return value;
	    }

	    extend(List, {
	        inArray: function(node, parentNode) {
	            var idx, length, siblings = parentNode.children;

	            if (!node || node.parentNode !== parentNode) {
	                return -1;
	            }

	            for (idx = 0, length = siblings.length; idx < length; idx++) {
	                if (node === siblings[idx]) {
	                    return idx;
	                }
	            }

	            return -1;
	        },
	        unifyType: unifyType
	    });

	    kendo.ui.List = List;

	    ui.Select = List.extend({
	        init: function(element, options) {
	            List.fn.init.call(this, element, options);
	            this._initial = this.element.val();
	        },

	        setDataSource: function(dataSource) {
	            var that = this;
	            var parent;

	            that.options.dataSource = dataSource;

	            that._dataSource();

	            if (that.listView.bound()) {
	                that._initialIndex = null;
	                that.listView._current = null;
	            }

	            that.listView.setDataSource(that.dataSource);

	            if (that.options.autoBind) {
	                that.dataSource.fetch();
	            }

	            parent = that._parentWidget();

	            if (parent) {
	                that._cascadeSelect(parent);
	            }
	        },

	        close: function() {
	            this.popup.close();
	        },

	        select: function(candidate) {
	            var that = this;

	            if (candidate === undefined) {
	                return that.selectedIndex;
	            } else {
	                return that._select(candidate).done(function() {
	                    that._cascadeValue = that._old = that._accessor();
	                    that._oldIndex = that.selectedIndex;
	                });
	            }
	        },

	        _accessor: function(value, idx) {
	            return this[this._isSelect ? "_accessorSelect" : "_accessorInput"](value, idx);
	        },

	        _accessorInput: function(value) {
	            var element = this.element[0];

	            if (value === undefined) {
	                return element.value;
	            } else {
	                if (value === null) {
	                    value = "";
	                }
	                element.value = value;
	            }
	        },

	        _accessorSelect: function(value, idx) {
	            var element = this.element[0];
	            var hasValue;

	            if (value === undefined) {
	                return getSelectedOption(element).value || "";
	            }

	            getSelectedOption(element).selected = false;

	            if (idx === undefined) {
	                idx = -1;
	            }

	            hasValue = (value !== null && value !== "");

	            if (hasValue && idx == -1) {
	                this._custom(value);
	            } else {
	                if (value) {
	                    element.value = value;
	                } else {
	                    element.selectedIndex = idx;
	                }
	            }
	        },

	        _syncValueAndText: function () {
	            return true;
	        },

	        _custom: function(value) {
	            var that = this;
	            var element = that.element;
	            var custom = that._customOption;

	            if (!custom) {
	                custom = $("<option/>");
	                that._customOption = custom;

	                element.append(custom);
	            }

	            custom.text(value);
	            custom[0].selected = true;
	        },

	        _hideBusy: function () {
	            var that = this;
	            clearTimeout(that._busy);
	            that._arrowIcon.removeClass(LOADING);
	            that._focused.attr("aria-busy", false);
	            that._busy = null;
	            that._showClear();
	        },

	        _showBusy: function (e) {
	            var that = this;

	            if (e.isDefaultPrevented()) {
	                return;
	            }

	            that._request = true;

	            if (that._busy) {
	                return;
	            }

	            that._busy = setTimeout(function () {
	                if (that._arrowIcon) { //destroyed after request start
	                    that._focused.attr("aria-busy", true);
	                    that._arrowIcon.addClass(LOADING);
	                    that._hideClear();
	                }
	            }, 100);
	        },

	        _requestEnd: function() {
	            this._request = false;
	            this._hideBusy();
	        },

	        _dataSource: function() {
	            var that = this,
	                element = that.element,
	                options = that.options,
	                dataSource = options.dataSource || {},
	                idx;

	            dataSource = $.isArray(dataSource) ? {data: dataSource} : dataSource;

	            if (that._isSelect) {
	                idx = element[0].selectedIndex;
	                if (idx > -1) {
	                    options.index = idx;
	                }

	                dataSource.select = element;
	                dataSource.fields = [{ field: options.dataTextField },
	                                     { field: options.dataValueField }];
	            }

	            if (that.dataSource) {
	                that._unbindDataSource();
	            } else {
	                that._requestStartHandler = proxy(that._showBusy, that);
	                that._requestEndHandler = proxy(that._requestEnd, that);
	                that._errorHandler = proxy(that._hideBusy, that);
	            }

	            that.dataSource = kendo.data.DataSource.create(dataSource)
	                                   .bind(REQUESTSTART, that._requestStartHandler)
	                                   .bind(REQUESTEND, that._requestEndHandler)
	                                   .bind("error", that._errorHandler);
	        },

	        _firstItem: function() {
	            this.listView.focusFirst();
	        },

	        _lastItem: function() {
	            this.listView.focusLast();
	        },

	        _nextItem: function() {
	            return this.listView.focusNext();
	        },

	        _prevItem: function() {
	            return this.listView.focusPrev();
	        },

	        _getNormalizedDataItem: function(candidate) {
	            var that = this,
	                listView = that.listView,
	                isIndex = typeof candidate === "number",
	                hasOptionLabel = that.optionLabel && that.optionLabel.length,
	                index;

	            if (isIndex) {
	                index =  hasOptionLabel ? --candidate : candidate;
	            } else {
	                index = listView.getElementIndex(candidate);
	            }

	            return listView.dataItemByIndex(index);
	        },

	        _getNormalizedSelectCandidate: function(candidate) {
	            var that = this,
	                hasOptionLabel = that.optionLabel && that.optionLabel.length,
	                isIndex = typeof candidate === "number",
	                normalizedCandidate = candidate;

	            if (hasOptionLabel && isIndex) {
	                normalizedCandidate++;
	            }

	            return normalizedCandidate;
	        },

	        _move: function(e) {
	            var that = this;
	            var listView = that.listView;
	            var key = e.keyCode;
	            var down = key === keys.DOWN;
	            var isVirtual = that.options.virtual;
	            var dataItem;
	            var pressed;
	            var current;
	            var moveIndex;
	            var selectCandidate;

	            if (key === keys.UP || down) {
	                if (e.altKey) {
	                    that.toggle(down);
	                } else {
	                    if (!listView.bound() && !that.ul[0].firstChild) {
	                        if (!that._fetch) {
	                            that.dataSource.one(CHANGE, function() {
	                                that._fetch = false;
	                                that._move(e);
	                            });

	                            that._fetch = true;
	                            that._filterSource();
	                        }

	                        e.preventDefault();

	                        return true; //pressed
	                    }

	                    current = that._focus();

	                    if (!that._fetch && (!current || current.hasClass("k-state-selected"))) {
	                        if (down) {
	                            moveIndex = that._nextItem();

	                            if ((isVirtual && moveIndex <= 0) || (!that._focus() && !moveIndex) ) {
	                                that._lastItem();
	                            }
	                        } else {
	                            moveIndex = that._prevItem();

	                            if ((isVirtual && moveIndex >= listView.dataSource.total() - 1) || (!that._focus() && !moveIndex)) {
	                                that._firstItem();
	                            }
	                        }
	                    }

	                    selectCandidate = that._getNormalizedSelectCandidate(that._get(that._focus()) || moveIndex || 0);

	                    that._select(selectCandidate, true).done(function() {
	                        var done = function() {
	                            if (!that.popup.visible()) {
	                                that._blur();
	                            }

	                            if (that._cascadedValue === null) {
	                                that._cascadedValue = that.value();
	                            } else {
	                                that._cascadedValue = that.dataItem() ? that.dataItem()[that.options.dataValueField] || that.dataItem() : null;
	                            }
	                        };

	                        if (that.trigger(SELECT, { dataItem: that._getNormalizedDataItem(selectCandidate), item: that._focus() })) {
	                            that._select(current).done(done);
	                        } else {
	                            done();
	                        }
	                    });
	                }

	                e.preventDefault();
	                pressed = true;
	            } else if (key === keys.ENTER || key === keys.TAB) {
	                if (that.popup.visible()) {
	                    e.preventDefault();
	                }

	                current = that._focus();
	                dataItem = that.dataItem();

	                if (!that.popup.visible() && (!dataItem || that.text() !== that._text(dataItem))) {
	                    current = null;
	                }

	                var activeFilter = that.filterInput && that.filterInput[0] === activeElement();
	                var selection;

	                if (current) {
	                    dataItem = listView.dataItemByIndex(listView.getElementIndex(current));
	                    var shouldTrigger = true;

	                    if (dataItem) {
	                        shouldTrigger = that._value(dataItem) !==  List.unifyType(that.value(), typeof that._value(dataItem));
	                    }

	                    if (shouldTrigger && that.trigger(SELECT, { dataItem: dataItem, item: current })) {
	                        return;
	                    }

	                    selection = that._select(current);
	                } else if (that.input) {
	                    if (that._syncValueAndText() || that._isSelect) {
	                        that._accessor(that.input.val());
	                    }
	                    that.listView.value(that.input.val());
	                }

	                if (that._focusElement) {
	                    that._focusElement(that.wrapper);
	                }

	                if (activeFilter && key === keys.TAB) {
	                    that.wrapper.focusout();
	                } else {
	                    if (selection && typeof selection.done === "function") {
	                        selection.done(function () {
	                            that._blur();
	                        });
	                    } else {
	                        that._blur();
	                    }
	                }

	                that.close();
	                pressed = true;
	            } else if (key === keys.ESC) {
	                if (that.popup.visible()) {
	                    e.preventDefault();
	                }
	                that.close();
	                pressed = true;
	            } else if (that.popup.visible() && (key === keys.PAGEDOWN || key === keys.PAGEUP)) {
	                e.preventDefault();

	                var direction = key === keys.PAGEDOWN ? 1 : -1;
	                listView.scrollWith(direction * listView.screenHeight());

	                pressed = true;
	            }

	            return pressed;
	        },

	        _fetchData: function() {
	            var that = this;
	            var hasItems = !!that.dataSource.view().length;

	            if (that._request || that.options.cascadeFrom) {
	                return;
	            }

	            if (!that.listView.bound() && !that._fetch && !hasItems) {
	                that._fetch = true;
	                that.dataSource.fetch().done(function() {
	                    that._fetch = false;
	                });
	            }
	        },

	        _options: function(data, optionLabel, value) {
	            var that = this,
	                element = that.element,
	                htmlElement = element[0],
	                length = data.length,
	                options = "",
	                option,
	                dataItem,
	                dataText,
	                dataValue,
	                idx = 0;

	            if (optionLabel) {
	                options = optionLabel;
	            }

	            for (; idx < length; idx++) {
	                option = "<option";
	                dataItem = data[idx];
	                dataText = that._text(dataItem);
	                dataValue = that._value(dataItem);

	                if (dataValue !== undefined) {
	                    dataValue += "";

	                    if (dataValue.indexOf('"') !== -1) {
	                        dataValue = dataValue.replace(quotRegExp, "&quot;");
	                    }

	                    option += ' value="' + dataValue + '"';
	                }

	                option += ">";

	                if (dataText !== undefined) {
	                    option += htmlEncode(dataText);
	                }

	                option += "</option>";
	                options += option;
	            }

	            element.html(options);

	            if (value !== undefined) {
	                htmlElement.value = value;
	                if (htmlElement.value && !value) {
	                    htmlElement.selectedIndex = -1;
	                }
	            }

	            if (htmlElement.selectedIndex !== -1) {
	                option = getSelectedOption(htmlElement);

	                if (option) {
	                    option.setAttribute(SELECTED, SELECTED);
	                }
	            }
	        },

	        _reset: function() {
	            var that = this,
	                element = that.element,
	                formId = element.attr("form"),
	                form = formId ? $("#" + formId) : element.closest("form");

	            if (form[0]) {
	                that._resetHandler = function() {
	                    setTimeout(function() {
	                        that.value(that._initial);
	                    });
	                };

	                that._form = form.on("reset", that._resetHandler);
	            }
	        },

	        _parentWidget: function() {
	            var name = this.options.name;

	            if (!this.options.cascadeFrom) {
	                return;
	            }

	            var parentElement = $("#" + this.options.cascadeFrom);
	            var parent = parentElement.data("kendo" + name);

	            if (!parent) {
	                for(var i = 0; i < alternativeNames[name].length; i+=1) {
	                    parent = parentElement.data("kendo" + alternativeNames[name][i]);

	                    if (!!parent) {
	                        break;
	                    }
	                }
	            }

	            return parent;
	        },

	        _cascade: function() {
	            var that = this;
	            var options = that.options;
	            var cascade = options.cascadeFrom;
	            var parent;

	            if (cascade) {
	                parent = that._parentWidget();

	                if (!parent) {
	                    return;
	                }

	                that._cascadeHandlerProxy = proxy(that._cascadeHandler, that);
	                that._cascadeFilterRequests = [];

	                options.autoBind = false;

	                parent.bind("set", function() { //will cascade
	                    that.one("set", function(e) { //get your value
	                        that._selectedValue = e.value || that._accessor();
	                    });
	                });

	                parent.first(CASCADE, that._cascadeHandlerProxy);

	                //refresh was called
	                if (parent.listView.bound()) {
	                    that._toggleCascadeOnFocus();
	                    that._cascadeSelect(parent);
	                } else {
	                    parent.one("dataBound", function() {
	                        that._toggleCascadeOnFocus();
	                        if (parent.popup.visible()) {
	                            parent._focused.focus();
	                        }
	                    });

	                    if (!parent.value()) {
	                        that.enable(false);
	                    }
	                }
	            }
	        },

	        _toggleCascadeOnFocus: function() {
	            var that = this;
	            var parent = that._parentWidget();
	            var focusout = isIE && parent instanceof ui.DropDownList ? BLUR : FOCUSOUT;

	            parent._focused.add(parent.filterInput).bind(FOCUS, function() {
	                parent.unbind(CASCADE, that._cascadeHandlerProxy);
	                parent.first(CHANGE, that._cascadeHandlerProxy);
	            });

	            parent._focused.add(parent.filterInput).bind(focusout, function() {
	                parent.unbind(CHANGE, that._cascadeHandlerProxy);
	                parent.first(CASCADE, that._cascadeHandlerProxy);
	            });
	        },

	        _cascadeHandler: function(e) {
	            var parent = this._parentWidget();
	            var valueBeforeCascade = this.value();

	            this._userTriggered = e.userTriggered || parent._userTriggered;

	            if (this.listView.bound()) {
	                this._clearSelection(parent, true);
	            }

	            this._cascadeSelect(parent, valueBeforeCascade);
	        },

	        _cascadeChange: function(parent) {
	            var that = this;
	            var value = that._accessor() || that._selectedValue;

	            if (!that._cascadeFilterRequests.length) {
	                that._selectedValue = null;
	            }

	            if (that._userTriggered) {
	                that._clearSelection(parent, true);
	            } else if (value) {
	                if (value !==  unifyType(that.listView.value()[0], typeof value)) {
	                    that.value(value);
	                }

	                if (!that.dataSource.view()[0] || that.selectedIndex === -1) {
	                    that._clearSelection(parent, true);
	                }
	            } else if (that.dataSource.flatView().length) {
	                that.select(that.options.index);
	            }

	            that.enable();
	            that._triggerCascade();
	            that._triggerChange();
	            that._userTriggered = false;
	        },

	        _cascadeSelect: function(parent, valueBeforeCascade) {
	            var that = this;
	            var dataItem = parent.dataItem();
	            var filterValue = dataItem ? dataItem[that.options.cascadeFromParentField] || parent._value(dataItem) : null;
	            var valueField = that.options.cascadeFromField || parent.options.dataValueField;
	            var expressions;

	            that._valueBeforeCascade = valueBeforeCascade !== undefined ? valueBeforeCascade : that.value();

	            if (filterValue || filterValue === 0) {
	                expressions = that.dataSource.filter() || {};
	                removeFiltersForField(expressions, valueField);

	                var handler = function () {
	                    var currentHandler = that._cascadeFilterRequests.shift();
	                    if (currentHandler) {
	                        that.unbind('dataBound', currentHandler);
	                    }

	                    currentHandler = that._cascadeFilterRequests[0];
	                    if (currentHandler) {
	                        that.first('dataBound', currentHandler);
	                    }

	                    that._cascadeChange(parent);
	                };

	                that._cascadeFilterRequests.push(handler);

	                if (that._cascadeFilterRequests.length === 1) {
	                    that.first('dataBound', handler);
	                }

	                that._cascading = true;
	                that._filterSource({
	                    field: valueField,
	                    operator: "eq",
	                    value: filterValue
	                });
	                that._cascading = false;
	            } else {
	                that.enable(false);
	                that._clearSelection(parent);
	                that._triggerCascade();
	                that._triggerChange();
	                that._userTriggered = false;
	            }
	        }
	    });

	    var STATIC_LIST_NS = ".StaticList";

	    var StaticList = kendo.ui.DataBoundWidget.extend({
	        init: function(element, options) {
	            Widget.fn.init.call(this, element, options);

	            this.element.attr("role", "listbox")
	                        .on("click" + STATIC_LIST_NS, "li", proxy(this._click, this))
	                        .on("mouseenter" + STATIC_LIST_NS, "li", function() { $(this).addClass(HOVER); })
	                        .on("mouseleave" + STATIC_LIST_NS, "li", function() { $(this).removeClass(HOVER); });

	            if (support.touch) {
	                this._touchHandlers();
	            }

	            if (this.options.selectable === "multiple") {
	                this.element.attr("aria-multiselectable", true);
	            }

	            this.content = this.element.wrap("<div class='k-list-scroller' unselectable='on'></div>").parent();
	            this.header = this.content.before('<div class="k-group-header" style="display:none"></div>').prev();

	            this.bound(false);

	            this._optionID = kendo.guid();

	            this._selectedIndices = [];

	            this._view = [];
	            this._dataItems = [];
	            this._values = [];

	            var value = this.options.value;

	            if (value) {
	                this._values = $.isArray(value) ? value.slice(0) : [value];
	            }

	            this._getter();
	            this._templates();

	            this.setDataSource(this.options.dataSource);

	            this._onScroll = proxy(function() {
	                var that = this;
	                clearTimeout(that._scrollId);

	                that._scrollId = setTimeout(function() {
	                    that._renderHeader();
	                }, 50);
	            }, this);
	        },

	        options: {
	            name: "StaticList",
	            dataValueField: null,
	            valuePrimitive: false,
	            selectable: true,
	            template: null,
	            groupTemplate: null,
	            fixedGroupTemplate: null
	        },

	        events: [
	           "click",
	            CHANGE,
	           "activate",
	           "deactivate",
	           "dataBinding",
	           "dataBound",
	           "selectedItemChange"
	        ],

	        setDataSource: function(source) {
	            var that = this;
	            var dataSource = source || {};
	            var value;

	            dataSource = $.isArray(dataSource) ? { data: dataSource } : dataSource;
	            dataSource = kendo.data.DataSource.create(dataSource);

	            if (that.dataSource) {
	                that.dataSource.unbind(CHANGE, that._refreshHandler);

	                value = that.value();

	                that.value([]);
	                that.bound(false);

	                that.value(value);
	            } else {
	                that._refreshHandler = proxy(that.refresh, that);
	            }

	            that.setDSFilter(dataSource.filter());

	            that.dataSource = dataSource.bind(CHANGE, that._refreshHandler);
	            that._fixedHeader();
	        },

	        _touchHandlers: function () {
	            var that = this;
	            var startY;
	            var endY;
	            var tapPosition = function (event) {
	                return (event.originalEvent || event).changedTouches[0].pageY;
	            };

	            that.element.on("touchstart" + STATIC_LIST_NS, function (e) {
	                startY = tapPosition(e);
	            });

	            that.element.on("touchend" + STATIC_LIST_NS, function (e) {
	                if (e.isDefaultPrevented()) {
	                    return;
	                }

	                endY = tapPosition(e);

	                if (Math.abs(endY - startY) < 10) {
	                    that._touchTriggered = true;
	                    that._triggerClick($(e.target).closest(ITEMSELECTOR).get(0));
	                }
	            });
	        },

	        skip: function() {
	            return this.dataSource.skip();
	        },

	        setOptions: function(options) {
	            Widget.fn.setOptions.call(this, options);

	            this._getter();
	            this._templates();
	            this._render();
	        },

	        destroy: function() {
	            this.element.off(STATIC_LIST_NS);

	            if (this._refreshHandler) {
	                this.dataSource.unbind(CHANGE, this._refreshHandler);
	            }

	            clearTimeout(this._scrollId);

	            Widget.fn.destroy.call(this);
	        },

	        dataItemByIndex: function(index) {
	            return this.dataSource.flatView()[index];
	        },

	        screenHeight: function() {
	            return this.content[0].clientHeight;
	        },

	        scrollToIndex: function(index) {
	            var item = this.element[0].children[index];

	            if (item) {
	                this.scroll(item);
	            }
	        },

	        scrollWith: function(value) {
	            this.content.scrollTop(this.content.scrollTop() + value);
	        },

	        scroll: function (item) {
	            if (!item) {
	                return;
	            }

	            if (item[0]) {
	                item = item[0];
	            }

	            var content = this.content[0],
	                itemOffsetTop = item.offsetTop,
	                itemOffsetHeight = item.offsetHeight,
	                contentScrollTop = content.scrollTop,
	                contentOffsetHeight = content.clientHeight,
	                bottomDistance = itemOffsetTop + itemOffsetHeight;

	                if (contentScrollTop > itemOffsetTop) {
	                    contentScrollTop = itemOffsetTop;
	                } else if (bottomDistance > (contentScrollTop + contentOffsetHeight)) {
	                    contentScrollTop = (bottomDistance - contentOffsetHeight);
	                }

	                content.scrollTop = contentScrollTop;
	        },

	        selectedDataItems: function(dataItems) {
	            if (dataItems === undefined) {
	                return this._dataItems.slice();
	            }

	            this._dataItems = dataItems;
	            this._values = this._getValues(dataItems);
	        },

	        _getValues: function(dataItems) {
	            var getter = this._valueGetter;

	            return $.map(dataItems, function(dataItem) {
	                return getter(dataItem);
	            });
	        },

	        focusNext: function() {
	            var current = this.focus();

	            if (!current) {
	                current = 0;
	            } else {
	                current = current.next();
	            }

	            this.focus(current);
	        },

	        focusPrev: function() {
	            var current = this.focus();

	            if (!current) {
	                current = this.element[0].children.length - 1;
	            } else {
	                current = current.prev();
	            }

	            this.focus(current);
	        },

	        focusFirst: function() {
	            this.focus(this.element[0].children[0]);
	        },

	        focusLast: function() {
	            this.focus(last(this.element[0].children));
	        },

	        focus: function(candidate) {
	            var that = this;
	            var id = that._optionID;
	            var hasCandidate;

	            if (candidate === undefined) {
	                return that._current;
	            }

	            candidate = last(that._get(candidate));
	            candidate = $(this.element[0].children[candidate]);

	            if (that._current) {
	                that._current
	                    .removeClass(FOCUSED)
	                    .removeAttr(ID);

	                that.trigger("deactivate");
	            }

	            hasCandidate = !!candidate[0];

	            if (hasCandidate) {
	                candidate.addClass(FOCUSED);
	                that.scroll(candidate);

	                candidate.attr("id", id);
	            }

	            that._current = hasCandidate ? candidate : null;
	            that.trigger("activate");
	        },

	        focusIndex: function() {
	            return this.focus() ? this.focus().index() : undefined;
	        },

	        skipUpdate: function(skipUpdate) {
	            this._skipUpdate = skipUpdate;
	        },

	        select: function(indices) {
	            var that = this;
	            var selectable = that.options.selectable;
	            var singleSelection = selectable !== "multiple" && selectable !== false;
	            var selectedIndices = that._selectedIndices;
	            var uiSelectedIndices = [this.element.find(".k-state-selected").index()];

	            var added = [];
	            var removed = [];
	            var result;

	            if (indices === undefined) {
	                return selectedIndices.slice();
	            }

	            indices = that._get(indices);

	            if (indices.length === 1 && indices[0] === -1) {
	                indices = [];
	            }

	            var deferred = $.Deferred().resolve();
	            var filtered = that.isFiltered();

	            if (filtered && !singleSelection && that._deselectFiltered(indices)) {
	                return deferred;
	            }

	            if (singleSelection && !filtered &&
	                $.inArray(last(indices), selectedIndices) !== -1 && $.inArray(last(indices), uiSelectedIndices) !== -1) {

	                if (that._dataItems.length && that._view.length) {
	                    that._dataItems = [that._view[selectedIndices[0]].item];
	                }

	                return deferred;
	            }

	            result = that._deselect(indices);

	            removed = result.removed;
	            indices = result.indices;

	            if (indices.length) {
	                if (singleSelection) {
	                    indices = [last(indices)];
	                }

	                added = that._select(indices);
	            }

	            if (added.length || removed.length) {
	                that._valueComparer = null;
	                that.trigger(CHANGE, {
	                    added: added,
	                    removed: removed
	                });
	            }

	            return deferred;
	        },

	        removeAt: function(position) {
	            this._selectedIndices.splice(position, 1);
	            this._values.splice(position, 1);
	            this._valueComparer = null;

	            return {
	                position: position,
	                dataItem: this._dataItems.splice(position, 1)[0]
	            };
	        },

	        setValue: function(value) {
	            value = $.isArray(value) || value instanceof ObservableArray ? value.slice(0) : [value];

	            this._values = value;

	            this._valueComparer = null;
	        },

	        value: function(value) {
	            var that = this;
	            var deferred = that._valueDeferred;
	            var indices;

	            if (value === undefined) {
	                return that._values.slice();
	            }

	            that.setValue(value);

	            if (!deferred || deferred.state() === "resolved") {
	                that._valueDeferred = deferred = $.Deferred();
	            }

	            if (that.bound()) {
	                indices = that._valueIndices(that._values);

	                if (that.options.selectable === "multiple") {
	                    that.select(-1);
	                }

	                that.select(indices);

	                deferred.resolve();
	            }

	            that._skipUpdate = false;

	            return deferred;
	        },

	        items: function() {
	            return this.element.children(ITEMSELECTOR);
	        },

	        _click: function(e) {
	            if (this._touchTriggered)
	            {
	                this._touchTriggered = false;
	                return;
	            }

	            if (!e.isDefaultPrevented()) {
	                this._triggerClick(e.currentTarget);
	            }
	        },

	        _triggerClick: function (item) {
	            if (!this.trigger("click", { item: $(item) })) {
	                this.select(item);
	            }
	        },

	        _valueExpr: function(type, values) {
	            var that = this;
	            var idx = 0;

	            var body;
	            var comparer;
	            var normalized = [];

	            if (!that._valueComparer  || that._valueType !== type) {
	                that._valueType = type;

	                for (; idx < values.length; idx++) {
	                    normalized.push(unifyType(values[idx], type));
	                }

	                body = "for (var idx = 0; idx < " + normalized.length + "; idx++) {" +
	                        " if (current === values[idx]) {" +
	                        "   return idx;" +
	                        " }" +
	                        "} " +
	                        "return -1;";

	                comparer = new Function("current", "values", body);

	                that._valueComparer = function(current) {
	                    return comparer(current, normalized);
	                };
	            }

	            return that._valueComparer;
	        },

	        _dataItemPosition: function(dataItem, values) {
	            var value = this._valueGetter(dataItem);

	            var valueExpr = this._valueExpr(typeof value, values);

	            return valueExpr(value);
	        },

	        _getter: function() {
	            this._valueGetter = kendo.getter(this.options.dataValueField);
	        },

	        _deselect: function(indices) {
	            var that = this;
	            var children = that.element[0].children;
	            var selectable = that.options.selectable;
	            var selectedIndices = that._selectedIndices;
	            var dataItems = that._dataItems;
	            var values = that._values;
	            var removed = [];
	            var i = 0;
	            var j;

	            var index, selectedIndex;
	            var removedIndices = 0;

	            indices = indices.slice();

	            if (selectable === true || !indices.length) {
	                for (; i < selectedIndices.length; i++) {
	                    $(children[selectedIndices[i]]).removeClass("k-state-selected").attr("aria-selected", false);

	                    removed.push({
	                        position: i,
	                        dataItem: dataItems[i]
	                    });
	                }

	                that._values = [];
	                that._dataItems = [];
	                that._selectedIndices = [];
	            } else if (selectable === "multiple") {
	                for (; i < indices.length; i++) {
	                    index = indices[i];

	                    if (!$(children[index]).hasClass("k-state-selected")) {
	                        continue;
	                    }

	                    for (j = 0; j < selectedIndices.length; j++) {
	                        selectedIndex = selectedIndices[j];

	                        if (selectedIndex === index) {
	                            $(children[selectedIndex]).removeClass("k-state-selected").attr("aria-selected", false);
	                            var dataItem = this._view[index].item;
	                            var position = this._dataItemPosition(dataItem, this._values);

	                            removed.push({
	                                position: position,
	                                dataItem: dataItem
	                            });

	                            dataItems.splice(j, 1);
	                            selectedIndices.splice(j, 1);
	                            indices.splice(i, 1);
	                            values.splice(j, 1);

	                            removedIndices += 1;
	                            i -= 1;
	                            j -= 1;
	                            break;
	                        }
	                    }
	                }
	            }

	            return {
	                indices: indices,
	                removed: removed
	            };
	        },

	        _deselectFiltered: function(indices) {
	            var children = this.element[0].children;
	            var dataItem, index, position;
	            var removed = [];
	            var idx = 0;

	            for (; idx < indices.length; idx++) {
	                index = indices[idx];

	                dataItem = this._view[index].item;
	                position = this._dataItemPosition(dataItem, this._values);

	                if (position > -1) {
	                    removed.push(this.removeAt(position));
	                    $(children[index]).removeClass("k-state-selected");
	                }
	            }

	            if (removed.length) {
	                this.trigger(CHANGE, {
	                    added: [],
	                    removed: removed
	                });

	                return true;
	            }

	            return false;
	        },

	        _select: function(indices) {
	            var that = this;
	            var children = that.element[0].children;
	            var data = that._view;
	            var dataItem, index;
	            var added = [];
	            var idx = 0;

	            if (last(indices) !== -1) {
	                that.focus(indices);
	            }

	            for (; idx < indices.length; idx++) {
	                index = indices[idx];
	                dataItem = data[index];

	                if (index === -1 || !dataItem) {
	                    continue;
	                }

	                dataItem = dataItem.item;

	                that._selectedIndices.push(index);
	                that._dataItems.push(dataItem);
	                that._values.push(that._valueGetter(dataItem));

	                $(children[index]).addClass("k-state-selected").attr("aria-selected", true);

	                added.push({
	                    dataItem: dataItem
	                });
	            }

	            return added;
	        },

	        getElementIndex: function(element) {
	            return $(element).data("offset-index");
	        },

	        _get: function(candidate) {
	            if (typeof candidate === "number") {
	                candidate = [candidate];
	            } else if (!isArray(candidate)) {
	                candidate = this.getElementIndex(candidate);
	                candidate = [candidate !== undefined ? candidate : -1];
	            }

	            return candidate;
	        },

	        _template: function() {
	            var that = this;
	            var options = that.options;
	            var template = options.template;

	            if (!template) {
	                template = kendo.template('<li tabindex="-1" role="option" unselectable="on" class="k-item">${' + kendo.expr(options.dataTextField, "data") + "}</li>", { useWithBlock: false });
	            } else {
	                template = kendo.template(template);
	                template = function(data) {
	                    return '<li tabindex="-1" role="option" unselectable="on" class="k-item">' + template(data) + "</li>";
	                };
	            }

	            return template;
	        },

	        _templates: function() {
	            var template;
	            var options = this.options;
	            var templates = {
	                template: options.template,
	                groupTemplate: options.groupTemplate,
	                fixedGroupTemplate: options.fixedGroupTemplate
	            };

	            if (options.columns) {
	                for (var i = 0; i < options.columns.length; i++) {
	                    var currentColumn = options.columns[i];
	                    var templateText = currentColumn.field ? currentColumn.field.toString(): "text";

	                    templates["column"+ i] = currentColumn.template || "#: " + templateText + "#";
	                }
	            }

	            for (var key in templates) {
	                template = templates[key];
	                if (template && typeof template !== "function") {
	                    templates[key] = kendo.template(template);
	                }
	            }

	            this.templates = templates;
	        },

	        _normalizeIndices: function(indices) {
	            var newIndices = [];
	            var idx = 0;

	            for (; idx < indices.length; idx++) {
	                if (indices[idx] !== undefined) {
	                    newIndices.push(indices[idx]);
	                }
	            }

	            return newIndices;
	        },

	        _valueIndices: function(values, indices) {
	            var data = this._view;
	            var idx = 0;
	            var index;

	            indices = indices ? indices.slice() : [];

	            if (!values.length) {
	                return [];
	            }

	            for (; idx < data.length; idx++) {
	                index = this._dataItemPosition(data[idx].item, values);

	                if (index !== -1) {
	                    indices[index] = idx;
	                }
	            }

	            return this._normalizeIndices(indices);
	        },

	        _firstVisibleItem: function() {
	            var element = this.element[0];
	            var content = this.content[0];
	            var scrollTop = content.scrollTop;
	            var itemHeight = $(element.children[0]).height();
	            var itemIndex = Math.floor(scrollTop / itemHeight) || 0;
	            var item = element.children[itemIndex] || element.lastChild;
	            var forward = item.offsetTop < scrollTop;

	            while (item) {
	                if (forward) {
	                    if ((item.offsetTop + itemHeight) > scrollTop || !item.nextSibling) {
	                        break;
	                    }

	                    item = item.nextSibling;
	                } else {
	                    if (item.offsetTop <= scrollTop || !item.previousSibling) {
	                        break;
	                    }

	                    item = item.previousSibling;
	                }
	            }

	            return this._view[$(item).data("offset-index")];
	        },

	        _fixedHeader: function() {
	            if (this.isGrouped() && this.templates.fixedGroupTemplate) {
	                this.header.show();
	                this.content.scroll(this._onScroll);
	            } else {
	                this.header.hide();
	                this.content.off("scroll", this._onScroll);
	            }
	        },

	        _renderHeader: function() {
	            var template = this.templates.fixedGroupTemplate;
	            if (!template) {
	                return;
	            }

	            var visibleItem = this._firstVisibleItem();

	            if (visibleItem && visibleItem.group.toString().length) {
	                this.header.html(template(visibleItem.group));
	            }
	        },

	        _renderItem: function(context) {
	            var item = '<li tabindex="-1" role="option" unselectable="on" class="k-item';

	            var dataItem = context.item;
	            var notFirstItem = context.index !== 0;
	            var selected = context.selected;
	            var isGrouped = this.isGrouped();
	            var hasColumns = this.options.columns && this.options.columns.length;

	            if (notFirstItem && context.newGroup) {
	                item += ' k-first';
	            }

	            if (context.isLastGroupedItem && hasColumns) {
	                item += ' k-last';
	            }

	            if (selected) {
	                item += ' k-state-selected';
	            }

	            item += '" aria-selected="' + (selected ? "true" : "false") + '" data-offset-index="' + context.index + '">';
	            if (hasColumns) {
	                item += this._renderColumns(dataItem);
	            } else {
	                item += this.templates.template(dataItem);
	            }

	            if (notFirstItem && context.newGroup) {
	                if (hasColumns) {
	                    item += '<div class="k-cell k-group-cell"><span>' + this.templates.groupTemplate(context.group) + '</span></div>';
	                } else {
	                    item += '<div class="k-group">' + this.templates.groupTemplate(context.group) + '</div>';
	                }
	            } else if (isGrouped && hasColumns) {
	                item += "<div class='k-cell k-spacer-cell'></div>";
	            }

	            return item + "</li>";
	        },

	        _renderColumns: function(dataItem) {
	            var item = "";

	            for (var i = 0; i < this.options.columns.length; i++) {
	                var currentWidth = this.options.columns[i].width;
	                var currentWidthInt = parseInt(currentWidth, 10);
	                var widthStyle = '';

	                if (currentWidth && !isNaN(currentWidthInt)) {
	                    widthStyle += "style='width:";
	                    widthStyle += currentWidthInt;
	                    widthStyle += percentageUnitsRegex.test(currentWidth) ? "%" : "px";
	                    widthStyle += ";'";
	                }
	                item += "<span class='k-cell' " + widthStyle + ">";
	                item += this.templates["column"+ i](dataItem);
	                item += "</span>";
	            }

	            return item;
	        },

	        _render: function() {
	            var html = "";

	            var i = 0;
	            var idx = 0;
	            var context;
	            var dataContext = [];
	            var view = this.dataSource.view();
	            var values = this.value();

	            var group, newGroup, j;
	            var isGrouped = this.isGrouped();

	            if (isGrouped) {
	                for (i = 0; i < view.length; i++) {
	                    group = view[i];
	                    newGroup = true;

	                    for (j = 0; j < group.items.length; j++) {
	                        context = {
	                            selected: this._selected(group.items[j], values),
	                            item: group.items[j],
	                            group: group.value,
	                            newGroup: newGroup,
	                            isLastGroupedItem: j === group.items.length - 1,
	                            index: idx };
	                        dataContext[idx] = context;
	                        idx += 1;

	                        html += this._renderItem(context);
	                        newGroup = false;
	                    }
	                }
	            } else {
	                for (i = 0; i < view.length; i++) {
	                    context = { selected: this._selected(view[i], values), item: view[i], index: i };

	                    dataContext[i] = context;

	                    html += this._renderItem(context);
	                }
	            }

	            this._view = dataContext;

	            this.element[0].innerHTML = html;

	            if (isGrouped && dataContext.length) {
	                this._renderHeader();
	            }
	        },

	        _selected: function(dataItem, values) {
	            var select = !this.isFiltered() || this.options.selectable === "multiple";
	            return select && this._dataItemPosition(dataItem, values) !== -1;
	        },

	        setDSFilter: function(filter) {
	            this._lastDSFilter = extend({}, filter);
	        },

	        isFiltered: function() {
	            if (!this._lastDSFilter) {
	                this.setDSFilter(this.dataSource.filter());
	            }

	            return !kendo.data.Query.compareFilters(this.dataSource.filter(), this._lastDSFilter);
	        },

	        refresh: function(e) {
	            var that = this;
	            var action = e && e.action;
	            var skipUpdateOnBind = that.options.skipUpdateOnBind;
	            var isItemChange = action === "itemchange";
	            var result;

	            that.trigger("dataBinding");
	            that._angularItems("cleanup");

	            that._fixedHeader();

	            that._render();

	            that.bound(true);

	            if (isItemChange || action === "remove") {
	                result = mapChangedItems(that._dataItems, e.items);

	                if (result.changed.length) {
	                    if (isItemChange) {
	                        that.trigger("selectedItemChange", {
	                            items: result.changed
	                        });
	                    } else {
	                        that.value(that._getValues(result.unchanged));
	                    }
	                }
	            } else if (that.isFiltered() || that._skipUpdate || that._emptySearch) {
	                that.focus(0);
	                if (that._skipUpdate) {
	                    that._skipUpdate = false;
	                    that._selectedIndices = that._valueIndices(that._values, that._selectedIndices);
	                }
	            } else if (!skipUpdateOnBind && (!action || action === "add")) {
	                that.value(that._values);
	            }

	            if (that._valueDeferred) {
	                that._valueDeferred.resolve();
	            }

	            that._angularItems("compile");
	            that.trigger("dataBound");
	        },

	        bound: function(bound) {
	            if (bound === undefined) {
	                return this._bound;
	            }

	            this._bound = bound;
	        },

	        isGrouped: function() {
	            return (this.dataSource.group() || []).length;
	        }
	    });

	    ui.plugin(StaticList);

	    function last(list) {
	        return list[list.length - 1];
	    }

	    function getSelectedOption(select) {
	        var index = select.selectedIndex;
	        return index > -1 ? select.options[index] : {};
	    }

	    function mapChangedItems(selected, itemsToMatch) {
	        var itemsLength = itemsToMatch.length;
	        var selectedLength = selected.length;
	        var dataItem;
	        var found;
	        var i, j;

	        var changed = [];
	        var unchanged = [];

	        if (selectedLength) {
	            for (i = 0; i < selectedLength; i++) {
	                dataItem = selected[i];
	                found = false;

	                for (j = 0; j < itemsLength; j++) {
	                    if (dataItem === itemsToMatch[j]) {
	                        found = true;
	                        changed.push({ index: i, item: dataItem });
	                        break;
	                    }
	                }

	                if (!found) {
	                    unchanged.push(dataItem);
	                }
	            }
	        }

	        return {
	            changed: changed,
	            unchanged: unchanged
	        };
	    }

	    function isValidFilterExpr(expression) {
	        if (!expression || $.isEmptyObject(expression)) {
	            return false;
	        }

	        if (expression.filters && !expression.filters.length) {
	            return false;
	        }

	        return true;
	    }

	    function removeFiltersForField(expression, field) {
	        var filters;
	        var found = false;

	        if (expression.filters) {
	            filters = $.grep(expression.filters, function(filter) {
	                found = removeFiltersForField(filter, field);
	                if (filter.filters) {
	                    return filter.filters.length;
	                } else {
	                    return filter.field != field;
	                }
	            });

	            if (!found && expression.filters.length !== filters.length) {
	                found = true;
	            }

	            expression.filters = filters;
	        }

	        return found;
	    }

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "S/n4":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1556);
	module.exports = __webpack_require__(1556);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1556:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(20)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function () {

	/* global JSZip */

	kendo.ooxml = kendo.ooxml || {};

	kendo.ooxml.createZip = function() {
	    if (typeof JSZip === "undefined") {
	       throw new Error("JSZip not found. Check http://docs.telerik.com/kendo-ui/framework/excel/introduction#requirements for more details.");
	    }

	    return new JSZip();
	};

	})();

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "S82l":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "SDgz":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1358);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "progressbar",
	    name: "ProgressBar",
	    category: "web",
	    description: "The ProgressBar offers rich functionality for displaying and tracking progress",
	    depends: [ "core" ]
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        HORIZONTAL = "horizontal",
	        VERTICAL = "vertical",
	        DEFAULTMIN = 0,
	        DEFAULTMAX = 100,
	        DEFAULTVALUE = 0,
	        DEFAULTCHUNKCOUNT = 5,
	        KPROGRESSBAR = "k-progressbar",
	        KPROGRESSBARREVERSE = "k-progressbar-reverse",
	        KPROGRESSBARINDETERMINATE = "k-progressbar-indeterminate",
	        KPROGRESSBARCOMPLETE = "k-complete",
	        KPROGRESSWRAPPER = "k-state-selected",
	        KPROGRESSSTATUS = "k-progress-status",
	        LABEL_POSITION_END = "k-progress-end",
	        KCOMPLETEDCHUNK = "k-state-selected",
	        KUPCOMINGCHUNK = "k-state-default",
	        STATEDISABLED = "k-state-disabled",
	        PROGRESSTYPE = {
	            VALUE: "value",
	            PERCENT: "percent",
	            CHUNK: "chunk"
	        },
	        CHANGE = "change",
	        COMPLETE = "complete",
	        BOOLEAN = "boolean",
	        math = Math,
	        extend = $.extend,
	        proxy = $.proxy,
	        HUNDREDPERCENT = 100,
	        DEFAULTANIMATIONDURATION = 400,
	        PRECISION = 3,
	        templates = {
	            progressStatus: "<span class='k-progress-status-wrap " + LABEL_POSITION_END + "'><span class='k-progress-status'></span></span>"
	        };

	    var ProgressBar = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(this, element, options);

	            options = that.options;

	            that._progressProperty = (options.orientation === HORIZONTAL) ? "width" : "height";

	            that._fields();

	            options.value = that._validateValue(options.value);

	            that._validateType(options.type);

	            that._wrapper();

	            that._progressAnimation();

	            if ((options.value !== options.min) && (options.value !== false)) {
	               that._updateProgress();
	            }
	        },

	        setOptions: function(options) {
	            var that = this;

	            Widget.fn.setOptions.call(that, options);

	            if (options.hasOwnProperty("reverse")) {
	                that.wrapper.toggleClass("k-progressbar-reverse", options.reverse);
	            }

	            if (options.hasOwnProperty("enable")) {
	                that.enable(options.enable);
	            }

	            that._progressAnimation();

	            that._validateValue();

	            that._updateProgress();
	        },

	        events: [
	            CHANGE,
	            COMPLETE
	        ],

	        options: {
	            name: "ProgressBar",
	            orientation: HORIZONTAL,
	            reverse: false,
	            min: DEFAULTMIN,
	            max: DEFAULTMAX,
	            value: DEFAULTVALUE,
	            enable: true,
	            type: PROGRESSTYPE.VALUE,
	            chunkCount: DEFAULTCHUNKCOUNT,
	            showStatus: true,
	            animation: { }
	        },

	        _fields: function() {
	            var that = this;

	            that._isStarted = false;

	            that.progressWrapper = that.progressStatus = $();
	        },

	        _validateType: function(currentType) {
	            var isValid = false;

	            $.each(PROGRESSTYPE, function(k, type) {
	                if (type === currentType) {
	                    isValid = true;
	                    return false;
	                }
	            });

	            if (!isValid) {
	                throw new Error(kendo.format("Invalid ProgressBar type '{0}'", currentType));
	            }
	        },

	        _wrapper: function() {
	            var that = this;
	            var container = that.wrapper = that.element;
	            var options = that.options;
	            var orientation = options.orientation;
	            var initialStatusValue;

	            container.addClass("k-widget " + KPROGRESSBAR);

	            container.addClass(KPROGRESSBAR + "-" + ((orientation === HORIZONTAL) ? HORIZONTAL : VERTICAL));

	            if(options.enable === false) {
	                container.addClass(STATEDISABLED);
	            }

	            if (options.reverse) {
	                container.addClass(KPROGRESSBARREVERSE);
	            }

	            if (options.value === false) {
	                container.addClass(KPROGRESSBARINDETERMINATE);
	            }

	            if (options.type === PROGRESSTYPE.CHUNK) {
	                that._addChunkProgressWrapper();
	            } else {
	                if (options.showStatus){
	                    that.progressStatus = that.wrapper.prepend(templates.progressStatus)
	                                              .find("." + KPROGRESSSTATUS);

	                    initialStatusValue = (options.value !== false) ? options.value : options.min;

	                    if (options.type === PROGRESSTYPE.VALUE) {
	                        that.progressStatus.text(initialStatusValue);
	                    } else {
	                        that.progressStatus.text(that._calculatePercentage(initialStatusValue).toFixed() + "%");
	                    }
	                }
	            }
	        },

	        value: function(value) {
	            return this._value(value);
	        },

	        _value: function(value){
	            var that = this;
	            var options = that.options;
	            var validated;

	            if (value === undefined) {
	                return options.value;
	            } else {
	                if (typeof value !== BOOLEAN) {
	                    value = that._roundValue(value);

	                    if(!isNaN(value)) {
	                        validated = that._validateValue(value);

	                        if (validated !== options.value) {
	                            that.wrapper.removeClass(KPROGRESSBARINDETERMINATE);

	                            options.value = validated;

	                            that._isStarted = true;

	                            that._updateProgress();
	                        }
	                    }
	                } else if (!value) {
	                    that.wrapper.addClass(KPROGRESSBARINDETERMINATE);
	                    options.value = false;
	                }
	            }
	        },

	        _roundValue: function(value) {
	             value = parseFloat(value);

	             var power = math.pow(10, PRECISION);

	             return kendo._round(value * power) / power;
	        },

	        _validateValue: function(value) {
	            var that = this;
	            var options = that.options;

	            if (value !== false) {
	                if (value <= options.min || value === true) {
	                    return options.min;
	                } else if (value >= options.max) {
	                    return options.max;
	                }
	            } else if (value === false) {
	                return false;
	            }

	            if(isNaN(that._roundValue(value))) {
	                return options.min;
	            }

	            return value;
	        },

	        _updateProgress: function() {
	            var that = this;
	            var options = that.options;
	            var percentage = that._calculatePercentage();

	            if (options.type === PROGRESSTYPE.CHUNK) {
	                that._updateChunks(percentage);
	                that._onProgressUpdateAlways(options.value);
	            } else {
	                that._updateProgressWrapper(percentage);
	            }
	        },

	        _updateChunks: function(percentage) {
	            var that = this;
	            var options = that.options;
	            var chunkCount = options.chunkCount;
	            var percentagesPerChunk =  parseInt((HUNDREDPERCENT / chunkCount) * 100, 10) / 100;
	            var percentageParsed = parseInt(percentage * 100, 10) / 100;
	            var completedChunksCount = math.floor(percentageParsed / percentagesPerChunk);
	            var completedChunks;

	            if((options.orientation === HORIZONTAL && !(options.reverse)) ||
	               (options.orientation === VERTICAL && options.reverse)) {
	                completedChunks = that.wrapper.find("li.k-item:lt(" + completedChunksCount + ")");
	            } else {
	                completedChunks = that.wrapper.find("li.k-item:gt(-" + (completedChunksCount + 1) + ")");
	            }

	            that.wrapper.find("." + KCOMPLETEDCHUNK)
	                        .removeClass(KCOMPLETEDCHUNK)
	                        .addClass(KUPCOMINGCHUNK);

	            completedChunks.removeClass(KUPCOMINGCHUNK)
	                           .addClass(KCOMPLETEDCHUNK);
	        },

	        _updateProgressWrapper: function(percentage) {
	            var that = this;
	            var options = that.options;
	            var progressWrapper = that.wrapper.find("." + KPROGRESSWRAPPER);
	            var animationDuration = that._isStarted ? that._animation.duration : 0;
	            var animationCssOptions = { };

	            if (progressWrapper.length === 0) {
	                that._addRegularProgressWrapper();
	            }

	            animationCssOptions[that._progressProperty] = percentage + "%";
	            that.progressWrapper.animate(animationCssOptions, {
	                duration: animationDuration,
	                start: proxy(that._onProgressAnimateStart, that),
	                progress: proxy(that._onProgressAnimate, that),
	                complete: proxy(that._onProgressAnimateComplete, that, options.value),
	                always: proxy(that._onProgressUpdateAlways, that, options.value)
	            });
	        },

	        _onProgressAnimateStart: function() {
	            this.progressWrapper.show();
	        },

	        _onProgressAnimate: function(e) {
	            var that = this;
	            var options = that.options;
	            var progressInPercent = parseFloat(e.elem.style[that._progressProperty], 10);
	            var progressStatusWrapSize;

	            if (options.showStatus) {
	                progressStatusWrapSize = 10000 / parseFloat(that.progressWrapper[0].style[that._progressProperty]);

	                that.progressWrapper.find(".k-progress-status-wrap").css(that._progressProperty, progressStatusWrapSize + "%");
	            }

	            if (options.type !== PROGRESSTYPE.CHUNK && progressInPercent <= 98) {
	                that.progressWrapper.removeClass(KPROGRESSBARCOMPLETE);
	            }
	        },

	        _onProgressAnimateComplete: function(currentValue) {
	            var that = this;
	            var options = that.options;
	            var progressWrapperSize = parseFloat(that.progressWrapper[0].style[that._progressProperty]);
	            var progressValue;

	            if (options.type !== PROGRESSTYPE.CHUNK && progressWrapperSize > 98) {
	                that.progressWrapper.addClass(KPROGRESSBARCOMPLETE);
	            }

	            if (options.showStatus) {
	                if (options.type === PROGRESSTYPE.VALUE) {
	                    progressValue = currentValue;
	                } else if (options.type == PROGRESSTYPE.PERCENT) {
	                    progressValue = that._calculatePercentage(currentValue).toFixed() + "%";
	                } else {
	                    progressValue = math.floor(that._calculatePercentage(currentValue)) + "%";
	                }
	                that.progressStatus.text(progressValue);
	            }

	            if (currentValue === options.min) {
	                that.progressWrapper.hide();
	            }
	        },

	        _onProgressUpdateAlways: function(currentValue) {
	            var that = this;
	            var options = that.options;

	            if (that._isStarted) {
	                that.trigger(CHANGE, { value: currentValue });
	            }

	            if (currentValue === options.max && that._isStarted) {
	                that.trigger(COMPLETE, { value: options.max });
	            }
	        },

	        enable: function(enable) {
	            var that = this;
	            var options = that.options;

	            options.enable = typeof(enable) === "undefined" ? true : enable;
	            that.wrapper.toggleClass(STATEDISABLED, !options.enable);
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);
	        },

	        _addChunkProgressWrapper: function () {
	            var that = this;
	            var options = that.options;
	            var container = that.wrapper;
	            var chunkSize = HUNDREDPERCENT / options.chunkCount;
	            var html = "";

	            if (options.chunkCount <= 1) {
	                options.chunkCount = 1;
	            }

	            html += "<ul class='k-reset'>";
	            for (var i = options.chunkCount - 1; i >= 0; i--) {
	                html += "<li class='k-item k-state-default'></li>";
	            }
	            html += "</ul>";

	            container.append(html).find(".k-item").css(that._progressProperty, chunkSize + "%")
	                     .first().addClass("k-first")
	                     .end()
	                     .last().addClass("k-last");

	            that._normalizeChunkSize();
	        },

	        _normalizeChunkSize: function() {
	            var that = this;
	            var options = that.options;
	            var lastChunk = that.wrapper.find(".k-item:last");
	            var currentSize = parseFloat(lastChunk[0].style[that._progressProperty]);
	            var difference = HUNDREDPERCENT - (options.chunkCount * currentSize);

	            if (difference > 0) {
	                lastChunk.css(that._progressProperty, (currentSize + difference) + "%");
	            }
	        },

	        _addRegularProgressWrapper: function() {
	            var that = this;

	            that.progressWrapper = $("<div class='" + KPROGRESSWRAPPER + "'></div>").appendTo(that.wrapper);

	            if (that.options.showStatus) {
	                that.progressWrapper.append(templates.progressStatus);

	                that.progressStatus = that.wrapper.find("." + KPROGRESSSTATUS);
	            }
	        },

	        _calculateChunkSize: function() {
	            var that = this;
	            var chunkCount = that.options.chunkCount;
	            var chunkContainer = that.wrapper.find("ul.k-reset");

	            return (parseInt(chunkContainer.css(that._progressProperty), 10) - (chunkCount - 1)) / chunkCount;
	        },

	        _calculatePercentage: function(currentValue) {
	            var that = this;
	            var options = that.options;
	            var value = (currentValue !== undefined) ? currentValue : options.value;
	            var min = options.min;
	            var max = options.max;
	            that._onePercent = math.abs((max - min) / 100);

	            return math.abs((value - min) / that._onePercent);
	        },

	        _progressAnimation: function() {
	            var that = this;
	            var options = that.options;
	            var animation = options.animation;

	            if (animation === false) {
	                that._animation = { duration: 0 };
	            } else {
	                that._animation = extend({
	                    duration: DEFAULTANIMATIONDURATION
	                }, options.animation);
	            }
	        }
	    });

	    kendo.ui.plugin(ProgressBar);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "SOT/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var context_1 = __webpack_require__("RQ1/");
var component_1 = __webpack_require__("pQ38");
var componentRecipes_1 = __webpack_require__("EOXx");
var OverlayWrapperComponent = (function (_super) {
    __extends(OverlayWrapperComponent, _super);
    function OverlayWrapperComponent() {
        return _super.call(this) || this;
    }
    OverlayWrapperComponent.prototype.init = function () { };
    OverlayWrapperComponent.prototype.showLoadingOverlay = function (eOverlayWrapper) {
        var _this = this;
        this.setTemplate(OverlayWrapperComponent.LOADING_WRAPPER_OVERLAY_TEMPLATE);
        this.componentRecipes.newLoadingOverlayComponent().then(function (renderer) {
            var loadingOverlayWrapper = _this.getRefElement("loadingOverlayWrapper");
            utils_1.Utils.removeAllChildren(loadingOverlayWrapper);
            loadingOverlayWrapper.appendChild(renderer.getGui());
        });
        this.showOverlay(eOverlayWrapper, this.getGui());
    };
    OverlayWrapperComponent.prototype.showNoRowsOverlay = function (eOverlayWrapper) {
        var _this = this;
        this.setTemplate(OverlayWrapperComponent.NO_ROWS_WRAPPER_OVERLAY_TEMPLATE);
        this.componentRecipes.newNoRowsOverlayComponent().then(function (renderer) {
            var noRowsOverlayWrapper = _this.getRefElement("noRowsOverlayWrapper");
            utils_1.Utils.removeAllChildren(noRowsOverlayWrapper);
            noRowsOverlayWrapper.appendChild(renderer.getGui());
        });
        this.showOverlay(eOverlayWrapper, this.getGui());
    };
    OverlayWrapperComponent.prototype.hideOverlay = function (eOverlayWrapper) {
        utils_1.Utils.removeAllChildren(eOverlayWrapper);
        eOverlayWrapper.style.display = 'none';
    };
    OverlayWrapperComponent.prototype.showOverlay = function (eOverlayWrapper, overlay) {
        if (overlay) {
            utils_1.Utils.removeAllChildren(eOverlayWrapper);
            eOverlayWrapper.style.display = '';
            eOverlayWrapper.appendChild(overlay);
        }
        else {
            console.warn('ag-Grid: unknown overlay');
            this.hideOverlay(eOverlayWrapper);
        }
    };
    // wrapping in outer div, and wrapper, is needed to center the loading icon
    // The idea for centering came from here: http://www.vanseodesign.com/css/vertical-centering/
    OverlayWrapperComponent.LOADING_WRAPPER_OVERLAY_TEMPLATE = '<div class="ag-overlay-panel" role="presentation">' +
        '<div class="ag-overlay-wrapper ag-overlay-loading-wrapper" ref="loadingOverlayWrapper">[OVERLAY_TEMPLATE]</div>' +
        '</div>';
    OverlayWrapperComponent.NO_ROWS_WRAPPER_OVERLAY_TEMPLATE = '<div class="ag-overlay-panel" role="presentation">' +
        '<div class="ag-overlay-wrapper ag-overlay-no-rows-wrapper" ref="noRowsOverlayWrapper">[OVERLAY_TEMPLATE]</div>' +
        '</div>';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], OverlayWrapperComponent.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('componentRecipes'),
        __metadata("design:type", componentRecipes_1.ComponentRecipes)
    ], OverlayWrapperComponent.prototype, "componentRecipes", void 0);
    return OverlayWrapperComponent;
}(component_1.Component));
exports.OverlayWrapperComponent = OverlayWrapperComponent;


/***/ }),

/***/ "SdeK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var gridSerializer_1 = __webpack_require__("39p0");
var downloader_1 = __webpack_require__("/d84");
var columnController_1 = __webpack_require__("77lH");
var valueService_1 = __webpack_require__("5JVC");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var constants_1 = __webpack_require__("ZZFX");
var utils_1 = __webpack_require__("IRr6");
var LINE_SEPARATOR = '\r\n';
var CsvSerializingSession = (function (_super) {
    __extends(CsvSerializingSession, _super);
    function CsvSerializingSession(columnController, valueService, gridOptionsWrapper, processCellCallback, processHeaderCallback, suppressQuotes, columnSeparator) {
        var _this = _super.call(this, columnController, valueService, gridOptionsWrapper, processCellCallback, processHeaderCallback) || this;
        _this.suppressQuotes = suppressQuotes;
        _this.columnSeparator = columnSeparator;
        _this.result = '';
        _this.lineOpened = false;
        return _this;
    }
    CsvSerializingSession.prototype.prepare = function (columnsToExport) {
    };
    CsvSerializingSession.prototype.addCustomHeader = function (customHeader) {
        if (!customHeader)
            return;
        this.result += customHeader + LINE_SEPARATOR;
    };
    CsvSerializingSession.prototype.addCustomFooter = function (customFooter) {
        if (!customFooter)
            return;
        this.result += customFooter + LINE_SEPARATOR;
    };
    CsvSerializingSession.prototype.onNewHeaderGroupingRow = function () {
        if (this.lineOpened)
            this.result += LINE_SEPARATOR;
        return {
            onColumn: this.onNewHeaderGroupingRowColumn.bind(this)
        };
    };
    CsvSerializingSession.prototype.onNewHeaderGroupingRowColumn = function (header, index, span) {
        if (index != 0) {
            this.result += this.columnSeparator;
        }
        this.result += header;
        for (var i = 1; i <= span; i++) {
            this.result += this.columnSeparator + this.putInQuotes("", this.suppressQuotes);
        }
        this.lineOpened = true;
    };
    CsvSerializingSession.prototype.onNewHeaderRow = function () {
        if (this.lineOpened)
            this.result += LINE_SEPARATOR;
        return {
            onColumn: this.onNewHeaderRowColumn.bind(this)
        };
    };
    CsvSerializingSession.prototype.onNewHeaderRowColumn = function (column, index, node) {
        if (index != 0) {
            this.result += this.columnSeparator;
        }
        this.result += this.putInQuotes(this.extractHeaderValue(column), this.suppressQuotes);
        this.lineOpened = true;
    };
    CsvSerializingSession.prototype.onNewBodyRow = function () {
        if (this.lineOpened)
            this.result += LINE_SEPARATOR;
        return {
            onColumn: this.onNewBodyRowColumn.bind(this)
        };
    };
    CsvSerializingSession.prototype.onNewBodyRowColumn = function (column, index, node) {
        if (index != 0) {
            this.result += this.columnSeparator;
        }
        this.result += this.putInQuotes(this.extractRowCellValue(column, index, constants_1.Constants.EXPORT_TYPE_CSV, node), this.suppressQuotes);
        this.lineOpened = true;
    };
    CsvSerializingSession.prototype.putInQuotes = function (value, suppressQuotes) {
        if (suppressQuotes) {
            return value;
        }
        if (value === null || value === undefined) {
            return '""';
        }
        var stringValue;
        if (typeof value === 'string') {
            stringValue = value;
        }
        else if (typeof value.toString === 'function') {
            stringValue = value.toString();
        }
        else {
            console.warn('unknown value type during csv conversion');
            stringValue = '';
        }
        // replace each " with "" (ie two sets of double quotes is how to do double quotes in csv)
        var valueEscaped = stringValue.replace(/"/g, "\"\"");
        return '"' + valueEscaped + '"';
    };
    CsvSerializingSession.prototype.parse = function () {
        return this.result;
    };
    return CsvSerializingSession;
}(gridSerializer_1.BaseGridSerializingSession));
exports.CsvSerializingSession = CsvSerializingSession;
var BaseCreator = (function () {
    function BaseCreator() {
    }
    BaseCreator.prototype.setBeans = function (beans) {
        this.beans = beans;
    };
    BaseCreator.prototype.export = function (userParams) {
        if (this.isExportSuppressed()) {
            console.warn("ag-grid: Export canceled. Export is not allowed as per your configuration.");
            return "";
        }
        var _a = this.getMergedParamsAndData(userParams), mergedParams = _a.mergedParams, data = _a.data;
        var fileNamePresent = mergedParams && mergedParams.fileName && mergedParams.fileName.length !== 0;
        var fileName = fileNamePresent ? mergedParams.fileName : this.getDefaultFileName();
        if (fileName.indexOf(".") === -1) {
            fileName = fileName + "." + this.getDefaultFileExtension();
        }
        this.beans.downloader.download(fileName, data, this.getMimeType());
        return data;
    };
    BaseCreator.prototype.getData = function (params) {
        return this.getMergedParamsAndData(params).data;
    };
    BaseCreator.prototype.getMergedParamsAndData = function (userParams) {
        var mergedParams = this.mergeDefaultParams(userParams);
        var data = this.beans.gridSerializer.serialize(this.createSerializingSession(mergedParams), mergedParams);
        return { mergedParams: mergedParams, data: data };
    };
    BaseCreator.prototype.mergeDefaultParams = function (userParams) {
        var baseParams = this.beans.gridOptionsWrapper.getDefaultExportParams();
        var params = {};
        utils_1._.assign(params, baseParams);
        utils_1._.assign(params, userParams);
        return params;
    };
    return BaseCreator;
}());
exports.BaseCreator = BaseCreator;
var CsvCreator = (function (_super) {
    __extends(CsvCreator, _super);
    function CsvCreator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CsvCreator.prototype.postConstruct = function () {
        this.setBeans({
            downloader: this.downloader,
            gridSerializer: this.gridSerializer,
            gridOptionsWrapper: this.gridOptionsWrapper
        });
    };
    CsvCreator.prototype.exportDataAsCsv = function (params) {
        return this.export(params);
    };
    CsvCreator.prototype.getDataAsCsv = function (params) {
        return this.getData(params);
    };
    CsvCreator.prototype.getMimeType = function () {
        return "text/csv;charset=utf-8;";
    };
    CsvCreator.prototype.getDefaultFileName = function () {
        return 'export.csv';
    };
    CsvCreator.prototype.getDefaultFileExtension = function () {
        return 'csv';
    };
    CsvCreator.prototype.createSerializingSession = function (params) {
        return new CsvSerializingSession(this.columnController, this.valueService, this.gridOptionsWrapper, params ? params.processCellCallback : null, params ? params.processHeaderCallback : null, params && params.suppressQuotes, (params && params.columnSeparator) || ',');
    };
    CsvCreator.prototype.isExportSuppressed = function () {
        return this.gridOptionsWrapper.isSuppressCsvExport();
    };
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], CsvCreator.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('valueService'),
        __metadata("design:type", valueService_1.ValueService)
    ], CsvCreator.prototype, "valueService", void 0);
    __decorate([
        context_1.Autowired('downloader'),
        __metadata("design:type", downloader_1.Downloader)
    ], CsvCreator.prototype, "downloader", void 0);
    __decorate([
        context_1.Autowired('gridSerializer'),
        __metadata("design:type", gridSerializer_1.GridSerializer)
    ], CsvCreator.prototype, "gridSerializer", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], CsvCreator.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CsvCreator.prototype, "postConstruct", null);
    CsvCreator = __decorate([
        context_1.Bean('csvCreator')
    ], CsvCreator);
    return CsvCreator;
}(BaseCreator));
exports.CsvCreator = CsvCreator;


/***/ }),

/***/ "SfB7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("+E39") && !__webpack_require__("S82l")(function () {
  return Object.defineProperty(__webpack_require__("ON07")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "SlR/":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(974);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 971:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("cmba");

/***/ }),

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(971) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($) {

	    // Imports ================================================================
	    var kendo = window.kendo,
	        editorNS = kendo.ui.editor,
	        Command = editorNS.Command,
	        EditorUtils = editorNS.EditorUtils,
	        registerTool = EditorUtils.registerTool,
	        Tool = editorNS.Tool,
	        ToolTemplate = editorNS.ToolTemplate,
	        extend = $.extend;

	var ExportPdfCommand = Command.extend({
	    init: function(options) {
	        this.async = true;
	        Command.fn.init.call(this, options);
	    },

	    exec: function() {
	        var that = this;
	        var range = that.lockRange(true);
	        var editor = that.editor;

	        editor._destroyResizings();

	        editor.saveAsPDF().then(function() {
	            that.releaseRange(range);
	            editor._initializeColumnResizing();
	            editor._initializeRowResizing();
	            editor._initializeTableResizing();
	        });
	    }
	});

	extend(editorNS, {
	    ExportPdfCommand: ExportPdfCommand
	});

	registerTool("pdf", new Tool({ command: ExportPdfCommand, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Export PDF"})}));

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "Sx1C":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1079);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1079:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1080), __webpack_require__(1081), __webpack_require__(1082) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "chat",
	    name: "Chat",
	    category: "web",
	    description: "The Chat component.",
	    depends: [ "core", "draganddrop" ]
	};

	(function($, undefined) {

	    var kendo = window.kendo;
	    var Widget = kendo.ui.Widget;
	    var extend = $.extend;
	    var DOT = ".";

	    var chatStyles = {
	        wrapper: "k-widget k-chat",
	        canvas: "k-chat-canvas",
	        viewWrapper: "k-message-list",
	        messageBoxWrapper: "k-message-box",
	        toolbarBoxWrapper: "k-toolbar-box"
	    };

	    var Chat = Widget.extend({
	        init: function(element, options, events) {
	            Widget.fn.init.call(this, element, options);

	            if (events) {
	                this._events = events;
	            }

	            this._user();

	            this._wrapper();

	            this._view();

	            this._messageBox();

	            if(options && options.toolbar && options.toolbar.buttons) {
	                this._toolbar();
	            }

	            kendo.notify(this);
	        },

	        events: [
	            "typingStart",
	            "typingEnd",
	            "post",
	            "sendMessage",
	            "actionClick",
	            "toolClick"
	        ],

	        options: {
	            user: {
	                name: "User",
	                iconUrl: ""
	            },
	            name: "Chat",
	            messages: {
	                placeholder: "Type a message...",
	                toggleButton: "Toggle toolbar",
	                sendButton: "Send message"
	            },
	            toolbar: false
	        },

	        setOptions: function(options) {
	            this._setEvents(options);
	            $.extend(true, this.options, options);

	            if (this.toolbar && "toolbar" in options) {
	                this.toolbar.destroy();
	                this.toolbar = null;
	            }

	            if (this.messageBox) {
	                this.messageBox.unbind();
	                this.messageBox.destroy();
	                this.messageBox = null;
	            }

	            this._messageBox();

	            if ("toolbar" in options) {
	                this._resetToolbarButtons(options);
	                this._toolbar();
	            }
	        },

	        _resetToolbarButtons: function (options) {
	            var toolbarBoxWrapper = this.wrapper.find(DOT + chatStyles.toolbarBoxWrapper);

	            if(!toolbarBoxWrapper.is(":visible")){
	                toolbarBoxWrapper.show();
	            }

	            if(options.toolbar && typeof options.toolbar == "object" && "buttons" in options.toolbar) {
	                this.options.toolbar.buttons = options.toolbar.buttons;
	            }
	        },

	        destroy: function() {
	            if (this.view) {
	                this.view.unbind();
	                this.view.destroy();
	                this.view = null;
	            }

	            if (this.messageBox) {
	                this.messageBox.unbind();
	                this.messageBox.destroy();
	                this.messageBox = null;
	            }

	            if(this.toolbar) {
	                this.toolbar.destroy();
	                this.toolbar = null;
	            }

	            Widget.fn.destroy.call(this);
	        },

	        _user: function() {
	            this.options.user.id = kendo.guid();
	        },

	        getUser: function() {
	            return extend(true, {}, this.options.user);
	        },

	        _wrapper: function() {
	            var chatStyles = Chat.styles;
	            var options = this.options;
	            var height = options.height;
	            var width = options.width;
	            var uiElements = "<div class='" + chatStyles.viewWrapper + "'></div>" +
	                             "<div class='" + chatStyles.messageBoxWrapper + "'></div>" +
	                             "<div class='" + chatStyles.toolbarBoxWrapper + "' role='toolbar' style='display:none;'></div>";

	            this.wrapper = this.element
	                .addClass(chatStyles.wrapper)
	                .append(uiElements);

	            if (options.toolbar && options.toolbar.buttons && options.toolbar.buttons.length) {
	                this.wrapper.find(DOT + chatStyles.toolbarBoxWrapper).show();
	            }

	            if (height) {
	                this.wrapper.height(height);
	            }

	            if (width) {
	                this.wrapper.css("max-width", width);
	            }
	        },

	        _view: function() {
	            var that = this;
	            var chatStyles = Chat.styles;
	            var options = extend(true, {}, this.options);

	            var element = this.wrapper.find(DOT + chatStyles.viewWrapper + "");

	            this.view = new kendo.chat.ChatView(element, options);

	            this.view
	                .bind("actionClick", function(args) {
	                    that.trigger("actionClick", args);

	                    that.postMessage(args.text);
	                });
	        },

	        _messageBox: function() {
	            var that = this;
	            var chatStyles = Chat.styles;
	            var options = extend(true, {}, this.options);
	            var element = this.wrapper.find(DOT + chatStyles.messageBoxWrapper + "");

	            this.messageBox = new kendo.chat.ChatMessageBox(element, options);

	            this.messageBox
	                .bind("typingStart", function(args) {
	                    that.trigger("typingStart", args);
	                })
	                .bind("typingEnd", function(args) {
	                    that.trigger("typingEnd", args);
	                })
	                .bind("sendMessage", function(args) {
	                    that.trigger("sendMessage", args);

	                    that.postMessage(args.text);
	                })
	                .bind("toggleToolbar", function() {
	                    that.toggleToolbar();
	                });
	        },

	        _toolbar: function() {
	            var that = this;
	            var chatStyles = Chat.styles;
	            var options = extend(true, {}, that.options);
	            var element = that.wrapper.find(DOT + chatStyles.toolbarBoxWrapper + "");

	            if(options.toolbar.scrollable === undefined) {
	                this.options.toolbar.scrollable = options.toolbar.scrollable = true;
	            }

	            if(options.toolbar.toggleable === undefined) {
	                this.options.toolbar.toggleable = options.toolbar.toggleable = false;
	            }

	            that.toolbar = new kendo.chat.ChatToolBar(element, options);

	            that.toolbar.bind("click", function(ev){
	                that.trigger("toolClick", {
	                    sender: that,
	                    name: ev.name,
	                    button: ev.button,
	                    messageBox: that.messageBox.input[0],
	                    originalEvent: ev.originalEvent
	                });
	            });
	        },

	        postMessage: function(message) {
	            var postArgs = extend(true, {}, { text: message, type: "message", timestamp: new Date(), from: this.getUser() });

	            this.trigger("post", postArgs);

	            this.renderMessage(postArgs, postArgs.from);
	        },

	        // TEST calling View renderMessage
	        renderMessage: function(message, sender) {
	            this.view.renderMessage(message, sender);
	        },

	        // TEST calling View renderSuggestedActions
	        renderSuggestedActions: function(suggestedActions) {
	            this.view.renderSuggestedActions(suggestedActions);
	        },

	        // TEST calling View renderCard
	        renderAttachments: function(options, sender) {
	            this.view.renderAttachments(options, sender);
	        },

	        toggleToolbar: function (skipAnimation) {
	            this.toolbar.toggle(skipAnimation);
	        },

	        renderUserTypingIndicator: function(sender) {
	            this.view._renderTypingIndicator(sender);
	        },

	        clearUserTypingIndicator: function(sender) {
	            this.view._removeTypingParticipant(sender);
	        },

	        removeTypingIndicator: function() {
	            this.view._removeTypingIndicator();
	        }
	    });

	    kendo.ui.plugin(Chat);

	    extend(true, Chat, { styles: chatStyles });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1080:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("E02g");

/***/ }),

/***/ 1081:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("DJye");

/***/ }),

/***/ 1082:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("cUpd");

/***/ })

/******/ });

/***/ }),

/***/ "TC33":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1332);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1068:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("S/9S");

/***/ }),

/***/ 1069:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("jBxA");

/***/ }),

/***/ 1070:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("bFti");

/***/ }),

/***/ 1332:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1068), __webpack_require__(1069), __webpack_require__(1070) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "multiselect",
	    name: "MultiSelect",
	    category: "web",
	    description: "The MultiSelect widget allows the selection from pre-defined values.",
	    depends: [ "list" ],
	    features: [ {
	        id: "mobile-scroller",
	        name: "Mobile scroller",
	        description: "Support for kinetic scrolling in mobile device",
	        depends: [ "mobile.scroller" ]
	    }, {
	        id: "virtualization",
	        name: "VirtualList",
	        description: "Support for virtualization",
	        depends: [ "virtuallist" ]
	    } ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        List = ui.List,
	        keys = $.extend({ A: 65 }, kendo.keys),
	        activeElement = kendo._activeElement,
	        ObservableArray = kendo.data.ObservableArray,
	        proxy = $.proxy,
	        ID = "id",
	        LI = "li",
	        ACCEPT = "accept",
	        FILTER = "filter",
	        REBIND = "rebind",
	        OPEN = "open",
	        CLOSE = "close",
	        CHANGE = "change",
	        PROGRESS = "progress",
	        SELECT = "select",
	        DESELECT = "deselect",
	        ARIA_DISABLED = "aria-disabled",
	        ARIA_READONLY = "aria-readonly",
	        FOCUSEDCLASS = "k-state-focused",
	        SELECTEDCLASS = "k-state-selected",
	        HIDDENCLASS = "k-hidden",
	        HOVERCLASS = "k-state-hover",
	        STATEDISABLED = "k-state-disabled",
	        NOCLICKCLASS = "k-no-click",
	        DISABLED = "disabled",
	        READONLY = "readonly",
	        AUTOCOMPLETEVALUE = "off",
	        ns = ".kendoMultiSelect",
	        CLICK = "click" + ns,
	        KEYDOWN = "keydown" + ns,
	        MOUSEENTER = "mouseenter" + ns,
	        MOUSELEAVE = "mouseleave" + ns,
	        HOVEREVENTS = MOUSEENTER + " " + MOUSELEAVE,
	        quotRegExp = /"/g,
	        isArray = $.isArray,
	        styles = ["font-family",
	                  "font-size",
	                  "font-stretch",
	                  "font-style",
	                  "font-weight",
	                  "letter-spacing",
	                  "text-transform",
	                  "line-height"];

	    var MultiSelect = List.extend({
	        init: function(element, options) {
	            var that = this, id, disabled;

	            that.ns = ns;
	            List.fn.init.call(that, element, options);

	            that._optionsMap = {};
	            that._customOptions = {};

	            that._wrapper();
	            that._tagList();
	            that._input();
	            that._textContainer();
	            that._loader();
	            that._clearButton();

	            that._tabindex(that.input);

	            element = that.element.attr("multiple", "multiple").hide();
	            options = that.options;

	            if (!options.placeholder) {
	                options.placeholder = element.data("placeholder");
	            }

	            id = element.attr(ID);

	            if (id) {
	                that._tagID = id + "_tag_active";

	                id = id + "_taglist";
	                that.tagList.attr(ID, id);

	                that.input.attr("aria-describedby", id);
	            }

	            that._initialOpen = true;
	            that._ariaLabel();
	            that._ariaSetLive();
	            that._dataSource();
	            that._ignoreCase();
	            that._popup();

	            that._tagTemplate();
	            that.requireValueMapper(that.options);
	            that._initList();

	            that._reset();
	            that._enable();
	            that._placeholder();

	            if (options.autoBind) {
	                that.dataSource.fetch();
	            } else if (options.value) {
	                that._preselect(options.value);
	            }

	            disabled = $(that.element).parents("fieldset").is(':disabled');

	            if (disabled) {
	                that.enable(false);
	            }

	            that._ariaSetSize(that.value().length);

	            kendo.notify(that);
	            that._toggleCloseVisibility();
	        },

	        options: {
	            name: "MultiSelect",
	            tagMode: "multiple",
	            enabled: true,
	            autoBind: true,
	            autoClose: true,
	            highlightFirst: true,
	            dataTextField: "",
	            dataValueField: "",
	            filter: "startswith",
	            ignoreCase: true,
	            minLength: 1,
	            messages: {
	                "singleTag": "item(s) selected",
	                "clear": "clear",
	                "deleteTag": "delete",
	                "noData": "No data found."
	            },
	            enforceMinLength: false,
	            delay: 100,
	            value: null,
	            maxSelectedItems: null,
	            placeholder: "",
	            height: 200,
	            animation: {},
	            virtual: false,
	            itemTemplate: "",
	            tagTemplate: "",
	            groupTemplate: "#:data#",
	            fixedGroupTemplate: "#:data#",
	            clearButton: true,
	            autoWidth: false,
	            popup: null
	        },

	        events: [
	            OPEN,
	            CLOSE,
	            CHANGE,
	            SELECT,
	            DESELECT,
	            "filtering",
	            "dataBinding",
	            "dataBound"
	        ],

	        setDataSource: function(dataSource) {
	            this.options.dataSource = dataSource;

	            this._state = "";
	            this._dataSource();

	            this.persistTagList = false;
	            this.listView.setDataSource(this.dataSource);

	            if (this.options.autoBind) {
	                this.dataSource.fetch();
	            }
	        },

	        setOptions: function(options) {
	            var listOptions = this._listOptions(options);

	            List.fn.setOptions.call(this, options);

	            this.listView.setOptions(listOptions);

	            this._accessors();
	            this._aria(this.tagList.attr(ID));
	            this._tagTemplate();
	            this._placeholder();
	            this._clearButton();
	        },

	        currentTag: function(candidate) {
	            var that = this;

	            if (candidate !== undefined) {
	                if (that._currentTag) {
	                    that._currentTag
	                        .removeClass(FOCUSEDCLASS)
	                        .removeAttr(ID);

	                    that._currentTag.find(".k-select").attr("aria-hidden", true);

	                    that.input.removeAttr("aria-activedescendant");
	                }

	                if (candidate) {
	                    candidate.addClass(FOCUSEDCLASS).attr(ID, that._tagID);

	                    candidate.find(".k-select").removeAttr("aria-hidden");

	                    that.input.attr("aria-activedescendant", that._tagID);
	                }

	                that._currentTag = candidate;
	            } else {
	                return that._currentTag;
	            }
	        },

	        dataItems: function() {
	            return this.listView.selectedDataItems();
	        },

	        destroy: function() {
	            var that = this,
	                ns = that.ns;

	            clearTimeout(that._busy);
	            clearTimeout(that._typingTimeout);

	            that.wrapper.off(ns);
	            that.tagList.off(ns);
	            that.input.off(ns);
	            that._clear.off(ns);

	            List.fn.destroy.call(that);
	        },

	        _activateItem: function() {
	            if (this.popup.visible()) {
	                List.fn._activateItem.call(this);
	            }
	            this.currentTag(null);
	        },

	        _listOptions: function(options) {
	            var that = this;
	            var listOptions = List.fn._listOptions.call(that, $.extend(options, {
	                selectedItemChange: proxy(that._selectedItemChange, that),
	                selectable: "multiple"
	            }));

	            var itemTemplate = this.options.itemTemplate || this.options.template;
	            var template = listOptions.itemTemplate || itemTemplate || listOptions.template;

	            if (!template) {
	                template = "#:" + kendo.expr(listOptions.dataTextField, "data") + "#";
	            }

	            listOptions.template = template;

	            return listOptions;
	        },

	        _setListValue: function() {
	            List.fn._setListValue.call(this, this._initialValues.slice(0));
	        },

	        _listChange: function(e) {
	            var data = this.dataSource.flatView();
	            var optionsMap = this._optionsMap;
	            var valueGetter = this._value;

	            if (this._state === REBIND) {
	                this._state = "";
	            }

	            for (var i = 0; i < e.added.length; i++) {
	                if (optionsMap[valueGetter(e.added[i].dataItem)] === undefined) {
	                    this._render(data); //render select element <option> tags if the item does not persist in the current data view
	                    break;
	                }
	            }

	            this._selectValue(e.added, e.removed);
	        },

	        _selectedItemChange: function(e) {
	            var items = e.items;
	            var context;
	            var idx;

	            for (idx = 0; idx < items.length; idx++) {
	                context = items[idx];
	                this.tagList.children().eq(context.index).children("span:first").html(this.tagTextTemplate(context.item));
	            }
	        },

	        _wrapperMousedown: function(e) {
	            var that = this;
	            var notInput = e.target.nodeName.toLowerCase() !== "input";
	            var target = $(e.target);
	            var closeButton = target.hasClass("k-select") || target.hasClass("k-icon");

	            if (closeButton) {
	                closeButton = !target.closest(".k-select").children(".k-i-arrow-60-down").length;
	            }

	            if (notInput && !(closeButton && kendo.support.mobileOS) && e.cancelable) {
	                e.preventDefault();
	            }

	            if (!closeButton) {
	                if (that.input[0] !== activeElement() && notInput) {
	                    that.input.focus();
	                }

	                if (that.options.minLength === 1) {
	                    that.open();
	                }
	            }

	        },

	        _inputFocus: function() {
	            this._placeholder(false);
	            this.wrapper.addClass(FOCUSEDCLASS);
	        },

	        _inputFocusout: function() {
	            var that = this;

	            clearTimeout(that._typingTimeout);

	            that.wrapper.removeClass(FOCUSEDCLASS);

	            that._placeholder(!that.listView.selectedDataItems()[0], true);
	            that.close();

	            if (that._state === FILTER) {
	                that._state = ACCEPT;
	                that.listView.skipUpdate(true);
	            }

	            if(that.listView.bound() && that.listView.isFiltered()) {
	                that.persistTagList = true;
	                that._clearFilter();
	            }

	            that.element.blur();
	        },

	        _removeTag: function(tag, shouldTrigger) {
	            var that = this;
	            var state = that._state;
	            var position = tag.index();
	            var listView = that.listView;
	            var value = listView.value()[position];
	            var dataItem = that.listView.selectedDataItems()[position];
	            var customIndex = that._customOptions[value];
	            var listViewChildren = listView.element[0].children;
	            var option;
	            var listViewChild;

	            if (that.trigger(DESELECT, { dataItem: dataItem, item: tag })) {
	                that._close();
	                return;
	            }

	            if (customIndex === undefined && (state === ACCEPT || state === FILTER)) {
	                customIndex = that._optionsMap[value];
	            }

	            var done = function() {
	                that.currentTag(null);
	                if (shouldTrigger) {
	                    that._change();
	                }
	                that._close();
	            };

	            if (customIndex === undefined && listView.select().length) {
	                that.persistTagList = false;
	                listView.select(listView.select()[position]).done(done);
	            } else {
	                option = that.element[0].children[customIndex];
	                if (option) {
	                    option.selected = false;
	                }

	                listView.removeAt(position);
	                listViewChild = listViewChildren[customIndex];
	                if (listViewChild) {
	                    listViewChildren[customIndex].classList.remove("k-state-selected");
	                }
	                if (that.options.tagMode !== "single"){
	                    tag.remove();
	                } else {
	                    that._updateTagListHTML();
	                }
	                done();
	            }
	        },

	        _tagListClick: function(e) {
	            e.preventDefault();
	            e.stopPropagation();
	            var target = $(e.currentTarget);

	            if (!target.children(".k-i-arrow-60-down").length) {
	                this._removeTag(target.closest(LI), true);
	            }
	        },

	        _clearValue: function() {
	            var that = this;

	            if (that.options.tagMode === "single"){
	                that._clearSingleTagValue();
	            } else{
	                that.tagList.children().each(function(index, tag) {
	                    that._removeTag($(tag), false);
	                });
	            }

	            that.input.val("");
	            that._search();
	            that._change();
	            that.focus();
	            that._hideClear();

	            if (that._state === FILTER) {
	                that._state = ACCEPT;
	            }
	        },

	        _clearSingleTagValue: function() {
	            var that = this;
	            var items = that.dataItems();
	            var tags = that.tagList.children();
	            var persistTagList = that.persistTagList;

	            for (var i = 0; i < items.length; i += 1) {
	                if (that.trigger(DESELECT, { dataItem: items[i], item: tags.first() })) {
	                    that._close();
	                    return;
	                }
	            }

	            if (persistTagList) {
	                that.persistTagList = false;
	            }

	            that.listView.value([]);
	            that.persistTagList = persistTagList;
	        },

	        _focusHandler: function() {
	            this.input.focus();
	        },

	        _editable: function(options) {
	            var that = this,
	                disable = options.disable,
	                readonly = options.readonly,
	                wrapper = that.wrapper.off(ns),
	                tagList = that.tagList.off(ns),
	                input = that.element.add(that.input.off(ns));

	            if (!readonly && !disable) {
	                wrapper
	                    .removeClass(STATEDISABLED)
	                    .removeClass(NOCLICKCLASS)
	                    .on(HOVEREVENTS, that._toggleHover)
	                    .on("mousedown" + ns + " touchend" + ns, proxy(that._wrapperMousedown, that))
	                    .on(CLICK, proxy(that._focusHandler, that));

	                that.input.on(KEYDOWN, proxy(that._keydown, that))
	                    .on("paste" + ns, proxy(that._search, that))
	                    .on("input" + ns, proxy(that._search, that))
	                    .on("focus" + ns, proxy(that._inputFocus, that))
	                    .on("focusout" + ns, proxy(that._inputFocusout, that));

	                that._clear.on(CLICK + " touchend" + ns, proxy(that._clearValue, that));
	                input.removeAttr(DISABLED)
	                     .removeAttr(READONLY)
	                     .attr(ARIA_DISABLED, false)
	                     .attr(ARIA_READONLY, false);

	                tagList
	                    .on(MOUSEENTER, LI, function() { $(this).addClass(HOVERCLASS); })
	                    .on(MOUSELEAVE, LI, function() { $(this).removeClass(HOVERCLASS); })
	                    .on(CLICK + " touchend" + ns, "li.k-button .k-select", proxy(that._tagListClick, that));
	            } else {

	                wrapper.toggleClass(STATEDISABLED, disable)
	                       .toggleClass(NOCLICKCLASS, readonly);

	                input.attr(DISABLED, disable)
	                     .attr(READONLY, readonly)
	                     .attr(ARIA_DISABLED, disable)
	                     .attr(ARIA_READONLY, readonly);
	            }
	        },

	        _close: function() {
	            var that = this;
	            if (that.options.autoClose) {
	                that.close();
	            } else {
	                that.popup.position();
	            }
	        },

	        _filterSource: function(filter, force) {
	            if(!force) {
	                force = this._retrieveData;
	            }
	            this._retrieveData = false;
	            List.fn._filterSource.call(this, filter, force);
	        },

	        close: function() {
	            this._activeItem = null;
	            this.input.removeAttr("aria-activedescendant");

	            this.popup.close();
	        },

	        open: function() {
	            var that = this;

	            if (that._request) {
	                that._retrieveData = false;
	            }

	            if (that._retrieveData || !that.listView.bound() || that._state === ACCEPT) {
	                that._open = true;
	                that._state = REBIND;

	                that.listView.skipUpdate(true);

	                that.persistTagList = that._initialOpen && !that.listView.bound() ? false : true;
	                that._filterSource();
	                that._focusItem();
	            } else if (that._allowOpening()) {

	                //selects values in autoBind false and non virtual scenario on initial load
	                if (that._initialOpen && !that.options.autoBind && !that.options.virtual && that.options.value && !$.isPlainObject(that.options.value[0])){
	                    that.value(that.value() || that._initialValues);
	                }

	                // In some cases when the popup is opened resize is triggered which will cause it to close
	                // Setting the below flag will prevent this from happening
	                that.popup._hovered = true;
	                that._initialOpen = false;
	                that.popup.open();
	                that._focusItem();
	            }
	        },

	        toggle: function(toggle) {
	            toggle = toggle !== undefined ? toggle : !this.popup.visible();

	            this[toggle ? OPEN : CLOSE]();
	        },

	        refresh: function() {
	            this.listView.refresh();
	        },

	        _listBound: function() {
	            var that = this;
	            var data = that.dataSource.flatView();

	            that._render(data);
	            that._renderFooter();
	            that._renderNoData();
	            that._toggleNoData(!data.length);
	            that._resizePopup();
	            that._updateItemFocus();

	            if (that._open) {
	                that._open = false;
	                that.toggle(that._allowOpening());
	            }

	            that.popup.position();

	            if (that._touchScroller) {
	                that._touchScroller.reset();
	            }

	            that._hideBusy();
	            that._makeUnselectable();

	            that.trigger("dataBound");
	        },

	        _updateItemFocus: function() {
	            var that = this,
	                data = that.dataSource.flatView(),
	                skip = that.listView.skip(),
	                isFirstPage = skip === undefined || skip === 0;

	            if (data.length && isFirstPage) {
	                if (!that.options.highlightFirst) {
	                    that.listView.focus(-1);
	                } else {
	                    that.listView.focusFirst();
	                }
	            }
	        },

	        _inputValue: function() {
	            var that = this;
	            var inputValue = that.input.val();

	            if (that.options.placeholder === inputValue) {
	                inputValue = "";
	            }
	            return inputValue;
	        },

	        value: function(value) {
	            var that = this;
	            var listView = that.listView;
	            var oldValue = listView.value().slice();
	            var maxSelectedItems = that.options.maxSelectedItems;
	            var clearFilters = listView.bound() && listView.isFiltered();

	            if (value === undefined) {
	                return oldValue;
	            }

	            that.persistTagList = false;
	            that.requireValueMapper(that.options, value);

	            value = that._normalizeValues(value);

	            if (maxSelectedItems !== null && value.length > maxSelectedItems) {
	                value = value.slice(0, maxSelectedItems);
	            }

	            if (clearFilters) {
	                that._clearFilter();
	            }

	            listView.value(value);
	            that._old = that._valueBeforeCascade = value.slice(); //get a new array reference

	            if (!clearFilters) {
	                that._fetchData();
	            }

	            that._ariaSetSize(that.value().length);

	            that._toggleCloseVisibility();
	        },

	        _preselect: function(data, value) {
	            var that = this;

	            if (!isArray(data) && !(data instanceof kendo.data.ObservableArray)) {
	                data = [data];
	            }

	            if ($.isPlainObject(data[0]) || data[0] instanceof kendo.data.ObservableObject || !that.options.dataValueField) {
	                that.dataSource.data(data);
	                that.value(value || that._initialValues);
	                that._retrieveData = true;
	            }
	        },

	        _setOption: function(value, selected) {
	            var option = this.element[0].children[this._optionsMap[value]];

	            if (option) {
	                option.selected = selected;
	            }
	        },

	        _fetchData: function() {
	            var that = this;
	            var hasItems = !!that.dataSource.view().length;
	            var isEmptyArray = that.listView.value().length === 0;

	            if (isEmptyArray || that._request) {
	                return;
	            }

	            if (that._retrieveData || (!that._fetch && !hasItems)) {
	                that._fetch = true;
	                that._retrieveData = false;
	                that.dataSource.read().done(function() {
	                    that._fetch = false;
	                });
	            }
	        },

	        _isBound: function() {
	            return this.listView.bound() && !this._retrieveData;
	        },

	        _dataSource: function() {
	            var that = this,
	                element = that.element,
	                options = that.options,
	                dataSource = options.dataSource || {};

	            dataSource = isArray(dataSource) ? {data: dataSource} : dataSource;

	            dataSource.select = element;
	            dataSource.fields = [{ field: options.dataTextField },
	                                 { field: options.dataValueField }];

	            if (that.dataSource && that._refreshHandler) {
	                that._unbindDataSource();
	            } else {
	                that._progressHandler = proxy(that._showBusy, that);
	                that._errorHandler = proxy(that._hideBusy, that);
	            }

	            that.dataSource = kendo.data.DataSource.create(dataSource)
	                                   .bind(PROGRESS, that._progressHandler)
	                                   .bind("error", that._errorHandler);
	        },

	        _reset: function() {
	            var that = this,
	                element = that.element,
	                formId = element.attr("form"),
	                form = formId ? $("#" + formId) : element.closest("form");

	            if (form[0]) {
	                that._resetHandler = function() {
	                    setTimeout(function() {
	                        that.value(that._initialValues);
	                        that._placeholder();
	                    });
	                };

	                that._form = form.on("reset", that._resetHandler);
	            }
	        },

	        _initValue: function() {
	            var value = this.options.value || this.element.val();

	            this._old = this._initialValues = this._normalizeValues(value);
	        },

	        _normalizeValues: function(value) {
	            var that = this;

	            if (value === null) {
	                value = [];
	            } else if (value && $.isPlainObject(value)) {
	                value = [that._value(value)];
	            } else if (value && $.isPlainObject(value[0])) {
	                value = $.map(value, function(dataItem) { return that._value(dataItem); });
	            } else if (!isArray(value) && !(value instanceof ObservableArray)) {
	                value = [value];
	            } else if (isArray(value)) {
	                value = value.slice();
	            }

	            return value;
	        },

	        _change: function() {
	            var that = this,
	                value = that.value();

	            if (!compare(value, that._old)) {
	                that._old = value.slice();

	                that.trigger(CHANGE);

	                // trigger the DOM change event so any subscriber gets notified
	                that.element.trigger(CHANGE);
	            }
	            that.popup.position();

	            that._ariaSetSize(value.length);

	            that._toggleCloseVisibility();
	        },

	        _click: function(e) {
	            var that = this;
	            var item = e.item;

	            e.preventDefault();

	            that._select(item).done(function() {
	                that._activeItem = item;
	                that._change();
	                that._close();
	            });
	        },

	        _getActiveItem: function() {
	            return this._activeItem || $(this.listView.items()[this._getSelectedIndices().length - 1]) || this.listView.focus();
	        },

	        _getSelectedIndices: function() {
	            return this.listView._selectedIndices || this.listView._selectedIndexes;
	        },

	        _keydown: function(e) {
	            var that = this;
	            var key = e.keyCode;
	            var tag = that._currentTag;
	            var listView = that.listView;
	            var hasValue = that.input.val();
	            var isRtl = kendo.support.isRtl(that.wrapper);
	            var visible = that.popup.visible();
	            var dir = 0;
	            var activeItemIdx;

	            if(key !== keys.ENTER) {
	                this._multipleSelection = false;
	            }

	             if (key === keys.DOWN) {
	                e.preventDefault();

	                if (!visible) {
	                    that.open();

	                    if (!listView.focus()) {
	                        listView.focusFirst();
	                    }
	                    return;
	                }

	                if (listView.focus()) {
	                    if (!that._activeItem && e.shiftKey) {
	                        that._activeItem = listView.focus();
	                        dir = -1;
	                    }
	                    activeItemIdx = listView.getElementIndex(that._getActiveItem().first());

	                    listView.focusNext();
	                    if (!listView.focus()) {
	                        listView.focusLast();
	                    } else {
	                        if (e.shiftKey) {
	                            this._multipleSelection = true;
	                            that._selectRange(activeItemIdx, listView.getElementIndex(listView.focus().first()) + dir);
	                        }
	                    }
	                } else {
	                    listView.focusFirst();
	                }

	            } else if (key === keys.UP) {
	                if (visible) {
	                    if (!that._activeItem && e.shiftKey) {
	                        that._activeItem = listView.focus();
	                        dir = 1;
	                    }
	                    activeItemIdx = listView.getElementIndex(that._getActiveItem().first());
	                    listView.focusPrev();
	                    if (!listView.focus()) {
	                        that.close();
	                    } else {
	                        if (e.shiftKey) {
	                            this._multipleSelection = true;
	                            that._selectRange(activeItemIdx, listView.getElementIndex(listView.focus().first()) + dir);
	                        }
	                    }
	                }
	                e.preventDefault();
	            } else if ((key === keys.LEFT && !isRtl) || (key === keys.RIGHT && isRtl)) {
	                if (!hasValue) {
	                    tag = tag ? tag.prev() : $(that.tagList[0].lastChild);
	                    if (tag[0]) {
	                        that.currentTag(tag);
	                    }
	                }
	            } else if ((key === keys.RIGHT && !isRtl) || (key === keys.LEFT && isRtl)) {
	                if (!hasValue && tag) {
	                    tag = tag.next();
	                    that.currentTag(tag[0] ? tag : null);
	                }
	            } else if (e.ctrlKey && !e.altKey && key === keys.A && visible && !that.options.virtual) {
	                this._multipleSelection = true;
	                if (this._getSelectedIndices().length === listView.items().length) {
	                    that._activeItem = null;
	                }

	                if (listView.items().length) {
	                    that._selectRange(0, listView.items().length -1);
	                }
	            } else if (key === keys.ENTER && visible) {
	                if (!listView.focus()) {
	                    return;
	                }

	                e.preventDefault();

	                if (this._multipleSelection) {
	                    this._multipleSelection = false;
	                     if (listView.focus().hasClass(SELECTEDCLASS)) {
	                        that._close();
	                        return;
	                    }
	                }

	                that._select(listView.focus()).done(function() {
	                    that._change();
	                    that._close();
	                });
	            } else if (key === keys.SPACEBAR && e.ctrlKey && visible) {
	                if (that._activeItem && listView.focus() && listView.focus()[0] === that._activeItem[0]) {
	                    that._activeItem = null;
	                }
	                if (!$(listView.focus()).hasClass(SELECTEDCLASS)) {
	                    that._activeItem = listView.focus();
	                }
	                that._select(listView.focus()).done(function () {
	                    that._change();
	                });
	                e.preventDefault();
	            } else if (key === keys.SPACEBAR && e.shiftKey && visible) {
	                var activeIndex = listView.getElementIndex(that._getActiveItem());
	                var currentIndex = listView.getElementIndex(listView.focus());

	                if (activeIndex !== undefined && currentIndex !== undefined) {
	                    that._selectRange(activeIndex, currentIndex);
	                }

	                e.preventDefault();
	            } else if (key === keys.ESC) {
	                if (visible) {
	                    e.preventDefault();
	                } else {
	                    that.tagList.children().each(function(index, tag) {
	                        that._removeTag($(tag), false);
	                    });
	                    that._change();
	                }

	                that.close();
	            } else if (key === keys.HOME) {
	                if (visible) {
	                    if (!listView.focus()) {
	                        that.close();
	                    } else {
	                        if (e.ctrlKey && e.shiftKey && !that.options.virtual) {
	                            that._selectRange(listView.getElementIndex(listView.focus()[0]), 0);
	                        }
	                        listView.focusFirst();
	                    }
	                } else if (!hasValue) {
	                    tag = that.tagList[0].firstChild;

	                    if (tag) {
	                        that.currentTag($(tag));
	                    }
	                }
	            } else if (key === keys.END) {
	                if (visible) {
	                    if (!listView.focus()) {
	                        that.close();
	                    } else {
	                        if (e.ctrlKey && e.shiftKey && !that.options.virtual) {
	                            that._selectRange(
	                                listView.getElementIndex(listView.focus()[0]),
	                                listView.element.children().length - 1
	                            );
	                        }
	                        listView.focusLast();
	                    }
	                } else if (!hasValue) {
	                    tag = that.tagList[0].lastChild;

	                    if (tag) {
	                        that.currentTag($(tag));
	                    }
	                }
	            } else if ((key === keys.DELETE || key === keys.BACKSPACE) && !hasValue) {
	                that._state = ACCEPT;

	                if (that.options.tagMode === "single") {
	                    that._clearSingleTagValue();

	                    that._change();
	                    that._close();
	                    return;
	                }

	                if (key === keys.BACKSPACE && !tag) {
	                    tag = $(that.tagList[0].lastChild);
	                }

	                if (tag && tag[0]) {
	                    that._removeTag(tag, true);
	                }
	            } else if (that.popup.visible() && (key === keys.PAGEDOWN || key === keys.PAGEUP)) {
	                e.preventDefault();

	                var direction = key === keys.PAGEDOWN ? 1: -1;
	                listView.scrollWith(direction * listView.screenHeight());
	            } else {
	                clearTimeout(that._typingTimeout);
	                setTimeout(function() {
	                    that._scale();
	                });
	                that._search();
	            }
	        },

	        _hideBusy: function () {
	            var that = this;
	            clearTimeout(that._busy);
	            that.input.attr("aria-busy", false);
	            that._loading.addClass(HIDDENCLASS);
	            that._request = false;
	            that._busy = null;

	            that._toggleCloseVisibility();
	        },

	        _showBusyHandler: function() {
	            this.input.attr("aria-busy", true);
	            this._loading.removeClass(HIDDENCLASS);
	            this._hideClear();
	        },

	        _showBusy: function () {
	            var that = this;

	            that._request = true;

	            if (that._busy) {
	                return;
	            }

	            that._busy = setTimeout(proxy(that._showBusyHandler, that), 100);
	        },

	        _placeholder: function(show, skipCaret) {
	            var that = this;
	            var input = that.input;
	            var active = activeElement();
	            var placeholder = that.options.placeholder;
	            var inputValue = input.val();
	            var isActive = input[0] === active;
	            var caretPos = inputValue.length;

	            if (!isActive || that.options.autoClose || inputValue === placeholder) {
	                caretPos = 0;
	                inputValue = "";
	            }

	            if (show === undefined) {
	                show = false;
	                if (input[0] !== active) {
	                    show = !that.listView.selectedDataItems()[0];
	                }
	            }

	            that._prev = inputValue;
	            input.toggleClass("k-readonly", show).val(show ? placeholder : inputValue);

	            if (isActive && !skipCaret) {
	                kendo.caret(input[0], caretPos, caretPos);
	            }

	            that._scale();
	        },

	        _scale: function() {
	            var that = this,
	                wrapper = that.wrapper.find(".k-multiselect-wrap"),
	                wrapperWidth = wrapper.width(),
	                span = that._span.text(that.input.val()),
	                textWidth;

	            if (!wrapper.is(":visible")) {
	                span.appendTo(document.documentElement);
	                wrapperWidth = textWidth = span.width() + 25;
	                span.appendTo(wrapper);
	            } else {
	                textWidth = span.width() + 25;
	            }

	            that.input.width(textWidth > wrapperWidth ? wrapperWidth : textWidth);
	        },

	        _option: function(dataValue, dataText, selected) {
	            var option = "<option";

	            if (dataValue !== undefined) {
	                dataValue += "";

	                if (dataValue.indexOf('"') !== -1) {
	                    dataValue = dataValue.replace(quotRegExp, "&quot;");
	                }

	                option += ' value="' + dataValue + '"';
	            }

	            if (selected) {
	                option += ' selected';
	            }

	            option += ">";

	            if (dataText !== undefined) {
	                option += kendo.htmlEncode(dataText);
	            }

	            return option += "</option>";
	        },

	        _render: function(data) {
	            var selectedItems = this.listView.selectedDataItems();
	            var values = this.listView.value();
	            var length = data.length;
	            var selectedIndex;
	            var options = "";
	            var dataItem;
	            var value;
	            var idx;

	            if (values.length !== selectedItems.length) {
	                selectedItems = this._buildSelectedItems(values);
	            }

	            var custom = {};
	            var optionsMap = {};

	            for (idx = 0; idx < length; idx++) {
	                dataItem = data[idx];
	                value = this._value(dataItem);

	                selectedIndex = this._selectedItemIndex(value, selectedItems);
	                if (selectedIndex !== -1) {
	                    selectedItems.splice(selectedIndex, 1);
	                }

	                optionsMap[value] = idx;
	                options += this._option(value, this._text(dataItem), selectedIndex !== -1);
	            }

	            if (selectedItems.length) {
	                for (idx = 0; idx < selectedItems.length; idx++) {
	                    dataItem = selectedItems[idx];

	                    value = this._value(dataItem);
	                    custom[value] = length;
	                    optionsMap[value] = length;

	                    length += 1;
	                    options += this._option(value, this._text(dataItem), true);
	                }
	            }

	            this._customOptions = custom;
	            this._optionsMap = optionsMap;

	            this.element.html(options);
	        },

	        _buildSelectedItems: function(values) {
	            var valueField = this.options.dataValueField;
	            var textField = this.options.dataTextField;
	            var result = [];
	            var item;

	            for (var idx = 0; idx < values.length; idx++) {
	                item = {};
	                item[valueField] = values[idx];
	                item[textField] = values[idx];

	                result.push(item);
	            }

	            return result;
	        },

	        _selectedItemIndex: function(value, selectedItems) {
	            var valueGetter = this._value;
	            var idx = 0;

	            for (; idx < selectedItems.length; idx++) {
	                if (value === valueGetter(selectedItems[idx])) {
	                    return idx;
	                }
	            }

	            return -1;
	        },

	        _search: function() {
	            var that = this;

	            clearTimeout(that._typingTimeout);

	            that._typingTimeout = setTimeout(function() {
	                var value = that._inputValue();
	                if (that._prev !== value) {
	                    that._prev = value;
	                    that.search(value);
	                    that._toggleCloseVisibility();
	                }
	            }, that.options.delay);
	        },

	        _toggleCloseVisibility: function() {
	            if (this.value().length || (this.input.val() && this.input.val() !== this.options.placeholder)) {
	                this._showClear();
	            } else {
	                this._hideClear();
	            }
	        },

	        _allowOpening: function() {
	            return this._allowSelection() && List.fn._allowOpening.call(this);
	        },

	        _allowSelection: function() {
	            var max = this.options.maxSelectedItems;
	            return max === null || max > this.listView.value().length;
	        },

	        _angularTagItems: function(cmd) {
	            var that = this;

	            that.angular(cmd, function() {
	                return {
	                    elements: that.tagList[0].children,
	                    data: $.map(that.dataItems(), function(dataItem) {
	                        return { dataItem: dataItem };
	                    })
	                };
	            });
	        },

	        updatePersistTagList: function(added, removed){
	            if(this.persistTagList.added &&
	                this.persistTagList.added.length === removed.length &&
	                this.persistTagList.removed &&
	                this.persistTagList.removed.length === added.length){
	                    this.persistTagList = false;
	             }else{
	                 this.listView._removedAddedIndexes = this._old.slice();
	                 this.persistTagList = {
	                     added: added,
	                     removed: removed
	                 };
	             }
	        },

	        _selectValue: function (added, removed) {
	            var that = this;
	            var total = that.dataSource.total();
	            var tagList = that.tagList;
	            var getter = that._value;
	            var removedItem;
	            var addedItem;
	            var idx;

	            if(this.persistTagList){
	                this.updatePersistTagList(added, removed);

	                return;
	            }

	            that._angularTagItems("cleanup");

	            if (that.options.tagMode === "multiple") {
	                for (idx = removed.length - 1; idx > -1; idx--) {
	                    removedItem = removed[idx];

	                    if (tagList.children().length) {
	                        tagList[0].removeChild(tagList[0].children[removedItem.position]);
	                        that._setOption(getter(removedItem.dataItem), false);
	                    }
	                }

	                for (idx = 0; idx < added.length; idx++) {
	                    addedItem = added[idx];

	                    tagList.append(that.tagTemplate(addedItem.dataItem));

	                    that._setOption(getter(addedItem.dataItem), true);
	                }

	                that._updateTagListAria();
	            } else {
	                if (!that._maxTotal || that._maxTotal < total) {
	                    that._maxTotal = total;
	                }

	                this._updateTagListHTML();

	                for (idx = removed.length - 1; idx > -1; idx--) {
	                    that._setOption(getter(removed[idx].dataItem), false);
	                }

	                for (idx = 0; idx < added.length; idx++) {
	                    that._setOption(getter(added[idx].dataItem), true);
	                }
	            }

	            that._angularTagItems("compile");
	            that._placeholder();
	        },

	        _updateTagListHTML: function(){
	            var that = this;
	            var values = that.value();
	            var total = that.dataSource.total();
	            var tagList = that.tagList;

	            tagList.html("");

	            if (values.length) {
	                tagList.append(that.tagTemplate({
	                    values: values,
	                    dataItems: that.dataItems(),
	                    maxTotal: that._maxTotal,
	                    currentTotal: total
	                }));
	            }

	            that._updateTagListAria();
	        },

	        _updateTagListAria: function () {
	            var that = this;
	            var tagList = that.tagList;

	            tagList.attr("role", tagList.children().length ? "listbox" : "presentation");
	        },

	        _select: function(candidate) {
	            var resolved = $.Deferred().resolve();

	            if (!candidate) {
	                return resolved;
	            }

	            var that = this;
	            var listView = that.listView;
	            var dataItem = listView.dataItemByIndex(listView.getElementIndex(candidate));
	            var isSelected = candidate.hasClass("k-state-selected");

	            if (that._state === REBIND) {
	                that._state = "";
	            }

	            if (!that._allowSelection() && !isSelected) {
	                return resolved;
	            }

	            if (that.trigger(isSelected ? DESELECT : SELECT, { dataItem: dataItem, item: candidate })) {
	                that._close();
	                return resolved;
	            }

	            that.persistTagList = false;
	            return listView.select(candidate).done(function() {
	                that._placeholder();

	                if (that._state === FILTER) {
	                    that._state = ACCEPT;
	                    listView.skipUpdate(true);
	                }
	            });
	        },

	        _selectRange: function (startIndex, endIndex) {
	            var that = this;
	            var listView = this.listView;
	            var maxSelectedItems = this.options.maxSelectedItems;
	            var indices = this._getSelectedIndices().slice();
	            var indicesToSelect = [];
	            var i;

	            var selectIndices = function(indices) {
	                listView.select(indices).done(function() {
	                    indices.forEach(function(index) {
	                        var dataItem  = listView.dataItemByIndex(index);
	                        var candidate = listView.element.children()[index];
	                        var isSelected = $(candidate).hasClass("k-state-selected");

	                        that.trigger(isSelected ? SELECT : DESELECT, {dataItem: dataItem, item: $(candidate)});
	                    });
	                    that._change();
	                });
	            };

	            if (indices.length - 1 === endIndex - startIndex) {
	                return selectIndices(indices);
	            }

	            if (startIndex < endIndex) {
	                for (i = startIndex; i <= endIndex; i++) {
	                    indicesToSelect.push(i);
	                }
	            } else {
	                for (i = startIndex; i >= endIndex; i--) {
	                    indicesToSelect.push(i);
	                }
	            }

	            if (maxSelectedItems !== null && indicesToSelect.length > maxSelectedItems) {
	                indicesToSelect = indicesToSelect.slice(0, maxSelectedItems);
	            }

	            for (i = 0; i < indicesToSelect.length; i++) {
	                var index = indicesToSelect[i];

	                if (this._getSelectedIndices().indexOf(index) == -1) {
	                    indices.push(index);
	                } else {
	                    indices.splice(indices.indexOf(index), 1);
	                }
	            }

	            if (!indices.length) {
	                return;
	            }

	            that.persistTagList = false;
	            return selectIndices(indices);
	        },

	        _input: function() {
	            var that = this;
	            var element = that.element;
	            var accessKey = element[0].accessKey;
	            var input = that._inputWrapper.children("input.k-input");

	            if (!input[0]) {
	                input = $('<input class="k-input" style="width: 25px" />').appendTo(that._inputWrapper);
	            }

	            element.removeAttr("accesskey");

	            that._focused = that.input = input.attr({
	                "accesskey": accessKey,
	                "autocomplete": AUTOCOMPLETEVALUE,
	                "role": "textbox",
	                "title": element[0].title,
	                "aria-expanded": false,
	                "aria-haspopup": "true",
	                "aria-autocomplete": "list"
	            });
	        },

	        _tagList: function() {
	            var that = this,
	                tagList = that._inputWrapper.children("ul");

	            if (!tagList[0]) {
	                tagList = $('<ul unselectable="on" class="k-reset"/>').appendTo(that._inputWrapper);
	            }

	            that.tagList = tagList;
	        },

	        _tagTemplate: function() {
	            var that = this;
	            var options = that.options;
	            var tagTemplate = options.tagTemplate;
	            var hasDataSource = options.dataSource;
	            var isMultiple = options.tagMode === "multiple";
	            var singleTag = options.messages.singleTag;
	            var defaultTemplate;

	            if (that.element[0].length && !hasDataSource) {
	                options.dataTextField = options.dataTextField || "text";
	                options.dataValueField = options.dataValueField || "value";
	            }

	            defaultTemplate = isMultiple ? kendo.template("#:" + kendo.expr(options.dataTextField, "data") + "#", { useWithBlock: false }) : kendo.template("#:values.length# " + singleTag);

	            that.tagTextTemplate = tagTemplate = tagTemplate ? kendo.template(tagTemplate) : defaultTemplate;

	            that.tagTemplate = function(data) {
	                return '<li role="option" aria-selected="true" class="k-button" unselectable="on"><span unselectable="on">' +
	                        tagTemplate(data) + '</span>' +
	                        '<span aria-hidden="true" unselectable="on" aria-label="' +
	                        (isMultiple ? ('delete" title="' + that.options.messages.deleteTag + '" aria-label="' + that.options.messages.deleteTag) : 'open') +
	                        '" class="k-select"><span class="k-icon ' +
	                        (isMultiple ? "k-i-close" : "k-i-arrow-60-down") + '">' +
	                        '</span></span></li>';
	            };
	        },

	        _loader: function() {
	            this._loading = $('<span class="k-icon k-i-loading ' + HIDDENCLASS + '"></span>').insertAfter(this.input);
	        },

	        _clearButton: function() {
	            List.fn._clearButton.call(this);

	            if (this.options.clearButton) {
	                this._clear.insertAfter(this.input);
	                this.wrapper.addClass("k-multiselect-clearable");
	            }
	        },

	        _textContainer: function() {
	            var computedStyles = kendo.getComputedStyles(this.input[0], styles);

	            computedStyles.position = "absolute";
	            computedStyles.visibility = "hidden";
	            computedStyles.top = -3333;
	            computedStyles.left = -3333;

	            this._span = $("<span/>").css(computedStyles).appendTo(this.wrapper);
	        },

	        _wrapper: function() {
	            var that = this,
	                element = that.element,
	                wrapper = element.parent("span.k-multiselect");

	            if (!wrapper[0]) {
	                wrapper = element.wrap('<div class="k-widget k-multiselect" unselectable="on" />').parent();
	                wrapper[0].style.cssText = element[0].style.cssText;
	                wrapper[0].title = element[0].title;

	                $('<div class="k-multiselect-wrap k-floatwrap" unselectable="on" />').insertBefore(element);
	            }

	            that.wrapper = wrapper.addClass(element[0].className).removeClass('input-validation-error').css("display", "");
	            that._inputWrapper = $(wrapper[0].firstChild);
	        },

	        _ariaSetSize: function(value) {
	            var that = this;
	            var selectedItems = that.tagList.children();

	            if(value && selectedItems.length) {
	                selectedItems.attr("aria-setsize", value);
	            }
	        },

	        _ariaSetLive: function() {
	            var that = this;

	            that.ul.attr("aria-live", !that._isFilterEnabled() ? "off" : "polite");
	        }
	    });

	    function compare(a, b) {
	        var length;

	        if ((a === null && b !== null) || (a !== null && b === null)) {
	            return false;
	        }

	        length = a.length;
	        if (length !== b.length) {
	            return false;
	        }

	        while (length--) {
	            if (a[length] !== b[length]) {
	                return false;
	            }
	        }

	        return true;
	    }

	    ui.plugin(MultiSelect);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "TGH/":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1553);
	module.exports = __webpack_require__(1553);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 904:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("S/n4");

/***/ }),

/***/ 1553:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/***********************************************************************
	 * WARNING: this file is auto-generated.  If you change it directly,
	 * your modifications will eventually be lost.  The source code is in
	 * `kendo-ooxml` repository, you should make your changes there and
	 * run `src-modules/sync.sh` in this repository.
	 */
	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(20),
	        __webpack_require__(904)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {
	/* jshint eqnull:true */
	/* jshint laxbreak:true */

	window.kendo.ooxml = window.kendo.ooxml || {};
	var ooxml = kendo.ooxml;

	var map = $.map;
	var createZip = ooxml.createZip;

	var current = {
	    toString: function (value) { return value; }
	};

	var IntlService = kendo.Class.extend({

	});

	IntlService.register = function(userImplementation) {
	    current = userImplementation;
	};

	IntlService.toString = function(value, format) {
	    return current.toString(value, format);
	};

	// date packing utilities from Kendo Spreadsheet

	// Julian days algorithms from http://www.hermetic.ch/cal_stud/jdn.htm#comp
	function dateToJulianDays(y, m, d) {
	    return ((1461 * (y + 4800 + ((m - 13) / 12 | 0))) / 4 | 0) +
	        ((367 * (m - 1 - 12 * ((m - 13) / 12 | 0))) / 12 | 0) -
	        ((3 * (((y + 4900 + ((m - 13) / 12 | 0)) / 100 | 0))) / 4 | 0) +
	        d - 32075;
	}

	// This uses the Google Spreadsheet approach: treat 1899-12-31 as day 1, allowing to avoid
	// implementing the "Leap Year Bug" yet still be Excel compatible for dates starting 1900-03-01.
	var BASE_DATE = dateToJulianDays(1900, 0, -1);

	function packDate(year, month, date) {
	    return dateToJulianDays(year, month, date) - BASE_DATE;
	}

	function packTime(hh, mm, ss, ms) {
	    return (hh + (mm + (ss + ms / 1000) / 60) / 60) / 24;
	}

	function dateToSerial(date) {
	    var time = packTime(date.getHours(),
	                          date.getMinutes(),
	                          date.getSeconds(),
	                          date.getMilliseconds());
	    var serial = packDate(date.getFullYear(),
	                            date.getMonth(),
	                            date.getDate());
	    return serial < 0 ? serial - 1 + time : serial + time;
	}

	var MIME_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
	var DATA_URL_PREFIX = "data:" + MIME_TYPE + ";base64,";
	var DATA_URL_OPTIONS = { compression: "DEFLATE", type: "base64" };
	var BLOB_OPTIONS = { compression: "DEFLATE", type: "blob" };
	var ARRAYBUFFER_OPTIONS = { compression: "DEFLATE", type: "arraybuffer" };

	/* eslint-disable key-spacing, no-arrow-condition, indent, no-nested-ternary, consistent-return */

	function toDataURI(content) {
	    return DATA_URL_PREFIX + content;
	}

	function indexOf(thing, array) {
	    return array.indexOf(thing);
	}

	var parseJSON = JSON.parse.bind(JSON);

	function ESC(val) {
	    return String(val)
	        .replace(/&/g, "&amp;")
	        .replace(/</g, "&lt;")
	        .replace(/>/g, "&gt;")
	        .replace(/\"/g, "&quot;")
	        .replace(/\'/g, "&#39;");
	}

	function repeat(count, func) {
	    var str = "";
	    for (var i = 0; i < count; ++i) {
	        str += func(i);
	    }
	    return str;
	}

	function foreach(arr, func) {
	    var str = "";
	    if (arr != null) {
	        if (Array.isArray(arr)) {
	            for (var i = 0; i < arr.length; ++i) {
	                str += func(arr[i], i);
	            }
	        } else if (typeof arr == "object") {
	            Object.keys(arr).forEach(function (key, i) {
	                str += func(arr[key], key, i);
	            });
	        }
	    }
	    return str;
	}

	var XMLHEAD = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r';

	var RELS = XMLHEAD + "\n            <Relationships xmlns=\"http://schemas.openxmlformats.org/package/2006/relationships\">\n               <Relationship Id=\"rId3\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties\" Target=\"docProps/app.xml\"/>\n               <Relationship Id=\"rId2\" Type=\"http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties\" Target=\"docProps/core.xml\"/>\n               <Relationship Id=\"rId1\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument\" Target=\"xl/workbook.xml\"/>\n            </Relationships>";

	var CORE = function (ref) {
	  var creator = ref.creator;
	  var lastModifiedBy = ref.lastModifiedBy;
	  var created = ref.created;
	  var modified = ref.modified;

	  return (XMLHEAD + "\n <cp:coreProperties xmlns:cp=\"http://schemas.openxmlformats.org/package/2006/metadata/core-properties\"\n   xmlns:dc=\"http://purl.org/dc/elements/1.1/\" xmlns:dcterms=\"http://purl.org/dc/terms/\"\n   xmlns:dcmitype=\"http://purl.org/dc/dcmitype/\" xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\">\n   <dc:creator>" + (ESC(creator)) + "</dc:creator>\n   <cp:lastModifiedBy>" + (ESC(lastModifiedBy)) + "</cp:lastModifiedBy>\n   <dcterms:created xsi:type=\"dcterms:W3CDTF\">" + (ESC(created)) + "</dcterms:created>\n   <dcterms:modified xsi:type=\"dcterms:W3CDTF\">" + (ESC(modified)) + "</dcterms:modified>\n</cp:coreProperties>");
	};

	var APP = function (ref) {
	  var sheets = ref.sheets;

	  return (XMLHEAD + "\n<Properties xmlns=\"http://schemas.openxmlformats.org/officeDocument/2006/extended-properties\" xmlns:vt=\"http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes\">\n  <Application>Microsoft Excel</Application>\n  <DocSecurity>0</DocSecurity>\n  <ScaleCrop>false</ScaleCrop>\n  <HeadingPairs>\n    <vt:vector size=\"2\" baseType=\"variant\">\n      <vt:variant>\n        <vt:lpstr>Worksheets</vt:lpstr>\n      </vt:variant>\n      <vt:variant>\n        <vt:i4>" + (sheets.length) + "</vt:i4>\n      </vt:variant>\n    </vt:vector>\n  </HeadingPairs>\n  <TitlesOfParts>\n    <vt:vector size=\"" + (sheets.length) + "\" baseType=\"lpstr\">" + (foreach(sheets, function (sheet, i) { return sheet.options.title
	          ? ("<vt:lpstr>" + (ESC(sheet.options.title)) + "</vt:lpstr>")
	          : ("<vt:lpstr>Sheet" + (i + 1) + "</vt:lpstr>"); }
	      )) + "</vt:vector>\n  </TitlesOfParts>\n  <LinksUpToDate>false</LinksUpToDate>\n  <SharedDoc>false</SharedDoc>\n  <HyperlinksChanged>false</HyperlinksChanged>\n  <AppVersion>14.0300</AppVersion>\n</Properties>");
	};

	var CONTENT_TYPES = function (ref) {
	  var sheetCount = ref.sheetCount;
	  var commentFiles = ref.commentFiles;
	  var drawingFiles = ref.drawingFiles;

	  return (XMLHEAD + "\n<Types xmlns=\"http://schemas.openxmlformats.org/package/2006/content-types\">\n  <Default Extension=\"png\" ContentType=\"image/png\"/>\n  <Default Extension=\"gif\" ContentType=\"image/gif\"/>\n  <Default Extension=\"jpg\" ContentType=\"image/jpeg\"/>\n  <Default Extension=\"rels\" ContentType=\"application/vnd.openxmlformats-package.relationships+xml\" />\n  <Default Extension=\"xml\" ContentType=\"application/xml\" />\n  <Default Extension=\"vml\" ContentType=\"application/vnd.openxmlformats-officedocument.vmlDrawing\"/>\n  <Override PartName=\"/xl/workbook.xml\" ContentType=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml\" />\n  <Override PartName=\"/xl/styles.xml\" ContentType=\"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml\"/>\n  <Override PartName=\"/xl/sharedStrings.xml\" ContentType=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml\"/>\n  " + (repeat(sheetCount, function (idx) { return ("<Override PartName=\"/xl/worksheets/sheet" + (idx + 1) + ".xml\" ContentType=\"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml\" />"); })) + "\n  " + (foreach(commentFiles, function (filename) { return ("<Override PartName=\"/xl/" + filename + "\" ContentType=\"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml\"/>"); })) + "\n  " + (foreach(drawingFiles, function (filename) { return ("<Override PartName=\"/xl/drawings/" + filename + "\" ContentType=\"application/vnd.openxmlformats-officedocument.drawing+xml\"/>"); })) + "\n  <Override PartName=\"/docProps/core.xml\" ContentType=\"application/vnd.openxmlformats-package.core-properties+xml\" />\n  <Override PartName=\"/docProps/app.xml\" ContentType=\"application/vnd.openxmlformats-officedocument.extended-properties+xml\" />\n</Types>");
	};

	var WORKBOOK = function (ref) {
	  var sheets = ref.sheets;
	  var filterNames = ref.filterNames;
	  var userNames = ref.userNames;

	  return (XMLHEAD + "\n<workbook xmlns=\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\" xmlns:r=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships\">\n  <fileVersion appName=\"xl\" lastEdited=\"5\" lowestEdited=\"5\" rupBuild=\"9303\" />\n  <workbookPr defaultThemeVersion=\"124226\" />\n  <bookViews>\n    <workbookView xWindow=\"240\" yWindow=\"45\" windowWidth=\"18195\" windowHeight=\"7995\" />\n  </bookViews>\n  <sheets>\n  " + (foreach(sheets, function (ref, i) {
	    var options = ref.options;

	    var name = options.name || options.title || ("Sheet" + (i + 1));
	    return ("<sheet name=\"" + (ESC(name)) + "\" sheetId=\"" + (i + 1) + "\" r:id=\"rId" + (i + 1) + "\" />");
	  })) + "\n  </sheets>\n  " + (filterNames.length || userNames.length ? ("\n    <definedNames>\n      " + (foreach(filterNames, function (f) { return ("\n         <definedName name=\"_xlnm._FilterDatabase\" hidden=\"1\" localSheetId=\"" + (f.localSheetId) + "\">" + (ESC(quoteSheet(f.name))) + "!" + (ESC(f.from)) + ":" + (ESC(f.to)) + "</definedName>"); })) + "\n      " + (foreach(userNames, function (f) { return ("\n         <definedName name=\"" + (f.name) + "\" hidden=\"" + (f.hidden ? 1 : 0) + "\" " + (f.localSheetId != null ? ("localSheetId=\"" + (f.localSheetId) + "\"") : '') + ">" + (ESC(f.value)) + "</definedName>"); })) + "\n    </definedNames>") : '') + "\n  <calcPr fullCalcOnLoad=\"1\" calcId=\"145621\" />\n</workbook>");
	};

	var WORKSHEET = function (ref$1) {
	  var frozenColumns = ref$1.frozenColumns;
	  var frozenRows = ref$1.frozenRows;
	  var columns = ref$1.columns;
	  var defaults = ref$1.defaults;
	  var data = ref$1.data;
	  var index = ref$1.index;
	  var mergeCells = ref$1.mergeCells;
	  var autoFilter = ref$1.autoFilter;
	  var filter = ref$1.filter;
	  var showGridLines = ref$1.showGridLines;
	  var hyperlinks = ref$1.hyperlinks;
	  var validations = ref$1.validations;
	  var defaultCellStyleId = ref$1.defaultCellStyleId;
	  var rtl = ref$1.rtl;
	  var legacyDrawing = ref$1.legacyDrawing;
	  var drawing = ref$1.drawing;
	  var lastRow = ref$1.lastRow;
	  var lastCol = ref$1.lastCol;

	  return (XMLHEAD + "\n<worksheet xmlns=\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\" xmlns:mc=\"http://schemas.openxmlformats.org/markup-compatibility/2006\" xmlns:r=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships\" xmlns:x14ac=\"http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac\" mc:Ignorable=\"x14ac\">\n   " + (lastRow && lastCol ? ("<dimension ref=\"A1:" + (ref(lastRow - 1, lastCol - 1)) + "\" />") : "") + "\n\n   <sheetViews>\n     <sheetView " + (rtl ? 'rightToLeft="1"' : '') + " " + (index === 0 ? 'tabSelected="1"' : '') + " workbookViewId=\"0\" " + (showGridLines === false ? 'showGridLines="0"' : '') + ">\n     " + (frozenRows || frozenColumns ? ("\n       <pane state=\"frozen\"\n         " + (frozenColumns ? ("xSplit=\"" + frozenColumns + "\"") : '') + "\n         " + (frozenRows ? ("ySplit=\"" + frozenRows + "\"") : '') + "\n         topLeftCell=\"" + (String.fromCharCode(65 + (frozenColumns || 0)) + ((frozenRows || 0) + 1)) + "\"\n       />") : '') + "\n     </sheetView>\n   </sheetViews>\n\n   <sheetFormatPr x14ac:dyDescent=\"0.25\" " + (!defaults.skipCustomHeight ? 'customHeight="1"' : '') + " defaultRowHeight=\"" + (defaults.rowHeight ? defaults.rowHeight * 0.75 : 15) + "\"\n     " + (defaults.columnWidth ? ("defaultColWidth=\"" + (toWidth(defaults.columnWidth)) + "\"") : '') + " />\n\n   " + (defaultCellStyleId != null || (columns && columns.length > 0) ? ("\n     <cols>\n       " + (!columns || !columns.length ? ("\n         <col min=\"1\" max=\"16384\" style=\"" + defaultCellStyleId + "\"\n              " + (defaults.columnWidth ? ("width=\"" + (toWidth(defaults.columnWidth)) + "\"") : '') + " /> ") : '') + "\n       " + (foreach(columns, function (column, ci) {
	         var columnIndex = typeof column.index === "number" ? column.index + 1 : (ci + 1);
	         if (column.width === 0) {
	           return ("<col " + (defaultCellStyleId != null ? ("style=\"" + defaultCellStyleId + "\"") : '') + "\n                        min=\"" + columnIndex + "\" max=\"" + columnIndex + "\" hidden=\"1\" customWidth=\"1\" />");
	         }
	         return ("<col " + (defaultCellStyleId != null ? ("style=\"" + defaultCellStyleId + "\"") : '') + "\n                      min=\"" + columnIndex + "\" max=\"" + columnIndex + "\" customWidth=\"1\"\n                      " + (column.autoWidth
	                          ? ("width=\"" + (((column.width * 7 + 5) / 7 * 256) / 256) + "\" bestFit=\"1\"")
	                          : ("width=\"" + (toWidth(column.width)) + "\"")) + " />");
	       })) + "\n     </cols>") : '') + "\n\n   <sheetData>\n     " + (foreach(data, function (row, ri) {
	       var rowIndex = typeof row.index === "number" ? row.index + 1 : (ri + 1);
	       return ("\n         <row r=\"" + rowIndex + "\" x14ac:dyDescent=\"0.25\"\n              " + (row.level ? ("outlineLevel=\"" + (row.level) + "\"") : '') + "\n              " + (row.height === 0 ? 'hidden="1"'
	                                 : row.height ? ("ht=\"" + (toHeight(row.height)) + "\" customHeight=\"1\"") : "") + ">\n           " + (foreach(row.data, function (cell) { return ("\n             <c r=\"" + (cell.ref) + "\" " + (cell.style ? ("s=\"" + (cell.style) + "\"") : '') + " " + (cell.type ? ("t=\"" + (cell.type) + "\"") : '') + ">\n               " + (cell.formula != null ? writeFormula(cell.formula) : '') + "\n               " + (cell.value != null ? ("<v>" + (ESC(cell.value)) + "</v>") : '') + "\n             </c>"); })) + "\n         </row>\n       ");})) + "\n   </sheetData>\n\n   " + (autoFilter ? ("<autoFilter ref=\"" + (autoFilter.from) + ":" + (autoFilter.to) + "\"/>")
	                : filter ? spreadsheetFilters(filter) : '') + "\n\n   " + (mergeCells.length ? ("\n     <mergeCells count=\"" + (mergeCells.length) + "\">\n       " + (foreach(mergeCells, function (ref) { return ("<mergeCell ref=\"" + ref + "\"/>"); })) + "\n     </mergeCells>") : '') + "\n\n   " + (validations.length ? ("\n     <dataValidations>\n       " + (foreach(validations, function (val) { return ("\n         <dataValidation sqref=\"" + (val.sqref.join(" ")) + "\"\n                         showErrorMessage=\"" + (val.showErrorMessage) + "\"\n                         type=\"" + (ESC(val.type)) + "\"\n                         " + (val.type !== "list" ? ("operator=\"" + (ESC(val.operator)) + "\"") : '') + "\n                         allowBlank=\"" + (val.allowBlank) + "\"\n                         showDropDown=\"" + (val.showDropDown) + "\"\n                         " + (val.error ? ("error=\"" + (ESC(val.error)) + "\"") : '') + "\n                         " + (val.errorTitle ? ("errorTitle=\"" + (ESC(val.errorTitle)) + "\"") : '') + ">\n           " + (val.formula1 ? ("<formula1>" + (ESC(val.formula1)) + "</formula1>") : '') + "\n           " + (val.formula2 ? ("<formula2>" + (ESC(val.formula2)) + "</formula2>") : '') + "\n         </dataValidation>"); })) + "\n     </dataValidations>") : '') + "\n\n   " + (hyperlinks.length ? ("\n     <hyperlinks>\n       " + (foreach(hyperlinks, function (link) { return ("\n         <hyperlink ref=\"" + (link.ref) + "\" r:id=\"" + (link.rId) + "\"/>"); })) + "\n     </hyperlinks>") : '') + "\n\n   <pageMargins left=\"0.7\" right=\"0.7\" top=\"0.75\" bottom=\"0.75\" header=\"0.3\" footer=\"0.3\" />\n   " + (drawing ? ("<drawing r:id=\"" + drawing + "\"/>") : '') + "\n   " + (legacyDrawing ? ("<legacyDrawing r:id=\"" + legacyDrawing + "\"/>") : '') + "\n</worksheet>");
	};

	var WORKBOOK_RELS = function (ref) {
	  var count = ref.count;

	  return (XMLHEAD + "\n<Relationships xmlns=\"http://schemas.openxmlformats.org/package/2006/relationships\">\n  " + (repeat(count, function (idx) { return ("\n    <Relationship Id=\"rId" + (idx + 1) + "\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet\" Target=\"worksheets/sheet" + (idx + 1) + ".xml\" />"); })) + "\n  <Relationship Id=\"rId" + (count + 1) + "\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles\" Target=\"styles.xml\" />\n  <Relationship Id=\"rId" + (count + 2) + "\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings\" Target=\"sharedStrings.xml\" />\n</Relationships>");
	};

	var WORKSHEET_RELS = function (ref) {
	  var hyperlinks = ref.hyperlinks;
	  var comments = ref.comments;
	  var sheetIndex = ref.sheetIndex;
	  var drawings = ref.drawings;

	  return (XMLHEAD + "\n<Relationships xmlns=\"http://schemas.openxmlformats.org/package/2006/relationships\">\n  " + (foreach(hyperlinks, function (link) { return ("\n    <Relationship Id=\"" + (link.rId) + "\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink\" Target=\"" + (ESC(link.target)) + "\" TargetMode=\"External\" />"); })) + "\n  " + (!comments.length ? '' : ("\n    <Relationship Id=\"comment" + sheetIndex + "\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments\" Target=\"../comments" + sheetIndex + ".xml\"/>\n    <Relationship Id=\"vml" + sheetIndex + "\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing\" Target=\"../drawings/vmlDrawing" + sheetIndex + ".vml\"/>")) + "\n  " + (!drawings.length ? '' : ("\n    <Relationship Id=\"drw" + sheetIndex + "\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing\" Target=\"../drawings/drawing" + sheetIndex + ".xml\"/>")) + "\n</Relationships>");
	};

	var COMMENTS_XML = function (ref) {
	  var comments = ref.comments;

	  return (XMLHEAD + "\n<comments xmlns=\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\">\n  <authors>\n    <author></author>\n  </authors>\n  <commentList>\n    " + (foreach(comments, function (comment) { return ("\n      <comment ref=\"" + (comment.ref) + "\" authorId=\"0\">\n        <text>\n          <r>\n            <rPr>\n              <sz val=\"8\"/>\n              <color indexed=\"81\"/>\n              <rFont val=\"Tahoma\"/>\n              <charset val=\"1\"/>\n            </rPr>\n            <t>" + (ESC(comment.text)) + "</t>\n          </r>\n        </text>\n      </comment>"); })) + "\n  </commentList>\n</comments>");
	};

	var LEGACY_DRAWING = function (ref) {
	  var comments = ref.comments;

	  return ("<xml xmlns:v=\"urn:schemas-microsoft-com:vml\"\n     xmlns:o=\"urn:schemas-microsoft-com:office:office\"\n     xmlns:x=\"urn:schemas-microsoft-com:office:excel\">\n  <v:shapetype coordsize=\"21600,21600\" id=\"_x0000_t202\" path=\"m,l,21600r21600,l21600,xe\">\n    <v:stroke joinstyle=\"miter\"/>\n    <v:path gradientshapeok=\"t\" o:connecttype=\"rect\"/>\n  </v:shapetype>\n  " + (foreach(comments, function (comment) { return ("\n    <v:shape type=\"#_x0000_t202\" style=\"visibility: hidden\" fillcolor=\"#ffffe1\" o:insetmode=\"auto\">\n      <v:shadow on=\"t\" color=\"black\" obscured=\"t\"/>\n      <x:ClientData ObjectType=\"Note\">\n        <x:MoveWithCells/>\n        <x:SizeWithCells/>\n        <x:Anchor>" + (comment.anchor) + "</x:Anchor>\n        <x:AutoFill>False</x:AutoFill>\n        <x:Row>" + (comment.row) + "</x:Row>\n        <x:Column>" + (comment.col) + "</x:Column>\n      </x:ClientData>\n    </v:shape>"); })) + "\n</xml>");
	};

	var DRAWINGS_XML = function (drawings) { return (XMLHEAD + "\n<xdr:wsDr xmlns:xdr=\"http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing\"\n          xmlns:a=\"http://schemas.openxmlformats.org/drawingml/2006/main\"\n          xmlns:r=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships\">\n  " + (foreach(drawings, function (drawing, index) { return ("\n    <xdr:oneCellAnchor editAs=\"oneCell\">\n      <xdr:from>\n        <xdr:col>" + (drawing.col) + "</xdr:col>\n        <xdr:colOff>" + (drawing.colOffset) + "</xdr:colOff>\n        <xdr:row>" + (drawing.row) + "</xdr:row>\n        <xdr:rowOff>" + (drawing.rowOffset) + "</xdr:rowOff>\n      </xdr:from>\n      <xdr:ext cx=\"" + (drawing.width) + "\" cy=\"" + (drawing.height) + "\" />\n      <xdr:pic>\n        <xdr:nvPicPr>\n          <xdr:cNvPr id=\"" + (index + 1) + "\" name=\"Picture " + (index + 1) + "\"/>\n          <xdr:cNvPicPr/>\n        </xdr:nvPicPr>\n        <xdr:blipFill>\n          <a:blip r:embed=\"" + (drawing.imageId) + "\"/>\n          <a:stretch>\n            <a:fillRect/>\n          </a:stretch>\n        </xdr:blipFill>\n        <xdr:spPr>\n          <a:prstGeom prst=\"rect\">\n            <a:avLst/>\n          </a:prstGeom>\n        </xdr:spPr>\n      </xdr:pic>\n      <xdr:clientData/>\n    </xdr:oneCellAnchor>"); })) + "\n</xdr:wsDr>"); };

	var DRAWINGS_RELS_XML = function (rels) { return (XMLHEAD + "\n<Relationships xmlns=\"http://schemas.openxmlformats.org/package/2006/relationships\">\n  " + (foreach(rels, function (rel) { return ("\n    <Relationship Id=\"" + (rel.rId) + "\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/image\" Target=\"" + (rel.target) + "\"/>"); })) + "\n</Relationships>"); };

	var SHARED_STRINGS = function (ref) {
	  var count = ref.count;
	  var uniqueCount = ref.uniqueCount;
	  var indexes = ref.indexes;

	  return (XMLHEAD + "\n<sst xmlns=\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\" count=\"" + count + "\" uniqueCount=\"" + uniqueCount + "\">\n  " + (foreach(Object.keys(indexes), function (index) { return ("\n    <si><t xml:space=\"preserve\">" + (ESC(index.substring(1))) + "</t></si>"); })) + "\n</sst>");
	};

	var STYLES = function (ref) {
	  var formats = ref.formats;
	  var fonts = ref.fonts;
	  var fills = ref.fills;
	  var borders = ref.borders;
	  var styles = ref.styles;

	  return (XMLHEAD + "\n<styleSheet\n    xmlns=\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\"\n    xmlns:mc=\"http://schemas.openxmlformats.org/markup-compatibility/2006\"\n    mc:Ignorable=\"x14ac\"\n    xmlns:x14ac=\"http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac\">\n  <numFmts count=\"" + (formats.length) + "\">\n  " + (foreach(formats, function (format, fi) { return ("\n    <numFmt formatCode=\"" + (ESC(format.format)) + "\" numFmtId=\"" + (165 + fi) + "\" />"); })) + "\n  </numFmts>\n  <fonts count=\"" + (fonts.length + 1) + "\" x14ac:knownFonts=\"1\">\n    <font>\n       <sz val=\"11\" />\n       <color theme=\"1\" />\n       <name val=\"Calibri\" />\n       <family val=\"2\" />\n       <scheme val=\"minor\" />\n    </font>\n    " + (foreach(fonts, function (font) { return ("\n    <font>\n      " + (font.bold ? '<b/>' : '') + "\n      " + (font.italic ? '<i/>' : '') + "\n      " + (font.underline ? '<u/>' : '') + "\n      <sz val=\"" + (font.fontSize || 11) + "\" />\n      " + (font.color ? ("<color rgb=\"" + (ESC(font.color)) + "\" />") : '<color theme="1" />') + "\n      " + (font.fontFamily ? ("\n        <name val=\"" + (ESC(font.fontFamily)) + "\" />\n        <family val=\"2\" />\n      ") : "\n        <name val=\"Calibri\" />\n        <family val=\"2\" />\n        <scheme val=\"minor\" />\n      ") + "\n    </font>"); })) + "\n  </fonts>\n  <fills count=\"" + (fills.length + 2) + "\">\n      <fill><patternFill patternType=\"none\"/></fill>\n      <fill><patternFill patternType=\"gray125\"/></fill>\n    " + (foreach(fills, function (fill) { return ("\n      " + (fill.background ? ("\n        <fill>\n          <patternFill patternType=\"solid\">\n              <fgColor rgb=\"" + (ESC(fill.background)) + "\"/>\n          </patternFill>\n        </fill>\n      ") : '')); })) + "\n  </fills>\n  <borders count=\"" + (borders.length + 1) + "\">\n    <border><left/><right/><top/><bottom/><diagonal/></border>\n    " + (foreach(borders, borderTemplate)) + "\n  </borders>\n  <cellStyleXfs count=\"1\">\n    <xf borderId=\"0\" fillId=\"0\" fontId=\"0\" />\n  </cellStyleXfs>\n  <cellXfs count=\"" + (styles.length + 1) + "\">\n    <xf numFmtId=\"0\" fontId=\"0\" fillId=\"0\" borderId=\"0\" xfId=\"0\" />\n    " + (foreach(styles, function (style) { return ("\n      <xf xfId=\"0\"\n          " + (style.fontId ? ("fontId=\"" + (style.fontId) + "\" applyFont=\"1\"") : '') + "\n          " + (style.fillId ? ("fillId=\"" + (style.fillId) + "\" applyFill=\"1\"") : '') + "\n          " + (style.numFmtId ? ("numFmtId=\"" + (style.numFmtId) + "\" applyNumberFormat=\"1\"") : '') + "\n          " + (style.textAlign || style.verticalAlign || style.wrap ? 'applyAlignment="1"' : '') + "\n          " + (style.borderId ? ("borderId=\"" + (style.borderId) + "\" applyBorder=\"1\"") : '') + ">\n        " + (style.textAlign || style.verticalAlign || style.wrap ? ("\n        <alignment\n          " + (style.textAlign ? ("horizontal=\"" + (ESC(style.textAlign)) + "\"") : '') + "\n          " + (style.verticalAlign ? ("vertical=\"" + (ESC(style.verticalAlign)) + "\"") : '') + "\n          " + (style.indent ? ("indent=\"" + (ESC(style.indent)) + "\"") : '') + "\n          " + (style.wrap ? 'wrapText="1"' : '') + " />\n        ") : '') + "\n      </xf>\n    "); })) + "\n  </cellXfs>\n  <cellStyles count=\"1\">\n    <cellStyle name=\"Normal\" xfId=\"0\" builtinId=\"0\"/>\n  </cellStyles>\n  <dxfs count=\"0\" />\n  <tableStyles count=\"0\" defaultTableStyle=\"TableStyleMedium2\" defaultPivotStyle=\"PivotStyleMedium9\" />\n</styleSheet>");
	};

	function writeFormula(formula) {
	    if (typeof formula == "string") {
	        return ("<f>" + (ESC(formula)) + "</f>");
	    }
	    // array formulas
	    return ("<f t=\"array\" ref=\"" + (formula.ref) + "\">" + (ESC(formula.src)) + "</f>");
	}

	function numChar(colIndex) {
	   var letter = Math.floor(colIndex / 26) - 1;

	   return (letter >= 0 ? numChar(letter) : "") + String.fromCharCode(65 + (colIndex % 26));
	}

	function ref(rowIndex, colIndex) {
	    return numChar(colIndex) + (rowIndex + 1);
	}

	function $ref(rowIndex, colIndex) {
	    return "$" + numChar(colIndex) + "$" + (rowIndex + 1);
	}

	function filterRowIndex(options) {
	    var frozenRows = options.frozenRows || (options.freezePane || {}).rowSplit || 1;
	    return frozenRows - 1;
	}

	function toWidth(px) {
	    var maximumDigitWidth = 7;
	    return (px / maximumDigitWidth) - (Math.floor(128 / maximumDigitWidth) / 256);
	}

	function toHeight(px) {
	    return px * 0.75;
	}

	function stripFunnyChars(value) {
	    return String(value)
	        .replace(/[\x00-\x09\x0B\x0C\x0E-\x1F]/g, "") // leave CRLF in
	        .replace(/\r?\n/g, "\r\n");                   // make sure LF is preceded by CR
	}

	var Worksheet = kendo.Class.extend({
	    init: function(options, sharedStrings, styles, borders) {
	        this.options = options;
	        this._strings = sharedStrings;
	        this._styles = styles;
	        this._borders = borders;
	        this._validations = {};
	        this._comments = [];
	        this._drawings = options.drawings || [];
	        this._hyperlinks = (this.options.hyperlinks || []).map(
	            function (link, i) { return $.extend({}, link, { rId: ("link" + i) }); });
	    },

	    relsToXML: function() {
	        var hyperlinks = this._hyperlinks;
	        var comments = this._comments;
	        var drawings = this._drawings;

	        if (hyperlinks.length || comments.length || drawings.length) {
	            return WORKSHEET_RELS({
	                hyperlinks : hyperlinks,
	                comments   : comments,
	                sheetIndex : this.options.sheetIndex,
	                drawings   : drawings
	            });
	        }
	    },

	    toXML: function(index) {
	        var this$1 = this;

	        var mergeCells = this.options.mergedCells || [];
	        var rows = this.options.rows || [];
	        var data = inflate(rows, mergeCells);

	        this._readCells(data);

	        var autoFilter = this.options.filter;
	        var filter;
	        if (autoFilter && (typeof autoFilter.from === "number") && (typeof autoFilter.to === "number")) {
	            // Grid enables auto filter
	            autoFilter = {
	                from: ref(filterRowIndex(this.options), autoFilter.from),
	                to: ref(filterRowIndex(this.options), autoFilter.to)
	            };
	        } else if (autoFilter && autoFilter.ref && autoFilter.columns) {
	            // this is probably from the Spreadsheet
	            filter = autoFilter;
	            autoFilter = null;
	        }

	        var validations = [];
	        for (var i in this._validations) {
	            if (Object.prototype.hasOwnProperty.call(this$1._validations, i)) {
	                validations.push(this$1._validations[i]);
	            }
	        }

	        var defaultCellStyleId = null;
	        if (this.options.defaultCellStyle) {
	            defaultCellStyleId = this._lookupStyle(this.options.defaultCellStyle);
	        }

	        var freezePane = this.options.freezePane || {};
	        var defaults = this.options.defaults || {};
	        var lastRow = this.options.rows ? this._getLastRow() : 1;
	        var lastCol = this.options.rows ? this._getLastCol() : 1;

	        return WORKSHEET({
	            frozenColumns: this.options.frozenColumns || freezePane.colSplit,
	            frozenRows: this.options.frozenRows || freezePane.rowSplit,
	            columns: this.options.columns,
	            defaults: defaults,
	            data: data,
	            index: index,
	            mergeCells: mergeCells,
	            autoFilter: autoFilter,
	            filter: filter,
	            showGridLines: this.options.showGridLines,
	            hyperlinks: this._hyperlinks,
	            validations: validations,
	            defaultCellStyleId: defaultCellStyleId,
	            rtl: this.options.rtl !== undefined ? this.options.rtl : defaults.rtl,
	            legacyDrawing: this._comments.length ? ("vml" + (this.options.sheetIndex)) : null,
	            drawing: this._drawings.length ? ("drw" + (this.options.sheetIndex)) : null,
	            lastRow: lastRow,
	            lastCol: lastCol
	        });
	    },

	    commentsXML: function() {
	        if (this._comments.length) {
	            return COMMENTS_XML({ comments: this._comments });
	        }
	    },

	    drawingsXML: function(images) {
	        if (this._drawings.length) {
	            var rels = {};
	            var main = this._drawings.map(function (drw) {
	                var ref = parseRef(drw.topLeftCell);
	                var img = rels[drw.image];
	                if (!img) {
	                    img = rels[drw.image] = {
	                        rId: ("img" + (drw.image)),
	                        target: images[drw.image].target
	                    };
	                }
	                return {
	                    col       : ref.col,
	                    colOffset : pixelsToExcel(drw.offsetX),
	                    row       : ref.row,
	                    rowOffset : pixelsToExcel(drw.offsetY),
	                    width     : pixelsToExcel(drw.width),
	                    height    : pixelsToExcel(drw.height),
	                    imageId   : img.rId
	                };
	            });
	            return {
	                main: DRAWINGS_XML(main),
	                rels: DRAWINGS_RELS_XML(rels)
	            };
	        }
	    },

	    legacyDrawing: function() {
	        if (this._comments.length) {
	            return LEGACY_DRAWING({ comments: this._comments });
	        }
	    },

	    _lookupString: function(value) {
	        var key = "$" + value;
	        var index = this._strings.indexes[key];
	        var result;

	        if (index !== undefined) {
	            result = index;
	        } else {
	            result = this._strings.indexes[key] = this._strings.uniqueCount;
	            this._strings.uniqueCount ++;
	        }

	        this._strings.count ++;

	        return result;
	    },

	    _lookupStyle: function(style) {
	        var json = JSON.stringify(style);

	        if (json === "{}") {
	            return 0;
	        }

	        var index = indexOf(json, this._styles);

	        if (index < 0) {
	            index = this._styles.push(json) - 1;
	        }

	        // There is one default style
	        return index + 1;
	    },

	    _lookupBorder: function(border) {
	        var json = JSON.stringify(border);
	        if (json === "{}") {
	            return;
	        }

	        var index = indexOf(json, this._borders);
	        if (index < 0) {
	            index = this._borders.push(json) - 1;
	        }

	        // There is one default border
	        return index + 1;
	    },

	    _readCells: function(rowData) {
	        var this$1 = this;

	        for (var i = 0; i < rowData.length; i++) {
	            var row = rowData[i];
	            var cells = row.cells;

	            row.data = [];

	            for (var j = 0; j < cells.length; j++) {
	                var cellData = this$1._cell(cells[j], row.index, j);
	                if (cellData) {
	                    row.data.push(cellData);
	                }
	            }
	        }
	    },

	    _cell: function(data, rowIndex, cellIndex) {
	        if (!data || data === EMPTY_CELL) {
	            return null;
	        }

	        var value = data.value;

	        var border = {};

	        if (data.borderLeft) {
	            border.left = data.borderLeft;
	        }

	        if (data.borderRight) {
	            border.right = data.borderRight;
	        }

	        if (data.borderTop) {
	            border.top = data.borderTop;
	        }

	        if (data.borderBottom) {
	            border.bottom = data.borderBottom;
	        }

	        border = this._lookupBorder(border);

	        var defStyle = this.options.defaultCellStyle || {};
	        var style = { borderId: border };

	        (function(add) {
	            add("color");
	            add("background");
	            add("bold");
	            add("italic");
	            add("underline");
	            if (!add("fontFamily")) { add("fontName", "fontFamily"); }
	            add("fontSize");
	            add("format");
	            if (!add("textAlign")) { add("hAlign", "textAlign"); }
	            if (!add("verticalAlign")) { add("vAlign", "verticalAlign"); }
	            add("wrap");
	            add("indent");
	        })(
	            function(prop, target) {
	                var val = data[prop];
	                if (val === undefined) {
	                    val = defStyle[prop];
	                }
	                if (val !== undefined) {
	                    style[target || prop] = val;
	                    return true;
	                }
	            }
	        );

	        var columns = this.options.columns || [];

	        var column = columns[cellIndex];
	        var type = typeof value;

	        if (column && column.autoWidth && (!data.colSpan || data.colSpan === 1)) {
	            var displayValue = value;

	            // XXX: let's not bring kendo.toString in only for this.
	            //      better wait until the spreadsheet engine is available as a separate
	            //      component, then we can use a real Excel-like formatter.
	            //
	            if (type === "number") {
	                // kendo.toString will not behave exactly like the Excel format
	                // Still, it's the best we have available for estimating the character count.
	                displayValue = IntlService.toString(value, data.format);
	            }

	            column.width = Math.max(column.width || 0, String(displayValue).length);
	        }

	        if (type === "string") {
	            value = stripFunnyChars(value);
	            value = this._lookupString(value);
	            type = "s";
	        } else if (type === "number") {
	            type = "n";
	        } else if (type === "boolean") {
	            type = "b";
	            value = Number(value);
	        } else if (value && value.getTime) {
	            type = null;
	            value = dateToSerial(value);
	            if (!style.format) {
	                style.format = "mm-dd-yy";
	            }
	        } else {
	            type = null;
	            value = null;
	        }

	        style = this._lookupStyle(style);

	        var cellName = ref(rowIndex, cellIndex);

	        if (data.validation) {
	            this._addValidation(data.validation, cellName);
	        }

	        if (data.comment) {
	            var anchor = [
	                cellIndex + 1,  // start column
	                15,             // start column offset
	                rowIndex,       // start row
	                10,             // start row offset
	                cellIndex + 3,  // end column
	                15,             // end column offset
	                rowIndex + 3,   // end row
	                4               // end row offset
	            ];
	            this._comments.push({
	                ref    : cellName,
	                text   : data.comment,
	                row    : rowIndex,
	                col    : cellIndex,
	                anchor : anchor.join(", ")
	            });
	        }

	        return {
	            value: value,
	            formula: data.formula,
	            type: type,
	            style: style,
	            ref: cellName
	        };
	    },

	    _addValidation: function(v, ref) {
	        var tmp = {
	            showErrorMessage : v.type === "reject" ? 1 : 0,
	            formula1         : v.from,
	            formula2         : v.to,
	            type             : MAP_EXCEL_TYPE[v.dataType] || v.dataType,
	            operator         : MAP_EXCEL_OPERATOR[v.comparerType] || v.comparerType,
	            allowBlank       : v.allowNulls ? 1 : 0,
	            showDropDown     : v.showButton ? 0 : 1, // LOL, Excel!
	            error            : v.messageTemplate,
	            errorTitle       : v.titleTemplate
	        };
	        var json = JSON.stringify(tmp);
	        if (!this._validations[json]) {
	            this._validations[json] = tmp;
	            tmp.sqref = [];
	        }
	        this._validations[json].sqref.push(ref);
	    },

	    _getLastRow: function() {
	        return countData(this.options.rows);
	    },

	    _getLastCol: function() {
	        var last = 0;
	        this.options.rows.forEach(function(row) {
	            if (row.cells) {
	                last = Math.max(last, countData(row.cells));
	            }
	        });
	        return last;
	    }
	});

	function countData(data) {
	    var last = data.length;
	    data.forEach(function(el) {
	        if (el.index && el.index >= last) {
	            last = el.index + 1;
	        }
	    });
	    return last;
	}

	var MAP_EXCEL_OPERATOR = {
	    // includes only what differs; key is our operator, value is Excel
	    // operator.
	    greaterThanOrEqualTo : "greaterThanOrEqual",
	    lessThanOrEqualTo    : "lessThanOrEqual"
	};

	var MAP_EXCEL_TYPE = {
	    number: "decimal"
	};

	var defaultFormats = {
	    "General": 0,
	    "0": 1,
	    "0.00": 2,
	    "#,##0": 3,
	    "#,##0.00": 4,
	    "0%": 9,
	    "0.00%": 10,
	    "0.00E+00": 11,
	    "# ?/?": 12,
	    "# ??/??": 13,
	    "mm-dd-yy": 14,
	    "d-mmm-yy": 15,
	    "d-mmm": 16,
	    "mmm-yy": 17,
	    "h:mm AM/PM": 18,
	    "h:mm:ss AM/PM": 19,
	    "h:mm": 20,
	    "h:mm:ss": 21,
	    "m/d/yy h:mm": 22,
	    "#,##0 ;(#,##0)": 37,
	    "#,##0 ;[Red](#,##0)": 38,
	    "#,##0.00;(#,##0.00)": 39,
	    "#,##0.00;[Red](#,##0.00)": 40,
	    "mm:ss": 45,
	    "[h]:mm:ss": 46,
	    "mmss.0": 47,
	    "##0.0E+0": 48,
	    "@": 49,
	    "[$-404]e/m/d": 27,
	    "m/d/yy": 30,
	    "t0": 59,
	    "t0.00": 60,
	    "t#,##0": 61,
	    "t#,##0.00": 62,
	    "t0%": 67,
	    "t0.00%": 68,
	    "t# ?/?": 69,
	    "t# ??/??": 70
	};

	function convertColor(value) {
	    var color = value;
	    if (color.length < 6) {
	        color = color.replace(/(\w)/g, function($0, $1) {
	            return $1 + $1;
	        });
	    }

	    color = color.substring(1).toUpperCase();

	    if (color.length < 8) {
	        color = "FF" + color;
	    }

	    return color;
	}

	var Workbook = kendo.Class.extend({
	    init: function(options) {
	        var this$1 = this;

	        this.options = options || {};
	        this._strings = {
	            indexes: {},
	            count: 0,
	            uniqueCount: 0
	        };
	        this._styles = [];
	        this._borders = [];
	        this._images = this.options.images;
	        this._imgId = 0;

	        this._sheets = map(this.options.sheets || [], function (options, i) {
	            options.defaults = this$1.options;
	            options.sheetIndex = i + 1;
	            return new Worksheet(options, this$1._strings, this$1._styles, this$1._borders);
	        });
	    },

	    imageFilename: function(mimeType) {
	        var id = ++this._imgId;
	        switch (mimeType) {
	          case "image/jpg":
	          case "image/jpeg":
	            return ("image" + id + ".jpg");
	          case "image/png":
	            return ("image" + id + ".png");
	          case "image/gif":
	            return ("image" + id + ".gif");
	          default:
	            return ("image" + id + ".bin"); // XXX: anything better to do here?
	        }
	    },

	    toZIP: function() {
	        var this$1 = this;

	        var zip = createZip();

	        var docProps = zip.folder("docProps");

	        docProps.file("core.xml", CORE({
	            creator: this.options.creator || "Kendo UI",
	            lastModifiedBy: this.options.creator || "Kendo UI",
	            created: this.options.date || new Date().toJSON(),
	            modified: this.options.date || new Date().toJSON()
	        }));

	        var sheetCount = this._sheets.length;

	        docProps.file("app.xml", APP({ sheets: this._sheets }));

	        var rels = zip.folder("_rels");
	        rels.file(".rels", RELS);

	        var xl = zip.folder("xl");

	        var xlRels = xl.folder("_rels");
	        xlRels.file("workbook.xml.rels", WORKBOOK_RELS({ count: sheetCount }));

	        if (this._images) {
	            var media = xl.folder("media");
	            Object.keys(this._images).forEach(function (id) {
	                var img = this$1._images[id];
	                var filename = this$1.imageFilename(img.type);
	                media.file(filename, img.data);
	                img.target = "../media/" + filename;
	            });
	        }

	        var sheetIds = {};
	        xl.file("workbook.xml", WORKBOOK({
	            sheets: this._sheets,
	            filterNames: map(this._sheets, function(sheet, index) {
	                var options = sheet.options;
	                var sheetName = (options.name || options.title || "Sheet" + (index + 1));
	                sheetIds[sheetName.toLowerCase()] = index;
	                var filter = options.filter;
	                if (filter) {
	                    if (filter.ref) {
	                        // spreadsheet provides `ref`
	                        var a = filter.ref.split(":");
	                        var from = parseRef(a[0]);
	                        var to = parseRef(a[1]);
	                        return {
	                            localSheetId: index,
	                            name: sheetName,
	                            from: $ref(from.row, from.col),
	                            to: $ref(to.row, to.col)
	                        };
	                    } else if (typeof filter.from !== "undefined" && typeof filter.to !== "undefined") {
	                        // grid does this
	                        return {
	                            localSheetId: index,
	                            name: sheetName,
	                            from: $ref(filterRowIndex(options), filter.from),
	                            to: $ref(filterRowIndex(options), filter.to)
	                        };
	                    }
	                }
	            }),
	            userNames: map(this.options.names || [], function(def) {
	                return {
	                    name: def.localName,
	                    localSheetId: def.sheet ? sheetIds[def.sheet.toLowerCase()] : null,
	                    value: def.value,
	                    hidden: def.hidden
	                };
	            })
	        }));

	        var worksheets = xl.folder("worksheets");
	        var drawings = xl.folder("drawings");
	        var drawingsRels = drawings.folder("_rels");
	        var sheetRels = worksheets.folder("_rels");
	        var commentFiles = [];
	        var drawingFiles = [];

	        for (var idx = 0; idx < sheetCount; idx++) {
	            var sheet = this$1._sheets[idx];
	            var sheetName = "sheet" + (idx + 1) + ".xml";
	            var sheetXML = sheet.toXML(idx); // must be called before relsToXML
	            var relsXML = sheet.relsToXML();
	            var commentsXML = sheet.commentsXML();
	            var legacyDrawing = sheet.legacyDrawing();
	            var drawingsXML = sheet.drawingsXML(this$1._images);

	            if (relsXML) {
	                sheetRels.file(sheetName + ".rels", relsXML);
	            }
	            if (commentsXML) {
	                var name = "comments" + (sheet.options.sheetIndex) + ".xml";
	                xl.file(name, commentsXML);
	                commentFiles.push(name);
	            }
	            if (legacyDrawing) {
	                drawings.file(("vmlDrawing" + (sheet.options.sheetIndex) + ".vml"), legacyDrawing);
	            }
	            if (drawingsXML) {
	                var name$1 = "drawing" + (sheet.options.sheetIndex) + ".xml";
	                drawings.file(name$1, drawingsXML.main);
	                drawingsRels.file((name$1 + ".rels"), drawingsXML.rels);
	                drawingFiles.push(name$1);
	            }

	            worksheets.file(sheetName, sheetXML);
	        }

	        var borders = map(this._borders, parseJSON);

	        var styles = map(this._styles, parseJSON);

	        var hasFont = function(style) {
	            return style.underline || style.bold || style.italic || style.color || style.fontFamily || style.fontSize;
	        };

	        var convertFontSize = function(value) {
	            var fontInPx = Number(value);
	            var fontInPt;

	            if (fontInPx) {
	                fontInPt = fontInPx * 3 / 4;
	            }

	            return fontInPt;
	        };

	        var fonts = map(styles, function(style) {
	            if (style.fontSize) {
	                style.fontSize = convertFontSize(style.fontSize);
	            }

	            if (style.color) {
	                style.color = convertColor(style.color);
	            }

	            if (hasFont(style)) {
	                return style;
	            }
	        });

	        var formats = map(styles, function(style) {
	            if (style.format && defaultFormats[style.format] === undefined) {
	                return style;
	            }
	        });

	        var fills = map(styles, function(style) {
	            if (style.background) {
	                style.background = convertColor(style.background);
	                return style;
	            }
	        });

	        xl.file("styles.xml", STYLES({
	            fonts: fonts,
	            fills: fills,
	            formats: formats,
	            borders: borders,
	            styles: map(styles, function(style) {
	                var result = {};

	                if (hasFont(style)) {
	                    result.fontId = indexOf(style, fonts) + 1;
	                }

	                if (style.background) {
	                    result.fillId = indexOf(style, fills) + 2;
	                }

	                result.textAlign = style.textAlign;
	                result.indent = style.indent;
	                result.verticalAlign = style.verticalAlign;
	                result.wrap = style.wrap;
	                result.borderId = style.borderId;

	                if (style.format) {
	                    if (defaultFormats[style.format] !== undefined) {
	                        result.numFmtId = defaultFormats[style.format];
	                    } else {
	                        result.numFmtId = 165 + indexOf(style, formats);
	                    }
	                }

	                return result;
	            })
	        }));

	        xl.file("sharedStrings.xml", SHARED_STRINGS(this._strings));

	        zip.file("[Content_Types].xml", CONTENT_TYPES({
	            sheetCount: sheetCount,
	            commentFiles: commentFiles,
	            drawingFiles: drawingFiles
	        }));

	        return zip;
	    },

	    toDataURL: function() {
	        var zip = this.toZIP();

	        return zip.generateAsync ? zip.generateAsync(DATA_URL_OPTIONS).then(toDataURI) : toDataURI(zip.generate(DATA_URL_OPTIONS));
	    },

	    toBlob: function() {
	        var zip = this.toZIP();
	        if (zip.generateAsync) {
	            return zip.generateAsync(BLOB_OPTIONS);
	        }
	        return new Blob([ zip.generate(ARRAYBUFFER_OPTIONS) ], { type: MIME_TYPE });
	    }
	});

	function borderStyle(width) {
	    var alias = "thin";

	    if (width === 2) {
	        alias = "medium";
	    } else if (width === 3) {
	        alias = "thick";
	    }

	    return alias;
	}

	function borderSideTemplate(name, style) {
	    var result = "";

	    if (style) {
	        result += "<" + name + " style=\"" + borderStyle(style.size) + "\">";
	        if (style.color) {
	            result += "<color rgb=\"" + convertColor(style.color) + "\"/>";
	        }
	        result += "</" + name + ">";
	    }

	    return result;
	}

	function borderTemplate(border) {
	    return "<border>" +
	       borderSideTemplate("left", border.left) +
	       borderSideTemplate("right", border.right) +
	       borderSideTemplate("top", border.top) +
	       borderSideTemplate("bottom", border.bottom) +
	   "</border>";
	}

	var EMPTY_CELL = {};
	function inflate(rows, mergedCells) {
	    var rowData = [];
	    var rowsByIndex = [];

	    indexRows(rows, function(row, index) {
	        var data = {
	            _source: row,
	            index: index,
	            height: row.height,
	            level: row.level,
	            cells: []
	        };

	        rowData.push(data);
	        rowsByIndex[index] = data;
	    });

	    var sorted = sortByIndex(rowData).slice(0);
	    var ctx = {
	        rowData: rowData,
	        rowsByIndex: rowsByIndex,
	        mergedCells: mergedCells
	    };

	    for (var i = 0; i < sorted.length; i++) {
	        fillCells(sorted[i], ctx);
	        delete sorted[i]._source;
	    }

	    return sortByIndex(rowData);
	}

	function indexRows(rows, callback) {
	    for (var i = 0; i < rows.length; i++) {
	        var row = rows[i];
	        if (!row) {
	            continue;
	        }

	        var index = row.index;
	        if (typeof index !== "number") {
	            index = i;
	        }

	        callback(row, index);
	    }
	}

	function sortByIndex(items) {
	    return items.sort(function(a, b) {
	        return a.index - b.index;
	    });
	}

	function pushUnique(array, el) {
	    if (array.indexOf(el) < 0) {
	        array.push(el);
	    }
	}

	function getSpan(mergedCells, ref) {
	    for (var i = 0; i < mergedCells.length; ++i) {
	        var range = mergedCells[i];
	        var a = range.split(":");
	        var topLeft = a[0];
	        if (topLeft === ref) {
	            var bottomRight = a[1];
	            topLeft = parseRef(topLeft);
	            bottomRight = parseRef(bottomRight);
	            return {
	                rowSpan: bottomRight.row - topLeft.row + 1,
	                colSpan: bottomRight.col - topLeft.col + 1
	            };
	        }
	    }
	}

	function parseRef(ref) {
	    function getcol(str) {
	        var upperStr = str.toUpperCase();
	        var col = 0;
	        for (var i = 0; i < upperStr.length; ++i) {
	            col = col * 26 + upperStr.charCodeAt(i) - 64;
	        }
	        return col - 1;
	    }

	    function getrow(str) {
	        return parseInt(str, 10) - 1;
	    }

	    var m = /^([a-z]+)(\d+)$/i.exec(ref);
	    return {
	        row: getrow(m[2]),
	        col: getcol(m[1])
	    };
	}

	function pixelsToExcel(px) {
	    return Math.round(px * 9525);
	}

	function fillCells(data, ctx) {
	    var row = data._source;
	    var rowIndex = data.index;
	    var cells = row.cells;
	    var cellData = data.cells;

	    if (!cells) {
	        return;
	    }

	    for (var i = 0; i < cells.length; i++) {
	        var cell = cells[i] || EMPTY_CELL;

	        var rowSpan = cell.rowSpan || 1;
	        var colSpan = cell.colSpan || 1;

	        var cellIndex = insertCell(cellData, cell);
	        var topLeftRef = ref(rowIndex, cellIndex);

	        if (rowSpan === 1 && colSpan === 1) {
	            // could still be merged: the spreadsheet does not send
	            // rowSpan/colSpan, but mergedCells is already populated.
	            // https://github.com/telerik/kendo-ui-core/issues/2401
	            var tmp = getSpan(ctx.mergedCells, topLeftRef);
	            if (tmp) {
	                colSpan = tmp.colSpan;
	                rowSpan = tmp.rowSpan;
	            }
	        }

	        spanCell(cell, cellData, cellIndex, colSpan);

	        if (rowSpan > 1 || colSpan > 1) {
	            pushUnique(ctx.mergedCells,
	                       topLeftRef + ":" + ref(rowIndex + rowSpan - 1,
	                                              cellIndex + colSpan - 1));
	        }

	        if (rowSpan > 1) {
	            for (var ri = rowIndex + 1; ri < rowIndex + rowSpan; ri++) {
	                var nextRow = ctx.rowsByIndex[ri];
	                if (!nextRow) {
	                    nextRow = ctx.rowsByIndex[ri] = { index: ri, cells: [] };
	                    ctx.rowData.push(nextRow);
	                }

	                spanCell(cell, nextRow.cells, cellIndex - 1, colSpan + 1);
	            }
	        }
	    }
	}

	function insertCell(data, cell) {
	    var index;

	    if (typeof cell.index === "number") {
	        index = cell.index;
	        insertCellAt(data, cell, cell.index);
	    } else {
	        index = appendCell(data, cell);
	    }

	    return index;
	}

	function insertCellAt(data, cell, index) {
	    data[index] = cell;
	}

	function appendCell(data, cell) {
	    var index = data.length;

	    for (var i = 0; i < data.length + 1; i++) {
	        if (!data[i]) {
	            data[i] = cell;
	            index = i;
	            break;
	        }
	    }

	    return index;
	}

	function spanCell(cell, row, startIndex, colSpan) {
	    for (var i = 1; i < colSpan; i++) {
	        var tmp = {
	            borderTop    : cell.borderTop,
	            borderRight  : cell.borderRight,
	            borderBottom : cell.borderBottom,
	            borderLeft   : cell.borderLeft
	        };
	        insertCellAt(row, tmp, startIndex + i);
	    }
	}

	var SPREADSHEET_FILTERS = function (ref$1) {
	  var ref = ref$1.ref;
	  var columns = ref$1.columns;
	  var generators = ref$1.generators;

	  return ("\n<autoFilter ref=\"" + ref + "\">\n  " + (foreach(columns, function (col) { return ("\n    <filterColumn colId=\"" + (col.index) + "\">\n      " + (generators[col.filter](col)) + "\n    </filterColumn>\n  "); })) + "\n</autoFilter>");
	};

	var SPREADSHEET_CUSTOM_FILTER = function (ref) {
	  var logic = ref.logic;
	  var criteria = ref.criteria;

	  return ("\n<customFilters " + (logic === 'and' ? 'and="1"' : '') + ">\n" + (foreach(criteria, function (f) {
	    var op = spreadsheetFilters.customOperator(f);
	    var val = spreadsheetFilters.customValue(f);
	    return ("<customFilter " + (op ? ("operator=\"" + op + "\"") : '') + " val=\"" + val + "\"/>");
	})) + "\n</customFilters>");
	};

	var SPREADSHEET_DYNAMIC_FILTER = function (ref) {
	  var type = ref.type;

	  return ("<dynamicFilter type=\"" + (spreadsheetFilters.dynamicFilterType(type)) + "\" />");
	};

	var SPREADSHEET_TOP_FILTER = function (ref) {
	  var type = ref.type;
	  var value = ref.value;

	  return ("<top10 percent=\"" + (/percent$/i.test(type) ? 1 : 0) + "\"\n       top=\"" + (/^top/i.test(type) ? 1 : 0) + "\"\n       val=\"" + value + "\" />");
	};

	var SPREADSHEET_VALUE_FILTER = function (ref) {
	    var blanks = ref.blanks;
	    var values = ref.values;

	    return ("<filters " + (blanks ? 'blank="1"' : '') + ">\n    " + (foreach(values, function (value) { return ("\n      <filter val=\"" + value + "\" />"); })) + "\n  </filters>");
	};

	function spreadsheetFilters(filter) {
	    return SPREADSHEET_FILTERS({
	        ref: filter.ref,
	        columns: filter.columns,
	        generators: {
	            custom  : SPREADSHEET_CUSTOM_FILTER,
	            dynamic : SPREADSHEET_DYNAMIC_FILTER,
	            top     : SPREADSHEET_TOP_FILTER,
	            value   : SPREADSHEET_VALUE_FILTER
	        }
	    });
	}

	spreadsheetFilters.customOperator = function(f) {
	    return {
	        eq  : "equal",
	        gt  : "greaterThan",
	        gte : "greaterThanOrEqual",
	        lt  : "lessThan",
	        lte : "lessThanOrEqual",
	        ne  : "notEqual",

	        // These are not in the spec, but seems to be how Excel does
	        // it (see customValue below).  For the non-negated versions,
	        // the operator attribute is missing completely.
	        doesnotstartwith: "notEqual",
	        doesnotendwith: "notEqual",
	        doesnotcontain: "notEqual",
	        doesnotmatch: "notEqual"
	    }[f.operator.toLowerCase()];
	};

	function quoteSheet(name) {
	    if (/^\'/.test(name)) { // assume already quoted, the Spreadsheet does it.
	        return name;
	    }
	    if (/^[a-z_][a-z0-9_]*$/i.test(name)) {
	        return name;        // no need to quote it
	    }
	    return "'" + name.replace(/\x27/g, "\\'") + "'";
	}

	spreadsheetFilters.customValue = function(f) {
	    function esc(str) {
	        return str.replace(/([*?])/g, "~$1");
	    }

	    switch (f.operator.toLowerCase()) {
	        case "startswith":
	        case "doesnotstartwith":
	            return esc(f.value) + "*";

	        case "endswith":
	        case "doesnotendwith":
	            return "*" + esc(f.value);

	        case "contains":
	        case "doesnotcontain":
	            return "*" + esc(f.value) + "*";

	        default:
	            return f.value;
	    }
	};

	spreadsheetFilters.dynamicFilterType = function(type) {
	    return {
	        quarter1  : "Q1",
	        quarter2  : "Q2",
	        quarter3  : "Q3",
	        quarter4  : "Q4",
	        january   : "M1",
	        february  : "M2",
	        march     : "M3",
	        april     : "M4",
	        may       : "M5",
	        june      : "M6",
	        july      : "M7",
	        august    : "M8",
	        september : "M9",
	        october   : "M10",
	        november  : "M11",
	        december  : "M12"
	    }[type.toLowerCase()] || type;
	};

	kendo.deepExtend(kendo.ooxml, {
	    IntlService: IntlService,
	    Workbook: Workbook,
	    Worksheet: Worksheet
	});

	})(window.kendo.jQuery);

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "TLGp":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1605);
	module.exports = __webpack_require__(1605);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1605:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20), __webpack_require__(1606) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    // jshint laxbreak: true

	    var CellRef = kendo.spreadsheet.CellRef;
	    var RangeRef = kendo.spreadsheet.RangeRef;
	    var UnionRef = kendo.spreadsheet.UnionRef;

	    var Rectangle = kendo.Class.extend({
	        init: function Rectangle(left, top, width, height) {
	            this.left = left;
	            this.top = top;
	            this.width = width;
	            this.height = height;
	            this.right = this.left + this.width;
	            this.bottom = this.top + this.height;
	        },

	        offset: function(left, top) {
	            return new Rectangle(this.left + left, this.top + top, this.width, this.height);
	        },

	        resize: function(width, height) {
	            return new Rectangle(this.left, this.top, this.width + width, this.height + height);
	        },

	        intersects: function(x, y) {
	            if (x instanceof Rectangle) {
	                return this.intersectsRect(x);
	            }
	            return this.left < x && x < this.left + this.width &&
	                   this.top < y && y < this.top + this.height;
	        },

	        intersectsRect: function(b) {
	            var a = this;
	            return a.left <= b.right
	                && b.left <= a.right
	                && a.top <= b.bottom
	                && b.top <= a.bottom;
	        },

	        toDiv: function(className) {
	            return kendo.dom.element("div", {
	                className: className,
	                style: {
	                    width:  this.width + "px",
	                    height: this.height + "px",
	                    top:    this.top + "px",
	                    left:   this.left + "px"
	                }
	            });
	        }
	    });

	    // XXX: can we use ES5 yet? :-/
	    //
	    // Object.defineProperty(Rectangle.prototype, "right", {
	    //     get() {
	    //         return this.left + this.width;
	    //     }
	    // });
	    // Object.defineProperty(Rectangle.prototype, "bottom", {
	    //     get() {
	    //         return this.top + this.height;
	    //     }
	    // });

	    var Grid = kendo.Class.extend({
	        init: function(rows, columns, rowCount, columnCount, headerHeight, headerWidth) {
	            this.rowCount = rowCount;
	            this.columnCount = columnCount;
	            this._columns = columns;
	            this._rows = rows;
	            this._headerHeight = headerHeight;
	            this._headerWidth = headerWidth;
	        },

	        isAxis: function(ref) {
	            ref = ref.toRangeRef();
	            var topLeft = ref.topLeft;
	            var bottomRight = ref.bottomRight;
	            return (topLeft.row === 0 && bottomRight.row === this.rowCount - 1) || (topLeft.col === 0 && bottomRight.col === this.columnCount - 1);
	        },

	        width: function(start, end) {
	            return this._columns.sum(start, end);
	        },

	        height: function(start, end) {
	            return this._rows.sum(start, end);
	        },

	        totalHeight: function() {
	            return this._rows.total + this._headerHeight;
	        },

	        totalWidth: function() {
	            return this._columns.total + this._headerWidth;
	        },

	        index: function(row, column) {
	            return column * this.rowCount + row;
	        },

	        cellRef: function(index) {
	            return new CellRef(index % this.rowCount, (index / this.rowCount) >> 0);
	        },

	        rowRef: function(row) {
	            return new RangeRef(new CellRef(row, 0), new CellRef(row, this.columnCount - 1));
	        },

	        colRef: function(col) {
	            return new RangeRef(new CellRef(0, col), new CellRef(this.rowCount - 1, col));
	        },

	        cellRefIndex: function(ref) {
	            return this.index(ref.row, ref.col);
	        },

	        normalize: function(ref) {
	            if (ref instanceof RangeRef) {
	                return new RangeRef(
	                    this.normalize(ref.topLeft),
	                    this.normalize(ref.bottomRight)
	                ).setSheet(ref.sheet, ref.hasSheet());
	            }

	            if (ref instanceof UnionRef) {
	                return ref.map(function(ref) {
	                    return this.normalize(ref);
	                }, this);
	            }

	            if (ref instanceof CellRef) {
	                ref = ref.clone();
	                ref.col = Math.max(0, Math.min(this.columnCount - 1, ref.col));
	                ref.row = Math.max(0, Math.min(this.rowCount - 1, ref.row));
	            }

	            return ref;
	        },

	        rectangle: function(ref) {
	            var topLeft = this.normalize(ref.topLeft);
	            var bottomRight = this.normalize(ref.bottomRight);
	            return new Rectangle(
	                this.width(0, topLeft.col - 1),
	                this.height(0, topLeft.row - 1),
	                this.width(topLeft.col, bottomRight.col),
	                this.height(topLeft.row, bottomRight.row)
	            );
	        },

	        pane: function(options) {
	            return new PaneGrid(
	                new kendo.spreadsheet.PaneAxis(this._rows, options.row, options.rowCount, this._headerHeight),
	                new kendo.spreadsheet.PaneAxis(this._columns, options.column, options.columnCount, this._headerWidth),
	                this
	            );
	        },

	        rangeDimensions: function(rangeRef) {
	            return {
	                rows: this._rows.values.iterator(rangeRef.topLeft.row, rangeRef.bottomRight.row),
	                columns: this._columns.values.iterator(rangeRef.topLeft.col, rangeRef.bottomRight.col)
	            };
	        },

	        forEach: function(ref, callback) {
	            var topLeft = this.normalize(ref.topLeft);
	            var bottomRight = this.normalize(ref.bottomRight);

	            for (var ci = topLeft.col; ci <= bottomRight.col; ci ++) {
	                for (var ri = topLeft.row; ri <= bottomRight.row; ri ++) {
	                    callback(new CellRef(ri, ci));
	                }
	            }
	        },

	        trim: function(ref, property) {
	            var topLeft = this.normalize(ref.topLeft);
	            var bottomRight = this.normalize(ref.bottomRight);
	            var bottomRightRow = topLeft.row;
	            var bottomRightCol = topLeft.col;

	            for (var ci = topLeft.col; ci <= bottomRight.col; ci ++) {
	                var start = this.index(topLeft.row, ci);
	                var end = this.index(bottomRight.row, ci);
	                var values = property.tree.intersecting(start, end);
	                if(values.length) {
	                    var cell = this.cellRef(values[values.length - 1].end);
	                    bottomRightRow = Math.max(bottomRightRow, cell.row);
	                    bottomRightCol = ci;
	                }
	            }
	            return new RangeRef(ref.topLeft, new CellRef(Math.min(bottomRightRow, ref.bottomRight.row), bottomRightCol));
	        }
	    });

	    var PaneGrid = kendo.Class.extend({
	        init: function(rows, columns, grid) {
	            this.rows = rows;
	            this.columns = columns;
	            this._grid = grid;

	            this.headerHeight = rows.headerSize;
	            this.headerWidth = columns.headerSize;
	            this.hasRowHeader = columns.hasHeader;
	            this.hasColumnHeader = rows.hasHeader;
	        },

	        refresh: function(width, height) {
	            this.columns.viewSize(width);
	            this.rows.viewSize(height);

	            var x = this.columns.paneSegment();
	            var y = this.rows.paneSegment();

	            this.left = x.offset;
	            this.top = y.offset;
	            this.right = x.offset + x.length;
	            this.bottom = y.offset + y.length;

	            this.style = {
	                top: y.offset  + "px",
	                left: x.offset + "px",
	                height: y.length + "px",
	                width: x.length + "px"
	            };
	        },

	        view: function(left, top) {
	            var rows = this.rows.visible(top);
	            var columns = this.columns.visible(left);

	            return {
	                rows: rows,
	                columns: columns,

	                rowOffset: rows.offset,
	                columnOffset: columns.offset,

	                mergedCellLeft: columns.start,
	                mergedCellTop: rows.start,

	                ref: new RangeRef(
	                    new CellRef(rows.values.start, columns.values.start),
	                    new CellRef(rows.values.end, columns.values.end)
	                )
	            };
	        },

	        contains: function(ref) {
	            return this.rows.contains(ref.topLeft.row, ref.bottomRight.row) &&
	                this.columns.contains(ref.topLeft.col, ref.bottomRight.col);
	        },

	        index: function(row, column) {
	            return this._grid.index(row, column);
	        },

	        boundingRectangle: function(ref) {
	            return this._grid.rectangle(ref);
	        },

	        cellRefIndex: function(ref) {
	            return this._grid.cellRefIndex(ref);
	        },

	        scrollBoundaries: function(cell) {
	            var position = this.boundingRectangle(cell);

	            var boundaries = {
	                top: Math.max(0, position.top - this.top + (this.hasColumnHeader ? 0 : this.headerHeight)),
	                left: Math.max(0, position.left - this.left + (this.hasRowHeader ? 0 : this.headerWidth)),
	                right: position.right - this.columns._viewSize + this.headerWidth,
	                bottom: position.bottom - this.rows._viewSize + this.headerHeight
	            };

	            var widthCompensation = this.columns.defaultValue / 2;
	            var heightCompensation = this.rows.defaultValue / 2;

	            boundaries.scrollTop = boundaries.top - heightCompensation;
	            boundaries.scrollBottom = boundaries.bottom + heightCompensation;

	            boundaries.scrollLeft = boundaries.left - widthCompensation;
	            boundaries.scrollRight = boundaries.right + widthCompensation;
	            return boundaries;
	        }
	    });

	    kendo.spreadsheet.Grid = Grid;
	    kendo.spreadsheet.PaneGrid = PaneGrid;
	    kendo.spreadsheet.Rectangle = Rectangle;
	})(kendo);
	}, __webpack_require__(3));


/***/ }),

/***/ 1606:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7Ygf");

/***/ })

/******/ });

/***/ }),

/***/ "TM1e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var TabbedLayout = (function () {
    function TabbedLayout(params) {
        var _this = this;
        this.items = [];
        this.params = params;
        this.eGui = document.createElement('div');
        this.eGui.innerHTML = TabbedLayout.TEMPLATE;
        this.eHeader = this.eGui.querySelector('#tabHeader');
        this.eBody = this.eGui.querySelector('#tabBody');
        utils_1.Utils.addCssClass(this.eGui, params.cssClass);
        if (params.items) {
            params.items.forEach(function (item) { return _this.addItem(item); });
        }
    }
    TabbedLayout.prototype.setAfterAttachedParams = function (params) {
        this.afterAttachedParams = params;
    };
    TabbedLayout.prototype.getMinWidth = function () {
        var eDummyContainer = document.createElement('span');
        // position fixed, so it isn't restricted to the boundaries of the parent
        eDummyContainer.style.position = 'fixed';
        // we put the dummy into the body container, so it will inherit all the
        // css styles that the real cells are inheriting
        this.eGui.appendChild(eDummyContainer);
        var minWidth = 0;
        this.items.forEach(function (itemWrapper) {
            utils_1.Utils.removeAllChildren(eDummyContainer);
            var eClone = itemWrapper.tabbedItem.bodyPromise.resolveNow(null, function (body) { return body.cloneNode(true); });
            if (eClone == null)
                return;
            eDummyContainer.appendChild(eClone);
            if (minWidth < eDummyContainer.offsetWidth) {
                minWidth = eDummyContainer.offsetWidth;
            }
        });
        this.eGui.removeChild(eDummyContainer);
        return minWidth;
    };
    TabbedLayout.prototype.showFirstItem = function () {
        if (this.items.length > 0) {
            this.showItemWrapper(this.items[0]);
        }
    };
    TabbedLayout.prototype.addItem = function (item) {
        var eHeaderButton = document.createElement('span');
        eHeaderButton.appendChild(item.title);
        utils_1.Utils.addCssClass(eHeaderButton, 'ag-tab');
        this.eHeader.appendChild(eHeaderButton);
        var wrapper = {
            tabbedItem: item,
            eHeaderButton: eHeaderButton
        };
        this.items.push(wrapper);
        eHeaderButton.addEventListener('click', this.showItemWrapper.bind(this, wrapper));
    };
    TabbedLayout.prototype.showItem = function (tabbedItem) {
        var itemWrapper = utils_1.Utils.find(this.items, function (itemWrapper) {
            return itemWrapper.tabbedItem === tabbedItem;
        });
        if (itemWrapper) {
            this.showItemWrapper(itemWrapper);
        }
    };
    TabbedLayout.prototype.showItemWrapper = function (wrapper) {
        var _this = this;
        if (this.params.onItemClicked) {
            this.params.onItemClicked({ item: wrapper.tabbedItem });
        }
        if (this.activeItem === wrapper) {
            utils_1.Utils.callIfPresent(this.params.onActiveItemClicked);
            return;
        }
        utils_1.Utils.removeAllChildren(this.eBody);
        wrapper.tabbedItem.bodyPromise.then(function (body) {
            _this.eBody.appendChild(body);
        });
        if (this.activeItem) {
            utils_1.Utils.removeCssClass(this.activeItem.eHeaderButton, 'ag-tab-selected');
        }
        utils_1.Utils.addCssClass(wrapper.eHeaderButton, 'ag-tab-selected');
        this.activeItem = wrapper;
        if (wrapper.tabbedItem.afterAttachedCallback) {
            wrapper.tabbedItem.afterAttachedCallback(this.afterAttachedParams);
        }
    };
    TabbedLayout.prototype.getGui = function () {
        return this.eGui;
    };
    TabbedLayout.TEMPLATE = '<div>' +
        '<div id="tabHeader" class="ag-tab-header"></div>' +
        '<div id="tabBody" class="ag-tab-body"></div>' +
        '</div>';
    return TabbedLayout;
}());
exports.TabbedLayout = TabbedLayout;


/***/ }),

/***/ "TNV1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "TcQ7":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("MU5D");
var defined = __webpack_require__("52gC");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "TgGN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = __webpack_require__("pQ38");
var componentAnnotations_1 = __webpack_require__("x5ih");
var utils_1 = __webpack_require__("IRr6");
var baseFilter_1 = __webpack_require__("5yUf");
var context_1 = __webpack_require__("RQ1/");
var componentRecipes_1 = __webpack_require__("EOXx");
var DateFilter = (function (_super) {
    __extends(DateFilter, _super);
    function DateFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateFilter.prototype.modelFromFloatingFilter = function (from) {
        return {
            dateFrom: from,
            dateTo: this.getDateTo(),
            type: this.filter,
            filterType: 'date'
        };
    };
    DateFilter.prototype.getApplicableFilterTypes = function () {
        return [baseFilter_1.BaseFilter.EQUALS, baseFilter_1.BaseFilter.GREATER_THAN, baseFilter_1.BaseFilter.LESS_THAN, baseFilter_1.BaseFilter.NOT_EQUAL, baseFilter_1.BaseFilter.IN_RANGE];
    };
    DateFilter.prototype.bodyTemplate = function () {
        return "<div class=\"ag-filter-body\">\n                    <div class=\"ag-filter-date-from\" id=\"filterDateFromPanel\">\n                    </div>\n                    <div class=\"ag-filter-date-to\" id=\"filterDateToPanel\">\n                    </div>\n                </div>";
    };
    DateFilter.prototype.initialiseFilterBodyUi = function () {
        var _this = this;
        _super.prototype.initialiseFilterBodyUi.call(this);
        var dateComponentParams = {
            onDateChanged: this.onDateChanged.bind(this)
        };
        this.componentRecipes.newDateComponent(dateComponentParams).then(function (dateToComponent) {
            _this.dateToComponent = dateToComponent;
            var dateToElement = _this.dateToComponent.getGui();
            _this.eDateToPanel.appendChild(dateToElement);
            if (_this.dateToComponent.afterGuiAttached) {
                _this.dateToComponent.afterGuiAttached();
            }
        });
        this.componentRecipes.newDateComponent(dateComponentParams).then(function (dateFromComponent) {
            _this.dateFromComponent = dateFromComponent;
            var dateFromElement = _this.dateFromComponent.getGui();
            _this.eDateFromPanel.appendChild(dateFromElement);
            if (_this.dateFromComponent.afterGuiAttached) {
                _this.dateFromComponent.afterGuiAttached();
            }
        });
    };
    DateFilter.prototype.onDateChanged = function () {
        this.dateFrom = DateFilter.removeTimezone(this.dateFromComponent.getDate());
        this.dateTo = DateFilter.removeTimezone(this.dateToComponent.getDate());
        this.onFilterChanged();
    };
    DateFilter.prototype.refreshFilterBodyUi = function () {
        var visible = this.filter === baseFilter_1.BaseFilter.IN_RANGE;
        utils_1.Utils.setVisible(this.eDateToPanel, visible);
    };
    DateFilter.prototype.comparator = function () {
        return this.filterParams.comparator ? this.filterParams.comparator : this.defaultComparator.bind(this);
    };
    DateFilter.prototype.defaultComparator = function (filterDate, cellValue) {
        //The default comparator assumes that the cellValue is a date
        var cellAsDate = cellValue;
        if (cellAsDate < filterDate) {
            return -1;
        }
        if (cellAsDate > filterDate) {
            return 1;
        }
        return cellValue != null ? 0 : -1;
    };
    DateFilter.prototype.serialize = function () {
        return {
            dateTo: utils_1.Utils.serializeDateToYyyyMmDd(this.dateToComponent.getDate(), "-"),
            dateFrom: utils_1.Utils.serializeDateToYyyyMmDd(this.dateFromComponent.getDate(), "-"),
            type: this.filter ? this.filter : this.defaultFilter,
            filterType: 'date'
        };
    };
    DateFilter.prototype.filterValues = function () {
        return this.filter !== baseFilter_1.BaseFilter.IN_RANGE ?
            this.dateFromComponent.getDate() :
            [this.dateFromComponent.getDate(), this.dateToComponent.getDate()];
    };
    // not used by ag-Grid, but exposed as part of the filter API for the client if they want it
    DateFilter.prototype.getDateFrom = function () {
        return utils_1.Utils.serializeDateToYyyyMmDd(this.dateFromComponent.getDate(), "-");
    };
    // not used by ag-Grid, but exposed as part of the filter API for the client if they want it
    DateFilter.prototype.getDateTo = function () {
        return utils_1.Utils.serializeDateToYyyyMmDd(this.dateToComponent.getDate(), "-");
    };
    // not used by ag-Grid, but exposed as part of the filter API for the client if they want it
    DateFilter.prototype.getFilterType = function () {
        return this.filter;
    };
    DateFilter.prototype.setDateFrom = function (date) {
        this.dateFrom = utils_1.Utils.parseYyyyMmDdToDate(date, "-");
        this.dateFromComponent.setDate(this.dateFrom);
    };
    DateFilter.prototype.setDateTo = function (date) {
        this.dateTo = utils_1.Utils.parseYyyyMmDdToDate(date, "-");
        this.dateToComponent.setDate(this.dateTo);
    };
    DateFilter.prototype.resetState = function () {
        this.setDateFrom(null);
        this.setDateTo(null);
        this.setFilterType(this.defaultFilter);
    };
    DateFilter.prototype.parse = function (model) {
        this.setDateFrom(model.dateFrom);
        this.setDateTo(model.dateTo);
        this.setFilterType(model.type);
    };
    DateFilter.prototype.setType = function (filterType) {
        this.setFilterType(filterType);
    };
    DateFilter.removeTimezone = function (from) {
        if (!from)
            return null;
        return new Date(from.getFullYear(), from.getMonth(), from.getDate());
    };
    __decorate([
        context_1.Autowired('componentRecipes'),
        __metadata("design:type", componentRecipes_1.ComponentRecipes)
    ], DateFilter.prototype, "componentRecipes", void 0);
    __decorate([
        componentAnnotations_1.QuerySelector('#filterDateFromPanel'),
        __metadata("design:type", HTMLElement)
    ], DateFilter.prototype, "eDateFromPanel", void 0);
    __decorate([
        componentAnnotations_1.QuerySelector('#filterDateToPanel'),
        __metadata("design:type", HTMLElement)
    ], DateFilter.prototype, "eDateToPanel", void 0);
    return DateFilter;
}(baseFilter_1.ScalarBaseFilter));
exports.DateFilter = DateFilter;
var DefaultDateComponent = (function (_super) {
    __extends(DefaultDateComponent, _super);
    function DefaultDateComponent() {
        return _super.call(this, "<input class=\"ag-filter-filter\" type=\"text\" placeholder=\"yyyy-mm-dd\">") || this;
    }
    DefaultDateComponent.prototype.init = function (params) {
        this.eDateInput = this.getGui();
        if (utils_1.Utils.isBrowserChrome()) {
            this.eDateInput.type = 'date';
        }
        this.listener = params.onDateChanged;
        this.addGuiEventListener('input', this.listener);
    };
    DefaultDateComponent.prototype.getDate = function () {
        return utils_1.Utils.parseYyyyMmDdToDate(this.eDateInput.value, "-");
    };
    DefaultDateComponent.prototype.setDate = function (date) {
        this.eDateInput.value = utils_1.Utils.serializeDateToYyyyMmDd(date, "-");
    };
    return DefaultDateComponent;
}(component_1.Component));
exports.DefaultDateComponent = DefaultDateComponent;


/***/ }),

/***/ "Tttz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var columnUtils_1 = __webpack_require__("PAC5");
var columnGroup_1 = __webpack_require__("YX13");
var originalColumnGroup_1 = __webpack_require__("pOb1");
var context_1 = __webpack_require__("RQ1/");
var utils_1 = __webpack_require__("IRr6");
var context_2 = __webpack_require__("RQ1/");
// takes in a list of columns, as specified by the column definitions, and returns column groups
var DisplayedGroupCreator = (function () {
    function DisplayedGroupCreator() {
    }
    DisplayedGroupCreator.prototype.createDisplayedGroups = function (
        // all displayed columns sorted - this is the columns the grid should show
        sortedVisibleColumns, 
        // the tree of columns, as provided by the users, used to know what groups columns roll up into
        balancedColumnTree, 
        // create's unique id's for the group
        groupInstanceIdCreator, 
        // we try to reuse old groups if we can, to allow gui to do animation
        oldDisplayedGroups) {
        var _this = this;
        var result = [];
        var previousRealPath;
        var previousOriginalPath;
        var oldColumnsMapped = this.mapOldGroupsById(oldDisplayedGroups);
        // go through each column, then do a bottom up comparison to the previous column, and start
        // to share groups if they converge at any point.
        sortedVisibleColumns.forEach(function (currentColumn) {
            var currentOriginalPath = _this.getOriginalPathForColumn(balancedColumnTree, currentColumn);
            var currentRealPath = [];
            var firstColumn = !previousOriginalPath;
            for (var i = 0; i < currentOriginalPath.length; i++) {
                if (firstColumn || currentOriginalPath[i] !== previousOriginalPath[i]) {
                    // new group needed
                    var newGroup = _this.createColumnGroup(currentOriginalPath[i], groupInstanceIdCreator, oldColumnsMapped);
                    currentRealPath[i] = newGroup;
                    // if top level, add to result, otherwise add to parent
                    if (i == 0) {
                        result.push(newGroup);
                    }
                    else {
                        currentRealPath[i - 1].addChild(newGroup);
                    }
                }
                else {
                    // reuse old group
                    currentRealPath[i] = previousRealPath[i];
                }
            }
            var noColumnGroups = currentRealPath.length === 0;
            if (noColumnGroups) {
                // if we are not grouping, then the result of the above is an empty
                // path (no groups), and we just add the column to the root list.
                result.push(currentColumn);
            }
            else {
                var leafGroup = currentRealPath[currentRealPath.length - 1];
                leafGroup.addChild(currentColumn);
            }
            previousRealPath = currentRealPath;
            previousOriginalPath = currentOriginalPath;
        });
        this.setupParentsIntoColumns(result, null);
        return result;
    };
    DisplayedGroupCreator.prototype.createColumnGroup = function (originalGroup, groupInstanceIdCreator, oldColumnsMapped) {
        var groupId = originalGroup.getGroupId();
        var instanceId = groupInstanceIdCreator.getInstanceIdForKey(groupId);
        var uniqueId = columnGroup_1.ColumnGroup.createUniqueId(groupId, instanceId);
        var columnGroup = oldColumnsMapped[uniqueId];
        // if the user is setting new colDefs, it is possible that the id's overlap, and we
        // would have a false match from above. so we double check we are talking about the
        // same original column group.
        if (columnGroup && columnGroup.getOriginalColumnGroup() !== originalGroup) {
            columnGroup = null;
        }
        if (utils_1.Utils.exists(columnGroup)) {
            // clean out the old column group here, as we will be adding children into it again
            columnGroup.reset();
        }
        else {
            columnGroup = new columnGroup_1.ColumnGroup(originalGroup, groupId, instanceId);
            this.context.wireBean(columnGroup);
        }
        return columnGroup;
    };
    // returns back a 2d map of ColumnGroup as follows: groupId -> instanceId -> ColumnGroup
    DisplayedGroupCreator.prototype.mapOldGroupsById = function (displayedGroups) {
        var result = {};
        var recursive = function (columnsOrGroups) {
            columnsOrGroups.forEach(function (columnOrGroup) {
                if (columnOrGroup instanceof columnGroup_1.ColumnGroup) {
                    var columnGroup = columnOrGroup;
                    result[columnOrGroup.getUniqueId()] = columnGroup;
                    recursive(columnGroup.getChildren());
                }
            });
        };
        if (displayedGroups) {
            recursive(displayedGroups);
        }
        return result;
    };
    DisplayedGroupCreator.prototype.setupParentsIntoColumns = function (columnsOrGroups, parent) {
        var _this = this;
        columnsOrGroups.forEach(function (columnsOrGroup) {
            columnsOrGroup.setParent(parent);
            if (columnsOrGroup instanceof columnGroup_1.ColumnGroup) {
                var columnGroup = columnsOrGroup;
                _this.setupParentsIntoColumns(columnGroup.getChildren(), columnGroup);
            }
        });
    };
    // private createFakePath(balancedColumnTree: OriginalColumnGroupChild[], column: Column): OriginalColumnGroup[] {
    //     let fakePath: OriginalColumnGroup[] = [];
    //     let currentChildren = balancedColumnTree;
    //     // this while loop does search on the balanced tree, so our result is the right length
    //     let index = 0;
    //     while (currentChildren && currentChildren[0] && currentChildren[0] instanceof OriginalColumnGroup) {
    //         // putting in a deterministic fake id, in case the API in the future needs to reference the col
    //         let fakeGroup = new OriginalColumnGroup(null, 'FAKE_PATH_' + index, true);
    //         this.context.wireBean(fakeGroup);
    //
    //         // fakePath.setChildren(children);
    //
    //         fakePath.push(fakeGroup);
    //         currentChildren = (<OriginalColumnGroup>currentChildren[0]).getChildren();
    //         index++;
    //     }
    //
    //     fakePath.forEach( (fakePathGroup: OriginalColumnGroup, i: number) => {
    //         let lastItemInList = i === fakePath.length-1;
    //         let child = lastItemInList ? column : fakePath[i+1];
    //         fakePathGroup.setChildren([child]);
    //     });
    //
    //     return fakePath;
    // }
    DisplayedGroupCreator.prototype.getOriginalPathForColumn = function (balancedColumnTree, column) {
        var result = [];
        var found = false;
        recursePath(balancedColumnTree, 0);
        // it's possible we didn't find a path. this happens if the column is generated
        // by the grid (auto-group), in that the definition didn't come from the client. in this case,
        // we create a fake original path.
        if (found) {
            return result;
        }
        else {
            console.log('could not get path');
            return null;
            // return this.createFakePath(balancedColumnTree, column);
        }
        function recursePath(balancedColumnTree, dept) {
            for (var i = 0; i < balancedColumnTree.length; i++) {
                if (found) {
                    // quit the search, so 'result' is kept with the found result
                    return;
                }
                var node = balancedColumnTree[i];
                if (node instanceof originalColumnGroup_1.OriginalColumnGroup) {
                    var nextNode = node;
                    recursePath(nextNode.getChildren(), dept + 1);
                    result[dept] = node;
                }
                else {
                    if (node === column) {
                        found = true;
                    }
                }
            }
        }
    };
    __decorate([
        context_2.Autowired('columnUtils'),
        __metadata("design:type", columnUtils_1.ColumnUtils)
    ], DisplayedGroupCreator.prototype, "columnUtils", void 0);
    __decorate([
        context_2.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], DisplayedGroupCreator.prototype, "context", void 0);
    DisplayedGroupCreator = __decorate([
        context_1.Bean('displayedGroupCreator')
    ], DisplayedGroupCreator);
    return DisplayedGroupCreator;
}());
exports.DisplayedGroupCreator = DisplayedGroupCreator;


/***/ }),

/***/ "U6ln":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__("ZZFX");
var component_1 = __webpack_require__("pQ38");
var utils_1 = __webpack_require__("IRr6");
var TextCellEditor = (function (_super) {
    __extends(TextCellEditor, _super);
    function TextCellEditor() {
        return _super.call(this, TextCellEditor.TEMPLATE) || this;
    }
    TextCellEditor.prototype.init = function (params) {
        this.params = params;
        var eInput = this.getGui();
        var startValue;
        // cellStartedEdit is only false if we are doing fullRow editing
        if (params.cellStartedEdit) {
            this.focusAfterAttached = true;
            var keyPressBackspaceOrDelete = params.keyPress === constants_1.Constants.KEY_BACKSPACE
                || params.keyPress === constants_1.Constants.KEY_DELETE;
            if (keyPressBackspaceOrDelete) {
                startValue = '';
            }
            else if (params.charPress) {
                startValue = params.charPress;
            }
            else {
                startValue = this.getStartValue(params);
                if (params.keyPress !== constants_1.Constants.KEY_F2) {
                    this.highlightAllOnFocus = true;
                }
            }
        }
        else {
            this.focusAfterAttached = false;
            startValue = this.getStartValue(params);
        }
        if (utils_1.Utils.exists(startValue)) {
            eInput.value = startValue;
        }
        this.addDestroyableEventListener(eInput, 'keydown', function (event) {
            var isNavigationKey = event.keyCode === constants_1.Constants.KEY_LEFT
                || event.keyCode === constants_1.Constants.KEY_RIGHT
                || event.keyCode === constants_1.Constants.KEY_UP
                || event.keyCode === constants_1.Constants.KEY_DOWN
                || event.keyCode === constants_1.Constants.KEY_PAGE_DOWN
                || event.keyCode === constants_1.Constants.KEY_PAGE_UP
                || event.keyCode === constants_1.Constants.KEY_PAGE_HOME
                || event.keyCode === constants_1.Constants.KEY_PAGE_END;
            if (isNavigationKey) {
                // this stops the grid from executing keyboard navigation
                event.stopPropagation();
                // this stops the browser from scrolling up / down
                var pageUp = event.keyCode === constants_1.Constants.KEY_PAGE_UP;
                var pageDown = event.keyCode === constants_1.Constants.KEY_PAGE_DOWN;
                if (pageUp || pageDown) {
                    event.preventDefault();
                }
            }
        });
    };
    TextCellEditor.prototype.afterGuiAttached = function () {
        if (!this.focusAfterAttached) {
            return;
        }
        var eInput = this.getGui();
        eInput.focus();
        if (this.highlightAllOnFocus) {
            eInput.select();
        }
        else {
            // when we started editing, we want the carot at the end, not the start.
            // this comes into play in two scenarios: a) when user hits F2 and b)
            // when user hits a printable character, then on IE (and only IE) the carot
            // was placed after the first character, thus 'apply' would end up as 'pplea'
            var length_1 = eInput.value ? eInput.value.length : 0;
            if (length_1 > 0) {
                eInput.setSelectionRange(length_1, length_1);
            }
        }
    };
    // gets called when tabbing trough cells and in full row edit mode
    TextCellEditor.prototype.focusIn = function () {
        var eInput = this.getGui();
        eInput.focus();
        eInput.select();
    };
    TextCellEditor.prototype.getValue = function () {
        var eInput = this.getGui();
        return this.params.parseValue(eInput.value);
    };
    TextCellEditor.prototype.getStartValue = function (params) {
        var formatValue = params.useFormatter || params.column.getColDef().refData;
        return formatValue ? params.formatValue(params.value) : params.value;
    };
    TextCellEditor.TEMPLATE = '<input class="ag-cell-edit-input" type="text"/>';
    return TextCellEditor;
}(component_1.Component));
exports.TextCellEditor = TextCellEditor;


/***/ }),

/***/ "U8qt":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1260);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1187:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("99zt");

/***/ }),

/***/ 1191:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1Z35");

/***/ }),

/***/ 1253:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("n1t0");

/***/ }),

/***/ 1260:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1059), __webpack_require__(1086), __webpack_require__(1191), __webpack_require__(1253), __webpack_require__(1261), __webpack_require__(1262), __webpack_require__(1187)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "gantt.editors",
	    name: "GanttEditors",
	    category: "web",
	    description: "The Gantt component editors.",
	    depends: [ "data", "popup", "window", "gantt.data", "grid", "datetimepicker", "numerictextbox"],
	    hidden: true
	};

	(function($, undefined) {

	    var kendo = window.kendo,
	        ui = kendo.ui,
	        browser = kendo.support.browser,
	        Observable = kendo.Observable,
	        Widget = ui.Widget,
	        outerWidth = kendo._outerWidth,

	        keys = $.extend({F10: 121}, kendo.keys),

	        proxy = $.proxy,
	        extend = $.extend,
	        isPlainObject = $.isPlainObject,

	        NS = ".kendoGantt",
	        PERCENTAGE_FORMAT = "p0",
	        TABINDEX = "tabIndex",
	        CLICK = "click",
	        WIDTH = "width",
	        STRING = "string",
	        ARIA_DESCENDANT = "aria-activedescendant",
	        ACTIVE_OPTION = "action-option-focused",
	        DOT = ".",

	        DIRECTIONS = {
	            "down": {
	                origin: "bottom left",
	                position: "top left"
	            },
	            "up": {
	                origin: "top left",
	                position: "bottom left"
	            }
	        },

	        TASK_DROPDOWN_TEMPLATE = kendo.template('<div class="#=styles.popupWrapper#">' +
	            '<ul class="#=styles.popupList#" role="listbox">' +
	                '#for(var i = 0, l = actions.length; i < l; i++){#' +
	                    '<li class="#=styles.item#" data-action="#=actions[i].data#" role="option">#=actions[i].text#</span>' +
	                '#}#' +
	            '</ul>' +
	        '</div>');

	    var ganttStyles = {
	        buttonDelete: "k-gantt-delete",
	        buttonCancel: "k-gantt-cancel",
	        buttonSave: "k-gantt-update",
	        focused: "k-state-focused",
	        gridContent: "k-grid-content",
	        hovered: "k-state-hover",
	        item: "k-item",
	        popupWrapper: "k-list-container",
	        popupList: "k-list k-reset",
	        popup: {
	            form: "k-popup-edit-form",
	            editForm: "k-gantt-edit-form",
	            formContainer: "k-edit-form-container",
	            resourcesFormContainer: "k-resources-form-container",
	            message: "k-popup-message",
	            buttonsContainer: "k-edit-buttons k-state-default",
	            button: "k-button",
	            editField: "k-edit-field",
	            editLabel: "k-edit-label",
	            resourcesField: "k-gantt-resources"
	        },
	        primary: "k-primary",
	        toolbar: {
	            appendButton: "k-gantt-create"
	        }
	    };

	    var DATERANGEEDITOR = function(container, options) {
	        var attr = { name: options.field, title: options.title };
	        var validationRules = options.model.fields[options.field].validation;

	        if (validationRules && isPlainObject(validationRules) && validationRules.message) {
	            attr[kendo.attr("dateCompare-msg")] = validationRules.message;
	        }

	        $('<input type="text" required ' +
	                kendo.attr("type") + '="date" ' +
	                kendo.attr("role") + '="datetimepicker" ' +
	                kendo.attr("bind") + '="value:' +
	                options.field +'" ' +
	                kendo.attr("validate") + "='true' />")
	            .attr(attr)
	            .appendTo(container);

	        $('<span ' + kendo.attr("for") + '="' + options.field + '" class="k-invalid-msg"/>')
	            .hide()
	            .appendTo(container);
	    };

	    var RESOURCESEDITOR = function(container, options) {
	        $('<a href="#" class="' + options.styles.button + '">' + options.messages.assignButton + '</a>').click(options.click).appendTo(container);
	    };

	    var TaskDropDown = Observable.extend({
	        init: function(element, options) {

	            Observable.fn.init.call(this);

	            this.element = element;
	            this.options = extend(true, {}, this.options, options);

	            this._popup();
	        },

	        options: {
	            direction: "down",
	            navigatable: false
	        },

	        destroy: function() {
	            clearTimeout(this._focusTimeout);
	            this.popup.destroy();
	            this.element.off(NS);
	            this.list.off(NS);
	            this.unbind();
	        },

	        _adjustListWidth: function() {
	            var list = this.list;
	            var width = list[0].style.width;
	            var wrapper = this.element;
	            var listOuterWidth = outerWidth(list);
	            var computedStyle;
	            var computedWidth;

	            if (!list.data(WIDTH) && width) {
	                return;
	            }

	            computedStyle = window.getComputedStyle ? window.getComputedStyle(wrapper[0], null) : 0;
	            computedWidth = computedStyle ? parseFloat(computedStyle.width) : outerWidth(wrapper);

	            if (computedStyle && (browser.mozilla || browser.msie)) { // getComputedStyle returns different box in FF and IE.
	                computedWidth += parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight) + parseFloat(computedStyle.borderLeftWidth) + parseFloat(computedStyle.borderRightWidth);
	            }

	            if (list.css("box-sizing") !== "border-box") {
	                width = computedWidth - (outerWidth(list) - list.width());
	            } else {
	                width = computedWidth;
	            }

	            if (listOuterWidth > width) {
	                width = listOuterWidth;
	            }

	            list.css({
	                fontFamily: wrapper.css("font-family"),
	                width: width
	            })
	            .data(WIDTH, width);
	        },

	        _current: function(method) {
	            var current = this.list
	                .find(DOT + ganttStyles.focused);
	            var sibling = current[method]();

	            if (sibling.length) {
	                current
	                    .removeClass(ganttStyles.focused)
	                    .removeAttr("id");
	                sibling
	                    .addClass(ganttStyles.focused)
	                    .attr("id", ACTIVE_OPTION);

	                this.list.find("ul")
	                    .removeAttr(ARIA_DESCENDANT)
	                    .attr(ARIA_DESCENDANT, ACTIVE_OPTION);
	            }
	        },

	        _popup: function() {
	            var that = this;
	            var itemSelector = "li" + DOT + ganttStyles.item;
	            var actions = this.options.messages.actions;
	            var navigatable = this.options.navigatable;

	            this.list = $(TASK_DROPDOWN_TEMPLATE({
	                styles: ganttStyles,
	                actions: [
	                    {
	                        data: "add",
	                        text: actions.addChild
	                    },
	                    {
	                        data: "insert-before",
	                        text: actions.insertBefore
	                    },
	                    {
	                        data: "insert-after",
	                        text: actions.insertAfter
	                    }
	                ]
	            }));

	            this.element.append(this.list);

	            this.popup = new kendo.ui.Popup(this.list,
	                extend({
	                    anchor: this.element,
	                    open: function() {
	                        that._adjustListWidth();
	                    },
	                    animation: this.options.animation
	                }, DIRECTIONS[this.options.direction])
	            );

	            this.element
	                .on(CLICK + NS, function(e) {
	                    var target = $(this);
	                    var action = target.attr(kendo.attr("action"));

	                    e.preventDefault();

	                    if (action) {
	                        that.trigger("command", { type: action });
	                    } else {
	                        that.popup.open();

	                        if (navigatable) {
	                            that.list
	                                .find("li:first")
	                                .addClass(ganttStyles.focused)
	                                .attr("id", ACTIVE_OPTION)
	                                .end()
	                                .find("ul")
	                                .attr({
	                                    TABINDEX: 0,
	                                    "aria-activedescendant": ACTIVE_OPTION
	                                })
	                                .focus();
	                        }
	                    }
	                });

	            this.list
	                .find(itemSelector)
	                .hover(function() {
	                    $(this).addClass(ganttStyles.hovered);
	                }, function() {
	                    $(this).removeClass(ganttStyles.hovered);
	                })
	                .end()
	                .on(CLICK + NS, itemSelector, function() {
	                    that.trigger("command", { type: $(this).attr(kendo.attr("action")) });
	                    that.popup.close();
	                });

	            if (navigatable) {
	                this.popup
	                    .bind("close", function() {
	                        that.list
	                            .find(itemSelector)
	                            .removeClass(ganttStyles.focused)
	                            .end()
	                            .find("ul")
	                            .attr(TABINDEX, 0);

	                        that.element
	                            .parents('[' + kendo.attr("role") + '="gantt"]')
	                            .find(DOT + ganttStyles.gridContent + " > table:first")
	                            .focus();
	                    });

	                this.list
	                    .find("ul")
	                    .on("keydown" + NS, function(e) {
	                        var key = e.keyCode;

	                        switch (key) {
	                            case keys.UP:
	                                e.preventDefault();
	                                that._current("prev");
	                                break;
	                            case keys.DOWN:
	                                e.preventDefault();
	                                that._current("next");
	                                break;
	                            case keys.ENTER:
	                                that.list
	                                    .find(DOT + ganttStyles.focused)
	                                    .click();
	                                break;
	                            case keys.ESC:
	                                e.preventDefault();
	                                that.popup.close();
	                                break;
	                        }
	                    });
	            }
	        }
	    });

	    var editors = {
	        desktop: {
	            dateRange: DATERANGEEDITOR,
	            resources: RESOURCESEDITOR
	        }
	    };

	    var Editor = kendo.Observable.extend({
	        init: function(element, options) {
	            kendo.Observable.fn.init.call(this);

	            this.element = element;
	            this.options = extend(true, {}, this.options, options);
	            this.createButton = this.options.createButton;
	        },

	        fields: function(editors, model, plannedEditors) {
	            var that = this;
	            var options = this.options;
	            var messages = options.messages.editor;
	            var resources = options.resources;
	            var fields;

	            var click = function(e) {
	                e.preventDefault();
	                resources.editor(that.container.find(DOT + ganttStyles.popup.resourcesField), model);
	            };

	            if (options.editable.template) {
	                fields = $.map(model.fields, function(value, key) {
	                            return { field: key };
	                        });
	            } else {
	                fields = [
	                    { field: "title", title: messages.title },
	                    { field: "start", title: messages.start, editor: editors.dateRange },
	                    { field: "end", title: messages.end, editor: editors.dateRange },
	                    { field: "percentComplete", title: messages.percentComplete, format: PERCENTAGE_FORMAT }
	                ];

	                if(plannedEditors) {
	                    fields.splice.apply(fields, [1, 0].concat([
	                        { field: "plannedStart", title: messages.plannedStart, editor: editors.dateRange },
	                        { field: "plannedEnd", title: messages.plannedEnd, editor: editors.dateRange }
	                    ]));
	                }

	                if (model.get(resources.field)) {
	                    fields.push({ field: resources.field, title: messages.resources, messages: messages, editor: editors.resources, click: click, styles: ganttStyles.popup });
	                }
	            }

	            return fields;
	        },

	        _buildEditTemplate: function(model, fields, editableFields) {
	            var resources = this.options.resources;
	            var template = this.options.editable.template;
	            var settings = extend({}, kendo.Template, this.options.templateSettings);
	            var paramName = settings.paramName;
	            var popupStyles = ganttStyles.popup;
	            var html = "";

	            if (template) {
	                if (typeof template === STRING) {
	                    template = kendo.unescape(template);
	                }

	                html += (kendo.template(template, settings))(model);
	            } else {
	                for (var i = 0, length = fields.length; i < length; i++) {
	                    var field = fields[i];

	                    html += '<div class="' + popupStyles.editLabel + '"><label for="' + field.field + '">' + (field.title || field.field || "") + '</label></div>';

	                    if (field.field === resources.field) {
	                        html += '<div class="' + popupStyles.resourcesField + '" style="display:none"></div>';
	                    }

	                    if ((!model.editable || model.editable(field.field))) {
	                        editableFields.push(field);
	                        html += '<div ' + kendo.attr("container-for") + '="' + field.field + '" class="' + popupStyles.editField + '"></div>';
	                    } else {
	                        var tmpl = "#:";

	                        if (field.field) {
	                            field = kendo.expr(field.field, paramName);
	                            tmpl += field + "==null?'':" + field;
	                        } else {
	                            tmpl += "''";
	                        }

	                        tmpl += "#";

	                        tmpl = kendo.template(tmpl, settings);

	                        html += '<div class="' + popupStyles.editField + '">' + tmpl(model) + '</div>';
	                    }
	                }
	            }

	            return html;
	        }
	    });

	    var PopupEditor = Editor.extend({
	        destroy: function() {
	            this.close();
	            this.unbind();
	        },

	        close: function() {
	            var that = this;

	            var destroy = function() {
	                if (that.editable) {
	                    that.editable.destroy();
	                    that.editable = null;
	                    that.container = null;
	                }

	                if (that.popup) {
	                    that.popup.destroy();
	                    that.popup = null;
	                }
	            };

	            if (this.editable && this.container.is(":visible")) {
	                that.trigger("close", { window: that.container });
	                this.container.data("kendoWindow").bind("deactivate", destroy).close();
	            } else {
	                destroy();
	            }
	        },

	        editTask: function(task, plannedEditors) {
	            this.editable = this._createPopupEditor(task, plannedEditors);
	        },

	        showDialog: function(options) {
	            var buttons = options.buttons;
	            var popupStyles = ganttStyles.popup;

	            var html = kendo.format('<div class="{0}"><div class="{1}"><p class="{2}">{3}</p><div class="{4}">',
	                popupStyles.form, popupStyles.formContainer, popupStyles.message, options.text, popupStyles.buttonsContainer);

	            for (var i = 0, length = buttons.length; i < length; i++) {
	                html += this.createButton(buttons[i]);
	            }

	            html += '</div></div></div>';

	            var wrapper = this.element;

	            if (this.popup) {
	                this.popup.destroy();
	            }

	            var popup = this.popup = $(html).appendTo(wrapper)
	                .eq(0)
	                .on("click", DOT + popupStyles.button, function(e) {
	                    e.preventDefault();

	                    popup.close();

	                    var buttonIndex = $(e.currentTarget).index();

	                    buttons[buttonIndex].click();
	                })
	                .kendoWindow({
	                    modal: true,
	                    autoFocus: false,
	                    resizable: false,
	                    draggable: false,
	                    title: options.title,
	                    visible: false,
	                    deactivate: function() {
	                        this.destroy();
	                        wrapper.focus();
	                    }
	                })
	                .getKendoWindow();

	            popup.center().open();

	            popup.element.find(".k-primary").focus();
	        },

	        _createPopupEditor: function(task, plannedEditors) {
	            var that = this;
	            var options = {};
	            var messages = this.options.messages;
	            var popupStyles = ganttStyles.popup;

	            var html = kendo.format('<div {0}="{1}" class="{2} {3}"><div class="{4}">',
	                kendo.attr("uid"), task.uid, popupStyles.form, popupStyles.editForm, popupStyles.formContainer);

	            var fields = this.fields(editors.desktop, task, plannedEditors);
	            var editableFields = [];

	            html += this._buildEditTemplate(task, fields, editableFields);

	            html += '<div class="' + popupStyles.buttonsContainer + '">';
	            html += this.createButton({ name: "update", text: messages.save, className: ganttStyles.primary });
	            html += this.createButton({ name: "cancel", text: messages.cancel });
	            if (that.options.editable.destroy !== false) {
	                html += this.createButton({ name: "delete", text: messages.destroy });
	            }

	            html += '</div></div></div>';

	            var container = this.container = $(html).appendTo(this.element)
	                .eq(0)
	                .kendoWindow(extend({
	                    modal: true,
	                    resizable: false,
	                    draggable: true,
	                    title: messages.editor.editorTitle,
	                    visible: false,
	                    close: function(e) {
	                        if (e.userTriggered) {
	                            if (that.trigger("cancel", { container: container, model: task })) {
	                                e.preventDefault();
	                            }
	                        }
	                    }
	                }, options));

	            var editableWidget = container
	                .kendoEditable({
	                    fields: editableFields,
	                    model: task,
	                    clearContainer: false,
	                    validateOnBlur: true,
	                    target: that.options.target
	                })
	                .data("kendoEditable");

	            kendo.cycleForm(container);

	            if (!this.trigger("edit", { container: container, model: task })) {
	                container.data("kendoWindow").center().open();

	                container.on(CLICK + NS, DOT + ganttStyles.buttonCancel, function(e) {
	                    e.preventDefault();
	                    e.stopPropagation();

	                    that.trigger("cancel", { container: container, model: task });
	                });

	                container.on(CLICK + NS, DOT + ganttStyles.buttonSave, function(e) {
	                    e.preventDefault();
	                    e.stopPropagation();

	                    var fields = that.fields(editors.desktop, task, plannedEditors);
	                    var updateInfo = {};
	                    var field;

	                    for (var i = 0, length = fields.length; i < length; i++) {
	                        field = fields[i].field;
	                        updateInfo[field] = task.get(field);
	                    }

	                    that.trigger("save", { container: container, model: task, updateInfo: updateInfo });
	                });

	                container.on(CLICK + NS, DOT + ganttStyles.buttonDelete, function(e) {
	                    e.preventDefault();
	                    e.stopPropagation();

	                    that.trigger("remove", { container: container, model: task });
	                });
	            } else {
	                that.trigger("cancel", { container: container, model: task });
	            }

	            return editableWidget;
	        }
	    });

	    var ResourceEditor = Widget.extend({
	        init: function(element, options) {
	            Widget.fn.init.call(this, element, options);

	            this.wrapper = this.element;
	            this.model = this.options.model;
	            this.resourcesField = this.options.resourcesField;
	            this.createButton = this.options.createButton;

	            this._initContainer();
	            this._attachHandlers();
	        },

	        events: [
	            "save"
	        ],

	        close: function() {
	            this.window.bind("deactivate", proxy(this.destroy, this)).close();
	        },

	        destroy: function() {
	            this._dettachHandlers();

	            this.grid.destroy();
	            this.grid = null;

	            this.window.destroy();
	            this.window = null;

	            Widget.fn.destroy.call(this);

	            kendo.destroy(this.wrapper);

	            this.element = this.wrapper = null;
	        },

	        open: function() {
	            this.window.center().open();
	        },

	        _attachHandlers: function() {
	            var grid = this.grid;

	            var closeHandler = this._cancelProxy = proxy(this._cancel, this);
	            this.container.on(CLICK + NS, DOT + ganttStyles.buttonCancel, this._cancelProxy);

	            this._saveProxy = proxy(this._save, this);
	            this.container.on(CLICK + NS, DOT + ganttStyles.buttonSave, this._saveProxy);

	            this.window.bind("close", function(e) {
	                if (e.userTriggered) {
	                    closeHandler(e);
	                }
	            });

	            grid.wrapper.on(CLICK + NS, "input[type='checkbox']", function() {
	                var element = $(this);
	                var row = $(element).closest("tr");
	                var model = grid.dataSource.getByUid(row.attr(kendo.attr("uid")));
	                var value = $(element).is(":checked") ? 1 : "";

	                model.set("value", value);
	            });
	        },

	        _cancel: function(e) {
	            e.preventDefault();
	            this.close();
	        },

	        _createButtons: function() {
	            var buttons = this.options.buttons;
	            var html = '<div class="' + ganttStyles.popup.buttonsContainer + '">';

	            for (var i = 0, length = buttons.length; i < length; i++) {
	                html += this.createButton(buttons[i]);
	            }

	            html += "</div>";

	            this.container.append(html);
	        },

	        _dettachHandlers: function() {
	            this._cancelProxy = null;
	            this._saveProxy = null;
	            this.container.off(NS);
	            this.grid.wrapper.off();
	        },

	        _initContainer: function() {
	            var that = this;
	            var popupStyles = ganttStyles.popup;
	            var dom = kendo.format('<div class="{0} {1}"><div class="{2} {3}"></div></div>"',
	                popupStyles.form, popupStyles.editForm, popupStyles.formContainer, popupStyles.resourcesFormContainer);

	            dom = $(dom);

	            this.container = dom.find(DOT + popupStyles.resourcesFormContainer);

	            this.window = dom.kendoWindow({
	                modal: true,
	                resizable: false,
	                draggable: true,
	                visible: false,
	                title: this.options.messages.resourcesEditorTitle,
	                open: function() {
	                      that.grid.resize(true);
	                }
	            }).data("kendoWindow");

	            this._resourceGrid();
	            this._createButtons();
	        },

	        _resourceGrid: function() {
	            var that = this;
	            var messages = this.options.messages;
	            var element = $('<div id="resources-grid"/>').appendTo(this.container);

	            this.grid = new kendo.ui.Grid(element, {
	                columns: [
	                    {
	                        field: "name",
	                        title: messages.resourcesHeader,
	                        template:
	                            "<label><input type='checkbox' value='#=name#'" +
	                                "# if (value > 0 && value !== null) {#" +
	                                       "checked='checked'" +
	                                "# } #" +
	                            "/>#=name#</labe>"
	                    },
	                    {
	                        field: "value",
	                        title: messages.unitsHeader,
	                        template: function(dataItem) {
	                            var valueFormat = dataItem.format;
	                            var value = dataItem.value !== null ? dataItem.value : "";

	                            return valueFormat ? kendo.toString(value, valueFormat) : value;
	                        }
	                    }
	                ],
	                height: 280,
	                sortable: true,
	                editable: true,
	                filterable: true,
	                dataSource: {
	                    data: that.options.data,
	                    schema: {
	                        model: {
	                            id: "id",
	                            fields: {
	                                id: { from: "id" },
	                                name: { from: "name", type: "string", editable: false},
	                                value: { from: "value", type: "number", validation: this.options.unitsValidation },
	                                format: { from: "format", type: "string" }
	                            }
	                        }
	                    }
	                },
	                save: function(e) {
	                    var value = !!e.values.value;
	                    e.container.parent().find("input[type='checkbox']").prop("checked", value);
	                }
	            });
	        },

	        _save: function(e) {
	            e.preventDefault();

	            this._updateModel();

	            if (!this.wrapper.is(DOT + ganttStyles.popup.resourcesField)) {
	                this.trigger("save", { container: this.wrapper, model: this.model });
	            }

	            this.close();
	        },

	        _updateModel: function() {
	            var resources = [];
	            var value;
	            var data = this.grid.dataSource.data();

	            for (var i = 0, length = data.length; i < length; i++) {
	                value = data[i].get("value");
	                if (value !== null && value > 0) {
	                    resources.push(data[i]);
	                }
	            }

	            this.model[this.resourcesField] = resources;
	        }
	    });

	    kendo.gantt = {
	        TaskDropDown: TaskDropDown,
	        Editor: Editor,
	        PopupEditor: PopupEditor,
	        ResourceEditor: ResourceEditor
	    };
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ }),

/***/ 1261:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("jvub");

/***/ }),

/***/ 1262:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("EDhZ");

/***/ })

/******/ });

/***/ }),

/***/ "U9Xd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var context_1 = __webpack_require__("RQ1/");
var context_2 = __webpack_require__("RQ1/");
var LoggerFactory = (function () {
    function LoggerFactory() {
    }
    LoggerFactory.prototype.setBeans = function (gridOptionsWrapper) {
        this.logging = gridOptionsWrapper.isDebug();
    };
    LoggerFactory.prototype.create = function (name) {
        return new Logger(name, this.isLogging.bind(this));
    };
    LoggerFactory.prototype.isLogging = function () {
        return this.logging;
    };
    __decorate([
        __param(0, context_2.Qualifier('gridOptionsWrapper')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [gridOptionsWrapper_1.GridOptionsWrapper]),
        __metadata("design:returntype", void 0)
    ], LoggerFactory.prototype, "setBeans", null);
    LoggerFactory = __decorate([
        context_1.Bean('loggerFactory')
    ], LoggerFactory);
    return LoggerFactory;
}());
exports.LoggerFactory = LoggerFactory;
var Logger = (function () {
    function Logger(name, isLoggingFunc) {
        this.name = name;
        this.isLoggingFunc = isLoggingFunc;
    }
    Logger.prototype.isLogging = function () {
        return this.isLoggingFunc();
    };
    Logger.prototype.log = function (message) {
        if (this.isLoggingFunc()) {
            console.log('ag-Grid.' + this.name + ': ' + message);
        }
    };
    return Logger;
}());
exports.Logger = Logger;


/***/ }),

/***/ "U9s4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var columnController_1 = __webpack_require__("77lH");
var gridPanel_1 = __webpack_require__("inOk");
var column_1 = __webpack_require__("hDyE");
var context_1 = __webpack_require__("RQ1/");
var headerContainer_1 = __webpack_require__("NtVV");
var eventService_1 = __webpack_require__("k5uU");
var events_1 = __webpack_require__("3ok8");
var scrollVisibleService_1 = __webpack_require__("5AnZ");
var HeaderRenderer = (function () {
    function HeaderRenderer() {
    }
    HeaderRenderer.prototype.init = function () {
        var _this = this;
        this.eHeaderViewport = this.gridPanel.getHeaderViewport();
        this.eRoot = this.gridPanel.getRoot();
        this.eHeaderOverlay = this.gridPanel.getHeaderOverlay();
        this.centerContainer = new headerContainer_1.HeaderContainer(this.gridPanel.getHeaderContainer(), this.gridPanel.getHeaderViewport(), this.eRoot, null);
        this.childContainers = [this.centerContainer];
        if (!this.gridOptionsWrapper.isForPrint()) {
            this.pinnedLeftContainer = new headerContainer_1.HeaderContainer(this.gridPanel.getPinnedLeftHeader(), null, this.eRoot, column_1.Column.PINNED_LEFT);
            this.pinnedRightContainer = new headerContainer_1.HeaderContainer(this.gridPanel.getPinnedRightHeader(), null, this.eRoot, column_1.Column.PINNED_RIGHT);
            this.childContainers.push(this.pinnedLeftContainer);
            this.childContainers.push(this.pinnedRightContainer);
        }
        this.childContainers.forEach(function (container) { return _this.context.wireBean(container); });
        // when grid columns change, it means the number of rows in the header has changed and it's all new columns
        this.eventService.addEventListener(events_1.Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
        // shotgun way to get labels to change, eg from sum(amount) to avg(amount)
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.refreshHeader.bind(this));
        // for resized, the individual cells take care of this, so don't need to refresh everything
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_RESIZED, this.setPinnedColContainerWidth.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.setPinnedColContainerWidth.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
        if (this.columnController.isReady()) {
            this.refreshHeader();
        }
    };
    HeaderRenderer.prototype.onScrollVisibilityChanged = function () {
        this.setPinnedColContainerWidth();
    };
    HeaderRenderer.prototype.forEachHeaderElement = function (callback) {
        this.childContainers.forEach(function (childContainer) { return childContainer.forEachHeaderElement(callback); });
    };
    HeaderRenderer.prototype.destroy = function () {
        this.childContainers.forEach(function (container) { return container.destroy(); });
    };
    HeaderRenderer.prototype.onGridColumnsChanged = function () {
        this.setHeight();
    };
    HeaderRenderer.prototype.refreshHeader = function () {
        this.setHeight();
        this.childContainers.forEach(function (container) { return container.refresh(); });
        this.setPinnedColContainerWidth();
    };
    HeaderRenderer.prototype.setHeight = function () {
        // if forPrint, overlay is missing
        if (this.eHeaderOverlay) {
            var rowHeight = this.gridOptionsWrapper.getHeaderHeight();
            // we can probably get rid of this when we no longer need the overlay
            var dept = this.columnController.getHeaderRowCount();
            this.eHeaderOverlay.style.height = rowHeight + 'px';
            this.eHeaderOverlay.style.top = ((dept - 1) * rowHeight) + 'px';
        }
    };
    HeaderRenderer.prototype.setPinnedColContainerWidth = function () {
        // pinned col doesn't exist when doing forPrint
        if (this.gridOptionsWrapper.isForPrint()) {
            return;
        }
        var pinnedLeftWidthWithScroll = this.scrollVisibleService.getPinnedLeftWithScrollWidth();
        var pinnedRightWidthWithScroll = this.scrollVisibleService.getPinnedRightWithScrollWidth();
        this.eHeaderViewport.style.marginLeft = pinnedLeftWidthWithScroll + 'px';
        this.eHeaderViewport.style.marginRight = pinnedRightWidthWithScroll + 'px';
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], HeaderRenderer.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], HeaderRenderer.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('gridPanel'),
        __metadata("design:type", gridPanel_1.GridPanel)
    ], HeaderRenderer.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], HeaderRenderer.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], HeaderRenderer.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('scrollVisibleService'),
        __metadata("design:type", scrollVisibleService_1.ScrollVisibleService)
    ], HeaderRenderer.prototype, "scrollVisibleService", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], HeaderRenderer.prototype, "init", null);
    __decorate([
        context_1.PreDestroy,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], HeaderRenderer.prototype, "destroy", null);
    HeaderRenderer = __decorate([
        context_1.Bean('headerRenderer')
    ], HeaderRenderer);
    return HeaderRenderer;
}());
exports.HeaderRenderer = HeaderRenderer;


/***/ }),

/***/ "USml":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = __webpack_require__("pQ38");
var constants_1 = __webpack_require__("ZZFX");
var utils_1 = __webpack_require__("IRr6");
var LargeTextCellEditor = (function (_super) {
    __extends(LargeTextCellEditor, _super);
    function LargeTextCellEditor() {
        return _super.call(this, LargeTextCellEditor.TEMPLATE) || this;
    }
    LargeTextCellEditor.prototype.init = function (params) {
        this.params = params;
        this.focusAfterAttached = params.cellStartedEdit;
        this.textarea = document.createElement("textarea");
        this.textarea.maxLength = params.maxLength ? params.maxLength : "200";
        this.textarea.cols = params.cols ? params.cols : "60";
        this.textarea.rows = params.rows ? params.rows : "10";
        if (utils_1.Utils.exists(params.value)) {
            this.textarea.value = params.value.toString();
        }
        this.getGui().querySelector('.ag-large-textarea').appendChild(this.textarea);
        this.addGuiEventListener('keydown', this.onKeyDown.bind(this));
    };
    LargeTextCellEditor.prototype.onKeyDown = function (event) {
        var key = event.which || event.keyCode;
        if (key == constants_1.Constants.KEY_LEFT ||
            key == constants_1.Constants.KEY_UP ||
            key == constants_1.Constants.KEY_RIGHT ||
            key == constants_1.Constants.KEY_DOWN ||
            (event.shiftKey && key == constants_1.Constants.KEY_ENTER)) {
            event.stopPropagation();
        }
    };
    LargeTextCellEditor.prototype.afterGuiAttached = function () {
        if (this.focusAfterAttached) {
            this.textarea.focus();
        }
    };
    LargeTextCellEditor.prototype.getValue = function () {
        return this.textarea.value;
    };
    LargeTextCellEditor.prototype.isPopup = function () {
        return true;
    };
    LargeTextCellEditor.TEMPLATE = 
    // tab index is needed so we can focus, which is needed for keyboard events
    '<div class="ag-large-text" tabindex="0">' +
        '<div class="ag-large-textarea"></div>' +
        '</div>';
    return LargeTextCellEditor;
}(component_1.Component));
exports.LargeTextCellEditor = LargeTextCellEditor;


/***/ }),

/***/ "UVEK":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1352);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1046:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2btM");

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1046) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "pivot.configurator",
	    name: "PivotConfigurator",
	    category: "web",
	    depends: [ "dropdownlist", "treeview", "pivot.fieldmenu" ],
	    hidden: true
	};

	/*jshint eqnull: true*/
	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        ns = ".kendoPivotConfigurator",
	        HOVEREVENTS = "mouseenter" + ns + " mouseleave" + ns,
	        SETTING_CONTAINER_TEMPLATE = kendo.template('<p class="k-reset"><span class="k-icon #=icon#"></span>${name}</p>' +
	                '<div class="k-list-container k-reset"></div>');

	    function addKPI(data) {
	        var found;
	        var idx = 0;
	        var length = data.length;

	        for (; idx < length; idx++) {
	            if (data[idx].type == 2) {
	                found = true;
	                break;
	            }
	        }

	        if (found) {
	            data.splice(idx + 1, 0, {
	                caption: "KPIs",
	                defaultHierarchy: "[KPIs]",
	                name: "KPIs",
	                uniqueName: "[KPIs]"
	            });
	        }
	    }

	    function kpiNode(node) {
	        return {
	            name: node.uniqueName,
	            type: node.type
	        };
	    }

	    function normalizeKPIs(data) {
	        for (var idx = 0, length = data.length; idx < length; idx++) {
	            data[idx].uniqueName = data[idx].name;
	            data[idx].type = "kpi";
	        }

	        return data;
	    }

	    function settingTargetFromNode(node) {
	        var target = $(node).closest(".k-pivot-setting");

	        if (target.length) {
	            return target.data("kendoPivotSettingTarget");
	        }
	        return null;
	    }

	    var PivotConfigurator = Widget.extend({
	        init: function(element, options) {
	            Widget.fn.init.call(this, element, options);

	            this.element.addClass("k-widget k-fieldselector k-alt k-edit-form-container");

	            this._dataSource();

	            this._layout();

	            this.refresh();

	            kendo.notify(this);
	        },

	        events: [],

	        options: {
	            name: "PivotConfigurator",
	            filterable: false,
	            sortable: false,
	            messages: {
	                measures: "Drop Data Fields Here",
	                columns: "Drop Column Fields Here",
	                rows: "Drop Rows Fields Here",
	                measuresLabel: "Measures",
	                columnsLabel: "Columns",
	                rowsLabel: "Rows",
	                fieldsLabel: "Fields"
	            }
	        },

	        _dataSource: function() {
	            var that = this;

	            if (that.dataSource && that._refreshHandler) {
	                that.dataSource.unbind("change", that._refreshHandler)
	                               .unbind("error", that._errorHandler)
	                               .unbind("progress", that._progressHandler);
	            } else {
	                that._errorHandler = $.proxy(that._error, that);
	                that._refreshHandler = $.proxy(that.refresh, that);
	                that._progressHandler = $.proxy(that._requestStart, that);
	            }

	            that.dataSource = kendo.data.PivotDataSource.create(that.options.dataSource);
	            that.dataSource.bind("change", that._refreshHandler)
	                           .bind("error", that._errorHandler)
	                           .bind("progress", that._progressHandler);
	        },

	        setDataSource: function(dataSource) {
	            this.options.dataSource = dataSource;

	            this._dataSource();

	            if (this.measures) {
	                this.measures.setDataSource(dataSource);
	            }

	            if (this.rows) {
	                this.rows.setDataSource(dataSource);
	            }

	            if (this.columns) {
	                this.columns.setDataSource(dataSource);
	            }

	            this.refresh();
	        },

	        _treeViewDataSource: function() {
	            var that = this;

	            return kendo.data.HierarchicalDataSource.create({
	                schema: {
	                    model: {
	                        id: "uniqueName",
	                        hasChildren: function(item) {
	                            return !("hierarchyUniqueName" in item) && !("aggregator" in item);
	                        }
	                    }
	                },
	                transport: {
	                    read: function(options) {
	                        var promise;
	                        var node;
	                        var kpi;

	                        if ($.isEmptyObject(options.data)) {
	                            promise = that.dataSource.schemaDimensions();

	                            promise.done(function(data) {
	                                        if (!that.dataSource.cubeBuilder) {
	                                            addKPI(data);
	                                        }
	                                        options.success(data);
	                                    })
	                                    .fail(options.error);
	                        } else {
	                            //Hack to get the actual node as the HierarchicalDataSource does not support passing it
	                            node = that.treeView.dataSource.get(options.data.uniqueName);

	                            if (node.uniqueName === "[KPIs]") {
	                                kpi = true;
	                                promise = that.dataSource.schemaKPIs();
	                                promise.done(function (data) {
	                                            options.success(normalizeKPIs(data));
	                                       })
	                                       .fail(options.error);
	                            } else if (node.type == "kpi") {
	                                kpi = true;
	                                options.success(buildKPImeasures(node));
	                            }

	                            if (!kpi) {
	                                if (node.type == 2) { //measure
	                                    promise = that.dataSource.schemaMeasures();
	                                } else if (node.dimensionUniqueName) { // hierarchy
	                                    promise = that.dataSource.schemaLevels(options.data.uniqueName);
	                                } else { // dimension
	                                    promise = that.dataSource.schemaHierarchies(options.data.uniqueName);
	                                }

	                                promise.done(options.success)
	                                        .fail(options.error);
	                            }
	                        }
	                    }
	                }
	            });
	        },

	        _progress: function(toggle) {
	            kendo.ui.progress(this.element, toggle);
	        },

	        _error: function() {
	            this._progress(false);
	        },

	        _requestStart: function() {
	            this._progress(true);
	        },

	        _layout: function() {
	            this.form = $('<div class="k-columns k-state-default k-floatwrap"/>').appendTo(this.element);
	            this._fields();
	            this._targets();
	        },

	        _fields: function() {
	            var container = $('<div class="k-state-default"><p class="k-reset"><span class="k-icon k-i-group"></span>' + this.options.messages.fieldsLabel + '</p></div>').appendTo(this.form);

	            var template = '# if (item.type == 2 || item.uniqueName == "[KPIs]") { #' +
	                           '<span class="k-icon k-i-#= (item.type == 2 ? \"sum\" : \"kpi\") #"></span>' +
	                           '# } else if (item.type && item.type !== "kpi") { #' +
	                           '<span class="k-icon k-i-arrows-dimensions"></span>' +
	                           '# } #' +
	                           '#: item.caption || item.name #';

	            this.treeView = $("<div/>").appendTo(container)
	                .kendoTreeView({
	                    template: template,
	                    dataTextField: "caption",
	                    dragAndDrop: true,
	                    autoBind: false,
	                    dataSource: this._treeViewDataSource(),
	                    dragstart: function(e) {
	                        var dataItem = this.dataItem(e.sourceNode);
	                        if ((!dataItem.hasChildren && !dataItem.aggregator && !dataItem.measure) || (dataItem.type == 2) || dataItem.uniqueName === "[KPIs]") {
	                            e.preventDefault();
	                        }
	                    },
	                    drag: function(e) {
	                        var status = "k-i-cancel";

	                        var setting = settingTargetFromNode(e.dropTarget);
	                        if (setting && setting.validate(this.dataItem(e.sourceNode))) {
	                            status = "k-i-plus";
	                        }

	                        e.setStatusClass(status);
	                    },
	                    drop: function(e) {
	                        e.preventDefault();

	                        var setting = settingTargetFromNode(e.dropTarget);
	                        var node = this.dataItem(e.sourceNode);
	                        var idx, length, measures;
	                        var name;

	                        if (setting && setting.validate(node)) {
	                            name = node.defaultHierarchy || node.uniqueName;

	                            if (node.type === "kpi") {
	                                measures = buildKPImeasures(node);
	                                length = measures.length;
	                                name = [];

	                                for (idx = 0; idx < length; idx++) {
	                                    name.push(kpiNode(measures[idx]));
	                                }
	                            } else if (node.kpi) {
	                                name = [kpiNode(node)];
	                            }

	                            setting.add(name);
	                        }
	                    }
	                 })
	                .data("kendoTreeView");
	        },

	        _createTarget: function(element, options) {
	            var template = '<li class="k-item k-header" data-' + kendo.ns + 'name="${data.name}">${data.name}';
	            var sortable = options.sortable;
	            var icons = "";

	            if (sortable) {
	                icons += '#if (data.sortIcon) {#';
	                icons += '<span class="k-icon ${data.sortIcon}-sm"></span>';
	                icons += '#}#';
	            }

	            if (options.filterable || sortable) {
	                icons += '<span class="k-icon k-i-more-vertical k-setting-fieldmenu"></span>';
	            }

	            icons += '<span class="k-icon k-i-close k-setting-delete"></span>';
	            template += '<span class="k-field-actions">' + icons + '</span></li>';

	            return new kendo.ui.PivotSettingTarget(element, $.extend({
	                dataSource: this.dataSource,
	                hint: function(element) {
	                    var wrapper = $('<div class="k-fieldselector"><ul class="k-list k-reset"></ul></div>');

	                    wrapper.find(".k-list").append(element.clone());

	                    return wrapper;
	                },
	                template: template,
	                emptyTemplate: '<li class="k-item k-empty">${data}</li>'
	            }, options));
	        },

	        _targets: function() {
	            var container = $('<div class="k-state-default"/>').appendTo(this.form);

	            var columnsContainer = $(SETTING_CONTAINER_TEMPLATE({ name: this.options.messages.columnsLabel, icon: "k-i-columns" })).appendTo(container);
	            var columns = $('<ul class="k-pivot-configurator-settings k-list k-reset" />').appendTo(columnsContainer.last());

	            var rowsContainer = $(SETTING_CONTAINER_TEMPLATE({ name: this.options.messages.rowsLabel, icon: "k-i-rows" })).appendTo(container);
	            var rows = $('<ul class="k-pivot-configurator-settings k-list k-reset" />').appendTo(rowsContainer.last());

	            var measuresContainer = $(SETTING_CONTAINER_TEMPLATE({ name: this.options.messages.measuresLabel, icon: "k-i-sum"})).appendTo(container);
	            var measures = $('<ul class="k-pivot-configurator-settings k-list k-reset" />').appendTo(measuresContainer.last());

	            var options = this.options;

	            this.columns = this._createTarget(columns, {
	                filterable: options.filterable,
	                sortable: options.sortable,
	                connectWith: rows,
	                messages: {
	                    empty: options.messages.columns,
	                    fieldMenu: options.messages.fieldMenu
	                }
	            });

	            this.rows = this._createTarget(rows, {
	                filterable: options.filterable,
	                sortable: options.sortable,
	                setting: "rows",
	                connectWith: columns,
	                messages: {
	                    empty: this.options.messages.rows,
	                    fieldMenu: this.options.messages.fieldMenu
	                }
	            });

	            this.measures = this._createTarget(measures, {
	                setting: "measures",
	                messages: {
	                    empty: options.messages.measures
	                }
	            });

	            columns
	                .add(rows)
	                .add(measures)
	                .on(HOVEREVENTS, ".k-item:not(.k-empty)", this._toggleHover);
	        },

	        _toggleHover: function(e) {
	            $(e.currentTarget).toggleClass("k-state-hover", e.type === "mouseenter");
	        },

	        _resize: function() {
	            var element = this.element;
	            var height = this.options.height;
	            var border, fields;
	            var outerHeight = kendo._outerHeight;

	            if (!height) {
	                return;
	            }

	            element.height(height);

	            if (element.is(":visible")) {
	                fields = element.children(".k-columns")
	                                .children("div.k-state-default");

	                height = element.innerHeight();

	                border = (outerHeight(element) - height) / 2;
	                height = height - (outerHeight(fields, true) - fields.height()) - border;

	                fields.height(height);
	            }
	        },

	        refresh: function() {
	            var dataSource = this.dataSource;

	            if (dataSource.cubeBuilder || this._cube !== dataSource.cube() || this._catalog !== dataSource.catalog()) {
	                this.treeView.dataSource.fetch();
	            }

	            this._catalog = this.dataSource.catalog();
	            this._cube = this.dataSource.cube();

	            this._resize();

	            this._progress(false);
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            this.dataSource.unbind("change", this._refreshHandler);

	            this.form.find(".k-list").off(ns);

	            this.rows.destroy();
	            this.columns.destroy();
	            this.measures.destroy();
	            this.treeView.destroy();

	            this.element = null;
	            this._refreshHandler = null;
	        }
	    });

	    function kpiMeasure(name, measure, type) {
	        return {
	            hierarchyUniqueName: name,
	            uniqueName: measure,
	            caption: measure,
	            measure: measure,
	            name: measure,
	            type: type,
	            kpi: true
	        };
	    }

	    function buildKPImeasures(node) {
	        var name = node.name;
	        return [
	            kpiMeasure(name, node.value, "value"),
	            kpiMeasure(name, node.goal, "goal"),
	            kpiMeasure(name, node.status, "status"),
	            kpiMeasure(name, node.trend, "trend")
	        ];
	    }

	    ui.plugin(PivotConfigurator);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "UZBu":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(906);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 884:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FTkt");

/***/ }),

/***/ 902:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("eykn");

/***/ }),

/***/ 906:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(884), __webpack_require__(902) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($, undefined) {
	    // Imports ================================================================
	    var kendo = window.kendo,
	        diagram = kendo.dataviz.diagram,
	        Class = kendo.Class,
	        deepExtend = kendo.deepExtend,
	        Point = diagram.Point,
	        Rect = diagram.Rect,
	        Matrix = diagram.Matrix,
	        Utils = diagram.Utils,
	        isNumber = Utils.isNumber,
	        isString = Utils.isString,
	        MatrixVector = diagram.MatrixVector,

	        g = kendo.geometry,
	        d = kendo.drawing,

	        defined = d.util.defined,

	        inArray = $.inArray;

	    // Constants ==============================================================
	    var TRANSPARENT = "transparent",
	        Markers = {
	            none: "none",
	            arrowStart: "ArrowStart",
	            filledCircle: "FilledCircle",
	            arrowEnd: "ArrowEnd"
	        },
	        FULL_CIRCLE_ANGLE = 360,
	        START = "start",
	        END = "end",
	        WIDTH = "width",
	        HEIGHT = "height",
	        X = "x",
	        Y = "y";

	    diagram.Markers = Markers;

	    function diffNumericOptions(options, fields) {
	        var elementOptions = this.options;
	        var hasChanges = false;
	        var value, field;
	        for (var i = 0; i < fields.length; i++) {
	            field = fields[i];
	            value = options[field];
	            if (isNumber(value) && elementOptions[field] !== value) {
	                elementOptions[field] = value;
	                hasChanges = true;
	            }
	        }

	        return hasChanges;
	    }

	    var Scale = Class.extend({
	        init: function (x, y) {
	            this.x = x;
	            this.y = y;
	        },
	        toMatrix: function () {
	            return Matrix.scaling(this.x, this.y);
	        },
	        toString: function () {
	            return kendo.format("scale({0},{1})", this.x, this.y);
	        },
	        invert: function() {
	            return new Scale(1/this.x, 1/this.y);
	        }
	    });

	    var Translation = Class.extend({
	        init: function (x, y) {
	            this.x = x;
	            this.y = y;
	        },
	        toMatrixVector: function () {
	            return new MatrixVector(0, 0, 0, 0, this.x, this.y);
	        },
	        toMatrix: function () {
	            return Matrix.translation(this.x, this.y);
	        },
	        toString: function () {
	            return kendo.format("translate({0},{1})", this.x, this.y);
	        },
	        plus: function (delta) {
	            this.x += delta.x;
	            this.y += delta.y;
	        },
	        times: function (factor) {
	            this.x *= factor;
	            this.y *= factor;
	        },
	        length: function () {
	            return Math.sqrt(this.x * this.x + this.y * this.y);
	        },
	        normalize: function () {
	            if (this.Length === 0) {
	                return;
	            }
	            this.times(1 / this.length());
	        },
	        invert: function() {
	            return new Translation(-this.x, -this.y);
	        }
	    });

	    var Rotation = Class.extend({
	        init: function (angle, x, y) {
	            this.x = x || 0;
	            this.y = y || 0;
	            this.angle = angle;
	        },
	        toString: function () {
	            if (this.x && this.y) {
	                return kendo.format("rotate({0},{1},{2})", this.angle, this.x, this.y);
	            } else {
	                return kendo.format("rotate({0})", this.angle);
	            }
	        },
	        toMatrix: function () {
	            return Matrix.rotation(this.angle, this.x, this.y); // T*R*T^-1
	        },
	        center: function () {
	            return new Point(this.x, this.y);
	        },
	        invert: function() {
	            return new Rotation(FULL_CIRCLE_ANGLE - this.angle, this.x, this.y);
	        }
	    });

	    Rotation.ZERO = new Rotation(0);

	    Rotation.create = function (rotation) {
	        return new Rotation(rotation.angle, rotation.x, rotation.y);
	    };

	    Rotation.parse = function (str) {
	        var values = str.slice(1, str.length - 1).split(","),
	            angle = values[0],
	            x = values[1],
	            y = values[2];
	        var rotation = new Rotation(angle, x, y);
	        return rotation;
	    };

	    var CompositeTransform = Class.extend({
	        init: function (x, y, scaleX, scaleY, angle, center) {
	            this.translate = new Translation(x, y);
	            if (scaleX !== undefined && scaleY !== undefined) {
	                this.scale = new Scale(scaleX, scaleY);
	            }
	            if (angle !== undefined) {
	                this.rotate = center ? new Rotation(angle, center.x, center.y) : new Rotation(angle);
	            }
	        },
	        toString: function () {
	            var toString = function (transform) {
	                return transform ? transform.toString() : "";
	            };

	            return toString(this.translate) +
	                toString(this.rotate) +
	                toString(this.scale);
	        },

	        render: function (visual) {
	            visual._transform = this;
	            visual._renderTransform();
	        },

	        toMatrix: function () {
	            var m = Matrix.unit();

	            if (this.translate) {
	                m = m.times(this.translate.toMatrix());
	            }
	            if (this.rotate) {
	                m = m.times(this.rotate.toMatrix());
	            }
	            if (this.scale) {
	                m = m.times(this.scale.toMatrix());
	            }
	            return m;
	        },
	        invert: function() {
	            var rotate = this.rotate ? this.rotate.invert() : undefined,
	                rotateMatrix = rotate ? rotate.toMatrix() : Matrix.unit(),
	                scale = this.scale ? this.scale.invert() : undefined,
	                scaleMatrix = scale ? scale.toMatrix() : Matrix.unit();

	            var translatePoint = new Point(-this.translate.x, -this.translate.y);
	            translatePoint = rotateMatrix.times(scaleMatrix).apply(translatePoint);
	            var translate = new Translation(translatePoint.x, translatePoint.y);

	            var transform = new CompositeTransform();
	            transform.translate = translate;
	            transform.rotate = rotate;
	            transform.scale = scale;

	            return transform;
	        }
	    });

	    var AutoSizeableMixin = {
	        _setScale: function() {
	            var options = this.options;
	            var originWidth = this._originWidth;
	            var originHeight = this._originHeight;
	            var scaleX = options.width / originWidth;
	            var scaleY = options.height / originHeight;

	            if (!isNumber(scaleX)) {
	                scaleX = 1;
	            }
	            if (!isNumber(scaleY)) {
	                scaleY = 1;
	            }

	            this._transform.scale = new Scale(scaleX, scaleY);
	        },

	        _setTranslate: function() {
	            var options = this.options;
	            var x = options.x || 0;
	            var y = options.y || 0;
	            this._transform.translate = new Translation(x, y);
	        },

	        _initSize: function() {
	            var options = this.options;
	            var transform = false;
	            if (options.autoSize !== false && (defined(options.width) || defined(options.height))) {
	                this._measure(true);
	                this._setScale();
	                transform = true;
	            }

	            if (defined(options.x) || defined(options.y)) {
	                this._setTranslate();
	                transform = true;
	            }

	            if (transform) {
	                this._renderTransform();
	            }
	        },

	        _updateSize: function(options) {
	            var update = false;

	            if (this.options.autoSize !== false && this._diffNumericOptions(options, [WIDTH, HEIGHT])) {
	                update = true;
	                this._measure(true);
	                this._setScale();
	            }

	            if (this._diffNumericOptions(options, [X, Y])) {
	                update = true;
	                this._setTranslate();
	            }

	            if (update) {
	                this._renderTransform();
	            }

	            return update;
	        }
	    };

	    var Element = Class.extend({
	        init: function (options) {
	            var element = this;
	            element.options = deepExtend({}, element.options, options);
	            element.id = element.options.id;
	            element._originSize = Rect.empty();
	            element._transform = new CompositeTransform();
	        },

	        visible: function (value) {
	            return this.drawingContainer().visible(value);
	        },

	        redraw: function (options) {
	            if (options && options.id) {
	                 this.id = options.id;
	            }
	        },

	        position: function (x, y) {
	            var options = this.options;
	            if (!defined(x)) {
	               return new Point(options.x, options.y);
	            }

	            if (defined(y)) {
	                options.x = x;
	                options.y = y;
	            } else if (x instanceof Point) {
	                options.x = x.x;
	                options.y = x.y;
	            }

	            this._transform.translate = new Translation(options.x, options.y);
	            this._renderTransform();
	        },

	        rotate: function (angle, center) {
	            if (defined(angle)) {
	                this._transform.rotate = new Rotation(angle, center.x, center.y);
	                this._renderTransform();
	            }
	            return this._transform.rotate || Rotation.ZERO;
	        },

	        drawingContainer: function() {
	            return this.drawingElement;
	        },

	        _renderTransform: function () {
	            var matrix = this._transform.toMatrix();
	            this.drawingContainer().transform(new g.Matrix(matrix.a, matrix.b, matrix.c, matrix.d, matrix.e, matrix.f));
	        },

	        _hover: function () {},

	        _diffNumericOptions: diffNumericOptions,

	        _measure: function (force) {
	            var rect;
	            if (!this._measured || force) {
	                var box = this._boundingBox() || new g.Rect();
	                var startPoint = box.topLeft();
	                rect = new Rect(startPoint.x, startPoint.y, box.width(), box.height());
	                this._originSize = rect;
	                this._originWidth = rect.width;
	                this._originHeight = rect.height;
	                this._measured = true;
	            } else {
	                rect = this._originSize;
	            }
	            return rect;
	        },

	        _boundingBox: function() {
	            return this.drawingElement.rawBBox();
	        }
	    });

	    var VisualBase = Element.extend({
	        init: function(options) {
	            Element.fn.init.call(this, options);

	            options = this.options;
	            options.fill = normalizeDrawingOptions(options.fill);
	            options.stroke = normalizeDrawingOptions(options.stroke);
	        },

	        options: {
	            stroke: {
	                color: "gray",
	                width: 1
	            },
	            fill: {
	                color: TRANSPARENT
	            }
	        },

	        fill: function(color, opacity) {
	            this._fill({
	                color: getColor(color),
	                opacity: opacity
	            });
	        },

	        stroke: function(color, width, opacity) {
	            this._stroke({
	                color: getColor(color),
	                width: width,
	                opacity: opacity
	            });
	        },

	        redraw: function (options) {
	            if (options) {
	                var stroke = options.stroke;
	                var fill = options.fill;
	                if (stroke) {
	                    this._stroke(normalizeDrawingOptions(stroke));
	                }
	                if (fill) {
	                    this._fill(normalizeDrawingOptions(fill));
	                }

	                Element.fn.redraw.call(this, options);
	            }
	        },

	        _hover: function (show) {
	            var drawingElement = this.drawingElement;
	            var options = this.options;
	            var hover = options.hover;

	            if (hover && hover.fill) {
	                var fill = show ? normalizeDrawingOptions(hover.fill) : options.fill;
	                drawingElement.fill(fill.color, fill.opacity);
	            }
	        },

	        _stroke: function(strokeOptions) {
	            var options = this.options;
	            deepExtend(options, {
	                stroke: strokeOptions
	            });

	            strokeOptions = options.stroke;

	            var stroke = null;
	            if (strokeOptions.width > 0) {
	                stroke = {
	                    color: strokeOptions.color,
	                    width: strokeOptions.width,
	                    opacity: strokeOptions.opacity,
	                    dashType: strokeOptions.dashType
	                };
	            }

	            this.drawingElement.options.set("stroke", stroke);
	        },

	        _fill: function(fillOptions) {
	            var options = this.options;
	            deepExtend(options, {
	                fill: fillOptions || {}
	            });
	            var fill = options.fill;

	            if (fill.gradient) {
	                var gradient = fill.gradient;
	                var GradientClass = (gradient.type === "radial" ? d.RadialGradient : d.LinearGradient);
	                this.drawingElement.fill(new GradientClass(gradient));
	            } else {
	                this.drawingElement.fill(fill.color, fill.opacity);
	            }
	        }
	    });

	    var TextBlock = VisualBase.extend({
	        init: function (options) {
	            options = this._textColor(options);
	            VisualBase.fn.init.call(this, options);

	            this._font();
	            this._initText();
	            this._initSize();
	        },

	        options: {
	            fontSize: 15,
	            fontFamily: "sans-serif",
	            stroke: {
	                width: 0
	            },
	            fill: {
	                color: "black"
	            },
	            autoSize: true
	        },

	        _initText: function() {
	            var options = this.options;

	            this.drawingElement = new d.Text(defined(options.text) ? options.text : "", new g.Point(), {
	                font: options.font
	            });

	            this._fill();
	            this._stroke();
	        },

	        _textColor: function(options) {
	            if (options && options.color) {
	                options = deepExtend({}, options, {
	                    fill: {
	                        color: options.color
	                    }
	                });
	            }
	            return options;
	        },

	        _font: function() {
	            var options = this.options;
	            if (options.fontFamily && defined(options.fontSize)) {
	                var fontOptions = [];

	                if (options.fontStyle) {
	                    fontOptions.push(options.fontStyle);
	                }

	                if (options.fontWeight) {
	                    fontOptions.push(options.fontWeight);
	                }

	                fontOptions.push(options.fontSize + (isNumber(options.fontSize) ? "px" : ""));
	                fontOptions.push(options.fontFamily);

	                options.font = fontOptions.join(" ");
	            } else {
	                delete options.font;
	            }
	        },

	        content: function (text) {
	            return this.drawingElement.content(text);
	        },

	        redraw: function (options) {
	            if (options) {
	                var sizeChanged = false;
	                var textOptions = this.options;

	                options = this._textColor(options);

	                VisualBase.fn.redraw.call(this, options);

	                if (options.fontFamily || defined(options.fontSize) || options.fontStyle || options.fontWeight) {
	                    deepExtend(textOptions, {
	                        fontFamily: options.fontFamily,
	                        fontSize: options.fontSize,
	                        fontStyle: options.fontStyle,
	                        fontWeight: options.fontWeight
	                    });
	                    this._font();
	                    this.drawingElement.options.set("font", textOptions.font);
	                    sizeChanged = true;
	                }

	                if (options.text) {
	                    this.content(options.text);
	                    sizeChanged = true;
	                }

	                if (!this._updateSize(options) && sizeChanged) {
	                    this._initSize();
	                }
	            }
	        }
	    });

	    deepExtend(TextBlock.fn, AutoSizeableMixin);

	    var Rectangle = VisualBase.extend({
	        init: function (options) {
	            VisualBase.fn.init.call(this, options);
	            this._initPath();
	            this._setPosition();
	        },

	        _setPosition: function() {
	            var options = this.options;
	            var x = options.x;
	            var y = options.y;
	            if (defined(x) || defined(y)) {
	                this.position(x || 0, y || 0);
	            }
	        },

	        redraw: function (options) {
	            if (options) {
	                VisualBase.fn.redraw.call(this, options);
	                if (this._diffNumericOptions(options, [WIDTH, HEIGHT])) {
	                    this._drawPath();
	                }
	                if (this._diffNumericOptions(options, [X, Y])) {
	                    this._setPosition();
	                }
	            }
	        },

	        _initPath: function() {
	            var options = this.options;
	            this.drawingElement = new d.Path({
	                stroke: options.stroke,
	                closed: true
	            });

	            this._fill();
	            this._drawPath();
	        },

	        _drawPath: function() {
	            var drawingElement = this.drawingElement;
	            var sizeOptions = sizeOptionsOrDefault(this.options);
	            var width = sizeOptions.width;
	            var height = sizeOptions.height;

	            drawingElement.segments.elements([
	                createSegment(0, 0),
	                createSegment(width, 0),
	                createSegment(width, height),
	                createSegment(0, height)
	            ]);
	        }
	    });

	    var MarkerBase = VisualBase.extend({
	        init: function(options) {
	           VisualBase.fn.init.call(this, options);
	           var anchor = this.options.anchor;
	           this.anchor = new g.Point(anchor.x, anchor.y);
	           this.createElement();
	        },

	        options: {
	           stroke: {
	                color: TRANSPARENT,
	                width: 0
	           },
	           fill: {
	                color: "black"
	           }
	        },

	        _transformToPath: function(point, path) {
	            var transform = path.transform();
	            if (point && transform) {
	                point = point.transformCopy(transform);
	            }
	            return point;
	        },

	        redraw: function(options) {
	            if (options) {
	                if (options.position) {
	                    this.options.position = options.position;
	                }

	                VisualBase.fn.redraw.call(this, options);
	            }
	        }
	    });

	    var CircleMarker = MarkerBase.extend({
	        options: {
	            radius: 4,
	            anchor: {
	                x: 0,
	                y: 0
	            }
	        },

	        createElement: function() {
	            var options = this.options;
	            this.drawingElement = new d.Circle(new g.Circle(this.anchor, options.radius), {
	                fill: options.fill,
	                stroke: options.stroke
	            });
	        },

	        positionMarker: function(path) {
	            var options = this.options;
	            var position = options.position;
	            var segments = path.segments;
	            var targetSegment;
	            var point;

	            if (position == START) {
	                targetSegment = segments[0];
	            } else {
	                targetSegment = segments[segments.length - 1];
	            }
	            if (targetSegment) {
	                point = this._transformToPath(targetSegment.anchor(), path);
	                this.drawingElement.transform(g.transform().translate(point.x, point.y));
	            }
	        }
	    });

	    var ArrowMarker = MarkerBase.extend({
	        options: {
	            path: "M 0 0 L 10 5 L 0 10 L 3 5 z"           ,
	            anchor: {
	                x: 10,
	                y: 5
	            }
	        },

	        createElement: function() {
	            var options = this.options;
	            this.drawingElement = d.Path.parse(options.path, {
	                fill: options.fill,
	                stroke: options.stroke
	            });
	        },

	        positionMarker: function(path) {
	            var points = this._linePoints(path);
	            var start = points.start;
	            var end = points.end;
	            var transform = g.transform();
	            if (start) {
	                transform.rotate(lineAngle(start, end), end);
	            }

	            if (end) {
	                var anchor = this.anchor;
	                var translate = end.clone().translate(-anchor.x, -anchor.y);
	                transform.translate(translate.x, translate.y);
	            }
	            this.drawingElement.transform(transform);
	        },

	        _linePoints: function(path) {
	            var options = this.options;
	            var segments = path.segments;
	            var startPoint, endPoint, targetSegment;
	            if (options.position == START) {
	                targetSegment = segments[0];
	                if (targetSegment) {
	                    endPoint = targetSegment.anchor();
	                    startPoint = targetSegment.controlOut();
	                    var nextSegment = segments[1];
	                    if (!startPoint && nextSegment) {
	                        startPoint = nextSegment.anchor();
	                    }
	                }
	            } else {
	                targetSegment = segments[segments.length - 1];
	                if (targetSegment) {
	                    endPoint = targetSegment.anchor();
	                    startPoint = targetSegment.controlIn();
	                    var prevSegment = segments[segments.length - 2];
	                    if (!startPoint && prevSegment) {
	                        startPoint = prevSegment.anchor();
	                    }
	                }
	            }
	            if (endPoint) {
	                return {
	                    start: this._transformToPath(startPoint, path),
	                    end: this._transformToPath(endPoint, path)
	                };
	            }
	        }
	    });

	    var MarkerPathMixin = {
	        _getPath: function(position) {
	            var path = this.drawingElement;
	            if (path instanceof d.MultiPath) {
	                if (position == START) {
	                    path = path.paths[0];
	                } else {
	                    path = path.paths[path.paths.length - 1];
	                }
	            }
	            if (path && path.segments.length) {
	                return path;
	            }
	        },

	        _normalizeMarkerOptions: function(options) {
	            var startCap = options.startCap;
	            var endCap = options.endCap;

	            if (isString(startCap)) {
	                options.startCap = {
	                    type: startCap
	                };
	            }

	            if (isString(endCap)) {
	                options.endCap = {
	                    type: endCap
	                };
	            }
	        },

	        _removeMarker: function(position) {
	            var marker = this._markers[position];
	            if (marker) {
	                this.drawingContainer().remove(marker.drawingElement);
	                delete this._markers[position];
	            }
	        },

	        _createMarkers: function() {
	            var options = this.options;
	            this._normalizeMarkerOptions(options);

	            this._markers = {};
	            this._markers[START] = this._createMarker(options.startCap, START);
	            this._markers[END] = this._createMarker(options.endCap, END);
	        },

	        _createMarker: function(options, position) {
	            var type = (options || {}).type;
	            var path = this._getPath(position);
	            var markerType, marker;
	            if (!path) {
	                this._removeMarker(position);
	                return;
	            }

	            if (type == Markers.filledCircle) {
	                markerType = CircleMarker;
	            } else if (type == Markers.arrowStart || type == Markers.arrowEnd){
	                markerType = ArrowMarker;
	            } else {
	                this._removeMarker(position);
	            }
	            if (markerType) {
	                marker = new markerType(deepExtend({}, options, {
	                    position: position
	                }));
	                marker.positionMarker(path);
	                this.drawingContainer().append(marker.drawingElement);

	                return marker;
	            }
	        },

	        _positionMarker : function(position) {
	            var marker = this._markers[position];

	            if (marker) {
	                var path = this._getPath(position);
	                if (path) {
	                    marker.positionMarker(path);
	                } else {
	                    this._removeMarker(position);
	                }
	            }
	        },

	        _capMap: {
	            start: "startCap",
	            end: "endCap"
	        },

	        _redrawMarker: function(pathChange, position, options) {
	            this._normalizeMarkerOptions(options);

	            var pathOptions = this.options;
	            var cap = this._capMap[position];
	            var pathCapType = (pathOptions[cap] || {}).type;
	            var optionsCap = options[cap];
	            var created = false;
	            if (optionsCap) {
	                pathOptions[cap] = deepExtend({}, pathOptions[cap], optionsCap);
	                if (optionsCap.type && pathCapType != optionsCap.type) {
	                    this._removeMarker(position);
	                    this._markers[position] = this._createMarker(pathOptions[cap], position);
	                    created  = true;
	                } else if (this._markers[position]) {
	                   this._markers[position].redraw(optionsCap);
	                }
	            } else if (pathChange && !this._markers[position] && pathOptions[cap]) {
	                this._markers[position] = this._createMarker(pathOptions[cap], position);
	                created = true;
	            }
	            return created;
	        },

	        _redrawMarkers: function (pathChange, options) {
	            if (!this._redrawMarker(pathChange, START, options) && pathChange) {
	                this._positionMarker(START);
	            }
	            if (!this._redrawMarker(pathChange, END, options) && pathChange) {
	                this._positionMarker(END);
	            }
	        }
	    };

	    var Path = VisualBase.extend({
	        init: function (options) {
	            VisualBase.fn.init.call(this, options);
	            this.container = new d.Group();
	            this._createElements();
	            this._initSize();
	        },

	        options: {
	            autoSize: true
	        },

	        drawingContainer: function() {
	            return this.container;
	        },

	        data: function (value) {
	            var options = this.options;
	            if (value) {
	                if (options.data != value) {
	                   options.data = value;
	                   this._setData(value);
	                   this._initSize();
	                   this._redrawMarkers(true, {});
	                }
	            } else {
	                return options.data;
	            }
	        },

	        redraw: function (options) {
	            if (options) {
	                VisualBase.fn.redraw.call(this, options);

	                var pathOptions = this.options;
	                var data = options.data;

	                if (defined(data) && pathOptions.data != data) {
	                    pathOptions.data = data;
	                    this._setData(data);
	                    if (!this._updateSize(options)) {
	                        this._initSize();
	                    }
	                    this._redrawMarkers(true, options);
	                } else {
	                    this._updateSize(options);
	                    this._redrawMarkers(false, options);
	                }
	            }
	        },

	        _createElements: function() {
	            var options = this.options;

	            this.drawingElement = d.Path.parse(options.data || "", {
	                stroke: options.stroke
	            });

	            this._fill();
	            this.container.append(this.drawingElement);
	            this._createMarkers();
	        },

	        _setData: function(data) {
	            var drawingElement = this.drawingElement;
	            var multipath = d.Path.parse(data || "");
	            var paths = multipath.paths.slice(0);
	            multipath.paths.elements([]);
	            drawingElement.paths.elements(paths);
	        }
	    });

	    deepExtend(Path.fn, AutoSizeableMixin);
	    deepExtend(Path.fn, MarkerPathMixin);

	    var Line = VisualBase.extend({
	        init: function (options) {
	            VisualBase.fn.init.call(this, options);
	            this.container = new d.Group();
	            this._initPath();
	            this._createMarkers();
	        },

	        drawingContainer: function() {
	            return this.container;
	        },

	        redraw: function (options) {
	            if (options) {
	                options = options || {};
	                var from = options.from;
	                var to = options.to;
	                if (from) {
	                    this.options.from = from;
	                }

	                if (to) {
	                    this.options.to = to;
	                }

	                if (from || to) {
	                    this._drawPath();
	                    this._redrawMarkers(true, options);
	                } else {
	                    this._redrawMarkers(false, options);
	                }

	                VisualBase.fn.redraw.call(this, options);
	            }
	        },

	        _initPath: function() {
	            var options = this.options;
	            var drawingElement = this.drawingElement = new d.Path({
	                stroke: options.stroke
	            });

	            this._fill();
	            this._drawPath();
	            this.container.append(drawingElement);
	        },

	        _drawPath: function() {
	            var options = this.options;
	            var drawingElement = this.drawingElement;
	            var from = options.from || new Point();
	            var to = options.to || new Point();

	            drawingElement.segments.elements([
	                createSegment(from.x, from.y),
	                createSegment(to.x, to.y)
	            ]);
	        }
	    });

	    deepExtend(Line.fn, MarkerPathMixin);

	    var Polyline = VisualBase.extend({
	        init: function (options) {
	            VisualBase.fn.init.call(this, options);
	            this.container = new d.Group();
	            this._initPath();
	            this._createMarkers();
	        },

	        drawingContainer: function() {
	            return this.container;
	        },

	        points: function (points) {
	            var options = this.options;
	            if (points) {
	                options.points = points;
	                this._updatePath();
	            } else {
	                return options.points;
	            }
	        },

	        redraw: function (options) {
	            if (options) {
	                var points = options.points;
	                VisualBase.fn.redraw.call(this, options);

	                if (points && this._pointsDiffer(points)) {
	                    this.points(points);
	                    this._redrawMarkers(true, options);
	                } else {
	                    this._redrawMarkers(false, options);
	                }
	            }
	        },

	        _initPath: function() {
	            var options = this.options;
	            this.drawingElement = new d.Path({
	                stroke: options.stroke
	            });

	            this._fill();
	            this.container.append(this.drawingElement);

	            if (options.points) {
	                this._updatePath();
	            }
	        },

	        _pointsDiffer: function(points) {
	            var currentPoints = this.options.points;
	            var differ = currentPoints.length !== points.length;
	            if (!differ) {
	                for (var i = 0; i < points.length; i++) {
	                    if (currentPoints[i].x !== points[i].x || currentPoints[i].y !== points[i].y) {
	                        differ = true;
	                        break;
	                    }
	                }
	            }

	            return differ;
	        },

	        _updatePath: function() {
	            var drawingElement = this.drawingElement;
	            var options = this.options;
	            var points = options.points;
	            var segments = [];
	            var point;
	            for (var i = 0; i < points.length; i++) {
	                point = points[i];
	                segments.push(createSegment(point.x, point.y));
	            }

	            drawingElement.segments.elements(segments);
	        },

	        options: {
	            points: []
	        }
	    });

	    deepExtend(Polyline.fn, MarkerPathMixin);

	    var Image = Element.extend({
	        init: function (options) {
	            Element.fn.init.call(this, options);

	            this._initImage();
	        },

	        redraw: function (options) {
	            if (options) {
	                if (options.source) {
	                    this.drawingElement.src(options.source);
	                }

	                if (this._diffNumericOptions(options, [WIDTH, HEIGHT, X, Y])) {
	                    this.drawingElement.rect(this._rect());
	                }

	                Element.fn.redraw.call(this, options);
	            }
	        },

	        _initImage: function() {
	            var options = this.options;
	            var rect = this._rect();

	            this.drawingElement = new d.Image(options.source, rect, {});
	        },

	        _rect: function() {
	            var sizeOptions = sizeOptionsOrDefault(this.options);
	            var origin = new g.Point(sizeOptions.x, sizeOptions.y);
	            var size = new g.Size(sizeOptions.width, sizeOptions.height);

	            return new g.Rect(origin, size);
	        }
	    });

	    var Group = Element.extend({
	        init: function (options) {
	            this.children = [];
	            Element.fn.init.call(this, options);
	            this.drawingElement = new d.Group();
	            this._initSize();
	        },

	        options: {
	            autoSize: false
	        },

	        append: function (visual) {
	            this.drawingElement.append(visual.drawingContainer());
	            this.children.push(visual);
	            this._childrenChange = true;
	        },

	        remove: function (visual) {
	            if (this._remove(visual)) {
	                this._childrenChange = true;
	            }
	        },

	        _remove: function(visual) {
	            var index = inArray(visual, this.children);
	            if (index >= 0) {
	                this.drawingElement.removeAt(index);
	                this.children.splice(index, 1);
	                return true;
	            }
	        },

	        clear: function () {
	            this.drawingElement.clear();
	            this.children = [];
	            this._childrenChange = true;
	        },

	        toFront: function (visuals) {
	            var visual;

	            for (var i = 0; i < visuals.length; i++) {
	                visual = visuals[i];
	                if (this._remove(visual)) {
	                    this.append(visual);
	                }
	            }
	        },
	        //TO DO: add drawing group support for moving and inserting children
	        toBack: function (visuals) {
	            this._reorderChildren(visuals, 0);
	        },

	        toIndex: function (visuals, indices) {
	            this._reorderChildren(visuals, indices);
	        },

	        _reorderChildren: function(visuals, indices) {
	            var group = this.drawingElement;
	            var drawingChildren = group.children.slice(0);
	            var children = this.children;
	            var fixedPosition = isNumber(indices);
	            var i, index, toIndex, drawingElement, visual;

	            for (i = 0; i < visuals.length; i++) {
	                visual = visuals[i];
	                drawingElement = visual.drawingContainer();

	                index = inArray(visual, children);
	                if (index >= 0) {
	                    drawingChildren.splice(index, 1);
	                    children.splice(index, 1);

	                    toIndex = fixedPosition ? indices : indices[i];

	                    drawingChildren.splice(toIndex, 0, drawingElement);
	                    children.splice(toIndex, 0, visual);
	                }
	            }
	            group.clear();
	            group.append.apply(group, drawingChildren);
	        },

	        redraw: function (options) {
	            if (options) {
	                if (this._childrenChange) {
	                    this._childrenChange = false;
	                    if (!this._updateSize(options)) {
	                        this._initSize();
	                    }
	                } else {
	                    this._updateSize(options);
	                }

	                Element.fn.redraw.call(this, options);
	            }
	        },

	        _boundingBox: function() {
	            var children = this.children;
	            var boundingBox;
	            var visual, childBoundingBox;
	            for (var i = 0; i < children.length; i++) {
	                visual = children[i];
	                if (visual.visible() && visual._includeInBBox !== false) {
	                    childBoundingBox = visual.drawingContainer().clippedBBox(null);
	                    if (childBoundingBox) {
	                        if (boundingBox) {
	                            boundingBox = g.Rect.union(boundingBox, childBoundingBox);
	                        } else {
	                            boundingBox = childBoundingBox;
	                        }
	                    }
	                }
	            }

	            return boundingBox;
	        }
	    });

	    deepExtend(Group.fn, AutoSizeableMixin);

	    var Layout = Group.extend({
	        init: function (rect, options) {
	            this.children = [];
	            Element.fn.init.call(this, options);
	            this.drawingElement = new d.Layout(toDrawingRect(rect), options);
	            this._initSize();
	        },

	        rect: function(rect) {
	            if (rect) {
	                this.drawingElement.rect(toDrawingRect(rect));
	            } else {
	                var drawingRect = this.drawingElement.rect();
	                if (drawingRect) {
	                    return new Rect(drawingRect.origin.x, drawingRect.origin.y, drawingRect.size.width, drawingRect.size.height);
	                }
	            }
	        },

	        reflow: function() {
	            this.drawingElement.reflow();
	        },

	        redraw: function (options) {
	            kendo.deepExtend(this.drawingElement.options, options);
	            Group.fn.redraw.call(this, options);
	        }
	    });

	    var Circle = VisualBase.extend({
	        init: function (options) {
	            VisualBase.fn.init.call(this, options);
	            this._initCircle();
	            this._initSize();
	        },

	        redraw: function (options) {
	            if (options) {
	                var circleOptions = this.options;

	                if (options.center) {
	                    deepExtend(circleOptions, {
	                        center: options.center
	                    });
	                    this._center.move(circleOptions.center.x, circleOptions.center.y);
	                }

	                if (this._diffNumericOptions(options, ["radius"])) {
	                    this._circle.setRadius(circleOptions.radius);
	                }

	                this._updateSize(options);

	                VisualBase.fn.redraw.call(this, options);
	            }
	        },

	        _initCircle: function() {
	            var options = this.options;
	            var width = options.width;
	            var height = options.height;
	            var radius = options.radius;
	            if (!defined(radius)) {
	                if (!defined(width)) {
	                    width = height;
	                }
	                if (!defined(height)) {
	                    height = width;
	                }
	                options.radius = radius = Math.min(width, height) / 2;
	            }

	            var center = options.center || {x: radius, y: radius};
	            this._center = new g.Point(center.x, center.y);
	            this._circle = new g.Circle(this._center, radius);
	            this.drawingElement = new d.Circle(this._circle, {
	                stroke: options.stroke
	            });

	            this._fill();
	        }
	    });
	    deepExtend(Circle.fn, AutoSizeableMixin);

	    var Canvas = Class.extend({
	        init: function (element, options) {
	            options = options || {};
	            this.element = element;
	            this.surface = d.Surface.create(element, options);
	            if (kendo.isFunction(this.surface.translate)) {
	                this.translate = this._translate;
	            }

	            this.drawingElement = new d.Group();
	            this._viewBox = new Rect(0, 0, options.width, options.height);
	            this.size(this._viewBox);
	        },

	        bounds: function () {
	            var box = this.drawingElement.clippedBBox();
	            return new Rect(0, 0, box.width(), box.height());
	        },

	        size: function (size) {
	            var viewBox = this._viewBox;
	            if (defined(size)) {
	                viewBox.width = size.width;
	                viewBox.height = size.height;
	                this.surface.setSize(size);
	            }
	            return {
	                width: viewBox.width,
	                height: viewBox.height
	            };
	        },

	        _translate: function (x, y) {
	            var viewBox = this._viewBox;
	            if (defined(x) && defined(y)) {
	                viewBox.x = x;
	                viewBox.y = y;
	                this.surface.translate({x: x, y: y});
	            }
	            return {
	                x: viewBox.x,
	                y: viewBox.y
	            };
	        },

	        draw: function() {
	            this.surface.draw(this.drawingElement);
	        },

	        append: function (visual) {
	            this.drawingElement.append(visual.drawingContainer());
	            return this;
	        },

	        remove: function (visual) {
	            this.drawingElement.remove(visual.drawingContainer());
	        },

	        insertBefore: function () {

	        },

	        clear: function () {
	            this.drawingElement.clear();
	        },

	        destroy: function(clearHtml) {
	            this.surface.destroy();
	            if(clearHtml) {
	                $(this.element).remove();
	            }
	        }
	    });

	    // Helper functions ===========================================

	    function sizeOptionsOrDefault(options) {
	        return {
	            x: options.x || 0,
	            y: options.y || 0,
	            width: options.width || 0,
	            height: options.height || 0
	        };
	    }

	    function normalizeDrawingOptions(options) {
	        if (options) {
	            var drawingOptions = options;

	            if (isString(drawingOptions)) {
	                drawingOptions = {
	                    color: drawingOptions
	                };
	            }

	            if (drawingOptions.color) {
	                drawingOptions.color = getColor(drawingOptions.color);
	            }
	            return drawingOptions;
	        }
	    }

	    function getColor(value) {
	        var color;
	        if (value != TRANSPARENT) {
	            color = new d.Color(value).toHex();
	        } else {
	            color = value;
	        }
	        return color;
	    }

	    function lineAngle(p1, p2) {
	        var xDiff = p2.x - p1.x;
	        var yDiff = p2.y - p1.y;
	        var angle = d.util.deg(Math.atan2(yDiff, xDiff));
	        return angle;
	    }

	    function createSegment(x, y) {
	        return new d.Segment(new g.Point(x, y));
	    }

	    function toDrawingRect(rect) {
	        if (rect) {
	            return new g.Rect([rect.x, rect.y], [rect.width, rect.height]);
	        }
	    }

	    // Exports ================================================================
	    kendo.deepExtend(diagram, {
	        init: function (element) {
	            kendo.init(element, diagram.ui);
	        },
	        diffNumericOptions: diffNumericOptions,
	        Element: Element,
	        Scale: Scale,
	        Translation: Translation,
	        Rotation: Rotation,
	        Circle: Circle,
	        Group: Group,
	        Rectangle: Rectangle,
	        Canvas: Canvas,
	        Path: Path,
	        Layout: Layout,
	        Line: Line,
	        MarkerBase: MarkerBase,
	        ArrowMarker: ArrowMarker,
	        CircleMarker: CircleMarker,
	        Polyline: Polyline,
	        CompositeTransform: CompositeTransform,
	        TextBlock: TextBlock,
	        Image: Image,
	        VisualBase: VisualBase
	    });
	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "UkXK":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(995);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 971:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("cmba");

/***/ }),

/***/ 995:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(971) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($) {

	    // Imports ================================================================
	    var kendo = window.kendo,
	        editorNS = kendo.ui.editor,
	        Command = editorNS.Command,
	        EditorUtils = editorNS.EditorUtils,
	        registerTool = EditorUtils.registerTool,
	        Tool = editorNS.Tool,
	        ToolTemplate = editorNS.ToolTemplate,
	        extend = $.extend;

	var PrintCommand = Command.extend({
	    init: function(options) {
	        Command.fn.init.call(this, options);

	        this.managesUndoRedo = true;
	    },

	    exec: function() {
	        var editor = this.editor;

	        if (kendo.support.browser.msie) {
	            editor.document.execCommand("print", false, null);
	        } else if (editor.window.print) {
	            editor.window.print();
	        }
	    }
	});

	extend(editorNS, {
	    PrintCommand: PrintCommand
	});

	registerTool("print", new Tool({ command: PrintCommand, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Print"})}));

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "Uo1E":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1581);
	module.exports = __webpack_require__(1581);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1581:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var AxisManager = kendo.Class.extend({
	        init: function(sheet) {
	            this._sheet = sheet;
	        },

	        forEachSelectedColumn: function(callback) {
	            var sheet = this._sheet;

	            sheet.batch(function() {
	                sheet.select().forEachColumnIndex(function(index, i) {
	                    callback(sheet, index, i);
	                });
	            }, { layout: true, recalc: true });
	        },

	        forEachSelectedRow: function(callback) {
	            var sheet = this._sheet;

	            sheet.batch(function() {
	                sheet.select().forEachRowIndex(function(index, i) {
	                    callback(sheet, index, i);
	                });
	            }, { layout: true, recalc: true });
	        },

	        includesHiddenColumns: function(ref) {
	            return this._sheet._grid._columns.includesHidden(ref.topLeft.col, ref.bottomRight.col);
	        },

	        includesHiddenRows: function(ref) {
	            return this._sheet._grid._rows.includesHidden(ref.topLeft.row, ref.bottomRight.row);
	        },

	        selectionIncludesHiddenColumns: function() {
	            return this.includesHiddenColumns(this._sheet.select());
	        },

	        selectionIncludesHiddenRows: function() {
	            return this.includesHiddenRows(this._sheet.select());
	        },

	        deleteSelectedColumns: function() {
	            var indexes = [], delta = 0;
	            this.forEachSelectedColumn(function(sheet, index) {
	                index -= delta;
	                if (sheet.isHiddenColumn(index)) {
	                    return;
	                }
	                delta++;
	                var formulas = [];
	                indexes.unshift({
	                    index    : index,
	                    formulas : formulas,
	                    width    : sheet.columnWidth(index)
	                });
	                sheet._saveModifiedFormulas(formulas, function(){
	                    sheet.deleteColumn(index);
	                });
	            });
	            return indexes;
	        },

	        deleteSelectedRows: function() {
	            var indexes = [], delta = 0;
	            this.forEachSelectedRow(function(sheet, index) {
	                index -= delta;
	                if (sheet.isHiddenRow(index)) {
	                    return;
	                }
	                delta++;
	                var formulas = [];
	                indexes.unshift({
	                    index    : index,
	                    formulas : formulas,
	                    height   : sheet.rowHeight(index)
	                });
	                sheet._saveModifiedFormulas(formulas, function(){
	                    sheet.deleteRow(index);
	                });
	            });
	            return indexes;
	        },

	        hideSelectedColumns: function() {
	            this.forEachSelectedColumn(function(sheet, index) {
	                sheet.hideColumn(index);
	            });
	            var sheet = this._sheet;
	            var ref = sheet.select().toRangeRef();
	            var left = ref.topLeft.col;
	            var right = ref.bottomRight.col;
	            var sel = null;
	            while (true) {
	                var hasRight = right < sheet._columns._count;
	                var hasLeft = left >= 0;
	                if (!hasLeft && !hasRight) {
	                    break;
	                }
	                if (hasRight && !sheet.isHiddenColumn(right)) {
	                    sel = right;
	                    break;
	                }
	                if (hasLeft && !sheet.isHiddenColumn(left)) {
	                    sel = left;
	                    break;
	                }
	                left--;
	                right++;
	            }
	            if (sel !== null) {
	                ref = new kendo.spreadsheet.RangeRef(
	                    new kendo.spreadsheet.CellRef(0, sel),
	                    new kendo.spreadsheet.CellRef(sheet._rows._count - 1, sel)
	                );
	                sheet.range(ref).select();
	            }
	        },

	        hideSelectedRows: function() {
	            this.forEachSelectedRow(function(sheet, index) {
	                sheet.hideRow(index);
	            });
	            var sheet = this._sheet;
	            var ref = sheet.select().toRangeRef();
	            var top = ref.topLeft.row;
	            var bottom = ref.bottomRight.row;
	            var sel = null;
	            while (true) {
	                var hasBottom = bottom < sheet._rows._count;
	                var hasTop = top >= 0;
	                if (!hasTop && !hasBottom) {
	                    break;
	                }
	                if (hasBottom && !sheet.isHiddenRow(bottom)) {
	                    sel = bottom;
	                    break;
	                }
	                if (hasTop && !sheet.isHiddenRow(top)) {
	                    sel = top;
	                    break;
	                }
	                top--;
	                bottom++;
	            }
	            if (sel !== null) {
	                ref = new kendo.spreadsheet.RangeRef(
	                    new kendo.spreadsheet.CellRef(sel, 0),
	                    new kendo.spreadsheet.CellRef(sel, sheet._columns._count - 1)
	                );
	                sheet.range(ref).select();
	            }
	        },

	        unhideSelectedColumns: function() {
	            this.forEachSelectedColumn(function(sheet, index) {
	                sheet.unhideColumn(index);
	            });
	        },

	        unhideSelectedRows: function() {
	            this.forEachSelectedRow(function(sheet, index) {
	                sheet.unhideRow(index);
	            });
	        },

	        preventAddRow: function() {
	            var range = this._sheet.select().toRangeRef();
	            var rowCount = range.height();
	            return this._sheet.preventInsertRow(0, rowCount);
	        },

	        preventAddRowAfterLast: function() {
	            var range = this._sheet.select().toRangeRef();
	            var rowCount = range.height();
	            return this._sheet.preventInsertBelowLastRow(range.bottomRight.row, rowCount);
	        },

	        preventAddColumn: function() {
	            var range = this._sheet.select().toRangeRef();
	            var columnCount = range.width();
	            return this._sheet.preventInsertColumn(0, columnCount);
	        },

	        preventAddColumnAfterLast: function() {
	            var range = this._sheet.select().toRangeRef();
	            var columnCount = range.width();
	            return this._sheet.preventInsertAfterLastColumn(range.bottomRight.col, columnCount);
	        },

	        addColumnLeft: function() {
	            var sheet = this._sheet;
	            var base, count = 0;
	            sheet.batch(function(){
	                sheet.select().forEachColumnIndex(function(index) {
	                    if (!base) {
	                        base = index;
	                    }
	                    sheet.insertColumn(base);
	                    ++count;
	                });
	            }, { recalc: true, layout: true });
	            return { base: base, count: count };
	        },

	        addColumnRight: function() {
	            var sheet = this._sheet;
	            var base, count = 0;
	            sheet.batch(function(){
	                sheet.select().forEachColumnIndex(function(index) {
	                    base = index + 1;
	                    ++count;
	                });
	                for (var i = 0; i < count; ++i) {
	                    sheet.insertColumn(base);
	                }
	            }, { recalc: true, layout: true });
	            return { base: base, count: count };
	        },

	        addRowAbove: function() {
	            var sheet = this._sheet;
	            var base, count = 0;
	            var totalRows = sheet._grid.rowCount;
	            var selectedRows = sheet.select();
	            var selectedRowsCount = selectedRows.bottomRight.row - selectedRows.topLeft.row + 1;

	            sheet.batch(function(){
	                selectedRows.forEachRowIndex(function(index) {
	                    if (!base) {
	                        base = index;
	                    }
	                    if(selectedRows.bottomRight.row + selectedRowsCount < totalRows) {
	                        sheet.insertRow(base);
	                    }
	                    ++count;
	                });
	            }, { recalc: true, layout: true });

	            return { base: base, count: count };
	        },

	        addRowBelow: function() {
	            var sheet = this._sheet;
	            var base, count = 0;
	            var totalRows = sheet._grid.rowCount;

	            sheet.batch(function(){
	                sheet.select().forEachRowIndex(function(index) {
	                    base = index + 1;
	                    ++count;
	                });

	                if(base + count < totalRows) {
	                    for (var i = 0; i < count; ++i) {
	                        sheet.insertRow(base);
	                    }
	                }
	            }, { recalc: true, layout: true });

	            return { base: base, count: count };
	        }
	    });

	    kendo.spreadsheet.AxisManager = AxisManager;
	})(kendo);
	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "Up6z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var popupService_1 = __webpack_require__("LnC7");
var valueService_1 = __webpack_require__("5JVC");
var columnController_1 = __webpack_require__("77lH");
var columnApi_1 = __webpack_require__("E/Wy");
var context_1 = __webpack_require__("RQ1/");
var eventService_1 = __webpack_require__("k5uU");
var events_1 = __webpack_require__("3ok8");
var gridApi_1 = __webpack_require__("BAow");
var componentResolver_1 = __webpack_require__("migL");
var FilterManager = (function () {
    function FilterManager() {
        this.allFilters = {};
        this.quickFilter = null;
    }
    FilterManager_1 = FilterManager;
    FilterManager.prototype.init = function () {
        this.eventService.addEventListener(events_1.Events.EVENT_ROW_DATA_CHANGED, this.onNewRowsLoaded.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this));
        this.quickFilter = this.parseQuickFilter(this.gridOptionsWrapper.getQuickFilterText());
        // check this here, in case there is a filter from the start
        this.checkExternalFilter();
    };
    FilterManager.prototype.setFilterModel = function (model) {
        var _this = this;
        var allPromises = [];
        if (model) {
            // mark the filters as we set them, so any active filters left over we stop
            var modelKeys_1 = Object.keys(model);
            utils_1.Utils.iterateObject(this.allFilters, function (colId, filterWrapper) {
                utils_1.Utils.removeFromArray(modelKeys_1, colId);
                var newModel = model[colId];
                _this.setModelOnFilterWrapper(filterWrapper.filterPromise, newModel);
                allPromises.push(filterWrapper.filterPromise);
            });
            // at this point, processedFields contains data for which we don't have a filter working yet
            utils_1.Utils.iterateArray(modelKeys_1, function (colId) {
                var column = _this.columnController.getPrimaryColumn(colId);
                if (!column) {
                    console.warn('Warning ag-grid setFilterModel - no column found for colId ' + colId);
                    return;
                }
                var filterWrapper = _this.getOrCreateFilterWrapper(column);
                _this.setModelOnFilterWrapper(filterWrapper.filterPromise, model[colId]);
                allPromises.push(filterWrapper.filterPromise);
            });
        }
        else {
            utils_1.Utils.iterateObject(this.allFilters, function (key, filterWrapper) {
                _this.setModelOnFilterWrapper(filterWrapper.filterPromise, null);
                allPromises.push(filterWrapper.filterPromise);
            });
        }
        utils_1.Promise.all(allPromises).then(function (whatever) {
            _this.onFilterChanged();
        });
    };
    FilterManager.prototype.setModelOnFilterWrapper = function (filterPromise, newModel) {
        filterPromise.then(function (filter) {
            if (typeof filter.setModel !== 'function') {
                console.warn('Warning ag-grid - filter missing setModel method, which is needed for setFilterModel');
                return;
            }
            filter.setModel(newModel);
        });
    };
    FilterManager.prototype.getFilterModel = function () {
        var result = {};
        utils_1.Utils.iterateObject(this.allFilters, function (key, filterWrapper) {
            // because user can provide filters, we provide useful error checking and messages
            var filterPromise = filterWrapper.filterPromise;
            var filter = filterPromise.resolveNow(null, function (filter) { return filter; });
            if (filter == null)
                return null;
            if (typeof filter.getModel !== 'function') {
                console.warn('Warning ag-grid - filter API missing getModel method, which is needed for getFilterModel');
                return;
            }
            var model = filter.getModel();
            if (utils_1.Utils.exists(model)) {
                result[key] = model;
            }
        });
        return result;
    };
    // returns true if any advanced filter (ie not quick filter) active
    FilterManager.prototype.isAdvancedFilterPresent = function () {
        return this.advancedFilterPresent;
    };
    FilterManager.prototype.setAdvancedFilterPresent = function () {
        var atLeastOneActive = false;
        utils_1.Utils.iterateObject(this.allFilters, function (key, filterWrapper) {
            if (filterWrapper.filterPromise.resolveNow(false, function (filter) { return filter.isFilterActive(); })) {
                atLeastOneActive = true;
            }
        });
        this.advancedFilterPresent = atLeastOneActive;
    };
    FilterManager.prototype.updateFilterFlagInColumns = function (source) {
        utils_1.Utils.iterateObject(this.allFilters, function (key, filterWrapper) {
            var filterActive = filterWrapper.filterPromise.resolveNow(false, function (filter) { return filter.isFilterActive(); });
            filterWrapper.column.setFilterActive(filterActive, source);
        });
    };
    // returns true if quickFilter or advancedFilter
    FilterManager.prototype.isAnyFilterPresent = function () {
        return this.isQuickFilterPresent() || this.advancedFilterPresent || this.externalFilterPresent;
    };
    FilterManager.prototype.doesFilterPass = function (node, filterToSkip) {
        var data = node.data;
        var colKeys = Object.keys(this.allFilters);
        for (var i = 0, l = colKeys.length; i < l; i++) {
            var colId = colKeys[i];
            var filterWrapper = this.allFilters[colId];
            // if no filter, always pass
            if (filterWrapper === undefined) {
                continue;
            }
            var filter = filterWrapper.filterPromise.resolveNow(undefined, function (filter) { return filter; });
            // if filter not yet there, continue
            if (filter === undefined) {
                continue;
            }
            if (filter === filterToSkip) {
                continue;
            }
            // don't bother with filters that are not active
            if (!filter.isFilterActive()) {
                continue;
            }
            if (!filter.doesFilterPass) {
                console.error('Filter is missing method doesFilterPass');
            }
            var params = {
                node: node,
                data: data
            };
            if (!filter.doesFilterPass(params)) {
                return false;
            }
        }
        // all filters passed
        return true;
    };
    FilterManager.prototype.parseQuickFilter = function (newFilter) {
        if (utils_1.Utils.missing(newFilter) || newFilter === "") {
            return null;
        }
        if (this.gridOptionsWrapper.isRowModelInfinite()) {
            console.warn('ag-grid: cannot do quick filtering when doing virtual paging');
            return null;
        }
        return newFilter.toUpperCase();
    };
    // returns true if it has changed (not just same value again)
    FilterManager.prototype.setQuickFilter = function (newFilter) {
        var parsedFilter = this.parseQuickFilter(newFilter);
        if (this.quickFilter !== parsedFilter) {
            this.quickFilter = parsedFilter;
            this.onFilterChanged();
        }
    };
    FilterManager.prototype.checkExternalFilter = function () {
        this.externalFilterPresent = this.gridOptionsWrapper.isExternalFilterPresent();
    };
    FilterManager.prototype.onFilterChanged = function () {
        this.setAdvancedFilterPresent();
        this.updateFilterFlagInColumns("filterChanged");
        this.checkExternalFilter();
        utils_1.Utils.iterateObject(this.allFilters, function (key, filterWrapper) {
            filterWrapper.filterPromise.then(function (filter) {
                if (filter.onAnyFilterChanged) {
                    filter.onAnyFilterChanged();
                }
            });
        });
        var event = {
            type: events_1.Events.EVENT_FILTER_CHANGED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(event);
    };
    FilterManager.prototype.isQuickFilterPresent = function () {
        return this.quickFilter !== null;
    };
    FilterManager.prototype.doesRowPassOtherFilters = function (filterToSkip, node) {
        return this.doesRowPassFilter(node, filterToSkip);
    };
    FilterManager.prototype.doesRowPassQuickFilterNoCache = function (node) {
        var _this = this;
        var columns = this.columnController.getAllColumnsForQuickFilter();
        var filterPasses = false;
        columns.forEach(function (column) {
            if (filterPasses) {
                return;
            }
            var part = _this.getQuickFilterTextForColumn(column, node);
            if (utils_1.Utils.exists(part)) {
                if (part.indexOf(_this.quickFilter) >= 0) {
                    filterPasses = true;
                }
            }
        });
        return filterPasses;
    };
    FilterManager.prototype.doesRowPassQuickFilterCache = function (node) {
        if (!node.quickFilterAggregateText) {
            this.aggregateRowForQuickFilter(node);
        }
        var filterPasses = node.quickFilterAggregateText.indexOf(this.quickFilter) >= 0;
        return filterPasses;
    };
    FilterManager.prototype.doesRowPassQuickFilter = function (node) {
        var filterPasses;
        if (this.gridOptionsWrapper.isCacheQuickFilter()) {
            filterPasses = this.doesRowPassQuickFilterCache(node);
        }
        else {
            filterPasses = this.doesRowPassQuickFilterNoCache(node);
        }
        return filterPasses;
    };
    FilterManager.prototype.doesRowPassFilter = function (node, filterToSkip) {
        // the row must pass ALL of the filters, so if any of them fail,
        // we return true. that means if a row passes the quick filter,
        // but fails the column filter, it fails overall
        // first up, check quick filter
        if (this.isQuickFilterPresent()) {
            if (!this.doesRowPassQuickFilter(node)) {
                return false;
            }
        }
        // secondly, give the client a chance to reject this row
        if (this.externalFilterPresent) {
            if (!this.gridOptionsWrapper.doesExternalFilterPass(node)) {
                return false;
            }
        }
        // lastly, check our internal advanced filter
        if (this.advancedFilterPresent) {
            if (!this.doesFilterPass(node, filterToSkip)) {
                return false;
            }
        }
        // got this far, all filters pass
        return true;
    };
    FilterManager.prototype.getQuickFilterTextForColumn = function (column, rowNode) {
        var value = this.valueService.getValue(column, rowNode);
        var valueAfterCallback;
        var colDef = column.getColDef();
        if (column.getColDef().getQuickFilterText) {
            var params = {
                value: value,
                node: rowNode,
                data: rowNode.data,
                column: column,
                colDef: colDef
            };
            valueAfterCallback = column.getColDef().getQuickFilterText(params);
        }
        else {
            valueAfterCallback = value;
        }
        if (valueAfterCallback && valueAfterCallback !== '') {
            return valueAfterCallback.toString().toUpperCase();
        }
        else {
            return null;
        }
    };
    FilterManager.prototype.aggregateRowForQuickFilter = function (node) {
        var _this = this;
        var stringParts = [];
        var columns = this.columnController.getAllColumnsForQuickFilter();
        columns.forEach(function (column) {
            var part = _this.getQuickFilterTextForColumn(column, node);
            if (utils_1.Utils.exists(part)) {
                stringParts.push(part);
            }
        });
        node.quickFilterAggregateText = stringParts.join(FilterManager_1.QUICK_FILTER_SEPARATOR);
    };
    FilterManager.prototype.onNewRowsLoaded = function (source) {
        utils_1.Utils.iterateObject(this.allFilters, function (key, filterWrapper) {
            filterWrapper.filterPromise.then(function (filter) {
                if (filter.onNewRowsLoaded) {
                    filter.onNewRowsLoaded();
                }
            });
        });
        this.updateFilterFlagInColumns(source);
        this.setAdvancedFilterPresent();
    };
    FilterManager.prototype.createValueGetter = function (column) {
        var that = this;
        return function valueGetter(node) {
            return that.valueService.getValue(column, node);
        };
    };
    FilterManager.prototype.getFilterComponent = function (column) {
        var filterWrapper = this.getOrCreateFilterWrapper(column);
        return filterWrapper.filterPromise;
    };
    FilterManager.prototype.getOrCreateFilterWrapper = function (column) {
        var filterWrapper = this.cachedFilter(column);
        if (!filterWrapper) {
            filterWrapper = this.createFilterWrapper(column);
            this.allFilters[column.getColId()] = filterWrapper;
        }
        return filterWrapper;
    };
    FilterManager.prototype.cachedFilter = function (column) {
        return this.allFilters[column.getColId()];
    };
    FilterManager.prototype.createFilterInstance = function (column, $scope) {
        var _this = this;
        var defaultFilter = 'agTextColumnFilter';
        if (this.gridOptionsWrapper.isEnterprise()) {
            defaultFilter = 'agSetColumnFilter';
        }
        var sanitisedColDef = utils_1.Utils.cloneObject(column.getColDef());
        var event = {
            type: events_1.Events.EVENT_FILTER_MODIFIED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        var filterChangedCallback = this.onFilterChanged.bind(this);
        var filterModifiedCallback = function () { return _this.eventService.dispatchEvent(event); };
        var params = {
            column: column,
            colDef: sanitisedColDef,
            rowModel: this.rowModel,
            filterChangedCallback: filterChangedCallback,
            filterModifiedCallback: filterModifiedCallback,
            valueGetter: this.createValueGetter(column),
            context: this.gridOptionsWrapper.getContext(),
            doesRowPassOtherFilter: null,
            $scope: $scope
        };
        return this.componentResolver.createAgGridComponent(sanitisedColDef, params, 'filter', {
            api: this.gridApi,
            columnApi: this.columnApi,
            column: column,
            colDef: sanitisedColDef
        }, defaultFilter, true, function (params, filter) { return utils_1.Utils.assign(params, {
            doesRowPassOtherFilter: _this.doesRowPassOtherFilters.bind(_this, filter),
        }); });
    };
    FilterManager.prototype.createFilterWrapper = function (column) {
        var filterWrapper = {
            column: column,
            filterPromise: null,
            scope: null,
            guiPromise: utils_1.Promise.external()
        };
        filterWrapper.scope = this.gridOptionsWrapper.isAngularCompileFilters() ? this.$scope.$new() : null;
        filterWrapper.filterPromise = this.createFilterInstance(column, filterWrapper.scope);
        this.putIntoGui(filterWrapper);
        return filterWrapper;
    };
    FilterManager.prototype.putIntoGui = function (filterWrapper) {
        var _this = this;
        var eFilterGui = document.createElement('div');
        eFilterGui.className = 'ag-filter';
        filterWrapper.filterPromise.then(function (filter) {
            var guiFromFilter = filter.getGui();
            if (utils_1.Utils.missing(guiFromFilter)) {
                console.warn("getGui method from filter returned " + guiFromFilter + ", it should be a DOM element or an HTML template string.");
            }
            // for backwards compatibility with Angular 1 - we
            // used to allow providing back HTML from getGui().
            // once we move away from supporting Angular 1
            // directly, we can change this.
            if (typeof guiFromFilter === 'string') {
                guiFromFilter = utils_1.Utils.loadTemplate(guiFromFilter);
            }
            eFilterGui.appendChild(guiFromFilter);
            if (filterWrapper.scope) {
                _this.$compile(eFilterGui)(filterWrapper.scope);
                setTimeout(function () { return filterWrapper.scope.$apply(); }, 0);
            }
            filterWrapper.guiPromise.resolve(eFilterGui);
        });
    };
    FilterManager.prototype.onNewColumnsLoaded = function () {
        this.destroy();
    };
    // destroys the filter, so it not longer takes part
    FilterManager.prototype.destroyFilter = function (column, source) {
        if (source === void 0) { source = "api"; }
        var filterWrapper = this.allFilters[column.getColId()];
        if (filterWrapper) {
            this.disposeFilterWrapper(filterWrapper, source);
            this.onFilterChanged();
        }
    };
    FilterManager.prototype.disposeFilterWrapper = function (filterWrapper, source) {
        var _this = this;
        filterWrapper.filterPromise.then(function (filter) {
            filter.setModel(null);
            if (filter.destroy) {
                filter.destroy();
            }
            filterWrapper.column.setFilterActive(false, source);
            if (filterWrapper.scope) {
                filterWrapper.scope.$destroy();
            }
            delete _this.allFilters[filterWrapper.column.getColId()];
        });
    };
    FilterManager.prototype.destroy = function () {
        var _this = this;
        utils_1.Utils.iterateObject(this.allFilters, function (key, filterWrapper) {
            _this.disposeFilterWrapper(filterWrapper, "filterDestroyed");
        });
    };
    FilterManager.QUICK_FILTER_SEPARATOR = '\n';
    __decorate([
        context_1.Autowired('$compile'),
        __metadata("design:type", Object)
    ], FilterManager.prototype, "$compile", void 0);
    __decorate([
        context_1.Autowired('$scope'),
        __metadata("design:type", Object)
    ], FilterManager.prototype, "$scope", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], FilterManager.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('gridCore'),
        __metadata("design:type", Object)
    ], FilterManager.prototype, "gridCore", void 0);
    __decorate([
        context_1.Autowired('popupService'),
        __metadata("design:type", popupService_1.PopupService)
    ], FilterManager.prototype, "popupService", void 0);
    __decorate([
        context_1.Autowired('valueService'),
        __metadata("design:type", valueService_1.ValueService)
    ], FilterManager.prototype, "valueService", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], FilterManager.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('rowModel'),
        __metadata("design:type", Object)
    ], FilterManager.prototype, "rowModel", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], FilterManager.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('enterprise'),
        __metadata("design:type", Boolean)
    ], FilterManager.prototype, "enterprise", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], FilterManager.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], FilterManager.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], FilterManager.prototype, "gridApi", void 0);
    __decorate([
        context_1.Autowired('componentResolver'),
        __metadata("design:type", componentResolver_1.ComponentResolver)
    ], FilterManager.prototype, "componentResolver", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FilterManager.prototype, "init", null);
    __decorate([
        context_1.PreDestroy,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FilterManager.prototype, "destroy", null);
    FilterManager = FilterManager_1 = __decorate([
        context_1.Bean('filterManager')
    ], FilterManager);
    return FilterManager;
    var FilterManager_1;
}());
exports.FilterManager = FilterManager;


/***/ }),

/***/ "UtsZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1435);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1046:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2btM");

/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1078:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("qo2y");

/***/ }),

/***/ 1091:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("3gOi");

/***/ }),

/***/ 1190:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("JKVm");

/***/ }),

/***/ 1191:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1Z35");

/***/ }),

/***/ 1249:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("9fcU");

/***/ }),

/***/ 1264:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Z9Q2");

/***/ }),

/***/ 1269:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7Y4C");

/***/ }),

/***/ 1272:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nAZz");

/***/ }),

/***/ 1435:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1046),
	        __webpack_require__(1059),
	        __webpack_require__(1269),
	        __webpack_require__(1249),
	        __webpack_require__(1191),
	        __webpack_require__(1091),
	        __webpack_require__(1078),
	        __webpack_require__(1190),
	        __webpack_require__(1264),
	        __webpack_require__(1272)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "treelist",
	    name: "TreeList",
	    category: "web",
	    description: "The TreeList widget displays self-referencing data and offers rich support for interacting with data, sorting, filtering, and selection.",
	    depends: [ "dom", "data", "pager" ],
	    features: [ {
	        id: "treelist-sorting",
	        name: "Sorting",
	        description: "Support for column sorting",
	        depends: [ "columnsorter" ]
	    }, {
	        id: "treelist-filtering",
	        name: "Filtering",
	        description: "Support for record filtering",
	        depends: [ "filtermenu" ]
	    }, {
	        id: "treelist-editing",
	        name: "Editing",
	        description: "Support for record editing",
	        depends: [ "editable", "window" ]
	    }, {
	        id: "treelist-selection",
	        name: "Selection",
	        description: "Support for row selection",
	        depends: [ "selectable" ]
	    }, {
	        id: "treelist-column-resize",
	        name: "Column resizing",
	        description: "Support for column resizing",
	        depends: [ "resizable" ]
	    }, {
	        id: "treelist-dragging",
	        name: "Drag & Drop",
	        description: "Support for drag & drop of rows",
	        depends: [ "treeview.draganddrop" ]
	    }, {
	        id: "treelist-excel-export",
	        name: "Excel export",
	        description: "Export data as Excel spreadsheet",
	        depends: [ "excel" ]
	    }, {
	        id: "treelist-pdf-export",
	        name: "PDF export",
	        description: "Export data as PDF",
	        depends: [ "pdf", "drawing" ]
	    }, {
	        id: "treelist-paging",
	        name: "Paging",
	        description: "Support for treelist paging",
	        depends: [ "pager" ]
	    } ]
	};

	(function($, undefined) {
	    var data = kendo.data;
	    var kendoDom = kendo.dom;
	    var kendoDomElement = kendoDom.element;
	    var kendoTextElement = kendoDom.text;
	    var kendoHtmlElement = kendoDom.html;
	    var outerWidth = kendo._outerWidth;
	    var keys = kendo.keys;
	    var outerHeight = kendo._outerHeight;
	    var ui = kendo.ui;
	    var DataBoundWidget = ui.DataBoundWidget;
	    var DataSource = data.DataSource;
	    var ObservableArray = data.ObservableArray;
	    var Query = data.Query;
	    var Model = data.Model;
	    var browser = kendo.support.browser;
	    var kendoTemplate = kendo.template;
	    var activeElement = kendo._activeElement;
	    var touchDevice = kendo.support.touch;

	    var isArray = $.isArray;
	    var extend = $.extend;
	    var proxy = $.proxy;
	    var map = $.map;
	    var grep = $.grep;
	    var inArray = $.inArray;
	    var isPlainObject = $.isPlainObject;

	    var push = Array.prototype.push;

	    var STRING = "string";
	    var CHANGE = "change";
	    var ITEM_CHANGE = "itemChange";
	    var ERROR = "error";
	    var PROGRESS = "progress";
	    var DOT = ".";
	    var NS = ".kendoTreeList";
	    var CLICK = "click";
	    var INPUT = "input";
	    var BEFORE_EDIT = "beforeEdit";
	    var EDIT = "edit";
	    var PAGE = "page";
	    var PAGE_CHANGE = "pageChange";
	    var SAVE = "save";
	    var SAVE_CHANGES = "saveChanges";
	    var SORT = "sort";
	    var EXPAND = "expand";
	    var COLLAPSE = "collapse";
	    var CELL_CLOSE = "cellClose";
	    var REMOVE = "remove";
	    var DATA_CELL = "td:not(.k-group-cell):not(.k-hierarchy-cell):visible";
	    var DATABINDING = "dataBinding";
	    var DATABOUND = "dataBound";
	    var CANCEL = "cancel";
	    var TABINDEX = "tabIndex";
	    var FILTERMENUINIT = "filterMenuInit";
	    var FILTERMENUOPEN = "filterMenuOpen";
	    var COLUMNHIDE = "columnHide";
	    var COLUMNSHOW = "columnShow";
	    var HEADERCELLS = "th.k-header";
	    var COLUMNREORDER = "columnReorder";
	    var COLUMNRESIZE = "columnResize";
	    var COLUMNMENUINIT = "columnMenuInit";
	    var COLUMNMENUOPEN = "columnMenuOpen";
	    var COLUMNLOCK = "columnLock";
	    var COLUMNUNLOCK = "columnUnlock";
	    var PARENTIDFIELD = "parentId";
	    var DRAGSTART = "dragstart";
	    var DRAG = "drag";
	    var DROP = "drop";
	    var DRAGEND = "dragend";
	    var NAVROW = "tr:visible";
	    var NAVCELL = "td:visible";
	    var NAVHEADER = "th:visible";
	    var NORECORDSCLASS = "k-grid-norecords";
	    var ITEMROW = "tr:not(.k-footer-template):visible";
	    var FIRSTNAVITEM = NAVROW + " > td:first:visible";
	    var LASTITEMROW = ITEMROW + ":last";
	    var isRtl = false;
	    var HEIGHT = "height";
	    var INCELL = "incell";
	    var INLINE = "inline";
	    var POPUP = "popup";
	    var TABLE = "table";
	    var CHECKBOX = "k-checkbox";
	    var CHECKBOXINPUT = "input[data-role='checkbox']." + CHECKBOX;
	    var SELECTCOLUMNTMPL = '<input class="' + CHECKBOX + '" data-role="checkbox" aria-label="Select row" aria-checked="false" type="checkbox">';
	    var SELECTCOLUMNHEADERTMPL = '<input class="' + CHECKBOX + '" data-role="checkbox" aria-label="Select all rows" aria-checked="false" type="checkbox">';
	    var SELECTED = "k-state-selected";

	    var classNames = {
	        wrapper: "k-treelist k-grid k-widget k-grid-display-block",
	        header: "k-header",
	        button: "k-button",
	        alt: "k-alt",
	        editCell: "k-edit-cell",
	        editRow: "k-grid-edit-row",
	        dirtyCell: "k-dirty-cell",
	        group: "k-treelist-group",
	        gridToolbar: "k-grid-toolbar",
	        gridHeader: "k-grid-header",
	        gridHeaderWrap: "k-grid-header-wrap",
	        gridContent: "k-grid-content",
	        gridContentWrap: "k-grid-content",
	        gridFilter: "k-grid-filter",
	        footerTemplate: "k-footer-template",
	        focused: "k-state-focused",
	        loading: "k-i-loading",
	        refresh: "k-i-reload",
	        retry: "k-request-retry",
	        selected: "k-state-selected",
	        status: "k-status",
	        link: "k-link",
	        withIcon: "k-with-icon",
	        filterable: "k-filterable",
	        icon: "k-icon",
	        iconFilter: "k-i-filter",
	        iconCollapse: "k-i-collapse",
	        iconExpand: "k-i-expand",
	        iconHidden: "k-i-none",
	        iconPlaceHolder: "k-icon k-i-none",
	        input: "k-input",
	        dropPositions: "k-i-insert-up k-i-insert-down k-i-plus k-i-insert-middle",
	        dropTop: "k-i-insert-up",
	        dropBottom: "k-i-insert-down",
	        dropAdd: "k-i-plus",
	        dropMiddle: "k-i-insert-middle",
	        dropDenied: "k-i-cancel",
	        dragStatus: "k-drag-status",
	        dragClue: "k-drag-clue",
	        dragClueText: "k-clue-text"
	    };

	    var defaultCommands = {
	        create: {
	            imageClass: "k-i-plus",
	            className: "k-grid-add",
	            methodName: "addRow"
	        },
	        createchild: {
	            imageClass: "k-i-plus",
	            className: "k-grid-add",
	            methodName: "addRow"
	        },
	        destroy: {
	            imageClass: "k-i-close",
	            className: "k-grid-delete",
	            methodName: "removeRow"
	        },
	        edit: {
	            imageClass: "k-i-edit",
	            className: "k-grid-edit",
	            methodName: "editRow"
	        },
	        update: {
	            imageClass: "k-i-check",
	            className: "k-primary k-grid-update",
	            methodName: "saveRow"
	        },
	        canceledit: {
	            imageClass: "k-i-cancel",
	            className: "k-grid-cancel",
	            methodName: "_cancelEdit"
	        },
	        cancel: {
	            imageClass: "k-icon k-i-cancel",
	            text: "Cancel changes",
	            className: "k-grid-cancel-changes",
	            methodName: "cancelChanges"
	        },
	        save: {
	            imageClass: "k-icon k-i-check",
	            text: "Save changes",
	            className: "k-grid-save-changes",
	            methodName: "saveChanges"
	        },
	        excel: {
	            imageClass: "k-i-file-excel",
	            className: "k-grid-excel",
	            methodName: "saveAsExcel"
	        },
	        pdf: {
	            imageClass: "k-i-file-pdf",
	            className: "k-grid-pdf",
	            methodName: "saveAsPDF"
	        },
	        search: {
	            template:
	            "<span class='k-textbox k-grid-search k-display-flex'>" +
	                "<input autocomplete='off' placeholder='" + "#= message #" + "' title='"+ "#= message #" + "' class='k-input' />" +
	                "<span class='k-input-icon'><span class='k-icon k-i-search'></span></span>" +
	            "</span>"
	        }
	    };

	    var TreeView = kendo.Class.extend({
	        init: function(data, options) {
	            var that = this;

	            that.data = data || [];
	            that.options = extend(that.options, options);
	        },

	        options: {
	            defaultParentId: null,
	            idField: "id",
	            parentIdField: PARENTIDFIELD
	        },

	        childrenMap: function() {
	            var that = this;
	            var childrenMap = {};
	            var dataLength = that.data.length;
	            var dataItem;
	            var dataItemId;
	            var dataItemParentId;
	            var idField = that.options.idField;
	            var parentIdField = that.options.parentIdField;

	            if (that._childrenMap) {
	                return that._childrenMap;
	            }

	            for (var i = 0; i < dataLength; i++) {
	                dataItem = this.data[i];
	                dataItemId = dataItem[idField];
	                dataItemParentId = dataItem[parentIdField];

	                childrenMap[dataItemId] = childrenMap[dataItemId] || [];
	                childrenMap[dataItemParentId] = childrenMap[dataItemParentId] || [];

	                childrenMap[dataItemParentId].push(dataItem);
	            }

	            that._childrenMap = childrenMap;

	            return childrenMap;
	        },

	        idsMap: function() {
	            var that = this;
	            var idsMap = {};
	            var data = that.data;
	            var dataLength = data.length;
	            var dataItem;
	            var idField = that.options.idField;

	            if (that._idMap) {
	                return that._idMap;
	            }

	            for (var i = 0; i < dataLength; i++) {
	                dataItem = data[i];
	                idsMap[dataItem[idField]] = dataItem;
	            }

	            that.idsMap = idsMap;
	            return idsMap;
	        },

	        dataMaps: function() {
	            var that = this;
	            var childrenMap = {};
	            var data = that.data;
	            var dataLength = data.length;
	            var idsMap = {};
	            var dataItem;
	            var dataItemId;
	            var dataItemParentId;
	            var idField = that.options.idField;
	            var parentIdField = that.options.parentIdField;

	            if (that._dataMaps) {
	                return that._dataMaps;
	            }

	            for (var i = 0; i < dataLength; i++) {
	                dataItem = data[i];
	                dataItemId = dataItem[idField];
	                dataItemParentId = dataItem[parentIdField];

	                idsMap[dataItemId] = dataItem;

	                childrenMap[dataItemId] = childrenMap[dataItemId] || [];
	                childrenMap[dataItemParentId] = childrenMap[dataItemParentId] || [];
	                childrenMap[dataItemParentId].push(dataItem);
	            }

	            that._dataMaps = {
	                children: childrenMap,
	                ids: idsMap
	            };

	            return that._dataMaps;
	        },

	        rootNodes: function() {
	            var that = this;
	            var data = that.data;
	            var defaultParentId = that.options.defaultParentId;
	            var dataLength = data.length;
	            var rootNodes = [];
	            var dataItem;
	            var parentIdField = that.options.parentIdField;

	            for (var i = 0; i < dataLength; i++) {
	                dataItem = data[i];

	                if (dataItem[parentIdField] === defaultParentId) {
	                    rootNodes.push(dataItem);
	                }
	            }

	            return rootNodes;
	        },

	        removeCollapsedSubtreesFromRootNodes: function(options) {
	            options = options || {};
	            var that = this;
	            var rootNodes = that.rootNodes();
	            var result = [];
	            var prunedTree;

	            that._childrenMap = options.childrenMap = options.childrenMap || that.childrenMap();
	            options.maxDepth = options.maxDepth || Infinity;

	            for (var i = 0; i < rootNodes.length; i++) {
	                prunedTree = that.removeCollapsedSubtrees(rootNodes[i], options);
	                result = result.concat(prunedTree);
	            }

	            return result;
	        },

	        removeCollapsedSubtrees: function(rootNode, options) {
	            options = options || {};
	            var that = this;
	            var result = [];
	            var childIdx;
	            var prunedTree;
	            var childrenMap = options.childrenMap || {};
	            var maxDepth = options.maxDepth || Infinity;
	            var idField = that.options.idField;
	            var children = childrenMap[rootNode[idField]] || [];
	            var expanded = isUndefined(rootNode.expanded) ? options.expanded : rootNode.expanded;

	            result.push(rootNode);

	            if (children && expanded) {
	                for (childIdx = 0; childIdx < children.length; childIdx++) {
	                    if (result.length >= maxDepth) {
	                        break;
	                    }

	                    prunedTree = that.removeCollapsedSubtrees(children[childIdx], options);
	                    result = result.concat(prunedTree);
	                }
	            }

	            return result;
	        }
	    });

	    var TreeQuery = function(data) {
	        this.data = data || [];
	    };

	    TreeQuery.prototype = new Query();
	    TreeQuery.prototype.constructor = TreeQuery;

	    TreeQuery.process = function(data, options, inPlace) {
	        options = options || {};
	        var query = new TreeQuery(data);
	        var group = options.group;
	        var sort = Query.normalizeGroup(group || []).concat(Query.normalizeSort(options.sort || []));
	        var filterCallback = options.filterCallback;
	        var filter = options.filter;
	        var skip = options.skip;
	        var take = options.take;
	        var total;
	        var childrenMap;
	        var filteredChildrenMap;
	        var view;
	        var prunedData;

	        if (sort && inPlace) {
	            query = query.sort(sort, undefined, undefined, inPlace);
	        }

	        if (filter) {
	            query = query.filter(filter);

	            if (filterCallback) {
	                query = filterCallback(query);
	            }

	            total = query.toArray().length;
	        }

	        if (sort && !inPlace) {
	            query = query.sort(sort);

	            if (group) {
	                data = query.toArray();
	            }
	        }

	        if (options.processFromRootNodes) {
	            view = new TreeView(query.toArray(), options);

	            if (filter) {
	                filteredChildrenMap = view.childrenMap();
	            }

	            prunedData = view.removeCollapsedSubtreesFromRootNodes({
	                // filtering or sorting requires changes to childrenMap
	                childrenMap: filter || (sort && sort.length) ? undefined : options.childrenMap,
	                expanded: options.expanded,
	                maxDepth: (skip + take) || Infinity
	            });

	            childrenMap = view.childrenMap();

	            query = new TreeQuery(prunedData);
	        }

	        if (skip !== undefined && take !== undefined) {
	            query = query.range(skip, take);
	        }

	        if (group) {
	            query = query.group(group, data);
	        }

	        return {
	            total: total,
	            data: query.toArray(),
	            childrenMap: childrenMap,
	            filteredChildrenMap: filteredChildrenMap
	        };
	    };

	    var TreeListModel = Model.define({
	        id: "id",

	        parentId: PARENTIDFIELD,

	        fields: {
	            id: { type: "number" },
	            parentId: { type: "number", nullable: true }
	        },

	        init: function(value) {
	            Model.fn.init.call(this, value);

	            this._loaded = false;

	            if (!this.parentIdField) {
	                this.parentIdField = PARENTIDFIELD;
	            }

	            this.parentId = this.get(this.parentIdField);
	        },

	        accept: function(data) {
	            Model.fn.accept.call(this, data);

	            this.parentId = this.get(this.parentIdField);
	        },

	        set: function(field, value, initiator) {
	            if (field == PARENTIDFIELD && this.parentIdField != PARENTIDFIELD) {
	                this[this.parentIdField] = value;
	            }

	            Model.fn.set.call(this, field, value, initiator);

	            if (field == this.parentIdField) {
	                this.parentId = this.get(this.parentIdField);
	            }
	        },

	        loaded: function(value) {
	            if (value !== undefined) {
	                this._loaded = value;
	            } else {
	                return this._loaded;
	            }
	        },

	        shouldSerialize: function(field) {
	            return Model.fn.shouldSerialize.call(this, field) && field !== "_loaded" && field != "_error" && field != "_edit" && !(this.parentIdField !== "parentId" && field === "parentId");
	        }
	    });

	    TreeListModel.parentIdField = PARENTIDFIELD;

	    TreeListModel.define = function(base, options) {
	        if (options === undefined) {
	            options = base;
	            base = TreeListModel;
	        }

	        var parentId = options.parentId || PARENTIDFIELD;

	        options.parentIdField = parentId;

	        var model = Model.define(base, options);

	        if (parentId) {
	            model.parentIdField = parentId;
	        }

	        return model;
	    };

	    function is(field) {
	        return function(object) {
	            return object[field];
	        };
	    }

	    function not(func) {
	        return function(object) {
	            return !func(object);
	        };
	    }

	    var TreeListDataSource = DataSource.extend({
	        init: function(options) {
	            options = options || {};
	            var that = this;
	            that._dataMaps = that._getDataMaps();

	            options.schema = extend(true, {}, {
	                modelBase: TreeListModel,
	                model: TreeListModel
	            }, options.schema);

	            DataSource.fn.init.call(this, options);
	        },

	        _addRange: function() {
	            // empty override for performance - the treelist does not support virtualization
	        },

	        _createNewModel: function(data) {
	            var that = this;
	            var model = {};
	            var fromModel = data instanceof Model;
	            var parentIdField = this._modelParentIdField();

	            if (fromModel) {
	                model = data;
	            }

	            model = DataSource.fn._createNewModel.call(this, model);

	            if (!fromModel) {
	                if (data.parentId) {
	                    data[model.parentIdField] = data.parentId;
	                } else if (that._isPageable() && data[parentIdField]) {
	                    data[model.parentIdField] = data[parentIdField];
	                }

	                model.accept(data);
	            }

	            return model;
	        },

	        _shouldWrap: function() {
	            return true;
	        },

	        _push: function(result, operation) {
	            var data = DataSource.fn._readData.call(this, result);

	            if (!data) {
	                data = result;
	            }

	            this[operation](data);
	        },

	        _getData: function() {
	            // do not use .data(), which wraps the data items
	            return this._data || [];
	        },

	        _readData: function(newData) {
	            var that = this;
	            var data = that._isPageable() ? that._getData().toJSON() : that.data();

	            newData = DataSource.fn._readData.call(this, newData);

	            this._replaceData(((data.toJSON ? data.toJSON() : data)).concat(newData), data);

	            if (newData instanceof ObservableArray) {
	                return newData;
	            }

	            return data;
	        },

	        _replaceData: function(source, target) {
	            var sourceLength = source.length;

	            for (var i = 0; i < sourceLength; i++) {
	                target[i] = source[i];
	            }

	            target.length = sourceLength;
	        },

	        _readAggregates: function(data) {
	            var result = extend(this._aggregateResult, this.reader.aggregates(data));
	            if ("" in result) {
	                result[this._defaultParentId()] = result[""];
	                delete result[""];
	            }

	            return result;
	        },

	        read: function(data) {
	            var that = this;

	            if (that._isPageable()) {
	                that._dataMaps = {};
	                if (!that._modelOptions().expanded) {
	                    that._skip = 0;
	                    that._page = 1;
	                    that._collapsedTotal = undefined;
	                }
	            }

	            return DataSource.fn.read.call(that, data);
	        },

	        remove: function(root) {
	            this._removeChildData(root);

	            this._removeFromDataMaps(root);

	            return DataSource.fn.remove.call(this, root);
	        },

	        _removeChildData: function(model, removePristine) {
	            var that = this;
	            var pageable = that._isPageable();
	            var data = pageable ? this._getData() : this.data();
	            var childrenMap = pageable ? that._getChildrenMap() || that.childrenMap(data) : that._childrenMap(data);
	            var items = this._subtree(childrenMap, model.id);
	            var shouldRemovePristine = isUndefined(removePristine) ? false : removePristine;

	            var removedItems = this._removeItems(items, shouldRemovePristine);

	            that._removeFromDataMaps(removedItems);
	        },

	        pushDestroy: function(items) {
	            var that = this;

	            if (!isArray(items)) {
	                items = [items];
	            }

	            for (var i = 0; i < items.length; i++) {
	                that._removeChildData(items[i], true);
	                that._removeFromDataMaps(items[i]);
	            }

	            DataSource.fn.pushDestroy.call(that, items);
	        },

	        insert: function(index, model) {
	            var that = this;
	            var newModel = that._createNewModel(model);

	            that._insertInDataMaps(newModel);

	            return DataSource.fn.insert.call(that, index, newModel);
	        },

	        _filterCallback: function(query) {
	            var that = this;
	            var i, item;
	            var map = {};
	            var result = [];
	            var data = query.toArray();
	            var idField = that._modelIdField();
	            var parentIdField = that._modelParentIdField();
	            var pageable = that._isPageable();
	            var parentSubtree = [];
	            var parent;

	            for (i = 0; i < data.length; i++) {
	                item = data[i];

	                if (pageable) {
	                    // return view from root nodes to child nodes
	                    parentSubtree = [];

	                    if (!map[item[idField]]) {
	                        map[item[idField]] = true;
	                        parentSubtree.push(item);
	                    }

	                    parent = that._parentNode(item);

	                    while (parent) {
	                        if (!map[parent[idField]]) {
	                            map[parent[idField]] = true;
	                            parentSubtree.unshift(parent);
	                            parent = that._parentNode(parent);
	                        } else {
	                            // the parent chain is already processed
	                            break;
	                        }
	                    }

	                    if (parentSubtree.length) {
	                        result = result.concat(parentSubtree);
	                    }
	                } else {
	                    while (item) {
	                        if (!map[item[idField]]) {
	                            map[item[idField]] = true;
	                            result.push(item);
	                        }

	                        if (!map[item[parentIdField]]) {
	                            map[item[parentIdField]] = true;
	                            item = this.parentNode(item);

	                            if (item) {
	                                result.push(item);
	                            }
	                        } else {
	                            break;
	                        }
	                    }
	                }
	            }

	            return new Query(result);
	        },

	        _subtree: function(map, id) {
	            var that = this;
	            var result = map[id] || [];
	            var defaultParentId = that._defaultParentId();
	            var idField = that._modelIdField();

	            for (var i = 0, len = result.length; i < len; i++) {
	                if (result[i][idField] !== defaultParentId) {
	                    result = result.concat(that._subtree(map, result[i][idField]));
	                }
	            }

	            return result;
	        },

	        // builds hash id -> children
	        _childrenMap: function(data) {
	            var map = {};
	            var i, item, id, parentId;

	            data = this._observeView(data);

	            for (i = 0; i < data.length; i++) {
	                item = data[i];
	                id = item.id;
	                parentId = item.parentId;

	                map[id] = map[id] || [];
	                map[parentId] = map[parentId] || [];
	                map[parentId].push(item);
	            }

	            return map;
	        },

	        childrenMap: function(data) {
	            var view = this._createTreeView(data);
	            var map =  view.childrenMap();
	            return map;
	        },

	        _getChildrenMap: function() {
	            var that = this;
	            var dataMaps = that._getDataMaps();
	            return dataMaps.children;
	        },

	        _initIdsMap: function(data) {
	            var that = this;
	            var dataMaps = that._getDataMaps();

	            if (isUndefined(dataMaps.ids)) {
	                dataMaps.ids = that._idsMap(data);
	            }

	            return dataMaps.ids;
	        },

	        _idsMap: function(data) {
	            var view = this._createTreeView(data);
	            var map =  view.idsMap();
	            return map;
	        },

	        _getIdsMap: function() {
	            var that = this;
	            var dataMaps = that._getDataMaps();
	            return dataMaps.ids || {};
	        },

	        _getFilteredChildrenMap: function() {
	            var that = this;
	            var dataMaps = that._getDataMaps();
	            return dataMaps.filteredChildren;
	        },

	        _setFilteredChildrenMap: function(map) {
	            var that = this;
	            var dataMaps = that._getDataMaps();
	            dataMaps.filteredChildren = map;
	        },

	        _initDataMaps: function(data) {
	            var that = this;
	            var view = that._createTreeView(data);

	            that._dataMaps = view.dataMaps();

	            return that._dataMaps;
	        },

	        _initChildrenMapForParent: function(parent) {
	            var that = this;
	            var data = that._getData();
	            var childrenMap = that._getChildrenMap();
	            var idField = that._modelIdField();
	            var parentIdField = that._modelParentIdField();
	            var parentId = (parent || {})[idField];

	            if (childrenMap && parent) {
	                childrenMap[parentId] = [];

	                for (var i = 0; i < data.length; i++) {
	                    if (data[i][parentIdField] === parentId) {
	                        childrenMap[parentId].push(data[i]);
	                    }
	                }
	            }
	        },

	        _getDataMaps: function() {
	            var that = this;
	            that._dataMaps = that._dataMaps || {};
	            return that._dataMaps;
	        },

	        _createTreeView: function(data, options) {
	            var view = new TreeView(data, extend(options, this._defaultTreeModelOptions()));
	            return view;
	        },

	        _defaultTreeModelOptions: function() {
	            var that = this;
	            var modelOptions = that._modelOptions();

	            return {
	                defaultParentId: that._defaultParentId(),
	                idField: that._modelIdField(),
	                parentIdField: that._modelParentIdField(),
	                expanded: modelOptions.expanded
	            };
	        },

	        _defaultDataItemType: function() {
	            return this.reader.model || kendo.data.ObservableObject;
	        },

	        _calculateAggregates: function(data, options) {
	            options = options || {};
	            var that = this;
	            var result = {};
	            var item, subtree, i;
	            var filter = options.filter;
	            var skip = options.skip;
	            var take = options.take;
	            var maxDepth = !isUndefined(skip) && !isUndefined(take) ? (skip + take) : Infinity;
	            var pageable = that._isPageable();
	            var filteredChildrenMap = options.filteredChildrenMap;
	            var childrenMap = options.childrenMap;
	            var pageableChildrenMap;

	            if (pageable) {
	                if (isUndefined(options.aggregate)) {
	                    return result;
	                }

	                if (filteredChildrenMap) {
	                    pageableChildrenMap = filteredChildrenMap;
	                } else if (childrenMap) {
	                    pageableChildrenMap = childrenMap;
	                } else {
	                    pageableChildrenMap = that.childrenMap(that._getData());
	                }
	            }

	            if (!pageable && filter) {
	                data = Query.process(data, {
	                    filter: filter,
	                    filterCallback: proxy(this._filterCallback, this)
	                }).data;
	            }

	            var map = pageable ? pageableChildrenMap : that._childrenMap(data);

	            // calculate aggregates for each subtree
	            result[this._defaultParentId()] = new Query(this._subtree(map, this._defaultParentId())).aggregate(options.aggregate);

	            for (i = 0; i < data.length; i++) {
	                if (i >= maxDepth) {
	                    break;
	                }

	                item = data[i];
	                subtree = this._subtree(map, item.id);

	                result[item.id] = new Query(subtree).aggregate(options.aggregate);
	            }

	            return result;
	        },

	        _queryProcess: function(data, options) {
	            var that = this;
	            var result = {};
	            options = options || {};
	            options.filterCallback = proxy(this._filterCallback, this);

	            if (that._isPageable()) {
	                return that._processPageableQuery(data, options);
	            } else {
	                var defaultParentId = this._defaultParentId();
	                result = Query.process(data, options);
	                var map = this._childrenMap(result.data);
	                var hasLoadedChildren, i, item, children;

	                data = map[defaultParentId] || [];

	                for (i = 0; i < data.length; i++) {
	                    item = data[i];

	                    if (item.id === defaultParentId) {
	                        continue;
	                    }

	                    children = map[item.id];
	                    hasLoadedChildren = !!(children && children.length);

	                    if (!item.loaded()) {
	                        item.loaded(hasLoadedChildren || !item.hasChildren);
	                    }

	                    if (item.loaded() || item.hasChildren !== true) {
	                        item.hasChildren = hasLoadedChildren;
	                    }

	                    if (hasLoadedChildren) {
	                        //cannot use splice due to IE8 bug
	                        data = data.slice(0, i + 1).concat(children, data.slice(i + 1));
	                    }
	                }

	                result.data = data;
	            }

	            return result;
	        },

	        _processPageableQuery: function(data, options) {
	            var that = this;
	            var dataMaps = that._getDataMaps();
	            var result;
	            var filteredChildrenMap;

	            if (that._getData() !== data || !dataMaps.children || !dataMaps.ids) {
	                dataMaps = that._initDataMaps(that._getData());
	            }

	            options.childrenMap = dataMaps.children || {};
	            options.idsMap = dataMaps.ids || {};

	            result = that._processTreeQuery(data, options);

	            that._replaceWithObservedData(result.data, data);

	            that._processDataItemsState(result.data, result.childrenMap);

	            that._replaceItemsInDataMaps(result.data);

	            result.dataToAggregate = that._dataToAggregate(result.data, options);

	            if (options.filter || that.filter()) {
	                filteredChildrenMap = result.filteredChildrenMap;
	                that._replaceInMapWithObservedData(filteredChildrenMap, data);
	                that._setFilteredChildrenMap(filteredChildrenMap);
	                options.filteredChildrenMap = filteredChildrenMap;
	                that._calculateCollapsedTotal(result.data);
	            }

	            return result;
	        },

	        _dataToAggregate: function(data) {
	            var that = this;
	            var firstDataItem = data[0] || {};
	            var firstItemParents = that._parentNodes(firstDataItem);
	            var dataToAggregate = firstItemParents.concat(data);

	            return dataToAggregate;
	        },

	        _replaceItemsInDataMaps: function(observableArray) {
	            var that = this;
	            var view = isArray(observableArray) ? observableArray : [observableArray];
	            var itemType = that._defaultDataItemType();
	            var defaultParentId = that._defaultParentId();
	            var idField = that._modelIdField();
	            var parentIdField = that._modelParentIdField();
	            var dataMaps = that._getDataMaps();
	            var item;
	            var parents;
	            var directParent;

	            for (var viewIndex = 0; viewIndex < view.length; viewIndex++) {
	                item = view[viewIndex];

	                if (!(item instanceof itemType)) {
	                    continue;
	                }

	                that._insertInIdsMap(item);

	                parents = that._parentNodes(item);
	                directParent = parents && parents.length ? parents[parents.length - 1] : undefined;

	                if (item[parentIdField] === defaultParentId) {
	                    that._replaceInMap(dataMaps.children, defaultParentId, item, itemType);
	                } else if (directParent) {
	                    that._replaceInMap(dataMaps.children, directParent[idField], item, itemType);
	                }
	            }
	        },

	        _replaceInMap: function(map, id, replacement, itemType) {
	            var idField = this._modelIdField();
	            map[id] = map[id] || [];
	            itemType = itemType || this._defaultDataItemType();

	            var itemInArray = map[id].filter(function(element) {
	                return replacement[idField] === element[idField];
	            })[0];

	            var itemIndex = itemInArray ? map[id].indexOf(itemInArray) : -1;

	            if (itemIndex !== -1 && !(itemInArray instanceof itemType)) {
	                map[id][itemIndex] = replacement;
	            }
	        },

	        _replaceWithObservedData: function(dataToReplace, replacementArray) {
	            var that = this;
	            var idsMap = that._getDataMaps().ids || {};
	            var idField = that._modelIdField();
	            var itemType = that._defaultDataItemType();
	            var itemToReplace;
	            var itemToReplaceId;
	            var dataItem;
	            var dataItemIndex;
	            var observableItem;

	            for (var i = 0; i < dataToReplace.length; i++) {
	                itemToReplace = dataToReplace[i];
	                itemToReplaceId = itemToReplace[idField];

	                if (!(itemToReplace instanceof itemType)) {
	                    if (!(idsMap[itemToReplaceId] instanceof itemType)) {
	                        dataItem = that._getById(itemToReplaceId);
	                        dataItemIndex = replacementArray.indexOf(dataItem);

	                        if (dataItem && dataItemIndex !== -1) {
	                            observableItem = replacementArray.at(dataItemIndex);
	                            dataToReplace[i] = observableItem;
	                        }
	                    } else {
	                        dataToReplace[i] = idsMap[itemToReplaceId];
	                    }
	                }
	            }
	        },

	        _replaceInMapWithObservedData: function(map, replacementArray) {
	            var that = this;

	            for (var key in map) {
	                that._replaceWithObservedData(map[key], replacementArray);
	            }
	        },

	        _insertInDataMaps: function(item) {
	            var that = this;

	            if (that._isPageable()) {
	                that._insertInIdsMap(item);
	                that._insertInChildrenMap(item);
	            }
	        },

	        _insertInIdsMap: function(item) {
	            var that = this;
	            var idsMap = that._getIdsMap();
	            var idField = that._modelIdField();

	            if (!isUndefined(item[idField])) {
	                idsMap[item[idField]] = item;
	            }
	        },

	        _insertInChildrenMap: function(item, index) {
	            var that = this;
	            var childrenMap = that._getChildrenMap() || {};
	            var idField = that._modelIdField();
	            var parentIdField = that._modelParentIdField();
	            var itemId = item[idField];
	            var parentId = item[parentIdField];
	            index = index || 0;

	            childrenMap[itemId] = childrenMap[itemId] || [];
	            childrenMap[parentId] = childrenMap[parentId] || [];
	            childrenMap[parentId].splice(index, 0, item);
	        },

	        _removeFromDataMaps: function(items) {
	            var that = this;
	            items = isArray(items) ? items : [items];

	            if (that._isPageable()) {
	                for (var i = 0; i < items.length; i++) {
	                    that._removeFromIdsMap(items[i]);
	                    that._removeFromChildrenMap(items[i]);
	                }
	            }
	        },

	        _removeFromIdsMap: function(item) {
	            var that = this;
	            var idsMap = that._getIdsMap();
	            var idField = that._modelIdField();

	            if (!isUndefined(item[idField])) {
	                idsMap[item[idField]] = undefined;
	            }
	        },

	        _removeFromChildrenMap: function(item) {
	            var that = this;
	            var childrenMap = that._getChildrenMap() || {};
	            var parentIdField = that._modelParentIdField();
	            var parentId = item[parentIdField];

	            childrenMap[parentId] = childrenMap[parentId] || [];

	            var itemIndex = that._indexInChildrenMap(item);

	            if (itemIndex !== -1) {
	                childrenMap[parentId].splice(itemIndex, 1);
	            }
	        },

	        _indexInChildrenMap: function(item) {
	            var that = this;
	            return that._itemIndexInMap(item, that._getChildrenMap());
	        },

	        _itemIndexInMap: function(item, dataMap) {
	            var that = this;
	            var map = dataMap || {};
	            var parentIdField = that._modelParentIdField();
	            var parentId = item[parentIdField];

	            map[parentId] = map[parentId] || [];

	            var itemInArray = map[parentId].filter(function(element) {
	                return item.uid === element.uid;
	            })[0];

	            var itemIndex = itemInArray ? map[parentId].indexOf(itemInArray) : -1;

	            return itemIndex;
	        },

	        _getById: function(id) {
	            var that = this;
	            var idField = that._modelIdField();
	            var data = that._getData();

	            for (var i = 0; i < data.length; i++) {
	                if (data[i][idField] === id) {
	                    return data[i];
	                }
	            }
	        },

	        _isLastItemInView: function(dataItem) {
	            var view = this.view();
	            return view.length && view[view.length - 1] === dataItem;
	        },

	        _defaultPageableQueryOptions: function() {
	            var that = this;
	            var dataMaps = that._getDataMaps();
	            var options = {
	                skip: that.skip(),
	                take: that.take(),
	                page: that.page(),
	                pageSize: that.pageSize(),
	                sort: that.sort(),
	                filter: that.filter(),
	                group: that.group(),
	                aggregate: that.aggregate(),
	                filterCallback: proxy(that._filterCallback, that),
	                childrenMap: dataMaps.children,
	                idsMap: dataMaps.ids
	            };

	            return options;
	        },

	        _isPageable: function() {
	            var pageSize = this.pageSize();
	            return (!isUndefined(pageSize) && pageSize > 0 && !this.options.serverPaging);
	        },

	        _updateTotalForAction: function(action, items) {
	            var that = this;

	            DataSource.fn._updateTotalForAction.call(that, action, items);

	            if (that._isPageable()) {
	                that._updateCollapsedTotalForAction(action, items);
	            }
	        },

	        _updateCollapsedTotalForAction: function(action, items) {
	            var that = this;
	            var total = parseInt(that._collapsedTotal, 10);

	            if (!isNumber(that._collapsedTotal)) {
	                that._calculateCollapsedTotal();
	                return;
	            }

	            if (action === "add") {
	                total += items.length;
	            } else if (action === "remove") {
	                total -= items.length;
	            } else if (action !== "itemchange" && action !== "sync" && !that.options.serverPaging) {
	                total = that._calculateCollapsedTotal();
	            } else if (action === "sync") {
	                total = that._calculateCollapsedTotal();
	            }

	            that._collapsedTotal = total;
	        },

	        _setFilterTotal: function(filterTotal, setDefaultValue) {
	            var that = this;

	            DataSource.fn._setFilterTotal.call(that, filterTotal, setDefaultValue);

	        },

	        collapsedTotal: function() {
	            var that = this;

	            if (!isUndefined(that._collapsedTotal)) {
	                return that._collapsedTotal;
	            }

	            return that._calculateCollapsedTotal();
	        },

	        _calculateCollapsedTotal: function(filteredData) {
	            var that = this;
	            var data = that._dataWithoutCollapsedSubtrees(filteredData);//

	            if (data.length) {
	                that._collapsedTotal = data.length;
	            }

	            return that._collapsedTotal;
	        },

	        _dataWithoutCollapsedSubtrees: function(filteredData) {
	            return this._removeCollapsedSubtrees(filteredData || this._getData());
	        },

	        _removeCollapsedSubtrees: function(data) {
	            var that = this;
	            var view = that._createTreeView(data);
	            var result = view.removeCollapsedSubtreesFromRootNodes({
	                expanded: that._modelOptions().expanded,
	                childrenMap: that.filter() ? that._getFilteredChildrenMap() : that._getChildrenMap()
	            });

	            return result;
	        },

	        _processTreeQuery: function(data, options) {
	            var result = TreeQuery.process(data, extend(options, this._defaultTreeModelOptions(), {
	                processFromRootNodes: true
	            }));

	            return result;
	        },

	        _processDataItemsState: function(data, childrenMap) {
	            var dataLength = data.length;
	            var i;

	            for (i = 0; i < dataLength; i++) {
	                this._processDataItemState(data[i], childrenMap);
	            }
	        },

	        _processDataItemState: function(dataItem, childrenMap) {
	            var defaultParentId = this._defaultParentId();

	            if (dataItem.id === defaultParentId) {
	                return;
	            }

	            var children = childrenMap[dataItem.id] || [];
	            var hasLoadedChildren = !!(children && children.length);

	            if (!dataItem.loaded) {
	                return;
	            }

	            if (!dataItem.loaded()) {
	                dataItem.loaded(hasLoadedChildren || !dataItem.hasChildren);
	            }

	            if (dataItem.loaded() || dataItem.hasChildren !== true) {
	                dataItem.hasChildren = hasLoadedChildren;
	            }
	        },

	        _queueRequest: function(options, callback) {
	            // allow simultaneous requests (loading multiple items at the same time)
	            callback.call(this);
	        },

	        _modelLoaded: function(id) {
	            var model = this.get(id);
	            model.loaded(true);
	            model.hasChildren = this.childNodes(model).length > 0;
	        },

	        _modelError: function(id, e) {
	            this.get(id)._error = e;
	        },

	        success: function(data, requestParams) {
	            if (!requestParams || typeof requestParams.id == "undefined") {
	                this._data = this._observe([]);
	            }

	            DataSource.fn.success.call(this, data, requestParams);
				this._total = this._data.length;
	        },

	        load: function(model) {
	            var method = "_query";
	            var remote = this.options.serverSorting || this.options.serverPaging || this.options.serverFiltering || this.options.serverGrouping || this.options.serverAggregates;
	            var defaultPromise = $.Deferred().resolve().promise();

	            if (model.loaded()) {
	                if (remote) {
	                    return defaultPromise;
	                }
	            } else if (model.hasChildren) {
	                method = "read";
	                this._removeChildData(model);
	            }

	            return this[method]({ id: model.id })
	                .done(proxy(this._modelLoaded, this, model.id))
	                .fail(proxy(this._modelError, this, model.id));
	        },

	        contains: function(root, child) {
	            var that = this;
	            var idField = that._modelIdField();
	            var parentIdField = that._modelParentIdField();
	            var rootId = root[idField];
	            var pageable = that._isPageable();

	            while (child) {
	                if (child[parentIdField] === rootId) {
	                    return true;
	                }

	                child = pageable ? that._parentNode(child) : that.parentNode(child);
	            }

	            return false;
	        },

	        _byParentId: function(id, defaultId) {
	            var result = [];
	            var view = this.view();
	            var current;

	            if (id === defaultId) {
	                return [];
	            }

	            for (var i = 0; i < view.length; i++) {
	                current = view.at(i);

	                if (current.parentId == id) {
	                    result.push(current);
	                }
	            }

	            return result;
	        },

	        _defaultParentId: function() {
	            return this.reader.model.fn.defaults[this.reader.model.parentIdField];
	        },

	        _modelOptions: function() {
	            var modelOptions = ((this.options.schema || {}).model || {});
	            return modelOptions;
	        },

	        _modelIdField: function() {
	            var modelOptions = this._modelOptions();
	            return modelOptions.id || "id";
	        },

	        _modelParentIdField: function() {
	            var modelOptions = this._modelOptions();
	            return modelOptions.parentId || PARENTIDFIELD;
	        },

	        childNodes: function(model) {
	            return this._byParentId(model.id, this._defaultParentId());
	        },

	        allChildNodes: function(model, result){
	            var directChildren = this.data().filter(function(item){
	                return  item.parentId === model.id;
	            });

	            for (var i =0; i < directChildren.length; i++) {
	                result.push(directChildren[i]);
	                this.allChildNodes(directChildren[i], result);
	            }
	        },

	        rootNodes: function() {
	            return this._byParentId(this._defaultParentId());
	        },

	        _rootNode: function(child) {
	            return this._parentNodes(child)[0];
	        },

	        _pageableRootNodes: function(options) {
	            options = options || {};
	            var that = this;
	            var defaultParentId = that._defaultParentId();
	            var parentIdField = that._modelParentIdField();
	            var result = [];
	            var nodesWithoutParentInView = that._nodesWithoutParentInView(options);
	            var node;
	            var root;

	            for (var i = 0; i < nodesWithoutParentInView.length; i++) {
	                node = nodesWithoutParentInView[i];

	                if (node[parentIdField] === defaultParentId) {
	                    result.push(node);
	                } else {
	                    root = that._rootNode(node);

	                    if (root && result.indexOf(root) === -1) {
	                        result.push(root);
	                    }
	                }
	            }

	            return result;
	        },

	        parentNode: function(model) {
	            return this.get(model.parentId);
	        },

	        _parentNode: function(child) {
	            var that = this;
	            var parentIdField = that._modelParentIdField();
	            var idsMap = that._initIdsMap(that._getData());
	            var parentId = child[parentIdField];
	            var parent = idsMap[parentId] || that._getById(parentId);

	            return parent;
	        },

	        _parentNodes: function(child) {
	            var that = this;
	            var parent = that._parentNode(child);
	            var parents = [];

	            while (parent) {
	                parents.unshift(parent);
	                parent = that._parentNode(parent);
	            }

	            return parents;
	        },

	        _parentNodesNotInView: function() {
	            var that = this;
	            var view = that.view();
	            var result = [];
	            var defaultParentId = that._defaultParentId();
	            var idField = that._modelIdField();
	            var parentIdField = that._modelParentIdField();
	            var parentInView;
	            var parents = [];
	            var directParent;
	            var dataItem;
	            var dataItemId;
	            var dataItemParentId;

	            for (var i = 0; i < view.length; i++) {
	                dataItem = view[i];
	                dataItemId = dataItem[idField];
	                dataItemParentId = dataItem[parentIdField];
	                parentInView = that._parentInView(dataItemParentId);

	                if (!parentInView && dataItemParentId !== defaultParentId) {
	                    parents = that._parentNodes(dataItem);

	                    directParent = parents && parents.length ? parents[parents.length - 1] : that._getById(dataItemParentId);

	                    if (directParent && result.indexOf(directParent) === -1) {
	                        result.push(directParent);
	                    }
	                }
	            }

	            return result;
	        },

	        _nodesWithoutParentInView: function(options) {
	            options = options || {};
	            var that = this;
	            var view = that.view();
	            var childrenMap = options.childrenMap || that.childrenMap(that._getData());
	            var idField = that._modelIdField();
	            var parentIdField = that._modelParentIdField();
	            var dataItem;
	            var parentInView;
	            var children = [];
	            var result = [];

	            for (var i = 0; i < view.length; i++) {
	                dataItem = view[i];
	                children = childrenMap[dataItem[idField]];
	                parentInView = that._parentInView(dataItem[parentIdField]);

	                if (!parentInView) {
	                    result.push(dataItem);
	                }
	            }

	            return result;
	        },

	        _parentInView: function(parentId) {
	            var view = this.view();

	            for (var i = 0; i < view.length; i++) {
	                if (view[i].id === parentId) {
	                    return view[i];
	                }
	            }
	        },

	        level: function(model) {
	            var result = -1;

	            if (!(model instanceof TreeListModel)) {
	                model = this.get(model);
	            }

	            do {
	                model = this.parentNode(model);
	                result++;
	            } while (model);

	            return result;
	        },

	        _pageableModelLevel: function(model) {
	            var that = this;

	            if (!model || !that._isPageable()) {
	                return 0;
	            }

	            var parents = that._parentNodes(model);

	            return parents.length;
	        },

	        filter: function(value) {
	            var baseFilter = DataSource.fn.filter;

	            if (value === undefined) {
	                return baseFilter.call(this, value);
	            }

	            baseFilter.call(this, value);
	        },

	        _pageableQueryOptions: function(options) {
	            var dataMaps = this._getDataMaps();

	            options.childrenMap = dataMaps.children;
	            options.idsMap = dataMaps.ids;

	            return options;
	        },

	        _flatData: function(data, skip) {
	            skip = this._isPageable() ? true : skip;
	            return DataSource.fn._flatData.call(this, data, skip);
	        },

	        data: function(data) {
	            var that = this;
	            var result = DataSource.fn.data.call(that, data);

	            if (that._isPageable()) {
	                that._initDataMaps(that._getData());
	                that._calculateCollapsedTotal();
	            }

	            return result;
	        },

	        cancelChanges: function(model) {
	            var that = this;

	            DataSource.fn.cancelChanges.call(that, model);

	            that._restorePageSizeAfterAddChild();
	        },

	        _modelCanceled: function(model) {
	            var that = this;

	            if (that._isPageable()) {
	                that._removeFromDataMaps(model);
	            }
	        },

	        _changesCanceled: function() {
	            var that = this;

	            if (that._isPageable()) {
	                that._initDataMaps(that._getData());
	            }
	        },

	        _setAddChildPageSize: function() {
	            var that = this;
	            var queryOptions = {};

	            if (that._isPageable()) {
	                // increase the page size to make the new item visible in view
	                that._addChildPageSize = that.pageSize() + 1;

	                queryOptions = that._defaultPageableQueryOptions();
	                queryOptions.take = that._addChildPageSize;
	                queryOptions.pageSize = that._addChildPageSize;
	                that._query(queryOptions);
	            }
	        },

	        _restorePageSizeAfterAddChild: function() {
	            var that = this;
	            var queryOptions = {};

	            if (that._isPageable()) {
	                if (!isUndefined(that._addChildPageSize)) {
	                    queryOptions = that._defaultPageableQueryOptions();
	                    queryOptions.take = that._addChildPageSize - 1;
	                    queryOptions.pageSize = that._addChildPageSize - 1;
	                    that._query(queryOptions);
	                }
	            }

	            that._addChildPageSize = undefined;
	        },

	        sync: function() {
	            var that = this;

	            return DataSource.fn.sync.call(that)
	                .then(function() {
	                    that._restorePageSizeAfterAddChild();
	                });
	        },

	        _syncEnd: function() {
	            var that = this;

	            if (that._isPageable()) {
	                that._initDataMaps(that._getData());
	            }
	        }
	    });

	    TreeListDataSource.create = function(options) {
	        if ($.isArray(options)) {
	            options = { data: options };
	        } else if (options instanceof ObservableArray) {
	            options = { data: options.toJSON() };
	        }

	        return options instanceof TreeListDataSource ? options : new TreeListDataSource(options);
	    };

	    function isCellVisible() {
	        return this.style.display !== "none";
	    }

	    function sortCells(cells) {
	        var indexAttr = kendo.attr("index");
	        return cells.sort(function(a, b) {
	            a = $(a);
	            b = $(b);

	            var indexA = a.attr(indexAttr);
	            var indexB = b.attr(indexAttr);

	            if (indexA === undefined) {
	                indexA = $(a).index();
	            }
	            if (indexB === undefined) {
	                indexB = $(b).index();
	            }

	            indexA = parseInt(indexA, 10);
	            indexB = parseInt(indexB, 10);
	            return indexA > indexB ? 1 : (indexA < indexB ? -1 : 0);
	        });
	    }

	    function leafDataCells(container) {
	        var rows = container.find(">tr:not(.k-filter-row)");

	        var filter = function() {
	            var el = $(this);
	            return !el.hasClass("k-group-cell") && !el.hasClass("k-hierarchy-cell");
	        };

	        var cells = $();
	        if (rows.length > 1) {
	            cells = rows.find("th[data-index]")
	                .filter(filter);
	        }

	        cells = cells.add(rows.last().find("th").filter(filter));

	        return sortCells(cells);
	    }

	    function createPlaceholders(options) {
	        var spans = [];
	        var className = options.className;

	        for (var i = 0, level = options.level; i < level; i++) {
	            spans.push(kendoDomElement("span", { className: className }));
	        }

	        return spans;
	    }

	    function columnsWidth(cols) {
	        var colWidth, width = 0;

	        for (var idx = 0, length = cols.length; idx < length; idx++) {
	            colWidth = cols[idx].style.width;
	            if (colWidth && colWidth.indexOf("%") == -1) {
	                width += parseInt(colWidth, 10);
	            }
	        }

	        return width;
	    }

	    function syncTableHeight(table1, table2) {
	       table1 = table1[0];
	       table2 = table2[0];

	       if (table1.rows.length && table2.rows.length && table1.rows.length !== table2.rows.length) {
	           var lockedHeigth = table1.offsetHeight;
	           var tableHeigth = table2.offsetHeight;

	           var row;
	           var diff;
	           if (lockedHeigth > tableHeigth) {
	               row = table2.rows[table2.rows.length - 1];

	               diff = lockedHeigth - tableHeigth;
	           } else {
	               row = table1.rows[table1.rows.length - 1];

	               diff = tableHeigth - lockedHeigth;
	           }
	           row.style.height = row.offsetHeight + diff + "px";
	       }
	    }

	    var TreeListPager = ui.Pager.extend({
	        options: {
	            name: "TreeListPager"
	        },

	        totalPages: function() {
	            var that = this;
	            var dataSource = that.dataSource;

	            if (dataSource && dataSource._filter) {
	                return ui.Pager.fn.totalPages.call(that);
	            }

	            return Math.ceil((that._collapsedTotal() || 0) / (that.pageSize() || 1));
	        },

	        _createDataSource: function(options) {
	            this.dataSource = kendo.data.TreeListDataSource.create(options.dataSource);
	        },

	        _collapsedTotal: function() {
	            var dataSource = this.dataSource;
	            return dataSource ? (dataSource.collapsedTotal() || 0) : 0;
	        }
	    });

	    var Editor = kendo.Observable.extend({
	        init: function(element, options) {
	            kendo.Observable.fn.init.call(this);

	            options = this.options = extend(true, {}, this.options, options);

	            this.element = element;

	            this.bind(this.events, options);

	            this.model = this.options.model;

	            this.fields = this._fields(this.options.columns);

	            this._initContainer();

	            this.createEditable();
	        },

	        events: [],

	        _initContainer: function() {
	            this.wrapper = this.element;
	        },

	        createEditable: function() {
	            var options = this.options;

	            this.editable = new ui.Editable(this.wrapper, {
	                fields: this.fields,
	                target: options.target,
	                clearContainer: options.clearContainer,
	                model: this.model,
	                change: options.change
	            });
	        },

	        _isEditable: function(column) {
	            return isColumnEditable(column, this.model);
	        },

	        _fields: function(columns) {
	            var fields = [];
	            var idx, length, column;

	            for (idx = 0, length = columns.length; idx < length; idx++) {
	                column = columns[idx];

	                if (this._isEditable(column)) {
	                    fields.push({
	                        field: column.field,
	                        format: column.format,
	                        editor: column.editor
	                    });
	                }
	            }

	            return fields;
	        },

	        end: function() {
	            return this.editable.end();
	        },

	        close: function() {
	            this.destroy();
	        },

	        destroy: function() {
	            this.editable.destroy();
	            this.editable.element
	                .find("[" + kendo.attr("container-for") + "]")
	                .empty()
	                .end()
	                .removeAttr(kendo.attr("role"));

	            this.model = this.wrapper = this.element = this.columns = this.editable = null;
	        }
	    });

	    var PopupEditor = Editor.extend({
	        init: function(element, options) {
	            Editor.fn.init.call(this, element, options);

	            this._attachHandlers();
	            kendo.cycleForm(this.wrapper);

	            this.open();
	        },

	        events: [
	            CANCEL,
	            SAVE
	        ],

	        options: {
	            window: {
	                modal: true,
	                resizable: false,
	                draggable: true,
	                title: "Edit",
	                visible: false
	            }
	        },

	        _initContainer: function() {
	            var options = this.options;
	            var formContent = [];

	            this.wrapper = $('<div class="k-popup-edit-form"/>')
	                .attr(kendo.attr("uid"), this.model.uid)
	                .append('<div class="k-edit-form-container"/>');

	            if (options.template) {
	                this._appendTemplate(formContent);
	                this.fields = [];
	            } else {
	                this._appendFields(formContent);
	            }
	            this._appendButtons(formContent);

	            new kendoDom.Tree(this.wrapper.children()[0]).render(formContent);

	            this.wrapper.appendTo(options.appendTo);

	            this.window = new ui.Window(this.wrapper, options.window);
	        },

	        _appendTemplate: function(form) {
	            var template = this.options.template;

	            if (typeof template === STRING) {
	                template = kendo.unescape(template);
	            }

	            template = kendo.template(template)(this.model);

	            form.push(kendoHtmlElement(template));
	        },

	        _appendFields: function(form) {
	            var idx, length, column;
	            var columns = this.options.columns;

	            for (idx = 0, length = columns.length; idx < length; idx++) {
	                column = columns[idx];

	                if (column.selectable) {
	                    continue;
	                }

	                if (column.command) {
	                    continue;
	                }

	                form.push(kendoHtmlElement('<div class="k-edit-label"><label for="' + column.field + '">' + (column.title || column.field || "") + '</label></div>'));

	                if (this._isEditable(column)) {
	                    form.push(kendoHtmlElement('<div ' + kendo.attr("container-for") + '="' + column.field +
	                                '" class="k-edit-field"></div>'));
	                } else {
	                    form.push(kendoDomElement("div", {
	                            "class": "k-edit-field"
	                        },
	                        [ this.options.fieldRenderer(column, this.model) ]));
	                }
	            }
	        },

	        _appendButtons: function(form) {
	            form.push(kendoDomElement("div", {
	                "class": "k-edit-buttons k-state-default"
	            }, this.options.commandRenderer()));
	        },

	        _attachHandlers: function() {
	            var closeHandler = this._cancelProxy = proxy(this._cancel, this);
	            this.wrapper.on(CLICK + NS, ".k-grid-cancel", this._cancelProxy);

	            this._saveProxy = proxy(this._save, this);
	            this.wrapper.on(CLICK + NS, ".k-grid-update", this._saveProxy);

	            this.window.bind("close", function(e) {
	                if (e.userTriggered) {
	                    closeHandler(e);
	                }
	            });
	        },

	        _detachHandlers: function() {
	            this._cancelProxy = null;
	            this._saveProxy = null;
	            this.wrapper.off(NS);
	        },

	        _cancel: function(e) {
	            this.trigger(CANCEL, e);
	        },

	        _save: function() {
	            this.trigger(SAVE);
	        },

	        open: function() {
	            this.window.center().open();
	        },

	        close: function() {
	            this.window.bind("deactivate", proxy(this.destroy, this)).close();
	        },

	        destroy: function() {
	            this.window.destroy();
	            this.window = null;
	            this._detachHandlers();

	            Editor.fn.destroy.call(this);
	        }
	    });

	    var IncellEditor = Editor.extend({
	        destroy: function() {
	            var that = this;

	            that.editable.destroy();

	            that.editable.element
	                .off()
	                .empty()
	                .removeAttr(kendo.attr("role"));

	            that.model = that.wrapper = that.element = that.columns = that.editable = null;
	        }
	    });

	    var TreeList = DataBoundWidget.extend({
	        init: function(element, options, events) {
	            DataBoundWidget.fn.init.call(this, element, options);

	            if (events) {
	                this._events = events;
	            }

	            isRtl = kendo.support.isRtl(element);
	            this._dataSource(this.options.dataSource);
	            this._aria();
	            this._columns();
	            this._layout();
	            this._navigatable();
	            this._selectable();
	            this._sortable();
	            this._resizable();
	            this._filterable();
	            this._attachEvents();
	            this._toolbar();
	            this._scrollable();
	            this._reorderable();
	            this._columnMenu();
	            this._minScreenSupport();
	            this._draggable();
	            this._pageable();

	            if (this.options.autoBind) {
	                this.dataSource.fetch();
	            }

	            if (this._hasLockedColumns) {
	                var widget = this;
	                this.wrapper.addClass("k-grid-lockedcolumns");
	                this._resizeHandler = function()  { widget.resize(); };
	                $(window).on("resize" + NS, this._resizeHandler);
	            }

	            kendo.notify(this);
	        },

	        _draggable: function() {
	            var that = this;
	            var editable = this.options.editable;
	            var dataSource = that.dataSource;
	            var idField = dataSource._modelIdField();
	            var parentIdField = dataSource._modelParentIdField();
	            var pageable = that._isPageable();
	            var reorderable;

	            if (!editable || !editable.move) {
	                return;
	            }

	            reorderable = editable.move.reorderable;

	            this._dragging = new kendo.ui.HierarchicalDragAndDrop(this.wrapper, {
	                $angular: this.$angular,
	                autoScroll: true,
	                holdToDrag: touchDevice,
	                filter: "tbody>tr",
	                itemSelector: "tr",
	                allowedContainers: this.wrapper,
	                hintText: function(row) {
	                    var text = function() { return $(this).text(); };
	                    var separator = "<span class='k-header k-drag-separator'></span>";
	                    return row.children("td").map(text).toArray().join(separator);
	                },
	                contains: proxy(function(source, destination) {
	                    var dest = this.dataItem(destination);
	                    var src = this.dataItem(source);

	                    return src == dest || this.dataSource.contains(src, dest);
	                }, this),
	                itemFromTarget: function(target) {
	                    var tr = target.closest("tr");
	                    var prevRow = tr.prev();
	                    var nextRow = tr.next();
	                    var first;
	                    var last;

	                    if (prevRow) {
	                        first =  !that.sameLevel(prevRow, tr);
	                    }

	                    if (nextRow) {
	                        last = !that.sameLevel(nextRow, tr);
	                    }

	                    return {
	                        item: tr,
	                        content: tr,
	                        first: first,
	                        last: last
	                    };
	                },
	                dragstart: proxy(function(source) {
	                    this.wrapper.addClass("k-treelist-dragging");

	                    if (this.wrapper.find('.k-grid-content').length) {
	                        this.wrapper.find('.k-grid-content table, .k-grid-content-locked table').css("position", "relative");
	                    }

	                    var model = this.dataItem(source);

	                    return this.trigger(DRAGSTART, { source: model });
	                }, this),
	                drag: proxy(function(e) {
	                    e.source = this.dataItem(e.source);

	                    this.trigger(DRAG, e);
	                }, this),
	                drop: proxy(function(e) {
	                    e.source = this.dataItem(e.source);
	                    e.destination = this.dataItem(e.destination);

	                    this.wrapper.removeClass("k-treelist-dragging");

	                    if (this.wrapper.find('.k-grid-content').length) {
	                        this.wrapper.find('.k-grid-content table, .k-grid-content-locked table').css("position", "static");
	                    }

	                    return this.trigger(DROP, e);
	                }, this),
	                dragend: proxy(function(e) {
	                    var dest = this.dataItem(e.destination);
	                    var src = this.dataItem(e.source);
	                    var originalSrcParentId = src[parentIdField];
	                    var originalSrcIndex = dataSource._indexInChildrenMap(src);
	                    var position = e.position;

	                    if (position == "over") {
	                        if (pageable) {
	                            dataSource._removeFromChildrenMap(src);
	                            src[parentIdField] = dest ? dest[idField] : null;

	                            dataSource._initChildrenMapForParent(dest);

	                            // src.set() below will not work as the parent id is already set
	                            src[parentIdField] = originalSrcParentId;
	                        }

	                        var isPrevented = src.set("parentId", dest ? dest.id : null);

	                        if (pageable && isPrevented) {
	                            dataSource._removeFromChildrenMap(src);
	                            src[parentIdField] = originalSrcParentId;
	                            dataSource._removeFromChildrenMap(src);
	                            dataSource._insertInChildrenMap(src, originalSrcIndex);
	                        }


	                    } else {
	                        if (position == "before") {
	                            that.insertBefore(src, dest);
	                        } else if (position == "after") {
	                            that.insertAfter(src, dest);
	                        }
	                    }

	                    e.source = src;
	                    e.destination = dest;

	                    this.trigger(DRAGEND, e);
	                }, this),
	                reorderable: reorderable,
	                dropHintContainer: function(item) {
	                    return item.children("td:visible:eq(0)");
	                },
	                dropPositionFrom: function(dropHint) {
	                    var contents;
	                    var length;
	                    var i;
	                    var dropHintElement;
	                    var isAfterText = false;

	                    if(dropHint.parent().find('.k-i-none').length) {
	                        return dropHint.prevAll(".k-i-none").length > 0 ? "after" : "before";
	                    } else {
	                        contents = dropHint.parent().contents();
	                        length = contents.length;
	                        dropHintElement = dropHint[0];

	                        for (i = 0; i < length; i++) {
	                            if (contents[i] === dropHintElement) {
	                                break;
	                            }

	                            if (contents[i].nodeType === 3) {
	                                isAfterText = true;
	                            }
	                        }

	                        return isAfterText ? "after" : "before";
	                    }
	                }
	            });
	        },

	        sameLevel: function () {
	           return arguments[0].find("." + classNames.iconHidden).length === arguments[1].find("." + classNames.iconHidden).length;
	        },

	        insertAfter: function(nodeData, referenceNode) {
	            this.insertAction(nodeData, referenceNode, 1);
	        },

	        insertBefore: function(nodeData, referenceNode) {
	            this.insertAction(nodeData, referenceNode, 0);
	        },

	        insertAction: function(nodeData, referenceNode, indexOffset){
	            var that = this;
	            var dataSource = that.dataSource;
	            var parentIdField = dataSource._modelParentIdField();
	            var referenceNodeIndex = dataSource.indexOf(referenceNode);
	            var nodeDataIndex = dataSource.indexOf(nodeData);
	            var pageable = that._isPageable();
	            var originalDestIndex = dataSource._indexInChildrenMap(referenceNode);
	            var dataLength = dataSource._data.length;
	            var destIndex = referenceNodeIndex + indexOffset;
	            var childrenMap = dataSource._getChildrenMap() || {};
	            var parentId = nodeData[parentIdField];

	            that._unbindDataSource();
	            that._unbindDataChange();

	            if (pageable) {
	                dataSource._removeFromChildrenMap(nodeData);
	            }

	            if (nodeData[parentIdField] != referenceNode[parentIdField]) {
	                 nodeData.set("parentId", referenceNode && referenceNode.parentId ? referenceNode.parentId : null);
	            }


	            if (destIndex > dataLength - 1) {
	                destIndex = dataLength - 1;
	            }

	            dataSource._data.splice(nodeDataIndex, 1);

	            if (pageable) {
	                originalDestIndex += indexOffset;

	                if (childrenMap[parentId].length <= originalDestIndex) {
	                    originalDestIndex = childrenMap[parentId].length;
	                }
	                dataSource._insertInChildrenMap(nodeData, originalDestIndex);
	            }

	            if (destIndex >= nodeDataIndex) {
	                destIndex -=1;
	            }

	            dataSource._data.splice(destIndex, 0, nodeData);
	            dataSource._destroyed.pop();
	            that._bindDataChange();
	            that._bindDataSource();
	            that.refresh();
	        },

	        _bindDataChange: function () {
	            var dataSource = this.dataSource;
	            if (dataSource._data && dataSource._changeHandler) {
	                dataSource._data.bind(CHANGE, dataSource._changeHandler);
	                dataSource._data.trigger(CHANGE);
	            }
	        },

	        _unbindDataChange: function () {
	            var dataSource = this.dataSource;
	            if (dataSource._data && dataSource._changeHandler) {
	                dataSource._data.unbind(CHANGE, dataSource._changeHandler);
	            }
	        },

	        _bindDataSource: function() {
	            var that = this;
	            var dataSource = that.dataSource;

	            if (dataSource) {
	                dataSource.bind(CHANGE, that._refreshHandler);
	            }
	        },

	        _unbindDataSource: function() {
	            var that = this;
	            var dataSource = that.dataSource;

	            if (dataSource) {
	                dataSource.unbind(CHANGE, that._refreshHandler);
	            }
	        },

	        itemFor: function(model) {
	            if (typeof model == "number") {
	                model = this.dataSource.get(model);
	            }

	            return this.tbody.find("[" + kendo.attr("uid") + "=" + model.uid + "]");
	        },

	        _itemFor: function(model) {
	            var that = this;
	            var table = that.lockedContent ? that.lockedTable : that.table;

	            if (typeof model == "number") {
	                model = this.dataSource.get(model);
	            }

	            return table.find("[" + kendo.attr("uid") + "=" + model.uid + "]");
	        },

	        _scrollable: function() {
	            if (this.options.scrollable) {
	                var scrollables = this.thead.closest(".k-grid-header-wrap");
	                var lockedContent = $(this.lockedContent)
	                    .bind("DOMMouseScroll" + NS + " mousewheel" + NS, proxy(this._wheelScroll, this));

	                this.content.bind("scroll" + NS, function() {
	                    kendo.scrollLeft(scrollables, this.scrollLeft);
	                    lockedContent.scrollTop(this.scrollTop);
	                });


	                var touchScroller = kendo.touchScroller(this.content);

	                if (touchScroller && touchScroller.movable) {
	                    this._touchScroller = touchScroller;

	                    touchScroller.movable.bind("change", function(e) {
	                        kendo.scrollLeft(scrollables, -e.sender.x);
	                        if (lockedContent) {
	                            lockedContent.scrollTop(-e.sender.y);
	                        }
	                    });
	                }
	            }
	        },

	        _wheelScroll: function (e) {
	            if (e.ctrlKey) {
	                return;
	            }

	            var delta = kendo.wheelDeltaY(e);
	            var lockedDiv = $(e.currentTarget);

	            if (delta) {
	                if (lockedDiv[0].scrollHeight > lockedDiv[0].clientHeight &&
	                    (lockedDiv[0].scrollTop < lockedDiv[0].scrollHeight - lockedDiv[0].clientHeight && delta < 0 ||
	                    lockedDiv[0].scrollTop > 0 && delta > 0)) {
	                    e.preventDefault();
	                }
	                //In Firefox DOMMouseScroll event cannot be canceled
	                lockedDiv.one("wheel" + NS, false);

	                this.content.scrollTop(this.content.scrollTop() + (-delta));
	            }
	        },

	        _progress: function() {
	            var messages = this.options.messages;

	            if (!this.tbody.find("tr").length) {
	                this._showStatus(
	                    kendo.template(
	                        "<span class='#= className #'></span> #: messages.loading #"
	                    )({
	                        className: classNames.icon + " " + classNames.loading,
	                        messages: messages
	                    })
	                );
	            }
	        },

	        _error: function(e) {
	            if (!this.dataSource.rootNodes().length) {
	                this._render({ error: e });
	            }
	        },

	        refresh: function(e) {
	            var that = this;
	            e = e || {};

	            if (e.action == "itemchange" && this.editor) {
	                return;
	            }

	            if (this.trigger(DATABINDING)) {
	                return;
	            }
	            var current = $(this.current());
	            var isCurrentInHeader = false;
	            var currentIndex;

	            this._cancelEditor();

	            this._render();

	            this._adjustHeight();

	            if (this.options.navigatable) {
	                if (this._isActiveInTable() || this.editor) {
	                    isCurrentInHeader = current.is("th");
	                    currentIndex = Math.max(this.cellIndex(current), 0);
	                }
	                this._restoreCurrent(currentIndex, isCurrentInHeader);
	            }

	            if (that._checkBoxSelection) {
	                that._deselectCheckRows(that.items());
	            }

	            this.trigger(DATABOUND);
	        },

	        _angularFooters: function(command) {
	            var i, footer, aggregates;
	            var allAggregates = this.dataSource.aggregates();
	            var footerRows = this._footerItems();

	            for (i = 0; i < footerRows.length; i++) {
	                footer = footerRows.eq(i);
	                aggregates = allAggregates[footer.attr("data-parentId")];

	                this._angularFooter(command, footer.find("td").get(), aggregates);
	            }
	        },

	        _angularFooter: function(command, cells, aggregates) {
	            var columns = this.columns;
	            this.angular(command, function() {
	                return {
	                    elements: cells,
	                    data: map(columns, function(col){
	                        return {
	                            column: col,
	                            aggregate: aggregates && aggregates[col.field]
	                        };
	                    })
	                };
	            });
	        },

	        items: function() {
	            if (this._hasLockedColumns) {
	                return this._items(this.tbody).add(this._items(this.lockedTable));
	            } else {
	                return this._items(this.tbody);
	            }
	        },

	        _items: function(container) {
	            return container.find("tr[data-uid]").filter(function() {
	                return !$(this).hasClass(classNames.footerTemplate);
	            });
	        },

	        _footerItems: function() {
	            var container = this.tbody;
	            if (this._hasLockedColumns) {
	                container = container.add(this.lockedTable);
	            }

	            return container.find("tr").filter(function() {
	                return $(this).hasClass(classNames.footerTemplate);
	            });
	        },

	        dataItems: function() {
	            var dataItems = kendo.ui.DataBoundWidget.fn.dataItems.call(this);
	            if (this._hasLockedColumns) {
	                var n = dataItems.length, tmp = new Array(2 * n);
	                for (var i = n; --i >= 0;) {
	                    tmp[i] = tmp[i + n] = dataItems[i];
	                }
	                dataItems = tmp;
	            }

	            return dataItems;
	        },

	        _showNoRecordsTemplate: function () {
	            var wrapper = '<div class="{0}">{1}</div>';
	            var defaultTemplate = '<div class="k-grid-norecords-template"{1}>{0}</div>';
	            var scrollableNoGridHeightStyles = (this.options.scrollable && !this.wrapper[0].style.height) ? ' style="margin:0 auto;position:static;"' : '';
	            var template;

	            this._contentTree.render([]);
	            if (this._hasLockedColumns) {
	                this._lockedContentTree.render([]);
	            }

	            template = kendo.format(defaultTemplate, this.options.messages.noRows, scrollableNoGridHeightStyles);

	            $(kendo.template(kendo.format(wrapper, NORECORDSCLASS, template))({})).insertAfter(this.table);
	        },

	        _showStatus: function(message) {
	            var status = this.element.find(".k-status");
	            var content = $(this.content).add(this.lockedContent);

	            if (!status.length) {
	                status = $("<div class='k-status' />").appendTo(this.element);
	            }

	            this._contentTree.render([]);
	            if (this._hasLockedColumns) {
	                this._lockedContentTree.render([]);
	            }

	            content.hide();

	            status.html(message);
	        },

	        _hideStatus: function() {
	            this.element.find(".k-status").remove();
	            this._hideNoRecordsTempalte();

	            $(this.content).add(this.lockedContent).show();
	        },

	        _hideNoRecordsTempalte: function() {
	            this.element.find("."+NORECORDSCLASS).remove();
	        },

	        _adjustHeight: function() {
	            var that = this;
	            var element = this.element;
	            var contentWrap = element.find(DOT + classNames.gridContentWrap);
	            var header = element.find(DOT + classNames.gridHeader);
	            var toolbar = element.find(DOT + classNames.gridToolbar);
	            var status = element.find(DOT + classNames.status);
	            var pagerHeight = that._isPageable() && that.pager && that.pager.element.is(":visible") ? outerHeight(that.pager.element) : 0;
	            var height;
	            var scrollbar = kendo.support.scrollbar();

	            element.css(HEIGHT, this.options.height);

	            // identical code found in grid & scheduler :(
	            var isHeightSet = function(el) {
	                var initialHeight, newHeight;
	                if (el[0].style.height) {
	                    return true;
	                } else {
	                    initialHeight = el.height();
	                }

	                el.height("auto");
	                newHeight = el.height();
	                el.height("");

	                return (initialHeight != newHeight);
	            };

	            if (isHeightSet(element)) {
	                height = element.height() - outerHeight(header) - outerHeight(toolbar) - outerHeight(status) - pagerHeight;

	                contentWrap.height(height);

	                if (this._hasLockedColumns) {
	                    scrollbar = this.table[0].offsetWidth > this.table.parent()[0].clientWidth ? scrollbar : 0;
	                    this.lockedContent.height(height - scrollbar);
	                }
	            }
	        },

	        _resize: function(size, force) {
	            this._applyLockedContainersWidth();
	            this._adjustHeight();

	            if (this.pager && this.pager.element) {
	                this.pager.resize(force);
	            }
	        },

	        _minScreenSupport: function() {
	            var any = this.hideMinScreenCols();

	            if (any) {
	                this.minScreenResizeHandler = proxy(this.hideMinScreenCols, this);
	                $(window).on("resize", this.minScreenResizeHandler);
	            }
	        },

	        _iterateMinScreenCols: function (cols, screenWidth) {
	            var any = false;

	            for (var i = 0; i < cols.length; i++) {
	                var col = cols[i];
	                var minWidth = col.minScreenWidth;
	                if (minWidth !== undefined && minWidth !== null) {
	                    any = true;
	                    if (minWidth > screenWidth) {
	                        this.hideColumn(col);
	                    } else {
	                        this.showColumn(col);
	                    }
	                }
	                if (!col.hidden && col.columns) {
	                    any = this._iterateMinScreenCols(col.columns, screenWidth) || any;
	                }
	            }
	            return any;
	        },

	        hideMinScreenCols: function() {
	            var cols = this.columns,
	                screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;

	            return this._iterateMinScreenCols(cols, screenWidth);
	        },

	        destroy: function() {
	            DataBoundWidget.fn.destroy.call(this);

	            var dataSource = this.dataSource;

	            dataSource.unbind(CHANGE, this._refreshHandler);
	            dataSource.unbind(ERROR, this._errorHandler);
	            dataSource.unbind(PROGRESS, this._progressHandler);

	            this._navigatableTables = null;
	            this._current = null;

	            if (this._resizeHandler) {
	                $(window).off("resize" + NS, this._resizeHandler);
	            }

	            if (this._dragging) {
	                this._dragging.destroy();
	                this._dragging = null;
	            }

	            if (this.resizable) {
	                this.resizable.destroy();
	                this.resizable = null;
	            }

	            if (this.reorderable) {
	                this.reorderable.destroy();
	                this.reorderable = null;
	            }

	            if (this._draggableInstance && this._draggableInstance.element) {
	                this._draggableInstance.destroy();
	                this._draggableInstance = null;
	            }

	            if(this.selectable){
	                this.selectable.destroy();
	            }

	            if (this._userEvents) {
	                this._userEvents.destroy();
	                this._userEvents = null;
	            }

	            if (this.minScreenResizeHandler) {
	                $(window).off("resize", this.minScreenResizeHandler);
	            }

	            this._destroyEditor();

	            this.element.off(NS);
	            this.wrapper.off(NS);

	            if (this._touchScroller) {
	                this._touchScroller.destroy();
	            }

	            this._destroyPager();

	            if (dataSource) {
	                dataSource._dataMaps = null;
	            }

	            this._autoExpandable = null;

	            this._refreshHandler = this._errorHandler = this._progressHandler = this._dataSourceFetchProxy = null;

	            this.thead =
	                this.content =
	                this.tbody =
	                this.table =
	                this.element =
	                this.lockedHeader =
	                this.lockedContent = null;

	            this._statusTree =
	                this._headerTree =
	                this._contentTree =
	                this._lockedHeaderColsTree =
	                this._lockedContentColsTree =
	                this._lockedHeaderTree =
	                this._lockedContentTree = null;
	        },

	        options: {
	            name: "TreeList",
	            columns: [],
	            autoBind: true,
	            scrollable: true,
	            selectable: false,
	            sortable: false,
	            toolbar: null,
	            height: null,
	            columnMenu: false,
	            messages: {
	                noRows: "No records to display",
	                loading: "Loading...",
	                requestFailed: "Request failed.",
	                retry: "Retry",
	                commands: {
	                    edit: "Edit",
	                    update: "Update",
	                    canceledit: "Cancel",
	                    create: "Add new record",
	                    createchild: "Add child record",
	                    destroy: "Delete",
	                    excel: "Export to Excel",
	                    pdf: "Export to PDF",
	                    search: "Search..."
	                }
	            },
	            excel: {
	                hierarchy: true
	            },
	            resizable: false,
	            search: false,
	            filterable: false,
	            editable: false,
	            reorderable: false,
	            pageable: false,
	            renderAllRows: true
	        },

	        events: [
	            CHANGE,
	            BEFORE_EDIT,
	            EDIT,
	            PAGE,
	            SAVE,
	            SAVE_CHANGES,
	            REMOVE,
	            EXPAND,
	            COLLAPSE,
	            DATABINDING,
	            DATABOUND,
	            CANCEL,
	            DRAGSTART,
	            DRAG,
	            DROP,
	            DRAGEND,
	            FILTERMENUINIT,
	            ITEM_CHANGE,
	            CELL_CLOSE,
	            FILTERMENUOPEN,
	            COLUMNHIDE,
	            COLUMNSHOW,
	            COLUMNREORDER,
	            COLUMNRESIZE,
	            COLUMNMENUINIT,
	            COLUMNMENUOPEN,
	            COLUMNLOCK,
	            COLUMNUNLOCK
	        ],

	        getOptions: function() {
	            var options = this.options;
	            options.dataSource = null;

	            var result = extend(true, {}, this.options);
	            result.columns = kendo.deepExtend([], this.columns);

	            var dataSource = this.dataSource;

	            var initialData = dataSource.options.data && dataSource._data;
	            dataSource.options.data = null;

	            result.dataSource = $.extend(true, {}, dataSource.options);

	            dataSource.options.data = initialData;

	            result.dataSource.data = initialData;
	            result.dataSource.page = dataSource.page();
	            result.dataSource.filter = $.extend(true, {}, dataSource.filter());
	            result.dataSource.pageSize = dataSource.pageSize();
	            result.dataSource.sort = dataSource.sort();
	            result.dataSource.group = dataSource.group();
	            result.dataSource.aggregate = dataSource.aggregate();

	            if (result.dataSource.transport) {
	                result.dataSource.transport.dataSource = null;
	            }

	            if (result.pageable && result.pageable.pageSize) {
	                result.pageable.pageSize = dataSource.pageSize();
	            }

	            result.$angular = undefined;

	            return result;
	        },

	        setOptions: function(options) {
	            var currentOptions = this.getOptions();
	            kendo.deepExtend(currentOptions, options);
	            if (!options.dataSource) {
	                currentOptions.dataSource = this.dataSource;
	            }
	            var wrapper = this.wrapper;
	            var events = this._events;
	            var element = this.element;

	            this.destroy();
	            this.options = null;
	            if (wrapper[0] !== element[0]) {
	                wrapper.before(element);
	                wrapper.remove();
	            }
	            element.empty();

	            this.init(element, currentOptions, events);
	            this._setEvents(currentOptions);
	        },

	        _toggle: function(model, expand) {
	            var that = this;
	            var defaultPromise = $.Deferred().resolve().promise();
	            var loaded = model.loaded();

	             if (that._isIncellEditable() && that.editor) {
	                // manually trigger change as the expand/collapse icons are not focusable
	                $(activeElement()).change();
	                that.closeCell();
	            }

	            // reset error state
	            if (model._error) {
	                model.expanded = false;
	                model._error = undefined;
	            }

	            // do not load items that are currently loading
	            if (!loaded && model.expanded) {
	                return defaultPromise;
	            }

	            // toggle expanded state
	            if (typeof expand == "undefined") {
	                expand = !model.expanded;
	            }

	            model.expanded = expand;

	            function afterModelLoaded() {
	                that._toggleData();
	                if (that._isPageable()) {
	                    that.refresh();
	                } else {
	                    that._render();
	                }
	                that._syncLockedContentHeight();
	            }

	            if (!loaded) {
	                defaultPromise = this.dataSource.load(model)
	                    .always(proxy(function() {
	                        afterModelLoaded();
	                    }, this));
	            }

	            afterModelLoaded();

	            return defaultPromise;
	        },

	        _toggleData: function() {
	            var that = this;

	            if (that._isPageable()) {
	                that._togglePageableData();
	            }
	        },

	        _togglePageableData: function() {
	            var that = this;
	            var dataSource = that.dataSource;
	            var data = dataSource._getData();
	            var result;
	            var queryOptions = dataSource._defaultPageableQueryOptions();

	            that._renderProgress(true);

	            var childrenMap = dataSource._getChildrenMap() || dataSource.childrenMap(dataSource._getData());

	            dataSource._processDataItemsState(data, childrenMap);

	            result = dataSource._processPageableQuery(data, queryOptions);

	            queryOptions.childrenMap = result.childrenMap;
	            queryOptions.filteredChildrenMap = result.filteredChildrenMap;

	            dataSource._aggregateResult = dataSource._calculateAggregates(result.dataToAggregate, queryOptions);

	            dataSource.view(result.data);

	            if (!dataSource.filter()) {
	                dataSource._calculateCollapsedTotal();
	            }

	            that._refreshPager();

	            that._renderProgress(false);
	        },

	        _refreshPager: function() {
	            var pager = this.pager;

	            if (pager) {
	                pager.refresh();
	            }
	        },

	        expand: function(row) {
	            return this._toggle(this.dataItem(row), true);
	        },

	        collapse: function(row) {
	            return this._toggle(this.dataItem(row), false);
	        },

	        _toggleChildren: function(e) {
	            var icon = $(e.target);
	            var model = this.dataItem(icon);

	            if (!model) {
	                return;
	            }

	            var event = !model.expanded ? EXPAND : COLLAPSE;

	            if (!this.trigger(event, { model: model })) {
	                this._toggle(model);
	            }

	            e.preventDefault();
	        },

	        _navigatable: function() {
	            var that = this;

	            if (!that.options.navigatable) {
	                return;
	            }
	            var tables = that.table.add(that.lockedTable);

	            var headerTables = that.thead.parent().add($(">table", that.lockedHeader));
	            if (that.options.scrollable) {
	                //add the header table when the widget is scrollable
	                tables = tables.add(headerTables);
	                //data tables will recive first focus on TAB
	                headerTables.attr(TABINDEX, -1);
	            }

	            this._navigatableTables = tables;

	            tables
	                //handle click on tables, will attempt to focus the table
	                .on((kendo.support.touch ? "touchstart" + NS : "mousedown" + NS), NAVROW + ">:visible", proxy(that._tableClick, that))
	                .on("focus" + NS, proxy(that._tableFocus, that))
	                .on("focusout" + NS, proxy(that._tableBlur, that))
	                .on("keydown" + NS, proxy(that._tableKeyDown, that));
	        },

	        cellIndex: function(td) {
	            var lockedColumnOffset = 0;

	            if (this.lockedTable && !$.contains(this.lockedTable[0], td[0])) {
	                lockedColumnOffset = leafColumns(lockedColumns(this.columns)).length;
	            }

	            return $(td).parent().children().index(td) + lockedColumnOffset;
	        },

	        _isActiveInTable: function() {
	            var active = kendo._activeElement();

	            if (!active) { return false; }

	            return this.table[0] === active ||
	                $.contains(this.table[0], active) ||
	                (this.lockedTable &&
	                    (this.lockedTable[0] === active || $.contains(this.lockedTable[0], active))
	                );
	        },

	        _restoreCurrent: function(currentIndex, isCurrentInHeader) {
	            var rowIndex;
	            var row;
	            var td;

	            if (currentIndex === undefined || currentIndex < 0) {
	                return;
	            }

	            if (this._current) {
	                this._current.removeClass("k-state-focused");
	            }

	            if (isCurrentInHeader) {
	                this.current(this.thead.find("th").eq(currentIndex));
	            } else {
	                rowIndex = 0;
	                currentIndex = 0;

	                row = $();

	                if (this.lockedTable) {
	                    row = this.lockedTable.find(">tbody>tr:visible").eq(rowIndex);
	                }
	                row = row.add(this.tbody.children().eq(rowIndex));

	                td = row.find(">td:visible")
	                    .eq(currentIndex);

	                this.current(td);
	            }

	            if (this._current) {
	                focusTable(this._current.closest("table")[0], true);
	            }
	        },

	        current: function (newCurrent) {
	            var current = this._current;
	            newCurrent = $(newCurrent);

	            if(newCurrent.length && (!current || current[0] !== newCurrent[0])) {
	                this._updateCurrentAttr(current, newCurrent);

	                this._scrollCurrent();
	            }

	            if (newCurrent && newCurrent.length) {
	                this._lastCellIndex = newCurrent.parent().children(DATA_CELL).index(newCurrent);
	            }

	            return this._current;
	        },

	        _setCurrent: function(newCurrent) {
	            var that = this;
	            newCurrent = $(newCurrent);

	            if (newCurrent[0]) {
	                that._current = newCurrent;
	                that._updateCurrentAttr(that._current, newCurrent);
	                that._scrollCurrent();
	            }

	            return that._current;
	        },

	        _scrollCurrent: function() {
	            var current = this._current;
	            var scrollable = this.options.scrollable;

	            if (!current || !scrollable) {
	                return;
	            }

	            var row = current.parent();
	            var tableContainer = row.closest("table").parent();

	            var isInLockedContainer = tableContainer.is(".k-grid-content-locked,.k-grid-header-locked");
	            var isInContent = tableContainer.is(".k-grid-content-locked,.k-grid-content");

	            var scrollableContainer = $(this.content)[0];

	            //adjust scroll vertically
	            if (isInContent) {
	                this._scrollTo(this._relatedRow(row)[0], scrollableContainer);
	            }

	            if (this.lockedContent) {
	                //sync locked and non-locked content scrollTop
	                this.lockedContent[0].scrollTop = scrollableContainer.scrollTop;
	            }

	            //adjust scroll horizontally, if not inside locked tables
	            if (!isInLockedContainer) {
	                this._scrollTo(current[0], scrollableContainer);
	            }
	        },

	        _findCurrentCell: function() {
	            var that = this;
	            var current = that.current();
	            var elements = $(that.table).add(that.header).add(that.lockedTable).add(that.lockedHeader);

	            if (current && elements.find(current).length > 0) {
	                return current;
	            } else {
	                return elements.find(DOT + classNames.focused);
	            }
	        },

	        _scrollTo: function(element, container) {
	            var elementToLowercase = element.tagName.toLowerCase();
	            var isHorizontal =  elementToLowercase === "td" || elementToLowercase === "th";
	            var table = $(element).closest("table")[0];
	            var elementOffsetDir = element[isHorizontal ? "offsetWidth" : "offsetHeight"];
	            var containerScroll = container[isHorizontal ? "scrollLeft" : "scrollTop"];
	            var containerOffsetDir = container[isHorizontal ? "clientWidth" : "clientHeight"];
	            var elementOffset = $(element).css("position") === "relative" && isRtl && isHorizontal ? Math.abs(table.offsetLeft - element.offsetLeft) : element[isHorizontal ? "offsetLeft" : "offsetTop"];
	            var bottomDistance = elementOffset + elementOffsetDir;
	            var result = 0;
	            var ieCorrection = 0;
	            var firefoxCorrection = 0;

	            if (isRtl && isHorizontal) {
	                if (browser.msie || browser.edge) {
	                    ieCorrection = table.offsetLeft;
	                } else if (browser.mozilla || (browser.webkit && (browser.version > 85))) {
	                    firefoxCorrection = table.offsetLeft - kendo.support.scrollbar();
	                }
	            }
	            containerScroll = Math.abs(containerScroll + ieCorrection - firefoxCorrection);
	            if (containerScroll > elementOffset) {
	                result = elementOffset;
	            } else if (bottomDistance > (containerScroll + containerOffsetDir)) {
	                if (elementOffsetDir <= containerOffsetDir) {
	                    result = (bottomDistance - containerOffsetDir);
	                } else {
	                    result = elementOffset;
	                }
	            } else {
	                result = containerScroll;
	            }
	            result = Math.abs(result + ieCorrection) + firefoxCorrection;
	            container[isHorizontal ? "scrollLeft" : "scrollTop"] = result;
	        },

	        _aria: function() {
	            var id = this.element.attr("id") || "aria";

	            if (id) {
	                this._elementId = id + "_active_element";
	            }
	        },

	        _currentDataIndex: function(table, current) {
	            var index = current.attr("data-index");

	            if (!index) {
	                return undefined;
	            }

	            var lockedColumnsCount = lockedColumns(this.columns).length;
	            if (lockedColumnsCount && !table.closest("div").hasClass("k-grid-content-locked")[0]) {
	                return index - lockedColumnsCount;
	            }

	            return index;
	        },

	        _prevVerticalCell: function(container, current) {
	            var cells;
	            var row = current.parent();
	            var rows = container.children(NAVROW);
	            var rowIndex = rows.index(row);
	            //get data-index in case of last level of multi-level columns
	            var index = this._currentDataIndex(container, current);

	            //current is in the header, but not at the last level of multi-level columns
	            if (index || current.hasClass("k-header")) {
	                cells = parentColumnsCells(current);
	                return cells.eq(cells.length - 2);
	            }

	            index = Math.max(row.children(DATA_CELL).index(current), this._lastCellIndex || 0);

	            //if current is inside filter row
	            if (row.hasClass("k-filter-row")) {
	                return leafDataCells(container).filter(isCellVisible).eq(index);
	            }

	            //move up to header container
	            if (rowIndex == -1) {
	                //is there filter row in the header container
	                row = container.find("tr.k-filter-row:visible");
	                if (!row[0]) {
	                    return leafDataCells(container).filter(isCellVisible).eq(index);
	                }
	            } else {
	                row =  rowIndex === 0 ? $() : rows.eq(rowIndex - 1);
	            }

	            cells = row.children(DATA_CELL);
	            if (cells.length > index) {
	                return cells.eq(index);
	            }

	            return cells.eq(0);
	        },

	        _nextVerticalCell: function(container, current) {
	            var cells;
	            var row = current.parent();
	            var rows = container.children(NAVROW);
	            var rowIndex = rows.index(row);
	            //get data-index in case of last level of multi-level columns
	            var index = this._currentDataIndex(container, current);

	            //current is in the header, but not at the last level of multi-level columns
	            //and we are not changing the table
	            if (rowIndex != -1 && index === undefined && current.hasClass("k-header")) {
	                return childColumnsCells(current).eq(1);
	            }

	            index = index ? parseInt(index, 10) : row.children(DATA_CELL).index(current);
	            index = Math.max(index, this._lastCellIndex || 0);

	            //move down to data container
	            if (rowIndex == -1) {
	                row = rows.eq(0);
	            } else {
	                row = rows.eq(rowIndex + current[0].rowSpan);
	            }

	            var tmpIndex = index;
	            //in case of last level of multi-level columns the index should be updated depending on the hidden columns
	            if (this._currentDataIndex(container, current) !== undefined) {
	                var currentRowCells = row.children(":not(.k-group-cell):not(.k-hierarchy-cell)");
	                var hiddenColumns = currentRowCells.filter(":hidden");
	                for(var idx = 0, length = hiddenColumns.length; idx < length; idx++) {
	                    if (currentRowCells.index(hiddenColumns[idx]) < index) {
	                        tmpIndex--;
	                    }
	                }
	            }
	            index = tmpIndex;

	            cells = row.children(DATA_CELL);
	            if (cells.length > index) {
	                return cells.eq(index);
	            }

	            return cells.eq(0);
	        },

	        _verticalContainer: function(container, up) {
	            var table = container.parent();
	            var length = this._navigatableTables.length;
	            var step = Math.floor(length / 2);
	            var index = inArray(table[0], this._navigatableTables);

	            if (up) {
	                step *= -1;
	            }
	            index += step;

	            if (index >= 0 || index < length) {
	                table = this._navigatableTables.eq(index);
	            }

	            return table.find(up ? "thead" : "tbody");
	        },

	        _updateCurrentAttr: function(current, next) {
	            var headerId = $(current).data("headerId");

	            $(current)
	                .removeClass(classNames.focused)
	                .closest("table")
	                .removeAttr("aria-activedescendant");

	            if(headerId){
	                headerId = headerId.replace(this._elementId, "");
	                $(current).attr("id", headerId);
	            }else{
	                $(current).removeAttr("id");
	            }

	            next
	                .data("headerId", next.attr("id"))
	                .attr("id", this._elementId)
	                .addClass(classNames.focused)
	                .closest("table")
	                .attr("aria-activedescendant", this._elementId);

	            this._current = next;
	        },

	        _tableKeyDown: function(e) {
	            var handled = false;
	            var current = this.current();
	            var target = $(e.target);
	            var canHandle = !e.isDefaultPrevented() && !target.is(":button,a,:input,a>.k-icon");

	            current = current ? current : $(this.lockedTable).add(this.table).find(FIRSTNAVITEM);

	            if (canHandle && e.keyCode == keys.UP) {
	                handled = this._moveUp(current, e.shiftKey);
	            }

	            if (canHandle && e.keyCode == keys.DOWN) {
	                handled = this._moveDown(current, e.shiftKey);
	            }

	            if (canHandle && e.keyCode == (isRtl ? keys.LEFT : keys.RIGHT)) {
	                if (e.altKey) {
	                    handled = this._handleExpand(current);
	                } else {
	                    handled = this._moveRight(current);
	                }
	            }

	            if (canHandle && e.keyCode == (isRtl ? keys.RIGHT : keys.LEFT)) {
	                if (e.altKey) {
	                    handled = this._handleCollapse(current);
	                } else {
	                    handled = this._moveLeft(current);
	                }
	            }

	            if (canHandle && e.keyCode == keys.PAGEDOWN) {
	                handled = this._handlePageDown();
	            }

	            if (canHandle && e.keyCode == keys.PAGEUP) {
	                handled = this._handlePageUp();
	            }

	            if (e.keyCode == keys.ENTER || e.keyCode == keys.F2) {
	                handled = this._handleEnterKey(current, e.currentTarget, target);
	            }

	            if (e.keyCode == keys.ESC) {
	                handled = this._handleEscKey(current, e.currentTarget);
	            }

	            if (canHandle && e.keyCode == keys.HOME) {
	                handled = this._handleHome(current, e.ctrlKey);
	            }

	            if (canHandle && e.keyCode == keys.END) {
	                handled = this._handleEnd(current, e.ctrlKey);
	            }

	            if (e.keyCode == keys.TAB) {
	                handled = this._handleTabKey(current, e.currentTarget, e.shiftKey);
	            }

	            if (handled) {
	                //prevent scrolling while pressing the keys
	                e.preventDefault();
	                //required in hierarchy
	                e.stopPropagation();
	            }
	        },

	        _handleExpand: function(current) {
	            var that = this;
	            var row = current.parent();
	            var model = that.dataItem(row);

	            if (current.hasClass("k-header")) {
	                return false;
	            }

	            if (model && model.hasChildren && !model.expanded && !that.trigger(EXPAND, { model: model })) {
	                this.expand(row);
	                return true;
	            }

	            return false;
	        },

	        _handleCollapse: function(current) {
	            var that = this;
	            var row = current.parent();
	            var model = that.dataItem(row);

	            if (current.hasClass("k-header")) {
	                return false;
	            }

	            if (model && model.hasChildren && model.expanded && !that.trigger(COLLAPSE, { model: model })) {
	                that.collapse(row);
	                return true;
	            }

	            return false;
	        },

	        _handleHome: function(current, ctrl) {
	            var row = current.parent();
	            var rowContainer = row.parent();
	            var isInLockedTable = this.lockedTable && this.lockedTable.children("tbody")[0] === rowContainer[0];
	            var isInBody = rowContainer[0] === this.tbody[0];
	            var prev;

	            if (ctrl) {
	                if (this.lockedTable) {
	                    prev = this.lockedTable.find(FIRSTNAVITEM);
	                } else {
	                    prev = this.table.find(FIRSTNAVITEM);
	                }
	            } else if (isInBody || isInLockedTable) {
	                if (isInBody && this.lockedTable) {
	                    row = this._relatedRow(row);
	                }
	                prev = row.children(NAVCELL + ":first");
	            }

	            if (prev && prev.length) {
	                this.current(prev);
	                return true;
	            }
	        },

	        _handleEnd: function(current, ctrl) {
	            var row = current.parent();
	            var rowContainer = row.parent();
	            var isInLockedTable = this.lockedTable && this.lockedTable.children("tbody")[0] === rowContainer[0];
	            var isInBody = rowContainer[0] === this.tbody[0];
	            var next;

	            if (ctrl) {
	                next = this.table.find(LASTITEMROW + ">" + NAVCELL + ":last");
	            } else if (isInBody || isInLockedTable) {
	                if (!isInBody && this.lockedTable) {
	                    row = this._relatedRow(row);
	                }
	                next = row.children(NAVCELL + ":last");
	            }

	            if (next && next.length) {
	                this.current(next);
	                return true;
	            }
	        },

	        _handlePageDown: function() {
	            var that = this;

	            if (!that._isPageable()) {
	                return false;
	            }

	            that.dataSource._restorePageSizeAfterAddChild();
	            that.dataSource.page(that.dataSource.page() + 1);

	            return true;
	        },

	        _handlePageUp: function() {
	            var that = this;

	            if (!that._isPageable()) {
	                return false;
	            }

	            that.dataSource._restorePageSizeAfterAddChild();
	            that.dataSource.page(that.dataSource.page() - 1);

	            return true;
	        },

	        _handleEscKey: function(current, currentTable) {
	            var active = kendo._activeElement();
	            var currentIndex;
	            var that = this;
	            var row;
	            var rowIndex;
	            var cellIndex;
	            var tbody;

	            if (!current || !current.parent().hasClass("k-grid-edit-row")) {
	                if (current.has(active).length) {
	                    // return focus back to the table
	                    focusTable(currentTable, true);

	                    return true;
	                }
	                return false;
	            }

	            if (that._isIncellEditable()) {
	                row = current.parent();
	                cellIndex = current.index();
	                rowIndex = row.index();
	                tbody = row.closest("tbody");

	                that.closeCell(true);

	                // refresh the current element as the DOM element reference can be changed after render()
	                // moving this to closeCell() causes flickering when clicking on a cell and then on another
	                // as 'k-state-focused' is shown for the closing cell and then added to the newly edited cell
	                that._setCurrent(tbody.children().eq(rowIndex).children().eq(cellIndex));
	            } else {
	                currentIndex = $(current).parent().index();
	                if (active) {
	                    active.blur();
	                }
	                this.cancelRow();
	                if (currentIndex >= 0) {
	                    this.current(this.items().eq(currentIndex).children(NAVCELL).first());
	                }
	            }

	            if (browser.msie && browser.version < 9) {
	                document.body.focus();
	            }

	            focusTable(currentTable, true);

	            return true;
	        },

	        _handleEnterKey: function(current, currentTable, target) {
	            var editable = this.options.editable;
	            var container = target.closest("[role=gridcell]");
	            var focusable;

	            if (!target.is("table") && !$.contains(current[0], target[0])) {
	                current = container;
	            }

	            if (current.is("th")) {
	                // sort the column, if possible
	                current.find(".k-link").click();
	                return true;
	            }

	            focusable = current.find(":kendoFocusable:first");
	            if (focusable[0] && current.hasClass("k-state-focused")) {
	                focusable.focus();

	                return true;
	            }

	            if (editable && !target.is(":button,.k-button,textarea")) {
	                if (!container[0]) {
	                    container = current;
	                }

	                this._handleEditing(container, false, currentTable);

	                return true;
	            }

	            return false;
	        },

	        _handleTabKey: function(current, currentTable, shiftKey) {
	            var that = this;
	            var incellEditing = that.options.editable && that._isIncellEditable();
	            var cell;

	            if (!incellEditing || current.is("th")) {
	                return false;
	            }

	            cell = $(activeElement()).closest(DOT + classNames.editCell);

	            if (cell[0] && cell[0] !== current[0]) {
	                current = cell;
	            }

	            cell = that._tabNext(current, currentTable, shiftKey);

	            if (cell.length) {
	                that._handleEditing(current, cell, cell.closest(TABLE));
	                return true;
	            } else {
	                that._preventPageSizeRestore = false;
	            }

	            return false;
	        },

	        _tabNext: function (current, currentTable, back) {
	            var that = this;
	            var switchRow = true;
	            var next = back ? current.prevAll(DATA_CELL + ":first") : current.nextAll(":visible:first");

	            if (!next.length) {
	                next = current.parent();
	                if (that.lockedTable) {
	                    switchRow = (back && currentTable == that.lockedTable[0]) || (!back && currentTable == that.table[0]);
	                    next = that._relatedRow(next);
	                }

	                if (switchRow) {
	                    next = next[back ? "prevAll" : "nextAll"]("tr:not(.k-grouping-row):not(.k-detail-row):visible:first");
	                }
	                next = next.children(DATA_CELL + (back ? ":last" : ":first"));

	                that.dataSource._restorePageSizeAfterAddChild();
	            }

	            return next;
	        },

	        _handleEditing: function(current, next, table) {
	            var that = this,
	                active = $(kendo._activeElement()),
	                isIE = browser.msie,
	                editContainer,
	                focusable,
	                isEdited;
	            var editable = that.options.editable && that.options.editable.update !== false;
	            var incellEditing = that._isIncellEditable();
	            var nextFocusableCellRowIndex = $(next).parents("tr").index();
	            var nextFocusableCellIndex = $(next).index();
	            var currentFocusedCellRowIndex = $(current).parents("tr").index();
	            var currentFocusedCellIndex = current.index();
	            var editedCell;

	            table = $(table);

	            if (incellEditing) {
	                isEdited = current.hasClass(classNames.editCell);
	            } else {
	                isEdited = current.parent().hasClass("k-grid-edit-row");
	            }

	            if (that.editor) {
	                editContainer = that.editor.wrapper;
	                if (editContainer && $.contains(editContainer[0], active[0])) {
	                    if (browser.opera) {
	                        active.blur().change().triggerHandler("blur");
	                    } else {
	                        active.blur();
	                        if (isIE) {
	                            //IE10 with jQuery 1.9.x does not trigger blur handler
	                            //numeric textbox does trigger change
	                            active.blur();
	                        }
	                    }
	                }

	                if (!that.editor) {
	                    focusTable(table);
	                    return;
	                }

	                if (that.editor.end()) {
	                    if (incellEditing) {
	                        that._preventPageSizeRestore = true;
	                        that.closeCell();
	                        that._preventPageSizeRestore = false;

	                        if ($(that.table).add(that.lockedTable).find(DOT + classNames.editCell).length === 0) {
	                            that.current(table.find("tbody").children().eq(currentFocusedCellRowIndex).children().eq(currentFocusedCellIndex));
	                        }
	                    } else {
	                        that.saveRow();
	                        isEdited = true;
	                    }
	                } else {
	                    if (incellEditing) {
	                        that.current(editContainer);
	                    } else {
	                        that.current(editContainer.children().filter(NAVCELL).first());
	                    }

	                    focusable = editContainer.find(":kendoFocusable:first")[0];
	                    if (focusable) {
	                        focusable.focus();
	                    }
	                    return;
	                }
	            }

	            // the next cell to focus might be re-rendered, so update the reference to it if it is an element
	            next = $(next).length && table.find(next).length === 0 ? table.find("tbody").children().eq(nextFocusableCellRowIndex).children().eq(nextFocusableCellIndex) : next;

	            if (next) {
	                that.current(next);
	            }

	            focusTable(table, true);

	            if (!editable) {
	                return;
	            }

	            if ((!isEdited && !next) || next) {
	                var currentIndex = that.current().index();

	                if (incellEditing) {
	                    that.editCell(that.current());

	                    editedCell = $(that.table).add(that.lockedTable).find(DOT + classNames.editCell)[0];

	                    if (editedCell) {
	                        that._current = $(editedCell);
	                    } else {
	                        that.current(that._findCurrentCell());
	                    }
	                } else {
	                    that.editRow(that.current().parent());
	                    that.current(that.editor.wrapper.children().eq(currentIndex));
	                    that.current().removeClass("k-state-focused");
	                }
	            } else {
	                that.dataSource._restorePageSizeAfterAddChild();
	            }
	        },

	        _moveRight: function(current) {
	            var next = current.nextAll(NAVCELL).first();
	            var row = current.parent();

	            if (current.hasClass("k-header")) {
	                next = current.nextAll(NAVHEADER).first();
	                if(!next[0] && this.lockedTable && current.closest("table")[0] === this.lockedHeader.find("table")[0]) {
	                    next = this.thead.find(NAVHEADER + ":first");
	                }
	            }

	            if (!next[0] && this.lockedTable && current.closest("table")[0] === this.lockedTable[0]) {
	               next = this._relatedRow(row).children(NAVCELL).first();
	            }

	            if (next[0] && next[0] !== current[0]) {
	                focusTable(next.closest("table"), true);
	            }

	            this.current(next);

	            return true;
	        },

	        _moveLeft: function(current) {
	            var prev = current.prevAll(NAVCELL).first();
	            var row = current.parent();

	            if (current.hasClass("k-header")) {
	                prev = current.prevAll(NAVHEADER).first();
	                if(!prev[0] && this.lockedTable && current.closest("table")[0] === this.thead.parent()[0]) {
	                    prev = this.lockedHeader.find(">table>thead>tr>"+ NAVHEADER + ":last");
	                }
	            }

	            if (!prev[0] && this.lockedTable && current.closest("table")[0] === this.table[0]) {
	               prev = this._relatedRow(row).children(NAVCELL).last();
	            }

	            if (prev[0] && prev[0] !== current[0]) {
	                focusTable(prev.closest("table"), true);
	            }

	            this.current(prev);

	            return true;
	        },

	        _moveUp: function(current, shiftKey) {
	            var container = current.parent().parent();
	            var prev;

	            if (shiftKey) {
	               prev = current.parent();
	               prev = prev.prevAll(ITEMROW + ":first");
	               prev = current.parent().is(ITEMROW) ? prev.children().eq(current.index()) : prev.children(DATA_CELL + ":last" );
	            } else {
	               prev = this._prevVerticalCell(container, current);
	               if (!prev[0]) {
	                  this._lastCellIndex = 0;
	                  container = this._verticalContainer(container, true);

	                  prev = this._prevVerticalCell(container, current);

	                  if (prev[0]) {
	                      focusTable(container.parent(), true);
	                  }
	               }
	            }

	            var tmp = this._lastCellIndex || 0;
	            this.current(prev);
	            this._lastCellIndex = tmp;

	            return true;
	        },

	        _moveDown: function(current, shiftKey) {
	            var container = current.parent().parent();
	            var next;

	            if (shiftKey) {
	                next = current.parent();
	                next = next.nextAll(ITEMROW + ":first");
	                next = current.parent().is(ITEMROW)? next.children().eq(current.index()) : next.children(DATA_CELL + ":first" );
	            } else {
	                next = this._nextVerticalCell(container, current);
	                if (!next[0]) {
	                    this._lastCellIndex = 0;
	                    container = this._verticalContainer(container);

	                    next = this._nextVerticalCell(container, current);
	                    if (next[0]) {
	                        focusTable(container.parent(), true);
	                    }
	                }
	            }
	            var tmp = this._lastCellIndex || 0;
	            this.current(next);
	            this._lastCellIndex = tmp;
	            return true;
	        },

	        _tableClick: function(e) {
	            var currentTarget = $(e.currentTarget),
	                isHeader = currentTarget.is("th"),
	                table = this.table.add(this.lockedTable),
	                headerTable = this.thead.parent().add($(">table", this.lockedHeader)),
	                isInput = isInputElement(e.target),
	                currentTable = currentTarget.closest("table")[0];

	            if (kendo.support.touch) {
	                return;
	            }

	            if (currentTable !== table[0] && currentTable !== table[1] && currentTable !== headerTable[0] && currentTable !== headerTable[1]) {
	                return;
	            }

	            if (this.options.navigatable) {
	                this.current(currentTarget);
	            }

	            if (isHeader || !isInput) {
	                setTimeout(function() {
	                   if (!isInputElement(kendo._activeElement()) || !$.contains(currentTable, kendo._activeElement())) {
	                       focusTable(currentTable, true);
	                   }
	                });
	            }

	            if (isHeader) {
	                e.preventDefault(); //if any problem occurs, call preventDefault only for the clicked header links
	            }
	        },

	        _setTabIndex: function(table) {
	            this._navigatableTables.attr(TABINDEX, -1);

	            table.attr(TABINDEX, 0);
	        },

	        _tableFocus: function(e) {
	            var current = this.current();
	            var table = $(e.currentTarget);

	            if (current && current.is(":visible")) {
	                current.addClass(classNames.focused);
	            } else {
	                this.current(table.find(FIRSTNAVITEM));
	            }

	            this._setTabIndex(table);
	        },

	        _tableBlur: function() {
	            var current = this.current();

	            if (current) {
	                current.removeClass(classNames.focused);
	            }
	        },

	        _attachEvents: function() {
	            var that = this;
	            var retryButton = DOT + classNames.retry;

	            that._userEvents = new kendo.UserEvents(that.element, {
	                press: proxy(that._onPress, that),
	                allowSelection: true
	            });

	            this.element
	                .on(CLICK + NS, retryButton, this._dataSourceFetchProxy)
	                .on(CLICK + NS, ".k-button[data-command]", proxy(this._commandClick, this))
	                .on(INPUT + NS, ".k-grid-search input", proxy(this._search, this));

	            this._attachCellEditingEventHandlers();
	        },

	        _onPress: function (e) {
	            var that = this;
	            var icons = DOT + classNames.iconCollapse +
	                ", ." + classNames.iconExpand +
	                ", ." + classNames.refresh;

	            if ($(e.event.target).is(icons)) {
	                that._toggleChildren.call(that, e.event);
	            }
	        },

	        _attachCellEditingEventHandlers: function() {
	            var that = this;
	            var editable = that.options.editable;
	            var selectable = that.selectable && that.selectable.options.multiple;
	            var closeCell = function(e) {
	                var target = activeElement();
	                var editor = that.editor || {};
	                var cell = editor.element;

	                if (cell && !$.contains(cell[0], target) && cell[0] !== target && !$(target).closest(".k-animation-container").length) {
	                    if (editor.end()) {
	                        if (!e.relatedTarget && that._isPageable() && !isUndefined(that.dataSource._addChildPageSize)) {
	                            that._preventPageSizeRestore = false;
	                        }

	                        that.closeCell();
	                    }
	                }

	                that._preventPageSizeRestore = false;
	            };

	            if (that._isIncellEditable() && editable.update !== false) {
	                that.wrapper
	                    .on(CLICK + NS, "tr:not(.k-grouping-row) > td", function(e) {
	                        var td = $(this),
	                            isLockedCell = that.lockedTable && td.closest("table")[0] === that.lockedTable[0];

	                        if (td.hasClass(classNames.editCell) ||
	                            td.has("a.k-grid-delete").length ||
	                            td.has("button.k-grid-delete").length ||
	                            (td.closest("tbody")[0] !== that.tbody[0] && !isLockedCell) ||
	                            $(e.target).is(":input") ||
	                            $(e.target).hasClass(classNames.iconExpand) ||
	                            $(e.target).hasClass(classNames.iconCollapse)) {

	                            if (!that.editor) {
	                                that.dataSource._restorePageSizeAfterAddChild();
	                            }

	                            that._preventPageSizeRestore = false;

	                            return;
	                        }

	                        if (that.editor) {
	                            if (that.editor.end()) {
	                                if (selectable) {
	                                    $(activeElement()).blur();
	                                }
	                                that.closeCell();
	                                that.editCell(td);
	                            }
	                        } else {
	                            that.editCell(td);
	                        }
	                    })
	                    .on("mousedown" + NS, "tr:not(.k-grouping-row) > td", function(e) {
	                        // cache the result on "mousedown", which is fired before "focusout" and "click"
	                        if (that.editor && that._isPageable() && !isUndefined(that.dataSource._addChildPageSize)) {
	                            that._preventPageSizeRestore = $(e.target).parents(DOT + classNames.editRow).length > 0;
	                        } else {
	                            that._preventPageSizeRestore = false;
	                        }
	                    })
	                    .on("focusin" + NS, function() {
	                        // fix focus issue in IE
	                        if (!$.contains(this, activeElement())) {
	                            clearTimeout(that._closeCellTimeout);
	                            that._closeCellTimeout = null;
	                        }
	                    })
	                    .on("focusout" + NS, function(e) {
	                        that._closeCellTimeout = setTimeout(function() {
	                            closeCell(e);
	                        }, 1);
	                    });
	            }
	        },

	        _commandByName: function(name) {
	            var columns = this.columns;
	            var toolbar = $.isArray(this.options.toolbar) ? this.options.toolbar : [];
	            var i, j, commands, currentName;

	            name = name.toLowerCase();

	            if (defaultCommands[name]) {
	                return defaultCommands[name];
	            }

	            // command not found in defaultCommands, must be custom
	            for (i = 0; i < columns.length; i++) {
	                commands = columns[i].command;
	                if (commands) {
	                    for (j = 0; j < commands.length; j++) {
	                        currentName = commands[j].name;

	                        if (!currentName) {
	                            continue;
	                        }

	                        if (currentName.toLowerCase() == name) {
	                            return commands[j];
	                        }
	                    }
	                }
	            }

	            // custom command in toolbar
	            for (i = 0; i < toolbar.length; i++) {
	                currentName = toolbar[i].name;

	                if (!currentName) {
	                    continue;
	                }

	                if (currentName.toLowerCase() == name) {
	                    return toolbar[i];
	                }
	            }
	        },

	        _commandClick: function(e) {
	            var button = $(e.currentTarget);
	            var commandName = button.attr("data-command");
	            var command = this._commandByName(commandName);
	            var row = button.parentsUntil(this.wrapper, "tr");

	            row = row.length ? row : undefined;

	            if (command) {
	                if (command.methodName) {
	                    this[command.methodName](row);
	                } else if (command.click) {
	                    command.click.call(this, e);
	                }

	                e.preventDefault();
	            }
	        },

	        _search: function(e) {
	            var that = this;
	            var input = e.currentTarget;
	            clearTimeout(that._searchTimeOut);
	            that._searchTimeOut = setTimeout(function () {
	                that._searchTimeOut = null;
	                var options = that.options;
	                var searchFields = options.search ? options.search.fields : null;
	                var expression = { filters:[], logic:"or" };
	                var value = input.value;

	                if (!searchFields) {
	                    searchFields = getColumnsFields(options.columns);
	                }

	                if (value) {
	                    for (var i = 0; i < searchFields.length; i++) {
	                        expression.filters.push({ field: searchFields[i], operator: "contains", value: value });
	                    }
	                } else {
	                    expression = {};
	                }

	                that.dataSource.filter(expression);

	            }, 300);
	        },

	        _ensureExpandableColumn: function() {
	            if (this._autoExpandable) {
	                delete this._autoExpandable.expandable;
	            }

	            var visibleColumns = grep(this.columns, not(is("hidden")));
	            visibleColumns = grep(visibleColumns, not(is("command")));
	            visibleColumns = grep(visibleColumns, not(is("selectable")));
	            var expandableColumns = grep(visibleColumns, is("expandable"));

	            if (this.columns.length && !expandableColumns.length) {
	                this._autoExpandable = visibleColumns[0];
	                visibleColumns[0].expandable = true;
	            }
	        },

	        _columns: function() {
	            var that = this;
	            var columns = this.options.columns || [];

	            this.columns = map(columns, function(column) {
	                column = (typeof column === "string") ? { field: column } : column;

	                return extend({ encoded: true }, column);
	            });

	            var lockedCols = lockedColumns(columns);
	            if (lockedCols.length > 0) {
	                this._hasLockedColumns = true;
	                this.columns = lockedCols.concat(nonLockedColumns(this.columns));
	            }

	            this.columns = normalizeColumns(this.columns);

	            this._ensureExpandableColumn();

	            this._columnTemplates();
	            this._columnAttributes();

	            if ($.grep(leafColumns(that.columns), function (col) {
	                if (col.selectable) {
	                    that._includeChildren = col.includeChildren;
	                }
	                return col.selectable;
	            }).length) {
	                that._checkBoxSelection = true;
	                that.element.on(CLICK + NS, "tbody > tr " + CHECKBOXINPUT, proxy(that._checkboxClick, that));
	                that.element.on(CLICK + NS, "thead > tr " + CHECKBOXINPUT, proxy(that._headerCheckboxClick, that));
	            }
	        },

	        _columnTemplates: function() {
	            var idx, length, column;
	            var columns = leafColumns(this.columns);

	            for (idx = 0, length = columns.length; idx < length; idx++) {
	                column = columns[idx];
	                if (column.template) {
	                    column.template = kendo.template(column.template);
	                }

	                if (this._isIncellEditable()) {
	                    column.dirtyCellTemplate = this._createDirtyColumnTemplate(column);
	                    column.dirtyIndicatorTemplate = this._createIndicatorTemplate(column);
	                }

	                if (column.headerTemplate) {
	                    column.headerTemplate = kendo.template(column.headerTemplate);
	                }

	                if (column.footerTemplate) {
	                    column.footerTemplate = kendo.template(column.footerTemplate);
	                }
	            }
	        },

	        _columnAttributes: function() {
	            // column style attribute is string, kendo.dom expects object
	            var idx, length;
	            var columns = this.columns;

	            function convertStyle(attr) {
	                var properties, i, declaration;

	                if (attr && attr.style) {
	                    properties = attr.style.split(";");
	                    attr.style = {};

	                    for (i = 0; i < properties.length; i++) {
	                        declaration = properties[i].split(":");

	                        var name = kendo.trim(declaration[0]);

	                        if (name) {
	                            attr.style[$.camelCase(name)] = kendo.trim(declaration[1]);
	                        }
	                    }
	                }
	            }

	            for (idx = 0, length = columns.length; idx < length; idx++) {
	                convertStyle(columns[idx].attributes);
	                convertStyle(columns[idx].headerAttributes);
	            }
	        },

	        _clearSortClasses: function () {
	            var that = this;

	            if (that.content) {
	                that.content.find("col:not(.k-group-col):not(.k-hierarchy-col)").removeClass("k-sorted");
	            }

	            if (that.lockedContent) {
	                that.lockedContent.find("col:not(.k-group-col):not(.k-hierarchy-col)").removeClass("k-sorted");
	            }
	        },

	        _layout: function () {
	            var columns = this.columns;
	            var element = this.element;
	            var layout = "";

	            this.wrapper = element.addClass(classNames.wrapper);

	            layout = "<div class='#= gridHeader #'>";

	            if (this._hasLockedColumns) {
	                layout += "<div class='k-grid-header-locked'>" +
	                                "<table role='grid'>" +
	                                    "<colgroup></colgroup>"+
	                                    "<thead role='rowgroup'></thead>" +
	                                "</table>" +
	                            "</div>";
	            }

	            layout += "<div class='#= gridHeaderWrap #'>" +
	                            "<table role='grid'>" +
	                                "<colgroup></colgroup>"+
	                                "<thead role='rowgroup'></thead>" +
	                            "</table>" +
	                        "</div>"+
	                        "</div>";

	            if (this._hasLockedColumns) {
	                layout += "<div class='k-grid-content-locked'>" +
	                                "<table role='treegrid' tabindex='0'>" +
	                                    "<colgroup></colgroup>"+
	                                    "<tbody></tbody>" +
	                                "</table>" +
	                            "</div>";
	            }

	            layout += "<div class='#= gridContentWrap # k-auto-scrollable'>" +
	                            "<table role='treegrid' tabindex='0'>" +
	                                "<colgroup></colgroup>"+
	                                "<tbody></tbody>" +
	                            "</table>" +
	                        "</div>";

	            if (!this.options.scrollable) {
	                layout =
	                    "<table role='treegrid' tabindex='0'>" +
	                        "<colgroup></colgroup>"+
	                        "<thead class='#= gridHeader #' role='rowgroup'></thead>" +
	                        "<tbody></tbody>" +
	                    "</table>";
	            }

	            if (this.options.toolbar) {
	                layout = "<div class='#= header # #= gridToolbar #'></div>" + layout;
	            }

	            element.append(
	                kendo.template(layout)(classNames) +
	                "<div class='k-status'></div>"
	            );

	            this.toolbar = element.find(DOT + classNames.gridToolbar);

	            var header = element.find(DOT + classNames.gridHeader).find("thead").addBack().filter("thead");
	            this.thead = header.last();

	            if (this.options.scrollable) {
	                var rtl = kendo.support.isRtl(element);

	                element.find("div." + classNames.gridHeader)
	                    .css(rtl ? "padding-left" : "padding-right", kendo.support.scrollbar());
	            }


	            var content = element.find(DOT + classNames.gridContentWrap);
	            if (!content.length) {
	                content = element;
	            } else {
	                this.content = content;
	            }

	            this.table = content.find(">table");
	            this.tbody = this.table.find(">tbody");

	            if (this._hasLockedColumns) {
	                this.lockedHeader = header.first().closest(".k-grid-header-locked");
	                this.lockedContent = element.find(".k-grid-content-locked");
	                this.lockedTable = this.lockedContent.children();
	            }

	            this._initVirtualTrees();

	            this._renderCols();
	            this._renderHeader();

	            this.angular("compile", function() {
	                return {
	                    elements: header.find("th.k-header").get(),
	                    data: map(columns, function(col) { return { column: col }; })
	                };
	            });
	        },

	        _initVirtualTrees: function() {
	            this._headerColsTree = new kendoDom.Tree(this.thead.prev()[0]);
	            this._contentColsTree = new kendoDom.Tree(this.tbody.prev()[0]);
	            this._headerTree = new kendoDom.Tree(this.thead[0]);
	            this._contentTree = new kendoDom.Tree(this.tbody[0]);
	            this._statusTree = new kendoDom.Tree(this.element.children(".k-status")[0]);

	            if (this.lockedHeader){
	                this._lockedHeaderColsTree = new kendoDom.Tree(this.lockedHeader.find("colgroup")[0]);
	                this._lockedContentColsTree = new kendoDom.Tree(this.lockedTable.find(">colgroup")[0]);
	                this._lockedHeaderTree = new kendoDom.Tree(this.lockedHeader.find("thead")[0]);
	                this._lockedContentTree = new kendoDom.Tree(this.lockedTable.find(">tbody")[0]);
	            }
	        },

	        _toolbar: function() {
	            var options = this.options.toolbar;
	            var toolbar = this.toolbar;

	            if (!options) {
	                return;
	            }

	            if ($.isArray(options)) {
	                var buttons = this._buildCommands(options);
	                new kendoDom.Tree(toolbar[0]).render(buttons);
	            } else {
	                toolbar.append(kendo.template(options)({}));
	            }

	            this.angular("compile", function() {
	                return { elements: toolbar.get() };
	            });
	        },

	        _lockedColumns: function() {
	            return grep(this.columns, is("locked"));
	        },

	        _nonLockedColumns: function() {
	            return grep(this.columns, not(is("locked")));
	        },

	        _templateColumns: function() {
	            return grep(this.columns, is("template"));
	        },

	        _flushCache: function() {
	            if (this.options.$angular && this._templateColumns().length) {
	                this._contentTree.render([]);
	                if (this._hasLockedColumns) {
	                    this._lockedContentTree.render([]);
	                }
	            }
	        },

	        _render: function(options) {
	            var that = this;
	            options = options || {};
	            options = that._renderOptions(options);
	            var messages = this.options.messages;
	            var pageable = that._isPageable();
	            var dataSource = that.dataSource;

	            var maps = { children: (options.filteredChildrenMap || options.childrenMap), ids: options.idsMap };
	            var dataMaps = pageable ? (maps && maps.children && maps.ids ? maps : dataSource._initDataMaps(dataSource._getData())) : {};
	            var childrenMap = dataMaps.children;
	            var idsMap = dataMaps.ids;
	            options.childrenMap = childrenMap;
	            options.idsMap = idsMap;

	            var data = that._dataToRender(options);
	            var level = that._renderedModelLevel(data[0], options);
	            var uidAttr = kendo.attr("uid");
	            var hasFooterTemplate;
	            var selected = this.select().removeClass("k-state-selected").map(function(_, row) {
	                return $(row).attr(uidAttr);
	            });
	            var viewChildrenMap;

	            this._absoluteIndex = 0;

	            this._angularItems("cleanup");
	            this._angularFooters("cleanup");
	            this._flushCache();

	            that._clearRenderMap();

	            if (options.error) {
	                // root-level error message
	                this._showStatus(kendo.template(
	                    "#: messages.requestFailed # " +
	                    "<button class='#= buttonClass #'>#: messages.retry #</button>"
	                )({
	                    buttonClass: [classNames.button, classNames.retry].join(" "),
	                    messages: messages
	                }));
	            } else if (!data.length) {
	                // no rows message
	                this._hideStatus();
	                this._showNoRecordsTemplate();
	            } else {
	                if (pageable) {
	                    viewChildrenMap = that._viewChildrenMap(options);
	                }

	                // render rows
	                this._hideStatus();

	                hasFooterTemplate = this._hasFooterTemplate();

	                this._contentTree.render(this._trs({
	                    columns: leafColumns(nonLockedColumns(this.columns)),
	                    editedColumn: options.editedColumn,
	                    editedColumnIndex: options.editedColumnIndex,
	                    aggregates: options.aggregates,
	                    selected: selected,
	                    data: data,
	                    childrenMap: childrenMap,
	                    viewChildrenMap: viewChildrenMap,
	                    hasFooterTemplate: hasFooterTemplate,
	                    visible: true,
	                    level: 0
	                }));

	                if (this._hasLockedColumns) {
	                    this._absoluteIndex = 0;
	                    this._lockedContentTree.render(this._trs({
	                        columns: leafColumns(lockedColumns(this.columns)),
	                        editedColumn: options.editedColumn,
	                        editedColumnIndex: options.editedColumnIndex,
	                        aggregates: options.aggregates,
	                        selected: selected,
	                        data: data,
	                        childrenMap: childrenMap,
	                        viewChildrenMap: viewChildrenMap,
	                        hasFooterTemplate: hasFooterTemplate,
	                        visible: true,
	                        level: level
	                    }));
	                }
	            }

	            if (this._touchScroller) {
	                this._touchScroller.contentResized();
	            }

	            this._muteAngularRebind(function() {
	                this._angularItems("compile");
	                this._angularFooters("compile");
	            });

	            this.items().filter(function() {
	                return $.inArray($(this).attr(uidAttr), selected) >= 0;
	            })
	            .addClass("k-state-selected");

	            this._syncLockedContentHeight();

	            that._togglePagerVisibility();

	            that._setExpanderElement();
	        },

	        _setExpanderElement: function() {
	            var that = this,
	                hiddenDivClass = 'k-grid-content-expander',
	                hiddenDiv = '<div class="' + hiddenDivClass + '"></div>',
	                expander;

	            if (that.options.scrollable && that.wrapper.is(":visible")) {
	                expander = that.table.parent().children('.' + hiddenDivClass);
	                if (!that.dataSource || !that.dataSource.view().length) {
	                    if (!expander[0]) {
	                        expander = $(hiddenDiv).appendTo(that.table.parent());
	                    }
	                    if (that.thead) {
	                        expander.width(that.thead.width());
	                    }
	                } else if (expander[0]) {
	                    expander.remove();
	                }
	            }
	        },

	        _renderProgress: function(toggle) {
	            kendo.ui.progress(this.wrapper, toggle);
	        },

	        _renderOptions: function(options) {
	            options = options || {};
	            var that = this;
	            var dataMaps = that.dataSource._getDataMaps();
	            var filter = that.dataSource.filter();

	            if (that._isPageable()) {
	                options.childrenMap = dataMaps.children;
	                options.idsMap = dataMaps.ids;

	                if (filter) {
	                    options.filteredChildrenMap = dataMaps.filteredChildren;
	                }
	            }

	            return options;
	        },

	        _renderedModelLevel: function(model, options) {
	            return !this._isPageable() ? 0 : this.dataSource._pageableModelLevel(model, options);
	        },

	        _viewChildrenMap: function(options) {
	            options = options || {};
	            var that = this;
	            var dataSource = that.dataSource;
	            var viewChildrenMap = dataSource.childrenMap(dataSource.view());
	            var idField = dataSource._modelIdField();
	            var parentsNotInView = dataSource._parentNodesNotInView();
	            var parentNotInView;
	            var parentNotInViewId;
	            var parents;
	            var parent;
	            var parentId;
	            var child;
	            var childId;
	            var parentsCopy;

	            that._clearRenderMap();

	            for (var i = 0; i < parentsNotInView.length; i++) {
	                parentNotInView = parentsNotInView[i];
	                parentNotInViewId = parentNotInView[idField];

	                that._markNodeAsNonRenderable(parentNotInViewId);

	                viewChildrenMap[parentNotInViewId] = viewChildrenMap[parentNotInViewId] || [];

	                parents = dataSource._parentNodes(parentNotInView);

	                // copy the items to avoid mutating the original collection
	                parentsCopy = parents.slice();
	                parentsCopy.push(parentNotInView);

	                for (var parentIndex = 0; parentIndex < parentsCopy.length - 1; parentIndex++) {
	                    parent = parentsCopy[parentIndex];
	                    parentId = parent[idField];
	                    that._markNodeAsNonRenderable(parentId);
	                    viewChildrenMap[parentId] = viewChildrenMap[parentId] || [];

	                    child = parentsCopy[parentIndex + 1];
	                    childId = child[idField];
	                    that._markNodeAsNonRenderable(childId);
	                    viewChildrenMap[childId] = viewChildrenMap[childId] || [];

	                    if (viewChildrenMap[parentId].indexOf(child) === -1) {
	                        viewChildrenMap[parentId].unshift(child);
	                    }
	                }
	            }

	            return viewChildrenMap;
	        },

	        _clearRenderMap: function() {
	            this._skipRenderingMap = {};
	        },

	        _dataToRender: function(options) {
	            var that = this;

	            if (that._isPageable()) {
	                return that.dataSource._pageableRootNodes(options);
	            }

	            return that.dataSource.rootNodes();
	        },

	        _markNodeAsNonRenderable: function(nodeId) {
	            this._skipRenderingMap[nodeId] = true;
	        },

	        _adjustRowsHeight: function(table1, table2) {
	            if (!this._hasLockedColumns) {
	                return;
	            }

	            var rows = table1[0].rows;
	            var length = rows.length;
	            var idx;
	            var rows2 = table2[0].rows;
	            var containers = table1.add(table2);
	            var containersLength = containers.length;
	            var heights = [];

	            for (idx = 0; idx < length; idx++) {
	                if (!rows2[idx]) {
	                    break;
	                }

	                if (rows[idx].style.height) {
	                    rows[idx].style.height = rows2[idx].style.height = "";
	                }
	            }

	            for (idx = 0; idx < length; idx++) {
	                if (!rows2[idx]) {
	                    break;
	                }

	                var offsetHeight1 = rows[idx].offsetHeight;
	                var offsetHeight2 = rows2[idx].offsetHeight;
	                var height = 0;

	                if (offsetHeight1 > offsetHeight2) {
	                    height = offsetHeight1;
	                } else if (offsetHeight1 < offsetHeight2) {
	                    height = offsetHeight2;
	                }

	                heights.push(height);
	            }

	            for (idx = 0; idx < containersLength; idx++) {
	                containers[idx].style.display = "none";
	            }

	            for (idx = 0; idx < length; idx++) {
	                if (heights[idx]) {
	                    //add one to resolve row misalignment in IE
	                    rows[idx].style.height = rows2[idx].style.height = (heights[idx] + 1) + "px";
	                }
	            }

	            for (idx = 0; idx < containersLength; idx++) {
	                containers[idx].style.display = "";
	            }
	        },

	        _ths: function(columns, rowSpan) {
	            var ths = [];
	            var column, title, children, cellClasses, attr, headerContent;
	            var index;
	            var leafs;

	            for (var i = 0, length = columns.length; i < length; i++) {
	                column = columns[i];
	                children = [];
	                cellClasses = [classNames.header];

	                if (column.selectable) {
	                    leafs = leafColumns(columns);
	                    index = inArray(column, leafs);
	                    attr = {
	                        scope: "col",
	                        role: "columnheader",
	                        className: cellClasses.join(" ")
	                    };

	                    if (column.headerTemplate) {
	                        title = column.headerTemplate({});
	                    }

	                    title = column.headerTemplate ? title: kendo.template(SELECTCOLUMNHEADERTMPL)({});


	                    if (rowSpan && !column.colSpan) {
	                        attr.rowSpan = rowSpan;
	                    }

	                    if (index > -1) {
	                        attr[kendo.attr("index")] = index;
	                    }

	                    children.push(kendoHtmlElement(title));

	                    ths.push(kendoDomElement("th", $.extend(true, {}, attr, column.headerAttributes), children));
	                    continue;
	                }

	                if (column.headerTemplate) {
	                    title = column.headerTemplate({});
	                } else {
	                    title = column.title || column.field || "";
	                }

	                if (column.headerTemplate) {
	                    headerContent = kendoHtmlElement(title);
	                } else {
	                    headerContent = kendoTextElement(title);
	                }

	                if (column.sortable) {
	                    children.push(kendoDomElement("a", { href: "#", className: classNames.link }, [
	                        headerContent
	                    ]));
	                } else {
	                    children.push(headerContent);
	                }

	                attr = {
	                    "data-field": column.field,
	                    "data-title": column.title,
	                    "style": column.hidden === true ? { "display": "none" } : {},
	                    className: cellClasses.join(" "),
	                    "role": "columnheader"
	                };

	                if (!column.columns) {
	                    attr.rowSpan = rowSpan ? rowSpan : 1;
	                }

	                if (column.headerAttributes) {
	                    if (column.headerAttributes.colSpan === 1) {
	                        delete column.headerAttributes.colSpan;
	                    }
	                    if (column.headerAttributes["class"]) {
	                        attr.className += " " + column.headerAttributes["class"];
	                        delete column.headerAttributes["class"];
	                    }
	                }

	                if (column["data-index"] > -1) {
	                    attr["data-index"] = column["data-index"];
	                }

	                attr = extend(true, {}, attr, column.headerAttributes);

	                ths.push(kendoDomElement("th", attr, children));
	            }

	            return ths;
	        },

	        _cols: function(columns) {
	            var cols = [];
	            var width, attr;

	            for (var i = 0; i < columns.length; i++) {
	                if (columns[i].hidden === true) {
	                    continue;
	                }

	                width = columns[i].width;
	                attr = {};

	                if (width && parseInt(width, 10) !== 0) {
	                    attr.style = {
	                        width: typeof width === "string" ? width : width + "px"
	                    };
	                }

	                cols.push(kendoDomElement("col", attr));
	            }

	            return cols;
	        },

	        _clearColsCache: function () {
	            this._headerColsTree.render([]);
	            if (this.options.scrollable) {
	                this._contentColsTree.render([]);
	            }
	            if (this._hasLockedColumns) {
	                this._lockedHeaderColsTree.render([]);
	                this._lockedContentColsTree.render([]);
	            }
	        },

	        _renderCols: function() {
	            var columns = nonLockedColumns(this.columns);
	            this._headerColsTree.render(this._cols(leafColumns(columns)));

	            if (this.options.scrollable) {
	                this._contentColsTree.render(this._cols(leafColumns(columns)));
	            }

	            if (this._hasLockedColumns) {
	                columns = lockedColumns(this.columns);
	                this._lockedHeaderColsTree.render(this._cols(leafColumns(columns)));
	                this._lockedContentColsTree.render(this._cols(leafColumns(columns)));
	            }
	        },

	        _retrieveFirstColumn: function(columns, rows) {
	            var result = $();

	            if (rows.length && columns[0]) {
	                var column = columns[0];

	                while(column.columns && column.columns.length) {
	                    column = column.columns[0];
	                    rows = rows.filter(":not(:first())");
	                }

	                result = result.add(rows);
	            }

	            return result;
	        },

	        _updateFirstColumnClass: function() {
	            var that = this;
	            var columns = that.columns || [];
	            var tr = that.thead.find(">tr:not(:first)");
	            var rows;

	            columns = nonLockedColumns(columns);

	            rows = that._retrieveFirstColumn(columns, tr);

	            if (that.lockedHeader) {
	                tr = that.lockedHeader.find("thead>tr:not(.k-filter-row):not(:first)");
	                columns = lockedColumns(that.columns);

	                rows = rows.add(that._retrieveFirstColumn(columns, tr));
	            }

	            rows.each(function() {
	                var ths = $(this).find("th");
	                ths.removeClass("k-first");
	                ths.eq(0).addClass("k-first");
	            });
	        },

	        _updateRowSpans: function(rows) {
	            for (var i = rows.length - 1; i >= 0; i--) {
	                var included = visibleChildColumns(rows[i].cells).length > 0;

	                if (included) {
	                    rows[i].rowSpan = rows.length - i;
	                }
	            }
	        },

	        _setColumnDataIndexes: function(columns) {
	            for (var i = 0; i < columns.length; i++) {
	               columns[i]["data-index"] = i;
	            }
	        },

	        _updateColumnCellIndex: function() {
	            var header;
	            var offset = 0;

	            if (this.lockedHeader) {
	                header = this.lockedHeader.find("thead");
	                offset = updateCellIndex(header, lockedColumns(this.columns));
	            }
	            updateCellIndex(this.thead, nonLockedColumns(this.columns), offset);
	        },

	        _setParentsVisibility: function(column, visible) {
	            var columns = this.columns;
	            var idx;
	            var parents = [];
	            var parent;

	            var predicate = visible ?
	                function(p) { return visibleColumns(p.columns).length && p.hidden; } :
	                function(p) { return !visibleColumns(p.columns).length && !p.hidden; };


	            if (columnParents(column, columns, parents) && parents.length) {
	                for (idx = parents.length - 1; idx >= 0; idx--) {
	                    parent = parents[idx];

	                    if (predicate(parent)) {
	                        parent.hidden = !visible;
	                    }
	                }
	            }
	        },

	        _prepareColumns: function(rows, columns, parentCell, parentRow, parentColumn) {
	            var row = parentRow || rows[rows.length - 1];

	            var childRow = rows[row.index + 1];
	            var totalColSpan = 0;

	            for (var idx = 0; idx < columns.length; idx++) {
	                var cell = $.extend({}, columns[idx],  { headerAttributes: columns[idx].headerAttributes || {} } );
	                row.cells.push(cell);

	                if (columns[idx].columns && columns[idx].columns.length) {
	                    if (!childRow) {
	                        childRow = { rowSpan: 0, cells: [], index: rows.length };
	                        rows.push(childRow);
	                    }
	                    if (columns[idx].columns.length) {
	                        cell.headerAttributes.colSpan = visibleChildColumns(columns[idx].columns).length || 1;
	                        cell.headerAttributes["data-colspan"] = leafColumns(columns[idx].columns).length;
	                    }
	                    this._prepareColumns(rows, columns[idx].columns, cell, childRow, columns[idx]);
	                    if (!cell.hidden) {
	                        totalColSpan += cell.headerAttributes.colSpan - 1;
	                    }
	                    row.rowSpan = rows.length - row.index;
	                }
	                columns[idx].rowIndex = row.index;
	                if (parentColumn) {
	                    columns[idx].parentColumn = parentColumn;
	                }
	                columns[idx].cellIndex = row.cells.length - 1;
	            }
	            if (parentCell) {
	                parentCell.headerAttributes.colSpan += totalColSpan;
	            }
	        },

	        _renderHeaderTree: function(tree, columns, hasMultiColumnHeaders) {
	            var idx;
	            var rows = [];
	            var rowsToRender = [];

	            if (hasMultiColumnHeaders) {
	                rows = [{ rowSpan: 1, cells: [], index: 0 }];
	                this._prepareColumns(rows, columns);
	                this._updateRowSpans(rows);
	                for (idx = 0; idx< rows.length; idx++) {
	                    rowsToRender.push(kendoDomElement("tr", { "role": "row" }, this._ths(rows[idx].cells, rows[idx].rowSpan)));
	                }
	                tree.render(rowsToRender);
	            } else {
	                tree.render([kendoDomElement("tr", { "role": "row" }, this._ths(columns))]);
	            }
	        },

	        _renderHeader: function() {
	            var columns = nonLockedColumns(this.columns);
	            var hasMultiColumnHeaders = grep(this.columns, function(item) {
	                return item.columns !== undefined;
	            }).length > 0;
	            this._setColumnDataIndexes(leafColumns(this.columns));
	            this._renderHeaderTree(this._headerTree, columns, hasMultiColumnHeaders);

	            if (this._hasLockedColumns) {
	                columns = lockedColumns(this.columns);
	                this._renderHeaderTree(this._lockedHeaderTree, columns, hasMultiColumnHeaders);

	                this._applyLockedContainersWidth();
	                this._syncLockedHeaderHeight();
	            }
	            this._updateFirstColumnClass();
	        },

	        _applyLockedContainersWidth: function() {
	            if (!this._hasLockedColumns) {
	                return;
	            }

	            var lockedWidth = columnsWidth(this.lockedHeader.find(">table>colgroup>col"));

	            var headerTable = this.thead.parent();
	            var nonLockedWidth = columnsWidth(headerTable.find(">colgroup>col"));

	            var wrapperWidth = this.wrapper[0].clientWidth;
	            var scrollbar = kendo.support.scrollbar();

	            if (lockedWidth >= wrapperWidth) {
	                lockedWidth = wrapperWidth - 3 * scrollbar;
	            }

	            this.lockedHeader
	                .add(this.lockedContent)
	                .width(lockedWidth);

	            headerTable.add(this.table).width(nonLockedWidth);

	            var width = wrapperWidth - lockedWidth;
	            this.content.width(width - 1);
	            headerTable.parent().width(width - scrollbar - 2);
	        },

	        _trs: function(options) {
	            var that = this;
	            var model, attr, className, hasChildren, childNodes, i, length;
	            var modelId;
	            var rows = [];
	            var level = options.level;
	            var data = options.data;
	            var dataSource = this.dataSource;
	            var aggregates = dataSource.aggregates() || {};
	            var idField = dataSource._modelIdField();
	            var parentIdField = dataSource._modelParentIdField();
	            var columns = options.columns;
	            var pageable = that._isPageable();
	            var childrenMap = options.childrenMap || dataSource.childrenMap(dataSource._getData());

	            for (i = 0, length = data.length; i < length; i++) {
	                className = [];

	                model = data[i];
	                modelId = model[idField];

	                childNodes = pageable ? childrenMap[modelId] : (model.loaded() ? dataSource.childNodes(model) : []);
	                hasChildren = childNodes && childNodes.length;

	                attr = { "role": "row" };

	                attr[kendo.attr("uid")] = model.uid;

	                if (hasChildren) {
	                    attr["aria-expanded"] = !!model.expanded;
	                }

	                if (options.visible) {
	                    if (!pageable || (pageable && !that._skipRenderingMap[modelId])) {
	                        if (this._absoluteIndex % 2 !== 0) {
	                            className.push(classNames.alt);
	                        }

	                        this._absoluteIndex++;
	                    }
	                } else {
	                    attr.style = { display: "none" };
	                }

	                if ($.inArray(model.uid, options.selected) >= 0) {
	                    className.push(classNames.selected);
	                }

	                if (hasChildren) {
	                    className.push(classNames.group);
	                }

	                if (model._edit) {
	                    className.push("k-grid-edit-row");
	                }

	                attr.className = className.join(" ");

	                if (!that._skipRenderingMap[modelId]) {
	                    var row = this._tds({
	                        model: model,
	                        attr: attr,
	                        level: pageable ? that._renderedModelLevel(model, options) : level,
	                        editedColumn: options.editedColumn,
	                        editedColumnIndex: options.editedColumnIndex
	                    }, columns, proxy(this._td, this));

	                    rows.push(row);
	                }


	                if (hasChildren && (that.options.renderAllRows || !!model.expanded)) {
	                    if (pageable) {
	                        // render the child nodes in the paged view only
	                        childNodes = (options.viewChildrenMap || {})[modelId] || [];
	                    }

	                    if (childNodes.length === 0) {
	                        continue;
	                    }

	                    rows = rows.concat(this._trs({
	                        columns: columns,
	                        editedColumn: options.editedColumn,
	                        editedColumnIndex: options.editedColumnIndex,
	                        aggregates: aggregates,
	                        selected: options.selected,
	                        visible: pageable ? options.visible : (options.visible && !!model.expanded),
	                        data: childNodes,
	                        childrenMap: options.childrenMap || childrenMap,
	                        hasFooterTemplate: options.hasFooterTemplate,
	                        viewChildrenMap: options.viewChildrenMap,
	                        level: level + 1
	                    }));
	                }
	            }

	            if (options.hasFooterTemplate && model) {
	                attr = {
	                    className: classNames.footerTemplate,
	                    "data-parentId": model[parentIdField]
	                };

	                if (!options.visible) {
	                    attr.style = { display: "none" };
	                }

	                rows.push(this._tds({
	                    model: aggregates[model[parentIdField]],
	                    attr: attr,
	                    level: level,
	                    editedColumn: options.editedColumn,
	                    editedColumnIndex: options.editedColumnIndex
	                }, columns, this._footerId));
	            }

	            return rows;
	        },

	        _footerId: function(options) {
	            var content = [];
	            var column = options.column;
	            var template = options.column.footerTemplate || $.noop;
	            var aggregates = options.model[column.field] || {};
	            var attr = {
	                "role": "gridcell",
	                "style": column.hidden === true ? { "display": "none" } : {}
	            };

	            if (column.expandable) {
	                content = content.concat(createPlaceholders({

	                    level: options.level + 1,
	                    className: classNames.iconPlaceHolder
	                }));
	            }

	            if (column.attributes) {
	                extend(true, attr, column.attributes, {
	                    "style": column.hidden === true ? { "display": "none" } : {}
	                });
	            }

	            content.push(kendoHtmlElement(template(aggregates) || ""));

	            return kendoDomElement("td", attr, content);
	        },

	        _hasFooterTemplate: function() {
	            return !!grep(leafColumns(this.columns), function(c) {
	                return c.footerTemplate;
	            }).length;
	        },

	        _tds: function(options, columns, renderer) {
	            var children = [];
	            var column;
	            var editedColumnField = (options.editedColumn || {}).field;
	            var incellEditing = this._isIncellEditable();
	            var length = columns.length;

	            for (var i = 0; i < length; i++) {
	                column = columns[i];

	                var col = renderer({
	                    model: options.model,
	                    column: column,
	                    editColumn: !incellEditing || (incellEditing && column.field === editedColumnField && options.editedColumnIndex === i),
	                    level: options.level
	                });

	                children.push(col);
	            }

	            return kendoDomElement("tr", options.attr, children);
	        },

	        _td: function(options) {
	            var children = [];
	            var model = options.model;
	            var column = options.column;
	            var iconClass;
	            var attr = {
	                "role": "gridcell",
	                "style": column.hidden === true ? { "display": "none" } : {}
	            };
	            var incellEditing = this._isIncellEditable();
	            var columnHasEditCommand = false;

	            if (column.attributes) {
	                extend(true, attr, column.attributes);
	            }

	            if (this.options.navigatable) {
	                attr["aria-describedby"] = column.headerAttributes.id;
	            }

	            if (model._edit && column.field && options.editColumn && (incellEditing || (!incellEditing && isColumnEditable(column, model)))) {
	                attr[kendo.attr("container-for")] = column.field;

	                if (incellEditing) {
	                    if (attr.className && attr.className.indexOf(classNames.editCell) !== -1) {
	                        attr.className += " " + classNames.editCell;
	                    } else if (!attr.className) {
	                        attr.className = classNames.editCell;
	                    }
	                }
	            } else {
	                if (column.expandable) {
	                    children = createPlaceholders({ level: options.level, className: classNames.iconPlaceHolder });
	                    iconClass = [classNames.icon];

	                    if (model.hasChildren) {
	                        iconClass.push(model.expanded ? classNames.iconCollapse : classNames.iconExpand);
	                    } else {
	                        iconClass.push(classNames.iconHidden);
	                    }

	                    if (model._error) {
	                        iconClass.push(classNames.refresh);
	                    } else if (!model.loaded() && model.expanded) {
	                        iconClass.push(classNames.loading);
	                    }

	                    children.push(kendoDomElement("span", { className: iconClass.join(" ") }));

	                    attr.style["white-space"] = "nowrap";
	                }

	                if (isDirtyColumn(column, model)) {
	                    if (attr.className) {
	                        attr.className += classNames.dirtyCell;
	                    } else if (!attr.className) {
	                        attr.className = classNames.dirtyCell;
	                    }
	                }

	                if (column.command) {
	                    if (attr.className && attr.className.indexOf("k-command-cell") !== -1 ) {
	                        attr.className += " k-command-cell";
	                    } else if (!attr.className) {
	                        attr.className = "k-command-cell";
	                    }

	                    columnHasEditCommand = grep(column.command, function(command) {
	                        return command === EDIT || command.name === EDIT;
	                    }).length > 0;

	                    if (model._edit && !this._isIncellEditable() && columnHasEditCommand) {
	                        children = this._buildCommands(["update", "canceledit"]);
	                    } else {
	                        children = this._buildCommands(column.command);
	                    }
	                } else  {
	                    children.push(this._cellContent(column, model));
	                }

	                if (attr["class"]) {
	                    attr.className = attr["class"] + " " + attr.className;
	                }
	            }

	            return kendoDomElement("td", attr, children);
	        },

	        _cellContent: function(column, model) {
	            var that = this;
	            var value;
	            var incellEditing = that._isIncellEditable();
	            var dirtyIndicator;

	            if (column.selectable) {
	                return kendoHtmlElement(SELECTCOLUMNTMPL);
	            }

	            if (column.template) {
	                value = that._evalColumnTemplate(column, model);
	            } else if (column.field) {
	                value = model.get(column.field);
	                dirtyIndicator = incellEditing ? column.dirtyIndicatorTemplate(model) : "";
	                if (value !== null && !isUndefined(value)) {
	                    if (column.format) {
	                        value = kendo.format(column.format, value);
	                    }

	                    value = dirtyIndicator + value;
	                } else {
	                    value = dirtyIndicator;
	                }
	            } else if (value === null || isUndefined(value)) {
	                value = "";
	            }

	            if (column.template || !column.encoded) {
	                return kendoHtmlElement(value);
	            } else {
	                if (incellEditing) {
	                    return kendoHtmlElement(value);
	                } else {
	                    return kendoTextElement(value);
	                }
	            }
	        },

	        _evalColumnTemplate: function(column, model) {
	            if (this._isIncellEditable()) {
	                return column.dirtyCellTemplate(model);
	            } else {
	                return column.template(model);
	            }
	        },

	        _createDirtyColumnTemplate: function(column) {
	            var that = this;
	            var templateSettings = that._customTemplateSettings();
	            var columnTemplateAlias = "#=this.columnTemplate(" + templateSettings.paramName + ")#";

	            var templateString = that._dirtyIndicatorTemplate(column.field) + columnTemplateAlias;
	            var templateFunction = proxy(kendoTemplate(templateString, templateSettings), { columnTemplate: column.template });

	            return templateFunction;
	        },

	        _createIndicatorTemplate: function(column) {
	            var dirtyIndicatorTemplate = this._dirtyIndicatorTemplate(column.field);

	            return kendoTemplate(dirtyIndicatorTemplate);
	        },

	        _dirtyIndicatorTemplate: function(field) {
	            var that = this;
	            var dirtyField;
	            var templateSettings = that._customTemplateSettings();
	            var paramName = templateSettings.paramName;

	            if (field && paramName) {
	                dirtyField = field.charAt(0) === "[" ? kendo.expr(field, paramName + ".dirtyFields") : paramName + ".dirtyFields['" + field + "']";

	                return "#= " + paramName + " && " + paramName + ".dirty && " + paramName + ".dirtyFields && " + dirtyField +
	                        " ? '<span class=\"k-dirty\"></span>' : '' #";
	            }

	            return "";
	        },

	        _customTemplateSettings: function() {
	            return extend({}, kendo.Template, this.options.templateSettings);
	        },

	        _buildCommands: function(commands) {
	            var i, result = [];

	            for (i = 0; i < commands.length; i++) {
	                result.push(this._handleCommand(commands[i]));
	            }

	            return result;
	        },

	        _handleCommand: function(command) {
	            var name = (command.name || command).toLowerCase();
	            var text = this.options.messages.commands[name];
	            var icon = [];

	            command = extend({}, defaultCommands[name], { text: text }, command);

	            if (command.imageClass) {
	                icon.push(kendoDomElement("span", {
	                    className: [ "k-icon", command.imageClass ].join(" ")
	                }));
	            }

	            if(command.template) {
	                return kendoHtmlElement(kendo.template(command.template)({ message: command.text || this.options.messages.commands.search }));
	            } else {
	                return this._button(command, name, icon);
	            }
	        },

	        _button: function(command, name, icon) {

	            return kendoDomElement(
	                "button", {
	                    "type": "button",
	                    "data-command": name,
	                    className: [ "k-button", "k-button-icontext", command.className ].join(" ")
	                }, icon.concat([ kendoTextElement(command.text || command.name) ])
	            );
	        },

	        _positionResizeHandle: function(e) {
	            var th = $(e.currentTarget);
	            var resizeHandle = this.resizeHandle;
	            var position = th.position();
	            var left;
	            var rtlCorrection = 0;
	            var headerWrap;
	            var ieCorrection;
	            var webkitCorrection;
	            var firefoxCorrection;
	            var leftMargin;
	            var invisibleSpace;
	            var leftBorderWidth;
	            var scrollLeft;
	            var cellWidth = outerWidth(th);
	            var container = th.closest("div");
	            var button = typeof e.buttons !== "undefined" ? e.buttons : (e.which || e.button);
	            var indicatorWidth = this.options.columnResizeHandleWidth || 3;
	            var halfResizeHandle = (indicatorWidth * 3) / 2;

	            left = cellWidth;

	            if (typeof button !== "undefined" && button !== 0) {
	                //do not create a new resize handle if a mouse button is still pressed
	                //this happens during resizing or before UserEvents trigger "start"
	                return;
	            }

	            if (!resizeHandle) {
	                resizeHandle = this.resizeHandle = $(
	                    '<div class="k-resize-handle"><div class="k-resize-handle-inner"></div></div>'
	                );
	            }

	            var cells = leafDataCells(th.closest("thead")).filter(":visible");
	            if (isRtl) {
	                scrollLeft = kendo.scrollLeft(container);

	                if (browser.mozilla || (browser.webkit && browser.version >= 85)) {
	                    scrollLeft = scrollLeft * -1;
	                }
	                leftBorderWidth = parseFloat(container.css("borderLeftWidth"));
	                left = th.offset().left + scrollLeft - parseFloat(th.css("marginLeft")) - (container.offset().left + leftBorderWidth);
	                rtlCorrection = (left <= scrollLeft ? halfResizeHandle : 0);// when shown on first column headers are misaligned due to the width of the resize handler
	                headerWrap = th.closest(".k-grid-header-wrap, .k-grid-header-locked");
	                invisibleSpace = headerWrap[0].scrollWidth - headerWrap[0].offsetWidth; // the difference between the entire width and the visible area
	                leftMargin = parseFloat(headerWrap.css("marginLeft"));
	                ieCorrection = browser.msie ? 2*kendo.scrollLeft(headerWrap) + leftBorderWidth - leftMargin - rtlCorrection: 0;
	                webkitCorrection = browser.webkit && (browser.version < 85) ? (invisibleSpace - rtlCorrection - leftMargin + leftBorderWidth) : -rtlCorrection; //margin left is added due to a margin that avoids double borders
	                firefoxCorrection = browser.mozilla ? leftBorderWidth - leftMargin - rtlCorrection : 0;
	                left -= webkitCorrection + firefoxCorrection + ieCorrection;
	            } else {
	                for (var idx = 0; idx < cells.length; idx++) {
	                    if (cells[idx] == th[0]) {
	                        break;
	                    }
	                    left += cells[idx].offsetWidth;
	                }
	            }

	            container.append(resizeHandle);

	            resizeHandle
	                .show()
	                .css({
	                    top: position.top,
	                    left: left - halfResizeHandle,
	                    height: outerHeight(th),
	                    width: indicatorWidth * 3
	                })
	                .data("th", th);

	            var that = this;
	            resizeHandle.off("dblclick" + NS).on("dblclick" + NS, function () {
	                //TODO handle frozen columns index
	                var index= th.index();
	                if ($.contains(that.thead[0], th[0])) {
	                    index += grep(that.columns, function (val) { return val.locked && !val.hidden; }).length;
	                }
	                that.autoFitColumn(index);
	            });
	        },

	        autoFitColumn: function (column) {
	            var that = this,
	                options = that.options,
	                columns = that.columns,
	                index,
	                browser = kendo.support.browser,
	                th,
	                headerTable,
	                isLocked,
	                visibleLocked = that.lockedHeader ? leafDataCells(that.lockedHeader.find(">table>thead")).filter(isCellVisible).length : 0,
	                col;

	            //  retrieve the column object, depending on the method argument
	            if (typeof column == "number") {
	                column = columns[column];
	            } else if (isPlainObject(column)) {
	                column = grep(columns, function (item) {
	                    return item === column;
	                })[0];
	            } else {
	                column = grep(columns, function (item) {
	                    return item.field === column;
	                })[0];
	            }

	            if (!column || column.hidden) {
	                return;
	            }

	            index = inArray(column, columns);
	            isLocked = column.locked;

	            if (isLocked) {
	                headerTable = that.lockedHeader.children("table");
	            } else {
	                headerTable = that.thead.parent();
	            }

	            th = headerTable.find("[data-index='" + index + "']");

	            var contentTable = isLocked ? that.lockedTable : that.table,
	                footer = that.footer || $();

	            if (that.footer && that.lockedContent) {
	                footer = isLocked ? that.footer.children(".k-grid-footer-locked") : that.footer.children(".k-grid-footer-wrap");
	            }

	            var footerTable = footer.find("table").first();

	            if (that.lockedHeader && visibleLocked >= index && !isLocked) {
	                index -= visibleLocked;
	            }

	            // adjust column index, depending on previous hidden columns
	            for (var j = 0; j < columns.length; j++) {
	                if (columns[j] === column) {
	                    break;
	                } else {
	                    if (columns[j].hidden) {
	                        index--;
	                    }
	                }
	            }

	            // get col elements
	            if (options.scrollable) {
	                col = headerTable.find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")")
	                    .add(contentTable.children("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")"))
	                    .add(footerTable.find("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")"));
	            } else {
	                col = contentTable.children("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")");
	            }

	            var tables = headerTable.add(contentTable).add(footerTable);

	            var oldColumnWidth = outerWidth(th);

	            // reset the table and autofitted column widths
	            // if scrolling is disabled, we need some additional repainting of the table
	            col.width("");
	            tables.css("table-layout", "fixed");
	            col.width("auto");
	            tables.addClass("k-autofitting");
	            tables.css("table-layout", "");

	            var newColumnWidth = Math.ceil(
	                    Math.max(
	                        outerWidth(th),
	                        outerWidth(contentTable.find("tr").eq(0).children("td:visible").eq(index)),
	                        outerWidth(footerTable.find("tr").eq(0).children("td:visible").eq(index))
	            ));

	            col.width(newColumnWidth);
	            column.width = newColumnWidth;

	            // if all visible columns have widths, the table needs a pixel width as well
	            if (options.scrollable) {
	                var cols = headerTable.find("col"),
	                    colWidth,
	                    totalWidth = 0;
	                for (var idx = 0, length = cols.length; idx < length; idx += 1) {
	                    colWidth = cols[idx].style.width;
	                    if (colWidth && colWidth.indexOf("%") == -1) {
	                        totalWidth += parseInt(colWidth, 10);
	                    } else {
	                        totalWidth = 0;
	                        break;
	                    }
	                }

	                if (totalWidth) {
	                    tables.each(function () {
	                        this.style.width = totalWidth + "px";
	                    });
	                }
	            }

	            if (browser.msie && browser.version == 8) {
	                tables.css("display", "inline-table");
	                setTimeout(function () {
	                    tables.css("display", "table");
	                }, 1);
	            }

	            tables.removeClass("k-autofitting");

	            that.trigger(COLUMNRESIZE, {
	                column: column,
	                oldWidth: oldColumnWidth,
	                newWidth: newColumnWidth
	            });

	            that._applyLockedContainersWidth();
	            that._syncLockedContentHeight();
	            that._syncLockedHeaderHeight();
	        },

	        _adjustLockedHorizontalScrollBar: function() {
	            var table = this.table,
	                content = table.parent();

	            var scrollbar = table[0].offsetWidth > content[0].clientWidth ? kendo.support.scrollbar() : 0;
	            this.lockedContent.height(outerHeight(content) - scrollbar);
	        },

	        _syncLockedContentHeight: function() {
	            if (this.lockedTable) {
	                if (!this._touchScroller) {
	                    this._adjustLockedHorizontalScrollBar();
	                }
	                this._adjustRowsHeight(this.table, this.lockedTable);
	                this._syncLockedScroll();
	            }
	        },

	        _syncLockedHeaderHeight: function() {
	            if (this.lockedHeader) {
	                var lockedTable = this.lockedHeader.children("table");
	                var table = this.thead.parent();

	                this._adjustRowsHeight(lockedTable, table);

	                syncTableHeight(lockedTable, table);
	            }
	        },

	        _syncLockedScroll: function () {
	            if (!this.options.scrollable) {
	                return;
	            }
	            this.lockedContent[0].scrollTop = this.content[0].scrollTop;
	        },

	        _resizable: function() {
	            if (!this.options.resizable) {
	                return;
	            }

	            if (this.resizable) {
	                this.resizable.destroy();
	            }

	            var treelist = this;

	            $(this.lockedHeader).find("thead").add(this.thead)
	                .on("mousemove" + NS, "th", $.proxy(this._positionResizeHandle, this));

	            this.resizable = new kendo.ui.Resizable(this.wrapper, {
	                handle: ".k-resize-handle",
	                start: function(e) {
	                    var th = $(e.currentTarget).data("th");
	                    var index = $.inArray(th[0], leafDataCells(th.closest("thead")).filter(":visible"));
	                    var colSelector = "col:eq(" + index + ")";
	                    var header, contentTable;

	                    treelist.wrapper.addClass("k-grid-column-resizing");

	                    if (treelist.lockedHeader && $.contains(treelist.lockedHeader[0], th[0])) {
	                        header = treelist.lockedHeader;
	                        contentTable = treelist.lockedTable;
	                    } else {
	                        header = treelist.thead.parent();
	                        contentTable = treelist.table;
	                    }

	                    this.col = contentTable.children("colgroup").find(colSelector)
	                          .add(header.find(colSelector));
	                    this.th = th;
	                    this.startLocation = e.x.location;
	                    this.columnWidth = outerWidth(th);
	                    this.table = this.col.closest("table");
	                    this.totalWidth = this.table.width();
	                },
	                resize: function(e) {
	                    var rtlModifier = isRtl ? -1 : 1;
	                    var minColumnWidth = 11;
	                    var delta = (e.x.location * rtlModifier) - (this.startLocation * rtlModifier);

	                    if (this.columnWidth + delta < minColumnWidth) {
	                        delta = minColumnWidth - this.columnWidth;
	                    }

	                    this.table.width(this.totalWidth + delta);
	                    this.col.width(this.columnWidth + delta);
	                },
	                resizeend: function() {
	                    treelist.wrapper.removeClass("k-grid-column-resizing");

	                    var field = this.th.attr("data-field");
	                    var column = grep(leafColumns(treelist.columns), function(c) {
	                        return c.field == field;
	                    });
	                    var newWidth = Math.floor(outerWidth(this.th));

	                    column[0].width = newWidth;
	                    treelist._resize();
	                    treelist._syncLockedContentHeight();
	                    treelist._syncLockedHeaderHeight();
	                    treelist.trigger(COLUMNRESIZE, {
	                        column: column,
	                        oldWidth: this.columnWidth,
	                        newWidth: newWidth
	                    });

	                    this.table = this.col = this.th = null;
	                }
	            });
	        },

	        _sortable: function() {
	            var columns;
	            var column;
	            var sortableInstance;
	            var cells;
	            var cell, idx, length;
	            var sortable = this.options.sortable;
	            var hasMultiColumnHeaders = grep(this.columns, function(item) {
	                return item.columns !== undefined;
	            }).length > 0;

	            if (!sortable) {
	                return;
	            }

	            if (hasMultiColumnHeaders) {
	                if (this.lockedHeader) {
	                    cells = sortCells(leafDataCells(this.lockedHeader.find(">table>thead")).add(leafDataCells(this.thead)));
	                } else {
	                    cells = leafDataCells(this.thead);
	                }
	            } else {
	                cells = $(this.lockedHeader).add(this.thead).find("th");
	            }
	            columns = leafColumns(this.columns);

	            for (idx = 0, length = cells.length; idx < length; idx++) {
	                column = columns[idx];

	                if (column.sortable !== false && !column.command && column.field && !column.selectable) {
	                    cell = cells.eq(idx);

	                    sortableInstance = cell.data("kendoColumnSorter");
	                    if (sortableInstance) {
	                        sortableInstance.destroy();
	                    }

	                    cell.kendoColumnSorter(
	                            extend({}, sortable, column.sortable, {
	                                dataSource: this.dataSource
	                            })
	                        );
	                }
	            }
	        },

	        _filterable: function() {
	            var cells;
	            var filterable = this.options.filterable;
	            var idx;
	            var length;
	            var columns;
	            var column;
	            var cell;
	            var filterMenuInstance;
	            var hasMultiColumnHeaders = grep(this.columns, function(item) {
	                return item.columns !== undefined;
	            }).length > 0;

	            if (!filterable || this.options.columnMenu) {
	                return;
	            }

	            var filterInit = proxy(function(e) {
	                this.trigger(FILTERMENUINIT, { field: e.field, container: e.container });
	            }, this);

	            var filterOpen = proxy(function(e) {
	                this.trigger(FILTERMENUOPEN, { field: e.field, container: e.container });
	            }, this);

	            if (hasMultiColumnHeaders) {
	                if (this.lockedHeader) {
	                    cells = leafDataCells(this.lockedHeader.find(">table>thead").add(this.thead));
	                } else {
	                    cells = leafDataCells(this.thead);
	                }
	            } else {
	                cells = $(this.lockedHeader).add(this.thead).find("th");
	            }
	            columns = leafColumns(this.columns);

	            for (idx = 0, length = cells.length; idx < length; idx++) {
	                column = columns[idx];
	                cell = cells.eq(idx);

	                filterMenuInstance = cell.data("kendoFilterMenu");
	                if (filterMenuInstance) {
	                    filterMenuInstance.destroy();
	                }

	                if (column.command || column.filterable === false || column.selectable) {
	                    continue;
	                }

	                cell.kendoFilterMenu(extend(true, {}, filterable, column.filterable, {
	                    dataSource: this.dataSource,
	                    init: filterInit,
	                    open: filterOpen
	                }));
	            }
	        },

	        _change: function() {
	            var that = this;
	            var selectedValues;

	            if (that._checkBoxSelection) {
	                selectedValues = that.selectable.value();
	                that._uncheckCheckBoxes();
	                that._checkRows(selectedValues);
	                if (selectedValues.length && selectedValues.length === that.items().length) {
	                    that._toggleHeaderCheckState(true);
	                } else {
	                    that._toggleHeaderCheckState(false);
	                }
	            }
	            this.trigger(CHANGE);
	        },

	        _isLocked: function() {
	            return this.lockedHeader !== null;
	        },

	        _selectable: function() {
	            var that = this;
	            var selectable = this.options.selectable;
	            var filter;
	            var element = this.table;
	            var useAllItems;
	            var isLocked = that._isLocked();
	            var multi;
	            var cell;

	            if (selectable) {
	                selectable = kendo.ui.Selectable.parseOptions(selectable);

	                if (this._hasLockedColumns) {
	                    element = element.add(this.lockedTable);
	                    useAllItems = selectable.multiple && selectable.cell;
	                }

	                filter = ">tbody>tr:not(.k-footer-template)";

	                if (selectable.cell) {
	                    filter = filter + ">td";
	                }

	                this.selectable = new kendo.ui.Selectable(element, {
	                    filter: filter,
	                    aria: true,
	                    multiple: selectable.multiple,
	                    change: proxy(this._change, this),
	                    useAllItems: useAllItems,
	                    continuousItems: proxy(this._continuousItems, this, filter, selectable.cell),
	                    relatedTarget: !selectable.cell && this._hasLockedColumns ? proxy(this._selectableTarget, this) : undefined
	                });

	                if (that.options.navigatable) {
	                    multi = selectable.multiple;
	                    cell = selectable.cell;

	                    element.on("keydown" + NS, function(e) {
	                        var current = that.current();
	                        var target = e.target;
	                        if (e.keyCode === keys.SPACEBAR && !e.shiftKey && $.inArray(target, element) > -1 &&
	                            !current.is(".k-header")) {

	                                e.preventDefault();
	                                e.stopPropagation();
	                                current = cell ? current : current.parent();

	                                if (isLocked && !cell) {
	                                    current = current.add(that._relatedRow(current));
	                                }

	                                if (multi) {
	                                    if(!e.ctrlKey) {
	                                        that.selectable.clear();
	                                    } else {
	                                        if (current.hasClass(classNames.selected)) {
	                                            current.removeClass(classNames.selected);
	                                            that.trigger(CHANGE);
	                                            return;
	                                        }
	                                    }
	                                } else {
	                                    that.selectable.clear();
	                                }
	                                if (!cell) {
	                                    that.selectable._lastActive = current;
	                                }

	                                that.selectable.value(current);
	                        } else if (!cell && ((e.shiftKey && e.keyCode == keys.LEFT)||
	                                    (e.shiftKey && e.keyCode == keys.RIGHT)||
	                                    (e.shiftKey && e.keyCode == keys.UP)||
	                                    (e.shiftKey && e.keyCode == keys.DOWN)||
	                                    (e.keyCode === keys.SPACEBAR && e.shiftKey))) {

	                            e.preventDefault();
	                            e.stopPropagation();
	                            current = current.parent();

	                            if (isLocked) {
	                                current = current.add(that._relatedRow(current));
	                            }

	                            if (multi) {
	                                if(!that.selectable._lastActive) {
	                                    that.selectable._lastActive = current;
	                                }
	                                that.selectable.selectRange(that.selectable._firstSelectee(), current);
	                            } else {
	                                that.selectable.clear();
	                                that.selectable.value(current);
	                            }
	                        }
	                    });
	                }
	            }
	        },

	        _continuousItems: function(filter, cell) {
	            if (!this.lockedContent) {
	                return;
	            }

	            var lockedItems = $(filter, this.lockedTable);
	            var nonLockedItems = $(filter, this.table);
	            var columns = cell ? lockedColumns(this.columns).length : 1;
	            var nonLockedColumns = cell ? this.columns.length - columns : 1;
	            var result = [];

	            for (var idx = 0; idx < lockedItems.length; idx += columns) {
	                push.apply(result, lockedItems.slice(idx, idx + columns));
	                push.apply(result, nonLockedItems.splice(0, nonLockedColumns));
	            }

	            return result;
	        },

	        _selectableTarget: function(items) {
	            var related;
	            var result = $();
	            for (var idx = 0, length = items.length; idx < length; idx ++) {
	                related = this._relatedRow(items[idx]);

	                if (inArray(related[0], items) < 0) {
	                    result = result.add(related);
	                }
	            }

	            return result;
	        },

	        _relatedRow: function(row) {
	            var lockedTable = this.lockedTable;
	            row = $(row);

	            if (!lockedTable) {
	                return row;
	            }

	            var table = row.closest(this.table.add(this.lockedTable));
	            var index = table.find(">tbody>tr").index(row);

	            table = table[0] === this.table[0] ? lockedTable : this.table;

	            return table.find(">tbody>tr").eq(index);
	        },

	        select: function(value) {
	            var that = this;
	            var selectable = this.selectable;

	            if (that._checkBoxSelection) {
	                if (value) {
	                    that._checkRows(value);
	                    if (that.select().length === that.items().length) {
	                        that._toggleHeaderCheckState(true);
	                    }
	                }

	                return that.items().filter("." + SELECTED);
	            }

	            if (!selectable) {
	                return $();
	            }

	            if (typeof value !== "undefined") {
	                if (!selectable.options.multiple) {
	                    selectable.clear();

	                    value = value.first();
	                }

	                if (this._hasLockedColumns) {
	                    value = value.add($.map(value, proxy(this._relatedRow, this)));
	                }
	            }

	            return selectable.value(value);
	        },

	        clearSelection: function() {
	            var that = this;
	            var selected = this.select();

	            if (that.selectable && !that._checkBoxSelection) {
	                that.selectable.clear();
	            }

	            if (that._checkBoxSelection) {
	                that._deselectCheckRows(that.select());
	                return;
	            }

	            if(selected.length || that._checkBoxSelection){
	                that.trigger(CHANGE);
	            }
	        },

	        _uncheckCheckBoxes: function () {
	            var that= this;
	            var tables = that.table.add(that.lockedTable);

	            tables.find("tbody " + CHECKBOXINPUT).attr("aria-checked", false)
	                .prop("checked", false).attr("aria-label", "Select row");

	        },

	        _deselectCheckRows: function(items) {
	            var that = this;
	            items = that.table.add(that.lockedTable).find(items);

	            if (that._isLocked()) {
	                items = items.add(items.map(function() {
	                    return that._relatedRow(this);
	                }));
	            }

	            items.each(function() {
	                $(this).removeClass(SELECTED).find(CHECKBOXINPUT).attr("aria-checked", false)
	                    .prop("checked", false).attr("aria-label", "Select row");
	            });
	            that._toggleHeaderCheckState(false);

	            that.trigger(CHANGE);
	        },

	        _headerCheckboxClick: function(e) {
	            var that = this,
	                checkBox = $(e.target),
	                checked = checkBox.prop("checked"),
	                parentGrid = checkBox.closest(".k-grid.k-widget").getKendoTreeList();

	            if (that !== parentGrid) {
	                return;
	            }

	            if (checked) {
	                that.select(parentGrid.items());
	            } else {
	                that.clearSelection();
	            }
	        },

	        _checkboxClick: function(e) {
	            var that = this,
	                row =  $(e.target).closest("tr"),
	                isSelecting = !row.hasClass(SELECTED),
	                dataItem = that.dataItem(row),
	                children = [],
	                selector = "";

	            if (that !== row.closest(".k-grid.k-widget").getKendoTreeList()) {
	                return;
	            }

	            if (that._includeChildren) {
	                that.dataSource.allChildNodes(dataItem, children);

	                for (var i = 0; i < children.length; i++){
	                    selector += "tr[data-uid='" +	children[i].uid + "'],";
	                }
	            }

	            selector += "tr[data-uid='" +	dataItem.uid + "']";
	            row = $(selector);

	            if (isSelecting) {
	                that.select(row);
	            } else {
	                that._deselectCheckRows(row);
	            }
	        },

	        _checkRows: function(items) {
	            items.each(function() {
	                $(this).addClass(SELECTED).find(CHECKBOXINPUT).prop("checked", true)
	                    .attr("aria-label", "Deselect row").attr("aria-checked", true);
	            });
	        },

	        _toggleHeaderCheckState: function(checked) {
	            var that = this;
	            if (checked) {
	                that.thead.add(that.lockedHeader).find("tr " + CHECKBOXINPUT)
	                    .prop("checked", true).attr("aria-checked", true)
	                    .attr("aria-label", "Deselect all rows");
	            } else {
	                that.thead.add(that.lockedHeader).find("tr " + CHECKBOXINPUT)
	                    .prop("checked", false).attr("aria-checked", false)
	                    .attr("aria-label", "Select all rows");
	            }
	        },

	        _dataSource: function(dataSource) {
	            var that = this;
	            var ds = this.dataSource;
	            var pageable = that.options.pageable;

	            if (ds) {
	                ds.unbind(CHANGE, this._refreshHandler);
	                ds.unbind(ERROR, this._errorHandler);
	                ds.unbind(SORT, this._sortHandler);
	                ds.unbind(PROGRESS, this._progressHandler);
	            }

	            this._refreshHandler = proxy(this.refresh, this);
	            this._errorHandler = proxy(this._error, this);
	            this._sortHandler = proxy(this._clearSortClasses, this);
	            this._progressHandler = proxy(this._progress, this);


	            if (isPlainObject(dataSource)) {
	                extend(dataSource, { table: that.table, fields: that.columns });

	                if (isPlainObject(pageable) && pageable.pageSize !== undefined) {
	                    dataSource.pageSize = pageable.pageSize;
	                }
	            }

	            ds = this.dataSource = TreeListDataSource.create(dataSource);

	            if (pageable) {
	                ds._collapsedTotal = undefined;
	            }

	            ds.bind(CHANGE, this._refreshHandler);
	            ds.bind(ERROR, this._errorHandler);
	            ds.bind(SORT, this._sortHandler);
	            ds.bind(PROGRESS, this._progressHandler);

	            this._dataSourceFetchProxy = proxy(function() {
	                this.dataSource.fetch();
	            }, this);
	        },

	        setDataSource: function(dataSource) {
	            this._dataSource(dataSource);
	            this._sortable();
	            this._filterable();
	            this._columnMenu();
	            this._pageable();

	            this._contentTree.render([]);

	            if (this.options.autoBind) {
	                this.dataSource.fetch();
	            }
	        },

	        dataItem: function(element) {
	            if (element instanceof TreeListModel) {
	                return element;
	            }

	            var row = $(element).closest("tr");
	            var uid = row.attr(kendo.attr("uid"));
	            var model = isUndefined(uid) ? null : this.dataSource.getByUid(uid);

	            return model;
	        },

	        editRow: function(row) {
	            var that = this;
	            var model;

	            if (this._isIncellEditable() || !this.options.editable) {
	                return;
	            }

	            if (typeof row === STRING) {
	                row = this.tbody.find(row);
	            }

	            if (that._isPageable() && that._isPopupEditable() && row instanceof TreeListModel) {
	                // popup editor can be created without a rendered row
	                model = row;
	            } else {
	                model = this.dataItem(row);
	            }

	            if (!model) {
	                return;
	            }

	            if (that.editor) {
	                model._edit = true;
	                this._render();
	                this._cancelEditor();
	            } else {
	                that._preventPageSizeRestore = false;

	            }

	            if (this._editMode() != "popup") {
	                model._edit = true;
	            }

	            if (this.trigger(BEFORE_EDIT, { model: model })) {
	                that.dataSource._restorePageSizeAfterAddChild();
	                return;
	            }

	            this._render();

	            this._createEditor(model);

	            this.trigger(EDIT, {
	                container: this.editor.wrapper,
	                model: model
	            });
	        },

	        _cancelEdit: function(e) {
	            if (!this.editor) {
	                return;
	            }
	            var currentIndex;

	            e = extend(e, {
	                container: this.editor.wrapper,
	                model: this.editor.model
	            });

	            if (this.trigger(CANCEL, e)) {
	                return;
	            }

	            if (this.options.navigatable) {
	                currentIndex = this.items().index($(this.current()).parent());
	            }

	            this.cancelRow();

	            if (this.options.navigatable) {
	                this.current(this.items().eq(currentIndex).children().filter(NAVCELL).first());
	                focusTable(this.table, true);
	            }
	        },

	        cancelRow: function() {
	            if (this._isIncellEditable()) {
	                return;
	            }

	            this._cancelEditor();

	            this._render();
	        },

	        saveRow: function() {
	            var editor = this.editor;
	            var args;

	            if (this._isIncellEditable()) {
	                return;
	            }

	            if (!editor) {
	                return ;
	            }

	            args = {
	                model: editor.model,
	                container: editor.wrapper
	            };

	            if (editor.end() && !this.trigger(SAVE, args)) {
	                this.dataSource.sync();
	            }
	        },

	        addRow: function(parent) {
	            var that = this;
	            var dataSource = that.dataSource;
	            var pageable = that._isPageable();
	            var incellEditing = that._isIncellEditable();
	            var inlineEditing = that._isInlineEditable();
	            var editor = this.editor;
	            var index = 0;
	            var model = {};

	            if ((editor && !editor.end()) || !this.options.editable) {
	                return;
	            }

	            if (parent) {
	                if (!(parent instanceof TreeListModel)) {
	                    parent = this.dataItem(parent);
	                }

	                model[parent.parentIdField] = parent.id;
	                index = this.dataSource.indexOf(parent) + 1;

	                this.expand(parent)
	                    .then(function() {
	                        var showNewModelInView = pageable && dataSource._isLastItemInView(parent) && (incellEditing || inlineEditing);
	                        that._insertAt(model, index, showNewModelInView);
	                    });

	                return;
	            }

	            this._insertAt(model, index);
	        },

	        _insertAt: function(model, index, showNewModelInView) {
	            var that = this;
	            var dataSource = that.dataSource;
	            model = that.dataSource.insert(index, model);

	            if (showNewModelInView) {
	                dataSource._setAddChildPageSize();
	            }

	            var row = this._itemFor(model);
	            var cell;

	            if (that._isIncellEditable()) {
	                cell = row.children("td").eq(that._firstEditableColumnIndex(row));
	                that.editCell(cell);
	            } else if (row && row[0]) {
	                that.editRow(row);
	            } else if (that._isPageable() && that._isPopupEditable()) {
	                that.editRow(model);
	            }
	        },

	        _firstEditableColumnIndex: function(container) {
	            var that = this;
	            var model = that.dataItem(container);
	            var columns = leafColumns(that.columns);
	            var length = columns.length;
	            var column;
	            var idx;

	            for (idx = 0; idx < length; idx++) {
	                column = columns[idx];

	                if (model && (!model.editable || model.editable(column.field)) && !column.command && column.field && column.hidden !== true) {
	                    return idx;
	                }
	            }

	            return -1;
	        },

	        removeRow: function(row) {
	            var model = this.dataItem(row);
	            var args = {
	                model: model,
	                row: row
	            };

	            if (this.options.editable && model && !this.trigger(REMOVE, args)) {
	                if (document.activeElement === $(row).find(".k-grid-delete")[0]) {
	                    $(row).find(".k-grid-delete").blur();
	                }
	                this.dataSource.remove(model);

	                if (!this._isIncellEditable()) {
	                    this.dataSource.sync();
	                }
	            }
	        },

	        _cancelEditor: function() {
	            var that = this;
	            var model;
	            var editor = that.editor;

	            if (editor) {
	                model = editor.model;

	                that._destroyEditor();

	                if (!that._isIncellEditable()) {
	                    that.dataSource.cancelChanges(model);
	                } else if (that._shouldRestorePageSize()) {
	                    that.dataSource._restorePageSizeAfterAddChild();
	                }

	                model._edit = false;
	            }

	            that._preventPageSizeRestore = false;
	        },

	        _shouldRestorePageSize: function() {
	            var that = this;
	            return that._isPageable() && that._isIncellEditable() && !that._preventPageSizeRestore;
	        },

	        _destroyEditor: function() {
	            if (!this.editor) {
	                return;
	            }

	            this.editor.close();
	            this.editor = null;
	        },

	        _createEditor: function(model) {
	            var row = this.itemFor(model);
	            var columns = leafColumns(this.columns);
	            var leafCols = [];

	            for (var idx = 0; idx < columns.length; idx++) {
	                leafCols.push(extend({}, columns[idx]));
	                delete leafCols[idx].parentColumn;
	            }

	            row = row.add(this._relatedRow(row));

	            var mode = this._editMode();

	            var options = {
	                columns: leafCols,
	                model: model,
	                target: this,
	                clearContainer: false,
	                template: this.options.editable.template
	            };

	            if (mode == "inline") {
	                this.editor = new Editor(row, options);
	            } else {
	                extend(options, {
	                    window: this.options.editable.window,
	                    commandRenderer: proxy(function() {
	                        return this._buildCommands(["update", "canceledit"]);
	                    }, this),
	                    fieldRenderer: proxy(this._cellContent, this),
	                    save: proxy(this.saveRow, this),
	                    cancel: proxy(this._cancelEdit, this),
	                    appendTo: this.wrapper
	                });

	                this.editor = new PopupEditor(row, options);
	            }
	        },

	        _createIncellEditor: function(cell, options) {
	            var that = this;
	            var column = extend({}, options.columns[0]);

	            delete column.parentColumn;

	            return new IncellEditor(cell, extend({}, {
	                fieldRenderer: proxy(that._cellContent, that),
	                appendTo: that.wrapper,
	                clearContainer: false,
	                target: that,
	                columns: [column],
	                model: options.model,
	                change: options.change
	            }));
	        },

	        editCell: function(cell) {
	            var that = this;
	            cell = $(cell);
	            var column = leafColumns(that.columns)[that.cellIndex(cell)];
	            var model = that.dataItem(cell);

	            if (that._isIncellEditable() && model && isColumnEditable(column, model)) {
	                that._editCell(cell, column, model);
	            }
	        },

	        _editCell: function(cell, column, model) {
	            var that = this;
	            var editedCell;

	            if (that.trigger(BEFORE_EDIT, { model: model })) {
	                that.dataSource._restorePageSizeAfterAddChild();
	                return;
	            }

	            that.closeCell();

	            model._edit = true;

	            that._cancelEditor();

	            that._render({
	                editedColumn: column,
	                editedColumnIndex: cell.index()
	            });

	            editedCell = that.table.add(that.lockedTable).find(DOT + classNames.editCell).first();

	            that.editor = that._createIncellEditor(editedCell, {
	                columns: [column],
	                model: model,
	                change: function(e) {
	                    if (that.trigger(SAVE, { values: e.values, container: cell, model: model } )) {
	                        e.preventDefault();
	                    }

	                }
	            });

	            // refresh the current element as the DOM element reference can be changed after render()
	            that._current = editedCell;

	            that.trigger(EDIT, { container: cell, model: model });
	        },

	        closeCell: function(isCancel) {
	            var that = this;
	            var cell = (that.editor || {}).element;
	            var tr;
	            var model;

	            if (!cell || !cell[0] || !that._isIncellEditable()) {
	                return;
	            }

	            model = that.dataItem(cell);

	            if (isCancel && that.trigger(CANCEL, { container: cell, model: model })) {
	                return;
	            }

	            that.trigger(CELL_CLOSE, { type: isCancel ? CANCEL: SAVE, model: model, container: cell });

	            that._cancelEditor();

	            cell.removeClass(classNames.editCell);

	            tr = cell.parent().removeClass(classNames.editRow);

	            if (that.lockedContent) {
	                that._relatedRow(tr).removeClass(classNames.editRow);
	            }

	            that._render();

	            that.trigger(ITEM_CHANGE, { item: tr, data: model, ns: ui });

	            if (that.lockedContent) {
	                adjustRowHeight(tr.css("height", "")[0], that._relatedRow(tr).css("height", "")[0]);
	            }
	        },

	        cancelChanges: function() {
	            this.dataSource.cancelChanges();
	        },

	        saveChanges: function() {
	            var that = this;
	            var editable = (that.editor || {}).editable;
	            var valid = editable && editable.end();

	            if ((valid || !editable) && !that.trigger(SAVE_CHANGES)) {
	                that.dataSource.sync();
	            }
	        },

	        _editMode: function() {
	            var mode = "inline",
	                editable = this.options.editable;

	            if (editable !== true) {
	                if (typeof editable == "string") {
	                    mode = editable;
	                } else {
	                    mode = editable.mode || mode;
	                }
	            }

	            return mode.toLowerCase();
	        },

	        _isIncellEditable: function() {
	            return this._editMode() === INCELL;
	        },

	        _isInlineEditable: function() {
	            return this._editMode() === INLINE;
	        },

	        _isPopupEditable: function() {
	            return this._editMode() === POPUP;
	        },

	        hideColumn: function(column) {
	            this._toggleColumnVisibility(column, true);
	        },

	        showColumn: function(column) {
	            this._toggleColumnVisibility(column, false);
	        },

	        _toggleColumnVisibility: function(column, hidden) {
	            column = this._findColumn(column);

	            if (!column || column.hidden === hidden) {
	                return;
	            }

	            column.hidden = hidden;
	            this._setParentsVisibility(column, !hidden);

	            this._ensureExpandableColumn();
	            this._clearColsCache();
	            this._renderCols();
	            this._renderHeader();
	            this._render();

	            this._adjustTablesWidth();

	            this.trigger(hidden ? COLUMNHIDE : COLUMNSHOW, { column: column });

	            if (!hidden && !column.width) {
	                this.table
	                    .add(this.thead.closest("table"))
	                    .width("");
	            }
	            this._updateFirstColumnClass();
	        },

	        _findColumn: function(column) {
	            if (typeof column == "number") {
	                column = this.columns[column];
	            } else if (isPlainObject(column)) {
	                column = grep(leafColumns(this.columns), function(item) {
	                    return item === column;
	                })[0];
	            } else {
	                column = grep(leafColumns(this.columns), function(item) {
	                    return item.field === column;
	                })[0];
	            }

	            return column;
	        },

	        _adjustTablesWidth: function() {
	            var idx, length;
	            var cols = this.thead.prev().children();
	            var colWidth, width = 0;

	            for (idx = 0, length = cols.length; idx < length; idx++ ) {
	                colWidth = cols[idx].style.width;
	                if (colWidth && colWidth.indexOf("%") == -1) {
	                    width += parseInt(colWidth, 10);
	                } else {
	                    width = 0;
	                    break;
	                }
	            }


	            if (width) {
	                this.table
	                    .add(this.thead.closest("table"))
	                    .width(width);
	            }
	        },

	        _reorderable: function() {
	            if (!this.options.reorderable) {
	                return;
	            }

	            var scrollable = this.options.scrollable === true;
	            var selector = (scrollable ? ".k-grid-header:first " : "table:first>.k-grid-header ") + HEADERCELLS;
	            var that = this;

	            this._draggableInstance = new ui.Draggable(this.wrapper, {
	                group: kendo.guid(),
	                filter: selector,
	                hint: function(target) {
	                    return $('<div class="k-header k-reorder-clue k-drag-clue" />')
	                    .html(target.attr(kendo.attr("title")) || target.attr(kendo.attr("field")) || target.text())
	                    .prepend('<span class="k-icon k-drag-status k-i-cancel" />');
	                }
	            });

	            this.reorderable = new ui.Reorderable(this.wrapper, {
	                draggable: this._draggableInstance,
	                dragOverContainers: proxy(this._allowDragOverContainers, this),
	                inSameContainer: function(e) {
	                    return $(e.source).parent()[0] === $(e.target).parent()[0] && targetParentContainerIndex(flatColumnsInDomOrder(that.columns), that.columns, e.sourceIndex, e.targetIndex) > -1;
	                },
	                change: function(e) {
	                    var columns = flatColumnsInDomOrder(that.columns);
	                    var column = columns[e.oldIndex];
	                    var newIndex = targetParentContainerIndex(columns, that.columns, e.oldIndex, e.newIndex);

	                    that.trigger(COLUMNREORDER, {
	                        newIndex: newIndex,
	                        oldIndex: inArray(column, columns),
	                        column: column
	                    });

	                    that.reorderColumn(newIndex, column, e.position === "before");
	                }
	            });
	        },

	        _allowDragOverContainers: function(sourceIndex, targetIndex) {
	            var columns = flatColumnsInDomOrder(this.columns);
	            return columns[sourceIndex].lockable !== false && targetParentContainerIndex(columns, this.columns, sourceIndex, targetIndex) > -1;
	        },

	        _reorderTrees: function(destSources, destContainer, destDomTree, sources, sourcesContainer, sourcesDomTree, before, depth) {
	            var ths = $();
	            var source = sourcesContainer.find("tr:eq(" + sources[0].rowIndex + ")");
	            var sourceDOM = sourcesDomTree.children[sources[0].rowIndex];
	            var sourceChildren = source.children();
	            var destDomChildren;
	            var currentIndex;
	            var destColumn = before? destSources[0] : destSources[destSources.length -1];
	            var destRow;
	            var sourcesLeafs;
	            var destLeafs;
	            var reorderTaget;
	            var destThs;

	            for (var idx = 0; idx < sources.length; idx++) {
	                currentIndex = sources[idx].cellIndex;
	                ths = ths.add(sourceChildren.eq(currentIndex));
	                destDomChildren = destDomTree.children[destColumn.rowIndex].children;
	                if (destDomTree === sourcesDomTree && before) {
	                    currentIndex += idx;
	                }

	                destDomChildren.splice(before ? destColumn.cellIndex + idx : destColumn.cellIndex + 1+ idx, 0, sourceDOM.children[currentIndex]);
	            }

	            if (destDomTree === sourcesDomTree && before) {
	                sourceDOM.children.splice(sources[0].cellIndex + sources.length, sources.length);
	            } else {
	                sourceDOM.children.splice(sources[0].cellIndex, sources.length);
	            }
	            destRow = destContainer.find("tr:eq(" + destColumn.rowIndex + ")");
	            destThs = destRow.find(">th.k-header:eq(" + destColumn.cellIndex + ")");

	            if (destThs.length && ths[0] !== destThs[0]) {
	                ths[before ? "insertBefore" : "insertAfter"](destThs);
	            }

	            if (depth >= sources[0].rowIndex + 1 && depth != 1) {
	                sourcesLeafs = [];
	                for (idx = 0; idx < sources.length; idx++) {
	                    if (sources[idx].columns) {
	                        sourcesLeafs = sourcesLeafs.concat(sources[idx].columns);
	                    }
	                }
	                if (!sourcesLeafs.length) {
	                    return;
	                }

	                destLeafs = [];

	                for (idx = 0; idx < destSources.length; idx++) {
	                    if (destSources[idx].columns) {
	                        destLeafs = destLeafs.concat(destSources[idx].columns);
	                    }
	                }

	                if (!destLeafs.length && (destContainer !== sourcesContainer || (destColumn.cellIndex - sources[0].cellIndex > 1 || sources[0].cellIndex - destColumn.cellIndex > 1))) {
	                    reorderTaget = findReorderTarget(this.columns, destColumn, sources[0], before, this.columns);

	                    destLeafs = [reorderTaget];
	                    if (!reorderTaget && sourcesLeafs.length && destContainer.find("tr").length > sources[0].rowIndex + 1) {
	                        this._insertTree(sourcesLeafs, sourcesContainer, sourcesDomTree, destContainer, destDomTree);
	                        return;
	                    }
	                }

	                if (!destLeafs.length) {
	                    return;
	                }

	                this._reorderTrees(destLeafs, destContainer, destDomTree, sourcesLeafs, sourcesContainer, sourcesDomTree, before, depth);
	            }
	        },

	        _insertTree: function(columns, sourcesContainer, sourcesDomTree, destContainer, destDomTree) {
	            var leafs = [];
	            var row;
	            var ths = $();
	            var domTr;

	            row = sourcesContainer.find("tr:eq(" + columns[0].rowIndex + ")");
	            domTr = sourcesDomTree.children[columns[0].rowIndex];

	            for (var idx = 0; idx < columns.length; idx++) {
	                if (columns[idx].columns) {
	                    leafs = leafs.concat(columns[idx].columns);
	                }
	                destDomTree.children[columns[0].rowIndex].children.splice(idx, 0, domTr.children[columns[idx].rowIndex]);
	                ths = ths.add(row.find(">th.k-header:eq(" + columns[idx].cellIndex + ")"));
	            }

	            sourcesDomTree.children[columns[0].rowIndex].children.splice(columns[0].cellIndex, columns.length);
	            destContainer.find("tr:eq(" + columns[0].rowIndex + ")").append(ths);

	            if (leafs.length) {
	                this._insertTree(leafs, sourcesContainer, sourcesDomTree, destContainer, destDomTree);
	            }
	        },

	        _reorderHeader: function(destColumn, column, before) {
	            var sourcesDepth = column.columns ? depth([column]) : 1;
	            var targetDepth = destColumn.columns ? depth([destColumn]) : 1;
	            var sourceLocked = isLocked(column);
	            var destLocked = isLocked(destColumn);
	            var destContainer = destLocked ? this.lockedHeader : this.thead;
	            var sourcesContainer = sourceLocked ? this.lockedHeader : this.thead;
	            var destDomTree = destLocked ? this._lockedHeaderTree : this._headerTree;
	            var sourcesDomTree = sourceLocked ? this._lockedHeaderTree : this._headerTree;
	            var rowsToAdd;
	            var destRows = destContainer.find("tr");


	            if (sourcesDepth === targetDepth || sourcesDepth < destRows.length ) {
	                this._reorderTrees([destColumn], destContainer, destDomTree , [column], sourcesContainer ,sourcesDomTree, before, sourcesDepth);
	                updateRowSpans(destContainer, destDomTree);
	                removeEmptyRows(sourcesContainer, sourcesDomTree);
	            } else {
	                if (destContainer !== sourcesContainer) {
	                    rowsToAdd = sourcesDepth - destRows.length;

	                    destRows.each(function (idx) {
	                        var cells = this.cells;
	                        for (var i = 0; i < cells.length; i++) {
	                            if (cells[i].colSpan <= 1 && cells[i].attributes.rowspan) {
	                                destDomTree.children[idx].children[i].attr.rowSpan += rowsToAdd;
	                                cells[i].rowSpan += rowsToAdd;
	                            }
	                        }
	                    });

	                    for (var j = 0; j < rowsToAdd ; j++) {
	                       destDomTree.children.push(kendoDomElement("tr", { "role": "row" }));
	                       if (destContainer.is("thead")) {
	                           destContainer.append("<tr role='row'></tr>");
	                       } else {
	                           destContainer.find("thead").append("<tr role='row'></tr>");
	                       }
	                    }
	                }

	                this._reorderTrees([destColumn], destContainer, destDomTree , [column], sourcesContainer ,sourcesDomTree, before, sourcesDepth);
	                removeEmptyRows(sourcesContainer, sourcesDomTree);
	             }
	        },

	        reorderColumn: function(destIndex, column, before) {
	            var lockChanged;
	            var parent = column.parentColumn;
	            var columns = parent ? parent.columns : this.columns;
	            var sourceIndex = inArray(column, columns);
	            var destColumn = columns[destIndex];
	            var isLocked = !!destColumn.locked;
	            var hasMultiColumnHeaders = grep(this.columns, function(item) {
	                return item.columns !== undefined;
	            }).length > 0;
	            var nonLockedColumnsLength = nonLockedColumns(columns).length;

	            if (sourceIndex === destIndex) {
	                return;
	            }

	            if (isLocked && !column.locked && nonLockedColumnsLength == 1) {
	                return;
	            }

	            if (!isLocked && column.locked && (columns.length - nonLockedColumnsLength == 1)) {
	                return;
	            }

	            if (before === undefined) {
	                before = destIndex < sourceIndex;
	            }

	            if (hasMultiColumnHeaders) {
	                this._reorderHeader(destColumn, column, before);
	            }

	            lockChanged = !!column.locked;
	            lockChanged = lockChanged != isLocked;

	            column.locked = isLocked;
	            columns.splice(before ? destIndex : destIndex + 1, 0, column);
	            columns.splice(sourceIndex < destIndex ? sourceIndex : sourceIndex + 1, 1);
	            this._setColumnDataIndexes(leafColumns(this.columns));
	            this._clearColsCache();
	            this._renderCols();

	            //reorder column header manually
	            if (!hasMultiColumnHeaders) {
	                var ths = $(this.lockedHeader).add(this.thead).find("th");
	                ths.eq(sourceIndex)[before ? "insertBefore" : "insertAfter"](ths.eq(destIndex));

	                var dom = this._headerTree.children[0].children;
	                if (this._hasLockedColumns) {
	                    dom = this._lockedHeaderTree.children[0].children.concat(dom);
	                }
	                dom.splice(before ? destIndex : destIndex + 1, 0, dom[sourceIndex]);
	                dom.splice(sourceIndex < destIndex ? sourceIndex : sourceIndex + 1, 1);
	                if (this._hasLockedColumns) {
	                    this._lockedHeaderTree.children[0].children = dom.splice(0, lockedColumns(columns).length);
	                    this._headerTree.children[0].children = dom;
	                }
	            } else {
	                if (this.lockedHeader) {
	                    columns = nonLockedColumns(this.columns);
	                    this._prepareColumns([{ rowSpan: 1, cells: [], index: 0 }], columns);
	                    columns = lockedColumns(this.columns);
	                    this._prepareColumns([{ rowSpan: 1, cells: [], index: 0 }], columns);
	                } else {
	                    this._prepareColumns([{ rowSpan: 1, cells: [], index: 0 }], this.columns);
	                }
	            }
	            this._updateColumnCellIndex();
	            this._applyLockedContainersWidth();
	            this._syncLockedHeaderHeight();
	            this._updateFirstColumnClass();

	            this.refresh();

	            if(!lockChanged) {
	                return;
	            }

	            if (isLocked) {
	                this.trigger(COLUMNLOCK, {
	                    column: column
	                });
	            } else {
	                this.trigger(COLUMNUNLOCK, {
	                    column: column
	                });
	            }
	        },

	        lockColumn: function(column) {
	            var columns = this.columns;

	            if (typeof column == "number") {
	                column = columns[column];
	            } else {
	                column = grep(columns, function(item) {
	                    return item.field === column;
	                })[0];
	            }

	            if (!column || column.hidden) {
	                return;
	            }

	            var index = lockedColumns(columns).length - 1;
	            this.reorderColumn(index, column, false);
	        },

	        unlockColumn: function(column) {
	            var columns = this.columns;

	            if (typeof column == "number") {
	                column = columns[column];
	            } else {
	                column = grep(columns, function(item) {
	                    return item.field === column;
	                })[0];
	            }

	            if (!column || column.hidden) {
	                return;
	            }

	            var index = lockedColumns(columns).length;
	            this.reorderColumn(index, column, true);
	        },

	        _columnMenu: function() {
	            var ths = $(this.lockedHeader).add(this.thead).find("th");
	            var columns = this.columns;
	            var options = this.options;
	            var columnMenu = options.columnMenu;
	            var column, menu, menuOptions, sortable, filterable;
	            var initHandler = proxy(this._columnMenuInit, this);
	            var openHandler = proxy(this._columnMenuOpen, this);
	            var hasLockableColumns = grep(this.columns, function(item) {
	                return item.lockable !== false;
	            }).length > 0;
	            var hasMultiColumnHeaders = grep(this.columns, function(item) {
	                return item.columns !== undefined;
	            }).length > 0;

	            if (hasMultiColumnHeaders) {
	                columns = leafColumns(columns);
	                if (this.lockedHeader) {
	                    ths = sortCells(leafDataCells(this.lockedHeader.find(">table>thead")).add(leafDataCells(this.thead)));
	                } else {
	                    ths = leafDataCells(this.thead);
	                }
	            } else {
	                ths = $(this.lockedHeader).add(this.thead).find("th");
	            }

	            if (!columnMenu) {
	                return;
	            }

	            if (typeof columnMenu == "boolean") {
	                columnMenu = {};
	            }

	            for (var i = 0; i < ths.length; i++) {
	                column = columns[i];
	                if (!column.field) {
	                    continue;
	                }

	                menu = ths.eq(i).data("kendoColumnMenu");
	                if (menu) {
	                    menu.destroy();
	                }

	                sortable = false;
	                if (column.sortable !== false && columnMenu.sortable !== false && options.sortable !== false) {
	                    sortable = extend({}, options.sortable, { compare: (column.sortable || {}).compare });
	                }

	                filterable = false;
	                if (options.filterable && column.filterable !== false && columnMenu.filterable !== false) {
	                    filterable = extend({ pane: this.pane }, column.filterable, options.filterable);
	                }

	                menuOptions = {
	                    dataSource: this.dataSource,
	                    values: column.values,
	                    columns: columnMenu.columns,
	                    sortable: sortable,
	                    filterable: filterable,
	                    messages: columnMenu.messages,
	                    owner: this,
	                    closeCallback: $.noop,
	                    init: initHandler,
	                    open: openHandler,
	                    pane: this.pane,
	                    hasLockableColumns: lockedColumns(columns).length > 0 && hasLockableColumns && !hasMultiColumnHeaders
	                };

	                if (options.$angular) {
	                    menuOptions.$angular = options.$angular;
	                }

	                ths.eq(i).kendoColumnMenu(menuOptions);
	            }
	        },

	        _columnMenuInit: function(e) {
	            this.trigger(COLUMNMENUINIT, { field: e.field, container: e.container });
	        },

	        _columnMenuOpen: function(e) {
	            this.trigger(COLUMNMENUOPEN, { field: e.field, container: e.container });
	        },

	        _pageable: function() {
	            var that = this,
	                wrapper,
	                pageable = that.options.pageable;

	            if (pageable) {
	                wrapper = that.wrapper.children("div.k-grid-pager");

	                if (!wrapper.length) {
	                    wrapper = $('<div class="k-pager-wrap k-grid-pager"/>').appendTo(that.wrapper);
	                }

	                that._destroyPager();

	                if (typeof pageable === "object" && pageable instanceof kendo.ui.TreeListPager) {
	                    that.pager = pageable;
	                } else if (that.dataSource && !that.dataSource.options.serverPaging) {
	                    that._createPager(wrapper);
	                }

	                if (that.pager) {
	                    that.pager.bind(PAGE_CHANGE, function(e) {
	                        if (that.trigger(PAGE, { page: e.index })) {
	                            e.preventDefault();
	                        }
	                    });
	                }
	            }
	        },

	        _createPager: function(element, options) {
	            var that = this;

	            that.pager = new TreeListPager(element, extend({}, that.options.pageable, { dataSource: that.dataSource }, options));
	        },

	        _destroyPager: function() {
	            if (this.pager) {
	                this.pager.destroy();
	            }
	        },

	        _isPageable: function() {
	            var that = this;
	            return that.options.pageable && (!that.dataSource || (that.dataSource && that.dataSource._isPageable()));
	        },

	        _togglePagerVisibility: function() {
	            var that = this;
	            var pageable = that.options.pageable;

	            if (pageable && (isPlainObject(pageable) || pageable instanceof TreeListPager) && pageable.alwaysVisible === false) {
	                that.wrapper.find(".k-grid-pager").toggle((that.dataSource.collapsedTotal() || 0) >= that.dataSource.pageSize());
	            }
	        }
	    });

	    function isInputElement(element) {
	       return $(element).is(":button,a,:input,a>.k-icon,textarea,span.k-select,span.k-icon,span.k-link,.k-input,.k-multiselect-wrap,.k-tool-icon");
	    }

	    function isLocked(column) {
	        if (!column.parentColumn) {
	            return !!column.locked;
	        }
	        return !!isLocked(column.parentColumn);
	    }

	    function findParentColumnWithChildren(columns, index, source, rtl) {
	        var target;
	        var locked = !!source.locked;
	        var targetLocked;

	        do {
	            target = columns[index];
	            index += rtl ? 1 : -1;
	            targetLocked = !!target.locked;
	        } while(target && index > -1 && index < columns.length && target != source && !target.columns && targetLocked === locked);

	        return target;
	    }

	    function findReorderTarget(columns, target, source, before, masterColumns) {
	        if (target.columns) {
	            target = target.columns;
	            return target[before ? 0 : target.length - 1];
	        } else {
	            var parent = columnParent(target, columns);
	            var parentColumns;

	            if (parent) {
	                parentColumns = parent.columns;
	            } else {
	                parentColumns = columns;
	            }

	            var index = inArray(target, parentColumns);
	            if (index === 0 && before && parentColumns.length !== 1) {
	                index++;
	            } else if (index == parentColumns.length - 1 && !before && index !== 0) {
	                index--;
	            } else if (index > 0 || (index === 0 && !before && index !== 0)) {
	                index += before ? -1 : 1;
	            }

	            var sourceIndex = inArray(source, parentColumns);
	            target = findParentColumnWithChildren(parentColumns, index, source, sourceIndex > index);
	            var targetIndex = inArray(target, masterColumns);
	            if (target.columns && (!targetIndex || targetIndex === parentColumns.length -1)) {
	                return null;
	            }

	            if (target && target != source && target.columns) {
	                return findReorderTarget(columns, target, source, before, masterColumns);
	            }
	        }
	        return null;
	    }

	    function leafColumns(columns) {
	        var result = [];

	        for (var idx = 0; idx < columns.length; idx++) {
	            if (!columns[idx].columns) {
	                result.push(columns[idx]);
	                continue;
	            }
	            result = result.concat(leafColumns(columns[idx].columns));
	        }

	        return result;
	    }

	    function getColumnsFields(columns) {
	        var result = [];
	        columns = leafColumns(columns);

	        for (var idx = 0; idx < columns.length; idx++) {
	            if (typeof columns[idx] === "string") {
	                result.push(columns[idx]);
	            } else if (columns[idx].field) {
	                result.push(columns[idx].field);
	            }
	        }
	        return result;
	    }

	    function visibleChildColumns(columns) {
	        return grep(columns, function(column) {
	            return !column.hidden;
	        });
	    }

	    function isVisible(column) {
	        return visibleColumns([column]).length > 0;
	    }

	    function visibleColumns(columns) {
	        return grep(columns, function(column) {
	            var result = !column.hidden;
	            if (result && column.columns) {
	                result = visibleColumns(column.columns).length > 0;
	            }
	            return result;
	        });
	    }

	    function normalizeColumns(columns, hide, parentIds) {
	        return map(columns, function(column) {
	            var hidden;

	            column.parentIds = parentIds;

	            if (!isVisible(column) || hide) {
	                hidden = true;
	            }

	            var uid = kendo.guid();
	            column.headerAttributes = extend({headers: parentIds}, column.headerAttributes);
	            if (!column.headerAttributes || !column.headerAttributes.id) {
	                column.headerAttributes = extend({id: uid}, column.headerAttributes);
	            } else {
	                uid = column.headerAttributes.id;
	            }

	            if (column.columns) {
	                column.columns = normalizeColumns(column.columns, hidden, parentIds ? (parentIds + " " + uid): uid);
	            }
	            return extend({ hidden: hidden }, column);
	        });
	    }

	    function flatColumnsInDomOrder(columns) {
	        var result = flatColumns(lockedColumns(columns));
	        return result.concat(flatColumns(nonLockedColumns(columns)));
	    }

	    function targetParentContainerIndex(flatColumns, columns, sourceIndex, targetIndex) {
	        var column = flatColumns[sourceIndex];
	        var target = flatColumns[targetIndex];

	        var parent = columnParent(column, columns);
	        columns = parent ? parent.columns : columns;

	        return inArray(target, columns);
	    }

	    function parentColumnsCells(cell) {
	        var container = cell.closest("table");
	        var result = $().add(cell);

	        var row = cell.closest("tr");
	        var headerRows = container.find("tr");
	        var level = headerRows.index(row);
	        if (level > 0) {
	            var parent = headerRows.eq(level - 1);
	            var parentCellsWithChildren = parent.find("th").filter(function() {
	                return !$(this).attr("rowspan");
	            });

	            var offset = 0;
	            var index = row.find("th").index(cell);

	            var prevCells = cell.prevAll().filter(function() {
	                return this.colSpan > 1;
	            });

	            for (var idx = 0; idx < prevCells.length; idx++) {
	                offset += prevCells[idx].colSpan || 1;
	            }

	            index += Math.max(offset - 1, 0);

	            offset = 0;
	            for (idx = 0; idx < parentCellsWithChildren.length; idx++) {
	                var parentCell = parentCellsWithChildren.eq(idx);
	                if (parentCell.attr("data-colspan")) {
	                    offset += parentCell[0].getAttribute("data-colspan");
	                } else {
	                    offset += 1;
	                }
	                if (index >= idx && index < offset) {
	                    result = parentColumnsCells(parentCell).add(result);
	                    break;
	                }
	            }
	        }
	        return result;
	    }

	    function childColumnsCells(cell) {
	        var container = cell.closest("thead");
	        var result = $().add(cell);

	        var row = cell.closest("tr");
	        var headerRows = container.find("tr");
	        var level = headerRows.index(row) + cell[0].rowSpan;
	        var colSpanAttr = kendo.attr("colspan");

	        if (level <= headerRows.length - 1) {
	            var child = row.next();
	            var prevCells = cell.prevAll();

	            var idx;

	            prevCells = prevCells.filter(function() {
	                return !this.rowSpan || this.rowSpan === 1;
	            });

	            var offset = 0;

	            for (idx = 0; idx < prevCells.length; idx++) {
	                offset += parseInt(prevCells.eq(idx).attr(colSpanAttr), 10) || 1;
	            }

	            var cells = child.find("th");
	            var colSpan = parseInt(cell.attr(colSpanAttr), 10) || 1;

	            idx = 0;

	            while (idx < colSpan) {
	                child = cells.eq(idx + offset);
	                result = result.add(childColumnsCells(child));
	                var value = parseInt(child.attr(colSpanAttr), 10);
	                if (value > 1) {
	                    colSpan -= value - 1;
	                }
	                idx++;
	            }
	        }

	        return result;
	    }

	    function columnParent(column, columns) {
	        var parents = [];
	        columnParents(column, columns, parents);
	        return parents[parents.length - 1];
	    }

	    function columnParents(column, columns, parents) {
	        parents = parents || [];

	        for (var idx = 0; idx < columns.length; idx++) {
	            if (column === columns[idx]) {
	                return true;
	            } else if (columns[idx].columns) {
	                var inserted = parents.length;
	                parents.push(columns[idx]);
	                if (!columnParents(column, columns[idx].columns, parents)) {
	                    parents.splice(inserted, parents.length - inserted);
	                } else {
	                    return true;
	                }
	            }
	        }
	        return false;
	    }

	    function flatColumns(columns) {
	        var result = [];
	        var children = [];
	        for (var idx = 0; idx < columns.length; idx++) {
	            result.push(columns[idx]);
	            if (columns[idx].columns) {
	                children = children.concat(columns[idx].columns);
	            }

	        }
	        if (children.length) {
	            result = result.concat(flatColumns(children));
	        }
	        return result;
	    }

	    function columnPosition(column, columns, row, cellCounts) {
	        var result;
	        var idx;

	        row = row || 0;
	        cellCounts = cellCounts || {};
	        cellCounts[row] = cellCounts[row] || 0;

	        for (idx = 0; idx < columns.length; idx++) {
	           if (columns[idx] == column) {
	                result = { cell: cellCounts[row], row: row };
	                break;
	           } else if (columns[idx].columns) {
	               result = columnPosition(column, columns[idx].columns, row + 1, cellCounts);
	               if (result) {
	                    break;
	               }
	           }

	           cellCounts[row]++;
	        }
	        return result;
	    }

	    function updateCellIndex(thead, columns, offset) {
	        offset = offset || 0;

	        var position;
	        var cell;
	        var allColumns = columns;
	        columns = leafColumns(columns);

	        var cells = {};
	        var rows = thead.find(">tr:not(.k-filter-row)");

	        var filter = function() {
	            var el = $(this);
	            return !el.hasClass("k-group-cell") && !el.hasClass("k-hierarchy-cell");
	        };

	        for (var idx = 0, length = columns.length; idx < length; idx++) {
	            position = columnPosition(columns[idx], allColumns);

	            if (!cells[position.row]) {
	                cells[position.row] = rows.eq(position.row)
	                    .find(".k-header")
	                    .filter(filter);
	            }

	            cell = cells[position.row].eq(position.cell);
	            cell.attr(kendo.attr("index"), offset + idx);
	        }

	        return columns.length;
	    }

	    function depth(columns) {
	        var result = 1;
	        var max = 0;

	        for (var idx = 0; idx < columns.length; idx++) {
	            if (columns[idx].columns) {
	                var temp = depth(columns[idx].columns);
	                if (temp > max) {
	                    max = temp;
	                }
	            }
	        }
	        return result + max;
	    }

	    function lockedColumns(columns) {
	        return grep(columns, is("locked"));
	    }

	    function nonLockedColumns(columns) {
	        return grep(columns, not(is("locked")));
	    }

	    function updateRowSpans(container, containerDOMtree) {
	        var rows = container.find("tr");
	        var length = rows.length;

	        rows.each(function (idx) {
	            var cells = this.cells;
	            for (var i = 0; i < cells.length; i++) {
	                if (cells[i].colSpan <= 1 && cells[i].attributes.rowspan) {
	                    containerDOMtree.children[idx].children[i].attr.rowSpan = length - idx;
	                    cells[i].rowSpan = length - idx;
	                }
	            }
	        });
	    }

	    function removeEmptyRows(container, containerDOMtree) {
	        var rows = container.find("tr");
	        var emptyRows = [];

	        rows.filter(function(idx) {
	            var shouldRemove = !$(this).children().length;
	            if (shouldRemove) {
	                emptyRows.push(idx);

	            }
	            return shouldRemove;
	        }).remove();

	        for (var i = emptyRows.length - 1; i >= 0; i--) {
	            containerDOMtree.children.splice(emptyRows[i], 1);
	        }

	        updateRowSpans(container, containerDOMtree);
	    }

	    function focusTable(table, direct) {
	      if (direct === true) {
	         table = $(table);
	         var scrollTop, scrollLeft;
	         scrollTop = table.parent().scrollTop();
	         scrollLeft = kendo.scrollLeft(table.parent());

	        kendo.focusElement(table);

	        kendo.scrollLeft(table.parent().scrollTop(scrollTop), scrollLeft);

	      } else {
	         $(table).one("focusin", function(e) { e.preventDefault(); }).focus();
	      }
	    }

	    function adjustRowHeight(row1, row2) {
	       var height;
	       var offsetHeight1 = row1.offsetHeight;
	       var offsetHeight2 = row2.offsetHeight;

	       if (offsetHeight1 > offsetHeight2) {
	           height = offsetHeight1 + "px";
	       } else if (offsetHeight1 < offsetHeight2) {
	           height = offsetHeight2 + "px";
	       }

	       if (height) {
	           row1.style.height = row2.style.height = height;
	       }
	    }

	    function isColumnEditable(column, model) {
	        if (!column || !model || !column.field || column.selectable || column.command || (column.editable && !column.editable(model))) {
	            return false;
	        }

	        return (column.field && model.editable && model.editable(column.field));
	    }

	    function isDirtyColumn(column, model) {
	        var field = (column || {}).field || "";
	        return (model.dirty && model.dirtyFields && model.dirtyFields[field] && isColumnEditable(column, model));
	    }

	    function isUndefined(value) {
	        return typeof(value) === "undefined";
	    }

	    function isNumber(value) {
	        return typeof value === "number" && !isNaN(value);
	    }

	    if (kendo.ExcelMixin) {
	        kendo.ExcelMixin.extend(TreeList.prototype);
	    }

	    if (kendo.PDFMixin) {
	        kendo.PDFMixin.extend(TreeList.prototype);

	       TreeList.prototype._drawPDF = function(progress) {
	           var treeList = this;

	           if (treeList.options.pdf.paperSize && treeList.options.pdf.paperSize != "auto") {
	               return treeList._drawPDF_autoPageBreak(progress);
	           }

	           var result = new $.Deferred();
	           var dataSource = treeList.dataSource;
	           var allPages = treeList.options.pdf.allPages;

	           this._initPDFProgress(progress);

	           // This group will be our document containing all pages
	           var doc = new kendo.drawing.Group();
	           var startingPage = dataSource.page();

	           function resolve() {
	               if (allPages && startingPage !== undefined) {
	                   dataSource.unbind("change", exportPage);
	                   dataSource.one("change", function() {
	                       result.resolve(doc);
	                   });

	                   dataSource.page(startingPage);
	               } else {
	                   result.resolve(doc);
	               }
	           }

	           function exportPage() {
	                treeList._drawPDFShadow({
	                    width: treeList.wrapper.width()
	                }, {
	                    avoidLinks: treeList.options.pdf.avoidLinks
	                })
	                .done(function(group) {
	                    var pageNum = dataSource.page();
	                    var totalPages = allPages ? dataSource.totalPages() : 1;

	                    var args = {
	                        page: group,
	                        pageNumber: pageNum,
	                        progress: pageNum / totalPages,
	                        totalPages: totalPages
	                    };

	                    progress.notify(args);
	                    doc.append(args.page);

	                    if (pageNum < totalPages) {
	                        dataSource.page(pageNum + 1);
	                    } else {
	                        resolve();
	                    }
	                })
	                .fail(function(err) {
	                    result.reject(err);
	                });
	            }

	            if (allPages) {
	                dataSource.bind("change", exportPage);
	                dataSource.page(1);
	            } else {
	                exportPage();
	            }

	            return result.promise();
	        };

	        TreeList.prototype._initPDFProgress = function(deferred) {
	            var loading = $("<div class='k-loading-pdf-mask'><div class='k-loading-color'></div></div>");
	            loading.prepend(this.wrapper.clone().css({
	                position: "absolute", top: 0, left: 0
	            }));

	            this.wrapper.append(loading);

	            var progressBar = $("<div class='k-loading-pdf-progress'>")
	                .appendTo(loading)
	                .kendoProgressBar({
	                    type: "chunk",
	                    chunkCount: 10,
	                    min: 0,
	                    max: 1,
	                    value: 0
	                }).data("kendoProgressBar");

	            deferred.progress(function(e) {
	                progressBar.value(e.progress);
	            })
	            .always(function() {
	                kendo.destroy(loading);
	                loading.remove();
	            });
	        };

	        TreeList.prototype._drawPDF_autoPageBreak = function(progress) {
	            var treeList = this;
	            var result = new $.Deferred();
	            var dataSource = treeList.dataSource;
	            var allPages = treeList.options.pdf.allPages;
	            var origBody = treeList.wrapper.find('table[role="treeList"] > tbody');
	            var cont = $("<div>")
	                .css({ position: "absolute", left: -10000, top: -10000 });
	            var clone = treeList.wrapper.clone().css({
	                height: "auto", width: "auto"
	            }).appendTo(cont);
	            clone.find(".k-grid-content").css({ height: "auto", width: "auto", overflow: "visible" });
	            clone.find('table[role="treeList"], .k-grid-footer table').css({ height: "auto", width: "100%", overflow: "visible" });
	            clone.find(".k-grid-pager, .k-grid-toolbar, .k-grouping-header").remove();
	            clone.find(".k-grid-header, .k-grid-footer").css({ paddingRight: 0 });

	            this._initPDFProgress(progress);

	            var body = clone.find('table[role="treeList"] > tbody').empty();
	            var startingPage = dataSource.page();

	            function resolve() {
	                if (allPages && startingPage !== undefined) {
	                    dataSource.one("change", draw);
	                    dataSource.page(startingPage);
	                } else {
	                    treeList.refresh();
	                    draw();
	                }
	            }

	            function draw() {
	                cont.appendTo(document.body);
	                var options = $.extend({}, treeList.options.pdf, {
	                    _destructive: true,
	                    progress: function(p) {
	                        progress.notify({
	                            page: p.page,
	                            pageNumber: p.pageNum,
	                            progress: 0.5 + p.pageNum / p.totalPages / 2,
	                            totalPages: p.totalPages
	                        });
	                    }
	                });
	                kendo.drawing.drawDOM(clone, options)
	                    .always(function(){
	                        cont.remove();
	                    })
	                    .then(function(group){
	                        result.resolve(group);
	                    })
	                    .fail(function(err){
	                        result.reject(err);
	                    });
	            }

	            function renderPage() {
	                var pageNum = dataSource.page();
	                var totalPages = allPages ? dataSource.totalPages() : 1;
	                body.append(origBody.find("tr"));
	                if (pageNum < totalPages) {
	                    dataSource.page(pageNum + 1);
	                } else {
	                    dataSource.unbind("change", renderPage);
	                    resolve();
	                }
	            }

	            if (allPages) {
	                dataSource.bind("change", renderPage);
	                dataSource.page(1);
	            } else {
	                renderPage();
	            }

	            return result.promise();
	        };
	    }

	    extend(true, kendo.data, {
	        TreeListDataSource: TreeListDataSource,
	        TreeListModel: TreeListModel
	    });

	    ui.plugin(TreeList);
	    ui.plugin(TreeListPager);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "UuGF":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "V1aE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var ToolPanelColumnComp = (function (_super) {
    __extends(ToolPanelColumnComp, _super);
    function ToolPanelColumnComp(column, columnDept, allowDragging) {
        var _this = _super.call(this) || this;
        _this.processingColumnStateChange = false;
        _this.column = column;
        _this.columnDept = columnDept;
        _this.allowDragging = allowDragging;
        return _this;
    }
    ToolPanelColumnComp.prototype.init = function () {
        this.setTemplate(ToolPanelColumnComp.TEMPLATE);
        this.displayName = this.columnController.getDisplayNameForColumn(this.column, 'toolPanel');
        this.eText.innerHTML = this.displayName;
        this.addCssClass('ag-toolpanel-indent-' + this.columnDept);
        if (this.allowDragging) {
            this.addDragSource();
        }
        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onColumnStateChanged.bind(this));
        this.addDestroyableEventListener(this.column, main_1.Column.EVENT_VALUE_CHANGED, this.onColumnStateChanged.bind(this));
        this.addDestroyableEventListener(this.column, main_1.Column.EVENT_PIVOT_CHANGED, this.onColumnStateChanged.bind(this));
        this.addDestroyableEventListener(this.column, main_1.Column.EVENT_ROW_GROUP_CHANGED, this.onColumnStateChanged.bind(this));
        this.addDestroyableEventListener(this.column, main_1.Column.EVENT_VISIBLE_CHANGED, this.onColumnStateChanged.bind(this));
        this.addDestroyableEventListener(this.gridOptionsWrapper, 'functionsReadOnly', this.onColumnStateChanged.bind(this));
        this.instantiate(this.context);
        this.onColumnStateChanged();
        this.addDestroyableEventListener(this.cbSelect, main_1.AgCheckbox.EVENT_CHANGED, this.onChange.bind(this));
        this.addDestroyableEventListener(this.eText, 'click', this.onClick.bind(this));
        this.addTap();
        main_1.CssClassApplier.addToolPanelClassesFromColDef(this.column.getColDef(), this.getGui(), this.gridOptionsWrapper, this.column, null);
    };
    ToolPanelColumnComp.prototype.addTap = function () {
        var touchListener = new main_1.TouchListener(this.getGui(), true);
        this.addDestroyableEventListener(touchListener, main_1.TouchListener.EVENT_TAP, this.onClick.bind(this));
        this.addDestroyFunc(touchListener.destroy.bind(touchListener));
    };
    ToolPanelColumnComp.prototype.onClick = function () {
        if (this.cbSelect.isReadOnly()) {
            return;
        }
        this.cbSelect.toggle();
    };
    ToolPanelColumnComp.prototype.onChange = function (event) {
        // only want to action if the user clicked the checkbox, not is we are setting the checkbox because
        // of a change in the model
        if (this.processingColumnStateChange) {
            return;
        }
        // action in a timeout, as the action takes some time, we want to update the icons first
        // so the user gets nice feedback when they click. otherwise there would be a lag and the
        // user would think the checkboxes were clunky
        if (this.columnController.isPivotMode()) {
            if (event.selected) {
                this.actionCheckedPivotMode();
            }
            else {
                this.actionUnCheckedPivotMode();
            }
        }
        else {
            this.columnController.setColumnVisible(this.column, event.selected, "columnMenu");
        }
    };
    ToolPanelColumnComp.prototype.actionUnCheckedPivotMode = function () {
        var functionPassive = this.gridOptionsWrapper.isFunctionsPassive();
        var column = this.column;
        var columnController = this.columnController;
        // remove pivot if column is pivoted
        if (column.isPivotActive()) {
            if (functionPassive) {
                var copyOfPivotColumns = this.columnController.getPivotColumns().slice();
                copyOfPivotColumns.push(column);
                var event_1 = {
                    type: main_1.Events.EVENT_COLUMN_PIVOT_CHANGE_REQUEST,
                    columns: copyOfPivotColumns,
                    api: this.gridApi,
                    columnApi: this.columnApi
                };
                this.eventService.dispatchEvent(event_1);
            }
            else {
                columnController.removePivotColumn(column, "columnMenu");
            }
        }
        // remove value if column is value
        if (column.isValueActive()) {
            if (functionPassive) {
                var copyOfValueColumns = this.columnController.getValueColumns().slice();
                copyOfValueColumns.push(column);
                var event_2 = {
                    type: main_1.Events.EVENT_COLUMN_VALUE_CHANGE_REQUEST,
                    columns: copyOfValueColumns,
                    api: this.gridApi,
                    columnApi: this.columnApi
                };
                this.eventService.dispatchEvent(event_2);
            }
            else {
                columnController.removeValueColumn(column, "columnMenu");
            }
        }
        // remove group if column is grouped
        if (column.isRowGroupActive()) {
            if (functionPassive) {
                var copyOfRowGroupColumns = this.columnController.getRowGroupColumns().slice();
                copyOfRowGroupColumns.push(column);
                var event_3 = {
                    type: main_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST,
                    columns: copyOfRowGroupColumns,
                    api: this.gridApi,
                    columnApi: this.columnApi
                };
                this.eventService.dispatchEvent(event_3);
            }
            else {
                columnController.removeRowGroupColumn(column, "columnMenu");
            }
        }
    };
    ToolPanelColumnComp.prototype.actionCheckedPivotMode = function () {
        var column = this.column;
        // function already active, so do nothing
        if (column.isValueActive() || column.isPivotActive() || column.isRowGroupActive()) {
            return;
        }
        var functionPassive = this.gridOptionsWrapper.isFunctionsPassive();
        if (column.isAllowValue()) {
            if (functionPassive) {
                var copyOfValueColumns = this.columnController.getValueColumns().slice();
                main_1.Utils.removeFromArray(copyOfValueColumns, column);
                var event_4 = {
                    type: main_1.Events.EVENT_COLUMN_VALUE_CHANGE_REQUEST,
                    api: this.gridApi,
                    columnApi: this.columnApi,
                    columns: copyOfValueColumns
                };
                this.eventService.dispatchEvent(event_4);
            }
            else {
                this.columnController.addValueColumn(column, "columnMenu");
            }
        }
        else if (column.isAllowRowGroup()) {
            if (functionPassive) {
                var copyOfRowGroupColumns = this.columnController.getRowGroupColumns().slice();
                main_1.Utils.removeFromArray(copyOfRowGroupColumns, column);
                var event_5 = {
                    type: main_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST,
                    api: this.gridApi,
                    columnApi: this.columnApi,
                    columns: copyOfRowGroupColumns
                };
                this.eventService.dispatchEvent(event_5);
            }
            else {
                this.columnController.addRowGroupColumn(column, "columnMenu");
            }
        }
        else if (column.isAllowPivot()) {
            if (functionPassive) {
                var copyOfPivotColumns = this.columnController.getPivotColumns().slice();
                main_1.Utils.removeFromArray(copyOfPivotColumns, column);
                var event_6 = {
                    type: main_1.Events.EVENT_COLUMN_PIVOT_CHANGE_REQUEST,
                    api: this.gridApi,
                    columnApi: this.columnApi,
                    columns: copyOfPivotColumns
                };
                this.eventService.dispatchEvent(event_6);
            }
            else {
                this.columnController.addPivotColumn(column, "columnMenu");
            }
        }
    };
    ToolPanelColumnComp.prototype.addDragSource = function () {
        var _this = this;
        var dragSource = {
            type: main_1.DragSourceType.ToolPanel,
            eElement: this.getGui(),
            dragItemName: this.displayName,
            dragItemCallback: function () { return _this.createDragItem(); }
        };
        this.dragAndDropService.addDragSource(dragSource, true);
        this.addDestroyFunc(function () { return _this.dragAndDropService.removeDragSource(dragSource); });
    };
    ToolPanelColumnComp.prototype.createDragItem = function () {
        var visibleState = {};
        visibleState[this.column.getId()] = this.column.isVisible();
        return {
            columns: [this.column],
            visibleState: visibleState
        };
    };
    ToolPanelColumnComp.prototype.onColumnStateChanged = function () {
        this.processingColumnStateChange = true;
        var isPivotMode = this.columnController.isPivotMode();
        if (isPivotMode) {
            // if reducing, checkbox means column is one of pivot, value or group
            var anyFunctionActive = this.column.isAnyFunctionActive();
            this.cbSelect.setSelected(anyFunctionActive);
        }
        else {
            // if not reducing, the checkbox tells us if column is visible or not
            this.cbSelect.setSelected(this.column.isVisible());
        }
        var checkboxReadOnly;
        if (isPivotMode) {
            // when in pivot mode, the item should be read only if:
            //  a) gui is not allowed make any changes
            var functionsReadOnly = this.gridOptionsWrapper.isFunctionsReadOnly();
            //  b) column is not allow any functions on it
            var noFunctionsAllowed = !this.column.isAnyFunctionAllowed();
            checkboxReadOnly = functionsReadOnly || noFunctionsAllowed;
        }
        else {
            // when in normal mode, the checkbox is read only if visibility is locked
            checkboxReadOnly = this.column.isLockVisible();
        }
        this.cbSelect.setReadOnly(checkboxReadOnly);
        var checkboxPassive = isPivotMode && this.gridOptionsWrapper.isFunctionsPassive();
        this.cbSelect.setPassive(checkboxPassive);
        this.processingColumnStateChange = false;
    };
    ToolPanelColumnComp.TEMPLATE = '<div class="ag-column-select-column">' +
        '<ag-checkbox class="ag-column-select-checkbox"></ag-checkbox>' +
        '<span class="ag-column-select-label"></span>' +
        '</div>';
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], ToolPanelColumnComp.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        main_1.Autowired('columnController'),
        __metadata("design:type", main_1.ColumnController)
    ], ToolPanelColumnComp.prototype, "columnController", void 0);
    __decorate([
        main_1.Autowired('eventService'),
        __metadata("design:type", main_1.EventService)
    ], ToolPanelColumnComp.prototype, "eventService", void 0);
    __decorate([
        main_1.Autowired('dragAndDropService'),
        __metadata("design:type", main_1.DragAndDropService)
    ], ToolPanelColumnComp.prototype, "dragAndDropService", void 0);
    __decorate([
        main_1.Autowired('gridPanel'),
        __metadata("design:type", main_1.GridPanel)
    ], ToolPanelColumnComp.prototype, "gridPanel", void 0);
    __decorate([
        main_1.Autowired('context'),
        __metadata("design:type", main_1.Context)
    ], ToolPanelColumnComp.prototype, "context", void 0);
    __decorate([
        main_1.Autowired('columnApi'),
        __metadata("design:type", main_1.ColumnApi)
    ], ToolPanelColumnComp.prototype, "columnApi", void 0);
    __decorate([
        main_1.Autowired('gridApi'),
        __metadata("design:type", main_1.GridApi)
    ], ToolPanelColumnComp.prototype, "gridApi", void 0);
    __decorate([
        main_1.QuerySelector('.ag-column-select-label'),
        __metadata("design:type", HTMLElement)
    ], ToolPanelColumnComp.prototype, "eText", void 0);
    __decorate([
        main_1.QuerySelector('.ag-column-select-indent'),
        __metadata("design:type", HTMLElement)
    ], ToolPanelColumnComp.prototype, "eIndent", void 0);
    __decorate([
        main_1.QuerySelector('.ag-column-select-checkbox'),
        __metadata("design:type", main_1.AgCheckbox)
    ], ToolPanelColumnComp.prototype, "cbSelect", void 0);
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ToolPanelColumnComp.prototype, "init", null);
    return ToolPanelColumnComp;
}(main_1.Component));
exports.ToolPanelColumnComp = ToolPanelColumnComp;


/***/ }),

/***/ "VT9e":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1564);
	module.exports = __webpack_require__(1564);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 967:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CRfZ");

/***/ }),

/***/ 968:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1Z35");

/***/ }),

/***/ 1564:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1565), __webpack_require__(968), __webpack_require__(1566), __webpack_require__(1567), __webpack_require__(967)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {
	    var kendo = window.kendo,
	        extend = $.extend,
	        Class = kendo.Class,
	        EXTENSIONS = {
	            svg: ".svg",
	            png: ".png"
	        },
	        keys = kendo.keys;

	    var ErrorDialog = Class.extend({
	        init: function (options) {
	            this.options = extend(options, {
	                actions: [{
	                    text: options.messages.dialogs.okText
	                }]
	            });
	            this._dialog = $("<div />")
	                    .kendoDialog(this.options)
	                    .getKendoDialog();
	        },
	        open: function () {
	            this._dialog.center().open();
	        }
	    });

	    var ExportAsDialog = Class.extend({
	        init: function (options) {
	            this.options = extend(options, this.options, {
	                fileFormats: [{
	                    description: options.messages.dialogs.exportAsDialog.png,
	                    extension: EXTENSIONS.png
	                }, {
	                    description: options.messages.dialogs.exportAsDialog.svg,
	                    extension: EXTENSIONS.svg
	                }],
	                title: options.messages.dialogs.exportAsDialog.title,
	                open: function() {
	                    this.center();
	                }
	            });
	            this._initializeDialog();
	            return this;
	        },
	        options: {
	            extension: EXTENSIONS.png,
	            autoFocus: true,
	            resizable: false,
	            modal: {
	                preventScroll: true
	            },
	            width: "90%",
	            maxWidth: 520,
	            template:
	                "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.fileName #:</label></div>" +
	                "<div class='k-edit-field'>" +
	                    "<input class='k-textbox' data-bind='value: name' />" +
	                "</div>" +
	                "<div>" +
	                    "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.saveAsType #:</label></div>" +
	                    "<div class='k-edit-field'>" +
	                    "<select data-role='dropdownlist' class='k-file-format' " +
	                        "data-text-field='description' " +
	                        "data-value-field='extension' " +
	                        "data-bind='value: extension, source: fileFormats'></select>" +
	                    "</div>" +
	                "</div>" +
	                "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.page #:</label></div>" +
	                "<div class='k-edit-field'>" +
	                    "<input data-role='numerictextbox' data-format='n0' data-min='1' data-max='#: total #' data-bind='value: page' />" +
	                "</div>" +
	                "<div class='k-action-buttons'>" +
	                    "<button class='k-button k-primary' data-bind='click: apply'>#: messages.save #</button>" +
	                    "<button class='k-button' data-bind='click: close'>#: messages.cancel #</button>" +
	                "</div>"
	        },
	        _updateModel: function (options) {
	            if (options.pagesCount) {
	                this.viewModel.set("pagesCount", options.pagesCount);
	            }
	            if (options.page) {
	                this.viewModel.set("page", options.page);
	            }
	        },
	        _initializeDialog: function () {
	            var that = this;
	            var options = that.options;
	            var dialogMessages = options.messages.dialogs;
	            var dialog = $("<div class='k-pdf-viewer-window k-action-window k-popup-edit-form' />")
	                    .append(kendo.template(options.template)({
	                        total: options.pagesCount,
	                        messages: dialogMessages
	                    }))
	                    .kendoWindow(options)
	                    .getKendoWindow();

	            that.viewModel = kendo.observable({
	                title: dialogMessages.exportAsDialog.title,
	                name: dialogMessages.exportAsDialog.defaultFileName,
	                extension: options.extension,
	                fileFormats: options.fileFormats,
	                pagesCount: options.pagesCount,
	                page: 1,
	                apply: that.apply.bind(this),
	                close: function () {
	                    dialog.close();
	                }
	            });

	            that._dialog = dialog;

	            kendo.bind(dialog.element, that.viewModel);
	            return dialog;
	        },
	        open: function() {
	            this._dialog.center().open();
	        },
	        apply: function() {
	            this._dialog.close();
	            this.options.apply({
	                fileName: this.viewModel.name + this.viewModel.extension,
	                extension: this.viewModel.extension,
	                page: this.viewModel.page
	            });
	        }
	    });

	    var SearchDialog = Class.extend({
	        init: function (options) {
	            var that = this;
	            that.options = extend({}, options, that.options);
	        },
	        options: {
	            resizable: false,
	            template: "<div class='k-search-container'>" +
	                          "<button class='k-button k-button-icon k-flat k-search-dialog-draghandle'><span class='k-icon k-i-handler-drag'></span></button>" +
	                          "<span class='k-textbox'>" +
	                              "<input class='k-search-dialog-input' data-bind='value: boundValue, events: { keyup: onKeyup, input: onInput }' aria-label='#: messages.inputLabel #' title='#: messages.inputLabel #' />" +
	                              "<button class='k-button k-button-icon k-flat k-match-case-button' data-bind='css: {k-state-selected: matchCase}, click: matchCaseClick' aria-label='#: messages.matchCase #' title='#: messages.matchCase #'><span class='k-icon k-i-convert-lowercase'></span></button>" +
	                          "</span>" +
	                          "<span class='k-search-matches'><span data-bind='text: matchIndex'></span> #: messages.of # <span data-bind='text: matches'></span></span>" +
	                          "<button class='k-button k-button-icon k-flat' data-bind='click: prev' aria-label='#: messages.previous #' title='#: messages.previous #'><span class='k-icon k-i-arrow-up'></span></button>" +
	                          "<button class='k-button k-button-icon k-flat' data-bind='click: next' aria-label='#: messages.next #' title='#: messages.next #'><span class='k-icon k-i-arrow-down'></span></button>" +
	                          "<button class='k-button k-button-icon k-flat' data-bind='click: close' aria-label='#: messages.close #' title='#: messages.close #'><span class='k-icon k-i-close'></<span></button>" +
	                      "</div>"
	        },
	        open: function () {
	            var that = this;

	            if(!that.dialog) {
	                that._initializeDialog();
	            }

	            that.dialog.open();
	        },
	        _initializeDialog: function () {
	            var that = this;
	            var template = kendo.template(that.options.template);
	            var dialogElm = $("<div class='k-pdf-viewer-search-dialog'></div>").append(template({
	                messages: that.options.messages
	            }));
	            var dialogOffset = {
	                top: that.options.position.top + 16,
	                left: that.options.position.left + 16
	            };

	            that.dialog = new kendo.ui.Window(dialogElm, extend({}, that.options, {
	                autoFocus: false,
	                title: false,
	                position: { top: dialogOffset.top, left: dialogOffset.left },
	                minHeight: 30,
	                draggable: {
	                    dragHandle: ".k-search-dialog-draghandle"
	                },
	                activate: function (ev) {
	                    ev.sender.element.find(".k-search-dialog-input").focus();
	                }
	            }));

	            that.searchModel = kendo.observable({
	                boundValue: "",
	                searchText: "",
	                matchCase: false,
	                matchIndex: 0,
	                matches: 0,
	                matchCaseClick: function () {
	                    this.set("matchCase", !this.matchCase);
	                },
	                next: that.options.next,
	                prev: that.options.prev,
	                close: function () {
	                    this.set("boundValue", "");
	                    that.dialog.close();
	                },
	                onKeyup: function (ev) {
	                    var key = ev.keyCode;
	                    var navigationFn = ev.shiftKey ? this.prev : this.next;

	                    if(key === keys.ENTER) {
	                        navigationFn();
	                        ev.preventDefault();
	                    }
	                },
	                onInput: function (ev) {
	                    this.set("searchText", ev.target.value);
	                }
	            });

	            kendo.bind(that.dialog.element, that.searchModel);
	        }
	    });

	    extend(kendo.pdfviewer, {
	        dialogs: {
	            ErrorDialog: ErrorDialog,
	            ExportAsDialog: ExportAsDialog,
	            SearchDialog: SearchDialog
	        }
	    });
	})(window.kendo.jQuery);

	return window.kendo;
	}, __webpack_require__(3));

/***/ }),

/***/ 1565:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Owf0");

/***/ }),

/***/ 1566:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ydSV");

/***/ }),

/***/ 1567:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("99zt");

/***/ })

/******/ });

/***/ }),

/***/ "VU/8":
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "Vaij":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: String,
        default: undefined
    },
    animation: {
        type: Object,
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    cascadeFrom: {
        type: String,
        default: undefined
    },
    cascadeFromField: {
        type: String,
        default: undefined
    },
    cascadeFromParentField: {
        type: String,
        default: undefined
    },
    columns: {
        type: Array,
        default: undefined
    },
    clearButton: {
        type: Boolean,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    dataValueField: {
        type: String,
        default: undefined
    },
    dropDownWidth: {
        type: [String, Number],
        default: undefined
    },
    delay: {
        type: Number,
        default: undefined
    },
    enable: {
        type: Boolean,
        default: undefined
    },
    enforceMinLength: {
        type: Boolean,
        default: undefined
    },
    filter: {
        type: String,
        default: undefined
    },
    filterFields: {
        type: Array,
        default: undefined
    },
    fixedGroupTemplate: {
        type: [String, Function],
        default: undefined
    },
    footerTemplate: {
        type: [String, Function],
        default: undefined
    },
    groupTemplate: {
        type: [String, Function],
        default: undefined
    },
    height: {
        type: Number,
        default: undefined
    },
    highlightFirst: {
        type: Boolean,
        default: undefined
    },
    ignoreCase: {
        type: Boolean,
        default: undefined
    },
    index: {
        type: Number,
        default: undefined
    },
    minLength: {
        type: Number,
        default: undefined
    },
    noDataTemplate: {
        type: [String, Function],
        default: undefined
    },
    placeholder: {
        type: String,
        default: undefined
    },
    popup: {
        type: Object,
        default: undefined
    },
    suggest: {
        type: Boolean,
        default: undefined
    },
    syncValueAndText: {
        type: Boolean,
        default: undefined
    },
    headerTemplate: {
        type: [String, Function],
        default: undefined
    },
    text: {
        type: String,
        default: undefined
    },
    value: {
        type: String,
        default: undefined
    },
    valuePrimitive: {
        type: Boolean,
        default: undefined
    },
    virtual: {
        type: [Boolean, Object],
        default: undefined
    },

    // Events
    change: Function,
    close: Function,
    dataBound: {
        type: Function,
        default: undefined
    },
    filtering: Function,
    open: Function,
    select: Function,
    cascade: Function
};

/***/ }),

/***/ "Vn5t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var component_1 = __webpack_require__("pQ38");
var AnimateSlideCellRenderer = (function (_super) {
    __extends(AnimateSlideCellRenderer, _super);
    function AnimateSlideCellRenderer() {
        var _this = _super.call(this, AnimateSlideCellRenderer.TEMPLATE) || this;
        _this.refreshCount = 0;
        _this.eCurrent = _this.queryForHtmlElement('.ag-value-slide-current');
        return _this;
    }
    AnimateSlideCellRenderer.prototype.init = function (params) {
        this.params = params;
        this.refresh(params);
    };
    AnimateSlideCellRenderer.prototype.addSlideAnimation = function () {
        var _this = this;
        this.refreshCount++;
        // below we keep checking this, and stop working on the animation
        // if it no longer matches - this means another animation has started
        // and this one is stale.
        var refreshCountCopy = this.refreshCount;
        // if old animation, remove it
        if (this.ePrevious) {
            this.getGui().removeChild(this.ePrevious);
        }
        this.ePrevious = utils_1.Utils.loadTemplate('<span class="ag-value-slide-previous ag-value-slide-out"></span>');
        this.ePrevious.innerHTML = this.eCurrent.innerHTML;
        this.getGui().insertBefore(this.ePrevious, this.eCurrent);
        // having timeout of 0 allows use to skip to the next css turn,
        // so we know the previous css classes have been applied. so the
        // complex set of setTimeout below creates the animation
        setTimeout(function () {
            if (refreshCountCopy !== _this.refreshCount) {
                return;
            }
            utils_1.Utils.addCssClass(_this.ePrevious, 'ag-value-slide-out-end');
        }, 50);
        setTimeout(function () {
            if (refreshCountCopy !== _this.refreshCount) {
                return;
            }
            _this.getGui().removeChild(_this.ePrevious);
            _this.ePrevious = null;
        }, 3000);
    };
    AnimateSlideCellRenderer.prototype.refresh = function (params) {
        var value = params.value;
        if (utils_1.Utils.missing(value)) {
            value = '';
        }
        if (value === this.lastValue) {
            return;
        }
        this.addSlideAnimation();
        this.lastValue = value;
        if (utils_1.Utils.exists(params.valueFormatted)) {
            this.eCurrent.innerHTML = params.valueFormatted;
        }
        else if (utils_1.Utils.exists(params.value)) {
            this.eCurrent.innerHTML = value;
        }
        else {
            this.eCurrent.innerHTML = '';
        }
        return true;
    };
    AnimateSlideCellRenderer.TEMPLATE = '<span>' +
        '<span class="ag-value-slide-current"></span>' +
        '</span>';
    return AnimateSlideCellRenderer;
}(component_1.Component));
exports.AnimateSlideCellRenderer = AnimateSlideCellRenderer;


/***/ }),

/***/ "VqpB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__("ungA");

var _MultiSelectProps = __webpack_require__("awzK");

var _MultiSelectProps2 = _interopRequireDefault(_MultiSelectProps);

var _Animation = __webpack_require__("dGGS");

var _Animation2 = _interopRequireDefault(_Animation);

var _Popup = __webpack_require__("rQ4N");

var _Popup2 = _interopRequireDefault(_Popup);

var _Virtual = __webpack_require__("ZSoY");

var _Virtual2 = _interopRequireDefault(_Virtual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _MultiSelectProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _Animation2.default, _Popup2.default, _Virtual2.default],
    mounted: function mounted() {
        var that = this;
        var widgetElement = that.$el;

        kendo.jQuery(widgetElement).kendoMultiSelect(that.widgetOptions);

        if (this.v3) {
            this.ready();
        }

        that.$emit('kendowidgetready', that.kendoWidget());

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', that.kendoWidget().value());
            } else {
                that.$emit('changemodel', that.kendoWidget().value());
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            var widgetElement = this.$el;

            return kendo.jQuery(widgetElement).getKendoMultiSelect();
        }
    },
    model: {
        event: 'changemodel'
    }
};

/***/ }),

/***/ "W2nU":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "W8+b":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1375);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1369:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("dWoE");

/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1369) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "scheduler.monthview",
	    name: "Scheduler Month View",
	    category: "web",
	    description: "The Scheduler Month View",
	    depends: [ "scheduler.view" ],
	    hidden: true
	};

	(function($){
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        SchedulerView = ui.SchedulerView,
	        NS = ".kendoMonthView",
	        extend = $.extend,
	        getDate = kendo.date.getDate,
	        MS_PER_DAY = kendo.date.MS_PER_DAY,
	        NUMBER_OF_ROWS = 6,
	        NUMBER_OF_COLUMNS = 7,
	        INVERSE_COLOR_CLASS = "k-event-inverse",
	        DAY_TEMPLATE = kendo.template('<span class="k-link k-nav-day">#:kendo.toString(date, "dd")#</span>'),
	        EVENT_WRAPPER_STRING = '<div role="gridcell" aria-selected="false" data-#=ns#uid="#=uid#"' +
	                '#if (resources[0]) { #' +
	                    'style="background-color:#=resources[0].color #; border-color: #=resources[0].color#"' +
	                    'class="k-event"' +
	                '#} else {#' +
	                    'class="k-event"' +
	                '#}#' +
	                '>' +
	                '<span class="k-event-actions">' +
	                    '# if (data.tail || data.middle) {#' +
	                        '<span class="k-icon k-i-arrow-60-left"></span>' +
	                    '#}#' +
	                    '# if (data.isException()) {#' +
	                        '<span class="k-icon k-i-non-recurrence"></span>' +
	                    '# } else if (data.isRecurring()) {#' +
	                        '<span class="k-icon k-i-reload"></span>' +
	                    '#}#' +
	                '</span>' +
	                '{0}' +
	                '<span class="k-event-actions">' +
	                    '#if (showDelete) {#' +
	                        '<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>' +
	                    '#}#' +
	                    '# if (data.head || data.middle) {#' +
	                        '<span class="k-icon k-i-arrow-60-right"></span>' +
	                    '#}#' +
	                '</span>' +
	                '# if (resizable && !data.tail && !data.middle) {#' +
	                '<span class="k-resize-handle k-resize-w"></span>' +
	                '#}#' +
	                '# if (resizable && !data.head && !data.middle) {#' +
	                '<span class="k-resize-handle k-resize-e"></span>' +
	                '#}#' +
	                '</div>',
	        EVENT_TEMPLATE = kendo.template('<div title="#=title.replace(/"/g,"&\\#34;")#">' +
	                    '<div class="k-event-template">#:title#</div>' +
	                '</div>');

	    var CELL_INNER_SPACING = 2;

	    var MORE_BUTTON_TEMPLATE = kendo.template(
	        '<div style="width:#=width#px;left:#=left#px;top:#=top#px" class="k-more-events k-button"><span class="k-icon k-i-more-horizontal"></span></div>'
	    );

	    var MonthGroupedView = kendo.Class.extend({
	        init: function(view) {
	            this._view = view;
	        },

	        _verticalRowCountForLevel: function(level) {
	            var view = this._view;

	            return view._rowCountForLevel(level);
	        },

	        _horizontalGroupCountForLevel: function(level) {
	            var view = this._view;

	            return view._columnCountForLevel(level);
	        },

	        _getCalendarRowsLength: function(cellsPerRow, cellCount) {
	            return cellCount / cellsPerRow;
	        },

	        _createRows: function(start, startIdx, horizontalGroupCount, verticalGroupIndex) {
	            var view = this._view;
	            var cellsPerRow = NUMBER_OF_COLUMNS;
	            var isVerticallyGrouped = view._isVerticallyGrouped();
	            var html = "";

	            for (var groupIdx = 0; groupIdx < horizontalGroupCount; groupIdx++) {
	                html += view._createRow(start, startIdx, cellsPerRow, isVerticallyGrouped ? verticalGroupIndex : groupIdx);
	            }

	            return html;
	        },

	        _adjustStartDate: function(start) {
	            return kendo.date.addDays(start, NUMBER_OF_COLUMNS);
	        },

	        _getContent: function(content, startDate, resources) {
	            return content({ date: startDate, resources: resources });
	        },

	        _getTimeSlotByPosition: function(x, y, groupIndex) {
	            var group = this._view.groups[groupIndex];

	            return group.daySlotByPosition(x, y);
	        },

	        _nextSlotStartDate: function(startDate) {
	            return kendo.date.nextDay(startDate);
	        },

	        _createRowsLayout: function(resources, rows, groupHeaderTemplate) {
	            var view = this._view;

	            return view._createRowsLayout(resources, rows, groupHeaderTemplate);
	        },

	        _createVerticalColumnsLayout: function(resources, rows, groupHeaderTemplate, columns) {

	            return columns;
	        },

	        _createColumnsLayout: function(resources, columns, groupHeaderTemplate) {
	            var view = this._view;

	            return view._createColumnsLayout(resources, columns, groupHeaderTemplate);
	        },

	        _verticalGroupCount: function(level) {
	            var view = this._view;

	            return view._rowCountForLevel(level);
	        },

	        _horizontalGroupCount: function(level) {
	            var view = this._view;

	            return view._columnCountForLevel(level) / view._columnOffsetForResource(level);
	        },

	        _positionMobileEvent: function(event, group, range, rangeCount, start, end, rangeIndex){
	            var view = this._view;

	            if (rangeCount > 1) {
	                if (rangeIndex === 0) {
	                    end = range.end.endDate();
	                } else if (rangeIndex == rangeCount - 1) {
	                    start = range.start.startDate();
	                } else {
	                    start = range.start.startDate();
	                    end = range.end.endDate();
	                }
	            }

	            var occurrence = event.clone({ start: start, end: end, head: range.head, tail: range.tail });

	            view._positionMobileEvent(range, view._createEventElement(occurrence), group);
	        },

	        _positionEvent: function(event, group, range, rangeCount, start, end, rangeIndex){
	            var view = this._view;

	            if (rangeCount > 1) {
	                if (rangeIndex === 0) {
	                    end = range.end.endDate();
	                } else if (rangeIndex == rangeCount - 1) {
	                    start = range.start.startDate();
	                } else {
	                    start = range.start.startDate();
	                    end = range.end.endDate();
	                }
	            }

	            var occurrence = event.clone({ start: start, end: end, head: range.head, tail: range.tail });

	            view._positionEvent(range, view._createEventElement(occurrence), group);
	        },

	        _addDaySlotCollections: function(groupCount, tableRows, startDate) {
	            var view = this._view;
	            var columnCount = NUMBER_OF_COLUMNS;
	            var rowCount = NUMBER_OF_ROWS;

	            for (var groupIndex = 0; groupIndex < groupCount; groupIndex++) {
	                var cellCount = 0;
	                var rowMultiplier = 0;

	                if (view._isVerticallyGrouped()) {
	                    rowMultiplier = groupIndex;
	                }

	                for (var rowIndex = rowMultiplier * rowCount; rowIndex < (rowMultiplier + 1) * rowCount; rowIndex++) {
	                    var group = view.groups[groupIndex];
	                    var collection = group.addDaySlotCollection(kendo.date.addDays(startDate, cellCount), kendo.date.addDays(startDate, cellCount + columnCount));

	                    var tableRow = tableRows[rowIndex];
	                    var cells = tableRow.children;
	                    var cellMultiplier = 0;

	                    tableRow.setAttribute("role", "row");

	                    if (!view._isVerticallyGrouped()) {
	                        cellMultiplier = groupIndex;
	                    }

	                    for (var cellIndex = cellMultiplier * columnCount; cellIndex < (cellMultiplier + 1) * columnCount; cellIndex++) {
	                        var cell = cells[cellIndex];

	                        view.addDaySlot(collection, cell, startDate, cellCount);
	                        cellCount++;
	                    }
	                }
	            }
	        },

	        _changePeriodGroupIndex: function(reverse){
	            var view = this._view;

	            return reverse ? view.groups.length - 1 : 0;
	        },

	        _createResizeHint: function(range) {
	            var view = this._view;
	            var left = range.startSlot().offsetLeft;
	            var top = range.start.offsetTop;
	            var width = range.innerWidth();
	            var height = range.start.clientHeight - 2;
	            var hint = SchedulerView.fn._createResizeHint.call(view, left, top, width, height);

	            view._appendResizeHint(hint);
	        },

	        _createMoveHint: function(range, event) {
	            var view = this._view;
	            var startSlot = range.startSlot();
	            var endSlot = range.endSlot();
	            var hint = view._createEventElement(event.clone({ head: range.head, tail: range.tail }));

	            hint.css({
	                left: startSlot.offsetLeft + 2,
	                top: startSlot.offsetTop + startSlot.firstChildHeight,
	                height: (view.options.eventHeight === "auto") ? 25 : view.options.eventHeight,
	                width: range.innerWidth() - (startSlot.index !== endSlot.index ? 3 : 2)
	            });

	            hint.addClass("k-event-drag-hint");

	            if (event.inverseColor) {
	                hint.addClass(INVERSE_COLOR_CLASS);
	            }

	            view._appendMoveHint(hint);
	        }
	    });

	    var MonthGroupedByDateView = kendo.Class.extend({
	        init: function(view) {
	            this._view = view;
	        },

	        _verticalRowCountForLevel: function() {
	            return 1;
	        },

	        _horizontalGroupCountForLevel: function(level) {
	            var view = this._view;

	            return view._columnCountForLevel(level + 1) / NUMBER_OF_COLUMNS;
	        },

	        _createRows: function(start, startIdx, horizontalGroupCount) {
	            var view = this._view;
	            var cellsPerRow = NUMBER_OF_COLUMNS;
	            var isVerticallyGrouped = view._isVerticallyGrouped();
	            var html = "";
	            var dateIdx = 0;

	            if (isVerticallyGrouped) {
	                var verticalStart = new Date(start);
	                var groupCount = view._groupCount();
	                for (dateIdx; dateIdx < NUMBER_OF_ROWS; dateIdx++) {
	                    html += view._createRow(verticalStart, startIdx, groupCount, dateIdx);

	                    verticalStart = kendo.date.addDays(verticalStart, cellsPerRow);
	                }
	                start = kendo.date.nextDay(start);
	            } else {
	                for (dateIdx; dateIdx < cellsPerRow; dateIdx++) {
	                    html += view._createRow(start, startIdx, horizontalGroupCount, dateIdx);
	                    start = kendo.date.nextDay(start);
	                }
	                start = kendo.date.addDays(start, cellsPerRow);
	            }

	            return html;
	        },

	        _adjustStartDate: function(start, isLastRow) {
	            var view = this._view;
	            var isVerticallyGrouped = view._isVerticallyGrouped();

	            if (isVerticallyGrouped) {
	                if (isLastRow) {
	                    return kendo.date.addDays(start, NUMBER_OF_COLUMNS * (NUMBER_OF_ROWS - 1) + 1);
	                } else {
	                    return kendo.date.nextDay(start);
	                }
	            }

	            return kendo.date.addDays(start, NUMBER_OF_COLUMNS);
	        },

	        _getContent: function(content, startDate, resources, cellIdx) {
	            if (cellIdx === 0) {
	                return content({ date: startDate, resources: resources });
	            }
	            return "";
	        },

	        _getTimeSlotByPosition: function(x, y, groupIndex) {
	            var group = this._view.groups[groupIndex];

	            return group.daySlotByPosition(x, y, true);
	        },

	        _nextSlotStartDate: function(startDate) {
	            return startDate;
	        },

	        _getCalendarRowsLength: function() {
	            var view = this._view;
	            var isVerticallyGrouped = view._isVerticallyGrouped();

	            return isVerticallyGrouped ? NUMBER_OF_COLUMNS : NUMBER_OF_ROWS;
	        },

	        _createRowsLayout: function(resources, rows, groupHeaderTemplate, columns) {
	            var view = this._view;

	            return view._createDateLayout(columns, null, false);
	        },

	        _createVerticalColumnsLayout: function(resources, rows, groupHeaderTemplate) {
	            var view = this._view;
	            var resource = resources[0];
	            var configuration = [];
	            var data = resource.dataSource.view();

	            for (var dataIndex = 0; dataIndex < data.length * NUMBER_OF_ROWS; dataIndex++) {
	                var obj = {
	                    text: groupHeaderTemplate({
	                        text: kendo.htmlEncode(kendo.getter(resource.dataTextField)(data[dataIndex % data.length])),
	                        color: kendo.getter(resource.dataColorField)(data[dataIndex % data.length]),
	                        field: resource.field,
	                        title: resource.title,
	                        name: resource.name,
	                        value: kendo.getter(resource.dataValueField)(data[dataIndex % data.length])
	                    }),
	                    className: "k-slot-cell"
	                };
	                obj.columns = view._createColumnsLayout(resources.slice(1), null, groupHeaderTemplate);

	                configuration.push(obj);
	            }

	            return configuration;
	        },

	        _createColumnsLayout: function(resources, columns, groupHeaderTemplate, subColumns) {
	            var view = this._view;

	            return view._createColumnsLayout(resources, columns, groupHeaderTemplate, subColumns, true);
	        },

	        _verticalGroupCount: function(level) {
	            var view = this._view;

	            return view._columnCountForLevel(level) / NUMBER_OF_ROWS;
	        },

	        _horizontalGroupCount: function(level) {
	            var view = this._view;
	            return view._columnCountForLevel(level) / NUMBER_OF_COLUMNS;
	        },

	        _positionMobileEvent: function(event, group, range, rangeCount, start, end){
	            var view = this._view;
	            var startIndex = range.start.index;
	            var endIndex = range.end.index;

	            for (var i = range.start.index; i <= range.end.index; i++) {
	                var currentSlot = range.collection._slots[i];
	                var dateRange = group.daySlotRanges(currentSlot.start, currentSlot.start, true)[0];

	                var occurrence = event.clone({
	                    start: i === startIndex ? start: currentSlot.startDate(),
	                    end: i === endIndex ? end : currentSlot.endDate(),
	                    head: i !== endIndex || range.head,
	                    tail: i !== startIndex || range.tail });

	                view._positionMobileEvent(dateRange, view._createEventElement(occurrence), group);
	            }
	        },

	        _positionEvent: function(event, group, range, rangeCount, start, end){
	            var view = this._view;
	            var startIndex = range.start.index;
	            var endIndex = range.end.index;

	            for (var i = range.start.index; i <= range.end.index; i++) {
	                var currentSlot = range.collection._slots[i];
	                var dateRange = group.daySlotRanges(currentSlot.start, currentSlot.start, true)[0];

	                var occurrence = event.clone({
	                    start: i === startIndex ? start: currentSlot.startDate(),
	                    end: i === endIndex ? end : currentSlot.endDate(),
	                    head: i !== endIndex || range.head,
	                    tail: i !== startIndex || range.tail });

	                view._positionEvent(dateRange, view._createEventElement(occurrence), group);
	            }
	        },

	        _addDaySlotCollections: function(groupCount, tableRows, startDate) {
	            var view = this._view;
	            var columnCount = NUMBER_OF_COLUMNS;
	            var rowCount = NUMBER_OF_ROWS;
	            var isVerticallyGrouped = view._isVerticallyGrouped();

	            for (var dateIndex = 0; dateIndex < columnCount; dateIndex++) {
	                for (var rowIndex = 0; rowIndex < rowCount; rowIndex++) {
	                    var groupIndex = 0;
	                    var currentTableIndex = isVerticallyGrouped ? dateIndex : rowIndex;
	                    var tableRow = tableRows[currentTableIndex];
	                    var cells = tableRow.children;
	                    var cellMultiplier = 0;

	                    tableRow.setAttribute("role", "row");

	                    if (!view._isVerticallyGrouped()) {
	                        cellMultiplier = dateIndex;
	                    }

	                    for (var cellIndex = cellMultiplier * groupCount; cellIndex < (cellMultiplier + 1) * groupCount; cellIndex++) {
	                        var cellCount = (rowIndex * columnCount) + dateIndex;
	                        var currentCellIndex = isVerticallyGrouped ? cellIndex + (rowIndex * groupCount) : cellIndex;
	                        var cell = cells[currentCellIndex];
	                        var currentGroupIndex = isVerticallyGrouped ? cellIndex : groupIndex;
	                        var group = view.groups[currentGroupIndex];
	                        var collection;
	                        if (dateIndex === 0) {
	                            collection = group.addDaySlotCollection(kendo.date.addDays(startDate, cellCount), kendo.date.addDays(startDate, cellCount + columnCount));
	                        } else {
	                            collection = group._daySlotCollections[rowIndex];
	                        }

	                        view.addDaySlot(collection, cell, startDate, cellCount);
	                        groupIndex++;
	                    }
	                }
	            }
	        },

	        _changePeriodGroupIndex: function(reverse, vertical, selectionGroupIndex){
	            var view = this._view;

	            if (vertical && view._isVerticallyGrouped()){
	                return reverse ? view.groups.length - 1 : 0;
	            }

	            return selectionGroupIndex;
	        },

	        _createResizeHint: function(range) {
	            var view = this._view;
	            var left, top, width, height, hint;

	            if (view._isVerticallyGrouped()) {
	            left = range.startSlot().offsetLeft;
	            top = range.start.offsetTop;
	            width = range.startSlot().offsetWidth;
	            height = range.endSlot().offsetTop + range.startSlot().offsetHeight - range.startSlot().offsetTop - 2;
	            hint = SchedulerView.fn._createResizeHint.call(view, left, top, width, height);

	            view._appendResizeHint(hint);
	            } else {
	                for (var slotIdx = range.startSlot().index; slotIdx <= range.endSlot().index; slotIdx++) {
	                    var slot = range.collection._slots[slotIdx];
	                    left = slot.offsetLeft;
	                    top = slot.offsetTop;
	                    width = slot.offsetWidth;
	                    height = slot.offsetHeight - 2;
	                    hint = SchedulerView.fn._createResizeHint.call(view, left, top, width, height);

	                    view._appendResizeHint(hint);
	                }
	            }
	        },

	        _createMoveHint: function(range, event) {
	            var view = this._view;
	            var startSlot = range.startSlot();
	            var endSlot = range.endSlot();

	            for (var slotIdx = startSlot.index; slotIdx <= endSlot.index; slotIdx++) {
	                var slot = range.collection._slots[slotIdx];
	                var hint = view._createEventElement(event.clone({ head: range.head, tail: range.tail }));

	                hint.css({
	                    left: slot.offsetLeft,
	                    top: slot.offsetTop + slot.firstChildHeight,
	                    height: (view.options.eventHeight === "auto") ? 25 : view.options.eventHeight,
	                    width: slot.offsetWidth - 2
	                });

	                hint.addClass("k-event-drag-hint");

	                if (event.inverseColor) {
	                    hint.addClass(INVERSE_COLOR_CLASS);
	                }

	                view._appendMoveHint(hint);
	            }
	        }
	    });

	    kendo.ui.scheduler.MonthGroupedView = MonthGroupedView;
	    kendo.ui.scheduler.MonthGroupedByDateView = MonthGroupedByDateView;

	    ui.MonthView = SchedulerView.extend({
	        init: function(element, options) {
	            var that = this;

	            // Do not allow less than one event
	            if (options.eventsPerDay === 0) {
	                options.eventsPerDay = 1;
	            }

	            // Do not allow 0 height events
	            if (options.eventHeight === 0) {
	                options.eventHeight = 1;
	            }

	            // Do not allow 0 height more-button
	            if (options.moreButtonHeight === 0) {
	                options.moreButtonHeight = 1;
	            }

	            // Do not allow string values other than auto
	            if (typeof options.eventHeight === "string" && options.eventHeight !== "auto") {
	                options.eventHeight = 25;
	            }

	            // Set adaptiveSlotHeight to true if eventHeight is auto
	            if (options.eventHeight === "auto") {
	                options.adaptiveSlotHeight = true;
	            }

	            SchedulerView.fn.init.call(that, element, options);
	            that._groupedView = that._getGroupedView();

	            // Exception handling for invalid combinations
	            var isGroupedByDate = this._isGroupedByDate();
	            var adaptiveSlotHeight = this.options.adaptiveSlotHeight;
	            var eventHeight = this.options.eventHeight;

	            if (isGroupedByDate === true && adaptiveSlotHeight === true) {
	                throw new Error("Incompatible options: adaptive slot height and date grouping!");
	            }

	            if (isGroupedByDate === true && eventHeight === "auto") {
	                throw new Error("Incompatible options: auto event height and date grouping!");
	            }

	            that.title = that.options.title;

	            that._templates();

	            that._editable();

	            that._renderLayout(that.options.date);

	            that._groups();
	        },

	        name: "month",

	        _getGroupedView: function(){
	            if (this._isGroupedByDate()){
	                return new kendo.ui.scheduler.MonthGroupedByDateView(this);
	            } else {
	                return new kendo.ui.scheduler.MonthGroupedView(this);
	            }
	        },

	        _updateDirection: function(selection, ranges, multiple, reverse, vertical) {
	            if (multiple) {
	                var startSlot = ranges[0].start;
	                var endSlot = ranges[ranges.length - 1].end;
	                var isSameSlot = startSlot.index === endSlot.index;
	                var isSameCollection = startSlot.collectionIndex === endSlot.collectionIndex;
	                var updateDirection;

	                if (vertical) {
	                    updateDirection = (isSameSlot && isSameCollection) || isSameCollection;
	                } else {
	                    updateDirection = isSameSlot && isSameCollection;
	                }

	                if (updateDirection) {
	                    selection.backward = reverse;
	                }
	            }
	        },

	        _changeDate: function(selection, slot, previous) {
	            var group = this.groups[selection.groupIndex];
	            var collections, index;

	            if (previous) {
	                collections = group._getCollections(group.daySlotCollectionCount());
	                index = slot.collectionIndex - 1;

	                if (index >= 0) {
	                    return  collections[index]._slots[collections[index]._slots.length - 1];
	                }
	            } else {
	                collections = group._getCollections(group.daySlotCollectionCount());
	                index = slot.collectionIndex + 1;
	                var slotIndex = 0;

	                if (collections[index] && collections[index]._slots[slotIndex]) {
	                    return  collections[index]._slots[slotIndex];
	                }
	            }
	        },

	        _getNextHorizontalRange: function(group, method, horizontalRange){
	            var isVertical = this._isVerticallyGrouped();

	            horizontalRange.startSlot = group[method](horizontalRange.startSlot, isVertical);
	            horizontalRange.endSlot = group[method](horizontalRange.endSlot, isVertical);

	            return horizontalRange;
	        },

	        _getNextVerticalRange: function(group, method, verticalRange, multiple){
	            var isVertical = this._isVerticallyGrouped() && this._isGroupedByDate();

	            verticalRange.startSlot = group[method](verticalRange.startSlot, multiple, isVertical);
	            verticalRange.endSlot = group[method](verticalRange.endSlot, multiple, isVertical);

	            return verticalRange;
	        },

	        _changeViewPeriod: function(selection, reverse, vertical) {
	            var pad = vertical ? 7 : 1;
	            var newStart, newEnd;

	            if (reverse) {
	                pad *= -1;
	            }

	            newStart =  kendo.date.addDays(selection.start, pad);
	            newEnd = kendo.date.addDays(selection.end, pad);

	            if (this._isInRange(newStart, newEnd)){
	                return false;
	            }

	            selection.start = newStart;
	            selection.end = newEnd;

	            if (!vertical || (vertical && this._isVerticallyGrouped())) {
	                selection.groupIndex = this._groupedView._changePeriodGroupIndex(reverse, vertical, selection.groupIndex);
	            }

	            selection.events = [];

	            return true;
	        },

	        _continuousSlot: function(selection, ranges, reverse) {
	            var index = selection.backward ? 0 : ranges.length - 1;
	            var group = this.groups[selection.groupIndex];

	            return group.continuousSlot(ranges[index].start, reverse);
	        },

	        _changeGroupContinuously: function(selection, continuousSlot, multiple, reverse) {
	            if (!multiple) {
	                var groupIndex = selection.groupIndex;
	                var lastGroupIndex = this.groups.length - 1;
	                var vertical = this._isVerticallyGrouped();
	                var group = this.groups[groupIndex];

	                if (!continuousSlot && vertical) {

	                    continuousSlot = group[reverse ? "lastSlot" : "firstSlot"]();

	                    groupIndex += (reverse ? -1 : 1);

	                } else if (continuousSlot && !vertical) {
	                    groupIndex = reverse ? lastGroupIndex : 0;
	                }

	                if (groupIndex < 0 || groupIndex > lastGroupIndex) {
	                    groupIndex = reverse ? lastGroupIndex : 0;
	                    continuousSlot = null;
	                }

	                selection.groupIndex = groupIndex;
	            }

	            return continuousSlot;
	        },

	        _normalizeHorizontalSelection: function(selection, ranges, reverse) {
	            var slot;

	            if (reverse) {
	                slot = ranges[0].start;
	            } else {
	                slot = ranges[ranges.length - 1].end;
	            }

	            return slot;
	        },

	        _normalizeVerticalSelection: function(selection, ranges) {
	            var slot;

	            if (selection.backward) {
	                slot = ranges[0].start;
	            } else {
	                slot = ranges[ranges.length - 1].end;
	            }

	            return slot;
	        },

	        _templates: function() {
	            var options = this.options,
	                settings = extend({}, kendo.Template, options.templateSettings);

	            this.eventTemplate = this._eventTmpl(options.eventTemplate, EVENT_WRAPPER_STRING);
	            this.dayTemplate = kendo.template(options.dayTemplate, settings);
	            this.groupHeaderTemplate = kendo.template(options.groupHeaderTemplate, settings);
	        },

	        dateForTitle: function() {
	            return kendo.format(this.options.selectedDateFormat, this._firstDayOfMonth, this._lastDayOfMonth);
	        },

	        shortDateForTitle: function() {
	            return kendo.format(this.options.selectedShortDateFormat, this._firstDayOfMonth, this._lastDayOfMonth);
	        },

	        mobileDateForTitle: function () {
	            return kendo.format(this.options.selectedMobileDateFormat, this._firstDayOfMonth, this._lastDayOfMonth);
	        },

	        nextDate: function() {
	            return kendo.date.nextDay(this._lastDayOfMonth);
	        },

	        previousDate: function() {
	            return kendo.date.previousDay(this._firstDayOfMonth);
	        },

	        startDate: function() {
	            return this._startDate;
	        },

	        endDate: function() {
	            return this._endDate;
	        },

	        _renderLayout: function(date) {
	            var that = this;

	            this._firstDayOfMonth = kendo.date.firstDayOfMonth(date);

	            this._lastDayOfMonth = kendo.date.lastDayOfMonth(date);

	            this._startDate = firstVisibleMonthDay(date, this.calendarInfo());

	            this.createLayout(this._layout());

	            this._content();

	            this._initSlotHeight();

	            this.refreshLayout();

	            if(this._isVirtualized()) {
	                this._tryRenderContent();
	            }

	            this.content.on("click" + NS, ".k-nav-day,.k-more-events", function(e) {
	                var offset = $(e.currentTarget).offset();
	                var slot = that._slotByPosition(offset.left, offset.top);

	                e.preventDefault();
	                that.trigger("navigate", { view: "day", date: slot.startDate() });
	            });

	            this._footer();
	        },

	        _editable: function() {
	            if (this.options.editable) {
	                if (this._isMobile()) {
	                    this._touchEditable();
	                } else {
	                    this._mouseEditable();
	                }

	            }
	        },

	        _mouseEditable: function() {
	            var that = this;
	            that.element.on("click" + NS, ".k-scheduler-monthview .k-event a:has(.k-i-close)", function(e) {
	                that.trigger("remove", { uid: $(this).closest(".k-event").attr(kendo.attr("uid")) });
	                e.preventDefault();
	            });

	            if (that.options.editable.create !== false) {
	                that.element.on("dblclick" + NS, ".k-scheduler-monthview .k-scheduler-content td", function(e) {
	                    var offset = $(e.currentTarget).offset();
	                    var slot = that._slotByPosition(offset.left, offset.top);

	                    if (slot) {
	                        var resourceInfo = that._resourceBySlot(slot);
	                        that.trigger("add", { eventInfo: extend({ isAllDay: true, start: slot.startDate(), end: slot.startDate() }, resourceInfo ) });
	                    }

	                    e.preventDefault();
	                });
	            }

	            if (that.options.editable.update !== false) {
	                that.element.on("dblclick" + NS, ".k-scheduler-monthview .k-event", function(e) {
	                    that.trigger("edit", { uid: $(this).closest(".k-event").attr(kendo.attr("uid")) });
	                    e.preventDefault();
	                });
	            }
	        },

	        _touchEditable: function() {
	            var that = this;
	            var threshold = 0;

	            if (kendo.support.mobileOS.android) {
	                threshold = 5;
	            }

	            if (that.options.editable.create !== false) {
	                that._addUserEvents = new kendo.UserEvents(that.element, {
	                    threshold: threshold,
	                    useClickAsTap: !kendo.support.browser.edge,
	                    filter: ".k-scheduler-monthview .k-scheduler-content td",
	                    tap: function(e) {
	                        if (that._scrolling) {
	                            return;
	                        }
	                        var offset = $(e.target).offset();
	                        var slot = that._slotByPosition(offset.left, offset.top);

	                        if (slot) {
	                            var resourceInfo = that._resourceBySlot(slot);
	                            that.trigger("add", { eventInfo: extend({ isAllDay: true, start: slot.startDate(), end: slot.startDate() }, resourceInfo ) });
	                        }

	                        e.preventDefault();
	                    }
	                });
	            }
	        },

	        selectionByElement: function(cell) {
	            var offset = $(cell).offset();
	            return this._slotByPosition(offset.left, offset.top);
	        },

	        _columnCountForLevel: function(level) {
	            var columnLevel = this.columnLevels[level];
	            return columnLevel ? columnLevel.length : 0;
	        },

	        _rowCountForLevel: function(level) {
	            var rowLevel = this.rowLevels[level];
	            return rowLevel ? rowLevel.length : 0;
	        },

	        _content: function() {
	            var html = '<tbody>';
	            var verticalGroupCount = 1;
	            var groupedView = this._groupedView;
	            var resources = this.groupedResources;

	            if (resources.length) {
	                if (this._isVerticallyGrouped()) {
	                    verticalGroupCount = groupedView._verticalRowCountForLevel(resources.length - 1);
	                }
	            }

	            for (var verticalGroupIdx = 0; verticalGroupIdx < verticalGroupCount; verticalGroupIdx++) {
	                html += this._createCalendar(verticalGroupIdx);
	                this._cachedGroupIndex = verticalGroupIdx;
	            }

	            html += "</tbody>";

	            this.content.find("table").html(html);
	        },

	        _virtualContent: function(){
	            var that = this;
	            var html = '';

	            html += this._createCalendar(++this._cachedGroupIndex);

	            that.content.find("table tbody").append(html);

	            that._initSlotHeight();
	        },

	        _calcSlotHeight: function(eventsPerDay) {
	            var options = this.options;
	            var eventHeight = options.eventHeight;
	            var eventSpacing = options.eventSpacing;
	            var moreButtonHeight = options.moreButtonHeight;
	            var firstCell = this.content.find("table tr td")[0];
	            var dateHeader;

	            if (eventHeight === "auto" || !firstCell) {
	                return undefined;
	            }

	            dateHeader = firstCell.firstChild;

	            return Math.round(
	                // border of cell
	                ( firstCell.offsetHeight - firstCell.clientHeight ) +

	                // top padding
	                dateHeader.offsetTop +

	                // height of date header
	                dateHeader.offsetHeight +

	                // cell inner spacing
	                CELL_INNER_SPACING +

	                // all visible events and spacing
	                ( eventsPerDay * eventHeight ) + ( ( eventsPerDay - 1 ) * eventSpacing ) +

	                // leading space, more button
	                ( CELL_INNER_SPACING + moreButtonHeight ) +

	                // traling spacing
	                CELL_INNER_SPACING
	            );
	        },

	        _initSlotHeight: function() {
	            var options = this.options;
	            var eventsPerDay = options.eventsPerDay;
	            var eventHeight = options.eventHeight;
	            var isMobile = this._isMobile();
	            var table = this.content.find("table");
	            var rowHeight;

	            if (isMobile) {
	                return;
	            }

	            if (typeof eventHeight === "number") {
	                table.addClass("k-scheduler-table-auto");

	                rowHeight = this._calcSlotHeight(eventsPerDay);

	                table.find("tr").height( rowHeight );
	            }
	        },

	        _adjustSlotHeight: function(group) {
	            var options = this.options;
	            var eventHeight = options.eventHeight;
	            var eventSpacing = options.eventSpacing;
	            var moreButtonHeight = options.moreButtonHeight;

	            if (this._canAdjustSlotHeight !== true) {
	                return;
	            }

	            var weeks = group._daySlotCollections;

	            this.content.find("table").addClass("k-scheduler-table-auto");

	            weeks.forEach(function(week) {
	                var events = week._events;
	                var eventIndex = 0;
	                var slots = week._slots;
	                var firstSlot = slots[0];
	                var weekOffsetTop = firstSlot.element.offsetTop;
	                var weekHeight = 0;

	                // Ensure event meta exists in each slot
	                slots.forEach(function(slot) {
	                    if (!slot.eventMeta) {
	                        slot.eventMeta = [];
	                        slot.actualEventCount = 0;
	                    } else {
	                        slot.actualEventCount = slot.eventMeta.length;
	                    }
	                });

	                // Ensure spanning event meta is present in all related slots
	                slots.forEach(function(slot, slotIndex) {

	                    slot.eventMeta.forEach(function(meta, eventIndex) {

	                        // Skip events not starting in this slot
	                        if (meta.startIndex !== slotIndex) {
	                            return;
	                        }

	                        // Skip non-spanning events
	                        if (meta.startIndex === meta.endIndex) {
	                            return;
	                        }

	                        // Copy spanning event meta in all related slots
	                        slots.slice(slotIndex, meta.endIndex + 1).forEach(function(adjSlot) {

	                            var adjMeta = adjSlot.eventMeta;

	                            if (adjMeta.indexOf(meta) > -1) {
	                                return;
	                            }

	                            // adjMeta.push(meta);
	                            adjMeta[adjMeta.length] = slot.eventMeta[eventIndex];
	                            adjSlot.actualEventCount = adjMeta.length;
	                            adjSlot.dirty = true;
	                        });

	                    });

	                    // Set correct order
	                    if (slot.dirty === true) {
	                        slot.eventMeta.sort(function(first, second) {
	                            return first.order - second.order;
	                        });
	                        delete slot.dirty;
	                    }

	                });

	                if (eventHeight === "auto") {
	                    slots.forEach(function(slot, slotIndex) { // jshint ignore:line
	                        var slotHeight = slot.firstChildTop + slot.firstChildHeight + CELL_INNER_SPACING;

	                        slot.eventMeta.forEach(function(meta, eventIndex) { // jshint ignore:line
	                            meta.top = Math.max(meta.top, weekOffsetTop + slotHeight);
	                            slotHeight = (meta.top - weekOffsetTop) + eventSpacing + meta.height;
	                        });
	                    });
	                }

	                // Position events
	                slots.forEach(function(slot, slotIndex) {
	                    var slotHeight = slot.firstChildTop + slot.firstChildHeight + CELL_INNER_SPACING;

	                    slot.eventMeta.forEach(function(meta) {
	                        meta.top = Math.max(meta.top, weekOffsetTop + slotHeight);
	                        slotHeight = (meta.top - weekOffsetTop) + eventSpacing + meta.height;

	                        if (meta.startIndex === slotIndex) {
	                            events[eventIndex].element[0].style.top = meta.top + "px";
	                            eventIndex++;
	                        }
	                    });

	                    if (slot.eventMeta.length > 0) {
	                        slotHeight -= eventSpacing;
	                        slotHeight += CELL_INNER_SPACING;
	                    } else {
	                        slotHeight += (eventHeight === "auto" ? 25 : eventHeight);
	                    }

	                    if (slot.more) {
	                        slot.more[0].style.top = weekOffsetTop + slotHeight + "px";
	                        slotHeight += CELL_INNER_SPACING + moreButtonHeight;
	                    }

	                    weekHeight = Math.max(weekHeight, slotHeight + 1);

	                });

	                // Update slot size and meta
	                firstSlot.element.parentNode.style.height = weekHeight + "px";
	                slots.forEach(function(slot) {
	                    slot.offsetTop = weekOffsetTop;
	                    slot.offsetHeight = weekHeight;
	                    slot.clientHeight = weekHeight - 1;
	                });

	            }.bind(this));
	        },

	        _createCalendar: function(verticalGroupIndex) {
	            var start = this.startDate();
	            var cellCount = NUMBER_OF_COLUMNS*NUMBER_OF_ROWS;
	            var cellsPerRow = NUMBER_OF_COLUMNS;
	            var weekStartDates = [start];
	            var html = '';
	            var horizontalGroupCount = 1;
	            var isVerticallyGrouped = this._isVerticallyGrouped();
	            var groupedView = this._groupedView;

	            var resources = this.groupedResources;

	            if (resources.length) {
	                if (!isVerticallyGrouped) {
	                    horizontalGroupCount = groupedView._horizontalGroupCountForLevel(resources.length - 1);
	                }
	            }

	            this._slotIndices = {};

	            var calendarRowsLength = groupedView._getCalendarRowsLength(cellsPerRow, cellCount);

	            for (var rowIdx = 0; rowIdx < calendarRowsLength; rowIdx++) {
	                html += "<tr>";

	                weekStartDates.push(start);

	                var startIdx = rowIdx*cellsPerRow;

	                html += groupedView._createRows(start, startIdx, horizontalGroupCount, verticalGroupIndex);
	                start = groupedView._adjustStartDate(start, rowIdx === calendarRowsLength - 1);

	                html += "</tr>";
	            }

	            this._weekStartDates = weekStartDates;
	            this._endDate = kendo.date.previousDay(start);

	            return html;
	        },

	        _createRow: function(startDate, startIdx, cellsPerRow, groupIndex) {
	            var that = this;
	            var min = that._firstDayOfMonth;
	            var max = that._lastDayOfMonth;
	            var content = that.dayTemplate;
	            var classes = "";
	            var html = "";
	            var groupedView = this._groupedView;

	            var resources = function() {
	                return that._resourceBySlot({ groupIndex: groupIndex });
	            };

	            for (var cellIdx = 0; cellIdx < cellsPerRow; cellIdx++) {
	                classes = "";

	                if (kendo.date.isToday(startDate)) {
	                    classes += "k-today";
	                }

	                if (!kendo.date.isInDateRange(startDate, min, max)) {
	                    classes += " k-other-month";
	                }

	                html += "<td ";

	                if (classes !== "") {
	                    html += 'class="' + classes + '"';
	                }

	                html += ">";
	                html += groupedView._getContent(content, startDate, resources, cellIdx);
	                html += "</td>";

	                that._slotIndices[getDate(startDate).getTime()] = startIdx + cellIdx;

	                startDate = groupedView._nextSlotStartDate(startDate);
	            }

	            return html;
	        },

	        _layout: function() {
	            var calendarInfo = this.calendarInfo();

	            var weekDayNames = this._isMobile() ? calendarInfo.days.namesShort.map(function (name) {
	                return name[0];
	            }) : calendarInfo.days.names;

	            var names = shiftArray(weekDayNames, calendarInfo.firstDay);
	            var columns = $.map(names, function(value) { return { text: value }; });
	            var resources = this.groupedResources;
	            var rows;
	            var groupedView = this._groupedView;

	            if (resources.length) {
	                if (this._isVerticallyGrouped()) {
	                    var inner = []; //add hidden cells in order to sync the content rows
	                    for (var idx = 0; idx < 6; idx++) {
	                        inner.push({ text: "<div>&nbsp;</div>", className: "k-hidden k-slot-cell" });
	                    }
	                    rows =  groupedView._createRowsLayout(resources, inner, this.groupHeaderTemplate, columns);
	                    columns =  groupedView._createVerticalColumnsLayout(resources, inner, this.groupHeaderTemplate, columns);

	                } else {
	                    columns =  groupedView._createColumnsLayout(resources, columns, this.groupHeaderTemplate, columns);
	                }
	            }

	            return {
	                columns: columns,
	                rows: rows
	            };
	        },

	        _createEventElement: function(event) {
	            var options = this.options;
	            var editable = options.editable;

	            var isMobile = this._isMobile();

	            event.showDelete = editable && editable.destroy !== false && !isMobile;
	            event.resizable = editable && editable.resize !== false && !isMobile;
	            event.ns = kendo.ns;
	            event.resources = this.eventResources(event);
	            event.inverseColor = false;
	            event.messages = options.messages || { destroy: "Delete" };

	            var element = $(this.eventTemplate(event));

	            this.angular("compile", function(){
	                return {
	                    elements: element,
	                    data: [ { dataItem: event } ]
	                };
	            });

	            return element;
	        },

	        _isInDateSlot: function(event) {
	            var groups = this.groups[0];
	            var slotStart = groups.firstSlot().start;
	            var slotEnd = groups.lastSlot().end - 1;

	            var startTime = kendo.date.toUtcTime(event.start);
	            var endTime = kendo.date.toUtcTime(event.end);

	            return (isInDateRange(startTime, slotStart, slotEnd) ||
	                isInDateRange(endTime, slotStart, slotEnd) ||
	                isInDateRange(slotStart, startTime, endTime) ||
	                isInDateRange(slotEnd, startTime, endTime)) &&
	                (!isInDateRange(endTime, slotStart, slotStart) || isInDateRange(endTime, startTime, startTime) || event.isAllDay );
	        },

	        _slotIndex: function(date) {
	            return this._slotIndices[getDate(date).getTime()];
	        },

	        _positionMobileEvent: function(slotRange, element, group) {
	            var startSlot = slotRange.start;

	            if (slotRange.start.offsetLeft > slotRange.end.offsetLeft) {
	               startSlot = slotRange.end;
	            }

	            var startIndex = slotRange.start.index;
	            var endIndex = startIndex;

	            var eventCount = 3;
	            var events = SchedulerView.collidingEvents(slotRange.events(), startIndex, endIndex);

	            events.push({element: element, start: startIndex, end: endIndex });

	            var rows = SchedulerView.createRows(events);

	            var slot = slotRange.collection.at(startIndex);

	            var container = slot.container;

	            if (!container) {

	                container = $(kendo.format('<div class="k-events-container" style="top:{0};left:{1};width:{2}"></div>',
	                    startSlot.offsetTop + startSlot.firstChildTop + startSlot.firstChildHeight + "px",
	                    startSlot.offsetLeft + "px",
	                    startSlot.offsetWidth + "px"
	                ));

	                slot.container = container;

	                this.content[0].appendChild(container[0]);
	            }

	            if (rows.length <= eventCount) {
	                slotRange.addEvent({element: element, start: startIndex, end: endIndex, groupIndex: startSlot.groupIndex });

	                group._continuousEvents.push({
	                    element: element,
	                    uid: element.attr(kendo.attr("uid")),
	                    start: slotRange.start,
	                    end: slotRange.end
	                });

	                container[0].appendChild(element[0]);
	            }
	        },

	        _positionEvent: function(slotRange, element, group) {
	            var eventHeight = this.options.eventHeight;
	            var eventSpacing = this.options.eventSpacing;
	            var startSlot = slotRange.start;

	            if (slotRange.start.offsetLeft > slotRange.end.offsetLeft) {
	                startSlot = slotRange.end;
	            }

	            var startIndex = slotRange.start.index;
	            var endIndex = slotRange.end.index;
	            var eventCount = startSlot.eventCount;
	            var events = SchedulerView.collidingEvents(slotRange.events(), startIndex, endIndex);
	            var rightOffset = startIndex !== endIndex ? 3 : 2;

	            events.push({element: element, start: startIndex, end: endIndex });

	            var rows = SchedulerView.createRows(events);

	            for (var idx = 0, length = Math.min(rows.length, eventCount); idx < length; idx++) {
	                var rowEvents = rows[idx].events;
	                var eventTop = (eventHeight === "auto")
	                    ? "" // jshint ignore:line
	                    : (
	                        startSlot.offsetTop +
	                        startSlot.firstChildTop +
	                        startSlot.firstChildHeight +
	                        CELL_INNER_SPACING +
	                        idx * (eventHeight + eventSpacing) +
	                        "px"
	                    );

	                for (var j = 0, eventLength = rowEvents.length; j < eventLength; j++) {
	                    rowEvents[j].element[0].style.top = eventTop;
	                    rowEvents[j].element.attr(kendo.attr("order"), idx);
	                }
	            }

	            if (rows.length > eventCount) {
	                for (var slotIndex = startIndex; slotIndex <= endIndex; slotIndex++) {
	                    var collection = slotRange.collection;

	                    var slot = collection.at(slotIndex);

	                    if (slot.more) {
	                        continue;
	                    }

	                    slot.more = $(MORE_BUTTON_TEMPLATE({
	                        ns: kendo.ns,
	                        start: slotIndex,
	                        end: slotIndex,
	                        width: slot.clientWidth - 2,
	                        left: slot.offsetLeft + 2,
	                        top: (eventHeight === "auto")
	                            ? "" // jshint ignore:line
	                            : (
	                                slot.offsetTop +
	                                slot.firstChildTop +
	                                slot.firstChildHeight +
	                                CELL_INNER_SPACING +
	                                (eventCount * eventHeight) +
	                                ( (eventCount - 1) * eventSpacing) +
	                                CELL_INNER_SPACING
	                            )
	                    }));

	                    this.content[0].appendChild(slot.more[0]);
	                }
	            } else {
	                slotRange.addEvent({element: element, start: startIndex, end: endIndex, groupIndex: startSlot.groupIndex });

	                element[0].style.width = slotRange.innerWidth() - rightOffset + "px";
	                element[0].style.left = startSlot.offsetLeft + 2 + "px";
	                element[0].style.height = (eventHeight === "auto") ? "" : eventHeight + "px";

	                group._continuousEvents.push({
	                    element: element,
	                    uid: element.attr(kendo.attr("uid")),
	                    start: slotRange.start,
	                    end: slotRange.end,
	                    order: parseInt(element.attr(kendo.attr("order")), 10)
	                });

	                element.appendTo(this.content);

	                this._inverseEventColor(element);

	                // Add event meta to slot
	                var _collectionIndex = slotRange.start.collectionIndex;
	                var _startSlotIndex = slotRange.start.index;
	                var _startSlot = group._daySlotCollections[_collectionIndex]._slots[_startSlotIndex];

	                if (!_startSlot.eventMeta) {
	                    _startSlot.eventMeta = [];
	                }

	                _startSlot.eventMeta.push({
	                    height: (eventHeight === "auto") ? element.outerHeight() : eventHeight,
	                    top: 0,
	                    startIndex: _startSlotIndex,
	                    endIndex: slotRange.end.index,
	                    uid: element.attr(kendo.attr("uid")),
	                    order: parseInt(element.attr(kendo.attr("order")), 10)
	                });
	            }
	        },

	        _slotByPosition: function(x, y) {
	            var offset = this.content.offset();

	            x -= offset.left;
	            y -= offset.top;
	            y += this.content[0].scrollTop;
	            x += this.content[0].scrollLeft;

	            x = Math.ceil(x);
	            y = Math.ceil(y);

	            for (var groupIndex = 0; groupIndex < this.groups.length; groupIndex++) {
	                var slot = this._groupedView._getTimeSlotByPosition(x, y, groupIndex);

	                if (slot) {
	                    return slot;
	                }
	            }

	            return null;
	        },

	        _appendResizeHint: function(hint) {
	            hint.appendTo(this.content);

	            this._resizeHint = this._resizeHint.add(hint);
	        },

	        _updateResizeHint: function(event, groupIndex, startTime, endTime) {
	            this._removeResizeHint();

	            var group = this.groups[groupIndex];

	            var ranges = group.ranges(startTime, endTime, true, event.isAllDay);

	            for (var rangeIndex = 0; rangeIndex < ranges.length; rangeIndex++) {
	                this._groupedView._createResizeHint(ranges[rangeIndex]);
	            }

	            this._resizeHint.find(".k-label-top,.k-label-bottom").text("");

	            this._resizeHint.first().addClass("k-first").find(".k-label-top").text(kendo.toString(kendo.timezone.toLocalDate(startTime), "M/dd"));

	            this._resizeHint.last().addClass("k-last").find(".k-label-bottom").text(kendo.toString(kendo.timezone.toLocalDate(endTime), "M/dd"));
	        },

	        _updateMoveHint: function(event, groupIndex, distance) {
	            var start = kendo.date.toUtcTime(event.start) + distance;

	            var end = start + event.duration();

	            var group = this.groups[groupIndex];

	            var ranges = group.ranges(start, end, true, event.isAllDay);

	            this._removeMoveHint(event.uid);

	            for (var rangeIndex = 0; rangeIndex < ranges.length; rangeIndex++) {
	                this._groupedView._createMoveHint(ranges[rangeIndex], event);
	            }
	        },

	        _appendMoveHint: function(hint) {
	            hint.appendTo(this.content);

	            this._moveHint = this._moveHint.add(hint);
	        },

	        _groups: function() {
	            var groupCount = this._groupCount();
	            var tableRows = this.content[0].getElementsByTagName("tr");
	            var startDate = this.startDate();
	            this.groups = [];

	            for (var idx = 0; idx < groupCount; idx++) {
	                this._addResourceView(idx);
	            }

	            this._groupedView._addDaySlotCollections(groupCount, tableRows, startDate);
	        },


	        addDaySlot: function(collection, cell, startDate, cellCount){
	            var start = kendo.date.addDays(startDate, cellCount);
	            var end = kendo.date.MS_PER_DAY;
	            var eventsPerDay = this.options.eventsPerDay;

	            if (startDate.getHours() !== start.getHours()) {
	                end += (startDate.getHours() - start.getHours()) * kendo.date.MS_PER_HOUR;
	            }

	            start = kendo.date.toUtcTime(start);
	            end += start;

	            cell.setAttribute("role", "gridcell");
	            cell.setAttribute("aria-selected", false);

	            collection.addDaySlot(cell, start, end, eventsPerDay);
	        },

	        render: function(events) {
	            this.content.children(".k-event,.k-more-events,.k-events-container").remove();

	            this._cachedEvents = events;

	            this._groups();

	            events = new kendo.data.Query(events)
	                .sort([{ field: "start", dir: "asc" },{ field: "end", dir: "desc" }])
	                .toArray()
	                .filter(function(event) {
	                    return this._isInDateSlot(event);
	                }.bind(this));

	            var resources = this.groupedResources;
	            var isMobile = this._isMobile();
	            var isGroupedByDate = this._isGroupedByDate();
	            var adaptiveSlotHeight = this.options.adaptiveSlotHeight;

	            this._canAdjustSlotHeight = isMobile !== true && isGroupedByDate !== true && resources.length === 0 && adaptiveSlotHeight === true;

	            if (resources.length) {
	                this._renderGroups(events, resources, 0, 1);
	            } else {
	                this._renderEvents(events, 0);
	            }

	            this.refreshLayout();
	            this.trigger("activate");
	        },

	        _renderEvents: function(events, groupIndex) {
	            var group = this.groups[groupIndex];
	            var view = this._groupedView._view;
	            var isMobile = view._isMobile();

	            if(!group) {
	                return;
	            }

	            if (!group._continuousEvents) {
	                group._continuousEvents = [];
	            }

	            if (isMobile) {

	                events.forEach(function(event) {
	                    var ranges = group.slotRanges(event, true);
	                    var range = ranges[0];
	                    var start = range.start.start;
	                    var end = range.end.end;
	                    var rangeStart = new Date(range.start.start);
	                    var rangeEnd = ranges[ranges.length - 1].end.end;
	                    var newStart = new Date(rangeStart);
	                    var newEnd = new Date(end);

	                    while (rangeStart.getTime() <= rangeEnd &&
	                        event.end >= kendo.timezone.toLocalDate(rangeStart) &&
	                        event.start <= kendo.timezone.toLocalDate(rangeEnd)){
	                        var dateRange = group.daySlotRanges(newStart.getTime(), newEnd.getTime(), true)[0];
	                        newEnd.setDate(newEnd.getDate() + 1);
	                        newStart.setDate(newStart.getDate() + 1);

	                        if (dateRange) {
	                            dateRange.head = null;
	                            dateRange.middle = null;
	                            dateRange.tail = null;
	                            this._groupedView._positionMobileEvent(event, group, dateRange, 1, start, end, 0);
	                        }

	                        rangeStart = kendo.date.addDays(rangeStart, 1);
	                    }

	                }.bind(this));

	            } else {

	                events.forEach(function(event) {
	                    var range;
	                    var start = event.start;
	                    var end = event.end;
	                    var ranges = group.slotRanges(event, true);
	                    var rangeCount = ranges.length;

	                    for (var rangeIndex = 0; rangeIndex < rangeCount; rangeIndex++) {
	                        range = ranges[rangeIndex];

	                        this._groupedView._positionEvent(event, group, range, rangeCount, start, end, rangeIndex);
	                    }

	                }.bind(this));

	                if (this._canAdjustSlotHeight === true) {
	                    this._adjustSlotHeight(group);
	                }

	            }
	        },

	        _renderGroups: function(events, resources, offset, columnLevel) {
	            var resource = resources[0];

	            if (resource) {
	                var view = resource.dataSource.view();

	                for (var itemIdx = 0; itemIdx < view.length; itemIdx++) {
	                    var value = this._resourceValue(resource, view[itemIdx]);

	                    var tmp = new kendo.data.Query(events).filter({ field: resource.field, operator: SchedulerView.groupEqFilter(value) }).toArray();

	                    if (resources.length > 1) {
	                        offset = this._renderGroups(tmp, resources.slice(1), offset++, columnLevel + 1);
	                    } else {
	                        this._renderEvents(tmp, offset++);
	                    }
	                }
	            }
	            return offset;
	        },

	        _groupCount: function() {
	            var resources = this.groupedResources;
	            var groupedView = this._groupedView;

	            if (resources.length) {
	                if (this._isVerticallyGrouped()) {
	                    return groupedView._verticalGroupCount(resources.length - 1);
	                } else {
	                    return groupedView._horizontalGroupCount(resources.length);
	                }
	            }
	            return 1;
	        },

	        _columnOffsetForResource: function(index) {
	            return this._columnCountForLevel(index) / this._columnCountForLevel(index - 1);
	        },

	        destroy: function(){
	            if (this.table) {
	                this.table.removeClass("k-scheduler-monthview");
	            }

	            if (this.content) {
	                this.content.off(NS);
	            }

	            if (this.element) {
	                this.element.off(NS);
	            }

	            SchedulerView.fn.destroy.call(this);

	            if (this._isMobile() && this.options.editable) {
	                if (this.options.editable.create !== false) {
	                    this._addUserEvents.destroy();
	                }
	            }
	        },

	        events: ["remove", "add", "edit", "navigate"],

	        options: {
	            title: "Month",
	            name: "month",
	            eventHeight: 25,
	            moreButtonHeight: 13,
	            editable: true,
	            selectedDateFormat: "{0:y}",
	            selectedShortDateFormat: "{0:y}",
	            selectedMobileDateFormat: "{0:MMMM}",
	            groupHeaderTemplate: "#=text#",
	            dayTemplate: DAY_TEMPLATE,
	            eventTemplate: EVENT_TEMPLATE,
	            eventsPerDay: 2,
	            adaptiveSlotHeight: false,
	            eventSpacing: 3
	        }
	    });


	    function shiftArray(array, idx) {
	        return array.slice(idx).concat(array.slice(0, idx));
	    }

	    function firstVisibleMonthDay(date, calendarInfo) {
	        var firstDay = calendarInfo.firstDay,
	            firstVisibleDay = new Date(date.getFullYear(), date.getMonth(), 0, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());

	        while (firstVisibleDay.getDay() != firstDay) {
	            kendo.date.setTime(firstVisibleDay, -1 * MS_PER_DAY);
	        }

	        return firstVisibleDay;
	    }

	    function isInDateRange(value, min, max) {
	        var msMin = min,
	            msMax = max,
	            msValue;

	        msValue = value;

	        return msValue >= msMin && msValue <= msMax;
	    }
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "WO3E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var eventService_1 = __webpack_require__("k5uU");
var context_1 = __webpack_require__("RQ1/");
var events_1 = __webpack_require__("3ok8");
var beanStub_1 = __webpack_require__("xffp");
var columnApi_1 = __webpack_require__("E/Wy");
var gridApi_1 = __webpack_require__("BAow");
var ColumnHoverService = (function (_super) {
    __extends(ColumnHoverService, _super);
    function ColumnHoverService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColumnHoverService.prototype.init = function () {
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_CELL_MOUSE_OVER, this.onCellMouseOver.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_CELL_MOUSE_OUT, this.onCellMouseOut.bind(this));
    };
    ColumnHoverService.prototype.onCellMouseOver = function (cellEvent) {
        this.currentlySelectedColumn = cellEvent.column;
        var event = {
            type: events_1.Events.EVENT_COLUMN_HOVER_CHANGED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(event);
    };
    ColumnHoverService.prototype.onCellMouseOut = function () {
        this.currentlySelectedColumn = null;
        var event = {
            type: events_1.Events.EVENT_COLUMN_HOVER_CHANGED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(event);
    };
    ColumnHoverService.prototype.isHovered = function (column) {
        return column == this.currentlySelectedColumn;
    };
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], ColumnHoverService.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], ColumnHoverService.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], ColumnHoverService.prototype, "gridApi", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ColumnHoverService.prototype, "init", null);
    ColumnHoverService = __decorate([
        context_1.Bean('columnHoverService')
    ], ColumnHoverService);
    return ColumnHoverService;
}(beanStub_1.BeanStub));
exports.ColumnHoverService = ColumnHoverService;


/***/ }),

/***/ "WPdJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var logger_1 = __webpack_require__("U9Xd");
var columnUtils_1 = __webpack_require__("PAC5");
var columnKeyCreator_1 = __webpack_require__("oPvZ");
var originalColumnGroup_1 = __webpack_require__("pOb1");
var column_1 = __webpack_require__("hDyE");
var context_1 = __webpack_require__("RQ1/");
var utils_1 = __webpack_require__("IRr6");
var defaultColumnTypes_1 = __webpack_require__("6iBx");
// takes in a list of columns, as specified by the column definitions, and returns column groups
var BalancedColumnTreeBuilder = (function () {
    function BalancedColumnTreeBuilder() {
    }
    BalancedColumnTreeBuilder.prototype.setBeans = function (loggerFactory) {
        this.logger = loggerFactory.create('BalancedColumnTreeBuilder');
    };
    BalancedColumnTreeBuilder.prototype.createForAutoGroups = function (autoGroupCols, gridBalancedTree) {
        var _this = this;
        var autoColBalancedTree = [];
        autoGroupCols.forEach(function (col) {
            var fakeTreeItem = _this.createAutoGroupTreeItem(gridBalancedTree, col);
            autoColBalancedTree.push(fakeTreeItem);
        });
        return autoColBalancedTree;
    };
    BalancedColumnTreeBuilder.prototype.createAutoGroupTreeItem = function (balancedColumnTree, column) {
        var dept = this.findDept(balancedColumnTree);
        // at the end, this will be the top of the tree item.
        var nextChild = column;
        for (var i = dept - 1; i >= 0; i--) {
            var autoGroup = new originalColumnGroup_1.OriginalColumnGroup(null, "FAKE_PATH_" + column.getId() + "}_" + i, true);
            this.context.wireBean(autoGroup);
            autoGroup.setChildren([nextChild]);
            nextChild = autoGroup;
        }
        // at this point, the nextChild is the top most item in the tree
        return nextChild;
    };
    BalancedColumnTreeBuilder.prototype.findDept = function (balancedColumnTree) {
        var dept = 0;
        var pointer = balancedColumnTree;
        while (pointer && pointer[0] && pointer[0] instanceof originalColumnGroup_1.OriginalColumnGroup) {
            dept++;
            pointer = pointer[0].getChildren();
        }
        return dept;
    };
    BalancedColumnTreeBuilder.prototype.createBalancedColumnGroups = function (abstractColDefs, primaryColumns) {
        // column key creator dishes out unique column id's in a deterministic way,
        // so if we have two grids (that cold be master/slave) with same column definitions,
        // then this ensures the two grids use identical id's.
        var columnKeyCreator = new columnKeyCreator_1.ColumnKeyCreator();
        // create am unbalanced tree that maps the provided definitions
        var unbalancedTree = this.recursivelyCreateColumns(abstractColDefs, 0, columnKeyCreator, primaryColumns);
        var treeDept = this.findMaxDept(unbalancedTree, 0);
        this.logger.log('Number of levels for grouped columns is ' + treeDept);
        var balancedTree = this.balanceColumnTree(unbalancedTree, 0, treeDept, columnKeyCreator);
        this.columnUtils.depthFirstOriginalTreeSearch(balancedTree, function (child) {
            if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
                child.setupExpandable();
            }
        });
        return {
            balancedTree: balancedTree,
            treeDept: treeDept
        };
    };
    BalancedColumnTreeBuilder.prototype.balanceColumnTree = function (unbalancedTree, currentDept, columnDept, columnKeyCreator) {
        var _this = this;
        var result = [];
        // go through each child, for groups, recurse a level deeper,
        // for columns we need to pad
        unbalancedTree.forEach(function (child) {
            if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
                var originalGroup = child;
                var newChildren = _this.balanceColumnTree(originalGroup.getChildren(), currentDept + 1, columnDept, columnKeyCreator);
                originalGroup.setChildren(newChildren);
                result.push(originalGroup);
            }
            else {
                var newChild = child;
                for (var i = columnDept - 1; i >= currentDept; i--) {
                    var newColId = columnKeyCreator.getUniqueKey(null, null);
                    var colGroupDefMerged = _this.createMergedColGroupDef(null);
                    var paddedGroup = new originalColumnGroup_1.OriginalColumnGroup(colGroupDefMerged, newColId, true);
                    _this.context.wireBean(paddedGroup);
                    paddedGroup.setChildren([newChild]);
                    newChild = paddedGroup;
                }
                result.push(newChild);
            }
        });
        return result;
    };
    BalancedColumnTreeBuilder.prototype.findMaxDept = function (treeChildren, dept) {
        var maxDeptThisLevel = dept;
        for (var i = 0; i < treeChildren.length; i++) {
            var abstractColumn = treeChildren[i];
            if (abstractColumn instanceof originalColumnGroup_1.OriginalColumnGroup) {
                var originalGroup = abstractColumn;
                var newDept = this.findMaxDept(originalGroup.getChildren(), dept + 1);
                if (maxDeptThisLevel < newDept) {
                    maxDeptThisLevel = newDept;
                }
            }
        }
        return maxDeptThisLevel;
    };
    BalancedColumnTreeBuilder.prototype.recursivelyCreateColumns = function (abstractColDefs, level, columnKeyCreator, primaryColumns) {
        var _this = this;
        var result = [];
        if (!abstractColDefs) {
            return result;
        }
        abstractColDefs.forEach(function (abstractColDef) {
            var newGroupOrColumn;
            if (_this.isColumnGroup(abstractColDef)) {
                newGroupOrColumn = _this.createColumnGroup(columnKeyCreator, primaryColumns, abstractColDef, level);
            }
            else {
                newGroupOrColumn = _this.createColumn(columnKeyCreator, primaryColumns, abstractColDef);
            }
            result.push(newGroupOrColumn);
        });
        return result;
    };
    BalancedColumnTreeBuilder.prototype.createColumnGroup = function (columnKeyCreator, primaryColumns, colGroupDef, level) {
        var colGroupDefMerged = this.createMergedColGroupDef(colGroupDef);
        var groupId = columnKeyCreator.getUniqueKey(colGroupDefMerged.groupId, null);
        var originalGroup = new originalColumnGroup_1.OriginalColumnGroup(colGroupDefMerged, groupId, false);
        this.context.wireBean(originalGroup);
        var children = this.recursivelyCreateColumns(colGroupDefMerged.children, level + 1, columnKeyCreator, primaryColumns);
        originalGroup.setChildren(children);
        return originalGroup;
    };
    BalancedColumnTreeBuilder.prototype.createMergedColGroupDef = function (colGroupDef) {
        var colGroupDefMerged = {};
        utils_1.Utils.assign(colGroupDefMerged, this.gridOptionsWrapper.getDefaultColGroupDef());
        utils_1.Utils.assign(colGroupDefMerged, colGroupDef);
        this.checkForDeprecatedItems(colGroupDefMerged);
        return colGroupDefMerged;
    };
    BalancedColumnTreeBuilder.prototype.createColumn = function (columnKeyCreator, primaryColumns, colDef) {
        var colDefMerged = this.mergeColDefs(colDef);
        this.checkForDeprecatedItems(colDefMerged);
        var colId = columnKeyCreator.getUniqueKey(colDefMerged.colId, colDefMerged.field);
        var column = new column_1.Column(colDefMerged, colId, primaryColumns);
        this.context.wireBean(column);
        return column;
    };
    BalancedColumnTreeBuilder.prototype.mergeColDefs = function (colDef) {
        // start with empty merged definition
        var colDefMerged = {};
        // merge properties from default column definitions
        utils_1.Utils.assign(colDefMerged, this.gridOptionsWrapper.getDefaultColDef());
        // merge properties from column type properties
        if (colDef.type) {
            this.assignColumnTypes(colDef, colDefMerged);
        }
        // merge properties from column definitions
        utils_1.Utils.assign(colDefMerged, colDef);
        return colDefMerged;
    };
    BalancedColumnTreeBuilder.prototype.assignColumnTypes = function (colDef, colDefMerged) {
        var typeKeys;
        if (colDef.type instanceof Array) {
            var invalidArray = colDef.type.some(function (a) { return typeof a !== 'string'; });
            if (invalidArray) {
                console.warn("ag-grid: if colDef.type is supplied an array it should be of type 'string[]'");
            }
            else {
                typeKeys = colDef.type;
            }
        }
        else if (typeof colDef.type === 'string') {
            typeKeys = colDef.type.split(',');
        }
        else {
            console.warn("ag-grid: colDef.type should be of type 'string' | 'string[]'");
            return;
        }
        // merge user defined with default column types
        var allColumnTypes = utils_1.Utils.assign({}, this.gridOptionsWrapper.getColumnTypes(), defaultColumnTypes_1.DefaultColumnTypes);
        typeKeys.forEach(function (t) {
            var typeColDef = allColumnTypes[t.trim()];
            if (typeColDef) {
                utils_1.Utils.assign(colDefMerged, typeColDef);
            }
            else {
                console.warn("ag-grid: colDef.type '" + t + "' does not correspond to defined gridOptions.columnTypes");
            }
        });
    };
    BalancedColumnTreeBuilder.prototype.checkForDeprecatedItems = function (colDef) {
        if (colDef) {
            var colDefNoType = colDef; // take out the type, so we can access attributes not defined in the type
            if (colDefNoType.group !== undefined) {
                console.warn('ag-grid: colDef.group is invalid, please check documentation on how to do grouping as it changed in version 3');
            }
            if (colDefNoType.headerGroup !== undefined) {
                console.warn('ag-grid: colDef.headerGroup is invalid, please check documentation on how to do grouping as it changed in version 3');
            }
            if (colDefNoType.headerGroupShow !== undefined) {
                console.warn('ag-grid: colDef.headerGroupShow is invalid, should be columnGroupShow, please check documentation on how to do grouping as it changed in version 3');
            }
            if (colDefNoType.suppressRowGroup !== undefined) {
                console.warn('ag-grid: colDef.suppressRowGroup is deprecated, please use colDef.type instead');
            }
            if (colDefNoType.suppressAggregation !== undefined) {
                console.warn('ag-grid: colDef.suppressAggregation is deprecated, please use colDef.type instead');
            }
            if (colDefNoType.suppressRowGroup || colDefNoType.suppressAggregation) {
                console.warn('ag-grid: colDef.suppressAggregation and colDef.suppressRowGroup are deprecated, use allowRowGroup, allowPivot and allowValue instead');
            }
            if (colDefNoType.displayName) {
                console.warn("ag-grid: Found displayName " + colDefNoType.displayName + ", please use headerName instead, displayName is deprecated.");
                colDefNoType.headerName = colDefNoType.displayName;
            }
        }
    };
    // if object has children, we assume it's a group
    BalancedColumnTreeBuilder.prototype.isColumnGroup = function (abstractColDef) {
        return abstractColDef.children !== undefined;
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], BalancedColumnTreeBuilder.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('columnUtils'),
        __metadata("design:type", columnUtils_1.ColumnUtils)
    ], BalancedColumnTreeBuilder.prototype, "columnUtils", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], BalancedColumnTreeBuilder.prototype, "context", void 0);
    __decorate([
        __param(0, context_1.Qualifier('loggerFactory')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
        __metadata("design:returntype", void 0)
    ], BalancedColumnTreeBuilder.prototype, "setBeans", null);
    BalancedColumnTreeBuilder = __decorate([
        context_1.Bean('balancedColumnTreeBuilder')
    ], BalancedColumnTreeBuilder);
    return BalancedColumnTreeBuilder;
}());
exports.BalancedColumnTreeBuilder = BalancedColumnTreeBuilder;


/***/ }),

/***/ "WPfE":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1099);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1099:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "data.odata",
	    name: "OData",
	    category: "framework",
	    depends: [ "core" ],
	    hidden: true
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        extend = $.extend,
	        NEWLINE = "\r\n",
	        DOUBLELINE = "\r\n\r\n",
	        isFunction = kendo.isFunction,
	        odataFilters = {
	            eq: "eq",
	            neq: "ne",
	            gt: "gt",
	            gte: "ge",
	            lt: "lt",
	            lte: "le",
	            contains : "substringof",
	            doesnotcontain: "substringof",
	            endswith: "endswith",
	            startswith: "startswith",
	            isnull: "eq",
	            isnotnull: "ne",
	            isnullorempty: "eq",
	            isnotnullorempty: "ne",
	            isempty: "eq",
	            isnotempty: "ne"
	        },
	        odataFiltersVersionFour = extend({}, odataFilters, {
	            contains: "contains"
	        }),
	        mappers = {
	            pageSize: $.noop,
	            page: $.noop,
	            filter: function(params, filter, useVersionFour) {
	                if (filter) {
	                    filter = toOdataFilter(filter, useVersionFour);
	                    if (filter) {
	                        params.$filter = filter;
	                    }
	                }
	            },
	            sort: function(params, orderby) {
	                var expr = $.map(orderby, function(value) {
	                    var order = value.field.replace(/\./g, "/");

	                    if (value.dir === "desc") {
	                        order += " desc";
	                    }

	                    return order;
	                }).join(",");

	                if (expr) {
	                    params.$orderby = expr;
	                }
	            },
	            skip: function(params, skip) {
	                if (skip) {
	                    params.$skip = skip;
	                }
	            },
	            take: function(params, take) {
	                if (take) {
	                    params.$top = take;
	                }
	            }
	        },
	        defaultDataType = {
	            read: {
	                dataType: "jsonp"
	            }
	        };

	    function toOdataFilter(filter, useOdataFour) {
	        var result = [],
	            logic = filter.logic || "and",
	            idx,
	            length,
	            field,
	            type,
	            format,
	            operator,
	            value,
	            ignoreCase,
	            filters = filter.filters;

	        for (idx = 0, length = filters.length; idx < length; idx++) {
	            filter = filters[idx];
	            field = filter.field;
	            value = filter.value;
	            operator = filter.operator;

	            if (filter.filters) {
	                filter = toOdataFilter(filter, useOdataFour);
	            } else {
	                ignoreCase = filter.ignoreCase;
	                field = field.replace(/\./g, "/");
	                filter = odataFilters[operator];
	                if (useOdataFour) {
	                    filter = odataFiltersVersionFour[operator];
	                }

	                if (operator === "isnullorempty") {
	                    filter = kendo.format("{0} {1} null or {0} {1} ''", field, filter);
	                } else if(operator === "isnotnullorempty") {
	                    filter = kendo.format("{0} {1} null and {0} {1} ''", field, filter);
	                } else if (operator === "isnull" || operator === "isnotnull") {
	                    filter = kendo.format("{0} {1} null", field, filter);
	                } else if (operator === "isempty" || operator === "isnotempty") {
	                    filter = kendo.format("{0} {1} ''", field, filter);
	                } else if (filter && value !== undefined) {
	                    type = $.type(value);
	                    if (type === "string") {
	                        format = "'{1}'";
	                        value = value.replace(/'/g, "''");

	                        if (ignoreCase === true) {
	                            field = "tolower(" + field + ")";
	                        }

	                    } else if (type === "date") {
	                        if (useOdataFour) {
	                            format = "{1:yyyy-MM-ddTHH:mm:ss+00:00}";
	                            value = kendo.timezone.apply(value, 'Etc/UTC');
	                        } else {
	                            format = "datetime'{1:yyyy-MM-ddTHH:mm:ss}'";
	                        }
	                    } else {
	                        format = "{1}";
	                    }

	                    if (filter.length > 3) {
	                        if (filter !== "substringof") {
	                            format = "{0}({2}," + format + ")";
	                        } else {
	                            format = "{0}(" + format + ",{2})";
	                            if (operator === "doesnotcontain") {
	                                if (useOdataFour) {
	                                    format = "{0}({2},'{1}') eq -1";
	                                    filter = "indexof";
	                                } else {
	                                    format += " eq false";
	                                }
	                            }
	                        }
	                    } else {
	                        format = "{2} {0} " + format;
	                    }

	                    filter = kendo.format(format, filter, value, field);
	                }
	            }

	            result.push(filter);
	        }

	        filter = result.join(" " + logic + " ");

	        if (result.length > 1) {
	            filter = "(" + filter + ")";
	        }

	        return filter;
	    }

	    function stripMetadata(obj) {
	        for (var name in obj) {
	            if(name.indexOf("@odata") === 0) {
	                delete obj[name];
	            }
	        }
	    }

	    function hex16() {
	        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substr(1);
	    }

	    function createBoundary(prefix) {
	        return prefix + hex16() + '-' + hex16() + '-' + hex16();
	    }

	    function createDelimeter(boundary, close) {
	        var result = NEWLINE + "--" + boundary;

	        if (close) {
	            result += "--";
	        }

	        return result;
	    }

	    function createCommand(transport, item, httpVerb, command) {
	         var transportUrl = transport.options[command].url;
	         var commandPrefix = kendo.format("{0} ", httpVerb);

	         if (isFunction(transportUrl)) {
	             return commandPrefix + transportUrl(item);
	         } else {
	             return commandPrefix + transportUrl;
	         }
	    }

	    function getOperationHeader(changeset, changeId) {
	        var header = "";

	        header += createDelimeter(changeset, false);
	        header += NEWLINE + 'Content-Type: application/http';
	        header += NEWLINE + 'Content-Transfer-Encoding: binary';
	        header += NEWLINE + 'Content-ID: ' + changeId;

	        return header;
	    }

	    function getOperationContent(item) {
	        var content = "";

	        content += NEWLINE + "Content-Type: application/json;odata=minimalmetadata";
	        content += NEWLINE + "Prefer: return=representation";
	        content += DOUBLELINE + kendo.stringify(item);

	        return content;
	    }

	    function getOperations(collection, changeset, changeId, command, transport, skipContent) {
	        var requestBody = "";

	        for (var i = 0; i < collection.length; i++) {
	            requestBody += getOperationHeader(changeset, changeId);
	            requestBody += DOUBLELINE + createCommand(transport, collection[i], transport.options[command].type, command) + ' HTTP/1.1';
	            if (!skipContent) {
	                requestBody += getOperationContent(collection[i]);
	            }
	            requestBody += NEWLINE;
	            changeId++;
	        }

	        return requestBody;
	    }

	    function processCollection(colection, boundary, changeset, changeId, transport, command, skipContent) {
	        var requestBody = "";

	        requestBody += getBoundary(boundary, changeset);
	        requestBody += getOperations(colection, changeset, changeId, command, transport, skipContent);
	        requestBody += createDelimeter(changeset, true);
	        requestBody += NEWLINE;

	        return requestBody;
	    }

	    function getBoundary(boundary,changeset) {
	        var requestBody = "";

	        requestBody += "--" + boundary + NEWLINE;
	        requestBody += "Content-Type: multipart/mixed; boundary=" + changeset + NEWLINE;

	        return requestBody;
	    }

	    function createBatchRequest(transport, colections) {
			var options = extend({}, transport.options.batch);
	        var boundary = createBoundary("sf_batch_");
	        var requestBody = "";
	        var changeId = 0;
	        var batchURL = transport.options.batch.url;
	        var changeset = createBoundary("sf_changeset_");

	        options.type = transport.options.batch.type;
	        options.url = isFunction(batchURL) ? batchURL() : batchURL;
			options.headers = extend(options.headers || {}, {
				"Content-Type": "multipart/mixed; boundary=" + boundary
			});

	        if (colections.updated.length) {
	            requestBody += processCollection(colections.updated, boundary, changeset, changeId, transport, "update", false);
	            changeId += colections.updated.length;
	            changeset = createBoundary("sf_changeset_");
	        }

	        if (colections.destroyed.length) {
	            requestBody += processCollection(colections.destroyed, boundary, changeset, changeId, transport, "destroy", true);
	            changeId += colections.destroyed.length;
	            changeset = createBoundary("sf_changeset_");
	        }

	        if (colections.created.length) {
	            requestBody += processCollection(colections.created, boundary, changeset, changeId, transport, "create", false);
	        }

	        requestBody += createDelimeter(boundary, true);

	        options.data = requestBody;

	        return options;
	    }

	    function parseBatchResponse(responseText) {
	        var responseMarkers = responseText.match(/--changesetresponse_[a-z0-9-]+$/gm);
	        var markerIndex = 0;
	        var collections = [];
	        var changeBody;
	        var status;
	        var code;
	        var marker;
	        var jsonModel;

	        collections.push({ models: [], passed: true });

	        for (var i = 0; i < responseMarkers.length; i++) {
	            marker = responseMarkers[i];
	            if (marker.lastIndexOf('--', marker.length - 1)) {
	                if (i < responseMarkers.length - 1) {
	                    collections.push({ models: [], passed: true });
	                }
	                continue;
	            }

	            if (!markerIndex) {
	                markerIndex = responseText.indexOf(marker);
	            } else {
	                markerIndex = responseText.indexOf(marker, markerIndex + marker.length);
	            }

	            changeBody = responseText.substring(markerIndex, responseText.indexOf("--", markerIndex + 1));
	            status = changeBody.match(/^HTTP\/1\.\d (\d{3}) (.*)$/gm).pop();
	            code = kendo.parseFloat(status.match(/\d{3}/g).pop());

	            if (code >= 200 && code <= 299) {
	                jsonModel = changeBody.match(/\{.*\}/gm);
	                if (jsonModel) {
	                    collections[collections.length - 1].models.push(JSON.parse(jsonModel[0]));
	                }
	            } else {
	                collections[collections.length - 1].passed = false;
	            }

	        }

	        return collections;
	    }

	    extend(true, kendo.data, {
	        schemas: {
	            odata: {
	                type: "json",
	                data: function(data) {
	                    return data.d.results || [data.d];
	                },
	                total: "d.__count"
	            }
	        },
	        transports: {
	            odata: {
	                read: {
	                    cache: true, // to prevent jQuery from adding cache buster
	                    dataType: "jsonp",
	                    jsonp: "$callback"
	                },
	                update: {
	                    cache: true,
	                    dataType: "json",
	                    contentType: "application/json", // to inform the server the the request body is JSON encoded
	                    type: "PUT" // can be PUT or MERGE
	                },
	                create: {
	                    cache: true,
	                    dataType: "json",
	                    contentType: "application/json",
	                    type: "POST" // must be POST to create new entity
	                },
	                destroy: {
	                    cache: true,
	                    dataType: "json",
	                    type: "DELETE"
	                },
	                parameterMap: function(options, type, useVersionFour) {
	                    var params,
	                        value,
	                        option,
	                        dataType;

	                    options = options || {};
	                    type = type || "read";
	                    dataType = (this.options || defaultDataType)[type];
	                    dataType = dataType ? dataType.dataType : "json";

	                    if (type === "read") {
	                        params = {
	                            $inlinecount: "allpages"
	                        };

	                        if (dataType != "json") {
	                            params.$format = "json";
	                        }

	                        for (option in options) {
	                            if (mappers[option]) {
	                                mappers[option](params, options[option], useVersionFour);
	                            } else {
	                                params[option] = options[option];
	                            }
	                        }
	                    } else {
	                        if (dataType !== "json") {
	                            throw new Error("Only json dataType can be used for " + type + " operation.");
	                        }

	                        if (type !== "destroy") {
	                            for (option in options) {
	                                value = options[option];
	                                if (typeof value === "number") {
	                                    options[option] = value + "";
	                                }
	                            }

	                            params = kendo.stringify(options);
	                        }
	                    }

	                    return params;
	                }
	            }
	        }
	    });

	    extend(true, kendo.data, {
	        schemas: {
	            "odata-v4": {
	                type: "json",
	                data: function(data) {
	                    if ($.isArray(data)) {
	                        for (var i = 0; i < data.length; i++) {
	                            stripMetadata(data[i]);
	                        }
	                        return data;
	                    } else {
	                        data = $.extend({}, data);
	                        stripMetadata(data);

	                        if (data.value) {
	                            return data.value;
	                        }
	                        return [data];
	                    }
	                },
	                total: function(data) {
	                    return data["@odata.count"];
	                }
	            }
	        },
	        transports: {
	            "odata-v4": {
	                batch: {
	                    type: "POST"
	                },
	                read: {
	                    cache: true, // to prevent jQuery from adding cache buster
	                    dataType: "json"
	                },
	                update: {
	                    cache: true,
	                    dataType: "json",
	                    contentType: "application/json;IEEE754Compatible=true", // to inform the server the the request body is JSON encoded
	                    type: "PUT" // can be PUT or MERGE
	                },
	                create: {
	                    cache: true,
	                    dataType: "json",
	                    contentType: "application/json;IEEE754Compatible=true",
	                    type: "POST" // must be POST to create new entity
	                },
	                destroy: {
	                    cache: true,
	                    dataType: "json",
	                    type: "DELETE"
	                },
	                parameterMap: function(options, type) {
	                    var result = kendo.data.transports.odata.parameterMap(options, type, true);
	                    if (type == "read") {
	                        result.$count = true;
	                        delete result.$inlinecount;
	                    }
						
						if (result.$filter) {
							// Remove the single quotation marks around the GUID (OData v4).
							result.$filter = result.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig, function (x) {
								return x.substring(1, x.length - 1);
							});
						}

	                    return result;
	                },
	                submit: function(e) {
	                    var that = this;
	                    var options = createBatchRequest(that, e.data);
	                    var collections = e.data;

	                    if (!collections.updated.length && !collections.destroyed.length && !collections.created.length) {
	                        return;
	                    }

	                    $.ajax(extend(true, {}, {
	                        success: function (response) {
	                            var responses = parseBatchResponse(response);
	                            var index = 0;
	                            var current;

	                            if (collections.updated.length) {
	                                current = responses[index];
	                                if (current.passed) {
	                                    // Pass either the obtained models or an empty array if only status codes are returned.
	                                    e.success(current.models.length ? current.models : [], "update");
	                                }
	                                index++;
	                            }
	                            if (collections.destroyed.length) {
	                                current = responses[index];
	                                if (current.passed) {
	                                    // For delete operations OData returns only status codes.
	                                    // Passing empty array to datasource will force it to correctly remove the deleted items from the pristine collection.
	                                    e.success([], "destroy");
	                                }
	                                index++;
	                            }
	                            if (collections.created.length) {
	                                current = responses[index];
	                                if (current.passed) {
	                                    e.success(current.models, "create");
	                                }
	                            }
	                        },
	                        error: function (response, status, error) {
	                            e.error(response, status, error);
	                        }
	                    }, options));
	                }
	            }
	        }
	    });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "WX3+":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(935);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 935:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(936)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {

	var dataviz = kendo.dataviz;
	var Chart = dataviz.ui.Chart;
	var KendoSparkline = dataviz.Sparkline;
	var ChartInstanceObserver = dataviz.ChartInstanceObserver;

	var extend = $.extend;

	var Sparkline = Chart.extend({

	    init: function(element, userOptions) {
	        var options = userOptions;
	        if (options instanceof kendo.data.ObservableArray) {
	            options = { seriesDefaults: { data: options } };
	        }

	        Chart.fn.init.call(this, element, KendoSparkline.normalizeOptions(options));
	    },

	    _createChart: function(options, themeOptions) {
	        this._instance = new KendoSparkline(this.element[0], options, themeOptions, {
	            observer: new ChartInstanceObserver(this),
	            sender: this,
	            rtl: this._isRtl()
	        });
	    },

	    _createTooltip: function() {
	        return new SparklineTooltip(this.element, extend({}, this.options.tooltip, {
	            rtl: this._isRtl()
	        }));
	    },

	    options: {
	        name: "Sparkline",
	        chartArea: {
	            margin: 2
	        },
	        axisDefaults: {
	            visible: false,
	            majorGridLines: {
	                visible: false
	            },
	            valueAxis: {
	                narrowRange: true
	            }
	        },
	        seriesDefaults: {
	            type: "line",
	            area: {
	                line: {
	                    width: 0.5
	                }
	            },
	            bar: {
	                stack: true
	            },
	            padding: 2,
	            width: 0.5,
	            overlay: {
	                gradient: null
	            },
	            highlight: {
	                visible: false
	            },
	            border: {
	                width: 0
	            },
	            markers: {
	                size: 2,
	                visible: false
	            }
	        },
	        tooltip: {
	            visible: true,
	            shared: true
	        },
	        categoryAxis: {
	            crosshair: {
	                visible: true,
	                tooltip: {
	                    visible: false
	                }
	            }
	        },
	        legend: {
	            visible: false
	        },
	        transitions: false,

	        pointWidth: 5,

	        panes: [{
	            clip: false
	        }]
	    }
	});

	dataviz.ui.plugin(Sparkline);

	var SparklineTooltip = dataviz.Tooltip.extend({
	    options: {
	        animation: {
	            duration: 0
	        }
	    },

	    _hideElement: function() {
	        if (this.element) {
	            this.element.hide().remove();
	        }
	    }
	});

	dataviz.SparklineTooltip = SparklineTooltip;

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 936:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("EBqR");

/***/ })

/******/ });

/***/ }),

/***/ "Wbid":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1312);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1294:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("pfAC");

/***/ }),

/***/ 1295:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("iAAw");

/***/ }),

/***/ 1312:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1295), __webpack_require__(1294) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.actionsheet",
	    name: "ActionSheet",
	    category: "mobile",
	    description: "The mobile ActionSheet widget displays a set of choices related to a task the user initiates.",
	    depends: [ "mobile.popover", "mobile.shim" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        support = kendo.support,
	        ui = kendo.mobile.ui,
	        Shim = ui.Shim,
	        Popup = ui.Popup,
	        Widget = ui.Widget,
	        OPEN = "open",
	        CLOSE = "close",
	        COMMAND = "command",
	        BUTTONS = "li>a",
	        CONTEXT_DATA = "actionsheetContext",
	        WRAP = '<div class="km-actionsheet-wrapper"></div>',
	        cancelTemplate = kendo.template('<li class="km-actionsheet-cancel"><a href="\\#">#:cancel#</a></li>');

	    var ActionSheet = Widget.extend({
	        init: function(element, options) {
	            var that = this,
	                ShimClass,
	                tablet,
	                type,
	                os = support.mobileOS;

	            Widget.fn.init.call(that, element, options);

	            options = that.options;
	            type = options.type;
	            element = that.element;

	            if (type === "auto") {
	                tablet = os && os.tablet;
	            } else {
	                tablet = type === "tablet";
	            }

	            ShimClass = tablet ? Popup : Shim;

	            if (options.cancelTemplate) {
	                cancelTemplate = kendo.template(options.cancelTemplate);
	            }

	            element
	                .addClass("km-actionsheet")
	                .append(cancelTemplate({cancel: that.options.cancel}))
	                .wrap(WRAP)
	                .on("up", BUTTONS, "_click")
	                .on("click", BUTTONS, kendo.preventDefault);

	            that.view().bind("destroy", function() {
	                that.destroy();
	            });

	            that.wrapper = element.parent().addClass(type ? " km-actionsheet-" + type : "");

	            that.shim = new ShimClass(that.wrapper, $.extend({modal: os.ios && os.majorVersion < 7, className: "km-actionsheet-root"}, that.options.popup) );

	            that._closeProxy = $.proxy(that, "_close");
	            that._shimHideProxy = $.proxy(that, "_shimHide");
	            that.shim.bind("hide", that._shimHideProxy);

	            if (tablet) {
	                kendo.onResize(that._closeProxy);
	            }

	            kendo.notify(that, ui);
	        },

	        events: [
	            OPEN,
	            CLOSE,
	            COMMAND
	        ],

	        options: {
	            name: "ActionSheet",
	            cancel: "Cancel",
	            type: "auto",
	            popup: { height: "auto" }
	        },

	        open: function(target, context) {
	            var that = this;
	            that.target = $(target);
	            that.context = context;
	            that.shim.show(target);
	        },

	        close: function() {
	            this.context = this.target = null;
	            this.shim.hide();
	        },

	        openFor: function(target) {
	            var that = this,
	                context = target.data(CONTEXT_DATA);

	            that.open(target, context);
	            that.trigger(OPEN, { target: target, context: context });
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            kendo.unbindResize(this._closeProxy);
	            this.shim.destroy();
	        },

	        _click: function(e) {
	            if (e.isDefaultPrevented()) {
	                return;
	            }

	            var currentTarget = $(e.currentTarget);
	            var action = currentTarget.data("action");

	            if (action) {
	                var actionData = {
	                    target: this.target,
	                    context: this.context
	                },
	                $angular = this.options.$angular;

	                if ($angular) {
	                    this.element.injector().get("$parse")(action)($angular[0])(actionData);
	                } else {
	                    kendo.getter(action)(window)(actionData);
	                }
	            }

	            this.trigger(COMMAND, { target: this.target, context: this.context, currentTarget: currentTarget });

	            e.preventDefault();
	            this._close();
	        },

	        _shimHide: function(e) {
	            if (!this.trigger(CLOSE)) {
	                this.context = this.target = null;
	            } else {
	                e.preventDefault();
	            }
	        },

	        _close: function(e) {
	            if (!this.trigger(CLOSE)) {
	                this.close();
	            } else {
	                e.preventDefault();
	            }
	        }
	    });

	    ui.plugin(ActionSheet);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "WkgI":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1016);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1016:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
	   !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1017), __webpack_require__(1018)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function() {

	(function($, undefined) {

	var kendo = window.kendo,
	    numericTextBoxSettings = { format: "0", min: 0 },
	    units = ["px", "em"],
	    borderStyles = ["solid", "dotted", "dashed", "double", "groove", "ridge", "inset", "outset", "initial", "inherit", "none", "hidden"];

	var DEFAULT_NUMBER_OF_COLS_AND_ROWS = 4;

	var tableAlignmentDropDownSettings = {
	    dataSource: [{
	        className: "k-icon k-i-table-align-middle-left",
	        value: "left"
	    }, {
	        className: "k-icon k-i-table-align-middle-center",
	        value: "center"
	    }, {
	        className: "k-icon k-i-table-align-middle-right",
	        value: "right"
	    }, {
	        className: "k-icon k-i-align-remove",
	        value: ""
	    }],
	    dataTextField: "className",
	    dataValueField: "value",
	    template: "<span class='#: className #' title='#: tooltip #'></span>",
	    valueTemplate: "<span class='k-align-group #: className #' title='#: tooltip #'></span>"
	};

	var cellAlignmentDropDownSettings = {
	    dataSource: [{
	        className: "k-icon k-i-table-align-top-left",
	        value: "left top"
	    }, {
	        className: "k-icon k-i-table-align-top-center",
	        value: "center top"
	    }, {
	        className: "k-icon k-i-table-align-top-right",
	        value: "right top"
	    }, {
	        className: "k-icon k-i-table-align-middle-left",
	        value: "left middle"
	    }, {
	        className: "k-icon k-i-table-align-middle-center",
	        value: "center middle"
	    }, {
	        className: "k-icon k-i-table-align-middle-right",
	        value: "right middle"
	    }, {
	        className: "k-icon k-i-table-align-bottom-left",
	        value: "left bottom"
	    }, {
	        className: "k-icon k-i-table-align-bottom-center",
	        value: "center bottom"
	    }, {
	        className: "k-icon k-i-table-align-bottom-right",
	        value: "right bottom"
	    }, {
	        className: "k-icon k-i-align-remove",
	        value: ""
	    }],
	    dataTextField: "className",
	    dataValueField: "value",
	    template: "<span class='#: className #' title='#: tooltip #'></span>",
	    valueTemplate: "<span class='k-align-group #: className #' title='#: tooltip #'></span>"
	};

	var accessibilityAlignmentDropDownSettings = {
	    dataSource: [{
	        className: "k-icon k-i-table-align-top-left",
	        value: "left top"
	    }, {
	        className: "k-icon k-i-table-align-top-center",
	        value: "center top"
	    }, {
	        className: "k-icon k-i-table-align-top-right",
	        value: "right top"
	    }, {
	        className: "k-icon k-i-table-align-bottom-left",
	        value: "left bottom"
	    }, {
	        className: "k-icon k-i-table-align-bottom-center",
	        value: "center bottom"
	    }, {
	        className: "k-icon k-i-table-align-bottom-right",
	        value: "right bottom"
	    }, {
	        className: "k-icon k-i-align-remove",
	        value: ""
	    }],
	    dataTextField: "className",
	    dataValueField: "value",
	    template: "<span class='#: className #' title='#: tooltip #'></span>",
	    valueTemplate: "<span class='k-align-group #: className #' title='#: tooltip #'></span>"
	};

	var dialogTemplate =
	    '<div class="k-editor-dialog k-editor-table-wizard-dialog k-action-window k-popup-edit-form">' +
	        '<div class="k-edit-form-container">' +
	            '<div id="k-table-wizard-tabs" class="k-root-tabs">' +
	                '<ul>' +
	                    '<li class="k-state-active">#= messages.tableTab #</li>' +
	                    '<li>#= messages.cellTab #</li>' +
	                    '<li>#= messages.accessibilityTab #</li>' +
	                '</ul>' +
	                '<div id="k-table-properties">' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-table-width">#= messages.width #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input type="numeric" id="k-editor-table-width" />' +
	                        '<input id="k-editor-table-width-type" aria-label="#= messages.units #" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-table-height">#= messages.height #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input type="numeric" id="k-editor-table-height" />' +
	                        '<input id="k-editor-table-height-type" aria-label="#= messages.units #" />' +
	                    '</div>' +

	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-table-columns">#= messages.columns #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input type="numeric" id="k-editor-table-columns" />' +
	                    '</div>' +

	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-table-rows">#= messages.rows #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input type="numeric" id="k-editor-table-rows" />' +
	                    '</div>' +

	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-table-cell-spacing">#= messages.cellSpacing #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input type="numeric" id="k-editor-table-cell-spacing" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-table-cell-padding">#= messages.cellPadding #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input type="numeric" id="k-editor-table-cell-padding" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-table-alignment">#= messages.alignment #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input id="k-editor-table-alignment" class="k-align" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-table-bg">#= messages.background #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input id="k-editor-table-bg" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-css-class">#= messages.cssClass #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input id="k-editor-css-class" class="k-textbox" type="text" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-id">#= messages.id #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input id="k-editor-id" class="k-textbox" type="text" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-border-width">#= messages.border #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input type="numeric" id="k-editor-border-width" />' +
	                        '<input id="k-editor-border-color" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-border-style">#= messages.borderStyle #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input id="k-editor-border-style" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">&nbsp;</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input id="k-editor-collapse-borders" type="checkbox" class="k-checkbox" />' +
	                        '<label for="k-editor-collapse-borders" class="k-checkbox-label">#= messages.collapseBorders #</label>' +
	                    '</div>' +
	                '</div>' +

	                '<div id="k-cell-properties">' +

	                    '<div class="k-edit-field">' +
	                        '<input id="k-editor-selectAllCells" type="checkbox" class="k-checkbox" />' +
	                        '<label for="k-editor-selectAllCells" class="k-checkbox-label">#= messages.selectAllCells #</label>' +
	                    '</div>' +

	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-cell-width">#= messages.width #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input type="numeric" id="k-editor-cell-width" />' +
	                        '<input id="k-editor-cell-width-type" aria-label="#= messages.units #" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-cell-height">#= messages.height #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input type="numeric" id="k-editor-cell-height" />' +
	                        '<input id="k-editor-cell-height-type" aria-label="#= messages.units #" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-table-cell-margin">#= messages.cellMargin #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input type="numeric" id="k-editor-table-cell-margin" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-table-cells-padding">#= messages.cellPadding #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input type="numeric" id="k-editor-table-cells-padding" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-cell-alignment">#= messages.alignment #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input id="k-editor-cell-alignment" class="k-align" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-cell-bg">#= messages.background #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input id="k-editor-cell-bg" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-cell-css-class">#= messages.cssClass #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input id="k-editor-cell-css-class" class="k-textbox" type="text" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-cell-id">#= messages.id #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input id="k-editor-cell-id" class="k-textbox" type="text" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-cell-border-width">#= messages.border #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input type="numeric" id="k-editor-cell-border-width" />' +
	                        '<input id="k-editor-cell-border-color" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-cell-border-style">#= messages.borderStyle #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input id="k-editor-cell-border-style" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">&nbsp;</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input id="k-editor-wrap-text" type="checkbox" class="k-checkbox" />' +
	                        '<label for="k-editor-wrap-text" class="k-checkbox-label">#= messages.wrapText #</label>' +
	                    '</div>' +
	                '</div>' +

	                '<div id="k-accessibility-properties">' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-table-header-rows">#= messages.headerRows #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input type="numeric" id="k-editor-table-header-rows" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-table-header-columns">#= messages.headerColumns #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input type="numeric" id="k-editor-table-header-columns" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-table-caption">#= messages.caption #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input id="k-editor-table-caption" class="k-textbox" type="text"/>' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-accessibility-alignment">#= messages.alignment #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<input id="k-editor-accessibility-alignment" class="k-align" />' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-accessibility-summary">#= messages.summary #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<textarea id="k-editor-accessibility-summary" rows="5" class="k-textbox k-editor-accessibility-summary" placeholder="#= messages.tableSummaryPlaceholder #"></textarea>' +
	                    '</div>' +
	                    '<div class="k-edit-label">' +
	                        '<label for="k-editor-cells-headers">#= messages.associateCellsWithHeaders #</label>' +
	                    '</div>' +
	                    '<div class="k-edit-field">' +
	                        '<select id="k-editor-cells-headers">' +
	                            '<option value="none">#= messages.associateNone #</option>' +
	                            '<option value="scope">#= messages.associateScope #</option>' +
	                            '<option value="ids">#= messages.associateIds #</option>' +
	                        '</select>' +
	                    '</div>' +
	                '</div>' +
	                '</div>' +
	                '<div class="k-edit-buttons k-state-default">' +
	                '<button class="k-button k-primary k-dialog-ok">#= messages.dialogOk #</button>' +
	                '<button class="k-button k-dialog-close">#= messages.dialogCancel #</button>' +
	            '</div>' +
	        '</div>' +
	    '</div>';

	var TableWizardDialog = kendo.Class.extend({
	    init: function(options) {
	        this.options = options;
	    },
	    open: function() {
	        var that = this,
	            options = that.options,
	            dialogOptions = options.dialogOptions,
	            tableData = options.table,
	            dialog,
	            messages = options.messages,
	            isIE = kendo.support.browser.msie;

	        function close(e) {
	            e.preventDefault();
	            that.destroy();
	            dialog.destroy();
	        }

	        function okHandler(e) {
	            that.collectDialogValues(tableData);

	            close(e);

	            if (that.change) {
	                that.change();
	            }

	            options.closeCallback(tableData);
	        }

	        function closeHandler(e) {
	            close(e);
	            options.closeCallback();
	        }

	        dialogOptions.close = closeHandler;
	        dialogOptions.title = messages.tableWizard;
	        dialogOptions.visible = options.visible;

	        dialog = $(that._dialogTemplate(messages)).appendTo(document.body)
	            .kendoWindow(dialogOptions)
	            .closest(".k-window").toggleClass("k-rtl", options.isRtl).end()
	            .find(".k-dialog-ok").click(okHandler).end()
	            .find(".k-dialog-close").click(closeHandler).end()
	            .data("kendoWindow");

	        var element = dialog.element;
	        that._initTabStripComponent(element);
	        that._initTableViewComponents(element, tableData);
	        that._initCellViewComponents(element, tableData);
	        that._initAccessibilityViewComponents(element, tableData);

	        dialog.center();
	        dialog.open();

	        if(isIE) {
	            var dialogHeight = element.closest(".k-window").height();
	            element.css("max-height", dialogHeight);
	        }
	    },

	    _initTabStripComponent: function(element){
	        var components = this.components = {};
	        components.tabStrip = element.find("#k-table-wizard-tabs").kendoTabStrip({
	            animation: false
	        }).data("kendoTabStrip");
	    },

	    collectDialogValues: function() {
	        var that = this;
	        var data = that.options.table;
	        that._collectTableViewValues(data);
	        that._collectCellViewValues(data);
	        that._collectAccessibilityViewValues(data);
	    },

	    _collectTableViewValues: function(tableData) {
	        var tableView = this.components.tableView;
	        var tableProperties = tableData.tableProperties;
	        tableProperties.width = tableView.width.value();
	        tableProperties.widthUnit = tableView.widthUnit.value();
	        tableProperties.height = tableView.height.value();
	        tableProperties.columns = tableView.columns.value();
	        tableProperties.rows = tableView.rows.value();
	        tableProperties.heightUnit = tableView.heightUnit.value();
	        tableProperties.cellSpacing = tableView.cellSpacing.value();
	        tableProperties.cellPadding = tableView.cellPadding.value();
	        tableProperties.alignment = tableView.alignment.value();
	        tableProperties.bgColor = tableView.bgColor.value();
	        tableProperties.className = tableView.className.value;
	        tableProperties.id = tableView.id.value;
	        tableProperties.borderWidth = tableView.borderWidth.value();
	        tableProperties.borderColor = tableView.borderColor.value();
	        tableProperties.borderStyle = tableView.borderStyle.value();
	        tableProperties.collapseBorders = tableView.collapseBorders.checked;
	    },

	    _collectCellViewValues: function(table) {
	        var cellData = table.cellProperties = {};
	        var cellView = this.components.cellView;

	        cellData.selectAllCells = cellView.selectAllCells.checked;
	        cellData.width = cellView.width.value();
	        cellData.widthUnit = cellView.widthUnit.value();
	        cellData.height = cellView.height.value();
	        cellData.heightUnit = cellView.heightUnit.value();
	        cellData.cellMargin = cellView.cellMargin.value();
	        cellData.cellPadding = cellView.cellPadding.value();
	        cellData.alignment = cellView.alignment.value();
	        cellData.bgColor = cellView.bgColor.value();
	        cellData.className = cellView.className.value;
	        cellData.id = cellView.id.value;
	        cellData.borderWidth = cellView.borderWidth.value();
	        cellData.borderColor = cellView.borderColor.value();
	        cellData.borderStyle = cellView.borderStyle.value();
	        cellData.wrapText = cellView.wrapText.checked;

	        if (!cellData.width) {
	            cellData.selectAllCells = true;
	            cellData.width = 100 / table.tableProperties.columns;
	            cellData.widthUnit = "%";
	        }
	    },

	   _collectAccessibilityViewValues: function(table) {
	        var tableProperties = table.tableProperties;
	        var accessibilityView = this.components.accessibilityView;
	        tableProperties.captionContent = accessibilityView.captionContent.value;
	        tableProperties.captionAlignment = accessibilityView.captionAlignment.value();
	        tableProperties.summary = accessibilityView.summary.value;
	        tableProperties.cellsWithHeaders = accessibilityView.cellsWithHeaders.value();

	        tableProperties.headerRows = accessibilityView.headerRows.value();
	        tableProperties.headerColumns = accessibilityView.headerColumns.value();
	    },
	    _addUnit: function(units, value){
	        if (value && $.inArray(value, units) == -1) {
	            units.push(value);
	        }
	    },
	    _initTableViewComponents: function(element, table) {
	        var that = this;
	        var components = that.components;
	        var tableView = components.tableView = {};
	        var tableProperties = table.tableProperties = table.tableProperties || {};
	        tableProperties.borderStyle = tableProperties.borderStyle || "";

	        var onColumnsNumberChange = function(args) {
	            var accessibilityView = that.components.accessibilityView;
	            var headerColumnsNumeric = accessibilityView.headerColumns;
	            var currentNumberOfColumnsHeaders = headerColumnsNumeric.value();
	            var numberOfColumns = args.sender.value();

	            if(numberOfColumns < currentNumberOfColumnsHeaders) {
	                headerColumnsNumeric.value(numberOfColumns);
	            }

	            headerColumnsNumeric.max(numberOfColumns);
	        };

	        var onRowsNumberChange = function(args) {
	            var accessibilityView = that.components.accessibilityView;
	            var headerRowsNumeric = accessibilityView.headerRows;
	            var currentNumberOfRowHeaders = headerRowsNumeric.value();
	            var numberOfRows = args.sender.value();

	            if(numberOfRows < currentNumberOfRowHeaders) {
	                headerRowsNumeric.value(numberOfRows);
	            }

	            headerRowsNumeric.max(numberOfRows);
	        };

	        that._addUnit(units, tableProperties.widthUnit);
	        that._addUnit(units, tableProperties.heightUnit);

	        that._initNumericTextbox(element.find("#k-editor-table-width"), "width", tableProperties, tableView);
	        that._initNumericTextbox(element.find("#k-editor-table-height"), "height", tableProperties, tableView);
	        that._initNumericTextbox(element.find("#k-editor-table-columns"), "columns", tableProperties, tableView, {min: 1, value: DEFAULT_NUMBER_OF_COLS_AND_ROWS, change: onColumnsNumberChange});
	        that._initNumericTextbox(element.find("#k-editor-table-rows"), "rows", tableProperties, tableView, {min: 1, value: DEFAULT_NUMBER_OF_COLS_AND_ROWS, change: onRowsNumberChange});
	        that._initDropDownList(element.find("#k-editor-table-width-type"), "widthUnit", tableProperties, tableView, units);
	        that._initDropDownList(element.find("#k-editor-table-height-type"), "heightUnit", tableProperties, tableView, units);
	        that._initNumericTextbox(element.find("#k-editor-table-cell-spacing"), "cellSpacing", tableProperties, tableView);
	        that._initNumericTextbox(element.find("#k-editor-table-cell-padding"), "cellPadding", tableProperties, tableView);
	        that._initTableAlignmentDropDown(element.find("#k-editor-table-alignment"), tableProperties);
	        that._initColorPicker(element.find("#k-editor-table-bg"), "bgColor", tableProperties, tableView);
	        that._initInput(element.find("#k-editor-css-class"), "className", tableProperties, tableView);
	        that._initInput(element.find("#k-editor-id"), "id", tableProperties, tableView);
	        that._initNumericTextbox(element.find("#k-editor-border-width"), "borderWidth", tableProperties, tableView);
	        that._initColorPicker(element.find("#k-editor-border-color"), "borderColor", tableProperties, tableView);
	        that._initDropDownList(element.find("#k-editor-border-style"), "borderStyle", tableProperties, tableView, borderStyles);
	        that._initCheckbox(element.find("#k-editor-collapse-borders"), "collapseBorders", tableProperties, tableView);
	    },

	    _initCellViewComponents: function(element, table) {
	        var components = this.components;
	        var cellView = components.cellView = {};
	        table.selectedCells = table.selectedCells = table.selectedCells || [];
	        var cellProperties = table.selectedCells[0] || {borderStyle: "", wrapText: true};
	        this._addUnit(units, cellProperties.widthUnit);
	        this._addUnit(units, cellProperties.heightUnit);

	        this._initCheckbox(element.find("#k-editor-selectAllCells"), "selectAllCells", table.tableProperties, cellView);
	        this._initNumericTextbox(element.find("#k-editor-cell-width"), "width", cellProperties, cellView);
	        this._initNumericTextbox(element.find("#k-editor-cell-height"), "height", cellProperties, cellView);
	        this._initDropDownList(element.find("#k-editor-cell-width-type"), "widthUnit", cellProperties, cellView, units);
	        this._initDropDownList(element.find("#k-editor-cell-height-type"), "heightUnit", cellProperties, cellView, units);
	        this._initNumericTextbox(element.find("#k-editor-table-cell-margin"), "cellMargin", cellProperties, cellView);
	        this._initNumericTextbox(element.find("#k-editor-table-cells-padding"), "cellPadding", cellProperties, cellView);
	        this._initCellAlignmentDropDown(element.find("#k-editor-cell-alignment"), cellProperties);
	        this._initColorPicker(element.find("#k-editor-cell-bg"), "bgColor", cellProperties, cellView);
	        this._initInput(element.find("#k-editor-cell-css-class"), "className", cellProperties, cellView);
	        this._initInput(element.find("#k-editor-cell-id"), "id", cellProperties, cellView);
	        this._initNumericTextbox(element.find("#k-editor-cell-border-width"), "borderWidth", cellProperties, cellView);
	        this._initColorPicker(element.find("#k-editor-cell-border-color"), "borderColor", cellProperties, cellView);
	        this._initDropDownList(element.find("#k-editor-cell-border-style"), "borderStyle", cellProperties, cellView, borderStyles);
	        this._initCheckbox(element.find("#k-editor-wrap-text"), "wrapText", cellProperties, cellView);
	    },

	    _initAccessibilityViewComponents: function(element, table) {
	        var components = this.components;
	        var accessibilityView = components.accessibilityView = {};
	        var tableProperties = table.tableProperties;

	        this._initInput(element.find("#k-editor-table-caption"), "captionContent", tableProperties, accessibilityView);
	        this._initAccessibilityAlignmentDropDown(element.find("#k-editor-accessibility-alignment"), tableProperties);
	        this._initInput(element.find("#k-editor-accessibility-summary"), "summary", tableProperties, accessibilityView);
	        this._initAssociationDropDown(element.find("#k-editor-cells-headers"), "cellsWithHeaders", { valuePrimitive: true }, tableProperties, accessibilityView);
	        this._initNumericTextbox(element.find("#k-editor-table-header-rows"), "headerRows", tableProperties, accessibilityView, { max: tableProperties.rows || DEFAULT_NUMBER_OF_COLS_AND_ROWS });
	        this._initNumericTextbox(element.find("#k-editor-table-header-columns"), "headerColumns", tableProperties, accessibilityView, { max: tableProperties.columns || DEFAULT_NUMBER_OF_COLS_AND_ROWS });
	    },

	    _initNumericTextbox: function(element, property, data, storage, settings) {
	        var component = storage[property] = element.kendoNumericTextBox(
	                settings ? $.extend({}, numericTextBoxSettings, settings) : numericTextBoxSettings
	            ).data("kendoNumericTextBox");
	        if (property in data) {
	            component.value(parseInt(data[property], 10));
	        }
	    },

	    _initDropDownList: function(element, property, data, storage, dataSource) {
	        var component = storage[property] = element.kendoDropDownList({
	            dataSource: dataSource
	        }).data("kendoDropDownList");
	        this._setComponentValue(component, data, property);
	    },

	    _initTableAlignmentDropDown: function (element, data) {
	        var messages = this.options.messages;
	        var tableView =  this.components.tableView;
	        var dataSource = tableAlignmentDropDownSettings.dataSource;
	        dataSource[0].tooltip = messages.alignLeft;
	        dataSource[1].tooltip = messages.alignCenter;
	        dataSource[2].tooltip = messages.alignRight;
	        dataSource[3].tooltip = messages.alignRemove;

	        this._initAlignmentDropDown(element, tableAlignmentDropDownSettings, "alignment", data, tableView);
	    },

	    _initCellAlignmentDropDown: function (element, data) {
	        var messages = this.options.messages;
	        var cellView =  this.components.cellView;
	        var dataSource = cellAlignmentDropDownSettings.dataSource;
	        dataSource[0].tooltip = messages.alignLeftTop;
	        dataSource[1].tooltip = messages.alignCenterTop;
	        dataSource[2].tooltip = messages.alignRightTop;
	        dataSource[3].tooltip = messages.alignLeftMiddle;
	        dataSource[4].tooltip = messages.alignCenterMiddle;
	        dataSource[5].tooltip = messages.alignRightMiddle;
	        dataSource[6].tooltip = messages.alignLeftBottom;
	        dataSource[7].tooltip = messages.alignCenterBottom;
	        dataSource[8].tooltip = messages.alignRightBottom;
	        dataSource[9].tooltip = messages.alignRemove;

	        this._initAlignmentDropDown(element, cellAlignmentDropDownSettings, "alignment", data, cellView);
	    },

	    _initAccessibilityAlignmentDropDown: function (element, data) {
	        var messages = this.options.messages;
	        var accessibilityView =  this.components.accessibilityView;
	        var dataSource = accessibilityAlignmentDropDownSettings.dataSource;
	        dataSource[0].tooltip = messages.alignLeftTop;
	        dataSource[1].tooltip = messages.alignCenterTop;
	        dataSource[2].tooltip = messages.alignRightTop;
	        dataSource[3].tooltip = messages.alignLeftBottom;
	        dataSource[4].tooltip = messages.alignCenterBottom;
	        dataSource[5].tooltip = messages.alignRightBottom;
	        dataSource[6].tooltip = messages.alignRemove;

	        this._initAlignmentDropDown(element, accessibilityAlignmentDropDownSettings, "captionAlignment", data, accessibilityView);
	    },
	    _initAlignmentDropDown: function(element, settings, name, data, storage) {
	        var component = storage[name] =
	            element.kendoDropDownList(settings).data("kendoDropDownList");

	        component.list.addClass('k-align').css('width', '110px');
	        this._setComponentValue(component, data, name);
	    },
	    _initAssociationDropDown: function(element, name, settings, data, storage) {
	        var component = storage[name] =
	            element.kendoDropDownList(settings).data("kendoDropDownList");

	        this._setComponentValue(component, data, name);
	    },
	    _setComponentValue: function(component, data, property){
	        if (property in data) {
	            component.value(data[property]);
	        }
	    },

	    _initColorPicker: function(element, property, data, storage) {
	        var component = storage[property] =
	            element.kendoColorPicker({buttons: false, clearButton: true}).data("kendoColorPicker");

	        if (data[property]) {
	            component.value(data[property]);
	        }
	    },
	    _initInput: function(element, property, data, storage) {
	        var component = storage[property] = element.get(0);
	        if (property in data) {
	            component.value = data[property];
	        }
	    },

	    _initCheckbox: function(element, property, data, storage) {
	        var component = storage[property] = element.get(0);
	        if (property in data) {
	            component.checked = data[property];
	        }
	    },

	    destroy: function() {
	        this._destroyComponents(this.components.tableView);
	        this._destroyComponents(this.components.cellView);
	        this._destroyComponents(this.components.accessibilityView);
	        this._destroyComponents(this.components);

	        delete this.components;
	    },
	    _destroyComponents: function(components) {
	        for (var widget in components) {
	            if (components[widget].destroy) {
	                components[widget].destroy();
	            }
	            delete components[widget];
	        }
	    },

	    _dialogTemplate: function(messages) {
	        return kendo.template(dialogTemplate)({ messages: messages });
	    }
	});

	kendo.ui.editor.TableWizardDialog = TableWizardDialog;

	})(window.kendo.jQuery);

	}, __webpack_require__(3));

/***/ }),

/***/ 1017:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("BwK2");

/***/ }),

/***/ 1018:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FPoQ");

/***/ })

/******/ });

/***/ }),

/***/ "WuVc":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1381);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1109) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "slider",
	    name: "Slider",
	    category: "web",
	    description: "The Slider widget provides a rich input for selecting values or ranges of values.",
	    depends: [ "draganddrop" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        Draggable = kendo.ui.Draggable,
	        outerWidth = kendo._outerWidth,
	        outerHeight = kendo._outerHeight,
	        extend = $.extend,
	        format = kendo.format,
	        parse = kendo.parseFloat,
	        proxy = $.proxy,
	        isArray = $.isArray,
	        math = Math,
	        support = kendo.support,
	        pointers = support.pointers,
	        msPointers = support.msPointers,
	        CHANGE = "change",
	        SLIDE = "slide",
	        NS = ".slider",
	        MOUSE_DOWN = "touchstart" + NS + " mousedown" + NS,
	        TRACK_MOUSE_DOWN = pointers ? "pointerdown" + NS : (msPointers ? "MSPointerDown" + NS : MOUSE_DOWN),
	        MOUSE_UP = "touchend" + NS + " mouseup" + NS,
	        TRACK_MOUSE_UP = pointers ? "pointerup" : (msPointers ? "MSPointerUp" + NS : MOUSE_UP),
	        MOVE_SELECTION = "moveSelection",
	        KEY_DOWN = "keydown" + NS,
	        CLICK = "click" + NS,
	        MOUSE_OVER = "mouseover" + NS,
	        FOCUS = "focus" + NS,
	        BLUR = "blur" + NS,
	        DRAG_HANDLE = ".k-draghandle",
	        TRACK_SELECTOR = ".k-slider-track",
	        TICK_SELECTOR = ".k-tick",
	        STATE_SELECTED = "k-state-selected",
	        STATE_FOCUSED = "k-state-focused",
	        STATE_DEFAULT = "k-state-default",
	        STATE_DISABLED = "k-state-disabled",
	        DISABLED = "disabled",
	        UNDEFINED = "undefined",
	        TABINDEX = "tabindex",
	        getTouches = kendo.getTouches;

	    var SliderBase = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            options = that.options;
	            that._isHorizontal = options.orientation == "horizontal";
	            that._isRtl = that._isHorizontal && kendo.support.isRtl(element);
	            that._position = that._isHorizontal ? "left" : "bottom";
	            that._sizeFn = that._isHorizontal ? "width" : "height";
	            that._outerSize = that._isHorizontal ? outerWidth : outerHeight;

	            options.tooltip.format = options.tooltip.enabled ? options.tooltip.format || "{0}" : "{0}";

	            if (options.smallStep <= 0) {
	                throw new Error('Kendo UI Slider smallStep must be a positive number.');
	            }

	            that._createHtml();
	            that.wrapper = that.element.closest(".k-slider");
	            that._trackDiv = that.wrapper.find(TRACK_SELECTOR);

	            that._setTrackDivWidth();

	            that._maxSelection = that._trackDiv[that._sizeFn]();

	            that._sliderItemsInit();

	            that._reset();

	            that._tabindex(that.wrapper.find(DRAG_HANDLE));
	            that[options.enabled ? "enable" : "disable"]();

	            var rtlDirectionSign = kendo.support.isRtl(that.wrapper) ? -1 : 1;

	            that._keyMap = {
	                37: step(-1 * rtlDirectionSign * options.smallStep), // left arrow
	                40: step(-options.smallStep), // down arrow
	                39: step(+1 * rtlDirectionSign * options.smallStep), // right arrow
	                38: step(+options.smallStep), // up arrow
	                35: setValue(options.max), // end
	                36: setValue(options.min), // home
	                33: step(+options.largeStep), // page up
	                34: step(-options.largeStep)  // page down
	            };

	            kendo.notify(that);
	        },

	        events: [
	            CHANGE,
	            SLIDE
	        ],

	        options: {
	            enabled: true,
	            min: 0,
	            max: 10,
	            smallStep: 1,
	            largeStep: 5,
	            orientation: "horizontal",
	            tickPlacement: "both",
	            tooltip: { enabled: true, format: "{0}" }
	        },

	        _distance: function(){
	            return round(this.options.max - this.options.min);
	        },

	        _resize: function() {
	            this._setTrackDivWidth();
	            this.wrapper.find(".k-slider-items").remove();

	            this._maxSelection = this._trackDiv[this._sizeFn]();
	            this._sliderItemsInit();
	            this._refresh();

	            if (this.options.enabled) {
	                this.enable(true);
	            }
	        },

	        _sliderItemsInit: function() {
	            var that = this,
	                options = that.options;

	            var sizeBetweenTicks = that._maxSelection / ((options.max - options.min) / options.smallStep);
	            var pixelWidths = that._calculateItemsWidth(math.floor(removeFraction(that._distance()) / removeFraction(options.smallStep)));

	            if (options.tickPlacement != "none" && sizeBetweenTicks >= 2) {
	                $(this.element).parent().find(".k-slider-items").remove();
	                that._trackDiv.before(createSliderItems(options, that._distance()));
	                that._setItemsWidth(pixelWidths);
	                that._setItemsTitle();
	            }

	            that._calculateSteps(pixelWidths);

	            if (options.tickPlacement != "none" && sizeBetweenTicks >= 2 &&
	                options.largeStep >= options.smallStep) {
	                that._setItemsLargeTick();
	            }
	        },

	        getSize: function() {
	            return kendo.dimensions(this.wrapper);
	        },

	        _setTrackDivWidth: function() {
	            var that = this,
	                trackDivPosition = parseFloat(that._trackDiv.css(that._isRtl ? "right" : that._position), 10) * 2;

	            that._trackDiv[that._sizeFn]((that.wrapper[that._sizeFn]() - 2) - trackDivPosition);
	        },

	        _setItemsWidth: function(pixelWidths) {
	            var that = this,
	                options = that.options,
	                first = 0,
	                last = pixelWidths.length - 1,
	                items = that.wrapper.find(TICK_SELECTOR),
	                i,
	                paddingTop = 0,
	                bordersWidth = 2,
	                count = items.length,
	                selection = 0;

	            for (i = 0; i < count - 2; i++) {
	                $(items[i + 1])[that._sizeFn](pixelWidths[i]);
	            }

	            if (that._isHorizontal) {
	                $(items[first]).addClass("k-first")[that._sizeFn](pixelWidths[last - 1]);
	                $(items[last]).addClass("k-last")[that._sizeFn](pixelWidths[last]);
	            } else {
	                $(items[last]).addClass("k-first")[that._sizeFn](pixelWidths[last]);
	                $(items[first]).addClass("k-last")[that._sizeFn](pixelWidths[last - 1]);
	            }

	            if (that._distance() % options.smallStep !== 0 && !that._isHorizontal) {
	                for (i = 0; i < pixelWidths.length; i++) {
	                    selection += pixelWidths[i];
	                }

	                paddingTop = that._maxSelection - selection;
	                paddingTop += parseFloat(that._trackDiv.css(that._position), 10) + bordersWidth;

	                that.wrapper.find(".k-slider-items").css("padding-top", paddingTop);
	            }
	        },

	        _setItemsTitle: function() {
	            var that = this,
	                options = that.options,
	                items = that.wrapper.find(TICK_SELECTOR),
	                titleNumber = options.min,
	                count = items.length,
	                i = that._isHorizontal && !that._isRtl ? 0 : count - 1,
	                limit = that._isHorizontal && !that._isRtl ? count : -1,
	                increment = that._isHorizontal && !that._isRtl ? 1 : -1;

	            for (; i - limit !== 0 ; i += increment) {
	                $(items[i]).attr("title", format(options.tooltip.format, round(titleNumber)));
	                titleNumber += options.smallStep;
	            }
	        },

	        _setItemsLargeTick: function() {
	            var that = this,
	                options = that.options,
	                items = that.wrapper.find(TICK_SELECTOR),
	                i = 0, item, value;

	            if (removeFraction(options.largeStep) % removeFraction(options.smallStep) === 0 || that._distance() / options.largeStep >= 3) {
	                if (!that._isHorizontal && !that._isRtl) {
	                    items = $.makeArray(items).reverse();
	                }

	                for (i = 0; i < items.length; i++) {
	                    item = $(items[i]);
	                    value = that._values[i];
	                    var valueWithoutFraction = round(removeFraction(value - this.options.min));
	                    if (valueWithoutFraction % removeFraction(options.smallStep) === 0 && valueWithoutFraction % removeFraction(options.largeStep) === 0) {
	                        item.addClass("k-tick-large")
	                            .html("<span class='k-label'>" + item.attr("title") + "</span>");

	                        if (i !== 0 && i !== items.length - 1) {
	                            item.css("line-height", item[that._sizeFn]() + "px");
	                        }
	                    }
	                }
	            }
	        },

	        _calculateItemsWidth: function(itemsCount) {
	            var that = this,
	                options = that.options,
	                trackDivSize = parseFloat(that._trackDiv.css(that._sizeFn)) + 1,
	                distance = that._distance(),
	                preciseItemsCount = removeFraction(distance) / removeFraction(options.smallStep),
	                pixelStep = trackDivSize / removeFraction(distance),
	                itemWidth,
	                pixelWidths,
	                i;

	            if (preciseItemsCount - itemsCount > 0) {
	                trackDivSize -= ((removeFraction(distance) % removeFraction(options.smallStep)) * pixelStep);
	            }

	            itemWidth = trackDivSize / itemsCount;
	            pixelWidths = [];

	            for (i = 0; i < itemsCount - 1; i++) {
	                pixelWidths[i] = itemWidth;
	            }

	            pixelWidths[itemsCount - 1] = pixelWidths[itemsCount] = itemWidth / 2;
	            return that._roundWidths(pixelWidths);
	        },

	        _roundWidths: function(pixelWidthsArray) {
	            var balance = 0,
	                count = pixelWidthsArray.length,
	                i;

	            for (i = 0; i < count; i++) {
	                balance += (pixelWidthsArray[i] - math.floor(pixelWidthsArray[i]));
	                pixelWidthsArray[i] = math.floor(pixelWidthsArray[i]);
	            }

	            balance = math.round(balance);

	            return this._addAdditionalSize(balance, pixelWidthsArray);
	        },

	        _addAdditionalSize: function(additionalSize, pixelWidthsArray) {
	            if (additionalSize === 0) {
	                return pixelWidthsArray;
	            }

	            //set step size
	            var step = parseFloat(pixelWidthsArray.length - 1) / parseFloat(additionalSize == 1 ? additionalSize : additionalSize - 1),
	                i;

	            for (i = 0; i < additionalSize; i++) {
	                pixelWidthsArray[parseInt(math.round(step * i), 10)] += 1;
	            }

	            return pixelWidthsArray;
	        },

	        _calculateSteps: function(pixelWidths) {
	            var that = this,
	                options = that.options,
	                val = options.min,
	                selection = 0,
	                distance = that._distance(),
	                itemsCount = math.ceil(removeFraction(distance) / removeFraction(options.smallStep)),
	                i = 1,
	                lastItem;

	            itemsCount += (removeFraction(distance) / removeFraction(options.smallStep)) % 1 === 0 ? 1 : 0;
	            pixelWidths.splice(0, 0, pixelWidths[itemsCount - 2] * 2);
	            pixelWidths.splice(itemsCount -1, 1, pixelWidths.pop() * 2);

	            that._pixelSteps = [selection];
	            that._values = [val];

	            if (itemsCount === 0) {
	                return;
	            }

	            while (i < itemsCount) {
	                selection += (pixelWidths[i - 1] + pixelWidths[i]) / 2;
	                that._pixelSteps[i] = selection;
	                val += options.smallStep;
	                that._values[i] = round(val);

	                i++;
	            }

	            lastItem = (removeFraction(distance) % removeFraction(options.smallStep)) === 0 ? itemsCount - 1 : itemsCount;

	            that._pixelSteps[lastItem] = that._maxSelection;
	            that._values[lastItem] = options.max;

	            if (that._isRtl) {
	                that._pixelSteps.reverse();
	                that._values.reverse();
	            }
	        },

	        _getValueFromPosition: function(mousePosition, dragableArea) {
	            var that = this,
	                options = that.options,
	                step = math.max(options.smallStep * (that._maxSelection / that._distance()), 0),
	                position = 0,
	                halfStep = (step / 2),
	                i;

	            if (that._isHorizontal) {
	                position = mousePosition - dragableArea.startPoint;
	                if (that._isRtl) {
	                    position = that._maxSelection - position;
	                }
	            } else {
	                position = dragableArea.startPoint - mousePosition;
	            }

	            if (that._maxSelection - ((parseInt(that._maxSelection % step, 10) - 3) / 2) < position) {
	                return options.max;
	            }

	            for (i = 0; i < that._pixelSteps.length; i++) {
	                if (math.abs(that._pixelSteps[i] - position) - 1 <= halfStep) {
	                    return round(that._values[i]);
	                }
	            }
	        },

	        _getFormattedValue: function(val, drag) {
	            var that = this,
	                html = "",
	                tooltip = that.options.tooltip,
	                tooltipTemplate,
	                selectionStart,
	                selectionEnd;

	            if (isArray(val)) {
	                selectionStart = val[0];
	                selectionEnd = val[1];
	            } else if (drag && drag.type) {
	                selectionStart = drag.selectionStart;
	                selectionEnd = drag.selectionEnd;
	            }

	            if (drag) {
	                tooltipTemplate = drag.tooltipTemplate;
	            }

	            if (!tooltipTemplate && tooltip.template) {
	                tooltipTemplate = kendo.template(tooltip.template);
	            }

	            if (isArray(val) || (drag && drag.type)) {

	                if (tooltipTemplate) {
	                    html = tooltipTemplate({
	                        selectionStart: selectionStart,
	                        selectionEnd: selectionEnd
	                    });
	                } else {
	                    selectionStart = format(tooltip.format, selectionStart);
	                    selectionEnd = format(tooltip.format, selectionEnd);
	                    html = selectionStart + " - " + selectionEnd;
	                }
	            } else {
	                if (drag) {
	                    drag.val = val;
	                }

	                if (tooltipTemplate) {
	                    html = tooltipTemplate({
	                        value: val
	                    });
	                } else {
	                    html = format(tooltip.format, val);
	                }
	            }
	            return html;
	        },

	        _getDraggableArea: function() {
	            var that = this,
	                offset = kendo.getOffset(that._trackDiv);

	            return {
	                startPoint: that._isHorizontal ? offset.left : offset.top + that._maxSelection,
	                endPoint: that._isHorizontal ? offset.left + that._maxSelection : offset.top
	            };
	        },

	        _createHtml: function() {
	            var that = this,
	                element = that.element,
	                options = that.options,
	                inputs = element.find("input");

	            if (inputs.length == 2) {
	                inputs.eq(0).prop("value", formatValue(options.selectionStart));
	                inputs.eq(1).prop("value", formatValue(options.selectionEnd));
	            } else {
	                element.prop("value", formatValue(options.value));
	            }

	            element.wrap(createWrapper(options, element, that._isHorizontal)).hide();

	            if (options.showButtons) {
	                element.before(createButton(options, "increase", that._isHorizontal, that._isRtl))
	                       .before(createButton(options, "decrease", that._isHorizontal, that._isRtl));
	            }

	            element.before(createTrack(options, element));
	        },

	        _focus: function(e) {
	            var that = this,
	                target = e.target,
	                val = that.value(),
	                drag = that._drag;

	            if (!drag) {
	                if (target == that.wrapper.find(DRAG_HANDLE).eq(0)[0]) {
	                    drag = that._firstHandleDrag;
	                    that._activeHandle = 0;
	                } else {
	                    drag = that._lastHandleDrag;
	                    that._activeHandle = 1;
	                }
	                val = val[that._activeHandle];
	            }

	            $(target).addClass(STATE_FOCUSED + " " + STATE_SELECTED);

	            if (drag) {
	                that._activeHandleDrag = drag;

	                drag.selectionStart = that.options.selectionStart;
	                drag.selectionEnd = that.options.selectionEnd;

	                drag._updateTooltip(val);
	            }
	        },

	        _focusWithMouse: function(target) {
	            target = $(target);

	            var that = this,
	                idx = target.is(DRAG_HANDLE) ? target.index() : 0;

	            window.setTimeout(function(){
	                that.wrapper.find(DRAG_HANDLE)[idx == 2 ? 1 : 0].focus();
	            }, 1);

	            that._setTooltipTimeout();
	        },

	        _blur: function(e) {
	            var that = this,
	                drag = that._activeHandleDrag;

	            $(e.target).removeClass(STATE_FOCUSED + " " + STATE_SELECTED);

	            if (drag) {
	                drag._removeTooltip();
	                delete that._activeHandleDrag;
	                delete that._activeHandle;
	            }
	        },

	        _setTooltipTimeout: function() {
	            var that = this;
	            that._tooltipTimeout = window.setTimeout(function(){
	                var drag = that._drag || that._activeHandleDrag;
	                if (drag) {
	                    drag._removeTooltip();
	                }
	            }, 300);
	        },

	        _clearTooltipTimeout: function() {
	            var that = this;
	            window.clearTimeout(this._tooltipTimeout);
	            var drag = that._drag || that._activeHandleDrag;
	            if (drag && drag.tooltipDiv) {
	                drag.tooltipDiv.stop(true, false).css("opacity", 1);
	            }
	        },

	        _reset: function () {
	            var that = this,
	                element = that.element,
	                formId = element.attr("form"),
	                form = formId ? $("#" + formId) : element.closest("form");

	            if (form[0]) {
	                that._form = form.on("reset", proxy(that._formResetHandler, that));
	            }
	        },

	        min: function(value){
	            if(!value){
	                return this.options.min;
	            }
	            this.setOptions({"min":value});
	        },

	        max: function(value){
	            if(!value){
	                return this.options.max;
	            }
	            this.setOptions({"max":value});
	        },

	        setOptions: function(options) {
	            Widget.fn.setOptions.call(this, options);
	            this._sliderItemsInit();
	            this._refresh();
	        },

	        destroy: function () {
	            if (this._form) {
	                this._form.off("reset", this._formResetHandler);
	            }
	            Widget.fn.destroy.call(this);
	        }
	    });

	    function createWrapper (options, element, isHorizontal) {
	        var orientationCssClass = isHorizontal ? " k-slider-horizontal" : " k-slider-vertical",
	            style = options.style ? options.style : element.attr("style"),
	            cssClasses = element.attr("class") ? (" " + element.attr("class")) : "",
	            tickPlacementCssClass = "";

	        if (options.tickPlacement == "bottomRight") {
	            tickPlacementCssClass = " k-slider-bottomright";
	        } else if (options.tickPlacement == "topLeft") {
	            tickPlacementCssClass = " k-slider-topleft";
	        }

	        style = style ? " style='" + style + "'" : "";

	        return "<div class='k-widget k-slider" + orientationCssClass + cssClasses + "'" + style + ">" +
	               "<div class='k-slider-wrap" + (options.showButtons ? " k-slider-buttons" : "") + tickPlacementCssClass +
	               "'></div></div>";
	    }

	    function createButton (options, type, isHorizontal, isRtl) {
	        var buttonCssClass = "";

	        if(isHorizontal) {
	            if ((!isRtl && type == "increase") || (isRtl && type != "increase")) {
	                buttonCssClass = "k-i-arrow-60-right";
	            } else {
	                buttonCssClass = "k-i-arrow-60-left";
	            }
	        } else {
	            if (type == "increase") {
	                buttonCssClass = "k-i-arrow-60-up";
	            } else {
	                buttonCssClass = "k-i-arrow-60-down";
	            }
	        }

	        return "<a class='k-button k-button-" + type + "' " +
	                "title='" + options[type + "ButtonTitle"] + "' " +
	                "aria-label='" + options[type + "ButtonTitle"] + "'>" +
	                "<span class='k-icon " + buttonCssClass + "'></span></a>";
	    }

	    function createSliderItems (options, distance) {
	        var result = "<ul class='k-reset k-slider-items'>",
	            count = math.floor(round(distance / options.smallStep)) + 1,
	            i;

	        for(i = 0; i < count; i++) {
	            result += "<li class='k-tick' role='presentation'>&nbsp;</li>";
	        }

	        result += "</ul>";

	        return result;
	    }

	    function createTrack (options, element) {
	        var dragHandleCount = element.is("input") ? 1 : 2,
	            firstDragHandleTitle = dragHandleCount == 2 ? options.leftDragHandleTitle : options.dragHandleTitle;

	        return "<div class='k-slider-track'><div class='k-slider-selection'><!-- --></div>" +
	               "<a href='#' class='k-draghandle' title='" + firstDragHandleTitle + "' role='slider' aria-valuemin='" + options.min + "' aria-valuemax='" + options.max + "' aria-valuenow='" + (dragHandleCount > 1 ? (options.selectionStart || options.min) : options.value || options.min) + "'></a>" +
	               (dragHandleCount > 1 ? "<a href='#' class='k-draghandle' title='" + options.rightDragHandleTitle + "'role='slider' aria-valuemin='" + options.min + "' aria-valuemax='" + options.max + "' aria-valuenow='" + (options.selectionEnd || options.max) + "'></a>" : "") +
	               "</div>";
	    }

	    function step(stepValue) {
	        return function (value) {
	            return value + stepValue;
	        };
	    }

	    function setValue(value) {
	        return function () {
	            return value;
	        };
	    }

	    function formatValue(value) {
	        return (value + "").replace(".", kendo.cultures.current.numberFormat["."]);
	    }

	    function calculatePrecision(value) {
	        var number = value.toString();
	        var precision = 0;

	        number = number.split(".");

	        if (number[1]) {
	            precision = number[1].length;
	        }

	        precision = precision > 10 ? 10 : precision;
	        return precision;
	    }

	    function round(value) {
	        var precision, power;

	        value = parseFloat(value, 10);
	        precision = calculatePrecision(value);
	        power = math.pow(10, precision || 0);

	        return math.round(value * power) / power;
	    }

	    function parseAttr(element, name) {
	        var value = parse(element.getAttribute(name));
	        if (value === null) {
	            value = undefined;
	        }
	        return value;
	    }

	    function defined(value) {
	        return typeof value !== UNDEFINED;
	    }

	    function removeFraction(value) {
	        return value * 10000;
	    }

	    var Slider = SliderBase.extend({
	        init: function(element, options) {
	            var that = this,
	                dragHandle;

	            element.type = "text";
	            options = extend({}, {
	                value: parseAttr(element, "value"),
	                min: parseAttr(element, "min"),
	                max: parseAttr(element, "max"),
	                smallStep: parseAttr(element, "step")
	            }, options);

	            element = $(element);

	            if (options && options.enabled === undefined) {
	                options.enabled = !element.is("[disabled]");
	            }

	            SliderBase.fn.init.call(that, element, options);
	            options = that.options;
	            if (!defined(options.value) || options.value === null) {
	                options.value = options.min;
	                element.prop("value", formatValue(options.min));
	            }
	            options.value = math.max(math.min(options.value, options.max), options.min);

	            dragHandle = that.wrapper.find(DRAG_HANDLE);

	            this._selection = new Slider.Selection(dragHandle, that, options);
	            that._drag = new Slider.Drag(dragHandle, "", that, options);
	        },

	        options: {
	            name: "Slider",
	            showButtons: true,
	            increaseButtonTitle: "Increase",
	            decreaseButtonTitle: "Decrease",
	            dragHandleTitle: "drag",
	            tooltip: { format: "{0:#,#.##}" },
	            value: null
	        },

	        enable: function (enable) {
	            var that = this,
	                options = that.options,
	                clickHandler,
	                move;

	            that.disable();
	            if (enable === false) {
	                return;
	            }

	            that.wrapper
	                .removeClass(STATE_DISABLED)
	                .addClass(STATE_DEFAULT);

	            that.wrapper.find("input").removeAttr(DISABLED);

	            clickHandler = function (e) {
	                var touch = getTouches(e)[0];

	                if (!touch) {
	                    return;
	                }

	                var mousePosition = that._isHorizontal ? touch.location.pageX : touch.location.pageY,
	                    dragableArea = that._getDraggableArea(),
	                    target = $(e.target);

	                if (target.hasClass("k-draghandle")) {
	                    target.addClass(STATE_FOCUSED + " " + STATE_SELECTED);
	                    return;
	                }

	                that._update(that._getValueFromPosition(mousePosition, dragableArea));

	                that._focusWithMouse(e.target);

	                that._drag.dragstart(e);
	                e.preventDefault();
	            };

	            that.wrapper
	                .find(TICK_SELECTOR + ", " + TRACK_SELECTOR)
	                    .on(TRACK_MOUSE_DOWN, clickHandler)
	                    .end()
	                    .on(TRACK_MOUSE_DOWN, function() {
	                        $(document.documentElement).one("selectstart", kendo.preventDefault);
	                    })
	                    .on(TRACK_MOUSE_UP, function() {
	                        that._drag._end();
	                    });

	            that.wrapper
	                .find(DRAG_HANDLE)
	                .attr(TABINDEX, 0)
	                .on(MOUSE_UP, function () {
	                    that._setTooltipTimeout();
	                })
	                .on(CLICK, function (e) {
	                    that._focusWithMouse(e.target);
	                    e.preventDefault();
	                })
	                .on(FOCUS, proxy(that._focus, that))
	                .on(BLUR, proxy(that._blur, that));

	            move = proxy(function (sign) {
	                var newVal = that._nextValueByIndex(that._valueIndex + (sign * 1));
	                that._setValueInRange(newVal);
	                that._drag._updateTooltip(newVal);
	            }, that);

	            if (options.showButtons) {
	                var mouseDownHandler = proxy(function(e, sign) {
	                    this._clearTooltipTimeout();
	                    if (e.which === 1 || (support.touch && e.which === 0)) {
	                        move(sign);

	                        this.timeout = setTimeout(proxy(function () {
	                            this.timer = setInterval(function () {
	                                move(sign);
	                            }, 60);
	                        }, this), 200);
	                    }
	                }, that);

	                that.wrapper.find(".k-button")
	                    .on(MOUSE_UP, proxy(function (e) {
	                        this._clearTimer();
	                        that._focusWithMouse(e.target);
	                    }, that))
	                    .on(MOUSE_OVER, function (e) {
	                        $(e.currentTarget).addClass("k-state-hover");
	                    })
	                    .on("mouseout" + NS, proxy(function (e) {
	                        $(e.currentTarget).removeClass("k-state-hover");
	                        this._clearTimer();
	                    }, that))
	                    .eq(0)
	                    .on(MOUSE_DOWN, proxy(function (e) {
	                        mouseDownHandler(e, 1);
	                    }, that))
	                    .click(false)
	                    .end()
	                    .eq(1)
	                    .on(MOUSE_DOWN, proxy(function (e) {
	                        mouseDownHandler(e, -1);
	                    }, that))
	                    .click(kendo.preventDefault);
	            }

	            that.wrapper
	                .find(DRAG_HANDLE)
	                .off(KEY_DOWN, false)
	                .on(KEY_DOWN, proxy(this._keydown, that));

	            options.enabled = true;
	        },

	        disable: function () {
	            var that = this;

	            that.wrapper
	                .removeClass(STATE_DEFAULT)
	                .addClass(STATE_DISABLED);

	            $(that.element).prop(DISABLED, DISABLED);

	            that.wrapper
	                .find(".k-button")
	                .off(MOUSE_DOWN)
	                .on(MOUSE_DOWN, function(e) {
	                    e.preventDefault();
	                    $(this).addClass("k-state-active");
	                })
	                .off(MOUSE_UP)
	                .on(MOUSE_UP, function(e) {
	                    e.preventDefault();
	                    $(this).removeClass("k-state-active");
	                })
	                .off("mouseleave" + NS)
	                .on("mouseleave" + NS, kendo.preventDefault)
	                .off(MOUSE_OVER)
	                .on(MOUSE_OVER, kendo.preventDefault);

	            that.wrapper
	                .find(TICK_SELECTOR + ", " + TRACK_SELECTOR).off(TRACK_MOUSE_DOWN).off(TRACK_MOUSE_UP);

	            that.wrapper
	                .find(DRAG_HANDLE)
	                .attr(TABINDEX, -1)
	                .off(MOUSE_UP)
	                .off(KEY_DOWN)
	                .off(CLICK)
	                .off(FOCUS)
	                .off(BLUR);

	            that.options.enabled = false;
	        },

	        _update: function (val) {
	            var that = this,
	                change = that.value() != val;

	            that.value(val);

	            if (change) {
	                that.trigger(CHANGE, { value: that.options.value });
	            }
	        },

	        value: function (value) {
	            var that = this,
	                options = that.options;

	            value = round(value);
	            if (isNaN(value)) {
	                return options.value;
	            }

	            if (value >= options.min && value <= options.max) {
	                if (options.value != value) {
	                    that.element.prop("value", formatValue(value));
	                    options.value = value;
	                    that._refreshAriaAttr(value);
	                    that._refresh();
	                }
	            }
	        },

	        _refresh: function () {
	            this.trigger(MOVE_SELECTION, { value: this.options.value });
	        },

	        _refreshAriaAttr: function(value) {
	            var that = this,
	                drag = that._drag,
	                formattedValue;

	            if (drag && drag._tooltipDiv) {
	                formattedValue = drag._tooltipDiv.text();
	            } else {
	                formattedValue = that._getFormattedValue(value, null);
	            }
	            this.wrapper.find(DRAG_HANDLE).attr("aria-valuenow", value).attr("aria-valuetext", formattedValue);
	        },

	        _clearTimer: function () {
	            clearTimeout(this.timeout);
	            clearInterval(this.timer);
	        },

	        _keydown: function (e) {
	            var that = this;

	            if (e.keyCode in that._keyMap) {
	                that._clearTooltipTimeout();
	                that._setValueInRange(that._keyMap[e.keyCode](that.options.value));
	                that._drag._updateTooltip(that.value());
	                e.preventDefault();
	            }
	        },

	        _setValueInRange: function (val) {
	            var that = this,
	                options = that.options;

	            val = round(val);
	            if (isNaN(val)) {
	                that._update(options.min);
	                return;
	            }

	            val = math.max(math.min(val, options.max), options.min);
	            that._update(val);
	        },

	        _nextValueByIndex: function (index) {
	            var count = this._values.length;
	            if (this._isRtl) {
	                index = count - 1 - index;
	            }
	            return this._values[math.max(0, math.min(index, count - 1))];
	        },

	        _formResetHandler: function () {
	            var that = this,
	                min = that.options.min;

	            setTimeout(function () {
	                var value = that.element[0].value;
	                that.value(value === "" || isNaN(value) ? min : value);
	            });
	        },

	        destroy: function() {
	            var that = this;

	            SliderBase.fn.destroy.call(that);

	            that.wrapper.off(NS)
	                .find(".k-button").off(NS)
	                .end()
	                .find(DRAG_HANDLE).off(NS)
	                .end()
	                .find(TICK_SELECTOR + ", " + TRACK_SELECTOR).off(NS)
	                .end();

	            that._drag.draggable.destroy();
	            that._drag._removeTooltip(true);
	        }
	    });

	    Slider.Selection = function (dragHandle, that, options) {
	        function moveSelection (val) {
	            var selectionValue = val - options.min,
	                index = that._valueIndex = math.ceil(round(selectionValue / options.smallStep)),
	                selection = parseInt(that._pixelSteps[index], 10),
	                selectionDiv = that._trackDiv.find(".k-slider-selection"),

	                halfDragHanndle = parseInt(that._outerSize(dragHandle) / 2, 10),
	                rtlCorrection = that._isRtl ? 2 : 0;

	            selectionDiv[that._sizeFn](that._isRtl ? that._maxSelection - selection : selection);
	            dragHandle.css(that._position, selection - halfDragHanndle - rtlCorrection);
	        }

	        moveSelection(options.value);

	        that.bind([SLIDE, MOVE_SELECTION], function (e) {
	            moveSelection(parseFloat(e.value, 10));
	        });

	        that.bind(CHANGE, function (e) {
	            moveSelection(parseFloat(e.sender.value(), 10));
	        });
	    };

	    Slider.Drag = function (element, type, owner, options) {
	        var that = this;
	        that.owner = owner;
	        that.options = options;
	        that.element = element;
	        that.type = type;

	        that.draggable = new Draggable(element, {
	            distance: 0,
	            dragstart: proxy(that._dragstart, that),
	            drag: proxy(that.drag, that),
	            dragend: proxy(that.dragend, that),
	            dragcancel: proxy(that.dragcancel, that)
	        });

	        element.click(false);

	        // Disable link dragging
	        element.on("dragstart", function(e){
	            e.preventDefault();
	        });
	    };

	    Slider.Drag.prototype = {
	        dragstart: function(e) {
	            // add reference to the last active drag handle.
	            this.owner._activeDragHandle = this;
	            // HACK to initiate click on the line
	            this.draggable.userEvents.cancel();
	            this._dragstart(e);
	            this.dragend();
	        },

	        _dragstart: function(e) {
	            var that = this,
	                owner = that.owner,
	                options = that.options;

	            if (!options.enabled) {
	                e.preventDefault();
	                return;
	            }

	            // add reference to the last active drag handle.
	            this.owner._activeDragHandle = this;

	            owner.element.off(MOUSE_OVER);
	            owner.wrapper.find("." + STATE_FOCUSED).removeClass(STATE_FOCUSED + " " + STATE_SELECTED);
	            that.element.addClass(STATE_FOCUSED + " " + STATE_SELECTED);
	            $(document.documentElement).css("cursor", "pointer");

	            that.dragableArea = owner._getDraggableArea();
	            that.step = math.max(options.smallStep * (owner._maxSelection / owner._distance()), 0);

	            if (that.type) {
	                that.selectionStart = options.selectionStart;
	                that.selectionEnd = options.selectionEnd;
	                owner._setZIndex(that.type);
	            } else {
	                that.oldVal = that.val = options.value;
	            }

	            that._removeTooltip(true);
	            that._createTooltip();
	        },

	        _createTooltip: function() {
	            var that = this,
	                owner = that.owner,
	                tooltip = that.options.tooltip,
	                html = '',
	                wnd = $(window),
	                tooltipTemplate, colloutCssClass;

	            if (!tooltip.enabled) {
	                return;
	            }

	            if (tooltip.template) {
	                tooltipTemplate = that.tooltipTemplate = kendo.template(tooltip.template);
	            }

	            $(".k-slider-tooltip").remove(); // if user changes window while tooltip is visible, a second one will be created
	            that.tooltipDiv = $("<div class='k-tooltip k-slider-tooltip'><!-- --></div>").appendTo(document.body);

	            html = owner._getFormattedValue(that.val || owner.value(), that);

	            if (!that.type) {
	                colloutCssClass = "k-callout-" + (owner._isHorizontal ? 's' : 'e');
	                that.tooltipInnerDiv = "<div class='k-callout " + colloutCssClass + "'><!-- --></div>";
	                html += that.tooltipInnerDiv;
	            }

	            that.tooltipDiv.html(html);

	            that._scrollOffset = {
	                top: wnd.scrollTop(),
	                left: kendo.scrollLeft(wnd)
	            };

	            that.moveTooltip();
	        },

	        drag: function (e) {
	            var that = this,
	                owner = that.owner,
	                x = e.x.location,
	                y = e.y.location,
	                startPoint = that.dragableArea.startPoint,
	                endPoint = that.dragableArea.endPoint,
	                slideParams;

	            e.preventDefault();

	            if (owner._isHorizontal) {
	                if (owner._isRtl) {
	                    that.val = that.constrainValue(x, startPoint, endPoint, x < endPoint);
	                } else {
	                    that.val = that.constrainValue(x, startPoint, endPoint, x >= endPoint);
	                }
	            } else {
	                that.val = that.constrainValue(y, endPoint, startPoint, y <= endPoint);
	            }

	            if (that.oldVal != that.val) {
	                that.oldVal = that.val;

	                if (that.type) {
	                    if (that.type == "firstHandle") {
	                        if (that.val < that.selectionEnd) {
	                            that.selectionStart = that.val;
	                        } else {
	                            that.selectionStart = that.selectionEnd = that.val;
	                        }
	                    } else {
	                        if (that.val > that.selectionStart) {
	                            that.selectionEnd = that.val;
	                        } else {
	                            that.selectionStart = that.selectionEnd = that.val;
	                        }
	                    }
	                    slideParams = {
	                        values: [that.selectionStart, that.selectionEnd],
	                        value: [that.selectionStart, that.selectionEnd]
	                    };
	                } else {
	                    slideParams = { value: that.val };
	                }

	                owner.trigger(SLIDE, slideParams);
	            }
	            that._updateTooltip(that.val);
	        },

	        _updateTooltip: function(val) {
	            var that = this,
	                options = that.options,
	                tooltip = options.tooltip,
	                html = "";

	            if (!tooltip.enabled) {
	                return;
	            }

	            if (!that.tooltipDiv) {
	                that._createTooltip();
	            }

	            html = that.owner._getFormattedValue(round(val), that);

	            if (!that.type) {
	                html += that.tooltipInnerDiv;
	            }

	            that.tooltipDiv.html(html);
	            that.moveTooltip();
	        },

	        dragcancel: function() {
	            this.owner._refresh();
	            $(document.documentElement).css("cursor", "");
	            return this._end();
	        },

	        dragend: function() {
	            var that = this,
	                owner = that.owner;

	            $(document.documentElement).css("cursor", "");

	            if (that.type) {
	                owner._update(that.selectionStart, that.selectionEnd);
	            } else {
	                owner._update(that.val);
	                that.draggable.userEvents._disposeAll();
	            }

	            that.draggable.userEvents.cancel();
	            return that._end();
	        },

	        _end: function() {
	            var that = this,
	                owner = that.owner;

	            owner._focusWithMouse(that.element);

	            owner.element.on(MOUSE_OVER);

	            return false;
	        },

	        _removeTooltip: function(noAnimation) {
	            var that = this,
	                owner = that.owner;

	            if (that.tooltipDiv && owner.options.tooltip.enabled && owner.options.enabled) {
	                if (noAnimation) {
	                    that.tooltipDiv.remove();
	                    that.tooltipDiv = null;
	                } else {
	                    that.tooltipDiv.fadeOut("slow", function(){
	                        $(this).remove();
	                        that.tooltipDiv = null;
	                    });
	                }
	            }
	        },

	        moveTooltip: function () {
	            var that = this,
	                owner = that.owner,
	                top = 0,
	                left = 0,
	                element = that.element,
	                offset = kendo.getOffset(element),
	                margin = 8,
	                viewport = $(window),
	                callout = that.tooltipDiv.find(".k-callout"),
	                width = outerWidth(that.tooltipDiv),
	                height = outerHeight(that.tooltipDiv),
	                dragHandles, sdhOffset, diff, anchorSize;

	            if (that.type) {
	                dragHandles = owner.wrapper.find(DRAG_HANDLE);
	                offset = kendo.getOffset(dragHandles.eq(0));
	                sdhOffset = kendo.getOffset(dragHandles.eq(1));

	                if (owner._isHorizontal) {
	                    top = sdhOffset.top;
	                    left = offset.left + ((sdhOffset.left - offset.left) / 2);
	                } else {
	                    top = offset.top + ((sdhOffset.top - offset.top) / 2);
	                    left = sdhOffset.left;
	                }

	                anchorSize = outerWidth(dragHandles.eq(0)) + 2 * margin;
	            } else {
	                top = offset.top;
	                left = offset.left;
	                anchorSize = outerWidth(element) + 2 * margin;
	            }

	            if (owner._isHorizontal) {
	                left -= parseInt((width - owner._outerSize(element)) / 2, 10);
	                top -= height + margin + (callout.length ? callout.height() : 0);
	            } else {
	                top -= parseInt((height - owner._outerSize(element)) / 2, 10);
	                left -= width + margin + (callout.length ? callout.width() : 0);
	            }

	            if (owner._isHorizontal) {
	                diff = that._flip(top, height, anchorSize, outerHeight(viewport) + that._scrollOffset.top);
	                top += diff;
	                left += that._fit(left, width, outerWidth(viewport) + that._scrollOffset.left);
	            } else {
	                diff = that._flip(left, width, anchorSize, outerWidth(viewport) + that._scrollOffset.left);
	                top += that._fit(top, height, outerHeight(viewport) + that._scrollOffset.top);
	                left += diff;
	            }

	            if (diff > 0 && callout) {
	                callout.removeClass();
	                callout.addClass("k-callout k-callout-" + (owner._isHorizontal ? "n" : "w"));
	            }

	            that.tooltipDiv.css({ top: top, left: left });
	        },

	        _fit: function(position, size, viewPortEnd) {
	            var output = 0;

	            if (position + size > viewPortEnd) {
	                output = viewPortEnd - (position + size);
	            }

	            if (position < 0) {
	                output = -position;
	            }

	            return output;
	        },

	        _flip: function(offset, size, anchorSize, viewPortEnd) {
	            var output = 0;

	            if (offset + size > viewPortEnd) {
	                output += -(anchorSize + size);
	            }

	            if (offset + output < 0) {
	                output += anchorSize + size;
	            }

	            return output;
	        },

	        constrainValue: function (position, min, max, maxOverflow) {
	            var that = this,
	                val = 0;

	            if (min < position && position < max) {
	                val = that.owner._getValueFromPosition(position, that.dragableArea);
	            } else {
	                if (maxOverflow ) {
	                    val = that.options.max;
	                } else {
	                    val = that.options.min;
	                }
	            }

	            return val;
	        }

	    };

	    kendo.ui.plugin(Slider);

	    var RangeSlider = SliderBase.extend({
	        init: function(element, options) {
	            var that = this,
	                inputs = $(element).find("input"),
	                firstInput = inputs.eq(0)[0],
	                secondInput = inputs.eq(1)[0];

	            firstInput.type = "text";
	            secondInput.type = "text";

	            if (options && options.showButtons) {
	                if (window.console) {
	                    window.console.warn("showbuttons option is not supported for the range slider, ignoring");
	                }

	                options.showButtons = false;
	            }

	            options = extend({}, {
	                selectionStart: parseAttr(firstInput, "value"),
	                min: parseAttr(firstInput, "min"),
	                max: parseAttr(firstInput, "max"),
	                smallStep: parseAttr(firstInput, "step")
	            }, {
	                selectionEnd: parseAttr(secondInput, "value"),
	                min: parseAttr(secondInput, "min"),
	                max: parseAttr(secondInput, "max"),
	                smallStep: parseAttr(secondInput, "step")
	            }, options);

	            if (options && options.enabled === undefined) {
	                options.enabled = !inputs.is("[disabled]");
	            }

	            SliderBase.fn.init.call(that, element, options);
	            options = that.options;
	            if (!defined(options.selectionStart) || options.selectionStart === null) {
	                options.selectionStart = options.min;
	                inputs.eq(0).prop("value", formatValue(options.min));
	            }

	            if (!defined(options.selectionEnd) || options.selectionEnd === null) {
	                options.selectionEnd = options.max;
	                inputs.eq(1).prop("value", formatValue(options.max));
	            }

	            var dragHandles = that.wrapper.find(DRAG_HANDLE);

	            this._selection = new RangeSlider.Selection(dragHandles, that, options);
	            that._firstHandleDrag = new Slider.Drag(dragHandles.eq(0), "firstHandle", that, options);
	            that._lastHandleDrag = new Slider.Drag(dragHandles.eq(1), "lastHandle" , that, options);
	        },

	        options: {
	            name: "RangeSlider",
	            leftDragHandleTitle: "drag",
	            rightDragHandleTitle: "drag",
	            tooltip: { format: "{0:#,#.##}" },
	            selectionStart: null,
	            selectionEnd: null
	        },

	        enable: function (enable) {
	            var that = this,
	                options = that.options,
	                clickHandler;

	            that.disable();
	            if (enable === false) {
	                return;
	            }

	            that.wrapper
	                .removeClass(STATE_DISABLED)
	                .addClass(STATE_DEFAULT);

	            that.wrapper.find("input").removeAttr(DISABLED);

	            clickHandler = function (e) {
	                var touch = getTouches(e)[0];

	                if (!touch) {
	                    return;
	                }

	                var mousePosition = that._isHorizontal ? touch.location.pageX : touch.location.pageY,
	                    dragableArea = that._getDraggableArea(),
	                    val = that._getValueFromPosition(mousePosition, dragableArea),
	                    target = $(e.target),
	                    from, to, drag;

	                if (target.hasClass("k-draghandle")) {
	                    that.wrapper.find("." + STATE_FOCUSED).removeClass(STATE_FOCUSED + " " + STATE_SELECTED);
	                    target.addClass(STATE_FOCUSED + " " + STATE_SELECTED);
	                    return;
	                }

	                if (val < options.selectionStart) {
	                    from = val;
	                    to = options.selectionEnd;
	                    drag = that._firstHandleDrag;
	                } else if (val > that.selectionEnd) {
	                    from = options.selectionStart;
	                    to = val;
	                    drag = that._lastHandleDrag;
	                } else {
	                    if (val - options.selectionStart <= options.selectionEnd - val) {
	                        from = val;
	                        to = options.selectionEnd;
	                        drag = that._firstHandleDrag;
	                    } else {
	                        from = options.selectionStart;
	                        to = val;
	                        drag = that._lastHandleDrag;
	                    }
	                }

	                drag.dragstart(e);
	                that._setValueInRange(from, to);
	                that._focusWithMouse(drag.element);
	            };

	            that.wrapper
	                .find(TICK_SELECTOR + ", " + TRACK_SELECTOR)
	                    .on(TRACK_MOUSE_DOWN, clickHandler)
	                    .end()
	                    .on(TRACK_MOUSE_DOWN, function() {
	                        $(document.documentElement).one("selectstart", kendo.preventDefault);
	                    })
	                    .on(TRACK_MOUSE_UP, function() {
	                        if (that._activeDragHandle) {
	                            that._activeDragHandle._end();
	                        }
	                    });

	            that.wrapper
	                .find(DRAG_HANDLE)
	                .attr(TABINDEX, 0)
	                .on(MOUSE_UP, function () {
	                    that._setTooltipTimeout();
	                })
	                .on(CLICK, function (e) {
	                    that._focusWithMouse(e.target);
	                    e.preventDefault();
	                })
	                .on(FOCUS, proxy(that._focus, that))
	                .on(BLUR, proxy(that._blur, that));

	            that.wrapper.find(DRAG_HANDLE)
	                .off(KEY_DOWN, kendo.preventDefault)
	                .eq(0).on(KEY_DOWN,
	                    proxy(function(e) {
	                        this._keydown(e, "firstHandle");
	                    }, that)
	                )
	                .end()
	                .eq(1).on(KEY_DOWN,
	                    proxy(function(e) {
	                        this._keydown(e, "lastHandle");
	                    }, that)
	                );

	            that.options.enabled = true;
	        },

	        disable: function () {
	            var that = this;

	            that.wrapper
	                .removeClass(STATE_DEFAULT)
	                .addClass(STATE_DISABLED);

	            that.wrapper.find("input").prop(DISABLED, DISABLED);

	            that.wrapper
	                .find(TICK_SELECTOR + ", " + TRACK_SELECTOR).off(TRACK_MOUSE_DOWN).off(TRACK_MOUSE_UP);

	            that.wrapper
	                .find(DRAG_HANDLE)
	                .attr(TABINDEX, -1)
	                .off(MOUSE_UP)
	                .off(KEY_DOWN)
	                .off(CLICK)
	                .off(FOCUS)
	                .off(BLUR);

	            that.options.enabled = false;
	        },

	        _keydown: function (e, handle) {
	            var that = this,
	                selectionStartValue = that.options.selectionStart,
	                selectionEndValue = that.options.selectionEnd,
	                dragSelectionStart,
	                dragSelectionEnd,
	                activeHandleDrag;

	            if (e.keyCode in that._keyMap) {

	                that._clearTooltipTimeout();

	                if (handle == "firstHandle") {
	                    activeHandleDrag = that._activeHandleDrag = that._firstHandleDrag;
	                    selectionStartValue = that._keyMap[e.keyCode](selectionStartValue);

	                    if (selectionStartValue > selectionEndValue) {
	                        selectionEndValue = selectionStartValue;
	                    }
	                } else {
	                    activeHandleDrag = that._activeHandleDrag = that._lastHandleDrag;
	                    selectionEndValue = that._keyMap[e.keyCode](selectionEndValue);

	                    if (selectionStartValue > selectionEndValue) {
	                        selectionStartValue = selectionEndValue;
	                    }
	                }

	                that._setValueInRange(round(selectionStartValue), round(selectionEndValue));

	                dragSelectionStart = Math.max(selectionStartValue, that.options.selectionStart);
	                dragSelectionEnd = Math.min(selectionEndValue, that.options.selectionEnd);

	                activeHandleDrag.selectionEnd = Math.max(dragSelectionEnd, that.options.selectionStart);
	                activeHandleDrag.selectionStart = Math.min(dragSelectionStart, that.options.selectionEnd);

	                activeHandleDrag._updateTooltip(that.value()[that._activeHandle]);

	                e.preventDefault();
	            }
	        },

	        _update: function (selectionStart, selectionEnd) {
	            var that = this,
	                values = that.value();

	            var change = values[0] != selectionStart || values[1] != selectionEnd;

	            that.value([selectionStart, selectionEnd]);

	            if (change) {
	                that.trigger(CHANGE, {
	                    values: [selectionStart, selectionEnd],
	                    value: [selectionStart, selectionEnd]
	                });
	            }
	        },

	        value: function(value) {
	            if (value && value.length) {
	                return this._value(value[0], value[1]);
	            } else {
	                return this._value();
	            }
	        },

	        _value: function(start, end) {
	            var that = this,
	                options = that.options,
	                selectionStart = options.selectionStart,
	                selectionEnd = options.selectionEnd;

	            if (isNaN(start) && isNaN(end)) {
	                return [selectionStart, selectionEnd];
	            } else {
	                start = round(start);
	                end = round(end);
	            }

	            if (start >= options.min && start <= options.max &&
	                end >= options.min && end <= options.max && start <= end) {
	                if (selectionStart != start || selectionEnd != end) {
	                    that.element.find("input")
	                        .eq(0).prop("value", formatValue(start))
	                        .end()
	                        .eq(1).prop("value", formatValue(end));

	                    options.selectionStart = start;
	                    options.selectionEnd = end;
	                    that._refresh();
	                    that._refreshAriaAttr(start, end);
	                }
	            }
	        },

	        values: function (start, end) {
	            if (isArray(start)) {
	                return this._value(start[0], start[1]);
	            } else {
	                return this._value(start, end);
	            }
	        },

	        _refresh: function() {
	            var that = this,
	                options = that.options;

	            that.trigger(MOVE_SELECTION, {
	                values: [options.selectionStart, options.selectionEnd],
	                value: [options.selectionStart, options.selectionEnd]
	            });

	            if (options.selectionStart == options.max && options.selectionEnd == options.max) {
	                that._setZIndex("firstHandle");
	            }
	        },

	        _refreshAriaAttr: function(start, end) {
	            var that = this,
	                dragHandles = that.wrapper.find(DRAG_HANDLE),
	                drag = that._activeHandleDrag,
	                formattedValue;

	            formattedValue = that._getFormattedValue([start, end], drag);

	            dragHandles.eq(0).attr("aria-valuenow", start);
	            dragHandles.eq(1).attr("aria-valuenow", end);
	            dragHandles.attr("aria-valuetext", formattedValue);
	        },

	        _setValueInRange: function (selectionStart, selectionEnd) {
	            var options = this.options;

	            selectionStart = math.max(math.min(selectionStart, options.max), options.min);

	            selectionEnd = math.max(math.min(selectionEnd, options.max), options.min);

	            if (selectionStart == options.max && selectionEnd == options.max) {
	                this._setZIndex("firstHandle");
	            }

	            this._update(math.min(selectionStart, selectionEnd), math.max(selectionStart, selectionEnd));
	        },

	        _setZIndex: function (type) {
	            this.wrapper.find(DRAG_HANDLE).each(function (index) {
	                $(this).css("z-index", type == "firstHandle" ? 1 - index : index);
	            });
	        },

	        _formResetHandler: function () {
	            var that = this,
	                options = that.options;

	            setTimeout(function () {
	                var inputs = that.element.find("input");
	                var start = inputs[0].value;
	                var end = inputs[1].value;
	                that.values(start === "" || isNaN(start) ? options.min : start, end === "" || isNaN(end) ? options.max : end);
	            });
	        },

	        destroy: function() {
	            var that = this;

	            SliderBase.fn.destroy.call(that);

	            that.wrapper.off(NS)
	                .find(TICK_SELECTOR + ", " + TRACK_SELECTOR).off(NS)
	                .end()
	                .find(DRAG_HANDLE).off(NS);

	            that._firstHandleDrag.draggable.destroy();
	            that._lastHandleDrag.draggable.destroy();
	        }
	    });

	    RangeSlider.Selection = function (dragHandles, that, options) {
	        function moveSelection(value) {
	            value = value || [];
	            var selectionStartValue = value[0] - options.min,
	                selectionEndValue = value[1] - options.min,
	                selectionStartIndex = math.ceil(round(selectionStartValue / options.smallStep)),
	                selectionEndIndex = math.ceil(round(selectionEndValue / options.smallStep)),
	                selectionStart = that._pixelSteps[selectionStartIndex],
	                selectionEnd = that._pixelSteps[selectionEndIndex],
	                halfHandle = parseInt(that._outerSize(dragHandles.eq(0)) / 2, 10),
	                rtlCorrection = that._isRtl ? 2 : 0;

	            dragHandles.eq(0).css(that._position, selectionStart - halfHandle - rtlCorrection)
	                       .end()
	                       .eq(1).css(that._position, selectionEnd - halfHandle - rtlCorrection);

	            makeSelection(selectionStart, selectionEnd);
	        }

	        function makeSelection(selectionStart, selectionEnd) {
	            var selection,
	                selectionPosition,
	                selectionDiv = that._trackDiv.find(".k-slider-selection");

	            selection = math.abs(selectionStart - selectionEnd);

	            selectionDiv[that._sizeFn](selection);
	            if (that._isRtl) {
	                selectionPosition = math.max(selectionStart, selectionEnd);
	                selectionDiv.css("right", that._maxSelection - selectionPosition - 1);
	            } else {
	                selectionPosition = math.min(selectionStart, selectionEnd);
	                selectionDiv.css(that._position, selectionPosition - 1);
	            }
	        }

	        moveSelection(that.value());

	        that.bind([ CHANGE, SLIDE, MOVE_SELECTION ], function (e) {
	            moveSelection(e.values);
	        });
	    };

	    kendo.ui.plugin(RangeSlider);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "X+Of":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1025);
	module.exports = __webpack_require__(1025);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1025:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function () {

	    (function ($, undefined) {
	        var kendo = window.kendo,
	            extend = $.extend,
	            deferred = $.Deferred,
	            proxy = $.proxy,
	            Class = kendo.Class;

	        var Command = Class.extend({
	            init: function (options) {
	                this.options = options;
	                this.filemanager = options.filemanager;
	            }
	        });

	        var CreateFolderCommand = Command.extend({
	            init: function (options) {
	                Command.fn.init.call(this, options);
	            },
	            exec: function () {
	                var that = this,
	                    filemanager = that.filemanager,
	                    commandStack = filemanager._commandStack,
	                    dataSource = filemanager._viewDataSource || filemanager.dataSource,
	                    removeProxy = proxy(that._remove, that);

	                that._item = dataSource._createNewModel();

	                commandStack.push({ item: that._item.toJSON() }).fail(removeProxy);
	                dataSource.add(that._item);
	            },
	            _remove: function () {
	                var that = this,
	                    filemanager = that.filemanager,
	                    dataSource = filemanager._viewDataSource || filemanager.dataSource;

	                dataSource.pushDestroy(that._item);
	            }
	        });

	        var RenameCommand = Command.extend({
	            init: function (options) {
	                Command.fn.init.call(this, options);
	            },
	            exec: function () {
	                var that = this,
	                    target = that.options.target,
	                    filemanager = that.filemanager,
	                    commandStack = filemanager._commandStack,
	                    viewItem = filemanager._view.widgetComponent.dataItem(target);

	                if(target && viewItem){
	                    commandStack.push({ target: target, item: viewItem });
	                    that.filemanager._view.edit(target);
	                } else {
	                    that._renameTreeViewItem(target);
	                }
	            },
	            _renameTreeViewItem: function(target){
	                var that = this,
	                    filemanager = that.filemanager,
	                    commandStack = filemanager._commandStack,
	                    uid = target.data("uid"),
	                    item = that.filemanager.treeView.widgetComponent.dataSource.getByUid(uid),
	                    realItem = that.filemanager.dataSource.get(item.id);

	                that.filemanager._prompt({
	                    type: "rename",
	                    defaultInput: realItem.name,
	                    target: target
	                }).done(function(newName){
	                    commandStack.push({ target: target, item: realItem });
	                    realItem.set("name", newName);
	                });
	            }
	        });

	        var DeleteCommand = Command.extend({
	            init: function (options) {
	                Command.fn.init.call(this, options);
	            },
	            exec: function () {
	                var that = this,
	                    target = that.options.target,
	                    filemanager = that.filemanager,
	                    items = filemanager.getSelected(),
	                    viewItem = that.filemanager._view.widgetComponent.dataItem(target),
	                    itemsToRemove;

	                if(target && target.is(".k-state-selected") && items && items.length) {
	                    itemsToRemove = items;
	                } else if(target && viewItem) {
	                    itemsToRemove = viewItem;
	                } else if(target) {
	                    var uid = target.data("uid");
	                    var item = that.filemanager.treeView.widgetComponent.dataSource.getByUid(uid);
	                    var realItem = that.filemanager.dataSource.get(item.id);

	                    itemsToRemove = realItem;
	                }

	                filemanager._confirm({
	                    type: "delete",
	                    target: target
	                })
	                .done(function () {
	                    that.removeItems(itemsToRemove);
	                });
	            },
	            removeItems: function(items) {
	                var that = this;

	                that._itemsToRemove = Array.isArray(items) ? items : [items];

	                that._removeItem();
	            },
	            _removeItem: function(){
	                var that = this,
	                    filemanager = that.filemanager,
	                    commandStack = filemanager._commandStack,
	                    dataSource = filemanager.dataSource,
	                    itemToRemove = !!that._itemsToRemove.length && that._itemsToRemove.splice(0,1)[0];

	                if (itemToRemove) {
	                    commandStack.push({ item: itemToRemove })
	                        .then(proxy(that._removeItem, that), proxy(that._removeItem, that));

	                    dataSource.remove(itemToRemove);
	                }
	            }
	        });

	        var CopyCommand = Command.extend({
	            init: function (options) {
	                Command.fn.init.call(this, options);
	            },
	            exec: function () {
	                var that = this,
	                filemanager = that.filemanager,
	                dataSource = filemanager.dataSource,
	                commandStack = filemanager._commandStack,
	                items = that.options.items,
	                target = dataSource.get(that.options.target),
	                targetDataSource = target.children;

	                for (var i = 0; i < items.length; i++) {
	                    var item = dataSource.get(items[i]).toJSON();
	                    item.fileManagerNewItem = true;
	                    commandStack.push({ item: item, target: target });
	                    targetDataSource.add(item);
	                }
	            }
	        });

	        var MoveCommand = Command.extend({
	            init: function (options) {
	                var that = this;
	                Command.fn.init.call(that, options);
	                that._itemsToRemove = [];
	            },
	            exec: function () {
	                var that = this,
	                    filemanager = that.filemanager,
	                    commandStack = filemanager._commandStack,
	                    dataSource = filemanager.dataSource,
	                    items = that.options.items,
	                    target = dataSource.get(that.options.target),
	                    targetDataSource = target.children,
	                    promises = [];

	                for (var i = 0; i < items.length; i++) {
	                    var item = dataSource.get(items[i]);
	                    var cloning = item.toJSON();
	                    cloning.fileManagerNewItem = true;

	                    var promise = commandStack.push({ item: item, target: target })
	                        .then(proxy(that._delete, that));

	                        promises.push(promise);
	                        targetDataSource.add(cloning);
	                }

	                kendo.whenAll(promises).always(proxy(that._removeItem, that));
	            },
	            _delete: function(data){
	                var that = this;
	                that._itemsToRemove.push(data.item);
	            },
	            _removeItem: function(){
	                var that = this,
	                    filemanager = that.filemanager,
	                    commandStack = filemanager._commandStack,
	                    dataSource = filemanager.dataSource,
	                    itemToRemove = !!that._itemsToRemove.length && that._itemsToRemove.splice(0,1)[0];

	                if (itemToRemove) {
	                    commandStack.push({ item: itemToRemove })
	                        .then(proxy(that._removeItem, that), proxy(that._removeItem, that));

	                    dataSource.remove(itemToRemove);
	                }
	            }
	        });

	        var SortCommand = Command.extend({
	            init: function (options) {
	                Command.fn.init.call(this, options);
	            },
	            exec: function () {
	                var that = this,
	                    options = that.options,
	                    filemanager = that.filemanager,
	                    sortOptions = filemanager.defaultSortOption;

	                extend(sortOptions, {
	                    dir: options.dir,
	                    field: options.field
	                });

	                filemanager._view.widgetComponent.dataSource.sort([ filemanager.folderSortOption, sortOptions ]);
	            }
	        });

	        var SearchCommand = Command.extend({
	            init: function (options) {
	                Command.fn.init.call(this, options);
	            },
	            exec: function () {
	                var that = this,
	                    options = that.options,
	                    filemanager = that.filemanager,
	                    filter = {
	                        field: options.field,
	                        operator: options.operator,
	                        value: options.value
	                    };

	                filemanager._view.widgetComponent.dataSource.filter(filter);
	            }
	        });

	        var ChangeViewCommand = Command.extend({
	            init: function (options) {
	                Command.fn.init.call(this, options);
	            },
	            exec: function () {
	                var that = this,
	                    options = that.options,
	                    filemanager = that.filemanager;

	                filemanager.view(options.value);
	                filemanager.resize(true);
	            }
	        });

	        var OpenDialogCommand = Command.extend({
	            init: function (options) {
	                Command.fn.init.call(this, options);
	            },
	            exec: function () {
	                var that = this,
	                    filemanager = that.filemanager,
	                    dialog = filemanager[that.options.type];

	                if (dialog) {
	                    dialog.open();
	                } else {
	                    window.console.warn(kendo.format("The {0} dialog is not available!", that.options.type));
	                }
	            }
	        });

	        var TogglePaneCommand = Command.extend({
	            init: function (options) {
	                Command.fn.init.call(this, options);
	            },
	            exec: function() {
	                var that = this,
	                    filemanager = that.filemanager,
	                    pane = filemanager[that.options.type],
	                    resizable = that.getResizable();

	                if (pane) {
	                    pane.toggle();

	                    if (resizable) {
	                        filemanager.wrapper
	                            .find(resizable.options.handle)
	                            .toggle();
	                    }
	                }
	            },
	            getResizable: function() {
	                var that = this,
	                    filemanager = that.filemanager,
	                    type = that.options.type;

	                if (!filemanager._resizeDraggable) {
	                    return;
	                }

	                return filemanager._resizeDraggable[type];
	            }
	        });

	        var CommandStack = Class.extend({
	            init: function(){
	                var that = this;

	                that._stack = {};
	                that._keys = [];
	            },
	            push: function(data){
	                var that = this,
	                    guid = kendo.guid();

	                that._keys.push(guid);
	                that._stack[guid] = {
	                    guid: guid,
	                    data: data,
	                    deferred: deferred()
	                };

	                return that._stack[guid].deferred;
	            },
	            next: function () {
	                var that = this,
	                    key = that.keys().splice(0,1),
	                    nextCommand = that._stack[key];

	                return nextCommand;
	            },
	            resolve: function(command){
	                var that = this;
	                delete that._stack[command.guid];
	                command.deferred.resolve(command.data);
	            },
	            reject: function(command){
	                var that = this;
	                delete that._stack[command.guid];
	                command.deferred.reject(command.data);
	            },
	            keys: function () {
	                return this._keys;
	            },
	            empty: function(){
	                return this.keys().length === 0;
	            }
	        });

	        extend(kendo.ui, {
	            filemanager: {
	                FileManagerCommand: Command,
	                CommandStack: CommandStack,
	                commands: {
	                    CreateFolderCommand: CreateFolderCommand,
	                    RenameCommand: RenameCommand,
	                    DeleteCommand: DeleteCommand,
	                    MoveCommand: MoveCommand,
	                    CopyCommand: CopyCommand,
	                    SortCommand: SortCommand,
	                    SearchCommand: SearchCommand,
	                    ChangeViewCommand: ChangeViewCommand,
	                    OpenDialogCommand: OpenDialogCommand,
	                    TogglePaneCommand: TogglePaneCommand
	                }
	            }
	        });

	    })(window.kendo.jQuery);

	    return window.kendo;

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "X1NG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var VirtualList = (function (_super) {
    __extends(VirtualList, _super);
    function VirtualList() {
        var _this = _super.call(this, null) || this;
        _this.rowsInBodyContainer = {};
        _this.rowHeight = 20;
        return _this;
    }
    VirtualList.prototype.init = function () {
        this.setTemplate(VirtualList.TEMPLATE);
        this.eListContainer = this.queryForHtmlElement(".ag-virtual-list-container");
        this.addScrollListener();
        this.rowHeight = this.gridOptionsWrapper.getVirtualItemHeight();
    };
    VirtualList.prototype.ensureIndexVisible = function (index) {
        var lastRow = this.model.getRowCount();
        if (typeof index !== 'number' || index < 0 || index >= lastRow) {
            console.warn('invalid row index for ensureIndexVisible: ' + index);
            return;
        }
        // let nodeAtIndex = this.rowModel.getRow(index);
        var rowTopPixel = index * this.rowHeight;
        var rowBottomPixel = rowTopPixel + this.rowHeight;
        var viewportTopPixel = this.getGui().scrollTop;
        var viewportHeight = this.getGui().offsetHeight;
        var viewportBottomPixel = viewportTopPixel + viewportHeight;
        var viewportScrolledPastRow = viewportTopPixel > rowTopPixel;
        var viewportScrolledBeforeRow = viewportBottomPixel < rowBottomPixel;
        if (viewportScrolledPastRow) {
            // if row is before, scroll up with row at top
            this.getGui().scrollTop = rowTopPixel;
        }
        else if (viewportScrolledBeforeRow) {
            // if row is below, scroll down with row at bottom
            var newScrollPosition = rowBottomPixel - viewportHeight;
            this.getGui().scrollTop = newScrollPosition;
        }
    };
    VirtualList.prototype.setComponentCreator = function (componentCreator) {
        this.componentCreator = componentCreator;
    };
    VirtualList.prototype.getRowHeight = function () {
        return this.rowHeight;
    };
    VirtualList.prototype.getScrollTop = function () {
        return this.getGui().scrollTop;
    };
    VirtualList.prototype.setRowHeight = function (rowHeight) {
        this.rowHeight = rowHeight;
        this.refresh();
    };
    VirtualList.prototype.refresh = function () {
        if (main_1.Utils.missing(this.model)) {
            return;
        }
        this.eListContainer.style.height = (this.model.getRowCount() * this.rowHeight) + "px";
        this.clearVirtualRows();
        this.drawVirtualRows();
    };
    VirtualList.prototype.clearVirtualRows = function () {
        var rowsToRemove = Object.keys(this.rowsInBodyContainer);
        this.removeVirtualRows(rowsToRemove);
    };
    VirtualList.prototype.drawVirtualRows = function () {
        var topPixel = this.getGui().scrollTop;
        var bottomPixel = topPixel + this.getGui().offsetHeight;
        var firstRow = Math.floor(topPixel / this.rowHeight);
        var lastRow = Math.floor(bottomPixel / this.rowHeight);
        this.ensureRowsRendered(firstRow, lastRow);
    };
    VirtualList.prototype.ensureRowsRendered = function (start, finish) {
        // at the end, this array will contain the items we need to remove
        var rowsToRemove = Object.keys(this.rowsInBodyContainer);
        // add in new rows
        for (var rowIndex = start; rowIndex <= finish; rowIndex++) {
            // see if item already there, and if yes, take it out of the 'to remove' array
            if (rowsToRemove.indexOf(rowIndex.toString()) >= 0) {
                rowsToRemove.splice(rowsToRemove.indexOf(rowIndex.toString()), 1);
                continue;
            }
            // check this row actually exists (in case overflow buffer window exceeds real data)
            if (this.model.getRowCount() > rowIndex) {
                var value = this.model.getRow(rowIndex);
                this.insertRow(value, rowIndex);
            }
        }
        // at this point, everything in our 'rowsToRemove' . . .
        this.removeVirtualRows(rowsToRemove);
    };
    // takes array of row id's
    VirtualList.prototype.removeVirtualRows = function (rowsToRemove) {
        var _this = this;
        rowsToRemove.forEach(function (index) {
            var component = _this.rowsInBodyContainer[index];
            _this.eListContainer.removeChild(component.eDiv);
            if (component.rowComponent.destroy) {
                component.rowComponent.destroy();
            }
            delete _this.rowsInBodyContainer[index];
        });
    };
    VirtualList.prototype.insertRow = function (value, rowIndex) {
        var eDiv = document.createElement('div');
        main_1.Utils.addCssClass(eDiv, 'ag-virtual-list-item');
        eDiv.style.top = (this.rowHeight * rowIndex) + "px";
        var rowComponent = this.componentCreator(value);
        eDiv.appendChild(rowComponent.getGui());
        this.eListContainer.appendChild(eDiv);
        this.rowsInBodyContainer[rowIndex] = {
            rowComponent: rowComponent,
            eDiv: eDiv
        };
    };
    VirtualList.prototype.addScrollListener = function () {
        var _this = this;
        this.addGuiEventListener('scroll', function () {
            _this.drawVirtualRows();
        });
    };
    VirtualList.prototype.setModel = function (model) {
        this.model = model;
    };
    VirtualList.TEMPLATE = '<div class="ag-virtual-list-viewport">' +
        '<div class="ag-virtual-list-container">' +
        '</div>' +
        '</div>';
    __decorate([
        main_1.Autowired('environment'),
        __metadata("design:type", main_1.Environment)
    ], VirtualList.prototype, "environment", void 0);
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], VirtualList.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VirtualList.prototype, "init", null);
    return VirtualList;
}(main_1.Component));
exports.VirtualList = VirtualList;


/***/ }),

/***/ "X8DO":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "XBCZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var LINE_SEPARATOR = '\r\n';
var XmlFactory = (function () {
    function XmlFactory() {
    }
    XmlFactory.prototype.createXml = function (xmlElement, booleanTransformer) {
        var _this = this;
        var props = "";
        if (xmlElement.properties) {
            if (xmlElement.properties.prefixedAttributes) {
                xmlElement.properties.prefixedAttributes.forEach(function (prefixedSet) {
                    Object.keys(prefixedSet.map).forEach(function (key) {
                        props += _this.returnAttributeIfPopulated(prefixedSet.prefix + key, prefixedSet.map[key], booleanTransformer);
                    });
                });
            }
            if (xmlElement.properties.rawMap) {
                Object.keys(xmlElement.properties.rawMap).forEach(function (key) {
                    props += _this.returnAttributeIfPopulated(key, xmlElement.properties.rawMap[key], booleanTransformer);
                });
            }
        }
        var result = "<" + xmlElement.name + props;
        if (!xmlElement.children && xmlElement.textNode == null) {
            return result + "/>" + LINE_SEPARATOR;
        }
        if (xmlElement.textNode != null) {
            return result + ">" + xmlElement.textNode + "</" + xmlElement.name + ">" + LINE_SEPARATOR;
        }
        result += ">" + LINE_SEPARATOR;
        xmlElement.children.forEach(function (it) {
            result += _this.createXml(it, booleanTransformer);
        });
        return result + "</" + xmlElement.name + ">" + LINE_SEPARATOR;
    };
    XmlFactory.prototype.returnAttributeIfPopulated = function (key, value, booleanTransformer) {
        if (!value) {
            return "";
        }
        var xmlValue = value;
        if ((typeof (value) === 'boolean')) {
            if (booleanTransformer) {
                xmlValue = booleanTransformer(value);
            }
        }
        xmlValue = '"' + xmlValue + '"';
        return " " + key + "=" + xmlValue;
    };
    XmlFactory = __decorate([
        context_1.Bean('xmlFactory')
    ], XmlFactory);
    return XmlFactory;
}());
exports.XmlFactory = XmlFactory;


/***/ }),

/***/ "XRen":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoAutoComplete = __webpack_require__("/0gA");

var _KendoAutoComplete2 = _interopRequireDefault(_KendoAutoComplete);

var _KendoDropDownList = __webpack_require__("CiAW");

var _KendoDropDownList2 = _interopRequireDefault(_KendoDropDownList);

var _KendoComboBox = __webpack_require__("Gr0w");

var _KendoComboBox2 = _interopRequireDefault(_KendoComboBox);

var _KendoMultiSelect = __webpack_require__("02+g");

var _KendoMultiSelect2 = _interopRequireDefault(_KendoMultiSelect);

var _KendoMultiColumnComboBox = __webpack_require__("Os2y");

var _KendoMultiColumnComboBox2 = _interopRequireDefault(_KendoMultiColumnComboBox);

var _KendoMultiColumnComboBoxColumn = __webpack_require__("Yjjl");

var _KendoMultiColumnComboBoxColumn2 = _interopRequireDefault(_KendoMultiColumnComboBoxColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoDropdownsInstaller = function () {
    function KendoDropdownsInstaller() {
        _classCallCheck(this, KendoDropdownsInstaller);
    }

    _createClass(KendoDropdownsInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoAutoComplete2.default.name, _KendoAutoComplete2.default);
            Vue.component(_KendoDropDownList2.default.name, _KendoDropDownList2.default);
            Vue.component(_KendoComboBox2.default.name, _KendoComboBox2.default);
            Vue.component(_KendoMultiSelect2.default.name, _KendoMultiSelect2.default);
            Vue.component(_KendoMultiColumnComboBox2.default.name, _KendoMultiColumnComboBox2.default);
            Vue.component(_KendoMultiColumnComboBoxColumn2.default.name, _KendoMultiColumnComboBoxColumn2.default);
        }
    }]);

    return KendoDropdownsInstaller;
}();

exports.default = KendoDropdownsInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoDropdownsInstaller);
}

/***/ }),

/***/ "XY8W":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1359);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1046:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2btM");

/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1359:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1046) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	    var __meta__ = { // jshint ignore:line
	        id: "rating",
	        name: "Rating",
	        category: "web",
	        description: "The Rating component.",
	        depends: [ "core" ]
	    };

	    (function($, undefined) {
	        var kendo = window.kendo,
	            ui = kendo.ui,
	            NS = ".kendoRating",
	            Widget = ui.Widget,
	            extend = $.extend,
	            proxy = $.proxy,
	            keys = kendo.keys,
	            parseFloat = kendo.parseFloat,
	            CHANGE = "change",
	            SELECT = "select",
	            SELECTED = "selected",
	            HOVERED = "hovered",
	            DISABLED = "disabled",
	            READONLY = "readonly",
	            KEYDOWN = "keydown" + NS,
	            CLICK = "click" + NS,
	            MOUSEENTER = "mouseenter" + NS,
	            MOUSELEAVE = "mouseleave" + NS,
	            MOUSEMOVE = "mousemove" + NS,
	            MOUSEDOWN = "mousedown" + NS,
	            FOCUS = "focus" + NS,
	            BLUR = "blur" + NS,
	            ARIA_LABEL = "aria-label",
	            ARIA_LABELLEDBY = "aria-labelledby",
	            ARIA_VALUEMIN = "aria-valuemin",
	            ARIA_VALUEMAX = "aria-valuemax",
	            ARIA_VALUENOW = "aria-valuenow",
	            ARIA_DISABLED = "aria-disabled",
	            ARIA_READONLY = "aria-readonly",
	            PRECISION_PART = "k-rating-precision-part",
	            PRECISION_COMPLEMENT = "k-rating-precision-complement",
	            PRECISION_HALF_VALUE = 0.5,
	            LABELIDPART = "_label",
	            KITEM = "k-rating-item",
	            FOCUSED = "k-state-focused",
	            TABINDEX = "tabindex",
	            DOT = ".",
	            ROLE = "role",
	            MIN = "min",
	            MAX = "max";

	        var ratingSelection = {
	            single: "single",
	            continuous: "continuous"
	        };

	        var ratingPrecision = {
	            item: "item",
	            half: "half"
	        };

	        var ratingItemTemplates = {
	            item: "itemTemplate",
	            hovered: "hoveredTemplate",
	            selected: "selectedTemplate"
	        };

	        var ratingItemStates = {
	            selected: "k-state-selected",
	            hovered: "k-state-hover",
	            hoveredPrecise: "k-state-hover-precise"
	        };

	        var ratingItemAttributes = {
	            partValue: "part-value",
	            dataValue: "data-value",
	            value: "value",
	            title: "title"
	        };

	        var ratingStyles = {
	            widget: "k-rating k-widget",
	            container: "k-rating-container",
	            item: "k-rating-item",
	            icon: "k-icon k-i-star-outline",
	            iconSelected: "k-icon k-i-star",
	            label: "k-rating-label",
	            disabled: "k-state-disabled",
	            readonly: "k-state-readonly",
	            active: "k-state-active",
	            hidden: "k-hidden"
	        };

	        var RATING_TEMPLATE = kendo.template(
	            '<span class="#=styles.widget#"></span>'
	        );

	        var RATING_CONTAINER_TEMPLATE = kendo.template(
	            '<span class="#=styles.container#"></span>'
	        );

	        var RATING_LABEL_WRAPPER_TEMPLATE = kendo.template(
	            '<span class="#=styles.label#"></span>'
	        );

	        var RATING_LABEL_TEMPLATE = kendo.template(
	            '<span>#=value# / #=maxValue#</span>'
	        );

	        var RATING_ITEM_WRAPPER_TEMPLATE = kendo.template(
	            '<span class="#=styles.item#" data-value="#=value#"></span>'
	        );

	        var RATING_ITEM_TEMPLATE = kendo.template(
	            '<span class="#=icon#"></span>'
	        );

	        var Rating = Widget.extend({
	            init: function(element, options) {
	                var that = this;

	                Widget.fn.init.call(that, element, options);

	                that.options = extend({}, that.options, options);

	                that._element();

	                that._wrapper();

	                that._aria();

	                that._initSettings();

	                that._renderItems();

	                that._renderTooltip();

	                that._renderLabel();

	                that._selectInitial();

	                that._attachEvents();

	                kendo.notify(this);
	            },

	            events: [
	                SELECT,
	                CHANGE
	            ],

	            options: {
	                name: "Rating",
	                messages: {},
	                min: 1,
	                max: 5,
	                selection: ratingSelection.continuous,
	                precision: ratingPrecision.item,
	                tooltip: true,
	                label: true,
	                readonly: false,
	                enabled: true,
	                selectValueOnFocus: null,
	                itemTemplate: null,
	                selectedTemplate: null,
	                hoveredTemplate: null
	            },

	            _element: function() {
	                var that = this;

	                that.element.addClass(ratingStyles.hidden);
	            },

	            _wrapper: function() {
	                var that = this;

	                that.wrapper = $(RATING_TEMPLATE({
	                    styles: ratingStyles
	                }));

	                that.wrapper = that.element.wrap(that.wrapper).parent();

	                that.wrapper
	                    .addClass(that.element[0].className.replace(ratingStyles.hidden, ""))
	                    .append($(RATING_CONTAINER_TEMPLATE({
	                        styles: ratingStyles
	                    })));

	                that.wrapper[0].style.cssText = that.element[0].style.cssText;

	                that.container = that.wrapper.find(DOT + ratingStyles.container);
	            },

	            _aria: function() {
	                var that = this,
	                    wrapper = that.wrapper,
	                    element = that.element,
	                    id = element.attr("id"),
	                    labelFor = $("label[for=\"" + id  + "\"]"),
	                    ariaLabel = element.attr(ARIA_LABEL),
	                    ariaLabelledBy = element.attr(ARIA_LABELLEDBY);

	                that.wrapper
	                    .attr(TABINDEX, 0)
	                    .attr(ROLE, "slider")
	                    .attr(ARIA_VALUEMIN, parseFloat(that.element.attr(MIN)) || that.options.min)
	                    .attr(ARIA_VALUEMAX, parseFloat(that.element.attr(MAX)) || that.options.max)
	                    .attr(ARIA_VALUENOW, that.options.value);

	                if (ariaLabel) {
	                    wrapper.attr(ARIA_LABEL, ariaLabel);
	                } else if (ariaLabelledBy){
	                    wrapper.attr(ARIA_LABELLEDBY, ariaLabelledBy);
	                } else if (labelFor.length){
	                    var labelId = labelFor.attr("id");

	                    if (!labelId) {
	                        labelId = (id || kendo.guid()) + LABELIDPART;
	                        labelFor.attr("id", labelId);
	                    }

	                    wrapper.attr(ARIA_LABELLEDBY, labelId);
	                }
	            },

	            _initSettings: function() {
	                var that = this,
	                    isPrecise = that.options.precision != ratingPrecision.item,
	                    options = that.options;

	                options.value = parseFloat(options.value);
	                if (options.value === null) {
	                    options.value = parseFloat(that.element.val());
	                }

	                options.min = parseFloat(that.element.attr(MIN)) || that.options.min;
	                options.max = parseFloat(that.element.attr(MAX)) || that.options.max;
	                that._valueMin = isPrecise ? that.options.min - PRECISION_HALF_VALUE : that.options.min;

	                options.enabled = options.enabled && !that.element.attr(DISABLED);
	                options.readonly = options.readonly || !!that.element.attr(READONLY);
	                that._setState();
	            },

	            _renderItems: function() {
	                var that = this,
	                    container = that.container,
	                    min = that.options.min,
	                    max = that.options.max,
	                    itemTemplate = that.options.itemTemplate ?
	                        kendo.template(that.options.itemTemplate) :
	                        RATING_ITEM_TEMPLATE;

	                for (var i = min; i <= max; i += 1) {
	                    var itemWrapper = $(RATING_ITEM_WRAPPER_TEMPLATE({
	                        styles: ratingStyles,
	                        value: i
	                    }));

	                    itemWrapper.append(itemTemplate({
	                        icon: ratingStyles.icon,
	                        index: i
	                    }));

	                    container.append(itemWrapper);
	                }
	            },

	            _renderTooltip: function() {
	                var that = this,
	                    items = that.container.find(DOT + KITEM),
	                    enabled = that.options.tooltip === true;

	                if (!enabled) {
	                    items.removeAttr(ratingItemAttributes.title);
	                    return;
	                }

	                for (var i = 0; i < items.length; i += 1) {
	                    $(items[i]).attr(ratingItemAttributes.title, $(items[i]).data(ratingItemAttributes.value));
	                }
	            },

	            _renderLabel: function() {
	                var that = this,
	                    label = that.wrapper.find(DOT + ratingStyles.label),
	                    enabled = that.options.label === true || that.options.label.template !== undefined,
	                    template = that.options.label && that.options.label.template ?
	                        kendo.template(that.options.label.template) :
	                        RATING_LABEL_TEMPLATE;

	                if (!enabled || that.value() === null) {
	                    label.remove();
	                    that.label = null;
	                    return;
	                }

	                if (!label.length) {
	                    that.label = label = $(RATING_LABEL_WRAPPER_TEMPLATE({
	                        styles: ratingStyles
	                    }));

	                    that.wrapper.append(label);
	                }

	                label.html(template({
	                    styles: ratingStyles,
	                    value: that.value() % 1 === 0 ? that.value() : that._format(that.value()),
	                    maxValue: that.options.max
	                }));
	            },

	            _selectInitial: function() {
	                var that = this;

	                if (!isNaN(that.options.value)) {
	                    that.value(that.options.value);
	                }
	            },

	            _attachEvents: function() {
	                var that = this,
	                    isHalfPrecision = that.options.precision == ratingPrecision.half;

	                that.wrapper
	                    .on(FOCUS, proxy(that._focus, that))
	                    .on(BLUR, proxy(that._blur, that))
	                    .on(KEYDOWN, proxy(that._keydown, that));

	                that.container
	                    .on(CLICK, DOT + KITEM, proxy(that._click, that))
	                    .on(MOUSEENTER, DOT + KITEM, proxy(that._mouseenter, that))
	                    .on(MOUSELEAVE, DOT + KITEM, proxy(that._mouseleave, that))
	                    .on(MOUSEDOWN, proxy(that._mousedown, that));

	                if (isHalfPrecision) {
	                    that.container.on(MOUSEMOVE, DOT + KITEM,  proxy(that._mousemove, that));
	                }
	            },

	            _focus: function() {
	                var that = this,
	                    container = that.container,
	                    wrapper = that.wrapper,
	                    focusedItems = that.container.find(DOT + FOCUSED),
	                    selectValueOnFocus = that.options.selectValueOnFocus,
	                    firstElement = container.children().first(),
	                    selectedElement, hoveredElement, itemToFocus;

	                if (!that.options.enabled || that.options.readonly || that.preventFocus) {
	                    if (that.options.readonly) {
	                        that.wrapper.addClass(FOCUSED);
	                    }
	                    return;
	                }

	                wrapper.addClass(FOCUSED);
	                focusedItems.removeClass(FOCUSED);

	                if (that.value() === null && selectValueOnFocus !== null) {
	                    that.value(selectValueOnFocus);
	                }

	                selectedElement = container.find(DOT + ratingItemStates.selected).last();
	                hoveredElement = container.find(DOT + ratingItemStates.hovered).last();
	                itemToFocus = selectedElement.length ? selectedElement : hoveredElement;
	                itemToFocus = itemToFocus.length ? itemToFocus : firstElement;

	                itemToFocus.addClass(FOCUSED);
	            },

	            _blur: function() {
	                var that = this;

	                that.preventFocus = false;

	                that.wrapper.removeClass(FOCUSED);
	                that.container.find(DOT + FOCUSED).removeClass(FOCUSED);

	                that.element.blur();
	            },

	            _mousedown: function() {
	                var that = this;

	                that.preventFocus = true;
	            },

	            _keydown: function(e) {
	                var that = this,
	                    container = that.container,
	                    currentValue = that.parsedValue,
	                    isPrecise = that.options.precision != ratingPrecision.item,
	                    step = isPrecise ? PRECISION_HALF_VALUE : 1,
	                    focusableItems = container.find(DOT + KITEM),
	                    focusedElement = container.find(DOT + FOCUSED),
	                    currentIndex = focusableItems.index(focusedElement),
	                    isRtl =  kendo.support.isRtl(that.wrapper),
	                    isEmpty = isNaN(currentValue),
	                    keyCode = e.keyCode,
	                    left, right, itemToFocus, itemValue;

	                if (!that.options.enabled || that.options.readonly) {
	                    return;
	                }

	                left = (keyCode === keys.RIGHT && isRtl) || (keyCode === keys.LEFT && !isRtl);
	                right = (keyCode === keys.LEFT && isRtl) || (keyCode === keys.RIGHT && !isRtl);

	                if (left || keyCode === keys.DOWN) {
	                    itemToFocus = isEmpty ? focusableItems.eq(0) : $(focusableItems[currentIndex - 1]);
	                    itemValue = isEmpty ? that._valueMin : currentValue - step;

	                    that._select(itemToFocus, itemValue);
	                    e.preventDefault();
	                } else if (right || keyCode === keys.UP) {
	                    itemToFocus = isEmpty ? focusableItems.eq(0) : $(focusableItems[currentIndex + 1]);
	                    itemValue = isEmpty ? that._valueMin : currentValue + step;

	                    that._select(itemToFocus, itemValue);
	                    e.preventDefault();
	                } else if (keyCode === keys.HOME) {
	                    itemToFocus = focusableItems.eq(0);

	                    that._select(itemToFocus, that._valueMin);
	                    e.preventDefault();
	                } else if (keyCode === keys.END) {
	                    itemToFocus = focusableItems.eq(focusableItems.length - 1);

	                    that._select(itemToFocus);
	                    e.preventDefault();
	                }
	            },

	            _getTemplateType: function(type) {
	                var that = this,
	                    template;

	                if (that.options[type]) {
	                    template = kendo.template(that.options[type]);
	                }  else {
	                    template = RATING_ITEM_TEMPLATE;
	                }

	                return template;
	            },

	            _renderTemplate: function(target, type) {
	                var that = this,
	                    template = that._getTemplateType(type),
	                    defaultIcon = ratingStyles.icon;

	                if (type == ratingItemTemplates.selected || type == ratingItemTemplates.hovered) {
	                    defaultIcon = ratingStyles.iconSelected;
	                }

	                for (var i = 0; i < target.length; i += 1) {
	                    $(target[i]).html(template({ icon: defaultIcon, index: $(target[i]).index() }));
	                }
	            },

	            _updateItemTemplates: function(state, target) {
	                var that = this,
	                    isSingle = ratingSelection.single == that.options.selection,
	                    isHalfPrecision = that.options.precision == ratingPrecision.half,
	                    previousSelection = that.container.find(DOT + ratingItemStates.selected),
	                    currentSelection = isSingle ? target : target.prevAll().addBack(),
	                    resetItems = isSingle ? previousSelection : target.nextAll(),
	                    templateType = ratingItemTemplates[state],
	                    stateClass = ratingItemStates[state];

	                resetItems.removeClass(stateClass);
	                currentSelection.addClass(stateClass);

	                that._renderTemplate(currentSelection, templateType);

	                if ((!isSingle) || (isSingle && state == SELECTED && currentSelection.get(0) != previousSelection.get(0))) {
	                    that._renderTemplate(resetItems, ratingItemTemplates.item);
	                }

	                if (isHalfPrecision) {
	                    that._renderTemplate(target, ratingItemTemplates.item);
	                }
	            },

	            _change: function(target, newValue) {
	                var that = this,
	                    currentValue = that.value();

	                that.value(newValue);

	                that.trigger(CHANGE, { target: target, oldValue: currentValue, newValue: that.value() });
	            },

	            _click: function(e) {
	                var that = this,
	                    target = $(e.target).closest(DOT + KITEM),
	                    valueToSelect = target.attr(ratingItemAttributes.dataValue);

	                if (!that.options.enabled || that.options.readonly) {
	                    return;
	                }

	                if (target.data(ratingItemAttributes.partValue)) {
	                    valueToSelect = target.data(ratingItemAttributes.partValue);
	                }

	                that._select(target, valueToSelect);
	            },

	            _select: function(target, newValue) {
	                var that = this,
	                    value = isNaN(newValue) ? target.attr(ratingItemAttributes.dataValue) : newValue;

	                if (value == that.value() || value < that._valueMin || value > that.options.max) {
	                   return;
	                }

	                that.trigger(SELECT, { target: target });

	                that._change(target, value);

	                that._focus();
	            },

	            _mouseenter: function(e) {
	                var that = this,
	                    target = $(e.target),
	                    item = target.closest(DOT + KITEM);

	                if (!that.options.enabled || that.options.readonly) {
	                    return;
	                }

	                that.enableMove = true;

	                if (target.is(DOT + KITEM)) {
	                    that._updateItemTemplates(HOVERED, item);
	                }
	            },

	            _mouseleave: function(e) {
	                var that = this,
	                    selection = that.options.selection,
	                    isHalfPrecision = that.options.precision == ratingPrecision.half,
	                    isSingle = selection == ratingSelection.single,
	                    item = $(e.target).closest(DOT + KITEM),
	                    items = that.container.find(DOT + KITEM),
	                    hasPart,
	                    template;

	                that.enableMove = false;

	                var setTemplate = function(item) {
	                    hasPart = that.parsedValue % 1 !== 0 && item.is(that.container.find("[data-value=" + Math.ceil(that.parsedValue) + "]"));
	                    template = (item.hasClass(ratingItemStates.selected) || item.hasClass(ratingItemStates.hovered)) && !hasPart ?
	                        ratingItemTemplates.selected :
	                        ratingItemTemplates.item;

	                    that._renderTemplate(item, template);

	                    if (isHalfPrecision && hasPart && item.hasClass(ratingItemStates.selected)) {
	                        that._togglePrecisionElements(item, SELECTED);
	                    }
	                };

	                items.removeClass(ratingItemStates.hovered);

	                if (isSingle) {
	                    setTemplate(item);
	                } else {
	                    for (var i = 0; i < items.length; i += 1) {
	                        var currentItem = $(items[i]);

	                        setTemplate(currentItem);
	                    }
	                }
	            },

	            _mousemove: function(e) {
	                var that = this,
	                    item = $(e.target).closest(DOT + KITEM),
	                    mousePosition, itemOffset, partSize;

	                if (!that.enableMove) {
	                    return;
	                }

	                if (item.length) {
	                    mousePosition = e.clientX;
	                    itemOffset = item.offset().left;

	                    partSize = Math.abs(mousePosition - itemOffset);

	                    that._togglePrecisionElements(item, HOVERED);
	                    that._updatePrecisionElements(item, partSize);
	                }

	                e.preventDefault();
	            },

	            _togglePrecisionElements: function(item, templateType) {
	                var that = this,
	                    part = item.find(DOT + PRECISION_PART),
	                    partTemplate = that._getTemplateType(ratingItemTemplates[templateType]),
	                    isFraction, itemSize;

	                if (!part.length) {
	                    isFraction = that.parsedValue % 1 !== 0;
	                    itemSize = that._getItemWidth(item);
	                    part = $("<span></span>").addClass(PRECISION_PART);

	                    part.append(partTemplate({
	                        icon: ratingStyles.iconSelected
	                    }));

	                    part.width(isFraction ? itemSize / 2 : itemSize);

	                    item.append(part);

	                    item.append($("<span></span>").css({
	                        "width": itemSize,
	                        "height": itemSize,
	                        "display": "block"
	                    }));

	                    that._createUpdatePrecisionComplement(item, isFraction);
	                } else {
	                    part.html(partTemplate({
	                        icon: ratingStyles.iconSelected
	                    }));
	                }
	            },

	            _createUpdatePrecisionComplement: function(item, isHalf) {
	                var that = this,
	                    complement = item.find(DOT + PRECISION_COMPLEMENT),
	                    iconElement = item.children().first(),
	                    isRtl =  kendo.support.isRtl(that.wrapper),
	                    dir = !isRtl ? "left" : "right";

	                if (!complement.length) {
	                    complement = iconElement.wrap($("<span></span>")
	                        .addClass(PRECISION_COMPLEMENT))
	                        .parent();
	                }

	                complement.width(isHalf ? that._getItemWidth(item) / 2 : 0);

	                complement.css(dir, isHalf || isRtl  ? "50%" : 0);
	            },

	            _calculateItemWidthFromStyles: function(item) {
	                if (!item) {
	                    return;
	                }

	                return parseFloat(item.find(".k-icon").css("font-size"));
	            },

	            _getItemWidth: function(item) {
	                if (!item) {
	                    return;
	                }

	                return item.width() || this._calculateItemWidthFromStyles(item) || 0;
	            },

	            _updatePrecisionElements: function(item, partSize) {
	                var that = this,
	                    itemPart = item.find(DOT + PRECISION_PART),
	                    itemValue = kendo.parseFloat(item.data(ratingItemAttributes.value)),
	                    isRtl =  kendo.support.isRtl(this.wrapper),
	                    itemWidth = item.width(),
	                    halfWidth = itemWidth / 2,
	                    halfOffset = parseFloat(item.outerWidth() / 2),
	                    isHalf =  !isRtl ? partSize < halfOffset : partSize > halfOffset;

	                if (item.length && itemPart.length) {
	                    itemPart.width(isHalf ? halfWidth : itemWidth);

	                    if (this.options.tooltip) {
	                        item.attr(ratingItemAttributes.title, isHalf ?
	                            that._format(itemValue - PRECISION_HALF_VALUE) : itemValue
	                        );
	                    }

	                    item.data(ratingItemAttributes.partValue, isHalf ?
	                        itemValue - PRECISION_HALF_VALUE : itemValue
	                    );

	                    that._createUpdatePrecisionComplement(item, isHalf);
	                }
	            },

	            _updateElement: function(value) {
	                var that = this,
	                    elementValue = value === null ? "" : value;

	                that.element.val(that._format(elementValue));

	                if (that.value === null) {
	                    that.wrapper.removeAttr(ARIA_VALUENOW);
	                } else {
	                    that.wrapper.attr(ARIA_VALUENOW, that._format(value));
	                }
	            },

	            _updateItemsRendering: function(value) {
	                var that = this,
	                    isHalfPrecision = that.options.precision == ratingPrecision.half,
	                    updateTemplate = value === null ? "item" : SELECTED,
	                    valueItem = value === null ?
	                        that.container.find(DOT + ratingItemStates.selected).last() :
	                        that.container.find(DOT + KITEM + "[data-value='"+ Math.ceil(value)  +"']");

	                if (value === null ) {
	                    that.container.find(DOT + KITEM).removeClass(ratingItemStates.selected);
	                }

	                that._updateItemTemplates(updateTemplate, valueItem);

	                if (isHalfPrecision && value !== null) {
	                    that._togglePrecisionElements(valueItem, SELECTED);
	                }

	                that._renderLabel();
	            },

	            _setState: function() {
	                var that = this,
	                    element = that.element,
	                    wrapper = that.wrapper,
	                    readonly = that.options.readonly,
	                    enabled = that.options.enabled;

	                if (readonly && enabled) {
	                    element.attr(READONLY, READONLY);
	                    wrapper.attr(ARIA_READONLY, true);
	                } else {
	                    element.removeAttr(READONLY);
	                    wrapper.removeAttr(ARIA_READONLY);
	                }

	                if (enabled) {
	                    element.removeAttr(DISABLED);
	                    wrapper.removeAttr(ARIA_DISABLED);
	                    wrapper.attr(TABINDEX, 0);
	                } else {
	                    element.attr(DISABLED, DISABLED);
	                    wrapper.attr(ARIA_DISABLED, true);
	                    wrapper.removeAttr(TABINDEX);
	                }

	                wrapper.toggleClass(ratingStyles.disabled, !enabled);
	                wrapper.toggleClass(ratingStyles.readonly, readonly && enabled);
	            },

	            _format: function(value) {
	                return kendo.toString(value, "n1", kendo.getCulture().name);
	            },

	            value: function(value) {
	                var that = this,
	                    isHalfPrecision = that.options.precision == ratingPrecision.half;

	                if (value === null) {
	                    that._updateElement(value);
	                    that._updateItemsRendering(value);

	                    return;
	                }

	                value = parseFloat(value);

	                if (value === null) {
	                    value = parseFloat(that.element.val());
	                    return value;
	                }

	                value = Math.max(that._valueMin, Math.min(value, that.options.max));

	                if (isHalfPrecision) {
	                    that.parsedValue = parseFloat(that._format(Math.ceil(value * 2) / 2));
	                } else {
	                    that.parsedValue = Math.round(value);
	                }

	                that._updateElement(value);
	                that._updateItemsRendering(value);
	            },

	            reset: function() {
	                var that = this;

	                that.value(null);
	            },

	            enable: function(enable) {
	                var that = this;

	                if (typeof enable == "undefined") {
	                    enable = true;
	                }

	                that.options.enabled = enable;
	                that.options.readonly = false;

	                that._setState();
	            },

	            readonly: function(readonly) {
	                var that = this;

	                if (typeof readonly == "undefined") {
	                    readonly = true;
	                }

	                that.options.readonly = readonly;
	                that.options.enabled = true;

	                that._setState();
	            },

	            setOptions: function (options) {
	                var that = this;

	                that.options = $.extend(that.options, options);

	                if (options.enabled !== undefined) {
	                    that.enable(options.enabled);
	                }

	                if (options.readonly !== undefined) {
	                    that.readonly(options.readonly);
	                }

	                if (options.label !== undefined) {
	                    that._renderLabel();
	                }

	                if (options.tooltip !== undefined) {
	                    that._renderTooltip();
	                }

	                if (options.value !== undefined) {
	                    that.value(options.value);
	                }

	                if (options.min || options.max !== undefined ||
	                    options.itemTemplate !== undefined ||
	                    options.selectedTemplate !== undefined ||
	                    options.hoveredTemplate !== undefined) {
	                        that.container.empty();
	                        that._renderItems();
	                        that._renderLabel();
	                        that._renderTooltip();
	                        that._selectInitial();
	                }
	            },

	            destroy: function() {
	                var that = this;

	                that.wrapper.off(NS);
	                that.container.off(NS);

	                Widget.fn.destroy.call(that);
	            }

	        });

	        ui.plugin(Rating);
	  })(window.kendo.jQuery);

	  return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "XmWM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("KCLY");
var utils = __webpack_require__("cGG2");
var InterceptorManager = __webpack_require__("fuGk");
var dispatchRequest = __webpack_require__("xLtR");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "Xqqy":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1554);
	module.exports = __webpack_require__(1554);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1554:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(20),
	        __webpack_require__(1555)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {

	var Workbook = kendo.ooxml.Workbook;

	kendo.ooxml.IntlService.register({
	    toString: kendo.toString
	});

	kendo.ooxml.Workbook = Workbook.extend({
	    toDataURL: function() {
	        var result = Workbook.fn.toDataURL.call(this);
	        if (typeof result !== 'string') {
	            throw new Error('The toDataURL method can be used only with jsZip 2. Either include jsZip 2 or use the toDataURLAsync method.');
	        }

	        return result;
	    },

	    toDataURLAsync: function() {
	        var deferred = $.Deferred();
	        var result = Workbook.fn.toDataURL.call(this);
	        if (typeof result === 'string') {
	            result = deferred.resolve(result);
	        } else if (result && result.then){
	            result.then(function(dataURI) {
	                deferred.resolve(dataURI);
	            }, function() {
	                deferred.reject();
	            });
	        }

	        return deferred.promise();
	    }
	});

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 1555:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("TGH/");

/***/ })

/******/ });

/***/ }),

/***/ "Xs6l":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1584);
	module.exports = __webpack_require__(1584);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1584:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var $ = kendo.jQuery;
	    var CellRef = kendo.spreadsheet.CellRef;

	    var Clipboard = kendo.Class.extend({
	        init: function(workbook) {
	            this._content = {};
	            this._externalContent = {};
	            this._internalContent = {};
	            this.workbook = workbook;
	            this.origin = kendo.spreadsheet.NULLREF;
	            this.iframe = document.createElement("iframe");
	            this.iframe.className = "k-spreadsheet-clipboard-paste";
	            this.iframe.setAttribute("title", "Spreadsheet clipboard iframe");
	            this.menuInvoked = false;
	            this._uid = kendo.guid();
	            document.body.appendChild(this.iframe);
	        },

	        destroy: function() {
	            document.body.removeChild(this.iframe);
	        },

	        canCopy: function() {
	            var status = {canCopy: true};
	            var selection = this.workbook.activeSheet().select();
	            if (selection === kendo.spreadsheet.NULLREF) {
	                status.canCopy = false;
	            }
	            if (selection instanceof kendo.spreadsheet.UnionRef) {
	                status.canCopy = false;
	                status.multiSelection = true;
	            }
	            if (this.menuInvoked) {
	                status.canCopy = false;
	                status.menuInvoked = true;
	            }
	            return status;
	        },

	        canPaste: function() {
	            var sheet = this.workbook.activeSheet();
	            var ref = this.pasteRef();
	            var range = sheet.range(ref);
	            var status = { canPaste: true, pasteOnMerged: false, pasteOnDisabled: false };

	            if (!range.enable()) {
	                status.canPaste =  false;
	                status.pasteOnDisabled = true;
	            }
	            if (!ref.eq(sheet.unionWithMerged(ref))) {
	                status.canPaste = false;
	                status.pasteOnMerged = true;
	            }
	            if (this.menuInvoked) {
	                status.canPaste = false;
	                status.menuInvoked = true;
	            }
	            if (ref.bottomRight.row >= sheet._rows._count || ref.bottomRight.col >= sheet._columns._count) {
	                status.canPaste = false;
	                status.overflow = true;
	            }
	            return status;
	        },

	        intersectsMerged: function() {
	            var sheet = this.workbook.activeSheet();
	            this.parse();
	            this.origin = this._content.origRef;
	            var ref = this.pasteRef();
	            return !ref.eq(sheet.unionWithMerged(ref));
	        },

	        copy: function() {
	            var sheet = this.workbook.activeSheet();
	            this.origin = sheet.select();
	            this._internalContent = sheet.selection().getState();
	            delete this._externalContent.html;
	            delete this._externalContent.plain;
	        },

	        cut: function() {
	            var sheet = this.workbook.activeSheet();
	            this.copy();
	            sheet.range(sheet.select()).clear();
	        },

	        pasteRef: function() {
	            var sheet = this.workbook.activeSheet();

	            // When pasting from an external source, origin will be
	            // NULLREF.  Just return the destination range.
	            // https://github.com/telerik/kendo-ui-core/issues/3486
	            if (this.origin === kendo.spreadsheet.NULLREF) {
	                return sheet.select();
	            }

	            var destination = sheet.activeCell().first();
	            var originActiveCell = this.origin.first();
	            var rowDelta = originActiveCell.row - destination.row;
	            var colDelta = originActiveCell.col - destination.col;

	            return this.origin.relative(rowDelta, colDelta, 3);
	        },

	        paste: function() {
	            var sheet = this.workbook.activeSheet();
	            var pasteRef = this.pasteRef();
	            sheet.range(pasteRef).setState(this._content, this);
	            sheet.triggerChange({ recalc: true, ref: pasteRef });
	        },

	        external: function(data) {
	            if (data && (data.html || data.plain)) {
	                this._externalContent = data;
	            } else {
	                return this._externalContent;
	            }
	        },

	        isExternal: function() {
	            return !this._isInternal();
	        },

	        parse: function() {
	            var state = newState();

	            if (this._isInternal()) {
	                state = this._internalContent;
	            } else {
	                var data = this._externalContent;
	                if (data.html) {
	                    var doc = this.iframe.contentWindow.document;
	                    doc.open();
	                    doc.write(data.html);
	                    doc.close();
	                    var table = doc.querySelector("table");
	                    if (table) {
	                        state = parseHTML(table);
	                    } else {
	                        state = parseTSV(data.plain);
	                    }
	                } else {
	                    state = parseTSV(data.plain);
	                }
	                this.origin = state.origRef;
	            }

	            this._content = state;
	        },

	        _isInternal: function() {
	            if (this._externalContent.html === undefined) {
	                return true;
	            }
	            var internalHTML = $("<div/>").html(this._externalContent.html).find("table.kendo-clipboard-"+ this._uid).length ? true : false;
	            var internalPlain = $("<div/>").html(this._externalContent.plain).find("table.kendo-clipboard-"+ this._uid).length ? true : false;
	            return (internalHTML || internalPlain);
	        }
	    });
	    kendo.spreadsheet.Clipboard = Clipboard;

	    function newState() {
	        var ref = new CellRef(0, 0, 0);
	        return {
	            ref         : ref,
	            mergedCells : [],
	            data        : [],
	            foreign     : true,
	            origRef     : ref.toRangeRef()
	        };
	    }

	    function setStateData(state, row, col, value) {
	        var data = state.data || (state.data = []);
	        if (!data[row]) {
	            data[row] = [];
	        }
	        data[row][col] = value;
	        var br = state.origRef.bottomRight;
	        br.row = Math.max(br.row, row);
	        br.col = Math.max(br.col, col);
	    }

	    function stripStyle(style) {
	        return style.replace(/^-(?:ms|moz|webkit)-/, "");
	    }

	    function borderObject(styles) {
	        var obj = {};
	        [
	            "borderBottom",
	            "borderRight",
	            "borderLeft",
	            "borderTop"
	        ].forEach(function(key) {
	            obj[key] = styles[key + "Style"] == "none" ? null : {
	                size: 1,
	                color: styles[key + "Color"]
	            };
	        });
	        return obj;
	    }

	    function cellState(row, col, element, hBorders, vBorders) {
	        var styles = window.getComputedStyle(element);

	        // note: Chrome 70 appends a \t to a cell's text, which is actually mandated by the standard
	        // ([1] item 6).  We remove it below.  In [2] it's suggested they might switch back to
	        // previous behavior, but removing an eventual last TAB won't hurt anyway.
	        //
	        // [1] https://www.w3.org/TR/html53/dom.html#dom-htmlelement-innertext
	        // [2] https://bugs.chromium.org/p/chromium/issues/detail?id=897373
	        var text = element.innerText.replace(/\t$/, "");

	        var borders = borderObject(styles);
	        var state = {
	            value: text === "" ? null : text,

	            borderTop    : borders.borderTop    || hBorders.get(row, col)     || null,
	            borderBottom : borders.borderBottom || hBorders.get(row + 1, col) || null,
	            borderLeft   : borders.borderLeft   || vBorders.get(row, col)     || null,
	            borderRight  : borders.borderRight  || vBorders.get(row, col + 1) || null,

	            fontSize : parseInt(styles["font-size"], 10)
	        };

	        hBorders.set(row, col, state.borderTop);
	        hBorders.set(row + 1, col, state.borderBottom);
	        vBorders.set(row, col, state.borderLeft);
	        vBorders.set(row, col + 1, state.borderRight);

	        if (styles["background-color"] !== "rgb(0, 0, 0)" && styles["background-color"] !== "rgba(0, 0, 0, 0)") {
	            state.background = styles["background-color"];
	        }
	        if (styles.color !== "rgb(0, 0, 0)" && styles.color !== "rgba(0, 0, 0, 0)") {
	            state.color = styles.color;
	        }
	        if (styles["text-decoration"] == "underline") {
	            state.underline = true;
	        }
	        if (styles["font-style"] == "italic") {
	            state.italic = true;
	        }
	        if (styles["font-weight"] == "bold") {
	            state.bold = true;
	        }
	        if (stripStyle(styles["text-align"]) !== "right") {
	            state.textAlign = stripStyle(styles["text-align"]);
	        }
	        if (styles["vertical-align"] !== "middle") {
	            state.verticalAlign = styles["vertical-align"];
	        }
	        if (styles["word-wrap"] !== "normal" ) {
	            state.wrap = true;
	        }

	        return state;
	    }

	    function parseHTML(table) {
	        var state = newState();

	        var done = [], row = 0, col = 0;
	        for (var i = 0; i < table.rows.length; ++i) {
	            done.push([]);
	        }
	        var hBorders = new kendo.spreadsheet.calc.runtime.Matrix();
	        var vBorders = new kendo.spreadsheet.calc.runtime.Matrix();

	        for (var ri = 0; ri < table.rows.length; ++ri, ++row) {
	            var tr = table.rows[ri];
	            col = 0;
	            for (var ci = 0; ci < tr.cells.length; ++ci) {
	                var td = tr.cells[ci];
	                var rowSpan = td.rowSpan;
	                var colSpan = td.colSpan;
	                while (done[row][col]) {
	                    col++;
	                }

	                // A cell containing a long text overflowing the next (empty) cell will weirdly be
	                // reported as merged by Excel (has colspan=2).  Then, Excel informatively suggests
	                // us to ignore the colSpan by passing mso-ignore:colspan in the style.  Much thanks!
	                // https://github.com/telerik/kendo-ui-core/issues/3760
	                var style = td.getAttribute("style");
	                var ignoreColspan = /mso-ignore:colspan/.test(style);

	                setStateData(state, row, col, cellState(row, col, td, hBorders, vBorders));
	                if (rowSpan > 1 || (colSpan > 1 && !ignoreColspan)) {
	                    state.mergedCells.push(
	                        new kendo.spreadsheet.RangeRef(
	                            new CellRef(row, col),
	                            new CellRef(row + rowSpan - 1, col + colSpan - 1)
	                        ).toString());
	                }
	                for (var dr = row + rowSpan; --dr >= row;) {
	                    for (var dc = col + colSpan; --dc >= col;) {
	                        if (dr < done.length) {
	                            done[dr][dc] = true;
	                            if (!(dr == row && dc == col)) {
	                                setStateData(state, dr, dc, {});
	                            }
	                        }
	                    }
	                }
	            }
	        }

	        return state;
	    }

	    function parseTSV(data) {
	        var state = newState();
	        if (data.indexOf("\t") === -1 && data.indexOf("\n") == -1) {
	            setStateData(state, 0, 0, { value: data });
	        } else {
	            var rows = data.split("\n");
	            for (var ri = 0; ri < rows.length; ri++) {
	                var cols = rows[ri].split("\t");
	                for (var ci = 0; ci < cols.length; ci++) {
	                    setStateData(state, ri, ci, { value: cols[ci] });
	                }
	            }
	        }
	        return state;
	    }

	})(kendo);
	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "YEid":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var DetailCellRenderer = (function (_super) {
    __extends(DetailCellRenderer, _super);
    function DetailCellRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DetailCellRenderer.prototype.init = function (params) {
        var _this = this;
        this.rowId = params.node.id;
        this.masterGridApi = params.api;
        this.selectAndSetTemplate(params);
        if (main_1._.exists(this.eDetailGrid)) {
            this.addThemeToDetailGrid();
            this.createDetailsGrid(params);
            this.registerDetailWithMaster(params.node);
            this.loadRowData(params);
            this.setupGrabMouseWheelEvent();
            setTimeout(function () { return _this.detailGridOptions.api.doLayout(); }, 0);
        }
        else {
            console.warn('ag-Grid: reference to eDetailGrid was missing from the details template. ' +
                'Please add ref="eDetailGrid" to the template.');
        }
    };
    DetailCellRenderer.prototype.addThemeToDetailGrid = function () {
        // this is needed by environment service of the child grid, the class needs to be on
        // the grid div itself - the browser's CSS on the other hand just inherits from the parent grid theme.
        var theme = this.environment.getTheme();
        if (main_1._.exists(theme)) {
            main_1._.addCssClass(this.eDetailGrid, theme);
        }
    };
    DetailCellRenderer.prototype.setupGrabMouseWheelEvent = function () {
        var mouseWheelListener = function (event) {
            event.stopPropagation();
        };
        // event is 'mousewheel' for IE9, Chrome, Safari, Opera
        this.eDetailGrid.addEventListener('mousewheel', mouseWheelListener);
        // event is 'DOMMouseScroll' Firefox
        this.eDetailGrid.addEventListener('DOMMouseScroll', mouseWheelListener);
    };
    DetailCellRenderer.prototype.registerDetailWithMaster = function (rowNode) {
        var _this = this;
        var gridInfo = {
            id: this.rowId,
            api: this.detailGridOptions.api,
            columnApi: this.detailGridOptions.columnApi
        };
        // register with api
        this.masterGridApi.addDetailGridInfo(this.rowId, gridInfo);
        // register with node
        rowNode.detailGridInfo = gridInfo;
        this.addDestroyFunc(function () {
            _this.masterGridApi.removeDetailGridInfo(_this.rowId); // unregister from api
            rowNode.detailGridInfo = null; // unregister from node
        });
    };
    DetailCellRenderer.prototype.selectAndSetTemplate = function (params) {
        var paramsAny = params;
        if (main_1._.missing(paramsAny.template)) {
            // use default template
            this.setTemplate(DetailCellRenderer.TEMPLATE);
        }
        else {
            // use user provided template
            if (typeof paramsAny.template === 'string') {
                this.setTemplate(paramsAny.template);
            }
            else if (typeof paramsAny.template === 'function') {
                var templateFunc = paramsAny.template;
                var template = templateFunc(params);
                this.setTemplate(template);
            }
            else {
                console.warn('ag-Grid: detailCellRendererParams.template should be function or string');
                this.setTemplate(DetailCellRenderer.TEMPLATE);
            }
        }
    };
    DetailCellRenderer.prototype.createDetailsGrid = function (params) {
        // we clone the detail grid options, as otherwise it would be shared
        // across many instances, and that would be a problem because we set
        // api and columnApi into gridOptions
        var _this = this;
        var gridOptions = params.detailGridOptions;
        if (main_1._.missing(gridOptions)) {
            console.warn('ag-Grid: could not find detail grid options for master detail, ' +
                'please set gridOptions.detailCellRendererParams.detailGridOptions');
        }
        // IMPORTANT - gridOptions must be cloned
        this.detailGridOptions = main_1._.cloneObject(gridOptions);
        //Passing a dummy agGridReact bean in case this is for a REACT grid
        new main_1.Grid(this.eDetailGrid, this.detailGridOptions, {
            seedBeanInstances: {
                agGridReact: {}
            }
        });
        this.addDestroyFunc(function () { return _this.detailGridOptions.api.destroy(); });
    };
    DetailCellRenderer.prototype.loadRowData = function (params) {
        var userFunc = params.getDetailRowData;
        if (!userFunc) {
            console.warn('ag-Grid: could not find getDetailRowData for master / detail, ' +
                'please set gridOptions.detailCellRendererParams.getDetailRowData');
            return;
        }
        var funcParams = {
            node: params.node,
            data: params.data,
            successCallback: this.setRowData.bind(this)
        };
        userFunc(funcParams);
    };
    DetailCellRenderer.prototype.setRowData = function (rowData) {
        this.detailGridOptions.api.setRowData(rowData);
    };
    DetailCellRenderer.TEMPLATE = "<div class=\"ag-details-row\">\n            <div ref=\"eDetailGrid\" class=\"ag-details-grid\"/>\n        </div>";
    __decorate([
        main_1.RefSelector('eDetailGrid'),
        __metadata("design:type", HTMLElement)
    ], DetailCellRenderer.prototype, "eDetailGrid", void 0);
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], DetailCellRenderer.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        main_1.Autowired('environment'),
        __metadata("design:type", main_1.Environment)
    ], DetailCellRenderer.prototype, "environment", void 0);
    return DetailCellRenderer;
}(main_1.Component));
exports.DetailCellRenderer = DetailCellRenderer;


/***/ }),

/***/ "YPT/":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1428);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1190:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("JKVm");

/***/ }),

/***/ 1428:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1109), __webpack_require__(1190)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "tilelayout",
	    name: "TileLayout",
	    category: "web",
	    depends: [ "core"]
	};

	(function($) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        Draggable = ui.Draggable,
	        selector = kendo.selectorFromClasses,
	        RESIZE = "resize",
	        REORDER = "reorder",
	        NS = ".kendoTileLayout",
	        DOWNCURSOR = "k-cursor-ns-resize",
	        RIGHTCURSOR = "k-cursor-ew-resize",
	        DIAGONALCURSOR = "k-cursor-nwse-resize",
	        RTLDIAGONALCURSOR = "k-cursor-nesw-resize",
	        GRABCURSOR = "k-cursor-grab",
	        GRABBINGCURSOR = "k-cursor-grabbing",
	        MINIMALSPAN = 1,
	        CURSORCLASSES = "k-cursor-nesw-resize k-cursor-nwse-resize k-cursor-ew-resize k-cursor-ns-resize";

	    var tileLayoutStyles = {
	        wrapper: "k-widget k-tilelayout",
	        item: "k-tilelayout-item k-card",
	        itemHeader: "k-tilelayout-item-header k-card-header",
	        itemHeaderTitle: "k-card-title",
	        itemBody: "k-tilelayout-item-body k-card-body",
	        reorderHint: "k-layout-item-hint k-layout-item-hint-reorder",
	        resizeHint: "k-layout-item-hint k-layout-item-hint-resize"
	    };

	    var TileLayout = Widget.extend( {
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            $.cssNumber.gridColumnStart = true;
	            $.cssNumber.gridColumnEnd = true;
	            $.cssNumber.gridRowStart = true;
	            $.cssNumber.gridRowEnd = true;

	            that.element = $(element).addClass(TileLayout.styles.wrapper);

	            that._setWrapperStyles();
	            that._initContainers();
	            that._resizable();
	            that._reorderable();
	        },

	        events: [
	            RESIZE,
	            REORDER
	        ],

	        options: {
	            name: "TileLayout",
	            columns: null,
	            gap : {
	                columns: 16,
	                rows: 16
	            },
	            containers: [],
	            resizable: false,
	            reorderable: false,
	            columnsWidth: "1fr",
	            rowsHeight: "1fr",
	            height: "",
	            width: ""
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            if (this._draggableInstance) {

	                this.element.find(".k-tilelayout-item").each(function() {
	                    var item = $(this);
	                    if (item.data("kendoDropTarget")) {
	                        item.data("kendoDropTarget").destroy();
	                    }
	                });

	                this._draggableInstance.destroy();
	                this._draggableInstance.element = this._draggableInstance.draggable = null;
	            }

	            if (this.resizable) {
	                this.resizable.destroy();
	                this.resizable = null;
	            }

	            if (this.resizeHandle) {
	                this.resizeHandle.off(NS).remove();
	                this.resizeHandle = null;
	            }

	            this.element.off(NS);
	        },

	        setOptions: function(options) {
	            this.destroy();
	            kendo.deepExtend(this.options, options);
	            this.element.empty();
	            this.init(this.element, this.options);
	        },

	        getOptions: function() {
	            var result = $.extend(true, {}, this.options);
	            result.containers = kendo.deepExtend([], this.items);

	            return result;
	        },

	        _initContainers: function() {
	            var that = this;
	            var containers = that.options.containers;
	            var containerElements = that.element.children();
	            var hasElements = !!containerElements.length;
	            var id;
	            var container;
	            var header;
	            var headerSettings;
	            var body;
	            var containerSettings;
	            var headerContent;

	            that.items = [];
	            that.itemsMap = {};

	            if (hasElements) {
	                containerElements.each(function(i ,element) {
	                    id = kendo.guid();
	                    var current = $(element)
	                                    .addClass(TileLayout.styles.item)
	                                    .attr("id", id);

	                    that._addContainer(current, containers[i], i, id);
	                });
	            } else {
	                for (var i = 0; i < containers.length; i++) {
	                    id = kendo.guid();
	                    containerSettings = containers[i];
	                    container = $("<div></div>")
	                                        .addClass(TileLayout.styles.item)
	                                        .attr("id", id);

	                    headerSettings = containerSettings.header;
	                    if (headerSettings && (headerSettings.template || headerSettings.text)) {
	                        header = $("<div></div>").addClass(TileLayout.styles.itemHeader);
	                        if (that.options.reorderable) {
	                            header.addClass(GRABCURSOR);
	                        }
	                        if (headerSettings.text) {
	                            headerContent = "<h5 class='" + TileLayout.styles.itemHeaderTitle + "'>" + headerSettings.text + "</h5>";
	                        }
	                        header.append(headerContent || kendo.template(headerSettings.template)({}));
	                        header.appendTo(container);
	                    }
	                    body = $("<div></div>").addClass(TileLayout.styles.itemBody);
	                    if (!containerSettings.bodyTemplate) {
	                        throw new Error("Having a bodyTemplate for the container is mandatory");
	                    }
	                    body.append(kendo.template(containerSettings.bodyTemplate)({}));
	                    body.appendTo(container);
	                    container.appendTo(that.element);

	                    that._addContainer(container, containerSettings, i, id);
	                }
	            }
	        },

	        _addContainer: function (element, item, index, id) {
	            var that = this;
	            item.order = typeof item.order == 'number' ? item.order : index;
	            element.attr(kendo.attr("index"), item.order);
	            item.id = id;
	            that._setContainerCoordinates(element, item);
	            that.itemsMap[id] = item;
	            that.items.push(that.itemsMap[id]);
	        },

	        _setWrapperStyles: function () {
	            var that = this;
	            var options = that.options;
	            that.element.css({
	                "grid-template-columns": kendo.format("repeat({0}, minmax(0, {1}))", options.columns, typeof options.columnsWidth === "string" ? options.columnsWidth : options.columnsWidth + "px"),
	                "grid-auto-rows":  kendo.format("minmax(0, {0})", typeof options.rowsHeight === "string" ? options.rowsHeight : options.rowsHeight + "px"),
	                "column-gap": options.gap.columns,
	                "width": typeof options.width === "string" ? options.width : options.width + "px",
	                "height": typeof options.height === "string" ? options.height : options.height + "px",
	                "padding": options.gap.rows + "px " +options.gap.columns + "px ",
	                "row-gap": options.gap.rows
	            });
	        },

	        _setContainerCoordinates: function (element, settings) {
	            if (!settings) {
	                return;
	            }
	            element.css({
	                "order": settings.order,
					"grid-column-end": kendo.format("span {0}",settings.colSpan),
					"grid-row-end": kendo.format("span {0}",settings.rowSpan)
	            })
	            .attr(kendo.attr("index"), settings.order);
	        },

	        _updateContainers: function () {
	            var that = this;

	            for (var i = 0; i < that.items.length; i++) {
	                that._setContainerCoordinates(that.element.find("#" + that.items[i].id) , that.items[i]);
	            }
	        },

	        _createResizeHandle: function(container, side, down) {
	            var that = this;

	            if (that._isresizing) {
	                return;
	            }

	            if (that.resizeHandle &&  that.resizeHandle.data("div")[0] !== container[0]) {
	                that.resizeHandle.off(NS).remove();
	                that.resizeHandle = null;
	            }

	            if (!that.resizeHandle) {
	                that.resizeHandle = $(
	                    '<div class="k-resize-handle"></div>'
	                );
	                that.resizeHandle.appendTo(container);
	            }

	            that._positionResizeHandle(container, side, down);
	        },

	        _positionResizeHandle: function(container, side, down) {
	            var that = this;
	            var leftBorderWidth = parseFloat(container.css("borderRightWidth"));
	            var bottomBorderWidth = parseFloat(container.css("borderBottomWidth"));
	            var containerHeight = container.height();
	            var containerWidth = container.width();
	            var top = down ? containerHeight -6.5 -bottomBorderWidth : 0;
	            var left = side ? containerWidth -4.5 -leftBorderWidth: 0;
	            var width = 9;
	            var height = 9;
	            var cursorClass;

	            if (side && down) {
	                height = width = 25;
	                top-=12.5;
	                left-=12.5;
	                cursorClass = kendo.support.isRtl(that.element) ? RTLDIAGONALCURSOR : DIAGONALCURSOR;
	            } else if (side && !down) {
	                height = containerHeight;
	                cursorClass = RIGHTCURSOR;
	            } else if(!side && down) {
	                width = containerWidth;
	                cursorClass = DOWNCURSOR;
	            }

	            that.resizeHandle
	                .css({
	                    top: top,
	                    left: left,
	                    height: height,
	                    width: width
	                })
	                .attr("side", side)
	                .attr("down", down)
	                .removeClass(CURSORCLASSES)
	                .addClass(cursorClass)
	                .data("div", container)
	                .show();
	        },

	        _createResizeHint: function (container) {
	            var that = this;

	            if (that.hint) {
	                return;
	            }

	            var colSpan = container.css("grid-column-end");
	            var rowSpan = container.css("grid-row-end");
	            var order = container.css("order");

	            that.hint = $("<div class='" + TileLayout.styles.resizeHint + "'></div>")
	            .css({
	                "order": order,
				    "grid-column-end": colSpan,
	                "grid-row-end": rowSpan
	            })
	            .insertAfter(container);
	        },

	        _removeResizeHint: function () {
	            if (this._isresizing) {
	                return;
	            }

	            if (this.hint) {
	                this.hint.remove();
	                this.hint = null;
	            }
	        },

	        _positionHint: function (colSpan, rowSpan) {
	            var that = this;

	            if (colSpan) {
	                that.hint.css("grid-column-end", kendo.format("span {0}", colSpan));
	            }

	            if (rowSpan) {
	                that.hint.css("grid-row-end", kendo.format("span {0}", rowSpan));
	            }
	        },

	        _removeAbsoluteStyles: function (container) {
	            container.css("position", "");
	            container.css("left", "");
	            container.css("top", "");
	            container.css("width", "");
	            container.css("height", "");
	            container.css("z-index", "");
	        },

	        _positionAbsolutely: function (container) {
	            if (container.css("position") ==  "absolute") {
	                return;
	            }
	            var position = container.position();
	            var width = container.outerWidth();
	            var height = container.outerHeight();

	            container.css("position", "absolute");
	            container.css("left", position.left);
	            container.css("top", position.top);
	            container.css("width", width);
	            container.css("height", height);
	            container.css("z-index", 2);
	        },

	        _resizable: function () {
	            var that = this;
	            var side;
	            var down;
	            var id;
	            var fractionWidth;
	            var fractionHeight;
	            var currentContainer;
	            var lastXLocation = 0;
	            var lastYLocation = 0;
	            var initialWidth = 0;
	            var initialHeight = 0;
	            var startColSpan = 0;
	            var startRowSpan = 0;
	            var itemsMaxSpace = 0;
	            var rowsCount;

	            if (that.options.resizable) {
	                that.element.on("mousemove" + NS, selector(TileLayout.styles.item), function (e) {
	                    var rightPosition;
	                    var downPosition;
	                    var container = $(this);
	                    var rectPosition = container[0].getBoundingClientRect();

	                    rightPosition = Math.abs(rectPosition.right - e.clientX) < 16;
	                    downPosition = Math.abs(rectPosition.bottom - e.clientY) < 16;

	                    if (rightPosition && downPosition) {
	                        that._createResizeHandle(container, true, true);
	                    } else if (rightPosition) {
	                        that._createResizeHandle(container, true, false);
	                    } else  if (downPosition) {
	                        that._createResizeHandle(container, false, true);
	                    }
	                });

	                that.resizable = new ui.Resizable(that.element, {
	                    handle: "div.k-tilelayout-item > .k-resize-handle",
	                    start: function(e) {
	                        var resizeHandle = $(e.currentTarget);
	                        currentContainer = resizeHandle.data("div");
	                        id = currentContainer.attr("id");
	                        side = resizeHandle.attr("side");
	                        down = resizeHandle.attr("down");
	                        rowsCount = that.element.css("grid-template-rows").split(" ").length;

	                        if (side) {
	                            fractionWidth = that._calculateFractionWidth();
	                            itemsMaxSpace = that._calculateRightEndSide(fractionWidth);
	                            lastXLocation = e.x.location;
	                            initialWidth = currentContainer.width();
	                            startColSpan = parseInt(currentContainer.css("grid-column-end").replace('span',''), 10);
	                        }

	                        if (down) {
	                            fractionHeight = (that.element[0].scrollHeight - (rowsCount + 1)*that.options.gap.rows)/rowsCount;
	                            lastYLocation = e.y.location;
	                            initialHeight = currentContainer.height();
	                            startRowSpan = parseInt(currentContainer.css("grid-row-end").replace('span',''), 10);
	                        }

	                        that._isresizing = true;
	                    },
	                    resize: function(e) {
	                        var hintColumns = 0;
	                        var hintRows = 0;
	                        var mouseDeltaX = 0;
	                        var mouseDeltaY = 0;
	                        var overflowsLayout;
	                        var isBeyondMinimum;
	                        var deltaFromStart = 0;
	                        var resizeRowsCount = 0;
	                        var resizeColumnsCount = 0;
	                        var clientRect = that.element[0].getBoundingClientRect();

	                        that._positionAbsolutely(currentContainer);
	                        that._createResizeHint(currentContainer);

	                        if (side == "true") {
	                            mouseDeltaX = e.x.location - lastXLocation;
	                            overflowsLayout = (clientRect.left + itemsMaxSpace - window.scrollX - e.x.location) < that.options.gap.columns;
	                            isBeyondMinimum = (initialWidth + mouseDeltaX) < fractionWidth;

	                            if (!overflowsLayout && !isBeyondMinimum) {
	                                resizeColumnsCount = (mouseDeltaX)/(fractionWidth + that.options.gap.columns);
	                                deltaFromStart = mouseDeltaX -(Math.floor(resizeColumnsCount)*(fractionWidth + that.options.gap.columns));
	                                hintColumns = startColSpan + Math.floor(resizeColumnsCount) + ((deltaFromStart >= (fractionWidth/2))? 1: 0);
	                                that.itemsMap[id].colSpan = Math.max(hintColumns, MINIMALSPAN);
	                            } else {
	                                mouseDeltaX = 0;
	                            }
	                        }

	                        if (down == "true") {
	                            mouseDeltaY = e.y.location - lastYLocation;
	                            overflowsLayout = (clientRect.bottom + window.scrollY - e.y.location) < that.options.gap.rows;
	                            isBeyondMinimum = (initialHeight + mouseDeltaY) <= fractionHeight;

	                            if (!overflowsLayout && !isBeyondMinimum) {
	                                resizeRowsCount = (mouseDeltaY)/(fractionHeight + that.options.gap.rows);
	                                deltaFromStart = mouseDeltaY - (Math.floor(resizeRowsCount)*(fractionHeight + that.options.gap.rows));
	                                hintRows = startRowSpan + Math.floor(resizeRowsCount) + ((deltaFromStart >= (fractionHeight/2))? 1: 0);
	                                that.itemsMap[id].rowSpan = Math.max(hintRows, MINIMALSPAN);
	                            } else {
	                                mouseDeltaY = 0;
	                            }
	                        }

	                        that._positionHint(hintColumns, hintRows);
	                        that._positionResizeHandle(currentContainer, side == "true", down == "true");
	                        if (mouseDeltaY) {
	                            currentContainer.css("height", initialHeight + mouseDeltaY);
	                        }
	                        if (mouseDeltaX) {
	                            currentContainer.css("width", initialWidth + mouseDeltaX);
	                        }
	                    },
	                    resizeend: function() {
	                        that._isresizing = false;
	                        that._setContainerCoordinates(currentContainer, that.itemsMap[id]);
	                        that._removeAbsoluteStyles(currentContainer);
	                        that._removeResizeHint();
	                        that.trigger(RESIZE, {
	                            container: currentContainer
	                        });
	                    }
	                });
	            }
	        },

	        _calculateFractionWidth: function () {
	            var that = this;
	            var container = that.element.children().first();
	            var colSpan = that.itemsMap[container.attr("id")].colSpan;
	            var totalWidth = container.outerWidth();

	            return (totalWidth - (colSpan -1)*(that.options.gap.columns))/colSpan;
	        },

	        _calculateRightEndSide: function (fractionWidth) {
	            var that = this;
	            var columns = that.options.columns;
	            var columnGap = that.options.gap.columns;

	            return columns*(fractionWidth + columnGap) + columnGap;
	        },
	        
	        _createDropHint: function (settings) {
	            this.dropHint = $("<div class='" + TileLayout.styles.reorderHint + "'></div>")
	                .css({
	                    "order": settings.order,
	                    "grid-column-end": settings.columnEnd,
	                    "grid-row-end": settings.rowEnd
	                })
	                .attr(kendo.attr("index"), settings.order)
	                .attr("direction", settings.direction);
	        },

	        _insertDropHint: function (container, direction) {
	            if (direction == "right") {
	                this.dropHint.insertAfter(container);
	            } else {
	                this.dropHint.insertBefore(container);
	            }
	        },

	        _removeDropHint: function () {
	            if (this.dropHint) {
	                this.dropHint.remove();
	                this.dropHint = null;
	            }
	        },

	        _reorderable: function () {
	            if (!this.options.reorderable) {
	                return;
	            }

	            var that = this;
	            var element = that.element;
	            var originalElement;
	            var itemSelector = selector(TileLayout.styles.item);
	            var headerSelector = selector(TileLayout.styles.itemHeader);
	            var group = kendo.guid();

	            this._draggableInstance = new Draggable(this.element, {
	                filter: headerSelector,
	                autoScroll: true,
	                group: group,
	                hint: function(target) {
	                    var item = target.closest(itemSelector);
	                    var width = item.width();
	                    var height= item.height();
	                    var clone = item.clone();
	                    clone.find(headerSelector)
	                        .removeClass(GRABCURSOR)
	                        .addClass(GRABBINGCURSOR);
	                    return clone.width(width).height(height);
	                },
	                dragstart: function (e) {
	                    originalElement = $(e.currentTarget).closest(itemSelector);
	                },
	                drag: function (e) {
	                    var elementUnderCursor = kendo.elementUnderCursor(e);
	                    var hint = e.sender.hint;
	                    var dropContainer;
	                    var containerBoundaries;
	                    var pixelsToLeftBorder;
	                    var pixelsToRightBorder;
	                    var direction;
	                    
	                    var draggedItem = that._draggableInstance.currentTarget.closest(itemSelector);
	                    var newOrder;

	                    if (containsOrEqualTo(hint[0], elementUnderCursor)) {
	                        hint.hide();

	                        elementUnderCursor = kendo.elementUnderCursor(e);

	                        if (!containsOrEqualTo(originalElement[0], elementUnderCursor)) {

	                            if (that.dropHint && that.dropHint[0] == elementUnderCursor[0]) {
	                                hint.show();
	                                return;
	                            }

	                            dropContainer = $(elementUnderCursor);
	                            dropContainer = dropContainer.hasClass(TileLayout.styles.item) ? dropContainer : dropContainer.closest(itemSelector);

	                            if (dropContainer.hasClass(TileLayout.styles.item)) {
	                                containerBoundaries = dropContainer[0].getBoundingClientRect();
	                                pixelsToLeftBorder = e.clientX - containerBoundaries.left;
	                                pixelsToRightBorder = containerBoundaries.right - e.clientX;
	                                direction = pixelsToLeftBorder > pixelsToRightBorder ? "right" : "left";
	                                newOrder = dropContainer.css("order");

	                                if (that.dropHint && that.dropHint.attr("direction") !== direction) {
	                                    var clone = that.dropHint.clone();
	                                    clone.css("order", newOrder);
	                                    that.dropHint.remove();
	                                    that.dropHint = clone;

	                                    that._insertDropHint(dropContainer ,direction);

	                                    that.dropHint
	                                        .attr("direction", direction)
	                                        .attr(kendo.attr("index"), newOrder);
	                                } else if (!that.dropHint) {

	                                    var futureContainer = direction == "right" ? dropContainer.next() : dropContainer.prev();

	                                    if (futureContainer[0] != originalElement[0]) {
	                                        that._createDropHint({ order: newOrder, columnEnd: draggedItem.css("grid-column-end"), rowEnd: draggedItem.css("grid-row-end"), direction: direction });
	                                        originalElement.hide();
	                                        that._insertDropHint(dropContainer ,direction);
	                                    }
	                                }
	                            }
	                        }
	                        hint.show();
	                    }
	                },
	                dragend: function (e) {
	                    if (!that.dropHint) {
	                        e.sender.hint.remove();
	                        that._removeDropHint();
	                        return;
	                    }
	                    var newOrder = parseInt(that.dropHint.css("order"), 10);
	                    var container = e.currentTarget.closest(itemSelector);
	                    var items = that.element.find(itemSelector);
	                    var oldOrder = parseInt(container.css("order"), 10);
	                    var itemId = container.attr("id");
	                    var containers = that.element.children(":visible");
	                    var indexAttr = kendo.attr("index");
	                    var start;
	                    var end;
	                    var item;
	                    var direction;
	                    
	                    containers.sort(function(a, b) {
	                        a = $(a);
	                        b = $(b);
	                    
	                        var indexA = a.attr(indexAttr);
	                        var indexB = b.attr(indexAttr);
	                    
	                        if (indexA === undefined) {
	                            indexA = $(a).index();
	                        }
	                        if (indexB === undefined) {
	                            indexB = $(b).index();
	                        }
	                    
	                        indexA = parseInt(indexA, 10);
	                        indexB = parseInt(indexB, 10);
	                        return indexA > indexB ? 1 : (indexA < indexB ? -1 : 0);
	                    });

	                    newOrder = containers.index(that.dropHint[0]);
	                    end = Math.max(newOrder, oldOrder);
	                    start = Math.min(newOrder, oldOrder);

	                    that.itemsMap[itemId].order = newOrder;

	                    direction = newOrder > oldOrder ? "right" : "left"; //this is direction of movement

	                    if (direction == "left") {
	                        end--;
	                    } else {
	                        start++;
	                    }

	                    for (var i = start; i <= end ; i++) {
	                        item = items.filter("["+kendo.attr("index") + "='" +i + "']");
	                        that.itemsMap[item.attr("id")].order += direction == "left" ? 1 : -1;
	                    }

	                    container.show();

	                    that._updateContainers();

	                    e.sender.hint.remove();
	                    that._removeDropHint();
	                    that.trigger(REORDER, {
	                        newIndex: newOrder,
	                        oldIndex: oldOrder,
	                        container: container
	                    });
	                }
	            });

	            element.find(itemSelector).kendoDropTarget({
	                group: group,
	                dragenter: function(e) {
	                    if (that._isresizing) {
	                        return;
	                    }
	                    var dropContainer = $(e.dropTarget);
	                    var target = that._draggableInstance.currentTarget.closest(itemSelector);
	                    var dropContainerBoundaries;
	                    var pixelsToLeftBorder;
	                    var pixelsToRightBorder;
	                    var futureContainer;
	                    var direction;

	                    if (originalElement[0] != dropContainer[0]) {

	                        dropContainerBoundaries = dropContainer[0].getBoundingClientRect();
	                        pixelsToLeftBorder = e.clientX - dropContainerBoundaries.left;
	                        pixelsToRightBorder = dropContainerBoundaries.right - e.clientX;
	                        direction = pixelsToLeftBorder > pixelsToRightBorder ? "right" : "left";

	                        futureContainer = direction == "right" ? dropContainer.next() : dropContainer.prev();

	                        //handle the case when the container will be shown over the original one
	                        if (futureContainer[0] == originalElement[0]) {
	                            return;
	                        }

	                        that._removeDropHint();

	                        originalElement.hide();

	                        that._createDropHint({ order: dropContainer.css("order"), columnEnd: target.css("grid-column-end"), rowEnd: target.css("grid-row-end"), direction: direction});

	                        originalElement.hide();
	                        that._insertDropHint(dropContainer, direction);
	                    }
	                }
	            });
	        }
	    });

	    function containsOrEqualTo(parent, child) {
	        try {
	            return $.contains(parent, child) || parent == child;
	        } catch (e) {
	            return false;
	        }
	    }

	    ui.plugin(TileLayout);

	    $.extend(true, TileLayout, { styles: tileLayoutStyles });
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "YX13":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var column_1 = __webpack_require__("hDyE");
var eventService_1 = __webpack_require__("k5uU");
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var columnApi_1 = __webpack_require__("E/Wy");
var gridApi_1 = __webpack_require__("BAow");
var ColumnGroup = (function () {
    function ColumnGroup(originalColumnGroup, groupId, instanceId) {
        // depends on the open/closed state of the group, only displaying columns are stored here
        this.displayedChildren = [];
        this.localEventService = new eventService_1.EventService();
        this.groupId = groupId;
        this.instanceId = instanceId;
        this.originalColumnGroup = originalColumnGroup;
    }
    // this is static, a it is used outside of this class
    ColumnGroup.createUniqueId = function (groupId, instanceId) {
        return groupId + '_' + instanceId;
    };
    // as the user is adding and removing columns, the groups are recalculated.
    // this reset clears out all children, ready for children to be added again
    ColumnGroup.prototype.reset = function () {
        this.parent = null;
        this.children = null;
        this.displayedChildren = null;
    };
    ColumnGroup.prototype.getParent = function () {
        return this.parent;
    };
    ColumnGroup.prototype.setParent = function (parent) {
        this.parent = parent;
    };
    ColumnGroup.prototype.getUniqueId = function () {
        return ColumnGroup.createUniqueId(this.groupId, this.instanceId);
    };
    ColumnGroup.prototype.isEmptyGroup = function () {
        return this.displayedChildren.length === 0;
    };
    ColumnGroup.prototype.isMoving = function () {
        var allLeafColumns = this.getOriginalColumnGroup().getLeafColumns();
        if (!allLeafColumns || allLeafColumns.length === 0) {
            return false;
        }
        var allMoving = true;
        allLeafColumns.forEach(function (col) {
            if (!col.isMoving()) {
                allMoving = false;
            }
        });
        return allMoving;
    };
    ColumnGroup.prototype.checkLeft = function () {
        // first get all children to setLeft, as it impacts our decision below
        this.displayedChildren.forEach(function (child) {
            if (child instanceof ColumnGroup) {
                child.checkLeft();
            }
        });
        // set our left based on first displayed column
        if (this.displayedChildren.length > 0) {
            if (this.gridOptionsWrapper.isEnableRtl()) {
                var lastChild = this.displayedChildren[this.displayedChildren.length - 1];
                var lastChildLeft = lastChild.getLeft();
                this.setLeft(lastChildLeft);
            }
            else {
                var firstChildLeft = this.displayedChildren[0].getLeft();
                this.setLeft(firstChildLeft);
            }
        }
        else {
            // this should never happen, as if we have no displayed columns, then
            // this groups should not even exist.
            this.setLeft(null);
        }
    };
    ColumnGroup.prototype.getLeft = function () {
        return this.left;
    };
    ColumnGroup.prototype.getOldLeft = function () {
        return this.oldLeft;
    };
    ColumnGroup.prototype.setLeft = function (left) {
        this.oldLeft = left;
        if (this.left !== left) {
            this.left = left;
            this.localEventService.dispatchEvent(this.createAgEvent(ColumnGroup.EVENT_LEFT_CHANGED));
        }
    };
    ColumnGroup.prototype.createAgEvent = function (type) {
        return {
            type: type,
        };
    };
    ColumnGroup.prototype.addEventListener = function (eventType, listener) {
        this.localEventService.addEventListener(eventType, listener);
    };
    ColumnGroup.prototype.removeEventListener = function (eventType, listener) {
        this.localEventService.removeEventListener(eventType, listener);
    };
    ColumnGroup.prototype.getGroupId = function () {
        return this.groupId;
    };
    ColumnGroup.prototype.getInstanceId = function () {
        return this.instanceId;
    };
    ColumnGroup.prototype.isChildInThisGroupDeepSearch = function (wantedChild) {
        var result = false;
        this.children.forEach(function (foundChild) {
            if (wantedChild === foundChild) {
                result = true;
            }
            if (foundChild instanceof ColumnGroup) {
                if (foundChild.isChildInThisGroupDeepSearch(wantedChild)) {
                    result = true;
                }
            }
        });
        return result;
    };
    ColumnGroup.prototype.getActualWidth = function () {
        var groupActualWidth = 0;
        if (this.displayedChildren) {
            this.displayedChildren.forEach(function (child) {
                groupActualWidth += child.getActualWidth();
            });
        }
        return groupActualWidth;
    };
    ColumnGroup.prototype.isResizable = function () {
        if (!this.displayedChildren) {
            return false;
        }
        // if at least one child is resizable, then the group is resizable
        var result = false;
        this.displayedChildren.forEach(function (child) {
            if (child.isResizable()) {
                result = true;
            }
        });
        return result;
    };
    ColumnGroup.prototype.getMinWidth = function () {
        var result = 0;
        this.displayedChildren.forEach(function (groupChild) {
            result += groupChild.getMinWidth();
        });
        return result;
    };
    ColumnGroup.prototype.addChild = function (child) {
        if (!this.children) {
            this.children = [];
        }
        this.children.push(child);
    };
    ColumnGroup.prototype.getDisplayedChildren = function () {
        return this.displayedChildren;
    };
    ColumnGroup.prototype.getLeafColumns = function () {
        var result = [];
        this.addLeafColumns(result);
        return result;
    };
    ColumnGroup.prototype.getDisplayedLeafColumns = function () {
        var result = [];
        this.addDisplayedLeafColumns(result);
        return result;
    };
    // why two methods here doing the same thing?
    ColumnGroup.prototype.getDefinition = function () {
        return this.originalColumnGroup.getColGroupDef();
    };
    ColumnGroup.prototype.getColGroupDef = function () {
        return this.originalColumnGroup.getColGroupDef();
    };
    ColumnGroup.prototype.isPadding = function () {
        return this.originalColumnGroup.isPadding();
    };
    ColumnGroup.prototype.isExpandable = function () {
        return this.originalColumnGroup.isExpandable();
    };
    ColumnGroup.prototype.isExpanded = function () {
        return this.originalColumnGroup.isExpanded();
    };
    ColumnGroup.prototype.setExpanded = function (expanded) {
        this.originalColumnGroup.setExpanded(expanded);
    };
    ColumnGroup.prototype.addDisplayedLeafColumns = function (leafColumns) {
        this.displayedChildren.forEach(function (child) {
            if (child instanceof column_1.Column) {
                leafColumns.push(child);
            }
            else if (child instanceof ColumnGroup) {
                child.addDisplayedLeafColumns(leafColumns);
            }
        });
    };
    ColumnGroup.prototype.addLeafColumns = function (leafColumns) {
        this.children.forEach(function (child) {
            if (child instanceof column_1.Column) {
                leafColumns.push(child);
            }
            else if (child instanceof ColumnGroup) {
                child.addLeafColumns(leafColumns);
            }
        });
    };
    ColumnGroup.prototype.getChildren = function () {
        return this.children;
    };
    ColumnGroup.prototype.getColumnGroupShow = function () {
        return this.originalColumnGroup.getColumnGroupShow();
    };
    ColumnGroup.prototype.getOriginalColumnGroup = function () {
        return this.originalColumnGroup;
    };
    ColumnGroup.prototype.calculateDisplayedColumns = function () {
        var _this = this;
        // clear out last time we calculated
        this.displayedChildren = [];
        // it not expandable, everything is visible
        if (!this.originalColumnGroup.isExpandable()) {
            this.displayedChildren = this.children;
        }
        else {
            // and calculate again
            this.children.forEach(function (abstractColumn) {
                var headerGroupShow = abstractColumn.getColumnGroupShow();
                switch (headerGroupShow) {
                    case ColumnGroup.HEADER_GROUP_SHOW_OPEN:
                        // when set to open, only show col if group is open
                        if (_this.originalColumnGroup.isExpanded()) {
                            _this.displayedChildren.push(abstractColumn);
                        }
                        break;
                    case ColumnGroup.HEADER_GROUP_SHOW_CLOSED:
                        // when set to open, only show col if group is open
                        if (!_this.originalColumnGroup.isExpanded()) {
                            _this.displayedChildren.push(abstractColumn);
                        }
                        break;
                    default:
                        // default is always show the column
                        _this.displayedChildren.push(abstractColumn);
                        break;
                }
            });
        }
        this.localEventService.dispatchEvent(this.createAgEvent(ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED));
    };
    ColumnGroup.HEADER_GROUP_SHOW_OPEN = 'open';
    ColumnGroup.HEADER_GROUP_SHOW_CLOSED = 'closed';
    ColumnGroup.EVENT_LEFT_CHANGED = 'leftChanged';
    ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED = 'displayedChildrenChanged';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], ColumnGroup.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], ColumnGroup.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], ColumnGroup.prototype, "gridApi", void 0);
    return ColumnGroup;
}());
exports.ColumnGroup = ColumnGroup;


/***/ }),

/***/ "YaQm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var columnApi_1 = __webpack_require__("E/Wy");
var columnController_1 = __webpack_require__("77lH");
var gridApi_1 = __webpack_require__("BAow");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var expressionService_1 = __webpack_require__("1aUC");
var rowRenderer_1 = __webpack_require__("3RUv");
var templateService_1 = __webpack_require__("0vz1");
var valueService_1 = __webpack_require__("5JVC");
var eventService_1 = __webpack_require__("k5uU");
var columnAnimationService_1 = __webpack_require__("vLqC");
var focusedCellController_1 = __webpack_require__("4Sr9");
var cellEditorFactory_1 = __webpack_require__("x4W5");
var cellRendererFactory_1 = __webpack_require__("9WGm");
var popupService_1 = __webpack_require__("LnC7");
var cellRendererService_1 = __webpack_require__("sr48");
var valueFormatterService_1 = __webpack_require__("vFc7");
var stylingService_1 = __webpack_require__("Ewux");
var columnHoverService_1 = __webpack_require__("WO3E");
var gridPanel_1 = __webpack_require__("inOk");
var paginationProxy_1 = __webpack_require__("wYvi");
var animationFrameService_1 = __webpack_require__("tvEw");
var componentResolver_1 = __webpack_require__("migL");
var dragAndDropService_1 = __webpack_require__("I/uN");
var sortController_1 = __webpack_require__("fxGZ");
var filterManager_1 = __webpack_require__("Up6z");
var Beans = (function () {
    function Beans() {
    }
    Beans.prototype.postConstruct = function () {
        this.forPrint = this.gridOptionsWrapper.isForPrint();
        this.doingMasterDetail = this.gridOptionsWrapper.isMasterDetail();
    };
    __decorate([
        context_1.Autowired('paginationProxy'),
        __metadata("design:type", paginationProxy_1.PaginationProxy)
    ], Beans.prototype, "paginationProxy", void 0);
    __decorate([
        context_1.Autowired('gridPanel'),
        __metadata("design:type", gridPanel_1.GridPanel)
    ], Beans.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], Beans.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], Beans.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], Beans.prototype, "gridApi", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], Beans.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('expressionService'),
        __metadata("design:type", expressionService_1.ExpressionService)
    ], Beans.prototype, "expressionService", void 0);
    __decorate([
        context_1.Autowired('rowRenderer'),
        __metadata("design:type", rowRenderer_1.RowRenderer)
    ], Beans.prototype, "rowRenderer", void 0);
    __decorate([
        context_1.Autowired('$compile'),
        __metadata("design:type", Object)
    ], Beans.prototype, "$compile", void 0);
    __decorate([
        context_1.Autowired('templateService'),
        __metadata("design:type", templateService_1.TemplateService)
    ], Beans.prototype, "templateService", void 0);
    __decorate([
        context_1.Autowired('valueService'),
        __metadata("design:type", valueService_1.ValueService)
    ], Beans.prototype, "valueService", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], Beans.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], Beans.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('columnAnimationService'),
        __metadata("design:type", columnAnimationService_1.ColumnAnimationService)
    ], Beans.prototype, "columnAnimationService", void 0);
    __decorate([
        context_1.Optional('rangeController'),
        __metadata("design:type", Object)
    ], Beans.prototype, "rangeController", void 0);
    __decorate([
        context_1.Autowired('focusedCellController'),
        __metadata("design:type", focusedCellController_1.FocusedCellController)
    ], Beans.prototype, "focusedCellController", void 0);
    __decorate([
        context_1.Optional('contextMenuFactory'),
        __metadata("design:type", Object)
    ], Beans.prototype, "contextMenuFactory", void 0);
    __decorate([
        context_1.Autowired('cellEditorFactory'),
        __metadata("design:type", cellEditorFactory_1.CellEditorFactory)
    ], Beans.prototype, "cellEditorFactory", void 0);
    __decorate([
        context_1.Autowired('cellRendererFactory'),
        __metadata("design:type", cellRendererFactory_1.CellRendererFactory)
    ], Beans.prototype, "cellRendererFactory", void 0);
    __decorate([
        context_1.Autowired('popupService'),
        __metadata("design:type", popupService_1.PopupService)
    ], Beans.prototype, "popupService", void 0);
    __decorate([
        context_1.Autowired('cellRendererService'),
        __metadata("design:type", cellRendererService_1.CellRendererService)
    ], Beans.prototype, "cellRendererService", void 0);
    __decorate([
        context_1.Autowired('valueFormatterService'),
        __metadata("design:type", valueFormatterService_1.ValueFormatterService)
    ], Beans.prototype, "valueFormatterService", void 0);
    __decorate([
        context_1.Autowired('stylingService'),
        __metadata("design:type", stylingService_1.StylingService)
    ], Beans.prototype, "stylingService", void 0);
    __decorate([
        context_1.Autowired('columnHoverService'),
        __metadata("design:type", columnHoverService_1.ColumnHoverService)
    ], Beans.prototype, "columnHoverService", void 0);
    __decorate([
        context_1.Autowired('enterprise'),
        __metadata("design:type", Boolean)
    ], Beans.prototype, "enterprise", void 0);
    __decorate([
        context_1.Autowired('componentResolver'),
        __metadata("design:type", componentResolver_1.ComponentResolver)
    ], Beans.prototype, "componentResolver", void 0);
    __decorate([
        context_1.Autowired('animationFrameService'),
        __metadata("design:type", animationFrameService_1.AnimationFrameService)
    ], Beans.prototype, "taskQueue", void 0);
    __decorate([
        context_1.Autowired('dragAndDropService'),
        __metadata("design:type", dragAndDropService_1.DragAndDropService)
    ], Beans.prototype, "dragAndDropService", void 0);
    __decorate([
        context_1.Autowired('sortController'),
        __metadata("design:type", sortController_1.SortController)
    ], Beans.prototype, "sortController", void 0);
    __decorate([
        context_1.Autowired('filterManager'),
        __metadata("design:type", filterManager_1.FilterManager)
    ], Beans.prototype, "filterManager", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Beans.prototype, "postConstruct", null);
    Beans = __decorate([
        context_1.Bean('beans')
    ], Beans);
    return Beans;
}());
exports.Beans = Beans;


/***/ }),

/***/ "Ygk/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var abstractColumnDropPanel_1 = __webpack_require__("HDwJ");
var RowGroupColumnsPanel = (function (_super) {
    __extends(RowGroupColumnsPanel, _super);
    function RowGroupColumnsPanel(horizontal) {
        return _super.call(this, horizontal, false, 'row-group') || this;
    }
    RowGroupColumnsPanel.prototype.passBeansUp = function () {
        _super.prototype.setBeans.call(this, {
            gridOptionsWrapper: this.gridOptionsWrapper,
            eventService: this.eventService,
            context: this.context,
            loggerFactory: this.loggerFactory,
            dragAndDropService: this.dragAndDropService
        });
        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
        var emptyMessage = localeTextFunc('rowGroupColumnsEmptyMessage', 'Drag here to set row groups');
        var title = localeTextFunc('groups', 'Row Groups');
        _super.prototype.init.call(this, {
            dragAndDropIcon: main_1.DragAndDropService.ICON_GROUP,
            icon: main_1.Utils.createIconNoSpan('rowGroupPanel', this.gridOptionsWrapper, null),
            emptyMessage: emptyMessage,
            title: title
        });
        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.refreshGui.bind(this));
    };
    RowGroupColumnsPanel.prototype.isColumnDroppable = function (column) {
        if (this.gridOptionsWrapper.isFunctionsReadOnly()) {
            return false;
        }
        // we never allow grouping of secondary columns
        if (!column.isPrimary()) {
            return false;
        }
        var columnGroupable = column.isAllowRowGroup();
        var columnNotAlreadyGrouped = !column.isRowGroupActive();
        return columnGroupable && columnNotAlreadyGrouped;
    };
    RowGroupColumnsPanel.prototype.updateColumns = function (columns) {
        if (this.gridOptionsWrapper.isFunctionsPassive()) {
            var event_1 = {
                type: main_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST,
                columns: columns,
                api: this.gridApi,
                columnApi: this.columnApi
            };
            this.eventService.dispatchEvent(event_1);
        }
        else {
            this.columnController.setRowGroupColumns(columns, "toolPanelUi");
        }
    };
    RowGroupColumnsPanel.prototype.getIconName = function () {
        return this.isPotentialDndColumns() ? main_1.DragAndDropService.ICON_GROUP : main_1.DragAndDropService.ICON_NOT_ALLOWED;
    };
    RowGroupColumnsPanel.prototype.getExistingColumns = function () {
        return this.columnController.getRowGroupColumns();
    };
    __decorate([
        main_1.Autowired('columnController'),
        __metadata("design:type", main_1.ColumnController)
    ], RowGroupColumnsPanel.prototype, "columnController", void 0);
    __decorate([
        main_1.Autowired('eventService'),
        __metadata("design:type", main_1.EventService)
    ], RowGroupColumnsPanel.prototype, "eventService", void 0);
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], RowGroupColumnsPanel.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        main_1.Autowired('context'),
        __metadata("design:type", main_1.Context)
    ], RowGroupColumnsPanel.prototype, "context", void 0);
    __decorate([
        main_1.Autowired('loggerFactory'),
        __metadata("design:type", main_1.LoggerFactory)
    ], RowGroupColumnsPanel.prototype, "loggerFactory", void 0);
    __decorate([
        main_1.Autowired('dragAndDropService'),
        __metadata("design:type", main_1.DragAndDropService)
    ], RowGroupColumnsPanel.prototype, "dragAndDropService", void 0);
    __decorate([
        main_1.Autowired('columnApi'),
        __metadata("design:type", main_1.ColumnApi)
    ], RowGroupColumnsPanel.prototype, "columnApi", void 0);
    __decorate([
        main_1.Autowired('gridApi'),
        __metadata("design:type", main_1.GridApi)
    ], RowGroupColumnsPanel.prototype, "gridApi", void 0);
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RowGroupColumnsPanel.prototype, "passBeansUp", null);
    return RowGroupColumnsPanel;
}(abstractColumnDropPanel_1.AbstractColumnDropPanel));
exports.RowGroupColumnsPanel = RowGroupColumnsPanel;


/***/ }),

/***/ "YiI9":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1288);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1288:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1289) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "maskedtextbox",
	    name: "MaskedTextBox",
	    category: "web",
	    description: "The MaskedTextBox widget allows to specify a mask type on an input field.",
	    depends: ["core", "floatinglabel"]
	};

	(function($, undefined) {
	    var global = window;
	    var min = global.Math.min;
	    var kendo = global.kendo;
	    var caret = kendo.caret;
	    var keys = kendo.keys;
	    var ui = kendo.ui;
	    var Widget = ui.Widget;
	    var NS = ".kendoMaskedTextBox";
	    var isPlainObject = $.isPlainObject;
	    var proxy = $.proxy;
	    var setTimeout = window.setTimeout;

	    var LABELCLASSES = "k-label k-input-label";
	    var STATEDISABLED = "k-state-disabled";
	    var STATEINVALID = "k-state-invalid";
	    var DISABLED = "disabled";
	    var READONLY = "readonly";
	    var CHANGE = "change";
	    var MOUSEUP = "mouseup";
	    var DROP = "drop";
	    var KEYDOWN = "keydown";
	    var PASTE = "paste";
	    var INPUT = "input";

	    function ns(name) { return name + NS; }

	    var INPUT_EVENT_NAME = ns(kendo.support.propertyChangeEvent ? "propertychange" : INPUT);

	    function stringDiffStart(str1, str2) {
	        var i = 0;
	        while (i < str2.length) {
	            if (str1[i] !== str2[i]) {
	                break;
	            }
	            i++;
	        }

	        return i;
	    }
	    var MaskedTextBox = Widget.extend({
	        init: function(element, options) {
	            var that = this;
	            var DOMElement;

	            Widget.fn.init.call(that, element, options);

	            that._rules = $.extend({}, that.rules, that.options.rules);

	            element = that.element;
	            DOMElement = element[0];

	            that._wrapper();
	            that._tokenize();
	            that._form();

	            that.element
	                .addClass("k-textbox")
	                .attr("autocomplete", "off")
	                .on("focus" + NS, function() {
	                    var value = DOMElement.value;

	                    if (!value) {
	                        DOMElement.value = that._old = that._emptyMask;
	                    } else {
	                        that._togglePrompt(true);
	                    }

	                    that._oldValue = value;

	                    that._timeoutId = setTimeout(function() {
	                        caret(element, 0, value ? that._maskLength : 0);
	                    });
	                })
	                .on("focusout" + NS, function() {
	                    var value = element.val();

	                    clearTimeout(that._timeoutId);
	                    DOMElement.value = that._old = "";

	                    if (value !== that._emptyMask) {
	                        DOMElement.value = that._old = value;
	                    }

	                    that._change();
	                    that._togglePrompt();
	                });

	            var disabled = element.is("[disabled]") || $(that.element).parents("fieldset").is(':disabled');

	            if (disabled) {
	                that.enable(false);
	            } else {
	                that.readonly(element.is("[readonly]"));
	            }

	            that.value(that.options.value || element.val());

	            that._validationIcon = $("<span class='k-icon k-i-warning'></span>")
	                .insertAfter(element);
	            that._label();

	            kendo.notify(that);
	        },

	        options: {
	            name: "MaskedTextBox",
	            clearPromptChar: false,
	            unmaskOnPost: false,
	            promptChar: "_",
	            culture: "",
	            rules: {},
	            value: "",
	            mask: "",
	            label: null
	        },

	        events: [
	            CHANGE
	        ],

	        rules: {
	            "0": /\d/,
	            "9": /\d|\s/,
	            "#": /\d|\s|\+|\-/,
	            "L": /[a-zA-Z]/,
	            "?": /[a-zA-Z]|\s/,
	            "&": /\S/,
	            "C": /./,
	            "A": /[a-zA-Z0-9]/,
	            "a": /[a-zA-Z0-9]|\s/
	        },

	        setOptions: function(options) {
	            var that = this;

	            Widget.fn.setOptions.call(that, options);

	            that._rules = $.extend({}, that.rules, that.options.rules);

	            that._tokenize();

	            this._unbindInput();
	            this._bindInput();

	            that.value(that.element.val());
	        },

	        destroy: function() {
	            var that = this;

	            if (that.floatingLabel) {
	                that.floatingLabel.destroy();
	            }

	            that.element.off(NS);

	            if (that._formElement) {
	                that._formElement.off("reset", that._resetHandler);
	                that._formElement.off("submit", that._submitHandler);
	            }

	            Widget.fn.destroy.call(that);
	        },

	        raw: function() {
	            var unmasked = this._unmask(this.element.val(), 0);
	            return unmasked.replace(new RegExp(escapeRegExp(this.options.promptChar), "g"), "");
	        },

	        value: function(value) {
	            var element = this.element;
	            var emptyMask = this._emptyMask;

	            if (value === undefined) {
	                return this.element.val();
	            }

	            if (value === null) {
	                value = "";
	            }

	            if (!emptyMask) {
	                this._oldValue = value;
	                element.val(value);
	                return;
	            }

	            value = this._unmask(value + "");

	            element.val(value ? emptyMask : "");

	            this._mask(0, this._maskLength, value);
	            this._unmaskedValue = null;

	            value = element.val();
	            this._oldValue = value;

	            if (kendo._activeElement() !== element) {
	                if (value === emptyMask) {
	                    element.val("");
	                } else {
	                    this._togglePrompt();
	                }
	            }
	        },

	        _togglePrompt: function(show) {
	            var DOMElement = this.element[0];
	            var value = DOMElement.value;

	            if (this.options.clearPromptChar) {
	                if (!show) {
	                    value = value.replace(new RegExp(escapeRegExp(this.options.promptChar), "g"), " ");
	                } else {
	                    value = this._oldValue;
	                }

	                DOMElement.value = this._old = value;
	            }
	        },

	        readonly: function(readonly) {
	            var that = this;

	            this._editable({
	                readonly: readonly === undefined ? true : readonly,
	                disable: false
	            });

	            if (that.floatingLabel) {
	                that.floatingLabel.readonly(readonly === undefined ? true : readonly);
	            }
	        },

	        enable: function(enable) {
	            var that = this;

	            this._editable({
	                readonly: false,
	                disable: !(enable = enable === undefined ? true : enable)
	            });

	            if (that.floatingLabel) {
	                that.floatingLabel.enable(enable = enable === undefined ? true : enable);
	            }
	        },

	        _bindInput: function() {
	            var that = this;

	            if (that._maskLength) {
	                if(that.options.$angular) {//detach "input" event in angular scenario to keep the ng-model consistent and updated only when the change event of the textbox is raised.
	                    that.element.off(INPUT);
	                }
	                that.element
	                    .on(ns(KEYDOWN), proxy(that._keydown, that))
	                    .on(ns(DROP), proxy(that._drop, that))
	                    .on(ns(CHANGE), proxy(that._trackChange, that))
	                    .on(INPUT_EVENT_NAME, proxy(that._inputHandler, that));


	                if (kendo.support.browser.msie) {
	                    var version = kendo.support.browser.version;
	                    if (version > 8 && version < 11) {
	                        var events = [ns(MOUSEUP), ns(DROP), ns(KEYDOWN), ns(PASTE)].join(" ");
	                        that.element.on(events, proxy(that._legacyIEInputHandler, that));
	                    }
	                }
	            }
	        },

	        _unbindInput: function() {
	            var events = [INPUT_EVENT_NAME, ns(KEYDOWN), ns(MOUSEUP), ns(DROP), ns(PASTE)].join(" ");

	            this.element.off(events);
	        },

	        _editable: function(options) {
	            var that = this;
	            var element = that.element;
	            var wrapper = that.wrapper;
	            var disable = options.disable;
	            var readonly = options.readonly;

	            that._unbindInput();

	            if (!readonly && !disable) {
	                element.removeAttr(DISABLED)
	                       .removeAttr(READONLY);

	                wrapper.removeClass(STATEDISABLED);

	                that._bindInput();
	            } else {
	                element.attr(DISABLED, disable)
	                       .attr(READONLY, readonly);

	                wrapper.toggleClass(STATEDISABLED, disable);
	            }
	        },

	        _change: function() {
	            var that = this;
	            var value = that.value();

	            if (value !== that._oldValue) {
	                that._oldValue = value;

	                that.trigger(CHANGE);
	                that.element.trigger(CHANGE);
	            }
	            else if (value === "" && that.__changing) {//ensure change is raised when empty value (mask is stripped from input content) for consistent ngjs model update
	                that.element.trigger(CHANGE);
	            }
	        },

	        inputChange: function(backward) {
	            var that = this;
	            var old = that._old;
	            var element = that.element[0];
	            var value = element.value;
	            var selection = caret(element);
	            var cursor = selection[1];
	            var lengthDiff = value.length - old.length;
	            var mobile = kendo.support.mobileOS;

	            if (that.__dropping && lengthDiff < 0) {//dropping in same input on WebKit is raised once for the removal phase and once for the adding phase
	                return;
	            }

	            if (lengthDiff === -1 && mobile.android && mobile.browser === "chrome") {
	                backward = true;
	            }

	            var contentStart = min(cursor, stringDiffStart(value, old));
	            var content = value.substring(contentStart, cursor);

	            element.value = value.substring(0, contentStart) + that._emptyMask.substring(contentStart);

	            var caretPos = that._mask(contentStart, cursor, content);
	            var endContent = that._trimStartPromptChars(value.substring(cursor), min(lengthDiff, caretPos - contentStart));

	            var unmasked = that._unmask(endContent, old.length - endContent.length);
	            that._mask(caretPos, caretPos, unmasked);

	            if (backward) {
	                caretPos = that._findCaretPosBackwards(contentStart);
	            }

	            caret(element, caretPos);

	            //clean-up flags
	            that.__dropping = false;
	        },

	        _trimStartPromptChars: function(content, count) {
	            var promptChar = this.options.promptChar;

	            while (count-- > 0 && content.indexOf(promptChar) === 0) {
	                content = content.substring(1);
	            }

	            return content;
	        },

	        _findCaretPosBackwards: function(pos) {
	            var caretStart = this._find(pos, true);
	            if (caretStart < pos) {
	                caretStart += 1;
	            }

	            return caretStart;
	        },

	        _inputHandler: function() {
	            if (kendo._activeElement() !== this.element[0]) {
	                return;
	            }

	            this.inputChange(this.__backward);
	        },

	        _legacyIEInputHandler: function(e) {
	            var that = this;
	            var input = that.element[0];
	            var value = input.value;
	            var type = e.type;

	            that.__pasting = (type === "paste");

	            setTimeout(function() {
	                if(type === "mouseup" && that.__pasting) {
	                    return;
	                }
	                if (input.value && input.value !== value) {
	                    that.inputChange(that.__backward);
	                }
	            });
	        },

	        _trackChange: function() {
	            var that = this;

	            that.__changing = true;
	            setTimeout(function() { that.__changing = false; });
	        },

	        _form: function() {
	            var that = this;
	            var element = that.element;
	            var formId = element.attr("form");
	            var form = formId ? $("#" + formId) : element.closest("form");

	            if (form[0]) {
	                that._resetHandler = function() {
	                    setTimeout(function() {
	                        that.value(element[0].value);
	                    });
	                };

	                that._submitHandler = function() {
	                    that.element[0].value = that._old = that.raw();
	                };

	                if (that.options.unmaskOnPost) {
	                    form.on("submit", that._submitHandler);
	                }

	                that._formElement = form.on("reset", that._resetHandler);
	            }
	        },

	        _keydown: function(e) {
	            var key = e.keyCode;

	            this.__backward = key === keys.BACKSPACE;

	            if (key === keys.ENTER) {
	                this._change();
	            }
	        },

	        _drop: function() {
	            this.__dropping = true;
	        },

	        _find: function(idx, backward) {
	            var value = this.element.val() || this._emptyMask;
	            var step = 1;

	            if (backward === true) {
	                step = -1;
	            }

	            while (idx > -1 || idx <= this._maskLength) {
	                if (value.charAt(idx) !== this.tokens[idx]) {
	                    return idx;
	                }

	                idx += step;
	            }

	            return -1;
	        },

	        _mask: function(start, end, value, backward) {
	            var element = this.element[0];
	            var current = element.value || this._emptyMask;
	            var empty = this.options.promptChar;
	            var valueLength;
	            var chrIdx = 0;
	            var unmasked;
	            var chr;
	            var idx;

	            start = this._find(start, backward);

	            if (start > end) {
	                end = start;
	            }

	            unmasked = this._unmask(current.substring(end), end);
	            value = this._unmask(value, start);
	            valueLength = value.length;

	            if (value) {
	                unmasked = unmasked.replace(new RegExp("^_{0," + valueLength + "}"), "");
	            }

	            value += unmasked;
	            current = current.split("");
	            chr = value.charAt(chrIdx);

	            while (start < this._maskLength) {
	                current[start] = chr || empty;
	                chr = value.charAt(++chrIdx);

	                if (idx === undefined && chrIdx > valueLength) {
	                    idx = start;
	                }

	                start = this._find(start + 1);
	            }

	            element.value = this._old = current.join("");

	            if (kendo._activeElement() === element) {
	                if (idx === undefined) {
	                    idx = this._maskLength;
	                }

	                caret(element, idx);
	            }

	            return idx;
	        },

	        _unmask: function(value, idx) {
	            if (!value) {
	                return "";
	            }

	            if (this._unmaskedValue === value) {
	                return this._unmaskedValue;
	            }
	            value = (value + "").split("");

	            var chr;
	            var token;
	            var chrIdx = 0;
	            var tokenIdx = idx || 0;

	            var empty = this.options.promptChar;

	            var valueLength = value.length;
	            var tokensLength = this.tokens.length;

	            var result = "";

	            while (tokenIdx < tokensLength) {
	                chr = value[chrIdx];
	                token = this.tokens[tokenIdx];

	                if (chr === token || chr === empty) {
	                    result += chr === empty ? empty : "";

	                    chrIdx += 1;
	                    tokenIdx += 1;
	                } else if (typeof token !== "string") {
	                    if ((token && token.test && token.test(chr)) || ($.isFunction(token) && token(chr))) {
	                        result += chr;
	                        tokenIdx += 1;
	                    } else {
	                        if (valueLength === 1) {
	                            this._blinkInvalidState();
	                        }
	                    }

	                    chrIdx += 1;
	                } else {
	                    tokenIdx += 1;
	                }

	                if (chrIdx >= valueLength) {
	                    break;
	                }
	            }
	            this._unmaskedValue = result;
	            return result;
	        },

	        _label: function() {
	            var that = this;
	            var element = that.element;
	            var options = that.options;
	            var id = element.attr("id");
	            var floating;
	            var labelText;

	            if (options.label !== null) {
	                floating = isPlainObject(options.label) ? options.label.floating : false;
	                labelText = isPlainObject(options.label) ? options.label.content : options.label;

	                if (floating) {
	                    that._floatingLabelContainer = that.wrapper.wrap("<span></span>").parent();
	                    that.floatingLabel = new kendo.ui.FloatingLabel(that._floatingLabelContainer, { widget: that });
	                }

	                if (kendo.isFunction(labelText)) {
	                    labelText = labelText.call(that);
	                }

	                if (!labelText) {
	                    labelText = "";
	                }

	                if (!id) {
	                    id = options.name + "_" + kendo.guid();
	                    element.attr("id", id);
	                }

	                that._inputLabel = $("<label class='" + LABELCLASSES + "' for='" + id + "'>" + labelText + "</label>'").insertBefore(that.wrapper);
	            }
	        },

	        _wrapper: function () {
	            var that = this;
	            var element = that.element;
	            var DOMElement = element[0];

	            var wrapper = element.wrap("<span class='k-widget k-maskedtextbox'></span>").parent();
	            wrapper[0].style.cssText = DOMElement.style.cssText;
	            DOMElement.style.width = "100%";
	            that.wrapper = wrapper.addClass(DOMElement.className).removeClass('input-validation-error');
	        },

	        _blinkInvalidState: function () {
	            var that = this;

	            that.wrapper.addClass(STATEINVALID);
	            clearTimeout(that._invalidStateTimeout);
	            that._invalidStateTimeout = setTimeout(proxy(that._removeInvalidState, that), 100);
	        },

	        _removeInvalidState: function () {
	            var that = this;

	            that.wrapper.removeClass(STATEINVALID);
	            that._invalidStateTimeout = null;
	        },

	        _tokenize: function() {
	            var tokens = [];
	            var tokenIdx = 0;

	            var mask = this.options.mask || "";
	            var maskChars = mask.split("");
	            var length = maskChars.length;
	            var idx = 0;
	            var chr;
	            var rule;

	            var emptyMask = "";
	            var promptChar = this.options.promptChar;
	            var numberFormat = kendo.getCulture(this.options.culture).numberFormat;
	            var rules = this._rules;

	            for (; idx < length; idx++) {
	                chr = maskChars[idx];
	                rule = rules[chr];

	                if (rule) {
	                    tokens[tokenIdx] = rule;
	                    emptyMask += promptChar;
	                    tokenIdx += 1;
	                } else {
	                    if (chr === "." || chr === ",") {
	                        chr = numberFormat[chr];
	                    } else if (chr === "$") {
	                        chr = numberFormat.currency.symbol;
	                    } else if (chr === "\\") {
	                        idx += 1;
	                        chr = maskChars[idx];
	                    }

	                    chr = chr.split("");

	                    for (var i = 0, l = chr.length; i < l; i++) {
	                        tokens[tokenIdx] = chr[i];
	                        emptyMask += chr[i];
	                        tokenIdx += 1;
	                    }
	                }
	            }

	            this.tokens = tokens;

	            this._emptyMask = emptyMask;
	            this._maskLength = emptyMask.length;
	        }
	    });

	    function escapeRegExp(text) {
	        return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
	    }

	    ui.plugin(MaskedTextBox);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1289:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("5AFk");

/***/ })

/******/ });

/***/ }),

/***/ "Yjjl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Columns = __webpack_require__("B+Kv");

var _Columns2 = _interopRequireDefault(_Columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoGridColumn = {
    name: 'kendo-multicolumncombobox-column',
    render: function render() {
        return null;
    },

    mixins: [_Columns2.default]
};

exports.default = KendoGridColumn;

/***/ }),

/***/ "YlOY":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1356);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1046:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2btM");

/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1046), __webpack_require__(1059) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "pivotgrid",
	    name: "PivotGrid",
	    category: "web",
	    description: "The PivotGrid widget is a data summarization tool.",
	    depends: [ "dom", "data", "data.xml", "sortable" ],
	    features: [{
	        id: "pivotgrid-configurator",
	        name: "Configurator",
	        description: "The PivotConfigurator widget allows the user to select data slices displayed in PivotGrid",
	        depends: [ "pivot.configurator" ]
	    }, {
	        id: "pivotgrid-filtering",
	        name: "Filtering",
	        description: "Support for filtering",
	        depends: [ "pivot.fieldmenu" ]
	    }, {
	        id: "pivotgrid-excel-export",
	        name: "Excel export",
	        description: "Export pivot grid data as Excel spreadsheet",
	        depends: [ "ooxml" ]
	    }, {
	        id: "pivotgrid-pdf-export",
	        name: "PDF export",
	        description: "Export pivot grid data as PDF",
	        depends: [ "pdf", "drawing" ]
	    }, {
	        id: "mobile-scroller",
	        name: "Mobile scroller",
	        description: "Support for kinetic scrolling in mobile device",
	        depends: [ "mobile.scroller" ]
	    }]
	};

	/*jshint eqnull: true*/
	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        Class = kendo.Class,
	        Comparer = kendo.data.Comparer,
	        Widget = ui.Widget,
	        DataSource = kendo.data.DataSource,
	        outerWidth = kendo._outerWidth,
	        outerHeight = kendo._outerHeight,
	        toString = {}.toString,
	        identity = function(o) { return o; },
	        map = $.map,
	        extend = $.extend,
	        isFunction = kendo.isFunction,
	        CHANGE = "change",
	        ERROR = "error",
	        MEASURES = "Measures",
	        PROGRESS = "progress",
	        STATERESET = "stateReset",
	        AUTO = "auto",
	        DIV = "<div></div>",
	        NS = ".kendoPivotGrid",
	        ROW_TOTAL_KEY = "__row_total__",
	        DATABINDING = "dataBinding",
	        DATABOUND = "dataBound",
	        EXPANDMEMBER = "expandMember",
	        COLLAPSEMEMBER = "collapseMember",
	        STATE_EXPANDED = "k-i-collapse",
	        STATE_COLLAPSED = "k-i-expand",
	        HEADER_TEMPLATE = "<span>#: data.member.caption || data.member.name #</span>",
	        KPISTATUS_TEMPLATE = '<span class="k-icon k-i-kpi-status-#=data.dataItem.value > 0 ? \"open\" : data.dataItem.value < 0 ? \"deny\" : \"hold\"#" title="#:data.dataItem.value#"></span>',
	        KPITREND_TEMPLATE = '<span class="k-icon k-i-kpi-trend-#=data.dataItem.value > 0 ? \"increase\" : data.dataItem.value < 0 ? \"decrease\" : \"equal\"#" title="#:data.dataItem.value#"></span>',
	        DATACELL_TEMPLATE = '#= data.dataItem ? kendo.htmlEncode(data.dataItem.fmtValue || data.dataItem.value) || "&nbsp;" : "&nbsp;" #',
	        LAYOUT_TABLE = '<table class="k-pivot-layout">' +
	                            '<tr>' +
	                                '<td>' +
	                                    '<div class="k-pivot-rowheaders"></div>' +
	                                '</td>' +
	                                '<td>' +
	                                    '<div class="k-pivot-table k-state-default"></div>' +
	                                '</td>' +
	                            '</tr>' +
	                        '</table>';
	        var AXIS_ROWS = "rows";
	        var AXIS_COLUMNS = "columns";

	    function normalizeMeasures(measure) {
	        var descriptor = typeof measure === "string" ? [{ name: measure }] : measure;
	        var descriptors = toString.call(descriptor) === "[object Array]" ? descriptor : (descriptor !== undefined ? [descriptor] : []);

	        return map(descriptors, function(d) {
	            if (typeof d === "string") {
	                return { name: d };
	            }
	            return { name: d.name, type: d.type };
	        });
	    }

	    function normalizeMembers(member) {
	        var descriptor = typeof member === "string" ? [{ name: [member], expand: false }] : member;
	        var descriptors = toString.call(descriptor) === "[object Array]" ? descriptor : (descriptor !== undefined ? [descriptor] : []);

	        return map(descriptors, function(d) {
	            if (typeof d === "string") {
	                return { name: [d], expand: false };
	            }
	            return { name: (toString.call(d.name) === "[object Array]" ? d.name.slice() : [d.name]), expand: d.expand };
	        });
	    }

	    function normalizeName(name) {
	        if (name.indexOf(" ") !== -1) {
	            name = '["' + name + '"]';
	        }

	        return name;
	    }

	    function accumulateMembers(accumulator, rootTuple, tuple, level) {
	        var idx, length;
	        var children;
	        var member;

	        if (!tuple) {
	            tuple = rootTuple;
	        }

	        if (!level) {
	            level = 0;
	        }

	        member = tuple.members[level];

	        if (!member || member.measure) { //return if no member or measure
	            return;
	        }

	        children = member.children;
	        length = children.length;

	        if (tuple === rootTuple) {
	            accumulator[kendo.stringify([member.name])] = !!length;
	        } else if (length) {
	            accumulator[kendo.stringify(buildPath(tuple, level))] = true;
	        }

	        if (length) {
	            for (idx = 0; idx < length; idx++) {
	                accumulateMembers(accumulator, rootTuple, children[idx], level);
	            }
	        }

	        accumulateMembers(accumulator, rootTuple, tuple, level + 1);
	    }

	    function descriptorsForAxes(tuples) {
	        var result = {};

	        if (tuples.length) {
	            accumulateMembers(result, tuples[0]);
	        }

	        var descriptors = [];
	        for (var k in result) {
	            descriptors.push({ name: $.parseJSON(k), expand: result[k] });
	        }

	        return descriptors;
	    }

	    function addMissingPathMembers(members, axis) {
	        var tuples = axis.tuples || [];
	        var firstTuple = tuples[0];

	        if (firstTuple && members.length < firstTuple.members.length) {
	            var tupleMembers = firstTuple.members;

	            for (var idx = 0; idx < tupleMembers.length; idx++) {
	                if (tupleMembers[idx].measure) {
	                    continue;
	                }

	                var found = false;
	                for (var j = 0; j < members.length; j++) {
	                    if (getName(members[j]).indexOf(tupleMembers[idx].hierarchy) === 0) {
	                        found = true;
	                        break;
	                    }
	                }

	                if (!found) {
	                    members.push({ name: [tupleMembers[idx].name], expand: false }); //calling normalize here to make name from string to array
	                }
	            }
	        }
	    }

	    function tupleToDescriptors(tuple) {
	        var result = [];
	        var members = tuple.members;

	        for (var idx = 0; idx < members.length; idx++) {
	            if (members[idx].measure) {
	                continue;
	            }

	            //make tuple name an array
	            result.push({ name: [members[idx].name], expand: members[idx].children.length > 0});
	        }

	        return result;
	    }

	    function descriptorsForMembers(axis, members, measures) {
	        axis = axis || {};

	        addMissingPathMembers(members, axis);

	        if (measures.length > 1) {
	            members.push({
	                name: MEASURES,
	                measure: true,
	                children: normalizeMembers(measures)
	            });
	        }

	        var tupletoSearch = {
	            members: members
	        };

	        if (axis.tuples) {
	            var result = findExistingTuple(axis.tuples, tupletoSearch);
	            if (result.tuple) {
	                members = tupleToDescriptors(result.tuple);
	            }
	        }

	        return members;
	    }

	    function createAggregateGetter(m) {
	        var measureGetter = kendo.getter(m.field, true);
	        return function(aggregatorContext, state) {
	            return m.aggregate(measureGetter(aggregatorContext.dataItem), state, aggregatorContext);
	        };
	    }

	    function isNumber(val) {
	        return typeof val === "number" && !isNaN(val);
	    }

	    function isDate(val) {
	        return val && val.getTime;
	    }

	    var functions = {
	        sum: function(value, state) {
	            var accumulator = state.accumulator;

	            if (!isNumber(accumulator)) {
	                accumulator = value;
	            } else if (isNumber(value)) {
	                accumulator += value;
	            }

	            return accumulator;
	        },
	        count: function(value, state) {
	            return (state.accumulator || 0) + 1;
	        },
	        average: {
	            aggregate: function(value, state) {
	                var accumulator = state.accumulator;

	                if (state.count === undefined) {
	                    state.count = 0;
	                }

	                if (!isNumber(accumulator)) {
	                    accumulator = value;
	                } else if (isNumber(value)) {
	                    accumulator += value;
	                }

	                if (isNumber(value)) {
	                    state.count++;
	                }

	                return accumulator;
	            },
	            result: function(state) {
	                var accumulator = state.accumulator;

	                if (isNumber(accumulator)) {
	                    accumulator = accumulator / state.count;
	                }

	                return accumulator;
	            }
	        },
	        max: function(value, state) {
	            var accumulator = state.accumulator;

	            if (!isNumber(accumulator) && !isDate(accumulator)) {
	                accumulator = value;
	            }

	            if(accumulator < value && (isNumber(value) || isDate(value))) {
	                accumulator = value;
	            }
	            return accumulator;
	        },
	        min: function(value, state) {
	            var accumulator = state.accumulator;

	            if (!isNumber(accumulator) && !isDate(accumulator)) {
	                accumulator = value;
	            }

	            if(accumulator > value && (isNumber(value) || isDate(value))) {
	                accumulator = value;
	            }
	            return accumulator;
	        }
	    };

	    var PivotCubeBuilder = Class.extend({
	        init: function(options) {
	            this.options = extend({}, this.options, options);
	            this.dimensions = this._normalizeDescriptors("field", this.options.dimensions);
	            this.measures = this._normalizeDescriptors("name", this.options.measures);
	        },

	        _normalizeDescriptors: function(keyField, descriptors) {
	            descriptors = descriptors || {};
	            var fields = {};
	            var field;

	            if (toString.call(descriptors) === "[object Array]") {
	                for (var idx = 0, length = descriptors.length; idx < length; idx++) {
	                    field = descriptors[idx];
	                    if (typeof field === "string") {
	                        fields[field] = {};
	                    } else if (field[keyField]) {
	                        fields[field[keyField]] = field;
	                    }
	                }
	                descriptors = fields;
	            }

	            return descriptors;
	        },

	        _rootTuples: function(rootNames, measureAggregators) {
	            var aggregatorsLength = measureAggregators.length || 1;
	            var dimensionsSchema = this.dimensions || [];
	            var root, name, parts;
	            var measureIdx = 0;
	            var idx;

	            var rootNamesLength = rootNames.length;
	            var result = [];
	            var keys = [];

	            if (rootNamesLength || measureAggregators.length) {
	                for (measureIdx = 0; measureIdx < aggregatorsLength; measureIdx++) {

	                    root = { members: [] };

	                    for (idx = 0; idx < rootNamesLength; idx++) {
	                        name = rootNames[idx];
	                        parts = name.split("&");

	                        root.members[root.members.length] = {
	                            children: [],
	                            caption: (dimensionsSchema[name] || {}).caption || "All",
	                            name: name,
	                            levelName: name,
	                            levelNum: "0",
	                            hasChildren: true,
	                            parentName: parts.length > 1 ? parts[0] : undefined,
	                            hierarchy: name
	                        };
	                    }

	                    if (aggregatorsLength > 1) {
	                        root.members[root.members.length] = {
	                            children: [],
	                            caption: (measureAggregators[measureIdx]).caption,
	                            name: measureAggregators[measureIdx].descriptor.name,
	                            levelName: "MEASURES",
	                            levelNum: "0",
	                            hasChildren: false,
	                            parentName: undefined,
	                            hierarchy: "MEASURES"
	                        };
	                    }

	                    result[result.length] = root;
	                }

	                keys.push(ROW_TOTAL_KEY);
	            }

	            return {
	                keys: keys,
	                tuples: result
	            };
	        },

	        _sortMap: function(map, sortDescriptors) {
	            var sortedMaps = [];
	            var sortTree = [];
	            var flattenTree = [];
	            var mapItem;
	            var key;

	            for (key in map) {
	                if (!map[key].directParentName) {
	                    sortTree.push($.extend({}, { name :key, parentName: map[key].parentName }));
	                }
	            }

	            //if there are no root this means that something is expanding
	            //and we should only sort that part of the tree
	            if (!sortTree.length) {
	                for (key in map) {
	                    sortTree.push($.extend({}, { name :key, parentName: map[key].parentName }));
	                }
	            }

	            fillSortTree(sortTree, map);

	            // fill tree recursive
	            for (var i = 0; i < sortDescriptors.length; i++) {
	                sortItemsTree(sortDescriptors[i].field.split(".").pop(), sortTree, Comparer.create({ field: "name", dir: sortDescriptors[i].dir }));
	            }

	            flattenTree = flatColumns(sortTree);

	            //we need to flatten the structure so the tuples can build correctly
	            for (var j = 0; j < flattenTree.length; j++) {
	                mapItem = map[flattenTree[j].name];
	                mapItem.index = j;
	                sortedMaps[j] = mapItem;
	            }

	            return sortedMaps;
	        },

	        _expandedTuples: function(map, expanded, measureAggregators, sortDescriptors) {
	            var aggregatorsLength = measureAggregators.length || 1;
	            var dimensionsSchema = this.dimensions || [];
	            var measureIdx;
	            var tuple;

	            var key;
	            var mapItem;
	            var current;
	            var currentKeys;
	            var accumulator = [];
	            var accumulatorKeys = [];
	            var memberInfo;

	            var expandedNames;
	            var parts;
	            var name;
	            var idx;

	            if (sortDescriptors && sortDescriptors.length && !$.isEmptyObject(map)) {
	                map = this._sortMap(map, sortDescriptors);
	            }

	            for (key in map) {
	                mapItem = map[key];
	                memberInfo = this._findExpandedMember(expanded, mapItem.uniquePath);

	                current = accumulator[memberInfo.index] || [];
	                currentKeys = accumulatorKeys[memberInfo.index] || [];

	                expandedNames = memberInfo.member.names;

	                for (measureIdx = 0; measureIdx < aggregatorsLength; measureIdx++) {
	                    tuple = { members: [] };
	                    for (idx = 0; idx < expandedNames.length; idx++) {
	                        if (idx === memberInfo.member.expandedIdx) {
	                            tuple.members[tuple.members.length] = {
	                                children: [],
	                                caption: mapItem.value,
	                                name: mapItem.name,
	                                hasChildren: false,
	                                levelNum: 1,
	                                levelName: mapItem.parentName + mapItem.name,
	                                parentName: mapItem.parentName,
	                                hierarchy: mapItem.parentName + mapItem.name
	                            };

	                            if (measureIdx === 0) {
	                                currentKeys.push(buildPath(tuple, idx).join(""));
	                            }
	                        } else {
	                            name = expandedNames[idx];
	                            parts = name.split("&");
	                            tuple.members[tuple.members.length] = {
	                                children: [],
	                                caption: (dimensionsSchema[name] || {}).caption || "All",
	                                name: name,
	                                levelName: name,
	                                levelNum: "0",
	                                hasChildren: true,
	                                parentName: parts.length > 1 ? parts[0] : undefined,
	                                hierarchy: name
	                            };
	                        }
	                    }

	                    if (aggregatorsLength > 1) {
	                        tuple.members[tuple.members.length] = {
	                            children: [],
	                            caption: measureAggregators[measureIdx].caption,
	                            name: measureAggregators[measureIdx].descriptor.name,
	                            levelName: "MEASURES",
	                            levelNum: "0",
	                            hasChildren: true,
	                            parentName: undefined,
	                            hierarchy: "MEASURES"
	                        };
	                    }

	                    current[current.length] = tuple;
	                }

	                accumulator[memberInfo.index] = current;
	                accumulatorKeys[memberInfo.index] = currentKeys;
	            }

	            return {
	                keys: accumulatorKeys,
	                tuples: accumulator
	            };
	        },

	        _findExpandedMember: function(members, parentName) {
	            for (var idx = 0; idx < members.length; idx++) {
	                if (members[idx].uniquePath === parentName) {
	                    return {
	                        member: members[idx],
	                        index: idx
	                    };
	                }
	            }
	        },

	        _asTuples: function(map, descriptor, measureAggregators, sortDescriptors) {
	            measureAggregators = measureAggregators || [];

	            var rootInfo = this._rootTuples(descriptor.root, measureAggregators);
	            var expandedInfo = this._expandedTuples(map, descriptor.expanded, measureAggregators, sortDescriptors);

	            return {
	                keys: [].concat.apply(rootInfo.keys, expandedInfo.keys),
	                tuples: [].concat.apply(rootInfo.tuples, expandedInfo.tuples)
	            };
	        },

	        _measuresInfo: function(measures, rowAxis) {
	            var idx = 0;
	            var length = measures && measures.length;

	            var aggregateNames = [];
	            var resultFuncs= {};
	            var formats = {};

	            var descriptors = (this.measures || {});
	            var measure;
	            var name;

	            for (; idx < length; idx++) {
	                name = measures[idx].descriptor.name;
	                measure = descriptors[name] || {};

	                aggregateNames.push(name);

	                if (measure.result) {
	                    resultFuncs[name] = measure.result;
	                }

	                if (measure.format) {
	                    formats[name] = measure.format;
	                }
	            }

	            return {
	                names: aggregateNames,
	                formats: formats,
	                resultFuncs: resultFuncs,
	                rowAxis: rowAxis
	            };
	        },

	        _toDataArray: function(map, measuresInfo, rowKeys, columnKeys) {
	            var result = [];

	            var aggregates;
	            var name, i, j, k, n;
	            var row, column, columnKey;

	            var rowMeasureNamesLength = 1;
	            var rowMeasureNames = [];
	            var columnMeasureNames;

	            var rowLength = rowKeys.length || 1;
	            var columnLength = columnKeys.length || 1;

	            if (measuresInfo.rowAxis) {
	                rowMeasureNames = measuresInfo.names;
	                rowMeasureNamesLength = rowMeasureNames.length;
	            } else {
	                columnMeasureNames = measuresInfo.names;
	            }

	            for (i = 0; i < rowLength; i++) {
	                row = map[rowKeys[i] || ROW_TOTAL_KEY];

	                for (n = 0; n < rowMeasureNamesLength; n++) {
	                    if (measuresInfo.rowAxis) {
	                        columnMeasureNames = [rowMeasureNames[n]];
	                    }

	                    for (j = 0; j < columnLength; j++) {
	                        columnKey = columnKeys[j] || ROW_TOTAL_KEY;
	                        column = row.items[columnKey];

	                        if (columnKey === ROW_TOTAL_KEY) {
	                            aggregates = row.aggregates;
	                        } else {
	                            aggregates = column ? column.aggregates : {};
	                        }

	                        for (k = 0; k < columnMeasureNames.length; k++) {
	                            name = columnMeasureNames[k];
	                            this._addData(result, aggregates[name], measuresInfo.formats[name], measuresInfo.resultFuncs[name]);
	                        }
	                    }
	                }
	            }

	            return result;
	        },

	        _addData: function(result, value, format, resultFunc) {
	            var fmtValue = "";
	            var ordinal;

	            if (value) {
	                value = resultFunc ? resultFunc(value) : value.accumulator;
	                fmtValue = format ? kendo.format(format, value) : value;
	            }

	            ordinal = result.length;

	            result[ordinal] = {
	                ordinal: ordinal,
	                value: value || "",
	                fmtValue: fmtValue
	            };
	        },

	        _matchDescriptors: function(dataItem, descriptor, getters) {
	            var parts;
	            var parentField;
	            var expectedValue;

	            var names = descriptor.names;
	            var idx = descriptor.expandedIdx;
	            var value;

	            while (idx > 0) {
	                parts = names[--idx].split("&");
	                if (parts.length > 1) {
	                    parentField = parts[0];
	                    expectedValue = parts[1];

	                    value = getters[parentField](dataItem);
	                    value = (value !== undefined && value !== null) ? value.toString() : value;

	                    if (value != expectedValue) {
	                        return false;
	                    }
	                }
	            }
	            return true;
	        },

	        _calculateAggregate: function(measureAggregators, aggregatorContext, totalItem) {
	            var result = {};
	            var state;
	            var name;

	            for (var measureIdx = 0; measureIdx < measureAggregators.length; measureIdx++) {
	                name = measureAggregators[measureIdx].descriptor.name;
	                state = totalItem.aggregates[name] || { };
	                state.accumulator = measureAggregators[measureIdx].aggregator(aggregatorContext, state);
	                result[name] = state;
	            }

	            return result;
	        },

	        _processColumns: function(measureAggregators, descriptors, getters, columns, aggregatorContext, rowTotal, state, updateColumn) {
	            var value;
	            var descriptor;
	            var column;
	            var totalItem;
	            var key, name, parentName, path;
	            var dataItem = aggregatorContext.dataItem;
	            var idx = 0;

	            for (; idx < descriptors.length; idx++) {
	                descriptor = descriptors[idx];

	                //checks whether the dataItem is relevant to the descriptors
	                if (!this._matchDescriptors(dataItem, descriptor, getters)) {
	                    continue;
	                }

	                path = descriptor.names.slice(0, descriptor.expandedIdx).join("");
	                name = descriptor.names[descriptor.expandedIdx];


	                value = getters[name](dataItem);
	                value = (value !== undefined && value !== null) ? value.toString() : value;

	                parentName = name;
	                name = name + "&" + value;
	                key = path + name;

	                column = columns[key] || {
	                    index: state.columnIndex,
	                    parentName: parentName,
	                    name: name,
	                    directParentName: path.indexOf("&") !== -1 ? path: "",
	                    uniquePath: path + parentName,
	                    childrenMap : {},
	                    value: value
	                };

	                if (path && columns[path] && !columns[path].childrenMap[path + parentName + "&" + value]) {
	                    columns[path].childrenMap[path + parentName + "&" + value] = true;
	                }

	                totalItem = rowTotal.items[key] || {
	                    aggregates: {}
	                };

	                rowTotal.items[key] = {
	                    index: column.index,
	                    aggregates: this._calculateAggregate(measureAggregators, aggregatorContext, totalItem)
	                };

	                if (updateColumn) {
	                    if (!columns[key]) {
	                        state.columnIndex++;
	                    }
	                    columns[key] = column;
	                }
	            }
	        },

	        _measureAggregators: function(options) {
	            var measureDescriptors = options.measures || [];
	            var measures = this.measures || {};
	            var aggregators = [];
	            var descriptor, measure, idx, length;
	            var defaultAggregate, aggregate;

	            if (measureDescriptors.length) {
	                for (idx = 0, length = measureDescriptors.length; idx < length; idx++) {
	                    descriptor = measureDescriptors[idx];
	                    measure = measures[descriptor.name];
	                    defaultAggregate = null;

	                    if (measure) {
	                        aggregate = measure.aggregate;
	                        if (typeof aggregate === "string") {
	                            defaultAggregate = functions[aggregate.toLowerCase()];

	                            if (!defaultAggregate) {
	                                throw new Error("There is no such aggregate function");
	                            }

	                            measure.aggregate = defaultAggregate.aggregate || defaultAggregate;
	                            measure.result = defaultAggregate.result;
	                        }


	                        aggregators.push({
	                            descriptor: descriptor,
	                            caption: measure.caption,
	                            result: measure.result,
	                            aggregator: createAggregateGetter(measure)
	                        });
	                    }
	                }
	            } else {
	                aggregators.push({
	                    descriptor: { name: "default"},
	                    caption: "default",
	                    aggregator: function() { return 1; }
	                });
	            }

	            return aggregators;
	        },

	        _buildGetters: function(names) {
	            var result = {};
	            var parts;
	            var name;

	            for (var idx = 0; idx < names.length; idx++) {
	                name = names[idx];
	                parts = name.split("&");

	                if (parts.length > 1) {
	                    result[parts[0]] = kendo.getter(parts[0], true);
	                } else {
	                    result[name] = kendo.getter(normalizeName(name), true);
	                }
	            }

	            return result;
	        },

	        _parseDescriptors: function (descriptors) {
	            var parsedDescriptors = parseDescriptors(descriptors);
	            var rootNames = getRootNames(parsedDescriptors.root);
	            var expanded = parsedDescriptors.expanded;
	            var result = [];

	            for (var idx = 0; idx < expanded.length; idx++) {
	                result.push(mapNames(expanded[idx].name, rootNames));
	            }

	            return {
	                root: rootNames,
	                expanded: result
	            };
	        },

	        _filter: function(data, filter) {
	            if (!filter) {
	                return data;
	            }

	            var expr;
	            var idx = 0;
	            var filters = filter.filters;

	            for (; idx < filters.length; idx++) {
	                expr = filters[idx];

	                if (expr.operator === "in") {
	                    filters[idx] = this._normalizeFilter(expr);
	                }
	            }

	            return new kendo.data.Query(data).filter(filter).data;
	        },

	        _normalizeFilter: function(filter) {
	            var value = filter.value.split(",");
	            var result = [];

	            if (!value.length) {
	                return value;
	            }

	            for (var idx = 0; idx < value.length; idx++) {
	                result.push({
	                    field: filter.field,
	                    operator: "eq",
	                    value: value[idx]
	                });
	            }

	            return {
	                logic: "or",
	                filters: result
	            };
	        },

	        process: function(data, options) {
	            data = data || [];
	            options = options || {};

	            data = this._filter(data, options.filter);

	            var measures = options.measures || [];

	            var measuresRowAxis = options.measuresAxis === "rows";

	            var columnDescriptors = options.columns || [];
	            var rowDescriptors = options.rows || [];

	            if (!columnDescriptors.length && rowDescriptors.length && (!measures.length || (measures.length && measuresRowAxis))) {
	                columnDescriptors = rowDescriptors;
	                rowDescriptors = [];
	                measuresRowAxis = false;
	            }

	            if (!columnDescriptors.length && !rowDescriptors.length) {
	                measuresRowAxis = false;
	            }

	            if (!columnDescriptors.length && measures.length) {
	                columnDescriptors = normalizeMembers(options.measures);
	            }

	            columnDescriptors = this._parseDescriptors(columnDescriptors);
	            rowDescriptors = this._parseDescriptors(rowDescriptors);

	            var aggregatedData = {};
	            var columns = {};
	            var rows = {};

	            var rowValue;
	            var state = { columnIndex: 0 };

	            var measureAggregators = this._measureAggregators(options);

	            var columnGetters = this._buildGetters(columnDescriptors.root);
	            var rowGetters = this._buildGetters(rowDescriptors.root);

	            var processed = false;

	            var expandedColumns = columnDescriptors.expanded;
	            var expandedRows = rowDescriptors.expanded;

	            var dataItem;
	            var aggregatorContext;
	            var hasExpandedRows = expandedRows.length !== 0;

	            var rowIdx, rowDescriptor, rowName, rowTotal;
	            var key, path, parentName, value;
	            var columnsInfo, rowsInfo;
	            var length = data.length;
	            var idx = 0;

	            if (columnDescriptors.root.length || rowDescriptors.root.length) {
	                processed = true;

	                for (idx = 0; idx < length; idx++) {
	                    dataItem = data[idx];

	                    aggregatorContext = {
	                        dataItem: dataItem,
	                        index: idx
	                    };

	                    rowTotal = aggregatedData[ROW_TOTAL_KEY] || {
	                        items: {},
	                        aggregates: {}
	                    };

	                    this._processColumns(measureAggregators, expandedColumns, columnGetters, columns, aggregatorContext, rowTotal, state, !hasExpandedRows);

	                    rowTotal.aggregates = this._calculateAggregate(measureAggregators, aggregatorContext, rowTotal);
	                    aggregatedData[ROW_TOTAL_KEY] = rowTotal;

	                    for (rowIdx = 0; rowIdx < expandedRows.length; rowIdx++) {
	                        rowDescriptor = expandedRows[rowIdx];

	                        if (!this._matchDescriptors(dataItem, rowDescriptor, rowGetters)) {
	                            this._processColumns(measureAggregators, expandedColumns, columnGetters, columns, aggregatorContext, { items: {}, aggregates: {} }, state, true);
	                            continue;
	                        }

	                        path = rowDescriptor.names.slice(0, rowDescriptor.expandedIdx).join("");
	                        rowName = rowDescriptor.names[rowDescriptor.expandedIdx];

	                        parentName = rowName;

	                        rowValue = rowGetters[rowName](dataItem);
	                        rowValue = rowValue !== undefined ? rowValue.toString() : rowValue;

	                        rowName = rowName + "&" + rowValue;
	                        key = path + rowName;

	                        rows[key] = {
	                            uniquePath: path + parentName,
	                            parentName: parentName,
	                            name: rowName,
	                            value: rowValue
	                        };

	                        value = aggregatedData[key] || {
	                            items: {},
	                            aggregates: {}
	                        };

	                        this._processColumns(measureAggregators, expandedColumns, columnGetters, columns, aggregatorContext, value, state, true);

	                        value.aggregates = this._calculateAggregate(measureAggregators, aggregatorContext, value);
	                        aggregatedData[key] = value;
	                    }
	                }
	            }

	            if (processed && length) {
	                if (measureAggregators.length > 1 && (!options.columns || !options.columns.length)) {
	                    columnDescriptors = {
	                        root: [],
	                        expanded: []
	                    };
	                }

	                columnsInfo = this._asTuples(columns, columnDescriptors, measuresRowAxis ? [] : measureAggregators, options.sort ? options.sort: []);
	                rowsInfo = this._asTuples(rows, rowDescriptors, measuresRowAxis ? measureAggregators : [], options.sort ? options.sort: []);

	                columns = columnsInfo.tuples;
	                rows = rowsInfo.tuples;

	                aggregatedData = this._toDataArray(aggregatedData, this._measuresInfo(measureAggregators, measuresRowAxis), rowsInfo.keys, columnsInfo.keys);
	            } else {
	                aggregatedData = columns = rows = [];
	            }

	            return {
	                axes: {
	                    columns: { tuples: columns },
	                    rows: { tuples: rows }
	                },
	                data: aggregatedData
	            };
	        }
	    });

	    var PivotTransport = Class.extend({
	        init: function(options, transport) {
	            this.transport = transport;
	            this.options = transport.options || {};

	            if (!this.transport.discover) {
	                if (isFunction(options.discover)) {
	                    this.discover = options.discover;
	                }
	            }
	        },
	        read: function(options) {
	            return this.transport.read(options);
	        },
	        update: function(options) {
	            return this.transport.update(options);
	        },
	        create: function(options) {
	            return this.transport.create(options);
	        },
	        destroy: function(options) {
	            return this.transport.destroy(options);
	        },
	        discover: function(options) {
	            if (this.transport.discover) {
	                return this.transport.discover(options);
	            }
	            options.success({});
	        },
	        catalog: function(val) {
	            var options = this.options || {};

	            if (val === undefined) {
	                return (options.connection || {}).catalog;

	            }

	            var connection = options.connection || {};
	            connection.catalog = val;

	            this.options.connection = connection;
	            $.extend(this.transport.options, { connection: connection });
	        },
	        cube: function(val) {
	            var options = this.options || {};

	            if (val === undefined) {
	                return (options.connection || {}).cube;
	            }

	            var connection = options.connection || {};
	            connection.cube = val;

	            this.options.connection = connection;
	            extend(true, this.transport.options, { connection: connection });
	        }
	    });

	    var PivotDataSource = DataSource.extend({
	        init: function(options) {
	            var cube = ((options || {}).schema || {}).cube;
	            var measuresAxis = "columns";
	            var measures;

	            var schema = {
	                axes: identity,
	                cubes: identity,
	                catalogs: identity,
	                measures: identity,
	                dimensions: identity,
	                hierarchies: identity,
	                levels: identity,
	                members: identity
	            };

	            if (cube) {
	                schema = $.extend(schema, this._cubeSchema(cube));
	                this.cubeBuilder = new PivotCubeBuilder(cube);
	            }

	            DataSource.fn.init.call(this, extend(true, {}, {
	                schema: schema
	            }, options));

	            this.transport = new PivotTransport(this.options.transport || {}, this.transport);

	            this._columns = normalizeMembers(this.options.columns);
	            this._rows = normalizeMembers(this.options.rows);

	            measures = this.options.measures || [];

	            if (toString.call(measures) === "[object Object]") {
	                measuresAxis = measures.axis || "columns";
	                measures = measures.values || [];
	            }

	            this._measures = normalizeMeasures(measures);
	            this._measuresAxis = measuresAxis;

	            this._skipNormalize = 0;
	            this._axes = {};
	        },

	        _cubeSchema: function(cube) {
	            return {
	                dimensions: function() {
	                    var result = [];
	                    var dimensions = cube.dimensions;

	                    for (var key in dimensions) {
	                        result.push({
	                            name: key,
	                            caption: dimensions[key].caption || key,
	                            uniqueName: key,
	                            defaultHierarchy: key,
	                            type: 1
	                        });
	                    }

	                    if (cube.measures) {
	                        result.push({
	                            name: MEASURES,
	                            caption: MEASURES,
	                            uniqueName: MEASURES,
	                            type: 2
	                        });
	                    }

	                    return result;
	                },
	                hierarchies: function(){
	                    return [];
	                },
	                measures: function() {
	                    var result = [];
	                    var measures = cube.measures;

	                    for (var key in measures) {
	                        result.push({
	                            name: key,
	                            caption: key,
	                            uniqueName: key,
	                            aggregator: key
	                        });
	                    }

	                    return result;
	                },
	                members: $.proxy(function(response, restrictions) {
	                    var name = restrictions.levelUniqueName || restrictions.memberUniqueName;
	                    var schemaData = this.options.schema.data;
	                    var dataGetter = isFunction(schemaData) ? schemaData : kendo.getter(schemaData, true);
	                    var data = (this.options.data && dataGetter(this.options.data)) || this._rawData || [];
	                    var result = [];
	                    var getter;
	                    var value;
	                    var idx = 0;
	                    var distinct = {};

	                    if (name) {
	                        name = name.split(".")[0];
	                    }

	                    if (!restrictions.treeOp) {
	                        result.push({
	                            caption: cube.dimensions[name].caption || name,
	                            childrenCardinality: "1",
	                            dimensionUniqueName: name,
	                            hierarchyUniqueName: name,
	                            levelUniqueName: name,
	                            name: name,
	                            uniqueName: name
	                        });

	                        return result;
	                    }

	                    getter = kendo.getter(normalizeName(name), true);

	                    for (; idx < data.length; idx++) {
	                        value = getter(data[idx]);
	                        if ((value || value === 0) && !distinct[value]) {
	                            distinct[value] = true;

	                            result.push({
	                                caption: value,
	                                childrenCardinality: "0",
	                                dimensionUniqueName: name,
	                                hierarchyUniqueName: name,
	                                levelUniqueName: name,
	                                name: value,
	                                uniqueName: value
	                            });
	                        }
	                    }

	                    return result;
	                }, this)
	            };
	        },

	        options: {
	            serverSorting: true,
	            serverPaging: true,
	            serverFiltering: true,
	            serverGrouping: true,
	            serverAggregates: true
	        },

	        catalog: function(val) {
	            if (val === undefined) {
	                return this.transport.catalog();
	            }

	            this.transport.catalog(val);
	            this._mergeState({});// clears current state
	            this._axes = {};
	            this.data([]);
	        },

	        cube: function(val) {
	            if (val === undefined) {
	                return this.transport.cube();
	            }

	            this.transport.cube(val);
	            this._axes = {};
	            this._mergeState({});// clears current state
	            this.data([]);
	        },

	        axes: function() {
	            return this._axes;
	        },

	        columns: function(val) {
	            if (val === undefined) {
	                return this._columns;
	            }

	            this._skipNormalize += 1;
	            this._clearAxesData = true;

	            this._columns = normalizeMembers(val);
	            this.query({
	                columns: val,
	                rows: this.rowsAxisDescriptors(),
	                measures: this.measures(),
	                sort: this.sort(),
	                filter: this.filter()
	            });
	        },

	        rows: function(val) {
	            if (val === undefined) {
	                return this._rows;
	            }

	            this._skipNormalize += 1;
	            this._clearAxesData = true;

	            this._rows = normalizeMembers(val);

	            this.query({
	                columns: this.columnsAxisDescriptors(),
	                rows: val,
	                measures: this.measures(),
	                sort: this.sort(),
	                filter: this.filter()
	            });
	        },

	        measures: function(val) {
	            if (val === undefined) {
	                return this._measures;
	            }

	            this._skipNormalize += 1;
	            this._clearAxesData = true;

	            this.query({
	                columns: this.columnsAxisDescriptors(),
	                rows: this.rowsAxisDescriptors(),
	                measures: normalizeMeasures(val),
	                sort: this.sort(),
	                filter: this.filter()
	            });
	        },

	        measuresAxis: function() {
	            return this._measuresAxis || "columns";
	        },

	        _expandPath: function(path, axis) {
	            var origin = axis === "columns" ? "columns" : "rows";
	            var other = axis === "columns" ? "rows" : "columns";

	            var members = normalizeMembers(path);
	            var memberToExpand = getName(members[members.length - 1]);

	            this._lastExpanded = origin;

	            members = descriptorsForMembers(this.axes()[origin], members, this.measures());

	            for (var idx = 0; idx < members.length; idx++) {
	                var memberName = getName(members[idx]);

	                if (memberName === memberToExpand) {
	                    if (members[idx].expand) {
	                        return;
	                    }
	                    members[idx].expand = true;
	                } else {
	                    members[idx].expand = false;
	                }
	            }

	            var descriptors = {};
	            descriptors[origin] = members;
	            descriptors[other] = this._descriptorsForAxis(other);

	            this._query(descriptors);
	        },

	        _descriptorsForAxis: function(axis) {
	            var axes = this.axes();
	            var descriptors = this[axis]() || [];

	            if (axes && axes[axis] && axes[axis].tuples && axes[axis].tuples[0]) {
	                descriptors = descriptorsForAxes(axes[axis].tuples || []);
	            }
	            return descriptors;
	        },

	        columnsAxisDescriptors: function() {
	            return this._descriptorsForAxis("columns");
	        },

	        rowsAxisDescriptors: function() {
	            return this._descriptorsForAxis("rows");
	        },

	        _process: function (data, e) {
	            this._view = data;

	            e = e || {};
	            e.items = e.items || this._view;

	            this.trigger(CHANGE, e);
	        },

	        _query: function(options) {
	            var that = this;

	            if (!options) {
	                this._skipNormalize += 1;
	                this._clearAxesData = true;
	            }

	            return that.query(extend({}, {
	                page: that.page(),
	                pageSize: that.pageSize(),
	                sort: that.sort(),
	                filter: that.filter(),
	                group: that.group(),
	                aggregate: that.aggregate(),
	                columns: this.columnsAxisDescriptors(),
	                rows: this.rowsAxisDescriptors(),
	                measures: this.measures()
	            }, options));
	        },

	        query: function(options) {
	            var state = this._mergeState(options);

	            if (this._data.length && this.cubeBuilder) {
	                this._params(state);
	                this._updateLocalData(this._pristineData);

	                return $.Deferred().resolve().promise();
	            }

	            return this.read(state);
	        },

	        _mergeState: function(options) {
	            options = DataSource.fn._mergeState.call(this, options);

	            if (options !== undefined) {
	                this._measures = normalizeMeasures(options.measures);

	                if (options.columns) {
	                    options.columns = normalizeMembers(options.columns);
	                } else if (!options.columns) {
	                    this._columns = [];
	                }

	                if (options.rows) {
	                    options.rows = normalizeMembers(options.rows);
	                } else if (!options.rows) {
	                    this._rows = [];
	                }
	            }
	            return options;
	        },

	        filter: function(val) {
	            if (val === undefined) {
	                return this._filter;
	            }

	            this._skipNormalize += 1;
	            this._clearAxesData = true;
	            this._query({ filter: val, page: 1 });
	        },

	        expandColumn: function(path) {
	            this._expandPath(path, "columns");
	        },

	        expandRow: function(path) {
	            this._expandPath(path, "rows");
	        },

	        success: function(data) {
	            var originalData;
	            if (this.cubeBuilder) {
	                originalData = (this.reader.data(data) || []).slice(0);
	            }
	            DataSource.fn.success.call(this, data);
	            if (originalData) {
	                this._pristineData = originalData;
	            }
	        },

	        _processResult: function(data, axes) {
	            if (this.cubeBuilder) {
	                var processedData = this.cubeBuilder.process(data, this._requestData);

	                data = processedData.data;
	                axes = processedData.axes;
	            }

	            var columnIndexes, rowIndexes;
	            var tuples, resultAxis, measures, axisToSkip;
	            var columnDescriptors = this.columns();
	            var rowDescriptors = this.rows();
	            var hasColumnTuples = axes.columns && axes.columns.tuples;

	            if (!columnDescriptors.length && rowDescriptors.length && hasColumnTuples && (this._rowMeasures().length || !this.measures().length)) {
	                axes = {
	                    columns: {},
	                    rows: axes.columns
	                };
	            }

	            if (!columnDescriptors.length && !rowDescriptors.length && this.measuresAxis() === "rows" && hasColumnTuples) {
	                axes = {
	                    columns: {},
	                    rows: axes.columns
	                };
	            }

	            this._axes = {
	                columns: normalizeAxis(this._axes.columns),
	                rows: normalizeAxis(this._axes.rows)
	            };

	            axes = {
	                columns: normalizeAxis(axes.columns),
	                rows: normalizeAxis(axes.rows)
	            };

	            columnIndexes = this._normalizeTuples(axes.columns.tuples, this._axes.columns.tuples, columnDescriptors, this._columnMeasures());
	            rowIndexes = this._normalizeTuples(axes.rows.tuples, this._axes.rows.tuples, rowDescriptors, this._rowMeasures());

	            if (this._skipNormalize > 0) {
	                this._skipNormalize -= 1;
	            }

	            if (!this.cubeBuilder) {
	                data = this._normalizeData({
	                    columnsLength: axes.columns.tuples.length,
	                    rowsLength: axes.rows.tuples.length,
	                    columnIndexes: columnIndexes,
	                    rowIndexes: rowIndexes,
	                    data: data
	                });
	            }

	            if (this._lastExpanded == "rows") {
	                tuples = axes.columns.tuples;
	                measures = this._columnMeasures();
	                resultAxis = validateAxis(axes.columns, this._axes.columns, measures);

	                if (resultAxis) {
	                    axisToSkip = "columns";
	                    axes.columns = resultAxis;
	                    adjustDataByColumn(tuples, resultAxis.tuples, axes.rows.tuples.length, measures, data);
	                    if (!this.cubeBuilder) {
	                        data = this._normalizeData({
	                            columnsLength: membersCount(axes.columns.tuples, measures),
	                            rowsLength: axes.rows.tuples.length,
	                            data: data
	                        });
	                    }
	                }
	            } else if (this._lastExpanded == "columns") {
	                tuples = axes.rows.tuples;
	                measures = this._rowMeasures();
	                resultAxis = validateAxis(axes.rows, this._axes.rows, measures);

	                if (resultAxis) {
	                    axisToSkip = "rows";
	                    axes.rows = resultAxis;
	                    adjustDataByRow(tuples, resultAxis.tuples, axes.columns.tuples.length, measures, data);

	                    if (!this.cubeBuilder) {
	                        data = this._normalizeData({
	                            columnsLength: membersCount(axes.rows.tuples, measures),
	                            rowsLength: axes.columns.tuples.length,
	                            data: data
	                        });
	                    }
	                }
	            }

	            this._lastExpanded = null;

	            var result = this._mergeAxes(axes, data, axisToSkip);
	            this._axes = result.axes;

	            return result.data;
	        },

	        _readData: function(data) {
	            var axes = this.reader.axes(data);
	            var newData = this.reader.data(data);

	            if (this.cubeBuilder) {
	                this._rawData = newData;
	            }

	            return this._processResult(newData, axes);
	        },

	        _createTuple: function(tuple, measure, buildRoot) {
	            var members = tuple.members;
	            var length = members.length;
	            var root = { members: [] };
	            var levelName, levelNum;
	            var name, parentName;
	            var hasChildren;
	            var hierarchy;
	            var caption;
	            var member;
	            var idx = 0;

	            if (measure) {
	                length -= 1;
	            }

	            for (; idx < length; idx++) {
	                member = members[idx];
	                levelNum = Number(member.levelNum);

	                name = member.name;
	                parentName = member.parentName;
	                caption = member.caption || name;
	                hasChildren = member.hasChildren;
	                hierarchy = member.hierarchy;
	                levelName = member.levelName;

	                if (buildRoot) {
	                    caption = "All";
	                    if (levelNum === 0) {
	                        parentName = member.name;
	                    } else {
	                        levelNum -= 1;
	                    }

	                    hasChildren = true;
	                    name = hierarchy = levelName = parentName;
	                }

	                root.members.push({
	                    name: name,
	                    children: [],
	                    caption: caption,
	                    levelName: levelName,
	                    levelNum: levelNum.toString(),
	                    hasChildren: hasChildren,
	                    hierarchy: hierarchy,
	                    parentName: !buildRoot ? parentName: ""
	                });
	            }

	            if (measure) {
	                root.members.push({
	                    name: measure.name,
	                    children: []
	                });
	            }

	            return root;
	        },

	        _hasRoot: function(target, source, descriptors) {
	            if (source.length) {
	                return findExistingTuple(source, target).tuple;
	            }

	            var members = target.members;
	            var member;
	            var descriptor;

	            var isRoot = true;
	            var levelNum;

	            for (var idx = 0, length = members.length; idx < length; idx++) {
	                member = members[idx];
	                levelNum = Number(member.levelNum) || 0;
	                descriptor = descriptors[idx];

	                if (!(levelNum === 0 || (descriptor && member.name === getName(descriptor)))) {
	                    isRoot = false;
	                    break;
	                }
	            }

	            return isRoot;
	        },

	        _mergeAxes: function(sourceAxes, data, axisToSkip) {
	            var columnMeasures = this._columnMeasures();
	            var rowMeasures = this._rowMeasures();
	            var axes = this.axes();
	            var startIndex, tuples;

	            var oldRowsLength = membersCount(axes.rows.tuples, rowMeasures);
	            var newRowsLength = sourceAxes.rows.tuples.length;

	            var oldColumnsLength = membersCount(axes.columns.tuples, columnMeasures);
	            var newColumnsLength = sourceAxes.columns.tuples.length;

	            if (axisToSkip == "columns") {
	                newColumnsLength = oldColumnsLength;
	                tuples = sourceAxes.columns.tuples;
	            } else {
	                tuples = parseSource(sourceAxes.columns.tuples, columnMeasures);
	                data = prepareDataOnColumns(tuples, data);
	            }

	            var mergedColumns = mergeTuples(axes.columns.tuples, tuples, columnMeasures);

	            if (axisToSkip == "rows") {
	                newRowsLength = membersCount(sourceAxes.rows.tuples, rowMeasures);
	                tuples = sourceAxes.rows.tuples;
	            } else {
	                tuples = parseSource(sourceAxes.rows.tuples, rowMeasures);
	                data = prepareDataOnRows(tuples, data);
	            }
	            var mergedRows = mergeTuples(axes.rows.tuples, tuples, rowMeasures);

	            axes.columns.tuples = mergedColumns.tuples;
	            axes.rows.tuples = mergedRows.tuples;

	            if (oldColumnsLength !== membersCount(axes.columns.tuples, columnMeasures)) {
	                //columns are expanded
	                startIndex = mergedColumns.index + findDataIndex(mergedColumns.parsedRoot, mergedColumns.memberIndex, columnMeasures);
	                var offset = oldColumnsLength + newColumnsLength;
	                data = this._mergeColumnData(data, startIndex, newRowsLength, newColumnsLength, offset);
	            } else if (oldRowsLength !== membersCount(axes.rows.tuples, rowMeasures)) {
	                //rows are expanded
	                startIndex = mergedRows.index + findDataIndex(mergedRows.parsedRoot, mergedRows.memberIndex, rowMeasures);
	                data = this._mergeRowData(data, startIndex, newRowsLength, newColumnsLength);
	            }

	            if (axes.columns.tuples.length === 0 && axes.rows.tuples.length === 0) {
	                data = [];
	            }

	            return {
	                axes: axes,
	                data: data
	            };
	        },

	        _mergeColumnData: function(newData, columnIndex, rowsLength, columnsLength, offset) {
	            var data = this.data().toJSON();
	            var rowIndex, index, drop = 0, toAdd;
	            var columnMeasures = Math.max(this._columnMeasures().length, 1);

	            rowsLength = Math.max(rowsLength, 1);

	            if (data.length > 0) {
	                //if there is already data, drop the first new data item
	                drop = columnMeasures;
	                offset -= columnMeasures;
	            }

	            for (rowIndex = 0; rowIndex < rowsLength; rowIndex++) {
	                index = columnIndex + (rowIndex * offset);
	                toAdd = newData.splice(0, columnsLength);
	                toAdd.splice(0, drop);
	                [].splice.apply(data, [index, 0].concat(toAdd));
	            }

	            return data;
	        },

	        _mergeRowData: function(newData, rowIndex, rowsLength, columnsLength) {
	            var data = this.data().toJSON();
	            var idx, dataIndex, toAdd;
	            var rowMeasures = Math.max(this._rowMeasures().length, 1);

	            columnsLength = Math.max(columnsLength, 1);
	            if (data.length > 0) {
	                //if there is already data, drop the first new data item
	                rowsLength -= rowMeasures;
	                newData.splice(0, columnsLength * rowMeasures);
	            }

	            for (idx = 0; idx < rowsLength; idx++) {
	                toAdd = newData.splice(0, columnsLength);
	                dataIndex = (rowIndex * columnsLength) + (idx * columnsLength);
	                [].splice.apply(data, [dataIndex, 0].concat(toAdd));
	            }

	            return data;
	        },

	        _columnMeasures: function() {
	            var measures = this.measures();
	            var columnMeasures = [];

	            if (this.measuresAxis() === "columns") {
	                if (this.columns().length === 0) {
	                    columnMeasures = measures;
	                } else if (measures.length > 1) {
	                    columnMeasures = measures;
	                }
	            }

	            return columnMeasures;
	        },

	        _rowMeasures: function() {
	            var measures = this.measures();
	            var rowMeasures = [];

	            if (this.measuresAxis() === "rows") {
	                if (this.rows().length === 0) {
	                    rowMeasures = measures;
	                } else if (measures.length > 1) {
	                    rowMeasures = measures;
	                }
	            }

	            return rowMeasures;
	        },

	        _updateLocalData: function(data, state) {
	            if (this.cubeBuilder) {
	                if (state) {
	                    this._requestData = state;
	                }
	                data = this._processResult(data);
	            }

	            this._data = this._observe(data);

	            this._ranges = [];
	            this._addRange(this._data);

	            this._total = this._data.length;
	            this._pristineTotal = this._total;
	            this._process(this._data);
	        },

	        data: function(value) {
	            var that = this;
	            if (value !== undefined) {
	                this._pristineData = value.slice(0);
	                this._updateLocalData(value, {
	                        columns: this.columns(),
	                        rows: this.rows(),
	                        measures: this.measures()
	                    });
	            } else {
	                return that._data;
	            }
	        },

	        _normalizeTuples: function(tuples, source, descriptors, measures) {
	            var length = measures.length || 1;
	            var idx = 0;

	            var roots = [];
	            var indexes = {};
	            var measureIdx = 0;
	            var tuple, memberIdx, last;

	            if (!tuples.length) {
	                return;
	            }

	            if (this._skipNormalize <= 0 && !this._hasRoot(tuples[0], source, descriptors)) {
	                this._skipNormalize = 0;
	                for (; idx < length; idx++) {
	                    roots.push(this._createTuple(tuples[0], measures[idx], true));
	                    indexes[idx] = idx;
	                }

	                tuples.splice.apply(tuples, [0, tuples.length].concat(roots).concat(tuples));
	                idx = length;
	            }

	            if (measures.length) {
	                last = tuple = tuples[idx];
	                memberIdx = tuple.members.length - 1;

	                while (tuple) {
	                    if (measureIdx >= length) {
	                        measureIdx = 0;
	                    }

	                    if (tuple.members[memberIdx].name !== measures[measureIdx].name) {
	                        tuples.splice(idx, 0, this._createTuple(tuple, measures[measureIdx]));
	                        indexes[idx] = idx;
	                    }

	                    idx += 1;
	                    measureIdx += 1;
	                    tuple = tuples[idx];

	                    if (length > measureIdx && (!tuple || tupleName(last, memberIdx - 1) !== tupleName(tuple, memberIdx - 1))) {
	                        for (; measureIdx < length; measureIdx++) {
	                            tuples.splice(idx, 0, this._createTuple(last, measures[measureIdx]));
	                            indexes[idx] = idx;
	                            idx += 1;
	                        }
	                        tuple = tuples[idx];
	                    }
	                    last = tuple;
	                }
	            }

	            return indexes;
	        },

	        _addMissingDataItems: function(result, metadata) {
	            while (metadata.rowIndexes[parseInt(result.length / metadata.columnsLength, 10)] !== undefined) {
	                for (var idx = 0; idx < metadata.columnsLength; idx++) {
	                    result = addEmptyDataItem(result);
	                }
	            }

	            while (metadata.columnIndexes[result.length % metadata.columnsLength] !== undefined) {
	                result = addEmptyDataItem(result);
	            }

	            return result;
	        },

	        _normalizeOrdinals: function(result, dataItem, metadata) {
	            var lastOrdinal = metadata.lastOrdinal;

	            if (!dataItem) {
	                return addEmptyDataItem(result);
	            }

	            if ((dataItem.ordinal - lastOrdinal) > 1) {
	                lastOrdinal += 1;

	                while (lastOrdinal < dataItem.ordinal && result.length < metadata.length) {
	                    result = this._addMissingDataItems(addEmptyDataItem(result), metadata);
	                    lastOrdinal += 1;
	                }
	            }

	            dataItem.ordinal = result.length;
	            result[result.length] = dataItem;

	            return result;
	        },

	        _normalizeData: function(options) {
	            var data = options.data;
	            var dataIdx = 0;
	            var dataItem;
	            var result = [];
	            var lastOrdinal;
	            var length;

	            options.lastOrdinal = 0;
	            options.columnIndexes = options.columnIndexes || {};
	            options.rowIndexes = options.rowIndexes || {};
	            options.columnsLength = options.columnsLength || 1;
	            options.rowsLength = options.rowsLength || 1;
	            options.length = options.columnsLength * options.rowsLength;
	            length = options.length;

	            if (data.length === length) {
	                return data;
	            }

	            while(result.length < length) {
	                dataItem = data[dataIdx++];
	                if (dataItem) {
	                    lastOrdinal = dataItem.ordinal;
	                }

	                result = this._normalizeOrdinals(this._addMissingDataItems(result, options), dataItem, options);

	                options.lastOrdinal = lastOrdinal;
	            }

	            return result;
	        },

	        discover: function(options, converter) {
	            var that = this,
	                transport = that.transport;

	            return $.Deferred(function(deferred) {
	                transport.discover(extend({
	                    success: function(response) {
	                       response = that.reader.parse(response);

	                        if (that._handleCustomErrors(response)) {
	                            return;
	                        }

	                        if (converter) {
	                            response = converter(response);
	                        }
	                        deferred.resolve(response);
	                    },
	                    error: function(response, status, error) {
	                        deferred.reject(response);
	                        that.error(response, status, error);
	                    }
	                }, options));
	            }).promise().done(function() {
	                that.trigger("schemaChange");
	            });
	        },

	        schemaMeasures: function() {
	            var that = this;

	            return that.discover({
	                data: {
	                    command: "schemaMeasures",
	                    restrictions: {
	                        catalogName: that.transport.catalog(),
	                        cubeName: that.transport.cube()
	                    }
	                }
	            }, function(response) {
	                return that.reader.measures(response);
	            });
	        },

	        schemaKPIs: function() {
	            var that = this;

	            return that.discover({
	                data: {
	                    command: "schemaKPIs",
	                    restrictions: {
	                        catalogName: that.transport.catalog(),
	                        cubeName: that.transport.cube()
	                    }
	                }
	            }, function(response) {
	                return that.reader.kpis(response);
	            });
	        },

	        schemaDimensions: function() {
	            var that = this;

	            return that.discover({
	                data: {
	                    command: "schemaDimensions",
	                    restrictions: {
	                        catalogName: that.transport.catalog(),
	                        cubeName: that.transport.cube()
	                    }
	                }
	            }, function(response) {
	                return that.reader.dimensions(response);
	            });
	        },

	        schemaHierarchies: function(dimensionName) {
	            var that = this;

	            return that.discover({
	                data: {
	                    command: "schemaHierarchies",
	                    restrictions: {
	                        catalogName: that.transport.catalog(),
	                        cubeName: that.transport.cube(),
	                        dimensionUniqueName: dimensionName
	                    }
	                }
	            }, function(response) {
	                return that.reader.hierarchies(response);
	            });
	        },

	        schemaLevels: function(hierarchyName) {
	            var that = this;

	            return that.discover({
	                data: {
	                    command: "schemaLevels",
	                    restrictions: {
	                        catalogName: that.transport.catalog(),
	                        cubeName: that.transport.cube(),
	                        hierarchyUniqueName: hierarchyName
	                    }
	                }
	            }, function(response) {
	                return that.reader.levels(response);
	            });
	        },

	        schemaCubes: function() {
	            var that = this;

	            return that.discover({
	                data: {
	                    command: "schemaCubes",
	                    restrictions: {
	                        catalogName: that.transport.catalog()
	                    }
	                }
	            }, function(response) {
	                return that.reader.cubes(response);
	            });
	        },

	        schemaCatalogs: function() {
	            var that = this;

	            return that.discover({
	                data: {
	                    command: "schemaCatalogs"
	                }
	            }, function(response) {
	                return that.reader.catalogs(response);
	            });
	        },

	        schemaMembers: function(restrictions) {
	            var that = this;
	            var success = (function(restrictions) {
	                return function(response) {
	                    return that.reader.members(response, restrictions);
	                };
	            }(restrictions));

	            return that.discover({
	                data: {
	                    command: "schemaMembers",
	                    restrictions: extend({
	                       catalogName: that.transport.catalog(),
	                       cubeName: that.transport.cube()
	                   }, restrictions)
	                }
	            }, success);
	        },

	        _params: function(data) {
	            if (this._clearAxesData) {
	                this._axes = {};
	                this._data = this._observe([]);
	                this._clearAxesData = false;
	                this.trigger(STATERESET);
	            }

	            var options = DataSource.fn._params.call(this, data);

	            options = extend({
	                measures: this.measures(),
	                measuresAxis: this.measuresAxis(),
	                columns: this.columns(),
	                rows: this.rows()
	            }, options);

	            if (this.cubeBuilder) {
	                this._requestData = options;
	            }

	            return options;
	        }
	    });

	    function flatColumns(columns) {
	        var result = [];
	        for (var idx = 0; idx < columns.length; idx++) {
	            result.push(columns[idx]);
	            if (columns[idx].children) {
	                result = result.concat(flatColumns(columns[idx].children));
	            }
	        }

	        return result;
	    }

	    function sortItemsTree(field, items, sortFunction) {
	        for(var i = 0; i < items.length; i++) {
	            if (items[i].children && items[i].children.length) {
	                sortItemsTree(field, items[i].children, sortFunction);
	            }
	        }
	        if (items[0].parentName != field) {
	            return;
	        }
	        items = items.sort(sortFunction);
	    }

	    function fillSortTree(items, map) {
	        for (var i = 0; i < items.length; i++) {
	            var currentItem = map[items[i].name];

	            if (!$.isEmptyObject(currentItem.childrenMap)) {
	                items[i].children = [];
	                for (var name in currentItem.childrenMap) {
	                    items[i].children.push($.extend({}, { name :name, parentName: map[name].parentName }));
	                }

	                fillSortTree(items[i].children, map);
	            }
	        }
	    }

	    function addEmptyDataItem(result) {
	        result[result.length] = { value: "", fmtValue: "", ordinal: result.length };
	        return result;
	    }

	    function validateAxis(newAxis, axis, measures) {
	        if (newAxis.tuples.length < membersCount(axis.tuples, measures)) {

	            return axis;
	        }

	        return;
	    }

	    function adjustDataByColumn(sourceTuples, targetTuples, rowsLength, measures, data) {
	        var columnIdx, rowIdx, dataIdx;
	        var columnsLength = sourceTuples.length;
	        var targetColumnsLength = membersCount(targetTuples, measures);
	        var measuresLength = measures.length || 1;

	        for (rowIdx = 0; rowIdx < rowsLength; rowIdx++) {
	            for (columnIdx = 0; columnIdx < columnsLength; columnIdx++) {
	                dataIdx = tupleIndex(sourceTuples[columnIdx], targetTuples) * measuresLength;
	                dataIdx += columnIdx % measuresLength;

	                data[rowIdx * columnsLength + columnIdx].ordinal = rowIdx * targetColumnsLength + dataIdx;
	            }
	        }
	    }

	    function adjustDataByRow(sourceTuples, targetTuples, columnsLength, measures, data) {
	        var columnIdx, rowIdx, dataIdx;
	        var rowsLength = sourceTuples.length;
	        var measuresLength = measures.length || 1;

	        for (rowIdx = 0; rowIdx < rowsLength; rowIdx++) {
	            dataIdx = tupleIndex(sourceTuples[rowIdx], targetTuples);
	            dataIdx *= measuresLength;
	            dataIdx += rowIdx % measuresLength;

	            for (columnIdx = 0; columnIdx < columnsLength; columnIdx++) {
	                data[rowIdx * columnsLength + columnIdx].ordinal = dataIdx * columnsLength + columnIdx;
	            }
	        }
	    }

	    function tupleIndex(tuple, collection) {
	        return findExistingTuple(collection, tuple).index;
	    }

	    function membersCount(tuples, measures) {
	        if (!tuples.length) {
	            return 0;
	        }

	        var queue = tuples.slice();
	        var current = queue.shift();
	        var result = 1;

	        while (current) {
	            if (current.members) {
	                [].push.apply(queue, current.members);
	            } else if (current.children) {
	                if (!current.measure) {
	                    result += current.children.length;
	                }
	                [].push.apply(queue, current.children);
	            }

	            current = queue.shift();
	        }

	        if (measures.length) {
	            result = result * measures.length;
	        }

	        return result;
	    }

	    function normalizeAxis(axis) {
	        if (!axis) {
	            axis = {
	                tuples: []
	            };
	        }

	        if (!axis.tuples) {
	            axis.tuples = [];
	        }

	        return axis;
	    }

	    function findDataIndex(tuple, memberIndex, measures) {
	        if (!tuple) {
	            return 0;
	        }

	        var measuresLength = Math.max(measures.length, 1);
	        var tuples = tuple.members.slice(0, memberIndex);
	        var current = tuples.shift();

	        //the initial value is equal to the total number of measures
	        //as the measures member is not extracted from the members of the starting tuple
	        //but should be calculated in the final result
	        var counter = measuresLength;

	        while (current) {
	            if (current.name === MEASURES) {
	                //subtract 1 as the measures member has been already counted as a single standard member
	                //but we are interested in the total number of measures instead
	                counter += (measuresLength - 1);
	            } else if (current.children) {
	                //is member
	                [].push.apply(tuples, current.children);
	            } else {
	                //is tuple
	                counter ++;
	                [].push.apply(tuples, current.members);
	            }

	            current = tuples.shift();
	        }

	        return counter;
	    }

	    function mergeTuples(target, source, measures) {
	        if (!source[0]) {
	            return {
	                parsedRoot: null,
	                tuples: target,
	                memberIndex: 0,
	                index: 0
	            };
	        }

	        var result = findExistingTuple(target, source[0]);

	        if (!result.tuple) {
	            return {
	                parsedRoot: null,
	                tuples: source,
	                memberIndex: 0,
	                index: 0
	            };
	        }

	        var targetMembers = result.tuple.members;
	        var sourceMembers = source[0].members;
	        var memberIndex = -1;

	        if (targetMembers.length !== sourceMembers.length) {
	            return {
	                parsedRoot: null,
	                tuples: source,
	                memberIndex: 0,
	                index: 0
	            };
	        }

	        for (var idx = 0, length = targetMembers.length; idx < length; idx++) {
	            if (!targetMembers[idx].measure && sourceMembers[idx].children[0]) {
	                if (memberIndex == -1 && sourceMembers[idx].children.length) {
	                    memberIndex = idx;
	                }

	                targetMembers[idx].children = sourceMembers[idx].children;
	            }
	        }

	        measures = Math.max(measures.length, 1);

	        return {
	            parsedRoot: result.tuple,
	            index: result.index * measures,
	            memberIndex: memberIndex,
	            tuples: target
	        };
	    }

	    function equalTuples(first, second) {
	        var equal = true;
	        var idx, length;

	        first = first.members;
	        second = second.members;

	        for (idx = 0, length = first.length; idx < length; idx++) {
	            if (first[idx].measure || second[idx].measure) {
	                continue;
	            }

	            equal = equal && (getName(first[idx]) === getName(second[idx]));
	        }

	        return equal;
	    }

	    function findExistingTuple(tuples, toFind) {
	        var idx, length, tuple, found, counter = 0;
	        var memberIndex, membersLength, member;

	        for (idx = 0, length = tuples.length; idx < length; idx++) {
	            tuple = tuples[idx];
	            if (equalTuples(tuple, toFind)) {
	                return {
	                    tuple: tuple,
	                    index: counter
	                };
	            }

	            counter ++;

	            for (memberIndex = 0, membersLength = tuple.members.length; memberIndex < membersLength; memberIndex++) {
	                member = tuple.members[memberIndex];
	                if (member.measure) {
	                    //counter += member.children.length;
	                    continue;
	                }
	                found = findExistingTuple(member.children, toFind);
	                counter += found.index;
	                if (found.tuple) {
	                    return {
	                        tuple: found.tuple,
	                        index: counter
	                    };
	                }
	            }
	        }

	        return {
	            index: counter
	        };
	    }

	    function addMembers(members, map) {
	        var member, i, len, path = "";
	        for (i = 0, len = members.length; i < len; i++) {
	            member = members[i];
	            path += member.name;
	            if (!map[path]) {
	                map[path] = member;
	            }
	        }
	    }


	    function findParentMember(tuple, map) {
	        var members = tuple.members;
	        var i, len, member, path = "";
	        var parentPath = "";
	        var parentMember;

	        for (i = 0, len = members.length; i < len; i++) {
	            member = members[i];
	            if (parentMember) {
	                if (map[path + member.name]) {
	                    path += member.name;
	                    parentMember = map[path];
	                    continue;
	                } else if (map[path + member.parentName]) {
	                    return map[path + member.parentName];
	                } else if (map[parentPath + member.parentName]) {
	                    return map[parentPath + member.parentName];
	                } else {
	                    return map[parentPath];
	                }
	            }

	            path += member.name;
	            parentMember = map[member.parentName];

	            if (!parentMember) {
	                parentMember = map[path];
	                if (!parentMember) {
	                    return null;
	                }
	            }

	            if (parentMember) {
	                parentPath += parentMember.name;
	            }
	        }

	        return parentMember;
	    }

	    function measurePosition(tuple, measures) {
	        if (measures.length === 0) {
	            return -1;
	        }

	        var measure = measures[0];
	        var members = tuple.members;
	        for (var idx = 0, len = members.length; idx < len; idx ++) {
	            if (members[idx].name == measure.name) {
	                return idx;
	            }
	        }
	    }

	    function normalizeTupleMeasures(tuple, index) {
	        if (index < 0) {
	            return;
	        }
	        var member = {
	            name: MEASURES,
	            measure: true,
	            children: [
	                $.extend({ members: [], dataIndex: tuple.dataIndex }, tuple.members[index])
	            ]
	        };
	        tuple.members.splice(index, 1, member);
	        tuple.dataIndex = undefined;
	    }

	    function parseSource(tuples, measures) {
	        if (tuples.length < 1) {
	            return [];
	        }
	        var result = [];
	        var map = { };
	        var measureIndex = measurePosition(tuples[0], measures);

	        for (var i = 0; i < tuples.length; i++) {
	            var tuple = tuples[i];

	            //keep the old data index of the tuple
	            tuple.dataIndex = i;

	            normalizeTupleMeasures(tuple, measureIndex);
	            var parentMember = findParentMember(tuple, map);

	            if (parentMember) {
	                if (measureIndex < 0 || !parentMember.measure) {
	                    parentMember.children.push(tuple);
	                } else {
	                    parentMember.children.push(tuple.members[measureIndex].children[0]);
	                }
	            } else {
	                result.push(tuple);
	            }

	            addMembers(tuple.members, map);
	        }

	        return result;
	    }

	    function prepareDataOnRows(tuples, data) {
	        if (!tuples || !tuples.length) {
	            return data;
	        }

	        var result = [];
	        var indices = buildDataIndices(tuples);
	        var rowsLength = indices.length;
	        var columnsLength = Math.max(data.length / rowsLength, 1);
	        var rowIndex, columnIndex, targetIndex, sourceIndex;
	        var calcIndex;

	        for (rowIndex = 0; rowIndex < rowsLength; rowIndex++) {
	            targetIndex = columnsLength * rowIndex;
	            sourceIndex = columnsLength * indices[rowIndex];
	            for (columnIndex = 0; columnIndex < columnsLength; columnIndex++) {
	                calcIndex = parseInt(sourceIndex + columnIndex, 10);
	                result[parseInt(targetIndex + columnIndex, 10)] = data[calcIndex] || { value: "", fmtValue: "", ordinal: calcIndex };
	            }
	        }

	        return result;
	    }

	    function prepareDataOnColumns(tuples, data) {
	        if (!tuples || !tuples.length) {
	            return data;
	        }

	        var result = [];
	        var indices = buildDataIndices(tuples);
	        var columnsLength = indices.length;
	        var rowsLength = Math.max(data.length / columnsLength, 1);
	        var columnIndex, rowIndex, dataIndex, calcIndex;

	        for (rowIndex = 0; rowIndex < rowsLength; rowIndex++) {
	            dataIndex = columnsLength * rowIndex;
	            for (columnIndex = 0; columnIndex < columnsLength; columnIndex++) {
	                calcIndex = indices[columnIndex] + dataIndex;
	                result[dataIndex + columnIndex] = data[calcIndex] || { value: "", fmtValue: "", ordinal: calcIndex };
	            }
	        }

	        return result;
	    }

	    function buildDataIndices(tuples) {
	        tuples = tuples.slice();
	        var result = [];
	        var tuple = tuples.shift();
	        var idx, length, spliceIndex, children, member;

	        while (tuple) {
	            //required for multiple measures
	            if (tuple.dataIndex !== undefined) {
	                result.push(tuple.dataIndex);
	            }

	            spliceIndex = 0;
	            for (idx = 0, length = tuple.members.length; idx < length; idx++) {
	                member = tuple.members[idx];
	                children = member.children;
	                if (member.measure) {
	                    [].splice.apply(tuples, [0, 0].concat(children));
	                } else {
	                    [].splice.apply(tuples, [spliceIndex, 0].concat(children));
	                }
	                spliceIndex += children.length;
	            }

	            tuple = tuples.shift();
	        }

	        return result;
	    }

	    PivotDataSource.create = function(options) {
	        options = options && options.push ? { data: options } : options;

	        var dataSource = options || {},
	            data = dataSource.data;

	        dataSource.data = data;

	        if (!(dataSource instanceof PivotDataSource) && dataSource instanceof kendo.data.DataSource) {
	            throw new Error("Incorrect DataSource type. Only PivotDataSource instances are supported");
	        }

	        return dataSource instanceof PivotDataSource ? dataSource : new PivotDataSource(dataSource);
	    };

	    function baseHierarchyPath(memberName) {
	        var parts = memberName.split(".");
	        if (parts.length > 2) {
	            return parts[0] + "." + parts[1];
	        }
	        return memberName;
	    }

	    function expandMemberDescriptor(names, sort) {
	        var idx = names.length - 1;
	        var name = names[idx];
	        var sortDescriptor;

	        sortDescriptor = sortDescriptorForMember(sort, name);

	        if (sortDescriptor && sortDescriptor.dir) {
	            name = "ORDER(" + name + ".Children," + sortDescriptor.field + ".CurrentMember.MEMBER_CAPTION," + sortDescriptor.dir + ")";
	        } else {
	            name += ".Children";
	        }

	        names[idx] = name;

	        return names;
	    }

	    function sortDescriptorForMember(sort, member) {
	        for (var idx = 0, length = sort.length; idx < length; idx++) {
	            if (member.indexOf(sort[idx].field) === 0) {
	                return sort[idx];
	            }
	        }
	        return null;
	    }

	    function crossJoin(names) {
	        var result = "CROSSJOIN({";
	        var r;

	        if (names.length > 2) {
	            r = names.pop();
	            result += crossJoin(names);
	        } else {
	            result += names.shift();
	            r = names.pop();
	        }

	        result += "},{";
	        result += r;
	        result += "})";
	        return result;
	    }

	    function crossJoinCommand(members, measures) {
	        var tmp = members.slice(0);

	        if (measures.length > 1) {
	            tmp.push("{" + measureNames(measures).join(",") + "}");
	        }

	        return crossJoin(tmp);
	    }

	    function measureNames(measures) {
	        var idx = 0;
	        var length = measures.length;
	        var result = [];
	        var measure;

	        for (; idx < length; idx++) {
	            measure = measures[idx];
	            result.push(measure.name !== undefined ? measure.name :  measure);
	        }

	        return result;
	    }

	    function getName(name) {
	        name = name.name || name;

	        if (toString.call(name) === "[object Array]") {
	            name = name[name.length - 1];
	        }

	        return name;
	    }

	    function getRootNames(members) {
	        var length = members.length;
	        var names = [];
	        var idx = 0;

	        for (; idx < length; idx++) {
	            names.push(members[idx].name[0]);
	        }

	        return names;
	    }

	    function mapNames(names, rootNames) {
	        var name;
	        var rootName;

	        var j;
	        var idx = 0;
	        var length = names.length;
	        var rootLength = rootNames.length;

	        rootNames = rootNames.slice(0);

	        for (; idx < length; idx++) {
	            name = names[idx];

	            for (j = 0; j < rootLength; j++) {
	                rootName = baseHierarchyPath(rootNames[j]);

	                if (name.indexOf(rootName) !== -1) {
	                    rootNames[j] = name;
	                    break;
	                }
	            }
	        }

	        return {
	            names: rootNames,
	            expandedIdx: j,
	            uniquePath: rootNames.slice(0, j + 1).join("")
	        };
	    }

	    function parseDescriptors(members) {
	        var expanded = [];
	        var child = [];
	        var root = [];
	        var member;

	        var j, l;
	        var idx = 0;
	        var length = members.length;

	        var name;
	        var hierarchyName;

	        var found;

	        for (; idx < length; idx++) {
	            member = members[idx];
	            name = member.name;
	            found = false;

	            if (toString.call(name) !== "[object Array]") {
	                member.name = name = [name];
	            }

	            if (name.length > 1) {
	                child.push(member);
	            } else {
	                hierarchyName = baseHierarchyPath(name[0]);

	                for (j = 0, l = root.length; j < l; j++) {
	                    if (root[j].name[0].indexOf(hierarchyName) === 0) {
	                        found = true;
	                        break;
	                    }
	                }

	                if (!found) {
	                    root.push(member);
	                }

	                if (member.expand) {
	                    expanded.push(member);
	                }
	            }
	        }

	        expanded = expanded.concat(child);

	        return {
	            root: root,
	            expanded: expanded
	        };
	    }

	    function serializeMembers(members, measures, sort) {
	        var command = "";

	        members = members || [];

	        var expanded = parseDescriptors(members);
	        var root = expanded.root;

	        var rootNames = getRootNames(root);
	        var crossJoinCommands = [];

	        expanded = expanded.expanded;

	        var length = expanded.length;
	        var idx = 0;

	        var memberName;
	        var names = [];

	        if (rootNames.length > 1 || measures.length > 1) {
	            crossJoinCommands.push(crossJoinCommand(rootNames, measures));

	            for (; idx < length; idx++) {
	                memberName = expandMemberDescriptor(expanded[idx].name, sort);
	                names = mapNames(memberName, rootNames).names;

	                crossJoinCommands.push(crossJoinCommand(names, measures));
	            }

	            command += crossJoinCommands.join(",");
	        } else {
	            for (; idx < length; idx++) {
	                memberName = expandMemberDescriptor(expanded[idx].name, sort);
	                names.push(memberName[0]); //check if this is ok
	            }

	            command += rootNames.concat(names).join(",");
	        }

	        return command;
	    }

	    var filterFunctionFormats = {
	        contains: ", InStr({0}.CurrentMember.MEMBER_CAPTION,\"{1}\") > 0",
	        doesnotcontain: ", InStr({0}.CurrentMember.MEMBER_CAPTION,\"{1}\")",
	        startswith: ", Left({0}.CurrentMember.MEMBER_CAPTION,Len(\"{1}\"))=\"{1}\"",
	        endswith: ", Right({0}.CurrentMember.MEMBER_CAPTION,Len(\"{1}\"))=\"{1}\"",
	        eq: ", {0}.CurrentMember.MEMBER_CAPTION = \"{1}\"",
	        neq: ", {0}.CurrentMember.MEMBER_CAPTION = \"{1}\""
	    };

	    function serializeExpression(expression) {
	        var command = "";
	        var value = expression.value;
	        var field = expression.field;
	        var operator = expression.operator;

	        if (operator == "in") {
	            command += "{";
	            command += value;
	            command += "}";
	        } else {
	            command += operator == "neq" || operator == "doesnotcontain" ? "-" : "";
	            command += "Filter(";
	            command += field + ".MEMBERS";
	            command += kendo.format(filterFunctionFormats[operator], field, value);
	            command += ")";
	        }

	        return command;
	    }

	    function serializeFilters(filter, cube) {
	        var command = "", current;
	        var filters = filter.filters;
	        var length = filters.length;
	        var idx;

	        for (idx = length - 1; idx >= 0; idx--) {

	            current = "SELECT (";
	            current += serializeExpression(filters[idx]);
	            current += ") ON 0";

	            if (idx == length - 1) {
	                current += " FROM [" + cube + "]";
	                command = current;
	            } else {
	                command = current + " FROM ( " + command + " )";
	            }
	        }

	        return command;
	    }

	    function serializeOptions(parentTagName, options, capitalize) {
	        var result = "";

	        if (options) {
	            result += "<" + parentTagName + ">";
	            var value;
	            for (var key in options) {
	                value = options[key] ;
	                if (capitalize) {
	                    key = key.replace(/([A-Z]+(?=$|[A-Z][a-z])|[A-Z]?[a-z]+)/g, "$1_").toUpperCase().replace(/_$/, "");
	                }
	                result += "<" + key + ">" + value + "</" + key + ">";
	            }
	            result += "</" + parentTagName + ">";
	        } else {
	            result += "<" + parentTagName + "/>";
	        }
	        return result;
	    }

	    var xmlaDiscoverCommands = {
	        schemaCubes: "MDSCHEMA_CUBES",
	        schemaCatalogs: "DBSCHEMA_CATALOGS",
	        schemaMeasures: "MDSCHEMA_MEASURES",
	        schemaDimensions: "MDSCHEMA_DIMENSIONS",
	        schemaHierarchies: "MDSCHEMA_HIERARCHIES",
	        schemaLevels: "MDSCHEMA_LEVELS",
	        schemaMembers: "MDSCHEMA_MEMBERS",
	        schemaKPIs: "MDSCHEMA_KPIS"
	    };

	    var convertersMap = {
	        read: function(options) {
	            var command = '<Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/"><Header/><Body><Execute xmlns="urn:schemas-microsoft-com:xml-analysis"><Command><Statement>';

	            command += "SELECT NON EMPTY {";

	            var columns = options.columns || [];
	            var rows = options.rows || [];

	            var measures = options.measures || [];
	            var measuresRowAxis = options.measuresAxis === "rows";
	            var sort = options.sort || [];

	            if (!columns.length && rows.length && (!measures.length || (measures.length && measuresRowAxis))) {
	                columns = rows;
	                rows = [];
	                measuresRowAxis = false;
	            }

	            if (!columns.length && !rows.length) {
	                measuresRowAxis = false;
	            }

	            if (columns.length) {
	                command += serializeMembers(columns, !measuresRowAxis ? measures : [], sort);
	            } else if (measures.length && !measuresRowAxis) {
	                command += measureNames(measures).join(",");
	            }

	            command += "} DIMENSION PROPERTIES CHILDREN_CARDINALITY, PARENT_UNIQUE_NAME ON COLUMNS";

	            if (rows.length || (measuresRowAxis && measures.length > 1)) {
	                command += ", NON EMPTY {";

	                if (rows.length) {
	                    command += serializeMembers(rows, measuresRowAxis ? measures : [], sort);
	                } else {
	                    command += measureNames(measures).join(",");
	                }

	                command += "} DIMENSION PROPERTIES CHILDREN_CARDINALITY, PARENT_UNIQUE_NAME ON ROWS";
	            }

	            if (options.filter) {
	                command += " FROM ";
	                command += "(";
	                command += serializeFilters(options.filter, options.connection.cube);
	                command += ")";
	            } else {
	                command += " FROM [" + options.connection.cube + "]";
	            }

	            if (measures.length == 1 && columns.length) {
	                command += " WHERE (" + measureNames(measures).join(",") + ")";
	            }

	            command += '</Statement></Command><Properties><PropertyList><Catalog>' + options.connection.catalog + '</Catalog><Format>Multidimensional</Format></PropertyList></Properties></Execute></Body></Envelope>';
	            return command.replace(/\&/g, "&amp;");
	        },
	        discover: function(options) {
	            options = options || {};

	            var command = '<Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/"><Header/><Body><Discover xmlns="urn:schemas-microsoft-com:xml-analysis">';
	            command += "<RequestType>" + (xmlaDiscoverCommands[options.command] || options.command) + "</RequestType>";

	            command += "<Restrictions>" + serializeOptions("RestrictionList", options.restrictions, true) + "</Restrictions>";

	            if (options.connection && options.connection.catalog) {
	                options.properties = $.extend({}, {
	                    Catalog: options.connection.catalog
	                }, options.properties);
	            }

	            command += "<Properties>" + serializeOptions("PropertyList", options.properties) + "</Properties>";

	            command += '</Discover></Body></Envelope>';
	            return command;
	        }
	    };

	    var XmlaTransport = kendo.data.RemoteTransport.extend({
	        init: function(options) {
	            var originalOptions = options;

	            options = this.options = extend(true, {}, this.options, options);

	            kendo.data.RemoteTransport.call(this, options);

	            if (isFunction(originalOptions.discover)) {
	                this.discover = originalOptions.discover;
	            } else if (typeof originalOptions.discover === "string") {
	                this.options.discover = {
	                    url: originalOptions.discover
	                };
	            } else if (!originalOptions.discover) {
	                this.options.discover = this.options.read;
	            }
	        },
	        setup: function(options, type) {
	            options.data = options.data || {};
	            $.extend(true, options.data, { connection: this.options.connection });

	            return kendo.data.RemoteTransport.fn.setup.call(this, options, type);
	        },
	        options: {
	            read: {
	                dataType: "text",
	                contentType: "text/xml",
	                type: "POST"
	            },
	            discover: {
	                dataType: "text",
	                contentType: "text/xml",
	                type: "POST"
	            },
	            parameterMap: function(options, type) {
	                return convertersMap[type](options,type);
	            }
	        },

	        discover: function(options) {
	            return $.ajax(this.setup(options, "discover"));
	        }
	    });

	    function asArray(object) {
	        if (object == null) {
	            return [];
	        }

	        var type = toString.call(object);
	        if (type !== "[object Array]") {
	            return [object];
	        }

	        return object;
	    }

	    function translateAxis(axis) {
	        var result = { tuples: [] };
	        var tuples = asArray(kendo.getter("Tuples.Tuple", true)(axis));
	        var captionGetter = kendo.getter("Caption['#text']");
	        var unameGetter = kendo.getter("UName['#text']");
	        var levelNameGetter = kendo.getter("LName['#text']");
	        var levelNumGetter = kendo.getter("LNum['#text']");
	        var childrenGetter = kendo.getter("CHILDREN_CARDINALITY['#text']", true);
	        var hierarchyGetter = kendo.getter("['@Hierarchy']");
	        var parentNameGetter = kendo.getter("PARENT_UNIQUE_NAME['#text']", true);

	        for (var idx = 0; idx < tuples.length; idx++) {
	            var members = [];
	            var member = asArray(tuples[idx].Member);
	            for (var memberIdx = 0; memberIdx < member.length; memberIdx++) {
	                members.push({
	                    children: [],
	                    caption: captionGetter(member[memberIdx]),
	                    name: unameGetter(member[memberIdx]),
	                    levelName: levelNameGetter(member[memberIdx]),
	                    levelNum: levelNumGetter(member[memberIdx]),
	                    hasChildren: parseInt(childrenGetter(member[memberIdx]), 10) > 0,
	                    parentName: parentNameGetter(member[memberIdx]),
	                    hierarchy: hierarchyGetter(member[memberIdx])
	                });
	            }

	            result.tuples.push({ members: members });
	        }
	        return result;
	    }

	    var schemaDataReaderMap = {
	        cubes: {
	            name: kendo.getter("CUBE_NAME['#text']", true),
	            caption: kendo.getter("CUBE_CAPTION['#text']", true),
	            description: kendo.getter("DESCRIPTION['#text']", true),
	            type: kendo.getter("CUBE_TYPE['#text']", true)
	        },
	        catalogs: {
	            name: kendo.getter("CATALOG_NAME['#text']", true),
	            description: kendo.getter("DESCRIPTION['#text']", true)
	        },
	        measures: {
	            name: kendo.getter("MEASURE_NAME['#text']", true),
	            caption: kendo.getter("MEASURE_CAPTION['#text']", true),
	            uniqueName: kendo.getter("MEASURE_UNIQUE_NAME['#text']", true),
	            description: kendo.getter("DESCRIPTION['#text']", true),
	            aggregator: kendo.getter("MEASURE_AGGREGATOR['#text']", true),
	            groupName: kendo.getter("MEASUREGROUP_NAME['#text']", true),
	            displayFolder: kendo.getter("MEASURE_DISPLAY_FOLDER['#text']", true),
	            defaultFormat: kendo.getter("DEFAULT_FORMAT_STRING['#text']", true)
	        },
	        kpis: {
	            name: kendo.getter("KPI_NAME['#text']", true),
	            caption: kendo.getter("KPI_CAPTION['#text']", true),
	            value: kendo.getter("KPI_VALUE['#text']", true),
	            goal: kendo.getter("KPI_GOAL['#text']", true),
	            status: kendo.getter("KPI_STATUS['#text']", true),
	            trend: kendo.getter("KPI_TREND['#text']", true),
	            statusGraphic: kendo.getter("KPI_STATUS_GRAPHIC['#text']", true),
	            trendGraphic: kendo.getter("KPI_TREND_GRAPHIC['#text']", true),
	            description: kendo.getter("KPI_DESCRIPTION['#text']", true),
	            groupName: kendo.getter("MEASUREGROUP_NAME['#text']", true)
	        },
	        dimensions: {
	            name: kendo.getter("DIMENSION_NAME['#text']", true),
	            caption: kendo.getter("DIMENSION_CAPTION['#text']", true),
	            description: kendo.getter("DESCRIPTION['#text']", true),
	            uniqueName: kendo.getter("DIMENSION_UNIQUE_NAME['#text']", true),
	            defaultHierarchy: kendo.getter("DEFAULT_HIERARCHY['#text']", true),
	            type: kendo.getter("DIMENSION_TYPE['#text']", true)
	//unknown = 0; time = 1; measure = 2; other = 3; quantitative = 5; accounts = 6; customers = 7; products = 8; scenario = 9; utility = 10; currency = 11; rates = 12; channel = 13; promotion = 14; organization = 15; billOfMaterials = 16; geography = 17;

	        },
	        hierarchies: {
	            name: kendo.getter("HIERARCHY_NAME['#text']", true),
	            caption: kendo.getter("HIERARCHY_CAPTION['#text']", true),
	            description: kendo.getter("DESCRIPTION['#text']", true),
	            uniqueName: kendo.getter("HIERARCHY_UNIQUE_NAME['#text']", true),
	            dimensionUniqueName: kendo.getter("DIMENSION_UNIQUE_NAME['#text']", true),
	            displayFolder: kendo.getter("HIERARCHY_DISPLAY_FOLDER['#text']", true),
	            origin: kendo.getter("HIERARCHY_ORIGIN['#text']", true),
	            defaultMember: kendo.getter("DEFAULT_MEMBER['#text']", true)
	        },
	        levels: {
	            name: kendo.getter("LEVEL_NAME['#text']", true),
	            caption: kendo.getter("LEVEL_CAPTION['#text']", true),
	            description: kendo.getter("DESCRIPTION['#text']", true),
	            uniqueName: kendo.getter("LEVEL_UNIQUE_NAME['#text']", true),
	            dimensionUniqueName: kendo.getter("DIMENSION_UNIQUE_NAME['#text']", true),
	            displayFolder: kendo.getter("LEVEL_DISPLAY_FOLDER['#text']", true),
	            orderingProperty: kendo.getter("LEVEL_ORDERING_PROPERTY['#text']", true),
	            origin: kendo.getter("LEVEL_ORIGIN['#text']", true),
	            hierarchyUniqueName: kendo.getter("HIERARCHY_UNIQUE_NAME['#text']", true)
	        },
	        members: {
	            name: kendo.getter("MEMBER_NAME['#text']", true),
	            caption: kendo.getter("MEMBER_CAPTION['#text']", true),
	            uniqueName: kendo.getter("MEMBER_UNIQUE_NAME['#text']", true),
	            dimensionUniqueName: kendo.getter("DIMENSION_UNIQUE_NAME['#text']", true),
	            hierarchyUniqueName: kendo.getter("HIERARCHY_UNIQUE_NAME['#text']", true),
	            levelUniqueName: kendo.getter("LEVEL_UNIQUE_NAME['#text']", true),
	            childrenCardinality: kendo.getter("CHILDREN_CARDINALITY['#text']", true)
	        }
	    };

	    var xmlaReaderMethods = ["axes", "catalogs", "cubes", "dimensions", "hierarchies", "levels", "measures"];

	    var XmlaDataReader = kendo.data.XmlDataReader.extend({
	        init: function(options) {
	            kendo.data.XmlDataReader.call(this, options);

	            this._extend(options);
	        },
	        _extend: function(options) {
	            var idx = 0;
	            var length = xmlaReaderMethods.length;
	            var methodName;
	            var option;

	            for (; idx < length; idx++) {
	                methodName = xmlaReaderMethods[idx];
	                option = options[methodName];

	                if (option && option !== identity) {
	                    this[methodName] = option;
	                }
	            }
	        },
	        parse: function(xml) {
	            var result = kendo.data.XmlDataReader.fn.parse(xml.replace(/<(\/?)(\w|-)+:/g, "<$1"));
	            return kendo.getter("['Envelope']['Body']", true)(result);
	        },
	        errors: function(root) {
	            var fault = kendo.getter("['Fault']", true)(root);
	            if (fault) {
	                return [{
	                    faultstring: kendo.getter("faultstring['#text']", true)(fault),
	                    faultcode: kendo.getter("faultcode['#text']", true)(fault)
	                }];
	            }
	            return null;
	        },
	        axes: function(root) {
	            root = kendo.getter("ExecuteResponse[\"return\"].root", true)(root);

	            var axes = asArray(kendo.getter("Axes.Axis", true)(root));
	            var axis;

	            var result = {
	                columns: {},
	                rows: {}
	            };

	            for (var idx = 0; idx < axes.length; idx++) {
	                axis = axes[idx];

	                if (axis["@name"].toLowerCase() !== "sliceraxis") {
	                    if (!result.columns.tuples) {
	                        result.columns = translateAxis(axis);
	                    } else {
	                        result.rows = translateAxis(axis);
	                    }
	                }
	            }

	            return result;
	        },
	        data: function(root) {
	            root = kendo.getter("ExecuteResponse[\"return\"].root", true)(root);

	            var cells = asArray(kendo.getter("CellData.Cell", true)(root));

	            var result = [];
	            var ordinalGetter = kendo.getter("['@CellOrdinal']");
	            var valueGetter = kendo.getter("Value['#text']");
	            var fmtValueGetter = kendo.getter("FmtValue['#text']");

	            for (var idx = 0; idx < cells.length; idx++) {
	                result.push({
	                    value: valueGetter(cells[idx]),
	                    fmtValue: fmtValueGetter(cells[idx]),
	                    ordinal: parseInt(ordinalGetter(cells[idx]), 10)
	                });
	            }

	            return result;
	        },
	        _mapSchema: function(root, getters) {
	            root = kendo.getter("DiscoverResponse[\"return\"].root", true)(root);
	            var rows = asArray(kendo.getter("row", true)(root));

	            var result = [];

	            for (var idx = 0; idx < rows.length; idx++) {
	                var obj = {};
	                for (var key in getters) {
	                    obj[key] = getters[key](rows[idx]);
	                }
	                result.push(obj);
	            }

	            return result;
	        },
	        measures: function(root) {
	            return this._mapSchema(root, schemaDataReaderMap.measures);
	        },
	        kpis: function(root) {
	            return this._mapSchema(root, schemaDataReaderMap.kpis);
	        },
	        hierarchies: function(root) {
	            return this._mapSchema(root, schemaDataReaderMap.hierarchies);
	        },
	        levels: function(root) {
	            return this._mapSchema(root, schemaDataReaderMap.levels);
	        },
	        dimensions: function(root) {
	            return this._mapSchema(root, schemaDataReaderMap.dimensions);
	        },
	        cubes: function(root) {
	            return this._mapSchema(root, schemaDataReaderMap.cubes);
	        },
	        catalogs: function(root) {
	            return this._mapSchema(root, schemaDataReaderMap.catalogs);
	        },
	        members: function(root) {
	            return this._mapSchema(root, schemaDataReaderMap.members);
	        }
	    });

	    extend(true, kendo.data, {
	       PivotDataSource: PivotDataSource,
	       XmlaTransport: XmlaTransport,
	       XmlaDataReader: XmlaDataReader,
	       PivotCubeBuilder: PivotCubeBuilder,
	       transports: {
	           xmla: XmlaTransport
	       },
	       readers: {
	           xmla: XmlaDataReader
	       }
	    });

	    var sortExpr = function(expressions, name) {
	        if (!expressions) {
	            return null;
	        }

	        for (var idx = 0, length = expressions.length; idx < length; idx++) {
	            if (expressions[idx].field === name) {
	                return expressions[idx];
	            }
	        }

	        return null;
	    };

	    var removeExpr = function(expressions, name) {
	        var result = [];

	        for (var idx = 0, length = expressions.length; idx < length; idx++) {
	            if (expressions[idx].field !== name) {
	                result.push(expressions[idx]);
	            }
	        }

	        return result;
	    };

	    kendo.ui.PivotSettingTarget = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            that.element.addClass("k-pivot-setting");

	            that.dataSource = kendo.data.PivotDataSource.create(options.dataSource);

	            that._refreshHandler = $.proxy(that.refresh, that);
	            that.dataSource.first(CHANGE, that._refreshHandler);

	            if (!options.template) {
	                that.options.template = "<div data-" + kendo.ns + 'name="${data.name || data}">${data.name || data}' +
	                    (that.options.enabled ?
	                    '<a class="k-button k-button-icon k-flat"><span class="k-icon k-i-close k-setting-delete"></span></a>' : "") + '</div>';
	            }

	            that.template = kendo.template(that.options.template);
	            that.emptyTemplate = kendo.template(that.options.emptyTemplate);

	            that._sortable();

	            that.element.on("click" + NS, ".k-button,.k-item", function(e) {
	                var target = $(e.target);
	                var name = target.closest("[" + kendo.attr("name") + "]")
	                                 .attr(kendo.attr("name"));

	                if (!name) {
	                    return;
	                }

	                if (target.hasClass("k-i-close")) {
	                    that.remove(name);
	                } else if (that.options.sortable && target[0] === e.currentTarget) {
	                    that.sort({
	                        field: name,
	                        dir: target.find(".k-i-sort-asc-sm")[0] ? "desc" : "asc"
	                    });
	                }
	            });

	            if (options.filterable || options.sortable) {
	                that.fieldMenu = new ui.PivotFieldMenu(that.element, {
	                    messages: that.options.messages.fieldMenu,
	                    filter: ".k-setting-fieldmenu",
	                    filterable: options.filterable,
	                    sortable: options.sortable,
	                    dataSource: that.dataSource
	                });
	            }

	            that.refresh();
	        },

	        options: {
	            name: "PivotSettingTarget",
	            template: null,
	            filterable: false,
	            sortable: false,
	            emptyTemplate: "<div class='k-empty'>${data}</div>",
	            setting: "columns",
	            enabled: true,
	            messages: {
	                empty: "Drop Fields Here"
	            }
	        },
	        setDataSource: function(dataSource) {
	            this.dataSource.unbind(CHANGE, this._refreshHandler);
	            this.dataSource = this.options.dataSource = dataSource;

	            if (this.fieldMenu) {
	                this.fieldMenu.setDataSource(dataSource);
	            }
	            dataSource.first(CHANGE, this._refreshHandler);

	            this.refresh();
	        },

	        _sortable: function() {
	            var that = this;

	            if (that.options.enabled) {
	                this.sortable = this.element.kendoSortable({
	                    connectWith: this.options.connectWith,
	                    hint: that.options.hint,
	                    filter: ">*:not(.k-empty)",
	                    cursor: "move",
	                    start: function(e) {
	                        e.item.focus().blur();
	                    },
	                    change: function(e) {
	                        var name = e.item.attr(kendo.attr("name"));

	                        if (e.action == "receive") {
	                            that.add(name);
	                        } else if (e.action == "remove") {
	                            that.remove(name);
	                        } else if (e.action == "sort") {
	                            that.move(name, e.newIndex);
	                        }
	                    }
	                }).data("kendoSortable");
	            }
	        },

	        _indexOf: function(name, items) {
	            var idx, length, index = -1;

	            for (idx = 0, length = items.length; idx < length; idx++) {
	                if (getName(items[idx]) === name) {
	                    index = idx;
	                    break;
	                }
	            }
	            return index;
	        },

	        _isKPI: function(data) {
	            return data.type === "kpi" || data.measure;
	        },

	        validate: function(data) {
	            var isMeasure = (data.type == 2 || "aggregator" in data || this._isKPI(data));

	            if (isMeasure) {
	                return this.options.setting === "measures";
	            }

	            if (this.options.setting === "measures") {
	                return isMeasure;
	            }

	            var items = this.dataSource[this.options.setting]();
	            var name = data.defaultHierarchy || data.uniqueName;
	            if (this._indexOf(name, items) > -1) {
	                return false;
	            }

	            items = this.dataSource[this.options.setting === "columns" ? "rows" : "columns"]();
	            if (this._indexOf(name, items) > -1) {
	                return false;
	            }

	            return true;
	        },

	        add: function(name) {
	            var items = this.dataSource[this.options.setting]();
	            var i, l;

	            name = $.isArray(name) ? name.slice(0) : [name];

	            for (i = 0, l = name.length; i < l; i++) {
	                if (this._indexOf(name[i], items) !== -1) {
	                    name.splice(i, 1);
	                    i -= 1;
	                    l -= 1;
	                }
	            }

	            if (name.length) {
	                items = items.concat(name);
	                this.dataSource[this.options.setting](items);
	            }
	        },

	        move: function(name, index) {
	            var items = this.dataSource[this.options.setting]();
	            var idx = this._indexOf(name, items);

	            if (idx > -1) {
	                name = items.splice(idx, 1)[0];

	                items.splice(index, 0, name);

	                this.dataSource[this.options.setting](items);
	            }
	        },

	        remove: function (name) {
	            var items = this.dataSource[this.options.setting]();
	            var idx = this._indexOf(name, items);
	            var sortExpressions = this.dataSource.sort();
	            var filter = this.dataSource.filter();

	            if (idx > -1) {
	                if (filter) {
	                    filter.filters = removeExpr(filter.filters, name);
	                    this.dataSource._filter.filters = filter.filters;
	                    if (!filter.filters.length) {
	                        this.dataSource._filter = null;
	                    }
	                }
	                if (sortExpressions) {
	                    sortExpressions = removeExpr(sortExpressions, name);
	                    this.dataSource._sort = sortExpressions;
	                }
	                items.splice(idx, 1);
	                this.dataSource[this.options.setting](items);
	            }
	        },

	        sort: function(expr) {
	            var sortable = this.options.sortable;
	            var allowUnsort = sortable === true || sortable.allowUnsort;
	            var skipExpr = allowUnsort && expr.dir === "asc";

	            var expressions = (this.dataSource.sort() || []);
	            var result = removeExpr(expressions, expr.field);

	            if (skipExpr && expressions.length !== result.length) {
	                expr = null;
	            }

	            if (expr) {
	                result.push(expr);
	            }

	            this.dataSource.sort(result);
	        },

	        refresh: function() {
	            var html = "";
	            var items = this.dataSource[this.options.setting]();
	            var length = items.length;
	            var idx = 0;
	            var item;

	            if (length) {
	                for (; idx < length; idx++) {
	                    item = items[idx];
	                    item = item.name === undefined ? { name: item } : item;

	                    html += this.template(extend({ sortIcon: this._sortIcon(item.name) }, item));
	                }
	            } else {
	                html = this.emptyTemplate(this.options.messages.empty);
	            }

	            this.element.html(html);
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            this.dataSource.unbind(CHANGE, this._refreshHandler);
	            this.element.off(NS);

	            if (this.sortable) {
	                this.sortable.destroy();
	            }

	            if (this.fieldMenu) {
	                this.fieldMenu.destroy();
	            }

	            this.element = null;
	            this._refreshHandler = null;
	        },

	        _sortIcon: function(name) {
	            var expressions = this.dataSource.sort();
	            var expr = sortExpr(expressions, getName(name));
	            var icon = "";

	            if (expr) {
	                icon = "k-i-sort-" + expr.dir;
	            }

	            return icon;
	        }
	    });

	    var PivotGrid = Widget.extend({
	        init: function(element, options) {
	            var that = this;
	            var columnBuilder;
	            var rowBuilder;

	            Widget.fn.init.call(that, element, options);

	            that._dataSource();

	            that._bindConfigurator();

	            that._wrapper();
	            that._createLayout();

	            that._columnBuilder = columnBuilder = new ColumnBuilder();
	            that._rowBuilder = rowBuilder = new RowBuilder();
	            that._contentBuilder = new ContentBuilder();

	            that._templates();

	            that.columnsHeader
	                .add(that.rowsHeader)
	                .on("click", "span.k-icon", function() {
	                    var button = $(this);
	                    var builder = columnBuilder;
	                    var action = "expandColumn";
	                    var eventName;
	                    var path = button.attr(kendo.attr("path"));
	                    var eventArgs = {
	                        axis: "columns",
	                        path: $.parseJSON(path)
	                    };

	                    if (button.parent().is("td")) {
	                        builder = rowBuilder;
	                        action = "expandRow";
	                        eventArgs.axis = "rows";
	                    }

	                    var expanded = button.hasClass(STATE_EXPANDED);
	                    var metadata = builder.metadata[path];
	                    var request = metadata.expanded === undefined;

	                    eventName = expanded ? COLLAPSEMEMBER : EXPANDMEMBER;
	                    eventArgs.childrenLoaded = metadata.maxChildren > metadata.children;

	                    if (that.trigger(eventName, eventArgs)) {
	                        return;
	                    }

	                    builder.metadata[path].expanded = !expanded;

	                    button.toggleClass(STATE_EXPANDED, !expanded)
	                          .toggleClass(STATE_COLLAPSED, expanded);

	                    if (!expanded && request) {
	                        that.dataSource[action](eventArgs.path);
	                    } else {
	                        that.refresh();
	                    }
	                });

	            that._scrollable();

	            if (that.options.autoBind) {
	                that.dataSource.fetch();
	            }

	            kendo.notify(that);
	        },

	        events: [
	            DATABINDING,
	            DATABOUND,
	            EXPANDMEMBER,
	            COLLAPSEMEMBER
	        ],

	        options: {
	            name: "PivotGrid",
	            autoBind: true,
	            reorderable: true,
	            filterable: false,
	            sortable: false,
	            height: null,
	            columnWidth: 100,
	            configurator: "",
	            columnHeaderTemplate: null,
	            rowHeaderTemplate: null,
	            dataCellTemplate: null,
	            kpiStatusTemplate: null,
	            kpiTrendTemplate: null,
	            messages: {
	                measureFields: "Drop Data Fields Here",
	                columnFields: "Drop Column Fields Here",
	                rowFields: "Drop Rows Fields Here"
	            }
	        },

	        _templates: function() {
	            var columnTemplate = this.options.columnHeaderTemplate;
	            var rowTemplate = this.options.rowHeaderTemplate;
	            var dataTemplate = this.options.dataCellTemplate;
	            var kpiStatusTemplate = this.options.kpiStatusTemplate;
	            var kpiTrendTemplate = this.options.kpiTrendTemplate;

	            this._columnBuilder.template = kendo.template(columnTemplate || HEADER_TEMPLATE, { useWithBlock: !!columnTemplate });
	            this._contentBuilder.dataTemplate = kendo.template(dataTemplate || DATACELL_TEMPLATE, { useWithBlock: !!dataTemplate });
	            this._contentBuilder.kpiStatusTemplate = kendo.template(kpiStatusTemplate || KPISTATUS_TEMPLATE, { useWithBlock: !!kpiStatusTemplate });
	            this._contentBuilder.kpiTrendTemplate = kendo.template(kpiTrendTemplate || KPITREND_TEMPLATE, { useWithBlock: !!kpiTrendTemplate });
	            this._rowBuilder.template = kendo.template(rowTemplate || HEADER_TEMPLATE, { useWithBlock: !!rowTemplate });
	        },

	        _bindConfigurator: function() {
	            var configurator = this.options.configurator;
	            if (configurator) {
	                $(configurator).kendoPivotConfigurator("setDataSource", this.dataSource);
	            }
	        },

	        cellInfoByElement: function(element) {
	            element = $(element);

	            return this.cellInfo(element.index(), element.parent("tr").index());
	        },

	        cellInfo: function(columnIndex, rowIndex) {
	            var contentBuilder = this._contentBuilder;
	            var columnInfo = contentBuilder.columnIndexes[columnIndex || 0];
	            var rowInfo = contentBuilder.rowIndexes[rowIndex || 0];
	            var dataIndex;

	            if (!columnInfo || !rowInfo) {
	                return null;
	            }

	            dataIndex = (rowInfo.index * contentBuilder.rowLength) + columnInfo.index;

	            return {
	                columnTuple: columnInfo.tuple,
	                rowTuple: rowInfo.tuple,
	                measure: columnInfo.measure || rowInfo.measure,
	                dataItem: this.dataSource.view()[dataIndex]
	            };
	        },

	        setDataSource: function(dataSource) {
	            this.options.dataSource = dataSource;

	            this._dataSource();

	            if (this.measuresTarget) {
	                this.measuresTarget.setDataSource(dataSource);
	            }

	            if (this.rowsTarget) {
	                this.rowsTarget.setDataSource(dataSource);
	            }

	            if (this.columnsTarget) {
	                this.columnsTarget.setDataSource(dataSource);
	            }

	            this._bindConfigurator();

	            if (this.options.autoBind) {
	                dataSource.fetch();
	            }
	        },

	        setOptions: function(options) {
	            Widget.fn.setOptions.call(this, options);

	            this._templates();
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            clearTimeout(this._headerReflowTimeout);
	        },

	        _dataSource: function() {
	            var that = this;
	            var dataSource = that.options.dataSource;

	            dataSource = $.isArray(dataSource) ? { data: dataSource } : dataSource;

	            if (that.dataSource && this._refreshHandler) {
	                that.dataSource.unbind(CHANGE, that._refreshHandler)
	                               .unbind(STATERESET, that._stateResetHandler)
	                               .unbind(PROGRESS, that._progressHandler)
	                               .unbind(ERROR, that._errorHandler);
	            } else {
	                that._refreshHandler = $.proxy(that.refresh, that);
	                that._progressHandler = $.proxy(that._requestStart, that);
	                that._stateResetHandler = $.proxy(that._stateReset, that);
	                that._errorHandler = $.proxy(that._error, that);
	            }

	            that.dataSource = kendo.data.PivotDataSource.create(dataSource)
	                                   .bind(CHANGE, that._refreshHandler)
	                                   .bind(PROGRESS, that._progressHandler)
	                                   .bind(STATERESET, that._stateResetHandler)
	                                   .bind(ERROR, that._errorHandler);
	        },

	        _error: function() {
	            this._progress(false);
	        },

	        _requestStart: function() {
	            this._progress(true);
	        },

	        _stateReset: function() {
	            this._columnBuilder.reset();
	            this._rowBuilder.reset();
	        },

	        _wrapper: function() {
	            var height = this.options.height;

	            this.wrapper = this.element.addClass("k-widget k-pivot");

	            if (height) {
	                this.wrapper.css("height", height);
	            }
	        },

	        _measureFields: function() {
	            this.measureFields = $(DIV).addClass("k-pivot-toolbar k-header k-settings-measures");

	            this.measuresTarget = this._createSettingTarget(this.measureFields, {
	                setting: "measures",
	                messages: {
	                    empty: this.options.messages.measureFields
	                }
	            });
	        },

	        _createSettingTarget: function(element, options) {
	            var template = '<span tabindex="0" class="k-button" data-' + kendo.ns + 'name="${data.name}">${data.name}';
	            var sortable = options.sortable;
	            var icons = "";

	            if (sortable) {
	                icons += '#if (data.sortIcon) {#';
	                icons += '<span class="k-icon ${data.sortIcon}-sm"></span>';
	                icons += '#}#';
	            }

	            if (options.filterable || sortable) {
	                icons += '<span class="k-icon k-i-more-vertical k-setting-fieldmenu"></span>';
	            }
	            if (this.options.reorderable) {
	                icons += '<span class="k-icon k-i-close k-setting-delete"></span>';
	            }

	            if (icons) {
	                template += '<span class="k-field-actions">' + icons + '</span>';
	            }

	            template += '</span>';

	            return new kendo.ui.PivotSettingTarget(element, $.extend({
	                template: template,
	                emptyTemplate: '<span class="k-empty">${data}</span>',
	                enabled: this.options.reorderable,
	                dataSource: this.dataSource
	            }, options));
	        },

	        _initSettingTargets: function() {
	            this.columnsTarget = this._createSettingTarget(this.columnFields, {
	                connectWith: this.rowFields,
	                setting: "columns",
	                filterable: this.options.filterable,
	                sortable: this.options.sortable,
	                messages: {
	                    empty: this.options.messages.columnFields,
	                    fieldMenu: this.options.messages.fieldMenu
	                }
	            });

	            this.rowsTarget = this._createSettingTarget(this.rowFields, {
	                connectWith: this.columnFields,
	                setting: "rows",
	                filterable: this.options.filterable,
	                sortable: this.options.sortable,
	                messages: {
	                    empty: this.options.messages.rowFields,
	                    fieldMenu: this.options.messages.fieldMenu
	                }
	            });
	        },

	        _createLayout: function() {
	            var that = this;
	            var layoutTable = $(LAYOUT_TABLE);
	            var leftContainer = layoutTable.find(".k-pivot-rowheaders");
	            var rightContainer = layoutTable.find(".k-pivot-table");
	            var gridWrapper = $(DIV).addClass("k-grid k-widget");

	            that._measureFields();
	            that.columnFields = $(DIV).addClass("k-pivot-toolbar k-header k-settings-columns");

	            that.rowFields = $(DIV).addClass("k-pivot-toolbar k-header k-settings-rows");
	            that.columnsHeader = $('<div class="k-grid-header-wrap" />')
	                                    .wrap('<div class="k-grid-header" />');

	            that.columnsHeader.parent().css("padding-right", kendo.support.scrollbar());

	            that.rowsHeader = $('<div class="k-grid k-widget k-alt"/>');
	            that.content = $('<div class="k-grid-content" />');

	            leftContainer.append(that.measureFields);
	            leftContainer.append(that.rowFields);
	            leftContainer.append(that.rowsHeader);

	            gridWrapper.append(that.columnsHeader.parent());
	            gridWrapper.append(that.content);

	            rightContainer.append(that.columnFields);
	            rightContainer.append(gridWrapper);

	            that.wrapper.append(layoutTable);

	            that.columnsHeaderTree = new kendo.dom.Tree(that.columnsHeader[0]);
	            that.rowsHeaderTree = new kendo.dom.Tree(that.rowsHeader[0]);
	            that.contentTree = new kendo.dom.Tree(that.content[0]);

	            that._initSettingTargets();
	        },

	        _progress: function(toggle) {
	            kendo.ui.progress(this.wrapper, toggle);
	        },

	        _resize: function() {
	            if (this.content[0].firstChild) {
	                this._setSectionsWidth();
	                this._setSectionsHeight();
	                this._setContentWidth();
	                this._setContentHeight();
	                this._columnHeaderReflow();
	            }
	        },

	        _columnHeaderReflow: function() {
	            var columnTable = this.columnsHeader.children("table");

	            if (!kendo.support.browser.mozilla) {
	                return;
	            }

	            clearTimeout(this._headerReflowTimeout);

	            columnTable.css("table-layout", "auto");

	            this._headerReflowTimeout = setTimeout(function() {
	                columnTable.css("table-layout", "");
	            });
	        },

	        _setSectionsWidth: function() {
	            var rowsHeader = this.rowsHeader;
	            var leftColumn = rowsHeader.parent(".k-pivot-rowheaders").width(AUTO);
	            var width;

	            width = Math.max(outerWidth(this.measureFields), outerWidth(this.rowFields));
	            width = Math.max(rowsHeader.children("table").width(), width);

	            leftColumn.width(width);
	        },

	        _setSectionsHeight: function() {
	            var measureFieldsHeight = this.measureFields.height(AUTO).height();
	            var columnFieldsHeight = this.columnFields.height(AUTO).height();
	            var rowFieldsHeight = this.rowFields.height(AUTO).innerHeight();
	            var columnsHeight = this.columnsHeader.height(AUTO).innerHeight();

	            var padding = rowFieldsHeight - this.rowFields.height();

	            var firstRowHeight = columnFieldsHeight > measureFieldsHeight ? columnFieldsHeight : measureFieldsHeight;
	            var secondRowHeight = columnsHeight > rowFieldsHeight ? columnsHeight : rowFieldsHeight;

	            this.measureFields.height(firstRowHeight);
	            this.columnFields.height(firstRowHeight);
	            this.rowFields.height(secondRowHeight - padding);
	            this.columnsHeader.height(secondRowHeight);
	        },

	        _setContentWidth: function() {
	            var contentTable = this.content.find("table");
	            var columnTable = this.columnsHeader.children("table");

	            var rowLength = contentTable.children("colgroup").children().length;

	            var calculatedWidth = rowLength * this.options.columnWidth;
	            var minWidth = Math.ceil((calculatedWidth / this.content.width()) * 100);

	            if (minWidth < 100) {
	                minWidth = 100;
	            }

	            contentTable.add(columnTable).css("width", minWidth + "%");

	            this._resetColspan(columnTable);
	        },

	        _setContentHeight: function() {
	            var that = this;
	            var content = that.content;
	            var rowsHeader = that.rowsHeader;
	            var innerHeight = that.wrapper.innerHeight();
	            var scrollbar = kendo.support.scrollbar();
	            var skipScrollbar = content[0].offsetHeight === content[0].clientHeight;
	            var height = that.options.height;

	            if (that.wrapper.is(":visible")) {
	                if (!innerHeight || !height) {
	                    if (skipScrollbar) {
	                        scrollbar = 0;
	                    }

	                    content.height("auto");
	                    rowsHeader.height(content.height() - scrollbar);
	                    return;
	                }

	                innerHeight -= outerHeight(that.columnFields);
	                innerHeight -= outerHeight(that.columnsHeader.parent());

	                if (innerHeight <= scrollbar * 2) { // do not set height if proper scrollbar cannot be displayed
	                    innerHeight = scrollbar * 2 + 1;
	                    if (!skipScrollbar) {
	                        innerHeight += scrollbar;
	                    }
	                }

	                content.height(innerHeight);

	                if (skipScrollbar) {
	                    scrollbar = 0;
	                }

	                rowsHeader.height(innerHeight - scrollbar);
	            }
	        },

	        _resetColspan: function(columnTable) {
	            var that = this;
	            var cell = columnTable.children("tbody").children(":first").children(":first");

	            if (that._colspan === undefined) {
	                that._colspan = cell.attr("colspan");
	            }

	            cell.attr("colspan", 1);

	            clearTimeout(that._layoutTimeout);

	            that._layoutTimeout = setTimeout(function() {
	                cell.attr("colspan", that._colspan);
	                that._colspan = undefined;
	            });
	        },

	        _axisMeasures: function(axis) {
	            var result = [];
	            var dataSource = this.dataSource;
	            var measures = dataSource.measures();
	            var hasMeasure = measures.length > 1 || (measures[0] && measures[0].type);

	            if (dataSource.measuresAxis() === axis) {
	                if (dataSource[axis]().length === 0 || hasMeasure) {
	                    result = measures;
	                }
	            }

	            return result;
	        },

	        items: function() {
	            return [];
	        },

	        refresh: function() {
	            var that = this;
	            var dataSource = that.dataSource;

	            var axes = dataSource.axes();
	            var columns = (axes.columns || {}).tuples || [];
	            var rows = (axes.rows || {}).tuples || [];

	            var columnBuilder = that._columnBuilder;
	            var rowBuilder = that._rowBuilder;

	            var columnAxis = {};
	            var rowAxis = {};

	            if (that.trigger(DATABINDING, { action: "rebind" } )) {
	                return;
	            }

	            columnBuilder.measures = that._axisMeasures(AXIS_COLUMNS);
	            rowBuilder.measures = that._axisMeasures(AXIS_ROWS);

	            that.columnsHeaderTree.render(columnBuilder.build(columns));
	            that.rowsHeaderTree.render(rowBuilder.build(rows));

	            columnAxis = {
	                indexes: columnBuilder._indexes,
	                measures: columnBuilder.measures,
	                metadata: columnBuilder.metadata
	            };

	            rowAxis = {
	                indexes: rowBuilder._indexes,
	                measures: rowBuilder.measures,
	                metadata: rowBuilder.metadata
	            };

	            that.contentTree.render(that._contentBuilder.build(dataSource.view(), columnAxis, rowAxis));

	            that._resize();

	            if (that.touchScroller) {
	                that.touchScroller.contentResized();
	            } else {
	                var touchScroller = kendo.touchScroller(that.content);

	                if (touchScroller && touchScroller.movable) {
	                    that.touchScroller = touchScroller;

	                    touchScroller.movable.bind("change", function(e) {
	                        kendo.scrollLeft(that.columnsHeader, -e.sender.x);
	                        that.rowsHeader.scrollTop(-e.sender.y);
	                    });
	                }
	            }

	            that._progress(false);

	            that.trigger(DATABOUND);
	        },

	        _scrollable: function() {
	            var that = this;
	            var columnsHeader = that.columnsHeader;
	            var rowsHeader = that.rowsHeader;

	            that.content.scroll(function() {
	                kendo.scrollLeft(columnsHeader, this.scrollLeft);
	                rowsHeader.scrollTop(this.scrollTop);
	            });

	            rowsHeader.bind("DOMMouseScroll" + NS + " mousewheel" + NS, $.proxy(that._wheelScroll, that));
	        },

	        _wheelScroll: function (e) {
	            if (e.ctrlKey) {
	                return;
	            }

	            var delta = kendo.wheelDeltaY(e);
	            var scrollTop = this.content.scrollTop();

	            if (delta) {
	                e.preventDefault();
	                //In Firefox DOMMouseScroll event cannot be canceled
	                $(e.currentTarget).one("wheel" + NS, false);

	                this.rowsHeader.scrollTop(scrollTop + (-delta));
	                this.content.scrollTop(scrollTop + (-delta));
	            }
	        }
	    });

	    var element = kendo.dom.element;
	    var htmlNode = kendo.dom.html;

	    var createMetadata = function(levelNum, memberIdx) {
	       return {
	            maxChildren: 0,
	            children: 0,
	            maxMembers: 0,
	            members: 0,
	            measures: 1,
	            levelNum: levelNum,
	            parentMember: memberIdx !== 0
	        };
	    };

	    var buildPath = function(tuple, index) {
	        var path = [];
	        var idx = 0;

	        for(; idx <= index; idx++) {
	            path.push(tuple.members[idx].name);
	        }

	        return path;
	    };

	    var tupleName = function(tuple, index) {
	        var name = "";
	        var idx = 0;

	        for(; idx <= index; idx++) {
	            name += tuple.members[idx].name;
	        }

	        return name;
	    };

	    var ColumnBuilder = Class.extend({
	        init: function() {
	            this.measures = 1;
	            this.metadata = {};
	        },

	        build: function(tuples) {
	            var tbody = this._tbody(tuples);
	            var colgroup = this._colGroup();

	            return [
	                element("table", null, [colgroup, tbody])
	            ];
	        },

	        reset: function() {
	            this.metadata = {};
	        },

	        _colGroup: function() {
	            var length = this._rowLength();
	            var children = [];
	            var idx = 0;

	            for (; idx < length; idx++) {
	                children.push(element("col", null));
	            }

	            return element("colgroup", null, children);
	        },

	        _tbody: function(tuples) {
	            var root = tuples[0];

	            this.map = {};
	            this.rows = [];
	            this.rootTuple = root;

	            this._indexes = [];

	            if (root) {
	                this._buildRows(root, 0);
	                this._normalize();
	            } else {
	                this.rows.push(element("tr", null, [ element("th", null, [ htmlNode("&nbsp;") ]) ]));
	            }

	            return element("tbody", null, this.rows);
	        },

	        _normalize: function() {
	            var rows = this.rows;
	            var rowsLength = rows.length;
	            var rowIdx = 0;
	            var row;

	            var cellsLength;
	            var cellIdx;
	            var cells;
	            var cell;

	            for (; rowIdx < rowsLength; rowIdx++) {
	                row = rows[rowIdx];

	                if (row.rowSpan === 1) {
	                    continue;
	                }

	                cells = row.children;

	                cellIdx = 0;
	                cellsLength = cells.length;

	                for (; cellIdx < cellsLength; cellIdx++) {
	                    cell = cells[cellIdx];

	                    if (cell.tupleAll) {
	                        cell.attr.rowSpan = row.rowSpan;
	                    }
	                }
	            }
	        },

	        _rowIndex: function(row) {
	            var rows = this.rows;
	            var length = rows.length;
	            var idx = 0;

	            for(; idx < length; idx++) {
	                if (rows[idx] === row) {
	                    break;
	                }
	            }

	            return idx;
	        },

	        _rowLength: function() {
	            var cells = this.rows[0] ? this.rows[0].children : [];
	            var length = cells.length;
	            var rowLength = 0;
	            var idx = 0;

	            if (length) {
	                for (; idx < length; idx++) {
	                    rowLength += cells[idx].attr.colSpan || 1;
	                }
	            }

	            if (!rowLength) {
	                rowLength = this.measures;
	            }

	            return rowLength;
	        },

	        _row: function(tuple, memberIdx, parentMember) {
	            var rootName = this.rootTuple.members[memberIdx].name;
	            var levelNum = tuple.members[memberIdx].levelNum;
	            var rowKey = rootName + levelNum;
	            var map = this.map;
	            var parentRow;
	            var children;

	            var row = map[rowKey];

	            if (!row) {
	                row = element("tr", null, []);

	                row.parentMember = parentMember;
	                row.collapsed = 0;
	                row.colSpan = 0;
	                row.rowSpan = 1;

	                map[rowKey] = row;
	                parentRow = map[rootName + (Number(levelNum) - 1)];

	                if (parentRow) {
	                    children = parentRow.children;

	                    if (children[1] && children[1].attr.className.indexOf("k-alt") === -1) {
	                        row.notFirst = true;
	                    } else {
	                        row.notFirst = parentRow.notFirst;
	                    }
	                }

	                this.rows.splice(this._rowIndex(parentRow) + 1, 0, row);
	            } else {
	                row.notFirst = false;

	                if (!row.parentMember || row.parentMember !== parentMember) {
	                    row.parentMember = parentMember;
	                    row.collapsed = 0;
	                    row.colSpan = 0;
	                }
	            }

	            return row;
	        },

	        _measures: function(measures, tuple, className) {
	            var map = this.map;
	            var row = map.measureRow;
	            var measure;

	            if (!row) {
	                row = element("tr", null, []);
	                map.measureRow = row;
	                this.rows.push(row);
	            }

	            for (var idx = 0, length = measures.length; idx < length; idx++) {
	                measure = measures[idx];
	                row.children.push(this._cell((className || ""), [this._content(measure, tuple)], measure));
	            }

	            return length;
	        },

	        _content: function(member, tuple) {
	            return htmlNode(this.template({
	                member: member,
	                tuple: tuple
	            }));
	        },

	        _cell: function(className, children, member) {
	            var cell = element("th", { className: "k-header" + className }, children);
	            cell.value = member.caption || member.name;
	            return cell;
	        },

	        _buildRows: function(tuple, memberIdx, parentMember) {
	            var members = tuple.members;
	            var member = members[memberIdx];
	            var nextMember = members[memberIdx + 1];

	            var row, childRow, children, childrenLength;
	            var cell, allCell, cellAttr;
	            var cellChildren = [];
	            var path;

	            var idx = 0;
	            var metadata;

	            var colSpan;
	            var collapsed = 0;
	            var memberCollapsed = 0;

	            if (member.measure) {
	                this._measures(member.children, tuple);
	                return;
	            }

	            path = kendo.stringify(buildPath(tuple, memberIdx));
	            row = this._row(tuple, memberIdx, parentMember);

	            children = member.children;
	            childrenLength = children.length;

	            metadata = this.metadata[path];
	            if (!metadata) {
	                this.metadata[path] = metadata = createMetadata(Number(member.levelNum), memberIdx);
	                metadata.rootLevelNum = Number(this.rootTuple.members[memberIdx].levelNum);
	            }

	            this._indexes.push({
	                path: path,
	                tuple: tuple
	            });

	            if (member.hasChildren) {
	                if (metadata.expanded === false) {
	                    collapsed = metadata.maxChildren;
	                    row.collapsed += collapsed;

	                    metadata.children = 0;
	                    childrenLength = 0;
	                }

	                cellAttr = { className: "k-icon " + (childrenLength ? STATE_EXPANDED : STATE_COLLAPSED) };
	                cellAttr[kendo.attr("path")] = path;

	                cellChildren.push(element("span", cellAttr));
	            }

	            cellChildren.push(this._content(member, tuple));
	            cell = this._cell((row.notFirst ? " k-first" : ""), cellChildren, member);

	            row.children.push(cell);
	            row.colSpan += 1;

	            if (childrenLength) {
	                allCell = this._cell(" k-alt", [this._content(member, tuple)], member);
	                row.children.push(allCell);

	                for (; idx < childrenLength; idx++) {
	                    childRow = this._buildRows(children[idx], memberIdx, member);
	                }

	                colSpan = childRow.colSpan;
	                collapsed = childRow.collapsed;

	                cell.attr.colSpan = colSpan;

	                metadata.children = colSpan;
	                metadata.members = 1;

	                row.colSpan += colSpan;
	                row.collapsed += collapsed;
	                row.rowSpan = childRow.rowSpan + 1;

	                if (nextMember) {
	                    if (nextMember.measure) {
	                        colSpan = this._measures(nextMember.children, tuple, " k-alt");
	                    } else {
	                        childRow = this._buildRows(tuple, memberIdx + 1);
	                        colSpan = childRow.colSpan;

	                        row.collapsed += childRow.collapsed;
	                        memberCollapsed = childRow.collapsed;
	                    }

	                    allCell.attr.colSpan = colSpan;
	                    colSpan -= 1;

	                    metadata.members += colSpan;
	                    row.colSpan += colSpan;
	                }
	            } else if (nextMember) {
	                if (nextMember.measure) {
	                    colSpan = this._measures(nextMember.children, tuple);
	                } else {
	                    childRow = this._buildRows(tuple, memberIdx + 1);
	                    colSpan = childRow.colSpan;

	                    row.collapsed += childRow.collapsed;
	                    memberCollapsed = childRow.collapsed;
	                }

	                metadata.members = colSpan;

	                if (colSpan > 1) {
	                    cell.attr.colSpan = colSpan;
	                    row.colSpan += colSpan - 1;
	                }
	            }

	            if (metadata.maxMembers < (metadata.members + memberCollapsed)) {
	                metadata.maxMembers = metadata.members + memberCollapsed;
	            }

	            children = metadata.children + collapsed;

	            if (metadata.maxChildren < children) {
	                metadata.maxChildren = children;
	            }

	            (allCell || cell).tupleAll = true;

	            return row;
	        }
	    });

	    var RowBuilder = Class.extend({
	        init: function() {
	            this.metadata = {};
	        },

	        build: function(tuples) {
	            var tbody = this._tbody(tuples);
	            var colgroup = this._colGroup();

	            return [
	                element("table", null, [colgroup, tbody])
	            ];
	        },

	        reset: function() {
	            this.metadata = {};
	        },

	        _rowLength: function() {
	            var children = this.rows[0].children;
	            var length = 0;
	            var idx = 0;

	            var cell = children[idx];

	            while(cell) {
	                length += (cell.attr.colSpan || 1);
	                cell = children[++idx];
	            }

	            return length;
	        },

	        _colGroup: function() {
	            var length = this._rowLength();
	            var children = [];
	            var idx = 0;

	            for (; idx < length; idx++) {
	                children.push(element("col", null));
	            }

	            return element("colgroup", null, children);
	        },

	        _tbody: function(tuples) {
	            var root = tuples[0];

	            this.rootTuple = root;
	            this.rows = [];
	            this.map = {};

	            this._indexes = [];

	            if (root) {
	                this._buildRows(root, 0);
	                this._normalize();
	            } else {
	                this.rows.push(element("tr", null, [ element("td", null, [ htmlNode("&nbsp;") ]) ]));
	            }

	            return element("tbody", null, this.rows);
	        },

	        _normalize: function() {
	            var rows = this.rows;
	            var rowsLength = rows.length;
	            var rowIdx = 0;

	            var members = this.rootTuple.members;
	            var firstMemberName = members[0].name;
	            var membersLength = members.length;
	            var memberIdx = 0;

	            var row;
	            var cell;
	            var maxcolSpan;
	            var map = this.map;
	            var allRow;

	            for (; rowIdx < rowsLength; rowIdx++) {
	                row = rows[rowIdx];

	                for (memberIdx = 0; memberIdx < membersLength; memberIdx++) {
	                    maxcolSpan = this[members[memberIdx].name];
	                    cell = row.colSpan["dim" + memberIdx];

	                    if (cell && cell.colSpan < maxcolSpan) {
	                        cell.attr.colSpan = (maxcolSpan - cell.colSpan) + 1;
	                    }
	                }
	            }

	            row = map[firstMemberName];
	            allRow = map[firstMemberName + "all"];

	            if (row) {
	                row.children[0].attr.className = "k-first";
	            }

	            if (allRow) {
	                allRow.children[0].attr.className += " k-first";
	            }
	        },

	        _row: function(children) {
	            var row = element("tr", null, children);
	            row.rowSpan = 1;
	            row.colSpan = {};

	            this.rows.push(row);

	            return row;
	        },

	        _content: function(member, tuple) {
	            return htmlNode(this.template({
	                member: member,
	                tuple: tuple
	            }));
	        },

	        _cell: function(className, children, member) {
	            var cell = element("td", { className: className }, children);
	            cell.value = member.caption || member.name;
	            return cell;
	        },

	        _buildRows: function(tuple, memberIdx) {
	            var map = this.map;
	            var path;

	            var members = tuple.members;
	            var member = members[memberIdx];
	            var nextMember = members[memberIdx + 1];

	            var children = member.children;
	            var childrenLength = children.length;

	            var levelNum = Number(member.levelNum);
	            var rootName = this.rootTuple.members[memberIdx].name;
	            var tuplePath = buildPath(tuple, memberIdx - 1).join("");
	            var rootLevelNum = Number(this.rootTuple.members[memberIdx].levelNum);
	            var parentName = tuplePath + (rootLevelNum === levelNum ? "" : (member.parentName || ""));
	            var row = map[parentName + "all"] || map[parentName];
	            var colSpan = levelNum + 1;

	            var cell, allCell;
	            var childRow, allRow;
	            var metadata;
	            var className;
	            var cellChildren = [];
	            var expandIconAttr;
	            var idx;

	            if (!row || row.hasChild) {
	                row = this._row();
	            } else {
	                row.hasChild = true;
	            }

	            if (member.measure) {
	                className = row.allCell ? "k-grid-footer" : "";
	                row.children.push(this._cell(className, [ this._content(children[0], tuple) ], children[0]));

	                row.rowSpan = childrenLength;

	                for (idx = 1; idx < childrenLength; idx++) {
	                    this._row([ this._cell(className, [ this._content(children[idx], tuple) ], children[idx]) ]);
	                }

	                return row;
	            }

	            map[tuplePath + member.name] = row;

	            path = kendo.stringify(buildPath(tuple, memberIdx));

	            metadata = this.metadata[path];
	            if (!metadata) {
	                this.metadata[path] = metadata = createMetadata(levelNum, memberIdx);
	                metadata.rootLevelNum = rootLevelNum;
	            }

	            this._indexes.push({
	                path: path,
	                tuple: tuple
	            });

	            if (member.hasChildren) {
	                if (metadata.expanded === false) {
	                    childrenLength = 0;
	                    metadata.children = 0;
	                }

	                expandIconAttr = { className: "k-icon " + (childrenLength ? STATE_EXPANDED : STATE_COLLAPSED) };
	                expandIconAttr[kendo.attr("path")] = path;

	                cellChildren.push(element("span", expandIconAttr));
	            }

	            cellChildren.push(this._content(member, tuple));

	            className = row.allCell && !childrenLength ? "k-grid-footer" : "";
	            cell = this._cell(className, cellChildren, member);
	            cell.colSpan = colSpan;

	            row.children.push(cell);
	            row.colSpan["dim" + memberIdx] = cell;

	            if (!this[rootName] || this[rootName] < colSpan) {
	                this[rootName] = colSpan;
	            }

	            if (childrenLength) {
	                row.allCell = false;
	                row.hasChild = false;

	                for (idx = 0; idx < childrenLength; idx++) {
	                    childRow = this._buildRows(children[idx], memberIdx);

	                    if (row !== childRow) {
	                        row.rowSpan += childRow.rowSpan;
	                    }
	                }

	                if (row.rowSpan > 1) {
	                    cell.attr.rowSpan = row.rowSpan;
	                }

	                metadata.children = row.rowSpan;

	                allCell = this._cell("k-grid-footer", [this._content(member, tuple)], member);
	                allCell.colSpan = colSpan;

	                allRow = this._row([ allCell ]);
	                allRow.colSpan["dim" + memberIdx] = allCell;
	                allRow.allCell = true;

	                map[tuplePath + member.name + "all"] = allRow;

	                if (nextMember) {
	                    childRow = this._buildRows(tuple, memberIdx + 1);
	                    allCell.attr.rowSpan = childRow.rowSpan;
	                }

	                row.rowSpan += allRow.rowSpan;

	                metadata.members = allRow.rowSpan;

	            } else if (nextMember) {
	                row.hasChild = false;
	                this._buildRows(tuple, memberIdx + 1);

	                (allCell || cell).attr.rowSpan = row.rowSpan;

	                metadata.members = row.rowSpan;
	            }

	            if (metadata.maxChildren < metadata.children) {
	                metadata.maxChildren = metadata.children;
	            }

	            if (metadata.maxMembers < metadata.members) {
	                metadata.maxMembers = metadata.members;
	            }

	            return row;
	        }
	    });

	    var ContentBuilder = Class.extend({
	        init: function() {
	            this.columnAxis = {};
	            this.rowAxis = {};
	        },

	        build: function(data, columnAxis, rowAxis) {
	            var index = columnAxis.indexes[0];
	            var metadata = columnAxis.metadata[index ? index.path : undefined];

	            this.columnAxis = columnAxis;
	            this.rowAxis = rowAxis;

	            this.data = data;

	            this.rowLength = metadata ? metadata.maxChildren + metadata.maxMembers : columnAxis.measures.length || 1;

	            if (!this.rowLength) {
	                this.rowLength = 1;
	            }

	            var tbody = this._tbody();
	            var colgroup = this._colGroup();

	            return [
	                element("table", null, [colgroup, tbody])
	            ];
	        },

	        _colGroup: function() {
	            var length = this.columnAxis.measures.length || 1;
	            var children = [];
	            var idx = 0;

	            if (this.rows[0]) {
	                length = this.rows[0].children.length;
	            }

	            for (; idx < length; idx++) {
	                children.push(element("col", null));
	            }

	            return element("colgroup", null, children);
	        },

	        _tbody: function() {
	            this.rows = [];

	            if (this.data[0]) {
	                this.columnIndexes = this._indexes(this.columnAxis, this.rowLength);
	                this.rowIndexes = this._indexes(this.rowAxis, Math.ceil(this.data.length / this.rowLength));

	                this._buildRows();
	            } else {
	                this.rows.push(element("tr", null, [ element("td", null, [ htmlNode("&nbsp;") ]) ]));
	            }

	            return element("tbody", null, this.rows);
	        },

	        _indexes: function(axisInfo, total) {
	            var result = [];
	            var axisInfoMember;
	            var indexes = axisInfo.indexes;
	            var metadata = axisInfo.metadata;
	            var measures = axisInfo.measures;
	            var measuresLength = measures.length || 1;

	            var current;
	            var dataIdx = 0;
	            var firstEmpty = 0;

	            var idx = 0;
	            var length = indexes.length;
	            var measureIdx;
	            var index;

	            var children;
	            var skipChildren;

	            if (!length) {
	                for (measureIdx = 0; measureIdx < measuresLength; measureIdx++) {
	                    result[measureIdx] = {
	                        index: measureIdx,
	                        measure: measures[measureIdx],
	                        tuple: null
	                    };
	                }

	                return result;
	            }

	            for (; idx < length; idx++) {
	                axisInfoMember = indexes[idx];
	                current = metadata[axisInfoMember.path];
	                children = current.children + current.members;
	                skipChildren = 0;

	                if (children) {
	                    children -= measuresLength;
	                }

	                if (current.expanded === false && current.children !== current.maxChildren) {
	                    skipChildren = current.maxChildren;
	                }

	                if (current.parentMember && current.levelNum === current.rootLevelNum) {
	                    children = -1;
	                }

	                if (children > -1) {
	                    for (measureIdx = 0; measureIdx < measuresLength; measureIdx++) {
	                        index = children + measureIdx;
	                        if (!current.children) {
	                            index += firstEmpty;
	                        }

	                        result[children + firstEmpty + measureIdx] = {
	                            children: children,
	                            index: dataIdx,
	                            measure: measures[measureIdx],
	                            tuple: axisInfoMember.tuple
	                        };
	                        dataIdx += 1;
	                    }

	                    while(result[firstEmpty] !== undefined) {
	                        firstEmpty += 1;
	                    }
	                }

	                if (firstEmpty === total) {
	                    break;
	                }

	                dataIdx += skipChildren;
	            }

	            return result;
	        },

	        _buildRows: function() {
	            var rowIndexes = this.rowIndexes;
	            var length = rowIndexes.length;
	            var idx = 0;

	            for (; idx < length; idx++) {
	                var rowIndex = rowIndexes[idx];
	                if (rowIndex) {
	                    this.rows.push(this._buildRow(rowIndex));
	                }
	            }
	        },

	        _buildRow: function(rowInfo) {
	            var startIdx = rowInfo.index * this.rowLength;
	            var columnIndexes = this.columnIndexes;
	            var length = columnIndexes.length;
	            var columnInfo;
	            var cells = [];
	            var idx = 0;

	            var templateInfo;
	            var cell, cellContent;
	            var attr, dataItem, measure;

	            for (; idx < length; idx++) {
	                columnInfo = columnIndexes[idx];

	                if (columnInfo === undefined) {
	                    continue;
	                }

	                attr = {};
	                if (columnInfo.children) {
	                    attr.className = "k-alt";
	                }

	                cellContent = "";
	                dataItem = this.data[startIdx + columnInfo.index];
	                measure = columnInfo.measure || rowInfo.measure;

	                templateInfo = {
	                    columnTuple: columnInfo.tuple,
	                    rowTuple: rowInfo.tuple,
	                    measure: measure,
	                    dataItem: dataItem
	                };

	                if (dataItem.value !== "" && measure && measure.type) {
	                    if (measure.type === "status") {
	                        cellContent = this.kpiStatusTemplate(templateInfo);
	                    } else if (measure.type === "trend") {
	                        cellContent = this.kpiTrendTemplate(templateInfo);
	                    }
	                }

	                if (!cellContent) {
	                    cellContent = this.dataTemplate(templateInfo);
	                }

	                cell = element("td", attr, [ htmlNode(cellContent) ]);
	                cell.value = dataItem.value;
	                cells.push(cell);
	            }

	            attr = {};
	            if (rowInfo.children) {
	                attr.className = "k-grid-footer";
	            }

	            return element("tr", attr, cells);
	        }
	    });

	    ui.plugin(PivotGrid);

	    kendo.PivotExcelExporter = kendo.Class.extend({
	        init: function(options) {
	            this.options = options;

	            this.widget = options.widget;
	            this.dataSource = this.widget.dataSource;
	        },

	        _columns: function() {
	            var columnHeaderTable = this.widget.columnsHeaderTree.children[0];
	            var rowHeaderTable = this.widget.rowsHeaderTree.children[0];

	            var columnHeaderLength = columnHeaderTable.children[0].children.length;
	            var rowHeaderLength = rowHeaderTable.children[0].children.length;

	            var width = this.widget.options.columnWidth;
	            var result = [];
	            var idx;

	            if (rowHeaderLength && this.dataSource.data()[0]) {
	                for (idx = 0; idx < rowHeaderLength; idx++) {
	                    result.push({
	                        autoWidth: true
	                    });
	                }
	            }

	            for (idx = 0; idx < columnHeaderLength; idx++) {
	                result.push({
	                    autoWidth: false,
	                    width: width
	                });
	            }

	            return result;
	        },

	        _cells: function(rows, type, callback) {
	            var result = [];

	            var i = 0;
	            var length = rows.length;

	            var cellsLength;
	            var row, cells;
	            var j, cell;

	            for (; i < length; i++) {
	                row = [];
	                cells = rows[i].children;
	                cellsLength = cells.length;

	                for (j = 0; j < cellsLength; j++) {
	                    cell = cells[j];

	                    row.push({
	                        background: "#7a7a7a",
	                        color: "#fff",
	                        value: cell.value,
	                        colSpan: cell.attr.colSpan || 1,
	                        rowSpan: cell.attr.rowSpan || 1
	                    });
	                }

	                if (callback) {
	                    callback(row, i);
	                }

	                result.push({
	                    cells: row,
	                    type: type
	                });
	            }

	            return result;
	        },

	        _rows: function() {
	            var columnHeaderTable = this.widget.columnsHeaderTree.children[0];
	            var rowHeaderTable = this.widget.rowsHeaderTree.children[0];

	            var columnHeaderLength = columnHeaderTable.children[0].children.length;
	            var rowHeaderLength = rowHeaderTable.children[0].children.length;

	            var columnHeaderRows = columnHeaderTable.children[1].children;
	            var rowHeaderRows = rowHeaderTable.children[1].children;
	            var contentRows = this.widget.contentTree.children[0].children[1].children;

	            var columnRows = this._cells(columnHeaderRows, "header");

	            if (rowHeaderLength) {
	                columnRows[0].cells.splice(0, 0, {
	                    background: "#7a7a7a",
	                    color: "#fff",
	                    value: "",
	                    colSpan: rowHeaderLength,
	                    rowSpan: columnHeaderRows.length
	                });
	            }

	            var dataCallback = function(row, index) {
	                var j = 0;
	                var cell, value;
	                var cells = contentRows[index].children;

	                for (; j < columnHeaderLength; j++) {
	                    cell = cells[j];
	                    value = Number(cell.value);

	                    if (isNaN(value)) {
	                        value = cell.value;
	                    }

	                    row.push({
	                        background: "#dfdfdf",
	                        color: "#333",
	                        value: value,
	                        colSpan: 1,
	                        rowSpan: 1
	                    });
	                }
	            };

	            var rowRows = this._cells(rowHeaderRows, "data", dataCallback);

	            return columnRows.concat(rowRows);
	        },

	        _freezePane: function() {
	            var columnHeaderTable = this.widget.columnsHeaderTree.children[0];
	            var rowHeaderTable = this.widget.rowsHeaderTree.children[0];

	            var rowHeaderLength = rowHeaderTable.children[0].children.length;
	            var columnHeaderRows = columnHeaderTable.children[1].children;

	            return {
	                colSplit: rowHeaderLength,
	                rowSplit: columnHeaderRows.length
	            };
	        },

	        workbook: function() {
	            var promise;

	            if (this.dataSource.view()[0]) {
	                promise = $.Deferred();
	                promise.resolve();
	            } else {
	                promise = this.dataSource.fetch();
	            }

	            return promise.then($.proxy(function() {
	                return {
	                    sheets: [ {
	                       columns: this._columns(),
	                       rows: this._rows(),
	                       freezePane: this._freezePane(),
	                       filter: null
	                    } ]
	                };
	            }, this));
	        }
	    });

	    var PivotExcelMixin = {
	        extend: function(proto) {
	           proto.events.push("excelExport");
	           proto.options.excel = $.extend(proto.options.excel, this.options);
	           proto.saveAsExcel = this.saveAsExcel;
	        },
	        options: {
	            proxyURL: "",
	            filterable: false,
	            fileName: "Export.xlsx"
	        },
	        saveAsExcel: function() {
	            var excel = this.options.excel || {};

	            var exporter = new kendo.PivotExcelExporter({
	                widget: this
	            });

	            exporter.workbook().then($.proxy(function(book) {
	                if (!this.trigger("excelExport", { workbook: book })) {
	                    var workbook = new kendo.ooxml.Workbook(book);

	                    workbook.toDataURLAsync().then(function(dataURI) {
	                        kendo.saveAs({
	                            dataURI: dataURI,
	                            fileName: book.fileName || excel.fileName,
	                            proxyURL: excel.proxyURL,
	                            forceProxy: excel.forceProxy
	                        });
	                    });
	                }
	            }, this));
	        }
	    };

	    kendo.PivotExcelMixin = PivotExcelMixin;

	    if (kendo.ooxml && kendo.ooxml.Workbook) {
	        PivotExcelMixin.extend(PivotGrid.prototype);
	    }

	    if (kendo.PDFMixin) {
	        kendo.PDFMixin.extend(PivotGrid.prototype);

	        PivotGrid.fn._drawPDF = function() {
	            return this._drawPDFShadow({
	                width: this.wrapper.width()
	            }, {
	                avoidLinks: this.options.pdf.avoidLinks
	            });
	        };
	    }

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "Yobk":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("77Pl");
var dPs = __webpack_require__("qio6");
var enumBugKeys = __webpack_require__("xnc9");
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("ON07")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("RPLV").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "Ytuf":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(979);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(980) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($) {

	var kendo = window.kendo,
	    Class = kendo.Class,
	    extend = $.extend,
	    Editor = kendo.ui.editor,
	    formats = kendo.ui.Editor.fn.options.formats,
	    dom = Editor.Dom,
	    ToolTemplate = Editor.ToolTemplate,
	    FormatTool = Editor.FormatTool,
	    EditorUtils = Editor.EditorUtils,
	    registerTool = EditorUtils.registerTool,
	    registerFormat = EditorUtils.registerFormat,
	    RangeUtils = Editor.RangeUtils;

	var BlockFormatFinder = Class.extend({
	    init: function(format) {
	        this.format = format;
	    },

	    contains: function(node, children) {
	        var i, len, child;

	        for (i = 0, len = children.length; i < len; i++) {
	            child = children[i];
	            if (!child || !dom.isAncestorOrSelf(node, child)) {
	                return false;
	            }
	        }

	        return true;
	    },

	    findSuitable: function (nodes) {
	        var format = this.format,
	            suitable = [],
	            i, len, candidate;

	        for (i = 0, len = nodes.length; i < len; i++) {
	            for (var f = format.length - 1; f >= 0; f--) {
	                candidate = dom.ofType(nodes[i], format[f].tags) ? nodes[i] : dom.closestEditableOfType(nodes[i], format[f].tags);
	                if (candidate) {
	                    break;
	                }
	            }

	            if (!candidate || candidate.contentEditable === 'true') {
	                return [];
	            }

	            if ($.inArray(candidate, suitable) < 0) {
	                suitable.push(candidate);
	            }
	        }

	        this._resolveListsItems(suitable);

	        for (i = 0, len = suitable.length; i < len; i++) {
	            if (this.contains(suitable[i], suitable)) {
	                return [suitable[i]];
	            }
	        }

	        return suitable;
	    },
	    _resolveListsItems: function(nodes){
	        var i, node, wrapper;
	        for (i = 0; i < nodes.length; i++) {
	            node = nodes[i];
	            wrapper = dom.is(node, "li") ? node : dom.wrapper(node);
	            wrapper = wrapper && dom.list(wrapper) ? wrapper.children[0] : wrapper;
	            if (dom.is(wrapper, "li")) {
	                node = nodes[i] = wrapper;
	            }
	        }
	    },

	    findFormat: function (sourceNode) {
	        var format = this.format,
	            i, len, node, tags, attributes;
	        var editableParent = dom.editableParent(sourceNode);
	        var immutables = this.options && this.options.immutables;
	        var ImmutablesNS = Editor.Immutables;

	        for (i = 0, len = format.length; i < len; i++) {
	            node = sourceNode;
	            tags = format[i].tags;
	            attributes = format[i].attr;

	            if (immutables && tags && tags[0] == "immutable") {
	                var immutable = ImmutablesNS.immutableParent(node);
	                if (immutable && dom.attrEquals(immutable, attributes)) {
	                    return node;
	                }
	            }

	            while (node && dom.isAncestorOf(editableParent, node)) {
	                if (dom.ofType(node, tags) && dom.attrEquals(node, attributes)) {
	                    return node;
	                }

	                node = node.parentNode;
	            }
	        }
	        return null;
	    },

	    getFormat: function (nodes) {
	        var that = this,
	            findFormat = function(node) {
	                    return that.findFormat(dom.isDataNode(node) ? node.parentNode : node);
	                },
	            result = findFormat(nodes[0]),
	            i, len;

	        if (!result) {
	            return "";
	        }

	        for (i = 1, len = nodes.length; i < len; i++) {
	            if (result != findFormat(nodes[i])) {
	                return "";
	            }
	        }

	        return result.nodeName.toLowerCase();
	    },

	    isFormatted: function (nodes) {
	        for (var i = 0, len = nodes.length; i < len; i++) {
	            if (!this.findFormat(nodes[i])) {
	                return false;
	            }
	        }

	        return true;
	    }
	});

	var BlockFormatter = Class.extend({
	    init: function (format, values) {
	        this.format = format;
	        this.values = values;
	        this.finder = new BlockFormatFinder(format);
	    },

	    wrap: function(tag, attributes, nodes) {

	        var commonAncestor = nodes.length == 1 ? dom.blockParentOrBody(nodes[0]) : dom.commonAncestor.apply(null, nodes);

	        if (dom.isInline(commonAncestor)) {
	            commonAncestor = dom.blockParentOrBody(commonAncestor);
	        }

	        var ancestors = dom.significantChildNodes(commonAncestor),
	            position = dom.findNodeIndex(ancestors[0]),
	            wrapper = dom.create(commonAncestor.ownerDocument, tag, attributes),
	            i, ancestor;

	        for (i = 0; i < ancestors.length; i++) {
	            ancestor = ancestors[i];
	            if (dom.isBlock(ancestor)) {
	                dom.attr(ancestor, attributes);

	                if (wrapper.childNodes.length) {
	                    dom.insertBefore(wrapper, ancestor);
	                    wrapper = wrapper.cloneNode(false);
	                }

	                position = dom.findNodeIndex(ancestor) + 1;

	                continue;
	            }

	            wrapper.appendChild(ancestor);
	        }

	        if (wrapper.firstChild) {
	            dom.insertAt(commonAncestor, wrapper, position);
	        }
	    },

	    apply: function (nodes) {
	        var format, values = this.values;

	        function attributes(format) {
	            return extend({}, format && format.attr, values);
	        }

	        this._handleImmutables(nodes, true);

	        var images = dom.filter("img", nodes);
	        var imageFormat = EditorUtils.formatByName("img", this.format);
	        var imageAttributes = attributes(imageFormat);
	        $.each(images, function() {
	            dom.attr(this, imageAttributes);
	        });

	        // only images were selected, no need to wrap
	        if (images.length == nodes.length) {
	            return;
	        }

	        var nonImages = dom.filter("img", nodes, true);
	        var formatNodes = this.finder.findSuitable(nonImages);

	        if (formatNodes.length) {
	            for (var i = 0, len = formatNodes.length; i < len; i++) {
	                format = EditorUtils.formatByName(dom.name(formatNodes[i]), this.format);
	                dom.attr(formatNodes[i], attributes(format));
	            }
	        } else {
	            format = this.format[0];
	            this.wrap(format.tags[0], attributes(format), nonImages);
	        }
	    },

	    _handleImmutables: function (nodes, applyFormatting) {
	        if (!this.immutables()) {
	            return;
	        }
	        var immutableFormat = EditorUtils.formatByName("immutable", this.format);
	        if (!immutableFormat) {
	            return;
	        }
	        var ImmutablesNS = Editor.Immutables;
	        var l = nodes.length - 1;
	        for (var i = l; i >= 0; i--) {
	            var immutableParent = ImmutablesNS.immutableParent(nodes[i]);
	            if (!immutableParent) {
	                continue;
	            }
	            if (immutableParent !== nodes[i + 1]) {
	                if (applyFormatting) {
	                    dom.attr(immutableParent, immutableFormat.attr);
	                } else {
	                    dom.unstyle(immutableParent, immutableFormat.attr.style);
	                }
	            }
	            nodes.splice(i, 1);
	        }
	    },

	    immutables: function() {
	        return this.editor && this.editor.options.immutables;
	    },

	    remove: function (nodes) {
	        var i, l, formatNode, namedFormat, name;

	        this._handleImmutables(nodes, false);

	        for (i = 0, l = nodes.length; i < l; i++) {
	            formatNode = this.finder.findFormat(nodes[i]);
	            if (formatNode) {
	                name = dom.name(formatNode);
	                namedFormat = EditorUtils.formatByName(name, this.format);
	                if (namedFormat.attr.style) {
	                    dom.unstyle(formatNode, namedFormat.attr.style);
	                }
	                if (namedFormat.attr.className) {
	                    dom.removeClass(formatNode, namedFormat.attr.className);
	                }
	            }
	        }
	    },

	    toggle: function (range) {
	        var that = this,
	            nodes = dom.filterBy(RangeUtils.nodes(range), dom.htmlIndentSpace, true);

	        if (that.finder.isFormatted(nodes)) {
	            that.remove(nodes);
	        } else {
	            that.apply(nodes);
	        }
	    }
	});

	var GreedyBlockFormatter = Class.extend({
	    init: function (format, values) {
	        var that = this;
	        that.format = format;
	        that.values = values;
	        that.finder = new BlockFormatFinder(format);
	    },

	    apply: function (nodes) {
	        var format = this.format;
	        var blocks = dom.blockParents(nodes);
	        var formatTag = format[0].tags[0];
	        var i, len, list, formatter, range;
	        var element;
	        var tagName;
	        var block;
	        var immutalbeParent;

	        if (blocks.length) {
	            for (i = 0, len = blocks.length; i < len; i++) {
	                block = blocks[i];
	                immutalbeParent = this.immutables() && Editor.Immutables.immutableParent(block);

	                if (!immutalbeParent) {
	                    tagName = dom.name(block);

	                    if (tagName == "li") {
	                        list = block.parentNode;
	                        formatter = new Editor.ListFormatter(list.nodeName.toLowerCase(), formatTag);
	                        range = this.editor.createRange();
	                        range.selectNode(blocks[i]);
	                        formatter.toggle(range);
	                    } else if (formatTag && (tagName == "td" || block.attributes.contentEditable)) {
	                        new BlockFormatter(format, this.values).apply(block.childNodes);
	                    } else {
	                        element = dom.changeTag(block, formatTag);
	                        dom.attr(element, format[0].attr);
	                    }
	                }
	            }
	        } else {
	            var blockFormatter = new BlockFormatter(format, this.values);
	            blockFormatter.editor = this.editor;
	            blockFormatter.apply(nodes);
	        }
	    },

	    toggle: function (range) {
	        var nodes = RangeUtils.textNodes(range);
	        if (!nodes.length) {
	            range.selectNodeContents(range.commonAncestorContainer);
	            nodes = RangeUtils.textNodes(range);
	            if (!nodes.length) {
	                nodes = dom.significantChildNodes(range.commonAncestorContainer);
	            }
	        }

	        this.apply(nodes);
	    },

	    immutables: function() {
	        return this.editor && this.editor.options.immutables;
	    }
	});

	var BlockFormatTool = FormatTool.extend({ init: function (options) {
	        FormatTool.fn.init.call(this, extend(options, {
	            finder: new BlockFormatFinder(options.format),
	            formatter: function () {
	                return new BlockFormatter(options.format);
	            }
	        }));
	    }
	});

	extend(Editor, {
	    BlockFormatFinder: BlockFormatFinder,
	    BlockFormatter: BlockFormatter,
	    GreedyBlockFormatter: GreedyBlockFormatter,
	    BlockFormatTool: BlockFormatTool
	});

	var listElements = ["ul","ol","li"];

	registerFormat("justifyLeft", [
	    { tags: dom.nonListBlockElements, attr: { style: { textAlign: "left" }} },
	    { tags: ["img"], attr: { style: { "float": "left", display: "", marginLeft: "", marginRight: "" }} },
	    { tags: ["immutable"], attr: { style: { "float": "left", display: "", marginLeft: "", marginRight: "" }} },
	    { tags: listElements, attr: { style: { textAlign: "left", listStylePosition: "" }} }
	]);
	registerTool("justifyLeft", new BlockFormatTool({
	    format: formats.justifyLeft,
	    template: new ToolTemplate({
	        template: EditorUtils.buttonTemplate,
	        title: "Justify Left"
	    })
	}));

	registerFormat("justifyCenter", [
	    { tags: dom.nonListBlockElements, attr: { style: { textAlign: "center" }} },
	    { tags: ["img"], attr: { style: { display: "block", marginLeft: "auto", marginRight: "auto", "float": "" }} },
	    { tags: ["immutable"], attr: { style: { display: "block", marginLeft: "auto", marginRight: "auto", "float": "" }} },
	    { tags: listElements, attr: { style: { textAlign: "center", listStylePosition: "inside" }} }
	]);
	registerTool("justifyCenter", new BlockFormatTool({
	    format: formats.justifyCenter,
	    template: new ToolTemplate({
	        template: EditorUtils.buttonTemplate,
	        title: "Justify Center"
	    })
	}));

	registerFormat("justifyRight", [
	    { tags: dom.nonListBlockElements, attr: { style: { textAlign: "right" }} },
	    { tags: ["img"], attr: { style: { "float": "right", display: "", marginLeft: "", marginRight: "" }} },
	    { tags: ["immutable"], attr: { style: { "float": "right", display: "", marginLeft: "", marginRight: "" }} },
	    { tags: listElements, attr: { style: { textAlign: "right", listStylePosition: "inside" }} }
	]);
	registerTool("justifyRight", new BlockFormatTool({
	    format: formats.justifyRight,
	    template: new ToolTemplate({
	        template: EditorUtils.buttonTemplate,
	        title: "Justify Right"
	    })
	}));

	registerFormat("justifyFull", [
	    { tags: dom.nonListBlockElements, attr: { style: { textAlign: "justify" }} },
	    { tags: ["img"], attr: { style: { display: "block", marginLeft: "auto", marginRight: "auto", "float": "" }} },
	    { tags: ["immutable"], attr: { style: { display: "block", marginLeft: "auto", marginRight: "auto", "float": "" }} },
	    { tags: listElements, attr: { style: { textAlign: "justify", listStylePosition: "" }} }
	]);
	registerTool("justifyFull", new BlockFormatTool({
	    format: formats.justifyFull,
	    template: new ToolTemplate({
	        template: EditorUtils.buttonTemplate,
	        title: "Justify Full"
	    })
	}));

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 980:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("N+Bk");

/***/ })

/******/ });

/***/ }),

/***/ "Yz+S":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1322);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1296:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ur7x");

/***/ }),

/***/ 1297:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("RnqI");

/***/ }),

/***/ 1322:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1297), __webpack_require__(1296) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.pane",
	    name: "Pane",
	    category: "mobile",
	    description: "Mobile Pane",
	    depends: [ "mobile.view", "mobile.loader" ],
	    hidden: true
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        mobile = kendo.mobile,
	        roleSelector = kendo.roleSelector,
	        ui = mobile.ui,
	        Widget = ui.Widget,
	        ViewEngine = mobile.ViewEngine,
	        View = ui.View,
	        Loader = mobile.ui.Loader,

	        EXTERNAL = "external",
	        HREF = "href",
	        DUMMY_HREF = "#!",

	        NAVIGATE = "navigate",
	        VIEW_SHOW = "viewShow",
	        SAME_VIEW_REQUESTED = "sameViewRequested",
	        OS = kendo.support.mobileOS,
	        SKIP_TRANSITION_ON_BACK_BUTTON = OS.ios && !OS.appMode && OS.flatVersion >= 700,
	        WIDGET_RELS = /popover|actionsheet|modalview|drawer/,
	        BACK = "#:back",

	        attrValue = kendo.attrValue;

	    var Pane = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            options = that.options;
	            element = that.element;

	            element.addClass("km-pane");

	            if (that.options.collapsible) {
	                element.addClass("km-collapsible-pane");
	            }

	            this.history = [];

	            this.historyCallback = function(url, params, backButtonPressed) {
	                var transition = that.transition;
	                that.transition = null;

	                // swiping back in iOS leaves the app in a very broken state if we perform a transition
	                if (SKIP_TRANSITION_ON_BACK_BUTTON && backButtonPressed) {
	                    transition = "none";
	                }

	                return that.viewEngine.showView(url, transition, params);
	            };

	            this._historyNavigate = function(url) {
	                if (url === BACK) {
	                    if (that.history.length === 1) {
	                        return;
	                    }

	                    that.history.pop();
	                    url = that.history[that.history.length - 1];
	                } else {
	                    that.history.push(url);
	                }

	                that.historyCallback(url, kendo.parseQueryStringParams(url));
	            };

	            this._historyReplace = function(url) {
	                var params = kendo.parseQueryStringParams(url);
	                that.history[that.history.length - 1] = url;
	                that.historyCallback(url, params);
	            };

	            that.loader = new Loader(element, {
	                loading: that.options.loading
	            });

	            that.viewEngine = new ViewEngine({
	                container: element,
	                transition: options.transition,
	                modelScope: options.modelScope,
	                rootNeeded: !options.initial,
	                serverNavigation: options.serverNavigation,
	                remoteViewURLPrefix: options.root || "",
	                layout: options.layout,
	                $angular: options.$angular,
	                loader: that.loader,

	                showStart: function() {
	                    that.loader.transition();
	                    that.closeActiveDialogs();
	                },

	                after: function() {
	                    that.loader.transitionDone();
	                },

	                viewShow: function(e) {
	                    that.trigger(VIEW_SHOW, e);
	                },

	                loadStart: function() {
	                    that.loader.show();
	                },

	                loadComplete: function() {
	                    that.loader.hide();
	                },

	                sameViewRequested: function() {
	                    that.trigger(SAME_VIEW_REQUESTED);
	                },

	                viewTypeDetermined: function(e) {
	                    if (!e.remote || !that.options.serverNavigation)  {
	                        that.trigger(NAVIGATE, { url: e.url });
	                    }
	                }
	            });


	            this._setPortraitWidth();

	            kendo.onResize(function() {
	                that._setPortraitWidth();
	            });

	            that._setupAppLinks();
	        },

	        closeActiveDialogs: function() {
	            var dialogs = this.element.find(roleSelector("actionsheet popover modalview")).filter(":visible");
	            dialogs.each(function() {
	                kendo.widgetInstance($(this), ui).close();
	            });
	        },

	        navigateToInitial: function() {
	            var initial = this.options.initial;

	            if (initial) {
	                this.navigate(initial);
	            }

	            return initial;
	        },

	        options: {
	            name: "Pane",
	            portraitWidth: "",
	            transition: "",
	            layout: "",
	            collapsible: false,
	            initial: null,
	            modelScope: window,
	            loading: "<h1>Loading...</h1>"
	        },

	        events: [
	            NAVIGATE,
	            VIEW_SHOW,
	            SAME_VIEW_REQUESTED
	        ],

	        append: function(html) {
	            return this.viewEngine.append(html);
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            this.viewEngine.destroy();
	            this.userEvents.destroy();
	        },

	        navigate: function(url, transition) {
	            if (url instanceof View) {
	                url = url.id;
	            }

	            this.transition = transition;

	            this._historyNavigate(url);
	        },

	        replace: function(url, transition) {
	            if (url instanceof View) {
	                url = url.id;
	            }

	            this.transition = transition;

	            this._historyReplace(url);
	        },

	        bindToRouter: function(router) {
	            var that = this,
	                history = this.history,
	                viewEngine = this.viewEngine;

	            router.bind("init", function(e) {
	                var url = e.url,
	                    attrUrl = router.pushState ? url : "/";

	                viewEngine.rootView.attr(kendo.attr("url"), attrUrl);

	                // if current is set, then this means that the pane has navigated to a given view - we need to update the router accordingly.
	                var length = history.length;

	                if (url === "/" && length) {
	                    router.navigate(history[length - 1], true);
	                    e.preventDefault(); // prevents from executing routeMissing, by default
	                }
	            });

	            router.bind("routeMissing", function(e) {
	                if (!that.historyCallback(e.url, e.params, e.backButtonPressed)) {
	                    e.preventDefault();
	                }
	            });

	            router.bind("same", function() {
	                that.trigger(SAME_VIEW_REQUESTED);
	            });

	            that._historyNavigate = function(url) {
	                router.navigate(url);
	            };

	            that._historyReplace = function(url) {
	                router.replace(url);
	            };
	        },

	        hideLoading: function() {
	            this.loader.hide();
	        },

	        showLoading: function() {
	            this.loader.show();
	        },

	        changeLoadingMessage: function(message) {
	            this.loader.changeMessage(message);
	        },

	        view: function() {
	            return this.viewEngine.view();
	        },

	        _setPortraitWidth: function() {
	            var width,
	                portraitWidth = this.options.portraitWidth;

	            if (portraitWidth) {
	                width = kendo.mobile.application.element.is(".km-vertical") ? portraitWidth : "auto";
	                this.element.css("width", width);
	            }
	        },

	        _setupAppLinks: function() {
	            var that = this,
	                linkRoles = "tab",
	                pressedButtonSelector = "[data-" + kendo.ns + "navigate-on-press]",

	                buttonSelectors = $.map(["button", "backbutton", "detailbutton", "listview-link"] , function(role) {
	                    return roleSelector(role) + ":not(" + pressedButtonSelector + ")";
	                }).join(",");

	            this.element.handler(this)
	                .on("down", roleSelector(linkRoles) + "," + pressedButtonSelector, "_mouseup")
	                .on("click", roleSelector(linkRoles) + "," + buttonSelectors + "," + pressedButtonSelector, "_appLinkClick");

	            this.userEvents = new kendo.UserEvents(this.element, {
	                fastTap: true,
	                filter: buttonSelectors,
	                tap: function(e) {
	                    e.event.currentTarget = e.touch.currentTarget;
	                    that._mouseup(e.event);
	                }
	            });

	            // remove the ms-touch-action added by the user events, breaks native scrolling in WP8
	            this.element.css('-ms-touch-action', '');
	        },

	        _appLinkClick: function (e) {
	            var href = $(e.currentTarget).attr("href");
	            var remote = href && href[0] !== "#" && this.options.serverNavigation;

	            if(!remote && attrValue($(e.currentTarget), "rel") != EXTERNAL) {
	                e.preventDefault();
	            }
	        },

	        _mouseup: function(e) {
	            if (e.which > 1 || e.isDefaultPrevented()) {
	                return;
	            }

	            var pane = this,
	                link = $(e.currentTarget),
	                transition = attrValue(link, "transition"),
	                rel = attrValue(link, "rel") || "",
	                target = attrValue(link, "target"),
	                href = link.attr(HREF),
	                delayedTouchEnd = SKIP_TRANSITION_ON_BACK_BUTTON && link[0].offsetHeight === 0,
	                remote = href && href[0] !== "#" && this.options.serverNavigation;

	            if (delayedTouchEnd || remote || rel === EXTERNAL || (typeof href === "undefined") || href === DUMMY_HREF) {
	                return;
	            }

	            // Prevent iOS address bar progress display for in app navigation
	            link.attr(HREF, DUMMY_HREF);
	            setTimeout(function() { link.attr(HREF, href); });

	            if (rel.match(WIDGET_RELS)) {
	                kendo.widgetInstance($(href), ui).openFor(link);
	                // if propagation is not stopped and actionsheet is opened from tabstrip,
	                // the actionsheet is closed immediately.
	                if (rel === "actionsheet" || rel === "drawer") {
	                    e.stopPropagation();
	                }
	            } else {
	                if (target === "_top") {
	                    pane = mobile.application.pane;
	                }
	                else if (target) {
	                    pane = $("#" + target).data("kendoMobilePane");
	                }

	                pane.navigate(href, transition);
	            }

	            e.preventDefault();
	        }
	    });

	    Pane.wrap = function(element) {
	        if (!element.is(roleSelector("view"))) {
	            element = element.wrap('<div data-' + kendo.ns + 'role="view" data-stretch="true"></div>').parent();
	        }

	        var paneContainer = element.wrap('<div class="km-pane-wrapper"><div></div></div>').parent(),
	            pane = new Pane(paneContainer);

	        pane.navigate("");

	        return pane;
	    };
	    ui.plugin(Pane);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "Z3DQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var eventService_1 = __webpack_require__("k5uU");
var constants_1 = __webpack_require__("ZZFX");
var componentUtil_1 = __webpack_require__("f42d");
var gridApi_1 = __webpack_require__("BAow");
var context_1 = __webpack_require__("RQ1/");
var columnApi_1 = __webpack_require__("E/Wy");
var columnController_1 = __webpack_require__("77lH");
var utils_1 = __webpack_require__("IRr6");
var environment_1 = __webpack_require__("JLYF");
var DEFAULT_ROW_HEIGHT = 25;
var DEFAULT_DETAIL_ROW_HEIGHT = 300;
var DEFAULT_VIEWPORT_ROW_MODEL_PAGE_SIZE = 5;
var DEFAULT_VIEWPORT_ROW_MODEL_BUFFER_SIZE = 5;
var legacyThemes = [
    'ag-fresh',
    'ag-bootstrap',
    'ag-blue',
    'ag-dark',
    'ag-material'
];
function isTrue(value) {
    return value === true || value === 'true';
}
function zeroOrGreater(value, defaultValue) {
    if (value >= 0) {
        return value;
    }
    else {
        // zero gets returned if number is missing or the wrong type
        return defaultValue;
    }
}
function oneOrGreater(value, defaultValue) {
    if (value > 0) {
        return value;
    }
    else {
        // zero gets returned if number is missing or the wrong type
        return defaultValue;
    }
}
var GridOptionsWrapper = (function () {
    function GridOptionsWrapper() {
        this.propertyEventService = new eventService_1.EventService();
        this.domDataKey = '__AG_' + Math.random().toString();
    }
    GridOptionsWrapper_1 = GridOptionsWrapper;
    GridOptionsWrapper.prototype.agWire = function (gridApi, columnApi) {
        this.gridOptions.api = gridApi;
        this.gridOptions.columnApi = columnApi;
        this.checkForDeprecated();
    };
    GridOptionsWrapper.prototype.destroy = function () {
        // need to remove these, as we don't own the lifecycle of the gridOptions, we need to
        // remove the references in case the user keeps the grid options, we want the rest
        // of the grid to be picked up by the garbage collector
        this.gridOptions.api = null;
        this.gridOptions.columnApi = null;
    };
    GridOptionsWrapper.prototype.init = function () {
        var async = this.useAsyncEvents();
        this.eventService.addGlobalListener(this.globalEventHandler.bind(this), async);
        if (this.isGroupSelectsChildren() && this.isSuppressParentsInRowNodes()) {
            console.warn('ag-Grid: groupSelectsChildren does not work wth suppressParentsInRowNodes, this selection method needs the part in rowNode to work');
        }
        if (this.isGroupSelectsChildren()) {
            if (!this.isRowSelectionMulti()) {
                console.warn("ag-Grid: rowSelection must be 'multiple' for groupSelectsChildren to make sense");
            }
            if (this.isRowModelEnterprise()) {
                console.warn('ag-Grid: group selects children is NOT support for Enterprise Row Model. ' +
                    'This is because the rows are lazy loaded, so selecting a group is not possible as' +
                    'the grid has no way of knowing what the children are.');
            }
        }
        if (this.isGroupRemoveSingleChildren() && this.isGroupHideOpenParents()) {
            console.warn('ag-Grid: groupRemoveSingleChildren and groupHideOpenParents do not work with each other, you need to pick one. And don\'t ask us how to us these together on our support forum either you will get the same answer!');
        }
    };
    // returns the dom data, or undefined if not found
    GridOptionsWrapper.prototype.getDomData = function (element, key) {
        var domData = element[this.domDataKey];
        if (domData) {
            return domData[key];
        }
        else {
            return undefined;
        }
    };
    GridOptionsWrapper.prototype.setDomData = function (element, key, value) {
        var domData = element[this.domDataKey];
        if (utils_1.Utils.missing(domData)) {
            domData = {};
            element[this.domDataKey] = domData;
        }
        domData[key] = value;
    };
    GridOptionsWrapper.prototype.isEnterprise = function () { return this.enterprise; };
    GridOptionsWrapper.prototype.isRowSelection = function () { return this.gridOptions.rowSelection === "single" || this.gridOptions.rowSelection === "multiple"; };
    GridOptionsWrapper.prototype.isRowDeselection = function () { return isTrue(this.gridOptions.rowDeselection); };
    GridOptionsWrapper.prototype.isRowSelectionMulti = function () { return this.gridOptions.rowSelection === 'multiple'; };
    GridOptionsWrapper.prototype.getContext = function () { return this.gridOptions.context; };
    GridOptionsWrapper.prototype.isPivotMode = function () { return isTrue(this.gridOptions.pivotMode); };
    GridOptionsWrapper.prototype.isPivotTotals = function () { return isTrue(this.gridOptions.pivotTotals); };
    GridOptionsWrapper.prototype.isRowModelInfinite = function () { return this.gridOptions.rowModelType === constants_1.Constants.ROW_MODEL_TYPE_INFINITE; };
    GridOptionsWrapper.prototype.isRowModelViewport = function () { return this.gridOptions.rowModelType === constants_1.Constants.ROW_MODEL_TYPE_VIEWPORT; };
    GridOptionsWrapper.prototype.isRowModelEnterprise = function () { return this.gridOptions.rowModelType === constants_1.Constants.ROW_MODEL_TYPE_ENTERPRISE; };
    GridOptionsWrapper.prototype.isRowModelDefault = function () {
        return utils_1.Utils.missing(this.gridOptions.rowModelType) ||
            this.gridOptions.rowModelType === constants_1.Constants.ROW_MODEL_TYPE_IN_MEMORY ||
            this.gridOptions.rowModelType === constants_1.Constants.DEPRECATED_ROW_MODEL_TYPE_NORMAL;
    };
    GridOptionsWrapper.prototype.isFullRowEdit = function () { return this.gridOptions.editType === 'fullRow'; };
    GridOptionsWrapper.prototype.isSuppressFocusAfterRefresh = function () { return isTrue(this.gridOptions.suppressFocusAfterRefresh); };
    GridOptionsWrapper.prototype.isShowToolPanel = function () { return isTrue(this.gridOptions.showToolPanel); };
    GridOptionsWrapper.prototype.isToolPanelSuppressValues = function () { return isTrue(this.gridOptions.toolPanelSuppressValues); };
    GridOptionsWrapper.prototype.isToolPanelSuppressPivots = function () {
        // we don't allow pivots when doing tree data
        return isTrue(this.gridOptions.toolPanelSuppressPivots) || this.isTreeData();
    };
    GridOptionsWrapper.prototype.isToolPanelSuppressRowGroups = function () {
        // we don't allow row grouping when doing tree data
        return isTrue(this.gridOptions.toolPanelSuppressRowGroups) || this.isTreeData();
    };
    GridOptionsWrapper.prototype.isToolPanelSuppressPivotMode = function () {
        return isTrue(this.gridOptions.toolPanelSuppressPivotMode) || this.isTreeData();
    };
    GridOptionsWrapper.prototype.isSuppressTouch = function () { return isTrue(this.gridOptions.suppressTouch); };
    GridOptionsWrapper.prototype.useAsyncEvents = function () { return !isTrue(this.gridOptions.suppressAsyncEvents); };
    GridOptionsWrapper.prototype.isEnableCellChangeFlash = function () { return isTrue(this.gridOptions.enableCellChangeFlash); };
    GridOptionsWrapper.prototype.isGroupSelectsChildren = function () {
        var result = isTrue(this.gridOptions.groupSelectsChildren);
        if (result && this.isTreeData()) {
            console.warn('ag-Grid: groupSelectsChildren does not work with tree data');
            return false;
        }
        else {
            return result;
        }
    };
    GridOptionsWrapper.prototype.isGroupSelectsFiltered = function () { return isTrue(this.gridOptions.groupSelectsFiltered); };
    GridOptionsWrapper.prototype.isGroupHideOpenParents = function () { return isTrue(this.gridOptions.groupHideOpenParents); };
    // if we are doing hideOpenParents, then we always have groupMultiAutoColumn, otherwise hideOpenParents would not work
    GridOptionsWrapper.prototype.isGroupMultiAutoColumn = function () { return isTrue(this.gridOptions.groupMultiAutoColumn) || isTrue(this.gridOptions.groupHideOpenParents); };
    GridOptionsWrapper.prototype.isGroupRemoveSingleChildren = function () { return isTrue(this.gridOptions.groupRemoveSingleChildren); };
    GridOptionsWrapper.prototype.isGroupRemoveLowestSingleChildren = function () { return isTrue(this.gridOptions.groupRemoveLowestSingleChildren); };
    GridOptionsWrapper.prototype.isGroupIncludeFooter = function () { return isTrue(this.gridOptions.groupIncludeFooter); };
    GridOptionsWrapper.prototype.isGroupSuppressBlankHeader = function () { return isTrue(this.gridOptions.groupSuppressBlankHeader); };
    GridOptionsWrapper.prototype.isSuppressRowClickSelection = function () { return isTrue(this.gridOptions.suppressRowClickSelection); };
    GridOptionsWrapper.prototype.isSuppressCellSelection = function () { return isTrue(this.gridOptions.suppressCellSelection); };
    GridOptionsWrapper.prototype.isSuppressMultiSort = function () { return isTrue(this.gridOptions.suppressMultiSort); };
    GridOptionsWrapper.prototype.isGroupSuppressAutoColumn = function () { return isTrue(this.gridOptions.groupSuppressAutoColumn); };
    GridOptionsWrapper.prototype.isSuppressDragLeaveHidesColumns = function () { return isTrue(this.gridOptions.suppressDragLeaveHidesColumns); };
    GridOptionsWrapper.prototype.isSuppressScrollOnNewData = function () { return isTrue(this.gridOptions.suppressScrollOnNewData); };
    GridOptionsWrapper.prototype.isRowDragManaged = function () { return isTrue(this.gridOptions.rowDragManaged); };
    GridOptionsWrapper.prototype.isSuppressRowDrag = function () { return isTrue(this.gridOptions.suppressRowDrag); };
    GridOptionsWrapper.prototype.isForPrint = function () { return this.gridOptions.domLayout === 'forPrint'; };
    GridOptionsWrapper.prototype.isAutoHeight = function () { return this.gridOptions.domLayout === 'autoHeight'; };
    GridOptionsWrapper.prototype.isNormalDomLayout = function () { return !this.isForPrint() && !this.isAutoHeight(); };
    GridOptionsWrapper.prototype.isSuppressHorizontalScroll = function () { return isTrue(this.gridOptions.suppressHorizontalScroll); };
    GridOptionsWrapper.prototype.isSuppressLoadingOverlay = function () { return isTrue(this.gridOptions.suppressLoadingOverlay); };
    GridOptionsWrapper.prototype.isSuppressNoRowsOverlay = function () { return isTrue(this.gridOptions.suppressNoRowsOverlay); };
    GridOptionsWrapper.prototype.isSuppressFieldDotNotation = function () { return isTrue(this.gridOptions.suppressFieldDotNotation); };
    GridOptionsWrapper.prototype.getPinnedTopRowData = function () { return this.gridOptions.pinnedTopRowData; };
    GridOptionsWrapper.prototype.getPinnedBottomRowData = function () { return this.gridOptions.pinnedBottomRowData; };
    GridOptionsWrapper.prototype.isFunctionsPassive = function () { return isTrue(this.gridOptions.functionsPassive); };
    GridOptionsWrapper.prototype.isSuppressTabbing = function () { return isTrue(this.gridOptions.suppressTabbing); };
    GridOptionsWrapper.prototype.isSuppressChangeDetection = function () { return isTrue(this.gridOptions.suppressChangeDetection); };
    GridOptionsWrapper.prototype.isSuppressAnimationFrame = function () { return isTrue(this.gridOptions.suppressAnimationFrame); };
    GridOptionsWrapper.prototype.getQuickFilterText = function () { return this.gridOptions.quickFilterText; };
    GridOptionsWrapper.prototype.isCacheQuickFilter = function () { return isTrue(this.gridOptions.cacheQuickFilter); };
    GridOptionsWrapper.prototype.isUnSortIcon = function () { return isTrue(this.gridOptions.unSortIcon); };
    GridOptionsWrapper.prototype.isSuppressMenuHide = function () { return isTrue(this.gridOptions.suppressMenuHide); };
    GridOptionsWrapper.prototype.isEnterMovesDownAfterEdit = function () { return isTrue(this.gridOptions.enterMovesDownAfterEdit); };
    GridOptionsWrapper.prototype.getRowStyle = function () { return this.gridOptions.rowStyle; };
    GridOptionsWrapper.prototype.getRowClass = function () { return this.gridOptions.rowClass; };
    GridOptionsWrapper.prototype.getRowStyleFunc = function () { return this.gridOptions.getRowStyle; };
    GridOptionsWrapper.prototype.getRowClassFunc = function () { return this.gridOptions.getRowClass; };
    GridOptionsWrapper.prototype.rowClassRules = function () { return this.gridOptions.rowClassRules; };
    GridOptionsWrapper.prototype.getPopupParent = function () { return this.gridOptions.popupParent; };
    GridOptionsWrapper.prototype.getPostProcessPopupFunc = function () { return this.gridOptions.postProcessPopup; };
    GridOptionsWrapper.prototype.getDoesDataFlowerFunc = function () { return this.gridOptions.doesDataFlower; };
    GridOptionsWrapper.prototype.getPaginationNumberFormatterFunc = function () { return this.gridOptions.paginationNumberFormatter; };
    GridOptionsWrapper.prototype.getChildCountFunc = function () { return this.gridOptions.getChildCount; };
    GridOptionsWrapper.prototype.getIsFullWidthCellFunc = function () { return this.gridOptions.isFullWidthCell; };
    GridOptionsWrapper.prototype.getFullWidthCellRendererParams = function () { return this.gridOptions.fullWidthCellRendererParams; };
    GridOptionsWrapper.prototype.isEmbedFullWidthRows = function () {
        // if autoHeight, we always embed fullWidth rows, otherwise we let the user decide
        return this.isAutoHeight() || isTrue(this.gridOptions.embedFullWidthRows);
    };
    GridOptionsWrapper.prototype.getBusinessKeyForNodeFunc = function () { return this.gridOptions.getBusinessKeyForNode; };
    GridOptionsWrapper.prototype.getApi = function () { return this.gridOptions.api; };
    GridOptionsWrapper.prototype.getColumnApi = function () { return this.gridOptions.columnApi; };
    GridOptionsWrapper.prototype.isDeltaRowDataMode = function () { return isTrue(this.gridOptions.deltaRowDataMode); };
    GridOptionsWrapper.prototype.isEnsureDomOrder = function () { return isTrue(this.gridOptions.ensureDomOrder); };
    GridOptionsWrapper.prototype.isEnableColResize = function () { return isTrue(this.gridOptions.enableColResize); };
    GridOptionsWrapper.prototype.isSingleClickEdit = function () { return isTrue(this.gridOptions.singleClickEdit); };
    GridOptionsWrapper.prototype.isSuppressClickEdit = function () { return isTrue(this.gridOptions.suppressClickEdit); };
    GridOptionsWrapper.prototype.isStopEditingWhenGridLosesFocus = function () { return isTrue(this.gridOptions.stopEditingWhenGridLosesFocus); };
    GridOptionsWrapper.prototype.getGroupDefaultExpanded = function () { return this.gridOptions.groupDefaultExpanded; };
    GridOptionsWrapper.prototype.getMaxConcurrentDatasourceRequests = function () { return this.gridOptions.maxConcurrentDatasourceRequests; };
    GridOptionsWrapper.prototype.getMaxBlocksInCache = function () { return this.gridOptions.maxBlocksInCache; };
    GridOptionsWrapper.prototype.getCacheOverflowSize = function () { return this.gridOptions.cacheOverflowSize; };
    GridOptionsWrapper.prototype.getPaginationPageSize = function () { return this.gridOptions.paginationPageSize; };
    GridOptionsWrapper.prototype.getCacheBlockSize = function () { return this.gridOptions.cacheBlockSize; };
    GridOptionsWrapper.prototype.getInfiniteInitialRowCount = function () { return this.gridOptions.infiniteInitialRowCount; };
    GridOptionsWrapper.prototype.isPurgeClosedRowNodes = function () { return isTrue(this.gridOptions.purgeClosedRowNodes); };
    GridOptionsWrapper.prototype.isSuppressPaginationPanel = function () { return isTrue(this.gridOptions.suppressPaginationPanel); };
    GridOptionsWrapper.prototype.getRowData = function () { return this.gridOptions.rowData; };
    GridOptionsWrapper.prototype.isGroupUseEntireRow = function () { return isTrue(this.gridOptions.groupUseEntireRow); };
    GridOptionsWrapper.prototype.isEnableRtl = function () { return isTrue(this.gridOptions.enableRtl); };
    GridOptionsWrapper.prototype.getAutoGroupColumnDef = function () { return this.gridOptions.autoGroupColumnDef; };
    GridOptionsWrapper.prototype.isGroupSuppressRow = function () { return isTrue(this.gridOptions.groupSuppressRow); };
    GridOptionsWrapper.prototype.getRowGroupPanelShow = function () { return this.gridOptions.rowGroupPanelShow; };
    GridOptionsWrapper.prototype.getPivotPanelShow = function () { return this.gridOptions.pivotPanelShow; };
    GridOptionsWrapper.prototype.isAngularCompileRows = function () { return isTrue(this.gridOptions.angularCompileRows); };
    GridOptionsWrapper.prototype.isAngularCompileFilters = function () { return isTrue(this.gridOptions.angularCompileFilters); };
    GridOptionsWrapper.prototype.isAngularCompileHeaders = function () { return isTrue(this.gridOptions.angularCompileHeaders); };
    GridOptionsWrapper.prototype.isDebug = function () { return isTrue(this.gridOptions.debug); };
    GridOptionsWrapper.prototype.getColumnDefs = function () { return this.gridOptions.columnDefs; };
    GridOptionsWrapper.prototype.getColumnTypes = function () { return this.gridOptions.columnTypes; };
    GridOptionsWrapper.prototype.getDatasource = function () { return this.gridOptions.datasource; };
    GridOptionsWrapper.prototype.getViewportDatasource = function () { return this.gridOptions.viewportDatasource; };
    GridOptionsWrapper.prototype.getEnterpriseDatasource = function () { return this.gridOptions.enterpriseDatasource; };
    GridOptionsWrapper.prototype.isEnableSorting = function () { return isTrue(this.gridOptions.enableSorting) || isTrue(this.gridOptions.enableServerSideSorting); };
    GridOptionsWrapper.prototype.isAccentedSort = function () { return isTrue(this.gridOptions.accentedSort); };
    GridOptionsWrapper.prototype.isEnableCellExpressions = function () { return isTrue(this.gridOptions.enableCellExpressions); };
    GridOptionsWrapper.prototype.isEnableGroupEdit = function () { return isTrue(this.gridOptions.enableGroupEdit); };
    GridOptionsWrapper.prototype.isSuppressMiddleClickScrolls = function () { return isTrue(this.gridOptions.suppressMiddleClickScrolls); };
    GridOptionsWrapper.prototype.isSuppressPreventDefaultOnMouseWheel = function () { return isTrue(this.gridOptions.suppressPreventDefaultOnMouseWheel); };
    GridOptionsWrapper.prototype.isSuppressColumnVirtualisation = function () { return isTrue(this.gridOptions.suppressColumnVirtualisation); };
    GridOptionsWrapper.prototype.isSuppressContextMenu = function () { return isTrue(this.gridOptions.suppressContextMenu); };
    GridOptionsWrapper.prototype.isAllowContextMenuWithControlKey = function () { return isTrue(this.gridOptions.allowContextMenuWithControlKey); };
    GridOptionsWrapper.prototype.isSuppressCopyRowsToClipboard = function () { return isTrue(this.gridOptions.suppressCopyRowsToClipboard); };
    GridOptionsWrapper.prototype.isEnableFilter = function () { return isTrue(this.gridOptions.enableFilter) || isTrue(this.gridOptions.enableServerSideFilter); };
    GridOptionsWrapper.prototype.isPagination = function () { return isTrue(this.gridOptions.pagination); };
    // these are deprecated, should remove them when we take out server side pagination
    GridOptionsWrapper.prototype.isEnableServerSideFilter = function () { return this.gridOptions.enableServerSideFilter; };
    GridOptionsWrapper.prototype.isEnableServerSideSorting = function () { return isTrue(this.gridOptions.enableServerSideSorting); };
    GridOptionsWrapper.prototype.isSuppressMovableColumns = function () { return isTrue(this.gridOptions.suppressMovableColumns); };
    GridOptionsWrapper.prototype.isAnimateRows = function () {
        // never allow animating if enforcing the row order
        if (this.isEnsureDomOrder()) {
            return false;
        }
        return isTrue(this.gridOptions.animateRows);
    };
    GridOptionsWrapper.prototype.isSuppressColumnMoveAnimation = function () { return isTrue(this.gridOptions.suppressColumnMoveAnimation); };
    GridOptionsWrapper.prototype.isSuppressAggFuncInHeader = function () { return isTrue(this.gridOptions.suppressAggFuncInHeader); };
    GridOptionsWrapper.prototype.isSuppressAggAtRootLevel = function () { return isTrue(this.gridOptions.suppressAggAtRootLevel); };
    GridOptionsWrapper.prototype.isEnableRangeSelection = function () { return isTrue(this.gridOptions.enableRangeSelection); };
    GridOptionsWrapper.prototype.isSuppressMultiRangeSelection = function () { return isTrue(this.gridOptions.suppressMultiRangeSelection); };
    GridOptionsWrapper.prototype.isPaginationAutoPageSize = function () { return isTrue(this.gridOptions.paginationAutoPageSize); };
    GridOptionsWrapper.prototype.isRememberGroupStateWhenNewData = function () { return isTrue(this.gridOptions.rememberGroupStateWhenNewData); };
    GridOptionsWrapper.prototype.getIcons = function () { return this.gridOptions.icons; };
    GridOptionsWrapper.prototype.getAggFuncs = function () { return this.gridOptions.aggFuncs; };
    GridOptionsWrapper.prototype.getSortingOrder = function () { return this.gridOptions.sortingOrder; };
    GridOptionsWrapper.prototype.getAlignedGrids = function () { return this.gridOptions.alignedGrids; };
    GridOptionsWrapper.prototype.isMasterDetail = function () {
        var _this = this;
        var usingMasterDetail = isTrue(this.gridOptions.masterDetail);
        utils_1.Utils.doOnce(function () {
            if (usingMasterDetail && !_this.enterprise) {
                console.warn('ag-grid: Master Detail is an Enterprise feature of ag-Grid.');
            }
        }, 'MasterDetailEnterpriseCheck');
        return usingMasterDetail && this.enterprise;
    };
    GridOptionsWrapper.prototype.getIsRowMasterFunc = function () { return this.gridOptions.isRowMaster; };
    GridOptionsWrapper.prototype.getGroupRowRendererParams = function () { return this.gridOptions.groupRowRendererParams; };
    GridOptionsWrapper.prototype.getOverlayLoadingTemplate = function () { return this.gridOptions.overlayLoadingTemplate; };
    GridOptionsWrapper.prototype.getOverlayNoRowsTemplate = function () { return this.gridOptions.overlayNoRowsTemplate; };
    GridOptionsWrapper.prototype.isSuppressAutoSize = function () { return isTrue(this.gridOptions.suppressAutoSize); };
    GridOptionsWrapper.prototype.isSuppressParentsInRowNodes = function () { return isTrue(this.gridOptions.suppressParentsInRowNodes); };
    GridOptionsWrapper.prototype.isEnableStatusBar = function () { return isTrue(this.gridOptions.enableStatusBar); };
    GridOptionsWrapper.prototype.isAlwaysShowStatusBar = function () { return isTrue(this.gridOptions.alwaysShowStatusBar); };
    GridOptionsWrapper.prototype.isFunctionsReadOnly = function () { return isTrue(this.gridOptions.functionsReadOnly); };
    GridOptionsWrapper.prototype.isFloatingFilter = function () { return this.gridOptions.floatingFilter; };
    // public isFloatingFilter(): boolean { return true; }
    GridOptionsWrapper.prototype.getDefaultColDef = function () { return this.gridOptions.defaultColDef; };
    GridOptionsWrapper.prototype.getDefaultColGroupDef = function () { return this.gridOptions.defaultColGroupDef; };
    GridOptionsWrapper.prototype.getDefaultExportParams = function () { return this.gridOptions.defaultExportParams; };
    GridOptionsWrapper.prototype.isSuppressCsvExport = function () { return isTrue(this.gridOptions.suppressCsvExport); };
    GridOptionsWrapper.prototype.isSuppressExcelExport = function () { return isTrue(this.gridOptions.suppressExcelExport); };
    GridOptionsWrapper.prototype.getNodeChildDetailsFunc = function () { return this.gridOptions.getNodeChildDetails; };
    GridOptionsWrapper.prototype.getDataPathFunc = function () { return this.gridOptions.getDataPath; };
    // public getIsGroupFunc(): ((dataItem: any) => boolean) { return this.gridOptions.isGroup }
    GridOptionsWrapper.prototype.getGroupRowAggNodesFunc = function () { return this.gridOptions.groupRowAggNodes; };
    GridOptionsWrapper.prototype.getContextMenuItemsFunc = function () { return this.gridOptions.getContextMenuItems; };
    GridOptionsWrapper.prototype.getMainMenuItemsFunc = function () { return this.gridOptions.getMainMenuItems; };
    GridOptionsWrapper.prototype.getRowNodeIdFunc = function () { return this.gridOptions.getRowNodeId; };
    GridOptionsWrapper.prototype.getNavigateToNextCellFunc = function () { return this.gridOptions.navigateToNextCell; };
    GridOptionsWrapper.prototype.getTabToNextCellFunc = function () { return this.gridOptions.tabToNextCell; };
    GridOptionsWrapper.prototype.isTreeData = function () { return isTrue(this.gridOptions.treeData); };
    GridOptionsWrapper.prototype.isValueCache = function () { return isTrue(this.gridOptions.valueCache); };
    GridOptionsWrapper.prototype.isValueCacheNeverExpires = function () { return isTrue(this.gridOptions.valueCacheNeverExpires); };
    GridOptionsWrapper.prototype.isAggregateOnlyChangedColumns = function () { return isTrue(this.gridOptions.aggregateOnlyChangedColumns); };
    GridOptionsWrapper.prototype.getProcessSecondaryColDefFunc = function () { return this.gridOptions.processSecondaryColDef; };
    GridOptionsWrapper.prototype.getProcessSecondaryColGroupDefFunc = function () { return this.gridOptions.processSecondaryColGroupDef; };
    GridOptionsWrapper.prototype.getSendToClipboardFunc = function () { return this.gridOptions.sendToClipboard; };
    GridOptionsWrapper.prototype.getProcessRowPostCreateFunc = function () { return this.gridOptions.processRowPostCreate; };
    GridOptionsWrapper.prototype.getProcessCellForClipboardFunc = function () { return this.gridOptions.processCellForClipboard; };
    GridOptionsWrapper.prototype.getProcessCellFromClipboardFunc = function () { return this.gridOptions.processCellFromClipboard; };
    GridOptionsWrapper.prototype.getViewportRowModelPageSize = function () { return oneOrGreater(this.gridOptions.viewportRowModelPageSize, DEFAULT_VIEWPORT_ROW_MODEL_PAGE_SIZE); };
    GridOptionsWrapper.prototype.getViewportRowModelBufferSize = function () { return zeroOrGreater(this.gridOptions.viewportRowModelBufferSize, DEFAULT_VIEWPORT_ROW_MODEL_BUFFER_SIZE); };
    // public getCellRenderers(): {[key: string]: {new(): ICellRenderer} | ICellRendererFunc} { return this.gridOptions.cellRenderers; }
    // public getCellEditors(): {[key: string]: {new(): ICellEditor}} { return this.gridOptions.cellEditors; }
    GridOptionsWrapper.prototype.getClipboardDeliminator = function () {
        return utils_1.Utils.exists(this.gridOptions.clipboardDeliminator) ? this.gridOptions.clipboardDeliminator : '\t';
    };
    GridOptionsWrapper.prototype.setProperty = function (key, value) {
        var gridOptionsNoType = this.gridOptions;
        var previousValue = gridOptionsNoType[key];
        if (previousValue !== value) {
            gridOptionsNoType[key] = value;
            var event_1 = {
                type: key,
                currentValue: value,
                previousValue: previousValue
            };
            this.propertyEventService.dispatchEvent(event_1);
        }
    };
    GridOptionsWrapper.prototype.addEventListener = function (key, listener) {
        this.propertyEventService.addEventListener(key, listener);
    };
    GridOptionsWrapper.prototype.removeEventListener = function (key, listener) {
        this.propertyEventService.removeEventListener(key, listener);
    };
    GridOptionsWrapper.prototype.getAutoSizePadding = function () {
        return this.gridOptions.autoSizePadding > 0 ? this.gridOptions.autoSizePadding : 0;
    };
    // properties
    GridOptionsWrapper.prototype.getHeaderHeight = function () {
        if (typeof this.gridOptions.headerHeight === 'number') {
            return this.gridOptions.headerHeight;
        }
        else {
            return this.specialForNewMaterial(25, 'headerHeight');
        }
    };
    GridOptionsWrapper.prototype.getFloatingFiltersHeight = function () {
        if (typeof this.gridOptions.floatingFiltersHeight === 'number') {
            return this.gridOptions.floatingFiltersHeight;
        }
        else {
            return this.specialForNewMaterial(25, 'headerHeight');
        }
    };
    GridOptionsWrapper.prototype.getGroupHeaderHeight = function () {
        if (typeof this.gridOptions.groupHeaderHeight === 'number') {
            return this.gridOptions.groupHeaderHeight;
        }
        else {
            return this.getHeaderHeight();
        }
    };
    GridOptionsWrapper.prototype.getPivotHeaderHeight = function () {
        if (typeof this.gridOptions.pivotHeaderHeight === 'number') {
            return this.gridOptions.pivotHeaderHeight;
        }
        else {
            return this.getHeaderHeight();
        }
    };
    GridOptionsWrapper.prototype.getPivotGroupHeaderHeight = function () {
        if (typeof this.gridOptions.pivotGroupHeaderHeight === 'number') {
            return this.gridOptions.pivotGroupHeaderHeight;
        }
        else {
            return this.getGroupHeaderHeight();
        }
    };
    GridOptionsWrapper.prototype.isExternalFilterPresent = function () {
        if (typeof this.gridOptions.isExternalFilterPresent === 'function') {
            return this.gridOptions.isExternalFilterPresent();
        }
        else {
            return false;
        }
    };
    GridOptionsWrapper.prototype.doesExternalFilterPass = function (node) {
        if (typeof this.gridOptions.doesExternalFilterPass === 'function') {
            return this.gridOptions.doesExternalFilterPass(node);
        }
        else {
            return false;
        }
    };
    GridOptionsWrapper.prototype.getDocument = function () {
        // if user is providing document, we use the users one,
        // otherwise we use the document on the global namespace.
        var result;
        if (utils_1.Utils.exists(this.gridOptions.getDocument)) {
            result = this.gridOptions.getDocument();
        }
        if (utils_1.Utils.exists(result)) {
            return result;
        }
        else {
            return document;
        }
    };
    GridOptionsWrapper.prototype.getLayoutInterval = function () {
        if (typeof this.gridOptions.layoutInterval === 'number') {
            return this.gridOptions.layoutInterval;
        }
        else {
            return constants_1.Constants.LAYOUT_INTERVAL;
        }
    };
    GridOptionsWrapper.prototype.getMinColWidth = function () {
        if (this.gridOptions.minColWidth > GridOptionsWrapper_1.MIN_COL_WIDTH) {
            return this.gridOptions.minColWidth;
        }
        else {
            return GridOptionsWrapper_1.MIN_COL_WIDTH;
        }
    };
    GridOptionsWrapper.prototype.getMaxColWidth = function () {
        if (this.gridOptions.maxColWidth > GridOptionsWrapper_1.MIN_COL_WIDTH) {
            return this.gridOptions.maxColWidth;
        }
        else {
            return null;
        }
    };
    GridOptionsWrapper.prototype.getColWidth = function () {
        if (typeof this.gridOptions.colWidth !== 'number' || this.gridOptions.colWidth < GridOptionsWrapper_1.MIN_COL_WIDTH) {
            return 200;
        }
        else {
            return this.gridOptions.colWidth;
        }
    };
    GridOptionsWrapper.prototype.getRowBuffer = function () {
        if (typeof this.gridOptions.rowBuffer === 'number') {
            if (this.gridOptions.rowBuffer < 0) {
                console.warn('ag-Grid: rowBuffer should not be negative');
            }
            return this.gridOptions.rowBuffer;
        }
        else {
            return constants_1.Constants.ROW_BUFFER_SIZE;
        }
    };
    // the user might be using some non-standard scrollbar, eg a scrollbar that has zero
    // width and overlays (like the Safari scrollbar, but presented in Chrome). so we
    // allow the user to provide the scroll width before we work it out.
    GridOptionsWrapper.prototype.getScrollbarWidth = function () {
        var scrollbarWidth = this.gridOptions.scrollbarWidth;
        if (typeof scrollbarWidth !== 'number' || scrollbarWidth < 0) {
            scrollbarWidth = utils_1.Utils.getScrollbarWidth();
        }
        return scrollbarWidth;
    };
    GridOptionsWrapper.prototype.checkForDeprecated = function () {
        // casting to generic object, so typescript compiles even though
        // we are looking for attributes that don't exist
        var options = this.gridOptions;
        if (options.suppressUnSort) {
            console.warn('ag-grid: as of v1.12.4 suppressUnSort is not used. Please use sortingOrder instead.');
        }
        if (options.suppressDescSort) {
            console.warn('ag-grid: as of v1.12.4 suppressDescSort is not used. Please use sortingOrder instead.');
        }
        if (options.groupAggFields) {
            console.warn('ag-grid: as of v3 groupAggFields is not used. Please add appropriate agg fields to your columns.');
        }
        if (options.groupHidePivotColumns) {
            console.warn('ag-grid: as of v3 groupHidePivotColumns is not used as pivot columns are now called rowGroup columns. Please refer to the documentation');
        }
        if (options.groupKeys) {
            console.warn('ag-grid: as of v3 groupKeys is not used. You need to set rowGroupIndex on the columns to group. Please refer to the documentation');
        }
        if (typeof options.groupDefaultExpanded === 'boolean') {
            console.warn('ag-grid: groupDefaultExpanded can no longer be boolean. for groupDefaultExpanded=true, use groupDefaultExpanded=9999 instead, to expand all the groups');
        }
        if (options.onRowDeselected || options.rowDeselected) {
            console.warn('ag-grid: since version 3.4 event rowDeselected no longer exists, please check the docs');
        }
        if (options.rowsAlreadyGrouped) {
            console.warn('ag-grid: since version 3.4 rowsAlreadyGrouped no longer exists, please use getNodeChildDetails() instead');
        }
        if (options.groupAggFunction) {
            console.warn('ag-grid: since version 4.3.x groupAggFunction is now called groupRowAggNodes');
        }
        if (options.checkboxSelection) {
            console.warn('ag-grid: since version 8.0.x checkboxSelection is not supported as a grid option. ' +
                'If you want this on all columns, use defaultColDef instead and set it there');
        }
        if (options.paginationInitialRowCount) {
            console.warn('ag-grid: since version 9.0.x paginationInitialRowCount is now called infiniteInitialRowCount');
        }
        if (options.infinitePageSize) {
            console.warn('ag-grid: since version 9.0.x infinitePageSize is now called cacheBlockSize');
        }
        if (options.infiniteBlockSize) {
            console.warn('ag-grid: since version 10.0.x infiniteBlockSize is now called cacheBlockSize');
        }
        if (options.maxPagesInCache) {
            console.warn('ag-grid: since version 10.0.x maxPagesInCache is now called maxBlocksInCache');
        }
        if (options.paginationOverflowSize) {
            console.warn('ag-grid: since version 10.0.x paginationOverflowSize is now called cacheOverflowSize');
        }
        if (options.forPrint) {
            console.warn('ag-grid: since version 10.1.x, use property domLayout="forPrint" instead of forPrint=true');
        }
        if (options.suppressMenuFilterPanel) {
            console.warn("ag-grid: since version 11.0.x, use property colDef.menuTabs=['generalMenuTab','columnsMenuTab'] instead of suppressMenuFilterPanel=true");
        }
        if (options.suppressMenuMainPanel) {
            console.warn("ag-grid: since version 11.0.x, use property colDef.menuTabs=['filterMenuTab','columnsMenuTab'] instead of suppressMenuMainPanel=true");
        }
        if (options.suppressMenuColumnPanel) {
            console.warn("ag-grid: since version 11.0.x, use property colDef.menuTabs=['generalMenuTab','filterMenuTab'] instead of suppressMenuColumnPanel=true");
        }
        if (options.suppressUseColIdForGroups) {
            console.warn("ag-grid: since version 11.0.x, this is not in use anymore. You should be able to remove it from your definition");
        }
        if (options.groupColumnDef) {
            console.warn("ag-grid: since version 11.0.x, groupColumnDef has been renamed, this property is now called autoGroupColumnDef. Please change your configuration accordingly");
        }
        if (options.slaveGrids) {
            console.warn("ag-grid: since version 12.x, slaveGrids has been renamed, this property is now called alignedGrids. Please change your configuration accordingly");
        }
        if (options.floatingTopRowData) {
            console.warn("ag-grid: since version 12.x, floatingTopRowData is now called pinnedTopRowData");
        }
        if (options.floatingBottomRowData) {
            console.warn("ag-grid: since version 12.x, floatingBottomRowData is now called pinnedBottomRowData");
        }
        if (options.paginationStartPage) {
            console.warn("ag-grid: since version 12.x, paginationStartPage is gone, please call api.paginationGoToPage(" + options.paginationStartPage + ") instead.");
        }
        if (options.getHeaderCellTemplate) {
            console.warn("ag-grid: since version 15.x, getHeaderCellTemplate is gone, please check the header documentation on how to set header templates.");
        }
        if (options.headerCellTemplate) {
            console.warn("ag-grid: since version 15.x, headerCellTemplate is gone, please check the header documentation on how to set header templates.");
        }
        if (options.headerCellRenderer) {
            console.warn("ag-grid: since version 15.x, headerCellRenderer is gone, please check the header documentation on how to set header templates.");
        }
    };
    GridOptionsWrapper.prototype.getLocaleTextFunc = function () {
        if (this.gridOptions.localeTextFunc) {
            return this.gridOptions.localeTextFunc;
        }
        var that = this;
        return function (key, defaultValue) {
            var localeText = that.gridOptions.localeText;
            if (localeText && localeText[key]) {
                return localeText[key];
            }
            else {
                return defaultValue;
            }
        };
    };
    // responsible for calling the onXXX functions on gridOptions
    GridOptionsWrapper.prototype.globalEventHandler = function (eventName, event) {
        if (eventName === 'columnVisible') {
            console.log('columnVisible');
        }
        var callbackMethodName = componentUtil_1.ComponentUtil.getCallbackForEvent(eventName);
        if (typeof this.gridOptions[callbackMethodName] === 'function') {
            this.gridOptions[callbackMethodName](event);
        }
    };
    // we don't allow dynamic row height for virtual paging
    GridOptionsWrapper.prototype.getRowHeightAsNumber = function () {
        var rowHeight = this.gridOptions.rowHeight;
        if (utils_1.Utils.missing(rowHeight)) {
            return this.getDefaultRowHeight();
        }
        else if (this.isNumeric(this.gridOptions.rowHeight)) {
            return this.gridOptions.rowHeight;
        }
        else {
            console.warn('ag-Grid row height must be a number if not using standard row model');
            return this.getDefaultRowHeight();
        }
    };
    GridOptionsWrapper.prototype.getRowHeightForNode = function (rowNode) {
        // check the function first, in case use set both function and
        // number, when using virtual pagination then function can be
        // used for pinned rows and the number for the body rows.
        if (typeof this.gridOptions.getRowHeight === 'function') {
            var params = {
                node: rowNode,
                data: rowNode.data,
                api: this.gridOptions.api,
                context: this.gridOptions.context
            };
            return this.gridOptions.getRowHeight(params);
        }
        else if (rowNode.detail && this.isMasterDetail()) {
            if (this.isNumeric(this.gridOptions.detailRowHeight)) {
                return this.gridOptions.detailRowHeight;
            }
            else {
                return DEFAULT_DETAIL_ROW_HEIGHT;
            }
        }
        else if (this.isNumeric(this.gridOptions.rowHeight)) {
            return this.gridOptions.rowHeight;
        }
        else {
            return this.getDefaultRowHeight();
        }
    };
    GridOptionsWrapper.prototype.isDynamicRowHeight = function () {
        return typeof this.gridOptions.getRowHeight === 'function';
    };
    GridOptionsWrapper.prototype.getVirtualItemHeight = function () {
        return this.specialForNewMaterial(20, 'virtualItemHeight');
    };
    GridOptionsWrapper.prototype.isNumeric = function (value) {
        return !isNaN(value) && typeof value === 'number';
    };
    // Material data table has strict guidelines about whitespace, and these values are different than the ones 
    // ag-grid uses by default. We override the default ones for the sake of making it better out of the box
    GridOptionsWrapper.prototype.specialForNewMaterial = function (defaultValue, sassVariableName) {
        var theme = this.environment.getTheme();
        if (theme.indexOf('ag-theme') === 0) {
            return this.environment.getSassVariable(theme, sassVariableName);
        }
        else {
            return defaultValue;
        }
    };
    GridOptionsWrapper.prototype.getDefaultRowHeight = function () {
        return this.specialForNewMaterial(DEFAULT_ROW_HEIGHT, 'rowHeight');
    };
    GridOptionsWrapper.MIN_COL_WIDTH = 10;
    GridOptionsWrapper.PROP_HEADER_HEIGHT = 'headerHeight';
    GridOptionsWrapper.PROP_GROUP_REMOVE_SINGLE_CHILDREN = 'groupRemoveSingleChildren';
    GridOptionsWrapper.PROP_GROUP_REMOVE_LOWEST_SINGLE_CHILDREN = 'groupRemoveLowestSingleChildren';
    GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT = 'pivotHeaderHeight';
    GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT = 'groupHeaderHeight';
    GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT = 'pivotGroupHeaderHeight';
    GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT = 'floatingFiltersHeight';
    GridOptionsWrapper.PROP_SUPPRESS_ROW_DRAG = 'suppressRowDrag';
    GridOptionsWrapper.PROP_POPUP_PARENT = 'popupParent';
    __decorate([
        context_1.Autowired('gridOptions'),
        __metadata("design:type", Object)
    ], GridOptionsWrapper.prototype, "gridOptions", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], GridOptionsWrapper.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], GridOptionsWrapper.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('enterprise'),
        __metadata("design:type", Boolean)
    ], GridOptionsWrapper.prototype, "enterprise", void 0);
    __decorate([
        context_1.Autowired('frameworkFactory'),
        __metadata("design:type", Object)
    ], GridOptionsWrapper.prototype, "frameworkFactory", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], GridOptionsWrapper.prototype, "gridApi", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], GridOptionsWrapper.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('environment'),
        __metadata("design:type", environment_1.Environment)
    ], GridOptionsWrapper.prototype, "environment", void 0);
    __decorate([
        __param(0, context_1.Qualifier('gridApi')), __param(1, context_1.Qualifier('columnApi')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [gridApi_1.GridApi, columnApi_1.ColumnApi]),
        __metadata("design:returntype", void 0)
    ], GridOptionsWrapper.prototype, "agWire", null);
    __decorate([
        context_1.PreDestroy,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], GridOptionsWrapper.prototype, "destroy", null);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], GridOptionsWrapper.prototype, "init", null);
    GridOptionsWrapper = GridOptionsWrapper_1 = __decorate([
        context_1.Bean('gridOptionsWrapper')
    ], GridOptionsWrapper);
    return GridOptionsWrapper;
    var GridOptionsWrapper_1;
}());
exports.GridOptionsWrapper = GridOptionsWrapper;


/***/ }),

/***/ "Z9Q2":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1437);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1437:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1059), __webpack_require__(1109) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "treeview.draganddrop",
	    name: "Hierarchical Drag & Drop",
	    category: "framework",
	    depends: [ "core", "draganddrop" ],
	    advanced: true
	};

	(function($, undefined){
	    var kendo = window.kendo;
	    var ui = kendo.ui;
	    var proxy = $.proxy;
	    var extend = $.extend;
	    var VISIBILITY = "visibility";
	    var KSTATEHOVER = "k-state-hover";
	    var INPUTSELECTOR = "input,a:not(.k-in),textarea,.k-multiselect-wrap,select,button,a.k-button>.k-icon,button.k-button>.k-icon,span.k-icon.k-i-arrow-60-right,span.k-icon.k-i-arrow-45-down-right";
	    var DROPHINTTEMPLATE = "<div class='k-drop-hint k-drop-hint-h'>" +
	                                "<div class='k-drop-hint-start'></div>" +
	                                "<div class='k-drop-hint-line'></div>" +
	                            "</div>";

	    ui.HierarchicalDragAndDrop = kendo.Class.extend({
	        init: function (element, options) {
	            this.element = element;
	            this.hovered = element;
	            this.options = extend({
	                dragstart: $.noop, drag: $.noop, drop: $.noop, dragend: $.noop
	            }, options);

	            this._draggable = new ui.Draggable(element, {
	                ignore: INPUTSELECTOR,
	                filter: options.filter,
	                autoScroll: options.autoScroll,
	                cursorOffset: {
	                    left: 10,
	                    top: kendo.support.mobileOS ? -40 / kendo.support.zoomLevel() : 10
	                },
	                hint: proxy(this._hint, this),
	                dragstart: proxy(this.dragstart, this),
	                dragcancel: proxy(this.dragcancel, this),
	                drag: proxy(this.drag, this),
	                dragend: proxy(this.dragend, this),
	                $angular: options.$angular,
	                holdToDrag: options.holdToDrag
	            });
	        },

	        _hint: function(element) {
	            return "<div class='k-header k-drag-clue'>" +
	                        "<span class='k-icon k-drag-status'></span>" +
	                        this.options.hintText(element) +
	                    "</div>";
	        },

	        _removeTouchHover: function() {
	            if (kendo.support.touch && this.hovered) {
	                this.hovered.find("." + KSTATEHOVER).removeClass(KSTATEHOVER);
	                this.hovered = false;
	            }
	        },

	        _hintStatus: function(newStatus) {
	            var statusElement = this._draggable.hint.find(".k-drag-status")[0];

	            if (newStatus) {
	                statusElement.className = "k-icon k-drag-status " + newStatus;
	            } else {
	                return kendo.trim(statusElement.className.replace(/(p|k)-(icon|drag-status)/g, ""));
	            }
	        },

	        dragstart: function (e) {
	            this.source = e.currentTarget.closest(this.options.itemSelector);

	            if (this.options.dragstart(this.source)) {
	                e.preventDefault();
	            }

	            if (this.options.reorderable) {
	                this.dropHint = $(DROPHINTTEMPLATE)
	                    .css(VISIBILITY, "hidden")
	                    .appendTo(this.element);
	            } else {
	                this.dropHint = $();
	            }
	        },

	        drag: function (e) {
	            var options = this.options;
	            var source = this.source;
	            var target = this.dropTarget = $(kendo.eventTarget(e));
	            var container = target.closest(options.allowedContainers);
	            var hoveredItem, itemHeight, itemTop, itemContent, delta;
	            var insertOnTop, insertOnBottom, addChild;
	            var itemData, position, status;

	            if (!container.length) {
	                // dragging outside of allowed elements
	                status = "k-i-cancel";
	                this._removeTouchHover();
	            } else if (source[0] == target[0] || options.contains(source[0], target[0])) {
	                // dragging item within itself
	                status = "k-i-cancel";
	            } else {
	                // moving or reordering item
	                status = "k-i-insert-middle";

	                itemData = options.itemFromTarget(target);
	                hoveredItem = itemData.item;

	                if (hoveredItem.length) {
	                    this._removeTouchHover();
	                    itemHeight = kendo._outerHeight(hoveredItem);
	                    itemContent = itemData.content;

	                    if (options.reorderable) {
	                        delta = itemHeight / (itemContent.length > 0 ? 4 : 2);
	                        itemTop = kendo.getOffset(hoveredItem).top;

	                        insertOnTop = e.y.location < (itemTop + delta);
	                        insertOnBottom = (itemTop + itemHeight - delta) < e.y.location;
	                        addChild = itemContent.length && !insertOnTop && !insertOnBottom;
	                    } else {
	                        addChild = true;
	                        insertOnTop = false;
	                        insertOnBottom = false;
	                    }

	                    this.hovered = addChild ? container : false;

	                    this.dropHint.css(VISIBILITY, addChild ? "hidden" : "visible");

	                    if (this._lastHover && this._lastHover[0] != itemContent[0]) {
	                        this._lastHover.removeClass(KSTATEHOVER);
	                    }

	                    this._lastHover = itemContent.toggleClass(KSTATEHOVER, addChild);

	                    if (addChild) {
	                        status = "k-i-plus";
	                    } else {
	                        position = hoveredItem.position();
	                        position.top += insertOnTop ? 0 : itemHeight;

	                        this.dropHint.css(position)
	                            [insertOnTop ? "prependTo" : "appendTo"]
	                            (options.dropHintContainer(hoveredItem));

	                        if (insertOnTop && itemData.first) {
	                            status = "k-i-insert-up";
	                        }

	                        if (insertOnBottom && itemData.last) {
	                            status = "k-i-insert-down";
	                        }
	                    }
	                } else if (target[0] != this.dropHint[0]) {
	                    if (this._lastHover) {
	                        this._lastHover.removeClass(KSTATEHOVER);
	                    }

	                    if (!$.contains(this.element[0], container[0])) {
	                        // moving node to different element
	                        status = "k-i-plus";
	                    } else {
	                        status = "k-i-cancel";
	                    }
	                }
	            }

	            this.options.drag({
	                originalEvent: e.originalEvent,
	                source: source,
	                target: target,
	                pageY: e.y.location,
	                pageX: e.x.location,
	                status: status.substring(2),
	                setStatus: function(value) {
	                    status = value;
	                }
	            });

	            if (status.indexOf("k-i-insert") !== 0) {
	                this.dropHint.css(VISIBILITY, "hidden");
	            }

	            this._hintStatus(status);
	        },

	        dragcancel: function() {
	            this.dropHint.remove();
	        },

	        dragend: function (e) {
	            var position = "over",
	                source = this.source,
	                destination,
	                dropHint = this.dropHint,
	                dropTarget = this.dropTarget,
	                eventArgs, dropPrevented;

	            if (dropHint.css(VISIBILITY) == "visible") {
	                position = this.options.dropPositionFrom(dropHint);
	                destination = dropHint.closest(this.options.itemSelector);
	            } else if (dropTarget) {
	                destination = dropTarget.closest(this.options.itemSelector);

	                // moving node to root element
	                if (!destination.length) {
	                    destination = dropTarget.closest(this.options.allowedContainers);
	                }
	            }

	            eventArgs = {
	                originalEvent: e.originalEvent,
	                source: source[0],
	                destination: destination[0],
	                valid: this._hintStatus() != "k-i-cancel",
	                setValid: function(newValid) {
	                    this.valid = newValid;
	                },
	                dropTarget: dropTarget[0],
	                position: position
	            };

	            dropPrevented = this.options.drop(eventArgs);

	            dropHint.remove();
	            this._removeTouchHover();
	            if (this._lastHover) {
	                this._lastHover.removeClass(KSTATEHOVER);
	            }

	            if (!eventArgs.valid || dropPrevented) {
	                this._draggable.dropped = eventArgs.valid;
	                return;
	            }

	            this._draggable.dropped = true;

	            this.options.dragend({
	                originalEvent: e.originalEvent,
	                source: source,
	                destination: destination,
	                position: position
	            });
	        },

	        destroy: function() {
	            this._lastHover = this.hovered = null;
	            this._draggable.destroy();
	        }
	    });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "ZDqD":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1344);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1069:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("jBxA");

/***/ }),

/***/ 1344:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1069),
	        __webpack_require__(1345),
	        __webpack_require__(1346),
	        __webpack_require__(1347),
	        __webpack_require__(1348),
	        __webpack_require__(1349),
	        __webpack_require__(1350),
	        __webpack_require__(1351)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "pdfviewer",
	    name: "PDFViewer",
	    category: "web",
	    description: "PDFViewer to display pdfs in the browser",
	    depends: ["core", "window", "dialog", "toolbar", "mobile.scroller", "upload", "combobox", "drawing", "binder", "dropdownlist", "numerictextbox"]
	};

	(function($, undefined) {
	    var NS = ".kendoPDFViewer",
	        kendo = window.kendo,
	        ui = kendo.ui,
	        proxy = $.proxy,
	        extend = $.extend,
	        drawing = kendo.drawing,
	        keys = $.extend({PLUS: 187, MINUS: 189, ZERO: 48, NUMPAD_ZERO: 96 }, kendo.keys),
	        Page,
	        Widget = ui.Widget,
	        progress = kendo.ui.progress,
	        SCROLL = "scroll",
	        RENDER = "render",
	        OPEN = "open",
	        ERROR = "error",
	        FOCUS = "focus" + NS,
	        KEYDOWN = "keydown" + NS,
	        MOUSEWHEEL = "DOMMouseScroll" + NS + " mousewheel" + NS,
	        UPDATE = "update",
	        ZOOM_SCALE = 1.25,
	        PAGE_CHANGE = "pagechange",
	        ZOOMSTART = "zoomStart",
	        ZOOMEND = "zoomEnd",
	        ZOOMCOMMAND = "ZoomCommand",
	        WHITECOLOR = "#ffffff",
	        TABINDEX = "tabindex",
	        PROCESSORS = {
	            pdfjs: "pdfjs",
	            dpl: "dpl"
	        },
	        styles = {
	            viewer: "k-pdf-viewer k-widget",
	            scroller: "k-canvas k-list-scroller",
	            enableTextSelection: "k-enable-text-select",
	            enablePanning: "k-enable-panning",
	            highlightClass: "k-search-highlight",
	            charClass: "k-text-char"
	        };

	    var PDFViewer = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, kendo.deepExtend({}, this.options, options));

	            that._wrapper();

	            if (that.options.toolbar) {
	                that._renderToolbar();
	            }

	            that._initProcessor(options || {});
	            that._renderPageContainer();
	            that._loadDocument();

	            that._tabindex();
	            kendo.notify(that, kendo.ui);
	        },

	        events: [
	            RENDER,
	            OPEN,
	            ERROR,
	            ZOOMSTART,
	            ZOOMEND
	        ],

	        options: {
	            name: "PDFViewer",
	            view: {
	                type: "canvas"
	            },
	            pdfjsProcessing: {
	                file: null
	            },
	            dplProcessing: {
	                read: {
	                    url: null,
	                    type: "GET",
	                    dataType: "json",
	                    pageField: "pageNumber"
	                },
	                upload: {
	                    url: null,
	                    saveField: "file"
	                },
	                download: {
	                    url: null
	                },
	                loadOnDemand: false
	            },
	            toolbar: {
	                items: []
	            },
	            width: 1000,
	            height: 1200,
	            page: 1,
	            defaultPageSize: {
	                width: 794,
	                height: 1123
	            },
	            scale: null,
	            zoomMin: 0.5,
	            zoomMax: 4,
	            zoomRate: 0.25,
	            messages: {
	                defaultFileName: "Document",
	                toolbar: {
	                    zoom: {
	                        zoomLevel: "zoom level",
	                        zoomOut: "Zoom Out",
	                        zoomIn: "Zoom In",
	                        actualWidth: "Actual Width",
	                        autoWidth: "Automatic Width",
	                        fitToWidth: "Fit to Width",
	                        fitToPage: "Fit to Page"
	                    },
	                    open: "Open",
	                    exportAs: "Export",
	                    download: "Download",
	                    pager:  {
	                        first: "Go to the first page",
	                        previous: "Go to the previous page",
	                        next: "Go to the next page",
	                        last: "Go to the last page",
	                        of: " of {0} ",
	                        page: "page",
	                        pages: "pages"
	                    },
	                    print: "Print",
	                    toggleSelection: "Enable Selection",
	                    togglePan: "Enable Panning",
	                    search: "Search"
	                },
	                errorMessages: {
	                    notSupported: "Only pdf files allowed.",
	                    parseError: "PDF file fails to process.",
	                    notFound: "File is not found.",
	                    popupBlocked: "Popup is blocked."
	                },
	                dialogs: {
	                    exportAsDialog: {
	                        title: "Export...",
	                        defaultFileName: "Document",
	                        pdf: "Portable Document Format (.pdf)",
	                        png: "Portable Network Graphics (.png)",
	                        svg: "Scalable Vector Graphics (.svg)",
	                        labels: {
	                            fileName: "File name",
	                            saveAsType: "Save as",
	                            page: "Page"
	                        }
	                    },
	                    okText: "OK",
	                    save: "Save",
	                    cancel: "Cancel",
	                    search: {
	                        inputLabel: "Search Text",
	                        matchCase: "Match Case",
	                        next: "Next Match",
	                        previous: "Previous Match",
	                        close: "Close",
	                        of: "of"
	                    }
	                }
	            }
	        },

	        _wrapper: function () {
	            var that = this,
	                options = that.options;

	            that.wrapper = that.element;

	            that.wrapper
	                    .width(options.width)
	                    .height(options.height)
	                    .addClass(styles.viewer)
	                    .on(FOCUS, proxy(that._focus, that))
	                    .on(KEYDOWN, proxy(that._keydown, that));

	            that._allowResize = that.options.scale === null;
	            that._autoZoomScale = ZOOM_SCALE;
	            that.zoomScale = that.options.scale || that._autoZoomScale;

	            that._resizeHandler = kendo.onResize(function() {
	                that.resize();
	            });

	            that._pageNum = that.options.page;
	        },

	        _focus: function (e) {
	            if (this.toolbar) {
	                this.toolbar.wrapper.focus();
	            } else {
	                this.pageContainer.focus();
	            }
	            e.preventDefault();
	        },

	        _keydown: function (e) {
	            var plusShortcuts = [keys.PLUS, keys.NUMPAD_PLUS],
	                minusShortcuts = [keys.MINUS, keys.NUMPAD_MINUS],
	                zeroShortcuts = [keys.ZERO, keys.NUMPAD_ZERO],
	                shouldExecute = false,
	                args = {
	                    command: ZOOMCOMMAND,
	                    options: { updateComboBox: true }
	                };

	            if (!e.ctrlKey || this._blankPage || this.processingLib === PROCESSORS.dpl) {
	                return;
	            }

	            if (plusShortcuts.includes(e.keyCode)) {
	                args.options.zoomIn = true;
	                shouldExecute = true;
	            } else if (minusShortcuts.includes(e.keyCode)) {
	                args.options.zoomOut = true;
	                shouldExecute = true;
	            } else if (zeroShortcuts.includes(e.keyCode)) {
	                args.options.scale = ZOOM_SCALE;
	                shouldExecute = true;
	            }

	            if (shouldExecute) {
	                this.execute(args);
	                e.preventDefault();
	            }
	        },

	        _initProcessor: function (options) {
	            var that = this,
	                processingOptions;

	            processingOptions = options.dplProcessing ? that.options.dplProcessing : that.options.pdfjsProcessing;
	            that.processingLib = options.dplProcessing ? PROCESSORS.dpl : PROCESSORS.pdfjs;

	            that.processor = new kendo.pdfviewer[that.processingLib].processor(processingOptions, that);
	            Page = kendo.pdfviewer[that.processingLib].Page;
	        },

	        _renderToolbar: function () {
	            var that = this,
	                options = that.options;

	            var toolbarOptions = {
	                pager: {
	                    messages: options.messages.toolbar.pager
	                },
	                scale: options.scale,
	                resizable: true,
	                items: options.toolbar.items,
	                width: options.width,
	                action: that.execute.bind(that),
	                messages: options.messages.toolbar,
	                viewer: this
	            };

	            var toolbarElement = $("<div />");
	            toolbarElement.appendTo(that.element);
	            that.toolbar = new kendo.pdfviewer.Toolbar(toolbarElement, toolbarOptions);
	        },

	        _initErrorDialog: function (options) {
	            var that = this;

	            if (!that._errorDialog) {
	                options = extend(options, {
	                    messages: that.options.messages
	                });
	                var dialogInstance = new kendo.pdfviewer.dialogs.ErrorDialog(options);
	                that._errorDialog = dialogInstance._dialog;
	            }
	            return that._errorDialog;
	        },

	        _renderPageContainer: function () {
	            var that = this;

	            if (!that.pageContainer) {
	                that.pageContainer = $("<div />");
	                that.pageContainer.addClass(styles.scroller);
	                that.pageContainer.attr(TABINDEX, 0);
	                that.wrapper.append(that.pageContainer);
	            }
	        },

	        _triggerError: function (options) {
	            var dialog = this._initErrorDialog();
	            extend(options, {
	                dialog: dialog
	            });
	            if (this.pageContainer) {
	                progress(this.pageContainer, false);
	            }

	            if (this.trigger(ERROR, options))
	            {
	                return;
	            }

	            dialog.open().content(options.message);
	        },

	        _renderPages: function () {
	            var that = this,
	                document = that.document,
	                pagesData;

	            that.pages = [];

	            if (!document || !document.total) {
	                that._renderBlankPage();
	                return;
	            }

	            pagesData = document.pages;

	            for (var i = 1; i <= document.total; i++) {
	                var viewerPage,
	                    pageData = {
	                        processor: that.processor,
	                        number: i
	                    };

	                if (pagesData && pagesData.length) {
	                    pageData = extend(pageData, pagesData[i - 1]);
	                }

	                viewerPage = new Page(pageData, that);
	                that.pages.push(viewerPage);
	                that.pageContainer.append(viewerPage.element);
	            }

	            that._attachContainerEvents();
	            that._getVisiblePagesCount();
	        },

	        _renderBlankPage: function () {
	            this._blankPage = new Page(this.options.defaultPageSize, this);

	            this.pageContainer.append(this._blankPage.element);

	            this.trigger(UPDATE, { isBlank: true });
	        },

	        _resize: function () {
	            var that = this,
	                containerWidth,
	                ratio;

	            if (!that._allowResize) {
	                return;
	            }

	            if (!that.pages || !that.pages.length) {
	                if (that._blankPage) {
	                    ratio = containerWidth / that._blankPage.element.width();
	                    that._blankPage.resize(ratio);
	                }
	                return;
	            }

	            if (that.toolbar) {
	                that.toolbar.resize(true);
	            }

	            if (that._resizeHandler) {
	                clearTimeout(that._resizeHandler);
	            }
	            that._resizeHandler = setTimeout(that._resizePages.bind(that), 100);
	        },

	        _resizePages: function () {
	            var that = this,
	                containerWidth = that.pageContainer[0].clientWidth,
	                ratio = 0;

	            that.pages.forEach(function (page) {
	                var currentRatio = containerWidth / page.element.width();

	                if (currentRatio > ratio) {
	                    ratio = currentRatio;
	                }
	            });

	            if(that._autoFit) {
	                that.zoom(that._autoFit, true);
	                return;
	            }

	            ratio = Math.min(Math.max(ratio, that.options.zoomMin), ZOOM_SCALE);
	            if (ratio != that.zoomScale) {
	                that.zoom(ratio, true);
	                that.zoomScale = ratio;
	                that._allowResize = true;
	            }
	        },

	        _attachContainerEvents: function () {
	            var that = this;

	            that._wheel = kendo.throttle(
	                that._wheel.bind(that),
	                300
	            );

	            if(that.processingLib !== PROCESSORS.dpl) {
	                that.pageContainer.on(MOUSEWHEEL, function (e) {
	                    if (!e.ctrlKey) {
	                        return;
	                    }

	                    if (document.activeElement !== that.pageContainer[0]) {
	                        that.pageContainer.focus();
	                    }

	                    that._wheel(e);
	                    e.preventDefault();
	                });
	            }

	            that._scroller = new kendo.mobile.ui.Scroller(that.pageContainer, {
	                zoom: false,
	                elastic: true
	            });

	            that._scroller.scrollElement.addClass(styles.enablePanning);
	            that._scroller.bind(SCROLL, proxy(that._scroll, this));
	        },

	        _scroll: function (e) {
	            var that = this,
	                containerScrollHeight = that.pageContainer[0].scrollHeight,
	                containerHeight = that.pageContainer.height(),
	                containerScrollTop = e.scrollTop,
	                containerOffsetTop = that.pageContainer.offset().top,
	                total = that.pages.length,
	                pageNum = that._pageNum,
	                pageIndex = pageNum - 1,
	                pageToLoadNum = pageNum,
	                pageToLoad,
	                currentPage, currentPageTop, currentPageHeight,
	                previousPage, prevPageTop, prevPageHeight,
	                scrollDirection = containerScrollTop - that._prevScrollTop > 0 ? 1 : -1;

	                if (that._preventScroll || !total) {
	                    that._preventScroll = false;
	                    return;
	                }

	                that._scrollingStarted = true;

	                currentPage = that.pages[pageIndex];
	                currentPageTop = currentPage.element.offset().top - containerOffsetTop;
	                currentPageHeight = currentPage.element.height();

	                if (scrollDirection == -1 && that.pages[pageIndex + scrollDirection]) {
	                    previousPage = that.pages[pageIndex - that._visiblePagesCount] || that.pages[pageIndex + scrollDirection];
	                    prevPageTop = previousPage.element.offset().top - containerOffsetTop;
	                    prevPageHeight = previousPage.element.height();
	                }

	                if (Math.abs(containerScrollTop - (that._prevScrollTop || 0)) > containerHeight * that.zoomScale) {
	                    pageToLoadNum = Math.floor(containerScrollTop * (1 / (containerScrollHeight / total))) + 1;
	                } else if (currentPageTop < 0 && Math.abs(currentPageTop) >= currentPageHeight / 2 && scrollDirection === 1) {
	                    pageToLoadNum++;
	                } else if (previousPage && Math.abs(prevPageTop) <= prevPageHeight / 2) {
	                    pageToLoadNum--;
	                }

	                if (pageNum !== pageToLoadNum && pageToLoadNum >= 1 && pageToLoadNum <= total) {
	                    pageToLoad = that.pages[pageToLoadNum - 1].element;

	                    if (pageToLoad.offset().top > containerHeight) {
	                        return;
	                    }

	                    that._pageNum = pageToLoadNum;
	                    that._loadVisiblePages();

	                    that.trigger(UPDATE, { action: PAGE_CHANGE, page: pageToLoadNum, total: total });
	                }

	                that._prevScrollTop = containerScrollTop;
	        },

	        _wheel: function (e) {
	            var originalEvent = e.originalEvent,
	                delta = originalEvent.wheelDelta ? -originalEvent.wheelDelta : originalEvent.detail,
	                zoomIn = delta < 0;

	            this.execute({
	                command: ZOOMCOMMAND,
	                options: {
	                    zoomIn: zoomIn,
	                    zoomOut: !zoomIn,
	                    updateComboBox: true
	                }
	            });

	            e.preventDefault();
	        },

	        zoom: function (scale, preventComboBoxChange) {
	            var that = this;
	            if (!scale) {
	                return that.zoomScale;
	            }

	            return that.execute({
	                command: ZOOMCOMMAND,
	                options: {
	                    scale: scale,
	                    updateComboBox: !preventComboBoxChange
	                }
	            });
	        },

	        execute: function (options) {
	            var commandOptions = extend({ viewer: this }, options.options);
	            var command = new kendo.pdfviewer[options.command](commandOptions);
	            return command.exec();
	        },

	        _loadDocument: function () {
	            var that = this;
	            var page = that.options.page;

	            progress(that.pageContainer, true);
	            that.processor.fetchDocument().done(function (document) {
	                that._clearPages();
	                that.document = document;

	                that._renderPages();
	                that.resize(true);

	                if (document) {
	                    page = page >= 1 && page <= document.total ? page : 1;
	                    that.activatePage(page);
	                }

	                progress(that.pageContainer, false);
	            });
	        },

	        loadPage: function (number) {
	            var page = this.pages && this.pages[number - 1];

	            if (page) {
	                return page.load(this.zoomScale);
	            }
	        },

	        activatePage: function (number) {
	            var page = this.pages && this.pages[number - 1],
	                scroller = this._scroller,
	                scrollerTopPosition,
	                scrollerTopOffset,
	                pageTopOffset,
	                pageMargin;

	            if (!page) {
	                return;
	            }

	            scrollerTopPosition = scroller.scrollTop;
	            scrollerTopOffset = scroller.element.offset().top;
	            pageTopOffset = page.element.offset().top;
	            pageMargin = !this._autoFit ? parseInt(page.element.css("marginTop"), 10) : 0;

	            this._pageNum = number;
	            this._loadVisiblePages();

	            this._preventScroll = true;

	            this._scroller.scrollTo(0, -scrollerTopPosition - pageTopOffset + scrollerTopOffset + pageMargin);
	            this.trigger(UPDATE, { action: PAGE_CHANGE, page: number, total: this.pages.length });
	        },

	        _getVisiblePagesCount: function () {
	            var that = this,
	                loadedPagesHeight = 0,
	                updatedVisiblePagesCount = 0,
	                containerHeight = that.pageContainer[0].clientHeight,
	                index = 0;

	            while(loadedPagesHeight <= containerHeight && index < that.pages.length)
	            {
	                loadedPagesHeight += that.pages[index].element.height();
	                updatedVisiblePagesCount++;
	                index++;
	            }

	            that._visiblePagesCount = updatedVisiblePagesCount;
	        },

	        _loadVisiblePages: function () {
	            var pagesCount = this.pages && this.pages.length,
	                minVisiblePageNum =  Math.max(this._pageNum - this._visiblePagesCount, 1),
	                maxVisiblePageNum = Math.min(this._pageNum + this._visiblePagesCount, pagesCount);

	            this._visiblePages = this.pages.slice(minVisiblePageNum - 1, maxVisiblePageNum);

	            for (var i = minVisiblePageNum; i <= maxVisiblePageNum; i++)
	            {
	                this.loadPage(i);
	            }
	        },

	        _loadAllPages: function () {
	            var pagesCount = this.pages && this.pages.length;
	            var promises = [];

	            for (var i = 0; i <= pagesCount; i++)
	            {
	                promises.push(this.loadPage(i));
	            }

	            return promises;
	        },

	        fromFile: function (file) {
	            this.zoomScale = this.options.scale || ZOOM_SCALE;
	            this.zoom(this.zoomScale, true);
	            this.trigger(UPDATE, { action: "zoom", zoom: this.options.scale || "auto" });

	            this.processor._updateDocument(file);
	            this._loadDocument();
	        },

	        exportImage: function (options) {
	            var that = this;
	            var pageNumber = options.page;
	            var page = that.pages[pageNumber - 1] || that._blankPage;
	            var rootGroup = new drawing.Group();

	            page.load();

	            var background = kendo.drawing.Path.fromRect(new kendo.geometry.Rect([0, 0], [page.width, page.height]), {
	                fill: {
	                    color: WHITECOLOR
	                },
	                stroke: null
	            });

	            progress(that.pageContainer, true);
	            rootGroup.append(background, page.group);

	            drawing.exportImage(rootGroup).done(function (data) {
	                progress(that.pageContainer, false);
	                kendo.saveAs({
	                    dataURI: data,
	                    fileName: options.fileName,
	                    proxyURL: options.proxyURL || "",
	                    forceProxy: options.forceProxy,
	                    proxyTarget: options.proxyTarget
	                });
	            });
	        },

	        exportSVG: function (options) {
	            var that = this;
	            var pageNumber = options.page;
	            var page = that.pages[pageNumber - 1] || that._blankPage;

	            progress(that.pageContainer, true);

	            page.load();

	            drawing.exportSVG(page.group).done(function (data) {
	                progress(that.pageContainer, false);
	                kendo.saveAs({
	                    dataURI: data,
	                    fileName: options.fileName,
	                    proxyURL: options.proxyURL || "",
	                    forceProxy: options.forceProxy,
	                    proxyTarget: options.proxyTarget
	                });
	            });
	        },

	        setOptions: function (options)
	        {
	            var that = this;

	            if (options.pdfjsProcessing || options.dplProcessing) {
	                that._initProcessor(options || {});
	            }

	            options = $.extend(that.options, options);

	            Widget.fn.setOptions.call(that, options);

	            if (options.page) {
	                that._pageNum = options.page;
	                that.activatePage(options.page);
	            }

	            if (options.width) {
	                that.element.width(options.width);
	            }

	            if (options.height) {
	                that.element.height(options.height);
	            }
	        },

	        destroy: function ()
	        {
	            if (this._resizeHandler)
	            {
	                kendo.unbindResize(this._resizeHandler);
	            }

	            //destroy nested components
	            if (this._errorDialog) {
	                this._errorDialog.destroy();
	            }

	            if (this._saveDialog) {
	                this._saveDialog.destroy();
	            }

	            if (this._upload) {
	                this._upload.destroy();
	            }

	            if (this.toolbar) {
	                this.toolbar.unbind();
	                this.toolbar.destroy();
	                this.toolbar = null;
	            }

	            if (this.pages && this.pages.length) {
	                this.pages.forEach(function (page) {
	                    page.destroy();
	                });
	                this.pages = [];
	            }

	            if (this._scroller) {
	                this._scroller.unbind();
	                this._scroller.destroy();
	            }
	            this.pageContainer.off(NS);

	            Widget.fn.destroy.call(this);
	        },

	        _clearPages: function () {
	            this.pages = [];
	            this.document = null;
	            this._pageNum = 1;

	            this.pageContainer.off(NS);
	            this.pageContainer.empty();

	            if (this._scroller)
	            {
	                this._scroller.reset();
	                this._scroller.unbind();
	                this._scroller.destroy();
	            }
	        },

	        _toggleSelection: function (enable) {
	            var that = this;

	            if(enable === undefined) {
	                enable = true;
	            }

	            that._scroller.userEvents._shouldNotMove = enable;

	            that._scroller.scrollElement.toggleClass(styles.enableTextSelection, enable);
	            that._scroller.scrollElement.toggleClass(styles.enablePanning, !enable);
	        },


	        _initSearchDOM: function () {
	            var that = this;
	            var promise = new Promise(function (resolve) {
	                Promise.all(that._loadAllPages()).then(function(){
	                    that._searchDOM = new kendo.pdfviewer.SearchDOM({
	                        target: that._getTextLayers(),
	                        highlightClass: styles.highlightClass,
	                        charClass: styles.charClass
	                    });

	                    resolve();
	                });
	            });

	            return promise;
	        },

	        _getTextLayers: function () {
	            return this.pages.map(function(page){
	                return page.textLayer;
	            });
	        }
	    });

	    ui.plugin(PDFViewer);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1345:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("twYp");

/***/ }),

/***/ 1346:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("xVbs");

/***/ }),

/***/ 1347:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("orsE");

/***/ }),

/***/ 1348:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("6DMD");

/***/ }),

/***/ 1349:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("P886");

/***/ }),

/***/ 1350:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("VT9e");

/***/ }),

/***/ 1351:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("yXJn");

/***/ })

/******/ });

/***/ }),

/***/ "ZSoY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        virtualItemHeight: {
            type: Number,
            default: undefined,
            kComposite: 'virtual.itemHeight'
        },
        virtualMapValueTo: {
            type: String,
            default: undefined,
            kComposite: 'virtual.mapValueTo'
        },
        virtualValueMapper: {
            type: Function,
            default: undefined,
            kComposite: 'virtual.valueMapper'
        }
    }
};

/***/ }),

/***/ "ZZFX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var Constants = (function () {
    function Constants() {
    }
    Constants.STEP_EVERYTHING = 0;
    Constants.STEP_FILTER = 1;
    Constants.STEP_SORT = 2;
    Constants.STEP_MAP = 3;
    Constants.STEP_AGGREGATE = 4;
    Constants.STEP_PIVOT = 5;
    Constants.ROW_BUFFER_SIZE = 10;
    Constants.LAYOUT_INTERVAL = 500;
    Constants.EXPORT_TYPE_DRAG_COPY = 'dragCopy';
    Constants.EXPORT_TYPE_CLIPBOARD = 'clipboard';
    Constants.EXPORT_TYPE_EXCEL = 'excel';
    Constants.EXPORT_TYPE_CSV = 'csv';
    Constants.KEY_BACKSPACE = 8;
    Constants.KEY_TAB = 9;
    Constants.KEY_NEW_LINE = 10;
    Constants.KEY_ENTER = 13;
    Constants.KEY_SHIFT = 16;
    Constants.KEY_ESCAPE = 27;
    Constants.KEY_SPACE = 32;
    Constants.KEY_LEFT = 37;
    Constants.KEY_UP = 38;
    Constants.KEY_RIGHT = 39;
    Constants.KEY_DOWN = 40;
    Constants.KEY_DELETE = 46;
    Constants.KEY_A = 65;
    Constants.KEY_C = 67;
    Constants.KEY_V = 86;
    Constants.KEY_D = 68;
    Constants.KEY_F2 = 113;
    Constants.KEY_PAGE_UP = 33;
    Constants.KEY_PAGE_DOWN = 34;
    Constants.KEY_PAGE_HOME = 36;
    Constants.KEY_PAGE_END = 35;
    Constants.ROW_MODEL_TYPE_INFINITE = 'infinite';
    Constants.ROW_MODEL_TYPE_VIEWPORT = 'viewport';
    Constants.ROW_MODEL_TYPE_IN_MEMORY = 'inMemory';
    Constants.ROW_MODEL_TYPE_ENTERPRISE = 'enterprise';
    Constants.DEPRECATED_ROW_MODEL_TYPE_NORMAL = 'normal';
    Constants.ALWAYS = 'always';
    Constants.ONLY_WHEN_GROUPING = 'onlyWhenGrouping';
    Constants.PINNED_TOP = 'top';
    Constants.PINNED_BOTTOM = 'bottom';
    return Constants;
}());
exports.Constants = Constants;


/***/ }),

/***/ "Zn08":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var filterService_1 = __webpack_require__("9jRp");
var FilterStage = (function () {
    function FilterStage() {
    }
    FilterStage.prototype.execute = function (params) {
        var rowNode = params.rowNode;
        if (this.gridOptionsWrapper.isEnableServerSideFilter()) {
            this.filterService.filter(rowNode, false);
        }
        else {
            this.filterService.filterAccordingToColumnState(rowNode);
        }
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], FilterStage.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('filterService'),
        __metadata("design:type", filterService_1.FilterService)
    ], FilterStage.prototype, "filterService", void 0);
    FilterStage = __decorate([
        context_1.Bean('filterStage')
    ], FilterStage);
    return FilterStage;
}());
exports.FilterStage = FilterStage;


/***/ }),

/***/ "Zo25":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1588);
	module.exports = __webpack_require__(1588);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1588:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    'use strict';

	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var $ = kendo.jQuery;
	    var alphaNumRegExp = /:alphanum$/;

	    var ACTIONS = {
	        "up": "up",
	        "down": "down",
	        "left": "left",
	        "right": "right",
	        "home": "first-col",
	        "end": "last-col",
	        "ctrl+left": "word-left",
	        "ctrl+right": "word-right",
	        "ctrl+up": "word-up",
	        "ctrl+down": "word-down",
	        "ctrl+home": "first",
	        "ctrl+end": "last",
	        "pageup": "prev-page",
	        "pagedown": "next-page"
	    };

	    var ENTRY_ACTIONS = {
	        "tab": "next",
	        "shift+tab": "previous",
	        "enter": "lower",
	        "shift+enter": "upper",
	        "delete": "clearContents",
	        "backspace": "clearContents",
	        "shift+:alphanum": "edit",
	        "alt+:alphanum": "edit",
	        ":alphanum": "edit",
	        "ctrl+:alphanum": "ctrl",
	        "alt+ctrl+:alphanum": "edit",
	        ":edit": "edit"
	    };

	    var CONTAINER_EVENTS = {
	        "wheel": "onWheel",
	        "*+mousedown": "onMouseDown",
	        "contextmenu": "onContextMenu",
	        "*+mousedrag": "onMouseDrag",
	        "*+mouseup": "onMouseUp",
	        "*+dblclick": "onDblClick",
	        "mousemove": "onMouseMove"
	    };

	    var CLIPBOARD_EVENTS = {
	        "pageup": "onPageUp",
	        "pagedown": "onPageDown",
	        "mouseup": "onMouseUp",
	        "*+cut": "onCut",
	        "*+paste": "onPaste",
	        "*+copy": "onCopy"
	    };

	    var EDITOR_EVENTS = {
	        "esc": "onEditorEsc",
	        "enter": "onEditorBlur",
	        "alt+enter": "insertNewline",
	        "shift+enter": "onEditorBlur",
	        "tab": "onEditorBlur",
	        "shift+tab": "onEditorBlur",
	        "shift+ctrl+enter": "onEditorArrayFormula"
	    };

	    var FORMULABAR_EVENTS = $.extend({ focus: "onEditorBarFocus" }, EDITOR_EVENTS);
	    var FORMULAINPUT_EVENTS = $.extend({ focus: "onEditorCellFocus" }, EDITOR_EVENTS);

	    var SELECTION_MODES = {
	       cell: "range",
	       rowheader: "row",
	       columnheader: "column",
	       topcorner: "sheet",
	       autofill: "autofill"
	    };

	    function toActionSelector(selectors) {
	        return selectors.map(function(action) {
	            return '[data-action="' + action + '"]';
	        }).join(",");
	    }

	    var COMPOSITE_UNAVAILABLE_ACTION_SELECTORS = toActionSelector([ 'cut', 'copy', 'paste', 'insert-left', 'insert-right', 'insert-above', 'insert-below' ]);
	    var UNHIDE_ACTION_SELECTORS = toActionSelector([ 'unhide-row', 'unhide-column' ]);

	    var ACTION_KEYS = [];
	    var SHIFT_ACTION_KEYS = [];
	    var ENTRY_ACTION_KEYS = [];

	    for (var key in ACTIONS) {
	        ACTION_KEYS.push(key);
	        SHIFT_ACTION_KEYS.push("shift+" + key);
	    }

	    for (key in ENTRY_ACTIONS) {
	        ENTRY_ACTION_KEYS.push(key);
	    }

	    CLIPBOARD_EVENTS[ACTION_KEYS] = "onAction";
	    CLIPBOARD_EVENTS[SHIFT_ACTION_KEYS] = "onShiftAction";
	    CLIPBOARD_EVENTS[ENTRY_ACTION_KEYS] = "onEntryAction";

	    FORMULAINPUT_EVENTS[ACTION_KEYS] = "onEditorAction";
	    FORMULAINPUT_EVENTS[SHIFT_ACTION_KEYS] = "onEditorShiftAction";

	    var Controller = kendo.Class.extend({
	        init: function(view, workbook) {
	            this.view = view;
	            this.workbook(workbook);
	            this.container = $(view.container);
	            this.clipboardElement = $(view.clipboard);
	            this.cellContextMenu = view.cellContextMenu;
	            this.rowHeaderContextMenu = view.rowHeaderContextMenu;
	            this.colHeaderContextMenu = view.colHeaderContextMenu;
	            this.drawingContextMenu = view.drawingContextMenu;
	            this.scroller = view.scroller;
	            this.tabstrip = view.tabstrip;
	            this.sheetsbar = view.sheetsbar;

	            view.nameEditor.bind("enter", this.onNameEditorEnter.bind(this));
	            view.nameEditor.bind("cancel", this.onNameEditorCancel.bind(this));
	            view.nameEditor.bind("select", this.onNameEditorSelect.bind(this));
	            view.nameEditor.bind("delete", this.onNameEditorDelete.bind(this));

	            this.editor = view.editor;
	            this.editor.bind("change", this.onEditorChange.bind(this));
	            this.editor.bind("activate", this.onEditorActivate.bind(this));
	            this.editor.bind("deactivate", this.onEditorDeactivate.bind(this));
	            this.editor.bind("update", this.onEditorUpdate.bind(this));

	            $(view.scroller).on("scroll", this.onScroll.bind(this));
	            this.listener = new kendo.spreadsheet.EventListener(this.container, this, CONTAINER_EVENTS);
	            $(view.scroller).on("mousedown", this.onMouseDown.bind(this));

	            this._enableEditorEvents();

	            if (this.sheetsbar) {
	                this.sheetsbar.bind("select", this.onSheetBarSelect.bind(this));
	                this.sheetsbar.bind("reorder", this.onSheetBarReorder.bind(this));
	                this.sheetsbar.bind("rename", this.onSheetBarRename.bind(this));
	                this.sheetsbar.bind("remove", this.onSheetBarRemove.bind(this));
	            }

	            this.cellContextMenu.bind("select", this.onContextMenuSelect.bind(this));
	            this.rowHeaderContextMenu.bind("select", this.onContextMenuSelect.bind(this));
	            this.colHeaderContextMenu.bind("select", this.onContextMenuSelect.bind(this));
	            this.drawingContextMenu.bind("select", this.onContextMenuSelect.bind(this));

	            // this is necessary for Windows to catch prevent context menu correctly
	            this.cellContextMenu.element
	                .add(this.rowHeaderContextMenu.element)
	                .add(this.colHeaderContextMenu.element)
	                .add(this.drawingContextMenu.element)
	                .on("contextmenu", false);

	            if (this.tabstrip) {
	                this.tabstrip.bind("action", this.onCommandRequest.bind(this));
	                this.tabstrip.bind("dialog", this.onDialogRequest.bind(this));
	            }
	        },

	        _enableEditorEvents: function (enable) {
	            if (enable === undefined || enable) {
	                this.keyListener = new kendo.spreadsheet.EventListener(this.clipboardElement, this, CLIPBOARD_EVENTS);
	                this.barKeyListener = new kendo.spreadsheet.EventListener(this.editor.barElement(), this, FORMULABAR_EVENTS);
	                this.inputKeyListener = new kendo.spreadsheet.EventListener(this.editor.cellElement(), this, FORMULAINPUT_EVENTS);
	            } else {
	                this.keyListener.destroy();
	                this.barKeyListener.destroy();
	                this.inputKeyListener.destroy();
	            }
	        },

	        _execute: function(options) {
	            var result = this._workbook.execute(options);

	            if (options.command === "EditCommand" && !result) {
	                this._workbook.trigger("change", { editorClose: true });
	            }

	            if (result) {
	                this._preventNavigation = true;
	                if (result.reason === "error") {
	                    this.editor.deactivate(true); // make sure we don't call any change hooks
	                    this.view.showError(result, function(){
	                        // we only get here in case of a validation error when the user decided to retry.
	                        this.activateEditor(false);
	                        // reset to last input from user
	                        this.editor.value(this._lastEditorValue);
	                        // however, set _value manually such that it'll detect change properly.  ugly :-\
	                        this.editor._value = this._workbook._inputForRef(this._workbook.activeSheet()._viewActiveCell());
	                        // seems like a nice UX to have the whole input selected
	                        this.editor.select();
	                    }.bind(this));
	                } else {
	                    this.view.openDialog(result.reason);
	                }
	            }

	            return result;
	        },

	        _activeTooltip: function() {
	            return this._workbook.activeSheet().activeCell().simplify().toString();
	        },

	        onContextMenuSelect: function(e) {
	            var action = $(e.item).data("action");
	            var command;
	            switch(action) {
	              case "cut":
	                command = { command: "ToolbarCutCommand", options: { workbook: this._workbook } };
	                break;
	              case "copy":
	                command = { command: "ToolbarCopyCommand", options: { workbook: this._workbook } };
	                break;
	              case "paste":
	                command = { command: "ToolbarPasteCommand", options: { workbook: this._workbook } };
	                break;
	              case "delete-drawing":
	                command = { command: "DeleteDrawingCommand", options: { drawing: this.navigator._sheet._activeDrawing } };
	                break;
	              case "bring-to-front":
	                command = { command: "BringToFrontCommand", options: { drawing: this.navigator._sheet._activeDrawing } };
	                break;
	              case "send-to-back":
	                command = { command: "SendToBackCommand", options: { drawing: this.navigator._sheet._activeDrawing } };
	                break;
	              case "unmerge":
	                command = { command: "MergeCellCommand", options: { value: "unmerge" } };
	                break;
	              case "merge":
	                this.view.openDialog("merge");
	                break;
	              case "hide-row":
	                command = { command: "HideLineCommand", options: { axis: "row" } };
	                break;
	              case "hide-column":
	                command = { command: "HideLineCommand", options: { axis: "column" } };
	                break;
	              case "unhide-row":
	                command = { command: "UnHideLineCommand", options: { axis: "row" } };
	                break;
	              case "unhide-column":
	                command = { command: "UnHideLineCommand", options: { axis: "column" } };
	                break;
	              case "delete-row":
	                command = { command: "DeleteRowCommand" };
	                break;
	              case "delete-column":
	                command = { command: "DeleteColumnCommand" };
	                break;
	            }

	            if (command) {
	                this._execute(command);
	            }
	        },

	        onSheetBarRemove: function(e) {
	            var sheet = this._workbook.sheetByName(e.name);

	            //TODO: move to model!
	            if (!sheet) {
	                return;
	            }

	            this._workbook.removeSheet(sheet);
	        },

	        destroy: function() {
	            this.listener.destroy();
	            this._enableEditorEvents(false);
	            this.keyListener.destroy();
	            this.inputKeyListener.destroy();
	        },

	        onSheetBarSelect: function(e) {
	            var sheet;
	            var workbook = this._workbook;

	            if (e.isAddButton) {
	                if (this._workbook.trigger("insertSheet")) {
	                    return;
	                }

	                sheet = workbook.insertSheet();
	            } else {
	                sheet = workbook.sheetByName(e.name);
	            }

	            //TODO: move to model
	            if (workbook.activeSheet().name() !== sheet.name()) {
	                if (this._workbook.trigger("selectSheet", { sheet: sheet })) {
	                    return;
	                }

	                if (!this.editor.canInsertRef(false)) {
	                    this.editor.deactivate();
	                }

	                workbook.activeSheet(sheet);
	            }
	        },

	        onSheetBarReorder: function(e) {
	            var sheet = this._workbook.sheetByIndex(e.oldIndex);

	            this._workbook.moveSheetToIndex(sheet, e.newIndex);

	            this._workbook.activeSheet(sheet);
	        },

	        onSheetBarRename: function(e) {
	            var sheet = this._workbook.sheetByIndex(e.sheetIndex);

	            if (this._workbook.sheetByName(e.name)) {
	                this.view.showError({ reason: "error", type: "duplicateSheetName" });
	                return;
	            }

	            this._workbook.renameSheet(sheet, e.name);

	            this.clipboardElement.focus();
	        },

	        sheet: function(sheet) {
	            this.navigator = sheet.navigator();
	            this.axisManager = sheet.axisManager();
	        },

	        workbook: function(workbook) {
	            this._workbook = workbook;
	            this.clipboard = workbook.clipboard();
	            workbook.bind("commandRequest", this.onCommandRequest.bind(this));
	        },

	        refresh: function() {
	            var editor = this.editor;
	            var workbook = this._workbook;
	            var sheet = workbook.activeSheet();

	            this._viewPortHeight = this.view.scroller.clientHeight;
	            this.navigator.height(this._viewPortHeight);

	            if (!editor.isActive() && !this.isEditorDisabled) {
	                editor.enable(sheet.selection().enable() !== false);
	                this.resetEditorValue();
	            }

	            var ref = sheet.selection()._ref.simplify();
	            var def = this._workbook.nameForRef(ref, sheet.name());
	            this.view.nameEditor.value(def.name);
	        },

	        onScroll: function() {
	            this.view.render({ scroll: true });
	        },

	        onWheel: function(event) {
	            var deltaX = event.originalEvent.deltaX;
	            var deltaY = event.originalEvent.deltaY;

	            if (event.originalEvent.deltaMode === 1) {
	                deltaX *= 10;
	                deltaY *= 10;
	            }

	            this.scrollWith(deltaX, deltaY);

	            event.preventDefault();
	        },

	        onAction: function(event, action) {
	            var sheet = this._workbook.activeSheet();
	            sheet._activeDrawing = null;
	            this.navigator.moveActiveCell(ACTIONS[action]);
	            event.preventDefault();
	        },

	        onPageUp: function() {
	            this.scrollDown(-this._viewPortHeight);
	        },

	        onPageDown: function() {
	            this.scrollDown(this._viewPortHeight);
	        },

	        onEntryAction: function(event, action) {
	            var sheet = this._workbook.activeSheet();

	            if (event.mod) {
	                var key = String.fromCharCode(event.keyCode);
	                var shouldPrevent = true;

	                switch(key) {
	                  case "A":
	                    sheet._activeDrawing = null;
	                    this.navigator.selectAll();
	                    break;
	                  case "Y":
	                    this._workbook.undoRedoStack.redo();
	                    break;
	                  case "Z":
	                    this._workbook.undoRedoStack.undo();
	                    break;
	                  default:
	                    shouldPrevent = false;
	                    break;
	                }
	                if (shouldPrevent) {
	                    event.preventDefault();
	                }
	            } else {
	                var disabled = sheet.selection().enable() === false;
	                var casual = action !== ":edit";

	                if (action == "delete" || action == "backspace") {
	                    if (sheet._activeDrawing) {
	                        this._execute({
	                            command: "DeleteDrawingCommand",
	                            options: { drawing: sheet._activeDrawing }
	                        });
	                    } else if (!disabled) {
	                        this._execute({ command: "ClearContentCommand" });
	                    }
	                    event.preventDefault();
	                } else if (alphaNumRegExp.test(action) || !casual) {
	                    sheet._activeDrawing = null;
	                    if (disabled) {
	                        event.preventDefault();
	                        return;
	                    }
	                    if (casual) {
	                        this.editor.value("");
	                    }
	                    this.activateEditor(casual);
	                } else {
	                    this.navigator.navigateInSelection(ENTRY_ACTIONS[action]);
	                    event.preventDefault();
	                }
	            }
	        },

	        onShiftAction: function(event, action) {
	            this.navigator.modifySelection(ACTIONS[action.replace("shift+", "")], this.appendSelection);
	            event.preventDefault();
	        },

	        onMouseMove: function(event) {
	            var sheet = this._workbook.activeSheet();

	            if (sheet.resizingInProgress() || sheet.selectionInProgress()) {
	                return;
	            }

	            var object = this.objectAt(event);
	            if (object.type === "columnresizehandle" || object.type === "rowresizehandle") {
	                sheet.positionResizeHandle(object.ref);
	            } else {
	                sheet.removeResizeHandle();
	            }

	            sheet._renderComment(object.type == "cell" ? object.ref : null);
	        },

	        onMouseDown: function(event) {
	            var object = this.objectAt(event);
	            if (object.pane) {
	                this.originFrame = object.pane;
	            }

	            if (this._startResizingDrawing(event, object)) {
	                event.stopPropagation();
	                return;
	            }

	            var sheet = this._workbook.activeSheet();
	            var win = this.container.closest('[data-role="window"]');
	            if (win.length) {
	                win = kendo.widgetInstance(win);
	                if (win && win.options.modal) {
	                    event.stopPropagation();
	                }
	            }

	            sheet._activeDrawing = null;
	            if (object.type === "drawing") {
	                sheet._activeDrawing = object.drawing;
	                object.copy = object.drawing.clone();
	                object.startBox = sheet.drawingBoundingBox(object.copy);
	                sheet.startDragging(object);
	                sheet.triggerChange({ dragging: true });
	                event.preventDefault();
	                return;
	            }

	            if (object.type === "editor") {
	                // XXX: canceling the edits, because they might not
	                // validate.  Not sure it's the Right Thing.
	                this.onEditorEsc();
	                this.openCustomEditor();
	                event.preventDefault();
	                return;
	            }

	            if (this.editor.canInsertRef(false) && object.ref) {
	                this._workbook.activeSheet()._setFormulaSelections(this.editor.highlightedRefs());
	                this.navigator.startSelection(object.ref, this._selectionMode, this.appendSelection, event.shiftKey, this.view);
	                event.preventDefault();
	                return;
	            } else {
	                this._preventNavigation = false;
	                this.editor.deactivate();
	                if (this._preventNavigation) {
	                    return;     // validation error
	                }
	            }

	            if (object.type === "columnresizehandle" || object.type === "rowresizehandle") {
	                sheet.startResizing({ x: object.x, y: object.y });
	                event.preventDefault();
	                return;
	            }

	            if (object.type === "filtericon") {
	                this.openFilterMenu(event);
	                event.preventDefault();
	                return;
	            }

	            this._selectionMode = SELECTION_MODES[object.type];
	            this.appendSelection = event.mod;
	            this.navigator.startSelection(object.ref, this._selectionMode, this.appendSelection, event.shiftKey, this.view);
	        },

	        _startResizingDrawing: function(event) {
	            var handle = $(event.target).closest(".k-spreadsheet-drawing-handle");
	            if (handle.length) {
	                var location = this.translateCoords(event);
	                var direction = handle.data("direction");
	                var sheet = this._workbook.activeSheet();
	                var drawing = sheet._activeDrawing;
	                sheet.startDragging({
	                    pane     : this.originFrame,
	                    drawing  : drawing,
	                    copy     : drawing.clone(),
	                    startBox : sheet.drawingBoundingBox(drawing),
	                    resize   : direction,
	                    //aspect   : drawing.width / drawing.height,
	                    startX   : location.x,
	                    startY   : location.y
	                });
	                return true;
	            }
	        },

	        onContextMenu: function(event) {
	            var sheet = this._workbook.activeSheet();

	            event.preventDefault();

	            if (sheet.resizingInProgress() || sheet.draggingInProgress()) {
	                return;
	            }

	            this.cellContextMenu.close();
	            this.colHeaderContextMenu.close();
	            this.rowHeaderContextMenu.close();
	            this.drawingContextMenu.close();

	            var menu;

	            var object = this.objectAt(event);

	            if (object.type === "columnresizehandle" || object.type === "rowresizehandle") {
	                return;
	            }

	            if (object.ref) {
	                this.navigator.selectForContextMenu(object.ref, SELECTION_MODES[object.type]);
	            } else if (object.type == "drawing") {
	                this.navigator.selectDrawingForContextMenu(object.drawing);
	            }

	            var isComposite = this.navigator._sheet.select() instanceof kendo.spreadsheet.UnionRef;
	            var showUnhide = false;
	            var showUnmerge = false;

	            if (object.type == "columnheader") {
	                menu = this.colHeaderContextMenu;
	                showUnhide = !isComposite && this.axisManager.selectionIncludesHiddenColumns();
	            } else if (object.type == "rowheader") {
	                menu = this.rowHeaderContextMenu;
	                showUnhide = !isComposite && this.axisManager.selectionIncludesHiddenRows();
	            } else if (object.type == "drawing") {
	                menu = this.drawingContextMenu;
	            } else {
	                menu = this.cellContextMenu;
	                showUnmerge = this.navigator.selectionIncludesMergedCells();
	            }

	            menu.element.find(COMPOSITE_UNAVAILABLE_ACTION_SELECTORS).toggle(!isComposite);
	            menu.element.find(UNHIDE_ACTION_SELECTORS).toggle(showUnhide);
	            menu.element.find('[data-action=unmerge]').toggle(showUnmerge);

	            // avoid the immediate close
	            setTimeout(function() {
	                menu.open(event.pageX, event.pageY);
	            });
	        },

	        prevent: function(event) {
	            event.preventDefault();
	        },

	        constrainResize: function(type, ref) {
	            var sheet = this._workbook.activeSheet();
	            var resizeHandle = sheet.resizeHandlePosition();

	            return !resizeHandle || type === "outside" || type === "topcorner" || ref.col < resizeHandle.col || ref.row < resizeHandle.row;
	        },

	        _dragDrawing: function(event) {
	            var sheet = this._workbook.activeSheet();
	            var drag = sheet.draggingInProgress();
	            if (!drag) {
	                return false;
	            }

	            var location = this.translateCoords(event);
	            var drawing = drag.drawing;
	            var deltaX = location.x - drag.startX;
	            var deltaY = location.y - drag.startY;

	            if (drag.resize == "SE") {
	                if (drag.aspect) {
	                    if (Math.abs(deltaX) > Math.abs(deltaY)) {
	                        drawing.width = Math.max(drag.copy.width + deltaX, 20);
	                        drawing.height = drawing.width / drag.aspect;
	                    } else {
	                        drawing.height = Math.max(drag.copy.height + deltaY, 20);
	                        drawing.width = drawing.height * drag.aspect;
	                    }
	                } else {
	                    drawing.width = Math.max(drag.copy.width + deltaX, 20);
	                    drawing.height = Math.max(drag.copy.height + deltaY, 20);
	                }
	            }
	            else if (drag.resize == "E") {
	                drawing.width = Math.max(drag.copy.width + deltaX, 20);
	            }
	            else if (drag.resize == "S") {
	                drawing.height = Math.max(drag.copy.height + deltaY, 20);
	            }
	            else if (drag.resize == "N") {
	                if (drag.copy.height - deltaY > 20) {
	                    drawing.height = drag.copy.height - deltaY;
	                    drawing.offsetY = drag.copy.offsetY + deltaY;
	                }
	            }
	            else if (drag.resize == "W") {
	                if (drag.copy.width - deltaX > 20) {
	                    drawing.width = drag.copy.width - deltaX;
	                    drawing.offsetX = drag.copy.offsetX + deltaX;
	                }
	            }
	            else if (drag.resize == "NE") {
	                drawing.width = Math.max(drag.copy.width + deltaX, 20);
	                if (drag.copy.height - deltaY > 20) {
	                    drawing.height = drag.copy.height - deltaY;
	                    drawing.offsetY = drag.copy.offsetY + deltaY;
	                }
	            }
	            else if (drag.resize == "SW") {
	                drawing.height = Math.max(drag.copy.height + deltaY, 20);
	                if (drag.copy.width - deltaX > 20) {
	                    drawing.width = drag.copy.width - deltaX;
	                    drawing.offsetX = drag.copy.offsetX + deltaX;
	                }
	            }
	            else if (drag.resize == "NW") {
	                if (drag.copy.height - deltaY > 20) {
	                    drawing.height = drag.copy.height - deltaY;
	                    drawing.offsetY = drag.copy.offsetY + deltaY;
	                }
	                if (drag.copy.width - deltaX > 20) {
	                    drawing.width = drag.copy.width - deltaX;
	                    drawing.offsetX = drag.copy.offsetX + deltaX;
	                }
	            }
	            // just moving (no resize)
	            else {
	                drawing.offsetX = drag.copy.offsetX + deltaX;
	                drawing.offsetY = drag.copy.offsetY + deltaY;
	            }

	            sheet.triggerChange({ dragging: true });

	            return true;
	        },

	        onMouseDrag: function(event) {
	            if (this._selectionMode === "sheet") {
	                return;
	            }

	            var location = { clientX: event.clientX, clientY: event.clientY };
	            var sheet = this._workbook.activeSheet();

	            if (this._dragDrawing(event)) {
	                return;
	            }

	            var object = this.objectAt(location);

	            if (sheet.resizingInProgress()) {

	                if (!this.constrainResize(object.type, object.ref)) {
	                    sheet.resizeHintPosition({ x: object.x, y: object.y });
	                }

	                return;
	            }

	            if (object.type === "outside") {
	                this.startAutoScroll(object);
	                return;
	            }

	            if (this.originFrame === object.pane) {
	                this.selectToLocation(location);
	            } else { // cross frame selection
	                var frame = this.originFrame._grid;

	                if (object.x > frame.right) {
	                    kendo.scrollLeft(this);
	                }

	                if (object.y > frame.bottom) {
	                    this.scrollTop();
	                }

	                if (object.y < frame.top || object.x < frame.left) {
	                    this.startAutoScroll(object, location);
	                } else {
	                    this.selectToLocation(location);
	                }
	            }

	            event.preventDefault();
	        },

	        onMouseUp: function(event) {
	            var sheet = this._workbook.activeSheet();
	            sheet.completeResizing();
	            sheet.completeDragging();

	            this.navigator.completeSelection();
	            this.stopAutoScroll();

	            var editor = this.editor.activeEditor();
	            if (!editor) {
	                return;
	            }
	            var el = event.target;
	            while (el) {
	                if (el === editor.element[0]) {
	                    return;
	                }
	                el = el.parentNode;
	            }

	            var object = this.objectAt(event);
	            if (object && object.ref && editor.canInsertRef(false)) {
	                editor.refAtPoint(sheet);
	                sheet._setFormulaSelections(editor.highlightedRefs());
	            }
	        },

	        onDblClick: function(event) {
	            var object = this.objectAt(event);
	            var disabled = this._workbook.activeSheet().selection().enable() === false;

	            if (object.type !== "cell" || disabled) {
	                return;
	            }

	            var sel = this._workbook.activeSheet().selection();
	            this.activateEditor(!sel.value() && !sel.formula());
	            this.onEditorUpdate();
	        },

	        onCut: function(e) {
	            if (e) {
	                var table = this.clipboardElement.find("table.kendo-clipboard-"+ this.clipboard._uid).detach();
	                this.clipboardElement.append(table.clone(false));
	                setTimeout(function() {
	                    this.clipboardElement.empty().append(table);
	                }.bind(this));
	            }

	            this.clipboard.menuInvoked = (e === undefined);
	            this._execute({
	                command: "CutCommand",
	                options: { workbook: this.view._workbook, event: e.originalEvent || e }
	            });
	        },

	        clipBoardValue: function() {
	            return this.clipboardElement.html();
	        },

	        _pasteImage: function(blob) {
	            var self = this;
	            var img = new window.Image();
	            img.src = window.URL.createObjectURL(blob);
	            img.onload = function() {
	                self._execute({
	                    command: "InsertImageCommand",
	                    options: {
	                        blob: blob,
	                        width: img.width,
	                        height: img.height
	                    }
	                });
	            };
	            setTimeout(function(){
	                window.URL.revokeObjectURL(img.src);
	            }, 10);
	        },

	        onPaste: function(e) {
	            var self = this;
	            var html = "";
	            var plain = "";
	            self.clipboard.menuInvoked = (e === undefined);
	            if (e) {
	                var clipboardData = e.originalEvent.clipboardData;
	                if (clipboardData && clipboardData.getData) {
	                    e.preventDefault();
	                    var hasHTML = false;
	                    var hasPlainText = false;
	                    // Firefox uses DOMStringList, needs special handling
	                    if (window.DOMStringList && clipboardData.types instanceof window.DOMStringList) {
	                        hasHTML = clipboardData.types.contains("text/html");
	                        hasPlainText = clipboardData.types.contains("text/plain");
	                    } else if (Array.isArray(clipboardData.types)) {
	                        hasHTML = clipboardData.types.indexOf("text/html") >= 0;
	                        hasPlainText = clipboardData.types.indexOf("text/plain") >= 0;
	                    } else {
	                        hasHTML = /text\/html/.test(clipboardData.types);
	                        hasPlainText = /text\/plain/.test(clipboardData.types);
	                    }
	                    if (hasHTML) {
	                        html = clipboardData.getData('text/html').trim();
	                    }
	                    if (hasPlainText) {
	                        plain = clipboardData.getData('text/plain').trim();
	                    }
	                    if (!html && !plain && clipboardData.items && clipboardData.items.length) {
	                        for (var i = 0; i < clipboardData.items.length; ++i) {
	                            var item = clipboardData.items[i];
	                            if (item.kind == "file" && /^image\/(?:png|jpe?g|gif)$/i.test(item.type)) {
	                                return self._pasteImage(item.getAsFile());
	                            }
	                        }
	                    }
	                } else {
	                    // workaround for IE's lack of access to the HTML clipboard data
	                    var table = self.clipboardElement.find("table.kendo-clipboard-"+ self.clipboard._uid).detach();
	                    self.clipboardElement.empty();

	                    if (window.clipboardData.files && window.clipboardData.files.length) {
	                        var file = window.clipboardData.files[0];
	                        if (/^image\/(?:png|jpe?g|gif)$/i.test(file.type)) {
	                            return self._pasteImage(file);
	                        }
	                    }
	                    html = self.clipboardElement.html();
	                    plain = window.clipboardData.getData("Text");
	                    if (plain) {
	                        plain = plain.trim();
	                    }
	                    if (!html && !plain) {
	                        return;
	                    }
	                    self.clipboard.external({ html: html, plain: plain });
	                    self.clipboardElement.empty().append(table);
	                    self._execute({
	                        command: "PasteCommand",
	                        options: { workbook: self.view._workbook, event: e.originalEvent || e }
	                    });
	                    self.clipboard.menuInvoked = true;

	                    return;
	                }
	            } else {
	                if (kendo.support.browser.msie) {
	                    self.clipboardElement.focus().select();
	                    document.execCommand('paste');
	                    return;
	                } else {
	                    self.clipboard.menuInvoked = true;
	                }
	            }

	            if (!html && !plain) {
	                return;
	            }
	            self.clipboard.external({ html: html, plain:plain });
	            self._execute({
	                command: "PasteCommand",
	                options: { workbook: self.view._workbook, event: e.originalEvent || e }
	            });
	        },

	        onCopy: function(e) {
	            this.clipboard.menuInvoked = (e === undefined);
	            this._execute({
	                command: "CopyCommand",
	                options: { workbook: this.view._workbook, event: e.originalEvent || e }
	            });
	        },

	////////////////////////////////////////////////////////////////////

	        scrollTop: function() {
	            this.scroller.scrollTop = 0;
	        },

	        scrollLeft: function() {
	            this.scroller.scrollLeft = 0;
	        },

	        scrollDown: function(value) {
	            this.scroller.scrollTop += value;
	        },

	        scrollRight: function(value) {
	            this.scroller.scrollLeft += value;
	        },

	        scrollWith: function(right, down) {
	            this.scroller.scrollTop += down;
	            this.scroller.scrollLeft += right;
	        },

	        translateCoords: function(location) {
	            var box = this.container[0].getBoundingClientRect();
	            return {
	                x: location.clientX - box.left,
	                y: location.clientY - box.top
	            };
	        },

	        objectAt: function(location, noDrawing) {
	            if (!location) {
	                return;
	            }
	            location = this.translateCoords(location);
	            return this.view.objectAt(location.x, location.y, noDrawing);
	        },

	        selectToLocation: function(cellLocation) {
	            var object = this.objectAt(cellLocation, true);

	            if (object.pane && object.ref) { // cell, rowheader or columnheader
	                this.extendSelection(object);
	                this.lastKnownCellLocation = cellLocation;
	                this.originFrame = object.pane;
	            }

	            this.stopAutoScroll();
	        },

	        extendSelection: function(object) {
	            this.navigator.extendSelection(object.ref, this._selectionMode);
	        },

	        autoScroll: function() {
	            var x = this._autoScrollTarget.x;
	            var y = this._autoScrollTarget.y;
	            var boundaries = this.originFrame._grid;
	            var scroller = this.view.scroller;
	            var scrollStep = 8;

	            var scrollLeft = scroller.scrollLeft;
	            var scrollTop = scroller.scrollTop;

	            if (x < boundaries.left) {
	                this.scrollRight(-scrollStep);
	            }
	            if (x > boundaries.right) {
	                this.scrollRight(scrollStep);
	            }
	            if (y < boundaries.top) {
	                this.scrollDown(-scrollStep);
	            }
	            if (y > boundaries.bottom) {
	                this.scrollDown(scrollStep);
	            }

	            if (scrollTop === scroller.scrollTop && scrollLeft === scroller.scrollLeft) {
	                this.selectToLocation(this.finalLocation);
	            } else {
	                this.extendSelection(this.objectAt(this.lastKnownCellLocation));
	            }
	        },

	        startAutoScroll: function(viewObject, location) {
	            if (!this._scrollInterval) {
	                this._scrollInterval = setInterval(this.autoScroll.bind(this), 50);
	            }

	            this.finalLocation = location || this.lastKnownCellLocation;

	            this._autoScrollTarget = viewObject;
	        },

	        stopAutoScroll: function() {
	            clearInterval(this._scrollInterval);
	            this._scrollInterval = null;
	        },

	        openCustomEditor: function() {
	            this.view.openCustomEditor();
	        },

	        openFilterMenu: function(event) {
	            var object = this.objectAt(event);
	            var sheet = this._workbook.activeSheet();
	            var column = sheet.filterColumn(object.ref);
	            var filterMenu = this.view.createFilterMenu(column);

	            filterMenu.bind("action", this.onCommandRequest.bind(this));
	            filterMenu.bind("action", filterMenu.close.bind(filterMenu));

	            filterMenu.openFor(event.target);
	        },

	////////////////////////////////////////////////////////////////////

	        _saveEditorValue: function(arrayFormula) {
	            var sheet = this.editor._range.sheet();
	            var value = this.editor.value();
	            if (this._workbook.activeSheet() !== sheet) {
	                // remove highlighted refs (XXX: which are mostly wrong, BTW)
	                this._workbook.activeSheet()._setFormulaSelections();
	                // go back to the original sheet
	                this._workbook.activeSheet(sheet);
	            }
	            sheet.isInEditMode(false);
	            this._lastEditorValue = value;
	            this._execute({
	                command: "EditCommand",
	                options: {
	                    value: value,
	                    arrayFormula: arrayFormula
	                }
	            });
	        },

	        onEditorChange: function() {
	            this._saveEditorValue(false);
	        },

	        onEditorArrayFormula: function() {
	            this._saveEditorValue(true);
	            this.editor.deactivate(true);
	        },

	        onEditorActivate: function() {
	            var workbook = this._workbook;
	            var sheet = workbook.activeSheet();

	            sheet._setFormulaSelections(this.editor.highlightedRefs());
	            sheet.isInEditMode(true);
	        },

	        onEditorDeactivate: function() {
	            var sheet = this._workbook.activeSheet();

	            sheet.isInEditMode(false);
	            sheet._setFormulaSelections([]);
	        },

	        onEditorUpdate: function() {
	            this._workbook.activeSheet()._setFormulaSelections(this.editor.highlightedRefs());
	        },

	        onEditorBarFocus: function() {
	            var disabled = this._workbook.activeSheet().selection().enable() === false;
	            if (disabled) {
	                return;
	            }
	            this.editor
	                .activate({
	                    range: this._workbook.activeSheet().selection(),
	                    rect: this.view.activeCellRectangle(),
	                    tooltip: this._activeTooltip()
	                });
	        },

	        onEditorCellFocus: function() {
	            this.editor.scale();
	        },

	        onEditorEsc: function() {
	            this.resetEditorValue();
	            this.editor.deactivate();

	            this.clipboardElement.focus();
	        },

	        insertNewline: function(e) {
	            e.preventDefault();
	            this.editor.insertNewline();
	        },

	        onEditorBlur: function(_, action) {
	            if (this.editor.isFiltered()) {
	                return;
	            }

	            this._preventNavigation = false;
	            this.editor.deactivate();

	            if (!this._preventNavigation) {
	                this.clipboardElement.focus();
	                this.navigator.navigateInSelection(ENTRY_ACTIONS[action]);
	            }
	        },

	        onEditorAction: function(event, action) {
	            var editor = this.editor;
	            var sheet = this._workbook.activeSheet();

	            if (this._casualEditing && /^(?:up|right|down|left)$/.test(action)) {
	                this.deactivateEditor();
	                this.navigator.moveActiveCell(ACTIONS[action]);
	                event.preventDefault();
	            }
	            else if (editor.canInsertRef(true)) {
	                this.navigator.moveActiveCell(ACTIONS[action]);
	                editor.activeEditor().refAtPoint(sheet);
	                sheet._setFormulaSelections(editor.highlightedRefs());
	                event.preventDefault();
	            }
	        },

	        onEditorShiftAction: function(event, action) {
	            var editor = this.editor;
	            var sheet = this._workbook.activeSheet();

	            if (editor.canInsertRef(true)) {
	                this.navigator.modifySelection(ACTIONS[action.replace("shift+", "")], this.appendSelection);

	                editor.activeEditor().refAtPoint(sheet);
	                sheet._setFormulaSelections(editor.highlightedRefs());

	                event.preventDefault();
	            }
	        },

	////////////////////////////////////////////////////////////////////
	        resetEditorValue: function() {
	            var sheet = this._workbook.activeSheet();
	            var ref = sheet.activeCell();
	            var input = this._workbook._inputForRef(ref);
	            var x = sheet.range(ref).intersectingArrayFormula();
	            if (x) {
	                input = "=" + x.formula;
	            }
	            this.editor.value(input, !!x);
	        },

	        activateEditor: function(casual) {
	            // This flag will be false when F2 has been pressed, and
	            // true when editing is "casual", i.e., user just started
	            // typing.  In this case we want arrow keys to do cell
	            // navigation rather than move the cursor.
	            // https://github.com/telerik/kendo-ui-core/issues/3644
	            this._casualEditing = casual;

	            this.editor.activate({
	                range: this._workbook.activeSheet().selection(),
	                rect: this.view.activeCellRectangle(),
	                tooltip: this._activeTooltip()
	            }).focus();
	        },

	        deactivateEditor: function() {
	            this.view.editor.deactivate();
	        },

	        onCommandRequest: function(e) {
	            if (e.command) {
	                this._execute(e);
	            } else {
	                this._workbook.undoRedoStack[e.action]();
	            }
	        },

	        onDialogRequest: function(e) {
	            var additionalOptions = {
	                pdfExport: this._workbook.options.pdf,
	                excelExport: this._workbook.options.excel
	            };

	            if (e.options) {
	                $.extend(true, e.options, additionalOptions);
	            } else {
	                e.options = additionalOptions;
	            }

	            this.view.openDialog(e.name, e.options);
	        },

	        onNameEditorEnter: function() {
	            var ref;
	            var workbook = this._workbook;
	            var sheet = workbook.activeSheet();
	            var name = this.view.nameEditor.value();

	            // 1. does it look like a reference, or already defined
	            // name?  If so, just select it (don't define/modify any
	            // names)
	            ref = kendo.spreadsheet.calc.parseReference(name, true) || workbook.nameValue(name);
	            if (ref instanceof kendo.spreadsheet.Ref) {
	                if (ref.sheet && ref.sheet.toLowerCase() != sheet.name().toLowerCase()) {
	                    // reference points to another sheet, select it if found
	                    var tmp = workbook.sheetByName(ref.sheet);
	                    if (tmp) {
	                        workbook.activeSheet(tmp);
	                        sheet = tmp;
	                    }
	                }
	                sheet.range(ref).select();
	                return;
	            }

	            ref = sheet.selection()._ref.clone().simplify().setSheet(sheet.name(), true);

	            // XXX: should we check if a name is already defined for this range, and update it instead?
	            // Excel just adds a new one, and provides a more complete Name Manager dialog.
	            //var def = workbook.nameForRef(ref, sheet.name());

	            // just define new name
	            this._execute({
	                command: "DefineNameCommand",
	                options: { name: name, value: ref }
	            });

	            this.clipboardElement.focus();
	        },
	        onNameEditorCancel: function() {
	            this.clipboardElement.focus();
	        },
	        onNameEditorSelect: function(ev) {
	            var name = ev.name;
	            var workbook = this._workbook;
	            var sheet = workbook.activeSheet();
	            var ref = workbook.nameValue(name);
	            if (ref instanceof kendo.spreadsheet.Ref) {
	                if (ref.sheet && ref.sheet.toLowerCase() != sheet.name().toLowerCase()) {
	                    // reference points to another sheet, select it if found
	                    var tmp = workbook.sheetByName(ref.sheet);
	                    if (tmp) {
	                        workbook.activeSheet(tmp);
	                        sheet = tmp;
	                    }
	                }
	                sheet.range(ref).select();
	                return;
	            }
	            this.clipboardElement.focus();
	        },
	        onNameEditorDelete: function(ev) {
	            this._execute({
	                command: "DeleteNameCommand",
	                options: { name: ev.name }
	            });
	            this.clipboardElement.focus();
	        }
	    });

	    kendo.spreadsheet.Controller = Controller;
	})(window.kendo);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "ZruT":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1639);
	module.exports = __webpack_require__(1639);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1639:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/***********************************************************************
	 * WARNING: this file is auto-generated.  If you change it directly,
	 * your modifications will eventually be lost.  The source code is in
	 * `kendo-drawing` repository, you should make your changes there and
	 * run `src-modules/sync.sh` in this repository.
	 */
	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(20)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {

	window.kendo.util = window.kendo.util || {};

	var LRUCache = kendo.Class.extend({
	    init: function(size) {

	        this._size = size;
	        this._length = 0;
	        this._map = {};
	    },

	    put: function(key, value) {
	        var map = this._map;
	        var entry = { key: key, value: value };

	        map[key] = entry;

	        if (!this._head) {
	            this._head = this._tail = entry;
	        } else {
	            this._tail.newer = entry;
	            entry.older = this._tail;
	            this._tail = entry;
	        }

	        if (this._length >= this._size) {
	            map[this._head.key] = null;
	            this._head = this._head.newer;
	            this._head.older = null;
	        } else {
	            this._length++;
	        }
	    },

	    get: function(key) {
	        var entry = this._map[key];

	        if (entry) {
	            if (entry === this._head && entry !== this._tail) {
	                this._head = entry.newer;
	                this._head.older = null;
	            }

	            if (entry !== this._tail) {
	                if (entry.older) {
	                    entry.older.newer = entry.newer;
	                    entry.newer.older = entry.older;
	                }

	                entry.older = this._tail;
	                entry.newer = null;

	                this._tail.newer = entry;
	                this._tail = entry;
	            }

	            return entry.value;
	        }
	    }
	});

	var REPLACE_REGEX = /\r?\n|\r|\t/g;
	var SPACE = ' ';

	function normalizeText(text) {
	    return String(text).replace(REPLACE_REGEX, SPACE);
	}

	function objectKey(object) {
	    var parts = [];
	    for (var key in object) {
	        parts.push(key + object[key]);
	    }

	    return parts.sort().join("");
	}

	// Computes FNV-1 hash
	// See http://en.wikipedia.org/wiki/Fowler%E2%80%93Noll%E2%80%93Vo_hash_function
	function hashKey(str) {
	    // 32-bit FNV-1 offset basis
	    // See http://isthe.com/chongo/tech/comp/fnv/#FNV-param
	    var hash = 0x811C9DC5;

	    for (var i = 0; i < str.length; ++i) {
	        hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
	        hash ^= str.charCodeAt(i);
	    }

	    return hash >>> 0;
	}

	function zeroSize() {
	    return { width: 0, height: 0, baseline: 0 };
	}

	var DEFAULT_OPTIONS = {
	    baselineMarkerSize: 1
	};

	var defaultMeasureBox;

	if (typeof document !== "undefined") {
	    defaultMeasureBox = document.createElement("div");
	    defaultMeasureBox.style.cssText = "position: absolute !important; top: -4000px !important; width: auto !important; height: auto !important;" +
	              "padding: 0 !important; margin: 0 !important; border: 0 !important;" +
	              "line-height: normal !important; visibility: hidden !important; white-space: pre!important;";
	}

	var TextMetrics = kendo.Class.extend({
	    init: function(options) {

	        this._cache = new LRUCache(1000);
	        this.options = $.extend({}, DEFAULT_OPTIONS, options);
	    },

	    measure: function(text, style, options) {
	        if (options === void 0) { options = {}; }

	        if (!text) {
	            return zeroSize();
	        }

	        var styleKey = objectKey(style);
	        var cacheKey = hashKey(text + styleKey);
	        var cachedResult = this._cache.get(cacheKey);

	        if (cachedResult) {
	            return cachedResult;
	        }

	        var size = zeroSize();
	        var measureBox = options.box || defaultMeasureBox;
	        var baselineMarker = this._baselineMarker().cloneNode(false);

	        for (var key in style) {
	            var value = style[key];
	            if (typeof value !== "undefined") {
	                measureBox.style[key] = value;
	            }
	        }

	        var textStr = options.normalizeText !== false ? normalizeText(text) : String(text);

	        measureBox.textContent = textStr;
	        measureBox.appendChild(baselineMarker);
	        document.body.appendChild(measureBox);

	        if (textStr.length) {
	            size.width = measureBox.offsetWidth - this.options.baselineMarkerSize;
	            size.height = measureBox.offsetHeight;
	            size.baseline = baselineMarker.offsetTop + this.options.baselineMarkerSize;
	        }

	        if (size.width > 0 && size.height > 0) {
	            this._cache.put(cacheKey, size);
	        }

	        measureBox.parentNode.removeChild(measureBox);

	        return size;
	    },

	    _baselineMarker: function() {
	        var marker = document.createElement("div");
	        marker.style.cssText = "display: inline-block; vertical-align: baseline;width: " +
	            this.options.baselineMarkerSize + "px; height: " + this.options.baselineMarkerSize + "px;overflow: hidden;";

	        return marker;
	    }
	});

	TextMetrics.current = new TextMetrics();

	function measureText(text, style, measureBox) {
	    return TextMetrics.current.measure(text, style, measureBox);
	}

	kendo.deepExtend(kendo.util, {
	    LRUCache: LRUCache,
	    TextMetrics: TextMetrics,
	    measureText: measureText,
	    objectKey: objectKey,
	    hashKey: hashKey,
	    normalizeText: normalizeText
	});

	})(window.kendo.jQuery);

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "a7ls":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: [String, Number],
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    autoWidth: {
        type: Boolean,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    clearButton: {
        type: Boolean,
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    delay: {
        type: Number,
        default: undefined
    },
    enable: {
        type: Boolean,
        default: undefined
    },
    enforceMinLength: {
        type: Boolean,
        default: undefined
    },
    filter: {
        type: String,
        default: undefined
    },
    fixedGroupTemplate: {
        type: [String, Function],
        default: undefined
    },
    footerTemplate: {
        type: [String, Function],
        default: undefined
    },
    groupTemplate: {
        type: [String, Function],
        default: undefined
    },
    height: {
        type: Number,
        default: undefined
    },
    highlightFirst: {
        type: Boolean,
        default: undefined
    },
    ignoreCase: {
        type: Boolean,
        default: undefined
    },
    minLength: {
        type: Number,
        default: undefined
    },
    noDataTemplate: {
        type: [String, Function],
        default: undefined
    },
    placeholder: {
        type: String,
        default: undefined
    },
    popup: {
        type: Object,
        default: undefined
    },
    separator: {
        type: [String, Array],
        default: undefined
    },
    suggest: {
        type: Boolean,
        default: undefined
    },
    headerTemplate: {
        type: [String, Function],
        default: undefined
    },
    template: {
        type: [String, Function],
        default: undefined
    },
    value: {
        type: [String, Number],
        default: undefined
    },
    valuePrimitive: {
        type: Boolean,
        default: undefined
    },
    virtual: {
        type: [Boolean, Object],
        default: undefined
    },

    // Events
    change: Function,
    close: Function,
    dataBound: {
        type: Function,
        default: undefined
    },
    filtering: Function,
    open: Function,
    select: Function
};

/***/ }),

/***/ "a9WV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
/**
 * There are many instances of this component covering each of the areas a row can be entered
 * eg body, pinned left, fullWidth. The component differs from others in that it's given the
 * elements, there is no template. All of the elements are part of the GridPanel.
 */
var RowContainerComponent = (function () {
    function RowContainerComponent(params) {
        this.childCount = 0;
        this.rowTemplatesToAdd = [];
        this.afterGuiAttachedCallbacks = [];
        this.eContainer = params.eContainer;
        this.eViewport = params.eViewport;
        this.hideWhenNoChildren = params.hideWhenNoChildren;
        this.body = params.body;
    }
    RowContainerComponent.prototype.postConstruct = function () {
        this.domOrder = this.gridOptionsWrapper.isEnsureDomOrder() && !this.gridOptionsWrapper.isForPrint();
        this.checkVisibility();
    };
    RowContainerComponent.prototype.getRowElement = function (compId) {
        return this.eContainer.querySelector("[comp-id=\"" + compId + "\"]");
    };
    RowContainerComponent.prototype.setHeight = function (height) {
        this.eContainer.style.height = height + "px";
        // can ask niall about this - was testing different ways to get the browser to display
        // unlimited number of rows
        // if (this.body) {
        //     let eParent = this.eViewport;
        //
        //     let FILLER_HEIGHT = 1000000;
        //
        //     let fillerCount = 0;
        //     let colors = ['#000020','#000040','#000060','#000080','#0000A0','#0000C0','#0000E0','#00F000','#00F020','#00F040','#00F060','#00F080','#00F0A0','#00F0C0','#00F0E0'];
        //     _.removeAllChildren(eParent);
        //     let pixelsToGo = height;
        //     while (pixelsToGo > 0) {
        //         fillerCount++;
        //         let pixelsThisDiv = (pixelsToGo > FILLER_HEIGHT) ? FILLER_HEIGHT : pixelsToGo;
        //         pixelsToGo -= FILLER_HEIGHT;
        //         let eFiller = document.createElement('div');
        //         eFiller.style.height = pixelsThisDiv + 'px';
        //         eFiller.style.backgroundColor = colors[fillerCount%colors.length];
        //         eFiller.innerHTML = '' + fillerCount;
        //         eParent.appendChild(eFiller);
        //     }
        //     console.log(`fillerCount = ${fillerCount}`);
        // }
    };
    RowContainerComponent.prototype.flushRowTemplates = function () {
        // if doing dom order, then rowTemplates will be empty,
        // or if no rows added since last time also empty.
        if (this.rowTemplatesToAdd.length !== 0) {
            var htmlToAdd = this.rowTemplatesToAdd.join('');
            utils_1.Utils.appendHtml(this.eContainer, htmlToAdd);
            this.rowTemplatesToAdd.length = 0;
        }
        // this only empty if no rows since last time, as when
        // doing dom order, we still have callbacks to process
        this.afterGuiAttachedCallbacks.forEach(function (func) { return func(); });
        this.afterGuiAttachedCallbacks.length = 0;
        this.lastPlacedElement = null;
    };
    RowContainerComponent.prototype.appendRowTemplate = function (rowTemplate, callback) {
        if (this.domOrder) {
            this.lastPlacedElement = utils_1.Utils.insertTemplateWithDomOrder(this.eContainer, rowTemplate, this.lastPlacedElement);
        }
        else {
            this.rowTemplatesToAdd.push(rowTemplate);
        }
        this.afterGuiAttachedCallbacks.push(callback);
        // it is important we put items in in order, so that when we open a row group,
        // the new rows are inserted after the opened group, but before the rows below.
        // that way, the rows below are over the new rows (as dom renders last in dom over
        // items previous in dom), otherwise the child rows would cover the row below and
        // that meant the user doesn't see the rows below slide away.
        this.childCount++;
        this.checkVisibility();
    };
    RowContainerComponent.prototype.ensureDomOrder = function (eRow) {
        if (this.domOrder) {
            utils_1.Utils.ensureDomOrder(this.eContainer, eRow, this.lastPlacedElement);
            this.lastPlacedElement = eRow;
        }
    };
    RowContainerComponent.prototype.removeRowElement = function (eRow) {
        this.eContainer.removeChild(eRow);
        this.childCount--;
        this.checkVisibility();
    };
    RowContainerComponent.prototype.checkVisibility = function () {
        if (!this.hideWhenNoChildren) {
            return;
        }
        var eGui = this.eViewport ? this.eViewport : this.eContainer;
        var visible = this.childCount > 0;
        if (this.visible !== visible) {
            this.visible = visible;
            utils_1.Utils.setVisible(eGui, visible);
        }
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], RowContainerComponent.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RowContainerComponent.prototype, "postConstruct", null);
    return RowContainerComponent;
}());
exports.RowContainerComponent = RowContainerComponent;


/***/ }),

/***/ "aQ8F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var pivotColDefService_1 = __webpack_require__("10Gu");
var PivotStage = (function () {
    function PivotStage() {
        this.uniqueValues = {};
    }
    PivotStage.prototype.execute = function (params) {
        var rootNode = params.rowNode;
        if (this.columnController.isPivotActive()) {
            this.executePivotOn(rootNode);
        }
        else {
            this.executePivotOff();
        }
    };
    PivotStage.prototype.executePivotOff = function () {
        this.aggregationColumnsHashLastTime = null;
        this.uniqueValues = {};
        this.columnController.setSecondaryColumns(null, "rowModelUpdated");
    };
    PivotStage.prototype.executePivotOn = function (rootNode) {
        var uniqueValues = this.bucketUpRowNodes(rootNode);
        var uniqueValuesChanged = this.setUniqueValues(uniqueValues);
        var aggregationColumns = this.columnController.getValueColumns();
        var aggregationColumnsHash = aggregationColumns.map(function (column) { return column.getId(); }).join('#');
        var aggregationFuncsHash = aggregationColumns.map(function (column) { return column.getAggFunc().toString(); }).join('#');
        var aggregationColumnsChanged = this.aggregationColumnsHashLastTime !== aggregationColumnsHash;
        var aggregationFuncsChanged = this.aggregationFuncsHashLastTime !== aggregationFuncsHash;
        this.aggregationColumnsHashLastTime = aggregationColumnsHash;
        this.aggregationFuncsHashLastTime = aggregationFuncsHash;
        if (uniqueValuesChanged || aggregationColumnsChanged || aggregationFuncsChanged) {
            var result = this.pivotColDefService.createPivotColumnDefs(this.uniqueValues);
            this.pivotColumnGroupDefs = result.pivotColumnGroupDefs;
            this.pivotColumnDefs = result.pivotColumnDefs;
            this.columnController.setSecondaryColumns(this.pivotColumnGroupDefs, "rowModelUpdated");
        }
    };
    PivotStage.prototype.setUniqueValues = function (newValues) {
        var json1 = JSON.stringify(newValues);
        var json2 = JSON.stringify(this.uniqueValues);
        var uniqueValuesChanged = json1 !== json2;
        // we only continue the below if the unique values are different, as otherwise
        // the result will be the same as the last time we did it
        if (uniqueValuesChanged) {
            this.uniqueValues = newValues;
            return true;
        }
        else {
            return false;
        }
    };
    // returns true if values were different
    PivotStage.prototype.bucketUpRowNodes = function (rootNode) {
        var _this = this;
        // accessed from inside inner function
        var uniqueValues = {};
        // finds all leaf groups and calls mapRowNode with it
        var recursivelySearchForLeafNodes = function (rowNode) {
            if (rowNode.leafGroup) {
                _this.bucketRowNode(rowNode, uniqueValues);
            }
            else {
                rowNode.childrenAfterFilter.forEach(function (child) {
                    recursivelySearchForLeafNodes(child);
                });
            }
        };
        recursivelySearchForLeafNodes(rootNode);
        return uniqueValues;
    };
    PivotStage.prototype.bucketRowNode = function (rowNode, uniqueValues) {
        var pivotColumns = this.columnController.getPivotColumns();
        if (pivotColumns.length === 0) {
            rowNode.childrenMapped = null;
            return;
        }
        rowNode.childrenMapped = this.bucketChildren(rowNode.childrenAfterFilter, pivotColumns, 0, uniqueValues);
    };
    PivotStage.prototype.bucketChildren = function (children, pivotColumns, pivotIndex, uniqueValues) {
        var _this = this;
        var mappedChildren = {};
        var pivotColumn = pivotColumns[pivotIndex];
        // map the children out based on the pivot column
        children.forEach(function (child) {
            var key = _this.valueService.getKeyForNode(pivotColumn, child);
            if (main_1.Utils.missing(key)) {
                key = '';
            }
            if (!uniqueValues[key]) {
                uniqueValues[key] = {};
            }
            if (!mappedChildren[key]) {
                mappedChildren[key] = [];
            }
            mappedChildren[key].push(child);
        });
        // if it's the last pivot column, return as is, otherwise go one level further in the map
        if (pivotIndex === pivotColumns.length - 1) {
            return mappedChildren;
        }
        else {
            var result_1 = {};
            main_1.Utils.iterateObject(mappedChildren, function (key, value) {
                result_1[key] = _this.bucketChildren(value, pivotColumns, pivotIndex + 1, uniqueValues[key]);
            });
            return result_1;
        }
    };
    PivotStage.prototype.getPivotColumnDefs = function () {
        return this.pivotColumnDefs;
    };
    __decorate([
        main_1.Autowired('rowModel'),
        __metadata("design:type", Object)
    ], PivotStage.prototype, "rowModel", void 0);
    __decorate([
        main_1.Autowired('valueService'),
        __metadata("design:type", main_1.ValueService)
    ], PivotStage.prototype, "valueService", void 0);
    __decorate([
        main_1.Autowired('columnController'),
        __metadata("design:type", main_1.ColumnController)
    ], PivotStage.prototype, "columnController", void 0);
    __decorate([
        main_1.Autowired('eventService'),
        __metadata("design:type", main_1.EventService)
    ], PivotStage.prototype, "eventService", void 0);
    __decorate([
        main_1.Autowired('pivotColDefService'),
        __metadata("design:type", pivotColDefService_1.PivotColDefService)
    ], PivotStage.prototype, "pivotColDefService", void 0);
    PivotStage = __decorate([
        main_1.Bean('pivotStage')
    ], PivotStage);
    return PivotStage;
}());
exports.PivotStage = PivotStage;


/***/ }),

/***/ "aW50":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = __webpack_require__("pQ38");
var utils_1 = __webpack_require__("IRr6");
var columnController_1 = __webpack_require__("77lH");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var context_1 = __webpack_require__("RQ1/");
var touchListener_1 = __webpack_require__("G4uV");
var componentAnnotations_1 = __webpack_require__("x5ih");
var originalColumnGroup_1 = __webpack_require__("pOb1");
var HeaderGroupComp = (function (_super) {
    __extends(HeaderGroupComp, _super);
    function HeaderGroupComp() {
        return _super.call(this, HeaderGroupComp.TEMPLATE) || this;
    }
    HeaderGroupComp.prototype.init = function (params) {
        this.params = params;
        this.setupLabel();
        this.addGroupExpandIcon();
        this.setupExpandIcons();
    };
    HeaderGroupComp.prototype.setupExpandIcons = function () {
        var _this = this;
        this.addInIcon('columnGroupOpened', 'agOpened');
        this.addInIcon('columnGroupClosed', 'agClosed');
        var expandAction = function () {
            var newExpandedValue = !_this.params.columnGroup.isExpanded();
            _this.columnController.setColumnGroupOpened(_this.params.columnGroup.getOriginalColumnGroup(), newExpandedValue, "uiColumnExpanded");
        };
        this.addTouchAndClickListeners(this.eCloseIcon, expandAction);
        this.addTouchAndClickListeners(this.eOpenIcon, expandAction);
        this.addDestroyableEventListener(this.getGui(), 'dblclick', expandAction);
        this.updateIconVisibility();
        var originalColumnGroup = this.params.columnGroup.getOriginalColumnGroup();
        this.addDestroyableEventListener(originalColumnGroup, originalColumnGroup_1.OriginalColumnGroup.EVENT_EXPANDED_CHANGED, this.updateIconVisibility.bind(this));
        this.addDestroyableEventListener(originalColumnGroup, originalColumnGroup_1.OriginalColumnGroup.EVENT_EXPANDABLE_CHANGED, this.updateIconVisibility.bind(this));
    };
    HeaderGroupComp.prototype.addTouchAndClickListeners = function (eElement, action) {
        var touchListener = new touchListener_1.TouchListener(this.eCloseIcon);
        this.addDestroyableEventListener(touchListener, touchListener_1.TouchListener.EVENT_TAP, action);
        this.addDestroyFunc(function () { return touchListener.destroy(); });
        this.addDestroyableEventListener(eElement, 'click', action);
    };
    HeaderGroupComp.prototype.updateIconVisibility = function () {
        var columnGroup = this.params.columnGroup;
        if (columnGroup.isExpandable()) {
            var expanded = this.params.columnGroup.isExpanded();
            utils_1.Utils.setVisible(this.eOpenIcon, !expanded);
            utils_1.Utils.setVisible(this.eCloseIcon, expanded);
        }
        else {
            utils_1.Utils.setVisible(this.eOpenIcon, false);
            utils_1.Utils.setVisible(this.eCloseIcon, false);
        }
    };
    HeaderGroupComp.prototype.addInIcon = function (iconName, refName) {
        var eIcon = utils_1.Utils.createIconNoSpan(iconName, this.gridOptionsWrapper, null);
        this.getRefElement(refName).appendChild(eIcon);
    };
    HeaderGroupComp.prototype.addGroupExpandIcon = function () {
        if (!this.params.columnGroup.isExpandable()) {
            utils_1.Utils.setVisible(this.eOpenIcon, false);
            utils_1.Utils.setVisible(this.eCloseIcon, false);
            return;
        }
    };
    HeaderGroupComp.prototype.setupLabel = function () {
        // no renderer, default text render
        if (this.params.displayName && this.params.displayName !== '') {
            if (utils_1.Utils.isBrowserSafari()) {
                this.getGui().style.display = 'table-cell';
            }
            var eInnerText = this.getRefElement('agLabel');
            eInnerText.innerHTML = this.params.displayName;
        }
    };
    HeaderGroupComp.TEMPLATE = "<div class=\"ag-header-group-cell-label\" ref=\"agContainer\">" +
        "<span ref=\"agLabel\" class=\"ag-header-group-text\"></span>" +
        "<span ref=\"agOpened\" class=\"ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded\"></span>" +
        "<span ref=\"agClosed\" class=\"ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed\"></span>" +
        "</div>";
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], HeaderGroupComp.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], HeaderGroupComp.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('agOpened'),
        __metadata("design:type", HTMLElement)
    ], HeaderGroupComp.prototype, "eOpenIcon", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('agClosed'),
        __metadata("design:type", HTMLElement)
    ], HeaderGroupComp.prototype, "eCloseIcon", void 0);
    return HeaderGroupComp;
}(component_1.Component));
exports.HeaderGroupComp = HeaderGroupComp;


/***/ }),

/***/ "aXhp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var filterManager_1 = __webpack_require__("Up6z");
var utils_1 = __webpack_require__("IRr6");
var popupService_1 = __webpack_require__("LnC7");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var eventService_1 = __webpack_require__("k5uU");
var StandardMenuFactory = (function () {
    function StandardMenuFactory() {
    }
    StandardMenuFactory.prototype.hideActiveMenu = function () {
        if (this.hidePopup) {
            this.hidePopup();
        }
    };
    StandardMenuFactory.prototype.showMenuAfterMouseEvent = function (column, mouseEvent) {
        var _this = this;
        this.showPopup(column, function (eMenu) {
            _this.popupService.positionPopupUnderMouseEvent({
                column: column,
                type: 'columnMenu',
                mouseEvent: mouseEvent,
                ePopup: eMenu
            });
        });
    };
    StandardMenuFactory.prototype.showMenuAfterButtonClick = function (column, eventSource) {
        var _this = this;
        this.showPopup(column, function (eMenu) {
            _this.popupService.positionPopupUnderComponent({ type: 'columnMenu', eventSource: eventSource,
                ePopup: eMenu, keepWithinBounds: true, column: column });
        });
    };
    StandardMenuFactory.prototype.showPopup = function (column, positionCallback) {
        var _this = this;
        var filterWrapper = this.filterManager.getOrCreateFilterWrapper(column);
        var eMenu = document.createElement('div');
        utils_1.Utils.addCssClass(eMenu, 'ag-menu');
        filterWrapper.guiPromise.promise.then(function (gui) {
            eMenu.appendChild(gui);
        });
        var hidePopup;
        var bodyScrollListener = function (event) {
            // if h scroll, popup is no longer over the column
            if (event.direction === 'horizontal') {
                hidePopup();
            }
        };
        this.eventService.addEventListener('bodyScroll', bodyScrollListener);
        var closedCallback = function () {
            _this.eventService.removeEventListener('bodyScroll', bodyScrollListener);
            column.setMenuVisible(false, "contextMenu");
        };
        // need to show filter before positioning, as only after filter
        // is visible can we find out what the width of it is
        hidePopup = this.popupService.addAsModalPopup(eMenu, true, closedCallback);
        positionCallback(eMenu);
        filterWrapper.filterPromise.then(function (filter) {
            if (filter.afterGuiAttached) {
                var params = {
                    hidePopup: hidePopup
                };
                filter.afterGuiAttached(params);
            }
        });
        this.hidePopup = hidePopup;
        column.setMenuVisible(true, "contextMenu");
    };
    StandardMenuFactory.prototype.isMenuEnabled = function (column) {
        // for standard, we show menu if filter is enabled, and he menu is not suppressed
        return this.gridOptionsWrapper.isEnableFilter() && column.isFilterAllowed();
    };
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], StandardMenuFactory.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('filterManager'),
        __metadata("design:type", filterManager_1.FilterManager)
    ], StandardMenuFactory.prototype, "filterManager", void 0);
    __decorate([
        context_1.Autowired('popupService'),
        __metadata("design:type", popupService_1.PopupService)
    ], StandardMenuFactory.prototype, "popupService", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], StandardMenuFactory.prototype, "gridOptionsWrapper", void 0);
    StandardMenuFactory = __decorate([
        context_1.Bean('menuFactory')
    ], StandardMenuFactory);
    return StandardMenuFactory;
}());
exports.StandardMenuFactory = StandardMenuFactory;


/***/ }),

/***/ "aghF":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(908);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 882:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nzx/");

/***/ }),

/***/ 884:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FTkt");

/***/ }),

/***/ 887:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 888:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Fv0e");

/***/ }),

/***/ 908:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/***********************************************************************
	 * WARNING: this file is auto-generated.  If you change it directly,
	 * your modifications will eventually be lost.  The source code is in
	 * `kendo-charts` repository, you should make your changes there and
	 * run `src-modules/sync.sh` in this repository.
	 */
	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(887),
	        __webpack_require__(888),
	        __webpack_require__(884),
	        __webpack_require__(882)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {

	window.kendo.dataviz = window.kendo.dataviz || {};
	var dataviz = kendo.dataviz;
	var getSpacing = dataviz.getSpacing;
	var defined = dataviz.defined;
	var constants = dataviz.constants;
	var BLACK = constants.BLACK;
	var COORD_PRECISION = constants.COORD_PRECISION;
	var services = dataviz.services;
	var deepExtend = dataviz.deepExtend;
	var isArray = dataviz.isArray;
	var setDefaultOptions = dataviz.setDefaultOptions;
	var NumericAxis = dataviz.NumericAxis;
	var limitValue = dataviz.limitValue;
	var Box = dataviz.Box;
	var interpolateValue = dataviz.interpolateValue;
	var round = dataviz.round;
	var drawing = kendo.drawing;
	var DrawingGroup = drawing.Group;
	var DrawingPath = drawing.Path;
	var Animation = drawing.Animation;
	var AnimationFactory = drawing.AnimationFactory;
	var geometry = kendo.geometry;
	var Rect = geometry.Rect;
	var GeometryPoint = geometry.Point;
	var transform = geometry.transform;

	var ANGULAR_SPEED = 150;
	var LINEAR_SPEED = 250;
	var ARROW = "arrow";
	var ARROW_POINTER = "arrowPointer";
	var BAR_POINTER = "barPointer";
	var DEFAULT_HEIGHT = 200;
	var DEFAULT_LINE_WIDTH = 0.5;
	var DEFAULT_WIDTH = 200;
	var DEGREE = Math.PI / 180;
	var INSIDE = "inside";
	var LINEAR = "linear";
	var OUTSIDE = "outside";
	var RADIAL_POINTER = "radialPointer";
	var RADIAL_RANGE_POINTER = "radialRangePointer";

	function pad(bbox, value) {
	    var origin = bbox.getOrigin();
	    var size = bbox.getSize();
	    var spacing = getSpacing(value);

	    bbox.setOrigin([ origin.x - spacing.left, origin.y - spacing.top ]);
	    bbox.setSize([ size.width + (spacing.left + spacing.right), size.height + (spacing.top + spacing.bottom) ]);

	    return bbox;
	}

	var Group = DrawingGroup;
	var Path$1 = DrawingPath;
	var Text = drawing.Text;

	function buildLabelElement(label, options) {
	    var labelBox = label.box;
	    var textBox = label.children[0].box;
	    var border = options.border || {};
	    var background = options.background || "";

	    var wrapper = Path$1.fromRect(new Rect([ labelBox.x1, labelBox.y1 ], [ labelBox.width(), labelBox.height() ]), {
	        stroke: {}
	    });

	    var text = new Text(label.text, new GeometryPoint(textBox.x1, textBox.y1), {
	        font: options.font,
	        fill: { color: options.color }
	    });

	    var styleGeometry = pad(text.bbox().clone(), options.padding);

	    var styleBox = Path$1.fromRect(styleGeometry, {
	        stroke: {
	            color: border.width ? border.color : "",
	            width: border.width,
	            opacity: border.opacity,
	            dashType: border.dashType,
	            lineJoin: "round",
	            lineCap: "round"
	        },
	        fill: {
	            color: background
	        }
	    });

	    var elements = new Group();
	    elements.append(wrapper);
	    elements.append(styleBox);
	    elements.append(text);

	    return elements;
	}

	function getRange(range, min, max) {
	    var from = defined(range.from) ? range.from : constants.MIN_VALUE;
	    var to = defined(range.to) ? range.to : constants.MAX_VALUE;

	    range.from = Math.max(Math.min(to, from), min);
	    range.to = Math.min(Math.max(to, from), max);

	    return range;
	}

	function unpad(bbox, value) {
	    var spacing = getSpacing(value);

	    spacing.left = -spacing.left; spacing.top = -spacing.top;
	    spacing.right = -spacing.right; spacing.bottom = -spacing.bottom;

	    return pad(bbox, spacing);
	}

	var DEFAULT_MARGIN = 5;
	var Path = DrawingPath;
	var Surface = drawing.Surface;

	var Gauge = dataviz.Class.extend({
	    init: function(element, userOptions, theme, context) {
	        if (context === void 0) { context = {}; }

	        this.element = element;
	        this.theme = theme;
	        this.contextService = new services.ChartService(this, context);
	        this._originalOptions = deepExtend({}, this.options, userOptions);
	        this.options = deepExtend({}, this._originalOptions);
	        this._initTheme(theme);

	        this.redraw();
	    },

	    destroy: function() {
	        if (this.surface) {
	            this.surface.destroy();
	            this.surface = null;
	        }

	        delete this.element;
	        delete this.surfaceElement;
	    },

	    value: function(pointerValue) {
	        var pointer = this.pointers[0];

	        if (arguments.length === 0) {
	            return pointer.value();
	        }

	        pointer.value(pointerValue);
	        this._setValueOptions(pointerValue);
	    },

	    _draw: function() {
	        var surface = this.surface;

	        surface.clear();
	        surface.draw(this._visuals);
	    },

	    exportVisual: function() {
	        return this._visuals;
	    },

	    allValues: function(values) {
	        var pointers = this.pointers;
	        var allValues = [];

	        if (arguments.length === 0) {
	            for (var i = 0; i < pointers.length; i++) {
	                allValues.push(pointers[i].value());
	            }

	            return allValues;
	        }

	        if (isArray(values)) {
	            for (var i$1 = 0; i$1 < values.length; i$1++) {
	                if (dataviz.isNumber(values[i$1])) {
	                    pointers[i$1].value(values[i$1]);
	                }
	            }
	        }

	        this._setValueOptions(values);
	    },

	    _setValueOptions: function(values) {
	        var pointers = [].concat(this.options.pointer);
	        var arrayValues = [].concat(values);

	        for (var i = 0; i < arrayValues.length; i++) {
	            pointers[i].value = arrayValues[i];
	        }
	    },

	    resize: function() {
	        this.noTransitionsRedraw();
	    },

	    noTransitionsRedraw: function() {
	        var transitions = this.options.transitions;

	        this._toggleTransitions(false);

	        this.redraw();

	        this._toggleTransitions(transitions);
	    },

	    redraw: function() {
	        var size = this._surfaceSize();
	        var wrapper = new Rect([ 0, 0 ], [ size.width, size.height ]);

	        this._initSurface();

	        this.gaugeArea = this._createGaugeArea();

	        this._createModel();

	        var bbox = unpad(wrapper.bbox(), this._gaugeAreaMargin);
	        this.reflow(bbox);
	    },

	    setOptions: function(options, theme) {
	        this._originalOptions = deepExtend(this._originalOptions, options);
	        this.options = deepExtend({}, this._originalOptions);

	        this._initTheme(theme);

	        this.redraw();
	    },

	    setDirection: function(rtl) {
	        this.contextService.rtl = Boolean(rtl);
	        if (this.surface && this.surface.type === 'svg') {
	            this.surface.destroy();
	            this.surface = null;
	        }
	    },

	    setIntlService: function(intl) {
	        this.contextService.intl = intl;
	    },

	    _initTheme: function(theme) {
	        var currentTheme = theme || this.theme || {};
	        this.theme = currentTheme;

	        this.options = deepExtend({}, currentTheme, this.options);
	        var options = this.options;
	        var pointer = options.pointer;

	        if (isArray(pointer)) {
	            var pointers = [];
	            for (var i = 0; i < pointer.length; i++) {
	                pointers.push(deepExtend({}, currentTheme.pointer, pointer[i]));
	            }
	            options.pointer = pointers;
	        }
	    },

	    _createGaugeArea: function() {
	        var options = this.options.gaugeArea;
	        var size = this.surface.size();
	        var border = options.border || {};
	        var areaGeometry = new Rect([ 0, 0 ], [ size.width, size.height ]);

	        this._gaugeAreaMargin = options.margin || DEFAULT_MARGIN;

	        if (border.width > 0) {
	            areaGeometry = unpad(areaGeometry, border.width);
	        }

	        var gaugeArea = Path.fromRect(areaGeometry, {
	            stroke: {
	                color: border.width ? border.color : "",
	                width: border.width,
	                dashType: border.dashType,
	                lineJoin: "round",
	                lineCap: "round"
	            },
	            fill: {
	                color: options.background
	            }
	        });

	        return gaugeArea;
	    },

	    _initSurface: function() {
	        var ref = this;
	        var options = ref.options;
	        var surface = ref.surface;
	        var element = this._surfaceElement();
	        var size = this._surfaceSize();

	        dataviz.elementSize(element, size);

	        if (!surface || surface.options.type !== options.renderAs) {
	            if (surface) {
	                surface.destroy();
	            }

	            this.surface = Surface.create(element, {
	                type: options.renderAs
	            });
	        } else {
	            this.surface.clear();
	            this.surface.resize();
	        }
	    },

	    _surfaceSize: function() {
	        var options = this.options;
	        var size = this._getSize();

	        if (options.gaugeArea) {
	            deepExtend(size, options.gaugeArea);
	        }

	        return size;
	    },

	    _surfaceElement: function() {
	        if (!this.surfaceElement) {
	            this.surfaceElement = document.createElement('div');
	            this.element.appendChild(this.surfaceElement);
	        }

	        return this.surfaceElement;
	    },

	    getSize: function() {
	        return this._getSize();
	    },

	    _getSize: function() {
	        var element = this.element;
	        var defaultSize = this._defaultSize();
	        var width = element.offsetWidth;
	        var height = element.offsetHeight;

	        if (!width) {
	            width = defaultSize.width;
	        }

	        if (!height) {
	            height = defaultSize.height;
	        }

	        return { width: width, height: height };
	    },

	    _defaultSize: function() {
	        return {
	            width: DEFAULT_WIDTH,
	            height: DEFAULT_HEIGHT
	        };
	    },

	    _toggleTransitions: function(value) {
	        var this$1 = this;

	        this.options.transitions = value;
	        for (var i = 0; i < this.pointers.length; i++) {
	            this$1.pointers[i].options.animation.transitions = value;
	        }
	    }
	});

	setDefaultOptions(Gauge, {
	    plotArea: {},
	    theme: "default",
	    renderAs: "",
	    pointer: {},
	    scale: {},
	    gaugeArea: {}
	});

	var Path$2 = DrawingPath;
	var Group$2 = DrawingGroup;
	var Point = GeometryPoint;

	function renderAxisTick(tickRenderOptions, tickOptions) {
	    var position = tickRenderOptions.position;
	    var tickX = tickRenderOptions.tickX;
	    var tickY = tickRenderOptions.tickY;
	    var start, end;

	    if (tickRenderOptions.vertical) {
	        start = new Point(tickX, position);
	        end = new Point(tickX + tickOptions.size, position);
	    } else {
	        start = new Point(position, tickY);
	        end = new Point(position, tickY + tickOptions.size);
	    }

	    var tickPath = new Path$2({
	        stroke: {
	            color: tickOptions.color,
	            width: tickOptions.width
	        }
	    }).moveTo(start).lineTo(end);

	    return tickPath;
	}

	function renderTicks(tickGroup, tickPositions, tickRenderOptions, tickOptions) {
	    var count = tickPositions.length;

	    if (tickOptions.visible) {
	        var mirror = tickRenderOptions.mirror;
	        var lineBox = tickRenderOptions.lineBox;
	        for (var i = tickOptions.skip; i < count; i += tickOptions.step) {
	            if (i % tickOptions.skipUnit === 0) {
	                continue;
	            }

	            tickRenderOptions.tickX = mirror ? lineBox.x2 : lineBox.x2 - tickOptions.size;
	            tickRenderOptions.tickY = mirror ? lineBox.y1 - tickOptions.size : lineBox.y1;
	            tickRenderOptions.position = tickPositions[i];

	            tickGroup.append(renderAxisTick(tickRenderOptions, tickOptions));
	        }
	    }
	}

	var LinearScale = NumericAxis.extend({
	    init: function(options, service) {
	        var scaleOptions = options || {};
	        if (!defined(scaleOptions.reverse) && scaleOptions.vertical === false && (service || {}).rtl) {
	            scaleOptions = $.extend({}, scaleOptions, {
	                reverse: true
	            });
	        }

	        NumericAxis.fn.init.call(this, 0, 1, scaleOptions, service);

	        this.options.minorUnit = this.options.minorUnit || this.options.majorUnit / 10;
	    },

	    initUserOptions: function(options) {
	        var scaleOptions = deepExtend({}, this.options, options);
	        scaleOptions = deepExtend({}, scaleOptions , { labels: { mirror: scaleOptions.mirror } });
	        scaleOptions.majorUnit = scaleOptions.majorUnit || dataviz.autoMajorUnit(scaleOptions.min, scaleOptions.max);

	        return scaleOptions;
	    },

	    initFields: function() {
	    },

	    render: function() {
	        var elements = this.elements = new Group$2();
	        var labels = this.renderLabels();
	        var scaleLine = this.renderLine();
	        var scaleTicks = this.renderTicks();
	        var ranges = this.renderRanges();

	        elements.append(scaleLine, labels, scaleTicks, ranges);

	        return elements;
	    },

	    renderRanges: function() {
	        var this$1 = this;

	        var options = this.options;
	        var min = options.min;
	        var max = options.max;
	        var vertical = options.vertical;
	        var mirror = options.labels.mirror;
	        var ranges = options.ranges || [];
	        var elements = new Group$2();
	        var count = ranges.length;
	        var rangeSize = options.rangeSize || options.minorTicks.size / 2;

	        for (var i = 0; i < count; i++) {
	            var range = getRange(ranges[i], min, max);
	            var slot = this$1.getSlot(range.from, range.to);
	            var slotX = vertical ? this$1.lineBox() : slot;
	            var slotY = vertical ? slot : this$1.lineBox();
	            if (vertical) {
	                slotX.x1 -= rangeSize * (mirror ? -1 : 1);
	            } else {
	                slotY.y2 += rangeSize * (mirror ? -1 : 1);
	            }

	            elements.append(Path$2.fromRect(new Rect([ slotX.x1, slotY.y1 ], [ slotX.x2 - slotX.x1, slotY.y2 - slotY.y1 ]), {
	                fill: { color: range.color, opacity: range.opacity },
	                stroke: { }
	            }));
	        }

	        return elements;
	    },

	    renderLabels: function() {
	        var ref = this;
	        var labels = ref.labels;
	        var options = ref.options;
	        var elements = new Group$2();

	        for (var i = 0; i < labels.length; i++) {
	            elements.append(buildLabelElement(labels[i], options.labels));
	        }

	        return elements;
	    },

	    renderLine: function() {
	        var line = this.options.line;
	        var lineBox = this.lineBox();
	        var elements = new Group$2();

	        if (line.width > 0 && line.visible) {
	            var linePath = new Path$2({
	                stroke: {
	                    color: line.color,
	                    dashType: line.dashType,
	                    width: line.width
	                }
	            });

	            linePath.moveTo(lineBox.x1, lineBox.y1).lineTo(lineBox.x2, lineBox.y2);
	            elements.append(linePath);
	        }

	        return elements;
	    },

	    renderTicks: function() {
	        var ticks = new Group$2();
	        var options = this.options;
	        var majorUnit = options.majorTicks.visible ? options.majorUnit : 0;
	        var tickRenderOptions = {
	            vertical: options.vertical,
	            mirror: options.labels.mirror,
	            lineBox: this.lineBox()
	        };

	        renderTicks(ticks, this.getMajorTickPositions(), tickRenderOptions, options.majorTicks);
	        renderTicks(ticks, this.getMinorTickPositions(), tickRenderOptions, deepExtend({}, {
	            skipUnit: majorUnit / options.minorUnit
	        }, options.minorTicks));

	        return ticks;
	    }
	});

	setDefaultOptions(LinearScale, {
	    min: 0,
	    max: 50,

	    majorTicks: {
	        size: 15,
	        align: INSIDE,
	        color: BLACK,
	        width: DEFAULT_LINE_WIDTH,
	        visible: true
	    },

	    minorTicks: {
	        size: 10,
	        align: INSIDE,
	        color: BLACK,
	        width: DEFAULT_LINE_WIDTH,
	        visible: true
	    },

	    line: {
	        width: DEFAULT_LINE_WIDTH
	    },

	    labels: {
	        position: INSIDE,
	        padding: 2
	    },
	    mirror: false,
	    _alignLines: false
	});

	var Pointer = dataviz.Class.extend({
	    init: function(scale, userOptions) {

	        var ref = scale.options;
	        var min = ref.min;
	        var max = ref.max;
	        var options = this.options = deepExtend({}, this.options, userOptions);

	        options.fill = options.color;

	        this.scale = scale;

	        if (defined(options.value)) {
	            options.value = limitValue(options.value, min, max);
	        } else {
	            options.value = min;
	        }
	    },

	    value: function(newValue) {
	        var options = this.options;
	        var value = options.value;

	        if (arguments.length === 0) {
	            return value;
	        }

	        var ref = this.scale.options;
	        var min = ref.min;
	        var max = ref.max;

	        options._oldValue = defined(options._oldValue) ? options.value : min;
	        options.value = limitValue(newValue, min, max);

	        if (this.elements) {
	            this.repaint();
	        }
	    }
	});

	setDefaultOptions(Pointer, {
	    color: BLACK
	});

	var LinearPointer = Pointer.extend({
	    init: function(scale, options) {
	        Pointer.fn.init.call(this, scale, options);

	        this.options = deepExtend({
	            track: {
	                visible: defined(options.track)
	            }
	        }, this.options);
	    },

	    reflow: function() {
	        var ref = this;
	        var options = ref.options;
	        var scale = ref.scale;
	        var ref$1 = scale.options;
	        var mirror = ref$1.mirror;
	        var vertical = ref$1.vertical;
	        var scaleLine = scale.lineBox();
	        var trackSize = options.track.size || options.size;
	        var pointerHalfSize = options.size / 2;
	        var margin = getSpacing(options.margin);
	        var space = vertical ?
	                 margin[mirror ? "left" : "right"] :
	                 margin[mirror ? "bottom" : "top"];
	        var pointerBox, pointerRangeBox, trackBox;

	        space = mirror ? -space : space;

	        if (vertical) {
	            trackBox = new Box(
	                scaleLine.x1 + space, scaleLine.y1,
	                scaleLine.x1 + space, scaleLine.y2);

	            if (mirror) {
	                trackBox.x1 -= trackSize;
	            } else {
	                trackBox.x2 += trackSize;
	            }

	            if (options.shape !== BAR_POINTER) {
	                pointerRangeBox = new Box(
	                    scaleLine.x2 + space, scaleLine.y1 - pointerHalfSize,
	                    scaleLine.x2 + space, scaleLine.y2 + pointerHalfSize
	                );
	                pointerBox = pointerRangeBox;
	            }
	        } else {
	            trackBox = new Box(
	                scaleLine.x1, scaleLine.y1 - space,
	                scaleLine.x2, scaleLine.y1 - space);

	            if (mirror) {
	                trackBox.y2 += trackSize;
	            } else {
	                trackBox.y1 -= trackSize;
	            }

	            if (options.shape !== BAR_POINTER) {
	                pointerRangeBox = new Box(
	                    scaleLine.x1 - pointerHalfSize, scaleLine.y1 - space,
	                    scaleLine.x2 + pointerHalfSize, scaleLine.y1 - space
	                );
	                pointerBox = pointerRangeBox;
	            }
	        }

	        this.trackBox = trackBox;
	        this.pointerRangeBox = pointerRangeBox;
	        this.box = pointerBox || trackBox.clone().pad(options.border.width);
	    },

	    getElementOptions: function() {
	        var options = this.options;

	        return {
	            fill: {
	                color: options.color,
	                opacity: options.opacity
	            },
	            stroke: defined(options.border) ? {
	                color: options.border.width ? options.border.color || options.color : "",
	                width: options.border.width,
	                dashType: options.border.dashType,
	                opacity: options.opacity
	            } : null
	        };
	    },

	    _margin: function() {
	        var ref = this;
	        var scale = ref.scale;
	        var options = ref.options;
	        var ref$1 = scale.options;
	        var mirror = ref$1.mirror;
	        var vertical = ref$1.vertical;
	        var margin = getSpacing(options.margin);

	        var space = vertical ?
	            margin[mirror ? "left" : "right"] :
	            margin[mirror ? "bottom" : "top"];

	        return space;
	    }
	});

	setDefaultOptions(LinearPointer, {
	    shape: BAR_POINTER,

	    track: {
	        border: {
	            width: 1
	        }
	    },

	    color: BLACK,
	    border: {
	        width: 1
	    },
	    opacity: 1,

	    margin: getSpacing(3),
	    animation: {
	        type: BAR_POINTER
	    },
	    visible: true
	});

	var ArrowLinearPointerAnimation = Animation.extend({
	    setup: function() {
	        var options = this.options;
	        var margin = options.margin;
	        var from = options.from;
	        var to = options.to;
	        var vertical = options.vertical;
	        var axis = vertical ? "x1" : "y1";

	        if (options.mirror === vertical) {
	            from[axis] -= margin; to[axis] -= margin;
	        } else {
	            from[axis] += margin; to[axis] += margin;
	        }

	        var fromScale = this.fromScale = new GeometryPoint(from.x1, from.y1);
	        var toScale = this.toScale = new GeometryPoint(to.x1, to.y1);

	        if (options.duration !== 0) {
	            options.duration = Math.max((fromScale.distanceTo(toScale) / options.duration) * 1000, 1);
	        }
	    },

	    step: function(pos) {
	        var translateX = interpolateValue(this.fromScale.x, this.toScale.x, pos);
	        var translateY = interpolateValue(this.fromScale.y, this.toScale.y, pos);

	        this.element.transform(transform().translate(translateX, translateY));
	    }
	});

	setDefaultOptions(ArrowLinearPointerAnimation, {
	    easing: LINEAR,
	    duration: LINEAR_SPEED
	});

	AnimationFactory.current.register(ARROW_POINTER, ArrowLinearPointerAnimation);

	var Point$1 = GeometryPoint;
	var Path$3 = DrawingPath;

	var ArrowLinearPointer = LinearPointer.extend({
	    init: function(scale, options) {
	        LinearPointer.fn.init.call(this, scale, options);

	        if (!defined(this.options.size)) {
	            this.options.size = this.scale.options.majorTicks.size * 0.6;
	        }
	    },

	    pointerShape: function() {
	        var ref = this;
	        var scale = ref.scale;
	        var size = ref.options.size;
	        var halfSize = size / 2;
	        var sign = (scale.options.mirror ? -1 : 1);
	        var shape;

	        if (scale.options.vertical) {
	            shape = [
	                new Point$1(0, 0 - halfSize), new Point$1(0 - sign * size, 0), new Point$1(0, 0 + halfSize)
	            ];
	        } else {
	            shape = [
	                new Point$1(0 - halfSize, 0), new Point$1(0, 0 + sign * size), new Point$1(0 + halfSize, 0)
	            ];
	        }

	        return shape;
	    },

	    repaint: function() {
	        var ref = this;
	        var scale = ref.scale;
	        var options = ref.options;
	        var animation = new ArrowLinearPointerAnimation(this.elements, deepExtend(options.animation, {
	            vertical: scale.options.vertical,
	            mirror: scale.options.mirror,
	            margin: this._margin(options.margin),
	            from: scale.getSlot(options._oldValue),
	            to: scale.getSlot(options.value)
	        }));

	        if (options.animation.transitions === false) {
	            animation.options.duration = 0;
	        }

	        animation.setup();
	        animation.play();
	    },

	    render: function() {
	        var ref = this;
	        var scale = ref.scale;
	        var options = ref.options;
	        var elementOptions = this.getElementOptions();
	        var shape = this.pointerShape(options.value);

	        options.animation.type = ARROW_POINTER;

	        var elements = new Path$3({
	            stroke: elementOptions.stroke,
	            fill: elementOptions.fill
	        }).moveTo(shape[0]).lineTo(shape[1]).lineTo(shape[2]).close();

	        var slot = scale.getSlot(options.value);
	        elements.transform(transform().translate(slot.x1, slot.y1));

	        this.elements = elements;

	        return elements;
	    }
	});

	var BarLinearPointerAnimation = Animation.extend({
	    setup: function() {
	        var options = this.options;
	        var axis = this.axis = options.vertical ? constants.Y : constants.X;
	        var to = this.to = options.newPoints[0][axis];
	        var from = this.from = options.oldPoints[0][axis];

	        if (options.duration !== 0) {
	            options.duration = Math.max((Math.abs(to - from) / options.speed) * 1000, 1);
	        }

	        this._set(from);
	    },

	    step: function(pos) {
	        var value = interpolateValue(this.from, this.to, pos);
	        this._set(value);
	    },

	    _set: function(value) {
	        var setter = "set" + this.axis.toUpperCase();
	        var points = this.options.newPoints;

	        points[0][setter](value);
	        points[1][setter](value);
	    }
	});

	setDefaultOptions(BarLinearPointerAnimation, {
	    easing: LINEAR,
	    speed: LINEAR_SPEED
	});

	AnimationFactory.current.register(BAR_POINTER, BarLinearPointerAnimation);

	var Group$3 = DrawingGroup;
	var Path$4 = DrawingPath;

	var BarLinearPointer = LinearPointer.extend({
	    init: function(scale, options) {
	        LinearPointer.fn.init.call(this, scale, options);

	        if (!defined(this.options.size)) {
	            this.options.size = this.scale.options.majorTicks.size * 0.3;
	        }
	    },

	    pointerShape: function(value) {
	        var ref = this;
	        var scale = ref.scale;
	        var options = ref.options;
	        var ref$1 = scale.options;
	        var mirror = ref$1.mirror;
	        var vertical = ref$1.vertical;
	        var dir = mirror === vertical ? -1 : 1;
	        var size = options.size * dir;
	        var minSlot = scale.getSlot(scale.options.min);
	        var slot = scale.getSlot(value);
	        var axis = vertical ? constants.Y : constants.X;
	        var sizeAxis = vertical ? constants.X : constants.Y;
	        var margin = this._margin() * dir;

	        var p1 = new GeometryPoint();
	        p1[axis] = minSlot[axis + "1"];
	        p1[sizeAxis] = minSlot[sizeAxis + "1"];

	        var p2 = new GeometryPoint();
	        p2[axis] = slot[axis + "1"];
	        p2[sizeAxis] = slot[sizeAxis + "1"];

	        if (vertical) {
	            p1.translate(margin, 0);
	            p2.translate(margin, 0);
	        } else {
	            p1.translate(0, margin);
	            p2.translate(0, margin);
	        }

	        var p3 = p2.clone();
	        var p4 = p1.clone();

	        if (vertical) {
	            p3.translate(size, 0);
	            p4.translate(size, 0);
	        } else {
	            p3.translate(0, size);
	            p4.translate(0, size);
	        }

	        return [ p1, p2, p3, p4 ];
	    },

	    repaint: function() {
	        var ref = this;
	        var scale = ref.scale;
	        var options = ref.options;
	        var shape = this.pointerShape(options.value);
	        var pointerPath = this.pointerPath;
	        var oldShape = this.pointerShape(options._oldValue);

	        pointerPath.moveTo(shape[0]).lineTo(shape[1]).lineTo(shape[2]).lineTo(shape[3]).close();

	        var animation = new BarLinearPointerAnimation(pointerPath, deepExtend(options.animation, {
	            reverse: scale.options.reverse,
	            vertical: scale.options.vertical,
	            oldPoints: [ oldShape[1], oldShape[2] ],
	            newPoints: [ shape[1], shape[2] ]
	        }));

	        if (options.animation.transitions === false) {
	            animation.options.duration = 0;
	        }

	        animation.setup();
	        animation.play();
	    },

	    render: function() {
	        var group = new Group$3();
	        var elementOptions = this.getElementOptions();

	        if (this.options.track.visible) {
	            group.append(this.renderTrack());
	        }

	        var pointer = this.pointerPath = new Path$4({
	            stroke: elementOptions.stroke,
	            fill: elementOptions.fill
	        });

	        group.append(pointer);

	        this.elements = group;

	        return group;
	    },

	    renderTrack: function() {
	        var trackOptions = this.options.track;
	        var border = trackOptions.border || {};
	        var trackBox = this.trackBox.clone().pad(border.width || 0);

	        return new Path$4.fromRect(trackBox.toRect(), {
	            fill: {
	                color: trackOptions.color,
	                opacity: trackOptions.opacity
	            },
	            stroke: {
	                color: border.width ? border.color || trackOptions.color : "",
	                width: border.width,
	                dashType: border.dashType
	            }
	        });
	    }
	});

	var DEFAULT_MIN_WIDTH = 60;
	var DEFAULT_MIN_HEIGHT = 60;

	var Group$1 = DrawingGroup;

	var LinearGauge = Gauge.extend({
	    reflow: function(bbox) {
	        var pointers = this.pointers;
	        var bboxX = bbox.origin.x;
	        var bboxY = bbox.origin.y;

	        var box = new Box(bboxX, bboxY, bboxX + bbox.width(), bboxY + bbox.height());

	        this.scale.reflow(box);
	        this._shrinkScaleWidth(box);

	        for (var i = 0; i < pointers.length; i++) {
	            pointers[i].reflow();
	        }

	        this.bbox = this._getBox(box);
	        this._alignElements();
	        this._shrinkElements();
	        this._buildVisual();
	        this._draw();
	    },

	    _buildVisual: function() {
	        var visuals = new Group$1();
	        var scaleElements = this.scale.render();
	        var pointers = this.pointers;

	        visuals.append(this.gaugeArea);
	        visuals.append(scaleElements);

	        for (var i = 0; i < pointers.length; i++) {
	            var current = pointers[i];
	            visuals.append(current.render());
	            current.value(current.options.value);
	        }

	        this._visuals = visuals;
	    },

	    _createModel: function() {
	        var this$1 = this;

	        var options = this.options;
	        var scale = this.scale = new LinearScale(options.scale, this.contextService);

	        this.pointers = [];

	        var pointers = options.pointer;
	        pointers = isArray(pointers) ? pointers : [ pointers ];

	        for (var i = 0; i < pointers.length; i++) {
	            var currentOptions = deepExtend({}, pointers[i], {
	                animation: {
	                    transitions: options.transitions
	                }
	            });
	            var pointerType = currentOptions.shape === ARROW ? ArrowLinearPointer : BarLinearPointer;

	            this$1.pointers.push(new pointerType(scale, currentOptions));
	        }
	    },

	    _defaultSize: function() {
	        var vertical = this.options.scale.vertical;

	        return {
	            width: vertical ? DEFAULT_MIN_WIDTH : DEFAULT_WIDTH,
	            height: vertical ? DEFAULT_HEIGHT : DEFAULT_MIN_HEIGHT
	        };
	    },

	    _getBox: function(box) {
	        var ref = this;
	        var scale = ref.scale;
	        var pointers = ref.pointers;
	        var boxCenter = box.center();
	        var plotAreaBox = pointers[0].box.clone().wrap(scale.box);

	        for (var i = 0; i < pointers.length; i++) {
	            plotAreaBox.wrap(pointers[i].box.clone());
	        }

	        var size;
	        if (scale.options.vertical) {
	            size = plotAreaBox.width() / 2;
	            plotAreaBox = new Box(
	                boxCenter.x - size, box.y1,
	                boxCenter.x + size, box.y2
	            );
	        } else {
	            size = plotAreaBox.height() / 2;
	            plotAreaBox = new Box(
	                box.x1, boxCenter.y - size,
	                box.x2, boxCenter.y + size
	            );
	        }

	        return plotAreaBox;
	    },

	    _alignElements: function() {
	        var this$1 = this;

	        var ref = this;
	        var scale = ref.scale;
	        var pointers = ref.pointers;
	        var scaleBox = scale.box;
	        var box = pointers[0].box.clone().wrap(scale.box);
	        var plotAreaBox = this.bbox;

	        for (var i = 0; i < pointers.length; i++) {
	            box.wrap(pointers[i].box.clone());
	        }

	        var diff;
	        if (scale.options.vertical) {
	            diff = plotAreaBox.center().x - box.center().x;
	            scale.reflow(new Box(
	                scaleBox.x1 + diff, plotAreaBox.y1,
	                scaleBox.x2 + diff, plotAreaBox.y2
	            ));
	        } else {
	            diff = plotAreaBox.center().y - box.center().y;
	            scale.reflow(new Box(
	                scaleBox.x1, scaleBox.y1 + diff,
	                scaleBox.x2, scaleBox.y2 + diff
	            ));
	        }

	        for (var i$1 = 0; i$1 < pointers.length; i$1++) {
	            pointers[i$1].reflow(this$1.bbox);
	        }
	    },

	    _shrinkScaleWidth: function(bbox) {
	        var ref = this;
	        var scale = ref.scale;
	        if (!scale.options.vertical) {
	            var overflow = scale.contentBox().width() - bbox.width();
	            if (overflow > 0) {
	                scale.box.shrink(overflow, 0);
	                scale.box.alignTo(bbox, 'center');
	                scale.reflow(scale.box);
	            }
	        }
	    },

	    _shrinkElements: function() {
	        var this$1 = this;

	        var ref = this;
	        var scale = ref.scale;
	        var pointers = ref.pointers;
	        var scaleBox = scale.box.clone();
	        var pos = scale.options.vertical ? "y" : "x";
	        var pointerBox = pointers[0].box;

	        for (var i = 0; i < pointers.length; i++) {
	            pointerBox.wrap(pointers[i].box.clone());
	        }

	        scaleBox[pos + 1] += Math.max(scaleBox[pos + 1] - pointerBox[pos + 1], 0);
	        scaleBox[pos + 2] -= Math.max(pointerBox[pos + 2] - scaleBox[pos + 2], 0);

	        scale.reflow(scaleBox);

	        for (var i$1 = 0; i$1 < pointers.length; i$1++) {
	            pointers[i$1].reflow(this$1.bbox);
	        }
	    }
	});

	setDefaultOptions(LinearGauge, {
	    transitions: true,
	    gaugeArea: {
	        background: ""
	    },
	    scale: {
	        vertical: true
	    }
	});

	var GEO_ARC_ADJUST_ANGLE = 180;

	var Arc = drawing.Arc;
	var Path$5 = DrawingPath;
	var Group$5 = DrawingGroup;

	function drawTicks(arc, tickAngles, unit, tickOptions) {
	    var ticks = new Group$5();
	    var center = arc.center;
	    var radius = arc.getRadiusX();

	    if (tickOptions.visible) {
	        for (var i = 0; i < tickAngles.length; i++) {
	            var tickStart = arc.pointAt(tickAngles[i]);
	            var tickEnd = new GeometryPoint(center.x + radius - tickOptions.size, center.y).rotate(tickAngles[i], center);

	            ticks.append(new Path$5({
	                stroke: {
	                    color: tickOptions.color,
	                    width: tickOptions.width
	                }
	            }).moveTo(tickStart).lineTo(tickEnd));
	        }
	    }

	    return ticks;
	}

	function rangeSegment(from, to, color, opacity) {
	    return { from: from, to: to, color: color, opacity: opacity };
	}

	var RadialScale = NumericAxis.extend({
	    init: function(options, service) {
	        NumericAxis.fn.init.call(this, 0, 1, options, service);
	    },

	    initUserOptions: function(options) {
	        var scaleOptions = deepExtend({}, this.options, options);
	        scaleOptions.majorUnit = scaleOptions.majorUnit || dataviz.autoMajorUnit(scaleOptions.min, scaleOptions.max);
	        scaleOptions.minorUnit = scaleOptions.minorUnit || scaleOptions.majorUnit / 10;

	        return scaleOptions;
	    },

	    initFields: function() {
	    },

	    render: function(center, radius) {
	        var arc = this.renderArc(center, radius);

	        this.bbox = arc.bbox();
	        this.labelElements = this.renderLabels();
	        this.ticks = this.renderTicks();
	        this.ranges = this.renderRanges();
	    },

	    reflow: function(bbox) {
	        var center = bbox.center();
	        var radius = Math.min(bbox.height(), bbox.width()) / 2;

	        if (defined(this.bbox)) {
	            this.bbox = this.arc.bbox();
	            this.radius(this.arc.getRadiusX());
	            this.repositionRanges();
	            this.renderLabels();
	        } else {
	            return this.render(center, radius);
	        }
	    },

	    slotAngle: function(value) {
	        var ref = this.options;
	        var min = ref.min;
	        var max = ref.max;
	        var reverse = ref.reverse;
	        var startAngle = ref.startAngle;
	        var endAngle = ref.endAngle;
	        var angle = endAngle - startAngle;
	        var result;

	        if (reverse) {
	            result = endAngle - (value - min) / (max - min) * angle;
	        } else {
	            result = ((value - min) / (max - min) * angle) + startAngle;
	        }

	        return result + GEO_ARC_ADJUST_ANGLE;
	    },

	    hasRanges: function() {
	        var ranges = this.options.ranges;

	        return ranges && ranges.length;
	    },

	    ticksSize: function() {
	        var ref = this.options;
	        var majorTicks = ref.majorTicks;
	        var minorTicks = ref.minorTicks;
	        var size = 0;
	        if (majorTicks.visible) {
	            size = majorTicks.size;
	        }

	        if (minorTicks.visible) {
	            size = Math.max(minorTicks.size, size);
	        }

	        return size;
	    },

	    renderLabels: function() {
	        var this$1 = this;

	        var options = this.options;
	        var arc = this.arc.clone();
	        var radius = arc.getRadiusX();
	        var tickAngles = this.tickAngles(arc, options.majorUnit);
	        var rangeSize = options.rangeSize = options.rangeSize || radius * 0.1;
	        var labelsGroup = new Group$5();

	        var rangeDistance = radius * 0.05;
	        if (defined(options.rangeDistance)) {
	            rangeDistance = options.rangeDistance;
	        } else {
	            options.rangeDistance = rangeDistance;
	        }

	        var labelsOptions = options.labels;
	        var isInside = labelsOptions.position === INSIDE;
	        var hasLabelElements = defined(this.labelElements);

	        if (isInside) {
	            radius -= this.ticksSize();

	            if (this.hasRanges() && !hasLabelElements) {
	                radius -= rangeSize + rangeDistance;
	            }
	            arc.setRadiusX(radius).setRadiusY(radius);
	        }

	        var labels = this.labels;
	        var count = labels.length;
	        var padding = labelsOptions.padding;

	        for (var i = 0; i < count; i++) {
	            var label = labels[i];
	            var halfWidth = label.box.width() / 2;
	            var halfHeight = label.box.height() / 2;
	            var angle = tickAngles[i];
	            var labelAngle = (angle - GEO_ARC_ADJUST_ANGLE) * DEGREE;

	            var lp = arc.pointAt(angle);
	            var cx = lp.x + (Math.cos(labelAngle) * (halfWidth + padding) * (isInside ? 1 : -1));
	            var cy = lp.y + (Math.sin(labelAngle) * (halfHeight + padding) * (isInside ? 1 : -1));

	            label.reflow(new Box(cx - halfWidth, cy - halfHeight, cx + halfWidth, cy + halfHeight));
	            var labelPos = new GeometryPoint(label.box.x1, label.box.y1);

	            var labelElement = (void 0);
	            if (!hasLabelElements) {
	                labelElement = buildLabelElement(label, options.labels);
	                labelsGroup.append(labelElement);
	            } else {
	                labelElement = this$1.labelElements.children[i];
	                var prevLabelPos = labelElement.bbox().origin;

	                var labelTransform = labelElement.transform() || transform();
	                labelTransform.translate(labelPos.x - prevLabelPos.x, labelPos.y - prevLabelPos.y);
	                labelElement.transform(labelTransform);
	            }

	            this$1.bbox = Rect.union(this$1.bbox, labelElement.bbox());
	        }

	        return labelsGroup;
	    },

	    repositionRanges: function() {
	        var ranges = this.ranges.children;

	        if (ranges.length > 0) {
	            var ref = this.options;
	            var rangeDistance = ref.rangeDistance;
	            var rangeSize = ref.rangeSize;
	            var rangeRadius = this.getRangeRadius();

	            if (this.options.labels.position === INSIDE) {
	                rangeRadius += rangeSize + rangeDistance;
	            }

	            var newRadius = rangeRadius + (rangeSize / 2);

	            for (var i = 0; i < ranges.length; i++) {
	                ranges[i]._geometry.setRadiusX(newRadius).setRadiusY(newRadius);
	            }

	            this.bbox = Rect.union(this.bbox, this.ranges.bbox());
	        }
	    },

	    renderRanges: function() {
	        var this$1 = this;

	        var segments = this.rangeSegments();
	        var segmentsCount = segments.length;
	        var result = new Group$5();

	        if (segmentsCount) {
	            var ref = this.options;
	            var rangeSize = ref.rangeSize;
	            var reverse = ref.reverse;
	            var rangeDistance = ref.rangeDistance;
	            var rangeRadius = this.getRangeRadius();

	            // move the ticks with a range distance and a range size
	            this.radius(this.radius() - rangeSize - rangeDistance);

	            for (var i = 0; i < segmentsCount; i++) {
	                var segment = segments[i];
	                var from = this$1.slotAngle(segment[reverse ? "to" : "from"]);
	                var to = this$1.slotAngle(segment[!reverse ? "to" : "from"]);

	                if (to - from !== 0) {
	                    result.append(this$1.createRange(from, to, rangeRadius, segment));
	                }
	            }
	        }

	        return result;
	    },

	    createRange: function(startAngle, endAngle, rangeRadius, options) {
	        var rangeSize = this.options.rangeSize;
	        var rangeGeom = new geometry.Arc(this.arc.center, {
	            radiusX: rangeRadius + (rangeSize / 2),
	            radiusY: rangeRadius + (rangeSize / 2),
	            startAngle: startAngle,
	            endAngle: endAngle
	        });

	        return new Arc(rangeGeom, {
	            stroke: {
	                width: rangeSize,
	                color: options.color,
	                opacity: options.opacity,
	                lineCap: options.lineCap
	            }
	        });
	    },

	    rangeSegments: function() {
	        var options = this.options;
	        var ranges = options.ranges || [];
	        var count = ranges.length;
	        var segments = [];

	        if (count) {
	            var min = options.min;
	            var max = options.max;
	            var defaultColor = options.rangePlaceholderColor;
	            segments.push(rangeSegment(min, max, defaultColor));

	            for (var i = 0; i < count; i++) {
	                var range = getRange(ranges[i], min, max);
	                var segmentsCount = segments.length;

	                for (var j = 0; j < segmentsCount; j++) {
	                    var segment = segments[j];

	                    if (segment.from <= range.from && range.from <= segment.to) {
	                        segments.push(rangeSegment(range.from, range.to, range.color, range.opacity));

	                        if (segment.from <= range.to && range.to <= segment.to) {
	                            segments.push(rangeSegment(range.to, segment.to, defaultColor, range.opacity));
	                        }

	                        segment.to = range.from;

	                        break;
	                    }
	                }
	            }
	        }

	        return segments;
	    },

	    getRangeRadius: function() {
	        var ref = this;
	        var arc = ref.arc;
	        var options = ref.options;
	        var rangeSize = options.rangeSize;
	        var rangeDistance = options.rangeDistance;
	        var majorTickSize = options.majorTicks.size;
	        var radius;

	        if (options.labels.position === OUTSIDE) {
	            radius = arc.getRadiusX() - majorTickSize - rangeDistance - rangeSize;
	        } else {
	            radius = arc.getRadiusX() - rangeSize;
	        }

	        return radius;
	    },

	    renderArc: function(center, radius) {
	        var options = this.options;

	        var arc = this.arc = new geometry.Arc(center, {
	            radiusX: radius,
	            radiusY: radius,
	            startAngle: options.startAngle + GEO_ARC_ADJUST_ANGLE,
	            endAngle: options.endAngle + GEO_ARC_ADJUST_ANGLE
	        });

	        return arc;
	    },

	    renderTicks: function() {
	        var ref = this;
	        var arc = ref.arc;
	        var options = ref.options;
	        var tickArc = arc.clone();

	        this.majorTickAngles = this.tickAngles(arc, options.majorUnit);
	        this.majorTicks = drawTicks(tickArc, this.majorTickAngles, options.majorUnit, options.majorTicks);

	        var allTicks = new Group$5();
	        allTicks.append(this.majorTicks);

	        var majorTickSize = options.majorTicks.size;
	        var minorTickSize = options.minorTicks.size;

	        this._tickDifference = majorTickSize - minorTickSize;

	        if (options.labels.position === OUTSIDE) {
	            var radius = tickArc.getRadiusX();
	            tickArc.setRadiusX(radius - majorTickSize + minorTickSize)
	                   .setRadiusY(radius - majorTickSize + minorTickSize);
	        }

	        this.minorTickAngles = this.normalizeTickAngles(this.tickAngles(arc, options.minorUnit));
	        this.minorTicks = drawTicks(tickArc, this.minorTickAngles, options.minorUnit, options.minorTicks);
	        allTicks.append(this.minorTicks);

	        return allTicks;
	    },

	    normalizeTickAngles: function(angles) {
	        var options = this.options;
	        var skip = options.majorUnit / options.minorUnit;

	        for (var i = angles.length - 1; i >= 0; i--) {
	            if (i % skip === 0) {
	                angles.splice(i, 1);
	            }
	        }

	        return angles;
	    },

	    tickAngles: function(ring, stepValue) {
	        var options = this.options;
	        var reverse = options.reverse;
	        var range = options.max - options.min;
	        var angle = ring.endAngle - ring.startAngle;
	        var tickCount = range / stepValue;
	        var pos = ring.startAngle;
	        var step = angle / tickCount;

	        if (reverse) {
	            pos += angle;
	            step = -step;
	        }

	        var positions = [];
	        for (var i = 0; i < tickCount; i++) {
	            positions.push(round(pos, COORD_PRECISION));
	            pos += step;
	        }

	        if (round(pos) <= ring.endAngle) {
	            positions.push(pos);
	        }

	        return positions;
	    },

	    radius: function(value) {
	        if (value) {
	            this.arc.setRadiusX(value).setRadiusY(value);
	            this.repositionTicks(this.majorTicks.children, this.majorTickAngles);
	            this.repositionTicks(this.minorTicks.children, this.minorTickAngles, true);
	        } else {
	            return this.arc.getRadiusX();
	        }
	    },

	    repositionTicks: function(ticks, tickAngles, minor) {
	        var diff = minor ? (this._tickDifference || 0) : 0;
	        var tickArc = this.arc;
	        var radius = tickArc.getRadiusX();

	        if (minor && this.options.labels.position === OUTSIDE && diff !== 0) {
	            tickArc = this.arc.clone();
	            tickArc.setRadiusX(radius - diff).setRadiusY(radius - diff);
	        }

	        for (var i = 0; i < ticks.length; i++) {
	            var newPoint = tickArc.pointAt(tickAngles[i]);
	            var segments = ticks[i].segments;
	            var xDiff = newPoint.x - segments[0].anchor().x;
	            var yDiff = newPoint.y - segments[0].anchor().y;

	            ticks[i].transform(new transform().translate(xDiff, yDiff));
	        }
	    }
	});

	setDefaultOptions(RadialScale, {
	    min: 0,
	    max: 100,

	    majorTicks: {
	        size: 15,
	        align: INSIDE,
	        color: BLACK,
	        width: DEFAULT_LINE_WIDTH,
	        visible: true
	    },

	    minorTicks: {
	        size: 10,
	        align: INSIDE,
	        color: BLACK,
	        width: DEFAULT_LINE_WIDTH,
	        visible: true
	    },

	    startAngle: -30,
	    endAngle: 210,

	    labels: {
	        position: INSIDE,
	        padding: 2
	    }
	});

	var RadialPointerAnimation = Animation.extend({
	    init: function(element, options) {
	        Animation.fn.init.call(this, element, options);

	        var animationOptions = this.options;

	        animationOptions.duration = Math.max((Math.abs(animationOptions.newAngle - animationOptions.oldAngle) / animationOptions.duration) * 1000, 1);
	    },

	    step: function(pos) {
	        var options = this.options;
	        var angle = interpolateValue(options.oldAngle, options.newAngle, pos);

	        this.element.transform(transform().rotate(angle, options.center));
	    }
	});

	setDefaultOptions(RadialPointerAnimation, {
	    easing: LINEAR,
	    duration: ANGULAR_SPEED
	});

	AnimationFactory.current.register(RADIAL_POINTER, RadialPointerAnimation);

	var CAP_SIZE = 0.05;
	var Circle = drawing.Circle;
	var Group$6 = DrawingGroup;
	var Path$6 = DrawingPath;

	var RadialPointer = Pointer.extend({
	    setAngle: function(angle) {
	        this.elements.transform(transform().rotate(angle, this.center));
	    },

	    repaint: function() {
	        var ref = this;
	        var scale = ref.scale;
	        var options = ref.options;
	        var oldAngle = scale.slotAngle(options._oldValue);
	        var newAngle = scale.slotAngle(options.value);

	        if (options.animation.transitions === false) {
	            this.setAngle(newAngle);
	        } else {
	            new RadialPointerAnimation(this.elements, deepExtend(options.animation, {
	                oldAngle: oldAngle,
	                newAngle: newAngle
	            })).play();
	        }
	    },

	    render: function() {
	        var ref = this;
	        var scale = ref.scale;
	        var options = ref.options;
	        var elements = new Group$6();

	        if (options.animation !== false) {
	            deepExtend(options.animation, {
	                startAngle: 0,
	                center: scale.arc.center,
	                reverse: scale.options.reverse
	            });
	        }

	        elements.append(this._renderNeedle(), this._renderCap());

	        this.elements = elements;
	        this.setAngle(DEGREE);

	        return elements;
	    },

	    reflow: function(arc) {
	        var center = this.center = arc.center;
	        var length = limitValue(this.options.length || 1, 0.1, 1.5);
	        var radius = this.radius = arc.getRadiusX() * length;
	        var capSize = this.capSize = Math.round(radius * this.options.cap.size);

	        this.bbox = Rect.fromPoints(new GeometryPoint(center.x - capSize, center.y - capSize),
	                                    new GeometryPoint(center.x + capSize, center.y + capSize));
	    },

	    _renderNeedle: function() {
	        var minorTickSize = this.scale.options.minorTicks.size;
	        var center = this.center;
	        var needleColor = this.options.color;

	        var needlePath = new Path$6({
	            fill: { color: needleColor },
	            stroke: { color: needleColor, width: DEFAULT_LINE_WIDTH }
	        });

	        needlePath.moveTo(center.x + this.radius - minorTickSize, center.y)
	                  .lineTo(center.x, center.y - (this.capSize / 2))
	                  .lineTo(center.x, center.y + (this.capSize / 2))
	                  .close();

	        return needlePath;
	    },

	    _renderCap: function() {
	        var options = this.options;
	        var capColor = options.cap.color || options.color;
	        var circle = new geometry.Circle(this.center, this.capSize);

	        var cap = new Circle(circle, {
	            fill: { color: capColor },
	            stroke: { color: capColor }
	        });

	        return cap;
	    }
	});

	setDefaultOptions(RadialPointer, {
	    cap: {
	        size: CAP_SIZE
	    },
	    arrow: {
	        width: 16,
	        height: 14
	    },
	    animation: {
	        type: RADIAL_POINTER,
	        duration: ANGULAR_SPEED
	    }
	});

	var Group$4 = DrawingGroup;

	var RadialGauge = Gauge.extend({
	    reflow: function(bbox) {
	        var this$1 = this;

	        var pointers = this.pointers;
	        this.scale.reflow(bbox);
	        this._initialPlotArea = this.scale.bbox;

	        for (var i = 0; i < pointers.length; i++) {
	            pointers[i].reflow(this$1.scale.arc);
	            this$1._initialPlotArea = Rect.union(this$1._initialPlotArea, pointers[i].bbox);
	        }

	        this.fitScale(bbox);
	        this.alignScale(bbox);
	        this._buildVisual(this.gaugeArea, pointers, this.scale);
	        this._draw();
	    },

	    _buildVisual: function(gaugeArea, pointers, scale) {
	        var visuals = this._visuals = new Group$4();

	        visuals.append(gaugeArea);
	        visuals.append(scale.ticks);
	        visuals.append(scale.ranges);
	        this._buildPointers(pointers);
	        visuals.append(scale.labelElements);
	    },

	    _buildPointers: function(pointers) {
	        var this$1 = this;

	        for (var i = 0; i < pointers.length; i++) {
	            var current = pointers[i];
	            current.render();
	            this$1._visuals.append(current.elements);

	            current.value(current.options.value);
	        }
	    },

	    fitScale: function(bbox) {
	        var this$1 = this;

	        var arc = this.scale.arc;
	        var plotAreaBox = this._initialPlotArea;
	        var step = Math.abs(this.getDiff(plotAreaBox, bbox));
	        var min = round(step, COORD_PRECISION);
	        var max = round(-step, COORD_PRECISION);
	        var minDiff, midDiff, maxDiff, mid, oldDiff;
	        var staleFlag = 0;
	        var i = 0;

	        while (i++ < 100) {
	            staleFlag = (oldDiff === maxDiff) ? (staleFlag + 1) : 0;

	            if (staleFlag > 5) {
	                break;
	            }

	            if (min !== mid) {
	                minDiff = this$1.getPlotBox(min, bbox, arc);
	                if (0 <= minDiff && minDiff <= 2) {
	                    break;
	                }
	            }

	            if (max !== mid) {
	                maxDiff = this$1.getPlotBox(max, bbox, arc);
	                if (0 <= maxDiff && maxDiff <= 2) {
	                    break;
	                }
	            }

	            if (minDiff > 0 && maxDiff > 0) {
	                mid = min * 2;
	            } else if (minDiff < 0 && maxDiff < 0) {
	                mid = max * 2;
	            } else {
	                mid = round(((min + max) / 2) || 1, COORD_PRECISION);
	            }

	            midDiff = this$1.getPlotBox(mid, bbox, arc);
	            if (0 <= midDiff && midDiff <= 2) {
	                break;
	            }

	            oldDiff = maxDiff;

	            if (midDiff > 0) {
	                max = mid;
	                maxDiff = midDiff;
	            } else {
	                min = mid;
	                minDiff = midDiff;
	            }
	        }
	    },

	    getPlotBox: function(step, bbox, arc) {
	        var this$1 = this;

	        var scale = this.scale;
	        var pointers = this.pointers;
	        var radius = arc.getRadiusX();
	        var scaleArc = arc.clone();

	        scaleArc.setRadiusX(radius + step).setRadiusY(radius + step);

	        scale.arc = scaleArc;
	        scale.reflow(bbox);
	        this.plotBbox = scale.bbox;

	        for (var i = 0; i < pointers.length; i++) {
	            pointers[i].reflow(scaleArc);
	            this$1.plotBbox = Rect.union(this$1.plotBbox, pointers[i].bbox);
	        }

	        return this.getDiff(this.plotBbox, bbox);
	    },

	    getDiff: function(plotBox, box) {
	        return Math.min(box.width() - plotBox.width(), box.height() - plotBox.height());
	    },

	    alignScale: function(bbox) {
	        var this$1 = this;

	        var plotBoxCenter = this.plotBbox.center();
	        var boxCenter = bbox.center();
	        var paddingX = plotBoxCenter.x - boxCenter.x;
	        var paddingY = plotBoxCenter.y - boxCenter.y;
	        var ref = this;
	        var scale = ref.scale;
	        var pointers = ref.pointers;

	        scale.arc.center.x -= paddingX;
	        scale.arc.center.y -= paddingY;

	        scale.reflow(bbox);

	        for (var i = 0; i < pointers.length; i++) {
	            pointers[i].reflow(scale.arc);
	            this$1.plotBbox = Rect.union(scale.bbox, pointers[i].bbox);
	        }
	    },

	    _createModel: function() {
	        var this$1 = this;

	        var options = this.options;
	        var pointers = options.pointer;
	        var scale = this.scale = new RadialScale(options.scale, this.contextService);

	        this.pointers = [];

	        var pointersArr = isArray(pointers) ? pointers : [ pointers ];
	        for (var i = 0; i < pointersArr.length; i++) {
	            var current = new RadialPointer(scale, deepExtend({}, pointersArr[i], {
	                animation: {
	                    transitions: options.transitions
	                }
	            }));

	            this$1.pointers.push(current);
	        }
	    }
	});

	setDefaultOptions(RadialGauge, {
	    transitions: true,
	    gaugeArea: {
	        background: ""
	    }
	});

	var ArcScale = RadialScale.extend({
	    rangeSegments: function() {
	        var ref = this.options;
	        var min = ref.min;
	        var max = ref.max;
	        var rangePlaceholderColor = ref.rangePlaceholderColor;
	        var rangeLineCap = ref.rangeLineCap;

	        return [ { from: min, to: max, color: rangePlaceholderColor, lineCap: rangeLineCap } ];
	    },

	    hasRanges: function() {
	        return true;
	    },

	    placeholderRangeAngle: function(angle) {
	        var geometry$$1 = this.ranges.children[0].geometry();

	        if (this.options.reverse) {
	            geometry$$1.setEndAngle(angle);
	        } else {
	            geometry$$1.setStartAngle(angle);
	        }
	    },

	    addRange: function(from, to, options) {
	        var reverse = this.options.reverse;

	        var startAngle = this.slotAngle(reverse ? to : from);
	        var endAngle = this.slotAngle(reverse ? from : to);

	        var range = this.createRange(startAngle, endAngle, this.getRangeRadius(), options);

	        this.ranges.append(range);

	        return range;
	    }
	});

	setDefaultOptions(ArcScale, {
	    min: 0,
	    max: 100,

	    majorTicks: {
	        visible: false
	    },

	    minorTicks: {
	        visible: false
	    },

	    labels: {
	        visible: false
	    },

	    startAngle: 0,
	    endAngle: 180,
	    rangeLineCap: 'round'
	});

	var MAX_DURATION = 800;

	var RangePointerAnimation = Animation.extend({
	    init: function(element, options) {
	        Animation.fn.init.call(this, element, options);

	        var animationOptions = this.options;
	        var duration = (Math.abs(animationOptions.newAngle - animationOptions.oldAngle) / animationOptions.duration) * 1000;
	        animationOptions.duration = limitValue(duration, ANGULAR_SPEED, MAX_DURATION);

	        var startColor = element.elements.options.get("stroke.color");
	        var color = element.currentColor();
	        if (startColor !== color) {
	            this.startColor = new kendo.Color(startColor);
	            this.color = new kendo.Color(color);
	        }
	    },

	    step: function(pos) {
	        var ref = this;
	        var options = ref.options;
	        var startColor = ref.startColor;
	        var color = ref.color;
	        var angle = interpolateValue(options.oldAngle, options.newAngle, pos);
	        this.element.angle(angle);

	        if (color) {
	            var r = round(interpolateValue(startColor.r, color.r, pos));
	            var g = round(interpolateValue(startColor.g, color.g, pos));
	            var b = round(interpolateValue(startColor.b, color.b, pos));

	            this.element.stroke(new kendo.Color(r, g, b).toHex());
	        }
	    }
	});

	setDefaultOptions(RangePointerAnimation, {
	    easing: LINEAR,
	    duration: ANGULAR_SPEED
	});

	AnimationFactory.current.register(RADIAL_RANGE_POINTER, RangePointerAnimation);

	var RangePointer = Pointer.extend({
	    repaint: function() {
	        var ref = this;
	        var scale = ref.scale;
	        var options = ref.options;
	        var oldAngle = scale.slotAngle(options._oldValue);
	        var newAngle = scale.slotAngle(options.value);

	        if (this.animation) {
	            this.animation.abort();
	        }

	        if (options.animation.transitions === false) {
	            this.angle(newAngle);
	            this.stroke(this.currentColor());
	        } else {
	            this.animation = new RangePointerAnimation(this, deepExtend(options.animation, {
	                oldAngle: oldAngle,
	                newAngle: newAngle
	            }));

	            this.animation.play();
	        }
	    },

	    angle: function(value) {
	        var geometry$$1 = this.elements.geometry();
	        if (this.scale.options.reverse) {
	            geometry$$1.setStartAngle(value);
	        } else {
	            geometry$$1.setEndAngle(value);
	        }
	        this.scale.placeholderRangeAngle(value);
	    },

	    stroke: function(value) {
	        this.elements.stroke(value);
	    },

	    render: function() {
	        if (this.elements) {
	            return;
	        }

	        var ref = this;
	        var scale = ref.scale;
	        var options = ref.options;

	        if (options.animation !== false) {
	            deepExtend(options.animation, {
	                startAngle: 0,
	                center: scale.arc.center,
	                reverse: scale.options.reverse
	            });
	        }

	        this.elements = scale.addRange(scale.options.min, this.options.value, {
	            color: this.currentColor(),
	            opacity: options.opacity,
	            lineCap: scale.options.rangeLineCap
	        });
	    },

	    currentColor: function() {
	        var ref = this.scale.options;
	        var min = ref.min;
	        var max = ref.max;
	        var ref$1 = this.options;
	        var colors = ref$1.colors;
	        var color = ref$1.color;
	        var value = ref$1.value;
	        var currentValue = dataviz.isNumber(value) ? value : min;

	        if (colors) {
	            for (var idx = 0; idx < colors.length; idx++) {
	                var ref$2 = colors[idx];
	                var rangeColor = ref$2.color;
	                var from = ref$2.from; if (from === void 0) { from = min; }
	                var to = ref$2.to; if (to === void 0) { to = max; }

	                if (from <= currentValue && currentValue <= to) {
	                    return rangeColor;
	                }
	            }
	        }

	        return color;
	    },

	    reflow: function() {
	        this.render();

	        this.bbox = this.elements.bbox();
	    }
	});

	setDefaultOptions(RangePointer, {
	    animation: {
	        type: RADIAL_RANGE_POINTER,
	        duration: ANGULAR_SPEED
	    }
	});

	var ArcGauge = RadialGauge.extend({
	    _initTheme: function(theme) {
	        RadialGauge.fn._initTheme.call(this, theme);

	        this.options.color = this.options.color || (this.theme.pointer || {}).color;
	    },

	    _createModel: function() {
	        var options = this.options;
	        var scale = this.scale = new ArcScale(options.scale, this.contextService);

	        var pointer = new RangePointer(scale, deepExtend({}, {
	            colors: options.colors,
	            color: options.color,
	            value: options.value,
	            opacity: options.opacity,
	            animation: {
	                transitions: options.transitions
	            }
	        }));

	        this.pointers = [ pointer ];
	    },

	    _buildPointers: function(pointers) {
	        for (var i = 0; i < pointers.length; i++) {
	            var current = pointers[i];
	            current.render();

	            current.value(current.options.value);
	        }
	    },

	    _setValueOptions: function(value) {
	        this.options.value = value;
	    },

	    currentColor: function() {
	        var pointer = this.pointers[0];
	        if (pointer) {
	            return pointer.currentColor();
	        }
	    },

	    centerLabelPosition: function(width, height) {
	        var size = this.getSize();
	        var center = this.scale.arc.center;

	        var left = center.x - width / 2;
	        var top = center.y - height / 2;

	        if (width < size.width) {
	            var right = left + width;

	            left = Math.max(left, 0);

	            if (right > size.width) {
	                left -= right - size.width;
	            }
	        }

	        if (height < size.height) {
	            var bbox = this.scale.bbox;
	            var yLimit = bbox.bottomRight().y;
	            var bottom = top + height;

	            top = Math.max(top, bbox.origin.y);

	            if (bottom > yLimit) {
	                top -= bottom - yLimit;
	            }
	        }

	        return {
	            left: left,
	            top: top
	        };
	    }
	});

	kendo.deepExtend(kendo.dataviz, {
	    Gauge: Gauge,
	    LinearGauge: LinearGauge,
	    LinearPointer: LinearPointer,
	    ArrowLinearPointer: ArrowLinearPointer,
	    BarLinearPointer: BarLinearPointer,
	    LinearScale: LinearScale,
	    RadialGauge: RadialGauge,
	    RadialPointer: RadialPointer,
	    RadialScale: RadialScale,
	    ArcGauge: ArcGauge,
	    RangePointer: RangePointer,
	    ArcScale: ArcScale
	});

	})(window.kendo.jQuery);

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "apSr":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1292);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1292:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1086), __webpack_require__(1059) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "menu",
	    name: "Menu",
	    category: "web",
	    description: "The Menu widget displays hierarchical data as a multi-level menu.",
	    depends: [ "popup", "data", "data.odata" ]
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        activeElement = kendo._activeElement,
	        touch = (kendo.support.touch && kendo.support.mobileOS),
	        isArray = $.isArray,
	        HierarchicalDataSource = kendo.data.HierarchicalDataSource,
	        MOUSEDOWN = "mousedown",
	        CLICK = "click",
	        DELAY = 30,
	        SCROLLSPEED = 50,
	        extend = $.extend,
	        proxy = $.proxy,
	        each = $.each,
	        template = kendo.template,
	        keys = kendo.keys,
	        Widget = ui.Widget,
	        excludedNodesRegExp = /^(ul|a|div)$/i,
	        NS = ".kendoMenu",
	        IMG = "img",
	        OPEN = "open",
	        MENU = "k-menu",
	        LINK = "k-link k-menu-link",
	        LINK_SELECTOR = ".k-link",
	        ICON_SELECTOR = ".k-menu-expand-arrow",
	        LAST = "k-last",
	        CLOSE = "close",
	        TIMER = "timer",
	        FIRST = "k-first",
	        IMAGE = "k-image",
	        SELECT = "select",
	        ZINDEX = "zIndex",
	        ACTIVATE = "activate",
	        DEACTIVATE = "deactivate",
	        POINTERDOWN = "touchstart" + NS + " MSPointerDown" + NS + " pointerdown" + NS,
	        pointers = kendo.support.pointers,
	        msPointers = kendo.support.msPointers,
	        allPointers = msPointers || pointers,
	        CHANGE = "change",
	        ERROR = "error",
	        TOUCHSTART = kendo.support.touch ? "touchstart" : "",
	        MOUSEENTER = pointers ? "pointerover" : (msPointers ? "MSPointerOver" : "mouseenter"),
	        MOUSELEAVE = pointers ? "pointerout" : (msPointers ? "MSPointerOut" : "mouseleave"),
	        MOUSEWHEEL = "DOMMouseScroll" + NS + " mousewheel" + NS,
	        RESIZE = kendo.support.resize + NS,
	        SCROLLWIDTH = "scrollWidth",
	        SCROLLHEIGHT = "scrollHeight",
	        OFFSETWIDTH = "offsetWidth",
	        OFFSETHEIGHT = "offsetHeight",
	        POPUP_ID_ATTR = "group",
	        POPUP_OPENER_ATTR = "groupparent",
	        DOCUMENT_ELEMENT = $(document.documentElement),
	        KENDOPOPUP = "kendoPopup",
	        DEFAULTSTATE = "k-state-default",
	        HOVERSTATE = "k-state-hover",
	        FOCUSEDSTATE = "k-state-focused",
	        DISABLEDSTATE = "k-state-disabled",
	        SELECTEDSTATE = "k-state-selected",
	        menuSelector = ".k-menu",
	        groupSelector = ".k-menu-group",
	        animationContainerSelector = ".k-animation-container",
	        popupSelector = groupSelector + "," + animationContainerSelector,
	        allItemsSelector = ":not(.k-list) > .k-item",
	        disabledSelector = ".k-item.k-state-disabled",
	        itemSelector = ".k-item",
	        availableItemsSelector = ".k-item:not(.k-state-disabled)",
	        linkSelector = ".k-item:not(.k-state-disabled) > .k-link",
	        exclusionSelector = ":not(.k-item.k-separator)",
	        nextSelector = itemSelector + exclusionSelector + ":eq(0)",
	        lastSelector = itemSelector + exclusionSelector + ":last",
	        templateSelector = "div:not(.k-animation-container,.k-list-container)",
	        scrollButtonSelector = ".k-menu-scroll-button",
	        touchPointerTypes = { "2": 1, "touch": 1 },
	        STRING = "string",
	        DATABOUND = "dataBound",

	        bindings = {
	            text: "dataTextField",
	            url: "dataUrlField",
	            spriteCssClass: "dataSpriteCssClassField",
	            imageUrl: "dataImageUrlField",
	            imageAttr: "dataImageAttrField",
	            content: "dataContentField"
	        },

	        rendering = {
	            wrapperCssClass: function(group, item) {
	                var result = "k-item k-menu-item",
	                    index = item.index;

	                if (item.enabled === false) {
	                    result += " k-state-disabled";
	                } else {
	                    result += " k-state-default";
	                }

	                if (group.firstLevel && index === 0) {
	                    result += " k-first";
	                }

	                if (index == group.length - 1) {
	                    result += " k-last";
	                }

	                if (item.cssClass) {
	                    result += " " + item.cssClass;
	                }

	                if (item.attr && item.attr.hasOwnProperty("class")) {
	                    result += " " + item.attr["class"];
	                }

	                if (item.selected) {
	                    result += " " + SELECTEDSTATE;
	                }

	                return result;
	            },

	            itemCssAttributes: function (item) {
	                var result = "";
	                var attributes = item.attr || {};

	                for (var attr in attributes) {
	                    if(attributes.hasOwnProperty(attr) && attr !== "class") {
	                        result += attr + "=\"" + attributes[attr] + "\" ";
	                    }
	                }

	                return result;
	            },

	            imageCssAttributes: function (imgAttributes) {
	                var result = "";
	                var attributes = imgAttributes && imgAttributes.toJSON ? imgAttributes.toJSON() : {};

	                if (!attributes['class']) {
	                    attributes['class'] = IMAGE;
	                } else {
	                    attributes['class'] += " " + IMAGE;
	                }

	                for (var attr in attributes) {
	                    if(attributes.hasOwnProperty(attr)) {
	                        result += attr + "=\"" + attributes[attr] + "\" ";
	                    }
	                }

	                return result;
	            },

	            contentCssAttributes: function (item) {
	                var result = "";
	                var attributes = item.contentAttr || {};
	                var defaultClasses = "k-content k-group k-menu-group";

	                if (!attributes['class']) {
	                    attributes['class'] = defaultClasses;
	                } else {
	                    attributes['class'] += " " + defaultClasses;
	                }

	                for (var attr in attributes) {
	                    if(attributes.hasOwnProperty(attr)) {
	                        result += attr + "=\"" + attributes[attr] + "\" ";
	                    }
	                }

	                return result;
	            },

	            textClass: function() {
	                return LINK;
	            },

	            arrowClass: function(item, group) {
	                var result = "k-menu-expand-arrow k-icon";

	                if (group.horizontal) {
	                    result += " k-i-arrow-60-down";
	                } else {
	                    result += " k-i-arrow-60-right";
	                }

	                return result;
	            },

	            groupAttributes: function(group) {
	                return group.expanded !== true ? " style='display:none'" : "";
	            },

	            groupCssClass: function() {
	                return "k-group k-menu-group";
	            },

	            content: function(item) {
	                return item.content ? item.content : "&nbsp;";
	            }
	    };

	    function getEffectDirection(direction, root) {
	        direction = direction.split(" ")[!root+0] || direction;
	        return direction.replace("top", "up").replace("bottom", "down");
	    }

	    function parseDirection(direction, root, isRtl) {
	        direction = direction.split(" ")[!root+0] || direction;
	        var output = { origin: ["bottom", (isRtl ? "right" : "left")], position: ["top", (isRtl ? "right" : "left")] },
	            horizontal = /left|right/.test(direction);

	        if (horizontal) {
	            output.origin = [ "top", direction ];
	            output.position[1] = kendo.directions[direction].reverse;
	        } else {
	            output.origin[0] = direction;
	            output.position[0] = kendo.directions[direction].reverse;
	        }

	        output.origin = output.origin.join(" ");
	        output.position = output.position.join(" ");

	        return output;
	    }

	    function contains(parent, child) {
	        try {
	            return $.contains(parent, child);
	        } catch (e) {
	            return false;
	        }
	    }

	    function updateItemClasses(item) {
	        item = $(item);

	        item.addClass("k-item k-menu-item")
	            .children(IMG)
	            .addClass(IMAGE);

	        item
	            .children("a")
	            .addClass(LINK)
	            .children(IMG)
	            .addClass(IMAGE);

	        item
	            .filter(":not([disabled])")
	            .addClass(DEFAULTSTATE);

	        item
	            .filter(".k-separator")
	            .removeClass("k-menu-item")
	            .addClass("k-menu-separator")
	            .empty()
	            .append("&nbsp;");

	        item
	            .filter("li[disabled]")
	            .addClass(DISABLEDSTATE)
	            .removeAttr("disabled")
	            .attr("aria-disabled", true);

	        if (!item.filter("[role]").length) {
	            item.attr("role", "menuitem");
	        }

	        if (!item.children(LINK_SELECTOR).length) {
	            item
	                .contents()      // exclude groups, real links, templates and empty text nodes
	                .filter(function() { return (!this.nodeName.match(excludedNodesRegExp) && !(this.nodeType == 3 && !kendo.trim(this.nodeValue))); })
	                .wrapAll("<span class='" + LINK + "'/>");
	        }

	        updateArrow(item);
	        updateFirstLast(item);
	    }

	    function updateArrow(item) {
	        item = $(item);

	        item.find("> .k-link > [class*=k-i-arrow-60]:not(.k-sprite)").remove();

	        item.filter(":has(.k-menu-group)")
	            .children(".k-link:not(:has([class*=k-i-arrow]:not(.k-sprite)))")
	            .each(function () {
	                var item = $(this),
	                    arrowCssClass = getArrowCssClass(item);

	                item.append("<span class='k-menu-expand-arrow k-icon " + arrowCssClass + "' />");
	            });
	    }

	    function getArrowCssClass(item) {
	        var arrowCssClass,
	            parent = item.parent().parent(),
	            isRtl = kendo.support.isRtl(parent);

	        if (parent.hasClass(MENU + "-horizontal")) {
	            arrowCssClass = "k-i-arrow-60-down";
	        } else {
	            if (isRtl) {
	                arrowCssClass = "k-i-arrow-60-left";
	            }
	            else {
	                arrowCssClass = "k-i-arrow-60-right";
	            }
	        }
	        return arrowCssClass;
	    }

	    function updateFirstLast (item) {
	        item = $(item);

	        item.filter(".k-first:not(:first-child)").removeClass(FIRST);
	        item.filter(".k-last:not(:last-child)").removeClass(LAST);
	        item.filter(":first-child").addClass(FIRST);
	        item.filter(":last-child").addClass(LAST);
	    }

	    function updateHasAriaPopup (parents) {
	        if (parents && parents.length) {
	            for (var index in parents) {
	                var parentLi = parents.eq(index);
	                if (parentLi.find("ul").length) {
	                    parentLi.attr("aria-haspopup", true);
	                } else {
	                    parentLi.removeAttr("aria-haspopup");
	                }
	            }
	        }
	    }

	    function getParentLiItems(group) {
	        if (!group.hasClass(MENU)) {
	            return group.parentsUntil("." + MENU, "li");
	        }
	    }

	    function storeItemSelectEventHandler (element, options) {
	        var selectHandler = getItemSelectEventHandler(options);
	        if(selectHandler) {
	            setItemData(element, selectHandler);
	        }

	        if (options.items) {
	            $(element).children("ul").children("li").each(function(i){
	                storeItemSelectEventHandler(this, options.items[i]);
	            });
	        }
	    }

	    function setItemData (element, selectHandler) {
	        $(element).children(".k-link").data({
	            selectHandler : selectHandler
	        });
	    }

	    function getItemSelectEventHandler (options) {
	        var selectHandler = options.select,
	            isFunction = kendo.isFunction;

	        if (selectHandler && isFunction(selectHandler)) {
	            return selectHandler;
	        }
	        return null;
	    }

	    function popupOpenerSelector(id){
	        return id ? "li[data-groupparent='" + id + "']" : "li[data-groupparent]";
	    }
	    function popupGroupSelector(id) {
	        var selector = id ? "[data-group='" + id + "']" : "[data-group]";
	        return "ul" + selector + ",div" + selector;
	    }
	    function getChildPopups (currentPopup, overflowWrapper) {
	        var childPopupOpener = currentPopup.find(popupOpenerSelector());
	        var result = [];
	        childPopupOpener.each(function(i, opener){
	            opener = $(opener);
	            var popupId = opener.data(POPUP_OPENER_ATTR);
	            var popup = currentPopup;
	            while(popupId) {
	                popup = overflowWrapper.find(popupGroupSelector(popupId) + ":visible");
	                if (popup.length) {
	                    result.push(popup);
	                }
	                opener = popup.find(popupOpenerSelector());
	                popupId = opener.data(POPUP_OPENER_ATTR);
	            }
	        });

	        return result;
	    }

	    function popupParentItem(popupElement, overflowWrapper) {
	        var popupId = popupElement.data(POPUP_ID_ATTR);
	        return popupId ? overflowWrapper.find(popupOpenerSelector(popupId)) : $([]);
	    }

	    function itemPopup(item, overflowWrapper) {
	        var popupId = item.data(POPUP_OPENER_ATTR);
	        return popupId ? overflowWrapper.children(animationContainerSelector).children(popupGroupSelector(popupId)) : $([]);
	    }

	    function overflowMenuParents(current, overflowWrapper) {
	        var parents = [];
	        var getParents = function(item){
	            while (item.parentNode && !overflowWrapper.is(item.parentNode)) {
	                parents.push(item.parentNode);
	                item = item.parentNode;
	            }
	        };
	        var elem = current[0] || current;
	        getParents(elem);
	        var last = parents[parents.length - 1];
	        while($(last).is(animationContainerSelector)){
	            var popupElement = $(last).children("ul");
	            elem = popupParentItem(popupElement, overflowWrapper)[0];
	            if (!elem) {
	                break;
	            }
	            parents.push(elem);
	            getParents(elem);
	            last = parents[parents.length - 1];
	        }
	        return parents;
	    }

	    function mousewheelDelta(e) {
	        var delta = 0;

	        if (e.wheelDelta) {
	            delta = -e.wheelDelta / 120;
	            delta = delta > 0 ? Math.ceil(delta) : Math.floor(delta);
	        }

	        if (e.detail) {
	            delta = Math.round(e.detail / 3);
	        }

	        return delta;
	    }

	    function parentsScroll(current, scrollDirection) {
	        var scroll = 0;
	        var parent = current.parentNode;
	        while(parent && !isNaN(parent[scrollDirection])) {
	            scroll += parent[scrollDirection];
	            parent = parent.parentNode;
	        }
	        return scroll;
	    }

	    function isPointerTouch(e){
	        return allPointers && e.originalEvent && e.originalEvent.pointerType in touchPointerTypes;
	    }

	    function isTouch(e){
	        var ev = e.originalEvent;
	        return touch && /touch/i.test(ev.type || "");
	    }

	    function removeSpacesBetweenItems(ul){
	        ul.contents().filter(function(){ return this.nodeName != "LI"; }).remove();
	    }

	    var Menu = kendo.ui.DataBoundWidget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            element = that.wrapper = that.element;
	            options = that.options;
	            that._accessors();
	            that._templates();
	            that._dataSource();

	            that._updateClasses();

	            that._animations(options);

	            that.nextItemZIndex = 100;

	            that._tabindex();

	            that._initOverflow(options);

	            that._attachMenuEventsHandlers();

	            if (options.openOnClick) {
	                that.clicked = false;
	            }

	            element.attr("role", "menubar");

	            if (element[0].id) {
	                that._ariaId = kendo.format("{0}_mn_active", element[0].id);
	            }

	            kendo.notify(that);
	        },

	        events: [
	            OPEN,
	            CLOSE,
	            ACTIVATE,
	            DEACTIVATE,
	            SELECT,
	            DATABOUND
	        ],

	        options: {
	            name: "Menu",
	            animation: {
	                open: {
	                    duration: 200
	                },
	                close: { // if close animation effects are defined, they will be used instead of open.reverse
	                    duration: 100
	                }
	            },
	            orientation: "horizontal",
	            direction: "default",
	            openOnClick: false,
	            closeOnClick: true,
	            hoverDelay: 100,
	            scrollable: false,
	            popupCollision: undefined
	        },

	        _initData: function() {
	            var that = this;

	            if (that.dataSource) {
	                that.angular("cleanup", function(){
	                    return {
	                        elements: that.element.children()
	                    };
	                });
	                that.element.empty();

	                that.append(that.dataSource.view(), that.element);
	                that.angular("compile", function(){
	                    return {
	                        elements: that.element.children()
	                    };
	                });
	            }
	        },

	        _attachMenuEventsHandlers: function() {
	            var that = this;
	            var element = that.element;
	            var options = that.options;
	            var overflowWrapper = that._overflowWrapper();

	            (overflowWrapper || element).on(POINTERDOWN, itemSelector, proxy(that._focusHandler, that))
	                   .on(CLICK + NS, disabledSelector, false)
	                   .on(CLICK + NS, itemSelector, proxy(that._click , that))
	                   .on(POINTERDOWN + " " + MOUSEDOWN + NS, ".k-content", proxy(that._preventClose, that))
	                   .on(MOUSEENTER + NS, availableItemsSelector, proxy(that._mouseenter, that))
	                   .on(MOUSELEAVE + NS, availableItemsSelector, proxy(that._mouseleave, that))
	                   .on(MOUSEDOWN + NS, availableItemsSelector, proxy(that._mousedown, that))
	                   .on(TOUCHSTART + NS + " " + MOUSEENTER + NS + " " + MOUSELEAVE + NS + " " +
	                       MOUSEDOWN + NS + " " + CLICK + NS, linkSelector, proxy(that._toggleHover, that));

	            element.on("keydown" + NS, proxy(that._keydown, that))
	                   .on("focus" + NS, proxy(that._focus, that))
	                   .on("focus" + NS, ".k-content", proxy(that._focus, that))
	                   .on("blur" + NS, proxy(that._removeHoverItem, that))
	                   .on("blur" + NS, "[tabindex]", proxy(that._checkActiveElement, that));

	            if (overflowWrapper) {
	                overflowWrapper
	                    .on(MOUSELEAVE + NS, popupSelector, proxy(that._mouseleavePopup, that))
	                    .on(MOUSEENTER + NS, popupSelector, proxy(that._mouseenterPopup, that));
	            }

	            if (options.openOnClick) {
	                that._documentClickHandler = proxy(that._documentClick, that);
	                $(document).click(that._documentClickHandler);
	            }
	        },

	        _detachMenuEventsHandlers: function() {
	            var that = this;
	            var overflowWrapper = that._overflowWrapper();

	            if (overflowWrapper) {
	                overflowWrapper.off(NS);
	            }

	            that.element.off(NS);

	            if (that._documentClickHandler) {
	                $(document).unbind("click", that._documentClickHandler);
	            }
	        },

	        _initOverflow: function(options) {
	            var that = this;
	            var isHorizontal = options.orientation == "horizontal";
	            var backwardBtn, forwardBtn;

	            if (options.scrollable) {
	                that._openedPopups = {};
	                that._scrollWrapper = that.element.wrap("<div class='k-menu-scroll-wrapper " + options.orientation + "'></div>").parent();
	                if (isHorizontal) {
	                    removeSpacesBetweenItems(that.element);
	                }

	                backwardBtn = $(that.templates.scrollButton({direction: isHorizontal ? "left" : "up"}));
	                forwardBtn = $(that.templates.scrollButton({direction: isHorizontal ? "right": "down"}));
	                backwardBtn.add(forwardBtn).appendTo(that._scrollWrapper);

	                that._initScrolling(that.element, backwardBtn, forwardBtn, isHorizontal);

	                var initialWidth = that.element.outerWidth();
	                var initialCssWidth = that.element[0].style.width;
	                initialCssWidth = initialCssWidth === "auto" ? "" : initialCssWidth;

	                if (isHorizontal) {
	                    $(window).on(RESIZE, kendo.throttle(function(){
	                        that._setOverflowWrapperWidth(initialWidth, initialCssWidth);
	                        that._toggleScrollButtons(that.element, backwardBtn, forwardBtn, isHorizontal);
	                    }, 100));
	                }

	                that._setOverflowWrapperWidth(initialWidth, initialCssWidth);
	                that._toggleScrollButtons(that.element, backwardBtn, forwardBtn, isHorizontal);
	            }
	        },

	        _overflowWrapper: function(){
	            return this._scrollWrapper || this._popupsWrapper;
	        },

	        _setOverflowWrapperWidth: function(initialWidth, initialCssWidth) {
	            var that = this;
	            var wrapperCssWidth = that._scrollWrapper.css("width");

	            that._scrollWrapper.css({width: ""});
	            var wrapperWidth = that._scrollWrapper.outerWidth();
	            that._scrollWrapper.css({ width: wrapperCssWidth });

	            var menuWidth = that.element.outerWidth();
	            var borders = that.element[0].offsetWidth - that.element[0].clientWidth;

	            if (menuWidth != wrapperWidth && wrapperWidth > 0) {
	                var width = initialCssWidth ? Math.min(initialWidth, wrapperWidth) : wrapperWidth;
	                that.element.width(width - borders);
	                that._scrollWrapper.width(width);
	            }
	        },

	        _reinitOverflow: function(options) {
	            var that = this;
	            var overflowChanged = ((options.scrollable && !that.options.scrollable) || (!options.scrollable && that.options.scrollable)) ||
	                (options.scrollable && that.options.scrollable && options.scrollable.distance != that.options.scrollable.distance) ||
	                options.orientation != that.options.orientation;

	            if (overflowChanged) {
	                that._detachMenuEventsHandlers();
	                that._destroyOverflow();
	                that._initOverflow(options);
	                that._attachMenuEventsHandlers();
	            }
	        },

	        _destroyOverflow: function() {
	            var that = this;
	            var overflowWrapper = that._overflowWrapper();
	            if(overflowWrapper) {
	                overflowWrapper.off(NS);
	                overflowWrapper.find(scrollButtonSelector).off(NS).remove();
	                overflowWrapper.children(animationContainerSelector).each(function(i, popupWrapper){
	                    var ul = $(popupWrapper).children(groupSelector);
	                    ul.off(MOUSEWHEEL);
	                    var popupParentLi = popupParentItem(ul, overflowWrapper);
	                    if (popupParentLi.length) {
	                        popupParentLi.append(popupWrapper);
	                    }
	                });

	                overflowWrapper.find(popupOpenerSelector()).removeAttr("data-groupparent");
	                overflowWrapper.find(popupGroupSelector()).removeAttr("data-group");
	                that.element.off(MOUSEWHEEL);
	                $(window).off(RESIZE);
	                overflowWrapper.contents().unwrap();

	                that._scrollWrapper = that._popupsWrapper = that._openedPopups = undefined;
	            }
	        },

	        _initScrolling: function(scrollElement, backwardBtn, forwardBtn, isHorizontal) {
	            var that = this;
	            var scrollable = that.options.scrollable;
	            var distance =  $.isNumeric(scrollable.distance) ? scrollable.distance : SCROLLSPEED;
	            var mouseWheelDistance = distance / 2;
	            var backward = "-=" + distance;
	            var forward = "+=" + distance;
	            var backwardDouble = "-=" + distance * 2;
	            var forwardDouble = "+=" + distance * 2;
	            var scrolling = false;
	            var touchEvents = false;

	            var scroll = function(value) {
	                var scrollValue = isHorizontal ? {"scrollLeft": value} : { "scrollTop": value };
	                scrollElement.finish().animate(scrollValue, "fast", "linear", function () {
	                    if (scrolling) {
	                        scroll(value);
	                    }
	                });
	                that._toggleScrollButtons(scrollElement, backwardBtn, forwardBtn, isHorizontal);
	            };

	            var mouseenterHandler = function(e) {
	                if (!scrolling && !touchEvents) {
	                    scroll(e.data.direction);
	                    scrolling = true;
	                }
	            };

	            var mousedownHandler = function(e) {
	                var scrollValue = isHorizontal ? {"scrollLeft": e.data.direction} : { "scrollTop": e.data.direction };
	                touchEvents = isTouch(e) || isPointerTouch(e);
	                scrollElement.stop().animate(scrollValue, "fast", "linear", function(){
	                    if (!touchEvents) {
	                        $(e.currentTarget).trigger(MOUSEENTER);
	                    } else {
	                         that._toggleScrollButtons(scrollElement, backwardBtn, forwardBtn, isHorizontal);
	                         scrolling = true;
	                    }
	                });
	                scrolling = false;

	                e.stopPropagation();
	                e.preventDefault();
	            };

	            backwardBtn.on(MOUSEENTER + NS, {direction: backward}, mouseenterHandler)
	                .on(kendo.eventMap.down + NS, {direction: backwardDouble}, mousedownHandler);

	            forwardBtn.on(MOUSEENTER + NS, {direction: forward}, mouseenterHandler)
	                .on(kendo.eventMap.down + NS, {direction: forwardDouble}, mousedownHandler);

	            backwardBtn.add(forwardBtn)
	                .on(MOUSELEAVE + NS, function() {
	                    scrollElement.stop();
	                    scrolling = false;
	                    that._toggleScrollButtons(scrollElement, backwardBtn, forwardBtn, isHorizontal);
	                });

	            scrollElement.on(MOUSEWHEEL, function(e){
	                if (!e.ctrlKey && !e.shiftKey && !e.altKey) {
	                    var wheelDelta = mousewheelDelta(e.originalEvent);
	                    var scrollSpeed = Math.abs(wheelDelta) * mouseWheelDistance;
	                    var value = (wheelDelta > 0 ? "+=" : "-=") + scrollSpeed;
	                    var scrollValue = isHorizontal ? {"scrollLeft": value} : {"scrollTop": value };

	                    that._closeChildPopups(scrollElement);

	                    scrollElement.finish().animate(scrollValue, "fast", "linear", function(){
	                        that._toggleScrollButtons(scrollElement, backwardBtn, forwardBtn, isHorizontal);
	                    });
	                    e.preventDefault();
	                }
	            });
	        },

	        _toggleScrollButtons: function(scrollElement, backwardBtn, forwardBtn, horizontal) {
	            var currentScroll = horizontal ? kendo.scrollLeft(scrollElement) : scrollElement.scrollTop();
	            var scrollSize = horizontal ? SCROLLWIDTH : SCROLLHEIGHT;
	            var offset = horizontal ? OFFSETWIDTH : OFFSETHEIGHT;

	            backwardBtn.toggle(currentScroll !== 0);
	            forwardBtn.toggle(currentScroll < scrollElement[0][scrollSize] - scrollElement[0][offset] - 1);
	        },

	        setOptions: function(options) {
	            var animation = this.options.animation;

	            this._animations(options);

	            options.animation = extend(true, animation, options.animation);

	            if ("dataSource" in options) {
	                this._dataSource(options);
	            }

	            this._updateClasses();
	            this._reinitOverflow(options);

	            Widget.fn.setOptions.call(this, options);
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            that._detachMenuEventsHandlers();

	            that._destroyOverflow();

	            kendo.destroy(that.element);
	        },

	        enable: function (element, enable) {
	            this._toggleDisabled(element, enable !== false);

	            return this;
	        },

	        disable: function (element) {
	            this._toggleDisabled(element, false);

	            return this;
	        },

	        attemptGetItem: function (candidate) {
	            candidate = candidate || this.element;
	            var item = this.element.find(candidate);
	            var overflowWrapper = this._overflowWrapper();

	            if (item.length || candidate === this.element){
	                return item;
	            } else if (overflowWrapper) {
	                return overflowWrapper.find(candidate);
	            } else {
	                return $();
	            }
	        },

	        append: function (item, referenceItem) {
	            referenceItem = this.attemptGetItem(referenceItem);

	            var inserted = this._insert(item, referenceItem, referenceItem.length ? this._childPopupElement(referenceItem) : null);

	            each(inserted.items, function (i) {
	                inserted.group.append(this);
	                updateArrow(this);
	                storeItemSelectEventHandler(this, item[i] || item);
	            });

	            updateArrow(referenceItem);
	            updateFirstLast(inserted.group.find(".k-first, .k-last").add(inserted.items));
	            updateHasAriaPopup(getParentLiItems(inserted.group));

	            return this;
	        },

	        insertBefore: function (item, referenceItem) {
	            referenceItem = this.attemptGetItem(referenceItem);

	            var inserted = this._insert(item, referenceItem, referenceItem.parent());

	            each(inserted.items, function (i) {
	                referenceItem.before(this);
	                updateArrow(this);
	                updateFirstLast(this);
	                storeItemSelectEventHandler(this, item[i] || item);
	            });

	            updateFirstLast(referenceItem);

	            return this;
	        },

	        insertAfter: function (item, referenceItem) {
	            referenceItem = this.attemptGetItem(referenceItem);

	            var inserted = this._insert(item, referenceItem, referenceItem.parent());

	            each(inserted.items, function (i) {
	                referenceItem.after(this);
	                updateArrow(this);
	                updateFirstLast(this);
	                storeItemSelectEventHandler(this, item[i] || item);
	            });

	            updateFirstLast(referenceItem);

	            return this;
	        },

	        _insert: function (item, referenceItem, parent) {
	            var that = this,
	                items, groups;

	            if (!referenceItem || !referenceItem.length) {
	                parent = that.element;
	            }

	            var plain = $.isPlainObject(item) || item instanceof kendo.data.ObservableObject,
	                groupData = {
	                    firstLevel: parent.hasClass(MENU),
	                    horizontal: parent.hasClass(MENU + "-horizontal"),
	                    expanded: true,
	                    length: parent.children().length
	                };

	            if (referenceItem && !parent.length) {
	                parent = $(that.renderGroup({ group: groupData, options: that.options })).appendTo(referenceItem);
	            }

	            if (plain || isArray(item) || item instanceof kendo.data.ObservableArray) { // is JSON
	                items = $($.map(plain ? [ item ] : item, function (value, idx) {
	                            if (typeof value === "string") {
	                                return $(value).get();
	                            } else {
	                                return $(that.renderItem({
	                                    group: groupData,
	                                    item: extend(value, { index: idx })
	                                })).get();
	                            }
	                        }));
	            } else {
	                if (typeof item == "string" && item.charAt(0) != "<") {
	                    items = that.element.find(item);
	                } else {
	                    items = $(item);
	                }

	                groups = items.find("> ul")
	                                .addClass("k-menu-group")
	                                .attr("role", "menu");

	                items = items.filter("li");

	                items.add(groups.find("> li")).each(function () {
	                    updateItemClasses(this);
	                });
	            }

	            return { items: items, group: parent };
	        },

	        remove: function (element) {
	            element = this.attemptGetItem(element);

	            var that = this,
	                parent = element.parentsUntil(that.element, allItemsSelector),
	                group = element.parent("ul:not(.k-menu)");

	            element.remove();

	            if (group && !group.children(allItemsSelector).length) {
	                var parentItems = getParentLiItems(group);

	                var container = group.parent(animationContainerSelector);

	                if (container.length) {
	                    container.remove();
	                } else {
	                    group.remove();
	                }

	                updateHasAriaPopup(parentItems);
	            }

	            if (parent.length) {
	                parent = parent.eq(0);

	                updateArrow(parent);
	                updateFirstLast(parent);
	            }

	            return that;
	        },

	        _openAfterLoad: function (element, dataItem) {
	            var that = this;
	            if(dataItem.loaded()) {
	                that.open(element);
	                that._loading = false;
	            } else {
	                dataItem.one(CHANGE, function(){
	                    element.find(ICON_SELECTOR).removeClass("k-i-loading");
	                    if(that._loading) {
	                        that.open(element);
	                        that._loading = false;
	                    }
	                });
	            }
	        },

	        open: function (element) {
	            var that = this;
	            var options = that.options;
	            var horizontal = options.orientation == "horizontal";
	            var direction = options.direction;
	            var isRtl = kendo.support.isRtl(that.wrapper);
	            var overflowWrapper = that._overflowWrapper();
	            element = (overflowWrapper || that.element).find(element);

	            var dataItem = that.dataSource && that.dataSource.getByUid(element.data(kendo.ns + "uid"));

	            if(dataItem && dataItem.hasChildren && !dataItem.loaded() && !that._loading){
	                that._loading = true;
	                element.find(ICON_SELECTOR).addClass("k-i-loading");
	                dataItem.load();
	                that._openAfterLoad(element, dataItem);
	                return;
	            }

	            if (/^(top|bottom|default)$/.test(direction)) {
	                if (isRtl) {
	                    direction = horizontal ? (direction + " left").replace("default", "bottom") : "left";
	                } else {
	                    direction = horizontal ? (direction + " right").replace("default", "bottom") : "right";
	                }
	            }

	            var visiblePopups = ">.k-popup:visible,>.k-animation-container>.k-popup:visible";
	            var closePopup = function () {
	                var popup = $(this).data(KENDOPOPUP);
	                if (popup) {
	                    // Use the built-in close method to play the hoverDelay from the options
	                    that.close($(this).closest("li.k-item"), true);
	                }
	            };

	            element.siblings()
	                   .find(visiblePopups)
	                   .each(closePopup);

	            if (overflowWrapper) {
	                element.find(visiblePopups).each(closePopup);
	            }

	            if (that.options.openOnClick) {
	                that.clicked = true;
	            }

	            element.each(function () {
	                var li = $(this);

	                clearTimeout(li.data(TIMER));

	                li.data(TIMER, setTimeout(function () {
	                    var ul = li.find(".k-menu-group:first:hidden");
	                    var popup;
	                    var overflowPopup;

	                    if  (!ul[0] && overflowWrapper) {
	                        overflowPopup = that._getPopup(li);
	                        ul = overflowPopup && overflowPopup.element;
	                    }
	                    if (ul.is(":visible")) {
	                        return;
	                    }

	                    if (ul[0] && that._triggerEvent({ item: li[0], type: OPEN }) === false) {

	                        if (!ul.find(".k-menu-group")[0] && ul.children(".k-item").length > 1) {
	                            var windowHeight = $(window).height(),
	                                setScrolling = function(){
	                                    ul.css({maxHeight: windowHeight - (kendo._outerHeight(ul) - ul.height()) - kendo.getShadows(ul).bottom, overflow: "auto"});
	                                };

	                            if (kendo.support.browser.msie && kendo.support.browser.version <= 7) {
	                                setTimeout(setScrolling, 0); // timeout required by IE7
	                            } else {
	                                setScrolling();
	                            }
	                        } else {
	                            ul.css({maxHeight: "", overflow: ""});
	                        }

	                        li.data(ZINDEX, li.css(ZINDEX));
	                        var nextZindex = that.nextItemZIndex++;
	                        li.css(ZINDEX, nextZindex);

	                        if (that.options.scrollable) {
	                            li.parent().siblings(scrollButtonSelector).css({zIndex: ++nextZindex});
	                        }

	                        popup = ul.data(KENDOPOPUP);
	                        var root = li.parent().hasClass(MENU),
	                            parentHorizontal = root && horizontal,
	                            directions = parseDirection(direction, root, isRtl),
	                            effects = options.animation.open.effects,
	                            openEffects = effects !== undefined ? effects : "slideIn:" + getEffectDirection(direction, root);

	                        if (!popup) {
	                            popup = ul.kendoPopup({
	                                activate: function() { that._triggerEvent({ item: this.wrapper.parent(), type: ACTIVATE }); },
	                                deactivate: function(e) {
	                                    that._closing = false;
	                                    e.sender.element // Restore opacity after fade.
	                                        .removeData("targetTransform")
	                                        .css({ opacity: "" });
	                                    that._triggerEvent({ item: this.wrapper.parent(), type: DEACTIVATE });
	                                },
	                                origin: directions.origin,
	                                position: directions.position,
	                                collision: options.popupCollision !== undefined ? options.popupCollision : (parentHorizontal ? "fit" : "fit flip"),
	                                anchor: li,
	                                appendTo: overflowWrapper || li,
	                                animation: {
	                                    open: extend(true, { effects: openEffects }, options.animation.open),
	                                    close: options.animation.close
	                                },
	                                open: proxy(that._popupOpen, that),
	                                close: function (e) {
	                                    that._closing = true;
	                                    var li = e.sender.wrapper.parent();

	                                    if (overflowWrapper) {
	                                        var popupId = e.sender.element.data(POPUP_ID_ATTR);
	                                        if (popupId) {
	                                            li = (overflowWrapper || that.element).find(popupOpenerSelector(popupId));
	                                        }
	                                        e.sender.wrapper.children(scrollButtonSelector).hide();
	                                    }

	                                    if (!that._triggerEvent({ item: li[0], type: CLOSE })) {
	                                        li.css(ZINDEX, li.data(ZINDEX));
	                                        li.removeData(ZINDEX);

	                                        if (that.options.scrollable) {
	                                            li.parent().siblings(scrollButtonSelector).css({zIndex: ""});
	                                        }

	                                        if (touch || allPointers || kendo.support.mouseAndTouchPresent) {
	                                            li.removeClass(HOVERSTATE);
	                                            that._removeHoverItem();
	                                        }
	                                    } else {
	                                        e.preventDefault();
	                                    }
	                                }
	                            }).data(KENDOPOPUP);
	                        } else {
	                            popup = ul.data(KENDOPOPUP);
	                            popup.options.origin = directions.origin;
	                            popup.options.position = directions.position;
	                            popup.options.animation.open.effects = openEffects;
	                        }
	                        ul.removeAttr("aria-hidden");

	                        that._configurePopupOverflow(popup, li);

	                        popup._hovered = true;
	                        popup.open();

	                        that._initPopupScrolling(popup);
	                    }

	                }, that.options.hoverDelay));
	            });

	            return that;
	        },

	        _configurePopupOverflow: function(popup, popupOpener) {
	            var that = this;
	           if (that.options.scrollable) {
	                that._wrapPopupElement(popup);
	                if (!popupOpener.attr("data-groupparent")) {
	                    var groupId = new Date().getTime();
	                    popupOpener.attr("data-groupparent", groupId);
	                    popup.element.attr("data-group", groupId);
	                }
	           }
	        },

	        _wrapPopupElement: function(popup){
	            if (!popup.element.parent().is(animationContainerSelector)) {
	                popup.wrapper = kendo.wrap(popup.element, popup.options.autosize)
	                    .css({
	                        overflow: "hidden",
	                        display: "block",
	                        position: "absolute"
	                    });
	            }
	        },

	        _initPopupScrolling: function(popup, isHorizontal, skipMouseEvents) {
	            var that = this;

	            if (that.options.scrollable && popup.element[0].scrollHeight > popup.element[0].offsetHeight) {
	                that._initPopupScrollButtons(popup, isHorizontal, skipMouseEvents);
	            }
	        },

	        _initPopupScrollButtons: function(popup, isHorizontal, skipMouseEvents) {
	            var that = this;
	            var scrollButtons = popup.wrapper.children(scrollButtonSelector);
	            var animation = that.options.animation;
	            var timeout = ((animation && animation.open && animation.open.duration) || 0) + DELAY;
	            setTimeout(function() {
	                if (!scrollButtons.length) {
	                    var backwardBtn = $(that.templates.scrollButton({direction: isHorizontal ? "left" : "up"}));
	                    var forwardBtn = $(that.templates.scrollButton({direction: isHorizontal ? "right": "down"}));

	                    scrollButtons = backwardBtn.add(forwardBtn).appendTo(popup.wrapper);

	                    that._initScrolling(popup.element, backwardBtn, forwardBtn, isHorizontal);
	                    if (!skipMouseEvents) {
	                        scrollButtons.on(MOUSEENTER + NS, function() {
	                            var overflowWrapper = that._overflowWrapper();
	                            $(getChildPopups(popup.element, overflowWrapper)).each(function(i, p){
	                                var popupOpener = overflowWrapper.find(popupOpenerSelector(p.data(POPUP_ID_ATTR)));
	                                that.close(popupOpener);
	                            });
	                        })
	                        .on(MOUSELEAVE + NS, function(){
	                            setTimeout(function(){
	                                if ($.isEmptyObject(that._openedPopups)) {
	                                    that._closeParentPopups(popup.element);
	                                }
	                            }, DELAY);
	                        });
	                    }
	                }
	                that._toggleScrollButtons(popup.element, scrollButtons.first(), scrollButtons.last(), isHorizontal);
	            }, timeout);
	        },

	        _popupOpen: function(e) {
	            if (!this._keyTriggered) {
	                e.sender.element.children("." + FOCUSEDSTATE).removeClass(FOCUSEDSTATE);
	            }
	            if (this.options.scrollable) {
	                this._setPopupHeight(e.sender);
	            }
	        },

	        _setPopupHeight: function(popup, isFixed){
	            var popupElement = popup.element;
	            var popups = popupElement.add(popupElement.parent(animationContainerSelector));

	            popups.height((popupElement.hasClass(MENU) && this._initialHeight) || "");

	            var location = popup._location(isFixed);
	            var windowHeight = $(window).height();
	            var popupOuterHeight = location.height;
	            var popupOffsetTop = isFixed ? 0 : Math.max(location.top, 0);
	            var scrollTop = isFixed ? 0 : parentsScroll(this._overflowWrapper()[0], "scrollTop");
	            var bottomScrollbar = window.innerHeight - windowHeight;
	            var maxHeight = windowHeight - kendo.getShadows(popupElement).bottom + bottomScrollbar;
	            var canFit = maxHeight + scrollTop > popupOuterHeight + popupOffsetTop;

	            if (!canFit) {
	                var height = Math.min(maxHeight, maxHeight - popupOffsetTop + scrollTop);
	                popups.css({overflow: "hidden", height: height + "px"});
	            }
	        },

	        close: function (items, dontClearClose) {
	            var that = this;
	            var overflowWrapper = that._overflowWrapper();
	            var element = (overflowWrapper || that.element);

	            items = element.find(items);

	            if (!items.length) {
	                items = element.find(">.k-item");
	            }

	            var hasChildPopupsHovered = function(currentPopup){
	                var result = false;
	                if ($.isEmptyObject(that._openedPopups)) {
	                    return result;
	                }
	                $(getChildPopups(currentPopup, overflowWrapper)).each(function(i, popup){
	                    result = !!that._openedPopups[popup.data(POPUP_ID_ATTR).toString()];
	                    return !result;
	                });
	                return result;
	            };

	            var isPopupMouseLeaved = function(opener) {
	                var groupId = opener.data(POPUP_OPENER_ATTR);
	                return (!overflowWrapper || !groupId || !that._openedPopups[groupId.toString()]);
	            };

	            items.each(function () {
	                var li = $(this);

	                if (!dontClearClose && that._isRootItem(li)) {
	                    that.clicked = false;
	                }

	                clearTimeout(li.data(TIMER));

	                li.data(TIMER, setTimeout(function () {
	                    var popup = that._getPopup(li);
	                    if (popup && (isPopupMouseLeaved(li) || that._forceClose)) {
	                        if (!that._forceClose && hasChildPopupsHovered(popup.element)) {
	                            return;
	                        }

	                        popup.close();
	                        popup.element.attr("aria-hidden", true);

	                        if (overflowWrapper) {
	                            if (that._forceClose && items.last().is(li[0])) {
	                                delete that._forceClose;
	                            }
	                        }
	                    }
	                }, that.options.hoverDelay));
	            });

	            return that;
	        },

	        _getPopup: function(li) {
	            var that = this;
	            var popup = li.find(".k-menu-group:not(.k-list-container):not(.k-calendar-container):first:visible").data(KENDOPOPUP);
	            var overflowWrapper = that._overflowWrapper();

	            if (!popup && overflowWrapper) {
	                var groupId = li.data(POPUP_OPENER_ATTR);
	                if (groupId) {
	                    var popupElement = overflowWrapper.find(popupGroupSelector(groupId));
	                    popup = popupElement.data(KENDOPOPUP);
	                }
	            }
	            return popup;
	        },

	        _toggleDisabled: function (items, enable) {
	            this.element.find(items).each(function () {
	                $(this)
	                    .toggleClass(DEFAULTSTATE, enable)
	                    .toggleClass(DISABLEDSTATE, !enable)
	                    .attr("aria-disabled", !enable);
	            });
	        },

	        _toggleHover: function(e) {
	            var target = $(kendo.eventTarget(e) || e.target).closest(allItemsSelector),
	                isEnter = e.type == MOUSEENTER || MOUSEDOWN.indexOf(e.type) !== -1;

	            target.siblings().removeClass(HOVERSTATE);

	            if (!target.parents("li." + DISABLEDSTATE).length) {
	                target.toggleClass(HOVERSTATE, isEnter || e.type == "mousedown" || e.type == "pointerover" || e.type == TOUCHSTART);
	            }

	            this._removeHoverItem();
	        },

	        _preventClose: function() {
	            if (!this.options.closeOnClick) {
	                this._closurePrevented = true;
	            }
	        },

	        _checkActiveElement: function(e) {
	            var that = this,
	                hoverItem = $(e ? e.currentTarget : this._hoverItem()),
	                target = that._findRootParent(hoverItem)[0];

	            if (!this._closurePrevented) {
	                setTimeout(function() {
	                    if (!document.hasFocus() || (!contains(target, kendo._activeElement()) && e && !contains(target, e.currentTarget))) {
	                        that.close(target);
	                    }
	                }, 0);
	            }

	            this._closurePrevented = false;
	        },

	        _removeHoverItem: function() {
	            var oldHoverItem = this._hoverItem();

	            if (oldHoverItem && oldHoverItem.hasClass(FOCUSEDSTATE)) {
	                oldHoverItem.removeClass(FOCUSEDSTATE);
	                this._oldHoverItem = null;
	            }
	        },

	        _updateClasses: function() {
	            var element = this.element,
	                nonContentGroupsSelector = ".k-menu-init div ul",
	                items;

	            element.removeClass("k-menu-horizontal k-menu-vertical");
	            element.addClass("k-widget k-reset k-header k-menu-init " + MENU).addClass(MENU + "-" + this.options.orientation);

	            element.find("li > ul")
	                   .filter(function() {
	                       return !kendo.support.matchesSelector.call(this, nonContentGroupsSelector);
	                   })
	                   .addClass("k-group k-menu-group")
	                   .attr("role", "menu")
	                   .attr("aria-hidden", element.is(":visible"))
	                   .parent("li")
	                   .attr("aria-haspopup", "true")
	                   .end()
	                   .find("li > div")
	                   .addClass("k-content")
	                   .attr("tabindex", "-1"); // Capture the focus before the Menu

	            items = element.find("> li,.k-menu-group > li");

	            element.removeClass("k-menu-init");

	            items.each(function () {
	                updateItemClasses(this);
	            });
	        },

	        _mouseenter: function (e) {
	            var that = this;
	            var element = $(e.currentTarget);
	            var hasChildren = that._itemHasChildren(element);
	            var popupId = element.data(POPUP_OPENER_ATTR) || element.parent().data(POPUP_ID_ATTR);
	            var pointerTouch = isPointerTouch(e);

	            if (popupId) {
	                that._openedPopups[popupId.toString()] = true;
	            }

	            if (that._closing || (e.delegateTarget != element.parents(menuSelector)[0] && e.delegateTarget != element.parents(".k-menu-scroll-wrapper,.k-popups-wrapper")[0])) {
	                return;
	            }

	            that._keyTriggered = false;

	            if ((that.options.openOnClick.rootMenuItems && that._isRootItem(element.closest(allItemsSelector))) ||
	                (that.options.openOnClick.subMenuItems && !that._isRootItem(element.closest(allItemsSelector)))) {
	                return;
	            }

	            if ((that.options.openOnClick === false ||
	                (that.options.openOnClick.rootMenuItems === false && that._isRootItem(element.closest(allItemsSelector))) ||
	                (that.options.openOnClick.subMenuItems === false && !that._isRootItem(element.closest(allItemsSelector))) || that.clicked) && !touch &&
	                !(pointerTouch && that._isRootItem(element.closest(allItemsSelector)))) {
	                if (!contains(e.currentTarget, e.relatedTarget) && hasChildren) {
	                    that.open(element);
	                }
	            }

	            if (that.options.openOnClick === true && that.clicked || touch) {
	                element.siblings().each(proxy(function (_, sibling) {
	                    that.close(sibling, true);
	                }, that));
	            }
	        },

	        _mousedown: function (e) {
	            var that = this;
	            var element = $(e.currentTarget);
	            // needs to close subMenuItems
	            if (that.options.openOnClick.subMenuItems && !that._isRootItem(element) || touch) {
	                element.siblings().each(proxy(function (_, sibling) {
	                    that.close(sibling, true);
	                }, that));
	            }
	        },

	        _mouseleave: function (e) {
	            var that = this;
	            var element = $(e.currentTarget);
	            var popupOpener = element.data(POPUP_OPENER_ATTR);
	            var hasChildren = (element.children(animationContainerSelector).length || element.children(groupSelector).length) || popupOpener;
	            var $window = $(window);

	            if (popupOpener) {
	                delete that._openedPopups[popupOpener.toString()];
	            }

	            if (element.parentsUntil(animationContainerSelector, ".k-list-container,.k-calendar-container")[0]) {
	                e.stopImmediatePropagation();
	                return;
	            }

	            if ((that.options.openOnClick === false || (!that.options.openOnClick.rootMenuItems && that._isRootItem(element)) ||
	                (!that.options.openOnClick.subMenuItems && !that._isRootItem(element))) && !touch && !isPointerTouch(e) &&
	                !contains(e.currentTarget, e.relatedTarget || e.target) && hasChildren &&
	                !contains(e.currentTarget, kendo._activeElement())) {
	                    that.close(element, true);
	                    that._loading = false;
	                    return;
	            }

	            // Detect if cursor goes outside the viewport of the browser
	            if( (kendo.support.browser.msie && !e.toElement && !e.relatedTarget && !isPointerTouch(e)) ||
	                e.clientX < 0 || e.clientY < 0 ||
	                e.clientY > $window.height() ||
	                e.clientX > $window.width()){
	                that.close(element);
	            }
	        },

	        _mouseenterPopup: function(e){
	            var that = this;
	            var popupElement = $(e.currentTarget);

	            if (popupElement.parent().is(animationContainerSelector)) {
	                 return;
	            }

	            popupElement = popupElement.children("ul");
	            var popupId = popupElement.data(POPUP_ID_ATTR);

	            if (popupId) {
	                that._openedPopups[popupId.toString()] = true;
	            }
	        },

	        _mouseleavePopup: function (e) {
	            var that = this;
	            var popupElement = $(e.currentTarget);

	            if (!isPointerTouch(e) && popupElement.is(animationContainerSelector)) {
	                that._closePopups(popupElement.children("ul"));
	            }
	        },

	        _closePopups: function(rootPopup) {
	            var that = this;
	            var overflowWrapper = that._overflowWrapper();
	            var popupId = rootPopup.data(POPUP_ID_ATTR);

	            if (popupId) {
	                delete that._openedPopups[popupId.toString()];
	                var groupParent = overflowWrapper.find(popupOpenerSelector(popupId));

	                setTimeout(function() {
	                    if (that.options.openOnClick) {
	                        that._closeChildPopups(rootPopup);
	                    } else {
	                        if ($.isEmptyObject(that._openedPopups)) {
	                            var innerPopup = that._innerPopup(rootPopup);
	                            that._closeParentPopups(innerPopup);
	                        } else {
	                            that.close(groupParent, true);
	                        }
	                    }
	                }, 0);
	            }
	        },

	        _closeChildPopups: function(current){
	            var that = this;
	            var overflowWrapper = that._overflowWrapper();
	            $(getChildPopups(current, overflowWrapper)).each(function(){
	                var popupOpener = overflowWrapper.find(popupOpenerSelector(this.data(POPUP_ID_ATTR)));
	                that.close(popupOpener, true);
	            });
	        },

	        _innerPopup: function(current) {
	            var overflowWrapper = this._overflowWrapper();
	            var popups = getChildPopups(current, overflowWrapper);
	            return popups[popups.length - 1] || current;
	        },

	        _closeParentPopups: function (current) {
	            var that = this;
	            var overflowWrapper = that._overflowWrapper();
	            var popupId = current.data(POPUP_ID_ATTR);
	            var popupOpener = overflowWrapper.find(popupOpenerSelector(popupId));
	            popupId = popupOpener.parent().data(POPUP_ID_ATTR);
	            that.close(popupOpener, true);
	            while (popupId && !that._openedPopups[popupId]) {
	                if (popupOpener.parent().is(menuSelector)) {
	                    break;
	                }
	                popupOpener = overflowWrapper.find(popupOpenerSelector(popupId));
	                that.close(popupOpener, true);
	                popupId = popupOpener.parent().data(POPUP_ID_ATTR);
	            }
	        },

	        _click: function (e) {
	            var that = this, openHandle,
	                options = that.options,
	                target = $(kendo.eventTarget(e)),
	                targetElement = target[0],
	                nodeName = target[0] ? target[0].nodeName.toUpperCase() : "",
	                formNode = (nodeName == "INPUT" || nodeName == "SELECT" || nodeName == "BUTTON" || nodeName == "LABEL"),
	                link = target.closest(LINK_SELECTOR),
	                element = target.closest(allItemsSelector),
	                itemElement = element[0],
	                href = link.attr("href"), childGroup, childGroupVisible,
	                targetHref = target.attr("href"),
	                sampleHref = $("<a href='#' />").attr("href"),
	                isLink = (!!href && href !== sampleHref),
	                isLocalLink = isLink && !!href.match(/^#/),
	                isTargetLink = (!!targetHref && targetHref !== sampleHref),
	                overflowWrapper = that._overflowWrapper(),
	                shouldCloseTheRootItem;

	            if(targetElement && !targetElement.parentNode){
	                return;
	            }

	            if($(target).hasClass('k-menu-expand-arrow')){
	                this._lastClickedElement = targetElement.parentElement;
	            }

	            while (targetElement && targetElement.parentNode != itemElement) {
	                targetElement = targetElement.parentNode;
	            }

	            if ($(targetElement).is(templateSelector)) {
	                return;
	            }

	            if (element.hasClass(DISABLEDSTATE)) {
	                e.preventDefault();
	                return;
	            }

	            if (!e.handled && that._triggerSelect(target, itemElement) && !formNode) { // We shouldn't stop propagation and shoudn't prevent form elements.
	                e.preventDefault();
	            }

	            e.handled = true;

	            childGroup = element.children(popupSelector);
	            if (overflowWrapper) {
	                var childPopupId = element.data(POPUP_OPENER_ATTR);
	                if (childPopupId) {
	                    childGroup = overflowWrapper.find(popupGroupSelector(childPopupId));
	                }
	            }
	            childGroupVisible = childGroup.is(":visible");
	            shouldCloseTheRootItem = options.openOnClick && childGroupVisible && that._isRootItem(element);

	            if (options.closeOnClick && (!isLink || isLocalLink) && (!childGroup.length || shouldCloseTheRootItem)) {
	                element.removeClass(HOVERSTATE).css("height"); // Force refresh for Chrome
	                that._oldHoverItem = that._findRootParent(element);
	                var item = that._parentsUntil(link, that.element, allItemsSelector);
	                that._forceClose = !!overflowWrapper;
	                that.close(item);
	                that.clicked = false;
	                if ("MSPointerUp".indexOf(e.type) != -1) {
	                    e.preventDefault();
	                }
	                return;
	            }

	            if (isLink && e.enterKey) {
	                link[0].click();
	            }

	            if (((!that._isRootItem(element) || options.openOnClick === false) && !options.openOnClick.subMenuItems) && !kendo.support.touch && !(isPointerTouch(e) && that._isRootItem(element.closest(allItemsSelector)))) {
	                return;
	            }

	            if (!isLink && !formNode && !isTargetLink) {
	                e.preventDefault();
	            }

	            that.clicked = true;
	            openHandle = childGroup.is(":visible") ? CLOSE : OPEN;
	            if (!options.closeOnClick && openHandle == CLOSE) {
	                return;
	            }
	            that[openHandle](element);
	        },

	        _parentsUntil: function(context, top, selector) {
	            var overflowWrapper = this._overflowWrapper();
	            if (!overflowWrapper) {
	                return context.parentsUntil(top, selector);
	            } else {
	                var parents = overflowMenuParents(context, overflowWrapper);
	                var result = [];
	                $(parents).each(function(){
	                    var parent = $(this);
	                    if (parent.is(top)) {
	                        return false;
	                    }
	                    if (parent.is(selector)) {
	                        result.push(this);
	                    }
	                });
	                return $(result);
	            }
	        },

	        _triggerSelect: function (target, itemElement) {
	            target = target.is(".k-link") ? target : target.closest(".k-link");

	            var selectHandler = target.data("selectHandler"),
	                itemSelectEventData;

	            if (selectHandler) {
	                itemSelectEventData = this._getEventData(target);
	                selectHandler.call(this, itemSelectEventData);
	            }

	            var isSelectItemDefaultPrevented = itemSelectEventData && itemSelectEventData.isDefaultPrevented();
	            var isSelectDefaultPrevented = this._triggerEvent({ item: itemElement, type: SELECT });
	            return isSelectItemDefaultPrevented || isSelectDefaultPrevented;
	        },

	        _getEventData: function (target) {
	            var eventData = {
	                sender: this,
	                target: target,
	                _defaultPrevented: false,
	                preventDefault: function () {
	                    this._defaultPrevented = true;
	                },
	                isDefaultPrevented: function () {
	                    return this._defaultPrevented;
	                }
	            };
	            return eventData;
	        },

	        _documentClick: function (e) {
	            var that = this;
	            var target = $(e.target).hasClass('k-menu-expand-arrow') ? that._lastClickedElement : e.target;

	            if (contains((that._overflowWrapper() || that.element)[0], target)) {
	                that._lastClickedElement = undefined;
	                return;
	            }

	            that.clicked = false;
	        },

	        _focus: function (e) {
	            var that = this,
	                target = e.target,
	                hoverItem = that._hoverItem(),
	                active = activeElement();

	            if (target != that.wrapper[0] && !$(target).is(":kendoFocusable")) {
	                e.stopPropagation();
	                $(target).closest(".k-content").closest(".k-menu-group").closest(".k-item").addClass(FOCUSEDSTATE);
	                that.wrapper.focus();
	                return;
	            }

	            if (active === e.currentTarget) {
	                if (hoverItem.length) {
	                    that._moveHover([], hoverItem);
	                } else if (!that._oldHoverItem) {
	                    that._moveHover([], that.wrapper.children().first());
	                }
	            }
	        },

	        _keydown: function (e) {
	            var that = this,
	                key = e.keyCode,
	                hoverItem = that._oldHoverItem,
	                target,
	                belongsToVertical,
	                hasChildren,
	                isRtl = kendo.support.isRtl(that.wrapper);

	            if (e.target != e.currentTarget && key != keys.ESC) {
	                return;
	            }

	            if (!hoverItem) {
	                hoverItem  = that._oldHoverItem = that._hoverItem();
	            }

	            belongsToVertical = that._itemBelongsToVertival(hoverItem);
	            hasChildren = that._itemHasChildren(hoverItem);
	            that._keyTriggered = true;

	            if (key == keys.RIGHT) {
	                target = that[isRtl ? "_itemLeft" : "_itemRight"](hoverItem, belongsToVertical, hasChildren);
	            } else if (key == keys.LEFT) {
	                target = that[isRtl ? "_itemRight" : "_itemLeft"](hoverItem, belongsToVertical, hasChildren);
	            } else if (key == keys.DOWN) {
	                target = that._itemDown(hoverItem, belongsToVertical, hasChildren);
	            } else if (key == keys.UP) {
	                target = that._itemUp(hoverItem, belongsToVertical, hasChildren);
	            } else if (key == keys.HOME) {
	                that._moveHover(hoverItem, hoverItem.parent().children().first());
	                e.preventDefault();
	            } else if (key == keys.END) {
	                that._moveHover(hoverItem, hoverItem.parent().children().last());
	                e.preventDefault();
	            } else if (key == keys.ESC) {
	                target = that._itemEsc(hoverItem, belongsToVertical);
	            } else if (key == keys.ENTER || key == keys.SPACEBAR) {
	                target = hoverItem.children(".k-link");
	                if (target.length > 0) {
	                    that._click({ target: target[0], preventDefault: function () {}, enterKey: true });
	                    if (hasChildren && !hoverItem.hasClass(DISABLEDSTATE)) {
	                        that.open(hoverItem);
	                        that._moveHover(hoverItem, that._childPopupElement(hoverItem).children().first());
	                    } else {
	                        that._moveHover(hoverItem, that._findRootParent(hoverItem));
	                    }
	                }
	            } else if (key == keys.TAB) {
	                target = that._findRootParent(hoverItem);
	                that._moveHover(hoverItem, target);
	                that._checkActiveElement();
	                return;
	            }

	            if (target && target[0]) {
	                e.preventDefault();
	                e.stopPropagation(); // needed to handle ESC in column menu only when a root item is focused
	            }
	        },

	        _hoverItem: function() {
	            return this.wrapper.find(".k-item.k-state-hover,.k-item.k-state-focused").filter(":visible");
	        },

	        _itemBelongsToVertival: function (item) {
	            var menuIsVertical = this.wrapper.hasClass("k-menu-vertical");

	            if (!item.length) {
	                return menuIsVertical;
	            }
	            return item.parent().hasClass("k-menu-group") || menuIsVertical;
	        },

	        _itemHasChildren: function (item) {
	            if (!item || !item.length || !item[0].nodeType) {
	                return false;
	            }
	            return item.children(".k-menu-group, div.k-animation-container").length > 0 ||
	                (!!item.data(POPUP_OPENER_ATTR) && !!this._overflowWrapper().children(popupGroupSelector(item.data(POPUP_OPENER_ATTR))));
	        },

	        _moveHover: function (item, nextItem) {
	            var that = this,
	                id = that._ariaId;

	            if (item.length && nextItem.length) {
	                item.removeClass(FOCUSEDSTATE);
	            }

	            if (nextItem.length) {
	                if (nextItem[0].id) {
	                    id = nextItem[0].id;
	                }

	                nextItem.addClass(FOCUSEDSTATE);
	                that._oldHoverItem = nextItem;

	                if (id) {
	                    that.element.removeAttr("aria-activedescendant");
	                    $("#" + id).removeAttr("id");
	                    nextItem.attr("id", id);
	                    that.element.attr("aria-activedescendant", id);
	                }
	                that._scrollToItem(nextItem);
	            }
	        },

	        _findRootParent: function (item) {
	            if (this._isRootItem(item)) {
	                return item;
	            } else {
	                return this._parentsUntil(item, menuSelector, "li.k-item").last();
	            }
	        },

	        _isRootItem: function (item) {
	            return item.parent().hasClass(MENU);
	        },

	        _itemRight: function (item, belongsToVertical, hasChildren) {
	            var that = this,
	                nextItem,
	                parentItem,
	                overflowWrapper;

	            if (!belongsToVertical) {
	                nextItem = item.nextAll(nextSelector);
	                if (!nextItem.length) {
	                    nextItem = item.prevAll(lastSelector);
	                }
	                that.close(item);
	            } else if (hasChildren && !item.hasClass(DISABLEDSTATE)) {
	                that.open(item);
	                nextItem = that._childPopupElement(item).children().first();
	            } else if (that.options.orientation == "horizontal") {
	                parentItem = that._findRootParent(item);
	                overflowWrapper = that._overflowWrapper();
	                if (overflowWrapper) {
	                    var rootPopup = itemPopup(parentItem, overflowWrapper);
	                    that._closeChildPopups(rootPopup);
	                }
	                that.close(parentItem);
	                nextItem = parentItem.nextAll(nextSelector);
	            }

	            if (nextItem && !nextItem.length) {
	                nextItem = that.wrapper.children(".k-item").first();
	            } else if (!nextItem) {
	                nextItem = [];
	            }

	            that._moveHover(item, nextItem);
	            return nextItem;
	        },

	        _itemLeft: function (item, belongsToVertical) {
	            var that = this,
	                nextItem,
	                overflowWrapper;

	            if (!belongsToVertical) {
	                nextItem = item.prevAll(nextSelector);
	                if (!nextItem.length) {
	                    nextItem = item.nextAll(lastSelector);
	                }
	                that.close(item);
	            } else {
	                nextItem = item.parent().closest(".k-item");
	                overflowWrapper = that._overflowWrapper();
	                if (!nextItem.length && overflowWrapper) {
	                    nextItem = popupParentItem(item.parent(), overflowWrapper);
	                }
	                that.close(nextItem);
	                if (that._isRootItem(nextItem) && that.options.orientation == "horizontal") {
	                    nextItem = nextItem.prevAll(nextSelector);
	                }
	            }

	            if (!nextItem.length) {
	                nextItem = that.wrapper.children(".k-item").last();
	            }

	            that._moveHover(item, nextItem);
	            return nextItem;
	        },

	        _itemDown: function (item, belongsToVertical, hasChildren) {
	            var that = this,
	                nextItem;

	            if (!belongsToVertical) {
	                if (!hasChildren || item.hasClass(DISABLEDSTATE)) {
	                    return;
	                } else {
	                    that.open(item);
	                    nextItem = that._childPopupElement(item).children().first();
	                }
	            } else {
	                nextItem = item.nextAll(nextSelector);
	            }

	            if (!nextItem.length && item.length) {
	                nextItem = item.parent().children().first();
	            } else if (!item.length) {
	                nextItem = that.wrapper.children(".k-item").first();
	            }

	            that._moveHover(item, nextItem);
	            return nextItem;
	        },

	        _itemUp: function (item, belongsToVertical) {
	            var that = this,
	                nextItem;

	            if (!belongsToVertical) {
	                return;
	            } else {
	                nextItem = item.prevAll(nextSelector);
	            }

	            if (!nextItem.length && item.length) {
	                nextItem = item.parent().children().last();
	            } else if (!item.length) {
	                nextItem = that.wrapper.children(".k-item").last();
	            }

	            that._moveHover(item, nextItem);
	            return nextItem;
	        },

	        _scrollToItem: function(item){
	            var that = this;
	            if (that.options.scrollable && item && item.length) {
	                var ul = item.parent();
	                var isHorizontal = ul.hasClass(MENU) ? that.options.orientation == "horizontal" : false;
	                var scrollDir = isHorizontal ? "scrollLeft" : "scrollTop";
	                var getSize = isHorizontal ? kendo._outerWidth : kendo._outerHeight;
	                var currentScrollOffset = ul[scrollDir]();
	                var itemSize = getSize(item);
	                var itemOffset = item[0][isHorizontal ? "offsetLeft" : "offsetTop"];
	                var ulSize = getSize(ul);
	                var scrollButtons = ul.siblings(scrollButtonSelector);
	                var scrollButtonSize = scrollButtons.length ? getSize(scrollButtons.first()) : 0;
	                var itemPosition;

	                if (currentScrollOffset + ulSize < itemOffset + itemSize + scrollButtonSize) {
	                    itemPosition = itemOffset + itemSize - ulSize + scrollButtonSize;
	                } else if (currentScrollOffset > itemOffset - scrollButtonSize) {
	                    itemPosition = itemOffset - scrollButtonSize;
	                }

	                if (!isNaN(itemPosition)) {
	                    var scrolling = {};
	                    scrolling[scrollDir] = itemPosition;
	                    ul.finish().animate(scrolling, "fast", "linear", function () {
	                        that._toggleScrollButtons(ul, scrollButtons.first(), scrollButtons.last(), isHorizontal);
	                    });
	                }
	            }
	        },

	        _itemEsc: function (item, belongsToVertical) {
	            var that = this,
	                nextItem;

	            if (!belongsToVertical) {
	                return item;
	            } else {
	                nextItem = item.parent().closest(".k-item");
	                that.close(nextItem);
	                that._moveHover(item, nextItem);
	            }

	            return nextItem;
	        },

	        _childPopupElement: function(item) {
	            var popupElement = item.find(".k-menu-group");
	            var wrapper = this._overflowWrapper();
	            if (!popupElement.length && wrapper) {
	                popupElement = itemPopup(item, wrapper);
	            }
	            return popupElement;
	        },

	        _triggerEvent: function(e) {
	            var that = this;

	            return that.trigger(e.type, { type: e.type, item: e.item });
	        },

	        _focusHandler: function (e) {
	            var that = this,
	                item = $(kendo.eventTarget(e)).closest(allItemsSelector);

	            if (item.hasClass(DISABLEDSTATE)) {
	                return;
	            }

	            setTimeout(function () {
	                that._moveHover([], item);
	                if (item.children(".k-content")[0]) {
	                    item.parent().closest(".k-item").removeClass(FOCUSEDSTATE);
	                }
	            }, 200);
	        },

	        _animations: function(options) {
	            if (options && ("animation" in options) && !options.animation) {
	                options.animation = { open: { effects: {} }, close: { hide: true, effects: {} } };
	            }
	        },
	        _dataSource: function(options) {
	            var that = this,
	                dataSource = options ? options.dataSource : that.options.dataSource;

	            if (!dataSource) {
	                return;
	            }

	            dataSource = isArray(dataSource) ? { data: dataSource } : dataSource;

	            that._unbindDataSource();

	            if (!dataSource.fields) {
	                dataSource.fields = [
	                    { field: "uid" },
	                    { field: "text" },
	                    { field: "url" },
	                    { field: "cssClass" },
	                    { field: "spriteCssClass" },
	                    { field: "imageUrl" },
	                    { field: "imageAttr" },
	                    { field: "attr" },
	                    { field: "contentAttr" },
	                    { field: "content" },
	                    { field: "encoded" },
	                    { field: "items" },
	                    { field: "select" }
	                ];
	            }

	            that.dataSource = HierarchicalDataSource.create(dataSource);

	            that._bindDataSource();

	            that.dataSource.fetch();
	        },

	        _bindDataSource: function() {
	            this._refreshHandler = proxy(this.refresh, this);
	            this._errorHandler = proxy(this._error, this);

	            this.dataSource.bind(CHANGE, this._refreshHandler);
	            this.dataSource.bind(ERROR, this._errorHandler);
	        },

	        _unbindDataSource: function() {
	            var dataSource = this.dataSource;

	            if (dataSource) {
	                dataSource.unbind(CHANGE, this._refreshHandler);
	                dataSource.unbind(ERROR, this._errorHandler);
	            }
	        },

	        _error: function () {

	        },

	        findByUid: function (uid) {
	            var wrapperElement = this._overflowWrapper() || this.element;
	            return wrapperElement.find("[" + kendo.attr("uid") + "=" + uid + "]");
	        },

	        refresh: function (ev) {
	            var that = this;
	            var node = ev.node;
	            var action = ev.action;
	            var parentElement = node ? that.findByUid(node.uid) : that.element;
	            var itemsToUpdate = ev.items;
	            var index = ev.index;
	            var updateProxy = $.proxy(that._updateItem, that);
	            var removeProxy = $.proxy(that._removeItem, that);

	            if (action == "add") {
	                that._appendItems(itemsToUpdate, index, parentElement);
	            } else if (action == "remove") {
	                itemsToUpdate.forEach(removeProxy);
	            } else if (action == "itemchange") {
	                itemsToUpdate.forEach(updateProxy);
	            } else if (action === "itemloaded") {
	                that.append(ev.items, parentElement);
	            } else {
	                this._initData();
	            }

	            this.trigger(DATABOUND, { item: parentElement, dataItem: node });
	        },

	        _appendItems: function(items, index, parent) {
	            var that = this;
	            var referenceItem = parent.find(itemSelector).eq(index);

	            if(referenceItem.length){
	                that.insertBefore(items, referenceItem);
	            } else {
	                that.append(items, parent);
	            }
	        },

	        _removeItem: function(item) {
	            var that = this;
	            var element = that.findByUid(item.uid);
	            that.remove(element);
	        },

	        _updateItem: function(item) {
	            var that = this;
	            var element = that.findByUid(item.uid);
	            var nextElement = element.next();
	            var parentNode = item.parentNode();

	            that.remove(element);

	            if(nextElement.length) {
	                that.insertBefore(item, nextElement);
	            } else {
	                that.append(item, parentNode && that.findByUid(parentNode.uid));
	            }
	        },

	        _accessors: function() {
	            var that = this,
	                options = that.options,
	                i, field, textField,
	                element = that.element;

	            for (i in bindings) {
	                field = options[bindings[i]];
	                textField = element.attr(kendo.attr(i + "-field"));

	                if (!field && textField) {
	                    field = textField;
	                }

	                if (!field) {
	                    field = i;
	                }

	                if (!isArray(field)) {
	                    field = [field];
	                }

	                options[bindings[i]] = field;
	            }
	        },

	        _fieldAccessor: function(fieldName) {
	            var fieldBindings = this.options[bindings[fieldName]] || [],
	                count = fieldBindings.length,
	                result = "(function(item) {";

	            if (count === 0) {
	                result += "return item['" + fieldName + "'];";
	            } else {
	                result += "var levels = [" +
	                            $.map(fieldBindings, function(x) {
	                                return "function(d){ return " + kendo.expr(x) + "}";
	                            }).join(",") + "];";
	                result += "if(item.level){return levels[Math.min(item.level(), " + count + "-1)](item);}else";
	                result += "{return levels["+ count + "-1](item)}";
	            }

	            result += "})";

	            return result;
	        },

	        _templates: function () {
	            var that = this,
	                options = that.options,
	                fieldAccessor = proxy(that._fieldAccessor, that);

	            if (options.template && typeof options.template == STRING) {
	                    options.template = template(options.template);
	            } else if (!options.template) {
	                    options.template = template(
	                    "# var text = " + fieldAccessor("text") + "(data.item); #" +
	                    "# if (typeof data.item.encoded != 'undefined' && data.item.encoded === false) {#" +
	                        "#= text #" +
	                    "# } else { #" +
	                        "#: text #" +
	                    "# } #"
	                );
	            }

	            that.templates = {
	                content: template(
	                    "#var contentHtml = " + fieldAccessor("content") + "(item);#" +
	                    "<div #= contentCssAttributes(item.toJSON ? item.toJSON() : item) # tabindex='-1'>#= contentHtml || '' #</div>"
	                ),
	                group: template(
	                    "<ul class='#= groupCssClass(group) #'#= groupAttributes(group) # role='menu' aria-hidden='true'>" +
	                        "#= renderItems(data) #" +
	                    "</ul>"
	                ),
	                itemWrapper: template(
	                    "# var url = " + fieldAccessor("url") + "(item); #" +
	                    "# var imageUrl = " + fieldAccessor("imageUrl") + "(item); #" +
	                    "# var imgAttributes = " + fieldAccessor("imageAttr") + "(item);#" +
	                    "# var tag = url ? 'a' : 'span' #" +
	                    "<#= tag # class='#= textClass(item) #' #if(url){#href='#= url #'#}#>" +

	                    "# if (imageUrl) { #" +
	                              "<img #= imageCssAttributes(imgAttributes) #  alt='' src='#= imageUrl #' />" +
	                    "# } #" +

	                    "#= sprite(item) ##= data.menu.options.template(data) #" +
	                        "#= arrow(data) #" +
	                    "</#= tag #>"
	                ),
	                item: template(
	                    "#var contentHtml = " + fieldAccessor("content") + "(item);#" +
	                    "<li class='#= wrapperCssClass(group, item) #' #= itemCssAttributes(item.toJSON ? item.toJSON() : item) # role='menuitem'  #=item.items ? \"aria-haspopup='true'\": \"\"#" +
	                        "#=item.enabled === false ? \"aria-disabled='true'\" : ''#" +
	                        kendo.attr("uid") + "='#= item.uid #' >" +
	                        "#= itemWrapper(data) #" +
	                        "#if (item.hasChildren || item.items) { #" +
	                        "#= subGroup({ items: item.items, menu: menu, group: { expanded: item.expanded } }) #" +
	                        "# } else if (item.content || item.contentUrl || contentHtml) { #" +
	                        "#= renderContent(data) #" +
	                        "# } #" +
	                    "</li>"
	                ),
	                scrollButton: template(
	                    "<span class='k-button k-button-icon k-menu-scroll-button k-scroll-#= direction #' unselectable='on'>" +
	                    "<span class='k-icon k-i-arrow-60-#= direction #'></span></span>"
	                ),
	                arrow: template("<span class='#= arrowClass(item, group) #'></span>"),
	                sprite: template("# var spriteCssClass = " + fieldAccessor("spriteCssClass") + "(data); if(spriteCssClass) {#<span class='k-sprite #= spriteCssClass #'></span>#}#"),
	                empty: template("")
	            };
	        },

	        renderItem: function (options) {
	            var that = this;
	            options = extend({ menu: that, group: {} }, options);

	            var empty = that.templates.empty,
	                item = options.item;

	            return that.templates.item(extend(options, {
	                sprite: that.templates.sprite,
	                itemWrapper: that.templates.itemWrapper,
	                renderContent: that.renderContent,
	                arrow: item.items || item.content || item[that.options.dataContentField[0]] ? that.templates.arrow : empty,
	                subGroup: that.renderGroup
	            }, rendering));
	        },

	        renderGroup: function (options) {
	            var that = this;
	            var templates = that.templates || options.menu.templates;

	            return templates.group(extend({
	                renderItems: function(options) {
	                    var html = "",
	                        i = 0,
	                        items = options.items,
	                        len = items ? items.length : 0,
	                        group = extend({ length: len }, options.group);

	                    for (; i < len; i++) {
	                        html += options.menu.renderItem(extend(options, {
	                            group: group,
	                            item: extend({ index: i }, items[i])
	                        }));
	                    }

	                    return html;
	                }
	            }, options, rendering));
	        },

	        renderContent: function (options) {
	            return options.menu.templates.content(extend(options, rendering));
	        }
	    });

	    var ContextMenu = Menu.extend({
	        init: function(element, options) {
	            var that = this;

	            Menu.fn.init.call(that, element, options);

	            that._marker = kendo.guid().substring(0, 8);

	            that.target = $(that.options.target);

	            that._popup();
	            that._wire();
	        },

	        _initOverflow: function(options){
	            var that = this;
	            if (options.scrollable && !that._overflowWrapper()) {
	                that._openedPopups = {};

	                that._popupsWrapper = (that.element.parent().is(animationContainerSelector) ? that.element.parent() : that.element)
	                    .wrap("<div class='k-popups-wrapper " + options.orientation + "'></div>").parent();

	                if (that.options.orientation == "horizontal") {
	                    removeSpacesBetweenItems(that.element);
	                }

	                if (options.appendTo) {
	                    options.appendTo = $(options.appendTo);
	                    options.appendTo.append(that._popupsWrapper);
	                }

	                that._initialHeight = that.element[0].style.height;
	                that._initialWidth = that.element[0].style.width;
	            }
	        },

	        options: {
	            name: "ContextMenu",
	            filter: null,
	            showOn: "contextmenu",
	            orientation: "vertical",
	            alignToAnchor: false,
	            copyAnchorStyles : true,
	            target: "body"
	        },

	        events: [
	            OPEN,
	            CLOSE,
	            ACTIVATE,
	            DEACTIVATE,
	            SELECT
	        ],

	        setOptions: function(options) {
	            var that = this;

	            Menu.fn.setOptions.call(that, options);

	            that.target.off(that.showOn + NS + that._marker, that._showProxy);

	            if (that.userEvents) {
	                that.userEvents.destroy();
	            }

	            that.target = $(that.options.target);
	            if (options.orientation && that.popup.wrapper[0]) {
	                that.popup.element.unwrap();
	            }

	            that._wire();

	            Menu.fn.setOptions.call(this, options);
	        },

	        destroy: function() {
	            var that = this;

	            that.target.off(that.options.showOn + NS + that._marker);
	            DOCUMENT_ELEMENT.off(kendo.support.mousedown + NS + that._marker, that._closeProxy);

	            if (that.userEvents) {
	                that.userEvents.destroy();
	            }

	            Menu.fn.destroy.call(that);
	        },

	        open: function(x, y) {
	            var that = this;

	            x = $(x)[0];

	            if (contains(that.element[0], $(x)[0]) || that._itemHasChildren($(x))) { // call parent open for children elements
	                Menu.fn.open.call(that, x);
	            } else {
	                if (that._triggerEvent({ item: that.element, type: OPEN }) === false) {
	                    if (that.popup.visible() && that.options.filter) {
	                        that.popup.close(true);
	                        that.popup.element.kendoStop(true);
	                    }

	                    if (y !== undefined) {
	                        var overflowWrapper = that._overflowWrapper();
	                        if (overflowWrapper) {
	                            var offset = overflowWrapper.offset();
	                            x -= offset.left;
	                            y -= offset.top;
	                        }
	                        that.popup.wrapper.hide();
	                        that._configurePopupScrolling(x, y);
	                        that.popup.open(x, y);
	                    } else {
	                        that.popup.options.anchor = (x ? x : that.popup.anchor) || that.target;
	                        that.popup.element.kendoStop(true);
	                        that._configurePopupScrolling();
	                        that.popup.open();
	                    }

	                    DOCUMENT_ELEMENT.off(that.popup.downEvent, that.popup._mousedownProxy);
	                    DOCUMENT_ELEMENT
	                        .on(kendo.support.mousedown + NS + that._marker, that._closeProxy);
	                }
	            }

	            return that;
	        },

	        _configurePopupScrolling: function(x, y){
	            var that = this;
	            var popup = that.popup;
	            var isHorizontal = that.options.orientation == "horizontal";

	            if (that.options.scrollable) {
	                that._wrapPopupElement(popup);

	                popup.element.parent().css({
	                    position: "",
	                    height: ""
	                });

	                popup.element.css({
	                    visibility: "hidden",
	                    display: "",
	                    position: ""
	                });

	                if (isHorizontal) {
	                    that._setPopupWidth(popup, isNaN(x) ? undefined : {isFixed: true, x: x, y: y});
	                } else {
	                    that._setPopupHeight(popup, isNaN(x) ? undefined : {isFixed: true, x: x, y: y});
	                }

	                popup.element.css({
	                    visibility: "",
	                    display: "none",
	                    position: "absolute"
	                });

	                that._initPopupScrollButtons(popup, isHorizontal, true);
	                popup.element.siblings(scrollButtonSelector).hide();
	            }
	        },

	        _setPopupWidth: function(popup, isFixed){
	            var popupElement = popup.element;
	            var popups = popupElement.add(popupElement.parent(animationContainerSelector));

	            popups.width(this._initialWidth || "");

	            var location = popup._location(isFixed);
	            var windowWidth = $(window).width();
	            var popupOuterWidth = location.width;
	            var popupOffsetLeft = Math.max(location.left, 0);
	            var scrollLeft = isFixed ? 0 : parentsScroll(this._overflowWrapper()[0], "scrollLeft");
	            var shadow = kendo.getShadows(popupElement);
	            var maxWidth = windowWidth - shadow.left - shadow.right;
	            var canFit = maxWidth + scrollLeft > popupOuterWidth + popupOffsetLeft;

	            if (!canFit) {
	                popups.css({overflow: "hidden", width: (maxWidth - popupOffsetLeft + scrollLeft) + "px"});
	            }
	        },

	        close: function() {
	            var that = this;

	            if (contains(that.element[0], $(arguments[0])[0]) || that._itemHasChildren(arguments[0])) {
	                Menu.fn.close.call(that, arguments[0]);
	            } else {
	                if (that.popup.visible()) {
	                    if (that._triggerEvent({ item: that.element, type: CLOSE }) === false) {
	                        that.popup.close();
	                        DOCUMENT_ELEMENT.off(kendo.support.mousedown + NS + that._marker, that._closeProxy);
	                        that.unbind(SELECT, that._closeTimeoutProxy);
	                    }
	                }
	            }
	        },

	        _showHandler: function (e) {
	            var ev = e, offset,
	                that = this,
	                options = that.options,
	                target = kendo.support.mobileOS ? $(ev.target) : $(ev.currentTarget);

	            if (e.event) {
	                ev = e.event;
	                ev.pageX = e.x.location;
	                ev.pageY = e.y.location;
	            }

	            if (contains(that.element[0], e.relatedTarget || e.target)) {
	                return;
	            }

	            that._eventOrigin = ev;

	            ev.preventDefault();
	            ev.stopImmediatePropagation();

	            that.element.find("." + FOCUSEDSTATE).removeClass(FOCUSEDSTATE);

	            if ((options.filter && target.is(options.filter)) || !options.filter) {
	                if (options.alignToAnchor) {
	                    that.popup.options.anchor = ev.currentTarget;
	                    that.open(ev.currentTarget);
	                } else {
	                    that.popup.options.anchor = ev.currentTarget;

	                    if (that._targetChild) {
	                        offset = that.target.offset();
	                        that.open(ev.pageX - offset.left, ev.pageY - offset.top);
	                    } else {
	                        that.open(ev.pageX, ev.pageY);
	                    }
	                }
	            }
	        },

	        _closeHandler: function (e) {
	            var that = this,
	                target = $(e.relatedTarget || e.target),
	                sameTarget = target.closest(that.target.selector)[0] == that.target[0],
	                item = target.closest(itemSelector),
	                children = that._itemHasChildren(item),
	                overflowWrapper = that._overflowWrapper(),
	                containment = contains(that.element[0], target[0]) || (overflowWrapper && contains(overflowWrapper[0], target[0]));

	            that._eventOrigin = e;

	            var normalClick = e.which !== 3;

	            if (that.popup.visible() && ((normalClick && sameTarget) || !sameTarget) && ((that.options.closeOnClick && !children && containment) || !containment)) {
	                if (containment) {
	                    this.unbind(SELECT, this._closeTimeoutProxy);
	                    that.bind(SELECT, that._closeTimeoutProxy);
	                } else {
	                    that.close();
	                }
	            }
	        },

	        _wire: function() {
	            var that = this,
	                options = that.options,
	                target = that.target;

	            that._preventProxy = null;
	            that._showProxy = proxy(that._showHandler, that);
	            that._closeProxy = proxy(that._closeHandler, that);
	            that._closeTimeoutProxy = proxy(that.close, that);

	            if (target[0]) {
	                if (kendo.support.mobileOS && options.showOn == "contextmenu") {
	                    that.userEvents = new kendo.UserEvents(target, {
	                        filter: options.filter,
	                        allowSelection: false
	                    });

	                    that._preventProxy = function() { return false; };

	                    that.userEvents.bind("hold", that._showProxy);
	                }

	                if (options.filter) {
	                    target.on(options.showOn + NS + that._marker, options.filter, that._preventProxy || that._showProxy);
	                } else {
	                    target.on(options.showOn + NS + that._marker, that._preventProxy || that._showProxy);
	                }
	            }
	        },

	        _triggerEvent: function(e) {
	            var that = this,
	                anchor = $(that.popup.options.anchor)[0],
	                origin = that._eventOrigin;

	            that._eventOrigin = undefined;

	            return that.trigger(e.type, extend({ type: e.type, item: e.item || this.element[0], target: anchor }, origin ? { event: origin } : {} ));
	        },

	        _popup: function() {
	            var that = this;
	            var overflowWrapper = that._overflowWrapper();

	            that._triggerProxy = proxy(that._triggerEvent, that);

	            that.popup = that.element
	                            .addClass("k-context-menu")
	                            .kendoPopup({
	                                autosize: that.options.orientation === "horizontal",
	                                anchor: that.target || "body",
	                                copyAnchorStyles: that.options.copyAnchorStyles,
	                                collision: that.options.popupCollision || "fit",
	                                animation: that.options.animation,
	                                activate: that._triggerProxy,
	                                deactivate: that._triggerProxy,
	                                appendTo: overflowWrapper || that.options.appendTo,
	                                close: !overflowWrapper ? $.noop : function(e) {
	                                    $(getChildPopups(e.sender.element, overflowWrapper)).each(function(i, p) {
	                                        var popup = p.data(KENDOPOPUP);
	                                        if (popup) {
	                                            popup.close(true);
	                                        }
	                                    });
	                                }
	                            }).data(KENDOPOPUP);

	            that._targetChild = contains(that.target[0], that.popup.element[0]);
	        }
	    });

	    ui.plugin(Menu);
	    ui.plugin(ContextMenu);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "askF":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1129);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1045:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FTkt");

/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1069:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("jBxA");

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FZAa");

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1059), __webpack_require__(1109), __webpack_require__(1088), __webpack_require__(1069),
	        __webpack_require__(1045),

	       __webpack_require__(1130),
	       __webpack_require__(1131),
	       __webpack_require__(1132),
	       __webpack_require__(1133),
	       __webpack_require__(1134),
	       __webpack_require__(1135)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	    var __meta__ = { // jshint ignore:line
	        id: "dataviz.diagram",
	        name: "Diagram",
	        category: "dataviz",
	        description: "The Kendo DataViz Diagram ",
	        depends: [ "data", "userevents", "mobile.scroller", "draganddrop", "drawing", "dataviz.core", "dataviz.themes", "toolbar" ],
	        features: [{
	            id: "dataviz.diagram-pdf-export",
	            name: "PDF export",
	            description: "Export Diagram as PDF",
	            depends: [ "pdf" ]
	        },{
	            id: "dataviz.diagram-editing",
	            name: "Editing",
	            description: "Support for model editing",
	            depends: [ "editable", "window", "dropdownlist" ]
	        }]
	    };

	    return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1130:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("JHp9");

/***/ }),

/***/ 1131:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("eykn");

/***/ }),

/***/ 1132:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("UZBu");

/***/ }),

/***/ 1133:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("O5Ud");

/***/ }),

/***/ 1134:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("QBqZ");

/***/ }),

/***/ 1135:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7quO");

/***/ })

/******/ });

/***/ }),

/***/ "awzK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: [Array, Number],
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    autoClose: {
        type: Boolean,
        default: undefined
    },
    autoWidth: {
        type: Boolean,
        default: undefined
    },
    clearButton: {
        type: Boolean,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    dataValueField: {
        type: String,
        default: undefined
    },
    delay: {
        type: Number,
        default: undefined
    },
    enable: {
        type: Boolean,
        default: undefined
    },
    enforceMinLength: {
        type: Boolean,
        default: undefined
    },
    filter: {
        type: String,
        default: undefined
    },
    fixedGroupTemplate: {
        type: [String, Function],
        default: undefined
    },
    footerTemplate: {
        type: [String, Function],
        default: undefined
    },
    groupTemplate: {
        type: [String, Function],
        default: undefined
    },
    height: {
        type: Number,
        default: undefined
    },
    highlightFirst: {
        type: Boolean,
        default: undefined
    },
    ignoreCase: {
        type: Boolean,
        default: undefined
    },
    minLength: {
        type: Number,
        default: undefined
    },
    maxSelectedItems: {
        type: Number,
        default: undefined
    },
    noDataTemplate: {
        type: [String, Function],
        default: undefined
    },
    placeholder: {
        type: String,
        default: undefined
    },
    popup: {
        type: Object,
        default: undefined
    },
    headerTemplate: {
        type: [String, Function],
        default: undefined
    },
    itemTemplate: {
        type: [String, Function],
        default: undefined
    },
    tagTemplate: {
        type: [String, Function],
        default: undefined
    },
    tagMode: {
        type: String,
        default: undefined
    },
    value: {
        type: [Array, Number],
        default: undefined
    },
    valuePrimitive: {
        type: Boolean,
        default: undefined
    },
    virtual: {
        type: [Boolean, Object],
        default: undefined
    },

    // Events
    change: Function,
    close: Function,
    dataBound: {
        type: Function,
        default: undefined
    },
    filtering: Function,
    open: Function,
    select: Function,
    deselect: Function
};

/***/ }),

/***/ "ax3d":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("e8AB")('keys');
var uid = __webpack_require__("3Eo+");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "b8bx":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(952);
	module.exports = __webpack_require__(952);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 945:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("KBs5");

/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(953), __webpack_require__(945) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {

	    var NS = ".kendo";
	    var kendo = window.kendo;
	    var deepExtend = kendo.deepExtend;
	    var utils = kendo.drawing.util;
	    var defined = utils.defined;
	    var limitValue = utils.limitValue;
	    var eventCoordinates = utils.eventCoordinates;
	    var outerWidth = kendo._outerWidth;
	    var outerHeight = kendo._outerHeight;
	    var proxy = $.proxy;

	    var TOOLTIP_TEMPLATE = '<div class="k-tooltip">' +
	            '<div class="k-tooltip-content"></div>' +
	        '</div>';
	    var TOOLTIP_CLOSE_TEMPLATE = '<div class="k-tooltip-button"><a href="\\#" class="k-icon k-i-close">close</a></div>';

	    var SurfaceTooltip = kendo.Class.extend({
	        init: function(surface, options) {
	            this.element = $(TOOLTIP_TEMPLATE);
	            this.content = this.element.children(".k-tooltip-content");

	            options = options || {};

	            this.options = deepExtend({}, this.options, this._tooltipOptions(options));
	            this.popupOptions = {
	                appendTo: options.appendTo,
	                animation: options.animation,
	                copyAnchorStyles: false,
	                collision: "fit fit"
	            };

	            this._openPopupHandler = $.proxy(this._openPopup, this);

	            this.surface = surface;
	            this._bindEvents();
	        },

	        options: {
	            position: "top",
	            showOn: "mouseenter",
	            offset: 7,
	            autoHide: true,
	            hideDelay: 0,
	            showAfter: 100
	        },

	        _bindEvents: function() {
	            this._showHandler = proxy(this._showEvent, this);
	            this._surfaceLeaveHandler = proxy(this._surfaceLeave, this);
	            this._mouseleaveHandler = proxy(this._mouseleave, this);
	            this._mousemoveHandler = proxy(this._mousemove, this);

	            this.surface.bind("click", this._showHandler);
	            this.surface.bind("mouseenter", this._showHandler);
	            this.surface.bind("mouseleave", this._mouseleaveHandler);
	            this.surface.bind("mousemove", this._mousemoveHandler);

	            this.surface.element.on("mouseleave" + NS, this._surfaceLeaveHandler);

	            this.element.on("click" + NS, ".k-tooltip-button", proxy(this._hideClick, this));
	            this.element.on("mouseleave" + NS, proxy(this._tooltipLeave, this));
	        },

	        getPopup: function() {
	            if (!this.popup) {
	                this.popup = new kendo.ui.Popup(this.element, this.popupOptions);
	            }

	            return this.popup;
	        },

	        destroy: function() {
	            var popup = this.popup;

	            this.surface.unbind("click", this._showHandler);
	            this.surface.unbind("mouseenter", this._showHandler);
	            this.surface.unbind("mouseleave", this._mouseleaveHandler);
	            this.surface.unbind("mousemove", this._mousemoveHandler);

	            this.surface.element.off("mouseleave" + NS, this._surfaceLeaveHandler);
	            this.element.off("click" + NS);
	            this.element.off("mouseleave" + NS);

	            if (popup) {
	                popup.destroy();
	                delete this.popup;
	            }
	            delete this.popupOptions;

	            clearTimeout(this._timeout);

	            delete this.element;
	            delete this.content;
	            delete this.surface;
	        },

	        _tooltipOptions: function(options) {
	            options = options || {};
	            return {
	                position: options.position,
	                showOn: options.showOn,
	                offset: options.offset,
	                autoHide: options.autoHide,
	                width: options.width,
	                height: options.height,
	                content: options.content,
	                shared: options.shared,
	                hideDelay: options.hideDelay,
	                showAfter: options.showAfter
	            };
	        },

	        _tooltipShape: function(shape) {
	            while(shape && !shape.options.tooltip) {
	                shape = shape.parent;
	            }
	            return shape;
	        },

	        _updateContent: function(target, shape, options) {
	            var content = options.content;
	            if (kendo.isFunction(content)) {
	                content = content({
	                    element: shape,
	                    target: target
	                });
	            }

	            if (content) {
	                this.content.html(content);
	                return true;
	            }
	        },

	        _position: function(shape, options, elementSize, event) {
	            var position = options.position;
	            var tooltipOffset = options.offset || 0;
	            var surface = this.surface;
	            var offset = surface._instance._elementOffset();
	            var size = surface.getSize();
	            var surfaceOffset = surface._instance._offset;
	            var bbox = shape.bbox();
	            var width = elementSize.width;
	            var height = elementSize.height;
	            var left = 0, top = 0;

	            bbox.origin.translate(offset.left, offset.top);
	            if (surfaceOffset) {
	                bbox.origin.translate(-surfaceOffset.x, -surfaceOffset.y);
	            }

	            if (position == "cursor" && event) {
	                var coord = eventCoordinates(event);
	                left = coord.x - width / 2;
	                top = coord.y - height - tooltipOffset;
	            } else if (position == "left") {
	                left = bbox.origin.x - width - tooltipOffset;
	                top = bbox.center().y - height / 2;
	            } else if (position == "right") {
	                left = bbox.bottomRight().x + tooltipOffset;
	                top = bbox.center().y - height / 2;
	            } else if (position == "bottom") {
	                left = bbox.center().x - width / 2;
	                top = bbox.bottomRight().y + tooltipOffset;
	            } else {
	                left = bbox.center().x - width / 2;
	                top = bbox.origin.y - height - tooltipOffset;
	            }

	            return {
	                left: limitValue(left, offset.left, offset.left + size.width),
	                top: limitValue(top, offset.top, offset.top + size.height)
	            };
	        },

	        show: function(shape, options) {
	            this._show(shape, shape, deepExtend({}, this.options, this._tooltipOptions(shape.options.tooltip), options));
	        },

	        hide: function() {
	            var popup = this.popup;
	            var current = this._current;

	            delete this._current;
	            clearTimeout(this._showTimeout);
	            if (popup && popup.visible() && current &&
	                !this.surface.trigger("tooltipClose", { element: current.shape, target: current.target, popup: popup})) {
	                popup.close();
	            }
	        },

	        _hideClick: function(e) {
	            e.preventDefault();
	            this.hide();
	        },

	        _show: function(target, shape, options, event, delay) {
	            var current = this._current;

	            clearTimeout(this._timeout);

	            if (current && ((current.shape === shape && options.shared) || current.target === target)) {
	                return;
	            }

	            clearTimeout(this._showTimeout);

	            var popup = this.getPopup();

	            if (!this.surface.trigger("tooltipOpen", { element: shape, target: target, popup: popup }) &&
	                this._updateContent(target, shape, options)) {

	                this._autoHide(options);
	                var elementSize = this._measure(options);

	                if (popup.visible()) {
	                    popup.close(true);
	                }

	                this._current = {
	                    options: options,
	                    elementSize: elementSize,
	                    shape: shape,
	                    target: target,
	                    position: this._position(options.shared ? shape: target, options, elementSize, event)
	                };

	                if (delay) {
	                    this._showTimeout = setTimeout(this._openPopupHandler, options.showAfter || 0);
	                } else {
	                    this._openPopup();
	                }
	            }
	        },

	        _openPopup: function() {
	            var current = this._current;
	            var position = current.position;

	            this.getPopup().open(position.left, position.top);
	        },

	        _autoHide: function(options) {
	            if (options.autoHide && this._closeButton) {
	                this.element.removeClass("k-tooltip-closable");
	                this._closeButton.remove();
	                delete this._closeButton;
	            }

	            if (!options.autoHide && !this._closeButton) {
	                this.element.addClass("k-tooltip-closable");
	                this._closeButton = $(TOOLTIP_CLOSE_TEMPLATE).appendTo(this.element);
	            }
	        },

	        _showEvent: function(e) {
	            var shape = this._tooltipShape(e.element);

	            if (shape) {
	                var options = deepExtend({}, this.options, this._tooltipOptions(shape.options.tooltip));

	                if (options && options.showOn == e.type) {
	                    this._show(e.element, shape, options, e.originalEvent, true);
	                }
	            }
	        },

	        _measure: function(options) {
	            var popup = this.getPopup();
	            var width, height;
	            this.element.css({
	                width: "auto",
	                height: "auto"
	            });
	            var visible = popup.visible();
	            if (!visible) {
	                popup.wrapper.show();
	            }

	            this.element.css({
	                width: defined(options.width) ? options.width : "auto",
	                height: defined(options.height) ? options.height : "auto"
	            });

	            width = outerWidth(this.element);
	            height = outerHeight(this.element);

	            if (!visible) {
	                popup.wrapper.hide();
	            }

	            return {
	                width: width,
	                height: height
	            };
	        },

	        _mouseleave: function(e) {
	            if (this.popup && !this._popupRelatedTarget(e.originalEvent)) {
	                var tooltip = this;
	                var current = tooltip._current;

	                if (current && current.options.autoHide) {
	                    tooltip._timeout = setTimeout(function() {
	                        clearTimeout(tooltip._showTimeout);
	                        tooltip.hide();
	                    }, current.options.hideDelay || 0);
	                }
	            }
	        },

	        _mousemove: function(e) {
	            var current = this._current;
	            if (current && e.element) {
	                var options = current.options;
	                if (options.position == "cursor") {
	                    var position = this._position(e.element, options, current.elementSize, e.originalEvent);
	                    current.position = position;
	                    this.getPopup().wrapper.css({left: position.left, top: position.top});
	                }
	            }
	        },

	        _surfaceLeave: function(e) {
	            if (this.popup && !this._popupRelatedTarget(e)) {
	                clearTimeout(this._showTimeout);
	                this.hide();
	            }
	        },

	        _popupRelatedTarget: function(e) {
	            return e.relatedTarget && $(e.relatedTarget).closest(this.popup.wrapper).length;
	        },

	        _tooltipLeave: function() {
	            var tooltip = this;
	            var current = tooltip._current;
	            if (current && current.options.autoHide) {
	                tooltip._timeout = setTimeout(function() {
	                    tooltip.hide();
	                }, current.options.hideDelay || 0);
	            }
	        }
	    });

	    kendo.drawing.SurfaceTooltip = SurfaceTooltip;

	})(window.kendo.jQuery);

	}, __webpack_require__(3));

/***/ }),

/***/ 953:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ })

/******/ });

/***/ }),

/***/ "b9Tm":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1050);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1050:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "appbar",
	    name: "AppBar",
	    category: "web",
	    depends: [ "core"]
	};

	var spacerTemplate = "<span class='k-appbar-spacer'></span>";

	(function($) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        RESIZE = "resize",
	        proxy = $.proxy;

	    var AppBar = Widget.extend( {
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            that.element = $(element).addClass("k-appbar");

	            if (that.options.position != "none") {
	                that.element.addClass("k-appbar-" + that.options.position);
	            }

	            that.element
	            .addClass("k-appbar-" + that.options.positionMode +
	                      " k-appbar-" + that.options.themeColor);

	            that._initItems();
	            that._attachEvents();
	        },

	        events: [
	            RESIZE
	        ],

	        options: {
	            name: "AppBar",
	            positionMode: "static",
	            position: "none",
	            themeColor: "light",
	            items: []
	        },

	        destroy: function() {
	            if (this.resizeHandler) {
	                kendo.unbindResize(this.resizeHandler);
	                this.resizeHandler = null;
	            }
	            Widget.fn.destroy.call(this);
	        },

	        setOptions: function(options) {
	            var that = this;

	            if (that.options.position != "none") {
	                that.element.removeClass("k-appbar-" + that.options.position);
	            }

	            that.element
	                .removeClass("k-appbar-" + that.options.positionMode +
	                      " k-appbar-" + that.options.themeColor);

	            kendo.deepExtend(that.options, options);
	            this.destroy();
	            this.element.empty();
	            this.init(this.element, this.options);
	        },

	        _initItems: function () {
	            var that = this;
	            var options = that.options;
	            var items = options.items;
	            var item;
	            var html = "";
	            var separator;

	            for (var i = 0; i < items.length; i++) {
	                item = items[i];

	                if (item.type == "spacer") {
	                    separator = $(kendo.template(spacerTemplate)({})).addClass(item.className);
	                    if (item.width) {
	                        separator.addClass("k-appbar-spacer-sized");
	                        separator.css("width", typeof item.width === "string" ? item.width : item.width + "px");
	                    }
	                    html += separator[0].outerHTML;
	                } else {
	                    if (!item.template) {
	                        throw new Error("Having a template for the contentItem is mandatory");
	                    }
	                    if (item.className) {
	                        html += "<div class='k-appbar-section " + item.className + "'>";
	                    } else {
	                        html += "<div class='k-appbar-section'>";
	                    }
	                    html += kendo.template(item.template)({});
	                    html += "</div>";
	                }
	            }

	            that.element.html(html);
	        },

	        _resize: function () {
	            this.trigger(RESIZE);
	        },

	        _attachEvents: function () {
	            var that = this;

	            that.resizeHandler = proxy(that._resize, that);

	            kendo.onResize(that.resizeHandler);
	        }
	    });

	    ui.plugin(AppBar);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "b9np":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var columnApi_1 = __webpack_require__("E/Wy");
var columnController_1 = __webpack_require__("77lH");
var rowRenderer_1 = __webpack_require__("3RUv");
var filterManager_1 = __webpack_require__("Up6z");
var eventService_1 = __webpack_require__("k5uU");
var gridPanel_1 = __webpack_require__("inOk");
var logger_1 = __webpack_require__("U9Xd");
var constants_1 = __webpack_require__("ZZFX");
var popupService_1 = __webpack_require__("LnC7");
var events_1 = __webpack_require__("3ok8");
var utils_1 = __webpack_require__("IRr6");
var borderLayout_1 = __webpack_require__("twlb");
var context_1 = __webpack_require__("RQ1/");
var focusedCellController_1 = __webpack_require__("4Sr9");
var component_1 = __webpack_require__("pQ38");
var paginationComp_1 = __webpack_require__("H9AQ");
var gridApi_1 = __webpack_require__("BAow");
var GridCore = (function () {
    function GridCore(loggerFactory) {
        this.destroyFunctions = [];
        this.logger = loggerFactory.create('GridCore');
    }
    GridCore.prototype.init = function () {
        var _this = this;
        var eSouthPanel = this.createSouthPanel();
        var eastPanel;
        var westPanel;
        if (this.toolPanel && !this.gridOptionsWrapper.isForPrint()) {
            // if we are doing RTL, then the tool panel appears on the left
            if (this.gridOptionsWrapper.isEnableRtl()) {
                westPanel = this.toolPanel.getGui();
            }
            else {
                eastPanel = this.toolPanel.getGui();
            }
        }
        var createTopPanelGui = this.createNorthPanel();
        this.eRootPanel = new borderLayout_1.BorderLayout({
            center: this.gridPanel.getLayout(),
            east: eastPanel,
            west: westPanel,
            north: createTopPanelGui,
            south: eSouthPanel,
            dontFill: this.gridOptionsWrapper.isForPrint(),
            fillHorizontalOnly: this.gridOptionsWrapper.isAutoHeight(),
            name: 'eRootPanel'
        });
        // parts of the CSS need to know if we are in 'for print' mode or not,
        // so we add a class to allow applying CSS based on this.
        if (this.gridOptionsWrapper.isForPrint()) {
            utils_1.Utils.addCssClass(this.eRootPanel.getGui(), 'ag-layout-for-print');
            // kept to limit breaking changes, ag-no-scrolls was renamed to ag-layout-for-print
            utils_1.Utils.addCssClass(this.eRootPanel.getGui(), 'ag-no-scrolls');
        }
        else if (this.gridOptionsWrapper.isAutoHeight()) {
            utils_1.Utils.addCssClass(this.eRootPanel.getGui(), 'ag-layout-auto-height');
        }
        else {
            utils_1.Utils.addCssClass(this.eRootPanel.getGui(), 'ag-layout-normal');
            // kept to limit breaking changes, ag-scrolls was renamed to ag-layout-normal
            utils_1.Utils.addCssClass(this.eRootPanel.getGui(), 'ag-scrolls');
        }
        // see what the grid options are for default of toolbar
        this.showToolPanel(this.gridOptionsWrapper.isShowToolPanel());
        this.eGridDiv.appendChild(this.eRootPanel.getGui());
        // if using angular, watch for quickFilter changes
        if (this.$scope) {
            this.$scope.$watch(this.quickFilterOnScope, function (newFilter) { return _this.filterManager.setQuickFilter(newFilter); });
        }
        if (!this.gridOptionsWrapper.isForPrint()) {
            this.addWindowResizeListener();
        }
        // important to set rtl before doLayout, as setting the RTL class impacts the scroll position,
        // which doLayout indirectly depends on
        this.addRtlSupport();
        this.doLayout();
        this.finished = false;
        this.periodicallyDoLayout();
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onRowGroupChanged.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.onRowGroupChanged.bind(this));
        this.onRowGroupChanged();
        this.logger.log('ready');
    };
    GridCore.prototype.addRtlSupport = function () {
        if (this.gridOptionsWrapper.isEnableRtl()) {
            utils_1.Utils.addCssClass(this.eRootPanel.getGui(), 'ag-rtl');
        }
        else {
            utils_1.Utils.addCssClass(this.eRootPanel.getGui(), 'ag-ltr');
        }
    };
    GridCore.prototype.createNorthPanel = function () {
        var _this = this;
        if (!this.gridOptionsWrapper.isEnterprise()) {
            return null;
        }
        var topPanelGui = document.createElement('div');
        var dropPanelVisibleListener = this.onDropPanelVisible.bind(this);
        this.rowGroupComp = this.rowGroupCompFactory.create();
        this.pivotComp = this.pivotCompFactory.create();
        topPanelGui.appendChild(this.rowGroupComp.getGui());
        topPanelGui.appendChild(this.pivotComp.getGui());
        this.rowGroupComp.addEventListener(component_1.Component.EVENT_VISIBLE_CHANGED, dropPanelVisibleListener);
        this.pivotComp.addEventListener(component_1.Component.EVENT_VISIBLE_CHANGED, dropPanelVisibleListener);
        this.destroyFunctions.push(function () {
            _this.rowGroupComp.removeEventListener(component_1.Component.EVENT_VISIBLE_CHANGED, dropPanelVisibleListener);
            _this.pivotComp.removeEventListener(component_1.Component.EVENT_VISIBLE_CHANGED, dropPanelVisibleListener);
        });
        this.onDropPanelVisible();
        return topPanelGui;
    };
    GridCore.prototype.onDropPanelVisible = function () {
        var bothVisible = this.rowGroupComp.isVisible() && this.pivotComp.isVisible();
        this.rowGroupComp.addOrRemoveCssClass('ag-width-half', bothVisible);
        this.pivotComp.addOrRemoveCssClass('ag-width-half', bothVisible);
    };
    GridCore.prototype.getRootGui = function () {
        return this.eRootPanel.getGui();
    };
    GridCore.prototype.createSouthPanel = function () {
        if (!this.statusBar && this.gridOptionsWrapper.isEnableStatusBar()) {
            console.warn('ag-Grid: status bar is only available in ag-Grid-Enterprise');
        }
        var statusBarEnabled = this.statusBar && this.gridOptionsWrapper.isEnableStatusBar();
        var isPaging = this.gridOptionsWrapper.isPagination();
        var paginationPanelEnabled = isPaging
            && !this.gridOptionsWrapper.isForPrint()
            && !this.gridOptionsWrapper.isSuppressPaginationPanel();
        if (!statusBarEnabled && !paginationPanelEnabled) {
            return null;
        }
        var eSouthPanel = document.createElement('div');
        if (statusBarEnabled) {
            eSouthPanel.appendChild(this.statusBar.getGui());
        }
        if (paginationPanelEnabled) {
            var paginationComp = new paginationComp_1.PaginationComp();
            this.context.wireBean(paginationComp);
            eSouthPanel.appendChild(paginationComp.getGui());
            this.destroyFunctions.push(paginationComp.destroy.bind(paginationComp));
        }
        return eSouthPanel;
    };
    GridCore.prototype.onRowGroupChanged = function () {
        if (!this.rowGroupComp) {
            return;
        }
        var rowGroupPanelShow = this.gridOptionsWrapper.getRowGroupPanelShow();
        if (rowGroupPanelShow === constants_1.Constants.ALWAYS) {
            this.rowGroupComp.setVisible(true);
        }
        else if (rowGroupPanelShow === constants_1.Constants.ONLY_WHEN_GROUPING) {
            var grouping = !this.columnController.isRowGroupEmpty();
            this.rowGroupComp.setVisible(grouping);
        }
        else {
            this.rowGroupComp.setVisible(false);
        }
        this.eRootPanel.doLayout();
    };
    GridCore.prototype.addWindowResizeListener = function () {
        var eventListener = this.doLayout.bind(this);
        window.addEventListener('resize', eventListener);
        this.destroyFunctions.push(function () { return window.removeEventListener('resize', eventListener); });
    };
    GridCore.prototype.periodicallyDoLayout = function () {
        var _this = this;
        if (!this.finished) {
            var intervalMillis = this.gridOptionsWrapper.getLayoutInterval();
            // if interval is negative, this stops the layout from happening
            if (intervalMillis > 0) {
                this.frameworkFactory.setTimeout(function () {
                    _this.doLayout();
                    _this.gridPanel.periodicallyCheck();
                    _this.periodicallyDoLayout();
                }, intervalMillis);
            }
            else {
                // if user provided negative number, we still do the check every 5 seconds,
                // in case the user turns the number positive again
                this.frameworkFactory.setTimeout(function () {
                    _this.periodicallyDoLayout();
                }, 5000);
            }
        }
    };
    GridCore.prototype.showToolPanel = function (show) {
        if (show && !this.toolPanel) {
            console.warn('ag-Grid: toolPanel is only available in ag-Grid Enterprise');
            this.toolPanelShowing = false;
            return;
        }
        this.toolPanelShowing = show;
        if (this.toolPanel) {
            this.toolPanel.setVisible(show);
            this.eRootPanel.doLayout();
        }
    };
    GridCore.prototype.isToolPanelShowing = function () {
        return this.toolPanelShowing;
    };
    GridCore.prototype.destroy = function () {
        this.finished = true;
        this.eGridDiv.removeChild(this.eRootPanel.getGui());
        this.logger.log('Grid DOM removed');
        this.destroyFunctions.forEach(function (func) { return func(); });
    };
    // Valid values for position are bottom, middle and top
    GridCore.prototype.ensureNodeVisible = function (comparator, position) {
        if (position === void 0) { position = 'top'; }
        if (this.doingVirtualPaging) {
            throw 'Cannot use ensureNodeVisible when doing virtual paging, as we cannot check rows that are not in memory';
        }
        // look for the node index we want to display
        var rowCount = this.rowModel.getPageLastRow() + 1;
        var comparatorIsAFunction = typeof comparator === 'function';
        var indexToSelect = -1;
        // go through all the nodes, find the one we want to show
        for (var i = 0; i < rowCount; i++) {
            var node = this.rowModel.getRow(i);
            if (comparatorIsAFunction) {
                if (comparator(node)) {
                    indexToSelect = i;
                    break;
                }
            }
            else {
                // check object equality against node and data
                if (comparator === node || comparator === node.data) {
                    indexToSelect = i;
                    break;
                }
            }
        }
        if (indexToSelect >= 0) {
            this.gridPanel.ensureIndexVisible(indexToSelect, position);
        }
    };
    GridCore.prototype.doLayout = function () {
        // need to do layout first, as drawVirtualRows and setPinnedColHeight
        // need to know the result of the resizing of the panels.
        var sizeChanged = this.eRootPanel.doLayout();
        // not sure why, this is a hack, but if size changed, it may need to be called
        // again - as the size change can change whether scrolls are visible or not (i think).
        // to see why, take this second 'doLayout' call out, and see example in docs for
        // width & height, the grid will flicker as it doesn't get laid out correctly with
        // one call to doLayout()
        if (sizeChanged) {
            this.eRootPanel.doLayout();
        }
        // both of the two below should be done in gridPanel, the gridPanel should register 'resize' to the panel
        if (sizeChanged) {
            this.rowRenderer.redrawAfterScroll();
            var event_1 = {
                type: events_1.Events.EVENT_GRID_SIZE_CHANGED,
                clientWidth: this.eRootPanel.getGui().clientWidth,
                clientHeight: this.eRootPanel.getGui().clientHeight,
                api: this.gridApi,
                columnApi: this.columnApi
            };
            this.eventService.dispatchEvent(event_1);
        }
    };
    __decorate([
        context_1.Autowired('gridOptions'),
        __metadata("design:type", Object)
    ], GridCore.prototype, "gridOptions", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], GridCore.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('rowModel'),
        __metadata("design:type", Object)
    ], GridCore.prototype, "rowModel", void 0);
    __decorate([
        context_1.Autowired('frameworkFactory'),
        __metadata("design:type", Object)
    ], GridCore.prototype, "frameworkFactory", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], GridCore.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('rowRenderer'),
        __metadata("design:type", rowRenderer_1.RowRenderer)
    ], GridCore.prototype, "rowRenderer", void 0);
    __decorate([
        context_1.Autowired('filterManager'),
        __metadata("design:type", filterManager_1.FilterManager)
    ], GridCore.prototype, "filterManager", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], GridCore.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('gridPanel'),
        __metadata("design:type", gridPanel_1.GridPanel)
    ], GridCore.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('eGridDiv'),
        __metadata("design:type", HTMLElement)
    ], GridCore.prototype, "eGridDiv", void 0);
    __decorate([
        context_1.Autowired('$scope'),
        __metadata("design:type", Object)
    ], GridCore.prototype, "$scope", void 0);
    __decorate([
        context_1.Autowired('quickFilterOnScope'),
        __metadata("design:type", String)
    ], GridCore.prototype, "quickFilterOnScope", void 0);
    __decorate([
        context_1.Autowired('popupService'),
        __metadata("design:type", popupService_1.PopupService)
    ], GridCore.prototype, "popupService", void 0);
    __decorate([
        context_1.Autowired('focusedCellController'),
        __metadata("design:type", focusedCellController_1.FocusedCellController)
    ], GridCore.prototype, "focusedCellController", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], GridCore.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], GridCore.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], GridCore.prototype, "gridApi", void 0);
    __decorate([
        context_1.Optional('rowGroupCompFactory'),
        __metadata("design:type", Object)
    ], GridCore.prototype, "rowGroupCompFactory", void 0);
    __decorate([
        context_1.Optional('pivotCompFactory'),
        __metadata("design:type", Object)
    ], GridCore.prototype, "pivotCompFactory", void 0);
    __decorate([
        context_1.Optional('toolPanel'),
        __metadata("design:type", component_1.Component)
    ], GridCore.prototype, "toolPanel", void 0);
    __decorate([
        context_1.Optional('statusBar'),
        __metadata("design:type", component_1.Component)
    ], GridCore.prototype, "statusBar", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], GridCore.prototype, "init", null);
    __decorate([
        context_1.PreDestroy,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], GridCore.prototype, "destroy", null);
    GridCore = __decorate([
        context_1.Bean('gridCore'),
        __param(0, context_1.Qualifier('loggerFactory')),
        __metadata("design:paramtypes", [logger_1.LoggerFactory])
    ], GridCore);
    return GridCore;
}());
exports.GridCore = GridCore;


/***/ }),

/***/ "bFti":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1453);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1048:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("BOhp");

/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1453:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1059) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "virtuallist",
	    name: "VirtualList",
	    category: "framework",
	    depends: [ "data" ],
	    hidden: true
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        DataBoundWidget = ui.DataBoundWidget,
	        proxy = $.proxy,
	        percentageUnitsRegex = /^\d+(\.\d+)?%$/i,
	        WRAPPER = "k-virtual-wrap",
	        VIRTUALLIST = "k-virtual-list",
	        CONTENT = "k-virtual-content",
	        LIST = "k-list",
	        HEADER = "k-group-header",
	        VIRTUALITEM = "k-virtual-item",
	        ITEM = "k-item",
	        HEIGHTCONTAINER = "k-height-container",
	        GROUPITEM = "k-group",

	        SELECTED = "k-state-selected",
	        FOCUSED = "k-state-focused",
	        HOVER = "k-state-hover",
	        CHANGE = "change",
	        CLICK = "click",
	        LISTBOUND = "listBound",
	        ITEMCHANGE = "itemChange",

	        ACTIVATE = "activate",
	        DEACTIVATE = "deactivate",

	        VIRTUAL_LIST_NS = ".VirtualList";

	    function lastFrom(array) {
	        return array[array.length - 1];
	    }

	    function toArray(value) {
	        return value instanceof Array ? value : [value];
	    }

	    function isPrimitive(dataItem) {
	        return typeof dataItem === "string" || typeof dataItem === "number" || typeof dataItem === "boolean";
	    }

	    function getItemCount(screenHeight, listScreens, itemHeight) {
	        return Math.ceil(screenHeight * listScreens / itemHeight);
	    }

	    function appendChild(parent, className, tagName) {
	        var element = document.createElement(tagName || "div");
	        if (className) {
	            element.className = className;
	        }
	        parent.appendChild(element);

	        return element;
	    }

	    function getDefaultItemHeight() {
	        var mockList = $('<div class="k-popup"><ul class="k-list"><li class="k-item"><li></ul></div>'),
	            lineHeight;
	        mockList.css({
	            position: "absolute",
	            left: "-200000px",
	            visibility: "hidden"
	        });
	        mockList.appendTo(document.body);
	        lineHeight = parseFloat(kendo.getComputedStyles(mockList.find(".k-item")[0], ["line-height"])["line-height"]);
	        mockList.remove();

	        return lineHeight;
	    }

	    function bufferSizes(screenHeight, listScreens, opposite) { //in pixels
	        return {
	            down: screenHeight * opposite,
	            up: screenHeight * (listScreens - 1 - opposite)
	        };
	    }

	    function listValidator(options, screenHeight) {
	        var downThreshold = (options.listScreens - 1 - options.threshold) * screenHeight;
	        var upThreshold = options.threshold * screenHeight;

	        return function(list, scrollTop, lastScrollTop) {
	            if (scrollTop > lastScrollTop) {
	                return scrollTop - list.top < downThreshold;
	            } else {
	                return list.top === 0 || scrollTop - list.top > upThreshold;
	            }
	        };
	    }

	    function scrollCallback(element, callback) {
	        return function(force) {
	            return callback(element.scrollTop, force);
	        };
	    }

	    function syncList(reorder) {
	        return function(list, force) {
	            reorder(list.items, list.index, force);
	            return list;
	        };
	    }

	    function position(element, y) {
	        if (kendo.support.browser.msie && kendo.support.browser.version < 10) {
	            element.style.top = y + "px";
	        } else {
	            element.style.webkitTransform = 'translateY(' + y + "px)";
	            element.style.transform = 'translateY(' + y + "px)";
	        }
	    }

	    function map2(callback, templates) {
	        return function(arr1, arr2) {
	            for (var i = 0, len = arr1.length; i < len; i++) {
	                callback(arr1[i], arr2[i], templates);
	                if (arr2[i].item) {
	                    this.trigger(ITEMCHANGE, { item: $(arr1[i]), data: arr2[i].item, ns: kendo.ui });
	                }
	            }
	        };
	    }

	    function reshift(items, diff) {
	        var range;

	        if (diff > 0) { // down
	            range = items.splice(0, diff);
	            items.push.apply(items, range);
	        } else { // up
	            range = items.splice(diff, -diff);
	            items.unshift.apply(items, range);
	        }

	        return range;
	    }

	    function render(element, data, templates) {
	        var itemTemplate = templates.template;

	        element = $(element);

	        if (!data.item) {
	            itemTemplate = templates.placeholderTemplate;
	        }

	         if (data.index === 0 && this.header && data.group) {
	             this.header.html(templates.fixedGroupTemplate(data.group));
	         }

	        this.angular("cleanup", function() {
	            return { elements: [ element ]};
	        });

	        element
	            .attr("data-uid", data.item ? data.item.uid : "")
	            .attr("data-offset-index", data.index);

	         if (this.options.columns && this.options.columns.length && data.item) {
	            element.html(renderColumns(this.options, data.item, templates));
	        } else {
	            element.html(itemTemplate(data.item || {}));
	        }

	        element.toggleClass(FOCUSED, data.current);
	        element.toggleClass(SELECTED, data.selected);
	        element.toggleClass("k-first", data.newGroup);
	        element.toggleClass("k-last", data.isLastGroupedItem);
	        element.toggleClass("k-loading-item", !data.item);

	        if (data.index !== 0 && data.newGroup) {
	            $("<div class=" + GROUPITEM + "></div>")
	                .appendTo(element)
	                .html(templates.groupTemplate(data.group));
	        }

	        if (data.top !== undefined) {
	            position(element[0], data.top);
	        }

	        this.angular("compile", function() {
	            return { elements: [ element ], data: [ { dataItem: data.item, group: data.group, newGroup: data.newGroup } ]};
	        });
	    }

	    function renderColumns(options, dataItem, templates) {
	        var item = "";

	        for (var i = 0; i < options.columns.length; i++) {
	            var currentWidth = options.columns[i].width;
	            var currentWidthInt = parseInt(currentWidth, 10);
	            var widthStyle = '';

	            if(currentWidth){
	                widthStyle += "style='width:";
	                widthStyle += currentWidthInt;
	                widthStyle += percentageUnitsRegex.test(currentWidth) ? "%" : "px";
	                widthStyle += ";'";
	            }
	            item += "<span class='k-cell' " + widthStyle + ">";
	            item += templates["column"+ i](dataItem);
	            item += "</span>";
	        }

	        return item;
	    }

	    function mapChangedItems(selected, itemsToMatch) {
	        var itemsLength = itemsToMatch.length;
	        var selectedLength = selected.length;
	        var dataItem;
	        var found;
	        var i, j;

	        var changed = [];
	        var unchanged = [];

	        if (selectedLength) {
	            for (i = 0; i < selectedLength; i++) {
	                dataItem = selected[i];
	                found = false;

	                for (j = 0; j < itemsLength; j++) {
	                    if (dataItem === itemsToMatch[j]) {
	                        found = true;
	                        changed.push({ index: i, item: dataItem });
	                        break;
	                    }
	                }

	                if (!found) {
	                    unchanged.push(dataItem);
	                }
	            }
	        }

	        return {
	            changed: changed,
	            unchanged: unchanged
	        };
	    }

	    function isActivePromise(promise) {
	        return promise && promise.state() !== "resolved";
	    }

	    var VirtualList = DataBoundWidget.extend({
	        init: function(element, options) {
	            var that = this;

	            that.bound(false);
	            that._fetching = false;

	            Widget.fn.init.call(that, element, options);

	            if (!that.options.itemHeight) {
	                that.options.itemHeight = getDefaultItemHeight();
	            }

	            options = that.options;

	            that.element.addClass(LIST + " " + VIRTUALLIST).attr("role", "listbox");
	            that.content = that.element.wrap("<div unselectable='on' class='" + CONTENT + "'></div>").parent();
	            that.wrapper = that.content.wrap("<div class='" + WRAPPER + "'></div>").parent();
	            that.header = that.content.before("<div class='" + HEADER + "'></div>").prev();

	            if (options.columns && options.columns.length) {
	                that.element.removeClass(LIST);
	            }

	            that.element.on("mouseenter" + VIRTUAL_LIST_NS, "li:not(.k-loading-item)", function() { $(this).addClass(HOVER); })
	                        .on("mouseleave" + VIRTUAL_LIST_NS, "li", function() { $(this).removeClass(HOVER); });

	            that._values = toArray(that.options.value);
	            that._selectedDataItems = [];
	            that._selectedIndexes = [];
	            that._rangesList = {};
	            that._promisesList = [];
	            that._optionID = kendo.guid();

	            that._templates();

	            that.setDataSource(options.dataSource);

	            that.content.on("scroll" + VIRTUAL_LIST_NS, kendo.throttle(function() {
	                that._renderItems();
	                that._triggerListBound();
	            }, options.delay));

	            that._selectable();
	        },

	        options: {
	            name: "VirtualList",
	            autoBind: true,
	            delay: 100,
	            height: null,
	            listScreens: 4,
	            threshold: 0.5,
	            itemHeight: null,
	            oppositeBuffer: 1,
	            type: "flat",
	            selectable: false,
	            value: [],
	            dataValueField: null,
	            template: "#:data#",
	            placeholderTemplate: "loading...",
	            groupTemplate: "#:data#",
	            fixedGroupTemplate: "#:data#",
	            mapValueTo: "index",
	            valueMapper: null
	        },

	        events: [
	            CHANGE,
	            CLICK,
	            LISTBOUND,
	            ITEMCHANGE,
	            ACTIVATE,
	            DEACTIVATE
	        ],

	        setOptions: function(options) {
	            Widget.fn.setOptions.call(this, options);

	            if (this._selectProxy && this.options.selectable === false) {
	                this.element.off(CLICK, "." + VIRTUALITEM, this._selectProxy);
	            } else if (!this._selectProxy && this.options.selectable) {
	                this._selectable();
	            }

	            this._templates();
	            this.refresh();
	        },

	        items: function() {
	            return $(this._items);
	        },

	        destroy: function() {
	            this.wrapper.off(VIRTUAL_LIST_NS);
	            this.dataSource.unbind(CHANGE, this._refreshHandler);
	            Widget.fn.destroy.call(this);
	        },

	        setDataSource: function(source) {
	            var that = this;
	            var dataSource = source || {};
	            var value;

	            dataSource = $.isArray(dataSource) ? {data: dataSource} : dataSource;
	            dataSource = kendo.data.DataSource.create(dataSource);

	            if (that.dataSource) {
	                that.dataSource.unbind(CHANGE, that._refreshHandler);

	                that._clean();
	                that.bound(false);

	                that._deferValueSet = true;
	                value = that.value();

	                that.value([]);
	                that.mute(function() {
	                    that.value(value);
	                });
	            } else {
	                that._refreshHandler = $.proxy(that.refresh, that);
	            }

	            that.dataSource = dataSource.bind(CHANGE, that._refreshHandler);

	            that.setDSFilter(dataSource.filter());

	            if (dataSource.view().length !== 0) {
	                that.refresh();
	            } else if (that.options.autoBind) {
	                dataSource.fetch();
	            }
	        },

	        skip: function() {
	            return this.dataSource.currentRangeStart();
	        },

	        _triggerListBound: function () {
	            var that = this;
	            var skip = that.skip();

	            if (that.bound() && !that._selectingValue && that._skip !== skip) {
	                that._skip = skip;
	                that.trigger(LISTBOUND);
	            }
	        },

	        _getValues: function(dataItems) {
	            var getter = this._valueGetter;

	            return $.map(dataItems, function(dataItem) {
	                return getter(dataItem);
	            });
	        },

	        _highlightSelectedItems: function () {
	            for (var i = 0; i < this._selectedDataItems.length; i++) {
	                var item = this._getElementByDataItem(this._selectedDataItems[i]);
	                if(item.length){
	                    item.addClass(SELECTED);
	                }
	            }
	        },

	        refresh: function(e) {
	            var that = this;
	            var action = e && e.action;
	            var isItemChange = action === "itemchange";
	            var filtered = this.isFiltered();
	            var result;

	            if (that._mute) { return; }

	            that._deferValueSet = false;

	            if (!that._fetching) {
	                if (filtered) {
	                    that.focus(0);
	                }

	                that._createList();
	                if (!action && that._values.length && !filtered &&
	                     !that.options.skipUpdateOnBind && !that._emptySearch) {
	                    that._selectingValue = true;

	                    that.bound(true);
	                    that.value(that._values, true).done(function () {
	                        that._selectingValue = false;
	                        that._triggerListBound();
	                    });
	                } else {
	                    that.bound(true);
	                    that._highlightSelectedItems();
	                    that._triggerListBound();
	                }
	            } else {
	                if (that._renderItems) {
	                    that._renderItems(true);
	                }

	                that._triggerListBound();
	            }

	            if (isItemChange || action === "remove") {
	                result = mapChangedItems(that._selectedDataItems, e.items);
	                if (result.changed.length) {
	                    if (isItemChange) {
	                        that.trigger("selectedItemChange", {
	                            items: result.changed
	                        });
	                    } else {
	                        that.value(that._getValues(result.unchanged));
	                    }
	                }
	            }

	            that._fetching = false;
	        },

	        removeAt: function(position) {
	            this._selectedIndexes.splice(position, 1);
	            this._values.splice(position, 1);

	            return {
	                position: position,
	                dataItem: this._selectedDataItems.splice(position, 1)[0]
	            };
	        },

	        setValue: function(value) {
	            this._values = toArray(value);
	        },

	        value: function(value, _forcePrefetch) {
	            var that = this;

	            if (value === undefined) {
	                return that._values.slice();
	            }

	            if (value === null) {
	                value = [];
	            }

	            value = toArray(value);

	            if (!that._valueDeferred || that._valueDeferred.state() === "resolved") {
	                that._valueDeferred = $.Deferred();
	            }

	            var shouldClear = that.options.selectable === "multiple" && that.select().length && value.length;

	            if (shouldClear || !value.length) {
	                that.select(-1);
	            }

	            that._values = value;

	            if ((that.bound() && !that._mute && !that._deferValueSet) || _forcePrefetch) {
	                that._prefetchByValue(value);
	            }

	            return that._valueDeferred;
	        },

	        _checkValuesOrder: function (value) {
	            if (this._removedAddedIndexes &&
	                this._removedAddedIndexes.length === value.length) {
	                    var newValue = this._removedAddedIndexes.slice();
	                    this._removedAddedIndexes = null;
	                return newValue;
	            }

	            return value;
	        },

	        _prefetchByValue: function(value) {
	            var that = this,
	                dataView = that._dataView,
	                valueGetter = that._valueGetter,
	                mapValueTo = that.options.mapValueTo,
	                item, match = false,
	                forSelection = [];

	            //try to find the items in the loaded data
	            for (var i = 0; i < value.length; i++) {
	                for (var idx = 0; idx < dataView.length; idx++) {
	                    item = dataView[idx].item;
	                    if (item) {
	                        match = isPrimitive(item) ? value[i] === item : value[i] === valueGetter(item);

	                        if (match) {
	                            forSelection.push(dataView[idx].index);
	                        }
	                    }
	                }
	            }

	            if (forSelection.length === value.length) {
	                that._values = [];
	                that.select(forSelection);
	                return;
	            }

	            //prefetch the items
	            if (typeof that.options.valueMapper === "function") {
	                that.options.valueMapper({
	                    value: (this.options.selectable === "multiple") ? value : value[0],
	                    success: function(response) {
	                        if (mapValueTo === "index") {
	                            that.mapValueToIndex(response);
	                        } else if (mapValueTo === "dataItem") {
	                            that.mapValueToDataItem(response);
	                        }
	                    }
	                });
	            } else {
	                 if (!that.value()[0]) {
	                     that.select([-1]);
	                 } else {
	                    that._selectingValue = false;
	                    that._triggerListBound();
	                 }
	            }
	        },

	        mapValueToIndex: function(indexes) {
	            if (indexes === undefined || indexes === -1 || indexes === null) {
	                indexes = [];
	            } else {
	                indexes = toArray(indexes);
	            }

	            if (!indexes.length) {
	                indexes = [-1];
	            } else {
	                var removed = this._deselect([]).removed;
	                if (removed.length) {
	                    this._triggerChange(removed, []);
	                }
	            }

	            this.select(indexes);
	        },

	        mapValueToDataItem: function(dataItems) {
	            var removed, added;

	            if (dataItems === undefined || dataItems === null) {
	                dataItems = [];
	            } else {
	                dataItems = toArray(dataItems);
	            }

	            if (!dataItems.length) {
	                this.select([-1]);
	            } else {
	                removed = $.map(this._selectedDataItems, function(item, index) {
	                    return { index: index, dataItem: item };
	                });

	                added = $.map(dataItems, function(item, index) {
	                    return { index: index, dataItem: item };
	                });

	                this._selectedDataItems = dataItems;

	                this._selectedIndexes = [];

	                for (var i = 0; i < this._selectedDataItems.length; i++) {
	                    var item = this._getElementByDataItem(this._selectedDataItems[i]);
	                    this._selectedIndexes.push(this._getIndecies(item)[0]);
	                    item.addClass(SELECTED);
	                }

	                this._triggerChange(removed, added);

	                if (this._valueDeferred) {
	                    this._valueDeferred.resolve();
	                }
	            }
	        },

	        deferredRange: function(index) {
	            var dataSource = this.dataSource;
	            var take = this.itemCount;
	            var ranges = this._rangesList;
	            var result = $.Deferred();
	            var defs = [];

	            var low = Math.floor(index / take) * take;
	            var high = Math.ceil(index / take) * take;

	            var pages = high === low ? [ high ] : [ low, high ];

	            $.each(pages, function(_, skip) {
	                var end = skip + take;
	                var existingRange = ranges[skip];
	                var deferred;

	                if (!existingRange || (existingRange.end !== end)) {
	                    deferred = $.Deferred();
	                    ranges[skip] = { end: end, deferred: deferred };

	                    dataSource._multiplePrefetch(skip, take, function() {
	                        deferred.resolve();
	                    });
	                } else {
	                    deferred = existingRange.deferred;
	                }

	                defs.push(deferred);
	            });

	            $.when.apply($, defs).then(function() {
	                result.resolve();
	            });

	            return result;
	        },

	        prefetch: function(indexes) {
	            var that = this,
	                take = this.itemCount,
	                isEmptyList = !that._promisesList.length;

	            if (!isActivePromise(that._activeDeferred)) {
	                that._activeDeferred = $.Deferred();
	                that._promisesList = [];
	            }

	            $.each(indexes, function(_, index) {
	                that._promisesList.push(that.deferredRange(that._getSkip(index, take)));
	            });

	            if (isEmptyList) {
	                $.when.apply($, that._promisesList).done(function() {
	                    that._promisesList = [];
	                    that._activeDeferred.resolve();
	                });
	            }

	            return that._activeDeferred;
	        },

	        _findDataItem: function(view, index) {
	            var group;

	            //find in grouped view
	            if (this.options.type === "group") {
	                for (var i = 0; i < view.length; i++) {
	                    group = view[i].items;
	                    if (group.length <= index) {
	                        index = index - group.length;
	                    } else {
	                        return group[index];
	                    }
	                }
	            }

	            //find in flat view
	            return view[index];
	        },

	        _getRange: function(skip, take) {
	            return this.dataSource._findRange(skip, Math.min(skip + take, this.dataSource.total()));
	        },

	        dataItemByIndex: function(index) {
	            var that = this;
	            var take = that.itemCount;
	            var skip = that._getSkip(index, take);
	            var view = this._getRange(skip, take);

	            //should not return item if data is not loaded
	            if (!that._getRange(skip, take).length) {
	                return null;
	            }

	            if (that.options.type === "group") {
	                kendo.ui.progress($(that.wrapper), true);
	                that.mute(function() {
	                    that.dataSource.range(skip, take, function () {
	                        kendo.ui.progress($(that.wrapper), false);
	                    });
	                    view = that.dataSource.view();
	                });
	            }

	            return that._findDataItem(view, [index - skip]);
	        },

	        selectedDataItems: function() {
	            return this._selectedDataItems.slice();
	        },

	        scrollWith: function(value) {
	            this.content.scrollTop(this.content.scrollTop() + value);
	        },

	        scrollTo: function(y) {
	            this.content.scrollTop(y); //works only if the element is visible
	        },

	        scrollToIndex: function(index) {
	            this.scrollTo(index * this.options.itemHeight);
	        },

	        focus: function(candidate) {
	            var element,
	                index,
	                data,
	                current,
	                itemHeight = this.options.itemHeight,
	                id = this._optionID,
	                triggerEvent = true;

	            if (candidate === undefined) {
	                current = this.element.find("." + FOCUSED);
	                return current.length ? current : null;
	            }

	            if (typeof candidate === "function") {
	                data = this.dataSource.flatView();
	                for (var idx = 0; idx < data.length; idx++) {
	                    if (candidate(data[idx])) {
	                        candidate = idx;
	                        break;
	                    }
	                }
	            }

	            if (candidate instanceof Array) {
	                candidate = lastFrom(candidate);
	            }

	            if (isNaN(candidate)) {
	                element = $(candidate);
	                index = parseInt($(element).attr("data-offset-index"), 10);
	            } else {
	                index = candidate;
	                element = this._getElementByIndex(index);
	            }

	            if (index === -1) {
	                this.element.find("." + FOCUSED).removeClass(FOCUSED);
	                this._focusedIndex = undefined;
	                return;
	            }

	            if (element.length) { /*focus rendered item*/
	                if (element.hasClass(FOCUSED)) {
	                    triggerEvent = false;
	                }
	                if (this._focusedIndex !== undefined) {
	                    current = this._getElementByIndex(this._focusedIndex);
	                    current
	                        .removeClass(FOCUSED)
	                        .removeAttr("id");

	                    if (triggerEvent) {
	                        this.trigger(DEACTIVATE);
	                    }
	                }

	                this._focusedIndex = index;

	                element
	                    .addClass(FOCUSED)
	                    .attr("id", id);

	                var position = this._getElementLocation(index);

	                if (position === "top") {
	                    this.scrollTo(index * itemHeight);
	                } else if (position === "bottom") {
	                    this.scrollTo((index * itemHeight + itemHeight) - this._screenHeight);
	                } else if (position === "outScreen") {
	                    this.scrollTo(index * itemHeight);
	                }

	                if (triggerEvent) {
	                    this.trigger(ACTIVATE);
	                }
	            } else { /*focus non rendered item*/
	                this._focusedIndex = index;
	                this.items().removeClass(FOCUSED);
	                this.scrollToIndex(index);
	            }
	        },

	        focusIndex: function() {
	            return this._focusedIndex;
	        },

	        focusFirst: function() {
	            this.scrollTo(0);
	            this.focus(0);
	        },

	        focusLast: function() {
	            var lastIndex = this.dataSource.total();
	            this.scrollTo(this.heightContainer.offsetHeight);
	            this.focus(lastIndex - 1);
	        },

	        focusPrev: function() {
	            var index = this._focusedIndex;
	            var current;

	            if (!isNaN(index) && index > 0) {
	                index -= 1;
	                this.focus(index);

	                current = this.focus();
	                if (current && current.hasClass("k-loading-item")) {
	                    index += 1;
	                    this.focus(index);
	                }

	                return index;
	            } else {
	                index = this.dataSource.total() - 1;
	                this.focus(index);
	                return index;
	            }
	        },

	        focusNext: function() {
	            var index = this._focusedIndex;
	            var lastIndex = this.dataSource.total() - 1;
	            var current;

	            if (!isNaN(index) && index < lastIndex) {
	                index += 1;
	                this.focus(index);

	                current = this.focus();
	                if (current && current.hasClass("k-loading-item")) {
	                    index -= 1;
	                    this.focus(index);
	                }

	                return index;
	            } else {
	                index = 0;
	                this.focus(index);
	                return index;
	            }
	        },

	        _triggerChange: function(removed, added) {
	            removed = removed || [];
	            added = added || [];

	            if (removed.length || added.length) {
	                this.trigger(CHANGE, {
	                    removed: removed,
	                    added: added
	                });
	            }
	        },

	        select: function(candidate) {
	            var that = this,
	                indices,
	                initialIndices,
	                singleSelection = that.options.selectable !== "multiple",
	                prefetchStarted = isActivePromise(that._activeDeferred),
	                filtered = this.isFiltered(),
	                isAlreadySelected,
	                deferred,
	                result,
	                removed = [];

	            if (candidate === undefined) {
	                return that._selectedIndexes.slice();
	            }

	            if (!that._selectDeferred || that._selectDeferred.state() === "resolved") {
	                that._selectDeferred = $.Deferred();
	            }

	            indices = that._getIndecies(candidate);
	            isAlreadySelected = singleSelection && !filtered && lastFrom(indices) === lastFrom(this._selectedIndexes);
	            removed = that._deselectCurrentValues(indices);

	            if (removed.length || !indices.length || isAlreadySelected) {
	                that._triggerChange(removed);

	                if (that._valueDeferred) {
	                    that._valueDeferred.resolve().promise();
	                }

	                return that._selectDeferred.resolve().promise();
	            }

	            if (indices.length === 1 && indices[0] === -1) {
	                indices = [];
	            }

	            initialIndices = indices;
	            result = that._deselect(indices);
	            removed = result.removed;
	            indices = result.indices;

	            if (singleSelection) {
	                prefetchStarted = false;
	                if (indices.length) {
	                    indices = [lastFrom(indices)];
	                }
	            }

	            var done = function() {
	                var added = that._select(indices);

	                if (initialIndices.length === indices.length || singleSelection) {
	                    that.focus(indices);
	                }

	                that._triggerChange(removed, added);

	                if (that._valueDeferred) {
	                    that._valueDeferred.resolve();
	                }

	                that._selectDeferred.resolve();
	            };

	            deferred = that.prefetch(indices);

	            if (!prefetchStarted) {
	                if (deferred) {
	                    deferred.done(done);
	                } else {
	                    done();
	                }
	            }

	            return that._selectDeferred.promise();
	        },

	        bound: function(bound) {
	            if (bound === undefined) {
	                return this._listCreated;
	            }

	            this._listCreated = bound;
	        },

	        mute: function(callback) {
	            this._mute = true;
	            proxy(callback(), this);
	            this._mute = false;
	        },

	        setDSFilter: function(filter) {
	            this._lastDSFilter = $.extend({}, filter);
	        },

	        isFiltered: function() {
	            if (!this._lastDSFilter) {
	                this.setDSFilter(this.dataSource.filter());
	            }

	            return !kendo.data.Query.compareFilters(this.dataSource.filter(), this._lastDSFilter);
	        },

	        skipUpdate: $.noop,

	        _getElementByIndex: function(index) {
	            return this.items().filter(function(idx, element) {
	                return index === parseInt($(element).attr("data-offset-index"), 10);
	            });
	        },

	        _getElementByDataItem: function(dataItem) {
	            var dataView = this._dataView,
	            valueGetter = this._valueGetter,
	                element, match;

	            for (var i = 0; i < dataView.length; i++) {
	                match = dataView[i].item && isPrimitive(dataView[i].item) ? dataView[i].item === dataItem : dataView[i].item && dataItem && valueGetter(dataView[i].item) == valueGetter(dataItem);
	                if (match) {
	                    element = dataView[i];
	                    break;
	                }
	            }

	            return element ? this._getElementByIndex(element.index) : $();
	        },

	        _clean: function() {
	            this.result = undefined;
	            this._lastScrollTop = undefined;
	            this._skip = undefined;
	            $(this.heightContainer).remove();
	            this.heightContainer = undefined;
	            this.element.empty();
	        },

	        _height: function() {
	            var hasData = !!this.dataSource.view().length,
	                height = this.options.height,
	                itemHeight = this.options.itemHeight,
	                total = this.dataSource.total();

	            if (!hasData) {
	                height = 0;
	            } else if (height/itemHeight > total) {
	                height = total * itemHeight;
	            }

	            return height;
	        },

	        setScreenHeight: function() {
	            var height = this._height();

	            this.content.height(height);
	            this._screenHeight = height;
	        },

	        screenHeight: function() {
	            return this._screenHeight;
	        },

	        _getElementLocation: function(index) {
	            var scrollTop = this.content.scrollTop(),
	                screenHeight = this._screenHeight,
	                itemHeight = this.options.itemHeight,
	                yPosition = index * itemHeight,
	                yDownPostion = yPosition + itemHeight,
	                screenEnd = scrollTop + screenHeight,
	                position;

	            if (yPosition === (scrollTop - itemHeight) || (yDownPostion > scrollTop && yPosition < scrollTop)) {
	                position = "top";
	            } else if (yPosition === screenEnd || (yPosition < screenEnd && screenEnd < yDownPostion)) {
	                position = "bottom";
	            } else if ((yPosition >= scrollTop) && (yPosition <= scrollTop + (screenHeight - itemHeight))) {
	                position = "inScreen";
	            } else {
	                position = "outScreen";
	            }

	            return position;
	        },

	        _templates: function() {
	            var options = this.options;
	            var templates = {
	                template: options.template,
	                placeholderTemplate: options.placeholderTemplate,
	                groupTemplate: options.groupTemplate,
	                fixedGroupTemplate: options.fixedGroupTemplate
	            };

	            if (options.columns) {
	                for (var i = 0; i < options.columns.length; i++) {
	                    var currentColumn = options.columns[i];
	                    var templateText = currentColumn.field ? currentColumn.field.toString(): "text";

	                    templates["column"+ i] = currentColumn.template || "#: " + templateText + "#";
	                }
	            }

	            for (var key in templates) {
	                if (typeof templates[key] !== "function") {
	                    templates[key] = kendo.template(templates[key] || "");
	                }
	            }

	            this.templates = templates;
	        },

	        _generateItems: function(element, count) {
	            var items = [],
	                item,
	                itemHeight = this.options.itemHeight + "px";

	            while(count-- > 0) {
	                item = document.createElement("li");
	                item.tabIndex = -1;
	                item.className = VIRTUALITEM + " " + ITEM;
	                item.setAttribute("role", "option");
	                item.style.height = itemHeight;
	                item.style.minHeight = itemHeight;
	                element.appendChild(item);

	                items.push(item);
	            }

	            return items;
	        },

	        _saveInitialRanges: function() {
	            var ranges = this.dataSource._ranges;
	            var deferred = $.Deferred();
	            deferred.resolve();

	            this._rangesList = {};
	            for (var i = 0; i < ranges.length; i++) {
	                this._rangesList[ranges[i].start] = { end: ranges[i].end, deferred: deferred };
	            }
	        },

	        _createList: function() {
	            var that = this,
	                content = that.content.get(0),
	                options = that.options,
	                dataSource = that.dataSource;

	            if (that.bound()) {
	                that._clean();
	            }

	            that._saveInitialRanges();
	            that._buildValueGetter();
	            that.setScreenHeight();
	            that.itemCount = getItemCount(that._screenHeight, options.listScreens, options.itemHeight);

	            if (that.itemCount > dataSource.total()) {
	                that.itemCount = dataSource.total();
	            }

	            that._items = that._generateItems(that.element[0], that.itemCount);

	            that._setHeight(options.itemHeight * dataSource.total());
	            that.options.type = (dataSource.group() || []).length ? "group" : "flat";

	            if (that.options.type === "flat") {
	                that.header.hide();
	            } else {
	                that.header.show();
	            }

	            that.getter = that._getter(function() {
	                that._renderItems(true);
	            });

	            that._onScroll = function(scrollTop, force) {
	                var getList = that._listItems(that.getter);
	                return that._fixedHeader(scrollTop, getList(scrollTop, force));
	            };

	            that._renderItems = that._whenChanged(
	                scrollCallback(content, that._onScroll),
	                syncList(that._reorderList(that._items, $.proxy(render, that)))
	            );

	            that._renderItems();
	            that._calculateGroupPadding(that._screenHeight);
	            that._calculateColumnsHeaderPadding();
	        },

	        _setHeight: function(height) {
	            var currentHeight,
	                heightContainer = this.heightContainer;

	            if (!heightContainer) {
	                heightContainer = this.heightContainer = appendChild(this.content[0], HEIGHTCONTAINER);
	            } else {
	                currentHeight = heightContainer.offsetHeight;
	            }

	            if (height !== currentHeight) {
	                heightContainer.innerHTML = "";

	                while (height > 0) {
	                    var padHeight = Math.min(height, 250000); //IE workaround, should not create elements with height larger than 250000px
	                    appendChild(heightContainer).style.height = padHeight + "px";
	                    height -= padHeight;
	                }
	            }
	        },

	        _getter: function() {
	            var lastRequestedRange = null,
	                dataSource = this.dataSource,
	                lastRangeStart = dataSource.skip(),
	                type = this.options.type,
	                pageSize = this.itemCount,
	                flatGroups = {};

	            if (dataSource.pageSize() < pageSize) {
	                this.mute(function() {
	                    dataSource.pageSize(pageSize);
	                });
	            }

	            return function(index, rangeStart) {
	                var that = this;
	                if (!dataSource.inRange(rangeStart, pageSize)) {
	                    if (lastRequestedRange !== rangeStart) {
	                        lastRequestedRange = rangeStart;
	                        lastRangeStart = rangeStart;

	                        if (that._getterDeferred) {
	                            that._getterDeferred.reject();
	                        }

	                        that._getterDeferred = that.deferredRange(rangeStart);
	                        that._getterDeferred.then(function() {
	                            var firstItemIndex = that._indexConstraint(that.content[0].scrollTop);

	                            that._getterDeferred = null;

	                            if (rangeStart <= firstItemIndex && firstItemIndex <= (rangeStart + pageSize)) {
	                                that._fetching = true;
	                                dataSource.range(rangeStart, pageSize);
	                            }
	                        });
	                    }

	                    return null;
	                } else {
	                    if (lastRangeStart !== rangeStart) {
	                        this.mute(function() {
	                            dataSource.range(rangeStart, pageSize);
	                            lastRangeStart = rangeStart;
	                        });
	                    }

	                    var result;
	                    if (type === "group") { //grouped list
	                        if (!flatGroups[rangeStart]) {
	                            var flatGroup = flatGroups[rangeStart] = [];
	                            var groups = dataSource.view();
	                            for (var i = 0, len = groups.length; i < len; i++) {
	                                var group = groups[i];
	                                for (var j = 0, groupLength = group.items.length; j < groupLength; j++) {
	                                    flatGroup.push({ item: group.items[j], group: group.value });
	                                }
	                            }
	                        }

	                        result = flatGroups[rangeStart][index - rangeStart];
	                    } else { //flat list
	                        result = dataSource.view()[index - rangeStart];
	                    }

	                    return result;
	                }
	            };
	        },

	        _fixedHeader: function(scrollTop, list) {
	            var group = this.currentVisibleGroup,
	                itemHeight = this.options.itemHeight,
	                firstVisibleDataItemIndex = Math.floor((scrollTop - list.top) / itemHeight),
	                firstVisibleDataItem = list.items[firstVisibleDataItemIndex];

	            if (firstVisibleDataItem && firstVisibleDataItem.item) {
	                var firstVisibleGroup = firstVisibleDataItem.group;

	                if (firstVisibleGroup !== group) {
	                    var fixedGroupText = firstVisibleGroup || "";
	                    this.header.html(this.templates.fixedGroupTemplate(fixedGroupText));
	                    this.currentVisibleGroup = firstVisibleGroup;
	                }
	            }

	            return list;
	        },

	        _itemMapper: function(item, index, value) {
	            var listType = this.options.type,
	                itemHeight = this.options.itemHeight,
	                currentIndex = this._focusedIndex,
	                selected = false,
	                current = false,
	                newGroup = false,
	                group = null,
	                match = false,
	                valueGetter = this._valueGetter;

	            if (listType === "group") {
	                if (item) {
	                    newGroup = index === 0 || (this._currentGroup !== false && this._currentGroup !== item.group);
	                    this._currentGroup = item.group;
	                }

	                group = item ? item.group : null;
	                item = item ? item.item : null;
	            }

	            if (this.options.mapValueTo === "dataItem" && this._selectedDataItems.length && item) {
	                for (var i = 0; i < this._selectedDataItems.length; i++) {
	                    match = valueGetter(this._selectedDataItems[i]) === valueGetter(item);
	                    if (match) {
	                        selected = true;
	                        break;
	                    }
	                }
	            } else if (!this.isFiltered() && value.length && item) {
	                for (var j = 0; j < value.length; j++) {
	                    match = isPrimitive(item) ? value[j] === item : value[j] === valueGetter(item);
	                    if (match) {
	                        value.splice(j , 1);
	                        selected = true;
	                        break;
	                    }
	                }
	            }

	            if (currentIndex === index) {
	                current = true;
	            }

	            return {
	                item: item ? item : null,
	                group: group,
	                newGroup: newGroup,
	                selected: selected,
	                current: current,
	                index: index,
	                top: index * itemHeight
	            };
	        },

	        _range: function(index) {
	            var itemCount = this.itemCount,
	                value = this._values.slice(),
	                items = [],
	                item;

	            this._view = {};
	            this._currentGroup = false;

	            for (var i = index, length = index + itemCount; i < length; i++) {
	                item = this._itemMapper(this.getter(i, index), i, value);
	                if(items[items.length - 1]){
	                    items[items.length - 1].isLastGroupedItem = item.newGroup;
	                }
	                items.push(item);
	                this._view[item.index] = item;
	            }

	            this._dataView = items;
	            return items;
	        },

	        _getDataItemsCollection: function(scrollTop, lastScrollTop) {
	            var items = this._range(this._listIndex(scrollTop, lastScrollTop));
	            return {
	                index: items.length ? items[0].index : 0,
	                top: items.length ? items[0].top : 0,
	                items: items
	            };
	        },

	        _listItems: function() {
	            var screenHeight = this._screenHeight,
	                options = this.options;

	            var theValidator = listValidator(options, screenHeight);

	            return $.proxy(function(value, force) {
	                var result = this.result,
	                    lastScrollTop = this._lastScrollTop;

	                if (force || !result || !theValidator(result, value, lastScrollTop)) {
	                    result = this._getDataItemsCollection(value, lastScrollTop);
	                }

	                this._lastScrollTop = value;
	                this.result = result;

	                return result;
	            }, this);
	        },

	        _whenChanged: function(getter, callback) {
	            var current;

	            return function(force) {
	                var theNew = getter(force);

	                if (theNew !== current) {
	                    current = theNew;
	                    callback(theNew, force);
	                }
	            };
	        },

	        _reorderList: function(list, reorder) {
	            var that = this;
	            var length = list.length;
	            var currentOffset = -Infinity;
	            reorder = $.proxy(map2(reorder, this.templates), this);

	            return function(list2, offset, force) {
	                var diff = offset - currentOffset;
	                var range, range2;

	                if (force || Math.abs(diff) >= length) { // full reorder
	                    range = list;
	                    range2 = list2;
	                } else { // partial reorder
	                    range = reshift(list, diff);
	                    range2 = diff > 0 ? list2.slice(-diff) : list2.slice(0, -diff);
	                }

	                reorder(range, range2, that.bound());

	                currentOffset = offset;
	            };
	        },

	        _bufferSizes: function() {
	            var options = this.options;

	            return bufferSizes(this._screenHeight, options.listScreens, options.oppositeBuffer);
	        },

	        _indexConstraint: function(position) {
	            var itemCount = this.itemCount,
	                itemHeight = this.options.itemHeight,
	                total = this.dataSource.total();

	            return Math.min(Math.max(total - itemCount, 0), Math.max(0, Math.floor(position / itemHeight )));
	        },

	        _listIndex: function(scrollTop, lastScrollTop) {
	            var buffers = this._bufferSizes(),
	                position;

	            position = scrollTop - ((scrollTop > lastScrollTop) ? buffers.down : buffers.up);

	            return this._indexConstraint(position);
	        },

	        _selectable: function() {
	            if (this.options.selectable) {
	                this._selectProxy = $.proxy(this, "_clickHandler");
	                this.element.on(CLICK + VIRTUAL_LIST_NS, "." + VIRTUALITEM, this._selectProxy);
	            }
	        },

	        getElementIndex: function(element) {
	            if (!(element instanceof jQuery)) {
	                return undefined;
	            }

	            return parseInt(element.attr("data-offset-index"), 10);
	        },

	        _getIndecies: function(candidate) {
	            var result = [], data;

	            if (typeof candidate === "function") {
	                data = this.dataSource.flatView();
	                for (var idx = 0; idx < data.length; idx++) {
	                    if (candidate(data[idx])) {
	                        result.push(idx);
	                        break;
	                    }
	                }
	            }

	            if (typeof candidate === "number") {
	                result.push(candidate);
	            }

	            var elementIndex = this.getElementIndex(candidate);
	            if (!isNaN(elementIndex)) {
	                result.push(elementIndex);
	            }

	            if (candidate instanceof Array) {
	                result = candidate;
	            }

	            return result;
	        },

	        _deselect: function(indices) {
	            var removed = [],
	                selectedIndex,
	                dataItem,
	                selectedIndexes = this._selectedIndexes,
	                selectedDataItems = this._selectedDataItems,
	                position = 0,
	                selectable = this.options.selectable,
	                removedindexesCounter = 0,
	                valueGetter = this._valueGetter,
	                item, match,
	                result = null;

	            indices = indices.slice();

	            if (selectable === true || !indices.length) { //deselect everything
	                for (var idx = 0; idx < selectedIndexes.length; idx++) {
	                    if (selectedIndexes[idx] !== undefined) {
	                        this._getElementByIndex(selectedIndexes[idx]).removeClass(SELECTED);
	                    } else if (selectedDataItems[idx]) {
	                        this._getElementByDataItem(selectedDataItems[idx]).removeClass(SELECTED);
	                    }

	                    removed.push({
	                        index: selectedIndexes[idx],
	                        position: idx,
	                        dataItem: selectedDataItems[idx]
	                    });
	                }

	                this._values = [];
	                this._selectedDataItems = [];
	                this._selectedIndexes = [];
	            } else if (selectable === "multiple") {
	                for (var i = 0; i < indices.length; i++) {
	                    result = null;
	                    position = $.inArray(indices[i], selectedIndexes);
	                    dataItem = this.dataItemByIndex(indices[i]);

	                    if (position === -1 && dataItem) {
	                        for (var j = 0; j < selectedDataItems.length; j++) {
	                            match = isPrimitive(dataItem) ? selectedDataItems[j] === dataItem : valueGetter(selectedDataItems[j]) === valueGetter(dataItem);
	                            if (match) {
	                                item = this._getElementByIndex(indices[i]);
	                                result = this._deselectSingleItem(item, j, indices[i], removedindexesCounter);
	                            }
	                        }
	                    } else {
	                        selectedIndex = selectedIndexes[position];

	                        if (selectedIndex !== undefined) {
	                            item = this._getElementByIndex(selectedIndex);
	                            result = this._deselectSingleItem(item, position, selectedIndex, removedindexesCounter);
	                        }
	                    }

	                    if (result) {
	                        indices.splice(i, 1);
	                        removed.push(result);

	                        removedindexesCounter++;
	                        i--;
	                    }
	                }
	            }

	            return {
	                indices: indices,
	                removed: removed
	            };
	        },

	        _deselectSingleItem: function(item, position, selectedIndex, removedindexesCounter) {
	            var dataItem;

	            if (!item.hasClass("k-state-selected")) {
	                return;
	            }

	            item.removeClass(SELECTED);
	            this._values.splice(position, 1);
	            this._selectedIndexes.splice(position, 1);
	            dataItem = this._selectedDataItems.splice(position, 1)[0];

	            return {
	                index: selectedIndex,
	                position: position + removedindexesCounter,
	                dataItem: dataItem
	            };
	        },

	        _deselectCurrentValues: function(indices) {
	            var children = this.element[0].children;
	            var value, index, position;
	            var values = this._values;
	            var removed = [];
	            var idx = 0;
	            var j;

	            if (this.options.selectable !== "multiple" || !this.isFiltered()) {
	                return [];
	            }

	            if (indices[0] === -1) {
	                $(children).removeClass("k-state-selected");
	                removed = $.map(this._selectedDataItems.slice(0), function(dataItem, idx) {
	                   return {
	                      dataItem: dataItem,
	                      position: idx
	                   };
	                });
	                this._selectedIndexes = [];
	                this._selectedDataItems = [];
	                this._values = [];
	                return removed;
	            }

	            for (; idx < indices.length; idx++) {
	                position = -1;
	                index = indices[idx];
	                if (this.dataItemByIndex(index)) {
	                    value = this._valueGetter(this.dataItemByIndex(index));
	                }

	                for (j = 0; j < values.length; j++) {
	                    if (value == values[j]) {
	                        position = j;
	                        break;
	                    }
	                }

	                if (position > -1) {
	                    removed.push(this.removeAt(position));
	                    $(children[index]).removeClass("k-state-selected");
	                }
	            }

	            return removed;
	        },

	        _getSkip: function(index, take) {
	            var page = index < take ? 1 : Math.floor(index / take) + 1;

	            return (page - 1) * take;
	        },

	        _select: function(indexes) {
	            var that = this,
	                singleSelection = this.options.selectable !== "multiple",
	                dataSource = this.dataSource,
	                dataItem, oldSkip,
	                take = this.itemCount,
	                valueGetter = this._valueGetter,
	                added = [];

	            if (singleSelection) {
	                that._selectedIndexes = [];
	                that._selectedDataItems = [];
	                that._values = [];
	            }

	            oldSkip = dataSource.skip();

	            $.each(indexes, function(_, index) {
	                var skip = that._getSkip(index, take);

	                that.mute(function() {
	                    dataSource.range(skip, take); //switch the range to get the dataItem

	                    dataItem = that._findDataItem(dataSource.view(), [index - skip]);
	                    that._selectedIndexes.push(index);
	                    that._selectedDataItems.push(dataItem);
	                    that._values.push(isPrimitive(dataItem) ? dataItem : valueGetter(dataItem));

	                    added.push({
	                        index: index,
	                        dataItem: dataItem
	                    });

	                    that._getElementByIndex(index).addClass(SELECTED);

	                    dataSource.range(oldSkip, take); //switch back the range
	                });
	            });

	            that._values = that._checkValuesOrder(that._values);

	            return added;
	        },

	        _clickHandler: function(e) {
	            var item = $(e.currentTarget);

	            if (!e.isDefaultPrevented() && item.attr("data-uid")) {
	                this.trigger(CLICK, { item: item });
	            }
	        },

	        _buildValueGetter: function() {
	            this._valueGetter = kendo.getter(this.options.dataValueField);
	        },

	        _calculateGroupPadding: function (height) {
	            var firstItem = this.items().first(),
	                groupHeader = this.header,
	                padding = 0;

	            if (groupHeader[0] && groupHeader[0].style.display !== "none") {
	                if (height !== "auto") {
	                    padding = kendo.support.scrollbar();
	                }

	                padding += parseFloat(firstItem.css("border-right-width"), 10) + parseFloat(firstItem.children(".k-group").css("right"), 10);

	                groupHeader.css("padding-right", padding);
	            }
	        },

	        _calculateColumnsHeaderPadding: function () {
	            if(this.options.columns && this.options.columns.length){
	                var isRtl = kendo.support.isRtl(this.wrapper);
	                var scrollbar = kendo.support.scrollbar();
	                var columnsHeader = this.content.parent().parent().find(".k-grid-header");
	                var total = this.dataSource.total();

	                columnsHeader.css((isRtl ? "padding-left" : "padding-right"), total ? scrollbar : 0);
	            }
	        }

	    });

	    kendo.ui.VirtualList = VirtualList;
	    kendo.ui.plugin(VirtualList);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1048)))

/***/ })

/******/ });

/***/ }),

/***/ "bP2e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var eventService_1 = __webpack_require__("k5uU");
var events_1 = __webpack_require__("3ok8");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var selectionController_1 = __webpack_require__("D4cr");
var valueService_1 = __webpack_require__("5JVC");
var columnController_1 = __webpack_require__("77lH");
var columnApi_1 = __webpack_require__("E/Wy");
var context_1 = __webpack_require__("RQ1/");
var constants_1 = __webpack_require__("ZZFX");
var utils_1 = __webpack_require__("IRr6");
var valueCache_1 = __webpack_require__("uKqK");
var gridApi_1 = __webpack_require__("BAow");
var RowNode = (function () {
    function RowNode() {
        /** Children mapped by the pivot columns */
        this.childrenMapped = {};
        this.selected = false;
    }
    RowNode.prototype.setData = function (data) {
        var oldData = this.data;
        this.data = data;
        this.valueCache.onDataChanged();
        var event = this.createDataChangedEvent(data, oldData, false);
        this.dispatchLocalEvent(event);
    };
    RowNode.prototype.createDataChangedEvent = function (newData, oldData, update) {
        return {
            type: RowNode.EVENT_DATA_CHANGED,
            node: this,
            oldData: oldData,
            newData: newData,
            update: update
        };
    };
    RowNode.prototype.createLocalRowEvent = function (type) {
        return {
            type: type,
            node: this
        };
    };
    // similar to setRowData, however it is expected that the data is the same data item. this
    // is intended to be used with Redux type stores, where the whole data can be changed. we are
    // guaranteed that the data is the same entity (so grid doesn't need to worry about the id of the
    // underlying data changing, hence doesn't need to worry about selection). the grid, upon receiving
    // dataChanged event, will refresh the cells rather than rip them all out (so user can show transitions).
    RowNode.prototype.updateData = function (data) {
        var oldData = this.data;
        this.data = data;
        var event = this.createDataChangedEvent(data, oldData, true);
        this.dispatchLocalEvent(event);
    };
    RowNode.prototype.getRowIndexString = function () {
        if (this.rowPinned === constants_1.Constants.PINNED_TOP) {
            return 't-' + this.rowIndex;
        }
        else if (this.rowPinned === constants_1.Constants.PINNED_BOTTOM) {
            return 'b-' + this.rowIndex;
        }
        else {
            return this.rowIndex.toString();
        }
    };
    RowNode.prototype.createDaemonNode = function () {
        var oldNode = new RowNode();
        this.context.wireBean(oldNode);
        // just copy the id and data, this is enough for the node to be used
        // in the selection controller (the selection controller is the only
        // place where daemon nodes can live).
        oldNode.id = this.id;
        oldNode.data = this.data;
        oldNode.daemon = true;
        oldNode.selected = this.selected;
        oldNode.level = this.level;
        return oldNode;
    };
    RowNode.prototype.setDataAndId = function (data, id) {
        var oldNode = utils_1.Utils.exists(this.id) ? this.createDaemonNode() : null;
        var oldData = this.data;
        this.data = data;
        this.setId(id);
        this.selectionController.syncInRowNode(this, oldNode);
        var event = this.createDataChangedEvent(data, oldData, false);
        this.dispatchLocalEvent(event);
    };
    RowNode.prototype.setId = function (id) {
        // see if user is providing the id's
        var getRowNodeId = this.gridOptionsWrapper.getRowNodeIdFunc();
        if (getRowNodeId) {
            // if user is providing the id's, then we set the id only after the data has been set.
            // this is important for virtual pagination and viewport, where empty rows exist.
            if (this.data) {
                this.id = getRowNodeId(this.data);
            }
            else {
                // this can happen if user has set blank into the rowNode after the row previously
                // having data. this happens in virtual page row model, when data is delete and
                // the page is refreshed.
                this.id = undefined;
            }
        }
        else {
            this.id = id;
        }
    };
    RowNode.prototype.isPixelInRange = function (pixel) {
        return pixel >= this.rowTop && pixel < (this.rowTop + this.rowHeight);
    };
    RowNode.prototype.clearRowTop = function () {
        this.oldRowTop = this.rowTop;
        this.setRowTop(null);
    };
    RowNode.prototype.setFirstChild = function (firstChild) {
        if (this.firstChild === firstChild) {
            return;
        }
        this.firstChild = firstChild;
        if (this.eventService) {
            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_FIRST_CHILD_CHANGED));
        }
    };
    RowNode.prototype.setLastChild = function (lastChild) {
        if (this.lastChild === lastChild) {
            return;
        }
        this.lastChild = lastChild;
        if (this.eventService) {
            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_LAST_CHILD_CHANGED));
        }
    };
    RowNode.prototype.setChildIndex = function (childIndex) {
        if (this.childIndex === childIndex) {
            return;
        }
        this.childIndex = childIndex;
        if (this.eventService) {
            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_CHILD_INDEX_CHANGED));
        }
    };
    RowNode.prototype.setRowTop = function (rowTop) {
        if (this.rowTop === rowTop) {
            return;
        }
        this.rowTop = rowTop;
        if (this.eventService) {
            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_TOP_CHANGED));
        }
    };
    RowNode.prototype.setDragging = function (dragging) {
        if (this.dragging === dragging) {
            return;
        }
        this.dragging = dragging;
        if (this.eventService) {
            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_DRAGGING_CHANGED));
        }
    };
    RowNode.prototype.setAllChildrenCount = function (allChildrenCount) {
        if (this.allChildrenCount === allChildrenCount) {
            return;
        }
        this.allChildrenCount = allChildrenCount;
        if (this.eventService) {
            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED));
        }
    };
    RowNode.prototype.setRowHeight = function (rowHeight) {
        this.rowHeight = rowHeight;
        if (this.eventService) {
            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_HEIGHT_CHANGED));
        }
    };
    RowNode.prototype.setRowIndex = function (rowIndex) {
        this.rowIndex = rowIndex;
        if (this.eventService) {
            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_ROW_INDEX_CHANGED));
        }
    };
    RowNode.prototype.setUiLevel = function (uiLevel) {
        if (this.uiLevel === uiLevel) {
            return;
        }
        this.uiLevel = uiLevel;
        if (this.eventService) {
            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_UI_LEVEL_CHANGED));
        }
    };
    RowNode.prototype.setExpanded = function (expanded) {
        if (this.expanded === expanded) {
            return;
        }
        this.expanded = expanded;
        if (this.eventService) {
            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_EXPANDED_CHANGED));
        }
        var event = this.createGlobalRowEvent(events_1.Events.EVENT_ROW_GROUP_OPENED);
        this.mainEventService.dispatchEvent(event);
    };
    RowNode.prototype.createGlobalRowEvent = function (type) {
        var event = {
            type: type,
            node: this,
            data: this.data,
            rowIndex: this.rowIndex,
            rowPinned: this.rowPinned,
            context: this.gridOptionsWrapper.getContext(),
            api: this.gridOptionsWrapper.getApi(),
            columnApi: this.gridOptionsWrapper.getColumnApi()
        };
        return event;
    };
    RowNode.prototype.dispatchLocalEvent = function (event) {
        if (this.eventService) {
            this.eventService.dispatchEvent(event);
        }
    };
    // we also allow editing the value via the editors. when it is done via
    // the editors, no 'cell changed' event gets fired, as it's assumed that
    // the cell knows about the change given it's in charge of the editing.
    // this method is for the client to call, so the cell listens for the change
    // event, and also flashes the cell when the change occurs.
    RowNode.prototype.setDataValue = function (colKey, newValue) {
        var column = this.columnController.getPrimaryColumn(colKey);
        this.valueService.setValue(this, column, newValue);
        this.dispatchCellChangedEvent(column, newValue);
    };
    RowNode.prototype.setGroupValue = function (colKey, newValue) {
        var column = this.columnController.getGridColumn(colKey);
        if (utils_1.Utils.missing(this.groupData)) {
            this.groupData = {};
        }
        this.groupData[column.getColId()] = newValue;
        this.dispatchCellChangedEvent(column, newValue);
    };
    // sets the data for an aggregation
    RowNode.prototype.setAggData = function (newAggData) {
        var _this = this;
        // find out all keys that could potentially change
        var colIds = utils_1.Utils.getAllKeysInObjects([this.aggData, newAggData]);
        this.aggData = newAggData;
        // if no event service, nobody has registered for events, so no need fire event
        if (this.eventService) {
            colIds.forEach(function (colId) {
                var column = _this.columnController.getGridColumn(colId);
                var value = _this.aggData ? _this.aggData[colId] : undefined;
                _this.dispatchCellChangedEvent(column, value);
            });
        }
    };
    RowNode.prototype.hasChildren = function () {
        // we need to return true when this.group=true, as this is used by enterprise row model
        // (as children are lazy loaded and stored in a cache anyway). otherwise we return true
        // if children exist.
        return this.group || (this.childrenAfterGroup && this.childrenAfterGroup.length > 0);
    };
    RowNode.prototype.isEmptyFillerNode = function () {
        return this.group && utils_1.Utils.missingOrEmpty(this.childrenAfterGroup);
    };
    RowNode.prototype.dispatchCellChangedEvent = function (column, newValue) {
        var cellChangedEvent = {
            type: RowNode.EVENT_CELL_CHANGED,
            node: this,
            column: column,
            newValue: newValue
        };
        this.dispatchLocalEvent(cellChangedEvent);
    };
    RowNode.prototype.resetQuickFilterAggregateText = function () {
        this.quickFilterAggregateText = null;
    };
    RowNode.prototype.isExpandable = function () {
        return this.hasChildren() || this.master;
    };
    RowNode.prototype.isSelected = function () {
        // for footers, we just return what our sibling selected state is, as cannot select a footer
        if (this.footer) {
            return this.sibling.isSelected();
        }
        return this.selected;
    };
    RowNode.prototype.depthFirstSearch = function (callback) {
        if (this.childrenAfterGroup) {
            this.childrenAfterGroup.forEach(function (child) { return child.depthFirstSearch(callback); });
        }
        callback(this);
    };
    // + rowController.updateGroupsInSelection()
    RowNode.prototype.calculateSelectedFromChildren = function () {
        var atLeastOneSelected = false;
        var atLeastOneDeSelected = false;
        var atLeastOneMixed = false;
        var newSelectedValue;
        if (this.childrenAfterGroup) {
            for (var i = 0; i < this.childrenAfterGroup.length; i++) {
                var childState = this.childrenAfterGroup[i].isSelected();
                switch (childState) {
                    case true:
                        atLeastOneSelected = true;
                        break;
                    case false:
                        atLeastOneDeSelected = true;
                        break;
                    default:
                        atLeastOneMixed = true;
                        break;
                }
            }
        }
        if (atLeastOneMixed) {
            newSelectedValue = undefined;
        }
        else if (atLeastOneSelected && !atLeastOneDeSelected) {
            newSelectedValue = true;
        }
        else if (!atLeastOneSelected && atLeastOneDeSelected) {
            newSelectedValue = false;
        }
        else {
            newSelectedValue = undefined;
        }
        this.selectThisNode(newSelectedValue);
    };
    RowNode.prototype.calculateSelectedFromChildrenBubbleUp = function () {
        this.calculateSelectedFromChildren();
        if (this.parent) {
            this.parent.calculateSelectedFromChildrenBubbleUp();
        }
    };
    RowNode.prototype.setSelectedInitialValue = function (selected) {
        this.selected = selected;
    };
    RowNode.prototype.setSelected = function (newValue, clearSelection, tailingNodeInSequence) {
        if (clearSelection === void 0) { clearSelection = false; }
        if (tailingNodeInSequence === void 0) { tailingNodeInSequence = false; }
        this.setSelectedParams({
            newValue: newValue,
            clearSelection: clearSelection,
            tailingNodeInSequence: tailingNodeInSequence,
            rangeSelect: false
        });
    };
    RowNode.prototype.isRowPinned = function () {
        return this.rowPinned === constants_1.Constants.PINNED_TOP || this.rowPinned === constants_1.Constants.PINNED_BOTTOM;
    };
    // to make calling code more readable, this is the same method as setSelected except it takes names parameters
    RowNode.prototype.setSelectedParams = function (params) {
        var groupSelectsChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
        var newValue = params.newValue === true;
        var clearSelection = params.clearSelection === true;
        var tailingNodeInSequence = params.tailingNodeInSequence === true;
        var rangeSelect = params.rangeSelect === true;
        // groupSelectsFiltered only makes sense when group selects children
        var groupSelectsFiltered = groupSelectsChildren && (params.groupSelectsFiltered === true);
        if (this.id === undefined) {
            console.warn('ag-Grid: cannot select node until id for node is known');
            return 0;
        }
        if (this.rowPinned) {
            console.log('ag-Grid: cannot select pinned rows');
            return 0;
        }
        // if we are a footer, we don't do selection, just pass the info
        // to the sibling (the parent of the group)
        if (this.footer) {
            var count = this.sibling.setSelectedParams(params);
            return count;
        }
        if (rangeSelect) {
            var newRowClicked = this.selectionController.getLastSelectedNode() !== this;
            var allowMultiSelect = this.gridOptionsWrapper.isRowSelectionMulti();
            if (newRowClicked && allowMultiSelect) {
                return this.doRowRangeSelection();
            }
        }
        var updatedCount = 0;
        // when groupSelectsFiltered, then this node may end up intermediate despite
        // trying to set it to true / false. this group will be calculated further on
        // down when we call calculatedSelectedForAllGroupNodes(). we need to skip it
        // here, otherwise the updatedCount would include it.
        var skipThisNode = groupSelectsFiltered && this.group;
        if (!skipThisNode) {
            var thisNodeWasSelected = this.selectThisNode(newValue);
            if (thisNodeWasSelected) {
                updatedCount++;
            }
        }
        if (groupSelectsChildren && this.group) {
            updatedCount += this.selectChildNodes(newValue, groupSelectsFiltered);
        }
        // clear other nodes if not doing multi select
        var actionWasOnThisNode = !tailingNodeInSequence;
        if (actionWasOnThisNode) {
            if (newValue && (clearSelection || !this.gridOptionsWrapper.isRowSelectionMulti())) {
                updatedCount += this.selectionController.clearOtherNodes(this);
            }
            // only if we selected something, then update groups and fire events
            if (updatedCount > 0) {
                // update groups
                if (groupSelectsFiltered) {
                    // if the group was selecting filtered, then all nodes above and or below
                    // this node could have check, unchecked or intermediate, so easiest is to
                    // recalculate selected state for all group nodes
                    this.calculatedSelectedForAllGroupNodes();
                }
                else {
                    // if no selecting filtered, then everything below the group node was either
                    // selected or not selected, no intermediate, so no need to check items below
                    // this one, just the parents all the way up to the root
                    if (groupSelectsChildren && this.parent) {
                        this.parent.calculateSelectedFromChildrenBubbleUp();
                    }
                }
                // fire events
                // this is the very end of the 'action node', so we are finished all the updates,
                // include any parent / child changes that this method caused
                var event_1 = {
                    type: events_1.Events.EVENT_SELECTION_CHANGED,
                    api: this.gridApi,
                    columnApi: this.columnApi
                };
                this.mainEventService.dispatchEvent(event_1);
            }
            // so if user next does shift-select, we know where to start the selection from
            if (newValue) {
                this.selectionController.setLastSelectedNode(this);
            }
        }
        return updatedCount;
    };
    // selects all rows between this node and the last selected node (or the top if this is the first selection).
    // not to be mixed up with 'cell range selection' where you drag the mouse, this is row range selection, by
    // holding down 'shift'.
    RowNode.prototype.doRowRangeSelection = function () {
        var updatedCount = 0;
        var groupsSelectChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
        var lastSelectedNode = this.selectionController.getLastSelectedNode();
        var nodesToSelect = this.rowModel.getNodesInRangeForSelection(lastSelectedNode, this);
        nodesToSelect.forEach(function (rowNode) {
            if (rowNode.group && groupsSelectChildren) {
                return;
            }
            var nodeWasSelected = rowNode.selectThisNode(true);
            if (nodeWasSelected) {
                updatedCount++;
            }
        });
        if (groupsSelectChildren) {
            this.calculatedSelectedForAllGroupNodes();
        }
        var event = {
            type: events_1.Events.EVENT_SELECTION_CHANGED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.mainEventService.dispatchEvent(event);
        return updatedCount;
    };
    RowNode.prototype.isParentOfNode = function (potentialParent) {
        var parentNode = this.parent;
        while (parentNode) {
            if (parentNode === potentialParent) {
                return true;
            }
            parentNode = parentNode.parent;
        }
        return false;
    };
    RowNode.prototype.calculatedSelectedForAllGroupNodes = function () {
        // we have to make sure we do this dept first, as parent nodes
        // will have dependencies on the children having correct values
        var inMemoryRowModel = this.rowModel;
        inMemoryRowModel.getTopLevelNodes().forEach(function (topLevelNode) {
            if (topLevelNode.group) {
                topLevelNode.depthFirstSearch(function (childNode) {
                    if (childNode.group) {
                        childNode.calculateSelectedFromChildren();
                    }
                });
                topLevelNode.calculateSelectedFromChildren();
            }
        });
    };
    RowNode.prototype.selectThisNode = function (newValue) {
        if (this.selected === newValue) {
            return false;
        }
        this.selected = newValue;
        if (this.eventService) {
            this.dispatchLocalEvent(this.createLocalRowEvent(RowNode.EVENT_ROW_SELECTED));
        }
        var event = this.createGlobalRowEvent(events_1.Events.EVENT_ROW_SELECTED);
        this.mainEventService.dispatchEvent(event);
        return true;
    };
    RowNode.prototype.selectChildNodes = function (newValue, groupSelectsFiltered) {
        var children = groupSelectsFiltered ? this.childrenAfterFilter : this.childrenAfterGroup;
        var updatedCount = 0;
        if (utils_1.Utils.missing(children)) {
            return;
        }
        for (var i = 0; i < children.length; i++) {
            updatedCount += children[i].setSelectedParams({
                newValue: newValue,
                clearSelection: false,
                tailingNodeInSequence: true
            });
        }
        return updatedCount;
    };
    RowNode.prototype.addEventListener = function (eventType, listener) {
        if (!this.eventService) {
            this.eventService = new eventService_1.EventService();
        }
        this.eventService.addEventListener(eventType, listener);
    };
    RowNode.prototype.removeEventListener = function (eventType, listener) {
        this.eventService.removeEventListener(eventType, listener);
    };
    RowNode.prototype.onMouseEnter = function () {
        this.dispatchLocalEvent(this.createLocalRowEvent(RowNode.EVENT_MOUSE_ENTER));
    };
    RowNode.prototype.onMouseLeave = function () {
        this.dispatchLocalEvent(this.createLocalRowEvent(RowNode.EVENT_MOUSE_LEAVE));
    };
    RowNode.prototype.getFirstChildOfFirstChild = function (rowGroupColumn) {
        var currentRowNode = this;
        // if we are hiding groups, then if we are the first child, of the first child,
        // all the way up to the column we are interested in, then we show the group cell.
        var isCandidate = true;
        var foundFirstChildPath = false;
        var nodeToSwapIn;
        while (isCandidate && !foundFirstChildPath) {
            var parentRowNode = currentRowNode.parent;
            var firstChild = utils_1.Utils.exists(parentRowNode) && currentRowNode.firstChild;
            if (firstChild) {
                if (parentRowNode.rowGroupColumn === rowGroupColumn) {
                    foundFirstChildPath = true;
                    nodeToSwapIn = parentRowNode;
                }
            }
            else {
                isCandidate = false;
            }
            currentRowNode = parentRowNode;
        }
        return foundFirstChildPath ? nodeToSwapIn : null;
    };
    RowNode.EVENT_ROW_SELECTED = 'rowSelected';
    RowNode.EVENT_DATA_CHANGED = 'dataChanged';
    RowNode.EVENT_CELL_CHANGED = 'cellChanged';
    RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED = 'allChildrenCountChanged';
    RowNode.EVENT_MOUSE_ENTER = 'mouseEnter';
    RowNode.EVENT_MOUSE_LEAVE = 'mouseLeave';
    RowNode.EVENT_HEIGHT_CHANGED = 'heightChanged';
    RowNode.EVENT_TOP_CHANGED = 'topChanged';
    RowNode.EVENT_FIRST_CHILD_CHANGED = 'firstChildChanged';
    RowNode.EVENT_LAST_CHILD_CHANGED = 'lastChildChanged';
    RowNode.EVENT_CHILD_INDEX_CHANGED = 'childIndexChanged';
    RowNode.EVENT_ROW_INDEX_CHANGED = 'rowIndexChanged';
    RowNode.EVENT_EXPANDED_CHANGED = 'expandedChanged';
    RowNode.EVENT_UI_LEVEL_CHANGED = 'uiLevelChanged';
    RowNode.EVENT_DRAGGING_CHANGED = 'draggingChanged';
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], RowNode.prototype, "mainEventService", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], RowNode.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('selectionController'),
        __metadata("design:type", selectionController_1.SelectionController)
    ], RowNode.prototype, "selectionController", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], RowNode.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('valueService'),
        __metadata("design:type", valueService_1.ValueService)
    ], RowNode.prototype, "valueService", void 0);
    __decorate([
        context_1.Autowired('rowModel'),
        __metadata("design:type", Object)
    ], RowNode.prototype, "rowModel", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], RowNode.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('valueCache'),
        __metadata("design:type", valueCache_1.ValueCache)
    ], RowNode.prototype, "valueCache", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], RowNode.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], RowNode.prototype, "gridApi", void 0);
    return RowNode;
}());
exports.RowNode = RowNode;


/***/ }),

/***/ "bR1D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var RichSelectRow = (function (_super) {
    __extends(RichSelectRow, _super);
    function RichSelectRow(columnDef) {
        var _this = _super.call(this, '<div class="ag-rich-select-row"></div>') || this;
        _this.columnDef = columnDef;
        return _this;
    }
    RichSelectRow.prototype.setState = function (value, valueFormatted, selected) {
        var rendererSuccessful = this.populateWithRenderer(value, valueFormatted);
        if (!rendererSuccessful) {
            this.populateWithoutRenderer(value, valueFormatted);
        }
        main_1.Utils.addOrRemoveCssClass(this.getGui(), 'ag-rich-select-row-selected', selected);
    };
    RichSelectRow.prototype.populateWithoutRenderer = function (value, valueFormatted) {
        var valueFormattedExits = valueFormatted !== null && valueFormatted !== undefined;
        var valueToRender = valueFormattedExits ? valueFormatted : value;
        if (main_1.Utils.exists(valueToRender) && valueToRender !== '') {
            // not using innerHTML to prevent injection of HTML
            // https://developer.mozilla.org/en-US/docs/Web/API/Element/innerHTML#Security_considerations
            this.getGui().textContent = valueToRender.toString();
        }
        else {
            // putting in blank, so if missing, at least the user can click on it
            this.getGui().innerHTML = '&nbsp;';
        }
    };
    RichSelectRow.prototype.populateWithRenderer = function (value, valueFormatted) {
        var _this = this;
        var promise = this.cellRendererService.useRichSelectCellRenderer(this.columnDef, this.getGui(), { value: value, valueFormatted: valueFormatted });
        var foundRenderer = main_1._.exists(promise);
        if (foundRenderer) {
            promise.then(function (childComponent) {
                if (childComponent && childComponent.destroy) {
                    _this.addDestroyFunc(childComponent.destroy.bind(childComponent));
                }
            });
            return true;
        }
        else {
            return false;
        }
    };
    __decorate([
        main_1.Autowired('cellRendererService'),
        __metadata("design:type", main_1.CellRendererService)
    ], RichSelectRow.prototype, "cellRendererService", void 0);
    return RichSelectRow;
}(main_1.Component));
exports.RichSelectRow = RichSelectRow;


/***/ }),

/***/ "bWAB":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1629);
	module.exports = __webpack_require__(1629);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1kkP");

/***/ }),

/***/ 953:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 967:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CRfZ");

/***/ }),

/***/ 969:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("3Bvt");

/***/ }),

/***/ 1030:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nce5");

/***/ }),

/***/ 1629:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1030), __webpack_require__(969), __webpack_require__(6), __webpack_require__(967), __webpack_require__(953), __webpack_require__(1630) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    /* jshint eqnull:true */

	    var $ = kendo.jQuery;

	    var ToolBar = kendo.ui.ToolBar;

	    var MESSAGES = kendo.spreadsheet.messages.toolbar = {
	        addColumnLeft: "Add column left",
	        addColumnRight: "Add column right",
	        addRowAbove: "Add row above",
	        addRowBelow: "Add row below",
	        alignment: "Alignment",
	        alignmentButtons: {
	            justtifyLeft: "Align left",
	            justifyCenter: "Center",
	            justifyRight: "Align right",
	            justifyFull: "Justify",
	            alignTop: "Align top",
	            alignMiddle: "Align middle",
	            alignBottom: "Align bottom"
	        },
	        backgroundColor: "Background",
	        bold: "Bold",
	        borders: "Borders",
	        copy: "Copy",
	        cut: "Cut",
	        deleteColumn: "Delete column",
	        deleteRow: "Delete row",
	        filter: "Filter",
	        fontFamily: "Font",
	        fontSize: "Font size",
	        format: "Custom format...",
	        formatTypes: {
	            automatic: "Automatic",
	            text: "Text",
	            number: "Number",
	            percent: "Percent",
	            financial: "Financial",
	            currency: "Currency",
	            date: "Date",
	            time: "Time",
	            dateTime: "Date time",
	            duration: "Duration",
	            moreFormats: "More formats..."
	        },
	        formatDecreaseDecimal: "Decrease decimal",
	        formatIncreaseDecimal: "Increase decimal",
	        freeze: "Freeze panes",
	        freezeButtons: {
	            freezePanes: "Freeze panes",
	            freezeRows: "Freeze rows",
	            freezeColumns: "Freeze columns",
	            unfreeze: "Unfreeze panes"
	        },
	        insertComment: "Insert comment",
	        insertImage: "Insert image",
	        italic: "Italic",
	        merge: "Merge cells",
	        mergeButtons: {
	            mergeCells: "Merge all",
	            mergeHorizontally: "Merge horizontally",
	            mergeVertically: "Merge vertically",
	            unmerge: "Unmerge"
	        },
	        open: "Open...",
	        paste: "Paste",
	        quickAccess: {
	            redo: "Redo",
	            undo: "Undo"
	        },
	        exportAs: "Export...",
	        toggleGridlines: "Toggle gridlines",
	        sort: "Sort",
	        sortButtons: {
	            // sortSheetAsc: "Sort sheet A to Z",
	            // sortSheetDesc: "Sort sheet Z to A",
	            sortRangeAsc: "Sort range A to Z",
	            sortRangeDesc: "Sort range Z to A"
	        },
	        textColor: "Text Color",
	        textWrap: "Wrap text",
	        underline: "Underline",
	        validation: "Data validation...",
	        hyperlink: "Link"
	    };

	    var defaultTools = {
	        home: [
	            "open",
	            "exportAs",
	            [ "cut", "copy", "paste" ],
	            [ "bold", "italic", "underline" ], "hyperlink", "insertComment", "insertImage",
	            "backgroundColor", "textColor",
	            "borders",
	            "fontSize", "fontFamily",
	            "alignment",
	            "textWrap",
	            [ "formatDecreaseDecimal", "formatIncreaseDecimal" ],
	            "format",
	            "merge",
	            "freeze",
	            "filter",
	            "toggleGridlines"
	        ],
	        insert: [
	            [ "addColumnLeft", "addColumnRight", "addRowBelow", "addRowAbove" ],
	            [ "deleteColumn", "deleteRow" ]
	        ],
	        data: [
	            "sort",
	            "filter",
	            "validation"
	        ]
	    };

	    var toolDefaults = {
	        //home tab
	        open:                  { type: "open",                                     overflow: "never",                          iconClass: "file-excel" },
	        exportAs:              { type: "exportAsDialog", dialogName: "exportAs",   overflow: "never",       text: "",        iconClass: "file-excel" },
	        bold:                  { type: "button", command: "PropertyChangeCommand", property: "bold",          value: true,     iconClass: "bold", togglable: true },
	        italic:                { type: "button", command: "PropertyChangeCommand", property: "italic",        value: true,     iconClass: "italic", togglable: true },
	        underline:             { type: "button", command: "PropertyChangeCommand", property: "underline",     value: true,     iconClass: "underline", togglable: true },
	        formatDecreaseDecimal: { type: "button", command: "AdjustDecimalsCommand",                            value: -1,       iconClass: "decimal-decrease" },
	        formatIncreaseDecimal: { type: "button", command: "AdjustDecimalsCommand",                            value: +1,       iconClass: "decimal-increase" },
	        textWrap:              { type: "button", command: "TextWrapCommand",       property: "wrap",          value: true,     iconClass: "text-wrap", togglable: true },
	        cut:                   { type: "button", command: "ToolbarCutCommand",                                                 iconClass: "cut" },
	        copy:                  { type: "button", command: "ToolbarCopyCommand",                                                iconClass: "copy" },
	        paste:                 { type: "button", command: "ToolbarPasteCommand",                                               iconClass: "paste" },
	        separator:             { type: "separator" },
	        alignment:             { type: "alignment",                           iconClass: "align-left" },
	        backgroundColor:       { type: "colorPicker", property: "background", iconClass: "paint" },
	        textColor:             { type: "colorPicker", property: "color",      iconClass: "foreground-color" },
	        fontFamily:            { type: "fontFamily",  property: "fontFamily", iconClass: "font-family" },
	        fontSize:              { type: "fontSize",    property: "fontSize",   iconClass: "font-size" },
	        format:                { type: "format",      property: "format",     iconClass: "custom-format" },
	        filter:                { type: "filter",      property: "hasFilter",  iconClass: "filter" },
	        merge:                 { type: "merge",                               iconClass: "cells-merge" },
	        freeze:                { type: "freeze",                              iconClass: "pane-freeze" },
	        borders:               { type: "borders",                             iconClass: "borders-all" },
	        formatCells:           { type: "dialog", dialogName: "formatCells", overflow: "never" },
	        hyperlink:             { type: "dialog", dialogName: "hyperlink", iconClass: "link-horizontal", overflow: "never", text: "" },
	        toggleGridlines:       { type: "button", command: "GridLinesChangeCommand", property: "gridLines", value: true, iconClass: "border-no", togglable: true },
	        insertComment:         { type: "dialog", dialogName: "insertComment", property: "comment", togglable: true, overflow: "never", iconClass: "comment", text: "" },
	        insertImage:           { type: "dialog", dialogName: "insertImage", overflow: "never", iconClass: "image", text: "" },

	        //insert tab
	        addColumnLeft:         { type: "button", command: "AddColumnCommand",    value: "left",  iconClass: "table-column-insert-left"  },
	        addColumnRight:        { type: "button", command: "AddColumnCommand",    value: "right", iconClass: "table-column-insert-right" },
	        addRowBelow:           { type: "button", command: "AddRowCommand",       value: "below", iconClass: "table-row-insert-below"    },
	        addRowAbove:           { type: "button", command: "AddRowCommand",       value: "above", iconClass: "table-row-insert-above"    },
	        deleteColumn:          { type: "button", command: "DeleteColumnCommand",                 iconClass: "table-column-delete"    },
	        deleteRow:             { type: "button", command: "DeleteRowCommand",                    iconClass: "table-row-delete"       },

	        //data tab
	        sort:                  { type: "sort", iconClass: "sort-desc" },
	        validation:            { type: "dialog", dialogName: "validation", iconClass: "exception", overflow: "never" }
	    };

	    var SpreadsheetToolBar = ToolBar.extend({
	        init: function(element, options) {
	            options.items = this._expandTools(options.tools || SpreadsheetToolBar.prototype.options.tools[options.toolbarName]);

	            ToolBar.fn.init.call(this, element, options);
	            var handleClick = this._click.bind(this);

	            this.element.addClass("k-spreadsheet-toolbar");

	            this._addSeparators(this.element);
	            var that = this;
	            this.element.on("keydown", function (e) {
	                var tool;
	                if (e.keyCode === 9) {
	                    tool = that._nextTool(e.shiftKey ? -1 : 1);
	                    if (tool) {
	                        document.activeElement.blur();
	                        if ($(tool).is(".k-upload-button")) {
	                            $(tool).addClass("k-state-focused");
	                        }
	                        if($(tool).find("input").length) {
	                            $(tool).find("input").focus();
	                        } else {
	                            tool.focus();
	                        }
	                        e.preventDefault();
	                    }
	                }
	            });

	            this.element.on("focusout", function () {
	                $(this).find(".k-toolbar-first-visible").removeClass("k-state-focused");
	            });

	            this.bind({
	                click: handleClick,
	                toggle: handleClick
	            });
	        },
	        _nextTool: function (direction) {
	            var that = this;
	            var tools = that.element.find(".k-widget, .k-button, .k-button-group > a");
	            var activeIndex = tools.index($(document.activeElement).closest(".k-widget, .k-button, .k-button-group > a"));
	            if (activeIndex > 0) {
	                return tools[activeIndex + direction];
	            }
	        },
	        _addSeparators: function(element) {
	            var groups = element.children(".k-widget, a.k-button, .k-button-group");

	            groups.before("<span class='k-separator'></span>");
	        },
	        _expandTools: function(tools) {
	            function expandTool(toolName) {
	                // expand string to object, add missing tool properties
	                var options = $.isPlainObject(toolName) ? toolName : toolDefaults[toolName] || {};
	                var spriteCssClass = "k-icon k-i-" + options.iconClass;
	                var type = options.type;
	                var typeDefaults = {
	                    button: {
	                        showText: "overflow"
	                    },
	                    colorPicker: {
	                        toolIcon: spriteCssClass,
	                        spriteCssClass: spriteCssClass
	                    },
	                    borders: { spriteCssClass: spriteCssClass },
	                    alignment:  { spriteCssClass: spriteCssClass },
	                    merge:  { spriteCssClass: spriteCssClass },
	                    freeze:  { spriteCssClass: spriteCssClass }
	                };

	                var tool = kendo.deepExtend({
	                    name: options.name || toolName,
	                    text: MESSAGES[options.name || toolName],
	                    icon: options.iconClass,
	                    attributes: {
	                        title: MESSAGES[options.name || toolName],
	                        "aria-label":   MESSAGES[options.name || toolName]
	                    }
	                }, typeDefaults[type], options);

	                if (type == "splitButton") {
	                    tool.menuButtons = tool.menuButtons.map(expandTool);
	                }

	                tool.attributes["data-tool"] = toolName;

	                if (options.property) {
	                    tool.attributes["data-property"] = options.property;
	                }

	                return tool;
	            }

	            return tools.reduce(function(tools, tool) {
	                if ($.isArray(tool)) {
	                    tools.push({ type: "buttonGroup", buttons: tool.map(expandTool) });
	                } else {
	                    tools.push(expandTool.call(this, tool));
	                }

	                return tools;
	            }, []);
	        },
	        _click: function(e) {
	            var toolName = e.target.attr("data-tool");
	            var tool = toolDefaults[toolName] || {};
	            var commandType = tool.command;

	            if (!commandType) {
	                return;
	            }

	            var args = {
	                command: commandType,
	                options: {
	                    property: tool.property || null,
	                    value: tool.value || null
	                }
	            };

	            if (typeof args.options.value === "boolean") {
	                args.options.value = e.checked ? true : null;
	            }

	            this.action(args);
	        },
	        events: [
	            "click",
	            "toggle",
	            "open",
	            "close",
	            "overflowOpen",
	            "overflowClose",

	            "action",
	            "dialog"
	        ],
	        options: {
	            name: "SpreadsheetToolBar",
	            resizable: true,
	            tools: defaultTools
	        },
	        action: function(args) {
	            this.trigger("action", args);
	        },
	        dialog: function(args) {
	            this.trigger("dialog", args);
	        },
	        refresh: function(activeCell) {
	            var range = activeCell;
	            var tools = this._tools();

	            function setToggle(tool, value) {
	                var toolbar = tool.toolbar;
	                var overflow = tool.overflow;
	                var togglable = (toolbar && toolbar.options.togglable) ||
	                                 (overflow && overflow.options.togglable);

	                if (!togglable) {
	                    return;
	                }

	                var toggle = false;

	                if (typeof value === "boolean") {
	                    toggle = value;
	                } else if (typeof value === "string") {
	                    if (toolbar.options.hasOwnProperty("value")) {
	                        toggle = toolbar.options.value === value;
	                    } else {
	                        // if no value is specified in the tool
	                        // options, assume it should be ON if the
	                        // range value is not null, and OFF otherwise.
	                        toggle = value != null;
	                    }
	                }

	                toolbar.toggle(toggle);

	                if (overflow) {
	                    overflow.toggle(toggle);
	                }
	            }

	            function update(tool, value) {
	                var toolbar = tool.toolbar;
	                var overflow = tool.overflow;

	                if (toolbar && toolbar.update) {
	                    toolbar.update(value);
	                }

	                if (overflow && overflow.update) {
	                    overflow.update(value);
	                }
	            }

	            for (var i = 0; i < tools.length; i++) {
	                var property = tools[i].property;
	                var tool = tools[i].tool;
	                var value = kendo.isFunction(range[property]) ? range[property]() : range;

	                if (property == "gridLines") {
	                    // the law of leaky abstractions kicks in.  this
	                    // isn't really a property of the range, it's
	                    // per-sheet.
	                    value = range.sheet().showGridLines();
	                }

	                if (tool.type === "button") {
	                    setToggle(tool, value);
	                } else {
	                    update(tool, value);
	                }
	            }
	            this.resize();
	        },
	        _tools: function() {
	            return this.element.find("[data-property]").toArray().map(function(element) {
	                element = $(element);
	                return {
	                    property: element.attr("data-property"),
	                    tool: this._getItem(element)
	                };
	            }.bind(this));
	        },
	        destroy: function() {
	            // TODO: move to ToolBar.destroy to take care of these
	            this.element.find("[data-command],.k-button").each(function() {
	                var element = $(this);
	                var instance = element.data("instance");
	                if (instance && instance.destroy) {
	                    instance.destroy();
	                }
	            });

	            ToolBar.fn.destroy.call(this);
	        }
	    });
	    kendo.spreadsheet.ToolBar = SpreadsheetToolBar;

	    var DropDownTool = kendo.toolbar.Item.extend({
	        init: function(options, toolbar) {
	            var dropDownList = $("<select />")
	                .attr("title", options.attributes.title)
	                .attr("aria-label", options.attributes.title)
	                .kendoDropDownList({
	                    height: "auto"
	                }).data("kendoDropDownList");

	            this.dropDownList = dropDownList;
	            this.element = dropDownList.wrapper;
	            this.options = options;
	            this.toolbar = toolbar;

	            this.attributes();
	            this.addUidAttr();
	            this.addOverflowAttr();

	            dropDownList.bind("open", this._open.bind(this));
	            dropDownList.bind("change", this._change.bind(this));

	            this.element.width(options.width).attr({
	                "data-command": "PropertyChangeCommand",
	                "data-property": options.property
	            });
	        },
	        _open: function() {
	            var ddl = this.dropDownList;
	            var list = ddl.list;
	            var listWidth;

	            list.css({
	                whiteSpace: "nowrap",
	                width: "auto"
	            });

	            listWidth = list.width();

	            if (listWidth > 0) {
	                listWidth += 20;
	            } else {
	                listWidth = ddl._listWidth;
	            }

	            list.css("width", listWidth + kendo.support.scrollbar());

	            ddl._listWidth = listWidth;
	        },
	        _change: function(e) {
	            var that = this;
	            var instance = e.sender;
	            var value = instance.value();
	            var dataItem = instance.dataItem();
	            var popupName = dataItem ? dataItem.popup : undefined;

	            if (popupName) {
	                setTimeout(function () {
	                    that.toolbar.dialog({ name: popupName });
	                });
	            } else {
	                that.toolbar.action({
	                    command: "PropertyChangeCommand",
	                    options: {
	                        property: this.options.property,
	                        value: value == "null" ? null : value
	                    }
	                });
	            }
	        },
	        value: function(value) {
	            if (value !== undefined) {
	                this.dropDownList.value(value);
	            } else {
	                return this.dropDownList.value();
	            }
	        }
	    });

	    var PopupTool = kendo.toolbar.Item.extend({
	        init: function(options, toolbar) {
	            this.element = $("<a role='button' href='#' class='k-button k-button-icon'>" +
	                                "<span class='" + options.spriteCssClass + "'>" +
	                                "</span><span class='k-icon k-i-arrow-60-down'></span>" +
	                            "</a>");

	            this.element
	                .on("click touchend", this.open.bind(this))
	                .attr("data-command", options.command);

	            this.options = options;
	            this.toolbar = toolbar;

	            this.attributes();
	            this.addUidAttr();
	            this.addOverflowAttr();

	            this._popup();
	        },
	        destroy: function() {
	            this.popup.destroy();
	        },
	        open: function(ev) {
	            ev.preventDefault();
	            this.popup.toggle();
	        },
	        _popup: function() {
	            var element = this.element;

	            this.popup = $("<div class='k-spreadsheet-popup' />").appendTo(element).kendoPopup({
	                anchor: element
	            }).data("kendoPopup");
	        }
	    });

	    kendo.toolbar.registerComponent("dialog", kendo.toolbar.ToolBarButton.extend({
	        init: function(options, toolbar) {
	            kendo.toolbar.ToolBarButton.fn.init.call(this, options, toolbar);

	            this._dialogName = options.dialogName;

	            this.element.bind("click touchend", this.open.bind(this))
	                        .data("instance", this);
	        },
	        open: function() {
	            this.toolbar.dialog({ name: this._dialogName });
	        }
	    }));

	    kendo.toolbar.registerComponent("exportAsDialog", kendo.toolbar.Item.extend({
	        init: function(options, toolbar) {
	            this._dialogName = options.dialogName;

	            this.toolbar = toolbar;
	            this._title = options.attributes.title;
	            this.element = $("<button type='button' role='button' class='k-button k-button-icon'>" +
	                                 "<span class='k-icon k-i-download'></span>" +
	                             "</button>")
	                             .attr("title", this._title)
	                             .attr("aria-label", this._title)
	                             .data("instance", this);

	            this.element.bind("click", this.open.bind(this))
	                        .data("instance", this);
	        },
	        open: function() {
	            this.toolbar.dialog({ name: this._dialogName });
	        }
	    }));

	    var OverflowDialogButton = kendo.toolbar.OverflowButton.extend({
	        init: function(options, toolbar) {
	            kendo.toolbar.OverflowButton.fn.init.call(this, options, toolbar);

	            this.element.on("click touchend", this._click.bind(this));

	            this.message = this.options.text;

	            var instance = this.element.data("button");
	            this.element.data(this.options.type, instance);
	        },
	        _click: $.noop
	    });

	    var ColorPicker = PopupTool.extend({
	        init: function(options, toolbar) {
	            PopupTool.fn.init.call(this, options, toolbar);
	            this.popup.element.addClass("k-spreadsheet-colorpicker");

	            this.colorChooser = new kendo.spreadsheet.ColorChooser(this.popup.element, {
	                change: this._colorChange.bind(this)
	            });

	            this.element.attr({
	                "data-property": options.property
	            });

	            this.element.data({
	                type: "colorPicker",
	                colorPicker: this,
	                instance: this
	            });
	        },
	        destroy: function() {
	            this.colorChooser.destroy();
	            PopupTool.fn.destroy.call(this);
	        },
	        update: function(value) {
	            this.value(value);
	        },
	        value: function(value) {
	            this.colorChooser.value(value);
	        },
	        _colorChange: function(e) {
	            this.toolbar.action({
	                command: "PropertyChangeCommand",
	                options: {
	                    property: this.options.property,
	                    value: e.sender.value()
	                }
	            });
	            this.popup.close();
	        }
	    });

	    var ColorPickerButton = OverflowDialogButton.extend({
	        init: function(options, toolbar) {
	            options.iconName = "text";
	            OverflowDialogButton.fn.init.call(this, options, toolbar);
	        },
	        _click: function() {
	            this.toolbar.dialog({
	                name: "colorPicker",
	                options: {
	                    title: this.options.property, property: this.options.property
	                }
	            });
	        }
	    });

	    kendo.toolbar.registerComponent("colorPicker", ColorPicker, ColorPickerButton);

	    var FONT_SIZES = [8, 9, 10, 11, 12, 13, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72];
	    var DEFAULT_FONT_SIZE = 12;

	    var FontSize = kendo.toolbar.Item.extend({
	        init: function(options, toolbar) {
	            var comboBox = $("<input />")
	                .attr("aria-label", options.attributes.title)
	                .attr("title", options.attributes.title)
	                .kendoComboBox({
	                    change: this._valueChange.bind(this),
	                    clearButton: false,
	                    dataSource: options.fontSizes || FONT_SIZES,
	                    value: DEFAULT_FONT_SIZE
	                }).data("kendoComboBox");

	            this.comboBox = comboBox;
	            this.element = comboBox.wrapper;
	            this.options = options;
	            this.toolbar = toolbar;

	            this.attributes();
	            this.addUidAttr();
	            this.addOverflowAttr();

	            this.element.width(options.width).attr({
	                "data-command": "PropertyChangeCommand",
	                "data-property": options.property
	            });

	            this.element.data({
	                type: "fontSize",
	                fontSize: this
	            });
	        },

	        _valueChange: function(e) {
	            this.toolbar.action({
	                command: "PropertyChangeCommand",
	                options: {
	                    property: this.options.property,
	                    value: kendo.parseInt(e.sender.value())
	                }
	            });
	        },

	        update: function(value) {
	            this.value(kendo.parseInt(value) || DEFAULT_FONT_SIZE);
	        },

	        value: function(value) {
	            if (value !== undefined) {
	                this.comboBox.value(value);
	            } else {
	                return this.comboBox.value();
	            }
	        }
	    });

	    var FontSizeButton = OverflowDialogButton.extend({
	        _click: function() {
	            this.toolbar.dialog({
	                name: "fontSize",
	                options: {
	                    sizes: FONT_SIZES,
	                    defaultSize: DEFAULT_FONT_SIZE
	                }
	            });
	        },
	        update: function(value) {
	            this._value = value || DEFAULT_FONT_SIZE;
	            this.element.find(".k-text").text(this.message + " (" + this._value + ") ...");
	        }
	    });

	    kendo.toolbar.registerComponent("fontSize", FontSize, FontSizeButton);

	    var FONT_FAMILIES = ["Arial", "Courier New", "Georgia", "Times New Roman", "Trebuchet MS", "Verdana"];
	    var DEFAULT_FONT_FAMILY = "Arial";

	    var FontFamily = DropDownTool.extend({
	        init: function(options, toolbar) {
	            DropDownTool.fn.init.call(this, options, toolbar);

	            var ddl = this.dropDownList;
	            ddl.setDataSource(options.fontFamilies || FONT_FAMILIES);
	            ddl.value(DEFAULT_FONT_FAMILY);

	            this.element.data({
	                type: "fontFamily",
	                fontFamily: this
	            });
	        },
	        update: function(value) {
	            this.value(value || DEFAULT_FONT_FAMILY);
	        }
	    });

	    var FontFamilyButton = OverflowDialogButton.extend({
	        _click: function() {
	            this.toolbar.dialog({
	                name: "fontFamily",
	                options: {
	                    fonts: FONT_FAMILIES,
	                    defaultFont: DEFAULT_FONT_FAMILY
	                }
	            });
	        },
	        update: function(value) {
	            this._value = value || DEFAULT_FONT_FAMILY;
	            this.element.find(".k-text").text(this.message + " (" + this._value + ") ...");
	        }
	    });

	    kendo.toolbar.registerComponent("fontFamily", FontFamily, FontFamilyButton);

	    var defaultFormats = kendo.spreadsheet.formats = {
	        automatic: null,
	        text: "@",
	        number: "#,0.00",
	        percent: "0.00%",
	        financial: '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',
	        currency: "$#,##0.00;[Red]$#,##0.00",
	        date: "m/d/yyyy",
	        time: "h:mm:ss AM/PM",
	        dateTime: "m/d/yyyy h:mm",
	        duration: "[h]:mm:ss"
	    };

	    var Format = DropDownTool.extend({
	        _revertTitle: function(e) {
	            e.sender.value("");
	            e.sender.wrapper.width("auto");
	        },
	        init: function(options, toolbar) {
	            DropDownTool.fn.init.call(this, options, toolbar);

	            var ddl = this.dropDownList;
	            var icon = "<span class='k-icon k-i-" + options.iconClass + "' style='line-height: 1em; width: 1.35em;'></span>";
	            ddl.bind("change", this._revertTitle.bind(this));
	            ddl.bind("dataBound", this._revertTitle.bind(this));
	            ddl.setOptions({
	                dataValueField: "format",
	                dataTextField: "name",
	                dataValuePrimitive: true,
	                valueTemplate: icon,
	                template:
	                    "# if (data.sample) { #" +
	                        "<span class='k-spreadsheet-sample'>#: data.sample #</span>" +
	                    "# } #" +
	                    "#: data.name #"
	            });
	            ddl.text(icon);
	            ddl.setDataSource([
	                { format: defaultFormats.automatic, name: MESSAGES.formatTypes.automatic },
	                { format: defaultFormats.text, name: MESSAGES.formatTypes.text },
	                { format: defaultFormats.number, name: MESSAGES.formatTypes.number , sample: "1,499.99" },
	                { format: defaultFormats.percent, name: MESSAGES.formatTypes.percent , sample: "14.50%" },
	                { format: defaultFormats.financial, name: MESSAGES.formatTypes.financial , sample: "(1,000.12)" },
	                { format: defaultFormats.currency, name: MESSAGES.formatTypes.currency , sample: "$1,499.99" },
	                { format: defaultFormats.date, name: MESSAGES.formatTypes.date , sample: "4/21/2012" },
	                { format: defaultFormats.time, name: MESSAGES.formatTypes.time , sample: "5:49:00 PM" },
	                { format: defaultFormats.dateTime, name: MESSAGES.formatTypes.dateTime , sample: "4/21/2012 5:49:00" },
	                { format: defaultFormats.duration, name: MESSAGES.formatTypes.duration , sample: "168:05:00" },
	                { popup: "formatCells", name: MESSAGES.formatTypes.moreFormats }
	            ]);

	            this.element.data({
	                type: "format",
	                format: this
	            });
	        }
	    });

	    var FormatButton = OverflowDialogButton.extend({
	        _click: function() {
	            this.toolbar.dialog({ name: "formatCells" });
	        }
	    });

	    kendo.toolbar.registerComponent("format", Format, FormatButton);

	    var BorderChangeTool = PopupTool.extend({
	        init: function(options, toolbar) {
	            PopupTool.fn.init.call(this, options, toolbar);
	            this._borderPalette();

	            this.element.data({
	                type: "borders",
	                instance: this
	            });
	        },
	        destroy: function() {
	            this.borderPalette.destroy();
	            PopupTool.fn.destroy.call(this);
	        },
	        _borderPalette: function() {
	            var element = $("<div />").appendTo(this.popup.element);
	            this.borderPalette = new kendo.spreadsheet.BorderPalette(element, {
	                change: this._action.bind(this)
	            });
	        },
	        _action: function(e) {
	            this.toolbar.action({
	                command: "BorderChangeCommand",
	                options: {
	                    border: e.type,
	                    style: { size: 1, color: e.color }
	                }
	            });
	        }
	    });

	    var BorderChangeButton = OverflowDialogButton.extend({
	        _click: function() {
	            this.toolbar.dialog({ name: "borders" });
	        }
	    });

	    kendo.toolbar.registerComponent("borders", BorderChangeTool, BorderChangeButton);

	    var AlignmentTool = PopupTool.extend({
	        init: function(options, toolbar) {
	            PopupTool.fn.init.call(this, options, toolbar);

	            this.element.attr({ "data-property": "alignment" });
	            this._defineButtons();
	            this._commandPalette();
	            this.popup.element.on("click", ".k-button", function(e) {
	                this._action($(e.currentTarget));
	            }.bind(this));

	            this.element.data({
	                type: "alignment",
	                alignment: this,
	                instance: this
	            });
	        },
	        _defineButtons: function() {
	            this.buttons = [
	                { property: "textAlign",     value: "left",    iconClass: "align-left",   text: MESSAGES.alignmentButtons.justtifyLeft },
	                { property: "textAlign",     value: "center",  iconClass: "align-center", text: MESSAGES.alignmentButtons.justifyCenter },
	                { property: "textAlign",     value: "right",   iconClass: "align-right",  text: MESSAGES.alignmentButtons.justifyRight },
	                { property: "textAlign",     value: "justify", iconClass: "align-justify",   text: MESSAGES.alignmentButtons.justifyFull },
	                { property: "verticalAlign", value: "top",     iconClass: "align-top",      text: MESSAGES.alignmentButtons.alignTop },
	                { property: "verticalAlign", value: "center",  iconClass: "align-middle",   text: MESSAGES.alignmentButtons.alignMiddle },
	                { property: "verticalAlign", value: "bottom",  iconClass: "align-bottom",   text: MESSAGES.alignmentButtons.alignBottom }
	            ];
	        },
	        destroy: function() {
	            this.popup.element.off();
	            PopupTool.fn.destroy.call(this);
	        },
	        update: function(range) {
	            var textAlign = range.textAlign();
	            var verticalAlign = range.verticalAlign();
	            var element = this.popup.element;

	            element.find(".k-button").removeClass("k-state-active");

	            if (textAlign) {
	                element.find("[data-property=textAlign][data-value=" + textAlign + "]").addClass("k-state-active");
	            }

	            if (verticalAlign) {
	                element.find("[data-property=verticalAlign][data-value=" + verticalAlign + "]").addClass("k-state-active");
	            }
	        },
	        _commandPalette: function() {
	            var buttons = this.buttons;
	            var element = $("<div />").appendTo(this.popup.element);
	            buttons.forEach(function(options, index) {
	                var button = "<a role='button' title='" + options.text + "' data-property='" + options.property + "' data-value='" + options.value + "' class='k-button k-button-icon'>" +
	                                "<span class='k-icon k-i-" + options.iconClass + "'></span>" +
	                             "</a>";
	                if (index !== 0 && buttons[index - 1].property !== options.property) {
	                    element.append($("<span class='k-separator' />"));
	                }
	                element.append(button);
	            });
	        },
	        _action: function(button) {
	            var property = button.attr("data-property");
	            var value = button.attr("data-value");

	            this.toolbar.action({
	                command: "PropertyChangeCommand",
	                options: {
	                    property: property,
	                    value: value
	                }
	            });
	        }
	    });

	    var AlignmentButton = OverflowDialogButton.extend({
	        _click: function() {
	            this.toolbar.dialog({ name: "alignment" });
	        }
	    });

	    kendo.toolbar.registerComponent("alignment", AlignmentTool, AlignmentButton);

	    var MergeTool = PopupTool.extend({
	        init: function(options, toolbar) {
	            PopupTool.fn.init.call(this, options, toolbar);

	            this._defineButtons();
	            this._commandPalette();
	            this.popup.element.on("click", ".k-button", function(e) {
	                this._action($(e.currentTarget));
	            }.bind(this));

	            this.element.data({
	                type: "merge",
	                merge: this,
	                instance: this
	            });
	        },
	        _defineButtons: function() {
	            this.buttons = [
	                { value: "cells",        iconClass: "cells-merge",        text: MESSAGES.mergeButtons.mergeCells },
	                { value: "horizontally", iconClass: "cells-merge-horizontally", text: MESSAGES.mergeButtons.mergeHorizontally },
	                { value: "vertically",   iconClass: "cells-merge-vertically",   text: MESSAGES.mergeButtons.mergeVertically },
	                { value: "unmerge",      iconClass: "table-unmerge",      text: MESSAGES.mergeButtons.unmerge }
	            ];
	        },
	        destroy: function() {
	            this.popup.element.off();
	            PopupTool.fn.destroy.call(this);
	        },
	        _commandPalette: function() {
	            var element = $("<div />").appendTo(this.popup.element);
	            this.buttons.forEach(function(options) {
	                var button = "<a role='button' title='" + options.text + "' data-value='" + options.value + "' class='k-button k-button-icontext'>" +
	                                "<span class='k-icon k-i-" + options.iconClass + "'></span>" + options.text +
	                             "</a>";
	                element.append(button);
	            });
	        },
	        _action: function(button) {
	            var value = button.attr("data-value");

	            this.toolbar.action({
	                command: "MergeCellCommand",
	                options: {
	                    value: value
	                }
	            });
	        }
	    });

	    var MergeButton = OverflowDialogButton.extend({
	        _click: function() {
	            this.toolbar.dialog({ name: "merge" });
	        }
	    });

	    kendo.toolbar.registerComponent("merge", MergeTool, MergeButton);

	    var FreezeTool = PopupTool.extend({
	        init: function(options, toolbar) {
	            PopupTool.fn.init.call(this, options, toolbar);

	            this._defineButtons();
	            this._commandPalette();
	            this.popup.element.on("click", ".k-button", function(e) {
	                this._action($(e.currentTarget));
	            }.bind(this));

	            this.element.data({
	                type: "freeze",
	                freeze: this,
	                instance: this
	            });
	        },
	        _defineButtons: function() {
	            this.buttons = [
	                { value: "panes",    iconClass: "pane-freeze",  text: MESSAGES.freezeButtons.freezePanes },
	                { value: "rows",     iconClass: "row-freeze",    text: MESSAGES.freezeButtons.freezeRows },
	                { value: "columns",  iconClass: "column-freeze",    text: MESSAGES.freezeButtons.freezeColumns },
	                { value: "unfreeze", iconClass: "table-unmerge", text: MESSAGES.freezeButtons.unfreeze }
	            ];
	        },
	        destroy: function() {
	            this.popup.element.off();
	            PopupTool.fn.destroy.call(this);
	        },
	        _commandPalette: function() {
	            var element = $("<div />").appendTo(this.popup.element);
	            this.buttons.forEach(function(options) {
	                var button = "<a role='button' title='" + options.text + "' data-value='" + options.value + "' class='k-button k-button-icontext'>" +
	                                "<span class='k-icon k-i-" + options.iconClass + "'></span>" + options.text +
	                             "</a>";
	                element.append(button);
	            });
	        },
	        _action: function(button) {
	            var value = button.attr("data-value");

	            this.toolbar.action({
	                command: "FreezePanesCommand",
	                options: {
	                    value: value
	                }
	            });
	        }
	    });

	    var FreezeButton = OverflowDialogButton.extend({
	        _click: function() {
	            this.toolbar.dialog({ name: "freeze" });
	        }
	    });

	    kendo.toolbar.registerComponent("freeze", FreezeTool, FreezeButton);

	    var Sort = DropDownTool.extend({
	        _revertTitle: function(e) {
	            e.sender.value("");
	            e.sender.wrapper.width("auto");
	        },
	        init: function(options, toolbar) {
	            DropDownTool.fn.init.call(this, options, toolbar);

	            var ddl = this.dropDownList;
	            ddl.bind("change", this._revertTitle.bind(this));
	            ddl.bind("dataBound", this._revertTitle.bind(this));
	            ddl.setOptions({
	                valueTemplate: "<span class='k-icon k-i-" + options.iconClass + "' style='line-height: 1em; width: 1.35em;'></span>",
	                template: "<span class='k-icon k-i-#= iconClass #' style='line-height: 1em; width: 1.35em;'></span>#=text#",
	                dataTextField: "text",
	                dataValueField: "value"
	            });
	            ddl.setDataSource([
	                // { value: "asc", sheet: true, asc: true,  text: MESSAGES.sortButtons.sortSheetAsc,  iconClass: "sort-asc" },
	                // { value: "desc", sheet: true, asc: false, text: MESSAGES.sortButtons.sortSheetDesc,  , iconClass: "sort-desc" },
	                { value: "asc", sheet: false, text: MESSAGES.sortButtons.sortRangeAsc, iconClass: "sort-asc" },
	                { value: "desc", sheet: false, text: MESSAGES.sortButtons.sortRangeDesc, iconClass: "sort-desc" }
	            ]);
	            ddl.select(0);

	            this.element.data({
	                type: "sort",
	                sort: this
	            });
	        },
	        _change: function(e) {
	            var instance = e.sender;
	            var dataItem = instance.dataItem();

	            if (dataItem) {
	                this.toolbar.action({
	                    command: "SortCommand",
	                    options: {
	                        value: dataItem.value,
	                        sheet: dataItem.sheet
	                    }
	                });
	            }
	        },
	        value: $.noop
	    });

	    var SortButton = OverflowDialogButton.extend({
	        _click: function() {
	            this.toolbar.dialog({ name: "sort" });
	        }
	    });

	    kendo.toolbar.registerComponent("sort", Sort, SortButton);

	    var Filter = kendo.toolbar.ToolBarButton.extend({
	        init: function(options, toolbar) {
	            options.showText = "overflow";
	            kendo.toolbar.ToolBarButton.fn.init.call(this, options, toolbar);

	            this.element.on("click", this._click.bind(this));

	            this.element.data({
	                type: "filter",
	                filter: this
	            });
	        },
	        _click: function() {
	            this.toolbar.action({ command: "FilterCommand" });
	        },
	        update: function(value) {
	            this.toggle(value);
	        }
	    });

	    var FilterButton = OverflowDialogButton.extend({
	        init: function(options, toolbar) {
	            OverflowDialogButton.fn.init.call(this, options, toolbar);

	            this.element.data({
	                type: "filter",
	                filter: this
	            });
	        },
	        _click: function() {
	            this.toolbar.action({ command: "FilterCommand" });
	        },
	        update: function(value) {
	            this.toggle(value);
	        }
	    });

	    kendo.toolbar.registerComponent("filter", Filter, FilterButton);

	    var Open = kendo.toolbar.Item.extend({
	        init: function(options, toolbar) {
	            this.toolbar = toolbar;
	            this.element = $("<div class='k-button k-upload-button k-button-icon'>" +
	                                 "<span class='k-icon k-i-folder-open'></span>" +
	                             "</div>").data("instance", this);

	            this._title = options.attributes.title;
	            this._reset();
	        },
	        _reset: function() {
	            this.element.find("input").remove();

	            $("<input type='file' autocomplete='off' accept='.xlsx'/>")
	                .attr("title", this._title)
	                .attr("aria-label", this._title)
	                .one("change", this._change.bind(this))
	                .appendTo(this.element);
	        },
	        _change: function(e) {
	            this.toolbar.action({
	                command: "OpenCommand",
	                options: {
	                    file: e.target.files[0]
	                }
	            });

	            this._reset();
	        }
	    });
	    kendo.toolbar.registerComponent("open", Open);

	    kendo.spreadsheet.TabStrip = kendo.ui.TabStrip.extend({
	        init: function(element, options) {
	            kendo.ui.TabStrip.fn.init.call(this, element, options);
	            element.addClass("k-spreadsheet-tabstrip");
	            this._quickAccessButtons();

	            this.toolbars = {};

	            var tabs = options.dataSource;

	            this.contentElements.each(function(idx, element) {
	                this._toolbar($(element), tabs[idx].id, options.toolbarOptions[tabs[idx].id]);
	            }.bind(this));

	            this.one("activate", function() { //force resize of the tabstrip after TabStrip tab is opened
	                this.toolbars[this.options.dataSource[0].id].resize();
	            });
	        },

	        events: kendo.ui.TabStrip.fn.events.concat([ "action", "dialog" ]),

	        destroy: function() {
	            this.quickAccessToolBar.off("click");
	            kendo.ui.TabStrip.fn.destroy.call(this);
	            for (var name in this.toolbars) {
	                this.toolbars[name].destroy();
	            }
	        },

	        action: function(args) {
	            this.trigger("action", args);
	        },

	        dialog: function(args) {
	            this.trigger("dialog", args);
	        },

	        refreshTools: function(range) {
	            var toolbars = this.toolbars;
	            for (var name in toolbars) {
	                if (toolbars.hasOwnProperty(name)) {
	                    toolbars[name].refresh(range);
	                }
	            }
	        },

	        _quickAccessButtons: function() {
	            var buttons = [
	                { title: MESSAGES.quickAccess.undo, iconClass: "undo", action: "undo" },
	                { title: MESSAGES.quickAccess.redo, iconClass: "redo", action: "redo" }
	            ];
	            var buttonTemplate = kendo.template("<a role='button' href='\\#' title='#= title #' data-action='#= action #' class='k-button k-button-icon' aria-label='#= title #'><span class='k-icon k-i-#=iconClass#'></span></a>");

	            this.quickAccessToolBar = $("<div />", {
	                "class": "k-spreadsheet-quick-access-toolbar",
	                "html": kendo.render(buttonTemplate, buttons)
	            }).insertBefore(this.wrapper);

	            this.quickAccessToolBar.on("click", ".k-button", function(e) {
	                e.preventDefault();

	                var action = $(e.currentTarget).attr("data-action");
	                this.action({ action: action });
	            }.bind(this));

	            this.quickAccessAdjust();
	        },

	        quickAccessAdjust: function() {
	            this.tabGroup.css("padding-left", kendo._outerWidth(this.quickAccessToolBar));
	        },

	        _toolbar: function(container, name, tools) {
	            var element;
	            var options;

	            if (this.toolbars[name]) {
	                this.toolbars[name].destroy();
	                container.children(".k-toolbar").remove();
	            }

	            if (tools) {
	                element = container.html("<div></div>").children("div");

	                options = {
	                    tools: typeof tools === "boolean" ? undefined : tools,
	                    toolbarName: name,
	                    action: this.action.bind(this),
	                    dialog: this.dialog.bind(this)
	                };

	                this.toolbars[name] = new kendo.spreadsheet.ToolBar(element, options);
	            }
	        }

	    });

	})(window.kendo);

	}, __webpack_require__(3));


/***/ }),

/***/ 1630:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("wcKb");

/***/ })

/******/ });

/***/ }),

/***/ "bbfP":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1244);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1053:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1kkP");

/***/ }),

/***/ 1054:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CRfZ");

/***/ }),

/***/ 1170:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("zQRd");

/***/ }),

/***/ 1187:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("99zt");

/***/ }),

/***/ 1244:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1245), __webpack_require__(1170), __webpack_require__(1187), __webpack_require__(1053), __webpack_require__(1054) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "filtercell",
	    name: "Row filter",
	    category: "framework",
	    depends: [ "autocomplete" ],
	    advanced: true
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        DataSource = kendo.data.DataSource,
	        Widget = ui.Widget,
	        CHANGE = "change",
	        BOOL = "boolean",
	        ENUM = "enums",
	        STRING = "string",
	        EQ = "Is equal to",
	        NEQ = "Is not equal to",
	        proxy = $.proxy,
	        nonValueOperators = ["isnull", "isnotnull", "isempty", "isnotempty", "isnullorempty", "isnotnullorempty"];

	    function isNonValueFilter(filter) {
	        var operator = typeof filter === "string" ? filter : filter.operator;
	        return $.inArray(operator, nonValueOperators) > -1;
	    }

	    function findFilterForField(filter, field) {
	        var filters = [];
	        if ($.isPlainObject(filter)) {
	            if (filter.hasOwnProperty("filters")) {
	                filters = filter.filters;
	            } else if(filter.field == field) {
	                return filter;
	            }
	        }
	        if (($.isArray(filter))) {
	           filters = filter;
	        }

	        for (var i = 0; i < filters.length; i++) {
	          var result = findFilterForField(filters[i], field);
	          if (result) {
	             return result;
	          }
	        }
	    }

	    function removeFiltersForField(expression, field) {
	        if (expression.filters) {
	            expression.filters = $.grep(expression.filters, function(filter) {
	                removeFiltersForField(filter, field);
	                if (filter.filters) {
	                    return filter.filters.length;
	                } else {
	                    return filter.field != field;
	                }
	            });
	        }
	    }

	    function removeDuplicates (dataSelector, dataTextField) {
	        var getter = kendo.getter(dataTextField, true);

	        return function(e) {
	            var items = dataSelector(e),
	                result = [],
	                index = 0,
	                seen = {};

	            while (index < items.length) {
	                var item = items[index++],
	                    text = getter(item);

	                if(!seen.hasOwnProperty(text)){
	                    result.push(item);
	                    seen[text] = true;
	                }
	            }

	            return result;
	        };
	    }

	    var FilterCell = Widget.extend( {
	        init: function(element, options) {
	            element = $(element).addClass("k-filtercell");
	            var wrapper = this.wrapper = $("<span/>").appendTo(element);
	            var that = this,
	                dataSource,
	                viewModel,
	                passedOptions = options,
	                first,
	                type,
	                operators = that.operators = options.operators || {},
	                input = that.input = $("<input/>")
	                    .attr(kendo.attr("bind"), "value: value")
	                    .appendTo(wrapper);

	            var suggestDataSource = options ? options.suggestDataSource : null;

	            if (suggestDataSource) {
	                // avoid deep cloning the suggest data source
	                options = $.extend({}, options, { suggestDataSource: {} });
	            }

	            Widget.fn.init.call(that, element[0], options);

	            if (suggestDataSource) {
	                that.options.suggestDataSource = suggestDataSource;
	            }

	            options = that.options;

	            dataSource = that.dataSource = options.dataSource;

	            //gets the type from the dataSource or sets default to string
	            that.model = dataSource.reader.model;
	            type = options.type = STRING;
	            var fields = kendo.getter("reader.model.fields", true)(dataSource) || {};
	            var target = fields[options.field];
	            if (target && target.type) {
	                type = options.type = target.type;
	            }
	            if (options.values) {
	                options.type = type = ENUM;
	            }

	            operators = operators[type] || options.operators[type];

	            if (!passedOptions.operator) {
	                for (first in operators) { // get the first operator
	                    options.operator = first;
	                    break;
	                }
	            }

	            that._parse = function(value) {
	                /*jshint eqnull: true */
	                return value != null ? (value + "") : value;
	            };

	            if (that.model && that.model.fields) {
	                var field = that.model.fields[options.field];

	                if (field) {
	                    if (field.parse) {
	                        that._parse = proxy(field.parse, field);
	                    }
	                }
	            }

	            that.defaultOperator = options.operator;

	            that.viewModel = viewModel = kendo.observable({
	                operator: options.operator,
	                value: null,
	                operatorVisible: function() {
	                    var val = this.get("value");
	                    return  (val !== null && val !== undefined && val != "undefined") || (isNonValueFilter(this.get("operator")) && !that._clearInProgress);
	                }
	            });
	            viewModel.bind(CHANGE, proxy(that.updateDsFilter, that));

	            if (type == STRING) {
	                that.initSuggestDataSource(options);
	            }

	            if (options.inputWidth !== null) {
	                input.addClass('k-sized-input');
	                input.width(options.inputWidth);
	            }

	            input.attr("aria-label", that._getColumnTitle());
	            input.attr("title", that._getColumnTitle());

	            that._setInputType(options, type);

	            if (type != BOOL && options.showOperators !== false) {
	                that._createOperatorDropDown(operators);
	            } else {
	                $('<div unselectable="on" />')
	                    .css("display", "none")
	                    .text("eq")
	                    .appendTo(wrapper);

	                wrapper.addClass("k-operator-hidden");
	            }

	            that._createClearIcon();

	            kendo.bind(this.wrapper, viewModel);

	            if (type == STRING) {
	                if (!options.template) {
	                    that.setAutoCompleteSource();
	                }
	            }

	            if (type == ENUM) {
	                that.setComboBoxSource(that.options.values);
	            }

	            that._refreshUI();

	            that._refreshHandler = proxy(that._refreshUI, that);

	            that.dataSource.bind(CHANGE, that._refreshHandler);

	        },

	        _setInputType: function(options, type) {
	            var that = this,
	                input = that.input;

	            if (typeof (options.template) == "function") {
	                options.template.call(that.viewModel, {
	                    element: that.input,
	                    dataSource: that.suggestDataSource
	                });

	                that._angularItems("compile");

	            } else if (type == STRING) {
	                input.attr(kendo.attr("role"), "autocomplete")
	                        .attr(kendo.attr("text-field"), options.dataTextField || options.field)
	                        .attr(kendo.attr("filter"), options.suggestionOperator)
	                        .attr(kendo.attr("delay"), options.delay)
	                        .attr(kendo.attr("min-length"), options.minLength)
	                        .attr(kendo.attr("value-primitive"), true);
	            } else if (type == "date") {
	                input.attr(kendo.attr("role"), "datepicker");
	            } else if (type == BOOL) {
	                input.remove();
	                var radioInput = $("<input type='radio'/>");
	                var wrapper = that.wrapper;
	                var inputName = kendo.guid();

	                var labelTrue = $("<label/>").text(options.messages.isTrue).append(radioInput);
	                radioInput.attr(kendo.attr("bind"), "checked:value")
	                    .attr("name", inputName)
	                    .val("true");

	                var labelFalse = labelTrue.clone().text(options.messages.isFalse);
	                radioInput.clone().val("false").appendTo(labelFalse);
	                wrapper.append([labelTrue, labelFalse]);

	            } else if (type == "number") {
	                input.attr(kendo.attr("role"), "numerictextbox")
	                        .attr("title", that._getColumnTitle());
	            } else if (type == ENUM) {
	                input.attr(kendo.attr("role"), "combobox")
	                        .attr(kendo.attr("text-field"), "text")
	                        .attr(kendo.attr("suggest"), true)
	                        .attr(kendo.attr("filter"), "contains")
	                        .attr(kendo.attr("value-field"), "value")
	                        .attr(kendo.attr("value-primitive"), true);
	            }
	        },

	        _getColumnTitle: function() {
	            var column = this.options.column;
	            return column ? column.title || column.field : "";
	        },

	        _createOperatorDropDown: function(operators) {
	            var items = [],
	                viewModel = this.viewModel;
	            for (var prop in operators) {
	                items.push({
	                    text: operators[prop],
	                    value: prop
	                });
	            }
	            var dropdown = $('<input class="k-dropdown-operator" ' + kendo.attr("bind") + '="value: operator"/>').appendTo(this.wrapper);
	            this.operatorDropDown = dropdown.kendoDropDownList({
	                dataSource: items,
	                dataTextField: "text",
	                dataValueField: "value",
	                open: function() {
	                    //TODO calc this
	                    this.popup.element.width(150);
	                },
	                valuePrimitive: true
	            }).data("kendoDropDownList");

	            viewModel.bind("change", function() {
	                var ariaLabel = operators[viewModel.operator];
	                dropdown.attr("aria-label", ariaLabel);
	            });

	            this.operatorDropDown.wrapper.find(".k-i-arrow-60-down").removeClass("k-i-arrow-60-down").addClass("k-i-filter");
	        },

	        initSuggestDataSource: function(options) {
	            var suggestDataSource = options.suggestDataSource;

	            if (!(suggestDataSource instanceof DataSource)) {
	                if (!options.customDataSource && suggestDataSource) {
	                    suggestDataSource.group = undefined;
	                }
	                suggestDataSource =
	                    this.suggestDataSource =
	                        DataSource.create(suggestDataSource);


	            }

	            if (!options.customDataSource) {
	                suggestDataSource._pageSize = undefined;
	                suggestDataSource.reader.data = removeDuplicates(suggestDataSource.reader.data, this.options.field);
	            }

	            this.suggestDataSource = suggestDataSource;
	        },

	        setAutoCompleteSource: function() {
	            var autoComplete = this.input.data("kendoAutoComplete");
	            if (autoComplete) {
	                autoComplete.setDataSource(this.suggestDataSource);
	            }
	        },

	        setComboBoxSource: function(values) {
	            var dataSource = DataSource.create({
	                data: values
	            });
	            var comboBox = this.input.data("kendoComboBox");
	            if (comboBox && !this.options.template) {
	                comboBox.setDataSource(dataSource);
	            }
	        },

	        _refreshUI: function() {
	            var that = this,
	                filter = findFilterForField(that.dataSource.filter(), this.options.field) || {},
	                viewModel = that.viewModel;

	            that.manuallyUpdatingVM = true;
	            filter = $.extend(true, {}, filter);
	            //MVVM check binding does not update the UI when changing the value to null/undefined
	            if (that.options.type == BOOL) {
	                if (viewModel.value !== filter.value) {
	                    that.wrapper.find(":radio").prop("checked", false);
	                }
	            }

	            if (filter.operator) {
	                viewModel.set("operator", filter.operator);
	            }
	            viewModel.set("value", filter.value);
	            that.manuallyUpdatingVM = false;
	        },

	        updateDsFilter: function(e) {
	            var that = this,
	                model = that.viewModel;

	            if (that.manuallyUpdatingVM || (e.field == "operator" && model.value === undefined && !isNonValueFilter(model)) ||
	                (e.field == "operator" && that._clearInProgress && model.value !== null))  {
	                return;
	            }

	            var currentFilter = $.extend({}, that.viewModel.toJSON(), { field: that.options.field });

	            var expression = {
	                logic: "and",
	                filters: []
	            };

	            var prevented = false;

	            if ((currentFilter.value !== undefined && currentFilter.value !== null) || (isNonValueFilter(currentFilter) && !this._clearInProgress)) {
	                expression.filters.push(currentFilter);

	                prevented = that.trigger(CHANGE, { filter: expression, field: that.options.field });
	            }

	            if (that._clearInProgress || currentFilter.value === null) {
	                prevented = that.trigger(CHANGE, { filter: null, field: that.options.field });
	            }

	            if (prevented) {
	                return;
	            }

	            var mergeResult = that._merge(expression);
	            if (mergeResult.filters.length) {
	                that.dataSource.filter(mergeResult);
	            } else {
	                that.dataSource.filter({});
	            }
	        },

	        _merge: function(expression) {
	            var that = this,
	                logic = expression.logic || "and",
	                filters = expression.filters,
	                filter,
	                result = that.dataSource.filter() || { filters:[], logic: "and" },
	                idx,
	                length;

	            removeFiltersForField(result, that.options.field);

	            for (idx = 0, length = filters.length; idx < length; idx++) {
	                filter = filters[idx];
	                filter.value = that._parse(filter.value);
	            }

	            filters = $.grep(filters, function(filter) {
	                return (filter.value !== "" && filter.value !== null) || isNonValueFilter(filter);
	            });

	            if (filters.length) {
	                if (result.filters.length) {
	                    expression.filters = filters;

	                    if (result.logic !== "and") {
	                        result.filters = [ { logic: result.logic, filters: result.filters }];
	                        result.logic = "and";
	                    }

	                    if (filters.length > 1) {
	                        result.filters.push(expression);
	                    } else {
	                        result.filters.push(filters[0]);
	                    }
	                } else {
	                    result.filters = filters;
	                    result.logic = logic;
	                }
	            }

	            return result;
	        },

	        _createClearIcon: function() {
	            var that = this;

	            $("<button type='button' class='k-button k-button-icon' title = " + that.options.messages.clear + "/>")
	                .attr("aria-label", that.options.messages.clear)
	                .attr(kendo.attr("bind"), "visible:operatorVisible")
	                .html("<span class='k-icon k-i-filter-clear'></span>")
	                .click(proxy(that.clearFilter, that))
	                .appendTo(that.wrapper);
	        },

	        clearFilter: function() {
	            this._clearInProgress = true;

	            if (isNonValueFilter(this.viewModel.operator)) {
	                this.viewModel.set("operator", this.defaultOperator);
	            }

	            this.viewModel.set("value", null);
	            this._clearInProgress = false;
	        },

	        _angularItems: function(action) {
	            var elements = this.wrapper.closest("th").get();
	            var column = this.options.column;

	            this.angular(action, function() {
	                return {
	                    elements: elements,
	                    data: [{ column: column }]
	                };
	            });
	        },

	        destroy: function() {
	            var that = this;

	            that.filterModel = null;
	            that.operatorDropDown = null;

	            that._angularItems("cleanup");

	            if (that._refreshHandler) {
	                that.dataSource.bind(CHANGE, that._refreshHandler);
	                that._refreshHandler = null;
	            }

	            kendo.unbind(that.element);

	            Widget.fn.destroy.call(that);

	            kendo.destroy(that.element);
	        },

	        events: [
	            CHANGE
	        ],

	        options: {
	            name: "FilterCell",
	            delay: 200,
	            minLength: 1,
	            inputWidth: null,
	            values: undefined,
	            customDataSource: false,
	            field: "",
	            dataTextField: "",
	            type: "string",
	            suggestDataSource: null,
	            suggestionOperator: "startswith",
	            operator: "eq",
	            showOperators: true,
	            template: null,
	            messages: {
	                isTrue: "is true",
	                isFalse: "is false",
	                filter: "Filter",
	                clear: "Clear",
	                operator: "Operator"
	            },
	            operators: {
	                string: {
	                    eq: EQ,
	                    neq: NEQ,
	                    startswith: "Starts with",
	                    contains: "Contains",
	                    doesnotcontain: "Does not contain",
	                    endswith: "Ends with",
	                    isnull: "Is null",
	                    isnotnull: "Is not null",
	                    isempty: "Is empty",
	                    isnotempty: "Is not empty",
	                    isnullorempty: "Has no value",
	                    isnotnullorempty: "Has value"
	                },
	                number: {
	                    eq: EQ,
	                    neq: NEQ,
	                    gte: "Is greater than or equal to",
	                    gt: "Is greater than",
	                    lte: "Is less than or equal to",
	                    lt: "Is less than",
	                    isnull: "Is null",
	                    isnotnull: "Is not null"
	                },
	                date: {
	                    eq: EQ,
	                    neq: NEQ,
	                    gte: "Is after or equal to",
	                    gt: "Is after",
	                    lte: "Is before or equal to",
	                    lt: "Is before",
	                    isnull: "Is null",
	                    isnotnull: "Is not null"
	                },
	                enums: {
	                    eq: EQ,
	                    neq: NEQ,
	                    isnull: "Is null",
	                    isnotnull: "Is not null"
	                }
	            }
	        }
	    });

	    ui.plugin(FilterCell);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1245:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("trYX");

/***/ })

/******/ });

/***/ }),

/***/ "bfur":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1164);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1164:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "dateinput",
	    name: "DateInput",
	    category: "web",
	    description: "The DateInput widget allows to edit date by typing.",
	    depends: [ "core" ]
	};

	(function ($, undefined) {
	    var global = window;
	    var kendo = global.kendo;
	    var caret = kendo.caret;
	    var ui = kendo.ui;
	    var Widget = ui.Widget;
	    var keys = kendo.keys;
	    var ns = ".kendoDateInput";
	    var proxy = $.proxy;
	    var objectToString = {}.toString;

	    var INPUT_EVENT_NAME = (kendo.support.propertyChangeEvent ? "propertychange.kendoDateInput input" : "input") + ns;

	    var STATEDISABLED = "k-state-disabled";
	    var STATEDEFAULT = "k-state-default";
	    // var STATEFOCUSED = "k-state-focused";
	    // var STATEHOVER = "k-state-hover";
	    var STATEINVALID = "k-state-invalid";

	    var DISABLED = "disabled";
	    var READONLY = "readonly";
	    var CHANGE = "change";

	    var knownSymbols = "dMyHhmftsz";

	    var DateInput = Widget.extend({
	        init: function (element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);
	            element = that.element;

	            options = that.options;
	            options.format = kendo._extractFormat(options.format || kendo.getCulture(options.culture).calendars.standard.patterns.d);
	            options.min = kendo.parseDate(element.attr("min")) || kendo.parseDate(options.min);
	            options.max = kendo.parseDate(element.attr("max")) || kendo.parseDate(options.max);

	            var insidePicker = ((element.parent().attr("class") || "").indexOf("k-picker-wrap") >= 0);
	            if (insidePicker) {
	                that.wrapper = element.parent();
	            } else {
	                that.wrapper = element.wrap("<span class='k-widget k-dateinput'></span>").parent();
	                that.wrapper.addClass(element[0].className).removeClass('input-validation-error');
	                that.wrapper[0].style.cssText = element[0].style.cssText;
	                element.css({
	                    width: "100%",
	                    height: element[0].style.height
	                });
	            }

	            that._inputWrapper = $(that.wrapper[0]);

	            $("<span class='k-icon k-i-warning'></span>").insertAfter(element);

	            that._form();

	            that.element
	                .addClass(insidePicker ? " " : "k-textbox")
	                .attr("autocomplete", "off")
	                .on("focusout" + ns, function () {
	                    that._change();
	                });

	            try {
	                element[0].setAttribute("type", "text");
	            } catch (e) {
	                element[0].type = "text";
	            }

	            var disabled = element.is("[disabled]") || $(that.element).parents("fieldset").is(':disabled');

	            if (disabled) {
	                that.enable(false);
	            } else {
	                that.readonly(element.is("[readonly]"));
	            }

	            that.value(that.options.value || element.val());

	            kendo.notify(that);
	        },

	        options: {
	            name: "DateInput",
	            culture: "",
	            value: "",
	            format: "",
	            min: new Date(1900, 0, 1),
	            max: new Date(2099, 11, 31),
	            messages: {
	                "year": "year",
	                "month": "month",
	                "day": "day",
	                "weekday": "day of the week",
	                "hour": "hours",
	                "minute": "minutes",
	                "second": "seconds",
	                "dayperiod": "AM/PM"
	            }
	        },

	        events: [
	            CHANGE
	        ],

	        min: function (value) {
	            if (value !== undefined) {
	                this.options.min = value;
	            } else {
	                return this.options.min;
	            }
	        },

	        max: function (value) {
	            if (value !== undefined) {
	                this.options.max = value;
	            } else {
	                return this.options.max;
	            }
	        },

	        setOptions: function (options) {
	            var that = this;
	            Widget.fn.setOptions.call(that, options);
	            this._unbindInput();
	            this._bindInput();
	            this._updateElementValue();
	        },

	        destroy: function () {
	            var that = this;
	            that.element.off(ns);

	            if (that._formElement) {
	                that._formElement.off("reset", that._resetHandler);
	            }

	            Widget.fn.destroy.call(that);
	        },

	        value: function (value) {
	            if (value === undefined) {
	                return this._dateTime.getDateObject();
	            }

	            if (value === null) {
	                value = "";
	            }

	            if (objectToString.call(value) !== "[object Date]") {
	                value = kendo.parseDate(value, this.options.format, this.options.culture);
	            }

	            if (value && !value.getTime()) {
	                value = null;
	            }

	            this._dateTime = new customDateTime(value, this.options.format, this.options.culture, this.options.messages);

	            this._updateElementValue();
	            this._oldValue = value;
	        },

	        _updateElementValue: function () {
	            var stringAndFromat = this._dateTime.toPair(this.options.format, this.options.culture, this.options.messages);
	            this.element.val(stringAndFromat[0]);
	            this._oldText = stringAndFromat[0];
	            this._format = stringAndFromat[1];
	        },

	        readonly: function (readonly) {
	            this._editable({
	                readonly: readonly === undefined ? true : readonly,
	                disable: false
	            });
	        },

	        enable: function (enable) {
	            this._editable({
	                readonly: false,
	                disable: !(enable = enable === undefined ? true : enable)
	            });
	        },

	        _bindInput: function () {
	            var that = this;
	            that.element
	                .on("focusout" + ns, function () {
	                    that._change();
	                })
	                .on("paste" + ns, proxy(that._paste, that))
	                .on("keydown" + ns, proxy(that._keydown, that))
	                .on(INPUT_EVENT_NAME, proxy(that._input, that))
	                .on("mouseup" + ns, proxy(that._mouseUp, that))
	                .on("DOMMouseScroll" + ns + " mousewheel" + ns, proxy(that._scroll, that));
	        },

	        _unbindInput: function () {
	            this.element
	                .off("keydown" + ns)
	                .off("paste" + ns)
	                .off("focusout" + ns)
	                .off(INPUT_EVENT_NAME)
	                .off("mouseup" + ns)
	                .off("DOMMouseScroll" + ns + " mousewheel" + ns);
	        },

	        _editable: function (options) {
	            var that = this;
	            var element = that.element;
	            var disable = options.disable;
	            var readonly = options.readonly;
	            var wrapper = that.wrapper;

	            that._unbindInput();

	            if (!readonly && !disable) {
	                wrapper.addClass(STATEDEFAULT)
	                    .removeClass(STATEDISABLED);
	                if(element && element.length) {
	                    element[0].removeAttribute(DISABLED);
	                    element[0].removeAttribute(READONLY);
	                }

	                that._bindInput();
	            } else {
	                if (disable) {
	                    wrapper.addClass(STATEDISABLED)
	                    .removeClass(STATEDEFAULT);
	                    element.attr(DISABLED, disable);
	                    if(element && element.length) {
	                        element[0].removeAttribute(READONLY);
	                    }
	                }
	                if (readonly) {
	                    element.attr(READONLY, readonly);
	                }
	            }
	        },

	        _change: function () {
	            var that = this;
	            var oldValue = that._oldValue;
	            var value = that.value();

	            if (value && that.min() && value < that.min()) {
	                that.value(that.min());
	                value = that.value();
	            }
	            if (value && that.max() && value > that.max()) {
	                that.value(that.max());
	                value = that.value();
	            }

	            if (oldValue && value && value.getTime() !== oldValue.getTime() ||
	                oldValue && !value ||
	                !oldValue && value
	            ) {
	                that._oldValue = value;
	                that.trigger(CHANGE);
	                that.element.trigger(CHANGE);
	            }
	        },

	        _input: function () {
	            var that = this;
	            var element = that.element[0];
	            var blinkInvalid = false;

	            if (kendo._activeElement() !== element) {
	                return;
	            }

	            var diff = approximateStringMatching(
	                this._oldText,
	                this._format,
	                this.element[0].value,
	                caret(this.element[0])[0]);

	            var navigationOnly = (diff.length === 1 && diff[0][1] === " ");
	            if (!navigationOnly) {
	                for (var i = 0; i < diff.length; i++) {
	                    var valid = this._dateTime.parsePart(diff[i][0], diff[i][1]);
	                    blinkInvalid = blinkInvalid || !valid;
	                }
	            }
	            this._updateElementValue();

	            if (diff.length && diff[0][0] !== " ") {
	                this._selectSegment(diff[0][0]);

	                //android fix
	                if (!navigationOnly) {
	                    var difSym = diff[0][0];
	                    setTimeout(function () { that._selectSegment(difSym); });
	                }
	            }
	            if (navigationOnly) {
	                var newEvent = { keyCode: 39, preventDefault: function () { } };
	                this._keydown(newEvent);
	            }
	            if (blinkInvalid) {
	                clearTimeout(that._blinkInvalidTimeout);
	                var stateInvalid = STATEINVALID;
	                that.wrapper.addClass(STATEINVALID);
	                that._blinkInvalidTimeout = setTimeout(function () { that.wrapper.removeClass(stateInvalid); }, 100);
	            }
	        },

	        _mouseUp: function () {
	            var selection = caret(this.element[0]);
	            if (selection[0] === selection[1]) {
	                this._selectNearestSegment();
	            }
	        },

	        _scroll: function (e) {
	            if (kendo._activeElement() !== this.element[0] || this.element.is("[readonly]")) {
	                return;
	            }
	            e = window.event || e;

	            var newEvent = { keyCode: 37, preventDefault: function () { } };

	            if (e.shiftKey) {
	                newEvent.keyCode = (e.wheelDelta || -e.detail) > 0 ? 37 : 39;
	            } else {
	                newEvent.keyCode = (e.wheelDelta || -e.detail) > 0 ? 38 : 40;
	            }
	            this._keydown(newEvent);
	            e.returnValue = false;
	            if (e.preventDefault) {
	                e.preventDefault();
	            }
	            if (e.stopPropagation) {
	                e.stopPropagation();
	            }
	        },

	        _form: function () {
	            var that = this;
	            var element = that.element;
	            var formId = element.attr("form");
	            var form = formId ? $("#" + formId) : element.closest("form");
	            var initialValue = element[0].value;

	            if (!initialValue && that.options.value) {
	                initialValue = that.options.value;
	            }

	            if (form[0]) {
	                that._resetHandler = function () {
	                    setTimeout(function () {
	                        that.value(initialValue);
	                    });
	                };

	                that._formElement = form.on("reset", that._resetHandler);
	            }
	        },

	        _paste: function (e) {
	            e.preventDefault();
	        },

	        _keydown: function (e) {
	            var key = e.keyCode;
	            var selection;
	            if (key == 37 || key == 39) { //left/right
	                e.preventDefault();
	                selection = caret(this.element[0]);
	                if (selection[0] != selection[1]) {
	                    this._selectNearestSegment();
	                }
	                var dir = (key == 37) ? -1 : 1;
	                var index = (dir == -1) ? caret(this.element[0])[0] - 1 : caret(this.element[0])[1] + 1;
	                while (index >= 0 && index < this._format.length) {
	                    if (knownSymbols.indexOf(this._format[index]) >= 0) {
	                        this._selectSegment(this._format[index]);
	                        break;
	                    }
	                    index += dir;
	                }
	            }
	            if (key == 38 || key == 40) { //up/down
	                e.preventDefault();
	                selection = caret(this.element[0]);
	                var symbol = this._format[selection[0]];
	                if (knownSymbols.indexOf(symbol) >= 0) {
	                    var interval = 1;
	                    if (symbol == 'm') {
	                        interval = this.options.interval || 1;
	                    }
	                    this._dateTime.modifyPart(symbol, key == 38 ? interval * 1 : interval * -1);
	                    this._updateElementValue();
	                    this._selectSegment(symbol);
	                    this.element.trigger(CHANGE);
	                }
	            }
	            if (kendo.support.browser.msie && kendo.support.browser.version < 10) {
	                var keycode = e.keyCode ? e.keyCode : e.which;
	                if (keycode === 8 || keycode === 46) {
	                    var that = this;
	                    setTimeout(function () {
	                        that._input();
	                    }, 0);
	                }
	            }
	            if (key === keys.ENTER){
	                this._change();
	            }
	        },

	        _selectNearestSegment: function () {
	            var selection = caret(this.element[0]);
	            var start = selection[0];
	            for (var i = start, j = start - 1; i < this._format.length || j >= 0; i++ , j--) {
	                if (i < this._format.length && knownSymbols.indexOf(this._format[i]) !== -1) {
	                    this._selectSegment(this._format[i]);
	                    return;
	                }
	                if (j >= 0 && knownSymbols.indexOf(this._format[j]) !== -1) {
	                    this._selectSegment(this._format[j]);
	                    return;
	                }
	            }
	        },

	        _selectSegment: function (symbol) {
	            var begin = -1, end = 0;
	            for (var i = 0; i < this._format.length; i++) {
	                if (this._format[i] === symbol) {
	                    end = i + 1;
	                    if (begin === -1) {
	                        begin = i;
	                    }
	                }
	            }
	            if (begin < 0) {
	                begin = 0;
	            }
	            caret(this.element, begin, end);
	        }

	    });

	    ui.plugin(DateInput);

	    var customDateTime = function (initDate, initFormat, initCulture, initMessages) {

	        var value = null;
	        var year = true, month = true, date = true, hours = true, minutes = true, seconds = true, milliseconds = true;
	        var typedMonthPart = "";
	        var typedDayPeriodPart = "";
	        var placeholders = {};

	        //TODO: rewrite pad method
	        var zeros = ["", "0", "00", "000", "0000"];
	        function pad(number, digits, end) {
	            number = number + "";
	            digits = digits || 2;
	            end = digits - number.length;

	            if (end) {
	                return zeros[digits].substring(0, end) + number;
	            }

	            return number;
	        }
	        var dateFormatRegExp = /dddd|ddd|dd|d|MMMM|MMM|MM|M|yyyy|yy|HH|H|hh|h|mm|m|fff|ff|f|tt|ss|s|zzz|zz|z|"[^"]*"|'[^']*'/g;
	        var months = null, calendar = null, days = null, returnsFormat = false;
	        var matcher = function (match) {
	            var mins, sign;
	            var result;

	            switch (match) {
	                case ("d"): result = date ? value.getDate() : placeholders.day; break;
	                case ("dd"): result = date ? pad(value.getDate()) : placeholders.day; break;
	                case ("ddd"): result = date && month && year ? days.namesAbbr[value.getDay()] : placeholders.weekday; break;
	                case ("dddd"): result = date && month && year ? days.names[value.getDay()] : placeholders.weekday; break;

	                case ("M"): result = month ? value.getMonth() + 1 : placeholders.month; break;
	                case ("MM"): result = month ? pad(value.getMonth() + 1) : placeholders.month; break;
	                case ("MMM"): result = month ? months.namesAbbr[value.getMonth()] : placeholders.month; break;
	                case ("MMMM"): result = month ? months.names[value.getMonth()] : placeholders.month; break;

	                case ("yy"): result = year ? pad(value.getFullYear() % 100) : placeholders.year; break;
	                case ("yyyy"): result = year ? pad(value.getFullYear(), 4) : placeholders.year; break;

	                case ("h"): result = hours ? value.getHours() % 12 || 12 : placeholders.hour; break;
	                case ("hh"): result = hours ? pad(value.getHours() % 12 || 12) : placeholders.hour; break;
	                case ("H"): result = hours ? value.getHours() : placeholders.hour; break;
	                case ("HH"): result = hours ? pad(value.getHours()) : placeholders.hour; break;

	                case ("m"): result = minutes ? value.getMinutes() : placeholders.minute; break;
	                case ("mm"): result = minutes ? pad(value.getMinutes()) : placeholders.minute; break;
	                case ("s"): result = seconds ? value.getSeconds() : placeholders.second; break;
	                case ("ss"): result = seconds ? pad(value.getSeconds()) : placeholders.second; break;
	                case ("f"): result = milliseconds ? Math.floor(value.getMilliseconds() / 100) : milliseconds; break;
	                case ("ff"):
	                    result = value.getMilliseconds();
	                    if (result > 99) {
	                        result = Math.floor(result / 10);
	                    }
	                    result = milliseconds ? pad(result) : match;
	                    break;
	                case ("fff"): result = milliseconds ? pad(value.getMilliseconds(), 3) : match; break;
	                case ("tt"): result = hours ? (value.getHours() < 12 ? calendar.AM[0] : calendar.PM[0]) : placeholders.dayperiod; break;
	                case ("zzz"):
	                    mins = value.getTimezoneOffset();
	                    sign = mins < 0;
	                    result = Math.abs(mins / 60).toString().split(".")[0];
	                    mins = Math.abs(mins) - (result * 60);
	                    result = (sign ? "+" : "-") + pad(result);
	                    result += ":" + pad(mins);
	                    break;
	                case ("z"):
	                case ("zz"):
	                    result = value.getTimezoneOffset() / 60;
	                    sign = result < 0;
	                    result = Math.abs(result).toString().split(".")[0];
	                    result = (sign ? "+" : "-") + (match === "zz" ? pad(result) : result);
	                    break;
	            }
	            result = (result !== undefined ? result : match.slice(1, match.length - 1));

	            if (returnsFormat) {
	                result = "" + result;
	                var formatResult = "";
	                if (match == "ddd") { match = "EEE"; }
	                if (match == "dddd") { match = "EEEE"; }
	                for (var i = 0; i < result.length; i++) {
	                    formatResult += match[0];
	                }
	                return formatResult;
	            } else {
	                return result;
	            }
	        };

	        function generateMatcher(retFormat) {
	            returnsFormat = retFormat;
	            return matcher;
	        }

	        function setExisting(symbol, val) {
	            switch (symbol) {
	                case "y": year = val; break;
	                case "M": month = val;
	                    if (!val) {
	                        value.setMonth(0);
	                        typedMonthPart = "";
	                    }
	                    break;
	                case "d": date = val; break;
	                case "H":
	                case "h": hours = val;
	                    if (!val) {
	                        typedDayPeriodPart = "";
	                    }
	                    break;
	                case "m": minutes = val; break;
	                case "s": seconds = val; break;
	                default: return;
	            }
	        }

	        this.setValue = function (val) {
	            date = val;
	        };

	        this.getValue = function () {
	            return date;
	        };

	        this.modifyPart = function (symbol, offset) {
	            var newValue = new Date((value && value.getTime) ? value.getTime() : value);
	            switch (symbol) {
	                case "y": newValue.setFullYear(newValue.getFullYear() + offset); break;
	                case "M":
	                    var newMonth = newValue.getMonth() + offset;
	                    newValue.setMonth(newMonth);
	                    if (newValue.getMonth() % 12 !== (newMonth + 12) % 12) {
	                        //handle case when new month does not have such date
	                        newValue.setDate(1);
	                        newValue.setMonth(newMonth);
	                    }
	                    break;
	                case "d":
	                case "E": newValue.setDate(newValue.getDate() + offset); break;
	                case "H":
	                case "h": newValue.setHours(newValue.getHours() + offset); break;
	                case "m": newValue.setMinutes(newValue.getMinutes() + offset); break;
	                case "s": newValue.setSeconds(newValue.getSeconds() + offset); break;
	                case "t": newValue.setHours((newValue.getHours() + 12) % 24); break;
	                default: break;
	            }
	            if (newValue.getFullYear() > 0) {
	                setExisting(symbol, true);
	                value = newValue;
	            }
	        };

	        this.parsePart = function (symbol, currentChar) {
	            if (!currentChar) {
	                setExisting(symbol, false);
	                return true;
	            }
	            var newValue = new Date((value && value.getTime) ? value.getTime() : value);
	            var lastDateOfMonth = new Date(newValue.getFullYear(), newValue.getMonth() + 1, 0).getDate();
	            var newHours;
	            switch (symbol) {
	                case "d":
	                    var newDate = (date ? newValue.getDate() * 10 : 0) + parseInt(currentChar, 10);
	                    if (isNaN(newDate)) { return; }
	                    while (newDate > lastDateOfMonth) {
	                        newDate = parseInt(newDate.toString().slice(1), 10);
	                    }
	                    if (newDate < 1) {
	                        date = false;
	                    } else {
	                        newValue.setDate(newDate);
	                        if (newValue.getMonth() !== value.getMonth()) {
	                            return;
	                        }
	                        date = true;
	                    }
	                    break;
	                case "M":
	                    var newMonth = (month ? (newValue.getMonth() + 1) * 10 : 0) + parseInt(currentChar, 10);
	                    if (!isNaN(newMonth)) {
	                        while (newMonth > 12) {
	                            newMonth = parseInt(newMonth.toString().slice(1), 10);
	                        }
	                        if (newMonth < 1) {
	                            month = false;
	                        } else {
	                            newValue.setMonth(newMonth - 1);
	                            if (newValue.getMonth() !== newMonth - 1) {
	                                newValue.setDate(1);
	                                newValue.setMonth(newMonth - 1);
	                            }
	                            month = true;
	                        }
	                    }
	                    else {
	                        var monthNames = calendar.months.names;
	                        typedMonthPart += currentChar.toLowerCase();

	                        while (typedMonthPart.length > 0) {
	                            for (var i = 0; i < monthNames.length; i++) {
	                                if (monthNames[i].toLowerCase().indexOf(typedMonthPart) === 0) {
	                                    newValue.setMonth(i);
	                                    month = true;
	                                    value = newValue;
	                                    return true;
	                                }
	                            }
	                            typedMonthPart = typedMonthPart.substring(1, typedMonthPart.length);
	                        }
	                        return false;
	                    }
	                    break;
	                case "y":
	                    var newYear = (year ? (newValue.getFullYear()) * 10 : 0) + parseInt(currentChar, 10);
	                    if (isNaN(newYear)) {return;}
	                    while (newYear > 9999) {
	                        newYear = parseInt(newYear.toString().slice(1), 10);
	                    }
	                    if (newYear < 1) {
	                        year = false;
	                    } else {
	                        newValue.setFullYear(newYear);
	                        year = true;
	                    }
	                    break;
	                case "h":
	                    newHours = (hours ? (newValue.getHours() % 12 || 12) * 10 : 0) + parseInt(currentChar, 10);
	                    if (isNaN(newHours)) { return; }
	                    while (newHours > 12) {
	                        newHours = parseInt(newHours.toString().slice(1), 10);
	                    }
	                    newValue.setHours(Math.floor(newValue.getHours() / 12) * 12 + newHours % 12);
	                    hours = true;
	                    break;
	                case "H":
	                    newHours = (hours ? (newValue.getHours()) * 10 : 0) + parseInt(currentChar, 10);
	                    if (isNaN(newHours)) { return; }
	                    while (newHours > 23) {
	                        newHours = parseInt(newHours.toString().slice(1), 10);
	                    }
	                    newValue.setHours(newHours);
	                    hours = true;
	                    break;
	                case "m":
	                    var newMinutes = (minutes ? (newValue.getMinutes()) * 10 : 0) + parseInt(currentChar, 10);
	                    if (isNaN(newMinutes)) { return; }
	                    while (newMinutes > 59) {
	                        newMinutes = parseInt(newMinutes.toString().slice(1), 10);
	                    }
	                    newValue.setMinutes(newMinutes);
	                    minutes = true;
	                    break;
	                case "s":
	                    var newSeconds = (seconds ? (newValue.getSeconds()) * 10 : 0) + parseInt(currentChar, 10);
	                    if (isNaN(newSeconds)) { return; }
	                    while (newSeconds > 59) {
	                        newSeconds = parseInt(newSeconds.toString().slice(1), 10);
	                    }
	                    newValue.setSeconds(newSeconds);
	                    seconds = true;
	                    break;
	                case "t":
	                    if (hours) {
	                        typedDayPeriodPart += currentChar.toLowerCase();
	                        while (typedDayPeriodPart.length > 0) {
	                            if (calendar.AM[0].toLowerCase().indexOf(typedDayPeriodPart) === 0 && newValue.getHours() >= 12 ||
	                                calendar.PM[0].toLowerCase().indexOf(typedDayPeriodPart) === 0 && newValue.getHours() < 12) {
	                                newValue.setHours((newValue.getHours() + 12) % 24);
	                                value = newValue;
	                                return true;
	                            }
	                            typedDayPeriodPart = typedDayPeriodPart.substring(1, typedDayPeriodPart.length);
	                        }
	                        return false;
	                    }
	                    break;
	                default: break;
	            }
	            value = newValue;
	            return true;
	        };

	        this.toPair = function (format, culture , messages) {
	            if (!format) {
	                return ["", ""];
	            }
	            culture = kendo.getCulture(culture);
	            calendar = culture.calendars.standard;
	            format = calendar.patterns[format] || format;
	            days = calendar.days;
	            months = calendar.months;
	            placeholders = messages;
	            return [
	                format.replace(dateFormatRegExp, generateMatcher(false)),
	                format.replace(dateFormatRegExp, generateMatcher(true))
	            ];
	        };

	        this.getDateObject = function () {
	            return (year && month && date && hours && minutes && seconds && milliseconds) ?
	                new Date(value.getTime()) : null;
	        };

	        if (!initDate) {
	            value = new Date();
	            var sampleFormat = this.toPair(initFormat, initCulture, initMessages)[1];
	            for (var i = 0; i < sampleFormat.length; i++) {
	                setExisting(sampleFormat[i], false);
	            }
	        } else {
	            value = new Date(initDate.getTime());
	        }
	    };

	    function approximateStringMatching(oldText, oldFormat, newText, caret){
	        var oldTextSeparator = oldText[caret + oldText.length - newText.length];
	        oldText = oldText.substring(0, caret + oldText.length - newText.length);
	        newText = newText.substring(0, caret);
	        var diff = [];
	        var i;
	        //handle typing single character over the same selection
	        if (oldText === newText && caret > 0) {
	            diff.push([oldFormat[caret - 1], newText[caret - 1]]);
	            return diff;
	        }
	        if (oldText.indexOf(newText) === 0 && (newText.length === 0 || oldFormat[newText.length - 1] !== oldFormat[newText.length])) {
	            //handle delete/backspace
	            var deletedSymbol = "";
	            for (i = newText.length; i < oldText.length; i++) {
	                if (oldFormat[i] !== deletedSymbol && knownSymbols.indexOf(oldFormat[i]) >= 0) {
	                    deletedSymbol = oldFormat[i];
	                    diff.push([deletedSymbol, ""]);
	                }
	            }
	            return diff;
	        }

	        //handle entering space or separator, for nagivation to next item
	        if (newText[newText.length - 1] === " " || newText[newText.length - 1] === oldTextSeparator) {
	            return [[oldFormat[caret - 1], " "]];
	        }

	        //handle inserting text (new text is longer than previous)
	        //handle typing over literal as well
	        if (newText.indexOf(oldText) === 0 || knownSymbols.indexOf(oldFormat[caret - 1]) === -1) {
	            var symbol = oldFormat[0];
	            for (i = Math.max(0, oldText.length - 1); i < oldFormat.length; i++) {
	                if (knownSymbols.indexOf(oldFormat[i]) >= 0) {
	                    symbol = oldFormat[i];
	                    break;
	                }
	            }
	            return [[symbol, newText[caret - 1]]];
	        }
	        //handle typing over correctly selected part
	        return [[oldFormat[caret - 1], newText[caret - 1]]];
	}

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "bgyk":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1592);
	module.exports = __webpack_require__(1592);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 8:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("3i6F");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1566:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ydSV");

/***/ }),

/***/ 1592:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20), __webpack_require__(1566), __webpack_require__(8) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    /* jshint eqnull:true */
	    /* jshint latedef: false */
	    /* jshint multistr: true */

	    var $ = kendo.jQuery;
	    var ObservableObject = kendo.data.ObservableObject;

	    var MESSAGES = kendo.spreadsheet.messages.dialogs = {
	        apply: "Apply",
	        save: "Save",
	        cancel: "Cancel",
	        remove: "Remove",
	        retry: "Retry",
	        revert: "Revert",
	        okText: "OK",
	        formatCellsDialog: {
	            title: "Format",
	            categories: {
	                number: "Number",
	                currency: "Currency",
	                date: "Date"
	            }
	        },
	        fontFamilyDialog: {
	            title: "Font"
	        },
	        fontSizeDialog: {
	            title: "Font size"
	        },
	        bordersDialog: {
	            title: "Borders"
	        },
	        alignmentDialog: {
	            title: "Alignment",
	            buttons: {
	                justtifyLeft: "Align left",
	                justifyCenter: "Center",
	                justifyRight: "Align right",
	                justifyFull: "Justify",
	                alignTop: "Align top",
	                alignMiddle: "Align middle",
	                alignBottom: "Align bottom"
	            }
	        },
	        mergeDialog: {
	            title: "Merge cells",
	            buttons: {
	                mergeCells: "Merge all",
	                mergeHorizontally: "Merge horizontally",
	                mergeVertically: "Merge vertically",
	                unmerge: "Unmerge"
	            }
	        },
	        freezeDialog: {
	            title: "Freeze panes",
	            buttons: {
	                freezePanes: "Freeze panes",
	                freezeRows: "Freeze rows",
	                freezeColumns: "Freeze columns",
	                unfreeze: "Unfreeze panes"
	            }
	        },
	        confirmationDialog: {
	            text: "Are you sure you want to remove this sheet?",
	            title: "Sheet remove"
	        },
	        validationDialog: {
	            title: "Data Validation",
	            hintMessage: "Please enter a valid {0} value {1}.",
	            hintTitle: "Validation {0}",
	            criteria: {
	                any: "Any value",
	                number: "Number",
	                text: "Text",
	                date: "Date",
	                custom: "Custom Formula",
	                list: "List"
	            },
	            comparers: {
	                greaterThan: "greater than",
	                lessThan: "less than",
	                between: "between",
	                notBetween: "not between",
	                equalTo: "equal to",
	                notEqualTo: "not equal to",
	                greaterThanOrEqualTo: "greater than or equal to",
	                lessThanOrEqualTo: "less than or equal to"
	            },
	            comparerMessages: {
	                greaterThan: "greater than {0}",
	                lessThan: "less than {0}",
	                between: "between {0} and {1}",
	                notBetween: "not between {0} and {1}",
	                equalTo: "equal to {0}",
	                notEqualTo: "not equal to {0}",
	                greaterThanOrEqualTo: "greater than or equal to {0}",
	                lessThanOrEqualTo: "less than or equal to {0}",
	                custom: "that satisfies the formula: {0}"
	            },
	            labels: {
	                criteria: "Criteria",
	                comparer: "Comparer",
	                min: "Min",
	                max: "Max",
	                value: "Value",
	                start: "Start",
	                end: "End",
	                onInvalidData: "On invalid data",
	                rejectInput: "Reject input",
	                showWarning: "Show warning",
	                showHint: "Show hint",
	                hintTitle: "Hint title",
	                hintMessage: "Hint message",
	                ignoreBlank: "Ignore blank",
	                showListButton: "Display button to show list",
	                showCalendarButton: "Display button to show calendar"
	            },
	            placeholders: {
	                typeTitle: "Type title",
	                typeMessage: "Type message"
	            }
	        },
	        exportAsDialog: {
	            title: "Export...",
	            defaultFileName: "Workbook",
	            xlsx: {
	                description: "Excel Workbook (.xlsx)"
	            },
	            pdf: {
	                description: "Portable Document Format (.pdf)",
	                area: {
	                    workbook: "Entire Workbook",
	                    sheet: "Active Sheet",
	                    selection: "Selection"
	                },
	                paper: {
	                    a2        : "A2 (420 mm × 594 mm)",
	                    a3        : "A3 (297 mm x 420 mm)",
	                    a4        : "A4 (210 mm x 297 mm)",
	                    a5        : "A5 (148 mm x 210 mm)",
	                    b3        : "B3 (353 mm × 500 mm)",
	                    b4        : "B4 (250 mm x 353 mm)",
	                    b5        : "B5 (176 mm x 250 mm)",
	                    folio     : 'Folio (8.5" x 13")',
	                    legal     : 'Legal (8.5" x 14")',
	                    letter    : 'Letter (8.5" x 11")',
	                    tabloid   : 'Tabloid (11" x 17")',
	                    executive : 'Executive (7.25" x 10.5")'
	                },
	                margin: {
	                    normal: "Normal",
	                    narrow: "Narrow",
	                    wide: "Wide"
	                }
	            },
	            labels: {
	                scale: "Scale",
	                fit: "Fit to page",
	                fileName: "File name",
	                saveAsType: "Save as type",
	                exportArea: "Export",
	                paperSize: "Paper size",
	                margins: "Margins",
	                orientation: "Orientation",
	                print: "Print",
	                guidelines: "Guidelines",
	                center: "Center",
	                horizontally: "Horizontally",
	                vertically: "Vertically"
	            }
	        },
	        modifyMergedDialog: {
	            errorMessage: "Cannot change part of a merged cell."
	        },
	        rangeDisabledDialog: {
	            errorMessage: "Destination range contains disabled cells."
	        },
	        intersectsArrayDialog: {
	            errorMessage: "You cannot alter part of an array"
	        },
	        incompatibleRangesDialog: {
	            errorMessage: "Incompatible ranges"
	        },
	        noFillDirectionDialog: {
	            errorMessage: "Cannot determine fill direction"
	        },
	        duplicateSheetNameDialog: {
	            errorMessage: "Duplicate sheet name"
	        },
	        overflowDialog: {
	            errorMessage: "Cannot paste, because the copy area and the paste area are not the same size and shape."
	        },
	        useKeyboardDialog: {
	            title: "Copying and pasting",
	            errorMessage: "These actions cannot be invoked through the menu. Please use the keyboard shortcuts instead:",
	            labels: {
	                forCopy: "for copy",
	                forCut: "for cut",
	                forPaste: "for paste"
	            }
	        },
	        unsupportedSelectionDialog: {
	            errorMessage: "That action cannot be performed on multiple selection."
	        },
	        linkDialog: {
	            title: "Hyperlink",
	            labels: {
	                text: "Text",
	                url: "Address",
	                removeLink: "Remove link"
	            }
	        },
	        insertCommentDialog: {
	            title: "Insert comment",
	            labels: {
	                comment: "Comment",
	                removeComment: "Remove comment"
	            }
	        },
	        insertImageDialog: {
	            title: "Insert image",
	            info: "Drag an image here, or click to select",
	            typeError: "Please select a JPEG, PNG or GIF image"
	        }
	    };

	    var registry = {};
	    kendo.spreadsheet.dialogs = {
	        register: function(name, dialogClass) {
	            registry[name] = dialogClass;
	        },
	        registered: function(name) {
	            return !!registry[name];
	        },
	        create: function(name, options) {
	            var dialogClass = registry[name];

	            if (dialogClass) {
	                return new dialogClass(options);
	            }
	        }
	    };

	    var SpreadsheetDialog = kendo.spreadsheet.SpreadsheetDialog = kendo.Observable.extend({
	        init: function(options) {
	            kendo.Observable.fn.init.call(this, options);

	            this.options = translate($.extend(true, {}, this.options, options));

	            this.bind(this.events, options);
	        },
	        events: [
	            "close",
	            "activate"
	        ],
	        options: {
	            autoFocus: true
	        },
	        dialog: function() {
	            if (!this._dialog) {
	                var options = {
	                    autoFocus: false,
	                    scrollable: false,
	                    resizable: false,
	                    modal: true,
	                    visible: false,
	                    width: this.options.width || 320,
	                    title: this.options.title,
	                    open: function() {
	                        this.center();
	                    },
	                    close: this._onDialogClose.bind(this),
	                    activate: this._onDialogActivate.bind(this),
	                    deactivate: this._onDialogDeactivate.bind(this)
	                };
	                this._dialog = $("<div class='k-spreadsheet-window k-action-window k-popup-edit-form' />")
	                    .addClass(this.options.className || "")
	                    .append(kendo.template(this.options.template)({
	                        messages: kendo.spreadsheet.messages.dialogs || MESSAGES,

	                        // this is for ImportErrorDialog.  ugly that
	                        // we need this line here, but I couldn't
	                        // figure out a better way
	                        errors: this.options.errors
	                    }))
	                    .kendoWindow(options)
	                    .data("kendoWindow");
	            }

	            return this._dialog;
	        },
	        _onDialogClose: function() {
	            this.trigger("close", {
	                action: this._action
	            });
	        },
	        _onDialogActivate: function() {
	            this.trigger("activate");
	        },
	        _onDialogDeactivate: function() {
	            this.trigger("deactivate");
	            this.destroy();
	        },
	        destroy: function() {
	            if (this._dialog) {
	                this._dialog.destroy();
	                this._dialog = null;
	            }
	        },
	        open: function() {
	            this.dialog().open();
	            this.dialog().element.find(".k-primary").focus();
	        },
	        apply: function() {
	            this.close();
	        },
	        close: function() {
	            this._action = "close";

	            this.dialog().close();
	        }
	    });

	    function formattedValue(value, format) {
	        return kendo.spreadsheet.formatting.text(value, format);
	    }

	    var FormatCellsViewModel = kendo.spreadsheet.FormatCellsViewModel = ObservableObject.extend({
	        init: function(options) {
	            ObservableObject.fn.init.call(this, options);

	            this.useCategory(this.category);
	        },
	        useCategory: function(category) {
	            var type = category && category.type || "number";
	            var formatCurrency = type == "currency";

	            this.category = category;

	            this.set("showCurrencyFilter", formatCurrency && this.currencies.length > 1);

	            if (!formatCurrency) {
	                this.set("formats", this.allFormats[type + "Formats"]);
	            } else {
	                this.currency(this.currencies[0]);
	            }

	            this.useFirstFormat();
	        },
	        useFirstFormat: function() {
	            if (this.formats.length) {
	                this.set("format", this.formats[0].value);
	            }
	        },
	        currency: function(currency) {
	            if (currency !== undefined) {
	                this._currency = currency;

	                var info = currency.value;
	                var formats = [
	                    { currency: info, decimals: true },
	                    { currency: info, decimals: true, iso: true },
	                    { currency: info, decimals: false }
	                ];

	                formats = formats.map(function(format) {
	                    format = FormatCellsViewModel.convert.currency(format);

	                    return { value: format, name: formattedValue(1000, format) };
	                });

	                this.set("formats", formats);

	                this.useFirstFormat();
	            }

	            return this._currency || this.currencies[0];
	        },
	        categoryFilter: function(category) {
	            if (category !== undefined) {
	                this.useCategory(category);
	            }

	            return this.category;
	        },
	        preview: function() {
	            var format = this.get("format");
	            var value = this.value || 0;

	            if (format && format.length) {
	                return formattedValue(value, format);
	            } else {
	                return value;
	            }
	        }
	    });

	    FormatCellsViewModel.convert = {
	        currency: function(options) {
	            function repeat(token, n) {
	                return new Array(n+1).join(token);
	            }

	            // convert culture info to spreadsheet format
	            var info = options.currency;
	            var format = info.pattern[1];

	            if (options.decimals) {
	                format = format.replace(/n/g, "n" + info["."] + repeat("0", info.decimals));
	            }

	            if (options.iso) {
	                format = '"' + info.abbr + '" ' + format.replace(/\s*\$\s*/g, "");
	            } else {
	                format = format.replace(/\$/g, JSON.stringify(info.symbol));
	            }

	            format = format.replace(/n/g, "?");

	            return format;
	        },
	        date: function(format) {
	            if ((/T|Z/).test(format)) {
	                return "";
	            }

	            return format.toLowerCase().replace(/tt/g, "AM/PM").replace(/'/g, '"');
	        }
	    };

	    function uniqueBy(field, array) {
	        var result = [];
	        var values = [];

	        for (var i = 0; i < array.length; i++) {
	            if ($.inArray(array[i][field], values) == -1) {
	                result.push(array[i]);
	                values.push(array[i][field]);
	            }
	        }

	        return result;
	    }

	    var FormatCellsDialog = SpreadsheetDialog.extend({
	        init: function(options) {
	            var messages = kendo.spreadsheet.messages.dialogs.formatCellsDialog || MESSAGES;
	            var defaultOptions = {
	                title: messages.title,
	                categories: [
	                    { type: "number", name: messages.categories.number },
	                    { type: "currency", name: messages.categories.currency },
	                    { type: "date", name: messages.categories.date }
	                ]
	            };

	            SpreadsheetDialog.fn.init.call(this, $.extend(defaultOptions, options));

	            this._generateFormats();
	        },
	        options: {
	            className: "k-spreadsheet-format-cells",
	            template:
	                "<div class='k-edit-form-container'>" +

	                    "<div class='k-root-tabs' data-role='tabstrip' " +
	                        "data-text-field='name' " +
	                        "data-bind='source: categories, value: categoryFilter' " +
	                        "data-animation='false'></div>" +

	                    "<div class='k-spreadsheet-preview' data-bind='text: preview'></div>" +

	                    "<script type='text/x-kendo-template' id='format-item-template'>" +
	                        "\\#: data.name \\#" +
	                    "</script>" +

	                    "<select data-role='dropdownlist' class='k-format-filter' " +
	                        "data-text-field='description' " +
	                        "data-value-field='value.name' " +
	                        "data-bind='visible: showCurrencyFilter, value: currency, source: currencies'></select>" +

	                    "<ul data-role='staticlist' tabindex='0' " +
	                        "class='k-list k-reset' " +
	                        "data-template='format-item-template' " +
	                        "data-value-primitive='true' " +
	                        "data-value-field='value' " +
	                        "data-bind='source: formats, value: format'></ul>" +

	                    "<div class='k-action-buttons'>" +
	                        "<button class='k-button k-primary' data-bind='click: apply'>#: messages.apply #</button>" +
	                        "<button class='k-button' data-bind='click: close'>#: messages.cancel #</button>" +
	                    "</div>"+

	                "</div>"
	        },
	        _generateFormats: function() {
	            var options = this.options;

	            if (!options.currencies) {
	                options.currencies = FormatCellsDialog.currenciesFrom(kendo.cultures);
	            }

	            if (!options.numberFormats) {
	                options.numberFormats = [
	                    { value: "#.00%", name: "100.00%" },
	                    { value: "#%", name: "100%" },
	                    { value: "#.00", name: "1024.00" },
	                    { value: "#,###.00", name: "1,024.00" }
	                ];
	            }

	            if (!options.dateFormats) {
	                var calendarPatterns = kendo.cultures.current.calendars.standard.patterns;

	                options.dateFormats = uniqueBy("value", $.map(calendarPatterns, function(format) {
	                    format = FormatCellsViewModel.convert.date(format);

	                    if (!format) {
	                        return;
	                    }

	                    return { value: format, name: formattedValue(34567.7678, format) };
	                }));
	            }
	        },
	        open: function(range) {
	            var options = this.options;
	            var value = range.value();
	            var categories = options.categories.slice(0);
	            var element;

	            this.viewModel = new FormatCellsViewModel({
	                currencies: options.currencies.slice(0),
	                allFormats: {
	                    numberFormats: options.numberFormats.slice(0),
	                    dateFormats: options.dateFormats.slice(0)
	                },
	                categories: categories,
	                format: range.format(),
	                category: value instanceof Date ? categories[2] : categories[0],
	                apply: this.apply.bind(this),
	                close: this.close.bind(this),
	                value: value
	            });

	            SpreadsheetDialog.fn.open.call(this);

	            element = this.dialog().element;

	            kendo.bind(element, this.viewModel);

	            var currencyFilter = element.find("select.k-format-filter").data("kendoDropDownList");

	            if (options.currencies.length > 10) {
	                currencyFilter.setOptions({ filter: "contains" });
	            }

	            element.find(kendo.roleSelector("staticlist")).parent().addClass("k-list-wrapper");
	        },
	        apply: function() {
	            var format = this.viewModel.format;

	            SpreadsheetDialog.fn.apply.call(this);

	            this.trigger("action", {
	                command: "PropertyChangeCommand",
	                options: {
	                    property: "format",
	                    value: format
	                }
	            });
	        }
	    });

	    FormatCellsDialog.currenciesFrom = function (cultures) {
	        return uniqueBy("description", $.map(cultures, function(culture, name) {
	            if (!(/-/).test(name)) {
	                return;
	            }

	            var currency = culture.numberFormat.currency;
	            var description = kendo.format(
	                "{0} ({1}, {2})",
	                currency.name,
	                currency.abbr,
	                currency.symbol
	            );

	            return { description: description, value: currency };
	        }));
	    };

	    kendo.spreadsheet.dialogs.register("formatCells", FormatCellsDialog);

	    kendo.spreadsheet.dialogs.FormatCellsDialog = FormatCellsDialog;

	    var MessageDialog = SpreadsheetDialog.extend({
	        options: {
	            className: "k-spreadsheet-message",
	            title: "",
	            messageId: "",
	            text: "",
	            template:
	                "<div class='k-spreadsheet-message-content' data-bind='text: text'></div>" +
	                "<div class='k-action-buttons'>" +
	                    "<button class='k-button k-primary' data-bind='click: close'>" +
	                        "#= messages.okText #" +
	                    "</button>" +
	                "</div>"
	        },
	        open: function() {
	            SpreadsheetDialog.fn.open.call(this);

	            var options = this.options;
	            var text = options.text;

	            if (options.messageId) {
	                text = kendo.getter(options.messageId, true)(kendo.spreadsheet.messages.dialogs);
	            }

	            kendo.bind(this.dialog().element, {
	                text: text,
	                close: this.close.bind(this)
	            });
	        }
	    });

	    kendo.spreadsheet.dialogs.register("message", MessageDialog);

	    var ConfirmationDialog = SpreadsheetDialog.extend({
	        init: function(options) {
	            var messages = kendo.spreadsheet.messages.dialogs.confirmationDialog || MESSAGES;
	            var defaultOptions = {
	                title: messages.title,
	                text: messages.text
	            };

	            SpreadsheetDialog.fn.init.call(this, $.extend(defaultOptions, options));
	        },
	        options: {
	            className: "k-spreadsheet-message",
	            messageId: "",
	            template:
	                "<div class='k-spreadsheet-message-content' data-bind='text: text'></div>" +
	                "<div class='k-action-buttons'>" +
	                    "<button class='k-button k-primary' data-bind='click: confirm'>" +
	                        "#= messages.okText #" +
	                    "</button>" +
	                    "<button class='k-button' data-bind='click: cancel'>" +
	                        "#= messages.cancel #" +
	                    "</button>" +
	                "</div>"
	        },
	        open: function() {
	            SpreadsheetDialog.fn.open.call(this);

	            var options = this.options;
	            var text = options.text;

	            if (options.messageId) {
	                text = kendo.getter(options.messageId, true)(kendo.spreadsheet.messages.dialogs);
	            }

	            kendo.bind(this.dialog().element, {
	                text: text,
	                confirm: this.confirm.bind(this),
	                cancel: this.close.bind(this)
	            });
	        },
	        isConfirmed: function() {
	            return this._confirmed;
	        },
	        confirm: function() {
	            this._confirmed = true;
	            this.close();
	        }
	    });

	    kendo.spreadsheet.dialogs.register("confirmation", ConfirmationDialog);

	    var ValidationErrorDialog = SpreadsheetDialog.extend({
	        options: {
	            className: "k-spreadsheet-message",
	            title: "",
	            messageId: "",
	            text: "",
	            template:
	            "<div class='k-spreadsheet-message-content' data-bind='text: text'></div>" +
	            "<div class='k-action-buttons'>" +
	            "<button class='k-button k-primary' data-bind='click: retry'>" +
	                "#= messages.retry #" +
	            "</button>" +
	            "<button class='k-button' data-bind='click: cancel'>" +
	                "#= messages.cancel #" +
	            "</button>" +
	            "</div>"
	        },
	        open: function() {
	            SpreadsheetDialog.fn.open.call(this);

	            var options = this.options;
	            var text = options.text;

	            if (options.messageId) {
	                text = kendo.getter(options.messageId, true)(kendo.spreadsheet.messages.dialogs);
	            }

	            kendo.bind(this.dialog().element, {
	                text: text,
	                retry: this.retry.bind(this),
	                cancel: this.close.bind(this)
	            });
	        },
	        retry: function() {
	            this._retry = true;
	            this.close();
	        }
	    });

	    kendo.spreadsheet.dialogs.register("validationError", ValidationErrorDialog);

	    var FontFamilyDialog = SpreadsheetDialog.extend({
	        init: function(options) {
	            var messages = kendo.spreadsheet.messages.dialogs.fontFamilyDialog || MESSAGES;

	            SpreadsheetDialog.fn.init.call(this, $.extend({ title: messages.title }, options));

	            this._list();
	        },
	        options: {
	            template: "<ul class='k-list k-reset'></ul>"
	        },
	        _list: function() {
	            var ul = this.dialog().element.find("ul");
	            var fonts = this.options.fonts;
	            var defaultFont = this.options.defaultFont;

	            this.list = new kendo.ui.StaticList(ul, {
	                dataSource: new kendo.data.DataSource({ data: fonts }),
	                template: "#: data #",
	                value: defaultFont,
	                change: this.apply.bind(this)
	            });

	            this.list.dataSource.fetch();
	        },
	        apply: function(e) {
	            SpreadsheetDialog.fn.apply.call(this);

	            this.trigger("action", {
	                command: "PropertyChangeCommand",
	                options: {
	                    property: "fontFamily",
	                    value: e.sender.value()[0]
	                }
	            });
	        }
	    });

	    kendo.spreadsheet.dialogs.register("fontFamily", FontFamilyDialog);

	    var FontSizeDialog = SpreadsheetDialog.extend({
	        init: function(options) {
	            var messages = kendo.spreadsheet.messages.dialogs.fontSizeDialog || MESSAGES;

	            SpreadsheetDialog.fn.init.call(this, $.extend({ title: messages.title }, options));

	            this._list();
	        },
	        options: {
	            template: "<ul class='k-list k-reset'></ul>"
	        },
	        _list: function() {
	            var ul = this.dialog().element.find("ul");
	            var sizes = this.options.sizes;
	            var defaultSize = this.options.defaultSize;

	            this.list = new kendo.ui.StaticList(ul, {
	                dataSource: new kendo.data.DataSource({ data: sizes }),
	                template: "#: data #",
	                value: defaultSize,
	                change: this.apply.bind(this)
	            });

	            this.list.dataSource.fetch();
	        },
	        apply: function(e) {
	            SpreadsheetDialog.fn.apply.call(this);

	            this.trigger("action", {
	                command: "PropertyChangeCommand",
	                options: {
	                    property: "fontSize",
	                    value: kendo.parseInt(e.sender.value()[0])
	                }
	            });
	        }
	    });

	    kendo.spreadsheet.dialogs.register("fontSize", FontSizeDialog);

	    var BordersDialog = SpreadsheetDialog.extend({
	        init: function(options) {
	            var messages = kendo.spreadsheet.messages.dialogs.bordersDialog || MESSAGES;

	            SpreadsheetDialog.fn.init.call(this, $.extend({ title: messages.title }, options));

	            this.element = this.dialog().element;
	            this._borderPalette();

	            this.viewModel = kendo.observable({
	                apply: this.apply.bind(this),
	                close: this.close.bind(this)
	            });

	            kendo.bind(this.element.find(".k-action-buttons"), this.viewModel);
	        },
	        options: {
	            width: 177,
	            template:   "<div></div>" +
	                        "<div class='k-action-buttons'>" +
	                            "<button class='k-button k-primary' data-bind='click: apply'>#: messages.apply #</button>" +
	                            "<button class='k-button' data-bind='click: close'>#: messages.cancel #</button>" +
	                        "</div>"
	        },
	        apply: function() {
	            SpreadsheetDialog.fn.apply.call(this);

	            var state = this.value();

	            this.trigger("action", {
	                command: "BorderChangeCommand",
	                options: {
	                    border: state.type,
	                    style: { size: 1, color: state.color }
	                }
	            });
	        },
	        _borderPalette: function() {
	            var element = this.dialog().element.find("div:first");

	            this.borderPalette = new kendo.spreadsheet.BorderPalette(element, {
	                change: this.value.bind(this)
	            });
	        },
	        value: function(state) {
	            if (state === undefined) {
	                return this._state;
	            } else {
	                this._state = state;
	            }
	        }
	    });

	    kendo.spreadsheet.dialogs.register("borders", BordersDialog);

	    var ColorChooser = SpreadsheetDialog.extend({
	        init: function(options) {
	            SpreadsheetDialog.fn.init.call(this, options);

	            this.element = this.dialog().element;
	            this.property = options.property;
	            this.options.title = options.title;

	            this.viewModel = kendo.observable({
	                apply: this.apply.bind(this),
	                close: this.close.bind(this)
	            });

	            kendo.bind(this.element.find(".k-action-buttons"), this.viewModel);
	        },
	        options: {
	            template:   "<div></div>" +
	                        "<div class='k-action-buttons'>" +
	                            "<button class='k-button k-primary' data-bind='click: apply'>#: messages.apply #</button>" +
	                            "<button class='k-button' data-bind='click: close'>#: messages.cancel #</button>" +
	                        "</div>"
	        },
	        apply: function() {
	            SpreadsheetDialog.fn.apply.call(this);

	            this.trigger("action", {
	                command: "PropertyChangeCommand",
	                options: {
	                    property: this.property,
	                    value: this.value()
	                }
	            });
	        },
	        value: function(e) {
	            if (e === undefined) {
	                return this._value;
	            } else {
	                this._value = e.value;
	            }
	        }
	    });

	    var ColorPickerDialog = ColorChooser.extend({
	        init: function(options) {
	            options.width = 177;
	            ColorChooser.fn.init.call(this, options);
	            this._colorPalette();
	        },
	        _colorPalette: function() {
	            var element = this.dialog().element.find("div:first");
	            this.colorPalette = element.kendoColorPalette({
	                palette: [ //metro palette
	                    "#ffffff", "#000000", "#d6ecff", "#4e5b6f", "#7fd13b", "#ea157a", "#feb80a", "#00addc", "#738ac8", "#1ab39f",
	                    "#f2f2f2", "#7f7f7f", "#a7d6ff", "#d9dde4", "#e5f5d7", "#fad0e4", "#fef0cd", "#c5f2ff", "#e2e7f4", "#c9f7f1",
	                    "#d8d8d8", "#595959", "#60b5ff", "#b3bcca", "#cbecb0", "#f6a1c9", "#fee29c", "#8be6ff", "#c7d0e9", "#94efe3",
	                    "#bfbfbf", "#3f3f3f", "#007dea", "#8d9baf", "#b2e389", "#f272af", "#fed46b", "#51d9ff", "#aab8de", "#5fe7d5",
	                    "#a5a5a5", "#262626", "#003e75", "#3a4453", "#5ea226", "#af0f5b", "#c58c00", "#0081a5", "#425ea9", "#138677",
	                    "#7f7f7f", "#0c0c0c", "#00192e", "#272d37", "#3f6c19", "#750a3d", "#835d00", "#00566e", "#2c3f71", "#0c594f"
	                ],
	                change: this.value.bind(this)
	            }).data("kendoColorPalette");
	        }
	    });

	    kendo.spreadsheet.dialogs.register("colorPicker", ColorPickerDialog);

	    var CustomColorDialog = ColorChooser.extend({
	        init: function(options) {
	            options.width = 268;
	            ColorChooser.fn.init.call(this, options);
	            this.dialog().setOptions({ animation: false });
	            this.dialog().one("activate", this._colorPicker.bind(this));
	        },
	        _colorPicker: function() {
	            var element = this.dialog().element.find("div:first");
	            this.colorPicker = element.kendoFlatColorPicker({
	                change: this.value.bind(this)
	            }).data("kendoFlatColorPicker");
	        }
	    });

	    kendo.spreadsheet.dialogs.register("customColor", CustomColorDialog);

	    var AlignmentDialog = SpreadsheetDialog.extend({
	        init: function(options) {
	            var messages = kendo.spreadsheet.messages.dialogs.alignmentDialog || MESSAGES;
	            var defaultOptions = {
	                title: messages.title,
	                buttons: [
	                    { property: "textAlign",     value: "left",    iconClass: "align-left",   text: messages.buttons.justtifyLeft },
	                    { property: "textAlign",     value: "center",  iconClass: "align-center", text: messages.buttons.justifyCenter },
	                    { property: "textAlign",     value: "right",   iconClass: "align-right",  text: messages.buttons.justifyRight },
	                    { property: "textAlign",     value: "justify", iconClass: "align-justify",   text: messages.buttons.justifyFull },
	                    { property: "verticalAlign", value: "top",     iconClass: "align-top",      text: messages.buttons.alignTop },
	                    { property: "verticalAlign", value: "center",  iconClass: "align-middle",   text: messages.buttons.alignMiddle },
	                    { property: "verticalAlign", value: "bottom",  iconClass: "align-bottom",   text: messages.buttons.alignBottom }
	                ]
	            };

	            SpreadsheetDialog.fn.init.call(this, $.extend(defaultOptions, options));

	            this._list();
	        },
	        options: {
	            template: "<ul class='k-list k-reset'></ul>"
	        },
	        _list: function() {
	            var ul = this.dialog().element.find("ul");

	            this.list = new kendo.ui.StaticList(ul, {
	                dataSource: new kendo.data.DataSource({ data: this.options.buttons }),
	                template: "<a role='button' title='#=text#' data-property='#=property#' data-value='#=value#'>" +
	                                "<span class='k-icon k-i-#=iconClass#'></span>" +
	                                "#=text#" +
	                           "</a>",
	                change: this.apply.bind(this)
	            });

	            this.list.dataSource.fetch();
	        },
	        apply: function(e) {
	            var dataItem = e.sender.value()[0];
	            SpreadsheetDialog.fn.apply.call(this);

	            this.trigger("action", {
	                command: "PropertyChangeCommand",
	                options: {
	                    property: dataItem.property,
	                    value: dataItem.value
	                }
	            });
	        }
	    });

	    kendo.spreadsheet.dialogs.register("alignment", AlignmentDialog);

	    var MergeDialog = SpreadsheetDialog.extend({
	        init: function(options) {
	            var messages = kendo.spreadsheet.messages.dialogs.mergeDialog || MESSAGES;
	            var defaultOptions = {
	                title: messages.title,
	                buttons: [
	                    { value: "cells",        iconClass: "cells-merge",        text: messages.buttons.mergeCells },
	                    { value: "horizontally", iconClass: "cells-merge-horizontally", text: messages.buttons.mergeHorizontally },
	                    { value: "vertically",   iconClass: "cells-merge-vertically",   text: messages.buttons.mergeVertically },
	                    { value: "unmerge",      iconClass: "table-unmerge",      text: messages.buttons.unmerge }
	                ]
	            };

	            SpreadsheetDialog.fn.init.call(this, $.extend(defaultOptions, options));

	            this._list();
	        },
	        options: {
	            template: "<ul class='k-list k-reset'></ul>"
	        },
	        _list: function() {
	            var ul = this.dialog().element.find("ul");

	            this.list = new kendo.ui.StaticList(ul, {
	                dataSource: new kendo.data.DataSource({ data: this.options.buttons }),
	                template: "<a role='button' title='#=text#' data-value='#=value#'>" +
	                            "<span class='k-icon k-icon k-i-#=iconClass#'></span>#=text#" +
	                          "</a>",
	                change: this.apply.bind(this)
	            });

	            this.list.dataSource.fetch();
	        },
	        apply: function(e) {
	            var dataItem = e.sender.value()[0];
	            SpreadsheetDialog.fn.apply.call(this);

	            this.trigger("action", {
	                command: "MergeCellCommand",
	                options: {
	                    value: dataItem.value
	                }
	            });
	        }
	    });

	    kendo.spreadsheet.dialogs.register("merge", MergeDialog);

	    var FreezeDialog = SpreadsheetDialog.extend({
	        init: function(options) {
	            var messages = kendo.spreadsheet.messages.dialogs.freezeDialog || MESSAGES;
	            var defaultOptions = {
	                title: messages.title,
	                buttons: [
	                    { value: "panes",    iconClass: "pane-freeze",  text: messages.buttons.freezePanes },
	                    { value: "rows",     iconClass: "row-freeze",    text: messages.buttons.freezeRows },
	                    { value: "columns",  iconClass: "column-freeze",    text: messages.buttons.freezeColumns },
	                    { value: "unfreeze", iconClass: "table-unmerge", text: messages.buttons.unfreeze }
	                ]
	            };

	            SpreadsheetDialog.fn.init.call(this, $.extend(defaultOptions, options));

	            this._list();
	        },
	        options: {
	            template: "<ul class='k-list k-reset'></ul>"
	        },
	        _list: function() {
	            var ul = this.dialog().element.find("ul");

	            this.list = new kendo.ui.StaticList(ul, {
	                dataSource: new kendo.data.DataSource({ data: this.options.buttons }),
	                template: "<a role='button' title='#=text#' data-value='#=value#'>" +
	                            "<span class='k-icon k-icon k-i-#=iconClass#'></span>#=text#" +
	                          "</a>",
	                change: this.apply.bind(this)
	            });

	            this.list.dataSource.fetch();
	        },
	        apply: function(e) {
	            var dataItem = e.sender.value()[0];
	            SpreadsheetDialog.fn.apply.call(this);

	            this.trigger("action", {
	                command: "FreezePanesCommand",
	                options: {
	                    value: dataItem.value
	                }
	            });
	        }
	    });

	    kendo.spreadsheet.dialogs.register("freeze", FreezeDialog);

	    var ValidationViewModel = kendo.spreadsheet.ValidationCellsViewModel = ObservableObject.extend({
	        init: function(options) {
	            ObservableObject.fn.init.call(this, options);

	            this.bind("change", (function(e) {

	                if (e.field === "criterion") {
	                    this.reset();

	                    if (this.criterion === "custom" || this.criterion === "list") {
	                        this.setHintMessageTemplate();
	                    }
	                }

	                if (e.field === "comparer") {
	                    this.setHintMessageTemplate();
	                }

	                if ((e.field == "hintMessage" || e.field == "hintTitle") && !this._mute) {
	                    this.shouldBuild = false;
	                }

	                if ((e.field == "from" || e.field == "to" || e.field == "hintMessageTemplate" || e.field == "type") && this.shouldBuild) {
	                    this.buildMessages();
	                }
	            }).bind(this));

	            this.reset();
	        },
	        buildMessages: function() {
	            this._mute = true;
	            this.set("hintTitle", this.hintTitleTemplate ? kendo.format(this.hintTitleTemplate, this.type) : "");
	            this.set("hintMessage", this.hintMessageTemplate ? kendo.format(this.hintMessageTemplate, this.from, this.to) : "");
	            this._mute = false;
	        },
	        reset: function() {
	            this.setComparers();
	            this.set("comparer", this.comparers[0].type);
	            this.set("from", null);
	            this.set("to", null);

	            this.set("useCustomMessages", false);

	            this.shouldBuild = true;

	            this.hintTitleTemplate = this.defaultHintTitle;
	            this.buildMessages();
	        },
	        //TODO: refactor
	        setComparers: function() {
	            var all = this.defaultComparers;
	            var comparers = [];

	            if (this.criterion === "text") {
	                var text_comparers = ["equalTo", "notEqualTo"];
	                for (var idx = 0; idx < all.length; idx++) {
	                    if (text_comparers[0] == all[idx].type) {
	                        comparers.push(all[idx]);
	                        text_comparers.shift();
	                    }
	                }
	            } else {
	                comparers = all.slice();
	            }

	            this.set("comparers", comparers);
	        },
	        setHintMessageTemplate: function() {
	           if (this.criterion !== "custom" && this.criterion !== "list") {
	               this.set("hintMessageTemplate", kendo.format(this.defaultHintMessage, this.criterion, this.comparerMessages[this.comparer]));
	           } else {
	               this.set("hintMessageTemplate", "");
	               this.set("hintMessage", "");
	           }
	        },
	        isAny: function() {
	            return this.get("criterion") === "any";
	        },
	        isNumber: function() {
	            return this.get("criterion") === "number";
	        },
	        showToForNumber: function() {
	            return this.showTo() && this.isNumber();
	        },
	        showToForDate: function() {
	            return this.showTo() && this.isDate();
	        },
	        isText: function() {
	            return this.get("criterion") === "text";
	        },
	        isDate: function() {
	            return this.get("criterion") === "date";
	        },
	        isList: function() {
	            return this.get("criterion") === "list";
	        },
	        isCustom: function() {
	            return this.get("criterion") === "custom";
	        },
	        showRemove: function() {
	            return this.get("hasValidation");
	        },
	        showTo: function() {
	            return this.get("comparer") == "between" || this.get("comparer") == "notBetween";
	        },
	        update: function(validation) {
	            this.set("hasValidation", !!validation);

	            if (validation) {
	                this.fromValidationObject(validation);
	            }
	        },
	        fromValidationObject: function(validation) {
	            this.set("criterion", validation.dataType);
	            this.set("comparer", validation.comparerType);
	            this.set("from", validation.from);
	            this.set("to", validation.to);
	            this.set("type", validation.type);
	            this.set("ignoreBlank", validation.allowNulls);
	            this.set("showButton", validation.showButton);

	            if (validation.messageTemplate || validation.titleTemplate) {
	                this.hintMessageTemplate = validation.messageTemplate;
	                this.hintMessage = validation.messageTemplate;
	                this.hintTitleTemplate = validation.titleTemplate;
	                this.hintTitle = validation.titleTemplate;
	                this.useCustomMessages = true;
	                this.buildMessages();
	            } else {
	                this.useCustomMessages = false;
	            }
	        },
	        toValidationObject: function() {
	            if (this.criterion === "any") {
	                return null;
	            }

	            var options = {
	                type: this.type,
	                dataType: this.criterion,
	                comparerType: this.comparer,
	                from: this.from,
	                to: this.to,
	                allowNulls: this.ignoreBlank,
	                showButton: this.showButton
	            };

	            if (this.useCustomMessages) {
	                options.messageTemplate = this.shouldBuild ? this.hintMessageTemplate : this.hintMessage;
	                options.titleTemplate = this.hintTitle;
	            }

	            return options;
	        }
	    });

	    var ValidationDialog = SpreadsheetDialog.extend({
	        init: function(options) {
	            var messages = kendo.spreadsheet.messages.dialogs.validationDialog || MESSAGES;
	            var defaultOptions = {
	                title: messages.title,
	                hintMessage: messages.hintMessage,
	                hintTitle: messages.hintTitle,
	                criteria: [
	                    { type: "any", name: messages.criteria.any },
	                    { type: "number", name: messages.criteria.number },
	                    { type: "text", name: messages.criteria.text },
	                    { type: "date", name: messages.criteria.date },
	                    { type: "custom", name: messages.criteria.custom },
	                    { type: "list", name: messages.criteria.list }
	                ],
	                comparers: [
	                    { type: "greaterThan", name: messages.comparers.greaterThan },
	                    { type: "lessThan",    name: messages.comparers.lessThan },
	                    { type: "between",     name: messages.comparers.between },
	                    { type: "notBetween",  name: messages.comparers.notBetween },
	                    { type: "equalTo",     name: messages.comparers.equalTo },
	                    { type: "notEqualTo",  name: messages.comparers.notEqualTo },
	                    { type: "greaterThanOrEqualTo", name: messages.comparers.greaterThanOrEqualTo },
	                    { type: "lessThanOrEqualTo",    name: messages.comparers.lessThanOrEqualTo }
	                ],
	                comparerMessages: messages.comparerMessages
	            };

	            SpreadsheetDialog.fn.init.call(this, $.extend(defaultOptions, options));
	        },
	        options: {
	            width: 450,
	            criterion: "any",
	            type: "reject",
	            ignoreBlank: true,
	            showButton: true,
	            useCustomMessages: false,
	            errorTemplate:
	                '<div class="k-tooltip k-tooltip-error k-validator-tooltip">' +
	                    '<span class="k-tooltip-icon k-icon k-i-warning"></span>' +
	                    '<span class="k-tooltip-content">#= message #</span>' +
	                    '<span class="k-callout k-callout-n"></span>' +
	                '</div>',
	            template:
	                '<div class="k-edit-form-container">' +
	                    '<div class="k-edit-label"><label>#: messages.validationDialog.labels.criteria #:</label></div>' +
	                    '<div class="k-edit-field">' +
	                        '<select data-role="dropdownlist" ' +
	                            'title="#: messages.validationDialog.labels.criteria #"' +
	                            'data-text-field="name" ' +
	                            'data-value-field="type" ' +
	                            'data-bind="value: criterion, source: criteria"></select>' +
	                    '</div>' +

	                    '<div data-bind="visible: isNumber">' +
	                        '<div class="k-edit-label"><label>#: messages.validationDialog.labels.comparer #:</label></div>' +
	                        '<div class="k-edit-field">' +
	                            '<select data-role="dropdownlist" ' +
	                                'title="#: messages.validationDialog.labels.comparer #"' +
	                                'data-text-field="name" ' +
	                                'data-value-field="type" ' +
	                                'data-bind="value: comparer, source: comparers"></select>' +
	                        '</div>' +
	                        '<div class="k-edit-label"><label>#: messages.validationDialog.labels.min #:</label></div>' +
	                        '<div class="k-edit-field">' +
	                            '<input name="#: messages.validationDialog.labels.min #" title="#: messages.validationDialog.labels.min #" placeholder="e.g. 10" class="k-textbox" data-bind="value: from, enabled: isNumber" required="required" />' +
	                        '</div>' +
	                        '<div data-bind="visible: showTo">' +
	                            '<div class="k-edit-label"><label>#: messages.validationDialog.labels.max #:</label></div>' +
	                            '<div class="k-edit-field">' +
	                                '<input name="#: messages.validationDialog.labels.max #" title="#: messages.validationDialog.labels.max #" placeholder="e.g. 100" class="k-textbox" data-bind="value: to, enabled: showToForNumber" required="required" />' +
	                            '</div>' +
	                        '</div>' +
	                    '</div>' +

	                    '<div data-bind="visible: isText">' +
	                        '<div class="k-edit-label"><label>#: messages.validationDialog.labels.comparer #:</label></div>' +
	                        '<div class="k-edit-field">' +
	                            '<select data-role="dropdownlist" ' +
	                                'title="#: messages.validationDialog.labels.comparer #"' +
	                                'data-text-field="name" ' +
	                                'data-value-field="type" ' +
	                                'data-bind="value: comparer, source: comparers"></select>' +
	                        '</div>' +
	                        '<div class="k-edit-label"><label>#: messages.validationDialog.labels.value #:</label></div>' +
	                        '<div class="k-edit-field">' +
	                            '<input name="#: messages.validationDialog.labels.value #" title="#: messages.validationDialog.labels.value #" class="k-textbox" data-bind="value: from, enabled: isText" required="required" />' +
	                        '</div>' +
	                    '</div>' +

	                    '<div data-bind="visible: isDate">' +
	                        '<div class="k-edit-label"><label>#: messages.validationDialog.labels.comparer #:</label></div>' +
	                        '<div class="k-edit-field">' +
	                            '<select data-role="dropdownlist" ' +
	                                'title="#: messages.validationDialog.labels.comparer #"' +
	                                'data-text-field="name" ' +
	                                'data-value-field="type" ' +
	                                'data-bind="value: comparer, source: comparers"></select>' +
	                        '</div>' +
	                        '<div class="k-edit-label"><label>#: messages.validationDialog.labels.start #:</label></div>' +
	                        '<div class="k-edit-field">' +
	                            '<input name="#: messages.validationDialog.labels.start #" title="#: messages.validationDialog.labels.start #" class="k-textbox" data-bind="value: from, enabled: isDate" required="required" />' +
	                        '</div>' +
	                        '<div data-bind="visible: showTo">' +
	                            '<div class="k-edit-label"><label>#: messages.validationDialog.labels.end #:</label></div>' +
	                            '<div class="k-edit-field">' +
	                                '<input name="#: messages.validationDialog.labels.end #" title="#: messages.validationDialog.labels.end #" class="k-textbox" data-bind="value: to, enabled: showToForDate" required="required" />' +
	                            '</div>' +
	                        '</div>' +
	                    '</div>' +

	                    '<div data-bind="visible: isCustom">' +
	                        '<div class="k-edit-label"><label>#: messages.validationDialog.labels.value #:</label></div>' +
	                        '<div class="k-edit-field">' +
	                            '<input name="#: messages.validationDialog.labels.value #" title="#: messages.validationDialog.labels.value #" class="k-textbox" data-bind="value: from, enabled: isCustom" required="required" />' +
	                        '</div>' +
	                    '</div>' +

	                    '<div data-bind="visible: isList">' +
	                        '<div class="k-edit-label"><label>#: messages.validationDialog.labels.value #:</label></div>' +
	                        '<div class="k-edit-field">' +
	                            '<input name="#: messages.validationDialog.labels.value #" title="#: messages.validationDialog.labels.value #" class="k-textbox" data-bind="value: from, enabled: isList" required="required" />' +
	                        '</div>' +
	                    '</div>' +

	                    '<div data-bind="visible: isList">' +
	                        '<div class="k-edit-field">' +
	                            '<input type="checkbox" name="showButton" id="listShowButton" class="k-checkbox" data-bind="checked: showButton"/>' +
	                            '<label for="listShowButton" class="k-checkbox-label">' +
	                                ' #: messages.validationDialog.labels.showListButton #' +
	                            '</label>' +
	                        '</div>' +
	                    "</div>" +

	                    '<div data-bind="visible: isDate">' +
	                        '<div class="k-edit-field">' +
	                            '<input type="checkbox" name="showButton" id="dateShowButton" class="k-checkbox" data-bind="checked: showButton"/>' +
	                            '<label for="dateShowButton" class="k-checkbox-label">' +
	                                ' #: messages.validationDialog.labels.showCalendarButton #' +
	                            '</label>' +
	                        '</div>' +
	                    "</div>" +

	                    '<div data-bind="invisible: isAny">' +
	                        '<div class="k-edit-field">' +
	                            '<input type="checkbox" title="#: messages.validationDialog.labels.ignoreBlank #" name="ignoreBlank" id="ignoreBlank" class="k-checkbox" data-bind="checked: ignoreBlank"/>' +
	                            '<label for="ignoreBlank" class="k-checkbox-label">' +
	                                ' #: messages.validationDialog.labels.ignoreBlank #' +
	                            '</label>' +
	                        '</div>' +
	                    '</div>' +

	                    '<div data-bind="invisible: isAny">' +
	                        '<div class="k-hr"></div>' +
	                        '<div class="k-edit-label"><label>#: messages.validationDialog.labels.onInvalidData #:</label></div>' +
	                        '<div class="k-edit-field">' +
	                            '<input type="radio" title="#: messages.validationDialog.labels.rejectInput #" id="validationTypeReject" name="validationType" value="reject" data-bind="checked: type" class="k-radio" />' +
	                            '<label for="validationTypeReject" class="k-radio-label">' +
	                                 "#: messages.validationDialog.labels.rejectInput #" +
	                            '</label> ' +
	                            '<input type="radio" title="#: messages.validationDialog.labels.showWarning #" id="validationTypeWarning"  name="validationType" value="warning" data-bind="checked: type" class="k-radio" />' +
	                            '<label for="validationTypeWarning" class="k-radio-label">' +
	                                 "#: messages.validationDialog.labels.showWarning #" +
	                            '</label>' +
	                        '</div>' +
	                    '</div>' +

	                    '<div data-bind="invisible: isAny" class="hint-wrapper">' +
	                        '<div class="k-edit-field">' +
	                            '<input type="checkbox" title="#: messages.validationDialog.labels.showHint #" name="useCustomMessages" id="useCustomMessages" class="k-checkbox" data-bind="checked: useCustomMessages" />' +
	                            '<label class="k-checkbox-label" for="useCustomMessages">'+
	                                ' #: messages.validationDialog.labels.showHint #' +
	                            '</label>' +
	                        '</div>' +
	                        '<div data-bind="visible: useCustomMessages">' +
	                            '<div class="k-edit-label"><label>#: messages.validationDialog.labels.hintTitle #:</label></div>' +
	                            '<div class="k-edit-field">' +
	                                '<input class="k-textbox" title="#: messages.validationDialog.labels.hintTitle #" placeholder="#: messages.validationDialog.placeholders.typeTitle #" data-bind="value: hintTitle" />' +
	                            '</div>' +
	                            '<div class="k-edit-label"><label>#: messages.validationDialog.labels.hintMessage #:</label></div>' +
	                            '<div class="k-edit-field">' +
	                                '<input class="k-textbox" title="#: messages.validationDialog.labels.hintMessage #" placeholder="#: messages.validationDialog.placeholders.typeMessage #" data-bind="value: hintMessage" />' +
	                            '</div>' +
	                        '</div>' +
	                    '</div>' +

	                    '<div class="k-action-buttons">' +
	                        '<button class="k-button" data-bind="visible: showRemove, click: remove">#: messages.remove #</button>' +
	                        '<button class="k-button k-primary" data-bind="click: apply">#: messages.apply #</button>' +
	                        '<button class="k-button" data-bind="click: close">#: messages.cancel #</button>' +
	                    "</div>" +
	                "</div>"
	        },
	        open: function(range) {
	            var options = this.options;
	            var element;

	            this.viewModel = new ValidationViewModel({
	                type: options.type,
	                defaultHintMessage: options.hintMessage,
	                defaultHintTitle: options.hintTitle,
	                defaultComparers: options.comparers.slice(0),
	                comparerMessages: options.comparerMessages,
	                criteria: options.criteria.slice(0),
	                criterion: options.criterion,
	                ignoreBlank: options.ignoreBlank,
	                showButton: options.showButton,
	                apply: this.apply.bind(this),
	                close: this.close.bind(this),
	                remove: this.remove.bind(this)
	            });

	            this.viewModel.update(range.validation());

	            SpreadsheetDialog.fn.open.call(this);

	            element = this.dialog().element;

	            if (this.validatable) {
	                this.validatable.destroy();
	            }

	            kendo.bind(element, this.viewModel);

	            this.validatable = new kendo.ui.Validator(element.find(".k-edit-form-container"), {
	                validateOnBlur: false,
	                errorTemplate: this.options.errorTemplate || undefined
	            });
	        },
	        apply: function() {

	            if (this.validatable.validate()) {
	                SpreadsheetDialog.fn.apply.call(this);

	                this.trigger("action", {
	                    command: "EditValidationCommand",
	                    options: {
	                        value: this.viewModel.toValidationObject()
	                    }
	                });
	            }
	        },
	        remove: function() {
	            this.viewModel.set("criterion", "any");
	            this.apply();
	        }
	    });

	    kendo.spreadsheet.dialogs.register("validation", ValidationDialog);
	    kendo.spreadsheet.dialogs.ValidationDialog = ValidationDialog;

	    function PDF_PAPER_SIZE(size) {
	        return {
	            value: size,
	            text: TEXT("exportAsDialog.pdf.paper." + size)
	        };
	    }

	    var ExportAsDialog = SpreadsheetDialog.extend({
	        init: function(options) {
	            SpreadsheetDialog.fn.init.call(this, options);
	            options = this.options;

	            this.viewModel = kendo.observable({
	                title: options.title,
	                name: options.name,
	                extension: options.extension,
	                fileFormats:options.fileFormats,
	                excel: options.excelExport,
	                pdf: {
	                    proxyURL: options.pdfExport.proxyURL,
	                    forceProxy: options.pdfExport.forceProxy,
	                    title: options.pdfExport.title,
	                    author: options.pdfExport.author,
	                    subject: options.pdfExport.subject,
	                    keywords: options.pdfExport.keywords,
	                    creator: options.pdfExport.creator,
	                    date: options.pdfExport.date,

	                    fitWidth: options.pdf.fitWidth,
	                    area: options.pdf.area,
	                    areas: options.pdf.areas,
	                    paperSize: options.pdf.paperSize,
	                    paperSizes: options.pdf.paperSizes,
	                    margin: options.pdf.margin,
	                    margins: options.pdf.margins,
	                    landscape: options.pdf.landscape,
	                    guidelines: options.pdf.guidelines,
	                    hCenter: options.pdf.hCenter,
	                    vCenter: options.pdf.vCenter
	                },
	                apply: this.apply.bind(this),
	                close: this.close.bind(this)
	            });

	            var dialog = this.dialog();
	            this.viewModel.bind("change", function(e) {
	                if (e.field === "extension") {
	                    this.set("showPdfOptions", this.extension === ".pdf" ? true : false);
	                    dialog.center();
	                }
	            });

	            kendo.bind(dialog.element, this.viewModel);
	        },
	        options: {
	            title: TEXT("exportAsDialog.title", "Export..."),
	            name: TEXT("exportAsDialog.defaultFileName", "Workbook"),
	            extension: ".xlsx",
	            fileFormats: [{
	                description: TEXT("exportAsDialog.xlsx.description", "Excel Workbook (.xlsx)"),
	                extension: ".xlsx"
	            }, {
	                description: TEXT("exportAsDialog.pdf.description", "Portable Document Format (.pdf)"),
	                extension: ".pdf"
	            }],
	            pdf: {
	                fitWidth: true,
	                area: "workbook",
	                areas: [{
	                    area: "workbook",
	                    text: TEXT("exportAsDialog.pdf.area.workbook", "Entire Workbook")
	                },{
	                    area: "sheet",
	                    text: TEXT("exportAsDialog.pdf.area.sheet", "Active Sheet")
	                },{
	                    area: "selection",
	                    text: TEXT("exportAsDialog.pdf.area.selection", "Selection")
	                }],
	                paperSize: "a4",
	                paperSizes: [
	                    "a2", "a3", "a4", "a5", "b3", "b4", "b5", "folio", "legal", "letter", "tabloid", "executive"
	                ].map(PDF_PAPER_SIZE),
	                margin: {bottom: "0.75in", left: "0.7in", right: "0.7in", top: "0.75in"},
	                margins: [
	                    { value: { bottom: "0.75in", left: "0.7in", right: "0.7in", top: "0.75in" },
	                      text: TEXT("exportAsDialog.pdf.margin.normal", "Normal")
	                    },
	                    { value: { bottom: "0.75in", left: "0.25in", right: "0.25in", top: "0.75in" },
	                      text: TEXT("exportAsDialog.pdf.margin.narrow", "Narrow")
	                    },
	                    { value: { bottom: "1in", left: "1in", right: "1in", top: "1in" },
	                      text: TEXT("exportAsDialog.pdf.margin.wide", "Wide")
	                    }
	                ],
	                landscape: true,
	                guidelines: true,
	                hCenter: true,
	                vCenter: true
	            },
	            width: 520,
	            template:
	                "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.fileName #:</label></div>" +
	                "<div class='k-edit-field'>" +
	                    "<input class='k-textbox' data-bind='value: name' />" +
	                "</div>" +
	                "<div >" +
	                    "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.saveAsType #:</label></div>" +
	                    "<div class='k-edit-field'>" +
	                    "<select data-role='dropdownlist' class='k-file-format' " +
	                        "data-text-field='description' " +
	                        "data-value-field='extension' " +
	                        "data-bind='value: extension, source: fileFormats'></select>" +
	                    "</div>" +
	                "</div>" +
	                "<div class='k-export-config' data-bind='visible: showPdfOptions'>" +
	                    "<hr class='k-hr' />" +
	                    "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.exportArea #:</label></div>" +
	                    "<div class='k-edit-field'>" +
	                        "<select data-role='dropdownlist' class='k-file-format' " +
	                            "data-text-field='text' " +
	                            "data-value-field='area' " +
	                            "data-bind='value: pdf.area, source: pdf.areas'></select>" +
	                    "</div>" +
	                    "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.paperSize#:</label></div>" +
	                    "<div class='k-edit-field'>" +
	                        "<select data-role='dropdownlist' class='k-file-format' " +
	                            "data-text-field='text' " +
	                            "data-value-field='value' " +
	                            "data-bind='value: pdf.paperSize, source: pdf.paperSizes'></select>" +
	                    "</div>" +
	                    "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.margins #:</label></div>" +
	                    "<div class='k-edit-field'>" +
	                        "<select data-role='dropdownlist' class='k-file-format' " +
	                            "data-value-primitive='true'" +
	                            "data-text-field='text' " +
	                            "data-value-field='value' " +
	                            "data-bind='value: pdf.margin, source: pdf.margins'></select>" +
	                    "</div>" +
	                    "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.orientation #:</label></div>" +
	                    "<div class='k-edit-field'>" +
	                        "<div class='k-button-group'>" +
	                            "<input type='radio' id='k-orientation-portrait' name='orientation' data-type='boolean' data-bind='checked: pdf.landscape' value='false' />" +
	                            "<label class='k-button k-button-icon k-group-start k-orientation-button' for='k-orientation-portrait'><span class='k-icon k-i-page-portrait'></span></label>" +
	                            "<input type='radio' id='k-orientation-landscape' name='orientation' data-type='boolean' data-bind='checked: pdf.landscape' value='true' />" +
	                            "<label class='k-button k-button-icon k-group-end k-orientation-button' for='k-orientation-landscape'><span class='k-icon k-i-page-landscape'></span></label>" +
	                        "</div>" +
	                    "</div>" +
	                    "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.print #:</label></div>" +
	                    "<div class='k-edit-field'>" +
	                        "<input class='k-checkbox' id='guidelines' type='checkbox' data-bind='checked: pdf.guidelines'/><label class='k-checkbox-label' for='guidelines'>#: messages.exportAsDialog.labels.guidelines#</label>" +
	                    "</div>" +
	                    "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.scale #:</label></div>" +
	                    "<div class='k-edit-field'>" +
	                        "<input class='k-checkbox' id='fitWidth' type='checkbox' data-bind='checked: pdf.fitWidth'/><label class='k-checkbox-label' for='fitWidth'>#: messages.exportAsDialog.labels.fit #</label>" +
	                    "</div>" +
	                    "<div class='k-edit-label'><label>#: messages.exportAsDialog.labels.center #:</label></div>" +
	                    "<div class='k-edit-field'>" +
	                        "<input class='k-checkbox' id='hCenter' type='checkbox' data-bind='checked: pdf.hCenter'/><label class='k-checkbox-label' for='hCenter'>#: messages.exportAsDialog.labels.horizontally #</label>" +
	                        "<input class='k-checkbox' id='vCenter' type='checkbox' data-bind='checked: pdf.vCenter'/><label class='k-checkbox-label' for='vCenter'>#: messages.exportAsDialog.labels.vertically #</label>" +
	                    "</div>" +
	                    "<div class='k-page-orientation'>" +
	                        "<span class='k-icon k-i-page-portrait' data-bind='invisible: pdf.landscape'></span>" +
	                        "<span class='k-icon k-i-page-landscape' data-bind='visible: pdf.landscape'></span>" +
	                    "</div>" +
	                "</div>" +
	                "<div class='k-action-buttons'>" +
	                    "<button class='k-button k-primary' data-bind='click: apply'>#: messages.save #</button>" +
	                    "<button class='k-button' data-bind='click: close'>#: messages.cancel #</button>" +
	                "</div>"
	        },
	        apply: function() {
	            SpreadsheetDialog.fn.apply.call(this);

	            this.trigger("action", {
	                command: "SaveAsCommand",
	                options: this.viewModel
	            });
	        }
	    });
	    kendo.spreadsheet.dialogs.register("exportAs", ExportAsDialog);

	    function basicErrorDialog(id, msg) {
	        kendo.spreadsheet.dialogs.register(
	            id,
	            MessageDialog.extend({
	                options: { messageId: msg }
	            })
	        );
	    }

	    basicErrorDialog("modifyMerged", "modifyMergedDialog.errorMessage");
	    basicErrorDialog("rangeDisabled", "rangeDisabledDialog.errorMessage");
	    basicErrorDialog("intersectsArray", "intersectsArrayDialog.errorMessage");
	    basicErrorDialog("overflow", "overflowDialog.errorMessage");
	    basicErrorDialog("unsupportedSelection", "unsupportedSelectionDialog.errorMessage");
	    basicErrorDialog("incompatibleRanges", "incompatibleRangesDialog.errorMessage");
	    basicErrorDialog("noFillDirection", "noFillDirectionDialog.errorMessage");
	    basicErrorDialog("duplicateSheetName", "duplicateSheetNameDialog.errorMessage");

	    var ImportErrorDialog = MessageDialog.extend({
	        options: {
	            width: 640,
	            title: "Errors in import",
	            template:
	                "<div class='k-spreadsheet-message-content k-spreadsheet-import-errors'>" +
	                  "<div class='k--header-message'>We encountered #= errors.length # errors while reading this file.  Please be aware that some formulas might be missing, or contain invalid results.</div>" +
	                  "<div class='k--errors'>" +
	                    "<table>" +
	                      "<thead>" +
	                        "<tr><th>Context</th><th>Error message</th></tr>" +
	                      "</thead>" +
	                      "# for (var i = 0; i < errors.length; ++i) { #" +
	                        "# var err = errors[i]; #" +
	                        "<tr><td>#: err.context #</td><td>#: err.error #</td></tr>" +
	                      "# } #" +
	                    "</table>" +
	                  "</div>" +
	                "</div>" +
	                "<div class='k-action-buttons'>" +
	                  "<button class='k-button k-primary' data-bind='click: close'>" +
	                    "#: messages.okText #" +
	                  "</button>" +
	                "</div>"
	        }
	    });

	    kendo.spreadsheet.dialogs.register("importError", ImportErrorDialog);

	    var UseKeyboardDialog = MessageDialog.extend({
	        options: {
	            title: TEXT("useKeyboardDialog.title", "Copying and pasting"),
	            template:
	                "#: messages.useKeyboardDialog.errorMessage #" +
	                "<div>Ctrl+C #: messages.useKeyboardDialog.labels.forCopy #</div>" +
	                "<div>Ctrl+X #: messages.useKeyboardDialog.labels.forCut #</div>" +
	                "<div>Ctrl+V #: messages.useKeyboardDialog.labels.forPaste #</div>" +
	                '<div class="k-action-buttons">' +
	                    "<button class='k-button k-primary' data-bind='click: close'>" +
	                        "#= messages.okText #" +
	                    "</button>" +
	                "</div>"
	        }
	    });

	    kendo.spreadsheet.dialogs.register("useKeyboard", UseKeyboardDialog);

	    var HyperlinkDialog = SpreadsheetDialog.extend({
	        options: {
	            title: TEXT("linkDialog.title", "Hyperlink"),
	            template:
	            ("<div class='k-edit-label'><label>#: messages.linkDialog.labels.url #:</label></div>" +
	             "<div class='k-edit-field'><input class='k-textbox' data-bind='value: url' title='#: messages.linkDialog.labels.url #' /></div>" +
	             "<div class='k-action-buttons'>" + (
	                 ("<button class='k-button k-left' data-bind='click: remove'>#= messages.linkDialog.labels.removeLink #</button>" +
	                  "<button class='k-button k-primary' data-bind='click: apply'>#= messages.okText #</button>" +
	                  "<button class='k-button' data-bind='click: cancel'>#= messages.cancel #</button>")
	             ) + "</div>"
	            ),
	            autoFocus: false
	        },
	        open: function(range) {
	            var self = this;
	            SpreadsheetDialog.fn.open.apply(self, arguments);
	            var element = self.dialog().element;
	            var model = kendo.observable({
	                url: range.link(),
	                apply: function() {
	                    if (!/\S/.test(model.url)) {
	                        model.url = null;
	                    }
	                    self.trigger("action", {
	                        command: "HyperlinkCommand",
	                        options: {
	                            link: model.url
	                        }
	                    });
	                    self.close();
	                },
	                remove: function() {
	                    model.url = null;
	                    model.apply();
	                },
	                cancel: self.close.bind(self)
	            });
	            kendo.bind(element, model);

	            // it would be nice if we could easily handle that in one
	            // place for all dialogs, but it doesn't seem easily
	            // doable.
	            element.find("input")
	                .focus()
	                .on("keydown", function(ev){
	                    if (ev.keyCode == 13 /*ENTER*/) {
	                        model.url = $(this).val(); // there won't be a "change" event and the model wouldn't update :-\
	                        ev.stopPropagation();
	                        ev.preventDefault();
	                        model.apply();
	                    } else if (ev.keyCode == 27 /*ESC*/) {
	                        ev.stopPropagation();
	                        ev.preventDefault();
	                        model.cancel();
	                    }
	                });
	        }
	    });

	    kendo.spreadsheet.dialogs.register("hyperlink", HyperlinkDialog);

	    var InsertCommentDialog = SpreadsheetDialog.extend({
	        options: {
	            className: "k-spreadsheet-insert-comment",
	            template: "\
	<div class='k-edit-label'><label>#: messages.insertCommentDialog.labels.comment #:</label></div>\
	<div class='k-edit-field'><textarea rows='5' class='k-textbox' data-bind='value: comment'></textarea></div>\
	<div class='k-action-buttons'>\
	  <button class='k-button k-left' data-bind='click: remove'>#: messages.insertCommentDialog.labels.removeComment #</button>\
	  <button class='k-button k-primary' data-bind='click: apply'>#: messages.okText #</button>\
	  <button class='k-button' data-bind='click: cancel'>#= messages.cancel #</button>\
	</div>\
	",
	            title: TEXT("insertCommentDialog.title", "Insert comment"),
	            autoFocus: false,
	            width: 450
	        },
	        open: function(range) {
	            var self = this;
	            SpreadsheetDialog.fn.open.apply(self, arguments);
	            var element = self.dialog().element;
	            var model = kendo.observable({
	                comment: range.comment(),
	                apply: function() {
	                    if (!/\S/.test(model.comment)) {
	                        model.comment = null;
	                    }
	                    self.trigger("action", {
	                        command: "InsertCommentCommand",
	                        options: {
	                            value: model.comment
	                        }
	                    });
	                    self.close();
	                },
	                remove: function() {
	                    model.comment = null;
	                    model.apply();
	                },
	                cancel: self.close.bind(self)
	            });
	            kendo.bind(element, model);

	            element.find("textarea").focus();
	        }
	    });

	    kendo.spreadsheet.dialogs.register("insertComment", InsertCommentDialog);

	    var InsertImageDialog = SpreadsheetDialog.extend({
	        options: {
	            template: "\
	<div class='k-spreadsheet-insert-image-dialog'>\
	  <label data-bind='style: { background-image: imageUrl },\
	                    css: { k-spreadsheet-has-image: hasImage, k-state-hovered: isHovered },\
	                    events: { dragenter: dragEnter, dragover: stopEvent, dragleave: dragLeave, drop: drop }'>\
	    <div data-bind='text: info'></div>\
	    <input type='file' data-bind='events: { change: change }'\
	           accept='image/png, image/jpeg, image/gif' />\
	  </label>\
	</div>\
	<div class='k-action-buttons'>\
	  <button class='k-button k-primary' data-bind='enabled: okEnabled, click: apply'>#: messages.okText #</button>\
	  <button class='k-button' data-bind='click: cancel'>#= messages.cancel #</button>\
	</div>",
	            title: TEXT("insertImageDialog.title", "Insert image"),
	            width: "auto"
	        },
	        open: function() {
	            var self = this;
	            SpreadsheetDialog.fn.open.apply(self, arguments);
	            var element = self.dialog().element;
	            var model = kendo.observable({
	                okEnabled: false,
	                info: kendo.spreadsheet.messages.dialogs.insertImageDialog.info,
	                imageUrl: "",
	                hasImage: false,
	                isHovered: false,
	                _url: null,
	                _image: null,
	                apply: function() {
	                    window.URL.revokeObjectURL(model._url);
	                    self.trigger("action", {
	                        command: "InsertImageCommand",
	                        options: {
	                            blob   : model._image,
	                            width  : model._width,
	                            height : model._height
	                        }
	                    });
	                    self.close();
	                },
	                cancel: self.close.bind(self),
	                stopEvent: function(ev) {
	                    ev.stopPropagation();
	                    ev.preventDefault();
	                },
	                drop: function(ev) {
	                    model.stopEvent(ev);
	                    model.selectFile(ev.originalEvent.dataTransfer.files);
	                    model.set("isHovered", false);
	                },
	                dragEnter: function(ev) {
	                    model.stopEvent(ev);
	                    model.set("isHovered", true);
	                },
	                dragLeave: function(ev) {
	                    model.stopEvent(ev);
	                    model.set("isHovered", false);
	                },
	                change: function(ev) {
	                    model.selectFile(ev.target.files);
	                },
	                selectFile: function(files) {
	                    var image;
	                    for (var i = 0; i < files.length; ++i) {
	                        if (/^image\//i.test(files[i].type)) {
	                            image = files[i];
	                            break;
	                        }
	                    }
	                    if (model._url) {
	                        window.URL.revokeObjectURL(model._url);
	                    }
	                    if (image) {
	                        model._image = image;
	                        model._url = window.URL.createObjectURL(image);
	                        var img = new Image();
	                        img.src = model._url;
	                        img.onload = function() {
	                            model._width = img.width;
	                            model._height = img.height;
	                            model.set("info", kendo.spreadsheet.messages.dialogs.insertImageDialog.info);
	                            model.set("okEnabled", true);
	                            model.set("imageUrl", "url('" + model._url + "')");
	                            model.set("hasImage", true);
	                        };
	                    } else {
	                        model._image = null;
	                        model.set("info", kendo.spreadsheet.messages.dialogs.insertImageDialog.typeError);
	                        model.set("okEnabled", false);
	                        model.set("imageUrl", "");
	                        model.set("hasImage", false);
	                    }
	                }
	            });
	            kendo.bind(element, model);
	        }
	    });

	    kendo.spreadsheet.dialogs.register("insertImage", InsertImageDialog);

	    function Localizable(path, def) {
	        this.path = path.split(".");
	        this.def = def;
	    }

	    Localizable.prototype.trans = function() {
	        var msg = kendo.spreadsheet.messages.dialogs;
	        for (var i = 0; i < this.path.length; ++i) {
	            msg = msg[this.path[i]];
	            if (!msg) {
	                return this.def;
	            }
	        }
	        return msg;
	    };

	    function TEXT(path, def) {
	        return new Localizable(path, def);
	    }

	    function translate(thing) {
	        if (thing instanceof Localizable) {
	            return thing.trans();
	        }
	        else if (Array.isArray(thing)) {
	            return thing.map(translate);
	        }
	        else if (thing != null && typeof thing == "object") {
	            return Object.keys(thing).reduce(function(ret, key){
	                ret[key] = translate(thing[key]);
	                return ret;
	            }, {});
	        }
	        return thing;
	    }

	})(window.kendo);
	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "bmqz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var dragAndDropService_1 = __webpack_require__("I/uN");
var context_1 = __webpack_require__("RQ1/");
var focusedCellController_1 = __webpack_require__("4Sr9");
var gridPanel_1 = __webpack_require__("inOk");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var eventService_1 = __webpack_require__("k5uU");
var eventKeys_1 = __webpack_require__("+Y9o");
var RowDragFeature = (function () {
    function RowDragFeature(eContainer) {
        this.eContainer = eContainer;
    }
    RowDragFeature.prototype.postConstruct = function () {
        if (this.gridOptionsWrapper.isRowModelDefault()) {
            this.inMemoryRowModel = this.rowModel;
        }
    };
    RowDragFeature.prototype.getContainer = function () {
        return this.eContainer;
    };
    RowDragFeature.prototype.isInterestedIn = function (type) {
        return type === dragAndDropService_1.DragSourceType.RowDrag;
    };
    RowDragFeature.prototype.getIconName = function () {
        return dragAndDropService_1.DragAndDropService.ICON_MOVE;
    };
    RowDragFeature.prototype.onDragEnter = function (draggingEvent) {
        // when entering, we fire the enter event, then in onEnterOrDragging,
        // we also fire the move event. so we get both events when entering.
        this.dispatchEvent(eventKeys_1.Events.EVENT_ROW_DRAG_ENTER, draggingEvent);
        this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_MOVE);
        draggingEvent.dragItem.rowNode.setDragging(true);
        this.onEnterOrDragging(draggingEvent);
    };
    RowDragFeature.prototype.onDragging = function (draggingEvent) {
        this.onEnterOrDragging(draggingEvent);
    };
    RowDragFeature.prototype.onEnterOrDragging = function (draggingEvent) {
        // this event is fired for enter and move
        this.dispatchEvent(eventKeys_1.Events.EVENT_ROW_DRAG_MOVE, draggingEvent);
        this.lastDraggingEvent = draggingEvent;
        var pixel = this.normaliseForScroll(draggingEvent.y);
        var managedDrag = this.gridOptionsWrapper.isRowDragManaged();
        if (managedDrag) {
            this.doManagedDrag(draggingEvent, pixel);
        }
        this.checkCenterForScrolling(pixel);
    };
    RowDragFeature.prototype.doManagedDrag = function (draggingEvent, pixel) {
        var rowNode = draggingEvent.dragItem.rowNode;
        var rowWasMoved = this.inMemoryRowModel.ensureRowAtPixel(rowNode, pixel);
        if (rowWasMoved) {
            this.focusedCellController.clearFocusedCell();
            if (this.rangeController) {
                this.rangeController.clearSelection();
            }
        }
    };
    RowDragFeature.prototype.normaliseForScroll = function (pixel) {
        var gridPanelHasScrolls = this.gridOptionsWrapper.isNormalDomLayout();
        if (gridPanelHasScrolls) {
            var pixelRange = this.gridPanel.getVerticalPixelRange();
            return pixel + pixelRange.top;
        }
        else {
            return pixel;
        }
    };
    RowDragFeature.prototype.checkCenterForScrolling = function (pixel) {
        // scroll if the mouse is within 50px of the grid edge
        var pixelRange = this.gridPanel.getVerticalPixelRange();
        // console.log(`pixelRange = (${pixelRange.top}, ${pixelRange.bottom})`);
        this.needToMoveUp = pixel < (pixelRange.top + 50);
        this.needToMoveDown = pixel > (pixelRange.bottom - 50);
        // console.log(`needToMoveUp = ${this.needToMoveUp} = pixel < (pixelRange.top + 50) = ${pixel} < (${pixelRange.top} + 50)`);
        // console.log(`needToMoveDown = ${this.needToMoveDown} = pixel < (pixelRange.top + 50) = ${pixel} < (${pixelRange.top} + 50)`);
        if (this.needToMoveUp || this.needToMoveDown) {
            this.ensureIntervalStarted();
        }
        else {
            this.ensureIntervalCleared();
        }
    };
    RowDragFeature.prototype.ensureIntervalStarted = function () {
        if (!this.movingIntervalId) {
            this.intervalCount = 0;
            this.movingIntervalId = setInterval(this.moveInterval.bind(this), 100);
        }
    };
    RowDragFeature.prototype.ensureIntervalCleared = function () {
        if (this.moveInterval) {
            clearInterval(this.movingIntervalId);
            this.movingIntervalId = null;
        }
    };
    RowDragFeature.prototype.moveInterval = function () {
        // the amounts we move get bigger at each interval, so the speed accelerates, starting a bit slow
        // and getting faster. this is to give smoother user experience. we max at 100px to limit the speed.
        var pixelsToMove;
        this.intervalCount++;
        pixelsToMove = 10 + (this.intervalCount * 5);
        if (pixelsToMove > 100) {
            pixelsToMove = 100;
        }
        var pixelsMoved;
        if (this.needToMoveDown) {
            pixelsMoved = this.gridPanel.scrollVertically(pixelsToMove);
        }
        else if (this.needToMoveUp) {
            pixelsMoved = this.gridPanel.scrollVertically(-pixelsToMove);
        }
        if (pixelsMoved !== 0) {
            this.onDragging(this.lastDraggingEvent);
        }
    };
    // i tried using generics here with this:
    //     public createEvent<T extends RowDragEvent>(type: string, clazz: {new(): T; }, draggingEvent: DraggingEvent) {
    // but it didn't work - i think it's because it only works with classes, and not interfaces, (the events are interfaces)
    RowDragFeature.prototype.dispatchEvent = function (type, draggingEvent) {
        var yNormalised = this.normaliseForScroll(draggingEvent.y);
        var overIndex = -1;
        var overNode = null;
        var mouseIsPastLastRow = yNormalised > this.rowModel.getCurrentPageHeight();
        if (!mouseIsPastLastRow) {
            overIndex = this.rowModel.getRowIndexAtPixel(yNormalised);
            overNode = this.rowModel.getRow(overIndex);
        }
        var vDirectionString;
        switch (draggingEvent.vDirection) {
            case dragAndDropService_1.VDirection.Down:
                vDirectionString = 'down';
                break;
            case dragAndDropService_1.VDirection.Up:
                vDirectionString = 'up';
                break;
            default:
                vDirectionString = null;
                break;
        }
        var event = {
            type: type,
            api: this.gridOptionsWrapper.getApi(),
            columnApi: this.gridOptionsWrapper.getColumnApi(),
            event: draggingEvent.event,
            node: draggingEvent.dragItem.rowNode,
            overIndex: overIndex,
            overNode: overNode,
            y: yNormalised,
            vDirection: vDirectionString
        };
        this.eventService.dispatchEvent(event);
    };
    RowDragFeature.prototype.onDragLeave = function (draggingEvent) {
        this.dispatchEvent(eventKeys_1.Events.EVENT_ROW_DRAG_LEAVE, draggingEvent);
        this.stopDragging(draggingEvent);
    };
    RowDragFeature.prototype.onDragStop = function (draggingEvent) {
        this.dispatchEvent(eventKeys_1.Events.EVENT_ROW_DRAG_END, draggingEvent);
        this.stopDragging(draggingEvent);
    };
    RowDragFeature.prototype.stopDragging = function (draggingEvent) {
        this.ensureIntervalCleared();
        draggingEvent.dragItem.rowNode.setDragging(false);
    };
    __decorate([
        context_1.Autowired('dragAndDropService'),
        __metadata("design:type", dragAndDropService_1.DragAndDropService)
    ], RowDragFeature.prototype, "dragAndDropService", void 0);
    __decorate([
        context_1.Autowired('rowModel'),
        __metadata("design:type", Object)
    ], RowDragFeature.prototype, "rowModel", void 0);
    __decorate([
        context_1.Autowired('focusedCellController'),
        __metadata("design:type", focusedCellController_1.FocusedCellController)
    ], RowDragFeature.prototype, "focusedCellController", void 0);
    __decorate([
        context_1.Autowired('gridPanel'),
        __metadata("design:type", gridPanel_1.GridPanel)
    ], RowDragFeature.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], RowDragFeature.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Optional('rangeController'),
        __metadata("design:type", Object)
    ], RowDragFeature.prototype, "rangeController", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], RowDragFeature.prototype, "eventService", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RowDragFeature.prototype, "postConstruct", null);
    return RowDragFeature;
}());
exports.RowDragFeature = RowDragFeature;


/***/ }),

/***/ "c+Wt":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1426);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1289:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("5AFk");

/***/ }),

/***/ 1426:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1049), __webpack_require__(1289)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function () {

	var __meta__ = {// jshint ignore:line
	    id: "textarea",
	    name: "TextArea",
	    category: "web",
	    description: "The TextArea widget represents a multi-line plain-text editing control which enables you to style and provide a floating label functionality to textarea elements",
	    depends: ["core", "floatinglabel"]
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        ui = kendo.ui,
	        isPlainObject = $.isPlainObject,
	        NS = ".kendoTextArea",
	        CHANGE = "change",
	        DISABLED = "disabled",
	        READONLY = "readonly",
	        INPUT = "k-input",
	        FOCUSED = "k-state-focused",
	        LABELCLASSES = "k-label k-input-label",
	        STATEDISABLED = "k-state-disabled",
	        NOCLICKCLASS = "k-no-click",
	        ARIA_DISABLED = "aria-disabled",
	        TEXTAREACONTAINER = "k-textarea-container",
	        proxy = $.proxy;

	    var TextArea = Widget.extend({
	        init: function (element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);
	            options = $.extend(true, {}, options);

	            that.options.value = options.value || that.element.val();
	            that.options.readonly = options.readonly !== undefined ? options.readonly : Boolean(that.element.attr("readonly"));
	            that.options.enable = options.enable !== undefined ? options.enable : !(Boolean(that.element.attr("disabled")));
	            that.options.placeholder = options.placeholder || that.element.attr("placeholder");

	            if(!that.options.value.replace(/\s/g, '').length){
	                that.options.value = '';
	                that.element.val('');
	            }

	            that.value(that.options.value);
	            that._wrapper();
	            that._label();
	            that._editable({
	                readonly: that.options.readonly,
	                disable: !(that.options.enable)
	            });
	            that._applyAttributes();

	            that.element
	                .addClass(INPUT)
	                .css("resize", that.options.resizable)
	                .attr("autocomplete", "off");

	            kendo.notify(that);
	        },

	        events: [
	            CHANGE
	        ],

	        attributes: [
	            "maxLength",
	            "rows",
	            "placeholder"
	        ],

	        options: {
	            name: 'TextArea',
	            value: '',
	            readonly: false,
	            enable: true,
	            placeholder: '',
	            label: null,
	            resizable: "none",
	            maxLength: null,
	            cols: 20,
	            rows: 1
	        },

	        _applyAttributes: function(){
	            var that = this;
	            var property;
	            var attributes = {};

	            for (property in that.attributes) {
	                attributes[that.attributes[property]] = that.options[that.attributes[property]];
	            }

	            that.element.attr(attributes);
	        },

	        value: function(value) {
	            var that = this;

	            if (value === undefined) {
	                return that._value;
	            }

	            that._value = value;
	            that.element.val(value);
	        },

	        readonly: function(readonly) {
	            var that = this;

	            this._editable({
	                readonly: readonly === undefined ? true : readonly,
	                disable: false
	            });

	            if (that.floatingLabel) {
	                that.floatingLabel.readonly(readonly === undefined ? true : readonly);
	            }
	        },

	        enable: function(enable) {
	            var that = this;

	            this._editable({
	                readonly: false,
	                disable: !(enable = enable === undefined ? true : enable)
	            });

	            if (that.floatingLabel) {
	                that.floatingLabel.enable(enable = enable === undefined ? true : enable);
	            }
	        },

	        focus: function() {
	            var that = this;

	            that.element[0].focus();
	        },

	        destroy: function() {
	            var that = this;

	            if (that.floatingLabel) {
	                that.floatingLabel.destroy();
	            }

	            that.element.off(NS);
	            Widget.fn.destroy.call(that);
	        },

	        _editable: function(options) {
	            var that = this;
	            var element = that.element;
	            var wrapper = that.wrapper;
	            var disable = options.disable;
	            var readonly = options.readonly;

	            element.off(NS);

	            if (!readonly && !disable) {
	                element.removeAttr(DISABLED)
	                       .removeAttr(READONLY)
	                       .attr(ARIA_DISABLED, false);

	                wrapper.removeClass(STATEDISABLED)
	                        .removeClass(NOCLICKCLASS);

	                element.on("focusin" + NS, proxy(that._focusin, that));
	                element.on("focusout" + NS, proxy(that._focusout, that));
	            } else {
	                element.attr(DISABLED, disable)
	                       .attr(READONLY, readonly)
	                       .attr(ARIA_DISABLED, disable);

	                wrapper.toggleClass(STATEDISABLED, disable)
	                        .toggleClass(NOCLICKCLASS, readonly);
	            }
	        },

	        _label: function() {
	            var that = this;
	            var element = that.element;
	            var options = that.options;
	            var id = element.attr("id");
	            var floating;
	            var labelText;

	            if (options.label !== null) {
	                floating = isPlainObject(options.label) ? options.label.floating : false;
	                labelText = isPlainObject(options.label) ? options.label.content : options.label;

	                if (floating) {
	                    that._floatingLabelContainer = that.wrapper.wrap("<span></span>").parent();
	                    that.floatingLabel = new kendo.ui.FloatingLabel(that._floatingLabelContainer, { widget: that });
	                    that._floatingLabelContainer.addClass(TEXTAREACONTAINER);
	                }

	                if (kendo.isFunction(labelText)) {
	                    labelText = labelText.call(that);
	                }

	                if (!labelText) {
	                    labelText = "";
	                }

	                if (!id) {
	                    id = options.name + "_" + kendo.guid();
	                    element.attr("id", id);
	                }

	                that._inputLabel = $("<label class='" + LABELCLASSES + "' for='" + id + "'>" + labelText + "</label>'").insertBefore(that.wrapper);
	            }
	        },

	        _focusin: function() {
	            var that = this;

	            that.wrapper.addClass(FOCUSED);
	        },

	        _focusout: function() {
	            var that = this;
	            var value = that._value;
	            var newValue = that.element.val();

	            that.wrapper.removeClass(FOCUSED);

	            if (value !== newValue) {
	                that._value = newValue;

	                that.trigger(CHANGE);
	            }
	        },

	        _wrapper: function () {
	            var that = this;
	            var element = that.element;
	            var DOMElement = element[0];
	            var wrapper;

	            wrapper = element.wrap("<span class='k-widget k-textarea'></span>").parent();
	            wrapper[0].style.cssText = DOMElement.style.cssText;
	            DOMElement.style.width = "100%";
	            that.wrapper = wrapper.addClass(DOMElement.className).removeClass('input-validation-error');
	        }
	    });
	    ui.plugin(TextArea);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "c/Tr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("5zde"), __esModule: true };

/***/ }),

/***/ "c4fk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ag_grid_1 = __webpack_require__("F6Mk");
var EnterpriseBlock = (function (_super) {
    __extends(EnterpriseBlock, _super);
    function EnterpriseBlock(pageNumber, parentRowNode, params, parentCache) {
        var _this = _super.call(this, pageNumber, params) || this;
        _this.params = params;
        _this.parentRowNode = parentRowNode;
        _this.parentCache = parentCache;
        _this.level = parentRowNode.level + 1;
        _this.groupLevel = _this.level < params.rowGroupCols.length;
        _this.leafGroup = _this.level === (params.rowGroupCols.length - 1);
        return _this;
    }
    EnterpriseBlock.prototype.createNodeIdPrefix = function () {
        var parts = [];
        var rowNode = this.parentRowNode;
        // pull keys from all parent nodes, but do not include the root node
        while (rowNode.level >= 0) {
            parts.push(rowNode.key);
            rowNode = rowNode.parent;
        }
        if (parts.length > 0) {
            this.nodeIdPrefix = parts.reverse().join('-') + '-';
        }
    };
    EnterpriseBlock.prototype.createIdForIndex = function (index) {
        if (ag_grid_1._.exists(this.nodeIdPrefix)) {
            return this.nodeIdPrefix + index.toString();
        }
        else {
            return index.toString();
        }
    };
    EnterpriseBlock.prototype.getNodeIdPrefix = function () {
        return this.nodeIdPrefix;
    };
    EnterpriseBlock.prototype.getRow = function (displayRowIndex) {
        // do binary search of tree
        // http://oli.me.uk/2013/06/08/searching-javascript-arrays-with-a-binary-search/
        var bottomPointer = this.getStartRow();
        // the end row depends on whether all this block is used or not. if the virtual row count
        // is before the end, then not all the row is used
        var virtualRowCount = this.parentCache.getVirtualRowCount();
        var endRow = this.getEndRow();
        var actualEnd = (virtualRowCount < endRow) ? virtualRowCount : endRow;
        var topPointer = actualEnd - 1;
        if (ag_grid_1._.missing(topPointer) || ag_grid_1._.missing(bottomPointer)) {
            console.warn("ag-grid: error: topPointer = " + topPointer + ", bottomPointer = " + bottomPointer);
            return null;
        }
        while (true) {
            var midPointer = Math.floor((bottomPointer + topPointer) / 2);
            var currentRowNode = _super.prototype.getRowUsingLocalIndex.call(this, midPointer);
            if (currentRowNode.rowIndex === displayRowIndex) {
                return currentRowNode;
            }
            var childrenCache = currentRowNode.childrenCache;
            if (currentRowNode.rowIndex === displayRowIndex) {
                return currentRowNode;
            }
            else if (currentRowNode.expanded && childrenCache && childrenCache.isDisplayIndexInCache(displayRowIndex)) {
                return childrenCache.getRow(displayRowIndex);
            }
            else if (currentRowNode.rowIndex < displayRowIndex) {
                bottomPointer = midPointer + 1;
            }
            else if (currentRowNode.rowIndex > displayRowIndex) {
                topPointer = midPointer - 1;
            }
        }
    };
    EnterpriseBlock.prototype.setBeans = function (loggerFactory) {
        this.logger = loggerFactory.create('EnterpriseBlock');
    };
    EnterpriseBlock.prototype.init = function () {
        if (this.groupLevel) {
            var groupColVo = this.params.rowGroupCols[this.level];
            this.groupField = groupColVo.field;
            this.rowGroupColumn = this.columnController.getRowGroupColumns()[this.level];
        }
        this.createNodeIdPrefix();
        _super.prototype.init.call(this, {
            context: this.context,
            rowRenderer: this.rowRenderer
        });
    };
    EnterpriseBlock.prototype.setDataAndId = function (rowNode, data, index) {
        rowNode.stub = false;
        if (ag_grid_1._.exists(data)) {
            // if the user is not providing id's, then we build an id based on the index.
            // for infinite scrolling, the index is used on it's own. for enterprise,
            // we combine the index with the level and group key, so that the id is
            // unique across the set.
            //
            // unique id is needed for selection (so selection can be maintained when
            // doing server side sorting / filtering) - if user is not providing id's
            // (and we use the indexes) then selection will not work between sorting &
            // filtering.
            //
            // id's are also used by the row renderer for updating the dom as it identifies
            // rowNodes by id
            var idToUse = this.createIdForIndex(index);
            rowNode.setDataAndId(data, idToUse);
            rowNode.setRowHeight(this.gridOptionsWrapper.getRowHeightForNode(rowNode));
            if (rowNode.group) {
                rowNode.key = this.valueService.getValue(this.rowGroupColumn, rowNode);
            }
        }
        else {
            rowNode.setDataAndId(undefined, undefined);
            rowNode.key = null;
        }
        if (this.groupLevel) {
            this.setGroupDataIntoRowNode(rowNode);
            this.setChildCountIntoRowNode(rowNode);
        }
    };
    EnterpriseBlock.prototype.setChildCountIntoRowNode = function (rowNode) {
        var getChildCount = this.gridOptionsWrapper.getChildCountFunc();
        if (getChildCount) {
            rowNode.allChildrenCount = getChildCount(rowNode.data);
        }
    };
    EnterpriseBlock.prototype.setGroupDataIntoRowNode = function (rowNode) {
        var _this = this;
        var groupDisplayCols = this.columnController.getGroupDisplayColumns();
        groupDisplayCols.forEach(function (col) {
            if (col.isRowGroupDisplayed(_this.rowGroupColumn.getId())) {
                var groupValue = _this.valueService.getValue(_this.rowGroupColumn, rowNode);
                if (ag_grid_1._.missing(rowNode.groupData)) {
                    rowNode.groupData = {};
                }
                rowNode.groupData[col.getColId()] = groupValue;
            }
        });
    };
    EnterpriseBlock.prototype.loadFromDatasource = function () {
        var _this = this;
        var params = this.createLoadParams();
        setTimeout(function () {
            _this.params.datasource.getRows(params);
        }, 0);
    };
    EnterpriseBlock.prototype.createBlankRowNode = function (rowIndex) {
        var rowNode = _super.prototype.createBlankRowNode.call(this, rowIndex);
        rowNode.group = this.groupLevel;
        rowNode.leafGroup = this.leafGroup;
        rowNode.level = this.level;
        rowNode.uiLevel = this.level;
        rowNode.parent = this.parentRowNode;
        // stub gets set to true here, and then false when this rowNode gets it's data
        rowNode.stub = true;
        if (rowNode.group) {
            rowNode.expanded = false;
            rowNode.field = this.groupField;
            rowNode.rowGroupColumn = this.rowGroupColumn;
        }
        return rowNode;
    };
    EnterpriseBlock.prototype.createGroupKeys = function (groupNode) {
        var keys = [];
        var pointer = groupNode;
        while (pointer.level >= 0) {
            keys.push(pointer.key);
            pointer = pointer.parent;
        }
        keys.reverse();
        return keys;
    };
    EnterpriseBlock.prototype.isPixelInRange = function (pixel) {
        return pixel >= this.blockTop && pixel < (this.blockTop + this.blockHeight);
    };
    EnterpriseBlock.prototype.getRowBounds = function (index, virtualRowCount) {
        var start = this.getStartRow();
        var end = this.getEndRow();
        for (var i = start; i <= end; i++) {
            // the blocks can have extra rows in them, if they are the last block
            // in the cache and the virtual row count doesn't divide evenly by the
            if (i >= virtualRowCount) {
                continue;
            }
            var rowNode = this.getRowUsingLocalIndex(i);
            if (rowNode) {
                if (rowNode.rowIndex === index) {
                    return {
                        rowHeight: rowNode.rowHeight,
                        rowTop: rowNode.rowTop
                    };
                }
                if (rowNode.group && rowNode.expanded && ag_grid_1._.exists(rowNode.childrenCache)) {
                    var enterpriseCache = rowNode.childrenCache;
                    if (enterpriseCache.isDisplayIndexInCache(index)) {
                        return enterpriseCache.getRowBounds(index);
                    }
                }
            }
        }
        console.error("ag-Grid: looking for invalid row index in Enterprise Row Model, index=" + index);
        return null;
    };
    EnterpriseBlock.prototype.getRowIndexAtPixel = function (pixel, virtualRowCount) {
        var start = this.getStartRow();
        var end = this.getEndRow();
        for (var i = start; i <= end; i++) {
            // the blocks can have extra rows in them, if they are the last block
            // in the cache and the virtual row count doesn't divide evenly by the
            if (i >= virtualRowCount) {
                continue;
            }
            var rowNode = this.getRowUsingLocalIndex(i);
            if (rowNode) {
                if (rowNode.isPixelInRange(pixel)) {
                    return rowNode.rowIndex;
                }
                if (rowNode.group && rowNode.expanded && ag_grid_1._.exists(rowNode.childrenCache)) {
                    var enterpriseCache = rowNode.childrenCache;
                    if (enterpriseCache.isPixelInRange(pixel)) {
                        return enterpriseCache.getRowIndexAtPixel(pixel);
                    }
                }
            }
        }
        console.warn("ag-Grid: invalid pixel range for enterprise block " + pixel);
        return 0;
    };
    EnterpriseBlock.prototype.clearRowTops = function (virtualRowCount) {
        this.forEachRowNode(virtualRowCount, function (rowNode) {
            rowNode.clearRowTop();
            var hasChildCache = rowNode.group && ag_grid_1._.exists(rowNode.childrenCache);
            if (hasChildCache) {
                var enterpriseCache = rowNode.childrenCache;
                enterpriseCache.clearRowTops();
            }
        });
    };
    EnterpriseBlock.prototype.setDisplayIndexes = function (displayIndexSeq, virtualRowCount, nextRowTop) {
        this.displayIndexStart = displayIndexSeq.peek();
        this.blockTop = nextRowTop.value;
        this.forEachRowNode(virtualRowCount, function (rowNode) {
            var rowIndex = displayIndexSeq.next();
            rowNode.setRowIndex(rowIndex);
            rowNode.setRowTop(nextRowTop.value);
            nextRowTop.value += rowNode.rowHeight;
            var hasChildCache = rowNode.group && ag_grid_1._.exists(rowNode.childrenCache);
            if (hasChildCache) {
                var enterpriseCache = rowNode.childrenCache;
                if (rowNode.expanded) {
                    enterpriseCache.setDisplayIndexes(displayIndexSeq, nextRowTop);
                }
                else {
                    // we need to clear the row tops, as the row renderer depends on
                    // this to know if the row should be faded out
                    enterpriseCache.clearRowTops();
                }
            }
        });
        this.displayIndexEnd = displayIndexSeq.peek();
        this.blockHeight = nextRowTop.value - this.blockTop;
    };
    EnterpriseBlock.prototype.forEachRowNode = function (virtualRowCount, callback) {
        var start = this.getStartRow();
        var end = this.getEndRow();
        for (var i = start; i <= end; i++) {
            // the blocks can have extra rows in them, if they are the last block
            // in the cache and the virtual row count doesn't divide evenly by the
            if (i >= virtualRowCount) {
                continue;
            }
            var rowNode = this.getRowUsingLocalIndex(i);
            if (rowNode) {
                callback(rowNode);
            }
        }
    };
    EnterpriseBlock.prototype.createLoadParams = function () {
        var groupKeys = this.createGroupKeys(this.parentRowNode);
        var request = {
            startRow: this.getStartRow(),
            endRow: this.getEndRow(),
            rowGroupCols: this.params.rowGroupCols,
            valueCols: this.params.valueCols,
            pivotCols: this.params.pivotCols,
            pivotMode: this.params.pivotMode,
            groupKeys: groupKeys,
            filterModel: this.params.filterModel,
            sortModel: this.params.sortModel
        };
        var params = {
            successCallback: this.pageLoaded.bind(this, this.getVersion()),
            failCallback: this.pageLoadFailed.bind(this),
            request: request
        };
        return params;
    };
    EnterpriseBlock.prototype.isDisplayIndexInBlock = function (displayIndex) {
        return displayIndex >= this.displayIndexStart && displayIndex < this.displayIndexEnd;
    };
    EnterpriseBlock.prototype.isBlockBefore = function (displayIndex) {
        return displayIndex >= this.displayIndexEnd;
    };
    EnterpriseBlock.prototype.getDisplayIndexStart = function () {
        return this.displayIndexStart;
    };
    EnterpriseBlock.prototype.getDisplayIndexEnd = function () {
        return this.displayIndexEnd;
    };
    EnterpriseBlock.prototype.getBlockHeight = function () {
        return this.blockHeight;
    };
    EnterpriseBlock.prototype.getBlockTop = function () {
        return this.blockTop;
    };
    __decorate([
        ag_grid_1.Autowired('context'),
        __metadata("design:type", ag_grid_1.Context)
    ], EnterpriseBlock.prototype, "context", void 0);
    __decorate([
        ag_grid_1.Autowired('rowRenderer'),
        __metadata("design:type", ag_grid_1.RowRenderer)
    ], EnterpriseBlock.prototype, "rowRenderer", void 0);
    __decorate([
        ag_grid_1.Autowired('columnController'),
        __metadata("design:type", ag_grid_1.ColumnController)
    ], EnterpriseBlock.prototype, "columnController", void 0);
    __decorate([
        ag_grid_1.Autowired('valueService'),
        __metadata("design:type", ag_grid_1.ValueService)
    ], EnterpriseBlock.prototype, "valueService", void 0);
    __decorate([
        ag_grid_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", ag_grid_1.GridOptionsWrapper)
    ], EnterpriseBlock.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        __param(0, ag_grid_1.Qualifier('loggerFactory')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ag_grid_1.LoggerFactory]),
        __metadata("design:returntype", void 0)
    ], EnterpriseBlock.prototype, "setBeans", null);
    __decorate([
        ag_grid_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], EnterpriseBlock.prototype, "init", null);
    return EnterpriseBlock;
}(ag_grid_1.RowNodeBlock));
exports.EnterpriseBlock = EnterpriseBlock;


/***/ }),

/***/ "cERj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
// class returns unique instance id's for columns.
// eg, the following calls (in this order) will result in:
//
// getInstanceIdForKey('country') => 0
// getInstanceIdForKey('country') => 1
// getInstanceIdForKey('country') => 2
// getInstanceIdForKey('country') => 3
// getInstanceIdForKey('age') => 0
// getInstanceIdForKey('age') => 1
// getInstanceIdForKey('country') => 4
var GroupInstanceIdCreator = (function () {
    function GroupInstanceIdCreator() {
        // this map contains keys to numbers, so we remember what the last call was
        this.existingIds = {};
    }
    GroupInstanceIdCreator.prototype.getInstanceIdForKey = function (key) {
        var lastResult = this.existingIds[key];
        var result;
        if (typeof lastResult !== 'number') {
            // first time this key
            result = 0;
        }
        else {
            result = lastResult + 1;
        }
        this.existingIds[key] = result;
        return result;
    };
    return GroupInstanceIdCreator;
}());
exports.GroupInstanceIdCreator = GroupInstanceIdCreator;


/***/ }),

/***/ "cGG2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("JP+z");
var isBuffer = __webpack_require__("Re3r");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "cUpd":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(22);
	module.exports = __webpack_require__(22);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20), __webpack_require__(23)  ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {

	    var kendo = window.kendo;
	    var Widget = kendo.ui.Widget;
	    var extend = $.extend;
	    var proxy = $.proxy;
	    var DOT = ".";
	    var SPACE = " ";
	    var NS = ".kendoChat";

	    var MESSAGE_GROUP_TEMPLATE = kendo.template(
	        '<div #:text# class="#=styles.messageGroup# #= url ? "" : styles.noAvatar #">' +
	            '<p class="#=styles.author#">#:text#</p>' +
	            '# if (url) { #' +
	                '<img src="#=url#" alt="#:text#" class="#=styles.avatar#">' +
	            '# } #' +
	        '</div>');

	    var SELF_MESSAGE_GROUP_TEMPLATE = kendo.template(
	        '<div me class="#=styles.messageGroup# #=styles.self# #= url ? "" : styles.noAvatar #">' +
	            '# if (url) { #' +
	                '<img src="#=url#" alt="#:text#" class="#=styles.avatar#">' +
	            '# } #' +
	        '</div>');

	    var TEXT_MESSAGE_TEMPLATE = kendo.template(
	        '<div class="#=styles.message#">' +
	            '<time class="#=styles.messageTime#">#= kendo.toString(kendo.parseDate(timestamp), "HH:mm:ss") #</time>' +
	            '<div class="#=styles.bubble#">#:text#</div>' +
	        '</div>');

	    var TYPING_INDICATOR_TEMPLATE = kendo.template(
	        '<div class="#=styles.messageListContent# #=styles.typingIndicatorBubble#">' +
	            '<p class="#=styles.author#">#:text#</p>' +
	            '<div class="#=styles.message#">' +
	                '<div class="#=styles.bubble#">' +
	                    '<div class="#=styles.typingIndicator#">' +
	                        '<span></span><span></span><span></span>' +
	                    '</div>' +
	                '</div>' +
	            '</div>' +
	        '</div>');

	    var SUGGESTED_ACTIONS_TEMPLATE = kendo.template(
	        '<div class="#=styles.suggestedActions#">' +
	            '# for (var i = 0; i < suggestedActions.length; i++) { #' +
	                '<span class="#=styles.suggestedAction#" data-value="#:suggestedActions[i].value#">#:suggestedActions[i].title#</span>' +
	            '# } #' +
	        '</div>'
	        );

	    var HERO_CARD_TEMPLATE = kendo.template(
	        '<div class="#=styles.card# #=styles.cardRich#">' +
	            '# if (typeof images !== "undefined" && images.length > 0) { #' +
	                '<img src="#:images[0].url#" alt="#:images[0].alt#" class="#=styles.cardImage#" />' +
	            '# } #' +
	            '<div class="#=styles.cardBody#">' +
	                '# if (typeof title !== "undefined") { #' +
	                    '<h5 class="#=styles.cardTitle#">#:title#</h5>' +
	                '# } #' +
	                '# if (typeof subtitle !== "undefined") { #' +
	                    '<h6 class="#=styles.cardSubtitle#">#:subtitle#</h6>' +
	                '# } #' +
	                '# if (typeof text !== "undefined") { #' +
	                    '<p>#:text#</p>' +
	                '# } #' +
	            '</div>' +
	            '# if (typeof buttons !== "undefined" && buttons.length > 0) { #' +
	                '<div class="#=styles.cardActions# #=styles.cardActionsVertical#">' +
	                '# for (var i = 0; i < buttons.length; i++) { #' +
	                    '<span class="#=styles.cardAction#"><span class="#=styles.button# #=styles.buttonPrimary#" data-value="#:buttons[i].value#">#:buttons[i].title#</span></span>' +
	                '# } #' +
	                '</div>' +
	            '# } #' +
	        '</div>'
	        );

	    extend(kendo.chat, {
	        Templates: {},
	        Components: {}
	    });

	    kendo.chat.registerTemplate = function(templateName, template) {
	        kendo.chat.Templates[templateName] = kendo.template(template);
	    };

	    kendo.chat.getTemplate = function(templateName) {
	        return kendo.chat.Templates[templateName] || TEXT_MESSAGE_TEMPLATE;
	    };

	    kendo.chat.registerTemplate("text", TEXT_MESSAGE_TEMPLATE);
	    kendo.chat.registerTemplate("message", TEXT_MESSAGE_TEMPLATE);
	    kendo.chat.registerTemplate("typing", TYPING_INDICATOR_TEMPLATE);
	    kendo.chat.registerTemplate("suggestedAction", SUGGESTED_ACTIONS_TEMPLATE);
	    kendo.chat.registerTemplate("heroCard", HERO_CARD_TEMPLATE);
	    kendo.chat.registerTemplate("application/vnd.microsoft.card.hero", HERO_CARD_TEMPLATE);

	    kendo.chat.registerComponent = function(componentName, component) {
	        kendo.chat.Components[componentName] = component;
	    };

	    kendo.chat.getComponent = function(componentName) {
	        return kendo.chat.Components[componentName] || null;
	    };

	    var Component = kendo.chat.Component = kendo.Class.extend({
	        init: function(options, view) {
	            this.element = $('<div></div>');
	            this.options = options;
	            this.view = view;
	        },

	        destroy: function() {
	            kendo.destroy(this.element);
	        }
	    });

	    var Calendar = Component.extend({
	        init: function(options, view) {
	            Component.fn.init.call(this, options, view);

	            this.element.kendoCalendar({
	                change: function() {
	                    view.trigger("suggestedAction", { text: kendo.toString(this.value(), 'd'), type: "message" });
	                }
	            });
	        },

	        destroy: function() {
	        }
	    });
	    kendo.chat.registerComponent("calendar", Calendar);

	    var viewStyles = {
	        wrapper: "k-widget k-chat",
	        messageList: "k-avatars",
	        messageListContent: "k-message-list-content",
	        messageTime: "k-message-time",
	        messageGroup: "k-message-group",
	        message: "k-message",
	        only: "k-only",
	        first: "k-first",
	        middle: "k-middle",
	        last: "k-last",
	        author: "k-author",
	        avatar: "k-avatar",
	        noAvatar: "k-no-avatar",
	        self: "k-alt",
	        button: "k-button",
	        iconButton: "k-button-icon",
	        buttonPrimary: "k-flat k-primary",
	        scrollButtonIcon: "k-icon",
	        scrollButtonIconLeft: "k-i-arrow-chevron-left",
	        scrollButtonIconRight: "k-i-arrow-chevron-right",
	        typingIndicator: "k-typing-indicator",
	        typingIndicatorBubble: "k-typing-indicator-bubble",
	        bubble: "k-bubble",
	        suggestedActions: "k-quick-replies",
	        suggestedAction: "k-quick-reply",
	        cardWrapper: "k-card-container",
	        cardDeckScrollWrap: "k-card-deck-scrollwrap",
	        cardDeck: "k-card-deck",
	        cardList: "k-card-list",
	        card: "k-card",
	        cardRich: "k-card-type-rich",
	        cardBody: "k-card-body",
	        cardImage: "k-card-image",
	        cardTitle: "k-card-title",
	        cardSubtitle: "k-card-subtitle",
	        cardActions: "k-card-actions",
	        cardActionsVertical: "k-card-actions-vertical",
	        cardAction: "k-card-action",
	        selected: "k-state-selected"
	    };

	    var ChatView = kendo.chat.ChatView = Widget.extend({
	        init: function(element, options) {
	            Widget.fn.init.call(this, element, options);

	            this._list();

	            this._lastSender = null;

	            this.typingParticipants = [];

	            this._attachEvents();

	            this._scrollable();
	        },

	        events: [
	        ],

	        options: {
	            messages: {
	                isTyping: " is typing.",
	                areTyping: " are typing.",
	                and: " and "
	            }
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            if (this._scrollDraggable) {
	                this._scrollDraggable.destroy();
	            }

	            this.element.empty();
	            this.element.off(NS);

	            this.list = null;
	            this._lastSender = null;
	        },

	        _list: function() {
	            var viewStyles = ChatView.styles;

	            this.element
	                .addClass(viewStyles.messageList)
	                .attr("aria-live", "polite");

	            this.list = $("<div>")
	                .addClass(viewStyles.messageListContent)
	                .appendTo(this.element);
	        },

	        _attachEvents: function() {
	            var styles = ChatView.styles;

	            this.element
	                .on("click" + NS, proxy(this._listClick, this))
	                .on("click" + NS, DOT + styles.message, proxy(this._messageClick, this))
	                .on("click" + NS, DOT + styles.suggestedAction, proxy(this._suggestedActionClick, this))
	                .on("click" + NS, DOT + styles.cardAction + SPACE + DOT + styles.button, proxy(this._cardActionClick, this));
	        },

	        _scrollable: function() {
	            var viewStyles = ChatView.styles;

	            this.element
	                .on("click" + NS, DOT + viewStyles.cardDeckScrollWrap + SPACE + DOT + viewStyles.button, proxy(this._scrollButtonClick, this));
	        },

	        _scrollButtonClick: function(e) {
	            var viewStyles = ChatView.styles;
	            var button = $(e.currentTarget);
	            var scrollToLeft = button.find(DOT + viewStyles.scrollButtonIconLeft).length !== 0;
	            var scrollContainer = button.siblings(DOT + viewStyles.cardDeck);
	            var lastCard = scrollContainer.find(DOT + viewStyles.card).last();
	            var cardWidth = lastCard.outerWidth(true);

	            if (scrollToLeft) {
	                kendo.scrollLeft(scrollContainer, kendo.scrollLeft(scrollContainer) - cardWidth);
	            } else {
	                kendo.scrollLeft(scrollContainer, kendo.scrollLeft(scrollContainer) + cardWidth);
	            }
	        },

	        getTemplate: function(templateName) {
	            return kendo.chat.getTemplate(templateName);
	        },

	        getComponent: function(type) {
	           return kendo.chat.getComponent(type);
	        },

	        renderMessage: function(message, sender) {
	            if (!message.timestamp) {
	                message.timestamp = new Date();
	            }

	            if (!message.text) {
	                message.text = "";
	            }

	            var bubbleElement = this._renderTemplate(message.type, message);

	            this._renderBubble(message.type, bubbleElement, sender);

	            if (message.type == "typing") {
	                if (this.typingParticipants.length > 0) {
	                    this._removeTypingParticipant(sender);
	                }
	            } else {
	                this._lastSender = sender.id;
	            }
	        },

	        renderSuggestedActions: function(suggestedActions) {
	            this._removeSuggestedActions();

	            var element = this._renderTemplate("suggestedAction", { suggestedActions: suggestedActions });

	            this.list.append(element);

	            this._scrollToBottom();
	        },

	        renderAttachments: function(options) {
	            var wrapper = this._renderAttachmentWrapper(options.attachmentLayout);
	            var cardContainer = options.attachmentLayout === "carousel" ? wrapper.find(DOT + ChatView.styles.cardDeck) : wrapper;
	            var attachments = options.attachments;

	            if (!attachments.length) {
	                return;
	            }

	            for (var i = 0; i < attachments.length; i++) {
	                var cardElement = this._renderTemplate(attachments[i].contentType, attachments[i].content);

	                cardContainer.append(cardElement);
	            }

	            this._removeSuggestedActions();
	            this._removeTypingIndicator();

	            this.list.append(wrapper);

	            this._lastSender = null;
	        },

	        renderComponent: function(type) {
	            var componentType = this.getComponent(type);
	            var component = new componentType({}, this);

	            this.list.append(component.element);

	            this._scrollToBottom();
	        },

	        _renderAttachmentWrapper: function(layout) {
	            var viewStyles = ChatView.styles;
	            var wrapper = $("<div>");

	            if (layout === "carousel") {
	                wrapper.addClass(viewStyles.cardDeckScrollWrap);

	                var buttonLeft = this._renderScrollButton(viewStyles.scrollButtonIconLeft);
	                wrapper.append(buttonLeft);

	                wrapper.append($("<div>").addClass(viewStyles.cardDeck));

	                var buttonRight = this._renderScrollButton(viewStyles.scrollButtonIconRight);
	                wrapper.append(buttonRight);
	            } else {
	                wrapper.addClass(viewStyles.cardList);
	            }

	            return wrapper;
	        },

	        _renderScrollButton: function(directionClass) {
	            var viewStyles = ChatView.styles;

	            return $("<button>")
	                .addClass(viewStyles.button)
	                .addClass(viewStyles.iconButton)
	                .append($("<span>")
	                    .addClass(viewStyles.scrollButtonIcon)
	                    .addClass(directionClass)
	                );
	        },

	        _removeSuggestedActions: function() {
	            this.list.find(DOT + ChatView.styles.suggestedActions).remove();
	        },

	        _listClick: function(e) {
	            var styles = ChatView.styles;
	            var targetElement = $(e.target);

	            if (targetElement.hasClass(styles.message) || targetElement.parents(DOT + styles.message).length) {
	                return;
	            }

	            this._clearSelection();
	        },

	        _messageClick: function(e) {
	            this._clearSelection();

	            $(e.currentTarget).addClass(ChatView.styles.selected);
	        },

	        _suggestedActionClick: function(e) {
	            var text = $(e.target).data("value") || "";

	            this.trigger("actionClick", { text: text });

	            this._removeSuggestedActions();
	        },

	        _cardActionClick: function(e) {
	            var text = $(e.target).data("value") || "";

	            this.trigger("actionClick", { text: text });
	        },

	        _renderBubble: function(messageType, bubbleElement, sender) {
	            this._removeSuggestedActions();
	            this._removeTypingIndicator();

	            var group = this._getMessageGroup(sender, messageType);

	            this._appendToGroup(group, bubbleElement, messageType);

	            this._scrollToBottom();
	        },

	        _renderTemplate: function(type, options) {
	            var componentType = this.getComponent(type);
	            var element;

	            if (componentType) {
	                var component = new componentType(options, this);

	                element = component.element;
	            } else {
	                var template = this.getTemplate(type);
	                var templateOptions = extend(true, {}, options, { styles: ChatView.styles });

	                element = $(template(templateOptions));
	            }

	            return element;
	        },

	        _getMessageGroup: function(sender, messageType) {
	            var viewStyles = ChatView.styles;
	            var template = this._getMessageGroupTemplate(sender, messageType);
	            var appendTarget = messageType == "typing" ? this.element : this.list;
	            var group;

	            if (sender.id === this._lastSender && this._lastSender !== null && messageType !== "typing") {
	                group = this.list.find(DOT + viewStyles.messageGroup).last();

	                if (group.length) {
	                    return group;
	                }
	            }

	            return $(template({text: sender.name, url: sender.iconUrl, styles: viewStyles})).appendTo(appendTarget);
	        },

	        _getMessageGroupTemplate: function(sender, messageType) {
	            var isOwnMessage = sender.id === this.options.user.id;
	            var template = isOwnMessage ?
	                SELF_MESSAGE_GROUP_TEMPLATE :
	                MESSAGE_GROUP_TEMPLATE;

	            if(messageType == "typing") {
	                template = TYPING_INDICATOR_TEMPLATE;
	            }

	            return template;
	        },

	        _appendToGroup: function(group, messageElement, messageType) {
	            var viewStyles = ChatView.styles;
	            var children = group.find(DOT + viewStyles.message);
	            var childrenCount = children.length;
	            var indicator = this.element.find(DOT + viewStyles.typingIndicator);

	            if(indicator.length && messageType == "typing") {
	                return;
	            }

	            messageElement.addClass(childrenCount === 0 ? viewStyles.only : viewStyles.last);

	            children.filter(DOT + viewStyles.only)
	                .removeClass(viewStyles.only)
	                .addClass(viewStyles.first);

	            children.filter(DOT + viewStyles.last)
	                .removeClass(viewStyles.last)
	                .addClass(viewStyles.middle);

	            group.append(messageElement);
	        },

	        _renderTypingIndicator: function(sender) {
	            var indicator = this.element.find(DOT + viewStyles.typingIndicatorBubble),
	                indicatorList,
	                participants;

	            this._addTypingParticipant(sender);

	            if(indicator.length) {
	                participants = this._composeTypingParticipantsText(this.typingParticipants);

	                indicatorList = indicator.find(DOT + viewStyles.author).first();
	                indicatorList.text(participants);

	            } else {
	                $(TYPING_INDICATOR_TEMPLATE({
	                    text: sender.name + this.options.messages.isTyping,
	                    styles: viewStyles
	                })).appendTo(this.element);
	            }

	            this._scrollToBottom();
	        },

	        _addTypingParticipant: function(sender) {
	            var found = false;
	            for(var i = 0; i < this.typingParticipants.length; i += 1) {
	                if(this.typingParticipants[i].id == sender.id) {
	                    found = true;
	                    break;
	                }
	            }
	            if(!found) {
	                this.typingParticipants.push(sender);
	            }
	        },

	        _removeTypingParticipant: function(sender) {
	            var indicator = this.element.find(DOT + viewStyles.typingIndicatorBubble),
	                indicatorList,
	                participants;

	            if(indicator.length) {
	                for (var i = 0; i < this.typingParticipants.length; i += 1) {
	                    if (this.typingParticipants[i].id == sender.id) {
	                        this.typingParticipants.splice(i, 1);
	                    }
	                }

	                participants = this._composeTypingParticipantsText(this.typingParticipants);

	                if(participants === "") {
	                    indicator.remove();
	                } else {
	                    indicatorList = indicator.find(DOT + viewStyles.author).first();
	                    indicatorList.text(participants);
	                }
	            }
	        },

	        _composeTypingParticipantsText: function(participants) {
	            var messages = this.options.messages,
	                typingAction = participants.length == 1 ? messages.isTyping : messages.areTyping,
	                typingText = "";

	            if(participants.length === 0) {
	                return typingText;
	            }

	            typingText = this.typingParticipants.map(function(author) {
	                return author.name;
	            }).join(', ').replace(/,(?!.*,)/gmi, messages.and.trimRight()) + typingAction;

	            return typingText;
	        },

	        _removeTypingIndicator: function() {
	            var indicator = this.element.find(DOT + viewStyles.typingIndicatorBubble);

	            if(indicator.length) {
	                this.typingParticipants = [];
	                indicator.remove();
	            }
	        },

	        _clearSelection: function() {
	            var selectedClass = ChatView.styles.selected;

	            this.element.find(DOT + selectedClass).removeClass(selectedClass);
	        },

	        _scrollToBottom: function() {
	            this.element.scrollTop(this.element.prop("scrollHeight"));
	        }
	    });

	    extend(true, ChatView, { styles: viewStyles });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 23:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ })

/******/ });

/***/ }),

/***/ "cWbx":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(975);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(976), __webpack_require__(977) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {

	var kendo = window.kendo,
	    extend = $.extend,
	    Editor = kendo.ui.editor,
	    EditorUtils = Editor.EditorUtils,
	    dom = Editor.Dom,
	    registerTool = EditorUtils.registerTool,
	    ToolTemplate = Editor.ToolTemplate,
	    RangeUtils = Editor.RangeUtils,
	    Command = Editor.Command,
	    LinkFormatter = Editor.LinkFormatter,
	    textNodes = RangeUtils.textNodes,
	    keys = kendo.keys,
	    KEDITORFILEURL = "#k-editor-file-url",
	    KEDITORFILETEXT = "#k-editor-file-text",
	    KEDITORFILETITLE = "#k-editor-file-title";

	var FileCommand = Command.extend({
	    init: function(options) {
	        var that = this;
	        Command.fn.init.call(that, options);

	        that.formatter = new LinkFormatter();

	        that.async = true;
	        that.attributes = {};
	    },

	    insertFile: function(file, range) {
	        var attributes = this.attributes;
	        var doc = RangeUtils.documentFromRange(range);

	        if (attributes.href && attributes.href != "http://") {

	            if (!file) {
	                file = dom.create(doc, "a", {href: attributes.href});
	                file.innerHTML = attributes.innerHTML;
	                file.title = attributes.title;

	                range.deleteContents();
	                range.insertNode(file);

	                if (!file.nextSibling) {
	                    dom.insertAfter(doc.createTextNode("\ufeff"), file);
	                }

	                range.setStartAfter(file);
	                range.setEndAfter(file);
	                RangeUtils.selectRange(range);
	                return true;
	            } else {
	                dom.attr(file, attributes);
	            }
	        }

	        return false;
	    },

	    _dialogTemplate: function(showBrowser) {
	        return kendo.template(
	            '<div class="k-editor-dialog k-popup-edit-form">' +
	                '<div class="k-edit-form-container">' +
	                    '<div class="k-edit-form-content">' +
	                        '# if (showBrowser) { #' +
	                            '<div class="k-filebrowser"></div>' +
	                        '# } #' +
	                        "<div class='k-edit-label'>" +
	                            '<label for="k-editor-file-url">#: messages.fileWebAddress #</label>' +
	                        "</div>" +
	                        "<div class='k-edit-field'>" +
	                            '<input type="text" class="k-textbox" id="k-editor-file-url">' +
	                        "</div>" +
	                        "<div class='k-edit-label'>" +
	                            '<label for="k-editor-file-text">#: messages.fileText #</label>' +
	                        "</div>" +
	                        "<div class='k-edit-field'>" +
	                            '<input type="text" class="k-textbox" id="k-editor-file-text">' +
	                        "</div>" +
	                        "<div class='k-edit-label'>" +
	                            '<label for="k-editor-file-title">#: messages.fileTitle #</label>' +
	                        "</div>" +
	                        "<div class='k-edit-field'>" +
	                            '<input type="text" class="k-textbox" id="k-editor-file-title">' +
	                        "</div>" +
	                    '</div>' +
	                    '<div class="k-edit-buttons k-state-default">' +
	                        '<button class="k-dialog-insert k-button k-primary">#: messages.dialogInsert #</button>' +
	                        '<button class="k-dialog-close k-button">#: messages.dialogCancel #</button>' +
	                    '</div>' +
	                '</div>' +
	            '</div>'
	        )({
	            messages: this.editor.options.messages,
	            showBrowser: showBrowser
	        });
	    },

	    redo: function () {
	        var that = this,
	            range = that.lockRange();

	        this.formatter.apply(range, this.attributes);
	        that.releaseRange(range);
	    },

	    exec: function () {
	        var that = this,
	            range = that.lockRange(),
	            nodes = textNodes(range),
	            applied = false,
	            file = nodes.length ? this.formatter.finder.findSuitable(nodes[0]) : null,
	            dialog,
	            isIE = kendo.support.browser.msie,
	            options = that.editor.options,
	            messages = options.messages,
	            fileBrowser = options.fileBrowser,
	            showBrowser = !!(kendo.ui.FileBrowser && fileBrowser && fileBrowser.transport && fileBrowser.transport.read !== undefined),
	            dialogOptions = {
	                title: messages.insertFile,
	                visible: false,
	                resizable: showBrowser
	            };

	        this.expandImmutablesIn(range);

	        function apply(e) {
	            var element = dialog.element,
	                href = element.find(KEDITORFILEURL).val().replace(/ /g, "%20"),
	                innerHTML = element.find(KEDITORFILETEXT).val(),
	                title = element.find(KEDITORFILETITLE).val();

	            that.attributes = {
	                href: href,
	                innerHTML: innerHTML !== "" ? innerHTML : href,
	                title: title
	            };

	            applied = that.insertFile(file, range);

	            close(e);

	            if (that.change) {
	                that.change();
	            }
	        }

	        function close(e) {
	            e.preventDefault();
	            dialog.destroy();

	            dom.windowFromDocument(RangeUtils.documentFromRange(range)).focus();
	            if (!applied) {
	                that.releaseRange(range);
	            }
	        }

	        function keyDown(e) {
	            if (e.keyCode == keys.ENTER) {
	                apply(e);
	            } else if (e.keyCode == keys.ESC) {
	                close(e);
	            }
	        }

	        dialogOptions.close = close;

	        if (showBrowser) {
	            dialogOptions.width = 750;
	        }

	        dialog = this.createDialog(that._dialogTemplate(showBrowser), dialogOptions)
	            .toggleClass("k-filebrowser-dialog", showBrowser)
	            .find(".k-dialog-insert").click(apply).end()
	            .find(".k-dialog-close").click(close).end()
	            .find(".k-edit-field input").keydown(keyDown).end()
	            // IE < 8 returns absolute url if getAttribute is not used
	            .find(KEDITORFILEURL).val(file ? file.getAttribute("href", 2) : "http://").end()
	            .find(KEDITORFILETEXT).val(file ? file.innerText : "").end()
	            .find(KEDITORFILETITLE).val(file ? file.title : "").end()
	            .data("kendoWindow");

	        var element = dialog.element;
	        if (showBrowser) {
	            that._fileBrowser = new kendo.ui.FileBrowser(
	                element.find(".k-filebrowser"),
	                extend({}, fileBrowser)
	            );

	            that._fileBrowser.bind("change", function (ev) {
	                if (ev.selected.get("type") === "f") {
	                    element.find(KEDITORFILEURL).val(this.value());
	                }
	            } );

	            that._fileBrowser.bind("apply", apply);
	        }

	        if(isIE) {
	            var dialogHeight = element.closest(".k-window").height();
	            element.css("max-height", dialogHeight);
	        }
	        dialog.center().open();
	        element.find(KEDITORFILEURL).focus().select();
	    }

	});

	kendo.ui.editor.FileCommand = FileCommand;

	registerTool("insertFile", new Editor.Tool({ command: FileCommand, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Insert File" }) }));

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 976:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("qrfa");

/***/ }),

/***/ 977:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("wfaU");

/***/ })

/******/ });

/***/ }),

/***/ "cWxy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("dVOP");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "ci/Y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var cellComp_1 = __webpack_require__("wTNE");
var rowNode_1 = __webpack_require__("bP2e");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var column_1 = __webpack_require__("hDyE");
var events_1 = __webpack_require__("3ok8");
var context_1 = __webpack_require__("RQ1/");
var component_1 = __webpack_require__("pQ38");
var componentAnnotations_1 = __webpack_require__("x5ih");
var LoadingCellRenderer = (function (_super) {
    __extends(LoadingCellRenderer, _super);
    function LoadingCellRenderer() {
        return _super.call(this, LoadingCellRenderer.TEMPLATE) || this;
    }
    LoadingCellRenderer.prototype.init = function (params) {
        var eLoadingIcon = utils_1._.createIconNoSpan('groupLoading', this.gridOptionsWrapper, null);
        this.eLoadingIcon.appendChild(eLoadingIcon);
        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
        this.eLoadingText.innerText = localeTextFunc('loadingOoo', 'Loading');
    };
    LoadingCellRenderer.prototype.refresh = function (params) {
        return false;
    };
    LoadingCellRenderer.TEMPLATE = "<div class=\"ag-stub-cell\">\n            <span class=\"ag-loading-icon\" ref=\"eLoadingIcon\"></span>\n            <span class=\"ag-loading-text\" ref=\"eLoadingText\"></span>\n        </div>";
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], LoadingCellRenderer.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('eLoadingIcon'),
        __metadata("design:type", HTMLElement)
    ], LoadingCellRenderer.prototype, "eLoadingIcon", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('eLoadingText'),
        __metadata("design:type", HTMLElement)
    ], LoadingCellRenderer.prototype, "eLoadingText", void 0);
    return LoadingCellRenderer;
}(component_1.Component));
exports.LoadingCellRenderer = LoadingCellRenderer;
var RowComp = (function (_super) {
    __extends(RowComp, _super);
    function RowComp(parentScope, bodyContainerComp, pinnedLeftContainerComp, pinnedRightContainerComp, fullWidthContainerComp, rowNode, beans, animateIn, useAnimationFrameForCreate) {
        var _this = _super.call(this) || this;
        _this.eAllRowContainers = [];
        _this.active = true;
        _this.columnRefreshPending = false;
        _this.cellComps = {};
        // for animations, there are bits we want done in the next VM turn, to all DOM to update first.
        // instead of each row doing a setTimeout(func,0), we put the functions here and the rowRenderer
        // executes them all in one timeout
        _this.createSecondPassFuncs = [];
        // these get called before the row is destroyed - they set up the DOM for the remove animation (ie they
        // set the DOM up for the animation), then the delayedDestroyFunctions get called when the animation is
        // complete (ie removes from the dom).
        _this.removeFirstPassFuncs = [];
        // for animations, these functions get called 400ms after the row is cleared, called by the rowRenderer
        // so each row isn't setting up it's own timeout
        _this.removeSecondPassFuncs = [];
        _this.initialised = false;
        _this.parentScope = parentScope;
        _this.beans = beans;
        _this.bodyContainerComp = bodyContainerComp;
        _this.pinnedLeftContainerComp = pinnedLeftContainerComp;
        _this.pinnedRightContainerComp = pinnedRightContainerComp;
        _this.fullWidthContainerComp = fullWidthContainerComp;
        _this.rowNode = rowNode;
        _this.rowIsEven = _this.rowNode.rowIndex % 2 === 0;
        _this.paginationPage = _this.beans.paginationProxy.getCurrentPage();
        _this.useAnimationFrameForCreate = useAnimationFrameForCreate;
        _this.setAnimateFlags(animateIn);
        return _this;
    }
    RowComp.prototype.init = function () {
        var _this = this;
        this.rowFocused = this.beans.focusedCellController.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
        this.scope = this.createChildScopeOrNull(this.rowNode.data);
        this.setupRowContainers();
        this.addListeners();
        if (this.slideRowIn) {
            this.createSecondPassFuncs.push(function () {
                _this.onTopChanged();
            });
        }
        if (this.fadeRowIn) {
            this.createSecondPassFuncs.push(function () {
                _this.eAllRowContainers.forEach(function (eRow) { return utils_1._.removeCssClass(eRow, 'ag-opacity-zero'); });
            });
        }
    };
    RowComp.prototype.createTemplate = function (contents, extraCssClass) {
        if (extraCssClass === void 0) { extraCssClass = null; }
        var templateParts = [];
        var rowHeight = this.rowNode.rowHeight;
        var rowClasses = this.getInitialRowClasses(extraCssClass).join(' ');
        var rowIdSanitised = utils_1._.escape(this.rowNode.id);
        var userRowStyles = this.preProcessStylesFromGridOptions();
        var businessKey = this.getRowBusinessKey();
        var businessKeySanitised = utils_1._.escape(businessKey);
        var rowTopStyle = this.getInitialRowTopStyle();
        templateParts.push("<div");
        templateParts.push(" role=\"row\"");
        templateParts.push(" row-index=\"" + this.rowNode.getRowIndexString() + "\"");
        templateParts.push(rowIdSanitised ? " row-id=\"" + rowIdSanitised + "\"" : "");
        templateParts.push(businessKey ? " row-business-key=\"" + businessKeySanitised + "\"" : "");
        templateParts.push(" comp-id=\"" + this.getCompId() + "\"");
        templateParts.push(" class=\"" + rowClasses + "\"");
        templateParts.push(" style=\"height: " + rowHeight + "px; " + rowTopStyle + " " + userRowStyles + "\">");
        // add in the template for the cells
        templateParts.push(contents);
        templateParts.push("</div>");
        return templateParts.join('');
    };
    RowComp.prototype.getCellForCol = function (column) {
        var cellComp = this.cellComps[column.getColId()];
        if (cellComp) {
            return cellComp.getGui();
        }
        else {
            return null;
        }
    };
    RowComp.prototype.afterFlush = function () {
        if (!this.initialised) {
            this.initialised = true;
            this.executeProcessRowPostCreateFunc();
        }
    };
    RowComp.prototype.executeProcessRowPostCreateFunc = function () {
        var func = this.beans.gridOptionsWrapper.getProcessRowPostCreateFunc();
        if (func) {
            var params = {
                eRow: this.eBodyRow,
                ePinnedLeftRow: this.ePinnedLeftRow,
                ePinnedRightRow: this.ePinnedRightRow,
                node: this.rowNode,
                api: this.beans.gridOptionsWrapper.getApi(),
                rowIndex: this.rowNode.rowIndex,
                addRenderedRowListener: this.addEventListener.bind(this),
                columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
                context: this.beans.gridOptionsWrapper.getContext()
            };
            func(params);
        }
    };
    RowComp.prototype.getInitialRowTopStyle = function () {
        var rowTopStyle = '';
        var setRowTop = !this.beans.forPrint && !this.beans.gridOptionsWrapper.isAutoHeight();
        if (setRowTop) {
            // if sliding in, we take the old row top. otherwise we just set the current row top.
            var pixels = this.slideRowIn ? this.roundRowTopToBounds(this.rowNode.oldRowTop) : this.rowNode.rowTop;
            var pixelsWithOffset = this.applyPaginationOffset(pixels);
            // if not setting row top, then below is empty string
            rowTopStyle = "top: " + pixelsWithOffset + "px; ";
        }
        return rowTopStyle;
    };
    RowComp.prototype.getRowBusinessKey = function () {
        if (typeof this.beans.gridOptionsWrapper.getBusinessKeyForNodeFunc() === 'function') {
            var businessKey = this.beans.gridOptionsWrapper.getBusinessKeyForNodeFunc()(this.rowNode);
            return businessKey;
        }
    };
    RowComp.prototype.lazyCreateCells = function (cols, eRow) {
        if (this.active) {
            var cellTemplatesAndComps = this.createCells(cols);
            eRow.innerHTML = cellTemplatesAndComps.template;
            this.callAfterRowAttachedOnCells(cellTemplatesAndComps.cellComps, eRow);
        }
    };
    RowComp.prototype.createRowContainer = function (rowContainerComp, cols, callback) {
        var _this = this;
        var cellTemplatesAndComps;
        if (this.useAnimationFrameForCreate) {
            cellTemplatesAndComps = { cellComps: [], template: '' };
        }
        else {
            cellTemplatesAndComps = this.createCells(cols);
        }
        var rowTemplate = this.createTemplate(cellTemplatesAndComps.template);
        rowContainerComp.appendRowTemplate(rowTemplate, function () {
            var eRow = rowContainerComp.getRowElement(_this.getCompId());
            _this.afterRowAttached(rowContainerComp, eRow);
            callback(eRow);
            if (_this.useAnimationFrameForCreate) {
                _this.beans.taskQueue.addP1Task(_this.lazyCreateCells.bind(_this, cols, eRow));
            }
            else {
                _this.callAfterRowAttachedOnCells(cellTemplatesAndComps.cellComps, eRow);
            }
        });
    };
    RowComp.prototype.createChildScopeOrNull = function (data) {
        if (this.beans.gridOptionsWrapper.isAngularCompileRows()) {
            var newChildScope = this.parentScope.$new();
            newChildScope.data = data;
            newChildScope.rowNode = this.rowNode;
            newChildScope.context = this.beans.gridOptionsWrapper.getContext();
            return newChildScope;
        }
        else {
            return null;
        }
    };
    RowComp.prototype.setupRowContainers = function () {
        var isFullWidthCellFunc = this.beans.gridOptionsWrapper.getIsFullWidthCellFunc();
        var isFullWidthCell = isFullWidthCellFunc ? isFullWidthCellFunc(this.rowNode) : false;
        var isDetailCell = this.beans.doingMasterDetail && this.rowNode.detail;
        var isGroupSpanningRow = this.rowNode.group && this.beans.gridOptionsWrapper.isGroupUseEntireRow();
        if (this.rowNode.stub) {
            this.createFullWidthRows(RowComp.LOADING_CELL_RENDERER, RowComp.LOADING_CELL_RENDERER_COMP_NAME);
        }
        else if (isDetailCell) {
            this.createFullWidthRows(RowComp.DETAIL_CELL_RENDERER, RowComp.DETAIL_CELL_RENDERER_COMP_NAME);
        }
        else if (isFullWidthCell) {
            this.createFullWidthRows(RowComp.FULL_WIDTH_CELL_RENDERER, null);
        }
        else if (isGroupSpanningRow) {
            this.createFullWidthRows(RowComp.GROUP_ROW_RENDERER, RowComp.GROUP_ROW_RENDERER_COMP_NAME);
        }
        else {
            this.setupNormalRowContainers();
        }
    };
    RowComp.prototype.setupNormalRowContainers = function () {
        var _this = this;
        var centerCols = this.beans.columnController.getAllDisplayedCenterVirtualColumnsForRow(this.rowNode);
        this.createRowContainer(this.bodyContainerComp, centerCols, function (eRow) { return _this.eBodyRow = eRow; });
        if (!this.beans.forPrint) {
            var leftCols = this.beans.columnController.getDisplayedLeftColumnsForRow(this.rowNode);
            var rightCols = this.beans.columnController.getDisplayedRightColumnsForRow(this.rowNode);
            this.createRowContainer(this.pinnedRightContainerComp, rightCols, function (eRow) { return _this.ePinnedRightRow = eRow; });
            this.createRowContainer(this.pinnedLeftContainerComp, leftCols, function (eRow) { return _this.ePinnedLeftRow = eRow; });
        }
    };
    RowComp.prototype.createFullWidthRows = function (type, name) {
        var _this = this;
        this.fullWidthRow = true;
        this.fullWidthRowEmbedded = this.beans.gridOptionsWrapper.isEmbedFullWidthRows();
        if (this.fullWidthRowEmbedded) {
            this.createFullWidthRowContainer(this.bodyContainerComp, null, null, type, name, function (eRow) {
                _this.eFullWidthRowBody = eRow;
            }, function (cellRenderer) {
                _this.fullWidthRowComponentBody = cellRenderer;
            });
            this.createFullWidthRowContainer(this.pinnedLeftContainerComp, column_1.Column.PINNED_LEFT, 'ag-cell-last-left-pinned', type, name, function (eRow) {
                _this.eFullWidthRowLeft = eRow;
            }, function (cellRenderer) {
                _this.fullWidthRowComponentLeft = cellRenderer;
            });
            this.createFullWidthRowContainer(this.pinnedRightContainerComp, column_1.Column.PINNED_RIGHT, 'ag-cell-first-right-pinned', type, name, function (eRow) {
                _this.eFullWidthRowRight = eRow;
            }, function (cellRenderer) {
                _this.fullWidthRowComponentRight = cellRenderer;
            });
        }
        else {
            // otherwise we add to the fullWidth container as normal
            // let previousFullWidth = ensureDomOrder ? this.lastPlacedElements.eFullWidth : null;
            this.createFullWidthRowContainer(this.fullWidthContainerComp, null, null, type, name, function (eRow) {
                _this.eFullWidthRow = eRow;
                // and fake the mouse wheel for the fullWidth container
                if (!_this.beans.forPrint) {
                    _this.addMouseWheelListenerToFullWidthRow();
                }
            }, function (cellRenderer) {
                _this.fullWidthRowComponent = cellRenderer;
            });
        }
    };
    RowComp.prototype.addMouseWheelListenerToFullWidthRow = function () {
        var mouseWheelListener = this.beans.gridPanel.genericMouseWheelListener.bind(this.beans.gridPanel);
        // IE9, Chrome, Safari, Opera
        this.addDestroyableEventListener(this.eFullWidthRow, 'mousewheel', mouseWheelListener);
        // Firefox
        this.addDestroyableEventListener(this.eFullWidthRow, 'DOMMouseScroll', mouseWheelListener);
    };
    RowComp.prototype.setAnimateFlags = function (animateIn) {
        if (animateIn) {
            var oldRowTopExists = utils_1._.exists(this.rowNode.oldRowTop);
            // if the row had a previous position, we slide it in (animate row top)
            this.slideRowIn = oldRowTopExists;
            // if the row had no previous position, we fade it in (animate
            this.fadeRowIn = !oldRowTopExists;
        }
        else {
            this.slideRowIn = false;
            this.fadeRowIn = false;
        }
    };
    RowComp.prototype.isEditing = function () {
        return this.editingRow;
    };
    RowComp.prototype.stopRowEditing = function (cancel) {
        this.stopEditing(cancel);
    };
    RowComp.prototype.isFullWidth = function () {
        return this.fullWidthRow;
    };
    RowComp.prototype.addListeners = function () {
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_HEIGHT_CHANGED, this.onRowHeightChanged.bind(this));
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_ROW_SELECTED, this.onRowSelected.bind(this));
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_ROW_INDEX_CHANGED, this.onRowIndexChanged.bind(this));
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_TOP_CHANGED, this.onTopChanged.bind(this));
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_EXPANDED_CHANGED, this.onExpandedChanged.bind(this));
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_DATA_CHANGED, this.onRowNodeDataChanged.bind(this));
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_CELL_CHANGED, this.onRowNodeCellChanged.bind(this));
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_DRAGGING_CHANGED, this.onRowNodeDraggingChanged.bind(this));
        var eventService = this.beans.eventService;
        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_VIRTUAL_COLUMNS_CHANGED, this.onVirtualColumnsChanged.bind(this));
        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this));
        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_CELL_FOCUSED, this.onCellFocusChanged.bind(this));
        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this));
        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
    };
    // when grid columns change, then all cells should be cleaned out,
    // as the new columns could have same id as the previous columns and may conflict
    RowComp.prototype.onGridColumnsChanged = function () {
        var allRenderedCellIds = Object.keys(this.cellComps);
        this.removeRenderedCells(allRenderedCellIds);
    };
    RowComp.prototype.onRowNodeDataChanged = function (event) {
        // if this is an update, we want to refresh, as this will allow the user to put in a transition
        // into the cellRenderer refresh method. otherwise this might be completely new data, in which case
        // we will want to completely replace the cells
        this.forEachCellComp(function (cellComp) {
            return cellComp.refreshCell({
                suppressFlash: !event.update,
                newData: !event.update
            });
        });
        // check for selected also, as this could be after lazy loading of the row data, in which case
        // the id might of just gotten set inside the row and the row selected state may of changed
        // as a result. this is what happens when selected rows are loaded in virtual pagination.
        // - niall note - since moving to the stub component, this may no longer be true, as replacing
        // the stub component now replaces the entire row
        this.onRowSelected();
        // as data has changed, then the style and class needs to be recomputed
        this.postProcessCss();
    };
    RowComp.prototype.onRowNodeCellChanged = function (event) {
        // as data has changed, then the style and class needs to be recomputed
        this.postProcessCss();
    };
    RowComp.prototype.postProcessCss = function () {
        this.postProcessStylesFromGridOptions();
        this.postProcessClassesFromGridOptions();
        this.postProcessRowClassRules();
        this.postProcessRowDragging();
    };
    RowComp.prototype.onRowNodeDraggingChanged = function () {
        this.postProcessRowDragging();
    };
    RowComp.prototype.postProcessRowDragging = function () {
        var dragging = this.rowNode.dragging;
        this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-dragging', dragging); });
    };
    RowComp.prototype.onExpandedChanged = function () {
        if (this.rowNode.group && !this.rowNode.footer) {
            var expanded_1 = this.rowNode.expanded;
            this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-group-expanded', expanded_1); });
            this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-group-contracted', !expanded_1); });
        }
    };
    RowComp.prototype.onDisplayedColumnsChanged = function () {
        if (!this.fullWidthRow) {
            this.refreshCells();
        }
    };
    RowComp.prototype.destroyFullWidthComponents = function () {
        if (this.fullWidthRowComponent) {
            if (this.fullWidthRowComponent.destroy) {
                this.fullWidthRowComponent.destroy();
            }
            this.fullWidthRowComponent = null;
        }
        if (this.fullWidthRowComponentBody) {
            if (this.fullWidthRowComponentBody.destroy) {
                this.fullWidthRowComponentBody.destroy();
            }
            this.fullWidthRowComponent = null;
        }
        if (this.fullWidthRowComponentLeft) {
            if (this.fullWidthRowComponentLeft.destroy) {
                this.fullWidthRowComponentLeft.destroy();
            }
            this.fullWidthRowComponentLeft = null;
        }
        if (this.fullWidthRowComponentRight) {
            if (this.fullWidthRowComponentRight.destroy) {
                this.fullWidthRowComponentRight.destroy();
            }
            this.fullWidthRowComponent = null;
        }
    };
    RowComp.prototype.getContainerForCell = function (pinnedType) {
        switch (pinnedType) {
            case column_1.Column.PINNED_LEFT: return this.ePinnedLeftRow;
            case column_1.Column.PINNED_RIGHT: return this.ePinnedRightRow;
            default: return this.eBodyRow;
        }
    };
    RowComp.prototype.onVirtualColumnsChanged = function () {
        if (!this.fullWidthRow) {
            this.refreshCells();
        }
    };
    RowComp.prototype.onColumnResized = function () {
        if (!this.fullWidthRow) {
            this.refreshCells();
        }
    };
    RowComp.prototype.refreshCells = function () {
        if (this.beans.gridOptionsWrapper.isSuppressAnimationFrame()) {
            this.refreshCellsInAnimationFrame();
        }
        else {
            if (this.columnRefreshPending) {
                return;
            }
            this.beans.taskQueue.addP1Task(this.refreshCellsInAnimationFrame.bind(this));
        }
    };
    RowComp.prototype.refreshCellsInAnimationFrame = function () {
        if (!this.active) {
            return;
        }
        this.columnRefreshPending = false;
        var centerCols = this.beans.columnController.getAllDisplayedCenterVirtualColumnsForRow(this.rowNode);
        var leftCols = this.beans.columnController.getDisplayedLeftColumnsForRow(this.rowNode);
        var rightCols = this.beans.columnController.getDisplayedRightColumnsForRow(this.rowNode);
        this.insertCellsIntoContainer(this.eBodyRow, centerCols);
        this.insertCellsIntoContainer(this.ePinnedLeftRow, leftCols);
        this.insertCellsIntoContainer(this.ePinnedRightRow, rightCols);
        var colIdsToRemove = Object.keys(this.cellComps);
        centerCols.forEach(function (col) { return utils_1._.removeFromArray(colIdsToRemove, col.getId()); });
        leftCols.forEach(function (col) { return utils_1._.removeFromArray(colIdsToRemove, col.getId()); });
        rightCols.forEach(function (col) { return utils_1._.removeFromArray(colIdsToRemove, col.getId()); });
        // we never remove editing cells, as this would cause the cells to loose their values while editing
        // as the grid is scrolling horizontally.
        colIdsToRemove = utils_1._.filter(colIdsToRemove, this.isCellEligibleToBeRemoved.bind(this));
        // remove old cells from gui, but we don't destroy them, we might use them again
        this.removeRenderedCells(colIdsToRemove);
    };
    RowComp.prototype.removeRenderedCells = function (colIds) {
        var _this = this;
        colIds.forEach(function (key) {
            var cellComp = _this.cellComps[key];
            // could be old reference, ie removed cell
            if (utils_1._.missing(cellComp)) {
                return;
            }
            cellComp.detach();
            cellComp.destroy();
            _this.cellComps[key] = null;
        });
    };
    RowComp.prototype.isCellEligibleToBeRemoved = function (indexStr) {
        var displayedColumns = this.beans.columnController.getAllDisplayedColumns();
        var REMOVE_CELL = true;
        var KEEP_CELL = false;
        var renderedCell = this.cellComps[indexStr];
        if (!renderedCell) {
            return REMOVE_CELL;
        }
        // always remove the cell if it's in the wrong pinned location
        if (this.isCellInWrongRow(renderedCell)) {
            return REMOVE_CELL;
        }
        // we want to try and keep editing and focused cells
        var editing = renderedCell.isEditing();
        var focused = this.beans.focusedCellController.isCellFocused(renderedCell.getGridCell());
        var mightWantToKeepCell = editing || focused;
        if (mightWantToKeepCell) {
            var column = renderedCell.getColumn();
            var cellStillDisplayed = displayedColumns.indexOf(column) >= 0;
            return cellStillDisplayed ? KEEP_CELL : REMOVE_CELL;
        }
        else {
            return REMOVE_CELL;
        }
    };
    RowComp.prototype.ensureCellInCorrectContainer = function (cellComp) {
        var element = cellComp.getGui();
        var column = cellComp.getColumn();
        var pinnedType = column.getPinned();
        var eContainer = this.getContainerForCell(pinnedType);
        // if in wrong container, remove it
        var eOldContainer = cellComp.getParentRow();
        var inWrongRow = eOldContainer !== eContainer;
        if (inWrongRow) {
            // take out from old row
            if (eOldContainer) {
                eOldContainer.removeChild(element);
            }
            eContainer.appendChild(element);
            cellComp.setParentRow(eContainer);
        }
    };
    RowComp.prototype.isCellInWrongRow = function (cellComp) {
        var column = cellComp.getColumn();
        var rowWeWant = this.getContainerForCell(column.getPinned());
        // if in wrong container, remove it
        var oldRow = cellComp.getParentRow();
        return oldRow !== rowWeWant;
    };
    RowComp.prototype.insertCellsIntoContainer = function (eRow, cols) {
        var _this = this;
        if (!eRow) {
            return;
        }
        var cellTemplates = [];
        var newCellComps = [];
        cols.forEach(function (col) {
            var colId = col.getId();
            var oldCell = _this.cellComps[colId];
            if (oldCell) {
                _this.ensureCellInCorrectContainer(oldCell);
            }
            else {
                _this.createNewCell(col, eRow, cellTemplates, newCellComps);
            }
        });
        if (cellTemplates.length > 0) {
            utils_1._.appendHtml(eRow, cellTemplates.join(''));
            this.callAfterRowAttachedOnCells(newCellComps, eRow);
        }
    };
    RowComp.prototype.addDomData = function (eRowContainer) {
        var gow = this.beans.gridOptionsWrapper;
        gow.setDomData(eRowContainer, RowComp.DOM_DATA_KEY_RENDERED_ROW, this);
        this.addDestroyFunc(function () {
            gow.setDomData(eRowContainer, RowComp.DOM_DATA_KEY_RENDERED_ROW, null);
        });
    };
    RowComp.prototype.createNewCell = function (col, eContainer, cellTemplates, newCellComps) {
        var newCellComp = new cellComp_1.CellComp(this.scope, this.beans, col, this.rowNode, this);
        var cellTemplate = newCellComp.getCreateTemplate();
        cellTemplates.push(cellTemplate);
        newCellComps.push(newCellComp);
        this.cellComps[col.getId()] = newCellComp;
        newCellComp.setParentRow(eContainer);
    };
    RowComp.prototype.onMouseEvent = function (eventName, mouseEvent) {
        switch (eventName) {
            case 'dblclick':
                this.onRowDblClick(mouseEvent);
                break;
            case 'click':
                this.onRowClick(mouseEvent);
                break;
        }
    };
    RowComp.prototype.createRowEvent = function (type, domEvent) {
        return {
            type: type,
            node: this.rowNode,
            data: this.rowNode.data,
            rowIndex: this.rowNode.rowIndex,
            rowPinned: this.rowNode.rowPinned,
            context: this.beans.gridOptionsWrapper.getContext(),
            api: this.beans.gridOptionsWrapper.getApi(),
            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
            event: domEvent
        };
    };
    RowComp.prototype.createRowEventWithSource = function (type, domEvent) {
        var event = this.createRowEvent(type, domEvent);
        // when first developing this, we included the rowComp in the event.
        // this seems very weird. so when introducing the event types, i left the 'source'
        // out of the type, and just include the source in the two places where this event
        // was fired (rowClicked and rowDoubleClicked). it doesn't make sense for any
        // users to be using this, as the rowComp isn't an object we expose, so would be
        // very surprising if a user was using it.
        event.source = this;
        return event;
    };
    RowComp.prototype.onRowDblClick = function (mouseEvent) {
        if (utils_1._.isStopPropagationForAgGrid(mouseEvent)) {
            return;
        }
        var agEvent = this.createRowEventWithSource(events_1.Events.EVENT_ROW_DOUBLE_CLICKED, mouseEvent);
        this.beans.eventService.dispatchEvent(agEvent);
    };
    RowComp.prototype.onRowClick = function (mouseEvent) {
        if (utils_1._.isStopPropagationForAgGrid(mouseEvent)) {
            return;
        }
        var agEvent = this.createRowEventWithSource(events_1.Events.EVENT_ROW_CLICKED, mouseEvent);
        this.beans.eventService.dispatchEvent(agEvent);
        // ctrlKey for windows, metaKey for Apple
        var multiSelectKeyPressed = mouseEvent.ctrlKey || mouseEvent.metaKey;
        var shiftKeyPressed = mouseEvent.shiftKey;
        // we do not allow selecting groups by clicking (as the click here expands the group)
        // so return if it's a group row
        if (this.rowNode.group) {
            return;
        }
        // we also don't allow selection of pinned rows
        if (this.rowNode.rowPinned) {
            return;
        }
        // if no selection method enabled, do nothing
        if (!this.beans.gridOptionsWrapper.isRowSelection()) {
            return;
        }
        // if click selection suppressed, do nothing
        if (this.beans.gridOptionsWrapper.isSuppressRowClickSelection()) {
            return;
        }
        if (this.rowNode.isSelected()) {
            if (multiSelectKeyPressed) {
                if (this.beans.gridOptionsWrapper.isRowDeselection()) {
                    this.rowNode.setSelectedParams({ newValue: false });
                }
            }
            else {
                // selected with no multi key, must make sure anything else is unselected
                this.rowNode.setSelectedParams({ newValue: true, clearSelection: true });
            }
        }
        else {
            this.rowNode.setSelectedParams({ newValue: true, clearSelection: !multiSelectKeyPressed, rangeSelect: shiftKeyPressed });
        }
    };
    RowComp.prototype.createFullWidthRowContainer = function (rowContainerComp, pinned, extraCssClass, cellRendererType, cellRendererName, eRowCallback, cellRendererCallback) {
        var _this = this;
        var rowTemplate = this.createTemplate('', extraCssClass);
        rowContainerComp.appendRowTemplate(rowTemplate, function () {
            var eRow = rowContainerComp.getRowElement(_this.getCompId());
            var params = _this.createFullWidthParams(eRow, pinned);
            var callback = function (cellRenderer) {
                if (_this.isAlive()) {
                    var gui = cellRenderer.getGui();
                    eRow.appendChild(gui);
                    cellRendererCallback(cellRenderer);
                }
                else {
                    if (cellRenderer.destroy) {
                        cellRenderer.destroy();
                    }
                }
            };
            _this.beans.componentResolver.createAgGridComponent(null, params, cellRendererType, params, cellRendererName).then(callback);
            _this.afterRowAttached(rowContainerComp, eRow);
            eRowCallback(eRow);
            _this.angular1Compile(eRow);
        });
    };
    RowComp.prototype.angular1Compile = function (element) {
        if (this.scope) {
            this.beans.$compile(element)(this.scope);
        }
    };
    RowComp.prototype.createFullWidthParams = function (eRow, pinned) {
        var params = {
            fullWidth: true,
            data: this.rowNode.data,
            node: this.rowNode,
            value: this.rowNode.key,
            $scope: this.scope,
            rowIndex: this.rowNode.rowIndex,
            api: this.beans.gridOptionsWrapper.getApi(),
            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
            context: this.beans.gridOptionsWrapper.getContext(),
            // these need to be taken out, as part of 'afterAttached' now
            eGridCell: eRow,
            eParentOfValue: eRow,
            pinned: pinned,
            addRenderedRowListener: this.addEventListener.bind(this)
        };
        return params;
    };
    RowComp.prototype.getInitialRowClasses = function (extraCssClass) {
        var classes = [];
        if (utils_1._.exists(extraCssClass)) {
            classes.push(extraCssClass);
        }
        classes.push('ag-row');
        classes.push(this.rowFocused ? 'ag-row-focus' : 'ag-row-no-focus');
        if (this.fadeRowIn) {
            classes.push('ag-opacity-zero');
        }
        if (this.rowIsEven) {
            classes.push('ag-row-even');
        }
        else {
            classes.push('ag-row-odd');
        }
        if (this.beans.gridOptionsWrapper.isAnimateRows()) {
            classes.push('ag-row-animation');
        }
        else {
            classes.push('ag-row-no-animation');
        }
        if (this.rowNode.isSelected()) {
            classes.push('ag-row-selected');
        }
        if (this.rowNode.group) {
            classes.push('ag-row-group');
            // if a group, put the level of the group in
            classes.push('ag-row-level-' + this.rowNode.level);
            if (this.rowNode.footer) {
                classes.push('ag-row-footer');
            }
        }
        else {
            // if a leaf, and a parent exists, put a level of the parent, else put level of 0 for top level item
            if (this.rowNode.parent) {
                classes.push('ag-row-level-' + (this.rowNode.parent.level + 1));
            }
            else {
                classes.push('ag-row-level-0');
            }
        }
        if (this.rowNode.stub) {
            classes.push('ag-row-stub');
        }
        if (this.fullWidthRow) {
            classes.push('ag-full-width-row');
        }
        if (this.rowNode.group && !this.rowNode.footer) {
            classes.push(this.rowNode.expanded ? 'ag-row-group-expanded' : 'ag-row-group-contracted');
        }
        if (this.rowNode.dragging) {
            classes.push('ag-row-dragging');
        }
        utils_1._.pushAll(classes, this.processClassesFromGridOptions());
        utils_1._.pushAll(classes, this.preProcessRowClassRules());
        return classes;
    };
    RowComp.prototype.preProcessRowClassRules = function () {
        var res = [];
        this.processRowClassRules(function (className) {
            res.push(className);
        }, function (className) {
            // not catered for, if creating, no need
            // to remove class as it was never there
        });
        return res;
    };
    RowComp.prototype.processRowClassRules = function (onApplicableClass, onNotApplicableClass) {
        this.beans.stylingService.processClassRules(this.beans.gridOptionsWrapper.rowClassRules(), {
            value: undefined,
            colDef: undefined,
            data: this.rowNode.data,
            node: this.rowNode,
            rowIndex: this.rowNode.rowIndex,
            api: this.beans.gridOptionsWrapper.getApi(),
            $scope: this.scope,
            context: this.beans.gridOptionsWrapper.getContext()
        }, onApplicableClass, onNotApplicableClass);
    };
    RowComp.prototype.stopEditing = function (cancel) {
        if (cancel === void 0) { cancel = false; }
        this.forEachCellComp(function (renderedCell) {
            renderedCell.stopEditing(cancel);
        });
        if (this.editingRow) {
            if (!cancel) {
                var event_1 = this.createRowEvent(events_1.Events.EVENT_ROW_VALUE_CHANGED);
                this.beans.eventService.dispatchEvent(event_1);
            }
            this.setEditingRow(false);
        }
    };
    RowComp.prototype.setEditingRow = function (value) {
        this.editingRow = value;
        this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-editing', value); });
        var event = value ?
            this.createRowEvent(events_1.Events.EVENT_ROW_EDITING_STARTED)
            : this.createRowEvent(events_1.Events.EVENT_ROW_EDITING_STOPPED);
        this.beans.eventService.dispatchEvent(event);
    };
    RowComp.prototype.startRowEditing = function (keyPress, charPress, sourceRenderedCell) {
        if (keyPress === void 0) { keyPress = null; }
        if (charPress === void 0) { charPress = null; }
        if (sourceRenderedCell === void 0) { sourceRenderedCell = null; }
        // don't do it if already editing
        if (this.editingRow) {
            return;
        }
        this.forEachCellComp(function (renderedCell) {
            var cellStartedEdit = renderedCell === sourceRenderedCell;
            if (cellStartedEdit) {
                renderedCell.startEditingIfEnabled(keyPress, charPress, cellStartedEdit);
            }
            else {
                renderedCell.startEditingIfEnabled(null, null, cellStartedEdit);
            }
        });
        this.setEditingRow(true);
    };
    RowComp.prototype.forEachCellComp = function (callback) {
        utils_1._.iterateObject(this.cellComps, function (key, cellComp) {
            if (cellComp) {
                callback(cellComp);
            }
        });
    };
    RowComp.prototype.postProcessClassesFromGridOptions = function () {
        var _this = this;
        var cssClasses = this.processClassesFromGridOptions();
        if (cssClasses) {
            cssClasses.forEach(function (classStr) {
                _this.eAllRowContainers.forEach(function (row) { return utils_1._.addCssClass(row, classStr); });
            });
        }
    };
    RowComp.prototype.postProcessRowClassRules = function () {
        var _this = this;
        this.processRowClassRules(function (className) {
            _this.eAllRowContainers.forEach(function (row) { return utils_1._.addCssClass(row, className); });
        }, function (className) {
            _this.eAllRowContainers.forEach(function (row) { return utils_1._.removeCssClass(row, className); });
        });
    };
    RowComp.prototype.processClassesFromGridOptions = function () {
        var res = [];
        var process = function (rowClass) {
            if (typeof rowClass === 'string') {
                res.push(rowClass);
            }
            else if (Array.isArray(rowClass)) {
                rowClass.forEach(function (e) { return res.push(e); });
            }
        };
        // part 1 - rowClass
        var rowClass = this.beans.gridOptionsWrapper.getRowClass();
        if (rowClass) {
            if (typeof rowClass === 'function') {
                console.warn('ag-Grid: rowClass should not be a function, please use getRowClass instead');
                return;
            }
            process(rowClass);
        }
        // part 2 - rowClassFunc
        var rowClassFunc = this.beans.gridOptionsWrapper.getRowClassFunc();
        if (rowClassFunc) {
            var params = {
                node: this.rowNode,
                data: this.rowNode.data,
                rowIndex: this.rowNode.rowIndex,
                context: this.beans.gridOptionsWrapper.getContext(),
                api: this.beans.gridOptionsWrapper.getApi()
            };
            var rowClassFuncResult = rowClassFunc(params);
            process(rowClassFuncResult);
        }
        return res;
    };
    RowComp.prototype.preProcessStylesFromGridOptions = function () {
        var rowStyles = this.processStylesFromGridOptions();
        return utils_1._.cssStyleObjectToMarkup(rowStyles);
    };
    RowComp.prototype.postProcessStylesFromGridOptions = function () {
        var rowStyles = this.processStylesFromGridOptions();
        this.eAllRowContainers.forEach(function (row) { return utils_1._.addStylesToElement(row, rowStyles); });
    };
    RowComp.prototype.processStylesFromGridOptions = function () {
        // part 1 - rowStyle
        var rowStyle = this.beans.gridOptionsWrapper.getRowStyle();
        if (rowStyle && typeof rowStyle === 'function') {
            console.log('ag-Grid: rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead');
            return;
        }
        // part 1 - rowStyleFunc
        var rowStyleFunc = this.beans.gridOptionsWrapper.getRowStyleFunc();
        var rowStyleFuncResult;
        if (rowStyleFunc) {
            var params = {
                data: this.rowNode.data,
                node: this.rowNode,
                api: this.beans.gridOptionsWrapper.getApi(),
                context: this.beans.gridOptionsWrapper.getContext(),
                $scope: this.scope
            };
            rowStyleFuncResult = rowStyleFunc(params);
        }
        return utils_1._.assign({}, rowStyle, rowStyleFuncResult);
    };
    RowComp.prototype.createCells = function (cols) {
        var _this = this;
        var templateParts = [];
        var newCellComps = [];
        cols.forEach(function (col) {
            var newCellComp = new cellComp_1.CellComp(_this.scope, _this.beans, col, _this.rowNode, _this);
            var cellTemplate = newCellComp.getCreateTemplate();
            templateParts.push(cellTemplate);
            newCellComps.push(newCellComp);
            _this.cellComps[col.getId()] = newCellComp;
        });
        var templateAndComps = {
            template: templateParts.join(''),
            cellComps: newCellComps
        };
        return templateAndComps;
    };
    RowComp.prototype.onRowSelected = function () {
        var selected = this.rowNode.isSelected();
        this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-selected', selected); });
    };
    // called:
    // + after row created for first time
    // + after horizontal scroll, so new cells due to column virtualisation
    RowComp.prototype.callAfterRowAttachedOnCells = function (newCellComps, eRow) {
        var _this = this;
        newCellComps.forEach(function (cellComp) {
            cellComp.setParentRow(eRow);
            cellComp.afterAttached();
            // if we are editing the row, then the cell needs to turn
            // into edit mode
            if (_this.editingRow) {
                cellComp.startEditingIfEnabled();
            }
        });
    };
    RowComp.prototype.afterRowAttached = function (rowContainerComp, eRow) {
        var _this = this;
        this.addDomData(eRow);
        this.removeSecondPassFuncs.push(function () {
            // console.log(eRow);
            rowContainerComp.removeRowElement(eRow);
        });
        this.removeFirstPassFuncs.push(function () {
            if (utils_1._.exists(_this.rowNode.rowTop)) {
                // the row top is updated anyway, however we set it here again
                // to something more reasonable for the animation - ie if the
                // row top is 10000px away, the row will flash out, so this
                // gives it a rounded value, so row animates out more slowly
                var rowTop = _this.roundRowTopToBounds(_this.rowNode.rowTop);
                _this.setRowTop(rowTop);
            }
            else {
                utils_1._.addCssClass(eRow, 'ag-opacity-zero');
            }
        });
        this.eAllRowContainers.push(eRow);
        // adding hover functionality adds listener to this row, so we
        // do it lazily in an animation frame
        if (this.useAnimationFrameForCreate) {
            this.beans.taskQueue.addP1Task(this.addHoverFunctionality.bind(this, eRow));
        }
        else {
            this.addHoverFunctionality(eRow);
        }
    };
    RowComp.prototype.addHoverFunctionality = function (eRow) {
        var _this = this;
        // because we use animation frames to do this, it's possible the row no longer exists
        // by the time we get to add it
        if (!this.active) {
            return;
        }
        // because mouseenter and mouseleave do not propagate, we cannot listen on the gridPanel
        // like we do for all the other mouse events.
        // because of the pinning, we cannot simply add / remove the class based on the eRow. we
        // have to check all eRow's (body & pinned). so the trick is if any of the rows gets a
        // mouse hover, it sets such in the rowNode, and then all three reflect the change as
        // all are listening for event on the row node.
        // step 1 - add listener, to set flag on row node
        this.addDestroyableEventListener(eRow, 'mouseenter', function () { return _this.rowNode.onMouseEnter(); });
        this.addDestroyableEventListener(eRow, 'mouseleave', function () { return _this.rowNode.onMouseLeave(); });
        // step 2 - listen for changes on row node (which any eRow can trigger)
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_MOUSE_ENTER, function () {
            utils_1._.addCssClass(eRow, 'ag-row-hover');
        });
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_MOUSE_LEAVE, function () {
            utils_1._.removeCssClass(eRow, 'ag-row-hover');
        });
    };
    // for animation, we don't want to animate entry or exit to a very far away pixel,
    // otherwise the row would move so fast, it would appear to disappear. so this method
    // moves the row closer to the viewport if it is far away, so the row slide in / out
    // at a speed the user can see.
    RowComp.prototype.roundRowTopToBounds = function (rowTop) {
        var range = this.beans.gridPanel.getVerticalPixelRange();
        var minPixel = this.applyPaginationOffset(range.top, true) - 100;
        var maxPixel = this.applyPaginationOffset(range.bottom, true) + 100;
        if (rowTop < minPixel) {
            return minPixel;
        }
        else if (rowTop > maxPixel) {
            return maxPixel;
        }
        else {
            return rowTop;
        }
    };
    RowComp.prototype.onRowHeightChanged = function () {
        // check for exists first - if the user is resetting the row height, then
        // it will be null (or undefined) momentarily until the next time the flatten
        // stage is called where the row will then update again with a new height
        if (utils_1._.exists(this.rowNode.rowHeight)) {
            var heightPx_1 = this.rowNode.rowHeight + 'px';
            this.eAllRowContainers.forEach(function (row) { return row.style.height = heightPx_1; });
        }
    };
    RowComp.prototype.addEventListener = function (eventType, listener) {
        if (eventType === 'renderedRowRemoved' || eventType === 'rowRemoved') {
            eventType = events_1.Events.EVENT_VIRTUAL_ROW_REMOVED;
            console.warn('ag-Grid: Since version 11, event renderedRowRemoved is now called ' + events_1.Events.EVENT_VIRTUAL_ROW_REMOVED);
        }
        _super.prototype.addEventListener.call(this, eventType, listener);
    };
    RowComp.prototype.removeEventListener = function (eventType, listener) {
        if (eventType === 'renderedRowRemoved' || eventType === 'rowRemoved') {
            eventType = events_1.Events.EVENT_VIRTUAL_ROW_REMOVED;
            console.warn('ag-Grid: Since version 11, event renderedRowRemoved and rowRemoved is now called ' + events_1.Events.EVENT_VIRTUAL_ROW_REMOVED);
        }
        _super.prototype.removeEventListener.call(this, eventType, listener);
    };
    RowComp.prototype.destroyScope = function () {
        if (this.scope) {
            this.scope.$destroy();
            this.scope = null;
        }
    };
    RowComp.prototype.destroy = function (animate) {
        if (animate === void 0) { animate = false; }
        _super.prototype.destroy.call(this);
        this.destroyScope();
        this.active = false;
        // why do we have this method? shouldn't everything below be added as a destroy func beside
        // the corresponding create logic?
        this.destroyFullWidthComponents();
        if (animate) {
            this.removeFirstPassFuncs.forEach(function (func) { return func(); });
            this.removeSecondPassFuncs.push(this.destroyContainingCells.bind(this));
        }
        else {
            this.destroyContainingCells();
            // we are not animating, so execute the second stage of removal now.
            // we call getAndClear, so that they are only called once
            var delayedDestroyFunctions = this.getAndClearDelayedDestroyFunctions();
            delayedDestroyFunctions.forEach(function (func) { return func(); });
        }
        var event = this.createRowEvent(events_1.Events.EVENT_VIRTUAL_ROW_REMOVED);
        this.dispatchEvent(event);
        this.beans.eventService.dispatchEvent(event);
    };
    RowComp.prototype.destroyContainingCells = function () {
        this.forEachCellComp(function (renderedCell) { return renderedCell.destroy(); });
        this.destroyFullWidthComponents();
    };
    // we clear so that the functions are never executed twice
    RowComp.prototype.getAndClearDelayedDestroyFunctions = function () {
        var result = this.removeSecondPassFuncs;
        this.removeSecondPassFuncs = [];
        return result;
    };
    RowComp.prototype.onCellFocusChanged = function () {
        var rowFocused = this.beans.focusedCellController.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
        if (rowFocused !== this.rowFocused) {
            this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-focus', rowFocused); });
            this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-no-focus', !rowFocused); });
            this.rowFocused = rowFocused;
        }
        // if we are editing, then moving the focus out of a row will stop editing
        if (!rowFocused && this.editingRow) {
            this.stopEditing(false);
        }
    };
    RowComp.prototype.onPaginationChanged = function () {
        var currentPage = this.beans.paginationProxy.getCurrentPage();
        // it is possible this row is in the new page, but the page number has changed, which means
        // it needs to reposition itself relative to the new page
        if (this.paginationPage !== currentPage) {
            this.paginationPage = currentPage;
            this.onTopChanged();
        }
    };
    RowComp.prototype.onTopChanged = function () {
        // top is not used in forPrint, as the rows are just laid out naturally
        var doNotSetRowTop = this.beans.forPrint || this.beans.gridOptionsWrapper.isAutoHeight();
        if (doNotSetRowTop) {
            return;
        }
        this.setRowTop(this.rowNode.rowTop);
    };
    // applies pagination offset, eg if on second page, and page height is 500px, then removes
    // 500px from the top position, so a row with rowTop 600px is displayed at location 100px.
    // reverse will take the offset away rather than add.
    RowComp.prototype.applyPaginationOffset = function (topPx, reverse) {
        if (reverse === void 0) { reverse = false; }
        if (this.rowNode.isRowPinned()) {
            return topPx;
        }
        else {
            var pixelOffset = this.beans.paginationProxy.getPixelOffset();
            if (reverse) {
                return topPx + pixelOffset;
            }
            else {
                return topPx - pixelOffset;
            }
        }
    };
    RowComp.prototype.setRowTop = function (pixels) {
        // need to make sure rowTop is not null, as this can happen if the node was once
        // visible (ie parent group was expanded) but is now not visible
        if (utils_1._.exists(pixels)) {
            var pixelsWithOffset = this.applyPaginationOffset(pixels);
            var topPx_1 = pixelsWithOffset + "px";
            this.eAllRowContainers.forEach(function (row) { return row.style.top = topPx_1; });
        }
    };
    // we clear so that the functions are never executed twice
    RowComp.prototype.getAndClearNextVMTurnFunctions = function () {
        var result = this.createSecondPassFuncs;
        this.createSecondPassFuncs = [];
        return result;
    };
    RowComp.prototype.getRowNode = function () {
        return this.rowNode;
    };
    RowComp.prototype.getRenderedCellForColumn = function (column) {
        return this.cellComps[column.getColId()];
    };
    RowComp.prototype.onRowIndexChanged = function () {
        this.onCellFocusChanged();
        this.updateRowIndexes();
    };
    RowComp.prototype.updateRowIndexes = function () {
        var rowIndexStr = this.rowNode.getRowIndexString();
        var rowIsEven = this.rowNode.rowIndex % 2 === 0;
        var rowIsEvenChanged = this.rowIsEven !== rowIsEven;
        if (rowIsEvenChanged) {
            this.rowIsEven = rowIsEven;
        }
        this.eAllRowContainers.forEach(function (eRow) {
            eRow.setAttribute('row-index', rowIndexStr);
            if (rowIsEvenChanged) {
                utils_1._.addOrRemoveCssClass(eRow, 'ag-row-even', rowIsEven);
                utils_1._.addOrRemoveCssClass(eRow, 'ag-row-odd', !rowIsEven);
            }
        });
    };
    RowComp.prototype.ensureDomOrder = function () {
        var body = this.getBodyRowElement();
        if (body) {
            this.bodyContainerComp.ensureDomOrder(body);
        }
        var left = this.getPinnedLeftRowElement();
        if (left) {
            this.pinnedLeftContainerComp.ensureDomOrder(left);
        }
        var right = this.getPinnedRightRowElement();
        if (right) {
            this.pinnedRightContainerComp.ensureDomOrder(right);
        }
        var fullWidth = this.getFullWidthRowElement();
        if (fullWidth) {
            this.fullWidthContainerComp.ensureDomOrder(fullWidth);
        }
    };
    // returns the pinned left container, either the normal one, or the embedded full with one if exists
    RowComp.prototype.getPinnedLeftRowElement = function () {
        return this.ePinnedLeftRow ? this.ePinnedLeftRow : this.eFullWidthRowLeft;
    };
    // returns the pinned right container, either the normal one, or the embedded full with one if exists
    RowComp.prototype.getPinnedRightRowElement = function () {
        return this.ePinnedRightRow ? this.ePinnedRightRow : this.eFullWidthRowRight;
    };
    // returns the body container, either the normal one, or the embedded full with one if exists
    RowComp.prototype.getBodyRowElement = function () {
        return this.eBodyRow ? this.eBodyRow : this.eFullWidthRowBody;
    };
    // returns the full width container
    RowComp.prototype.getFullWidthRowElement = function () {
        return this.eFullWidthRow;
    };
    RowComp.DOM_DATA_KEY_RENDERED_ROW = 'renderedRow';
    RowComp.FULL_WIDTH_CELL_RENDERER = 'fullWidthCellRenderer';
    RowComp.GROUP_ROW_RENDERER = 'groupRowRenderer';
    RowComp.GROUP_ROW_RENDERER_COMP_NAME = 'agGroupRowRenderer';
    RowComp.LOADING_CELL_RENDERER = 'loadingCellRenderer';
    RowComp.LOADING_CELL_RENDERER_COMP_NAME = 'agLoadingCellRenderer';
    RowComp.DETAIL_CELL_RENDERER = 'detailCellRenderer';
    RowComp.DETAIL_CELL_RENDERER_COMP_NAME = 'agDetailCellRenderer';
    return RowComp;
}(component_1.Component));
exports.RowComp = RowComp;


/***/ }),

/***/ "cmba":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(957);
	module.exports = __webpack_require__(957);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(958) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($) {

	    // Imports ================================================================
	    var kendo = window.kendo,
	        Class = kendo.Class,
	        editorNS = kendo.ui.editor,
	        dom = editorNS.Dom,
	        RestorePoint = editorNS.RestorePoint,
	        Marker = editorNS.Marker,
	        extend = $.extend;

	function finishUpdate(editor, startRestorePoint) {
	    var endRestorePoint = editor.selectionRestorePoint = new RestorePoint(editor.getRange(), editor.body);
	    var command = new GenericCommand(startRestorePoint, endRestorePoint);
	    command.editor = editor;

	    editor.undoRedoStack.push(command);

	    return endRestorePoint;
	}

	var Command = Class.extend({
	    init: function(options) {
	        this.options = options;
	        this.restorePoint = new RestorePoint(options.range, options.body, {immutables: options.immutables});
	        this.marker = new Marker();
	        this.formatter = options.formatter;
	    },

	    getRange: function () {
	        return this.restorePoint.toRange();
	    },

	    lockRange: function (expand) {
	        return this.marker.add(this.getRange(), expand);
	    },

	    releaseRange: function (range) {
	        this.marker.remove(range);
	        this.editor.selectRange(range);
	    },

	    undo: function () {
	        var point = this.restorePoint;
	        point.restoreHtml();
	        this.editor.selectRange(point.toRange());
	    },

	    redo: function () {
	        this.exec();
	    },

	    createDialog: function (content, options) {
	        var editor = this.editor;

	        return $(content).appendTo(document.body)
	            .kendoWindow(extend({}, editor.options.dialogOptions, options))
	            .closest(".k-window").toggleClass("k-rtl", kendo.support.isRtl(editor.wrapper)).end();
	    },

	    exec: function () {
	        var range = this.lockRange(true);
	        this.formatter.editor = this.editor;
	        this.formatter.toggle(range);
	        this.releaseRange(range);
	    },

	    immutables: function(){
	        return this.editor && this.editor.options.immutables;
	    },

	    expandImmutablesIn: function(range) {
	        if (this.immutables()) {
	            kendo.ui.editor.Immutables.expandImmutablesIn(range);
	            this.restorePoint = new RestorePoint(range, this.editor.body);
	        }
	    }
	});

	var GenericCommand = Class.extend({
	    init: function(startRestorePoint, endRestorePoint) {
	        this.body = startRestorePoint.body;
	        this.startRestorePoint = startRestorePoint;
	        this.endRestorePoint = endRestorePoint;
	    },

	    redo: function () {
	        dom.removeChildren(this.body);

	        this.body.innerHTML = this.endRestorePoint.html;
	        this.editor.selectRange(this.endRestorePoint.toRange());
	    },

	    undo: function () {
	        dom.removeChildren(this.body);

	        this.body.innerHTML = this.startRestorePoint.html;
	        this.editor.selectRange(this.startRestorePoint.toRange());
	    }
	});

	extend(editorNS, {
	    _finishUpdate: finishUpdate,
	    Command: Command,
	    GenericCommand: GenericCommand
	});

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 958:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("xW2y");

/***/ })

/******/ });

/***/ }),

/***/ "cvpo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var SetFilterListItem = (function (_super) {
    __extends(SetFilterListItem, _super);
    function SetFilterListItem(value, column) {
        var _this = _super.call(this, SetFilterListItem.TEMPLATE) || this;
        _this.selected = true;
        _this.value = value;
        _this.column = column;
        return _this;
    }
    SetFilterListItem.prototype.init = function () {
        var _this = this;
        this.eCheckedIcon = main_1._.createIconNoSpan('checkboxChecked', this.gridOptionsWrapper, this.column);
        this.eUncheckedIcon = main_1._.createIconNoSpan('checkboxUnchecked', this.gridOptionsWrapper, this.column);
        this.eCheckbox = this.queryForHtmlElement(".ag-filter-checkbox");
        this.eClickableArea = this.getGui();
        this.updateCheckboxIcon();
        this.render();
        var listener = function (mouseEvent) {
            main_1._.addAgGridEventPath(mouseEvent);
            _this.selected = !_this.selected;
            _this.updateCheckboxIcon();
            var event = {
                type: SetFilterListItem.EVENT_SELECTED
            };
            return _this.dispatchEvent(event);
        };
        this.addDestroyableEventListener(this.eClickableArea, 'click', listener);
    };
    SetFilterListItem.prototype.isSelected = function () {
        return this.selected;
    };
    SetFilterListItem.prototype.setSelected = function (selected) {
        this.selected = selected;
        this.updateCheckboxIcon();
    };
    SetFilterListItem.prototype.updateCheckboxIcon = function () {
        if (this.eCheckbox.children) {
            for (var i = 0; i < this.eCheckbox.children.length; i++) {
                this.eCheckbox.removeChild(this.eCheckbox.children.item(i));
            }
        }
        if (this.isSelected()) {
            this.eCheckbox.appendChild(this.eCheckedIcon);
        }
        else {
            this.eCheckbox.appendChild(this.eUncheckedIcon);
        }
    };
    SetFilterListItem.prototype.render = function () {
        var _this = this;
        var valueElement = this.queryForHtmlElement(".ag-filter-value");
        var valueFormatted = this.valueFormatterService.formatValue(this.column, null, null, this.value);
        var colDef = this.column.getColDef();
        var valueObj = { value: this.value, valueFormatted: valueFormatted };
        var componentPromise = this.cellRendererService.useFilterCellRenderer(colDef, valueElement, valueObj);
        if (!componentPromise)
            return;
        componentPromise.then(function (component) {
            if (component && component.destroy) {
                _this.addDestroyFunc(component.destroy.bind(component));
            }
        });
    };
    SetFilterListItem.EVENT_SELECTED = 'selected';
    SetFilterListItem.TEMPLATE = '<label class="ag-set-filter-item">' +
        '<div class="ag-filter-checkbox"></div>' +
        '<span class="ag-filter-value"></span>' +
        '</label>';
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], SetFilterListItem.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        main_1.Autowired('cellRendererService'),
        __metadata("design:type", main_1.CellRendererService)
    ], SetFilterListItem.prototype, "cellRendererService", void 0);
    __decorate([
        main_1.Autowired('valueFormatterService'),
        __metadata("design:type", main_1.ValueFormatterService)
    ], SetFilterListItem.prototype, "valueFormatterService", void 0);
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SetFilterListItem.prototype, "init", null);
    return SetFilterListItem;
}(main_1.Component));
exports.SetFilterListItem = SetFilterListItem;


/***/ }),

/***/ "dB3r":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1622);
	module.exports = __webpack_require__(1622);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1578:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("I2Wh");

/***/ }),

/***/ 1622:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// -*- fill-column: 100 -*-

	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1578) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	    "use strict";

	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    // WARNING: removing the following jshint declaration and turning
	    // == into === to make JSHint happy will break functionality.
	    /* jshint eqnull:true, newcap:false, laxbreak:true, validthis:true */
	    /* jshint latedef: nofunc */

	    var spreadsheet = kendo.spreadsheet;
	    var calc = spreadsheet.calc;
	    var runtime = calc.runtime;
	    var defineFunction = runtime.defineFunction;
	    var CalcError = runtime.CalcError;
	    var packDate = runtime.packDate;
	    var unpackDate = runtime.unpackDate;
	    var isLeapYear = runtime.isLeapYear;
	    var daysInMonth = runtime.daysInMonth;
	    var _days_360 = runtime._days_360;

	    /* -----[ Spreadsheet API ]----- */

	    defineFunction("ERF", function(ll, ul) {
	        if (ul == null) {
	            return ERF(ll);
	        }
	        return ERF(ul) - ERF(ll);
	    }).args([
	        [ "lower_limit", "number" ],
	        [ "upper_limit", [ "or", "number", "null" ] ]
	    ]);

	    defineFunction("ERFC", ERFC).args([
	        [ "x", "number" ]
	    ]);

	    defineFunction("GAMMALN", GAMMALN).args([
	        [ "x", "number++" ]
	    ]);

	    defineFunction("GAMMA", GAMMA).args([
	        [ "x", "number" ]
	    ]);

	    defineFunction("GAMMA.DIST", GAMMA_DIST).args([
	        [ "x", "number+" ],
	        [ "alpha", "number++" ],
	        [ "beta", "number++" ],
	        [ "cumulative", "logical" ]
	    ]);

	    defineFunction("GAMMA.INV", GAMMA_INV).args([
	        [ "p", [ "and", "number", [ "[between]", 0, 1 ] ] ],
	        [ "alpha", "number++" ],
	        [ "beta", "number++" ]
	    ]);

	    defineFunction("NORM.S.DIST", NORM_S_DIST).args([
	        [ "z", "number" ],
	        [ "cumulative", "logical" ]
	    ]);

	    defineFunction("NORM.S.INV", NORM_S_INV).args([
	        [ "p", [ "and", "number", [ "[between]", 0, 1 ] ] ]
	    ]);

	    defineFunction("NORM.DIST", NORM_DIST).args([
	        [ "x", "number" ],
	        [ "mean", "number" ],
	        [ "stddev", "number++" ],
	        [ "cumulative", "logical" ]
	    ]);

	    defineFunction("NORM.INV", NORM_INV).args([
	        [ "p", [ "and", "number", [ "[between]", 0, 1 ] ] ],
	        [ "mean", "number" ],
	        [ "stddev", "number++" ]
	    ]);

	    defineFunction("BETADIST", BETADIST).args([
	        [ "x", "number" ],
	        [ "alpha", "number++" ],
	        [ "beta", "number++" ],
	        [ "A", [ "or", "number", [ "null", 0 ] ] ],
	        [ "B", [ "or", "number", [ "null", 1 ] ] ],
	        [ "?", [ "assert", "$x >= $A", "NUM" ] ],
	        [ "?", [ "assert", "$x <= $B", "NUM" ] ],
	        [ "?", [ "assert", "$A < $B", "NUM" ] ]
	    ]);

	    defineFunction("BETA.DIST", BETA_DIST).args([
	        [ "x", "number" ],
	        [ "alpha", "number++" ],
	        [ "beta", "number++" ],
	        [ "cumulative", "logical" ],
	        [ "A", [ "or", "number", [ "null", 0 ] ] ],
	        [ "B", [ "or", "number", [ "null", 1 ] ] ],
	        [ "?", [ "assert", "$x >= $A", "NUM" ] ],
	        [ "?", [ "assert", "$x <= $B", "NUM" ] ],
	        [ "?", [ "assert", "$A < $B", "NUM" ] ]
	    ]);

	    defineFunction("BETA.INV", BETA_INV).args([
	        [ "p", [ "and", "number", [ "[between]", 0, 1 ] ] ],
	        [ "alpha", "number++" ],
	        [ "beta", "number++" ],
	        [ "A", [ "or", "number", [ "null", 0 ] ] ],
	        [ "B", [ "or", "number", [ "null", 1 ] ] ]
	    ]);

	    defineFunction("CHISQ.DIST", chisq_left).args([
	        [ "x", "number+" ],
	        [ "deg_freedom", "integer++" ],
	        [ "cumulative", "logical" ]
	    ]);

	    defineFunction("CHISQ.DIST.RT", chisq_right).args([
	        [ "x", "number+" ],
	        [ "deg_freedom", "integer++" ]
	    ]);

	    defineFunction("CHISQ.INV", chisq_left_inv).args([
	        [ "p", [ "and", "number", [ "[between]", 0, 1 ] ] ],
	        [ "deg_freedom", "integer++" ]
	    ]);

	    defineFunction("CHISQ.INV.RT", chisq_right_inv).args([
	        [ "p", [ "and", "number", [ "[between]", 0, 1 ] ] ],
	        [ "deg_freedom", "integer++" ]
	    ]);

	    defineFunction("CHISQ.TEST", function(ac, ex){
	        return chisq_test(ac.data, ex.data);
	    }).args([
	        [ "actual_range", "matrix" ],
	        [ "expected_range", "matrix" ],
	        [ "?", [ "assert", "$actual_range.width == $expected_range.width" ] ],
	        [ "?", [ "assert", "$actual_range.height == $expected_range.height" ] ]
	    ]);

	    defineFunction("EXPON.DIST", expon).args([
	        [ "x", "number+" ],
	        [ "lambda", "number++" ],
	        [ "cumulative", "logical" ]
	    ]);

	    defineFunction("POISSON.DIST", poisson).args([
	        [ "x", "integer+" ],
	        [ "mean", "number+" ],
	        [ "cumulative", "logical" ]
	    ]);

	    defineFunction("F.DIST", Fdist).args([
	        [ "x", "number+" ],
	        [ "deg_freedom1", "integer++" ],
	        [ "deg_freedom2", "integer++" ],
	        [ "cumulative", "logical" ]
	    ]);

	    defineFunction("F.DIST.RT", Fdist_right).args([
	        [ "x", "number+" ],
	        [ "deg_freedom1", "integer++" ],
	        [ "deg_freedom2", "integer++" ]
	    ]);

	    defineFunction("F.INV", Finv).args([
	        [ "p", [ "and", "number", [ "[between]", 0, 1 ] ] ],
	        [ "deg_freedom1", "integer++" ],
	        [ "deg_freedom2", "integer++" ]
	    ]);

	    defineFunction("F.INV.RT", Finv_right).args([
	        [ "p", [ "and", "number", [ "[between]", 0, 1 ] ] ],
	        [ "deg_freedom1", "integer++" ],
	        [ "deg_freedom2", "integer++" ]
	    ]);

	    defineFunction("F.TEST", Ftest).args([
	        [ "array1", [ "collect", "number", 1 ] ],
	        [ "array2", [ "collect", "number", 1 ] ],
	        [ "?", [ "assert", "$array1.length >= 2", "DIV/0" ] ],
	        [ "?", [ "assert", "$array2.length >= 2", "DIV/0" ] ]
	    ]);

	    defineFunction("FISHER", fisher).args([
	        [ "x", [ "and", "number", [ "(between)", -1, 1 ] ] ]
	    ]);

	    defineFunction("FISHERINV", fisherinv).args([
	        [ "y", "number" ]
	    ]);

	    defineFunction("T.DIST", Tdist).args([
	        [ "x", "number" ],
	        [ "deg_freedom", "integer++" ],
	        [ "cumulative", "logical" ]
	    ]);

	    defineFunction("T.DIST.RT", Tdist_right).args([
	        [ "x", "number" ],
	        [ "deg_freedom", "integer++" ]
	    ]);

	    defineFunction("T.DIST.2T", Tdist_2tail).args([
	        [ "x", "number+" ],
	        [ "deg_freedom", "integer++" ]
	    ]);

	    defineFunction("T.INV", Tdist_inv).args([
	        [ "p", [ "and", "number", [ "(between]", 0, 1 ] ] ],
	        [ "deg_freedom", "integer++" ]
	    ]);

	    defineFunction("T.INV.2T", Tdist_2tail_inv).args([
	        [ "p", [ "and", "number", [ "(between]", 0, 1 ] ] ],
	        [ "deg_freedom", "integer++" ]
	    ]);

	    defineFunction("T.TEST", Tdist_test).args([
	        [ "array1", [ "collect", "number", 1 ] ],
	        [ "array2", [ "collect", "number", 1 ] ],
	        [ "tails", [ "and", "integer", [ "values", 1, 2 ] ] ],
	        [ "type", [ "and", "integer", [ "values", 1, 2, 3 ] ] ],
	        [ "?", [ "assert", "$type != 1 || $array1.length == $array2.length", "N/A" ] ],
	        [ "?", [ "assert", "$array1.length >= 2", "DIV/0" ] ],
	        [ "?", [ "assert", "$array2.length >= 2", "DIV/0" ] ]
	    ]);

	    defineFunction("CONFIDENCE.T", confidence_t).args([
	        [ "alpha", [ "and", "number", [ "(between)", 0, 1 ] ] ],
	        [ "standard_dev", "number++" ],
	        [ "size", [ "and", "integer++",
	                    [ "assert", "$size != 1", "DIV/0" ] ] ]
	    ]);

	    defineFunction("CONFIDENCE.NORM", confidence_norm).args([
	        [ "alpha", [ "and", "number", [ "(between)", 0, 1 ] ] ],
	        [ "standard_dev", "number++" ],
	        [ "size", [ "and", "integer++" ] ]
	    ]);

	    defineFunction("GAUSS", gauss).args([
	        [ "z", "number" ]
	    ]);

	    defineFunction("PHI", phi).args([
	        [ "x", "number" ]
	    ]);

	    defineFunction("LOGNORM.DIST", lognorm_dist).args([
	        [ "x", "number++" ],
	        [ "mean", "number" ],
	        [ "standard_dev", "number++" ],
	        [ "cumulative", "logical" ]
	    ]);

	    defineFunction("LOGNORM.INV", lognorm_inv).args([
	        [ "probability", [ "and", "number", [ "(between)", 0, 1 ] ] ],
	        [ "mean", "number" ],
	        [ "standard_dev", "number++" ]
	    ]);

	    defineFunction("PROB", prob).args([
	        [ "x_range", [ "collect", "number", 1 ] ],
	        [ "prob_range", [ "collect", "number", 1 ] ],
	        [ "lower_limit", "number" ],
	        [ "upper_limit", [ "or", "number", [ "null", "$lower_limit" ] ] ],
	        [ "?", [ "assert", "$prob_range.length == $x_range.length", "N/A" ] ]
	    ]);

	    defineFunction("SLOPE", slope).args([
	        [ "known_y", [ "collect", "number", 1 ] ],
	        [ "known_x", [ "collect", "number", 1 ] ],
	        [ "?", [ "assert", "$known_x.length == $known_y.length", "N/A" ] ],
	        [ "?", [ "assert", "$known_x.length > 0 && $known_y.length > 0", "N/A" ] ]
	    ]);

	    defineFunction("INTERCEPT", intercept).args([
	        [ "known_y", [ "collect", "number", 1 ] ],
	        [ "known_x", [ "collect", "number", 1 ] ],
	        [ "?", [ "assert", "$known_x.length == $known_y.length", "N/A" ] ],
	        [ "?", [ "assert", "$known_x.length > 0 && $known_y.length > 0", "N/A" ] ]
	    ]);

	    defineFunction("PEARSON", pearson).args([
	        [ "array1", [ "collect!", "anything", 1 ] ],
	        [ "array2", [ "collect!", "anything", 1 ] ],
	        [ "?", [ "assert", "$array2.length == $array1.length", "N/A" ] ],
	        [ "?", [ "assert", "$array2.length > 0 && $array1.length > 0", "N/A" ] ]
	    ]);

	    defineFunction("RSQ", rsq).args([
	        [ "known_y", [ "collect", "number", 1 ] ],
	        [ "known_x", [ "collect", "number", 1 ] ],
	        [ "?", [ "assert", "$known_x.length == $known_y.length", "N/A" ] ],
	        [ "?", [ "assert", "$known_x.length > 0 && $known_y.length > 0", "N/A" ] ],
	        [ "?", [ "assert", "$known_x.length != 1 && $known_y.length != 1", "N/A" ] ]
	    ]);

	    defineFunction("STEYX", steyx).args([
	        [ "known_y", [ "collect", "number", 1 ] ],
	        [ "known_x", [ "collect", "number", 1 ] ],
	        [ "?", [ "assert", "$known_x.length == $known_y.length", "N/A" ] ],
	        [ "?", [ "assert", "$known_x.length >= 3 && $known_y.length >= 3", "DIV/0" ] ]
	    ]);

	    defineFunction("FORECAST", forecast).args([
	        [ "x", "number" ],
	        [ "known_y", [ "collect", "number", 1 ] ],
	        [ "known_x", [ "collect", "number", 1 ] ],
	        [ "?", [ "assert", "$known_x.length == $known_y.length", "N/A" ] ],
	        [ "?", [ "assert", "$known_x.length > 0 && $known_y.length > 0", "N/A" ] ]
	    ]);

	    defineFunction("LINEST", linest).args([
	        [ "known_y", "matrix" ],
	        [ "known_x", [ "or", "matrix", "null" ] ],
	        [ "const", [ "or", "logical", [ "null", true ] ] ],
	        [ "stats", [ "or", "logical", [ "null", false ] ] ]
	    ]);

	    defineFunction("LOGEST", logest).args([
	        [ "known_y", "matrix" ],
	        [ "known_x", [ "or", "matrix", "null" ] ],
	        [ "const", [ "or", "logical", [ "null", true ] ] ],
	        [ "stats", [ "or", "logical", [ "null", false ] ] ]
	    ]);

	    defineFunction("TREND", trend).args([
	        [ "known_y", "matrix" ],
	        [ "known_x", [ "or", "matrix", "null" ] ],
	        [ "new_x", [ "or", "matrix", "null" ] ],
	        [ "const", [ "or", "logical", [ "null", true ] ] ]
	    ]);

	    defineFunction("GROWTH", growth).args([
	        [ "known_y", "matrix" ],
	        [ "known_x", [ "or", "matrix", "null" ] ],
	        [ "new_x", [ "or", "matrix", "null" ] ],
	        [ "const", [ "or", "logical", [ "null", true ] ] ]
	    ]);

	    defineFunction("FV", FV).args([
	        [ "rate", "number" ],
	        [ "nper", "number" ],
	        [ "pmt", [ "or", "number", [ "null", 0 ] ] ],
	        [ "pv", [ "or", "number", [ "null", 0 ] ] ],
	        [ "type", [ "or", [ "values", 0, 1 ], [ "null", 0 ] ] ],
	        [ "?", [ "assert", "$pmt || $pv" ] ]
	    ]);

	    defineFunction("PV", PV).args([
	        [ "rate", "number" ],
	        [ "nper", "number" ],
	        [ "pmt", [ "or", "number", [ "null", 0 ] ] ],
	        [ "fv", [ "or", "number", [ "null", 0 ] ] ],
	        [ "type", [ "or", [ "values", 0, 1 ], [ "null", 0 ] ] ]
	    ]);

	    defineFunction("PMT", PMT).args([
	        [ "rate", "number" ],
	        [ "nper", "number" ],
	        [ "pmt", "number" ],
	        [ "fv", [ "or", "number", [ "null", 0 ] ] ],
	        [ "type", [ "or", [ "values", 0, 1 ], [ "null", 0 ] ] ]
	    ]);

	    defineFunction("NPER", NPER).args([
	        [ "rate", "number" ],
	        [ "pmt", "number" ],
	        [ "pv", "number" ],
	        [ "fv", [ "or", "number", [ "null", 0 ] ] ],
	        [ "type", [ "or", [ "values", 0, 1 ], [ "null", 0 ] ] ]
	    ]);

	    defineFunction("RATE", RATE).args([
	        [ "nper", "number" ],
	        [ "pmt", [ "or", "number", [ "null", 0 ] ] ],
	        [ "pv", "number" ],
	        [ "fv", [ "or", "number", [ "null", 0 ] ] ],
	        [ "type", [ "or", [ "values", 0, 1 ], [ "null", 0 ] ] ],
	        [ "guess", [ "or", "number++", [ "null", 0.01 ] ] ],
	        [ "?", [ "assert", "$pmt || $fv" ] ]
	    ]);

	    defineFunction("IPMT", IPMT).args([
	        [ "rate", "number" ],
	        [ "per", "number++" ],
	        [ "nper", "number++" ],
	        [ "pv", "number" ],
	        [ "fv", [ "or", "number", [ "null", 0 ] ] ],
	        [ "type", [ "or", [ "values", 0, 1 ], [ "null", 0 ] ] ],
	        [ "?", [ "assert", "$per >= 1 && $per <= $nper" ] ]
	    ]);

	    defineFunction("PPMT", PPMT).args([
	        [ "rate", "number" ],
	        [ "per", "number++" ],
	        [ "nper", "number++" ],
	        [ "pv", "number" ],
	        [ "fv", [ "or", "number", [ "null", 0 ] ] ],
	        [ "type", [ "or", [ "values", 0, 1 ], [ "null", 0 ] ] ],
	        [ "?", [ "assert", "$per >= 1 && $per <= $nper" ] ]
	    ]);

	    defineFunction("CUMPRINC", CUMPRINC).args([
	        [ "rate", "number++" ],
	        [ "nper", "number++" ],
	        [ "pv", "number++" ],
	        [ "start_period", "number++" ],
	        [ "end_period", "number++" ],
	        [ "type", [ "or", [ "values", 0, 1 ], [ "null", 0 ] ] ],
	        [ "?", [ "assert", "$end_period >= $start_period", "NUM" ] ]
	    ]);

	    defineFunction("CUMIPMT", CUMIPMT).args([
	        [ "rate", "number++" ],
	        [ "nper", "number++" ],
	        [ "pv", "number++" ],
	        [ "start_period", "number++" ],
	        [ "end_period", "number++" ],
	        [ "type", [ "or", [ "values", 0, 1 ], [ "null", 0 ] ] ],
	        [ "?", [ "assert", "$end_period >= $start_period", "NUM" ] ]
	    ]);

	    defineFunction("NPV", NPV).args([
	        [ "rate", "number" ],
	        [ "values", [ "collect", "number" ] ],
	        [ "?", [ "assert", "$values.length > 0", "N/A" ] ]
	    ]);

	    defineFunction("IRR", IRR).args([
	        [ "values", [ "collect", "number", 1 ] ],
	        [ "guess", [ "or", "number", [ "null", 0.1 ] ] ]
	    ]);

	    defineFunction("EFFECT", EFFECT).args([
	        [ "nominal_rate", "number++" ],
	        [ "npery", "integer++" ]
	    ]);

	    defineFunction("NOMINAL", NOMINAL).args([
	        [ "effect_rate", "number++" ],
	        [ "npery", "integer++" ]
	    ]);

	    defineFunction("XNPV", XNPV).args([
	        [ "rate", "number" ],
	        [ "values", [ "collect", "number", 1 ] ],
	        [ "dates", [ "collect", "date", 1 ] ],
	        [ "?", [ "assert", "$values.length == $dates.length", "NUM" ] ]
	    ]);

	    defineFunction("XIRR", XIRR).args([
	        [ "values", [ "collect", "number", 1 ] ],
	        [ "dates", [ "collect", "date", 1 ] ],
	        [ "guess", [ "or", "number", [ "null", 0.1 ] ] ],
	        [ "?", [ "assert", "$values.length == $dates.length", "NUM" ] ]
	    ]);

	    defineFunction("ISPMT", ISPMT).args([
	        [ "rate", "number" ],
	        [ "per", "number++" ],
	        [ "nper", "number++" ],
	        [ "pv", "number" ],
	        [ "?", [ "assert", "$per >= 1 && $per <= $nper" ] ]
	    ]);

	    defineFunction("DB", DB).args([
	        [ "cost", "number" ],
	        [ "salvage", "number" ],
	        [ "life", "number++" ],
	        [ "period", "number++" ],
	        [ "month", [ "or", "number", [ "null", 12 ] ] ]
	    ]);

	    defineFunction("DDB", DDB).args([
	        [ "cost", "number" ],
	        [ "salvage", "number" ],
	        [ "life", "number++" ],
	        [ "period", "number++" ],
	        [ "factor", [ "or", "number", [ "null", 2 ] ] ]
	    ]);

	    defineFunction("SLN", SLN).args([
	        [ "cost", "number" ],
	        [ "salvage", "number" ],
	        [ "life", "number++" ]
	    ]);

	    defineFunction("SYD", SYD).args([
	        [ "cost", "number" ],
	        [ "salvage", "number" ],
	        [ "life", "number++" ],
	        [ "per", "number++" ]
	    ]);

	    defineFunction("VDB", VDB).args([
	        [ "cost", "number+" ],
	        [ "salvage", "number+" ],
	        [ "life", "number++" ],
	        [ "start_period", "number+" ],
	        [ "end_period", "number+" ],
	        [ "factor", [ "or", "number+", [ "null", 2 ] ] ],
	        [ "no_switch", [ "or", "logical", [ "null", false ] ] ],
	        [ "?", [ "assert", "$end_period >= $start_period", "NUM" ] ]
	    ]);

	    var COUPS_ARGS = [
	        [ "settlement", "date" ],
	        [ "maturity", "date" ],
	        [ "frequency", [ "and", "integer", [ "values", 1, 2, 4 ] ] ],
	        [ "basis", [ "or", [ "null", 0 ],
	                     [ "and", "integer", [ "values", 0, 1, 2, 3, 4 ] ] ] ],
	        [ "?", [ "assert", "$settlement < $maturity", "NUM" ] ]
	    ];

	    defineFunction("COUPDAYBS", COUPDAYBS).args(COUPS_ARGS);

	    defineFunction("COUPDAYS", COUPDAYS).args(COUPS_ARGS);

	    defineFunction("COUPDAYSNC", COUPDAYSNC).args(COUPS_ARGS);

	    defineFunction("COUPPCD", COUPPCD).args(COUPS_ARGS);

	    defineFunction("COUPNCD", COUPNCD).args(COUPS_ARGS);

	    defineFunction("COUPNUM", COUPNUM).args(COUPS_ARGS);

	    defineFunction("ACCRINTM", ACCRINTM).args([
	        [ "issue", "date" ],
	        [ "settlement", "date" ],
	        [ "rate", "number++" ],
	        [ "par", [ "or", [ "null", 1000 ], "number++" ] ],
	        [ "basis", [ "or", [ "null", 0 ],
	                     [ "and", "integer", [ "values", 0, 1, 2, 3, 4 ] ] ] ],
	        [ "?", [ "assert", "$issue < $settlement", "NUM" ] ]
	    ]);

	    defineFunction("ACCRINT", ACCRINT).args([
	        [ "issue", "date" ],
	        [ "first_interest", "date" ],
	        [ "settlement", "date" ],
	        [ "rate", "number++" ],
	        [ "par", [ "or", [ "null", 1000 ], "number++" ] ],
	        [ "frequency", [ "and", "integer", [ "values", 1, 2, 4 ] ] ],
	        [ "basis", [ "or", [ "null", 0 ],
	                     [ "and", "integer", [ "values", 0, 1, 2, 3, 4 ] ] ] ],
	        [ "calc_method", [ "or", "logical", [ "null", true ] ] ],
	        [ "?", [ "assert", "$issue < $settlement", "NUM" ] ]
	    ]);

	    defineFunction("DISC", DISC).args([
	        [ "settlement", "date" ],
	        [ "maturity", "date" ],
	        [ "pr", "number++" ],
	        [ "redemption", "number++" ],
	        [ "basis", [ "or", [ "null", 0 ],
	                     [ "and", "integer", [ "values", 0, 1, 2, 3, 4 ] ] ] ],
	        [ "?", [ "assert", "$settlement < $maturity", "NUM" ] ]
	    ]);

	    defineFunction("INTRATE", INTRATE).args([
	        [ "settlement", "date" ],
	        [ "maturity", "date" ],
	        [ "investment", "number++" ],
	        [ "redemption", "number++" ],
	        [ "basis", [ "or", [ "null", 0 ],
	                     [ "and", "integer", [ "values", 0, 1, 2, 3, 4 ] ] ] ],
	        [ "?", [ "assert", "$settlement < $maturity", "NUM" ] ]
	    ]);

	    defineFunction("RECEIVED", RECEIVED).args([
	        [ "settlement", "date" ],
	        [ "maturity", "date" ],
	        [ "investment", "number++" ],
	        [ "discount", "number++" ],
	        [ "basis", [ "or", [ "null", 0 ],
	                     [ "and", "integer", [ "values", 0, 1, 2, 3, 4 ] ] ] ],
	        [ "?", [ "assert", "$settlement < $maturity", "NUM" ] ]
	    ]);

	    defineFunction("PRICE", PRICE).args([
	        [ "settlement", "date" ],
	        [ "maturity", "date" ],
	        [ "rate", "number++" ],
	        [ "yld", "number++" ],
	        [ "redemption", "number++" ],
	        [ "frequency", [ "and", "integer", [ "values", 1, 2, 4 ] ] ],
	        [ "basis", [ "or", [ "null", 0 ],
	                     [ "and", "integer", [ "values", 0, 1, 2, 3, 4 ] ] ] ],
	        [ "?", [ "assert", "$settlement < $maturity", "NUM" ] ]
	    ]);

	    defineFunction("PRICEDISC", PRICEDISC).args([
	        [ "settlement", "date" ],
	        [ "maturity", "date" ],
	        [ "discount", "number++" ],
	        [ "redemption", "number++" ],
	        [ "basis", [ "or", [ "null", 0 ],
	                     [ "and", "integer", [ "values", 0, 1, 2, 3, 4 ] ] ] ],
	        [ "?", [ "assert", "$settlement < $maturity", "NUM" ] ]
	    ]);

	    /* -----[ utils ]----- */

	    // function resultAsMatrix(f) {
	    //     return function() {
	    //         var a = f.apply(this, arguments);
	    //         return this.asMatrix(a);
	    //     };
	    // }

	    /* -----[ definitions: statistical functions ]----- */

	    var MAX_IT = 300,     // Maximum allowed number of iterations
	        EPS = 2.2204e-16, // Relative accuracy; 1-3*(4/3-1) = 2.220446049250313e-16
	        FP_MIN = 1.0e-30, // Near the smallest representable as floating-point, number.
	        f_abs = Math.abs;

	    function ERF(x) {
	        if (f_abs(x) >= 3.3) {
	            return 1 - ERFC(x);
	        }
	        var S = x > 0 ? 1 : -1;
	        if (S == -1) {
	            x = -x;
	        }
	        var m = 0, an = 1;
	        for (var n = 1; n < 100; n++) {
	            m += an;
	            an *= 2*x*x/(2*n+1);
	        }
	        return S*2/Math.sqrt(Math.PI)*x*Math.exp(-x*x)*m;
	    }

	    function ERFC(x) {
	        if (f_abs(x) < 3.3) {
	            return 1 - ERF(x);
	        }
	        var s = 1;
	        if (x < 0) {
	            s = -1;
	            x = -x;
	        }
	        var frac = x;
	        for (var n = 8; n >= 1; n -= 0.5) {
	            frac = x + n/frac;
	        }
	        frac = 1 / (x + frac);
	        return s == 1
	            ? Math.exp(-x*x)/Math.sqrt(Math.PI)*frac
	            : 2 - Math.exp(-x*x)/Math.sqrt(Math.PI)*frac;
	    }

	    function GAMMALN(x) { // Returns the value ln[Γ(x)] for x > 0.
	        var cof = [
	            1.000000000190015, 76.18009172947146, -86.50532032941677,
	            24.01409824083091, -1.231739572450155, 0.1208650973866179e-2, -0.5395239384953e-5
	        ];
	        var y = x, tmp = x + 5.5, ser = cof[0];
	        tmp -= (x + 0.5) * Math.log(tmp);
	        for (var j = 1; j <= 6; j++) {
	            y += 1;
	            ser += cof[j] / y;
	        }
	        return -tmp + Math.log(Math.sqrt(2*Math.PI) * ser / x); // log(Γ(x)) = log(Γ(x+1)) - log(x)
	    }

	    function GAMMA(x) { // returns Infinity for 0 or negative _integer argument.
	        if (x > 0) {
	            return Math.exp(GAMMALN(x));
	        }
	        var pi = Math.PI, y = -x; // For x<0 we use the reflection formula: Γ(x)Γ(1-x) = PI / sin(PI*x)
	        return -pi / (y*GAMMA(y)*Math.sin(pi*y));
	    }

	    function BETALN(a, b) {
	        return GAMMALN(a) + GAMMALN(b) - GAMMALN(a+b);
	    }

	    function BETA(a, b) {
	        return Math.exp(BETALN(a, b));
	    }

	    function gamma_inc(a, x) { // returns the normalized incomplete gamma function P(a, x); x > 0.
	        return x < a+1.0 ? g_series(a, x) : 1 - g_contfrac(a, x);
	    }

	    function g_series(a, x) { // evaluate P(a, x) by its series representation (converges quickly for x < a+1).
	        var sum = 1/a,
	            frac = sum,
	            ap = a;
	        var gln = GAMMALN(a), n;
	        for (n = 1; n <= MAX_IT; n++) {
	            ap++;
	            frac *= x/ap;
	            sum += frac;
	            if (f_abs(frac) < f_abs(sum)*EPS) {
	                break; // already the last frac is too small versus the current sum value
	            }
	        }
	        return sum * Math.exp(-x + a*Math.log(x) - gln); // e^{-x} * x^a * Γ(a) * sum
	    }

	    function g_contfrac(a, x) { // Q(a, x) by its continued fraction representation (converges quickly for x > a + 1); modified Lentz’s method (Numerical Recipes (The Art of Scientific Computing), 2rd Edition $5.2)
	        var f = FP_MIN, c = f, d = 0, aj = 1, bj = x + 1 - a;
	        var gln = GAMMALN(a);
	        for (var i = 1; i <= MAX_IT; i++) {
	            d = bj + aj * d;
		    if (f_abs(d) < FP_MIN) {
	                d = FP_MIN;
	            }
		    c = bj + aj / c;
		    if (f_abs(c) < FP_MIN) {
	                c = FP_MIN;
	            }
		    d = 1 / d;
		    var delta = c * d;
		    f *= delta;
	    	    if (f_abs(delta - 1) < EPS) {
	                break;
	            }
		    bj += 2;
		    aj = -i * (i - a);
		}
		return f * Math.exp(-x - gln + a * Math.log(x));
	    }

	    function GAMMA_DIST(x, a, b, cumulative) { // a > 0, b > 0; x >= 0
	        if (!cumulative) {
	            return Math.pow(x/b, a-1)*Math.exp(-x/b)/(b*GAMMA(a)); // the PDF of the Gamma distribution
	        }
	        return gamma_inc(a, x/b); // (else) compute the CDF (using the incomplete Gamma function)
	    }

	    function GAMMA_INV(p, a, b) { // the quantile function of the Gamma distribution
		if (p === 0) {
	            return 0;
	        }
		if (p == 1) {
	            return Infinity;
	        }
		var m = 0, M = 10, x = 0, ab = a*b;
		if (ab > 1) {
	            M *= ab;
	        }
		for (var i = 0; i < MAX_IT; i++) {
		    x = 0.5*(m + M); // console.log(x);
		    var q = GAMMA_DIST(x, a, b, true);
		    if (f_abs(p - q) < 1e-16) {
	                break;
	            }
		    if (q > p) {
	                M = x;
	            } else {
	                m = x;
	            }
		}
		return x;
	    }

	    function NORM_S_DIST(x, cumulative) {
	        if (!cumulative) {
	            return Math.exp(-x*x/2)/Math.sqrt(2*Math.PI);
	        }
	        return 0.5 + 0.5*ERF(x/Math.sqrt(2));
	    }

	    function NORM_S_INV(p) { // see [1] $26.2.3 and http://home.online.no/~pjacklam/notes/invnorm/#References
	        // Coefficients in rational approximations.
	        var a = [-3.969683028665376e+01,  2.209460984245205e+02,
	                 -2.759285104469687e+02,  1.383577518672690e+02,
	                 -3.066479806614716e+01,  2.506628277459239e+00],
	            b = [-5.447609879822406e+01,  1.615858368580409e+02,
	                 -1.556989798598866e+02,  6.680131188771972e+01,
	                 -1.328068155288572e+01],
	            c = [-7.784894002430293e-03, -3.223964580411365e-01,
	                 -2.400758277161838e+00, -2.549732539343734e+00,
	                 4.374664141464968e+00,  2.938163982698783e+00],
	            d = [ 7.784695709041462e-03,  3.224671290700398e-01,
	                  2.445134137142996e+00,  3.754408661907416e+00];
	        // Define break-points.
	        var plow  = 0.02425,
	            phigh = 1 - plow;
	        var q, r;
	        // Rational approximation for lower region:
	        if (p < plow) {
	            q = Math.sqrt(-2*Math.log(p));
	            return (((((c[0]*q+c[1])*q+c[2])*q+c[3])*q+c[4])*q+c[5]) / ((((d[0]*q+d[1])*q+d[2])*q+d[3])*q+1);
	        }
	        // Rational approximation for upper region:
	        if (phigh < p) {
	            q = Math.sqrt(-2*Math.log(1-p));
	            return -(((((c[0]*q+c[1])*q+c[2])*q+c[3])*q+c[4])*q+c[5]) / ((((d[0]*q+d[1])*q+d[2])*q+d[3])*q+1);
	        }
	        // Rational approximation for central region:
	        q = p - 0.5;
	        r = q*q;
	        return (((((a[0]*r+a[1])*r+a[2])*r+a[3])*r+a[4])*r+a[5])*q / (((((b[0]*r+b[1])*r+b[2])*r+b[3])*r+b[4])*r+1);
	    }

	    function NORM_DIST(x, m, s, cumulative) {
	        if (!cumulative) {
	            return Math.exp(-(x-m)*(x-m)/(2*s*s))/(s*Math.sqrt(2*Math.PI)); // NORM_S_DIST((x-m)/s)/s;
	        }
	        return NORM_S_DIST((x-m)/s, true);
	    }

	    function NORM_INV(p, m, s) {
	        return m + s*NORM_S_INV(p);
	    }

	    function betastd_pdf(x, a, b) {
	        return Math.exp((a-1)*Math.log(x) + (b-1)*Math.log(1-x) - BETALN(a, b));
	    }

	    function betastd_cdf(x, a, b) {
	        var k = Math.exp(a*Math.log(x) + b*Math.log(1-x) - BETALN(a, b));
	        return x < (a+1)/(a+b+2) ? k*beta_lentz(a, b, x)/a : 1 - k*beta_lentz(b, a, 1-x)/b;
	    }

	    function beta_lentz(a, b, x) { // estimates continued fraction by modified Lentz’s method ([2] $8.17.22)
	        var m, m2;
	        var aa, c, d, del, h, qab, qam, qap;
	        qab = a + b; // These q’s will be used in factors that occur in the coefficients d_n
	        qap = a + 1;
	        qam = a - 1;
	        c = 1; // First step of Lentz’s method.
	        d = 1 - qab * x / qap;
	        if (f_abs(d) < FP_MIN) {
	            d = FP_MIN;
	        }
	        d = 1/d;
	        h = d;
	        for (m = 1; m <= MAX_IT; m++) {
	            m2 = 2*m;
	            aa = m*(b - m)*x / ((qam + m2)*(a + m2));
	            d = 1 + aa*d; // One step (the even one) of the recurrence.
	            if (f_abs(d) < FP_MIN) {
	                d = FP_MIN;
	            }
	            c = 1 + aa/c;
	            if (f_abs(c) < FP_MIN) {
	                c = FP_MIN;
	            }
	            d = 1/d;
	            h *= d*c;
	            aa = -(a + m)*(qab + m)*x / ((a + m2)*(qap + m2));
	            d = 1 + aa*d; // Next step of the recurrence (the odd one).
	            if (f_abs(d) < FP_MIN) {
	                d = FP_MIN;
	            }
	            c = 1 + aa/c;
	            if (f_abs(c) < FP_MIN) {
	                c = FP_MIN;
	            }
	            d = 1/d;
	            del = d*c;
	            h *= del;
	            if (f_abs(del - 1) < EPS) {
	                break;
	            }
	        }
	        return h; // if(m > MAX_IT) throw new Error("a or b too big, or MAX_IT too small");
	    }

	    function betastd_inv(p, a, b) { // the quantile function of the standard Beta distribution
		var m = 0, M = 1, x = 0;
		for (var i = 0; i < MAX_IT; i++) {
		    x = 0.5*(m + M);
		    var q = betastd_cdf(x, a, b);
		    if (f_abs(p - q) < EPS) {
	                break;
	            }
		    if (q > p) {
	                M = x;
	            } else {
	                m = x;
	            }
		}
		return x;
	    }

	    function BETADIST(x, a, b, m, M) {
	        return betastd_cdf((x-m)/(M-m), a, b);
	    }

	    function BETA_DIST(x, a, b, cdf, m, M) {
	        if (cdf) {
	            return betastd_cdf((x-m)/(M-m), a, b);
	        }
	        return betastd_pdf((x-m)/(M-m), a, b) / (M-m);
	    }

	    function BETA_INV(p, a, b, m, M) {
	        return m + (M-m)*betastd_inv(p, a, b);
	    }

	    function chisq_left(x, n, cds) {  // CHISQ.DIST(x,deg_freedom,cumulative)
	        return GAMMA_DIST(x, n/2, 2, cds);
	    }

	    function chisq_right(x, n) { // CHISQ.DIST.RT(x,deg_freedom)
	        return 1 - chisq_left(x, n, true);
	    }

	    function chisq_left_inv(p, n) { // CHISQ.INV( probability, degrees_freedom )
	        return GAMMA_INV(p, n/2, 2);
	    }

	    function chisq_right_inv(p, n) { // CHISQ.INV.RT(probability,deg_freedom)
	        return chisq_left_inv(1-p, n);
	    }

	    function chisq_test(obsv, expect) {
	        var rows = obsv.length, cols = obsv[0].length;
	        var x = 0, i, j;
	        for (i = 0; i < rows; i++) {
	            for (j = 0; j < cols; j++) {
	                var eij = expect[i][j];
	                var delta = obsv[i][j] - eij;
	                delta *= delta;
	                x += delta/eij;
	            }
	        }
	        var n = (rows - 1)*(cols - 1);
	        return chisq_right(x, n);
	    }

	    function expon(x, r, cdf) { // EXPON.DIST(x, lambda, cumulative)
	        if (cdf) {
	            return 1 - Math.exp(-r*x);
	        }
	        return r * Math.exp(-r*x);
	    }

	    function poisson(k, m, cdf) { // POISSON.DIST(x, mean, cumulative)
	        if (cdf) {
	            return 1 - chisq_left(2*m, 2*(k+1), true);
	        }
	        //return chisq_left(2*m, 2*k, true) - chisq_left(2*m, 2*(k+1), true);
	        var lnf = 0;
	        for (var i = 2; i <= k; i++) {
	            lnf += Math.log(i); // compute log(k!)
	        }
	        return Math.exp(k*Math.log(m) - m - lnf);
	    }

	    function Fdist(x, n, d, cdf) { //F.DIST(x,deg_freedom1,deg_freedom2,cumulative)
	        if (cdf) {
	            return betastd_cdf(n*x/(d+n*x), n/2, d/2);
	        }
	        var u = n/d;
	        n /= 2; d /= 2;
	        return u/BETA(n, d) * Math.pow(u*x, n-1) / Math.pow(1+u*x, n+d);
	    }

	    function Fdist_right(x, n, d) { // F.DIST.RT(x,deg_freedom1,deg_freedom2)
	        return 1 - Fdist(x, n, d, true);
	    }

	    function Finv_right(p, n, d) { // F.INV.RT(probability,deg_freedom1,deg_freedom2
	        return d/n*(1/BETA_INV(p, d/2, n/2, 0, 1) - 1);
	    }

	    function Finv(p, n, d) { // F.INV(probability,deg_freedom1,deg_freedom2
	        return d/n*(1/BETA_INV(1-p, d/2, n/2, 0, 1) - 1);
	    }

	    function _mean(arr) {
	        var me = 0, n = arr.length;
	        for (var i = 0; i < n; i++) {
	            me += arr[i];
	        }
	        return me / n;
	    }

	    function _var_sq(arr, m) { // returns the (n-1)-part of the sum of the squares of deviations from m (= VAR)
	        var v = 0, n = arr.length;
	        for (var i = 0; i < n; i++) {
	            var delta = arr[i] - m;
	            v += delta*delta;
	        }
	        return v / (n-1);
	    }

	    function Ftest(arr1, arr2) { // F.TEST(array1,array2)
	        var n1 = arr1.length - 1, n2 = arr2.length - 1;
	        var va1 = _var_sq(arr1, _mean(arr1)),
	            va2 = _var_sq(arr2, _mean(arr2));
	        if (!va1 || !va2) {
	            throw new CalcError("DIV/0");
	        }
	        return 2*Fdist(va1 / va2, n1, n2, true);
	    }

	    function fisher(x) { // FISHER(x)
	        return 0.5*Math.log((1+x)/(1-x));
	    }

	    function fisherinv(x) { // FISHERINV(x)
	        var e2 = Math.exp(2*x);
	        return (e2 - 1)/(e2 + 1);
	    }

	    function Tdist(x, n, cdf) { // T.DIST(x,deg_freedom, cumulative)
	        if (cdf) {
	            return 1 - 0.5*betastd_cdf(n/(x*x+n), n/2, 0.5);
	        }
	        return 1/(Math.sqrt(n)*BETA(0.5, n/2)) * Math.pow(1 + x*x/n, -(n+1)/2);
	    }

	    function Tdist_right(x, n) { // T.DIST.RT(x,deg_freedom)
	        return 1 - Tdist(x, n, true);
	    }

	    function Tdist_2tail(x, n) { // T.DIST.2T(x,deg_freedom)
	        if (x < 0) {
	            x = -x;
	        }
	        return 2*Tdist_right(x, n);
	    }

	    function Tdist_inv(p, n) { // T.INV(probability,deg_freedom)
	        var x = betastd_inv(2*Math.min(p, 1-p), n/2, 0.5); // ibetainv();
	        x = Math.sqrt(n * (1 - x) / x);
	        return (p > 0.5) ? x : -x;
	    }

	    function Tdist_2tail_inv(p, n) { // T.INV.2T(probability,deg_freedom)
	        // T2 = 2T_r = p => T_r(x,n) = p/2 => 1 - T(x,n,true) = p/2 => x = T^-1(1-p/2, n)
	        return Tdist_inv(1-p/2, n);
	    }

	    function Tdist_test(gr1, gr2, tail, type) { // T.TEST(array1,array2,tails,type)
	        var n1 = gr1.length, n2 = gr2.length;
	        var t_st, df; // the t-statistic and the "degree of freedom"
	        if (type == 1) { // paired (dependent) samples
	            var d = 0, d2 = 0;
	            for (var i = 0; i < n1; i++) {
	                var delta = gr1[i] - gr2[i];
	                d += delta;
	                d2 += delta*delta;
	            }
	            var md = d/n1; //, md2 = d2 / n1;
	            t_st = md / Math.sqrt((d2 - d*md)/(n1*(n1-1))); // has a "Student T" distribution
	            return tail == 1 ? Tdist_right(t_st, n1-1) : Tdist_2tail(t_st, n1-1);
	        }
	        // unpaired (independent) samples
	        var m1 = _mean(gr1), m2 = _mean(gr2),
	            v1 = _var_sq(gr1, m1), v2 = _var_sq(gr2, m2);
	        if (type == 3) { // unpaired, unequal variances
	            var u1 = v1/n1, u2 = v2/n2, u = u1 + u2;
	            var q1 = u1/u, q2 = u2/u; // u==0 must be invalidated
	            df = 1/(q1*q1/(n1-1) + q2*q2/(n2-1));
	            t_st =  f_abs(m1-m2)/Math.sqrt(u);
	            return tail == 1 ? Tdist_right(t_st, df) : Tdist_2tail(t_st, df);
	        }
	        else { // (type == 2) unpaired, equal variances ("equal" in the sense that there is no significant difference in variance in both groups - a prealable F-test could revealed that)
	            df = n1 + n2 - 2;
	            t_st = f_abs(m1-m2)*Math.sqrt(df*n1*n2/((n1+n2)*((n1-1)*v1+(n2-1)*v2)));
	            return tail == 1 ? Tdist_right(t_st, df) : Tdist_2tail(t_st, df);
	        }
	    }

	    function confidence_t(alpha, stddev, size) { // CONFIDENCE.T(alpha,standard_dev,size)
	        return -Tdist_inv(alpha/2, size-1)*stddev/Math.sqrt(size);
	    }

	    function confidence_norm(alpha, stddev, size) { // CONFIDENCE.NORM(alpha,standard_dev,size)
	        return -NORM_S_INV(alpha/2)*stddev/Math.sqrt(size);
	    }

	    function gauss(z) { // GAUSS(z)
	        return NORM_S_DIST(z, true) - 0.5;
	    }

	    function phi(x) { // PHI(x)
	        return NORM_S_DIST(x);
	    }

	    function lognorm_dist(x, m, s, cumulative) { // LOGNORM.DIST(x,mean,standard_dev,cumulative)
	        if (cumulative) {
	            return 0.5 + 0.5*ERF((Math.log(x)-m)/(s*Math.sqrt(2)));
	        }
	        var t = Math.log(x)-m;
	        return Math.exp(-t*t/(2*s*s))/(x*s*Math.sqrt(2*Math.PI));
	    }

	    function lognorm_inv(p, m, s) { //LOGNORM.INV(probability, mean, standard_dev)
	        return Math.exp(NORM_INV(p, m, s));
	    }

	    function prob(x_, p_, lw, up) { //PROB(x_range, prob_range, [lower_limit], [upper_limit])
	        var n = x_.length;
	        var s = 0, i;
	        for (i = 0; i < n; i++) {
	            if (p_[i] <= 0 || p_[i] > 1) {
	                throw new CalcError("NUM");
	            }
	            s += p_[i];
	        }
	        if (s != 1) {
	            throw new CalcError("NUM");
	        }
	        var res = 0;
	        for (i = 0; i < n; i++) {
	            var x = x_[i];
	            if (x >= lw && x <= up) {
	                res += p_[i];
	            }
	        }
	        return res;
	    }

	    function slope(y_, x_) { // SLOPE(known_y's, known_x's)
	        var mx = _mean(x_), my = _mean(y_), b1 = 0, b2 = 0;
	        for (var i = 0, n = y_.length; i < n; i++) {
	            var t = x_[i] - mx;
	            b1 += t*(y_[i] - my);
	            b2 += t*t;
	        }
	        return b1/b2;
	    }

	    function intercept(y_, x_) { // INTERCEPT(known_y's, known_x's)
	        var mx = _mean(x_), my = _mean(y_);
	        // return my - mx*slope(y_, x_);  //but repeating the calls for _mean()
	        var b1 = 0, b2 = 0;
	        for (var i = 0, n = y_.length; i < n; i++) {
	            var t = x_[i] - mx;
	            b1 += t*(y_[i] - my);
	            b2 += t*t;
	        }
	        return my - b1*mx/b2;
	    }

	    function pearson(x_, y_) { // PEARSON(array1, array2)
	        whipNumberArrays(x_, y_);
	        var mx = _mean(x_), my = _mean(y_);
	        var s1 = 0, s2 = 0, s3 = 0;
	        for(var i = 0, n = x_.length; i < n; i++) {
	            var t1 = x_[i] - mx, t2 = y_[i] - my;
	            s1 += t1*t2;
	            s2 += t1*t1;
	            s3 += t2*t2;
	        }
	        return s1/Math.sqrt(s2*s3);
	    }

	    function rsq(x_, y_) { // RSQ(known_y's,known_x's)
	        var r = pearson(x_, y_);
	        return r*r;
	    }

	    function steyx(y_, x_) { //STEYX(known_y's, known_x's)
	        var n = x_.length;
	        var mx = _mean(x_), my = _mean(y_);
	        var s1 = 0, s2 = 0, s3 = 0;
	        for (var i = 0; i < n; i++) {
	            var t1 = x_[i] - mx, t2 = y_[i] - my;
	            s1 += t2*t2;
	            s2 += t1*t2;
	            s3 += t1*t1;
	        }
	        return Math.sqrt((s1 - s2*s2/s3)/(n-2));
	    }

	    function forecast(x, y_, x_) { //FORECAST(x, known_y's, known_x's)
	        var mx = _mean(x_), my = _mean(y_);
	        var s1 = 0, s2 = 0;
	        for (var i = 0, n = x_.length; i < n; i++) {
	            var t1 = x_[i] - mx, t2 = y_[i] - my;
	            s1 += t1*t2;
	            s2 += t1*t1;
	        }
	        if (s2 === 0) {
	            throw new CalcError("N/A");
	        }
	        var b = s1/s2, a = my - b*mx;
	        return a + b*x;
	    }

	    function _mat_mean(Mat) { // returns the mean value of a Matrix(n, 1)
	        var n = Mat.height, sum = 0;
	        for (var i=0; i < n; i++) {
	            sum += Mat.data[i][0];
	        }
	        return sum/n;
	    }

	    function _mat_devsq(Mat, mean) { // returns the sum of squares of deviations for a Matrix(n, 1)
	        var n = Mat.height, sq = 0;
	        for (var i=0; i < n; i++) {
	            var x = Mat.data[i][0] - mean;
	            sq += x*x;
	        }
	        return sq;
	    }

	    function linest(Y, X, konst, stats) { // LINEST(known_y's, [known_x's], [const], [stats])
	        var i = 0;

	        if (!X) {
	            // if not passed, X should default to array {1, 2, 3, ...} (same size as Y)
	            X = Y.map(function(){ return ++i; });
	        }

	        if (konst) { // adding 1's column is unnecessary when const==false (meaning that y_intercept==0)
	            X = X.clone();
	            X.eachRow(function(row){
	                X.data[row].unshift(1);
	            });
	            ++X.width;
	        }

	        var Xt = X.transpose();
	        var B = Xt.multiply(X).inverse().multiply(Xt).multiply(Y); // the last square estimate of the coefficients
	        var line_1 = [];
	        for (i = B.height-1; i >= 0; i--) {
	            line_1.push(B.data[i][0]); // regression coefficients ('slopes') and the y_intercept
	        }
	        if (!konst) {
	            line_1.push(0); // display 0 for y_intercept, when const==false
	        }
	        if (!stats) {
	            return this.asMatrix([ line_1 ]); // don't display statistics about the regression, when stats==false
	        }

	        var Y1 = X.multiply(B); // the predicted Y values
	        var y_y1 = Y.adds(Y1, true); // the errors of the predictions (= Y - Y1)
	        var mp = !konst? 0 : _mat_mean(Y1);
	        var SSreg = _mat_devsq(Y1, mp); // The regression sum of squares
	        var me = !konst? 0 : _mat_mean(y_y1);
	        var SSresid = _mat_devsq(y_y1, me); // The residual sum of squares
	        var line_5 = [];
	        line_5.push(SSreg, SSresid);
	        var R2 = SSreg / (SSreg + SSresid); // The coefficient of determination
	        var degfre = Y.height - X.width; // The degrees of freedom
	        var err_est = Math.sqrt(SSresid / degfre); // The standard error for the y estimate
	        var line_3 = [];
	        line_3.push(R2, err_est);
	        var F_sta = !konst ? (R2/X.width)/((1-R2)/(degfre)) : (SSreg/(X.width-1))/(SSresid/degfre); // The F statistic
	        var line_4 = [];
	        line_4.push(F_sta, degfre);
	        var SCP = Xt.multiply(X).inverse();
	        var line_2 = [];
	        for (i=SCP.height-1; i >= 0; i--) { // The standard errors (of coefficients an y-intercept)
	            line_2.push(Math.sqrt(SCP.data[i][i]*SSresid/degfre));
	        }
	        return this.asMatrix([line_1, line_2, line_3, line_4, line_5]);
	    }

	    function logest(Y, X, konst, stats) { // LOGEST(known_y's, [known_x's], [const], [stats])
	        return linest.call(this, Y.map(Math.log), X, konst, stats).map(Math.exp);
	    }

	    function trend(Y, X, W, konst) { // TREND(known_y's, [known_x's], [new_x's], [const])
	        var i = 0;

	        if (!X) {
	            // if not passed, X should default to array {1, 2, 3, ...} (same size as Y)
	            X = Y.map(function(){ return ++i; });
	        }

	        if (konst) { // adding 1's column is unnecessary when const==false (meaning that y_intercept==0)
	            X = X.clone();
	            X.eachRow(function(row){
	                X.data[row].unshift(1);
	            });
	            ++X.width;
	        }

	        var Xt = X.transpose();
	        var B = Xt.multiply(X).inverse().multiply(Xt).multiply(Y); // the last square estimate of the coefficients

	        if (!W) {
	            W = X;
	        } else {
	            if (konst) { // for non-zero y_intercept
	                W = W.clone();
	                W.eachRow(function(row){
	                    W.data[row].unshift(1);
	                });
	                ++W.width;
	            }
	        }
	        return W.multiply(B); // the predicted Y values for the W values
	    }

	    function growth(Y, X, new_X, konst) { // GROWTH(known_y's, [known_x's], [new_x's], [const])
	        // = EXP(TREND(LN(Y_), X_, new_X, const))
	        return trend.call(this, Y.map(Math.log), X, new_X, konst).map(Math.exp);
	    }

	    /*
	      [1] Handbook of Mathematical Functions (NIST, 1964-2010):
	      https://en.wikipedia.org/wiki/Abramowitz_and_Stegun
	      http://dlmf.nist.gov/
	      http://www.aip.de/groups/soe/local/numres/

	      [2] https://en.wikibooks.org/wiki/Statistics/Numerical_Methods/Numerics_in_Excel
	    */

	    /* -----[ financial functions ]----- */

	    //// find the root of a function known an initial guess (Newton's method) ////
	    function root_newton(func, guess, max_it, eps) { // func(x) must return [value_F(x), value_F'(x)]
	        var MAX_IT = max_it || 20, // maximum number of iterations
	            EPS = eps || 1E-7; // accuracy
	        var root = guess;
	        for (var j = 1; j <= MAX_IT; j++) {
	            var f_d = func(root),
	                f = f_d[0], // the value of the function
	                df = f_d[1]; // the value of the derivative
	            var dx = f / df;
	            root -= dx;
	            if (Math.abs(dx) < EPS) {
	                return root;
	            }
	        }
	        return new CalcError("NUM");
	    }


	    /* https://support.office.com/en-us/article/PV-function-23879d31-0e02-4321-be01-da16e8168cbd
	       if(rate==0):
	       PMT * nper + PV + FV = 0
	       else: //the basic equation (with six variables) implied in financial problems
	       PV * (1+rate)^nper + PMT * (1+rate*type) * ((1+rate)^nper-1) / rate + FV = 0         [1]
	    */



	    //// FV (final or future value) ////
	    /* I initially invest £1000 in a saving scheme and then at the end of each month I invest an
	       extra £50. If the interest rate is 0.5% per month and I continue this process for two year,
	       how much will my saving be worth: =FV(0.005, 24, -50, -1000, 0) */
	    function FV(rate, nper, pmt, pv, type) { // FV(rate,nper,pmt,[pv],[type])
	        var h1 = Math.pow(1+rate, nper);
	        var h2 = rate ? (h1 - 1)/rate : nper;
	        return -(pv * h1 + pmt * h2 * (1 + rate*type));
	    }

	    //// PV (present value of investment) ////
	    /* If I wish to accumulate £5000 in four years time by depositing £75 per month in a fixed
	       rate account with interest rate of 0.4% per month, what initial investment must I also
	       make: =PV(0.004, 4*12, -75, 5000, 0) */
	    function PV(rate, nper, pmt, fv, type) { // PV(rate, nper, pmt, [fv], [type])
	        if (!rate) {
	            return -fv - pmt*nper;
	        }
	        var h1 = Math.pow(1+rate, nper);
	        return -(fv + pmt * (h1 - 1)/rate * (1 + rate*type)) / h1;
	    }

	    //// PMT monthly payments (= principal part PPMT + interest part IPMT) ////
	    /* How much will the monthly repayments be if I borrow £100,000 over 20 years with an
	       effective monthly interest rate is 0.5%: =PMT(0.005, 12*20, 100000, 0, 0) */
	    function PMT(rate, nper, pv, fv, type) { // PMT(rate, nper, pv, [fv], [type])
	        if (!rate) {
	            return -(fv + pv)/nper;
	        }
	        var h1 = Math.pow(1+rate, nper);
	        return -rate*(fv + pv*h1)/((1 + rate*type)*(h1 - 1));
	    }

	    //// NPER (number of periods for an investment) ////
	    /* How long would it take me to pay off a loan of £10,000 at a rate of 0.5% per month if I
	       can afford to pay £100 per month: =NPER(0.5%, -100, 10000, 0, 0) */
	    function NPER(rate, pmt, pv, fv, type) { // NPER(rate,pmt,pv,[fv],[type])
	        if (!rate) {
	            return -(fv + pv) / pmt;
	        }
	        var h1 = pmt*(1 + rate*type);
	        return Math.log((h1 - fv*rate)/(h1 + pv*rate)) / Math.log(1 + rate);
	    }

	    //// RATE (the interest rate per period) ////
	    /* I borrow £1000 over 1 year making payments of £100 per month at the end of each
	       month. What is the monthly interest rate: =RATE(12, −100, 1000, 0, 0, 0) */

	    function RATE (nper, pmt, pv, fv, type, guess) { // RATE(nper, pmt, pv, [fv], [type], [guess])
	        function xfd(x) { // returns F(x) and F'(x), where F is given by the equation [1]
	            var h2 = Math.pow(1+x, nper-1), h1 = h2*(1+x);
	            return [ pv*h1 + pmt*(1/x + type)*(h1 - 1) + fv,
	                     nper*pv*h2 + pmt*(-(h1 - 1)/(x*x) + (1/x + type)*nper*h2) ];
	        }
	        return root_newton(xfd, guess); // a root of the equation F(x)=0
	    }

	    //// IPMT (interest part of a loan or investment) ////
	    //// PPMT (principal part of a loan) ////

	    function IPMT(rate, per, nper, pv, fv, type) { // IPMT(rate, per, nper, pv, [fv], [type])
	        if(type==1 && per==1) { // interest before beginnig of the payments... = ZERO
	            return 0;
	        }
	        var pmt = PMT(rate, nper, pv, fv, type);
	        var ipmt = FV(rate, per - 1, pmt, pv, type) * rate;
	        return type ? ipmt/(1 + rate) : ipmt;
	    }

	    function PPMT(rate, per, nper, pv, fv, type) { // PPMT(rate, per, nper, pv, [fv], [type])
	        var pmt = PMT(rate, nper, pv, fv, type);
	        return pmt - IPMT(rate, per, nper, pv, fv, type);
	    }

	    //// CUMPRINC (cumulative principal paid) ////
	    /* The amount financed is $200,000 at an interest rate of 7.25% for 30 years. How much is the amount of principal
	       and the amount of interest paid in the first year: CUMPRINC(0.0725/12, 12*30, 200000, 1, 12, 0)
	       and CUMIPMT(0.0725/12, 12*30, 200000, 1, 12, 0) */
	    function CUMPRINC(rate, nper, pv, start, end, type) { // CUMPRINC(rate, nper, pv, start_period, end_period, type)
	        if(type == 1) { // start >= 1 (as in Excel), but if pay at beginning of the period (type==1),
	            start --;    // then periods must be counted from Zero (decreasing given start and end parameters)
	            end --;
	        }
	        var tn = Math.pow(1 + rate, nper),
	            ts = Math.pow(1 + rate, start-1),
	            te = Math.pow(1 + rate, end);
	        var monthlyPayment = rate * pv * tn / (tn - 1);
	        var remainingBalanceAtStart = ts * pv - ((ts - 1) / rate) * monthlyPayment;
	        var remainingBalanceAtEnd = te * pv - ((te - 1) / rate) * monthlyPayment;
	        return remainingBalanceAtEnd - remainingBalanceAtStart;
	    }

	    //// CUMIPMT (cumulative  interest paid) ////
	    function CUMIPMT(rate, nper, pv, start, end, type) { // CUMIPMT(rate, nper, pv, start_period, end_period, type)
	        var cip = 0;
	        for(var i=start; i<=end; i++) {
	            cip += IPMT(rate, i, nper, pv, 0, type);
	        }
	        return cip;
	    }

	    //// NPV (Net Present Value of an investment based on a series of periodic cash flows and a discount rate) ////
	    function NPV(rate, flows) { // NPV(rate,value1,[value2],...)
	        var npv = 0;
	        for(var i=0, n=flows.length; i < n; i++) {
	            npv += flows[i]*Math.pow(1 + rate, -i-1);
	        }
	        return npv;
	    }

	    //// IRR (Internal Rate of Return on an investment based on a series of periodic cash flows) ////
	    function IRR(flows, guess) { // IRR(values, [guess])
	        function xfd(x) {
	            var npv = 0, npv1 = 0;
	            for(var j=0, n=flows.length; j < n; j++) {
	                npv += flows[j]*Math.pow(1 + x, -j-1); // construct the NPV(x) value,
	                npv1 += -j*flows[j]*Math.pow(1+x, -j-2); // the value in x of the NPV()-derivative
	            }
	            return [npv, npv1];
	        }
	        return root_newton(xfd, guess);
	    }

	    //// EFFECT (effective annual interest rate) ////
	    /* which investment option is better - one that pays 5 percent after one year, or a
	       savings account that pays a monthly interest of 4.75 percent:
	       = (5% - EFFECT(4.75%, 12)) * 10000 */
	    function EFFECT(nominal_rate, npery) { // EFFECT(nominal_rate, npery)
	        return Math.pow(1 + nominal_rate/npery, npery) - 1;
	    }

	    //// NOMINAL (nominal annual interest rate) ////
	    function NOMINAL(effect_rate, npery) { // NOMINAL(effect_rate, npery)
	        return npery*(Math.pow(effect_rate + 1, 1/npery) - 1);
	    }

	    //// XNPV (Net Present Value of a series of cashflows at irregular intervals) ////
	    function XNPV(rate, values, dates) { // XNPV(rate, values, dates)
	        var npv = 0;
	        for(var i=0, n=values.length; i < n; i++) {
	            npv += values[i]*Math.pow(1 + rate, (dates[0]-dates[i])/365);
	        }
	        return npv;
	    }

	    //// XIRR (Internal Rate of Return of a series of cashflows at irregular intervals) ////
	    function XIRR(values, dates, guess) { // XIRR(values, dates, [guess])
	        function xfd(x) {
	            var npv = values[0], npv1 = 0;
	            for(var j=1, n=values.length; j < n; j++) {
	                var delta = (dates[0] - dates[j]) / 365;
	                npv += values[j]*Math.pow(1 + x, delta); // construct the XNPV(x) value,
	                npv1 += delta*values[j]*Math.pow(1+x, delta - 1); // the value in x of the XNPV()-derivative
	            }
	            return [npv, npv1];
	        }
	        return root_newton(xfd, guess); // , 100, 0.1);
	    }

	    //// ISPMT (Interest paid during a Specific Period of an investment) ////
	    function ISPMT(rate, per, nper, pv) { // ISPMT(rate, per, nper, pv)
	        var tmp = -pv*rate;
	        return tmp*(1 - per/nper);
	    }

	    //// DB (Declining Balance depreciation) ////
	    function DB(cost, salvage, life, period, month) { // DB(cost, salvage, life, period, [month])
	        var rate = 1 - Math.pow(salvage/cost, 1/life);
	        rate = Math.floor(rate*1000 + 0.5) / 1000; // rounded to three decimals
	        var db = cost * rate * month / 12;
	        if(period == 1) {
	            return db;
	        }
	        for(var i=1; i < life; i++) {
	            if(i == period - 1) {
	                return (cost - db) * rate;
	            }
	            db += (cost - db) * rate;
	        }
	        return (cost - db) * rate * (12 - month) / 12;
	    }

	    //// DDB (Double Declining Balance depreciation) ////
	    function DDB(cost, salvage, life, period, factor) { // DDB(cost, salvage, life, period, [factor])
	        var f = factor / life;
	        var prior = -cost * (Math.pow(1-f, period-1) - 1);
	        var dep = (cost - prior) * f;
	        /* Depreciation cannot exceed book value.  */
	        dep = Math.min(dep, Math.max(0, cost - prior - salvage));
	        return dep;
	    }

	    //// SLN (straight-line depreciation) ////
	    function SLN(cost, salvage, life) { // SLN(cost, salvage, life)
	        return (cost - salvage) / life;
	    }

	    //// SYD (Sum-of-Years' digits Depreciation) ////
	    function SYD(cost, salvage, life, per) { // SYD(cost, salvage, life, per)
	        return (cost - salvage) * (life - per + 1) * 2 / (life * (life + 1));
	    }

	    //// VDB (Variable Declining Balance) ////
	    //
	    // Code adapted from Gnumeric, which in turn took it from OpenOffice.  The original code is
	    // available under GNU Lesser General Public License (LGPL).
	    // https://github.com/GNOME/gnumeric/blob/master/plugins/fn-financial/sc-fin.c
	    function VDB (cost, salvage, life, start, end, factor, no_switch) {
	        var interest = factor >= life ? 1 : factor / life;

	        function _getGDA(value, period) {
	            var gda, oldValue, newValue;
	            if (interest == 1) {
	                oldValue = period == 1 ? value : 0;
	            } else {
	                oldValue = value * Math.pow(1 - interest, period - 1);
	            }
	            newValue = value * Math.pow(1 - interest, period);
	            gda = newValue < salvage ? oldValue - salvage : oldValue - newValue;
	            return gda < 0 ? 0 : gda;
	        }

	        function _interVDB(cost, life1, period) {
	            var remValue = cost - salvage;
	            var intEnd = Math.ceil(period);
	            var term, lia = 0, vdb = 0, nowLia = false;
	            for (var i = 1; i <= intEnd; i++) {
	                if (!nowLia) {
	                    var gda = _getGDA(cost, i);
	                    lia = remValue / (life1 - i + 1);
	                    if (lia > gda) {
	                        term = lia;
	                        nowLia = true;
	                    } else {
	                        term = gda;
	                        remValue -= gda;
	                    }
	                } else {
	                    term = lia;
	                }
	                if (i == intEnd) {
	                    term *= period + 1 - intEnd;
	                }
	                vdb += term;
	            }
	            return vdb;
	        }

	        var intStart = Math.floor(start), intEnd = Math.ceil(end);
	        var vdb = 0;
	        if (no_switch) {
	            for (var i = intStart + 1; i <= intEnd; i++) {
	                var term = _getGDA(cost, i);
	                if (i == intStart + 1) {
	                    term *= Math.min(end, intStart + 1) - start;
	                } else {
	                    if (i == intEnd) {
	                        term *= end + 1 - intEnd;
	                    }
	                }
	                vdb += term;
	            }
	        } else {
	            var life1 = life;
	            if (start != Math.floor(start)) {
	                if (factor > 1) {
	                    if (start >= life / 2) {
	                        var part = start - life / 2;
	                        start = life / 2;
	                        end -= part;
	                        life1 += 1;
	                    }
	                }
	            }
	            cost -= _interVDB(cost, life1, start);
	            vdb = _interVDB(cost, life - start, end - start);
	        }
	        return vdb;
	    }

	    /*************************************************************************************/

	    /*   (from  http://beginnersinvest.about.com)
	         an investor agrees to loan money to a company or government in exchange for a predetermined interest rate for a pre-determined length of time.

	         If an investor wanted to buy a $25,000 Coca-Cola bond with a 30 year maturity and an 10% coupon, it would work like this: He would send in the $25,000 from his savings account and get a $25,000 engraved bond certificate in exchange. After 30 years, he would be able to get his whole $25,000 back from the Coca-Cola company (of course, he can always sell it before then if he needs the money).

	         Every year, he’s entitled to receive 10% interest on the money he lent, or $2,500. Since most companies in the United States pay interest semi-annually, he would likely have 60 coupons attached to his bond for $1,250 each.
	         Every June 30th and December 31st, the investor would go down, clip the proper coupon, send it in, and get their money.

	         Although the practice is now defunct, the terminology stuck and interest payments on bonds will forever be known as coupons.
	    */


	    // "Use EDATE to calculate maturity dates or due dates that fall on the same day of the month as the date of issue."
	    // See also: DATEDIF, DAY, DAYS, DAY360, EOMONTH (wich can be useful to determine limits of coupon periods)
	    function _edate(base, months) { // EDATE(start_date, months)
	        var d = unpackDate(base);
	        var m = d.month + months;
	        var y = d.year + Math.floor(m/12);
	        m %= 12;
	        if (m < 0) {
	            m += 12;
	        }
	        d = Math.min(d.date, daysInMonth(y, m));
	        return packDate(y, m, d);
	    }

	    function _daysBetween(from, to, basis) {
	        if (basis == 1 || basis == 2 || basis == 3) { // Actual/Actual || Actual/360 || Actual/365
	            return to - from;
	        }
	        return _days_360(from, to, basis);
	    }

	    // Find coupon dates that enclose the settlement date, counting backward from the maturity date.
	    /* independent of the 'basis' convention to count days - here we have no need to count days */
	    function _borderCoupons(settlement, maturity, freq) {
	        var sett = unpackDate(settlement), base = unpackDate(maturity);
	        var periods = base.year - sett.year;
	        if (periods > 0) {
	            periods = (periods - 1) * freq;
	        }
	        var prev, next, months = 12/freq;
	        do {
	            periods++;
	            prev = _edate(maturity, - periods*months);
	        } while (settlement < prev);
	        periods--;
	        next = _edate(maturity, - periods*months);
	        return [ prev, next ];
	    }

	    // Find coupon dates that enclose the settlement date, counting forward from the first-coupon payment.
	    /* independent of the 'basis' convention to count days - here we have no need to count days */
	    function _borderCoupons_fw(first, settlement, freq) {
	        var sett = unpackDate(settlement), base = unpackDate(first);
	        var periods = sett.year - base.year;
	        if (periods > 0) {
	            periods = (periods - 1) * freq;
	        }
	        var prev = first, next, months = 12/freq;
	        while (settlement > prev) {
	            next = prev;
	            periods++;
	            prev = _edate(first, periods*months);
	        }
	        return [ next, prev ];
	    }

	    //// COUPDAYBS (COUPon DAYs Beginning to Settlement) ////
	    /* returns the number of days from the beginning of the coupon period to the settlement date */
	    function COUPDAYBS(settlement, maturity, frequency, basis) { // COUPDAYBS(settlement, maturity, frequency, [basis])
	        var prev = _borderCoupons(settlement, maturity, frequency)[0];
	        return _daysBetween(prev, settlement, basis);
	    }

	    //// COUPDAYS (COUPon DAYs containing Settlement) ////
	    /* Returns the number of days in the coupon period that contains the settlement date */
	    function COUPDAYS(settl, matur, freq, basis) { // COUPDAYS(settlement, maturity, frequency, [basis])
	        if (basis == 1) {
	            var borders = _borderCoupons(settl, matur, freq);
	            return _daysBetween(borders[0], borders[1], 1);
	        }
	        if (basis == 3) {
	            return 365/freq;
	        }
	        return 360/freq;
	    }

	    //// COUPDAYSNC (COUPon DAYs Settlement to Next Coupon) ////
	    /* Returns the number of days from the settlement date to the next coupon date */
	    function COUPDAYSNC(settl, matur, freq, basis) { // COUPDAYSNC(settlement, maturity, frequency, [basis])
	        var next = _borderCoupons(settl, matur, freq)[1];
	        return _daysBetween(settl, next, basis);
	    }

	    //// COUPPCD (COUPon, Previous Coupon Date) ////
	    /* Returns the previous coupon date before the settlement date */
	    function COUPPCD(settl, matur, freq/*, basis*/) { // COUPPCD(settlement, maturity, frequency, [basis])
	        // It is no need to count days, so 'basis' becomes a inutil parameter.
	        return _borderCoupons(settl, matur, freq)[0];
	    }

	    //// COUPNCD (COUPon, Next Coupon Date) ////
	    /* Returns the next coupon date after the settlement date */
	    function COUPNCD(settl, matur, freq/*, basis*/) { // COUPNCD(settlement, maturity, frequency, [basis])
	        // It is no need to count days, so 'basis' becomes a inutil parameter.
	        return _borderCoupons(settl, matur, freq)[1];
	    }

	    function COUPNUM(settl, matur, freq/*, basis*/) { // COUPNUM(settlement, maturity, frequency, [basis])
	        var sett = unpackDate(settl),
	            mat = unpackDate(matur);
	        var months = 12*(mat.year - sett.year) + mat.month - sett.month;
	        //// Discount the last month if there are not enough days? Finally - we decide to not discount.
	        //// (if this "last month" have 2 days, Excel.COUPNUM returns 6 but GoogleSpreads give only 5)
	        //    var res = _edate(matur, -months);
	        //    if (sett.date >= unpackDate(res).date) {
	        //        months--; // an incomplete last month correspond to a qvasi-coupon period
	        //    }
	        return 1 + (months * freq / 12 | 0);
	    }

	    function daysInYear(yr, basis) {
	        if (basis == 3) { return 365; }
	        if (basis == 1) { return isLeapYear(yr) ? 366 : 365; }
	        return 360;
	    }

	    //// ACCRINTM  the accrued interest for a security that pays interest at maturity ////
	    function ACCRINTM(issue, maturity, rate, par, basis) { // ACCRINTM(issue, settlement, rate, par, [basis])
	        var year_days = daysInYear(unpackDate(maturity).year, basis); // 360;
	        return rate*par * _daysBetween(issue, maturity, basis) / year_days;
	    }

	    function ACCRINT(issue, first, settl, rate, par, freq, basis, calc) {
	        var accr = 0, cost = par * rate / freq;
	        var brace, prev, next, prev1, next1, nrc;

	        var annual = basis % 2 === 0 ? 360 : 365; // only if to >> from, we eventually need to count leap years
	        function _numCoupons(from, to) { // better than COUPNUM(from, to, freq, basis)-1
	            return (to - from)*freq/annual | 0;
	        }

	        if (settl <= first) {
	            brace = _borderCoupons(settl, first, freq);
	            prev = brace[0];
	            next = brace[1];
	            if (prev <= issue) {
	                return cost * _daysBetween(issue, settl, basis) / _daysBetween(prev, next, basis);
	            }
	            brace = _borderCoupons(issue, prev, freq);
	            prev1 = brace[0];
	            next1 = brace[1];
	            nrc = _numCoupons(next1, settl); // when settl==next, days are counted implicitly by nrc
	            return cost *
	                (nrc +
	                 _daysBetween(issue, next1, basis) / _daysBetween(prev1, next1, basis) +
	                 (settl < next? _daysBetween(prev, settl, basis) / _daysBetween(prev, next, basis) : 0));
	        } else {
	            brace = _borderCoupons_fw(first, settl, freq);
	            prev = brace[0];
	            next = brace[1];
	            nrc = _numCoupons(first, settl); // COUPNUM(first, settl, freq, basis) - 1;
	            if (next == settl) {
	                accr = cost * nrc;
	            } else {
	                accr = cost * (nrc + _daysBetween(prev, settl, basis) / _daysBetween(prev, next, basis));
	            }
	            if (!calc) { return accr; } // Only the accrued interest between first and settlement dates.
	            brace = _borderCoupons(issue, first, freq); // Add the accrued interest between issue and first dates.
	            prev = brace[0];
	            next = brace[1];
	            nrc = _numCoupons(issue, first);
	            accr += cost * (nrc + _daysBetween(issue, next, basis) / _daysBetween(prev, next, basis));
	            return accr; // accrued interest between issue and settlement dates
	        }
	    }

	    //// DISC  the discount rate for a security (given price and redemption values per 100$ face value) ////
	    function DISC(settl, matur, pr, redemption, basis) { // DISC(settlement, maturity, pr, redemption, [basis])
	        var annual = basis % 2 === 0 ? 360 : (isLeapYear(unpackDate(settl).year) ? 366 : 365);
	        return (redemption - pr)/redemption*annual/_daysBetween(settl, matur, basis);
	    }

	    //// INTRATE  the interest rate for a fully invested security ////
	    function INTRATE(settl, matur, investment, redemption, basis) { // INTRATE(settlement, maturity, investment, redemption, [basis])
	        var annual = basis % 2 === 0 ? 360 : (isLeapYear(unpackDate(settl).year) ? 366 : 365);
	        return (redemption - investment)/investment*annual/_daysBetween(settl, matur, basis);
	    }

	    //// RECEIVED  the amount received at maturity for a fully invested security ////
	    function RECEIVED(settl, matur, investment, discount, basis) { // RECEIVED(settlement, maturity, investment, discount, [basis])
	        var annual = basis % 2 === 0 ? 360 : (isLeapYear(unpackDate(settl).year) ? 366 : 365);
	        return investment/(1 - discount*_daysBetween(settl, matur, basis)/annual);
	    }

	    //// PRICE  the price per $100 face value of a security that pays periodic interest ////
	    function PRICE(settl, matur, rate, yld, redemption, freq, basis) { // PRICE(settlement, maturity, rate, yld, redemption, frequency, [basis])
	        var N = 1 + ((matur - settl)*freq/(basis % 2 === 0 ? 360 : 365) | 0); // coupons playable between settlement and maturity dates
	        var brace = _borderCoupons(settl, matur, freq),
	            prev = brace[0], next = brace[1];
	        var beg_settl = _daysBetween(prev, settl, basis),
	            settl_end = _daysBetween(settl, next, basis),
	            beg_end = _daysBetween(prev, next, basis);
	        var den = 100*rate/freq,
	            yf = yld/freq,
	            frac = settl_end / beg_end;
	        if (N == 1) {
	            return (redemption + den)/(1 + frac*yf) - beg_settl / beg_end * den;
	        }
	        return redemption / Math.pow(1 + yf, N-1+frac)
	            + den * Math.pow(1 + yf, 1-N-frac) * (Math.pow(1+yf, N) - 1) / yf
	            - beg_settl / beg_end * den;
	    }

	    //// PRICEDISC  the price per $100 face value of a discounted security ////
	    function PRICEDISC(settl, matur, discount, redemption, basis) { // PRICEDISC(settlement, maturity, discount, redemption, [basis])
	        var dsm = _daysBetween(settl, matur, basis),
	            dy = daysInYear(unpackDate(matur).year, basis);
	        return redemption - discount*redemption*dsm/dy;
	    }

	    // Used in PEARSON, more could follow.  In some situations Excel appears to silently ignore
	    // missing or non-numeric values, for example if some value in a is missing a corresponding
	    // value in b, then the one in a is going to be ignored as if not present.  Arrays must have the
	    // same number of elements.  I couldn't come up with a good name for this function.
	    function whipNumberArrays(a, b) {
	        for (var i = a.length; --i >= 0;) {
	            if (typeof a[i] != "number" || typeof b[i] != "number") {
	                a.splice(i, 1);
	                b.splice(i, 1);
	            }
	        }
	    }

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "dGGS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        animationCloseEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.close.effects'
        },
        animationCloseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.close.duration'
        },
        animationOpenEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.open.effects'
        },
        animationOpenDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.open.duration'
        }
    }
};

/***/ }),

/***/ "dIwP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "dSzd":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("e8AB")('wks');
var uid = __webpack_require__("3Eo+");
var Symbol = __webpack_require__("7KvD").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "dVOP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "dWoE":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1378);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1378:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "scheduler.view",
	    name: "Scheduler View",
	    category: "web",
	    description: "The Scheduler Common View",
	    depends: [ "core" ],
	    hidden: true
	};
	    kendo.ui.scheduler = {};
	/* jshint eqnull: true */
	(function($) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        getDate = kendo.date.getDate,
	        Widget = ui.Widget,
	        outerHeight = kendo._outerHeight,
	        keys = kendo.keys,
	        NS = ".kendoSchedulerView",
	        INVERSE_COLOR_CLASS = "k-event-inverse",
	        MIN_HORIZONTAL_SCROLL_SIZE = 1024,
	        math = Math;

	    function levels(values, key) {
	        var result = [];

	        function collect(depth, values) {
	            values = values[key];

	            if (values) {
	                var level = result[depth] = result[depth] || [];

	                for (var idx = 0; idx < values.length; idx++) {
	                    level.push(values[idx]);
	                    collect(depth + 1, values[idx]);
	                }
	            }
	        }

	        collect(0, values);

	        return result;
	    }

	    function cellspacing() {
	        if (kendo.support.cssBorderSpacing) {
	            return "";
	        }

	        return 'cellspacing="0"';
	    }

	    function table(tableRows, className) {
	        if (!tableRows.length) {
	            return "";
	        }

	        return '<table role="presentation"' + cellspacing() + ' class="' + kendo.trim('k-scheduler-table ' + (className || "")) + '">' +
	               '<tr>' +
	                    tableRows.join("</tr><tr>") +
	               '</tr>' +
	               '</table>';
	    }

	    function allDayTable(tableRows, className) {
	        if (!tableRows.length) {
	            return "";
	        }

	        return "<div style='position:relative'>" + table(tableRows, className) + "</div>";
	    }

	    function timesHeader(columnLevelCount, allDaySlot, rowCount) {
	        var tableRows = [];

	        if (rowCount > 0) {
	            for (var idx = 0; idx < columnLevelCount; idx++) {
	                tableRows.push("<th>&#8203;</th>");
	            }
	        }

	        if (allDaySlot) {
	            tableRows.push('<th class="k-scheduler-times-all-day">' + allDaySlot.text + '</th>');
	        }

	        if (rowCount < 1) {
	           return $();
	        }

	        return $('<div class="k-scheduler-times">' + table(tableRows) + '</div>');
	    }

	    function datesHeader(columnLevels, columnCount, allDaySlot) {
	        var dateTableRows = [];
	        var columnIndex;

	        for (var columnLevelIndex = 0; columnLevelIndex < columnLevels.length; columnLevelIndex++) {
	            var level = columnLevels[columnLevelIndex];
	            var th = [];
	            var colspan = columnCount / level.length;

	            for (columnIndex = 0; columnIndex < level.length; columnIndex ++) {
	                var column = level[columnIndex];

	                th.push('<th colspan="' + (column.colspan || colspan) + '" class="' + (column.className || "")  + '">' + column.text + "</th>");
	            }

	            dateTableRows.push(th.join(""));
	        }

	        var allDayTableRows = [];

	        if (allDaySlot) {
	            var lastLevel = columnLevels[columnLevels.length - 1];
	            var td = [];
	            var cellContent = allDaySlot.cellContent;

	            for (columnIndex = 0; columnIndex < lastLevel.length; columnIndex++) {
	                td.push('<td class="' + (lastLevel[columnIndex].className || "")  + '">' + (cellContent ? cellContent(columnIndex) : '&nbsp;') + '</td>');
	            }

	            allDayTableRows.push(td.join(""));
	        }

	        return $(
	            '<div class="k-scheduler-header k-state-default">' +
	                '<div class="k-scheduler-header-wrap">' +
	                    table(dateTableRows) +
	                    allDayTable(allDayTableRows, "k-scheduler-header-all-day") +
	                '</div>' +
	            '</div>'
	        );
	    }

	    function times(rowLevels, rowCount, isMobile) {
	        var rows = new Array(rowCount).join().split(",");
	        var rowHeaderRows = [];
	        var rowIndex;

	        for (var rowLevelIndex = 0; rowLevelIndex < rowLevels.length; rowLevelIndex++) {
	            var level = rowLevels[rowLevelIndex];
	            var rowspan = rowCount / level.length;
	            var className;
	            var text;

	            for (rowIndex = 0; rowIndex < level.length; rowIndex++) {
	                className = level[rowIndex].className || "";
	                text = level[rowIndex].text;

	                if (level[rowIndex].allDay) {
	                    className = "k-scheduler-times-all-day";
	                }

	                if (isMobile && className.indexOf("k-scheduler-group-cell") !== -1) {
	                    text = '<span class="k-scheduler-group-text">' + text + '</span>';
	                }

	                rows[rowspan * rowIndex] += '<th class="' + className + '" rowspan="' + rowspan + '">' + text + "</th>";
	            }
	        }

	        for (rowIndex = 0; rowIndex < rowCount; rowIndex++) {
	            rowHeaderRows.push(rows[rowIndex]);
	        }

	        if (rowCount < 1) {
	            return $();
	        }

	        return $('<div class="k-scheduler-times">' + table(rowHeaderRows) + '</div>');
	    }

	    function content() {
	        return $(
	            '<div class="k-scheduler-content">' +
	                '<table role="presentation"' + cellspacing() + ' class="k-scheduler-table"></table>' +
	            '</div>'
	        );
	    }
	    var HINT = '<div class="k-marquee k-scheduler-marquee">' +
	                    '<div class="k-marquee-color"></div>' +
	                    '<div class="k-marquee-text">' +
	                        '<div class="k-label-top"></div>' +
	                        '<div class="k-label-bottom"></div>' +
	                    '</div>' +
	                '</div>';


	    var ResourceView = kendo.Class.extend({
	        init: function(index, isRtl) {
	            this._index = index;
	            this._timeSlotCollections = [];
	            this._daySlotCollections = [];
	            this._isRtl = isRtl;
	        },

	        addTimeSlotCollection: function(startDate, endDate) {
	            return this._addCollection(startDate, endDate, this._timeSlotCollections);
	        },

	        addDaySlotCollection: function(startDate, endDate) {
	            return this._addCollection(startDate, endDate, this._daySlotCollections);
	        },

	        _addCollection: function(startDate, endDate, collections) {
	            var collection = new SlotCollection(startDate, endDate, this._index, collections.length);

	            collections.push(collection);

	            return collection;
	        },

	        timeSlotCollectionCount: function() {
	            return this._timeSlotCollections.length;
	        },

	        daySlotCollectionCount: function() {
	            return this._daySlotCollections.length;
	        },

	        daySlotByPosition: function(x, y, byDate) {
	            return this._slotByPosition(x, y, this._daySlotCollections, byDate);
	        },

	        timeSlotByPosition: function(x, y, byDate) {
	            return this._slotByPosition(x, y, this._timeSlotCollections, byDate);
	        },

	        _slotByPosition: function(x, y, collections, byDate) {
	           for (var collectionIndex = 0; collectionIndex < collections.length; collectionIndex++) {
	               var collection = collections[collectionIndex];

	               for (var slotIndex = 0; slotIndex < collection.count(); slotIndex++) {
	                   var slot = collection.at(slotIndex);
	                   var width = slot.offsetWidth;
	                   var height = slot.offsetHeight;
	                   var nextSlot;

	                   var horizontalEnd = slot.offsetLeft + width;
	                   var verticalEnd =  slot.offsetTop + height;

	                   if (!byDate) {
	                        nextSlot =  collection.at(slotIndex + 1);
	                   }

	                   if (nextSlot) {
	                       if (nextSlot.offsetLeft != slot.offsetLeft) {
	                           if (this._isRtl) {
	                               horizontalEnd = slot.offsetLeft + (slot.offsetLeft - nextSlot.offsetLeft);
	                           } else {
	                               horizontalEnd = nextSlot.offsetLeft;
	                           }
	                       } else {
	                           verticalEnd = nextSlot.offsetTop;
	                       }
	                   }

	                   if (x >= slot.offsetLeft && x < horizontalEnd &&
	                       y >= slot.offsetTop && y < verticalEnd) {
	                       return slot;
	                   }
	               }
	           }
	        },

	        refresh: function() {
	            var collectionIndex;

	            for (collectionIndex = 0; collectionIndex < this._daySlotCollections.length; collectionIndex++) {
	                this._daySlotCollections[collectionIndex].refresh();
	            }

	            for (collectionIndex = 0; collectionIndex < this._timeSlotCollections.length; collectionIndex++) {
	                this._timeSlotCollections[collectionIndex].refresh();
	            }
	        },

	        timeSlotRanges: function(startTime, endTime) {
	            var collections = this._timeSlotCollections;

	            var start = this._startSlot(startTime, collections);

	            if (!start.inRange && startTime >= start.slot.end) {
	                start = null;
	            }

	            var end = start;

	            if (startTime < endTime) {
	                end = this._endSlot(endTime, collections);
	            }

	            if (end && !end.inRange && endTime <= end.slot.start) {
	                end = null;
	            }

	            if (start === null && end === null) {
	                return [];
	            }

	            if (start === null) {
	                if (end.slot.end <= startTime) {
	                    return [];
	                }

	                start = {
	                    inRange: true,
	                    slot: collections[end.slot.collectionIndex].first()
	                };
	            }

	            if (end === null) {
	                if (start.slot.start >= endTime) {
	                    return [];
	                }

	                end = {
	                    inRange: true,
	                    slot: collections[start.slot.collectionIndex].last()
	                };
	            }

	            return this._continuousRange(TimeSlotRange, collections, start, end);
	        },

	        daySlotRanges: function(startTime, endTime, isAllDay) {
	            var collections = this._daySlotCollections;

	            var start = this._startSlot(startTime, collections, isAllDay);

	            if (!start.inRange && startTime >= start.slot.end) {
	                start = null;
	            }

	            var end = start;

	            if (startTime < endTime) {
	                end = this._endSlot(endTime, collections, isAllDay);
	            }

	            if (end && !end.inRange && endTime <= end.slot.start) {
	                end = null;
	            }

	            if (start === null && end === null) {
	                return [];
	            }

	            if (start === null) {
	                if (end.slot.end <= startTime) {
	                    return [];
	                }

	                do {
	                    startTime += kendo.date.MS_PER_DAY;
	                    start = this._startSlot(startTime, collections, isAllDay);
	                } while (!start.inRange && startTime >= start.slot.end);
	            }

	            if (end === null) {
	                if (start.slot.start >= endTime) {
	                    return [];
	                }

	                do {
	                    endTime -= kendo.date.MS_PER_DAY;
	                    end = this._endSlot(endTime, collections, isAllDay);
	                } while (!end.inRange && endTime <= end.slot.start);
	            }

	            return this._continuousRange(DaySlotRange, collections, start, end);
	        },

	        _continuousRange: function(range, collections, start, end) {
	            var startSlot = start.slot;
	            var endSlot = end.slot;

	            var startIndex = startSlot.collectionIndex;
	            var endIndex = endSlot.collectionIndex;

	            var ranges = [];

	            for (var collectionIndex = startIndex; collectionIndex <= endIndex; collectionIndex++) {
	                var collection = collections[collectionIndex];

	                var first = collection.first();
	                var last = collection.last();
	                var head = false;
	                var tail = false;

	                if (collectionIndex == startIndex) {
	                    tail = !start.inRange;
	                }

	                if (collectionIndex == endIndex) {
	                    head = !end.inRange;
	                }

	                if (first.start < startSlot.start) {
	                    first = startSlot;
	                }

	                if (last.start > endSlot.start) {
	                    last = endSlot;
	                }

	                if (startIndex < endIndex) {
	                    if (collectionIndex == startIndex) {
	                        head = true;
	                    } else if (collectionIndex == endIndex) {
	                        tail = true;
	                    } else {
	                        head = tail = true;
	                    }
	                }

	                ranges.push(new range({
	                    start: first,
	                    end: last,
	                    collection: collection,
	                    head: head,
	                    tail: tail
	                }));
	            }

	            return ranges;
	        },

	        slotRanges: function(event, isDay) {
	            var startTime = event._startTime || kendo.date.toUtcTime(event.start);
	            var endTime = event._endTime || kendo.date.toUtcTime(event.end);

	            if (isDay === undefined) {
	                isDay = event.isMultiDay();
	            }

	            if (isDay) {
	                return this.daySlotRanges(startTime, endTime, event.isAllDay);
	            }

	            return this.timeSlotRanges(startTime, endTime);
	        },

	        ranges: function(startTime, endTime, isDay, isAllDay) {
	            if (typeof startTime != "number") {
	                startTime = kendo.date.toUtcTime(startTime);
	            }

	            if (typeof endTime != "number") {
	                endTime = kendo.date.toUtcTime(endTime);
	            }

	            if (isDay) {
	                return this.daySlotRanges(startTime, endTime, isAllDay);
	            }

	            return this.timeSlotRanges(startTime, endTime);
	        },

	        _startCollection: function(date, collections) {
	            for (var collectionIndex = 0; collectionIndex < collections.length; collectionIndex++) {
	                var collection = collections[collectionIndex];

	                if (collection.startInRange(date)) {
	                    return collection;
	                }
	            }

	            return null;
	        },

	        _endCollection: function(date, collections, isAllDay) {
	            for (var collectionIndex = 0; collectionIndex < collections.length; collectionIndex++) {
	                var collection = collections[collectionIndex];

	                if (collection.endInRange(date, isAllDay)) {
	                    return collection;
	                }
	            }

	            return null;
	        },

	        _getCollections: function(isDay) {
	            return isDay ? this._daySlotCollections : this._timeSlotCollections;
	        },

	        continuousSlot: function(slot, reverse) {
	            var pad = reverse ? -1 : 1;
	            var collections = this._getCollections(slot.isDaySlot);
	            var collection = collections[slot.collectionIndex + pad];

	            return collection ? collection[reverse ? "last" : "first"]() : undefined;
	        },

	        firstSlot: function() {
	            var collections = this._getCollections(this.daySlotCollectionCount());

	            return collections[0].first();
	        },

	        lastSlot: function() {
	            var collections = this._getCollections(this.daySlotCollectionCount());

	            return collections[collections.length - 1].last();
	        },

	        upSlot: function(slot, keepCollection, groupByDateVertically) {
	            var that = this;
	            var moveToDaySlot = function(isDaySlot, collectionIndex, index) {
	                var isFirstCell = index === 0;

	                if (!keepCollection && !isDaySlot && isFirstCell && that.daySlotCollectionCount()) {
	                    return that._daySlotCollections[0].at(collectionIndex);
	                }
	            };

	            if (!this.timeSlotCollectionCount()) {
	                keepCollection = true;
	            }

	            return this._verticalSlot(slot, -1, moveToDaySlot, groupByDateVertically);
	        },

	        downSlot: function(slot, keepCollection, groupByDateVertically) {
	            var that = this;
	            var moveToTimeSlot = function(isDaySlot, collectionIndex, index) {
	                if (!keepCollection && isDaySlot && that.timeSlotCollectionCount()) {
	                    return that._timeSlotCollections[index].at(0);
	                }
	            };

	            if (!this.timeSlotCollectionCount()) {
	                keepCollection = true;
	            }

	            return this._verticalSlot(slot, 1, moveToTimeSlot, groupByDateVertically);
	        },

	        leftSlot: function(slot, groupByDateVertically) {
	            return this._horizontalSlot(slot, -1, groupByDateVertically);
	        },

	        rightSlot: function(slot, groupByDateVertically) {
	            return this._horizontalSlot(slot, 1, groupByDateVertically);
	        },

	        _horizontalSlot: function(slot, step, groupByDateVertically) {
	            var index = slot.index;
	            var isDaySlot = slot.isDaySlot;
	            var collectionIndex = slot.collectionIndex;
	            var collections = this._getCollections(isDaySlot);

	            isDaySlot = groupByDateVertically ? false : isDaySlot;

	            if (isDaySlot) {
	                index += step;
	            } else {
	                collectionIndex += step;
	            }

	            var collection = collections[collectionIndex];

	            return collection ? collection.at(index) : undefined;
	        },

	        _verticalSlot: function(slot, step, swapCollection, groupByDateVertically) {
	            var index = slot.index;
	            var isDaySlot = slot.isDaySlot;
	            var collectionIndex = slot.collectionIndex;
	            var collections = this._getCollections(isDaySlot);

	            slot = swapCollection(isDaySlot, collectionIndex, index);
	            if (slot) {
	                return slot;
	            }

	            isDaySlot = groupByDateVertically ? false : isDaySlot;

	            if (isDaySlot) {
	                collectionIndex += step;
	            } else {
	                index += step;
	            }

	            var collection = collections[collectionIndex];

	            return collection ? collection.at(index) : undefined;
	        },

	        _collection: function(index, multiday) {
	            var collections = multiday? this._daySlotCollections : this._timeSlotCollections;

	            return collections[index];
	        },

	        _startSlot: function(time, collections, isAllDay) {
	            var collection = this._startCollection(time, collections);

	            var inRange = true;

	            if (!collection) {
	                collection = collections[0];
	                inRange = false;
	            }

	            var slot = collection.slotByStartDate(time, isAllDay);

	            if (!slot) {
	                slot = collection.first();
	                inRange = false;
	            }

	            return {
	                slot: slot,
	                inRange: inRange
	            };
	        },

	        _endSlot: function(time, collections, isAllDay) {
	            var collection = this._endCollection(time, collections, isAllDay);

	            var inRange = true;

	            if (!collection) {
	                collection = collections[collections.length - 1];
	                inRange = false;
	            }

	            var slot = collection.slotByEndDate(time, isAllDay);

	            if (!slot) {
	                slot = collection.last();
	                inRange = false;
	            }

	            return {
	                slot: slot,
	                inRange: inRange
	            };
	        },

	        getSlotCollection: function(index, isDay) {
	            return this[isDay ? "getDaySlotCollection" : "getTimeSlotCollection"](index);
	        },

	        getTimeSlotCollection: function(index) {
	            return this._timeSlotCollections[index];
	        },

	        getDaySlotCollection: function(index) {
	            return this._daySlotCollections[index];
	        }
	    });

	    var SlotRange = kendo.Class.extend({
	        init: function(options) {
	            $.extend(this, options);
	        },

	        innerHeight: function() {
	            var collection = this.collection;

	            var startIndex = this.start.index;

	            var endIndex = this.end.index;

	            var result = 0;

	            for (var slotIndex = startIndex; slotIndex <= endIndex; slotIndex++) {
	               result += collection.at(slotIndex).offsetHeight;
	            }

	            return result;
	        },

	        events: function () {
	            return this.collection.events();
	        },

	        addEvent: function(event) {
	            this.events().push(event);
	        },

	        startSlot: function() {
	            if (this.start.offsetLeft > this.end.offsetLeft) {
	                return this.end;
	            }
	            return this.start;
	        },

	        endSlot: function() {
	            if (this.start.offsetLeft > this.end.offsetLeft) {
	                return this.start;
	            }
	            return this.end;
	        }
	    });

	    var TimeSlotRange = SlotRange.extend({
	        innerHeight: function() {
	            var collection = this.collection;

	            var startIndex = this.start.index;

	            var endIndex = this.end.index;

	            var result = 0;

	            for (var slotIndex = startIndex; slotIndex <= endIndex; slotIndex++) {
	               result += collection.at(slotIndex).offsetHeight;
	            }

	            return result;
	        },

	        outerRect: function(start, end, snap) {
	            return this._rect("offset", start, end, snap);
	        },

	        _rect: function(property, start, end, snap) {
	            var top;
	            var bottom;
	            var left;
	            var right;
	            var startSlot = this.start;
	            var endSlot = this.end;
	            var isRtl = kendo.support.isRtl(startSlot.element);

	            if (typeof start != "number") {
	                start = kendo.date.toUtcTime(start);
	            }

	            if (typeof end != "number") {
	                end = kendo.date.toUtcTime(end);
	            }

	            if (snap) {
	                top = startSlot.offsetTop;
	                bottom = endSlot.offsetTop + endSlot[property + "Height"];
	                if(isRtl) {
	                    left = endSlot.offsetLeft;
	                    right = startSlot.offsetLeft + startSlot[property + "Width"];
	                } else {
	                    left = startSlot.offsetLeft;
	                    right = endSlot.offsetLeft + endSlot[property + "Width"];
	                }
	            } else {
	                var startOffset = start - startSlot.start;

	                if (startOffset < 0) {
	                    startOffset = 0;
	                }

	                var startSlotDuration = startSlot.end - startSlot.start;

	                top = startSlot.offsetTop + startSlot[property + "Height"] * startOffset / startSlotDuration;

	                var endOffset = endSlot.end - end;

	                if (endOffset < 0) {
	                    endOffset = 0;
	                }

	                var endSlotDuration = endSlot.end - endSlot.start;

	                bottom = endSlot.offsetTop + endSlot[property + "Height"] - endSlot[property + "Height"] * endOffset / endSlotDuration;

	                if(isRtl) {
	                    left = Math.round(endSlot.offsetLeft + endSlot[property + "Width"]* endOffset / endSlotDuration);
	                    right = Math.round(startSlot.offsetLeft + startSlot[property + "Width"] - startSlot[property + "Width"] * startOffset / startSlotDuration);
	                } else {
	                    left = Math.round(startSlot.offsetLeft + startSlot[property + "Width"] * startOffset / startSlotDuration);
	                    right = Math.round(endSlot.offsetLeft + endSlot[property + "Width"] - endSlot[property + "Width"] * endOffset / endSlotDuration);
	                }
	            }

	            return {
	                top: top,
	                bottom: bottom,
	                //first column has no left border
	                left: left === 0 ? left : left + 1,
	                right: right
	            };
	        },

	        innerRect: function(start, end, snap) {
	            return this._rect("client", start, end, snap);
	        }
	    });

	    var DaySlotRange = SlotRange.extend({
	        innerWidth: function() {
	            var collection = this.collection;

	            var startIndex = this.start.index;

	            var endIndex = this.end.index;

	            var result = 0;

	            var width = startIndex !== endIndex ? "offsetWidth" : "clientWidth";

	            for (var slotIndex = startIndex; slotIndex <= endIndex; slotIndex++) {
	               result += collection.at(slotIndex)[width];
	            }

	            return result;
	        }
	    });

	    var SlotCollection = kendo.Class.extend({
	        init: function(startDate, endDate, groupIndex, collectionIndex) {
	            this._slots = [];

	            this._events = [];

	            this._start = kendo.date.toUtcTime(startDate);

	            this._end = kendo.date.toUtcTime(endDate);

	            this._groupIndex = groupIndex;

	            this._collectionIndex = collectionIndex;
	        },
	        refresh: function() {
	            for (var slotIndex = 0; slotIndex < this._slots.length; slotIndex++) {
	                this._slots[slotIndex].refresh();
	            }
	        },

	        startInRange: function(date) {
	            return this._start <= date && date < this._end;
	        },

	        endInRange: function(date, isAllDay) {
	            var end = isAllDay ? date < this._end : date <= this._end;
	            return this._start <= date && end;
	        },

	        slotByStartDate: function(date) {
	            var time = date;

	            if (typeof time != "number") {
	                time = kendo.date.toUtcTime(date);
	            }

	            for (var slotIndex = 0; slotIndex < this._slots.length; slotIndex++) {
	                var slot = this._slots[slotIndex];

	                if (slot.startInRange(time)) {
	                    return slot;
	                }
	            }

	            return null;
	        },

	        slotByEndDate: function(date, allday) {
	            var time = date;

	            if (typeof time != "number") {
	                time = kendo.date.toUtcTime(date);
	            }

	            if (allday) {
	                return this.slotByStartDate(date, false);
	            }

	            for (var slotIndex = 0; slotIndex < this._slots.length; slotIndex++) {
	                var slot = this._slots[slotIndex];

	                if (slot.endInRange(time)) {
	                    return slot;
	                }
	            }

	            return null;
	        },

	        count: function() {
	            return this._slots.length;
	        },
	        events: function() {
	            return this._events;
	        },
	        addTimeSlot: function(element, start, end, isHorizontal) {
	            var slot = new TimeSlot(element, start, end, this._groupIndex, this._collectionIndex, this._slots.length, isHorizontal);

	            this._slots.push(slot);
	        },
	        addDaySlot: function(element, start, end, eventCount) {
	            var slot = new DaySlot(element, start, end, this._groupIndex, this._collectionIndex, this._slots.length, eventCount);

	            this._slots.push(slot);
	        },
	        first: function() {
	            return this._slots[0];
	        },
	        last: function() {
	            return this._slots[this._slots.length - 1];
	        },
	        at: function(index) {
	            return this._slots[index];
	        }
	    });

	    var Slot = kendo.Class.extend({
	        init: function(element, start, end, groupIndex, collectionIndex, index) {
	            this.element = element;
	            this.clientWidth = element.clientWidth;
	            this.clientHeight = element.clientHeight;
	            this.offsetWidth = element.offsetWidth;
	            this.offsetHeight = element.offsetHeight;
	            this.offsetTop = element.offsetTop;
	            this.offsetLeft = element.offsetLeft;

	            this.start = start;
	            this.end = end;
	            this.element = element;
	            this.groupIndex = groupIndex;
	            this.collectionIndex = collectionIndex;
	            this.index = index;
	            this.isDaySlot = false;
	        },

	        refresh: function() {
	            var element = this.element;

	            this.clientWidth = element.clientWidth;
	            this.clientHeight = element.clientHeight;
	            this.offsetWidth = element.offsetWidth;
	            this.offsetHeight = element.offsetHeight;
	            this.offsetTop = element.offsetTop;
	            this.offsetLeft = element.offsetLeft;
	        },

	        startDate: function() {
	            return kendo.timezone.toLocalDate(this.start);
	        },

	        endDate: function() {
	            return kendo.timezone.toLocalDate(this.end);
	        },

	        startInRange: function(date) {
	            return this.start <= date && date < this.end;
	        },

	        endInRange: function(date) {
	            return this.start < date && date <= this.end;
	        },

	        startOffset: function() {
	           return this.start;
	        },

	        endOffset: function() {
	            return this.end;
	        }
	    });

	    var TimeSlot = Slot.extend({
	        init: function(element, start, end, groupIndex, collectionIndex, index, isHorizontal) {
	            Slot.fn.init.apply(this, arguments);

	            this.isHorizontal = isHorizontal ? true : false;
	        },

	        offsetX: function(rtl, offset) {
	            if (rtl) {
	                return this.offsetLeft + offset;
	            } else {
	                return this.offsetLeft + offset;
	            }
	        },

	        startInRange: function(date) {
	            return this.start <= date && date < this.end;
	        },

	        endInRange: function(date) {
	            return this.start < date && date <= this.end;
	        },

	        startOffset: function(x, y, snap) {
	            if (snap) {
	                return this.start;
	            }

	            var offset = $(this.element).offset();

	            var duration = this.end - this.start;
	            var difference;
	            var time;

	            if (this.isHorizontal) {
	                //need update
	                var isRtl = kendo.support.isRtl(this.element);
	                difference =  x - offset.left;
	                time = Math.floor(duration * ( difference / this.offsetWidth));

	                if (isRtl) {
	                    return this.start + duration - time;
	                }
	            } else {
	                difference = y - offset.top;
	                time = Math.floor(duration * ( difference / this.offsetHeight));
	            }

	            return this.start + time;
	        },

	        endOffset: function(x, y, snap) {
	            if (snap) {
	                return this.end;
	            }

	            var offset = $(this.element).offset();

	            var duration = this.end - this.start;
	            var difference;
	            var time;

	            if (this.isHorizontal) {
	                //need update
	                var isRtl = kendo.support.isRtl(this.element);
	                difference = x - offset.left;
	                time = Math.floor(duration * ( difference / this.offsetWidth));

	                if (isRtl) {
	                    return this.start + duration - time;
	                }
	            } else {
	                difference = y - offset.top;
	                time = Math.floor(duration * ( difference / this.offsetHeight));
	            }

	            return this.start + time;
	        }
	    });

	    var DaySlot = Slot.extend({
	        init: function(element, start, end, groupIndex, collectionIndex, index, eventCount) {
	            Slot.fn.init.apply(this, arguments);

	            this.eventCount = eventCount;
	            this.isDaySlot = true;

	            if (this.element.children.length) {
	                var firstChild = this.element.children[0];

	                this.firstChildHeight = firstChild.offsetHeight;
	                this.firstChildTop = firstChild.offsetTop;
	            } else {
	                this.firstChildHeight = 3;
	                this.firstChildTop = 0;
	            }
	        },

	        startDate: function() {
	            var date = new Date(this.start);

	            return kendo.timezone.apply(date, "Etc/UTC");
	        },

	        endDate: function() {
	            var date = new Date(this.end);

	            return kendo.timezone.apply(date, "Etc/UTC");
	        },

	        startInRange: function(date) {
	            return this.start <= date && date < this.end;
	        },

	        endInRange: function(date) {
	            return this.start < date && date <= this.end;
	        }
	    });

	    var scrollbarWidth;
	    function scrollbar() {
	        scrollbarWidth = scrollbarWidth ? scrollbarWidth : kendo.support.scrollbar();
	        return scrollbarWidth;
	    }

	    kendo.ui.SchedulerView = Widget.extend({
	        init: function(element, options) {
	            Widget.fn.init.call(this, element, options);

	            this._normalizeOptions();
	            this._scrollbar = scrollbar();
	            this._isRtl = kendo.support.isRtl(element);
	            this._resizeHint = $();
	            this._moveHint = $();
	            this._cellId = kendo.guid();
	            this._resourcesForGroups();
	            this._selectedSlots = [];
	        },

	        visibleEndDate: function () {
	            return this.endDate();
	        },

	        _normalizeOptions: function() {
	            var options = this.options;

	            if (options.startTime) {
	                options.startTime.setMilliseconds(0);
	            }

	            if (options.endTime) {
	                options.endTime.setMilliseconds(0);
	            }

	            if (options.workDayStart) {
	                options.workDayStart.setMilliseconds(0);
	            }

	            if (options.workDayEnd) {
	                options.workDayEnd.setMilliseconds(0);
	            }
	        },

	        _isMobile: function() {
	            var options = this.options;
	            return (options.mobile === true && kendo.support.mobileOS) || options.mobile === "phone" || options.mobile === "tablet";
	        },

	        _addResourceView: function() {
	            var resourceView = new ResourceView(this.groups.length, this._isRtl);

	            this.groups.push(resourceView);

	            return resourceView;
	        },

	        dateForTitle: function() {
	            return kendo.format(this.options.selectedDateFormat, this.startDate(), this.endDate());
	        },

	        shortDateForTitle: function() {
	            return kendo.format(this.options.selectedShortDateFormat, this.startDate(), this.endDate());
	        },

	        mobileDateForTitle: function () {
	            return kendo.format(this.options.selectedMobileDateFormat || this.options.selectedShortDateFormat, this.startDate(), this.endDate());
	        },

	        _changeGroup: function(selection, previous) {
	            var method = previous ? "prevGroupSlot" : "nextGroupSlot";
	            var slot = this[method](selection.start, selection.groupIndex, selection.isAllDay);

	            if (slot) {
	                selection.groupIndex += previous ? -1 : 1;
	            }

	            if (this._isGroupedByDate() && !slot) {
	               selection.groupIndex = previous ? this.groups.length - 1 : 0;
	            }

	            return slot;
	        },

	        _changeDate: function(selection, slot, previous) {
	            var group = this.groups[selection.groupIndex];
	            var collections, index;

	            if (previous) {
	                  collections = group._getCollections(false);
	                  index = group.daySlotCollectionCount() ? slot.index - 1 : slot.collectionIndex - 1;

	                  if (index >= 0) {
	                      return  collections[index]._slots[collections[index]._slots.length - 1];
	                  }
	              } else {
	                  collections = group._getCollections(group.daySlotCollectionCount());
	                  index = group.daySlotCollectionCount() ? 0 : slot.collectionIndex + 1;
	                  var slotIndex = group.daySlotCollectionCount() ? slot.collectionIndex + 1 : 0;

	                  if (collections[index] && collections[index]._slots[slotIndex]) {
	                      return  collections[index]._slots[slotIndex];
	                  }
	               }
	        },

	        _changeGroupContinuously: function() {
	            return null;
	        },

	        _changeViewPeriod: function() {
	            return false;
	        },

	        _isInRange: function(newStart, newEnd) {
	            if(!newStart || !newEnd || !this.options.min || !this.options.max){
	                return false;
	            }
	            return getDate(newStart) <= getDate(this.options.min) || getDate(newEnd) >= getDate(this.options.max);
	        },

	        _horizontalSlots: function(selection, ranges, multiple, reverse) {
	            var method = reverse ? "leftSlot" : "rightSlot";
	            var horizontalRange = {
	                 startSlot: ranges[0].start,
	                 endSlot: ranges[ranges.length - 1].end
	             };
	            var group = this.groups[selection.groupIndex];
	            var isVertical = this._isVerticallyGrouped();

	            if (!multiple) {
	                var slot = this._normalizeHorizontalSelection(selection, ranges, reverse);
	                if (slot) {
	                    horizontalRange.startSlot = horizontalRange.endSlot = slot;
	                }
	            }

	            if (this._isGroupedByDate() && !multiple) {
	                  var tempSlot = this._changeGroup(selection, reverse);

	                  if(!tempSlot)
	                  {
	                    horizontalRange = this._getNextHorizontalRange(group, method, horizontalRange);
	                  } else {
	                      horizontalRange.startSlot = horizontalRange.endSlot = tempSlot;
	                  }
	            } else {
	                  horizontalRange.startSlot = group[method](horizontalRange.startSlot);
	                  horizontalRange.endSlot = group[method](horizontalRange.endSlot);

	                  if (!multiple && !isVertical && (!horizontalRange.startSlot || !horizontalRange.endSlot)) {
	                        horizontalRange.startSlot = horizontalRange.endSlot = this._changeGroup(selection, reverse);
	                  }
	            }

	            var continuousSlot;

	            if ((!horizontalRange.startSlot || !horizontalRange.endSlot) && !this._isGroupedByDate()) {
	                continuousSlot = this._continuousSlot(selection, ranges, reverse);
	                continuousSlot = this._changeGroupContinuously(selection, continuousSlot, multiple, reverse);

	                if (continuousSlot) {
	                    horizontalRange.startSlot = horizontalRange.endSlot = continuousSlot;
	                }
	            }

	            return horizontalRange;
	        },

	         _getNextHorizontalRange: function(group, method, horizontalRange){
	            if(!this._isVerticallyGrouped()){
	                horizontalRange.startSlot = group[method](horizontalRange.startSlot);
	                horizontalRange.endSlot = group[method](horizontalRange.endSlot);
	            }

	             return horizontalRange;
	        },

	        _verticalSlots: function(selection, ranges, multiple, reverse) {
	            var group = this.groups[selection.groupIndex];
	            var slot;
	            var verticalRange = {
	                startSlot: ranges[0].start,
	                endSlot: ranges[ranges.length - 1].end
	            };

	            if (!multiple) {
	                slot = this._normalizeVerticalSelection(selection, ranges, reverse);
	                if (slot) {
	                    verticalRange.startSlot = verticalRange.endSlot = slot;
	                }
	            }

	            var method = reverse ? "upSlot" : "downSlot";

	            verticalRange = this._getNextVerticalRange(group, method, verticalRange, multiple);

	            if (!multiple && this._isVerticallyGrouped() && (!verticalRange.startSlot || !verticalRange.endSlot)) {
	                if (this._isGroupedByDate()) {
	                    verticalRange.startSlot = verticalRange.endSlot = this._changeDate(selection, slot, reverse);

	               }else{
	                    verticalRange.startSlot = verticalRange.endSlot = this._changeGroup(selection, reverse);
	               }
	            }

	            return verticalRange;
	        },

	        _getNextVerticalRange: function(group, method, verticalRange, multiple){
	             verticalRange.startSlot = group[method](verticalRange.startSlot, multiple);
	             verticalRange.endSlot = group[method](verticalRange.endSlot, multiple);

	             return verticalRange;
	        },

	        _normalizeHorizontalSelection: function() {
	            return null;
	        },

	        _normalizeVerticalSelection: function(selection, ranges, reverse) {
	            var slot;

	            if (reverse) {
	                slot = ranges[0].start;
	            } else {
	                slot = ranges[ranges.length - 1].end;
	            }

	            return slot;
	        },

	        _continuousSlot: function() {
	            return null;
	        },

	        _footer: function() {
	            var that = this;
	            var options = that.options;

	            if (that._isMobile()) {
	                var html = '<div class="k-scheduler-footer k-toolbar">';
	                html += '<span class="k-state-default k-scheduler-today"><a href="#" class="k-link">';
	                html += options.messages.today + '</a></span>';
	                html += "</div>";
	                that.footer = $(html).appendTo(that.element);
	            }

	            if(that.footer) {
	                that.footer.on("click" + NS, ".k-scheduler-today", function(e) {
	                    e.preventDefault();
	                    var timezone = that.options.timezone;
	                    var action = "today";
	                    var currentDate = new Date();
	                    var date;

	                    if(timezone){
	                        var timezoneOffset = kendo.timezone.offset(currentDate, timezone);
	                        date = kendo.timezone.convert(currentDate, currentDate.getTimezoneOffset(), timezoneOffset);
	                    }else{
	                        date = currentDate;
	                    }

	                    that.trigger("navigate", { view: that.name || options.name, action: action, date: date });
	                });
	            }
	        },

	        constrainSelection: function(selection) {
	            var group = this.groups[0];
	            var slot;

	            if (!this.inRange(selection)) {
	               slot = group.firstSlot();

	               selection.isAllDay = slot.isDaySlot;
	               selection.start = slot.startDate();
	               selection.end = slot.endDate();
	            } else {
	                if (!group.daySlotCollectionCount()) {
	                    selection.isAllDay = false;
	                } else if (!group.timeSlotCollectionCount()) {
	                    selection.isAllDay = true;
	                }
	           }

	            if (!this.groups[selection.groupIndex]) {
	                selection.groupIndex = 0;
	            }
	        },

	        move: function(selection, key, shift) {
	            var handled = false;
	            var group = this.groups[selection.groupIndex];
	            var verticalByDate = this._isGroupedByDate()  && this._isVerticallyGrouped();

	            if (!group.timeSlotCollectionCount()) {
	                selection.isAllDay = true;
	            }

	            var ranges = group.ranges(selection.start, selection.end, selection.isAllDay, false);
	            var startSlot, endSlot, reverse, slots;

	            if (key === keys.DOWN || key === keys.UP) {
	                handled = true;
	                reverse = key === keys.UP;

	                this._updateDirection(selection, ranges, shift, reverse, true);

	                slots = this._verticalSlots(selection, ranges, shift, reverse);

	                if (!slots.startSlot && !shift && this._changeViewPeriod(selection, reverse, !verticalByDate)) {
	                    return handled;
	                }

	            } else if (key === keys.LEFT || key === keys.RIGHT) {
	                handled = true;
	                reverse = key === keys.LEFT;

	                this._updateDirection(selection, ranges, shift, reverse, false);

	                slots = this._horizontalSlots(selection, ranges, shift, reverse);

	                if (!slots.startSlot && !shift && this._changeViewPeriod(selection, reverse, verticalByDate)) {
	                    return handled;
	                }
	            }

	            if (handled) {
	                startSlot = slots.startSlot;
	                endSlot = slots.endSlot;

	                if (shift) {
	                    var backward = selection.backward;
	                    if (backward && startSlot) {
	                        selection.start = startSlot.startDate();
	                    } else if (!backward && endSlot) {
	                        selection.end = endSlot.endDate();
	                    }
	                } else if (startSlot && endSlot) {
	                    selection.isAllDay = startSlot.isDaySlot;
	                    selection.start = startSlot.startDate();
	                    selection.end = endSlot.endDate();
	                }

	                selection.events = [];
	            }

	            return handled;
	        },

	        moveToEventInGroup: function(group, slot, selectedEvents, prev) {
	            var events = group._continuousEvents || [];

	            var found, event;

	            var pad = prev ? -1 : 1;

	            var length = events.length;
	            var idx = prev ? length - 1 : 0;

	            if (selectedEvents.length) {
	                var lastSelected = selectedEvents[selectedEvents.length - 1];

	                for (var i = 0; i < events.length; i++) {
	                    if (events[i].uid === lastSelected) {
	                        idx = i + pad;
	                    }
	                }
	            }

	            while (idx < length && idx > -1) {
	                event = events[idx];

	                if ( (!prev && event.start.startDate() >= slot.startDate()) ||
	                    (prev && event.start.startDate() <= slot.startDate()) ) {

	                    if (event && $.inArray(event.uid, selectedEvents) === -1) {
	                        found = !!event;
	                        break;
	                    }
	                }

	                idx += pad;
	            }

	            return event;
	        },

	        moveToEvent: function(selection, prev) {
	            var groupIndex = selection.groupIndex;

	            var group = this.groups[groupIndex];
	            var slot = group.ranges(selection.start, selection.end, selection.isAllDay, false)[0].start;

	            var length = this.groups.length;
	            var pad = prev ? -1 : 1;
	            var events = selection.events;
	            var event;

	            if (this._isGroupedByDate()) {
	                var allEvents = this._getAllEvents();
	                var uniqueAllEvents = this._getUniqueEvents(allEvents);
	                var sortedEvents = this._getSortedEvents(uniqueAllEvents);

	                if(events.length === 0){
	                    var eventIndex = this._getNextEventIndexBySlot(slot, sortedEvents, groupIndex);

	                    if(prev){
	                        eventIndex--;
	                    }

	                    event = sortedEvents[eventIndex];
	                } else{
	                     var idx = this._getStartIdx(events, sortedEvents);

	                    while (idx < sortedEvents.length && idx > -1) {
	                        if(events.length > 0){
	                            slot = this._getSelectedSlot(slot, sortedEvents, event, idx, pad, prev);
	                        }

	                        if(!slot){
	                            break;
	                        }

	                        if ( (!prev && sortedEvents[idx].start.startDate() >= slot.startDate()) ||
	                              (prev && sortedEvents[idx].start.startDate() <= slot.startDate())) {
	                             if (events[0] != sortedEvents[idx].uid) {
	                                 event = sortedEvents[idx];
	                                  break;
	                             }
	                        }
	                        idx += pad;
	                    }
	                }
	            } else {
	                  while (groupIndex < length && groupIndex > -1) {
	                    event = this.moveToEventInGroup(group, slot, events, prev);

	                    groupIndex += pad;
	                    group = this.groups[groupIndex];

	                    if (!group || event) {
	                        break;
	                    }

	                    events = [];
	                    if (prev) {
	                        slot = group.lastSlot();
	                    } else {
	                        slot = group.firstSlot(true);
	                    }
	                }
	            }

	            if (event) {
	                selection.events = [ event.uid ];
	                selection.start = event.start.startDate();
	                selection.end = event.end.endDate();
	                selection.isAllDay = event.start.isDaySlot;
	                selection.groupIndex = event.start.groupIndex;
	            }

	            return !!event;
	        },

	        current: function(candidate) {
	            if (candidate !== undefined) {
	                this._current = candidate;
	                if (this.content.has(candidate)) {
	                    this._scrollTo(candidate, this.content[0]);
	                }
	            } else {
	                return this._current;
	            }
	        },

	        select: function(selection) {
	            this.clearSelection();

	            if (!this._selectEvents(selection)) {
	                this._selectSlots(selection);
	            }
	        },

	        _getNextEventIndexBySlot: function(slot, sortedEvents, groupIndex){
	            var tempIndex = 0;
	            var slotStartDate = kendo.date.getDate(slot.startDate());

	            for (var i = 0; i < sortedEvents.length; i++) {
	                var eventStartDate = kendo.date.getDate(sortedEvents[i].start.startDate());
	                if (slotStartDate > eventStartDate) {
	                    tempIndex++;
	                    continue;
	                }

	                if (slotStartDate.getTime() === eventStartDate.getTime() && groupIndex > sortedEvents[i].start.groupIndex) {
	                      tempIndex++;
	                      continue;
	                }

	                if (slotStartDate.getTime() === eventStartDate.getTime() &&
	                    groupIndex >= sortedEvents[i].start.groupIndex &&
	                    slot.startDate() > sortedEvents[i].start.startDate()) {
	                    tempIndex++;
	                    continue;
	                 }

	                 break;
	            }
	            return tempIndex;
	        },

	        _getSelectedSlot: function(slot, sortedEvents, event, idx, pad, prev) {
	              if (sortedEvents[idx + pad] &&
	               sortedEvents[idx].start.groupIndex !== sortedEvents[idx + pad].start.groupIndex) {
	                    var groupIndex = sortedEvents[idx + pad].start.groupIndex;
	                    var group = this.groups[groupIndex];

	                    if (!group || event) {
	                       slot = null;
	                    }

	                    if (prev) {
	                        slot = group.lastSlot();
	                    } else {
	                        slot = group.firstSlot(true);
	                    }
	                }
	             return slot;
	        },

	        _getStartIdx: function(events, sortedEvents){
	            var selectedEventIndex = 0;

	            $.each(sortedEvents, function() {
	                if (this.uid === events[0]){
	                     return false;
	                }

	                selectedEventIndex++;
	            });

	            return selectedEventIndex;
	        },

	        _getAllEvents: function(){
	            var allEvents = [];
	            var groups = this.groups;

	            for (var idx = 0; idx < groups.length; idx++) {
	                if (groups[idx]._continuousEvents) {
	                    allEvents= allEvents.concat(groups[idx]._continuousEvents);
	                }
	            }

	            return allEvents;
	        },

	        _getUniqueEvents: function(allEvents){
	            var uniqueAllEvents = [];

	            for (var i = 0; i < allEvents.length; i++) {
	                var exists = false;
	                for (var j = 0; j < uniqueAllEvents.length; j++) {
	                    if (allEvents[i].uid === uniqueAllEvents[j].uid) {
	                        exists = true;
	                        break;
	                    }
	                }

	                if (!exists) {
	                    uniqueAllEvents.push(allEvents[i]);
	                }
	            }

	            return uniqueAllEvents;
	        },

	        _getSortedEvents: function(uniqueAllEvents){
	             return uniqueAllEvents.sort(function(first, second) {
	                var firstStartDate = first.start.startDate();
	                var secondStartDate = second.start.startDate();
	                var result = kendo.date.getDate(firstStartDate) - kendo.date.getDate(secondStartDate);

	                if (result === 0) {
	                    result = first.start.groupIndex - second.start.groupIndex;
	                }

	                if (result === 0) {
	                    result = firstStartDate.getTime() - secondStartDate.getTime();
	                }

	                if (result === 0) {
	                    if (first.start.isDaySlot && !second.start.isDaySlot) {
	                            result = -1;
	                    }

	                    if (!first.start.isDaySlot && second.start.isDaySlot) {
	                            result = 1;
	                    }
	                }

	                if (result === 0) {
	                    result = $(first.element).index() - $(second.element).index();
	                }

	                return result;
	            });
	        },

	        _selectSlots: function(selection) {
	            var isAllDay = selection.isAllDay;
	            var group = this.groups[selection.groupIndex];

	            if (!group.timeSlotCollectionCount()) {
	                isAllDay = true;
	            }

	            this._selectedSlots = [];

	            var ranges = group.ranges(selection.start, selection.end, isAllDay, false);
	            var element;
	            var slot;

	            for (var rangeIndex = 0; rangeIndex < ranges.length; rangeIndex++) {
	                var range = ranges[rangeIndex];
	                var collection = range.collection;

	                for (var slotIndex = range.start.index; slotIndex <= range.end.index; slotIndex++) {
	                    slot = collection.at(slotIndex);

	                    element = slot.element;
	                    element.setAttribute("aria-selected", true);
	                    addSelectedState(element);

	                    this._selectedSlots.push({
	                        start: slot.startDate(),
	                        end: slot.endDate(),
	                        element: element
	                    });
	                }
	            }

	            if (selection.backward) {
	                element = ranges[0].start.element;
	            }

	            this.current(element);
	        },

	        _selectEvents: function(selection) {
	            var found = false;
	            var events = selection.events;
	            var groupEvents = this._getAllEvents();
	            var idx, groupEvent, length = groupEvents.length;

	            if (!events[0] || !groupEvents[0]) {
	                return found;
	            }

	            var result = $();
	            selection.events = [];
	            for (idx = 0; idx < length; idx ++) {
	                if ($.inArray(groupEvents[idx].uid, events) > -1) {
	                    groupEvent = groupEvents[idx];
	                    result = result.add(groupEvent.element);
	                    if(selection.events.indexOf(groupEvent.uid) === -1){
	                        selection.events.push(groupEvent.uid);
	                    }
	                }
	            }

	            if (result[0]) {
	                result.addClass("k-state-selected").attr("aria-selected", true);
	                this.current(result.last()[0]);
	                this._selectedSlots = [];
	                found = true;
	            }

	            return found;
	        },

	        inRange: function(options) {
	            var startDate = this.startDate();
	            var endDate = kendo.date.addDays(this.endDate(), 1);
	            var start = options.start;
	            var end = options.end;

	            return startDate <= start && start < endDate && startDate < end && end <= endDate;
	        },

	        _resourceValue: function(resource, item) {
	            if (resource.valuePrimitive) {
	                item = kendo.getter(resource.dataValueField)(item);
	            }
	            return item;
	        },

	        _resourceBySlot: function(slot) {
	            var resources = this.groupedResources;
	            var result = {};

	            if (resources.length) {
	                var resourceIndex = slot.groupIndex;

	                for (var idx = resources.length - 1; idx >=0; idx--) {
	                    var resource = resources[idx];

	                    var value = this._resourceValue(resource, resource.dataSource.view()[resourceIndex % resource.dataSource.total()]);

	                    if (resource.multiple) {
	                        value = [value];
	                    }

	                    var setter = kendo.setter(resource.field);
	                    setter(result, value);

	                    resourceIndex = Math.floor(resourceIndex / resource.dataSource.total());
	                }
	            }

	            return result;
	        },

	        _createResizeHint: function(left, top, width, height) {
	            return $(HINT).css({
	                left: left,
	                top: top,
	                width: width,
	                height: height
	            });
	        },

	        _removeResizeHint: function() {
	            this._resizeHint.remove();
	            this._resizeHint = $();
	        },

	        _removeMoveHint: function (uid) {
	            if (uid) {
	                this._moveHint.filter("[data-uid='" + uid + "']").remove();

	                this._moveHint = this._moveHint.filter("[data-uid!='" + uid + "']");
	            } else {
	                this._moveHint.remove();
	                this._moveHint = $();
	            }
	        },

	        _scrollTo: function(element, container) {
	            var elementOffset = element.offsetTop,
	                elementOffsetDir = element.offsetHeight,
	                containerScroll = container.scrollTop,
	                containerOffsetDir = container.clientHeight,
	                bottomDistance = elementOffset + elementOffsetDir,
	                result = 0;

	                if (containerScroll > elementOffset) {
	                    result = elementOffset;
	                } else if (bottomDistance > (containerScroll + containerOffsetDir)) {
	                    if (elementOffsetDir <= containerOffsetDir) {
	                        result = (bottomDistance - containerOffsetDir);
	                    } else {
	                        result = elementOffset;
	                    }
	                } else {
	                    result = containerScroll;
	                }
	                container.scrollTop = result;
	        },

	        _inverseEventColor: function(element) {
	            var eventColor = element.css("color");
	            var eventColorIsDark = new Color(eventColor).isDark();
	            var eventBackground = element.css("background-color");
	            var eventBackgroundIsDark = new Color(eventBackground).isDark();

	            if(eventColorIsDark == eventBackgroundIsDark) {
	                element.addClass(INVERSE_COLOR_CLASS);
	            }
	        },

	       _eventTmpl: function(template, wrapper) {
	           var options = this.options,
	               settings = $.extend({}, kendo.Template, options.templateSettings),
	               paramName = settings.paramName,
	               html = "",
	               type = typeof template,
	               state = { storage: {}, count: 0 };

	            if (type === "function") {
	                state.storage["tmpl" + state.count] = template;
	                html += "#=this.tmpl" + state.count + "(" + paramName + ")#";
	                state.count ++;
	            } else if (type === "string") {
	                html += template;
	            }

	            var tmpl = kendo.template(kendo.format(wrapper, html), settings);

	            if (state.count > 0) {
	                tmpl = $.proxy(tmpl, state.storage);
	            }

	            return tmpl;
	       },

	        eventResources: function(event) {
	            var resources = [],
	                options = this.options;

	            if (!options.resources) {
	                return resources;
	            }

	            for (var idx = 0; idx < options.resources.length; idx++) {
	                var resource = options.resources[idx];
	                var field = resource.field;
	                var eventResources = kendo.getter(field)(event);

	                if (eventResources == null) {
	                    continue;
	                }

	                if (!resource.multiple) {
	                    eventResources = [eventResources];
	                }

	                var data = resource.dataSource.view();

	                for (var resourceIndex = 0; resourceIndex < eventResources.length; resourceIndex++) {
	                    var eventResource = null;

	                    var value = eventResources[resourceIndex];

	                    if (!resource.valuePrimitive) {
	                        value = kendo.getter(resource.dataValueField)(value);
	                    }

	                    for (var dataIndex = 0; dataIndex < data.length; dataIndex++) {
	                        if (data[dataIndex].get(resource.dataValueField) == value) {
	                            eventResource = data[dataIndex];
	                            break;
	                        }
	                    }

	                    if (eventResource !== null) {
	                        var resourceColor = kendo.getter(resource.dataColorField)(eventResource);
	                        resources.push({
	                            field: resource.field,
	                            title: resource.title,
	                            name: resource.name,
	                            text: kendo.getter(resource.dataTextField)(eventResource),
	                            value: value,
	                            color: resourceColor
	                        });
	                    }
	                }
	            }
	            return resources;
	        },

	        createLayout: function(layout) {
	            var allDayIndex = -1;

	            if (!layout.rows) {
	                layout.rows = [];
	            }

	            for (var idx = 0; idx < layout.rows.length; idx++) {
	                if (layout.rows[idx].allDay) {
	                    allDayIndex = idx;
	                    break;
	                }
	            }

	            var allDaySlot = layout.rows[allDayIndex];

	            if (allDayIndex >= 0) {
	                layout.rows.splice(allDayIndex, 1);
	            }

	            var columnLevels = this.columnLevels = levels(layout, "columns");
	            var rowLevels = this.rowLevels = levels(layout, "rows");

	            if(this._isVirtualized()) {
	                this._trimRowLevels(rowLevels);
	            }

	            this.table = $('<table role="presentation"' + cellspacing() + ' class="k-scheduler-layout k-scheduler-' + this.name + 'view"><tbody></tbody></table>');

	            var rowCount = rowLevels[rowLevels.length - 1].length;

	            this.table.find("tbody:first").append(this._topSection(columnLevels, allDaySlot, rowCount));

	            this.table.find("tbody:first").append(this._bottomSection(columnLevels, rowLevels, rowCount));

	            this.element.append(this.table);

	            if(this._isVirtualized()) {
	                this._updateDomRowLevels();
	            }

	            // Enable horizontal scrolling when mobile, grouped and less than 1024px width
	            if(this._isMobile() &&
	                    columnLevels.length > 1 &&
	                    this._groupOrientation() === "horizontal" &&
	                    kendo._outerWidth($(window)) < MIN_HORIZONTAL_SCROLL_SIZE ){

	                this.table.find(".k-scheduler-content .k-scheduler-table").width((columnLevels[columnLevels.length - 2].length * 100)  + "%");
	                this.table.find(".k-scheduler-header .k-scheduler-table").width((columnLevels[columnLevels.length - 2].length * 100) + "%");
	            }

	            this._scroller();
	        },

	        _isVirtualized: function () {
	            return this.options.virtual && this.rowLevels.length > 1 && this._isVerticallyGrouped();
	        },

	        _trimRowLevels: function (rowLevels){
	            var lastGroup = rowLevels[rowLevels.length - 2];
	            var cachedRowLevels = this.cachedRowLevels || [];
	            var levelMarker;

	            this._hasContentToRender = true;

	            var stopAtLevel = function(levels, index) {
	                var hasParent  = levels[index - 1].length > 0;

	                if (hasParent) {
	                    return (levels[index].length % levels[index - 1][0].rows.length) !== 0;
	                } else {
	                    return true;
	                }
	            };

	            for (var rowLevelIndex = rowLevels.length - 2; rowLevelIndex >= 0; rowLevelIndex--) {
	                var stop = false;
	                if(rowLevelIndex > 0 && stopAtLevel(rowLevels, rowLevelIndex)) {
	                    stop = true;
	                    levelMarker = rowLevelIndex;
	                }

	                cachedRowLevels[rowLevelIndex] = rowLevels[rowLevelIndex].splice(1);

	                if(stop) {
	                    break;
	                }
	            }

	            cachedRowLevels[rowLevels.length - 1] = rowLevels[rowLevels.length - 1].splice(lastGroup[0].rows.length);

	            this.cachedRowLevels = cachedRowLevels;

	            if(!cachedRowLevels[cachedRowLevels.length - 1].length) {
	                this._hasContentToRender = false;
	            }

	            return {
	                levelMarker: levelMarker || 0,
	                rowLevels: rowLevels
	            };
	        },

	        createNextLayout: function (){
	            var clone = [];
	            var trimmedRowLevels;
	            var rowLevels;
	            var levelMarker;
	            var rowCount;

	            for (var rowLevelIndex = 0; rowLevelIndex < this.cachedRowLevels.length; rowLevelIndex++) {
	                clone[rowLevelIndex] = this.cachedRowLevels[rowLevelIndex];
	            }

	            trimmedRowLevels = this._trimRowLevels(clone);
	            rowLevels = trimmedRowLevels.rowLevels.splice(trimmedRowLevels.levelMarker);
	            levelMarker = trimmedRowLevels.levelMarker;
	            rowCount = rowLevels[rowLevels.length - 1].length;

	            delete this._height;

	            for (var i = levelMarker; i < this.rowLevels.length; i++) {
	                this.rowLevels[i] = this.rowLevels[i].concat(rowLevels[i - levelMarker]);
	            }

	            this.table
	                .find(".k-scheduler-times:last tbody")
	                .append(times(rowLevels, rowCount, this._isMobile()).find("tr"));

	            this._updateDomRowLevels();

	            if(levelMarker > 0) {
	                for (i = 0; i < levelMarker; i++) {
	                    var cell = this.table.find("[data-row-level=" + i + "]:last");
	                    var rowSpan = parseInt(cell.attr("rowspan"),10) + rowCount;
	                    cell.attr("rowspan", rowSpan);
	                }
	            }

	            this._virtualContent(rowLevels, this.columnLevels);
	            this.render(this._cachedEvents);
	        },

	        _tryRenderContent: function (){
	            var that = this;
	            var bufferHeight = that.table.innerHeight();
	            var height = that.content.find("table").innerHeight();
	            var scrollTop = that.content.scrollTop();

	            while(that._hasContentToRender && height - bufferHeight < scrollTop) {
	                that.createNextLayout();
	                height = that.content.find("table").innerHeight();
	            }
	        },

	        _updateDomRowLevels: function () {
	            var that = this;
	            var groupCells = that.times.find(".k-scheduler-group-cell:not([data-row-level])");

	            if(!this._rowLevelIndices) {
	                this._rowLevelIndices = groupCells.map(function(index, item){
	                    $(item).attr("data-row-level", index);
	                    return index;
	                }).toArray().reverse();
	                return;
	            }

	            groupCells = groupCells.toArray().reverse();

	            for(var i = 0; i <= groupCells.length; i++) {
	                $(groupCells[i]).attr("data-row-level", this._rowLevelIndices[i]);
	            }
	        },

	        refreshLayout: function() {
	            var that = this,
	                toolbar = that.element.find("> .k-scheduler-toolbar"),
	                height = that.element.innerHeight(),
	                scrollbar = this._scrollbar,
	                headerHeight = 0,
	                paddingDirection = this._isRtl ? "left" : "right";

	            for (var idx = 0; idx < toolbar.length; idx++) {
	                height -= outerHeight(toolbar.eq(idx));
	            }

	            if (that.datesHeader) {
	                headerHeight = outerHeight(that.datesHeader);
	            }

	            if (that.timesHeader && outerHeight(that.timesHeader) > headerHeight) {
	                headerHeight = outerHeight(that.timesHeader);
	            }

	            if (that.datesHeader && that.timesHeader) {
	                var datesHeaderRows = that.datesHeader.find("table:first tr");

	                that.timesHeader.find("tr").height(function(index) {
	                    $(this).height(datesHeaderRows.eq(index).height());
	                });
	            }

	            if (headerHeight) {
	                height -= headerHeight;
	            }

	            if (that.footer) {
	                height -= outerHeight(that.footer);
	            }

	            var isSchedulerHeightSet = function(el) {
	                var initialHeight, newHeight;
	                if (el[0].style.height) {
	                    return true;
	                } else {
	                    initialHeight = el.height();
	                }

	                el.height("auto");
	                newHeight = el.height();

	                if (initialHeight != newHeight) {
	                    el.height("");
	                    return true;
	                }
	                el.height("");
	                return false;
	            };

	            var contentDiv = that.content[0],
	                scrollbarWidth = !kendo.support.kineticScrollNeeded ? scrollbar : 0;

	            if (isSchedulerHeightSet(that.element)) { // set content height only if needed
	                if (height > scrollbar * 2) { // do not set height if proper scrollbar cannot be displayed
	                    that.content.height(height);
	                } else {
	                    that.content.height(scrollbar * 2 + 1);
	                }
	                that.times.height(contentDiv.clientHeight);

	                var timesTable = that.times.find("table");
	                if (timesTable.length) {
	                    timesTable.height(that.content.find("table")[0].clientHeight);
	                }
	            }


	            if (contentDiv.offsetWidth - contentDiv.clientWidth > 0) {
	                that.table.addClass("k-scrollbar-v");
	                that.datesHeader.css("padding-" + paddingDirection, scrollbarWidth - parseInt(that.datesHeader.children().css("border-" + paddingDirection + "-width"), 10));
	            } else {
	                that.datesHeader.css("padding-" + paddingDirection, "");
	            }
	            if (contentDiv.offsetHeight - contentDiv.clientHeight > 0 || contentDiv.clientHeight > that.content.children(".k-scheduler-table").height()) {
	                that.table.addClass("k-scrollbar-h");
	            } else {
	                that.table.removeClass("k-scrollbar-h");
	            }
	        },

	        _topSection: function(columnLevels, allDaySlot, rowCount) {
	            var thElm = $("<tr>");
	            var columnCount = columnLevels[columnLevels.length - 1].length;

	            this.timesHeader = timesHeader(columnLevels.length, allDaySlot, rowCount);
	            this.datesHeader = datesHeader(columnLevels, columnCount, allDaySlot);

	            var dateGroup = this.datesHeader.find(".k-nav-day");

	            if (dateGroup.length) {
	                dateGroup.closest("tr").addClass("k-scheduler-date-group");
	            }

	            if (this._isMobile())  {
	                thElm.addClass("k-mobile-header");
	                thElm.addClass("k-mobile-" + this._groupOrientation() + "-header");
	            }

	            return $(thElm).append(this.timesHeader.add(this.datesHeader).wrap("<td>").parent());
	        },

	        _bottomSection: function(columnLevels, rowLevels, rowCount) {
	            this.times = times(rowLevels, rowCount, this._isMobile());

	            this.content = content(columnLevels[columnLevels.length - 1], rowLevels[rowLevels.length - 1]);

	            return $("<tr>").append(this.times.add(this.content).wrap("<td>").parent());
	        },

	        _scroller: function() {
	            var that = this;

	            this.content.bind("scroll" + NS, function () {
	                kendo.scrollLeft(that.datesHeader.find(">.k-scheduler-header-wrap"), this.scrollLeft);
	                that.times.scrollTop(this.scrollTop);
	                if(that._isVirtualized()) {
	                    that._tryRenderContent();
	                }
	            });

	            var touchScroller = kendo.touchScroller(this.content, {
	                avoidScrolling: function(e) {
	                    return $(e.event.target).closest(".k-event.k-event-active").length > 0;
	                }
	            });

	            if (touchScroller && touchScroller.movable) {

	                this._touchScroller = touchScroller;

	                this.content = touchScroller.scrollElement;

	                touchScroller.movable.bind("change", function(e) {
	                    kendo.scrollLeft(that.datesHeader.find(">.k-scheduler-header-wrap"), -e.sender.x);
	                    that.times.scrollTop(-e.sender.y);
	                    if(that._isVirtualized()) {
	                        that._tryRenderContent();
	                    }
	                });
	            }
	        },

	        _resourcesForGroups: function() {
	            var result = [];
	            var groups = this.options.group;
	            var resources = this.options.resources;

	            groups = groups && groups.resources ? groups.resources : [];

	            if (resources && groups.length) {
	                for (var idx = 0, length = resources.length; idx < length; idx++) {
	                    for (var groupIdx = 0, groupLength = groups.length; groupIdx < groupLength; groupIdx++) {
	                        if (resources[idx].name === groups[groupIdx]) {
	                            result.push(resources[idx]);
	                        }
	                    }
	                }
	            }

	            this.groupedResources = result;
	        },

	        _createDateLayout: function(dates, inner, times) {
	            return createDateLayoutConfiguration("rows", dates, inner, times);
	        },

	        _createColumnsLayout: function(resources, inner, template, dates, times) {
	            return createLayoutConfiguration("columns", resources, inner, template, dates, times);
	        },

	        _groupOrientation: function() {
	            var groups = this.options.group;
	            return groups && groups.resources ? groups.orientation : "horizontal";
	        },

	        _isGroupedByDate: function() {
	            return this.options.group && this.options.group.date;
	        },

	        _isVerticallyGrouped: function() {
	            return this.groupedResources.length && this._groupOrientation() === "vertical";
	        },

	        _createRowsLayout: function(resources, inner, template, dates) {
	            return createLayoutConfiguration("rows", resources, inner, template, dates);
	        },

	        selectionByElement: function() {
	            return null;
	        },

	        clearSelection: function() {
	            this.content
	                .find(".k-state-selected")
	                .removeAttr("id")
	                .attr("aria-selected", false)
	                .removeClass("k-state-selected");
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(this);

	            if (that.table) {
	                kendo.destroy(that.table);
	                that.table.remove();
	            }

	            if (that.footer) {
	                kendo.destroy(that.footer);
	                that.footer.remove();
	            }

	            that.groups = null;
	            that.table = null;
	            that.content = null;
	            that.times = null;
	            that.datesHeader = null;
	            that.timesHeader = null;
	            that.footer = null;
	            that._resizeHint = null;
	            that._moveHint = null;
	        },

	        calendarInfo: function() {
	            return kendo.getCulture().calendars.standard;
	        },

	        prevGroupSlot: function(date, groupIndex, isDay) {
	            var collection;
	            var group = this.groups[groupIndex];
	            var slot = group.ranges(date, date, isDay, false)[0].start;

	            if (groupIndex <= 0) {
	                return;
	            }

	            if (this._isGroupedByDate()) {
	               return slot;
	            }

	            if (this._isVerticallyGrouped()) {
	                if (!group.timeSlotCollectionCount()) {
	                    collection = group._collection(group.daySlotCollectionCount() - 1, true);
	                    return collection.at(slot.index);
	                } else {
	                    collection = group._collection(isDay ? slot.index : slot.collectionIndex, false);
	                    return collection.last();
	                }
	            } else {
	                if (!group.timeSlotCollectionCount()) {
	                    collection = group._collection(slot.collectionIndex, true);
	                    return collection.last();
	                } else {
	                    collection = group._collection(isDay ? 0 : group.timeSlotCollectionCount() - 1, isDay);
	                    return isDay ? collection.last() : collection.at(slot.index);
	                }
	            }
	        },

	        nextGroupSlot: function(date, groupIndex, isDay) {
	            var collection;
	            var group = this.groups[groupIndex];
	            var slot = group.ranges(date, date, isDay, false)[0].start;
	            var daySlotCollectionCount;

	            if (groupIndex >= this.groups.length - 1) {
	                return;
	            }

	            if (this._isGroupedByDate()) {
	               return slot;
	            }

	            if (this._isVerticallyGrouped()) {
	                if (!group.timeSlotCollectionCount()) {
	                    collection = group._collection(0, true);
	                    return collection.at(slot.index);
	                } else {
	                    daySlotCollectionCount = group.daySlotCollectionCount();
	                    collection = group._collection(daySlotCollectionCount ? 0 : slot.collectionIndex, daySlotCollectionCount);

	                    return isDay ? collection.first() : collection.at(slot.collectionIndex);
	                }
	            } else {
	                if (!group.timeSlotCollectionCount()) {
	                    collection = group._collection(slot.collectionIndex, true);
	                    return collection.first();
	                } else {
	                    collection = group._collection(0, isDay);
	                    return isDay ? collection.first() : collection.at(slot.index);
	                }
	            }
	        },

	        _eventOptionsForMove: function () {
	            return {};
	        },

	        _updateEventForResize: function () {
	            return;
	        },

	        _updateEventForSelection: function (event) {
	            return event;
	        }
	    });

	    function collidingEvents(elements, start, end) {
	        var idx,
	            index,
	            startIndex,
	            overlaps,
	            endIndex;

	        for (idx = elements.length-1; idx >= 0; idx--) {
	            index = rangeIndex(elements[idx]);
	            startIndex = index.start;
	            endIndex = index.end;

	            overlaps = startIndex <= start && endIndex >= start;

	            if (overlaps || (startIndex >= start && endIndex <= end) || (start <= startIndex && end >= startIndex)) {
	                if (startIndex < start) {
	                    start = startIndex;
	                }

	                if (endIndex > end) {
	                    end = endIndex;
	                }
	            }
	        }

	        return eventsForSlot(elements, start, end);
	    }

	    function rangeIndex(eventElement) {
	        return {
	            start: eventElement.start,
	            end: eventElement.end
	        };
	    }

	    function eventsForSlot(elements, slotStart, slotEnd) {
	        var events = [];

	        for (var idx = 0; idx < elements.length; idx++) {
	            var event = rangeIndex(elements[idx]);

	            if ((event.start < slotStart && event.end > slotStart) || (event.start >= slotStart && event.end <= slotEnd)) {
	                events.push(elements[idx]);
	            }
	        }

	        return events;
	    }

	    function createColumns(eventElements) {
	        return _createColumns(eventElements);
	    }

	    function createRows(eventElements) {
	        return _createColumns(eventElements);
	    }

	    var Color = function(value) {
	        var color = this,
	            formats = Color.formats,
	            re,
	            processor,
	            parts,
	            i,
	            channels;

	        if (arguments.length === 1) {
	            value = color.resolveColor(value);

	            for (i = 0; i < formats.length; i++) {
	                re = formats[i].re;
	                processor = formats[i].process;
	                parts = re.exec(value);

	                if (parts) {
	                    channels = processor(parts);
	                    color.r = channels[0];
	                    color.g = channels[1];
	                    color.b = channels[2];
	                }
	            }
	        } else {
	            color.r = arguments[0];
	            color.g = arguments[1];
	            color.b = arguments[2];
	        }

	        color.r = color.normalizeByte(color.r);
	        color.g = color.normalizeByte(color.g);
	        color.b = color.normalizeByte(color.b);
	    };

	    Color.prototype = {
	        resolveColor: function(value) {
	            value = value || "#000";

	            if (value.charAt(0) == "#") {
	                value = value.substr(1, 6);
	            }

	            value = value.replace(/ /g, "");
	            value = value.toLowerCase();
	            value = Color.namedColors[value] || value;

	            return value;
	        },

	        normalizeByte: function(value) {
	            return (value < 0 || isNaN(value)) ? 0 : ((value > 255) ? 255 : value);
	        },

	        percBrightness: function() {
	            var color = this;
	            return math.sqrt(0.241 * color.r * color.r + 0.691 * color.g * color.g + 0.068 * color.b * color.b);
	        },

	        isDark: function() {
	            var color = this;
	            var brightnessValue = color.percBrightness();
	            return brightnessValue < 180;
	        }
	    };

	    Color.formats = [{
	            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
	            process: function(parts) {
	                return [
	                    parseInt(parts[1], 10), parseInt(parts[2], 10), parseInt(parts[3], 10)
	                ];
	            }
	        }, {
	            re: /^(\w{2})(\w{2})(\w{2})$/,
	            process: function(parts) {
	                return [
	                    parseInt(parts[1], 16), parseInt(parts[2], 16), parseInt(parts[3], 16)
	                ];
	            }
	        }, {
	            re: /^(\w{1})(\w{1})(\w{1})$/,
	            process: function(parts) {
	                return [
	                    parseInt(parts[1] + parts[1], 16),
	                    parseInt(parts[2] + parts[2], 16),
	                    parseInt(parts[3] + parts[3], 16)
	                ];
	            }
	        }
	    ];

	    Color.namedColors = {
	        aqua: "00ffff", azure: "f0ffff", beige: "f5f5dc",
	        black: "000000", blue: "0000ff", brown: "a52a2a",
	        coral: "ff7f50", cyan: "00ffff", darkblue: "00008b",
	        darkcyan: "008b8b", darkgray: "a9a9a9", darkgreen: "006400",
	        darkorange: "ff8c00", darkred: "8b0000", dimgray: "696969",
	        fuchsia: "ff00ff", gold: "ffd700", goldenrod: "daa520",
	        gray: "808080", green: "008000", greenyellow: "adff2f",
	        indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c",
	        lightblue: "add8e6", lightgrey: "d3d3d3", lightgreen: "90ee90",
	        lightpink: "ffb6c1", lightyellow: "ffffe0", lime: "00ff00",
	        limegreen: "32cd32", linen: "faf0e6", magenta: "ff00ff",
	        maroon: "800000", mediumblue: "0000cd", navy: "000080",
	        olive: "808000", orange: "ffa500", orangered: "ff4500",
	        orchid: "da70d6", pink: "ffc0cb", plum: "dda0dd",
	        purple: "800080", red: "ff0000", royalblue: "4169e1",
	        salmon: "fa8072", silver: "c0c0c0", skyblue: "87ceeb",
	        slateblue: "6a5acd", slategray: "708090", snow: "fffafa",
	        steelblue: "4682b4", tan: "d2b48c", teal: "008080",
	        tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee",
	        wheat: "f5deb3", white: "ffffff", whitesmoke: "f5f5f5",
	        yellow: "ffff00", yellowgreen: "9acd32"
	    };

	    function _createColumns(eventElements) {
	        var columns = [];

	        for (var idx = 0; idx < eventElements.length; idx++) {
	            var event = eventElements[idx];
	            var eventRange = rangeIndex(event);
	            var column = null;

	            for (var j = 0, columnLength = columns.length; j < columnLength; j++) {
	                var endOverlaps = eventRange.start > columns[j].end;

	                if (eventRange.start < columns[j].start || endOverlaps) {

	                    column = columns[j];

	                    if (column.end < eventRange.end) {
	                        column.end = eventRange.end;
	                    }

	                    break;
	                }
	            }

	            if (!column) {
	                column = { start: eventRange.start, end: eventRange.end, events: [] };
	                columns.push(column);
	            }

	            column.events.push(event);
	        }

	        return columns;
	    }

	    function createDateLayoutConfiguration(name, dates, inner, times) {
	         var configuration = [];

	         $.each(dates, function(index, item) {
	            var className = item.className ? "k-slot-cell " + item.className : "k-slot-cell";

	            var obj = {
	                text: item.text,
	                className: className
	            };

	            if(times && !item.minorTicks){
	                obj[name] = createDateLayoutConfiguration(name, item.columns, inner, times);
	            } else {
	                obj[name] = inner;
	            }
	            configuration.push(obj);
	        });

	        return configuration;
	    }

	    function createLayoutConfiguration(name, resources, inner, template, dates, times) {
	        var resource = resources[0];
	        var configuration = [];

	        if (resource) {
	            if (dates && inner) {
	                $.each(dates, function(index, item) {

	                    if (times && !item.minorTicks) {
	                        item[name] = createLayoutConfiguration(name, resources, item.columns, template, item.columns, times);
	                    } else {
	                         item[name] = createLayoutConfiguration(name, resources, null, template);
	                    }
	                });
	                configuration = dates;
	            } else {
	                var data = resource.dataSource.view();

	                for (var dataIndex = 0; dataIndex < data.length; dataIndex++) {
	                    var obj = {
	                        text: template({
	                            text: kendo.htmlEncode(kendo.getter(resource.dataTextField)(data[dataIndex])),
	                            color: kendo.getter(resource.dataColorField)(data[dataIndex]),
	                            field: resource.field,
	                            title: resource.title,
	                            name: resource.name,
	                            value:kendo.getter(resource.dataValueField)(data[dataIndex])
	                        }),
	                        className: "k-slot-cell k-scheduler-group-cell"
	                    };
	                    obj[name] = createLayoutConfiguration(name, resources.slice(1), inner, template);

	                    configuration.push(obj);
	                }
	            }
	            return configuration;
	        }
	        return inner;
	    }

	    function groupEqFilter(value) {
	        return function(item) {
	            if ($.isArray(item) || item instanceof kendo.data.ObservableArray) {
	                for (var idx = 0; idx < item.length; idx++) {
	                    if (item[idx] == value) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	            return item == value;
	        };
	    }

	    var selectedStateRegExp = /\s*k-state-selected/;
	    function addSelectedState(cell) {
	        cell.className = cell.className.replace(selectedStateRegExp, "") + " k-state-selected";
	    }

	    $.extend(ui.SchedulerView, {
	        createColumns: createColumns,
	        createRows: createRows,
	        rangeIndex: rangeIndex,
	        collidingEvents: collidingEvents,
	        groupEqFilter: groupEqFilter
	    });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "dY0y":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("dSzd")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "dbIj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var abstractColumnDropPanel_1 = __webpack_require__("HDwJ");
var PivotColumnsPanel = (function (_super) {
    __extends(PivotColumnsPanel, _super);
    function PivotColumnsPanel(horizontal) {
        return _super.call(this, horizontal, false, 'pivot') || this;
    }
    PivotColumnsPanel.prototype.passBeansUp = function () {
        _super.prototype.setBeans.call(this, {
            gridOptionsWrapper: this.gridOptionsWrapper,
            eventService: this.eventService,
            context: this.context,
            loggerFactory: this.loggerFactory,
            dragAndDropService: this.dragAndDropService
        });
        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
        var emptyMessage = localeTextFunc('pivotColumnsEmptyMessage', 'Drag here to set column labels');
        var title = localeTextFunc('pivots', 'Column Labels');
        _super.prototype.init.call(this, {
            dragAndDropIcon: main_1.DragAndDropService.ICON_GROUP,
            icon: main_1.Utils.createIconNoSpan('pivotPanel', this.gridOptionsWrapper, null),
            emptyMessage: emptyMessage,
            title: title
        });
        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.refresh.bind(this));
        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_COLUMN_PIVOT_CHANGED, this.refresh.bind(this));
        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.checkVisibility.bind(this));
        this.refresh();
    };
    PivotColumnsPanel.prototype.refresh = function () {
        this.checkVisibility();
        this.refreshGui();
    };
    PivotColumnsPanel.prototype.checkVisibility = function () {
        var pivotMode = this.columnController.isPivotMode();
        if (this.isHorizontal()) {
            // what we do for horizontal (ie the pivot panel at the top) depends
            // on the user property as well as pivotMode.
            switch (this.gridOptionsWrapper.getPivotPanelShow()) {
                case 'always':
                    this.setVisible(pivotMode);
                    break;
                case 'onlyWhenPivoting':
                    var pivotActive = this.columnController.isPivotActive();
                    this.setVisible(pivotMode && pivotActive);
                    break;
                default:
                    // never show it
                    this.setVisible(false);
                    break;
            }
        }
        else {
            // in toolPanel, the pivot panel is always shown when pivot mode is on
            this.setVisible(pivotMode);
        }
    };
    PivotColumnsPanel.prototype.isColumnDroppable = function (column) {
        if (this.gridOptionsWrapper.isFunctionsReadOnly()) {
            return false;
        }
        // we never allow grouping of secondary columns
        if (!column.isPrimary()) {
            return false;
        }
        var allowPivot = column.isAllowPivot();
        var columnNotAlreadyPivoted = !column.isPivotActive();
        return allowPivot && columnNotAlreadyPivoted;
    };
    PivotColumnsPanel.prototype.updateColumns = function (columns) {
        if (this.gridOptionsWrapper.isFunctionsPassive()) {
            var event_1 = {
                type: main_1.Events.EVENT_COLUMN_PIVOT_CHANGE_REQUEST,
                columns: columns,
                api: this.gridApi,
                columnApi: this.columnApi
            };
            this.eventService.dispatchEvent(event_1);
        }
        else {
            this.columnController.setPivotColumns(columns, "toolPanelUi");
        }
    };
    PivotColumnsPanel.prototype.getIconName = function () {
        return this.isPotentialDndColumns() ? main_1.DragAndDropService.ICON_PIVOT : main_1.DragAndDropService.ICON_NOT_ALLOWED;
    };
    PivotColumnsPanel.prototype.getExistingColumns = function () {
        return this.columnController.getPivotColumns();
    };
    __decorate([
        main_1.Autowired('columnController'),
        __metadata("design:type", main_1.ColumnController)
    ], PivotColumnsPanel.prototype, "columnController", void 0);
    __decorate([
        main_1.Autowired('eventService'),
        __metadata("design:type", main_1.EventService)
    ], PivotColumnsPanel.prototype, "eventService", void 0);
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], PivotColumnsPanel.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        main_1.Autowired('context'),
        __metadata("design:type", main_1.Context)
    ], PivotColumnsPanel.prototype, "context", void 0);
    __decorate([
        main_1.Autowired('loggerFactory'),
        __metadata("design:type", main_1.LoggerFactory)
    ], PivotColumnsPanel.prototype, "loggerFactory", void 0);
    __decorate([
        main_1.Autowired('dragAndDropService'),
        __metadata("design:type", main_1.DragAndDropService)
    ], PivotColumnsPanel.prototype, "dragAndDropService", void 0);
    __decorate([
        main_1.Autowired('columnApi'),
        __metadata("design:type", main_1.ColumnApi)
    ], PivotColumnsPanel.prototype, "columnApi", void 0);
    __decorate([
        main_1.Autowired('gridApi'),
        __metadata("design:type", main_1.GridApi)
    ], PivotColumnsPanel.prototype, "gridApi", void 0);
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PivotColumnsPanel.prototype, "passBeansUp", null);
    PivotColumnsPanel = __decorate([
        main_1.Bean("pivotColumnsPanel"),
        __metadata("design:paramtypes", [Boolean])
    ], PivotColumnsPanel);
    return PivotColumnsPanel;
}(abstractColumnDropPanel_1.AbstractColumnDropPanel));
exports.PivotColumnsPanel = PivotColumnsPanel;


/***/ }),

/***/ "ddUy":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(912);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 884:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FTkt");

/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(913), __webpack_require__(884) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($, undefined) {
	    // Imports ================================================================
	    var math = Math,
	        atan = math.atan,
	        exp = math.exp,
	        pow = math.pow,
	        sin = math.sin,
	        log = math.log,
	        tan = math.tan,

	        kendo = window.kendo,
	        Class = kendo.Class,

	        dataviz = kendo.dataviz,
	        deepExtend = kendo.deepExtend,

	        g = kendo.geometry,
	        Point = g.Point,

	        map = dataviz.map,
	        Location = map.Location,

	        util = kendo.drawing.util,
	        rad = util.rad,
	        deg = util.deg,
	        limit = util.limitValue;

	    // Constants ==============================================================
	    var PI = math.PI,
	        PI_DIV_2 = PI / 2,
	        PI_DIV_4 = PI / 4,
	        DEG_TO_RAD = PI / 180;

	    // Coordinate reference systems ===========================================
	    var WGS84 = {
	        a: 6378137,                 // Semi-major radius
	        b: 6356752.314245179,       // Semi-minor radius
	        f: 0.0033528106647474805,   // Flattening
	        e: 0.08181919084262149      // Eccentricity
	    };

	    // WGS 84 / World Mercator
	    var Mercator = Class.extend({
	        init: function(options) {
	            this._initOptions(options);
	        },

	        MAX_LNG: 180,
	        MAX_LAT: 85.0840590501,
	        INVERSE_ITERATIONS: 15,
	        INVERSE_CONVERGENCE: 1e-12,

	        options: {
	            centralMeridian: 0,
	            datum: WGS84
	        },

	        forward: function(loc, clamp) {
	            var proj = this,
	                options = proj.options,
	                datum = options.datum,
	                r = datum.a,
	                lng0 = options.centralMeridian,
	                lat = limit(loc.lat, -proj.MAX_LAT, proj.MAX_LAT),
	                lng = clamp ? limit(loc.lng, -proj.MAX_LNG, proj.MAX_LNG) : loc.lng,
	                x = rad(lng - lng0) * r,
	                y = proj._projectLat(lat);

	            return new Point(x, y);
	        },

	        _projectLat: function(lat) {
	            var datum = this.options.datum,
	                ecc = datum.e,
	                r = datum.a,
	                y = rad(lat),
	                ts = tan(PI_DIV_4 + y / 2),
	                con = ecc * sin(y),
	                p = pow((1 - con) / (1 + con), ecc / 2);

	            // See:
	            // http://en.wikipedia.org/wiki/Mercator_projection#Generalization_to_the_ellipsoid
	            return r * log(ts * p);
	        },

	        inverse: function(point, clamp) {
	            var proj = this,
	                options = proj.options,
	                datum = options.datum,
	                r = datum.a,
	                lng0 = options.centralMeridian,
	                lng = point.x / (DEG_TO_RAD * r) + lng0,
	                lat = limit(proj._inverseY(point.y), -proj.MAX_LAT, proj.MAX_LAT);

	            if (clamp) {
	                lng = limit(lng, -proj.MAX_LNG, proj.MAX_LNG);
	            }

	            return new Location(lat, lng);
	        },

	        _inverseY: function(y) {
	            var proj = this,
	                datum = proj.options.datum,
	                r = datum.a,
	                ecc = datum.e,
	                ecch = ecc / 2,
	                ts = exp(-y / r),
	                phi = PI_DIV_2 - 2 * atan(ts),
	                i;

	            for (i = 0; i <= proj.INVERSE_ITERATIONS; i++) {
	                var con = ecc * sin(phi),
	                    p = pow((1 - con) / (1 + con), ecch),
	                    dphi = PI_DIV_2 - 2 * atan(ts * p) - phi;

	                phi += dphi;

	                if (math.abs(dphi) <= proj.INVERSE_CONVERGENCE) {
	                    break;
	                }
	            }

	            return deg(phi);
	        }
	    });

	    // WGS 84 / Pseudo-Mercator
	    // Used by Google Maps, Bing, OSM, etc.
	    // Spherical projection of ellipsoidal coordinates.
	    var SphericalMercator = Mercator.extend({
	        MAX_LAT: 85.0511287798,

	        _projectLat: function(lat) {
	            var r = this.options.datum.a,
	                y = rad(lat),
	                ts = tan(PI_DIV_4 + y / 2);

	            return r * log(ts);
	        },

	        _inverseY: function(y) {
	            var r = this.options.datum.a,
	                ts = exp(-y / r);

	            return deg(PI_DIV_2 - (2 * atan(ts)));
	        }
	    });

	    var Equirectangular = Class.extend({
	        forward: function(loc) {
	            return new Point(loc.lng, loc.lat);
	        },

	        inverse: function(point) {
	            return new Location(point.y, point.x);
	        }
	    });

	    // TODO: Better (less cryptic name) for this class(es)
	    var EPSG3857 = Class.extend({
	        init: function() {
	            var crs = this,
	                proj = crs._proj = new SphericalMercator();

	            var c = this.c = 2 * PI * proj.options.datum.a;

	            // Scale circumference to 1, mirror Y and shift origin to top left
	            this._tm = g.transform().translate(0.5, 0.5).scale(1/c, -1/c);

	            // Inverse transform matrix
	            this._itm = g.transform().scale(c, -c).translate(-0.5, -0.5);
	        },

	        // Location <-> Point (screen coordinates for a given scale)
	        toPoint: function(loc, scale, clamp) {
	            var point = this._proj.forward(loc, clamp);

	            return point
	                .transform(this._tm)
	                .scale(scale || 1);
	        },

	        toLocation: function(point, scale, clamp) {
	            point = point
	                .clone()
	                .scale(1 / (scale || 1))
	                .transform(this._itm);

	            return this._proj.inverse(point, clamp);
	        }
	    });

	    var EPSG3395 = Class.extend({
	        init: function() {
	            this._proj = new Mercator();
	        },

	        toPoint: function(loc) {
	            return this._proj.forward(loc);
	        },

	        toLocation: function(point) {
	            return this._proj.inverse(point);
	        }
	    });

	    // WGS 84
	    var EPSG4326 = Class.extend({
	        init: function() {
	            this._proj = new Equirectangular();
	        },

	        toPoint: function(loc) {
	            return this._proj.forward(loc);
	        },

	        toLocation: function(point) {
	            return this._proj.inverse(point);
	        }
	    });

	    // Exports ================================================================
	    deepExtend(dataviz, {
	        map: {
	            crs: {
	                EPSG3395: EPSG3395,
	                EPSG3857: EPSG3857,
	                EPSG4326: EPSG4326
	            },
	            datums: {
	                WGS84: WGS84
	            },
	            projections: {
	                Equirectangular: Equirectangular,
	                Mercator: Mercator,
	                SphericalMercator: SphericalMercator
	            }
	        }
	    });

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 913:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("pV45");

/***/ })

/******/ });

/***/ }),

/***/ "djkc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var agComponentUtils_1 = __webpack_require__("rVYJ");
var ComponentMetadataProvider = (function () {
    function ComponentMetadataProvider() {
    }
    ComponentMetadataProvider.prototype.postConstruct = function () {
        this.componentMetaData = {
            dateComponent: {
                mandatoryMethodList: ['getDate', 'setDate'],
                optionalMethodList: []
            },
            detailCellRenderer: {
                mandatoryMethodList: [],
                optionalMethodList: []
            },
            headerComponent: {
                mandatoryMethodList: [],
                optionalMethodList: []
            },
            headerGroupComponent: {
                mandatoryMethodList: [],
                optionalMethodList: []
            },
            loadingOverlayComponent: {
                mandatoryMethodList: [],
                optionalMethodList: []
            },
            noRowsOverlayComponent: {
                mandatoryMethodList: [],
                optionalMethodList: []
            },
            floatingFilterComponent: {
                mandatoryMethodList: ['onParentModelChanged'],
                optionalMethodList: ['afterGuiAttached']
            },
            floatingFilterWrapperComponent: {
                mandatoryMethodList: [],
                optionalMethodList: []
            },
            cellRenderer: {
                mandatoryMethodList: ['refresh'],
                optionalMethodList: ['afterGuiAttached'],
                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
            },
            cellEditor: {
                mandatoryMethodList: ['getValue'],
                optionalMethodList: ['isPopup', 'isCancelBeforeStart', 'isCancelAfterEnd', 'focusIn', 'focusOut', 'afterGuiAttached']
            },
            innerRenderer: {
                mandatoryMethodList: [],
                optionalMethodList: ['afterGuiAttached'],
                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
            },
            fullWidthCellRenderer: {
                mandatoryMethodList: [],
                optionalMethodList: ['afterGuiAttached'],
                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
            },
            pinnedRowCellRenderer: {
                mandatoryMethodList: [],
                optionalMethodList: ['afterGuiAttached'],
                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
            },
            groupRowInnerRenderer: {
                mandatoryMethodList: [],
                optionalMethodList: ['afterGuiAttached'],
                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
            },
            filter: {
                mandatoryMethodList: ['isFilterActive', 'doesFilterPass', 'getModel', 'setModel'],
                optionalMethodList: ['afterGuiAttached', 'onNewRowsLoaded', 'getModelAsString', 'onFloatingFilterChanged', 'afterGuiAttached']
            },
            filterComponent: {
                mandatoryMethodList: ['isFilterActive', 'doesFilterPass', 'getModel', 'setModel'],
                optionalMethodList: ['afterGuiAttached', 'onNewRowsLoaded', 'getModelAsString', 'onFloatingFilterChanged', 'afterGuiAttached']
            }
        };
    };
    ComponentMetadataProvider.prototype.retrieve = function (name) {
        return this.componentMetaData[name];
    };
    __decorate([
        context_1.Autowired("agComponentUtils"),
        __metadata("design:type", agComponentUtils_1.AgComponentUtils)
    ], ComponentMetadataProvider.prototype, "agComponentUtils", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ComponentMetadataProvider.prototype, "postConstruct", null);
    ComponentMetadataProvider = __decorate([
        context_1.Bean("componentMetadataProvider")
    ], ComponentMetadataProvider);
    return ComponentMetadataProvider;
}());
exports.ComponentMetadataProvider = ComponentMetadataProvider;


/***/ }),

/***/ "e6n0":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("evD5").f;
var has = __webpack_require__("D2L2");
var TAG = __webpack_require__("dSzd")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "e8AB":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),

/***/ "e8XQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1293);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1057:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("3i6F");

/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1069:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("jBxA");

/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FZAa");

/***/ }),

/***/ 1097:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("WPfE");

/***/ }),

/***/ 1098:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("rS7A");

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Dz7c");

/***/ }),

/***/ 1105:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ef9w");

/***/ }),

/***/ 1106:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("iFTV");

/***/ }),

/***/ 1107:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MWyb");

/***/ }),

/***/ 1108:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ydSV");

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1121:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("eN7V");

/***/ }),

/***/ 1266:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("/A/6");

/***/ }),

/***/ 1293:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1049),
	        __webpack_require__(1104),
	        __webpack_require__(1097),
	        __webpack_require__(1098),
	        __webpack_require__(1059),
	        __webpack_require__(1107),
	        __webpack_require__(1108),
	        __webpack_require__(1057),
	        __webpack_require__(1105),
	        __webpack_require__(1106),
	        __webpack_require__(1088),
	        __webpack_require__(1109),
	        __webpack_require__(1086),
	        __webpack_require__(1266),
	        __webpack_require__(1295),
	        __webpack_require__(1296),
	        __webpack_require__(1069),
	        __webpack_require__(1294),
	        __webpack_require__(1297),
	        __webpack_require__(1298),
	        __webpack_require__(1299),
	        __webpack_require__(1300),
	        __webpack_require__(1301),
	        __webpack_require__(1302),
	        __webpack_require__(1303),
	        __webpack_require__(1304),
	        __webpack_require__(1305),
	        __webpack_require__(1306),
	        __webpack_require__(1307),
	        __webpack_require__(1308),
	        __webpack_require__(1309),
	        __webpack_require__(1310),
	        __webpack_require__(1311),
	        __webpack_require__(1121)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	    "bundle all";
	    return window.kendo;
	}, __webpack_require__(3));


/***/ }),

/***/ 1294:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("pfAC");

/***/ }),

/***/ 1295:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("iAAw");

/***/ }),

/***/ 1296:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ur7x");

/***/ }),

/***/ 1297:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("RnqI");

/***/ }),

/***/ 1298:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("vZJG");

/***/ }),

/***/ 1299:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("yrck");

/***/ }),

/***/ 1300:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("vKDZ");

/***/ }),

/***/ 1301:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Yz+S");

/***/ }),

/***/ 1302:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("DwXV");

/***/ }),

/***/ 1303:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Wbid");

/***/ }),

/***/ 1304:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MlFQ");

/***/ }),

/***/ 1305:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("tTsr");

/***/ }),

/***/ 1306:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("tg5X");

/***/ }),

/***/ 1307:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Jrwt");

/***/ }),

/***/ 1308:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("w52R");

/***/ }),

/***/ 1309:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nTqx");

/***/ }),

/***/ 1310:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("F4EX");

/***/ }),

/***/ 1311:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("jm6Q");

/***/ })

/******/ });

/***/ }),

/***/ "eN7V":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1047);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1047:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function() {

	var __meta__ = { // jshint ignore:line
	    id: "angular",
	    name: "AngularJS Directives",
	    category: "framework",
	    description: "Adds Kendo UI for AngularJS directives",
	    depends: [ "core" ],
	    defer: true
	};

	(function ($, angular, undefined) {
	    "use strict";

	    // Angular2 exposes a global angular object, but it does not have an injector...
	    if (!angular || !angular.injector) {
	        return;
	    }

	    /*jshint eqnull:true,loopfunc:true,-W052,-W028  */

	    var module = angular.module('kendo.directives', []),
	        $injector = angular.injector(['ng']),
	        $parse = $injector.get('$parse'),
	        $timeout = $injector.get('$timeout'),
	        $defaultCompile,
	        $log = $injector.get('$log');

	    function withoutTimeout(f) {
	        var save = $timeout;
	        try {
	            $timeout = function(f){ return f(); };
	            return f();
	        } finally {
	            $timeout = save;
	        }
	    }

	    var OPTIONS_NOW;

	    var createDataSource = (function() {
	        var types = {
	            TreeList    : 'TreeListDataSource',
	            TreeView    : 'HierarchicalDataSource',
	            Scheduler   : 'SchedulerDataSource',
	            PivotGrid   : 'PivotDataSource',
	            PivotConfigurator   : 'PivotDataSource',
	            PanelBar    : 'HierarchicalDataSource',
	            Menu        : "$PLAIN",
	            ContextMenu : "$PLAIN"
	        };
	        var toDataSource = function(dataSource, type) {
	            if (type == '$PLAIN') {
	                return dataSource;
	            }
	            return kendo.data[type].create(dataSource);
	        };
	        return function(scope, element, role, source) {
	            var type = types[role] || 'DataSource';
	            var current = scope.$eval(source);
	            var ds = toDataSource(current, type);

	            scope.$watch(source, function(mew) {
	                var widget = kendoWidgetInstance(element);

	                if (widget && typeof widget.setDataSource == "function") {
	                    if (mew !== current && mew !== widget.dataSource) {
	                        var ds = toDataSource(mew, type);
	                        widget.setDataSource(ds);
	                        current = mew;
	                    }
	                }
	            });
	            return ds;
	        };
	    }());

	    var ignoredAttributes = {
	        kDataSource : true,
	        kOptions    : true,
	        kRebind     : true,
	        kNgModel    : true,
	        kNgDelay    : true
	    };

	    var ignoredOwnProperties = {
	        // XXX: other names to ignore here?
	        name    : true,
	        title   : true,
	        style   : true
	    };

	    function createWidget(scope, element, attrs, widget, origAttr, controllers) {
	        /* jshint latedef: false */
	        if (!(element instanceof jQuery)) {
	            throw new Error("The Kendo UI directives require jQuery to be available before AngularJS. Please include jquery before angular in the document.");
	        }

	        var kNgDelay = attrs.kNgDelay,
	            delayValue = scope.$eval(kNgDelay);

	        controllers = controllers || [];

	        var ngModel = controllers[0],
	            ngForm = controllers[1];

	        var ctor = $(element)[widget];

	        if (!ctor) {
	            window.console.error("Could not find: " + widget);
	            return null;
	        }

	        var parsed = parseOptions(scope, element, attrs, widget, ctor);

	        var options = parsed.options;

	        if (parsed.unresolved.length) {
	            var promises = [];

	            for (var i = 0, len = parsed.unresolved.length; i < len; i++) {

	                var unresolved = parsed.unresolved[i];

	                var promise = $.Deferred(function(d) {
	                    var unwatch = scope.$watch(unresolved.path, function(newValue) {
	                        if (newValue !== undefined) {
	                            unwatch();
	                            d.resolve();
	                        }
	                    });
	                }).promise();

	                promises.push(promise);
	            }

	            $.when.apply(null, promises).then(createIt);

	            return;
	        }

	        if (kNgDelay && !delayValue) {
	            var root = scope.$root || scope;

	            var register = function() {
	                var unregister = scope.$watch(kNgDelay, function(newValue) {
	                        if (newValue !== undefined) {
	                        unregister();
	                        // remove subsequent delays, to make ng-rebind work
	                        element.removeAttr(attrs.$attr.kNgDelay);
	                        kNgDelay = null;
	                        $timeout(createIt); // XXX: won't work without `timeout` ;-\
	                    }
	                });
	            };

	            // WARNING: the watchers should be registered in the digest cycle.
	            // the fork here is for the timeout/non-timeout initiated widgets.
	            if (/^\$(digest|apply)$/.test(root.$$phase)) {
	                register();
	            } else {
	                scope.$apply(register);
	            }

	            return;
	        } else {
	            return createIt();
	        }

	        function createIt() {
	            var originalElement;

	            if (attrs.kRebind) {
	                originalElement = $($(element)[0].cloneNode(true));
	            }

	            // re-parse the options here.
	            options = parseOptions(scope, element, attrs, widget, ctor).options;

	            if (element.is("select")) {
	                (function(options){
	                    if (options.length > 0) {
	                        var first = $(options[0]);
	                        if (!/\S/.test(first.text()) && /^\?/.test(first.val())) {
	                            first.remove();
	                        }

	                        for (var i = 0; i < options.length; i++) {
	                            $(options[i]).off("$destroy");
	                        }
	                    }
	                }(element[0].options));
	            }

	            var object = ctor.call(element, OPTIONS_NOW = options).data(widget);

	            exposeWidget(object, scope, attrs, widget, origAttr);

	            scope.$emit("kendoWidgetCreated", object);

	            var destroyRegister = destroyWidgetOnScopeDestroy(scope, object);

	            if (attrs.kRebind) {
	                setupRebind(object, scope, element, originalElement, attrs.kRebind, destroyRegister, attrs);
	            }

	            if (attrs.kNgDisabled) {
	                var kNgDisabled = attrs.kNgDisabled;
	                var isDisabled = scope.$eval(kNgDisabled);
	                if (isDisabled) {
	                    object.enable(!isDisabled);
	                }
	                bindToKNgDisabled(object, scope, element, kNgDisabled);
	            }

	            if (attrs.kNgReadonly) {
	                var kNgReadonly = attrs.kNgReadonly;
	                var isReadonly = scope.$eval(kNgReadonly);
	                if (isReadonly) {
	                    object.readonly(isReadonly);
	                }
	                bindToKNgReadonly(object, scope, element, kNgReadonly);
	            }

	            // kNgModel is used for the "logical" value
	            if (attrs.kNgModel) {
	                bindToKNgModel(object, scope, attrs.kNgModel);
	            }

	            // 2 way binding: ngModel <-> widget.value()
	            if (ngModel) {
	                bindToNgModel(object, scope, element, ngModel, ngForm);
	            }

	            if (object) {
	                propagateClassToWidgetWrapper(object, element);
	            }

	            return object;
	        }
	    }


	    function parseOptions(scope, element, attrs, widget, ctor) {
	        var role = widget.replace(/^kendo/, '');
	        var unresolved = [];
	        var optionsPath = attrs.kOptions || attrs.options;
	        var optionsValue = scope.$eval(optionsPath);

	        if (optionsPath && optionsValue === undefined) {
	            unresolved.push({ option: "options", path: optionsPath });
	        }

	        var options = angular.extend({}, attrs.defaultOptions, optionsValue);

	        function addOption(name, value) {
	            var scopeValue = angular.copy(scope.$eval(value));
	            if (scopeValue === undefined) {
	                unresolved.push({ option: name, path: value });
	            } else {
	                options[name] = scopeValue;
	            }
	        }


	        var widgetOptions = ctor.widget.prototype.options;
	        var widgetEvents = ctor.widget.prototype.events;


	        $.each(attrs, function(name, value) {
	            if (name === "source" || name === "kDataSource" || name === "kScopeField" || name === "scopeField") {
	                return;
	            }

	            var dataName = "data" + name.charAt(0).toUpperCase() + name.slice(1);

	            if (name.indexOf("on") === 0) { // let's search for such event.
	                var eventKey = name.replace(/^on./, function(prefix) {
	                    return prefix.charAt(2).toLowerCase();
	                });

	                if (widgetEvents.indexOf(eventKey) > -1) {
	                    options[eventKey] = value;
	                }
	            } // don't elsif here - there are on* options

	            if (widgetOptions.hasOwnProperty(dataName)) {
	                addOption(dataName, value);
	            } else if (widgetOptions.hasOwnProperty(name) && !ignoredOwnProperties[name]) {
	                addOption(name, value);
	            } else if (!ignoredAttributes[name]) {
	                var match = name.match(/^k(On)?([A-Z].*)/);
	                if (match) {
	                    var optionName = match[2].charAt(0).toLowerCase() + match[2].slice(1);
	                    if (match[1] && name != "kOnLabel" // XXX: k-on-label can be used on MobileSwitch :-\
	                    ) {
	                        options[optionName] = value;
	                    } else {
	                        if (name == "kOnLabel") {
	                            optionName = "onLabel"; // XXX: that's awful.
	                        }
	                        addOption(optionName, value);
	                    }
	                }
	            }
	        });

	        // parse the datasource attribute
	        var dataSource = attrs.kDataSource || attrs.source;

	        if (dataSource) {
	            options.dataSource = createDataSource(scope, element, role, dataSource);
	        }

	        // deepExtend in kendo.core (used in Editor) will fail with stack
	        // overflow if we don't put it in an array :-\
	        options.$angular = [ scope ];

	        return {
	            options: options,
	            unresolved: unresolved
	        };
	    }

	    function bindToKNgDisabled(widget, scope, element, kNgDisabled) {
	        if ((kendo.ui.PanelBar && widget instanceof kendo.ui.PanelBar) || (kendo.ui.Menu && widget instanceof kendo.ui.Menu)) {
	            $log.warn("k-ng-disabled specified on a widget that does not have the enable() method: " + (widget.options.name));
	            return;
	        }
	        scope.$watch(kNgDisabled, function(newValue, oldValue) {
	            if (newValue != oldValue) {
	                widget.enable(!newValue);
	            }
	        });
	    }

	    function bindToKNgReadonly(widget, scope, element, kNgReadonly) {
	        if (typeof widget.readonly != "function") {
	            $log.warn("k-ng-readonly specified on a widget that does not have the readonly() method: " + (widget.options.name));
	            return;
	        }
	        scope.$watch(kNgReadonly, function(newValue, oldValue) {
	            if (newValue != oldValue) {
	                widget.readonly(newValue);
	            }
	        });
	    }

	    function exposeWidget(widget, scope, attrs, kendoWidget, origAttr) {
	        if (attrs[origAttr]) {
	            var set = $parse(attrs[origAttr]).assign;
	            if (set) {
	                // set the value of the expression to the kendo widget object to expose its api
	                set(scope, widget);
	            } else {
	                throw new Error(origAttr + ' attribute used but expression in it is not assignable: ' + attrs[kendoWidget]);
	            }
	        }
	    }

	    function formValue(element) {
	        if (/checkbox|radio/i.test(element.attr("type"))) {
	            return element.prop("checked");
	        }
	        return element.val();
	    }

	    var formRegExp = /^(input|select|textarea)$/i;

	    function isForm(element) {
	        return formRegExp.test(element[0].tagName);
	    }

	    function bindToNgModel(widget, scope, element, ngModel, ngForm) {
	        if (!widget.value) {
	            return;
	        }

	        var value;
	        // Some widgets trigger "change" on the input field
	        // and this would result in two events sent (#135)
	        var haveChangeOnElement = false;

	        if (isForm(element)) {
	            value = function() {
	                return formValue(element);
	            };
	        } else {
	            value = function() {
	                return widget.value();
	            };
	        }

	        // Angular will invoke $render when the view needs to be updated with the view value.
	        var viewRender = function() {
	            // Update the widget with the view value.

	            // delaying with setTimout for cases where the datasource is set thereafter.
	            // https://github.com/kendo-labs/angular-kendo/issues/304
	            var val = ngModel.$viewValue;
	            if (val === undefined) {
	                val = ngModel.$modelValue;
	            }

	            if (val === undefined) {
	                val = null;
	            }

	            haveChangeOnElement = true;
	            setTimeout(function(){
	                haveChangeOnElement = false;
	                if (widget) { // might have been destroyed in between. :-(
	                    var kNgModel = scope[widget.element.attr("k-ng-model")];

	                    if (kNgModel) {
	                        val = kNgModel;
	                    }

	                    if (widget.options.autoBind === false && !widget.listView.bound()) {
	                        if (val) {
	                            widget.value(val);
	                        }
	                    } else {
	                        widget.value(val);
	                    }
	                }
	            }, 0);
	        };

	        ngModel.$render = viewRender;
	        setTimeout(function() {
	            if (ngModel.$render !== viewRender) {
	                ngModel.$render = viewRender;
	                ngModel.$render();
	            }
	        });

	        if (isForm(element)) {
	            element.on("change", function() {
	                haveChangeOnElement = true;
	            });
	        }

	        var onChange = function(pristine) {
	            return function() {
	                var formPristine;
	                if (haveChangeOnElement && !element.is("select")) {
	                    return;
	                }
	                if (pristine && ngForm) {
	                    formPristine = ngForm.$pristine;
	                }
	                ngModel.$setViewValue(value());
	                if (pristine) {
	                    ngModel.$setPristine();
	                    if (formPristine) {
	                        ngForm.$setPristine();
	                    }
	                }
	                digest(scope);
	            };
	        };

	        widget.first("change", onChange(false));
	        widget.first("spin", onChange(false));

	        if (!(kendo.ui.AutoComplete && widget instanceof kendo.ui.AutoComplete)) {
	            widget.first("dataBound", onChange(true));
	        }

	        var currentVal = value();

	        // if the model value is undefined, then we set the widget value to match ( == null/undefined )
	        // In telerik/kendo-ui-core#1027 we discovered that after the timeout the $viewValue arives as NaN in some weird, default form.
	        // Hence the check below.
	        if (!isNaN(ngModel.$viewValue) && currentVal != ngModel.$viewValue) {
	            if (!ngModel.$isEmpty(ngModel.$viewValue)) {
	                widget.value(ngModel.$viewValue);
	            } else if (currentVal != null && currentVal !== "" && currentVal != ngModel.$viewValue) {
	                ngModel.$setViewValue(currentVal);
	            }
	        }

	        ngModel.$setPristine();
	    }

	    function bindToKNgModel(widget, scope, kNgModel) {
	        if(kendo.ui.DateRangePicker && widget instanceof kendo.ui.DateRangePicker){
	            var rangePickerModels = kNgModel.split(",");
	            var rangePickerStartModel = rangePickerModels[0].trim();
	            var rangePickerEndModel;

	            bindToKNgModel(widget._startDateInput, scope, rangePickerStartModel);
	            if (rangePickerModels[1]) {
	                rangePickerEndModel = rangePickerModels[1].trim();
	                bindToKNgModel(widget._endDateInput, scope, rangePickerEndModel);
	                widget.range({start:scope[rangePickerStartModel], end:scope[rangePickerEndModel] });
	            } else {
	                widget.range({start:scope[rangePickerStartModel], end: null });
	            }

	            return;
	        }

	        if (typeof widget.value != "function") {
	            $log.warn("k-ng-model specified on a widget that does not have the value() method: " + (widget.options.name));
	            return;
	        }

	        var form  = $(widget.element).parents("ng-form, form").first();
	        var ngForm = kendo.getter(form.attr("name"), true)(scope);
	        var getter = $parse(kNgModel);
	        var setter = getter.assign;
	        var updating = false;

	        var valueIsCollection = kendo.ui.MultiSelect && widget instanceof kendo.ui.MultiSelect ||
	                                kendo.ui.RangeSlider && widget instanceof kendo.ui.RangeSlider;

	        var length = function(value) {
	            //length is irrelevant when value is not collection
	            return value && valueIsCollection ? value.length : 0;
	        };

	        var currentValueLength = length(getter(scope));

	        widget.$angular_setLogicValue(getter(scope));

	        // keep in sync
	        var watchHandler = function(newValue, oldValue) {
	            if (newValue === undefined) {
	                // because widget's value() method usually checks if the new value is undefined,
	                // in which case it returns the current value rather than clearing the field.
	                // https://github.com/telerik/kendo-ui-core/issues/299
	                newValue = null;
	            }

	            //compare values by reference if a collection
	            if (updating || (newValue == oldValue && length(newValue) == currentValueLength)) {
	                return;
	            }

	            currentValueLength = length(newValue);
	            widget.$angular_setLogicValue(newValue);
	        };

	        if (valueIsCollection) {
	            scope.$watchCollection(kNgModel, watchHandler);
	        } else {
	            scope.$watch(kNgModel, watchHandler);
	        }

	        var changeHandler = function() {
	            updating = true;

	            if (ngForm && ngForm.$pristine) {
	                ngForm.$setDirty();
	            }

	            digest(scope, function(){
	                setter(scope, widget.$angular_getLogicValue());
	                currentValueLength = length(getter(scope));
	            });

	            updating = false;
	        };

	        widget.first("change", changeHandler);
	        widget.first("spin", changeHandler);
	    }

	    function destroyWidgetOnScopeDestroy(scope, widget) {
	        var deregister = scope.$on("$destroy", function() {
	            deregister();
	            if (widget) {
	                kendo.destroy(widget.element);
	                widget = null;
	            }
	        });

	        return deregister;
	    }

	    // mutation observers - propagate the original
	    // element's class to the widget wrapper.
	    function propagateClassToWidgetWrapper(widget, element) {
	        if (!(window.MutationObserver && widget.wrapper)) {
	            return;
	        }

	        var prevClassList = [].slice.call($(element)[0].classList);

	        var mo = new MutationObserver(function(changes){
	            suspend();    // make sure we don't trigger a loop
	            if (!widget) {
	                return;
	            }

	            changes.forEach(function(chg){
	                var w = $(widget.wrapper)[0];
	                switch (chg.attributeName) {

	                    case "class":
	                        // sync classes to the wrapper element
	                        var currClassList = [].slice.call(chg.target.classList);
	                        currClassList.forEach(function(cls){
	                            if (prevClassList.indexOf(cls) < 0) {
	                                w.classList.add(cls);
	                                if (kendo.ui.ComboBox && widget instanceof kendo.ui.ComboBox) { // https://github.com/kendo-labs/angular-kendo/issues/356
	                                    widget.input[0].classList.add(cls);
	                                }
	                            }
	                        });
	                        prevClassList.forEach(function(cls){
	                            if (currClassList.indexOf(cls) < 0) {
	                                w.classList.remove(cls);
	                                if (kendo.ui.ComboBox && widget instanceof kendo.ui.ComboBox) { // https://github.com/kendo-labs/angular-kendo/issues/356
	                                    widget.input[0].classList.remove(cls);
	                                }
	                            }
	                        });
	                        prevClassList = currClassList;
	                        break;

	                    case "disabled":
	                        if (typeof widget.enable == "function" && !widget.element.attr("readonly")) {
	                            widget.enable(!$(chg.target).attr("disabled"));
	                        }
	                        break;

	                    case "readonly":
	                        if (typeof widget.readonly == "function" && !widget.element.attr("disabled")) {
	                            widget.readonly(!!$(chg.target).attr("readonly"));
	                        }
	                        break;
	                }
	            });

	            resume();
	        });

	        function suspend() {
	            mo.disconnect();
	        }

	        function resume() {
	            mo.observe($(element)[0], { attributes: true });
	        }

	        resume();
	        widget.first("destroy", suspend);
	    }

	    function setupRebind(widget, scope, element, originalElement, rebindAttr, destroyRegister, attrs) {
	        // watch for changes on the expression passed in the k-rebind attribute
	        var unregister = scope.$watch(rebindAttr, function(newValue, oldValue) {
	            if (!widget._muteRebind && newValue !== oldValue) {
	                unregister(); // this watcher will be re-added if we compile again!

	                if (attrs._cleanUp) {
	                    attrs._cleanUp();
	                }

	                var templateOptions = WIDGET_TEMPLATE_OPTIONS[widget.options.name];

	                if (templateOptions) {
	                    templateOptions.forEach(function(name) {
	                        var templateContents = scope.$eval(attrs["k" + name]);

	                        if (templateContents) {
	                            originalElement.append($(templateContents).attr(kendo.toHyphens("k" + name), ""));
	                        }
	                    });
	                }

	                var _wrapper = $(widget.wrapper)[0];
	                var _element = $(widget.element)[0];
	                var isUpload = widget.options.name === "Upload";

	                if (isUpload) {
	                    element = $(_element);
	                }

	                var compile = element.injector().get("$compile");
	                widget._destroy();

	                if (destroyRegister) {
	                    destroyRegister();
	                }

	                widget = null;

	                if (_element) {
	                    if (_wrapper) {
	                        _wrapper.parentNode.replaceChild(_element, _wrapper);
	                    }
	                    $(element).replaceWith(originalElement);
	                }

	                compile(originalElement)(scope);
	            }
	        }, true); // watch for object equality. Use native or simple values.
	        digest(scope);
	    }

	    function bind(f, obj) {
	        return function(a, b) {
	            return f.call(obj, a, b);
	        };
	    }

	    function setTemplate(key, value) {
	        this[key] = kendo.stringify(value); // jshint ignore:line
	    }

	    module.factory('directiveFactory', [ '$compile', function(compile) {
	        var kendoRenderedTimeout;
	        var RENDERED = false;

	        // caching $compile for the dirty hack upstairs. This is awful, but we happen to have elements outside of the bootstrapped root :(.
	        $defaultCompile = compile;

	        var create = function(role, origAttr) {
	            return {
	                // Parse the directive for attributes and classes
	                restrict: "AC",
	                require: [ "?ngModel", "^?form" ],
	                scope: false,

	                controller: [ '$scope', '$attrs', '$element', function($scope, $attrs) {
	                    this.template = bind(setTemplate, $attrs);
	                    $attrs._cleanUp = bind(function(){
	                        this.template = null;
	                        $attrs._cleanUp = null;
	                    }, this);
	                }],

	                link: function(scope, element, attrs, controllers) {
	                    var $element = $(element);

	                    // we must remove data-kendo-widget-name attribute because
	                    // it breaks kendo.widgetInstance; can generate all kinds
	                    // of funny issues like
	                    //
	                    //   https://github.com/kendo-labs/angular-kendo/issues/167
	                    //
	                    // but we still keep the attribute without the
	                    // `data-` prefix, so k-rebind would work.
	                    var roleattr = role.replace(/([A-Z])/g, "-$1");

	                    $element.attr(roleattr, $element.attr("data-" + roleattr));
	                    $element[0].removeAttribute("data-" + roleattr);

	                    var widget = createWidget(scope, element, attrs, role, origAttr, controllers);

	                    if (!widget) {
	                        return;
	                    }

	                    if (kendoRenderedTimeout) {
	                        clearTimeout(kendoRenderedTimeout);
	                    }

	                    kendoRenderedTimeout = setTimeout(function() {
	                        scope.$emit("kendoRendered");
	                        if (!RENDERED) {
	                            RENDERED = true;
	                            $("form").each(function(){
	                                var form = $(this).controller("form");
	                                if (form) {
	                                    form.$setPristine();
	                                }
	                            });
	                        }
	                    });
	                }
	            };
	        };

	        return {
	            create: create
	        };
	    }]);

	    var TAGNAMES = {
	        Editor         : "textarea",
	        NumericTextBox : "input",
	        DatePicker     : "input",
	        DateTimePicker : "input",
	        TimePicker     : "input",
	        AutoComplete   : "input",
	        ColorPicker    : "input",
	        MaskedTextBox  : "input",
	        MultiSelect    : "input",
	        Upload         : "input",
	        Validator      : "form",
	        Button         : "button",
	        MobileButton        : "a",
	        MobileBackButton    : "a",
	        MobileDetailButton  : "a",
	        ListView       : "ul",
	        MobileListView: "ul",
	        ScrollView       : "div",
	        PanelBar       : "ul",
	        TreeView       : "ul",
	        Menu           : "ul",
	        ContextMenu    : "ul",
	        ActionSheet    : "ul",
	        Switch    : "input"
	    };

	    var SKIP_SHORTCUTS = [
	        'MobileView',
	        'MobileDrawer',
	        'MobileLayout',
	        'MobileSplitView',
	        'MobilePane',
	        'MobileModalView'
	    ];

	    var MANUAL_DIRECTIVES = [
	        'MobileApplication',
	        'MobileView',
	        'MobileModalView',
	        'MobileLayout',
	        'MobileActionSheet',
	        'MobileDrawer',
	        'MobileSplitView',
	        'MobilePane',
	        'MobileScrollView',
	        'MobilePopOver'
	    ];

	    angular.forEach(['MobileNavBar', 'MobileButton', 'MobileBackButton', 'MobileDetailButton', 'MobileTabStrip', 'MobileScrollView', 'MobileScroller'], function(widget) {
	        MANUAL_DIRECTIVES.push(widget);
	        widget = "kendo" + widget;
	        module.directive(widget, function() {
	            return {
	                restrict: "A",
	                link: function(scope, element, attrs) {
	                    createWidget(scope, element, attrs, widget, widget);
	                }
	            };
	        });
	    });

	    function createDirectives(klass, isMobile) {
	        function make(directiveName, widgetName) {
	            module.directive(directiveName, [
	                "directiveFactory",
	                function(directiveFactory) {
	                    return directiveFactory.create(widgetName, directiveName);
	                }
	            ]);
	        }

	        var name = isMobile ? "Mobile" : "";
	        name += klass.fn.options.name;

	        var className = name;
	        var shortcut = "kendo" + name.charAt(0) + name.substr(1).toLowerCase();
	        name = "kendo" + name;

	        // <kendo-numerictextbox>-type directives
	        var dashed = name.replace(/([A-Z])/g, "-$1");

	        if (SKIP_SHORTCUTS.indexOf(name.replace("kendo", "")) == -1) {
	            var names = name === shortcut ? [ name ] : [ name, shortcut ];
	            angular.forEach(names, function(directiveName) {
	                module.directive(directiveName, function(){
	                    return {
	                        restrict : "E",
	                        replace  : true,
	                        template : function(element, attributes) {
	                            var tag = TAGNAMES[className] || "div";
	                            var scopeField = attributes.kScopeField || attributes.scopeField;

	                            return "<" + tag + " " + dashed + (scopeField ? ('="' + scopeField + '"') : "") + ">" + element.html() + "</" + tag + ">";
	                        }
	                    };
	                });
	            });
	        }

	        if (MANUAL_DIRECTIVES.indexOf(name.replace("kendo", "")) > -1) {
	            return;
	        }

	        // here name should be like kendoMobileListView so kendo-mobile-list-view works,
	        // and shortcut like kendoMobilelistview, for kendo-mobilelistview

	        make(name, name);
	        if (shortcut != name) {
	            make(shortcut, name);
	        }

	    }

	    /* -----[ utils ]----- */

	    function kendoWidgetInstance(el) {
	        el = $(el);
	        return kendo.widgetInstance(el, kendo.ui) ||
	            kendo.widgetInstance(el, kendo.mobile.ui) ||
	            kendo.widgetInstance(el, kendo.dataviz.ui);
	    }

	    function digest(scope, func) {
	        var root = scope.$root || scope;
	        var isDigesting = /^\$(digest|apply)$/.test(root.$$phase);
	        if (func) {
	            if (isDigesting) {
	                func();
	            } else {
	                root.$apply(func);
	            }
	        } else if (!isDigesting) {
	            root.$digest();
	        }
	    }

	    function destroyScope(scope, el) {
	        scope.$destroy();
	        if (el) {
	            // prevent leaks. https://github.com/kendo-labs/angular-kendo/issues/237
	            $(el)
	                .removeData("$scope")
	                .removeData("$$kendoScope")
	                .removeData("$isolateScope")
	                .removeData("$isolateScopeNoTemplate")
	                .removeClass("ng-scope");
	        }
	    }

	    var encode = kendo.htmlEncode;
	    var open = /{{/g;
	    var close = /}}/g;
	    var encOpen = '{&#8203;{';
	    var encClose = '}&#8203;}';

	    kendo.htmlEncode = function(str) {
	        return encode(str)
	            .replace(open, encOpen)
	            .replace(close, encClose);
	    };

	    var pendingPatches = [];

	    // defadvice will patch a class' method with another function.  That
	    // function will be called in a context containing `next` (to call
	    // the next method) and `object` (a reference to the original
	    // object).
	    function defadvice(klass, methodName, func) {
	        if ($.isArray(klass)) {
	            return angular.forEach(klass, function(klass){
	                defadvice(klass, methodName, func);
	            });
	        }
	        if (typeof klass == "string") {
	            var a = klass.split(".");
	            var x = kendo;
	            while (x && a.length > 0) {
	                x = x[a.shift()];
	            }
	            if (!x) {
	                pendingPatches.push([ klass, methodName, func ]);
	                return false;
	            }
	            klass = x.prototype;
	        }
	        var origMethod = klass[methodName];
	        klass[methodName] = function() {
	            var self = this, args = arguments;
	            return func.apply({
	                self: self,
	                next: function() {
	                    return origMethod.apply(self, arguments.length > 0 ? arguments : args);
	                }
	            }, args);
	        };
	        return true;
	    }

	    kendo.onWidgetRegistered(function(entry){
	        pendingPatches = $.grep(pendingPatches, function(args){
	            return !defadvice.apply(null, args);
	        });
	        createDirectives(entry.widget, entry.prefix == "Mobile");
	    });

	    /* -----[ Customize widgets for Angular ]----- */

	    defadvice([ "ui.Widget", "mobile.ui.Widget" ], "angular", function(cmd, arg){
	        var self = this.self;
	        if (cmd == "init") {
	            // `arg` here should be the widget options.
	            // the Chart doesn't send the options to Widget::init in constructor
	            // hence the OPTIONS_NOW hack (initialized in createWidget).
	            if (!arg && OPTIONS_NOW) {
	                arg = OPTIONS_NOW;
	            }
	            OPTIONS_NOW = null;
	            if (arg && arg.$angular) {
	                self.$angular_scope = arg.$angular[0];
	                self.$angular_init(self.element, arg);
	            }
	            return;
	        }

	        var scope = self.$angular_scope;

	        if (scope) {
	            withoutTimeout(function(){
	                var x = arg(), elements = x.elements, data = x.data;
	                if (elements.length > 0) {
	                    switch (cmd) {

	                      case "cleanup":
	                        angular.forEach(elements, function(el){
	                            var itemScope = $(el).data("$$kendoScope");

	                            if (itemScope && itemScope !== scope && itemScope.$$kendoScope) {
	                                destroyScope(itemScope, el);
	                            }
	                        });
	                        break;

	                      case "compile":
	                        var injector = self.element.injector();
	                        var compile = injector ? injector.get("$compile") : $defaultCompile;

	                        angular.forEach(elements, function(el, i){
	                            var itemScope;
	                            if (x.scopeFrom) {
	                                itemScope = x.scopeFrom;
	                            } else {
	                                var vars = data && data[i];
	                                if (vars !== undefined) {
	                                    itemScope = $.extend(scope.$new(), vars);
	                                    itemScope.$$kendoScope = true;
	                                } else {
	                                    itemScope = scope;
	                                }
	                            }

	                            $(el).data("$$kendoScope", itemScope);
	                            compile(el)(itemScope);
	                        });
	                        digest(scope);
	                        break;
	                    }
	                }
	            });
	        }
	    });

	    defadvice("ui.Widget", "$angular_getLogicValue", function(){
	        return this.self.value();
	    });

	    defadvice("ui.Widget", "$angular_setLogicValue", function(val){
	        this.self.value(val);
	    });

	    defadvice("ui.Select", "$angular_getLogicValue", function(){
	        var item = this.self.dataItem(),
	            valueField = this.self.options.dataValueField;

	        if (item) {
	            if (this.self.options.valuePrimitive) {
	                if (!!valueField) {
	                    return item[valueField];
	                } else {
	                    return item;
	                }
	            } else {
	                return item.toJSON();
	            }
	        } else {
	            return null;
	        }
	    });

	    defadvice("ui.Select", "$angular_setLogicValue", function(val){
	        var self = this.self;
	        var options = self.options;
	        var valueField = options.dataValueField;
	        var text = options.text || "";

	        if (val === undefined) {
	            val = "";
	        }

	        if (valueField && !options.valuePrimitive && val) {
	            text = val[options.dataTextField] || "";
	            val = val[valueField || options.dataTextField];
	        }

	        if (self.options.autoBind === false && !self.listView.bound()) {
	            if (!text && val && options.valuePrimitive) {
	                self.value(val);
	            } else {
	                self._preselect(val, text);
	            }
	        } else {
	            self.value(val);
	        }
	    });

	    defadvice("ui.MultiSelect", "$angular_getLogicValue", function() {
	        var value = this.self.dataItems().slice(0);
	        var valueField = this.self.options.dataValueField;

	        if (valueField && this.self.options.valuePrimitive) {
	            value = $.map(value, function(item) {
	                return item[valueField];
	            });
	        }

	        return value;
	    });

	    defadvice("ui.MultiSelect", "$angular_setLogicValue", function(val){
	        if (val == null) {
	            val = [];
	        }

	        var self = this.self;
	        var options = self.options;
	        var valueField = options.dataValueField;
	        var data = val;

	        if (valueField && !options.valuePrimitive) {
	            val = $.map(val, function(item) {
	                return item[valueField];
	            });
	        }

	        if (options.autoBind === false && !options.valuePrimitive && !self.listView.bound()) {
	            self._preselect(data, val);
	        } else {
	            self.value(val);
	        }
	    });

	    /* AutoComplete's getter and setter are removed!
	       By design, AutoComplete should be bound only to primitive string
	       value and data items are bound only to serve the list of suggestions.

	       Binding multiple data items is supported by the MultiSelect widget.
	    */

	    // All event handlers that are strings are compiled the Angular way.
	    defadvice("ui.Widget", "$angular_init", function(element, options) {
	        var self = this.self;
	        if (options && !$.isArray(options)) {
	            var scope = self.$angular_scope;
	            for (var i = self.events.length; --i >= 0;) {
	                var event = self.events[i];
	                var handler = options[event];
	                if (handler && typeof handler == "string") {
	                    options[event] = self.$angular_makeEventHandler(event, scope, handler);
	                }
	            }
	        }
	    });

	    // most handers will only contain a kendoEvent in the scope.
	    defadvice("ui.Widget", "$angular_makeEventHandler", function(event, scope, handler){
	        handler = $parse(handler);
	        return function(e) {
	            digest(scope, function() {
	                handler(scope, { kendoEvent: e });
	            });
	        };
	    });

	    // for the Grid and ListView we add `data` and `selected` too.
	    defadvice([ "ui.Grid", "ui.ListView", "ui.TreeView", "ui.PanelBar" ], "$angular_makeEventHandler", function(event, scope, handler){
	        if (event != "change") {
	            return this.next();
	        }
	        handler = $parse(handler);
	        return function(ev) {
	            var widget = ev.sender;
	            var options = widget.options;
	            var cell, multiple, locals = { kendoEvent: ev }, elems, items, columns, colIdx;

	            if (angular.isString(options.selectable)) {
	                cell = options.selectable.indexOf('cell') !== -1;
	                multiple = options.selectable.indexOf('multiple') !== -1;
	            }
	            if (widget._checkBoxSelection) {
	                multiple = true;
	            }

	            elems = locals.selected = this.select();
	            items = locals.data = [];
	            columns = locals.columns = [];
	            for (var i = 0; i < elems.length; i++) {
	                var item = cell ? elems[i].parentNode : elems[i];
	                var dataItem = widget.dataItem(item);
	                if (cell) {
	                    if (angular.element.inArray(dataItem, items) < 0) {
	                        items.push(dataItem);
	                    }
	                    colIdx = angular.element(elems[i]).index();
	                    if (angular.element.inArray(colIdx, columns) < 0 ) {
	                        columns.push(colIdx);
	                    }
	                } else {
	                    items.push(dataItem);
	                }
	            }

	            if (!multiple) {
	                locals.dataItem = locals.data = items[0];
	                locals.angularDataItem = kendo.proxyModelSetters(locals.dataItem);
	                locals.selected = elems[0];
	            }

	            digest(scope, function() {
	                handler(scope, locals);
	            });
	        };
	    });

	    // If no `template` is supplied for Grid columns, provide an Angular
	    // template.  The reason is that in this way AngularJS will take
	    // care to update the view as the data in scope changes.
	    defadvice("ui.Grid", "$angular_init", function(element, options){
	        this.next();
	        if (options.columns) {
	            var settings = $.extend({}, kendo.Template, options.templateSettings);
	            angular.forEach(options.columns, function(col){
	                if (col.field && !col.template && !col.format && !col.values && (col.encoded === undefined || col.encoded)) {
	                    col.template = "<span ng-bind='" +
	                        kendo.expr(col.field, "dataItem") + "'>#: " +
	                        kendo.expr(col.field, settings.paramName) + "#</span>";
	                }
	            });
	        }
	    });

	    {
	        // mobile/ButtonGroup does not have a "value" method, but looks
	        // like it would be useful.  We provide it here.

	        defadvice("mobile.ui.ButtonGroup", "value", function(mew){
	            var self = this.self;
	            if (mew != null) {
	                self.select(self.element.children("li.km-button").eq(mew));
	                self.trigger("change");
	                self.trigger("select", { index: self.selectedIndex });
	            }
	            return self.selectedIndex;
	        });

	        defadvice("mobile.ui.ButtonGroup", "_select", function(){
	            this.next();
	            this.self.trigger("change");
	        });
	    }

	    // mobile directives
	    module
	    .directive('kendoMobileApplication', function() {
	        return {
	            terminal: true,
	            link: function(scope, element, attrs) {
	                createWidget(scope, element, attrs, 'kendoMobileApplication', 'kendoMobileApplication');
	            }
	        };
	    }).directive('kendoMobileView', function() {
	        return {
	            scope: true,
	            link: {
	                pre: function(scope, element, attrs) {
	                    attrs.defaultOptions = scope.viewOptions;
	                    attrs._instance = createWidget(scope, element, attrs, 'kendoMobileView', 'kendoMobileView');
	                },

	                post: function(scope, element, attrs) {
	                    attrs._instance._layout();
	                    attrs._instance._scroller();
	                }
	            }
	        };
	    }).directive('kendoMobileDrawer', function() {
	        return {
	            scope: true,
	            link: {
	                pre: function(scope, element, attrs) {
	                    attrs.defaultOptions = scope.viewOptions;
	                    attrs._instance = createWidget(scope, element, attrs, 'kendoMobileDrawer', 'kendoMobileDrawer');
	                },

	                post: function(scope, element, attrs) {
	                    attrs._instance._layout();
	                    attrs._instance._scroller();
	                }
	            }
	        };
	    }).directive('kendoMobileModalView', function() {
	        return {
	            scope: true,
	            link: {
	                pre: function(scope, element, attrs) {
	                    attrs.defaultOptions = scope.viewOptions;
	                    attrs._instance = createWidget(scope, element, attrs, 'kendoMobileModalView', 'kendoMobileModalView');
	                },

	                post: function(scope, element, attrs) {
	                    attrs._instance._layout();
	                    attrs._instance._scroller();
	                }
	            }
	        };
	    }).directive('kendoMobileSplitView', function() {
	        return {
	            terminal: true,
	            link: {
	                pre: function(scope, element, attrs) {
	                    attrs.defaultOptions = scope.viewOptions;
	                    attrs._instance = createWidget(scope, element, attrs, 'kendoMobileSplitView', 'kendoMobileSplitView');
	                },

	                post: function(scope, element, attrs) {
	                    attrs._instance._layout();
	                }
	            }
	        };
	    }).directive('kendoMobilePane', function() {
	        return {
	            terminal: true,
	            link: {
	                pre: function(scope, element, attrs) {
	                    attrs.defaultOptions = scope.viewOptions;
	                    createWidget(scope, element, attrs, 'kendoMobilePane', 'kendoMobilePane');
	                }
	            }
	        };
	    }).directive('kendoMobileLayout', function() {
	        return {
	            link: {
	                pre: function (scope, element, attrs) {
	                    createWidget(scope, element, attrs, 'kendoMobileLayout', 'kendoMobileLayout');
	                }
	            }
	        };
	    }).directive('kendoMobileActionSheet', function() {
	        return {
	            restrict: "A",
	            link: function(scope, element, attrs) {
	                element.find("a[k-action]").each(function() {
	                    $(this).attr("data-" + kendo.ns + "action", $(this).attr("k-action"));
	                });

	                createWidget(scope, element, attrs, 'kendoMobileActionSheet', 'kendoMobileActionSheet');
	            }
	        };
	    }).directive('kendoMobilePopOver', function() {
	        return {
	            terminal: true,
	            link: {
	                pre: function(scope, element, attrs) {
	                    attrs.defaultOptions = scope.viewOptions;
	                    createWidget(scope, element, attrs, 'kendoMobilePopOver', 'kendoMobilePopOver');
	                }
	            }
	        };
	    }).directive('kendoViewTitle', function(){
	        return {
	            restrict : "E",
	            replace  : true,
	            template : function(element) {
	                return "<span data-" + kendo.ns + "role='view-title'>" + element.html() + "</span>";
	            }
	        };
	    }).directive('kendoMobileHeader', function() {
	            return {
	                restrict: "E",
	                link: function(scope, element) {
	                    element.addClass("km-header").attr("data-role", "header");
	                }
	            };
	    }).directive('kendoMobileFooter', function() {
	            return {
	                restrict: 'E',
	                link: function(scope, element) {
	                    element.addClass("km-footer").attr("data-role", "footer");
	                }
	            };
	    }).directive('kendoMobileScrollViewPage', function(){
	        return {
	            restrict : "E",
	            replace  : true,
	            template : function(element) {
	                return "<div data-" + kendo.ns + "role='page'>" + element.html() + "</div>";
	            }
	        };
	    });

	    angular.forEach(['align', 'icon', 'rel', 'transition', 'actionsheetContext'], function(attr) {
	          var kAttr = "k" + attr.slice(0, 1).toUpperCase() + attr.slice(1);

	          module.directive(kAttr, function() {
	              return {
	                  restrict: 'A',
	                  priority: 2,
	                  link: function(scope, element, attrs) {
	                      element.attr(kendo.attr(kendo.toHyphens(attr)), scope.$eval(attrs[kAttr]));
	                  }
	              };
	          });
	    });

	    var WIDGET_TEMPLATE_OPTIONS = {
	        "TreeMap": [ "Template" ],
	        "MobileListView": [ "HeaderTemplate", "Template" ],
	        "MobileScrollView": [ "EmptyTemplate", "Template" ],
	        "Grid": [ "AltRowTemplate", "DetailTemplate", "RowTemplate" ],
	        "ListView": [ "EditTemplate", "Template", "AltTemplate" ],
	        "Pager": [ "SelectTemplate", "LinkTemplate" ],
	        "PivotGrid": [ "ColumnHeaderTemplate", "DataCellTemplate", "RowHeaderTemplate" ],
	        "Scheduler": ["AllDayEventTemplate", "DateHeaderTemplate", "EventTemplate", "MajorTimeHeaderTemplate", "MinorTimeHeaderTemplate"],
	        "ScrollView": [ "Template" ],
	        "PanelBar": [ "Template" ],
	        "TreeView": [ "Template" ],
	        "Validator": [ "ErrorTemplate" ]
	    };

	    (function() {
	        var templateDirectives = {};
	        angular.forEach(WIDGET_TEMPLATE_OPTIONS, function(templates, widget) {
	            angular.forEach(templates, function(template) {
	                if (!templateDirectives[template]) {
	                    templateDirectives[template] = [ ];
	                }
	                templateDirectives[template].push("?^^kendo" + widget);
	            });
	        });

	        angular.forEach(templateDirectives, function(parents, directive) {
	            var templateName = "k" + directive;
	            var attrName = kendo.toHyphens(templateName);

	            module.directive(templateName, function() {
	                return {
	                    restrict: "A",
	                    require: parents,
	                    terminal: true,
	                    compile: function($element, $attrs) {
	                        if ($attrs[templateName] !== "") {
	                            return;
	                        }

	                        $element.removeAttr(attrName);
	                        var template = $element[0].outerHTML;

	                        return function(scope, element, attrs, controllers) {
	                            var controller;

	                            while(!controller && controllers.length) {
	                                controller = controllers.shift();
	                            }

	                            if (!controller) {
	                                $log.warn(attrName + " without a matching parent widget found. It can be one of the following: " + parents.join(", "));
	                            } else {
	                                controller.template(templateName, template);
	                                element.remove();
	                            }
	                        };
	                    }
	                };
	            });
	        });

	    })();


	})(window.kendo.jQuery, window.angular);

	return window.kendo;

	}, __webpack_require__(3));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1048)))

/***/ }),

/***/ 1048:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("BOhp");

/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ })

/******/ });

/***/ }),

/***/ "eQt4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var changedPath_1 = __webpack_require__("ODdY");
var rowRenderer_1 = __webpack_require__("3RUv");
var eventService_1 = __webpack_require__("k5uU");
var constants_1 = __webpack_require__("ZZFX");
var beanStub_1 = __webpack_require__("xffp");
var events_1 = __webpack_require__("3ok8");
var ChangeDetectionService = (function (_super) {
    __extends(ChangeDetectionService, _super);
    function ChangeDetectionService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChangeDetectionService.prototype.init = function () {
        if (this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_IN_MEMORY) {
            this.inMemoryRowModel = this.rowModel;
        }
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged.bind(this));
    };
    ChangeDetectionService.prototype.onCellValueChanged = function (event) {
        this.doChangeDetection(event.node, event.column);
    };
    ChangeDetectionService.prototype.doChangeDetection = function (rowNode, column) {
        if (this.gridOptionsWrapper.isSuppressChangeDetection()) {
            return;
        }
        // step 1 of change detection is to update the aggregated values
        if (this.inMemoryRowModel) {
            var changedPath = void 0;
            if (rowNode.parent) {
                var onlyChangedColumns = this.gridOptionsWrapper.isAggregateOnlyChangedColumns();
                changedPath = new changedPath_1.ChangedPath(onlyChangedColumns);
                changedPath.addParentNode(rowNode.parent, [column]);
            }
            this.inMemoryRowModel.doAggregate(changedPath);
        }
        // step 2 of change detection is to refresh the cells
        this.rowRenderer.refreshCells();
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], ChangeDetectionService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('rowModel'),
        __metadata("design:type", Object)
    ], ChangeDetectionService.prototype, "rowModel", void 0);
    __decorate([
        context_1.Autowired('rowRenderer'),
        __metadata("design:type", rowRenderer_1.RowRenderer)
    ], ChangeDetectionService.prototype, "rowRenderer", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], ChangeDetectionService.prototype, "eventService", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ChangeDetectionService.prototype, "init", null);
    ChangeDetectionService = __decorate([
        context_1.Bean('changeDetectionService')
    ], ChangeDetectionService);
    return ChangeDetectionService;
}(beanStub_1.BeanStub));
exports.ChangeDetectionService = ChangeDetectionService;


/***/ }),

/***/ "ed5Q":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1436);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1048:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("BOhp");

/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1264:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Z9Q2");

/***/ }),

/***/ 1436:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1059), __webpack_require__(1264) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "treeview",
	    name: "TreeView",
	    category: "web",
	    description: "The TreeView widget displays hierarchical data in a traditional tree structure,with support for interactive drag-and-drop operations.",
	    depends: [ "data" ],
	    features: [{
	        id: "treeview-dragging",
	        name: "Drag & Drop",
	        description: "Support for drag & drop",
	        depends: [ "treeview.draganddrop" ]
	    }]
	};

	/*jshint eqnull: true */
	(function($, undefined){
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        data = kendo.data,
	        extend = $.extend,
	        template = kendo.template,
	        isArray = $.isArray,
	        Widget = ui.Widget,
	        HierarchicalDataSource = data.HierarchicalDataSource,
	        proxy = $.proxy,
	        keys = kendo.keys,
	        NS = ".kendoTreeView",
	        TEMP_NS = ".kendoTreeViewTemp",
	        SELECT = "select",
	        CHECK = "check",
	        NAVIGATE = "navigate",
	        EXPAND = "expand",
	        CHANGE = "change",
	        ERROR = "error",
	        CHECKED = "checked",
	        INDETERMINATE = "indeterminate",
	        COLLAPSE = "collapse",
	        DRAGSTART = "dragstart",
	        DRAG = "drag",
	        DROP = "drop",
	        DRAGEND = "dragend",
	        DATABOUND = "dataBound",
	        CLICK = "click",
	        UNDEFINED = "undefined",
	        KSTATEHOVER = "k-state-hover",
	        KTREEVIEW = "k-treeview",
	        VISIBLE = ":visible",
	        NODE = ".k-item",
	        STRING = "string",
	        ARIACHECKED = "aria-checked",
	        ARIASELECTED = "aria-selected",
	        ARIADISABLED = "aria-disabled",
	        ARIAEXPANDED = "aria-expanded",
	        DISABLED = "k-state-disabled",
	        TreeView,
	        subGroup, nodeContents, nodeIcon,
	        spriteRe,
	        bindings = {
	            text: "dataTextField",
	            url: "dataUrlField",
	            spriteCssClass: "dataSpriteCssClassField",
	            imageUrl: "dataImageUrlField"
	        },
	        isJQueryInstance = function(obj) {
	            return (obj instanceof kendo.jQuery) || (window.jQuery && obj instanceof window.jQuery);
	        },
	        isDomElement = function (o){
	            return (
	                typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
	                o && typeof o === "object" && o.nodeType === 1 && typeof o.nodeName === STRING
	            );
	        };

	    function contentChild(filter) {
	        return function(node) {
	            var result = node.children(".k-animation-container");

	            if (!result.length) {
	                result = node;
	            }

	            return result.children(filter);
	        };
	    }

	    function templateNoWith(code) {
	        return kendo.template(code, { useWithBlock: false });
	    }

	    subGroup = contentChild(".k-group");
	    nodeContents = contentChild(".k-group,.k-content");
	    nodeIcon = function(node) {
	        return node.children("div").children(".k-icon");
	    };

	    function checkboxes(node) {
	        return node.find(".k-checkbox-wrapper:first input[type=checkbox]");
	    }

	    function insertAction(indexOffset) {
	        return function (nodeData, referenceNode) {
	            referenceNode = referenceNode.closest(NODE);

	            var group = referenceNode.parent(),
	                parentNode;

	            if (group.parent().is("li")) {
	                parentNode = group.parent();
	            }

	            return this._dataSourceMove(nodeData, group, parentNode, function (dataSource, model) {
	                var referenceItem = this.dataItem(referenceNode);
	                var referenceNodeIndex = referenceItem ? referenceItem.parent().indexOf(referenceItem) : referenceNode.index();

	                return this._insert(dataSource.data(), model, referenceNodeIndex + indexOffset);
	            });
	        };
	    }

	    spriteRe = /k-sprite/;

	    function moveContents(node, container) {
	        var tmp;

	        while (node && node.nodeName.toLowerCase() != "ul") {
	            tmp = node;
	            node = node.nextSibling;

	            if (tmp.nodeType == 3) {
	                tmp.nodeValue = kendo.trim(tmp.nodeValue);
	            }

	            if (spriteRe.test(tmp.className)) {
	                container.insertBefore(tmp, container.firstChild);
	            } else {
	                container.appendChild(tmp);
	            }
	        }
	    }

	    function updateNodeHtml(node) {
	        var wrapper = node.children("div"),
	            group = node.children("ul"),
	            toggleButton = wrapper.children(".k-icon"),
	            checkbox = node.children("input[type=checkbox]"),
	            innerWrapper = wrapper.children(".k-in");

	        if (node.hasClass("k-treeview")) {
	            return;
	        }

	        if (!wrapper.length) {
	            wrapper = $("<div />").prependTo(node);
	        }

	        if (!toggleButton.length && group.length) {
	            toggleButton = $("<span class='k-icon' />").prependTo(wrapper);
	        } else if (!group.length || !group.children().length) {
	            toggleButton.remove();
	            group.remove();
	        }

	        if (checkbox.length) {
	            $("<span class='k-checkbox-wrapper' />").appendTo(wrapper).append(checkbox);
	        }

	        if (!innerWrapper.length) {
	            innerWrapper = node.children("a").eq(0).addClass("k-in k-link");

	            if (!innerWrapper.length) {
	                innerWrapper = $("<span class='k-in' />");
	            }

	            innerWrapper.appendTo(wrapper);

	            if (wrapper.length) {
	                moveContents(wrapper[0].nextSibling, innerWrapper[0]);
	            }
	        }
	    }

	    TreeView = kendo.ui.DataBoundWidget.extend({
	        init: function (element, options) {
	            var that = this,
	                inferred = false,
	                hasDataSource = options && !!options.dataSource,
	                list;

	            if (isArray(options)) {
	                options = { dataSource: options };
	            }

	            if (options && typeof options.loadOnDemand == UNDEFINED && isArray(options.dataSource)) {
	                options.loadOnDemand = false;
	            }

	            Widget.prototype.init.call(that, element, options);

	            element = that.element;
	            options = that.options;

	            that._dataSourceUids = {};

	            list = (element.is("ul") && element) ||
	                   (element.hasClass(KTREEVIEW) && element.children("ul"));

	            inferred = !hasDataSource && list.length;

	            if (inferred) {
	                options.dataSource.list = list;
	            }

	            that._animation();

	            that._accessors();

	            that._templates();

	            // render treeview if it's not already rendered
	            if (!element.hasClass(KTREEVIEW)) {
	                that._wrapper();

	                if (list) {
	                    that.root = element;
	                    that._group(that.wrapper);
	                }
	            } else {
	                // otherwise just initialize properties
	                that.wrapper = element;
	                that.root = element.children("ul").eq(0);
	            }

	            that._tabindex();

	            that.wrapper.attr("role", "tree");

	            that._dataSource(inferred);

	            that._attachEvents();

	            that._dragging();

	            if (!inferred) {
	                if (options.autoBind) {
	                    that._progress(true);
	                    that.dataSource.fetch();
	                }
	            } else {
	                that._syncHtmlAndDataSource();
	            }

	            if (options.checkboxes && options.checkboxes.checkChildren) {
	                that.updateIndeterminate();
	            }

	            if (that.element[0].id) {
	                that._ariaId = kendo.format("{0}_tv_active", that.element[0].id);
	            }

	            kendo.notify(that);
	        },

	        _attachEvents: function() {
	            var that = this,
	                clickableItems = ".k-in:not(.k-state-selected,.k-state-disabled)",
	                MOUSEENTER = "mouseenter";

	            that.wrapper
	                .on(MOUSEENTER + NS, ".k-in.k-state-selected", function(e) { e.preventDefault(); })
	                .on(MOUSEENTER + NS, clickableItems, function () { $(this).addClass(KSTATEHOVER); })
	                .on("mouseleave" + NS, clickableItems, function () { $(this).removeClass(KSTATEHOVER); })
	                .on(CLICK + NS, clickableItems, proxy(that._click, that))
	                .on("dblclick" + NS, ".k-in:not(.k-state-disabled)", proxy(that._toggleButtonClick, that))
	                .on(CLICK + NS, ".k-i-expand,.k-i-collapse", proxy(that._toggleButtonClick, that))
	                .on("keydown" + NS, proxy(that._keydown, that))
	                .on("keypress" + NS, proxy(that._keypress, that))
	                .on("focus" + NS, proxy(that._focus, that))
	                .on("blur" + NS, proxy(that._blur, that))
	                .on("mousedown" + NS, ".k-in,.k-checkbox-wrapper :checkbox,.k-i-expand,.k-i-collapse", proxy(that._mousedown, that))
	                .on("change" + NS, ".k-checkbox-wrapper :checkbox", proxy(that._checkboxChange, that))
	                .on("click" + NS, ".checkbox-span", proxy(that._checkboxLabelClick, that))
	                .on("click" + NS, ".k-request-retry", proxy(that._retryRequest, that))
	                .on("click" + NS, ".k-link.k-state-disabled", function(e) { e.preventDefault(); })
	                .on("click" + NS, function(e) {
	                    var target = $(e.target);

	                    if (!target.is(":kendoFocusable") && !target.find("input,select,textarea,button,object").is(":kendoFocusable")) {
	                        that.focus();
	                    }
	                });
	        },

	        _checkboxLabelClick: function(e) {
	            var checkbox = $(e.target.previousSibling);

	            if (checkbox.is("[disabled]")) {
	                return;
	            }

	            checkbox.prop('checked', !checkbox.prop('checked'));
	            checkbox.trigger('change');
	        },

	        _syncHtmlAndDataSource: function (root, dataSource) {
	            root = root || this.root;
	            dataSource = dataSource || this.dataSource;
	            var data = dataSource.view(),
	                uidAttr = kendo.attr("uid"),
	                expandedAttr = kendo.attr("expanded"),
	                checkboxesEnabled = this.options.checkboxes,
	                items = root.children("li"),
	                i,
	                item,
	                dataItem,
	                uid,
	                itemCheckbox;

	            for (i = 0; i < items.length; i++) {
	                dataItem = data[i];
	                uid = dataItem.uid;
	                item = items.eq(i);
	                item.attr("role", "treeitem")
	                    .attr(uidAttr, uid)
	                    .attr(ARIASELECTED, item.hasClass("k-state-selected"));

	                dataItem.expanded = item.attr(expandedAttr) === "true";

	                if (checkboxesEnabled) {
	                    itemCheckbox = checkboxes(item);
	                    dataItem.checked = itemCheckbox.prop(CHECKED);
	                    itemCheckbox.attr("id", "_" + uid);
	                    itemCheckbox.next(".k-checkbox-label").attr("for", "_" + uid);
	                }

	                this._syncHtmlAndDataSource(item.children("ul"), dataItem.children);
	            }
	        },

	        _animation: function() {
	            var options = this.options,
	                animationOptions = options.animation,
	                hasCollapseAnimation = animationOptions.collapse && "effects" in animationOptions.collapse,
	                collapse = extend({}, animationOptions.expand, animationOptions.collapse);

	            if (!hasCollapseAnimation) {
	                collapse = extend(collapse, {reverse: true});
	            }

	            if (animationOptions === false) {
	                animationOptions = {
	                    expand: { effects: {} },
	                    collapse: { hide: true, effects: {} }
	                };
	            }

	            animationOptions.collapse = extend(collapse, {hide: true});
	            options.animation = animationOptions;
	        },

	        _dragging: function() {
	            var enabled = this.options.dragAndDrop;
	            var dragging = this.dragging;

	            if (enabled && !dragging) {
	                var widget = this;

	                this.dragging = new ui.HierarchicalDragAndDrop(this.element, {
	                    reorderable: true,
	                    $angular: this.options.$angular,
	                    autoScroll: this.options.autoScroll,
	                    filter: "div:not(.k-state-disabled) .k-in",
	                    allowedContainers: ".k-treeview",
	                    itemSelector: ".k-treeview .k-item",
	                    hintText: proxy(this._hintText, this),
	                    contains: function(source, destination) {
	                        return $.contains(source, destination);
	                    },
	                    dropHintContainer: function(item) {
	                        return item;
	                    },
	                    itemFromTarget: function(target) {
	                        var item = target.closest(".k-top,.k-mid,.k-bot");
	                        return {
	                            item: item,
	                            content: target.closest(".k-in"),
	                            first: item.hasClass("k-top"),
	                            last: item.hasClass("k-bot")
	                        };
	                    },
	                    dropPositionFrom: function(dropHint) {
	                        return dropHint.prevAll(".k-in").length > 0 ? "after" : "before";
	                    },
	                    dragstart: function(source) {
	                        return widget.trigger(DRAGSTART, { sourceNode: source[0] });
	                    },
	                    drag: function(options) {
	                        widget.trigger(DRAG, {
	                            originalEvent: options.originalEvent,
	                            sourceNode: options.source[0],
	                            dropTarget: options.target[0],
	                            pageY: options.pageY,
	                            pageX: options.pageX,
	                            statusClass: options.status,
	                            setStatusClass: options.setStatus
	                        });
	                    },
	                    drop: function(options) {
	                        var dropTarget = $(options.dropTarget);
	                        var navigationTarget = dropTarget.closest("a");

	                        if(navigationTarget && navigationTarget.attr("href")) {
	                            widget._tempPreventNavigation(navigationTarget);
	                        }

	                        return widget.trigger(DROP, {
	                            originalEvent: options.originalEvent,
	                            sourceNode: options.source,
	                            destinationNode: options.destination,
	                            valid: options.valid,
	                            setValid: function(state) {
	                                this.valid = state;
	                                options.setValid(state);
	                            },
	                            dropTarget: options.dropTarget,
	                            dropPosition: options.position
	                        });
	                    },
	                    dragend: function(options) {
	                        var source = options.source;
	                        var destination = options.destination;
	                        var position = options.position;

	                        function triggerDragEnd(source) {
	                            if (widget.options.checkboxes && widget.options.checkboxes.checkChildren) {
	                                widget.updateIndeterminate();
	                            }

	                            widget.trigger(DRAGEND, {
	                                originalEvent: options.originalEvent,
	                                sourceNode: source && source[0],
	                                destinationNode: destination[0],
	                                dropPosition: position
	                            });
	                        }

	                        // perform reorder / move
	                        // different handling is necessary because append might be async in remote bound tree
	                        if (position == "over") {
	                            widget.append(source, destination, triggerDragEnd);
	                        } else {
	                            if (position == "before") {
	                                source = widget.insertBefore(source, destination);
	                            } else if (position == "after") {
	                                source = widget.insertAfter(source, destination);
	                            }

	                            triggerDragEnd(source);
	                        }
	                    }
	                });
	            } else if (!enabled && dragging) {
	                dragging.destroy();
	                this.dragging = null;
	            }
	        },

	        _tempPreventNavigation: function(node) {
	            node.on(CLICK + NS + TEMP_NS, function (ev) {
	                ev.preventDefault();
	                node.off(CLICK + NS + TEMP_NS);
	            });
	        },

	        _hintText: function(node) {
	            return this.templates.dragClue({
	                item: this.dataItem(node),
	                treeview: this.options
	            });
	        },

	        _templates: function() {
	            var that = this,
	                options = that.options,
	                fieldAccessor = proxy(that._fieldAccessor, that);

	            if (options.template && typeof options.template == STRING) {
	                options.template = template(options.template);
	            } else if (!options.template) {
	                options.template = templateNoWith(
	                    "# var text = " + fieldAccessor("text") + "(data.item); #" +
	                    "# if (typeof data.item.encoded != 'undefined' && data.item.encoded === false) {#" +
	                        "#= text #" +
	                    "# } else { #" +
	                        "#: text #" +
	                    "# } #"
	                );
	            }

	            that._checkboxes();

	            that.templates = {
	                setAttributes: function (item) {
	                    var result = "";
	                    var attributes = item.attr || {};

	                    for (var attr in attributes) {
	                        if(attributes.hasOwnProperty(attr) && attr !== "class") {
	                            result += attr + "=\"" + attributes[attr] + "\" ";
	                        }
	                    }

	                    return result;
	                },
	                wrapperCssClass: function (group, item) {
	                    var result = "k-item",
	                        index = item.index;

	                    if (group.firstLevel && index === 0) {
	                        result += " k-first";
	                    }

	                    if (index == group.length-1) {
	                        result += " k-last";
	                    }

	                    return result;
	                },
	                cssClass: function(group, item) {
	                    var result = "",
	                        index = item.index,
	                        groupLength = group.length - 1;

	                    if (group.firstLevel && index === 0) {
	                        result += "k-top ";
	                    }

	                    if (index === 0 && index != groupLength) {
	                        result += "k-top";
	                    } else if (index == groupLength) {
	                        result += "k-bot";
	                    } else {
	                        result += "k-mid";
	                    }

	                    return result;
	                },
	                textClass: function(item, isLink) {
	                    var result = "k-in";

	                    if (isLink) {
	                        result += " k-link";
	                    }

	                    if (item.enabled === false) {
	                        result += " k-state-disabled";
	                    }

	                    if (item.selected === true) {
	                        result += " k-state-selected";
	                    }

	                    return result;
	                },
	                toggleButtonClass: function(item) {
	                    var result = "k-icon";

	                    if (item.expanded !== true) {
	                        result += " k-i-expand";
	                    } else {
	                        result += " k-i-collapse";
	                    }

	                    return result;
	                },
	                groupAttributes: function(group) {
	                    var attributes = "";

	                    if (!group.firstLevel) {
	                        attributes = "role='group'";
	                    }

	                    return attributes + (group.expanded !== true ? " style='display:none'" : "");
	                },
	                groupCssClass: function(group) {
	                    var cssClass = "k-group";

	                    if (group.firstLevel) {
	                        cssClass += " k-treeview-lines";
	                    }

	                    return cssClass;
	                },
	                dragClue: templateNoWith(
	                    "#= data.treeview.template(data) #"
	                ),
	                group: templateNoWith(
	                    "<ul class='#= data.r.groupCssClass(data.group) #'#= data.r.groupAttributes(data.group) #>" +
	                        "#= data.renderItems(data) #" +
	                    "</ul>"
	                ),
	                itemContent: templateNoWith(
	                    "# var imageUrl = " + fieldAccessor("imageUrl") + "(data.item); #" +
	                    "# var spriteCssClass = " + fieldAccessor("spriteCssClass") + "(data.item); #" +
	                    "# if (imageUrl) { #" +
	                        "<img class='k-image' alt='' src='#= imageUrl #'>" +
	                    "# } #" +

	                    "# if (spriteCssClass) { #" +
	                        "<span class='k-sprite #= spriteCssClass #'></span>" +
	                    "# } #" +

	                    "#= data.treeview.template(data) #"
	                ),
	                itemElement: templateNoWith(
	                    "# var item = data.item, r = data.r; #" +
	                    "# var url = " + fieldAccessor("url") + "(item); #" +
	                    "<div class='#= r.cssClass(data.group, item) #'>" +
	                        "# if (item.hasChildren) { #" +
	                            "<span class='#= r.toggleButtonClass(item) #'></span>" +
	                        "# } #" +

	                        "# if (data.treeview.checkboxes) { #" +
	                            "<span class='k-checkbox-wrapper' role='presentation'>" +
	                                "#= data.treeview.checkboxes.template(data) #" +
	                            "</span>" +
	                        "# } #" +

	                        "# var tag = url ? 'a' : 'span'; #" +
	                        "# var textAttr = url ? ' href=\\'' + url + '\\'' : ''; #" +

	                        "<#=tag# class='#= r.textClass(item, !!url) #'#= textAttr #>" +
	                            "#= r.itemContent(data) #" +
	                        "</#=tag#>" +
	                    "</div>"
	                ),
	                item: templateNoWith(
	                    "# var item = data.item, r = data.r; #" +
	                    "<li role='treeitem' class='#= r.wrapperCssClass(data.group, item) #'" +
	                        kendo.attr("uid") + "='#= item.uid #' " +
	                        "#= r.setAttributes(item.toJSON ? item.toJSON() : item) # " +
	                        "# if (data.treeview.checkboxes) { #" +
	                            "aria-checked='#= item.checked ? \"true\" : \"false\" #' " +
	                        "# } #" +
	                        "aria-selected='#= item.selected ? \"true\" : \"false\" #' " +
	                        "#=item.enabled === false ? \"aria-disabled='true'\" : ''#" +
	                        "aria-expanded='#= item.expanded ? \"true\" : \"false\" #' " +
	                        "data-expanded='#= item.expanded ? \"true\" : \"false\" #' " +
	                    ">" +
	                        "#= r.itemElement(data) #" +
	                    "</li>"
	                ),
	                loading: templateNoWith(
	                    "<div class='k-icon k-i-loading'></div> #: data.messages.loading #"
	                ),
	                retry: templateNoWith(
	                    "#: data.messages.requestFailed # " +
	                    "<button class='k-button k-request-retry'>#: data.messages.retry #</button>"
	                )
	            };
	        },

	        items: function() {
	            return this.element.find(".k-item > div:first-child");
	        },

	        setDataSource: function(dataSource) {
	            var options = this.options;

	            options.dataSource = dataSource;

	            this._dataSourceUids = {};

	            this._dataSource();

	            if (options.checkboxes && options.checkboxes.checkChildren) {
	                this.dataSource.one("change", $.proxy(this.updateIndeterminate, this, null));
	            }

	            if (this.options.autoBind) {
	                this.dataSource.fetch();
	            }
	        },

	        _bindDataSource: function() {
	            this._refreshHandler = proxy(this.refresh, this);
	            this._errorHandler = proxy(this._error, this);

	            this.dataSource.bind(CHANGE, this._refreshHandler);
	            this.dataSource.bind(ERROR, this._errorHandler);
	        },

	        _unbindDataSource: function() {
	            var dataSource = this.dataSource;

	            if (dataSource) {
	                dataSource.unbind(CHANGE, this._refreshHandler);
	                dataSource.unbind(ERROR, this._errorHandler);
	            }
	        },

	        _dataSource: function(silentRead) {
	            var that = this,
	                options = that.options,
	                dataSource = options.dataSource;

	            function recursiveRead(data) {
	                for (var i = 0; i < data.length; i++) {
	                    data[i]._initChildren();

	                    data[i].children.fetch();

	                    recursiveRead(data[i].children.view());
	                }
	            }

	            dataSource = isArray(dataSource) ? { data: dataSource } : dataSource;

	            that._unbindDataSource();

	            if (!dataSource.fields) {
	                dataSource.fields = [
	                    { field: "text" },
	                    { field: "url" },
	                    { field: "spriteCssClass" },
	                    { field: "imageUrl" }
	                ];
	            }

	            that.dataSource = dataSource = HierarchicalDataSource.create(dataSource);

	            if (silentRead) {
	                dataSource.fetch();

	                recursiveRead(dataSource.view());
	            }

	            that._bindDataSource();
	        },

	        events: [
	            DRAGSTART,
	            DRAG,
	            DROP,
	            DRAGEND,

	            DATABOUND,

	            EXPAND,
	            COLLAPSE,
	            SELECT,
	            CHANGE,
	            NAVIGATE,
	            CHECK
	        ],

	        options: {
	            name: "TreeView",
	            dataSource: {},
	            animation: {
	                expand: {
	                    effects: "expand:vertical",
	                    duration: 200
	                }, collapse: {
	                    duration: 100
	                }
	            },
	            messages: {
	                loading: "Loading...",
	                requestFailed: "Request failed.",
	                retry: "Retry"
	            },
	            dragAndDrop: false,
	            checkboxes: false,
	            autoBind: true,
	            autoScroll: false,
	            loadOnDemand: true,
	            template: "",
	            dataTextField: null
	        },

	        _accessors: function() {
	            var that = this,
	                options = that.options,
	                i, field, textField,
	                element = that.element;

	            for (i in bindings) {
	                field = options[bindings[i]];
	                textField = element.attr(kendo.attr(i + "-field"));

	                if (!field && textField) {
	                    field = textField;
	                }

	                if (!field) {
	                    field = i;
	                }

	                if (!isArray(field)) {
	                    field = [field];
	                }

	                options[bindings[i]] = field;
	            }
	        },

	        // generates accessor function for a given field name, honoring the data*Field arrays
	        _fieldAccessor: function(fieldName) {
	            var fieldBindings = this.options[bindings[fieldName]],
	                count = fieldBindings.length,
	                result = "(function(item) {";

	            if (count === 0) {
	                result += "return item['" + fieldName + "'];";
	            } else {
	                result += "var levels = [" +
	                            $.map(fieldBindings, function(x) {
	                                return "function(d){ return " + kendo.expr(x) + "}";
	                            }).join(",") + "];";

	                result += "return levels[Math.min(item.level(), " + count + "-1)](item)";
	            }

	            result += "})";

	            return result;
	        },

	        setOptions: function(options) {
	            Widget.fn.setOptions.call(this, options);

	            this._animation();

	            this._dragging();

	            this._templates();
	        },

	        _trigger: function (eventName, node) {
	            return this.trigger(eventName, {
	                node: node.closest(NODE)[0]
	            });
	        },

	        _setChecked: function(datasource, value) {
	            if (!datasource || !$.isFunction(datasource.view)) {
	                return;
	            }

	            for (var i = 0, nodes = datasource.view(); i < nodes.length; i++) {
	                if(nodes[i].enabled !== false){
	                    this._setCheckedValue(nodes[i], value);
	                }

	                if (nodes[i].children) {
	                    this._setChecked(nodes[i].children, value);
	                }
	            }
	        },

	        _setCheckedValue: function (node, value){
	            node[CHECKED] = value;
	        },

	        _setIndeterminate: function(node) {
	            var group = subGroup(node),
	                siblings, length,
	                all = true,
	                i;

	            if (!group.length) {
	                return;
	            }

	            siblings = checkboxes(group.children());

	            length = siblings.length;

	            if (!length) {
	                return;
	            } else if (length > 1) {
	                for (i = 1; i < length; i++) {
	                    if (siblings[i].checked != siblings[i-1].checked ||
	                        siblings[i].indeterminate || siblings[i-1].indeterminate) {
	                        all = false;
	                        break;
	                    }
	                }
	            } else {
	                all = !siblings[0].indeterminate;
	            }

	            node.attr(ARIACHECKED, all ? siblings[0].checked : "mixed");

	            return checkboxes(node)
	                .data(INDETERMINATE, !all)
	                .prop(INDETERMINATE, !all)
	                .prop(CHECKED, all && siblings[0].checked);
	        },

	        updateIndeterminate: function(node) {
	            // top-down update of inital indeterminate state for all nodes
	            node = node || this.wrapper;

	            var subnodes = subGroup(node).children();
	            var i;
	            var checkbox;
	            var dataItem;

	            if (subnodes.length) {
	                for (i = 0; i < subnodes.length; i++) {
	                    this.updateIndeterminate(subnodes.eq(i));
	                }

	                if (node.is(".k-treeview")) {
	                    return;
	                }

	                checkbox = this._setIndeterminate(node);

	                dataItem = this.dataItem(node);

	                if (checkbox && checkbox.prop(CHECKED)) {
	                    dataItem.checked = true;
	                } else {
	                    if (dataItem) {
	                        delete dataItem.checked;
	                    }
	                }
	            }
	        },

	        _bubbleIndeterminate: function(node, skipDownward) {
	            // bottom-up setting of indeterminate state of parent nodes
	            if (!node.length) {
	                return;
	            }

	            if (!skipDownward) {
	                //update the indeterminate state of the node itself
	                this.updateIndeterminate(node);
	            }

	            var parentNode = this.parent(node),
	                checkbox;

	            if (parentNode.length) {
	                this._setIndeterminate(parentNode);

	                checkbox = parentNode.children("div").find(".k-checkbox-wrapper input[type=checkbox]");

	                this._skip = true;
	                if (checkbox.prop(INDETERMINATE) === false) {
	                    this.dataItem(parentNode).set(CHECKED, checkbox.prop(CHECKED));
	                } else {
	                    // delete this.dataItem(parentNode).checked;
	                    this.dataItem(parentNode).set(CHECKED, false);
	                }

	                this._skip = false;

	                this._bubbleIndeterminate(parentNode, true);
	            }
	        },

	        _checkboxChange: function(e) {
	            var that = this;
	            var checkbox = $(e.target);
	            var isChecked = checkbox.prop(CHECKED);
	            var node = checkbox.closest(NODE);
	            var dataItem = this.dataItem(node);

	            if (this._preventChange) {
	                return;
	            }

	            if (dataItem.checked != isChecked) {
	                dataItem.set(CHECKED, isChecked);
	                node.attr(ARIACHECKED, isChecked);
	                this._trigger(CHECK, node);
	            }

	            if (checkbox.is(":focus")) {
	                that._trigger(NAVIGATE, node);
	                that.focus();
	            }
	        },

	        _toggleButtonClick: function (e) {
	            var node = $(e.currentTarget).closest(NODE);

	            if (node.is("[aria-disabled='true']")) {
	                return;
	            }

	            this.toggle(node);
	        },

	        _mousedown: function(e) {
	            var that = this;
	            var currentTarget = $(e.currentTarget);
	            var node = $(e.currentTarget).closest(NODE);
	            var browser = kendo.support.browser;

	            if (node.is("[aria-disabled='true']")) {
	                return;
	            }

	            //IE does not trigger change for indeterminate checkboxes
	            if ((browser.msie || browser.edge) && currentTarget.is(":checkbox")) {
	                if (currentTarget.prop(INDETERMINATE)) {
	                    that._preventChange = false;

	                    currentTarget.prop(CHECKED, !currentTarget.prop(CHECKED));
	                    currentTarget.trigger(CHANGE);

	                    currentTarget.on(CLICK + NS, function (e) {
	                        e.preventDefault();
	                    });

	                    that._preventChange = true;
	                } else {
	                    currentTarget.off(CLICK + NS);
	                    that._preventChange = false;
	                }
	            }

	            that._clickTarget = node;
	            that.current(node);
	        },

	        _focusable: function (node) {
	            return node && node.length && node.is(":visible") && !node.find(".k-in:first").hasClass(DISABLED);
	        },

	        _focus: function() {
	            var current = this.select(),
	                clickTarget = this._clickTarget;

	            // suppress initial focus state on touch devices (until keyboard is used)
	            if (kendo.support.touch) {
	                return;
	            }

	            if (clickTarget && clickTarget.length) {
	                current = clickTarget;
	            }

	            if (!this._focusable(current)) {
	                current = this.current();
	            }

	            if (!this._focusable(current)) {
	                current = this._nextVisible($());
	            }

	            this.current(current);
	        },

	        focus: function() {
	            var wrapper = this.wrapper,
	                scrollContainer = wrapper[0],
	                containers = [],
	                offsets = [],
	                documentElement = document.documentElement,
	                i;

	            do {
	                scrollContainer = scrollContainer.parentNode;

	                if (scrollContainer.scrollHeight > scrollContainer.clientHeight) {
	                    containers.push(scrollContainer);
	                    offsets.push(scrollContainer.scrollTop);
	                }
	            } while (scrollContainer != documentElement);

	            kendo.focusElement(wrapper);

	            for (i = 0; i < containers.length; i++) {
	                containers[i].scrollTop = offsets[i];
	            }
	        },

	        _blur: function() {
	            this.current().find(".k-in:first").removeClass("k-state-focused");
	        },

	        _enabled: function(node) {
	            return !node.children("div").children(".k-in").hasClass(DISABLED);
	        },

	        parent: function(node) {
	            var wrapperRe = /\bk-treeview\b/,
	                itemRe = /\bk-item\b/,
	                result,
	                skipSelf;

	            if (typeof node == STRING) {
	                node = this.element.find(node);
	            }

	            if (!isDomElement(node)) {
	                node = node[0];
	            }

	            skipSelf = itemRe.test(node.className);

	            do {
	                node = node.parentNode;

	                if (itemRe.test(node.className)) {
	                    if (skipSelf) {
	                        result = node;
	                    } else {
	                        skipSelf = true;
	                    }
	                }
	            } while (!wrapperRe.test(node.className) && !result);

	            return $(result);
	        },

	        _nextVisible: function(node) {
	            var that = this,
	                expanded = that._expanded(node),
	                result;

	            function nextParent(node) {
	                while (node.length && !node.next().length) {
	                    node = that.parent(node);
	                }

	                if (node.next().length) {
	                    return node.next();
	                } else {
	                    return node;
	                }
	            }

	            if (!node.length || !node.is(":visible")) {
	                result = that.root.children().eq(0);
	            } else if (expanded) {
	                result = subGroup(node).children().first();

	                // expanded node with no children
	                if (!result.length) {
	                    result = nextParent(node);
	                }
	            } else {
	                result = nextParent(node);
	            }

	            return result;
	        },

	        _previousVisible: function(node) {
	            var that = this,
	                lastChild,
	                result;

	            if (!node.length || node.prev().length) {
	                if (node.length) {
	                    result = node.prev();
	                } else {
	                    result = that.root.children().last();
	                }

	                while (that._expanded(result)) {
	                    lastChild = subGroup(result).children().last();

	                    if (!lastChild.length) {
	                        break;
	                    }

	                    result = lastChild;
	                }
	            } else {
	                result = that.parent(node) || node;
	            }

	            return result;
	        },

	        _keydown: function(e) {
	            var that = this,
	                key = e.keyCode,
	                target,
	                focused = that.current(),
	                expanded = that._expanded(focused),
	                checkbox = focused.find(".k-checkbox-wrapper:first :checkbox"),
	                rtl = kendo.support.isRtl(that.element);

	            if (e.target != e.currentTarget) {
	                return;
	            }

	            if ((!rtl && key == keys.RIGHT) || (rtl && key == keys.LEFT)) {
	                if (expanded) {
	                    target = that._nextVisible(focused);
	                } else if (!focused.find(".k-in:first").hasClass(DISABLED)) {
	                    that.expand(focused);
	                }
	            } else if ((!rtl && key == keys.LEFT) || (rtl && key == keys.RIGHT)) {
	                if (expanded && !focused.find(".k-in:first").hasClass(DISABLED)) {
	                    that.collapse(focused);
	                } else {
	                    target = that.parent(focused);

	                    if (!that._enabled(target)) {
	                        target = undefined;
	                    }
	                }
	            } else if (key == keys.DOWN) {
	                target = that._nextVisible(focused);
	            } else if (key == keys.UP) {
	                target = that._previousVisible(focused);
	            } else if (key == keys.HOME) {
	                target = that._nextVisible($());
	            } else if (key == keys.END) {
	                target = that._previousVisible($());
	            } else if (key == keys.ENTER && !focused.find(".k-in:first").hasClass(DISABLED)) {
	                if (!focused.find(".k-in:first").hasClass("k-state-selected")) {
	                    if (!that._trigger(SELECT, focused)) {
	                        that.select(focused);
	                    }
	                }
	            } else if (key == keys.SPACEBAR && checkbox.length) {
	                if(!focused.find(".k-in:first").hasClass(DISABLED)){
	                    checkbox.prop(CHECKED, !checkbox.prop(CHECKED))
	                        .data(INDETERMINATE, false)
	                        .prop(INDETERMINATE, false);

	                    that._checkboxChange({ target: checkbox });
	                }
	                target = focused;
	            }

	            if (target) {
	                e.preventDefault();

	                if (focused[0] != target[0]) {
	                    that._trigger(NAVIGATE, target);
	                    that.current(target);
	                }
	            }
	        },

	        _keypress: function (e) {
	            var that = this;
	            var delay = 300;
	            var focusedNode = that.current().get(0);
	            var matchToFocus;
	            var key = e.key;
	            var isPrintable = key.length === 1;

	            if (!isPrintable) {
	                return;
	            }

	            if (!that._match) {
	                that._match = "";
	            }

	            that._match += key;
	            clearTimeout(that._matchTimer);
	            that._matchTimer = setTimeout(function() {
	                that._match = "";
	            }, delay);

	            matchToFocus = focusedNode &&
	                            that._matchNextByText(
	                                Array.prototype.indexOf.call(that.element.find(".k-item"),
	                                focusedNode), that._match
	                            );

	            if (!matchToFocus.length) {
	                matchToFocus = that._matchNextByText(-1, that._match);
	            }

	            if (matchToFocus.get(0) && matchToFocus.get(0) !== focusedNode) {
	                that._trigger(NAVIGATE, matchToFocus);
	                that.current(matchToFocus);
	            }
	        },

	        _matchNextByText: function(startIndex, text) {
	            var element = this.element;
	            var textNodes = element.find(".k-in").filter(function(i, element) {
	                return (i > startIndex &&
	                        $(element).is(":visible") &&
	                        $(element).text().toLowerCase().indexOf(text) === 0);
	            });

	            return textNodes.eq(0).closest(NODE);
	        },

	        _click: function (e) {
	            var that = this,
	                node = $(e.currentTarget),
	                contents = nodeContents(node.closest(NODE)),
	                href = node.attr("href"),
	                shouldNavigate;

	            if (href) {
	                shouldNavigate = href == "#" || href.indexOf("#" + this.element.id + "-") >= 0;
	            } else {
	                shouldNavigate = contents.length && !contents.children().length;
	            }

	            if (shouldNavigate) {
	                e.preventDefault();
	            }

	            if (!node.hasClass(".k-state-selected") && !that._trigger(SELECT, node)) {
	                that.select(node);
	            }
	        },

	        _wrapper: function() {
	            var that = this,
	                element = that.element,
	                wrapper, root,
	                wrapperClasses = "k-widget k-treeview";

	            if (element.is("ul")) {
	                wrapper = element.wrap('<div />').parent();
	                root = element;
	            } else {
	                wrapper = element;
	                root = wrapper.children("ul").eq(0);
	            }

	            that.wrapper = wrapper.addClass(wrapperClasses);
	            that.root = root;
	        },

	        _getSelectedNode: function() {
	            return this.element.find(".k-state-selected").closest(NODE);
	        },

	        _group: function(item) {
	            var that = this,
	                firstLevel = item.hasClass(KTREEVIEW),
	                group = {
	                    firstLevel: firstLevel,
	                    expanded: firstLevel || that._expanded(item)
	                },
	                groupElement = item.children("ul");

	            groupElement
	                .addClass(that.templates.groupCssClass(group))
	                .css("display", group.expanded ? "" : "none");

	            if(!firstLevel) {
	                groupElement.attr("role", "group");
	            }

	            that._nodes(groupElement, group);
	        },

	        _nodes: function(groupElement, groupData) {
	            var that = this,
	                nodes = groupElement.children("li"),
	                nodeData;

	            groupData = extend({ length: nodes.length }, groupData);

	            nodes.each(function(i, node) {
	                node = $(node);

	                nodeData = { index: i, expanded: that._expanded(node) };

	                updateNodeHtml(node);

	                that._updateNodeClasses(node, groupData, nodeData);

	                // iterate over child nodes
	                that._group(node);
	            });
	        },

	        _checkboxes: function() {
	            var options = this.options;
	            var checkboxes = options.checkboxes;
	            var defaultTemplate;

	            if (checkboxes) {
	                defaultTemplate = "<input type='checkbox' tabindex='-1' #= (item.enabled === false) ? 'disabled' : '' # #= item.checked ? 'checked' : '' #";


	                if (checkboxes.name) {
	                    defaultTemplate += " name='" + checkboxes.name + "'";
	                }

	                defaultTemplate += " id='_#= item.uid #' class='k-checkbox' /><span class='k-checkbox-label checkbox-span'></span>";

	                checkboxes = extend({
	                    template: defaultTemplate
	                }, options.checkboxes);

	                if (typeof checkboxes.template == STRING) {
	                    checkboxes.template = template(checkboxes.template);
	                }

	                options.checkboxes = checkboxes;
	            }
	        },

	        _updateNodeClasses: function (node, groupData, nodeData) {
	            var wrapper = node.children("div"),
	                group = node.children("ul"),
	                templates = this.templates;

	            if (node.hasClass("k-treeview")) {
	                return;
	            }

	            nodeData = nodeData || {};
	            nodeData.expanded = typeof nodeData.expanded != UNDEFINED ? nodeData.expanded : this._expanded(node);
	            nodeData.index = typeof nodeData.index != UNDEFINED ? nodeData.index : node.index();
	            nodeData.enabled = typeof nodeData.enabled != UNDEFINED ? nodeData.enabled : !wrapper.children(".k-in").hasClass("k-state-disabled");

	            groupData = groupData || {};
	            groupData.firstLevel = typeof groupData.firstLevel != UNDEFINED ? groupData.firstLevel : node.parent().parent().hasClass(KTREEVIEW);
	            groupData.length = typeof groupData.length != UNDEFINED ? groupData.length : node.parent().children().length;

	            // li
	            node.removeClass("k-first k-last")
	                .addClass(templates.wrapperCssClass(groupData, nodeData));

	            // div
	            wrapper.removeClass("k-top k-mid k-bot")
	                   .addClass(templates.cssClass(groupData, nodeData));

	            // span / a
	            var textWrap = wrapper.children(".k-in");
	            var isLink = textWrap[0] && textWrap[0].nodeName.toLowerCase() == "a";
	            textWrap.removeClass("k-in k-link k-state-default k-state-disabled")
	                .addClass(templates.textClass(nodeData, isLink));

	            // toggle button
	            if (group.length || node.attr("data-hasChildren") == "true") {
	                wrapper.children(".k-icon").removeClass("k-i-expand k-i-collapse")
	                    .addClass(templates.toggleButtonClass(nodeData));

	                group.addClass("k-group");
	            }
	        },


	        _processNodes: function(nodes, callback) {
	            var that = this;
	            var items = that.element.find(nodes);
	            for (var i = 0; i < items.length; i++) {
	                callback.call(that, i, $(items[i]).closest(NODE));
	            }
	        },

	        dataItem: function(node) {
	            var uid = $(node).closest(NODE).attr(kendo.attr("uid")),
	                dataSource = this.dataSource;

	            return dataSource && dataSource.getByUid(uid);
	        },

	        _dataItem: function(node) {
	            var uid = $(node).closest(NODE).attr(kendo.attr("uid")),
	                dataSource = this.dataSource;

	            return dataSource && this._dataSourceUids[uid];
	        },

	        _insertNode: function(nodeData, index, parentNode, insertCallback, collapsed) {
	            var that = this,
	                group = subGroup(parentNode),
	                updatedGroupLength = group.children().length + 1,
	                childrenData,
	                groupData = {
	                    firstLevel: parentNode.hasClass(KTREEVIEW),
	                    expanded: !collapsed,
	                    length: updatedGroupLength
	                }, node, i, item, nodeHtml = "", firstChild, lastChild,
	                append = function(item, group) {
	                    item.appendTo(group);
	                };

	            for (i = 0; i < nodeData.length; i++) {
	                item = nodeData[i];

	                item.index = index + i;

	                nodeHtml += that._renderItem({
	                    group: groupData,
	                    item: item
	                });
	            }

	            node = $(nodeHtml);

	            if (!node.length) {
	                return;
	            }

	            that.angular("compile", function(){
	                return {
	                    elements: node.get(),
	                    data: nodeData.map(function(item){
	                        return { dataItem: item };
	                    })
	                };
	            });

	            if (!group.length) {
	                group = $(that._renderGroup({
	                    group: groupData
	                })).appendTo(parentNode);
	            }

	            insertCallback(node, group);

	            if (parentNode.hasClass("k-item")) {
	                updateNodeHtml(parentNode);
	                that._updateNodeClasses(parentNode, groupData, {expanded: !collapsed});
	            }

	            firstChild = node.prev().first();
	            lastChild = node.next().last();

	            that._updateNodeClasses(firstChild, {}, {expanded: firstChild.attr(kendo.attr("expanded")) == "true"});
	            that._updateNodeClasses(lastChild, {}, {expanded: lastChild.attr(kendo.attr("expanded")) == "true"});

	            // render sub-nodes
	            for (i = 0; i < nodeData.length; i++) {
	                item = nodeData[i];

	                if (item.hasChildren) {
	                    childrenData = item.children.data();

	                    if (childrenData.length) {
	                        that._insertNode(childrenData, item.index, node.eq(i), append, !item.expanded);
	                    }
	                }
	            }

	            return node;
	        },

	        _updateNodes: function(items, field) {
	            var that = this;
	            var i, node, nodeWrapper, item, isChecked, isCollapsed;
	            var context = { treeview: that.options, item: item };
	            var render = field != "expanded" && field != "checked";

	            function setCheckedState(root, state) {
	                if (root.is(".k-group")) {
	                    root.find(".k-item:not([aria-disabled])").attr(ARIACHECKED, state);
	                }

	                root.find(".k-checkbox-wrapper input[type=checkbox]:not([disabled])")
	                    .prop(CHECKED, state)
	                    .data(INDETERMINATE, false)
	                    .prop(INDETERMINATE, false);
	            }

	            if (field == "selected") {
	                item = items[0];

	                node = that.findByUid(item.uid).find(".k-in:first")
	                        .removeClass("k-state-hover")
	                        .toggleClass("k-state-selected", item[field])
	                        .end();

	                if (item[field]) {
	                    that.current(node);
	                }

	                node.attr(ARIASELECTED, !!item[field]);
	            } else {
	                var elements = $.map(items, function(item) {
	                    return that.findByUid(item.uid).children("div");
	                });

	                if (render) {
	                    that.angular("cleanup", function() { return { elements: elements }; });
	                }

	                for (i = 0; i < items.length; i++) {
	                    context.item = item = items[i];
	                    nodeWrapper = elements[i];
	                    node = nodeWrapper.parent();

	                    if (render) {
	                        nodeWrapper.children(".k-in")
	                            .html(that.templates.itemContent(context));
	                    }

	                    if (field == CHECKED) {
	                        isChecked = item[field];

	                        setCheckedState(nodeWrapper, isChecked);

	                        node.attr(ARIACHECKED, isChecked);

	                        if (that.options.checkboxes.checkChildren) {
	                            setCheckedState(node.children(".k-group"), isChecked);

	                            that._setChecked(item.children, isChecked);

	                            that._bubbleIndeterminate(node);
	                        }
	                    } else if (field == "expanded") {
	                        that._toggle(node, item, item[field]);
	                    } else if (field == "enabled") {
	                        node.find(".k-checkbox-wrapper input[type=checkbox]").prop("disabled", !item[field]);

	                        isCollapsed = !nodeContents(node).is(VISIBLE);

	                        node.removeAttr(ARIADISABLED);

	                        if (!item[field]) {
	                            if (item.selected) {
	                                item.set("selected", false);
	                            }

	                            if (item.expanded) {
	                                item.set("expanded", false);
	                            }

	                            isCollapsed = true;
	                            node.attr(ARIASELECTED, false)
	                                .attr(ARIADISABLED, true);
	                        }

	                        that._updateNodeClasses(node, {}, { enabled: item[field], expanded: !isCollapsed });
	                    }

	                    if (nodeWrapper.length) {
	                        if (item._events && item._events.change) {
	                            item._events.change.splice(1);
	                        }
	                        this.trigger("itemChange", { item: nodeWrapper, data: item, ns: ui });
	                    }
	                }

	                if (render) {
	                    that.angular("compile", function(){
	                        return {
	                            elements: elements,
	                            data: $.map(items, function(item) {
	                                return [{ dataItem: item }];
	                            })
	                        };
	                    });
	                }
	            }
	        },

	        _appendItems: function(index, items, parentNode) {
	            var group = subGroup(parentNode);
	            var children = group.children();
	            var collapsed = !this._expanded(parentNode);

	            if(this.element === parentNode){
	                var dataItems = this.dataSource.data();
	                var viewItems = this.dataSource.view();
	                var rootItems = viewItems.length < dataItems.length ? viewItems : dataItems;
	                index = rootItems.indexOf(items[0]);
	            } else if (items.length){
	                index = items[0].parent().indexOf(items[0]);
	            }

	            if (typeof index == UNDEFINED) {
	                index = children.length;
	            }

	            this._insertNode(items, index, parentNode, function(item, group) {
	                // insert node into DOM
	                if (index >= children.length) {
	                    item.appendTo(group);
	                } else {
	                    item.insertBefore(children.eq(index));
	                }
	            }, collapsed);

	            if (!collapsed) {
	                this._updateNodeClasses(parentNode, {}, {expanded: !collapsed});
	                subGroup(parentNode).css("display", "block");
	            }
	        },

	        _refreshChildren: function(parentNode, items, index) {
	            var i, children, child;
	            var options = this.options;
	            var loadOnDemand = options.loadOnDemand;
	            var checkChildren = options.checkboxes && options.checkboxes.checkChildren;

	            subGroup(parentNode).empty();

	            if (!items.length) {
	                updateNodeHtml(parentNode);
	            } else {
	                this._appendItems(index, items, parentNode);

	                children = subGroup(parentNode).children();

	                if (loadOnDemand && checkChildren) {
	                    this._bubbleIndeterminate(children.last());
	                }

	                for (i = 0; i < children.length; i++) {
	                    child = children.eq(i);
	                    this.trigger("itemChange", {
	                        item: child.children("div"),
	                        data: items[i],
	                        ns: ui
	                    });
	                }
	            }
	        },

	        _refreshRoot: function(items) {
	            var groupHtml = this._renderGroup({
	                    items: items,
	                    group: {
	                        firstLevel: true,
	                        expanded: true
	                    }
	                });

	            if (this.root.length && this.root[0].parentElement) {
	                this._angularItems("cleanup");

	                var group = $(groupHtml);

	                this.root
	                    .attr("class", group.attr("class"))
	                    .html(group.html());
	            } else {
	                this.root = this.wrapper.html(groupHtml).children("ul");
	            }

	            var elements = this.root.children(".k-item");
	            for (var i = 0; i < items.length; i++) {
	                this.trigger("itemChange", {
	                    item: elements.eq(i),
	                    data: items[i],
	                    ns: ui
	                });
	            }
	            this._angularItems("compile");
	        },

	        refresh: function(e) {
	            var node = e.node;
	            var action = e.action;
	            var items = e.items;
	            var parentNode = this.wrapper;
	            var options = this.options;
	            var loadOnDemand = options.loadOnDemand;
	            var checkChildren = options.checkboxes && options.checkboxes.checkChildren;
	            var i;

	            if (this._skip) {
	                return;
	            }

	            for (i = 0; i < items.length; i++) {
	                this._dataSourceUids[items[i].uid] = items[i];
	            }

	            if (e.field) {
	                if (!items[0] || !items[0].level) {
	                    return;
	                }

	                return this._updateNodes(items, e.field);
	            }

	            if (node) {
	                parentNode = this.findByUid(node.uid);
	                this._progress(parentNode, false);
	            }

	            if (checkChildren && action != "remove") {
	                var bubble = false;

	                for (i = 0; i < items.length; i++) {
	                    if ("checked" in items[i]) {
	                        bubble = true;
	                        break;
	                    }
	                }

	                if (!bubble && node && node.checked) {
	                    for (i = 0; i < items.length; i++) {
	                        items[i].checked = true;
	                    }
	                }
	            }

	            if (action == "add") {
	                this._appendItems(e.index, items, parentNode);
	            } else if (action == "remove") {
	                this._remove(this.findByUid(items[0].uid), false);
	            } else if (action == "itemchange") {
	                this._updateNodes(items);
	            } else if (action == "itemloaded") {
	                this._refreshChildren(parentNode, items, e.index);
	            } else {
	                this._refreshRoot(items);
	            }

	            if (action != "remove") {
	                for (i = 0; i < items.length; i++) {
	                    if (!loadOnDemand || items[i].expanded || items[i]._loaded) {
	                        items[i].load();
	                    }
	                }
	            }

	            this.trigger(DATABOUND, { node: node ? parentNode : undefined });
	            if (this.dataSource.filter() && this.options.checkboxes.checkChildren) {
	                this.updateIndeterminate(parentNode);
	            }
	        },

	        _error: function(e) {
	            var node = e.node && this.findByUid(e.node.uid);
	            var retryHtml = this.templates.retry({ messages: this.options.messages });

	            if (node) {
	                this._progress(node, false);
	                this._expanded(node, false);
	                nodeIcon(node).addClass("k-i-reload");
	                e.node.loaded(false);
	            } else {
	                this._progress(false);
	                this.dataSource.data([]);
	                this.element.html(retryHtml);
	            }
	        },

	        _retryRequest: function(e) {
	            e.preventDefault();

	            this.dataSource.fetch();
	        },

	        expand: function (nodes) {
	            this._processNodes(nodes, function (index, item) {
	                this.toggle(item, true);
	            });
	        },

	        collapse: function (nodes) {
	            this._processNodes(nodes, function (index, item) {
	                this.toggle(item, false);
	            });
	        },

	        enable: function (nodes, enable) {
	            if (typeof nodes === "boolean") {
	                enable = nodes;
	                nodes = this.items();
	            } else {
	                enable = arguments.length == 2 ? !!enable : true;
	            }

	            this._processNodes(nodes, function (index, item) {
	                this.dataItem(item).set("enabled", enable);
	            });
	        },

	        current: function(node) {
	            var that = this,
	                current = that._current,
	                element = that.element,
	                id = that._ariaId;

	            if (arguments.length > 0 && node && node.length) {
	                if (current) {
	                    if (current[0].id === id) {
	                        current.removeAttr("id");
	                    }

	                    current.find(".k-in:first").removeClass("k-state-focused");
	                }

	                current = that._current = $(node, element).closest(NODE);

	                current.find(".k-in:first").addClass("k-state-focused");

	                id = current[0].id || id;

	                if (id) {
	                    that.wrapper.removeAttr("aria-activedescendant");
	                    current.attr("id", id);
	                    that.wrapper.attr("aria-activedescendant", id);
	                }

	                return;
	            }

	            if (!current) {
	                current = that._nextVisible($());
	            }

	            return current;
	        },

	        select: function (node) {
	            var that = this,
	                element = that.element;

	            if (!arguments.length) {
	                return element.find(".k-state-selected").closest(NODE);
	            }

	            node = $(node, element).closest(NODE);

	            element.find(".k-state-selected").each(function() {
	                var dataItem = that.dataItem(this);
	                if (dataItem) {
	                    dataItem.set("selected", false);
	                    delete dataItem.selected;
	                } else {
	                    $(this).removeClass("k-state-selected");
	                }
	            });

	            if (node.length) {
	                that.dataItem(node).set("selected", true);
	                that._clickTarget = node;
	            }

	            that.trigger(CHANGE);
	        },

	        _toggle: function(node, dataItem, expand) {
	            var options = this.options;
	            var contents = nodeContents(node);
	            var direction = expand ? "expand" : "collapse";
	            var loaded;

	            if (contents.data("animating")) {
	                return;
	            }

	            loaded = dataItem && dataItem.loaded();

	            if (expand && !loaded) {
	                if (options.loadOnDemand) {
	                    this._progress(node, true);
	                }

	                contents.remove();
	                dataItem.load();
	            } else {
	                this._updateNodeClasses(node, {}, { expanded: expand });

	                if (!expand) {
	                    contents.css("height", contents.height()).css("height");
	                }

	                contents
	                    .kendoStop(true, true)
	                    .kendoAnimate(extend(
	                        { reset: true },
	                        options.animation[direction],
	                        { complete: function() {
	                            if (expand) {
	                                contents.css("height", "");
	                            }
	                        } }
	                    ));
	            }

	        },

	        toggle: function (node, expand) {
	            node = $(node);

	            if (!nodeIcon(node).is(".k-i-expand, .k-i-collapse")) {
	                return;
	            }

	            if (arguments.length == 1) {
	                expand = !this._expanded(node);
	            }

	            this._expanded(node, expand);
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            that.wrapper.off(NS);
	            that.wrapper.find(".k-checkbox-wrapper :checkbox").off(NS);

	            that._unbindDataSource();

	            if (that.dragging) {
	                that.dragging.destroy();
	            }

	            that._dataSourceUids = {};

	            kendo.destroy(that.element);

	            that.root = that.wrapper = that.element = null;
	        },

	        _expanded: function(node, value, force) {
	            var expandedAttr = kendo.attr("expanded");
	            var dataItem;
	            var expanded = value;
	            var direction = expanded ? "expand" : "collapse";

	            if (arguments.length == 1) {
	                dataItem = this._dataItem(node);
	                return node.attr(expandedAttr) === "true" || (dataItem && dataItem.expanded);
	            }

	            dataItem = this.dataItem(node);

	            if (nodeContents(node).data("animating")) {
	                return;
	            }

	            if (force || !this._trigger(direction, node)) {
	                if (expanded) {
	                    node.attr(expandedAttr, "true");
	                    node.attr(ARIAEXPANDED, "true");
	                } else {
	                    node.removeAttr(expandedAttr);
	                    node.attr(ARIAEXPANDED, "false");
	                }

	                if (dataItem) {
	                    dataItem.set("expanded", expanded);
	                    // necessary when expanding an item yields an error and the item is not expanded as a result
	                    expanded = dataItem.expanded;
	                }
	            }
	        },

	        _progress: function(node, showProgress) {
	            var element = this.element;
	            var loadingText = this.templates.loading({ messages: this.options.messages });

	            if (arguments.length == 1) {
	                showProgress = node;

	                if (showProgress) {
	                    element.html(loadingText);
	                } else {
	                    element.empty();
	                }
	            } else {
	                nodeIcon(node).toggleClass("k-i-loading", showProgress).removeClass("k-i-reload");
	            }
	        },

	        text: function (node, text) {
	            var dataItem = this.dataItem(node),
	                fieldBindings = this.options[bindings.text],
	                level = dataItem.level(),
	                length = fieldBindings.length,
	                field = fieldBindings[Math.min(level, length-1)];

	            if (text) {
	                dataItem.set(field, text);
	            } else {
	                return dataItem[field];
	            }
	        },

	        _objectOrSelf: function (node) {
	            return $(node).closest("[data-role=treeview]").data("kendoTreeView") || this;
	        },

	        _dataSourceMove: function(nodeData, group, parentNode, callback) {
	            var referenceDataItem,
	                destTreeview = this._objectOrSelf(parentNode || group),
	                destDataSource = destTreeview.dataSource;
	            var loadPromise = $.Deferred().resolve().promise();

	            if (parentNode && parentNode[0] != destTreeview.element[0]) {
	                referenceDataItem = destTreeview.dataItem(parentNode);

	                if (!referenceDataItem.loaded()) {
	                    destTreeview._progress(parentNode, true);
	                    loadPromise = referenceDataItem.load();
	                }

	                if (parentNode != this.root) {
	                    destDataSource = referenceDataItem.children;

	                    if (!destDataSource || !(destDataSource instanceof HierarchicalDataSource)) {
	                        referenceDataItem._initChildren();
	                        referenceDataItem.loaded(true);
	                        destDataSource = referenceDataItem.children;
	                    }
	                }
	            }

	            nodeData = this._toObservableData(nodeData);

	            return callback.call(destTreeview, destDataSource, nodeData, loadPromise);
	        },

	        _toObservableData: function(node) {
	            var dataItem = node, dataSource, uid;

	            if (isJQueryInstance(node) || isDomElement(node)) {
	                dataSource = this._objectOrSelf(node).dataSource;
	                uid = $(node).attr(kendo.attr("uid"));
	                dataItem = dataSource.getByUid(uid);

	                if (dataItem) {
	                    dataItem = dataSource.remove(dataItem);
	                }
	            }

	            return dataItem;
	        },

	        _insert: function(data, model, index) {
	            if (!(model instanceof kendo.data.ObservableArray)) {
	                if (!isArray(model)) {
	                    model = [model];
	                }
	            } else {
	                // items will be converted to new Node instances
	                model = model.toJSON();
	            }

	            var parentNode = data.parent();

	            if (parentNode && parentNode._initChildren) {
	                parentNode.hasChildren = true;
	                parentNode._initChildren();
	            }

	            data.splice.apply(data, [ index, 0 ].concat(model));

	            return this.findByUid(data[index].uid);
	        },

	        insertAfter: insertAction(1),

	        insertBefore: insertAction(0),

	        append: function (nodeData, parentNode, success) {
	            var group = this.root;

	            if(parentNode && nodeData instanceof jQuery && parentNode[0] === nodeData[0]){
	                return;
	            }

	            parentNode = parentNode && parentNode.length ? parentNode : null;

	            if (parentNode) {
	                group = subGroup(parentNode);
	            }

	            return this._dataSourceMove(nodeData, group, parentNode, function (dataSource, model, loadModel) {
	                var inserted;
	                var that = this;

	                function add() {
	                    if (parentNode) {
	                        that._expanded(parentNode, true, true);
	                    }

	                    var data = dataSource.data(),
	                        index = Math.max(data.length, 0);

	                    return that._insert(data, model, index);
	                }

	                loadModel.done(function() {
	                    inserted = add();
	                    success = success || $.noop;
	                    success(inserted);
	                });

	                return inserted || null;
	            });
	        },

	        _remove: function (node, keepData) {
	            var that = this,
	                parentNode,
	                prevSibling, nextSibling;

	            node = $(node, that.element);

	            this.angular("cleanup", function(){
	                return { elements: node.get() };
	            });

	            parentNode = node.parent().parent();
	            prevSibling = node.prev();
	            nextSibling = node.next();

	            node[keepData ? "detach" : "remove"]();

	            if (parentNode.hasClass("k-item")) {
	                updateNodeHtml(parentNode);
	                that._updateNodeClasses(parentNode);
	            }

	            that._updateNodeClasses(prevSibling);
	            that._updateNodeClasses(nextSibling);

	            return node;
	        },

	        remove: function (node) {
	            var dataItem = this.dataItem(node);
	            if (dataItem) {
	                this.dataSource.remove(dataItem);
	            }
	        },

	        detach: function (node) {
	            return this._remove(node, true);
	        },

	        findByText: function(text) {
	            return $(this.element).find(".k-in").filter(function(i, element) {
	                return $(element).text() == text;
	            }).closest(NODE);
	        },

	        findByUid: function(uid) {
	            var items = this.element.find(".k-item");
	            var uidAttr = kendo.attr("uid");
	            var result;

	            for (var i = 0; i < items.length; i++) {
	                if (items[i].getAttribute(uidAttr) == uid) {
	                    result = items[i];
	                    break;
	                }
	            }

	            return $(result);
	        },

	        expandPath: function(path, complete) {
	            var treeview = this;
	            var nodeIds = path.slice(0);
	            var callback = complete || $.noop;

	            function proceed() {
	                nodeIds.shift();

	                if (nodeIds.length) {
	                    expand(nodeIds[0]).then(proceed);
	                } else {
	                    callback.call(treeview);
	                }
	            }

	            function expand(id) {
	                var result = $.Deferred();
	                var node = treeview.dataSource.get(id);
	                var expandedAttr = kendo.attr("expanded");
	                var nodeElement;

	                if (node) {
	                    nodeElement = treeview.findByUid(node.uid);

	                    if (node.loaded()) {
	                        node.set("expanded", true);
	                        nodeElement.attr(expandedAttr, true);
	                        nodeElement.attr(ARIAEXPANDED, true);
	                        result.resolve();
	                    } else {
	                        // manually show progress of the node
	                        // should be moved to `refresh`
	                        // if the datasource starts triggering a `requestStart` event for nodes
	                        treeview._progress(nodeElement, true);

	                        node.load().then(function() {
	                            node.set("expanded", true);
	                            nodeElement.attr(expandedAttr, true);
	                            nodeElement.attr(ARIAEXPANDED, true);
	                            result.resolve();
	                        });
	                    }
	                } else {
	                    result.resolve();
	                }

	                return result.promise();
	            }

	            // expand async nodes
	            expand(nodeIds[0]).then(proceed);
	        },

	        _parentIds: function(node) {
	            var parent = node && node.parentNode();
	            var parents = [];
	            while (parent && parent.parentNode) {
	                parents.unshift(parent.id);
	                parent = parent.parentNode();
	            }

	            return parents;
	        },

	        expandTo: function(node) {
	            if (!(node instanceof kendo.data.Node)) {
	                node = this.dataSource.get(node);
	            }

	            var parents = this._parentIds(node);

	            this.expandPath(parents);
	        },

	        _renderItem: function (options) {
	            if (!options.group) {
	                options.group = {};
	            }

	            options.treeview = this.options;

	            options.r = this.templates;

	            return this.templates.item(options);
	        },

	        _renderGroup: function (options) {
	            var that = this;

	            options.renderItems = function(options) {
	                    var html = "",
	                        i = 0,
	                        items = options.items,
	                        len = items ? items.length : 0,
	                        group = options.group;

	                    group.length = len;

	                    for (; i < len; i++) {
	                        options.group = group;
	                        options.item = items[i];
	                        options.item.index = i;
	                        html += that._renderItem(options);
	                    }

	                    return html;
	                };

	            options.r = that.templates;

	            return that.templates.group(options);
	        }
	    });

	    ui.plugin(TreeView);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1048)))

/***/ })

/******/ });

/***/ }),

/***/ "ef9w":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1365);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "router",
	    name: "Router",
	    category: "framework",
	    description: "The Router class is responsible for tracking the application state and navigating between the application states.",
	    depends: [ "core" ],
	    hidden: false
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        CHANGE = "change",
	        BACK = "back",
	        SAME = "same",
	        support = kendo.support,
	        location = window.location,
	        history = window.history,
	        CHECK_URL_INTERVAL = 50,
	        BROKEN_BACK_NAV = kendo.support.browser.msie,
	        hashStrip = /^#*/,
	        document = window.document;

	    function absoluteURL(path, pathPrefix) {
	        if (!pathPrefix) {
	            return path;
	        }

	        if (path + "/" === pathPrefix) {
	            path = pathPrefix;
	        }

	        var regEx = new RegExp("^" + pathPrefix, "i");

	        if (!regEx.test(path)) {
	            path = pathPrefix + "/" + path;
	        }

	        return location.protocol + '//' + (location.host + "/" + path).replace(/\/\/+/g, '/');
	    }

	    function hashDelimiter(bang) {
	        return bang ? "#!" : "#";
	    }

	    function locationHash(hashDelimiter) {
	        var href = location.href;

	        // ignore normal anchors if in hashbang mode - however, still return "" if no hash present
	        if (hashDelimiter === "#!" && href.indexOf("#") > -1 && href.indexOf("#!") < 0) {
	            return null;
	        }

	        return href.split(hashDelimiter)[1] || "";
	    }

	    function stripRoot(root, url) {
	        if (url.indexOf(root) === 0) {
	            return (url.substr(root.length)).replace(/\/\//g, '/');
	        } else {
	            return url;
	        }
	    }

	    var HistoryAdapter = kendo.Class.extend({
	        back: function() {
	            if (BROKEN_BACK_NAV) {
	                setTimeout(function() { history.back(); });
	            } else {
	                history.back();
	            }
	        },

	        forward: function() {
	            if (BROKEN_BACK_NAV) {
	                setTimeout(function() { history.forward(); });
	            } else {
	                history.forward();
	            }
	        },

	        length: function() {
	            return history.length;
	        },

	        replaceLocation: function(url) {
	            location.replace(url);
	        }
	    });

	    var PushStateAdapter = HistoryAdapter.extend({
	        init: function(root) {
	            this.root = root;
	        },

	        navigate: function(to) {
	            history.pushState({}, document.title, absoluteURL(to, this.root));
	        },

	        replace: function(to) {
	            history.replaceState({}, document.title, absoluteURL(to, this.root));
	        },

	        normalize: function(url) {
	            return stripRoot(this.root, url);
	        },

	        current: function() {
	            var current = location.pathname;

	            if (location.search) {
	                current += location.search;
	            }

	            return stripRoot(this.root, current);
	        },

	        change: function(callback) {
	            $(window).bind("popstate.kendo", callback);
	        },

	        stop: function() {
	            $(window).unbind("popstate.kendo");
	        },

	        normalizeCurrent: function(options) {
	            var fixedUrl,
	                root = options.root,
	                pathname = location.pathname,
	                hash = locationHash(hashDelimiter(options.hashBang));

	            if (root === pathname + "/") {
	                fixedUrl = root;
	            }

	            if (root === pathname && hash) {
	                fixedUrl = absoluteURL(hash.replace(hashStrip, ''), root);
	            }

	            if (fixedUrl) {
	                history.pushState({}, document.title, fixedUrl);
	            }
	        }
	    });

	    function fixHash(url) {
	        return url.replace(/^(#)?/, "#");
	    }

	    function fixBang(url) {
	        return url.replace(/^(#(!)?)?/, "#!");
	    }

	    var HashAdapter = HistoryAdapter.extend({
	        init: function(bang) {
	            this._id = kendo.guid();
	            this.prefix = hashDelimiter(bang);
	            this.fix = bang ? fixBang : fixHash;
	        },

	        navigate: function(to) {
	            location.hash = this.fix(to);
	        },

	        replace: function(to) {
	            this.replaceLocation(this.fix(to));
	        },

	        normalize: function(url) {
	            if (url.indexOf(this.prefix) < 0) {
	               return url;
	            } else {
	                return url.split(this.prefix)[1];
	            }
	        },

	        change: function(callback) {
	            if (support.hashChange) {
	                $(window).on("hashchange." + this._id, callback);
	            } else {
	                this._interval = setInterval(callback, CHECK_URL_INTERVAL);
	            }
	        },

	        stop: function() {
	            $(window).off("hashchange." + this._id);
	            clearInterval(this._interval);
	        },

	        current: function() {
	            return locationHash(this.prefix);
	        },

	        normalizeCurrent: function(options) {
	            var pathname = location.pathname,
	                root = options.root;

	            if (options.pushState && root !== pathname) {
	                this.replaceLocation(root + this.prefix + stripRoot(root, pathname));
	                return true; // browser will reload at this point.
	            }

	            return false;
	        }
	    });

	    var History = kendo.Observable.extend({
	        start: function(options) {
	            options = options || {};

	            this.bind([CHANGE, BACK, SAME], options);

	            if (this._started) {
	                return;
	            }

	            this._started = true;

	            options.root = options.root || "/";

	            var adapter = this.createAdapter(options),
	                current;

	            // adapter may reload the document
	            if (adapter.normalizeCurrent(options)) {
	                return;
	            }

	            current = adapter.current();

	            $.extend(this, {
	                adapter: adapter,
	                root: options.root,
	                historyLength: adapter.length(),
	                current: current,
	                locations: [current]
	            });

	            adapter.change($.proxy(this, "_checkUrl"));
	        },

	        createAdapter:function(options) {
	           return support.pushState && options.pushState ? new PushStateAdapter(options.root) : new HashAdapter(options.hashBang);
	        },

	        stop: function() {
	            if (!this._started) {
	                return;
	            }
	            this.adapter.stop();
	            this.unbind(CHANGE);
	            this._started = false;
	        },

	        change: function(callback) {
	            this.bind(CHANGE, callback);
	        },

	        replace: function(to, silent) {

	            this._navigate(to, silent, function(adapter) {
	                adapter.replace(to);
	                this.locations[this.locations.length - 1] = this.current;
	            });
	        },

	        navigate: function(to, silent) {
	            if (to === "#:back") {
	                this.backCalled = true;
	                this.adapter.back();
	                return;
	            }

	            this._navigate(to, silent, function(adapter) {
	                adapter.navigate(to);
	                this.locations.push(this.current);
	            });
	        },

	        _navigate: function(to, silent, callback) {
	            var adapter = this.adapter;

	            to = adapter.normalize(to);

	            if (this.current === to || this.current === decodeURIComponent(to)) {
	                this.trigger(SAME);
	                return;
	            }

	            if (!silent) {
	                if (this.trigger(CHANGE, { url: to, decode: false })) {
	                    return;
	                }
	            }

	            this.current = to;

	            callback.call(this, adapter);

	            this.historyLength = adapter.length();
	        },

	        _checkUrl: function() {
	            var adapter = this.adapter,
	                current = adapter.current(),
	                newLength = adapter.length(),
	                navigatingInExisting = this.historyLength === newLength,
	                back = current === this.locations[this.locations.length - 2] && navigatingInExisting,
	                backCalled = this.backCalled,
	                prev = this.current;

	            if (current === null || this.current === current || this.current === decodeURIComponent(current)) {
	                return true;
	            }

	            this.historyLength = newLength;
	            this.backCalled = false;

	            this.current = current;

	            if (back && this.trigger("back", { url: prev, to: current })) {
	                adapter.forward();
	                this.current = prev;
	                return;
	            }

	            if (this.trigger(CHANGE, { url: current, backButtonPressed: !backCalled })) {
	                if (back) {
	                    adapter.forward();
	                } else {
	                    adapter.back();
	                    this.historyLength --;
	                }
	                this.current = prev;
	                return;
	            }

	            if (back) {
	                this.locations.pop();
	            } else {
	                this.locations.push(current);
	            }
	        }
	    });

	    kendo.History = History;
	    kendo.History.HistoryAdapter = HistoryAdapter;
	    kendo.History.HashAdapter = HashAdapter;
	    kendo.History.PushStateAdapter = PushStateAdapter;
	    kendo.absoluteURL = absoluteURL;
	    kendo.history = new History();
	})(window.kendo.jQuery);

	(function() {
	    var kendo = window.kendo,
	        history = kendo.history,
	        Observable = kendo.Observable,
	        INIT = "init",
	        ROUTE_MISSING = "routeMissing",
	        CHANGE = "change",
	        BACK = "back",
	        SAME = "same",
	        optionalParam = /\((.*?)\)/g,
	        namedParam = /(\(\?)?:\w+/g,
	        splatParam = /\*\w+/g,
	        escapeRegExp = /[\-{}\[\]+?.,\\\^$|#\s]/g;

	    function namedParamReplace(match, optional) {
	        return optional ? match : '([^\/]+)';
	    }

	    function routeToRegExp(route, ignoreCase) {
	        return new RegExp('^' + route
	            .replace(escapeRegExp, '\\$&')
	            .replace(optionalParam, '(?:$1)?')
	            .replace(namedParam, namedParamReplace)
	            .replace(splatParam, '(.*?)') + '$', ignoreCase ? "i" : "");
	    }

	    function stripUrl(url) {
	        return url.replace(/(\?.*)|(#.*)/g, "");
	    }

	    var Route = kendo.Class.extend({
	        init: function(route, callback, ignoreCase) {
	            if (!(route instanceof RegExp)) {
	                route = routeToRegExp(route, ignoreCase);
	            }

	            this.route = route;
	            this._callback = callback;
	        },

	        callback: function(url, back, decode) {
	            var params,
	                idx = 0,
	                length,
	                queryStringParams = kendo.parseQueryStringParams(url);
	                queryStringParams._back = back;

	            url = stripUrl(url);
	            params = this.route.exec(url).slice(1);
	            length = params.length;

	            if (decode) {
	                for (; idx < length; idx ++) {
	                    if (typeof params[idx] !== 'undefined') {
	                        params[idx] = decodeURIComponent(params[idx]);
	                    }
	                }
	            }

	            params.push(queryStringParams);

	            this._callback.apply(null, params);
	        },

	        worksWith: function(url, back, decode) {
	            if (this.route.test(stripUrl(url))) {
	                this.callback(url, back, decode);
	                return true;
	            } else {
	                return false;
	            }
	        }
	    });

	    var Router = Observable.extend({
	        init: function(options) {
	            if (!options) {
	                options = {};
	            }

	            Observable.fn.init.call(this);

	            this.routes = [];
	            this.pushState = options.pushState;
	            this.hashBang = options.hashBang;
	            this.root = options.root;
	            this.ignoreCase = options.ignoreCase !== false;

	            this.bind([INIT, ROUTE_MISSING, CHANGE, SAME, BACK], options);
	        },

	        destroy: function() {
	            history.unbind(CHANGE, this._urlChangedProxy);
	            history.unbind(SAME, this._sameProxy);
	            history.unbind(BACK, this._backProxy);
	            this.unbind();
	        },

	        start: function() {
	            var that = this,
	                sameProxy = function() { that._same(); },
	                backProxy = function(e) { that._back(e); },
	                urlChangedProxy = function(e) { that._urlChanged(e); };

	            history.start({
	                same: sameProxy,
	                change: urlChangedProxy,
	                back: backProxy,
	                pushState: that.pushState,
	                hashBang: that.hashBang,
	                root: that.root
	            });

	            var initEventObject = { url: history.current || "/", preventDefault: $.noop };

	            if (!that.trigger(INIT, initEventObject)) {
	                that._urlChanged(initEventObject);
	            }

	            this._urlChangedProxy = urlChangedProxy;
	            this._backProxy = backProxy;
	        },

	        route: function(route, callback) {
	            this.routes.push(new Route(route, callback, this.ignoreCase));
	        },

	        navigate: function(url, silent) {
	            kendo.history.navigate(url, silent);
	        },

	        replace: function(url, silent) {
	            kendo.history.replace(url, silent);
	        },

	        _back: function(e) {
	            if (this.trigger(BACK, { url: e.url, to: e.to })) {
	                e.preventDefault();
	            }
	        },

	        _same: function() {
	            this.trigger(SAME);
	        },

	        _urlChanged: function(e) {
	            var url = e.url;
	            var decode = !!e.decode;
	            var back = e.backButtonPressed;

	            if (!url) {
	                url = "/";
	            }

	            if (this.trigger(CHANGE, { url: e.url, params: kendo.parseQueryStringParams(e.url), backButtonPressed: back })) {
	                e.preventDefault();
	                return;
	            }

	            var idx = 0,
	                routes = this.routes,
	                route,
	                length = routes.length;

	            for (; idx < length; idx ++) {
	                 route = routes[idx];

	                 if (route.worksWith(url, back, decode)) {
	                    return;
	                 }
	            }

	            if (this.trigger(ROUTE_MISSING, { url: url, params: kendo.parseQueryStringParams(url), backButtonPressed: back })) {
	                e.preventDefault();
	            }
	        }
	    });

	    kendo.Router = Router;
	})();

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "evD5":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("77Pl");
var IE8_DOM_DEFINE = __webpack_require__("SfB7");
var toPrimitive = __webpack_require__("MmMw");
var dP = Object.defineProperty;

exports.f = __webpack_require__("+E39") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "evUn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var textCellEditor_1 = __webpack_require__("U6ln");
var context_1 = __webpack_require__("RQ1/");
var dateFilter_1 = __webpack_require__("TgGN");
var headerComp_1 = __webpack_require__("N4JJ");
var headerGroupComp_1 = __webpack_require__("aW50");
var floatingFilter_1 = __webpack_require__("MwUU");
var componentResolver_1 = __webpack_require__("migL");
var groupCellRenderer_1 = __webpack_require__("sYFB");
var animateShowChangeCellRenderer_1 = __webpack_require__("jeRM");
var animateSlideCellRenderer_1 = __webpack_require__("Vn5t");
var rowComp_1 = __webpack_require__("ci/Y");
var selectCellEditor_1 = __webpack_require__("POfv");
var popupTextCellEditor_1 = __webpack_require__("Nrvl");
var popupSelectCellEditor_1 = __webpack_require__("33E9");
var largeTextCellEditor_1 = __webpack_require__("USml");
var textFilter_1 = __webpack_require__("G5+n");
var numberFilter_1 = __webpack_require__("6cDV");
var loadingOverlayComponent_1 = __webpack_require__("q7rp");
var noRowsOverlayComponent_1 = __webpack_require__("P0KY");
var utils_1 = __webpack_require__("IRr6");
var RegisteredComponentSource;
(function (RegisteredComponentSource) {
    RegisteredComponentSource[RegisteredComponentSource["DEFAULT"] = 0] = "DEFAULT";
    RegisteredComponentSource[RegisteredComponentSource["REGISTERED"] = 1] = "REGISTERED";
})(RegisteredComponentSource = exports.RegisteredComponentSource || (exports.RegisteredComponentSource = {}));
var ComponentProvider = (function () {
    function ComponentProvider() {
        this.agGridDefaults = {
            //date
            agDateInput: dateFilter_1.DefaultDateComponent,
            //header
            agColumnHeader: headerComp_1.HeaderComp,
            agColumnGroupHeader: headerGroupComp_1.HeaderGroupComp,
            //floating filters
            agSetColumnFloatingFilter: floatingFilter_1.SetFloatingFilterComp,
            agTextColumnFloatingFilter: floatingFilter_1.TextFloatingFilterComp,
            agNumberColumnFloatingFilter: floatingFilter_1.NumberFloatingFilterComp,
            agDateColumnFloatingFilter: floatingFilter_1.DateFloatingFilterComp,
            // renderers
            agAnimateShowChangeCellRenderer: animateShowChangeCellRenderer_1.AnimateShowChangeCellRenderer,
            agAnimateSlideCellRenderer: animateSlideCellRenderer_1.AnimateSlideCellRenderer,
            agGroupCellRenderer: groupCellRenderer_1.GroupCellRenderer,
            agGroupRowRenderer: groupCellRenderer_1.GroupCellRenderer,
            agLoadingCellRenderer: rowComp_1.LoadingCellRenderer,
            //editors
            agCellEditor: textCellEditor_1.TextCellEditor,
            agTextCellEditor: textCellEditor_1.TextCellEditor,
            agSelectCellEditor: selectCellEditor_1.SelectCellEditor,
            agPopupTextCellEditor: popupTextCellEditor_1.PopupTextCellEditor,
            agPopupSelectCellEditor: popupSelectCellEditor_1.PopupSelectCellEditor,
            agLargeTextCellEditor: largeTextCellEditor_1.LargeTextCellEditor,
            //filter
            agTextColumnFilter: textFilter_1.TextFilter,
            agNumberColumnFilter: numberFilter_1.NumberFilter,
            agDateColumnFilter: dateFilter_1.DateFilter,
            //overlays
            agLoadingOverlay: loadingOverlayComponent_1.LoadingOverlayComponent,
            agNoRowsOverlay: noRowsOverlayComponent_1.NoRowsOverlayComponent
        };
        this.agDeprecatedNames = {
            set: {
                newComponentName: 'agSetColumnFilter',
                propertyHolder: 'filter'
            },
            text: {
                newComponentName: 'agTextColumnFilter',
                propertyHolder: 'filter'
            },
            number: {
                newComponentName: 'agNumberColumnFilter',
                propertyHolder: 'filter'
            },
            date: {
                newComponentName: 'agDateColumnFilter',
                propertyHolder: 'filter'
            },
            group: {
                newComponentName: 'agGroupCellRenderer',
                propertyHolder: 'cellRenderer'
            },
            animateShowChange: {
                newComponentName: 'agAnimateShowChangeCellRenderer',
                propertyHolder: 'cellRenderer'
            },
            animateSlide: {
                newComponentName: 'agAnimateSlideCellRenderer',
                propertyHolder: 'cellRenderer'
            },
            select: {
                newComponentName: 'agSelectCellEditor',
                propertyHolder: 'cellEditor'
            },
            largeText: {
                newComponentName: 'agLargeTextCellEditor',
                propertyHolder: 'cellEditor'
            },
            popupSelect: {
                newComponentName: 'agPopupSelectCellEditor',
                propertyHolder: 'cellEditor'
            },
            popupText: {
                newComponentName: 'agPopupTextCellEditor',
                propertyHolder: 'cellEditor'
            },
            richSelect: {
                newComponentName: 'agRichSelectCellEditor',
                propertyHolder: 'cellEditor'
            },
            headerComponent: {
                newComponentName: 'agColumnHeader',
                propertyHolder: 'headerComponent'
            }
        };
        this.jsComponents = {};
        this.frameworkComponents = {};
    }
    ComponentProvider.prototype.init = function () {
        var _this = this;
        var componentProvider = this.context.getBean('componentProvider');
        if (this.gridOptions.components != null) {
            Object.keys(this.gridOptions.components).forEach(function (it) {
                componentProvider.registerComponent(it, _this.gridOptions.components[it]);
            });
        }
        if (this.gridOptions.frameworkComponents != null) {
            Object.keys(this.gridOptions.frameworkComponents).forEach(function (it) {
                componentProvider.registerFwComponent(it, _this.gridOptions.frameworkComponents[it]);
            });
        }
    };
    ComponentProvider.prototype.registerDefaultComponent = function (rawName, component, overridable) {
        if (overridable === void 0) { overridable = true; }
        var name = this.translateIfDeprecated(rawName);
        if (this.agGridDefaults[name]) {
            console.error("Trying to overwrite a default component. You should call registerComponent");
            return;
        }
        this.agGridDefaults[name] = component;
    };
    ComponentProvider.prototype.registerComponent = function (rawName, component) {
        var name = this.translateIfDeprecated(rawName);
        if (this.frameworkComponents[name]) {
            console.error("Trying to register a component that you have already registered for frameworks: " + name);
            return;
        }
        this.jsComponents[name] = component;
    };
    /**
     * B the business interface (ie IHeader)
     * A the agGridComponent interface (ie IHeaderComp). The final object acceptable by ag-grid
     */
    ComponentProvider.prototype.registerFwComponent = function (rawName, component) {
        var name = this.translateIfDeprecated(rawName);
        if (this.jsComponents[name]) {
            console.error("Trying to register a component that you have already registered for plain javascript: " + name);
            return;
        }
        this.frameworkComponents[name] = component;
    };
    /**
     * B the business interface (ie IHeader)
     * A the agGridComponent interface (ie IHeaderComp). The final object acceptable by ag-grid
     */
    ComponentProvider.prototype.retrieve = function (rawName) {
        var name = this.translateIfDeprecated(rawName);
        if (this.frameworkComponents[name]) {
            return {
                type: componentResolver_1.ComponentType.FRAMEWORK,
                component: this.frameworkComponents[name],
                source: RegisteredComponentSource.REGISTERED
            };
        }
        if (this.jsComponents[name]) {
            return {
                type: componentResolver_1.ComponentType.AG_GRID,
                component: this.jsComponents[name],
                source: RegisteredComponentSource.REGISTERED
            };
        }
        if (this.agGridDefaults[name]) {
            return this.agGridDefaults[name] ?
                {
                    type: componentResolver_1.ComponentType.AG_GRID,
                    component: this.agGridDefaults[name],
                    source: RegisteredComponentSource.DEFAULT
                } :
                null;
        }
        if (Object.keys(this.agGridDefaults).indexOf(name) < 0) {
            console.warn("ag-grid: Looking for component [" + name + "] but it wasn't found.");
        }
        return null;
    };
    ComponentProvider.prototype.translateIfDeprecated = function (raw) {
        var deprecatedInfo = this.agDeprecatedNames[raw];
        if (deprecatedInfo != null) {
            utils_1._.doOnce(function () {
                console.warn("ag-grid. Since v15.0 component names have been renamed to be namespaced. You should rename " + deprecatedInfo.propertyHolder + ":" + raw + " to " + deprecatedInfo.propertyHolder + ":" + deprecatedInfo.newComponentName);
            }, 'DEPREACTE_COMPONENT_' + raw);
            return deprecatedInfo.newComponentName;
        }
        return raw;
    };
    __decorate([
        context_1.Autowired('gridOptions'),
        __metadata("design:type", Object)
    ], ComponentProvider.prototype, "gridOptions", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], ComponentProvider.prototype, "context", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ComponentProvider.prototype, "init", null);
    ComponentProvider = __decorate([
        context_1.Bean('componentProvider')
    ], ComponentProvider);
    return ComponentProvider;
}());
exports.ComponentProvider = ComponentProvider;


/***/ }),

/***/ "eykn":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(903);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 882:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nzx/");

/***/ }),

/***/ 903:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(904), __webpack_require__(882) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($, undefined) {
	    // Imports ================================================================
	    var kendo = window.kendo,
	        diagram = kendo.dataviz.diagram,
	        Class = kendo.Class,
	        deepExtend = kendo.deepExtend,
	        dataviz = kendo.dataviz,
	        Utils = diagram.Utils,
	        Point = dataviz.Point2D,
	        isFunction = kendo.isFunction,
	        contains = Utils.contains,
	        map = $.map;

	    // Constants ==============================================================
	    var HITTESTAREA = 3,
	        EPSILON = 1e-06;

	    deepExtend(Point.fn, {
	        plus: function (p) {
	            return new Point(this.x + p.x, this.y + p.y);
	        },
	        minus: function (p) {
	            return new Point(this.x - p.x, this.y - p.y);
	        },
	        offset: function (value) {
	            return new Point(this.x - value, this.y - value);
	        },
	        times: function (s) {
	            return new Point(this.x * s, this.y * s);
	        },
	        normalize: function () {
	            if (this.length() === 0) {
	                return new Point();
	            }
	            return this.times(1 / this.length());
	        },
	        length: function () {
	            return Math.sqrt(this.x * this.x + this.y * this.y);
	        },
	        toString: function () {
	            return "(" + this.x + "," + this.y + ")";
	        },
	        lengthSquared: function () {
	            return (this.x * this.x + this.y * this.y);
	        },
	        middleOf: function MiddleOf(p, q) {
	            return new Point(q.x - p.x, q.y - p.y).times(0.5).plus(p);
	        },
	        toPolar: function (useDegrees) {
	            var factor = 1;
	            if (useDegrees) {
	                factor = 180 / Math.PI;
	            }
	            var a = Math.atan2(Math.abs(this.y), Math.abs(this.x));
	            var halfpi = Math.PI / 2;
	            var len = this.length();
	            if (this.x === 0) {
	                // note that the angle goes down and not the usual mathematical convention

	                if (this.y === 0) {
	                    return new Polar(0, 0);
	                }
	                if (this.y > 0) {
	                    return new Polar(len, factor * halfpi);
	                }
	                if (this.y < 0) {
	                    return new Polar(len, factor * 3 * halfpi);
	                }
	            }
	            else if (this.x > 0) {
	                if (this.y === 0) {
	                    return new Polar(len, 0);
	                }
	                if (this.y > 0) {
	                    return new Polar(len, factor * a);
	                }
	                if (this.y < 0) {
	                    return new Polar(len, factor * (4 * halfpi - a));
	                }
	            }
	            else {
	                if (this.y === 0) {
	                    return new Polar(len, 2 * halfpi);
	                }
	                if (this.y > 0) {
	                    return new Polar(len, factor * (2 * halfpi - a));
	                }
	                if (this.y < 0) {
	                    return new Polar(len, factor * (2 * halfpi + a));
	                }
	            }
	        },
	        isOnLine: function (from, to) {
	            if (from.x > to.x) { // from must be the leftmost point
	                var temp = to;
	                to = from;
	                from = temp;
	            }
	            var r1 = new Rect(from.x, from.y).inflate(HITTESTAREA, HITTESTAREA),
	                r2 = new Rect(to.x, to.y).inflate(HITTESTAREA, HITTESTAREA), o1, u1;
	            if (r1.union(r2).contains(this)) {
	                if (from.x === to.x || from.y === to.y) {
	                    return true;
	                }
	                else if (from.y < to.y) {
	                    o1 = r1.x + (((r2.x - r1.x) * (this.y - (r1.y + r1.height))) / ((r2.y + r2.height) - (r1.y + r1.height)));
	                    u1 = (r1.x + r1.width) + ((((r2.x + r2.width) - (r1.x + r1.width)) * (this.y - r1.y)) / (r2.y - r1.y));
	                }
	                else {
	                    o1 = r1.x + (((r2.x - r1.x) * (this.y - r1.y)) / (r2.y - r1.y));
	                    u1 = (r1.x + r1.width) + ((((r2.x + r2.width) - (r1.x + r1.width)) * (this.y - (r1.y + r1.height))) / ((r2.y + r2.height) - (r1.y + r1.height)));
	                }
	                return (this.x > o1 && this.x < u1);
	            }
	            return false;
	        }
	    });

	    deepExtend(Point, {
	        parse: function (str) {
	            var tempStr = str.slice(1, str.length - 1),
	                xy = tempStr.split(","),
	                x = parseInt(xy[0], 10),
	                y = parseInt(xy[1], 10);
	            if (!isNaN(x) && !isNaN(y)) {
	                return new Point(x, y);
	            }
	        }
	    });

	    /**
	     * Structure combining a Point with two additional points representing the handles or tangents attached to the first point.
	     * If the additional points are null or equal to the first point the path will be sharp.
	     * Left and right correspond to the direction of the underlying path.
	     */
	    var PathDefiner = Class.extend(
	        {
	            init: function (p, left, right) {
	                this.point = p;
	                this.left = left;
	                this.right = right;
	            }
	        }
	    );

	    /**
	     * Defines a rectangular region.
	     */
	    var Rect = Class.extend({
	        init: function (x, y, width, height) {
	            this.x = x || 0;
	            this.y = y || 0;
	            this.width = width || 0;
	            this.height = height || 0;
	        },
	        contains: function (point) {
	            return ((point.x >= this.x) && (point.x <= (this.x + this.width)) && (point.y >= this.y) && (point.y <= (this.y + this.height)));
	        },
	        inflate: function (dx, dy) {
	            if (dy === undefined) {
	                dy = dx;
	            }

	            this.x -= dx;
	            this.y -= dy;
	            this.width += 2 * dx + 1;
	            this.height += 2 * dy + 1;
	            return this;
	        },
	        offset: function (dx, dy) {
	            var x = dx, y = dy;
	            if (dx instanceof Point) {
	                x = dx.x;
	                y = dx.y;
	            }
	            this.x += x;
	            this.y += y;
	            return this;
	        },
	        union: function (r) {
	            var x1 = Math.min(this.x, r.x);
	            var y1 = Math.min(this.y, r.y);
	            var x2 = Math.max((this.x + this.width), (r.x + r.width));
	            var y2 = Math.max((this.y + this.height), (r.y + r.height));
	            return new Rect(x1, y1, x2 - x1, y2 - y1);
	        },
	        center: function () {
	            return new Point(this.x + this.width / 2, this.y + this.height / 2);
	        },
	        top: function () {
	            return new Point(this.x + this.width / 2, this.y);
	        },
	        right: function () {
	            return new Point(this.x + this.width, this.y + this.height / 2);
	        },
	        bottom: function () {
	            return new Point(this.x + this.width / 2, this.y + this.height);
	        },
	        left: function () {
	            return new Point(this.x, this.y + this.height / 2);
	        },
	        topLeft: function () {
	            return new Point(this.x, this.y);
	        },
	        topRight: function () {
	            return new Point(this.x + this.width, this.y);
	        },
	        bottomLeft: function () {
	            return new Point(this.x, this.y + this.height);
	        },
	        bottomRight: function () {
	            return new Point(this.x + this.width, this.y + this.height);
	        },
	        clone: function () {
	            return new Rect(this.x, this.y, this.width, this.height);
	        },
	        isEmpty: function () {
	            return !this.width && !this.height;
	        },
	        equals: function (rect) {
	            return this.x === rect.x && this.y === rect.y && this.width === rect.width && this.height === rect.height;
	        },
	        rotatedBounds: function (angle) {
	            var rect = this.clone(),
	                points = this.rotatedPoints(angle),
	                tl = points[0],
	                tr = points[1],
	                br = points[2],
	                bl = points[3];

	            rect.x = Math.min(br.x, tl.x, tr.x, bl.x);
	            rect.y = Math.min(br.y, tl.y, tr.y, bl.y);
	            rect.width = Math.max(br.x, tl.x, tr.x, bl.x) - rect.x;
	            rect.height = Math.max(br.y, tl.y, tr.y, bl.y) - rect.y;

	            return rect;
	        },
	        rotatedPoints: function (angle) {
	            var rect = this,
	                c = rect.center(),
	                br = rect.bottomRight().rotate(c, 360 - angle),
	                tl = rect.topLeft().rotate(c, 360 - angle),
	                tr = rect.topRight().rotate(c, 360 - angle),
	                bl = rect.bottomLeft().rotate(c, 360 - angle);

	            return [tl, tr, br, bl];
	        },
	        toString: function (delimiter) {
	            delimiter = delimiter || " ";

	            return this.x + delimiter + this.y + delimiter + this.width + delimiter + this.height;
	        },
	        scale: function (scaleX, scaleY, staicPoint, adornerCenter, angle) {
	            var tl = this.topLeft();
	            var thisCenter = this.center();
	            tl.rotate(thisCenter, 360 - angle).rotate(adornerCenter, angle);

	            var delta = staicPoint.minus(tl);
	            var scaled = new Point(delta.x * scaleX, delta.y * scaleY);
	            var position = delta.minus(scaled);
	            tl = tl.plus(position);
	            tl.rotate(adornerCenter, 360 - angle).rotate(thisCenter, angle);

	            this.x = tl.x;
	            this.y = tl.y;

	            this.width *= scaleX;
	            this.height *= scaleY;
	        },

	        zoom: function(zoom) {
	            this.x *= zoom;
	            this.y *= zoom;
	            this.width *= zoom;
	            this.height *= zoom;
	            return this;
	        },

	        overlaps: function(rect) {
	            var bottomRight = this.bottomRight();
	            var rectBottomRight = rect.bottomRight();
	            var overlaps = !(bottomRight.x < rect.x || bottomRight.y < rect.y ||
	                rectBottomRight.x < this.x || rectBottomRight.y < this.y);
	            return overlaps;
	        }
	    });

	    var Size = Class.extend({
	        init: function (width, height) {
	            this.width = width;
	            this.height = height;
	        }
	    });

	    Size.prototype.Empty = new Size(0, 0);

	    Rect.toRect = function (rect) {
	        if (!(rect instanceof Rect)) {
	            rect = new Rect(rect.x, rect.y, rect.width, rect.height);
	        }

	        return rect;
	    };

	    Rect.empty = function () {
	        return new Rect(0, 0, 0, 0);
	    };

	    Rect.fromPoints = function (p, q) {
	        if (isNaN(p.x) || isNaN(p.y) || isNaN(q.x) || isNaN(q.y)) {
	            throw "Some values are NaN.";
	        }
	        return new Rect(Math.min(p.x, q.x), Math.min(p.y, q.y), Math.abs(p.x - q.x), Math.abs(p.y - q.y));
	    };

	    function isNearZero(num) {
	        return Math.abs(num) < EPSILON;
	    }

	    function intersectLine(start1, end1, start2, end2, isSegment) {
	        var tangensdiff = ((end1.x - start1.x) * (end2.y - start2.y)) - ((end1.y - start1.y) * (end2.x - start2.x));
	        if (isNearZero(tangensdiff)) {
	            //parallel lines
	            return;
	        }

	        var num1 = ((start1.y - start2.y) * (end2.x - start2.x)) - ((start1.x - start2.x) * (end2.y - start2.y));
	        var num2 = ((start1.y - start2.y) * (end1.x - start1.x)) - ((start1.x - start2.x) * (end1.y - start1.y));
	        var r = num1 / tangensdiff;
	        var s = num2 / tangensdiff;

	        if (isSegment && (r < 0 || r > 1 || s < 0 || s > 1)) {
	            //r < 0 => line 1 is below line 2
	            //r > 1 => line 1 is above line 2
	            //s < 0 => line 2 is below line 1
	            //s > 1 => line 2 is above line 1
	            return;
	        }

	        return new Point(start1.x + (r * (end1.x - start1.x)), start1.y + (r * (end1.y - start1.y)));
	    }

	    var Intersect = {
	        lines: function (start1, end1, start2, end2) {
	            return intersectLine(start1, end1, start2, end2);
	        },
	        segments: function (start1, end1, start2, end2) {
	            return intersectLine(start1, end1, start2, end2, true);
	        },
	        rectWithLine: function (rect, start, end) {
	            return  Intersect.segments(start, end, rect.topLeft(), rect.topRight()) ||
	                Intersect.segments(start, end, rect.topRight(), rect.bottomRight()) ||
	                Intersect.segments(start, end, rect.bottomLeft(), rect.bottomRight()) ||
	                Intersect.segments(start, end, rect.topLeft(), rect.bottomLeft());
	        },
	        rects: function (rect1, rect2, angle) {
	            var tl = rect2.topLeft(),
	                tr = rect2.topRight(),
	                bl = rect2.bottomLeft(),
	                br = rect2.bottomRight();
	            var center = rect2.center();
	            if (angle) {
	                tl = tl.rotate(center, angle);
	                tr = tr.rotate(center, angle);
	                bl = bl.rotate(center, angle);
	                br = br.rotate(center, angle);
	            }

	            var intersect = rect1.contains(tl) ||
	                rect1.contains(tr) ||
	                rect1.contains(bl) ||
	                rect1.contains(br) ||
	                Intersect.rectWithLine(rect1, tl, tr) ||
	                Intersect.rectWithLine(rect1, tl, bl) ||
	                Intersect.rectWithLine(rect1, tr, br) ||
	                Intersect.rectWithLine(rect1, bl, br);

	            if (!intersect) {//last possible case is rect1 to be completely within rect2
	                tl = rect1.topLeft();
	                tr = rect1.topRight();
	                bl = rect1.bottomLeft();
	                br = rect1.bottomRight();

	                if (angle) {
	                    var reverseAngle = 360 - angle;
	                    tl = tl.rotate(center, reverseAngle);
	                    tr = tr.rotate(center, reverseAngle);
	                    bl = bl.rotate(center, reverseAngle);
	                    br = br.rotate(center, reverseAngle);
	                }

	                intersect = rect2.contains(tl) ||
	                    rect2.contains(tr) ||
	                    rect2.contains(bl) ||
	                    rect2.contains(br);
	            }

	            return intersect;
	        }
	    };

	    /**
	     * Aligns two rectangles, where one is the container and the other is content.
	     */
	    var RectAlign = Class.extend({
	        init: function (container) {
	            this.container = Rect.toRect(container);
	        },

	        align: function (content, alignment) {
	            var alignValues = alignment.toLowerCase().split(" ");

	            for (var i = 0; i < alignValues.length; i++) {
	                content = this._singleAlign(content, alignValues[i]);
	            }

	            return content;
	        },
	        _singleAlign: function (content, alignment) {
	            if (isFunction(this[alignment])) {
	                return this[alignment](content);
	            }
	            else {
	                return content;
	            }
	        },

	        left: function (content) {
	            return this._align(content, this._left);
	        },
	        center: function (content) {
	            return this._align(content, this._center);
	        },
	        right: function (content) {
	            return this._align(content, this._right);
	        },
	        stretch: function (content) {
	            return this._align(content, this._stretch);
	        },
	        top: function (content) {
	            return this._align(content, this._top);
	        },
	        middle: function (content) {
	            return this._align(content, this._middle);
	        },
	        bottom: function (content) {
	            return this._align(content, this._bottom);
	        },

	        _left: function (container, content) {
	            content.x = container.x;
	        },
	        _center: function (container, content) {
	            content.x = ((container.width - content.width) / 2) || 0;
	        },
	        _right: function (container, content) {
	            content.x = container.width - content.width;
	        },
	        _top: function (container, content) {
	            content.y = container.y;
	        },
	        _middle: function (container, content) {
	            content.y = ((container.height - content.height) / 2) || 0;
	        },
	        _bottom: function (container, content) {
	            content.y = container.height - content.height;
	        },
	        _stretch: function (container, content) {
	            content.x = 0;
	            content.y = 0;
	            content.height = container.height;
	            content.width = container.width;
	        },
	        _align: function (content, alignCalc) {
	            content = Rect.toRect(content);
	            alignCalc(this.container, content);

	            return content;
	        }
	    });

	    var Polar = Class.extend({
	        init: function (r, a) {
	            this.r = r;
	            this.angle = a;
	        }
	    });

	    /**
	     * SVG transformation matrix.
	     */
	    var Matrix = Class.extend({
	        init: function (a, b, c, d, e, f) {
	            this.a = a || 0;
	            this.b = b || 0;
	            this.c = c || 0;
	            this.d = d || 0;
	            this.e = e || 0;
	            this.f = f || 0;
	        },
	        plus: function (m) {
	            this.a += m.a;
	            this.b += m.b;
	            this.c += m.c;
	            this.d += m.d;
	            this.e += m.e;
	            this.f += m.f;
	        },
	        minus: function (m) {
	            this.a -= m.a;
	            this.b -= m.b;
	            this.c -= m.c;
	            this.d -= m.d;
	            this.e -= m.e;
	            this.f -= m.f;
	        },
	        times: function (m) {
	            return new Matrix(
	                this.a * m.a + this.c * m.b,
	                this.b * m.a + this.d * m.b,
	                this.a * m.c + this.c * m.d,
	                this.b * m.c + this.d * m.d,
	                this.a * m.e + this.c * m.f + this.e,
	                this.b * m.e + this.d * m.f + this.f
	            );
	        },
	        apply: function (p) {
	            return new Point(this.a * p.x + this.c * p.y + this.e, this.b * p.x + this.d * p.y + this.f);
	        },
	        applyRect: function (r) {
	            return Rect.fromPoints(this.apply(r.topLeft()), this.apply(r.bottomRight()));
	        },
	        toString: function () {
	            return "matrix(" + this.a + " " + this.b + " " + this.c + " " + this.d + " " + this.e + " " + this.f + ")";
	        }
	    });

	    deepExtend(Matrix, {
	        fromSVGMatrix: function (vm) {
	            var m = new Matrix();
	            m.a = vm.a;
	            m.b = vm.b;
	            m.c = vm.c;
	            m.d = vm.d;
	            m.e = vm.e;
	            m.f = vm.f;
	            return m;
	        },
	        fromMatrixVector: function (v) {
	            var m = new Matrix();
	            m.a = v.a;
	            m.b = v.b;
	            m.c = v.c;
	            m.d = v.d;
	            m.e = v.e;
	            m.f = v.f;
	            return m;
	        },
	        fromList: function (v) {
	            if (v.length !== 6) {
	                throw "The given list should consist of six elements.";
	            }
	            var m = new Matrix();
	            m.a = v[0];
	            m.b = v[1];
	            m.c = v[2];
	            m.d = v[3];
	            m.e = v[4];
	            m.f = v[5];
	            return m;
	        },
	        translation: function (x, y) {
	            var m = new Matrix();
	            m.a = 1;
	            m.b = 0;
	            m.c = 0;
	            m.d = 1;
	            m.e = x;
	            m.f = y;
	            return m;
	        },
	        unit: function () {
	            return new Matrix(1, 0, 0, 1, 0, 0);
	        },
	        rotation: function (angle, x, y) {
	            var m = new Matrix();
	            m.a = Math.cos(angle * Math.PI / 180);
	            m.b = Math.sin(angle * Math.PI / 180);
	            m.c = -m.b;
	            m.d = m.a;
	            m.e = (x - x * m.a + y * m.b) || 0;
	            m.f = (y - y * m.a - x * m.b) || 0;
	            return m;
	        },
	        scaling: function (scaleX, scaleY) {
	            var m = new Matrix();
	            m.a = scaleX;
	            m.b = 0;
	            m.c = 0;
	            m.d = scaleY;
	            m.e = 0;
	            m.f = 0;
	            return m;
	        },
	        parse: function (v) {
	            var parts, nums;
	            if (v) {
	                v = v.trim();
	                // of the form "matrix(...)"
	                if (v.slice(0, 6).toLowerCase() === "matrix") {
	                    nums = v.slice(7, v.length - 1).trim();
	                    parts = nums.split(",");
	                    if (parts.length === 6) {
	                        return Matrix.fromList(map(parts, function (p) {
	                            return parseFloat(p);
	                        }));
	                    }
	                    parts = nums.split(" ");
	                    if (parts.length === 6) {
	                        return Matrix.fromList(map(parts, function (p) {
	                            return parseFloat(p);
	                        }));
	                    }
	                }
	                // of the form "(...)"
	                if (v.slice(0, 1) === "(" && v.slice(v.length - 1) === ")") {
	                    v = v.substr(1, v.length - 1);
	                }
	                if (v.indexOf(",") > 0) {
	                    parts = v.split(",");
	                    if (parts.length === 6) {
	                        return Matrix.fromList(map(parts, function (p) {
	                            return parseFloat(p);
	                        }));
	                    }
	                }
	                if (v.indexOf(" ") > 0) {
	                    parts = v.split(" ");
	                    if (parts.length === 6) {
	                        return Matrix.fromList(map(parts, function (p) {
	                            return parseFloat(p);
	                        }));
	                    }
	                }
	            }
	            return parts;
	        }
	    });

	    /**
	     * SVG transformation represented as a vector.
	     */
	    var MatrixVector = Class.extend({
	        init: function (a, b, c, d, e, f) {
	            this.a = a || 0;
	            this.b = b || 0;
	            this.c = c || 0;
	            this.d = d || 0;
	            this.e = e || 0;
	            this.f = f || 0;
	        },
	        fromMatrix: function FromMatrix(m) {
	            var v = new MatrixVector();
	            v.a = m.a;
	            v.b = m.b;
	            v.c = m.c;
	            v.d = m.d;
	            v.e = m.e;
	            v.f = m.f;
	            return v;
	        }
	    });

	    /**
	     * Returns a value with Gaussian (normal) distribution.
	     * @param mean The mean value of the distribution.
	     * @param deviation The deviation (spreading at half-height) of the distribution.
	     * @returns {number}
	     */
	    function normalVariable(mean, deviation) {
	        var x, y, r;
	        do {
	            x = Math.random() * 2 - 1;
	            y = Math.random() * 2 - 1;
	            r = x * x + y * y;
	        }
	        while (!r || r > 1);
	        return mean + deviation * x * Math.sqrt(-2 * Math.log(r) / r);
	    }

	    /**
	     * Returns a random identifier which can be used as an ID of objects, eventually augmented with a prefix.
	     * @returns {string}
	     */
	    function randomId(length) {
	        if (Utils.isUndefined(length)) {
	            length = 10;
	        }
	        // old version return Math.floor((1 + Math.random()) * 0x1000000).toString(16).substring(1);
	        var result = '';
	        var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
	        for (var i = length; i > 0; --i) {
	            result += chars.charAt(Math.round(Math.random() * (chars.length - 1)));
	        }
	        return result;
	    }

	    var Geometry = {

	        /**
	         * Returns the squared distance to the line defined by the two given Points.
	         * @param p An arbitrary Point.
	         * @param a An endpoint of the line or segment.
	         * @param b The complementary endpoint of the line or segment.
	         */
	        _distanceToLineSquared: function (p, a, b) {
	            function d2(pt1, pt2) {
	                return (pt1.x - pt2.x) * (pt1.x - pt2.x) + (pt1.y - pt2.y) * (pt1.y - pt2.y);
	            }

	            if (a === b) { // returns the distance of p to a
	                return d2(p, a);
	            }

	            var vx = b.x - a.x,
	                vy = b.y - a.y,
	                dot = (p.x - a.x) * vx + (p.y - a.y) * vy;
	            if (dot < 0) {
	                return d2(a, p); // sits on side of a
	            }

	            dot = (b.x - p.x) * vx + (b.y - p.y) * vy;
	            if (dot < 0) {
	                return d2(b, p); // sits on side of b
	            }
	            // regular case, use crossproduct to get the sine out
	            dot = (b.x - p.x) * vy - (b.y - p.y) * vx;
	            return dot * dot / (vx * vx + vy * vy);
	        },

	        /**
	         * Returns the distance to the line defined by the two given Points.
	         * @param p An arbitrary Point.
	         * @param a An endpoint of the line or segment.
	         * @param b The complementary endpoint of the line or segment.
	         */
	        distanceToLine: function (p, a, b) {
	            return Math.sqrt(this._distanceToLineSquared(p, a, b));
	        },

	        /**
	         * Returns the distance of the given points to the polyline defined by the points.
	         * @param p An arbitrary point.
	         * @param points The points defining the polyline.
	         * @returns {Number}
	         */
	        distanceToPolyline: function (p, points) {
	            var minimum = Number.MAX_VALUE;
	            if (Utils.isUndefined(points) || points.length === 0) {
	                return Number.MAX_VALUE;
	            }
	            for (var s = 0; s < points.length - 1; s++) {
	                var p1 = points[s];
	                var p2 = points[s + 1];

	                var d = this._distanceToLineSquared(p, p1, p2);
	                if (d < minimum) {
	                    minimum = d;
	                }
	            }
	            return Math.sqrt(minimum);
	        }
	    };

	    /*---------------The HashTable structure--------------------------------*/

	    /**
	     * Represents a collection of key-value pairs that are organized based on the hash code of the key.
	     * _buckets[hashId] = {key: key, value:...}
	     * Important: do not use the standard Array access method, use the get/set methods instead.
	     * See http://en.wikipedia.org/wiki/Hash_table
	     */
	    var HashTable = kendo.Class.extend({
	        init: function () {
	            this._buckets = [];
	            this.length = 0;
	        },

	        /**
	         * Adds the literal object with the given key (of the form {key: key,....}).
	         */
	        add: function (key, value) {

	            var obj = this._createGetBucket(key);
	            if (Utils.isDefined(value)) {
	                obj.value = value;
	            }
	            return obj;
	        },

	        /**
	         * Gets the literal object with the given key.
	         */
	        get: function (key) {
	            if (this._bucketExists(key)) {
	                return this._createGetBucket(key);
	            }
	            return null;
	        },

	        /**
	         * Set the key-value pair.
	         * @param key The key of the entry.
	         * @param value The value to set. If the key already exists the value will be overwritten.
	         */
	        set: function (key, value) {
	            this.add(key, value);
	        },

	        /**
	         * Determines whether the HashTable contains a specific key.
	         */
	        containsKey: function (key) {
	            return this._bucketExists(key);
	        },

	        /**
	         * Removes the element with the specified key from the hashtable.
	         * Returns the removed bucket.
	         */
	        remove: function (key) {
	            if (this._bucketExists(key)) {
	                var hashId = this._hash(key);
	                delete this._buckets[hashId];
	                this.length--;
	                return key;
	            }
	        },

	        /**
	         * Foreach with an iterator working on the key-value pairs.
	         * @param func
	         */
	        forEach: function (func) {
	            var hashes = this._hashes();
	            for (var i = 0, len = hashes.length; i < len; i++) {
	                var hash = hashes[i];
	                var bucket = this._buckets[hash];
	                if (Utils.isUndefined(bucket)) {
	                    continue;
	                }
	                func(bucket);
	            }
	        },

	        /**
	         * Returns a (shallow) clone of the current HashTable.
	         * @returns {HashTable}
	         */
	        clone: function () {
	            var ht = new HashTable();
	            var hashes = this._hashes();
	            for (var i = 0, len = hashes.length; i < len; i++) {
	                var hash = hashes[i];
	                var bucket = this._buckets[hash];
	                if (Utils.isUndefined(bucket)) {
	                    continue;
	                }
	                ht.add(bucket.key, bucket.value);
	            }
	            return ht;
	        },

	        /**
	         * Returns the hashes of the buckets.
	         * @returns {Array}
	         * @private
	         */
	        _hashes: function () {
	            var hashes = [];
	            for (var hash in this._buckets) {
	                if (this._buckets.hasOwnProperty(hash)) {
	                    hashes.push(hash);
	                }
	            }
	            return hashes;
	        },

	        _bucketExists: function (key) {
	            var hashId = this._hash(key);
	            return Utils.isDefined(this._buckets[hashId]);
	        },

	        /**
	         * Returns-adds the createGetBucket with the given key. If not present it will
	         * be created and returned.
	         * A createGetBucket is a literal object of the form {key: key, ...}.
	         */
	        _createGetBucket: function (key) {
	            var hashId = this._hash(key);
	            var bucket = this._buckets[hashId];
	            if (Utils.isUndefined(bucket)) {
	                bucket = { key: key };
	                this._buckets[hashId] = bucket;
	                this.length++;
	            }
	            return bucket;
	        },

	        /**
	         * Hashing of the given key.
	         */
	        _hash: function (key) {
	            if (Utils.isNumber(key)) {
	                return key;
	            }
	            if (Utils.isString(key)) {
	                return this._hashString(key);
	            }
	            if (Utils.isObject(key)) {
	                return this._objectHashId(key);
	            }
	            throw "Unsupported key type.";
	        },

	        /**
	         * Hashing of a string.
	         */
	        _hashString: function (s) {
	            // see for example http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
	            var result = 0;
	            if (s.length === 0) {
	                return result;
	            }
	            for (var i = 0; i < s.length; i++) {
	                var ch = s.charCodeAt(i);
	                result = ((result * 32) - result) + ch;
	            }
	            return result;
	        },

	        /**
	         * Returns the unique identifier for an object. This is automatically assigned and add on the object.
	         */
	        _objectHashId: function (key) {
	            var id = key._hashId;
	            if (Utils.isUndefined(id)) {
	                id = randomId();
	                key._hashId = id;
	            }
	            return id;
	        }
	    });

	    /*---------------The Dictionary structure--------------------------------*/

	    /**
	     * Represents a collection of key-value pairs.
	     * Important: do not use the standard Array access method, use the get/Set methods instead.
	     */
	    var Dictionary = kendo.Observable.extend({
	        /**
	         * Initializes a new instance of the Dictionary class.
	         * @param dictionary Loads the content of the given dictionary into this new one.
	         */
	        init: function (dictionary) {
	            var that = this;
	            kendo.Observable.fn.init.call(that);
	            this._hashTable = new HashTable();
	            this.length = 0;
	            if (Utils.isDefined(dictionary)) {
	                if ($.isArray(dictionary)) {
	                    for (var i = 0; i < dictionary.length; i++) {
	                        this.add(dictionary[i]);
	                    }
	                } else {
	                    dictionary.forEach(function (k, v) {
	                        this.add(k, v);
	                    }, this);
	                }
	            }
	        },

	        /**
	         * Adds a key-value to the dictionary.
	         * If the key already exists this will assign the given value to the existing entry.
	         */
	        add: function (key, value) {
	            var entry = this._hashTable.get(key);
	            if (!entry) {
	                entry = this._hashTable.add(key);
	                this.length++;
	                this.trigger('changed');
	            }
	            entry.value = value;
	        },

	        /**
	         * Set the key-value pair.
	         * @param key The key of the entry.
	         * @param value The value to set. If the key already exists the value will be overwritten.
	         */
	        set: function (key, value) {
	            this.add(key, value);
	        },

	        /**
	         * Gets the value associated with the given key in the dictionary.
	         */
	        get: function (key) {
	            var entry = this._hashTable.get(key);
	            if (entry) {
	                return entry.value;
	            }
	            throw new Error("Cannot find key " + key);
	        },

	        /**
	         * Returns whether the dictionary contains the given key.
	         */
	        containsKey: function (key) {
	            return this._hashTable.containsKey(key);
	        },

	        /**
	         * Removes the element with the specified key from the dictionary.
	         */
	        remove: function (key) {
	            if (this.containsKey(key)) {
	                this.trigger("changed");
	                this.length--;
	                return this._hashTable.remove(key);
	            }
	        },

	        /**
	         * The functional gets the key and value as parameters.
	         */
	        forEach: function (func, thisRef) {
	            this._hashTable.forEach(function (entry) {
	                func.call(thisRef, entry.key, entry.value);
	            });
	        },

	        /**
	         * Same as forEach except that only the value is passed to the functional.
	         */
	        forEachValue: function (func, thisRef) {
	            this._hashTable.forEach(function (entry) {
	                func.call(thisRef, entry.value);
	            });
	        },

	        /**
	         * Calls a defined callback function for each key in the dictionary.
	         */
	        forEachKey: function (func, thisRef) {
	            this._hashTable.forEach(function (entry) {
	                func.call(thisRef, entry.key);
	            });
	        },

	        /**
	         * Gets an array with all keys in the dictionary.
	         */
	        keys: function () {
	            var keys = [];
	            this.forEachKey(function (key) {
	                keys.push(key);
	            });
	            return keys;
	        }
	    });

	    /*---------------Queue structure--------------------------------*/

	    var Queue = kendo.Class.extend({

	        init: function () {
	            this._tail = null;
	            this._head = null;
	            this.length = 0;
	        },

	        /**
	         * Enqueues an object to the end of the queue.
	         */
	        enqueue: function (value) {
	            var entry = { value: value, next: null };
	            if (!this._head) {
	                this._head = entry;
	                this._tail = this._head;
	            }
	            else {
	                this._tail.next = entry;
	                this._tail = this._tail.next;
	            }
	            this.length++;
	        },

	        /**
	         * Removes and returns the object at top of the queue.
	         */
	        dequeue: function () {
	            if (this.length < 1) {
	                throw new Error("The queue is empty.");
	            }
	            var value = this._head.value;
	            this._head = this._head.next;
	            this.length--;
	            return value;
	        },

	        contains: function (item) {
	            var current = this._head;
	            while (current) {
	                if (current.value === item) {
	                    return true;
	                }
	                current = current.next;
	            }
	            return false;
	        }
	    });


	    /**
	     * While other data structures can have multiple times the same item a Set owns only
	     * once a particular item.
	     * @type {*}
	     */
	    var Set = kendo.Observable.extend({
	        init: function (resource) {
	            var that = this;
	            kendo.Observable.fn.init.call(that);
	            this._hashTable = new HashTable();
	            this.length = 0;
	            if (Utils.isDefined(resource)) {
	                if (resource instanceof HashTable) {
	                    resource.forEach(function (d) {
	                        this.add(d);
	                    });
	                }
	                else if (resource instanceof Dictionary) {
	                    resource.forEach(function (k, v) {
	                        this.add({key: k, value: v});
	                    }, this);
	                }
	            }
	        },

	        contains: function (item) {
	            return this._hashTable.containsKey(item);
	        },

	        add: function (item) {
	            var entry = this._hashTable.get(item);
	            if (!entry) {
	                this._hashTable.add(item, item);
	                this.length++;
	                this.trigger('changed');
	            }
	        },

	        get: function (item) {
	            if (this.contains(item)) {
	                return this._hashTable.get(item).value;
	            }
	            else {
	                return null;
	            }
	        },

	        /**
	         * Returns the hash of the item.
	         * @param item
	         * @returns {*}
	         */
	        hash: function (item) {
	            return this._hashTable._hash(item);
	        },

	        /**
	         * Removes the given item from the set. No exception is thrown if the item is not in the Set.
	         * @param item
	         */
	        remove: function (item) {
	            if (this.contains(item)) {
	                this._hashTable.remove(item);
	                this.length--;
	                this.trigger('changed');
	            }
	        },
	        /**
	         * Foreach with an iterator working on the key-value pairs.
	         * @param func
	         */
	        forEach: function (func, context) {
	            this._hashTable.forEach(function (kv) {
	                func(kv.value);
	            }, context);
	        },
	        toArray: function () {
	            var r = [];
	            this.forEach(function (d) {
	                r.push(d);
	            });
	            return r;
	        }
	    });

	    /*----------------Node-------------------------------*/

	    /**
	     * Defines the node (vertex) of a Graph.
	     */
	    var Node = kendo.Class.extend({

	        init: function (id, shape) {

	            /**
	             * Holds all the links incident with the current node.
	             * Do not use this property to manage the incoming links, use the appropriate add/remove methods instead.
	             */
	            this.links = [];

	            /**
	             * Holds the links from the current one to another Node .
	             * Do not use this property to manage the incoming links, use the appropriate add/remove methods instead.
	             */
	            this.outgoing = [];

	            /**
	             * Holds the links from another Node to the current one.
	             * Do not use this property to manage the incoming links, use the appropriate add/remove methods instead.
	             */
	            this.incoming = [];

	            /**
	             * Holds the weight of this Node.
	             */
	            this.weight = 1;

	            if (Utils.isDefined(id)) {
	                this.id = id;
	            }
	            else {
	                this.id = randomId();
	            }
	            if (Utils.isDefined(shape)) {
	                this.associatedShape = shape;
	                // transfer the shape's bounds to the runtime props
	                var b = shape.bounds();
	                this.width = b.width;
	                this.height = b.height;
	                this.x = b.x;
	                this.y = b.y;
	            }
	            else {
	                this.associatedShape = null;
	            }
	            /**
	             * The payload of the node.
	             * @type {null}
	             */
	            this.data = null;
	            this.type = "Node";
	            this.shortForm = "Node '" + this.id + "'";
	            /**
	             * Whether this is an injected node during the analysis or layout process.
	             * @type {boolean}
	             */
	            this.isVirtual = false;
	        },

	        /**
	         * Returns whether this node has no links attached.
	         */
	        isIsolated: function () {
	            return Utils.isEmpty(this.links);
	        },

	        /**
	         * Gets or sets the bounding rectangle of this node.
	         * This should be considered as runtime data, the property is not hotlinked to a SVG item.
	         */
	        bounds: function (r) {
	            if (!Utils.isDefined(r)) {
	                return new diagram.Rect(this.x, this.y, this.width, this.height);
	            }

	            this.x = r.x;
	            this.y = r.y;
	            this.width = r.width;
	            this.height = r.height;
	        },

	        /**
	         * Returns whether there is at least one link with the given (complementary) node. This can be either an
	         * incoming or outgoing link.
	         */
	        isLinkedTo: function (node) {
	            var that = this;
	            return Utils.any(that.links, function (link) {
	                return link.getComplement(that) === node;
	            });
	        },

	        /**
	         * Gets the children of this node, defined as the adjacent nodes with a link from this node to the adjacent one.
	         * @returns {Array}
	         */
	        getChildren: function () {
	            if (this.outgoing.length === 0) {
	                return [];
	            }
	            var children = [];
	            for (var i = 0, len = this.outgoing.length; i < len; i++) {
	                var link = this.outgoing[i];
	                children.push(link.getComplement(this));
	            }
	            return children;
	        },

	        /**
	         * Gets the parents of this node, defined as the adjacent nodes with a link from the adjacent node to this one.
	         * @returns {Array}
	         */
	        getParents: function () {
	            if (this.incoming.length === 0) {
	                return [];
	            }
	            var parents = [];
	            for (var i = 0, len = this.incoming.length; i < len; i++) {
	                var link = this.incoming[i];
	                parents.push(link.getComplement(this));
	            }
	            return parents;
	        },

	        /**
	         * Returns a clone of the Node. Note that the identifier is not cloned since it's a different Node instance.
	         * @returns {Node}
	         */
	        clone: function () {
	            var copy = new Node();
	            if (Utils.isDefined(this.weight)) {
	                copy.weight = this.weight;
	            }
	            if (Utils.isDefined(this.balance)) {
	                copy.balance = this.balance;
	            }
	            if (Utils.isDefined(this.owner)) {
	                copy.owner = this.owner;
	            }
	            copy.associatedShape = this.associatedShape;
	            copy.x = this.x;
	            copy.y = this.y;
	            copy.width = this.width;
	            copy.height = this.height;
	            return copy;
	        },

	        /**
	         * Returns whether there is a link from the current node to the given node.
	         */
	        adjacentTo: function (node) {
	            return this.isLinkedTo(node) !== null;
	        },

	        /**
	         * Removes the given link from the link collection this node owns.
	         * @param link
	         */
	        removeLink: function (link) {
	            if (link.source === this) {
	                Utils.remove(this.links, link);
	                Utils.remove(this.outgoing, link);
	                link.source = null;
	            }

	            if (link.target === this) {
	                Utils.remove(this.links, link);
	                Utils.remove(this.incoming, link);
	                link.target = null;
	            }
	        },

	        /**
	         * Returns whether there is a (outgoing) link from the current node to the given one.
	         */
	        hasLinkTo: function (node) {
	            return Utils.any(this.outgoing, function (link) {
	                return link.target === node;
	            });
	        },

	        /**
	         * Returns the degree of this node, i.e. the sum of incoming and outgoing links.
	         */
	        degree: function () {
	            return this.links.length;
	        },

	        /**
	         * Returns whether this node is either the source or the target of the given link.
	         */
	        incidentWith: function (link) {
	            return contains(this.links, link);
	        },

	        /**
	         * Returns the links between this node and the given one.
	         */
	        getLinksWith: function (node) {
	            return Utils.all(this.links, function (link) {
	                return link.getComplement(this) === node;
	            }, this);
	        },

	        /**
	         * Returns the nodes (either parent or child) which are linked to the current one.
	         */
	        getNeighbors: function () {
	            var neighbors = [];
	            Utils.forEach(this.incoming, function (e) {
	                neighbors.push(e.getComplement(this));
	            }, this);
	            Utils.forEach(this.outgoing, function (e) {
	                neighbors.push(e.getComplement(this));
	            }, this);
	            return neighbors;
	        }
	    });

	    /**
	     * Defines a directed link (edge, connection) of a Graph.
	     */
	    var Link = kendo.Class.extend({

	        init: function (source, target, id, connection) {
	            if (Utils.isUndefined(source)) {
	                throw "The source of the new link is not set.";
	            }
	            if (Utils.isUndefined(target)) {
	                throw "The target of the new link is not set.";
	            }
	            var sourceFound, targetFound;
	            if (Utils.isString(source)) {
	                sourceFound = new Node(source);
	            }
	            else {
	                sourceFound = source;
	            }
	            if (Utils.isString(target)) {
	                targetFound = new Node(target);
	            }
	            else {
	                targetFound = target;
	            }

	            this.source = sourceFound;
	            this.target = targetFound;
	            this.source.links.push(this);
	            this.target.links.push(this);
	            this.source.outgoing.push(this);
	            this.target.incoming.push(this);
	            if (Utils.isDefined(id)) {
	                this.id = id;
	            }
	            else {
	                this.id = randomId();
	            }
	            if (Utils.isDefined(connection)) {
	                this.associatedConnection = connection;
	            }
	            else {
	                this.associatedConnection = null;
	            }
	            this.type = "Link";
	            this.shortForm = "Link '" + this.source.id + "->" + this.target.id + "'";
	        },

	        /**
	         * Returns the complementary node of the given one, if any.
	         */
	        getComplement: function (node) {
	            if (this.source !== node && this.target !== node) {
	                throw "The given node is not incident with this link.";
	            }
	            return this.source === node ? this.target : this.source;
	        },

	        /**
	         * Returns the overlap of the current link with the given one, if any.
	         */
	        getCommonNode: function (link) {
	            if (this.source === link.source || this.source === link.target) {
	                return this.source;
	            }
	            if (this.target === link.source || this.target === link.target) {
	                return this.target;
	            }
	            return null;
	        },

	        /**
	         * Returns whether the current link is bridging the given nodes.
	         */
	        isBridging: function (v1, v2) {
	            return this.source === v1 && this.target === v2 || this.source === v2 && this.target === v1;
	        },

	        /**
	         * Returns the source and target of this link as a tuple.
	         */
	        getNodes: function () {
	            return [this.source, this.target];
	        },

	        /**
	         * Returns whether the given node is either the source or the target of the current link.
	         */
	        incidentWith: function (node) {
	            return this.source === node || this.target === node;
	        },

	        /**
	         * Returns whether the given link is a continuation of the current one. This can be both
	         * via an incoming or outgoing link.
	         */
	        adjacentTo: function (link) {
	            return contains(this.source.links, link) || contains(this.target.links, link);
	        },

	        /**
	         * Changes the source-node of this link.
	         */
	        changeSource: function (node) {
	            Utils.remove(this.source.links, this);
	            Utils.remove(this.source.outgoing, this);

	            node.links.push(this);
	            node.outgoing.push(this);

	            this.source = node;
	        },

	        /**
	         * Changes the target-node of this link.
	         * @param node
	         */
	        changeTarget: function (node) {
	            Utils.remove(this.target.links, this);
	            Utils.remove(this.target.incoming, this);

	            node.links.push(this);
	            node.incoming.push(this);

	            this.target = node;
	        },

	        /**
	         * Changes both the source and the target nodes of this link.
	         */
	        changesNodes: function (v, w) {
	            if (this.source === v) {
	                this.changeSource(w);
	            }
	            else if (this.target === v) {
	                this.changeTarget(w);
	            }
	        },

	        /**
	         * Reverses the direction of this link.
	         */
	        reverse: function () {
	            var oldSource = this.source;
	            var oldTarget = this.target;

	            this.source = oldTarget;
	            Utils.remove(oldSource.outgoing, this);
	            this.source.outgoing.push(this);

	            this.target = oldSource;
	            Utils.remove(oldTarget.incoming, this);
	            this.target.incoming.push(this);
	            return this;
	        },

	        /**
	         * Ensures that the given target defines the endpoint of this link.
	         */
	        directTo: function (target) {
	            if (this.source !== target && this.target !== target) {
	                throw "The given node is not incident with this link.";
	            }
	            if (this.target !== target) {
	                this.reverse();
	            }
	        },

	        /**
	         * Returns a reversed clone of this link.
	         */
	        createReverseEdge: function () {
	            var r = this.clone();
	            r.reverse();
	            r.reversed = true;
	            return r;
	        },

	        /**
	         * Returns a clone of this link.
	         */
	        clone: function () {
	            var clone = new Link(this.source, this.target);
	            return clone;
	        }
	    });

	    /*--------------Graph structure---------------------------------*/
	    /**
	     * Defines a directed graph structure.
	     * Note that the incidence structure resides in the nodes through the incoming and outgoing links collection, rahter than
	     * inside the Graph.
	     */
	    var Graph = kendo.Class.extend({
	        init: function (idOrDiagram) {
	            /**
	             * The links or edge collection of this Graph.
	             * @type {Array}
	             */
	            this.links = [];
	            /**
	             * The node or vertex collection of this Graph.
	             * @type {Array}
	             */
	            this.nodes = [];

	            this._nodeMap = new Dictionary();
	            /**
	             * The optional reference to the Diagram on which this Graph is based.
	             * @type {null}
	             */
	            this.diagram = null;

	            /**
	             * The root of this Graph. If not set explicitly the first Node with zero incoming links will be taken.
	             * @type {null}
	             * @private
	             */
	            this._root = null;
	            if (Utils.isDefined(idOrDiagram)) {
	                if (Utils.isString(idOrDiagram)) {
	                    this.id = idOrDiagram;
	                }
	                else {
	                    this.diagram = idOrDiagram;
	                    this.id = idOrDiagram.id;
	                }
	            }
	            else {
	                this.id = randomId();
	            }

	            /**
	             * The bounds of this graph if the nodes have spatial extension defined.
	             * @type {Rect}
	             */
	            this.bounds = new Rect();
	            // keeps track whether the children & parents have been created
	            this._hasCachedRelationships = false;
	            this.type = "Graph";
	        },
	        /**
	         * Caches the relational information of parents and children in the 'parents' and 'children'
	         * properties.
	         * @param forceRebuild If set to true the relational info will be rebuild even if already present.
	         */
	        cacheRelationships: function (forceRebuild) {
	            if (Utils.isUndefined(forceRebuild)) {
	                forceRebuild = false;
	            }
	            if (this._hasCachedRelationships && !forceRebuild) {
	                return;
	            }
	            for (var i = 0, len = this.nodes.length; i < len; i++) {
	                var node = this.nodes[i];
	                node.children = this.getChildren(node);
	                node.parents = this.getParents(node);
	            }
	            this._hasCachedRelationships = true;
	        },

	        /**
	         * Assigns tree-levels to the nodes assuming this is a tree graph.
	         * If not connected or not a tree the process will succeed but
	         * will have little meaning.
	         * @param startNode The node from where the level numbering starts, usually the root of the tree.
	         * @param visited The collection of visited nodes.
	         * @param offset The offset or starting counter of the level info.
	         */
	        assignLevels: function (startNode, offset, visited) {
	            if (!startNode) {
	                throw "Start node not specified.";
	            }
	            if (Utils.isUndefined(offset)) {
	                offset = 0;
	            }
	            // if not done before, cache the parents and children
	            this.cacheRelationships();
	            if (Utils.isUndefined(visited)) {
	                visited = new Dictionary();
	                Utils.forEach(this.nodes, function (n) {
	                    visited.add(n, false);
	                });
	            }
	            visited.set(startNode, true);
	            startNode.level = offset;
	            var children = startNode.children;
	            for (var i = 0, len = children.length; i < len; i++) {
	                var child = children[i];
	                if (!child || visited.get(child)) {
	                    continue;
	                }
	                this.assignLevels(child, offset + 1, visited);
	            }
	        },

	        /**
	         * Gets or set the root of this graph.
	         * If not set explicitly the first Node with zero incoming links will be taken.
	         * @param value
	         * @returns {*}
	         */
	        root: function (value) {
	            if (Utils.isUndefined(value)) {
	                if (!this._root) {
	                    // TODO: better to use the longest path for the most probable root?
	                    var found = Utils.first(this.nodes, function (n) {
	                        return n.incoming.length === 0;
	                    });
	                    if (found) {
	                        return found;
	                    }
	                    return Utils.first(this.nodes);
	                }
	                else {
	                    return this._root;
	                }
	            }
	            else {
	                this._root = value;
	            }
	        },

	        /**
	         * Returns the connected components of this graph.
	         * Note that the returned graphs are made up of the nodes and links of this graph, i.e. a pointer to the items of this graph.
	         * If you alter the items of the components you'll alter the original graph and vice versa.
	         * @returns {Array}
	         */
	        getConnectedComponents: function () {
	            this.componentIndex = 0;
	            this.setItemIndices();
	            var componentId = Utils.initArray(this.nodes.length, -1);

	            for (var v = 0; v < this.nodes.length; v++) {
	                if (componentId[v] === -1) {
	                    this._collectConnectedNodes(componentId, v);
	                    this.componentIndex++;
	                }
	            }

	            var components = [], i;
	            for (i = 0; i < this.componentIndex; ++i) {
	                components[i] = new Graph();
	            }
	            for (i = 0; i < componentId.length; ++i) {
	                var graph = components[componentId[i]];
	                graph.addNodeAndOutgoings(this.nodes[i]);
	            }
	            // sorting the components in decreasing order of node count
	            components.sort(function (a, b) {
	                return b.nodes.length - a.nodes.length;
	            });
	            return components;
	        },

	        _collectConnectedNodes: function (setIds, nodeIndex) {
	            setIds[nodeIndex] = this.componentIndex; // part of the current component
	            var node = this.nodes[nodeIndex];
	            Utils.forEach(node.links,
	                function (link) {
	                    var next = link.getComplement(node);
	                    var nextId = next.index;
	                    if (setIds[nextId] === -1) {
	                        this._collectConnectedNodes(setIds, nextId);
	                    }
	                }, this);
	        },

	        /**
	         * Calculates the bounds of this Graph if the Nodes have spatial dimensions defined.
	         * @returns {Rect}
	         */
	        calcBounds: function () {
	            if (this.isEmpty()) {
	                this.bounds = new Rect();
	                return this.bounds;
	            }
	            var b = null;
	            for (var i = 0, len = this.nodes.length; i < len; i++) {
	                var node = this.nodes[i];
	                if (!b) {
	                    b = node.bounds();
	                }
	                else {
	                    b = b.union(node.bounds());
	                }
	            }
	            this.bounds = b;
	            return this.bounds;
	        },

	        /**
	         * Creates a spanning tree for the current graph.
	         * Important: this will not return a spanning forest if the graph is disconnected.
	         * Prim's algorithm  finds a minimum-cost spanning tree of an edge-weighted, connected, undirected graph;
	         * see http://en.wikipedia.org/wiki/Prim%27s_algorithm .
	         * @param root The root of the spanning tree.
	         * @returns {Graph}
	         */
	        getSpanningTree: function (root) {
	            var tree = new Graph();
	            var map = new Dictionary(), source, target;
	            tree.root = root.clone();
	            tree.root.level = 0;
	            tree.root.id = root.id;
	            map.add(root, tree.root);
	            root.level = 0;

	            var visited = [];
	            var remaining = [];
	            tree._addNode(tree.root);
	            visited.push(root);
	            remaining.push(root);

	            var levelCount = 1;
	            while (remaining.length > 0) {
	                var next = remaining.pop();
	                for (var ni = 0; ni < next.links.length; ni++) {
	                    var link = next.links[ni];
	                    var cn = link.getComplement(next);
	                    if (contains(visited, cn)) {
	                        continue;
	                    }

	                    cn.level = next.level + 1;
	                    if (levelCount < cn.level + 1) {
	                        levelCount = cn.level + 1;
	                    }
	                    if (!contains(remaining, cn)) {
	                        remaining.push(cn);
	                    }
	                    if (!contains(visited, cn)) {
	                        visited.push(cn);
	                    }
	                    if (map.containsKey(next)) {
	                        source = map.get(next);
	                    }
	                    else {
	                        source = next.clone();
	                        source.level = next.level;
	                        source.id = next.id;
	                        map.add(next, source);
	                    }
	                    if (map.containsKey(cn)) {
	                        target = map.get(cn);
	                    }
	                    else {
	                        target = cn.clone();
	                        target.level = cn.level;
	                        target.id = cn.id;
	                        map.add(cn, target);
	                    }
	                    var newLink = new Link(source, target);
	                    tree.addLink(newLink);
	                }

	            }

	            var treeLevels = [];
	            for (var i = 0; i < levelCount; i++) {
	                treeLevels.push([]);
	            }

	            Utils.forEach(tree.nodes, function (node) {
	                treeLevels[node.level].push(node);
	            });

	            tree.treeLevels = treeLevels;
	            tree.cacheRelationships();
	            return tree;
	        },

	        /**
	         * Returns a random node in this graph.
	         * @param excludedNodes The collection of nodes which should not be considered.
	         * @param incidenceLessThan The maximum degree or incidence the random node should have.
	         * @returns {*}
	         */
	        takeRandomNode: function (excludedNodes, incidenceLessThan) {
	            if (Utils.isUndefined(excludedNodes)) {
	                excludedNodes = [];
	            }
	            if (Utils.isUndefined(incidenceLessThan)) {
	                incidenceLessThan = 4;
	            }
	            if (this.nodes.length === 0) {
	                return null;
	            }
	            if (this.nodes.length === 1) {
	                return contains(excludedNodes, this.nodes[0]) ? null : this.nodes[0];
	            }
	            var pool = $.grep(this.nodes, function (node) {
	                return !contains(excludedNodes, node) && node.degree() <= incidenceLessThan;
	            });
	            if (Utils.isEmpty(pool)) {
	                return null;
	            }
	            return pool[Utils.randomInteger(0, pool.length)];
	        },

	        /**
	         * Returns whether this is an empty graph.
	         */
	        isEmpty: function () {
	            return Utils.isEmpty(this.nodes);
	        },

	        /**
	         * Checks whether the endpoints of the links are all in the nodes collection.
	         */
	        isHealthy: function () {
	            return Utils.all(this.links, function (link) {
	                return contains(this.nodes, link.source) && contains(this.nodes, link.target);
	            }, this);
	        },

	        /**
	         * Gets the parents of this node, defined as the adjacent nodes with a link from the adjacent node to this one.
	         * @returns {Array}
	         */
	        getParents: function (n) {
	            if (!this.hasNode(n)) {
	                throw "The given node is not part of this graph.";
	            }
	            return n.getParents();
	        },

	        /**
	         * Gets the children of this node, defined as the adjacent nodes with a link from this node to the adjacent one.
	         * @returns {Array}
	         */
	        getChildren: function (n) {
	            if (!this.hasNode(n)) {
	                throw "The given node is not part of this graph.";
	            }
	            return n.getChildren();
	        },

	        /**
	         * Adds a new link to the graph between the given nodes.
	         */
	        addLink: function (sourceOrLink, target, owner) {

	            if (Utils.isUndefined(sourceOrLink)) {
	                throw "The source of the link is not defined.";
	            }
	            if (Utils.isUndefined(target)) {
	                // can only be undefined if the first one is a Link
	                if (Utils.isDefined(sourceOrLink.type) && sourceOrLink.type === "Link") {
	                    this.addExistingLink(sourceOrLink);
	                    return;
	                }
	                else {
	                    throw "The target of the link is not defined.";
	                }
	            }

	            var foundSource = this.getNode(sourceOrLink);
	            if (Utils.isUndefined(foundSource)) {
	                foundSource = this.addNode(sourceOrLink);
	            }
	            var foundTarget = this.getNode(target);
	            if (Utils.isUndefined(foundTarget)) {
	                foundTarget = this.addNode(target);
	            }

	            var newLink = new Link(foundSource, foundTarget);

	            if (Utils.isDefined(owner)) {
	                newLink.owner = owner;
	            }

	            /*newLink.source.outgoing.push(newLink);
	             newLink.source.links.push(newLink);
	             newLink.target.incoming.push(newLink);
	             newLink.target.links.push(newLink);*/

	            this.links.push(newLink);

	            return newLink;
	        },

	        /**
	         * Removes all the links in this graph.
	         */
	        removeAllLinks: function () {
	            while (this.links.length > 0) {
	                var link = this.links[0];
	                this.removeLink(link);
	            }
	        },

	        /**
	         * Adds the given link to the current graph.
	         */
	        addExistingLink: function (link) {

	            if (this.hasLink(link)) {
	                return;
	            }
	            this.links.push(link);
	            if (this.hasNode(link.source.id)) {
	                // priority to the existing node with the id even if other props are different
	                var s = this.getNode(link.source.id);
	                link.changeSource(s);
	            }
	            else {
	                this.addNode(link.source);
	            }

	            if (this.hasNode(link.target.id)) {
	                var t = this.getNode(link.target.id);
	                link.changeTarget(t);
	            }
	            else {
	                this.addNode(link.target);
	            }

	            /*  if (!link.source.outgoing.contains(link)) {
	             link.source.outgoing.push(link);
	             }
	             if (!link.source.links.contains(link)) {
	             link.source.links.push(link);
	             }
	             if (!link.target.incoming.contains(link)) {
	             link.target.incoming.push(link);
	             }
	             if (!link.target.links.contains(link)) {
	             link.target.links.push(link);
	             }*/
	        },

	        /**
	         * Returns whether the given identifier or Link is part of this graph.
	         * @param linkOrId An identifier or a Link object.
	         * @returns {*}
	         */
	        hasLink: function (linkOrId) {
	            if (Utils.isString(linkOrId)) {
	                return Utils.any(this.links, function (link) {
	                    return link.id === linkOrId;
	                });
	            }
	            if (linkOrId.type === "Link") {
	                return contains(this.links, linkOrId);
	            }
	            throw "The given object is neither an identifier nor a Link.";
	        },
	        /**
	         * Gets the node with the specified Id or null if not part of this graph.
	         */
	        getNode: function (nodeOrId) {
	            var id = nodeOrId.id || nodeOrId;
	            if (this._nodeMap.containsKey(id)) {
	                return this._nodeMap.get(id);
	            }
	        },

	        /**
	         * Returns whether the given node or node Id is part of this graph.
	         */
	        hasNode: function (nodeOrId) {
	            var id = nodeOrId.id || nodeOrId;
	            return this._nodeMap.containsKey(id);
	        },

	        _addNode: function(node) {
	            this.nodes.push(node);
	            this._nodeMap.add(node.id, node);
	        },

	        _removeNode: function(node) {
	            Utils.remove(this.nodes, node);
	            this._nodeMap.remove(node.id);
	        },

	        /**
	         * Removes the given node from this graph.
	         * The node can be specified as an object or as an identifier (string).
	         */
	        removeNode: function (nodeOrId) {
	            var n = nodeOrId;
	            if (Utils.isString(nodeOrId)) {
	                n = this.getNode(nodeOrId);
	            }

	            if (Utils.isDefined(n)) {
	                var links = n.links;
	                n.links = [];
	                for (var i = 0, len = links.length; i < len; i++) {
	                    var link = links[i];
	                    this.removeLink(link);
	                }
	                this._removeNode(n);
	            }
	            else {
	                throw "The identifier should be a Node or the Id (string) of a node.";
	            }
	        },

	        /**
	         * Returns whether the given nodes are connected with a least one link independently of the direction.
	         */
	        areConnected: function (n1, n2) {
	            return Utils.any(this.links, function (link) {
	                return link.source == n1 && link.target == n2 || link.source == n2 && link.target == n1;
	            });
	        },

	        /**
	         * Removes the given link from this graph.
	         */
	        removeLink: function (link) {
	            /*    if (!this.links.contains(link)) {
	             throw "The given link is not part of the Graph.";
	             }
	             */
	            Utils.remove(this.links, link);

	            Utils.remove(link.source.outgoing, link);
	            Utils.remove(link.source.links, link);
	            Utils.remove(link.target.incoming, link);
	            Utils.remove(link.target.links, link);
	        },

	        /**
	         * Adds a new node to this graph, if not already present.
	         * The node can be an existing Node or the identifier of a new node.
	         * No error is thrown if the node is already there and the existing one is returned.
	         */
	        addNode: function (nodeOrId, layoutRect, owner) {

	            var newNode = null;

	            if (!Utils.isDefined(nodeOrId)) {
	                throw "No Node or identifier for a new Node is given.";
	            }

	            if (Utils.isString(nodeOrId)) {
	                if (this.hasNode(nodeOrId)) {
	                    return this.getNode(nodeOrId);
	                }
	                newNode = new Node(nodeOrId);
	            }
	            else {
	                if (this.hasNode(nodeOrId)) {
	                    return this.getNode(nodeOrId);
	                }
	                // todo: ensure that the param is a Node?
	                newNode = nodeOrId;
	            }

	            if (Utils.isDefined(layoutRect)) {
	                newNode.bounds(layoutRect);
	            }

	            if (Utils.isDefined(owner)) {
	                newNode.owner = owner;
	            }
	            this._addNode(newNode);
	            return newNode;
	        },

	        /**
	         * Adds the given Node and its outgoing links.
	         */
	        addNodeAndOutgoings: function (node) {
	            if (!this.hasNode(node)) {
	                this._addNode(node);
	            }

	            var newLinks = node.outgoing;
	            node.outgoing = [];
	            Utils.forEach(newLinks, function (link) {
	                this.addExistingLink(link);
	            }, this);
	        },

	        /**
	         * Sets the 'index' property on the links and nodes of this graph.
	         */
	        setItemIndices: function () {
	            var i;
	            for (i = 0; i < this.nodes.length; ++i) {
	                this.nodes[i].index = i;
	            }

	            for (i = 0; i < this.links.length; ++i) {
	                this.links[i].index = i;
	            }
	        },

	        /**
	         * Returns a clone of this graph.
	         */
	        clone: function (saveMapping) {
	            var copy = new Graph();
	            var save = Utils.isDefined(saveMapping) && saveMapping === true;
	            if (save) {
	                copy.nodeMap = new Dictionary();
	                copy.linkMap = new Dictionary();
	            }
	            // we need a map even if the saveMapping is not set
	            var map = new Dictionary();
	            Utils.forEach(this.nodes, function (nOriginal) {
	                var nCopy = nOriginal.clone();
	                map.set(nOriginal, nCopy);
	                copy._addNode(nCopy);

	                if (save) {
	                    copy.nodeMap.set(nCopy, nOriginal);
	                }
	            });

	            Utils.forEach(this.links, function (linkOriginal) {
	                if (map.containsKey(linkOriginal.source) && map.containsKey(linkOriginal.target)) {
	                    var linkCopy = copy.addLink(map.get(linkOriginal.source), map.get(linkOriginal.target));
	                    if (save) {
	                        copy.linkMap.set(linkCopy, linkOriginal);
	                    }
	                }
	            });

	            return copy;
	        },

	        /**
	         * The parsing allows a quick way to create graphs.
	         *  - ["n1->n2", "n2->n3"]: creates the three nodes and adds the links
	         *  - ["n1->n2", {id: "QSDF"}, "n2->n3"]: same as previous but also performs a deep extend of the link between n1 and n2 with the given object.
	         */
	        linearize: function (addIds) {
	            return Graph.Utils.linearize(this, addIds);
	        },

	        /**
	         * Performs a depth-first traversal starting at the given node.
	         * @param startNode a node or id of a node in this graph
	         * @param action
	         */
	        depthFirstTraversal: function (startNode, action) {
	            if (Utils.isUndefined(startNode)) {
	                throw "You need to supply a starting node.";
	            }
	            if (Utils.isUndefined(action)) {
	                throw "You need to supply an action.";
	            }
	            if (!this.hasNode(startNode)) {
	                throw "The given start-node is not part of this graph";
	            }
	            var foundNode = this.getNode(startNode);// case the given one is an Id
	            var visited = [];
	            this._dftIterator(foundNode, action, visited);
	        },

	        _dftIterator: function (node, action, visited) {

	            action(node);
	            visited.push(node);
	            var children = node.getChildren();
	            for (var i = 0, len = children.length; i < len; i++) {
	                var child = children[i];
	                if (contains(visited, child)) {
	                    continue;
	                }
	                this._dftIterator(child, action, visited);
	            }
	        },

	        /**
	         * Performs a breadth-first traversal starting at the given node.
	         * @param startNode a node or id of a node in this graph
	         * @param action
	         */
	        breadthFirstTraversal: function (startNode, action) {

	            if (Utils.isUndefined(startNode)) {
	                throw "You need to supply a starting node.";
	            }
	            if (Utils.isUndefined(action)) {
	                throw "You need to supply an action.";
	            }

	            if (!this.hasNode(startNode)) {
	                throw "The given start-node is not part of this graph";
	            }
	            var foundNode = this.getNode(startNode);// case the given one is an Id
	            var queue = new Queue();
	            var visited = [];
	            queue.enqueue(foundNode);

	            while (queue.length > 0) {
	                var node = queue.dequeue();
	                action(node);
	                visited.push(node);
	                var children = node.getChildren();
	                for (var i = 0, len = children.length; i < len; i++) {
	                    var child = children[i];
	                    if (contains(visited, child) || contains(queue, child)) {
	                        continue;
	                    }
	                    queue.enqueue(child);
	                }
	            }
	        },

	        /**
	         * This is the classic Tarjan algorithm for strongly connected components.
	         * See e.g. http://en.wikipedia.org/wiki/Tarjan's_strongly_connected_components_algorithm
	         * @param excludeSingleItems Whether isolated nodes should be excluded from the analysis.
	         * @param node The start node from which the analysis starts.
	         * @param indices  Numbers the nodes consecutively in the order in which they are discovered.
	         * @param lowLinks The smallest index of any node known to be reachable from the node, including the node itself
	         * @param connected The current component.
	         * @param stack The bookkeeping stack of things to visit.
	         * @param index The counter of visited nodes used to assign the indices.
	         * @private
	         */
	        _stronglyConnectedComponents: function (excludeSingleItems, node, indices, lowLinks, connected, stack, index) {
	            indices.add(node, index);
	            lowLinks.add(node, index);
	            index++;

	            stack.push(node);

	            var children = node.getChildren(), next;
	            for (var i = 0, len = children.length; i < len; i++) {
	                next = children[i];
	                if (!indices.containsKey(next)) {
	                    this._stronglyConnectedComponents(excludeSingleItems, next, indices, lowLinks, connected, stack, index);
	                    lowLinks.add(node, Math.min(lowLinks.get(node), lowLinks.get(next)));
	                }
	                else if (contains(stack, next)) {
	                    lowLinks.add(node, Math.min(lowLinks.get(node), indices.get(next)));
	                }
	            }
	            // If v is a root node, pop the stack and generate a strong component
	            if (lowLinks.get(node) === indices.get(node)) {
	                var component = [];
	                do {
	                    next = stack.pop();
	                    component.push(next);
	                }
	                while (next !== node);
	                if (!excludeSingleItems || (component.length > 1)) {
	                    connected.push(component);
	                }
	            }
	        },

	        /**
	         * Returns the cycles found in this graph.
	         * The returned arrays consist of the nodes which are strongly coupled.
	         * @param excludeSingleItems Whether isolated nodes should be excluded.
	         * @returns {Array} The array of cycles found.
	         */
	        findCycles: function (excludeSingleItems) {
	            if (Utils.isUndefined(excludeSingleItems)) {
	                excludeSingleItems = true;
	            }
	            var indices = new Dictionary();
	            var lowLinks = new Dictionary();
	            var connected = [];
	            var stack = [];
	            for (var i = 0, len = this.nodes.length; i < len; i++) {
	                var node = this.nodes[i];
	                if (indices.containsKey(node)) {
	                    continue;
	                }
	                this._stronglyConnectedComponents(excludeSingleItems, node, indices, lowLinks, connected, stack, 0);
	            }
	            return connected;
	        },

	        /**
	         * Returns whether this graph is acyclic.
	         * @returns {*}
	         */
	        isAcyclic: function () {
	            return Utils.isEmpty(this.findCycles());
	        },

	        /**
	         * Returns whether the given graph is a subgraph of this one.
	         * @param other Another graph instance.
	         */
	        isSubGraph: function (other) {
	            var otherArray = other.linearize();
	            var thisArray = this.linearize();
	            return Utils.all(otherArray, function (s) {
	                return contains(thisArray, s);
	            });
	        },

	        /**
	         *  Makes an acyclic graph from the current (connected) one.
	         * * @returns {Array} The reversed links.
	         */
	        makeAcyclic: function () {
	            // if empty or almost empty
	            if (this.isEmpty() || this.nodes.length <= 1 || this.links.length <= 1) {
	                return [];
	            }
	            // singular case of just two nodes
	            if (this.nodes.length == 2) {
	                var result = [];
	                if (this.links.length > 1) {
	                    var oneLink = this.links[0];
	                    var oneNode = oneLink.source;
	                    for (var i = 0, len = this.links.length; i < len; i++) {
	                        var link = this.links[i];
	                        if (link.source == oneNode) {
	                            continue;
	                        }
	                        var rev = link.reverse();
	                        result.push(rev);
	                    }
	                }
	                return result;
	            }

	            var copy = this.clone(true); // copy.nodeMap tells you the mapping
	            var N = this.nodes.length;

	            var intensityCatalog = new Dictionary();

	            /**
	             * If there are both incoming and outgoing links this will return the flow intensity (out-in).
	             * Otherwise the node acts as a flow source with N specifying the (equal) intensity.
	             * @param node
	             * @returns {number}
	             */
	            var flowIntensity = function (node) {
	                if (node.outgoing.length === 0) {
	                    return (2 - N);
	                }
	                else if (node.incoming.length === 0) {
	                    return (N - 2);
	                }
	                else {
	                    return node.outgoing.length - node.incoming.length;
	                }
	            };

	            /**
	             * Collects the nodes with the same intensity.
	             * @param node
	             * @param intensityCatalog
	             */
	            var catalogEqualIntensity = function (node, intensityCatalog) {
	                var intensity = flowIntensity(node, N);
	                if (!intensityCatalog.containsKey(intensity)) {
	                    intensityCatalog.set(intensity, []);
	                }
	                intensityCatalog.get(intensity).push(node);
	            };

	            Utils.forEach(copy.nodes, function (v) {
	                catalogEqualIntensity(v, intensityCatalog);
	            });

	            var sourceStack = [];
	            var targetStack = [];

	            while (copy.nodes.length > 0) {
	                var source, target, intensity;
	                if (intensityCatalog.containsKey(2 - N)) {
	                    var targets = intensityCatalog.get(2 - N); // nodes without outgoings
	                    while (targets.length > 0) {
	                        target = targets.pop();
	                        for (var li = 0; li < target.links.length; li++) {
	                            var targetLink = target.links[li];
	                            source = targetLink.getComplement(target);
	                            intensity = flowIntensity(source, N);
	                            Utils.remove(intensityCatalog.get(intensity), source);
	                            source.removeLink(targetLink);
	                            catalogEqualIntensity(source, intensityCatalog);
	                        }
	                        copy._removeNode(target);
	                        targetStack.unshift(target);
	                    }
	                }

	                // move sources to sourceStack
	                if (intensityCatalog.containsKey(N - 2)) {
	                    var sources = intensityCatalog.get(N - 2); // nodes without incomings
	                    while (sources.length > 0) {
	                        source = sources.pop();
	                        for (var si = 0; si < source.links.length; si++) {
	                            var sourceLink = source.links[si];
	                            target = sourceLink.getComplement(source);
	                            intensity = flowIntensity(target, N);
	                            Utils.remove(intensityCatalog.get(intensity), target);
	                            target.removeLink(sourceLink);
	                            catalogEqualIntensity(target, intensityCatalog);
	                        }
	                        sourceStack.push(source);
	                        copy._removeNode(source);
	                    }
	                }

	                if (copy.nodes.length > 0) {
	                    for (var k = N - 3; k > 2 - N; k--) {
	                        if (intensityCatalog.containsKey(k) &&
	                            intensityCatalog.get(k).length > 0) {
	                            var maxdiff = intensityCatalog.get(k);
	                            var v = maxdiff.pop();
	                            for (var ri = 0; ri < v.links.length; ri++) {
	                                var ril = v.links[ri];
	                                var u = ril.getComplement(v);
	                                intensity = flowIntensity(u, N);
	                                Utils.remove(intensityCatalog.get(intensity), u);
	                                u.removeLink(ril);
	                                catalogEqualIntensity(u, intensityCatalog);
	                            }
	                            sourceStack.push(v);
	                            copy._removeNode(v);
	                            break;
	                        }
	                    }
	                }
	            }

	            sourceStack = sourceStack.concat(targetStack);

	            var vertexOrder = new Dictionary();
	            for (var kk = 0; kk < this.nodes.length; kk++) {
	                vertexOrder.set(copy.nodeMap.get(sourceStack[kk]), kk);
	            }

	            var reversedEdges = [];
	            Utils.forEach(this.links, function (link) {
	                if (vertexOrder.get(link.source) > vertexOrder.get(link.target)) {
	                    link.reverse();
	                    reversedEdges.push(link);
	                }
	            });
	            return reversedEdges;
	        }
	    });

	    /**
	     * A collection of predefined graphs for demo and testing purposes.
	     */
	    Graph.Predefined = {
	        /**
	         * Eight-shapes graph all connected in a cycle.
	         * @returns {*}
	         * @constructor
	         */
	        EightGraph: function () {
	            return Graph.Utils.parse([ "1->2", "2->3", "3->4", "4->1", "3->5", "5->6", "6->7", "7->3"]);
	        },

	        /**
	         * Creates a typical mindmap diagram.
	         * @returns {*}
	         * @constructor
	         */
	        Mindmap: function () {
	            return Graph.Utils.parse(["0->1", "0->2", "0->3", "0->4", "0->5", "1->6", "1->7", "7->8", "2->9", "9->10", "9->11", "3->12",
	                "12->13", "13->14", "4->15", "4->16", "15->17", "15->18", "18->19", "18->20", "14->21", "14->22", "5->23", "23->24", "23->25", "6->26"]);
	        },

	        /**
	         * Three nodes connected in a cycle.
	         * @returns {*}
	         * @constructor
	         */
	        ThreeGraph: function () {
	            return Graph.Utils.parse([ "1->2", "2->3", "3->1"]);
	        },

	        /**
	         * A tree with each node having two children.
	         * @param levels How many levels the binary tree should have.
	         * @returns {diagram.Graph}
	         * @constructor
	         */
	        BinaryTree: function (levels) {
	            if (Utils.isUndefined(levels)) {
	                levels = 5;
	            }
	            return Graph.Utils.createBalancedTree(levels, 2);
	        },

	        /**
	         * A linear graph (discrete line segment).
	         * @param length How many segments (the node count is hence (length+1)).
	         * @returns {diagram.Graph}
	         * @constructor
	         */
	        Linear: function (length) {
	            if (Utils.isUndefined(length)) {
	                length = 10;
	            }
	            return Graph.Utils.createBalancedTree(length, 1);
	        },

	        /**
	         * A standard tree-graph with the specified levels and children (siblings) count.
	         * Note that for a balanced tree of level N and sibling count s, counting the root as level zero:
	         *  - NodeCount = (1-s^(N+1))/(1-s)]
	         *  - LinkCount = s.(1-s^N)/(1-s)
	         * @param levels How many levels the tree should have.
	         * @param siblingsCount How many siblings each level should have.
	         * @returns {diagram.Graph}
	         * @constructor
	         */
	        Tree: function (levels, siblingsCount) {
	            return Graph.Utils.createBalancedTree(levels, siblingsCount);
	        },

	        /**
	         * Creates a forest.
	         * Note that for a balanced forest of level N, sibling count s and tree count t, counting the root as level zero:
	         *  - NodeCount = t.(1-s^(N+1))/(1-s)]
	         *  - LinkCount = t.s.(1-s^N)/(1-s)
	         * @param levels How many levels the tree should have.
	         * @param siblingsCount How many siblings each level should have.
	         * @param trees The amount of trees the forest should have.
	         * @returns {diagram.Graph}
	         * @constructor
	         */
	        Forest: function (levels, siblingsCount, trees) {
	            return Graph.Utils.createBalancedForest(levels, siblingsCount, trees);
	        },

	        /**
	         * A workflow-like graph with cycles.
	         * @returns {*}
	         * @constructor
	         */
	        Workflow: function () {
	            return Graph.Utils.parse(
	                ["0->1", "1->2", "2->3", "1->4", "4->3", "3->5", "5->6", "6->3", "6->7", "5->4"]
	            );
	        },

	        /**
	         * A grid graph with the direction of the links avoiding cycles.
	         * Node count: (n+1).(m+1)
	         * Link count: n.(m+1) + m.(n+1)
	         * @param n Horizontal count of grid cells. If zero this will result in a linear graph.
	         * @param m Vertical count of grid cells. If zero this will result in a linear graph.
	         * @constructor
	         */
	        Grid: function (n, m) {
	            var g = new diagram.Graph();
	            if (n <= 0 && m <= 0) {
	                return g;
	            }

	            for (var i = 0; i < n + 1; i++) {
	                var previous = null;
	                for (var j = 0; j < m + 1; j++) {
	                    // using x-y coordinates to name the nodes
	                    var node = new Node(i.toString() + "." + j.toString());
	                    g.addNode(node);
	                    if (previous) {
	                        g.addLink(previous, node);
	                    }
	                    if (i > 0) {
	                        var left = g.getNode((i - 1).toString() + "." + j.toString());
	                        g.addLink(left, node);
	                    }
	                    previous = node;
	                }
	            }
	            return g;
	        }

	    };

	    /**
	     * Graph generation and other utilities.
	     */
	    Graph.Utils = {
	        /**
	         * The parsing allows a quick way to create graphs.
	         *  - ["n1->n2", "n2->n3"]: creates the three nodes and adds the links
	         *  - ["n1->n2", {id: "id177"}, "n2->n3"]: same as previous but also performs a deep extend of the link between n1 and n2 with the given object.
	         */
	        parse: function (graphString) {

	            var previousLink, graph = new diagram.Graph(), parts = graphString.slice();
	            for (var i = 0, len = parts.length; i < len; i++) {
	                var part = parts[i];
	                if (Utils.isString(part)) // link spec
	                {
	                    if (part.indexOf("->") < 0) {
	                        throw "The link should be specified as 'a->b'.";
	                    }
	                    var p = part.split("->");
	                    if (p.length != 2) {
	                        throw "The link should be specified as 'a->b'.";
	                    }
	                    previousLink = new Link(p[0], p[1]);
	                    graph.addLink(previousLink);
	                }
	                if (Utils.isObject(part)) {
	                    if (!previousLink) {
	                        throw "Specification found before Link definition.";
	                    }
	                    kendo.deepExtend(previousLink, part);
	                }
	            }
	            return graph;
	        },

	        /**
	         * Returns a linearized representation of the given Graph.
	         * See also the Graph.Utils.parse method for the inverse operation.
	         */
	        linearize: function (graph, addIds) {
	            if (Utils.isUndefined(graph)) {
	                throw "Expected an instance of a Graph object in slot one.";
	            }
	            if (Utils.isUndefined(addIds)) {
	                addIds = false;
	            }
	            var lin = [];
	            for (var i = 0, len = graph.links.length; i < len; i++) {
	                var link = graph.links[i];
	                lin.push(link.source.id + "->" + link.target.id);
	                if (addIds) {
	                    lin.push({id: link.id});
	                }
	            }
	            return lin;
	        },

	        /**
	         * The method used by the diagram creation to instantiate a shape.
	         * @param kendoDiagram The Kendo diagram where the diagram will be created.
	         * @param p The position at which to place the shape.
	         * @param shapeDefaults Optional Shape options.
	         * @param id Optional identifier of the shape.
	         * @returns {*}
	         * @private
	         */
	        _addShape: function (kendoDiagram, p, id, shapeDefaults) {
	            if (Utils.isUndefined(p)) {
	                p = new diagram.Point(0, 0);
	            }

	            if (Utils.isUndefined(id)) {
	                id = randomId();
	            }

	            shapeDefaults = kendo.deepExtend({
	                width: 20,
	                height: 20,
	                id: id,
	                radius: 10,
	                fill: "#778899",
	                data: "circle",
	                undoable: false,
	                x: p.x,
	                y: p.y
	            }, shapeDefaults);

	            return kendoDiagram.addShape(shapeDefaults);
	        },
	        /**
	         * The method used by the diagram creation to instantiate a connection.
	         * @param diagram he Kendo diagram where the diagram will be created.
	         * @param from The source shape.
	         * @param to The target shape.
	         * @param options Optional Connection options.
	         * @returns {*}
	         * @private
	         */
	        _addConnection: function (diagram, from, to, options) {
	            return diagram.connect(from, to, options);
	        },

	        /**
	         * Creates a diagram from the given Graph.
	         * @param diagram The Kendo diagram where the diagram will be created.
	         * @param graph The graph structure defining the diagram.
	         */
	        createDiagramFromGraph: function (diagram, graph, doLayout, randomSize) {

	            if (Utils.isUndefined(diagram)) {
	                throw "The diagram surface is undefined.";
	            }
	            if (Utils.isUndefined(graph)) {
	                throw "No graph specification defined.";
	            }
	            if (Utils.isUndefined(doLayout)) {
	                doLayout = true;
	            }
	            if (Utils.isUndefined(randomSize)) {
	                randomSize = false;
	            }

	            var width = diagram.element.clientWidth || 200;
	            var height = diagram.element.clientHeight || 200;
	            var map = [], node, shape;
	            for (var i = 0, len = graph.nodes.length; i < len; i++) {
	                node = graph.nodes[i];
	                var p = node.position;
	                if (Utils.isUndefined(p)) {
	                    if (Utils.isDefined(node.x) && Utils.isDefined(node.y)) {
	                        p = new Point(node.x, node.y);
	                    }
	                    else {
	                        p = new Point(Utils.randomInteger(10, width - 20), Utils.randomInteger(10, height - 20));
	                    }
	                }
	                var opt = {};

	                if (node.id === "0") {
	                    /* kendo.deepExtend(opt,
	                     {
	                     fill: "Orange",
	                     data: 'circle',
	                     width: 100,
	                     height: 100,
	                     center: new Point(50, 50)
	                     });*/
	                }
	                else if (randomSize) {
	                    kendo.deepExtend(opt, {
	                        width: Math.random() * 150 + 20,
	                        height: Math.random() * 80 + 50,
	                        data: 'rectangle',
	                        fill: {
	                            color: "#778899"
	                        }
	                    });
	                }

	                shape = this._addShape(diagram, p, node.id, opt);
	                //shape.content(node.id);

	                var bounds = shape.bounds();
	                if (Utils.isDefined(bounds)) {
	                    node.x = bounds.x;
	                    node.y = bounds.y;
	                    node.width = bounds.width;
	                    node.height = bounds.height;
	                }
	                map[node.id] = shape;
	            }
	            for (var gli = 0; gli < graph.links.length; gli++) {
	                var link = graph.links[gli];
	                var sourceShape = map[link.source.id];
	                if (Utils.isUndefined(sourceShape)) {
	                    continue;
	                }
	                var targetShape = map[link.target.id];
	                if (Utils.isUndefined(targetShape)) {
	                    continue;
	                }
	                this._addConnection(diagram, sourceShape, targetShape, {id: link.id});

	            }
	            if (doLayout) {
	                var l = new diagram.SpringLayout(diagram);
	                l.layoutGraph(graph, {limitToView: false});
	                for (var shi = 0; shi < graph.nodes.length; shi++) {
	                    node = graph.nodes[shi];
	                    shape = map[node.id];
	                    shape.bounds(new Rect(node.x, node.y, node.width, node.height));
	                }
	            }
	        },

	        /**
	         * Creates a balanced tree with the specified number of levels and siblings count.
	         * Note that for a balanced tree of level N and sibling count s, counting the root as level zero:
	         *  - NodeCount = (1-s^(N+1))/(1-s)]
	         *  - LinkCount = s.(1-s^N)/(1-s)
	         * @param levels How many levels the tree should have.
	         * @param siblingsCount How many siblings each level should have.
	         * @returns {diagram.Graph}
	         */
	        createBalancedTree: function (levels, siblingsCount) {
	            if (Utils.isUndefined(levels)) {
	                levels = 3;
	            }
	            if (Utils.isUndefined(siblingsCount)) {
	                siblingsCount = 3;
	            }

	            var g = new diagram.Graph(), counter = -1, lastAdded = [], news;
	            if (levels <= 0 || siblingsCount <= 0) {
	                return g;
	            }
	            var root = new Node((++counter).toString());
	            g.addNode(root);
	            g.root = root;
	            lastAdded.push(root);
	            for (var i = 0; i < levels; i++) {
	                news = [];
	                for (var j = 0; j < lastAdded.length; j++) {
	                    var parent = lastAdded[j];
	                    for (var k = 0; k < siblingsCount; k++) {
	                        var item = new Node((++counter).toString());
	                        g.addLink(parent, item);
	                        news.push(item);
	                    }
	                }
	                lastAdded = news;
	            }
	            return g;
	        },

	        /**
	         * Creates a balanced tree with the specified number of levels and siblings count.
	         * Note that for a balanced forest of level N, sibling count s and tree count t, counting the root as level zero:
	         *  - NodeCount = t.(1-s^(N+1))/(1-s)]
	         *  - LinkCount = t.s.(1-s^N)/(1-s)
	         * @param levels How many levels the tree should have.
	         * @param siblingsCount How many siblings each level should have.
	         * @returns {diagram.Graph}
	         * @param treeCount The number of trees the forest should have.
	         */
	        createBalancedForest: function (levels, siblingsCount, treeCount) {
	            if (Utils.isUndefined(levels)) {
	                levels = 3;
	            }
	            if (Utils.isUndefined(siblingsCount)) {
	                siblingsCount = 3;
	            }
	            if (Utils.isUndefined(treeCount)) {
	                treeCount = 5;
	            }
	            var g = new diagram.Graph(), counter = -1, lastAdded = [], news;
	            if (levels <= 0 || siblingsCount <= 0 || treeCount <= 0) {
	                return g;
	            }

	            for (var t = 0; t < treeCount; t++) {
	                var root = new Node((++counter).toString());
	                g.addNode(root);
	                lastAdded = [root];
	                for (var i = 0; i < levels; i++) {
	                    news = [];
	                    for (var j = 0; j < lastAdded.length; j++) {
	                        var parent = lastAdded[j];
	                        for (var k = 0; k < siblingsCount; k++) {
	                            var item = new Node((++counter).toString());
	                            g.addLink(parent, item);
	                            news.push(item);
	                        }
	                    }
	                    lastAdded = news;
	                }
	            }
	            return g;
	        },

	        /**
	         * Creates a random graph (uniform distribution) with the specified amount of nodes.
	         * @param nodeCount The amount of nodes the random graph should have.
	         * @param maxIncidence The maximum allowed degree of the nodes.
	         * @param isTree Whether the return graph should be a tree (default: false).
	         * @returns {diagram.Graph}
	         */
	        createRandomConnectedGraph: function (nodeCount, maxIncidence, isTree) {

	            /* Swa's Mathematica export of random Bernoulli graphs
	             gr[n_,p_]:=Module[{g=RandomGraph[BernoulliGraphDistribution[n,p],VertexLabels->"Name",DirectedEdges->True]},
	             While[Not[ConnectedGraphQ[g]],g=RandomGraph[BernoulliGraphDistribution[n,p],VertexLabels->"Name",DirectedEdges->True]];g];
	             project[a_]:=("\""<>ToString[Part[#,1]]<>"->"<>ToString[Part[#,2]]<>"\"")&     @ a;
	             export[g_]:=project/@ EdgeList[g]
	             g = gr[12,.1]
	             export [g]
	             */

	            if (Utils.isUndefined(nodeCount)) {
	                nodeCount = 40;
	            }
	            if (Utils.isUndefined(maxIncidence)) {
	                maxIncidence = 4;
	            }
	            if (Utils.isUndefined(isTree)) {
	                isTree = false;
	            }

	            var g = new diagram.Graph(), counter = -1;
	            if (nodeCount <= 0) {
	                return g;
	            }

	            var root = new Node((++counter).toString());
	            g.addNode(root);
	            if (nodeCount === 1) {
	                return g;
	            }
	            if (nodeCount > 1) {
	                // random tree
	                for (var i = 1; i < nodeCount; i++) {
	                    var poolNode = g.takeRandomNode([], maxIncidence);
	                    if (!poolNode) {
	                        //failed to find one so the graph will have less nodes than specified
	                        break;
	                    }
	                    var newNode = g.addNode(i.toString());
	                    g.addLink(poolNode, newNode);
	                }
	                if (!isTree && nodeCount > 1) {
	                    var randomAdditions = Utils.randomInteger(1, nodeCount);
	                    for (var ri = 0; ri < randomAdditions; ri++) {
	                        var n1 = g.takeRandomNode([], maxIncidence);
	                        var n2 = g.takeRandomNode([], maxIncidence);
	                        if (n1 && n2 && !g.areConnected(n1, n2)) {
	                            g.addLink(n1, n2);
	                        }
	                    }
	                }
	                return g;
	            }
	        },

	        /**
	         * Generates a random diagram.
	         * @param diagram The host diagram.
	         * @param shapeCount The number of shapes the random diagram should contain.
	         * @param maxIncidence The maximum degree the shapes can have.
	         * @param isTree Whether the generated diagram should be a tree
	         * @param layoutType The optional layout type to apply after the diagram is generated.
	         */
	        randomDiagram: function (diagram, shapeCount, maxIncidence, isTree, randomSize) {
	            var g = kendo.dataviz.diagram.Graph.Utils.createRandomConnectedGraph(shapeCount, maxIncidence, isTree);
	            Graph.Utils.createDiagramFromGraph(diagram, g, false, randomSize);
	        }
	    };

	    kendo.deepExtend(diagram, {
	        init: function (element) {
	            kendo.init(element, diagram.ui);
	        },

	        Point: Point,
	        Intersect: Intersect,
	        Geometry: Geometry,
	        Rect: Rect,
	        Size: Size,
	        RectAlign: RectAlign,
	        Matrix: Matrix,
	        MatrixVector: MatrixVector,
	        normalVariable: normalVariable,
	        randomId: randomId,
	        Dictionary: Dictionary,
	        HashTable: HashTable,
	        Queue: Queue,
	        Set: Set,
	        Node: Node,
	        Link: Link,
	        Graph: Graph,
	        PathDefiner: PathDefiner
	    });
	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 904:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("JHp9");

/***/ })

/******/ });

/***/ }),

/***/ "f1E8":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1077);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1077:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1078) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "calendar",
	    name: "Calendar",
	    category: "web",
	    description: "The Calendar widget renders a graphical calendar that supports navigation and selection.",
	    depends: [ "core", "selectable" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        support = kendo.support,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        keys = kendo.keys,
	        parse = kendo.parseDate,
	        adjustDST = kendo.date.adjustDST,
	        weekInYear = kendo.date.weekInYear,
	        Selectable = kendo.ui.Selectable,
	        extractFormat = kendo._extractFormat,
	        template = kendo.template,
	        getCulture = kendo.getCulture,
	        transitions = kendo.support.transitions,
	        transitionOrigin = transitions ? transitions.css + "transform-origin" : "",
	        cellTemplate = template('<td#=data.cssClass# role="gridcell"><a tabindex="-1" class="k-link" href="\\#" data-#=data.ns#value="#=data.dateString#">#=data.value#</a></td>', { useWithBlock: false }),
	        emptyCellTemplate = template('<td role="gridcell" class="k-out-of-range"><a class="k-link"></a></td>', { useWithBlock: false }),
	        otherMonthCellTemplate = template('<td role="gridcell" class="k-out-of-range">&nbsp;</td>', { useWithBlock: false }),
	        weekNumberTemplate = template('<td class="k-alt">#= data.weekNumber #</td>', { useWithBlock: false }),
	        browser = kendo.support.browser,
	        isIE8 = browser.msie && browser.version < 9,
	        outerWidth = kendo._outerWidth,
	        ns = ".kendoCalendar",
	        CLICK = "click" + ns,
	        KEYDOWN_NS = "keydown" + ns,
	        ID = "id",
	        MIN = "min",
	        LEFT = "left",
	        SLIDE = "slideIn",
	        MONTH = "month",
	        CENTURY = "century",
	        CHANGE = "change",
	        NAVIGATE = "navigate",
	        VALUE = "value",
	        HOVER = "k-state-hover",
	        DISABLED = "k-state-disabled",
	        FOCUSED = "k-state-focused",
	        OTHERMONTH = "k-other-month",
	        OTHERMONTHCLASS = ' class="' + OTHERMONTH + '"',
	        OUTOFRANGE = "k-out-of-range",
	        TODAY = "k-nav-today",
	        CELLSELECTOR = "td:has(.k-link)",
	        CELLSELECTORVALID = "td:has(.k-link):not(." + DISABLED + "):not(." + OUTOFRANGE + ")",
	        WEEKCOLUMNSELECTOR = "td:not(:has(.k-link))",
	        SELECTED = "k-state-selected",
	        BLUR = "blur" + ns,
	        FOCUS = "focus",
	        FOCUS_WITH_NS = FOCUS + ns,
	        MOUSEENTER = support.touch ? "touchstart" : "mouseenter",
	        MOUSEENTER_WITH_NS = support.touch ? "touchstart" + ns : "mouseenter" + ns,
	        MOUSELEAVE = support.touch ? "touchend" + ns + " touchmove" + ns : "mouseleave" + ns,
	        MS_PER_MINUTE = 60000,
	        MS_PER_DAY = 86400000,
	        PREVARROW = "_prevArrow",
	        NEXTARROW = "_nextArrow",
	        ARIA_DISABLED = "aria-disabled",
	        ARIA_SELECTED = "aria-selected",
	        ARIA_LABEL = "aria-label",
	        proxy = $.proxy,
	        extend = $.extend,
	        DATE = Date,
	        views = {
	            month: 0,
	            year: 1,
	            decade: 2,
	            century: 3
	        },
	        HEADERSELECTOR = '.k-header, .k-calendar-header',
	        CLASSIC_HEADER_TEMPLATE = '<div class="k-header">' +
	            '<a href="\\#" #=actionAttr#="prev" role="button" class="k-link k-nav-prev" ' + ARIA_LABEL + '="Previous"><span class="k-icon k-i-arrow-60-left"></span></a>' +
	            '<a href="\\#" #=actionAttr#="nav-up" role="button" aria-live="assertive" aria-atomic="true" class="k-link k-nav-fast"></a>' +
	            '<a href="\\#" #=actionAttr#="next" role="button" class="k-link k-nav-next" ' + ARIA_LABEL + '="Next"><span class="k-icon k-i-arrow-60-right"></span></a>' +
	        '</div>',
	        MODERN_HEADER_TEMPLATE = '<div class="k-calendar-header">' +
	            '<a href="\\#" #=actionAttr#="nav-up" role="button" aria-live="assertive" aria-atomic="true" class="k-button k-title"></a>' +
	            '<span class="k-calendar-nav">' +
	                '<a #=actionAttr#="prev" class="k-button k-button-icon k-prev-view">' +
	                    '<span class="k-icon k-i-arrow-60-left"></span>' +
	                '</a>' +
	                '<a #=actionAttr#="today" class="k-today">#=messages.today#</a>' +
	                '<a #=actionAttr#="next" class="k-button k-button-icon k-next-view">' +
	                    '<span class="k-icon k-i-arrow-60-right"></span>' +
	                '</a>' +
	            '</span>' +
	        '</div>';

	    var Calendar = Widget.extend({
	        init: function(element, options) {
	            var that = this, value, id;
	            options = options || {};
	            options.componentType = options.componentType || "classic";
	            Widget.fn.init.call(that, element, options);

	            element = that.wrapper = that.element;
	            options = that.options;

	            options.url = kendo.unescape(options.url);

	            that.options.disableDates = getDisabledExpr(that.options.disableDates);

	            that._templates();

	            that._selectable();

	            that._header();

	            that._viewWrapper();

	            if (that.options.hasFooter) {
	                that._footer(that.footer);
	            }

	            id = element
	                    .addClass("k-widget k-calendar " + (options.weekNumber ? " k-week-number" : ""))
	                    .on(MOUSEENTER_WITH_NS + " " + MOUSELEAVE, CELLSELECTOR, mousetoggle)
	                    .on(KEYDOWN_NS, "table.k-content", proxy(that._move, that))
	                    .on(CLICK + " touchend", CELLSELECTOR, function(e) {
	                        var link = e.currentTarget.firstChild,
	                            value = toDateObject(link);

	                        if (link.href.indexOf("#") != -1) {
	                            e.preventDefault();
	                        }

	                        if (that._view.name == "month" && that.options.disableDates(value)) {
	                            return;
	                        }
	                        if(that._view.name != "month" || options.selectable == "single") {
	                             that._click($(link));
	                        }
	                    })
	                    .on("mouseup" + ns, "table.k-content, .k-footer", function() {
	                        that._focusView(that.options.focusOnNav !== false);
	                    })
	                    .attr(ID);

	            if (id) {
	                that._cellID = id + "_cell_selected";
	            }

	            if(that._isMultipleSelection() && that.options.weekNumber) {
	                element.on(CLICK, WEEKCOLUMNSELECTOR, function(e) {
	                        var first = $(e.currentTarget).closest("tr").find(CELLSELECTORVALID).first(),
	                            last = that.selectable._lastActive = $(e.currentTarget).closest("tr").find(CELLSELECTORVALID).last();
	                        that.selectable.selectRange(first, last, { event: e});
	                        that._current = that._value = toDateObject(last.find("a"));
	                        that._class(FOCUSED, that._current);
	                });
	            }

	            normalize(options);
	            value = parse(options.value, options.format, options.culture);
	            that._selectDates = [];

	            that._index = views[options.start];

	            that._current = new DATE(+restrictValue(value, options.min, options.max));

	            that._addClassProxy = function() {
	                that._active = true;

	                if (that._cell.hasClass(DISABLED)) {
	                    var todayString = that._view.toDateString(getToday());
	                    that._cell = that._cellByDate(todayString);
	                }

	                that._cell.addClass(FOCUSED);
	            };

	            that._removeClassProxy = function() {
	                that._active = false;
	                that._cell.removeClass(FOCUSED);
	            };

	            that.value(value);

	            if(that._isMultipleSelection() && options.selectDates.length > 0) {
	                that.selectDates(options.selectDates);
	            }
	            kendo.notify(that);
	        },

	        options: {
	            name: "Calendar",
	            value: null,
	            min: new DATE(1900, 0, 1),
	            max: new DATE(2099, 11, 31),
	            dates: [],
	            disableDates: null,
	            url: "",
	            culture: "",
	            footer : "",
	            format : "",
	            month : {},
	            weekNumber: false,
	            selectable: "single",
	            selectDates: [],
	            start: MONTH,
	            depth: MONTH,
	            animation: {
	                horizontal: {
	                    effects: SLIDE,
	                    reverse: true,
	                    duration: 500,
	                    divisor: 2
	                },
	                vertical: {
	                    effects: "zoomIn",
	                    duration: 400
	                }
	            },
	            messages: {
	                weekColumnHeader: "",
	                today: "Today"
	            },
	            componentType: "classic"
	        },

	        events: [
	            CHANGE,
	            NAVIGATE
	        ],

	        componentTypes: {
	            "classic": {
	                header: {
	                    template: CLASSIC_HEADER_TEMPLATE
	                },
	                hasFooter: true,
	                linksSelector: ".k-link",
	                contentClasses: "k-content"
	            },
	            "modern": {
	                header: {
	                    template: MODERN_HEADER_TEMPLATE
	                },
	                hasFooter: false,
	                linksSelector: ".k-button",
	                contentClasses: "k-content k-calendar-content"
	            }
	        },

	        setOptions: function(options) {
	            var that = this;

	            normalize(options);

	            options.disableDates = getDisabledExpr(options.disableDates);
	            that._destroySelectable();

	            Widget.fn.setOptions.call(that, options);

	            that._templates();

	            that._selectable();

	            that._viewWrapper();

	            if (that.options.hasFooter) {
	                that._footer(that.footer);
	            } else {
	                that.element.find(".k-footer").hide();
	            }
	            that._index = views[that.options.start];

	            that.navigate();

	            if(options.weekNumber) {
	                that.element.addClass('k-week-number');
	            }
	        },

	        destroy: function() {
	            var that = this,
	            today = that._today;

	            that.element.off(ns);
	            that._title.off(ns);
	            that[PREVARROW].off(ns);
	            that[NEXTARROW].off(ns);
	            that._destroySelectable();
	            kendo.destroy(that._table);

	            if (today) {
	                kendo.destroy(today.off(ns));
	            }

	            Widget.fn.destroy.call(that);
	        },

	        current: function() {
	            return this._current;
	        },

	        view: function() {
	            return this._view;
	        },

	        focus: function(table) {
	            table = table || this._table;
	            this._bindTable(table);
	            table.trigger("focus");
	        },

	        min: function(value) {
	            return this._option(MIN, value);
	        },

	        max: function(value) {
	            return this._option("max", value);
	        },

	        navigateToPast: function() {
	            this._navigate(PREVARROW, -1);
	        },

	        navigateToFuture: function() {
	            this._navigate(NEXTARROW, 1);
	        },

	        navigateUp: function() {
	            var that = this,
	            index = that._index;

	            if (that._title.hasClass(DISABLED)) {
	                return;
	            }

	            that.navigate(that._current, ++index);
	        },

	        navigateDown: function(value) {
	            var that = this,
	            index = that._index,
	            depth = that.options.depth;

	            if (!value) {
	                return;
	            }

	            if (index === views[depth]) {
	                if (!isEqualDate(that._value, that._current) || !isEqualDate(that._value, value)) {
	                    that.value(value);
	                    that.trigger(CHANGE);
	                }
	                return;
	            }

	            that.navigate(value, --index);
	        },

	        navigate: function(value, view) {
	            view = isNaN(view) ? views[view] : view;

	            var that = this,
	                options = that.options,
	                culture = options.culture,
	                min = options.min,
	                max = options.max,
	                title = that._title,
	                from = that._table,
	                old = that._oldTable,
	                currentValue = that._current,
	                future = value && +value > +currentValue,
	                vertical = view !== undefined && view !== that._index,
	                to, currentView, compare,
	                disabled,
	                viewWrapper = that.element.children(".k-calendar-view");

	            if (!value) {
	                value = currentValue;
	            }

	            that._current = value = new DATE(+restrictValue(value, min, max));

	            if (view === undefined) {
	                view = that._index;
	            } else {
	                that._index = view;
	            }

	            that._view = currentView = calendar.views[view];
	            compare = currentView.compare;

	            disabled = view === views[CENTURY];
	            title.toggleClass(DISABLED, disabled).attr(ARIA_DISABLED, disabled);

	            disabled = compare(value, min) < 1;
	            that[PREVARROW].toggleClass(DISABLED, disabled).attr(ARIA_DISABLED, disabled);
	            if (that[PREVARROW].hasClass(DISABLED)) {
	                that[PREVARROW].removeClass(HOVER);
	            }

	            disabled = compare(value, max) > -1;
	            that[NEXTARROW].toggleClass(DISABLED, disabled).attr(ARIA_DISABLED, disabled);
	            if (that[NEXTARROW].hasClass(DISABLED)) {
	                that[NEXTARROW].removeClass(HOVER);
	            }

	            if (from && old && old.data("animating")) {
	                old.kendoStop(true, true);
	                from.kendoStop(true, true);
	            }

	            that._oldTable = from;

	            if (!from || that._changeView) {
	                title.html(currentView.title(value, min, max, culture));

	                that._table = to = $(currentView.content(extend({
	                    min: min,
	                    max: max,
	                    date: value,
	                    url: options.url,
	                    dates: options.dates,
	                    format: options.format,
	                    otherMonth : true,
	                    culture: culture,
	                    disableDates: options.disableDates,
	                    isWeekColumnVisible: options.weekNumber,
	                    messages: options.messages,
	                    contentClasses: that.options.contentClasses
	                }, that[currentView.name])));

	                addClassToViewContainer(to, currentView.name);
	                makeUnselectable(to);
	                var replace = from && from.data("start") === to.data("start");
	                that._animate({
	                    from: from,
	                    to: to,
	                    vertical: vertical,
	                    future: future,
	                    replace: replace
	                });

	                if(that.options.componentType === "modern"){
	                    viewWrapper.removeClass("k-calendar-monthview k-calendar-yearview k-calendar-decadeview k-calendar-centuryview");
	                    viewWrapper.addClass("k-calendar-" + currentView.name + "view");
	                }

	                that.trigger(NAVIGATE);

	                that._focus(value);
	            }

	            if (view === views[options.depth] && that._selectDates.length > 0) {
	                that._visualizeSelectedDatesInView();
	            }

	            if(that.options.selectable === "single") {
	                if (view === views[options.depth] && that._value && !that.options.disableDates(that._value)) {
	                    that._class("k-state-selected", that._value);
	                }
	            }

	            that._class(FOCUSED, value);

	            if (!from && that._cell) {
	                that._cell.removeClass(FOCUSED);
	            }

	            that._changeView = true;
	        },

	        selectDates: function(dates) {
	            var that = this,
	                validSelectedDates,
	                datesUnique;

	            if(dates === undefined) {
	                return that._selectDates;
	            }

	            datesUnique = dates
	                .map(function (date) { return date.getTime(); })
	                .filter(function (date, position, array) {
	                    return array.indexOf(date) === position;
	                })
	                .map(function (time) { return new Date(time); });

	            validSelectedDates = $.grep(datesUnique, function(value) {
	                if(value) {
	                    return +that._validateValue(new Date(value.setHours(0, 0, 0, 0))) === +value;
	                }
	            });
	            that._selectDates = validSelectedDates.length > 0 ? validSelectedDates : (datesUnique.length === 0 ? datesUnique : that._selectDates);
	            that._visualizeSelectedDatesInView();
	        },

	        value: function(value) {
	            var that = this,
	                old = that._view,
	                view = that._view;

	            if (value === undefined) {
	                return that._value;
	            }

	            value = that._validateValue(value);
	            if (value && that._isMultipleSelection()) {
	                var date = new Date(+value);
	                date.setHours(0, 0, 0, 0);
	                that._selectDates = [date];
	                that.selectable._lastActive = null;
	            }
	            if (old && value === null && that._cell) {
	                that._cell.removeClass(SELECTED);
	            } else {
	                that._changeView = !value || view && view.compare(value, that._current) !== 0;
	                that.navigate(value);
	            }
	        },

	        _validateValue: function(value) {
	            var that = this,
	                options = that.options,
	                min = options.min,
	                max = options.max;

	            if (value === null) {
	                that._current = createDate(that._current.getFullYear(), that._current.getMonth(), that._current.getDate());
	            }

	            value = parse(value, options.format, options.culture);

	            if (value !== null) {
	                value = new DATE(+value);

	                if (!isInRange(value, min, max)) {
	                    value = null;
	                }
	            }

	            if (value === null || !that.options.disableDates(new Date(+value))) {
	                that._value = value;
	            } else if (that._value === undefined) {
	                that._value = null;
	            }

	            return that._value;
	        },

	        _visualizeSelectedDatesInView: function() {
	            var that = this;
	             var selectedDates = {};
	            $.each(that._selectDates, function(index, value) {
	                selectedDates[kendo.calendar.views[0].toDateString(value)] = value;
	            });
	            that.selectable.clear();
	             var cells = that._table
	                .find(CELLSELECTOR)
	                .filter(function(index, element) {
	                    return selectedDates[$(element.firstChild).attr(kendo.attr(VALUE))];
	                });
	            if(cells.length > 0) {
	                that.selectable._selectElement(cells, true);
	            }
	        },

	        _isMultipleSelection: function() {
	            var that = this;
	            return that.options.selectable === "multiple";
	        },

	        _selectable: function() {
	            var that = this;
	            if(!that._isMultipleSelection()) {
	                return;
	            }

	            var selectable = that.options.selectable,
	            selectableOptions = Selectable.parseOptions(selectable);

	            if (selectableOptions.multiple) {
	                that.element.attr("aria-multiselectable", "true");
	            }
	            that.selectable = new Selectable(that.wrapper, {
	                aria: true,
	                //excludes the anchor element
	                inputSelectors: "input,textarea,.k-multiselect-wrap,select,button,.k-button>span,.k-button>img,span.k-icon.k-i-arrow-60-down,span.k-icon.k-i-arrow-60-up",
	                multiple: selectableOptions.multiple,
	                filter: "table.k-month:eq(0) " + CELLSELECTORVALID,
	                change: proxy(that._onSelect, that),
	                relatedTarget: proxy(that._onRelatedTarget, that)
	            });
	        },

	        _onRelatedTarget: function(target) {
	            var that = this;

	            if(that.selectable.options.multiple && target.is(CELLSELECTORVALID)) {
	                that._current = toDateObject(target.find("a"));
	                that._class(FOCUSED, toDateObject(target.find("a")));
	            }

	        },

	        _onSelect: function(e) {
	            var that = this,
	                eventArgs = e,
	                selectableOptions = Selectable.parseOptions(that.options.selectable);

	            if(!selectableOptions.multiple) {
	                if($(eventArgs.event.currentTarget).is("td") && !$(eventArgs.event.currentTarget).hasClass("k-state-selected")) {
	                    $(eventArgs.event.currentTarget).addClass("k-state-selected");
	                }
	                else {
	                    that._click($(eventArgs.event.currentTarget).find("a"));
	                }
	                return;
	            }

	            if(eventArgs.event.ctrlKey || eventArgs.event.metaKey) {
	                if($(eventArgs.event.currentTarget).is(CELLSELECTORVALID)) {
	                    that._toggleSelection($(eventArgs.event.currentTarget));
	                }
	                else {
	                    that._cellsBySelector(CELLSELECTORVALID).each(function(index, element){
	                        var value = toDateObject($(element).find("a"));
	                        that._deselect(value);
	                    });
	                    that._addSelectedCellsToArray();
	                }
	            }
	            else if (eventArgs.event.shiftKey) {
	                that._rangeSelection(that._cell);
	            }
	            else if($(eventArgs.event.currentTarget).is(CELLSELECTOR)) {
	                that.value(toDateObject($(eventArgs.event.currentTarget).find("a")));
	            }
	            else {
	                that._selectDates = [];
	                that._addSelectedCellsToArray();
	            }
	             that.trigger(CHANGE);
	        },

	        _destroySelectable: function() {
	            var that = this;

	            if (that.selectable) {
	                that.selectable.destroy();
	                that.selectable = null;
	            }
	        },

	        //when ctrl key is clicked
	        _toggleSelection: function(currentCell) {
	            var that = this,
	                date = toDateObject(currentCell.find("a"));
	                if(currentCell.hasClass("k-state-selected")) {
	                    that._selectDates.push(date);
	                }
	                else {
	                    that._deselect(date);
	                }
	        },

	        //shift selection
	        _rangeSelection: function(toDateCell, startDate) {
	            var that = this,
	                fromDate  = startDate || toDateObject(that.selectable.value().first().find("a")),
	                toDate = toDateObject(toDateCell.find("a")),
	                daysDifference;

	            if(that.selectable._lastActive || that._value) {
	                fromDate = that.selectable._lastActive? toDateObject(that.selectable._lastActive.find("a")): new Date(+that._value);
	            } else {
	                that.selectable._lastActive = startDate? that._cellByDate(that._view.toDateString(startDate), CELLSELECTORVALID): that.selectable.value().first();
	            }

	            that._selectDates = [];
	            daysDifference = daysBetweenTwoDates(fromDate, toDate);
	            addDaysToArray(that._selectDates, daysDifference, fromDate, that.options.disableDates);

	            that._visualizeSelectedDatesInView();
	        },

	        _cellsBySelector: function(selector) {
	            var that = this;
	            return that._table.find(selector);
	        },

	        _addSelectedCellsToArray: function() {
	            var that = this;
	            that.selectable.value().each(function(index, item) {
	                var date = toDateObject($(item.firstChild));
	                if(!that.options.disableDates(date)) {
	                    that._selectDates.push(date);
	                }
	            });
	        },

	         _deselect: function(date) {
	            var that = this;
	             var currentDateIndex = that._selectDates.map(Number).indexOf(+date);
	            if(currentDateIndex != -1) {
	                that._selectDates.splice(currentDateIndex, 1);
	            }
	        },

	        _dateInView: function(date) {
	            var that = this,
	                firstDateInView = toDateObject(that._cellsBySelector(CELLSELECTORVALID + ":first").find("a")),
	                lastDateInView = toDateObject(that._cellsBySelector(CELLSELECTORVALID + ":last").find("a"));

	            return +date <= +lastDateInView && +date >= +firstDateInView;
	        },

	        _isNavigatable: function(currentValue, cellIndex) {
	            var that = this;
	            var isDisabled = that.options.disableDates;
	            var cell;
	            var index;

	            if (that._view.name == "month") {
	                return !isDisabled(currentValue);
	            } else {
	                index = that.wrapper.find("."+FOCUSED).index();
	                cell = that.wrapper.find(".k-content td:eq("+(index+cellIndex)+")");
	                return cell.is(CELLSELECTORVALID) || !isDisabled(currentValue);
	            }
	        },

	        _move: function(e) {
	            var that = this,
	                options = that.options,
	                key = e.keyCode,
	                view = that._view,
	                index = that._index,
	                min = that.options.min,
	                max = that.options.max,
	                currentValue = new DATE(+that._current),
	                isRtl = kendo.support.isRtl(that.wrapper),
	                isDisabled = that.options.disableDates,
	                value, prevent, method, temp;

	            if (e.target === that._table[0]) {
	                that._active = true;
	            }

	            if (key == keys.RIGHT && !isRtl || key == keys.LEFT && isRtl) {
	                value = 1;
	                prevent = true;
	            } else if (key == keys.LEFT && !isRtl || key == keys.RIGHT && isRtl) {
	                value = -1;
	                prevent = true;
	            } else if (key == keys.UP) {
	                value = index === 0 ? -7 : -4;
	                prevent = true;
	            } else if (key == keys.DOWN) {
	                value = index === 0 ? 7 : 4;
	                prevent = true;
	            }
	            else if(key == keys.SPACEBAR) {
	                value = 0;
	                prevent = true;
	            }
	            else if (key == keys.HOME || key == keys.END) {
	                method = key == keys.HOME ? "first" : "last";
	                temp = view[method](currentValue);
	                currentValue = new DATE(temp.getFullYear(), temp.getMonth(), temp.getDate(), currentValue.getHours(), currentValue.getMinutes(), currentValue.getSeconds(), currentValue.getMilliseconds());
	                currentValue.setFullYear(temp.getFullYear());
	                prevent = true;
	            }

	            if (e.ctrlKey || e.metaKey) {
	                if (key == keys.RIGHT && !isRtl || key == keys.LEFT && isRtl) {
	                    that.navigateToFuture();
	                    prevent = true;
	                } else if (key == keys.LEFT && !isRtl || key == keys.RIGHT && isRtl) {
	                    that.navigateToPast();
	                    prevent = true;
	                } else if (key == keys.UP) {
	                    that.navigateUp();
	                    prevent = true;
	                } else if (key == keys.DOWN) {
	                    that._click($(that._cell[0].firstChild));
	                    prevent = true;
	                }
	                  else if ((key == keys.ENTER || key == keys.SPACEBAR) && that._isMultipleSelection()) {
	                    that._keyboardToggleSelection(e);

	                    var focusedDate = toDateObject($(that._cell[0]).find("a"));
	                    that._class(FOCUSED, focusedDate);

	                }
	            } else if(e.shiftKey) {
	                if (value !== undefined || method) {
	                    if (!method) {
	                        view.setDate(currentValue, value);
	                    }

	                    if (!isInRange(currentValue, min, max)) {
	                        currentValue = restrictValue(currentValue, options.min, options.max);
	                    }

	                    if (isDisabled(currentValue)) {
	                        currentValue = that._nextNavigatable(currentValue, value);
	                    }

	                    min = createDate(min.getFullYear(), min.getMonth(), min.getDate());
	                    if(that._isMultipleSelection()) {
	                        that._keyboardRangeSelection(e, currentValue);
	                    }
	                    else {
	                        that._focus(currentValue);
	                    }
	                }
	            } else {
	                if (key == keys.ENTER || key == keys.SPACEBAR) {
	                    if(view.name == "month" && that._isMultipleSelection()) {
	                        that.value(toDateObject($(that._cell.find("a"))));
	                        that.selectable._lastActive = $(that._cell[0]);
	                        that.trigger(CHANGE);
	                    }
	                    else {
	                        that._click($(that._cell[0].firstChild));
	                    }
	                    prevent = true;
	                } else if (key == keys.PAGEUP) {
	                    prevent = true;
	                    that.navigateToPast();
	                } else if (key == keys.PAGEDOWN) {
	                    prevent = true;
	                    that.navigateToFuture();
	                }

	                if (value || method) {
	                    if (!method) {
	                        view.setDate(currentValue, value);
	                    }

	                    min = createDate(min.getFullYear(), min.getMonth(), min.getDate());

	                    if (!isInRange(currentValue, min, max)) {
	                        currentValue = restrictValue(currentValue, options.min, options.max);
	                    }

	                    if (!that._isNavigatable(currentValue, value)) {
	                        currentValue = that._nextNavigatable(currentValue, value);
	                    }

	                    if(that._isMultipleSelection()) {
	                        if(!that._dateInView(currentValue)) {
	                            that.navigate(currentValue);
	                        }
	                        else {
	                            that._current = currentValue;
	                            that._class(FOCUSED, currentValue);
	                        }
	                    }
	                    else {
	                        that._focus(currentValue);
	                    }
	                }
	            }

	            if (prevent) {
	                e.preventDefault();
	            }

	            return that._current;
	        },

	        _keyboardRangeSelection: function(event, currentValue) {
	            var that = this,
	                fromDate,
	                daysDifference;

	            if(!that._dateInView(currentValue)) {
	                that._selectDates = [];

	                fromDate = that.selectable._lastActive? toDateObject(that.selectable._lastActive.find("a")): currentValue;
	                daysDifference = daysBetweenTwoDates(fromDate, new Date(+currentValue));

	                addDaysToArray(that._selectDates, daysDifference, fromDate, that.options.disableDates);

	                that.navigate(currentValue);
	                that._current = currentValue;
	                that.selectable._lastActive = that.selectable._lastActive || that._cellByDate(that._view.toDateString(currentValue), CELLSELECTORVALID);
	                that.trigger(CHANGE);
	                return;
	            }
	            that.selectable.options.filter = that.wrapper.find("table").length > 1 && +currentValue > +that._current? "table.k-month:eq(1) " + CELLSELECTORVALID: "table.k-month:eq(0) " + CELLSELECTORVALID;
	            that._class(FOCUSED, currentValue);
	            that._current = currentValue;

	            that._rangeSelection(that._cellByDate(that._view.toDateString(currentValue), CELLSELECTORVALID), currentValue);

	            that.trigger(CHANGE);

	            that.selectable.options.filter = "table.k-month:eq(0) " + CELLSELECTORVALID;
	        },

	        _keyboardToggleSelection: function(event) {
	            var that = this;

	            event.currentTarget = that._cell[0];
	            that.selectable._lastActive = $(that._cell[0]);

	            if ($(that._cell[0]).hasClass(SELECTED)) {
	                that.selectable._unselect($(that._cell[0]));
	                that.selectable.trigger(CHANGE, { event: event});
	            }
	            else {
	                that.selectable.value($(that._cell[0]), { event: event});
	            }
	        },

	        _nextNavigatable: function(currentValue, value) {
	            var that = this,
	            disabled = true,
	            view = that._view,
	            min = that.options.min,
	            max = that.options.max,
	            isDisabled = that.options.disableDates,
	            navigatableDate = new Date(currentValue.getTime());

	            view.setDate(navigatableDate, -value);

	            while (disabled) {
	                view.setDate(currentValue, value);

	                if (!isInRange(currentValue, min, max)) {
	                    currentValue = navigatableDate;
	                    break;
	                }
	                disabled = isDisabled(currentValue);
	            }
	            return currentValue;
	        },

	        _animate: function(options) {
	            var that = this;
	            var from = options.from;
	            var to = options.to;
	            var active = that._active;
	            var viewWrapper = that.element.children(".k-calendar-view");

	            if (!from) {
	                viewWrapper.append(to);
	                that._bindTable(to);
	            } else if (from.parent().data("animating")) {
	                from.off(ns);
	                from.parent().kendoStop(true, true).remove();
	                from.remove();

	                viewWrapper.append(to);
	                that._focusView(active);
	            } else if (!from.is(":visible") || that.options.animation === false || options.replace) {
	                to.insertAfter(from);
	                from.off(ns).remove();

	                that._focusView(active);
	            } else {
	                that[options.vertical ? "_vertical" : "_horizontal"](from, to, options.future);
	            }
	        },

	        _horizontal: function(from, to, future) {
	            var that = this,
	                active = that._active,
	                horizontal = that.options.animation.horizontal,
	                effects = horizontal.effects,
	                viewWidth = outerWidth(from);

	            if (effects && effects.indexOf(SLIDE) != -1) {
	                from.add(to).css({ width: viewWidth });

	                from.wrap("<div/>");

	                that._focusView(active, from);

	                from.parent()
	                .css({
	                    position: "relative",
	                    width: viewWidth * 2,
	                    "float": LEFT,
	                    "margin-left": future ? 0 : -viewWidth
	                });

	                to[future ? "insertAfter" : "insertBefore"](from);

	                extend(horizontal, {
	                    effects: SLIDE + ":" + (future ? "right" : LEFT),
	                    complete: function() {
	                        from.off(ns).remove();
	                        that._oldTable = null;

	                        to.unwrap();

	                        that._focusView(active);

	                    }
	                });

	                from.parent().kendoStop(true, true).kendoAnimate(horizontal);
	            }
	        },

	        _vertical: function(from, to) {
	            var that = this,
	                vertical = that.options.animation.vertical,
	                effects = vertical.effects,
	                active = that._active, //active state before from's blur
	                cell, position;

	            if (effects && effects.indexOf("zoom") != -1) {
	                to.insertBefore(from);

	                from.css({
	                    position: "absolute",
	                    width: to.width()
	                });

	                if (transitionOrigin) {
	                    cell = that._cellByDate(that._view.toDateString(that._current));
	                    position = cell.position();
	                    position = (position.left + parseInt(cell.width() / 2, 10)) + "px" + " " + (position.top + parseInt(cell.height() / 2, 10) + "px");
	                    to.css(transitionOrigin, position);
	                }

	                from.kendoStop(true, true).kendoAnimate({
	                    effects: "fadeOut",
	                    duration: 600,
	                    complete: function() {
	                        from.off(ns).remove();
	                        that._oldTable = null;

	                        that._focusView(active);
	                    }
	                });

	                to.kendoStop(true, true).kendoAnimate(vertical);
	            }
	        },

	        _cellByDate: function(value, selector) {
	            return this._table.find(selector ? selector : "td:not(." + OTHERMONTH + ")")
	            .filter(function() {
	                return $(this.firstChild).attr(kendo.attr(VALUE)) === value;
	            });
	        },

	        _class: function(className, date) {
	            var that = this,
	                id = that._cellID,
	                cell = that._cell,
	                value = that._view.toDateString(date),
	                disabledDate;

	            if (cell && cell.length) {
	                cell[0].removeAttribute(ARIA_SELECTED);
	                cell[0].removeAttribute(ARIA_LABEL);
	                cell[0].removeAttribute(ID);
	                //.removeClass(className);
	            }

	            if (date && that._view.name == "month") {
	                disabledDate = that.options.disableDates(date);
	            }
	            that._cellsBySelector(that._isMultipleSelection() ? CELLSELECTOR: "td:not(." + OTHERMONTH + ")").removeClass(className);
	            cell = that._cellByDate(value, that.options.selectable == "multiple" ? CELLSELECTOR: "td:not(." + OTHERMONTH + ")")
	            .attr(ARIA_SELECTED, true);

	            if (className === FOCUSED && !that._active && that.options.focusOnNav !== false || disabledDate) {
	                className = "";
	            }

	            cell.addClass(className);

	            if (cell[0]) {
	                that._cell = cell;
	            }

	            if (id) {
	                cell.attr(ID, id);
	                that._table[0].removeAttribute("aria-activedescendant");
	                that._table.attr("aria-activedescendant", id);
	            }
	        },

	        _bindTable: function (table) {
	            table
	            .on(FOCUS_WITH_NS, this._addClassProxy)
	            .on(BLUR, this._removeClassProxy);
	        },

	        _click: function(link) {
	            var that = this,
	            options = that.options,
	            currentValue = new Date(+that._current),
	            value = toDateObject(link);

	            adjustDST(value, 0);

	            if (that._view.name == "month" && that.options.disableDates(value)) {
	                value = that._value;
	            }

	            that._view.setDate(currentValue, value);

	            that.navigateDown(restrictValue(currentValue, options.min, options.max));
	        },

	        _focus: function(value) {
	            var that = this,
	            view = that._view;

	            if (view.compare(value, that._current) !== 0) {
	                that.navigate(value);
	            } else {
	                that._current = value;
	                that._class(FOCUSED, value);
	            }
	        },

	        _focusView: function(active, table) {
	            if (active) {
	                this.focus(table);
	            }
	        },

	        _viewWrapper: function() {
	            var that = this;
	            var element = that.element;
	            var viewWrapper = element.children(".k-calendar-view");

	            if (!viewWrapper[0]) {
	                viewWrapper = $("<div class='k-calendar-view' />").insertAfter(element.find(HEADERSELECTOR));
	            }
	        },

	        _footer: function(template) {
	            var that = this,
	            today = getToday(),
	            element = that.element,
	            footer = element.find(".k-footer");

	            if (!template) {
	                that._toggle(false);
	                footer.hide();
	                return;
	            }

	            if (!footer[0]) {
	                footer = $('<div class="k-footer"><a href="#" class="k-link k-nav-today"></a></div>').appendTo(element);
	            }

	            that._today = footer.show()
	            .find(".k-link")
	            .html(template(today))
	            .attr("title", kendo.toString(today, "D", that.options.culture));

	            that._toggle();
	        },

	        _header: function() {
	            var that = this,
	            element = that.element,
	            linksSelector = that.options.linksSelector;

	            if (!element.find(HEADERSELECTOR)[0]) {
	                element.html(kendo.template(that.options.header.template)($.extend(true,{}, that.options, {actionAttr: kendo.attr("action")})));
	            }

	            element.find(linksSelector)
	            .on(MOUSEENTER_WITH_NS + " " + MOUSELEAVE + " " + FOCUS_WITH_NS + " " + BLUR, mousetoggle)
	            .on(CLICK + " touchend" + ns, function() { return false; } );

	            that._title = element.find('[' + kendo.attr("action") + '="nav-up"]').on(CLICK + " touchend" + ns, function () {
	                that._active = that.options.focusOnNav !== false;
	                that.navigateUp();
	            });
	            that[PREVARROW] = element.find('[' + kendo.attr("action") + '="prev"]').on(CLICK + " touchend" + ns, function () {
	                that._active = that.options.focusOnNav !== false;
	                that.navigateToPast();
	            });
	            that[NEXTARROW] = element.find('[' + kendo.attr("action") + '="next"]').on(CLICK + " touchend" + ns, function () {
	                that._active = that.options.focusOnNav !== false;
	                that.navigateToFuture();
	            });
	            element.find('[' + kendo.attr("action") + '="today"]').on(CLICK + " touchend" + ns, proxy(that._todayClick, that));

	        },

	        _navigate: function(arrow, modifier) {
	            var that = this,
	            index = that._index + 1,
	            currentValue = new DATE(+that._current);

	            if (that._isMultipleSelection()) {
	                var firstDayCurrentMonth = that._table.find("td:not(.k-other-month):not(.k-out-of-range)").has(".k-link").first();
	                currentValue = toDateObject(firstDayCurrentMonth.find("a"));
	                that._current = new Date(+currentValue);
	            }

	            arrow = that[arrow];

	            if (!arrow.hasClass(DISABLED)) {
	                if (index > 3) {
	                    currentValue.setFullYear(currentValue.getFullYear() + 100 * modifier);
	                } else {
	                    calendar.views[index].setDate(currentValue, modifier);
	                }

	                that.navigate(currentValue);
	            }
	        },

	        _option: function(option, value) {
	            var that = this,
	                options = that.options,
	                currentValue = that._value || that._current,
	                isBigger;

	            if (value === undefined) {
	                return options[option];
	            }

	            value = parse(value, options.format, options.culture);

	            if (!value) {
	                return;
	            }

	            options[option] = new DATE(+value);

	            if (option === MIN) {
	                isBigger = value > currentValue;
	            } else {
	                isBigger = currentValue > value;
	            }

	            if (isBigger || isEqualMonth(currentValue, value)) {
	                if (isBigger) {
	                    that._value = null;
	                }
	                that._changeView = true;
	            }

	            if (!that._changeView) {
	                that._changeView = !!(options.month.content || options.month.empty);
	            }

	            that.navigate(that._value);

	            that._toggle();
	        },

	        _toggle: function(toggle) {
	            var that = this,
	                options = that.options,
	                isTodayDisabled = that.options.disableDates(getToday()),
	                link = that._today;

	            if (toggle === undefined) {
	                toggle = isInRange(getToday(), options.min, options.max);
	            }

	            if (link) {
	                link.off(CLICK);

	                if (toggle && !isTodayDisabled) {
	                    link.addClass(TODAY)
	                    .removeClass(DISABLED)
	                    .on(CLICK, proxy(that._todayClick, that));
	                } else {
	                    link.removeClass(TODAY)
	                    .addClass(DISABLED)
	                    .on(CLICK, prevent);
	                }
	            }
	        },

	        _todayClick: function(e) {
	            var that = this,
	            depth = views[that.options.depth],
	            disabled = that.options.disableDates,
	            today = getToday();

	            e.preventDefault();

	            if (disabled(today)) {
	                return;
	            }

	            if (that._view.compare(that._current, today) === 0 && that._index == depth) {
	                that._changeView = false;
	            }

	            if(that._isMultipleSelection()) {
	                that._selectDates = [today];
	                that.selectable._lastActive = null;
	            }

	            that._value = today;
	            that.navigate(today, depth);

	            that.trigger(CHANGE);
	        },

	        _templates: function() {
	            var that = this,
	                options = that.options,
	                footer = options.footer,
	                month = options.month,
	                content = month.content,
	                weekNumber = month.weekNumber,
	                empty = month.empty,
	                footerTemplate = '#= kendo.toString(data,"D","' + options.culture +'") #';

	            that.month = {
	                content: template('<td#=data.cssClass# role="gridcell"><a tabindex="-1" class="k-link#=data.linkClass#" href="#=data.url#" ' + kendo.attr(VALUE) + '="#=data.dateString#" title="#=data.title#">' + (content || "#=data.value#") + '</a></td>', { useWithBlock: !!content }),
	                empty: template('<td role="gridcell">' + (empty || "&nbsp;") + "</td>", { useWithBlock: !!empty }),
	                weekNumber: template('<td class="k-alt">' + (weekNumber || "#= data.weekNumber #") + "</td>", { useWithBlock: !!weekNumber })
	            };

	            if (footer && footer !== true) {
	                footerTemplate = footer;
	            }

	            that.footer = footer !== false ? template(footerTemplate, { useWithBlock: false }) : null;
	        }
	    });

	    ui.plugin(Calendar);

	    var calendar = {
	        firstDayOfMonth: function (date) {
	            return createDate(
	                date.getFullYear(),
	                date.getMonth(),
	                1
	            );
	        },

	        firstVisibleDay: function (date, calendarInfo) {
	            calendarInfo = calendarInfo || kendo.culture().calendar;

	            var firstDay = calendarInfo.firstDay,
	            firstVisibleDay = new DATE(date.getFullYear(), date.getMonth(), 1, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
	            firstVisibleDay.setFullYear(date.getFullYear());

	            while (firstVisibleDay.getDay() != firstDay) {
	                calendar.setTime(firstVisibleDay, -1 * MS_PER_DAY);
	            }

	            return firstVisibleDay;
	        },

	        setTime: function (date, time) {
	            var tzOffsetBefore = date.getTimezoneOffset(),
	            resultDATE = new DATE(date.getTime() + time),
	            tzOffsetDiff = resultDATE.getTimezoneOffset() - tzOffsetBefore;

	            date.setTime(resultDATE.getTime() + tzOffsetDiff * MS_PER_MINUTE);
	        },
	        views: [{
	            name: MONTH,
	            title: function(date, min, max, culture) {
	                return getCalendarInfo(culture).months.names[date.getMonth()] + " " + date.getFullYear();
	            },
	            content: function(options) {
	                var that = this,
	                idx = 0,
	                min = options.min,
	                max = options.max,
	                date = options.date,
	                dates = options.dates,
	                format = options.format,
	                culture = options.culture,
	                navigateUrl = options.url,
	                showHeader = options.showHeader,
	                otherMonth = options.otherMonth,
	                isWeekColumnVisible = options.isWeekColumnVisible,
	                hasUrl = navigateUrl && dates[0],
	                currentCalendar = getCalendarInfo(culture),
	                firstDayIdx = currentCalendar.firstDay,
	                days = currentCalendar.days,
	                names = shiftArray(days.names, firstDayIdx),
	                shortNames = shiftArray(days.namesShort, firstDayIdx),
	                start = calendar.firstVisibleDay(date, currentCalendar),
	                firstDayOfMonth = that.first(date),
	                lastDayOfMonth = that.last(date),
	                toDateString = that.toDateString,
	                today = getToday(),
	                contentClasses = options.contentClasses,
	                html = '<table tabindex="0" role="grid" class="' + contentClasses + '" cellspacing="0" data-start="' + toDateString(start) + '">';
	                if (showHeader) {
	                    html += '<caption class="k-month-header">' + this.title(date, min, max, culture) + '</caption><thead><tr role="row">';
	                } else {
	                    html += '<thead><tr role="row">';
	                }
	                if (isWeekColumnVisible) {
	                    html += '<th scope="col" class="k-alt">' + options.messages.weekColumnHeader + '</th>';
	                }

	                for (; idx < 7; idx++) {
	                    html += '<th scope="col" title="' + names[idx] + '">' + shortNames[idx] + '</th>';
	                }

	                adjustDST(today, 0);
	                today = +today;

	                return view({
	                    cells: 42,
	                    perRow: 7,
	                    html: html += '</tr></thead><tbody><tr role="row">',
	                    start: start,
	                    isWeekColumnVisible: isWeekColumnVisible,
	                    weekNumber: options.weekNumber,
	                    min: createDate(min.getFullYear(), min.getMonth(), min.getDate()),
	                    max: createDate(max.getFullYear(), max.getMonth(), max.getDate()),
	                    otherMonth : otherMonth,
	                    content: options.content,
	                    lastDayOfMonth : lastDayOfMonth,
	                    empty: options.empty,
	                    setter: that.setDate,
	                    disableDates: options.disableDates,
	                    build: function(date, idx, disableDates) {
	                        var cssClass = [],
	                        day = date.getDay(),
	                        linkClass = "",
	                        url = "#";

	                        if (date < firstDayOfMonth || date > lastDayOfMonth) {
	                            cssClass.push(OTHERMONTH);
	                        }

	                        if (disableDates(date)) {
	                            cssClass.push(DISABLED);
	                        }

	                        if (+date === today) {
	                            cssClass.push("k-today");
	                        }

	                        if (day === 0 || day === 6) {
	                            cssClass.push("k-weekend");
	                        }

	                        if (hasUrl && inArray(+date, dates)) {
	                            url = navigateUrl.replace("{0}", kendo.toString(date, format, culture));
	                            linkClass = " k-action-link";
	                        }

	                        return {
	                            date: date,
	                            dates: dates,
	                            ns: kendo.ns,
	                            title: kendo.toString(date, "D", culture),
	                            value: date.getDate(),
	                            dateString: toDateString(date),
	                            cssClass: cssClass[0] ? ' class="' + cssClass.join(" ") + '"' : "",
	                            linkClass: linkClass,
	                            url: url
	                        };
	                    },
	                    weekNumberBuild: function(date) {
	                        return {
	                            weekNumber: weekInYear(date, kendo.culture().calendar.firstDay),
	                            currentDate: date
	                        };
	                    }
	                });
	            },
	            first: function(date) {
	                return calendar.firstDayOfMonth(date);
	            },
	            last: function(date) {
	                var last = createDate(date.getFullYear(), date.getMonth() + 1, 0),
	                first = calendar.firstDayOfMonth(date),
	                timeOffset = Math.abs(last.getTimezoneOffset() - first.getTimezoneOffset());

	                if (timeOffset) {
	                    last.setHours(first.getHours() + (timeOffset / 60));
	                }

	                return last;
	            },
	            compare: function(date1, date2) {
	                var result,
	                month1 = date1.getMonth(),
	                year1 = date1.getFullYear(),
	                month2 = date2.getMonth(),
	                year2 = date2.getFullYear();

	                if (year1 > year2) {
	                    result = 1;
	                } else if (year1 < year2) {
	                    result = -1;
	                } else {
	                    result = month1 == month2 ? 0 : month1 > month2 ? 1 : -1;
	                }

	                return result;
	            },
	            setDate: function(date, value) {
	                var hours = date.getHours();
	                if (value instanceof DATE) {
	                    date.setFullYear(value.getFullYear(), value.getMonth(), value.getDate());
	                } else {
	                    calendar.setTime(date, value * MS_PER_DAY);
	                }
	                adjustDST(date, hours);
	            },
	            toDateString: function(date) {
	                return date.getFullYear() + "/" + date.getMonth() + "/" + date.getDate();
	            }
	        },
	        {
	            name: "year",
	            title: function(date) {
	                return date.getFullYear();
	            },
	            content: function(options) {
	                var namesAbbr = getCalendarInfo(options.culture).months.namesAbbr,
	                toDateString = this.toDateString,
	                min = options.min,
	                max = options.max,
	                html = "";

	                if (options.showHeader) {
	                    html += '<table tabindex="0" role="grid" class="k-content k-meta-view" cellspacing="0"><caption class="k-meta-header">';
	                    html += this.title(options.date);
	                    html += '</caption><tbody><tr role="row">';
	                }

	                return view({
	                    min: createDate(min.getFullYear(), min.getMonth(), 1),
	                    max: createDate(max.getFullYear(), max.getMonth(), 1),
	                    start: createDate(options.date.getFullYear(), 0, 1),
	                    html: html,
	                    setter: this.setDate,
	                    build: function(date) {
	                        return {
	                            value: namesAbbr[date.getMonth()],
	                            ns: kendo.ns,
	                            dateString: toDateString(date),
	                            cssClass: ""
	                        };
	                    }
	                });
	            },
	            first: function(date) {
	                return createDate(date.getFullYear(), 0, date.getDate());
	            },
	            last: function(date) {
	                return createDate(date.getFullYear(), 11, date.getDate());
	            },
	            compare: function(date1, date2){
	                return compare(date1, date2);
	            },
	            setDate: function(date, value) {
	                var month,
	                hours = date.getHours();

	                if (value instanceof DATE) {
	                    month = value.getMonth();

	                    date.setFullYear(value.getFullYear(), month, date.getDate());

	                    if (month !== date.getMonth()) {
	                        date.setDate(0);
	                    }
	                } else {
	                    month = date.getMonth() + value;

	                    date.setMonth(month);

	                    if (month > 11) {
	                        month -= 12;
	                    }

	                    if (month > 0 && date.getMonth() != month) {
	                        date.setDate(0);
	                    }
	                }

	                adjustDST(date, hours);
	            },
	            toDateString: function(date) {
	                return date.getFullYear() + "/" + date.getMonth() + "/1";
	            }
	        },
	        {
	            name: "decade",
	            title: function(date, min, max) {
	                return title(date, min, max, 10);
	            },
	            content: function(options) {
	                var year = options.date.getFullYear(),
	                toDateString = this.toDateString,
	                html = "";

	                if (options.showHeader) {
	                    html += '<table tabindex="0" role="grid" class="k-content k-meta-view" cellspacing="0"><caption class="k-meta-header">';
	                    html += this.title(options.date, options.min, options.max);
	                    html += '</caption><tbody><tr role="row">';
	                }

	                return view({
	                    start: createDate(year - year % 10 - 1, 0, 1),
	                    min: createDate(options.min.getFullYear(), 0, 1),
	                    max: createDate(options.max.getFullYear(), 0, 1),
	                    otherMonth : options.otherMonth,
	                    html : html,
	                    setter: this.setDate,
	                    build: function(date, idx) {
	                        return {
	                            value: date.getFullYear(),
	                            ns: kendo.ns,
	                            dateString: toDateString(date),
	                            cssClass: idx === 0 || idx == 11 ? OTHERMONTHCLASS : ""
	                        };
	                    }
	                });
	            },
	            first: function(date) {
	                var year = date.getFullYear();
	                return createDate(year - year % 10, date.getMonth(), date.getDate());
	            },
	            last: function(date) {
	                var year = date.getFullYear();
	                return createDate(year - year % 10 + 9, date.getMonth(), date.getDate());
	            },
	            compare: function(date1, date2) {
	                return compare(date1, date2, 10);
	            },
	            setDate: function(date, value) {
	                setDate(date, value, 1);
	            },
	            toDateString: function(date) {
	                return date.getFullYear() + "/0/1";
	            }
	        },
	        {
	            name: CENTURY,
	            title: function(date, min, max) {
	                return title(date, min, max, 100);
	            },
	            content: function(options) {
	                var year = options.date.getFullYear(),
	                min = options.min.getFullYear(),
	                max = options.max.getFullYear(),
	                toDateString = this.toDateString,
	                minYear = min,
	                maxYear = max,
	                html = "";

	                minYear = minYear - minYear % 10;
	                maxYear = maxYear - maxYear % 10;

	                if (maxYear - minYear < 10) {
	                    maxYear = minYear + 9;
	                }

	                if (options.showHeader) {
	                    html += '<table tabindex="0" role="grid" class="k-content k-meta-view" cellspacing="0"><caption class="k-meta-header">';
	                    html += this.title(options.date, options.min, options.max);
	                    html += '</caption><tbody><tr role="row">';
	                }

	                return view({
	                    start: createDate(year - year % 100 - 10, 0, 1),
	                    min: createDate(minYear, 0, 1),
	                    max: createDate(maxYear, 0, 1),
	                    otherMonth : options.otherMonth,
	                    html : html,
	                    setter: this.setDate,
	                    build: function(date, idx) {
	                        var start = date.getFullYear(),
	                        end = start + 9;

	                        if (start < min) {
	                            start = min;
	                        }

	                        if (end > max) {
	                            end = max;
	                        }

	                        return {
	                            ns: kendo.ns,
	                            value: start + " - " + end,
	                            dateString: toDateString(date),
	                            cssClass: idx === 0 || idx == 11 ? OTHERMONTHCLASS : ""
	                        };
	                    }
	                });
	            },
	            first: function(date) {
	                var year = date.getFullYear();
	                return createDate(year - year % 100, date.getMonth(), date.getDate());
	            },
	            last: function(date) {
	                var year = date.getFullYear();
	                return createDate(year - year % 100 + 99, date.getMonth(), date.getDate());
	            },
	            compare: function(date1, date2) {
	                return compare(date1, date2, 100);
	            },
	            setDate: function(date, value) {
	                setDate(date, value, 10);
	            },
	            toDateString: function(date) {
	                var year = date.getFullYear();
	                return (year - year % 10) + "/0/1";
	            }
	        }]
	    };

	    function title(date, min, max, modular) {
	        var start = date.getFullYear(),
	            minYear = min.getFullYear(),
	            maxYear = max.getFullYear(),
	            end;

	        start = start - start % modular;
	        end = start + (modular - 1);

	        if (start < minYear) {
	            start = minYear;
	        }
	        if (end > maxYear) {
	            end = maxYear;
	        }

	        return start + "-" + end;
	    }

	    function view(options) {
	        var idx = 0,
	            data,
	            min = options.min,
	            max = options.max,
	            start = options.start,
	            setter = options.setter,
	            build = options.build,
	            weekNumberBuild = options.weekNumberBuild,
	            length = options.cells || 12,
	            isWeekColumnVisible = options.isWeekColumnVisible,
	            cellsPerRow = options.perRow || 4,
	            otherMonth = options.otherMonth,
	            lastDayOfMonth = options.lastDayOfMonth,
	            weekNumber = options.weekNumber || weekNumberTemplate,
	            content = options.content || cellTemplate,
	            empty = options.empty || emptyCellTemplate,
	            otherMonthTemplate = options.otherMonthCellTemplate || otherMonthCellTemplate,
	            html = options.html || '<table tabindex="0" role="grid" class="k-content k-meta-view" cellspacing="0"><tbody><tr role="row">';
	            if(isWeekColumnVisible) {
	                html += weekNumber(weekNumberBuild(start));
	            }


	        for(; idx < length; idx++) {
	            if (idx > 0 && idx % cellsPerRow === 0) {
	                html += '</tr><tr role="row">';
	                if (isWeekColumnVisible) {
	                    html += otherMonth || (+start <= +lastDayOfMonth) ? weekNumber(weekNumberBuild(start)) : weekNumber({ weekNumber : "&nbsp;"});
	                }
	            }

	            start = createDate(start.getFullYear(), start.getMonth(), start.getDate());
	            adjustDST(start, 0);

	            data = build(start, idx, options.disableDates);

	            html += (data.cssClass.indexOf(OTHERMONTH) !== -1 && !otherMonth) ? otherMonthTemplate(data) : isInRange(start, min, max) ? content(data) : empty(data);

	            setter(start, 1);
	        }

	        return html + "</tr></tbody></table>";
	    }

	    function compare(date1, date2, modifier) {
	        var year1 = date1.getFullYear(),
	            start  = date2.getFullYear(),
	            end = start,
	            result = 0;

	        if (modifier) {
	            start = start - start % modifier;
	            end = start - start % modifier + modifier - 1;
	        }

	        if (year1 > end) {
	            result = 1;
	        } else if (year1 < start) {
	            result = -1;
	        }

	        return result;
	    }

	    function getToday() {
	        var today = new DATE();
	        return new DATE(today.getFullYear(), today.getMonth(), today.getDate());
	    }

	    function restrictValue (value, min, max) {
	        var today = getToday();

	        if (value) {
	            today = new DATE(+value);
	        }

	        if (min > today) {
	            today = new DATE(+min);
	        } else if (max < today) {
	            today = new DATE(+max);
	        }
	        return today;
	    }

	    function isInRange(date, min, max) {
	        return +date >= +min && +date <= +max;
	    }

	    function shiftArray(array, idx) {
	        return array.slice(idx).concat(array.slice(0, idx));
	    }

	    function setDate(date, value, multiplier) {
	        value = value instanceof DATE ? value.getFullYear() : date.getFullYear() + multiplier * value;
	        date.setFullYear(value);
	    }

	    function daysBetweenTwoDates(startDate, endDate) {
	        if(+endDate < +startDate) {
	            var temp = +startDate;
	            calendar.views[0].setDate(startDate, endDate);
	            calendar.views[0].setDate(endDate, new Date(temp));
	        }
	        var fromDateUTC = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
	        var endDateUTC = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

	        return Math.ceil((+endDateUTC - +fromDateUTC) / kendo.date.MS_PER_DAY);
	    }

	    function addDaysToArray(array, numberOfDays, fromDate, disableDates) {
	        for(var i = 0; i <= numberOfDays; i++) {
	            var nextDay = new Date(fromDate.getTime());
	            nextDay = new Date(nextDay.setDate(nextDay.getDate() + i));
	            if(!disableDates(nextDay)) {
	                array.push(nextDay);
	            }
	        }
	    }

	    function mousetoggle(e) {
	        var disabled = $(this).hasClass("k-state-disabled");

	        if (!disabled) {
	            $(this).toggleClass(HOVER, MOUSEENTER.indexOf(e.type) > -1 || e.type == FOCUS);
	        }
	    }

	    function prevent (e) {
	        e.preventDefault();
	    }

	    // creates date with full year
	    function createDate(year, month, date) {
	        var dateObject = new DATE(year, month, date);
	        dateObject.setFullYear(year, month, date);
	        return dateObject;
	    }

	    function getCalendarInfo(culture) {
	        return getCulture(culture).calendars.standard;
	    }

	    function normalize(options) {
	        var start = views[options.start],
	            depth = views[options.depth],
	            culture = getCulture(options.culture);

	        options.format = extractFormat(options.format || culture.calendars.standard.patterns.d);

	        if (isNaN(start)) {
	            start = 0;
	            options.start = MONTH;
	        }

	        if (depth === undefined || depth > start) {
	            options.depth = MONTH;
	        }

	        if (options.dates === null) {
	            options.dates = [];
	        }
	    }

	    function makeUnselectable(element) {
	        if (isIE8) {
	            element.find("*").attr("unselectable", "on");
	        }
	    }

	    function addClassToViewContainer(element, currentView) {
	        element.addClass("k-" + currentView);
	    }

	    function inArray(date, dates) {
	        for(var i = 0, length = dates.length; i < length; i++) {
	            if (date === +dates[i]) {
	                return true;
	            }
	        }
	        return false;
	    }

	    function isEqualDatePart(value1, value2) {
	        if (value1) {
	            return value1.getFullYear() === value2.getFullYear() &&
	                value1.getMonth() === value2.getMonth() &&
	                value1.getDate() === value2.getDate();
	        }

	        return false;
	    }

	    function isEqualMonth(value1, value2) {
	        if (value1) {
	            return value1.getFullYear() === value2.getFullYear() &&
	                value1.getMonth() === value2.getMonth();
	        }

	        return false;
	    }


	    function getDisabledExpr(option) {
	        if (kendo.isFunction(option)) {
	            return option;
	        }

	        if ($.isArray(option)) {
	            return createDisabledExpr(option);
	        }
	        return $.noop;
	    }

	    function convertDatesArray(dates) {
	        var result = [];
	        for (var i = 0; i < dates.length; i++) {
	            result.push(dates[i].setHours(0, 0, 0, 0));
	        }
	        return result;
	    }

	    function createDisabledExpr(dates) {
	        var body, callback,
	            disabledDates = [],
	            days = ["su", "mo", "tu", "we", "th", "fr", "sa"],
	            searchExpression = "if (found) {"+
	                    " return true " +
	                "} else {" +
	                    "return false" +
	                "}";

	        if (dates[0] instanceof DATE) {
	            disabledDates = convertDatesArray(dates);
	            body = "var clonedDate = new Date(date); var found = date && window.kendo.jQuery.inArray(clonedDate.setHours(0, 0, 0, 0),["+ disabledDates +"]) > -1;" + searchExpression;
	        } else {
	            for (var i = 0; i < dates.length; i++) {
	                var day = dates[i].slice(0,2).toLowerCase();
	                var index = $.inArray(day, days);
	                if (index > -1) {
	                    disabledDates.push(index);
	                }
	            }
	            body = "var clonedDate = new Date(date); var found = date && window.kendo.jQuery.inArray(clonedDate.getDay(),["+ disabledDates +"]) > -1;" + searchExpression;
	        }

	        callback = new Function("date", body); //jshint ignore:line

	        return callback;
	    }

	    function isEqualDate(oldValue, newValue) {
	       if (oldValue instanceof Date && newValue instanceof Date) {
	           oldValue = oldValue.getTime();
	           newValue = newValue.getTime();
	       }

	       return oldValue === newValue;
	    }

	    function toDateObject(link) {
	        var value = $(link).attr(kendo.attr(VALUE)).split("/");
	        //Safari cannot create correctly date from "1/1/2090"
	        value = createDate(value[0], value[1], value[2]);

	        return value;
	    }

	    calendar.isEqualDatePart = isEqualDatePart;
	    calendar.isEqualDate = isEqualDate;
	    calendar.makeUnselectable =  makeUnselectable;
	    calendar.restrictValue = restrictValue;
	    calendar.isInRange = isInRange;
	    calendar.addClassToViewContainer = addClassToViewContainer;
	    calendar.normalize = normalize;
	    calendar.viewsEnum = views;
	    calendar.disabled = getDisabledExpr;
	    calendar.toDateObject = toDateObject;
	    calendar.getToday = getToday;
	    calendar.createDate = createDate;

	    kendo.calendar = calendar;
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1078:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("qo2y");

/***/ })

/******/ });

/***/ }),

/***/ "f42d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__("3ok8");
var propertyKeys_1 = __webpack_require__("IfdU");
var utils_1 = __webpack_require__("IRr6");
var ComponentUtil = (function () {
    function ComponentUtil() {
    }
    ComponentUtil.getEventCallbacks = function () {
        if (!ComponentUtil.EVENT_CALLBACKS) {
            ComponentUtil.EVENT_CALLBACKS = [];
            ComponentUtil.EVENTS.forEach(function (eventName) {
                ComponentUtil.EVENT_CALLBACKS.push(ComponentUtil.getCallbackForEvent(eventName));
            });
        }
        return ComponentUtil.EVENT_CALLBACKS;
    };
    ComponentUtil.copyAttributesToGridOptions = function (gridOptions, component) {
        checkForDeprecated(component);
        // create empty grid options if none were passed
        if (typeof gridOptions !== 'object') {
            gridOptions = {};
        }
        // to allow array style lookup in TypeScript, take type away from 'this' and 'gridOptions'
        var pGridOptions = gridOptions;
        // add in all the simple properties
        ComponentUtil.ARRAY_PROPERTIES
            .concat(ComponentUtil.STRING_PROPERTIES)
            .concat(ComponentUtil.OBJECT_PROPERTIES)
            .concat(ComponentUtil.FUNCTION_PROPERTIES)
            .forEach(function (key) {
            if (typeof component[key] !== 'undefined') {
                pGridOptions[key] = component[key];
            }
        });
        ComponentUtil.BOOLEAN_PROPERTIES.forEach(function (key) {
            if (typeof component[key] !== 'undefined') {
                pGridOptions[key] = ComponentUtil.toBoolean(component[key]);
            }
        });
        ComponentUtil.NUMBER_PROPERTIES.forEach(function (key) {
            if (typeof component[key] !== 'undefined') {
                pGridOptions[key] = ComponentUtil.toNumber(component[key]);
            }
        });
        ComponentUtil.getEventCallbacks().forEach(function (funcName) {
            if (typeof component[funcName] !== 'undefined') {
                pGridOptions[funcName] = component[funcName];
            }
        });
        return gridOptions;
    };
    ComponentUtil.getCallbackForEvent = function (eventName) {
        if (!eventName || eventName.length < 2) {
            return eventName;
        }
        else {
            return 'on' + eventName[0].toUpperCase() + eventName.substr(1);
        }
    };
    // change this method, the caller should know if it's initialised or not, plus 'initialised'
    // is not relevant for all component types. maybe pass in the api and columnApi instead???
    ComponentUtil.processOnChange = function (changes, gridOptions, api, columnApi) {
        //if (!component._initialised || !changes) { return; }
        if (!changes) {
            return;
        }
        checkForDeprecated(changes);
        // to allow array style lookup in TypeScript, take type away from 'this' and 'gridOptions'
        var pGridOptions = gridOptions;
        // check if any change for the simple types, and if so, then just copy in the new value
        ComponentUtil.ARRAY_PROPERTIES
            .concat(ComponentUtil.OBJECT_PROPERTIES)
            .concat(ComponentUtil.STRING_PROPERTIES)
            .forEach(function (key) {
            if (changes[key]) {
                pGridOptions[key] = changes[key].currentValue;
            }
        });
        ComponentUtil.BOOLEAN_PROPERTIES.forEach(function (key) {
            if (changes[key]) {
                pGridOptions[key] = ComponentUtil.toBoolean(changes[key].currentValue);
            }
        });
        ComponentUtil.NUMBER_PROPERTIES.forEach(function (key) {
            if (changes[key]) {
                pGridOptions[key] = ComponentUtil.toNumber(changes[key].currentValue);
            }
        });
        ComponentUtil.getEventCallbacks().forEach(function (funcName) {
            if (changes[funcName]) {
                pGridOptions[funcName] = changes[funcName].currentValue;
            }
        });
        if (changes.showToolPanel) {
            api.showToolPanel(ComponentUtil.toBoolean(changes.showToolPanel.currentValue));
        }
        if (changes.quickFilterText) {
            api.setQuickFilter(changes.quickFilterText.currentValue);
        }
        if (changes.rowData) {
            api.setRowData(changes.rowData.currentValue);
        }
        if (changes.pinnedTopRowData) {
            api.setPinnedTopRowData(changes.pinnedTopRowData.currentValue);
        }
        if (changes.pinnedBottomRowData) {
            api.setPinnedBottomRowData(changes.pinnedBottomRowData.currentValue);
        }
        if (changes.columnDefs) {
            api.setColumnDefs(changes.columnDefs.currentValue, "gridOptionsChanged");
        }
        if (changes.datasource) {
            api.setDatasource(changes.datasource.currentValue);
        }
        if (changes.headerHeight) {
            api.setHeaderHeight(ComponentUtil.toNumber(changes.headerHeight.currentValue));
        }
        if (changes.paginationPageSize) {
            api.paginationSetPageSize(ComponentUtil.toNumber(changes.paginationPageSize.currentValue));
        }
        if (changes.pivotMode) {
            columnApi.setPivotMode(ComponentUtil.toBoolean(changes.pivotMode.currentValue), "gridOptionsChanged");
        }
        if (changes.groupRemoveSingleChildren) {
            api.setGroupRemoveSingleChildren(ComponentUtil.toBoolean(changes.groupRemoveSingleChildren.currentValue));
        }
        if (changes.suppressRowDrag) {
            api.setSuppressRowDrag(ComponentUtil.toBoolean(changes.suppressRowDrag.currentValue));
        }
        // copy changes into an event for dispatch
        var event = {
            type: events_1.Events.EVENT_COMPONENT_STATE_CHANGED,
            api: gridOptions.api,
            columnApi: gridOptions.columnApi
        };
        utils_1.Utils.iterateObject(changes, function (key, value) {
            event[key] = value;
        });
        api.dispatchEvent(event);
    };
    ComponentUtil.toBoolean = function (value) {
        if (typeof value === 'boolean') {
            return value;
        }
        else if (typeof value === 'string') {
            // for boolean, compare to empty String to allow attributes appearing with
            // not value to be treated as 'true'
            return value.toUpperCase() === 'TRUE' || value == '';
        }
        else {
            return false;
        }
    };
    ComponentUtil.toNumber = function (value) {
        if (typeof value === 'number') {
            return value;
        }
        else if (typeof value === 'string') {
            return Number(value);
        }
        else {
            return undefined;
        }
    };
    // all the events are populated in here AFTER this class (at the bottom of the file).
    ComponentUtil.EVENTS = [];
    ComponentUtil.STRING_PROPERTIES = propertyKeys_1.PropertyKeys.STRING_PROPERTIES;
    ComponentUtil.OBJECT_PROPERTIES = propertyKeys_1.PropertyKeys.OBJECT_PROPERTIES;
    ComponentUtil.ARRAY_PROPERTIES = propertyKeys_1.PropertyKeys.ARRAY_PROPERTIES;
    ComponentUtil.NUMBER_PROPERTIES = propertyKeys_1.PropertyKeys.NUMBER_PROPERTIES;
    ComponentUtil.BOOLEAN_PROPERTIES = propertyKeys_1.PropertyKeys.BOOLEAN_PROPERTIES;
    ComponentUtil.FUNCTION_PROPERTIES = propertyKeys_1.PropertyKeys.FUNCTION_PROPERTIES;
    ComponentUtil.ALL_PROPERTIES = propertyKeys_1.PropertyKeys.ALL_PROPERTIES;
    return ComponentUtil;
}());
exports.ComponentUtil = ComponentUtil;
utils_1.Utils.iterateObject(events_1.Events, function (key, value) {
    ComponentUtil.EVENTS.push(value);
});
function checkForDeprecated(changes) {
    if (changes.rowDeselected || changes.onRowDeselected) {
        console.warn('ag-grid: as of v3.4 rowDeselected no longer exists. Please check the docs.');
    }
}


/***/ }),

/***/ "f57H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var ViewportRowModel = (function () {
    function ViewportRowModel() {
        // rowRenderer tells us these
        this.firstRow = -1;
        this.lastRow = -1;
        // datasource tells us this
        this.rowCount = -1;
        this.rowNodesByIndex = {};
    }
    ViewportRowModel.prototype.init = function () {
        this.rowHeight = this.gridOptionsWrapper.getRowHeightAsNumber();
        this.eventService.addEventListener(main_1.Events.EVENT_VIEWPORT_CHANGED, this.onViewportChanged.bind(this));
        var viewportEnabled = this.gridOptionsWrapper.isRowModelViewport();
        if (viewportEnabled && this.gridOptionsWrapper.getViewportDatasource()) {
            this.setViewportDatasource(this.gridOptionsWrapper.getViewportDatasource());
        }
    };
    ViewportRowModel.prototype.destroy = function () {
        this.destroyCurrentDatasource();
    };
    ViewportRowModel.prototype.isLastRowFound = function () {
        return true;
    };
    ViewportRowModel.prototype.destroyCurrentDatasource = function () {
        if (this.viewportDatasource && this.viewportDatasource.destroy) {
            this.viewportDatasource.destroy();
        }
    };
    ViewportRowModel.prototype.calculateFirstRow = function (firstRenderedRow) {
        var bufferSize = this.gridOptionsWrapper.getViewportRowModelBufferSize();
        var pageSize = this.gridOptionsWrapper.getViewportRowModelPageSize();
        var afterBuffer = firstRenderedRow - bufferSize;
        if (afterBuffer < 0) {
            return 0;
        }
        else {
            return Math.floor(afterBuffer / pageSize) * pageSize;
        }
    };
    ViewportRowModel.prototype.calculateLastRow = function (lastRenderedRow) {
        var bufferSize = this.gridOptionsWrapper.getViewportRowModelBufferSize();
        var pageSize = this.gridOptionsWrapper.getViewportRowModelPageSize();
        var afterBuffer = lastRenderedRow + bufferSize;
        var result = Math.ceil(afterBuffer / pageSize) * pageSize;
        if (result <= this.rowCount) {
            return result;
        }
        else {
            return this.rowCount;
        }
    };
    ViewportRowModel.prototype.onViewportChanged = function (event) {
        var newFirst = this.calculateFirstRow(event.firstRow);
        var newLast = this.calculateLastRow(event.lastRow);
        if (this.firstRow !== newFirst || this.lastRow !== newLast) {
            this.firstRow = newFirst;
            this.lastRow = newLast;
            this.purgeRowsNotInViewport();
            if (this.viewportDatasource) {
                this.viewportDatasource.setViewportRange(this.firstRow, this.lastRow);
            }
        }
    };
    ViewportRowModel.prototype.purgeRowsNotInViewport = function () {
        var _this = this;
        Object.keys(this.rowNodesByIndex).forEach(function (indexStr) {
            var index = parseInt(indexStr);
            if (index < _this.firstRow || index > _this.lastRow) {
                delete _this.rowNodesByIndex[index];
            }
        });
    };
    ViewportRowModel.prototype.setViewportDatasource = function (viewportDatasource) {
        this.destroyCurrentDatasource();
        this.viewportDatasource = viewportDatasource;
        this.rowCount = 0;
        if (!viewportDatasource.init) {
            console.warn('ag-Grid: viewport is missing init method.');
        }
        else {
            viewportDatasource.init({
                setRowCount: this.setRowCount.bind(this),
                setRowData: this.setRowData.bind(this),
                getRow: this.getRow.bind(this)
            });
        }
    };
    ViewportRowModel.prototype.getType = function () {
        return main_1.Constants.ROW_MODEL_TYPE_VIEWPORT;
    };
    ViewportRowModel.prototype.getRow = function (rowIndex) {
        if (!this.rowNodesByIndex[rowIndex]) {
            this.rowNodesByIndex[rowIndex] = this.createBlankRowNode(rowIndex);
        }
        return this.rowNodesByIndex[rowIndex];
    };
    ViewportRowModel.prototype.getPageFirstRow = function () {
        return 0;
    };
    ViewportRowModel.prototype.getPageLastRow = function () {
        return this.rowCount - 1;
    };
    ViewportRowModel.prototype.getRowCount = function () {
        return this.rowCount;
    };
    ViewportRowModel.prototype.getRowIndexAtPixel = function (pixel) {
        if (this.rowHeight !== 0) {
            return Math.floor(pixel / this.rowHeight);
        }
        else {
            return 0;
        }
    };
    ViewportRowModel.prototype.getRowBounds = function (index) {
        return {
            rowHeight: this.rowHeight,
            rowTop: this.rowHeight * index
        };
    };
    ViewportRowModel.prototype.getCurrentPageHeight = function () {
        return this.rowCount * this.rowHeight;
    };
    ViewportRowModel.prototype.isEmpty = function () {
        return this.rowCount > 0;
    };
    ViewportRowModel.prototype.isRowsToRender = function () {
        return this.rowCount > 0;
    };
    ViewportRowModel.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
        var firstIndex = main_1.Utils.missing(firstInRange) ? 0 : firstInRange.rowIndex;
        var lastIndex = lastInRange.rowIndex;
        var firstNodeOutOfRange = firstIndex < this.firstRow || firstIndex > this.lastRow;
        var lastNodeOutOfRange = lastIndex < this.firstRow || lastIndex > this.lastRow;
        if (firstNodeOutOfRange || lastNodeOutOfRange) {
            return [];
        }
        var result = [];
        for (var i = firstIndex; i <= lastIndex; i++) {
            result.push(this.rowNodesByIndex[i]);
        }
        return result;
    };
    ViewportRowModel.prototype.forEachNode = function (callback) {
        var _this = this;
        var callbackCount = 0;
        Object.keys(this.rowNodesByIndex).forEach(function (indexStr) {
            var index = parseInt(indexStr);
            var rowNode = _this.rowNodesByIndex[index];
            callback(rowNode, callbackCount);
            callbackCount++;
        });
    };
    ViewportRowModel.prototype.setRowData = function (rowData) {
        var _this = this;
        main_1.Utils.iterateObject(rowData, function (indexStr, dataItem) {
            var index = parseInt(indexStr);
            // we should never keep rows that we didn't specifically ask for, this
            // guarantees the contract we have with the server.
            if (index >= _this.firstRow && index <= _this.lastRow) {
                var rowNode = _this.rowNodesByIndex[index];
                // the abnormal case is we requested a row even though the grid didn't need it
                // as a result of the paging and buffer (ie the row is off screen), in which
                // case we need to create a new node now
                if (main_1.Utils.missing(rowNode)) {
                    rowNode = _this.createBlankRowNode(index);
                    _this.rowNodesByIndex[index] = rowNode;
                }
                // now we deffo have a row node, so set in the details
                // if the grid already asked for this row (the normal case), then we would
                // of put a placeholder node in place.
                rowNode.setDataAndId(dataItem, index.toString());
            }
        });
    };
    ViewportRowModel.prototype.createBlankRowNode = function (rowIndex) {
        var rowNode = new main_1.RowNode();
        this.context.wireBean(rowNode);
        rowNode.setRowHeight(this.rowHeight);
        rowNode.setRowTop(this.rowHeight * rowIndex);
        rowNode.setRowIndex(rowIndex);
        return rowNode;
    };
    ViewportRowModel.prototype.setRowCount = function (rowCount) {
        if (rowCount !== this.rowCount) {
            this.rowCount = rowCount;
            var event_1 = {
                type: main_1.Events.EVENT_MODEL_UPDATED,
                api: this.gridApi,
                columnApi: this.columnApi,
                newData: false,
                newPage: false,
                keepRenderedRows: false,
                animate: false
            };
            this.eventService.dispatchEvent(event_1);
        }
    };
    ViewportRowModel.prototype.isRowPresent = function (rowNode) {
        return false;
    };
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], ViewportRowModel.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        main_1.Autowired('eventService'),
        __metadata("design:type", main_1.EventService)
    ], ViewportRowModel.prototype, "eventService", void 0);
    __decorate([
        main_1.Autowired('selectionController'),
        __metadata("design:type", main_1.SelectionController)
    ], ViewportRowModel.prototype, "selectionController", void 0);
    __decorate([
        main_1.Autowired('context'),
        __metadata("design:type", main_1.Context)
    ], ViewportRowModel.prototype, "context", void 0);
    __decorate([
        main_1.Autowired('gridApi'),
        __metadata("design:type", main_1.GridApi)
    ], ViewportRowModel.prototype, "gridApi", void 0);
    __decorate([
        main_1.Autowired('columnApi'),
        __metadata("design:type", main_1.ColumnApi)
    ], ViewportRowModel.prototype, "columnApi", void 0);
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ViewportRowModel.prototype, "init", null);
    __decorate([
        main_1.PreDestroy,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ViewportRowModel.prototype, "destroy", null);
    ViewportRowModel = __decorate([
        main_1.Bean('rowModel')
    ], ViewportRowModel);
    return ViewportRowModel;
}());
exports.ViewportRowModel = ViewportRowModel;


/***/ }),

/***/ "fBQ2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("evD5");
var createDesc = __webpack_require__("X8DO");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "fJYQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__("ungA");

var _ComboBoxProps = __webpack_require__("OHIl");

var _ComboBoxProps2 = _interopRequireDefault(_ComboBoxProps);

var _Animation = __webpack_require__("dGGS");

var _Animation2 = _interopRequireDefault(_Animation);

var _Popup = __webpack_require__("rQ4N");

var _Popup2 = _interopRequireDefault(_Popup);

var _Virtual = __webpack_require__("ZSoY");

var _Virtual2 = _interopRequireDefault(_Virtual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: _ComboBoxProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _Animation2.default, _Popup2.default, _Virtual2.default],
    model: {
        event: 'changemodel'
    },
    mounted: function mounted() {
        var that = this;
        var widgetElement = that.$el;

        kendo.jQuery(widgetElement).kendoComboBox(that.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', widgetElement.value);
            } else {
                that.$emit('changemodel', widgetElement.value);
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            var widgetElement = this.$el;

            return kendo.jQuery(widgetElement).getKendoComboBox();
        }
    }
};

/***/ }),

/***/ "fNSn":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1604);
	module.exports = __webpack_require__(1604);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1604:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo, window) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    /* jshint eqnull:true */
	    /* jshint latedef: nofunc */

	    var $ = kendo.jQuery;
	    var Widget = kendo.ui.Widget;
	    var ns = ".kendoFormulaInput";
	    var keys = kendo.keys;
	    var classNames = {
	        wrapper: "k-spreadsheet-formula-input",
	        listWrapper: "k-spreadsheet-formula-list"
	    };
	    var styles = [
	        "font-family",
	        "font-size",
	        "font-stretch",
	        "font-style",
	        "font-weight",
	        "letter-spacing",
	        "text-transform",
	        "line-height"
	    ];

	    //move to core
	    var KEY_NAMES = {
	        27: 'esc',
	        37: 'left',
	        39: 'right',
	        35: 'end',
	        36: 'home',
	        32: 'spacebar'
	    };

	    var PRIVATE_FORMULA_CHECK = /(^_|[^a-z0-9]$)/i;

	    var FormulaInput = Widget.extend({
	        init: function(element, options) {
	            Widget.call(this, element, options);

	            element = this.element;

	            element.addClass(FormulaInput.classNames.wrapper)
	                .attr("contenteditable", true)
	                .attr("spellcheck", false)
	                .css("white-space", "pre");

	            if(options && options.formulaBarWidth) {
	                element.css("max-width", options.formulaBarWidth - 16 + "px");
	            }

	            if (this.options.autoScale) {
	                element.on("input", this.scale.bind(this));
	            }

	            this._highlightedRefs = [];

	            this._formulaSource();

	            this._formulaList();

	            this._popup();

	            this._tooltip();

	            element
	                .on("keydown", this._keydown.bind(this))
	                .on("keyup", this._keyup.bind(this))
	                .on("blur", this._blur.bind(this))
	                .on("input click", this._input.bind(this))
	                .on("focus", this._focus.bind(this))
	                .on("paste", this._paste.bind(this));
	        },

	        options: {
	            name: "FormulaInput",
	            autoScale: false,
	            filterOperator: "startswith",
	            scalePadding: 30,
	            minLength: 1,
	            formulaBarWidth: null
	        },

	        events: [
	            "keyup",
	            "focus"
	        ],

	        enable: function(enable) {
	            if (enable === undefined) {
	                return this.element.attr("contenteditable") === "true";
	            }

	            if (enable) {
	                this.element.attr("contenteditable", enable);
	            } else {
	                this.element.removeAttr("contenteditable");
	            }

	            this.element.toggleClass("k-state-disabled", !enable);
	        },

	        getPos: function() {
	            var div = this.element[0];
	            var sel = window.getSelection();
	            var a = lookup(sel.focusNode, sel.focusOffset);
	            var b = lookup(sel.anchorNode, sel.anchorOffset);
	            if (a != null && b != null) {
	                if (a > b) {
	                    var tmp = a;
	                    a = b;
	                    b = tmp;
	                }
	                return { begin: a, end: b, collapsed: a == b };
	            }
	            function lookup(lookupNode, pos) {
	                try {
	                    (function loop(node){
	                        if (node === lookupNode) {
	                            throw pos;
	                        } else if (node.nodeType == 1 /* Element */) {
	                            for (var i = node.firstChild; i; i = i.nextSibling) {
	                                loop(i);
	                            }
	                        } else if (node.nodeType == 3 /* Text */) {
	                            pos += node.nodeValue.length;
	                        }
	                    })(div);
	                } catch(index) {
	                    return index;
	                }
	            }
	        },

	        setPos: function(begin, end) {
	            var eiv = this.element[0];
	            begin = lookup(eiv, begin);
	            if (end != null) {
	                end = lookup(eiv, end);
	            } else {
	                end = begin;
	            }
	            if (begin && end) {
	                var range = document.createRange();
	                range.setStart(begin.node, begin.pos);
	                range.setEnd(end.node, end.pos);
	                var sel = window.getSelection();
	                var currentRange = sel.getRangeAt(0);
	                if (differ(range, currentRange))  {
	                    sel.removeAllRanges();
	                    sel.addRange(range);
	                }
	            }
	            function differ(a, b) {
	                return (
	                    a.startOffset != b.startOffset ||
	                    a.endOffset != b.endOffset ||
	                    a.startContainer != b.endContainer ||
	                    a.endContainer != b.endContainer
	                );
	            }
	            function lookup(node, pos) {
	                try {
	                    (function loop(node){
	                        if (node.nodeType == 3 /* Text */) {
	                            var len = node.nodeValue.length;
	                            if (len >= pos) {
	                                throw node;
	                            }
	                            pos -= len;
	                        } else if (node.nodeType == 1 /* Element */) {
	                            for (var i = node.firstChild; i; i = i.nextSibling) {
	                                loop(i);
	                            }
	                        }
	                    })(node);
	                } catch(el) {
	                    return { node: el, pos: pos };
	                }
	            }
	        },

	        end: function() {
	            this.setPos(this.length());
	        },

	        home: function() {
	            this.setPos(0);
	        },

	        select: function() {
	            this.setPos(0, this.length());
	        },

	        length: function() {
	            return this.value().length;
	        },

	        _formulaSource: function() {
	            var result = [];
	            var value;

	            for (var key in kendo.spreadsheet.calc.runtime.FUNCS) {
	                if (!PRIVATE_FORMULA_CHECK.test(key)) {
	                    value = key.toUpperCase();
	                    result.push({ value: value, text: value });
	                }
	            }

	            this.formulaSource = new kendo.data.DataSource({ data: result });
	        },

	        _formulaList: function() {
	            this.list = new kendo.ui.StaticList($('<ul />')
	                .addClass(FormulaInput.classNames.listWrapper)
	                .insertAfter(this.element), {
	                    autoBind: false,
	                    selectable: true,
	                    change: this._formulaListChange.bind(this),
	                    dataSource: this.formulaSource,
	                    dataValueField: "value",
	                    template: "#:data.value#"
	                });

	            this.list.element.on("mousedown", function(e) {
	                e.preventDefault();
	            });
	        },

	        _formulaListChange: function() {
	            var tokenCtx = this._tokenContext();

	            if (!tokenCtx || this._mute) {
	                return;
	            }

	            var activeToken = tokenCtx.token;
	            var completion = this.list.value()[0];
	            var ctx = {
	                replace: true,
	                token: activeToken,
	                end: activeToken.end
	            };

	            if (!tokenCtx.nextToken || tokenCtx.nextToken.value != "(") {
	                completion += "(";
	            }

	            this._replaceAt(ctx, completion);
	            this.popup.close();
	        },

	        _popup: function() {
	            this.popup = new kendo.ui.Popup(this.list.element, {
	                anchor: this.element
	            });
	        },

	        _blur: function() {
	            this.popup.close();
	            clearTimeout(this._focusId);
	            this.trigger("blur");
	        },

	        _isFormula: function() {
	            return /^=/.test(this.value());
	        },

	        _keydown: function(e) {
	            var key = e.keyCode;
	            var that = this;

	            if (KEY_NAMES[key]) {
	                that.popup.close();
	                that._navigated = true;
	            } else if (that._move(key)) {
	                that._navigated = true;
	                e.preventDefault();
	            }

	            that._keyDownTimeout = setTimeout(that._syntaxHighlight.bind(that));
	        },

	        _keyup: function() {
	            var popup = this.popup;
	            var value;

	            if (this._isFormula() && !this._navigated) {
	                value = ((this._tokenContext() || {}).token || {}).value;

	                this.filter(value);

	                if (!value || !this.formulaSource.view().length) {
	                    popup.close();
	                } else {
	                    popup[popup.visible() ? "position" : "open"]();
	                    this.list.focusFirst();
	                }
	            }

	            this._navigated = false;
	            this._syntaxHighlight();

	            this.trigger("keyup");
	        },

	        _input: function() {
	            this._syntaxHighlight();
	        },

	        _focus: function() {
	            setTimeout(this._sync.bind(this));
	            this._focusTimeout = setTimeout(this._syntaxHighlight.bind(this));
	            this.trigger("focus");
	        },

	        _paste: function(ev) {
	            ev.preventDefault();
	            var pos = this.getPos();
	            var text;
	            if (kendo.support.browser.msie) {
	                text = window.clipboardData.getData("Text");
	            } else {
	                text = ev.originalEvent.clipboardData.getData("text/plain");
	            }
	            var val = this.value();
	            val = val.substr(0, pos.begin) + text + val.substr(pos.end);
	            this.value(val);
	            this.setPos(pos.begin + text.length);
	            this.scale();
	        },

	        _move: function(key) {
	            var list = this.list;
	            var popup = this.popup;
	            if (popup.visible()) {
	                if (key === keys.DOWN) {
	                    list.focusNext();
	                    if (!list.focus()) {
	                        list.focusFirst();
	                    }
	                    return true;
	                }
	                if (key === keys.UP) {
	                    list.focusPrev();
	                    if (!list.focus()) {
	                        list.focusLast();
	                    }
	                    return true;
	                }
	                if (key === keys.ENTER) {
	                    list.select(list.focus());
	                    popup.close();
	                    return true;
	                }
	                if (key === keys.TAB) {
	                    list.select(list.focus());
	                    popup.close();
	                    return true;
	                }
	                if (key === keys.PAGEUP) {
	                    list.focusFirst();
	                    return true;
	                }
	                if (key === keys.PAGEDOWN) {
	                    list.focusLast();
	                    return true;
	                }
	            }
	            return key === keys.ENTER || key === keys.TAB;
	        },

	        _tokenContext: function() {
	            var point = this.getPos();
	            var value = this.value();

	            if (!value || !point || !point.collapsed) {
	                return null;
	            }

	            var tokens = kendo.spreadsheet.calc.tokenize(value, this.row(), this.col());
	            var tok;

	            for (var i = 0; i < tokens.length; ++i) {
	                tok = tokens[i];
	                if (touches(tok, point) && /^(?:str|sym|func)$/.test(tok.type)) {
	                    return { token: tok, nextToken: tokens[i + 1] };
	                }
	            }

	            return null;
	        },

	        _sync: function() {
	            if (this._editorToSync && this.isActive()) {
	                this._editorToSync.value(this.value());
	            }
	        },

	        _textContainer: function() {
	            var computedStyles = kendo.getComputedStyles(this.element[0], styles);

	            computedStyles.position = "absolute";
	            computedStyles.visibility = "hidden";
	            computedStyles.whiteSpace = "pre";
	            computedStyles.top = -3333;
	            computedStyles.left = -3333;

	            this._span = $("<span style='white-space: pre'/>").css(computedStyles).insertAfter(this.element);
	        },

	        _tooltip: function() {
	            this._cellTooltip = $('<div class="k-widget k-tooltip" style="position:absolute; display:none">A1</div>').insertAfter(this.element);
	        },

	        tooltip: function(value) {
	            this._cellTooltip.text(value);
	        },

	        toggleTooltip: function(show) {
	            this._cellTooltip.toggle(show);
	        },

	        isActive: function() {
	            return this.element[0] === kendo._activeElement();
	        },

	        filter: function(value) {
	            if (!value || value.length < this.options.minLength) {
	                return;
	            }

	            this._mute = true;
	            this.list.select(-1);
	            this._mute = false;

	            this.formulaSource.filter({
	                field: this.list.options.dataValueField,
	                operator: this.options.filterOperator,
	                value: value
	            });
	        },

	        hide: function() {
	            this.enable(false);
	            this.element.hide();
	            this._cellTooltip.hide();
	        },

	        show: function() {
	            this.enable(true);
	            this.element.show();
	        },

	        row: function() {
	            if (this.activeCell) {
	                return this.activeCell.row;
	            }
	        },

	        col: function() {
	            if (this.activeCell) {
	                return this.activeCell.col;
	            }
	        },

	        position: function(rectangle) {
	            if (!rectangle) {
	                return;
	            }

	            this.show();

	            this.element
	                .css({
	                    "top": rectangle.top + 1 + "px",
	                    "left": rectangle.left + 1 + "px"
	                });

	            this._cellTooltip.css({
	                "top": (rectangle.top - this._cellTooltip.height() - 10) + "px",
	                "left": rectangle.left
	            });
	        },

	        resize: function(rectangle) {
	            if (!rectangle) {
	                return;
	            }

	            this.element.css({
	                width: rectangle.width - 1,
	                height: rectangle.height - 1
	            });
	        },

	        canInsertRef: function(isKeyboardAction) {
	            return this._canInsertRef(isKeyboardAction);
	        },

	        _canInsertRef: function(isKeyboardAction) {
	            if (this.popup.visible()) {
	                return null;
	            }
	            var strictMode = isKeyboardAction;
	            var point = this.getPos();
	            var tokens, tok;

	            if (point && this._isFormula()) {
	                if (point.begin === 0) {
	                    return null;
	                }

	                tokens = kendo.spreadsheet.calc.tokenize(this.value(), this.row(), this.col());

	                for (var i = 0; i < tokens.length; ++i) {
	                    tok = tokens[i];
	                    if (touches(tok, point)) {
	                        return canReplace(tok);
	                    }
	                    if (afterPoint(tok)) {
	                        return canInsertBetween(tokens[i-1], tok);
	                    }
	                }
	                return canInsertBetween(tok, null);
	            }

	            return null;

	            function afterPoint(tok) {
	                return tok.begin > point.begin;
	            }
	            function canReplace(tok) {
	                if (tok) {
	                    if (/^(?:num|str|bool|sym|ref)$/.test(tok.type)) {
	                        return { replace: true, token: tok, end: tok.end };
	                    }
	                    if (/^(?:op|punc|startexp)$/.test(tok.type)) {
	                        if (tok.end == point.end) {
	                            return canInsertBetween(tok, tokens[i+1]);
	                        }
	                        return canInsertBetween(tokens[i-1], tok);
	                    }
	                }
	            }
	            function canInsertBetween(left, right) {
	                if (left == null) {
	                    return null;
	                }
	                if (right == null) {
	                    if (/^(?:op|startexp)$/.test(left.type) || isOpenParen(left.value)) {
	                        return { token: left, end: point.end };
	                    }
	                    return null;
	                }
	                if (strictMode) {
	                    if (left.type == "op" && /^(?:punc|op)$/.test(right.type)) {
	                        return { token: left, end: point.end };
	                    }
	                } else {
	                    if (left.type == "startexp") {
	                        return { token: left, end: point.end };
	                    }
	                    if (/^(?:op|punc)$/.test(left.type) && /^[,;({]$/.test(left.value)) {
	                        return { token: left, end: point.end };
	                    }
	                    if (/^(?:ref|sym)/.test(left.type)) {
	                        return { token: left, replace: true, end: left.end };
	                    }
	                    if (/^(?:ref|sym)/.test(right.type)) {
	                        return { token: right, replace: true, end: right.end };
	                    }
	                }
	                return false;
	            }
	        },

	        refAtPoint: function(sheet) {
	            var x = this._canInsertRef();
	            if (x) {
	                var ref = sheet.selection()._ref.simplify().clone().relative(0, 0, 3);
	                if (sheet !== this.activeSheet) {
	                    ref = ref.setSheet(sheet.name(), true);
	                }
	                this._replaceAt(x, ref.print(0, 0));
	            }
	        },

	        _replaceAt: function(ctx, newValue) {
	            var value = this.value();
	            var tok = ctx.token;
	            var rest = value.substr(ctx.end);
	            value = value.substr(0, ctx.replace ? tok.begin : ctx.end) + newValue;
	            var point = value.length;
	            value += rest;
	            this._value(value);
	            this.setPos(point);
	            this.scale();
	            this._syntaxHighlight();
	        },

	        syncWith: function(formulaInput) {
	            var self = this;

	            // IE does not support "input" event on elements with contenteditable
	            // https://developer.mozilla.org/en-US/docs/Web/Events/input#Browser_compatibility
	            var eventName = "input" + ns;
	            var handler = self._sync.bind(self), iehandler;
	            if (kendo.support.browser.msie) {
	                eventName = "keydown" + ns;
	                iehandler = function() {
	                    setTimeout(handler);
	                };
	            }

	            self._editorToSync = formulaInput;
	            self.element.off(eventName).on(eventName, iehandler || handler);
	        },

	        scale: function() {
	            var element = this.element;
	            var width, height;

	            if (!this._span) {
	                this._textContainer();
	            }

	            this._span.html(element.html());

	            width = this._span.width() + this.options.scalePadding;
	            height = this._span.height();

	            if (width > element.width()) {
	                element.width(width);
	            }
	            if (height > element.height()) {
	                element.height(height);
	            }

	            this._sync();
	        },

	        _value: function(value) {
	            this.element.text(value);
	        },

	        value: function(value) {
	            if (value === undefined) {
	                // jQuery's .text() discards the newlines for some reason
	                var txt = this.element[0].innerText;
	                return txt.replace(/\n$/, "");
	            }

	            this._value(value);
	            this._syntaxHighlight();
	        },

	        highlightedRefs: function() {
	            return this._highlightedRefs.slice();
	        },

	        _syntaxHighlight: function() {
	            var pos = this.getPos();
	            var value = this.value();
	            var refClasses = kendo.spreadsheet.Pane.classNames.series;
	            var highlightedRefs = [];
	            var refIndex = 0;
	            var parens = [];
	            var tokens = [];
	            var activeToken;

	            if (pos && !pos.collapsed) {
	                // Backward selection (hold shift, move right to left)
	                // will not work properly if we continuously re-set
	                // the HTML.  If the selection is on, presumably the
	                // text has already been highlighted, so stop here.
	                return;
	            }

	            if (!(/^=/.test(value))) {
	                // if an user deleted the initial =, reset the text to
	                // discard any highlighting.  Only do that once.
	                if (this._highlightedRefs.length) {
	                    this._highlightedRefs = [];
	                    this.element.text(value);
	                }

	                // also make sure the completion popup goes away
	                if (this.popup) {
	                    this.popup.close();
	                }

	                return; // avoid messing with the cursor position below
	            } else {
	                tokens = kendo.spreadsheet.calc.tokenize(value, this.row(), this.col());
	                tokens.forEach(function(tok){
	                    tok.active = false;
	                    tok.cls = [ "k-syntax-" + tok.type ];

	                    if (tok.type == "ref") {
	                        tok.colorClass = refClasses[(refIndex++) % refClasses.length];
	                        tok.cls.push(tok.colorClass);
	                        highlightedRefs.push(tok);
	                    }
	                    if (pos && tok.type == "punc") {
	                        if (isOpenParen(tok.value)) {
	                            parens.unshift(tok);
	                        } else if (isCloseParen(tok.value)) {
	                            var open = parens.shift();
	                            if (open) {
	                                if (isMatchingParen(tok.value, open.value)) {
	                                    if (touches(tok, pos) || touches(open, pos)) {
	                                        tok.cls.push("k-syntax-paren-match");
	                                        open.cls.push("k-syntax-paren-match");
	                                    }
	                                } else {
	                                    tok.cls.push("k-syntax-error");
	                                    open.cls.push("k-syntax-error");
	                                }
	                            } else {
	                                tok.cls.push("k-syntax-error");
	                            }
	                        }
	                    }
	                    if (pos && touches(tok, pos)) {
	                        tok.cls.push("k-syntax-at-point");
	                        tok.active = true;
	                        activeToken = tok;
	                    }
	                    if (tok.type == "func" && !knownFunction(tok.value) && (!pos || !touches(tok, pos))) {
	                        tok.cls.push("k-syntax-error");
	                    }
	                });
	                tokens.reverse().forEach(function(tok){
	                    var begin = tok.begin, end = tok.end;
	                    var text = kendo.htmlEncode(value.substring(begin, end));
	                    value = value.substr(0, begin) +
	                        "<span class='" + tok.cls.join(" ") + "'>" + text + "</span>" +
	                        value.substr(end);
	                });
	                this.element.html(value);
	            }
	            if (pos) {
	                this.setPos(pos.begin, pos.end);
	            }

	            this._highlightedRefs = highlightedRefs;
	        },

	        destroy: function() {
	            this._editorToSync = null;

	            this.element.off(ns);

	            clearTimeout(this._focusTimeout);
	            clearTimeout(this._keyDownTimeout);

	            this._cellTooltip = null;
	            this._span = null;

	            this.popup.destroy();
	            this.popup = null;

	            Widget.fn.destroy.call(this);
	        },

	        insertNewline: function() {
	            var val = this.value();
	            var pos = this.getPos();
	            var eof = pos.end == val.length;
	            val = val.substr(0, pos.begin) + (eof ? "\n\n" : "\n" + val.substr(pos.end));
	            this.value(val);
	            this.setPos(pos.begin + 1);
	        }
	    });

	    function isOpenParen(ch) {
	        return ch == "(" || ch == "[" || ch == "{";
	    }

	    function isCloseParen(ch) {
	        return ch == ")" || ch == "]" || ch == "}";
	    }

	    function isMatchingParen(close, open) {
	        return open == "(" ? close == ")"
	            :  open == "[" ? close == "]"
	            :  open == "{" ? close == "}"
	            :  false;
	    }

	    function touches(pos, target) {
	        return pos.begin <= target.begin && pos.end >= target.end;
	    }

	    function knownFunction(name) {
	        return kendo.spreadsheet.calc.runtime.FUNCS[name.toLowerCase()];
	    }

	    kendo.spreadsheet.FormulaInput = FormulaInput;
	    $.extend(true, FormulaInput, { classNames: classNames });
	})(kendo, window);
	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "fkB2":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("UuGF");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "fuGk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "fxGZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var column_1 = __webpack_require__("hDyE");
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var columnApi_1 = __webpack_require__("E/Wy");
var columnController_1 = __webpack_require__("77lH");
var eventService_1 = __webpack_require__("k5uU");
var events_1 = __webpack_require__("3ok8");
var context_2 = __webpack_require__("RQ1/");
var utils_1 = __webpack_require__("IRr6");
var gridApi_1 = __webpack_require__("BAow");
var SortController = (function () {
    function SortController() {
    }
    SortController_1 = SortController;
    SortController.prototype.progressSort = function (column, multiSort, source) {
        if (source === void 0) { source = "api"; }
        var nextDirection = this.getNextSortDirection(column);
        this.setSortForColumn(column, nextDirection, multiSort, source);
    };
    SortController.prototype.setSortForColumn = function (column, sort, multiSort, source) {
        if (source === void 0) { source = "api"; }
        // auto correct - if sort not legal value, then set it to 'no sort' (which is null)
        if (sort !== column_1.Column.SORT_ASC && sort !== column_1.Column.SORT_DESC) {
            sort = null;
        }
        // update sort on current col
        column.setSort(sort, source);
        // sortedAt used for knowing order of cols when multi-col sort
        if (column.getSort()) {
            var sortedAt = Number(new Date().valueOf());
            column.setSortedAt(sortedAt);
        }
        else {
            column.setSortedAt(null);
        }
        var doingMultiSort = multiSort && !this.gridOptionsWrapper.isSuppressMultiSort();
        // clear sort on all columns except this one, and update the icons
        if (!doingMultiSort) {
            this.clearSortBarThisColumn(column, source);
        }
        this.dispatchSortChangedEvents();
    };
    // gets called by API, so if data changes, use can call this, which will end up
    // working out the sort order again of the rows.
    SortController.prototype.onSortChanged = function () {
        this.dispatchSortChangedEvents();
    };
    SortController.prototype.dispatchSortChangedEvents = function () {
        var event = {
            type: events_1.Events.EVENT_SORT_CHANGED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(event);
    };
    SortController.prototype.clearSortBarThisColumn = function (columnToSkip, source) {
        this.columnController.getPrimaryAndSecondaryAndAutoColumns().forEach(function (columnToClear) {
            // Do not clear if either holding shift, or if column in question was clicked
            if (!(columnToClear === columnToSkip)) {
                columnToClear.setSort(null, source);
            }
        });
    };
    SortController.prototype.getNextSortDirection = function (column) {
        var sortingOrder;
        if (column.getColDef().sortingOrder) {
            sortingOrder = column.getColDef().sortingOrder;
        }
        else if (this.gridOptionsWrapper.getSortingOrder()) {
            sortingOrder = this.gridOptionsWrapper.getSortingOrder();
        }
        else {
            sortingOrder = SortController_1.DEFAULT_SORTING_ORDER;
        }
        if (!Array.isArray(sortingOrder) || sortingOrder.length <= 0) {
            console.warn('ag-grid: sortingOrder must be an array with at least one element, currently it\'s ' + sortingOrder);
            return;
        }
        var currentIndex = sortingOrder.indexOf(column.getSort());
        var notInArray = currentIndex < 0;
        var lastItemInArray = currentIndex == sortingOrder.length - 1;
        var result;
        if (notInArray || lastItemInArray) {
            result = sortingOrder[0];
        }
        else {
            result = sortingOrder[currentIndex + 1];
        }
        // verify the sort type exists, as the user could provide the sortingOrder, need to make sure it's valid
        if (SortController_1.DEFAULT_SORTING_ORDER.indexOf(result) < 0) {
            console.warn('ag-grid: invalid sort type ' + result);
            return null;
        }
        return result;
    };
    // used by the public api, for saving the sort model
    SortController.prototype.getSortModel = function () {
        var columnsWithSorting = this.getColumnsWithSortingOrdered();
        return utils_1.Utils.map(columnsWithSorting, function (column) {
            return {
                colId: column.getColId(),
                sort: column.getSort()
            };
        });
    };
    SortController.prototype.setSortModel = function (sortModel, source) {
        var _this = this;
        if (source === void 0) { source = "api"; }
        if (!this.gridOptionsWrapper.isEnableSorting()) {
            console.warn('ag-grid: You are setting the sort model on a grid that does not have sorting enabled');
            return;
        }
        // first up, clear any previous sort
        var sortModelProvided = sortModel && sortModel.length > 0;
        var allColumnsIncludingAuto = this.columnController.getPrimaryAndSecondaryAndAutoColumns();
        allColumnsIncludingAuto.forEach(function (column) {
            var sortForCol = null;
            var sortedAt = -1;
            if (sortModelProvided && !column.getColDef().suppressSorting) {
                for (var j = 0; j < sortModel.length; j++) {
                    var sortModelEntry = sortModel[j];
                    if (typeof sortModelEntry.colId === 'string'
                        && typeof column.getColId() === 'string'
                        && _this.compareColIds(sortModelEntry, column)) {
                        sortForCol = sortModelEntry.sort;
                        sortedAt = j;
                    }
                }
            }
            if (sortForCol) {
                column.setSort(sortForCol, source);
                column.setSortedAt(sortedAt);
            }
            else {
                column.setSort(null, source);
                column.setSortedAt(null);
            }
        });
        this.dispatchSortChangedEvents();
    };
    SortController.prototype.compareColIds = function (sortModelEntry, column) {
        return sortModelEntry.colId === column.getColId();
    };
    SortController.prototype.getColumnsWithSortingOrdered = function () {
        // pull out all the columns that have sorting set
        var allColumnsIncludingAuto = this.columnController.getPrimaryAndSecondaryAndAutoColumns();
        var columnsWithSorting = utils_1.Utils.filter(allColumnsIncludingAuto, function (column) { return !!column.getSort(); });
        // put the columns in order of which one got sorted first
        columnsWithSorting.sort(function (a, b) { return a.sortedAt - b.sortedAt; });
        return columnsWithSorting;
    };
    // used by row controller, when doing the sorting
    SortController.prototype.getSortForRowController = function () {
        var columnsWithSorting = this.getColumnsWithSortingOrdered();
        return utils_1.Utils.map(columnsWithSorting, function (column) {
            var ascending = column.getSort() === column_1.Column.SORT_ASC;
            return {
                inverter: ascending ? 1 : -1,
                column: column
            };
        });
    };
    SortController.DEFAULT_SORTING_ORDER = [column_1.Column.SORT_ASC, column_1.Column.SORT_DESC, null];
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], SortController.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], SortController.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], SortController.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], SortController.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], SortController.prototype, "gridApi", void 0);
    SortController = SortController_1 = __decorate([
        context_2.Bean('sortController')
    ], SortController);
    return SortController;
    var SortController_1;
}());
exports.SortController = SortController;


/***/ }),

/***/ "g3du":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(998);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 971:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("cmba");

/***/ }),

/***/ 998:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(971) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {

	var kendo = window.kendo,
	    extend = $.extend,
	    Editor = kendo.ui.editor,
	    EditorUtils = Editor.EditorUtils,
	    Command = Editor.Command,
	    Tool = Editor.Tool,
	    ToolTemplate = Editor.ToolTemplate,
	    dom = Editor.Dom;

	var ViewHtmlCommand = Command.extend({
	    init: function(options) {
	        var cmd = this;
	        cmd.options = options;
	        Command.fn.init.call(cmd, options);
	        cmd.attributes = null;
	        cmd.async = true;
	    },

	    exec: function() {
	        var that = this,
	            editor = that.editor,
	            options = editor.options,
	            messages = editor.options.messages,
	            dialog = $(kendo.template(ViewHtmlCommand.template)(messages)).appendTo(document.body),
	            textarea = ".k-editor-textarea",
	            content, comments;

	        options.serialization.immutables = editor.immutables;

	        comments = dom.getAllComments(editor.body);

	        content = EditorUtils.cacheComments(editor.value(), comments);
	        content = ViewHtmlCommand.indent(content);
	        content = EditorUtils.retrieveComments(content, comments);

	        options.serialization.immutables = undefined;

	        function apply(e) {
	            options.deserialization.immutables = editor.immutables;
	            editor.value(dialog.find(textarea).val());
	            options.deserialization.immutables = undefined;

	            close(e);

	            if (that.change) {
	                that.change();
	            }

	            editor.trigger("change");
	        }

	        function close(e) {
	            e.preventDefault();

	            dialog.data("kendoWindow").destroy();

	            if (editor.immutables) {
	                editor.immutables.serializedImmutables = {};
	            }

	            editor.focus();
	        }

	        this.createDialog(dialog, {
	            title: messages.viewHtml,
	            width: 600,
	            height: 400,
	            resizable: true,
	            close: close,
	            visible: false
	        })
	            .find(textarea).val(content).end()
	            .find(".k-dialog-update").click(apply).end()
	            .find(".k-dialog-close").click(close).end()
	            .data("kendoWindow").center().open();

	        dialog.find(textarea).focus();
	    }
	});

	extend(ViewHtmlCommand, {
	    template: "" +
	    "<div class='k-editor-dialog k-popup-edit-form k-viewhtml-dialog'>" +
	        "<textarea class='k-textarea k-editor-textarea'></textarea>" +
	        "<div class='k-edit-buttons k-state-default'>" +
	            "<button class='k-dialog-update k-button k-primary'>#: dialogUpdate #</button>" +
	            "<button class='k-dialog-close k-button'>#: dialogCancel #</button>" +
	        "</div>" +
	    "</div>",
	    indent: function(content) {
	        return content.replace(/<\/(p|li|ul|ol|h[1-6]|table|tr|td|th)>/ig, "</$1>\n")
	                      .replace(/<(ul|ol)([^>]*)><li/ig, "<$1$2>\n<li")
	                      .replace(/<br \/>/ig, "<br />\n")
	                      .replace(/\n$/, "");
	    }
	});

	kendo.ui.editor.ViewHtmlCommand = ViewHtmlCommand;

	Editor.EditorUtils.registerTool("viewHtml", new Tool({ command: ViewHtmlCommand, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "View HTML"})}));

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "gVfB":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1383);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1048:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("BOhp");

/***/ }),

/***/ 1190:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("JKVm");

/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1190) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "splitter",
	    name: "Splitter",
	    category: "web",
	    description: "The Splitter widget provides an easy way to create a dynamic layout of resizable and collapsible panes.",
	    depends: [ "resizable" ]
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        keys = kendo.keys,
	        extend = $.extend,
	        proxy = $.proxy,
	        Widget = ui.Widget,
	        pxUnitsRegex = /^\d+(\.\d+)?px$/i,
	        percentageUnitsRegex = /^\d+(\.\d+)?%$/i,
	        NS = ".kendoSplitter",
	        EXPAND = "expand",
	        COLLAPSE = "collapse",
	        CONTENTLOAD = "contentLoad",
	        ERROR = "error",
	        RESIZE = "resize",
	        LAYOUTCHANGE = "layoutChange",
	        HORIZONTAL = "horizontal",
	        VERTICAL = "vertical",
	        MOUSEENTER = "mouseenter",
	        CLICK = "click",
	        PANE = "pane",
	        MOUSELEAVE = "mouseleave",
	        FOCUSED = "k-state-focused",
	        KPANE = "k-" + PANE,
	        PANECLASS = "." + KPANE;

	    function isPercentageSize(size) {
	        return percentageUnitsRegex.test(size);
	    }

	    function isPixelSize(size) {
	        return pxUnitsRegex.test(size) || /^\d+$/.test(size);
	    }

	    function isFluid(size) {
	        return !isPercentageSize(size) && !isPixelSize(size);
	    }

	    function calculateSize(size, total) {
	        var output = parseInt(size, 10);

	        if (isPercentageSize(size)) {
	            output = Math.floor(output * total / 100);
	        }

	        return output;
	    }

	    function panePropertyAccessor(propertyName, triggersResize) {
	        return function(pane, value) {
	            var paneConfig = this.element.find(pane).data(PANE);

	            if (arguments.length == 1) {
	                return paneConfig[propertyName];
	            }

	            paneConfig[propertyName] = value;

	            if (triggersResize) {
	                var splitter = this.element.data("kendo" + this.options.name);
	                splitter.resize(true);
	            }
	        };
	    }

	    var Splitter = Widget.extend({
	        init: function(element, options) {
	            var that = this,
	                isHorizontal;

	            Widget.fn.init.call(that, element, options);

	            that.wrapper = that.element;

	            if(that.options.orientation){
	                isHorizontal = that.options.orientation.toLowerCase() != VERTICAL;
	            }

	            that.orientation = isHorizontal ? HORIZONTAL : VERTICAL;
	            that._dimension = isHorizontal ? "width" : "height";
	            that._keys = {
	                decrease: isHorizontal ? keys.LEFT : keys.UP,
	                increase: isHorizontal ? keys.RIGHT : keys.DOWN
	            };

	            that._resizeStep = 10;

	            that._marker = kendo.guid().substring(0, 8);

	            that._initPanes();

	            that.resizing = new PaneResizing(that);

	            that.element.triggerHandler("init" + NS);
	        },
	        events: [
	            EXPAND,
	            COLLAPSE,
	            CONTENTLOAD,
	            ERROR,
	            RESIZE,
	            LAYOUTCHANGE
	        ],

	        _addOverlays: function() {
	            this._panes().append("<div class='k-splitter-overlay k-overlay' />");
	        },

	        _removeOverlays: function() {
	            this._panes().children(".k-splitter-overlay").remove();
	        },

	        _attachEvents: function() {
	            var that = this,
	                orientation = that.options.orientation;

	            // do not use delegated events to increase performance of nested elements
	            that.element
	                .children(".k-splitbar-draggable-" + orientation)
	                    .on("keydown" + NS, proxy(that._keydown, that))
	                    .on("mousedown" + NS, function(e) { e.currentTarget.focus(); })
	                    .on("focus" + NS, function(e) { $(e.currentTarget).addClass(FOCUSED);  })
	                    .on("blur" + NS, function(e) { $(e.currentTarget).removeClass(FOCUSED);
	                        if (that.resizing) {
	                            that.resizing.end();
	                        }
	                    })
	                    .on(MOUSEENTER + NS, function() { $(this).addClass("k-splitbar-" + that.orientation + "-hover"); })
	                    .on(MOUSELEAVE + NS, function() { $(this).removeClass("k-splitbar-" + that.orientation + "-hover"); })
	                    .on("mousedown" + NS, proxy(that._addOverlays, that))
	                .end()
	                .children(".k-splitbar")
	                    .on("dblclick" + NS, proxy(that._togglePane, that))
	                    .children(".k-collapse-next, .k-collapse-prev").on(CLICK + NS, that._arrowClick(COLLAPSE)).end()
	                    .children(".k-expand-next, .k-expand-prev").on(CLICK + NS, that._arrowClick(EXPAND)).end()
	                .end();

	            $(window).on("resize" + NS + that._marker, proxy(that.resize, that, false));
	            $(document).on("mouseup" + NS + that._marker, proxy(that._removeOverlays, that));
	        },

	        _detachEvents: function() {
	            var that = this;

	            that.element
	                .children(".k-splitbar-draggable-" + that.orientation).off(NS).end()
	                .children(".k-splitbar").off("dblclick" + NS)
	                    .children(".k-collapse-next, .k-collapse-prev, .k-expand-next, .k-expand-prev").off(NS);

	            $(window).off(NS + that._marker);
	            $(document).off(NS + that._marker);
	        },

	        options: {
	            name: "Splitter",
	            orientation: HORIZONTAL,
	            panes: []
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            this._detachEvents();

	            if (this.resizing) {
	                this.resizing.destroy();
	            }

	            kendo.destroy(this.element);

	            this.wrapper = this.element = null;
	        },

	        _keydown: function(e) {
	            var that = this,
	                key = e.keyCode,
	                resizing = that.resizing,
	                target = $(e.currentTarget),
	                navigationKeys = that._keys,
	                increase = key === navigationKeys.increase,
	                decrease = key === navigationKeys.decrease,
	                pane;

	            if (increase || decrease) {
	                if (e.ctrlKey) {
	                    pane = target[decrease ? "next" : "prev"]();

	                    if (resizing && resizing.isResizing()) {
	                        resizing.end();
	                    }

	                    if (!pane[that._dimension]()) {
	                        that._triggerAction(EXPAND, pane);
	                    } else {
	                        that._triggerAction(COLLAPSE, target[decrease ? "prev" : "next"]());
	                    }
	                } else if (resizing) {
	                    resizing.move((decrease ? -1 : 1) * that._resizeStep, target);
	                }
	                e.preventDefault();
	            } else if (key === keys.HOME) {
	                resizing.move(-resizing._maxPosition, target);
	                e.preventDefault();
	            } else if (key === keys.END) {
	                resizing.move(resizing._maxPosition, target);
	                e.preventDefault();
	            } else if (key === keys.ENTER && resizing) {
	                resizing.end();
	                e.preventDefault();
	            }
	        },

	        _initPanes: function() {
	            var panesConfig = this.options.panes || [];
	            var that = this;

	            this.element
	                .addClass("k-widget").addClass("k-splitter")
	                .children()
	                    .each(function(i, pane) {
	                        if (pane.nodeName.toLowerCase() != "script") {
	                            that._initPane(pane, panesConfig[i]);
	                        }
	                    });

	            this.resize();
	        },

	        _initPane: function(pane, config) {
	            pane = $(pane)
	                .attr("role", "group")
	                .addClass(KPANE);

	            pane.data(PANE, config ? config : {})
	                .toggleClass("k-scrollable", config ? config.scrollable !== false : true);

	            this.ajaxRequest(pane);
	        },

	        ajaxRequest: function(pane, url, data) {
	            var that = this,
	                paneConfig;

	            pane = that.element.find(pane);
	            paneConfig = pane.data(PANE);

	            url = url || paneConfig.contentUrl;

	            if (url) {
	                pane.append("<span class='k-icon k-i-loading k-pane-loading' />");

	                if (kendo.isLocalUrl(url)) {
	                    jQuery.ajax({
	                        url: url,
	                        data: data || {},
	                        type: "GET",
	                        dataType: "html",
	                        success: function (data) {
	                            that.angular("cleanup", function(){ return { elements: pane.get() }; });
	                            pane.html(data);
	                            that.angular("compile", function(){ return { elements: pane.get() }; });

	                            that.trigger(CONTENTLOAD, { pane: pane[0] });
	                        },
	                        error: function (xhr, status) {
	                            that.trigger(ERROR, {
	                                pane: pane[0],
	                                status: status,
	                                xhr: xhr
	                            });
	                        }
	                    });
	                } else {
	                    pane.removeClass("k-scrollable")
	                        .html("<iframe src='" + url + "' frameborder='0' class='k-content-frame'>" +
	                                "This page requires frames in order to show content" +
	                              "</iframe>");
	                }
	            }
	        },

	        _triggerAction: function(type, pane) {
	            if (!this.trigger(type, { pane: pane[0] })) {
	                this[type](pane[0]);
	            }
	        },

	        _togglePane: function(e) {
	            var that = this,
	                target = $(e.target),
	                arrow;

	            if (target.closest(".k-splitter")[0] != that.element[0]) {
	                return;
	            }

	            arrow = target.children(".k-icon:not(.k-resize-handle)");

	            if (arrow.length !== 1) {
	                return;
	            }

	            if (arrow.is(".k-collapse-prev")) {
	                that._triggerAction(COLLAPSE, target.prev());
	            } else if (arrow.is(".k-collapse-next")) {
	                that._triggerAction(COLLAPSE, target.next());
	            } else if (arrow.is(".k-expand-prev")) {
	                that._triggerAction(EXPAND, target.prev());
	            } else if (arrow.is(".k-expand-next")) {
	                that._triggerAction(EXPAND, target.next());
	            }
	        },
	        _arrowClick: function (arrowType) {
	            var that = this;

	            return function(e) {
	                var target = $(e.target),
	                    pane;

	                if (target.closest(".k-splitter")[0] != that.element[0]) {
	                    return;
	                }

	                if (target.is(".k-" + arrowType + "-prev")) {
	                    pane = target.parent().prev();
	                } else {
	                    pane = target.parent().next();
	                }
	                that._triggerAction(arrowType, pane);
	            };
	        },
	        _updateSplitBar: function(splitbar, previousPane, nextPane) {
	            var catIconIf = function(iconType, condition) {
	                   return condition ? "<div class='k-icon " + iconType + "'></div>" : "";
	                },
	                orientation = this.orientation,
	                draggable = (previousPane.resizable !== false) && (nextPane.resizable !== false),
	                prevCollapsible = previousPane.collapsible,
	                prevCollapsed = previousPane.collapsed,
	                nextCollapsible = nextPane.collapsible,
	                nextCollapsed = nextPane.collapsed;

	            splitbar.addClass("k-splitbar k-state-default k-splitbar-" + orientation)
	                    .attr("role", "separator")
	                    .attr("aria-expanded", !(prevCollapsed || nextCollapsed))
	                    .removeClass("k-splitbar-" + orientation + "-hover")
	                    .toggleClass("k-splitbar-draggable-" + orientation,
	                        draggable && !prevCollapsed && !nextCollapsed)
	                    .toggleClass("k-splitbar-static-" + orientation,
	                        !draggable && !prevCollapsible && !nextCollapsible)
	                    .html(
	                        catIconIf("k-collapse-prev k-i-arrow-60-up", prevCollapsible && !prevCollapsed && !nextCollapsed && orientation == VERTICAL) +
	                        catIconIf("k-collapse-prev k-i-arrow-60-left", prevCollapsible && !prevCollapsed && !nextCollapsed && orientation == HORIZONTAL) +
	                        catIconIf("k-expand-prev k-i-arrow-60-down", prevCollapsible && prevCollapsed && !nextCollapsed && orientation == VERTICAL) +
	                        catIconIf("k-expand-prev k-i-arrow-60-right", prevCollapsible && prevCollapsed && !nextCollapsed && orientation == HORIZONTAL) +
	                        catIconIf("k-resize-handle k-i-hbar", draggable && orientation == VERTICAL) +
	                        catIconIf("k-resize-handle k-i-vbar", draggable && orientation == HORIZONTAL) +
	                        catIconIf("k-collapse-next k-i-arrow-60-down", nextCollapsible && !nextCollapsed && !prevCollapsed && orientation == VERTICAL) +
	                        catIconIf("k-collapse-next k-i-arrow-60-right", nextCollapsible && !nextCollapsed && !prevCollapsed && orientation == HORIZONTAL) +
	                        catIconIf("k-expand-next k-i-arrow-60-up", nextCollapsible && nextCollapsed && !prevCollapsed && orientation == VERTICAL) +
	                        catIconIf("k-expand-next k-i-arrow-60-left", nextCollapsible && nextCollapsed && !prevCollapsed && orientation == HORIZONTAL)
	                    );

	            if (!draggable && !prevCollapsible && !nextCollapsible) {
	                splitbar.removeAttr("tabindex");
	            }
	        },
	        _updateSplitBars: function() {
	            var that = this;

	            this.element.children(".k-splitbar").each(function() {
	                var splitbar = $(this),
	                    previousPane = splitbar.prevAll(PANECLASS).first().data(PANE),
	                    nextPane = splitbar.nextAll(PANECLASS).first().data(PANE);

	                if (!nextPane) {
	                    return;
	                }

	                that._updateSplitBar(splitbar, previousPane, nextPane);
	            });
	        },
	        _removeSplitBars: function() {
	            this.element.children(".k-splitbar").remove();
	        },
	        _panes: function() {
	            if (!this.element) {
	                return $();
	            }
	            return this.element.children(PANECLASS);
	        },

	        _resize: function() {
	            var that = this,
	                element = that.element,
	                panes = element.children(PANECLASS),
	                isHorizontal = that.orientation == HORIZONTAL,
	                splitBars = element.children(".k-splitbar"),
	                splitBarsCount = splitBars.length,
	                sizingProperty = isHorizontal ? "width" : "height",
	                totalSize = element[sizingProperty]();

	            that.wrapper.addClass("k-splitter-resizing");

	            if (splitBarsCount === 0) {
	                splitBarsCount = panes.length - 1;
	                panes.slice(0, splitBarsCount)
	                     .after("<div tabindex='0' class='k-splitbar' data-marker='" + that._marker + "' />");

	                that._updateSplitBars();
	                splitBars = element.children(".k-splitbar");
	            } else {
	                that._updateSplitBars();
	            }

	            // discard splitbar sizes from total size
	            splitBars.each(function() {
	                totalSize -= this[isHorizontal ? "offsetWidth" : "offsetHeight"];
	            });

	            var sizedPanesWidth = 0,
	                sizedPanesCount = 0,
	                freeSizedPanes = $();

	            panes.css({ position: "absolute", top: 0 })
	                [sizingProperty](function() {
	                    var element = $(this),
	                        config = element.data(PANE) || {}, size;

	                    element.removeClass("k-state-collapsed");
	                    if (config.collapsed) {
	                        size = config.collapsedSize ? calculateSize(config.collapsedSize, totalSize) : 0;
	                        element.css("overflow", "hidden").addClass("k-state-collapsed");
	                    } else if (isFluid(config.size)) {
	                        freeSizedPanes = freeSizedPanes.add(this);
	                        return;
	                    } else { // sized in px/%, not collapsed
	                        size = calculateSize(config.size, totalSize);
	                    }

	                    sizedPanesCount++;
	                    sizedPanesWidth += size;

	                    return size;
	                });

	            totalSize -= sizedPanesWidth;

	            var freeSizePanesCount = freeSizedPanes.length,
	                freeSizePaneWidth = Math.floor(totalSize / freeSizePanesCount);

	            freeSizedPanes
	                .slice(0, freeSizePanesCount - 1)
	                    .css(sizingProperty, freeSizePaneWidth)
	                .end()
	                .eq(freeSizePanesCount - 1)
	                    .css(sizingProperty, totalSize - (freeSizePanesCount - 1) * freeSizePaneWidth);

	            // arrange panes
	            var sum = 0,
	                alternateSizingProperty = isHorizontal ? "height" : "width",
	                positioningProperty = isHorizontal ? "left" : "top",
	                sizingDomProperty = isHorizontal ? "offsetWidth" : "offsetHeight";

	            if (freeSizePanesCount === 0) {
	                var lastNonCollapsedPane = panes.filter(function() {
	                    return !(($(this).data(PANE) || {}).collapsed);
	                }).last();

	                lastNonCollapsedPane[sizingProperty](totalSize + lastNonCollapsedPane[0][sizingDomProperty]);
	            }

	            element.children()
	                .css(alternateSizingProperty, element[alternateSizingProperty]())
	                .each(function (i, child) {
	                    if (child.tagName.toLowerCase() != "script") {
	                        child.style[positioningProperty] = Math.floor(sum) + "px";
	                        sum += child[sizingDomProperty];
	                    }
	                });

	            that._detachEvents();
	            that._attachEvents();

	            that.wrapper.removeClass("k-splitter-resizing");

	            kendo.resize(panes);
	            that.trigger(LAYOUTCHANGE);
	        },

	        toggle: function(pane, expand) {
	            var that = this,
	                paneConfig;

	            pane = that.element.find(pane);
	            paneConfig = pane.data(PANE);

	            if (!expand && !paneConfig.collapsible) {
	                return;
	            }

	            if (arguments.length == 1) {
	                expand = paneConfig.collapsed === undefined ? false : paneConfig.collapsed;
	            }

	            paneConfig.collapsed = !expand;

	            if (paneConfig.collapsed) {
	                pane.css("overflow", "hidden");
	            } else {
	                pane.css("overflow", "");
	            }

	            that.resize(true);
	        },

	        collapse: function(pane) {
	            this.toggle(pane, false);
	        },

	        expand: function(pane) {
	            this.toggle(pane, true);
	        },

	        _addPane: function(config, idx, paneElement) {
	            var that = this;

	            if (paneElement.length) {
	                that.options.panes.splice(idx, 0, config);
	                that._initPane(paneElement, config);

	                that._removeSplitBars();

	                that.resize(true);
	            }

	            return paneElement;
	        },

	        append: function(config) {
	            config = config || {};

	            var that = this,
	                paneElement = $("<div />").appendTo(that.element);

	            return that._addPane(config, that.options.panes.length, paneElement);
	        },

	        insertBefore: function(config, referencePane) {
	            referencePane = $(referencePane);
	            config = config || {};

	            var that = this,
	                idx = that.wrapper.children(".k-pane").index(referencePane),
	                paneElement = $("<div />").insertBefore($(referencePane));

	            return that._addPane(config, idx, paneElement);
	        },

	        insertAfter: function(config, referencePane) {
	            referencePane = $(referencePane);
	            config = config || {};

	            var that = this,
	                idx = that.wrapper.children(".k-pane").index(referencePane),
	                paneElement = $("<div />").insertAfter($(referencePane));

	            return that._addPane(config, idx + 1, paneElement);
	        },

	        remove: function(pane) {
	            var that = this;
	            pane = that.wrapper.find(pane);

	            if (pane.length) {
	                kendo.destroy(pane);
	                pane.each(function(idx, element){
	                    that.options.panes.splice(that.wrapper.children(".k-pane").index(element), 1);
	                    $(element).remove();
	                });

	                that._removeSplitBars();

	                if (that.options.panes.length) {
	                    that.resize(true);
	                }
	            }

	            return that;
	        },

	        size: panePropertyAccessor("size", true),

	        min: panePropertyAccessor("min"),

	        max: panePropertyAccessor("max")
	    });

	    ui.plugin(Splitter);

	    var verticalDefaults = {
	            sizingProperty: "height",
	            sizingDomProperty: "offsetHeight",
	            alternateSizingProperty: "width",
	            positioningProperty: "top",
	            mousePositioningProperty: "pageY"
	        };

	    var horizontalDefaults = {
	            sizingProperty: "width",
	            sizingDomProperty: "offsetWidth",
	            alternateSizingProperty: "height",
	            positioningProperty: "left",
	            mousePositioningProperty: "pageX"
	        };

	    function PaneResizing(splitter) {
	        var that = this,
	            orientation = splitter.orientation;

	        that.owner = splitter;
	        that._element = splitter.element;
	        that.orientation = orientation;

	        extend(that, orientation === HORIZONTAL ? horizontalDefaults : verticalDefaults);

	        that._resizable = new kendo.ui.Resizable(splitter.element, {
	            orientation: orientation,
	            handle: ".k-splitbar-draggable-" + orientation + "[data-marker=" + splitter._marker + "]",
	            hint: proxy(that._createHint, that),
	            start: proxy(that._start, that),
	            max: proxy(that._max, that),
	            min: proxy(that._min, that),
	            invalidClass:"k-restricted-size-" + orientation,
	            resizeend: proxy(that._stop, that)
	        });
	    }

	    PaneResizing.prototype = {
	        press: function(target) {
	            this._resizable.press(target);
	        },

	        move: function(delta, target) {
	            if (!this.pressed) {
	                this.press(target);
	                this.pressed = true;
	            }

	            if (!this._resizable.target) {
	                this._resizable.press(target);
	            }

	            this._resizable.move(delta);
	        },

	        end: function() {
	            this._resizable.end();
	            this.pressed = false;
	        },

	        destroy: function() {
	            this._resizable.destroy();
	            this._resizable = this._element = this.owner = null;
	        },

	        isResizing: function() {
	            return this._resizable.resizing;
	        },

	        _createHint: function(handle) {
	            var that = this;
	            return $("<div class='k-ghost-splitbar k-ghost-splitbar-" + that.orientation + " k-state-default' />")
	                        .css(that.alternateSizingProperty, handle[that.alternateSizingProperty]());
	        },

	        _start: function(e) {
	            var that = this,
	                splitbar = $(e.currentTarget),
	                previousPane = splitbar.prev(),
	                nextPane = splitbar.next(),
	                previousPaneConfig = previousPane.data(PANE),
	                nextPaneConfig = nextPane.data(PANE),
	                prevBoundary = parseInt(previousPane[0].style[that.positioningProperty], 10),
	                nextBoundary = parseInt(nextPane[0].style[that.positioningProperty], 10) + nextPane[0][that.sizingDomProperty] - splitbar[0][that.sizingDomProperty],
	                totalSize = parseInt(that._element.css(that.sizingProperty), 10),
	                toPx = function (value) {
	                    var val = parseInt(value, 10);
	                    return (isPixelSize(value) ? val : (totalSize * val) / 100) || 0;
	                },
	                prevMinSize = toPx(previousPaneConfig.min),
	                prevMaxSize = toPx(previousPaneConfig.max) || nextBoundary - prevBoundary,
	                nextMinSize = toPx(nextPaneConfig.min),
	                nextMaxSize = toPx(nextPaneConfig.max) || nextBoundary - prevBoundary;

	            that.previousPane = previousPane;
	            that.nextPane = nextPane;
	            that._maxPosition = Math.min(nextBoundary - nextMinSize, prevBoundary + prevMaxSize);
	            that._minPosition = Math.max(prevBoundary + prevMinSize, nextBoundary - nextMaxSize);
	        },
	        _max: function() {
	              return this._maxPosition;
	        },
	        _min: function() {
	            return this._minPosition;
	        },
	        _stop: function(e) {
	            var that = this,
	                splitbar = $(e.currentTarget),
	                owner = that.owner;

	            owner._panes().children(".k-splitter-overlay").remove();

	            if (e.keyCode !== kendo.keys.ESC) {
	                var ghostPosition = e.position,
	                    previousPane = splitbar.prev(),
	                    nextPane = splitbar.next(),
	                    previousPaneConfig = previousPane.data(PANE),
	                    nextPaneConfig = nextPane.data(PANE),
	                    previousPaneNewSize = ghostPosition - parseInt(previousPane[0].style[that.positioningProperty], 10),
	                    nextPaneNewSize = parseInt(nextPane[0].style[that.positioningProperty], 10) + nextPane[0][that.sizingDomProperty] - ghostPosition - splitbar[0][that.sizingDomProperty],
	                    fluidPanesCount = that._element.children(PANECLASS).filter(function() { return isFluid($(this).data(PANE).size); }).length;

	                if (!isFluid(previousPaneConfig.size) || fluidPanesCount > 1) {
	                    if (isFluid(previousPaneConfig.size)) {
	                        fluidPanesCount--;
	                    }

	                    previousPaneConfig.size = previousPaneNewSize + "px";
	                }

	                if (!isFluid(nextPaneConfig.size) || fluidPanesCount > 1) {
	                    nextPaneConfig.size = nextPaneNewSize + "px";
	                }

	                owner.resize(true);
	            }

	            return false;
	        }
	    };

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1048)))

/***/ })

/******/ });

/***/ }),

/***/ "gv34":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var componentUtil_1 = __webpack_require__("f42d");
var grid_1 = __webpack_require__("5ela");
var registered = false;
function initialiseAgGridWithWebComponents() {
    console.warn('ag-grid: initialiseAgGridWithWebComponents is deprecated. Please use the ag-grid-webcomponent dependency instead. ');
    // only register to WebComponents once
    if (registered) {
        return;
    }
    registered = true;
    if (typeof document === 'undefined' || !document.registerElement) {
        console.error('ag-Grid: unable to find document.registerElement() function, unable to initialise ag-Grid as a Web Component');
    }
    // i don't think this type of extension is possible in TypeScript, so back to
    // plain Javascript to create this object
    var AgileGridProto = Object.create(HTMLElement.prototype);
    // wrap each property with a get and set method, so we can track when changes are done
    componentUtil_1.ComponentUtil.ALL_PROPERTIES.forEach(function (key) {
        Object.defineProperty(AgileGridProto, key, {
            set: function (v) {
                this.__agGridSetProperty(key, v);
            },
            get: function () {
                return this.__agGridGetProperty(key);
            },
            enumerable: true,
            configurable: true
        });
    });
    var agGridProtoNoType = AgileGridProto;
    agGridProtoNoType.__agGridSetProperty = function (key, value) {
        if (!this.__attributes) {
            this.__attributes = {};
        }
        this.__attributes[key] = value;
        // keeping this consistent with the ng2 onChange, so I can reuse the handling code
        var changeObject = {};
        changeObject[key] = { currentValue: value };
        this.onChange(changeObject);
    };
    agGridProtoNoType.onChange = function (changes) {
        if (this._initialised) {
            componentUtil_1.ComponentUtil.processOnChange(changes, this._gridOptions, this.api, this.columnApi);
        }
    };
    agGridProtoNoType.__agGridGetProperty = function (key) {
        if (!this.__attributes) {
            this.__attributes = {};
        }
        return this.__attributes[key];
    };
    agGridProtoNoType.setGridOptions = function (options) {
        var globalEventListener = this.globalEventListener.bind(this);
        this._gridOptions = componentUtil_1.ComponentUtil.copyAttributesToGridOptions(options, this);
        var gridParams = {
            globalEventListener: globalEventListener
        };
        this._agGrid = new grid_1.Grid(this, this._gridOptions, gridParams);
        this.api = options.api;
        this.columnApi = options.columnApi;
        this._initialised = true;
    };
    // copies all the attributes into this object
    agGridProtoNoType.createdCallback = function () {
        for (var i = 0; i < this.attributes.length; i++) {
            var attribute = this.attributes[i];
            this.setPropertyFromAttribute(attribute);
        }
    };
    agGridProtoNoType.setPropertyFromAttribute = function (attribute) {
        var name = toCamelCase(attribute.nodeName);
        var value = attribute.nodeValue;
        if (componentUtil_1.ComponentUtil.ALL_PROPERTIES.indexOf(name) >= 0) {
            this[name] = value;
        }
    };
    agGridProtoNoType.attachedCallback = function (params) { };
    agGridProtoNoType.detachedCallback = function (params) { };
    agGridProtoNoType.attributeChangedCallback = function (attributeName) {
        var attribute = this.attributes[attributeName];
        this.setPropertyFromAttribute(attribute);
    };
    agGridProtoNoType.globalEventListener = function (eventType, event) {
        var eventLowerCase = eventType.toLowerCase();
        var browserEvent = new Event(eventLowerCase);
        var browserEventNoType = browserEvent;
        browserEventNoType.agGridDetails = event;
        this.dispatchEvent(browserEvent);
        var callbackMethod = 'on' + eventLowerCase;
        if (typeof this[callbackMethod] === 'function') {
            this[callbackMethod](browserEvent);
        }
    };
    // finally, register
    document.registerElement('ag-grid', { prototype: AgileGridProto });
}
exports.initialiseAgGridWithWebComponents = initialiseAgGridWithWebComponents;
function toCamelCase(myString) {
    if (typeof myString === 'string') {
        var result = myString.replace(/-([a-z])/g, function (g) {
            return g[1].toUpperCase();
        });
        return result;
    }
    else {
        return myString;
    }
}


/***/ }),

/***/ "h65t":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("UuGF");
var defined = __webpack_require__("52gC");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "hDyE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var eventService_1 = __webpack_require__("k5uU");
var utils_1 = __webpack_require__("IRr6");
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var columnUtils_1 = __webpack_require__("PAC5");
var columnApi_1 = __webpack_require__("E/Wy");
var gridApi_1 = __webpack_require__("BAow");
// Wrapper around a user provide column definition. The grid treats the column definition as ready only.
// This class contains all the runtime information about a column, plus some logic (the definition has no logic).
// This class implements both interfaces ColumnGroupChild and OriginalColumnGroupChild as the class can
// appear as a child of either the original tree or the displayed tree. However the relevant group classes
// for each type only implements one, as each group can only appear in it's associated tree (eg OriginalColumnGroup
// can only appear in OriginalColumn tree).
var Column = (function () {
    function Column(colDef, colId, primary) {
        this.moving = false;
        this.menuVisible = false;
        this.filterActive = false;
        this.eventService = new eventService_1.EventService();
        this.rowGroupActive = false;
        this.pivotActive = false;
        this.aggregationActive = false;
        this.colDef = colDef;
        this.visible = !colDef.hide;
        this.sort = colDef.sort;
        this.sortedAt = colDef.sortedAt;
        this.colId = colId;
        this.primary = primary;
        this.lockPosition = colDef.lockPosition === true;
        this.lockPinned = colDef.lockPinned === true;
        this.lockVisible = colDef.lockVisible === true;
    }
    Column.prototype.isLockPosition = function () {
        return this.lockPosition;
    };
    Column.prototype.isLockVisible = function () {
        return this.lockVisible;
    };
    Column.prototype.isLockPinned = function () {
        return this.lockPinned;
    };
    Column.prototype.setParent = function (parent) {
        this.parent = parent;
    };
    Column.prototype.getParent = function () {
        return this.parent;
    };
    // this is done after constructor as it uses gridOptionsWrapper
    Column.prototype.initialise = function () {
        this.setPinned(this.colDef.pinned);
        var minColWidth = this.gridOptionsWrapper.getMinColWidth();
        var maxColWidth = this.gridOptionsWrapper.getMaxColWidth();
        if (this.colDef.minWidth) {
            this.minWidth = this.colDef.minWidth;
        }
        else {
            this.minWidth = minColWidth;
        }
        if (this.colDef.maxWidth) {
            this.maxWidth = this.colDef.maxWidth;
        }
        else {
            this.maxWidth = maxColWidth;
        }
        this.actualWidth = this.columnUtils.calculateColInitialWidth(this.colDef);
        var suppressDotNotation = this.gridOptionsWrapper.isSuppressFieldDotNotation();
        this.fieldContainsDots = utils_1.Utils.exists(this.colDef.field) && this.colDef.field.indexOf('.') >= 0 && !suppressDotNotation;
        this.tooltipFieldContainsDots = utils_1.Utils.exists(this.colDef.tooltipField) && this.colDef.tooltipField.indexOf('.') >= 0 && !suppressDotNotation;
        this.validate();
    };
    Column.prototype.isEmptyGroup = function () {
        return false;
    };
    Column.prototype.isRowGroupDisplayed = function (colId) {
        if (utils_1.Utils.missing(this.colDef) || utils_1.Utils.missing(this.colDef.showRowGroup)) {
            return false;
        }
        var showingAllGroups = this.colDef.showRowGroup === true;
        var showingThisGroup = this.colDef.showRowGroup === colId;
        return showingAllGroups || showingThisGroup;
    };
    Column.prototype.getUniqueId = function () {
        return this.getId();
    };
    Column.prototype.isPrimary = function () {
        return this.primary;
    };
    Column.prototype.isFilterAllowed = function () {
        return this.primary && !this.colDef.suppressFilter;
    };
    Column.prototype.isFieldContainsDots = function () {
        return this.fieldContainsDots;
    };
    Column.prototype.isTooltipFieldContainsDots = function () {
        return this.tooltipFieldContainsDots;
    };
    Column.prototype.validate = function () {
        var colDefAny = this.colDef;
        if (!this.gridOptionsWrapper.isEnterprise()) {
            var itemsNotAllowedWithoutEnterprise = ['enableRowGroup', 'rowGroup', 'rowGroupIndex', 'enablePivot', 'pivot', 'pivotIndex', 'aggFunc'];
            itemsNotAllowedWithoutEnterprise.forEach(function (item) {
                if (utils_1.Utils.exists(colDefAny[item])) {
                    console.warn("ag-Grid: " + item + " is only valid in ag-Grid-Enterprise, your column definition should not have " + item);
                }
            });
        }
        if (this.gridOptionsWrapper.isTreeData()) {
            var itemsNotAllowedWithTreeData = ['enableRowGroup', 'rowGroup', 'rowGroupIndex', 'enablePivot', 'pivot', 'pivotIndex'];
            itemsNotAllowedWithTreeData.forEach(function (item) {
                if (utils_1.Utils.exists(colDefAny[item])) {
                    console.warn("ag-Grid: " + item + " is not possible when doing tree data, your column definition should not have " + item);
                }
            });
        }
        if (utils_1.Utils.exists(this.colDef.width) && typeof this.colDef.width !== 'number') {
            console.warn('ag-Grid: colDef.width should be a number, not ' + typeof this.colDef.width);
        }
        if (utils_1.Utils.get(this, 'colDef.cellRendererParams.restrictToOneGroup', null)) {
            console.warn('ag-Grid: Since ag-grid 11.0.0 cellRendererParams.restrictToOneGroup is deprecated. You should use showRowGroup');
        }
        if (utils_1.Utils.get(this, 'colDef.cellRendererParams.keyMap', null)) {
            console.warn('ag-Grid: Since ag-grid 11.0.0 cellRendererParams.keyMap is deprecated. You should use colDef.keyCreator');
        }
        if (utils_1.Utils.get(this, 'colDef.cellRendererParams.keyMap', null)) {
            console.warn('ag-Grid: Since ag-grid 11.0.0 cellRendererParams.keyMap is deprecated. You should use colDef.keyCreator');
        }
        if (colDefAny.floatingCellRenderer) {
            console.warn('ag-Grid: since v11, floatingCellRenderer is now pinnedRowCellRenderer');
            this.colDef.pinnedRowCellRenderer = colDefAny.floatingCellRenderer;
        }
        if (colDefAny.floatingRendererFramework) {
            console.warn('ag-Grid: since v11, floatingRendererFramework is now pinnedRowCellRendererFramework');
            this.colDef.pinnedRowCellRendererFramework = colDefAny.floatingRendererFramework;
        }
        if (colDefAny.floatingRendererParams) {
            console.warn('ag-Grid: since v11, floatingRendererParams is now pinnedRowCellRendererParams');
            this.colDef.pinnedRowCellRendererParams = colDefAny.floatingRendererParams;
        }
        if (colDefAny.floatingValueFormatter) {
            console.warn('ag-Grid: since v11, floatingValueFormatter is now pinnedRowValueFormatter');
            this.colDef.pinnedRowValueFormatter = colDefAny.floatingValueFormatter;
        }
        if (colDefAny.cellFormatter) {
            console.warn('ag-Grid: since v12, cellFormatter is now valueFormatter');
            if (utils_1.Utils.missing(this.colDef.valueFormatter)) {
                this.colDef.valueFormatter = colDefAny.cellFormatter;
            }
        }
        if (colDefAny.headerCellTemplate) {
            console.warn('ag-Grid: since v15, headerCellTemplate is gone, use header component instead.');
        }
        if (colDefAny.headerCellRenderer) {
            console.warn('ag-Grid: since v15, headerCellRenderer is gone, use header component instead.');
        }
        if (colDefAny.volatile) {
            console.warn('ag-Grid: since v16, colDef.volatile is gone, please check refresh docs on how to refresh specific cells.');
        }
    };
    Column.prototype.addEventListener = function (eventType, listener) {
        this.eventService.addEventListener(eventType, listener);
    };
    Column.prototype.removeEventListener = function (eventType, listener) {
        this.eventService.removeEventListener(eventType, listener);
    };
    Column.prototype.createIsColumnFuncParams = function (rowNode) {
        return {
            node: rowNode,
            data: rowNode.data,
            column: this,
            colDef: this.colDef,
            context: this.gridOptionsWrapper.getContext(),
            api: this.gridOptionsWrapper.getApi(),
            columnApi: this.gridOptionsWrapper.getColumnApi()
        };
    };
    Column.prototype.isSuppressNavigable = function (rowNode) {
        // if boolean set, then just use it
        if (typeof this.colDef.suppressNavigable === 'boolean') {
            return this.colDef.suppressNavigable;
        }
        // if function, then call the function to find out
        if (typeof this.colDef.suppressNavigable === 'function') {
            var params = this.createIsColumnFuncParams(rowNode);
            var userFunc = this.colDef.suppressNavigable;
            return userFunc(params);
        }
        return false;
    };
    Column.prototype.isCellEditable = function (rowNode) {
        // only allow editing of groups if the user has this option enabled
        if (rowNode.group && !this.gridOptionsWrapper.isEnableGroupEdit()) {
            return false;
        }
        return this.isColumnFunc(rowNode, this.colDef.editable);
    };
    Column.prototype.isRowDrag = function (rowNode) {
        return this.isColumnFunc(rowNode, this.colDef.rowDrag);
    };
    Column.prototype.isCellCheckboxSelection = function (rowNode) {
        return this.isColumnFunc(rowNode, this.colDef.checkboxSelection);
    };
    Column.prototype.isSuppressPaste = function (rowNode) {
        return this.isColumnFunc(rowNode, this.colDef ? this.colDef.suppressPaste : null);
    };
    Column.prototype.isResizable = function () {
        var enableColResize = this.gridOptionsWrapper.isEnableColResize();
        var suppressResize = this.colDef && this.colDef.suppressResize;
        return enableColResize && !suppressResize;
    };
    Column.prototype.isColumnFunc = function (rowNode, value) {
        // if boolean set, then just use it
        if (typeof value === 'boolean') {
            return value;
        }
        // if function, then call the function to find out
        if (typeof value === 'function') {
            var params = this.createIsColumnFuncParams(rowNode);
            var editableFunc = value;
            return editableFunc(params);
        }
        return false;
    };
    Column.prototype.setMoving = function (moving, source) {
        if (source === void 0) { source = "api"; }
        this.moving = moving;
        this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_MOVING_CHANGED, source));
    };
    Column.prototype.createColumnEvent = function (type, source) {
        return {
            api: this.gridApi,
            columnApi: this.columnApi,
            type: type,
            column: this,
            columns: [this],
            source: source
        };
    };
    Column.prototype.isMoving = function () {
        return this.moving;
    };
    Column.prototype.getSort = function () {
        return this.sort;
    };
    Column.prototype.setSort = function (sort, source) {
        if (source === void 0) { source = "api"; }
        if (this.sort !== sort) {
            this.sort = sort;
            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_SORT_CHANGED, source));
        }
    };
    Column.prototype.setMenuVisible = function (visible, source) {
        if (source === void 0) { source = "api"; }
        if (this.menuVisible !== visible) {
            this.menuVisible = visible;
            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_MENU_VISIBLE_CHANGED, source));
        }
    };
    Column.prototype.isMenuVisible = function () {
        return this.menuVisible;
    };
    Column.prototype.isSortAscending = function () {
        return this.sort === Column.SORT_ASC;
    };
    Column.prototype.isSortDescending = function () {
        return this.sort === Column.SORT_DESC;
    };
    Column.prototype.isSortNone = function () {
        return utils_1.Utils.missing(this.sort);
    };
    Column.prototype.isSorting = function () {
        return utils_1.Utils.exists(this.sort);
    };
    Column.prototype.getSortedAt = function () {
        return this.sortedAt;
    };
    Column.prototype.setSortedAt = function (sortedAt) {
        this.sortedAt = sortedAt;
    };
    Column.prototype.setAggFunc = function (aggFunc) {
        this.aggFunc = aggFunc;
    };
    Column.prototype.getAggFunc = function () {
        return this.aggFunc;
    };
    Column.prototype.getLeft = function () {
        return this.left;
    };
    Column.prototype.getOldLeft = function () {
        return this.oldLeft;
    };
    Column.prototype.getRight = function () {
        return this.left + this.actualWidth;
    };
    Column.prototype.setLeft = function (left, source) {
        if (source === void 0) { source = "api"; }
        this.oldLeft = this.left;
        if (this.left !== left) {
            this.left = left;
            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_LEFT_CHANGED, source));
        }
    };
    Column.prototype.isFilterActive = function () {
        return this.filterActive;
    };
    Column.prototype.setFilterActive = function (active, source) {
        if (source === void 0) { source = "api"; }
        if (this.filterActive !== active) {
            this.filterActive = active;
            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_FILTER_ACTIVE_CHANGED, source));
        }
        this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_FILTER_CHANGED, source));
    };
    Column.prototype.setPinned = function (pinned) {
        // pinning is not allowed when doing 'forPrint'
        if (this.gridOptionsWrapper.isForPrint()) {
            return;
        }
        if (pinned === true || pinned === Column.PINNED_LEFT) {
            this.pinned = Column.PINNED_LEFT;
        }
        else if (pinned === Column.PINNED_RIGHT) {
            this.pinned = Column.PINNED_RIGHT;
        }
        else {
            this.pinned = null;
        }
        // console.log(`setColumnsPinned ${this.getColId()} ${this.pinned}`);
    };
    Column.prototype.setFirstRightPinned = function (firstRightPinned, source) {
        if (source === void 0) { source = "api"; }
        if (this.firstRightPinned !== firstRightPinned) {
            this.firstRightPinned = firstRightPinned;
            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_FIRST_RIGHT_PINNED_CHANGED, source));
        }
    };
    Column.prototype.setLastLeftPinned = function (lastLeftPinned, source) {
        if (source === void 0) { source = "api"; }
        if (this.lastLeftPinned !== lastLeftPinned) {
            this.lastLeftPinned = lastLeftPinned;
            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_LAST_LEFT_PINNED_CHANGED, source));
        }
    };
    Column.prototype.isFirstRightPinned = function () {
        return this.firstRightPinned;
    };
    Column.prototype.isLastLeftPinned = function () {
        return this.lastLeftPinned;
    };
    Column.prototype.isPinned = function () {
        return this.pinned === Column.PINNED_LEFT || this.pinned === Column.PINNED_RIGHT;
    };
    Column.prototype.isPinnedLeft = function () {
        return this.pinned === Column.PINNED_LEFT;
    };
    Column.prototype.isPinnedRight = function () {
        return this.pinned === Column.PINNED_RIGHT;
    };
    Column.prototype.getPinned = function () {
        return this.pinned;
    };
    Column.prototype.setVisible = function (visible, source) {
        if (source === void 0) { source = "api"; }
        var newValue = visible === true;
        if (this.visible !== newValue) {
            this.visible = newValue;
            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_VISIBLE_CHANGED, source));
        }
    };
    Column.prototype.isVisible = function () {
        return this.visible;
    };
    Column.prototype.getColDef = function () {
        return this.colDef;
    };
    Column.prototype.getColumnGroupShow = function () {
        return this.colDef.columnGroupShow;
    };
    Column.prototype.getColId = function () {
        return this.colId;
    };
    Column.prototype.getId = function () {
        return this.getColId();
    };
    Column.prototype.getDefinition = function () {
        return this.colDef;
    };
    Column.prototype.getActualWidth = function () {
        return this.actualWidth;
    };
    Column.prototype.getColSpan = function (rowNode) {
        if (utils_1.Utils.missing(this.colDef.colSpan)) {
            return 1;
        }
        else {
            var params = {
                node: rowNode,
                data: rowNode.data,
                colDef: this.colDef,
                column: this,
                api: this.gridOptionsWrapper.getApi(),
                columnApi: this.gridOptionsWrapper.getColumnApi(),
                context: this.gridOptionsWrapper.getContext()
            };
            var colSpan = this.colDef.colSpan(params);
            // colSpan must be number equal to or greater than 1
            if (colSpan > 1) {
                return colSpan;
            }
            else {
                return 1;
            }
        }
    };
    Column.prototype.setActualWidth = function (actualWidth, source) {
        if (source === void 0) { source = "api"; }
        if (this.actualWidth !== actualWidth) {
            this.actualWidth = actualWidth;
            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_WIDTH_CHANGED, source));
        }
    };
    Column.prototype.isGreaterThanMax = function (width) {
        if (this.maxWidth) {
            return width > this.maxWidth;
        }
        else {
            return false;
        }
    };
    Column.prototype.getMinWidth = function () {
        return this.minWidth;
    };
    Column.prototype.getMaxWidth = function () {
        return this.maxWidth;
    };
    Column.prototype.setMinimum = function (source) {
        if (source === void 0) { source = "api"; }
        this.setActualWidth(this.minWidth, source);
    };
    Column.prototype.setRowGroupActive = function (rowGroup, source) {
        if (source === void 0) { source = "api"; }
        if (this.rowGroupActive !== rowGroup) {
            this.rowGroupActive = rowGroup;
            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_ROW_GROUP_CHANGED, source));
        }
    };
    Column.prototype.isRowGroupActive = function () {
        return this.rowGroupActive;
    };
    Column.prototype.setPivotActive = function (pivot, source) {
        if (source === void 0) { source = "api"; }
        if (this.pivotActive !== pivot) {
            this.pivotActive = pivot;
            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_PIVOT_CHANGED, source));
        }
    };
    Column.prototype.isPivotActive = function () {
        return this.pivotActive;
    };
    Column.prototype.isAnyFunctionActive = function () {
        return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
    };
    Column.prototype.isAnyFunctionAllowed = function () {
        return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
    };
    Column.prototype.setValueActive = function (value, source) {
        if (source === void 0) { source = "api"; }
        if (this.aggregationActive !== value) {
            this.aggregationActive = value;
            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_VALUE_CHANGED, source));
        }
    };
    Column.prototype.isValueActive = function () {
        return this.aggregationActive;
    };
    Column.prototype.isAllowPivot = function () {
        return this.colDef.enablePivot === true;
    };
    Column.prototype.isAllowValue = function () {
        return this.colDef.enableValue === true;
    };
    Column.prototype.isAllowRowGroup = function () {
        return this.colDef.enableRowGroup === true;
    };
    Column.prototype.getMenuTabs = function (defaultValues) {
        var menuTabs = this.getColDef().menuTabs;
        if (menuTabs == null) {
            menuTabs = defaultValues;
        }
        return menuTabs;
    };
    // + renderedHeaderCell - for making header cell transparent when moving
    Column.EVENT_MOVING_CHANGED = 'movingChanged';
    // + renderedCell - changing left position
    Column.EVENT_LEFT_CHANGED = 'leftChanged';
    // + renderedCell - changing width
    Column.EVENT_WIDTH_CHANGED = 'widthChanged';
    // + renderedCell - for changing pinned classes
    Column.EVENT_LAST_LEFT_PINNED_CHANGED = 'lastLeftPinnedChanged';
    Column.EVENT_FIRST_RIGHT_PINNED_CHANGED = 'firstRightPinnedChanged';
    // + renderedColumn - for changing visibility icon
    Column.EVENT_VISIBLE_CHANGED = 'visibleChanged';
    // + every time the filter changes, used in the floating filters
    Column.EVENT_FILTER_CHANGED = 'filterChanged';
    // + renderedHeaderCell - marks the header with filter icon
    Column.EVENT_FILTER_ACTIVE_CHANGED = 'filterActiveChanged';
    // + renderedHeaderCell - marks the header with sort icon
    Column.EVENT_SORT_CHANGED = 'sortChanged';
    Column.EVENT_MENU_VISIBLE_CHANGED = 'menuVisibleChanged';
    // + toolpanel, for gui updates
    Column.EVENT_ROW_GROUP_CHANGED = 'columnRowGroupChanged';
    // + toolpanel, for gui updates
    Column.EVENT_PIVOT_CHANGED = 'columnPivotChanged';
    // + toolpanel, for gui updates
    Column.EVENT_VALUE_CHANGED = 'columnValueChanged';
    Column.PINNED_RIGHT = 'right';
    Column.PINNED_LEFT = 'left';
    Column.SORT_ASC = 'asc';
    Column.SORT_DESC = 'desc';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], Column.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('columnUtils'),
        __metadata("design:type", columnUtils_1.ColumnUtils)
    ], Column.prototype, "columnUtils", void 0);
    __decorate([
        context_1.Autowired('frameworkFactory'),
        __metadata("design:type", Object)
    ], Column.prototype, "frameworkFactory", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], Column.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], Column.prototype, "gridApi", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Column.prototype, "initialise", null);
    return Column;
}());
exports.Column = Column;


/***/ }),

/***/ "hJx8":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("evD5");
var createDesc = __webpack_require__("X8DO");
module.exports = __webpack_require__("+E39") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "hKoQ":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var require;/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.2+97478eb6
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = __webpack_require__(0);
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === GET_THEN_ERROR) {
      reject(promise, GET_THEN_ERROR.error);
      GET_THEN_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = void 0,
      failed = void 0;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (failed) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = getThen(entry);

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        handleMaybeThenable(promise, entry, _then);
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    return promise.then(function (value) {
      return constructor.resolve(callback()).then(function () {
        return value;
      });
    }, function (reason) {
      return constructor.resolve(callback()).then(function () {
        throw reason;
      });
    });
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
    var local = void 0;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU"), __webpack_require__("DuR2")))

/***/ }),

/***/ "hMV3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _vue = __webpack_require__("7+uW");

var aVue = _interopRequireWildcard(_vue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var allVue = aVue;
var gh = allVue.h;
var createApp = allVue.createApp;
exports.default = {
    name: 'baseComponent',
    props: {
        disabled: {
            type: Boolean,
            default: undefined
        },
        readonly: {
            type: Boolean,
            default: undefined
        }
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('div');
    },
    created: function created() {
        this.createdMethod();
    },

    beforeDestroy: gh ? undefined : function () {
        this.destroyKendoWidget();
    },
    beforeUnmount: function beforeUnmount() {
        this.destroyKendoWidget();
    },
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },

    beforeMount: function beforeMount() {
        if (this.v3) {
            this.createdMethod();
            var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
            var hasDataSource = !this.$props.dataSource;
            if (hasDataSource && defaultSlot) {
                var innerDatasource = defaultSlot.find(function (slot) {
                    return slot.type && slot.type.name && slot.type.name.indexOf('datasource') !== -1;
                });
                if (innerDatasource) {
                    var dataSourceOptions = this.parseOptions(innerDatasource, innerDatasource.type.mixins[0].mixins);
                    this.widgetOptions.dataSource = dataSourceOptions;
                }
            }
        }
    },
    updated: function updated() {
        if (this.modelValue) {
            this.changeValue(this.modelValue);
        }
    },
    mounted: function mounted() {
        if (this.$el.classList && this.$el.classList.length > 0) {
            this.nativeClasses = [].concat(_toConsumableArray(this.$el.classList));
        } else {
            this.nativeClasses = [];
        }
        var props = this.v3 ? this.$props : this.$options.propsData;
        for (var key in props) {
            var that = this;

            if (key.toLowerCase().indexOf('template') !== -1) {
                var isFunction = this.widgetOptions[key] instanceof Function;

                if (isFunction) {
                    this.widgetOptions[key] = this.transformTemplate(key);
                }
            }

            if (key === 'value') {
                that.$watch(key, function (newValue) {
                    that.changeValue(newValue);
                });
            } else if (key === 'disabled') {
                that.$watch(key, function (newValue) {
                    that.makeDisabled(newValue);
                });
            } else if (key === 'readonly') {
                that.$watch(key, function (newValue) {
                    that.makeReadonly(newValue);
                });
            } else {
                that.$watch(key, function (newValue, oldValue) {
                    // Vue always dispatches a change when inline complex objects are bound
                    // https://github.com/telerik/kendo-ui-core/issues/3952
                    if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
                        that.updateWidget();
                    }
                });
            }
        }
    },

    watch: {
        $attrs: function $attrs() {
            this.toggleClasses();
        }
    },
    methods: {
        createdMethod: function createdMethod() {
            this.resolveWidgetOptions();
            this.$_nativeTemplates = [];
            if (!this.v3) {
                this.$on('kendowidgetready', this.ready);
            }
        },
        destroyKendoWidget: function destroyKendoWidget() {
            if (this.kendoWidget() && this.kendoWidget().destroy) {
                this.kendoWidget().destroy();
                if (this.$_nativeTemplates.length) {
                    for (var i = 0; i < this.$_nativeTemplates.length; i++) {
                        var currentTemplate = this.$_nativeTemplates[i];
                        if (currentTemplate.unmount) {
                            currentTemplate.unmount();
                        } else {
                            currentTemplate.$destroy();
                        }
                    }
                }
            }
        },
        toggleClasses: function toggleClasses() {
            var that = this;
            var $element = kendo.jQuery(that.$el);
            var $wrapper = that.kendoWidget().wrapper;

            if ($wrapper && $wrapper[0] !== $element[0]) {
                that.nativeClasses.forEach(function (item) {
                    $wrapper.removeClass(item);
                });

                // Add to wrapper only the custom classes without the default Kendo ones
                if (that.kendoClasses) {
                    that.nativeClasses = [].concat(_toConsumableArray(that.$el.classList)).filter(function (item) {
                        return that.kendoClasses.indexOf(item) < 0;
                    });
                } else {
                    that.nativeClasses = [].concat(_toConsumableArray(that.$el.classList));
                }

                that.nativeClasses.forEach(function (item) {
                    $wrapper.addClass(item);
                });
            }

            if (that.kendoClasses) {
                that.kendoClasses.forEach(function (item) {
                    $element.addClass(item);
                });
            }
        },
        updateWidget: function updateWidget() {
            var that = this;

            that.resolveWidgetOptions();

            if (that._resolveChildren) {
                that._resolveChildren();
            }

            var currentWidget = that.kendoWidget();

            if (currentWidget && currentWidget.setOptions) {
                currentWidget.setOptions(that.widgetOptions);
            }
        },

        transformTemplate: function transformTemplate(key, val) {
            var that = this;
            var object;
            var props = that.v3 ? that.$props : that.$options.propsData;
            var templateDefinition = val || props[key];
            try {
                object = templateDefinition.call(that, {});
            } catch (e) {
                return templateDefinition;
            }

            if (!object.template) {
                return templateDefinition;
            }

            return function () {
                object = templateDefinition.apply(this, arguments);
                var kendoguid;
                if (that.v3) {
                    var newTemplateArgs = typeof object.templateArgs === 'string' ? object.templateArgs : Object.assign({}, object.templateArgs);
                    var tempComponent = (0, createApp)(Object.assign({}, object.template, {
                        data: function data() {
                            return Object.assign({}, object.template.data ? object.template.data() : {}, {
                                templateArgs: newTemplateArgs
                            });
                        }
                    }));
                    kendoguid = 'kendo' + kendo.guid();

                    that.$nextTick(function () {
                        if (document.getElementById(kendoguid)) {
                            tempComponent.mount('#' + kendoguid);
                            that.$_nativeTemplates.push(tempComponent);
                        }
                    });
                } else {
                    var newVue = allVue.default.extend(object);
                    var vueObject = new newVue(object.template);
                    vueObject.$data.templateArgs = object.templateArgs;
                    kendoguid = 'kendo' + kendo.guid();
                    that.$nextTick(function () {
                        if (document.getElementById(kendoguid)) {
                            vueObject.$mount('#' + kendoguid);
                            that.$_nativeTemplates.push(vueObject);
                        }
                    });
                }

                return '<div id="' + kendoguid + '"></div>';
            };
        },
        resolveChildren: function resolveChildren(prop, name) {
            var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
            if (!this.widgetOptions[prop] && defaultSlot) {
                var items = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = defaultSlot[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var childSlot = _step.value;

                        if (childSlot.tag && childSlot.tag.indexOf(name) !== -1 || childSlot.type && childSlot.type.name && childSlot.type.name.toLowerCase().indexOf(name) !== -1) {
                            var childInstance = this.v3 ? childSlot : childSlot.componentInstance;
                            var itemOptions = this.parseOptions(childInstance);

                            if (itemOptions.dataSourceRef) {
                                this.setInnerDataSource('dataSourceRef', 'dataSource', itemOptions);
                            }

                            items.push(itemOptions);
                            this.handleWatcher(childInstance);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                if (items.length) {
                    this.widgetOptions[prop] = items;
                }
            }
        },
        handleWatcher: function handleWatcher(childInstance) {
            var that = this;
            childInstance.stashedPropsData = JSON.stringify(that.v3 ? childInstance.$props : childInstance.$options.propsData);

            if (!that.v3 && !childInstance._isWatchAttached) {
                childInstance.$watch('$props', function () {
                    var props = that.v3 ? childInstance.$props : childInstance.$options.propsData;
                    var propsAsJson = JSON.stringify(props);
                    var needsUpdate = childInstance.stashedPropsData !== propsAsJson;

                    if (that.updateWidget && needsUpdate) {
                        that.updateWidget();
                    } else if (that._resolveInnerChildren) {
                        that._resolveInnerChildren();
                    }

                    childInstance.stashedPropsData = propsAsJson;
                }, { deep: true });

                childInstance._isWatchAttached = true;
            }
        },
        makeDisabled: function makeDisabled(toDisable) {
            if (this.kendoWidget().enable) {
                this.kendoWidget().enable(!toDisable);
            }
        },
        makeReadonly: function makeReadonly(value) {
            if (this.kendoWidget().readonly) {
                this.kendoWidget().readonly(value);
            }
        },
        changeValue: function changeValue(newValue) {
            if (this.kendoWidget().value) {
                this.kendoWidget().value(newValue);
            }
        },
        resolveWidgetOptions: function resolveWidgetOptions() {
            this.widgetOptions = this.parseOptions();
        },
        getListeners: function getListeners() {
            if (this.v3) {
                var listeners = {};
                for (var key in this.$attrs) {
                    if (key.startsWith('on')) {
                        listeners[key] = this.$attrs[key];
                    }
                }

                return listeners;
            } else {
                return this.$listeners;
            }
        },
        parseOptions: function parseOptions(component, defaultMixins) {
            var _this = this;

            var that = component || this;
            var options = {};
            var props = this.v3 ? component ? that.props : that.$props : that.$options.propsData;

            var _loop = function _loop(_key) {
                propOptions = _this.v3 ? component ? undefined : that.$options.__props[0][_key] || that.$options.__props[0][0][_key] : that.$options.props[_key];
                val = props[_key];

                if (_this.v3 && _key.indexOf('-') !== -1) {
                    _key = _this.camelize(_key);
                }

                compositeProps = propOptions ? propOptions.kComposite : undefined;


                if (that.v3 || _this.v3) {
                    var mixins = component ? defaultMixins || component.type.mixins : that.$options.mixins;
                    if (mixins) {
                        mixins.forEach(function (mixin) {
                            if (mixin.props && mixin.name !== 'baseComponent' && mixin.name !== 'baseDataSourceComponent' && mixin.props[_key] !== undefined && (that.$props ? that.$props[_key] !== undefined : true)) {
                                compositeProps = mixin.props[_key].kComposite;
                            }
                        });
                    }
                }

                if (!compositeProps) {
                    if (_key.toLowerCase().indexOf('template') !== -1 && val instanceof Function) {
                        options[_key] = _this.transformTemplate(_key, val);
                    } else {
                        if (val !== undefined) {
                            options[_key] = val;
                        }
                    }
                } else {
                    if (val !== undefined) {
                        _this.addCompositeProperty(options, compositeProps.split('.'), val);
                    }
                }
                key = _key;
            };

            for (var key in props) {
                var propOptions;
                var val;
                var compositeProps;

                _loop(key);
            }

            if (that.getListeners) {
                if (this.v3) {
                    Object.keys(that.$attrs).forEach(function (event) {
                        var listeners = that.getListeners();
                        var eventName = _this.v3 ? event : event.toLowerCase();
                        if (listeners && listeners[eventName]) {
                            var kendoIndex = event.lastIndexOf('kendo');
                            var kendoEvent;
                            if (kendoIndex !== -1) {
                                kendoEvent = event.replace('kendo', '').toLowerCase();
                            }

                            if (_this.v3 && event.indexOf('onKendo') !== -1) {
                                kendoEvent = event.replace('onKendo', '').toLowerCase();
                            }
                            var kendoEventProp = Object.keys(that.$props).find(function (e) {
                                return e.toLowerCase() === _this.removeOn(event);
                            });
                            options[kendoEvent || kendoEventProp || _this.removeOn(event)] = listeners[eventName];
                        }
                    });
                } else {
                    Object.keys(that.$props).forEach(function (event) {
                        var listeners = that.getListeners();
                        if (listeners && listeners[event.toLowerCase()]) {
                            var kendoIndex = event.lastIndexOf('kendo');
                            var kendoEvent;
                            if (kendoIndex !== -1) {
                                kendoEvent = event.replace('kendo', '').toLowerCase();
                            }

                            options[kendoEvent || event] = listeners[event.toLowerCase()];
                        }
                    });
                }
            }

            if (this.v3 && this.$props.modelValue) {
                options.value = this.$props.modelValue;
            }

            return options;
        },
        addCompositeProperty: function addCompositeProperty(obj, keys, val) {
            var lastKey = keys.pop();
            var lastObj = keys.reduce(function (obj, key) {
                obj[key] = _typeof(obj[key]) === 'object' ? obj[key] || {} : {};
                return obj[key];
            }, obj);

            if (lastKey.toLowerCase().indexOf('template') !== -1 && val instanceof Function) {
                lastObj[lastKey] = this.transformTemplate(lastKey, val);
            } else {
                lastObj[lastKey] = val;
            }
        },
        resolveInnerTags: function resolveInnerTags(tagName) {
            var items = [];
            var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = defaultSlot[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var childSlot = _step2.value;

                    if (childSlot.tag && childSlot.tag.indexOf(tagName) !== -1 || childSlot.type && childSlot.type.name && childSlot.type.name.toLowerCase().indexOf(tagName) !== -1) {
                        var childOptions = childSlot.componentOptions;
                        var childInstance = this.v3 ? childSlot : childSlot.componentInstance;
                        var item = this.v3 ? childInstance.$props || childInstance.props : childOptions.propsData;

                        if (this.v3) {
                            var itemKeys = Object.keys(item);
                            var _iteratorNormalCompletion3 = true;
                            var _didIteratorError3 = false;
                            var _iteratorError3 = undefined;

                            try {
                                for (var _iterator3 = itemKeys[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                    var propKey = _step3.value;

                                    if (propKey.indexOf('-') !== -1) {
                                        item[this.camelize(propKey)] = item[propKey];
                                    }
                                }
                            } catch (err) {
                                _didIteratorError3 = true;
                                _iteratorError3 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                        _iterator3.return();
                                    }
                                } finally {
                                    if (_didIteratorError3) {
                                        throw _iteratorError3;
                                    }
                                }
                            }
                        }

                        if (!item.items) {
                            item.items = childInstance.subitems;
                        }

                        items.push(item);
                        this.handleWatcher(childInstance);
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return items;
        },
        ready: function ready() {
            var that = this;

            if (this.$el.classList.length > 0) {
                that.kendoClasses = [].concat(_toConsumableArray(that.$el.classList)).filter(function (item) {
                    return that.nativeClasses.indexOf(item) < 0;
                });
            }
            var props = that.v3 ? that.$props : that.$options.propsData;
            if (props && props.disabled) {
                that.makeDisabled(true);
            }

            if (props && props.readonly) {
                that.makeReadonly(true);
            }
        },
        camelize: function camelize(str) {
            var arr = str.split('-');
            var capital = arr.map(function (item, index) {
                return index ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() : item;
            });
            var capitalString = capital.join('');

            return capitalString;
        },
        removeOn: function removeOn(str) {

            if (str.indexOf('onKendo') !== -1) {
                return str.replace('onKendo', '').toLowerCase();
            }

            return str.replace('on', '').toLowerCase();
        }
    }
};

/***/ }),

/***/ "hie4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var gridRow_1 = __webpack_require__("piWI");
var GridCell = (function () {
    function GridCell(gridCellDef) {
        this.rowIndex = gridCellDef.rowIndex;
        this.column = gridCellDef.column;
        this.floating = utils_1.Utils.makeNull(gridCellDef.floating);
    }
    GridCell.prototype.getGridCellDef = function () {
        return {
            rowIndex: this.rowIndex,
            column: this.column,
            floating: this.floating
        };
    };
    GridCell.prototype.getGridRow = function () {
        return new gridRow_1.GridRow(this.rowIndex, this.floating);
    };
    GridCell.prototype.toString = function () {
        return "rowIndex = " + this.rowIndex + ", floating = " + this.floating + ", column = " + (this.column ? this.column.getId() : null);
    };
    GridCell.prototype.createId = function () {
        return this.rowIndex + "." + this.floating + "." + this.column.getId();
    };
    return GridCell;
}());
exports.GridCell = GridCell;


/***/ }),

/***/ "hlPV":
/***/ (function(module, exports, __webpack_require__) {

(function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VueTheMask=t():e.VueTheMask=t()})(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={i:r,l:!1,exports:{}};return e[r].call(a.exports,a,a.exports,t),a.l=!0,a.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p=".",t(t.s=10)}([function(e,t){e.exports={"#":{pattern:/\d/},X:{pattern:/[0-9a-zA-Z]/},S:{pattern:/[a-zA-Z]/},A:{pattern:/[a-zA-Z]/,transform:function(e){return e.toLocaleUpperCase()}},a:{pattern:/[a-zA-Z]/,transform:function(e){return e.toLocaleLowerCase()}},"!":{escape:!0}}},function(e,t,n){"use strict";function r(e){var t=document.createEvent("Event");return t.initEvent(e,!0,!0),t}var a=n(2),o=n(0),i=n.n(o);t.a=function(e,t){var o=t.value;if((Array.isArray(o)||"string"==typeof o)&&(o={mask:o,tokens:i.a}),"INPUT"!==e.tagName.toLocaleUpperCase()){var u=e.getElementsByTagName("input");if(1!==u.length)throw new Error("v-mask directive requires 1 input, found "+u.length);e=u[0]}e.oninput=function(t){if(t.isTrusted){var i=e.selectionEnd,u=e.value[i-1];for(e.value=n.i(a.a)(e.value,o.mask,!0,o.tokens);i<e.value.length&&e.value.charAt(i-1)!==u;)i++;e===document.activeElement&&(e.setSelectionRange(i,i),setTimeout(function(){e.setSelectionRange(i,i)},0)),e.dispatchEvent(r("input"))}};var s=n.i(a.a)(e.value,o.mask,!0,o.tokens);s!==e.value&&(e.value=s,e.dispatchEvent(r("input")))}},function(e,t,n){"use strict";var r=n(6),a=n(5);t.a=function(e,t){var o=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],i=arguments[3];return Array.isArray(t)?n.i(a.a)(r.a,t,i)(e,t,o,i):n.i(r.a)(e,t,o,i)}},function(e,t,n){"use strict";function r(e){e.component(s.a.name,s.a),e.directive("mask",i.a)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),o=n.n(a),i=n(1),u=n(7),s=n.n(u);n.d(t,"TheMask",function(){return s.a}),n.d(t,"mask",function(){return i.a}),n.d(t,"tokens",function(){return o.a}),n.d(t,"version",function(){return c});var c="0.11.1";t.default=r,"undefined"!=typeof window&&window.Vue&&window.Vue.use(r)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(1),a=n(0),o=n.n(a),i=n(2);t.default={name:"TheMask",props:{value:[String,Number],mask:{type:[String,Array],required:!0},masked:{type:Boolean,default:!1},tokens:{type:Object,default:function(){return o.a}}},directives:{mask:r.a},data:function(){return{lastValue:null,display:this.value}},watch:{value:function(e){e!==this.lastValue&&(this.display=e)},masked:function(){this.refresh(this.display)}},computed:{config:function(){return{mask:this.mask,tokens:this.tokens,masked:this.masked}}},methods:{onInput:function(e){e.isTrusted||this.refresh(e.target.value)},refresh:function(e){this.display=e;var e=n.i(i.a)(e,this.mask,this.masked,this.tokens);e!==this.lastValue&&(this.lastValue=e,this.$emit("input",e))}}}},function(e,t,n){"use strict";function r(e,t,n){return t=t.sort(function(e,t){return e.length-t.length}),function(r,a){for(var o=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],i=0;i<t.length;){var u=t[i];i++;var s=t[i];if(!(s&&e(r,s,!0,n).length>u.length))return e(r,u,o,n)}return""}}t.a=r},function(e,t,n){"use strict";function r(e,t){var n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],r=arguments[3];e=e||"",t=t||"";for(var a=0,o=0,i="";a<t.length&&o<e.length;){var u=t[a],s=r[u],c=e[o];s&&!s.escape?(s.pattern.test(c)&&(i+=s.transform?s.transform(c):c,a++),o++):(s&&s.escape&&(a++,u=t[a]),n&&(i+=u),c===u&&o++,a++)}for(var f="";a<t.length&&n;){var u=t[a];if(r[u]){f="";break}f+=u,a++}return i+f}t.a=r},function(e,t,n){var r=n(8)(n(4),n(9),null,null);e.exports=r.exports},function(e,t){e.exports=function(e,t,n,r){var a,o=e=e||{},i=typeof e.default;"object"!==i&&"function"!==i||(a=e,o=e.default);var u="function"==typeof o?o.options:o;if(t&&(u.render=t.render,u.staticRenderFns=t.staticRenderFns),n&&(u._scopeId=n),r){var s=u.computed||(u.computed={});Object.keys(r).forEach(function(e){var t=r[e];s[e]=function(){return t}})}return{esModule:a,exports:o,options:u}}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement;return(e._self._c||t)("input",{directives:[{name:"mask",rawName:"v-mask",value:e.config,expression:"config"}],attrs:{type:"text"},domProps:{value:e.display},on:{input:e.onInput}})},staticRenderFns:[]}},function(e,t,n){e.exports=n(3)}])});

/***/ }),

/***/ "hmKk":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1602);
	module.exports = __webpack_require__(1602);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1602:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var $ = kendo.jQuery;

	    var classNames = {
	        wrapper: "k-spreadsheet-formula-bar"
	    };

	    var FormulaBar = kendo.ui.Widget.extend({
	        init: function(element, options) {
	            kendo.ui.Widget.call(this, element, options);

	            element = this.element.addClass(FormulaBar.classNames.wrapper);

	            var formulaBarWidth = element.width();

	            this.formulaInput = new kendo.spreadsheet.FormulaInput($("<div/>")
	                .appendTo(element), { formulaBarWidth: formulaBarWidth });
	        },

	        destroy: function() {
	            if (this.formulaInput) {
	                this.formulaInput.destroy();
	            }
	            this.formulaInput = null;
	        }
	    });

	    kendo.spreadsheet.FormulaBar = FormulaBar;
	    $.extend(true, FormulaBar, { classNames: classNames });
	})(window.kendo);
	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "iAAw":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1323);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1301:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Yz+S");

/***/ }),

/***/ 1323:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1086), __webpack_require__(1301) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.popover",
	    name: "PopOver",
	    category: "mobile",
	    description: "The mobile PopOver widget represents a transient view which is displayed when the user taps on a navigational widget or area on the screen. ",
	    depends: [ "popup", "mobile.pane" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        mobile = kendo.mobile,
	        ui = mobile.ui,
	        HIDE = "hide",
	        OPEN = "open",
	        CLOSE = "close",
	        WRAPPER = '<div class="km-popup-wrapper"></div>',
	        ARROW = '<div class="km-popup-arrow"></div>',
	        OVERLAY = '<div class="km-popup-overlay"></div>',
	        DIRECTION_CLASSES = "km-up km-down km-left km-right",
	        Widget = ui.Widget,
	        DIRECTIONS = {
	            "down": {
	                origin: "bottom center",
	                position: "top center"
	            },
	            "up": {
	                origin: "top center",
	                position: "bottom center"
	            },
	            "left": {
	                origin: "center left",
	                position: "center right",
	                collision: "fit flip"
	            },
	            "right": {
	                origin: "center right",
	                position: "center left",
	                collision: "fit flip"
	            }
	        },

	        ANIMATION = {
	            animation: {
	                open: {
	                    effects: "fade:in",
	                    duration: 0
	                },
	                close: {
	                    effects: "fade:out",
	                    duration: 400
	                }
	            }
	        },
	        DIMENSIONS = {
	            "horizontal": { offset: "top", size: "height" },
	            "vertical": { offset: "left", size: "width" }
	        },

	        REVERSE = {
	            "up": "down",
	            "down": "up",
	            "left": "right",
	            "right": "left"
	        };

	    var Popup = Widget.extend({
	        init: function(element, options) {
	            var that = this,
	                containerPopup = element.closest(".km-modalview-wrapper"),
	                viewport = element.closest(".km-root").children('.km-pane').first(),
	                container = containerPopup[0] ? containerPopup : viewport,
	                popupOptions,
	                axis;

	            if (options.viewport) {
	                viewport = options.viewport;
	            } else if (!viewport[0]) {
	                viewport = window;
	            }

	            if (options.container) {
	                container = options.container;
	            } else if (!container[0]) {
	                container = document.body;
	            }

	            popupOptions = {
	                viewport: viewport,
	                copyAnchorStyles: false,
	                autosize: true,
	                open: function() {
	                    that.overlay.show();
	                },

	                activate: $.proxy(that._activate, that),

	                deactivate: function() {
	                    that.overlay.hide();
	                    if (!that._apiCall) {
	                        that.trigger(HIDE);
	                    }

	                    that._apiCall = false;
	                }
	            };

	            Widget.fn.init.call(that, element, options);

	            element = that.element;
	            options = that.options;

	            element.wrap(WRAPPER).addClass("km-popup").show();

	            axis = that.options.direction.match(/left|right/) ? "horizontal" : "vertical";

	            that.dimensions = DIMENSIONS[axis];

	            that.wrapper = element.parent().css({
	                width: options.width,
	                height: options.height
	            }).addClass("km-popup-wrapper km-" + options.direction).hide();

	            that.arrow = $(ARROW).prependTo(that.wrapper).hide();

	            that.overlay = $(OVERLAY).appendTo(container).hide();
	            popupOptions.appendTo = that.overlay;

	            if (options.className) {
	                that.overlay.addClass(options.className);
	            }

	            that.popup = new kendo.ui.Popup(that.wrapper, $.extend(true, popupOptions, ANIMATION, DIRECTIONS[options.direction]));
	        },

	        options: {
	            name: "Popup",
	            width: 240,
	            height: "",
	            direction: "down",
	            container: null,
	            viewport: null
	        },

	        events: [
	            HIDE
	        ],

	        show: function(target) {
	            this.popup.options.anchor = $(target);
	            this.popup.open();
	        },

	        hide: function() {
	            this._apiCall = true;
	            this.popup.close();
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            this.popup.destroy();
	            this.overlay.remove();
	        },

	        target: function() {
	            return this.popup.options.anchor;
	        },

	        _activate: function() {
	            var that = this,
	                direction = that.options.direction,
	                dimensions = that.dimensions,
	                offset = dimensions.offset,
	                popup = that.popup,
	                anchor = popup.options.anchor,
	                anchorOffset = $(anchor).offset(),
	                elementOffset = $(popup.element).offset(),
	                cssClass = popup.flipped ? REVERSE[direction] : direction,
	                min = that.arrow[dimensions.size]() * 2,
	                max = that.element[dimensions.size]() - that.arrow[dimensions.size](),
	                size = $(anchor)[dimensions.size](),
	                offsetAmount = anchorOffset[offset] - elementOffset[offset] + (size / 2);

	            if (offsetAmount < min) {
	                offsetAmount = min;
	            }

	            if (offsetAmount > max) {
	                offsetAmount = max;
	            }

	            that.wrapper.removeClass(DIRECTION_CLASSES).addClass("km-" + cssClass);
	            that.arrow.css(offset, offsetAmount).show();
	        }
	    });

	    var PopOver = Widget.extend({
	        init: function(element, options) {
	            var that = this,
	                popupOptions;

	            that.initialOpen = false;

	            Widget.fn.init.call(that, element, options);

	            popupOptions = $.extend({
	                className: "km-popover-root",
	                hide: function() { that.trigger(CLOSE); }
	            }, this.options.popup);

	            that.popup = new Popup(that.element, popupOptions);
	            that.popup.overlay.on("move", function(e) {
	                if (e.target == that.popup.overlay[0]) {
	                    e.preventDefault();
	                }
	            });

	            that.pane = new ui.Pane(that.element, $.extend(this.options.pane, { $angular: this.options.$angular }));

	            kendo.notify(that, ui);
	        },

	        options: {
	            name: "PopOver",
	            popup: { },
	            pane: { }
	        },

	        events: [
	            OPEN,
	            CLOSE
	        ],

	        open: function(target) {
	            this.popup.show(target);

	            if (!this.initialOpen) {
	                if (!this.pane.navigateToInitial()) {
	                    this.pane.navigate("");
	                }

	                this.popup.popup._position();
	                this.initialOpen = true;
	            } else {
	                this.pane.view()._invokeNgController();
	            }
	        },

	        openFor: function(target) {
	            this.open(target);
	            this.trigger(OPEN, { target: this.popup.target() });
	        },

	        close: function() {
	            this.popup.hide();
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            this.pane.destroy();
	            this.popup.destroy();

	            kendo.destroy(this.element);
	        }
	    });

	    ui.plugin(Popup);
	    ui.plugin(PopOver);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "iFTV":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1452);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Dz7c");

/***/ }),

/***/ 1108:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ydSV");

/***/ }),

/***/ 1452:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1049),
	        __webpack_require__(1108),
	        __webpack_require__(1104)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "view",
	    name: "View",
	    category: "framework",
	    description: "The View class instantiates and handles the events of a certain screen from the application.",
	    depends: [ "core", "binder", "fx" ],
	    hidden: false
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        attr =  kendo.attr,
	        ui = kendo.ui,
	        attrValue = kendo.attrValue,
	        directiveSelector = kendo.directiveSelector,
	        Observable = kendo.Observable,
	        Widget = kendo.ui.Widget,
	        roleSelector = kendo.roleSelector,

	        SCRIPT = "SCRIPT",
	        INIT = "init",
	        TRANSITION_START = "transitionStart",
	        TRANSITION_END = "transitionEnd",
	        SHOW = "show",
	        HIDE = "hide",
	        ATTACH = "attach",
	        DETACH = "detach",
	        sizzleErrorRegExp = /unrecognized expression/;

	    var bodyRegExp = /<body[^>]*>(([\u000a\u000d\u2028\u2029]|.)*)<\/body>/i;
	    var LOAD_START = "loadStart";
	    var LOAD_COMPLETE = "loadComplete";
	    var SHOW_START = "showStart";
	    var SAME_VIEW_REQUESTED = "sameViewRequested";
	    var VIEW_SHOW = "viewShow";
	    var VIEW_TYPE_DETERMINED = "viewTypeDetermined";
	    var AFTER = "after";
	    var classNames = {
	        content: "k-content",
	        view: "k-view",
	        stretchedView: "k-stretched-view",
	        widget: "k-widget",
	        header: "k-header",
	        footer: "k-footer"
	    };

	    var View = kendo.ui.Widget.extend({
	        init: function(content, options) {
	            var that = this;
	            options = options || {};
	            that.id = kendo.guid();

	            Observable.fn.init.call(that);
	            this.options = $.extend({}, this.options, options);

	            that.content = content;

	            if (that.options.renderOnInit) {
	                Widget.fn.init.call(that, that._createElement(), options);
	            }

	            if (that.options.wrapInSections) {
	                that._renderSections();
	            }

	            that.tagName = options.tagName || "div";
	            that.model = options.model;
	            that._wrap = options.wrap !== false;
	            this._evalTemplate = options.evalTemplate || false;
	            that._fragments = {};

	            that.bind([ INIT, SHOW, HIDE, TRANSITION_START, TRANSITION_END ], options);
	        },

	        options: {
	            name: "View",
	            renderOnInit: false,
	            wrapInSections: false,
	            detachOnHide: true,
	            detachOnDestroy: true
	        },

	        render: function(container) {
	            var that = this,
	                notInitialized = !that.element;

	            // The order below matters - kendo.bind should happen when the element is in the DOM, and show should be triggered after init.

	            if (notInitialized) {
	                that.element = that._createElement();
	            }

	            if (container) {
	                $(container).append(that.element);
	            }

	            if (notInitialized) {
	                kendo.bind(that.element, that.model);
	                that.trigger(INIT);
	            }

	            if (container) {
	                that._eachFragment(ATTACH);
	                that.trigger(SHOW);
	            }

	            return that.element;
	        },

	        clone: function() {
	            return new ViewClone(this);
	        },

	        triggerBeforeShow: function() {
	            return true;
	        },

	        triggerBeforeHide: function() {
	            return true;
	        },

	        showStart: function() {
	            var that = this;
	            var element = that.render();

	            if (element) {
	                element.css("display", "");
	            }

	            this.trigger(SHOW_START, { view: this });
	        },

	        showEnd: function() {
	        },

	        hideEnd: function() {
	            this.hide();
	        },

	        beforeTransition: function(type){
	            this.trigger(TRANSITION_START, { type: type });
	        },

	        afterTransition: function(type){
	            this.trigger(TRANSITION_END, { type: type });
	        },

	        hide: function() {
	            if (this.options.detachOnHide) {
	                this._eachFragment(DETACH);
	                $(this.element).detach();
	            }

	            this.trigger(HIDE);
	        },

	        destroy: function() {
	            var that = this;
	            var element = that.element;

	            if (element) {
	                Widget.fn.destroy.call(that);

	                kendo.unbind(element);
	                kendo.destroy(element);

	                if (that.options.detachOnDestroy) {
	                    element.remove();
	                }
	            }
	        },

	        // ported from mobile view
	        purge: function() {
	            var that = this;

	            that.destroy();
	            $(that.element).add(that.content).add(that.wrapper).off().remove();
	        },

	        fragments: function(fragments) {
	            $.extend(this._fragments, fragments);
	        },

	        _eachFragment: function(methodName) {
	            for (var placeholder in this._fragments) {
	                this._fragments[placeholder][methodName](this, placeholder);
	            }
	        },

	        _createElement: function() {
	            var that = this,
	                wrapper = "<" + that.tagName + ">",
	                element,
	                content;

	            try {
	                content = $(document.getElementById(that.content) || that.content); // support passing id without #

	                if (content[0].tagName === SCRIPT) {
	                    content = content.html();
	                }
	            } catch(e) {
	                if (sizzleErrorRegExp.test(e.message)) {
	                    content = that.content;
	                }
	            }

	            if (typeof content === "string") {
	                content = content.replace(/^\s+|\s+$/g, '');
	                if (that._evalTemplate) {
	                    content = kendo.template(content)(that.model || {});
	                }

	                element = $(wrapper).append(content);
	                // drop the wrapper if asked - this seems like the easiest (although not very intuitive) way to avoid messing up templates with questionable content, like this one for instance:
	                // <script id="my-template">
	                // foo
	                // <span> Span </span>
	                // </script>
	                if (!that._wrap) {
	                   element = element.contents();
	                }
	            } else {
	                element = content;
	                if (that._evalTemplate) {
	                    var result = $(kendo.template($("<div />").append(element.clone(true)).html())(that.model || {}));

	                    // template uses DOM
	                    if ($.contains(document, element[0])) {
	                        element.replaceWith(result);
	                    }

	                    element = result;
	                }
	                if (that._wrap) {
	                    element = element.wrapAll(wrapper).parent();
	                }
	            }

	            return element;
	        },

	        _renderSections: function() {
	            var that = this;

	            if (that.options.wrapInSections) {
	                that._wrapper();
	                that._createContent();
	                that._createHeader();
	                that._createFooter();
	            }
	        },

	        _wrapper: function() {
	            var that = this;
	            var content = that.content;

	            if (content.is(roleSelector("view"))) {
	                that.wrapper = that.content;
	            } else {
	                that.wrapper = content
	                    .wrap('<div data-' + kendo.ns + 'stretch="true" data-' + kendo.ns + 'role="view" data-' + kendo.ns + 'init-widgets="false"></div>')
	                    .parent();
	            }

	            var wrapper = that.wrapper;

	            wrapper.attr("id", that.id);

	            wrapper.addClass(classNames.view);
	            wrapper.addClass(classNames.widget);
	            wrapper.attr("role", "view");
	        },

	        _createContent: function() {
	            var that = this;
	            var wrapper = $(that.wrapper);
	            var contentSelector = roleSelector("content");

	            if (!wrapper.children(contentSelector)[0]) {
	                var ccontentElements = wrapper.children().filter(function() {
	                    var child = $(this);
	                    if (!child.is(roleSelector("header")) && !child.is(roleSelector("footer"))) {
	                        return child;
	                    }
	                });

	                ccontentElements.wrap("<div " + attr("role") + '="content"></div>');
	            }

	            // use contentElement instead of content as view.content can be a string
	            this.contentElement = wrapper.children(roleSelector("content"));

	            this.contentElement
	                .addClass(classNames.stretchedView)
	                .addClass(classNames.content);
	        },

	        _createHeader: function() {
	            var that = this;
	            var wrapper = that.wrapper;

	            this.header = wrapper.children(roleSelector("header")).addClass(classNames.header);
	        },

	        _createFooter: function() {
	            var that = this;
	            var wrapper = that.wrapper;

	            this.footer = wrapper.children(roleSelector("footer")).addClass(classNames.footer);
	        }
	    });

	    var ViewClone = kendo.Class.extend({
	        init: function(view) {
	            $.extend(this, {
	                element: view.element.clone(true),
	                transition: view.transition,
	                id: view.id
	            });

	            view.element.parent().append(this.element);
	        },

	        hideEnd: function() {
	            this.element.remove();
	        },

	        beforeTransition: $.noop,
	        afterTransition: $.noop
	    });

	    var Layout = View.extend({
	        init: function(content, options) {
	            View.fn.init.call(this, content, options);
	            this.containers = {};
	        },

	        container: function(selector) {
	            var container = this.containers[selector];

	            if (!container) {
	                container = this._createContainer(selector);
	                this.containers[selector] = container;
	            }

	            return container;
	        },

	        showIn: function(selector, view, transition) {
	            this.container(selector).show(view, transition);
	        },

	        _createContainer: function(selector) {
	            var root = this.render(),
	                element = root.find(selector),
	                container;

	            if (!element.length && root.is(selector)) {
	                if (root.is(selector)) {
	                    element = root;
	                } else {

	                    throw new Error("can't find a container with the specified " + selector + " selector");
	                }
	            }

	            container = new ViewContainer(element);

	            container.bind("accepted", function(e) {
	                e.view.render(element);
	            });

	            return container;
	        }
	    });

	    var Fragment = View.extend({
	        attach: function(view, placeholder) {
	            view.element.find(placeholder).replaceWith(this.render());
	        },

	        detach: function() {
	        }
	    });

	    var transitionRegExp = /^(\w+)(:(\w+))?( (\w+))?$/;

	    function parseTransition(transition) {
	        if (!transition){
	            return {};
	        }

	        var matches = transition.match(transitionRegExp) || [];

	        return {
	            type: matches[1],
	            direction: matches[3],
	            reverse: matches[5] === "reverse"
	        };
	    }

	    var ViewContainer = Observable.extend({
	        init: function(container) {
	            Observable.fn.init.call(this);
	            this.container = container;
	            this.history = [];
	            this.view = null;
	            this.running = false;
	        },

	        after: function() {
	            this.running = false;
	            this.trigger("complete", {view: this.view});
	            this.trigger("after");
	        },

	        end: function() {
	            this.view.showEnd();
	            this.previous.hideEnd();
	            this.after();
	        },

	        show: function(view, transition, locationID) {
	            if (!view.triggerBeforeShow() || (this.view && !this.view.triggerBeforeHide())) {
	                this.trigger("after");
	                return false;
	            }

	            locationID = locationID || view.id;

	            var that = this,
	                current = (view === that.view) ? view.clone() : that.view,
	                history = that.history,
	                previousEntry = history[history.length - 2] || {},
	                back = previousEntry.id === locationID,
	                // If explicit transition is set, it will be with highest priority
	                // Next we will try using the history record transition or the view transition configuration
	                theTransition = transition || ( back ? history[history.length - 1].transition : view.transition ),
	                transitionData = parseTransition(theTransition);

	            if (that.running) {
	                that.effect.stop();
	            }

	            if (theTransition === "none") {
	                theTransition = null;
	            }

	            that.trigger("accepted", { view: view });
	            that.view = view;
	            that.previous = current;
	            that.running = true;

	            if (!back) {
	                history.push({ id: locationID, transition: theTransition });
	            } else {
	                history.pop();
	            }

	            if (!current) {
	                view.showStart();
	                view.showEnd();
	                that.after();
	                return true;
	            }

	            if (!theTransition || !kendo.effects.enabled) {
	                view.showStart();
	                that.end();
	            } else {
	                // hide the view element before init/show - prevents blinks on iPad
	                // the replace effect will remove this class
	                view.element.addClass("k-fx-hidden");
	                view.showStart();
	                // do not reverse the explicit transition
	                if (back && !transition) {
	                    transitionData.reverse = !transitionData.reverse;
	                }

	                that.effect = kendo.fx(view.element).replace(current.element, transitionData.type)
	                    .beforeTransition(function() {
	                        view.beforeTransition("show");
	                        current.beforeTransition("hide");
	                    })
	                    .afterTransition(function() {
	                        view.afterTransition("show");
	                        current.afterTransition("hide");
	                    })
	                    .direction(transitionData.direction)
	                    .setReverse(transitionData.reverse);

	                that.effect.run().then(function() { that.end(); });
	            }

	            return true;
	        },

	        destroy: function() {
	            var that = this;
	            var view = that.view;

	            if (view && view.destroy) {
	                view.destroy();
	            }
	        }
	    });

	    var ViewEngine = Observable.extend({
	        init: function(options) {
	            var that = this,
	                views,
	                container;

	            Observable.fn.init.call(that);
	            that.options = options;

	            $.extend(that, options);
	            that.sandbox = $("<div />");
	            container = that.container;

	            views = that._hideViews(container);
	            that.rootView = views.first();
	            that.layouts = {};

	            that.viewContainer = new kendo.ViewContainer(that.container);

	            that.viewContainer.bind("accepted", function(e) {
	                e.view.params = that.params;
	            });

	            that.viewContainer.bind("complete", function(e) {
	                that.trigger(VIEW_SHOW, { view: e.view });
	            });

	            that.viewContainer.bind(AFTER, function() {
	                that.trigger(AFTER);
	            });

	            this.bind(this.events, options);
	        },

	        events: [
	            SHOW_START,
	            AFTER,
	            VIEW_SHOW,
	            LOAD_START,
	            LOAD_COMPLETE,
	            SAME_VIEW_REQUESTED,
	            VIEW_TYPE_DETERMINED
	        ],

	        destroy: function() {
	            var that = this;
	            var viewContainer = that.viewContainer;

	            kendo.destroy(that.container);

	            for (var id in that.layouts) {
	                this.layouts[id].destroy();
	            }

	            if (viewContainer) {
	                viewContainer.destroy();
	            }
	        },

	        view: function() {
	            return this.viewContainer.view;
	        },

	        showView: function(url, transition, params) {
	            url = url.replace(new RegExp("^" + this.remoteViewURLPrefix), "");
	            if (url === "" && this.remoteViewURLPrefix) {
	                url = "/";
	            }

	            if (url.replace(/^#/, "") === this.url) {
	                this.trigger(SAME_VIEW_REQUESTED);
	                return false;
	            }

	            this.trigger(SHOW_START);

	            var that = this,
	                element = that._findViewElement(url),
	                view = kendo.widgetInstance(element);

	            that.url = url.replace(/^#/, "");

	            that.params = params;

	            if (view && view.reload) {
	                view.purge();
	                element = [];
	            }

	            this.trigger(VIEW_TYPE_DETERMINED, { remote: element.length === 0, url: url });

	            if (element[0]) {
	                if (!view) {
	                    view = that._createView(element);
	                }

	                return that.viewContainer.show(view, transition, url);
	            } else {
	                return true;
	            }
	        },

	        append: function(html, url) {
	            var sandbox = this.sandbox,
	                urlPath = (url || "").split("?")[0],
	                container = this.container,
	                views,
	                view;

	            if (bodyRegExp.test(html)) {
	                html = RegExp.$1;
	            }

	            sandbox[0].innerHTML = html;

	            container.append(sandbox.children("script, style"));

	            views = this._hideViews(sandbox);
	            view = views.first();

	            // Generic HTML content found as remote view - no remote view markers
	            if (!view.length) {
	                views = view = sandbox.wrapInner("<div data-role=view />").children(); // one element
	            }

	            if (urlPath) {
	                view.hide().attr(attr("url"), urlPath);
	            }

	            container.append(views);

	            return this._createView(view);
	        },

	        _locate: function(selectors) {
	            return this.$angular ? directiveSelector(selectors) : roleSelector(selectors);
	        },

	        _findViewElement: function(url) {
	            var element,
	                urlPath = url.split("?")[0];

	            if (!urlPath) {
	                return this.rootView;
	            }

	            element = this.container.children("[" + attr("url") + "='" + urlPath + "']");

	            // do not try to search for "#/foo/bar" id, jQuery throws error
	            if (!element[0] && urlPath.indexOf("/") === -1) {
	                element = this.container.children(urlPath.charAt(0) === "#" ? urlPath : "#" + urlPath);
	            }

	            if (!element[0]) {
	                element = this._findViewElementById(url);
	            }

	            return element;
	        },

	        _findViewElementById: function(id) {
	            var element = this.container.children("[id='" + id + "']");
	            return element;
	        },

	        _createView: function(element) {
	            //return this._createMobileView(element);
	            return this._createSpaView(element);
	        },

	        _createMobileView: function(element) {
	            return kendo.initWidget(element, {
	                defaultTransition: this.transition,
	                loader: this.loader,
	                container: this.container,
	                getLayout: this.getLayoutProxy,
	                modelScope: this.modelScope,
	                reload: attrValue(element, "reload")
	            }, ui.roles);
	        },

	        _createSpaView: function(element) {
	            var viewOptions = (this.options || {}).viewOptions || {};
	            return new kendo.View(element, {
	                renderOnInit: viewOptions.renderOnInit,
	                wrap: viewOptions.wrap || false,
	                wrapInSections: viewOptions.wrapInSections,
	                detachOnHide: viewOptions.detachOnHide,
	                detachOnDestroy: viewOptions.detachOnDestroy
	            });
	        },

	        _hideViews: function(container) {
	            return container.children(this._locate("view")).hide();
	        }
	    });

	    kendo.ViewEngine = ViewEngine;

	    kendo.ViewContainer = ViewContainer;
	    kendo.Fragment = Fragment;
	    kendo.Layout = Layout;
	    kendo.View = View;
	    kendo.ViewClone = ViewClone;

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "iMcQ":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("n0tP");

var populateClientExports = __webpack_require__("651g").populateClientExports;
populateClientExports(exports);


/***/ }),

/***/ "iVlI":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1374);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1369:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("dWoE");

/***/ }),

/***/ 1374:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1369) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "scheduler.dayview",
	    name: "Scheduler Day View",
	    category: "web",
	    description: "The Scheduler Day View",
	    depends: [ "scheduler.view" ],
	    hidden: true
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        browser = kendo.support.browser,
	        setTime = kendo.date.setTime,
	        SchedulerView = ui.SchedulerView,
	        outerWidth = kendo._outerWidth,
	        outerHeight = kendo._outerHeight,
	        extend = $.extend,
	        proxy = $.proxy,
	        getDate = kendo.date.getDate,
	        MS_PER_MINUTE = kendo.date.MS_PER_MINUTE,
	        MS_PER_DAY = kendo.date.MS_PER_DAY,
	        CURRENT_TIME_MARKER_CLASS = "k-current-time",
	        CURRENT_TIME_MARKER_ARROW_CLASS = "k-current-time-arrow",
	        INVERSE_COLOR_CLASS = "k-event-inverse",
	        BORDER_SIZE_COEFF = 0.8666,
	        getMilliseconds = kendo.date.getMilliseconds,
	        NS = ".kendoMultiDayView";

	    var DAY_VIEW_EVENT_TEMPLATE = kendo.template('<div title="(#=kendo.format("{0:t} - {1:t}", start, end)#): #=title.replace(/"/g,"&\\#34;")#">' +
	                    '<div class="k-event-template k-event-time">#:kendo.format("{0:t} - {1:t}", start, end)#</div>' +
	                    '<div class="k-event-template">${title}</div>' +
	                '</div>'),
	        DAY_VIEW_ALL_DAY_EVENT_TEMPLATE = kendo.template('<div title="(#=kendo.format("{0:t}", start)#): #=title.replace(/"/g,"&\\#34;")#">' +
	                    '<div class="k-event-template">${title}</div>' +
	                '</div>'),
	        DATA_HEADER_TEMPLATE = kendo.template("#var dateString = isMobile ? kendo.toString(date,'ddd')[0] : kendo.toString(date,'ddd M/dd'); #" +
	                "<span class='k-link k-nav-day'>#=dateString#</span>"),
	        ALLDAY_EVENT_WRAPPER_STRING = '<div role="gridcell" aria-selected="false" ' +
	                'data-#=ns#uid="#=uid#"' +
	                '#if (resources[0]) { #' +
	                    'style="background-color:#=resources[0].color#; border-color: #=resources[0].color#"' +
	                    'class="k-event"' +
	                '#} else {#' +
	                    'class="k-event"' +
	                '#}#' +
	                '>' +
	                '<span class="k-event-actions">' +
	                    '# if(data.tail || data.middle) {#' +
	                        '<span class="k-icon k-i-arrow-60-left"></span>' +
	                    '#}#' +
	                    '# if(data.isException()) {#' +
	                        '<span class="k-icon k-i-non-recurrence"></span>' +
	                    '# } else if(data.isRecurring()) {#' +
	                        '<span class="k-icon k-i-reload"></span>' +
	                    '# } #' +
	                '</span>' +
	                '{0}' +
	                '<span class="k-event-actions">' +
	                    '#if (showDelete) {#' +
	                        '<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>' +
	                    '#}#' +
	                    '# if(data.head || data.middle) {#' +
	                        '<span class="k-icon k-i-arrow-60-right"></span>' +
	                    '#}#' +
	                '</span>' +
	                '#if(resizable && !singleDay && !data.tail && !data.middle){#' +
	                '<span class="k-resize-handle k-resize-w"></span>' +
	                '#}#' +
	                '#if(resizable && !singleDay && !data.head && !data.middle){#' +
	                '<span class="k-resize-handle k-resize-e"></span>' +
	                '#}#' +
	                '</div>',
	        EVENT_WRAPPER_STRING = '<div role="gridcell" aria-selected="false" ' +
	                'data-#=ns#uid="#=uid#" ' +
	                '#if (resources[0]) { #' +
	                    'style="background-color:#=resources[0].color #; border-color: #=resources[0].color#"' +
	                    'class="k-event"' +
	                '#} else {#' +
	                    'class="k-event"' +
	                '#}#' +
	                '>' +
	                 '<span class="k-event-actions">' +
	                    '# if(data.isException()) {#' +
	                        '<span class="k-icon k-i-non-recurrence"></span>' +
	                    '# } else if(data.isRecurring()) {#' +
	                        '<span class="k-icon k-i-reload"></span>' +
	                    '# } #' +
	                '</span>' +
	                '{0}' +
	                '<span class="k-event-actions">' +
	                    '#if (showDelete) {#' +
	                        '<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>' +
	                    '#}#' +
	                '</span>' +
	                '<span class="k-event-top-actions">' +
	                    '# if(data.tail || data.middle) {#' +
	                    '<span class="k-icon k-i-arrow-60-up"></span>' +
	                    '# } #' +
	                '</span>' +
	                '<span class="k-event-bottom-actions">' +
	                    '# if(data.head || data.middle) {#' +
	                        '<span class="k-icon k-i-arrow-60-down"></span>' +
	                    '# } #' +
	                '</span>' +
	                '# if(resizable && !data.tail && !data.middle) {#' +
	                '<span class="k-resize-handle k-resize-n"></span>' +
	                '# } #' +
	                '# if(resizable && !data.head && !data.middle) {#' +
	                    '<span class="k-resize-handle k-resize-s"></span>' +
	                '# } #' +
	                '</div>';

	    function toInvariantTime(date) {
	        var staticDate = new Date(1980, 1, 1, 0, 0, 0);
	        setTime(staticDate, getMilliseconds(date));
	        return staticDate;
	    }

	    function isInDateRange(value, min, max) {
	        return value >= min && value <= max;
	    }

	    function isInTimeRange(value, min, max, overlaps) {
	        overlaps = overlaps ? value <= max : value < max;
	        return value > min && overlaps;
	    }

	    function addContinuousEvent(group, range, element, isAllDay) {
	        var events = group._continuousEvents;
	        var lastEvent = events[events.length - 1];
	        var startDate = getDate(range.start.startDate()).getTime();

	        //this handles all day event which is over multiple slots but starts
	        //after one of the time events
	        if (isAllDay && lastEvent &&
	            getDate(lastEvent.start.startDate()).getTime() == startDate) {

	                var idx = events.length - 1;
	                for ( ; idx > -1; idx --) {
	                    if (events[idx].isAllDay ||
	                        getDate(events[idx].start.startDate()).getTime() < startDate) {
	                            break;
	                        }
	                }

	                events.splice(idx + 1, 0, {
	                    element: element,
	                    isAllDay: true,
	                    uid: element.attr(kendo.attr("uid")),
	                    start: range.start,
	                    end: range.end
	                });
	            } else {
	                events.push({
	                    element: element,
	                    isAllDay: isAllDay,
	                    uid: element.attr(kendo.attr("uid")),
	                    start: range.start,
	                    end: range.end
	                });
	            }
	    }

	    function getWorkDays(options) {
	        if(options.workDays && options.workDays.length) {
	            return options.workDays;
	        }

	        var workDays = [];
	        var dayIndex = options.workWeekStart % 7;
	        var workWeekEnd = Math.abs(options.workWeekEnd % 7);

	        workDays.push(dayIndex);

	        while(workWeekEnd != dayIndex) {
	            if(dayIndex > 6 ) {
	                dayIndex -= 7;
	            } else {
	                dayIndex++;
	            }
	            workDays.push(dayIndex);
	        }
	        return workDays;
	    }

	    var MultiDayView = SchedulerView.extend({
	        init: function(element, options) {
	            var that = this;

	            SchedulerView.fn.init.call(that, element, options);

	            that.title = that.options.title || that.options.name;

	            that._workDays = getWorkDays(that.options);

	            that._templates();

	            that._editable();

	            that.calculateDateRange();

	            that._groups();

	            that._currentTime(true);
	        },

	        _currentTimeMarkerUpdater: function() {
	            this._updateCurrentTimeMarker(new Date());
	        },

	        _updateCurrentTimeMarker: function(currentTime) {
	            var options = this.options,
	                currentTimeMarkers, currentContentMarkers, timesTableMarkerWidth, position,
	                elementHtml = "<div class='" + CURRENT_TIME_MARKER_CLASS + "'></div>";

	            if(options.currentTimeMarker.useLocalTimezone === false) {
	                var timezone = options.dataSource.options.schema.timezone;

	                if(options.dataSource && timezone) {
	                   var timezoneOffset = kendo.timezone.offset(currentTime, timezone);
	                   currentTime = kendo.timezone.convert(currentTime, currentTime.getTimezoneOffset(), timezoneOffset);
	                }
	            }

	            currentTimeMarkers = this.times.find("." + CURRENT_TIME_MARKER_CLASS);
	            currentContentMarkers = this.content.find("." + CURRENT_TIME_MARKER_CLASS);

	            var groupsCount = !options.group || options.group.orientation == "horizontal" ? 1 : this.groups.length;
	            var firstTimesCell = this.times.find("tr:first th:first");
	            var lastTimesCell = this.times.find("tr:first th:last");

	            var markerWidth = this.content[0].scrollWidth;

	            if(browser.msie || browser.edge) {
	                markerWidth -= 1;
	            }

	            if(firstTimesCell.length > 0 && lastTimesCell.length > 0) {
	                if (this._isRtl) {
	                    position = firstTimesCell.position().left + outerHeight(firstTimesCell) - outerHeight(lastTimesCell);
	                } else {
	                    position = lastTimesCell.position().left;
	                }
	            }

	            for(var groupIndex = 0; groupIndex < groupsCount; groupIndex++) {
	                var currentGroup = this.groups[groupIndex];

	                if (!currentGroup) {
	                    return;
	                }

	                var utcCurrentTime = kendo.date.toUtcTime(currentTime);
	                var ranges = currentGroup.timeSlotRanges(utcCurrentTime, utcCurrentTime + 1);

	                if(ranges.length === 0) {
	                    return;
	                }

	                var collection = ranges[0].collection;
	                var slotElement = collection.slotByStartDate(currentTime);

	                if(slotElement) {
	                    var timesTableMarker = currentTimeMarkers[groupIndex] ? currentTimeMarkers.eq(groupIndex) : $(elementHtml).prependTo(this.times);
	                    var markerTopPosition = Math.round(ranges[0].innerRect(currentTime, new Date(currentTime.getTime() + 1), false).top);

	                    var timesTableMarkerCss = {};

	                    if (this._isRtl) {
	                        timesTableMarkerCss.right = position;
	                        timesTableMarker.addClass(CURRENT_TIME_MARKER_ARROW_CLASS + "-left");
	                    } else {
	                        timesTableMarkerCss.left = position;
	                        timesTableMarker.addClass(CURRENT_TIME_MARKER_ARROW_CLASS + "-right");
	                    }

	                    if(!timesTableMarkerWidth) {
	                        timesTableMarkerWidth = (outerWidth(timesTableMarker) * BORDER_SIZE_COEFF / 2);
	                    }

	                    timesTableMarkerCss.top = markerTopPosition - timesTableMarkerWidth;

	                    timesTableMarker.css(timesTableMarkerCss);

	                    var contentMarker = currentContentMarkers[groupIndex] ? currentContentMarkers.eq(groupIndex) : $(elementHtml).prependTo(this.content);

	                    contentMarker.css({
	                        top: markerTopPosition,
	                        height: "1px",
	                        right: 0,
	                        width: markerWidth,
	                        left: 0
	                    });
	                }
	            }
	        },

	        _currentTime: function(setUpdateTimer) {
	            var that = this;
	            var markerOptions = that.options.currentTimeMarker;

	            if (markerOptions !== false && markerOptions.updateInterval !== undefined) {
	                that._currentTimeMarkerUpdater();

	                if (setUpdateTimer) {
	                    that._currentTimeUpdateTimer = setInterval(proxy(this._currentTimeMarkerUpdater, that), markerOptions.updateInterval);
	                }
	            }
	        },

	        _updateResizeHint: function(event, groupIndex, startTime, endTime) {
	            var multiday = event.isMultiDay();

	            var group = this.groups[groupIndex];

	            var ranges = group.ranges(startTime, endTime, multiday, event.isAllDay);
	            var width, height, top, hint;

	            this._removeResizeHint();

	            for (var rangeIndex = 0; rangeIndex < ranges.length; rangeIndex++) {
	                var range = ranges[rangeIndex];
	                var start = range.startSlot();

	                if (this._isGroupedByDate() && multiday) {
	                    for (var slotIdx = start.index; slotIdx <= range.end.index; slotIdx++) {
	                        var slot = range.collection._slots[slotIdx];
	                        width = slot.offsetWidth;
	                        height = slot.clientHeight;
	                        top = slot.offsetTop;

	                        hint = SchedulerView.fn._createResizeHint.call(this,
	                            slot.offsetLeft,
	                            top,
	                            width,
	                            height
	                        );

	                        this._resizeHint = this._resizeHint.add(hint);
	                    }
	                } else {
	                    width = start.offsetWidth;
	                    height = start.clientHeight;
	                    top = start.offsetTop;

	                    if (multiday) {
	                        width = range.innerWidth();
	                    } else {
	                        var rect = range.outerRect(startTime, endTime, this.options.snap);
	                        top = rect.top;
	                        height = rect.bottom - rect.top;
	                    }

	                    hint = SchedulerView.fn._createResizeHint.call(this,
	                        start.offsetLeft,
	                        top,
	                        width,
	                        height
	                    );

	                   this._resizeHint = this._resizeHint.add(hint);
	                }
	            }

	            var format = "t";
	            var container = this.content;

	            if (multiday) {
	                format = "M/dd";
	                container = this.element.find(".k-scheduler-header-wrap:has(.k-scheduler-header-all-day) > div");
	                if (!container.length) {
	                    container = this.content;
	                }
	            }

	            this._resizeHint.appendTo(container);

	            this._resizeHint.find(".k-label-top,.k-label-bottom").text("");

	            this._resizeHint.first().addClass("k-first").find(".k-label-top").text(kendo.toString(kendo.timezone.toLocalDate(startTime), format));

	            this._resizeHint.last().addClass("k-last").find(".k-label-bottom").text(kendo.toString(kendo.timezone.toLocalDate(endTime), format));
	        },

	        _updateMoveHint: function (event, groupIndex, distance) {
	            var multiday = event.isMultiDay();

	            var group = this.groups[groupIndex];

	            var start = kendo.date.toUtcTime(event.start) + distance;

	            var end = start + event.duration();

	            var ranges = group.ranges(start, end, multiday, event.isAllDay);

	            start = kendo.timezone.toLocalDate(start);

	            end = kendo.timezone.toLocalDate(end);

	            this._removeMoveHint(event.uid);

	            if (!multiday && (getMilliseconds(end) === 0 || getMilliseconds(end) < getMilliseconds(this.startTime()))) {
	                if (ranges.length > 1) {
	                    ranges.pop();
	                }
	            }

	            var eventHint = $();

	            for (var rangeIndex = 0; rangeIndex < ranges.length; rangeIndex++) {
	                var range = ranges[rangeIndex];
	                var startSlot = range.start;
	                var hint;
	                var css = {
	                    left: startSlot.offsetLeft + 2,
	                    top: startSlot.offsetTop
	                };

	                if (this._isGroupedByDate() && multiday) {
	                    for (var slotIdx = startSlot.index; slotIdx <= range.end.index; slotIdx++) {
	                        var slot = range.collection._slots[slotIdx];

	                        css.left = this._isRtl ? slot.clientWidth * 0.1 + slot.offsetLeft + 2 : slot.offsetLeft + 2;
	                        css.height = slot.offsetHeight;
	                        css.width = slot.clientWidth * 0.9 - 2;

	                        hint = this._createEventElement(event.clone({ start: start, end: end }), !multiday);

	                        if(event.inverseColor) {
	                            hint.addClass(INVERSE_COLOR_CLASS);
	                        }

	                        this._appendMoveHint(hint, css);
	                        eventHint = eventHint.add(hint);
	                    }
	                } else {
	                    if (this._isRtl) {
	                       css.left = startSlot.clientWidth * 0.1 + startSlot.offsetLeft + 2;
	                    }

	                    if (multiday) {
	                        css.width = range.innerWidth() - 2;
	                    } else {
	                        var rect = range.outerRect(start, end, this.options.snap);
	                        css.top = rect.top;
	                        css.height = rect.bottom - rect.top;
	                        css.width = startSlot.clientWidth * 0.9 - 2;
	                    }

	                    hint = this._createEventElement(event.clone({ start: start, end: end }), !multiday);

	                    if(event.inverseColor) {
	                        hint.addClass(INVERSE_COLOR_CLASS);
	                    }

	                    this._appendMoveHint(hint, css);
	                    eventHint = eventHint.add(hint);
	                }
	            }

	            var content = this.content;

	            if (multiday) {
	                content = this.element.find(".k-scheduler-header-wrap:has(.k-scheduler-header-all-day) > div");
	                if (!content.length) {
	                    content = this.content;
	                }
	            }

	            eventHint.appendTo(content);
	        },

	        _appendMoveHint: function(hint, css) {
	            hint.addClass("k-event-drag-hint");

	            hint.css(css);

	            this._moveHint = this._moveHint.add(hint);
	       },

	       _slotByPosition: function(x, y) {
	           var slot, offset;

	           if (this._isVerticallyGrouped()) {
	               offset = this.content.offset();
	               y += this.content[0].scrollTop;
	               x += this.content[0].scrollLeft;
	           } else {
	               offset = this.element.find(".k-scheduler-header-wrap:has(.k-scheduler-header-all-day)").find(">div").offset();
	           }

	           if (offset) {
	               x -= offset.left;
	               y -= offset.top;
	           }

	           x = Math.ceil(x);
	           y = Math.ceil(y);

	           var group;
	           var groupIndex;

	           for (groupIndex = 0; groupIndex < this.groups.length; groupIndex++) {
	                group = this.groups[groupIndex];

	                slot = group.daySlotByPosition(x, y, this._isGroupedByDate());

	                if (slot) {
	                    return slot;
	                }
	           }

	           if (offset) {
	               x += offset.left;
	               y += offset.top;
	           }

	           offset = this.content.offset();

	           x -= offset.left;
	           y -= offset.top;

	           if (!this._isVerticallyGrouped()) {
	               y += this.content[0].scrollTop;
	               x += this.content[0].scrollLeft;
	           }

	           x = Math.ceil(x);
	           y = Math.ceil(y);

	           for (groupIndex = 0; groupIndex < this.groups.length; groupIndex++) {
	                group = this.groups[groupIndex];

	                slot = group.timeSlotByPosition(x, y);

	                if (slot) {
	                    return slot;
	                }
	           }

	           return null;
	       },

	       _groupCount: function() {
	            var resources = this.groupedResources;
	            var byDate = this._isGroupedByDate();

	            if (resources.length) {
	                if (this._groupOrientation() === "vertical") {
	                    if (byDate) {
	                        return this._columnCountForLevel(resources.length - 1);
	                    } else {
	                        return this._rowCountForLevel(resources.length - 1);
	                    }
	                } else {
	                    if (byDate) {
	                        return this._columnCountForLevel(resources.length) / this._columnCountForLevel(0);
	                    } else {
	                          return this._columnCountForLevel(resources.length) / this._columnOffsetForResource(resources.length);
	                    }
	                }
	            }
	            return 1;
	        },

	        _columnCountInResourceView: function() {
	            var resources = this.groupedResources;
	            var byDate = this._isGroupedByDate();

	            if (!resources.length || this._isVerticallyGrouped()) {
	                if (byDate) {
	                     return this._rowCountForLevel(0);
	                } else {
	                     return this._columnCountForLevel(0);
	                }
	            }

	            if (byDate) {
	                return this._columnCountForLevel(0);
	            } else {
	                return this._columnOffsetForResource(resources.length);
	            }
	        },

	        _timeSlotGroups: function(groupCount, columnCount) {
	            var interval = this._timeSlotInterval();
	            var verticalViews = groupCount;
	            var byDate = this._isGroupedByDate();
	            var tableRows = this.content.find("tr:not(.k-scheduler-header-all-day)");
	            var group, time, rowIndex, cellIndex;

	            tableRows.attr("role", "row");

	            var rowCount = tableRows.length;

	            if (this._isVerticallyGrouped()) {
	                if (byDate) {
	                    verticalViews = columnCount;
	                }
	                rowCount = Math.floor(rowCount / verticalViews);
	            }

	            for (var groupIndex = 0; groupIndex < verticalViews; groupIndex++) {
	                var rowMultiplier = 0;
	                var cellMultiplier = 0;

	                if (this._isVerticallyGrouped()) {
	                    rowMultiplier = groupIndex;
	                } else{
	                    cellMultiplier = groupIndex;
	                }

	                rowIndex = rowMultiplier * rowCount;

	              while (rowIndex < (rowMultiplier + 1) * rowCount) {
	                    var cells = tableRows[rowIndex].children;

	                    if (rowIndex % rowCount === 0) {
	                        time = getMilliseconds(new Date(+this.startTime()));
	                    }

	                    var timeIndex = 0;
	                    if(byDate){
	                        if (this._isVerticallyGrouped()) {
	                            for (cellIndex = 0; cellIndex < groupCount; cellIndex++) {
	                                group = this.groups[cellIndex];
	                                this._addTimeSlotGroup(group, cells, cellIndex, time, interval, groupIndex);
	                            }
	                        } else {
	                            group = this.groups[groupIndex];
	                            for (cellIndex = cellMultiplier; cellIndex < groupCount * columnCount; cellIndex=cellIndex + groupCount) {
	                                this._addTimeSlotGroup(group, cells, cellIndex, time, interval, timeIndex);
	                                timeIndex++;
	                            }
	                        }
	                    } else {
	                        group = this.groups[groupIndex];
	                        for (cellIndex = cellMultiplier * columnCount; cellIndex < (cellMultiplier + 1) * columnCount; cellIndex++) {

	                            this._addTimeSlotGroup(group, cells, cellIndex, time, interval,  timeIndex);
	                             timeIndex++;
	                        }
	                    }

	                    time += interval;
	                    rowIndex ++;
	                }
	            }
	        },

	        _addTimeSlotGroup: function(group, cells, cellIndex, time, interval, timeIndex) {
	              var cell = cells[cellIndex];
	              var collection = group.getTimeSlotCollection(timeIndex);
	              var currentDate = this._dates[timeIndex];
	              if(!currentDate || !cell){
	                  return;
	              }
	              var currentTime = Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
	              var start = currentTime + time;
	              var end = start + interval;

	              cell.setAttribute("role", "gridcell");
	              cell.setAttribute("aria-selected", false);

	              collection.addTimeSlot(cell, start, end);
	        },

	         _addDaySlotGroup: function(collection, cells, cellIndex, columnCount, cellCount) {
	                var cell = cells[cellIndex];
	                var start = this._dates[cellCount];
	                if(!start){
	                    return;
	                }
	                var currentTime = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());

	                cell.setAttribute("role", "gridcell");
	                cell.setAttribute("aria-selected", false);
	                collection.addDaySlot(cell, currentTime, currentTime + kendo.date.MS_PER_DAY);
	        },

	        _daySlotGroups: function(groupCount, columnCount) {
	            var tableRows, cellIndex;
	            var verticalViews = groupCount;
	            var byDate = this._isGroupedByDate();

	            if (this._isVerticallyGrouped()) {
	                if (byDate) {
	                    verticalViews = columnCount;
	                }
	                tableRows = this.element.find(".k-scheduler-header-all-day");
	            } else {
	                tableRows = this.element.find(".k-scheduler-header-all-day tr");
	            }

	            tableRows.attr("role", "row");

	            for (var groupIndex = 0; groupIndex < verticalViews; groupIndex++) {
	                var rowMultiplier = 0;
	                var group, collection;

	                if (this._isVerticallyGrouped()) {
	                    rowMultiplier = groupIndex;
	                }

	                var cells = tableRows[rowMultiplier].children;
	                var cellMultiplier = 0;

	                if (!this._isVerticallyGrouped()) {
	                    cellMultiplier = groupIndex;
	                }

	                var cellCount = 0;
	                if(byDate){
	                    if (this._isVerticallyGrouped()) {
	                        for (cellIndex = 0; cellIndex < groupCount; cellIndex++) {
	                            group = this.groups[cellIndex];
	                            collection = group.getDaySlotCollection(0);
	                            this._addDaySlotGroup(collection, cells, cellIndex, columnCount, groupIndex);
	                        }
	                    } else {
	                        group = this.groups[groupIndex];
	                        collection = group.getDaySlotCollection(0);
	                        for (cellIndex = cellMultiplier; cellIndex < groupCount * columnCount; cellIndex = cellIndex + groupCount) {
	                            this._addDaySlotGroup(collection, cells, cellIndex, columnCount, cellCount);
	                            cellCount++;
	                        }
	                    }
	                } else {
	                    group = this.groups[groupIndex];
	                    collection = group.getDaySlotCollection(0);
	                    for (cellIndex = cellMultiplier * columnCount; cellIndex < (cellMultiplier + 1) * columnCount; cellIndex++) {

	                        this._addDaySlotGroup(collection, cells, cellIndex, columnCount, cellCount);
	                        cellCount++;
	                    }
	                }
	            }
	        },

	        _groups: function() {
	            var groupCount = this._groupCount();
	            var columnCount = this._columnCountInResourceView();

	            this.groups = [];

	            for (var idx = 0; idx < groupCount; idx++) {
	                var view = this._addResourceView(idx);

	                for (var columnIndex = 0; columnIndex < columnCount; columnIndex++) {
	                    if(this._dates[columnIndex]){
	                        view.addTimeSlotCollection(this._dates[columnIndex], kendo.date.addDays(this._dates[columnIndex], 1));
	                    }
	                }

	                if (this.options.allDaySlot) {
	                    view.addDaySlotCollection(this._dates[0], kendo.date.addDays(this._dates[this._dates.length - 1], 1));
	                }
	            }

	            this._timeSlotGroups(groupCount, columnCount);

	            if (this.options.allDaySlot) {
	                this._daySlotGroups(groupCount, columnCount);
	            }
	        },

	        options: {
	            name: "MultiDayView",
	            selectedDateFormat: "{0:D}",
	            selectedShortDateFormat: "{0:d}",
	            selectedMobileDateFormat: "{0:MMM} {0:dd} - {1:dd}",
	            allDaySlot: true,
	            showWorkHours: false,
	            title: "",
	            startTime: kendo.date.today(),
	            endTime: kendo.date.today(),
	            minorTickCount: 2,
	            majorTick: 60,
	            majorTimeHeaderTemplate: "<span>#=kendo.toString(date, 't')#</span>",
	            minorTimeHeaderTemplate: "&\\#8203;",
	            groupHeaderTemplate: "#=text#",
	            slotTemplate: "&nbsp;",
	            allDaySlotTemplate: "&nbsp;",
	            eventTemplate: DAY_VIEW_EVENT_TEMPLATE,
	            allDayEventTemplate: DAY_VIEW_ALL_DAY_EVENT_TEMPLATE,
	            dateHeaderTemplate: DATA_HEADER_TEMPLATE,
	            editable: true,
	            workDayStart: new Date(1980, 1, 1, 8, 0, 0),
	            workDayEnd: new Date(1980, 1, 1, 17, 0, 0),
	            workWeekStart: 1,
	            workWeekEnd: 5,
	            footer: {
	                command: "workDay"
	            },
	            messages: {
	                allDay: "all day",
	                showFullDay: "Show full day",
	                showWorkDay: "Show business hours"
	            },
	            currentTimeMarker: {
	                 updateInterval: 10000,
	                 useLocalTimezone: true
	            }
	        },

	        events: ["remove", "add", "edit"],

	        _templates: function() {
	            var options = this.options,
	                settings = extend({}, kendo.Template, options.templateSettings);

	            this.eventTemplate = this._eventTmpl(options.eventTemplate, EVENT_WRAPPER_STRING);
	            this.allDayEventTemplate = this._eventTmpl(options.allDayEventTemplate, ALLDAY_EVENT_WRAPPER_STRING);

	            this.majorTimeHeaderTemplate = kendo.template(options.majorTimeHeaderTemplate, settings);
	            this.minorTimeHeaderTemplate = kendo.template(options.minorTimeHeaderTemplate, settings);
	            this.dateHeaderTemplate = kendo.template(options.dateHeaderTemplate, settings);
	            this.slotTemplate = kendo.template(options.slotTemplate, settings);
	            this.allDaySlotTemplate = kendo.template(options.allDaySlotTemplate, settings);
	            this.groupHeaderTemplate = kendo.template(options.groupHeaderTemplate, settings);
	        },

	        _editable: function() {
	            if (this.options.editable) {
	                if (this._isMobile()) {
	                    this._touchEditable();
	                } else {
	                    this._mouseEditable();
	                }
	            }
	        },

	        _mouseEditable: function() {
	            var that = this;
	            that.element.on("click" + NS, ".k-event a:has(.k-i-close)", function(e) {
	                that.trigger("remove", { uid: $(this).closest(".k-event").attr(kendo.attr("uid")) });
	                e.preventDefault();
	            });

	            if (that.options.editable.create !== false) {
	                that.element.on("dblclick" + NS, ".k-scheduler-content > table td", function(e) {
	                    if (!$(this).parent().hasClass("k-scheduler-header-all-day")) {
	                        var slot = that._slotByPosition(e.pageX, e.pageY);

	                        if (slot) {
	                            var resourceInfo = that._resourceBySlot(slot);
	                            that.trigger("add", { eventInfo: extend({ start: slot.startDate(), end: slot.endDate() }, resourceInfo) });
	                        }

	                        e.preventDefault();
	                    }
	                }).on("dblclick" + NS, ".k-scheduler-header-all-day td", function(e) {
	                    var slot = that._slotByPosition(e.pageX, e.pageY);
	                    if (slot) {
	                        var resourceInfo = that._resourceBySlot(slot);
	                        that.trigger("add", { eventInfo: extend({}, { isAllDay: true, start: kendo.date.getDate(slot.startDate()), end: kendo.date.getDate(slot.startDate()) }, resourceInfo) });
	                    }
	                    e.preventDefault();
	                });
	            }

	            if (that.options.editable.update !== false) {
	                that.element.on("dblclick" + NS, ".k-event", function(e) {
	                    that.trigger("edit", { uid: $(this).closest(".k-event").attr(kendo.attr("uid")) });
	                    e.preventDefault();
	                });
	            }
	        },

	        _touchEditable: function() {
	            var that = this;
	            var threshold = 0;

	            if (kendo.support.mobileOS.android) {
	                threshold = 5;
	            }

	            if (that.options.editable.create !== false) {
	                that._addUserEvents = new kendo.UserEvents(that.element, {
	                    threshold: threshold,
	                    filter:  ".k-scheduler-content td",
	                    useClickAsTap: !kendo.support.browser.edge,
	                    tap: function(e) {
	                        if (that._scrolling) {
	                            return;
	                        }
	                        if (!$(e.target).parent().hasClass("k-scheduler-header-all-day")) {
	                            var x = e.x.location !== undefined ? e.x.location : e.x;
	                            var y = e.y.location !== undefined ? e.y.location : e.y;
	                            var slot = that._slotByPosition(x, y);

	                            if (slot) {
	                                var resourceInfo = that._resourceBySlot(slot);
	                                that.trigger("add", { eventInfo: extend({ start: slot.startDate(), end: slot.endDate() }, resourceInfo) });
	                            }

	                            e.preventDefault();
	                        }
	                    }
	                });

	                that._allDayUserEvents = new kendo.UserEvents(that.element, {
	                    threshold: threshold,
	                    useClickAsTap: !kendo.support.browser.edge,
	                    filter: ".k-scheduler-header-all-day td",
	                    tap: function(e) {
	                        if (that._scrolling) {
	                            return;
	                        }
	                        var x = e.x.location !== undefined ? e.x.location : e.x;
	                        var y = e.y.location !== undefined ? e.y.location : e.y;
	                        var slot = that._slotByPosition(x, y);

	                        if (slot) {
	                            var resourceInfo = that._resourceBySlot(slot);
	                            that.trigger("add", { eventInfo: extend({}, { isAllDay: true, start: kendo.date.getDate(slot.startDate()), end: kendo.date.getDate(slot.startDate()) }, resourceInfo) });
	                        }

	                        e.preventDefault();
	                    }
	                });
	            }

	            if (that.options.editable.update !== false) {
	                that._editUserEvents = new kendo.UserEvents(that.element, {
	                    threshold: threshold,
	                    useClickAsTap: !kendo.support.browser.edge,
	                    filter: ".k-event",
	                    tap: function(e) {
	                        if (that._scrolling) {
	                            return;
	                        }
	                        var eventElement = $(e.target).closest(".k-event");
	                        var touchElement = $(e.touch.initialTouch);

	                        if (touchElement.hasClass("k-i-close")) {
	                            that.trigger("remove", { uid: eventElement.attr(kendo.attr("uid")) });
	                        } else if (!eventElement.hasClass("k-event-active")) {
	                            that.trigger("edit", { uid: eventElement.attr(kendo.attr("uid")) });
	                        }

	                        e.preventDefault();
	                    }
	                });
	            }
	        },

	        _layout: function(dates) {
	            var columns = [];
	            var rows = [];
	            var options = this.options;
	            var that = this;
	            var byDate = that._isGroupedByDate();

	            for (var idx = 0; idx < dates.length; idx++) {
	                var column = {};

	                column.text = that.dateHeaderTemplate({ date: dates[idx], isMobile: that._isMobile() });

	                if (kendo.date.isToday(dates[idx])) {
	                    column.className = "k-today";
	                }

	                columns.push(column);
	            }

	            var resources = this.groupedResources;

	            if (options.allDaySlot) {
	                rows.push({
	                    text: options.messages.allDay, allDay: true,
	                    cellContent: function(idx) {
	                        var groupIndex = idx;

	                        idx = resources.length && that._groupOrientation() !== "vertical" ? idx % dates.length : idx;

	                        return that.allDaySlotTemplate({ date: dates[idx], resources: function() {
	                                return that._resourceBySlot({ groupIndex: groupIndex });
	                            }
	                        });
	                    }
	                });
	            }

	            this._forTimeRange(this.startTime(), this.endTime(), function(date, majorTick, middleRow, lastSlotRow) {
	                var template = majorTick ? that.majorTimeHeaderTemplate : that.minorTimeHeaderTemplate;

	                var row = {
	                    text: template({ date: date }),
	                    className: lastSlotRow ? "k-slot-cell" : ""
	                };

	                rows.push(row);
	            });


	            if (resources.length) {
	                if (this._groupOrientation() === "vertical") {
	                    if (byDate) {
	                        rows = this._createDateLayout(columns, rows);
	                        columns = this._createColumnsLayout(resources, null, this.groupHeaderTemplate);
	                    } else {
	                        rows = this._createRowsLayout(resources, rows, this.groupHeaderTemplate);
	                    }
	                } else {
	                      if (byDate) {
	                         columns = this._createColumnsLayout(resources, columns, this.groupHeaderTemplate, columns);
	                      }else {
	                         columns = this._createColumnsLayout(resources, columns, this.groupHeaderTemplate);
	                      }
	                }
	            }

	            return {
	                columns: columns,
	                rows: rows
	            };
	        },

	        _footer: function() {
	            var options = this.options;

	            if (options.footer !== false) {
	                var html = '<div class="k-scheduler-footer k-toolbar">';

	                var command = options.footer.command;

	                if (this._isMobile()) {
	                    html += '<span class="k-state-default k-scheduler-today"><a href="#" class="k-link">';
	                    html += options.messages.today + '</a></span>';
	                }
	                if (command && command === "workDay") {
	                    if (this._isMobile()) {
	                        html += '<span class="k-state-default k-scheduler-fullday"><a href="#" class="k-link">';
	                        html += (options.showWorkHours ? options.messages.showFullDay : options.messages.showWorkDay) + '</a></span>';
	                    } else {
	                        html += '<button type="button" class="k-button k-scheduler-fullday">';
	                            html += '<span class="k-icon k-i-clock"></span>';
	                            html += '<span class="k-button-text">';
	                                html += (options.showWorkHours ? options.messages.showFullDay : options.messages.showWorkDay);
	                            html += '</span>';
	                        html += '</button>';
	                    }
	                }

	                html += "</div>";

	                this.footer = $(html).appendTo(this.element);

	                var that = this;

	                this.footer.on("click" + NS, ".k-scheduler-fullday", function(e) {
	                    e.preventDefault();
	                    that.trigger("navigate", { view: that.name || options.name, date: options.date, isWorkDay: !options.showWorkHours });
	                });

	                this.footer.on("click" + NS, ".k-scheduler-today", function(e) {
	                    e.preventDefault();
	                    var timezone = that.options.timezone;
	                    var action = "today";
	                    var currentDate = new Date();
	                    var date;

	                    if(timezone){
	                        var timezoneOffset = kendo.timezone.offset(currentDate, timezone);
	                        date = kendo.timezone.convert(currentDate, currentDate.getTimezoneOffset(), timezoneOffset);
	                    }else{
	                        date = currentDate;
	                    }

	                    that.trigger("navigate", { view: that.name || options.name, action: action, date: date });
	                });
	            }
	        },

	        _forTimeRange: function(min, max, action, after) {
	            min = toInvariantTime(min); //convert the date to 1/2/1980 and sets the time
	            max = toInvariantTime(max);

	            var that = this,
	                msMin = getMilliseconds(min),
	                msMax = getMilliseconds(max),
	                minorTickCount = that.options.minorTickCount,
	                msMajorInterval = that.options.majorTick * MS_PER_MINUTE,
	                msInterval = msMajorInterval / minorTickCount || 1,
	                start = new Date(+min),
	                startDay = start.getDate(),
	                msStart,
	                idx = 0, length,
	                html = "";

	            length = MS_PER_DAY / msInterval;

	            if (msMin != msMax) {
	                if (msMin > msMax) {
	                    msMax += MS_PER_DAY;
	                }

	                length = ((msMax - msMin) / msInterval);
	            }

	            length = Math.round(length);

	            for (; idx < length; idx++) {
	                var majorTickDivider = idx % (msMajorInterval/msInterval),
	                    isMajorTickRow = majorTickDivider === 0,
	                    isMiddleRow = majorTickDivider < minorTickCount - 1,
	                    isLastSlotRow = majorTickDivider === minorTickCount - 1;

	                html += action(start, isMajorTickRow, isMiddleRow, isLastSlotRow);

	                setTime(start, msInterval, false);
	            }

	            if (msMax) {
	                msStart = getMilliseconds(start);
	                if (startDay < start.getDate()) {
	                    msStart += MS_PER_DAY;
	                }

	                if (msStart > msMax) {
	                    start = new Date(+max);
	                }
	            }

	            if (after) {
	                html += after(start);
	            }

	            return html;
	        },

	        _content: function(dates) {
	            var that = this;
	            var html = '';

	            html += '<tbody>';

	            html += that._renderRows(dates, that.rowLevels, that.columnLevels);

	            html += '</tbody>';

	            this.content.find("table").append(html);
	        },

	        _virtualContent: function(rowLevels, columnLevels){
	            var that = this;
	            var html = '';
	            var dates = that._dates;

	            html += that._renderRows(dates, rowLevels, columnLevels);

	            that.content.find("table tbody").append(html);
	        },

	        _renderRows: function (dates, rowLevels, columnLevels) {
	            var that = this;
	            var isVerticalGroupped = that._groupOrientation() === "vertical";
	            var byDate = that._isGroupedByDate();
	            var dateID = 0;
	            var columnCount = dates.length;
	            var options = that.options;
	            var start = that.startTime();
	            var end = this.endTime();
	            var groupsCount = 1;
	            var rowCount = 1;
	            var resources = this.groupedResources;
	            var html = '';

	            if (resources.length) {
	                var levels = that._recalculateLevels(rowLevels, columnLevels);

	                rowCount = levels.rowCount;
	                groupsCount = levels.groupsCount;
	            }

	            var appendRow = function(date, majorTick, middleRow) {
	                var content = "";
	                var groupIdx = 0;
	                var idx, length;

	                content = '<tr' + (middleRow ? ' class="k-middle-row"' : "") + '>';

	                if (byDate) {
	                    for (idx = 0, length = columnCount; idx < length; idx++) {
	                        for (groupIdx = 0; groupIdx < groupsCount; groupIdx++) {
	                            var dateIndex = idx;
	                            if (isVerticalGroupped) {
	                                dateIndex = dateID;
	                            }
	                            content = that._addCellsToContent(content, dates, date, dateIndex, groupIdx, rowIdx);

	                        }
	                        if (isVerticalGroupped) {

	                            break;
	                        }
	                    }
	                } else {
	                     for (; groupIdx < groupsCount; groupIdx++) {
	                        for (idx = 0, length = columnCount; idx < length; idx++) {
	                            content = that._addCellsToContent(content, dates, date, idx, groupIdx, rowIdx);
	                        }
	                     }
	                }

	                content += "</tr>";

	                return content;
	            };

	            for (var rowIdx = 0; rowIdx < rowCount; rowIdx++) {
	                html += options.allDaySlot && isVerticalGroupped ? this._allDayVerticalGroupRow(dates, rowIdx, groupsCount, dateID) : "";

	                html += this._forTimeRange(start, end, appendRow);
	                if (isVerticalGroupped) {
	                        dateID++;
	                }
	            }

	            return html;
	        },

	        _recalculateLevels: function (rowLevels, columnLevels) {
	            var that = this;
	            var byDate = that._isGroupedByDate();
	            var isVerticalGroupped = that._groupOrientation() === "vertical";
	            var groupsCount = 1;
	            var rowCount = 1;

	            if (isVerticalGroupped) {
	                rowCount = that._rowCountForLevel(rowLevels.length - 2, rowLevels);

	                if (byDate) {
	                     groupsCount = that._columnCountForLevel(columnLevels.length - 1);
	                }
	            } else {
	                if (byDate) {
	                     groupsCount = that._columnCountForLevel(columnLevels.length - 1) / this._columnCountForLevel(0);
	                } else {
	                     groupsCount = that._columnCountForLevel(columnLevels.length - 2);
	                }
	            }

	            return {
	                rowCount: rowCount,
	                groupsCount: groupsCount
	            };
	        },

	        _allDayVerticalGroupRow: function (dates, groupIndex, groupsCount, dateID) {
	            var that = this;
	            var result = '<tr class="k-scheduler-header-all-day">';
	            var byDate = that._isGroupedByDate();
	            var dateGroupIndex = byDate ? 0 : groupIndex;
	            var allDaySlotTemplate = that.allDaySlotTemplate;

	            var resources = function() {
	                return that._resourceBySlot({ groupIndex: dateGroupIndex });
	            };

	            if (byDate) {
	                for (; dateGroupIndex < groupsCount; dateGroupIndex++) {
	                    result += "<td>" + allDaySlotTemplate({ date: dates[dateID], resources: resources }) + "</td>";
	                }
	            } else {
	                for (var idx = 0; idx < dates.length; idx++) {
	                    result += "<td>" + allDaySlotTemplate({ date: dates[idx], resources: resources }) + "</td>";
	                }
	            }

	            return result + "</tr>";
	        },

	        _addCellsToContent: function(content, dates, date, idx, groupIdx, rowIdx) {
	            var that = this;
	            var classes = "";
	            var tmplDate;
	            var slotTemplate = this.slotTemplate;
	            var isVerticalGroupped = this._groupOrientation() === "vertical";
	            var resources = function(groupIndex) {
	                return function() {
	                    return that._resourceBySlot({ groupIndex: groupIndex });
	                };
	            };

	            if (kendo.date.isToday(dates[idx])) {
	                classes += "k-today";
	            }

	            if (kendo.date.getMilliseconds(date) < kendo.date.getMilliseconds(this.options.workDayStart) ||
	                kendo.date.getMilliseconds(date) >= kendo.date.getMilliseconds(this.options.workDayEnd) ||
	                !this._isWorkDay(dates[idx])) {
	                classes += " k-nonwork-hour";
	            }

	            content += '<td' + (classes !== "" ? ' class="' + classes + '"' : "") + ">";
	            tmplDate = kendo.date.getDate(dates[idx]);
	            kendo.date.setTime(tmplDate, kendo.date.getMilliseconds(date));

	            content += slotTemplate({ date: tmplDate, resources: resources(isVerticalGroupped && !that._isGroupedByDate()  ? rowIdx : groupIdx) });
	            content += "</td>";
	            return content;
	        },

	        _isWorkDay: function(date) {
	            var day = date.getDay();
	            var workDays =  this._workDays;

	            for (var i = 0; i < workDays.length; i++) {
	                if (workDays[i] === day) {
	                    return true;
	                }
	            }
	            return false;
	        },

	        _render: function(dates) {
	            var that = this;

	            dates = dates || [];

	            this._dates = dates;

	            this._startDate = dates[0];

	            this._endDate = dates[(dates.length - 1) || 0];

	            this.createLayout(this._layout(dates));

	            this._content(dates);

	            this._footer();

	            this.refreshLayout();

	            if(this._isVirtualized()) {
	                this._tryRenderContent();
	            }

	            var allDayHeader = this.element.find(".k-scheduler-header-all-day td");

	            if (allDayHeader.length) {
	                this._allDayHeaderHeight = allDayHeader.first()[0].clientHeight;
	            }

	            that.element.on("click" + NS, ".k-nav-day", function(e) {
	                var th = $(e.currentTarget).closest("th");
	                var offset = th.offset();
	                var additioanlWidth = 0;
	                var additionalHeight = outerHeight(th);

	                if (that._isGroupedByDate()) {
	                    if (that._isVerticallyGrouped()) {
	                        additioanlWidth = outerWidth(that.times);
	                        additionalHeight = 0;
	                    } else {
	                        additionalHeight = outerHeight(that.datesHeader);
	                    }
	                }

	                var slot = that._slotByPosition(offset.left + additioanlWidth, offset.top + additionalHeight);

	                that.trigger("navigate", { view: "day", date: slot.startDate() });
	            });
	        },

	        startTime: function() {
	            var options = this.options;
	            return options.showWorkHours ? options.workDayStart : options.startTime;
	        },

	        endTime: function() {
	            var options = this.options;
	            return options.showWorkHours ? options.workDayEnd : options.endTime;
	        },

	        startDate: function() {
	            return this._startDate;
	        },

	        endDate: function() {
	            return this._endDate;
	        },

	        _end: function(isAllDay) {
	            var time = getMilliseconds(this.endTime()) || MS_PER_DAY;

	            if (isAllDay) {
	                time = 0;
	            }

	            return new Date(this._endDate.getTime() + time);
	        },

	        nextDate: function() {
	            return kendo.date.nextDay(this.endDate());
	        },

	        previousDate: function() {
	            return kendo.date.previousDay(this.startDate());
	        },

	        calculateDateRange: function() {
	            this._render([this.options.date]);
	        },

	        destroy: function() {
	            var that = this;

	            if (that._currentTimeUpdateTimer) {
	                clearInterval(that._currentTimeUpdateTimer);
	            }

	            if (that.datesHeader) {
	                that.datesHeader.off(NS);
	            }

	            if (that.element) {
	                that.element.off(NS);
	            }

	            if (that.footer) {
	                that.footer.remove();
	            }

	            SchedulerView.fn.destroy.call(this);

	            if (this._isMobile() && that.options.editable) {
	                if (that.options.editable.create !== false) {
	                    that._addUserEvents.destroy();
	                    that._allDayUserEvents.destroy();
	                }

	                if (that.options.editable.update !== false) {
	                    that._editUserEvents.destroy();
	                }
	            }
	        },

	        inRange: function(options) {
	            var inRange = SchedulerView.fn.inRange.call(this, options);

	            if (options.isAllDay) {
	                return inRange;
	            }

	            var startTime = getMilliseconds(this.startTime());
	            var endTime = getMilliseconds(this.endTime()) || kendo.date.MS_PER_DAY;

	            var start = getMilliseconds(options.start);
	            var end = getMilliseconds(options.end) || kendo.date.MS_PER_DAY;

	            return inRange && startTime <= start && end <= endTime;
	        },

	        selectionByElement: function(cell) {
	            var offset = cell.offset();
	            // The magical number 5 is to buffer properly the height of the cell for all browsers
	            var height = Math.round(cell.innerHeight()) - 5;

	            return this._slotByPosition(offset.left, offset.top + height);
	        },

	        _timeSlotInterval: function() {
	            var options = this.options;
	            return (options.majorTick/options.minorTickCount) * MS_PER_MINUTE;
	        },

	        _timeSlotIndex: function(date) {
	            var options = this.options;
	            var eventStartTime = getMilliseconds(date);
	            var startTime = getMilliseconds(this.startTime());
	            var timeSlotInterval = ((options.majorTick/options.minorTickCount) * MS_PER_MINUTE);

	            return (eventStartTime - startTime) / (timeSlotInterval);
	        },

	        _slotIndex: function(date, multiday) {
	            if (multiday) {
	                return this._dateSlotIndex(date);
	            }

	            return this._timeSlotIndex(date);
	        },

	        _dateSlotIndex: function(date, overlaps) {
	            var idx;
	            var length;
	            var slots = this._dates || [];
	            var slotStart;
	            var slotEnd;
	            var offset = 1;

	            for (idx = 0, length = slots.length; idx < length; idx++) {
	                slotStart = kendo.date.getDate(slots[idx]);
	                slotEnd = new Date(kendo.date.getDate(slots[idx]).getTime() + MS_PER_DAY - (overlaps ? 0 : 1));

	                if (isInDateRange(date, slotStart, slotEnd)) {
	                    return idx * offset;
	                }
	            }
	            return -1;
	        },

	        _positionAllDayEvent: function(element, slotRange) {
	            var slotWidth = slotRange.innerWidth();
	            var startIndex = slotRange.start.index;
	            var endIndex = slotRange.end.index;

	            var allDayEvents = SchedulerView.collidingEvents(slotRange.events(), startIndex, endIndex);

	            var currentColumnCount = this._headerColumnCount || 0;

	            var leftOffset = 2;

	            var rightOffset = startIndex !== endIndex ? 3 : 2;

	            var eventHeight = this._allDayHeaderHeight;

	            var start = slotRange.startSlot();

	            element
	                .css({
	                    left: start.offsetLeft + leftOffset,
	                    width: slotWidth - rightOffset
	                });

	            slotRange.addEvent({ slotIndex: startIndex, start: startIndex, end: endIndex, element: element });

	            allDayEvents.push({ slotIndex: startIndex, start: startIndex, end: endIndex, element: element });

	            var rows = SchedulerView.createRows(allDayEvents);

	            if (rows.length && rows.length > currentColumnCount) {
	                this._headerColumnCount = rows.length;
	            }

	            var top = slotRange.start.offsetTop;

	            for (var idx = 0, length = rows.length; idx < length; idx++) {
	                var rowEvents = rows[idx].events;

	                for (var j = 0, eventLength = rowEvents.length; j < eventLength; j++) {
	                    $(rowEvents[j].element).css({
	                        top: top + idx * eventHeight
	                    });
	                }
	            }
	        },

	        _arrangeColumns: function(element, top, height, slotRange) {
	            var startSlot = slotRange.start;

	            element = { element: element, slotIndex: startSlot.index, start: top, end: top + height };

	            var columns,
	                slotWidth = startSlot.clientWidth,
	                eventRightOffset = slotWidth * 0.10,
	                columnEvents,
	                eventElements =  slotRange.events(),
	                slotEvents = SchedulerView.collidingEvents(eventElements, element.start, element.end);

	            slotRange.addEvent(element);

	            slotEvents.push(element);

	            columns = SchedulerView.createColumns(slotEvents);

	            var columnWidth = (slotWidth - eventRightOffset) / columns.length;

	            for (var idx = 0, length = columns.length; idx < length; idx++) {
	                columnEvents = columns[idx].events;

	                for (var j = 0, eventLength = columnEvents.length; j < eventLength; j++) {
	                    var calculatedWidth = columnWidth - 2;
	                    columnEvents[j].element[0].style.width = (calculatedWidth > 0 ? calculatedWidth : columnWidth) + "px";
	                    columnEvents[j].element[0].style.left = (this._isRtl ? eventRightOffset : 0) + startSlot.offsetLeft + idx * columnWidth + 2 + "px";
	                }
	            }
	        },

	        _positionEvent: function(event, element, slotRange) {
	            var start = event._startTime || event.start;
	            var end = event._endTime || event.end;
	            var borderWidths = kendo.getComputedStyles(slotRange.start.element, ["border-top-width", "border-bottom-width"]);

	            var rect = slotRange.innerRect(start, end, false);

	            var height = rect.bottom - rect.top -
	                            parseFloat(borderWidths["border-top-width"]) -
	                            parseFloat(borderWidths["border-bottom-width"]);

	            if (height < 0) {
	                height = 0;
	            }

	            element.css( {
	                top: rect.top,
	                height: height
	            } );

	            this._arrangeColumns(element, rect.top, element[0].clientHeight, slotRange);
	       },

	       _createEventElement: function(event, isOneDayEvent, head, tail) {
	            var template = isOneDayEvent ? this.eventTemplate : this.allDayEventTemplate;
	            var options = this.options;
	            var editable = options.editable;
	            var isMobile = this._isMobile();
	            var showDelete = editable && editable.destroy !== false && !isMobile;
	            var resizable = editable && editable.resize !== false;
	            var startDate = getDate(this.startDate());
	            var endDate = getDate(this.endDate());
	            var startTime = getMilliseconds(this.startTime());
	            var endTime = getMilliseconds(this.endTime());
	            var eventStartTime = event._time("start");
	            var eventEndTime = event._time("end");
	            var middle;

	            if (startTime >= endTime) {
	                endTime = getMilliseconds(new Date(this.endTime().getTime() + MS_PER_DAY - 1));
	            }

	            if (!isOneDayEvent && !event.isAllDay) {
	                endDate = new Date(endDate.getTime() + MS_PER_DAY);
	            }

	            var eventStartDate = event.start;
	            var eventEndDate = event.end;

	            if (event.isAllDay) {
	                eventEndDate = getDate(event.end);
	            }

	            if ((!isInDateRange(getDate(eventStartDate), startDate, endDate) &&
	                !isInDateRange(eventEndDate, startDate, endDate)) ||
	                (isOneDayEvent && eventStartTime < startTime && eventEndTime > endTime)) {

	                middle = true;
	            } else if (getDate(eventStartDate) < startDate || (isOneDayEvent && eventStartTime < startTime)) {
	                tail = true;
	            } else if ((eventEndDate > endDate && !isOneDayEvent) || (isOneDayEvent && eventEndTime > endTime)) {
	                head = true;
	            }

	            var resources = this.eventResources(event);

	           if (event._startTime && eventStartTime !== kendo.date.getMilliseconds(event.start)) {
	                eventStartDate = new Date(eventStartTime);
	                eventStartDate = kendo.timezone.apply(eventStartDate, "Etc/UTC");
	            }

	           if (event._endTime && eventEndTime !== kendo.date.getMilliseconds(event.end)) {
	                eventEndDate = new Date(eventEndTime);
	                eventEndDate = kendo.timezone.apply(eventEndDate, "Etc/UTC");
	            }

	            var data = extend({}, {
	                ns: kendo.ns,
	                resizable: resizable,
	                showDelete: showDelete,
	                middle: middle,
	                head: head,
	                tail: tail,
	                singleDay: this._dates.length == 1,
	                resources: resources,
	                inverseColor: false,
	                messages: options.messages
	            }, event, {
	                start: eventStartDate,
	                end: eventEndDate
	            });

	            var element = $(template(data));

	            this.angular("compile", function(){
	                return {
	                    elements: element,
	                    data: [ { dataItem: data } ]
	                };
	            });

	            return element;
	        },

	        _isInTimeSlot: function(event) {
	            var slotStartTime = this.startTime(),
	                slotEndTime = this.endTime(),
	                startTime = event._startTime || event.start,
	                endTime = event._endTime || event.end;

	            if (getMilliseconds(slotEndTime) === getMilliseconds(kendo.date.getDate(slotEndTime))) {
	                slotEndTime = kendo.date.getDate(slotEndTime);
	                setTime(slotEndTime, MS_PER_DAY - 1);
	            }

	            if (event._date("end") > event._date("start")) {
	               endTime = +event._date("end") + (MS_PER_DAY - 1);
	            }

	            endTime = event._endTime ? endTime - event._date("end"): getMilliseconds(new Date(endTime));
	            startTime = event._startTime? startTime - event._date("start"): getMilliseconds(new Date(startTime));

	            slotEndTime = getMilliseconds(slotEndTime);
	            slotStartTime = getMilliseconds(slotStartTime);

	            if(slotStartTime === startTime && startTime === endTime) {
	                return true;
	            }

	            var overlaps = startTime !== slotEndTime;

	            return isInTimeRange(startTime, slotStartTime, slotEndTime, overlaps) ||
	                isInTimeRange(endTime, slotStartTime, slotEndTime, overlaps) ||
	                isInTimeRange(slotStartTime, startTime, endTime) ||
	                isInTimeRange(slotEndTime, startTime, endTime);
	        },

	        _isInDateSlot: function(event) {
	            var groups = this.groups[0];
	            var slotStart = groups.firstSlot().start;
	            var slotEnd = groups.lastSlot().end - 1;

	            var startTime = kendo.date.toUtcTime(event.start);
	            var endTime = kendo.date.toUtcTime(event.end);

	            return (isInDateRange(startTime, slotStart, slotEnd) ||
	                isInDateRange(endTime, slotStart, slotEnd) ||
	                isInDateRange(slotStart, startTime, endTime) ||
	                isInDateRange(slotEnd, startTime, endTime)) &&
	                (!isInDateRange(endTime, slotStart, slotStart) || isInDateRange(endTime, startTime, startTime) || event.isAllDay );
	        },

	        _updateAllDayHeaderHeight: function(height) {
	            if (this._height !== height) {
	                this._height = height;

	                var allDaySlots = this.element.find(".k-scheduler-header-all-day td");

	                if (allDaySlots.length) {
	                    allDaySlots.parent()
	                        .add(this.element.find(".k-scheduler-times-all-day").parent())
	                        .height(height);

	                    for (var groupIndex = 0; groupIndex < this.groups.length; groupIndex++) {
	                        this.groups[groupIndex].refresh();
	                    }
	                }
	            }
	        },

	        _renderEvents: function(events, groupIndex) {
	            var allDayEventContainer = this.datesHeader.find(".k-scheduler-header-wrap > div");
	            var byDate = this._isGroupedByDate();
	            var event;

	            var idx;
	            var length;

	            for (idx = 0, length = events.length; idx < length; idx++) {
	                event = events[idx];

	                if (this._isInDateSlot(event)) {
	                    var isMultiDayEvent = event.isAllDay || event.duration() >= MS_PER_DAY;
	                    var container = isMultiDayEvent && !this._isVerticallyGrouped() ? allDayEventContainer : this.content;
	                    var element, ranges, range, start, end, group;

	                    if (!isMultiDayEvent) {
	                        if (this._isInTimeSlot(event)) {
	                            group = this.groups[groupIndex];

	                            if(!group) {
	                                continue;
	                            }

	                            if (!group._continuousEvents) {
	                                group._continuousEvents = [];
	                            }

	                            ranges = group.slotRanges(event);

	                            var rangeCount = ranges.length;

	                            for (var rangeIndex = 0; rangeIndex < rangeCount; rangeIndex++) {
	                                range = ranges[rangeIndex];
	                                start = event.start;
	                                end = event.end;

	                                if (rangeCount > 1) {
	                                    if (rangeIndex === 0) {
	                                        end = range.end.endDate();
	                                    } else if (rangeIndex == rangeCount - 1) {
	                                        start = range.start.startDate();
	                                    } else {
	                                        start = range.start.startDate();
	                                        end = range.end.endDate();
	                                    }
	                                }

	                                var occurrence = event.clone({ start: start, end: end, _startTime: event._startTime, _endTime: event.endTime });

	                                if (this._isInTimeSlot(occurrence)) {
	                                    var head = range.head;

	                                    element = this._createEventElement(event, !isMultiDayEvent, head, range.tail);

	                                    element.appendTo(container);

	                                    this._inverseEventColor(element);

	                                    this._positionEvent(occurrence, element, range);

	                                    addContinuousEvent(group, range, element, false);
	                                }
	                            }
	                        }

	                    } else if (this.options.allDaySlot) {
	                        group = this.groups[groupIndex];

	                        if(!group) {
	                            continue;
	                        }

	                        if (!group._continuousEvents) {
	                            group._continuousEvents = [];
	                        }

	                        ranges = group.slotRanges(event);

	                        if (ranges.length) {
	                            range = ranges[0];
	                            var startIndex = range.start.index;
	                            var endIndex = range.end.index;

	                            if (byDate && startIndex !== endIndex) {
	                                start = range.start.start;
	                                end = range.end.end;
	                                var newStart = start;
	                                var newEnd = start;

	                                for (var i = range.start.index; i <= range.end.index; i++) {
	                                    element = this._createEventElement(event, !isMultiDayEvent, i !== endIndex, i !== startIndex);

	                                    var dateRange = group.daySlotRanges(newStart, newEnd, true)[0];
	                                    newStart = newEnd += kendo.date.MS_PER_DAY;

	                                    this._positionAllDayEvent(element, dateRange);

	                                    addContinuousEvent(group, dateRange, element, true);

	                                    element.appendTo(container);

	                                    this._inverseEventColor(element);
	                                }
	                            } else {
	                                element = this._createEventElement(event, !isMultiDayEvent);

	                                this._positionAllDayEvent(element, ranges[0]);

	                                addContinuousEvent(group, ranges[0], element, true);

	                                element.appendTo(container);

	                                this._inverseEventColor(element);
	                            }
	                        }
	                    }
	                }
	            }
	        },

	        render: function(events) {
	            this._headerColumnCount = 0;

	            this._cachedEvents = events;

	            this._groups();

	            this.element.find(".k-event").remove();

	            events = new kendo.data.Query(events)
	                .sort([{ field: "start", dir: "asc" },{ field: "end", dir: "desc" }])
	                .toArray();

	            var eventsByResource = [];

	            this._eventsByResource(events, this.groupedResources, eventsByResource);

	            var eventsPerDate = $.map(this._dates, function(date) {
	                return Math.max.apply(null,
	                    $.map(eventsByResource, function(events) {
	                        return $.grep(events, function(event) {
	                            return event.isMultiDay() && isInDateRange(date, getDate(event.start), getDate(event.end));
	                        }).length;
	                    })
	                );
	            });

	            var height = Math.max.apply(null, eventsPerDate);

	            this._updateAllDayHeaderHeight((height + 1) * this._allDayHeaderHeight);

	            for (var groupIndex = 0; groupIndex < eventsByResource.length; groupIndex++) {
	                this._renderEvents(eventsByResource[groupIndex], groupIndex);
	            }

	            this.refreshLayout();

	            this._currentTime(false);

	            this.trigger("activate");
	        },

	        _eventsByResource: function(events, resources, result) {
	            var resource = resources[0];

	            if (resource) {
	                var view = resource.dataSource.view();

	                for (var itemIdx = 0; itemIdx < view.length; itemIdx++) {
	                    var value = this._resourceValue(resource, view[itemIdx]);

	                    var eventsFilteredByResource = new kendo.data.Query(events).filter({ field: resource.field, operator: SchedulerView.groupEqFilter(value) }).toArray();

	                    if (resources.length > 1) {
	                        this._eventsByResource(eventsFilteredByResource, resources.slice(1), result);
	                    } else {
	                        result.push(eventsFilteredByResource);
	                    }
	                }
	            } else {
	                result.push(events);
	            }
	        },

	        _columnOffsetForResource: function(index) {
	            return this._columnCountForLevel(index) / this._columnCountForLevel(index - 1);
	        },

	        _columnCountForLevel: function(level) {
	            var columnLevel = this.columnLevels[level];
	            return columnLevel ? columnLevel.length : 0;
	        },

	        _rowCountForLevel: function(level, rowLevels) {
	            rowLevels = rowLevels || this.rowLevels;
	            var rowLevel = rowLevels[level];
	            return rowLevel ? rowLevel.length : 0;
	        },

	        clearSelection: function() {

	            this.content.add(this.datesHeader)
	                .find(".k-state-selected")
	                .removeAttr("id")
	                .attr("aria-selected", false)
	                .removeClass("k-state-selected");
	        },

	        _updateDirection: function(selection, ranges, multiple, reverse, vertical) {
	            var isDaySlot = selection.isAllDay;
	            var startSlot = ranges[0].start;
	            var endSlot = ranges[ranges.length - 1].end;

	            if (multiple) {
	                if (vertical) {
	                    if (!isDaySlot &&
	                        startSlot.index === endSlot.index &&
	                        startSlot.collectionIndex === endSlot.collectionIndex) {
	                            selection.backward = reverse;
	                    }
	                } else {
	                    if ((isDaySlot && startSlot.index === endSlot.index) ||
	                        (!isDaySlot && startSlot.collectionIndex === endSlot.collectionIndex)) {
	                            selection.backward = reverse;
	                    }
	                }
	            }
	        },

	        _changeViewPeriod: function(selection, reverse, vertical) {
	            if (!vertical) {
	                var date = reverse ? this.previousDate() : this.nextDate();
	                var start = selection.start;
	                var end = selection.end;
	                var verticalByDate = this._isGroupedByDate()  && this._isVerticallyGrouped();
	                var group = this.groups[selection.groupIndex];
	                var collection = reverse ? group._timeSlotCollections : group._getCollections(group.daySlotCollectionCount());
	                var slots = collection[collection.length - 1]._slots;
	                var slotIndex = (!reverse && !group.daySlotCollectionCount()) ? 0 : slots.length - 1;
	                var endMilliseconds;
	                var newDateStart, newDateEnd;

	                newDateStart =  new Date(date);
	                newDateEnd = new Date(date);

	                if(this._isInRange(newDateStart, newDateEnd)){
	                    return false;
	                }

	                selection.start = newDateStart;
	                selection.end = newDateEnd;

	                if (verticalByDate) {
	                    var newStart =new Date(slots[slotIndex].startDate());
	                    var newEnd = new Date(slots[slotIndex].endDate());
	                    endMilliseconds = getMilliseconds(newEnd) ? getMilliseconds(newEnd) : MS_PER_DAY ;

	                        setTime(selection.start, getMilliseconds(newStart));
	                        setTime(selection.end, endMilliseconds);
	                        if(group.daySlotCollectionCount()){
	                            selection.isAllDay = !selection.isAllDay;
	                        }
	                } else {
	                    endMilliseconds = (selection.isAllDay || !getMilliseconds(end)) ? MS_PER_DAY : getMilliseconds(end);

	                    setTime(selection.start, getMilliseconds(start));
	                    setTime(selection.end, endMilliseconds);
	                }

	                if (!this._isVerticallyGrouped()) {
	                    selection.groupIndex = reverse ? this.groups.length - 1 : 0;
	                }

	                selection.events = [];

	                return true;
	            }
	        }
	    });

	    extend(true, ui, {
	        MultiDayView: MultiDayView,
	        DayView: MultiDayView.extend({
	            options: {
	                name: "DayView",
	                title: "Day",
	                selectedMobileDateFormat: "{0:MMM d}"
	            },
	            name: "day"
	        }),
	        WeekView: MultiDayView.extend({
	            options: {
	                name: "WeekView",
	                title: "Week",
	                selectedDateFormat: "{0:D} - {1:D}",
	                selectedShortDateFormat: "{0:d} - {1:d}"
	            },
	            name: "week",
	            calculateDateRange: function() {
	                var selectedDate = this.options.date,
	                    start = kendo.date.dayOfWeek(selectedDate, this.calendarInfo().firstDay, -1),
	                    idx, length,
	                    dates = [];

	                for (idx = 0, length = 7; idx < length; idx++) {
	                    dates.push(start);
	                    start = kendo.date.nextDay(start);
	                }
	                this._render(dates);
	            }
	        }),
	        WorkWeekView: MultiDayView.extend({
	            options: {
	                name: "WorkWeekView",
	                title: "Work Week",
	                selectedDateFormat: "{0:D} - {1:D}",
	                selectedShortDateFormat: "{0:d} - {1:d}"
	            },
	            name: "workWeek",
	            nextDate: function() {
	                var weekStart = kendo.date.dayOfWeek(kendo.date.nextDay(this.startDate()), this.calendarInfo().firstDay, 1);
	                return kendo.date.addDays(weekStart, this._workDays[0]);
	            },
	            previousDate: function() {
	                var weekStart = kendo.date.dayOfWeek(this.startDate(), this.calendarInfo().firstDay, -1);
	                var workDays = this._workDays;

	                return kendo.date.addDays(weekStart, workDays[workDays.length - 1] - 7);
	            },
	            calculateDateRange: function() {
	                var options = this.options,
	                    selectedDate = options.date,
	                    dayOfWeek = kendo.date.dayOfWeek,
	                    weekStart = dayOfWeek(selectedDate, this.calendarInfo().firstDay, -1),
	                    start = dayOfWeek(weekStart, options.workWeekStart, 1),
	                    end = dayOfWeek(start, options.workWeekEnd, 1),
	                    dates = [],
	                    workDays =(options.workDays && options.workDays.length) ? options.workDays.map(function(day){
	                        return dayOfWeek(weekStart, day, 1).getTime();
	                    }) : null;

	                if(workDays) {
	                    start = weekStart;
	                    end = dayOfWeek(start, this.calendarInfo().firstDay + 6, 1);
	                }

	                while (start <= end) {
	                    if(workDays && workDays.indexOf(start.getTime()) > -1) {
	                        dates.push(start);
	                    } else if(!workDays) {
	                        dates.push(start);
	                    }

	                    start = kendo.date.nextDay(start);
	                }

	                this._render(dates);
	            }
	        })
	    });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "ic51":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1562);
	module.exports = __webpack_require__(1562);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1562:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function () {

	    kendo.pdf = kendo.pdf || {};

	    kendo.pdf.supportsDeflate = function() {
	        return window.pako && typeof window.pako.deflate == "function";
	    };

	    kendo.pdf.deflate = function(data) {
	        return window.pako.deflate(data);
	    };

	})();

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "inOk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var columnController_1 = __webpack_require__("77lH");
var columnApi_1 = __webpack_require__("E/Wy");
var rowRenderer_1 = __webpack_require__("3RUv");
var borderLayout_1 = __webpack_require__("twlb");
var logger_1 = __webpack_require__("U9Xd");
var context_1 = __webpack_require__("RQ1/");
var eventService_1 = __webpack_require__("k5uU");
var events_1 = __webpack_require__("3ok8");
var dragService_1 = __webpack_require__("ytBa");
var constants_1 = __webpack_require__("ZZFX");
var selectionController_1 = __webpack_require__("D4cr");
var csvCreator_1 = __webpack_require__("SdeK");
var mouseEventService_1 = __webpack_require__("BY3/");
var focusedCellController_1 = __webpack_require__("4Sr9");
var scrollVisibleService_1 = __webpack_require__("5AnZ");
var beanStub_1 = __webpack_require__("xffp");
var rowContainerComponent_1 = __webpack_require__("a9WV");
var paginationProxy_1 = __webpack_require__("wYvi");
var popupEditorWrapper_1 = __webpack_require__("KnXB");
var alignedGridsService_1 = __webpack_require__("sHqg");
var pinnedRowModel_1 = __webpack_require__("xRx6");
var gridApi_1 = __webpack_require__("BAow");
var animationFrameService_1 = __webpack_require__("tvEw");
var rowComp_1 = __webpack_require__("ci/Y");
var navigationService_1 = __webpack_require__("oNv9");
var valueService_1 = __webpack_require__("5JVC");
var touchListener_1 = __webpack_require__("G4uV");
var componentRecipes_1 = __webpack_require__("EOXx");
var dragAndDropService_1 = __webpack_require__("I/uN");
var rowDragFeature_1 = __webpack_require__("bmqz");
// in the html below, it is important that there are no white space between some of the divs, as if there is white space,
// it won't render correctly in safari, as safari renders white space as a gap
var HEADER_SNIPPET = '<div class="ag-header" role="row">' +
    '<div class="ag-pinned-left-header" role="presentation"></div>' +
    '<div class="ag-pinned-right-header" role="presentation"></div>' +
    '<div class="ag-header-viewport" role="presentation">' +
    '<div class="ag-header-container" role="presentation"></div>' +
    '</div>' +
    '<div class="ag-header-overlay" role="presentation"></div>' +
    '</div>';
var FLOATING_TOP_SNIPPET = '<div class="ag-floating-top" role="presentation">' +
    '<div class="ag-pinned-left-floating-top" role="presentation"></div>' +
    '<div class="ag-pinned-right-floating-top" role="presentation"></div>' +
    '<div class="ag-floating-top-viewport" role="presentation">' +
    '<div class="ag-floating-top-container" role="presentation"></div>' +
    '</div>' +
    '<div class="ag-floating-top-full-width-container" role="presentation"></div>' +
    '</div>';
var FLOATING_BOTTOM_SNIPPET = '<div class="ag-floating-bottom" role="presentation">' +
    '<div class="ag-pinned-left-floating-bottom" role="presentation"></div>' +
    '<div class="ag-pinned-right-floating-bottom" role="presentation"></div>' +
    '<div class="ag-floating-bottom-viewport" role="presentation">' +
    '<div class="ag-floating-bottom-container" role="presentation"></div>' +
    '</div>' +
    '<div class="ag-floating-bottom-full-width-container" role="presentation"></div>' +
    '</div>';
var BODY_SNIPPET = '<div class="ag-body" role="presentation">' +
    '<div class="ag-pinned-left-cols-viewport" role="presentation">' +
    '<div class="ag-pinned-left-cols-container" role="presentation"></div>' +
    '</div>' +
    '<div class="ag-pinned-right-cols-viewport" role="presentation">' +
    '<div class="ag-pinned-right-cols-container" role="presentation"></div>' +
    '</div>' +
    '<div class="ag-body-viewport-wrapper" role="presentation">' +
    '<div class="ag-body-viewport" role="presentation">' +
    '<div class="ag-body-container" role="presentation"></div>' +
    '</div>' +
    '</div>' +
    '<div class="ag-full-width-viewport" role="presentation">' +
    '<div class="ag-full-width-container" role="presentation"></div>' +
    '</div>' +
    '</div>';
// the difference between the 'normal' and 'full height' template is the order of the floating and body,
// for normal, the floating top and bottom go in first as they are fixed position,
// for auto-height, the body is in the middle of the top and bottom as they are just normally laid out
var GRID_PANEL_NORMAL_TEMPLATE = '<div class="ag-root ag-font-style" role="grid">' +
    HEADER_SNIPPET + FLOATING_TOP_SNIPPET + FLOATING_BOTTOM_SNIPPET + BODY_SNIPPET +
    '</div>';
var GRID_PANEL_AUTO_HEIGHT_TEMPLATE = '<div class="ag-root ag-font-style" role="grid">' +
    HEADER_SNIPPET + FLOATING_TOP_SNIPPET + BODY_SNIPPET + FLOATING_BOTTOM_SNIPPET +
    '</div>';
// the template for for-print is much easier than that others, as it doesn't have any pinned areas
// or scrollable areas (so no viewports).
var GRID_PANEL_FOR_PRINT_TEMPLATE = '<div class="ag-root ag-font-style">' +
    // header
    '<div class="ag-header-container"></div>' +
    // floating
    '<div class="ag-floating-top-container"></div>' +
    // body
    '<div class="ag-body-container"></div>' +
    // floating bottom
    '<div class="ag-floating-bottom-container"></div>' +
    '</div>';
var GridPanel = (function (_super) {
    __extends(GridPanel, _super);
    function GridPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.scrollLeft = -1;
        _this.nextScrollLeft = -1;
        _this.scrollTop = -1;
        _this.nextScrollTop = -1;
        _this.verticalRedrawNeeded = false;
        return _this;
    }
    GridPanel.prototype.agWire = function (loggerFactory) {
        this.logger = loggerFactory.create('GridPanel');
        // makes code below more readable if we pull 'forPrint' out
        this.forPrint = this.gridOptionsWrapper.isForPrint();
        this.autoHeight = this.gridOptionsWrapper.isAutoHeight();
        this.scrollWidth = this.gridOptionsWrapper.getScrollbarWidth();
        this.enableRtl = this.gridOptionsWrapper.isEnableRtl();
        this.loadTemplate();
        this.findElements();
    };
    GridPanel.prototype.getVerticalPixelRange = function () {
        var container = this.getPrimaryScrollViewport();
        var result = {
            top: container.scrollTop,
            bottom: container.scrollTop + container.offsetHeight
        };
        return result;
    };
    // we override this, as the base class is missing the annotation
    GridPanel.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    GridPanel.prototype.onRowDataChanged = function () {
        this.showOrHideOverlay();
    };
    GridPanel.prototype.showOrHideOverlay = function () {
        if (this.paginationProxy.isEmpty() && !this.gridOptionsWrapper.isSuppressNoRowsOverlay()) {
            this.showNoRowsOverlay();
        }
        else {
            this.hideOverlay();
        }
    };
    GridPanel.prototype.onNewColumnsLoaded = function () {
        // hide overlay if columns and rows exist, this can happen if columns are loaded after data.
        // this problem exists before of the race condition between the services (column controller in this case)
        // and the view (grid panel). if the model beans were all initialised first, and then the view beans second,
        // this race condition would not happen.
        if (this.columnController.isReady() && !this.paginationProxy.isEmpty()) {
            this.hideOverlay();
        }
    };
    GridPanel.prototype.getLayout = function () {
        return this.layout;
    };
    GridPanel.prototype.init = function () {
        this.useAnimationFrame = !this.gridOptionsWrapper.isSuppressAnimationFrame();
        this.addEventListeners();
        this.addDragListeners();
        this.layout = new borderLayout_1.BorderLayout({
            center: this.eRoot,
            dontFill: this.forPrint,
            fillHorizontalOnly: this.autoHeight,
            name: 'eGridPanel',
            componentRecipes: this.componentRecipes
        });
        this.layout.addSizeChangeListener(this.setBodyAndHeaderHeights.bind(this));
        this.layout.addSizeChangeListener(this.setLeftAndRightBounds.bind(this));
        this.addScrollListener();
        if (this.gridOptionsWrapper.isSuppressHorizontalScroll()) {
            this.eBodyViewport.style.overflowX = 'hidden';
        }
        if (this.gridOptionsWrapper.isRowModelDefault() && !this.gridOptionsWrapper.getRowData()) {
            this.showLoadingOverlay();
        }
        this.setPinnedContainersVisible();
        this.setBodyAndHeaderHeights();
        this.disableBrowserDragging();
        this.addShortcutKeyListeners();
        this.addMouseListeners();
        this.addKeyboardEvents();
        this.addBodyViewportListener();
        this.addStopEditingWhenGridLosesFocus();
        this.mockContextMenuForIPad();
        this.addRowDragListener();
        if (this.$scope) {
            this.addAngularApplyCheck();
        }
        this.onDisplayedColumnsWidthChanged();
    };
    GridPanel.prototype.addRowDragListener = function () {
        var rowDragFeature = new rowDragFeature_1.RowDragFeature(this.eBody);
        this.context.wireBean(rowDragFeature);
        this.dragAndDropService.addDropTarget(rowDragFeature);
    };
    GridPanel.prototype.addStopEditingWhenGridLosesFocus = function () {
        var _this = this;
        if (this.gridOptionsWrapper.isStopEditingWhenGridLosesFocus()) {
            this.addDestroyableEventListener(this.eBody, 'focusout', function (event) {
                // this is the element the focus is moving to
                var elementWithFocus = event.relatedTarget;
                // see if the element the focus is going to is part of the grid
                var clickInsideGrid = false;
                var pointer = elementWithFocus;
                while (utils_1.Utils.exists(pointer) && !clickInsideGrid) {
                    var isPopup = !!_this.gridOptionsWrapper.getDomData(pointer, popupEditorWrapper_1.PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER);
                    var isBody = _this.eBody == pointer;
                    clickInsideGrid = isPopup || isBody;
                    pointer = pointer.parentNode;
                }
                if (!clickInsideGrid) {
                    _this.rowRenderer.stopEditing();
                }
            });
        }
    };
    GridPanel.prototype.addAngularApplyCheck = function () {
        var _this = this;
        // this makes sure if we queue up requests, we only execute oe
        var applyTriggered = false;
        var listener = function () {
            // only need to do one apply at a time
            if (applyTriggered) {
                return;
            }
            applyTriggered = true; // mark 'need apply' to true
            setTimeout(function () {
                applyTriggered = false;
                _this.$scope.$apply();
            }, 0);
        };
        // these are the events we need to do an apply after - these are the ones that can end up
        // with columns added or removed
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_VIRTUAL_COLUMNS_CHANGED, listener);
    };
    // if we do not do this, then the user can select a pic in the grid (eg an image in a custom cell renderer)
    // and then that will start the browser native drag n' drop, which messes up with our own drag and drop.
    GridPanel.prototype.disableBrowserDragging = function () {
        this.eRoot.addEventListener('dragstart', function (event) {
            if (event.target instanceof HTMLImageElement) {
                event.preventDefault();
                return false;
            }
        });
    };
    GridPanel.prototype.addEventListeners = function () {
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_PINNED_ROW_DATA_CHANGED, this.setBodyAndHeaderHeights.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_ROW_DATA_CHANGED, this.onRowDataChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_ROW_DATA_UPDATED, this.onRowDataChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this));
        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_HEADER_HEIGHT, this.setBodyAndHeaderHeights.bind(this));
        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT, this.setBodyAndHeaderHeights.bind(this));
        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT, this.setBodyAndHeaderHeights.bind(this));
        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT, this.setBodyAndHeaderHeights.bind(this));
        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT, this.setBodyAndHeaderHeights.bind(this));
    };
    GridPanel.prototype.addDragListeners = function () {
        var _this = this;
        if (this.forPrint // no range select when doing 'for print'
            || !this.gridOptionsWrapper.isEnableRangeSelection() // no range selection if no property
            || utils_1.Utils.missing(this.rangeController)) {
            return;
        }
        var containers = [this.ePinnedLeftColsContainer, this.ePinnedRightColsContainer, this.eBodyContainer,
            this.eFloatingTop, this.eFloatingBottom];
        containers.forEach(function (container) {
            var params = {
                type: 'cell',
                dragStartPixels: 0,
                eElement: container,
                onDragStart: _this.rangeController.onDragStart.bind(_this.rangeController),
                onDragStop: _this.rangeController.onDragStop.bind(_this.rangeController),
                onDragging: _this.rangeController.onDragging.bind(_this.rangeController)
            };
            _this.dragService.addDragSource(params);
            _this.addDestroyFunc(function () { return _this.dragService.removeDragSource(params); });
        });
    };
    GridPanel.prototype.addMouseListeners = function () {
        var _this = this;
        var eventNames = ['click', 'mousedown', 'dblclick', 'contextmenu', 'mouseover', 'mouseout'];
        eventNames.forEach(function (eventName) {
            var listener = _this.processMouseEvent.bind(_this, eventName);
            _this.eAllCellContainers.forEach(function (container) {
                return _this.addDestroyableEventListener(container, eventName, listener);
            });
        });
    };
    GridPanel.prototype.addKeyboardEvents = function () {
        var _this = this;
        var eventNames = ['keydown', 'keypress'];
        eventNames.forEach(function (eventName) {
            var listener = _this.processKeyboardEvent.bind(_this, eventName);
            _this.eAllCellContainers.forEach(function (container) {
                _this.addDestroyableEventListener(container, eventName, listener);
            });
        });
    };
    GridPanel.prototype.addBodyViewportListener = function () {
        var _this = this;
        // we never add this when doing 'forPrint'
        if (this.gridOptionsWrapper.isForPrint()) {
            return;
        }
        // we want to listen for clicks directly on the eBodyViewport, so the user has a way of showing
        // the context menu if no rows are displayed, or user simply clicks outside of a cell
        var listener = function (mouseEvent) {
            var target = utils_1.Utils.getTarget(mouseEvent);
            if (target === _this.eBodyViewport || target === _this.ePinnedLeftColsViewport || target === _this.ePinnedRightColsViewport) {
                // show it
                _this.onContextMenu(mouseEvent, null, null, null, null);
                _this.preventDefaultOnContextMenu(mouseEvent);
            }
        };
        //For some reason listening only to this.eBody doesnt work... Maybe because the event is consumed somewhere else?
        //In any case, not expending much time on this, if anyome comes accross this and knows how to make this work with
        //one listener please go ahead and change it...
        this.addDestroyableEventListener(this.eBodyViewport, 'contextmenu', listener);
        this.addDestroyableEventListener(this.ePinnedRightColsViewport, 'contextmenu', listener);
        this.addDestroyableEventListener(this.ePinnedLeftColsViewport, 'contextmenu', listener);
    };
    GridPanel.prototype.getRowForEvent = function (event) {
        var sourceElement = utils_1.Utils.getTarget(event);
        while (sourceElement) {
            var renderedRow = this.gridOptionsWrapper.getDomData(sourceElement, rowComp_1.RowComp.DOM_DATA_KEY_RENDERED_ROW);
            if (renderedRow) {
                return renderedRow;
            }
            sourceElement = sourceElement.parentElement;
        }
        return null;
    };
    GridPanel.prototype.processKeyboardEvent = function (eventName, keyboardEvent) {
        var renderedCell = this.mouseEventService.getRenderedCellForEvent(keyboardEvent);
        if (!renderedCell) {
            return;
        }
        switch (eventName) {
            case 'keydown':
                // first see if it's a scroll key, page up / down, home / end etc
                var wasScrollKey = this.navigationService.handlePageScrollingKey(keyboardEvent);
                // if not a scroll key, then we pass onto cell
                if (!wasScrollKey) {
                    renderedCell.onKeyDown(keyboardEvent);
                }
                break;
            case 'keypress':
                renderedCell.onKeyPress(keyboardEvent);
                break;
        }
    };
    // gets called by rowRenderer when new data loaded, as it will want to scroll
    // to the top
    GridPanel.prototype.scrollToTop = function () {
        if (!this.forPrint) {
            this.getPrimaryScrollViewport().scrollTop = 0;
        }
    };
    GridPanel.prototype.processMouseEvent = function (eventName, mouseEvent) {
        if (!this.mouseEventService.isEventFromThisGrid(mouseEvent))
            return;
        if (utils_1.Utils.isStopPropagationForAgGrid(mouseEvent)) {
            return;
        }
        var rowComp = this.getRowForEvent(mouseEvent);
        var cellComp = this.mouseEventService.getRenderedCellForEvent(mouseEvent);
        if (eventName === "contextmenu") {
            this.handleContextMenuMouseEvent(mouseEvent, null, rowComp, cellComp);
        }
        else {
            if (cellComp)
                cellComp.onMouseEvent(eventName, mouseEvent);
            if (rowComp)
                rowComp.onMouseEvent(eventName, mouseEvent);
        }
        this.preventDefaultOnContextMenu(mouseEvent);
    };
    GridPanel.prototype.mockContextMenuForIPad = function () {
        var _this = this;
        // we do NOT want this when not in ipad, otherwise we will be doing
        if (!utils_1.Utils.isUserAgentIPad()) {
            return;
        }
        this.eAllCellContainers.forEach(function (container) {
            var touchListener = new touchListener_1.TouchListener(container);
            var longTapListener = function (event) {
                var rowComp = _this.getRowForEvent(event.touchEvent);
                var cellComp = _this.mouseEventService.getRenderedCellForEvent(event.touchEvent);
                _this.handleContextMenuMouseEvent(null, event.touchEvent, rowComp, cellComp);
            };
            _this.addDestroyableEventListener(touchListener, touchListener_1.TouchListener.EVENT_LONG_TAP, longTapListener);
            _this.addDestroyFunc(function () { return touchListener.destroy(); });
        });
    };
    GridPanel.prototype.handleContextMenuMouseEvent = function (mouseEvent, touchEvent, rowComp, cellComp) {
        var rowNode = rowComp ? rowComp.getRowNode() : null;
        var column = cellComp ? cellComp.getColumn() : null;
        var value = null;
        if (column) {
            var event_1 = mouseEvent ? mouseEvent : touchEvent;
            cellComp.dispatchCellContextMenuEvent(event_1);
            value = this.valueService.getValue(column, rowNode);
        }
        this.onContextMenu(mouseEvent, touchEvent, rowNode, column, value);
    };
    GridPanel.prototype.onContextMenu = function (mouseEvent, touchEvent, rowNode, column, value) {
        // to allow us to debug in chrome, we ignore the event if ctrl is pressed.
        // not everyone wants this, so first 'if' below allows to turn this hack off.
        if (!this.gridOptionsWrapper.isAllowContextMenuWithControlKey()) {
            // then do the check
            if (mouseEvent && (mouseEvent.ctrlKey || mouseEvent.metaKey)) {
                return;
            }
        }
        if (this.contextMenuFactory && !this.gridOptionsWrapper.isSuppressContextMenu()) {
            var eventOrTouch = mouseEvent ? mouseEvent : touchEvent.touches[0];
            this.contextMenuFactory.showMenu(rowNode, column, value, eventOrTouch);
            var event_2 = mouseEvent ? mouseEvent : touchEvent;
            event_2.preventDefault();
        }
    };
    GridPanel.prototype.preventDefaultOnContextMenu = function (mouseEvent) {
        // if we don't do this, then middle click will never result in a 'click' event, as 'mousedown'
        // will be consumed by the browser to mean 'scroll' (as you can scroll with the middle mouse
        // button in the browser). so this property allows the user to receive middle button clicks if
        // they want.
        if (this.gridOptionsWrapper.isSuppressMiddleClickScrolls() && mouseEvent.which === 2) {
            mouseEvent.preventDefault();
        }
    };
    GridPanel.prototype.addShortcutKeyListeners = function () {
        var _this = this;
        this.eAllCellContainers.forEach(function (container) {
            container.addEventListener('keydown', function (event) {
                // if the cell the event came from is editing, then we do not
                // want to do the default shortcut keys, otherwise the editor
                // (eg a text field) would not be able to do the normal cut/copy/paste
                var renderedCell = _this.mouseEventService.getRenderedCellForEvent(event);
                if (renderedCell && renderedCell.isEditing()) {
                    return;
                }
                // for copy / paste, we don't want to execute when the event
                // was from a child grid (happens in master detail)
                if (!_this.mouseEventService.isEventFromThisGrid(event)) {
                    return;
                }
                if (event.ctrlKey || event.metaKey) {
                    switch (event.which) {
                        case constants_1.Constants.KEY_A: return _this.onCtrlAndA(event);
                        case constants_1.Constants.KEY_C: return _this.onCtrlAndC(event);
                        case constants_1.Constants.KEY_V: return _this.onCtrlAndV(event);
                        case constants_1.Constants.KEY_D: return _this.onCtrlAndD(event);
                    }
                }
            });
        });
    };
    GridPanel.prototype.onCtrlAndA = function (event) {
        if (this.rangeController && this.paginationProxy.isRowsToRender()) {
            var rowEnd = void 0;
            var floatingStart = void 0;
            var floatingEnd = void 0;
            if (this.pinnedRowModel.isEmpty(constants_1.Constants.PINNED_TOP)) {
                floatingStart = null;
            }
            else {
                floatingStart = constants_1.Constants.PINNED_TOP;
            }
            if (this.pinnedRowModel.isEmpty(constants_1.Constants.PINNED_BOTTOM)) {
                floatingEnd = null;
                rowEnd = this.paginationProxy.getTotalRowCount() - 1;
            }
            else {
                floatingEnd = constants_1.Constants.PINNED_BOTTOM;
                rowEnd = this.pinnedRowModel.getPinnedBottomRowData().length - 1;
            }
            var allDisplayedColumns = this.columnController.getAllDisplayedColumns();
            if (utils_1.Utils.missingOrEmpty(allDisplayedColumns)) {
                return;
            }
            this.rangeController.setRange({
                rowStart: 0,
                floatingStart: floatingStart,
                rowEnd: rowEnd,
                floatingEnd: floatingEnd,
                columnStart: allDisplayedColumns[0],
                columnEnd: allDisplayedColumns[allDisplayedColumns.length - 1]
            });
        }
        event.preventDefault();
        return false;
    };
    GridPanel.prototype.onCtrlAndC = function (event) {
        if (!this.clipboardService) {
            return;
        }
        var focusedCell = this.focusedCellController.getFocusedCell();
        this.clipboardService.copyToClipboard();
        event.preventDefault();
        // the copy operation results in loosing focus on the cell,
        // because of the trickery the copy logic uses with a temporary
        // widget. so we set it back again.
        if (focusedCell) {
            this.focusedCellController.setFocusedCell(focusedCell.rowIndex, focusedCell.column, focusedCell.floating, true);
        }
        return false;
    };
    GridPanel.prototype.onCtrlAndV = function (event) {
        if (!this.rangeController) {
            return;
        }
        this.clipboardService.pasteFromClipboard();
        return false;
    };
    GridPanel.prototype.onCtrlAndD = function (event) {
        if (!this.clipboardService) {
            return;
        }
        this.clipboardService.copyRangeDown();
        event.preventDefault();
        return false;
    };
    // Valid values for position are bottom, middle and top
    // position should be {'top','middle','bottom', or undefined/null}.
    // if undefined/null, then the grid will to the minimal amount of scrolling,
    // eg if grid needs to scroll up, it scrolls until row is on top,
    //    if grid needs to scroll down, it scrolls until row is on bottom,
    //    if row is already in view, grid does not scroll
    GridPanel.prototype.ensureIndexVisible = function (index, position) {
        // if for print or auto height, everything is always visible
        if (this.gridOptionsWrapper.isForPrint() || this.gridOptionsWrapper.isAutoHeight()) {
            return;
        }
        this.logger.log('ensureIndexVisible: ' + index);
        var rowCount = this.paginationProxy.getTotalRowCount();
        if (typeof index !== 'number' || index < 0 || index >= rowCount) {
            console.warn('invalid row index for ensureIndexVisible: ' + index);
            return;
        }
        this.paginationProxy.goToPageWithIndex(index);
        var nodeAtIndex = this.paginationProxy.getRow(index);
        var pixelOffset = this.paginationProxy.getPixelOffset();
        var rowTopPixel = nodeAtIndex.rowTop - pixelOffset;
        var rowBottomPixel = rowTopPixel + nodeAtIndex.rowHeight;
        var vRange = this.getVerticalPixelRange();
        var vRangeTop = vRange.top;
        var vRangeBottom = vRange.bottom;
        var scrollShowing = this.isHorizontalScrollShowing();
        if (scrollShowing) {
            vRangeBottom -= this.scrollWidth;
        }
        var rowToHighlightHeight = rowBottomPixel - rowTopPixel;
        var viewportHeight = vRangeBottom - vRangeTop;
        var halfScreenHeight = (viewportHeight / 2) + (rowToHighlightHeight / 2);
        var eViewportToScroll = this.getPrimaryScrollViewport();
        var newScrollPosition;
        switch (position) {
            case 'top':
                newScrollPosition = rowTopPixel;
                break;
            case 'bottom':
                newScrollPosition = rowBottomPixel - viewportHeight;
                break;
            case 'middle':
                newScrollPosition = halfScreenHeight;
                // The if/else logic here protects us from over scrolling
                // ie: Trying to scroll past the row (ie ensureNodeVisible (0, 'middle'))
                newScrollPosition = newScrollPosition > rowTopPixel ? rowTopPixel : newScrollPosition;
                break;
            default:
                newScrollPosition = rowTopPixel;
                var viewportScrolledPastRow = vRangeTop > rowTopPixel;
                var viewportScrolledBeforeRow = vRangeBottom < rowBottomPixel;
                if (viewportScrolledPastRow) {
                    // if row is before, scroll up with row at top
                    newScrollPosition = rowTopPixel;
                }
                else if (viewportScrolledBeforeRow) {
                    // if row is below, scroll down with row at bottom
                    var viewportHeight_1 = vRangeBottom - vRangeTop;
                    newScrollPosition = rowBottomPixel - viewportHeight_1;
                }
                else {
                    // row already in view, and top/middle/bottom not specified, so do nothing.
                    newScrollPosition = null;
                }
                break;
        }
        // this means the row is already in view, and we don't need to scroll
        if (newScrollPosition === null) {
            return;
        }
        eViewportToScroll.scrollTop = newScrollPosition;
        this.rowRenderer.redrawAfterScroll();
    };
    GridPanel.prototype.getPrimaryScrollViewport = function () {
        if (this.enableRtl && this.columnController.isPinningLeft()) {
            return this.ePinnedLeftColsViewport;
        }
        else if (!this.enableRtl && this.columnController.isPinningRight()) {
            return this.ePinnedRightColsViewport;
        }
        else {
            return this.eBodyViewport;
        }
    };
    // + moveColumnController
    GridPanel.prototype.getCenterWidth = function () {
        return this.eBodyViewport.clientWidth;
    };
    GridPanel.prototype.isHorizontalScrollShowing = function () {
        var result = utils_1.Utils.isHorizontalScrollShowing(this.eBodyViewport);
        return result;
    };
    GridPanel.prototype.isVerticalScrollShowing = function () {
        if (this.columnController.isPinningRight()) {
            return utils_1.Utils.isVerticalScrollShowing(this.ePinnedRightColsViewport);
        }
        else {
            return utils_1.Utils.isVerticalScrollShowing(this.eBodyViewport);
        }
    };
    GridPanel.prototype.isBodyVerticalScrollShowing = function () {
        // if the scroll is on the pinned panel, then it is never in the center panel.
        // if LRT, then pinning right means scroll NOT on center
        if (!this.enableRtl && this.columnController.isPinningRight()) {
            return false;
        }
        // if RTL, then pinning left means scroll NOT on center
        if (this.enableRtl && this.columnController.isPinningLeft()) {
            return false;
        }
        return utils_1.Utils.isVerticalScrollShowing(this.eBodyViewport);
    };
    // gets called every 500 ms. we use this to set padding on right pinned column
    GridPanel.prototype.periodicallyCheck = function () {
        if (this.forPrint) {
            return;
        }
        this.setBottomPaddingOnPinnedRight();
        this.setMarginOnFullWidthCellContainer();
        this.setScrollShowing();
    };
    GridPanel.prototype.setScrollShowing = function () {
        var params = {
            vBody: false,
            hBody: false,
            vPinnedLeft: false,
            vPinnedRight: false
        };
        if (this.enableRtl) {
            if (this.columnController.isPinningLeft()) {
                params.vPinnedLeft = this.forPrint ? false : utils_1.Utils.isVerticalScrollShowing(this.ePinnedLeftColsViewport);
            }
            else {
                params.vBody = utils_1.Utils.isVerticalScrollShowing(this.eBodyViewport);
            }
        }
        else {
            if (this.columnController.isPinningRight()) {
                params.vPinnedRight = this.forPrint ? false : utils_1.Utils.isVerticalScrollShowing(this.ePinnedRightColsViewport);
            }
            else {
                params.vBody = utils_1.Utils.isVerticalScrollShowing(this.eBodyViewport);
            }
        }
        params.hBody = utils_1.Utils.isHorizontalScrollShowing(this.eBodyViewport);
        this.scrollVisibleService.setScrollsVisible(params);
    };
    // the pinned container needs extra space at the bottom, some blank space, otherwise when
    // vertically scrolled all the way down, the last row will be hidden behind the scrolls.
    // this extra padding allows the last row to be lifted above the bottom scrollbar.
    GridPanel.prototype.setBottomPaddingOnPinnedRight = function () {
        if (this.forPrint) {
            return;
        }
        if (this.columnController.isPinningRight()) {
            var bodyHorizontalScrollShowing = this.eBodyViewport.clientWidth < this.eBodyViewport.scrollWidth;
            if (bodyHorizontalScrollShowing) {
                this.ePinnedRightColsContainer.style.marginBottom = this.scrollWidth + 'px';
            }
            else {
                this.ePinnedRightColsContainer.style.marginBottom = '';
            }
        }
    };
    GridPanel.prototype.setMarginOnFullWidthCellContainer = function () {
        if (this.forPrint) {
            return;
        }
        // if either right or bottom scrollbars are showing, we need to make sure the
        // fullWidthCell panel isn't covering the scrollbars. originally i tried to do this using
        // margin, but the overflow was not getting clipped and going into the margin,
        // so used border instead. dunno why it works, trial and error found the solution.
        if (this.enableRtl) {
            if (this.isVerticalScrollShowing()) {
                this.eFullWidthCellViewport.style.borderLeft = this.scrollWidth + 'px solid transparent';
            }
            else {
                this.eFullWidthCellViewport.style.borderLeft = '';
            }
        }
        else {
            if (this.isVerticalScrollShowing()) {
                this.eFullWidthCellViewport.style.borderRight = this.scrollWidth + 'px solid transparent';
            }
            else {
                this.eFullWidthCellViewport.style.borderRight = '';
            }
        }
        if (this.isHorizontalScrollShowing()) {
            this.eFullWidthCellViewport.style.borderBottom = this.scrollWidth + 'px solid transparent';
        }
        else {
            this.eFullWidthCellViewport.style.borderBottom = '';
        }
    };
    GridPanel.prototype.ensureColumnVisible = function (key) {
        // if for print, everything is always visible
        if (this.gridOptionsWrapper.isForPrint()) {
            return;
        }
        var column = this.columnController.getGridColumn(key);
        if (!column) {
            return;
        }
        if (column.isPinned()) {
            console.warn('calling ensureIndexVisible on a ' + column.getPinned() + ' pinned column doesn\'t make sense for column ' + column.getColId());
            return;
        }
        if (!this.columnController.isColumnDisplayed(column)) {
            console.warn('column is not currently visible');
            return;
        }
        var colLeftPixel = column.getLeft();
        var colRightPixel = colLeftPixel + column.getActualWidth();
        var viewportWidth = this.eBodyViewport.clientWidth;
        var scrollPosition = this.getBodyViewportScrollLeft();
        var bodyWidth = this.columnController.getBodyContainerWidth();
        var viewportLeftPixel;
        var viewportRightPixel;
        // the logic of working out left and right viewport px is both here and in the ColumnController,
        // need to refactor it out to one place
        if (this.enableRtl) {
            viewportLeftPixel = bodyWidth - scrollPosition - viewportWidth;
            viewportRightPixel = bodyWidth - scrollPosition;
        }
        else {
            viewportLeftPixel = scrollPosition;
            viewportRightPixel = viewportWidth + scrollPosition;
        }
        var viewportScrolledPastCol = viewportLeftPixel > colLeftPixel;
        var viewportScrolledBeforeCol = viewportRightPixel < colRightPixel;
        var colToSmallForViewport = viewportWidth < column.getActualWidth();
        var alignColToLeft = viewportScrolledPastCol || colToSmallForViewport;
        var alignColToRight = viewportScrolledBeforeCol;
        if (alignColToLeft) {
            // if viewport's left side is after col's left side, scroll left to pull col into viewport at left
            if (this.enableRtl) {
                var newScrollPosition = bodyWidth - viewportWidth - colLeftPixel;
                this.setBodyViewportScrollLeft(newScrollPosition);
            }
            else {
                this.setBodyViewportScrollLeft(colLeftPixel);
            }
        }
        else if (alignColToRight) {
            // if viewport's right side is before col's right side, scroll right to pull col into viewport at right
            if (this.enableRtl) {
                var newScrollPosition = bodyWidth - colRightPixel;
                this.setBodyViewportScrollLeft(newScrollPosition);
            }
            else {
                var newScrollPosition = colRightPixel - viewportWidth;
                this.setBodyViewportScrollLeft(newScrollPosition);
            }
        }
        else {
            // otherwise, col is already in view, so do nothing
        }
        // this will happen anyway, as the move will cause a 'scroll' event on the body, however
        // it is possible that the ensureColumnVisible method is called from within ag-Grid and
        // the caller will need to have the columns rendered to continue, which will be before
        // the event has been worked on (which is the case for cell navigation).
        this.setLeftAndRightBounds();
    };
    GridPanel.prototype.showLoadingOverlay = function () {
        if (!this.gridOptionsWrapper.isSuppressLoadingOverlay()) {
            this.layout.showLoadingOverlay();
        }
    };
    GridPanel.prototype.showNoRowsOverlay = function () {
        if (!this.gridOptionsWrapper.isSuppressNoRowsOverlay()) {
            this.layout.showNoRowsOverlay();
        }
    };
    GridPanel.prototype.hideOverlay = function () {
        this.layout.hideOverlay();
    };
    GridPanel.prototype.getWidthForSizeColsToFit = function () {
        var availableWidth = this.eBody.clientWidth;
        // if pinning right, then the scroll bar can show, however for some reason
        // it overlays the grid and doesn't take space. so we are only interested
        // in the body scroll showing.
        var removeVerticalScrollWidth = this.isVerticalScrollShowing();
        if (removeVerticalScrollWidth) {
            availableWidth -= this.scrollWidth;
        }
        return availableWidth;
    };
    // method will call itself if no available width. this covers if the grid
    // isn't visible, but is just about to be visible.
    GridPanel.prototype.sizeColumnsToFit = function (nextTimeout) {
        var _this = this;
        var availableWidth = this.getWidthForSizeColsToFit();
        if (availableWidth > 0) {
            this.columnController.sizeColumnsToFit(availableWidth, "sizeColumnsToFit");
        }
        else {
            if (nextTimeout === undefined) {
                setTimeout(function () {
                    _this.sizeColumnsToFit(100);
                }, 0);
            }
            else if (nextTimeout === 100) {
                setTimeout(function () {
                    _this.sizeColumnsToFit(500);
                }, 100);
            }
            else if (nextTimeout === 500) {
                setTimeout(function () {
                    _this.sizeColumnsToFit(-1);
                }, 500);
            }
            else {
                console.log('ag-Grid: tried to call sizeColumnsToFit() but the grid is coming back with ' +
                    'zero width, maybe the grid is not visible yet on the screen?');
            }
        }
    };
    GridPanel.prototype.getBodyContainer = function () {
        return this.eBodyContainer;
    };
    GridPanel.prototype.getDropTargetBodyContainers = function () {
        if (this.forPrint) {
            return [this.eBodyContainer, this.eFloatingTopContainer, this.eFloatingBottomContainer];
        }
        else {
            return [this.eBodyViewport, this.eFloatingTopViewport, this.eFloatingBottomViewport];
        }
    };
    GridPanel.prototype.getBodyViewport = function () {
        return this.eBodyViewport;
    };
    GridPanel.prototype.getDropTargetLeftContainers = function () {
        if (this.forPrint) {
            return [];
        }
        else {
            return [this.ePinnedLeftColsViewport, this.ePinnedLeftFloatingBottom, this.ePinnedLeftFloatingTop];
        }
    };
    GridPanel.prototype.getDropTargetPinnedRightContainers = function () {
        if (this.forPrint) {
            return [];
        }
        else {
            return [this.ePinnedRightColsViewport, this.ePinnedRightFloatingBottom, this.ePinnedRightFloatingTop];
        }
    };
    GridPanel.prototype.getHeaderContainer = function () {
        return this.eHeaderContainer;
    };
    GridPanel.prototype.getHeaderOverlay = function () {
        return this.eHeaderOverlay;
    };
    GridPanel.prototype.getRoot = function () {
        return this.eRoot;
    };
    GridPanel.prototype.getPinnedLeftHeader = function () {
        return this.ePinnedLeftHeader;
    };
    GridPanel.prototype.getPinnedRightHeader = function () {
        return this.ePinnedRightHeader;
    };
    GridPanel.prototype.queryHtmlElement = function (selector) {
        return this.eRoot.querySelector(selector);
    };
    GridPanel.prototype.loadTemplate = function () {
        // the template we use is different when doing 'for print'
        var template;
        if (this.forPrint) {
            template = GRID_PANEL_FOR_PRINT_TEMPLATE;
        }
        else if (this.autoHeight) {
            template = GRID_PANEL_AUTO_HEIGHT_TEMPLATE;
        }
        else {
            template = GRID_PANEL_NORMAL_TEMPLATE;
        }
        this.eRoot = utils_1.Utils.loadTemplate(template);
    };
    GridPanel.prototype.findElements = function () {
        var _this = this;
        if (this.forPrint) {
            this.eHeaderContainer = this.queryHtmlElement('.ag-header-container');
            this.eBodyContainer = this.queryHtmlElement('.ag-body-container');
            this.eFloatingTopContainer = this.queryHtmlElement('.ag-floating-top-container');
            this.eFloatingBottomContainer = this.queryHtmlElement('.ag-floating-bottom-container');
            this.eAllCellContainers = [this.eBodyContainer, this.eFloatingTopContainer, this.eFloatingBottomContainer];
            var containers = {
                body: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eBodyContainer }),
                fullWidth: null,
                pinnedLeft: null,
                pinnedRight: null,
                floatingTop: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eFloatingTopContainer }),
                floatingTopPinnedLeft: null,
                floatingTopPinnedRight: null,
                floatingTopFullWidth: null,
                floatingBottom: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eFloatingBottomContainer }),
                floatingBottomPinnedLeft: null,
                floatingBottomPinnedRight: null,
                floatingBottomFullWith: null
            };
            this.rowContainerComponents = containers;
            // when doing forPrint, we don't have any fullWidth containers, instead we add directly to the main
            // containers. this works in forPrint only as there are no pinned columns (no need for fullWidth to
            // span pinned columns) and the rows are already the full width of the grid (the reason for fullWidth)
            containers.fullWidth = containers.body;
            containers.floatingBottomFullWith = containers.floatingBottom;
            containers.floatingTopFullWidth = containers.floatingTop;
        }
        else {
            this.eBody = this.queryHtmlElement('.ag-body');
            this.eBodyContainer = this.queryHtmlElement('.ag-body-container');
            this.eBodyViewport = this.queryHtmlElement('.ag-body-viewport');
            this.eBodyViewportWrapper = this.queryHtmlElement('.ag-body-viewport-wrapper');
            this.eFullWidthCellContainer = this.queryHtmlElement('.ag-full-width-container');
            this.eFullWidthCellViewport = this.queryHtmlElement('.ag-full-width-viewport');
            this.ePinnedLeftColsContainer = this.queryHtmlElement('.ag-pinned-left-cols-container');
            this.ePinnedRightColsContainer = this.queryHtmlElement('.ag-pinned-right-cols-container');
            this.ePinnedLeftColsViewport = this.queryHtmlElement('.ag-pinned-left-cols-viewport');
            this.ePinnedRightColsViewport = this.queryHtmlElement('.ag-pinned-right-cols-viewport');
            this.ePinnedLeftHeader = this.queryHtmlElement('.ag-pinned-left-header');
            this.ePinnedRightHeader = this.queryHtmlElement('.ag-pinned-right-header');
            this.eHeader = this.queryHtmlElement('.ag-header');
            this.eHeaderContainer = this.queryHtmlElement('.ag-header-container');
            this.eHeaderOverlay = this.queryHtmlElement('.ag-header-overlay');
            this.eHeaderViewport = this.queryHtmlElement('.ag-header-viewport');
            this.eFloatingTop = this.queryHtmlElement('.ag-floating-top');
            this.ePinnedLeftFloatingTop = this.queryHtmlElement('.ag-pinned-left-floating-top');
            this.ePinnedRightFloatingTop = this.queryHtmlElement('.ag-pinned-right-floating-top');
            this.eFloatingTopContainer = this.queryHtmlElement('.ag-floating-top-container');
            this.eFloatingTopViewport = this.queryHtmlElement('.ag-floating-top-viewport');
            this.eFloatingTopFullWidthCellContainer = this.queryHtmlElement('.ag-floating-top-full-width-container');
            this.eFloatingBottom = this.queryHtmlElement('.ag-floating-bottom');
            this.ePinnedLeftFloatingBottom = this.queryHtmlElement('.ag-pinned-left-floating-bottom');
            this.ePinnedRightFloatingBottom = this.queryHtmlElement('.ag-pinned-right-floating-bottom');
            this.eFloatingBottomContainer = this.queryHtmlElement('.ag-floating-bottom-container');
            this.eFloatingBottomViewport = this.queryHtmlElement('.ag-floating-bottom-viewport');
            this.eFloatingBottomFullWidthCellContainer = this.queryHtmlElement('.ag-floating-bottom-full-width-container');
            this.eAllCellContainers = [
                this.ePinnedLeftColsContainer, this.ePinnedRightColsContainer, this.eBodyContainer,
                this.eFloatingTop, this.eFloatingBottom, this.eFullWidthCellContainer
            ];
            this.rowContainerComponents = {
                body: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eBodyContainer, eViewport: this.eBodyViewport, body: true }),
                fullWidth: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eFullWidthCellContainer, hideWhenNoChildren: true, eViewport: this.eFullWidthCellViewport }),
                pinnedLeft: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.ePinnedLeftColsContainer, eViewport: this.ePinnedLeftColsViewport }),
                pinnedRight: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.ePinnedRightColsContainer, eViewport: this.ePinnedRightColsViewport }),
                floatingTop: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eFloatingTopContainer }),
                floatingTopPinnedLeft: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.ePinnedLeftFloatingTop }),
                floatingTopPinnedRight: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.ePinnedRightFloatingTop }),
                floatingTopFullWidth: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eFloatingTopFullWidthCellContainer, hideWhenNoChildren: true }),
                floatingBottom: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eFloatingBottomContainer }),
                floatingBottomPinnedLeft: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.ePinnedLeftFloatingBottom }),
                floatingBottomPinnedRight: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.ePinnedRightFloatingBottom }),
                floatingBottomFullWith: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eFloatingBottomFullWidthCellContainer, hideWhenNoChildren: true }),
            };
            this.addMouseWheelEventListeners();
            this.suppressScrollOnFloatingRow();
        }
        utils_1.Utils.iterateObject(this.rowContainerComponents, function (key, container) {
            if (container) {
                _this.context.wireBean(container);
            }
        });
    };
    // when editing a pinned row, if the cell is half outside the scrollable area, the browser can
    // scroll the column into view. we do not want this, the pinned sections should never scroll.
    // so we listen to scrolls on these containers and reset the scroll if we find one.
    GridPanel.prototype.suppressScrollOnFloatingRow = function () {
        var _this = this;
        var resetTopScroll = function () { return _this.eFloatingTopViewport.scrollLeft = 0; };
        var resetBottomScroll = function () { return _this.eFloatingTopViewport.scrollLeft = 0; };
        this.addDestroyableEventListener(this.eFloatingTopViewport, 'scroll', resetTopScroll);
        this.addDestroyableEventListener(this.eFloatingBottomViewport, 'scroll', resetBottomScroll);
    };
    GridPanel.prototype.getRowContainers = function () {
        return this.rowContainerComponents;
    };
    GridPanel.prototype.addMouseWheelEventListeners = function () {
        // IE9, Chrome, Safari, Opera use 'mousewheel', Firefox uses 'DOMMouseScroll'
        this.addDestroyableEventListener(this.eBodyViewport, 'mousewheel', this.centerMouseWheelListener.bind(this));
        this.addDestroyableEventListener(this.eBodyViewport, 'DOMMouseScroll', this.centerMouseWheelListener.bind(this));
        if (this.enableRtl) {
            this.addDestroyableEventListener(this.ePinnedRightColsViewport, 'mousewheel', this.genericMouseWheelListener.bind(this));
            this.addDestroyableEventListener(this.ePinnedRightColsViewport, 'DOMMouseScroll', this.genericMouseWheelListener.bind(this));
        }
        else {
            this.addDestroyableEventListener(this.ePinnedLeftColsViewport, 'mousewheel', this.genericMouseWheelListener.bind(this));
            this.addDestroyableEventListener(this.ePinnedLeftColsViewport, 'DOMMouseScroll', this.genericMouseWheelListener.bind(this));
        }
    };
    GridPanel.prototype.getHeaderViewport = function () {
        return this.eHeaderViewport;
    };
    GridPanel.prototype.centerMouseWheelListener = function (event) {
        // we are only interested in mimicking the mouse wheel if we are not scrolling on the middle,
        // otherwise the body has scrolls and the mouse wheel works for free
        var bodyVScrollShowing = this.isBodyVerticalScrollActive();
        if (!bodyVScrollShowing) {
            var targetPanel = this.enableRtl ? this.ePinnedLeftColsViewport : this.ePinnedRightColsViewport;
            return this.generalMouseWheelListener(event, targetPanel);
        }
    };
    // used for listening to mouse wheel events on 1) left pinned and also the 2) fullWidthCell components.
    // the fullWidthCell listener is added in renderedRow, hence public.
    GridPanel.prototype.genericMouseWheelListener = function (event) {
        var targetPanel;
        var bodyVScrollActive = this.isBodyVerticalScrollActive();
        if (bodyVScrollActive) {
            targetPanel = this.eBodyViewport;
        }
        else {
            targetPanel = this.enableRtl ? this.ePinnedLeftColsViewport : this.ePinnedRightColsViewport;
        }
        return this.generalMouseWheelListener(event, targetPanel);
    };
    GridPanel.prototype.generalMouseWheelListener = function (event, targetPanel) {
        var wheelEvent = utils_1.Utils.normalizeWheel(event);
        // we need to detect in which direction scroll is happening to allow trackpads scroll horizontally
        // horizontal scroll
        if (Math.abs(wheelEvent.pixelX) > Math.abs(wheelEvent.pixelY)) {
            var newLeftPosition = this.eBodyViewport.scrollLeft + wheelEvent.pixelX;
            this.eBodyViewport.scrollLeft = newLeftPosition;
        }
        else {
            var newTopPosition = targetPanel.scrollTop + wheelEvent.pixelY;
            targetPanel.scrollTop = newTopPosition;
        }
        // allow the option to pass mouse wheel events to the browser
        // https://github.com/ag-grid/ag-grid/issues/800
        // in the future, this should be tied in with 'forPrint' option, or have an option 'no vertical scrolls'
        var shouldPreventDefault = !this.gridOptionsWrapper.isAutoHeight() && !this.gridOptionsWrapper.isSuppressPreventDefaultOnMouseWheel();
        if (shouldPreventDefault) {
            // if we don't prevent default, then the whole browser will scroll also as well as the grid
            event.preventDefault();
        }
        return false;
    };
    GridPanel.prototype.onDisplayedColumnsChanged = function () {
        this.setPinnedContainersVisible();
        this.setBodyAndHeaderHeights();
        this.setLeftAndRightBounds();
    };
    GridPanel.prototype.onDisplayedColumnsWidthChanged = function () {
        this.setWidthsOfContainers();
        this.setLeftAndRightBounds();
        if (this.enableRtl) {
            // because RTL is all backwards, a change in the width of the row
            // can cause a change in the scroll position, without a scroll event,
            // because the scroll position in RTL is a function that depends on
            // the width. to be convinced of this, take out this line, enable RTL,
            // scroll all the way to the left and then resize a column
            this.horizontallyScrollHeaderCenterAndFloatingCenter();
        }
    };
    GridPanel.prototype.onScrollVisibilityChanged = function () {
        this.setWidthsOfContainers();
    };
    GridPanel.prototype.setWidthsOfContainers = function () {
        var mainRowWidth = this.columnController.getBodyContainerWidth() + 'px';
        this.eBodyContainer.style.width = mainRowWidth;
        if (this.forPrint) {
            // pinned col doesn't exist when doing forPrint
            return;
        }
        this.eFloatingBottomContainer.style.width = mainRowWidth;
        this.eFloatingTopContainer.style.width = mainRowWidth;
        this.setPinnedLeftWidth();
        this.setPinnedRightWidth();
    };
    GridPanel.prototype.setPinnedLeftWidth = function () {
        var pinnedLeftWidth = this.scrollVisibleService.getPinnedLeftWidth() + 'px';
        var pinnedLeftWidthWithScroll = this.scrollVisibleService.getPinnedLeftWithScrollWidth() + 'px';
        this.ePinnedLeftColsViewport.style.width = pinnedLeftWidthWithScroll;
        this.eBodyViewportWrapper.style.marginLeft = pinnedLeftWidthWithScroll;
        this.ePinnedLeftFloatingBottom.style.width = pinnedLeftWidthWithScroll;
        this.ePinnedLeftFloatingTop.style.width = pinnedLeftWidthWithScroll;
        this.ePinnedLeftColsContainer.style.width = pinnedLeftWidth;
    };
    GridPanel.prototype.setPinnedRightWidth = function () {
        var pinnedRightWidth = this.scrollVisibleService.getPinnedRightWidth() + 'px';
        var pinnedRightWidthWithScroll = this.scrollVisibleService.getPinnedRightWithScrollWidth() + 'px';
        this.ePinnedRightColsViewport.style.width = pinnedRightWidthWithScroll;
        this.eBodyViewportWrapper.style.marginRight = pinnedRightWidthWithScroll;
        this.ePinnedRightFloatingBottom.style.width = pinnedRightWidthWithScroll;
        this.ePinnedRightFloatingTop.style.width = pinnedRightWidthWithScroll;
        this.ePinnedRightColsContainer.style.width = pinnedRightWidth;
    };
    GridPanel.prototype.setPinnedContainersVisible = function () {
        // no need to do this if not using scrolls
        if (this.forPrint) {
            return;
        }
        var changeDetected = false;
        // if we are v scrolling, then one of these will have the scroll position.
        // we us this inside the if(changedDetected), so we don't always use it, however
        // it is changed when we make a pinned panel not visible, so we have to check it
        // before we change display on the pinned panels
        var scrollTop = Math.max(this.eBodyViewport.scrollTop, this.ePinnedLeftColsViewport.scrollTop, this.ePinnedRightColsViewport.scrollTop);
        var showLeftPinned = this.columnController.isPinningLeft();
        if (showLeftPinned !== this.pinningLeft) {
            this.pinningLeft = showLeftPinned;
            this.ePinnedLeftHeader.style.display = showLeftPinned ? 'inline-block' : 'none';
            this.ePinnedLeftColsViewport.style.display = showLeftPinned ? 'inline' : 'none';
            changeDetected = true;
        }
        var showRightPinned = this.columnController.isPinningRight();
        if (showRightPinned !== this.pinningRight) {
            this.pinningRight = showRightPinned;
            this.ePinnedRightHeader.style.display = showRightPinned ? 'inline-block' : 'none';
            this.ePinnedRightColsViewport.style.display = showRightPinned ? 'inline' : 'none';
            changeDetected = true;
        }
        if (changeDetected) {
            var bodyVScrollActive = this.isBodyVerticalScrollActive();
            this.eBodyViewport.style.overflowY = bodyVScrollActive ? 'auto' : 'hidden';
            // the body either uses it's scroll (when scrolling) or it's style.top
            // (when following the scroll of a pinned section), so we need to set it
            // back when changing from one to the other
            if (bodyVScrollActive) {
                this.setFakeScroll(this.eBodyContainer, 0);
                // this.eBodyContainer.style.top = '0px';
            }
            else {
                this.eBodyViewport.scrollTop = 0;
            }
            // when changing the primary scroll viewport, we copy over the scroll position,
            // eg if body was getting scrolled and we were at position 100px, then we start
            // pinning and pinned viewport is now the primary, we need to set it to 100px
            var primaryScrollViewport = this.getPrimaryScrollViewport();
            primaryScrollViewport.scrollTop = scrollTop;
            // this adjusts the scroll position of all the faking panels. they should already
            // be correct except body which has potentially just turned to be fake.
            this.fakeVerticalScroll(scrollTop);
        }
    };
    // init, layoutChanged, floatingDataChanged, headerHeightChanged
    GridPanel.prototype.setBodyAndHeaderHeights = function () {
        if (this.forPrint) {
            // if doing 'for print' or 'auto height', then the header and footers are laid
            // out naturally by the browser. it's whatever height that's needed to fit.
            return;
        }
        var heightOfContainer = this.layout.getCentreHeight();
        if (!heightOfContainer) {
            return;
        }
        var headerRowCount = this.columnController.getHeaderRowCount();
        var totalHeaderHeight;
        var numberOfFloating = 0;
        var groupHeight;
        var headerHeight;
        if (!this.columnController.isPivotMode()) {
            utils_1.Utils.removeCssClass(this.eHeader, 'ag-pivot-on');
            utils_1.Utils.addCssClass(this.eHeader, 'ag-pivot-off');
            if (this.gridOptionsWrapper.isFloatingFilter()) {
                headerRowCount++;
            }
            numberOfFloating = (this.gridOptionsWrapper.isFloatingFilter()) ? 1 : 0;
            groupHeight = this.gridOptionsWrapper.getGroupHeaderHeight();
            headerHeight = this.gridOptionsWrapper.getHeaderHeight();
        }
        else {
            utils_1.Utils.removeCssClass(this.eHeader, 'ag-pivot-off');
            utils_1.Utils.addCssClass(this.eHeader, 'ag-pivot-on');
            numberOfFloating = 0;
            groupHeight = this.gridOptionsWrapper.getPivotGroupHeaderHeight();
            headerHeight = this.gridOptionsWrapper.getPivotHeaderHeight();
        }
        var numberOfNonGroups = 1 + numberOfFloating;
        var numberOfGroups = headerRowCount - numberOfNonGroups;
        totalHeaderHeight = numberOfFloating * this.gridOptionsWrapper.getFloatingFiltersHeight();
        totalHeaderHeight += numberOfGroups * groupHeight;
        totalHeaderHeight += headerHeight;
        this.eHeader.style['height'] = totalHeaderHeight + 'px';
        // if we are doing auto-height, we only size the header, we don't size the
        // other parts as we use the normal browser layout for that
        if (this.autoHeight) {
            return;
        }
        // padding top covers the header and the pinned rows on top
        var floatingTopHeight = this.pinnedRowModel.getPinnedTopTotalHeight();
        var paddingTop = totalHeaderHeight + floatingTopHeight;
        // bottom is just the bottom pinned rows
        var floatingBottomHeight = this.pinnedRowModel.getPinnedBottomTotalHeight();
        var floatingBottomTop = heightOfContainer - floatingBottomHeight;
        var bodyHeight = heightOfContainer - totalHeaderHeight - floatingBottomHeight - floatingTopHeight;
        this.eBody.style.top = paddingTop + 'px';
        this.eBody.style.height = bodyHeight + 'px';
        this.eFloatingTop.style.top = totalHeaderHeight + 'px';
        this.eFloatingTop.style.height = floatingTopHeight + 'px';
        this.eFloatingBottom.style.height = floatingBottomHeight + 'px';
        this.eFloatingBottom.style.top = floatingBottomTop + 'px';
        this.ePinnedLeftColsViewport.style.height = bodyHeight + 'px';
        this.ePinnedRightColsViewport.style.height = bodyHeight + 'px';
        // bodyHeight property is used by pagination service, that may change number of rows
        // in this page based on the height of the grid
        if (this.bodyHeight !== bodyHeight) {
            this.bodyHeight = bodyHeight;
            var event_3 = {
                type: events_1.Events.EVENT_BODY_HEIGHT_CHANGED,
                api: this.gridApi,
                columnApi: this.columnApi
            };
            this.eventService.dispatchEvent(event_3);
        }
    };
    GridPanel.prototype.getBodyHeight = function () {
        return this.bodyHeight;
    };
    GridPanel.prototype.setHorizontalScrollPosition = function (hScrollPosition) {
        this.eBodyViewport.scrollLeft = hScrollPosition;
        // we need to manually do the event handling (rather than wait for the event)
        // for the alignedGridsService, as if we don't, the aligned grid service gets
        // notified async, and then it's 'consuming' flag doesn't get used right, and
        // we can end up with an infinite loop
        if (this.nextScrollLeft !== hScrollPosition) {
            this.nextScrollLeft = hScrollPosition;
            this.doHorizontalScroll();
        }
    };
    GridPanel.prototype.setVerticalScrollPosition = function (vScrollPosition) {
        this.eBodyViewport.scrollTop = vScrollPosition;
    };
    // tries to scroll by pixels, but returns what the result actually was
    GridPanel.prototype.scrollHorizontally = function (pixels) {
        var oldScrollPosition = this.eBodyViewport.scrollLeft;
        this.setHorizontalScrollPosition(oldScrollPosition + pixels);
        var newScrollPosition = this.eBodyViewport.scrollLeft;
        return newScrollPosition - oldScrollPosition;
    };
    // tries to scroll by pixels, but returns what the result actually was
    GridPanel.prototype.scrollVertically = function (pixels) {
        var oldScrollPosition = this.eBodyViewport.scrollTop;
        this.setVerticalScrollPosition(oldScrollPosition + pixels);
        var newScrollPosition = this.eBodyViewport.scrollTop;
        return newScrollPosition - oldScrollPosition;
    };
    GridPanel.prototype.addScrollListener = function () {
        var _this = this;
        // if printing, then no scrolling, so no point in listening for scroll events
        if (this.forPrint) {
            return;
        }
        this.addDestroyableEventListener(this.eBodyViewport, 'scroll', this.onBodyScroll.bind(this));
        // below we add two things:
        // pinnedScrollListener -> when pinned panel with scrollbar gets scrolled, it updates body and other pinned
        // suppressScroll -> stops scrolling when pinned panel was moved - which can only happen when user is navigating
        //     in the pinned container, as the pinned col should never scroll. so we rollback the scroll on the pinned.
        var onPinnedLeftVerticalScroll = this.onVerticalScroll.bind(this, this.ePinnedLeftColsViewport);
        var onPinnedRightVerticalScroll = this.onVerticalScroll.bind(this, this.ePinnedRightColsViewport);
        if (this.enableRtl) {
            this.addDestroyableEventListener(this.ePinnedLeftColsViewport, 'scroll', onPinnedLeftVerticalScroll);
            var suppressRightScroll = function () { return _this.ePinnedRightColsViewport.scrollTop = 0; };
            this.addDestroyableEventListener(this.ePinnedRightColsViewport, 'scroll', suppressRightScroll);
        }
        else {
            this.addDestroyableEventListener(this.ePinnedRightColsViewport, 'scroll', onPinnedRightVerticalScroll);
            var suppressLeftScroll = function () { return _this.ePinnedLeftColsViewport.scrollTop = 0; };
            this.addDestroyableEventListener(this.ePinnedLeftColsViewport, 'scroll', suppressLeftScroll);
        }
        var suppressCenterScroll = function () {
            if (_this.getPrimaryScrollViewport() !== _this.eBodyViewport) {
                _this.eBodyViewport.scrollTop = 0;
            }
        };
        this.addDestroyableEventListener(this.eBodyViewport, 'scroll', suppressCenterScroll);
        this.addIEPinFix(onPinnedRightVerticalScroll, onPinnedLeftVerticalScroll);
    };
    GridPanel.prototype.onBodyScroll = function () {
        this.onBodyHorizontalScroll();
        this.onBodyVerticalScroll();
    };
    GridPanel.prototype.onBodyHorizontalScroll = function () {
        var scrollLeft = this.eBodyViewport.scrollLeft;
        if (this.nextScrollLeft !== scrollLeft) {
            this.nextScrollLeft = scrollLeft;
            if (this.useAnimationFrame) {
                this.animationFrameService.schedule();
            }
            else {
                this.doHorizontalScroll();
            }
        }
    };
    GridPanel.prototype.doHorizontalScroll = function () {
        this.scrollLeft = this.nextScrollLeft;
        var event = {
            type: events_1.Events.EVENT_BODY_SCROLL,
            api: this.gridApi,
            columnApi: this.columnApi,
            direction: 'horizontal',
            left: this.scrollLeft,
            top: this.scrollTop
        };
        this.eventService.dispatchEvent(event);
        this.horizontallyScrollHeaderCenterAndFloatingCenter();
        this.setLeftAndRightBounds();
        // this.alignedGridsService.fireHorizontalScrollEvent(this.scrollLeft);
    };
    GridPanel.prototype.onBodyVerticalScroll = function () {
        var bodyVScrollActive = this.isBodyVerticalScrollActive();
        if (bodyVScrollActive) {
            this.onVerticalScroll(this.eBodyViewport);
        }
    };
    GridPanel.prototype.onVerticalScroll = function (sourceElement) {
        var scrollTop = sourceElement.scrollTop;
        if (this.useAnimationFrame) {
            if (this.nextScrollTop !== scrollTop) {
                this.nextScrollTop = scrollTop;
                this.animationFrameService.schedule();
            }
        }
        else {
            if (scrollTop !== this.scrollTop) {
                this.scrollTop = scrollTop;
                this.fakeVerticalScroll(scrollTop);
                this.redrawRowsAfterScroll();
            }
        }
    };
    GridPanel.prototype.executeFrame = function () {
        if (this.scrollLeft !== this.nextScrollLeft) {
            this.doHorizontalScroll();
            return true;
        }
        else if (this.scrollTop !== this.nextScrollTop) {
            this.scrollTop = this.nextScrollTop;
            this.fakeVerticalScroll(this.scrollTop);
            this.verticalRedrawNeeded = true;
            return true;
        }
        else if (this.verticalRedrawNeeded) {
            this.redrawRowsAfterScroll();
            this.verticalRedrawNeeded = false;
            return true;
        }
        else {
            return false;
        }
    };
    GridPanel.prototype.redrawRowsAfterScroll = function () {
        var event = {
            type: events_1.Events.EVENT_BODY_SCROLL,
            direction: 'vertical',
            api: this.gridApi,
            columnApi: this.columnApi,
            left: this.scrollLeft,
            top: this.scrollTop
        };
        this.eventService.dispatchEvent(event);
        this.rowRenderer.redrawAfterScroll();
    };
    // if LTR, we hide body scroll if pinning right (as scroll is in right pinned),
    // if RTL, we hide body scroll if pinning left (as scroll is in left pinned)
    GridPanel.prototype.isBodyVerticalScrollActive = function () {
        var pinningRight = this.columnController.isPinningRight();
        var pinningLeft = this.columnController.isPinningLeft();
        var centerHasScroll = this.enableRtl ? !pinningLeft : !pinningRight;
        return centerHasScroll;
    };
    // this bit is a fix / hack for IE due to this:
    // https://www.ag-grid.com/forum/showthread.php?tid=4303
    // it gets the left panel to reposition itself after a model change
    GridPanel.prototype.addIEPinFix = function (onPinnedRightScroll, onPinnedLeftScroll) {
        var _this = this;
        var listener = function () {
            if (_this.columnController.isPinningRight()) {
                setTimeout(function () {
                    if (_this.enableRtl) {
                        onPinnedLeftScroll();
                    }
                    else {
                        onPinnedRightScroll();
                    }
                }, 0);
            }
        };
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_MODEL_UPDATED, listener);
    };
    // this gets called whenever a change in the viewport, so we can inform column controller it has to work
    // out the virtual columns again. gets called from following locations:
    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged, API (doLayout)
    GridPanel.prototype.setLeftAndRightBounds = function () {
        if (this.gridOptionsWrapper.isForPrint()) {
            return;
        }
        var scrollWidth = this.eBodyViewport.clientWidth;
        var scrollPosition = this.getBodyViewportScrollLeft();
        this.columnController.setVirtualViewportPosition(scrollWidth, scrollPosition);
    };
    GridPanel.prototype.getBodyViewportScrollLeft = function () {
        if (this.forPrint) {
            return 0;
        }
        // we defer to a util, as how you calculated scrollLeft when doing RTL depends on the browser
        return utils_1.Utils.getScrollLeft(this.eBodyViewport, this.enableRtl);
    };
    GridPanel.prototype.setBodyViewportScrollLeft = function (value) {
        if (this.forPrint) {
            return;
        }
        // we defer to a util, as how you calculated scrollLeft when doing RTL depends on the browser
        utils_1.Utils.setScrollLeft(this.eBodyViewport, value, this.enableRtl);
    };
    GridPanel.prototype.horizontallyScrollHeaderCenterAndFloatingCenter = function () {
        var scrollLeft = this.getBodyViewportScrollLeft();
        var offset = this.enableRtl ? scrollLeft : -scrollLeft;
        this.eHeaderContainer.style.left = offset + 'px';
        this.eFloatingBottomContainer.style.left = offset + 'px';
        this.eFloatingTopContainer.style.left = offset + 'px';
    };
    // we say fake scroll as only one panel (left, right or body) has scrolls,
    // the other panels mimic the scroll by getting it's top position updated.
    GridPanel.prototype.fakeVerticalScroll = function (position) {
        if (this.enableRtl) {
            // RTL
            // if pinning left, then body scroll is faking
            var pinningLeft = this.columnController.isPinningLeft();
            if (pinningLeft) {
                this.setFakeScroll(this.eBodyContainer, position);
            }
            // right is always faking
            this.setFakeScroll(this.ePinnedRightColsContainer, position);
        }
        else {
            // LTR
            // if pinning right, then body scroll is faking
            var pinningRight = this.columnController.isPinningRight();
            if (pinningRight) {
                this.setFakeScroll(this.eBodyContainer, position);
            }
            // left is always faking
            this.setFakeScroll(this.ePinnedLeftColsContainer, position);
        }
        // always scroll fullWidth container, as this is never responsible for a scroll
        this.setFakeScroll(this.eFullWidthCellContainer, position);
    };
    GridPanel.prototype.setFakeScroll = function (eContainer, pixels) {
        eContainer.style.top = -pixels + 'px';
        // eContainer.style.transform = `translateY(${-pixels}px)`;
    };
    GridPanel.prototype.addScrollEventListener = function (listener) {
        this.eBodyViewport.addEventListener('scroll', listener);
    };
    GridPanel.prototype.removeScrollEventListener = function (listener) {
        this.eBodyViewport.removeEventListener('scroll', listener);
    };
    __decorate([
        context_1.Autowired('alignedGridsService'),
        __metadata("design:type", alignedGridsService_1.AlignedGridsService)
    ], GridPanel.prototype, "alignedGridsService", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], GridPanel.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], GridPanel.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('rowRenderer'),
        __metadata("design:type", rowRenderer_1.RowRenderer)
    ], GridPanel.prototype, "rowRenderer", void 0);
    __decorate([
        context_1.Autowired('pinnedRowModel'),
        __metadata("design:type", pinnedRowModel_1.PinnedRowModel)
    ], GridPanel.prototype, "pinnedRowModel", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], GridPanel.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], GridPanel.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('animationFrameService'),
        __metadata("design:type", animationFrameService_1.AnimationFrameService)
    ], GridPanel.prototype, "animationFrameService", void 0);
    __decorate([
        context_1.Autowired('navigationService'),
        __metadata("design:type", navigationService_1.NavigationService)
    ], GridPanel.prototype, "navigationService", void 0);
    __decorate([
        context_1.Autowired('paginationProxy'),
        __metadata("design:type", paginationProxy_1.PaginationProxy)
    ], GridPanel.prototype, "paginationProxy", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], GridPanel.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], GridPanel.prototype, "gridApi", void 0);
    __decorate([
        context_1.Optional('rangeController'),
        __metadata("design:type", Object)
    ], GridPanel.prototype, "rangeController", void 0);
    __decorate([
        context_1.Autowired('dragService'),
        __metadata("design:type", dragService_1.DragService)
    ], GridPanel.prototype, "dragService", void 0);
    __decorate([
        context_1.Autowired('selectionController'),
        __metadata("design:type", selectionController_1.SelectionController)
    ], GridPanel.prototype, "selectionController", void 0);
    __decorate([
        context_1.Optional('clipboardService'),
        __metadata("design:type", Object)
    ], GridPanel.prototype, "clipboardService", void 0);
    __decorate([
        context_1.Autowired('csvCreator'),
        __metadata("design:type", csvCreator_1.CsvCreator)
    ], GridPanel.prototype, "csvCreator", void 0);
    __decorate([
        context_1.Autowired('mouseEventService'),
        __metadata("design:type", mouseEventService_1.MouseEventService)
    ], GridPanel.prototype, "mouseEventService", void 0);
    __decorate([
        context_1.Autowired('focusedCellController'),
        __metadata("design:type", focusedCellController_1.FocusedCellController)
    ], GridPanel.prototype, "focusedCellController", void 0);
    __decorate([
        context_1.Autowired('$scope'),
        __metadata("design:type", Object)
    ], GridPanel.prototype, "$scope", void 0);
    __decorate([
        context_1.Autowired('scrollVisibleService'),
        __metadata("design:type", scrollVisibleService_1.ScrollVisibleService)
    ], GridPanel.prototype, "scrollVisibleService", void 0);
    __decorate([
        context_1.Optional('contextMenuFactory'),
        __metadata("design:type", Object)
    ], GridPanel.prototype, "contextMenuFactory", void 0);
    __decorate([
        context_1.Autowired('frameworkFactory'),
        __metadata("design:type", Object)
    ], GridPanel.prototype, "frameworkFactory", void 0);
    __decorate([
        context_1.Autowired('valueService'),
        __metadata("design:type", valueService_1.ValueService)
    ], GridPanel.prototype, "valueService", void 0);
    __decorate([
        context_1.Autowired('componentRecipes'),
        __metadata("design:type", componentRecipes_1.ComponentRecipes)
    ], GridPanel.prototype, "componentRecipes", void 0);
    __decorate([
        context_1.Autowired('dragAndDropService'),
        __metadata("design:type", dragAndDropService_1.DragAndDropService)
    ], GridPanel.prototype, "dragAndDropService", void 0);
    __decorate([
        __param(0, context_1.Qualifier('loggerFactory')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
        __metadata("design:returntype", void 0)
    ], GridPanel.prototype, "agWire", null);
    __decorate([
        context_1.PreDestroy,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], GridPanel.prototype, "destroy", null);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], GridPanel.prototype, "init", null);
    GridPanel = __decorate([
        context_1.Bean('gridPanel')
    ], GridPanel);
    return GridPanel;
}(beanStub_1.BeanStub));
exports.GridPanel = GridPanel;


/***/ }),

/***/ "ismk":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1333);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1078:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("qo2y");

/***/ }),

/***/ 1166:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("f1E8");

/***/ }),

/***/ 1333:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1078), __webpack_require__(1166) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "multiviewcalendar",
	    name: "MultiViewCalendar",
	    category: "web",
	    description: "Multi-view calendar.",
	    depends: [ "core", "selectable", "calendar"  ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        calendar = kendo.calendar,
	        support = kendo.support,
	        isInRange = calendar.isInRange,
	        toDateObject = calendar.toDateObject,
	        createDate = calendar.createDate,
	        isEqualDate = calendar.isEqualDate,
	        getToday = calendar.getToday,
	        keys = kendo.keys,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        Selectable = ui.Selectable,
	        template = kendo.template,
	        mobileOS = support.mobileOS,
	        ns = ".kendoMultiViewCalendar",
	        CLICK = "click",
	        KEYDOWN = "keydown",
	        ID = "id",
	        MIN = "min",
	        MONTH = "month",
	        DOT = ".",
	        CENTURY = "century",
	        DECADE = "decade",
	        CHANGE = "change",
	        NAVIGATE = "navigate",
	        VALUE = "value",
	        FOCUSED = "k-state-focused",
	        SELECTED = "k-state-selected",
	        MID = "k-range-mid",
	        SPLITEND = "k-range-split-end",
	        SPLITSTART = "k-range-split-start",
	        START = "k-range-start",
	        END = "k-range-end",
	        HOVER = "k-state-hover",
	        DISABLED = "k-state-disabled",
	        TODAY = "k-nav-today",
	        OTHERMONTH = "k-other-month",
	        OUTOFRANGE = "k-out-of-range",
	        CELLSELECTOR = "td:has(.k-link):not(." + OUTOFRANGE + ")",
	        CELLSELECTORVALID = "td:has(.k-link):not(." + DISABLED + "):not(." + OUTOFRANGE + ")",
	        BLUR = "blur",
	        FOCUS = "focus",
	        MOUSEENTER = support.touch ? "touchstart" : "mouseenter",
	        MOUSELEAVE_NS = support.touch ? "touchend" + ns + " touchmove" + ns : "mouseleave" + ns,
	        PREVARROW = "_prevArrow",
	        NEXTARROW = "_nextArrow",
	        ARIA_SELECTED = "aria-selected",
	        INPUTSELECTOR = "input,a,textarea,.k-multiselect-wrap,select,button,.k-button>span,.k-button>img,span.k-icon.k-i-arrow-60-down,span.k-icon.k-i-arrow-60-up",
	        ARIA_DISABLED = "aria-disabled",
	        ARIA_LABEL = "aria-label",
	        proxy = $.proxy,
	        DATE = Date,
	        views = {
	            month: 0,
	            year: 1,
	            decade: 2,
	            century: 3
	        };

	    var RangeSelectable = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            that.userEvents = new kendo.UserEvents(that.element, {
	                global: true,
	                allowSelection: true,
	                filter: that.options.filter,
	                tap: proxy(that._tap, that),
	                touchAction: "none"
	            });
	        },

	        events: [CHANGE],

	        options: {
	            name: "RangeSelectable",
	            filter: ">*",
	            inputSelectors: INPUTSELECTOR,
	            multiple: false,
	            dragToSelect: true,
	            relatedTarget: $.noop
	        },

	        destroy: function () {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            that.userEvents.destroy();

	            that._lastActive = that.element = that.userEvents = that._start = that._end = null;
	        },

	        _allowSelection: function(target) {
	            if ($(target).is(this.options.inputSelectors)) {
	                this.userEvents.cancel();
	                return false;
	            }

	            return true;
	        },

	        start: function (element) {
	            if (element === undefined) {
	                return this._start;
	            }
	            element.addClass(START + " " + SELECTED);
	            this._start = element;
	        },

	        end: function(element) {
	            if (element === undefined) {
	                return this._start;
	            }
	            element.addClass(END + " " + SELECTED);
	            this._end = element;
	        },

	        mid: function(elements) {
	            var tables = this.element.find("table.k-month");

	            elements.addClass(MID);
	            tables.each(function() {
	                var that = $(this);
	                var lastCell = that.find(CELLSELECTORVALID + ":last");
	                var firstCell = that.find(CELLSELECTORVALID + ":first");

	                if (lastCell.hasClass(MID)) {
	                    lastCell.addClass(SPLITEND);
	                }

	                if (firstCell.hasClass(MID)) {
	                    firstCell.addClass(SPLITSTART);
	                }
	            });
	        },

	        clear: function(clearVariables) {
	            this.element.find(CELLSELECTOR).removeClass(END + " " + SELECTED + " " + START + " " + MID + " " + SPLITEND + " " + SPLITSTART);

	            if (clearVariables) {
	                this._start = this._end = null;
	            }
	        },

	        selectFrom: function(start) {
	            var that = this;
	            var items;
	            var startIdx;

	            items = that.element.find(CELLSELECTOR);

	            startIdx = $.inArray($(start)[0], items);

	            that.clear();
	            that.start(start);

	            items = items.filter(function (index) {
	                return index > startIdx;
	            });
	            that.mid(items);
	        },

	        selectTo: function(end) {
	            var that = this;
	            var items;
	            var endIdx;

	            items = that.element.find(CELLSELECTOR);

	            endIdx = $.inArray($(end)[0], items);

	            that.clear();

	            items = items.filter(function (index) {
	                return index < endIdx;
	            });
	            that.mid(items);
	            that.end($(end));
	        },

	        range: function(start, end) {
	            var that = this;
	            var items;
	            var startIdx;
	            var endIdx;
	            var temp;

	            if (start === undefined) {
	                return { start: that._start, end: that._end };
	            }

	            items = that.element.find(CELLSELECTOR);

	            startIdx = $.inArray($(start)[0], items);
	            endIdx = $.inArray($(end)[0], items);

	            if (startIdx > endIdx) {
	                temp = end;
	                end = start;
	                start = temp;
	                temp = startIdx;
	                startIdx = endIdx;
	                endIdx = temp;
	            }
	            that.clear();
	            start.addClass(START + " " + SELECTED);
	            that._start = start;

	            items = items.filter(function (index) {
	                return index > startIdx && index < endIdx;
	            });
	            that.mid(items);
	            that.end($(end));
	        },

	        change: function() {
	            this.trigger(CHANGE);
	        },

	        _tap: function(e) {
	            var target = $(e.target),
	                that = this,
	                items,
	                startIdx,
	                endIdx;


	            that._lastActive = target;
	            if(!that._start) {
	                that.start(target);
	                that.trigger(CHANGE);
	                return;
	            }

	            if(that._start && !that._end) {
	                items = that.element.find(CELLSELECTOR);

	                startIdx = $.inArray($(that._start)[0], items);
	                endIdx = $.inArray($(target)[0], items);

	                if (+toDateObject($(that._start).find("a")) > +toDateObject($(target).find("a"))) {
	                    that.clear();
	                    that.start(target);
	                    that.trigger(CHANGE);
	                    return;
	                }

	                items = items.filter(function (index) {
	                    return index > startIdx && index < endIdx;
	                });
	                that.mid(items);
	                that.end($(target));
	                that.trigger(CHANGE);
	                return;
	            }

	            if (that._start && that._end) {
	                if (target.hasClass(MID)) {
	                    if (!that._toggling) {
	                        that.range(target, that._end);
	                    } else {
	                        that.range(that._start, target);
	                    }
	                    that._toggling = !that._toggling;
	                    that.trigger(CHANGE);
	                    return;
	                }
	                that._toggling = false;
	                that._end = null;
	                that.clear();
	                that.start(target);
	                that.trigger(CHANGE);
	            }
	        }
	    });


	    var MultiViewCalendar = Widget.extend({
	        init: function(element, options) {
	            var that = this;
	            var id;
	            var culture;

	            Widget.fn.init.call(that, element, options);

	            element = that.wrapper = that.element;
	            options = that.options;

	            that.options.disableDates = calendar.disabled(that.options.disableDates);

	            culture = kendo.getCulture(options.culture);
	            options.format = kendo._extractFormat(options.format || culture.calendars.standard.patterns.d);

	            that._templates();

	            that._header();

	            that._wrapper();

	            id = element
	                .addClass("k-widget k-calendar k-calendar-range" + (options.weekNumber ? " k-week-number" : ""))
	                .on(KEYDOWN + ns, "table.k-content", proxy(that._move, that))
	                .on(BLUR + ns, "table", proxy(that._blur, that))
	                .on(CLICK + ns, CELLSELECTORVALID, function(e) {
	                    var link = e.currentTarget.firstChild;

	                    if (link.href.indexOf("#") != -1) {
	                        e.preventDefault();
	                    }

	                    that._click($(link));
	                })
	                .on(MOUSEENTER + ns, CELLSELECTORVALID, proxy(that._mouseEnter, that))
	                .on(MOUSELEAVE_NS, CELLSELECTORVALID, function() {
	                    $(this).removeClass(HOVER);
	                })
	                .attr(ID);

	            if (id) {
	                that._cellID = id + "_cell_selected";
	            }

	            that._calendarWidth = that.element.width();

	            that._range = options.range;

	            that._initViews({ viewName: options.start, value: options.value});
	            that._selectable();

	            that._footer(that.footer);
	            that._selectDates = [];
	            that.value(options.value);

	            if (options.selectable == "multiple") {
	                that._selectDates = options.selectDates.length ? options.selectDates : that._selectDates;
	                that._restoreSelection();
	            }

	            if (options.selectable == "range") {
	                that.selectRange(that._range);
	            }

	            kendo.notify(that);
	        },

	        options: {
	            name: "MultiViewCalendar",
	            value: null,
	            min: new DATE(1900, 0, 1),
	            max: new DATE(2099, 11, 31),
	            dates: [],
	            disableDates: null,
	            culture: "",
	            footer : "",
	            format : "",
	            month : {},
	            range : { start: null, end: null },
	            weekNumber: false,
	            views: 2,
	            showViewHeader: false,
	            selectable: "single",
	            selectDates: [],
	            start: MONTH,
	            depth: MONTH,
	            messages: {
	                weekColumnHeader: ""
	            }
	        },

	        events: [
	            CHANGE,
	            NAVIGATE
	        ],

	        setOptions: function(options) {
	            var that = this;

	            calendar.normalize(options);

	            options.disableDates = calendar.disabled(options.disableDates);

	            Widget.fn.setOptions.call(that, options);

	            that._selectable();

	            that._templates();

	            that._footer(that.footer);

	            for (var i = 0; i < that._views.length; i++) {
	                that._views[i].off(ns).remove();
	            }

	            that._initViews({ viewName: options.start, value: options.value});

	            that._range = options.range || { start: null, end: null };

	            that._restoreSelection();
	        },

	        destroy: function() {
	            var that = this;

	            that._cell = null;
	            that._currentView = null;
	            that._current = null;

	            if (that._views) {
	                for (var i = 0; i < that._views.length; i++) {
	                    that._views[i].off(ns).remove();
	                }
	            }

	            that.element.off(ns);

	            if (that.header) {
	                that.header.off(ns);
	                that._title = null;
	                that.header = null;
	            }

	            if (that.selectable) {
	                that.selectable.destroy();
	                that.selectable = null;
	            }

	            if (that.rangeSelectable) {
	                that.rangeSelectable.destroy();
	                that.rangeSelectable = null;
	            }

	            if (that._today) {
	                kendo.destroy(that._today.off(ns));
	            }

	            that._views = null;

	            Widget.fn.destroy.call(that);
	        },

	        current: function() {
	            return this._current;
	        },

	        focus: function() {
	            var table;

	            if (this._cell) {
	                this._cell.closest("table").trigger("focus");
	            } else if (this._current && this._dateInViews(this._current)) {
	                this._cell = this._cellByDate(this._current);
	                this._cell.closest("table").trigger("focus");
	            } else {
	                table = this.element.find("table").first().trigger("focus");
	                this._cell = table.find(CELLSELECTORVALID + ":first");
	                this._current = toDateObject(this._cell.find("a"));
	            }
	            this._cell.addClass(FOCUSED);
	        },

	        min: function(value) {
	            return this._option(MIN, value);
	        },

	        max: function(value) {
	            return this._option("max", value);
	        },

	        view: function() {
	            return this._currentView;
	        },

	        navigateToPast: function() {
	            this._navigate(PREVARROW, -1);
	        },

	        navigateToFuture: function() {
	            this._navigate(NEXTARROW, 1);
	        },

	        navigateUp: function() {
	            var that = this,
	            index = that._index;

	            if (that._title.hasClass(DISABLED)) {
	                return;
	            }

	            that.navigate(that._current, ++index);
	        },

	        navigateDown: function(value) {
	            var that = this,
	            index = that._index,
	            depth = that.options.depth;

	            if (!value) {
	                return;
	            }

	            if (index === views[depth]) {
	                if (!isEqualDate(that._value, that._current) || !isEqualDate(that._value, value)) {
	                    that.value(value);
	                    that.trigger(CHANGE);
	                }
	                return;
	            }

	            that.navigate(value, --index);
	        },

	        navigate: function(value, view) {
	            view = isNaN(view) ? calendar.views[calendar.viewsEnum[view]] : calendar.views[view];

	            var that = this;
	            var options = that.options;
	            var min = options.min;
	            var max = options.max;

	            if (!value) {
	                that._current = value = new DATE(+calendar.restrictValue(value, min, max));
	            } else {
	                that._current = value;
	            }

	            if (view === undefined) {
	                view = that._currentView;
	            }

	            that._currentView = view;

	            for (var i = 0; i < that._views.length; i++) {
	                that._views[i].off(ns).remove();
	            }

	            that._initViews({ viewName: view.name, value: value });

	            that._restoreSelection();
	        },

	        _updateHeader: function() {
	            var that = this;
	            var view = that._currentView;
	            var title = that._title;
	            var value = that._firstViewValue;
	            var options = that.options;
	            var visibleRange = that._visibleRange();
	            var culture = options.culture;
	            var min = options.min;
	            var max = options.max;
	            var lastDate;
	            var disabled;
	            var prevDisabled;
	            var nextDisabled;


	            if (view.name === DECADE || view.name === CENTURY) {
	                lastDate = shiftDate(value, view.name, options.views - 1);
	                if (!isInRange(lastDate, min, max)) {
	                    lastDate = max;
	                }

	                title.html(view.first(value).getFullYear() + " - " + view.last(lastDate).getFullYear());
	            } else {
	                title.html(view.title(value, min, max, culture) + " - " + view.title(shiftDate(value, view.name, options.views - 1), min, max, culture));
	            }

	            disabled = view.name === CENTURY;
	            title.toggleClass(DISABLED, disabled).attr(ARIA_DISABLED, disabled);

	            prevDisabled = view.compare(visibleRange.start, that.options.min) < 1;
	            nextDisabled = view.compare(visibleRange.end, that.options.max) > -1;

	            if (prevDisabled && nextDisabled) {
	                if (that._navContainer) {
	                    that._navContainer.remove();
	                    that._navContainer = null;
	                }
	            } else {
	                if (!that._navContainer) {
	                    that._navContainer = $('<span class="k-calendar-nav">' +
	                    '<a href="#" role="button" class="k-button k-button-icon k-prev-view" ' + ARIA_LABEL + '="Previous"><span class="k-icon k-i-arrow-60-left"></span></a>' +
	                    '<a href="#" role="button" class="k-button k-button-icon k-next-view" ' + ARIA_LABEL + '="Next"><span class="k-icon k-i-arrow-60-right"></span></a>' +
	                    '</span>').appendTo(that.header);
	                    that[PREVARROW] = that._navContainer.find(".k-prev-view");
	                    that[NEXTARROW] = that._navContainer.find(".k-next-view");
	                }

	                that[PREVARROW].toggleClass(DISABLED, prevDisabled).attr(ARIA_DISABLED, prevDisabled);
	                if (that[PREVARROW].hasClass(DISABLED)) {
	                    that[PREVARROW].removeClass(HOVER);
	                }

	                that[NEXTARROW].toggleClass(DISABLED, nextDisabled).attr(ARIA_DISABLED, nextDisabled);
	                if (that[NEXTARROW].hasClass(DISABLED)) {
	                    that[NEXTARROW].removeClass(HOVER);
	                }
	            }
	        },

	        _mouseEnter: function(e) {
	            var that = this;
	            var cell = $(e.currentTarget);
	            var range;
	            var items;
	            var startIdx;
	            var endIdx;

	            cell.addClass(HOVER);

	            if (that.rangeSelectable && that._currentView.name === "month") {
	                range = that.selectRange();
	                if (range.start && !range.end) {
	                    if (that._dateInViews(that.selectRange().start)) {
	                        items = that.element.find(that.rangeSelectable.options.filter);
	                        startIdx = $.inArray($(that.rangeSelectable._start)[0], items);
	                        endIdx = $.inArray($(cell)[0], items);
	                        if (startIdx > endIdx) {
	                            return;
	                        }
	                        that.rangeSelectable.range(that.rangeSelectable._start, cell);
	                    } else if(+toDateObject(that.element.find(CELLSELECTOR + ":first").find("a")) > +range.start) {
	                        that.rangeSelectable.selectTo(cell);
	                    }
	                    that.rangeSelectable._end = null;
	                }
	            }
	        },

	        _move: function(e, preventFocus) {
	            var that = this;
	            var options = that.options;
	            var key = e.keyCode;
	            var index = that._index;
	            var min = options.min;
	            var max = options.max;
	            var focusedCell = that.element.find(DOT+FOCUSED);
	            var table = focusedCell.closest("table");
	            var currentValue = new DATE(+(that._current || toDateObject(focusedCell.find("a"))));
	            var isRtl = kendo.support.isRtl(that.wrapper);
	            var navigate = false;
	            var value, prevent, method, cell, lastActive, cellIndex;

	            if (key == keys.RIGHT && !isRtl || key == keys.LEFT && isRtl) {
	                value = 1;
	                prevent = true;
	            } else if (key == keys.LEFT && !isRtl || key == keys.RIGHT && isRtl) {
	                value = -1;
	                prevent = true;
	            } else if (key == keys.UP) {
	                value = index === 0 ? -7 : -4;
	                prevent = true;
	            } else if (key == keys.DOWN) {
	                value = index === 0 ? 7 : 4;
	                prevent = true;
	            }
	            else if (key == keys.SPACEBAR) {
	                value = 0;
	                prevent = true;
	            }
	            else if (key == keys.HOME) {
	                prevent = true;
	                cell = table.find(CELLSELECTORVALID).eq(0);
	                if (cell.hasClass(FOCUSED)) {
	                    table = table.prev();
	                    if (table.length) {
	                        that._focusCell(table.find(CELLSELECTORVALID).eq(0));
	                    } else {
	                        navigate = that[PREVARROW] && !that[PREVARROW].hasClass(DISABLED);
	                        that._navigate(PREVARROW, -1, preventFocus);
	                        that._focusCell(that.element.find("table:first " + CELLSELECTORVALID + ":first"));
	                    }
	                } else {
	                    that._focusCell(cell);
	                }
	            } else if(key == keys.END) {
	                prevent = true;
	                cell = table.find(CELLSELECTORVALID).last();
	                if (cell.hasClass(FOCUSED)) {
	                    table = table.next();
	                    if (table.length) {
	                        that._focusCell(table.find(CELLSELECTORVALID).last());
	                    } else {
	                        navigate = that[NEXTARROW] && !that[NEXTARROW].hasClass(DISABLED);
	                        that._navigate(NEXTARROW, 1, preventFocus);
	                        that._focusCell(that.element.find("table:last " + CELLSELECTORVALID + ":last"));
	                    }
	                } else {
	                    that._focusCell(cell);
	                }
	            }

	            if (e.ctrlKey || e.metaKey) {
	                if (key == keys.RIGHT && !isRtl || key == keys.LEFT && isRtl) {
	                    navigate = that[NEXTARROW] && !that[NEXTARROW].hasClass(DISABLED);
	                    that._navigate(NEXTARROW, 1, preventFocus);
	                    prevent = true;
	                } else if (key == keys.LEFT && !isRtl || key == keys.RIGHT && isRtl) {
	                    navigate = that[PREVARROW] && !that[PREVARROW].hasClass(DISABLED);
	                    that._navigate(PREVARROW, -1, preventFocus);
	                    prevent = true;
	                } else if (key == keys.UP) {
	                    navigate = !that._title.hasClass(DISABLED);
	                    that.navigateUp();
	                    that._focusCell(that._cellByDate(that._current), !preventFocus);
	                    prevent = true;
	                } else if (key == keys.DOWN) {
	                    if (that._currentView.name === "month") {
	                        that.value(currentValue);
	                    } else {
	                        that.navigateDown(currentValue);
	                        that._focusCell(that._cellByDate(that._current), !preventFocus);
	                        navigate = true;
	                    }
	                    prevent = true;
	                } else if ((key == keys.ENTER || key == keys.SPACEBAR)) {
	                    if (options.selectable === "multiple") {
	                        that._toggleSelection(e);
	                    }
	                }
	            } else if (e.shiftKey && options.selectable !== "single") {
	                if (value !== undefined || method) {
	                    if (!method) {
	                        that._currentView.setDate(currentValue, value);
	                    }

	                    if (that._currentView.name !== "month") {
	                        return;
	                    }

	                    if (options.disableDates(currentValue)) {
	                        currentValue = that._nextNavigatable(currentValue, value);
	                    }

	                    min = createDate(min.getFullYear(), min.getMonth(), min.getDate());

	                    if (isInRange(currentValue, min, max)) {
	                        if (!that._dateInViews(currentValue)) {
	                            if (value > 0) {
	                                navigate = that[NEXTARROW] && !that[NEXTARROW].hasClass(DISABLED);
	                                that._navigate(NEXTARROW, 1, preventFocus);
	                            } else {
	                                navigate = that[PREVARROW] && !that[PREVARROW].hasClass(DISABLED);
	                                that._navigate(PREVARROW, -1, preventFocus);
	                            }
	                        }
	                        cell = that._cellByDate(currentValue);
	                        that._current = currentValue;

	                        if (that.selectable) {
	                            that._selectRange(toDateObject((that.selectable._lastActive || focusedCell).find("a")), currentValue);
	                            if (!that.selectable._lastActive) {
	                                that.selectable._lastActive = focusedCell;
	                            }
	                            that.trigger(CHANGE);
	                            that._focusCell(cell);
	                        }

	                        if (that.rangeSelectable) {
	                            lastActive = toDateObject((that.rangeSelectable._lastActive || focusedCell).find("a"));
	                            if (!that._dateInViews(lastActive)) {
	                                if (+lastActive > +currentValue) {
	                                    that.rangeSelectable._end = that.rangeSelectable._lastActive;
	                                    that.rangeSelectable.selectFrom(cell);
	                                } else {
	                                    that.rangeSelectable.selectTo(cell);
	                                }
	                            } else {
	                                if (that.rangeSelectable._end && that.rangeSelectable._end.is(DOT+FOCUSED)) {
	                                    that.rangeSelectable._lastActive = that.rangeSelectable._start;
	                                } else {
	                                    that.rangeSelectable._lastActive = that._cellByDate(lastActive);
	                                }
	                                that.rangeSelectable.range(that.rangeSelectable._lastActive, cell);
	                            }
	                            that.rangeSelectable.change();
	                            that._focusCell(cell);
	                        }
	                    }
	                }
	            } else {
	                if (key == keys.ENTER || key == keys.SPACEBAR) {
	                    if (that._currentView.name === "month") {
	                        if (that.selectable) {
	                            that.selectable._lastActive = that._cellByDate(currentValue);
	                        }
	                        that.value(currentValue);
	                        if (that.rangeSelectable) {
	                            that.rangeSelectable.change();
	                        }
	                    } else {
	                        that._click($(that._cell[0].firstChild), preventFocus);
	                    }
	                    prevent = true;
	                } else if (key == keys.PAGEUP || key == keys.PAGEDOWN) {
	                    prevent = true;
	                    cellIndex = table.find(CELLSELECTORVALID).index(focusedCell);
	                    table = key == keys.PAGEUP ? table.prev() : table.next();
	                    if (!table.length) {
	                        if (key == keys.PAGEUP) {
	                            navigate = that[PREVARROW] && !that[PREVARROW].hasClass(DISABLED);
	                            that.navigateToPast();
	                            table = that.element.find("table:first");
	                        } else {
	                            navigate = that[NEXTARROW] && !that[NEXTARROW].hasClass(DISABLED);
	                            that.navigateToFuture();
	                            table = that.element.find("table:last");
	                        }
	                    }
	                    cell = table.find(CELLSELECTORVALID).eq(cellIndex);
	                    if (cell.length) {
	                        that._focusCell(cell);
	                    } else {
	                        that._focusCell(table.find(CELLSELECTORVALID).last());
	                    }
	                }

	                if (value || method) {
	                    if (!method) {
	                        that._currentView.setDate(currentValue, value);
	                    }

	                    min = createDate(min.getFullYear(), min.getMonth(), min.getDate());

	                    if (isInRange(currentValue, min, max)) {
	                        if (that.selectable && options.disableDates(currentValue)) {
	                            currentValue = that._nextNavigatable(currentValue, value);
	                        }
	                        if (!that._dateInViews(currentValue)) {
	                            if (value > 0) {
	                                navigate = that[NEXTARROW] && !that[NEXTARROW].hasClass(DISABLED);
	                                that._navigate(NEXTARROW, 1, preventFocus);
	                            } else {
	                                navigate = that[PREVARROW] && !that[PREVARROW].hasClass(DISABLED);
	                                that._navigate(NEXTARROW, -1, preventFocus);
	                            }
	                        }
	                        cell = that._cellByDate(currentValue);
	                        that._current = currentValue;
	                        that._focusCell(cell, !preventFocus);
	                    }
	                }
	            }

	            if (navigate) {
	                that.trigger(NAVIGATE);
	            }

	            if (prevent) {
	                e.preventDefault();
	            }

	            return that._current;

	        },

	        _visualizeSelectedDatesInView: function() {
	            var that = this;
	            var selectedDates = {};
	            var cells;

	            $.each(that._selectDates, function(index, value) {
	                selectedDates[kendo.calendar.views[0].toDateString(value)] = value;
	            });
	            that.selectable.clear();
	            cells = that.element.find("table")
	                .find(CELLSELECTOR)
	                .filter(function(index, element) {
	                    return selectedDates[$(element.firstChild).attr(kendo.attr(VALUE))];
	                });

	            if (cells.length > 0) {
	                that.selectable._selectElement(cells, true);
	            }
	        },

	        _nextNavigatable: function(currentValue, value) {
	            var that = this;
	            var disabled = true;
	            var view = that._currentView;
	            var min = that.options.min;
	            var max = that.options.max;
	            var isDisabled = that.options.disableDates;
	            var navigatableDate = new Date(currentValue.getTime());

	            view.setDate(navigatableDate, -value);
	            while (disabled) {
	                view.setDate(currentValue, value);
	                 if (!isInRange(currentValue, min, max)) {
	                    currentValue = navigatableDate;
	                    break;
	                }
	                disabled = isDisabled(currentValue);
	            }
	            return currentValue;
	        },

	        _toggleSelection: function (event) {
	            var that = this;

	            that.selectable._lastActive = $(that._cell[0]);

	            if ($(that._cell[0]).hasClass(SELECTED)) {
	                that.selectable._unselect($(that._cell[0]));
	                that.selectable.trigger(CHANGE, { event: event});
	            }
	            else {
	                that.selectable.value($(that._cell[0]), { event: event});
	            }
	        },

	        _option: function(option, value) {
	            var that = this;
	            var options = that.options;
	            var currentValue = that._value || that._current;
	            var isBigger;

	            if (value === undefined) {
	                return options[option];
	            }

	            value = kendo.parseDate(value, options.format, options.culture);

	            if (!value) {
	                return;
	            }

	            options[option] = new DATE(+value);

	            if (option === MIN) {
	                isBigger = value > currentValue;
	            } else {
	                isBigger = currentValue > value;
	            }

	            if (isBigger) {
	                that._value = null;
	            }

	            that.navigate(that._value);

	            that._toggle();
	        },

	        _cellByDate: function(value) {
	            if (value instanceof Date) {
	                value = this._currentView.toDateString(value);
	            }
	            return this.element.find("table").find("td:not(." + OTHERMONTH + ")")
	            .filter(function() {
	                return $(this.firstChild).attr(kendo.attr(VALUE)) === value;
	            });
	        },

	        _selectable: function () {
	            var that = this;
	            var selectable = that.options.selectable;

	            if (that.selectable) {
	                that.selectable.destroy();
	                that.selectable = null;
	            }

	            if (that.rangeSelectable) {
	                that.rangeSelectable.destroy();
	                that.rangeSelectable = null;
	            }

	            if (selectable.toLowerCase() === "range") {
	                that.rangeSelectable = new RangeSelectable(that.wrapper, {
	                    filter: "table.k-month " + CELLSELECTORVALID,
	                    change: proxy(that._rangeSelection, that)
	                });
	            } else {
	                that.selectable = new Selectable(that.wrapper, {
	                    aria: true,
	                    dragToSelect: false,
	                    inputSelectors: "input,textarea,.k-multiselect-wrap,select,button,.k-button>span,.k-button>img,span.k-icon.k-i-arrow-60-down,span.k-icon.k-i-arrow-60-up",
	                    multiple: Selectable.parseOptions(selectable).multiple,
	                    filter: "table.k-content " + CELLSELECTORVALID,
	                    change: proxy(that._selection, that),
	                    relatedTarget: proxy(that._onRelatedTarget, that),
	                    unselect: proxy(that._unselecting, that)
	                });
	            }
	        },

	        _onRelatedTarget: function(target) {
	            var that = this;

	            if (that.selectable.options.multiple && target.is(CELLSELECTORVALID) && target.length > 1) {
	                that._focusCell(target.first(), true);
	            }
	        },

	        _getFirstViewDate: function(currentView) {
	            var that = this;
	            var options = that.options;
	            var ranges = [];
	            var start;
	            var end;
	            var current = new Date(+that._current);
	            var i;

	            for (i = 0; i < options.views; i++) {
	                start = currentView.first(current);
	                end =  currentView.last(current);

	                if (+end > +options.max) {
	                    if (+start <= +options.max) {
	                        ranges.push({start: start, end: new Date(+options.max)});
	                    }
	                    break;
	                }

	                ranges.push({start: start, end: end});

	                current = new Date(+shiftDate(end, currentView.name, 1));
	            }

	            current = new Date(+that._current);

	            for (i = 0; i < options.views; i++) {
	                start = currentView.first(current);
	                end = currentView.last(current);

	                if (+start < +options.min) {
	                    if (+end >= +options.min) {
	                        ranges.push({start: new Date(+options.min), end: end});
	                    }
	                    break;
	                }

	                ranges.push({start: start, end: end});

	                current = new Date(+shiftDate(start, currentView.name, -1));
	            }

	            start = ranges[0].start;

	            for (i = 0; i < options.views + 1; i++) {
	                if (!ranges[i]) {
	                    break;
	                }

	                if (+start > +ranges[i].start) {
	                    start = ranges[i].start;
	                }
	            }

	            return new Date(+start);
	        },

	        _canRenderNextView: function(viewDate) {
	            var fullYear = viewDate.getFullYear();
	            var month = viewDate.getMonth();
	            var date = viewDate.getDate();
	            var max = this.options.max;
	            var maxYear = max.getFullYear();
	            var maxMonth = max.getMonth();


	            if (fullYear < maxYear) {
	                return true;
	            }

	            if (fullYear === maxYear && month < maxMonth) {
	                return true;
	            }

	            if (fullYear === maxYear &&  month === maxMonth &&  date < max.getDate()) {
	                return true;
	            }

	            if (fullYear === maxYear &&  month === maxMonth &&  date === max.getDate()) {
	                return true;
	            }

	            return false;
	        },

	        _initViews: function(viewOptions) {
	            var that = this;
	            var options = that.options;
	            var index = calendar.viewsEnum[viewOptions.viewName];
	            var currentView = calendar.views[index];
	            var viewDate;

	            that._current = new DATE(+calendar.restrictValue(viewOptions.value, options.min, options.max));
	            that._views = [];
	            that._index = index;
	            viewDate = that._getFirstViewDate(currentView);
	            viewDate.setDate(1);

	            that._firstViewValue = new Date(+viewDate);

	            for (var i = 0; i < options.views; i++) {
	                viewDate = i ? shiftDate(viewDate, currentView.name, 1): viewDate;
	                viewDate.setDate(1);

	                if (!that._canRenderNextView(viewDate)) {
	                    break;
	                }

	                that._table = $(currentView.content($.extend({
	                    min: options.min,
	                    max: options.max,
	                    date: viewDate,
	                    url: options.url,
	                    dates: options.dates,
	                    format: options.format,
	                    culture: options.culture,
	                    disableDates: options.disableDates,
	                    showHeader: options.showViewHeader,
	                    isWeekColumnVisible: options.weekNumber,
	                    otherMonth: options.otherMonth,
	                    messages: options.messages,
	                    contentClasses: "k-content"
	                }, that[currentView.name])));

	                that._table.appendTo(that.tablesWrapper).addClass("k-" + currentView.name);
	                that._views.push(that._table);
	            }

	            // that.wrapper.width(visibleViews * that._calendarWidth);

	            that._currentView = currentView;

	            that.tablesWrapper.attr("class", "k-calendar-view k-calendar-" + currentView.name + "view");

	            that._updateHeader();
	        },

	        _rangeSelection: function(e) {
	            var that = this;
	            var range = e.sender.range();
	            var start;
	            var end;

	            if (range.start) {
	                start = toDateObject(range.start.find("a"));
	            }

	            if (range.end) {
	                end = toDateObject(range.end.find("a"));
	            }

	            that._range = { start: start, end: end };

	            if (!that._preventChange) {
	                that.trigger(CHANGE);
	            }
	        },

	        _selection: function(e) {
	            var that = this;
	            var selectElements = e.sender.value();
	            var domEvent = e.event;
	            var currentTarget = $(domEvent && domEvent.currentTarget);
	            var isCell = currentTarget.is("td");
	            var currentValue;

	            if (that.options.selectable === "single") {
	                that._validateValue(selectElements[0] ? toDateObject(selectElements.first().find("a")) : e.sender._lastActive ? toDateObject(e.sender._lastActive.find("a")) : that.value());
	            }

	            if (that.options.selectable == "multiple") {

	                if (isCell) {
	                    currentValue = toDateObject(currentTarget.find("a"));
	                }

	                if (domEvent && domEvent.ctrlKey) {
	                    if (isCell) {
	                        if (currentTarget.hasClass(SELECTED)) {
	                            that._selectDates.push(currentValue);
	                        } else {
	                            that._deselect(currentValue);
	                        }
	                    } else {
	                        that.element.find("table " + CELLSELECTORVALID).each(function(index, element){
	                            var value = toDateObject($(element).find("a"));
	                            that._deselect(value);
	                        });
	                        that._addSelectedCellsToArray();
	                    }
	                } else if (domEvent && domEvent.shiftKey) {
	                    that._selectRange(toDateObject(e.sender._lastActive ? e.sender._lastActive.find("a") : selectElements.first().find("a")), currentValue);
	                } else if (isCell) {
	                    that._selectDates  = [];
	                    that._selectDates.push(currentValue);
	                } else {
	                    that._selectDates = [];
	                    that._addSelectedCellsToArray();
	                }
	            }

	            if (!that._preventChange) {
	                that.trigger(CHANGE);
	            }
	        },

	        _addSelectedCellsToArray: function() {
	            var that = this;
	            that.selectable.value().each(function(index, item) {
	                var date = toDateObject($(item.firstChild));
	                if (!that.options.disableDates(date)) {
	                    that._selectDates.push(date);
	                }
	            });
	        },

	        _deselect: function(date) {
	            var that = this;
	            var currentDateIndex = that._selectDates.map(Number).indexOf(+date);
	             if (currentDateIndex != -1) {
	                that._selectDates.splice(currentDateIndex, 1);
	            }
	        },

	        _unselecting: function(e) {
	            var that = this;
	            var element = e.element;

	            if (that.options.selectable === "single" && !mobileOS && element.hasClass(FOCUSED)) {
	                e.preventDefault();
	            }
	        },

	        _visibleRange: function () {
	            var tables = this.element.find(".k-calendar-view table");
	            var firstDateInView = toDateObject(tables.first().find(CELLSELECTOR + ":first").find("a"));
	            var lastDateInView = toDateObject(tables.last().find(CELLSELECTOR + ":last").find("a"));
	            return { start : firstDateInView, end: lastDateInView };
	        },

	        _dateInViews: function(date) {
	            var that = this;
	            var tables = that.element.find(".k-calendar-view table");
	            var firstDateInView = toDateObject(tables.first().find(CELLSELECTOR + ":first").find("a"));
	            var lastDateInView = toDateObject(tables.last().find(CELLSELECTOR + ":last").find("a"));

	            return +date <= +lastDateInView && +date >= +firstDateInView;
	        },

	        _fillRange: function(start, end) {
	            var that = this;
	            var daysDifference;

	            that._selectDates = [];
	            daysDifference = daysBetweenTwoDates(start, end);
	            addDaysToArray(that._selectDates, daysDifference, start, that.options.disableDates);
	        },

	        _selectRange: function(start, end) {
	            var that = this;
	            var current;

	            if (+end < +start) {
	                current = end;
	                end = start;
	                start = current;
	            }

	            that._fillRange(start, end);
	            that._visualizeSelectedDatesInView();
	        },

	        _header: function() {
	            var that = this;
	            var element = that.element;
	            var buttons;
	            var header = element.find(".k-calendar-header");

	            if (!header.length) {
	                header = $('<div class="k-calendar-header">' +
	                    '<a href="#" role="button" class="k-button k-title" aria-live="assertive" aria-atomic="true"></a>' +
	                    '<span class="k-calendar-nav">' +
	                        '<a href="#" role="button" class="k-button k-button-icon k-prev-view" ' + ARIA_LABEL + '="Previous"><span class="k-icon k-i-arrow-60-left"></span></a>' +
	                        '<a href="#" role="button" class="k-button k-button-icon k-next-view" ' + ARIA_LABEL + '="Next"><span class="k-icon k-i-arrow-60-right"></span></a>' +
	                    '</span>' +
	                '</div>').prependTo(element);
	            }

	            that.header = header;

	            header.on(MOUSEENTER + ns + " " + MOUSELEAVE_NS + " " + FOCUS + ns + " " + BLUR + ns, ".k-button", mousetoggle).on("click", function() { return false; })
	                .on(CLICK + ns, ".k-button.k-title", function() { that.navigateUp(); that._focusCell(that._cellByDate(that._current), true); that.trigger(NAVIGATE); })
	                .on(CLICK + ns, ".k-button.k-prev-view", function(e) { e.preventDefault(); that.navigateToPast(); that.trigger(NAVIGATE); })
	                .on(CLICK + ns, ".k-button.k-next-view", function(e) { e.preventDefault(); that.navigateToFuture(); that.trigger(NAVIGATE); });

	            buttons = header.find(".k-button");

	            that._title = buttons.filter(".k-title");
	            that._navContainer= header.find(".k-calendar-nav");
	            that[PREVARROW] = buttons.filter(".k-prev-view");
	            that[NEXTARROW] = buttons.filter(".k-next-view");
	        },

	        _wrapper: function() {
	            this.tablesWrapper = $('<div class="k-calendar-view" />').insertAfter(this.element[0].firstChild);
	        },

	        _templates: function() {
	            var that = this;
	            var options = that.options;
	            var month = options.month;
	            var content = month.content;
	            var weekNumber = month.weekNumber;
	            var empty = month.empty;

	            that.month = {
	                content: template('<td#=data.cssClass# role="gridcell"><a tabindex="-1" class="k-link#=data.linkClass#" href="#=data.url#" ' + kendo.attr(VALUE) + '="#=data.dateString#" title="#=data.title#">' + (content || "#=data.value#") + '</a></td>', { useWithBlock: !!content }),
	                empty: template('<td role="gridcell"' + (empty ? '>' : ' class="k-out-of-range">') + (empty || "<a class='k-link'></a>") + "</td>", { useWithBlock: !!empty }),
	                weekNumber: template('<td class="k-alt">' + (weekNumber || "#= data.weekNumber #") + "</td>", { useWithBlock: !!weekNumber })
	            };
	        },

	        _footer: function() {
	            var that = this;
	            var options = that.options;
	            var template = options.footer !== false ? kendo.template(that.options.footer || '#= kendo.toString(data,"D","' + options.culture +'") #', { useWithBlock: false }) : null;
	            var today = getToday();
	            var element = that.element;
	            var footer = element.find(".k-footer");

	            if (!template) {
	                that._toggle(false);
	                footer.hide();
	                return;
	            }

	            if (!footer[0]) {
	                footer = $('<div class="k-footer"><a href="#" class="k-link k-nav-today"></a></div>').appendTo(element);
	            }

	            that._today = footer.show()
	                .find(".k-link")
	                .html(template(today))
	                .attr("title", kendo.toString(today, "D", that.options.culture));

	            that._toggle();
	        },

	        _navigate: function(arrow, modifier, preventFocus) {
	            var that = this;
	            var index = that._index + 1;
	            var currentValue = new DATE(+that._current);
	            var originaValue = new DATE(+that._current);
	            var offset;

	            arrow = that[arrow];

	            offset = that._cellByDate(currentValue).closest("table").index();

	            if (modifier > 0) {
	                offset = 1 - offset;
	            } else {
	                offset = offset + 1;
	            }

	            if (!arrow || !arrow.hasClass(DISABLED)) {
	                if (index > 3) {
	                    currentValue.setFullYear(currentValue.getFullYear() + 100 * (modifier * offset));
	                } else {
	                    calendar.views[index].setDate(currentValue, (modifier * offset));
	                }

	                that.navigate(currentValue);

	                if (that._dateInViews(originaValue)) {
	                    that._focusCell(that._cellByDate(originaValue), !preventFocus);
	                    that._current = originaValue;
	                } else {
	                    if (index > 3) {
	                        originaValue.setFullYear(originaValue.getFullYear() + 100 * modifier);
	                    } else {
	                        calendar.views[index].setDate(originaValue, modifier);
	                    }
	                    that._focusCell(that._cellByDate(originaValue), !preventFocus);
	                    that._current = originaValue;
	                }
	            }
	        },

	        _toggle: function(toggle) {
	            var that = this;
	            var options = that.options;
	            var isTodayDisabled = options.selectable !== "range" && that.options.disableDates(getToday());
	            var link = that._today;

	            if (toggle === undefined) {
	                toggle = isInRange(getToday(), options.min, options.max);
	            }

	            if (link) {
	                link.off(CLICK + ns);

	                if (toggle && !isTodayDisabled) {
	                    link.addClass(TODAY)
	                    .removeClass(DISABLED)
	                    .on(CLICK + ns, proxy(that._todayClick, that));
	                } else {
	                    link.removeClass(TODAY)
	                    .addClass(DISABLED)
	                    .on(CLICK + ns, function prevent (e) {
	                        e.preventDefault();
	                    });
	                }
	            }
	        },

	        _click: function(link, preventFocus) {
	            var that = this;
	            var options = that.options;
	            var currentValue = new Date(+that._current);
	            var value = toDateObject(link);

	            kendo.date.adjustDST(value, 0);

	            that._currentView.setDate(currentValue, value);
	            that._current = value;

	            if (that._currentView.name !== options.depth) {
	                that.navigateDown(calendar.restrictValue(currentValue, options.min, options.max));
	                that._focusCell(that._cellByDate(that._current), !preventFocus);
	                that.trigger(NAVIGATE);
	            } else {
	                that._focusCell(link.closest("td"), !preventFocus);
	            }
	        },

	        _blur: function() {
	            var that = this;

	            if (that._cell) {
	                that._cell.removeClass(FOCUSED);
	            }
	        },

	        _focus: function(e) {
	            var that = this;
	            var table = $(e.currentTarget);
	            var cell = that._cell;

	            if (!cell || !$.contains(table[0], cell[0])) {
	                cell = table.find(CELLSELECTORVALID + ":first");
	            }

	            that._focusCell(cell);
	        },

	        _focusCell: function(cell, focusTable) {
	            var that = this;
	            var cellId = that._cellID;
	            var table = cell.closest("table");

	            if (that._cell && that._cell.length) {
	                that._cell[0].removeAttribute(ARIA_SELECTED);
	                that._cell[0].removeAttribute(ARIA_LABEL);
	                that._cell.removeClass(FOCUSED);
	                that._cell[0].removeAttribute(ID);
	                that._cell.closest("table")[0].removeAttribute("aria-activedescendant");
	            }

	            that._cell = cell;

	            if (focusTable) {
	                table.trigger("focus");
	            }

	            if (cellId) {
	                cell.attr(ID, cellId);
	                table.attr("aria-activedescendant", cellId);
	            }

	            cell.attr(ARIA_SELECTED, true).addClass(FOCUSED);

	            if (cell.length && that._currentView.name == "month") {
	                that._current = toDateObject(cell.find("a"));
	            }
	        },

	        _todayClick: function(e) {
	            var that = this;
	            var disabled = that.options.disableDates;
	            var today = getToday();
	            var navigate = false;

	            e.preventDefault();

	            if (disabled(today)) {
	                return;
	            }

	            that._value = today;

	            if (that.options.selectable === "multiple") {
	                that._selectDates = [today];
	            }

	            if (that.options.selectable === "range") {
	                that.rangeSelectable.clear(true);
	                that._range = { start: today, end: null };
	            }

	            if (that._currentView.name != "month" || !that._dateInViews(today)) {
	                navigate = true;
	            }

	            that.navigate(today, that.options.depth);

	            if (that.options.selectable === "single") {
	                that.selectable._lastActive = null;
	            }

	            if (navigate) {
	                that.trigger(NAVIGATE);
	            }

	            that.trigger(CHANGE);
	        },

	        _validateValue: function(value) {
	            var that = this;
	            var options = that.options;
	            var min = options.min;
	            var max = options.max;

	            value = kendo.parseDate(value, options.format, options.culture);

	            if (value !== null) {
	                value = new DATE(+value);

	                if (!isInRange(value, min, max)) {
	                    value = null;
	                }
	            }

	            if (value === null || !that.options.disableDates(new Date(+value))) {
	                that._value = value;
	            } else if (that._value === undefined) {
	                that._value = null;
	            }

	            return that._value;
	        },

	        clearSelection: function () {
	            var that = this;

	            if (that.selectable) {
	                that.element.find(DOT+SELECTED).removeClass(SELECTED);
	            }

	            if (that.rangeSelectable) {
	                that.rangeSelectable.clear(true);
	            }
	        },

	        _restoreSelection: function() {
	            var that = this;
	            var range;
	            var selectable = that.options.selectable;

	            if (that._currentView.name !== that.options.depth) {
	                return;
	            }

	            that._preventChange = true;

	            if (selectable === "range") {
	                range = that.selectRange();

	                if (!range || !range.start) {
	                    that._preventChange = false;
	                    return;
	                }

	                that.selectRange(range);
	            }

	            if (selectable === "single" && that.value()) {
	                that.selectable.value(that._cellByDate(that.value()));
	            }

	            if (selectable === "multiple") {
	                that._visualizeSelectedDatesInView();
	            }

	            that._preventChange = false;
	        },

	        value: function(value) {
	            var that = this;
	            var cell;

	            if (value === undefined) {
	                return that._value;
	            }

	            value = that._validateValue(value);

	            that.clearSelection();

	            if (value && !that._dateInViews(value)) {
	                that.navigate(value);
	            }

	            if (value !== null && that._currentView.name === MONTH) {
	                cell = that._cellByDate(value);

	                if (that.selectable) {
	                    that.selectable.value(cell);
	                }

	                if (that.rangeSelectable) {
	                    that.rangeSelectable.start(cell);
	                    that.rangeSelectable._lastActive = cell;
	                }
	            }
	        },

	        selectDates: function(dates) {
	            var that = this;
	            var validSelectedDates;
	            var datesUnique;

	            if(dates === undefined) {
	                return that._selectDates;
	            }

	            datesUnique = dates
	                .map(function (date) { return date.getTime(); })
	                .filter(function (date, position, array) {
	                    return array.indexOf(date) === position;
	                })
	                .map(function (time) { return new Date(time); });

	            validSelectedDates = $.grep(datesUnique, function(value) {
	                if(value) {
	                    return +that._validateValue(new Date(value.setHours(0, 0, 0, 0))) === +value;
	                }
	            });
	            that._selectDates = validSelectedDates.length > 0 ? validSelectedDates : (datesUnique.length === 0 ? datesUnique : that._selectDates);
	            that._visualizeSelectedDatesInView();
	        },

	        selectRange: function(range) {
	            var that = this;
	            var startInRange;
	            var endInRange;
	            var visibleRange;

	            if (range === undefined) {
	                return that._range;
	            }

	            that._range = range;

	            if (!range.start) {
	                return;
	            }

	            visibleRange = that._visibleRange();

	            startInRange = that._dateInViews(range.start);
	            endInRange = range.end && that._dateInViews(range.end);

	            if (!startInRange && endInRange) {
	                that.rangeSelectable.selectTo(that._cellByDate(range.end));
	            }

	            if (startInRange && endInRange) {
	                that.rangeSelectable.range(that._cellByDate(range.start), that._cellByDate(range.end));
	            }

	            if (range.end && startInRange && !endInRange) {
	                that.rangeSelectable.selectFrom(that._cellByDate(range.start));
	            }

	            if (!range.end && startInRange) {
	                that.rangeSelectable.start(that._cellByDate(range.start));
	            }

	            if (+visibleRange.start > +range.start && +visibleRange.end < +range.end) {
	                that.rangeSelectable.mid(that.element.find(CELLSELECTORVALID));
	            }
	        }
	    });

	    kendo.ui.plugin(MultiViewCalendar);

	    function mousetoggle(e) {
	        var disabled = $(this).hasClass("k-state-disabled");

	        if (!disabled) {
	            $(this).toggleClass(HOVER, MOUSEENTER.indexOf(e.type) > -1 || e.type == FOCUS);
	        }
	    }

	    function addDaysToArray(array, numberOfDays, fromDate, disableDates) {
	        for(var i = 0; i <= numberOfDays; i++) {
	            var nextDay = new Date(fromDate.getTime());
	            nextDay = new Date(nextDay.setDate(nextDay.getDate() + i));
	            if(!disableDates(nextDay)) {
	                array.push(nextDay);
	            }
	        }
	    }

	    function daysBetweenTwoDates(startDate, endDate) {
	        if(+endDate < +startDate) {
	            var temp = +startDate;
	            calendar.views[0].setDate(startDate, endDate);
	            calendar.views[0].setDate(endDate, new Date(temp));
	        }
	        var fromDateUTC = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
	        var endDateUTC = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

	        return Math.ceil((+endDateUTC - +fromDateUTC) / kendo.date.MS_PER_DAY);
	    }

	    function shiftDate(value, dimension, numberOfViews) {
	        var current;
	        if (dimension === "month") {
	            current = new DATE(value.getFullYear(), value.getMonth() + numberOfViews, value.getDate());
	            current.setFullYear(value.getFullYear());
	            if (Math.abs(current.getMonth() - value.getMonth()) > numberOfViews || numberOfViews > 10) {
	                current.setMonth(value.getMonth() + numberOfViews);
	                current = calendar.views[0].last(current);
	            }
	            return current;
	        } else if (dimension === "year") {
	            current = new DATE(1, value.getMonth(), value.getDate());
	            current.setFullYear(value.getFullYear() + numberOfViews);
	            if (Math.abs(current.getFullYear() - value.getFullYear()) > numberOfViews) {
	                current = new DATE(1, value.getMonth(), 1);
	                current.setFullYear(value.getFullYear() + numberOfViews);
	                current = calendar.views[1].last(current);
	            }
	            return current;
	        } else if (dimension === "decade") {
	            current = new DATE(1, value.getMonth(), value.getDate());
	            current.setFullYear(value.getFullYear() + 10*numberOfViews);
	            if (Math.abs(current.getFullYear() - value.getFullYear()) > 10*numberOfViews) {
	                current = new DATE(1, value.getMonth(), 1);
	                current.setFullYear(value.getFullYear() + 10*numberOfViews);
	                current = calendar.views[2].last(current);
	            }
	            return current;
	        } else if (dimension === "century") {
	            current = new DATE(1, value.getMonth(), value.getDate());
	            current.setFullYear(value.getFullYear() + 100*numberOfViews);
	            if (Math.abs(current.getFullYear() - value.getFullYear()) > 100*numberOfViews) {
	                current = new DATE(1, value.getMonth(), 1);
	                current.setFullYear(value.getFullYear() + 100*numberOfViews);
	                current = calendar.views[3].last(current);
	            }
	            return current;
	        }
	    }

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "j74h":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(917);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(918) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function() {

	(function ($, undefined) {
	    // Imports ================================================================
	    var kendo = window.kendo,

	        dataviz = kendo.dataviz,
	        deepExtend = kendo.deepExtend,
	        defined = kendo.drawing.util.defined,

	        Extent = dataviz.map.Extent,
	        Location = dataviz.map.Location,
	        TileLayer = dataviz.map.layers.TileLayer,
	        TileView = dataviz.map.layers.TileView;

	    // Bing tile layer =============================================================
	    var BingLayer = TileLayer.extend({
	        init: function(map, options) {
	            this.options.baseUrl =
	                this._scheme() +
	                "://dev.virtualearth.net/REST/v1/Imagery/Metadata/";

	            TileLayer.fn.init.call(this, map, options);

	            this._onMetadata = $.proxy(this._onMetadata, this);
	            this._fetchMetadata();
	        },

	        options: {
	            imagerySet: "road"
	        },

	        _fetchMetadata: function() {
	            var options = this.options;

	            if (!options.key) {
	                throw new Error("Bing tile layer: API key is required");
	            }

	            $.ajax({
	                url: options.baseUrl + options.imagerySet,
	                data: {
	                    output: "json",
	                    include: "ImageryProviders",
	                    key: options.key,
	                    uriScheme: this._scheme()
	                },
	                type: "get",
	                dataType: "jsonp",
	                jsonp: "jsonp",
	                success: this._onMetadata
	            });
	        },

	        _scheme: function(proto) {
	            proto = proto || window.location.protocol;
	            return proto.replace(":", "") === "https" ? "https" : "http";
	        },

	        _onMetadata: function(data) {
	            if (data && data.resourceSets.length) {
	                var resource = this.resource = data.resourceSets[0].resources[0];

	                deepExtend(this._view.options, {
	                    urlTemplate: resource.imageUrl
	                        .replace("{subdomain}", "#= subdomain #")
	                        .replace("{quadkey}", "#= quadkey #")
	                        .replace("{culture}", "#= culture #"),
	                    subdomains: resource.imageUrlSubdomains
	                });

	                var options = this.options;
	                if (!defined(options.minZoom)) {
	                    options.minZoom = resource.zoomMin;
	                }
	                if (!defined(options.maxZoom)) {
	                    options.maxZoom = resource.zoomMax;
	                }

	                this._addAttribution();

	                if (this.element.css("display") !== "none") {
	                    this._reset();
	                }
	            }
	        },

	        _viewType: function() {
	            return BingView;
	        },

	        _addAttribution: function() {
	            var attr = this.map.attribution;
	            if (attr) {
	                var items = this.resource.imageryProviders;
	                if (items) {
	                    for (var i = 0; i < items.length; i++) {
	                        var item = items[i];
	                        for (var y = 0; y < item.coverageAreas.length; y++) {
	                            var area = item.coverageAreas[y];
	                            attr.add({
	                                text: item.attribution,
	                                minZoom: area.zoomMin,
	                                maxZoom: area.zoomMax,
	                                extent: new Extent(
	                                    new Location(area.bbox[2], area.bbox[1]),
	                                    new Location(area.bbox[0], area.bbox[3])
	                                )
	                            });
	                        }
	                    }
	                }
	            }
	        },

	        imagerySet: function(value) {
	            if (value) {
	                this.options.imagerySet = value;
	                this.map.attribution.clear();
	                this._fetchMetadata();
	            } else {
	                return this.options.imagerySet;
	            }
	        }
	    });

	    var BingView = TileView.extend({
	        options: {
	            culture: "en-US"
	        },

	        tileOptions: function(currentIndex) {
	            var options = TileView.fn.tileOptions.call(this, currentIndex);

	            options.culture = this.options.culture;
	            options.quadkey = this.tileQuadKey(this.wrapIndex(currentIndex));

	            return options;
	        },

	        tileQuadKey: function(index) {
	            var quadKey = "",
	                digit, mask, i;

	            for (i = this._zoom; i > 0; i--) {
	                digit = 0;
	                mask = 1 << (i - 1);

	                if ((index.x & mask) !== 0) {
	                    digit++;
	                }

	                if ((index.y & mask) !== 0) {
	                    digit += 2;
	                }

	                quadKey += digit;
	            }

	            return quadKey;
	        }
	    });

	    // Exports ================================================================
	    deepExtend(dataviz, {
	        map: {
	            layers: {
	                bing: BingLayer,
	                BingLayer: BingLayer,
	                BingView: BingView
	            }
	        }
	    });

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 918:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("uC7k");

/***/ })

/******/ });

/***/ }),

/***/ "jBxA":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1324);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Dz7c");

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1324:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1104), __webpack_require__(1109) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.scroller",
	    name: "Scroller",
	    category: "mobile",
	    description: "The Kendo Mobile Scroller widget enables touch friendly kinetic scrolling for the contents of a given DOM element.",
	    depends: [ "fx", "draganddrop" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        mobile = kendo.mobile,
	        fx = kendo.effects,
	        ui = mobile.ui,
	        proxy = $.proxy,
	        extend = $.extend,
	        Widget = ui.Widget,
	        Class = kendo.Class,
	        Movable = kendo.ui.Movable,
	        Pane = kendo.ui.Pane,
	        PaneDimensions = kendo.ui.PaneDimensions,
	        Transition = fx.Transition,
	        Animation = fx.Animation,
	        abs = Math.abs,
	        SNAPBACK_DURATION = 500,
	        SCROLLBAR_OPACITY = 0.7,
	        FRICTION = 0.96,
	        VELOCITY_MULTIPLIER = 10,
	        MAX_VELOCITY = 55,
	        OUT_OF_BOUNDS_FRICTION = 0.5,
	        ANIMATED_SCROLLER_PRECISION = 5,
	        RELEASECLASS = "km-scroller-release",
	        REFRESHCLASS = "km-scroller-refresh",
	        PULL = "pull",
	        CHANGE = "change",
	        RESIZE = "resize",
	        SCROLL = "scroll",
	        MOUSE_WHEEL_ID = 2;

	    var ZoomSnapBack = Animation.extend({
	        init: function(options) {
	            var that = this;
	            Animation.fn.init.call(that);
	            extend(that, options);

	            that.userEvents.bind("gestureend", proxy(that.start, that));
	            that.tapCapture.bind("press", proxy(that.cancel, that));
	        },

	        enabled: function() {
	          return this.movable.scale < this.dimensions.minScale;
	        },

	        done: function() {
	            return this.dimensions.minScale - this.movable.scale < 0.01;
	        },

	        tick: function() {
	            var movable = this.movable;
	            movable.scaleWith(1.1);
	            this.dimensions.rescale(movable.scale);
	        },

	        onEnd: function() {
	            var movable = this.movable;
	            movable.scaleTo(this.dimensions.minScale);
	            this.dimensions.rescale(movable.scale);
	        }
	    });

	    var DragInertia = Animation.extend({
	        init: function(options) {
	            var that = this;

	            Animation.fn.init.call(that);

	            extend(that, options, {
	                transition: new Transition({
	                    axis: options.axis,
	                    movable: options.movable,
	                    onEnd: function() { that._end(); }
	                })
	            });

	            that.tapCapture.bind("press", function() { that.cancel(); });
	            that.userEvents.bind("end", proxy(that.start, that));
	            that.userEvents.bind("gestureend", proxy(that.start, that));
	            that.userEvents.bind("tap", proxy(that.onEnd, that));
	        },

	        onCancel: function() {
	            this.transition.cancel();
	        },

	        freeze: function(location) {
	            var that = this;
	            that.cancel();
	            that._moveTo(location);
	        },

	        onEnd: function() {
	            var that = this;
	            if (that.paneAxis.outOfBounds()) {
	                that._snapBack();
	            } else {
	                that._end();
	            }
	        },

	        done: function() {
	            return abs(this.velocity) < 1;
	        },

	        start: function(e) {
	            var that = this,
	                velocity;

	            if (!that.dimension.enabled) { return; }

	            if (that.paneAxis.outOfBounds()) {
	                if(that.transition._started){
	                    that.transition.cancel();
	                    that.velocity = Math.min(e.touch[that.axis].velocity * that.velocityMultiplier, MAX_VELOCITY);

	                    Animation.fn.start.call(that);
	                }else{
	                    that._snapBack();
	                }
	            } else {
	                velocity = e.touch.id === MOUSE_WHEEL_ID ? 0 : e.touch[that.axis].velocity;
	                that.velocity = Math.max(Math.min(velocity * that.velocityMultiplier, MAX_VELOCITY), -MAX_VELOCITY);

	                that.tapCapture.captureNext();
	                Animation.fn.start.call(that);
	            }
	        },

	        tick: function() {
	            var that = this,
	                dimension = that.dimension,
	                friction = that.paneAxis.outOfBounds() ? OUT_OF_BOUNDS_FRICTION : that.friction,
	                delta = (that.velocity *= friction),
	                location = that.movable[that.axis] + delta;

	                if (!that.elastic && dimension.outOfBounds(location)) {
	                    location = Math.max(Math.min(location, dimension.max), dimension.min);
	                    that.velocity = 0;
	                }

	            that.movable.moveAxis(that.axis, location);
	        },

	        _end: function() {
	            this.tapCapture.cancelCapture();
	            this.end();
	        },

	        _snapBack: function() {
	            var that = this,
	                dimension = that.dimension,
	                snapBack = that.movable[that.axis] > dimension.max ? dimension.max : dimension.min;
	            that._moveTo(snapBack);
	        },

	        _moveTo: function(location) {
	            this.transition.moveTo({ location: location, duration: SNAPBACK_DURATION, ease: Transition.easeOutExpo });
	        }
	    });

	    var AnimatedScroller = Animation.extend({
	        init: function(options) {
	            var that = this;

	            kendo.effects.Animation.fn.init.call(this);

	            extend(that, options, {
	                origin: {},
	                destination: {},
	                offset: {}
	            });
	        },

	        tick: function() {
	            this._updateCoordinates();
	            this.moveTo(this.origin);
	        },

	        done: function() {
	            return abs(this.offset.y) < ANIMATED_SCROLLER_PRECISION && abs(this.offset.x) < ANIMATED_SCROLLER_PRECISION;
	        },

	        onEnd: function() {
	            this.moveTo(this.destination);
	            if (this.callback) {
	                this.callback.call();
	            }
	        },

	        setCoordinates: function(from, to) {
	            this.offset = {};
	            this.origin = from;
	            this.destination = to;
	        },

	        setCallback: function(callback) {
	            if (callback && kendo.isFunction(callback)) {
	                this.callback = callback;
	            } else {
	                callback = undefined;
	            }
	        },

	        _updateCoordinates: function() {
	            this.offset = {
	                x: (this.destination.x - this.origin.x) / 4,
	                y: (this.destination.y - this.origin.y) / 4
	            };

	            this.origin = {
	                y: this.origin.y + this.offset.y,
	                x: this.origin.x + this.offset.x
	            };
	        }
	    });

	    var ScrollBar = Class.extend({
	        init: function(options) {
	            var that = this,
	                horizontal = options.axis === "x",
	                element = $('<div class="km-touch-scrollbar km-' + (horizontal ? "horizontal" : "vertical") + '-scrollbar" />');

	            extend(that, options, {
	                element: element,
	                elementSize: 0,
	                movable: new Movable(element),
	                scrollMovable: options.movable,
	                alwaysVisible: options.alwaysVisible,
	                size: horizontal ? "width" : "height"
	            });

	            that.scrollMovable.bind(CHANGE, proxy(that.refresh, that));
	            that.container.append(element);
	            if (options.alwaysVisible) {
	                that.show();
	            }
	        },

	        refresh: function() {
	            var that = this,
	                axis = that.axis,
	                dimension = that.dimension,
	                paneSize = dimension.size,
	                scrollMovable = that.scrollMovable,
	                sizeRatio = paneSize / dimension.total,
	                position = Math.round(-scrollMovable[axis] * sizeRatio),
	                size = Math.round(paneSize * sizeRatio);

	                if (sizeRatio >= 1) {
	                    this.element.css("display", "none");
	                } else {
	                    this.element.css("display", "");
	                }

	                if (position + size > paneSize) {
	                    size = paneSize - position;
	                } else if (position < 0) {
	                    size += position;
	                    position = 0;
	                }

	            if (that.elementSize != size) {
	                that.element.css(that.size, size + "px");
	                that.elementSize = size;
	            }

	            that.movable.moveAxis(axis, position);
	        },

	        show: function() {
	            this.element.css({opacity: SCROLLBAR_OPACITY, visibility: "visible"});
	        },

	        hide: function() {
	            if (!this.alwaysVisible) {
	                this.element.css({opacity: 0});
	            }
	        }
	    });

	    var Scroller = Widget.extend({
	        init: function(element, options) {
	            var that = this;
	            Widget.fn.init.call(that, element, options);

	            element = that.element;

	            that._native = that.options.useNative && kendo.support.hasNativeScrolling;
	            if (that._native) {
	                element.addClass("km-native-scroller")
	                    .prepend('<div class="km-scroll-header"/>');

	                extend(that, {
	                    scrollElement: element,
	                    fixedContainer: element.children().first()
	                });

	                return;
	            }

	            element
	                .css("overflow", "hidden")
	                .addClass("km-scroll-wrapper")
	                .wrapInner('<div class="km-scroll-container"/>')
	                .prepend('<div class="km-scroll-header"/>');

	            var inner = element.children().eq(1),

	                tapCapture = new kendo.TapCapture(element),

	                movable = new Movable(inner),

	                dimensions = new PaneDimensions({
	                    element: inner,
	                    container: element,
	                    forcedEnabled: that.options.zoom
	                }),

	                avoidScrolling = this.options.avoidScrolling,

	                userEvents = new kendo.UserEvents(element, {
	                    touchAction: "pan-y",
	                    fastTap: true,
	                    allowSelection: true,
	                    preventDragEvent: true,
	                    captureUpIfMoved: true,
	                    multiTouch: that.options.zoom,
	                    supportDoubleTap: that.options.supportDoubleTap,
	                    start: function(e) {
	                        dimensions.refresh();

	                        var velocityX = abs(e.x.velocity),
	                            velocityY = abs(e.y.velocity),
	                            horizontalSwipe  = velocityX * 2 >= velocityY,
	                            originatedFromFixedContainer = $.contains(that.fixedContainer[0], e.event.target),
	                            verticalSwipe = velocityY * 2 >= velocityX;


	                        if (!originatedFromFixedContainer && !avoidScrolling(e) && that.enabled && (dimensions.x.enabled && horizontalSwipe || dimensions.y.enabled && verticalSwipe)) {
	                            userEvents.capture();
	                        } else {
	                            userEvents.cancel();
	                        }
	                    }
	                }),

	                pane = new Pane({
	                    movable: movable,
	                    dimensions: dimensions,
	                    userEvents: userEvents,
	                    elastic: that.options.elastic
	                }),

	                zoomSnapBack = new ZoomSnapBack({
	                    movable: movable,
	                    dimensions: dimensions,
	                    userEvents: userEvents,
	                    tapCapture: tapCapture
	                }),

	                animatedScroller = new AnimatedScroller({
	                    moveTo: function(coordinates) {
	                        that.scrollTo(coordinates.x, coordinates.y);
	                    }
	                });

	            movable.bind(CHANGE, function() {
	                that.scrollTop = - movable.y;
	                that.scrollLeft = - movable.x;

	                that.trigger(SCROLL, {
	                    scrollTop: that.scrollTop,
	                    scrollLeft: that.scrollLeft
	                });
	            });

	            if (that.options.mousewheelScrolling) {
	                element.on("DOMMouseScroll mousewheel",  proxy(this, "_wheelScroll"));
	            }

	            extend(that, {
	                movable: movable,
	                dimensions: dimensions,
	                zoomSnapBack: zoomSnapBack,
	                animatedScroller: animatedScroller,
	                userEvents: userEvents,
	                pane: pane,
	                tapCapture: tapCapture,
	                pulled: false,
	                enabled: true,
	                scrollElement: inner,
	                scrollTop: 0,
	                scrollLeft: 0,
	                fixedContainer: element.children().first()
	            });

	            that._initAxis("x");
	            that._initAxis("y");

	            // build closure
	            that._wheelEnd = function() {
	                that._wheel = false;
	                that.userEvents.end(0, that._wheelY);
	            };

	            dimensions.refresh();

	            if (that.options.pullToRefresh) {
	                that._initPullToRefresh();
	            }
	        },

	        _wheelScroll: function(e) {
	            if (e.ctrlKey) {
	                return;
	            }

	            if (!this._wheel) {
	                this._wheel = true;
	                this._wheelY = 0;
	                this.userEvents.press(0, this._wheelY);
	            }

	            clearTimeout(this._wheelTimeout);
	            this._wheelTimeout = setTimeout(this._wheelEnd, 50);

	            var delta = kendo.wheelDeltaY(e);

	            if (delta) {
	                this._wheelY += delta;
	                this.userEvents.move(0, this._wheelY);
	            }

	            e.preventDefault();
	        },

	        makeVirtual: function() {
	            this.dimensions.y.makeVirtual();
	        },

	        virtualSize: function(min, max) {
	            this.dimensions.y.virtualSize(min, max);
	        },

	        height: function() {
	            return this.dimensions.y.size;
	        },

	        scrollHeight: function() {
	            return this.scrollElement[0].scrollHeight;
	        },

	        scrollWidth: function() {
	            return this.scrollElement[0].scrollWidth;
	        },

	        options: {
	            name: "Scroller",
	            zoom: false,
	            pullOffset: 140,
	            visibleScrollHints: false,
	            elastic: true,
	            useNative: false,
	            mousewheelScrolling: true,
	            avoidScrolling: function() { return false; },
	            pullToRefresh: false,
	            messages: {
	                pullTemplate: "Pull to refresh",
	                releaseTemplate: "Release to refresh",
	                refreshTemplate: "Refreshing"
	            }
	        },

	        events: [
	            PULL,
	            SCROLL,
	            RESIZE
	        ],

	        _resize: function() {
	            if (!this._native) {
	                this.contentResized();
	            }
	        },

	        setOptions: function(options) {
	            var that = this;
	            Widget.fn.setOptions.call(that, options);
	            if (options.pullToRefresh) {
	                that._initPullToRefresh();
	            }
	        },

	        reset: function() {
	            if (this._native) {
	                this.scrollElement.scrollTop(0);
	            } else {
	                this.movable.moveTo({x: 0, y: 0});
	                this._scale(1);
	            }
	        },

	        contentResized: function() {
	            this.dimensions.refresh();
	            if (this.pane.x.outOfBounds()) {
	                this.movable.moveAxis("x", this.dimensions.x.min);
	            }

	            if (this.pane.y.outOfBounds()) {
	                this.movable.moveAxis("y", this.dimensions.y.min);
	            }
	        },

	        zoomOut: function() {
	            var dimensions = this.dimensions;
	            dimensions.refresh();
	            this._scale(dimensions.fitScale);
	            this.movable.moveTo(dimensions.centerCoordinates());
	        },

	        enable: function() {
	            this.enabled = true;
	        },

	        disable: function() {
	            this.enabled = false;
	        },

	        scrollTo: function(x, y) {
	            if (this._native) {
	                kendo.scrollLeft(this.scrollElement, abs(x));
	                this.scrollElement.scrollTop(abs(y));
	            } else {
	                this.dimensions.refresh();
	                this.movable.moveTo({x: x, y: y});
	            }
	        },

	        animatedScrollTo: function(x, y, callback) {
	            var from,
	                to;

	            if(this._native) {
	                this.scrollTo(x, y);
	            } else {
	                from = { x: this.movable.x, y: this.movable.y };
	                to = { x: x, y: y };

	                this.animatedScroller.setCoordinates(from, to);
	                this.animatedScroller.setCallback(callback);
	                this.animatedScroller.start();
	            }
	        },

	        pullHandled: function() {
	            var that = this;
	            that.refreshHint.removeClass(REFRESHCLASS);
	            that.hintContainer.html(that.pullTemplate({}));
	            that.yinertia.onEnd();
	            that.xinertia.onEnd();
	            that.userEvents.cancel();
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            if (this.userEvents) {
	                this.userEvents.destroy();
	            }
	        },

	        _scale: function(scale) {
	            this.dimensions.rescale(scale);
	            this.movable.scaleTo(scale);
	        },

	        _initPullToRefresh: function() {
	            var that = this;

	            that.dimensions.y.forceEnabled();
	            that.pullTemplate = kendo.template(that.options.messages.pullTemplate);
	            that.releaseTemplate = kendo.template(that.options.messages.releaseTemplate);
	            that.refreshTemplate = kendo.template(that.options.messages.refreshTemplate);

	            that.scrollElement.prepend('<span class="km-scroller-pull"><span class="km-icon"></span><span class="km-loading-left"></span><span class="km-loading-right"></span><span class="km-template">' + that.pullTemplate({}) + '</span></span>');
	            that.refreshHint = that.scrollElement.children().first();
	            that.hintContainer = that.refreshHint.children(".km-template");

	            that.pane.y.bind("change", proxy(that._paneChange, that));
	            that.userEvents.bind("end", proxy(that._dragEnd, that));
	        },

	        _dragEnd: function() {
	            var that = this;

	            if(!that.pulled) {
	                return;
	            }

	            that.pulled = false;
	            that.refreshHint.removeClass(RELEASECLASS).addClass(REFRESHCLASS);
	            that.hintContainer.html(that.refreshTemplate({}));
	            that.yinertia.freeze(that.options.pullOffset / 2);
	            that.trigger("pull");
	        },

	        _paneChange: function() {
	            var that = this;

	            if (that.movable.y / OUT_OF_BOUNDS_FRICTION > that.options.pullOffset) {
	                if (!that.pulled) {
	                    that.pulled = true;
	                    that.refreshHint.removeClass(REFRESHCLASS).addClass(RELEASECLASS);
	                    that.hintContainer.html(that.releaseTemplate({}));
	                }
	            } else if (that.pulled) {
	                that.pulled = false;
	                that.refreshHint.removeClass(RELEASECLASS);
	                that.hintContainer.html(that.pullTemplate({}));
	            }
	        },

	        _initAxis: function(axis) {
	            var that = this,
	                movable = that.movable,
	                dimension = that.dimensions[axis],
	                tapCapture = that.tapCapture,
	                paneAxis = that.pane[axis],
	                scrollBar = new ScrollBar({
	                    axis: axis,
	                    movable: movable,
	                    dimension: dimension,
	                    container: that.element,
	                    alwaysVisible: that.options.visibleScrollHints
	                });

	            dimension.bind(CHANGE, function() {
	                scrollBar.refresh();
	            });

	            paneAxis.bind(CHANGE, function() {
	                scrollBar.show();
	            });

	            that[axis + "inertia"] = new DragInertia({
	                axis: axis,
	                paneAxis: paneAxis,
	                movable: movable,
	                tapCapture: tapCapture,
	                userEvents: that.userEvents,
	                dimension: dimension,
	                elastic: that.options.elastic,
	                friction: that.options.friction || FRICTION,
	                velocityMultiplier: that.options.velocityMultiplier || VELOCITY_MULTIPLIER,
	                end: function() {
	                    scrollBar.hide();
	                    that.trigger("scrollEnd", {
	                        axis: axis,
	                        scrollTop: that.scrollTop,
	                        scrollLeft: that.scrollLeft
	                    });
	                }
	            });
	        }
	    });

	    ui.plugin(Scroller);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "jJge":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var context_1 = __webpack_require__("RQ1/");
var HorizontalDragService = (function () {
    function HorizontalDragService() {
    }
    HorizontalDragService.prototype.addDragHandling = function (params) {
        var _this = this;
        params.eDraggableElement.addEventListener('mousedown', function (startEvent) {
            var myDocument = _this.gridOptionsWrapper.getDocument();
            var eBody = myDocument.querySelector('body');
            new DragInstance(params, startEvent, eBody);
        });
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], HorizontalDragService.prototype, "gridOptionsWrapper", void 0);
    HorizontalDragService = __decorate([
        context_1.Bean('horizontalDragService')
    ], HorizontalDragService);
    return HorizontalDragService;
}());
exports.HorizontalDragService = HorizontalDragService;
var DragInstance = (function () {
    function DragInstance(params, startEvent, eBody) {
        this.mouseMove = this.onMouseMove.bind(this);
        this.mouseUp = this.onMouseUp.bind(this);
        this.mouseLeave = this.onMouseLeave.bind(this);
        this.lastDelta = 0;
        this.params = params;
        this.eDragParent = eBody;
        this.dragStartX = startEvent.clientX;
        this.startEvent = startEvent;
        this.eDragParent.addEventListener('mousemove', this.mouseMove);
        this.eDragParent.addEventListener('mouseup', this.mouseUp);
        this.eDragParent.addEventListener('mouseleave', this.mouseLeave);
        this.draggingStarted = false;
        var startAfterPixelsExist = typeof params.startAfterPixels === 'number' && params.startAfterPixels > 0;
        if (!startAfterPixelsExist) {
            this.startDragging();
        }
    }
    DragInstance.prototype.startDragging = function () {
        this.draggingStarted = true;
        this.oldBodyCursor = this.params.eBody.style.cursor;
        this.oldParentCursor = this.eDragParent.style.cursor;
        this.oldMsUserSelect = this.eDragParent.style.msUserSelect;
        this.oldWebkitUserSelect = this.eDragParent.style.webkitUserSelect;
        // change the body cursor, so when drag moves out of the drag bar, the cursor is still 'resize' (or 'move'
        this.params.eBody.style.cursor = this.params.cursor;
        // same for outside the grid, we want to keep the resize (or move) cursor
        this.eDragParent.style.cursor = this.params.cursor;
        // we don't want text selection outside the grid (otherwise it looks weird as text highlights when we move)
        this.eDragParent.style.msUserSelect = 'none';
        this.eDragParent.style.webkitUserSelect = 'none';
        this.params.onDragStart(this.startEvent);
    };
    DragInstance.prototype.onMouseMove = function (moveEvent) {
        var newX = moveEvent.clientX;
        this.lastDelta = newX - this.dragStartX;
        if (!this.draggingStarted) {
            var dragExceededStartAfterPixels = Math.abs(this.lastDelta) >= this.params.startAfterPixels;
            if (dragExceededStartAfterPixels) {
                this.startDragging();
            }
        }
        if (this.draggingStarted) {
            this.params.onDragging(this.lastDelta, false);
        }
    };
    DragInstance.prototype.onMouseUp = function () {
        this.stopDragging();
    };
    DragInstance.prototype.onMouseLeave = function () {
        this.stopDragging();
    };
    DragInstance.prototype.stopDragging = function () {
        // reset cursor back to original cursor, if they were changed in the first place
        if (this.draggingStarted) {
            this.params.eBody.style.cursor = this.oldBodyCursor;
            this.eDragParent.style.cursor = this.oldParentCursor;
            this.eDragParent.style.msUserSelect = this.oldMsUserSelect;
            this.eDragParent.style.webkitUserSelect = this.oldWebkitUserSelect;
            this.params.onDragging(this.lastDelta, true);
        }
        // always remove the listeners, as these are always added
        this.eDragParent.removeEventListener('mousemove', this.mouseMove);
        this.eDragParent.removeEventListener('mouseup', this.mouseUp);
        this.eDragParent.removeEventListener('mouseleave', this.mouseLeave);
    };
    return DragInstance;
}());


/***/ }),

/***/ "jK1P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var main_2 = __webpack_require__("F6Mk");
var ag_grid_1 = __webpack_require__("F6Mk");
var ag_grid_2 = __webpack_require__("F6Mk");
// we cannot have 'null' as a key in a JavaScript map,
// it needs to be a string. so we use this string for
// storing null values.
var NULL_VALUE = '___NULL___';
var SetFilterModelValuesType;
(function (SetFilterModelValuesType) {
    SetFilterModelValuesType[SetFilterModelValuesType["PROVIDED_LIST"] = 0] = "PROVIDED_LIST";
    SetFilterModelValuesType[SetFilterModelValuesType["PROVIDED_CB"] = 1] = "PROVIDED_CB";
    SetFilterModelValuesType[SetFilterModelValuesType["NOT_PROVIDED"] = 2] = "NOT_PROVIDED";
})(SetFilterModelValuesType = exports.SetFilterModelValuesType || (exports.SetFilterModelValuesType = {}));
var SetFilterModel = (function () {
    function SetFilterModel(colDef, rowModel, valueGetter, doesRowPassOtherFilters, suppressSorting, modelUpdatedFunc, isLoadingFunc) {
        this.suppressSorting = suppressSorting;
        this.colDef = colDef;
        this.valueGetter = valueGetter;
        this.doesRowPassOtherFilters = doesRowPassOtherFilters;
        this.modelUpdatedFunc = modelUpdatedFunc;
        this.isLoadingFunc = isLoadingFunc;
        if (rowModel.getType() === ag_grid_1.Constants.ROW_MODEL_TYPE_IN_MEMORY) {
            this.inMemoryRowModel = rowModel;
        }
        this.filterParams = this.colDef.filterParams ? this.colDef.filterParams : {};
        if (main_1.Utils.exists(this.filterParams) && main_1.Utils.exists(this.filterParams.values)) {
            this.valuesType = Array.isArray(this.filterParams.values) ?
                SetFilterModelValuesType.PROVIDED_LIST :
                SetFilterModelValuesType.PROVIDED_CB;
            this.showingAvailableOnly = this.filterParams.suppressRemoveEntries !== true;
        }
        else {
            this.valuesType = SetFilterModelValuesType.NOT_PROVIDED;
            this.showingAvailableOnly = true;
        }
        this.createAllUniqueValues();
        this.createAvailableUniqueValues();
        // by default, no filter, so we display everything
        this.displayedValues = this.availableUniqueValues;
        this.miniFilter = null;
        // we use a map rather than an array for the selected values as the lookup
        // for a map is much faster than the lookup for an array, especially when
        // the length of the array is thousands of records long
        this.selectedValuesMap = {};
        this.selectEverything();
        this.formatter = this.filterParams.textFormatter ? this.filterParams.textFormatter : main_2.TextFilter.DEFAULT_FORMATTER;
    }
    // if keepSelection not set will always select all filters
    // if keepSelection set will keep current state of selected filters
    //    unless selectAll chosen in which case will select all
    SetFilterModel.prototype.refreshAfterNewRowsLoaded = function (keepSelection, isSelectAll) {
        this.createAllUniqueValues();
        this.refreshSelection(keepSelection, isSelectAll);
    };
    // if keepSelection not set will always select all filters
    // if keepSelection set will keep current state of selected filters
    //    unless selectAll chosen in which case will select all
    SetFilterModel.prototype.refreshValues = function (valuesToUse, keepSelection, isSelectAll) {
        this.setValues(valuesToUse);
        this.refreshSelection(keepSelection, isSelectAll);
    };
    SetFilterModel.prototype.refreshSelection = function (keepSelection, isSelectAll) {
        this.createAvailableUniqueValues();
        var oldModel = Object.keys(this.selectedValuesMap);
        this.selectedValuesMap = {};
        this.processMiniFilter();
        if (keepSelection) {
            this.setModel(oldModel, isSelectAll);
        }
        else {
            this.selectEverything();
        }
    };
    SetFilterModel.prototype.refreshAfterAnyFilterChanged = function () {
        if (this.showingAvailableOnly) {
            this.createAvailableUniqueValues();
            this.processMiniFilter();
        }
    };
    SetFilterModel.prototype.createAllUniqueValues = function () {
        if (this.areValuesSync()) {
            var valuesToUse = this.extractSyncValuesToUse();
            this.setValues(valuesToUse);
            this.filterValuesPromise = ag_grid_2.Promise.resolve(null);
        }
        else {
            this.filterValuesExternalPromise = ag_grid_2.Promise.external();
            this.filterValuesPromise = this.filterValuesExternalPromise.promise;
            this.isLoadingFunc(true);
            this.setValues([]);
            var callback = this.filterParams.values;
            var params = {
                success: this.onAsyncValuesLoaded.bind(this)
            };
            callback(params);
        }
    };
    SetFilterModel.prototype.onAsyncValuesLoaded = function (values) {
        this.modelUpdatedFunc(values);
        this.isLoadingFunc(false);
        this.filterValuesExternalPromise.resolve(null);
    };
    SetFilterModel.prototype.areValuesSync = function () {
        return this.valuesType == SetFilterModelValuesType.PROVIDED_LIST || this.valuesType == SetFilterModelValuesType.NOT_PROVIDED;
    };
    SetFilterModel.prototype.setValuesType = function (value) {
        this.valuesType = value;
    };
    SetFilterModel.prototype.setValues = function (valuesToUse) {
        this.allUniqueValues = valuesToUse;
        if (!this.suppressSorting) {
            this.sortValues(this.allUniqueValues);
        }
    };
    SetFilterModel.prototype.extractSyncValuesToUse = function () {
        var valuesToUse;
        if (this.valuesType == SetFilterModelValuesType.PROVIDED_LIST) {
            if (Array.isArray(this.filterParams.values)) {
                valuesToUse = main_1.Utils.toStrings(this.filterParams.values);
            }
            else {
                // In this case the values are async but have already been resolved, so we can reuse them
                valuesToUse = this.allUniqueValues;
            }
        }
        else if (this.valuesType == SetFilterModelValuesType.PROVIDED_CB) {
            throw Error("ag-grid: Error extracting values to use. We should not extract the values synchronously when using a callback for the filterParams.values");
        }
        else {
            var uniqueValuesAsAnyObjects = this.getUniqueValues(false);
            valuesToUse = main_1.Utils.toStrings(uniqueValuesAsAnyObjects);
        }
        return valuesToUse;
    };
    SetFilterModel.prototype.createAvailableUniqueValues = function () {
        var dontCheckAvailableValues = !this.showingAvailableOnly || this.valuesType == SetFilterModelValuesType.PROVIDED_LIST || this.valuesType == SetFilterModelValuesType.PROVIDED_CB;
        if (dontCheckAvailableValues) {
            this.availableUniqueValues = this.allUniqueValues;
            return;
        }
        var uniqueValuesAsAnyObjects = this.getUniqueValues(true);
        this.availableUniqueValues = main_1.Utils.toStrings(uniqueValuesAsAnyObjects);
        this.sortValues(this.availableUniqueValues);
    };
    SetFilterModel.prototype.sortValues = function (values) {
        if (this.filterParams && this.filterParams.comparator) {
            values.sort(this.filterParams.comparator);
        }
        else if (this.colDef.comparator) {
            values.sort(this.colDef.comparator);
        }
        else {
            values.sort(main_1.Utils.defaultComparator);
        }
    };
    SetFilterModel.prototype.getUniqueValues = function (filterOutNotAvailable) {
        var _this = this;
        var uniqueCheck = {};
        var result = [];
        if (!this.inMemoryRowModel) {
            console.error('ag-Grid: Set Filter cannot initialise because you are using a row model that does not contain all rows in the browser. Either use a different filter type, or configure Set Filter such that you provide it with values');
            return [];
        }
        this.inMemoryRowModel.forEachLeafNode(function (node) {
            // only pull values from rows that have data. this means we skip filler group nodes.
            if (!node.data) {
                return;
            }
            var value = _this.valueGetter(node);
            if (_this.colDef.keyCreator) {
                value = _this.colDef.keyCreator({ value: value });
            }
            if (value === "" || value === undefined) {
                value = null;
            }
            if (filterOutNotAvailable) {
                if (!_this.doesRowPassOtherFilters(node)) {
                    return;
                }
            }
            if (value != null && Array.isArray(value)) {
                for (var j = 0; j < value.length; j++) {
                    addUniqueValueIfMissing(value[j]);
                }
            }
            else {
                addUniqueValueIfMissing(value);
            }
        });
        function addUniqueValueIfMissing(value) {
            if (!uniqueCheck.hasOwnProperty(value)) {
                result.push(value);
                uniqueCheck[value] = 1;
            }
        }
        return result;
    };
    //sets mini filter. returns true if it changed from last value, otherwise false
    SetFilterModel.prototype.setMiniFilter = function (newMiniFilter) {
        newMiniFilter = main_1.Utils.makeNull(newMiniFilter);
        if (this.miniFilter === newMiniFilter) {
            //do nothing if filter has not changed
            return false;
        }
        this.miniFilter = newMiniFilter;
        this.processMiniFilter();
        return true;
    };
    SetFilterModel.prototype.getMiniFilter = function () {
        return this.miniFilter;
    };
    SetFilterModel.prototype.processMiniFilter = function () {
        // if no filter, just use the unique values
        if (this.miniFilter === null) {
            this.displayedValues = this.availableUniqueValues;
            return;
        }
        // if filter present, we filter down the list
        this.displayedValues = [];
        var miniFilter = this.formatter(this.miniFilter);
        // make upper case to have search case insensitive
        var miniFilterUpperCase = miniFilter.toUpperCase();
        for (var i = 0, l = this.availableUniqueValues.length; i < l; i++) {
            var filteredValue = this.availableUniqueValues[i];
            if (filteredValue) {
                var value = this.formatter(filteredValue.toString());
                if (value !== null) {
                    // allow for case insensitive searches, make both filter and value uppercase
                    var valueUpperCase = value.toUpperCase();
                    if (valueUpperCase.indexOf(miniFilterUpperCase) >= 0) {
                        this.displayedValues.push(filteredValue);
                    }
                }
            }
        }
    };
    SetFilterModel.prototype.getDisplayedValueCount = function () {
        return this.displayedValues.length;
    };
    SetFilterModel.prototype.getDisplayedValue = function (index) {
        return this.displayedValues[index];
    };
    SetFilterModel.prototype.selectEverything = function () {
        if (!this.filterParams.selectAllOnMiniFilter || !this.miniFilter) {
            this.selectOn(this.allUniqueValues);
        }
        else {
            this.selectOn(this.displayedValues);
        }
    };
    SetFilterModel.prototype.selectOn = function (toSelectOn) {
        var count = toSelectOn.length;
        for (var i = 0; i < count; i++) {
            var key = toSelectOn[i];
            var safeKey = this.valueToKey(key);
            this.selectedValuesMap[safeKey] = null;
        }
        this.selectedValuesCount = count;
    };
    SetFilterModel.prototype.valueToKey = function (key) {
        if (key === null) {
            return NULL_VALUE;
        }
        else {
            return key;
        }
    };
    SetFilterModel.prototype.keyToValue = function (value) {
        if (value === NULL_VALUE) {
            return null;
        }
        else {
            return value;
        }
    };
    SetFilterModel.prototype.isFilterActive = function () {
        return this.allUniqueValues.length !== this.selectedValuesCount;
    };
    SetFilterModel.prototype.selectNothing = function () {
        var _this = this;
        if (!this.filterParams.selectAllOnMiniFilter || !this.miniFilter) {
            this.selectedValuesMap = {};
            this.selectedValuesCount = 0;
        }
        else {
            this.displayedValues.forEach(function (it) { return _this.unselectValue(it); });
        }
    };
    SetFilterModel.prototype.getUniqueValueCount = function () {
        return this.allUniqueValues.length;
    };
    SetFilterModel.prototype.getUniqueValue = function (index) {
        return this.allUniqueValues[index];
    };
    SetFilterModel.prototype.unselectValue = function (value) {
        var safeKey = this.valueToKey(value);
        if (this.selectedValuesMap[safeKey] !== undefined) {
            delete this.selectedValuesMap[safeKey];
            this.selectedValuesCount--;
        }
    };
    SetFilterModel.prototype.selectValue = function (value) {
        var safeKey = this.valueToKey(value);
        if (this.selectedValuesMap[safeKey] === undefined) {
            this.selectedValuesMap[safeKey] = null;
            this.selectedValuesCount++;
        }
    };
    SetFilterModel.prototype.isValueSelected = function (value) {
        var safeKey = this.valueToKey(value);
        return this.selectedValuesMap[safeKey] !== undefined;
    };
    SetFilterModel.prototype.isEverythingSelected = function () {
        var _this = this;
        if (!this.filterParams.selectAllOnMiniFilter || !this.miniFilter) {
            return this.allUniqueValues.length === this.selectedValuesCount;
        }
        else {
            return this.displayedValues.filter(function (it) { return _this.isValueSelected(it); }).length === this.displayedValues.length;
        }
    };
    SetFilterModel.prototype.isNothingSelected = function () {
        var _this = this;
        if (!this.filterParams.selectAllOnMiniFilter || !this.miniFilter) {
            return this.selectedValuesCount === 0;
        }
        else {
            return this.displayedValues.filter(function (it) { return _this.isValueSelected(it); }).length === 0;
        }
    };
    SetFilterModel.prototype.getModel = function () {
        var _this = this;
        if (!this.isFilterActive()) {
            return null;
        }
        var selectedValues = [];
        main_1.Utils.iterateObject(this.selectedValuesMap, function (key) {
            var value = _this.keyToValue(key);
            selectedValues.push(value);
        });
        return selectedValues;
    };
    SetFilterModel.prototype.setModel = function (model, isSelectAll) {
        if (isSelectAll === void 0) { isSelectAll = false; }
        if (model && !isSelectAll) {
            this.selectNothing();
            for (var i = 0; i < model.length; i++) {
                var rawValue = model[i];
                var value = this.keyToValue(rawValue);
                if (this.allUniqueValues.indexOf(value) >= 0) {
                    this.selectValue(value);
                }
            }
        }
        else {
            this.selectEverything();
        }
    };
    SetFilterModel.prototype.onFilterValuesReady = function (callback) {
        //This guarantees that if the user is racing to set values async into the set filter, only the first instance
        //will be used
        // ie Values are async and the user manually wants to override them before the retrieval of values is triggered
        // (set filter values in the following example)
        // http://plnkr.co/edit/eFka7ynvPj68tL3VJFWf?p=preview
        this.filterValuesPromise.firstOneOnly(callback);
    };
    return SetFilterModel;
}());
exports.SetFilterModel = SetFilterModel;


/***/ }),

/***/ "jUST":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var virtualList_1 = __webpack_require__("X1NG");
var aggFuncService_1 = __webpack_require__("R6MX");
var ColumnComponent = (function (_super) {
    __extends(ColumnComponent, _super);
    function ColumnComponent(column, dragSourceDropTarget, ghost, valueColumn) {
        var _this = _super.call(this) || this;
        _this.popupShowing = false;
        _this.valueColumn = valueColumn;
        _this.column = column;
        _this.dragSourceDropTarget = dragSourceDropTarget;
        _this.ghost = ghost;
        return _this;
    }
    ColumnComponent.prototype.init = function () {
        this.setTemplate(ColumnComponent.TEMPLATE);
        this.displayName = this.columnController.getDisplayNameForColumn(this.column, 'columnDrop');
        this.setupComponents();
        if (!this.ghost && !this.gridOptionsWrapper.isFunctionsReadOnly()) {
            this.addDragSource();
        }
    };
    ColumnComponent.prototype.addDragSource = function () {
        var _this = this;
        var dragSource = {
            type: main_1.DragSourceType.ToolPanel,
            eElement: this.eText,
            dragItemCallback: function () { return _this.createDragItem(); },
            dragItemName: this.displayName,
            dragSourceDropTarget: this.dragSourceDropTarget
        };
        this.dragAndDropService.addDragSource(dragSource, true);
        this.addDestroyFunc(function () { return _this.dragAndDropService.removeDragSource(dragSource); });
    };
    ColumnComponent.prototype.createDragItem = function () {
        var visibleState = {};
        visibleState[this.column.getId()] = this.column.isVisible();
        return {
            columns: [this.column],
            visibleState: visibleState
        };
    };
    ColumnComponent.prototype.setupComponents = function () {
        this.setTextValue();
        this.setupRemove();
        if (this.ghost) {
            main_1.Utils.addCssClass(this.getGui(), 'ag-column-drop-cell-ghost');
        }
        if (this.valueColumn && !this.gridOptionsWrapper.isFunctionsReadOnly()) {
            this.addGuiEventListener('click', this.onShowAggFuncSelection.bind(this));
        }
    };
    ColumnComponent.prototype.setupRemove = function () {
        var _this = this;
        main_1.Utils.setVisible(this.btRemove, !this.gridOptionsWrapper.isFunctionsReadOnly());
        this.addDestroyableEventListener(this.btRemove, 'click', function (mouseEvent) {
            var agEvent = { type: ColumnComponent.EVENT_COLUMN_REMOVE };
            _this.dispatchEvent(agEvent);
            mouseEvent.stopPropagation();
        });
        var touchListener = new main_1.TouchListener(this.btRemove);
        this.addDestroyableEventListener(touchListener, main_1.TouchListener.EVENT_TAP, function (event) {
            var agEvent = { type: ColumnComponent.EVENT_COLUMN_REMOVE };
            _this.dispatchEvent(agEvent);
        });
        this.addDestroyFunc(touchListener.destroy.bind(touchListener));
    };
    ColumnComponent.prototype.setTextValue = function () {
        var displayValue;
        if (this.valueColumn) {
            var aggFunc = this.column.getAggFunc();
            // if aggFunc is a string, we can use it, but if it's a function, then we swap with 'func'
            var aggFuncString = (typeof aggFunc === 'string') ? aggFunc : 'agg';
            var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
            var aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
            displayValue = aggFuncStringTranslated + "(" + this.displayName + ")";
        }
        else {
            displayValue = this.displayName;
        }
        this.eText.innerHTML = displayValue;
    };
    ColumnComponent.prototype.onShowAggFuncSelection = function () {
        var _this = this;
        if (this.popupShowing) {
            return;
        }
        this.popupShowing = true;
        var virtualList = new virtualList_1.VirtualList();
        var rows = this.aggFuncService.getFuncNames(this.column);
        virtualList.setModel({
            getRow: function (index) { return rows[index]; },
            getRowCount: function () { return rows.length; }
        });
        this.context.wireBean(virtualList);
        var ePopup = main_1.Utils.loadTemplate('<div class="ag-select-agg-func-popup"></div>');
        ePopup.style.top = '0px';
        ePopup.style.left = '0px';
        ePopup.appendChild(virtualList.getGui());
        // ePopup.style.height = this.gridOptionsWrapper.getAggFuncPopupHeight() + 'px';
        ePopup.style.width = this.getGui().clientWidth + 'px';
        var popupHiddenFunc = function () {
            virtualList.destroy();
            _this.popupShowing = false;
        };
        var hidePopup = this.popupService.addAsModalPopup(ePopup, true, popupHiddenFunc);
        virtualList.setComponentCreator(this.createAggSelect.bind(this, hidePopup));
        this.popupService.positionPopupUnderComponent({
            type: 'aggFuncSelect',
            eventSource: this.getGui(),
            ePopup: ePopup,
            keepWithinBounds: true,
            column: this.column
        });
        virtualList.refresh();
    };
    ColumnComponent.prototype.createAggSelect = function (hidePopup, value) {
        var _this = this;
        var itemSelected = function () {
            hidePopup();
            if (_this.gridOptionsWrapper.isFunctionsPassive()) {
                var event_1 = {
                    type: main_1.Events.EVENT_COLUMN_AGG_FUNC_CHANGE_REQUEST,
                    columns: [_this.column],
                    aggFunc: value,
                    api: _this.gridApi,
                    columnApi: _this.columnApi
                };
                _this.eventService.dispatchEvent(event_1);
            }
            else {
                _this.columnController.setColumnAggFunc(_this.column, value, "toolPanelDragAndDrop");
            }
        };
        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
        var aggFuncString = value.toString();
        var aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
        var comp = new AggItemComp(itemSelected, aggFuncStringTranslated);
        return comp;
    };
    ColumnComponent.EVENT_COLUMN_REMOVE = 'columnRemove';
    ColumnComponent.TEMPLATE = "<span class=\"ag-column-drop-cell\">\n          <span class=\"ag-column-drop-cell-text\"></span>\n          <span class=\"ag-column-drop-cell-button\">&#10006;</span>\n        </span>";
    __decorate([
        main_1.Autowired('dragAndDropService'),
        __metadata("design:type", main_1.DragAndDropService)
    ], ColumnComponent.prototype, "dragAndDropService", void 0);
    __decorate([
        main_1.Autowired('columnController'),
        __metadata("design:type", main_1.ColumnController)
    ], ColumnComponent.prototype, "columnController", void 0);
    __decorate([
        main_1.Autowired('gridPanel'),
        __metadata("design:type", main_1.GridPanel)
    ], ColumnComponent.prototype, "gridPanel", void 0);
    __decorate([
        main_1.Autowired('context'),
        __metadata("design:type", main_1.Context)
    ], ColumnComponent.prototype, "context", void 0);
    __decorate([
        main_1.Autowired('popupService'),
        __metadata("design:type", main_1.PopupService)
    ], ColumnComponent.prototype, "popupService", void 0);
    __decorate([
        main_1.Autowired('aggFuncService'),
        __metadata("design:type", aggFuncService_1.AggFuncService)
    ], ColumnComponent.prototype, "aggFuncService", void 0);
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], ColumnComponent.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        main_1.Autowired('eventService'),
        __metadata("design:type", main_1.EventService)
    ], ColumnComponent.prototype, "eventService", void 0);
    __decorate([
        main_1.Autowired('columnApi'),
        __metadata("design:type", main_1.ColumnApi)
    ], ColumnComponent.prototype, "columnApi", void 0);
    __decorate([
        main_1.Autowired('gridApi'),
        __metadata("design:type", main_1.GridApi)
    ], ColumnComponent.prototype, "gridApi", void 0);
    __decorate([
        main_1.QuerySelector('.ag-column-drop-cell-text'),
        __metadata("design:type", HTMLElement)
    ], ColumnComponent.prototype, "eText", void 0);
    __decorate([
        main_1.QuerySelector('.ag-column-drop-cell-button'),
        __metadata("design:type", HTMLElement)
    ], ColumnComponent.prototype, "btRemove", void 0);
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ColumnComponent.prototype, "init", null);
    return ColumnComponent;
}(main_1.Component));
exports.ColumnComponent = ColumnComponent;
var AggItemComp = (function (_super) {
    __extends(AggItemComp, _super);
    function AggItemComp(itemSelected, value) {
        var _this = _super.call(this, '<div class="ag-select-agg-func-item"/>') || this;
        _this.getGui().innerText = value;
        _this.value = value;
        _this.addGuiEventListener('click', itemSelected);
        return _this;
    }
    return AggItemComp;
}(main_1.Component));


/***/ }),

/***/ "jeRM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var component_1 = __webpack_require__("pQ38");
var ARROW_UP = '&#65514;';
var ARROW_DOWN = '&#65516;';
var AnimateShowChangeCellRenderer = (function (_super) {
    __extends(AnimateShowChangeCellRenderer, _super);
    function AnimateShowChangeCellRenderer() {
        var _this = _super.call(this, AnimateShowChangeCellRenderer.TEMPLATE) || this;
        _this.refreshCount = 0;
        return _this;
    }
    AnimateShowChangeCellRenderer.prototype.init = function (params) {
        // this.params = params;
        this.eValue = this.queryForHtmlElement('.ag-value-change-value');
        this.eDelta = this.queryForHtmlElement('.ag-value-change-delta');
        this.refresh(params);
    };
    AnimateShowChangeCellRenderer.prototype.showDelta = function (params, delta) {
        var absDelta = Math.abs(delta);
        var valueFormatted = params.formatValue(absDelta);
        var valueToUse = utils_1.Utils.exists(valueFormatted) ? valueFormatted : absDelta;
        var deltaUp = (delta >= 0);
        if (deltaUp) {
            this.eDelta.innerHTML = ARROW_UP + valueToUse;
        }
        else {
            // because negative, use ABS to remove sign
            this.eDelta.innerHTML = ARROW_DOWN + valueToUse;
        }
        // class makes it green (in ag-fresh)
        utils_1.Utils.addOrRemoveCssClass(this.eDelta, 'ag-value-change-delta-up', deltaUp);
        // class makes it red (in ag-fresh)
        utils_1.Utils.addOrRemoveCssClass(this.eDelta, 'ag-value-change-delta-down', !deltaUp);
    };
    AnimateShowChangeCellRenderer.prototype.setTimerToRemoveDelta = function () {
        var _this = this;
        // the refreshCount makes sure that if the value updates again while
        // the below timer is waiting, then the below timer will realise it
        // is not the most recent and will not try to remove the delta value.
        this.refreshCount++;
        var refreshCountCopy = this.refreshCount;
        setTimeout(function () {
            if (refreshCountCopy === _this.refreshCount) {
                _this.hideDeltaValue();
            }
        }, 2000);
    };
    AnimateShowChangeCellRenderer.prototype.hideDeltaValue = function () {
        utils_1.Utils.removeCssClass(this.eValue, 'ag-value-change-value-highlight');
        this.eDelta.innerHTML = '';
    };
    AnimateShowChangeCellRenderer.prototype.refresh = function (params) {
        var value = params.value;
        if (value === this.lastValue) {
            return;
        }
        if (utils_1.Utils.exists(params.valueFormatted)) {
            this.eValue.innerHTML = params.valueFormatted;
        }
        else if (utils_1.Utils.exists(params.value)) {
            this.eValue.innerHTML = value;
        }
        else {
            this.eValue.innerHTML = '';
        }
        if (typeof value === 'number' && typeof this.lastValue === 'number') {
            var delta = value - this.lastValue;
            this.showDelta(params, delta);
        }
        // highlight the current value, but only if it's not new, otherwise it
        // would get highlighted first time the value is shown
        if (this.lastValue) {
            utils_1.Utils.addCssClass(this.eValue, 'ag-value-change-value-highlight');
        }
        this.setTimerToRemoveDelta();
        this.lastValue = value;
        return true;
    };
    AnimateShowChangeCellRenderer.TEMPLATE = '<span>' +
        '<span class="ag-value-change-delta"></span>' +
        '<span class="ag-value-change-value"></span>' +
        '</span>';
    return AnimateShowChangeCellRenderer;
}(component_1.Component));
exports.AnimateShowChangeCellRenderer = AnimateShowChangeCellRenderer;


/***/ }),

/***/ "jm6Q":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1329);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1329:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.tabstrip",
	    name: "TabStrip",
	    category: "mobile",
	    description: "The mobile TabStrip widget is used inside a mobile view or layout footer element to display an application-wide group of navigation buttons.",
	    depends: [ "core" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.mobile.ui,
	        Widget = ui.Widget,
	        ACTIVE_STATE_CLASS = "km-state-active",
	        SELECT = "select";

	    function createBadge(value) {
	        return $('<span class="km-badge">' + value + '</span>');
	    }

	    var TabStrip = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);
	            that.container().bind("show", $.proxy(this, "refresh"));

	            that.element
	               .addClass("km-tabstrip")
	               .find("a").each(that._buildButton)
	               .eq(that.options.selectedIndex).addClass(ACTIVE_STATE_CLASS);

	            that.element.on("down", "a", "_release");
	        },

	        events: [
	            SELECT
	        ],

	        switchTo: function(url) {
	            var tabs = this.element.find('a'),
	                tab,
	                path,
	                idx = 0,
	                length = tabs.length;

	            if(isNaN(url)) {
	                for (; idx < length; idx ++) {
	                    tab = tabs[idx];
	                    path = tab.href.replace(/(\#.+)(\?.+)$/, "$1"); // remove the fragment query string - http://www.foo.com?foo#bar**?baz=qux**

	                    if (path.indexOf(url, path.length - url.length) !== -1) {
	                        this._setActiveItem($(tab));
	                        return true;
	                    }
	                }
	            } else {
	                this._setActiveItem(tabs.eq(url));
	                return true;
	            }

	            return false;
	        },

	        switchByFullUrl: function(url) {
	            var tab;

	            tab = this.element.find("a[href$='" + url + "']");
	            this._setActiveItem(tab);
	        },

	        clear: function() {
	            this.currentItem().removeClass(ACTIVE_STATE_CLASS);
	        },

	        currentItem: function() {
	            return this.element.children("." + ACTIVE_STATE_CLASS);
	        },

	        badge: function(item, value) {
	            var tabstrip = this.element, badge;

	            if (!isNaN(item)) {
	                item = tabstrip.children().get(item);
	            }

	            item = tabstrip.find(item);
	            badge = $(item.find(".km-badge")[0] || createBadge(value).insertAfter(item.children(".km-icon")));

	            if (value || value === 0) {
	                badge.html(value);
	                return this;
	            }

	            if (value === false) {
	                badge.empty().remove();
	                return this;
	            }

	            return badge.html();
	        },

	        _release: function(e) {
	            if (e.which > 1) {
	                return;
	            }

	            var that = this,
	                item = $(e.currentTarget);

	            if (item[0] === that.currentItem()[0]) {
	                return;
	            }

	            if (that.trigger(SELECT, {item: item})) {
	                e.preventDefault();
	            } else {
	                that._setActiveItem(item);
	            }
	        },

	        _setActiveItem: function(item) {
	            if (!item[0]) {
	                return;
	            }
	            this.clear();
	            item.addClass(ACTIVE_STATE_CLASS);
	        },

	        _buildButton: function() {
	            var button = $(this),
	                icon = kendo.attrValue(button, "icon"),
	                badge = kendo.attrValue(button, "badge"),
	                image = button.find("img"),
	                iconSpan = $('<span class="km-icon"/>');

	            button
	                .addClass("km-button")
	                .attr(kendo.attr("role"), "tab")
	                    .contents().not(image)
	                    .wrapAll('<span class="km-text"/>');

	            if (image[0]) {
	                image.addClass("km-image").prependTo(button);
	            } else {
	                button.prepend(iconSpan);
	                if (icon) {
	                    iconSpan.addClass("km-" + icon);
	                    if (badge || badge === 0) {
	                        createBadge(badge).insertAfter(iconSpan);
	                    }
	                }
	            }
	        },

	        refresh: function(e) {
	            var url = e.view.id;

	            if (url && !this.switchTo(e.view.id)) {
	                this.switchTo(url);
	            }
	        },

	        options: {
	            name: "TabStrip",
	            selectedIndex: 0,
	            enable: true
	        }
	    });

	    ui.plugin(TabStrip);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "jsXh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ag_grid_1 = __webpack_require__("F6Mk");
var clipboardService_1 = __webpack_require__("/3L8");
var aggFuncService_1 = __webpack_require__("R6MX");
var MenuItemMapper = (function () {
    function MenuItemMapper() {
    }
    MenuItemMapper.prototype.mapWithStockItems = function (originalList, column) {
        var _this = this;
        if (!originalList) {
            return [];
        }
        var resultList = [];
        originalList.forEach(function (menuItemOrString) {
            var result;
            if (typeof menuItemOrString === 'string') {
                result = _this.getStockMenuItem(menuItemOrString, column);
            }
            else {
                result = menuItemOrString;
            }
            if (result.subMenu) {
                var resultDef = result;
                resultDef.subMenu = _this.mapWithStockItems(resultDef.subMenu, column);
            }
            resultList.push(result);
        });
        return resultList;
    };
    MenuItemMapper.prototype.getStockMenuItem = function (key, column) {
        var _this = this;
        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
        switch (key) {
            case 'pinSubMenu': return {
                name: localeTextFunc('pinColumn', 'Pin Column'),
                icon: ag_grid_1.Utils.createIconNoSpan('menuPin', this.gridOptionsWrapper, null),
                subMenu: ['pinLeft', 'pinRight', 'clearPinned']
            };
            case 'pinLeft': return {
                name: localeTextFunc('pinLeft', 'Pin Left'),
                action: function () { return _this.columnController.setColumnPinned(column, ag_grid_1.Column.PINNED_LEFT, "contextMenu"); },
                checked: column.isPinnedLeft()
            };
            case 'pinRight': return {
                name: localeTextFunc('pinRight', 'Pin Right'),
                action: function () { return _this.columnController.setColumnPinned(column, ag_grid_1.Column.PINNED_RIGHT, "contextMenu"); },
                checked: column.isPinnedRight()
            };
            case 'clearPinned': return {
                name: localeTextFunc('noPin', 'No Pin'),
                action: function () { return _this.columnController.setColumnPinned(column, null, "contextMenu"); },
                checked: !column.isPinned()
            };
            case 'valueAggSubMenu': return {
                name: localeTextFunc('valueAggregation', 'Value Aggregation'),
                icon: ag_grid_1.Utils.createIconNoSpan('menuValue', this.gridOptionsWrapper, null),
                subMenu: this.createAggregationSubMenu(column)
            };
            case 'autoSizeThis': return {
                name: localeTextFunc('autosizeThiscolumn', 'Autosize This Column'),
                action: function () { return _this.columnController.autoSizeColumn(column, "contextMenu"); }
            };
            case 'autoSizeAll': return {
                name: localeTextFunc('autosizeAllColumns', 'Autosize All Columns'),
                action: function () { return _this.columnController.autoSizeAllColumns("contextMenu"); }
            };
            case 'rowGroup': return {
                name: localeTextFunc('groupBy', 'Group by') + ' ' + this.columnController.getDisplayNameForColumn(column, 'header'),
                action: function () { return _this.columnController.addRowGroupColumn(column, "contextMenu"); },
                icon: ag_grid_1.Utils.createIconNoSpan('menuAddRowGroup', this.gridOptionsWrapper, null)
            };
            case 'rowUnGroup': return {
                name: localeTextFunc('ungroupBy', 'Un-Group by') + ' ' + this.columnController.getDisplayNameForColumn(column, 'header'),
                action: function () { return _this.columnController.removeRowGroupColumn(column, "contextMenu"); },
                icon: ag_grid_1.Utils.createIconNoSpan('menuRemoveRowGroup', this.gridOptionsWrapper, null)
            };
            case 'resetColumns': return {
                name: localeTextFunc('resetColumns', 'Reset Columns'),
                action: function () { return _this.columnController.resetColumnState("contextMenu"); }
            };
            case 'expandAll': return {
                name: localeTextFunc('expandAll', 'Expand All'),
                action: function () { return _this.gridApi.expandAll(); }
            };
            case 'contractAll': return {
                name: localeTextFunc('collapseAll', 'Collapse All'),
                action: function () { return _this.gridApi.collapseAll(); }
            };
            case 'copy': return {
                name: localeTextFunc('copy', 'Copy'),
                shortcut: localeTextFunc('ctrlC', 'Ctrl+C'),
                icon: ag_grid_1.Utils.createIconNoSpan('clipboardCopy', this.gridOptionsWrapper, null),
                action: function () { return _this.clipboardService.copyToClipboard(false); }
            };
            case 'copyWithHeaders': return {
                name: localeTextFunc('copyWithHeaders', 'Copy with Headers'),
                // shortcut: localeTextFunc('ctrlC','Ctrl+C'),
                icon: ag_grid_1.Utils.createIconNoSpan('clipboardCopy', this.gridOptionsWrapper, null),
                action: function () { return _this.clipboardService.copyToClipboard(true); }
            };
            case 'paste': return {
                name: localeTextFunc('paste', 'Paste'),
                shortcut: localeTextFunc('ctrlV', 'Ctrl+V'),
                disabled: true,
                icon: ag_grid_1.Utils.createIconNoSpan('clipboardPaste', this.gridOptionsWrapper, null),
                action: function () { return _this.clipboardService.pasteFromClipboard(); }
            };
            case 'toolPanel': return {
                name: localeTextFunc('toolPanel', 'Tool Panel'),
                checked: this.gridApi.isToolPanelShowing(),
                action: function () { return _this.gridApi.showToolPanel(!_this.gridApi.isToolPanelShowing()); }
            };
            case 'export':
                var exportSubMenuItems = [];
                if (!this.gridOptionsWrapper.isSuppressCsvExport()) {
                    exportSubMenuItems.push('csvExport');
                }
                if (!this.gridOptionsWrapper.isSuppressExcelExport()) {
                    exportSubMenuItems.push('excelExport');
                }
                return {
                    name: localeTextFunc('export', 'Export'),
                    subMenu: exportSubMenuItems
                };
            case 'csvExport': return {
                name: localeTextFunc('csvExport', 'CSV Export'),
                action: function () { return _this.gridApi.exportDataAsCsv({}); }
            };
            case 'excelExport': return {
                name: localeTextFunc('excelExport', 'Excel Export'),
                action: function () { return _this.gridApi.exportDataAsExcel({}); }
            };
            case 'separator': return 'separator';
            default:
                console.log("ag-Grid: unknown menu item type " + key);
                return null;
        }
    };
    MenuItemMapper.prototype.createAggregationSubMenu = function (column) {
        var _this = this;
        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
        var columnIsAlreadyAggValue = column.isValueActive();
        var funcNames = this.aggFuncService.getFuncNames(column);
        var columnToUse;
        if (column.isPrimary()) {
            columnToUse = column;
        }
        else {
            columnToUse = column.getColDef().pivotValueColumn;
        }
        var result = [];
        funcNames.forEach(function (funcName) {
            result.push({
                name: localeTextFunc(funcName, funcName),
                action: function () {
                    _this.columnController.setColumnAggFunc(columnToUse, funcName, "contextMenu");
                    _this.columnController.addValueColumn(columnToUse, "contextMenu");
                },
                checked: columnIsAlreadyAggValue && columnToUse.getAggFunc() === funcName
            });
        });
        return result;
    };
    __decorate([
        ag_grid_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", ag_grid_1.GridOptionsWrapper)
    ], MenuItemMapper.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        ag_grid_1.Autowired('columnController'),
        __metadata("design:type", ag_grid_1.ColumnController)
    ], MenuItemMapper.prototype, "columnController", void 0);
    __decorate([
        ag_grid_1.Autowired('gridApi'),
        __metadata("design:type", ag_grid_1.GridApi)
    ], MenuItemMapper.prototype, "gridApi", void 0);
    __decorate([
        ag_grid_1.Autowired('clipboardService'),
        __metadata("design:type", clipboardService_1.ClipboardService)
    ], MenuItemMapper.prototype, "clipboardService", void 0);
    __decorate([
        ag_grid_1.Autowired('aggFuncService'),
        __metadata("design:type", aggFuncService_1.AggFuncService)
    ], MenuItemMapper.prototype, "aggFuncService", void 0);
    MenuItemMapper = __decorate([
        ag_grid_1.Bean('menuItemMapper')
    ], MenuItemMapper);
    return MenuItemMapper;
}());
exports.MenuItemMapper = MenuItemMapper;


/***/ }),

/***/ "jvub":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1267);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1048:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("BOhp");

/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1078:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("qo2y");

/***/ }),

/***/ 1091:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("3gOi");

/***/ }),

/***/ 1190:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("JKVm");

/***/ }),

/***/ 1191:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1Z35");

/***/ }),

/***/ 1241:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Owf0");

/***/ }),

/***/ 1249:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("9fcU");

/***/ }),

/***/ 1252:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("HQQe");

/***/ }),

/***/ 1257:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("rbj2");

/***/ }),

/***/ 1267:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1059),
	        __webpack_require__(1269),
	        __webpack_require__(1249),
	        __webpack_require__(1191),
	        __webpack_require__(1091),
	        __webpack_require__(1270),
	        __webpack_require__(1271),
	        __webpack_require__(1272),
	        __webpack_require__(1078),
	        __webpack_require__(1273),
	        __webpack_require__(1268),
	        __webpack_require__(1190),
	        __webpack_require__(1274),
	        __webpack_require__(1275),
	        __webpack_require__(1276),
	        __webpack_require__(1277),
	        __webpack_require__(1257),
	        __webpack_require__(1241),
	        __webpack_require__(1276),
	        __webpack_require__(1252)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "grid",
	    name: "Grid",
	    category: "web",
	    description: "The Grid widget displays tabular data and offers rich support for interacting with data,including paging, sorting, grouping, and selection.",
	    depends: [ "data", "columnsorter", "sortable" ],
	    features: [ {
	        id: "grid-editing",
	        name: "Editing",
	        description: "Support for record editing",
	        depends: [ "editable", "window" ]
	    }, {
	        id: "grid-filtering",
	        name: "Filtering",
	        description: "Support for record filtering",
	        depends: [ "filtermenu" ]
	    }, {
	        id: "grid-columnmenu",
	        name: "Column menu",
	        description: "Support for header column menu",
	        depends: [ "columnmenu" ]
	    }, {
	        id: "grid-grouping",
	        name: "Grouping",
	        description: "Support for grid grouping",
	        depends: [ "groupable" ]
	    }, {
	        id: "grid-filtercell",
	        name: "Row filter",
	        description: "Support for grid header filtering",
	        depends: [ "filtercell" ]
	    }, {
	        id: "grid-paging",
	        name: "Paging",
	        description: "Support for grid paging",
	        depends: [ "pager" ]
	    }, {
	        id: "grid-selection",
	        name: "Selection",
	        description: "Support for row selection",
	        depends: [ "selectable" ]
	    }, {
	        id: "grid-column-reorder",
	        name: "Column reordering",
	        description: "Support for column reordering",
	        depends: [ "reorderable" ]
	    }, {
	        id: "grid-column-resize",
	        name: "Column resizing",
	        description: "Support for column resizing",
	        depends: [ "resizable" ]
	    }, {
	        id: "grid-mobile",
	        name: "Grid adaptive rendering",
	        description: "Support for adaptive rendering",
	        depends: [ "dialog", "pane", "switch" ]
	    }, {
	        id: "grid-excel-export",
	        name: "Excel export",
	        description: "Export grid data as Excel spreadsheet",
	        depends: [ "excel" ]
	    }, {
	        id: "grid-pdf-export",
	        name: "PDF export",
	        description: "Export grid data as PDF",
	        depends: [ "pdf", "drawing", "progressbar" ]
	    } ]
	};

	/* jshint eqnull: true */
	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        DataSource = kendo.data.DataSource,
	        ObservableObject = kendo.data.ObservableObject,
	        tbodySupportsInnerHtml = kendo.support.tbodyInnerHtml,
	        activeElement = kendo._activeElement,
	        Widget = ui.Widget,
	        outerWidth = kendo._outerWidth,
	        outerHeight = kendo._outerHeight,
	        keys = kendo.keys,

	        isPlainObject = $.isPlainObject,
	        extend = $.extend,
	        map = $.map,
	        grep = $.grep,
	        isArray = $.isArray,
	        inArray = $.inArray,
	        push = Array.prototype.push,
	        proxy = $.proxy,
	        isFunction = kendo.isFunction,
	        isEmptyObject = $.isEmptyObject,
	        contains = $.contains,
	        math = Math,

	        DOT = ".",
	        PROGRESS = "progress",
	        ERROR = "error",
	        HIERARCHY_CELL_CLASS = "k-hierarchy-cell",
	        DATA_CELL = ":not(.k-group-cell):not([" + kendo.attr("virtual") + "]):not(.k-hierarchy-cell:not(:has(.k-icon.k-i-collapse,.k-icon.k-i-expand))):visible",
	        SELECTION_CELL_SELECTOR = "tbody>tr:not(.k-grouping-row):not(.k-detail-row):not(.k-group-footer) > td:not(.k-group-cell):not(.k-hierarchy-cell)",
	        NAVROW = "tr:not(.k-footer-template):visible",
	        NAVCELL = ":not(.k-group-cell):not(.k-detail-cell):not(.k-hierarchy-cell):visible",
	        ITEMROW = "tr:not(.k-grouping-row):not(.k-detail-row):not(.k-footer-template):not(.k-group-footer):visible",
	        FIRSTITEMROW = ITEMROW + ":first",
	        LASTITEMROW = ITEMROW + ":last",
	        FIRSTNAVITEM = NAVROW + ":first>" + NAVCELL + ":first",
	        HEADERCELLS = "th.k-header:not(.k-group-cell):not(.k-hierarchy-cell)",
	        NS = ".kendoGrid",
	        CONTENTRLOCKEDCONTAINER = "k-grid-content-locked",
	        GROUPCELLCLASS = "k-group-cell",

	        EDIT = "edit",
	        BEFOREEDIT = "beforeEdit",
	        SAVE = "save",
	        REMOVE = "remove",
	        DETAILINIT = "detailInit",
	        FILTERMENUINIT = "filterMenuInit",
	        COLUMNMENUINIT = "columnMenuInit",
	        FILTERMENUOPEN = "filterMenuOpen",
	        COLUMNMENUOPEN = "columnMenuOpen",
	        CELLCLOSE = "cellClose",
	        CHANGE = "change",
	        COLUMNHIDE = "columnHide",
	        COLUMNSHOW = "columnShow",
	        SAVECHANGES = "saveChanges",
	        DATABOUND = "dataBound",
	        DETAILEXPAND = "detailExpand",
	        DETAILCOLLAPSE = "detailCollapse",
	        ITEM_CHANGE = "itemchange",
	        PAGE = "page",
	        PAGING = "paging",
	        SCROLL = "scroll",
	        SYNC = "sync",

	        FOCUSED = "k-state-focused",
	        FOCUSABLE = ":kendoFocusable",
	        SELECTED = "k-state-selected",
	        CHECKBOX = "k-checkbox",
	        CHECKBOXINPUT = "input[data-role='checkbox']." + CHECKBOX,
	        NORECORDSCLASS = "k-grid-norecords",
	        LINK_CLASS = "k-link",
	        ICON_CLASS = "k-icon",
	        ORDER_CLASS = "k-sort-order",
	        HEADER_COLUMN_MENU_CLASS = "k-header-column-menu",
	        FILTER_MENU_CLASS = "k-grid-filter",
	        STICKY_CELL_CLASS= "k-grid-content-sticky",
	        STICKY_HEADER_CLASS = "k-grid-header-sticky",
	        STICKY_FOOTER_CLASS = "k-grid-footer-sticky",
	        STICKY_HEADER_NO_BORDER_CLASS = "k-grid-no-left-border",
	        RESIZE = "resize",
	        COLUMNRESIZE = "columnResize",
	        COLUMNREORDER = "columnReorder",
	        COLUMNLOCK = "columnLock",
	        COLUMNUNLOCK = "columnUnlock",
	        COLUMNSTICK = "columnStick",
	        COLUMNUNSTICK = "columnUnstick",
	        NAVIGATE = "navigate",
	        CLICK = "click",
	        MOUSEDOWN = "mousedown",
	        HEIGHT = "height",
	        TABINDEX = "tabIndex",
	        FUNCTION = "function",
	        STRING = "string",
	        BOTTOM = "bottom",
	        CONTAINER_FOR = "container-for",
	        FIELD = "field",
	        INPUT = "input",
	        INCELL = "incell",
	        INLINE = "inline",
	        UNIQUE_ID = "uid",
	        MINCOLSPANVALUE = 1,
	        COLSPAN = "colSpan",
	        OVERFLOW = "overflow",
	        HIDDEN = "hidden",
	        SORT = "sort",
	        GROUP_SORT = "group-sort",
	        DELETECONFIRM = "Are you sure you want to delete this record?",
	        NORECORDS = "No records available.",
	        CONFIRMDELETE = "Delete",
	        CANCELDELETE = "Cancel",
	        COLLAPSE = "Collapse",
	        EXPAND = "Expand",
	        ARIALABEL = "aria-label",
	        formatRegExp = /(\}|\#)/ig,
	        templateHashRegExp = /#/ig,
	        whitespaceRegExp = "[\\x20\\t\\r\\n\\f]",
	        nonDataCellsRegExp = new RegExp("(^|" + whitespaceRegExp + ")" + "(k-group-cell|k-hierarchy-cell)" + "(" + whitespaceRegExp + "|$)"),
	        filterRowRegExp = new RegExp("(^|" + whitespaceRegExp + ")" + "(k-filter-row)" + "(" + whitespaceRegExp + "|$)"),
	        COMMANDBUTTONTMPL = '# if (iconClass) {#' +
	                                '<a role="button" class="k-button k-button-icontext #=className#" #=attr# href="\\#"><span class="#=iconClass#"></span>#=text#</a>' +
	                            '# } else { #' +
	                                '<a role="button" class="k-button k-button-icontext #=className#" #=attr# href="\\#">#=text#</a>' +
	                            '# } #',
	        SELECTCOLUMNTMPL = '<input class="' + CHECKBOX + '" data-role="checkbox" aria-label="Select row" aria-checked="false" type="checkbox">',
	        SELECTCOLUMNHEADERTMPL = '<input class="' + CHECKBOX + '" data-role="checkbox" aria-label="Select all rows" aria-checked="false" type="checkbox">',
	        isRtl = false,
	        browser = kendo.support.browser,
	        isIE7 = browser.msie && browser.version == 7,
	        isIE8 = browser.msie && browser.version == 8;
	    var isIE11 = browser.msie && browser.version === 11;
	    var isMac = /Mac OS/.test(navigator.userAgent);
	    var classNames = {
	        content: "k-content",
	        widget: "k-widget",
	        scrollContainer: "k-scroll-container"
	    };
	    var GroupsPager;

	    if (ui.Pager) {
	        GroupsPager = ui.Pager.extend({
	            init: function (element, options) {
	                ui.Pager.fn.init.call(this, element, extend(true, {}, options));
	                this.dataSource.options.useRanges = true;
	                this.dataSource._omitPrefetch = true;
	            },
	            options: {
	                name: "GroupsPager"
	            },

	            totalPages: function () {
	                var that = this;

	                return Math.ceil((that._collapsedTotal() || 0) / (that.pageSize() || 1));
	            },
	            _collapsedTotal: function () {
	                var dataSource = this.dataSource;
	                return dataSource ? (dataSource.groupsTotal(true) || 0) : 0;
	            }
	        });
	    }

	    var VirtualScrollable =  Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);
	            that._refreshHandler = proxy(that.refresh, that);
	            that.setDataSource(options.dataSource);
	            that.wrap();
	        },

	        setDataSource: function(dataSource) {
	            var that = this;
	            if (that.dataSource) {
	                that.dataSource.unbind(CHANGE, that._refreshHandler);
	            }
	            that.dataSource = dataSource;
	            that.dataSource.bind(CHANGE, that._refreshHandler);
	            that.dataSource.options.useRanges = true;
	        },

	        options: {
	            name: "VirtualScrollable",
	            itemHeight: $.noop,
	            prefetch: true,
	            maxScrollHeight: 250000
	        },

	        events: [
	            PAGING,
	            PAGE,
	            SCROLL
	        ],

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            that.dataSource.unbind(CHANGE, that._refreshHandler);
	            that.wrapper.add(that.verticalScrollbar).off(NS);

	            clearTimeout(that._timeout);
	            if (that._scrollingTimeout) {
	                clearTimeout(that._scrollingTimeout);
	            }

	            if (that.drag) {
	                that.drag.destroy();
	                that.drag = null;
	            }
	            that.wrapper = that.element = that.verticalScrollbar = null;
	            that._refreshHandler = null;
	        },

	        wrap: function() {
	            var that = this,
	                // workaround for IE issue where scroll is not raised if container is same width as the scrollbar
	                scrollbar = kendo.support.scrollbar() + 1,
	                element = that.element,
	                wrapper;

	            element.css( {
	                width: "auto",
	                overflow: "hidden"
	            }).css((isRtl ? "padding-left" : "padding-right"), scrollbar);
	            that.content = element.children().first();
	            wrapper = that.wrapper = that.content.wrap('<div class="k-virtual-scrollable-wrap"/>')
	                                .parent()
	                                .bind("DOMMouseScroll" + NS + " mousewheel" + NS, proxy(that._wheelScroll, that));
	            that._wrapper();

	            if (kendo.support.kineticScrollNeeded || kendo.support.touch) {
	                that.wrapper.css("touch-action", "none");
	                that.drag = new kendo.UserEvents(that.wrapper, {
	                    global: true,
	                    allowSelection: true,
	                    start: function(e) {
	                        e.sender.capture();
	                    },
	                    move: function(e) {
	                        that.verticalScrollbar.scrollTop(that.verticalScrollbar.scrollTop() - e.y.delta);
	                        kendo.scrollLeft(wrapper, kendo.scrollLeft(wrapper) - e.x.delta);
	                        e.preventDefault();
	                    }
	                });
	            }

	            that.verticalScrollbar = $('<div class="k-scrollbar k-scrollbar-vertical" />')
	                                        .css({
	                                            width: scrollbar
	                                        }).appendTo(element)
	                                        .bind("scroll" + NS, proxy(that._scroll, that));
	        },

	        _wrapper: function() {
	            var that = this;

	            if (isIE11) {
	                //scrolling the virtual scrollbar to the bottom and then
	                //scrolling the horizontal content scrollbar does not fire the "scroll" event
	                //seems like a problem in IE 11 only (after version 11.0.9600.18860)
	                //https://github.com/telerik/kendo-ui-core/issues/3779
	                that.wrapper.css({
	                    "overflow-y": SCROLL
	                });

	                //hide the wrapper behind the virtual scrollbar
	                that.element.css((isRtl ? "padding-left" : "padding-right"), 0);
	            }
	        },

	        _wheelScroll: function (e) {
	            if (e.ctrlKey) {
	                return;
	            }

	            var scrollbar = this.verticalScrollbar,
	                scrollTop = scrollbar.scrollTop(),
	                delta = kendo.wheelDeltaY(e);

	            if (delta && !(delta > 0 && scrollTop === 0) && !(delta < 0 && scrollTop + scrollbar[0].clientHeight == scrollbar[0].scrollHeight)) {
	                e.preventDefault();
	                this.verticalScrollbar.scrollTop(scrollTop + (-delta));
	            }
	        },

	        _scroll: function(e) {
	            var that = this,
	                delayLoading = !that.options.prefetch,
	                scrollTop = e.currentTarget.scrollTop,
	                dataSource = that.dataSource,
	                rowHeight = that.itemHeight,
	                skip = dataSource.skip() || 0,
	                start = that._rangeStart || skip,
	                height = that.element.innerHeight(),
	                isScrollingUp = !!(that._scrollbarTop && that._scrollbarTop > scrollTop),
	                firstItemIndex = math.max(math.floor(scrollTop / rowHeight), 0),
	                lastItemOffset = isScrollingUp ? math.ceil(height / rowHeight) : math.floor(height / rowHeight),
	                lastItemIndex = math.max(firstItemIndex + lastItemOffset, 0);

	            if (that._preventScroll) {
	                that._preventScroll = false;
	                return;
	            }
	            that._prevScrollTop = that._scrollTop;
	            that._scrollTop = scrollTop - (start * rowHeight);
	            that._scrollbarTop = scrollTop;

	            that._scrolling = delayLoading;

	            if (!that._fetch(firstItemIndex, lastItemIndex, isScrollingUp)) {
	                that.wrapper[0].scrollTop = that._scrollTop;
	            }

	            that.trigger(SCROLL);

	            if (delayLoading) {
	                if (that._scrollingTimeout) {
	                    clearTimeout(that._scrollingTimeout);
	                }

	                that._scrollingTimeout = setTimeout(function() {
	                    that._scrolling = false;
	                    that._page(that._rangeStart, that.dataSource.take());
	                }, 100);
	            }
	        },

	        scrollToTop: function() {
	            this._scrollTo(0);
	        },

	        scrollToBottom: function() {
	            var scrollbar = this.verticalScrollbar;
	            this._scrollTo(scrollbar[0].scrollHeight - scrollbar.height());
	        },

	        _scrollWrapperToTop: function() {
	            this.wrapper.scrollTop(0);
	        },

	        _scrollWrapperToBottom: function() {
	            this.wrapper.scrollTop(this.wrapper[0].scrollHeight);
	        },

	        _scrollWrapperOnColumnResize: function() {
	            var that = this;
	            var wrapper = this.wrapper;
	            var initialScrollTop = wrapper.scrollTop();

	            if (wrapper[0].scrollWidth > wrapper[0].clientWidth) {
	                if ((!that._wrapperScrolled && initialScrollTop) || that._isScrolledToBottom()) {
	                    wrapper.scrollTop(initialScrollTop + kendo.support.scrollbar());
	                    that._scrollTop = wrapper.scrollTop();
	                    that._wrapperScrolled = true;
	                }
	            } else if (that._wrapperScrolled) {
	                if (!that._isWrapperScrolledToBottom()) {
	                    wrapper.scrollTop(initialScrollTop - kendo.support.scrollbar());
	                    that._scrollTop = wrapper.scrollTop();
	                }

	                that._wrapperScrolled = false;
	            }
	        },

	        _scrollTo: function(scrollTop) {
	            var that = this;
	            var scrollbar = that.verticalScrollbar;

	            if (scrollbar.scrollTop() !== scrollTop) {
	                that._preventScroll = true;
	            }

	            that.wrapper.scrollTop(scrollTop);
	            that._scrollTop = that.wrapper.scrollTop();

	            scrollbar.scrollTop(scrollTop);
	            that._scrollbarTop = scrollbar.scrollTop();
	        },

	        _isScrolledToTop: function() {
	            return this.verticalScrollbar.scrollTop() === 0;
	        },

	        _isScrolledToBottom: function() {
	            var scrollbar = this.verticalScrollbar;
	            var scrollTop = scrollbar.scrollTop();

	            return (scrollTop > 0 && scrollTop >= parseInt(scrollbar[0].scrollHeight - scrollbar.height(), 10));
	        },

	        _isWrapperScrolledToBottom: function() {
	            var wrapper = this.wrapper;

	            return (wrapper.scrollTop() >= parseInt(wrapper[0].scrollHeight - wrapper.height(), 10));
	        },

	        itemIndex: function(rowIndex) {
	            var rangeStart = this._rangeStart || this.dataSource.skip() || 0;

	            return rangeStart + rowIndex;
	        },

	        position: function(index) {
	            var rangeStart = this._rangeStart || this.dataSource.skip() || 0;
	            var pageSize = this.dataSource.pageSize();
	            var result;

	            if (index > rangeStart) {
	                result = index - rangeStart;
	            } else {
	                result = rangeStart - index - 1;
	            }

	            return result > pageSize ? pageSize : result;
	        },

	        scrollIntoView: function(row) {
	            var container = this.wrapper[0];
	            var containerHeight = container.clientHeight;
	            var containerScroll = !this._isScrolledToBottom() ? (this._scrollTop || container.scrollTop) : container.scrollTop;
	            var elementOffset = row[0].offsetTop;
	            var elementHeight = row[0].offsetHeight;

	            if (containerScroll > elementOffset) {
	                this.verticalScrollbar[0].scrollTop -= containerHeight / 2;
	            } else if (elementOffset + elementHeight >=  containerScroll + containerHeight) {
	                this.verticalScrollbar[0].scrollTop += containerHeight / 2;
	            }
	        },

	        _fetch: function(firstItemIndex, lastItemIndex, scrollingUp) {
	            var that = this,
	                dataSource = that.dataSource,
	                itemHeight = that.itemHeight,
	                take = dataSource.take(),
	                rangeStart = that._rangeStart || dataSource.skip() || 0,
	                currentSkip = math.floor(firstItemIndex / take) * take,
	                fetching = false,
	                prefetchAt = 0.33;
	            var scrollbar = that.verticalScrollbar;
	            var webkitCorrection = browser.webkit ? 1 : 0;
	            var total = dataSource._isGroupPaged() ? dataSource.groupsTotal(true) : dataSource.total();

	            if (firstItemIndex < rangeStart) {

	                fetching = true;
	                rangeStart = math.max(0, lastItemIndex - take);
	                that._scrollTop = scrollbar.scrollTop() - (rangeStart * itemHeight);
	                that._page(rangeStart, take);

	            } else if (lastItemIndex >= rangeStart + take && !scrollingUp) {

	                fetching = true;
	                rangeStart = math.min(firstItemIndex, total - take);

	                //ensure the scrollbar can be scrolled to bottom with mouse drag
	                if (scrollbar.scrollTop() >= scrollbar[0].scrollHeight - scrollbar[0].offsetHeight - webkitCorrection) {
	                    that._scrollTop = that.wrapper[0].scrollHeight - that.wrapper[0].offsetHeight;
	                } else if (that.dataSource._isGroupPaged() && firstItemIndex >= total - take) {
	                    that._scrollTop = that.wrapper[0].scrollHeight - that.wrapper[0].offsetHeight - (that._scrollTop - that._prevScrollTop);
	                } else {
	                    that._scrollTop = itemHeight;
	                }

	                that._page(rangeStart, take);

	            } else if (!that._fetching && that.options.prefetch) {

	                if (firstItemIndex < (currentSkip + take) - take * prefetchAt && firstItemIndex > take) {
	                    dataSource.prefetch(currentSkip - take, take, $.noop);
	                }
	                if (lastItemIndex > currentSkip + take * prefetchAt) {
	                    dataSource.prefetch(currentSkip + take, take, $.noop);
	                }

	            }
	            return fetching;
	        },

	        fetching: function() {
	            return this._fetching;
	        },

	        _page: function(skip, take, callback) {
	            var that = this,
	                delayLoading = !that.options.prefetch,
	                dataSource = that.dataSource,
	                isGroupPaged = dataSource._isGroupPaged();
	            callback = isFunction(callback) ? callback : $.noop;

	            if (that.trigger(PAGING, { skip: skip, take: take })) {
	                return;
	            }

	            clearTimeout(that._timeout);
	            that._fetching = true;
	            that._rangeStart = skip;

	            if ((isGroupPaged && dataSource._groupRangeExists(skip, skip + take)) || (!isGroupPaged && dataSource.inRange(skip, take))) {
	                kendo.ui.progress($(that.wrapper).parent(), true);

	                dataSource.range(skip, take, function() {
	                    kendo.ui.progress($(that.wrapper).parent(), false);
	                    callback();
	                    that.trigger(PAGE);
	                }, "page");
	            } else {
	                if (!delayLoading) {
	                    kendo.ui.progress(that.wrapper.parent(), true);
	                }

	                that._timeout = setTimeout(function() {
	                    if (!that._scrolling) {

	                        if (delayLoading) {
	                            kendo.ui.progress(that.wrapper.parent(), true);
	                        }

	                        dataSource.range(skip, take, function() {
	                            kendo.ui.progress(that.wrapper.parent(), false);
	                            callback();
	                            that.trigger(PAGE);
	                        });
	                    }
	                }, 100);
	            }
	        },

	        repaintScrollbar: function(shouldScrollWrapper) {
	            var that = this,
	                html = "",
	                maxHeight = that.options.maxScrollHeight,
	                dataSource = that.dataSource,
	                scrollbar = !kendo.support.kineticScrollNeeded ? kendo.support.scrollbar() : 0,
	                wrapperElement = that.wrapper[0],
	                totalHeight,
	                idx,
	                itemHeight;
	            var wasScrolledToBottom = that._isScrolledToBottom();

	            itemHeight = that.itemHeight = that.options.itemHeight() || 0;

	            var addScrollBarHeight = (wrapperElement.scrollWidth > wrapperElement.offsetWidth) ? scrollbar : 0;

	            totalHeight = (dataSource._isGroupPaged() ? dataSource.groupsTotal(true) : dataSource.total()) * itemHeight + addScrollBarHeight;

	            for (idx = 0; idx < math.floor(totalHeight / maxHeight) ; idx++) {
	                html += '<div style="width:1px;height:' + maxHeight + 'px"></div>';
	            }

	            if (totalHeight % maxHeight) {
	                html += '<div style="width:1px;height:' + (totalHeight % maxHeight) + 'px"></div>';
	            }

	            that.verticalScrollbar.html(html);

	            if (wasScrolledToBottom && !that._isScrolledToBottom() && !that.dataSource._isGroupPaged()) {
	                that.scrollToBottom();
	            }

	            if (typeof(that._scrollTop) !== "undefined" && !!shouldScrollWrapper) {
	                wrapperElement.scrollTop = that._scrollTop;
	                that._scrollWrapperOnColumnResize();
	            }
	        },

	        refresh: function(e) {
	            var that = this,
	                dataSource = that.dataSource,
	                rangeStart = that._rangeStart;
	            var action = (e || {}).action;
	            var shouldScrollWrapper = that._isScrolledToBottom() || !action || (action !== ITEM_CHANGE && action !== REMOVE && action !== SYNC);

	            kendo.ui.progress(that.wrapper.parent(), false);
	            clearTimeout(that._timeout);

	            that.repaintScrollbar(shouldScrollWrapper);

	            if (that.drag) {
	                that.drag.cancel();
	            }

	            if (typeof(rangeStart) !== "undefined" && !that._fetching) { // we are rebound from outside local range should be reset
	                if (!action || (action !== SYNC && action !== ITEM_CHANGE && action !== "expandGroup")) {
	                    that._rangeStart = dataSource.skip();
	                }

	                if (dataSource.page() === 1 && (!action || (action !== SYNC && action !== ITEM_CHANGE && action !== "expandGroup" && action !== "collapseGroup"))) {
	                    // reset the scrollbar position if datasource is filtered
	                    that.verticalScrollbar[0].scrollTop = 0;
	                }
	            }

	            that._fetching = false;
	        }
	    });

	    function attrEquals(attrName, attrValue) {
	        return "[" + kendo.attr(attrName) + "=" + attrValue + "]";
	    }

	    function groupCells(count) {
	        return new Array(count + 1).join('<td class="k-group-cell">&nbsp;</td>');
	    }

	    function stringifyAttributes(attributes) {
	        var attr,
	            result = " ";

	        if (attributes) {
	            if (typeof attributes === STRING) {
	                return attributes;
	            }

	            for (attr in attributes) {
	                if (attributes[attr] !== '') {
	                    result += attr + '="' + attributes[attr] + '"';
	                }
	            }
	        }
	        return result;
	    }

	    var defaultCommands = {
	        create: {
	            text: "Add new record",
	            className: "k-grid-add",
	            iconClass: "k-icon k-i-plus"
	        },
	        cancel: {
	            text: "Cancel changes",
	            className: "k-grid-cancel-changes",
	            iconClass: "k-icon k-i-cancel"
	        },
	        save: {
	            text: "Save changes",
	            className: "k-grid-save-changes",
	            iconClass: "k-icon k-i-check"
	        },
	        destroy: {
	            text: "Delete",
	            className: "k-grid-delete",
	            iconClass: "k-icon k-i-close"
	        },
	        edit: {
	            text: "Edit",
	            className: "k-grid-edit",
	            iconClass: "k-icon k-i-edit"
	        },
	        update: {
	            text: "Update",
	            className: "k-primary k-grid-update",
	            iconClass: "k-icon k-i-check"
	        },
	        canceledit: {
	            text: "Cancel",
	            className: "k-grid-cancel",
	            iconClass: "k-icon k-i-cancel"
	        },
	        excel: {
	            text: "Export to Excel",
	            className: "k-grid-excel",
	            iconClass: "k-icon k-i-file-excel"
	        },
	        pdf: {
	            text: "Export to PDF",
	            className: "k-grid-pdf",
	            iconClass: "k-icon k-i-file-pdf"
	        },
	        search: {
	            text: "Search...",
	            className: "k-grid-search"
	        }
	    };

	    function cursor(context, value) {
	        $('th, th .k-grid-filter, th .k-link', context)
	            .add(document.body)
	            .css('cursor', value);
	    }

	    function reorder(selector, source, dest, before, count) {
	        var sourceIndex = source;
	        source = $();
	        count = count || 1;
	        for (var idx = 0; idx < count; idx++) {
	            source = source.add(selector.eq(sourceIndex + idx));
	        }

	        if (typeof dest == "number") {
	            source[before ? "insertBefore" : "insertAfter"](selector.eq(dest));
	        } else {
	            source.appendTo(dest);
	        }
	    }

	    function elements(lockedContent, content, filter) {
	        return $(lockedContent).add(content).find(filter);
	    }

	    function attachCustomCommandEvent(context, container, commands) {
	        var idx,
	            length,
	            command,
	            commandName;

	        commands = !isArray(commands) ? [commands] : commands;

	        for (idx = 0, length = commands.length; idx < length; idx++) {
	            command = commands[idx];

	            if (isPlainObject(command) && command.click) {
	                commandName = command.name || command.text;
	                container.on(CLICK + NS, "a.k-grid-" + (commandName || "").replace(/\s/g, ""), { commandName: commandName }, proxy(command.click, context));
	            }
	        }
	    }

	    function normalizeColumns(columns, encoded, hide, locked, parentIds) {
	        return map(columns, function(column) {
	            column = typeof column === STRING ? { field: column } : column;

	            var hidden;
	            column.parentIds = parentIds;

	            if (!isVisible(column) || hide) {
	                column.attributes = addHiddenStyle(column.attributes);
	                column.footerAttributes = addHiddenStyle(column.footerAttributes);
	                column.headerAttributes = addHiddenStyle(column.headerAttributes);
	                hidden = true;
	            }

	            var uid = kendo.guid();
	            if (locked && !column.locked) {
	                column.locked = locked;
	            }

	            column.headerAttributes = extend({headers: parentIds}, column.headerAttributes);
	            if (!column.headerAttributes.id) {
	                column.headerAttributes = extend({id: uid}, column.headerAttributes);
	            } else {
	                uid = column.headerAttributes.id;
	            }

	            if (column.columns) {
	                column.columns = normalizeColumns(column.columns, encoded, hidden, column.locked, parentIds ? (parentIds + " " + uid): uid);
	            }
	            return extend({ encoded: encoded, hidden: hidden, locked: locked }, column);
	        });
	    }

	    function columnParent(column, columns) {
	        var parents = [];
	        columnParents(column, columns, parents);
	        return parents[parents.length - 1];
	    }

	    function columnParents(column, columns, parents) {
	        parents = parents || [];

	        for (var idx = 0; idx < columns.length; idx++) {
	            if (column === columns[idx]) {
	                return true;
	            } else if (columns[idx].columns) {
	                var inserted = parents.length;
	                parents.push(columns[idx]);
	                if (!columnParents(column, columns[idx].columns, parents)) {
	                    parents.splice(inserted, parents.length - inserted);
	                } else {
	                    return true;
	                }
	            }
	        }
	        return false;
	    }

	    function setColumnVisibility(column, visible) {
	        setVisibility(column, visible, visible);
	    }

	    function setVisibility(column, visible, show) {
	        var method = show ? removeHiddenStyle : addHiddenStyle;
	        column.hidden = !visible;
	        column.attributes = method(column.attributes);
	        column.footerAttributes = method(column.footerAttributes);
	        column.headerAttributes = method(column.headerAttributes);
	    }


	    function setColumnMediaVisibility(column, visible) {
	        setColumnMatchesMedia(column);
	        var hideByMedia = column._hideByMedia;
	        setVisibility(column, visible, hideByMedia ? column.matchesMedia : visible);
	    }

	    function setColumnMatchesMedia(column) {
	        column.matchesMedia = columnMatchesMedia(column);
	    }

	    function columnMatchesMedia(column) {
	        return column && (isUndefined(column.media) || (!isUndefined(column.media) && kendo.matchesMedia(column.media)));
	    }

	    function isCellVisible() {
	        return this.style.display !== "none";
	    }

	    function isElementVisible(element) {
	        return $(element)[0].style.display !== "none";
	    }

	    function isVisible(column) {
	        return visibleColumns([column]).length > 0;
	    }

	    function visibleColumns(columns) {
	        return grep(columns, function(column) {
	            var result = !column.hidden && column.matchesMedia !== false;

	            if (result && column.columns) {
	                result = visibleColumns(column.columns).length > 0;
	            }
	            return result;
	        });
	    }

	    function columnsWithMedia(columns) {
	        var result = [];
	        var column;

	        for (var i = 0; i < columns.length; i++) {
	            column = columns[i];

	            if (!isUndefined(column.media)) {
	                if (!isUndefined(column.minScreenWidth)) {
	                    throw new Error("Using 'media' and 'minScreenWidth' options at the same time is not supported.");
	                }

	                result.push(column);
	            }

	            if (column.columns) {
	                result = result.concat(columnsWithMedia(column.columns));
	            }
	        }

	        return result;
	    }

	    function isUndefined(value) {
	        return typeof value === "undefined";
	    }

	    function toJQuery(elements) {
	        return $(elements).map(function() { return this.toArray(); });
	    }

	    function updateCellRowSpan(cell, columns, sourceLockedColumnsCount) {
	        var lockedColumnDepth = depth(lockedColumns(columns));
	        var nonLockedColumnDepth = depth(nonLockedColumns(columns));

	        var rowSpan = cell.rowSpan;
	        if (sourceLockedColumnsCount) {
	            if (lockedColumnDepth > nonLockedColumnDepth) {
	                cell.rowSpan = (rowSpan - (lockedColumnDepth - nonLockedColumnDepth)) || 1;
	            } else {
	                cell.rowSpan = rowSpan + (nonLockedColumnDepth - lockedColumnDepth);
	            }
	        } else {
	            if (lockedColumnDepth > nonLockedColumnDepth) {
	                cell.rowSpan = rowSpan + (lockedColumnDepth - nonLockedColumnDepth);
	            } else {
	                cell.rowSpan = (rowSpan - (nonLockedColumnDepth - lockedColumnDepth)) || 1;
	            }
	        }
	    }

	    function moveCellsBetweenContainers(sources, target, leafs, columns, container, destination, groups, action) {
	        var sourcesDepth = depth(sources);
	        var targetDepth = depth([target]);

	        if (sourcesDepth > targetDepth) {
	            var groupCells = new Array(groups + 1).join('<th class="k-group-cell k-header" scope="col">&nbsp;</th>');
	            var rows = destination.children(":not(.k-filter-row)");
	            $(new Array((sourcesDepth - targetDepth) + 1).join("<tr>" + groupCells + "</tr>")).insertAfter(rows.last());
	        }

	        addRowSpanValue(destination, sourcesDepth - targetDepth);

	        moveCells(leafs, columns, container, destination, action);
	    }

	    function updateCellIndex(thead, columns, offset) {
	        offset = offset || 0;

	        var position;
	        var cell;
	        var allColumns = columns;
	        columns = leafColumns(columns);

	        var cells = {};
	        var rows = thead.find(">tr:not(.k-filter-row)");

	        var filter = function() {
	            var el = $(this);
	            return !el.hasClass("k-group-cell") && !el.hasClass("k-hierarchy-cell");
	        };

	        for (var idx = 0, length = columns.length; idx < length; idx++) {
	            position = columnPosition(columns[idx], allColumns);

	            if (!cells[position.row]) {
	                cells[position.row] = rows.eq(position.row)
	                    .find(".k-header")
	                    .filter(filter);
	            }

	            cell = cells[position.row].eq(position.cell);
	            cell.attr(kendo.attr("index"), offset + idx);
	        }


	        return columns.length;
	    }

	    function depth(columns) {
	        var result = 1;
	        var max = 0;

	        for (var idx = 0; idx < columns.length; idx++) {
	            if (columns[idx].columns) {
	                var temp = depth(columns[idx].columns);
	                if (temp > max) {
	                    max = temp;
	                }
	            }
	        }
	        return result + max;
	    }

	    function moveCells(leafs, columns, container, destination, action) {
	        var sourcePosition = columnVisiblePosition(leafs[0], columns);

	        var ths = container.find(">tr:not(.k-filter-row):eq(" + sourcePosition.row + ")>th.k-header");

	        var t = $();
	        var sourceIndex = sourcePosition.cell;
	        var idx;

	        for (idx = 0; idx < leafs.length; idx++) {
	            t = t.add(ths.eq(sourceIndex + idx));
	        }

	        destination.find(">tr:not(.k-filter-row)").eq(sourcePosition.row)[action](t);

	        var children = [];
	        for (idx = 0; idx < leafs.length; idx++) {
	            if (leafs[idx].columns) {
	                children = children.concat(leafs[idx].columns);
	            }
	        }

	        if (children.length) {
	            moveCells(children, columns, container, destination, action);
	        }
	    }

	    function columnPosition(column, columns, row, cellCounts) {
	        var result;
	        var idx;

	        row = row || 0;
	        cellCounts = cellCounts || {};
	        cellCounts[row] = cellCounts[row] || 0;

	        for (idx = 0; idx < columns.length; idx++) {
	           if (columns[idx] == column) {
	                result = { cell: cellCounts[row], row: row };
	                break;
	           } else if (columns[idx].columns) {
	               result = columnPosition(column, columns[idx].columns, row + 1, cellCounts);
	               if (result) {
	                    break;
	               }
	           }

	           cellCounts[row]++;
	        }
	        return result;
	    }
	    function findParentColumnWithChildren(columns, index, source, rtl) {
	        var target;
	        var locked = !!source.locked;
	        var targetLocked;

	        do {
	            target = columns[index];
	            index += rtl ? 1 : -1;
	            targetLocked = !!target.locked;
	        } while(target && index > -1 && index < columns.length && target != source && !target.columns && targetLocked === locked);

	        return target;
	    }

	    function findReorderTarget(columns, target, source, before, masterColumns) {
	        if (target.columns) {
	            target = target.columns;
	            return target[before ? 0 : target.length - 1];
	        } else {
	            var parent = columnParent(target, columns);
	            var parentColumns;

	            if (parent) {
	                parentColumns = parent.columns;
	            } else {
	                parentColumns = columns;
	            }

	            var index = inArray(target, parentColumns);
	            if (index === 0 && before) {
	                index++;
	            } else if ((index == parentColumns.length - 1 && !before) || (!source.locked && !target.columns && !before)) {
	                index--;
	            } else if (index > 0 || (index === 0 && !before)) {
	                index++;
	            }

	            var sourceIndex = inArray(source, parentColumns);
	            target = findParentColumnWithChildren(parentColumns, index, source, sourceIndex > index);
	            var targetIndex = inArray(target, masterColumns);
	            if (target.columns && (!targetIndex || targetIndex === parentColumns.length -1)) {
	                return null;
	            }

	            if (target && target != source && target.columns) {
	                return findReorderTarget(columns, target, source, before, masterColumns);
	            }
	        }
	        return null;
	    }

	    function columnVisiblePosition(column, columns, row, cellCounts) {
	        var result;
	        var idx;

	        row = row || 0;
	        cellCounts = cellCounts || {};
	        cellCounts[row] = cellCounts[row] || 0;

	        for (idx = 0; idx < columns.length; idx++) {
	           if (columns[idx] == column) {
	                result = { cell: cellCounts[row], row: row };
	                break;
	           } else if (columns[idx].columns) {
	               result = columnVisiblePosition(column, columns[idx].columns, row + 1, cellCounts);
	               if (result) {
	                    break;
	               }
	           }

	           if (!columns[idx].hidden) {
	               cellCounts[row]++;
	           }
	        }
	        return result;
	    }

	    function flatColumnsInDomOrder(columns) {
	        var result = flatColumns(lockedColumns(columns));
	        return result.concat(flatColumns(nonLockedColumns(columns)));
	    }

	    function targetParentContainerIndex(flatColumns, columns, sourceIndex, targetIndex) {
	        var column = flatColumns[sourceIndex];
	        var target = flatColumns[targetIndex];

	        var parent = columnParent(column, columns);
	        columns = parent ? parent.columns : columns;

	        return inArray(target, columns);
	    }

	    function flatColumns(columns) {
	        var result = [];
	        var children = [];
	        for (var idx = 0; idx < columns.length; idx++) {
	            result.push(columns[idx]);
	            if (columns[idx].columns) {
	                children = children.concat(columns[idx].columns);
	            }

	        }
	        if (children.length) {
	            result = result.concat(flatColumns(children));
	        }
	        return result;
	    }

	    function hiddenLeafColumnsCount(columns) {
	        var counter = 0;
	        var column;

	        for (var idx = 0; idx < columns.length; idx++) {
	            column = columns[idx];

	            if (column.columns) {
	                counter += hiddenLeafColumnsCount(column.columns);
	            } else if (column.hidden) {
	                counter++;
	            }
	        }
	        return counter;
	    }

	    function sumWidths(cols) {
	        var width = 0;

	        for (var idx = 0, length = cols.length; idx < length; idx++) {
	            if (!cols[idx].hidden) {
	                width += parseInt(cols[idx].width, 10);
	            }
	        }

	        return width;
	    }

	    function columnsWidth(cols) {
	        var colWidth, width = 0;

	        for (var idx = 0, length = cols.length; idx < length; idx++) {
	            colWidth = cols[idx].style.width;
	            if (colWidth && colWidth.indexOf("%") == -1) {
	                width += parseInt(colWidth, 10);
	            }
	        }

	        return width;
	    }

	    function removeRowSpanValue(container, count) {
	        var cells = container.find("tr:not(.k-filter-row) th:not(.k-group-cell,.k-hierarchy-cell)");

	        var rowSpan;
	        for (var idx = 0; idx < cells.length; idx++) {
	            rowSpan = cells[idx].rowSpan;
	            if (rowSpan > 1) {
	                cells[idx].rowSpan = (rowSpan - count) || 1;
	            }
	        }
	    }

	    function addRowSpanValue(container, count) {
	        var cells = container.find("tr:not(.k-filter-row) th:not(.k-group-cell,.k-hierarchy-cell)");

	        for (var idx = 0; idx < cells.length; idx++) {
	            cells[idx].rowSpan += count;
	        }
	    }

	    function removeEmptyRows(container) {
	        var rows = container.find("tr:not(.k-filter-row)");

	        var emptyRowsCount = rows.filter(function() {
	            return !$(this).children().length;
	        }).remove().length;

	        var cells = rows.find("th:not(.k-group-cell,.k-hierarchy-cell)");

	        for (var idx = 0; idx < cells.length; idx++) {
	            if (cells[idx].rowSpan > 1) {
	                cells[idx].rowSpan -= emptyRowsCount;
	            }
	        }
	        return rows.length - emptyRowsCount;
	    }

	    function mapColumnToCellRows(columns, cells, rows, rowIndex, offset) {
	        var idx, row, length, children = [];

	        for (idx = 0, length = columns.length; idx < length; idx++) {
	            row = rows[rowIndex] || [];
	            row.push(cells.eq(offset + idx));
	            rows[rowIndex] = row;

	            if (columns[idx].columns) {
	                children = children.concat(columns[idx].columns);
	            }
	        }

	        if (children.length) {
	            mapColumnToCellRows(children, cells, rows, rowIndex + 1, offset + columns.length);
	        }
	    }

	    function setLeftAndRightStyles(element, left, right) {
	        element.css({
	            "left": left,
	            "right": right
	        });
	    }

	    function createColumnAttribute(column, attribute, property) {
	        column[attribute] = column[attribute] || {};
	        column[attribute][property] = column[attribute][property] || "";
	    }

	    function addColumnAttribute(column, attribute, property, value) {
	        createColumnAttribute(column, attribute, property);

	        if (column[attribute][property] !== "") {
	            column[attribute][property] += " " + value;
	        } else {
	            column[attribute][property] = value;
	        }
	    }

	    function removeColumnAttribute(column, attribute, property, value) {
	        createColumnAttribute(column, attribute, property);

	        column[attribute][property] = column[attribute][property].replace(value, "");
	    }

	    function lockedColumns(columns) {
	        return grep(columns, function(column) {
	            return column.locked;
	        });
	    }

	    function nonLockedColumns(columns) {
	        return grep(columns, function(column) {
	            return !column.locked;
	        });
	    }

	    function stickyColumns(columns) {
	        return grep(columns, function(column) {
	            return column.sticky && !column.locked;
	        });
	    }

	    function visibleStickyColumns(columns) {
	        return grep(columns, function(column) {
	            return column.sticky && !column.locked && isVisible(column);
	        });
	    }

	    function visibleNonLockedColumns(columns) {
	        return grep(columns, function(column) {
	            return !column.locked && isVisible(column);
	        });
	    }

	    function visibleLockedColumns(columns) {
	        return grep(columns, function(column) {
	            return column.locked && isVisible(column);
	        });
	    }

	    function visibleLeafColumns(columns) {
	        var result = [];

	        for (var idx = 0; idx < columns.length; idx++) {
	            if (columns[idx].hidden) {
	                continue;
	            }

	            if (columns[idx].columns) {
	                result = result.concat(visibleLeafColumns(columns[idx].columns));
	            } else {
	                result.push(columns[idx]);
	            }
	        }

	        return result;
	    }

	    function childColumns(columns) {
	        var result = [];

	        for (var idx = 0; idx < columns.length; idx++) {
	            if (columns[idx].columns) {
	                result = result.concat(columns[idx].columns);
	            }
	        }

	        return result;
	    }

	    function visibleChildColumns(columns) {
	        var result = childColumns(columns);

	        result = result.filter(function(e) {
	            return !e.hidden;
	        });

	        return result;
	    }

	    function leafColumns(columns) {
	        var result = [];

	        for (var idx = 0; idx < columns.length; idx++) {
	            if (!columns[idx].columns) {
	                result.push(columns[idx]);
	                continue;
	            }
	            result = result.concat(leafColumns(columns[idx].columns));
	        }

	        return result;
	    }

	    function getColumnsFields(columns) {
	        var result = [];
	        columns = leafColumns(columns);

	        for (var idx = 0; idx < columns.length; idx++) {
	            if (typeof columns[idx] === "string") {
	                result.push(columns[idx]);
	            } else if (columns[idx].field) {
	                result.push(columns[idx].field);
	            }
	        }
	        return result;
	    }

	    function leafDataCells(container) {
	        var rows = container.find(">tr:not(.k-filter-row)");

	        var filter = function() {
	            var el = $(this);
	            return !el.hasClass("k-group-cell") && !el.hasClass("k-hierarchy-cell");
	        };

	        var cells = $();
	        if (rows.length > 1) {
	            cells = rows.find("th")
	                .filter(filter)
	                .filter(function() { return this.rowSpan > 1; });
	        }

	        cells = cells.add(rows.last().find("th").filter(filter));

	        var indexAttr = kendo.attr("index");
	        cells.sort(function(a, b) {
	            a = $(a);
	            b = $(b);

	            var indexA = a.attr(indexAttr);
	            var indexB = b.attr(indexAttr);

	            if (indexA === undefined) {
	                indexA = $(a).index();
	            }
	            if (indexB === undefined) {
	                indexB = $(b).index();
	            }

	            indexA = parseInt(indexA, 10);
	            indexB = parseInt(indexB, 10);
	            return indexA > indexB ? 1 : (indexA < indexB ? -1 : 0);
	        });

	        return cells;
	    }

	    function parentColumnsCells(cell) {
	        var container = cell.closest("table");
	        var result = $().add(cell);

	        var row = cell.closest("tr");
	        var headerRows = container.find("tr:not(.k-filter-row)");
	        var level = headerRows.index(row);
	        if (level > 0) {
	            var parent = headerRows.eq(level - 1);
	            var parentCellsWithChildren = parent.find("th:not(.k-group-cell,.k-hierarchy-cell)").filter(function() {
	                return !$(this).attr("rowspan");
	            });

	            var offset = 0;
	            var index = row.find("th:not(.k-group-cell,.k-hierarchy-cell)").index(cell);

	            var prevCells = cell.prevAll(":not(.k-group-cell,.k-hierarchy-cell)").filter(function() {
	                return this.colSpan > 1;
	            });

	            for (var idx = 0; idx < prevCells.length; idx++) {
	                offset += prevCells[idx].colSpan || 1;
	            }

	            index += Math.max(offset - 1, 0);

	            offset = 0;
	            for (idx = 0; idx < parentCellsWithChildren.length; idx++) {
	                var parentCell = parentCellsWithChildren.eq(idx);
	                if (parentCell.attr("data-colspan")) {
	                    offset += parentCell[0].getAttribute("data-colspan");
	                } else {
	                    offset += 1;
	                }
	                if (index >= idx && index < offset) {
	                    result = parentColumnsCells(parentCell).add(result);
	                    break;
	                }
	            }
	        }
	        return result;
	    }

	    function childColumnsCells(cell) {
	        var container = cell.closest("thead");
	        var result = $().add(cell);

	        var row = cell.closest("tr");
	        var headerRows = container.find("tr:not(.k-filter-row)");
	        var level = headerRows.index(row) + cell[0].rowSpan;
	        var colSpanAttr = kendo.attr("colspan");

	        if (level <= headerRows.length - 1) {
	            var child = row.next();
	            var prevCells = cell.prevAll(":not(.k-group-cell,.k-hierarchy-cell)");

	            var idx;

	            prevCells = prevCells.filter(function() {
	                return !this.rowSpan || this.rowSpan === 1;
	            });

	            var offset = 0;

	            for (idx = 0; idx < prevCells.length; idx++) {
	                offset += parseInt(prevCells.eq(idx).attr(colSpanAttr), 10) || 1;
	            }

	            var cells = child.find("th:not(.k-group-cell,.k-hierarchy-cell)");
	            var colSpan = parseInt(cell.attr(colSpanAttr), 10) || 1;

	            idx = 0;

	            while (idx < colSpan) {
	                child = cells.eq(idx + offset);
	                result = result.add(childColumnsCells(child));
	                var value = parseInt(child.attr(colSpanAttr), 10);
	                if (value > 1) {
	                    colSpan -= value - 1;
	                }
	                idx++;
	            }
	        }

	        return result;
	    }

	    function appendContent(tbody, table, html, empty) {
	        var placeholder,
	            tmp = tbody;

	        // necessary for AngularJS to cleanup its guts.
	        if (empty) {
	            tbody.empty();
	        }

	        if (tbodySupportsInnerHtml) {
	            tbody[0].innerHTML = html;
	        } else {
	            placeholder = document.createElement("div");
	            placeholder.innerHTML = "<table><tbody>" + html + "</tbody></table>";
	            tbody = placeholder.firstChild.firstChild;
	            table[0].replaceChild(tbody, tmp[0]);
	            tbody = $(tbody);
	        }
	        return tbody;
	    }

	    function addHiddenStyle(attr) {
	        attr = attr || {};
	        var style = attr.style;

	        if(!style) {
	            style = "display:none";
	        } else {
	            style = style.replace(/display:[^;]*/i, "display:none");
	            if(!style.match(/display:/i)) {
	                style = style.replace(/(.*)?/i, "display:none;$1");
	            }
	        }

	        return extend({}, attr, { style: style });
	    }

	    function hasHiddenStyle(attr) {
	        attr = attr || {};
	        var style = attr.style || "";

	        return style.indexOf("display:none") !== -1;
	    }

	    function removeHiddenStyle(attr) {
	        attr = attr || {};
	        var style = attr.style;

	        if(style) {
	            attr.style = style.replace(/(display\s*:\s*none\s*;?)*/ig, "");
	        }

	        return attr;
	    }

	    function normalizeCols(table, visibleColumns, hasDetails, groups) {
	        var colgroup = table.find(">colgroup"),
	            width,
	            cols = map(visibleColumns, function(column) {
	                    width = column.width;
	                    if (width && parseInt(width, 10) !== 0) {
	                        return kendo.format('<col style="width:{0}"/>', typeof width === STRING? width : width + "px");
	                    }

	                    return "<col />";
	                });

	        if (hasDetails || colgroup.find(".k-hierarchy-col").length) {
	            cols.splice(0, 0, '<col class="k-hierarchy-col" />');
	        }

	        if (colgroup.length) {
	            colgroup.remove();
	        }

	        colgroup = $(new Array(groups + 1).join('<col class="k-group-col">') + cols.join(""));
	        if (!colgroup.is("colgroup")) {
	            colgroup = $("<colgroup/>").append(colgroup);
	        }

	        table.prepend(colgroup);

	        // fill gap after column hiding
	        if (browser.msie && browser.version == 8) {
	            table.css("display", "inline-table");
	            window.setTimeout(function(){table.css("display", "");}, 1);
	        }
	    }

	    function normalizeHeaderCells(container, columns) {
	        var lastIndex = 0;
	        var idx , len;
	        var th = container.find("th:not(.k-group-cell)");

	        for (idx = 0, len = columns.length; idx < len; idx ++) {
	            if (columns[idx].locked) {
	                th.eq(idx).insertBefore(th.eq(lastIndex));
	                th = container.find("th:not(.k-group-cell)");
	                lastIndex ++;
	            }
	        }
	    }

	    function convertToObject(array) {
	        var result = {},
	            item,
	            idx,
	            length;

	        for (idx = 0, length = array.length; idx < length; idx++) {
	            item = array[idx];
	            result[item.value] = item.text;
	        }

	        return result;
	    }

	    function formatGroupValue(value, format, columnValues, encoded) {
	        var isForeignKey = columnValues && columnValues.length && isPlainObject(columnValues[0]) && "value" in columnValues[0],
	            groupValue = isForeignKey ? convertToObject(columnValues)[value] : value;

	        groupValue = groupValue != null ? groupValue : "";

	        return format ? kendo.format(format, groupValue) : (encoded === false ? groupValue : kendo.htmlEncode(groupValue));
	    }

	    function setCellVisibility(cells, index, visible) {
	        var pad = 0,
	            state,
	            cell = cells[pad];

	        while (cell) {
	            state = visible ? true : cell.style.display !== "none";

	            if (state && !nonDataCellsRegExp.test(cell.className) && --index < 0) {
	                cell.style.display = visible ? "" : "none";
	                break;
	            }

	            cell = cells[++pad];
	        }
	    }

	    function hideColumnCells(rows, columnIndex) {
	        var idx = 0,
	            length = rows.length,
	            cell, row;

	        for ( ; idx < length; idx += 1) {
	            row = rows.eq(idx);
	            if (row.is(".k-grouping-row,.k-detail-row")) {
	                cell = row.children(":not(.k-group-cell):first,.k-detail-cell").last();
	                cell.attr("colspan", parseInt(cell.attr("colspan"), 10) - 1);
	            } else {
	                if (row.hasClass("k-grid-edit-row") && (cell = row.children(".k-edit-container")[0])) {
	                    cell = $(cell);
	                    cell.attr("colspan", parseInt(cell.attr("colspan"), 10) - 1);
	                    cell.find("col").eq(columnIndex).remove();
	                    row = cell.find("tr:first");
	                }

	                setCellVisibility(row[0].cells, columnIndex, false);
	            }
	        }
	    }

	    function groupRows(data) {
	        var result = [];
	        var item;

	        for (var idx = 0; idx < data.length; idx++) {
	            item = data[idx];
	            if (!("field" in item && "value" in item && "items" in item)) {
	                break;
	            }

	            result.push(item);

	            if (item.hasSubgroups) {
	                result = result.concat(groupRows(item.items));
	            }
	        }

	        return result;
	    }

	    function groupFooters(data) {
	        var result = [];
	        var item;

	        for (var idx = 0; idx < data.length; idx++) {
	            item = data[idx];
	            if (!("field" in item && "value" in item && "items" in item)) {
	                break;
	            }

	            if (item.hasSubgroups) {
	                result = result.concat(groupFooters(item.items));
	            }

	            result.push(item.aggregates);
	        }

	        return result;
	    }

	    function showColumnCells(rows, columnIndex) {
	        var idx = 0,
	            length = rows.length,
	            cell, row, columns;

	        for ( ; idx < length; idx += 1) {
	            row = rows.eq(idx);
	            if (row.is(".k-grouping-row,.k-detail-row")) {
	                cell = row.children(":not(.k-group-cell):first,.k-detail-cell").last();
	                cell.attr("colspan", parseInt(cell.attr("colspan"), 10) + 1);
	            } else {
	                if (row.hasClass("k-grid-edit-row") && (cell = row.children(".k-edit-container")[0])) {
	                    cell = $(cell);
	                    cell.attr("colspan", parseInt(cell.attr("colspan"), 10) + 1);
	                    normalizeCols(cell.find(">form>table"), visibleColumns(columns), false,  0);
	                    row = cell.find("tr:first");
	                }

	                setCellVisibility(row[0].cells, columnIndex, true);
	            }
	        }
	    }

	    function updateColspan(toAdd, toRemove, num) {
	        num = num || 1;

	        var item, idx, length;
	        for (idx = 0, length = toAdd.length; idx < length; idx++) {
	            item = toAdd.eq(idx).children().last();
	            item.attr("colspan", parseInt(item.attr("colspan"), 10) + num);

	            item = toRemove.eq(idx).children().last();
	            item.attr("colspan", parseInt(item.attr("colspan"), 10) - num);
	        }
	    }

	    function tableWidth(table) {
	        var idx, length, width = 0;
	        var cols = table.find(">colgroup>col");

	        for (idx = 0, length = cols.length; idx < length; idx += 1) {
	            width += parseInt(cols[idx].style.width, 10);
	        }

	        return width;
	    }

	    var Grid = kendo.ui.DataBoundWidget.extend({
	        init: function(element, options, events) {
	            var that = this;

	            options = isArray(options) ? { dataSource: options } : options;

	            Widget.fn.init.call(that, element, options);

	            if (events) {
	                that._events = events;
	            }

	            isRtl = kendo.support.isRtl(element);

	            that._element();

	            that._aria();

	            that._columns($.extend(true, [], that.options.columns));

	            if (that._foreignKeyPromises) {
	                $.when.apply(null, that._foreignKeyPromises)
	                    .then(function () {
	                        that._foreignKeyPromises = null;
	                        that._continueInit();
	                    });
	            } else {
	                that._continueInit();
	            }
	        },

	        _continueInit: function () {
	            var that = this;

	            that._dataSource();

	            that._stickyColumns();

	            that._tbody();

	            that._thead();

	            that._groupable();

	            that._toolbar();

	            that._pageable();

	            that._setContentHeight();

	            that._templates();

	            that._navigatable();

	            that._selectable();

	            that._clipboard();

	            that._details();

	            that._editable();

	            that._attachCustomCommandsEvent();

	            that._adaptiveColumns();

	            that._minScreenSupport();

	            if (that.options.autoBind) {
	                that.dataSource.fetch();
	            } else {
	                that._group = that._groups() > 0;
	                that._footer();
	            }

	            if (that.lockedContent) {
	                that.wrapper.addClass("k-grid-lockedcolumns");
	                that._resizeHandler = function () {
	                    that.resize();
	                };
	                $(window).on("resize" + NS, that._resizeHandler);
	            }

	            kendo.notify(that);
	        },

	        events: [
	           CHANGE,
	           "dataBinding",
	           "cancel",
	           DATABOUND,
	           DETAILEXPAND,
	           DETAILCOLLAPSE,
	           DETAILINIT,
	           FILTERMENUINIT,
	           FILTERMENUOPEN,
	           COLUMNMENUINIT,
	           COLUMNMENUOPEN,
	           EDIT,
	           BEFOREEDIT,
	           SAVE,
	           REMOVE,
	           SAVECHANGES,
	           CELLCLOSE,
	           COLUMNRESIZE,
	           COLUMNREORDER,
	           COLUMNSHOW,
	           COLUMNHIDE,
	           COLUMNLOCK,
	           COLUMNUNLOCK,
	           COLUMNSTICK,
	           COLUMNUNSTICK,
	           NAVIGATE,
	           "page",
	           "sort",
	           "filter",
	           "group",
	           "groupExpand",
	           "groupCollapse",
	           "kendoKeydown"
	        ],

	        setDataSource: function(dataSource) {
	            var that = this;
	            var scrollable = that.options.scrollable;
	            var scrollableContent;

	            that.options.dataSource = dataSource;

	            that._dataSource();

	            that._pageable();

	            that._thead();

	            if (scrollable) {
	                if (scrollable.virtual) {
	                    scrollableContent = that.content.find(">.k-virtual-scrollable-wrap");
	                    kendo.scrollLeft(scrollableContent, leftMostPosition(scrollableContent, isRtl));
	                } else {
	                    scrollableContent = that.tbody;
	                    kendo.scrollLeft(that.content, leftMostPosition(scrollableContent, isRtl));
	                }
	            }

	            if (that.options.groupable) {
	                that._groupable();
	            }

	            if (that.virtualScrollable) {
	                that.virtualScrollable.setDataSource(that.options.dataSource);
	            }

	            if (that.options.navigatable) {
	                that._navigatable();
	            }

	            if (that.options.selectable) {
	                that._selectable();
	            }

	            if (that.options.autoBind) {
	                that.dataSource.fetch();
	            }
	        },

	        options: {
	            name: "Grid",
	            columns: [],
	            toolbar: null,
	            autoBind: true,
	            filterable: false,
	            scrollable: true,
	            sortable: false,
	            selectable: false,
	            allowCopy: false,
	            navigatable: false,
	            pageable: false,
	            persistSelection: false,
	            editable: false,
	            encodeTitles: false,
	            groupable: false,
	            rowTemplate: "",
	            altRowTemplate: "",
	            search: false,
	            noRecords: false,
	            dataSource: {},
	            height: null,
	            resizable: false,
	            reorderable: false,
	            columnMenu: false,
	            detailTemplate: null,
	            columnResizeHandleWidth: 3,
	            mobile: "",
	            messages: {
	                editable: {
	                    cancelDelete: CANCELDELETE,
	                    confirmation: DELETECONFIRM,
	                    confirmDelete: CONFIRMDELETE
	                },
	                commands: {
	                    create: defaultCommands.create.text,
	                    cancel: defaultCommands.cancel.text,
	                    save: defaultCommands.save.text,
	                    destroy: defaultCommands.destroy.text,
	                    edit: defaultCommands.edit.text,
	                    update: defaultCommands.update.text,
	                    canceledit: defaultCommands.canceledit.text,
	                    excel: defaultCommands.excel.text,
	                    pdf: defaultCommands.pdf.text,
	                    search: defaultCommands.search.text
	                },
	                noRecords: NORECORDS,
	                expandCollapseColumnHeader: "",
	                groupHeader: "Press ctrl + space to group",
	                ungroupHeader: "Press ctrl + space to ungroup"
	            },
	            width: null
	        },

	        destroy: function() {
	            var that = this,
	                element;

	            that._angularItems("cleanup");
	            that._destroyColumnAttachments();

	            Widget.fn.destroy.call(that);

	            if (this._navigatableTables) {
	                this._navigatableTables.off(NS);
	                this._navigatableTables = null;
	            }

	            if (that._resizeHandler) {
	                $(window).off("resize" + NS, that._resizeHandler);
	            }

	            if (that.pager && that.pager.element) {
	                that.pager.destroy();
	            }

	            if (that.timer) {
	                clearTimeout(that.timer);
	            }

	            if (that._progressTimeOut) {
	                clearTimeout(that._progressTimeOut);
	            }

	            if (that._collapseGroupsTimeOut) {
	                clearTimeout(that._collapseGroupsTimeOut);
	            }

	            if (that._endlessFetchTimeOut) {
	                clearTimeout(that._endlessFetchTimeOut);
	            }

	            that.pager = null;

	            that._destroyGroupable();

	            if (that.options.reorderable) {
	                that.wrapper.data("kendoReorderable").destroy();
	            }

	            if (that.selectable && that.selectable.element) {
	                that.selectable.destroy();

	                that.clearArea();
	                that._selectedIds = null;

	                if (that.copyHandler) {
	                    that.wrapper.off("keydown", that.copyHandler);
	                    that.unbind(that.copyHandler);
	                }
	                if (that.updateClipBoardState) {
	                    that.unbind(that.updateClipBoardState);
	                    that.updateClipBoardState = null;
	                }
	                if (that.clearAreaHandler) {
	                    that.wrapper.off("keyup", that.clearAreaHandler);
	                }
	            }

	            that.selectable = null;

	            if (that.resizable) {
	                that.resizable.destroy();

	                if (that._resizeUserEvents) {
	                    if (that._resizeHandleDocumentClickHandler) {
	                        $(document).off("click", that._resizeHandleDocumentClickHandler);
	                    }
	                    that._resizeUserEvents.destroy();
	                    that._resizeUserEvents = null;
	                }
	                that.resizable = null;
	            }

	            that._destroyVirtualScrollable();

	            if (that.editableUserEvents) {
	                that.editableUserEvents.destroy();
	                that.editableUserEvents = null;
	            }

	            if (that._lockedContentUserEvents) {
	                that._lockedContentUserEvents.destroy();
	                that._lockedContentUserEvents = null;
	            }

	            that._destroyEditable();

	            if (that.dataSource) {
	                that.dataSource.unbind(CHANGE, that._refreshHandler)
	                           .unbind(PROGRESS, that._progressHandler)
	                           .unbind(ERROR, that._errorHandler)
	                           .unbind(SORT, that._clearSortClasses);

	                that._refreshHandler = that._progressHandler = that._errorHandler = that._clearSortClasses = null;
	            }

	            element = that.element
	                .add(that.wrapper)
	                .add(that.table)
	                .add(that.thead)
	                .add(that.wrapper.find(">.k-grid-toolbar"));

	            if (that.content) {
	                element = element
	                        .add(that.content)
	                        .add(that.content.find(">.k-virtual-scrollable-wrap"));
	            }

	            if (that.lockedHeader) {
	                that._removeLockedContainers();
	            }

	            if (that.pane) {
	                that.pane.destroy();
	            }

	            if (that._isMobile) {
	                that.wrapper.off("transitionend" + NS);
	                that.wrapper.off("contextmenu" + NS);
	            }

	            if (that.minScreenResizeHandler) {
	                $(window).off("resize", that.minScreenResizeHandler);
	            }

	            that._detachColumnMediaResizeHandler();

	            if (that._draggableInstance && that._draggableInstance.element) {
	                that._draggableInstance.destroy();
	            }

	            that._draggableInstance = null;

	            element.off(NS);

	            kendo.destroy(that.wrapper);

	            that.rowTemplate =
	            that.altRowTemplate =
	            that.lockedRowTemplate =
	            that.lockedAltRowTemplate =
	            that.detailTemplate =
	            that.footerTemplate =
	            that.groupFooterTemplate =
	            that.lockedGroupFooterTemplate =
	            that.noRecordsTemplate = null;

	            that.scrollables =
	            that.thead =
	            that.tbody =
	            that.element =
	            that.table =
	            that.content =
	            that.footer =
	            that.wrapper =
	            that.lockedTable =
	            that.lockedContent =
	            that.lockedHeader =
	            that.lockedFooter =
	            that._groupableClickHandler =
	            that._groupRows =
	            that._setContentWidthHandler = null;
	        },

	        getOptions: function() {
	            var options = this.options;
	            options.dataSource = null;

	            var result = extend(true, {}, this.options);
	            result.columns = kendo.deepExtend([], this.columns);

	            var dataSource = this.dataSource;

	            var initialData = dataSource.options.data && dataSource._data;
	            dataSource.options.data = null;

	            result.dataSource = $.extend(true, {}, dataSource.options);

	            dataSource.options.data = initialData;

	            result.dataSource.data = initialData;
	            result.dataSource.page = dataSource.page();
	            result.dataSource.filter = $.extend(true, {}, dataSource.filter());
	            result.dataSource.pageSize = dataSource.pageSize();
	            result.dataSource.sort = dataSource.sort();
	            result.dataSource.group = dataSource.group();
	            result.dataSource.aggregate = dataSource.aggregate();

	            if (result.dataSource.transport) {
	                result.dataSource.transport.dataSource = null;
	            }

	            if (result.pageable && result.pageable.pageSize) {
	                result.pageable.pageSize = dataSource.pageSize();
	            }

	            result.$angular = undefined;

	            return result;
	        },

	        setOptions: function(options) {
	            var currentOptions = this.getOptions();
	            kendo.deepExtend(currentOptions, options);
	            if (!options.dataSource) {
	                currentOptions.dataSource = this.dataSource;
	            } else {
	              if (options.dataSource.filter) {
	                  currentOptions.dataSource.filter = options.dataSource.filter;
	              }
	            }
	            var wrapper = this.wrapper;
	            var events = this._events;
	            var element = this.element;

	            this.destroy();
	            this.options = null;
	            if (this._isMobile) {
	                var mobileWrapper = wrapper.closest(kendo.roleSelector("pane")).parent();
	                mobileWrapper.after(wrapper);
	                mobileWrapper.remove();
	                wrapper.removeClass("k-grid-mobile");
	            }
	            if (wrapper[0] !== element[0]) {
	                wrapper.before(element);
	                wrapper.remove();
	            }
	            element.empty();

	            this.init(element, currentOptions, events);
	            this._setEvents(currentOptions);
	        },

	        items: function() {
	            if (this.lockedContent) {
	                return this._items(this.tbody).add(this._items(this.lockedTable.children("tbody")));
	            } else {
	                return this._items(this.tbody);
	            }
	        },

	        _items: function(container, includeGroupRows) {
	            return container.children().filter(function() {
	                var tr = $(this);
	                return  (includeGroupRows ? !tr.hasClass("k-detail-row") : !tr.hasClass("k-grouping-row")) && !tr.hasClass("k-detail-row") && !tr.hasClass("k-group-footer");
	            });
	        },

	        dataItems: function() {
	            var dataItems = kendo.ui.DataBoundWidget.fn.dataItems.call(this);
	            if (this.lockedContent) {
	                var n = dataItems.length, tmp = new Array(2 * n);
	                for (var i = n; --i >= 0;) {
	                    tmp[i] = tmp[i + n] = dataItems[i];
	                }
	                dataItems = tmp;
	            }

	            return dataItems;
	        },

	        _destroyColumnAttachments: function() {
	            var that = this;

	            that.resizeHandle = null;

	            if (!that.thead) {
	                return;
	            }

	            this.angular("cleanup", function(){
	                return { elements: that.thead.get() };
	            });

	            that.thead.add(that.lockedHeader).find("th").each(function(){
	                var th = $(this),
	                    filterMenu = th.data("kendoFilterMenu"),
	                    sortable = th.data("kendoColumnSorter"),
	                    columnMenu = th.data("kendoColumnMenu");

	                if (filterMenu) {
	                    filterMenu.destroy();
	                }

	                if (sortable) {
	                    sortable.destroy();
	                }

	                if (columnMenu) {
	                    columnMenu.destroy();
	                }
	            });
	        },

	        _attachCustomCommandsEvent: function() {
	            var that = this,
	                columns = leafColumns(that.columns || []),
	                command,
	                idx,
	                length;

	            for (idx = 0, length = columns.length; idx < length; idx++) {
	                command = columns[idx].command;

	                if (command) {
	                    attachCustomCommandEvent(that, that.wrapper, command);
	                }
	            }
	        },

	        _aria: function() {
	            var id = this.element.attr("id") || "aria";

	            if (id) {
	                this._cellId = id + "_active_cell";
	            }
	        },

	        _element: function() {
	            var that = this,
	                table = that.element;

	            if (!table.is("table")) {
	                if (that.options.scrollable) {
	                    table = that.element.find("> .k-grid-content > table");
	                } else {
	                    table = that.element.children("table");
	                }

	                if (!table.length) {
	                    table = $("<table />").appendTo(that.element);
	                }
	            }

	            if (isIE7) {
	                table.attr("cellspacing", 0);
	            }

	            that.table = table.attr("role", that._hasDetails() ? "treegrid" : "grid");

	            that._wrapper();
	        },

	        _createResizeHandle: function(container, th) {
	            var that = this;
	            var indicatorWidth = that.options.columnResizeHandleWidth;
	            var scrollable = that.options.scrollable;
	            var resizeHandle = that.resizeHandle;
	            var halfResizeHandle = (indicatorWidth * 3) / 2;
	            var rtlCorrection = 0;
	            var headerWrap;
	            var ieCorrection;
	            var webkitCorrection;
	            var firefoxCorrection;
	            var leftMargin;
	            var invisibleSpace;
	            var leftBorderWidth;
	            var scrollLeft;
	            var left;
	            var top;

	            if (resizeHandle && that.lockedContent && resizeHandle.data("th")[0] !== th[0]) {
	                resizeHandle.off(NS).remove();
	                resizeHandle = null;
	            }

	            if (!resizeHandle) {
	                resizeHandle = that.resizeHandle = $('<div class="k-resize-handle"><div class="k-resize-handle-inner"></div></div>');
	                container.append(resizeHandle);
	            }

	            scrollLeft = kendo.scrollLeft(container);

	            if(isRtl && (browser.mozilla || (browser.webkit && browser.version >= 85))) {
	                scrollLeft = scrollLeft * -1;
	            }

	            leftBorderWidth = parseFloat(container.css("borderLeftWidth"));

	            left = th.offset().left + scrollLeft - parseFloat(th.css("marginLeft")) - (container.offset().left + leftBorderWidth);

	            if (!isRtl) {
	                left += th[0].offsetWidth;
	           } else {
	                if (scrollable) {
	                    rtlCorrection = (left <= scrollLeft ? halfResizeHandle : 0);// when shown on first column headers are misaligned due to the width of the resize handler
	                    headerWrap = th.closest(".k-grid-header-wrap, .k-grid-header-locked");
	                    invisibleSpace = headerWrap[0].scrollWidth - headerWrap[0].offsetWidth; // the difference between the entire width and the visible area
	                    leftMargin = parseFloat(headerWrap.css("marginLeft"));
	                    ieCorrection = browser.msie ? 2*kendo.scrollLeft(headerWrap) + leftBorderWidth - leftMargin - rtlCorrection: 0;
	                    webkitCorrection = -rtlCorrection;
	                    firefoxCorrection = browser.mozilla ? leftBorderWidth - leftMargin - rtlCorrection : 0;

	                    left -= webkitCorrection + firefoxCorrection + ieCorrection;
	                }
	            }

	            top = th.offset().top - parseFloat(th.css("marginTop")) - (container.offset().top + parseFloat(container.css("borderTopWidth")));

	            resizeHandle.css({
	                top: top, //scrollable ? 0 : heightAboveHeader(that.wrapper),
	                left: left - halfResizeHandle,
	                height: outerHeight(th),
	                width: indicatorWidth * 3 - rtlCorrection
	            })
	            .data("th", th)
	            .show();

	            resizeHandle.off("dblclick" + NS).on("dblclick" + NS, function () {
	                that._autoFitLeafColumn(parseInt(th.attr(kendo.attr("index")), 10));
	            });
	        },

	        _positionColumnResizeHandle: function() {
	            var that = this,
	                lockedHead = that.lockedHeader ? that.lockedHeader.find("thead:first") : $();

	            that.thead.add(lockedHead).on("mousemove" + NS, "tr:not(.k-filter-row) > th", function (e) {
	                var button = typeof e.buttons !== "undefined" ? e.buttons : (e.which || e.button);

	                var th = $(this);
	                if (th.hasClass("k-group-cell") || th.hasClass("k-hierarchy-cell")) {
	                    return;
	                }

	                if (typeof button !== "undefined" && button !== 0) {
	                    //do not create a new resize handle if a mouse button is still pressed
	                    //this happens during resizing or before UserEvents trigger "start"
	                    return;
	                }

	                if (th[0].hasAttribute(kendo.attr(COLSPAN))) {
	                    // resizing multi-column headers is not supported
	                    return;
	                }

	                that._createResizeHandle(th.closest("div"), th);
	            });
	        },

	        _resizeHandleDocumentClick: function(e) {
	            if ($(e.target).closest(".k-column-active").length) {
	                return;
	            }

	            $(document).off(e);

	            this._resetResizeHandleHeader();
	            this._hideResizeHandle();
	        },

	        _resetResizeHandleHeader: function() {
	            var th;

	            if (!this.resizeHandle) {
	                return;
	            }

	            th = $(this.resizeHandle).data("th");

	            if (th) {
	                th.find(DOT + LINK_CLASS).find(DOT + ICON_CLASS).show();
	                th.find(DOT + ORDER_CLASS).show();
	                th.find(DOT + HEADER_COLUMN_MENU_CLASS).show();
	                th.find(DOT + FILTER_MENU_CLASS).show();
	            }
	        },

	        _hideResizeHandle: function() {
	            if (this.resizeHandle) {
	                this.resizeHandle.data("th")
	                    .removeClass("k-column-active");

	                if (this.lockedContent && !this._isMobile) {
	                    this.resizeHandle.off(NS).remove();
	                    this.resizeHandle = null;
	                } else {
	                    this.resizeHandle.hide();
	                }
	            }
	        },

	        _positionColumnResizeHandleTouch: function() {
	            var that = this,
	                lockedHead = that.lockedHeader ? that.lockedHeader.find("thead:first") : $();

	            that._resizeUserEvents = new kendo.UserEvents(lockedHead.add(that.thead), {
	                filter: "th:not(.k-group-cell):not(.k-hierarchy-cell)",
	                threshold: 10,
	                minHold: 500,
	                hold: function(e) {
	                    var th = $(e.target);

	                    e.preventDefault();

	                    if (that.resizeHandle) {
	                        that.resizeHandle.data("th")
	                            .removeClass("k-column-active");
	                        that._resetResizeHandleHeader();
	                    }

	                    th.addClass("k-column-active");

	                    th.find(DOT + LINK_CLASS).find(DOT + ICON_CLASS).hide();
	                    th.find(DOT + ORDER_CLASS).hide();
	                    th.find(DOT + HEADER_COLUMN_MENU_CLASS).hide();
	                    th.find(DOT + FILTER_MENU_CLASS).hide();

	                    that._createResizeHandle(th.closest("div"), th);

	                    if (!that._resizeHandleDocumentClickHandler) {
	                        that._resizeHandleDocumentClickHandler = proxy(that._resizeHandleDocumentClick, that);
	                    }

	                    $(document).on("click", that._resizeHandleDocumentClickHandler);
	                }
	            });
	        },

	        resizeColumn: function(column, columnWidth) {
	            var that = this;
	            var isLocked = !!column.locked;
	            var isHidden = !!column.hidden;
	            var options = this.options;
	            var scrollbar = !kendo.support.mobileOS ? kendo.support.scrollbar() : 0;
	            var index = isLocked ? inArray(column, visibleLockedColumns(visibleLeafColumns(that.columns))) : inArray(column, visibleNonLockedColumns(visibleLeafColumns(that.columns)));
	            var contentTable =  isLocked ? that.lockedTable : that.table;
	            var footer = that.footer || $();
	            var header = isLocked ? that.lockedHeader.find("table") : that.thead.closest("table");
	            var columnMinWidth = column.minResizableWidth || 10;
	            var gridWidth = isLocked ? outerWidth(contentTable.find("tbody")) : outerWidth(that.tbody); // IE returns 0 if grid is empty and scrolling is enabled
	            var col;

	            if (isHidden) {
	                column.width = columnWidth > columnMinWidth ? columnWidth : columnMinWidth;
	                return;
	            }

	            if (that.footer && that.lockedContent) {
	                footer = isLocked ? that.footer.children(".k-grid-footer-locked") : that.footer.children(".k-grid-footer-wrap");
	            }

	            if (options.scrollable) {

	                col = header.find("col:not(.k-group-col,.k-hierarchy-col):eq(" + index + ")")
	                    .add(contentTable.children("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")"))
	                    .add(footer.find("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")"));
	            } else {
	                col = contentTable.find("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")");
	            }

	            if (options.scrollable) {
	                var constrain = false;
	                var totalWidth = that.wrapper.width() - scrollbar;
	                var width = columnWidth = columnWidth > columnMinWidth ? columnWidth : columnMinWidth;

	                if (isLocked && gridWidth - columnWidth + width > totalWidth) {
	                    width = columnWidth + (totalWidth - gridWidth - scrollbar * 2);
	                    if (width < 0) {
	                        width = columnWidth;
	                    }
	                    constrain = true;
	                }

	                if (width > 10 && width >= columnMinWidth) {
	                    col.css('width', width);

	                    if (gridWidth) {
	                        if (constrain) {
	                            width = totalWidth - scrollbar * 2;
	                        } else {
	                            width = gridWidth + (columnWidth - column.width);
	                        }

	                        contentTable
	                            .add(header)
	                            .add(footer)
	                            .css('width', width);

	                        if (!isLocked) {
	                            that._footerWidth = width;
	                        }
	                    }
	                }

	            that._scrollVirtualWrapperOnColumnResize();
	            } else if (columnWidth > 10 && columnWidth >= columnMinWidth) {
	                col.css('width', columnWidth);
	            }

	            column.width = columnWidth;

	            that._applyLockedContainersWidth();
	            that._syncLockedContentHeight();
	            that._syncLockedHeaderHeight();
	            that._updateStickyColumns();
	        },

	        _resizable: function() {
	            var that = this,
	                options = that.options,
	                container,
	                columnStart,
	                columnWidth,
	                columnMinWidth,
	                gridWidth,
	                isMobile = this._isMobile,
	                scrollbar = !kendo.support.mobileOS ? kendo.support.scrollbar() : 0,
	                isLocked,
	                col, th;

	            if (options.resizable) {
	                container = options.scrollable ? that.wrapper.find(".k-grid-header-wrap:first") : that.wrapper;

	                if (isMobile) {
	                    that._positionColumnResizeHandleTouch(container);
	                } else {
	                    that._positionColumnResizeHandle(container);
	                }

	                if (that.resizable) {
	                    that.resizable.destroy();
	                }

	                that.resizable = new ui.Resizable(container.add(that.lockedHeader), {
	                    handle: (!!options.scrollable ? "" : ">") + ".k-resize-handle",
	                    hint: function(handle) {
	                        return $('<div class="k-grid-resize-indicator" />').css({
	                            height: outerHeight(handle.data("th")) + that.tbody.attr("clientHeight")
	                        });
	                    },
	                    start: function(e) {
	                        th = $(e.currentTarget).data("th");

	                        if (isMobile) {
	                            that._hideResizeHandle();
	                        }

	                        var header = th.closest("table"),
	                            index = $.inArray(th[0], leafDataCells(th.closest("thead")).filter(":visible"));

	                        isLocked = header.parent().hasClass("k-grid-header-locked");

	                        var contentTable =  isLocked ? that.lockedTable : that.table,
	                            footer = that.footer || $();

	                        if (that.footer && that.lockedContent) {
	                            footer = isLocked ? that.footer.children(".k-grid-footer-locked") : that.footer.children(".k-grid-footer-wrap");
	                        }

	                        cursor(that.wrapper, 'col-resize');

	                        if (options.scrollable) {
	                            col = header.find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")")
	                                .add(contentTable.children("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")"))
	                                .add(footer.find("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")"));
	                        } else {
	                            col = contentTable.children("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + index + ")");
	                        }

	                        var columns = $.map(that.columns, function(a) {
	                            return !a.hidden && ((isLocked && a.locked) || ((!isLocked && !a.locked))) ? a : null;
	                        });

	                        columnStart = e.x.location;
	                        columnWidth = outerWidth(th);
	                        columnMinWidth = leafColumns(columns)[index].minResizableWidth || 10;
	                        gridWidth = isLocked ? outerWidth(contentTable.children("tbody")) : outerWidth(that.tbody); // IE returns 0 if grid is empty and scrolling is enabled

	                        // fix broken UI in Chrome38+
	                        if (browser.webkit) {
	                            that.wrapper.addClass("k-grid-column-resizing");
	                        }
	                    },
	                    resize: function(e) {
	                        var rtlMultiplier = isRtl ? -1 : 1,
	                            currentWidth = columnWidth + (e.x.location * rtlMultiplier) - (columnStart * rtlMultiplier);

	                        if (options.scrollable) {
	                            var footer;
	                            if (isLocked && that.lockedFooter) {
	                                footer = that.lockedFooter.children("table");
	                            } else if (that.footer) {
	                                footer = that.footer.find(">.k-grid-footer-wrap>table");
	                            }
	                            if (!footer || !footer[0]) {
	                                footer = $();
	                            }
	                            var header = th.closest("table");
	                            var contentTable = isLocked ? that.lockedTable : that.table;
	                            var constrain = false;
	                            var totalWidth = that.wrapper.width() - scrollbar;
	                            var width = currentWidth;

	                            if (isLocked && gridWidth - columnWidth + width > totalWidth) {
	                                width = columnWidth + (totalWidth - gridWidth - scrollbar * 2);
	                                if (width < 0) {
	                                    width = currentWidth;
	                                }
	                                constrain = true;
	                            }

	                            if (width > 10 && width >= columnMinWidth) {
	                                col.css('width', width);

	                                if (gridWidth) {
	                                    if (constrain) {
	                                        width = totalWidth - scrollbar * 2;
	                                    } else {
	                                        width = gridWidth + (e.x.location * rtlMultiplier) - (columnStart * rtlMultiplier);
	                                    }

	                                    contentTable
	                                        .add(header)
	                                        .add(footer)
	                                        .css('width', width);

	                                    if (!isLocked) {
	                                        that._footerWidth = width;
	                                    }
	                                }
	                            }

	                            that._scrollVirtualWrapperOnColumnResize();
	                        } else if (currentWidth > 10 && currentWidth >= columnMinWidth) {
	                            col.css('width', currentWidth);
	                        }
	                    },
	                    resizeend: function() {
	                        var newWidth = outerWidth(th),
	                            column,
	                            header;

	                        cursor(that.wrapper, "");

	                        if (browser.webkit) {
	                            that.wrapper.removeClass("k-grid-column-resizing");
	                        }

	                        if (columnWidth != newWidth) {
	                            header = that.lockedHeader ? that.lockedHeader.find("thead:first tr:first").add(that.thead.find("tr:first")) : th.parent();

	                            var index = th.attr(kendo.attr("index"));
	                            if (!index) {
	                                index = header.find("th:not(.k-group-cell):not(.k-hierarchy-cell)").index(th);
	                            }
	                            column = leafColumns(that.columns)[index];

	                            column.width = newWidth;

	                            that.trigger(COLUMNRESIZE, {
	                                column: column,
	                                oldWidth: columnWidth,
	                                newWidth: newWidth
	                            });

	                            that._applyLockedContainersWidth();
	                            that._syncLockedContentHeight();
	                            that._syncLockedHeaderHeight();
	                            that._updateStickyColumns();
	                        }

	                        that._resetResizeHandleHeader();
	                        that._hideResizeHandle();
	                        th = null;
	                    }
	                });

	            }
	        },

	        _draggable: function() {
	            var that = this;
	            if (that.options.reorderable) {

	                if (that._draggableInstance) {
	                    that._draggableInstance.destroy();
	                }

	                var header = that.wrapper.children(".k-grid-header");

	                that._draggableInstance = that.wrapper.kendoDraggable({
	                    group: kendo.guid(),
	                    autoScroll: true,
	                    filter: that.content ? ".k-grid-header:first " + HEADERCELLS : "table:first>.k-grid-header " + HEADERCELLS,
	                    dragstart: function() {
	                        header.children(".k-grid-header-wrap").unbind("scroll" + NS + "scrolling").bind("scroll" + NS + "scrolling", function (e) {
	                            if (that.virtualScrollable) {
	                                kendo.scrollLeft(that.content.find(">.k-virtual-scrollable-wrap"), this.scrollLeft);
	                            } else {
	                                kendo.scrollLeft(that.scrollables.not(e.currentTarget), this.scrollLeft);
	                            }
	                        });
	                    },
	                    dragend: function() {
	                        that._resetResizeHandleHeader();
	                        header.children(".k-grid-header-wrap").unbind("scroll" + NS + "scrolling");
	                    },
	                    drag: function() {
	                        that._hideResizeHandle();
	                    },
	                    hint: function(target) {
	                        var title = target.attr(kendo.attr("title"));
	                        if (title) {
	                            title = kendo.htmlEncode(title);
	                        }
	                        return $('<div class="k-header k-reorder-clue k-drag-clue" />')
	                            .html(title || target.attr(kendo.attr("field")) || target.text())
	                            .prepend('<span class="k-icon k-drag-status k-i-cancel"></span>');
	                    }
	                }).data("kendoDraggable");
	            }
	        },

	        _reorderable: function() {
	            var that = this;
	            if (that.options.reorderable) {
	                if (that.wrapper.data("kendoReorderable")) {
	                    that.wrapper.data("kendoReorderable").destroy();
	                }

	                that.wrapper.kendoReorderable({
	                    draggable: that._draggableInstance,
	                    dragOverContainers: function(sourceIndex, targetIndex) {
	                        var columns = flatColumnsInDomOrder(that.columns);
	                        return columns[sourceIndex].lockable !== false && targetParentContainerIndex(columns, that.columns, sourceIndex, targetIndex) > -1;
	                    },
	                    inSameContainer: function(e) {
	                        return $(e.source).parent()[0] === $(e.target).parent()[0] && targetParentContainerIndex(flatColumnsInDomOrder(that.columns), that.columns, e.sourceIndex, e.targetIndex) > -1;
	                    },
	                    change: function(e) {
	                        var columns = flatColumnsInDomOrder(that.columns);
	                        var column = columns[e.oldIndex];
	                        var newIndex = targetParentContainerIndex(columns, that.columns, e.oldIndex, e.newIndex);

	                        that.trigger(COLUMNREORDER, {
	                            newIndex: newIndex,
	                            oldIndex: inArray(column, columns),
	                            column: column
	                        });

	                        that.reorderColumn(newIndex, column, e.position === "before");
	                    }
	                });
	            }
	        },

	        _reorderHeader: function(sources, target, before, container) {
	            var that = this;
	            var sourcePosition = columnPosition(sources[0], that.columns);
	            var destPosition = columnPosition(target, that.columns);
	            var action;
	            var ths;

	            var leafs = [];
	            for (var idx = 0; idx < sources.length; idx++) {
	                if (sources[idx].columns) {
	                    leafs = leafs.concat(sources[idx].columns);
	                }
	            }
	            if (container) {
	                ths = elements(container, container, "tr:eq(" + sourcePosition.row + ")>th.k-header:not(.k-group-cell,.k-hierarchy-cell)");
	            } else {
	                ths = elements(that.lockedHeader, that.thead, "tr:eq(" + sourcePosition.row + ")>th.k-header:not(.k-group-cell,.k-hierarchy-cell)");
	            }

	            var sourceLockedColumns = lockedColumns(sources).length;
	            var targetLockedColumns = lockedColumns([target]).length;

	            if (leafs.length) {
	                if (sourceLockedColumns > 0 && targetLockedColumns === 0) {
	                    action = "prepend";
	                    moveCellsBetweenContainers(sources, target, leafs, that.columns, that.lockedHeader.find("thead"), that.thead, this._groups(), action);
	                } else if (sourceLockedColumns === 0 && targetLockedColumns > 0) {
	                    action = destPosition.cell === 0 && sources[0].columns && !target.columns && !that._group ? "prepend" : "append";
	                    moveCellsBetweenContainers(sources, target, leafs, nonLockedColumns(that.columns), that.thead, that.lockedHeader.find("thead"), this._groups(), action);
	                }

	                if (target.columns || sourcePosition.cell - destPosition.cell > 1 || destPosition.cell - sourcePosition.cell > 1) {
	                    target = findReorderTarget(that.columns, target, sources[0], before, that.columns);
	                    if (target) {
	                        if (sourceLockedColumns > 0 && targetLockedColumns === 0) {
	                            that._reorderHeader(leafs, target, before, that.thead);
	                        } else if (sourceLockedColumns === 0 && targetLockedColumns > 0) {
	                            that._reorderHeader(leafs, target, before, that.lockedHead);
	                        } else {
	                            that._reorderHeader(leafs, target, before);
	                        }
	                    }
	                }
	            } else if (sourceLockedColumns !== targetLockedColumns) { // move between containers
	                updateCellRowSpan(ths[sourcePosition.cell], that.columns, sourceLockedColumns);
	            }

	            reorder(ths, sourcePosition.cell, destPosition.cell, before, sources.length);
	        },

	        _reorderContent: function(sources, destination, before) {
	            var that = this;
	            var lockedRows = $();
	            var source = sources[0];
	            var visibleSources = visibleColumns(sources);
	            var sourceIndex = inArray(source, leafColumns(that.columns));
	            var destIndex = inArray(destination, leafColumns(that.columns));

	            var colSourceIndex = inArray(visibleSources[0], visibleLeafColumns(that.columns));
	            var colDest = inArray(destination, visibleLeafColumns(that.columns));
	            var lockedCount = lockedColumns(that.columns).length;
	            var isLocked = !!destination.locked;
	            var footer = that.footer || that.wrapper.find(".k-grid-footer");

	            var headerCol, footerCol, beforeVisibleColumn;
	            headerCol = footerCol = colDest;

	            if (destination.hidden) {
	                var columnsArray = isLocked ? lockedColumns(that.columns): nonLockedColumns(that.columns);

	                if (visibleColumns(columnsArray).length > 0) {
	                    headerCol = footerCol = colDest = this._findClosestVisibleColumnIndex(columnsArray, destIndex);
	                    beforeVisibleColumn = visibleColumns(columnsArray.slice(destIndex)).length > 0;
	                }
	                else {
	                    if (isLocked) {
	                        colDest = that.lockedTable.find("colgroup");
	                        headerCol = that.lockedHeader.find("colgroup");
	                        footerCol = $(that.lockedFooter).find(">table>colgroup");
	                    } else {
	                        colDest = that.tbody.prev();
	                        headerCol = that.thead.prev();
	                        footerCol = footer.find(".k-grid-footer-wrap").find(">table>colgroup");
	                    }
	                }
	            }

	            if (that._hasFilterRow()) {
	                reorder(that.wrapper.find(".k-filter-row th:not(.k-group-cell,.k-hierarchy-cell)"), sourceIndex, destIndex, before, sources.length);
	            }

	            if (colSourceIndex >= 0) {
	                reorder(elements(that.lockedHeader, that.thead.prev(), "col:not(.k-group-col,.k-hierarchy-col)"), colSourceIndex, headerCol, beforeVisibleColumn ? beforeVisibleColumn : before, visibleSources.length);
	            }

	            if (that.options.scrollable) {
	                if (colSourceIndex >= 0 && !that._hasVirtualColumns()) {
	                    reorder(elements(that.lockedTable, that.tbody.prev(), "col:not(.k-group-col,.k-hierarchy-col)"), colSourceIndex, colDest, beforeVisibleColumn ? beforeVisibleColumn : before, visibleSources.length);
	                }
	            }

	            if (footer && footer.length) {
	                if (colSourceIndex >= 0) {
	                    reorder(elements(that.lockedFooter, footer.find(".k-grid-footer-wrap"), ">table>colgroup>col:not(.k-group-col,.k-hierarchy-col)"), colSourceIndex, footerCol, beforeVisibleColumn ? beforeVisibleColumn : before, visibleSources.length);
	                }
	                reorder(footer.find(".k-footer-template>td:not(.k-group-cell,.k-hierarchy-cell)"), sourceIndex, destIndex, before, sources.length);
	            }

	            var rows = that.tbody.children(":not(.k-grouping-row,.k-detail-row)");
	            if (that.lockedTable) {
	                if (lockedCount > destIndex) {
	                    if (lockedCount <= sourceIndex) {
	                        updateColspan(
	                            that.lockedTable.find(">tbody>tr.k-grouping-row"),
	                            that.table.find(">tbody>tr.k-grouping-row"),
	                            sources.length
	                        );
	                    }
	                } else if (lockedCount > sourceIndex) {
	                    updateColspan(
	                        that.table.find(">tbody>tr.k-grouping-row"),
	                        that.lockedTable.find(">tbody>tr.k-grouping-row"),
	                        sources.length
	                    );
	                }

	                lockedRows = that.lockedTable.find(">tbody>tr:not(.k-grouping-row,.k-detail-row)");
	            }

	            for (var idx = 0, length = rows.length; idx < length; idx += 1) {
	                reorder(elements(lockedRows[idx], rows[idx], ">td:not(.k-group-cell,.k-hierarchy-cell)"), sourceIndex, destIndex, before, sources.length);
	            }
	        },

	        _findClosestVisibleColumnIndex: function(columns, columnIndex) {
	            var columnsArray = visibleColumns(columns.slice(columnIndex)).length > 0 ? columns.slice(columnIndex) : columns.slice(0, columnIndex + 1).reverse(),
	                closestVisibleColumn = visibleColumns(columnsArray)[0];

	            return inArray(closestVisibleColumn, visibleColumns(this.columns));
	        },

	        _autoFitLeafColumn: function (leafIndex) {
	            this.autoFitColumn(leafColumns(this.columns)[leafIndex]);
	        },

	        autoFitColumn: function (column) {
	            var that = this,
	                options = that.options,
	                columns = that.columns,
	                index,
	                th,
	                headerTable,
	                isLocked,
	                visibleLocked = that.lockedHeader ? leafDataCells(that.lockedHeader.find(">table>thead")).filter(isCellVisible).length : 0,
	                col,
	                minWidth,
	                contentDiv, scrollLeft,
	                notGroupOrHierarchyCol = "col:not(.k-group-col):not(.k-hierarchy-col)",
	                notGroupOrHierarchyVisibleCell = "td:visible:not(.k-group-cell):not(.k-hierarchy-cell)",
	                menu,
	                thWidth;

	            //  retrieve the column object, depending on the method argument
	            if (typeof column == "number") {
	                column = columns[column];
	            } else if (isPlainObject(column)) {
	                column = grep(flatColumns(columns), function (item) {
	                    return item === column;
	                })[0];
	            } else {
	                column = grep(flatColumns(columns), function (item) {
	                    return item.field === column;
	                })[0];
	            }

	            if (!column || !isVisible(column)) {
	                return;
	            }

	            minWidth = column.minResizableWidth;
	            index = inArray(column, leafColumns(columns));
	            isLocked = column.locked;

	            if (isLocked) {
	                headerTable = that.lockedHeader.children("table");
	            } else {
	                headerTable = that.thead.parent();
	            }

	            th = headerTable.find("[data-index='" + index + "']");
	            menu = th.find('a.k-header-column-menu, a.k-grid-filter');

	            var contentTable = isLocked ? that.lockedTable : that.table,
	                footer = that.footer || $();

	            if (that.footer && that.lockedContent) {
	                footer = isLocked ? that.footer.children(".k-grid-footer-locked") : that.footer.children(".k-grid-footer-wrap");
	            }

	            var footerTable = footer.find("table").first();

	            if (that.lockedHeader && !isLocked) {
	                index -= visibleLocked;
	            }

	            // adjust column index, depending on previous hidden columns
	            for (var j = 0; j < columns.length; j++) {
	                if (columns[j] === column) {
	                    break;
	                } else {
	                    if (columns[j].hidden) {
	                        index--;
	                    }
	                }
	            }

	            // get col elements
	            if (options.scrollable) {
	                col = headerTable.find(notGroupOrHierarchyCol).eq(index)
	                    .add(contentTable.children("colgroup").find(notGroupOrHierarchyCol).eq(index))
	                    .add(footerTable.find("colgroup").find(notGroupOrHierarchyCol).eq(index));

	                if (!isLocked) {
	                    contentDiv = contentTable.parent();
	                    scrollLeft = kendo.scrollLeft(contentDiv);
	                }
	            } else {
	                col = contentTable.children("colgroup").find(notGroupOrHierarchyCol).eq(index);
	            }

	            var tables = headerTable.add(contentTable).add(footerTable);

	            if (browser.safari) {
	                th.css("white-space", "initial");
	            }

	            var oldColumnWidth = outerWidth(th);

	            // reset the table and autofitted column widths
	            // if scrolling is disabled, we need some additional repainting of the table
	            col.width("");
	            tables.css("table-layout", "fixed");
	            col.width("auto");
	            tables.addClass("k-autofitting");
	            tables.css("table-layout", "");

	            thWidth = menu.length ? outerWidth(menu) + outerWidth(th) : outerWidth(th);

	            // +1 is required by IE, regardless of the border widths, otherwise unexpected wrapping may occur with hyphenated text
	            var newColumnWidth = Math.ceil(Math.max(
	                thWidth,
	                outerWidth(contentTable.find("tr:not(.k-grouping-row)").eq(0).children(notGroupOrHierarchyVisibleCell).eq(index)),
	                outerWidth(footerTable.find("tr").eq(0).children(notGroupOrHierarchyVisibleCell).eq(index))
	            )) + 1;

	            if (minWidth && minWidth > newColumnWidth) {
	                newColumnWidth = minWidth;
	            }

	            col.width(newColumnWidth);
	            column.width = newColumnWidth;

	            if (browser.safari) {
	                th.css("white-space", "");
	            }

	            // if all visible columns have widths, the table needs a pixel width as well
	            if (options.scrollable) {
	                var cols = headerTable.find("col"),
	                    colWidth,
	                    totalWidth = 0;
	                for (var idx = 0, length = cols.length; idx < length; idx += 1) {
	                    colWidth = cols[idx].style.width;
	                    if (colWidth && colWidth.indexOf("%") == -1) {
	                        totalWidth += parseInt(colWidth, 10);
	                    } else if (cols.eq(idx).hasClass("k-group-col")) {
	                        totalWidth += parseInt(cols.eq(idx).width(), 10);
	                    } else {
	                        totalWidth = 0;
	                        break;
	                    }
	                }

	                if (totalWidth) {
	                    tables.each(function () {
	                        this.style.width = totalWidth + "px";
	                    });
	                }
	            }

	            if (browser.msie && browser.version == 8) {
	                tables.css("display", "inline-table");
	                setTimeout(function () {
	                    tables.css("display", "table");
	                }, 1);
	            }

	            tables.removeClass("k-autofitting");

	            if (scrollLeft) {
	                kendo.scrollLeft(contentDiv, scrollLeft);
	            }

	            that.trigger(COLUMNRESIZE, {
	                column: column,
	                oldWidth: oldColumnWidth,
	                newWidth: newColumnWidth
	            });

	            that._applyLockedContainersWidth();
	            that._syncLockedContentHeight();
	            that._syncLockedHeaderHeight();
	            that._updateStickyColumns();
	        },

	        reorderColumn: function(destIndex, column, before) {
	            var that = this,
	                parent = columnParent(column, that.columns),
	                columns = parent ? parent.columns : that.columns,
	                sourceIndex = inArray(column, columns),
	                destColumn = columns[destIndex],
	                virtualScroll = that.virtualScroll || {},
	                lockChanged,
	                isLocked = !!destColumn.locked,
	                lockedCount = lockedColumns(that.columns).length,
	                groupHeaderColumnTemplateColumns = grep(leafColumns(that.columns), function(column) { return column.groupHeaderColumnTemplate; });

	            if (sourceIndex === destIndex) {
	                return;
	            }

	            if (!column.locked && isLocked && nonLockedColumns(that.columns).length == 1) {
	                return;
	            }

	            if (column.locked && !isLocked && lockedCount == 1) {
	                return;
	            }

	            that._hideResizeHandle();

	            if (before === undefined) {
	                before = destIndex < sourceIndex;
	            }

	            var sourceColumns = [column];

	            that._reorderHeader(sourceColumns, destColumn, before);

	            if (that.lockedHeader) {
	                removeEmptyRows(that.thead);
	                removeEmptyRows(that.lockedHeader);
	            }

	            if (destColumn.columns) {
	                destColumn = leafColumns(destColumn.columns);
	                destColumn = destColumn[before ? 0 : destColumn.length - 1];
	            }

	            if (column.columns) {
	                sourceColumns = leafColumns(column.columns);
	            }

	            that._reorderContent(sourceColumns, destColumn, before);

	            lockChanged = !!column.locked;
	            lockChanged = lockChanged != isLocked;
	            column.locked = isLocked;

	            columns.splice(before ? destIndex : destIndex + 1, 0, column);
	            columns.splice(sourceIndex < destIndex ? sourceIndex : sourceIndex + 1, 1);

	            that._updateLockedCols();
	            that._updateCols();
	            that._templates();

	            that._updateColumnCellIndex();
	            that._updateColumnSorters();

	            if (groupHeaderColumnTemplateColumns.length > 0) {
	                that._renderGroupRows();
	            }
	            that._updateTablesWidth();
	            that._applyLockedContainersWidth();
	            that._syncLockedHeaderHeight();
	            that._syncLockedContentHeight();
	            that._updateFirstColumnClass();
	            that._updateStickyColumns();

	            if (virtualScroll.columns) {
	                that.refresh();
	            }

	            if(!lockChanged) {
	                return;
	            }

	            if (isLocked) {
	                that.trigger(COLUMNLOCK, {
	                    column: column
	                });
	            } else {
	                that.trigger(COLUMNUNLOCK, {
	                    column: column
	                });
	            }
	        },

	        _updateColumnCellIndex: function() {
	            var header;
	            var offset = 0;

	            if (this.lockedHeader) {
	                header = this.lockedHeader.find("thead");
	                offset = updateCellIndex(header, lockedColumns(this.columns));
	            }
	            updateCellIndex(this.thead, nonLockedColumns(this.columns), offset);
	        },

	        lockColumn: function(column) {
	            var columns = this.columns;

	            if (typeof column == "number") {
	                column = columns[column];
	            } else {
	                column = grep(columns, function(item) {
	                    return item.field === column;
	                })[0];
	            }

	            if (!column || column.locked || column.hidden) {
	                return;
	            }

	            if (column.sticky) {
	                this.unstickColumn(columns.indexOf(column));
	            }

	            var index = lockedColumns(columns).length - 1;
	            this.reorderColumn(index, column, false);
	        },

	        unlockColumn: function(column) {
	            var columns = this.columns;

	            if (typeof column == "number") {
	                column = columns[column];
	            } else {
	                column = grep(columns, function(item) {
	                    return item.field === column;
	                })[0];
	            }

	            if (!column || !column.locked || column.hidden) {
	                return;
	            }

	            var index = lockedColumns(columns).length;
	            this.reorderColumn(index, column, true);
	        },

	        stickColumn: function(column) {
	            var columns = this.columns;

	            if (typeof column == "number") {
	                column = columns[column];
	            } else {
	                column = grep(columns, function(item) {
	                    return item.field === column;
	                })[0];
	            }

	            if (!column || column.sticky || column.hidden) {
	                return;
	            }

	            if (column.locked) {
	                this.unlockColumn(columns.indexOf(column));

	                if (column.locked) {
	                    return;
	                }
	            }

	            column.sticky = true;
	            this._updateStickyColumns();
	        },

	        unstickColumn: function(column) {
	            var columns = this.columns;

	            if (typeof column == "number") {
	                column = columns[column];
	            } else {
	                column = grep(columns, function(item) {
	                    return item.field === column;
	                })[0];
	            }

	            if (!column || !column.sticky || column.locked || column.hidden) {
	                return;
	            }

	            this._removeStickyAttributes([column]);
	            this._removeStickyStyles(stickyColumns(columns));

	            column.sticky = false;
	            this._updateStickyColumns();
	        },

	        cellIndex: function(td) {
	            var lockedColumnOffset = 0;

	            if (this.lockedTable && !$.contains(this.lockedTable[0], td[0])) {
	                lockedColumnOffset = leafColumns(lockedColumns(this.columns)).length;
	            }

	            return $(td).parent().children('td:not(.k-group-cell,.k-hierarchy-cell)').index(td) + lockedColumnOffset;
	        },

	        _modelForContainer: function(container) {
	            container = $(container);

	            if (!container.is("tr") && this._editMode() !== "popup") {
	                container = container.closest("tr");
	            }

	            var id = container.attr(kendo.attr("uid"));

	            return this.dataSource.getByUid(id);
	        },

	        _calculateColumnIndex: function(cell) {
	            var cellIndex = this.cellIndex(cell);
	            var virtualOffset = 0;

	            if (this._hasVirtualColumns()) {
	                virtualOffset = parseInt($(cell).closest("tr").find("td:first").attr("colspan"), 10);
	                virtualOffset = (virtualOffset > 1 ? virtualOffset - 1 : 0);
	            }

	            return cellIndex + virtualOffset;
	        },

	        _editable: function() {
	            var that = this,
	                editable = that.options.editable,
	                handler = function() {
	                    var target = activeElement(),
	                        cell = that._editContainer;

	                    if (cell && cell[0] && !$.contains(cell[0], target) && cell[0] !== target && !$(target).closest(".k-animation-container").length) {
	                        if (that.editable.end()) {
	                            that.closeCell();
	                        } else {
	                            that._scrollVirtualWrapper();
	                        }
	                    }
	                };

	            if (editable) {
	                this.wrapper.addClass("k-editable");

	                var mode = that._editMode();
	                if (mode === "incell") {
	                    that.table.add(that.lockedTable)
	                        .on("mousedown" + NS, NAVROW + ">" + NAVCELL, function (e) {
	                            var target = $(e.target);
	                            if (that._editMode() === "incell" && target.hasClass("k-checkbox") && target.prev().attr(kendo.attr("bind"))) {
	                                e.preventDefault();
	                            }
	                        });

	                    if (editable.update !== false) {
	                        if (isMac) {
	                            that.wrapper
	                                .on(CLICK + NS, ".k-edit-cell > input[type='checkbox']", function(e) {
	                                    // checking /unchecking a checkbox does not change the document.activeElement to be the checkbox
	                                    // this is necessary for the "focusout" event to be fired
	                                    $(e.target).focus();
	                                })
	                                .on(CLICK + NS, ".k-edit-cell", function(e) {
	                                    if (!$(e.target).is("input")) {
	                                        $(e.currentTarget).find("input[type='checkbox']").focus();
	                                    }
	                                })
	                                .on(MOUSEDOWN + NS, "tr:not(.k-grouping-row) > td", function(e) {
	                                    var editContainer = that._editContainer;

	                                    if (editContainer && editContainer[0] && ($.contains(editContainer[0], e.target) || editContainer[0] === e.target)) {
	                                        that._mousedownOnEditCell = true;
	                                    } else {
	                                        that._mousedownOnEditCell = false;
	                                    }
	                                });
	                        }

	                        that.editableUserEvents = new kendo.UserEvents(that.wrapper, {
	                            filter: "tr:not(.k-grouping-row) > td",
	                            allowSelection: true,
	                            tap: function(e) {
	                                var td = $(e.target),
	                                isLockedCell = that.lockedTable && td.closest("table")[0] === that.lockedTable[0];

	                                that._mousedownOnEditCell = false;

	                                if (td.hasClass("k-hierarchy-cell") ||
	                                    td.hasClass("k-detail-cell") ||
	                                    td.hasClass("k-group-cell") ||
	                                    td.hasClass("k-edit-cell") ||
	                                    td.has("a.k-grid-delete").length ||
	                                    td.has("button.k-grid-delete").length ||
	                                    (td.closest("tbody")[0] !== that.tbody[0] && !isLockedCell) ||
	                                    $(e.target).is(":input")) {
	                                    return;
	                                }

	                                if (that.editable) {
	                                    if (that.editable.end()) {
	                                        $(activeElement()).blur();
	                                        that.closeCell();
	                                        that.editCell(td);
	                                    } else {
	                                        that._scrollVirtualWrapper();
	                                    }
	                                } else {
	                                    that.editCell(td);
	                                }
	                            }
	                        });

	                        that.wrapper.on("focusin" + NS, function() {
	                            // fix focus issue in IE
	                            if (!$.contains(this, activeElement())) {
	                                clearTimeout(that.timer);
	                                that.timer = null;
	                            }
	                        })
	                        .on("focusout" + NS, function(e) {
	                            var shouldCloseCell = true;

	                            if ((isMac && that._mousedownOnEditCell) || that._virtualColScroll) {
	                                shouldCloseCell = false;
	                            }

	                            that._mousedownOnEditCell = false;

	                            if (shouldCloseCell) {
	                                that.timer = setTimeout(function() {
	                                    handler(e);
	                                }, 1);
	                            }
	                        });
	                    }
	                } else {
	                    if (editable.update !== false) {
	                        that.wrapper.on(CLICK + NS, "tbody>tr:not(.k-detail-row,.k-grouping-row):visible a.k-grid-edit", function(e) {
	                            e.preventDefault();
	                            that.editRow($(this).closest("tr"));
	                        });

	                        if (that._isVirtualInlineEditable()) {
	                            that.wrapper.on("focusout" + NS, "tr:not(.k-grouping-row) > td", function() {
	                                if (that.editable && !that.editable.end()) {
	                                    that._scrollVirtualWrapper();
	                                }
	                            });
	                        }
	                    }
	                }

	                if (editable.destroy !== false) {
	                    that.wrapper.on(CLICK + NS, "tbody>tr:not(.k-detail-row,.k-grouping-row):visible .k-grid-delete", function(e) {
	                        e.preventDefault();
	                        e.stopPropagation();
	                        that.removeRow($(this).closest("tr"));
	                    });
	                } else {
	                    //Required for the MVC server wrapper delete button
	                    that.wrapper.on(CLICK + NS, "tbody>tr:not(.k-detail-row,.k-grouping-row):visible button.k-grid-delete", function(e) {
	                        e.stopPropagation();

	                        if (!that._confirmation()) {
	                            e.preventDefault();
	                        }
	                    });
	                }
	            }
	        },

	        editCell: function(cell) {
	            cell = $(cell);

	            var that = this,
	            column = leafColumns(that.columns)[that._calculateColumnIndex(cell)],
	                model = that._modelForContainer(cell);

	            that.closeCell();

	            if (model && isColumnEditable(column, model) && !column.command) {
	                if (that.trigger(BEFOREEDIT, { model: model })) {
	                    return;
	                }

	                that._attachModelChange(model);

	                that._editContainer = cell;

	                if (that._shouldClearEditableState) {
	                    that._clearEditableState();
	                }
	                that.editable = cell.addClass("k-edit-cell")
	                    .kendoEditable({
	                        fields: { field: column.field, format: column.format, editor: column.editor, values: column.values },
	                        model: model,
	                        target: that,
	                        change: function(e) {
	                            if (that.trigger(SAVE, { values: e.values, container: cell, model: model } )) {
	                                e.preventDefault();
	                            }
	                        },
	                        skipFocus: (that._isVirtualIncellEditable() || that._hasVirtualColumns()) && that._editableState ? true : false

	                    }).data("kendoEditable");

	                var tr = cell.parent().addClass("k-grid-edit-row");

	                if (that.lockedContent) {
	                    adjustRowHeight(tr[0], that._relatedRow(tr).addClass("k-grid-edit-row")[0]);
	                    that._syncLockedScroll();
	                }

	                that.trigger(EDIT, { container: cell, model: model });
	            }
	        },

	        _adjustLockedHorizontalScrollBar: function() {
	            var table = this.table,
	                content = table.parent();

	            var scrollbar = table[0].offsetWidth > content[0].clientWidth ? kendo.support.scrollbar() : 0;
	            this.lockedContent.height(content[0].offsetHeight - scrollbar);
	        },

	        _syncLockedScroll: function () {
	            this.lockedContent[0].scrollTop = this.content[0].scrollTop;
	            if (this.virtualScrollable) {
	                this.lockedContent[0].scrollTop = this.wrapper.find(".k-virtual-scrollable-wrap")[0].scrollTop;
	            }
	        },

	        _syncLockedContentHeight: function() {
	            if (this.lockedTable) {
	                if (!this.touchScroller) {
	                    this._adjustLockedHorizontalScrollBar();
	                }
	                this._adjustRowsHeight(this.table, this.lockedTable);
	            }
	        },

	        _syncLockedHeaderHeight: function() {
	            if (this.lockedHeader) {
	                var lockedTable = this.lockedHeader.children("table");
	                var table = this.thead.parent();

	                this._adjustRowsHeight(lockedTable, table);

	                syncTableHeight(lockedTable, table);
	            }
	        },

	        _syncLockedFooterHeight: function() {
	            if (this.lockedFooter && this.footer && this.footer.length) {
	                this._adjustRowsHeight(this.lockedFooter.children("table"), this.footer.find(".k-grid-footer-wrap > table"));
	            }
	        },

	        _destroyEditable: function() {
	            var that = this;

	            var destroy = function() {
	                if (that.editable) {

	                    var container = that.editView ? that.editView.element : that._editContainer;

	                    if (container) {
	                        container.off(CLICK + NS, "a.k-grid-cancel", that._editCancelClickHandler);
	                        container.off(CLICK + NS, "a.k-grid-update", that._editUpdateClickHandler);
	                    }

	                    that._detachModelChange();
	                    that.editable.destroy();
	                    that.editable = null;
	                    that._editContainer = null;
	                    that._destroyEditView();
	                    that._editableIsClosing = null;
	                }
	            };

	            if (that.editable) {
	                if (that._editMode() === "popup" && !that._isMobile) {
	                    if (that._editableIsClosing) {
	                        that._editContainer.data("kendoWindow").bind("deactivate", destroy);
	                    }
	                    else {
	                        that._editableIsClosing = true;
	                        that._editContainer.data("kendoWindow").bind("deactivate", destroy).close();
	                    }
	                } else {
	                    destroy();
	                }
	            }
	            if (that._confirmDialog) {
	                that._confirmDialog.close();
	                that._confirmDialog.destroy();
	                that._confirmDialog = null;
	            }
	        },

	        _destroyEditView: function() {
	            if (this.editView) {
	                this.editView.purge();
	                this.editView = null;
	                this.pane.navigate("");
	            }
	        },

	        _attachModelChange: function(model) {
	            var that = this;

	            that._modelChangeHandler = function(e) {
	                that._modelChange({ field: e.field, model: this });
	            };

	            model.bind("change", that._modelChangeHandler);
	        },

	        _detachModelChange: function() {
	            var that = this,
	                container = that._editContainer,
	                model = that._modelForContainer(container);

	            if (model) {
	                model.unbind(CHANGE, that._modelChangeHandler);
	            }
	        },

	        closeCell: function(isCancel) {
	            var that = this,
	                cell = that._editContainer,
	                column,
	                tr,
	                model;

	            if (!cell) {
	                return;
	            }

	            model = that._modelForContainer(cell);

	            if (isCancel && that.trigger("cancel", { container: cell, model: model })) {
	                return;
	            }

	            that.trigger(CELLCLOSE, { type: isCancel ? "cancel" : "save", model: model, container: cell });

	            cell.removeClass("k-edit-cell");
	            column = leafColumns(that.columns)[that._calculateColumnIndex(cell)];

	            tr = cell.parent().removeClass("k-grid-edit-row");

	            if (that.lockedContent) {
	                that._relatedRow(tr).removeClass("k-grid-edit-row");
	            }

	            that._destroyEditable(); // editable should be destroyed before content of the container is changed

	            that._displayCell(cell, column, model);

	            if (that._shouldClearEditableState) {
	                that._clearEditableState();
	            }

	            that.trigger("itemChange", { item: tr, data: model, ns: ui });

	            if (that.lockedContent) {
	                adjustRowHeight(tr.css("height", "")[0], that._relatedRow(tr).css("height", "")[0]);
	            }
	        },

	        _displayCell: function(cell, column, dataItem) {
	            var that = this,
	                state = { storage: {}, count: 0 },
	                settings = extend({}, kendo.Template, that.options.templateSettings),
	                tmpl = kendo.template(that._cellTmpl(column, state), settings);

	            if (state.count > 0) {
	                tmpl = proxy(tmpl, state.storage);
	            }

	            cell.empty().html(tmpl(dataItem));

	            that.angular("compile", function(){
	                return {
	                    elements: cell,
	                    data: [ { dataItem: dataItem } ]
	                };
	            });
	        },

	        removeRow: function(row) {
	            if (!this._confirmation(row)) {
	                return;
	            }

	            this._removeRow(row);
	        },

	        _removeRow: function(row) {
	            var that = this,
	                model,
	                modelId,
	                key,
	                schema,
	                mode = that._editMode();

	            if (mode !== "incell") {
	                that.cancelRow();
	            }

	            row = $(row);

	            if (that.lockedContent) {
	                row = row.add(that._relatedRow(row));
	            }

	            row = row.hide();
	            if (that.dataSource._isGroupPaged()) {
	                that._removeGroupIfEmpty(row);
	            }

	            model = that._modelForContainer(row);

	            if (model && !that.trigger(REMOVE, { row: row, model: model })) {
	                schema =  that.dataSource.options.schema;
	                if (that._selectedIds && schema && schema.model) {
	                    modelId = isFunction(that.dataSource.options.schema.model) ? that.dataSource.options.schema.model.fn.idField : that.dataSource.options.schema.model.id;
	                    key = model[modelId];
	                    delete that._selectedIds[key];
	                }

	                that.dataSource.remove(model);

	                if (mode === "inline" || mode === "popup") {
	                    that.dataSource.sync();
	                }
	            } else if (mode === "incell") {
	                that._destroyEditable();
	            }
	        },

	        _editMode: function() {
	            var mode = "incell",
	                editable = this.options.editable;

	            if (editable !== true) {
	                if (typeof editable == "string") {
	                    mode = editable;
	                } else {
	                    mode = editable.mode || mode;
	                }
	            }

	            return mode;
	        },

	        editRow: function(row) {
	            var model;
	            var that = this;

	            if (row instanceof ObservableObject) {
	                model = row;
	            } else {
	                row = $(row);
	                model = that._modelForContainer(row);
	            }

	            var mode = that._editMode();
	            var container;

	            that.cancelRow();

	            if (model) {
	                row = that.tbody.children("[" + kendo.attr("uid") + "=" + model.uid + "]");
	                that._attachModelChange(model);

	                if (mode === "popup") {
	                    that._createPopupEditor(model);
	                } else if (mode === "inline") {
	                    that._createInlineEditor(row, model);
	                } else if (mode === "incell") {
	                    $(row).children(DATA_CELL).each(function() {
	                        var cell = $(this);
	                        var column = leafColumns(that.columns)[that._calculateColumnIndex(cell)];

	                        model = that._modelForContainer(cell);

	                        if (model && (!model.editable || model.editable(column.field)) && column.field && !column.selectable) {
	                            that.editCell(cell);
	                            return false;
	                        }
	                    });
	                }


	                container = that.editView ? that.editView.element : that._editContainer;

	                if (container) {
	                    if (!this._editCancelClickHandler) {
	                        this._editCancelClickHandler = proxy(this._editCancelClick, this);
	                    }

	                    container.on(CLICK + NS, "a.k-grid-cancel", this._editCancelClickHandler);

	                    if (!this._editUpdateClickHandler) {
	                        this._editUpdateClickHandler = proxy(this._editUpdateClick, this);
	                    }

	                    container.on(CLICK + NS, "a.k-grid-update", this._editUpdateClickHandler);
	                }
	            }
	        },

	        _editUpdateClick: function(e) {
	            e.preventDefault();
	            e.stopPropagation();

	            this.saveRow();
	        },

	        _editCancelClick: function(e) {
	            var that = this;
	            var navigatable = that.options.navigatable;
	            var model = that.editable.options.model;
	            var container = that.editView ? that.editView.element : that._editContainer;

	            e.preventDefault();
	            e.stopPropagation();

	            if (that.trigger("cancel", { container: container, model: model })) {
	                return;
	            }

	            var currentIndex = that.items().index($(that.current()).parent());

	            that.cancelRow();

	            if (navigatable) {
	                that._setCurrent(that.items().eq(currentIndex).children().filter(NAVCELL).first());
	                focusTable(that.table, true);
	            }
	        },

	        _createPopupEditor: function(model) {
	            var that = this;
	            var html = '<div ' + kendo.attr("uid") + '="' + model.uid + '" class="k-popup-edit-form"><' + (that._isMobile ? 'ul class="k-edit-form-container k-listgroup k-listgroup-flush">' : 'div class="k-edit-form-container">');
	            var column;
	            var command;
	            var fields = [];
	            var idx;
	            var length;
	            var tmpl;
	            var updateText;
	            var cancelText;
	            var updateIconClass;
	            var cancelIconClass;
	            var tempCommand;
	            var columns = leafColumns(that.columns);
	            var attr;
	            var editMenuGuid = kendo.guid();
	            var editable = that.options.editable;
	            var template = editable.template;
	            var options = isPlainObject(editable) ? editable.window : {};
	            var settings = extend({}, kendo.Template, that.options.templateSettings);
	            var state;

	            if (that.trigger(BEFOREEDIT, { model: model })) {
	                return;
	            }

	            options = options || {};

	            if (template) {
	                if (typeof template === STRING) {
	                    template = kendo.unescape(template);
	                }

	                html += (kendo.template(template, settings))(model);

	                for (idx = 0, length = columns.length; idx < length; idx++) {
	                    column = columns[idx];
	                    if (column.command) {
	                        tempCommand = getCommand(column.command, "edit");
	                        if (tempCommand) {
	                            command = tempCommand;
	                        }
	                    }
	                }
	            } else {
	                for (idx = 0, length = columns.length; idx < length; idx++) {
	                    column = columns[idx];
	                    if (column.selectable) {
	                        continue;
	                    }
	                    if (!column.command) {
	                        if (!that._isMobile) {
	                            html += '<div class="k-edit-label"><label for="' + column.field + '">' + (column.title && (that.options.encodeTitles ? htmlEncode(column.title) : column.title) || column.field || "") + '</label></div>';

	                            if (isColumnEditable(column, model)) {
	                                fields.push({ field: column.field, title: column.title, format: column.format, editor: column.editor, values: column.values });
	                                html += '<div ' + kendo.attr("container-for") + '="' + column.field + '" class="k-edit-field"></div>';
	                            } else {
	                                state = { storage: {}, count: 0 };

	                                tmpl = kendo.template(that._cellTmpl(column, state), settings);

	                                if (state.count > 0) {
	                                    tmpl = proxy(tmpl, state.storage);
	                                }

	                                html += '<div class="k-edit-field k-no-editor">' + tmpl(model) + '</div>';
	                            }
	                        } else {
	                            html += '<li class="k-item k-listgroup-item">';

	                            if (isColumnEditable(column, model)) {
	                                fields.push({ field: column.field, title: column.title, format: column.format, editor: column.editor, values: column.values });
	                                html += '<label class="k-label k-listgroup-form-row">';
	                                html += '<span class="k-item-title k-listgroup-form-field-label">' + (column.title && (that.options.encodeTitles ? htmlEncode(column.title, true) : column.title) || column.field || "") + '</span>';
	                                html += '<div class="k-listgroup-form-field-wrapper" id="' + column.field + '_' + editMenuGuid + '" ' + kendo.attr("container-for") + '="' + column.field + '"></div>';
	                                html += '</label>';
	                            } else {
	                                state = { storage: {}, count: 0 };

	                                tmpl = kendo.template(that._cellTmpl(column, state), settings);

	                                if (state.count > 0) {
	                                    tmpl = proxy(tmpl, state.storage);
	                                }

	                                html += '<label class="k-label k-listgroup-form-row k-no-click">';
	                                html += '<span class="k-item-title k-listgroup-form-field-label">' + (column.title && (that.options.encodeTitles ? htmlEncode(column.title, true) : column.title) || column.field || "") + '</span>';
	                                html += '<span class="k-no-editor k-listgroup-form-field-wrapper">' + tmpl(model) + '</span>';
	                                html += '</label>';
	                            }

	                            html += "</li>";
	                        }
	                    } else if (column.command) {
	                        tempCommand = getCommand(column.command, "edit");
	                        if (tempCommand) {
	                            command = tempCommand;
	                        }
	                    }
	                }
	            }

	            if (command) {
	                if (isPlainObject(command)) {
	                    if (isPlainObject(command.text)) {
	                        updateText = command.text.update;
	                        cancelText = command.text.cancel;
	                    }
	                    if (isPlainObject(command.iconClass)) {
	                        updateIconClass = command.iconClass.update;
	                        cancelIconClass = command.iconClass.cancel;
	                    }

	                   if (command.attr) {
	                       attr = command.attr;
	                   }
	                }
	            }

	            var container;

	            if (!that._isMobile) {
	                html += '<div class="k-edit-buttons k-state-default">';
	                html += that._createButton({ name: "update", text: updateText, attr: attr, iconClass: updateIconClass }) + that._createButton({ name: "canceledit", text: cancelText, attr: attr, iconClass: cancelIconClass });
	                html += '</div></div></div>';

	                container = that._editContainer = $(html)
	                .appendTo(that.wrapper).eq(0)
	                .kendoWindow(extend({
	                    modal: true,
	                    resizable: false,
	                    draggable: true,
	                    title: that.options.messages.commands.edit || "Edit",
	                    visible: false,
	                    close: function(e) {
	                        if (e.userTriggered) {
	                            //The bellow line is required due to: draggable window in IE, change event will be triggered while the window is closing
	                            e.sender.element.focus();
	                            if (that.trigger("cancel", { container: container, model: model })) {
	                                e.preventDefault();
	                                return;
	                            }

	                            var currentIndex = that.items().index($(that.current()).parent());

	                            that._editableIsClosing = true;
	                            that.cancelRow();
	                            if (that.options.navigatable) {
	                                that._setCurrent(that.items().eq(currentIndex).children().filter(NAVCELL).first());
	                                focusTable(that.table, true);
	                            }
	                        }
	                    }
	                }, options));
	            } else {
	                html += "</ul></div>";
	                that.editView = that.pane.append(
	                    '<div data-' + kendo.ns + 'role="view" class="k-grid-edit-form">' +
	                        '<div data-' + kendo.ns + 'role="header" class="k-header">' +
	                            '<a href="\\#" class="k-header-cancel k-link k-grid-cancel" title="#=messages.cancel#" ' +
	                            'aria-label="#=messages.cancel#"><span class="k-icon k-i-arrow-chevron-left"></span></a>' +
	                            (that.options.messages.commands.edit || "Edit") +
	                            '<a href="\\#" class="k-header-done k-link k-grid-update" title="#=messages.done#" ' +
	                            'aria-label="#=messages.done#"><span class="k-icon k-i-check"></span></a>' +
	                        '</div>'+
	                        '<div data-' + kendo.ns + 'role="content" class="' + classNames.content + '">' +
	                            html +
	                        '</div>' +
	                    '</div>');
	                container = that._editContainer = that.editView.element.find(".k-popup-edit-form");
	            }

	            that.editable = that._editContainer
	                .kendoEditable({
	                    fields: fields,
	                    model: model,
	                    clearContainer: false,
	                    target: that
	                }).data("kendoEditable");

	            that._openPopUpEditor();

	            that.trigger(EDIT, { container: container, model: model });
	        },

	        _openPopUpEditor: function() {
	            var that = this;
	            var windowEditor = that._editContainer ? that._editContainer.data("kendoWindow") : null;
	            var windowOptions = (that.options.editable || {}).window || {};

	            if (!this._isMobile) {
	                if (windowEditor) {
	                    if (!windowOptions.position) {
	                        windowEditor.center();
	                    }

	                    windowEditor.open();
	                }
	            } else {
	                this.pane.navigate(this.editView, this._editAnimation);
	            }
	        },

	        _createInlineEditor: function(row, model) {
	            var that = this;
	            var column;
	            var cell;
	            var command;
	            var fields = [];

	            if (that.trigger(BEFOREEDIT, { model: model })) {
	                return;
	            }

	            if (that.lockedContent) {
	                row = row.add(that._relatedRow(row));
	            }

	            row.children(":not(.k-group-cell,.k-hierarchy-cell)").each(function() {
	                cell = $(this);
	                column = leafColumns(that.columns)[that._calculateColumnIndex(cell)];

	                if (!column.command && isColumnEditable(column, model)) {
	                    fields.push({ field: column.field, title: column.title, format: column.format, editor: column.editor, values: column.values });
	                    cell.attr(kendo.attr("container-for"), column.field);
	                    cell.empty();
	                } else if (column.command) {
	                    command = getCommand(column.command, "edit");
	                    if (command) {
	                        cell.empty();

	                        var updateText,
	                            cancelText,
	                            updateIconClass,
	                            cancelIconClass,
	                            attr;

	                        if (isPlainObject(command)) {
	                                if (isPlainObject(command.text)) {
	                                    updateText = command.text.update;
	                                    cancelText = command.text.cancel;
	                                }
	                                if (isPlainObject(command.iconClass)) {
	                                    updateIconClass = command.iconClass.update;
	                                    cancelIconClass = command.iconClass.cancel;
	                                }

	                            if (command.attr) {
	                                attr = command.attr;
	                            }
	                        }

	                        $(that._createButton({ name: "update", text: updateText, attr: attr, iconClass: updateIconClass }) +
	                            that._createButton({ name: "canceledit", text: cancelText, attr: attr, iconClass: cancelIconClass })).appendTo(cell);
	                    }
	                }
	            });

	            that._editContainer = row;
	            that._editContainer.addClass("k-grid-edit-row");

	            if (that._shouldClearEditableState) {
	                that._clearEditableState();
	            }

	            that.editable = new kendo.ui.Editable(that._editContainer, {
	                target: that,
	                fields: fields,
	                model: model,
	                skipFocus: (that._isVirtualInlineEditable() && that._editableState && (that._editableState.field ? true : false)) || that._hasVirtualColumns(),
	                clearContainer: false
	            });

	            if (row.length > 1) {

	                adjustRowHeight(row[0], row[1]);
	                that._applyLockedContainersWidth();
	            }

	            that.trigger(EDIT, { container: row, model: model });
	        },

	        cancelRow: function(notify) {
	            var that = this,
	                container = that._editContainer,
	                model;

	            if (container) {
	                model = that._modelForContainer(container);

	                if (!model || (notify && that.trigger("cancel", { container: container, model: model }))) {
	                    return;
	                }

	                that._destroyEditable();

	                that.dataSource.cancelChanges(model);

	                that._clearEditableState();

	                if (that._editMode() !== "popup") {
	                    that._displayRow(container);
	                } else {
	                    that._displayRow(that.tbody.find("[" + kendo.attr("uid") + "=" + model.uid + "]"));
	                }
	            }
	        },

	        saveRow: function() {
	            var that = this;
	            var container = this._editContainer;
	            var model = this._modelForContainer(container);
	            var deferred = $.Deferred();
	            var valid;

	            if (!container || !this.editable) {
	                return deferred.resolve().promise();
	            }

	            valid = that.editable && that.editable.end();

	            if (!valid || this.trigger(SAVE, { container: container, model: model })) {
	                if (!valid) {
	                    that._scrollVirtualWrapper();
	                }

	                return deferred.reject().promise();
	            }

	            that._clearEditableState();

	            return this.dataSource.sync();
	        },

	        _displayRow: function(row) {
	            var that = this,
	                model = that._modelForContainer(row),
	                related,
	                newRow,
	                nextRow,
	                isSelected = row.hasClass("k-state-selected"),
	                isAlt = row.hasClass("k-alt");

	            if (model) {

	                if (that.lockedContent) {
	                    related = $((isAlt ? that.lockedAltRowTemplate : that.lockedRowTemplate)(model));
	                    that._relatedRow(row.last()).replaceWith(related);
	                }

	                that.angular("cleanup", function(){ return { elements: row.get() }; });

	                newRow = $((isAlt ? that.altRowTemplate : that.rowTemplate)(model));
	                if(!row.is(":visible")) {
	                    newRow.hide();
	                }
	                row.replaceWith(newRow);

	                that.trigger("itemChange", { item: newRow, data: model, ns: ui });

	                if (related && related.length) {
	                    that.trigger("itemChange", { item: related, data: model, ns: ui });
	                }

	                var angularElements = newRow;
	                var angularData = [{ dataItem: model }];

	                if (related && related.length) {
	                    angularElements = newRow.add(related);
	                    angularData.push({ dataItem: model });
	                }

	                that.angular("compile", function(){
	                    return {
	                        elements: angularElements.get(),
	                        data: angularData
	                    };
	                });


	                if (isSelected && (that.options.selectable || that._checkBoxSelection)) {
	                    that.select(newRow.add(related));
	                }

	                if (related) {
	                    adjustRowHeight(newRow[0], related[0]);
	                }

	                nextRow = newRow.next();
	                if (nextRow.hasClass("k-detail-row") && nextRow.is(":visible")) {
	                    newRow.find(".k-hierarchy-cell .k-icon")
	                        .removeClass("k-i-expand")
	                        .addClass("k-i-collapse");
	                }
	            }
	        },

	        _showMessage: function(messages, row) {
	            var that = this;

	            if (!that._isMobile) {
	                return window.confirm(messages.title);
	            }

	            var confirmDialog = that._confirmDialog = new kendo.ui.Confirm($("<div />").appendTo(document.body), {
	                modal: {
	                    preventScroll: true
	                },
	                closable: false,
	                title: false,
	                content: messages.title,
	                messages: {
	                    okText: messages.confirmDelete,
	                    cancel: messages.cancelDelete
	                },
	                open: function () {
	                    if (that.content) {
	                        that.content.data(OVERFLOW, that.content.css(OVERFLOW));
	                        that.content.css(OVERFLOW, HIDDEN);
	                    }
	                },
	                close: function() {
	                    if (that.content) {
	                        that.content.css(OVERFLOW, that.content.data(OVERFLOW));
	                    }
	                }
	            });

	            confirmDialog.result
	                .done(function() {
	                    that._removeRow(row);
	                })
	                .fail(function() {
	                    var confirmDialog = that._confirmDialog;

	                    if (confirmDialog) {
	                        confirmDialog.close();
	                        confirmDialog.destroy();
	                    }
	                });

	            return false;
	        },

	        _confirmation: function(row) {
	            var that = this,
	                editable = that.options.editable,
	                confirmation = (editable === true || typeof editable === STRING) ? that.options.messages.editable.confirmation : editable.confirmation;

	            if (isPlainObject(editable) && typeof editable.mode === STRING && typeof confirmation !== FUNCTION && typeof confirmation !== STRING && confirmation !== false) {
	                confirmation = that.options.messages.editable.confirmation;
	            }

	            if (confirmation !== false && confirmation != null) {

	                if (typeof confirmation === FUNCTION) {
	                    confirmation = confirmation(that._modelForContainer(row));
	                }

	                return that._showMessage({
	                        confirmDelete: editable.confirmDelete || that.options.messages.editable.confirmDelete,
	                        cancelDelete: editable.cancelDelete || that.options.messages.editable.cancelDelete,
	                        title: confirmation === true ? that.options.messages.editable.confirmation : confirmation
	                    }, row);
	            }

	            return true;
	        },

	        cancelChanges: function() {
	            var that = this;

	            that.dataSource.cancelChanges();

	            if (that._isVirtualEditable()) {
	                that._virtualPageToTop(function() {
	                    that.virtualScrollable.scrollToTop();
	                });
	            }
	        },

	        saveChanges: function() {
	            var that = this;
	            var valid = that.editable && that.editable.end();

	            if ((valid || !that.editable) && !that.trigger(SAVECHANGES)) {
	                that.dataSource.sync();
	            } else if (!valid) {
	                that._scrollVirtualWrapper();
	            }
	        },

	        addRow: function() {
	            var that = this,
	                index,
	                dataSource = that.dataSource,
	                mode = that._editMode(),
	                createAt = that.options.editable.createAt || "",
	                pageSize = dataSource.pageSize(),
	                view = dataSource.view() || [];
	            var createAtBottom = createAt.toLowerCase() === BOTTOM;
	            var model;
	            var virtualEditable = that._isVirtualEditable();

	            if ((that.editable && that.editable.end()) || !that.editable) {
	                if (mode != "incell") {
	                    that.cancelRow();
	                }

	                index = dataSource.indexOf(view[0]);

	                if (createAtBottom) {
	                    index += view.length;

	                    if (pageSize && !dataSource.options.serverPaging && pageSize <= view.length) {
	                        index -= 1;
	                    }
	                }

	                if (index < 0) {
	                    if (dataSource.page() > dataSource.totalPages()) {
	                        index = (dataSource.page() - 1) * pageSize;
	                    } else {
	                        index = 0;
	                    }
	                }

	                if (that.options.navigatable && mode == "incell") {
	                    that._removeCurrent();
	                }

	                if (virtualEditable) {
	                    that._virtualAddRow();
	                } else {
	                    model = dataSource.insert(index, {});
	                    that._editModel(model);
	                }
	            } else {
	                that._scrollVirtualWrapper();
	            }
	        },

	        _editModel: function(model) {
	            var that = this;
	            var createAt = that.options.editable.createAt || "";
	            var mode = that._editMode();

	            if (model) {
	                var id = model.uid,
	                    table = that.lockedContent ? that.lockedTable : that.table,
	                    row = table.find("tr[" + kendo.attr("uid") + "=" + id + "]"),
	                    cell = row.children("td:not(.k-group-cell,.k-hierarchy-cell)").eq(that._firstEditableColumnIndex(row));

	                if (mode === "inline" && row.length) {
	                    that.editRow(row);
	                } else if (mode === "popup") {
	                    that.editRow(model);
	                } else if (cell.length) {
	                    that.editCell(cell);
	                }

	                if (createAt.toLowerCase() == "bottom" && that.lockedContent) {
	                    //scroll the containers to the bottom
	                    that.lockedContent[0].scrollTop = that.content[0].scrollTop = that.table[0].offsetHeight;
	                }
	            }
	        },

	        _virtualAddRow: function() {
	            var that = this;
	            var createAtBottom = (that.options.editable.createAt || "").toLowerCase() === BOTTOM;

	            that._clearEditableState();

	            if (createAtBottom) {
	                that._virtualAddRowAtBottom();
	            } else {
	                that._virtualAddRowAtTop();
	            }
	        },

	        _virtualAddRowAtTop: function() {
	            var that = this;
	            var dataSource = that.dataSource;
	            var virtualScrollable = that.virtualScrollable;
	            var model;

	            if (dataSource.page() === 1) {
	                model = dataSource.insert(0, {});
	                that._editModel(model);
	                virtualScrollable.scrollToTop();
	            } else {
	                that._virtualPageToTop(function() {
	                    model = dataSource.insert(0, {});
	                    that._editModel(model);
	                    virtualScrollable.scrollToTop();
	                });
	            }
	        },

	        _virtualAddRowAtBottom: function() {
	            var that = this;
	            var dataSource = that.dataSource;
	            var virtualScrollable = that.virtualScrollable;
	            var index = dataSource.total();
	            var model;

	            if (dataSource.at(index - 1) instanceof ObservableObject) {
	                model = dataSource.insert(index, {});

	                that._virtualPageToBottom(function() {
	                    that._editModel(model);
	                    virtualScrollable.scrollToBottom();
	                });
	            } else {
	                that._virtualPageToBottom(function() {
	                    model = dataSource.insert(index, {});
	                    that._editModel(model);
	                    virtualScrollable.scrollToBottom();
	                });
	            }
	        },

	        _virtualPageToTop: function(callback) {
	            var that = this;

	            that._virtualPage(0, that.dataSource.take(), function() {
	                callback();
	            });
	        },

	        _virtualPageToBottom: function(callback) {
	            var that = this;
	            var dataSource = that.dataSource;
	            var take = dataSource.take();
	            var total = dataSource.total();
	            var skip = total > take ? (total - take) : 0;

	            that._virtualPage(skip, take, function() {
	                callback();
	            });
	        },

	        _virtualPage: function(skip, take, callback) {
	            var that = this;

	            if (that._isVirtualEditable()) {
	                that.virtualScrollable._preventScroll = true;
	                that.virtualScrollable._page(skip, take, callback);
	            }
	        },

	        _firstEditableColumnIndex: function(container) {
	            var that = this,
	                column,
	                columns = leafColumns(that.columns),
	                idx,
	                length,
	                model = that._modelForContainer(container);

	            for (idx = 0, length = columns.length; idx < length; idx++) {
	                column = columns[idx];

	                if (model && (!model.editable || model.editable(column.field)) && !column.command && column.field && column.hidden !== true) {
	                    return idx;
	                }
	            }
	            return -1;
	        },

	        _toolbar: function() {
	            var that = this,
	                wrapper = that.wrapper,
	                toolbar = that.options.toolbar,
	                editable = that.options.editable,
	                container;

	            if (toolbar) {
	                container = that.wrapper.find(".k-grid-toolbar");

	                if (!container.length) {
	                    if (!isFunction(toolbar)) {
	                        toolbar = (typeof toolbar === STRING ? toolbar : that._toolbarTmpl(toolbar).replace(templateHashRegExp, "\\#"));
	                        toolbar = proxy(kendo.template(toolbar), that);
	                    }

	                    container = $('<div class="k-header k-grid-toolbar" />')
	                        .html(toolbar({}))
	                        .prependTo(wrapper);

	                    that.angular("compile", function(){
	                        return { elements: container.get() };
	                    });
	                }

	                if (editable && editable.create !== false) {
	                    container.on(CLICK + NS, ".k-grid-add", function(e) { e.preventDefault(); that.addRow(); })
	                        .on(CLICK + NS, ".k-grid-cancel-changes", function(e) { e.preventDefault(); that.cancelChanges(); })
	                        .on(CLICK + NS, ".k-grid-save-changes", function(e) { e.preventDefault(); that.saveChanges(); });
	                }

	                container.on(CLICK + NS, ".k-grid-excel", function(e) {
	                    e.preventDefault();

	                    that.saveAsExcel();
	                });

	                container.on(CLICK + NS, ".k-grid-pdf", function(e) {
	                    e.preventDefault();

	                    that.saveAsPDF();
	                });

	                container.on(INPUT + NS, ".k-grid-search input", function(e) {
	                    var input = e.currentTarget;
	                    clearTimeout(that._searchTimeOut);
	                    that._searchTimeOut = setTimeout(function () {
	                        that._searchTimeOut = null;
	                        var options = that.options;
	                        var searchFields = options.search ? options.search.fields : null;
	                        var expression = { filters:[], logic:"or" };
	                        var value = input.value;

	                        if (!searchFields) {
	                            searchFields = getColumnsFields(options.columns);
	                        }

	                        if (that.dataSource.options.endless) {
	                            that.dataSource.options.endless = null;
	                            that._endlessPageSize = that.dataSource.options.pageSize;
	                        }

	                        if (value) {
	                            for (var i = 0; i < searchFields.length; i++) {
	                                expression.filters.push({ field: searchFields[i], operator: "contains", value: value });
	                            }
	                        } else {
	                            expression = {};
	                        }

	                        that.dataSource.filter(expression);

	                    }, 300);
	                });
	            }
	        },

	        _toolbarTmpl: function(commands) {
	            var that = this,
	                idx,
	                length,
	                html = "",
	                command,
	                searchText = "",
	                messages = that.options.messages.commands;

	            if (isArray(commands)) {
	                for (idx = 0, length = commands.length; idx < length; idx++) {
	                    command = typeof commands[idx] === 'string' ? commands[idx].toLowerCase() : (commands[idx].name || "").toLowerCase();
	                    if (command === "search") {
	                        if (typeof commands[idx] !== 'string') {
	                            searchText = commands[idx].text;
	                        }
	                        searchText = searchText || messages.search;
	                        html += "<span class='k-textbox k-grid-search k-display-flex'>";
	                        html += "<input autocomplete='off' placeholder='" + searchText + "' title='"+ searchText + "' class='k-input' />";
	                        html += "<span class='k-input-icon'><span class='k-icon k-i-search'></span></span>";
	                        html += "</span>";
	                    } else {
	                        html += that._createButton(commands[idx]);
	                    }
	                }
	            }

	            return html;
	        },

	        _createButton: function(command) {
	            var template = command.template || COMMANDBUTTONTMPL,
	                commandName = typeof command === STRING ? command : command.name || command.text,
	                className = defaultCommands[commandName] ? defaultCommands[commandName].className : "k-grid-" + (commandName || "").replace(/\s/g, ""),
	                options = { className: className, text: commandName, attr: "", iconClass: "" },
	                messages = this.options.messages.commands,
	                attributeClassMatch;

	            if (!commandName && !(isPlainObject(command) && command.template))  {
	                throw new Error("Custom commands should have name specified");
	            }

	            if (isPlainObject(command)) {
	                command = extend(true, {}, command);

	                if (command.className && inArray(options.className, command.className.split(" ")) < 0) {
	                    command.className += " " + options.className;
	                } else if (command.className === undefined) {
	                    command.className = options.className;
	                }

	                if (commandName === "edit") {
	                    command = extend(true, {}, command);
	                    command.text = isPlainObject(command.text) ? command.text.edit : command.text;
	                    command.iconClass = isPlainObject(command.iconClass) ? command.iconClass.edit : command.iconClass;
	                }

	                if (command.attr) {
	                    if (isPlainObject(command.attr)) {
	                        command.attr = stringifyAttributes(command.attr);
	                    }

	                    if (typeof command.attr === STRING) {
	                        attributeClassMatch = command.attr.match(/class="(.+?)"/);

	                        if (attributeClassMatch && inArray(attributeClassMatch[1], command.className.split(" ")) < 0) {
	                            command.className += " " + attributeClassMatch[1];
	                        }
	                    }
	                }

	                options = extend(true, options, defaultCommands[commandName], { text: messages[commandName] }, command);
	            } else {
	                options = extend(true, options, defaultCommands[commandName], { text: messages[commandName] });
	            }

	            return kendo.template(template)(options);
	        },

	        _hasFooters: function() {
	            return !!this.footerTemplate ||
	                !!this.groupFooterTemplate ||
	                (this.footer && this.footer.length > 0) ||
	                this.wrapper.find(".k-grid-footer").length > 0;
	        },

	        _groupable: function() {
	            var that = this;

	            if (that._groupableClickHandler) {
	                that.table.add(that.lockedTable).off(CLICK + NS, that._groupableClickHandler);
	            } else {
	                that._groupableClickHandler = function(e) {
	                    var element = $(this),
	                    groupRow = element.closest("tr");

	                    var group = that._groupRows ? that._groupRows[that.wrapper.find(".k-grouping-row").index(groupRow)] : { };

	                    if(element.hasClass('k-i-collapse')) {
	                        if (!that.trigger("groupCollapse", { group: group, element: groupRow})) {
	                            that.collapseGroup(groupRow);
	                        }
	                    } else {
	                        if (!that.trigger("groupExpand",  { group: group, element: groupRow})) {
	                            that.expandGroup(groupRow);
	                        }
	                    }
	                    e.preventDefault();
	                    e.stopPropagation();
	                };
	            }

	            if (that._isLocked()) {
	                that.lockedTable.on(CLICK + NS, ".k-grouping-row .k-i-expand, .k-grouping-row .k-i-collapse", that._groupableClickHandler);
	            } else {
	                that.table.on(CLICK + NS, ".k-grouping-row .k-i-expand, .k-grouping-row .k-i-collapse", that._groupableClickHandler);
	            }

	            that._attachGroupable();
	        },

	        _attachGroupable: function() {
	            var that = this,
	                wrapper = that.wrapper,
	                groupable = that.options.groupable,
	                draggables = HEADERCELLS + "[" + kendo.attr("field") + "]",
	                filter = that.content ? ".k-grid-header:first " + draggables  : "table:first>.k-grid-header " + draggables;

	            if (groupable && groupable.enabled !== false) {

	                if(!wrapper.has("div.k-grouping-header")[0]) {
	                    $("<div>&nbsp;</div>").addClass("k-grouping-header").prependTo(wrapper);
	                }

	                if (that.groupable) {
	                    that._destroyGroupable();
	                }

	                if (browser.chrome) {
	                    wrapper.find("div.k-grouping-header").css("touch-action", "none");
	                    wrapper.find(filter).css("touch-action", "none");
	                }

	                that.groupable = new ui.Groupable(wrapper, extend({}, groupable, {
	                    draggable: that._draggableInstance,
	                    groupContainer: ">div.k-grouping-header",
	                    dataSource: that.dataSource,
	                    draggableElements: filter,
	                    filter: filter,
	                    allowDrag: that.options.reorderable,
	                    change: function(e) {
	                        if(that.trigger("group", { groups: e.groups })) {
	                            e.preventDefault();
	                        } else {
	                            that._clearEditableState();
	                            if (that.dataSource.options.endless) {
	                                that.dataSource.options.endless = null;
	                                that._endlessPageSize = that.dataSource.options.pageSize;
	                                that.dataSource._skip = 0;
	                                that.dataSource._pageSize = that.dataSource._take = that._endlessPageSize;
	                                that.dataSource._page = 1;
	                            }
	                        }
	                    }
	                }));

	                that._addGroupableOptionsToHeader();
	            }
	        },

	        _addGroupableOptionsToHeader: function() {
	            var that = this;
	            var columns = flatColumns(that.columns);
	            var columnFieldMap = {};
	            var field = "";
	            var headerCells = that._headerCells();
	            var cellFieldAttr = "";
	            var headerCell;
	            var columnOptions;
	            var i;

	            for (i = 0; i < columns.length; i++) {
	                field = columns[i].field;
	                columnFieldMap[columns[i].field] = columns[i];
	            }

	            for (i = 0; i < headerCells.length; i++) {
	                headerCell = headerCells.eq(i);
	                cellFieldAttr = headerCell.attr(kendo.attr(FIELD));
	                columnOptions = columnFieldMap[cellFieldAttr];

	                if (columnOptions && columnOptions.groupable && columnOptions.groupable.sort) {
	                    headerCell.data(GROUP_SORT, columnOptions.groupable.sort);
	                }
	            }
	        },

	        _destroyGroupable: function() {
	            var that = this;

	            if (that.groupable && that.groupable.element) {
	                that.groupable.element.kendoGroupable("destroy");
	            }

	            that.groupable = null;

	            that._removeGroupableOptionsFromHeader();
	        },

	        _removeGroupableOptionsFromHeader: function() {
	            var that = this;
	            var headerCells = that._headerCells();

	            for (var i = 0; i < headerCells.length; i++) {
	                headerCells.eq(i).removeData(GROUP_SORT);
	            }
	        },

	        _continuousItems: function(filter, cell) {
	            if (!this.lockedContent) {
	                return;
	            }

	            var that = this;

	            var elements = that.table.add(that.lockedTable);

	            var lockedItems = $(filter, elements[0]);
	            var nonLockedItems = $(filter, elements[1]);
	            var columns = cell ? lockedColumns(that.columns).length : 1;
	            var nonLockedColumns = cell ? that.columns.length - columns : 1;
	            var result = [];

	            for (var idx = 0; idx < lockedItems.length; idx += columns) {
	                push.apply(result, lockedItems.slice(idx, idx + columns));
	                push.apply(result, nonLockedItems.splice(0, nonLockedColumns));
	            }

	            return result;
	        },

	        _selectable: function() {
	            var that = this,
	                multi,
	                cell,
	                notString = [],
	                isLocked = that._isLocked(),
	                selectable = that.options.selectable;

	            if (selectable) {

	                if (that.selectable) {
	                    that.selectable.destroy();
	                }

	                that._selectedIds = {};

	                selectable = kendo.ui.Selectable.parseOptions(selectable);

	                multi = selectable.multiple;
	                cell = selectable.cell;

	                if (that._hasDetails()) {
	                    notString[notString.length] = ".k-detail-row";
	                }
	                if (that.options.groupable || that._hasFooters() || that._groups()) {
	                    notString[notString.length] = ".k-grouping-row,.k-group-footer";
	                }

	                notString = notString.join(",");

	                if (notString !== "") {
	                    notString = ":not(" + notString + ")";
	                }

	                var elements = that.table;
	                if (isLocked) {
	                    elements = elements.add(that.lockedTable);
	                }

	                var filter = ">" + (cell ? SELECTION_CELL_SELECTOR : "tbody>tr" + notString);
	                that.selectable = new kendo.ui.Selectable(elements, {
	                    filter: filter,
	                    aria: true,
	                    multiple: multi,
	                    change: function() {
	                        var selectedValues;
	                        if (!cell) {
	                            that._persistSelectedRows();
	                        }

	                        if (that._checkBoxSelection) {
	                            selectedValues = that.selectable.value();
	                            that._uncheckCheckBoxes();
	                            that._checkRows(selectedValues);
	                            if (selectedValues.length && selectedValues.length === that.items().length) {
	                                that._toggleHeaderCheckState(true);
	                            } else {
	                                that._toggleHeaderCheckState(false);
	                            }
	                        }

	                        that.trigger(CHANGE);
	                    },
	                    useAllItems: isLocked && multi && cell,
	                    relatedTarget: function(items) {
	                        if (cell || !isLocked) {
	                            return;
	                        }

	                        var related;
	                        var result = $();
	                        for (var idx = 0, length = items.length; idx < length; idx ++) {
	                            related = that._relatedRow(items[idx]);

	                            if (inArray(related[0], items) < 0) {
	                                result = result.add(related);
	                            }
	                        }

	                        return result;
	                    },
	                    continuousItems: function() {
	                        return that._continuousItems(filter, cell);
	                    }
	                });

	                if (that.options.navigatable) {
	                    elements.on("keydown" + NS, function(e) {
	                        var current = that.current();
	                        var target = e.target;
	                        if (!current) {
	                            return;
	                        }
	                        if (e.keyCode === keys.SPACEBAR && !e.shiftKey && $.inArray(target, elements) > -1 &&
	                            !current.is(".k-edit-cell,.k-header") &&
	                            current.parent().is(":not(.k-grouping-row,.k-detail-row,.k-group-footer)")) {
	                                e.preventDefault();
	                                e.stopPropagation();
	                                current = cell ? current : current.parent();

	                                if (isLocked && !cell) {
	                                    current = current.add(that._relatedRow(current));
	                                }

	                                if(multi) {
	                                    if(!e.ctrlKey) {
	                                        that.selectable.clear();
	                                    } else {
	                                        if(current.hasClass(SELECTED)) {
	                                            that._deselectCheckRows(current);
	                                            return;
	                                        }
	                                    }
	                                } else {
	                                    that.selectable.clear();
	                                }
	                                if (!cell) {
	                                    that.selectable._lastActive = current;
	                                }
	                                that.selectable.value(current);
	                        } else if(!cell &&
	                            ($(target).is("td") || ($(target).is("table") && inArray(target, this._navigatableTables))) &&
	                          ((e.shiftKey && e.keyCode == keys.LEFT)||
	                           (e.shiftKey && e.keyCode == keys.RIGHT)||
	                           (e.shiftKey && e.keyCode == keys.UP)||
	                           (e.shiftKey && e.keyCode == keys.DOWN)||
	                           (e.keyCode === keys.SPACEBAR && e.shiftKey))) {
	                            e.preventDefault();
	                            e.stopPropagation();
	                            current = current.parent();

	                            if (isLocked) {
	                                current = current.add(that._relatedRow(current));
	                            }

	                            if (multi) {
	                                if(!that.selectable._lastActive) {
	                                    that.selectable._lastActive = current;
	                                }
	                                that.selectable.selectRange(that.selectable._firstSelectee(), current);
	                            } else {
	                                that.selectable.clear();
	                                that.selectable.value(current);
	                            }
	                        }
	                    });
	                }
	            }
	        },

	        _clipboard: function() {
	            var options = this.options;
	            var selectable = options.selectable;
	            if (selectable && options.allowCopy) {
	                var grid = this;
	                if (!options.navigatable) {
	                    grid.table.add(grid.lockedTable)
	                        .attr("tabindex", 0)
	                        .on("mousedown" + NS + " keydown" + NS, ".k-detail-cell", function(e) {
	                            if (e.target !== e.currentTarget) {
	                                e.stopImmediatePropagation();
	                            }
	                        })
	                        .on("mousedown" + NS, NAVROW + ">" + NAVCELL, proxy(tableClick, grid));
	                }
	                grid.copyHandler = proxy(grid.copySelection, grid);
	                grid.updateClipBoardState = function () {
	                    if (grid.areaClipBoard) {
	                        grid.areaClipBoard.val(grid.getTSV()).focus().select();
	                    }
	                };
	                grid.bind("change",grid.updateClipBoardState);
	                grid.wrapper.on("keydown", grid.copyHandler);
	                grid.clearAreaHandler = proxy(grid.clearArea, grid);
	                grid.wrapper.on("keyup", grid.clearAreaHandler);
	            }
	        },

	        copySelection: function(e) {
	            if ((e instanceof jQuery.Event && !(e.ctrlKey || e.metaKey)) ||
	                $(e.target).is("input:visible,textarea:visible") ||
	                (window.getSelection && window.getSelection().toString()) ||
	                (document.selection && document.selection.createRange().text) ) {
	                return;
	            }


	            if (!this.areaClipBoard) {
	                this.areaClipBoard =
	                    $("<textarea />")
	                    .css({
	                        position: "fixed",
	                        top: "50%",
	                        left:"50%",
	                        opacity: 0,
	                        width: 0,
	                        height: 0
	                    })
	                    .appendTo(this.wrapper);
	            }

	            this.areaClipBoard.val(this.getTSV()).focus().select();

	        },

	        getTSV: function() {
	            var grid = this;
	            var selected = grid.select();
	            var delimeter = "\t";
	            var allowCopy = grid.options.allowCopy;
	            var onlyVisible = true;

	            if ($.isPlainObject(allowCopy) && allowCopy.delimeter) {
	                delimeter = allowCopy.delimeter;
	            }
	            var text = "";
	            if (selected.length) {
	                if (selected.eq(0).is("tr")) {
	                    selected = selected.find("td:not(.k-group-cell)");
	                }
	                if (onlyVisible) {
	                    selected.filter(":visible");
	                }

	                var result = [];
	                var cellsOffset = this.columns.length;
	                var lockedCols = grid._isLocked() && lockedColumns(grid.columns).length;
	                var inLockedArea = true;

	                $.each(selected, function (idx, cell) {
	                    cell = $(cell);
	                    var tr = cell.closest("tr");
	                    var rowIndex = tr.index();
	                    var cellIndex = cell.index();
	                    if (onlyVisible) {
	                        cellIndex -= cell.prevAll(":hidden").length;
	                    }
	                    if (lockedCols && inLockedArea) {
	                        inLockedArea = $.contains(grid.lockedTable[0], cell[0]);
	                    }
	                    if (grid._groups() && inLockedArea) {
	                        cellIndex -= grid._groups();
	                    }
	                    cellIndex = inLockedArea ? cellIndex : (cellIndex + lockedCols );
	                    if (cellsOffset > cellIndex) {
	                        cellsOffset = cellIndex;
	                    }
	                    var cellText = cell.text();
	                    if (!result[rowIndex]) {
	                        result[rowIndex] = [];
	                    }
	                    result[rowIndex][cellIndex] = cellText;

	                });

	                var rowsOffset = result.length;
	                result = $.each(result, function (idx, val) {
	                    if (val) {
	                        result[idx] = val.slice(cellsOffset);
	                        if (rowsOffset > idx) {
	                            rowsOffset = idx;
	                        }
	                    }
	                });

	                $.each(result.slice(rowsOffset), function (idx, val) {
	                    if (val) {
	                        text += val.join(delimeter) + "\r\n";
	                    } else {
	                        text +=  "\r\n";
	                    }
	                });
	            }
	            return text;
	        },

	        clearArea: function (e) {
	            var table;
	            if (this.areaClipBoard && e && e.target === this.areaClipBoard[0]) {
	                if (this.options.navigatable) {
	                    table = $(this.current()).closest("table");
	                } else {
	                    table = this.table;
	                }
	                focusTable(table, true);
	            }

	            if (this.areaClipBoard) {
	                this.areaClipBoard.remove();
	                this.areaClipBoard = null;
	            }
	        },

	        _adaptiveColumns: function() {
	            var that = this;

	            if (that._anyColumnHasMediaQuery()) {
	                that._setColumnsMediaVisibility(that.columns);
	                that._attachColumnMediaResizeHandler();
	            }
	        },

	        _anyColumnHasMediaQuery: function() {
	            return this._columnsWithMediaQuery().length;
	        },

	        _columnsWithMediaQuery: function() {
	            return columnsWithMedia(this.columns);
	        },

	        _attachColumnMediaResizeHandler: function() {
	            var that = this;

	            that._detachColumnMediaResizeHandler();
	            that._columnMediaResizeHandler = proxy(that._onColumnMediaResize, that);
	            $(window).on(RESIZE + NS, that._columnMediaResizeHandler);
	        },

	        _detachColumnMediaResizeHandler: function() {
	            var that = this;

	            if (that._columnMediaResizeHandler) {
	                $(window).off(RESIZE + NS, that._columnMediaResizeHandler);
	            }
	        },

	        _onColumnMediaResize: function() {
	            var that = this;
	            that._setColumnsMediaVisibility(that.columns);
	            that._setContentMediaWidth();
	        },

	        _setColumnsMediaVisibility: function(columns) {
	            var cols = columns || [];

	            for (var i = 0; i < cols.length; i++) {
	                this._setColumnMediaVisibility(cols[i]);
	            }
	        },

	        _setColumnMediaVisibility: function(column) {
	            var that = this;

	            if (isUndefined(column.media)) {
	                that._setColumnsMediaVisibility(column.columns);
	            } else {
	                if (columnMatchesMedia(column)) {
	                    that._showColumnByMedia(column);

	                    if (!column.hidden) {
	                        that._setColumnsMediaVisibility(column.columns);
	                    }
	                } else {
	                    that._hideColumnByMedia(column);
	                }
	            }
	        },

	        _showColumnByMedia: function(column) {
	            if (!column.hidden) {
	                // "hidden" has a priority over "matchesMedia"
	                this.showColumn(column);
	            }

	            setColumnMatchesMedia(column);
	        },

	        _hideColumnByMedia: function(column) {
	            var initiallyHidden = column.hidden;

	            if (!initiallyHidden) {
	                column._hideByMedia = true;
	                this.hideColumn(column);
	                column._hideByMedia = false;

	                // hiding is tracked in "matchesMedia" instead of "hidden" flag
	                column.hidden = initiallyHidden;
	            }

	            setColumnMatchesMedia(column);
	        },

	        _setContentMediaWidth: function() {
	            var that = this;
	            var options = that.options;
	            var isLocked = that._isLocked();
	            var footer;

	            if (options.scrollable && options.resizable) {
	                if (isLocked && that.lockedFooter) {
	                    footer = that.lockedFooter.children("table");
	                } else if (that.footer) {
	                    footer = that.footer.find(">.k-grid-footer-wrap>table");
	                }

	                if (!footer || !footer[0]) {
	                    footer = $();
	                }

	                var header = isLocked ? that.wrapper.find(".k-grid-header-locked").find("table") : that.wrapper.find(".k-grid-header").find("table");
	                var contentTable = isLocked ? that.lockedTable : that.table;

	                var headerColumns = header.find("th");
	                var headerColgroup = header.find("colgroup");

	                var headerColumnsCount = headerColumns.length;
	                var visibleHeaderColumnsCount = headerColumns.filter(isCellVisible).length;
	                var hiddenHeaderColumnsCount = headerColumns.length - visibleHeaderColumnsCount;

	                var totalHeaderWidth = 0;

	                if (header[0].style.width !== "" && parseFloat(header[0].style.width) !== totalHeaderWidth) {
	                    var currentHeaderWidth = header.css("width");

	                    for (var i = 0; i < headerColumnsCount; i++) {
	                        if (isElementVisible(headerColumns[i])) {
	                            var columnWidth;
	                            var cellIndex = Math.max(i, (i - hiddenHeaderColumnsCount));
	                            var colgroupChild = headerColgroup.children()[cellIndex];
	                            var columnStyleWidth = colgroupChild ? colgroupChild.style.width : "";

	                            if (columnStyleWidth !== "") {
	                                columnWidth = parseFloat(columnStyleWidth);
	                            } else {
	                                // remove the header width to calculate the height of a column without fixed width
	                                header.css("width", "auto");
	                                columnWidth = outerWidth(headerColumns.eq(i));
	                                header.css("width", currentHeaderWidth);
	                            }

	                            totalHeaderWidth += columnWidth;
	                        }
	                    }

	                    contentTable.css('width', totalHeaderWidth - 1); // subtract 1 to remove the horizontal scroll
	                    header.css('width', totalHeaderWidth);
	                    footer.css('width', totalHeaderWidth);
	                    that._updateStickyColumns();
	                }
	            }
	        },

	        _minScreenSupport: function() {
	            var any = this.hideMinScreenCols();

	            if (any) {
	                this.minScreenResizeHandler = proxy(this.hideMinScreenCols, this);
	                $(window).on("resize", this.minScreenResizeHandler);
	            }
	        },

	        hideMinScreenCols: function() {
	            var cols = this.columns,
	                screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;

	            return this._iterateMinScreenCols(cols, screenWidth);
	        },

	        _iterateMinScreenCols: function (cols, screenWidth) {
	            var any = false;

	            for (var i = 0; i < cols.length; i++) {
	                var col = cols[i];
	                var minWidth = col.minScreenWidth;
	                if (minWidth !== undefined && minWidth !== null) {
	                    any = true;
	                    if (minWidth > screenWidth) {
	                        this.hideColumn(col);
	                    } else {
	                        this.showColumn(col);
	                    }
	                }
	                if (!col.hidden && col.columns) {
	                    any = this._iterateMinScreenCols(col.columns, screenWidth) || any;
	                }
	            }
	            return any;
	        },

	        _stickyColumns: function() {
	            var that = this;

	            if (that._anyStickyColumns()) {
	                that._setStickyColumns(false);
	            }
	        },

	        _updateStickyColumns: function() {
	            var that = this;
	            var groupHeaderColumnTemplateColumns = grep(leafColumns(that.columns), function(column) { return column.groupHeaderColumnTemplate; });

	            if (that._anyStickyColumns()) {
	                that._setStickyColumns(true);
	                that._templates();

	                if (groupHeaderColumnTemplateColumns.length > 0) {
	                    that._renderGroupRows();
	                }
	            }
	        },

	        _anyStickyColumns: function() {
	            var that = this;

	            return stickyColumns(that.columns).length;
	        },

	        _setStickyColumns: function(updateStyles) {
	            var that = this;
	            var columns = stickyColumns(that.columns);
	            var visibleColumns = visibleStickyColumns(that.columns);
	            var stickyWidths = that._calculateStickyWidths(visibleColumns);

	            that._removeStickyAttributes(columns);
	            that._setStickyClassAttributes(columns);
	            that._setStickyStyleAttributes(visibleColumns, stickyWidths, updateStyles);

	            if (updateStyles) {
	                that._setStickyStyles(visibleColumns, stickyWidths);
	            }
	        },

	        _calculateStickyWidths: function(columns, initialLeftWidth, initialRightWidth) {
	            var that = this;
	            var i;
	            var column;
	            var columnWidth;
	            var nextColumnLeft;
	            var nextColumnRight;
	            var left = isRtl ? "right" : "left";
	            var right = isRtl ? "left" : "right";
	            var stickyWidths = {
	                left: new Array(columns.length).fill(initialLeftWidth ? initialLeftWidth : 0),
	                right: new Array(columns.length).fill(initialRightWidth ? initialRightWidth : 0)
	            };

	            for (i = 0; i < columns.length - 1; i++) {
	                column = columns[i];
	                columnWidth = that._sumColumnWidth(column);
	                nextColumnLeft = columnWidth + stickyWidths[left][i];

	                stickyWidths[left][i+1] = nextColumnLeft;
	            }

	            for (i = columns.length - 1; i > 0; i--) {
	                column = columns[i];
	                columnWidth = that._sumColumnWidth(column);
	                nextColumnRight = columnWidth + stickyWidths[right][i];

	                stickyWidths[right][i-1] = nextColumnRight;
	            }

	            return stickyWidths;
	        },

	        _setStickyClassAttributes: function(columns, masterIndex) {
	            var that = this;
	            var i;
	            var column;

	            for (i = 0; i < columns.length; i++) {
	                column = columns[i];

	                if (column.columns) {
	                    if (!masterIndex && i) {
	                        masterIndex = i;
	                    }

	                    that._setStickyClassAttributes(childColumns([column]), masterIndex);
	                }

	                if (masterIndex) {
	                    addColumnAttribute(column, "headerAttributes", "class", STICKY_HEADER_NO_BORDER_CLASS);
	                }
	                addColumnAttribute(column, "attributes", "class", STICKY_CELL_CLASS);
	                addColumnAttribute(column, "headerAttributes", "class", STICKY_HEADER_CLASS);
	                addColumnAttribute(column, "footerAttributes", "class", STICKY_FOOTER_CLASS);
	            }
	        },

	        _setStickyStyleAttributes: function(columns, stickyWidths, updateStyles) {
	            var that = this;
	            var i;
	            var column;
	            var stickyLeft;
	            var stickyRight;
	            var stickyStyle;
	            var childCols;
	            var childStickyWidths;

	            for (i = 0; i < columns.length; i++) {
	                column = columns[i];
	                stickyLeft = stickyWidths.left[i];
	                stickyRight = stickyWidths.right[i];
	                stickyStyle = "left: " + stickyLeft + "px; right: " + stickyRight + "px;";

	                if (column.columns) {
	                    childCols = visibleChildColumns([column]);
	                    childStickyWidths = that._calculateStickyWidths(childCols, stickyLeft, stickyRight);

	                    that._setStickyStyleAttributes(childCols, childStickyWidths, updateStyles);

	                    if (updateStyles) {
	                        that._setStickyStyles(childCols, childStickyWidths);
	                    }
	                }

	                addColumnAttribute(column, "attributes", "style", stickyStyle);
	                addColumnAttribute(column, "headerAttributes", "style", stickyStyle);
	                addColumnAttribute(column, "footerAttributes", "style", stickyStyle);

	                column.stickyStyle = stickyStyle;
	            }
	        },

	        _removeStickyAttributes: function(columns) {
	            var that = this;
	            var i;
	            var cellClassRegExp = new RegExp("(\\s*" + STICKY_CELL_CLASS + ")*", "ig");
	            var headerClassRegExp = new RegExp("(\\s*" + STICKY_HEADER_CLASS + ")*", "ig");
	            var footerClassRegExp = new RegExp("(\\s*" + STICKY_FOOTER_CLASS + ")*", "ig");
	            var headerClassNoBorderRegExp = new RegExp("(\\s*" + STICKY_HEADER_NO_BORDER_CLASS + ")*", "ig");
	            var leftRegExp = new RegExp("(\\s*left\\s*:\\s*\\d*px;?)*", "ig");
	            var rightRegExp = new RegExp("(\\s*right\\s*:\\s*\\d*px;?)*", "ig");
	            var column;

	            for (i = 0; i < columns.length; i++) {
	                column = columns[i];

	                if (column.columns) {
	                    that._removeStickyAttributes(childColumns([column]));
	                }

	                removeColumnAttribute(column, "attributes", "class", cellClassRegExp);
	                removeColumnAttribute(column, "attributes", "style", leftRegExp);
	                removeColumnAttribute(column, "attributes", "style", rightRegExp);

	                removeColumnAttribute(column, "headerAttributes", "class", headerClassRegExp);
	                removeColumnAttribute(column, "headerAttributes", "class", headerClassNoBorderRegExp);
	                removeColumnAttribute(column, "headerAttributes", "style", leftRegExp);
	                removeColumnAttribute(column, "headerAttributes", "style", rightRegExp);

	                removeColumnAttribute(column, "footerAttributes", "class", footerClassRegExp);
	                removeColumnAttribute(column, "footerAttributes", "style", leftRegExp);
	                removeColumnAttribute(column, "footerAttributes", "style", rightRegExp);
	            }
	        },

	        _setStickyStyles: function(columns, stickyWidths) {
	            var that = this;
	            var i;
	            var j;
	            var leafsCols = leafColumns(nonLockedColumns(that.columns));
	            var rows = that.tbody.children(":not(.k-detail-row)");
	            var row;
	            var column;
	            var columnIndex;
	            var left;
	            var right;
	            var header;
	            var footer;
	            var groupHeader;
	            var cell;

	            for (i = 0; i < columns.length; i++) {
	                column = columns[i];
	                left = stickyWidths.left[i];
	                right = stickyWidths.right[i];
	                columnIndex = leafsCols.indexOf(column);
	                header = that._getColumnHeader(column);

	                header.addClass(STICKY_HEADER_CLASS);
	                if (column.headerAttributes["class"] && column.headerAttributes["class"].indexOf(STICKY_HEADER_NO_BORDER_CLASS) !== -1) {
	                    header.addClass(STICKY_HEADER_NO_BORDER_CLASS);
	                }
	                setLeftAndRightStyles(header, left, right);

	                if (column.columns) {
	                    continue;
	                }

	                if (that.footer) {
	                    footer = that.footer.find(".k-grid-footer-wrap tr.k-footer-template").children().filter(":not(.k-group-cell,.k-hierarchy-cell)").eq(columnIndex);

	                    footer.addClass(STICKY_FOOTER_CLASS);
	                    setLeftAndRightStyles(footer, left, right);
	                }

	                for (j = 0; j < rows.length; j++) {
	                    row = $(rows[j]);

	                    if (row.hasClass("k-grouping-row")) {
	                        groupHeader = row.find("." + column.groupHeaderColumnTemplateClass);

	                        groupHeader.addClass(STICKY_CELL_CLASS);
	                        setLeftAndRightStyles(groupHeader, left, right);
	                    } else {
	                        cell = row.children().filter(":not(.k-group-cell,.k-hierarchy-cell)").eq(columnIndex);

	                        cell.addClass(STICKY_CELL_CLASS);
	                        setLeftAndRightStyles(cell, left, right);
	                    }
	                }
	            }
	        },

	        _removeStickyStyles: function(columns) {
	            var that = this;
	            var i;
	            var j;
	            var leafsCols = leafColumns(nonLockedColumns(that.columns));
	            var rows = that.tbody.children(":not(.k-detail-row)");
	            var row;
	            var column;
	            var columnIndex;
	            var header;
	            var footer;
	            var groupHeader;
	            var cell;

	            for (i = 0; i < columns.length; i++) {
	                column = columns[i];
	                columnIndex = leafsCols.indexOf(column);
	                header = that._getColumnHeader(column);

	                header.removeClass(STICKY_HEADER_CLASS);
	                header.removeClass(STICKY_HEADER_NO_BORDER_CLASS);
	                setLeftAndRightStyles(header, "", "");

	                if (column.columns) {
	                    that._removeStickyStyles(column.columns);
	                    continue;
	                }

	                if (column.footerTemplate && that.footer) {
	                    footer = that.footer.find(".k-grid-footer-wrap tr.k-footer-template").children().filter(":not(.k-group-cell,.k-hierarchy-cell)").eq(columnIndex);

	                    footer.removeClass(STICKY_FOOTER_CLASS);
	                    setLeftAndRightStyles(footer, "", "");
	                }

	                for (j = 0; j < rows.length; j++) {
	                    row = $(rows[j]);

	                    if (row.hasClass("k-grouping-row")) {
	                        groupHeader = row.find("." + column.groupHeaderColumnTemplateClass);

	                        groupHeader.removeClass(STICKY_CELL_CLASS);
	                        setLeftAndRightStyles(groupHeader, "", "");
	                    } else {
	                        cell = row.children().filter(":not(.k-group-cell,.k-hierarchy-cell)").eq(columnIndex);

	                        cell.removeClass(STICKY_CELL_CLASS);
	                        setLeftAndRightStyles(cell, "", "");
	                    }
	                }
	            }
	        },

	        _getColumnHeader: function(column) {
	            var that = this;
	            var header = $("#" + column.headerAttributes.id).length ? $("#" + column.headerAttributes.id) : $("#" + that._cellId);

	            return header;
	        },

	        _sumColumnWidth: function(column) {
	            var that = this;
	            var width = 0;

	            if (column.columns) {
	                width = that._sumCurrentWidths(leafColumns([column]));
	            } else {
	                width = that._sumCurrentWidths([column]);
	            }

	            return width;
	        },

	        _sumCurrentWidths: function(cols) {
	            var that = this;
	            var width = 0;
	            var colWidth = 0;
	            var col;
	            var header;
	            var i;
	            var length = cols.length;

	            for (i = 0; i < length; i++) {
	                col = cols[i];
	                header = that._getColumnHeader(col);

	                if (!col.hidden && columnMatchesMedia(col)) {
	                    colWidth = header.is(":visible") ? header.outerWidth() : col.width;

	                    width += colWidth ? parseInt(colWidth, 10) : 0;
	                }
	            }

	            return width;
	        },

	        _relatedRow: function(row) {
	            var lockedTable = this.lockedTable;
	            row = $(row);

	            if (!lockedTable) {
	                return row;
	            }

	            var table = row.closest(this.table.add(this.lockedTable));
	            var index = table.find(">tbody>tr").index(row);

	            table = table[0] === this.table[0] ? lockedTable : this.table;

	            return table.find(">tbody>tr").eq(index);
	        },

	        _relatedCell: function(cell) {
	            var lockedTable = this.lockedTable;

	            cell = $(cell);

	            if (!lockedTable) {
	                return cell;
	            }

	            var table = cell.closest(this.table.add(this.lockedTable));
	            var index = table.find(">tbody>tr>td").index(cell);

	            table = table[0] === this.table[0] ? lockedTable : this.table;

	            return table.find(">tbody>tr>td").index(index);
	        },

	        clearSelection: function() {
	            var that = this;

	            if (that.selectable && !that._checkBoxSelection) {
	                that.selectable.clear();
	            }

	            if (that._checkBoxSelection) {
	                that._deselectCheckRows(that.select());
	                return;
	            }

	            if (that.options.persistSelection) {
	                that._persistSelectedRows();
	            } else {
	                that._selectedIds = {};
	            }

	            that.trigger(CHANGE);
	        },

	        select: function(items) {
	            var that = this,
	                selectable = that.selectable,
	                selectableoptions = kendo.ui.Selectable.parseOptions(this.options.selectable),
	                cell = selectableoptions.cell;

	            items = that.table.add(that.lockedTable).find(items);
	            if(items.length) {
	                if(selectable && !selectable.options.multiple) {
	                    selectable.clear();
	                    items = items.first();
	                }

	                if (that._isLocked()) {
	                    items = items.add(items.map(function() {
	                        if (cell) {
	                            return that._relatedCell(this);
	                        }
	                        else {
	                            return that._relatedRow(this);
	                        }
	                    }));
	                }

	                if(selectable && !that._checkBoxSelection) {
	                   selectable.value(items);
	                } else {
	                    that._checkRows(items);
	                    if(that.select().length === that.items().length) {
	                        that._toggleHeaderCheckState(true);
	                    }

	                    if (!cell) {
	                        that._persistSelectedRows();
	                    }

	                    that.trigger(CHANGE);
	                }

	                return;
	            }

	            return selectable ? selectable.value() : that.items().filter("." + SELECTED);
	        },

	        _toggleHeaderCheckState: function(checked) {
	            var that = this;
	            if(checked) {
	                that.thead.add(that.lockedHeader).find("tr " + CHECKBOXINPUT)
	                    .prop("checked", true).attr("aria-checked", true)
	                    .attr("aria-label", "Deselect all rows");
	            } else {
	                that.thead.add(that.lockedHeader).find("tr " + CHECKBOXINPUT)
	                    .prop("checked", false).attr("aria-checked", false)
	                    .attr("aria-label", "Select all rows");
	            }
	        },

	        _uncheckCheckBoxes: function () {
	            var that= this;
	            var tables = that.table.add(that.lockedTable);

	            tables.find("tbody " + CHECKBOXINPUT).attr("aria-checked", false)
	                .prop("checked", false).attr("aria-label", "Select row");

	        },

	        _deselectCheckRows: function(items) {
	            var that = this;
	            items = that.table.add(that.lockedTable).find(items);

	            if (that._isLocked()) {
	                items = items.add(items.map(function() {
	                    return that._relatedRow(this);
	                }));
	            }

	            items.each(function() {
	                $(this).removeClass(SELECTED).find(CHECKBOXINPUT).attr("aria-checked", false)
	                    .prop("checked", false).attr("aria-label", "Select row");
	            });
	            that._toggleHeaderCheckState(false);

	            that._persistSelectedRows();

	            that.trigger(CHANGE);
	        },

	        _checkRows: function(items) {
	            items.each(function() {
	                $(this).addClass(SELECTED).find(CHECKBOXINPUT).prop("checked", true)
	                    .attr("aria-label", "Deselect row").attr("aria-checked", true);
	            });
	        },

	        _persistSelectedRows: function() {
	            var that = this,
	                key,
	                dataItem,
	                allRows = that.items(),
	                dataSourceOptions = that.dataSource.options,
	                schema = dataSourceOptions.schema,
	                modelId,
	                selectedViewIds = {};

	            if (!schema || !schema.model || !that._data) {
	                return;
	            }

	            modelId = isFunction(schema.model) ? schema.model.fn.idField : schema.model.id;

	            if (!modelId) {
	                return;
	            }

	            that.select().each(function() {
	                dataItem = that.dataItem(this);
	                selectedViewIds[dataItem[modelId]] = true;
	            });

	            for (var i = 0; i < allRows.length; i ++) {
	                dataItem = that.dataItem(allRows[i]);
	                key = dataItem[modelId];
	                if(selectedViewIds[key]) {
	                    that._selectedIds[key] = true;
	                } else {
	                    delete that._selectedIds[key];
	                }
	            }
	        },

	        selectedKeyNames: function() {
	            var that = this,
	                ids = [];
	            for (var property in that._selectedIds) {
	                ids.push(property);
	            }
	            ids.sort();
	            return ids;
	        },

	        _updateCurrentAttr: function(current, next) {
	            var headerId = $(current).data("headerId");
	            var nextId;

	            $(current)
	                .removeClass(FOCUSED)
	                .closest("table")
	                .removeAttr("aria-activedescendant");

	            if(headerId){
	                headerId = headerId.replace(this._cellId, "");
	                $(current).attr("id", headerId);
	            }else{
	                $(current).removeAttr("id");
	            }

	            nextId = next.attr("id");

	            if (nextId != this._cellId) {
	                next.data("headerId", nextId);
	            }

	            next
	                .attr("id", this._cellId)
	                .addClass(FOCUSED)
	                .closest("table")
	                .attr("aria-activedescendant", this._cellId);

	            this._current = next;
	        },

	        _scrollCurrent: function() {
	            var current = this._current;
	            var scrollable = this.options.scrollable;

	            if (!current || !scrollable) {
	                return;
	            }

	            var row = current.parent();
	            var tableContainer = row.closest("table").parent();

	            var isInLockedContainer = tableContainer.is(".k-grid-content-locked,.k-grid-header-locked");
	            var isInContent = tableContainer.is(".k-grid-content-locked,.k-grid-content,.k-virtual-scrollable-wrap");

	            var scrollableContainer = $(this.content).find(">.k-virtual-scrollable-wrap").addBack().last()[0];

	            //adjust scroll vertically
	            if (isInContent) {
	                if (this.virtualScroll) {
	                    var rowIndex = Math.max(inArray(row[0], this._items(row.parent())), 0);
	                    if (this.virtualScroll.rows) {
	                        this._rowVirtualIndex = this.virtualScrollable.itemIndex(rowIndex);
	                        this.virtualScrollable.scrollIntoView(row);
	                    } else {
	                        this._rowVirtualIndex = rowIndex;
	                        this._scrollTo(this._relatedRow(row)[0], scrollableContainer);
	                    }
	                } else {
	                    this._scrollTo(this._relatedRow(row)[0], scrollableContainer);
	                }
	            }

	            if (this.lockedContent) {
	                //sync locked and non-locked content scrollTop
	                this.lockedContent[0].scrollTop = scrollableContainer.scrollTop;
	            }

	            //adjust scroll horizontally, if not inside locked tables
	            if (!isInLockedContainer) {
	                this._scrollTo(current[0], scrollableContainer);
	            }
	        },

	        current: function(next) {
	            return this._setCurrent(next, true);
	        },

	        _setCurrent: function(next, preventTrigger, preventScroll) {
	            var current = this._current;
	            next = $(next);

	            if (next.length) {
	                if (!current || current[0] !== next[0]) {
	                    var parent = next.parent();
	                    var siblings = parent.children(DATA_CELL);
	                    var colspan = parseInt(parent.children().first().attr("colspan"), 10);

	                    if (this._hasVirtualColumns()) {
	                        this._virtualCellIndex = (colspan > 1 ? colspan : 0) + siblings.index(next);
	                    }
	                    this._updateCurrentAttr(current, next);

	                    if (!preventScroll) {
	                        this._scrollCurrent();
	                    }

	                    if (!preventTrigger) {
	                        this.trigger(NAVIGATE, {
	                            element: next
	                        });
	                    }
	                }
	            }

	            if (next && next.length) {
	                this._lastCellIndex = next.parent().children(DATA_CELL).index(next);
	            }
	            return this._current;
	        },

	        _removeCurrent: function() {
	            if (this._current) {
	                this._current.removeClass(FOCUSED);
	                this._current = null;
	            }
	        },

	        _scrollTo: function(element, container) {
	            var elementToLowercase = element.tagName.toLowerCase();
	            var isHorizontal =  elementToLowercase === "td" || elementToLowercase === "th";
	            var table = $(element).closest("table")[0];
	            var elementOffsetDir = element[isHorizontal ? "offsetWidth" : "offsetHeight"];
	            var containerScroll = container[isHorizontal ? "scrollLeft" : "scrollTop"];
	            var containerOffsetDir = container[isHorizontal ? "clientWidth" : "clientHeight"];
	            var elementOffset = $(element).css("position") === "relative" && isRtl && isHorizontal ? Math.abs(table.offsetLeft - element.offsetLeft) : element[isHorizontal ? "offsetLeft" : "offsetTop"];
	            var bottomDistance = elementOffset + elementOffsetDir;
	            var result = 0;
	            var ieCorrection = 0;
	            var firefoxCorrection = 0;

	            if (isRtl && isHorizontal) {
	                if (browser.msie || browser.edge) {
	                    ieCorrection = table.offsetLeft;
	                } else if (browser.mozilla || (browser.webkit && (browser.version > 85))) {
	                    firefoxCorrection = table.offsetLeft - kendo.support.scrollbar();
	                }
	            }

	            containerScroll = Math.abs(containerScroll + ieCorrection - firefoxCorrection);

	            if (containerScroll > elementOffset) {
	                result = elementOffset;
	            } else if (bottomDistance > (containerScroll + containerOffsetDir)) {
	                if (elementOffsetDir <= containerOffsetDir) {
	                    result = (bottomDistance - containerOffsetDir);
	                } else {
	                    result = elementOffset;
	                }
	            } else {
	                result = containerScroll;
	            }

	            result = Math.abs(result + ieCorrection) + firefoxCorrection;

	            container[isHorizontal ? "scrollLeft" : "scrollTop"] = result;
	        },

	        _navigatable: function() {
	            var that = this;

	            if (!that.options.navigatable) {
	                return;
	            }

	            //data tables - locked and non-locked
	            var dataTables = that.table.add(that.lockedTable);
	            //header tables - locked and non-locked
	            var headerTables = that.thead.parent().add($(">table", that.lockedHeader));

	            //the over wich keys will be handled
	            var tables = dataTables;

	            if (that.options.scrollable) {
	                //add the header table when the widget is scrollable
	                tables = tables.add(headerTables);
	                //data tables will recive first focus on TAB
	                headerTables.attr(TABINDEX, -1);
	            }

	            this._navigatableTables = tables;

	            //dettach all previous events
	            tables.off("mousedown" + NS + " focus" + NS + " focusout" + NS + " keydown" + NS);

	            headerTables
	                .on("keydown" + NS, proxy(that._openHeaderMenu, that))
	                .find("a.k-link").attr("tabIndex", -1);

	            //prevent propagation when clicked inside detail grid
	            dataTables
	                .attr(TABINDEX, math.max(dataTables.attr(TABINDEX) || 0, 0))
	                .on("keydown" + NS, ".k-detail-cell", function(e) {
	                    if (e.target !== e.currentTarget) {
	                        e.stopImmediatePropagation();
	                    }
	                });

	            tables
	                //handle click on tables, will attempt to focus the table
	                .on((kendo.support.touch ? "touchstart" + NS : "mousedown" + NS), NAVROW + ">" + NAVCELL, proxy(tableClick, that))
	                .on("focus" + NS, proxy(that._tableFocus, that))
	                .on("focusout" + NS, proxy(that._tableBlur, that))
	                .on("keydown" + NS, that, proxy(that._tableKeyDown, that));
	        },

	        _openHeaderMenu: function(e) {
	            if (e.altKey && e.keyCode == keys.DOWN) {
	                this.current().find(".k-grid-filter, .k-header-column-menu").click();
	                e.stopImmediatePropagation();
	            }
	        },

	        _setTabIndex: function(table) {
	            this._navigatableTables.attr(TABINDEX, -1);

	            table.attr(TABINDEX, 0);
	        },

	        _tableFocus: function(e) {
	            var current = this.current();
	            var table = $(e.currentTarget);

	            //if there is already current, highlighted it
	            //otherwise highlight the first possible cell
	            if (current && current.is(":visible")) {
	                current.addClass(FOCUSED);
	            } else {
	                if (this._virtualColScroll) {
	                    this._setCurrent(table.find(FIRSTNAVITEM), true, true);
	                } else {
	                    this._setCurrent(table.find(FIRSTNAVITEM));
	                }
	            }

	            this._setTabIndex(table);
	        },

	        _tableBlur: function() {
	            var current = this.current();

	            if (current) {
	                current.removeClass(FOCUSED);
	            }
	        },

	        _findCellIndex: function (columns, startIndex, reversed) {
	            var cellIndex;
	            var i;

	            if (reversed) {
	                for (i = startIndex; i >= 0; i--) {
	                    cellIndex = i;
	                    if (!columns[i].hidden) {
	                        break;
	                    }
	                }
	            } else {
	                for (i = startIndex; i < columns.length; i++) {
	                    cellIndex = i;
	                    if (!columns[i].hidden) {
	                        break;
	                    }
	                }
	            }

	            return cellIndex;
	        },

	        _scrollToColumn: function (key, e) {
	            if (this._virtualCellIndex === undefined) {
	                return false;
	            }

	            var that = this;
	            var cellIndex = that._virtualCellIndex;
	            var leafsCols = leafColumns(nonLockedColumns(that.columns));
	            var scrollWidth = 0;

	            if (key == (isRtl ? keys.LEFT : keys.RIGHT) && (cellIndex !== leafsCols.length -1)) {
	                cellIndex = that._findCellIndex(leafsCols, cellIndex + 1);
	            } else if (key == (isRtl ? keys.RIGHT : keys.LEFT) && cellIndex) {
	                cellIndex = that._findCellIndex(leafsCols,cellIndex - 1, true);
	            } else if (key == keys.HOME) {
	                cellIndex = that._findCellIndex(leafsCols, 0);
	            } else if (key == keys.END) {
	                cellIndex = that._findCellIndex(leafsCols, leafsCols.length - 1, true);
	            }

	            for (var i = 0; i < cellIndex; i++) {
	                scrollWidth += leafsCols[i].width;
	            }

	            that._virtualCellIndex = cellIndex;
	            if (e) {
	                e.preventDefault();
	                e.stopPropagation();
	            }
	            kendo.scrollLeft(that.content, scrollWidth);
	            return true;
	        },

	        _tableKeyDown: function(e) {
	            var current = this.current();
	            var virtualScroll = this.virtualScroll || {};
	            var requestInProgress = this.virtualScrollable && this.virtualScrollable.fetching();
	            var target = $(e.target);
	            var canHandle = !e.isDefaultPrevented() && !target.is(":button,a,:input,a>.k-icon");

	            // do not handle key down if request in progress
	            // or there isn't current set
	            if (requestInProgress) {
	                // swallow key events while in progress
	                e.preventDefault();
	                return;
	            }

	            if (virtualScroll.columns && (!current || !document.body.contains(current[0])) && (this._scrollToColumn(e.keyCode, e))) {
	                return;
	            }

	            if (!current) {
	                current = $(this.lockedTable).add(this.options.scrollable ? this.table : this.tbody).find(FIRSTNAVITEM);
	            }

	            if (!current.length) {
	                return;
	            }

	            var handled = false;

	            if (canHandle && e.keyCode == keys.UP) {
	                handled = this._moveUp(current, e.shiftKey);
	            }

	            if (canHandle && e.keyCode == keys.DOWN) {
	                handled = this._moveDown(current, e.shiftKey);
	            }

	            if (canHandle && e.keyCode == (isRtl ? keys.LEFT : keys.RIGHT)) {
	                handled = this._moveRight(current, e.altKey, e.shiftKey, e.ctrlKey, e.currentTarget);
	            }

	            if (canHandle && e.keyCode == (isRtl ? keys.RIGHT : keys.LEFT)) {
	                handled = this._moveLeft(current, e.altKey, e.shiftKey, e.ctrlKey, e.currentTarget);
	            }

	            if (canHandle && e.keyCode == keys.PAGEDOWN) {
	                handled = this._handlePageDown();
	            }

	            if (canHandle && e.keyCode == keys.PAGEUP) {
	                handled = this._handlePageUp();
	            }

	            if (canHandle && e.keyCode == keys.HOME) {
	                handled = this._handleHome(current, e.ctrlKey);
	            }

	            if (canHandle && e.keyCode == keys.END) {
	                handled = this._handleEnd(current, e.ctrlKey);
	            }

	            if (canHandle && e.keyCode == keys.SPACEBAR) {
	                handled = this._handleSpaceKey(current, e.ctrlKey);
	            }

	            if (e.keyCode == keys.ENTER || e.keyCode == keys.F2) {
	                handled = this._handleEnterKey(current, e.currentTarget, target);
	            }

	            if (e.keyCode == keys.ESC) {
	                handled = this._handleEscKey(current, e.currentTarget);
	            }

	            if (e.keyCode == keys.TAB) {
	                handled = this._handleTabKey(current, e.currentTarget, e.shiftKey);
	            }

	            if (handled) {
	                //prevent scrolling while pressing the keys
	                e.preventDefault();
	                //required in hierarchy
	                e.stopPropagation();
	            }
	        },

	        _moveLeft: function(current, altKey, shiftKey, ctrlKey, currentTable) {
	            var next, index;
	            var row = current.parent();
	            //thead or tbody
	            var container = row.parent();

	            if (altKey) {
	                this.collapseRow(row);
	            } else if (ctrlKey && current.is(".k-header") && this.options.reorderable) {
	               this._moveColumn(current, true);
	            } else {
	                index = container.find(NAVROW).index(row);
	                next = this._prevHorizontalCell(container, current, index);

	                if (!next[0]) {
	                    if (shiftKey) {
	                        if (this.lockedTable) {
	                            next = this._relatedRow(row);
	                            if ($.contains(this.lockedTable[0], row[0])) {
	                                next = next.prevAll(ITEMROW + ":first");
	                            }
	                            next = next.children(DATA_CELL + ":last");
	                        } else {
	                            next = this._tabNext(current, currentTable, true);
	                        }
	                    } else {
	                        container = this._horizontalContainer(container);

	                        next = this._prevHorizontalCell(container, current, index);

	                        if (next[0] !== current[0]) {
	                            focusTable(container.parent(), true);
	                        }
	                    }
	                }

	                this._setCurrent(next);
	            }

	            return true;
	        },

	        _moveRight: function(current, altKey, shiftKey, ctrlKey, currentTable) {
	            var next, index;
	            var row = current.parent();
	            //thead or tbody
	            var container = row.parent();

	            if (altKey) {
	                this.expandRow(row);
	             } else if (ctrlKey && current.is(".k-header") && this.options.reorderable) {
	                this._moveColumn(current, false);
	            } else {
	                index = container.find(NAVROW).index(row);
	                next = this._nextHorizontalCell(container, current, index);

	                if (!next[0]) {
	                    if (shiftKey) {
	                       if (this.lockedTable) {
	                            next = this._relatedRow(row);
	                            if ($.contains(this.table[0], row[0])) {
	                                next = next.nextAll(ITEMROW + ":first");
	                            }
	                            next = next.children(DATA_CELL + ":first");
	                        } else {
	                            next = this._tabNext(current, currentTable, false);
	                        }
	                    } else {
	                        container = this._horizontalContainer(container, true);

	                        next = this._nextHorizontalCell(container, current, index);

	                        if (next[0] !== current[0]) {
	                            focusTable(container.parent(), true);
	                        }
	                    }
	                }

	                this._setCurrent(next);
	            }

	            return true;
	        },

	        _moveUp: function(current, shiftKey) {
	            //thead or tbody
	            var container = current.parent().parent();
	            var next;

	            if (shiftKey) {
	               next = current.parent();
	               next = next.prevAll(ITEMROW + ":first");
	               next = current.parent().is(ITEMROW) ? next.children().eq(current.index()) : next.children(DATA_CELL + ":last" );
	            } else {
	               next = this._prevVerticalCell(container, current);
	               if (!next[0]) {
	                  this._lastCellIndex = 0;
	                  container = this._verticalContainer(container, true);

	                  next = this._prevVerticalCell(container, current);

	                  if (next[0]) {
	                      focusTable(container.parent(), true);
	                  }
	               }
	            }

	            var tmp = this._lastCellIndex || 0;
	            this._setCurrent(next);
	            this._lastCellIndex = tmp;

	            return true;
	        },

	        _moveDown: function(current, shiftKey) {
	            //thead or tbody
	            var container = current.parent().parent();
	            var next;

	            if (shiftKey) {
	                next = current.parent();
	                next = next.nextAll(ITEMROW + ":first");
	                next = current.parent().is(ITEMROW)? next.children().eq(current.index()) : next.children(DATA_CELL + ":first" );
	            } else {
	                next = this._nextVerticalCell(container, current);
	                if (!next[0]) {
	                    this._lastCellIndex = 0;
	                    container = this._verticalContainer(container);

	                    next = this._nextVerticalCell(container, current);
	                    if (next[0]) {
	                        focusTable(container.parent(), true);
	                    }
	                }
	            }
	            var tmp = this._lastCellIndex || 0;
	            this._setCurrent(next);
	            this._lastCellIndex = tmp;
	            return true;
	        },

	        _moveColumn: function(current, isLeft) {
	            var elements = this.wrapper.data().kendoReorderable.element.find(this._draggableInstance.options.filter + ":visible");

	            var columns = visibleColumns(flatColumnsInDomOrder(this.columns));
	            var oldIndex = elements.index($(current));
	            var offset = isLeft ? - 1: 1;
	            var column = columns[oldIndex];
	            var newIndex = targetParentContainerIndex(columns, this.columns, oldIndex, oldIndex + offset);
	            if (newIndex >= 0) {
	                this.reorderColumn(newIndex, column, isLeft);
	                this.trigger(COLUMNREORDER, {
	                    newIndex: newIndex,
	                    oldIndex: oldIndex,
	                    column: column
	                });
	            }
	        },

	        _handleHome: function(current, ctrl) {
	            var row = current.parent();
	            var rowContainer = row.parent();
	            var isInLockedTable = this.lockedTable && this.lockedTable.children("tbody")[0] === rowContainer[0];
	            var isInBody = rowContainer[0] === this.tbody[0];
	            var prev;

	            if (this._hasVirtualColumns()) {
	                this._scrollToColumn(kendo.keys.HOME);
	                return true;
	            }

	            if (ctrl) {
	                if (this.lockedTable) {
	                    prev = this.lockedTable.find(FIRSTITEMROW + ">" + NAVCELL + ":first");
	                } else {
	                    prev = this.table.find(FIRSTITEMROW + ">" + NAVCELL + ":first");
	                }
	            } else if (isInBody || isInLockedTable) {
	                if (isInBody && this.lockedTable) {
	                    row = this._relatedRow(row);
	                }
	                prev = row.children(DATA_CELL + ":first");
	            }

	            if (prev && prev.length) {
	                this._setCurrent(prev);
	                return true;
	            }
	        },

	        _handleEnd: function(current, ctrl) {
	            var row = current.parent();
	            var rowContainer = row.parent();
	            var isInLockedTable = this.lockedTable && this.lockedTable.children("tbody")[0] === rowContainer[0];
	            var isInBody = rowContainer[0] === this.tbody[0];
	            var next;

	            if (this._hasVirtualColumns()) {
	                this._scrollToColumn(kendo.keys.END);
	                return true;
	            }

	            if (ctrl) {
	                next = this.table.find(LASTITEMROW + ">" + NAVCELL + ":last");
	            } else if (isInBody || isInLockedTable) {
	                if (!isInBody && this.lockedTable) {
	                    row = this._relatedRow(row);
	                }
	                next = row.children(DATA_CELL + ":last");
	            }

	            if (next && next.length) {
	                this._setCurrent(next);
	                return true;
	            }
	        },

	        _handlePageDown: function() {
	            if (!this.options.pageable) {
	                return false;
	            }

	            this.dataSource.page(this.dataSource.page() + 1);

	            return true;
	        },

	        _handlePageUp: function() {
	            if (!this.options.pageable) {
	                return false;
	            }

	            this.dataSource.page(this.dataSource.page() - 1);

	            return true;
	        },

	        _handleTabKey: function(current, currentTable, shiftKey) {
	            var isInCell = this.options.editable && this._editMode() == "incell";
	            var cell;

	            if (!isInCell || current.is("th")) {
	                return false;
	            }

	            cell = $(activeElement()).closest(".k-edit-cell");

	            if (cell[0] && cell[0] !== current[0]) {
	                current = cell;
	            }

	            cell = this._tabNext(current, currentTable, shiftKey);

	            if (cell[0] === current[0]) {
	                return false;
	            }

	            if (cell.length) {
	                this._handleEditing(current, cell, cell.closest("table"));

	                return true;
	            }

	            return false;
	        },

	        _handleEscKey: function(current, currentTable) {
	            var active = activeElement();
	            var isInCell = this._editMode() == "incell";

	            if (!isInEdit(current)) {
	                if (current.has(active).length) {
	                    // return focus back to the table
	                    focusTable(currentTable, true);

	                    return true;
	                }
	                return false;
	            }

	            if (isInCell) {
	                this.closeCell(true);
	            } else {
	                var currentIndex = $(current).parent().index();
	                if (active) {
	                    active.blur();
	                }
	                this.cancelRow(true);
	                if (currentIndex >= 0) {
	                    this._setCurrent(this.items().eq(currentIndex).children(NAVCELL).first());
	                }
	            }

	            if (browser.msie && browser.version < 9) {
	                document.body.focus();
	            }

	            focusTable(currentTable, true);

	            return true;
	        },

	        _toggleCurrent: function(current, editable, hasDetails) {
	            var row = current.parent();

	            if (row.is(".k-grouping-row")) {
	                row.find(".k-icon:first").click();

	                return true;
	            }

	            if (!editable && hasDetails) {
	                row.find(".k-icon:first").click();

	                return true;
	            }

	            return false;
	        },

	        _handleSpaceKey: function(current, ctrlKey) {
	            var that = this;

	            if (!ctrlKey || !that.groupable || !current.hasClass("k-header")) {
	                return;
	            }

	            var descriptors = that.groupable.descriptors();
	            var field = current.attr(kendo.attr("field"));
	            var aggregates = that.groupable.aggregates();
	            var label = current.attr(kendo.attr("title")) || field;

	            if (that.groupable._canDrag(current)) {
	                descriptors.push({
	                    field: field,
	                    dir: "asc",
	                    aggregates: aggregates || []
	                });
	                label += " " + that.options.messages.ungroupHeader;
	            } else {
	                descriptors = $.grep(descriptors, function (item)
	                {
	                    return item.field !== field;
	                });
	                label += " " + that.options.messages.groupHeader;
	            }

	            current.attr("aria-label", label);

	            that.dataSource.group(descriptors);

	            return true;
	        },

	        _handleEnterKey: function(current, currentTable, target) {
	            var editable = this.options.editable && this.options.editable.update !== false;
	            var container = target.closest("[role=gridcell]");
	            var hasDetails = this._hasDetails();
	            var link;

	            if (!target.is("table") && !$.contains(current[0], target[0])) {
	                current = container;
	            }

	            if (current.is("th")) {
	                // sort the column, if possible
	                link = current.find(".k-link");
	                if (link.length) {
	                    link.click();
	                } else {
	                    current.find(CHECKBOXINPUT).focus();
	                }

	                return true;
	            }

	            if (this._toggleCurrent(current, editable, hasDetails)) {
	                return true;
	            }

	            var focusable = current.find(":kendoFocusable:first");
	            if (focusable[0] && !current.hasClass("k-edit-cell") && current.hasClass("k-state-focused")) {
	                focusable.focus();

	                return true;
	            }

	            if (editable && !target.is(":button,.k-button,textarea")) {
	                if (!container[0]) {
	                    container = current;
	                }

	                this._handleEditing(container, false, currentTable);

	                return true;
	            }

	            return false;
	        },

	        _nextHorizontalCell: function(table, current, originalIndex) {
	            var cells = current.nextAll(DATA_CELL);

	            if (!cells.length) {
	                var rows = table.find(NAVROW);
	                var rowIndex = rows.index(current.parent());

	                //no sibling cells are found and we've changed the table
	                if (rowIndex == -1) {
	                    if (current.hasClass("k-header")) {
	                        var headerRows = [];
	                        mapColumnToCellRows([lockedColumns(this.columns)[0]], childColumnsCells(rows.eq(0).children(":visible").first()), headerRows, 0, 0);

	                        if (headerRows[originalIndex]) {
	                            return headerRows[originalIndex][0];
	                        }

	                        return current;
	                    }

	                    //current is in filter row
	                    if (current.parent().hasClass("k-filter-row")) {
	                        return rows.last().children(DATA_CELL).first();
	                    }

	                    //get the same row index in the new table
	                    return rows.eq(originalIndex).children(DATA_CELL).first();
	                }
	            }

	            return cells.first();
	        },

	        _prevHorizontalCell: function(table, current, originalIndex) {
	            var cells = current.prevAll(DATA_CELL);

	            if (!cells.length) {
	                var rows = table.find(NAVROW);
	                var rowIndex = rows.index(current.parent());

	                //no sibling cells are found and we've changed the table
	                if (rowIndex == -1) {
	                    if (current.hasClass("k-header")) {
	                        var headerRows = [];
	                        var columns = lockedColumns(this.columns);
	                        mapColumnToCellRows([columns[columns.length - 1]], childColumnsCells(rows.eq(0).children().last()), headerRows, 0, 0);

	                        if (headerRows[originalIndex]) {
	                            return headerRows[originalIndex][0];
	                        }

	                        return current;
	                    }

	                    //current is in filter row
	                    if (current.parent().hasClass("k-filter-row")) {
	                        return rows.last().children(DATA_CELL).last();
	                    }

	                    //get the same row index in the new table
	                    return rows.eq(originalIndex).children(DATA_CELL).last();
	                }
	            }

	            return cells.first();
	        },

	        _currentDataIndex: function(table, current) {
	            var index = current.attr("data-index");

	            if (!index) {
	                return undefined;
	            }

	            var lockedColumnsCount = lockedColumns(this.columns).length;
	            if (lockedColumnsCount && !table.closest("div").hasClass("k-grid-content-locked")[0]) {
	                return index - lockedColumnsCount;
	            }

	            return index;
	        },

	        _prevVerticalCell: function(container, current) {
	            var cells;
	            var row = current.parent();
	            var rows = container.children(NAVROW);
	            var rowIndex = rows.index(row);
	            //get data-index in case of last level of multi-level columns
	            var index = this._currentDataIndex(container, current);

	            //current is in the header, but not at the last level of multi-level columns
	            if (index || current.hasClass("k-header")) {
	                cells = parentColumnsCells(current);
	                return cells.eq(cells.length - 2);
	            }

	            //check this out
	            index = Math.max(row.children(DATA_CELL).index(current), this._lastCellIndex || 0);

	            //if current is inside filter row
	            if (row.hasClass("k-filter-row")) {
	                return leafDataCells(container).filter(isCellVisible).eq(index);
	            }

	            //move up to header container
	            if (rowIndex == -1) {
	                if (this._hasVirtualColumns()) {
	                    index = this._virtualCellIndex;
	                }
	                //is there filter row in the header container
	                row = container.find("tr.k-filter-row:visible");
	                if (!row[0]) {
	                    // in hierarchical grid we need to correct the index
	                    // since the k-hierarchy cell is navigatable
	                    if ((this._hasDetails() || current.parent().find('.k-hierarchy-cell').length) && index) {
	                        index--;
	                    }
	                    return leafDataCells(container).filter(isCellVisible).eq(index);
	                }
	            } else {
	                row =  rowIndex === 0 ? $() : rows.eq(rowIndex - 1);
	            }

	            cells = row.children(DATA_CELL);
	            if (cells.length > index) {
	                return cells.eq(index);
	            }

	            return cells.eq(0);
	        },

	        _nextVerticalCell: function(container, current) {
	            var cells;
	            var row = current.parent();
	            var rows = container.children(NAVROW);
	            var rowIndex = rows.index(row);
	            //get data-index in case of last level of multi-level columns
	            var index = this._currentDataIndex(container, current);
	            var virtualScroll = this.virtualScroll || {};
	            var colspan;

	            //current is in the header, but not at the last level of multi-level columns
	            //and we are not changing the table
	            if (rowIndex != -1 && index === undefined && current.hasClass("k-header")) {
	                return childColumnsCells(current).eq(1);
	            }

	            index = index ? parseInt(index, 10) : row.children(DATA_CELL).index(current);
	            index = Math.max(index, this._lastCellIndex || 0);

	            //move down to data container
	            if (rowIndex == -1) {
	                row = rows.eq(0);
	                if (virtualScroll.columns) {
	                    colspan = parseInt(row.children().first().attr("colspan"), 10);
	                    index = this._virtualCellIndex - (colspan > 1 ? colspan : 0);
	                }
	                // in hierarchical grid we need to correct the index
	                // since the k-hierarchy cell is navigatable
	                if (this._hasDetails() || row.find('.k-hierarchy-cell').length) {
	                    index++;
	                }
	            } else {
	                row = rows.eq(rowIndex + current[0].rowSpan);
	            }

	            var tmpIndex = index;
	            //in case of last level of multi-level columns the index should be updated depending on the hidden columns
	            if (this._currentDataIndex(container, current) !== undefined) {
	                var currentRowCells = row.children(":not(.k-group-cell):not(.k-hierarchy-cell)");
	                var hiddenColumns = currentRowCells.filter(":hidden");
	                for(var idx = 0, length = hiddenColumns.length; idx < length; idx++) {
	                    if (currentRowCells.index(hiddenColumns[idx]) < index) {
	                        tmpIndex--;
	                    }
	                }
	            }
	            index = tmpIndex;

	            cells = row.children(DATA_CELL);
	            if (cells.length > index) {
	                return cells.eq(index);
	            }

	            return cells.eq(0);
	        },

	        _verticalContainer: function(container, up) {
	            var table = container.parent();
	            var length = this._navigatableTables.length;
	            var step = Math.floor(length / 2);
	            var index = inArray(table[0], this._navigatableTables);

	            if (up) {
	                step *= -1;
	            }
	            index += step;

	            if (index >= 0 || index < length) {
	                table = this._navigatableTables.eq(index);
	            }

	            return table.find(up ? ">thead" : ">tbody");
	        },

	        _horizontalContainer: function(container, right) {
	            var length = this._navigatableTables.length;
	            if (length <= 2) {
	                return container;
	            }

	            var table = container.parent();
	            var index = inArray(table[0], this._navigatableTables);

	            index += right ? 1 : -1;

	            if (right && (index == 2 || index == length)) {
	                return container;
	            }

	            if (!right && (index == 1 || index < 0)) {
	                return container;
	            }

	            return this._navigatableTables.eq(index).find("thead, tbody");
	        },

	        _tabNext: function (current, currentTable, back) {
	            var switchRow = true;
	            var next = back ? current.prevAll(DATA_CELL + ":first") : current.nextAll(":visible:first");

	            if (!next.length) {
	                next = current.parent();
	                if (this.lockedTable) {
	                    switchRow = (back && currentTable == this.lockedTable[0]) || (!back && currentTable == this.table[0]);
	                    next = this._relatedRow(next);
	                }

	                if (switchRow) {
	                    if (this._hasVirtualColumns()) {
	                        return current;
	                    }
	                    next = next[back ? "prevAll" : "nextAll"]("tr:not(.k-grouping-row):not(.k-detail-row):visible:first");
	                }
	                next = next.children(DATA_CELL + (back ? ":last" : ":first"));
	            }

	            return next;
	        },

	        _handleEditing: function(current, next, table) {
	            var that = this,
	                active = $(activeElement()),
	                mode = that._editMode(),
	                isIE = browser.msie,
	                oldIE = isIE && browser.version < 9,
	                editContainer = that._editContainer,
	                focusable,
	                editable = that.options.editable && that.options.editable.update !== false,
	                isEdited;

	            table = $(table);
	            if (mode == "incell") {
	                isEdited = current.hasClass("k-edit-cell");
	            } else {
	                isEdited = current.parent().hasClass("k-grid-edit-row");
	            }

	            if (that.editable) {
	                if ($.contains(editContainer[0], active[0])) {
	                    if (browser.opera || oldIE) {
	                        active.blur().change().triggerHandler("blur");
	                    } else {
	                        active.blur();
	                        if (isIE) {
	                            //IE10 with jQuery 1.9.x does not trigger blur handler
	                            //numeric textbox does trigger change
	                            active.blur();
	                        }
	                    }
	                }

	                if (!that.editable) {
	                    focusTable(table);
	                    return;
	                }

	                if (that.editable.end()) {
	                    if (mode == "incell") {
	                        that.closeCell();
	                    } else {
	                        that.saveRow();
	                        isEdited = true;
	                    }
	                } else {
	                    if (mode == "incell") {
	                        that._setCurrent(editContainer);
	                    } else {
	                        that._setCurrent(editContainer.children().filter(DATA_CELL).first());
	                    }
	                    focusable = editContainer.find(":kendoFocusable:first")[0];
	                    if (focusable) {
	                        focusable.focus();
	                    }
	                    return;
	                }
	            }

	            if (next) {
	                that._setCurrent(next);
	            }

	            if (oldIE) {
	                document.body.focus();
	            }

	            focusTable(table, true);

	            if (!editable) {
	                return;
	            }

	            if ((!isEdited && !next) || next) {
	                if (mode === INCELL) {
	                    if (!$(that.current()).hasClass(HIERARCHY_CELL_CLASS)) {
	                        that.editCell(that.current());
	                    }
	                } else {
	                    that.editRow(that.current().parent());
	                }
	            }
	        },

	        _wrapper: function() {
	            var that = this,
	                table = that.table,
	                height = that.options.height,
	                width = that.options.width,
	                wrapper = that.element;

	            if (!wrapper.is("div")) {
	               wrapper = wrapper.wrap("<div/>").parent();
	            }

	            that.wrapper = wrapper.addClass("k-grid k-widget k-grid-display-block");

	            if (height) {
	                that.wrapper.css(HEIGHT, height);
	                table.css(HEIGHT, "auto");
	            }

	            if (width) {
	                that.wrapper.css("width", width);
	            }

	            that._initMobile();
	        },

	        _initMobile: function() {
	            var options = this.options;
	            var that = this;

	            this._isMobile = (options.mobile === true && kendo.support.mobileOS) ||
	                                options.mobile === "phone" ||
	                                options.mobile === "tablet";

	            if (this._isMobile) {
	                var html = this.wrapper.addClass("k-grid-mobile").wrap(
	                    '<div data-' + kendo.ns + 'stretch="true" data-' + kendo.ns + 'role="view" ' +
	                    'data-' + kendo.ns + 'init-widgets="false"></div>'
	                )
	                .parent();

	                this.pane = this._createPane(html);
	                this.view = this.pane.view();

	                if (options.height) {
	                    this.pane.element.parent().css(HEIGHT, options.height);
	                } else {
	                    this.pane.element.parent().css(HEIGHT, this.wrapper[0].style.height);
	                }

	                this._editAnimation = "slide";

	                // Grid transitions should not propagate to the view
	                that.wrapper.on("transitionend" + NS, function(e) {
	                    e.stopPropagation();
	                });

	                that.wrapper.on("contextmenu" + NS, "th a", function (e) {
	                    e.preventDefault();
	                    return false;
	                });

	                this.view.bind("showStart", function() {
	                    if (that._isLocked()) {
	                        that._updateTablesWidth();
	                        that._applyLockedContainersWidth();
	                        that._syncLockedContentHeight();
	                        that._syncLockedHeaderHeight();
	                        that._syncLockedFooterHeight();
	                    }
	                });
	            }
	        },

	        _createPane: function(html) {
	            var pane = kendo.Pane.wrap(html, {
	                viewEngine: {
	                    viewOptions: {
	                        renderOnInit: true,
	                        wrap: false,
	                        wrapInSections: true,
	                        detachOnHide: false,
	                        detachOnDestroy: false
	                    }
	                }
	            });

	            return pane;
	        },

	        _tbody: function() {
	            var that = this,
	                table = that.table,
	                tbody;

	            tbody = table.find(">tbody");

	            if (!tbody.length) {
	                tbody = $("<tbody/>").appendTo(table);
	            }

	            that.tbody = tbody.attr("role", "rowgroup");
	        },

	        _scrollable: function() {
	            var that = this,
	                header,
	                table,
	                options = that.options,
	                scrollable = options.scrollable,
	                hasVirtualScroll = scrollable !== true && scrollable.virtual,
	                virtualScroll = hasVirtualScroll ? parseVirtualSettings(scrollable.virtual) : null,
	                scrollbar = !kendo.support.kineticScrollNeeded || (virtualScroll && virtualScroll.rows) ? kendo.support.scrollbar() : 0,
	                headerWrap;

	            if (scrollable) {
	                header = that.wrapper.children(".k-grid-header");

	                if (!header[0]) {
	                    header = $('<div class="k-grid-header" />').insertBefore(that.table);
	                }

	                // workaround for IE issue where scroll is not raised if container is same width as the scrollbar
	                header.css((isRtl ? "padding-left" : "padding-right"), scrollable.virtual ? scrollbar + 1 : scrollbar);
	                table = $('<table role="grid" />');
	                if (isIE7) {
	                    table.attr("cellspacing", 0);
	                }

	                table.width(that.table[0].style.width);

	                table.append(that.thead);
	                header.empty().append($('<div class="k-grid-header-wrap k-auto-scrollable" />').append(table));


	                that.content = that.table.parent();
	                that.virtualScroll = virtualScroll;

	                if (that.content.is(".k-virtual-scrollable-wrap, " + DOT + classNames.scrollContainer)) {
	                    that.content = that.content.parent();
	                }

	                if (!that.content.is(".k-grid-content, .k-virtual-scrollable-wrap")) {
	                    that.content = that.table.wrap('<div class="k-grid-content k-auto-scrollable" />').parent();
	                }

	                if (virtualScroll && virtualScroll.rows && !that.virtualScrollable) {
	                    that._createVirtualScrollable();
	                }

	                if (virtualScroll && virtualScroll.columns) {

	                    that.table.css({
	                        width: sumWidths(visibleLeafColumns(visibleNonLockedColumns(that.columns)))
	                    });
	                }

	                headerWrap = header.children(".k-grid-header-wrap");

	                that.scrollables = headerWrap.add(that.content);

	                // the footer may exists if rendered from the server
	                var footer = that.wrapper.find(".k-grid-footer");

	                if (footer.length) {
	                    that.scrollables = that.scrollables.add(footer.children(".k-grid-footer-wrap"));
	                }

	                headerWrap.unbind("scroll" + NS).bind("scroll" + NS, function (e) {
	                    if (that._scrollLeft !== this.scrollLeft) {
	                        kendo.scrollLeft(that.scrollables.not(e.currentTarget), this.scrollLeft);
	                    }
	                });

	                if (virtualScroll && virtualScroll.rows) {
	                    that.content.find(">.k-virtual-scrollable-wrap").unbind("scroll" + NS).bind("scroll" + NS, function () {
	                        var isScrollingLeft = this.scrollLeft != that._scrollLeft;
	                        that._scrollLeft = this.scrollLeft;
	                        kendo.scrollLeft(that.scrollables, this.scrollLeft);
	                        if (that.lockedContent) {
	                            that.lockedContent[0].scrollTop = this.scrollTop;
	                        }
	                        if (virtualScroll.columns && isScrollingLeft) {
	                            that.refresh();
	                        }
	                    });
	                } else {
	                    var endless = scrollable.endless;
	                    var originalPageSize = that.dataSource.options.pageSize;
	                    if (endless) {
	                        that._endlessPageSize = originalPageSize;
	                    }
	                    that.content.unbind("scroll" + NS).bind("scroll" + NS, function (e) {
	                        var isScrollingLeft = this.scrollLeft != that._scrollLeft;
	                        that._scrollLeft = this.scrollLeft;
	                        kendo.scrollLeft(that.scrollables.not(e.currentTarget), that._scrollLeft);
	                        if (that.lockedContent && e.currentTarget == that.content[0]) {
	                            that.lockedContent[0].scrollTop = this.scrollTop;
	                        }
	                        if (endless) {
	                            if ((this.scrollTop + this.clientHeight - this.scrollHeight >= -10) &&
	                                !that._endlessFetchInProgress &&
	                                that._endlessPageSize < that.dataSource.total()) {
	                                that._skipRerenderItemsCount =  that._endlessPageSize;
	                                that._endlessPageSize = that._endlessPageSize + originalPageSize;
	                                that.dataSource.options.endless = true;
	                                that._endlessFetchInProgress = true;
	                                that.dataSource.pageSize(that._endlessPageSize);
	                            }
	                        }

	                        if (virtualScroll && virtualScroll.columns && isScrollingLeft) {
	                              that._virtualColScroll = true;
	                              that._cacheEditableState();
	                              that.refresh();
	                              that._restoreEditableState();
	                              that._virtualColScroll = false;
	                        }
	                    });

	                    var touchScroller = that.content.data("kendoTouchScroller");
	                    if (touchScroller) {
	                        touchScroller.destroy();
	                    }

	                    touchScroller = kendo.touchScroller(that.content);
	                    if (touchScroller && touchScroller.movable) {
	                        that.touchScroller = touchScroller;
	                        touchScroller.movable.bind("change", function(e) {
	                            kendo.scrollLeft(that.scrollables, -e.sender.x);
	                            if (that.lockedContent) {
	                                that.lockedContent.scrollTop(-e.sender.y);
	                            }
	                        });

	                        that.one(DATABOUND, function (e) {
	                            e.sender.wrapper.addClass("k-grid-backface");
	                        });
	                    }
	                }
	            }
	        },

	        _createVirtualScrollable: function() {
	            var that = this;

	            if (that.virtualScrollable) {
	                that.virtualScrollable.destroy();
	            }

	            that.virtualScrollable = new VirtualScrollable(that.content, {
	                dataSource: that.dataSource,
	                itemHeight: function() { return that._averageRowHeight(); },
	                page: function() {
	                    that._restoreEditableState();
	                },
	                scroll: function() {
	                    that._focusEditable();
	                }
	            });

	            that.virtualScrollable.bind(PAGING, proxy(that._onVirtualPaging, that));
	        },

	        _onVirtualPaging: function() {
	            var that = this;

	            that._cacheEditableState();

	            if (that._isVirtualIncellEditable()) {
	                that._shouldClearEditableState = false;
	                that.closeCell();
	                that._shouldClearEditableState = true;
	            }
	        },

	        _isVirtualEditable: function() {
	            return this._isVirtualIncellEditable() || this._isVirtualInlineEditable() || this._isVirtualPopupEditable();
	        },

	        _isVirtualInlineEditable: function() {
	            return (this.virtualScrollable) && this._editMode() === INLINE;
	        },

	        _isVirtualIncellEditable: function() {
	            return (this.virtualScrollable) && this._editMode() === INCELL;
	        },

	        _isVirtualPopupEditable: function() {
	            return this.virtualScrollable && this._editMode() === "popup";
	        },

	        _hasVirtualColumns: function () {
	            return (this.virtualScroll || {}).columns ? true: false;
	        },

	        _scrollVirtualWrapper: function() {
	            var that = this;
	            var scrollable = that.virtualScrollable;

	            if (that._isVirtualInlineEditable() || that._isVirtualIncellEditable()) {
	                if (scrollable._isScrolledToBottom()) {
	                    scrollable._scrollWrapperToBottom();
	                } else if (scrollable._isScrolledToTop()) {
	                    scrollable._scrollWrapperToTop();
	                }
	            }
	        },

	        _scrollVirtualWrapperOnColumnResize: function() {
	            var virtualScrollable = this.virtualScrollable;

	            if (virtualScrollable) {
	                virtualScrollable._scrollWrapperOnColumnResize();
	            }
	        },

	        _restoreEditableState: function() {
	            var that = this;
	            var editableState = that._editableState || {};
	            var editedModel = editableState.model;
	            var dataSource = that.dataSource;
	            var inlineMode = that._isVirtualInlineEditable();
	            var incellMode = that._isVirtualIncellEditable();
	            var virtualColumns = that._hasVirtualColumns();
	            var row;
	            var cell;

	            if ((inlineMode || incellMode || virtualColumns) && editedModel && dataSource._getByUid(editedModel.uid, dataSource.view())) {
	                if (that._editMode() === INLINE) {
	                    that._shouldClearEditableState = false;
	                    that.editRow(editedModel);
	                    if (!virtualColumns) {
	                        that._focusEditable();
	                    }
	                } else if (that._editMode() === INCELL) {
	                    row = that.tbody.children(attrEquals(UNIQUE_ID, editedModel.uid));
	                    cell = $(row).children(attrEquals(FIELD, editableState.field));

	                    if (cell[0]) {
	                        that._shouldClearEditableState = false;
	                        that.editCell(cell);
	                        if (!virtualColumns) {
	                            that._focusEditable();
	                        }
	                    }
	                }
	            }

	            that._shouldClearEditableState = true;
	        },

	        _focusEditable: function() {
	            var that = this;
	            var editedField = (that._editableState || {}).field;
	            var editContainer = that._editContainer;

	            if (editContainer && editContainer.length && !contains(editContainer[0], activeElement()) && that._canFocusEditable()) {
	                if (that._isVirtualInlineEditable() || that._hasVirtualColumns()) {
	                    editContainer.find(attrEquals(CONTAINER_FOR, editedField)).find(FOCUSABLE).eq(0).focus();
	                } else if (that._isVirtualIncellEditable() || that._hasVirtualColumns()) {
	                    editContainer.find(FOCUSABLE).eq(0).focus();
	                }
	            }
	        },

	        _canFocusEditable: function() {
	            var that = this;
	            var result = ((that._isVirtualIncellEditable() || that._isVirtualInlineEditable() || that._hasVirtualColumns()) &&
	            (isElementVisibleInWrapper((that.virtualScrollable || {}).wrapper, that._editContainer) || isElementVisibleInWrapper(that.content, that._editContainer)));

	            return result;
	        },

	        _cacheEditableState: function() {
	            var that = this;
	            var editContainer = that._editContainer;
	            var editedModel = editContainer ? that._modelForContainer(editContainer) : null;
	            var inlineMode = that._isVirtualInlineEditable();
	            var incellMode = that._isVirtualIncellEditable();
	            var virtualColumns = that._hasVirtualColumns();
	            var active;
	            var widget;

	            if ((inlineMode || incellMode || virtualColumns) && editedModel) {
	                that._clearEditableState();
	                active = $(activeElement());

	                if (editContainer && active[0] && contains(editContainer[0], active[0])) {
	                    //change event is not fired if the editable container is scrolled
	                    //out of the virtual view with the mousewheel right after editing
	                    active.change();

	                    widget =  kendo.widgetInstance(active, kendo.ui);

	                    if (widget && isFunction(widget.value) && active.is(INPUT)) {
	                        widget.value(active.val());
	                        widget.trigger(CHANGE);
	                    }
	                }

	                if (that._editMode() === INLINE) {
	                    that._editableState = {
	                        model: editedModel,
	                        field: active.closest("[" + kendo.attr(CONTAINER_FOR) + "]").attr(kendo.attr(CONTAINER_FOR))
	                    };
	                } else if (that._editMode() === INCELL) {
	                    that._editableState = {
	                        model: editedModel,
	                        field: editContainer.attr(kendo.attr(FIELD))
	                    };
	                }
	            }
	        },

	        _clearSortClasses: function () {
	            var that = this;

	            if (that.content) {
	                that.content.find("col:not(.k-group-col):not(.k-hierarchy-col)").removeClass("k-sorted");
	            }

	            if (that.lockedContent) {
	                that.lockedContent.find("col:not(.k-group-col):not(.k-hierarchy-col)").removeClass("k-sorted");
	            }
	        },

	        _clearEditableState: function() {
	            var that = this;

	            if (that.virtualScrollable || (that.virtualScroll && that._hasVirtualColumns())) {
	                that._editableState = null;
	            }
	        },

	        _destroyVirtualScrollable: function() {
	            var that = this;

	            that._clearEditableState();

	            if (that.virtualScrollable && that.virtualScrollable.element) {
	                that.virtualScrollable.destroy();
	            }

	            that.virtualScrollable = null;
	        },

	        _renderNoRecordsContent: function() {
	            var that = this;

	            if (that.options.noRecords) {
	                var noRecordsElement = that.table.parent().children('.' + NORECORDSCLASS);

	                if (noRecordsElement.length) {
	                    that.angular("cleanup", function(){
	                        return { elements: noRecordsElement.get() };
	                    });

	                    noRecordsElement.remove();
	                }

	                if (!that.dataSource || !that.dataSource.view().length) {
	                    noRecordsElement = $(that.noRecordsTemplate({})).insertAfter(that.table);

	                    that.angular("compile", function(){
	                        return {
	                            elements: noRecordsElement.get(),
	                            data: [{}]
	                        };
	                    });
	                }
	            }
	        },

	        _setContentWidth: function(scrollLeft) {
	            var that = this,
	                hiddenDivClass = 'k-grid-content-expander',
	                hiddenDiv = '<div class="' + hiddenDivClass + '"></div>',
	                resizable = that.resizable,
	                expander;

	            if (that.options.scrollable && that.wrapper.is(":visible")) {
	                expander = that.table.parent().children('.' + hiddenDivClass);
	                that._setContentWidthHandler = proxy(that._setContentWidth, that);
	                if (!that.dataSource || !that.dataSource.view().length) {
	                    if (!expander[0]) {
	                        expander = $(hiddenDiv).appendTo(that.table.parent());
	                        if (resizable) {
	                            resizable.bind("resize", that._setContentWidthHandler);
	                        }
	                    }
	                    if (that.thead) {
	                        expander.width(that.thead.width());
	                        if (!isNaN(parseFloat(scrollLeft, 10))) {
	                            kendo.scrollLeft(that.content, scrollLeft);
	                        }
	                    }
	                } else if (expander[0]) {
	                    expander.remove();
	                    if (resizable) {
	                        resizable.unbind("resize", that._setContentWidthHandler);
	                    }
	                }

	                that._applyLockedContainersWidth();
	                that._syncLockedContentHeight();

	                // workaround IE does not show vertical scrollbar for elements without width
	                if (that.lockedHeader && that.table[0].clientWidth === 0) {
	                    that.table[0].style.width = "1px";
	                }
	            }
	        },

	        _applyLockedContainersWidth: function() {
	            if (this.options.scrollable && this.lockedHeader) {
	                var headerTable = this.thead.parent(),
	                    headerWrap = headerTable.parent(),
	                    contentWidth = this.wrapper[0].clientWidth,
	                    groups = this._groups(),
	                    scrollbar = kendo.support.scrollbar(),
	                    cols = this.lockedHeader.find(">table>colgroup>col:not(.k-group-col, .k-hierarchy-col)"),
	                    nonLockedCols = headerTable.find(">colgroup>col:not(.k-group-col, .k-hierarchy-col)"),
	                    width = columnsWidth(cols),
	                    nonLockedColsWidth = columnsWidth(nonLockedCols),
	                    footerWrap;

	                if (groups > 0) {
	                    width += outerWidth(this.lockedHeader.find(".k-group-cell:first")) * groups;
	                }

	                if (width >= contentWidth) {
	                    width = contentWidth - 3 * scrollbar;
	                }

	                this.lockedHeader
	                    .add(this.lockedContent)
	                    .width(width);

	                headerWrap[0].style.width = headerWrap.parent().width() - width - 2 + "px";

	                headerTable.add(this.table).width(nonLockedColsWidth);

	                //https://github.com/telerik/kendo-ui-core/issues/377
	                if (this.virtualScrollable && !isIE11) {
	                    contentWidth -= scrollbar;
	                }

	                this.content[0].style.width = contentWidth - width - 1 + "px";

	                if (this.lockedFooter && this.lockedFooter.length) {
	                    this.lockedFooter.width(width);
	                    footerWrap = this.footer.find(".k-grid-footer-wrap");
	                    footerWrap[0].style.width = headerWrap[0].clientWidth + "px";
	                    footerWrap.children().first().width(nonLockedColsWidth);
	                }
	            }
	        },

	        _setContentHeight: function() {
	            var that = this,
	                options = that.options,
	                height,
	                header = that.wrapper.children(".k-grid-header"),
	                scrollbar = kendo.support.scrollbar();
	            var scrollableHeight = (options.scrollable || {}).height;

	            if (options.scrollable && that.wrapper.is(":visible")) {
	                if (scrollableHeight && that.content[0].style.height === "") {
	                    // fallback to client-side setting as ASP.NET MVC Core wrapper does not provide server rendering of the content
	                    that.content[0].style.height = scrollableHeight;
	                }

	                height = that.wrapper.innerHeight();

	                height -= outerHeight(header);

	                if (that.pager && that.pager.element.is(":visible")) {
	                    height -= outerHeight(that.pager.element);
	                }

	                if(options.groupable) {
	                    height -= outerHeight(that.wrapper.children(".k-grouping-header"));
	                }

	                if(options.toolbar) {
	                    height -= outerHeight(that.wrapper.children(".k-grid-toolbar"));
	                }

	                if (that.footerTemplate) {
	                    height -= outerHeight(that.wrapper.children(".k-grid-footer"));
	                }

	                var isGridHeightSet = function(el) {
	                    var initialHeight, newHeight;
	                    if (el[0].style.height) {
	                        return true;
	                    } else {
	                        initialHeight = el.height();
	                    }

	                    el.height("auto");
	                    newHeight = el.height();

	                    if (initialHeight != newHeight) {
	                        el.height("");
	                        return true;
	                    }
	                    el.height("");
	                    return false;
	                };

	                if (isGridHeightSet(that.wrapper)) { // set content height only if needed
	                    if (height > scrollbar * 2) { // do not set height if proper scrollbar cannot be displayed
	                        if (that.lockedContent) {
	                            scrollbar = that.table[0].offsetWidth > that.table.parent()[0].clientWidth ? scrollbar : 0;
	                            that.lockedContent.height(height - scrollbar);
	                        }

	                        that.content.height(height);
	                    } else {
	                        that.content.height(scrollbar * 2 + 1);
	                    }
	                }
	            }
	        },

	        _averageRowHeight: function() {
	            var that = this,
	                itemsCount = that._items(that.tbody, true).length,
	                rowHeight = that._rowHeight;

	            if (itemsCount === 0) {
	                return rowHeight;
	            }

	            if (!that._rowHeight) {
	                that._rowHeight = rowHeight = outerHeight(that.table) / itemsCount;
	                that._sum = rowHeight;
	                that._measures = 1;
	            }

	            var currentRowHeight = outerHeight(that.table) / itemsCount;

	            if (rowHeight !== currentRowHeight) {
	                that._measures ++;
	                that._sum += currentRowHeight;
	                that._rowHeight = that._sum / that._measures;
	            }
	            return rowHeight;
	        },

	        _dataSource: function() {
	            var that = this,
	                options = that.options,
	                pageable,
	                dataSource = options.dataSource;

	            dataSource = isArray(dataSource) ? { data: dataSource } : dataSource;

	            if (isPlainObject(dataSource)) {
	                extend(dataSource, { table: that.table, fields: that.columns });

	                pageable = options.pageable;

	                if (isPlainObject(pageable) && pageable.pageSize !== undefined) {
	                    dataSource.pageSize = pageable.pageSize;
	                }
	            }

	            if (that.dataSource && that._refreshHandler) {
	                that.dataSource.unbind(CHANGE, that._refreshHandler)
	                                .unbind(PROGRESS, that._progressHandler)
	                                .unbind(ERROR, that._errorHandler)
	                                .unbind(SORT, that._sortHandler);
	            } else {
	                that._refreshHandler = proxy(that.refresh, that);
	                that._progressHandler = proxy(that._requestStart, that);
	                that._errorHandler = proxy(that._error, that);
	                that._sortHandler = proxy(that._clearSortClasses, that);
	            }

	            that.dataSource = DataSource.create(dataSource)
	                                .bind(CHANGE, that._refreshHandler)
	                                .bind(PROGRESS, that._progressHandler)
	                                .bind(ERROR, that._errorHandler)
	                                .bind(SORT, that._sortHandler);
	        },

	        _error: function() {
	            this._progress(false);
	        },

	        _requestStart: function() {
	            this._progress(true);
	        },

	        _modelChange: function(e) {
	            var that = this,
	                tbody = that.tbody,
	                model = e.model,
	                row = that.tbody.find("tr[" + kendo.attr("uid") + "=" + model.uid +"]"),
	                relatedRow,
	                cell,
	                column,
	                isAlt = row.hasClass("k-alt"),
	                tmp,
	                idx = that._items(tbody).index(row),
	                isLocked = that.lockedContent,
	                selectable,
	                selectableRow,
	                childCells,
	                originalCells,
	                length;

	            if (isLocked) {
	                relatedRow = that._relatedRow(row);
	            }

	            if (row.add(relatedRow).children(".k-edit-cell").length && !that.options.rowTemplate) {
	                row.add(relatedRow).children(":not(.k-group-cell,.k-hierarchy-cell)").each(function() {
	                    cell = $(this);
	                    column = leafColumns(that.columns)[that._calculateColumnIndex(cell)];

	                    if (column.field === e.field) {
	                        if (!cell.hasClass("k-edit-cell")) {
	                            that._displayCell(cell, column, model);
	                        } else {
	                            cell.addClass("k-dirty-cell");
	                        }
	                    }
	                });

	            } else if (!row.hasClass("k-grid-edit-row")) {

	                selectableRow = $().add(row);

	                if (isLocked) {
	                    tmp = (isAlt ? that.lockedAltRowTemplate : that.lockedRowTemplate)(model);

	                    selectableRow = selectableRow.add(relatedRow);

	                    relatedRow.replaceWith(tmp);
	                }

	                that.angular("cleanup", function(){ return { elements: selectableRow.get() }; });

	                tmp = (isAlt ? that.altRowTemplate : that.rowTemplate)(model);

	                row.replaceWith(tmp);

	                tmp = that._items(tbody).eq(idx);

	                var angularData = [ { dataItem: model } ];

	                if (isLocked) {
	                    row = row.add(relatedRow);

	                    relatedRow = that._relatedRow(tmp)[0];
	                    adjustRowHeight(tmp[0], relatedRow);

	                    tmp = tmp.add(relatedRow);
	                    angularData.push({ dataItem: model });
	                }

	                that.angular("compile", function(){
	                    return {
	                        elements: tmp.get(),
	                        data: angularData
	                     };
	                });

	                selectable = that.options.selectable;
	                if ((selectable || that._checkBoxSelection) && row.hasClass("k-state-selected")) {
	                   that.select(tmp);
	                }

	                originalCells = selectableRow.children(":not(.k-group-cell,.k-hierarchy-cell)");
	                childCells = tmp.children(":not(.k-group-cell,.k-hierarchy-cell)");

	                for (idx = 0, length = that.columns.length; idx < length; idx++) {
	                    column = that.columns[idx];

	                    cell = childCells.eq(idx);
	                    if (selectable && originalCells.eq(idx).hasClass("k-state-selected")) {
	                        cell.addClass("k-state-selected");
	                    }
	                }

	                that.trigger("itemChange", { item: tmp, data: model, ns: ui });
	            }
	        },

	        _pageable: function() {
	            var that = this,
	                pagerWrap,
	                pageable = that.options.pageable;

	            if (pageable) {
	                pagerWrap = that.wrapper.children("div.k-grid-pager");

	                if (!pagerWrap.length) {
	                    pagerWrap = $('<div class="k-pager-wrap k-grid-pager"/>');
	                }

	                if (pageable.position === "top") {
	                    pagerWrap.prependTo(that.wrapper).addClass("k-grid-pager-top");
	                } else {
	                    pagerWrap.appendTo(that.wrapper);
	                }

	                if (that.pager) {
	                    that.pager.destroy();
	                }

	                if (typeof pageable === "object" && pageable instanceof kendo.ui.Pager) {
	                    that.pager = pageable;
	                } else {
	                    if(that.dataSource._groupPaging){
	                        that.pager = new GroupsPager(pagerWrap, extend({}, pageable, { dataSource: that.dataSource }));
	                    } else {
	                        that.pager = new kendo.ui.Pager(pagerWrap, extend({}, pageable, { dataSource: that.dataSource }));
	                    }
	                }

	                that.pager.bind("pageChange", function(e) {
	                    if (that.trigger("page", { page: e.index })) {
	                        e.preventDefault();
	                    }
	                });

	                that._togglePagerVisibility();
	            }
	        },

	        _footer: function() {
	            var that = this,
	                aggregates = that.dataSource.aggregates(),
	                html = "",
	                footerTemplate = that.footerTemplate,
	                options = that.options,
	                footerWrap,
	                footer = that.footer || that.wrapper.find(".k-grid-footer");

	            if (footerTemplate) {
	                html = $(that._wrapFooter(footerTemplate(aggregates)));

	                if (footer.length) {
	                    var tmp = html;

	                    that.angular("cleanup", function(){
	                        return { elements: footer.get() };
	                    });

	                    footer.replaceWith(tmp);
	                    footer = that.footer = tmp;
	                } else {
	                    if (options.scrollable) {
	                        footer = that.footer = options.pageable && options.pageable.position !== "top" ? html.insertBefore(that.wrapper.children("div.k-grid-pager")) : html.appendTo(that.wrapper);
	                    } else {
	                        footer = that.footer = html.insertBefore(that.tbody);
	                    }
	                }

	                that.angular("compile", function(){
	                    return {
	                        elements: footer.find("td:not(.k-group-cell, .k-hierarchy-cell)").get(),
	                        data: map(that.columns, function(col){
	                            return {
	                                column: col,
	                                aggregate: aggregates[col.field]
	                            };
	                        })
	                    };
	                });

	            } else if (footer && !that.footer) {
	                that.footer = footer;
	            }

	            if (footer.length) {
	                if (options.scrollable) {
	                    footerWrap = footer.attr("tabindex", -1).children(".k-grid-footer-wrap");

	                    that.scrollables = $(
	                        that.scrollables
	                            .filter(function() { return !$(this).is(".k-grid-footer-wrap"); })
	                            .toArray()
	                    ).add(footerWrap);
	                }

	                if (that._footerWidth) {
	                    footer.find("table").css('width', that._footerWidth);
	                }

	                if (footerWrap) {
	                    var offset = kendo.scrollLeft(that.content);

	                    if (options.scrollable !== true && that.virtualScroll && that.virtualScroll.rows) {
	                        offset = kendo.scrollLeft(that.wrapper.find('.k-virtual-scrollable-wrap'));
	                    }
	                    kendo.scrollLeft(footerWrap, offset);
	                }
	            }

	            if (that.lockedContent) {
	                that._appendLockedColumnFooter();
	                that._applyLockedContainersWidth();
	                that._syncLockedFooterHeight();
	            }
	        },

	        _wrapFooter: function(footerRow) {
	            var that = this,
	                html = "",
	                scrollbar = !kendo.support.mobileOS ? kendo.support.scrollbar() : 0;

	            if (that.options.scrollable) {
	                html = $('<div class="k-grid-footer"><div class="k-grid-footer-wrap"><table' + (isIE7 ? ' cellspacing="0"' : '') + '><tbody>' + footerRow + '</tbody></table></div></div>');
	                that._appendCols(html.find("table"));
	                html.css((isRtl ? "padding-left" : "padding-right"), scrollbar); // Update inner fix.

	                return html;
	            }

	            return '<tfoot class="k-grid-footer">' + footerRow + '</tfoot>';
	        },

	        _columnMenu: function() {
	            var that = this,
	                menu,
	                columns = leafColumns(that.columns),
	                column,
	                options = that.options,
	                columnMenu = options.columnMenu,
	                menuOptions,
	                sortable,
	                filterable,
	                cells,
	                hasMultiColumnHeaders = grep(that.columns, function(item) {
	                    return item.columns !== undefined;
	                }).length > 0,
	                hasLockableColumns = grep(that.columns, function(item) {
	                    return item.lockable !== false;
	                }).length > 0,
	                hasStickableColumns = grep(that.columns, function(item) {
	                    return item.stickable === true;
	                }).length > 0,
	                isMobile = this._isMobile,
	                initCallback = function(e) {
	                    that.trigger(COLUMNMENUINIT, { field: e.field, container: e.container });
	                },
	                openCallback = function(e) {
	                    that.trigger(COLUMNMENUOPEN, { field: e.field, container: e.container });
	                },
	                closeCallback = function(element) {
	                    focusTable(element.closest("table"), true);
	                },
	                stickCallback = function(e) {
	                    that.trigger(COLUMNSTICK, { column: e.column });
	                },
	                unstickCallback = function(e) {
	                    that.trigger(COLUMNUNSTICK, { column: e.column });
	                },
	                sortHandler = function(e) {
	                    if (that.trigger("sort", { sort: e.sort })) {
	                        e.preventDefault();
	                    } else {
	                        that._clearEditableState();
	                        if (that.dataSource.options.endless) {
	                            that.dataSource.options.endless = null;
	                            that._endlessPageSize = that.dataSource.options.pageSize;
	                            that.dataSource.pageSize(that.dataSource.options.pageSize);
	                        }
	                    }
	                },
	                filterHandler = function(e) {
	                    if (that.trigger("filter", { filter: e.filter, field: e.field })) {
	                        e.preventDefault();
	                    } else {
	                        that._clearEditableState();
	                        if (that.dataSource.options.endless) {
	                            that.dataSource.options.endless = null;
	                            that._endlessPageSize = that.dataSource.options.pageSize;
	                            that.dataSource.pageSize(that.dataSource.options.pageSize);
	                        }
	                    }
	                },
	                $angular = options.$angular;

	            if (columnMenu) {
	                if (typeof columnMenu == "boolean") {
	                    columnMenu = {};
	                }

	                that._setColumnsMediaVisibility(columns);

	                cells = leafDataCells(that.thead);

	                for (var idx = 0, length = cells.length; idx < length; idx++) {
	                    column = columns[idx];
	                    var cell = cells.eq(idx);

	                    if (!column.command && (column.field || cell.attr("data-" + kendo.ns + "field"))) {
	                        menu = cell.data("kendoColumnMenu");
	                        if (menu) {
	                            menu.destroy();
	                        }

	                        sortable = column.sortable !== false && columnMenu.sortable !== false && options.sortable !== false ? extend({}, options.sortable, {
	                            compare: (column.sortable || {}).compare
	                        }) : false;

	                        filterable = options.filterable && column.filterable !== false && columnMenu.filterable !== false ? extend({ pane: that.pane }, options.filterable, column.filterable) : false;

	                        if (column.filterable && column.filterable.dataSource) {
	                            filterable.forceUnique = false;
	                            filterable.checkSource = column.filterable.dataSource;
	                        }

	                        if (filterable) {
	                            filterable.format = column.format;
	                        }

	                        menuOptions = {
	                            dataSource: that.dataSource,
	                            values: column.values,
	                            columns: columnMenu.columns,
	                            sortable: sortable,
	                            filterable: filterable,
	                            messages: columnMenu.messages,
	                            owner: that,
	                            closeCallback: closeCallback,
	                            init: initCallback,
	                            open: openCallback,
	                            stick: stickCallback,
	                            unstick: unstickCallback,
	                            pane: that.pane,
	                            sort: sortHandler,
	                            filtering: filterHandler,
	                            filter: isMobile ? ":not(.k-column-active)" : "",
	                            hasLockableColumns: lockedColumns(columns).length > 0 && hasLockableColumns && !hasMultiColumnHeaders,
	                            hasStickableColumns: hasStickableColumns && !hasMultiColumnHeaders,
	                            encodeTitles: that.options.encodeTitles
	                        };

	                        if ($angular) {
	                            menuOptions.$angular = $angular;
	                        }

	                        cell.kendoColumnMenu(menuOptions);
	                    }
	                }
	            }
	        },

	        _headerCells: function() {
	            return $(this.thead).find("th").filter(function() {
	                var th = $(this);
	                return !th.hasClass("k-group-cell") && !th.hasClass("k-hierarchy-cell");
	            });
	        },

	        _filterable: function() {
	            var that = this,
	                columns = leafColumns(that.columns),
	                filterMenu,
	                cells,
	                cell,
	                filterInit = function(e) {
	                    that.trigger(FILTERMENUINIT, { field: e.field, container: e.container });
	                },
	                closeCallback = function(element) {
	                    focusTable(element.closest("table"), true);
	                },
	                filterHandler = function(e) {
	                    if (that.trigger("filter", { filter: e.filter, field: e.field })) {
	                        e.preventDefault();
	                    } else {
	                        that._clearEditableState();
	                        if (that.dataSource.options.endless) {
	                            that.dataSource.options.endless = null;
	                            that._endlessPageSize = that.dataSource.options.pageSize;
	                            that.dataSource.pageSize(that.dataSource.options.pageSize);
	                        }
	                    }
	                },
	                filterOpen = function(e) {
	                    that.trigger(FILTERMENUOPEN, { field: e.field, container: e.container });
	                },
	                filterable = that.options.filterable;
	                if (filterable && typeof filterable.mode == STRING && filterable.mode.indexOf("menu") == -1) {
	                    filterable = false;
	                }

	            if (filterable && !that.options.columnMenu) {
	                cells = leafDataCells(that.thead);//that._headerCells();

	                for (var idx = 0, length = cells.length; idx < length; idx++) {
	                    cell = cells.eq(idx);

	                    if (columns[idx].filterable !== false && !columns[idx].command && (columns[idx].field || cell.attr("data-" + kendo.ns + "field"))) {
	                        filterMenu = cell.data("kendoFilterMenu");

	                        if (filterMenu) {
	                            filterMenu.destroy();
	                        }

	                        filterMenu = cell.data("kendoFilterMultiCheck");
	                        if (filterMenu) {
	                           filterMenu.destroy();
	                        }

	                        var columnFilterable = columns[idx].filterable;

	                        var options = extend({},
	                            filterable,
	                            columnFilterable,
	                            {
	                                dataSource: that.dataSource,
	                                values: columns[idx].values,
	                                format: columns[idx].format,
	                                closeCallback: closeCallback,
	                                title: columns[idx].title || columns[idx].field,
	                                init: filterInit,
	                                open: filterOpen,
	                                pane: that.pane,
	                                change: filterHandler
	                            }
	                        );

	                        if (columnFilterable && columnFilterable.messages) {
	                            options.messages = extend(true, {}, filterable.messages, columnFilterable.messages);
	                        }
	                        if (columnFilterable && columnFilterable.dataSource) {
	                            options.forceUnique = false;
	                            options.checkSource = columnFilterable.dataSource;
	                        }

	                        if (columnFilterable && columnFilterable.multi) {
	                            cell.kendoFilterMultiCheck(options);
	                        } else {
	                            cell.kendoFilterMenu(options);
	                        }
	                    }
	                }
	            }
	        },

	        _filterRow: function() {
	            var that = this;
	            if (!that._hasFilterRow()) {
	               return;
	            }

	            var settings;
	            var $angular = that.options.$angular;
	            var columns = leafColumns(that.columns),
	                filterable = that.options.filterable,
	                rowheader = that.thead.find(".k-filter-row"),
	                filterHandler = function(e) {
	                    if (that.trigger("filter", { filter: e.filter, field: e.field })) {
	                        e.preventDefault();
	                    } else {
	                        that._clearEditableState();
	                        if (that.dataSource.options.endless) {
	                            that.dataSource.options.endless = null;
	                            that._endlessPageSize = that.dataSource.options.pageSize;
	                            that.dataSource.pageSize(that.dataSource.options.pageSize);
	                        }
	                    }
	                };


	            this._updateHeader(this.dataSource.group().length);

	            for (var i = 0; i < columns.length; i++) {
	                var suggestDataSource,
	                    col = columns[i],
	                    operators = that.options.filterable.operators,
	                    customDataSource = false,
	                    th = $("<th/>"),
	                    field = col.field;

	                if (col.hidden) {
	                    th.hide();
	                }
	                rowheader.append(th);
	                if (field && col.filterable !== false) {
	                    var cellOptions = col.filterable && col.filterable.cell || {};

	                    suggestDataSource = that.options.dataSource;
	                    if (suggestDataSource instanceof DataSource) {
	                        suggestDataSource = that.options.dataSource.options;
	                    }

	                    var messages = extend(true, {}, filterable.messages);
	                    if (col.filterable) {
	                        extend(true, messages, col.filterable.messages);
	                    }

	                    if (cellOptions.enabled === false) {
	                        th.html("&nbsp;");
	                        continue;
	                    }
	                    if (cellOptions.dataSource) {
	                        suggestDataSource = cellOptions.dataSource;
	                        customDataSource = true;
	                    }
	                    if (col.filterable && col.filterable.operators) {
	                        operators =  col.filterable.operators;
	                    }

	                    settings = {
	                        column: col,
	                        dataSource: that.dataSource,
	                        suggestDataSource: suggestDataSource,
	                        customDataSource: customDataSource,
	                        field: field,
	                        messages: messages,
	                        values: col.values,
	                        template: cellOptions.template,
	                        delay: cellOptions.delay,
	                        inputWidth: cellOptions.inputWidth,
	                        suggestionOperator: cellOptions.suggestionOperator,
	                        minLength: cellOptions.minLength,
	                        dataTextField: cellOptions.dataTextField,
	                        operator: cellOptions.operator,
	                        operators: operators,
	                        showOperators: cellOptions.showOperators,
	                        change: filterHandler
	                    };

	                    if ($angular) {
	                        settings.$angular = $angular;
	                    }

	                    $("<span/>").attr(kendo.attr("field"), field)
	                        .appendTo(th)
	                        .kendoFilterCell(settings);
	                } else {
	                    th.html("&nbsp;");
	                }
	            }
	        },

	        _sortable: function() {
	            var that = this,
	                columns = leafColumns(that.columns),
	                column,
	                sorterInstance,
	                cell,
	                sortable = that.options.sortable,
	                sortHandler = function(e) {
	                    if (that.trigger("sort", { sort: e.sort })) {
	                        e.preventDefault();
	                    } else {
	                        that._clearEditableState();
	                    }
	                };


	            if (sortable) {
	                var cells = leafDataCells(that.thead);

	                for (var idx = 0, length = cells.length; idx < length; idx++) {
	                    column = columns[idx];

	                    if (column.sortable !== false && !column.command && column.field) {
	                        cell = cells.eq(idx);

	                        sorterInstance = cell.data("kendoColumnSorter");

	                        if (sorterInstance) {
	                            sorterInstance.destroy();
	                        }

	                        cell.attr("data-" + kendo.ns +"field", column.field)
	                            .kendoColumnSorter(
	                                extend({}, sortable, column.sortable, {
	                                    dataSource: that.dataSource,
	                                    aria: true,
	                                    filter: ":not(.k-column-active)",
	                                    change: sortHandler
	                                })
	                            );
	                    }
	                }
	                cells = null;
	            }
	        },

	        _columns: function(columns) {
	            var that = this,
	                table = that.table,
	                encoded,
	                cols = table.find("col"),
	                lockedCols,
	                headerRows = that.element.find('thead tr'),
	                dataSource = that.options.dataSource;

	            // using HTML5 data attributes as a configuration option e.g. <th data-field="foo">Foo</foo>
	            columns = columns.length ? columns : map(table.find("th:not(.k-group-cell):not(.k-hierarchy-cell)"), function(th, idx) {
	                th = $(th);
	                var sortable = th.attr(kendo.attr("sortable")),
	                    filterable = th.attr(kendo.attr("filterable")),
	                    type = th.attr(kendo.attr("type")),
	                    groupable = th.attr(kendo.attr("groupable")),
	                    field = th.attr(kendo.attr("field")),
	                    title = th.attr(kendo.attr("title")),
	                    menu = th.attr(kendo.attr("menu"));

	                if (!field) {
	                   field = th.text().replace(/\s|[^A-z0-9]/g, "");
	                }

	                return {
	                    field: field,
	                    type: type,
	                    title: title,
	                    sortable: sortable !== "false",
	                    filterable: filterable !== "false",
	                    groupable: groupable !== "false",
	                    menu: menu,
	                    template: th.attr(kendo.attr("template")),
	                    width: cols.eq(idx).css("width")
	                };
	            });

	            encoded = !(that.table.find("tbody tr").length > 0 && (!dataSource || !dataSource.transport));

	            if (that.options.scrollable) {
	                var initialColumns = columns;
	                lockedCols = lockedColumns(columns);
	                columns = nonLockedColumns(columns);

	                if (lockedCols.length > 0 && columns.length === 0) {
	                    throw new Error("There should be at least one non locked column");
	                }

	                normalizeHeaderCells(that.element.find("tr:has(th):first"), initialColumns);
	                columns = lockedCols.concat(columns);
	            }

	            if (headerRows.length && columns.length) {
	                that._updateColumnIDs(columns, headerRows.first());
	            }

	            that.columns = normalizeColumns(columns, encoded);

	            if($.grep(leafColumns(that.columns), function (col) { return col.selectable ;}).length) {
	                that._selectedIds = {};
	                that._checkBoxSelection = true;
	                that.wrapper.on(CLICK + NS, "tbody > tr " + CHECKBOXINPUT, proxy(that._checkboxClick, that));
	                that.wrapper.on(CLICK + NS, "thead > tr " + CHECKBOXINPUT, proxy(that._headerCheckboxClick, that));
	            }
	            that._foreignKeyBindings(that.columns);
	        },

	        _foreignKeyBindings: function (columns) {
	            var that = this;
	            var length = columns.length;
	            var column;

	            for (var i = 0; i < length; i++) {
	                column = columns[i];

	                if (column.dataSource) {
	                    that._fetchForeignKeyValues(column);
	                }
	            }
	        },

	        _fetchForeignKeyValues: function (column) {
	            var that = this;
	            var promise = $.Deferred();

	            that._hasBoundForeignKey = true;
	            column.dataSource = DataSource.create(column.dataSource);

	            if (!that._foreignKeyPromises) {
	                that._foreignKeyPromises = [];
	            }

	            that._foreignKeyPromises.push(promise);
	            column.dataSource.fetch().then(function () {
	                var data = column.dataSource.data();
	                column.values = data.map(function (item) {
	                    return {
	                        value: item[column.dataValueField],
	                        text: item[column.dataTextField]
	                    };
	                });
	                promise.resolve();
	            });

	        },

	        _updateColumnIDs: function (columns, tr) {

	            if (!columns.length) {
	                return;
	            }

	            var ths = tr.find("th:not(.k-group-cell):not(.k-hierarchy-cell)");
	            var id;
	            for (var i = 0; i<columns.length; i++) {
	                id = ths.eq(i).attr("id");
	                if (id) {
	                    columns[i].headerAttributes = extend(columns[i].headerAttributes, { id: id });
	                }
	            }

	            this._updateColumnIDs(childColumns(columns), tr.next());
	        },

	        _headerCheckboxClick: function(e) {
	            var that = this,
	                checkBox = $(e.target),
	                checked = checkBox.prop("checked"),
	                parentGrid = checkBox.closest(".k-grid.k-widget").getKendoGrid();

	            if (that !== parentGrid) {
	                return;
	            }

	            if (checked) {
	                that.select(parentGrid.items());
	            } else {
	                that.clearSelection();
	            }
	        },

	        _checkboxClick: function(e) {
	            var that = this,
	                row =  $(e.target).closest("tr"),
	                isSelecting = !row.hasClass(SELECTED);

	            if(that !== row.closest(".k-grid.k-widget").getKendoGrid()) {
	                return;
	            }

	            if (isSelecting) {
	                that.select(row);
	            } else {
	                that._deselectCheckRows(row);
	            }
	        },

	        _groups: function() {
	            var group = this.dataSource.group();

	            return group ? group.length : 0;
	        },

	        _tmpl: function(rowTemplate, columns, alt, skipGroupCells) {
	            var that = this,
	                settings = extend({}, kendo.Template, that.options.templateSettings),
	                paramName = settings.paramName,
	                idx,
	                length = columns.length,
	                template,
	                state = { storage: {}, count: 0 },
	                column,
	                type,
	                hasDetails = that._hasDetails(),
	                className = [],
	                groups = that._groups(),
	                navigatable = that.options.navigatable;
	            var fieldAttr = kendo.attr("field");
	            var field;
	            var dirtyCellTemplate = "";

	            if (!rowTemplate) {
	                rowTemplate = "<tr";

	                if (alt) {
	                    className.push("k-alt");
	                }

	                className.push("k-master-row");

	                if (className.length) {
	                    rowTemplate += ' class="' + className.join(" ") + '"';
	                }

	                if (length) { // data item is an object
	                    rowTemplate += ' ' + kendo.attr("uid") + '="#=' + kendo.expr("uid", settings.paramName) + '#"';
	                }

	                rowTemplate += " role='row'>";

	                if (groups > 0 && !skipGroupCells) {
	                    rowTemplate += groupCells(groups);
	                }

	                if (hasDetails) {
	                    rowTemplate += '<td class="k-hierarchy-cell" aria-expanded="false"><a class="k-icon k-i-expand" href="\\#" ' + ARIALABEL + '="' + EXPAND + '" tabindex="-1"></a></td>';
	                }

	                for (idx = 0; idx < length; idx++) {
	                    column = columns[idx];
	                    template = column.template;
	                    type = typeof template;
	                    field = column.field;

	                    if (that._editMode() === INCELL && field) {
	                        column.attributes = column.attributes || {};

	                        if (that.virtualScroll) {
	                            column.attributes[fieldAttr] = field;
	                        }

	                        dirtyCellTemplate = that._dirtyCellTemplate(field, paramName);
	                        column.attributes["class"] = (column.attributes["class"] || "");

	                        if (column.attributes["class"].indexOf(dirtyCellTemplate) < 0) {
	                            column.attributes["class"] += dirtyCellTemplate;
	                        }
	                    }

	                    if (column.colSpan && column.colSpan > 0 && hasHiddenStyle(column.attributes)) {  //virtual cell should be visible at all times
	                        column.attributes = removeHiddenStyle(column.attributes);
	                    } else if (!column.colSpan && column.hidden) {
	                        column.attributes = addHiddenStyle(column.attributes);
	                    }

	                    if (column.command) {
	                        column.attributes = column.attributes || {};

	                        if (typeof column.attributes["class"] !== "undefined") {
	                            column.attributes["class"] += " k-command-cell";
	                        } else {
	                            column.attributes["class"] = "k-command-cell";
	                        }
	                    }

	                    rowTemplate += "<td" + stringifyAttributes(column.attributes);

	                    if (navigatable) {
	                        rowTemplate += " aria-describedby='" + column.headerAttributes.id + "'";
	                    }

	                    if (column.colSpan) {
	                        if (column.colSpan > 1) {
	                            rowTemplate += " " + kendo.attr("virtual");
	                        }
	                        rowTemplate += " colSpan='" + column.colSpan + "'";
	                    }

	                    rowTemplate += " role='gridcell'>";
	                    rowTemplate += that._cellTmpl(column, state);

	                    rowTemplate += "</td>";
	                }

	                rowTemplate += "</tr>";
	            }

	            rowTemplate = kendo.template(rowTemplate, settings);

	            if (state.count > 0) {
	                return proxy(rowTemplate, state.storage);
	            }

	            return rowTemplate;
	        },

	        _dirtyCellTemplate: function(field, paramName) {
	            var dirtyField;

	            if (field && paramName) {
	                dirtyField = field.charAt(0) === "[" ? kendo.expr(field, paramName + ".dirtyFields") : paramName + ".dirtyFields['" + field + "']";

	                return "#= " + paramName + " && " + paramName + ".dirty && " + paramName + ".dirtyFields && " + dirtyField + " ? ' k-dirty-cell' : '' #";
	            }

	            return "";
	        },

	        _headerCellText: function(column) {
	            var that = this,
	                settings = extend({}, kendo.Template, that.options.templateSettings),
	                template = column.headerTemplate,
	                type = typeof(template),
	                text = column.title && (that.options.encodeTitles ? htmlEncode(column.title) : column.title) || column.field || "";

	            if (type === FUNCTION) {
	                text = kendo.template(template, settings)({});
	            } else if (type === STRING) {
	                text = template;
	            }
	            return text;
	        },

	        _cellTmpl: function(column, state) {
	            var that = this,
	                settings = extend({}, kendo.Template, that.options.templateSettings),
	                template = column.template,
	                paramName = settings.paramName,
	                field = column.field,
	                html = "",
	                idx,
	                length,
	                format = column.format,
	                type = typeof template,
	                columnValues = column.values;

	            if (column.command) {
	                if (isArray(column.command)) {
	                    for (idx = 0, length = column.command.length; idx < length; idx++) {
	                        if(column.command[idx].visible) {
	                            html += kendo.format("#= {0}(data)? '{1}':'' #",column.command[idx].visible, that._createButton(column.command[idx]).replace(templateHashRegExp, "\\#").replace(/'/ig,"\\'"));
	                        } else {
	                            html += that._createButton(column.command[idx]).replace(templateHashRegExp, "\\#");
	                        }
	                    }
	                    return html;
	                }
	                return that._createButton(column.command).replace(templateHashRegExp, "\\#");
	            }

	            if(column.selectable) {
	                return SELECTCOLUMNTMPL;
	            }

	            html += that._dirtyIndicatorTemplate(field, paramName);

	            if (type === FUNCTION) {
	                state.storage["tmpl" + state.count] = template;
	                html += "#=this.tmpl" + state.count + "(" + paramName + ")#";
	                state.count ++;
	            } else if (type === STRING) {
	                html += template;
	            } else if (columnValues && columnValues.length && isPlainObject(columnValues[0]) && "value" in columnValues[0] && field) {
	                html += "#var v =" + kendo.stringify(convertToObject(columnValues)).replace(templateHashRegExp, "\\#") + "#";
	                html += "#var f = v[";

	                if (!settings.useWithBlock) {
	                    html += paramName + ".";
	                }

	                html += field + "]#";
	                html += "${f != null ? f : ''}";
	            } else {
	                html += column.encoded ? "#:" : "#=";

	                if (format) {
	                    html += 'kendo.format(\"' + format.replace(formatRegExp,"\\$1") + '\",';
	                }

	                if (field) {
	                    field = kendo.expr(field, paramName);
	                    html += field + "==null?'':" + field;
	                } else {
	                    html += "''";
	                }

	                if (format) {
	                    html += ")";
	                }

	                html += "#";
	            }
	            return html;
	        },

	        _dirtyIndicatorTemplate: function(field, paramName) {
	            var dirtyField;

	            if (field && paramName) {
	                dirtyField = field.charAt(0) === "[" ? kendo.expr(field, paramName + ".dirtyFields") : paramName + ".dirtyFields['" + field + "']";

	                return "#= " + paramName + " && " + paramName + ".dirty && " + paramName + ".dirtyFields && " + dirtyField +
	                    " ? '<span class=\"k-dirty\"></span>' : '' #";
	            }

	            return "";
	        },

	        _virtualCols: function (columns) {
	            var that = this;
	            var widths = $.map(columns, function(c) { return c.hidden ? 0 : parseInt(c.width, 10); });
	            var scrollLeft = that.virtualScrollable ? kendo.scrollLeft(that.content.find(">.k-virtual-scrollable-wrap")) : kendo.scrollLeft(that.content);
	            var tableWidth = outerWidth(that.content);
	            var sumOfWidths = sumWidths(columns);
	            var colsToRender = [];
	            var firstColspan = 0;
	            var lastColspan = 0;
	            var hiddenColumns = 0;
	            var idx = 0;
	            var widthOfHiddenColumns = 0;
	            var considerNext;

	            for (idx = 0; idx < columns.length; idx++) {
	                considerNext = (idx < widths.length - 1) ? widths[idx + 1] : 0;
	                if (widthOfHiddenColumns + widths[idx] + 2*considerNext < scrollLeft) {
	                    if (widths[idx]) {
	                        hiddenColumns++;
	                    }
	                    widthOfHiddenColumns += widths[idx];
	                } else {
	                    firstColspan = 1 + hiddenColumns;
	                    break;
	                }
	            }

	            hiddenColumns = 0;
	            widthOfHiddenColumns = 0;

	            for (var i = columns.length - 1; i >= 0; i--) {
	                if (widthOfHiddenColumns + 3 * widths[i] < sumOfWidths - tableWidth - scrollLeft) {
	                    if (widths[i]) {
	                        hiddenColumns++;
	                    }
	                    widthOfHiddenColumns += widths[i];
	                } else {
	                    lastColspan = 1 + hiddenColumns;
	                    for (var j = idx; j <= i; j++) {
	                        if (columns[j].locked) {
	                            continue;
	                        }
	                        colsToRender.push(columns[j]);
	                        if (columns[j].colSpan) {
	                            delete columns[j].colSpan;
	                        }
	                    }
	                    colsToRender[0].colSpan =  firstColspan;
	                    colsToRender[colsToRender.length - 1].colSpan = lastColspan;
	                    break;
	                }
	            }

	            if (colsToRender[0].hidden) {
	                colsToRender[0].colSpan--;
	            }

	            that.virtualCols = colsToRender;

	            return colsToRender;
	        },

	        _templates: function() {
	            var that = this,
	                options = that.options,
	                dataSource = that.dataSource,
	                groups = dataSource.group(),
	                footer = that.footer || that.wrapper.find(".k-grid-footer"),
	                aggregates = dataSource.aggregate(),
	                columnLeafs = leafColumns(that.columns),
	                columnsLocked = leafColumns(lockedColumns(that.columns)),
	                leafsCols = options.scrollable ? leafColumns(nonLockedColumns(that.columns)) : columnLeafs,
	                columns = (that.virtualScroll || {}).columns ? that._virtualCols(leafsCols) : leafsCols,
	                groupHeaderColumnTemplateLockedColumns = grep(visibleColumns(columnsLocked), function(column, index) { return column.groupHeaderColumnTemplate && index !== 0; }),
	                groupHeaderColumnTemplateNonLockedColumns = grep(visibleColumns(columns), function(column) { return column.groupHeaderColumnTemplate; });

	            if (options.scrollable && columnsLocked.length) {
	                if (options.rowTemplate || options.altRowTemplate) {
	                    throw new Error("Having both row template and locked columns is not supported");
	                }

	                that.rowTemplate = that._tmpl(options.rowTemplate, columns, false, true);
	                that.altRowTemplate = that._tmpl(options.altRowTemplate || options.rowTemplate, columns, true, true);

	                that.lockedRowTemplate = that._tmpl(options.rowTemplate, columnsLocked);
	                that.lockedAltRowTemplate = that._tmpl(options.altRowTemplate || options.rowTemplate, columnsLocked, true);
	            } else {
	                that.rowTemplate = that._tmpl(options.rowTemplate, columns);
	                that.altRowTemplate = that._tmpl(options.altRowTemplate || options.rowTemplate, columns, true);
	            }

	            if (that._hasDetails()) {
	                that.detailTemplate = that._detailTmpl(options.detailTemplate || "");
	            }

	            if ((that._group && !isEmptyObject(aggregates)) || (!isEmptyObject(aggregates) && !footer.length) ||
	                grep(columnLeafs, function(column) { return column.footerTemplate; }).length) {

	                that.footerTemplate = that._footerTmpl(columnLeafs, aggregates, "footerTemplate", "k-footer-template");
	            }

	            if (groups && grep(columnLeafs, function(column) { return column.groupFooterTemplate; }).length) {
	                aggregates = $.map(groups, function(g) { return g.aggregates; });

	                that.groupFooterTemplate = that._footerTmpl(columns, aggregates, "groupFooterTemplate", "k-group-footer", columnsLocked.length);

	                if (options.scrollable && columnsLocked.length) {
	                    that.lockedGroupFooterTemplate = that._footerTmpl(columnsLocked, aggregates, "groupFooterTemplate", "k-group-footer");
	                }
	            }

	            if (groups && (groupHeaderColumnTemplateLockedColumns.length || groupHeaderColumnTemplateNonLockedColumns.length)) {
	                aggregates = $.map(groups, function(g) { return g.aggregates; });

	                that.groupHeaderColumnTemplate = that._groupHeaderTmpl(visibleColumns(columns), aggregates, "groupHeaderColumnTemplate", "k-grouping-row", columnsLocked.length, groupHeaderColumnTemplateNonLockedColumns);

	                if (options.scrollable && columnsLocked.length) {
	                    that.lockedGroupHeaderColumnTemplate = that._groupHeaderTmpl(visibleColumns(columnsLocked), aggregates, "groupHeaderColumnTemplate", "k-grouping-row", 0, groupHeaderColumnTemplateLockedColumns);
	                }
	            } else {
	                that.groupHeaderColumnTemplate = null;
	                that.lockedGroupHeaderColumnTemplate  = null;
	            }

	                if (that.options.noRecords) {
	                that.noRecordsTemplate = that._noRecordsTmpl();
	            }
	        },

	        _noRecordsTmpl: function () {
	            var wrapper = '<div class="{0}">{1}</div>';
	            var defaultTemplate = '<div class="k-grid-norecords-template"{1}>{0}</div>';
	            var scrollableNoGridHeightStyles = (this.options.scrollable && !this.wrapper[0].style.height) ? ' style="margin:0 auto;position:static;"' : '';
	            var state = { storage: {}, count: 0 };
	            var settings = $.extend({}, kendo.Template, this.options.templateSettings);
	            var paramName = settings.paramName;
	            var template;
	            var html = "";
	            var type;
	            var tmpl;

	            if (this.options.noRecords.template) {
	                template = this.options.noRecords.template;
	            } else {
	                template = kendo.format(defaultTemplate, this.options.messages.noRecords, scrollableNoGridHeightStyles);
	            }

	            type = typeof template;
	            if (type === "function") {
	                state.storage["tmpl" + state.count] = template;
	                html += "#=this.tmpl" + state.count + "(" + paramName + ")#";
	                state.count ++;
	            } else if (type === "string") {
	                html += template;
	            }

	            tmpl = kendo.template(kendo.format(wrapper, NORECORDSCLASS, html), settings);

	            if (state.count > 0) {
	                tmpl = $.proxy(tmpl, state.storage);
	            }

	            return tmpl;
	        },

	        _footerTmpl: function(columns, aggregates, templateName, rowClass, skipGroupCells) {
	            var that = this,
	                settings = extend({}, kendo.Template, that.options.templateSettings),
	                paramName = settings.paramName,
	                html = "",
	                idx,
	                length,
	                template,
	                type,
	                storage = {},
	                count = 0,
	                scope = {},
	                groups = that._groups(),
	                fieldsMap = that.dataSource._emptyAggregates(aggregates),
	                column;

	            html += '<tr class="' + rowClass + '">';

	            if (groups > 0 && !skipGroupCells) {
	                html += groupCells(groups);
	            }

	            if (that._hasDetails()) {
	                html += '<td class="k-hierarchy-cell">&nbsp;</td>';
	            }

	            for (idx = 0, length = columns.length; idx < length; idx++) {
	                column = columns[idx];
	                template = column[templateName];
	                type = typeof template;

	                html += "<td" + stringifyAttributes(column.footerAttributes) + ">";

	                if (template) {
	                    if (type !== FUNCTION) {
	                        scope = fieldsMap[column.field] ? extend({}, settings, { paramName: paramName + "['" + column.field + "']" }) : {};
	                        template = kendo.template(template, scope);
	                    }

	                    storage["tmpl" + count] = template;
	                    html += "#=this.tmpl" + count + "(" + paramName + ")#";
	                    count ++;
	                } else {
	                    html += "&nbsp;";
	                }

	                html += "</td>";
	            }

	            html += '</tr>';

	            html = kendo.template(html, settings);

	            if (count > 0) {
	                return proxy(html, storage);
	            }

	            return html;
	        },

	        _groupHeaderTmpl: function(columns, aggregates, templateName, rowClass, skipGroupCells, groupHeaderColumnTemplateColumns) {
	            var that = this,
	                settings = extend({}, kendo.Template, that.options.templateSettings),
	                paramName = settings.paramName,
	                html = "",
	                idx,
	                length,
	                template,
	                type,
	                storage = {},
	                count = 0,
	                scope = {},
	                fieldsMap = that.dataSource._emptyAggregates(aggregates),
	                column,
	                headerTemplateIndex = groupHeaderColumnTemplateColumns.length ? inArray(groupHeaderColumnTemplateColumns[0], columns) : -1,
	                groupHeaderColumnTemplateClass;

	            html += '<tr role="row" class="' + rowClass + '">';

	            if (!skipGroupCells) {
	                html += '# for (var i = 0; i < data.groupCells; i++) { #' +
	                '<td class="k-group-cell">' +
	                  '&nbsp;' +
	                '</td>' +
	                '# } #';
	            }

	            if (that._hasDetails()) {
	                html += '<td class="k-hierarchy-cell">&nbsp;</td>';
	            }

	            if (headerTemplateIndex < 0) {
	                html += !skipGroupCells ? groupCellBuilder(columns.length) : '';
	                return;
	            }

	            if (headerTemplateIndex < MINCOLSPANVALUE && groupHeaderColumnTemplateColumns.length <= 1 && !skipGroupCells) {
	                html += !skipGroupCells ? groupCellBuilder(columns.length) : '';
	                return kendo.template(html, settings);
	            }

	            if (headerTemplateIndex < MINCOLSPANVALUE) {
	                headerTemplateIndex = !skipGroupCells ? 1 : 0;
	                html += !skipGroupCells ? groupCellBuilder(headerTemplateIndex) : '';
	            }
	            else {
	                html += !skipGroupCells ? groupCellBuilder(headerTemplateIndex) : groupCellLockedContentBuilder(headerTemplateIndex);
	            }

	            for (idx = headerTemplateIndex, length = columns.length; idx < length; idx++) {
	                column = columns[idx];
	                template = column[templateName];
	                type = typeof template;

	                if (column.sticky) {
	                    groupHeaderColumnTemplateClass = (column.groupHeaderColumnTemplateClass || '');

	                    if (!groupHeaderColumnTemplateClass) {
	                        groupHeaderColumnTemplateClass = column.groupHeaderColumnTemplateClass = "group-header-column-template-" + kendo.guid();
	                    }

	                    html += "<td class='" + STICKY_CELL_CLASS + " " + groupHeaderColumnTemplateClass + "' style='" + (column.stickyStyle || '') + "'>";
	                } else {
	                    html += "<td>";
	                }

	                if (template) {
	                    if (type !== FUNCTION) {
	                        scope = fieldsMap[column.field] ? extend({}, settings, { paramName: paramName + "['" + column.field + "']" }) : {};
	                        template = kendo.template(template, scope);
	                    }

	                    storage["tmpl" + count] = template;
	                    html += "#=this.tmpl" + count + "(" + paramName + ")#";
	                    count ++;
	                } else {
	                    html += "&nbsp;";
	                }

	                html += "</td>";
	            }

	            html += '</tr>';

	            html = kendo.template(html, settings);

	            if (count > 0) {
	                return proxy(html, storage);
	            }

	            return html;
	        },

	        _detailTmpl: function(template) {
	            var that = this,
	                html = "",
	                settings = extend({}, kendo.Template, that.options.templateSettings),
	                paramName = settings.paramName,
	                templateFunctionStorage = {},
	                templateFunctionCount = 0,
	                groups = that._groups(),
	                colspan = visibleColumns(leafColumns(that.columns)).length,
	                type = typeof template;

	            html += '<tr class="k-detail-row">';
	            if (groups > 0) {
	                html += groupCells(groups);
	            }
	            html += '<td class="k-hierarchy-cell"></td><td class="k-detail-cell"' + (colspan? ' colspan="' + colspan + '"' : '') + ">";

	            if (type === FUNCTION) {
	                templateFunctionStorage["tmpl" + templateFunctionCount] = template;
	                html += "#=this.tmpl" + templateFunctionCount + "(" + paramName + ")#";
	                templateFunctionCount ++;
	            } else {
	                html += template;
	            }

	            html += "</td></tr>";

	            html = kendo.template(html, settings);

	            if (templateFunctionCount > 0) {
	                return proxy(html, templateFunctionStorage);
	            }

	            return html;
	        },

	        _hasDetails: function() {
	            var that = this;

	            return that.options.detailTemplate !== null  || (that._events[DETAILINIT] || []).length;
	        },
	        _hasFilterRow: function() {
	            var filterable = this.options.filterable;
	            var hasFiltering = filterable &&
	                    typeof filterable.mode == STRING &&
	                    filterable.mode.indexOf("row") != -1;
	            var columns = this.columns;
	            var columnsWithoutFiltering = $.grep(columns, function(col) {
	                return col.filterable === false;
	            });

	            if (columns.length && columnsWithoutFiltering.length == columns.length) {
	                hasFiltering = false;
	            }

	            return hasFiltering;
	        },

	        _details: function() {
	            var that = this;

	            if (that.options.scrollable && that._hasDetails() && lockedColumns(that.columns).length) {
	                throw new Error("Having both detail template and locked columns is not supported");
	            }

	            that.table.on(CLICK + NS, ".k-hierarchy-cell .k-i-expand, .k-hierarchy-cell .k-i-collapse", function(e) {
	                var button = $(this);

	                that._toggleDetails(button);
	                e.preventDefault();
	                return false;
	            });
	        },

	        _toggleDetails: function(button, omitAnimation){
	            var that = this,
	            cell = button.closest("td.k-hierarchy-cell"),
	            expanding = button.hasClass("k-i-expand"),
	            masterRow = button.closest("tr.k-master-row"),
	            detailRow,
	            detailTemplate = that.detailTemplate,
	            data,
	            hasDetails = that._hasDetails(),
	            ariaLabelText = expanding ? COLLAPSE : EXPAND,
	            ariaExpandText = expanding ? true : false;

	            button.toggleClass("k-i-expand", !expanding)
	                .toggleClass("k-i-collapse", expanding)
	                .attr(ARIALABEL, ariaLabelText);

	            cell.attr("aria-expanded", ariaExpandText);

	            detailRow = masterRow.next();

	            if (hasDetails && !detailRow.hasClass("k-detail-row")) {
	                data = that.dataItem(masterRow);

	                detailRow = $(detailTemplate(data))
	                    .addClass(masterRow.hasClass("k-alt") ? "k-alt" : "")
	                    .insertAfter(masterRow);

	                that.angular("compile", function(){
	                    return {
	                        elements: detailRow.get(),
	                        data: [ { dataItem: data } ]
	                    };
	                });

	                that.trigger(DETAILINIT, { masterRow: masterRow, detailRow: detailRow, data: data, detailCell: detailRow.find(".k-detail-cell") });
	            }

	            that.trigger(expanding ? DETAILEXPAND : DETAILCOLLAPSE, { masterRow: masterRow, detailRow: detailRow});

	            if(omitAnimation){
	                toggleRow(detailRow, expanding);
	            } else {
	                detailRow.toggle(expanding);
	            }
	        },

	        dataItem: function(tr) {
	            tr = $(tr)[0];
	            if (!tr) {
	                return null;
	            }

	            var rows = this.tbody.children(),
	                classesRegEx = /k-grouping-row|k-detail-row|k-group-footer/,
	                idx = tr.sectionRowIndex,
	                j, correctIdx;

	            correctIdx = idx;

	            for (j = 0; j < idx; j++) {
	                if (classesRegEx.test(rows[j].className)) {
	                    correctIdx--;
	                }
	            }

	            return this._data[correctIdx];
	        },

	        expandRow: function(tr, omitAnimation) {
	            var button = $(tr).find('> td .k-i-expand');

	            if (button.length) {
	                this._toggleDetails(button, omitAnimation);
	            }
	        },

	        collapseRow: function(tr, omitAnimation) {
	            var button = $(tr).find('> td .k-i-collapse');

	            if (button.length) {
	                this._toggleDetails(button, omitAnimation);
	            }
	        },

	        _createHeaderCells: function(columns, rowSpan) {
	            var that = this,
	                idx,
	                th,
	                text,
	                html = "",
	                length,
	                title,
	                messages = that.options.messages,
	                leafs = leafColumns(that.columns),
	                groups = that.dataSource.group(),
	                field;

	            for (idx = 0, length = columns.length; idx < length; idx++) {
	                th = columns[idx].column || columns[idx];
	                text = that._headerCellText(th);
	                field = "";

	                var index = inArray(th, leafs);

	                if (th.selectable) {
	                    html += "<th scope='col'" + stringifyAttributes(th.headerAttributes);

	                    if (rowSpan && !columns[idx].colSpan) {
	                        html += " rowspan='" + rowSpan + "'";
	                    }

	                    if (index > -1) {
	                        html += kendo.attr("index") + "='" + index + "'";
	                    }
	                    text = th.headerTemplate ? text: kendo.template(SELECTCOLUMNHEADERTMPL)({});
	                    html += ">" + text + "</th>";
	                } else if(th.command) {
	                    html += "<th scope='col'" + stringifyAttributes(th.headerAttributes);

	                    if (rowSpan && !columns[idx].colSpan) {
	                        html += " rowspan='" + rowSpan + "'";
	                    }

	                    if (index > -1) {
	                        html += kendo.attr("index") + "='" + index + "'";
	                    }

	                    html += ">" + text + "</th>";
	                } else {
	                    if (th.field) {
	                        field = kendo.attr("field") + "='" + th.field + "' ";
	                    }

	                    html += "<th scope='col' role='columnheader' " + field;
	                    html += " aria-haspopup='true'";

	                    if (rowSpan && !columns[idx].colSpan) {
	                        html += " rowspan='" + rowSpan + "'";
	                    }

	                    if (columns[idx].colSpan > 1) {
	                        html += 'colspan="' + (columns[idx].colSpan - hiddenLeafColumnsCount(th.columns)) + '" ';
	                        html += kendo.attr("colspan") + "='" + columns[idx].colSpan + "'";
	                    } else if (columns[idx].colSpan === 1) {
	                        html += kendo.attr("colspan") + "='" + columns[idx].colSpan + "'";
	                    }

	                    if (th.title) {
	                        title = th.title && (that.options.encodeTitles ? htmlEncode(th.title, true) : th.title);
	                        html += kendo.attr("title") + '="' + title + '" ';
	                    }

	                    if (th.groupable !== undefined) {
	                        html += kendo.attr("groupable") + "='" + th.groupable + "' ";
	                    }

	                    if (isColumnGroupable(that, th)) {
	                        html += "aria-label='" + (title || th.field) + " ";
	                        html += isGroupedBy(groups, th.field) ? messages.ungroupHeader : messages.groupHeader;
	                        html += "' ";
	                    }

	                    if (th.aggregates && th.aggregates.length) {
	                        html += kendo.attr("aggregates") + "='" + th.aggregates + "'";
	                    }

	                    if (index > -1) {
	                        html += kendo.attr("index") + "='" + index + "'";
	                    }

	                    html += stringifyAttributes(th.headerAttributes);

	                    html += ">" + text + "</th>";
	                }
	            }
	            return html;
	        },

	        _appendLockedColumnContent: function() {
	            var columns = this.columns,
	                idx,
	                colgroup = this.table.find("colgroup"),
	                cols = colgroup.find("col:not(.k-group-col,.k-hierarchy-col)"),
	                length,
	                lockedCols = $(),
	                skipHiddenCount = 0,
	                container,
	                colSpan,
	                spanIdx,
	                colOffset = 0;

	            for (idx = 0, length = columns.length; idx < length; idx++) {
	                if (columns[idx].locked) {

	                    if (isVisible(columns[idx])) {
	                        colSpan = 1;

	                        if (columns[idx].columns) {
	                            colSpan = leafColumns(columns[idx].columns).length - hiddenLeafColumnsCount(columns[idx].columns);
	                        }

	                        colSpan = colSpan || 1;
	                        for (spanIdx = 0; spanIdx < colSpan; spanIdx++) {
	                            lockedCols = lockedCols.add(cols.eq(idx + colOffset + spanIdx - skipHiddenCount));
	                        }
	                        colOffset += colSpan - 1;
	                    } else {
	                        skipHiddenCount ++;
	                    }
	                }
	            }

	            container = $('<div class="k-grid-content-locked"><table' + (isIE7 ? ' cellspacing="0"' : '') + '><colgroup></colgroup><tbody></tbody></table></div>');
	            // detach is required for IE8, otherwise it switches to compatibility mode
	            colgroup.detach();
	            container.find("colgroup").append(lockedCols);
	            colgroup.insertBefore(this.table.find("tbody"));

	            this.lockedContent = container.insertBefore(this.content);
	            this.lockedTable = container.children("table");
	        },

	        _appendLockedColumnFooter: function() {
	            var that = this;
	            var footer = that.footer;
	            var cells = footer.find(".k-footer-template>td");
	            var cols = footer.find(".k-grid-footer-wrap>table>colgroup>col");
	            var html = $('<div class="k-grid-footer-locked"><table><colgroup></colgroup><tbody><tr class="k-footer-template"></tr></tbody></table></div>');
	            var idx, length;
	            var groups = that._groups();
	            var lockedCells = $(), lockedCols = $();

	            lockedCells = lockedCells.add(cells.filter(".k-group-cell"));
	            for (idx = 0, length = leafColumns(lockedColumns(that.columns)).length; idx < length; idx++) {
	                lockedCells = lockedCells.add(cells.eq(idx + groups));
	            }

	            lockedCols = lockedCols.add(cols.filter(".k-group-col"));
	            for (idx = 0, length = visibleColumns(leafColumns(visibleLockedColumns(that.columns))).length; idx < length; idx++) {
	                lockedCols = lockedCols.add(cols.eq(idx + groups));
	            }

	            lockedCells.appendTo(html.find("tr"));
	            lockedCols.appendTo(html.find("colgroup"));
	            that.lockedFooter = html.prependTo(footer);
	        },

	        _appendLockedColumnHeader: function(container) {
	            var that = this,
	                columns = this.columns,
	                idx,
	                html,
	                length,
	                colgroup,
	                tr,
	                trFilter,
	                table,
	                header,
	                filtercellCells,
	                rows = [],
	                skipHiddenCount = 0,
	                cols = $(),
	                hasFilterRow = that._hasFilterRow(),
	                filterCellOffset = 0,
	                filterCells = $(),
	                cell,
	                leafColumnsCount = 0,
	                cells = $();

	            colgroup = that.thead.prev().find("col:not(.k-group-col,.k-hierarchy-col)");
	            header = that.thead.find("tr:first .k-header:not(.k-group-cell,.k-hierarchy-cell)");
	            filtercellCells = that.thead.find(".k-filter-row").find("th:not(.k-group-cell,.k-hierarchy-cell)");

	            var colOffset = 0;
	            for (idx = 0, length = columns.length; idx < length; idx++) {
	                if (columns[idx].locked) {
	                    cell = header.eq(idx);
	                    leafColumnsCount = leafColumns(columns[idx].columns || []).length;

	                    if (isVisible(columns[idx])) {
	                        var colSpan = null;

	                        if (columns[idx].columns) {
	                            colSpan = leafColumnsCount - hiddenLeafColumnsCount(columns[idx].columns);
	                        }

	                        colSpan = colSpan || 1;
	                        for (var spanIdx = 0; spanIdx < colSpan; spanIdx++) {
	                            cols = cols.add(colgroup.eq(idx + colOffset + spanIdx - skipHiddenCount));
	                        }
	                        colOffset += colSpan - 1;
	                    }

	                    mapColumnToCellRows([columns[idx]], childColumnsCells(cell), rows, 0, 0);

	                    leafColumnsCount = leafColumnsCount || 1;
	                    for (var j = 0; j < leafColumnsCount; j++) {
	                        filterCells = filterCells.add(filtercellCells.eq(filterCellOffset + j));
	                    }
	                    filterCellOffset += leafColumnsCount;
	                }

	                if (columns[idx].columns) {
	                    skipHiddenCount += hiddenLeafColumnsCount(columns[idx].columns);
	                }

	                if (!isVisible(columns[idx])) {
	                    skipHiddenCount++;
	                }
	            }

	            if (rows.length) {
	                html = '<div class="k-grid-header-locked" style="width:1px"><table' + (isIE7 ? ' cellspacing="0"' : '') + '><colgroup></colgroup><thead>';
	                html += new Array(rows.length + 1).join("<tr></tr>");
	                html += (hasFilterRow ? '<tr class="k-filter-row"></tr>' : '') + '</thead></table></div>';

	                table = $(html);

	                colgroup = table.find("colgroup");
	                colgroup.append(that.thead.prev().find("col.k-group-col").add(cols));

	                tr = table.find("thead tr:not(.k-filter-row)");
	                for (idx = 0, length = rows.length; idx < length; idx++) {
	                    cells = toJQuery(rows[idx]);
	                    tr.eq(idx).append(that.thead.find("tr:eq(" + idx + ") .k-group-cell").add(cells));
	                }

	                var count = removeEmptyRows(this.thead);
	                if (rows.length < count) {
	                    removeRowSpanValue(table, count - rows.length);
	                }

	                trFilter = table.find(".k-filter-row");
	                trFilter.append(that.thead.find(".k-filter-row .k-group-cell").add(filterCells));

	                this.lockedHeader = table.prependTo(container);
	                this.thead.find(".k-group-cell").remove();

	                return true;
	            }
	            return false;
	        },

	        _removeLockedContainers: function() {
	            var elements = this.lockedHeader
	                .add(this.lockedContent)
	                .add(this.lockedFooter);

	            kendo.destroy(elements);
	            elements.off(NS).remove();

	            this.lockedHeader = this.lockedContent = this.lockedFooter = null;
	            this.selectable = null;
	        },

	        _thead: function() {
	            var that = this,
	                columns = that.columns,
	                hasDetails = that._hasDetails() && columns.length,
	                hasFilterRow = that._hasFilterRow(),
	                idx,
	                html = "",
	                thead = that.table.find(">thead"),
	                hasTHead = that.element.find("thead:first").length > 0,
	                headerContent = that.options.messages.expandCollapseColumnHeader,
	                tr;

	            if (!thead.length) {
	                thead = $("<thead/>").insertBefore(that.tbody);
	            }

	            if (that.lockedHeader && that.thead) {
	                tr = that.thead.find("tr:has(th):not(.k-filter-row)").html("");
	                tr.remove();
	                tr = $();

	                that._removeLockedContainers();
	            } else if (hasTHead) {
	                tr = that.element.find("thead:first tr:has(th):not(.k-filter-row)");
	            } else {
	                tr = that.element.find("tr:has(th):first");
	            }

	            if (!tr.length) {
	                tr = thead.children().first();
	                if (!tr.length) {
	                   var rows = [{ rowSpan: 1, cells: [], index: 0 }];
	                   that._prepareColumns(rows, columns);

	                   for (idx = 0; idx < rows.length; idx++) {
	                       html += "<tr>";
	                       if (hasDetails) {
	                           html += '<th class="k-hierarchy-cell" scope="col">' + headerContent + '</th>';
	                       }
	                       html += that._createHeaderCells(rows[idx].cells, rows[idx].rowSpan);
	                       html += "</tr>";
	                   }

	                   tr = $(html);
	                }
	            } else {
	                for (idx = 0; idx < columns.length; idx++) {
						var columnIndex = inArray(columns[idx], leafColumns(columns));
						var cell = leafDataCells(tr.parent()).filter("th:not(.k-group-cell):not(.k-hierarchy-cell)").eq(columnIndex);
						if (columns[idx].hidden && columnIndex >= 0) {
							cell[0].style.display = "none";
						}
	               }

	               that._updateHeadersAttr(childColumns(columns));
				}

	            if (hasFilterRow) {
	                var filterRow = $("<tr/>");
	                filterRow.addClass("k-filter-row");
	                if (hasDetails || tr.find(".k-hierarchy-cell").length) { // handles server side detail template
	                    filterRow.prepend('<th class="k-hierarchy-cell" scope="col">&nbsp;</th>');
	                }

	                var existingFilterRow = (that.thead || thead).find(".k-filter-row");
	                if (existingFilterRow.length) {
	                    kendo.destroy(existingFilterRow);
	                    existingFilterRow.remove();
	                }

	                thead.append(filterRow);
	            }

	            if (!tr.children().length) {
	                html = "";
	                if (hasDetails) {
	                    html += '<th class="k-hierarchy-cell" scope="col">&nbsp;</th>';
	                }

	                html += that._createHeaderCells(columns);

	                tr.html(html);
	            } else if (hasDetails && !tr.find(".k-hierarchy-cell")[0]) {
	                tr.prepend('<th class="k-hierarchy-cell" scope="col">'+ (headerContent ? headerContent:'&nbsp;') +'</th>');
	            }

	            tr.attr("role", "row").find("th").addClass("k-header");

	            if(!that.options.scrollable) {
	                thead.addClass("k-grid-header");
	            }

	            tr.find("script").remove().end().prependTo(thead);

	            if (that.thead) {
	                that._destroyColumnAttachments();
	            }

	            this.angular("cleanup", function(){
	                return {
	                    elements: thead.find("th" + NAVCELL).get()
	                };
	            });

	            this.angular("compile", function(){
	                return {
	                    elements: thead.find(HEADERCELLS).get(),
	                    data: map(columns, function(col) { return { column: col }; })
	                };
	            });

	            that.thead = thead.attr("role", "rowgroup");

	            that._sortable();

	            that._filterable();

	            that._filterRow();

	            that._scrollable();

	            that._columnMenu();

	            var syncHeight;
	            var hasLockedColumns = this.options.scrollable && lockedColumns(this.columns).length;

	            if (hasLockedColumns) {

	                syncHeight = that._appendLockedColumnHeader(that.thead.closest(".k-grid-header"));

	                that._appendLockedColumnContent();

	                that.lockedContent.bind("DOMMouseScroll" + NS + " mousewheel" + NS, proxy(that._wheelScroll, that));

	                if (kendo.support.touch) {
	                    that._lockedContentUserEvents = new kendo.UserEvents(that.lockedContent, {
	                        move: function (e) {
	                            that.content.scrollTop(that.content.scrollTop() + (-e.y.delta));
	                            e.preventDefault();
	                        }
	                    });
	                }

	                that._updateLockedCols();
	            }

	            that._updateCols();

	            that._updateColumnCellIndex();

	            that._updateFirstColumnClass();

	            that._resizable();

	            that._draggable();

	            that._reorderable();

	            that._updateHeader(that._groups());

	            that._updateStickyColumns();

	            if (hasLockedColumns) {
	                if (syncHeight) {
	                    that._syncLockedHeaderHeight();
	                }

	                that._applyLockedContainersWidth();
	            }

	            if (that.groupable) {
	                that._attachGroupable();
	            }
	        },

	        _retrieveFirstColumn: function(columns, rows) {
	            var result = $();

	            if (rows.length && columns[0]) {
	                var column = columns[0];

	                while(column.columns && column.columns.length) {
	                    column = column.columns[0];
	                    rows = rows.filter(":not(:first())");
	                }

	                result = result.add(rows);
	            }

	            return result;
	        },

	        _updateFirstColumnClass: function() {
	            var that = this,
	                columns = that.columns || [],
	                hasDetails = that._hasDetails() && columns.length;

	            if (!hasDetails && !that._groups()) {
	                var tr = that.thead.find(">tr:not(.k-filter-row):not(:first)");
	                columns = nonLockedColumns(columns);

	                var rows = that._retrieveFirstColumn(columns, tr);

	                if (that._isLocked()) {
	                    tr = that.lockedHeader.find("thead>tr:not(.k-filter-row):not(:first)");
	                    columns = lockedColumns(that.columns);

	                    rows = rows.add(that._retrieveFirstColumn(columns, tr));
	                }

	                rows.each(function() {
	                    var ths = $(this).find("th");
	                    ths.removeClass("k-first");
	                    ths.eq(0).addClass("k-first");
	                });
	            }
	        },

	        _prepareColumns: function(rows, columns, parentCell, parentRow) {
	            var row = parentRow || rows[rows.length - 1];

	            var childRow = rows[row.index + 1];
	            var totalColSpan = 0;

	            for (var idx = 0; idx < columns.length; idx++) {
	                var cell = { column: columns[idx], colSpan: 0 };
	                row.cells.push(cell);

	                if (columns[idx].columns && columns[idx].columns.length) {
	                    if (!childRow) {
	                        childRow = { rowSpan: 0, cells: [], index: rows.length };
	                        rows.push(childRow);
	                    }
	                    cell.colSpan = columns[idx].columns.length;
	                    this._prepareColumns(rows, columns[idx].columns, cell, childRow);
	                    totalColSpan += cell.colSpan - 1;
	                    row.rowSpan = rows.length - row.index;
	                }
	            }
	            if (parentCell) {
	                parentCell.colSpan += totalColSpan;
	            }
	        },

	        _wheelScroll: function (e) {
	            if (e.ctrlKey) {
	                return;
	            }

	            var content = this.content;

	            if (this.virtualScroll && this.virtualScroll.rows) {
	                content = this.virtualScrollable.verticalScrollbar;
	            }

	            var scrollTop = content.scrollTop(),
	                delta = kendo.wheelDeltaY(e);

	            if (delta) {
	                if (content[0].scrollHeight > content[0].clientHeight &&
	                    (content[0].scrollTop < content[0].scrollHeight - content[0].clientHeight && delta < 0 ||
	                    content[0].scrollTop > 0 && delta > 0)) {
	                    e.preventDefault();
	                }

	                content.scrollTop(scrollTop + (-delta));
	            }
	        },

	        _isLocked: function() {
	            return this.lockedHeader != null;
	        },

	        _updateHeaderCols: function() {
	            var table = this.thead.parent().add(this.table);

	            if (this._isLocked()) {
	                normalizeCols(table, visibleLeafColumns(visibleNonLockedColumns(this.columns)), this._hasDetails(), 0);
	            } else {
	                normalizeCols(table, visibleLeafColumns(visibleColumns(this.columns)), this._hasDetails(), 0);
	            }
	        },

	        _updateColumnSorters: function() {
	            var that = this;
	            var cells = leafDataCells(that.thead);
	            var columns = leafColumns(that.columns);
	            var column;
	            var cell;
	            var sorterInstance;

	            if (!that.options.sortable) {
	                return;
	            }

	            for (var idx = 0, length = cells.length; idx < length; idx++) {
	                column = columns[idx];

	                if (column.sortable !== false && !column.command && column.field) {
	                    cell = cells.eq(idx);

	                    sorterInstance = cell.data("kendoColumnSorter");

	                    if (sorterInstance) {
	                        sorterInstance.refresh();
	                    }
	                }
	            }
	        },

	        _updateHeadersAttr: function (columns) {
	            if (!columns.length) {
	                return;
	            }

	            var that = this;

	            for (var i = 0 ;i < columns.length; i++) {
	                if (columns[i].headerAttributes) {
	                    var th = that.element.find("[id='" + columns[i].headerAttributes.id + "']");
	                    th.attr("headers", columns[i].headerAttributes.headers);
	                }

	            }

	            that._updateHeadersAttr(childColumns(columns));
	        },

	        _updateCols: function(table) {
	            table = table || this.thead.parent().add(this.table);

	            this._appendCols(table, this._isLocked());
	        },

	        _updateLockedCols: function(table) {
	            if (this._isLocked()) {
	                table = table || this.lockedHeader.find("table").add(this.lockedTable);

	                normalizeCols(table, visibleLeafColumns(visibleLockedColumns(this.columns)), this._hasDetails(), this._groups());
	            }
	        },

	        _appendCols: function(table, locked) {
	            if (locked) {
	                normalizeCols(table, visibleLeafColumns(visibleNonLockedColumns(this.columns)), this._hasDetails(), 0);
	            } else {
	                normalizeCols(table, visibleLeafColumns(visibleColumns(this.columns)), this._hasDetails(), this._groups());
	            }
	        },

	        _autoColumns: function(schema) {
	            if (schema && schema.toJSON) {
	                var that = this,
	                    field,
	                    encoded;

	                schema = schema.toJSON();

	                encoded = !(that.table.find("tbody tr").length > 0 && (!that.dataSource || !that.dataSource.transport));

	                for (field in schema) {
	                    that.columns.push({ field: field, encoded: encoded, headerAttributes: {id: kendo.guid()} });
	                }

	                that._thead();

	                that._templates();
	            }
	        },

	        _rowsHtml: function(data, templates) {
	            var that = this,
	                html = "",
	                idx,
	                rowTemplate = templates.rowTemplate,
	                altRowTemplate = templates.altRowTemplate,
	                length;

	            for (idx = 0, length = data.length; idx < length; idx++) {
	                if (that._skipRerenderItemsCount > 0) {
	                    that._skipRerenderItemsCount--;
	                } else {
	                    if (idx % 2) {
	                        html += altRowTemplate(data[idx]);
	                    } else {
	                        html += rowTemplate(data[idx]);
	                    }
	                }
	                that._data.push(data[idx]);
	            }

	            return html;
	        },

	        _groupData: function(group, skipFooter, firstColumn) {
	            var that = this,
	                footerDefaults = that._groupAggregatesDefaultObject || {},
	                groupItems = group.items,
	                aggregates = extend({}, footerDefaults, group.aggregates),
	                headerData = extend({}, {
	                    field: group.field,
	                    value: group.value,
	                    items: groupItems,
	                    aggregates: aggregates
	                }, group.aggregates[firstColumn ? firstColumn.field : group.field]),
	                footerData = {};

	            if (!skipFooter) {
	                for (var aggregate in aggregates) {
	                    footerData[aggregate] = extend({}, aggregates[aggregate],
	                        { group: { field: group.field, value: group.value, items: groupItems } }
	                    );
	                }
	            }
	            return extend({}, footerData, headerData);
	        },

	        _removeGroupIfEmpty: function (row) {
	            var that = this,
	                itemsCount,
	                subgroupsCount,
	                length = that.dataSource._group.length;

	            for (var i = 0; i < length; i++) {
	                row = row.prev();
	                itemsCount = +row.attr('data-group-item-count');
	                subgroupsCount = +row.attr('data-sub-group-count');

	                if (itemsCount == 1 || subgroupsCount == 1) {
	                    row.hide();
	                }

	            }
	        },

	        _groupRowHtml: function(group, colspan, level, groupHeaderBuilder, templates, skipColspan, skipLastGroup) {
	            var that = this,
	                html = "",
	                idx,
	                length,
	                field = group.field,
	                column = grep(leafColumns(that.columns), function(column) { return column.field == field; })[0] || { },
	                firstColumn = visibleColumns(that.columns)[0],
	                firstVisibleColumnGroupHeaderTemplate = firstColumn ? firstColumn.groupHeaderColumnTemplate : null,
	                template = column.groupHeaderTemplate ? column.groupHeaderTemplate : firstVisibleColumnGroupHeaderTemplate,
	                text = (column.title && (that.options.encodeTitles ? htmlEncode(column.title, true) : column.title) || field) + ': ' + formatGroupValue(group.value, column.format, column.values, column.encoded),
	                groupItems = group.currentItems || group.items,
	                groups = that._groups(),
	                groupFooterTemplate = templates.groupFooterTemplate,
	                groupHeaderColumnTemplate = templates.groupHeaderColumnTemplate,
	                groupData,
	                expanded = that.dataSource._isGroupPaged() ? that.dataSource._groupsState[group.uid] : true;

	            if (that.options.editable && group.items && group.items[0] && group.items[0].isNew && group.items[0].isNew()) {
	                expanded = true;
	            }

	            if (templates.groupFooterTemplate || templates.groupHeaderColumnTemplate || column.groupHeaderTemplate) {
	                groupData = that._groupData(group, false, !column.groupHeaderTemplate && visibleColumns(that.columns)[0].groupHeaderColumnTemplate ? visibleColumns(that.columns)[0] : false);
	            }
	            if (template && !skipColspan) {
	                text  = typeof template === FUNCTION ? template(groupData) : kendo.template(template)(groupData);
	            }
	            if (!that._skipRerenderItemsCount) {
	                if (groupHeaderColumnTemplate) {
	                    if (!group.excludeHeader) {
	                        html += groupHeaderColumnTemplate(extend({}, groupData, {
	                            groupCells: level,
	                            colspan: groups - level,
	                            text: text
	                        }));
	                    } else {
	                        group.excludeHeader = false;
	                    }
	                }
	                else {
	                    if (!group.excludeHeader) {
	                        html += groupHeaderBuilder(colspan, level, text, expanded, group.uid, that.dataSource._isGroupPaged());
	                    } else {
	                        group.excludeHeader = false;
	                    }
	                }
	            } else {
	                groupHeaderBuilder(colspan, level, text, expanded, group.uid, that.dataSource._isGroupPaged());
	            }

	            if (expanded) {
	                if (group.hasSubgroups) {
	                    for (idx = 0, length = groupItems.length; idx < length; idx++) {
	                        html += that._groupRowHtml(groupItems[idx], skipColspan ? colspan : colspan - 1, level + 1, groupHeaderBuilder, templates, skipColspan, skipLastGroup && idx === groupItems.length - 1);
	                    }
	                } else {
	                    html += that._rowsHtml(groupItems, templates);
	                }
	            }

	            if (groupFooterTemplate) {

	                if (skipLastGroup) {
	                    if (!inArray(group.value, that._skippedGroups)) {
	                        that._skippedGroups.push(group.value);
	                    }
	                } else {
	                    if (that._skippedGroups.length && that._skippedGroups[0] === group.value) {
	                        that._skippedGroups.shift();
	                    }
	                    if (!that._skipRerenderItemsCount) {
	                        html += groupFooterTemplate(groupData);
	                    }
	                }
	            }
	            return html;
	        },

	        collapseGroup: function(group) {

	            var level,
	                that = this,
	                groupToCollapse = group,
	                groupable = this.options.groupable,
	                showFooter =  groupable.showFooter,
	                footerCount = showFooter ? 0 : 1,
	                offset,
	                relatedGroup = $(),
	                idx,
	                length,
	                tr;

	            group = $(group);
	            level = group.find(".k-group-cell").length;

	            if (this.dataSource._isGroupPaged()) {
	                var groupUid = group.attr("data-group-uid");
	                var groupObject = that.dataSource._getGroupByUid(groupUid);
	                var currentGroupCount = that.dataSource._calculateGroupsTotal([groupObject], true);
	                var groupCountAfterCollapse;

	                that.dataSource._groupsState[groupUid] = false;
	                groupCountAfterCollapse = that.dataSource._calculateGroupsTotal([groupObject], true);
	                that.dataSource._serverGroupsTotal -= currentGroupCount - groupCountAfterCollapse;
	                that._progress(true);
	                that.dataSource.range(that.dataSource._currentRangeStart, that.dataSource.take(), function () {
	                    that._progress(false);
	                }, "collapseGroup");
	                return;
	            }

	            if (this._isLocked()) {
	                if (!group.closest("div").hasClass("k-grid-content-locked")) {
	                    relatedGroup = group.nextAll("tr");
	                    group = this.lockedTable.find(">tbody>tr:eq(" + group.index() + ")");
	                } else {
	                    relatedGroup = this.tbody.children("tr:eq(" + group.index() + ")").nextAll("tr");
	                }
	            }

	            group.find(".k-i-collapse").addClass("k-i-expand").removeClass("k-i-collapse");
	            group.find("td[aria-expanded='true']:first").attr("aria-expanded", false)
	                .find("a").attr(ARIALABEL, EXPAND);

	            group = group.nextAll("tr");

	            var toHide = [];

	            for (idx = 0, length = group.length; idx < length; idx ++ ) {
	                tr = group.eq(idx);
	                offset = tr.find(".k-group-cell").length;

	                if (tr.hasClass("k-grouping-row")) {
	                    footerCount++;
	                } else if (tr.hasClass("k-group-footer")) {
	                    footerCount--;
	                }

	                if (offset <= level || (tr.hasClass("k-group-footer") && footerCount < 0)) {
	                    break;
	                }

	                if (relatedGroup.length) {
	                    toHide.push(relatedGroup[idx]);
	                }
	                toHide.push(tr[0]);
	            }

	            $(toHide).hide();

	            if (this.options.scrollable.endless && this.content) {
	                clearTimeout(that._collapseGroupsTimeOut);
	                that._collapseGroupsTimeOut = setTimeout(function () {
	                    that.content.scroll();
	                    that._groupToCollapse = groupToCollapse;
	                });
	            }
	        },

	        expandGroup: function (group) {
	                group = $(group);

	            var that = this,
	                showFooter = that.options.groupable.showFooter,
	                level,
	                tr,
	                offset,
	                relatedGroup = $(),
	                idx,
	                length,
	                footersVisibility = [],
	                groupsCount = 1;

	                level = group.find(".k-group-cell").length;

	            if (this.dataSource._isGroupPaged()) {
	                var groupUid = group.attr("data-group-uid");
	                var groupObject = that.dataSource._getGroupByUid(groupUid);
	                var groupCount =  that.dataSource._calculateGroupsTotal([groupObject], true);
	                var groupCountAfterExpand;

	                that.dataSource._groupsState[groupUid] = true;
	                if(groupObject.items && groupObject.items.length){
	                    groupCountAfterExpand = that.dataSource._calculateGroupsTotal([groupObject], true);
	                    that.dataSource._serverGroupsTotal += groupCountAfterExpand - groupCount;
	                }

	                that._progress(true);
	                that.dataSource.range(that.dataSource._currentRangeStart, that.dataSource.take(), function () {
	                    that._progress(false);
	                }, "expandGroup");
	                return;
	            }

	            if (this._isLocked()) {
	                if (!group.closest("div").hasClass("k-grid-content-locked")) {
	                    relatedGroup = group.nextAll("tr");
	                    group = this.lockedTable.find(">tbody>tr:eq(" + group.index() + ")");
	                } else {
	                    relatedGroup = this.tbody.children("tr:eq(" + group.index() + ")").nextAll("tr");
	                }
	            }

	            group.find(".k-i-expand").addClass("k-i-collapse").removeClass("k-i-expand");
	            group.find("td[aria-expanded='false']:first").attr("aria-expanded", true)
	                .find("a").attr(ARIALABEL, COLLAPSE);
	            group = group.nextAll("tr");

	            for (idx = 0, length = group.length; idx < length; idx ++ ) {
	                tr = group.eq(idx);
	                offset = tr.find(".k-group-cell").length;
	                if (offset <= level) {
	                    break;
	                }

	                if (offset == level + 1 && !tr.hasClass("k-detail-row")) {
	                    tr.show();
	                    relatedGroup.eq(idx).show();

	                    if (tr.hasClass("k-grouping-row") && tr.find(".k-icon").hasClass("k-i-collapse")) {
	                        that.expandGroup(tr);
	                    }

	                    if (tr.hasClass("k-master-row") && tr.find(".k-icon").hasClass("k-i-collapse")) {
	                        tr.next().show();
	                        relatedGroup.eq(idx + 1).show();
	                    }
	                }

	                if (tr.hasClass("k-grouping-row")) {
	                    if (showFooter) {
	                        footersVisibility.push(tr.is(":visible"));
	                    }
	                    groupsCount ++;
	                }

	                if (tr.hasClass("k-group-footer")) {
	                    if (showFooter) {
	                        var toggleVisibility = footersVisibility.pop();
	                        tr.toggle(toggleVisibility);
	                        relatedGroup.eq(idx).toggle(toggleVisibility);
	                    }
	                    if (groupsCount == 1) {
	                        tr.show();
	                        relatedGroup.eq(idx).show();
	                    } else {
	                        groupsCount --;
	                    }
	                }
	            }

	            if (level === 0 && that.options.scrollable.endless && this._isLocked()) {
	                that._syncLockedContentHeight();
	            }
	        },

	        _updateHeader: function(groups) {
	            var that = this,
	                container = that._isLocked() ? that.lockedHeader.find("thead") : that.thead,
	                filterCells = container.find("tr.k-filter-row").find("th.k-group-cell").length,
	                length = container.find("tr:first").find("th.k-group-cell").length,
	                rows = container.children("tr:not(:first)").filter(function() {
	                    return !$(this).children(":visible").length;
	                });

	            if(groups > length) {
	                $(new Array(groups - length + 1).join('<th class="k-group-cell k-header" scope="col">' + that.options.messages.expandCollapseColumnHeader + '</th>')).prependTo(container.children("tr:not(.k-filter-row)"));
	                if (that.element.is(":visible")) {
	                    rows.find("th.k-group-cell").hide();
	                }
	            } else if(groups < length) {
	                container.find("tr").each(function() {
	                    $(this).find("th.k-group-cell")
	                        .filter(":eq(" + groups + ")," + ":gt(" + groups + ")").remove();
	                });
	            }
	            if(groups > filterCells) {
	                $(new Array(groups - filterCells + 1).join('<th class="k-group-cell k-header" scope="col">&nbsp;</th>')).prependTo(container.find(".k-filter-row"));
	            }
	        },

	        _firstDataItem: function(data, grouped) {
	            if(data && grouped) {
	                if(data.hasSubgroups) {
	                    data = this._firstDataItem(data.items[0], grouped);
	                } else {
	                    data = data.items[0];
	                }
	            }
	            return data;
	        },

	        _updateTablesWidth: function() {
	            var that = this,
	                tables;

	            if (!that._isLocked()) {
	                return;
	            }

	            tables =
	                $(">.k-grid-footer>.k-grid-footer-wrap>table", that.wrapper)
	                .add(that.thead.parent())
	                .add(that.table);

	            that._footerWidth = tableWidth(tables.eq(0));
	            tables.width(that._footerWidth);

	            tables =
	                $(">.k-grid-footer>.k-grid-footer-locked>table", that.wrapper)
	                .add(that.lockedHeader.find(">table"))
	                .add(that.lockedTable);

	            tables.width(tableWidth(tables.eq(0)));
	        },

	        hideColumn: function(column) {
	            var that = this,
	                cell,
	                tables,
	                idx,
	                cols,
	                colWidth,
	                position,
	                width = 0,
	                headerCellIndex,
	                length,
	                footer = that.footer || that.wrapper.find(".k-grid-footer"),
	                virtualScroll = that.virtualScroll || {},
	                columns = that.columns,
	                visibleLocked = that.lockedHeader ? leafDataCells(that.lockedHeader.find(">table>thead")).filter(isCellVisible).length : 0,
	                columnIndex,
	                groupHeaderColumnTemplateColumns = grep(leafColumns(that.columns), function(column) { return column.groupHeaderColumnTemplate; });

	            if (typeof column == "number") {
	                column = columns[column];
	            } else if (isPlainObject(column)) {
	                column = grep(flatColumns(columns), function(item) {
	                    return item === column;
	                })[0];
	            } else {
	                column = grep(flatColumns(columns), function(item) {
	                    return item.field === column;
	                })[0];
	            }

	            if (!column || !isVisible(column)) {
	                return;
	            }

	            var setColumnVisibility = that._columnVisibilitySetter(column);

	            if (column.columns && column.columns.length) {
	                position = columnVisiblePosition(column, columns);

	                setColumnVisibility(column, false);

	                setCellVisibility(elements($(">table>thead", that.lockedHeader), that.thead, ">tr:eq(" + position.row + ")>th"), position.cell, false);

	                for (idx = 0; idx < column.columns.length; idx++) {
	                   this.hideColumn(column.columns[idx]);
	                }

	                that.trigger(COLUMNHIDE, { column: column });

	                return;
	            }

	            columnIndex = inArray(column, visibleColumns(leafColumns(columns)));

	            setColumnVisibility(column, false);

	            that._setParentsVisibility(column, false);

	            that._templates();

	            that._updateCols();
	            that._updateLockedCols();

	            var container = that.thead;

	            headerCellIndex = columnIndex;
	            if (that.lockedHeader && visibleLocked > columnIndex) {
	                container = that.lockedHeader.find(">table>thead");
	            } else {
	                headerCellIndex -= visibleLocked;
	            }

	            cell = leafDataCells(container).filter(isCellVisible).eq(headerCellIndex);
	            cell[0].style.display = "none";

	            setCellVisibility(elements($(">table>thead", that.lockedHeader), that.thead, ">tr.k-filter-row>th"), columnIndex, false);
	            if (footer[0]) {
	                that._updateCols(footer.find(">.k-grid-footer-wrap>table"));
	                that._updateLockedCols(footer.find(">.k-grid-footer-locked>table"));
	                setCellVisibility(footer.find(".k-footer-template>td"), columnIndex, false);
	            }

	            if (virtualScroll.columns && !column.locked) {
	                that._updateContentWidth();
	                that.trigger(COLUMNHIDE, { column: column });
	                return;
	            }

	            if (that.lockedTable && visibleLocked > columnIndex) {
	                hideColumnCells(that.lockedTable.find(">tbody>tr"), columnIndex);
	            } else {
	                hideColumnCells(that.tbody.children(), columnIndex - visibleLocked);
	            }

	            if (that.lockedTable) {
	                that._updateTablesWidth();
	                that._applyLockedContainersWidth();
	                that._syncLockedContentHeight();
	                that._syncLockedHeaderHeight();
	                that._syncLockedFooterHeight();
	            } else {
	                cols = that.thead.prev().find("col");
	                for (idx = 0, length = cols.length; idx < length; idx += 1) {
	                    colWidth = cols[idx].style.width;

	                    if (cols[idx].className.indexOf("k-hierarchy-col") > -1) {
	                        width += outerWidth(cols[idx]);
	                        continue;
	                    }

	                    if (cols[idx].className.indexOf("k-group-col") > -1) {
	                        width += outerWidth(cols[idx]);
	                        continue;
	                    }

	                    if (colWidth && colWidth.indexOf("%") == -1) {
	                        width += parseInt(colWidth, 10);
	                    } else {
	                        width = 0;
	                        break;
	                    }
	                }

	                tables = $(">.k-grid-header table:first,>.k-grid-footer table:first",that.wrapper).add(that.table);
	                that._footerWidth = null;

	                if (width) {
	                    tables.each(function() {
	                        this.style.width = width + "px";
	                    });

	                    that._footerWidth = width;
	                    that._setContentWidth();
	                }
	                if(browser.msie && browser.version == 8) {
	                    tables.css("display", "inline-table");
	                    setTimeout(function() {
	                        tables.css("display", "table");
	                    }, 1);
	                }
	            }

	            that._updateFirstColumnClass();
	            that._updateStickyColumns();
	            if (groupHeaderColumnTemplateColumns.length > 0) {
	                that._renderGroupRows();
	            }
	            that.trigger(COLUMNHIDE, { column: column });
	        },

	        _setParentsVisibility: function(column, visible) {
	            var that = this;
	            var columns = that.columns;
	            var idx;
	            var parents = [];
	            var parent;
	            var position;
	            var cell;
	            var colSpan;
	            var setColumnVisibility = that._columnVisibilitySetter(column);

	            var predicate = visible ?
	                function(p) { return visibleColumns(p.columns).length && p.hidden; } :
	                function(p) { return !visibleColumns(p.columns).length && !p.hidden; };


	            if (columnParents(column, columns, parents) && parents.length) {
	                for (idx = parents.length - 1; idx >= 0; idx--) {
	                    parent = parents[idx];
	                    position = columnPosition(parent, columns);
	                    cell = elements($(">table>thead", this.lockedHeader), this.thead, ">tr:eq(" + position.row + ")>th:not(.k-group-cell):not(.k-hierarchy-cell)").eq(position.cell);

	                    if (predicate(parent)) {
	                        setColumnVisibility(parent, visible);
	                        cell[0].style.display = visible ? "" : "none";
	                    }

	                    if (cell.filter("[" + kendo.attr("colspan") + "]").length) {
	                        colSpan = parseInt(cell.attr(kendo.attr("colspan")), 10);
	                        cell[0].colSpan = (colSpan - hiddenLeafColumnsCount(parent.columns)) || 1;
	                    }
	                }
	            }
	        },

	        _updateContentWidth: function () {
	            var that = this;
	            var tables = that.table.add(that.thead.parent());

	            tables.css({
	                width: sumWidths(visibleLeafColumns(visibleNonLockedColumns(that.columns)))
	            });
	            that.refresh();
	        },

	        showColumn: function(column) {
	            var that = this,
	                idx,
	                length,
	                cell,
	                tables,
	                width,
	                headerCellIndex,
	                position,
	                colWidth,
	                cols,
	                columns = that.columns,
	                virtualScroll = that.virtualScroll || {},
	                footer = that.footer || that.wrapper.find(".k-grid-footer"),
	                lockedColumnsCount = that.lockedHeader ? leafDataCells(that.lockedHeader.find(">table>thead")).length : 0,
	                columnIndex,
	                originalColumn,
	                columnLeafIndex,
	                groupHeaderColumnTemplateColumns = grep(leafColumns(that.columns), function(column) { return column.groupHeaderColumnTemplate; });

	            if (typeof column == "number") {
	                columnIndex = column;
	                column = columns[column];
	            } else if (isPlainObject(column)) {
	                $.each(flatColumns(columns), function (index, item) {
	                    if (item === column) {
	                        column = item;
	                        columnIndex = index;
	                        return false;
	                    }
	                });
	            } else {
	                $.each(flatColumns(columns), function (index, item) {
	                    if (item.field === column) {
	                        column = item;
	                        columnIndex = index;
	                        return false;
	                    }
	                });
	            }

	            if (!column || isVisible(column)) {
	                return;
	            }

	            var setColumnVisibility = that._columnVisibilitySetter(column);

	            if (column.columns && column.columns.length) {
	                position =  columnPosition(column, columns);
	                originalColumn = flatColumns(that.options.columns)[columnIndex];

	                setColumnVisibility(column, true);

	                setCellVisibility(elements($(">table>thead", that.lockedHeader), that.thead, ">tr:eq(" + position.row + ")>th"), position.cell, true);

	                for (idx = 0; idx < column.columns.length; idx++) {
	                    if (!originalColumn.columns[idx].hidden) {
	                        this.showColumn(column.columns[idx]);
	                    }
	                }

	                that.trigger(COLUMNSHOW, { column: column });

	                return;
	            }

	            columnLeafIndex = inArray(column, leafColumns(columns));

	            setColumnVisibility(column, true);

	            that._setParentsVisibility(column, true);

	            that._templates();
	            that._updateCols();
	            that._updateLockedCols();

	            var container = that.thead;

	            headerCellIndex = columnLeafIndex;
	            if (that.lockedHeader && lockedColumnsCount > columnLeafIndex) {
	                container = that.lockedHeader.find(">table>thead");
	            } else {
	                headerCellIndex -= lockedColumnsCount;
	            }

	            cell = leafDataCells(container).eq(headerCellIndex);
	            cell[0].style.display = "";

	            setCellVisibility(elements($(">table>thead", that.lockedHeader), that.thead, ">tr.k-filter-row>th"), columnLeafIndex, true);
	            if (footer[0]) {
	                that._updateCols(footer.find(">.k-grid-footer-wrap>table"));
	                that._updateLockedCols(footer.find(">.k-grid-footer-locked>table"));
	                setCellVisibility(footer.find(".k-footer-template>td"), columnLeafIndex, true);
	            }

	            if (virtualScroll.columns && !column.locked) {
	                that._updateContentWidth();
	                that.trigger(COLUMNSHOW, { column: column });
	                return;
	            }

	            if (that.lockedTable && lockedColumnsCount > columnLeafIndex) {
	                showColumnCells(that.lockedTable.find(">tbody>tr"), columnLeafIndex);
	            } else {
	                showColumnCells(that.tbody.children(), columnLeafIndex - lockedColumnsCount);
	            }

	            if (that.lockedTable) {
	                that._updateTablesWidth();
	                that._applyLockedContainersWidth();
	                that._syncLockedContentHeight();
	                that._syncLockedHeaderHeight();
	            } else {
	                tables = $(">.k-grid-header table:first,>.k-grid-footer table:first",that.wrapper).add(that.table);
	                if (!column.width) {
	                    tables.width("");
	                } else {
	                    width = 0;
	                    cols = that.thead.prev().find("col");
	                    for (idx = 0, length = cols.length; idx < length; idx += 1) {
	                        colWidth = cols[idx].style.width;

	                        if (cols[idx].className.indexOf("k-hierarchy-col") > -1) {
	                            width += outerWidth(cols[idx]);
	                            continue;
	                        }

	                        if (cols[idx].className.indexOf("k-group-col") > -1) {
	                            width += outerWidth(cols[idx]);
	                            continue;
	                        }

	                        if (colWidth.indexOf("%") > -1) {
	                            width = 0;
	                            break;
	                        }
	                        width += parseInt(colWidth, 10);
	                    }

	                    that._footerWidth = null;
	                    if (width) {
	                        tables.each(function() {
	                            this.style.width = width + "px";
	                        });
	                        that._footerWidth = width;
	                        that._setContentWidth();
	                    }
	                }
	            }

	            that._updateFirstColumnClass();
	            that._updateStickyColumns();
	            if (groupHeaderColumnTemplateColumns.length > 0) {
	                that._renderGroupRows();
	            }
	            that.trigger(COLUMNSHOW, { column: column });
	        },

	        _columnVisibilitySetter: function(column) {
	            var col = column || {};

	            if (isUndefined(col.media)) {
	                return setColumnVisibility;
	            } else {
	                return setColumnMediaVisibility;
	            }
	        },

	        _progress: function(toggle) {
	            var element = this.element;
	            var endless = this.options.scrollable && this.options.scrollable.endless;

	            if (this._editContainer && this._editMode() === "popup") {
	                element = this._editContainer;
	            } else if (this.lockedContent || endless) {
	                element = this.wrapper;
	            } else if (this.element.is("table")) {
	                element = this.element.parent();
	            } else if (this.content && this.content.length) {
	                element = this.content;
	            }

	            if (endless && toggle) {
	                kendo.ui.progress(element, toggle, { height: this.content.height(), top: this.content[0].offsetTop, opacity: true });
	            } else {
	                kendo.ui.progress(element, toggle);
	            }
	        },

	        _resize: function(size, force) {

	            this._syncLockedContentHeight();
	            this._syncLockedHeaderHeight();

	            if (this.content) {
	                this._setContentWidth();
	                this._setContentHeight();
	            }

	            if (this.lockedTable) {
	                this._syncLockedScroll();
	            }

	            if (this.virtualScrollable && (force || this._rowHeight)) {
	                if (force) {
	                    this._rowHeight = null;
	                }
	                this.virtualScrollable.repaintScrollbar();
	            }

	            if (this.pager && this.pager.element) {
	                this.pager.resize(force);
	            }
	        },

	        _isActiveInTable: function() {
	            var active = activeElement();

	            if (!active) { return false; }

	            return this.table[0] === active ||
	                $.contains(this.table[0], active) ||
	                (this._isLocked() &&
	                    (this.lockedTable[0] === active || $.contains(this.lockedTable[0], active))
	                );
	        },

	        refresh: function(e) {
	            var that = this,
	                data = that.dataSource.view(),
	                navigatable = that.options.navigatable,
	                virtualScroll = that.virtualScroll || {},
	                currentIndex,
	                current = $(that.current()),
	                isCurrentInHeader = false,
	                groups = (that.dataSource.group() || []).length,
	                colspan = groups + visibleLeafColumns(visibleColumns(that.columns)).length,
	                contentScrollLeft,
	                cachedItemsToSkip;


	            if (e && e.action === "itemchange" && (that.editable || that.options.scrollable.endless)) { // skip rebinding if editing is in progress
	                if (this._editMode() != "popup" || this._editMode() === "popup" && !that._editableIsClosing) { // popup editing animation has not finished yet and the editable is not destoyed
	                    return;
	                }
	            }


	            if (virtualScroll.columns) {
	                that._templates();
	            }

	            //someone remove the edited item
	            if (e && e.action === "remove" && that.editable &&
	                that.editable.options.model && inArray(that.editable.options.model, e.items) > -1) {
	                that.editable.options.model.unbind(CHANGE, that._modelChangeHandler);
	            }

	            e = e || {};

	            if (that.trigger("dataBinding", { action: e.action || "rebind", index: e.index, items: e.items })) {
	                return;
	            }

	            if (e.action === SYNC && that._isVirtualEditable()) {
	                that._destroyEditable();
	                that._clearEditableState();
	            }

	            that._angularItems("cleanup");
	            if (!that._endlessFetchInProgress) {
	                if (navigatable && (that._isActiveInTable() || (that._editContainer && that._editContainer.data("kendoWindow")))) {
	                    isCurrentInHeader = current.is("th");
	                    currentIndex = isCurrentInHeader ? current.parent().children(":not(.k-group-cell)").index(current[0]) : Math.max(that.cellIndex(current), 0);
	                }
	                that._destroyEditable();
	            }

	            if(that.options.scrollable && that.options.scrollable.endless){
	                clearTimeout(that._progressTimeOut);
	                that._progressTimeOut = setTimeout(function(){
	                    if (!that._endlessFetchInProgress) {
	                        that._progress(false);
	                    }
	                },100);
	            } else {
	                 that._progress(false);
	            }

	            that._hideResizeHandle();

	            that._data = [];

	            if (!that.columns.length) {
	                that._autoColumns(that._firstDataItem(data[0], groups));
	                colspan = groups + that.columns.length;
	            }

	            that._group = groups > 0 || that._group;

	            if(that._group) {
	                that._templates();
	                that._updateCols();
	                that._updateLockedCols();
	                if (!that._virtualColScroll) {
	                    that._updateHeader(groups);
	                }
	                that._group = groups > 0;
	                that._groupRows = groupRows(data);
	            }

	            if (that.content) {
	                contentScrollLeft = kendo.scrollLeft(that.content);
	            }
	            cachedItemsToSkip = that._skipRerenderItemsCount;
	            that._renderContent(data, colspan, groups);
	            if (that.options.scrollable && that.options.scrollable.endless && this.lockedContent) {
	                that._skipRerenderItemsCount = cachedItemsToSkip;
	            }
	            that._renderLockedContent(data, colspan, groups);

	            if (!that._virtualColScroll) {
	                that._footer();

	                that._renderNoRecordsContent();

	                that._togglePagerVisibility();

	                that._setContentHeight();

	                that._setContentWidth(that.content && contentScrollLeft);
	            }

	            if (that.lockedTable) {
	                //requires manual trigger of scroll to sync both tables
	                if (virtualScroll.rows) {
	                    that.content.find(">.k-virtual-scrollable-wrap").trigger("scroll");
	                } else if (that.touchScroller) {
	                    that.touchScroller.movable.trigger("change");
	                } else {
	                    that.wrapper.one("scroll", function(e) { e.stopPropagation(); });
	                    that.content.trigger("scroll");
	                }
	            }

	            if(!that._endlessFetchInProgress) {
	                that._restoreCurrent(currentIndex, isCurrentInHeader);
	            }

	            if (that.touchScroller) {
	                that.touchScroller.contentResized();
	            }

	            if (that.selectable) {
	                that.selectable.resetTouchEvents();
	            }

	            that._muteAngularRebind(function() {
	                that._angularItems("compile");
	            });

	            if (that._checkBoxSelection) {
	                that._toggleHeaderCheckState(false);
	            }

	            if(that.options.persistSelection &&
	                ((that.selectable && !kendo.ui.Selectable.parseOptions(that.options.selectable).cell) || that._checkBoxSelection) &&
	                (that.items().length || that.dataSource._isGroupPaged())) {
	                that._restoreSelection();
	            }

	            that.trigger(DATABOUND);
	       },

	        _restoreCurrent: function(currentIndex, isCurrentInHeader) {
	            if (currentIndex === undefined || currentIndex < 0) {
	                return;
	            }

	            this._removeCurrent();

	            if (isCurrentInHeader) {
	                this._setCurrent(this.thead.find("th:not(.k-group-cell)").eq(currentIndex));
	            } else {
	                var rowIndex = 0;
	                var virtualScroll = this.virtualScroll || {};

	                if (this._rowVirtualIndex) {
	                    if (virtualScroll.rows) {
	                        rowIndex = this.virtualScrollable.position(this._rowVirtualIndex);
	                    } else {
	                        rowIndex = this._rowVirtualIndex;
	                    }
	                } else {
	                    currentIndex = 0;
	                }

	                var row = $();
	                var colspan;

	                if (this.lockedTable) {
	                    row = this.lockedTable.find(">tbody>tr").eq(rowIndex);
	                }
	                row = row.add(this.tbody.children().eq(rowIndex));

	                if (this._hasVirtualColumns()) {
	                    colspan = parseInt(row.find("td:first").attr("colspan"), 10);
	                    currentIndex = this._virtualCellIndex - (colspan > 1 ? colspan - 1 : 0);
	                }


	                var td = row.find(">td:not(.k-group-cell):not(.k-hierarchy-cell)")
	                    .eq(currentIndex);

	                if (!td.length || currentIndex < 0) {
	                    return;
	                }

	                if (this._hasVirtualColumns()) {
	                    this._setCurrent(td, true, true);

	                } else {
	                    this._setCurrent(td);
	                }

	            }

	            if (this._current) {
	                focusTable(this._current.closest("table")[0], true);
	            }
	        },

	        _restoreSelection: function() {
	            var that = this,
	                allRows = that.items(),
	                selectedRows,
	                id = isFunction(that.dataSource.options.schema.model) ? that.dataSource.options.schema.model.fn.idField : that.dataSource.options.schema.model.id;

	            selectedRows = grep(allRows, function(row) {
	                 var dataItemKey = that.dataItem(row)[id];
	                 if(that._selectedIds[dataItemKey]) {
	                    return row;
	                 }
	            });

	            that.select(selectedRows);
	        },

	       _angularItems: function(cmd) {

	           kendo.ui.DataBoundWidget.fn._angularItems.call(this, cmd);

	           if (cmd === "cleanup" && (!this.dataSource || !this.dataSource.options.endless)) {
	               this._cleanupDetailItems();
	           }

	           this._angularGroupItems(cmd);

	           this._angularGroupFooterItems(cmd);
	       },

	       _cleanupDetailItems: function() {
	           var that = this;

	           if (that._hasDetails()) {
	              that.angular("cleanup", function() {
	                   return { elements: that.tbody.children(".k-detail-row") };
	               });

	               that.tbody.find(".k-detail-cell").empty();
	           }
	       },

	       _angularGroupItems: function(cmd) {
	           var that = this,
	               container = that.tbody;

	           if (that.lockedContent) {
	               container = that.lockedTable.find("tbody");
	           }

	           if (that._group) {
	              that.angular(cmd, function(){
	                   return {
	                       elements: container.children(".k-grouping-row"),
	                       data: $.map(groupRows(that.dataSource.view()), function(dataItem){
	                           return { dataItem: dataItem };
	                       })
	                   };
	               });
	           }
	       },

	       _angularGroupFooterItems: function(cmd) {
	           var that = this,
	               container = that.tbody;

	           if (that.lockedContent) {
	                container = that.element;
	           }

	           if (that._group && that.groupFooterTemplate) {

	               that.angular(cmd, function() {
	                   return {
	                       elements: container.find(".k-group-footer"),
	                       data: $.map(groupFooters(that.dataSource.view()), function(dataItem){
	                           return { dataItem: dataItem };
	                       })
	                   };
	               });
	           }
	       },

	       _renderContent: function(data, colspan, groups) {
	            var that = this,
	                idx,
	                length,
	                html = "",
	                isLocked = that.lockedContent != null,
	                endlessAppend = null,
	                skipLastGroup,
	                flatViewLength,
	                scrollable = that.options.scrollable,
	                templates = {
	                        rowTemplate: that.rowTemplate,
	                        altRowTemplate: that.altRowTemplate,
	                        groupFooterTemplate: that.groupFooterTemplate,
	                        groupHeaderColumnTemplate: that.groupHeaderColumnTemplate
	                    };
	            if (scrollable && scrollable.endless && !that.dataSource.options.endless) {
	                that._skipRerenderItemsCount = 0;
	                if (that.content) {
	                    that.content[0].scrollTop = 0;
	                }
	            }
	            endlessAppend = that._skipRerenderItemsCount > 0;
	            colspan = isLocked ? colspan - visibleLeafColumns(visibleLockedColumns(that.columns)).length : colspan;
	            if(groups > 0) {

	                colspan = isLocked ? colspan - groups : colspan;

	                if (that.detailTemplate) {
	                    colspan++;
	                }

	                if (that.groupFooterTemplate) {
	                    that._groupAggregatesDefaultObject = that.dataSource.aggregates();
	                }
	                if (that.options.scrollable.endless) {
	                    flatViewLength = that.dataSource.flatView().length;
	                }
	                for (idx = 0, length = data.length; idx < length; idx++) {
	                    if (!that._skippedGroups) {
	                        that._skippedGroups = [];
	                    }
	                    skipLastGroup = flatViewLength && idx === data.length - 1 && flatViewLength !== that.dataSource.total();
	                    html += that._groupRowHtml(data[idx], colspan, 0, isLocked ? groupRowLockedContentBuilder : groupRowBuilder, templates, isLocked, skipLastGroup);
	                }
	            } else {
	                html += that._rowsHtml(data, templates);
	            }

	            if (endlessAppend) {
	                that.tbody.append(html);
	                clearTimeout(that._endlessFetchTimeOut);
	                that._endlessFetchTimeOut = setTimeout(function () {
	                    if (that._groupToCollapse) {
	                        that.collapseGroup(that._groupToCollapse);
	                        that._groupToCollapse = null;
	                    }
	                });
	                that._endlessFetchInProgress = null;
	            } else {
	                that.tbody = appendContent(that.tbody, that.table, html, this.options.$angular);
	            }
	       },

	       _renderGroupRows : function() {
	        var that = this,
	        data = that._groupRows,
	        groupRows = that.wrapper.find(".k-grouping-row"),
	        groups = that._groups(),
	        groupRowBuilderFunc,
	        isLocked = that.lockedContent != null,
	        columns,
	        colspan,
	        group,
	        field,
	        column,
	        template,
	        text,
	        groupHeaderData,
	        tableContainer,
	        isInLockedContainer,
	        prevElement,
	        newGroupRowElement,
	        currentRow,
	        level,
	        groupHeaderColumnTemplate,
	        firstColumnGroupData;

	        groupRows.each(function(index, row) {
	            currentRow = $(row);
	            tableContainer = currentRow.closest("table").parent();
	            isInLockedContainer = tableContainer.is("." + CONTENTRLOCKEDCONTAINER);
	            columns = isInLockedContainer ? visibleLeafColumns(visibleColumns(lockedColumns(that.columns))) : visibleLeafColumns(visibleColumns(nonLockedColumns(that.columns)));
	            level = currentRow.find("." + GROUPCELLCLASS).length;
	            if (isLocked) {
	                groupRowBuilderFunc = isInLockedContainer ? groupRowBuilder : groupRowLockedContentBuilder;
	                colspan = isInLockedContainer ? columns.length + groups - level  : columns.length;
	            }
	            else {
	                groupRowBuilderFunc = groupRowBuilder;
	                colspan = columns.length + groups - level;
	            }

	            group = index >= data.length ? data[index - data.length] : data[index];
	            field = group.field;
	            column = grep(leafColumns(that.columns), function(column) { return column.field == field; })[0] || { };
	            firstColumnGroupData = !column.groupHeaderTemplate && visibleColumns(that.columns)[0].groupHeaderColumnTemplate ? visibleColumns(that.columns)[0] : false;
	            template = column.groupHeaderTemplate ? column.groupHeaderTemplate : visibleColumns(that.columns)[0].groupHeaderColumnTemplate;
	            text = (column.title && (that.options.encodeTitles ? htmlEncode(column.title, true) : column.title) || field) + ': ' + formatGroupValue(group.value, column.format, column.values, column.encoded);
	            groups = groups;
	            groupHeaderData = that._groupData(group, false, firstColumnGroupData);
	            groupHeaderColumnTemplate = isInLockedContainer ? that.lockedGroupHeaderColumnTemplate : that.groupHeaderColumnTemplate;

	            if (template) {
	                text  = typeof template === FUNCTION ? template(groupHeaderData) : kendo.template(template)(groupHeaderData);
	            }

	            prevElement = currentRow.prev().length ? currentRow.prev() : currentRow.parent();

	            newGroupRowElement = $(groupHeaderColumnTemplate ?
	                groupHeaderColumnTemplate(extend({}, groupHeaderData, { groupCells: level, colspan: groups - level, text: text})) :
	                groupRowBuilderFunc(colspan, level, text)
	            );

	            if (prevElement.is("tbody")) {
	                prevElement.prepend(newGroupRowElement);
	            }
	            else {
	                prevElement.after(newGroupRowElement);
	            }
	                currentRow.remove();
	           });
	       },

	       _renderLockedContent: function(data, colspan, groups) {
	           var html = "",
	               idx,
	               length,
	               endlessAppend = null,
	               templates = {
	                   rowTemplate: this.lockedRowTemplate,
	                   altRowTemplate: this.lockedAltRowTemplate,
	                   groupFooterTemplate: this.lockedGroupFooterTemplate,
	                   groupHeaderColumnTemplate: this.lockedGroupHeaderColumnTemplate
	               };

	           if (this.lockedContent) {

	               var table = this.lockedTable;
	               endlessAppend = this._skipRerenderItemsCount > 0;

	               if (groups > 0) {
	                   colspan = colspan - visibleColumns(leafColumns(nonLockedColumns(this.columns))).length;
	                   for (idx = 0, length = data.length; idx < length; idx++) {
	                    html += this._groupRowHtml(data[idx], colspan, 0, groupRowBuilder, templates, false, this.options.scrollable.endless && idx === data.length -1);
	                   }
	               } else {
	                   html = this._rowsHtml(data, templates);
	               }

	               if (endlessAppend) {
	                   table.children("tbody").append(html);
	               } else {
	                   appendContent(table.children("tbody"), table, html, this.options.$angular);
	               }

	               this._syncLockedContentHeight();
	           }
	       },

	       _togglePagerVisibility: function() {
	           if (this.options.pageable.alwaysVisible === false) {
	                this.wrapper.find(".k-grid-pager").toggle(this.dataSource.total() >= this.dataSource.pageSize());
	            }
	       },

	       _adjustRowsHeight: function(table1, table2) {
	           var rows = table1[0].rows,
	               length = rows.length,
	               idx,
	               rows2 = table2[0].rows,
	               containers = table1.add(table2),
	               containersLength = containers.length,
	               heights = [];

	           for (idx = 0; idx < length; idx++) {
	               if (!rows2[idx]) {
	                   break;
	               }

	               if (rows[idx].style.height) {
	                   rows[idx].style.height = rows2[idx].style.height = "";
	               }
	           }

	           for (idx = 0; idx < length; idx++) {
	               if (!rows2[idx]) {
	                   break;
	               }

	               var offsetHeight1 = rows[idx].offsetHeight;
	               var offsetHeight2 = rows2[idx].offsetHeight;
	               var height = 0;

	               if (offsetHeight1 > offsetHeight2) {
	                   height = offsetHeight1;
	               } else if (offsetHeight1 < offsetHeight2) {
	                   height = offsetHeight2;
	               }

	               heights.push(height);
	           }

	           for (idx = 0; idx < containersLength; idx++) {
	               containers[idx].style.display = "none";
	           }

	           for (idx = 0; idx < length; idx++) {
	               if (heights[idx]) {
	                   //add one to resolve row misalignment in IE
	                   rows[idx].style.height = rows2[idx].style.height = (heights[idx] + 1) + "px";
	               }
	           }

	           for (idx = 0; idx < containersLength; idx++) {
	               containers[idx].style.display = "";
	           }
	       }
	   });

	   if (kendo.ExcelMixin) {
	       kendo.ExcelMixin.extend(Grid.prototype);
	   }

	   if (kendo.PDFMixin) {
	       kendo.PDFMixin.extend(Grid.prototype);

	       Grid.prototype._drawPDF_autoPageBreak = function(progress) {
	           var grid = this;
	           var result = new $.Deferred();
	           var dataSource = grid.dataSource;
	           var allPages = grid.options.pdf.allPages;
	           var origBody = grid.wrapper.find('table[role$="grid"] > tbody').first();
	           var cont = $("<div>")
	               .css({ position: "absolute", left: -10000, top: -10000 });
	           var clone = grid.wrapper.clone().css({
	               height: "auto", width: "auto"
	           }).appendTo(cont);
	           clone.find(".k-grid-content").css({ height: "auto", width: "auto", overflow: "visible" });
	           clone.find('table[role$="grid"], .k-grid-footer table').css({ height: "auto", width: "100%", overflow: "visible" });
	           clone.find(".k-grid-pager, .k-grid-toolbar, .k-grouping-header").remove();
	           clone.find(".k-grid-header, .k-grid-footer, .k-auto-scrollable").css({ paddingRight: 0 });

	           this._initPDFProgress(progress);

	           var body = clone.find('table[role$="grid"] > tbody').first().empty();
	           var startingPage = dataSource.page();

	           function resolve() {
	               if (allPages && startingPage !== undefined) {
	                   dataSource.one("change", draw);
	                   dataSource.page(startingPage);
	               } else {
	                   grid.refresh();
	                   draw();
	               }
	           }

	           function draw() {
	               cont.appendTo(document.body);
	               var options = $.extend({}, grid.options.pdf, {
	                   _destructive: true,
	                   progress: function(p) {
	                       progress.notify({
	                           page: p.page,
	                           pageNumber: p.pageNum,
	                           progress: 0.5 + p.pageNum / p.totalPages / 2,
	                           totalPages: p.totalPages
	                       });
	                   }
	               });
	               kendo.drawing.drawDOM(clone, options)
	                   .always(function(){
	                       cont.remove();
	                   })
	                   .then(function(group){
	                       result.resolve(group);
	                   })
	                   .fail(function(err){
	                       result.reject(err);
	                   });
	           }

	           function renderPage() {
	               var pageNum = dataSource.page();
	               var totalPages = allPages ? dataSource.totalPages() : 1;
	               body.append(origBody.children("tr:not(.k-detail-row)"));
	               if (pageNum < totalPages) {
	                   dataSource.page(pageNum + 1);
	               } else {
	                   dataSource.unbind("change", renderPage);
	                   resolve();
	               }
	           }

	           if (allPages) {
	               dataSource.bind("change", renderPage);
	               dataSource.page(1);
	           } else {
	               renderPage();
	           }

	           return result.promise();
	       };

	       Grid.prototype._drawPDF = function(progress) {
	           var grid = this;

	           if (grid.options.pdf.paperSize && grid.options.pdf.paperSize != "auto") {
	               return grid._drawPDF_autoPageBreak(progress);
	           }

	           var result = new $.Deferred();
	           var dataSource = grid.dataSource;
	           var allPages = grid.options.pdf.allPages;

	           this._initPDFProgress(progress);

	           // This group will be our document containing all pages
	           var doc = new kendo.drawing.Group();
	           var startingPage = dataSource.page();

	           function resolve() {
	               if (allPages && startingPage !== undefined) {
	                   dataSource.unbind("change", exportPage);
	                   dataSource.one("change", function() {
	                       result.resolve(doc);
	                   });

	                   dataSource.page(startingPage);
	               } else {
	                   result.resolve(doc);
	               }
	           }

	           function exportPage() {
	                grid._drawPDFShadow({
	                    width: grid.wrapper.width()
	                }, {
	                    avoidLinks: grid.options.pdf.avoidLinks
	                })
	                .done(function(group) {
	                    var pageNum = dataSource.page();
	                    var totalPages = allPages ? dataSource.totalPages() : 1;

	                    var args = {
	                        page: group,
	                        pageNumber: pageNum,
	                        progress: pageNum / totalPages,
	                        totalPages: totalPages
	                    };

	                    progress.notify(args);
	                    doc.append(args.page);

	                    if (pageNum < totalPages) {
	                        dataSource.page(pageNum + 1);
	                    } else {
	                        resolve();
	                    }
	                })
	                .fail(function(err) {
	                    result.reject(err);
	                });
	            }

	            if (allPages) {
	                dataSource.bind("change", exportPage);
	                dataSource.page(1);
	            } else {
	                exportPage();
	            }

	            return result.promise();
	        };

	        Grid.prototype._initPDFProgress = function(deferred) {
	           var loading = $("<div class='k-loading-pdf-mask'><div class='k-loading-color'></div></div>");
	           loading.prepend(this.wrapper.clone().css({
	               position: "absolute", top: 0, left: 0
	           }));

	           this.wrapper.append(loading);

	           var pb = $("<div class='k-loading-pdf-progress'>")
	           .appendTo(loading)
	           .kendoProgressBar({
	               type: "chunk",
	               chunkCount: 10,
	               min: 0,
	               max: 1,
	               value: 0
	           }).data("kendoProgressBar");

	           deferred.progress(function(e) {
	               pb.value(e.progress);
	           })
	           .always(function() {
	               kendo.destroy(loading);
	               loading.remove();
	           });
	        };
	   }

	   function syncTableHeight(table1, table2) {
	       table1 = table1[0];
	       table2 = table2[0];

	       if (table1.rows.length !== table2.rows.length) {
	           var lockedHeigth = table1.offsetHeight;
	           var tableHeigth = table2.offsetHeight;

	           var row;
	           var diff;
	           if (lockedHeigth > tableHeigth) {
	               row = table2.rows[table2.rows.length - 1];

	               if (filterRowRegExp.test(row.className)) {
	                   row = table2.rows[table2.rows.length - 2];
	               }

	               diff = lockedHeigth - tableHeigth;
	           } else {
	               row = table1.rows[table1.rows.length - 1];

	               if (filterRowRegExp.test(row.className)) {
	                   row = table1.rows[table1.rows.length - 2];
	               }

	               diff = tableHeigth - lockedHeigth;
	           }
	           row.style.height = row.offsetHeight + diff + "px";
	       }
	   }

	   function adjustRowHeight(row1, row2) {
	       var height;
	       var offsetHeight1 = row1.offsetHeight;
	       var offsetHeight2 = row2.offsetHeight;

	       if (offsetHeight1 > offsetHeight2) {
	           height = offsetHeight1 + "px";
	       } else if (offsetHeight1 < offsetHeight2) {
	           height = offsetHeight2 + "px";
	       }

	       if (height) {
	           row1.style.height = row2.style.height = height;
	       }
	   }

	   function getCommand(commands, name) {
	       var idx, length, command;

	       if (typeof commands === STRING && commands === name) {
	          return commands;
	       }

	       if (isPlainObject(commands) && commands.name === name) {
	           return commands;
	       }

	       if (isArray(commands)) {
	           for (idx = 0, length = commands.length; idx < length; idx++) {
	               command = commands[idx];

	               if ((typeof command === STRING && command === name) || (command.name === name)) {
	                   return command;
	               }
	           }
	       }
	       return null;
	   }

	   function focusTable(table, direct) {
	      if (direct === true) {
	         table = $(table);
	         var scrollLeft = kendo.scrollLeft(table.parent());

	         kendo.focusElement(table);
	         kendo.scrollLeft(table.parent(), scrollLeft);
	      } else {
	         $(table).one("focusin", function(e) { e.preventDefault(); }).focus();
	      }
	   }

	   function isColumnGroupable(grid, column) {
	       return grid.options.groupable && (column.groupable || column.groupable === undefined);
	   }

	   function isGroupedBy(groups, field) {
	       return !!$.grep(groups, function (item) {
	           return item.field === field;
	       }).length;
	   }

	   function isColumnEditable(column, model) {
	       if(!column.field || column.selectable) {
	           return false;
	       }
	       if(model.editable && !model.editable(column.field)) {
	           return false;
	       }
	       if(column.editable && !column.editable(model)) {
	           return false;
	       }
	       return true;
	   }

	   function isInputElement(element) {
	       return $(element).is(":button,a,:input,a>.k-icon,textarea,span.k-select,span.k-icon,span.k-link,label.k-checkbox-label,.k-input,.k-multiselect-wrap,.k-picker-wrap,.k-picker-wrap>.k-selected-color,.k-tool-icon,.k-dropdown");
	   }

	   function tableClick(e) {
	       var currentTarget = $(e.currentTarget),
	           isHeader = currentTarget.is("th"),
	           table = this.table.add(this.lockedTable),
	           headerTable = this.thead.parent().add($(">table", this.lockedHeader)),
	           isInput = isInputElement(e.target),
	           preventScroll = $(e.target).is('.k-checkbox'),
	           target = $(e.target),
	           currentTable = currentTarget.closest("table")[0];

	       if (isInput && currentTarget.find(kendo.roleSelector("filtercell")).length) {
	           this._setCurrent(currentTarget);
	           return;
	       }

	       if (currentTable !== table[0] && currentTable !== table[1] && currentTable !== headerTable[0] && currentTable !== headerTable[1]) {
	           return;
	       }

	       if (target.is("a.k-i-expand, a.k-i-collapse")) {
	           return;
	       }

	       if (this.options.navigatable) {
	           this._setCurrent(currentTarget, false, preventScroll);
	       }

	       if (isHeader || !isInput) {
	        setTimeout(function() {
	              //Do not focus if widget, because in IE8 a DDL will be closed
	              if (!(isIE8 && $(kendo._activeElement()).hasClass("k-widget"))) {
	                  //Only if input element is not selected yet and it is not descendant of the grid's table
	                  if ($(kendo._activeElement()).is(CHECKBOXINPUT) || !isInputElement(kendo._activeElement()) || !$.contains(currentTable, kendo._activeElement())) {
	                      //DOMElement.focus() only for header, because IE doesn't really focus the table
	                      focusTable(currentTable, true);
	                  }
	               }
	            });
	       }

	       if (isHeader && !kendo.support.touch) {
	           e.preventDefault(); //if any problem occurs, call preventDefault only for the clicked header links
	       }
	   }

	   function leftMostPosition(element, rtl) {
	       if (!rtl) {
	           return 0;
	       }

	       var result = 0;

	       if (kendo.support.browser.webkit) {
	           result = element.width();
	       }

	       return result;
	   }

	   function parseVirtualSettings(options) {
	        var asLowerString;

	        if (typeof options === "string") {
	            asLowerString = options.toLowerCase();
	            if (asLowerString === "true") {
	                return {
	                    rows: true
	                };
	            } else {
	                return {
	                    rows: asLowerString.indexOf("rows") > -1,
	                    columns: asLowerString.indexOf("columns") > -1
	                };
	            }

	        } else if (options === true) {
	            return {
	                rows: true
	            };
	        }
	   }

	   function isElementVisibleInWrapper(wrapper, element) {
	       var offsetTop;
	       var halfHeight;

	       if (!wrapper) {
	         return false;
	       }

	       element = $(element);

	       if (element[0] && contains(wrapper[0], element[0])) {
	           offsetTop = element.offset().top - wrapper.offset().top;
	           halfHeight = element.outerHeight() / 2;

	           if ((offsetTop >= 0 || math.abs(offsetTop) <= halfHeight) && (math.floor(offsetTop + halfHeight) <= wrapper.height())) {
	               return true;
	           }
	       }

	       return false;
	   }

	   function isInEdit(cell) {
	       return cell &&
	           (cell.hasClass("k-edit-cell") ||
	            cell.parent().hasClass("k-grid-edit-row"));
	   }

	   function groupCellBuilder(headerTemplateIndex) {
	    return '<td colspan="#=data.colspan +'+ headerTemplateIndex + '#">' +
	    '<p class="k-reset">' +
	    '<a class="k-icon k-i-collapse" href="\\#" tabindex="-1" ' +
	    ARIALABEL + '="' + COLLAPSE +
	    '"></a>#=data.text#' +
	    '</p></td>';
	   }

	   function groupCellLockedContentBuilder(headerTemplateIndex) {
	    return '<td colspan="'+ headerTemplateIndex + '">' +
	    '<p class="k-reset">&nbsp;</p></td>';
	   }

	   function groupRowBuilder(colspan, level, text, expanded, uid, includeAdditionalData) {
	    return '<tr role="row"' + (includeAdditionalData ? 'data-group-uid="' + uid + '"' : '') + 'class="k-grouping-row">' + groupCells(level) +
	        '<td colspan="' + colspan + '" aria-expanded="' + !!expanded + '">' +
	        '<p class="k-reset">' +
	        '<a class="k-icon '+ (expanded ? 'k-i-collapse' : 'k-i-expand') + '" href="#" tabindex="-1" ' + ARIALABEL + '="' + (expanded ? COLLAPSE : EXPAND) + '"></a>' + text +
	    '</p></td></tr>';
	   }

	   function groupRowLockedContentBuilder(colspan) {
	    return '<tr role="row" class="k-grouping-row">' +
	        '<td colspan="' + colspan + '" aria-expanded="true">' +
	        '<p class="k-reset">&nbsp;</p></td></tr>';
	   }

	   function toggleRow(row, visible) {
	       row = $(row)[0];
	       if (visible) {
	           row.style.display = "";
	       } else {
	           row.style.display = "none";
	       }
	   }

	   function htmlEncode(value, backslashEscapeQuotes) {
	       var ampRegExp = /&/g,
	           ltRegExp = /</g,
	           quoteRegExp = /"/g,
	           aposRegExp = /'/g,
	           gtRegExp = />/g;

	       return ("" + value)
	           .replace(ampRegExp, "&amp;")
	           .replace(ltRegExp, "&lt;")
	           .replace(gtRegExp, "&gt;")
	           .replace(quoteRegExp, function (match) {
	               if (backslashEscapeQuotes) {
	                   return "\\" + match;
	               }
	               return "&quot;";
	           })
	           .replace(aposRegExp, "&#39;");
	   }

	   ui.plugin(Grid);
	   ui.plugin(VirtualScrollable);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1048)))

/***/ }),

/***/ 1268:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("H/kR");

/***/ }),

/***/ 1269:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7Y4C");

/***/ }),

/***/ 1270:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("4Nap");

/***/ }),

/***/ 1271:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CHw0");

/***/ }),

/***/ 1272:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nAZz");

/***/ }),

/***/ 1273:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MiQa");

/***/ }),

/***/ 1274:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("tHOz");

/***/ }),

/***/ 1275:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("mxBz");

/***/ }),

/***/ 1276:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7IF8");

/***/ }),

/***/ 1277:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("SDgz");

/***/ })

/******/ });

/***/ }),

/***/ "k5uU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = __webpack_require__("U9Xd");
var utils_1 = __webpack_require__("IRr6");
var context_1 = __webpack_require__("RQ1/");
var context_2 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var EventService = (function () {
    function EventService() {
        this.allSyncListeners = {};
        this.allAsyncListeners = {};
        this.globalSyncListeners = [];
        this.globalAsyncListeners = [];
        this.asyncFunctionsQueue = [];
        this.scheduled = false;
    }
    EventService_1 = EventService;
    // because this class is used both inside the context and outside the context, we do not
    // use autowired attributes, as that would be confusing, as sometimes the attributes
    // would be wired, and sometimes not.
    //
    // the global event servers used by ag-Grid is autowired by the context once, and this
    // setBeans method gets called once.
    //
    // the times when this class is used outside of the context (eg RowNode has an instance of this
    // class) then it is not a bean, and this setBeans method is not called.
    EventService.prototype.setBeans = function (loggerFactory, gridOptionsWrapper, globalEventListener) {
        if (globalEventListener === void 0) { globalEventListener = null; }
        this.logger = loggerFactory.create('EventService');
        if (globalEventListener) {
            var async = gridOptionsWrapper.useAsyncEvents();
            this.addGlobalListener(globalEventListener, async);
        }
    };
    EventService.prototype.getListenerList = function (eventType, async) {
        var listenerMap = async ? this.allAsyncListeners : this.allSyncListeners;
        var listenerList = listenerMap[eventType];
        if (!listenerList) {
            listenerList = [];
            listenerMap[eventType] = listenerList;
        }
        return listenerList;
    };
    EventService.prototype.addEventListener = function (eventType, listener, async) {
        if (async === void 0) { async = false; }
        if (!this.assertNotDeprecated(eventType))
            return;
        var listenerList = this.getListenerList(eventType, async);
        if (listenerList.indexOf(listener) < 0) {
            listenerList.push(listener);
        }
    };
    EventService.prototype.assertNotDeprecated = function (eventType) {
        if (eventType === 'floatingRowDataChanged') {
            console.warn('ag-Grid: floatingRowDataChanged is now called pinnedRowDataChanged');
            return false;
        }
        else {
            return true;
        }
    };
    // for some events, it's important that the model gets to hear about them before the view,
    // as the model may need to update before the view works on the info. if you register
    // via this method, you get notified before the view parts
    EventService.prototype.addModalPriorityEventListener = function (eventType, listener, async) {
        if (async === void 0) { async = false; }
        if (!this.assertNotDeprecated(eventType))
            return;
        this.addEventListener(eventType + EventService_1.PRIORITY, listener, async);
    };
    EventService.prototype.addGlobalListener = function (listener, async) {
        if (async === void 0) { async = false; }
        if (async) {
            this.globalAsyncListeners.push(listener);
        }
        else {
            this.globalSyncListeners.push(listener);
        }
    };
    EventService.prototype.removeEventListener = function (eventType, listener, async) {
        if (async === void 0) { async = false; }
        var listenerList = this.getListenerList(eventType, async);
        utils_1.Utils.removeFromArray(listenerList, listener);
    };
    EventService.prototype.removeGlobalListener = function (listener, async) {
        if (async === void 0) { async = false; }
        if (async) {
            utils_1.Utils.removeFromArray(this.globalAsyncListeners, listener);
        }
        else {
            utils_1.Utils.removeFromArray(this.globalSyncListeners, listener);
        }
    };
    // why do we pass the type here? the type is in ColumnChangeEvent, so unless the
    // type is not in other types of events???
    EventService.prototype.dispatchEvent = function (event) {
        // console.log(`dispatching ${eventType}: ${event}`);
        this.dispatchToListeners(event, true);
        this.dispatchToListeners(event, false);
    };
    EventService.prototype.dispatchToListeners = function (event, async) {
        var _this = this;
        var globalListeners = async ? this.globalAsyncListeners : this.globalSyncListeners;
        var eventType = event.type;
        // this allows the columnController to get events before anyone else
        var p1ListenerList = this.getListenerList(eventType + EventService_1.PRIORITY, async);
        utils_1.Utils.forEachSnapshotFirst(p1ListenerList, function (listener) {
            if (async) {
                _this.dispatchAsync(function () { return listener(event); });
            }
            else {
                listener(event);
            }
        });
        var listenerList = this.getListenerList(eventType, async);
        utils_1.Utils.forEachSnapshotFirst(listenerList, function (listener) {
            if (async) {
                _this.dispatchAsync(function () { return listener(event); });
            }
            else {
                listener(event);
            }
        });
        utils_1.Utils.forEachSnapshotFirst(globalListeners, function (listener) {
            if (async) {
                _this.dispatchAsync(function () { return listener(eventType, event); });
            }
            else {
                listener(eventType, event);
            }
        });
    };
    // this gets called inside the grid's thread, for each event that it
    // wants to set async. the grid then batches the events into one setTimeout()
    // because setTimeout() is an expensive operation. ideally we would have
    // each event in it's own setTimeout(), but we batch for performance.
    EventService.prototype.dispatchAsync = function (func) {
        // add to the queue for executing later in the next VM turn
        this.asyncFunctionsQueue.push(func);
        // check if timeout is already scheduled. the first time the grid calls
        // this within it's thread turn, this should be false, so it will schedule
        // the 'flush queue' method the first time it comes here. then the flag is
        // set to 'true' so it will know it's already scheduled for subsequent calls.
        if (!this.scheduled) {
            // if not scheduled, schedule one
            setTimeout(this.flushAsyncQueue.bind(this), 0);
            // mark that it is scheduled
            this.scheduled = true;
        }
    };
    // this happens in the next VM turn only, and empties the queue of events
    EventService.prototype.flushAsyncQueue = function () {
        this.scheduled = false;
        // we take a copy, because the event listener could be using
        // the grid, which would cause more events, which would be potentially
        // added to the queue, so safe to take a copy, the new events will
        // get executed in a later VM turn rather than risk updating the
        // queue as we are flushing it.
        var queueCopy = this.asyncFunctionsQueue.slice();
        this.asyncFunctionsQueue = [];
        // execute the queue
        queueCopy.forEach(function (func) { return func(); });
    };
    // this is an old idea niall had, should really take it out, was to do with ordering who gets to process
    // events first, to give model and service objects preference over the view
    EventService.PRIORITY = '-P1';
    __decorate([
        __param(0, context_2.Qualifier('loggerFactory')),
        __param(1, context_2.Qualifier('gridOptionsWrapper')),
        __param(2, context_2.Qualifier('globalEventListener')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [logger_1.LoggerFactory,
            gridOptionsWrapper_1.GridOptionsWrapper,
            Function]),
        __metadata("design:returntype", void 0)
    ], EventService.prototype, "setBeans", null);
    EventService = EventService_1 = __decorate([
        context_1.Bean('eventService')
    ], EventService);
    return EventService;
    var EventService_1;
}());
exports.EventService = EventService;


/***/ }),

/***/ "kF9J":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1607);
	module.exports = __webpack_require__(1607);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1607:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var $ = kendo.jQuery;

	    var CLASS_NAMES = {
	        input: "k-spreadsheet-name-editor",
	        list: "k-spreadsheet-name-list"
	    };

	    var NameEditor = kendo.ui.Widget.extend({
	        init: function(element, options) {
	            kendo.ui.Widget.call(this, element, options);
	            element.addClass(CLASS_NAMES.input);

	            var comboBoxTitle = options.messages.nameBox || "Name Box";
	            var dataSource = new kendo.data.DataSource({
	                transport: {
	                    read: function(options) {
	                        var data = [];
	                        this._workbook.forEachName(function(def){
	                            if (!def.hidden && def.value instanceof kendo.spreadsheet.Ref) {
	                                data.push({ name: def.name });
	                            }
	                        });
	                        options.success(data);
	                    }.bind(this),
	                    cache: false
	                }
	            });

	            var comboElement = $("<input />")
	                .attr("title", comboBoxTitle)
	                .attr("aria-label", comboBoxTitle);

	            this.combo = comboElement.appendTo(element)
	                .kendoComboBox({
	                    clearButton: false,
	                    dataTextField: "name",
	                    dataValueField: "name",
	                    template: "#:data.name#<a role='button' class='k-button-delete' href='\\#'><span class='k-icon k-i-close'></span></a>",
	                    dataSource: dataSource,
	                    autoBind: false,
	                    ignoreCase: true,
	                    change: this._on_listChange.bind(this),
	                    noDataTemplate: "<div></div>",
	                    open: function() {
	                        dataSource.read();
	                    }
	                }).getKendoComboBox();

	            this.combo.input
	                .on("keydown", this._on_keyDown.bind(this))
	                .on("focus", this._on_focus.bind(this));

	            this.combo.popup.element
	                .addClass("k-spreadsheet-names-popup")

	                .on("mousemove", function(ev){
	                    // XXX: should remove this when we find a better
	                    // solution for the popup closing as we hover the
	                    // resize handles.
	                    ev.stopPropagation();
	                })

	                .on("click", ".k-button-delete", function(ev){
	                    ev.preventDefault();
	                    ev.stopPropagation();
	                    var item = $(ev.target).closest(".k-item");
	                    item = this.combo.dataItem(item);
	                    this._deleteItem(item.name);
	                }.bind(this));
	        },
	        value: function(val) {
	            if (val === undefined) {
	                return this.combo.value();
	            } else {
	                this.combo.value(val);
	            }
	        },
	        _deleteItem: function(name) {
	            this.trigger("delete", { name: name });
	        },
	        _on_keyDown: function(ev) {
	            switch (ev.keyCode) {
	              case 27:
	                this.combo.value(this._prevValue);
	                this.trigger("cancel");
	                break;
	              case 13:
	                this.trigger("enter");
	                break;
	            }
	        },
	        _on_focus: function() {
	            this._prevValue = this.combo.value();
	        },
	        _on_listChange: function() {
	            var name = this.combo.value();
	            if (name) {
	                this.trigger("select", { name: name });
	            }
	        }
	    });

	    kendo.spreadsheet.NameEditor = NameEditor;
	})(window.kendo);
	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "kL5d":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1032);
	module.exports = __webpack_require__(1032);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 956:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ed5Q");

/***/ }),

/***/ 1032:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1033), __webpack_require__(956)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {

	    var kendo = window.kendo,
	        ui = kendo.ui,
	        Observable = kendo.Observable,
	        extend = $.extend,
	        proxy = $.proxy,
	        keys = kendo.keys,

	        NAVIGATE = "navigate",
	        SELECT = "select",
	        EXPAND = "expand",
	        CHANGE = "change",
	        OPEN = "open",
	        LOAD = "load",
	        KEYDOWN = "keydown",
	        KEYDOWNACTION = "keydownAction",

	        NS = ".kendoFileManagerViewComponent",

	        fileManagerDraggables = [],
	        fileManagerDragOrigin = null;

	    var registerViewComponent = function(componentName, component) {
	        ui.filemanager.ViewComponents[componentName] = component;
	    };

	    var getViewComponent = function(componentName) {
	        return ui.filemanager.ViewComponents[componentName] || null;
	    };

	    var Component = Observable.extend({
	        init: function(widget, element, options) {
	            var that = this;

	            that.element = element;
	            that.options = options;

	            if(widget) {
	                that.widgetComponent = new widget(element, options);
	            } else {
	                throw new Error("The widget for the ViewComponent is not available! Please add the corresponding scripts!");
	            }

	            Observable.fn.init.call(that);
	        },

	        _bindEvents: function(){
	            this.widgetComponent.bind("dataBinding", proxy(this._binding, this));
	            this.widgetComponent.bind("dataBound", proxy(this._bound, this));
	        },

	        _binding: function(ev){
	            if(this.trigger("dataBinding", ev)) {
	                ev.preventDefault();
	            }
	        },

	        _bound: function(){
	            this.trigger("dataBound");
	        },

	        _setDSOptions: function (options, dataSourceOptions) {
	            if(!options.dataSource && dataSourceOptions) {
	                options.dataSource = dataSourceOptions;
	            }
	        },

	        _initDragAndDrop: function (element, filter) {
	            var that = this;

	            filter = filter || that.options.dropFilter;
	            element = element || that.element;

	            that.draggable = element.kendoDraggable({
	                filter: filter,
	                hint: proxy(that._hint, that),
	                cursorOffset: { top: -10, left: -50 },
	                holdToDrag: true,
	                ignore: "input, .k-focusable",
	                hold: proxy(that._hold, that)
	            }).data("kendoDraggable");

	            that.draggable.userEvents.minHold = 150;

	            that.droptarget = element.kendoDropTargetArea({
	                filter: filter,
	                drop: proxy(that._onDrop, that),
	                dragenter: function(ev){
	                    ev.dropTarget.addClass("k-filemanager-drop-target");
	                },
	                dragleave: function(ev){
	                    ev.dropTarget.removeClass("k-filemanager-drop-target");
	                }
	            }).data("kendoDraggable");
	        },

	        _hold: function (ev){
	            var that = this,
	                target = ev.currentTarget;

	            if(!target.is(".k-state-selected")) {
	                if(that.widgetComponent.selectable) {
	                    that.widgetComponent.selectable.clear();
	                }
	                that.widgetComponent.select(target);
	            }

	            if(that.widgetComponent.selectable) {
	                that.widgetComponent.selectable.userEvents.cancel();
	            }
	        },

	        _hint: function(target){
	            var that = this,
	                item = that.widgetComponent.dataItem(target),
	                selectedItems = that.widgetComponent.select();

	            fileManagerDragOrigin = that.widgetComponent;
	            fileManagerDraggables = selectedItems;

	            if(selectedItems.length > 1) {
	                return kendo.format("<div class='k-filemanager-drag-hint'><span class='k-icon k-i-{0}'></span> <span>{1} {2}</span></div>", "file", selectedItems.length, that.options.messages.items);
	            }

	            return kendo.format("<div class='k-filemanager-drag-hint'><span class='k-icon k-i-{0}'></span> <span>{1}</span></div>", (item.isDirectory ? "folder" : "file"), item.name);
	        },

	        _onDrop: function (ev){
	            var that = this,
	                target = that.widgetComponent.dataItem(ev.dropTarget),
	                targetId = target.id,
	                itemIds = [];

	            if(!target.isDirectory) {
	                return;
	            }

	            for (var i = 0; i < fileManagerDraggables.length; i++) {
	                var id = fileManagerDragOrigin.dataItem(fileManagerDraggables[i]).id;
	                itemIds.push(id);
	            }

	            this.trigger("drop",{target: targetId, items: itemIds});
	        },

	        getSelected: function(){
	            throw new Error("Not Implemented!");
	        },

	        refresh: function (dataSource) {
	            this.widgetComponent.setDataSource(dataSource);
	        },

	        destroy: function() {
	            kendo.destroy(this.element);
	        }
	    });

	    extend(kendo.ui.filemanager, {
	            ViewComponent: Component,
	            ViewComponents: {},
	            registerViewComponent: registerViewComponent,
	            getViewComponent: getViewComponent
	        }
	    );

	    var ListView = Component.extend({
	        init: function(element, options, explicitOptions) {
	            var that = this,
	                dataSourceOptions = explicitOptions.dataSource,
	                messages = explicitOptions.messages; // jshint ignore:line

	            options = extend({}, that.defaultOptions, options, {
	                messages: messages
	            });

	            that._setDSOptions(options, dataSourceOptions);
	            options.kendoKeydown = options.kendoKeydown || proxy(that._kendoKeydown , that);

	            Component.fn.init.call(this, ui.ListView, element, options);

	            that.listView = that.widgetComponent;
	            that._bindEvents();

	            if(explicitOptions.draggable !== false && !dataSourceOptions.isLocalBinding) {
	                that._initDragAndDrop();
	            }
	        },

	        defaultOptions: {
	            layout: "flex",
	            flex: {
	                direction: "row",
	                wrap: "wrap"
	            },
	            selectable: kendo.support.mobileOS ? "row" : "multiple",
	            template: "<div class='k-listview-item' title='#:name##:extension#'>" +
	                            "<div class='k-file-preview'><span class='k-file-icon k-icon k-i-#= !isDirectory ? kendo.getFileGroup(extension, true) : 'folder' #'></span></div>" +
	                            "<div class='k-file-name file-name'>#:name##:extension#</div>" +
	                      "</div>",
	            editTemplate: "<div class='k-listview-item'>" +
	                                "<div class='k-file-preview'><span class='k-file-icon k-icon k-i-#= !isDirectory ? kendo.getFileGroup(extension, true) : 'folder' #'></span></div>" +
	                                "<div class='k-file-name'><input type='text' class='k-textbox' data-bind='value:name' name='name' required='required' /></div>" +
	                          "</div>",
	            dropFilter: ".k-listview-item",
	            navigatable: true
	        },

	        _bindEvents: function (){
	            var that = this,
	                listView = that.listView;

	            listView.bind(CHANGE, proxy(that._select, that));
	            listView.element.on("dblclick" + NS, proxy(that._dblClick, that));
	            listView.element.on("mousedown" + NS, ".k-listview-item:not(.k-edit-item)", proxy(that._mousedown, that));
	            listView.element.on(KEYDOWN + NS, ".k-edit-item", proxy(that._keydown, that));
	            listView.element.on(KEYDOWN + NS, proxy(that._keydownAction, that));

	            listView.bind("edit", function(ev){
	                var sender = ev.sender;
	                var input = ev.item.find("input");

	                input.on("blur", function(){
	                    var isDirty = sender._modelFromElement(sender.editable.element).dirty;
	                    sender._closeEditable();
	                    if(!isDirty) {
	                        that.trigger("cancel");
	                    }
	                });
	            });

	            listView.bind("cancel", function(){
	                that.trigger("cancel");
	            });

	            Component.fn._bindEvents.call(this);
	        },

	        _select: function () {
	            var that = this,
	                dataItems = that.getSelected();

	            that.trigger(SELECT, {entries: dataItems});
	        },

	        _keydown: function(ev){
	            var that = this;
	            if (ev.keyCode === kendo.keys.ESC) {
	                that.listView._closeEditable();
	                that.trigger("cancel");
	            }
	        },

	        _keydownAction: function(ev) {
	            var that = this,
	                target = $(ev.target).find(".k-state-focused");

	            if(target.length && !target.is(".k-edit-item")) {
	                that.trigger(KEYDOWNACTION, { target: target, keyCode: ev.keyCode });
	            }
	        },

	        _mousedown: function(ev){
	            var that = this,
	                node = $(ev.target).closest(".k-listview-item");

	            if(ev.which === 3 && !node.is(".k-state-selected")) {
	                that.listView.selectable.clear();
	                that.listView.select(node);
	            }
	        },

	        _kendoKeydown : function (ev) {
	            var that = this;

	            if(ev.keyCode === keys.ENTER && !ev.preventKendoKeydown){
	                that._handleEnterKey(ev);
	            }
	        },

	        _handleEnterKey: function(ev){
	            var that = this,
	                target = $(ev.target),
	                node = that.listView.current();

	            if (that.widgetComponent.editable && target.is("input")) {
	                // Force blur to update item and close editable (cross browser)
	                target.trigger("blur");
	            } else if(!that.widgetComponent.editable) {
	                that._triggerOpen(node);
	            }

	            ev.preventKendoKeydown = true;
	        },

	        _dblClick: function(ev){
	            var that = this,
	                node = $(ev.target).closest(".k-listview-item");

	            that._triggerOpen(node);
	        },

	        _triggerOpen: function (node){
	            var that = this;

	            if(node.is(".k-edit-item")) {
	                return;
	            }

	            var item = that.listView.dataItem(node);

	            if(item) {
	                that.trigger(OPEN, { entry: item });
	            }
	        },

	        addFolder: function () {
	            this.listView.add();
	        },

	        edit: function (target) {
	            var that = this,
	                selected = that.listView.select();

	            that.listView.edit(target || selected);
	        },

	        getSelected: function(){
	            var that = this,
	            items = that.listView.select(),
	            dataItems = [];

	            for (var i = 0; i < items.length; i++) {
	                var item = that.listView.dataItem(items[i]);

	                if (item) {
	                    dataItems.push(item);
	                }
	            }

	            return dataItems;
	        },

	        destroy: function() {
	            this.listView.element.off(NS);
	            Component.fn.destroy.call(this);
	        }
	    });

	    ui.filemanager.registerViewComponent("list", ListView);

	    var TreeView = Component.extend({
	        init: function(element, options, explicitOptions) {
	            var that = this,
	                messages = explicitOptions.messages; // jshint ignore:line

	            options = extend({}, that.defaultOptions, options, {
	                messages: messages
	            });

	            Component.fn.init.call(this, ui.TreeView, element, options);

	            that.treeView = that.widgetComponent;
	            that._bindEvents();

	            if(explicitOptions.draggable !== false && !explicitOptions.isLocalBinding) {
	                that._initDragAndDrop();
	            }
	        },

	        defaultOptions: {
	            dataTextField: "name",
	            dropFilter: ".k-item"
	        },

	        _refreshDataSource: function(ev){
	            var that = this,
	                treeView = that.treeView,
	                action = ev.action,
	                node = ev.node,
	                parentNode = null,
	                items = ev.items.filter(function(item){
	                    return item.isDirectory;
	                }).map(function(item){
	                    return extend({}, item.toJSON(), {
	                        id: item.id || kendo.guid(),
	                        hasChildren: item.hasChildren,
	                        items: []
	                    });
	                });

	            if (node) {
	                parentNode = treeView.findByUid(treeView.dataSource.get(node.id).uid);
	                treeView._progress(parentNode, false);
	            }

	            if(!items.length) {
	                return;
	            }

	            if (action == "itemloaded" || (parentNode && action === "sync")) {
	                parentNode.find(".k-item").each(function(index, item){
	                    treeView.remove(item);
	                });
	                treeView.append(items, parentNode);

	                if (that._shouldFocus) {
	                    treeView.current(parentNode);
	                    treeView.focus();
	                }
	            } else if (action == "remove") {
	                this._remove(items[0].id);
	            } else if (action == "itemchange") {
	                var existingItem = treeView.dataSource.get(items[0].id);

	                if(existingItem) {
	                    existingItem.set(ev.field, items[0][ev.field]);
	                } else {
	                    treeView.append(items[0], parentNode);
	                }
	            } else if (!treeView.dataSource.data().length) {
	                treeView.append(items);
	            } else if (action === "sync" || (action === undefined && !parentNode)) {
	                treeView.items().each(function(index, item){
	                    treeView.remove(item);
	                });
	                treeView.append(items);

	                if (that._shouldFocus) {
	                    treeView.current(treeView._nextVisible($()));
	                    treeView.focus();
	                }
	            }

	        },

	        _remove: function(id){
	            var that = this,
	                treeView = that.treeView,
	                dataSource = treeView.dataSource,
	                item = dataSource.get(id),
	                node;

	            if(item) {
	                node = treeView.findByUid(item.uid);
	                treeView.remove(node);
	            }
	        },

	        _bindEvents: function () {
	            var that = this;

	            that.treeView.bind(SELECT, proxy(that._navigate, that));
	            that.treeView.bind(EXPAND, proxy(that._expand, that));
	            that.treeView.element.bind(KEYDOWN, proxy(that._keydownAction, that));
	        },

	        _keydownAction: function (ev) {
	            var that = this,
	                target = $(ev.target).find(".k-state-focused").closest(".k-item");

	            that.trigger(KEYDOWNACTION, { target: target, keyCode: ev.keyCode });
	        },

	        _expand: function (ev) {
	            var that = this,
	                treeView = that.treeView,
	                entry = treeView.dataItem(ev.node);

	            ev.preventDefault();
	            that.trigger(LOAD, { entryId: entry.id });
	        },

	        _navigate: function (ev) {
	            var that= this,
	                node = ev.node,
	                entry = that.treeView.dataItem(node),
	                path = entry.id;

	            ev.preventDefault();

	            that.trigger(NAVIGATE, {path: path, entry: entry.toJSON()});
	        },

	        _hold: $.noop,

	        getSelected: function () {
	            var that = this,
	                selectedItem = that.treeView.element.find(".k-state-selected").closest(".k-item"),
	                item = that.treeView.dataItem(selectedItem);

	            return item;
	        },

	        refresh: function (id) {
	            var that = this,
	                treeView = that.treeView,
	                entry = treeView.dataSource.get(id),
	                node = entry && treeView.findByUid(entry.uid);

	            if(entry && node) {
	                treeView.element.find(".k-state-selected").removeClass("k-state-selected");
	                node.find("> div .k-in").removeClass("k-state-hover").addClass("k-state-selected");
	            }
	        },

	        reload: function () {
	            this.treeView.dataSource.read();
	        }
	    });

	    ui.filemanager.registerViewComponent("tree", TreeView);

	    if(kendo.ui.Grid) {
	        var Grid = Component.extend({
	            init: function(element, options, explicitOptions) {
	                var that = this,
	                    dataSourceOptions = explicitOptions.dataSource,
	                    messages = explicitOptions.messages;

	                options = extend({}, that.defaultOptions, options, {
	                    messages: messages
	                });

	                that._setDSOptions(options, dataSourceOptions);
	                that._setupColumns(options, messages);
	                options.kendoKeydown = options.kendoKeydown || proxy(that._kendoKeydown , that);

	                Component.fn.init.call(this, ui.Grid, element, options);

	                that.grid = that.widgetComponent;
	                that._bindEvents();

	                if(explicitOptions.draggable !== false && !dataSourceOptions.isLocalBinding) {
	                    that._initDragAndDrop();
	                }
	            },

	            defaultOptions: {
	                selectable: kendo.support.mobileOS ? "row" : "multiple",
	                editable: {
	                    mode: "inline",
	                    confirmation: false
	                },
	                sortable: true,
	                dropFilter: "tr:not(.k-grid-edit-row)",
	                navigatable: true
	            },

	            _setupColumns: function (options, messages) {
	                if(!options.columns) {
	                    options.columns = [
	                        { field: "name", title: messages.nameField || "Name", template: function(item) {
	                            var icon = !item.isDirectory ? kendo.getFileGroup(item.extension, true) : "folder";

	                            var template = "<div class='file-group-icon'>" +
	                                                "<span class='k-icon k-i-" + icon + "'></span>" +
	                                            "</div>" +
	                                            "<div class='file-name'>" + kendo.htmlEncode(item.name + item.extension) + "<div>";

	                            return template;
	                        }},
	                        { field: "created", title: messages.dateCreatedField , format: "{0:G}" },
	                        { field: "size", title: messages.sizeField, template: function(item){
	                            if(item.size > 0) {
	                                return kendo.getFileSizeMessage(item.size);
	                            } else {
	                                return "";
	                            }
	                        } }
	                    ];
	                }
	            },

	            _bindEvents: function (){
	                var that = this,
	                    grid = that.grid;

	                grid.bind(CHANGE, proxy(that._select, that));
	                grid.table.on("dblclick" + NS, proxy(that._dblClick, that));
	                grid.table.on("mousedown" + NS, "tr:not(.k-grid-edit-row)", proxy(that._mousedown, that));
	                grid.table.on(KEYDOWN + NS, ".k-grid-edit-row", proxy(that._keydown, that));
	                grid.table.on(KEYDOWN + NS, proxy(that._keydownAction, that));

	                grid.bind("edit", function(){
	                    that._toggleFocusable(true);
	                });

	                grid.bind("cancel", function(){
	                    that.trigger("cancel");
	                });

	                grid.saveRow = $.noop;

	                Component.fn._bindEvents.call(this);
	            },

	            _kendoKeydown : function(ev){
	                var that = this,
	                    current = that.grid.current(),
	                    node = current ? current.closest("tr[data-uid]") : null;

	                if(node && ev.keyCode === keys.ENTER && !ev.preventKendoKeydown){
	                    that._triggerOpen(node);
	                    ev.preventKendoKeydown = true;
	                }

	                if(ev.keyCode === keys.F2) {
	                    ev.preventKendoKeydown = true;
	                }
	            },

	            _keydownAction: function(ev) {
	                var that = this,
	                    target = $(ev.target).find(".k-state-focused").closest("tr");

	                if(target.length && !target.is(".k-grid-edit-row")) {
	                    that.trigger(KEYDOWNACTION, { target: target, keyCode: ev.keyCode });
	                }
	            },

	            _keydown: function(ev){
	                var that = this,
	                    grid = that.grid;

	                if (!$(ev.target).closest(".k-grid-edit-row").length) {
	                    return;
	                }

	                if(ev.keyCode === kendo.keys.ENTER) {
	                    setTimeout(function(){
	                        var editorContainer = that.grid._editContainer || $();

	                        // force blur event for inputs
	                        editorContainer.find("input").trigger("blur");

	                        that._closeEditable();
	                    });

	                    that._tryCancel();
	                }

	                if (ev.keyCode === kendo.keys.ESC) {
	                    grid.cancelChanges();
	                    that.trigger("cancel");
	                }
	            },

	            _mousedown: function(ev){
	                var that = this,
	                    node = $(ev.target).closest("tr[data-uid]");

	                if(ev.which === 1 && that.grid.editable) {
	                    setTimeout(function(){
	                        that._closeEditable();
	                    });

	                    that._tryCancel();
	                }

	                if(ev.which === 3 && !node.is(".k-state-selected")) {
	                    that.grid.selectable.clear();
	                    that.grid.select(node);
	                }
	            },

	            _tryCancel: function() {
	                var that = this,
	                    grid = that.grid,
	                    container;

	                if (grid.editable) {
	                    container = grid._editContainer;
	                    if (!container.find("input").val()) {
	                        grid.cancelChanges();
	                    }
	                }

	                setTimeout(function() {
	                    that._toggleFocusable(false);
	                });

	            },

	            _toggleFocusable: function(state) {
	                var that = this,
	                    grid = that.grid;

	                grid.table.find("tr,td").children().addBack().toggleClass("k-focusable", state);
	            },

	            _closeEditable: function(){
	                var that = this,
	                    container;

	                if(that.grid.editable && !that.grid.editable.options.model.dirty){
	                    container = that.grid._editContainer;
	                    that.grid._destroyEditable();
	                    that.grid._displayRow(container);
	                    that.trigger("cancel");
	                }
	            },

	            _select: function () {
	                var that = this,
	                    dataItems = that.getSelected();

	                that.trigger(SELECT, {entries: dataItems});
	            },

	            _dblClick: function(ev){
	                var that = this,
	                    node = $(ev.target).closest("tr[data-uid]");

	                that._triggerOpen(node);
	            },

	            _triggerOpen: function (node) {
	                var that = this;

	                if(node.is(".k-grid-edit-row")) {
	                    return;
	                }

	                var item = that.grid.dataItem(node);

	                if(item) {
	                    that.trigger(OPEN, { entry: item });
	                }
	            },

	            getSelected: function(){
	                var that = this,
	                items = that.grid.select(),
	                dataItems = [];

	                for (var i = 0; i < items.length; i++) {
	                    dataItems.push(that.grid.dataItem(items[i]));
	                }

	                return dataItems;
	            },

	            addFolder: function () {
	                this.grid.addRow();
	            },

	            edit: function (target) {
	                var that = this,
	                    selected = that.grid.select();

	                that.grid.editRow(target || selected);
	            },

	            destroy: function(){
	                this.grid.table.off(NS);
	                this.grid.element.off(NS);
	                Component.fn.destroy.call(this);
	            }
	        });

	        ui.filemanager.registerViewComponent("grid", Grid);
	    }

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1033:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("wIIu");

/***/ })

/******/ });

/***/ }),

/***/ "kM2E":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var core = __webpack_require__("FeBl");
var ctx = __webpack_require__("+ZMJ");
var hide = __webpack_require__("hJx8");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "kPaM":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1376);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1054:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CRfZ");

/***/ }),

/***/ 1170:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("zQRd");

/***/ }),

/***/ 1187:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("99zt");

/***/ }),

/***/ 1243:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("pYWG");

/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1054), __webpack_require__(1170), __webpack_require__(1187),  __webpack_require__(1243) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "scheduler.recurrence",
	    name: "Recurrence",
	    category: "web",
	    depends: [ "dropdownlist", "datepicker", "numerictextbox", "buttongroup" ],
	    hidden: true
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        timezone = kendo.timezone,
	        Class = kendo.Class,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        DropDownList = ui.DropDownList,
	        ButtonGroup = ui.ButtonGroup,
	        kendoDate = kendo.date,
	        setTime = kendoDate.setTime,
	        setDayOfWeek = kendoDate.setDayOfWeek,
	        adjustDST = kendoDate.adjustDST,
	        firstDayOfMonth = kendoDate.firstDayOfMonth,
	        getMilliseconds = kendoDate.getMilliseconds,
	        DAYS_IN_LEAPYEAR = [0,31,60,91,121,152,182,213,244,274,305,335,366],
	        DAYS_IN_YEAR = [0,31,59,90,120,151,181,212,243,273,304,334,365],
	        MONTHS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
	        WEEK_DAYS = {
	            0: "SU",
	            1: "MO",
	            2: "TU",
	            3: "WE",
	            4: "TH",
	            5: "FR",
	            6: "SA"
	        },
	        WEEK_DAYS_IDX = {
	            "SU": 0,
	            "MO": 1,
	            "TU": 2,
	            "WE": 3,
	            "TH": 4,
	            "FR": 5,
	            "SA": 6
	        },
	        DATE_FORMATS = [
	            "yyyy-MM-ddTHH:mm:ss.fffzzz",
	            "yyyy-MM-ddTHH:mm:sszzz",
	            "yyyy-MM-ddTHH:mm:ss",
	            "yyyy-MM-ddTHH:mm",
	            "yyyy-MM-ddTHH",
	            "yyyy-MM-dd",
	            "yyyyMMddTHHmmssfffzzz",
	            "yyyyMMddTHHmmsszzz",
	            "yyyyMMddTHHmmss",
	            "yyyyMMddTHHmm",
	            "yyyyMMddTHH",
	            "yyyyMMdd"
	        ],
	        RULE_NAMES = ["months", "weeks", "yearDays", "monthDays", "weekDays", "hours", "minutes", "seconds"],
	        RULE_NAMES_LENGTH = RULE_NAMES.length,
	        RECURRENCE_DATE_FORMAT = "yyyyMMddTHHmmssZ",
	        limitation = {
	            months: function(date, end, rule) {
	                var monthRules = rule.months,
	                    months = ruleValues(monthRules, date.getMonth() + 1),
	                    changed = false;

	                if (months !== null) {
	                    if (months.length) {
	                        date.setMonth(months[0] - 1, 1);
	                    } else {
	                        date.setFullYear(date.getFullYear() + 1, monthRules[0] - 1, 1);
	                    }

	                    changed = true;
	                }

	                return changed;
	            },

	            monthDays: function(date, end, rule) {
	                var monthLength, month, days,
	                    changed = false,
	                    hours = date.getHours(),
	                    normalize = function(monthDay) {
	                        if (monthDay < 0) {
	                            monthDay = monthLength + monthDay + 1;
	                        }
	                        return monthDay;
	                    };

	                while (date <= end) {
	                    month = date.getMonth();
	                    monthLength = getMonthLength(date);
	                    days = ruleValues(rule.monthDays, date.getDate(), normalize);

	                    if (days === null) {
	                        return changed;
	                    }

	                    changed = true;

	                    if (days.length) {
	                        date.setMonth(month, days.sort(numberSortPredicate)[0]);
	                        adjustDST(date, hours);

	                        if (month === date.getMonth()) {
	                            break;
	                        }
	                    } else {
	                        date.setMonth(month + 1, 1);
	                    }
	                }

	                return changed;
	            },

	            yearDays: function(date, end, rule) {
	                var year, yearDays,
	                    changed = false,
	                    hours = date.getHours(),
	                    normalize = function(yearDay) {
	                        if (yearDay < 0) {
	                            yearDay = year + yearDay;
	                        }
	                        return yearDay;
	                    };

	                while (date < end) {
	                    year = leapYear(date) ? 366 : 365;
	                    yearDays = ruleValues(rule.yearDays, dayInYear(date), normalize);

	                    if (yearDays === null) {
	                        return changed;
	                    }

	                    changed = true;
	                    year = date.getFullYear();

	                    if (yearDays.length) {
	                        date.setFullYear(year, 0, yearDays.sort(numberSortPredicate)[0]);
	                        adjustDST(date, hours);
	                        break;
	                    } else {
	                        date.setFullYear(year + 1, 0, 1);
	                    }
	                }

	                return changed;
	            },

	            weeks: function(date, end, rule) {
	                var weekStart = rule.weekStart,
	                    year, weeks, day,
	                    changed = false,
	                    hours = date.getHours(),
	                    normalize = function(week) {
	                        if (week < 0) {
	                            week = 53 + week;
	                        }
	                        return week;
	                    };

	                while (date < end) {
	                    weeks = ruleValues(rule.weeks, weekInYear(date, weekStart), normalize);

	                    if (weeks === null) {
	                        return changed;
	                    }

	                    changed = true;
	                    year = date.getFullYear();

	                    if (weeks.length) {
	                        day = (weeks.sort(numberSortPredicate)[0] * 7) - 1;

	                        date.setFullYear(year, 0, day);
	                        setDayOfWeek(date, weekStart, -1);

	                        adjustDST(date, hours);
	                        break;
	                    } else {
	                        date.setFullYear(year + 1, 0, 1);
	                    }
	                }

	                return changed;
	            },

	            weekDays: function(date, end, rule) {
	                var offsetDate = new Date(date.getTime() + rule.offsets.start);
	                var normalizeDay = offsetDate.getDay() - date.getDay();
	                var weekDays = rule.weekDays;
	                var weekStart = rule.weekStart;
	                var weekDayRules = ruleWeekValues(weekDays, offsetDate, weekStart);
	                var hours = date.getHours();
	                var traverseRuleForNextMont = function(rule) {
	                    var nextMonthFirstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
	                    var ruleDay = normalizeDayIndex(rule.day, weekStart);

	                    if(nextMonthFirstDay.getDay() <= ruleDay) {
	                        if(!weekDayRule || normalizeDayIndex(weekDayRule.day, weekStart) > ruleDay) {
	                            weekDayRule = rule;
	                        }
	                    }
	                };
	                var weekDayRule, day;


	                if (weekDayRules === null) {
	                    return false;
	                }

	                weekDayRule = weekDayRules[0];

	                if (!weekDayRule) {
	                    if(rule.freq === "monthly" && !rule.positions || rule.position > 0) {
	                        weekDays.forEach(traverseRuleForNextMont);
	                    }
	                    if (!weekDayRule) {
	                        weekDayRule = weekDays[0];
	                    }
	                    setDayOfWeek(date, weekStart);
	                }

	                day = weekDayRule.day;
	                day -= normalizeDay;

	                if (weekDayRule.offset) {
	                    while (date <= end && !isInWeek(date, weekDayRule, weekStart)) {
	                        if (weekInMonth(date, weekStart) === numberOfWeeks(date, weekStart)) {
	                            date.setMonth(date.getMonth() + 1, 1);
	                            adjustDST(date, hours);
	                        } else {
	                            date.setDate(date.getDate() + 7);
	                            adjustDST(date, hours);

	                            setDayOfWeek(date, weekStart, -1);
	                        }
	                    }
	                }

	                if (date.getDay() !== day) {
	                    setDayOfWeek(date, day);
	                }

	                return true;
	            },

	            hours: function(date, end, rule) {
	                var hourRules = rule.hours,
	                    startTime = rule._startTime,
	                    startHours = startTime.getHours(),
	                    hours = ruleValues(hourRules, startHours),
	                    changed = false;

	                if (hours !== null) {
	                    changed = true;

	                    date.setHours(startHours);
	                    adjustDST(date, startHours);

	                    if (hours.length) {
	                        hours = hours[0];
	                        date.setHours(hours);
	                    } else {
	                        hours = date.getHours();
	                        date.setDate(date.getDate() + 1);
	                        adjustDST(date, hours);

	                        hours = hourRules[0];
	                        date.setHours(hours);
	                        adjustDST(date, hours);
	                    }

	                    if (rule.minutes) {
	                        date.setMinutes(0);
	                    }

	                    startTime.setHours(hours, date.getMinutes());
	                }

	                return changed;
	            },

	            minutes: function(date, end, rule) {
	                var minuteRules = rule.minutes,
	                    currentMinutes = date.getMinutes(),
	                    minutes = ruleValues(minuteRules, currentMinutes),
	                    hours = rule._startTime.getHours(),
	                    changed = false;

	                if (minutes !== null) {
	                    changed = true;

	                    if (minutes.length) {
	                        minutes = minutes[0];
	                    } else {
	                        hours += 1;
	                        minutes = minuteRules[0];
	                    }

	                    if (rule.seconds) {
	                        date.setSeconds(0);
	                    }

	                    date.setHours(hours, minutes);

	                    hours = hours % 24;
	                    adjustDST(date, hours);
	                    rule._startTime.setHours(hours, minutes, date.getSeconds());
	                }

	                return changed;
	            },

	            seconds: function(date, end, rule) {
	                var secondRules = rule.seconds,
	                    hours = rule._startTime.getHours(),
	                    seconds = ruleValues(secondRules, date.getSeconds()),
	                    minutes = date.getMinutes(),
	                    changed = false;

	                if (seconds !== null) {
	                    changed = true;

	                    if (seconds.length) {
	                        date.setSeconds(seconds[0]);
	                    } else {
	                        minutes += 1;
	                        date.setMinutes(minutes, secondRules[0]);

	                        if (minutes > 59) {
	                            minutes = minutes % 60;
	                            hours = (hours + 1) % 24;
	                        }
	                    }

	                    rule._startTime.setHours(hours, minutes, date.getSeconds());
	                }

	                return changed;
	            }
	        },
	        BaseFrequency = Class.extend({
	            next: function(date, rule) {
	                var startTime = rule._startTime,
	                    day = startTime.getDate(),
	                    minutes, seconds;

	                if (rule.seconds) {
	                    seconds = date.getSeconds() + 1;

	                    date.setSeconds(seconds);
	                    startTime.setSeconds(seconds);
	                    startTime.setDate(day);

	                } else if (rule.minutes) {
	                    minutes = date.getMinutes() + 1;

	                    date.setMinutes(minutes);
	                    startTime.setMinutes(minutes);
	                    startTime.setDate(day);
	                } else {
	                    return false;
	                }

	                return true;
	            },

	            normalize: function(options) {
	                var rule = options.rule;

	                if (options.idx === 4 && rule.hours) {
	                    rule._startTime.setHours(0);
	                    this._hour(options.date, rule);
	                }
	            },

	            limit: function(date, end, rule) {
	                var interval = rule.interval,
	                    ruleName, firstRule,
	                    modified,
	                    idx, day;

	                while (date <= end) {
	                    modified = firstRule = undefined;
	                    day = date.getDate();

	                    for (idx = 0; idx < RULE_NAMES_LENGTH; idx++) {
	                        ruleName = RULE_NAMES[idx];

	                        if (rule[ruleName]) {
	                            modified = limitation[ruleName](date, end, rule);
	                            if (firstRule !== undefined && modified) {
	                                break;
	                            } else {
	                                firstRule = modified;
	                            }
	                        }

	                        if (modified) {
	                            this.normalize({ date: date, rule: rule, day: day, idx: idx });
	                        }
	                    }

	                    if ((interval === 1 || !this.interval(rule, date)) && idx === RULE_NAMES_LENGTH) {
	                        break;
	                    }
	                }
	            },

	            interval: function (rule, current) {
	                var start = new Date(rule._startPeriod);
	                var date = new Date(current);
	                var hours = current.getHours();
	                var weekStart = rule.weekStart;
	                var interval = rule.interval;
	                var frequency = rule.freq;
	                var modified = false;
	                var excess = 0;
	                var month = 0;
	                var day = 1;
	                var diff;

	                var startTimeHours;

	                if (frequency === "hourly") {
	                    diff = date.getTimezoneOffset() - start.getTimezoneOffset();
	                    startTimeHours = rule._startTime.getHours();

	                    date = date.getTime();
	                    if (hours !== startTimeHours) {
	                        date += (startTimeHours - hours) * kendoDate.MS_PER_HOUR;
	                    }
	                    date -= start;

	                    if (diff) {
	                        date -= diff * kendoDate.MS_PER_MINUTE;
	                    }

	                    diff = Math.floor(date / kendoDate.MS_PER_HOUR);
	                    excess = intervalExcess(diff, interval);

	                    if (excess !== 0) {
	                        this._hour(current, rule, excess);
	                        modified = true;
	                    }
	                } else if (frequency === "daily") {
	                    kendoDate.setTime(date, -start, true);

	                    diff = Math.round(date / kendoDate.MS_PER_DAY);
	                    excess = intervalExcess(diff, interval);

	                    if (excess !== 0) {
	                        this._date(current, rule, excess);
	                        modified = true;
	                    }

	                } else if (frequency === "weekly") {
	                    excess = this._getNumberOfWeeksBetweenDates(start, current);

	                    var normalizedCurrentIndex = normalizeDayIndex(current.getDay(), weekStart);
	                    var normalizedStartIndex = normalizeDayIndex(start.getDay(), weekStart);

	                    if (normalizedCurrentIndex < normalizedStartIndex) {
	                        excess += 1;
	                    }

	                    excess = intervalExcess(excess, interval);
	                    if (excess !== 0) {
	                        kendoDate.setDayOfWeek(current, rule.weekStart, -1);

	                        current.setDate(current.getDate() + (excess * 7));
	                        adjustDST(current, hours);

	                        modified = true;
	                    }
	                } else if (frequency === "monthly") {
	                    diff = current.getFullYear() - start.getFullYear();
	                    diff = current.getMonth() - start.getMonth() + (diff * 12);

	                    excess = intervalExcess(diff, interval);

	                    if (excess !== 0) {
	                        day = rule._hasRuleValue ? 1 : current.getDate();

	                        current.setFullYear(current.getFullYear(), current.getMonth() + excess, day);
	                        adjustDST(current, hours);

	                        modified = true;
	                    }
	                } else if (frequency === "yearly") {
	                    diff = current.getFullYear() - start.getFullYear();
	                    excess = intervalExcess(diff, interval);

	                    if (!rule.months) {
	                        month = current.getMonth();
	                    }

	                    if (!rule.yearDays && !rule.monthDays && !rule.weekDays) {
	                        day = current.getDate();
	                    }

	                    if (excess !== 0) {
	                        current.setFullYear(current.getFullYear() + excess, month, day);
	                        adjustDST(current, hours);

	                        modified = true;
	                    }
	                }

	                return modified;
	            },

	            _getNumberOfWeeksBetweenDates: function(first, second){
	                 var weeks = (second - first) / 604800000;
	                 var exactWeeks = Math.floor(weeks);

	                //this is happening when weeks pass DST change
	                if (weeks - exactWeeks > 0.99) {
	                    exactWeeks = Math.round(weeks);
	                }
	                return exactWeeks;
	            },

	            _hour: function(date, rule, interval) {
	                var startTime = rule._startTime,
	                    hours = startTime.getHours();

	                if (interval) {
	                    hours += interval;
	                }

	                date.setHours(hours);

	                hours = hours % 24;
	                startTime.setHours(hours);
	                adjustDST(date, hours);
	            },

	            _date: function(date, rule, interval) {
	                var hours = date.getHours();

	                date.setDate(date.getDate() + interval);
	                if (!adjustDST(date, hours)) {
	                    this._hour(date, rule);
	                }
	            }
	        }),
	        HourlyFrequency = BaseFrequency.extend({
	            next: function(date, rule) {
	                if (!BaseFrequency.fn.next(date, rule)) {
	                    this._hour(date, rule, 1);
	                }
	            },

	            normalize: function(options) {
	                var rule = options.rule;

	                if (options.idx === 4) {
	                    rule._startTime.setHours(0);
	                    this._hour(options.date, rule);
	                }
	            }
	        }),
	        DailyFrequency = BaseFrequency.extend({
	            next: function(date, rule) {
	                if (!BaseFrequency.fn.next(date, rule)) {
	                    this[rule.hours ? "_hour" : "_date"](date, rule, 1);
	                }
	            }
	        }),
	        WeeklyFrequency = DailyFrequency.extend({
	            setup: function(rule, eventStartDate) {
	                if (!rule.weekDays) {
	                    rule.weekDays = [{
	                        day: eventStartDate.getDay(),
	                        offset: 0
	                    }];
	                }
	            }
	        }),
	        MonthlyFrequency = BaseFrequency.extend({
	            next: function(date, rule) {
	                var day, hours;
	                if (!BaseFrequency.fn.next(date, rule)) {
	                    if (rule.hours) {
	                        this._hour(date, rule, 1);
	                    } else if (rule.monthDays || rule.weekDays || rule.yearDays || rule.weeks) {
	                        this._date(date, rule, 1);
	                    } else {
	                        day = date.getDate();
	                        hours = date.getHours();

	                        date.setMonth(date.getMonth() + 1);
	                        adjustDST(date, hours);

	                        while(date.getDate() !== day) {
	                            date.setDate(day);
	                            adjustDST(date, hours);
	                        }

	                        this._hour(date, rule);
	                    }
	                }
	            },
	            normalize: function(options) {
	                var rule = options.rule,
	                    date = options.date,
	                    hours = date.getHours();

	                if (options.idx === 0 && !rule.monthDays && !rule.weekDays) {
	                    date.setDate(options.day);
	                    adjustDST(date, hours);
	                } else {
	                    BaseFrequency.fn.normalize(options);
	                }
	            },
	            setup: function(rule, eventStartDate, date) {
	                if (!rule.monthDays && !rule.weekDays) {
	                    date.setDate(eventStartDate.getDate());
	                }
	            }
	        }),
	        YearlyFrequency = MonthlyFrequency.extend({
	            next: function(date, rule) {
	                var day,
	                    hours = date.getHours();

	                if (!BaseFrequency.fn.next(date, rule)) {
	                    if (rule.hours) {
	                        this._hour(date, rule, 1);
	                    } else if (rule.monthDays || rule.weekDays || rule.yearDays || rule.weeks) {
	                        this._date(date, rule, 1);
	                    } else if (rule.months) {
	                        day = date.getDate();

	                        date.setMonth(date.getMonth() + 1);
	                        adjustDST(date, hours);

	                        while(date.getDate() !== day) {
	                            date.setDate(day);
	                            adjustDST(date, hours);
	                        }

	                        this._hour(date, rule);
	                    } else {
	                        date.setFullYear(date.getFullYear() + 1);
	                        adjustDST(date, hours);

	                        this._hour(date, rule);
	                    }
	                }
	            },
	            setup: function() {}
	        }),
	        frequencies = {
	            "hourly" : new HourlyFrequency(),
	            "daily" : new DailyFrequency(),
	            "weekly" : new WeeklyFrequency(),
	            "monthly" : new MonthlyFrequency(),
	            "yearly" : new YearlyFrequency()
	        },
	        CLICK = "click",
	        CHANGE = "change";

	    function intervalExcess(diff, interval) {
	        var excess;
	        if (diff !== 0 && diff < interval) {
	            excess = interval - diff;
	        } else {
	            excess = diff % interval;
	            if (excess) {
	                excess = interval - excess;
	            }
	        }

	        return excess;
	    }

	    function dayInYear(date) {
	        var month = date.getMonth();
	        var days = leapYear(date) ? DAYS_IN_LEAPYEAR[month] : DAYS_IN_YEAR[month];

	        return days + date.getDate();
	    }

	    function weekInYear(date, weekStart){
	        var year, days;

	        date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	        adjustDST(date, 0);

	        year = date.getFullYear();

	        if (weekStart !== undefined) {
	            setDayOfWeek(date, weekStart, -1);
	            date.setDate(date.getDate() + 4);
	        } else {
	            date.setDate(date.getDate() + (4 - (date.getDay() || 7)));
	        }

	        adjustDST(date, 0);
	        days = Math.floor((date.getTime() - new Date(year, 0, 1, -6)) / 86400000);

	        return 1 + Math.floor(days / 7);
	    }

	    function weekInMonth(date, weekStart) {
	        var firstWeekDay = firstDayOfMonth(date).getDay();
	        var firstWeekLength = 7 - (firstWeekDay + 7 - (weekStart || 7)) || 7;

	        if (firstWeekLength < 0) {
	            firstWeekLength += 7;
	        }

	        return Math.ceil((date.getDate() - firstWeekLength) / 7) + 1;
	    }

	    function normalizeDayIndex(weekDay, weekStart) {
	        return weekDay + (weekDay < weekStart ? 7 : 0);
	    }

	    function normalizeOffset(date, rule, weekStart) {
	        var offset = rule.offset;

	        if (!offset) {
	            return weekInMonth(date, weekStart);
	        }

	        var lastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
	        var weeksInMonth = weekInMonth(lastDate, weekStart);

	        var day = normalizeDayIndex(rule.day, weekStart);

	        var skipFirst = day < normalizeDayIndex(new Date(date.getFullYear(), date.getMonth(), 1).getDay(), weekStart);
	        var skipLast = day > normalizeDayIndex(lastDate.getDay(), weekStart);

	        if (offset < 0) {
	            offset = weeksInMonth + (offset + 1 - (skipLast ? 1 : 0));
	        } else if (skipFirst) {
	            offset += 1;
	        }

	        weeksInMonth -= (skipLast ? 1 : 0);

	        if (offset < (skipFirst ? 1 : 0) || offset > weeksInMonth) {
	            return null;
	        }

	        return offset;
	    }

	    function numberOfWeeks(date, weekStart) {
	        return weekInMonth(new Date(date.getFullYear(), date.getMonth() + 1, 0), weekStart);
	    }

	    function isInWeek(date, rule, weekStart) {
	        return weekInMonth(date, weekStart) === normalizeOffset(date, rule, weekStart);
	    }

	    function ruleWeekValues(weekDays, date, weekStart) {
	        var currentDay = normalizeDayIndex(date.getDay(), weekStart);
	        var length = weekDays.length;
	        var ruleWeekOffset;
	        var weekDay, day;
	        var weekNumber;
	        var result = [];
	        var idx = 0;

	        for (;idx < length; idx++) {
	            weekDay = weekDays[idx];

	            weekNumber = weekInMonth(date, weekStart);
	            ruleWeekOffset = normalizeOffset(date, weekDay, weekStart);

	            if (ruleWeekOffset === null) {
	                continue;
	            }

	            if (weekNumber < ruleWeekOffset) {
	                result.push(weekDay);
	            } else if (weekNumber === ruleWeekOffset) {
	                day = normalizeDayIndex(weekDay.day, weekStart);

	                if (currentDay < day) {
	                    result.push(weekDay);
	                } else if (currentDay === day) {
	                    return null;
	                }
	            }
	        }

	        return result;
	    }

	    function ruleValues(rules, value, normalize) {
	        var idx = 0,
	            length = rules.length,
	            availableRules = [],
	            ruleValue;

	        for (; idx < length; idx++) {
	            ruleValue = rules[idx];

	            if (normalize) {
	                ruleValue = normalize(ruleValue);
	            }

	            if (value === ruleValue) {
	                return null;
	            }  else if (value < ruleValue) {
	                availableRules.push(ruleValue);
	            }
	        }

	        return availableRules;
	    }

	    function parseArray(list, range) {
	        var idx = 0,
	            length = list.length,
	            value;

	        for (; idx < length; idx++) {
	            value = parseInt(list[idx], 10);
	            if (isNaN(value) || value < range.start || value > range.end || (value === 0 && range.start < 0)) {
	                return null;
	            }

	            list[idx] = value;
	        }

	        return list.sort(numberSortPredicate);
	    }

	    function parseWeekDayList(list) {
	        var idx = 0, length = list.length,
	            value, valueLength, day;

	        for (; idx < length; idx++) {
	            value = list[idx];
	            valueLength = value.length;
	            day = value.substring(valueLength - 2).toUpperCase();

	            day = WEEK_DAYS_IDX[day];
	            if (day === undefined) {
	                return null;
	            }

	            list[idx] = {
	                offset: parseInt(value.substring(0, valueLength - 2), 10) || 0,
	                day: day
	            };
	        }
	        return list;
	    }

	    function serializeWeekDayList(list) {
	        var idx = 0, length = list.length,
	            value, valueString, result = [];

	        for (; idx < length; idx++) {
	            value = list[idx];
	            if (typeof value === "string") {
	                valueString = value;
	            } else {
	                valueString = "" + WEEK_DAYS[value.day];

	                if (value.offset) {
	                    valueString = value.offset + valueString;
	                }
	            }

	            result.push(valueString);
	        }
	        return result.toString();
	    }

	    function getMonthLength(date) {
	        var month = date.getMonth();

	        if (month === 1) {
	            if (new Date(date.getFullYear(), 1, 29).getMonth() === 1) {
	                return 29;
	            }
	            return 28;
	        }
	        return MONTHS[month];
	    }

	    function leapYear(year) {
	        year = year.getFullYear();
	        return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
	    }

	    function numberSortPredicate(a, b) {
	        return a - b;
	    }

	    function parseExceptions(exceptions, zone) {
	        var idx = 0, length, date,
	            dates = [];

	        if (exceptions) {
	            exceptions = exceptions.split(exceptions.indexOf(";") !== -1 ? ";" : ",");
	            length = exceptions.length;

	            for (; idx < length; idx++) {
	                date = parseUTCDate(exceptions[idx], zone);

	                if (date) {
	                    dates.push(date);
	                }
	            }
	        }

	        return dates;
	    }

	    function isException(exceptions, date, zone) {
	        var dates = $.isArray(exceptions) ? exceptions : parseExceptions(exceptions, zone),
	            dateTime = date.getTime() - date.getMilliseconds(),
	            idx = 0, length = dates.length;

	        for (; idx < length; idx++) {
	            if (dates[idx].getTime() === dateTime) {
	                return true;
	            }
	        }

	        return false;
	    }

	    function toExceptionString(dates, zone) {
	        var idx = 0;
	        var length;
	        var date;
	        var result = [].concat(dates);

	        for (length = result.length; idx < length; idx++) {
	            date = result[idx];
	            date = kendo.timezone.convert(date, zone || date.getTimezoneOffset(), "Etc/UTC");
	            result[idx] = kendo.toString(date, RECURRENCE_DATE_FORMAT);
	        }

	        return result.join(",");
	    }

	    function startPeriodByFreq(start, rule) {
	        var date = new Date(start);

	        switch (rule.freq) {
	            case "yearly":
	                date.setFullYear(date.getFullYear(), 0, 1);
	                break;

	            case "monthly":
	                date.setFullYear(date.getFullYear(), date.getMonth(), 1);
	                break;

	            case "weekly":
	                setDayOfWeek(date, rule.weekStart, -1);
	                break;

	            default:
	                break;
	        }

	        if (rule.hours) {
	            date.setHours(0);
	        }

	        if (rule.minutes) {
	            date.setMinutes(0);
	        }

	        if (rule.seconds) {
	            date.setSeconds(0);
	        }

	        return date;
	    }

	    function endPeriodByFreq(start, rule) {
	        var date = new Date(start);

	        switch (rule.freq) {
	            case "yearly":
	                date.setFullYear(date.getFullYear(), 11, 31);
	                break;

	            case "monthly":
	                date.setFullYear(date.getFullYear(), date.getMonth() + 1, 0);
	                break;

	            case "weekly":
	                setDayOfWeek(date, rule.weekStart, -1);
	                date.setDate(date.getDate() + 6);
	                break;

	            default:
	                break;
	        }

	        if (rule.hours) {
	            date.setHours(23);
	        }

	        if (rule.minutes) {
	            date.setMinutes(59);
	        }

	        if (rule.seconds) {
	            date.setSeconds(59);
	        }

	        return date;
	    }

	    function eventsByPosition(periodEvents, start, positions, until) {
	        var periodEventsLength = periodEvents.length;
	        var events = [];
	        var position;
	        var event;
	        var inPeriod;

	        for (var idx = 0, length = positions.length; idx < length; idx++) {
	            position = positions[idx];

	            if (position < 0) {
	                position = periodEventsLength + position;
	            } else {
	                position -= 1; //convert to zero based index
	            }

	            event = periodEvents[position];
	            inPeriod = until ? event.start < until : true;

	            if (event && event.start >= start && inPeriod) {
	                events.push(event);
	            }
	        }

	        return events;
	    }

	    function removeExceptionDates(periodEvents, exceptionDates, zone) {
	        var events = [];
	        var event;

	        for (var idx = 0; idx < periodEvents.length; idx++) {
	            event = periodEvents[idx];
	            if (!isException(exceptionDates, event.start, zone)) {
	                events.push(event);
	            }
	        }

	        return events;
	    }

	    function expand(event, start, end, zone) {
	        var rule,
	            startTime, endTime, endDate,
	            hours, minutes, seconds,
	            durationMS, startPeriod, inPeriod,
	            ruleStart, ruleEnd,
	            useEventStart, freqName,
	            exceptionDates,
	            eventStartTime,
	            eventStartMS,
	            eventStart,
	            count, freq,
	            positions,
	            currentIdx,
	            periodEvents,
	            events = [],
	            shiftedStart,
	            shiftedEnd,
	            shiftedStartTime,
	            shifterEndTime;

	        rule = parseRule(event.recurrenceRule, zone, { // offsets argument
	            start: (getZoneOffset(event.start, zone) - getZoneOffset(event.start, event.startTimezone)) * kendo.date.MS_PER_MINUTE,
	            end: (getZoneOffset(event.end, zone) - getZoneOffset(event.end, event.endTimezone)) * kendo.date.MS_PER_MINUTE
	        });

	        if (!rule) {
	            return [event];
	        }

	        positions = rule.positions;
	        currentIdx = positions ? 0 : 1;

	        ruleStart = rule.start;
	        ruleEnd = rule.end;

	        if (ruleStart || ruleEnd) {
	            event = event.clone({
	                start: ruleStart ? new Date(ruleStart.value[0]) : undefined,
	                end: ruleEnd ? new Date(ruleEnd.value[0]) : undefined
	            });
	        }

	        eventStart = event.start;
	        eventStartMS = eventStart.getTime();
	        eventStartTime = getMilliseconds(eventStart);

	        exceptionDates = parseExceptions(event.recurrenceException, zone);

	        if (!exceptionDates[0] && rule.exdates) {
	            exceptionDates = rule.exdates.value;
	            event.set("recurrenceException", toExceptionString(exceptionDates, zone));
	        }

	        startPeriod = start = new Date(start);
	        end = new Date(end);

	        freqName = rule.freq;
	        freq = frequencies[freqName];
	        count = rule.count;

	        if (rule.until && rule.until < end) {
	            end = new Date(rule.until);
	        }

	        useEventStart = freqName === "yearly" || freqName === "monthly" || freqName === "weekly";

	        if (start < eventStartMS || count || rule.interval > 1 || useEventStart ||
	             ((freqName === "daily" || freqName === "hourly") && !rule.seconds)) {
	                    start = new Date(eventStartMS);
	        } else {
	            hours = start.getHours();
	            minutes = start.getMinutes();
	            seconds = start.getSeconds();

	            if (!rule.hours) {
	                hours = eventStart.getHours();
	            }

	            if (!rule.minutes) {
	                minutes = eventStart.getMinutes();
	            }

	            if (!rule.seconds) {
	                seconds = eventStart.getSeconds();
	            }

	            start.setHours(hours, minutes, seconds, eventStart.getMilliseconds());
	        }

	        rule._startPeriod = new Date(start);

	        if (positions) {
	            start = startPeriodByFreq(start, rule);
	            end = endPeriodByFreq(end, rule);

	            var diff = getMilliseconds(end) - getMilliseconds(start);
	            if (diff < 0) {
	                hours = start.getHours();
	                end.setHours(hours, start.getMinutes(), start.getSeconds(), start.getMilliseconds());
	                kendoDate.adjustDST(end, hours);
	            }

	            rule._startPeriod = new Date(start);
	            rule._endPeriod = endPeriodByFreq(start, rule);
	        }

	        durationMS = event.duration();
	        var allDayCompensation = event.isAllDay ? 86400000 : 0;
	        rule._startTime = startTime = kendoDate.toInvariantTime(start);

	        if (freq.setup) {
	            freq.setup(rule, eventStart, start);
	        }

	        freq.limit(start, end, rule);

	        while (start <= end) {
	            endDate = new Date(start);
	            setTime(endDate, durationMS);
	            var inPeriodCheckEndDate = new Date(start);
	            setTime(inPeriodCheckEndDate, durationMS + allDayCompensation);

	            inPeriod = start >= startPeriod || inPeriodCheckEndDate > startPeriod;

	            if (inPeriod && !isException(exceptionDates, start, zone) || positions) {
	                startTime = kendoDate.toUtcTime(kendoDate.getDate(start)) + getMilliseconds(rule._startTime);
	                endTime = startTime + durationMS;

	                if (eventStartMS !== start.getTime() || eventStartTime !== getMilliseconds(rule._startTime)) {
	                    var startZone = event.startTimezone || event.endTimezone;
	                    var endZone = event.endTimezone || event.startTimezone;

	                    if(!event.isAllDay){
	                        if((zone && startZone) || (!zone && !startZone)){
	                            var startOffsetDiff = getZoneOffset(start, zone) - getZoneOffset(event.start, zone);
	                            var endOffsetDiff = getZoneOffset(endDate, zone) - getZoneOffset(event.end, zone);
	                            var startTZOffsetDiff = getZoneOffset(start, startZone) - getZoneOffset(event.start, startZone);
	                            var endTZOffsetDiff = getZoneOffset(endDate, endZone) - getZoneOffset(event.end, endZone);

	                            if(startOffsetDiff !== startTZOffsetDiff){
	                                var offsetTicksStart = (startOffsetDiff - startTZOffsetDiff) * 60000;
	                                shiftedStart = new Date(start.getTime() - offsetTicksStart);
	                                shiftedStartTime = startTime - offsetTicksStart;
	                            }

	                            if(endOffsetDiff !== endTZOffsetDiff){
	                                var offsetTicksEnd = (endOffsetDiff - endTZOffsetDiff) * 60000;
	                                shiftedEnd = new Date(endDate.getTime() - offsetTicksEnd);
	                                shifterEndTime = endTime - offsetTicksEnd;
	                            }
	                        }
	                    }


	                    events.push(event.toOccurrence({
	                        start: shiftedStart || new Date(start),
	                        end: shiftedEnd || endDate,
	                        _startTime: shiftedStartTime || startTime,
	                        _endTime: shifterEndTime || endTime
	                    }));

	                    shiftedStart = shiftedEnd = shiftedStartTime = shifterEndTime = null;
	                } else {
	                    event._startTime = startTime;
	                    event._endTime = endTime;
	                    events.push(event);
	                }
	            }

	            if (positions) {
	                freq.next(start, rule);
	                freq.limit(start, end, rule);

	                if (start > rule._endPeriod) {
	                    periodEvents = eventsByPosition(events.slice(currentIdx), eventStart, positions, rule.until);
	                    periodEvents = removeExceptionDates(periodEvents, exceptionDates, zone);
	                    events = events.slice(0, currentIdx).concat(periodEvents);

	                    rule._endPeriod = endPeriodByFreq(start, rule);

	                    currentIdx = events.length;
	                }

	                if (count && count === currentIdx) {
	                    break;
	                }

	            } else {
	                if (count && count === currentIdx) {
	                    break;
	                }

	                currentIdx += 1;

	                var isMissingDSTHour = isDSTMissingHour(start);
	                freq.next(start, rule);

	                if(isMissingDSTHour && rule.freq!=="hourly" && kendoDate.toInvariantTime(event.start).getTime() !== kendoDate.toInvariantTime(start).getTime()){
	                    rule._startTime = startTime = new Date(start.getTime() - 3600000);
	                }

	                freq.limit(start, end, rule);
	            }
	        }

	        return events;
	    }

	    function isDSTMissingHour(date){
	        var dateOffset = date.getTimezoneOffset();
	        var dateMinusHour = new Date(date.getTime() - 3600000);
	        var dateMinusHourOffset = dateMinusHour.getTimezoneOffset();

	        return dateOffset < dateMinusHourOffset;
	    }

	    function getZoneOffset(date, zone) {
	        return zone ? kendo.timezone.offset(date, zone): date.getTimezoneOffset();
	    }

	    function parseUTCDate(value, zone) {
	        value = kendo.parseDate(value, DATE_FORMATS); //Parse UTC to local time

	        if (value && zone) {
	            value = timezone.apply(value, zone);
	        }

	        return value;
	    }

	    function parseDateRule(dateRule, zone) {
	        var pairs = dateRule.split(";");
	        var pair;
	        var property;
	        var value;
	        var tzid;
	        var valueIdx, valueLength;

	        for (var idx = 0, length = pairs.length; idx < length; idx++) {
	            pair = pairs[idx].split(":");
	            property = pair[0];
	            value = pair[1];

	            if (property.indexOf("TZID") !== -1) {
	                tzid = property.substring(property.indexOf("TZID")).split("=")[1];
	            }

	            if (value) {
	                value = value.split(",");

	                for (valueIdx = 0, valueLength = value.length; valueIdx < valueLength; valueIdx++) {
	                    value[valueIdx] = parseUTCDate(value[valueIdx], tzid || zone);
	                }
	            }
	        }

	        if (value) {
	            return {
	                value: value,
	                tzid: tzid
	            };
	        }
	    }

	    function parseRule(recur, zone, offsets) {
	        var instance = {};
	        var splits, value;
	        var idx = 0, length;
	        var ruleValue = false;
	        var rule, part, parts;
	        var property, weekStart, weekDays;
	        var predicate = function(a, b) {
	            var day1 = a.day,
	                day2 = b.day;

	            if (day1 < weekStart) {
	               day1 += 7;
	            }

	            if (day2 < weekStart) {
	                day2 += 7;
	            }

	            return day1 - day2;
	        };

	        if (!recur) {
	            return null;
	        }

	        parts = recur.split("\n");

	        if (!parts[1] && (recur.indexOf("DTSTART") !== -1 || recur.indexOf("DTEND") !== -1 || recur.indexOf("EXDATE") !== -1)) {
	            parts = recur.split(" ");
	        }

	        for (idx = 0, length = parts.length; idx < length; idx++) {
	            part = kendo.trim(parts[idx]);

	            if (part.indexOf("DTSTART") !== -1) {
	                instance.start = parseDateRule(part, zone);
	            } else if (part.indexOf("DTEND") !== -1) {
	                instance.end = parseDateRule(part, zone);
	            } else if (part.indexOf("EXDATE") !== -1) {
	                instance.exdates = parseDateRule(part, zone);
	            } else if (part.indexOf("RRULE") !== -1) {
	                rule = part.substring(6);
	            } else if (kendo.trim(part)) {
	                rule = part;
	            }
	        }

	        rule = rule.split(";");

	        for (idx = 0, length = rule.length; idx < length; idx++) {
	            property = rule[idx];
	            splits = property.split("=");
	            value = kendo.trim(splits[1]).split(",");

	            switch (kendo.trim(splits[0]).toUpperCase()) {
	                case "FREQ":
	                    instance.freq = value[0].toLowerCase();
	                    break;
	                case "UNTIL":
	                    instance.until = parseUTCDate(value[0], zone);
	                    break;
	                case "COUNT":
	                    instance.count = parseInt(value[0], 10);
	                    break;
	                case "INTERVAL":
	                    instance.interval = parseInt(value[0], 10);
	                    break;
	                case "BYSECOND":
	                    instance.seconds = parseArray(value, { start: 0, end: 60 });
	                    ruleValue = true;
	                    break;
	                case "BYMINUTE":
	                    instance.minutes = parseArray(value, { start: 0, end: 59 });
	                    ruleValue = true;
	                    break;
	                case "BYHOUR":
	                    instance.hours = parseArray(value, { start: 0, end: 23 });
	                    ruleValue = true;
	                    break;
	                case "BYMONTHDAY":
	                    instance.monthDays = parseArray(value, { start: -31, end: 31 });
	                    ruleValue = true;
	                    break;
	                case "BYYEARDAY":
	                    instance.yearDays = parseArray(value, { start: -366, end: 366 });
	                    ruleValue = true;
	                    break;
	                case "BYMONTH":
	                    instance.months = parseArray(value, { start: 1, end: 12 });
	                    ruleValue = true;
	                    break;
	                case "BYDAY":
	                    instance.weekDays = weekDays = parseWeekDayList(value);
	                    ruleValue = true;
	                    break;
	                case "BYWEEKNO":
	                    instance.weeks = parseArray(value, { start: -53, end: 53 });
	                    ruleValue = true;
	                    break;
	                case "BYSETPOS":
	                    instance.positions = parseArray(value, { start: -366, end: 366 });
	                    break;
	                case "WKST":
	                    instance.weekStart = weekStart = WEEK_DAYS_IDX[value[0]];
	                    break;
	            }
	        }

	        if (instance.freq === undefined || (instance.count !== undefined && instance.until)) {
	            return null;
	        }

	        if (!instance.interval) {
	            instance.interval = 1;
	        }

	        if (weekStart === undefined) {
	            instance.weekStart = weekStart = kendo.culture().calendar.firstDay;
	        }

	        if (weekDays) {
	            instance.weekDays = weekDays.sort(predicate);
	        }

	        if (instance.positions && !ruleValue) {
	            instance.positions = null;
	        }

	        instance._hasRuleValue = ruleValue;
	        instance.offsets = offsets;

	        return instance;
	    }

	    function serializeDateRule(dateRule, zone) {
	        var value = dateRule.value;
	        var tzid = dateRule.tzid || "";
	        var length = value.length;
	        var idx = 0;
	        var val;

	        for (; idx < length; idx++) {
	            val = value[idx];
	            val = timezone.convert(val, tzid || zone || val.getTimezoneOffset(), "Etc/UTC");
	            value[idx] = kendo.toString(val, "yyyyMMddTHHmmssZ");
	        }

	        if (tzid) {
	            tzid = ";TZID=" + tzid;
	        }

	        return tzid + ":" + value.join(",") + " ";
	    }

	    function serialize(rule, zone) {
	        var weekStart = rule.weekStart;
	        var ruleString = "FREQ=" + rule.freq.toUpperCase();
	        var exdates = rule.exdates || "";
	        var start = rule.start || "";
	        var end = rule.end || "";
	        var until = rule.until;

	        if (weekStart === undefined) {
	            weekStart = kendo.culture().calendar.firstDay;
	        }

	        if (rule.interval > 1) {
	            ruleString += ";INTERVAL=" + rule.interval;
	        }

	        if (rule.count) {
	            ruleString += ";COUNT=" + rule.count;
	        }

	        if (until) {
	            until = timezone.convert(until, zone || until.getTimezoneOffset(), "Etc/UTC");

	            ruleString += ";UNTIL=" + kendo.toString(until, "yyyyMMddTHHmmssZ");
	        }

	        if (rule.months) {
	            ruleString += ";BYMONTH=" + rule.months;
	        }

	        if (rule.weeks) {
	            ruleString += ";BYWEEKNO=" + rule.weeks;
	        }

	        if (rule.yearDays) {
	            ruleString += ";BYYEARDAY=" + rule.yearDays;
	        }

	        if (rule.monthDays) {
	            ruleString += ";BYMONTHDAY=" + rule.monthDays;
	        }

	        if (rule.weekDays) {
	            ruleString += ";BYDAY=" + serializeWeekDayList(rule.weekDays);
	        }

	        if (rule.hours) {
	            ruleString += ";BYHOUR=" + rule.hours;
	        }

	        if (rule.minutes) {
	            ruleString += ";BYMINUTE=" + rule.minutes;
	        }

	        if (rule.seconds) {
	            ruleString += ";BYSECOND=" + rule.seconds;
	        }

	        if (rule.positions) {
	            ruleString += ";BYSETPOS=" + rule.positions;
	        }

	        if (weekStart !== undefined) {
	            ruleString += ";WKST=" + WEEK_DAYS[weekStart];
	        }

	        if (start) {
	            start = "DTSTART" + serializeDateRule(start, zone);
	        }

	        if (end) {
	            end = "DTEND" + serializeDateRule(end, zone);
	        }

	        if (exdates) {
	            exdates = "EXDATE" + serializeDateRule(exdates, zone);
	        }

	        if (start || end || exdates) {
	            ruleString = start + end + exdates + "RRULE:" + ruleString;
	        }

	        return ruleString;
	    }

	    kendo.recurrence = {
	        rule: {
	            parse: parseRule,
	            serialize: serialize
	        },
	        expand: expand,
	        dayInYear: dayInYear,
	        weekInYear: weekInYear,
	        weekInMonth: weekInMonth,
	        numberOfWeeks: numberOfWeeks,
	        isException: isException,
	        toExceptionString: toExceptionString
	    };

	    var RECURRENCE_VIEW_TEMPLATE = kendo.template(
	       '# if (frequency !== "never") { #' +
	           '<div class="k-edit-label"><label>#:messages.repeatEvery#</label></div>' +
	           '<div class="k-edit-field"><input class="k-recur-interval" title="#:messages.repeatEvery# #:messages.interval#"/>#:messages.interval#</div>' +
	       '# } #' +
	       '# if (frequency === "weekly") { #' +
	           '<div class="k-edit-label"><label>#:messages.repeatOn#</label></div>' +
	           '<div class="k-edit-field"><div class="k-button-group-stretched k-recur-weekday-buttons" title="#:messages.repeatOn#"></div></div>' +
	       '# } else if (frequency === "monthly") { #' +
	           '<div class="k-edit-label"><label>#:messages.repeatOn#</label></div>' +
	           '<div class="k-edit-field">' +
	               '<ul class="k-reset">' +
	                   '<li>' +
	                       '<label class="k-radio-label"><input class="k-recur-month-radio k-radio" type="radio" name="month" value="monthday" title="#:messages.repeatOn#" />#:messages.date#:</label>' +
	                       '<input class="k-recur-monthday" title="#:messages.date#" />' +
	                   '</li>' +
	                   '<li>' +
	                        '<input class="k-recur-month-radio k-radio" type="radio" name="month" value="weekday" title="#:messages.repeatOn# #:messages.day#" />' +
	                        '<input class="k-recur-weekday-offset" title="#:messages.repeatOn#" /><input class="k-recur-weekday" title="#:messages.day#" />' +
	                   '</li>' +
	               '</ul>' +
	           '</div>' +
	       '# } else if (frequency === "yearly") { #' +
	           '<div class="k-edit-label"><label>#:messages.repeatOn#</label></div>' +
	           '<div class="k-edit-field">' +
	               '<ul class="k-reset">' +
	                   '<li>' +
	                       '<input class="k-recur-year-radio k-radio" type="radio" name="year" value="monthday" title="#:messages.repeatOn# #:messages.month#" />' +
	                       '<input class="k-recur-month" title="#:messages.month#" /><input class="k-recur-monthday" title="#:messages.date#" />' +
	                   '</li>' +
	                   '<li>' +
	                       '<input class="k-recur-year-radio k-radio" type="radio" name="year" value="weekday" title="#:messages.repeatOn# #:messages.day#" />' +
	                       '<input class="k-recur-weekday-offset" title="#:messages.repeatOn#" /><input class="k-recur-weekday" title="#:messages.day#"  />#:messages.of#<input class="k-recur-month" title="#:messages.of + messages.month#"/>' +
	                   '</li>' +
	               '</ul>' +
	           '</div>' +
	       '# } #' +
	       '# if (frequency !== "never") { #' +
	           '<div class="k-edit-label"><label>#:end.label#</label></div>' +
	           '<div class="k-edit-field">' +
	               '<ul class="k-reset">' +
	                   '<li>' +
	                       '<label class="k-radio-label"><input class="k-recur-end-never k-radio" type="radio" name="end" value="never" title="#:end.label#" />#:end.never#</label>' +
	                   '</li>' +
	                   '<li>' +
	                       '<label class="k-radio-label"><input class="k-recur-end-count k-radio" type="radio" name="end" value="count" title="#:end.label#" />#:end.after#</label>' +
	                       '<input class="k-recur-count" title="#:end.occurrence#" />#:end.occurrence#' +
	                   '</li>' +
	                   '<li>' +
	                       '<label class="k-radio-label"><input class="k-recur-end-until k-radio" type="radio" name="end" value="until" title="#:end.label#" />#:end.on#</label>' +
	                       '<input class="k-recur-until" title="#:end.on#" name="recur-until" />' +
	                   '</li>' +
	               '</ul>' +
	           '</div>' +
	       '# } #'
	    );

	    var DAY_RULE = [
	        { day: 0, offset: 0 },
	        { day: 1, offset: 0 },
	        { day: 2, offset: 0 },
	        { day: 3, offset: 0 },
	        { day: 4, offset: 0 },
	        { day: 5, offset: 0 },
	        { day: 6, offset: 0 }
	    ];

	    var WEEKDAY_RULE = [
	        { day: 1, offset: 0 },
	        { day: 2, offset: 0 },
	        { day: 3, offset: 0 },
	        { day: 4, offset: 0 },
	        { day: 5, offset: 0 }
	    ];

	    var WEEKEND_RULE = [
	        { day: 0, offset: 0 },
	        { day: 6, offset: 0 }
	    ];

	    var BaseRecurrenceEditor = Widget.extend({
	        init: function(element, options) {
	            var start;
	            var that = this;
	            var frequencies = options && options.frequencies;

	            Widget.fn.init.call(that, element, options);

	            that.wrapper = that.element;

	            options = that.options;
	            options.start = start = options.start || kendoDate.today();

	            if (frequencies) {
	                options.frequencies = frequencies;
	            }

	            if (typeof start === "string") {
	                options.start = kendo.parseDate(start, "yyyyMMddTHHmmss");
	            }

	            if (options.firstWeekDay === null) {
	                options.firstWeekDay = kendo.culture().calendar.firstDay;
	            }

	            that._namespace = "." + options.name;
	        },

	        options: {
	            value: "",
	            start: "",
	            timezone: "",
	            spinners: true,
	            firstWeekDay: null,
	            frequencies: [
	                "never",
	                "daily",
	                "weekly",
	                "monthly",
	                "yearly"
	            ],
	            mobile: false,
	            messages: {
	                repeat: "Repeat",
	                recurrenceEditorTitle:"Recurrence editor",
	                frequencies: {
	                    never: "Never",
	                    hourly: "Hourly",
	                    daily: "Daily",
	                    weekly: "Weekly",
	                    monthly: "Monthly",
	                    yearly: "Yearly"
	                },
	                hourly: {
	                    repeatEvery: "Repeat every: ",
	                    interval: " hour(s)"
	                },
	                daily: {
	                    repeatEvery: "Repeat every: ",
	                    interval: " day(s)"
	                },
	                weekly: {
	                    interval: " week(s)",
	                    repeatEvery: "Repeat every: ",
	                    repeatOn: "Repeat on: "
	                },
	                monthly: {
	                    repeatEvery: "Repeat every: ",
	                    repeatOn: "Repeat on: ",
	                    interval: " month(s)",
	                    day: "Day ",
	                    date: "Date"
	                },
	                yearly: {
	                    repeatEvery: "Repeat every: ",
	                    repeatOn: "Repeat on: ",
	                    interval: " year(s)",
	                    of: " of ",
	                    month: "month",
	                    day: "day",
	                    date: "Date"
	                },
	                end: {
	                    label: "End:",
	                    mobileLabel: "Ends",
	                    never: "Never",
	                    after: "After ",
	                    occurrence: " occurrence(s)",
	                    on: "On "
	                },
	                offsetPositions: {
	                    first: "first",
	                    second: "second",
	                    third: "third",
	                    fourth: "fourth",
	                    last: "last"
	                },
	                weekdays: {
	                    day: "day",
	                    weekday: "weekday",
	                    weekend: "weekend day"
	                }
	            }
	        },

	        events: ["change"],

	        _initInterval: function() {
	            var that = this;
	            var rule = that._value;

	            that._container
	                .find(".k-recur-interval")
	                .kendoNumericTextBox({
	                    spinners: that.options.spinners,
	                    value: rule.interval || 1,
	                    decimals: 0,
	                    format: "#",
	                    min: 1,
	                    change: function() {
	                        rule.interval = this.value();
	                        that._trigger();
	                    }
	                });
	        },

	        _weekDayButtons: function(firstDay) {
	            var that = this,
	                names = kendo.culture().calendar.days.names,
	                abbreviated = kendo.culture().calendar.days.namesAbbr,
	                repeatOn = that.options.messages.weekly.repeatOn,
	                length = names.length,
	                idx = 0,
	                values = [],
	                items = [];

	            for (; idx < length; idx++) {
	                values.push(idx);
	            }

	            names = names.slice(firstDay).concat(names.slice(0, firstDay));
	            abbreviated = abbreviated.slice(firstDay).concat(abbreviated.slice(0, firstDay));
	            values = values.slice(firstDay).concat(values.slice(0, firstDay));

	            for (idx = 0; idx < length; idx++) {
	                items.push({
	                    text: abbreviated[idx],
	                    attributes: {
	                        "data-value": values[idx],
	                        "aria-label":  repeatOn + " " + names[idx]
	                    }
	                });
	            }

	            that._weekDayButtonGroup = new ButtonGroup(that._container.find(".k-recur-weekday-buttons"), {
	                items: items,
	                selection: "multiple",
	                select: function() {
	                    var rule = that._value,
	                        selectedDays = that._weekDayButtonGroup.current();

	                    rule.weekDays = selectedDays.map(function(i, day) {
	                        return {
	                            day: Number(day.getAttribute("data-value")),
	                            offset: 0
	                        };
	                    });

	                    if (!that.options.mobile) {
	                        that._trigger();
	                    }
	                }
	            });
	        },

	        _weekDayRule: function(clear) {
	            var that = this;
	            var weekday = (that._weekDay.element || that._weekDay).val();
	            var offset = Number((that._weekDayOffset.element || that._weekDayOffset).val());
	            var weekDays = null;
	            var positions = null;

	            if (!clear) {
	                if (weekday === "day") {
	                    weekDays = DAY_RULE;
	                    positions = offset;
	                } else if (weekday === "weekday") {
	                    weekDays = WEEKDAY_RULE;
	                    positions = offset;
	                } else if (weekday === "weekend") {
	                    weekDays = WEEKEND_RULE;
	                    positions = offset;
	                } else {
	                    weekDays = [{
	                        offset: offset,
	                        day: Number(weekday)
	                    }];
	                }
	            }

	            that._value.weekDays = weekDays;
	            that._value.positions = positions;
	        },

	        _weekDayView: function() {
	            var that = this;
	            var weekDays = that._value.weekDays;
	            var positions = that._value.positions;
	            var weekDayOffsetWidget = that._weekDayOffset;
	            var weekDayOffset;
	            var weekDayValue;
	            var length;
	            var method;

	            if (weekDays) {
	                length = weekDays.length;

	                if (positions) {
	                    if (length === 7) {
	                        weekDayValue = "day";
	                        weekDayOffset = positions;
	                    } else if (length === 5) {
	                        weekDayValue = "weekday";
	                        weekDayOffset = positions;
	                    } else if (length === 2) {
	                        weekDayValue = "weekend";
	                        weekDayOffset = positions;
	                    }
	                }

	                if (!weekDayValue) {
	                    weekDays = weekDays[0];
	                    weekDayValue = weekDays.day;
	                    weekDayOffset = weekDays.offset || "";
	                }

	                method = weekDayOffsetWidget.value ? "value" : "val";

	                weekDayOffsetWidget[method](weekDayOffset);
	                that._weekDay[method](weekDayValue);
	            }
	        },

	        _initWeekDay: function() {
	            var that = this, data;

	            var weekdayMessage = that.options.messages.weekdays;
	            var offsetMessage = that.options.messages.offsetPositions;

	            var weekDayInput = that._container.find(".k-recur-weekday");

	            var change = function() {
	                that._weekDayRule();
	                that._trigger();
	            };

	            if (weekDayInput[0]) {
	                that._weekDayOffset = new DropDownList(that._container.find(".k-recur-weekday-offset"), {
	                    change: change,
	                    dataTextField: "text",
	                    dataValueField: "value",
	                    dataSource: [
	                        { text: offsetMessage.first, value: "1" },
	                        { text: offsetMessage.second, value: "2" },
	                        { text: offsetMessage.third, value: "3" },
	                        { text: offsetMessage.fourth, value: "4" },
	                        { text: offsetMessage.last, value: "-1" }
	                    ]
	                });

	                data = [
	                    { text: weekdayMessage.day, value: "day" },
	                    { text: weekdayMessage.weekday, value: "weekday" },
	                    { text: weekdayMessage.weekend, value: "weekend" }
	                ];

	                that._weekDay = new DropDownList(weekDayInput, {
	                    value: that.options.start.getDay(),
	                    change: change,
	                    dataTextField: "text",
	                    dataValueField: "value",
	                    dataSource: data.concat($.map(kendo.culture().calendar.days.names, function(dayName, idx) {
	                        return {
	                            text: dayName,
	                            value: idx
	                        };
	                    }))
	                });

	                that._weekDayView();
	            }
	        },

	        _initWeekDays: function() {
	            var that = this;
	            var rule = that._value;
	            var weekDayButtonGroup = that._weekDayButtonGroup;

	            if (weekDayButtonGroup && rule.weekDays && rule.weekDays.length) {
	                var ruleDays = rule.weekDays,
	                    ruleDaysLength = ruleDays.length,
	                    selectors = [],
	                    i = 0,
	                    selectedWeekDayButtons;

	                for (; i < ruleDaysLength; i++) {
	                    selectors.push("[data-value='" + ruleDays[i].day + "']");
	                }

	                selectedWeekDayButtons = weekDayButtonGroup.element.find(selectors.join(","));
	                weekDayButtonGroup.select(selectedWeekDayButtons);
	            }
	        },

	        _initMonthDay: function() {
	            var that = this;
	            var rule = that._value;
	            var monthDayInput = that._container.find(".k-recur-monthday");

	            if (monthDayInput[0]) {
	                that._monthDay = new kendo.ui.NumericTextBox(monthDayInput, {
	                    spinners: that.options.spinners,
	                    min: 1,
	                    max: 31,
	                    decimals: 0,
	                    format: "#",
	                    value: rule.monthDays ? rule.monthDays[0] : that.options.start.getDate(),
	                    change: function() {
	                        var value = this.value();

	                        rule.monthDays = value ? [value] : value;
	                        that._trigger();
	                    }
	                });
	            }
	        },

	        _initCount: function() {
	            var that = this,
	                input = that._container.find(".k-recur-count"),
	                rule = that._value;

	            that._count = input.kendoNumericTextBox({
	                spinners: that.options.spinners,
	                value: rule.count || 1,
	                decimals: 0,
	                format: "#",
	                min: 1,
	                change: function() {
	                    rule.count = this.value();
	                    that._trigger();
	                }
	            }).data("kendoNumericTextBox");
	        },

	        _initUntil: function() {
	            var that = this,
	                input = that._container.find(".k-recur-until"),
	                start = that.options.start,
	                rule = that._value,
	                until = rule.until,
	                min = until && until < start ? until : start,
	                startInput = that.wrapper.closest(".k-scheduler-edit-form").find("[name=start]:visible"),
	                validDateValidationMessage = kendo.format(kendo.ui.Validator.prototype.options.messages.date, that.options.messages.end.on),
	                dateCompareValidationMessage = kendo.ui.Validator.prototype.options.messages.dateCompare,
	                initialValue = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 23, 59, 59);

	            input.attr("data-validDate-msg", validDateValidationMessage);
	            input.attr("data-untilDateCompare-msg", dateCompareValidationMessage);

	            if(startInput.length === 0) {
	                startInput = that.wrapper.closest(".k-scheduler-edit-form").find("[name=start]");
	            }

	            if(startInput.length > 0 && startInput.val()) {
	                min = kendo.parseDate(startInput.val());

	                if(initialValue < min) {
	                    initialValue = min;
	                }
	            }

	            that._until = input.kendoDatePicker({
	                min: min,
	                value: until || initialValue,
	                change: function() {
	                    var date  = this.value();
	                    if(date) {
	                        rule.until =  new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
	                    }
	                    that._trigger();
	                }
	            }).data("kendoDatePicker");

	            if(startInput) {
	                startInput.on("change", function() {
	                    that._until.setOptions({
	                        min: startInput.val()
	                    });
	                });
	            }
	        },

	        _trigger: function() {
	            if (!this.options.mobile) {
	                this.trigger("change");
	            }
	        }
	    });

	    var RecurrenceEditor = BaseRecurrenceEditor.extend({
	        init: function(element, options) {
	            var that = this;

	            BaseRecurrenceEditor.fn.init.call(that, element, options);

	            that._initFrequency();

	            that._initContainer();

	            that.value(that.options.value);
	        },

	        options: {
	            name: "RecurrenceEditor"
	        },

	        events: [ "change" ],

	        destroy: function() {
	            var that = this;

	            that._frequency.destroy();

	            if(this._weekDayButtonGroup) {
	                this._weekDayButtonGroup.destroy();
	            }

	            that._container.find("input[type=radio],input[type=checkbox]").off(CLICK + that._namespace);

	            kendo.destroy(that._container);

	            BaseRecurrenceEditor.fn.destroy.call(that);
	        },

	        value: function(value) {
	            var that = this;
	            var timezone = that.options.timezone;
	            var freq, freqButton;

	            if (value === undefined) {
	                if (!that._value.freq) {
	                    return "";
	                }

	                return serialize(that._value, timezone);
	            }

	            that._value = parseRule(value, timezone) || {};

	            freq = that._value.freq;

	            if (freq) {
	                freqButton = that._frequency.element.find("[data-value='" + freq + "']");
	                that._frequency.select(freqButton);
	            } else {
	                that._frequency.select(0);
	            }

	            that._initView(that._frequency.current().data("value"));
	        },

	        _initContainer: function() {
	            var element = this.element,
	                container = $('<div class="k-recur-view" />'),
	                editContainer = element.parent(".k-edit-field");

	            if (editContainer[0]) {
	                container.insertAfter(editContainer);
	            } else {
	                element.append(container);
	            }

	            this._container = container;
	        },

	        _initFrequency: function() {
	            var that = this,
	                options = that.options,
	                frequencies = options.frequencies,
	                messages = options.messages.frequencies,
	                buttonGroupElement = $('<div class="k-button-group-stretched" />').attr({title: options.messages.recurrenceEditorTitle}),
	                frequency;

	            frequencies = $.map(frequencies, function(frequency) {
	                return {
	                    text: messages[frequency],
	                    attributes: { "data-value": frequency, "aria-label": options.messages.repeat + messages[frequency] }
	                };
	            });

	            frequency = frequencies[0];
	            if (frequency && frequency.attributes && frequency.attributes["data-value"] === "never") {
	                frequency.attributes["data-value"] = "";
	            }

	            that.element.append(buttonGroupElement);
	            that._frequency = new ButtonGroup(buttonGroupElement, {
	                items: frequencies,
	                select: function() {
	                    that._value = {};
	                    that._initView(that._frequency.current().data("value"));
	                    that.trigger("change");
	                }
	            });
	        },

	        _initView: function(frequency) {
	            var that = this;
	            var rule = that._value;
	            var options = that.options;

	            var data = {
	                 frequency: frequency || "never",
	                 firstWeekDay: options.firstWeekDay,
	                 messages: options.messages[frequency],
	                 end: options.messages.end
	            };

	            kendo.destroy(that._container);
	            that._container.html(RECURRENCE_VIEW_TEMPLATE(data));

	            if (!frequency) {
	                that._value = {};
	                return;
	            }

	            rule.freq = frequency;

	            if (frequency === "weekly" && !rule.weekDays) {
	                rule.weekDays = [{
	                    day: options.start.getDay(),
	                    offset: 0
	                }];
	            }

	            that._weekDayButtons(options.firstWeekDay);

	            that._initInterval();
	            that._initWeekDays();
	            that._initMonthDay();
	            that._initWeekDay();
	            that._initMonth();
	            that._initCount();
	            that._initUntil();

	            that._period();
	            that._end();
	        },

	        _initMonth: function() {
	            var that = this;
	            var rule = that._value;
	            var month = rule.months || [that.options.start.getMonth() + 1];
	            var monthInputs = that._container.find(".k-recur-month");
	            var options;

	            if (monthInputs[0]) {
	                options = {
	                    change:  function() {
	                        rule.months = [Number(this.value())];
	                        that.trigger("change");
	                    },
	                    dataTextField: "text",
	                    dataValueField: "value",
	                    dataSource: $.map(kendo.culture().calendar.months.names, function(monthName, idx) {
	                        return {
	                            text: monthName,
	                            value: idx + 1
	                        };
	                    })
	                };

	                that._month1 = new DropDownList(monthInputs[0], options);
	                that._month2 = new DropDownList(monthInputs[1], options);

	                if (month) {
	                    month = month[0];
	                    that._month1.value(month);
	                    that._month2.value(month);
	                }
	            }

	        },

	        _end: function() {
	            var that = this;
	            var rule = that._value;
	            var container = that._container;
	            var namespace = that._namespace;
	            var click = function(e) {
	                that._toggleEnd(e.currentTarget.value);
	                that.trigger("change");
	            };
	            var endRule;

	            that._buttonNever = container.find(".k-recur-end-never").on(CLICK + namespace, click);
	            that._buttonCount = container.find(".k-recur-end-count").on(CLICK + namespace, click);
	            that._buttonUntil = container.find(".k-recur-end-until").on(CLICK + namespace, click);

	            if (rule.count) {
	                endRule = "count";
	            } else if (rule.until) {
	                endRule = "until";
	            }

	            that._toggleEnd(endRule);
	        },

	        _period: function() {
	            var that = this;
	            var rule = that._value;
	            var monthly = rule.freq === "monthly";

	            var toggleRule = monthly ? that._toggleMonthDay : that._toggleYear;

	            var selector = ".k-recur-" + (monthly ? "month" : "year") + "-radio";
	            var radioButtons = that._container.find(selector);

	            if (!monthly && rule.freq !== "yearly") {
	                return;
	            }

	            radioButtons.on(CLICK + that._namespace, function(e) {
	                toggleRule.call(that, e.currentTarget.value);
	                that.trigger("change");
	            });

	            that._buttonMonthDay = radioButtons.eq(0);
	            that._buttonWeekDay = radioButtons.eq(1);

	            toggleRule.call(that, rule.weekDays ? "weekday" : "monthday");
	        },

	        _toggleEnd: function(endRule) {
	            var that = this;
	            var count, until;
	            var enableCount, enableUntil;

	            if (endRule === "count") {
	                that._buttonCount.prop("checked", true);

	                enableCount = true;
	                enableUntil = false;

	                count = that._count.value();
	                until = null;
	            } else if (endRule === "until") {
	                that._buttonUntil.prop("checked", true);

	                enableCount = false;
	                enableUntil = true;

	                count = null;
	                until = that._until.value();
	            } else {
	                that._buttonNever.prop("checked", true);

	                enableCount = enableUntil = false;
	                count = until = null;
	            }

	            if(that._count){
	                that._count.enable(enableCount);
	            }

	            if(that._until){
	                that._until.enable(enableUntil);
	            }

	            that._value.count = count;
	            that._value.until = until;
	        },

	        _toggleMonthDay: function(monthRule) {
	            var that = this;
	            var enableMonthDay = false;
	            var enableWeekDay = true;
	            var clear = false;
	            var monthDays;

	            if (monthRule === "monthday") {
	                that._buttonMonthDay.prop("checked", true);

	                monthDays = [that._monthDay.value()];

	                enableMonthDay = true;
	                enableWeekDay = false;
	                clear = true;
	            } else {
	                that._buttonWeekDay.prop("checked", true);
	                monthDays = null;
	            }

	            that._weekDay.enable(enableWeekDay);
	            that._weekDayOffset.enable(enableWeekDay);
	            that._monthDay.enable(enableMonthDay);

	            that._value.monthDays = monthDays;

	            that._weekDayRule(clear);
	        },

	        _toggleYear: function(yearRule) {
	            var that = this;
	            var enableMonth1 = false;
	            var enableMonth2 = true;
	            var month;

	            if (yearRule === "monthday") {
	                enableMonth1 = true;
	                enableMonth2 = false;

	                month = that._month1.value();
	            } else {
	                month = that._month2.value();
	            }

	            that._month1.enable(enableMonth1);
	            that._month2.enable(enableMonth2);

	            that._value.months = [month];
	            that._toggleMonthDay(yearRule);
	        }
	    });

	    ui.plugin(RecurrenceEditor);


	    var RECURRENCE_HEADER_TEMPLATE = kendo.template(
	        '<div data-role="content">' +
	            '<ul class="k-listgroup k-listgroup-flush">' +
	                '<li class="k-item k-listgroup-item">' +
	                    '<label class="k-label k-listgroup-form-row">' +
	                        '<span class="k-item-title k-listgroup-form-field-label">#:headerTitle#</span>' +
	                        '<div class="k-recur-pattern k-listgroup-form-field-wrapper"></div>' +
	                    '</label>' +
	                '</li>' +
	                '<li class="k-item k-listgroup-item k-recur-view"></li>' +
	            '</ul>' +
	        '</div>'
	    );

	    var RECURRENCE_REPEAT_PATTERN_TEMPLATE = kendo.template(
	        '# if (frequency !== "never") { #' +
	            '<label class="k-label k-listgroup-form-row">' +
	                '<span class="k-item-title k-listgroup-form-field-label">#:messages.repeatEvery#</span>' +
	                '<div class="k-recur-editor-wrap k-listgroup-form-field-wrapper">' +
	                    '<input class="k-recur-interval" type="number" pattern="\\\\d*"/>' +
	                    '# if (messages.interval.length) { #' +
	                        '<span class="k-recur-editor-text">#:messages.interval#</span>' +
	                    '# } #' +
	                '</div>' +
	            '</label>' +
	        '# } #' +
	        '# if (frequency === "weekly") { #' +
	            '<ul class="k-recur-items-wrap k-listgroup k-listgroup-flush">' +
	                '<li class="k-item k-listgroup-item k-no-click">' +
	                    '<label class="k-label k-listgroup-form-row">' +
	                        '<span class="k-item-title k-listgroup-form-field-label">#:messages.repeatOn#</span>' +
	                    '</label>' +
	                '</li>' +
	                '<div class="k-button-group-stretched k-recur-weekday-buttons" title="#:messages.repeatOn#">'+
	            '</ul>' +
	        '# } else if (frequency === "monthly") { #' +
	            '<ul class="k-recur-items-wrap k-listgroup k-listgroup-flush">' +
	                '<li class="k-item k-listgroup-item">' +
	                    '<label class="k-label k-listgroup-form-row">' +
	                        '<span class="k-item-title k-listgroup-form-field-label">#:messages.repeatBy#</span>' +
	                        '<div class="k-repeat-rule k-listgroup-form-field-wrapper"></div>' +
	                    '</label>' +
	                '</li>' +
	                '<li class="k-monthday-view k-item k-listgroup-item" style="display:none">' +
	                    '<label class="k-label k-listgroup-form-row">' +
	                        '<span class="k-item-title k-listgroup-form-field-label">#:messages.day#</span>' +
	                        '<div class="k-listgroup-form-field-wrapper"><input class="k-recur-monthday" type="number" title="#:messages.day#" pattern="\\\\d*"/></div>' +
	                    '</label>' +
	                '</li>' +
	                '<li class="k-weekday-view k-item k-listgroup-item" style="display:none">' +
	                    '<label class="k-label k-listgroup-form-row">' +
	                        '<span class="k-item-title k-listgroup-form-field-label">#:messages.every#</span>' +
	                        '<div class="k-listgroup-form-field-wrapper"><select class="k-recur-weekday-offset" title="#:messages.every#"></select></div>' +
	                    '</label>' +
	                '</li>' +
	                '<li class="k-weekday-view k-item k-listgroup-item" style="display:none">' +
	                    '<label class="k-label k-listgroup-form-row">' +
	                        '<span class="k-item-title k-listgroup-form-field-label">#:messages.day#</span>' +
	                        '<div class="k-listgroup-form-field-wrapper"><select class="k-recur-weekday" title="#:messages.day#"></select></div>' +
	                    '</label>' +
	                '</li>' +
	            '</ul>' +
	        '# } else if (frequency === "yearly") { #' +
	            '<ul class="k-recur-items-wrap k-listgroup k-listgroup-flush">' +
	                '<li class="k-item k-listgroup-item">' +
	                    '<label class="k-label k-listgroup-form-row">' +
	                        '<span class="k-item-title k-listgroup-form-field-label">#:messages.repeatBy#</span>' +
	                        '<div class="k-repeat-rule k-listgroup-form-field-wrapper"></div>' +
	                    '</label>' +
	                '</li>' +
	                '<li class="k-monthday-view k-item k-listgroup-item" style="display:none">' +
	                    '<label class="k-label k-listgroup-form-row">' +
	                        '<span class="k-item-title k-listgroup-form-field-label">#:messages.day#</span>' +
	                        '<div class="k-listgroup-form-field-wrapper"><input class="k-recur-monthday" type="number" title="#:messages.day#" pattern="\\\\d*"/></div>' +
	                    '</label>' +
	                '</li>' +
	                '<li class="k-weekday-view k-item k-listgroup-item" style="display:none">' +
	                    '<label class="k-label k-listgroup-form-row">' +
	                        '<span class="k-item-title k-listgroup-form-field-label">#:messages.every#</span>' +
	                        '<div class="k-listgroup-form-field-wrapper"><select class="k-recur-weekday-offset" title="#:messages.every#"></select></div>' +
	                    '</label>' +
	                '</li>' +
	                '<li class="k-weekday-view k-item k-listgroup-item" style="display:none">' +
	                    '<label class="k-label k-listgroup-form-row">' +
	                        '<span class="k-item-title k-listgroup-form-field-label">#:messages.day#</span>' +
	                        '<div class="k-listgroup-form-field-wrapper"><select class="k-recur-weekday" title="#:messages.day#"></select></div>' +
	                    '</label>' +
	                '</li>' +
	                '<li class="k-item k-item k-listgroup-item">' +
	                    '<label class="k-label k-listgroup-form-row">' +
	                        '<span class="k-item-title k-listgroup-form-field-label">#:messages.month#</span>' +
	                        '<div class="k-listgroup-form-field-wrapper"><select class="k-recur-month" title="#:messages.month#"></select></div>' +
	                    '</label>' +
	                '</li>' +
	           '</ul>' +
	        '# } #'
	    );

	    var RECURRENCE_END_PATTERN_TEMPLATE = kendo.template(
	        '# if (endPattern === "count") { #' +
	            '<label class="k-label k-listgroup-form-row">' +
	                '<span class="k-item-title k-listgroup-form-field-label">#:messages.after#</span>' +
	                '<div class="k-listgroup-form-field-wrapper"><input class="k-recur-count" type="number" pattern="\\\\d*" /></div>' +
	            '</label>' +
	        '# } else if (endPattern === "until") { #' +
	            '<label class="k-label k-listgroup-form-row">' +
	                '<span class="k-item-title k-listgroup-form-field-label">#:messages.on#</span>' +
	                '<div class="k-listgroup-form-field-wrapper"><input type="date" class="k-recur-until" name="recur-until"/></div>' +
	            '</label>' +
	        '# } #'
	    );

	    var RECURRENCE_GROUP_BUTTON_TEMPLATE = kendo.template(
	        '<select class="k-scheduler-select">' +
	            '#for (var i = 0, length = dataSource.length; i < length; i++) {#' +
	                '<option value="#=dataSource[i].value#" #= value === dataSource[i].value  ? \"selected\" : \"\" #>#:dataSource[i].text#</option>' +
	            '#}#'  +
	        '</select>'
	    );

	    var MobileRecurrenceEditor = BaseRecurrenceEditor.extend({
	        init: function(element, options) {
	            var that = this;

	            BaseRecurrenceEditor.fn.init.call(that, element, options);

	            options = that.options;

	            that._optionTemplate = kendo.template('<option value="#:value#">#:text#</option>');

	            that.value(options.value);

	            that._pane = options.pane || that.wrapper.closest("[data-role=pane]").data("kendoPane");

	            that._initRepeatButton();

	            that._initParentRepeatEnd();

	            that._defaultValue = that._value;
	        },

	        options: {
	            name: "MobileRecurrenceEditor",
	            animations: {
	                left: "slide",
	                right: "slide:right"
	            },
	            mobile: true,
	            messages: {
	                cancel: "Cancel",
	                update: "Save",
	                endTitle: "Repeat ends",
	                repeatTitle: "Repeat pattern",
	                headerTitle: "Repeat event",
	                end: {
	                    patterns: {
	                        never: "Never",
	                        after: "After...",
	                        on: "On..."
	                    },
	                    never: "Never",
	                    after: "End repeat after",
	                    on: "End repeat on"
	                },
	                daily: {
	                    interval: ""
	                },
	                hourly: {
	                    interval: ""
	                },
	                weekly: {
	                    interval: ""
	                },
	                monthly: {
	                    interval: "",
	                    repeatBy: "Repeat by: ",
	                    dayOfMonth: "Day of the month",
	                    dayOfWeek: "Day of the week",
	                    repeatEvery: "Repeat every",
	                    every: "Every",
	                    day: "Day "
	                },
	                yearly: {
	                    interval: "",
	                    repeatBy: "Repeat by: ",
	                    dayOfMonth: "Day of the month",
	                    dayOfWeek: "Day of the week",
	                    repeatEvery: "Repeat every: ",
	                    every: "Every",
	                    month: "Month",
	                    day: "Day"
	                }
	            }
	        },

	        events: [ "change" ],

	        value: function(value) {
	            var that = this;
	            var timezone = that.options.timezone;

	            if (value === undefined) {
	                if (!that._value.freq) {
	                    return "";
	                }

	                return serialize(that._value, timezone);
	            }

	            that._value = parseRule(value, timezone) || {};
	        },

	        destroy: function() {
	            this._destroyView();

	            kendo.destroy(this._endFields);

	            if(this._weekDayButtonGroup) {
	                this._weekDayButtonGroup.destroy();
	            }

	            this.element.off(CLICK + this._namespace);

	            BaseRecurrenceEditor.fn.destroy.call(this);
	        },

	        _initInterval: function() {
	            var that = this;
	            var rule = that._value;

	            that._container.find(".k-recur-interval")
	                .val(that._value.interval || 1)
	                .on(CHANGE + that._namespace, function(e){
	                    rule.interval = e.target.value;
	                    that._trigger();
	                });
	        },

	        _initRepeatButton: function() {
	            var that = this;
	            var freq = that.options.messages.frequencies[this._value.freq || "never"];

	            that._chevronButton = $('<span class="k-icon k-i-arrow-chevron-right"></span>');
	            that._repeatValue = $('<span class="">' + freq + '</span>');

	            that.element.append(that._repeatValue).append(that._chevronButton);

	            that.element.parents("li.k-item").on(CLICK + that._namespace, function(e) {
	                e.preventDefault();
	                that._createView("repeat");
	                that._pane.navigate(that._view, that.options.animations.left);
	            });
	        },

	        _endLiItem: function () {
	            var that = this;
	            return '<li class="k-item k-listgroup-item"><label class="k-label k-listgroup-form-row"><span class="k-item-title k-listgroup-form-field-label">' + that.options.messages.end.mobileLabel + '</span></label></li>';
	        },

	        _initParentRepeatEnd: function() {
	            var that = this;

	            var endLabelField = $(that._endLiItem()).insertAfter(that.element.parents("li.k-item"));

	            var endEditField = $('<div class="k-scheduler-recur-end-wrap k-listgroup-form-field-wrapper"><span class="k-scheduler-recur-end"></span></div>')
	                .appendTo(endLabelField.find(".k-label"));

	            endLabelField.on(CLICK + that._namespace, function(e) {
	                e.preventDefault();
	                that._navigateToView("repeat");
	            });

	            that._endParentLabelField = endLabelField.toggle(!!that._value.freq);
	            that._endParentEndButton = endEditField.find(".k-scheduler-recur-end").text(that._endText());
	        },

	        _initRepeatEnd: function() {
	            var that = this;

	            var endLabelField = $(that._endLiItem()).insertAfter(that._container);

	            var endEditField = $('<div class="k-scheduler-recur-end-wrap k-listgroup-form-field-wrapper"><span class="k-scheduler-recur-end"></span><span class="k-icon k-i-arrow-chevron-right"></span></div>')
	                .appendTo(endLabelField.find(".k-label"));

	            endLabelField.on(CLICK + that._namespace, function(e) {
	                e.preventDefault();
	                that._navigateToView("end");
	            });

	            that._endLabelField = endLabelField.toggleClass("k-state-disabled", !that._value.freq);
	            that._endButton = endEditField.find(".k-scheduler-recur-end").text(that._endText());
	        },

	        _navigateToView: function (viewName) {
	            var that = this;
	            that._createView(viewName);
	            that._pane.navigate(that._view, that.options.animations.left);
	        },

	        _endText: function() {
	            var rule = this._value;
	            var messages = this.options.messages.end;

	            var text = messages.never;

	            if (rule.count) {
	                text = kendo.format("{0} {1}", messages.after, rule.count);
	            } else if (rule.until) {
	                text = kendo.format("{0} {1:d}", messages.on, rule.until);
	            }

	            return text;
	        },

	        _initFrequency: function() {
	            var that = this;
	            var frequencyMessages = that.options.messages.frequencies;

	            var html = RECURRENCE_GROUP_BUTTON_TEMPLATE({
	                dataSource: $.map(this.options.frequencies, function(frequency) {
	                    return {
	                        text: frequencyMessages[frequency],
	                        value: frequency !== "never" ? frequency : ""
	                    };
	                }),
	                value: that._value.freq || "",
	                ns: kendo.ns
	            });

	            that._view.element
	                .find(".k-recur-pattern")
	                .append(html);

	            that._view.element.find(".k-scheduler-select")
	                .on(CHANGE + that._namespace, function(e) {
	                    var value = e.target.value;
	                    that._value = { freq: value };
	                    that._defaultValue = $.extend({}, that._value);
	                    that._initRepeatView();
	                    that._endButton.text(that._endText());
	                    that._endParentEndButton.text(that._endText());
	                });
	        },

	        _initEndNavigation: function() {
	            var that = this;
	            var endMessages = that.options.messages.end.patterns;
	            var rule = that._value;
	            var value = "";

	            if (rule.count) {
	                value = "count";
	            } else if (rule.until) {
	                value = "until";
	            }

	            var html = RECURRENCE_GROUP_BUTTON_TEMPLATE({
	                dataSource: [
	                    { text: endMessages.never, value: "" },
	                    { text: endMessages.after, value: "count" },
	                    { text: endMessages.on, value: "until" }
	                ],
	                value: value,
	                ns: kendo.ns
	            });

	            that._view.element
	                .find(".k-recur-pattern")
	                .append(html);

	            that._view.element.find(".k-scheduler-select")
	                .on(CHANGE + that._namespace, function(e) {
	                    var value = e.target.value;
	                    var count = null;
	                    var until = null;

	                    that._initEndView(value);

	                    if (that._count.length) {
	                        count = that._count.val();
	                        until = null;
	                    } else if (that._until.length) {
	                        count = null;
	                        until = that._until.val ? kendo.parseDate(that._until.val(), "yyyy-MM-dd") : that._until.value();
	                    }

	                    rule.count = count;
	                    rule.until = until;
	                });
	        },

	        _createView: function(viewType) {
	            var that = this;
	            var options = that.options;
	            var messages = options.messages;
	            var headerTitle = messages[viewType === "repeat" ? "repeatTitle" : "endTitle"];

	            var html = '<div data-role="view" class="k-popup-edit-form k-scheduler-edit-form" id="recurrence">' +
	                       '<div data-role="header" class="k-header">' +
	                           '<a href="#" class="k-header-cancel k-scheduler-cancel k-link" title="' + messages.cancel + '"'+
	                           'aria-label="' + messages.cancel + '"><span class="k-icon k-i-arrow-chevron-left"></span></a>' +
	                               messages.headerTitle +
	                           '<a href="#" class="k-header-done k-scheduler-update k-link" title="' + messages.update + '" ' +
	                           'aria-label="' + messages.update + '"><span class="k-icon k-i-check"></span></a>' +
	                       '</div>';

	            var returnViewId = that._pane.view().id;

	            that._view = that._pane.append(html + RECURRENCE_HEADER_TEMPLATE({ headerTitle: headerTitle }));

	            that._view.element.on(CLICK + that._namespace, "a.k-scheduler-cancel, a.k-scheduler-update", function(e) {
	                e.preventDefault();
	                e.stopPropagation();

	                if ($(this).hasClass("k-scheduler-update")) {
	                    that.trigger("change");
	                    that._defaultValue = $.extend({}, that._value);
	                } else {
	                    that._value = that._defaultValue;
	                }

	                var frequency = that._value.freq;

	                that._endParentEndButton.text(that._endText());
	                that._endParentLabelField.toggle(!!frequency && frequency !== "never");
	                that._endButton.text(that._endText());

	                that._repeatValue.text(messages.frequencies[frequency || "never"]);

	                that._pane.one("viewShow", function() {
	                    that._destroyView();
	                });

	                that._pane.navigate(returnViewId, that.options.animations.right);
	            });

	            that._container = that._view.element.find(".k-recur-view");

	            if (viewType === "repeat") {
	                that._initFrequency();
	                that._initRepeatView();
	                that._initRepeatEnd();
	            } else {
	                that._initEndNavigation();
	                that._initEndView();
	            }
	        },

	        _destroyView: function() {
	            if (this._view) {

	                this._view.destroy();
	                this._view.element.remove();
	                this._container = null;
	            }


	            this._view = null;
	        },

	        _initRepeatView: function() {
	            var that = this;
	            var frequency = that._value.freq || "never";

	            var data = {
	                 frequency: frequency,
	                 firstWeekDay: that.options.firstWeekDay,
	                 messages: that.options.messages[frequency]
	            };

	            var html = RECURRENCE_REPEAT_PATTERN_TEMPLATE(data);

	            var container = that._container = that._container || this._pane.view().content.find("li.k-recur-view");
	            var rule = that._value;

	            if(that._endLabelField){
	                that._endLabelField.toggleClass("k-state-disabled", frequency === "never");
	            }

	            kendo.destroy(container);
	            container.html(html);

	            if (!html) {
	                that._value = {};
	                container.hide();
	                return;
	            } else {
	                container.show();
	            }

	            if (frequency === "weekly" && !rule.weekDays) {
	                 rule.weekDays = [{
	                    day: that.options.start.getDay(),
	                    offset: 0
	                 }];
	            }

	            that._weekDayButtons(that.options.firstWeekDay);

	            that._initInterval();
	            that._initMonthDay();
	            that._initWeekDays();
	            that._initWeekDay();
	            that._initMonth();

	            that._period();
	        },

	        _initMonthDay: function () {
	            var that = this;
	            var rule = that._value;
	            var monthDayInput = that._monthDay = that._container.find(".k-recur-monthday");

	            monthDayInput.attr({
	                min: 1,
	                max: 31
	            })
	            .val(rule.monthDays ? rule.monthDays[0] : that.options.start.getDate())
	            .on(CHANGE + that._namespace, function(e){
	                rule.count = e.target.value;
	                that._trigger();
	            });
	        },

	        _initCount: function(){
	            var that = this,
	                input = that._count = that._container.find(".k-recur-count"),
	                rule = that._value;

	            input.val(rule.count || 1)
	                .on(CHANGE + that._namespace, function(ev){
	                    rule.count = ev.target.value;
	                    that._trigger();
	                });
	        },

	        _initEndView: function (endPattern) {
	            var that = this;
	            var rule = that._value;

	            if (endPattern === undefined) {
	                if (rule.count) {
	                    endPattern = "count";
	                } else if (rule.until) {
	                    endPattern = "until";
	                }
	            }

	            var data = {
	                 endPattern: endPattern,
	                 messages: that.options.messages.end
	            };

	            kendo.destroy(that._container);
	            that._container.html(RECURRENCE_END_PATTERN_TEMPLATE(data));

	            that._initCount();
	            that._initUntil();
	        },

	        _initWeekDay: function() {
	            var that = this, data;

	            var weekdayMessage = that.options.messages.weekdays;
	            var offsetMessage = that.options.messages.offsetPositions;

	            var weekDaySelect = that._container.find(".k-recur-weekday");

	            var change = function() {
	                that._weekDayRule();
	                that.trigger("change");
	            };

	            if (weekDaySelect[0]) {
	                that._weekDayOffset = that._container.find(".k-recur-weekday-offset")
	                                          .html(that._options([
	                                            { text: offsetMessage.first, value: "1" },
	                                            { text: offsetMessage.second, value: "2" },
	                                            { text: offsetMessage.third, value: "3" },
	                                            { text: offsetMessage.fourth, value: "4" },
	                                            { text: offsetMessage.last, value: "-1" }
	                                          ]))
	                                          .change(change);

	                data = [
	                    { text: weekdayMessage.day, value: "day" },
	                    { text: weekdayMessage.weekday, value: "weekday" },
	                    { text: weekdayMessage.weekend, value: "weekend" }
	                ];

	                data = data.concat($.map(kendo.culture().calendar.days.names, function(dayName, idx) {
	                    return {
	                        text: dayName,
	                        value: idx
	                    };
	                }));

	                that._weekDay = weekDaySelect.html(that._options(data))
	                                             .change(change)
	                                             .val(that.options.start.getDay());

	                that._weekDayView();
	            }
	        },

	        _initMonth: function() {
	            var that = this;
	            var rule = that._value;
	            var start = that.options.start;
	            var month = rule.months || [start.getMonth() + 1];
	            var monthSelect = that._container.find(".k-recur-month");
	            var monthNames = kendo.culture().calendar.months.names;

	            if (monthSelect[0]) {
	                var data = $.map(monthNames, function(monthName, idx) {
	                    return {
	                        text: monthName,
	                        value: idx + 1
	                    };
	                });

	                monthSelect.html(that._options(data))
	                           .change(function() {
	                               rule.months = [Number(this.value)];
	                           });

	                that._monthSelect = monthSelect;

	                if (month) {
	                    monthSelect.val(month[0]);
	                }
	            }

	        },

	        _period: function() {
	            var that = this;
	            var rule = that._value;
	            var container = that._container;
	            var messages = that.options.messages[rule.freq];
	            var repeatRuleGroupButton = container.find(".k-repeat-rule");
	            var weekDayView = container.find(".k-weekday-view");
	            var monthDayView = container.find(".k-monthday-view");

	            if (repeatRuleGroupButton[0]) {
	                var currentValue = rule.weekDays ? "weekday" : "monthday";

	                var html = RECURRENCE_GROUP_BUTTON_TEMPLATE({
	                    value : currentValue,
	                    dataSource: [
	                        { text: messages.dayOfMonth, value: "monthday" },
	                        { text: messages.dayOfWeek, value: "weekday" }
	                    ],
	                    ns: kendo.ns
	                });

	                var init = function(val) {
	                    var weekDayName = that._weekDay.val();
	                    var weekDayOffset = that._weekDayOffset.val();
	                    var monthDay = that._monthDay.val();
	                    var month = that._monthSelect ? that._monthSelect.val() : null;

	                    if (val === "monthday") {
	                        rule.weekDays = null;
	                        rule.monthDays = monthDay ? [monthDay] : monthDay;
	                        rule.months = month ? [Number(month)] : month;

	                        weekDayView.hide();
	                        monthDayView.show();
	                    } else {
	                        rule.monthDays = null;
	                        rule.months = month ? [Number(month)] : month;

	                        rule.weekDays = [{
	                            offset: Number(weekDayOffset),
	                            day: Number(weekDayName)
	                        }];

	                        weekDayView.show();
	                        monthDayView.hide();
	                    }
	                };

	                repeatRuleGroupButton
	                    .append(html);

	                repeatRuleGroupButton.find(".k-scheduler-select")
	                    .on(CHANGE + that._namespace, function(e) {
	                        init(e.target.value);
	                    });

	                init(currentValue);
	            }
	        },

	        _initUntil: function() {
	            var that = this;
	            var input = that._container.find(".k-recur-until");
	            var start = that.options.start;
	            var rule = that._value;
	            var until = rule.until;
	            var min = until && until < start ? until : start;
	            var validDateValidationMessage = kendo.format(kendo.ui.Validator.prototype.options.messages.date, that.options.messages.end.on);
	            var dateCompareValidationMessage = kendo.ui.Validator.prototype.options.messages.dateCompare;

	            input.attr("data-validDate-msg", validDateValidationMessage);
	            input.attr("data-untilDateCompare-msg", dateCompareValidationMessage);

	            if (kendo.support.input.date) {
	                that._until = input.attr("min", kendo.toString(min, "yyyy-MM-dd"))
	                                   .val(kendo.toString(until || start, "yyyy-MM-dd"))
	                                   .on("change", function() {
	                                        var date  = kendo.parseDate(this.value, "yyyy-MM-dd");
	                                        if(date) {
	                                            rule.until =  date;
	                                        }
	                                        that._trigger();
	                                   });
	            } else {
	                that._until = input.kendoDatePicker({
	                    min: min,
	                    value: until || start,
	                    change: function() {
	                        var date  = this.value();
	                        if(date) {
	                            rule.until =  date;
	                        }
	                        that._trigger();
	                    }
	                }).data("kendoDatePicker");
	            }
	        },

	        _options: function(data, optionLabel) {
	            var idx = 0;
	            var html = "";
	            var length = data.length;
	            var template = this._optionTemplate;

	            if (optionLabel) {
	                html += template({ value: "", text: optionLabel });
	            }

	            for (; idx < length; idx++) {
	                html += template(data[idx]);
	            }

	            return html;
	        }
	    });

	    ui.plugin(MobileRecurrenceEditor);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "kQPp":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(929);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 913:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("pV45");

/***/ }),

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(930), __webpack_require__(913)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($, undefined) {
	    // Imports ================================================================
	    var doc = document,
	        math = Math,
	        min = math.min,
	        pow = math.pow,

	        proxy = $.proxy,

	        kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        deepExtend = kendo.deepExtend,

	        dataviz = kendo.dataviz,
	        ui = dataviz.ui,

	        g = kendo.geometry,
	        Point = g.Point,

	        map = dataviz.map,
	        Extent = map.Extent,
	        Location = map.Location,
	        EPSG3857 = map.crs.EPSG3857,

	        util = kendo.util,
	        renderPos = util.renderPos,

	        drawingUtil = kendo.drawing.util,

	        defined = drawingUtil.defined,
	        limit = drawingUtil.limitValue,
	        valueOrDefault = drawingUtil.valueOrDefault;

	    // Constants ==============================================================
	    var CSS_PREFIX = "k-",
	        FRICTION = 0.90,
	        FRICTION_MOBILE = 0.93,
	        MOUSEWHEEL = "DOMMouseScroll mousewheel",
	        VELOCITY_MULTIPLIER = 5,
	        DEFAULT_ZOOM_RATE = 1;

	    // Map widget =============================================================
	    var Map = Widget.extend({
	        init: function(element, options) {
	            kendo.destroy(element);
	            Widget.fn.init.call(this, element);

	            this._initOptions(options);
	            this.bind(this.events, options);

	            this.crs = new EPSG3857();

	            this.element
	                .addClass(CSS_PREFIX + this.options.name.toLowerCase())
	                .css("position", "relative")
	                .empty()
	                .append(doc.createElement("div"));

	            this._viewOrigin = this._getOrigin();
	            this._initScroller();
	            this._initMarkers();
	            this._initControls();
	            this._initLayers();
	            this._reset();

	            this._mousewheel = proxy(this._mousewheel, this);
	            this.element.bind(MOUSEWHEEL, this._mousewheel);
	        },

	        options: {
	            name: "Map",
	            controls: {
	                attribution: true,
	                navigator: {
	                    panStep: 100
	                },
	                zoom: true
	            },
	            layers: [],
	            layerDefaults: {
	                shape: {
	                    style: {
	                        fill: {
	                            color: "#fff"
	                        },
	                        stroke: {
	                            color: "#aaa",
	                            width: 0.5
	                        }
	                    }
	                },
	                bubble: {
	                    style: {
	                        fill: {
	                            color: "#fff",
	                            opacity: 0.5
	                        },
	                        stroke: {
	                            color: "#aaa",
	                            width: 0.5
	                        }
	                    }
	                },
	                marker: {
	                    shape: "pinTarget",
	                    tooltip: {
	                        position: "top"
	                    }
	                }
	            },
	            center: [0, 0],
	            zoom: 3,
	            minSize: 256,
	            minZoom: 1,
	            maxZoom: 19,
	            markers: [],
	            markerDefaults: {
	                shape: "pinTarget",
	                tooltip: {
	                    position: "top"
	                }
	            },
	            wraparound: true
	        },

	        events:[
	            "beforeReset",
	            "click",
	            "markerActivate",
	            "markerClick",
	            "markerCreated",
	            "pan",
	            "panEnd",
	            "reset",
	            "shapeClick",
	            "shapeCreated",
	            "shapeFeatureCreated",
	            "shapeMouseEnter",
	            "shapeMouseLeave",
	            "zoomEnd",
	            "zoomStart"
	        ],

	        destroy: function() {
	            this.scroller.destroy();

	            if (this.navigator) {
	                this.navigator.destroy();
	            }

	            if (this.attribution) {
	                this.attribution.destroy();
	            }

	            if (this.zoomControl) {
	                this.zoomControl.destroy();
	            }

	            this.markers.destroy();

	            for (var i = 0; i < this.layers.length; i++) {
	                this.layers[i].destroy();
	            }

	            Widget.fn.destroy.call(this);
	        },

	        zoom: function(level) {
	            var options = this.options;

	            if (defined(level)) {
	                level = math.round(limit(level, options.minZoom, options.maxZoom));
	                if (options.zoom !== level) {
	                    options.zoom = level;
	                    this._reset();
	                }

	                return this;
	            } else {
	                return options.zoom;
	            }
	        },

	        center: function(center) {
	            if (center) {
	                this.options.center = Location.create(center).toArray();
	                this._reset();

	                return this;
	            } else {
	                return Location.create(this.options.center);
	            }
	        },

	        extent: function(extent) {
	            if (extent) {
	                this._setExtent(extent);
	                return this;
	            } else {
	                return this._getExtent();
	            }
	        },

	        setOptions: function(options) {
	            Widget.fn.setOptions.call(this, options);
	            this._reset();
	        },

	        locationToLayer: function(location, zoom) {
	            var clamp = !this.options.wraparound;
	            location = Location.create(location);
	            return this.crs.toPoint(location, this._layerSize(zoom), clamp);
	        },

	        layerToLocation: function(point, zoom) {
	            var clamp = !this.options.wraparound;
	            point = Point.create(point);
	            return  this.crs.toLocation(point, this._layerSize(zoom), clamp);
	        },

	        locationToView: function(location) {
	            location = Location.create(location);
	            var origin = this.locationToLayer(this._viewOrigin);
	            var point = this.locationToLayer(location);

	            return point.translateWith(origin.scale(-1));
	        },

	        viewToLocation: function(point, zoom) {
	            var origin = this.locationToLayer(this._getOrigin(), zoom);
	            point = Point.create(point);
	            point = point.clone().translateWith(origin);
	            return this.layerToLocation(point, zoom);
	        },

	        eventOffset: function(e) {
	            var point;
	            var x;
	            var y;
	            var offset = this.element.offset();

	            if (e.x || e.y) {
	                var field = "location";
	                x = e.x[field] - offset.left;
	                y = e.y[field] - offset.top;
	                point = new g.Point(x, y);
	            } else {
	                var event = e.originalEvent || e;
	                x = valueOrDefault(event.pageX, event.clientX) - offset.left;
	                y = valueOrDefault(event.pageY, event.clientY) - offset.top;
	                point = new g.Point(x, y);
	            }

	            return point;
	        },

	        eventToView: function(e) {
	            var cursor = this.eventOffset(e);
	            return this.locationToView(this.viewToLocation(cursor));
	        },

	        eventToLayer: function(e) {
	            return this.locationToLayer(this.eventToLocation(e));
	        },

	        eventToLocation: function(e) {
	            var cursor = this.eventOffset(e);
	            return this.viewToLocation(cursor);
	        },

	        viewSize: function() {
	            var element = this.element;
	            var scale = this._layerSize();
	            var width = element.width();

	            if (!this.options.wraparound) {
	                width = min(scale, width);
	            }
	            return {
	                width: width,
	                height: min(scale, element.height())
	            };
	        },

	        exportVisual: function() {
	            this._reset();
	            return false;
	        },

	        _setOrigin: function(origin, zoom) {
	            var size = this.viewSize(),
	                topLeft;

	            origin = this._origin = Location.create(origin);
	            topLeft = this.locationToLayer(origin, zoom);
	            topLeft.x += size.width / 2;
	            topLeft.y += size.height / 2;

	            this.options.center = this.layerToLocation(topLeft, zoom).toArray();

	            return this;
	        },

	        _getOrigin: function(invalidate) {
	            var size = this.viewSize(),
	                topLeft;

	            if (invalidate || !this._origin) {
	                topLeft = this.locationToLayer(this.center());
	                topLeft.x -= size.width / 2;
	                topLeft.y -= size.height / 2;

	                this._origin = this.layerToLocation(topLeft);
	            }

	            return this._origin;
	        },

	        _setExtent: function(extent) {
	            var raw = Extent.create(extent);
	            var se = raw.se.clone();
	            if (this.options.wraparound && se.lng < 0 && extent.nw.lng > 0) {
	                se.lng = 180 + (180 + se.lng);
	            }

	            extent = new Extent(raw.nw, se);
	            this.center(extent.center());

	            var width = this.element.width();
	            var height = this.element.height();
	            for (var zoom = this.options.maxZoom; zoom >= this.options.minZoom; zoom--) {
	                var topLeft = this.locationToLayer(extent.nw, zoom);
	                var bottomRight = this.locationToLayer(extent.se, zoom);

	                var layerWidth = math.abs(bottomRight.x - topLeft.x);
	                var layerHeight = math.abs(bottomRight.y - topLeft.y);

	                if (layerWidth <= width && layerHeight <= height) {
	                    break;
	                }
	            }

	            this.zoom(zoom);
	        },

	        _getExtent: function() {
	            var nw = this._getOrigin();
	            var bottomRight = this.locationToLayer(nw);
	            var size = this.viewSize();

	            bottomRight.x += size.width;
	            bottomRight.y += size.height;

	            var se = this.layerToLocation(bottomRight);
	            return new Extent(nw, se);
	        },

	        _zoomAround: function(pivot, level) {
	            this._setOrigin(this.layerToLocation(pivot, level), level);
	            this.zoom(level);
	        },

	        _initControls: function() {
	            var controls = this.options.controls;

	            if (ui.Attribution && controls.attribution) {
	                this._createAttribution(controls.attribution);
	            }

	            if (!kendo.support.mobileOS) {
	                if (ui.Navigator && controls.navigator) {
	                    this._createNavigator(controls.navigator);
	                }

	                if (ui.ZoomControl && controls.zoom) {
	                    this._createZoomControl(controls.zoom);
	                }
	            }
	        },

	        _createControlElement: function(options, defaultPos) {
	            var pos = options.position || defaultPos;
	            var posSelector = "." + renderPos(pos).replace(" ", ".");
	            var wrap = $(".k-map-controls" + posSelector, this.element);
	            if (wrap.length === 0) {
	                wrap = $("<div>")
	                       .addClass("k-map-controls " + renderPos(pos))
	                       .appendTo(this.element);
	            }

	            return $("<div>").appendTo(wrap);
	        },

	        _createAttribution: function(options) {
	            var element = this._createControlElement(options, "bottomRight");
	            this.attribution = new ui.Attribution(element, options);
	        },

	        _createNavigator: function(options) {
	            var element = this._createControlElement(options, "topLeft");
	            var navigator = this.navigator = new ui.Navigator(element, options);

	            this._navigatorPan = proxy(this._navigatorPan, this);
	            navigator.bind("pan", this._navigatorPan);

	            this._navigatorCenter = proxy(this._navigatorCenter, this);
	            navigator.bind("center", this._navigatorCenter);
	        },

	        _navigatorPan: function(e) {
	            var map = this;
	            var scroller = map.scroller;

	            var x = scroller.scrollLeft + e.x;
	            var y = scroller.scrollTop - e.y;

	            var bounds = this._virtualSize;
	            var height = this.element.height();
	            var width = this.element.width();

	            // TODO: Move limits in scroller
	            x = limit(x, bounds.x.min, bounds.x.max - width);
	            y = limit(y, bounds.y.min, bounds.y.max - height);

	            map.scroller.one("scroll", function(e) { map._scrollEnd(e); });
	            map.scroller.scrollTo(-x, -y);
	        },

	        _navigatorCenter: function() {
	            this.center(this.options.center);
	        },

	        _createZoomControl: function(options) {
	            var element = this._createControlElement(options, "topLeft");
	            var zoomControl = this.zoomControl = new ui.ZoomControl(element, options);

	            this._zoomControlChange = proxy(this._zoomControlChange, this);
	            zoomControl.bind("change", this._zoomControlChange);
	        },

	        _zoomControlChange: function(e) {
	            if (!this.trigger("zoomStart", { originalEvent: e })) {
	                this.zoom(this.zoom() + e.delta);
	                this.trigger("zoomEnd", { originalEvent: e });
	            }
	        },

	        _initScroller: function() {
	            var friction = kendo.support.mobileOS ? FRICTION_MOBILE : FRICTION;
	            var zoomable = this.options.zoomable !== false;
	            var scroller = this.scroller = new kendo.mobile.ui.Scroller(
	                this.element.children(0), {
	                    friction: friction,
	                    velocityMultiplier: VELOCITY_MULTIPLIER,
	                    zoom: zoomable,
	                    mousewheelScrolling: false,
	                    supportDoubleTap: true
	                });

	            scroller.bind("scroll", proxy(this._scroll, this));
	            scroller.bind("scrollEnd", proxy(this._scrollEnd, this));
	            scroller.userEvents.bind("gesturestart", proxy(this._scaleStart, this));
	            scroller.userEvents.bind("gestureend", proxy(this._scale, this));
	            scroller.userEvents.bind("doubleTap", proxy(this._doubleTap, this));
	            scroller.userEvents.bind("tap", proxy(this._tap, this));

	            this.scrollElement = scroller.scrollElement;
	        },

	        _initLayers: function() {
	            var defs = this.options.layers,
	                layers = this.layers = [];

	            for (var i = 0; i < defs.length; i++) {
	                var options = defs[i];
	                var type = options.type || "shape";
	                var defaults = this.options.layerDefaults[type];
	                var impl = dataviz.map.layers[type];

	                layers.push(new impl(this, deepExtend({}, defaults, options)));
	            }
	        },

	        _initMarkers: function() {
	            this.markers = new map.layers.MarkerLayer(this, this.options.markerDefaults);
	            this.markers.add(this.options.markers);
	        },

	        _scroll: function(e) {
	            var origin = this.locationToLayer(this._viewOrigin).round();
	            var movable = e.sender.movable;

	            var offset = new g.Point(movable.x, movable.y).scale(-1).scale(1/movable.scale);
	            origin.x += offset.x;
	            origin.y += offset.y;

	            this._scrollOffset = offset;

	            this._setOrigin(this.layerToLocation(origin));
	            this.trigger("pan", {
	                originalEvent: e,
	                origin: this._getOrigin(),
	                center: this.center()
	            });
	        },

	        _scrollEnd: function(e) {
	            if (!this._scrollOffset || !this._panComplete()) {
	                return;
	            }

	            this._scrollOffset = null;
	            this._panEndTS = new Date();

	            this.trigger("panEnd", {
	                originalEvent: e,
	                origin: this._getOrigin(),
	                center: this.center()
	            });
	        },

	        _panComplete: function() {
	            return new Date() - (this._panEndTS || 0) > 50;
	        },

	        _scaleStart: function(e) {
	            if (this.trigger("zoomStart", { originalEvent: e })) {
	                var touch = e.touches[1];
	                if (touch) {
	                    touch.cancel();
	                }
	            }
	        },

	        _scale: function(e) {
	            var scale = this.scroller.movable.scale;
	            var zoom = this._scaleToZoom(scale);
	            var gestureCenter = new g.Point(e.center.x, e.center.y);
	            var centerLocation = this.viewToLocation(gestureCenter, zoom);
	            var centerPoint = this.locationToLayer(centerLocation, zoom);
	            var originPoint = centerPoint.translate(-gestureCenter.x, -gestureCenter.y);

	            this._zoomAround(originPoint, zoom);
	            this.trigger("zoomEnd", { originalEvent: e });
	        },

	        _scaleToZoom: function(scaleDelta) {
	            var scale = this._layerSize() * scaleDelta;
	            var tiles = scale / this.options.minSize;
	            var zoom = math.log(tiles) / math.log(2);

	            return math.round(zoom);
	        },

	        _reset: function() {
	            if (this.attribution) {
	                this.attribution.filter(this.center(), this.zoom());
	            }

	            this._viewOrigin = this._getOrigin(true);
	            this._resetScroller();
	            this.trigger("beforeReset");
	            this.trigger("reset");
	        },

	        _resetScroller: function() {
	            var scroller = this.scroller;
	            var x = scroller.dimensions.x;
	            var y = scroller.dimensions.y;
	            var scale = this._layerSize();
	            var nw = this.extent().nw;
	            var topLeft = this.locationToLayer(nw).round();

	            scroller.movable.round = true;
	            scroller.reset();
	            scroller.userEvents.cancel();

	            var zoom = this.zoom();
	            scroller.dimensions.forcedMinScale = pow(2, this.options.minZoom - zoom);
	            scroller.dimensions.maxScale = pow(2, this.options.maxZoom - zoom);

	            var xBounds = { min: -topLeft.x, max: scale - topLeft.x };
	            var yBounds = { min: -topLeft.y, max: scale - topLeft.y };

	            if (this.options.wraparound) {
	                xBounds.max = 20 * scale;
	                xBounds.min = -xBounds.max;
	            }

	            if (this.options.pannable === false) {
	                var viewSize = this.viewSize();
	                xBounds.min = yBounds.min = 0;
	                xBounds.max = viewSize.width;
	                yBounds.max = viewSize.height;
	            }

	            x.makeVirtual();
	            y.makeVirtual();
	            x.virtualSize(xBounds.min, xBounds.max);
	            y.virtualSize(yBounds.min, yBounds.max);

	            this._virtualSize = { x: xBounds, y: yBounds };
	        },

	        _renderLayers: function() {
	            var defs = this.options.layers,
	                layers = this.layers = [],
	                scrollWrap = this.scrollWrap;

	            scrollWrap.empty();

	            for (var i = 0; i < defs.length; i++) {
	                var options = defs[i];
	                var type = options.type || "shape";
	                var defaults = this.options.layerDefaults[type];
	                var impl = dataviz.map.layers[type];

	                layers.push(new impl(this, deepExtend({}, defaults, options)));
	            }
	        },

	        _layerSize: function(zoom) {
	            zoom = valueOrDefault(zoom, this.options.zoom);
	            return this.options.minSize * pow(2, zoom);
	        },

	        _tap: function(e) {
	            if (!this._panComplete()) {
	                return;
	            }

	            var cursor = this.eventOffset(e);
	            this.trigger("click", {
	                originalEvent: e,
	                location: this.viewToLocation(cursor)
	            });
	        },

	        _doubleTap: function(e) {
	            var options = this.options;
	            if (options.zoomable !== false) {
	                if (!this.trigger("zoomStart", { originalEvent: e })) {
	                    var toZoom = this.zoom() + DEFAULT_ZOOM_RATE;
	                    var cursor = this.eventOffset(e);
	                    var location = this.viewToLocation(cursor);
	                    var postZoom = this.locationToLayer(location, toZoom);
	                    var origin = postZoom.translate(-cursor.x, -cursor.y);
	                    this._zoomAround(origin, toZoom);
	                    this.trigger("zoomEnd", { originalEvent: e });
	                }
	            }
	        },

	        _mousewheel: function(e) {
	            e.preventDefault();
	            var delta = dataviz.mwDelta(e) > 0 ? -1 : 1;
	            var options = this.options;
	            var fromZoom = this.zoom();
	            var toZoom = limit(fromZoom + delta, options.minZoom, options.maxZoom);

	            if (options.zoomable !== false && toZoom !== fromZoom) {
	                if (!this.trigger("zoomStart", { originalEvent: e })) {
	                    var cursor = this.eventOffset(e);
	                    var location = this.viewToLocation(cursor);
	                    var postZoom = this.locationToLayer(location, toZoom);
	                    var origin = postZoom.translate(-cursor.x, -cursor.y);
	                    this._zoomAround(origin, toZoom);

	                    this.trigger("zoomEnd", { originalEvent: e });
	                }
	            }
	        }
	    });

	    // Exports ================================================================
	    dataviz.ui.plugin(Map);

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 930:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ddUy");

/***/ })

/******/ });

/***/ }),

/***/ "kQYo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ag_grid_1 = __webpack_require__("F6Mk");
var columnSelectComp_1 = __webpack_require__("LE8v");
var menuList_1 = __webpack_require__("Fjmu");
var menuItemComponent_1 = __webpack_require__("CN4P");
var menuItemMapper_1 = __webpack_require__("jsXh");
var EnterpriseMenuFactory = (function () {
    function EnterpriseMenuFactory() {
    }
    EnterpriseMenuFactory.prototype.hideActiveMenu = function () {
        if (this.activeMenu) {
            this.activeMenu.destroy();
        }
    };
    EnterpriseMenuFactory.prototype.showMenuAfterMouseEvent = function (column, mouseEvent, defaultTab) {
        var _this = this;
        this.showMenu(column, function (menu) {
            _this.popupService.positionPopupUnderMouseEvent({
                column: column,
                type: 'columnMenu',
                mouseEvent: mouseEvent,
                ePopup: menu.getGui()
            });
            if (defaultTab) {
                menu.showTab(defaultTab);
            }
        }, defaultTab);
    };
    EnterpriseMenuFactory.prototype.showMenuAfterButtonClick = function (column, eventSource, defaultTab, restrictToTabs) {
        var _this = this;
        this.showMenu(column, function (menu) {
            _this.popupService.positionPopupUnderComponent({
                column: column,
                type: 'columnMenu',
                eventSource: eventSource,
                ePopup: menu.getGui(),
                nudgeX: -9,
                nudgeY: -26,
                minWidth: menu.getMinWidth(),
                keepWithinBounds: true
            });
            if (defaultTab) {
                menu.showTab(defaultTab);
            }
        }, defaultTab, restrictToTabs);
    };
    EnterpriseMenuFactory.prototype.showMenu = function (column, positionCallback, defaultTab, restrictToTabs) {
        var _this = this;
        var menu = new EnterpriseMenu(column, this.lastSelectedTab, restrictToTabs);
        this.context.wireBean(menu);
        var eMenuGui = menu.getGui();
        // need to show filter before positioning, as only after filter
        // is visible can we find out what the width of it is
        var hidePopup = this.popupService.addAsModalPopup(eMenuGui, true, function () {
            menu.destroy();
            column.setMenuVisible(false, "contextMenu");
        });
        positionCallback(menu);
        menu.afterGuiAttached({
            hidePopup: hidePopup
        });
        if (!defaultTab) {
            menu.showTabBasedOnPreviousSelection();
        }
        menu.addEventListener(EnterpriseMenu.EVENT_TAB_SELECTED, function (event) {
            _this.lastSelectedTab = event.key;
        });
        column.setMenuVisible(true, "contextMenu");
        this.activeMenu = menu;
        menu.addEventListener(ag_grid_1.BeanStub.EVENT_DESTORYED, function () {
            if (_this.activeMenu === menu) {
                _this.activeMenu = null;
            }
        });
    };
    EnterpriseMenuFactory.prototype.isMenuEnabled = function (column) {
        return column.getMenuTabs(EnterpriseMenu.TABS_DEFAULT).length > 0;
    };
    __decorate([
        ag_grid_1.Autowired('context'),
        __metadata("design:type", ag_grid_1.Context)
    ], EnterpriseMenuFactory.prototype, "context", void 0);
    __decorate([
        ag_grid_1.Autowired('popupService'),
        __metadata("design:type", ag_grid_1.PopupService)
    ], EnterpriseMenuFactory.prototype, "popupService", void 0);
    __decorate([
        ag_grid_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", ag_grid_1.GridOptionsWrapper)
    ], EnterpriseMenuFactory.prototype, "gridOptionsWrapper", void 0);
    EnterpriseMenuFactory = __decorate([
        ag_grid_1.Bean('menuFactory')
    ], EnterpriseMenuFactory);
    return EnterpriseMenuFactory;
}());
exports.EnterpriseMenuFactory = EnterpriseMenuFactory;
var EnterpriseMenu = (function (_super) {
    __extends(EnterpriseMenu, _super);
    function EnterpriseMenu(column, initialSelection, restrictTo) {
        var _this = _super.call(this) || this;
        _this.tabFactories = {};
        _this.includeChecks = {};
        _this.column = column;
        _this.initialSelection = initialSelection;
        _this.tabFactories[EnterpriseMenu.TAB_GENERAL] = _this.createMainPanel.bind(_this);
        _this.tabFactories[EnterpriseMenu.TAB_FILTER] = _this.createFilterPanel.bind(_this);
        _this.tabFactories[EnterpriseMenu.TAB_COLUMNS] = _this.createColumnsPanel.bind(_this);
        _this.includeChecks[EnterpriseMenu.TAB_GENERAL] = function () { return true; };
        _this.includeChecks[EnterpriseMenu.TAB_FILTER] = function () {
            var isFilterEnabled = _this.gridOptionsWrapper.isEnableFilter();
            var isFloatingFiltersEnabled = _this.gridOptionsWrapper.isFloatingFilter();
            var isAnyFilteringEnabled = isFilterEnabled || isFloatingFiltersEnabled;
            var suppressFilterForThisColumn = _this.column.getColDef().suppressFilter;
            return isAnyFilteringEnabled && !suppressFilterForThisColumn;
        };
        _this.includeChecks[EnterpriseMenu.TAB_COLUMNS] = function () { return true; };
        _this.restrictTo = restrictTo;
        return _this;
    }
    EnterpriseMenu.prototype.getMinWidth = function () {
        return this.tabbedLayout.getMinWidth();
    };
    EnterpriseMenu.prototype.init = function () {
        var _this = this;
        var items = this.column.getMenuTabs(this.restrictTo ? this.restrictTo : EnterpriseMenu.TABS_DEFAULT)
            .filter(function (menuTabName) {
            return _this.isValidMenuTabItem(menuTabName);
        })
            .filter(function (menuTabName) {
            return _this.isNotSuppressed(menuTabName);
        })
            .map(function (menuTabName) {
            return _this.createTab(menuTabName);
        });
        this.tabbedLayout = new ag_grid_1.TabbedLayout({
            items: items,
            cssClass: 'ag-menu',
            onActiveItemClicked: this.onHidePopup.bind(this),
            onItemClicked: this.onTabItemClicked.bind(this)
        });
    };
    EnterpriseMenu.prototype.isValidMenuTabItem = function (menuTabName) {
        var isValid = true;
        var itemsToConsider = EnterpriseMenu.TABS_DEFAULT;
        if (this.restrictTo != null) {
            isValid = this.restrictTo.indexOf(menuTabName) > -1;
            itemsToConsider = this.restrictTo;
        }
        isValid = isValid && EnterpriseMenu.TABS_DEFAULT.indexOf(menuTabName) > -1;
        if (!isValid)
            console.warn("Trying to render an invalid menu item '" + menuTabName + "'. Check that your 'menuTabs' contains one of [" + itemsToConsider + "]");
        return isValid;
    };
    EnterpriseMenu.prototype.isNotSuppressed = function (menuTabName) {
        return this.includeChecks[menuTabName]();
    };
    EnterpriseMenu.prototype.createTab = function (name) {
        return this.tabFactories[name]();
    };
    EnterpriseMenu.prototype.showTabBasedOnPreviousSelection = function () {
        // show the tab the user was on last time they had a menu open
        this.showTab(this.initialSelection);
    };
    EnterpriseMenu.prototype.showTab = function (toShow) {
        if (this.tabItemColumns && toShow === EnterpriseMenu.TAB_COLUMNS) {
            this.tabbedLayout.showItem(this.tabItemColumns);
        }
        else if (this.tabItemFilter && toShow === EnterpriseMenu.TAB_FILTER) {
            this.tabbedLayout.showItem(this.tabItemFilter);
        }
        else if (this.tabItemGeneral && toShow === EnterpriseMenu.TAB_GENERAL) {
            this.tabbedLayout.showItem(this.tabItemGeneral);
        }
        else {
            this.tabbedLayout.showFirstItem();
        }
    };
    EnterpriseMenu.prototype.onTabItemClicked = function (event) {
        var key;
        switch (event.item) {
            case this.tabItemColumns:
                key = EnterpriseMenu.TAB_COLUMNS;
                break;
            case this.tabItemFilter:
                key = EnterpriseMenu.TAB_FILTER;
                break;
            case this.tabItemGeneral:
                key = EnterpriseMenu.TAB_GENERAL;
                break;
        }
        if (key) {
            var event_1 = {
                type: EnterpriseMenu.EVENT_TAB_SELECTED,
                key: key
            };
            this.dispatchEvent(event_1);
        }
    };
    EnterpriseMenu.prototype.destroy = function () {
        if (this.columnSelectPanel) {
            this.columnSelectPanel.destroy();
        }
        if (this.mainMenuList) {
            this.mainMenuList.destroy();
        }
        _super.prototype.destroy.call(this);
    };
    EnterpriseMenu.prototype.getMenuItems = function () {
        var defaultMenuOptions = this.getDefaultMenuOptions();
        var result;
        var userFunc = this.gridOptionsWrapper.getMainMenuItemsFunc();
        if (userFunc) {
            var userOptions = userFunc({
                column: this.column,
                api: this.gridOptionsWrapper.getApi(),
                columnApi: this.gridOptionsWrapper.getColumnApi(),
                context: this.gridOptionsWrapper.getContext(),
                defaultItems: defaultMenuOptions
            });
            result = userOptions;
        }
        else {
            result = defaultMenuOptions;
        }
        // GUI looks weird when two separators are side by side. this can happen accidentally
        // if we remove items from the menu then two separators can edit up adjacent.
        ag_grid_1.Utils.removeRepeatsFromArray(result, EnterpriseMenu.MENU_ITEM_SEPARATOR);
        return result;
    };
    EnterpriseMenu.prototype.getDefaultMenuOptions = function () {
        var result = [];
        var allowPinning = !this.column.isLockPinned();
        var rowGroupCount = this.columnController.getRowGroupColumns().length;
        var doingGrouping = rowGroupCount > 0;
        var groupedByThisColumn = this.columnController.getRowGroupColumns().indexOf(this.column) >= 0;
        var allowValue = this.column.isAllowValue();
        var allowRowGroup = this.column.isAllowRowGroup();
        var isPrimary = this.column.isPrimary();
        var pivotModeOn = this.columnController.isPivotMode();
        var isInMemoryRowModel = this.rowModel.getType() === ag_grid_1.Constants.ROW_MODEL_TYPE_IN_MEMORY;
        var allowValueAgg = 
        // if primary, then only allow aggValue if grouping and it's a value columns
        (isPrimary && doingGrouping && allowValue)
            || !isPrimary;
        if (allowPinning) {
            result.push('pinSubMenu');
        }
        if (allowValueAgg) {
            result.push('valueAggSubMenu');
        }
        if (allowPinning || allowValueAgg) {
            result.push(EnterpriseMenu.MENU_ITEM_SEPARATOR);
        }
        result.push('autoSizeThis');
        result.push('autoSizeAll');
        result.push(EnterpriseMenu.MENU_ITEM_SEPARATOR);
        if (allowRowGroup && this.column.isPrimary()) {
            if (groupedByThisColumn) {
                result.push('rowUnGroup');
            }
            else {
                result.push('rowGroup');
            }
        }
        result.push(EnterpriseMenu.MENU_ITEM_SEPARATOR);
        result.push('resetColumns');
        result.push('toolPanel');
        // only add grouping expand/collapse if grouping in the InMemoryRowModel
        // if pivoting, we only have expandable groups if grouping by 2 or more columns
        // as the lowest level group is not expandable while pivoting.
        // if not pivoting, then any active row group can be expanded.
        var allowExpandAndContract = isInMemoryRowModel && (pivotModeOn ? rowGroupCount > 1 : rowGroupCount > 0);
        if (allowExpandAndContract) {
            result.push('expandAll');
            result.push('contractAll');
        }
        return result;
    };
    EnterpriseMenu.prototype.createMainPanel = function () {
        this.mainMenuList = new menuList_1.MenuList();
        this.context.wireBean(this.mainMenuList);
        var menuItems = this.getMenuItems();
        var menuItemsMapped = this.menuItemMapper.mapWithStockItems(menuItems, this.column);
        this.mainMenuList.addMenuItems(menuItemsMapped);
        this.mainMenuList.addEventListener(menuItemComponent_1.MenuItemComponent.EVENT_ITEM_SELECTED, this.onHidePopup.bind(this));
        this.tabItemGeneral = {
            title: ag_grid_1.Utils.createIconNoSpan('menu', this.gridOptionsWrapper, this.column),
            bodyPromise: ag_grid_1.Promise.resolve(this.mainMenuList.getGui()),
            name: EnterpriseMenu.TAB_GENERAL
        };
        return this.tabItemGeneral;
    };
    EnterpriseMenu.prototype.onHidePopup = function () {
        this.hidePopupFunc();
    };
    EnterpriseMenu.prototype.createFilterPanel = function () {
        var filterWrapper = this.filterManager.getOrCreateFilterWrapper(this.column);
        var afterFilterAttachedCallback;
        filterWrapper.filterPromise.then(function (filter) {
            if (filter.afterGuiAttached) {
                afterFilterAttachedCallback = filter.afterGuiAttached.bind(filter);
            }
        });
        this.tabItemFilter = {
            title: ag_grid_1.Utils.createIconNoSpan('filter', this.gridOptionsWrapper, this.column),
            bodyPromise: filterWrapper.guiPromise.promise,
            afterAttachedCallback: afterFilterAttachedCallback,
            name: EnterpriseMenu.TAB_FILTER
        };
        return this.tabItemFilter;
    };
    EnterpriseMenu.prototype.createColumnsPanel = function () {
        var eWrapperDiv = document.createElement('div');
        ag_grid_1.Utils.addCssClass(eWrapperDiv, 'ag-menu-column-select-wrapper');
        this.columnSelectPanel = new columnSelectComp_1.ColumnSelectComp(false);
        this.context.wireBean(this.columnSelectPanel);
        eWrapperDiv.appendChild(this.columnSelectPanel.getGui());
        this.tabItemColumns = {
            title: ag_grid_1.Utils.createIconNoSpan('columns', this.gridOptionsWrapper, this.column),
            bodyPromise: ag_grid_1.Promise.resolve(eWrapperDiv),
            name: EnterpriseMenu.TAB_COLUMNS
        };
        return this.tabItemColumns;
    };
    EnterpriseMenu.prototype.afterGuiAttached = function (params) {
        this.tabbedLayout.setAfterAttachedParams({ hidePopup: params.hidePopup });
        this.hidePopupFunc = params.hidePopup;
        // if the body scrolls, we want to hide the menu, as the menu will not appear in the right location anymore
        var onBodyScroll = function (event) {
            // if h scroll, popup is no longer over the column
            if (event.direction === 'horizontal') {
                params.hidePopup();
            }
        };
        this.addDestroyFunc(params.hidePopup);
        this.addDestroyableEventListener(this.eventService, 'bodyScroll', onBodyScroll);
    };
    EnterpriseMenu.prototype.getGui = function () {
        return this.tabbedLayout.getGui();
    };
    EnterpriseMenu.EVENT_TAB_SELECTED = 'tabSelected';
    EnterpriseMenu.TAB_FILTER = 'filterMenuTab';
    EnterpriseMenu.TAB_GENERAL = 'generalMenuTab';
    EnterpriseMenu.TAB_COLUMNS = 'columnsMenuTab';
    EnterpriseMenu.TABS_DEFAULT = [EnterpriseMenu.TAB_GENERAL, EnterpriseMenu.TAB_FILTER, EnterpriseMenu.TAB_COLUMNS];
    EnterpriseMenu.MENU_ITEM_SEPARATOR = 'separator';
    __decorate([
        ag_grid_1.Autowired('columnController'),
        __metadata("design:type", ag_grid_1.ColumnController)
    ], EnterpriseMenu.prototype, "columnController", void 0);
    __decorate([
        ag_grid_1.Autowired('filterManager'),
        __metadata("design:type", ag_grid_1.FilterManager)
    ], EnterpriseMenu.prototype, "filterManager", void 0);
    __decorate([
        ag_grid_1.Autowired('context'),
        __metadata("design:type", ag_grid_1.Context)
    ], EnterpriseMenu.prototype, "context", void 0);
    __decorate([
        ag_grid_1.Autowired('gridApi'),
        __metadata("design:type", ag_grid_1.GridApi)
    ], EnterpriseMenu.prototype, "gridApi", void 0);
    __decorate([
        ag_grid_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", ag_grid_1.GridOptionsWrapper)
    ], EnterpriseMenu.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        ag_grid_1.Autowired('eventService'),
        __metadata("design:type", ag_grid_1.EventService)
    ], EnterpriseMenu.prototype, "eventService", void 0);
    __decorate([
        ag_grid_1.Autowired('menuItemMapper'),
        __metadata("design:type", menuItemMapper_1.MenuItemMapper)
    ], EnterpriseMenu.prototype, "menuItemMapper", void 0);
    __decorate([
        ag_grid_1.Autowired('rowModel'),
        __metadata("design:type", Object)
    ], EnterpriseMenu.prototype, "rowModel", void 0);
    __decorate([
        ag_grid_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], EnterpriseMenu.prototype, "init", null);
    return EnterpriseMenu;
}(ag_grid_1.BeanStub));
exports.EnterpriseMenu = EnterpriseMenu;


/***/ }),

/***/ "kXT1":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1631);
	module.exports = __webpack_require__(1631);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1578:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("I2Wh");

/***/ }),

/***/ 1631:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1578) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	    "use strict";

	    var $ = kendo.jQuery;

	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var spreadsheet = kendo.spreadsheet;

	    var exports = {};
	    spreadsheet.validation = exports;
	    var calc = spreadsheet.calc;
	    var Class = kendo.Class;
	    var TRANSPOSE_FORMAT = "_matrix({0})";
	    var DATE_FORMAT = 'DATEVALUE("{0}")';

	    calc.runtime.defineFunction("_matrix", function(m){
	        if (typeof m == "string") {
	            // for constant list validation, Excel includes a string
	            // with comma-separated values — make a Matrix from it.
	            m = this.asMatrix([ m.split(/\s*,\s*/) ]);
	        }
	        return m;
	    }).args([
	        [ "m", [ "or", "matrix", "string" ] ]
	    ]);

	    function compileValidation(sheet, row, col, validation) {
	        var validationHandler;
	        var comparer;
	        var parsedFromDate;
	        var parsedToDate;

	        if (typeof validation === "string") {
	            validation = JSON.parse(validation);
	        }

	        if (validation.from) {
	            if (validation.dataType === "list" && !validation.fromIsListValue) {
	                // We need to convert the {...} validation.from value to a string, so that it would work when exported to XLSX
	                if(validation.from.indexOf("{") > -1) {
	                    validation.from = validation.from.replace(/\"/g,"").replace("{","\"").replace("}", "\"");
	                }
	                validation.from = kendo.format(TRANSPOSE_FORMAT, validation.from);
	                validation.fromIsListValue = true;
	            }

	            if (validation.dataType === "date") {
	                parsedFromDate = calc.runtime.parseDate(validation.from);
	                if (parsedFromDate) {
	                    validation.from = kendo.format(DATE_FORMAT, validation.from);
	                    validation.fromIsDateValue = true;
	                }
	            }

	            validation.from = calc.compile(calc.parseFormula(sheet, row, col, validation.from));
	        }

	        if (validation.to) {
	            if (validation.dataType === "date") {
	                parsedToDate = calc.runtime.parseDate(validation.to);
	                if (parsedToDate) {
	                    validation.to = kendo.format(DATE_FORMAT, validation.to);
	                    validation.toIsDateValue = true;
	                }
	            }

	            validation.to = calc.compile(calc.parseFormula(sheet, row, col, validation.to));
	        }

	        if (validation.dataType == "custom") {
	            comparer = exports.validationComparers.custom;
	        } else if (validation.dataType == "list") {
	            comparer = exports.validationComparers.list;
	        } else {
	            comparer = exports.validationComparers[validation.comparerType];
	        }

	        if (!comparer) {
	            throw kendo.format("'{0}' comparer is not implemented.", validation.comparerType);
	        }

	        validationHandler = function (valueToCompare) { //add 'valueFormat' arg when add isDate comparer
	            var toValue = this.to && (this.to_value || this.to_value === 0) ? this.to_value : undefined;

	            if (valueToCompare === null || valueToCompare === "") {
	                if (this.allowNulls) {
	                    this.value = true;
	                } else {
	                    this.value = false;
	                }
	            } else if (this.dataType == "custom") {
	                this.value = comparer(valueToCompare, this.from_value,  toValue);
	            } else if (this.dataType == "list") {
	                var data = this._getListData();

	                this.value = comparer(valueToCompare, data, toValue);
	            } else {
	                //TODO: TYPE CHECK IS REQUIRED ONLY FOR DATE TYPE WHEN SPECIAL COMPARER (ISDATE) IS USED
	                this.value = comparer(valueToCompare, this.from_value,  toValue);
	            }

	            return this.value;
	        };

	        return new kendo.spreadsheet.validation.Validation($.extend(validation, {
	            handler: validationHandler,
	            sheet: sheet,
	            row: row,
	            col: col
	        }));
	    }

	    var Validation = Class.extend({
	        init: function Validation(options){
	            this.handler = options.handler;
	            this.from = options.from;
	            this.to = options.to;
	            this.dataType = options.dataType; //date, time etc
	            this.comparerType =  options.comparerType; //greaterThan, EqaulTo etc
	            this.type = options.type ? options.type : "warning"; //info, warning, reject
	            this.allowNulls = options.allowNulls ? true : false;
	            this.fromIsDateValue = options.fromIsDateValue ? true : false;
	            this.toIsDateValue = options.toIsDateValue ? true : false;
	            this.showButton = options.showButton;
	            this.fromIsListValue = options.fromIsListValue ? true : false;

	            //TODO: address to be range / cell ref, and adjust it based on it
	            this.sheet = options.sheet;
	            this.row = options.row;
	            this.col = options.col;

	            if (options.tooltipMessageTemplate) {
	                this.tooltipMessageTemplate = options.tooltipMessageTemplate;
	            }

	            if (options.tooltipTitleTemplate) {
	                this.tooltipTitleTemplate = options.tooltipTitleTemplate;
	            }

	            if (options.messageTemplate) {
	                this.messageTemplate = options.messageTemplate;
	            }

	            if (options.titleTemplate) {
	                this.titleTemplate = options.titleTemplate;
	            }
	        },

	        _formatMessages: function(format) {
	            var from = this.from ? this.from_value : "";
	            var to = this.to ? this.to_value : "";

	            var fromFormula = this.from ? this.from.toString() : "";
	            var toFormula = this.to ? this.to.toString() : "";
	            var dataType = this.dataType;
	            var type = this.type;
	            var comparerType = this.comparerType;

	            return kendo.format(format, from, to, fromFormula, toFormula, dataType, type, comparerType);
	        },

	        _setMessages: function() {
	            this.title = "";
	            this.message = "";

	            if (this.tooltipTitleTemplate) {
	                this.tooltipTitle = this._formatMessages(this.tooltipTitleTemplate);
	            }

	            if (this.tooltipMessageTemplate) {
	                this.tooltipMessage = this._formatMessages(this.tooltipMessageTemplate);
	            }

	            if (this.titleTemplate) {
	                this.title = this._formatMessages(this.titleTemplate);
	            }

	            if (this.messageTemplate) {
	                this.message = this._formatMessages(this.messageTemplate);
	            }
	        },

	        _getListData: function() {
	            if (!this.from_value || !this.from_value.data) {
	                return [];
	            }

	            var cube = this.from_value.data;
	            var i;
	            var y;
	            var data = [];

	            for (i = 0; i < cube.length; i++ ) {
	                var array = cube[i];

	                if (array) {
	                    for (y = 0; y < array.length; y++ ) {
	                        data.push(array[y]);
	                    }
	                }
	            }

	            return data;
	        },

	        clone: function(sheet, row, col) {
	            var options = this._getOptions();

	            if (options.from) {
	                options.from = options.from.clone(sheet, row, col);
	            }

	            if (options.to) {
	                options.to = options.to.clone(sheet, row, col);
	            }

	            return new Validation($.extend(options,
	                { handler: this.handler },
	                { sheet: sheet, row: row, col: col }
	            ));
	        },

	        deepClone: function() {
	            var v = new Validation(this);
	            v.from = v.from.deepClone();
	            if (v.to) {
	                v.to = v.to.deepClone();
	            }
	            return v;
	        },

	        exec: function(ss, compareValue, compareFormat, callback) {
	            var self = this;

	            function getValue(val) {
	                if (val instanceof kendo.spreadsheet.Ref) {
	                    val = ss.getData(val);
	                    if (Array.isArray(val)) {
	                        val = val[0];
	                    }
	                }
	                return val;
	            }

	            var calculateFromCallBack = function(val) {
	                self.from_value = getValue(val);
	                self.value = self.handler.call(self, compareValue, compareFormat);
	                self._setMessages();
	                if (callback) {
	                    callback(self.value);
	                }
	            };

	            if (self.to) {
	                self.to.exec(ss, function(val) {
	                    self.to_value = getValue(val);
	                    self.from.exec(ss, calculateFromCallBack);
	                });
	            } else {
	                self.from.exec(ss, calculateFromCallBack);
	            }
	        },

	        reset: function() {
	            if (this.from) {
	                this.from.reset();
	            }
	            if (this.to) {
	                this.to.reset();
	            }
	            delete this.value;
	        },

	        adjust: function(affectedSheet, operation, start, delta) {
	            var prevFrom, prevTo, modified;
	            var formulaRow = this.row;
	            var formulaCol = this.col;
	            if (this.from) {
	                prevFrom = this.from.adjust(affectedSheet, operation, start, delta);
	            }
	            if (this.to) {
	                prevTo = this.to.adjust(affectedSheet, operation, start, delta);
	            }
	            if (this.sheet.toLowerCase() == affectedSheet.toLowerCase()) {
	                switch (operation) {
	                  case "row":
	                    if (formulaRow >= start) {
	                        modified = true;
	                        this.row += delta;
	                    }
	                    break;
	                  case "col":
	                    if (formulaCol >= start) {
	                        modified = true;
	                        this.col += delta;
	                    }
	                    break;
	                }
	            }
	            if (modified || prevFrom || prevTo) {
	                var v = new Validation(this);
	                v.from = prevFrom;
	                v.to = prevTo;
	                v.row = formulaRow;
	                v.col = formulaCol;
	                return v;
	            }
	        },

	        toJSON: function() {
	            var options = this._getOptions();

	            if (options.from) {
	                options.from = options.from.toString();

	                if (options.dataType === "list") {
	                    options.from = options.from.replace(/^_matrix\((.*)\)$/i, "$1");
	                    delete options.fromIsListValue;
	                }

	                if (options.dataType === "date") {
	                    if (this.fromIsDateValue) {
	                        options.from = options.from.replace(/^DATEVALUE\("(.*)"\)$/i, "$1");
	                        delete options.fromIsDateValue;
	                    }
	                }
	            }

	            if (options.to) {
	                options.to = options.to.toString();

	                if (options.dataType === "date") {
	                    if (this.toIsDateValue) {
	                        options.to = options.to.replace(/^DATEVALUE\("(.*)"\)$/i, "$1");
	                        delete options.toIsDateValue;
	                    }
	                }
	            }

	            return options;
	        },

	        _getOptions: function () {
	            return {
	                from: this.from,
	                to: this.to,
	                dataType: this.dataType,
	                type: this.type,
	                comparerType: this.comparerType,
	                row: this.row,
	                col: this.col,
	                sheet: this.sheet,
	                allowNulls: this.allowNulls,
	                fromIsListValue: this.fromIsListValue,
	                fromIsDateValue: this.fromIsDateValue,
	                toIsDateValue: this.toIsDateValue,
	                tooltipMessageTemplate: this.tooltipMessageTemplate,
	                tooltipTitleTemplate: this.tooltipTitleTemplate,
	                //TODO: export generated messages instead?
	                messageTemplate: this.messageTemplate,
	                titleTemplate: this.titleTemplate,
	                showButton: this.showButton
	            };
	        }
	    });
	    exports.compile = compileValidation;
	    exports.validationComparers = {
	        greaterThan: function (valueToCompare, from) {
	            return valueToCompare > from;
	        },

	        lessThan: function (valueToCompare, from) {
	            return valueToCompare < from;
	        },

	        between: function (valueToCompare, from, to) {
	            return valueToCompare >= from && valueToCompare <= to;
	        },

	        equalTo: function (valueToCompare, from) {
	            return valueToCompare == from;
	        },

	        notEqualTo: function (valueToCompare, from) {
	            return valueToCompare != from;
	        },

	        greaterThanOrEqualTo: function (valueToCompare, from) {
	            return valueToCompare >= from;
	        },

	        lessThanOrEqualTo: function (valueToCompare, from) {
	            return valueToCompare <= from;
	        },

	        notBetween: function (valueToCompare, from, to) {
	            return valueToCompare < from || valueToCompare > to;
	        },

	        custom: function (valueToCompare, from) {
	            return from;
	        },

	        list: function (valueToCompare, data) {
	            return data.indexOf(valueToCompare) > -1;
	        }
	    };

	    exports.Validation = Validation;


	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "lOnJ":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "lQLJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1579);
	module.exports = __webpack_require__(1579);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1579:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var RangeRef = kendo.spreadsheet.RangeRef;
	    var CellRef = kendo.spreadsheet.CellRef;

	    var AutoFillCalculator = kendo.Class.extend({
	        init: function(grid) {
	            this._grid = grid;
	        },

	        rectIsVertical: function(start, end, x, y) {
	            var startRect = this._grid.rectangle(start.toRangeRef());
	            var endRect = this._grid.rectangle(end.toRangeRef());
	            return Math.abs(endRect[y] - startRect[y]) > Math.abs(startRect[x] - endRect[x]);
	        },

	        autoFillDest: function(selection, cursor) {
	            var topLeft = selection.topLeft;
	            var bottomRight = selection.bottomRight;

	            var quadrant;
	            var lower = cursor.row >= topLeft.row;
	            var further = cursor.col >= topLeft.col;

	            if (lower) {
	                quadrant = further ? 4 : 3;
	            } else {
	                quadrant = further ? 2 : 1;
	            }

	            var pivot, opposite, cornerResult, expanding;

	            if (quadrant === 4) {
	                pivot = topLeft;
	                opposite = bottomRight;

	                expanding = cursor.row > opposite.row || cursor.col > opposite.col;

	                if (expanding) {
	                    cursor = new CellRef(Math.max(cursor.row, opposite.row), Math.max(cursor.col, opposite.col));
	                }

	                if (this.rectIsVertical(opposite, cursor, 'right', 'bottom')) { // vertical
	                    cornerResult = new CellRef(cursor.row, opposite.col);
	                } else {
	                    cornerResult = new CellRef(opposite.row, cursor.col);
	                }
	            } else if (quadrant === 3) {
	                var bottomLeft = new CellRef(topLeft.col, bottomRight.row);

	                if (cursor.row > bottomRight.row && this.rectIsVertical(bottomLeft, cursor, 'left', 'bottom')) { // vertical
	                    pivot = topLeft;
	                    cornerResult = new CellRef(cursor.row, bottomRight.col);
	                } else {
	                    pivot = bottomRight;
	                    cornerResult = new CellRef(topLeft.row, cursor.col);
	                }
	            } else if (quadrant === 2){
	                var topRight = new CellRef(topLeft.row, bottomRight.col);

	                if (cursor.col > bottomRight.col && !this.rectIsVertical(topRight, cursor, 'right', 'top')) { // horizontal
	                    pivot = topLeft;
	                    cornerResult = new CellRef(bottomRight.row, cursor.col);
	                } else {
	                    pivot = bottomRight;
	                    cornerResult = new CellRef(cursor.row, topLeft.col);
	                }
	            } else {
	                pivot = bottomRight;
	                if (this.rectIsVertical(topLeft, cursor, 'left', 'top')) { // horizontal
	                    cornerResult = new CellRef(cursor.row, topLeft.col);
	                } else {
	                    cornerResult = new CellRef(topLeft.row, cursor.col);
	                }
	            }

	            return this._grid.normalize(new RangeRef(pivot, cornerResult));
	        }
	    });

	    kendo.spreadsheet.AutoFillCalculator = AutoFillCalculator;
	})(kendo);
	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "lQjy":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1454);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1045:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FTkt");

/***/ }),

/***/ 1046:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2btM");

/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1053:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1kkP");

/***/ }),

/***/ 1054:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CRfZ");

/***/ }),

/***/ 1055:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("AJsk");

/***/ }),

/***/ 1056:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("TC33");

/***/ }),

/***/ 1057:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("3i6F");

/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1068:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("S/9S");

/***/ }),

/***/ 1069:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("jBxA");

/***/ }),

/***/ 1070:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("bFti");

/***/ }),

/***/ 1075:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("BHwR");

/***/ }),

/***/ 1078:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("qo2y");

/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1087:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("WuVc");

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FZAa");

/***/ }),

/***/ 1089:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("+Uqz");

/***/ }),

/***/ 1092:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("apSr");

/***/ }),

/***/ 1097:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("WPfE");

/***/ }),

/***/ 1098:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("rS7A");

/***/ }),

/***/ 1103:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7Omp");

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Dz7c");

/***/ }),

/***/ 1105:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ef9w");

/***/ }),

/***/ 1106:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("iFTV");

/***/ }),

/***/ 1107:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MWyb");

/***/ }),

/***/ 1108:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ydSV");

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1121:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("eN7V");

/***/ }),

/***/ 1166:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("f1E8");

/***/ }),

/***/ 1167:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("bfur");

/***/ }),

/***/ 1169:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ismk");

/***/ }),

/***/ 1170:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("zQRd");

/***/ }),

/***/ 1172:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("oX25");

/***/ }),

/***/ 1187:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("99zt");

/***/ }),

/***/ 1190:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("JKVm");

/***/ }),

/***/ 1191:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1Z35");

/***/ }),

/***/ 1192:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("3Bvt");

/***/ }),

/***/ 1193:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("E+tE");

/***/ }),

/***/ 1232:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("wIIu");

/***/ }),

/***/ 1233:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("o4s/");

/***/ }),

/***/ 1234:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("9BzU");

/***/ }),

/***/ 1241:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Owf0");

/***/ }),

/***/ 1243:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("pYWG");

/***/ }),

/***/ 1245:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("trYX");

/***/ }),

/***/ 1249:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("9fcU");

/***/ }),

/***/ 1252:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("HQQe");

/***/ }),

/***/ 1253:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("n1t0");

/***/ }),

/***/ 1254:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("U8qt");

/***/ }),

/***/ 1255:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("QI4T");

/***/ }),

/***/ 1256:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("vGlF");

/***/ }),

/***/ 1259:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("UtsZ");

/***/ }),

/***/ 1261:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("jvub");

/***/ }),

/***/ 1262:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("EDhZ");

/***/ }),

/***/ 1264:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Z9Q2");

/***/ }),

/***/ 1268:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("H/kR");

/***/ }),

/***/ 1269:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7Y4C");

/***/ }),

/***/ 1270:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("4Nap");

/***/ }),

/***/ 1271:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CHw0");

/***/ }),

/***/ 1272:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nAZz");

/***/ }),

/***/ 1273:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MiQa");

/***/ }),

/***/ 1274:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("tHOz");

/***/ }),

/***/ 1275:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("mxBz");

/***/ }),

/***/ 1277:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("SDgz");

/***/ }),

/***/ 1280:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("qrfa");

/***/ }),

/***/ 1289:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("5AFk");

/***/ }),

/***/ 1291:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nce5");

/***/ }),

/***/ 1354:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("YlOY");

/***/ }),

/***/ 1355:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ed5Q");

/***/ }),

/***/ 1367:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("iVlI");

/***/ }),

/***/ 1368:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("kPaM");

/***/ }),

/***/ 1369:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("dWoE");

/***/ }),

/***/ 1370:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Cyi2");

/***/ }),

/***/ 1371:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("W8+b");

/***/ }),

/***/ 1439:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("zmaz");

/***/ }),

/***/ 1440:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1pYj");

/***/ }),

/***/ 1441:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7qx9");

/***/ }),

/***/ 1442:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7coT");

/***/ }),

/***/ 1443:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("c+Wt");

/***/ }),

/***/ 1444:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("YiI9");

/***/ }),

/***/ 1445:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("qZXN");

/***/ }),

/***/ 1446:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CLcD");

/***/ }),

/***/ 1447:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FPoQ");

/***/ }),

/***/ 1448:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("gVfB");

/***/ }),

/***/ 1454:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1049),
	        __webpack_require__(1105),
	        __webpack_require__(1106),
	        __webpack_require__(1104),
	        __webpack_require__(1046),
	        __webpack_require__(1097),
	        __webpack_require__(1098),
	        __webpack_require__(1059),
	        __webpack_require__(1274),
	        __webpack_require__(1275),
	        __webpack_require__(1107),
	        __webpack_require__(1108),
	        __webpack_require__(1045),
	        __webpack_require__(1057),
	        __webpack_require__(1088),
	        __webpack_require__(1109),
	        __webpack_require__(1069),
	        __webpack_require__(1271),
	        __webpack_require__(1268),
	        __webpack_require__(1190),
	        __webpack_require__(1273),
	        __webpack_require__(1078),
	        __webpack_require__(1455),
	        __webpack_require__(1089),
	        __webpack_require__(1243),
	        __webpack_require__(1234),
	        __webpack_require__(1252),
	        __webpack_require__(1272),
	        __webpack_require__(1086),
	        __webpack_require__(1440),
	        __webpack_require__(1103),
	        __webpack_require__(1068),
	        __webpack_require__(1166),
	        __webpack_require__(1170),
	        __webpack_require__(1167),
	        __webpack_require__(1456),
	        __webpack_require__(1169),
	        __webpack_require__(1245),
	        __webpack_require__(1054),
	        __webpack_require__(1055),
	        __webpack_require__(1053),
	        __webpack_require__(1056),
	        __webpack_require__(1457),
	        __webpack_require__(1192),
	        __webpack_require__(1270),
	        __webpack_require__(1269),
	        __webpack_require__(1261),
	        __webpack_require__(1232),
	        __webpack_require__(1441),
	        __webpack_require__(1442),
	        __webpack_require__(1280),
	        __webpack_require__(1193),
	        __webpack_require__(1458),
	        __webpack_require__(1187),
	        __webpack_require__(1444),
	        __webpack_require__(1459),
	        __webpack_require__(1092),
	        __webpack_require__(1249),
	        __webpack_require__(1460),
	        __webpack_require__(1461),
	        __webpack_require__(1462),
	        __webpack_require__(1445),
	        __webpack_require__(1277),
	        __webpack_require__(1446),
	        __webpack_require__(1447),
	        __webpack_require__(1172),
	        __webpack_require__(1291),
	        __webpack_require__(1262),
	        __webpack_require__(1463),
	        __webpack_require__(1264),
	        __webpack_require__(1355),
	        __webpack_require__(1464),
	        __webpack_require__(1087),
	        __webpack_require__(1448),
	        __webpack_require__(1233),
	        __webpack_require__(1241),
	        __webpack_require__(1191),
	        __webpack_require__(1070),
	        __webpack_require__(1369),
	        __webpack_require__(1367),
	        __webpack_require__(1370),
	        __webpack_require__(1371),
	        __webpack_require__(1368),
	        __webpack_require__(1465),
	        __webpack_require__(1253),
	        __webpack_require__(1254),
	        __webpack_require__(1255),
	        __webpack_require__(1256),
	        __webpack_require__(1466),
	        __webpack_require__(1467),
	        __webpack_require__(1259),
	        __webpack_require__(1354),
	        __webpack_require__(1468),
	        __webpack_require__(1469),
	        __webpack_require__(1470),
	        __webpack_require__(1471),
	        __webpack_require__(1472),
	        __webpack_require__(1121),
	        __webpack_require__(1075),
	        __webpack_require__(1473),
	        __webpack_require__(1474),
	        __webpack_require__(1443),
	        __webpack_require__(1439),
	        __webpack_require__(1475),
	        __webpack_require__(1289),
	        __webpack_require__(1476),
	        __webpack_require__(1477),
	        __webpack_require__(1478),
	        __webpack_require__(1479)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	    "bundle all";
	    return window.kendo;
	}, __webpack_require__(3));


/***/ }),

/***/ 1455:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Sx1C");

/***/ }),

/***/ 1456:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MRGr");

/***/ }),

/***/ 1457:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LmCc");

/***/ }),

/***/ 1458:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("5Y9s");

/***/ }),

/***/ 1459:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("9geK");

/***/ }),

/***/ 1460:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("zObk");

/***/ }),

/***/ 1461:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("synp");

/***/ }),

/***/ 1462:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("bbfP");

/***/ }),

/***/ 1463:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("KYVy");

/***/ }),

/***/ 1464:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("7XY/");

/***/ }),

/***/ 1465:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("PIXw");

/***/ }),

/***/ 1466:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Cloa");

/***/ }),

/***/ 1467:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("AhMq");

/***/ }),

/***/ 1468:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Hjpe");

/***/ }),

/***/ 1469:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("UVEK");

/***/ }),

/***/ 1470:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("+0l1");

/***/ }),

/***/ 1471:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ZDqD");

/***/ }),

/***/ 1472:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("XY8W");

/***/ }),

/***/ 1473:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("rYKI");

/***/ }),

/***/ 1474:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2Mfy");

/***/ }),

/***/ 1475:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("8Fbg");

/***/ }),

/***/ 1476:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("YPT/");

/***/ }),

/***/ 1477:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("txAZ");

/***/ }),

/***/ 1478:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("b9Tm");

/***/ }),

/***/ 1479:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("H99H");

/***/ })

/******/ });

/***/ }),

/***/ "lXhv":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1096);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1096:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1097), __webpack_require__(1098) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "data",
	    name: "Data source",
	    category: "framework",
	    description: "Powerful component for using local and remote data.Fully supports CRUD, Sorting, Paging, Filtering, Grouping, and Aggregates.",
	    depends: [ "core" ],
	    features: [ {
	        id: "data-odata",
	        name: "OData",
	        description: "Support for accessing Open Data Protocol (OData) services.",
	        depends: [ "data.odata" ]
	    }, {
	        id: "data-signalr",
	        name: "SignalR",
	        description: "Support for binding to SignalR hubs.",
	        depends: [ "data.signalr" ]
	    }, {
	        id: "data-XML",
	        name: "XML",
	        description: "Support for binding to XML.",
	        depends: [ "data.xml" ]
	    }]
	};

	/*jshint eqnull: true, loopfunc: true, evil: true */
	(function($, undefined) {
	    var extend = $.extend,
	        proxy = $.proxy,
	        isPlainObject = $.isPlainObject,
	        isEmptyObject = $.isEmptyObject,
	        isArray = $.isArray,
	        grep = $.grep,
	        ajax = $.ajax,
	        map,
	        each = $.each,
	        noop = $.noop,
	        kendo = window.kendo,
	        isFunction = kendo.isFunction,
	        Observable = kendo.Observable,
	        Class = kendo.Class,
	        STRING = "string",
	        FUNCTION = "function",
	        ASCENDING = "asc",
	        CREATE = "create",
	        READ = "read",
	        UPDATE = "update",
	        DESTROY = "destroy",
	        CHANGE = "change",
	        SYNC = "sync",
	        GET = "get",
	        ERROR = "error",
	        REQUESTSTART = "requestStart",
	        PROGRESS = "progress",
	        REQUESTEND = "requestEnd",
	        crud = [CREATE, READ, UPDATE, DESTROY],
	        identity = function(o) { return o; },
	        getter = kendo.getter,
	        stringify = kendo.stringify,
	        math = Math,
	        push = [].push,
	        join = [].join,
	        pop = [].pop,
	        splice = [].splice,
	        shift = [].shift,
	        slice = [].slice,
	        unshift = [].unshift,
	        toString = {}.toString,
	        stableSort = kendo.support.stableSort,
	        dateRegExp = /^\/Date\((.*?)\)\/$/,
	        objectKeys = [];

	    var ObservableArray = Observable.extend({
	        init: function(array, type) {
	            var that = this;

	            that.type = type || ObservableObject;

	            Observable.fn.init.call(that);

	            that.length = array.length;

	            that.wrapAll(array, that);
	        },

	        at: function(index) {
	            return this[index];
	        },

	        toJSON: function(serializeFunctions) {
	            var idx, length = this.length, value, json = new Array(length);

	            for (idx = 0; idx < length; idx++){
	                value = this[idx];

	                if (value instanceof ObservableObject) {
	                    value = value.toJSON(serializeFunctions);
	                }

	                json[idx] = value;
	            }

	            return json;
	        },

	        parent: noop,

	        wrapAll: function(source, target) {
	            var that = this,
	                idx,
	                length,
	                parent = function() {
	                    return that;
	                };

	            target = target || [];

	            for (idx = 0, length = source.length; idx < length; idx++) {
	                target[idx] = that.wrap(source[idx], parent);
	            }

	            return target;
	        },

	        wrap: function(object, parent) {
	            var that = this,
	                observable;

	            if (object !== null && toString.call(object) === "[object Object]") {
	                observable = object instanceof that.type || object instanceof Model;

	                if (!observable) {
	                    object = object instanceof ObservableObject ? object.toJSON() : object;
	                    object = new that.type(object);
	                }

	                object.parent = parent;

	                object.bind(CHANGE, function(e) {
	                    that.trigger(CHANGE, {
	                        field: e.field,
	                        node: e.node,
	                        index: e.index,
	                        items: e.items || [this],
	                        action: e.node ? (e.action || "itemloaded") : "itemchange"
	                    });
	                });
	            }

	            return object;
	        },

	        push: function() {
	            var index = this.length,
	                items = this.wrapAll(arguments),
	                result;

	            result = push.apply(this, items);

	            if (!this.omitChangeEvent) {
	                this.trigger(CHANGE, {
	                    action: "add",
	                    index: index,
	                    items: items
	                });
	            }

	            return result;
	        },

	        slice: slice,

	        sort: [].sort,

	        join: join,

	        pop: function() {
	            var length = this.length, result = pop.apply(this);

	            if (length) {
	                this.trigger(CHANGE, {
	                    action: "remove",
	                    index: length - 1,
	                    items:[result]
	                });
	            }

	            return result;
	        },

	        splice: function(index, howMany, item) {
	            var items = this.wrapAll(slice.call(arguments, 2)),
	                result, i, len;

	            result = splice.apply(this, [index, howMany].concat(items));

	            if (result.length) {
	                this.trigger(CHANGE, {
	                    action: "remove",
	                    index: index,
	                    items: result
	                });

	                for (i = 0, len = result.length; i < len; i++) {
	                    if (result[i] && result[i].children) {
	                        result[i].unbind(CHANGE);
	                    }
	                }
	            }

	            if (item) {
	                this.trigger(CHANGE, {
	                    action: "add",
	                    index: index,
	                    items: items
	                });
	            }
	            return result;
	        },

	        shift: function() {
	            var length = this.length, result = shift.apply(this);

	            if (length) {
	                this.trigger(CHANGE, {
	                    action: "remove",
	                    index: 0,
	                    items:[result]
	                });
	            }

	            return result;
	        },

	        unshift: function() {
	            var items = this.wrapAll(arguments),
	                result;

	            result = unshift.apply(this, items);

	            this.trigger(CHANGE, {
	                action: "add",
	                index: 0,
	                items: items
	            });

	            return result;
	        },

	        indexOf: function(item) {
	            var that = this,
	                idx,
	                length;

	            for (idx = 0, length = that.length; idx < length; idx++) {
	                if (that[idx] === item) {
	                    return idx;
	                }
	            }
	            return -1;
	        },

	        forEach: function(callback, thisArg) {
	            var idx = 0;
	            var length = this.length;
	            var context = thisArg || window;

	            for (; idx < length; idx++) {
	                callback.call(context, this[idx], idx, this);
	            }
	        },

	        map: function(callback, thisArg) {
	            var idx = 0;
	            var result = [];
	            var length = this.length;
	            var context = thisArg || window;

	            for (; idx < length; idx++) {
	                result[idx] = callback.call(context, this[idx], idx, this);
	            }

	            return result;
	        },

	        reduce: function(callback) {
	            var idx = 0,
	                result,
	                length = this.length;

	            if (arguments.length == 2) {
	                result = arguments[1];
	            } else if (idx < length) {
	                result = this[idx++];
	            }

	            for (; idx < length; idx++) {
	                result = callback(result, this[idx], idx, this);
	            }

	            return result;
	        },

	        reduceRight: function(callback) {
	            var idx = this.length - 1,
	                result;

	            if (arguments.length == 2) {
	                result = arguments[1];
	            } else if (idx > 0) {
	                result = this[idx--];
	            }

	            for (; idx >= 0; idx--) {
	                result = callback(result, this[idx], idx, this);
	            }

	            return result;
	        },

	        filter: function(callback, thisArg) {
	            var idx = 0;
	            var result = [];
	            var item;
	            var length = this.length;
	            var context = thisArg || window;

	            for (; idx < length; idx++) {
	                item = this[idx];
	                if (callback.call(context, item, idx, this)) {
	                    result[result.length] = item;
	                }
	            }

	            return result;
	        },

	        find: function(callback, thisArg) {
	            var idx = 0;
	            var item;
	            var length = this.length;
	            var context = thisArg || window;

	            for (; idx < length; idx++) {
	                item = this[idx];
	                if (callback.call(context, item, idx, this)) {
	                    return item;
	                }
	            }
	        },

	        every: function(callback, thisArg) {
	            var idx = 0;
	            var item;
	            var length = this.length;
	            var context = thisArg || window;

	            for (; idx < length; idx++) {
	                item = this[idx];
	                if (!callback.call(context, item, idx, this)) {
	                    return false;
	                }
	            }

	            return true;
	        },

	        some: function(callback, thisArg) {
	            var idx = 0;
	            var item;
	            var length = this.length;
	            var context = thisArg || window;

	            for (; idx < length; idx++) {
	                item = this[idx];
	                if (callback.call(context, item, idx, this)) {
	                    return true;
	                }
	            }

	            return false;
	        },

	        // non-standard collection methods
	        remove: function(item) {
	            var idx = this.indexOf(item);

	            if (idx !== -1) {
	                this.splice(idx, 1);
	            }
	        },

	        empty: function() {
	            this.splice(0, this.length);
	        }
	    });

	    // Polyfill for Symbol.iterator
	    if (typeof Symbol !== "undefined" && Symbol.iterator && !ObservableArray.prototype[Symbol.iterator]) {
	        ObservableArray.prototype[Symbol.iterator] = [][Symbol.iterator];
	    }

	    var LazyObservableArray = ObservableArray.extend({
	        init: function (data, type, events) {
	            Observable.fn.init.call(this);

	            this.type = type || ObservableObject;

	            if (events) {
	                this._events = events;
	            }

	            for (var idx = 0; idx < data.length; idx++) {
	                this[idx] = data[idx];
	            }

	            this.length = idx;
	            this._parent = proxy(function() { return this; }, this);
	        },
	        at: function(index) {
	            var item = this[index];

	            if (!(item instanceof this.type)) {
	                item = this[index] = this.wrap(item, this._parent);
	            } else {
	                item.parent = this._parent;
	            }

	            return item;
	        }
	    });

	    function eventHandler(context, type, field, prefix) {
	        return function(e) {
	            var event = {}, key;

	            for (key in e) {
	                event[key] = e[key];
	            }

	            if (prefix) {
	                event.field = field + "." + e.field;
	            } else {
	                event.field = field;
	            }

	            if (type == CHANGE && context._notifyChange) {
	                context._notifyChange(event);
	            }

	            context.trigger(type, event);
	        };
	    }

	    function ownKeys (value, ignoreObjectKeys) {
	        var props = [];

	        value = value || {};

	        while (value) {
	            Object.getOwnPropertyNames(value).forEach(function (prop) {
	                if (props.indexOf(prop) === -1 && (!ignoreObjectKeys || objectKeys.indexOf(prop) < 0)) {
	                    props.push(prop);
	                }
	            });
	            value = Object.getPrototypeOf(value);
	        }

	        return props;
	    }

	    objectKeys = ownKeys({}, false);

	    var ObservableObject = Observable.extend({
	        init: function(value) {
	            var that = this,
	                member,
	                keys = ownKeys(value, true),
	                parent = function() {
	                    return that;
	                };

	            Observable.fn.init.call(this);

	            this._handlers = {};

	            keys.forEach(function(field){
	                member = value[field];

	                if (typeof member === "object" && member && !member.getTime && field.charAt(0) != "_") {
	                    member = that.wrap(member, field, parent);
	                }

	                that[field] = member;
	            });

	            that.uid = kendo.guid();
	        },

	        shouldSerialize: function(field, serializeFunctions) {
	            return this.hasOwnProperty(field) && field !== "_handlers" && field !== "_events" && ((serializeFunctions && serializeFunctions[field]) || typeof this[field] !== FUNCTION) && field !== "uid";
	        },

	        forEach: function(f) {
	            for (var i in this) {
	                if (this.shouldSerialize(i)) {
	                    f(this[i], i);
	                }
	            }
	        },

	        toJSON: function (serializeFunctions) {
	            var result = {}, value, field;

	            for (field in this) {
	                if (this.shouldSerialize(field, serializeFunctions)) {
	                    value = this[field];

	                    if (value instanceof ObservableObject || value instanceof ObservableArray) {
	                        value = value.toJSON(serializeFunctions);
	                    }

	                    result[field] = value;
	                }
	            }

	            return result;
	        },

	        get: function(field) {
	            var that = this, result;

	            that.trigger(GET, { field: field });

	            if (field === "this") {
	                result = that;
	            } else {
	                result = kendo.getter(field, true)(that);
	            }

	            return result;
	        },

	        _set: function(field, value) {
	            var that = this;
	            var composite = field.indexOf(".") >= 0;

	            if (composite) {
	                var paths = field.split("."),
	                    path = "";

	                while (paths.length > 1) {
	                    path += paths.shift();
	                    var obj = kendo.getter(path, true)(that);
	                    if (obj instanceof ObservableObject) {
	                        obj.set(paths.join("."), value);
	                        return composite;
	                    }
	                    path += ".";
	                }
	            }

	            kendo.setter(field)(that, value);

	            return composite;
	        },

	        set: function(field, value) {
	            var that = this,
	                isSetPrevented = false,
	                composite = field.indexOf(".") >= 0,
	                current = kendo.getter(field, true)(that);

	            if (current !== value) {
	                if (current instanceof Observable && this._handlers[field]) {
	                    if (this._handlers[field].get) {
	                       current.unbind(GET, this._handlers[field].get);
	                    }
	                    current.unbind(CHANGE, this._handlers[field].change);
	                }

	                isSetPrevented = that.trigger("set", { field: field, value: value });

	                if (!isSetPrevented) {
	                    if (!composite) {
	                        value = that.wrap(value, field, function() { return that; });
	                    }
	                    if (!that._set(field, value) || field.indexOf("(") >= 0 || field.indexOf("[") >= 0) {
	                        that.trigger(CHANGE, { field: field });
	                    }
	                }
	            }

	            return isSetPrevented;
	        },

	        parent: noop,

	        wrap: function(object, field, parent) {
	            var that = this;
	            var get;
	            var change;
	            var type = toString.call(object);

	            if (object != null && (type === "[object Object]" || type === "[object Array]")) {
	                var isObservableArray = object instanceof ObservableArray;
	                var isDataSource = object instanceof DataSource;

	                if (type === "[object Object]" && !isDataSource && !isObservableArray) {
	                    if (!(object instanceof ObservableObject)) {
	                        object = new ObservableObject(object);
	                    }

	                    get = eventHandler(that, GET, field, true);
	                    object.bind(GET, get);
	                    change = eventHandler(that, CHANGE, field, true);
	                    object.bind(CHANGE, change);

	                    that._handlers[field] = { get: get, change: change };
	                } else if (type === "[object Array]" || isObservableArray || isDataSource) {
	                    if (!isObservableArray && !isDataSource) {
	                        object = new ObservableArray(object);
	                    }

	                    change = eventHandler(that, CHANGE, field, false);

	                    object.bind(CHANGE, change);

	                    that._handlers[field] = { change: change };
	                }

	                object.parent = parent;
	            }

	            return object;
	        }
	    });

	    function equal(x, y) {
	        if (x === y) {
	            return true;
	        }

	        var xtype = $.type(x), ytype = $.type(y), field;

	        if (xtype !== ytype) {
	            return false;
	        }

	        if (xtype === "date") {
	            return x.getTime() === y.getTime();
	        }

	        if (xtype !== "object" && xtype !== "array") {
	            return false;
	        }

	        for (field in x) {
	            if (!equal(x[field], y[field])) {
	                return false;
	            }
	        }

	        return true;
	    }

	    var parsers = {
	        "number": function(value) {
	            if (typeof value === STRING && value.toLowerCase() === "null") {
	                return null;
	            }
	            return kendo.parseFloat(value);
	        },

	        "date": function(value) {
	            if (typeof value === STRING && value.toLowerCase() === "null") {
	                return null;
	            }
	            return kendo.parseDate(value);
	        },

	        "boolean": function(value) {
	            if (typeof value === STRING) {
	                if (value.toLowerCase() === "null") {
	                    return null;
	                } else {
	                    return value.toLowerCase() === "true";
	                }
	            }
	            return value != null ? !!value : value;
	        },

	        "string": function(value) {
	            if (typeof value === STRING && value.toLowerCase() === "null") {
	                return null;
	            }
	            return value != null ? (value + "") : value;
	        },

	        "default": function(value) {
	            return value;
	        }
	    };

	    var defaultValues = {
	        "string": "",
	        "number": 0,
	        "date": new Date(),
	        "boolean": false,
	        "default": ""
	    };

	    function getFieldByName(obj, name) {
	        var field,
	            fieldName;

	        for (fieldName in obj) {
	            field = obj[fieldName];
	            if (isPlainObject(field) && field.field && field.field === name) {
	                return field;
	            } else if (field === name) {
	                return field;
	            }
	        }
	        return null;
	    }

	    var Model = ObservableObject.extend({
	        init: function(data) {
	            var that = this;

	            if (!data || $.isEmptyObject(data)) {
	                data = $.extend({}, that.defaults, data);

	                if (that._initializers) {
	                    for (var idx = 0; idx < that._initializers.length; idx++) {
	                         var name = that._initializers[idx];
	                         data[name] = that.defaults[name]();
	                    }
	                }
	            }

	            ObservableObject.fn.init.call(that, data);

	            that.dirty = false;
	            that.dirtyFields = {};

	            if (that.idField) {
	                that.id = that.get(that.idField);

	                if (that.id === undefined) {
	                    that.id = that._defaultId;
	                }
	            }
	        },

	        shouldSerialize: function(field) {
	            return ObservableObject.fn.shouldSerialize.call(this, field) &&
	                field !== "uid" && !(this.idField !== "id" && field === "id") &&
	                field !== "dirty" &&  field !== "dirtyFields" && field !== "_accessors";
	        },

	        _parse: function(field, value) {
	            var that = this,
	                fieldName = field,
	                fields = (that.fields || {}),
	                parse;

	            field = fields[field];
	            if (!field) {
	                field = getFieldByName(fields, fieldName);
	            }
	            if (field) {
	                parse = field.parse;
	                if (!parse && field.type) {
	                    parse = parsers[field.type.toLowerCase()];
	                }
	            }

	            return parse ? parse(value) : value;
	        },

	        _notifyChange: function(e) {
	            var action = e.action;

	            if (action == "add" || action == "remove") {
	                this.dirty = true;
	                this.dirtyFields[e.field] = true;
	            }
	        },

	        editable: function(field) {
	            field = (this.fields || {})[field];
	            return field ? field.editable !== false : true;
	        },

	        set: function(field, value) {
	            var that = this;
	            var dirty = that.dirty;

	            if (that.editable(field)) {
	                value = that._parse(field, value);

	                if (!equal(value, that.get(field))) {
	                    that.dirty = true;
	                    that.dirtyFields[field] = true;

	                    if (ObservableObject.fn.set.call(that, field, value) && !dirty) {
	                        that.dirty = dirty;

	                        if (!that.dirty) {
	                            that.dirtyFields[field] = false;
	                        }
	                    }
	                } else {
	                    that.trigger("equalSet", { field: field, value: value });
	                }
	            }
	        },

	        accept: function(data) {
	            var that = this,
	                parent = function() { return that; },
	                field;

	            for (field in data) {
	                var value = data[field];

	                if (field.charAt(0) != "_") {
	                    value = that.wrap(data[field], field, parent);
	                }

	                that._set(field, value);
	            }

	            if (that.idField) {
	                that.id = that.get(that.idField);
	            }

	            that.dirty = false;
	            that.dirtyFields = {};
	        },

	        isNew: function() {
	            return this.id === this._defaultId;
	        }
	    });

	    Model.define = function(base, options) {
	        if (options === undefined) {
	            options = base;
	            base = Model;
	        }

	        var model,
	            proto = extend({ defaults: {} }, options),
	            name,
	            field,
	            type,
	            value,
	            idx,
	            length,
	            fields = {},
	            originalName,
	            id = proto.id,
	            functionFields = [];

	        if (id) {
	            proto.idField = id;
	        }

	        if (proto.id) {
	            delete proto.id;
	        }

	        if (id) {
	            proto.defaults[id] = proto._defaultId = "";
	        }

	        if (toString.call(proto.fields) === "[object Array]") {
	            for (idx = 0, length = proto.fields.length; idx < length; idx++) {
	                field = proto.fields[idx];
	                if (typeof field === STRING) {
	                    fields[field] = {};
	                } else if (field.field) {
	                    fields[field.field] = field;
	                }
	            }
	            proto.fields = fields;
	        }

	        for (name in proto.fields) {
	            field = proto.fields[name];
	            type = field.type || "default";
	            value = null;
	            originalName = name;

	            name = typeof (field.field) === STRING ? field.field : name;

	            if (!field.nullable) {
	                value = proto.defaults[originalName !== name ? originalName : name] = field.defaultValue !== undefined ? field.defaultValue : defaultValues[type.toLowerCase()];

	                if (typeof value === "function") {
	                    functionFields.push(name);
	                }
	            }

	            if (options.id === name) {
	                proto._defaultId = value;
	            }

	            proto.defaults[originalName !== name ? originalName : name] = value;

	            field.parse = field.parse || parsers[type];
	        }

	        if (functionFields.length > 0) {
	            proto._initializers = functionFields;
	        }

	        model = base.extend(proto);
	        model.define = function(options) {
	            return Model.define(model, options);
	        };

	        if (proto.fields) {
	            model.fields = proto.fields;
	            model.idField = proto.idField;
	        }

	        return model;
	    };

	    var Comparer = {
	        selector: function(field) {
	            return isFunction(field) ? field : getter(field);
	        },

	        compare: function(field) {
	            var selector = this.selector(field);
	            return function (a, b) {
	                a = selector(a);
	                b = selector(b);

	                if (a == null && b == null) {
	                    return 0;
	                }

	                if (a == null) {
	                    return -1;
	                }

	                if (b == null) {
	                    return 1;
	                }

	                if (a.localeCompare) {
	                    return a.localeCompare(b);
	                }

	                return a > b ? 1 : (a < b ? -1 : 0);
	            };
	        },

	        create: function(sort) {
	            var compare = sort.compare || this.compare(sort.field);

	            if (sort.dir == "desc") {
	                return function(a, b) {
	                    return compare(b, a, true);
	                };
	            }

	            return compare;
	        },

	        combine: function(comparers) {
	            return function(a, b) {
	                var result = comparers[0](a, b),
	                    idx,
	                    length;

	                for (idx = 1, length = comparers.length; idx < length; idx ++) {
	                    result = result || comparers[idx](a, b);
	                }

	                return result;
	            };
	        }
	    };

	    var StableComparer = extend({}, Comparer, {
	        asc: function(field) {
	            var selector = this.selector(field);
	            return function (a, b) {
	                var valueA = selector(a);
	                var valueB = selector(b);

	                if (valueA && valueA.getTime && valueB && valueB.getTime) {
	                    valueA = valueA.getTime();
	                    valueB = valueB.getTime();
	                }

	                if (valueA === valueB) {
	                    return a.__position - b.__position;
	                }

	                if (valueA == null) {
	                    return -1;
	                }

	                if (valueB == null) {
	                    return 1;
	                }

	                if (valueA.localeCompare) {
	                    return valueA.localeCompare(valueB);
	                }

	                return valueA > valueB ? 1 : -1;
	            };
	        },

	        desc: function(field) {
	            var selector = this.selector(field);
	            return function (a, b) {
	                var valueA = selector(a);
	                var valueB = selector(b);

	                if (valueA && valueA.getTime && valueB && valueB.getTime) {
	                    valueA = valueA.getTime();
	                    valueB = valueB.getTime();
	                }

	                if (valueA === valueB) {
	                    return a.__position - b.__position;
	                }

	                if (valueA == null) {
	                    return 1;
	                }

	                if (valueB == null) {
	                    return -1;
	                }

	                if (valueB.localeCompare) {
	                    return valueB.localeCompare(valueA);
	                }

	                return valueA < valueB ? 1 : -1;
	            };
	        },
	        create: function(sort) {
	           return this[sort.dir](sort.field);
	        }
	    });

	    map = function (array, callback) {
	        var idx, length = array.length, result = new Array(length);

	        for (idx = 0; idx < length; idx++) {
	            result[idx] = callback(array[idx], idx, array);
	        }

	        return result;
	    };

	    var operators = (function(){

	        function quote(str) {
	            if (typeof str == "string") {
	                str = str.replace(/[\r\n]+/g, "");
	            }
	            return JSON.stringify(str);
	        }

	        function textOp(impl) {
	            return function(a, b, ignore, accentFoldingFiltering) {
	                b += "";
	                if (ignore) {
	                    a = "(" + a + " + '').toString()" + ((accentFoldingFiltering) ? ".toLocaleLowerCase('" + accentFoldingFiltering  +"')" : ".toLowerCase()");
	                    b = ((accentFoldingFiltering) ? b.toLocaleLowerCase(accentFoldingFiltering) : b.toLowerCase());
	                }
	                return impl(a, quote(b), ignore);
	            };
	        }

	        function operator(op, a, b, ignore, accentFoldingFiltering) {
	            if (b != null) {
	                if (typeof b === STRING) {
	                    var date = dateRegExp.exec(b);
	                    if (date) {
	                        b = new Date(+date[1]);
	                    } else if (ignore) {
	                        b = quote(((accentFoldingFiltering) ? b.toLocaleLowerCase(accentFoldingFiltering) : b.toLowerCase()));
	                        a = "((" + a + " || '')+'')" + ((accentFoldingFiltering) ? ".toLocaleLowerCase('" + accentFoldingFiltering  +"')" : ".toLowerCase()");
	                    } else {
	                        b = quote(b);
	                    }
	                }

	                if (b.getTime) {
	                    //b looks like a Date
	                    a = "(" + a + "&&" + a + ".getTime?" + a + ".getTime():" + a + ")";
	                    b = b.getTime();
	                }
	            }

	            return a + " " + op + " " + b;
	        }

	        function getMatchRegexp(pattern) {
	            // take a pattern, as supported by Excel match filter, and
	            // convert it to the equivalent JS regular expression.
	            // Excel patterns support:
	            //
	            //   * - match any sequence of characters
	            //   ? - match a single character
	            //
	            // to match a literal * or ?, they must be prefixed by a tilde (~)
	            for (var rx = "/^", esc = false, i = 0; i < pattern.length; ++i) {
	                var ch = pattern.charAt(i);
	                if (esc) {
	                    rx += "\\" + ch;
	                } else if (ch == "~") {
	                    esc = true;
	                    continue;
	                } else if (ch == "*") {
	                    rx += ".*";
	                } else if (ch == "?") {
	                    rx += ".";
	                } else if (".+^$()[]{}|\\/\n\r\u2028\u2029\xA0".indexOf(ch) >= 0) {
	                    rx += "\\" + ch;
	                } else {
	                    rx += ch;
	                }
	                esc = false;
	            }
	            return rx + "$/";
	        }

	        return {
	            quote: function(value) {
	                if (value && value.getTime) {
	                    return "new Date(" + value.getTime() + ")";
	                }
	                return quote(value);
	            },
	            eq: function(a, b, ignore, accentFoldingFiltering) {
	                return operator("==", a, b, ignore, accentFoldingFiltering);
	            },
	            neq: function(a, b, ignore, accentFoldingFiltering) {
	                return operator("!=", a, b, ignore, accentFoldingFiltering);
	            },
	            gt: function(a, b, ignore) {
	                return operator(">", a, b, ignore);
	            },
	            gte: function(a, b, ignore) {
	                return operator(">=", a, b, ignore);
	            },
	            lt: function(a, b, ignore) {
	                return operator("<", a, b, ignore);
	            },
	            lte: function(a, b, ignore) {
	                return operator("<=", a, b, ignore);
	            },
	            startswith: textOp(function(a, b) {
	                return a + ".lastIndexOf(" + b + ", 0) == 0";
	            }),
	            doesnotstartwith: textOp(function(a, b) {
	                return a + ".lastIndexOf(" + b + ", 0) == -1";
	            }),
	            endswith: textOp(function(a, b) {
	                var n = b ? b.length - 2 : 0;
	                return a + ".indexOf(" + b + ", " + a + ".length - " + n + ") >= 0";
	            }),
	            doesnotendwith: textOp(function(a, b) {
	                var n = b ? b.length - 2 : 0;
	                return a + ".indexOf(" + b + ", " + a + ".length - " + n + ") < 0";
	            }),
	            contains: textOp(function(a, b) {
	                return a + ".indexOf(" + b + ") >= 0";
	            }),
	            doesnotcontain: textOp(function(a, b) {
	                return a + ".indexOf(" + b + ") == -1";
	            }),
	            matches: textOp(function(a, b){
	                b = b.substring(1, b.length - 1);
	                return getMatchRegexp(b) + ".test(" + a + ")";
	            }),
	            doesnotmatch: textOp(function(a, b){
	                b = b.substring(1, b.length - 1);
	                return "!" + getMatchRegexp(b) + ".test(" + a + ")";
	            }),
	            isempty: function(a) {
	                return a + " === ''";
	            },
	            isnotempty: function(a) {
	                return a + " !== ''";
	            },
	            isnull: function(a) {
	                return "(" + a + " == null)";
	            },
	            isnotnull: function(a) {
	                return "(" + a + " != null)";
	            },
	            isnullorempty: function(a) {
	                return "(" + a + " === null) || (" + a + " === '')";
	            },
	            isnotnullorempty: function(a) {
	                return "(" + a + " !== null) && (" + a + " !== '')";
	            }
	        };
	    })();

	    function Query(data) {
	        this.data = data || [];
	    }

	    Query.filterExpr = function(expression) {
	        var expressions = [],
	            logic = { and: " && ", or: " || " },
	            idx,
	            length,
	            filter,
	            expr,
	            fieldFunctions = [],
	            operatorFunctions = [],
	            field,
	            operator,
	            filters = expression.filters;

	        for (idx = 0, length = filters.length; idx < length; idx++) {
	            filter = filters[idx];
	            field = filter.field;
	            operator = filter.operator;

	            if (filter.filters) {
	                expr = Query.filterExpr(filter);
	                //Nested function fields or operators - update their index e.g. __o[0] -> __o[1]
	                filter = expr.expression
	                .replace(/__o\[(\d+)\]/g, function(match, index) {
	                    index = +index;
	                    return "__o[" + (operatorFunctions.length + index) + "]";
	                })
	                .replace(/__f\[(\d+)\]/g, function(match, index) {
	                    index = +index;
	                    return "__f[" + (fieldFunctions.length + index) + "]";
	                });

	                operatorFunctions.push.apply(operatorFunctions, expr.operators);
	                fieldFunctions.push.apply(fieldFunctions, expr.fields);
	            } else {
	                if (typeof field === FUNCTION) {
	                    expr = "__f[" + fieldFunctions.length +"](d)";
	                    fieldFunctions.push(field);
	                } else {
	                    expr = kendo.expr(field);
	                }

	                if (typeof operator === FUNCTION) {
	                    filter = "__o[" + operatorFunctions.length + "](" + expr + ", " + operators.quote(filter.value) + ")";
	                    operatorFunctions.push(operator);
	                } else {
	                    filter = operators[(operator || "eq").toLowerCase()](expr, filter.value, filter.ignoreCase !== undefined? filter.ignoreCase : true, expression.accentFoldingFiltering);
	                }
	            }

	            expressions.push(filter);
	        }

	        return  { expression: "(" + expressions.join(logic[expression.logic]) + ")", fields: fieldFunctions, operators: operatorFunctions };
	    };

	    function normalizeSort(field, dir) {
	        if (field) {
	            var descriptor = typeof field === STRING ? { field: field, dir: dir } : field,
	            descriptors = isArray(descriptor) ? descriptor : (descriptor !== undefined ? [descriptor] : []);

	            return grep(descriptors, function(d) { return !!d.dir; });
	        }
	    }

	    function sortFields(sorts, dir) {
	        var sortObject = {};

	        if (sorts) {
	            var descriptor = typeof sorts === STRING ? { field: sorts, dir: dir } : sorts,
	            descriptors = isArray(descriptor) ? descriptor : (descriptor !== undefined ? [descriptor] : []);

	            for (var i = 0; i < descriptors.length; i++) {
	                sortObject[descriptors[i].field] = { dir: descriptors[i].dir, index: i + 1 };
	            }
	        }

	        return sortObject;
	    }

	    var operatorMap = {
	        "==": "eq",
	        equals: "eq",
	        isequalto: "eq",
	        equalto: "eq",
	        equal: "eq",
	        "!=": "neq",
	        ne: "neq",
	        notequals: "neq",
	        isnotequalto: "neq",
	        notequalto: "neq",
	        notequal: "neq",
	        "<": "lt",
	        islessthan: "lt",
	        lessthan: "lt",
	        less: "lt",
	        "<=": "lte",
	        le: "lte",
	        islessthanorequalto: "lte",
	        lessthanequal: "lte",
	        ">": "gt",
	        isgreaterthan: "gt",
	        greaterthan: "gt",
	        greater: "gt",
	        ">=": "gte",
	        isgreaterthanorequalto: "gte",
	        greaterthanequal: "gte",
	        ge: "gte",
	        notsubstringof: "doesnotcontain",
	        isnull: "isnull",
	        isempty: "isempty",
	        isnotempty: "isnotempty"
	    };

	    function normalizeOperator(expression) {
	        var idx,
	        length,
	        filter,
	        operator,
	        filters = expression.filters;

	        if (filters) {
	            for (idx = 0, length = filters.length; idx < length; idx++) {
	                filter = filters[idx];
	                operator = filter.operator;

	                if (operator && typeof operator === STRING) {
	                    filter.operator = operatorMap[operator.toLowerCase()] || operator;
	                }

	                normalizeOperator(filter);
	            }
	        }
	    }

	    function normalizeFilter(expression) {
	        if (expression && !isEmptyObject(expression)) {
	            if (isArray(expression) || !expression.filters) {
	                expression = {
	                    logic: "and",
	                    filters: isArray(expression) ? expression : [expression]
	                };
	            }

	            normalizeOperator(expression);

	            return expression;
	        }
	    }

	    Query.normalizeFilter = normalizeFilter;

	    function compareDescriptor(f1, f2) {
	        if (f1.logic || f2.logic) {
	            return false;
	        }

	        return f1.field === f2.field && f1.value === f2.value && f1.operator === f2.operator;
	    }

	    function normalizeDescriptor(filter) {
	        filter = filter || {};

	        if (isEmptyObject(filter)) {
	            return { logic: "and", filters: [] };
	        }

	        return normalizeFilter(filter);
	    }

	    function fieldComparer(a, b) {
	        if (b.logic || (a.field > b.field)) {
	            return 1;
	        } else if (a.field < b.field) {
	            return -1;
	        } else {
	            return 0;
	        }
	    }

	    function compareFilters(expr1, expr2) {
	        expr1 = normalizeDescriptor(expr1);
	        expr2 = normalizeDescriptor(expr2);

	        if (expr1.logic !== expr2.logic) {
	            return false;
	        }

	        var f1, f2;
	        var filters1 = (expr1.filters || []).slice();
	        var filters2 = (expr2.filters || []).slice();

	        if (filters1.length !== filters2.length) {
	            return false;
	        }

	        filters1 = filters1.sort(fieldComparer);
	        filters2 = filters2.sort(fieldComparer);

	        for (var idx = 0; idx < filters1.length; idx++) {
	            f1 = filters1[idx];
	            f2 = filters2[idx];

	            if (f1.logic && f2.logic) {
	                if (!compareFilters(f1, f2)) {
	                    return false;
	                }
	            } else if (!compareDescriptor(f1, f2)) {
	                return false;
	            }
	        }

	        return true;
	    }

	    Query.compareFilters = compareFilters;

	    function normalizeAggregate(expressions) {
	        return isArray(expressions) ? expressions : [expressions];
	    }

	    function normalizeGroup(field, dir, compare, skipItemSorting) {
	        var descriptor = typeof field === STRING ? { field: field, dir: dir, compare: compare, skipItemSorting : skipItemSorting } : field,
	        descriptors = isArray(descriptor) ? descriptor : (descriptor !== undefined ? [descriptor] : []);

	        return map(descriptors, function(d) {
	            return {
	                field: d.field,
	                dir: d.dir || "asc",
	                aggregates: d.aggregates,
	                compare: d.compare,
	                skipItemSorting: d.skipItemSorting
	            };
	        });
	    }

	    function normalizeGroupWithoutCompare(field, dir, compare) {
	        var descriptors = normalizeGroup(field, dir, compare);

	        for (var i = 0; i < descriptors.length; i++) {
	            delete descriptors[i].compare;
	        }

	        return descriptors;
	    }

	    function anyGroupDescriptorHasCompare(groupDescriptors) {
	        var descriptors = isArray(groupDescriptors) ? groupDescriptors : [groupDescriptors];

	        for (var i = 0; i < descriptors.length; i++) {
	            if (descriptors[i] && isFunction(descriptors[i].compare)) {
	                return true;
	            }
	        }

	        return false;
	    }

	    Query.prototype = {
	        toArray: function () {
	            return this.data;
	        },
	        range: function(index, count) {
	            return new Query(this.data.slice(index, index + count));
	        },
	        skip: function (count) {
	            return new Query(this.data.slice(count));
	        },
	        take: function (count) {
	            return new Query(this.data.slice(0, count));
	        },
	        select: function (selector) {
	            return new Query(map(this.data, selector));
	        },
	        order: function(selector, dir, inPlace) {
	            var sort = { dir: dir };

	            if (selector) {
	                if (selector.compare) {
	                    sort.compare = selector.compare;
	                } else {
	                    sort.field = selector;
	                }
	            }

	            if (inPlace) {
	                return new Query(this.data.sort(Comparer.create(sort)));
	            }

	            return new Query(this.data.slice(0).sort(Comparer.create(sort)));
	        },
	        orderBy: function(selector, inPlace) {
	            return this.order(selector, "asc", inPlace);
	        },
	        orderByDescending: function(selector, inPlace) {
	            return this.order(selector, "desc", inPlace);
	        },
	        sort: function(field, dir, comparer, inPlace) {
	            var idx,
	            length,
	            descriptors = normalizeSort(field, dir),
	            comparers = [];

	            comparer = comparer || Comparer;

	            if (descriptors.length) {
	                for (idx = 0, length = descriptors.length; idx < length; idx++) {
	                    comparers.push(comparer.create(descriptors[idx]));
	                }

	                return this.orderBy({ compare: comparer.combine(comparers) }, inPlace);
	            }

	            return this;
	        },

	        filter: function(expressions) {
	            var idx,
	            current,
	            length,
	            compiled,
	            predicate,
	            data = this.data,
	            fields,
	            operators,
	            result = [],
	            filter;

	            expressions = normalizeFilter(expressions);

	            if (!expressions || expressions.filters.length === 0) {
	                return this;
	            }

	            compiled = Query.filterExpr(expressions);
	            fields = compiled.fields;
	            operators = compiled.operators;

	            predicate = filter = new Function("d, __f, __o", "return " + compiled.expression);

	            if (fields.length || operators.length) {
	                filter = function(d) {
	                    return predicate(d, fields, operators);
	                };
	            }


	            for (idx = 0, length = data.length; idx < length; idx++) {
	                current = data[idx];

	                if (filter(current)) {
	                    result.push(current);
	                }
	            }

	            return new Query(result);
	        },

	        group: function(descriptors, allData, options) {
	            descriptors =  normalizeGroup(descriptors || []);
	            allData = allData || this.data;

	            var that = this,
	            result = new Query(that.data),
	            descriptor;

	            if (descriptors.length > 0) {
	                descriptor = descriptors[0];

	                if (options && options.groupPaging) {
	                    result = new Query(allData).groupAllData(descriptor, allData).select(function (group) {
	                        var data = new Query(allData).filter([{
	                            field: group.field,
	                            operator: "eq",
	                            value: group.value,
	                            ignoreCase: false
	                        }]);
	                        var items = descriptors.length > 1 ? new Query(group.items).group(descriptors.slice(1), data.toArray(), options).toArray() : group.items;
	                        return {
	                            field: group.field,
	                            value: group.value,
	                            hasSubgroups: descriptors.length > 1,
	                            items: items,
	                            aggregates: data.aggregate(descriptor.aggregates),
	                            uid: kendo.guid(),
	                            itemCount: items.length,
	                            subgroupCount: items.length
	                        };
	                    });

	                } else {
	                    result = result.groupBy(descriptor).select(function(group) {
	                        var data = new Query(allData).filter([ { field: group.field, operator: "eq", value: group.value, ignoreCase: false } ]);
	                        return {
	                            field: group.field,
	                            value: group.value,
	                            items: descriptors.length > 1 ? new Query(group.items).group(descriptors.slice(1), data.toArray()).toArray() : group.items,
	                            hasSubgroups: descriptors.length > 1,
	                            aggregates: data.aggregate(descriptor.aggregates)
	                        };
	                    });
	                }
	            }
	            return result;
	        },

	        groupBy: function(descriptor) {
	            var that = this;

	            if (isEmptyObject(descriptor) || !this.data.length) {
	                return new Query([]);
	            }

	            var field = descriptor.field,
	                sorted = descriptor.skipItemSorting ? this.data : this._sortForGrouping(field, descriptor.dir || "asc"),
	                accessor = kendo.accessor(field),
	                item,
	                groupValue = accessor.get(sorted[0], field),
	                group = {
	                    field: field,
	                    value: groupValue,
	                    items: []
	                },
	                currentValue,
	                idx,
	                len,
	                result = [group];

	            for(idx = 0, len = sorted.length; idx < len; idx++) {
	                item = sorted[idx];
	                currentValue = accessor.get(item, field);
	                if(!groupValueComparer(groupValue, currentValue)) {
	                    groupValue = currentValue;
	                    group = {
	                        field: field,
	                        value: groupValue,
	                        items: []
	                    };
	                    result.push(group);
	                }
	                group.items.push(item);
	            }

	            result = that._sortGroups(result, descriptor);

	            return new Query(result);
	        },

	        groupAllData: function (descriptor, allData) {
	            if (isEmptyObject(descriptor) || this.data && !this.data.length) {
	                return new Query([]);
	            }

	            var field = descriptor.field,
	                sorted = descriptor.skipItemSorting ? allData : new Query(allData).sort(field, descriptor.dir || "asc", StableComparer).toArray(),
	                accessor = kendo.accessor(field),
	                item,
	                groupValue = accessor.get(sorted[0], field),
	                group = {
	                    field: field,
	                    value: groupValue,
	                    items: []
	                },
	                currentValue,
	                idx,
	                len,
	                result = [group];

	            for (idx = 0, len = sorted.length; idx < len; idx++) {
	                item = sorted[idx];
	                currentValue = accessor.get(item, field);
	                if (!groupValueComparer(groupValue, currentValue)) {
	                    groupValue = currentValue;
	                    group = {
	                        field: field,
	                        value: groupValue,
	                        items: []
	                    };
	                    result.push(group);
	                }
	                group.items.push(item);
	            }

	            result = this._sortGroups(result, descriptor);

	            return new Query(result);
	        },

	        _sortForGrouping: function(field, dir) {
	            var idx, length,
	                data = this.data;

	            if (!stableSort) {
	                for (idx = 0, length = data.length; idx < length; idx++) {
	                    data[idx].__position = idx;
	                }

	                data = new Query(data).sort(field, dir, StableComparer).toArray();

	                for (idx = 0, length = data.length; idx < length; idx++) {
	                    delete data[idx].__position;
	                }
	                return data;
	            }

	            return this.sort(field, dir).toArray();
	        },

	        _sortGroups: function(groups, descriptor) {
	            var result = groups;

	            if (descriptor && isFunction(descriptor.compare)) {
	                result = new Query(result).order({ compare: descriptor.compare }, descriptor.dir || ASCENDING).toArray();
	            }

	            return result;
	        },

	        aggregate: function (aggregates) {
	            var idx,
	                len,
	                result = {},
	                state = {};

	            if (aggregates && aggregates.length) {
	                for(idx = 0, len = this.data.length; idx < len; idx++) {
	                    calculateAggregate(result, aggregates, this.data[idx], idx, len, state);
	                }
	            }
	            return result;
	        }
	    };

	    function groupValueComparer(a, b) {
	        if (a && a.getTime && b && b.getTime) {
	            return a.getTime() === b.getTime();
	        }
	        return a === b;
	    }

	    function calculateAggregate(accumulator, aggregates, item, index, length, state) {
	        aggregates = aggregates || [];
	        var idx,
	            aggr,
	            functionName,
	            len = aggregates.length;

	        for (idx = 0; idx < len; idx++) {
	            aggr = aggregates[idx];
	            functionName = aggr.aggregate;
	            var field = aggr.field;
	            accumulator[field] = accumulator[field] || {};
	            state[field] = state[field] || {};
	            state[field][functionName] = state[field][functionName] || {};
	            accumulator[field][functionName] = functions[functionName.toLowerCase()](accumulator[field][functionName], item, kendo.accessor(field), index, length, state[field][functionName]);
	        }
	    }

	    var functions = {
	        sum: function(accumulator, item, accessor) {
	            var value = accessor.get(item);

	            if (!isNumber(accumulator)) {
	                accumulator = value;
	            } else if (isNumber(value)) {
	                accumulator += value;
	            }

	            return accumulator;
	        },
	        count: function(accumulator) {
	            return (accumulator || 0) + 1;
	        },
	        average: function(accumulator, item, accessor, index, length, state) {
	            var value = accessor.get(item);

	            if (state.count === undefined) {
	                state.count = 0;
	            }

	            if (!isNumber(accumulator)) {
	                accumulator = value;
	            } else if (isNumber(value)) {
	                accumulator += value;
	            }

	            if (isNumber(value)) {
	                state.count++;
	            }

	            if(index == length - 1 && isNumber(accumulator)) {
	                accumulator = accumulator / state.count;
	            }
	            return accumulator;
	        },
	        max: function(accumulator, item, accessor) {
	            var value = accessor.get(item);

	            if (!isNumber(accumulator) && !isDate(accumulator)) {
	                accumulator = value;
	            }

	            if(accumulator < value && (isNumber(value) || isDate(value))) {
	                accumulator = value;
	            }
	            return accumulator;
	        },
	        min: function(accumulator, item, accessor) {
	            var value = accessor.get(item);

	            if (!isNumber(accumulator) && !isDate(accumulator)) {
	                accumulator = value;
	            }

	            if(accumulator > value && (isNumber(value) || isDate(value))) {
	                accumulator = value;
	            }
	            return accumulator;
	        }
	    };

	    function isNumber(val) {
	        return typeof val === "number" && !isNaN(val);
	    }

	    function isDate(val) {
	        return val && val.getTime;
	    }

	    function toJSON(array) {
	        var idx, length = array.length, result = new Array(length);

	        for (idx = 0; idx < length; idx++) {
	            result[idx] = array[idx].toJSON();
	        }

	        return result;
	    }

	    Query.normalizeGroup = normalizeGroup;
	    Query.normalizeSort = normalizeSort;

	    Query.process = function(data, options, inPlace) {
	        options = options || {};

	        var group = options.group;
	        var customGroupSort = anyGroupDescriptorHasCompare(normalizeGroup(group || []));
	        var query = new Query(data),
	            groupDescriptorsWithoutCompare = normalizeGroupWithoutCompare(group || []),
	            normalizedSort = normalizeSort(options.sort || []),
	            sort = customGroupSort ? normalizedSort : groupDescriptorsWithoutCompare.concat(normalizedSort),
	            groupDescriptorsWithoutSort,
	            total,
	            filterCallback = options.filterCallback,
	            filter = options.filter,
	            skip = options.skip,
	            take = options.take;

	        if (sort && inPlace) {
	            query = query.sort(sort, undefined, undefined, inPlace);
	        }

	        if (filter) {
	            query = query.filter(filter);

	            if (filterCallback) {
	                query = filterCallback(query);
	            }

	            total = query.toArray().length;
	        }

	        if (sort) {
	            if (!inPlace) {
	                query = query.sort(sort);
	            }

	            if (group) {
	                data = query.toArray();
	            }
	        }

	        if (customGroupSort) {
	            query = query.group(group, data);

	            if (skip !== undefined && take !== undefined) {
	                query = new Query(flatGroups(query.toArray())).range(skip, take);

	                groupDescriptorsWithoutSort = map(groupDescriptorsWithoutCompare, function(groupDescriptor) {
	                    return extend({}, groupDescriptor, {
	                        skipItemSorting: true
	                    });
	                });

	                query = query.group(groupDescriptorsWithoutSort, data);
	            }
	        } else {
	            if (skip !== undefined && take !== undefined) {
	                query = query.range(skip, take);
	            }

	            if (group) {
	                query = query.group(group, data, options);
	            }
	        }

	        return {
	            total: total,
	            data: query.toArray()
	        };
	    };

	    var LocalTransport = Class.extend({
	        init: function(options) {
	            this.data = options.data;
	        },

	        read: function(options) {
	            options.success(this.data);
	        },
	        update: function(options) {
	            options.success(options.data);
	        },
	        create: function(options) {
	            options.success(options.data);
	        },
	        destroy: function(options) {
	            options.success(options.data);
	        }
	    });

	    var RemoteTransport = Class.extend( {
	        init: function(options) {
	            var that = this, parameterMap;

	            options = that.options = extend({}, that.options, options);

	            each(crud, function(index, type) {
	                if (typeof options[type] === STRING) {
	                    options[type] = {
	                        url: options[type]
	                    };
	                }
	            });

	            that.cache = options.cache? Cache.create(options.cache) : {
	                find: noop,
	                add: noop
	            };

	            parameterMap = options.parameterMap;

	            if (options.submit) {
	                that.submit = options.submit;
	            }

	            if (isFunction(options.push)) {
	                that.push = options.push;
	            }

	            if (!that.push) {
	                that.push = identity;
	            }

	            that.parameterMap = isFunction(parameterMap) ? parameterMap : function(options) {
	                var result = {};

	                each(options, function(option, value) {
	                    if (option in parameterMap) {
	                        option = parameterMap[option];
	                        if (isPlainObject(option)) {
	                            value = option.value(value);
	                            option = option.key;
	                        }
	                    }

	                    result[option] = value;
	                });

	                return result;
	            };
	        },

	        options: {
	            parameterMap: identity
	        },

	        create: function(options) {
	            return ajax(this.setup(options, CREATE));
	        },

	        read: function(options) {
	            var that = this,
	                success,
	                error,
	                result,
	                cache = that.cache;

	            options = that.setup(options, READ);

	            success = options.success || noop;
	            error = options.error || noop;

	            result = cache.find(options.data);

	            if(result !== undefined) {
	                success(result);
	            } else {
	                options.success = function(result) {
	                    cache.add(options.data, result);

	                    success(result);
	                };

	                $.ajax(options);
	            }
	        },

	        update: function(options) {
	            return ajax(this.setup(options, UPDATE));
	        },

	        destroy: function(options) {
	            return ajax(this.setup(options, DESTROY));
	        },

	        setup: function(options, type) {
	            options = options || {};

	            var that = this,
	                parameters,
	                operation = that.options[type],
	                data = isFunction(operation.data) ? operation.data(options.data) : operation.data;

	            options = extend(true, {}, operation, options);
	            parameters = extend(true, {}, data, options.data);

	            options.data = that.parameterMap(parameters, type);

	            if (isFunction(options.url)) {
	                options.url = options.url(parameters);
	            }

	            return options;
	        }
	    });

	    var Cache = Class.extend({
	        init: function() {
	            this._store = {};
	        },
	        add: function(key, data) {
	            if(key !== undefined) {
	                this._store[stringify(key)] = data;
	            }
	        },
	        find: function(key) {
	            return this._store[stringify(key)];
	        },
	        clear: function() {
	            this._store = {};
	        },
	        remove: function(key) {
	            delete this._store[stringify(key)];
	        }
	    });

	    Cache.create = function(options) {
	        var store = {
	            "inmemory": function() { return new Cache(); }
	        };

	        if (isPlainObject(options) && isFunction(options.find)) {
	            return options;
	        }

	        if (options === true) {
	            return new Cache();
	        }

	        return store[options]();
	    };

	    function serializeRecords(data, getters, modelInstance, originalFieldNames, fieldNames) {
	        var record,
	            getter,
	            originalName,
	            idx,
	            setters = {},
	            length;

	        for (idx = 0, length = data.length; idx < length; idx++) {
	            record = data[idx];
	            for (getter in getters) {
	                originalName = fieldNames[getter];

	                if (originalName && originalName !== getter) {
	                    if (!setters[originalName]) {
	                        setters[originalName] = kendo.setter(originalName);
	                    }
	                    setters[originalName](record, getters[getter](record));
	                    delete record[getter];
	                }
	            }
	        }
	    }

	    function convertRecords(data, getters, modelInstance, originalFieldNames, fieldNames) {
	        var record,
	            getter,
	            originalName,
	            idx,
	            length;

	        for (idx = 0, length = data.length; idx < length; idx++) {
	            record = data[idx];
	            for (getter in getters) {
	                record[getter] = modelInstance._parse(getter, getters[getter](record));

	                originalName = fieldNames[getter];
	                if (originalName && originalName !== getter) {
	                    delete record[originalName];
	                }
	            }
	        }
	    }

	    function convertGroup(data, getters, modelInstance, originalFieldNames, fieldNames) {
	        var record,
	            idx,
	            fieldName,
	            length;

	        for (idx = 0, length = data.length; idx < length; idx++) {
	            record = data[idx];

	            fieldName = originalFieldNames[record.field];
	            if (fieldName && fieldName != record.field) {
	                record.field = fieldName;
	            }

	            record.value = modelInstance._parse(record.field, record.value);

	            if (record.items) {
	                if (record.hasSubgroups) {
	                    convertGroup(record.items, getters, modelInstance, originalFieldNames, fieldNames);
	                } else {
	                    convertRecords(record.items, getters, modelInstance, originalFieldNames, fieldNames);
	                }
	            }
	        }
	    }

	    function wrapDataAccess(originalFunction, model, converter, getters, originalFieldNames, fieldNames) {
	        return function(data) {
	            data = originalFunction(data);

	            return wrapDataAccessBase(model, converter, getters, originalFieldNames, fieldNames)(data);
	        };
	    }

	    function wrapDataAccessBase(model, converter, getters, originalFieldNames, fieldNames) {
	        return function(data) {

	            if (data && !isEmptyObject(getters)) {
	                if (toString.call(data) !== "[object Array]" && !(data instanceof ObservableArray)) {
	                    data = [data];
	                }

	                converter(data, getters, new model(), originalFieldNames, fieldNames);
	            }

	            return data || [];
	        };
	    }

	    var DataReader = Class.extend({
	        init: function(schema) {
	            var that = this, member, get, model, base;

	            schema = schema || {};

	            for (member in schema) {
	                get = schema[member];

	                that[member] = typeof get === STRING ? getter(get) : get;
	            }

	            base = schema.modelBase || Model;

	            if (isPlainObject(that.model)) {
	                that.model = model = base.define(that.model);
	            }

	            var dataFunction = proxy(that.data, that);

	            that._dataAccessFunction = dataFunction;

	            if (that.model) {
	                var groupsFunction = proxy(that.groups, that),
	                    serializeFunction = proxy(that.serialize, that),
	                    originalFieldNames = {},
	                    getters = {},
	                    serializeGetters = {},
	                    fieldNames = {},
	                    shouldSerialize = false,
	                    fieldName,
	                    name;

	                model = that.model;

	                if (model.fields) {
	                    each(model.fields, function(field, value) {
	                        var fromName;

	                        fieldName = field;

	                        if (isPlainObject(value) && value.field) {
	                            fieldName = value.field;
	                        } else if (typeof value === STRING) {
	                            fieldName = value;
	                        }

	                        if (isPlainObject(value) && value.from) {
	                            fromName = value.from;
	                        }

	                        shouldSerialize = shouldSerialize || (fromName && fromName !== field) || fieldName !== field;
	                        name = fromName || fieldName;
	                        getters[field] = name.indexOf(".") !== -1 ? getter(name, true) : getter(name);
	                        serializeGetters[field] = getter(field);
	                        originalFieldNames[fromName || fieldName] = field;
	                        fieldNames[field] = fromName || fieldName;
	                    });

	                    if (!schema.serialize && shouldSerialize) {
	                        that.serialize = wrapDataAccess(serializeFunction, model, serializeRecords, serializeGetters, originalFieldNames, fieldNames);
	                    }
	                }

	                that._dataAccessFunction = dataFunction;
	                that._wrapDataAccessBase = wrapDataAccessBase(model, convertRecords, getters, originalFieldNames, fieldNames);
	                that.data = wrapDataAccess(dataFunction, model, convertRecords, getters, originalFieldNames, fieldNames);
	                that.groups = wrapDataAccess(groupsFunction, model, convertGroup, getters, originalFieldNames, fieldNames);
	            }
	        },
	        errors: function(data) {
	            return data ? data.errors : null;
	        },
	        parse: identity,
	        data: identity,
	        total: function(data) {
	            return data.length;
	        },
	        groups: identity,
	        aggregates: function() {
	            return {};
	        },
	        serialize: function(data) {
	            return data;
	        }
	    });

	    function fillLastGroup(originalGroup, newGroup) {
	        var currOriginal;
	        var currentNew;

	        if (newGroup.items && newGroup.items.length) {
	            for (var i = 0; i < newGroup.items.length; i++) {
	                currOriginal = originalGroup.items[i];
	                currentNew = newGroup.items[i];
	                if (currOriginal && currentNew) {
	                    if (currOriginal.hasSubgroups) {
	                        fillLastGroup(currOriginal, currentNew);
	                    } else if (currOriginal.field && currOriginal.value == currentNew.value) {
	                        currOriginal.items.push.apply(currOriginal.items, currentNew.items);
	                    } else {
	                        originalGroup.items.push.apply(originalGroup.items, [currentNew]);
	                    }
	                } else if (currentNew) {
	                    originalGroup.items.push.apply(originalGroup.items, [currentNew]);
	                }
	            }
	        }
	    }
	    function mergeGroups(target, dest, skip, take) {
	        var group,
	            idx = 0,
	            items;

	        while (dest.length && take) {
	            group = dest[idx];
	            items = group.items;

	            var length = items.length;

	            if (target && target.field === group.field && target.value === group.value) {
	                if (target.hasSubgroups && target.items.length) {
	                    mergeGroups(target.items[target.items.length - 1], group.items, skip, take);
	                } else {
	                    items = items.slice(skip, skip + take);
	                    target.items = target.items.concat(items);
	                }
	                dest.splice(idx--, 1);
	            } else if (group.hasSubgroups && items.length) {
	                mergeGroups(group, items, skip, take);
	                if (!group.items.length) {
	                    dest.splice(idx--, 1);
	                }
	            } else {
	                items = items.slice(skip, skip + take);
	                group.items = items;

	                if (!group.items.length) {
	                    dest.splice(idx--, 1);
	                }
	            }

	            if (items.length === 0) {
	                skip -= length;
	            } else {
	                skip = 0;
	                take -= items.length;
	            }

	            if (++idx >= dest.length) {
	                break;
	            }
	        }

	        if (idx < dest.length) {
	            dest.splice(idx, dest.length - idx);
	        }
	    }

	    function flatGroups(groups, indexFunction) {
	        var result = [];
	        var groupsLength = (groups || []).length;
	        var group;
	        var items;
	        var indexFn = isFunction(indexFunction) ? indexFunction : function(array, index) {
	            return array[index];
	        };

	        for (var groupIndex = 0; groupIndex < groupsLength; groupIndex++) {
	            group = indexFn(groups, groupIndex);

	            if (group.hasSubgroups) {
	                result = result.concat(flatGroups(group.items));
	            } else {
	                items = group.items;

	                for (var itemIndex = 0; itemIndex < items.length; itemIndex++) {
	                    result.push(indexFn(items, itemIndex));
	                }
	            }
	        }
	        return result;
	    }

	    function flattenGroups(data) {
	        var idx,
	            result = [],
	            length,
	            items,
	            itemIndex;

	        for (idx = 0, length = data.length; idx < length; idx++) {
	            var group = data.at(idx);
	            if (group.items) {
	                if (group.hasSubgroups) {
	                    result = result.concat(flattenGroups(group.items));
	                } else {
	                    items = group.items;
	                    for (itemIndex = 0; itemIndex < items.length; itemIndex++) {
	                        result.push(items.at(itemIndex));
	                    }
	                }
	            }
	        }
	        return result;
	    }

	    function wrapGroupItems(data, model) {
	        var idx, length, group;
	        if (model) {
	            for (idx = 0, length = data.length; idx < length; idx++) {
	                group = data.at(idx);
	                if (group.items) {
	                    if (group.hasSubgroups) {
	                        wrapGroupItems(group.items, model);
	                    } else {
	                        group.items = new LazyObservableArray(group.items, model, group.items._events);
	                    }
	                }
	            }
	        }
	    }

	    function eachGroupItems(data, func) {
	        for (var idx = 0; idx < data.length; idx++) {
	            if (data[idx].hasSubgroups) {
	                if (eachGroupItems(data[idx].items, func)) {
	                    return true;
	                }
	            } else if (func(data[idx].items, data[idx])) {
	                return true;
	            }
	        }
	    }

	    function replaceInRanges(ranges, data, item, observable) {
	        for (var idx = 0; idx < ranges.length; idx++) {
	            if (ranges[idx].data === data) {
	                break;
	            }
	            if (replaceInRange(ranges[idx].data, item, observable)) {
	                break;
	            }
	        }
	    }

	    function replaceInRange(items, item, observable) {
	        for (var idx = 0, length = items.length; idx < length; idx++) {
	            if (items[idx] && items[idx].hasSubgroups) {
	                return replaceInRange(items[idx].items, item, observable);
	            } else if (items[idx] === item || items[idx] === observable) {
	               items[idx] = observable;
	               return true;
	            }
	        }
	    }

	    function replaceWithObservable(view, data, ranges, type, serverGrouping) {
	        for (var viewIndex = 0, length = view.length; viewIndex < length; viewIndex++) {
	            var item = view[viewIndex];

	            if (!item || item instanceof type) {
	                continue;
	            }

	            if (item.hasSubgroups !== undefined && !serverGrouping) {
	                replaceWithObservable(item.items, data, ranges, type, serverGrouping);
	            } else {
	                for (var idx = 0; idx < data.length; idx++) {
	                    if (data[idx] === item) {
	                        view[viewIndex] = data.at(idx);
	                        replaceInRanges(ranges, data, item, view[viewIndex]);
	                        break;
	                    }
	                }
	            }
	        }
	    }

	    function removeModel(data, model) {
	        if (!data) {
	            return;
	        }
	        var length = data.length;
	        var dataItem;
	        var idx;

	        for (idx = 0; idx < length; idx++) {
	            dataItem = data[idx];

	            if (dataItem.uid && dataItem.uid == model.uid) {
	                data.splice(idx, 1);
	                return dataItem;
	            }
	        }
	    }

	    function indexOfPristineModel(data, model) {
	        if (model) {
	            return indexOf(data, function(item) {
	                return (item.uid && item.uid == model.uid) || (item[model.idField] === model.id && model.id !== model._defaultId);
	            });
	        }
	        return -1;
	    }

	    function indexOfModel(data, model) {
	        if (model) {
	            return indexOf(data, function(item) {
	                return item.uid == model.uid;
	            });
	        }
	        return -1;
	    }

	    function indexOf(data, comparer) {
	        var idx, length;
	        if (!data) {
	            return;
	        }

	        for (idx = 0, length = data.length; idx < length; idx++) {
	            if (comparer(data[idx])) {
	                return idx;
	            }
	        }

	        return -1;
	    }

	    function fieldNameFromModel(fields, name) {
	        if (fields && !isEmptyObject(fields)) {
	            var descriptor = fields[name];
	            var fieldName;
	            if (isPlainObject(descriptor)) {
	                fieldName = descriptor.from || descriptor.field || name;
	            } else {
	                fieldName = fields[name] || name;
	            }

	            if (isFunction(fieldName)) {
	                return name;
	            }

	            return fieldName;
	        }
	        return name;
	    }

	    function convertFilterDescriptorsField(descriptor, model) {
	        var idx,
	            length,
	            target = {};

	        for (var field in descriptor) {
	            if (field !== "filters") {
	                target[field] = descriptor[field];
	            }
	        }

	        if (descriptor.filters) {
	            target.filters = [];
	            for (idx = 0, length = descriptor.filters.length; idx < length; idx++) {
	                target.filters[idx] = convertFilterDescriptorsField(descriptor.filters[idx], model);
	            }
	        } else {
	            target.field = fieldNameFromModel(model.fields, target.field);
	        }
	        return target;
	    }

	    function convertDescriptorsField(descriptors, model) {
	        var idx,
	            length,
	            result = [],
	            target,
	            descriptor;

	        for (idx = 0, length = descriptors.length; idx < length; idx ++) {
	            target = {};

	            descriptor = descriptors[idx];

	            for (var field in descriptor) {
	                target[field] = descriptor[field];
	            }

	            target.field = fieldNameFromModel(model.fields, target.field);

	            if (target.aggregates && isArray(target.aggregates)) {
	                target.aggregates = convertDescriptorsField(target.aggregates, model);
	            }
	            result.push(target);
	        }
	        return result;
	    }

	    var DataSource = Observable.extend({
	        init: function(options) {
	            var that = this, model, data;

	            if (options) {
	                data = options.data;
	            }

	            options = that.options = extend({}, that.options, options);

	            that._map = {};
	            that._prefetch = {};
	            that._data = [];
	            that._pristineData = [];
	            that._ranges = [];
	            that._view = [];
	            that._pristineTotal = 0;
	            that._destroyed = [];
	            that._pageSize = options.pageSize;
	            that._page = options.page  || (options.pageSize ? 1 : undefined);
	            that._sort = normalizeSort(options.sort);
	            that._sortFields = sortFields(options.sort);
	            that._filter = normalizeFilter(options.filter);
	            that._group = normalizeGroup(options.group);
	            that._aggregate = options.aggregate;
	            that._total = options.total;
	            that._groupPaging = options.groupPaging;

	            if (that._groupPaging) {
	                that._groupsState = {};
	            }
	            that._shouldDetachObservableParents = true;

	            Observable.fn.init.call(that);

	            that.transport = Transport.create(options, data, that);

	            if (isFunction(that.transport.push)) {
	                that.transport.push({
	                    pushCreate: proxy(that._pushCreate, that),
	                    pushUpdate: proxy(that._pushUpdate, that),
	                    pushDestroy: proxy(that._pushDestroy, that)
	                });
	            }

	            if (options.offlineStorage != null) {
	                if (typeof options.offlineStorage == "string") {
	                    var key = options.offlineStorage;

	                    that._storage = {
	                        getItem: function() {
	                            return JSON.parse(localStorage.getItem(key));
	                        },
	                        setItem: function(item) {
	                            localStorage.setItem(key, stringify(that.reader.serialize(item)));
	                        }
	                    };
	                } else {
	                    that._storage = options.offlineStorage;
	                }
	            }

	            that.reader = new kendo.data.readers[options.schema.type || "json" ](options.schema);

	            model = that.reader.model || {};

	            that._detachObservableParents();

	            that._data = that._observe(that._data);
	            that._online = true;

	            that.bind(["push", ERROR, CHANGE, REQUESTSTART, SYNC, REQUESTEND, PROGRESS], options);
	        },

	        options: {
	            data: null,
	            schema: {
	               modelBase: Model
	            },
	            offlineStorage: null,
	            serverSorting: false,
	            serverPaging: false,
	            serverFiltering: false,
	            serverGrouping: false,
	            serverAggregates: false,
	            batch: false,
	            inPlaceSort: false
	        },

	        clone: function() {
	            return this;
	        },

	        online: function(value) {
	            if (value !== undefined) {
	                if (this._online != value) {
	                    this._online = value;

	                    if (value) {
	                        return this.sync();
	                    }
	                }

	                return $.Deferred().resolve().promise();
	            } else {
	                return this._online;
	            }
	        },

	        offlineData: function(state) {
	            if (this.options.offlineStorage == null) {
	                return null;
	            }

	            if (state !== undefined) {
	                return this._storage.setItem(state);
	            }

	            return this._storage.getItem() || [];
	        },

	        _isServerGrouped: function() {
	            var group = this.group() || [];

	            return this.options.serverGrouping && group.length;
	        },

	        _isServerGroupPaged: function(){
	            return this._isServerGrouped() && this._groupPaging;
	        },

	        _isGroupPaged: function(){
	            var group = this._group || [];

	            return this._groupPaging && group.length;
	        },

	        _pushCreate: function(result) {
	            this._push(result, "pushCreate");
	        },

	        _pushUpdate: function(result) {
	            this._push(result, "pushUpdate");
	        },

	        _pushDestroy: function(result) {
	            this._push(result, "pushDestroy");
	        },

	        _push: function(result, operation) {
	            var data = this._readData(result);

	            if (!data) {
	                data = result;
	            }

	            this[operation](data);
	        },

	        _flatData: function(data, skip) {
	            if (data) {
	                if (this._isServerGrouped()) {
	                    return flattenGroups(data);
	                }

	                if (!skip) {
	                    for (var idx = 0; idx < data.length; idx++) {
	                        data.at(idx);
	                    }
	                }
	            }

	            return data;
	        },

	        parent: noop,

	        get: function(id) {
	            var idx, length, data = this._flatData(this._data, this.options.useRanges);

	            for (idx = 0, length = data.length; idx < length; idx++) {
	                if (data[idx].id == id) {
	                    return data[idx];
	                }
	            }
	        },

	        getByUid: function(id) {
	            return this._getByUid(id, this._data);
	        },

	        _getByUid: function(id, dataItems) {
	            var idx, length, data = this._flatData(dataItems, this.options.useRanges);

	            if (!data) {
	                return;
	            }

	            for (idx = 0, length = data.length; idx < length; idx++) {
	                if (data[idx].uid == id) {
	                    return data[idx];
	                }
	            }
	        },

	        indexOf: function(model) {
	            return indexOfModel(this._data, model);
	        },

	        at: function(index) {
	            return this._data.at(index);
	        },

	        data: function(value) {
	            var that = this;
	            if (value !== undefined) {
	                that._detachObservableParents();
	                that._data = this._observe(value);

	                that._pristineData = value.slice(0);

	                that._storeData();

	                that._ranges = [];
	                that.trigger("reset");
	                that._addRange(that._data);

	                that._total = that._data.length;
	                that._pristineTotal = that._total;

	                that._process(that._data);
	            } else {
	                if (that._data) {
	                    for (var idx = 0; idx < that._data.length; idx++) {
	                        that._data.at(idx);
	                    }
	                }

	                return that._data;
	            }
	        },

	        view: function(value) {
	            if (value === undefined) {
	                return this._view;
	            } else {
	                this._view = this._observeView(value);
	            }
	        },

	        _observeView: function(data) {
	            var that = this;
	            replaceWithObservable(data, that._data, that._ranges, that.reader.model || ObservableObject, that._isServerGrouped());

	            var view = new LazyObservableArray(data, that.reader.model);
	            view.parent = function() { return that.parent(); };
	            return view;
	        },

	        flatView: function() {
	            var groups = this.group() || [];

	            if (groups.length) {
	                return flattenGroups(this._view);
	            } else {
	                return this._view;
	            }
	        },

	        add: function(model) {
	            return this.insert(this._data.length, model);
	        },

	        _createNewModel: function(model) {
	            if (this.reader.model) {
	                return new this.reader.model(model);
	            }

	            if (model instanceof ObservableObject) {
	                return model;
	            }

	            return new ObservableObject(model);
	        },

	        insert: function(index, model) {
	            if (!model) {
	                model = index;
	                index = 0;
	            }

	            if (!(model instanceof Model)) {
	                model = this._createNewModel(model);
	            }

	            if (this._isServerGrouped()) {
	                this._data.splice(index, 0, this._wrapInEmptyGroup(model));
	            } else {
	                this._data.splice(index, 0, model);
	            }

	            this._insertModelInRange(index, model);

	            return model;
	        },

	        pushInsert: function(index, items) {
	            var that = this;
	            var rangeSpan = that._getCurrentRangeSpan();

	            if (!items) {
	                items = index;
	                index = 0;
	            }

	            if (!isArray(items)) {
	                items = [items];
	            }

	            var pushed = [];
	            var autoSync = this.options.autoSync;
	            this.options.autoSync = false;

	            try {
	                for (var idx = 0; idx < items.length; idx ++) {
	                    var item = items[idx];

	                    var result = this.insert(index, item);

	                    pushed.push(result);

	                    var pristine = result.toJSON();

	                    if (this._isServerGrouped()) {
	                        pristine = this._wrapInEmptyGroup(pristine);
	                    }

	                    this._pristineData.push(pristine);

	                    if (rangeSpan && rangeSpan.length) {
	                        $(rangeSpan).last()[0].pristineData.push(pristine);
	                    }

	                    index++;
	                }
	            } finally {
	                this.options.autoSync = autoSync;
	            }

	            if (pushed.length) {
	                this.trigger("push", {
	                    type: "create",
	                    items: pushed
	                });
	            }
	        },

	        pushCreate: function(items) {
	            this.pushInsert(this._data.length, items);
	        },

	        pushUpdate: function(items) {
	            if (!isArray(items)) {
	                items = [items];
	            }

	            var pushed = [];

	            for (var idx = 0; idx < items.length; idx ++) {
	                var item = items[idx];
	                var model = this._createNewModel(item);

	                var target = this.get(model.id);

	                if (target) {
	                    pushed.push(target);

	                    target.accept(item);

	                    target.trigger(CHANGE);

	                    this._updatePristineForModel(target, item);
	                } else {
	                    this.pushCreate(item);
	                }
	            }

	            if (pushed.length) {
	                this.trigger("push", {
	                    type: "update",
	                    items: pushed
	                });
	            }
	        },

	        pushDestroy: function(items) {
	            var pushed = this._removeItems(items);

	            if (pushed.length) {
	                this.trigger("push", {
	                    type: "destroy",
	                    items: pushed
	                });
	            }
	        },

	        _removeItems: function(items, removePristine) {
	            if (!isArray(items)) {
	                items = [items];
	            }

	            var shouldRemovePristine = typeof removePristine !== "undefined" ? removePristine : true;

	            var destroyed = [];
	            var autoSync = this.options.autoSync;
	            this.options.autoSync = false;
	            try {
	                for (var idx = 0; idx < items.length; idx ++) {
	                    var item = items[idx];
	                    var model = this._createNewModel(item);
	                    var found = false;

	                    this._eachItem(this._data, function(items){
	                        for (var idx = 0; idx < items.length; idx++) {
	                            var item = items.at(idx);
	                            if (item.id === model.id) {
	                                destroyed.push(item);
	                                items.splice(idx, 1);
	                                found = true;
	                                break;
	                            }
	                        }
	                    });

	                    if (found && shouldRemovePristine) {
	                        this._removePristineForModel(model);
	                        this._destroyed.pop();
	                    }
	                }
	            } finally {
	                this.options.autoSync = autoSync;
	            }

	            return destroyed;
	        },

	        remove: function(model) {
	            var result,
	                that = this,
	                hasGroups = that._isServerGrouped();

	            this._eachItem(that._data, function(items) {
	                result = removeModel(items, model);

	                if (result && hasGroups) {
	                    if (!result.isNew || !result.isNew()) {
	                        that._destroyed.push(result);
	                    }
	                    return true;
	                }
	            });

	            this._removeModelFromRanges(model);

	            return model;
	        },

	        destroyed: function() {
	            return this._destroyed;
	        },

	        created: function() {
	            var idx,
	                length,
	                result = [],
	                data = this._flatData(this._data, this.options.useRanges);

	            for (idx = 0, length = data.length; idx < length; idx++) {
	                if (data[idx].isNew && data[idx].isNew()) {
	                    result.push(data[idx]);
	                }
	            }
	            return result;
	        },

	        updated: function() {
	            var idx,
	                length,
	                result = [],
	                data = this._flatData(this._data, this.options.useRanges);

	            for (idx = 0, length = data.length; idx < length; idx++) {
	                if ((data[idx].isNew && !data[idx].isNew()) && data[idx].dirty) {
	                    result.push(data[idx]);
	                }
	            }
	            return result;
	        },

	        sync: function() {
	            var that = this,
	                created = [],
	                updated = [],
	                destroyed = that._destroyed;

	            var promise = $.Deferred().resolve().promise();

	            if (that.online()) {

	                if (!that.reader.model) {
	                    return promise;
	                }

	                created = that.created();
	                updated = that.updated();

	                var promises = [];

	                if (that.options.batch && that.transport.submit) {
	                    promises = that._sendSubmit(created, updated, destroyed);
	                } else {
	                    promises.push.apply(promises, that._send("create", created));
	                    promises.push.apply(promises, that._send("update", updated));
	                    promises.push.apply(promises, that._send("destroy", destroyed));
	                }

	                promise = $.when
	                 .apply(null, promises)
	                 .then(function() {
	                    var idx, length;

	                    for (idx = 0, length = arguments.length; idx < length; idx++){
	                        if (arguments[idx]) {
	                            that._accept(arguments[idx]);
	                        }
	                    }

	                    that._storeData(true);

	                    that._syncEnd();

	                    that._change({ action: "sync" });

	                    that.trigger(SYNC);

	                    if (that._isServerGroupPaged()) {
	                        that.read();
	                    }
	                });
	            } else {
	                that._storeData(true);

	                that._syncEnd();

	                that._change({ action: "sync" });
	            }

	            return promise;
	        },

	        _syncEnd: noop,

	        cancelChanges: function(model) {
	            var that = this;

	            if (model instanceof kendo.data.Model) {
	                that._cancelModel(model);
	            } else {
	                that._destroyed = [];
	                that._detachObservableParents();
	                that._data = that._observe(that._pristineData);
	                if (that.options.serverPaging) {
	                    that._total = that._pristineTotal;
	                }

	                that._ranges = [];
	                that._addRange(that._data, 0);

	                that._changesCanceled();

	                that._change();

	                that._markOfflineUpdatesAsDirty();

	                if (that._isServerGrouped()) {
	                    that.read();
	                }
	            }
	        },

	        _changesCanceled: noop,

	        _markOfflineUpdatesAsDirty: function() {
	            var that = this;

	            if (that.options.offlineStorage != null) {
	                that._eachItem(that._data, function(items) {
	                    for (var idx = 0; idx < items.length; idx++) {
	                        var item = items.at(idx);
	                        if (item.__state__ == "update" || item.__state__ == "create") {
	                            item.dirty = true;
	                        }
	                    }
	                });
	            }
	        },

	        hasChanges: function() {
	            var idx,
	                length,
	                data = this._flatData(this._data, this.options.useRanges);

	            if (this._destroyed.length) {
	                return true;
	            }

	            for (idx = 0, length = data.length; idx < length; idx++) {
	                if ((data[idx].isNew && data[idx].isNew()) || data[idx].dirty) {
	                    return true;
	                }
	            }

	            return false;
	        },

	        _accept: function(result) {
	            var that = this,
	                models = result.models,
	                response = result.response,
	                idx = 0,
	                serverGroup = that._isServerGrouped(),
	                pristine = that._pristineData,
	                type = result.type,
	                length;

	            that.trigger(REQUESTEND, { response: response, type: type });

	            if (response && !isEmptyObject(response)) {
	                response = that.reader.parse(response);

	                if (that._handleCustomErrors(response)) {
	                    return;
	                }

	                response = that.reader.data(response);

	                if (!isArray(response)) {
	                    response = [response];
	                }
	            } else {
	                response = $.map(models, function(model) { return model.toJSON(); } );
	            }

	            if (type === "destroy") {
	                that._destroyed = [];
	            }

	            for (idx = 0, length = models.length; idx < length; idx++) {
	                if (type !== "destroy") {
	                    models[idx].accept(response[idx]);

	                    if (type === "create") {
	                        pristine.push(serverGroup ? that._wrapInEmptyGroup(models[idx].toJSON()) : response[idx]);
	                    } else if (type === "update") {
	                        that._updatePristineForModel(models[idx], response[idx]);
	                    }
	                } else {
	                    that._removePristineForModel(models[idx]);
	                }
	            }
	        },

	        _updatePristineForModel: function(model, values) {
	            this._executeOnPristineForModel(model, function(index, items) {
	                kendo.deepExtend(items[index], values);
	            });
	        },

	        _executeOnPristineForModel: function(model, callback) {
	            this._eachPristineItem(
	                function(items) {
	                    var index = indexOfPristineModel(items, model);
	                    if (index > -1) {
	                        callback(index, items);
	                        return true;
	                    }
	                });
	        },

	        _removePristineForModel: function(model) {
	            this._executeOnPristineForModel(model, function(index, items) {
	                items.splice(index, 1);
	            });
	        },

	        _readData: function(data) {
	            var read = !this._isServerGrouped() ? this.reader.data : this.reader.groups;
	            return read.call(this.reader, data);
	        },

	        _eachPristineItem: function(callback) {
	            var that = this;
	            var options = that.options;
	            var rangeSpan = that._getCurrentRangeSpan();

	            that._eachItem(that._pristineData, callback);

	            if (options.serverPaging && options.useRanges) {
	                each(rangeSpan, function(i, range) {
	                    that._eachItem(range.pristineData, callback);
	                });
	            }
	        },

	       _eachItem: function(data, callback) {
	            if (data && data.length) {
	                if (this._isServerGrouped()) {
	                    eachGroupItems(data, callback);
	                } else {
	                    callback(data);
	                }
	            }
	        },

	        _pristineForModel: function(model) {
	            var pristine,
	                idx,
	                callback = function(items) {
	                    idx = indexOfPristineModel(items, model);
	                    if (idx > -1) {
	                        pristine = items[idx];
	                        return true;
	                    }
	                };

	            this._eachPristineItem(callback);

	            return pristine;
	        },

	        _cancelModel: function(model) {
	            var that = this;
	            var pristine = this._pristineForModel(model);

	            this._eachItem(this._data, function(items) {
	                var idx = indexOfModel(items, model);
	                if (idx >= 0) {
	                    if (pristine && (!model.isNew() || pristine.__state__)) {
	                        items[idx].accept(pristine);

	                        if (pristine.__state__ == "update") {
	                            items[idx].dirty = true;
	                        }

	                    } else {
	                        that._modelCanceled(model);

	                        items.splice(idx, 1);

	                        that._removeModelFromRanges(model);
	                    }
	                }
	            });
	        },

	        _modelCanceled: noop,

	        _submit: function(promises, data) {
	            var that = this;

	            that.trigger(REQUESTSTART, { type: "submit" });

	            that.trigger(PROGRESS);

	            that.transport.submit(extend({
	                success: function(response, type) {
	                    var promise = $.grep(promises, function(x) {
	                        return x.type == type;
	                    })[0];

	                    if (promise) {
	                        promise.resolve({
	                            response: response,
	                            models: promise.models,
	                            type: type
	                        });
	                    }
	                },
	                error: function(response, status, error) {
	                    for (var idx = 0; idx < promises.length; idx++) {
	                        promises[idx].reject(response);
	                    }

	                    that.error(response, status, error);
	                }
	            }, data));
	        },

	        _sendSubmit: function(created, updated, destroyed) {
	            var that = this,
	                promises = [];

	            if (that.options.batch) {
	                if (created.length) {
	                    promises.push($.Deferred(function(deferred) {
	                        deferred.type = "create";
	                        deferred.models = created;
	                    }));
	                }

	                if (updated.length) {
	                    promises.push($.Deferred(function(deferred) {
	                        deferred.type = "update";
	                        deferred.models = updated;
	                    }));
	                }

	                if (destroyed.length) {
	                    promises.push($.Deferred(function(deferred) {
	                        deferred.type = "destroy";
	                        deferred.models = destroyed;
	                    }));
	                }

	                that._submit(promises, {
	                    data: {
	                        created: that.reader.serialize(toJSON(created)),
	                        updated: that.reader.serialize(toJSON(updated)),
	                        destroyed: that.reader.serialize(toJSON(destroyed))
	                    }
	                });
	            }

	            return promises;
	        },

	        _promise: function(data, models, type) {
	            var that = this;

	            return $.Deferred(function(deferred) {
	                that.trigger(REQUESTSTART, { type: type });

	                that.trigger(PROGRESS);

	                that.transport[type].call(that.transport, extend({
	                    success: function(response) {
	                        deferred.resolve({
	                            response: response,
	                            models: models,
	                            type: type
	                        });
	                    },
	                    error: function(response, status, error) {
	                        deferred.reject(response);
	                        that.error(response, status, error);
	                    }
	                }, data));
	            }).promise();
	        },

	        _send: function(method, data) {
	            var that = this,
	                idx,
	                length,
	                promises = [],
	                converted = that.reader.serialize(toJSON(data));

	            if (that.options.batch) {
	                if (data.length) {
	                    promises.push(that._promise( { data: { models: converted } }, data , method));
	                }
	            } else {
	                for (idx = 0, length = data.length; idx < length; idx++) {
	                    promises.push(that._promise( { data: converted[idx] }, [ data[idx] ], method));
	                }
	            }

	            return promises;
	        },

	        read: function(data) {
	            var that = this, params = that._params(data);
	            var deferred = $.Deferred();

	            that._queueRequest(params, function() {
	                var isPrevented = that.trigger(REQUESTSTART, { type: "read" });
	                if (!isPrevented) {
	                    that.trigger(PROGRESS);

	                    that._ranges = [];
	                    that.trigger("reset");
	                    if (that.online()) {
	                        that.transport.read({
	                            data: params,
	                            success: function(data) {
	                                that._ranges = [];
	                                that.success(data, params);

	                                deferred.resolve();
	                            },
	                            error: function() {
	                                var args = slice.call(arguments);

	                                that.error.apply(that, args);

	                                deferred.reject.apply(deferred, args);
	                            }
	                        });
	                    } else if (that.options.offlineStorage != null){
	                        that.success(that.offlineData(), params);

	                        deferred.resolve();
	                    }
	                } else {
	                    that._dequeueRequest();

	                    deferred.resolve(isPrevented);
	                }
	            });

	            return deferred.promise();
	        },

	        _readAggregates: function(data) {
	            return this.reader.aggregates(data);
	        },

	        success: function(data) {
	            var that = this,
	                options = that.options,
	                items,
	                replaceSubset;

	            that.trigger(REQUESTEND, { response: data, type: "read" });

	            if (that.online()) {
	                data = that.reader.parse(data);

	                if (that._handleCustomErrors(data)) {
	                    that._dequeueRequest();
	                    return;
	                }

	                that._total = that.reader.total(data);

	                if (that._isServerGroupPaged()) {
	                    that._serverGroupsTotal = that._total;
	                }

	                if (that._pageSize > that._total) {
	                    that._pageSize = that._total;
	                    if (that.options.pageSize && that.options.pageSize > that._pageSize) {
	                        that._pageSize = that.options.pageSize;
	                    }
	                }

	                if (that._aggregate && options.serverAggregates) {
	                    that._aggregateResult = that._readAggregates(data);
	                }

	                data = that._readData(data);

	                that._destroyed = [];
	            } else {
	                data = that._readData(data);

	                items = [];
	                var itemIds = {};
	                var model = that.reader.model;
	                var idField = model ? model.idField : "id";
	                var idx;

	                for (idx = 0; idx < this._destroyed.length; idx++) {
	                    var id = this._destroyed[idx][idField];
	                    itemIds[id] = id;
	                }

	                for (idx = 0; idx < data.length; idx++) {
	                    var item = data[idx];
	                    var state = item.__state__;
	                    if (state == "destroy") {
	                        if (!itemIds[item[idField]]) {
	                            this._destroyed.push(this._createNewModel(item));
	                        }
	                    } else {
	                        items.push(item);
	                    }
	                }

	                data = items;

	                that._total = data.length;
	            }

	            that._pristineTotal = that._total;
	            replaceSubset = that._skip && that._data.length && that._skip < that._data.length;

	            if (that.options.endless) {
	                if (replaceSubset) {
	                    that._pristineData.splice(that._skip, that._pristineData.length);
	                }
	                items = data.slice(0);
	                for (var j = 0; j < items.length; j++) {
	                    that._pristineData.push(items[j]);
	                }
	            } else {
	                that._pristineData = data.slice(0);
	            }

	            that._detachObservableParents();

	            if (that.options.endless) {
	                that._data.unbind(CHANGE, that._changeHandler);

	                if (that._isServerGrouped() && that._data[that._data.length - 1].value === data[0].value) {
	                    fillLastGroup(that._data[that._data.length - 1], data[0]);
	                    data.shift();
	                }

	                data = that._observe(data);
	                if (replaceSubset) {
	                    that._data.splice(that._skip, that._data.length);
	                }
	                for (var i = 0; i < data.length; i++) {
	                    that._data.push(data[i]);
	                }
	                that._data.bind(CHANGE, that._changeHandler);
	            } else {
	                that._data = that._observe(data);
	            }

	            that._markOfflineUpdatesAsDirty();

	            that._storeData();

	            that._addRange(that._data);

	            that._process(that._data);

	            that._dequeueRequest();
	        },

	        _detachObservableParents: function() {
	            if (this._data && this._shouldDetachObservableParents) {
	                for (var idx = 0; idx < this._data.length; idx++) {
	                    if (this._data[idx].parent) {
	                        this._data[idx].parent = noop;
	                    }
	                }
	            }
	        },

	        _storeData: function(updatePristine) {
	            var serverGrouping = this._isServerGrouped();
	            var model = this.reader.model;

	            function items(data) {
	                var state = [];

	                for (var idx = 0; idx < data.length; idx++) {
	                    var dataItem = data.at(idx);
	                    var item = dataItem.toJSON();

	                    if (serverGrouping && dataItem.items) {
	                        item.items = items(dataItem.items);
	                    } else {
	                        item.uid = dataItem.uid;

	                        if (model) {
	                            if (dataItem.isNew()) {
	                                item.__state__ = "create";
	                            } else if (dataItem.dirty) {
	                                item.__state__ = "update";
	                            }
	                        }
	                    }
	                    state.push(item);
	                }

	                return state;
	            }

	            if (this.options.offlineStorage != null) {
	                var state = items(this._data);

	                var destroyed = [];

	                for (var idx = 0; idx < this._destroyed.length; idx++) {
	                    var item = this._destroyed[idx].toJSON();
	                    item.__state__ = "destroy";
	                    destroyed.push(item);
	                }

	                this.offlineData(state.concat(destroyed));

	                if (updatePristine) {
	                    this._pristineData = this.reader.reader ? this.reader.reader._wrapDataAccessBase(state) : this.reader._wrapDataAccessBase(state);
	                }
	            }
	        },

	        _addRange: function (data, skip) {
	            var that = this,
	                start = typeof (skip) !== "undefined" ? skip : (that._skip || 0),
	                end,
	                range = {
	                    data: data,
	                    pristineData: data.toJSON(),
	                    timestamp: that._timeStamp()
	                };

	            if (this._isGroupPaged()) {
	                end = start + data.length;
	                range.outerStart = start;
	                range.outerEnd = end;
	            } else {
	                end = start + that._flatData(data, true).length;
	            }

	            range.start = start;
	            range.end = end;
	            that._ranges.push(range);
	            that._sortRanges();

	            if (that._isGroupPaged()) {
	                if (!that._groupsFlat) {
	                    that._groupsFlat = [];
	                }
	                that._appendToGroupsFlat(range.data);
	                that._updateOuterRangesLength();
	            }
	        },

	        _appendToGroupsFlat: function (data) {
	            var length = data.length;

	            for (var i = 0; i < length; i++) {
	                this._groupsFlat.push(data[i]);
	            }
	        },

	        _getGroupByUid: function(uid){
	            var length = this._groupsFlat.length;
	            var group;

	            for (var i = 0; i < length; i++) {
	                group = this._groupsFlat[i];
	                if (group.uid === uid) {
	                    return group;
	                }
	            }
	        },

	        _sortRanges: function() {
	            this._ranges.sort(function(x, y) {
	                return x.start - y.start;
	            });
	        },

	        error: function(xhr, status, errorThrown) {
	            this._dequeueRequest();
	            this.trigger(REQUESTEND, { });
	            this.trigger(ERROR, { xhr: xhr, status: status, errorThrown: errorThrown });
	        },

	        _params: function(data) {
	            var that = this,
	                options =  extend({
	                    take: that.take(),
	                    skip: that.skip(),
	                    page: that.page(),
	                    pageSize: that.pageSize(),
	                    sort: that._sort,
	                    filter: that._filter,
	                    group: that._group,
	                    aggregate: that._aggregate,
	                    groupPaging: !!that._groupPaging
	                }, data);

	            if (!that.options.serverPaging) {
	                delete options.take;
	                delete options.skip;
	                delete options.page;
	                delete options.pageSize;
	            }

	            if (!that.options.serverGrouping) {
	                delete options.group;
	            } else if (that.reader.model && options.group) {
	                options.group = convertDescriptorsField(options.group, that.reader.model);
	            }

	            if (!that.options.serverFiltering) {
	                delete options.filter;
	            } else if (that.reader.model && options.filter) {
	               options.filter = convertFilterDescriptorsField(options.filter, that.reader.model);
	            }

	            if (!that.options.serverSorting) {
	                delete options.sort;
	            } else if (that.reader.model && options.sort) {
	                options.sort = convertDescriptorsField(options.sort, that.reader.model);
	            }

	            if (!that.options.serverAggregates) {
	                delete options.aggregate;
	            } else if (that.reader.model && options.aggregate) {
	                options.aggregate = convertDescriptorsField(options.aggregate, that.reader.model);
	            }

	            if (!that.options.groupPaging) {
	                delete options.groupPaging;
	            }

	            return options;
	        },

	        _queueRequest: function(options, callback) {
	            var that = this;
	            if (!that._requestInProgress) {
	                that._requestInProgress = true;
	                that._pending = undefined;
	                callback();
	            } else {
	                that._pending = { callback: proxy(callback, that), options: options };
	            }
	        },

	        _dequeueRequest: function() {
	            var that = this;
	            that._requestInProgress = false;
	            if (that._pending) {
	                that._queueRequest(that._pending.options, that._pending.callback);
	            }
	        },

	        _handleCustomErrors: function(response) {
	            if (this.reader.errors) {
	                var errors = this.reader.errors(response);
	                if (errors) {
	                    this.trigger(ERROR, { xhr: null, status: "customerror", errorThrown: "custom error", errors: errors });
	                    return true;
	                }
	            }
	            return false;
	        },

	        _shouldWrap: function(data) {
	            var model = this.reader.model;

	            if (model && data.length) {
	                return !(data[0] instanceof model);
	            }

	            return false;
	        },

	        _observe: function(data) {
	            var that = this,
	                model = that.reader.model;

	            that._shouldDetachObservableParents = true;

	            if (data instanceof ObservableArray) {
	                that._shouldDetachObservableParents = false;
	                if (that._shouldWrap(data)) {
	                    data.type = that.reader.model;
	                    data.wrapAll(data, data);
	                }
	            } else {
	                var arrayType = that.pageSize() && !that.options.serverPaging ? LazyObservableArray : ObservableArray;
	                data = new arrayType(data, that.reader.model);
	                data.parent = function() { return that.parent(); };
	            }

	            if (that._isServerGrouped()) {
	                wrapGroupItems(data, model);
	            }

	            if (that._changeHandler && that._data && that._data instanceof ObservableArray &&
	                !(that.options.useRanges && that.options.serverPaging)) {
	                that._data.unbind(CHANGE, that._changeHandler);
	            } else {
	                that._changeHandler = proxy(that._change, that);
	            }

	            return data.bind(CHANGE, that._changeHandler);
	        },

	        _updateTotalForAction: function(action, items) {
	            var that = this;

	            var total = parseInt(that._total, 10);

	            if (!isNumber(that._total)) {
	                total = parseInt(that._pristineTotal, 10);
	            }
	            if (action === "add") {
	                total += items.length;
	            } else if (action === "remove") {
	                total -= items.length;
	            } else if (action !== "itemchange" && action !== "sync" && !that.options.serverPaging) {
	                total = that._pristineTotal;
	            } else if (action === "sync") {
	                total = that._pristineTotal = parseInt(that._total, 10);
	            }

	            that._total = total;
	        },

	        _change: function(e) {
	            var that = this, idx, length, action = e ? e.action : "";

	            if (action === "remove") {
	                for (idx = 0, length = e.items.length; idx < length; idx++) {
	                    if (!e.items[idx].isNew || !e.items[idx].isNew()) {
	                        that._destroyed.push(e.items[idx]);
	                    }
	                }
	            }

	            if (that.options.autoSync && (action === "add" || action === "remove" || action === "itemchange")) {

	                var handler = function(args) {
	                    if (args.action === "sync") {
	                        that.unbind("change", handler);
	                        that._updateTotalForAction(action, e.items);
	                    }
	                };

	                that.first("change", handler);

	                that.sync();

	            } else {
	                that._updateTotalForAction(action, e ? e.items : []);

	                that._process(that._data, e);
	            }
	        },

	        _calculateAggregates: function (data, options) {
	            options = options || {};

	            var query = new Query(data),
	                aggregates = options.aggregate,
	                filter = options.filter;

	            if (filter) {
	                query = query.filter(filter);
	            }

	            return query.aggregate(aggregates);
	        },

	        _process: function (data, e) {
	            var that = this,
	                options = {},
	                result;

	            if (that.options.serverPaging !== true) {
	                options.skip = that._skip;
	                options.take = that._take || that._pageSize;

	                if(options.skip === undefined && that._page !== undefined && that._pageSize !== undefined) {
	                    options.skip = (that._page - 1) * that._pageSize;
	                }

	                if (that.options.useRanges) {
	                    options.skip = that.currentRangeStart();
	                }
	            }

	            if (that.options.serverSorting !== true) {
	                options.sort = that._sort;
	            }

	            if (that.options.serverFiltering !== true) {
	                options.filter = that._filter;
	            }

	            if (that.options.serverGrouping !== true) {
	                options.group = that._group;
	            }

	            if (that.options.serverAggregates !== true) {
	                options.aggregate = that._aggregate;
	            }

	            if (that.options.serverGrouping) {
	                that._clearEmptyGroups(data);
	            }

	            options.groupPaging = that._groupPaging;

	            if (that._isGroupPaged() && e && (e.action === "page" || e.action === "expandGroup" || e.action === "collapseGroup")) {
	                result = that._queryProcess(data, {
	                    aggregate: that._aggregate
	                });
	            } else {
	                result = that._queryProcess(data, options);
	            }

	            if (that.options.serverAggregates !== true) {
	                // for performance reasons, calculate aggregates for part of the data only after query process
	                // this is necessary in the TreeList when paging
	                that._aggregateResult = that._calculateAggregates(result.dataToAggregate || data, options);
	            }

	            that._setView(result, options, e);

	            that._setFilterTotal(result.total, false);

	            e = e || {};

	            e.items = e.items || that._view;

	            that.trigger(CHANGE, e);
	        },

	        _setView: function (result, options, e) {
	            var that = this;

	            if (that._isGroupPaged() && !that._isServerGrouped()) {
	                if (e && (e.action === "page" || e.action === "expandGroup" || e.action === "collapseGroup")) {
	                    that.view(result.data);
	                    that._updateOuterRangesLength();
	                } else {
	                    that._ranges = [];
	                    var query = new Query(result.data);
	                    that._addRange(that._observe(result.data));

	                    if (options.skip + options.take > result.data.length) {
	                        options.skip = result.data.length - options.take;
	                    }

	                    that.view(query.range(options.skip, options.take).toArray());
	                }

	            } else {
	                that.view(result.data);
	            }
	        },

	        _clearEmptyGroups: function(data) {
	            for (var idx = data.length - 1; idx >=0; idx--) {
	                var group = data[idx];
	                if (group.hasSubgroups) {
	                    this._clearEmptyGroups(group.items);
	                } else {
	                    if (group.items && !group.items.length) {
	                        splice.apply(group.parent(), [idx, 1]);
	                    }
	                }
	            }
	        },

	        _queryProcess: function(data, options) {
	            if (this.options.inPlaceSort) {
	                return Query.process(data, options, this.options.inPlaceSort);
	            }
	            else {
	                return Query.process(data, options);
	            }
	        },

	        _mergeState: function(options) {
	            var that = this;

	            if (options !== undefined) {
	                that._pageSize = options.pageSize;
	                that._page = options.page;
	                that._sort = options.sort;
	                that._filter = options.filter;
	                that._group = options.group;
	                that._aggregate = options.aggregate;
	                that._skip = that._currentRangeStart = options.skip;
	                that._take = options.take;

	                if(that._skip === undefined) {
	                    that._skip = that._currentRangeStart = that.skip();
	                    options.skip = that.skip();
	                }

	                if(that._take === undefined && that._pageSize !== undefined) {
	                    that._take = that._pageSize;
	                    options.take = that._take;
	                }

	                if (options.sort) {
	                    that._sort = options.sort = normalizeSort(options.sort);
	                    that._sortFields = sortFields(options.sort);
	                }

	                if (options.filter) {
	                    that._filter = options.filter = (that.options.accentFoldingFiltering && !$.isEmptyObject(options.filter)) ? $.extend({}, normalizeFilter(options.filter), { accentFoldingFiltering: that.options.accentFoldingFiltering}) : normalizeFilter(options.filter);
	                }

	                if (options.group) {
	                    that._group = options.group = normalizeGroup(options.group);
	                }
	                if (options.aggregate) {
	                    that._aggregate = options.aggregate = normalizeAggregate(options.aggregate);
	                }
	            }
	            return options;
	        },

	        query: function(options) {
	            var result;
	            var remote = this.options.serverSorting || this.options.serverPaging || this.options.serverFiltering || this.options.serverGrouping || this.options.serverAggregates;

	            if (remote || ((this._data === undefined || this._data.length === 0) && !this._destroyed.length)) {
	                if (this.options.endless) {
	                    var moreItemsCount = options.pageSize - this.pageSize();
	                    if (moreItemsCount > 0) {
	                        moreItemsCount = this.pageSize();
	                        options.page = options.pageSize / moreItemsCount;
	                        options.pageSize = moreItemsCount;
	                    } else {
	                        options.page = 1;
	                        this.options.endless = false;
	                    }
	                }
	                return this.read(this._mergeState(options));
	            }

	            var isPrevented = this.trigger(REQUESTSTART, { type: "read" });
	            if (!isPrevented) {
	                this.trigger(PROGRESS);
	                if (options) {
	                    options.groupPaging = this._groupPaging;
	                }
	                result = this._queryProcess(this._data, this._mergeState(options));

	                this._setFilterTotal(result.total, true);

	                this._aggregateResult = this._calculateAggregates(result.dataToAggregate || this._data, options);
	                this._setView(result, options);
	                this.trigger(REQUESTEND, { type: "read" });
	                this.trigger(CHANGE, { items: result.data, action: options ? options.action : "" });
	            }

	            return $.Deferred().resolve(isPrevented).promise();
	        },

	        _hasExpandedSubGroups: function (group) {
	            var result = false;
	            var length = group.items ? group.items.length : 0;

	            if (!group.hasSubgroups) {
	                return false;
	            }

	            for (var i = 0; i < length; i++) {
	                if (this._groupsState[group.items[i].uid]) {
	                    result = true;
	                    break;
	                }
	            }
	            return result;
	        },

	        _findGroupedRange: function (data, result, options, parents, callback) {
	            var that = this;
	            var length = data.length;
	            var group;
	            var current;
	            var itemsLength;
	            var hasNotRequestedItems;
	            var groupCount;
	            var itemsToSkip;

	            for (var i = 0; i < length; i++) {
	                group = data[i];

	                if (options.taken >= options.take) {
	                    break;
	                }

	                if (!that._getGroupByUid(group.uid)) {
	                    that._groupsFlat.push(group);
	                }

	                if (that._groupsState[group.uid]) {
	                    if (that._isServerGroupPaged()) {
	                        if (group.hasSubgroups && !group.subgroupCount) {
	                            that.getGroupSubGroupCount(group, options, parents, callback);
	                            that._fetchingGroupItems = true;
	                            return;
	                        }
	                        groupCount = (group.subgroupCount || group.itemCount) + 1;
	                        itemsToSkip = options.skip - options.skipped;
	                        hasNotRequestedItems = !group.items || (group.items.length - itemsToSkip) < (options.take - options.taken);

	                        if (!that._hasExpandedSubGroups(group) && itemsToSkip > groupCount) {
	                            options.skipped += groupCount;
	                            continue;
	                        }

	                        if ((group.hasSubgroups && (!group.items || hasNotRequestedItems && group.items.length < group.subgroupCount)) ||
	                            (!group.hasSubgroups && (!group.items || hasNotRequestedItems && group.items.length < group.itemCount))) {
	                            that.getGroupItems(group, options, parents, callback);
	                            that._fetchingGroupItems = true;
	                            return;
	                        }
	                    }

	                    if (options.includeParents && options.skipped < options.skip) {
	                        options.skipped++;
	                        group.excludeHeader = true;
	                    } else if (options.includeParents) {
	                        options.taken++;
	                    }

	                    if (group.hasSubgroups && group.items && group.items.length) {
	                        group.currentItems = [];

	                        if (!parents) {
	                            parents = [];
	                        }
	                        parents.push(group);

	                        that._findGroupedRange(group.items, group.currentItems, options, parents, callback);
	                        parents.pop();

	                        if (group.currentItems.length || options.taken > 0) {
	                            result.push(group);
	                        } else {
	                            group.excludeHeader = false;
	                        }
	                    } else {
	                        current = [];
	                        itemsLength = group.items.length;

	                        for (var j = 0; j < itemsLength; j++) {
	                            if (options.skipped < options.skip) {
	                                options.skipped++;
	                                continue;
	                            }

	                            if (options.taken >= options.take) {
	                                break;
	                            }
	                            current.push(group.items[j]);
	                            options.taken++;
	                        }

	                        if (current.length || options.taken > 0) {
	                            group.currentItems = current;
	                            result.push(group);
	                        } else {
	                            group.excludeHeader = false;
	                        }
	                    }
	                } else {
	                    if (options.skipped < options.skip) {
	                        options.skipped++;
	                        continue;
	                    }
	                    result.push(group);
	                    options.taken++;
	                }
	            }
	        },

	        getGroupItems: function (group, options, parents, callback) {
	            var that = this;
	            var skip;
	            var take;
	            var filter;
	            var data;
	            var subgroups;

	            if (!group.items) {
	                group.items = [];
	            }

	            skip = group.items.length;
	            take = that.take();
	            filter = this._composeItemsFilter(group, parents);
	            data = {
	                page: math.floor((skip || 0) / (take || 1)) || 1,
	                pageSize: take,
	                skip: skip,
	                take: take,
	                filter: filter,
	                aggregate: that._aggregate,
	                sort: that._sort
	            };
	            subgroups = that.findSubgroups(group);

	            if (subgroups && subgroups.length) {
	                data.group = subgroups;
	                data.groupPaging = true;
	            }

	            clearTimeout(that._timeout);
	            that._timeout = setTimeout(function () {
	                that._queueRequest(data, function () {
	                    if (!that.trigger(REQUESTSTART, {
	                            type: "read"
	                        })) {
	                        that.transport.read({
	                            data: data,
	                            success: that._groupItemsSuccessHandler(group, options.skip, that.take(), callback),
	                            error: function () {
	                                var args = slice.call(arguments);
	                                that.error.apply(that, args);
	                            }
	                        });
	                    } else {
	                        that._dequeueRequest();
	                    }
	                });
	            }, 100);
	        },

	        getGroupSubGroupCount: function (group, options, parents, callback) {
	            var that = this;
	            var filter;
	            var groupIndex;
	            var data;

	            if (!group.items) {
	                group.items = [];
	            }

	            filter = this._composeItemsFilter(group, parents);
	            groupIndex = this._group.map(function (g) {
	                return g.field;
	            }).indexOf(group.field);
	            data = {
	                filter: filter,
	                group: [that._group[groupIndex + 1]],
	                groupPaging: true,
	                includeSubGroupCount: true
	            };

	            clearTimeout(that._timeout);
	            that._timeout = setTimeout(function () {
	                that._queueRequest(data, function () {
	                    if (!that.trigger(REQUESTSTART, {
	                            type: "read"
	                        })) {
	                        that.transport.read({
	                            data: data,
	                            success: that._subGroupCountSuccessHandler(group, options.skip, that.take(), callback),
	                            error: function () {
	                                var args = slice.call(arguments);
	                                that.error.apply(that, args);
	                            }
	                        });
	                    } else {
	                        that._dequeueRequest();
	                    }
	                });
	            }, 100);
	        },

	        _subGroupCountSuccessHandler: function (group, skip, take, callback) {
	            var that = this;
	            callback = isFunction(callback) ? callback : noop;
	            var totalField = that.options.schema && that.options.schema.total ? that.options.schema.total : "Total";

	            return function (data) {

	                that._dequeueRequest();

	                that.trigger(REQUESTEND, {
	                    response: data,
	                    type: "read"
	                });
	                that._fetchingGroupItems = false;

	                if (isFunction(totalField)) {
	                    group.subgroupCount = totalField(data);
	                } else {
	                    group.subgroupCount = data[totalField];
	                }

	                that.range(skip, take, callback, "expandGroup");
	            };
	        },

	        _groupItemsSuccessHandler: function (group, skip, take, callback) {
	            var that = this;
	            var timestamp = that._timeStamp();
	            callback = isFunction(callback) ? callback : noop;

	            return function (data) {
	                var temp;
	                var model = Model.define(that.options.schema.model);

	                that._dequeueRequest();

	                that.trigger(REQUESTEND, {
	                    response: data,
	                    type: "read"
	                });

	                data = that.reader.parse(data);

	                if (group.hasSubgroups) {
	                    temp = that.reader.groups(data);
	                } else {
	                    temp = that.reader.data(data);
	                    temp = temp.map(function (item) {
	                        return new model(item);
	                    });
	                }

	                group.items.omitChangeEvent = true;
	                for (var i = 0; i < temp.length; i++) {
	                    group.items.push(temp[i]);
	                }
	                group.items.omitChangeEvent = false;

	                that._updateRangePristineData(group);
	                that._fetchingGroupItems = false;
	                that._serverGroupsTotal += temp.length;
	                that.range(skip, take, callback, "expandGroup");

	                if (timestamp >= that._currentRequestTimeStamp || !that._skipRequestsInProgress) {
	                    that.trigger(CHANGE, {});
	                }
	            };

	        },

	        findSubgroups: function (group) {
	            var indexOfCurrentGroup = this._group.map(function (g) {
	                return g.field;
	            }).indexOf(group.field);

	            return this._group.slice(indexOfCurrentGroup + 1, this._group.length);
	        },

	        _composeItemsFilter: function (group, parents) {
	            var filter = this.filter() || {
	                logic: "and",
	                filters: []
	            };

	            filter = extend(true, {}, filter);
	            filter.filters.push({
	                field: group.field,
	                operator: "eq",
	                value: group.value
	            });

	            if (parents) {
	                for (var i = 0; i < parents.length; i++) {
	                    filter.filters.push({
	                        field: parents[i].field,
	                        operator: "eq",
	                        value: parents[i].value
	                    });
	                }
	            }

	            return filter;
	        },

	        _updateRangePristineData: function (group) {
	            var that = this;
	            var ranges = that._ranges;
	            var rangesLength = ranges.length;
	            var temp;
	            var currentGroup;
	            var range;
	            var dataLength;
	            var indexes;

	            for (var i = 0; i < rangesLength; i++) {
	                range = ranges[i];
	                dataLength = range.data.length;
	                indexes = [];

	                for (var j = 0; j < dataLength; j++) {
	                    currentGroup = range.data[j];
	                    indexes.push(j);

	                    if ((currentGroup.uid === group.uid) || (currentGroup.hasSubgroups && currentGroup.items.length && that._containsSubGroup(currentGroup, group, indexes))) {
	                        break;
	                    }
	                    indexes.pop();
	                }

	                if (indexes.length) {
	                    temp = ranges[i].pristineData;

	                    while (indexes.length > 1) {
	                        temp = temp[indexes.splice(0, 1)[0]].items;
	                    }
	                    temp[indexes[0]] = that._cloneGroup(group);
	                    break;
	                }
	            }
	        },

	        _containsSubGroup: function (group, subgroup, indexes) {
	            var that = this;
	            var length = group.items.length;
	            var currentSubGroup;

	            if (group.hasSubgroups && length) {
	                for (var i = 0; i < length; i++) {
	                    currentSubGroup = group.items[i];
	                    indexes.push(i);
	                    if (currentSubGroup.uid === subgroup.uid) {
	                        return true;
	                    } else if (currentSubGroup.hasSubgroups && currentSubGroup.items.length) {
	                        return that._containsSubGroup(currentSubGroup, subgroup, indexes);
	                    }
	                    indexes.pop();
	                }
	            }

	        },

	        _cloneGroup: function (group) {
	            var that = this;
	            group = typeof group.toJSON == "function" ? group.toJSON() : group;

	            if (group.items && group.items.length) {
	                group.items = group.items.map(function (item) {
	                    return that._cloneGroup(item);
	                });
	            }

	            return group;
	        },

	        _setFilterTotal: function(filterTotal, setDefaultValue) {
	            var that = this;

	            if (!that.options.serverFiltering) {
	                if (filterTotal !== undefined) {
	                    that._total = filterTotal;
	                } else if (setDefaultValue) {
	                    that._total = that._data.length;
	                }
	            }
	        },

	        fetch: function(callback) {
	            var that = this;
	            var fn = function(isPrevented) {
	                if (isPrevented !== true && isFunction(callback)) {
	                    callback.call(that);
	                }
	            };

	            return this._query().done(fn);
	        },

	        _query: function(options) {
	            var that = this;

	            return that.query(extend({}, {
	                page: that.page(),
	                pageSize: that.pageSize(),
	                sort: that.sort(),
	                filter: that.filter(),
	                group: that.group(),
	                aggregate: that.aggregate()
	            }, options));
	        },

	        next: function(options) {
	            var that = this,
	                page = that.page(),
	                total = that.total();

	            options = options || {};

	            if (!page || (total && page + 1 > that.totalPages())) {
	                return;
	            }

	            that._skip = that._currentRangeStart = page * that.take();

	            page += 1;
	            options.page = page;

	            that._query(options);

	            return page;
	        },

	        prev: function(options) {
	            var that = this,
	                page = that.page();

	            options = options || {};

	            if (!page || page === 1) {
	                return;
	            }

	            that._skip = that._currentRangeStart = that._skip - that.take();

	            page -= 1;
	            options.page = page;

	            that._query(options);

	            return page;
	        },

	        page: function(val) {
	            var that = this,
	            skip;

	            if(val !== undefined) {
	                val = math.max(math.min(math.max(val, 1), that.totalPages()), 1);
	                var take = that.take();

	                if (that._isGroupPaged()) {
	                    val -= 1;
	                    that.range(val * take, take, null, "page");
	                    return;
	                }
	                that._query(that._pageableQueryOptions({ page: val }));
	                return;
	            }
	            skip = that.skip();

	            return skip !== undefined ? math.round((skip || 0) / (that.take() || 1)) + 1 : undefined;
	        },

	        pageSize: function(val) {
	            var that = this;

	            if (val !== undefined) {
	                that._query(that._pageableQueryOptions({ pageSize: val, page: 1 }));
	                return;
	            }

	            return that.take();
	        },

	        sort: function(val) {
	            var that = this;

	            if(val !== undefined) {
	                that.trigger("sort");
	                that._query({ sort: val });
	                return;
	            }

	            return that._sort;
	        },

	        filter: function(val) {
	            var that = this;

	            if (val === undefined) {
	                return that._filter;
	            }

	            that.trigger("reset");
	            that._query({ filter: val, page: 1 });
	        },

	        group: function(val) {
	            var that = this;
	            var options = { group: val };

	            if (that._groupPaging) {
	                options.page = 1;
	            }

	            if(val !== undefined) {
	                that._query(options);
	                return;
	            }

	            return that._group;
	        },

	        getGroupsFlat: function (data) {
	            var idx,
	                result = [],
	                length;

	            for (idx = 0, length = data.length; idx < length; idx++) {
	                var group = data[idx];
	                if (group.hasSubgroups) {
	                    result = result.concat(this.getGroupsFlat(group.items));
	                }

	                result.push(group);
	            }

	            return result;
	        },

	        total: function() {
	            return parseInt(this._total || 0, 10);
	        },

	        groupsTotal: function (includeExpanded) {
	            var that = this;

	            if (!that._group.length) {
	                return that.total();
	            }

	            if (that._isServerGrouped()) {
	                if (that._serverGroupsTotal) {
	                    return that._serverGroupsTotal;
	                }
	                that._serverGroupsTotal = that.total();

	                return that._serverGroupsTotal;
	            }

	            return that._calculateGroupsTotal(that._ranges.length ? that._ranges[0].data : [], includeExpanded);
	        },

	        _calculateGroupsTotal: function (groups, includeExpanded, itemsField, ignoreState) {
	            var that = this;
	            itemsField = itemsField || "items";
	            var total;
	            var length;

	            if (that._group.length && groups) {
	                total = 0;
	                length = groups.length;

	                for (var i = 0; i < length; i++) {
	                    total += that.groupCount(groups[i], includeExpanded, itemsField, ignoreState);
	                }
	                that._groupsTotal = total;
	                return total;
	            }

	            that._groupsTotal = that._data.length;
	            return that._groupsTotal;
	        },

	        groupCount: function (group, includeExpanded, itemsField, ignoreState) {
	            var that = this;
	            var total = 0;

	            if (group.hasSubgroups && that._groupsState[group.uid]) {
	                if (includeExpanded && !group.excludeHeader || ignoreState) {
	                    total += 1;
	                }

	                group[itemsField].forEach(function (subgroup) {
	                    total += that.groupCount(subgroup, includeExpanded, itemsField, ignoreState);
	                });
	            } else {
	                if (that._groupsState[group.uid]) {
	                    if (includeExpanded && !group.excludeHeader || ignoreState) {
	                        total++;
	                    }
	                    total += group[itemsField] ? group[itemsField].length : 0;
	                } else {
	                    total++;
	                }
	            }
	            return total;
	        },

	        countGroupRange: function (range) {
	            var total = 0;
	            var length = range.length;

	            for (var i = 0; i < length; i++) {
	                total += this.groupCount(range[i], true);
	            }

	            return total;
	        },

	        aggregate: function(val) {
	            var that = this;

	            if(val !== undefined) {
	                that._query({ aggregate: val });
	                return;
	            }

	            return that._aggregate;
	        },

	        aggregates: function() {
	            var result = this._aggregateResult;

	            if (isEmptyObject(result)) {
	                result = this._emptyAggregates(this.aggregate());
	            }

	            return result;
	        },

	        _emptyAggregates: function(aggregates) {
	            var result = {};

	            if (!isEmptyObject(aggregates)) {
	                var aggregate = {};

	                if (!isArray(aggregates)){
	                    aggregates = [aggregates];
	                }

	                for (var idx = 0; idx <aggregates.length; idx++) {
	                    aggregate[aggregates[idx].aggregate] = 0;
	                    result[aggregates[idx].field] = aggregate;
	                }
	            }

	            return result;
	        },

	        _pageableQueryOptions: function(options) {
	            return options;
	        },

	        _wrapInEmptyGroup: function(model) {
	            var groups = this.group(),
	                parent,
	                group,
	                idx,
	                length;

	            for (idx = groups.length-1, length = 0; idx >= length; idx--) {
	                group = groups[idx];
	                parent = {
	                    value: model.get ? model.get(group.field) : model[group.field],
	                    field: group.field,
	                    items: parent ? [parent] : [model],
	                    hasSubgroups: !!parent,
	                    aggregates: this._emptyAggregates(group.aggregates)
	                };
	            }

	            return parent;
	        },

	        totalPages: function() {
	            var that = this,
	                pageSize = that.pageSize() || that.total(),
	                total = that._isGroupPaged() ? that.groupsTotal(true) : that.total();

	            return math.ceil((total || 0) / pageSize);
	        },

	        inRange: function(skip, take) {
	            var that = this,
	                end = math.min(skip + take, that.total());

	            if (!that.options.serverPaging && that._data.length > 0) {
	                return true;
	            }

	            return that._findRange(skip, end).length > 0;
	        },

	        lastRange: function() {
	            var ranges = this._ranges;
	            return ranges[ranges.length - 1] || { start: 0, end: 0, data: [] };
	        },

	        firstItemUid: function() {
	            var ranges = this._ranges;
	            return ranges.length && ranges[0].data.length && ranges[0].data[0].uid;
	        },

	        enableRequestsInProgress: function() {
	            this._skipRequestsInProgress = false;
	        },

	        _timeStamp: function() {
	            return new Date().getTime();
	        },

	        range: function(skip, take, callback, action) {
	            this._currentRequestTimeStamp = this._timeStamp();
	            this._skipRequestsInProgress = true;
	            var total = this._isGroupPaged() ? this.groupsTotal(true) : this.total();

	            if (action === "expandGroup" || action === "collapseGroup") {
	                this._updateOuterRangesLength();
	            }

	            skip = math.min(skip || 0, total);
	            callback = isFunction(callback) ? callback : noop;

	            var that = this,
	                pageSkip = math.max(math.floor(skip / take), 0) * take,
	                size = math.min(pageSkip + take, total),
	                data;

	            data = that._findRange(skip, math.min(skip + take, total), callback);

	            if ((data.length || total === 0) && !that._fetchingGroupItems) {
	                that._processRangeData(data, skip, take, that._originalPageSkip || pageSkip, that._originalSize || size, {
	                    action: action
	                });
	                that._originalPageSkip = null;
	                that._originalSize = null;
	                callback();
	                return;
	            }

	            if (that._isGroupPaged()) {
	                that._originalPageSkip = pageSkip;
	                that._originalSize = size;

	                pageSkip = math.max(math.floor(that._adjustPageSkip(skip, take) / take), 0) * take;
	                size = math.min(pageSkip + take, total);
	            }

	            if (take !== undefined && !that._fetchingGroupItems) {
	                if ((that._isGroupPaged() && !that._groupRangeExists(pageSkip, take)) || !that._rangeExists(pageSkip, size)) {
	                    that.prefetch(pageSkip, take, function() {
	                        if (skip > pageSkip && size < that.total() && !that._rangeExists(size, math.min(size + take, that.total()))) {
	                            that.prefetch(size, take, function() {
	                                that.range(skip, take, callback );
	                            });
	                        } else {
	                            that.range(skip, take, callback);
	                        }
	                    });
	                } else if (pageSkip < skip) {
	                    that.prefetch(size, take, function() {
	                        that.range(skip, take, callback );
	                    });
	                }
	            }
	        },

	        _findRange: function(start, end, callback) {
	            var that = this,
	                ranges = that._ranges,
	                range,
	                data = [],
	                skipIdx,
	                takeIdx,
	                startIndex,
	                endIndex,
	                rangeData,
	                rangeEnd,
	                processed,
	                options = that.options,
	                remote = options.serverSorting || options.serverPaging || options.serverFiltering || options.serverGrouping || options.serverAggregates,
	                flatData,
	                count,
	                length,
	                groupMapOptions = {
	                        take: end - start,
	                        skip: start,
	                        skipped: 0,
	                        taken: 0,
	                        includeParents: true
	                    },
	                prevRangeEnd,
	                isGroupPaged = that._isGroupPaged(),
	                startField = isGroupPaged ? "outerStart" : "start",
	                endField = isGroupPaged ? "outerEnd" : "end",
	                currentDataLength;

	            for (skipIdx = 0, length = ranges.length; skipIdx < length; skipIdx++) {
	                range = ranges[skipIdx];

	                if (isGroupPaged) {
	                    if (range.outerStart >= end) {
	                        return [];
	                    }

	                    if (start > range.outerEnd) {
	                        groupMapOptions.skipped += range.outerEnd - (prevRangeEnd || 0);
	                        prevRangeEnd = range.outerEnd;
	                        continue;
	                    }

	                    if (typeof prevRangeEnd !== "undefined" && prevRangeEnd != range.outerStart) {
	                        groupMapOptions.skipped += range.outerStart - prevRangeEnd;
	                    }

	                    if (groupMapOptions.skipped > groupMapOptions.skip) {
	                        return [];
	                    }

	                    if (typeof prevRangeEnd === "undefined" && start > 0 && range.start > 0) {
	                        groupMapOptions.skipped = range.outerStart;
	                    }

	                    takeIdx = skipIdx;
	                    while (true) {
	                        this._findGroupedRange(range.data, data, groupMapOptions, null, callback);
	                        currentDataLength = that._calculateGroupsTotal(data, true, "currentItems");

	                        if (currentDataLength >= groupMapOptions.take) {
	                            return data;
	                        }

	                        if (that._fetchingGroupItems) {
	                            return [];
	                        }
	                        takeIdx++;

	                        if (ranges[takeIdx] && ranges[takeIdx].outerStart === range.outerEnd) {
	                            range = ranges[takeIdx];
	                        } else {
	                            break;
	                        }
	                    }
	                } else if (start >= range[startField] && start <= range[endField]) {
	                    count = 0;

	                    for (takeIdx = skipIdx; takeIdx < length; takeIdx++) {
	                        range = ranges[takeIdx];
	                        flatData = that._flatData(range.data, true);

	                        if (flatData.length && start + count >= range.start) {
	                            rangeData = range.data;
	                            rangeEnd = range.end;

	                            if (!remote) {
	                                if (options.inPlaceSort) {
	                                    processed = that._queryProcess(range.data, { filter: that.filter() });
	                                } else {
	                                    var sort = normalizeGroupWithoutCompare(that.group() || []).concat(normalizeSort(that.sort() || []));
	                                    processed = that._queryProcess(range.data, { sort: sort, filter: that.filter() });
	                                }
	                                flatData = rangeData = processed.data;

	                                if (processed.total !== undefined) {
	                                    rangeEnd = processed.total;
	                                }
	                            }

	                            startIndex = 0;
	                            if (start + count > range.start) {
	                                startIndex = (start + count) - range.start;
	                            }
	                            endIndex = flatData.length;
	                            if (rangeEnd > end) {
	                                endIndex = endIndex - (rangeEnd - end);
	                            }
	                            count += endIndex - startIndex;
	                            data = that._mergeGroups(data, rangeData, startIndex, endIndex);

	                            if (end <= range.end && count == end - start) {
	                                return data;
	                            }
	                        }
	                    }
	                    break;
	                }
	                prevRangeEnd = range.outerEnd;
	            }
	            return [];
	        },

	        _getRangesMismatch: function (pageSkip) {
	            var that = this;
	            var ranges = that._ranges;
	            var mismatch = 0;
	            var i = 0;

	            while (true) {
	                var range = ranges[i];
	                if (!range || range.outerStart > pageSkip) {
	                    break;
	                }

	                if (range.outerEnd != range.end) {
	                    mismatch = range.outerEnd - range.end;
	                }
	                i++;
	            }

	            return mismatch;
	        },

	        _mergeGroups: function(data, range, skip, take) {
	            if (this._isServerGrouped()) {
	                var temp = range.toJSON(),
	                    prevGroup;

	                if (data.length) {
	                    prevGroup = data[data.length - 1];
	                }

	                mergeGroups(prevGroup, temp, skip, take);

	                return data.concat(temp);
	            }
	            return data.concat(range.slice(skip, take));
	        },

	        _processRangeData: function(data, skip, take, pageSkip, size, eventData) {
	            var that = this;

	            that._pending = undefined;

	            that._skip = skip > that.skip() && !that._omitPrefetch ? math.min(size, (that.totalPages() - 1) * that.take()) : pageSkip;

	            that._currentRangeStart = skip;

	            that._take = take;

	            var paging = that.options.serverPaging;
	            var sorting = that.options.serverSorting;
	            var filtering = that.options.serverFiltering;
	            var aggregates = that.options.serverAggregates;
	            try {
	                that.options.serverPaging = true;
	                if (!that._isServerGrouped() && !(that.group() && that.group().length)) {
	                    that.options.serverSorting = true;
	                }
	                that.options.serverFiltering = true;
	                that.options.serverPaging = true;
	                that.options.serverAggregates = true;

	                if (paging) {
	                    that._detachObservableParents();
	                    that._data = data = that._observe(data);
	                }
	                that._process(data, eventData);
	            } finally {
	                that.options.serverPaging = paging;
	                that.options.serverSorting = sorting;
	                that.options.serverFiltering = filtering;
	                that.options.serverAggregates = aggregates;
	            }
	        },

	        skip: function() {
	            var that = this;

	            if (that._skip === undefined) {
	                return (that._page !== undefined ? (that._page  - 1) * (that.take() || 1) : undefined);
	            }
	            return that._skip;
	        },

	        currentRangeStart: function() {
	            return this._currentRangeStart || 0;
	        },

	        take: function() {
	            return this._take || this._pageSize;
	        },

	        _prefetchSuccessHandler: function (skip, size, callback, force) {
	            var that = this;
	            var timestamp = that._timeStamp();

	            return function(data) {
	                var found = false,
	                    range = { start: skip, end: size, data: [], timestamp: that._timeStamp() },
	                    idx,
	                    length,
	                    temp;

	                that._dequeueRequest();

	                that.trigger(REQUESTEND, { response: data, type: "read" });

	                data = that.reader.parse(data);

	                temp = that._readData(data);

	                if (temp.length) {
	                    for (idx = 0, length = that._ranges.length; idx < length; idx++) {
	                        if (that._ranges[idx].start === skip) {
	                            found = true;
	                            range = that._ranges[idx];

	                            if (!that._isGroupPaged()) {
	                                range.pristineData = temp;
	                                range.data = that._observe(temp);
	                                range.end = range.start + that._flatData(range.data, true).length;
	                                that._sortRanges();
	                            }

	                            break;
	                        }
	                    }

	                    if (!found) {
	                        that._addRange(that._observe(temp), skip);
	                    }
	                }

	                that._total = that.reader.total(data);

	                if (force || (timestamp >= that._currentRequestTimeStamp || !that._skipRequestsInProgress)) {
	                    if (callback && temp.length) {
	                        callback();
	                    } else {
	                        that.trigger(CHANGE, {});
	                    }
	                }
	            };
	        },

	        prefetch: function(skip, take, callback) {
	            var that = this,
	                size = math.min(skip + take, that.total()),
	                options = {
	                    take: take,
	                    skip: skip,
	                    page: skip / take + 1,
	                    pageSize: take,
	                    sort: that._sort,
	                    filter: that._filter,
	                    group: that._group,
	                    aggregate: that._aggregate
	                };


	            if ((that._isGroupPaged() && !that._isServerGrouped() && that._groupRangeExists(skip, size))) {
	                if (callback) {
	                    callback();
	                }
	                return;
	            }

	            if ((that._isServerGroupPaged() && !that._groupRangeExists(skip, size)) || !that._rangeExists(skip, size)) {
	                clearTimeout(that._timeout);

	                that._timeout = setTimeout(function() {
	                    that._queueRequest(options, function() {
	                        if (!that.trigger(REQUESTSTART, { type: "read" })) {
	                            if (that._omitPrefetch) {
	                                that.trigger(PROGRESS);
	                            }
	                            that.transport.read({
	                                data: that._params(options),
	                                success: that._prefetchSuccessHandler(skip, size, callback),
	                                error: function() {
	                                    var args = slice.call(arguments);
	                                    that.error.apply(that, args);
	                                }
	                            });
	                        } else {
	                            that._dequeueRequest();
	                        }
	                    });
	                }, 100);
	            } else if (callback) {
	                callback();
	            }
	        },

	        _multiplePrefetch: function(skip, take, callback) {
	            var that = this,
	                size = math.min(skip + take, that.total()),
	                options = {
	                    take: take,
	                    skip: skip,
	                    page: skip / take + 1,
	                    pageSize: take,
	                    sort: that._sort,
	                    filter: that._filter,
	                    group: that._group,
	                    aggregate: that._aggregate
	                };

	            if (!that._rangeExists(skip, size)) {
	                if (!that.trigger(REQUESTSTART, { type: "read" })) {
	                    that.transport.read({
	                        data: that._params(options),
	                        success: that._prefetchSuccessHandler(skip, size, callback, true)
	                    });
	                }
	            } else if (callback) {
	                callback();
	            }
	        },

	        _adjustPageSkip: function (start, take) {
	            var that = this;
	            var prevRange = that._getPrevRange(start);
	            var result;
	            var total = that.total();
	            var mismatch;

	            if (prevRange) {
	                mismatch = that._getRangesMismatch(start);

	                if (!mismatch) {
	                    return start;
	                }
	                start -= mismatch;
	            }
	            result = math.max(math.floor(start / take), 0) * take;

	            if (result > total) {
	                while (true) {
	                    result -= take;
	                    if (result < total) {
	                        break;
	                    }
	                }
	            }
	            return result;
	        },

	        _getNextRange: function (end) {
	            var that = this,
	                ranges = that._ranges,
	                idx,
	                length;

	            for (idx = 0, length = ranges.length; idx < length; idx++) {
	                if (ranges[idx].start <= end && ranges[idx].end >= end) {
	                    return ranges[idx];
	                }
	            }
	        },

	        _getPrevRange: function (start) {
	            var that = this,
	                ranges = that._ranges,
	                idx,
	                range,
	                length = ranges.length;

	            for (idx = length - 1; idx >= 0; idx--) {
	                if (ranges[idx].outerStart <= start) {
	                    range = ranges[idx];
	                    break;
	                }

	            }

	            return range;
	        },

	        _rangeExists: function(start, end) {
	            var that = this,
	                ranges = that._ranges,
	                idx,
	                length;

	            for (idx = 0, length = ranges.length; idx < length; idx++) {
	                if (ranges[idx].start <= start && ranges[idx].end >= end) {
	                    return true;
	                }
	            }

	            return false;
	        },

	        _groupRangeExists: function (start, end) {
	            var that = this,
	                ranges = that._ranges,
	                idx,
	                length,
	                availableItemsCount = 0,
	                total = that.groupsTotal(true);

	            if (end > total && !that._isServerGrouped()) {
	                end = total;
	            }

	            for (idx = 0, length = ranges.length; idx < length; idx++) {
	                var range = ranges[idx];
	                if (range.outerStart <= start && range.outerEnd >= start) {
	                    availableItemsCount += range.outerEnd - start;
	                } else if (range.outerStart <= end && range.outerEnd >= end) {
	                    availableItemsCount += end - range.outerStart;
	                }
	            }

	            return availableItemsCount >= end - start;
	        },

	        _getCurrentRangeSpan: function() {
	            var that = this;
	            var ranges = that._ranges;
	            var start = that.currentRangeStart();
	            var end = start + (that.take() || 0);
	            var rangeSpan = [];
	            var range;
	            var idx;
	            var length = ranges.length;

	            for (idx = 0; idx < length; idx++) {
	                range = ranges[idx];

	                if ((range.start <= start && range.end >= start) || (range.start >= start && range.start <= end)) {
	                    rangeSpan.push(range);
	                }
	            }

	            return rangeSpan;
	        },

	        _removeModelFromRanges: function(model) {
	            var that = this;
	            var range;

	            for (var idx = 0, length = this._ranges.length; idx < length; idx++) {
	                range = this._ranges[idx];

	                that._removeModelFromRange(range, model);
	            }

	            that._updateRangesLength();
	        },

	        _removeModelFromRange: function(range, model) {
	            this._eachItem(range.data, function(data) {
	                if (!data) {
	                    return;
	                }
	                for (var idx = 0; idx < data.length; idx++) {
	                    var dataItem = data[idx];

	                    if (dataItem.uid && dataItem.uid == model.uid) {
	                        [].splice.call(data, idx, 1);
	                        break;
	                    }
	                }
	            });
	        },

	        _insertModelInRange: function(index, model) {
	            var that = this;
	            var ranges = that._ranges || [];
	            var rangesLength = ranges.length;
	            var range;
	            var i;

	            for (i = 0; i < rangesLength; i++) {
	                range = ranges[i];

	                if (range.start <= index && range.end >= index) {
	                    if (!that._getByUid(model.uid, range.data)) {
	                        if (that._isServerGrouped()) {
	                            range.data.splice(index, 0, that._wrapInEmptyGroup(model));
	                        } else {
	                            range.data.splice(index, 0, model);
	                        }
	                    }

	                    break;
	                }
	            }

	            that._updateRangesLength();
	        },

	        _updateRangesLength: function() {
	            var that = this;
	            var ranges = that._ranges || [];
	            var rangesLength = ranges.length;
	            var mismatchFound = false;
	            var mismatchLength = 0;
	            var lengthDifference = 0;
	            var rangeLength;
	            var range;
	            var i;

	            for (i = 0; i < rangesLength; i++) {
	                range = ranges[i];
	                rangeLength = that._isGroupPaged() ? range.data.length : that._flatData(range.data, true).length;
	                lengthDifference = rangeLength - math.abs(range.end - range.start);

	                if (!mismatchFound && lengthDifference !== 0) {
	                    mismatchFound = true;
	                    mismatchLength = lengthDifference;
	                    range.end += mismatchLength;
	                    continue;
	                }

	                if (mismatchFound) {
	                    range.start += mismatchLength;
	                    range.end += mismatchLength;
	                }
	            }
	        },

	        _updateOuterRangesLength: function () {
	            var that = this;
	            var ranges = that._ranges || [];
	            var rangesLength = ranges.length;
	            var mismatchLength = 0;
	            var range;
	            var i;
	            var prevRange;
	            var rangeLength;

	            for (i = 0; i < rangesLength; i++) {
	                range = ranges[i];
	                rangeLength = that._isGroupPaged() ? that._calculateGroupsTotal(range.data, true, "items", true) : that._flatData(range.data, true).length;

	                if (prevRange) {
	                    if (prevRange.end != range.start) {
	                        mismatchLength = range.start - prevRange.end;
	                    }
	                    range.outerStart = prevRange.outerEnd + mismatchLength;
	                    mismatchLength = 0;
	                } else {
	                    range.outerStart = range.start;
	                }

	                range.outerEnd = range.outerStart + rangeLength;
	                prevRange = range;
	            }
	        }
	    });

	    var Transport = {};

	    Transport.create = function(options, data, dataSource) {
	        var transport,
	            transportOptions = options.transport ? $.extend({}, options.transport) : null;

	        if (transportOptions) {
	            transportOptions.read = typeof transportOptions.read === STRING ? { url: transportOptions.read } : transportOptions.read;

	            if (options.type === "jsdo") {
	                transportOptions.dataSource = dataSource;
	            }

	            if (options.type) {
	                kendo.data.transports = kendo.data.transports || {};
	                kendo.data.schemas = kendo.data.schemas || {};

	                if (!kendo.data.transports[options.type]) {
	                    kendo.logToConsole("Unknown DataSource transport type '" + options.type + "'.\nVerify that registration scripts for this type are included after Kendo UI on the page.", "warn");
	                } else if (!isPlainObject(kendo.data.transports[options.type])) {
	                    transport = new kendo.data.transports[options.type](extend(transportOptions, { data: data }));
	                } else {
	                    transportOptions = extend(true, {}, kendo.data.transports[options.type], transportOptions);
	                }

	                options.schema = extend(true, {}, kendo.data.schemas[options.type], options.schema);
	            }

	            if (!transport) {
	                transport = isFunction(transportOptions.read) ? transportOptions : new RemoteTransport(transportOptions);
	            }
	        } else {
	            transport = new LocalTransport({ data: options.data || [] });
	        }
	        return transport;
	    };

	    DataSource.create = function(options) {
	        if (isArray(options) || options instanceof ObservableArray) {
	           options = { data: options };
	        }

	        var dataSource = options || {},
	            data = dataSource.data,
	            fields = dataSource.fields,
	            table = dataSource.table,
	            select = dataSource.select,
	            idx,
	            length,
	            model = {},
	            field;

	        if (!data && fields && !dataSource.transport) {
	            if (table) {
	                data = inferTable(table, fields);
	            } else if (select) {
	                data = inferSelect(select, fields);

	                if (dataSource.group === undefined && data[0] && data[0].optgroup !== undefined) {
	                    dataSource.group = "optgroup";
	                }
	            }
	        }

	        if (kendo.data.Model && fields && (!dataSource.schema || !dataSource.schema.model)) {
	            for (idx = 0, length = fields.length; idx < length; idx++) {
	                field = fields[idx];
	                if (field.type) {
	                    model[field.field] = field;
	                }
	            }

	            if (!isEmptyObject(model)) {
	                dataSource.schema = extend(true, dataSource.schema, { model:  { fields: model } });
	            }
	        }

	        dataSource.data = data;

	        select = null;
	        dataSource.select = null;
	        table = null;
	        dataSource.table = null;

	        return dataSource instanceof DataSource ? dataSource : new DataSource(dataSource);
	    };

	    function inferSelect(select, fields) {
	        select = $(select)[0];
	        var options = select.options;
	        var firstField = fields[0];
	        var secondField = fields[1];

	        var data = [];
	        var idx, length;
	        var optgroup;
	        var option;
	        var record;
	        var value;

	        for (idx = 0, length = options.length; idx < length; idx++) {
	            record = {};
	            option = options[idx];
	            optgroup = option.parentNode;

	            if (optgroup === select) {
	                optgroup = null;
	            }

	            if (option.disabled || (optgroup && optgroup.disabled)) {
	                continue;
	            }

	            if (optgroup) {
	                record.optgroup = optgroup.label;
	            }

	            record[firstField.field] = option.text;

	            value = option.attributes.value;

	            if (value && value.specified) {
	                value = option.value;
	            } else {
	                value = option.text;
	            }

	            record[secondField.field] = value;

	            data.push(record);
	        }

	        return data;
	    }

	    function inferTable(table, fields) {
	        var tbody = $(table)[0].tBodies[0],
	        rows = tbody ? tbody.rows : [],
	        idx,
	        length,
	        fieldIndex,
	        fieldCount = fields.length,
	        data = [],
	        cells,
	        record,
	        cell,
	        empty;

	        for (idx = 0, length = rows.length; idx < length; idx++) {
	            record = {};
	            empty = true;
	            cells = rows[idx].cells;

	            for (fieldIndex = 0; fieldIndex < fieldCount; fieldIndex++) {
	                cell = cells[fieldIndex];
	                if(cell.nodeName.toLowerCase() !== "th") {
	                    empty = false;
	                    record[fields[fieldIndex].field] = cell.innerHTML;
	                }
	            }
	            if(!empty) {
	                data.push(record);
	            }
	        }

	        return data;
	    }

	    var Node = Model.define({
	        idField: "id",

	        init: function(value) {
	            var that = this,
	                hasChildren = that.hasChildren || value && value.hasChildren,
	                childrenField = "items",
	                childrenOptions = {};

	            kendo.data.Model.fn.init.call(that, value);

	            if (typeof that.children === STRING) {
	                childrenField = that.children;
	            }

	            childrenOptions = {
	                schema: {
	                    data: childrenField,
	                    model: {
	                        hasChildren: hasChildren,
	                        id: that.idField,
	                        fields: that.fields
	                    }
	                }
	            };

	            if (typeof that.children !== STRING) {
	                extend(childrenOptions, that.children);
	            }

	            childrenOptions.data = value;

	            if (!hasChildren) {
	                hasChildren = childrenOptions.schema.data;
	            }

	            if (typeof hasChildren === STRING) {
	                hasChildren = kendo.getter(hasChildren);
	            }

	            if (isFunction(hasChildren)) {
	                var hasChildrenObject = hasChildren.call(that, that);

	                if(hasChildrenObject && hasChildrenObject.length === 0){
	                    that.hasChildren = false;
	                } else{
	                    that.hasChildren = !!hasChildrenObject;
	                }
	            }

	            that._childrenOptions = childrenOptions;

	            if (that.hasChildren) {
	                that._initChildren();
	            }

	            that._loaded = !!(value && value._loaded);
	        },

	        _initChildren: function() {
	            var that = this;
	            var children, transport, parameterMap;

	            if (!(that.children instanceof HierarchicalDataSource)) {
	                children = that.children = new HierarchicalDataSource(that._childrenOptions);

	                transport = children.transport;
	                parameterMap = transport.parameterMap;

	                transport.parameterMap = function(data, type) {
	                    data[that.idField || "id"] = that.id;

	                    if (parameterMap) {
	                        data = parameterMap.call(that, data, type);
	                    }

	                    return data;
	                };

	                children.parent = function(){
	                    return that;
	                };

	                children.bind(CHANGE, function(e){
	                    e.node = e.node || that;
	                    that.trigger(CHANGE, e);
	                });

	                children.bind(ERROR, function(e){
	                    var collection = that.parent();

	                    if (collection) {
	                        e.node = e.node || that;
	                        collection.trigger(ERROR, e);
	                    }
	                });

	                that._updateChildrenField();
	            }
	        },

	        append: function(model) {
	            this._initChildren();
	            this.loaded(true);
	            this.children.add(model);
	        },

	        hasChildren: false,

	        level: function() {
	            var parentNode = this.parentNode(),
	                level = 0;

	            while (parentNode && parentNode.parentNode) {
	                level++;
	                parentNode = parentNode.parentNode ? parentNode.parentNode() : null;
	            }

	            return level;
	        },

	        _updateChildrenField: function() {
	            var fieldName = this._childrenOptions.schema.data;

	            this[fieldName || "items"] = this.children.data();
	        },

	        _childrenLoaded: function() {
	            this._loaded = true;

	            this._updateChildrenField();
	        },

	        load: function() {
	            var options = {};
	            var method = "_query";
	            var children, promise;

	            if (this.hasChildren) {
	                this._initChildren();

	                children = this.children;

	                options[this.idField || "id"] = this.id;

	                if (!this._loaded) {
	                    children._data = undefined;
	                    method = "read";
	                }

	                children.one(CHANGE, proxy(this._childrenLoaded, this));

	                if(this._matchFilter){
	                    options.filter = { field: '_matchFilter', operator: 'eq', value: true };
	                }

	                promise = children[method](options);
	            } else {
	                this.loaded(true);
	            }

	            return promise || $.Deferred().resolve().promise();
	        },

	        parentNode: function() {
	            var array = this.parent();

	            return array.parent();
	        },

	        loaded: function(value) {
	            if (value !== undefined) {
	                this._loaded = value;
	            } else {
	                return this._loaded;
	            }
	        },

	        shouldSerialize: function(field) {
	            return Model.fn.shouldSerialize.call(this, field) &&
	                    field !== "children" &&
	                    field !== "_loaded" &&
	                    field !== "hasChildren" &&
	                    field !== "_childrenOptions";
	        }
	    });

	    function dataMethod(name) {
	        return function() {
	            var data = this._data,
	                result = DataSource.fn[name].apply(this, slice.call(arguments));

	            if (this._data != data) {
	                this._attachBubbleHandlers();
	            }

	            return result;
	        };
	    }

	    var HierarchicalDataSource = DataSource.extend({
	        init: function(options) {
	            var node = Node.define({
	                children: options
	            });

	            if(options.filter && !options.serverFiltering){
	                this._hierarchicalFilter = options.filter;
	                options.filter = null;
	            }

	            DataSource.fn.init.call(this, extend(true, {}, { schema: { modelBase: node, model: node } }, options));

	            this._attachBubbleHandlers();
	        },

	        _attachBubbleHandlers: function() {
	            var that = this;

	            that._data.bind(ERROR, function(e) {
	                that.trigger(ERROR, e);
	            });
	        },

	        read: function(data) {
	            var result = DataSource.fn.read.call(this, data);

	            if(this._hierarchicalFilter){
	                if(this._data && this._data.length > 0){
	                    this.filter(this._hierarchicalFilter);
	                }else{
	                    this.options.filter = this._hierarchicalFilter;
	                    this._filter = normalizeFilter(this.options.filter);
	                    this._hierarchicalFilter = null;
	                }
	            }

	            return result;
	        },

	        remove: function(node){
	            var parentNode = node.parentNode(),
	                dataSource = this,
	                result;

	            if (parentNode && parentNode._initChildren) {
	                dataSource = parentNode.children;
	            }

	            result = DataSource.fn.remove.call(dataSource, node);

	            if (parentNode && !dataSource.data().length) {
	                parentNode.hasChildren = false;
	            }

	            return result;
	        },

	        success: dataMethod("success"),

	        data: dataMethod("data"),

	        insert: function(index, model) {
	            var parentNode = this.parent();

	            if (parentNode && parentNode._initChildren) {
	                parentNode.hasChildren = true;
	                parentNode._initChildren();
	            }

	            return DataSource.fn.insert.call(this, index, model);
	        },

	        filter: function(val) {
	            if (val === undefined) {
	                 return this._filter;
	            }

	            if(!this.options.serverFiltering && this._markHierarchicalQuery(val)){
	                val = { logic: "or", filters: [val, {field:'_matchFilter', operator: 'equals', value: true }]};
	            }

	            this.trigger("reset");
	            this._query({ filter: val, page: 1 });
	        },

	        _markHierarchicalQuery: function(expressions){
	            var compiled;
	            var predicate;
	            var fields;
	            var operators;
	            var filter;
	            var accentFoldingFiltering = this.options.accentFoldingFiltering;

	            expressions = accentFoldingFiltering ? $.extend({}, normalizeFilter(expressions), { accentFoldingFiltering: accentFoldingFiltering}) : normalizeFilter(expressions);

	            if (!expressions || expressions.filters.length === 0) {
	                this._updateHierarchicalFilter(function(){return true;});
	                return false;
	            }

	            compiled = Query.filterExpr(expressions);
	            fields = compiled.fields;
	            operators = compiled.operators;

	            predicate = filter = new Function("d, __f, __o", "return " + compiled.expression);

	            if (fields.length || operators.length) {
	                filter = function(d) {
	                    return predicate(d, fields, operators);
	                };
	            }

	            this._updateHierarchicalFilter(filter);
	            return true;
	        },

	         _updateHierarchicalFilter: function(filter){
	            var current;
	            var data = this._data;
	            var result = false;

	            for (var idx = 0; idx < data.length; idx++) {
	                 current = data[idx];

	                 if(current.hasChildren){
	                     current._matchFilter = current.children._updateHierarchicalFilter(filter);
	                    if(!current._matchFilter){
	                        current._matchFilter = filter(current);
	                    }
	                }else{
	                    current._matchFilter = filter(current);
	                }

	                if(current._matchFilter){
	                    result = true;
	                }
	            }
	            return result;
	        },

	        _find: function(method, value) {
	            var idx, length, node, children;
	            var data = this._data;

	            if (!data) {
	                return;
	            }

	            node = DataSource.fn[method].call(this, value);

	            if (node) {
	                return node;
	            }

	            data = this._flatData(this._data);

	            for (idx = 0, length = data.length; idx < length; idx++) {
	                children = data[idx].children;

	                if (!(children instanceof HierarchicalDataSource)) {
	                    continue;
	                }

	                node = children[method](value);

	                if (node) {
	                    return node;
	                }
	            }
	        },

	        get: function(id) {
	            return this._find("get", id);
	        },

	        getByUid: function(uid) {
	            return this._find("getByUid", uid);
	        }
	    });

	    function inferList(list, fields) {
	        var items = $(list).children(),
	            idx,
	            length,
	            data = [],
	            record,
	            textField = fields[0].field,
	            urlField = fields[1] && fields[1].field,
	            spriteCssClassField = fields[2] && fields[2].field,
	            imageUrlField = fields[3] && fields[3].field,
	            item,
	            id,
	            textChild,
	            className,
	            children;

	        function elements(collection, tagName) {
	            return collection.filter(tagName).add(collection.find(tagName));
	        }

	        for (idx = 0, length = items.length; idx < length; idx++) {
	            record = { _loaded: true };
	            item = items.eq(idx);

	            textChild = item[0].firstChild;
	            children = item.children();
	            list = children.filter("ul");
	            children = children.filter(":not(ul)");

	            id = item.attr("data-id");

	            if (id) {
	                record.id = id;
	            }

	            if (textChild) {
	                record[textField] = textChild.nodeType == 3 ? textChild.nodeValue : children.text();
	            }

	            if (urlField) {
	                record[urlField] = elements(children, "a").attr("href");
	            }

	            if (imageUrlField) {
	                record[imageUrlField] = elements(children, "img").attr("src");
	            }

	            if (spriteCssClassField) {
	                className = elements(children, ".k-sprite").prop("className");
	                record[spriteCssClassField] = className && kendo.trim(className.replace("k-sprite", ""));
	            }

	            if (list.length) {
	                record.items = inferList(list.eq(0), fields);
	            }

	            if (item.attr("data-hasChildren") == "true") {
	                record.hasChildren = true;
	            }

	            data.push(record);
	        }

	        return data;
	    }

	    HierarchicalDataSource.create = function(options) {
	        options = options && options.push ? { data: options } : options;

	        var dataSource = options || {},
	            data = dataSource.data,
	            fields = dataSource.fields,
	            list = dataSource.list;

	        if (data && data._dataSource) {
	            return data._dataSource;
	        }

	        if (!data && fields && !dataSource.transport) {
	            if (list) {
	                data = inferList(list, fields);
	            }
	        }

	        dataSource.data = data;

	        return dataSource instanceof HierarchicalDataSource ? dataSource : new HierarchicalDataSource(dataSource);
	    };

	    var Buffer = kendo.Observable.extend({
	        init: function(dataSource, viewSize, disablePrefetch) {
	            kendo.Observable.fn.init.call(this);

	            this._prefetching = false;
	            this.dataSource = dataSource;
	            this.prefetch = !disablePrefetch;

	            var buffer = this;

	            dataSource.bind("change", function() {
	                buffer._change();
	            });

	            dataSource.bind("reset", function() {
	                buffer._reset();
	            });

	            this._syncWithDataSource();

	            this.setViewSize(viewSize);
	        },

	        setViewSize: function(viewSize) {
	            this.viewSize = viewSize;
	            this._recalculate();
	        },

	        at: function(index)  {
	            var pageSize = this.pageSize,
	                itemPresent = true;

	            if (index >= this.total()) {
	                this.trigger("endreached", {index: index });
	                return null;
	            }

	            if (!this.useRanges) {
	               return this.dataSource.view()[index];
	            }
	            if (this.useRanges) {
	                // out of range request
	                if (index < this.dataOffset || index >= this.skip + pageSize) {
	                    itemPresent = this.range(Math.floor(index / pageSize) * pageSize);
	                }

	                // prefetch
	                if (index === this.prefetchThreshold) {
	                    this._prefetch();
	                }

	                // mid-range jump - prefetchThreshold and nextPageThreshold may be equal, do not change to else if
	                if (index === this.midPageThreshold) {
	                    this.range(this.nextMidRange, true);
	                }
	                // next range jump
	                else if (index === this.nextPageThreshold) {
	                    this.range(this.nextFullRange);
	                }
	                // pull-back
	                else if (index === this.pullBackThreshold) {
	                    if (this.offset === this.skip) { // from full range to mid range
	                        this.range(this.previousMidRange);
	                    } else { // from mid range to full range
	                        this.range(this.previousFullRange);
	                    }
	                }

	                if (itemPresent) {
	                    return this.dataSource.at(index - this.dataOffset);
	                } else {
	                    this.trigger("endreached", { index: index });
	                    return null;
	                }
	            }
	        },

	        indexOf: function(item) {
	            return this.dataSource.data().indexOf(item) + this.dataOffset;
	        },

	        total: function() {
	            return parseInt(this.dataSource.total(), 10);
	        },

	        next: function() {
	            var buffer = this,
	                pageSize = buffer.pageSize,
	                offset = buffer.skip - buffer.viewSize + pageSize,
	                pageSkip = math.max(math.floor(offset / pageSize), 0) * pageSize;

	            this.offset = offset;
	            this.dataSource.prefetch(pageSkip, pageSize, function() {
	                buffer._goToRange(offset, true);
	            });
	        },

	        range: function(offset, nextRange) {
	            if (this.offset === offset) {
	                return true;
	            }

	            var buffer = this,
	                pageSize = this.pageSize,
	                pageSkip = math.max(math.floor(offset / pageSize), 0) * pageSize,
	                dataSource = this.dataSource;

	            if (nextRange) {
	                pageSkip += pageSize;
	            }

	            if (dataSource.inRange(offset, pageSize)) {
	                this.offset = offset;
	                this._recalculate();
	                this._goToRange(offset);
	                return true;
	            } else if (this.prefetch) {
	                dataSource.prefetch(pageSkip, pageSize, function() {
	                    buffer.offset = offset;
	                    buffer._recalculate();
	                    buffer._goToRange(offset, true);
	                });
	                return false;
	            }

	            return true;
	        },

	        syncDataSource: function() {
	            var offset = this.offset;
	            this.offset = null;
	            this.range(offset);
	        },

	        destroy: function() {
	            this.unbind();
	        },

	        _prefetch: function() {
	            var buffer = this,
	                pageSize = this.pageSize,
	                prefetchOffset = this.skip + pageSize,
	                dataSource = this.dataSource;

	            if (!dataSource.inRange(prefetchOffset, pageSize) && !this._prefetching && this.prefetch) {
	                this._prefetching = true;
	                this.trigger("prefetching", { skip: prefetchOffset, take: pageSize });

	                dataSource.prefetch(prefetchOffset, pageSize, function() {
	                    buffer._prefetching = false;
	                    buffer.trigger("prefetched", { skip: prefetchOffset, take: pageSize });
	                });
	            }
	        },

	        _goToRange: function(offset, expanding) {
	            if (this.offset !== offset) {
	                return;
	            }

	            this.dataOffset = offset;
	            this._expanding = expanding;
	            this.dataSource.range(offset, this.pageSize);
	            this.dataSource.enableRequestsInProgress();
	        },

	        _reset: function() {
	            this._syncPending = true;
	        },

	        _change: function() {
	            var dataSource = this.dataSource;

	            this.length = this.useRanges ? dataSource.lastRange().end : dataSource.view().length;

	            if (this._syncPending) {
	                this._syncWithDataSource();
	                this._recalculate();
	                this._syncPending = false;
	                this.trigger("reset", { offset: this.offset });
	            }

	            this.trigger("resize");

	            if (this._expanding) {
	                this.trigger("expand");
	            }

	            delete this._expanding;
	        },

	        _syncWithDataSource: function() {
	            var dataSource = this.dataSource;

	            this._firstItemUid = dataSource.firstItemUid();
	            this.dataOffset = this.offset = dataSource.skip() || 0;
	            this.pageSize = dataSource.pageSize();
	            this.useRanges = dataSource.options.serverPaging;
	        },

	        _recalculate: function() {
	            var pageSize = this.pageSize,
	                offset = this.offset,
	                viewSize = this.viewSize,
	                skip = Math.ceil(offset / pageSize) * pageSize;

	            this.skip = skip;
	            this.midPageThreshold = skip + pageSize - 1;
	            this.nextPageThreshold = skip + viewSize - 1;
	            this.prefetchThreshold = skip + Math.floor(pageSize / 3 * 2);
	            this.pullBackThreshold = this.offset - 1;

	            this.nextMidRange = skip + pageSize - viewSize;
	            this.nextFullRange = skip;
	            this.previousMidRange = offset - viewSize;
	            this.previousFullRange = skip - pageSize;
	        }
	    });

	    var BatchBuffer = kendo.Observable.extend({
	        init: function(dataSource, batchSize) {
	            var batchBuffer = this;

	            kendo.Observable.fn.init.call(batchBuffer);

	            this.dataSource = dataSource;
	            this.batchSize = batchSize;
	            this._total = 0;

	            this.buffer = new Buffer(dataSource, batchSize * 3);

	            this.buffer.bind({
	                "endreached": function (e) {
	                    batchBuffer.trigger("endreached", { index: e.index });
	                },
	                "prefetching": function (e) {
	                    batchBuffer.trigger("prefetching", { skip: e.skip, take: e.take });
	                },
	                "prefetched": function (e) {
	                    batchBuffer.trigger("prefetched", { skip: e.skip, take: e.take });
	                },
	                "reset": function () {
	                    batchBuffer._total = 0;
	                    batchBuffer.trigger("reset");
	                },
	                "resize": function () {
	                    batchBuffer._total = Math.ceil(this.length / batchBuffer.batchSize);
	                    batchBuffer.trigger("resize", { total: batchBuffer.total(), offset: this.offset });
	                }
	            });
	        },

	        syncDataSource: function() {
	            this.buffer.syncDataSource();
	        },

	        at: function(index) {
	            var buffer = this.buffer,
	                skip = index * this.batchSize,
	                take = this.batchSize,
	                view = [],
	                item;

	            if (buffer.offset > skip) {
	                buffer.at(buffer.offset - 1);
	            }

	            for (var i = 0; i < take; i++) {
	                item = buffer.at(skip + i);

	                if (item === null) {
	                    break;
	                }

	                view.push(item);
	            }

	            return view;
	        },

	        total: function() {
	            return this._total;
	        },

	        destroy: function() {
	            this.buffer.destroy();
	            this.unbind();
	        }
	    });

	    extend(true, kendo.data, {
	        readers: {
	            json: DataReader
	        },
	        Query: Query,
	        DataSource: DataSource,
	        HierarchicalDataSource: HierarchicalDataSource,
	        Node: Node,
	        Comparer: Comparer,
	        ObservableObject: ObservableObject,
	        ObservableArray: ObservableArray,
	        LazyObservableArray: LazyObservableArray,
	        LocalTransport: LocalTransport,
	        RemoteTransport: RemoteTransport,
	        Cache: Cache,
	        DataReader: DataReader,
	        Model: Model,
	        Buffer: Buffer,
	        BatchBuffer: BatchBuffer
	    });
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1097:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("WPfE");

/***/ }),

/***/ 1098:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("rS7A");

/***/ })

/******/ });

/***/ }),

/***/ "lkJ8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var grid_1 = __webpack_require__("5ela");
function initialiseAgGridWithAngular1(angular) {
    var angularModule = angular.module("agGrid", []);
    angularModule.directive("agGrid", function () {
        return {
            restrict: "A",
            controller: ['$element', '$scope', '$compile', '$attrs', AngularDirectiveController],
            scope: true
        };
    });
}
exports.initialiseAgGridWithAngular1 = initialiseAgGridWithAngular1;
function AngularDirectiveController($element, $scope, $compile, $attrs) {
    var gridOptions;
    var quickFilterOnScope;
    var keyOfGridInScope = $attrs.agGrid;
    quickFilterOnScope = keyOfGridInScope + '.quickFilterText';
    gridOptions = $scope.$eval(keyOfGridInScope);
    if (!gridOptions) {
        console.warn("WARNING - grid options for ag-Grid not found. Please ensure the attribute ag-grid points to a valid object on the scope");
        return;
    }
    var eGridDiv = $element[0];
    var gridParams = {
        $scope: $scope,
        $compile: $compile,
        quickFilterOnScope: quickFilterOnScope
    };
    var grid = new grid_1.Grid(eGridDiv, gridOptions, gridParams);
    $scope.$on("$destroy", function () {
        grid.destroy();
    });
}


/***/ }),

/***/ "lktj":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("Ibhu");
var enumBugKeys = __webpack_require__("xnc9");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "lysN":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1005);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 973:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2UxK");

/***/ }),

/***/ 1005:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(973)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function() {

	(function(kendo, undefined) {
	    var global = window;
	    var math = global.Math;
	    var min = math.min;
	    var max = math.max;
	    var parseFloat = global.parseFloat;

	    var $ = kendo.jQuery;
	    var extend = $.extend;

	    var Editor = kendo.ui.editor;

	    var PERCENTAGE = "%";
	    var PIXEL = "px";
	    var REGEX_NUMBER_IN_PERCENTAGES = /(\d+)(\.?)(\d*)%/;
	    var REGEX_NUMBER_IN_PIXELS = /(\d+)(\.?)(\d*)px/;
	    var STRING = "string";

	    function constrain(options) {
	        var value = options.value;
	        var lowerBound = options.min;
	        var upperBound = options.max;

	        return max(min(parseFloat(value), parseFloat(upperBound)), parseFloat(lowerBound));
	    }

	    function getScrollBarWidth(element) {
	        if  (element && !$(element).is("body") && element.scrollHeight > element.clientHeight) {
	            return kendo.support.scrollbar();
	        }

	        return 0;
	    }

	    function calculatePercentageRatio(value, total) {
	        if (inPercentages(value)) {
	            return parseFloat(value);
	        }
	        else {
	            return ((parseFloat(value) / total) * 100);
	        }
	    }

	    function inPercentages(value) {
	        return (typeof(value) === STRING && REGEX_NUMBER_IN_PERCENTAGES.test(value));
	    }

	    function inPixels(value) {
	        return (typeof(value) === STRING && REGEX_NUMBER_IN_PIXELS.test(value));
	    }

	    function toPercentages(value) {
	        return (parseFloat(value) + PERCENTAGE);
	    }

	    function toPixels(value) {
	        return (parseFloat(value) + PIXEL);
	    }

	    var ResizingUtils = {
	        constrain: constrain,
	        getScrollBarWidth: getScrollBarWidth,
	        calculatePercentageRatio: calculatePercentageRatio,
	        inPercentages: inPercentages,
	        inPixels: inPixels,
	        toPercentages: toPercentages,
	        toPixels: toPixels
	    };

	    extend(Editor, {
	        ResizingUtils: ResizingUtils
	    });
	})(window.kendo);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "mJM+":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(955);
	module.exports = __webpack_require__(955);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(956) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {

	    var kendo = window.kendo,
	        ui = kendo.ui,
	        keys = kendo.keys,
	        DISABLED = "k-state-disabled",
	        SELECT = "select",
	        CHECKED = "checked",
	        proxy = $.proxy,
	        DATABOUND = "dataBound",
	        CLICK = "click",
	        NS = ".kendoTreeView",
	        INDETERMINATE = "indeterminate",
	        NAVIGATE = "navigate",
	        subGroup,
	        TreeView = ui.TreeView;

	        function contentChild(filter) {
	            return function(node) {
	                var result = node.children(".k-animation-container");

	                if (!result.length) {
	                    result = node;
	                }

	                return result.children(filter);
	            };
	        }

	        subGroup = contentChild(".k-group");

	    var Tree = TreeView.extend({
	        init: function(element, options, dropdowntree) {
	            var that = this;

	            that.dropdowntree = dropdowntree;
	            that._nodesToLoad = 0;

	            TreeView.fn.init.call(that, element, options);
	            if(that.dropdowntree._isMultipleSelection()){
	                that.wrapper.on(CLICK + NS, '.k-in.k-state-selected', proxy(that._clickSelectedItem, that));
	            }
	        },

	        _checkOnSelect: function (e) {
	            if (!e.isDefaultPrevented()) {
	                var dataItem = this.dataItem(e.node);

	                dataItem.set("checked", !dataItem.checked);
	            }
	        },

	        _setCheckedValue: function (node, value){
	            node.set(CHECKED, value);
	        },

	        _click: function (e) {
	            var that = this;

	            if(that.dropdowntree._isMultipleSelection()){
	                that.one("select", that._checkOnSelect);
	            }
	            TreeView.fn._click.call(that, e);
	        },

	        _clickSelectedItem: function (e) {
	            var that = this,
	            node = $(e.currentTarget);

	            that.one("select", that._checkOnSelect);
	            if (!that._trigger(SELECT, node)) {
	                that.dataItem(node).set("selected", false);
	            }
	        },

	        defaultrefresh: function(e) {
	            var that = this;
	            var node = e.node;
	            var action = e.action;
	            var items = e.items;
	            var parentNode = this.wrapper;
	            var options = this.options;
	            var loadOnDemand = options.loadOnDemand;
	            var checkChildren = options.checkboxes && options.checkboxes.checkChildren;
	            var i;

	            if (this._skip) {
	                return;
	            }

	            if (e.field) {
	                if (!items[0] || !items[0].level) {
	                    return;
	                }

	                return this._updateNodes(items, e.field);
	            }

	            if (node) {
	                parentNode = this.findByUid(node.uid);
	                this._progress(parentNode, false);
	            }

	            if (checkChildren && action != "remove") {
	                var bubble = false;

	                for (i = 0; i < items.length; i++) {
	                    if ("checked" in items[i]) {
	                        bubble = true;
	                        break;
	                    }
	                }

	                if (!bubble && node && node.checked) {
	                    for (i = 0; i < items.length; i++) {
	                        items[i].checked = true;
	                    }
	                }
	            }

	            if (action == "add") {
	                this._appendItems(e.index, items, parentNode);
	            } else if (action == "remove") {
	                this._remove(this.findByUid(items[0].uid), false);
	            } else if (action == "itemchange") {
	                this._updateNodes(items);
	            } else if (action == "itemloaded") {
	                this._nodesToLoad --;
	                this._refreshChildren(parentNode, items, e.index);
	            } else {
	                this._refreshRoot(items);
	            }

	            if (action != "remove") {
	                for (i = 0; i < items.length; i++) {
	                    if (!loadOnDemand || items[i].expanded) {
	                        if(items[i].hasChildren){
	                            that._nodesToLoad ++;
	                        }
	                        items[i].load();
	                    }
	                }
	            }
	            if(this._nodesToLoad === 0){
	                this.dropdowntree.trigger("allNodesAreLoaded");
	            }
	            this.trigger(DATABOUND, { node: node ? parentNode : undefined });
	            this.dropdowntree._treeViewDataBound({ node: node ? parentNode : undefined, sender: this });
	            if (this.options.checkboxes.checkChildren) {
	                this.updateIndeterminate();
	            }
	        },

	        _previousVisible: function(node) {
	            var that = this,
	                lastChild,
	                result;

	            if (!node.length || node.prev().length) {
	                if (node.length) {
	                    result = node.prev();
	                } else {
	                    result = that.root.children().last();
	                }

	                while (that._expanded(result)) {
	                    lastChild = subGroup(result).children().last();

	                    if (!lastChild.length) {
	                        break;
	                    }

	                    result = lastChild;
	                }
	            } else {
	                result = that.parent(node) || node;

	                if(!result.length){
	                    if (that.dropdowntree.checkAll && that.dropdowntree.checkAll.is(":visible")) {
	                        that.dropdowntree.checkAll.find(".k-checkbox").focus();
	                    } else if(that.dropdowntree.filterInput){
	                        that.dropdowntree.filterInput.focus();
	                    } else {
	                        that.dropdowntree.wrapper.focus();
	                    }
	                }
	            }

	            return result;
	        },

	        _keydown: function(e) {
	            var that = this,
	                key = e.keyCode,
	                target,
	                focused = that.current(),
	                expanded = that._expanded(focused),
	                checkbox = focused.find(".k-checkbox-wrapper:first :checkbox"),
	                rtl = kendo.support.isRtl(that.element);

	            if (e.target != e.currentTarget) {
	                return;
	            }

	            if ((!rtl && key == keys.RIGHT) || (rtl && key == keys.LEFT)) {
	                if (expanded) {
	                    target = that._nextVisible(focused);
	                } else if (!focused.find(".k-in:first").hasClass(DISABLED)) {
	                    that.expand(focused);
	                }
	            } else if ((!rtl && key == keys.LEFT) || (rtl && key == keys.RIGHT)) {
	                if (expanded && !focused.find(".k-in:first").hasClass(DISABLED)) {
	                    that.collapse(focused);
	                } else {
	                    target = that.parent(focused);

	                    if (!that._enabled(target)) {
	                        target = undefined;
	                    }
	                }
	            } else if (key == keys.DOWN) {
	                target = that._nextVisible(focused);
	            } else if (key == keys.UP && !e.altKey) {
	                target = that._previousVisible(focused);
	            } else if (key == keys.HOME) {
	                target = that._nextVisible($());
	            } else if (key == keys.END) {
	                target = that._previousVisible($());
	            } else if (key == keys.ENTER && !focused.find(".k-in:first").hasClass(DISABLED)) {
	                if (!focused.find(".k-in:first").hasClass("k-state-selected")) {
	                    if (!that._trigger(SELECT, focused)) {
	                        that.select(focused);
	                    }
	                }
	            } else if (key == keys.SPACEBAR && checkbox.length && !focused.find(".k-in:first").hasClass(DISABLED)) {
	                checkbox.prop(CHECKED, !checkbox.prop(CHECKED))
	                    .data(INDETERMINATE, false)
	                    .prop(INDETERMINATE, false);

	                that._checkboxChange({ target: checkbox });

	                target = focused;
	            } else if ((e.altKey && key === keys.UP) || key === keys.ESC) {
	                that._closePopup();
	            } else if ( key === keys.TAB) {
	                e.preventDefault();
	                that._closePopup();
	            }

	            if (target) {
	                e.preventDefault();

	                if (focused[0] != target[0]) {
	                    that._trigger(NAVIGATE, target);
	                    that.current(target);
	                }
	            }
	        },

	        _closePopup: function() {
	            this.dropdowntree.close();
	            this.dropdowntree.wrapper.focus();
	        },

	        refresh: function(e){
	            this.defaultrefresh(e);

	            if(this.dropdowntree.options.skipUpdateOnBind){
	                return;
	            }

	            if (e.action === "itemchange") {
	                if (this.dropdowntree._isMultipleSelection()) {
	                    if(e.field === "checked"){
	                        this.dropdowntree._checkValue(e.items[0]);
	                    }
	                } else {
	                    if(e.field !== "checked" && e.field !== "expanded" && e.items[0].selected){
	                        this.dropdowntree._selectValue(e.items[0]);
	                    }
	                }
	            } else {
	                this.dropdowntree.refresh(e);
	            }
	        }

	    });

	    kendo.ui._dropdowntree = Tree;

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 956:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ed5Q");

/***/ })

/******/ });

/***/ }),

/***/ "mJs/":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(950);
	module.exports = __webpack_require__(950);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 945:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("KBs5");

/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(945), __webpack_require__(951) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {

	    var kendo = window.kendo;
	    var draw = kendo.drawing;
	    var DrawingSurface = draw.Surface;
	    var Widget = kendo.ui.Widget;
	    var deepExtend = kendo.deepExtend;
	    var proxy = $.proxy;

	    kendo.support.svg = DrawingSurface.support.svg;
	    kendo.support.canvas = DrawingSurface.support.canvas;

	    var Surface = Widget.extend({
	        init: function(element, options) {
	            Widget.fn.init.call(this, element, {});

	            this.options = deepExtend({}, this.options, options);

	            this._instance = DrawingSurface.create(this.element[0], options);
	            if (this._instance.translate) {
	                this.translate = translate;
	            }

	            this._triggerInstanceHandler = proxy(this._triggerInstanceEvent, this);
	            this._bindHandler("click");
	            this._bindHandler("mouseenter");
	            this._bindHandler("mouseleave");
	            this._bindHandler("mousemove");

	            this._enableTracking();
	        },

	        options: {
	            name: "Surface",
	            tooltip: {}
	        },

	        events: [
	            "click",
	            "mouseenter",
	            "mouseleave",
	            "mousemove",
	            "resize",
	            "tooltipOpen",
	            "tooltipClose"
	        ],

	        _triggerInstanceEvent: function(e) {
	            this.trigger(e.type, e);
	        },

	        _bindHandler: function(event) {
	            this._instance.bind(event, this._triggerInstanceHandler);
	        },

	        draw: function(element) {
	            this._instance.draw(element);
	        },

	        clear: function() {
	            if (this._instance) {
	                this._instance.clear();
	            }
	            this.hideTooltip();
	        },

	        destroy: function() {
	            if (this._instance) {
	                this._instance.destroy();
	                delete this._instance;
	            }

	            if (this._tooltip) {
	                this._tooltip.destroy();
	                delete this._tooltip;
	            }

	            Widget.fn.destroy.call(this);
	        },

	        exportVisual: function() {
	            return this._instance.exportVisual();
	        },

	        eventTarget: function(e) {
	            return this._instance.eventTarget(e);
	        },

	        showTooltip: function(shape, options) {
	            if (this._tooltip) {
	                this._tooltip.show(shape, options);
	            }
	        },

	        hideTooltip: function() {
	            if (this._tooltip) {
	                this._tooltip.hide();
	            }
	        },

	        suspendTracking: function() {
	            this._instance.suspendTracking();
	            this.hideTooltip();
	        },

	        resumeTracking: function() {
	            this._instance.resumeTracking();
	        },

	        getSize: function() {
	            return {
	                width: this.element.width(),
	                height: this.element.height()
	            };
	        },

	        setSize: function(size) {
	            this.element.css({
	                width: size.width,
	                height: size.height
	            });

	            this._size = size;
	            this._instance.currentSize(size);
	            this._resize();
	        },

	        _resize: function() {
	            this._instance.currentSize(this._size);
	            this._instance._resize();
	        },

	        _enableTracking: function() {
	            if (kendo.ui.Popup) {
	                this._tooltip = new draw.SurfaceTooltip(this, this.options.tooltip || {});
	            }
	        }
	    });

	    kendo.ui.plugin(Surface);

	    Surface.create = function(element, options) {
	        return new Surface(element, options);
	    };

	    kendo.drawing.Surface = Surface;

	    function translate(offset) {
	        this._instance.translate(offset);
	    }

	})(window.kendo.jQuery);

	}, __webpack_require__(3));

/***/ }),

/***/ 951:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("b8bx");

/***/ })

/******/ });

/***/ }),

/***/ "mLPx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var sortController_1 = __webpack_require__("fxGZ");
var utils_1 = __webpack_require__("IRr6");
var valueService_1 = __webpack_require__("5JVC");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var columnController_1 = __webpack_require__("77lH");
var SortService = (function () {
    function SortService() {
    }
    SortService.prototype.sortAccordingToColumnsState = function (rowNode) {
        var sortOptions = this.sortController.getSortForRowController();
        this.sort(rowNode, sortOptions);
    };
    SortService.prototype.sort = function (rowNode, sortOptions) {
        var _this = this;
        rowNode.childrenAfterSort = rowNode.childrenAfterFilter.slice(0);
        // we clear out the 'pull down open parents' first, as the values mix up the sorting
        this.pullDownDataForHideOpenParents(rowNode, true);
        var sortActive = utils_1._.exists(sortOptions) && sortOptions.length > 0;
        if (sortActive) {
            // RE https://ag-grid.atlassian.net/browse/AG-444
            //Javascript sort is non deterministic when all the array items are equals
            //ie Comparator always returns 0, so if you want to ensure the array keeps its
            //order, then you need to add an additional sorting condition manually, in this
            //case we are going to inspect the original array position
            var sortedRowNodes = rowNode.childrenAfterSort.map(function (it, pos) {
                return { currentPos: pos, rowNode: it };
            });
            sortedRowNodes.sort(this.compareRowNodes.bind(this, sortOptions));
            rowNode.childrenAfterSort = sortedRowNodes.map(function (sorted) { return sorted.rowNode; });
        }
        this.updateChildIndexes(rowNode);
        this.pullDownDataForHideOpenParents(rowNode, false);
        // sort any groups recursively
        rowNode.childrenAfterFilter.forEach(function (child) {
            if (child.hasChildren()) {
                _this.sort(child, sortOptions);
            }
        });
    };
    SortService.prototype.compareRowNodes = function (sortOptions, sortedNodeA, sortedNodeB) {
        var nodeA = sortedNodeA.rowNode;
        var nodeB = sortedNodeB.rowNode;
        // Iterate columns, return the first that doesn't match
        for (var i = 0, len = sortOptions.length; i < len; i++) {
            var sortOption = sortOptions[i];
            // let compared = compare(nodeA, nodeB, sortOption.column, sortOption.inverter === -1);
            var isInverted = sortOption.inverter === -1;
            var valueA = this.getValue(nodeA, sortOption.column);
            var valueB = this.getValue(nodeB, sortOption.column);
            var comparatorResult = void 0;
            if (sortOption.column.getColDef().comparator) {
                //if comparator provided, use it
                comparatorResult = sortOption.column.getColDef().comparator(valueA, valueB, nodeA, nodeB, isInverted);
            }
            else {
                //otherwise do our own comparison
                comparatorResult = utils_1._.defaultComparator(valueA, valueB, this.gridOptionsWrapper.isAccentedSort());
            }
            if (comparatorResult !== 0) {
                return comparatorResult * sortOption.inverter;
            }
        }
        // All matched, we make is so that the original sort order is kept:
        return sortedNodeA.currentPos - sortedNodeB.currentPos;
    };
    SortService.prototype.getValue = function (nodeA, column) {
        return this.valueService.getValue(column, nodeA);
    };
    SortService.prototype.updateChildIndexes = function (rowNode) {
        if (utils_1._.missing(rowNode.childrenAfterSort)) {
            return;
        }
        rowNode.childrenAfterSort.forEach(function (child, index) {
            var firstChild = index === 0;
            var lastChild = index === rowNode.childrenAfterSort.length - 1;
            child.setFirstChild(firstChild);
            child.setLastChild(lastChild);
            child.setChildIndex(index);
        });
    };
    SortService.prototype.pullDownDataForHideOpenParents = function (rowNode, clearOperation) {
        var _this = this;
        if (utils_1._.missing(rowNode.childrenAfterSort)) {
            return;
        }
        if (!this.gridOptionsWrapper.isGroupHideOpenParents()) {
            return;
        }
        rowNode.childrenAfterSort.forEach(function (childRowNode) {
            var groupDisplayCols = _this.columnController.getGroupDisplayColumns();
            groupDisplayCols.forEach(function (groupDisplayCol) {
                var showRowGroup = groupDisplayCol.getColDef().showRowGroup;
                if (typeof showRowGroup !== 'string') {
                    console.error('ag-Grid: groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup');
                    return;
                }
                var displayingGroupKey = showRowGroup;
                var rowGroupColumn = _this.columnController.getPrimaryColumn(displayingGroupKey);
                var thisRowNodeMatches = rowGroupColumn === childRowNode.rowGroupColumn;
                if (thisRowNodeMatches) {
                    return;
                }
                if (clearOperation) {
                    // if doing a clear operation, we clear down the value for every possible group column
                    childRowNode.setGroupValue(groupDisplayCol.getId(), null);
                }
                else {
                    // if doing a set operation, we set only where the pull down is to occur
                    var parentToStealFrom = childRowNode.getFirstChildOfFirstChild(rowGroupColumn);
                    if (parentToStealFrom) {
                        childRowNode.setGroupValue(groupDisplayCol.getId(), parentToStealFrom.key);
                    }
                }
            });
        });
    };
    __decorate([
        context_1.Autowired('sortController'),
        __metadata("design:type", sortController_1.SortController)
    ], SortService.prototype, "sortController", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], SortService.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('valueService'),
        __metadata("design:type", valueService_1.ValueService)
    ], SortService.prototype, "valueService", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], SortService.prototype, "gridOptionsWrapper", void 0);
    SortService = __decorate([
        context_1.Bean('sortService')
    ], SortService);
    return SortService;
}());
exports.SortService = SortService;


/***/ }),

/***/ "mhUy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var rowNode_1 = __webpack_require__("bP2e");
var utils_1 = __webpack_require__("IRr6");
var InMemoryNodeManager = (function () {
    function InMemoryNodeManager(rootNode, gridOptionsWrapper, context, eventService, columnController) {
        this.nextId = 0;
        // when user is provide the id's, we also keep a map of ids to row nodes for convenience
        this.allNodesMap = {};
        this.rootNode = rootNode;
        this.gridOptionsWrapper = gridOptionsWrapper;
        this.context = context;
        this.eventService = eventService;
        this.columnController = columnController;
        this.rootNode.group = true;
        this.rootNode.level = -1;
        this.rootNode.id = InMemoryNodeManager.ROOT_NODE_ID;
        this.rootNode.allLeafChildren = [];
        this.rootNode.childrenAfterGroup = [];
        this.rootNode.childrenAfterSort = [];
        this.rootNode.childrenAfterFilter = [];
        // if we make this class a bean, then can annotate postConstruct
        this.postConstruct();
    }
    // @PostConstruct - this is not a bean, so postConstruct called by constructor
    InMemoryNodeManager.prototype.postConstruct = function () {
        // func below doesn't have 'this' pointer, so need to pull out these bits
        this.getNodeChildDetails = this.gridOptionsWrapper.getNodeChildDetailsFunc();
        this.suppressParentsInRowNodes = this.gridOptionsWrapper.isSuppressParentsInRowNodes();
        this.doesDataFlower = this.gridOptionsWrapper.getDoesDataFlowerFunc();
        this.isRowMasterFunc = this.gridOptionsWrapper.getIsRowMasterFunc();
        this.doingLegacyTreeData = utils_1.Utils.exists(this.getNodeChildDetails);
        this.doingMasterDetail = this.gridOptionsWrapper.isMasterDetail();
    };
    InMemoryNodeManager.prototype.getCopyOfNodesMap = function () {
        var result = utils_1.Utils.cloneObject(this.allNodesMap);
        return result;
    };
    InMemoryNodeManager.prototype.getRowNode = function (id) {
        return this.allNodesMap[id];
    };
    InMemoryNodeManager.prototype.setRowData = function (rowData) {
        this.rootNode.childrenAfterFilter = null;
        this.rootNode.childrenAfterGroup = null;
        this.rootNode.childrenAfterSort = null;
        this.rootNode.childrenMapped = null;
        this.nextId = 0;
        this.allNodesMap = {};
        if (!rowData) {
            this.rootNode.allLeafChildren = [];
            this.rootNode.childrenAfterGroup = [];
            return;
        }
        // kick off recursion
        var result = this.recursiveFunction(rowData, null, InMemoryNodeManager.TOP_LEVEL);
        if (this.doingLegacyTreeData) {
            this.rootNode.childrenAfterGroup = result;
            this.setLeafChildren(this.rootNode);
        }
        else {
            this.rootNode.allLeafChildren = result;
        }
    };
    InMemoryNodeManager.prototype.updateRowData = function (rowDataTran, rowNodeOrder) {
        var _this = this;
        if (this.isLegacyTreeData()) {
            return null;
        }
        var add = rowDataTran.add, addIndex = rowDataTran.addIndex, remove = rowDataTran.remove, update = rowDataTran.update;
        var rowNodeTransaction = {
            remove: [],
            update: [],
            add: []
        };
        if (utils_1.Utils.exists(add)) {
            var useIndex = typeof addIndex === 'number' && addIndex >= 0;
            if (useIndex) {
                // items get inserted in reverse order for index insertion
                add.reverse().forEach(function (item) {
                    var newRowNode = _this.addRowNode(item, addIndex);
                    rowNodeTransaction.add.push(newRowNode);
                });
            }
            else {
                add.forEach(function (item) {
                    var newRowNode = _this.addRowNode(item);
                    rowNodeTransaction.add.push(newRowNode);
                });
            }
        }
        if (utils_1.Utils.exists(remove)) {
            remove.forEach(function (item) {
                var removedRowNode = _this.updatedRowNode(item, false);
                if (removedRowNode) {
                    rowNodeTransaction.remove.push(removedRowNode);
                }
            });
        }
        if (utils_1.Utils.exists(update)) {
            update.forEach(function (item) {
                var updatedRowNode = _this.updatedRowNode(item, true);
                if (updatedRowNode) {
                    rowNodeTransaction.update.push(updatedRowNode);
                }
            });
        }
        if (rowNodeOrder) {
            utils_1.Utils.sortRowNodesByOrder(this.rootNode.allLeafChildren, rowNodeOrder);
        }
        return rowNodeTransaction;
    };
    InMemoryNodeManager.prototype.addRowNode = function (data, index) {
        var newNode = this.createNode(data, null, InMemoryNodeManager.TOP_LEVEL);
        if (utils_1.Utils.exists(index)) {
            utils_1.Utils.insertIntoArray(this.rootNode.allLeafChildren, newNode, index);
        }
        else {
            this.rootNode.allLeafChildren.push(newNode);
        }
        return newNode;
    };
    InMemoryNodeManager.prototype.updatedRowNode = function (data, update) {
        var rowNodeIdFunc = this.gridOptionsWrapper.getRowNodeIdFunc();
        var rowNode;
        if (utils_1.Utils.exists(rowNodeIdFunc)) {
            // find rowNode using id
            var id = rowNodeIdFunc(data);
            rowNode = this.allNodesMap[id];
            if (!rowNode) {
                console.error("ag-Grid: could not find row id=" + id + ", data item was not found for this id");
                return null;
            }
        }
        else {
            // find rowNode using object references
            rowNode = utils_1.Utils.find(this.rootNode.allLeafChildren, function (rowNode) { return rowNode.data === data; });
            if (!rowNode) {
                console.error("ag-Grid: could not find data item as object was not found", data);
                return null;
            }
        }
        if (update) {
            // do update
            rowNode.updateData(data);
        }
        else {
            // do delete
            rowNode.setSelected(false);
            utils_1.Utils.removeFromArray(this.rootNode.allLeafChildren, rowNode);
            this.allNodesMap[rowNode.id] = undefined;
        }
        return rowNode;
    };
    InMemoryNodeManager.prototype.recursiveFunction = function (rowData, parent, level) {
        var _this = this;
        // make sure the rowData is an array and not a string of json - this was a commonly reported problem on the forum
        if (typeof rowData === 'string') {
            console.warn('ag-Grid: rowData must be an array, however you passed in a string. If you are loading JSON, make sure you convert the JSON string to JavaScript objects first');
            return;
        }
        var rowNodes = [];
        rowData.forEach(function (dataItem) {
            var node = _this.createNode(dataItem, parent, level);
            rowNodes.push(node);
        });
        return rowNodes;
    };
    InMemoryNodeManager.prototype.createNode = function (dataItem, parent, level) {
        var node = new rowNode_1.RowNode();
        this.context.wireBean(node);
        var doingTreeData = this.gridOptionsWrapper.isTreeData();
        var doingLegacyTreeData = !doingTreeData && utils_1.Utils.exists(this.getNodeChildDetails);
        var nodeChildDetails = doingLegacyTreeData ? this.getNodeChildDetails(dataItem) : null;
        if (nodeChildDetails && nodeChildDetails.group) {
            node.group = true;
            node.childrenAfterGroup = this.recursiveFunction(nodeChildDetails.children, node, level + 1);
            node.expanded = nodeChildDetails.expanded === true;
            node.field = nodeChildDetails.field;
            node.key = nodeChildDetails.key;
            node.canFlower = node.master; // deprecated, is now 'master'
            // pull out all the leaf children and add to our node
            this.setLeafChildren(node);
        }
        else {
            node.group = false;
            if (doingTreeData) {
                node.master = false;
                node.expanded = false;
            }
            else {
                // this is the default, for when doing grid data
                if (this.doesDataFlower) {
                    node.master = this.doesDataFlower(dataItem);
                }
                else if (this.doingMasterDetail) {
                    // if we are doing master detail, then the
                    // default is that everything can flower.
                    if (this.isRowMasterFunc) {
                        node.master = this.isRowMasterFunc(dataItem);
                    }
                    else {
                        node.master = true;
                    }
                }
                else {
                    node.master = false;
                }
                node.expanded = node.master ? this.isExpanded(level) : false;
            }
        }
        // support for backwards compatibility, canFlow is now called 'master'
        node.canFlower = node.master;
        if (parent && !this.suppressParentsInRowNodes) {
            node.parent = parent;
        }
        node.level = level;
        node.setDataAndId(dataItem, this.nextId.toString());
        this.allNodesMap[node.id] = node;
        this.nextId++;
        return node;
    };
    InMemoryNodeManager.prototype.isExpanded = function (level) {
        var expandByDefault = this.gridOptionsWrapper.getGroupDefaultExpanded();
        if (expandByDefault === -1) {
            return true;
        }
        else {
            return level < expandByDefault;
        }
    };
    // this is only used for doing legacy tree data
    InMemoryNodeManager.prototype.setLeafChildren = function (node) {
        node.allLeafChildren = [];
        if (node.childrenAfterGroup) {
            node.childrenAfterGroup.forEach(function (childAfterGroup) {
                if (childAfterGroup.group) {
                    if (childAfterGroup.allLeafChildren) {
                        childAfterGroup.allLeafChildren.forEach(function (leafChild) { return node.allLeafChildren.push(leafChild); });
                    }
                }
                else {
                    node.allLeafChildren.push(childAfterGroup);
                }
            });
        }
    };
    InMemoryNodeManager.prototype.insertItemsAtIndex = function (index, rowData) {
        if (this.isLegacyTreeData()) {
            return null;
        }
        var nodeList = this.rootNode.allLeafChildren;
        if (index > nodeList.length) {
            console.warn("ag-Grid: invalid index " + index + ", max index is " + nodeList.length);
            return;
        }
        var newNodes = [];
        // go through the items backwards, otherwise they get added in reverse order
        for (var i = rowData.length - 1; i >= 0; i--) {
            var data = rowData[i];
            var newNode = this.createNode(data, null, InMemoryNodeManager.TOP_LEVEL);
            utils_1.Utils.insertIntoArray(nodeList, newNode, index);
            newNodes.push(newNode);
        }
        return newNodes.length > 0 ? newNodes : null;
    };
    InMemoryNodeManager.prototype.addItems = function (items) {
        var nodeList = this.rootNode.allLeafChildren;
        return this.insertItemsAtIndex(nodeList.length, items);
    };
    InMemoryNodeManager.prototype.isLegacyTreeData = function () {
        var rowsAlreadyGrouped = utils_1.Utils.exists(this.gridOptionsWrapper.getNodeChildDetailsFunc());
        if (rowsAlreadyGrouped) {
            console.warn('ag-Grid: adding and removing rows is not supported when using nodeChildDetailsFunc, ie it is not ' +
                'supported for legacy tree data. Please see the docs on the new preferred way of providing tree data that works with delta updates.');
            return true;
        }
        else {
            return false;
        }
    };
    InMemoryNodeManager.TOP_LEVEL = 0;
    InMemoryNodeManager.ROOT_NODE_ID = 'ROOT_NODE_ID';
    return InMemoryNodeManager;
}());
exports.InMemoryNodeManager = InMemoryNodeManager;


/***/ }),

/***/ "migL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var utils_1 = __webpack_require__("IRr6");
var componentProvider_1 = __webpack_require__("evUn");
var agComponentUtils_1 = __webpack_require__("rVYJ");
var componentMetadataProvider_1 = __webpack_require__("djkc");
var ComponentType;
(function (ComponentType) {
    ComponentType[ComponentType["AG_GRID"] = 0] = "AG_GRID";
    ComponentType[ComponentType["FRAMEWORK"] = 1] = "FRAMEWORK";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
var ComponentSource;
(function (ComponentSource) {
    ComponentSource[ComponentSource["DEFAULT"] = 0] = "DEFAULT";
    ComponentSource[ComponentSource["REGISTERED_BY_NAME"] = 1] = "REGISTERED_BY_NAME";
    ComponentSource[ComponentSource["HARDCODED"] = 2] = "HARDCODED";
})(ComponentSource = exports.ComponentSource || (exports.ComponentSource = {}));
var ComponentResolver = (function () {
    function ComponentResolver() {
    }
    /**
     * This method returns the underlying representation of the component to be created. ie for Javascript the
     * underlying function where we should be calling new into. In case of the frameworks, the framework class
     * object that represents the component to be created.
     *
     * This method is handy for different reasons, for example if you want to check if a component has a particular
     * method implemented without having to create the component, just by inspecting the source component
     *
     * It takes
     *  @param holder: This is the context for which this component needs to be created, it can be gridOptions
     *      (global) or columnDef mostly.
     *  @param propertyName: The name of the property used in ag-grid as a convention to refer to the component, it can be:
     *      'floatingFilter', 'cellRenderer', is used to find if the user is specifying a custom component
     *  @param dynamicComponentParams: Params to be passed to the dynamic component function in case it needs to be
     *      invoked
     *  @param defaultComponentName: The name of the component to load if there is no component specified
     */
    ComponentResolver.prototype.getComponentToUse = function (holder, propertyName, dynamicComponentParams, defaultComponentName) {
        /**
         * There are five things that can happen when resolving a component.
         *  a) HardcodedFwComponent: That holder[propertyName]Framework has associated a Framework native component
         *  b) HardcodedJsComponent: That holder[propertyName] has associate a JS component
         *  c) hardcodedJsFunction: That holder[propertyName] has associate a JS function
         *  d) hardcodedNameComponent: That holder[propertyName] has associate a string that represents a component to load
         *  e) That none of the three previous are specified, then we need to use the DefaultRegisteredComponent
         */
        var hardcodedNameComponent = null;
        var HardcodedJsComponent = null;
        var hardcodedJsFunction = null;
        var HardcodedFwComponent = null;
        var dynamicComponentFn;
        if (holder != null) {
            var componentPropertyValue = holder[propertyName];
            if (componentPropertyValue != null) {
                if (typeof componentPropertyValue === 'string') {
                    hardcodedNameComponent = componentPropertyValue;
                }
                else if (this.agComponentUtils.doesImplementIComponent(componentPropertyValue)) {
                    HardcodedJsComponent = componentPropertyValue;
                }
                else {
                    hardcodedJsFunction = componentPropertyValue;
                }
            }
            HardcodedFwComponent = holder[propertyName + "Framework"];
            dynamicComponentFn = holder[propertyName + "Selector"];
        }
        /**
         * Since we allow many types of flavors for specifying the components, let's make sure this is not an illegal
         * combination
         */
        if ((HardcodedJsComponent && HardcodedFwComponent) ||
            (hardcodedNameComponent && HardcodedFwComponent) ||
            (hardcodedJsFunction && HardcodedFwComponent)) {
            throw Error("ag-grid: you are trying to specify: " + propertyName + " twice as a component.");
        }
        if (HardcodedFwComponent && !this.frameworkComponentWrapper) {
            throw Error("ag-grid: you are specifying a framework component but you are not using a framework version of ag-grid for : " + propertyName);
        }
        if (dynamicComponentFn && (hardcodedNameComponent || HardcodedJsComponent || hardcodedJsFunction || HardcodedFwComponent)) {
            throw Error("ag-grid: you can't specify both, the selector and the component of ag-grid for : " + propertyName);
        }
        /**
         * At this stage we are guaranteed to either have,
         * DEPRECATED
         * - A unique HardcodedFwComponent
         * - A unique HardcodedJsComponent
         * - A unique hardcodedJsFunction
         * BY NAME- FAVOURED APPROACH
         * - A unique hardcodedNameComponent
         * - None of the previous, hence we revert to: RegisteredComponent
         */
        if (HardcodedFwComponent) {
            // console.warn(`ag-grid: Since version 12.1.0 specifying a component directly is deprecated, you should register the component by name`);
            // console.warn(`${HardcodedFwComponent}`);
            return {
                type: ComponentType.FRAMEWORK,
                component: HardcodedFwComponent,
                source: ComponentSource.HARDCODED,
                dynamicParams: null
            };
        }
        if (HardcodedJsComponent) {
            // console.warn(`ag-grid: Since version 12.1.0 specifying a component directly is deprecated, you should register the component by name`);
            // console.warn(`${HardcodedJsComponent}`);
            return {
                type: ComponentType.AG_GRID,
                component: HardcodedJsComponent,
                source: ComponentSource.HARDCODED,
                dynamicParams: null
            };
        }
        if (hardcodedJsFunction) {
            // console.warn(`ag-grid: Since version 12.1.0 specifying a function directly is deprecated, you should register the component by name`);
            // console.warn(`${hardcodedJsFunction}`);
            return this.agComponentUtils.adaptFunction(propertyName, hardcodedJsFunction, ComponentType.AG_GRID, ComponentSource.HARDCODED);
        }
        if (dynamicComponentFn) {
            var dynamicComponentDef = dynamicComponentFn(dynamicComponentParams);
            if (dynamicComponentDef != null) {
                if (dynamicComponentDef.component == null) {
                    dynamicComponentDef.component = defaultComponentName;
                }
                var dynamicComponent = this.resolveByName(propertyName, dynamicComponentDef.component);
                return utils_1._.assign(dynamicComponent, {
                    dynamicParams: dynamicComponentDef.params
                });
            }
        }
        //^^^^^ABOVE DEPRECATED - AT THIS POINT WE ARE RESOLVING BY NAME
        var componentNameToUse;
        if (hardcodedNameComponent) {
            componentNameToUse = hardcodedNameComponent;
        }
        else {
            componentNameToUse = defaultComponentName;
        }
        return componentNameToUse == null ? null : this.resolveByName(propertyName, componentNameToUse);
    };
    ComponentResolver.prototype.resolveByName = function (propertyName, componentNameOpt) {
        var componentName = componentNameOpt != null ? componentNameOpt : propertyName;
        var registeredComponent = this.componentProvider.retrieve(componentName);
        if (registeredComponent == null)
            return null;
        //If it is a FW it has to be registered as a component
        if (registeredComponent.type == ComponentType.FRAMEWORK) {
            return {
                component: registeredComponent.component,
                type: ComponentType.FRAMEWORK,
                source: ComponentSource.REGISTERED_BY_NAME,
                dynamicParams: null
            };
        }
        //If it is JS it may be a function or a component
        if (this.agComponentUtils.doesImplementIComponent(registeredComponent.component)) {
            return {
                component: registeredComponent.component,
                type: ComponentType.AG_GRID,
                source: (registeredComponent.source == componentProvider_1.RegisteredComponentSource.REGISTERED) ? ComponentSource.REGISTERED_BY_NAME : ComponentSource.DEFAULT,
                dynamicParams: null
            };
        }
        // This is a function
        return this.agComponentUtils.adaptFunction(propertyName, registeredComponent.component, registeredComponent.type, (registeredComponent.source == componentProvider_1.RegisteredComponentSource.REGISTERED) ? ComponentSource.REGISTERED_BY_NAME : ComponentSource.DEFAULT);
    };
    /**
     * Useful to check what would be the resultant params for a given object
     *  @param holder: This is the context for which this component needs to be created, it can be gridOptions
     *      (global) or columnDef mostly.
     *  @param propertyName: The name of the property used in ag-grid as a convention to refer to the component, it can be:
     *      'floatingFilter', 'cellRenderer', is used to find if the user is specifying a custom component
     *  @param agGridParams: Params to be passed to the component and passed by ag-Grid. This will get merged with any params
     *      specified by the user in the configuration
     * @returns {any} It merges the user agGridParams with the actual params specified by the user.
     */
    ComponentResolver.prototype.mergeParams = function (holder, propertyName, agGridParams, dynamicCustomParams, dynamicParams) {
        if (dynamicParams === void 0) { dynamicParams = null; }
        var customParamsRaw = holder ? holder[propertyName + "Params"] : null;
        var finalParams = {};
        utils_1._.mergeDeep(finalParams, agGridParams);
        if (customParamsRaw != null) {
            var customParams = null;
            if (typeof customParamsRaw === 'function') {
                customParams = customParamsRaw(dynamicCustomParams);
            }
            else {
                customParams = customParamsRaw;
            }
            utils_1._.mergeDeep(finalParams, customParams);
        }
        utils_1._.mergeDeep(finalParams, dynamicParams);
        if (!finalParams.api) {
            finalParams.api = this.gridOptions.api;
        }
        return finalParams;
    };
    /**
     * This method creates a component given everything needed to guess what sort of component needs to be instantiated
     * It takes
     *  @param holderOpt: This is the context for which this component needs to be created, it can be gridOptions
     *      (global) or columnDef mostly.
     *  @param agGridParams: Params to be passed to the component and passed by ag-Grid. This will get merged with any params
     *      specified by the user in the configuration
     *  @param propertyName: The name of the property used in ag-grid as a convention to refer to the component, it can be:
     *      'floatingFilter', 'cellRenderer', is used to find if the user is specifying a custom component
     *  @param dynamicComponentParams: Params to be passed to the dynamic component function in case it needs to be
     *      invoked
     *  @param defaultComponentName: The actual name of the component to instantiate, this is usually the same as propertyName, but in
     *      some cases is not, like floatingFilter, if it is the same is not necessary to specify
     *  @param mandatory: Handy method to tell if this should return a component ALWAYS. if that is the case, but there is no
     *      component found, it throws an error, by default all components are MANDATORY
     *  @param customInitParamsCb: A chance to customise the params passed to the init method. It receives what the current
     *  params are and the component that init is about to get called for
     */
    ComponentResolver.prototype.createAgGridComponent = function (holderOpt, agGridParams, propertyName, dynamicComponentParams, defaultComponentName, mandatory, customInitParamsCb) {
        if (mandatory === void 0) { mandatory = true; }
        var holder = holderOpt == null ? this.gridOptions : holderOpt;
        //Create the component instance
        var componentAndParams = this.newAgGridComponent(holder, propertyName, dynamicComponentParams, defaultComponentName, mandatory);
        if (!componentAndParams)
            return null;
        //Wire the component and call the init method with the correct params
        var finalParams = this.mergeParams(holder, propertyName, agGridParams, dynamicComponentParams, componentAndParams[1]);
        var deferredInit = this.initialiseComponent(componentAndParams[0], finalParams, customInitParamsCb);
        if (deferredInit == null) {
            return utils_1.Promise.resolve(componentAndParams[0]);
        }
        else {
            var asPromise = deferredInit;
            return asPromise.map(function (notRelevant) { return componentAndParams[0]; });
        }
    };
    /**
     * This method creates a component given everything needed to guess what sort of component needs to be instantiated
     * It takes
     *  @param clazz: The class to instantiate,
     *  @param agGridParams: Params to be passed to the component and passed by ag-Grid. This will get merged with any params
     *      specified by the user in the configuration
     *  @param customInitParamsCb: A chance to customise the params passed to the init method. It receives what the current
     *  params are and the component that init is about to get called for
     */
    ComponentResolver.prototype.createInternalAgGridComponent = function (clazz, agGridParams, customInitParamsCb) {
        var internalComponent = new clazz();
        this.initialiseComponent(internalComponent, agGridParams, customInitParamsCb);
        return internalComponent;
    };
    ComponentResolver.prototype.newAgGridComponent = function (holder, propertyName, dynamicComponentParams, defaultComponentName, mandatory) {
        if (mandatory === void 0) { mandatory = true; }
        var componentToUse = this.getComponentToUse(holder, propertyName, dynamicComponentParams, defaultComponentName);
        if (!componentToUse || !componentToUse.component) {
            if (mandatory) {
                console.error("Error creating component " + propertyName + "=>" + defaultComponentName);
            }
            return null;
        }
        if (componentToUse.type === ComponentType.AG_GRID) {
            return [
                new componentToUse.component(),
                componentToUse.dynamicParams
            ];
        }
        //Using framework component
        var FrameworkComponentRaw = componentToUse.component;
        var thisComponentConfig = this.componentMetadataProvider.retrieve(propertyName);
        return [
            this.frameworkComponentWrapper.wrap(FrameworkComponentRaw, thisComponentConfig.mandatoryMethodList, thisComponentConfig.optionalMethodList, defaultComponentName),
            componentToUse.dynamicParams
        ];
    };
    ComponentResolver.prototype.initialiseComponent = function (component, agGridParams, customInitParamsCb) {
        this.context.wireBean(component);
        if (customInitParamsCb == null) {
            return component.init(agGridParams);
        }
        else {
            return component.init(customInitParamsCb(agGridParams, component));
        }
    };
    __decorate([
        context_1.Autowired("gridOptions"),
        __metadata("design:type", Object)
    ], ComponentResolver.prototype, "gridOptions", void 0);
    __decorate([
        context_1.Autowired("gridOptionsWrapper"),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], ComponentResolver.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired("context"),
        __metadata("design:type", context_1.Context)
    ], ComponentResolver.prototype, "context", void 0);
    __decorate([
        context_1.Autowired("agComponentUtils"),
        __metadata("design:type", agComponentUtils_1.AgComponentUtils)
    ], ComponentResolver.prototype, "agComponentUtils", void 0);
    __decorate([
        context_1.Autowired("componentMetadataProvider"),
        __metadata("design:type", componentMetadataProvider_1.ComponentMetadataProvider)
    ], ComponentResolver.prototype, "componentMetadataProvider", void 0);
    __decorate([
        context_1.Autowired("componentProvider"),
        __metadata("design:type", componentProvider_1.ComponentProvider)
    ], ComponentResolver.prototype, "componentProvider", void 0);
    __decorate([
        context_1.Optional("frameworkComponentWrapper"),
        __metadata("design:type", Object)
    ], ComponentResolver.prototype, "frameworkComponentWrapper", void 0);
    ComponentResolver = __decorate([
        context_1.Bean('componentResolver')
    ], ComponentResolver);
    return ComponentResolver;
}());
exports.ComponentResolver = ComponentResolver;


/***/ }),

/***/ "mn2W":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1603);
	module.exports = __webpack_require__(1603);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1603:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function() {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    /* jshint eqnull:true */

	    var spreadsheet = kendo.spreadsheet;
	    var CellRef = spreadsheet.CellRef;
	    var RangeRef = spreadsheet.RangeRef;
	    var UnionRef = spreadsheet.UnionRef;
	    var NameRef = spreadsheet.NameRef;
	    var Ref = spreadsheet.Ref;

	    var FormulaContext = kendo.Class.extend({
	        init: function (workbook) {
	            this.workbook = workbook;
	        },

	        getRefCells: function(ref, hiddenInfo, fsheet, frow, fcol, wantNulls) {
	            var sheet, formula, value, i;
	            if (ref instanceof CellRef) {
	                sheet = this.workbook.sheetByName(ref.sheet);
	                if (!sheet || !ref.valid()) {
	                    return [{
	                        value: new kendo.spreadsheet.calc.runtime.CalcError("REF")
	                    }];
	                }
	                formula = sheet.formula(ref);
	                value = sheet.range(ref.row, ref.col).value();

	                if (wantNulls || formula != null || value != null) {
	                    return [{
	                        formula: formula,
	                        value: value,
	                        row: ref.row,
	                        col: ref.col,
	                        sheet: ref.sheet,
	                        hidden: hiddenInfo ? (sheet.columnWidth(ref.col) === 0 || sheet.rowHeight(ref.row) === 0) : false
	                    }];
	                } else {
	                    return [];
	                }
	            }
	            if (ref instanceof RangeRef) {
	                i = this.workbook.sheetIndex(ref.sheet);
	                var states = [], n = i;
	                if (ref.endSheet) {
	                    // "3D" reference.
	                    n = this.workbook.sheetIndex(ref.endSheet);
	                    if (i > n) {
	                        var tmp = i;
	                        i = n;
	                        n = tmp;
	                    }
	                }

	                if (i < 0 || n < 0 || !ref.valid()) {
	                    return [{
	                        value: new kendo.spreadsheet.calc.runtime.CalcError("REF")
	                    }];
	                }

	                // XXX: This is nicer, but significantly slower.
	                // Should investigate why, or add some options to make
	                // it faster (i.e. probably because it adds all cell
	                // properties, while we only need value and formula).
	                //
	                //     var add = function(row, col, data){
	                //         data.row = row;
	                //         data.col = col;
	                //         data.sheet = sheet.name();
	                //         states.push(data);
	                //     };
	                //     while (i <= n) {
	                //         sheet = this.workbook.sheetByIndex(i++);
	                //         sheet.forEach(ref, add);
	                //     }
	                //
	                // For now keep doing it "manually".

	                while (i <= n) {
	                    sheet = this.workbook.sheetByIndex(i++);
	                    var tl = sheet._grid.normalize(ref.topLeft);
	                    var br = sheet._grid.normalize(ref.bottomRight);

	                    var startCellIndex = sheet._grid.cellRefIndex(tl);
	                    var endCellIndex = sheet._grid.cellRefIndex(br);

	                    var values = sheet._properties.iterator("value", startCellIndex, endCellIndex);

	                    for (var col = tl.col; col <= br.col; ++col) {
	                        for (var row = tl.row; row <= br.row; ++row) {
	                            var index = sheet._grid.index(row, col);
	                            formula = sheet._properties.get("formula", index);
	                            value = values.at(index);
	                            if (wantNulls || formula != null || value != null) {
	                                states.push({
	                                    formula : formula,
	                                    value   : value,
	                                    row     : row,
	                                    col     : col,
	                                    sheet   : sheet.name(),
	                                    hidden  : hiddenInfo ? (sheet.columnWidth(col) === 0 || sheet.rowHeight(row) === 0) : false
	                                });
	                            }
	                        }
	                    }
	                }

	                return states;
	            }
	            if (ref instanceof UnionRef) {
	                var a = [];
	                for (i = 0; i < ref.refs.length; ++i) {
	                    a = a.concat(this.getRefCells(ref.refs[i], hiddenInfo, fsheet, frow, fcol));
	                }
	                return a;
	            }
	            if (ref instanceof NameRef) {
	                var val = this.nameValue(ref, fsheet, frow, fcol);
	                // XXX: revise this
	                if (val instanceof Ref) {
	                    return this.getRefCells(val, hiddenInfo, fsheet, frow, fcol);
	                }
	                return [{
	                    value: val == null ? new kendo.spreadsheet.calc.runtime.CalcError("NAME") : val
	                }];
	            }
	            return [];
	        },

	        nameValue: function(ref, fsheet, frow, fcol) {
	            var val;
	            if (ref.hasSheet()) {
	                // qualified name
	                val = this.workbook.nameValue(ref.print());
	            } else {
	                // try local name
	                ref = ref.clone().setSheet(fsheet, true);
	                val = this.workbook.nameValue(ref.print());
	                if (val == null) {
	                    // try global name
	                    val = this.workbook.nameValue(ref.name);
	                }
	            }
	            if (val instanceof Ref) {
	                val = val.absolute(frow, fcol);
	            }
	            return val;
	        },

	        getData: function(ref, fsheet, frow, fcol, wantNulls) {
	            var single = ref instanceof CellRef;
	            if (ref instanceof NameRef) {
	                single = this.workbook.nameValue(ref.name) instanceof CellRef;
	            }
	            var data = this.getRefCells(ref, false, fsheet, frow, fcol, wantNulls).map(function(cell){
	                var val = cell.value;
	                if (val instanceof kendo.spreadsheet.calc.runtime.Formula) {
	                    val = val.value;
	                }
	                return val;
	            });
	            return single ? data[0] : data;
	        },

	        onFormula: function(f) {
	            var sheet = this.workbook.sheetByName(f.sheet);
	            var row = f.row, col = f.col, value = f.value;
	            var currentFormula = sheet.formula({ row: row, col: col });
	            if (currentFormula !== f) {
	                // could have been deleted or modified in the mean time,
	                // if the formula was asynchronous.  ignore this result.
	                return false;
	            }

	            var arrayRange = f.arrayFormulaRange;
	            if (arrayRange) {
	                // `value` will always be a Matrix in this case;
	                // enforced in runtime.js (Context::_resolve).  We
	                // must fill only cells in arrayRange.
	                var tlRow, tlCol;
	                var width = value.width;
	                var height = value.height;
	                sheet.forEach(arrayRange, function(row, col){
	                    if (tlRow === undefined) {
	                        tlRow = row;
	                        tlCol = col;
	                    }
	                    var vrow = row - tlRow;
	                    var vcol = col - tlCol;
	                    var val;
	                    if (vrow < height && vcol < width) {
	                        val = value.get(vrow, vcol);
	                    } else {
	                        val = new kendo.spreadsheet.calc.runtime.CalcError("N/A");
	                    }
	                    sheet._value(row, col, val);
	                });
	            }
	            else {
	                // formulas may return references.  if a range or union,
	                // we'll just save the first cell.
	                if (value instanceof Ref) {
	                    value = this.getData(value, f.sheet, row, col);
	                    if (Array.isArray(value)) {
	                        value = value[0];
	                    }
	                    if (value === undefined) {
	                        value = null; // clear contents
	                    }
	                }

	                // when not saved as an array formula, a formula
	                // returning a Matrix will just save the first value.
	                if (value instanceof kendo.spreadsheet.calc.runtime.Matrix) {
	                    value = value.get(0, 0);
	                }

	                sheet._value(row, col, value);
	            }

	            clearTimeout(sheet._formulaContextRefresh);
	            sheet._formulaContextRefresh = setTimeout(function(){
	                sheet.batch(function(){}, { layout: true });
	            }, 50);

	            return true;
	        }
	    });

	    var ValidationFormulaContext = FormulaContext.extend({
	        onFormula: function() {
	            return true;
	        }
	    });

	    spreadsheet.FormulaContext = FormulaContext;
	    spreadsheet.ValidationFormulaContext = ValidationFormulaContext;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "msXi":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("77Pl");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "mtWM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("tIFN");

/***/ }),

/***/ "mvHQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("qkKv"), __esModule: true };

/***/ }),

/***/ "mxBz":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1228);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1228:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1229), __webpack_require__(1230) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "excel",
	    name: "Excel export",
	    category: "framework",
	    advanced: true,
	    mixin: true,
	    depends: [ "data", "ooxml" ]
	};

	}, __webpack_require__(3));


/***/ }),

/***/ 1229:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("oSV6");

/***/ }),

/***/ 1230:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LUKJ");

/***/ })

/******/ });

/***/ }),

/***/ "mypn":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "n0tP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var enterpriseMenu_1 = __webpack_require__("kQYo");
var rangeController_1 = __webpack_require__("PH8O");
var clipboardService_1 = __webpack_require__("/3L8");
var groupStage_1 = __webpack_require__("8Iik");
var aggregationStage_1 = __webpack_require__("uK4n");
var enterpriseBoot_1 = __webpack_require__("NGcw");
var statusBar_1 = __webpack_require__("zVEt");
var contextMenu_1 = __webpack_require__("u5iu");
var viewportRowModel_1 = __webpack_require__("f57H");
var pivotColumnsPanel_1 = __webpack_require__("dbIj");
var toolPanelComp_1 = __webpack_require__("Hehg");
var rowGroupCompFactory_1 = __webpack_require__("RU0j");
var licenseManager_1 = __webpack_require__("7uAN");
var md5_1 = __webpack_require__("MPcG");
var pivotStage_1 = __webpack_require__("aQ8F");
var pivotColDefService_1 = __webpack_require__("10Gu");
var aggFuncService_1 = __webpack_require__("R6MX");
var pivotCompFactory_1 = __webpack_require__("sVZL");
var menuItemMapper_1 = __webpack_require__("jsXh");
var excelCreator_1 = __webpack_require__("O8Rq");
var excelXmlFactory_1 = __webpack_require__("Bx8k");
var enterpriseRowModel_1 = __webpack_require__("spGI");
var rowModelTypes = { viewport: viewportRowModel_1.ViewportRowModel, enterprise: enterpriseRowModel_1.EnterpriseRowModel };
main_1.Grid.setEnterpriseBeans([toolPanelComp_1.ToolPanelComp, enterpriseMenu_1.EnterpriseMenuFactory, excelCreator_1.ExcelCreator, excelXmlFactory_1.ExcelXmlFactory, rowGroupCompFactory_1.RowGroupCompFactory, pivotCompFactory_1.PivotCompFactory,
    pivotColumnsPanel_1.PivotColumnsPanel, rangeController_1.RangeController, clipboardService_1.ClipboardService, pivotStage_1.PivotStage, pivotColDefService_1.PivotColDefService,
    contextMenu_1.ContextMenuFactory, groupStage_1.GroupStage, aggregationStage_1.AggregationStage, enterpriseBoot_1.EnterpriseBoot, aggFuncService_1.AggFuncService,
    statusBar_1.StatusBar, licenseManager_1.LicenseManager, md5_1.MD5, menuItemMapper_1.MenuItemMapper], rowModelTypes);


/***/ }),

/***/ "n1t0":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1258);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1258:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1059), __webpack_require__(1259)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "gantt.data",
	    name: "GanttData",
	    category: "web",
	    description: "The Gantt Data.",
	    depends: [ "data", "treelist" ],
	    hidden: true
	};

	(function($, undefined) {
	    var isArray = $.isArray,
	        extend = $.extend,
	        map = $.map,

	        kendoData = kendo.data,
	        Query = kendoData.Query,
	        DataSource = kendoData.DataSource,
	        TreeListDataSource = kendoData.TreeListDataSource,
	        TreeListModel = kendoData.TreeListModel,

	        PARENTIDFIELD = "parentId";

	    var createDataSource = function(type, name) {
	        return function(options) {
	            options = isArray(options) ? { data: options } : options;

	            var dataSource = options || {};
	            var data = dataSource.data;

	            dataSource.data = data;

	            if (!(dataSource instanceof type) && dataSource instanceof DataSource) {
	                throw new Error("Incorrect DataSource type. Only " + name + " instances are supported");
	            }

	            return dataSource instanceof type ? dataSource : new type(dataSource);
	        };
	    };

	    var dateCompareValidator = function(input) {
	        if (input.filter("[name=end], [name=start], [name=plannedEnd], [name=plannedStart]").length) {
	            var field = input.attr("name"),
	                picker = kendo.widgetInstance(input, kendo.ui),
	                dates = {},
	                container = input,
	                editable,
	                model;

	            while (container !== window && !editable) {
	                container = container.parent();

	                editable = container.data("kendoEditable");
	            }

	            model = editable ? editable.options.model : null;

	            if (!model) {
	                return true;
	            }

	            if(field.indexOf("planned") >= 0) {
	                dates.plannedStart = model.plannedStart;
	                dates.plannedEnd = model.plannedEnd;
	            } else {
	                dates.start = model.start;
	                dates.end = model.end;
	            }

	            dates[field] = picker ? picker.value() : kendo.parseDate(input.val());

	            if(field.indexOf("planned") >= 0) {
	                return dates.plannedStart <= dates.plannedEnd;
	            } else {
	                return dates.start <= dates.end;
	            }
	        }

	        return true;
	    };

	    var GanttDependency = kendo.data.Model.define({
	        id: "id",
	        fields: {
	            id: { type: "number", editable: false },
	            predecessorId: { type: "number" },
	            successorId: { type: "number" },
	            type: { type: "number" }
	        }
	    });

	    var GanttDependencyDataSource = DataSource.extend({
	        init: function(options) {
	            DataSource.fn.init.call(this, extend(true, {}, {
	                schema: {
	                    modelBase: GanttDependency,
	                    model: GanttDependency
	                }
	            }, options));
	        },

	        dependencies: function(id) {
	            var predecessors = this.predecessors(id),
	                successors = this.successors(id);

	            predecessors.push.apply(predecessors, successors);

	            return predecessors;
	        },

	        predecessors: function(id) {
	            return this._dependencies("successorId", id);
	        },

	        successors: function(id) {
	            return this._dependencies("predecessorId", id);
	        },

	        _dependencies: function(field, id) {
	            var data = this.view();
	            var filter = {
	                field: field,
	                operator: "eq",
	                value: id
	            };

	            data = new Query(data).filter(filter).toArray();

	            return data;
	        }
	    });

	    GanttDependencyDataSource.create = createDataSource(GanttDependencyDataSource, "GanttDependencyDataSource");

	    var GanttTask = TreeListModel.define({
	        fields: {
	            id: { type: "number", editable: false },
	            parentId: { type: "number", defaultValue: null, validation: { required: true }, nullable: true },
	            orderId: { type: "number", validation: { required: true } },
	            title: { type: "string", defaultValue: "New task" },
	            start: { type: "date", validation: { required: true } },
	            end: {
	                type: "date",
	                validation: {
	                    required: true,
	                    dateCompare: dateCompareValidator,
	                    message: "End date should be after or equal to the start date"
	                }
	            },
	            percentComplete: { type: "number", validation: { required: true, min:0, max: 1, step: 0.01 } },
	            summary: { type: "boolean" },
	            expanded: { type: "boolean", defaultValue: true },
	            plannedStart: { type: "date", defaultValue: null, nullable: true },
	            plannedEnd: {
	                type: "date",
	                defaultValue: null,
	                nullable: true,
	                validation: {
	                    dateCompare: dateCompareValidator,
	                    message: "Planned end date should be after or equal to the planned start date"
	                }
	            }
	        },

	        duration: function() {
	            var end = this.end,
	                start = this.start;

	            return end - start;
	        },

	        isMilestone: function() {
	            return this.duration() === 0;
	        },

	        _offset: function(value) {
	            var field = ["start", "end"],
	                newValue;

	            for (var i = 0; i < field.length; i++) {
	                newValue = new Date(this.get(field[i]).getTime() + value);
	                this.set(field[i], newValue);
	            }
	        },

	        _offsetPlanned: function(value) {
	            var field = ["plannedStart", "plannedEnd"],
	                newValue;

	            for (var i = 0; i < field.length; i++) {
	                newValue = new Date(this.get(field[i]).getTime() + value);
	                this.set(field[i], newValue);
	            }
	        }
	    });

	    GanttTask.define = function(base, options) {
	        if (options === undefined) {
	            options = base;
	            base = GanttTask;
	        }

	        var parentId = options.parentId || PARENTIDFIELD;

	        options.parentIdField = parentId;

	        var model = TreeListModel.define(base, options);

	        if (parentId) {
	            model.parentIdField = parentId;
	        }

	        return model;
	    };

	    var GanttDataSource = TreeListDataSource.extend({
	        init: function(options) {
	            TreeListDataSource.fn.init.call(this, extend(true, {}, {
	                schema: {
	                    modelBase: GanttTask,
	                    model: GanttTask
	                },
	                sort: { field: "orderId", dir: "asc" }
	            }, options));
	        },

	        add: function(task) {
	            if (!task) {
	                return;
	            }

	            task = this._toGanttTask(task);

	            return this.insert(this.taskSiblings(task).length, task);
	        },

	        insert: function(index, task) {
	            if (!task) {
	                return;
	            }

	            task = this._toGanttTask(task);

	            task.set("orderId", index);

	            task = DataSource.fn.insert.call(this, index, task);

	            this._reorderSiblings(task, this.taskSiblings(task).length - 1);
	            this._resolveSummaryFields(this.taskParent(task));

	            return task;
	        },

	        remove: function(task) {
	            var parentId = task.get("parentId"),
	                children = this.taskAllChildren(task);

	            this._removeItems(children);

	            task = TreeListDataSource.fn.remove.call(this, task);

	            this._childRemoved(parentId, task.get("orderId"));

	            return task;
	        },

	        taskAllChildren: function(task) {
	            var data = [],
	                that = this;
	            var callback = function(task) {
	                var tasks = that.taskChildren(task);

	                data.push.apply(data, tasks);
	                map(tasks, callback);
	            };

	            if (!!task) {
	                callback(task);
	            } else {
	                data = this.view();
	            }

	            return data;
	        },

	        taskChildren: function(task) {
	            // has been changed, so it gets all data from .view() to .data()
	            var data = this.view();
	            var filter = {
	                field: "parentId",
	                operator: "eq",
	                value: null
	            };

	            var order = (this._sort && this._sort.length) ? this._sort : {
	                field: "orderId",
	                dir: "asc"
	            };
	            var taskId;

	            if (!!task) {
	                taskId = task.get("id");

	                if (taskId === undefined || taskId === null || taskId === "") {
	                    return [];
	                }

	                filter.value = taskId;
	            }

	            data = new Query(data).filter(filter).sort(order).toArray();

	            return data;
	        },

	        taskLevel: function(task) {
	            var level = 0,
	                parent = this.taskParent(task);

	            while (parent !== null) {
	                level += 1;
	                parent = this.taskParent(parent);
	            }

	            return level;
	        },

	        taskParent: function(task) {
	            if (!task || task.get("parentId") === null) {
	                return null;
	            }
	            return this.get(task.parentId);
	        },

	        taskSiblings: function(task) {
	            if (!task) {
	                return null;
	            }

	            var parent = this.taskParent(task);

	            return this.taskChildren(parent);
	        },

	        taskTree: function(task) {
	            var data = [],
	                current,
	                tasks = this.taskChildren(task);

	            for (var i = 0, l = tasks.length; i < l; i++) {
	                current = tasks[i];
	                data.push(current);

	                if (current.get("expanded")) {
	                    var children = this.taskTree(current);

	                    data.push.apply(data, children);
	                }
	            }

	            return data;
	        },

	        update: function(task, taskInfo) {
	            var that = this,
	                oldValue;

	            var offsetChildren = function(parentTask, offset) {
	                var children = that.taskAllChildren(parentTask);

	                for (var i = 0, l = children.length; i < l; i++) {
	                    children[i]._offset(offset);
	                }
	            };

	            var offsetChildrenPlanned = function(parentTask, offset) {
	                var children = that.taskAllChildren(parentTask);

	                for (var i = 0, l = children.length; i < l; i++) {
	                    children[i]._offsetPlanned(offset);
	                }
	            };

	            var modelChangeHandler = function(e) {
	                var field = e.field,
	                    model = e.sender;

	                switch (field) {
	                    case "start":
	                        that._resolveSummaryStart(that.taskParent(model));

	                        offsetChildren(model, model.get(field).getTime() - oldValue.getTime());
	                        break;
	                    case "end":
	                        that._resolveSummaryEnd(that.taskParent(model));
	                        break;
	                    case "plannedStart":
	                        that._resolveSummaryPlannedStart(that.taskParent(model));

	                        if(model.get(field) && oldValue) {
	                            offsetChildrenPlanned(model, model.get(field).getTime() - oldValue.getTime());
	                        }
	                        break;
	                    case "plannedEnd":
	                        that._resolveSummaryPlannedEnd(that.taskParent(model));
	                        break;
	                    case "percentComplete":
	                        that._resolveSummaryPercentComplete(that.taskParent(model));
	                        break;
	                    case "orderId":
	                        that._reorderSiblings(model, oldValue);
	                        break;
	                }
	            };

	            if (taskInfo.parentId !== undefined) {
	                oldValue = task.get("parentId");

	                if (oldValue !== taskInfo.parentId) {
	                    task.set("parentId", taskInfo.parentId);

	                    that._childRemoved(oldValue, task.get("orderId"));

	                    task.set("orderId", that.taskSiblings(task).length - 1);
	                    that._resolveSummaryFields(that.taskParent(task));
	                }

	                delete taskInfo.parentId;
	            }

	            task.bind("change", modelChangeHandler);

	            for (var field in taskInfo) {
	                oldValue = task.get(field);

	                if(field === "plannedStart" || field === "plannedEnd") {
	                    // Update plannedStart and plannedEnd only when oldValue is not undefined or new value is not null
	                    // That limitation is needed to avoid redundant update requests when custom edit template is used
	                    // and the plannedStart and plannedEnd fields are not updated upon edit
	                    if(oldValue !== undefined || taskInfo[field] !== null) {
	                        task.set(field, taskInfo[field]);
	                    }
	                } else {
	                    task.set(field, taskInfo[field]);
	                }
	            }

	            task.unbind("change", modelChangeHandler);
	        },

	        _childRemoved: function(parentId, index) {
	            var parent = parentId === null ? null : this.get(parentId),
	                children = this.taskChildren(parent);

	            for (var i = index, l = children.length; i < l; i++) {
	                children[i].set("orderId", i);
	            }

	            this._resolveSummaryFields(parent);
	        },

	        _resolveSummaryFields: function(summary) {
	            if (!summary) {
	                return;
	            }

	            this._updateSummary(summary);

	            if (!this.taskChildren(summary).length) {
	                return;
	            }

	            this._resolveSummaryStart(summary);
	            this._resolveSummaryEnd(summary);
	            this._resolveSummaryPlannedStart(summary);
	            this._resolveSummaryPlannedEnd(summary);
	            this._resolveSummaryPercentComplete(summary);
	        },

	        _resolveSummaryStart: function(summary) {
	            var that = this;
	            var getSummaryStart = function(parentTask) {
	                var children = that.taskChildren(parentTask);
	                var min = children[0].start.getTime();
	                var currentMin;

	                for (var i = 1, l = children.length; i < l; i++) {
	                    currentMin = children[i].start.getTime();
	                    if (currentMin < min) {
	                        min = currentMin;
	                    }
	                }

	                return new Date(min);
	            };

	            this._updateSummaryRecursive(summary, "start", getSummaryStart);
	        },

	        _resolveSummaryEnd: function(summary) {
	            var that = this;
	            var getSummaryEnd = function(parentTask) {
	                var children = that.taskChildren(parentTask);
	                var max = children[0].end.getTime();
	                var currentMax;

	                for (var i = 1, l = children.length; i < l; i++) {
	                    currentMax = children[i].end.getTime();
	                    if (currentMax > max) {
	                        max = currentMax;
	                    }
	                }

	                return new Date(max);
	            };

	            this._updateSummaryRecursive(summary, "end", getSummaryEnd);
	        },

	        _resolveSummaryPlannedStart: function(summary) {
	            var that = this;
	            var getSummaryPlannedStart = function(parentTask) {
	                var children = that.taskChildren(parentTask),
	                    min = null,
	                    currentMin;

	                for (var i = 0, l = children.length; i < l; i++) {
	                    if(children[i].plannedStart) {
	                        currentMin = children[i].plannedStart.getTime();
	                        if (!min || currentMin < min) {
	                            min = currentMin;
	                        }
	                    }
	                }

	                if(!min) {
	                    return null;
	                }

	                return new Date(min);
	            };

	            this._updateSummaryRecursive(summary, "plannedStart", getSummaryPlannedStart);
	        },

	        _resolveSummaryPlannedEnd: function(summary) {
	            var that = this;
	            var getSummaryPlannedEnd = function(parentTask) {
	                var children = that.taskChildren(parentTask),
	                    max = null,
	                    currentMax;

	                for (var i = 0, l = children.length; i < l; i++) {
	                    if(children[i].plannedEnd) {
	                        currentMax = children[i].plannedEnd.getTime();
	                        if (!max || currentMax > max) {
	                            max = currentMax;
	                        }
	                    }
	                }

	                if(!max) {
	                    return null;
	                }

	                return new Date(max);
	            };

	            this._updateSummaryRecursive(summary, "plannedEnd", getSummaryPlannedEnd);
	        },

	        _resolveSummaryPercentComplete: function(summary) {
	            var that = this;
	            var getSummaryPercentComplete = function(parentTask) {
	                var children = that.taskChildren(parentTask);
	                var percentComplete = new Query(children).aggregate([{
	                    field: "percentComplete",
	                    aggregate: "average"
	                }]);

	                return percentComplete.percentComplete.average;
	            };

	            this._updateSummaryRecursive(summary, "percentComplete", getSummaryPercentComplete);
	        },

	        _reorderSiblings: function(task, oldOrderId) {
	            var orderId = task.get("orderId"),
	                direction = orderId > oldOrderId,
	                startIndex = direction ? oldOrderId : orderId,
	                endIndex = direction ? orderId : oldOrderId,
	                newIndex = direction ? startIndex : startIndex + 1,
	                siblings = this.taskSiblings(task);

	            if(!siblings.length){
	                return;
	            }

	            endIndex = Math.min(endIndex, siblings.length - 1);

	            for (var i = startIndex; i <= endIndex; i++) {
	                if (siblings[i] === task) {
	                    continue;
	                }

	                siblings[i].set("orderId", newIndex);

	                newIndex += 1;
	            }
	        },

	        _toGanttTask: function(task) {
	            if (!(task instanceof GanttTask)) {
	                var taskInfo = task;

	                task = DataSource.fn._createNewModel.call(this);
	                task.accept(taskInfo);
	            }

	            return task;
	        },

	        _updateSummary: function(task) {
	            if (task !== null) {
	                var childCount = this.taskChildren(task).length;

	                task.set("summary", childCount > 0);
	            }
	        },

	        _updateSummaryRecursive: function(summary, field, callback) {
	            if (!summary) {
	                return;
	            }

	            var value = callback(summary);

	            summary.set(field, value);

	            var parent = this.taskParent(summary);

	            if (parent) {
	                this._updateSummaryRecursive(parent, field, callback);
	            }
	        }
	    });

	    GanttDataSource.create = createDataSource(GanttDataSource, "GanttDataSource");

	    extend(true, kendo.data, {
	        GanttDataSource: GanttDataSource,
	        GanttTask: GanttTask,
	        GanttDependencyDataSource: GanttDependencyDataSource,
	        GanttDependency: GanttDependency
	    });
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1259:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("UtsZ");

/***/ })

/******/ });

/***/ }),

/***/ "nAZz":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1338);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1338:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1059) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "pager",
	    name: "Pager",
	    category: "framework",
	    depends: [ "data" ],
	    advanced: true
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        proxy = $.proxy,
	        FIRST = ".k-i-arrow-end-left",
	        LAST = ".k-i-arrow-end-right",
	        PREV = ".k-i-arrow-60-left",
	        NEXT = ".k-i-arrow-60-right",
	        SIZE = "k-pager-md k-pager-sm",
	        CHANGE = "change",
	        NS = ".kendoPager",
	        CLICK = "click",
	        KEYDOWN = "keydown",
	        DISABLED = "disabled",
	        MOUSEDOWN = "down",
	        MAX_VALUE = Number.MAX_VALUE,
	        iconTemplate = kendo.template('<a href="\\#" aria-label="#=text#" title="#=text#" class="k-link k-pager-nav #= wrapClassName #"><span class="k-icon #= className #"></span></a>');

	    function button(template, idx, text, numeric, title) {
	        return template( {
	            idx: idx,
	            text: text,
	            ns: kendo.ns,
	            numeric: numeric,
	            title: title || ""
	        });
	    }

	    function selectOption(template, idx, text, selected) {
	        return template( {
	            idx: idx,
	            text: text || idx,
	            selected: selected || false
	        });
	    }

	    function icon(className, text, wrapClassName) {
	        return iconTemplate({
	            className: className.substring(1),
	            text: text,
	            wrapClassName: wrapClassName || ""
	        });
	    }

	    function update(element, selector, page, disabled) {
	       element.find(selector)
	              .parent()
	              .attr(kendo.attr("page"), page)
	              .attr("tabindex", -1)
	              .toggleClass("k-state-disabled", disabled);
	    }

	    function first(element, page) {
	        update(element, FIRST, 1, page <= 1);
	    }

	    function prev(element, page) {
	        update(element, PREV, Math.max(1, page - 1), page <= 1);
	    }

	    function next(element, page, totalPages) {
	        update(element, NEXT, Math.min(totalPages, page + 1), page >= totalPages);
	    }

	    function last(element, page, totalPages) {
	        update(element, LAST, totalPages, page >= totalPages);
	    }

	    var Pager = Widget.extend( {
	        init: function(element, options) {
	            var that = this, page, totalPages;
	            var sizeClassName = null;

	            Widget.fn.init.call(that, element, options);

	            options = that.options;
	            that._createDataSource(options);
	            that.linkTemplate = kendo.template(that.options.linkTemplate);
	            that.selectTemplate = kendo.template(that.options.selectTemplate);
	            that.currentPageTemplate = kendo.template(that.options.currentPageTemplate);
	            that.numericSelectItemTemplate = kendo.template(that.options.numericSelectItemTemplate);

	            page = that.page();
	            totalPages = that.totalPages();

	            that._refreshHandler = proxy(that.refresh, that);

	            that.dataSource.bind(CHANGE, that._refreshHandler);
	            that.downEvent = kendo.applyEventMap(MOUSEDOWN, kendo.guid());

	            if (options.previousNext) {
	                if (!that.element.find(FIRST).length) {
	                    that.element.append(icon(FIRST, options.messages.first, "k-pager-first"));

	                    first(that.element, page, totalPages);
	                }

	                if (!that.element.find(PREV).length) {
	                    that.element.append(icon(PREV, options.messages.previous));

	                    prev(that.element, page, totalPages);
	                }
	            }

	            if (options.numeric) {
	                if (!that._numericWrap) {
	                    that._numericWrap = that.element.find(".k-pager-numbers-wrap");

	                    if (that._numericWrap.length === 0) {
	                        that._numericWrap = $("<div class='k-pager-numbers-wrap' />").appendTo(that.element);
	                    }
	                }

	                if (!that._numericSelect) {
	                    that._numericSelect = that._numericWrap.find(".k-dropdown");

	                    if (that._numericSelect.length === 0) {
	                       that._numericSelect = $("<select class='k-dropdown' />").appendTo(that._numericWrap);
	                    }
	                }

	                if (!that.list) {
	                    that.list = that._numericWrap.find(".k-pager-numbers");

	                    if (that.list.length === 0) {
	                       that.list = $('<ul class="k-pager-numbers" />').appendTo(that._numericWrap);
	                    }
	                }

	                if (options.dataSource && !options.dataSource.total()) {
	                    that._numericSelect.empty().append("<option value='0' />");
	                    that.list.empty().append(that.selectTemplate({ text: 0 }));
	                }
	            }

	            if (options.input) {
	                if (!that.element.find(".k-pager-input").length) {
	                   that.element.append('<span class="k-pager-input k-label">'+
	                       options.messages.page +
	                       '<input class="k-textbox">' +
	                       kendo.format(options.messages.of, totalPages) +
	                       '</span>');
	                }

	                that.element.on(KEYDOWN + NS, ".k-pager-input input", proxy(that._keydown, that));
	            }

	            if (options.previousNext) {
	                if (!that.element.find(NEXT).length) {
	                    that.element.append(icon(NEXT, options.messages.next));

	                    next(that.element, page, totalPages);
	                }

	                if (!that.element.find(LAST).length) {
	                    that.element.append(icon(LAST, options.messages.last, "k-pager-last"));

	                    last(that.element, page, totalPages);
	                }
	            }

	            if (options.pageSizes){
	                if (!that.element.find(".k-pager-sizes").length){
	                    var pageSizes = options.pageSizes.length ? options.pageSizes : ["all", 5, 10, 20];
	                    var pageItems = $.map(pageSizes, function(size) {
	                        if (size.toLowerCase && size.toLowerCase() === "all") {
	                            return "<option value='all'>" + options.messages.allPages + "</option>";
	                        }

	                        return "<option>" + size + "</option>";
	                    });

	                    $('<span class="k-pager-sizes k-label"><select></select>' + options.messages.itemsPerPage + "</span>")
	                        .appendTo(that.element)
	                        .find("select").html(pageItems.join("")).end()
	                        .appendTo(that.element);
	                }

	                that.element.find(".k-pager-sizes select").val(that.pageSize());

	                if (kendo.ui.DropDownList) {
	                   that.element.find(".k-pager-sizes select").show().kendoDropDownList();
	                }

	                that.element.on(CHANGE + NS, ".k-pager-sizes select", proxy(that._change, that));
	            }

	            if (options.refresh) {
	                if (!that.element.find(".k-pager-refresh").length) {
	                    that.element.append('<a href="#" class="k-pager-refresh k-link" title="' + options.messages.refresh +
	                        '" aria-label="' + options.messages.refresh + '"><span class="k-icon k-i-reload"></span></a>');
	                }

	                that.element.on(CLICK + NS, ".k-pager-refresh", proxy(that._refreshClick, that));
	            }

	            if (options.info) {
	                if (!that.element.find(".k-pager-info").length) {
	                    that.element.append('<span class="k-pager-info k-label" />');
	                }
	            }

	            that.element
	                .on(CLICK + NS , "a", proxy(that._click, that))
	                .on(CHANGE + NS , "select.k-dropdown", proxy(that._numericSelectChange, that))
	                .addClass("k-pager-wrap k-widget k-floatwrap");

	            if (options.autoBind) {
	                that.refresh();
	            }

	            that._resizeHandler = proxy(that.resize, that, true);
	            $(window).on("resize" + NS, that._resizeHandler);

	            sizeClassName = that._getWidthSizeClass(that.element.outerWidth());

	            if (sizeClassName) {
	                that.element.addClass(sizeClassName);
	            }

	            kendo.notify(that);
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            that.element.off(NS);
	            that.dataSource.unbind(CHANGE, that._refreshHandler);
	            that._refreshHandler = null;
	            $(window).off("resize" + NS, this._resizeHandler);

	            kendo.destroy(that.element);
	            that.element = that.list = null;
	        },

	        events: [
	            CHANGE
	        ],

	        options: {
	            name: "Pager",
	            selectTemplate: '<li><span class="k-link k-state-selected">#=text#</span></li>',
	            currentPageTemplate: '<li class="k-current-page"><span class="k-link k-pager-nav">#=text#</span></li>',
	            linkTemplate: '<li><a tabindex="-1" href="\\#" class="k-link" data-#=ns#page="#=idx#" #if (title !== "") {# title="#=title#" #}#>#=text#</a></li>',
	            numericItemTemplate: '<li><a tabindex="-1" href="\\#" class="k-link" data-#=ns#page="#=idx#" #if (title !== "") {# title="#=title#" #}#>#=text#</a></li>',
	            numericSelectItemTemplate: '<option value="#= idx #" #if (selected) {# selected="selected" #}#>#= text #</option>',
	            buttonCount: 10,
	            autoBind: true,
	            numeric: true,
	            info: true,
	            input: false,
	            previousNext: true,
	            pageSizes: false,
	            refresh: false,
	            responsive: true,
	            messages: {
	                allPages: "All",
	                display: "{0} - {1} of {2} items",
	                empty: "No items to display",
	                page: "Page",
	                of: "of {0}",
	                itemsPerPage: "items per page",
	                first: "Go to the first page",
	                previous: "Go to the previous page",
	                next: "Go to the next page",
	                last: "Go to the last page",
	                refresh: "Refresh",
	                morePages: "More pages"
	            }
	        },

	        setDataSource: function(dataSource) {
	            var that = this;

	            that.dataSource.unbind(CHANGE, that._refreshHandler);
	            that.dataSource = that.options.dataSource = dataSource;
	            dataSource.bind(CHANGE, that._refreshHandler);

	            if (that.options.autoBind) {
	                dataSource.fetch();
	            }
	        },

	        _resize: function(size) {
	            if (size.width) {
	                var sizeClassName = this._getWidthSizeClass(size.width);
	                var el = this.element;

	                if (!sizeClassName) {
	                    el.removeClass(SIZE);
	                } else if (!el.hasClass(sizeClassName)) {
	                    el.removeClass(SIZE);
	                    el.addClass(sizeClassName);
	                }
	            }
	        },

	        _createDataSource: function(options) {
	            this.dataSource = kendo.data.DataSource.create(options.dataSource);
	        },

	        refresh: function(e) {
	            var that = this,
	                idx,
	                end,
	                start = 1,
	                reminder,
	                page = that.page(),
	                html = "",
	                selectHtml = "",
	                options = that.options,
	                pageSize = that.pageSize(),
	                collapsedTotal = that._collapsedTotal(),
	                total = that.dataSource._isGroupPaged() ? that.dataSource.groupsTotal(true) : that.dataSource.total(),
	                totalPages = that.totalPages(),
	                linkTemplate = that.linkTemplate,
	                numericSelectItemTemplate = that.numericSelectItemTemplate,
	                buttonCount = options.buttonCount;

	            if (e && e.action == "itemchange") {
	                return;
	            }

	            if (options.numeric) {

	                if (page > buttonCount) {
	                    reminder = (page % buttonCount);
	                    start = (reminder === 0) ? (page - buttonCount) + 1 : (page - reminder) + 1;
	                }

	                end = Math.min((start + buttonCount) - 1, totalPages);

	                if (start > 1) {
	                    html += button(linkTemplate, start - 1, "...", false, options.messages.morePages);
	                    selectHtml += selectOption(numericSelectItemTemplate, start - 1, options.messages.morePages);
	                }

	                for (idx = start; idx <= end; idx++) {
	                    html += button(idx == page ? that.selectTemplate : linkTemplate, idx, idx, true);
	                    selectHtml += selectOption(numericSelectItemTemplate, idx, idx, idx == page);
	                }

	                if (end < totalPages) {
	                    html += button(linkTemplate, idx, "...", false, options.messages.morePages);
	                    selectHtml += selectOption(numericSelectItemTemplate, idx, options.messages.morePages);
	                }

	                if (html === "") {
	                    html = that.selectTemplate({ text: 0 });
	                    selectHtml = $("<option value='0' />");
	                }

	                that.list.html(html);
	                that._numericSelect.html(selectHtml);
	            }

	            if (options.info) {
	                if (total > 0) {
	                    html = kendo.format(options.messages.display,
	                        that.dataSource.options.endless ? 1 : Math.min((page - 1) * (that.dataSource.pageSize() || 0) + 1, collapsedTotal), // first item in the page
	                        Math.min(page * pageSize, collapsedTotal), // last item in the page
	                    total);
	                } else {
	                    html = options.messages.empty;
	                }

	                that.element.find(".k-pager-info").html(html);
	            }

	            if (options.input) {
	                that.element
	                    .find(".k-pager-input")
	                    .html(that.options.messages.page +
	                        '<input class="k-textbox" aria-label="' + page + '">' +
	                        kendo.format(options.messages.of, totalPages))
	                    .find("input")
	                    .val(page)
	                    .attr(DISABLED, total < 1)
	                    .toggleClass("k-state-disabled", total < 1);
	            }

	            if (options.previousNext) {
	                first(that.element, page, totalPages);

	                prev(that.element, page, totalPages);

	                next(that.element, page, totalPages);

	                last(that.element, page, totalPages);
	            }

	            if (options.pageSizes) {
	                var hasAll = that.element.find(".k-pager-sizes option[value='all']").length > 0;
	                var selectAll = hasAll && (pageSize === this.dataSource.total() || pageSize == MAX_VALUE);
	                var text = pageSize;
	                if (selectAll) {
	                    pageSize = "all";
	                    text = options.messages.allPages;
	                }

	                that.element
	                    .find(".k-pager-sizes select")
	                    .val(pageSize)
	                    .attr("aria-label", pageSize)
	                    .filter("[" + kendo.attr("role") + "=dropdownlist]")
	                    .kendoDropDownList("value", pageSize)
	                    .kendoDropDownList("text", text); // handles custom values
	            }
	        },

	        _collapsedTotal: function() {
	            return this.dataSource.total();
	        },

	        _keydown: function(e) {
	            if (e.keyCode === kendo.keys.ENTER) {
	                var input = this.element.find(".k-pager-input").find("input"),
	                    page = parseInt(input.val(), 10);

	                if (isNaN(page) || page < 1 || page > this.totalPages()) {
	                    page = this.page();
	                }

	                input.val(page);

	                this.page(page);
	            }
	        },

	        _refreshClick: function(e) {
	            e.preventDefault();

	            this.dataSource.read();
	        },

	        _change: function(e) {
	            var value = e.currentTarget.value;
	            var pageSize = parseInt(value, 10);
	            var dataSource = this.dataSource;

	            if (!isNaN(pageSize)){
	                dataSource.pageSize(pageSize);
	            } else if ((value + "").toLowerCase() == "all") {
	                dataSource._pageSize = undefined;
	                dataSource._take = undefined;
	                dataSource._skip = 0;
	                dataSource.fetch();
	            }
	        },

	        _numericSelectChange: function(e) {
	            var target = e.currentTarget;
	            var value = target.value;
	            var page = parseInt(value, 10);

	            target.blur();

	            this.page(page);
	        },

	        _click: function(e) {
	            var target = $(e.currentTarget);

	            e.preventDefault();

	            if (!target.is(".k-state-disabled")) {
	                this.page(parseInt(target.attr(kendo.attr("page")), 10));
	            }
	        },

	        totalPages: function() {
	            return Math.ceil((this.dataSource.total() || 0) / (this.pageSize() || 1));
	        },

	        pageSize: function() {
	            return this.dataSource.pageSize() || this.dataSource.total();
	        },

	        page: function(page) {
	            if (page) {
	                if (this.trigger("pageChange", { index: page })) {
	                   return;
	                }

	                this.dataSource.page(page);

	                this.trigger(CHANGE, { index: page });
	            } else {
	                if (this.dataSource.total() > 0) {
	                    return this.dataSource.page();
	                } else {
	                    return 0;
	                }
	            }
	        },

	        _getWidthSizeClass: function(width) {
	            var that = this,
	                sizes = SIZE.split(" ");

	            if (!that.options.responsive) {
	                return null;
	            } else if (width <= 480) {
	                return sizes[1];
	            } else if (width <= 600) {
	                return sizes[0];
	            }
	            return null;
	        }
	    });

	    ui.plugin(Pager);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "nK46":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1159);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1110:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nzx/");

/***/ }),

/***/ 1159:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1110),
	        __webpack_require__(1160),
	        __webpack_require__(1161),
	        __webpack_require__(1162)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "dataviz.themes",
	    name: "Themes",
	    description: "Built-in themes for the DataViz widgets",
	    category: "dataviz",
	    depends: [ "dataviz.core" ],
	    hidden: true
	};

	}, __webpack_require__(3));


/***/ }),

/***/ 1160:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("vkLX");

/***/ }),

/***/ 1161:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("BMMp");

/***/ }),

/***/ 1162:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LGr7");

/***/ })

/******/ });

/***/ }),

/***/ "nOyd":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1153);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1153:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1154), __webpack_require__(1155) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "dataviz.sparkline",
	    name: "Sparkline",
	    category: "dataviz",
	    description: "Sparkline widgets.",
	    depends: [ "dataviz.chart" ]
	};

	}, __webpack_require__(3));


/***/ }),

/***/ 1154:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("EBqR");

/***/ }),

/***/ 1155:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("WX3+");

/***/ })

/******/ });

/***/ }),

/***/ "nTqx":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1325);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Dz7c");

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1325:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1104), __webpack_require__(1059), __webpack_require__(1109) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.scrollview",
	    name: "ScrollView",
	    category: "mobile",
	    description: "The Kendo Mobile ScrollView widget is used to scroll content wider than the device screen.",
	    depends: [ "fx", "data", "draganddrop" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        mobile = kendo.mobile,
	        ui = mobile.ui,
	        proxy = $.proxy,
	        Transition = kendo.effects.Transition,
	        Pane = kendo.ui.Pane,
	        PaneDimensions = kendo.ui.PaneDimensions,
	        Widget = ui.DataBoundWidget,
	        DataSource = kendo.data.DataSource,
	        Buffer = kendo.data.Buffer,
	        BatchBuffer = kendo.data.BatchBuffer,

	        // Math
	        math = Math,
	        abs  = math.abs,
	        ceil = math.ceil,
	        round = math.round,
	        max = math.max,
	        min = math.min,
	        floor = math.floor,

	        CHANGE = "change",
	        CHANGING = "changing",
	        REFRESH = "refresh",
	        CURRENT_PAGE_CLASS = "current-page",
	        VIRTUAL_PAGE_CLASS = "virtual-page",
	        FUNCTION = "function",
	        ITEM_CHANGE = "itemChange",
	        CLEANUP = "cleanup",

	        VIRTUAL_PAGE_COUNT = 3,
	        LEFT_PAGE = -1,
	        CETER_PAGE = 0,
	        RIGHT_PAGE = 1,

	        LEFT_SWIPE = -1,
	        NUDGE = 0,
	        RIGHT_SWIPE = 1;

	    function className(name) {
	        return "k-" + name + " km-" + name;
	    }

	    var Pager = kendo.Class.extend({
	        init: function(scrollView) {
	            var that = this,
	                element = $("<ol class='" + className("pages") + "'/>");

	            scrollView.element.append(element);

	            this._changeProxy = proxy(that, "_change");
	            this._refreshProxy = proxy(that, "_refresh");
	            scrollView.bind(CHANGE, this._changeProxy);
	            scrollView.bind(REFRESH, this._refreshProxy);

	            $.extend(that, { element: element, scrollView: scrollView });
	        },

	        items: function() {
	            return this.element.children();
	        },

	        _refresh: function(e) {
	            var pageHTML = "";

	            for (var idx = 0; idx < e.pageCount; idx ++) {
	                pageHTML += "<li></li>";
	            }

	            this.element.html(pageHTML);
	            this.items().eq(e.page).addClass(className(CURRENT_PAGE_CLASS));
	        },

	        _change: function(e) {
	            this.items()
	                .removeClass(className(CURRENT_PAGE_CLASS))
	                .eq(e.page).addClass(className(CURRENT_PAGE_CLASS));
	        },

	        destroy: function() {
	            this.scrollView.unbind(CHANGE, this._changeProxy);
	            this.scrollView.unbind(REFRESH, this._refreshProxy);
	            this.element.remove();
	        }
	    });

	    kendo.mobile.ui.ScrollViewPager = Pager;

	    var TRANSITION_END = "transitionEnd",
	        DRAG_START = "dragStart",
	        DRAG_END = "dragEnd";

	    var ElasticPane = kendo.Observable.extend({
	        init: function(element, options) {
	            var that = this;

	            kendo.Observable.fn.init.call(this);

	            this.element = element;
	            this.container = element.parent();

	            var movable,
	                transition,
	                userEvents,
	                dimensions,
	                dimension,
	                pane;

	            movable = new kendo.ui.Movable(that.element);

	            transition = new Transition({
	                axis: "x",
	                movable: movable,
	                onEnd: function() {
	                    that.trigger(TRANSITION_END);
	                }
	            });

	            userEvents = new kendo.UserEvents(element, {
	                fastTap: true,
	                start: function(e) {
	                    if (abs(e.x.velocity) * 2 >= abs(e.y.velocity)) {
	                        userEvents.capture();
	                    } else {
	                        userEvents.cancel();
	                    }

	                    that.trigger(DRAG_START, e);
	                    transition.cancel();
	                },
	                allowSelection: true,
	                end: function(e) {
	                    that.trigger(DRAG_END, e);
	                }
	            });

	            dimensions = new PaneDimensions({
	                element: that.element,
	                container: that.container
	            });

	            dimension = dimensions.x;

	            dimension.bind(CHANGE, function() {
	                that.trigger(CHANGE);
	            });

	            pane = new Pane({
	                dimensions: dimensions,
	                userEvents: userEvents,
	                movable: movable,
	                elastic: true
	            });

	            $.extend(that, {
	                duration: options && options.duration || 1,
	                movable: movable,
	                transition: transition,
	                userEvents: userEvents,
	                dimensions: dimensions,
	                dimension: dimension,
	                pane: pane
	            });

	            this.bind([TRANSITION_END, DRAG_START, DRAG_END, CHANGE], options);
	        },

	        size: function() {
	            return { width: this.dimensions.x.getSize(), height: this.dimensions.y.getSize() };
	        },

	        total: function() {
	            return this.dimension.getTotal();
	        },

	        offset: function() {
	            return -this.movable.x;
	        },

	        updateDimension: function() {
	            this.dimension.update(true);
	        },

	        refresh: function() {
	            this.dimensions.refresh();
	        },

	        moveTo: function(offset) {
	            this.movable.moveAxis("x", -offset);
	        },

	        transitionTo: function(offset, ease, instant) {
	            if (instant) {
	                this.moveTo(-offset);
	            } else {
	                this.transition.moveTo({ location: offset, duration: this.duration, ease: ease });
	            }
	        }
	    });

	    kendo.mobile.ui.ScrollViewElasticPane = ElasticPane;

	    var ScrollViewContent = kendo.Observable.extend({
	        init: function(element, pane, options) {
	            var that = this;

	            kendo.Observable.fn.init.call(this);
	            that.element = element;
	            that.pane = pane;
	            that._getPages();
	            this.page = 0;
	            this.pageSize = options.pageSize || 1;
	            this.contentHeight = options.contentHeight;
	            this.enablePager = options.enablePager;
	            this.pagerOverlay = options.pagerOverlay;
	        },

	        scrollTo: function(page, instant) {
	            this.page = page;
	            this.pane.transitionTo(- page * this.pane.size().width, Transition.easeOutExpo, instant);
	        },

	        paneMoved: function(swipeType, bounce, callback, /*internal*/ instant) {
	            var that = this,
	                pane = that.pane,
	                width = pane.size().width * that.pageSize,
	                approx = round,
	                ease = bounce ? Transition.easeOutBack : Transition.easeOutExpo,
	                snap,
	                nextPage;

	            if (swipeType === LEFT_SWIPE) {
	                approx = ceil;
	            } else if (swipeType === RIGHT_SWIPE) {
	                approx = floor;
	            }

	            nextPage = approx(pane.offset() / width);

	            snap = max(that.minSnap, min(-nextPage * width, that.maxSnap));

	            if (nextPage != that.page) {
	                if (callback && callback({ currentPage: that.page, nextPage: nextPage })) {
	                    snap = -that.page * pane.size().width;
	                }
	            }

	            pane.transitionTo(snap, ease, instant);
	        },

	        updatePage: function() {
	            var pane = this.pane,
	                page = round(pane.offset() / pane.size().width);

	            if (page != this.page) {
	                this.page = page;
	                return true;
	            }

	            return false;
	        },

	        forcePageUpdate: function() {
	            return this.updatePage();
	        },

	        resizeTo: function(size) {
	            var pane = this.pane,
	                width = size.width;

	            this.pageElements.width(width);

	            if (this.contentHeight === "100%") {
	                var containerHeight = this.element.parent().height();

	                if (this.enablePager === true) {
	                    var pager = this.element.parent().find("ol.km-pages");
	                    if (!this.pagerOverlay && pager.length) {
	                        containerHeight -= kendo._outerHeight(pager, true);
	                    }
	                }

	                this.element.css("height", containerHeight);
	                this.pageElements.css("height", containerHeight);
	            }

	            // re-read pane dimension after the pageElements have been resized.
	            pane.updateDimension();

	            if (!this._paged) {
	                this.page = floor(pane.offset() / width);
	            }

	            this.scrollTo(this.page, true);

	            this.pageCount = ceil(pane.total() / width);
	            this.minSnap = - (this.pageCount - 1) * width;
	            this.maxSnap = 0;
	        },

	        _getPages: function() {
	            this.pageElements = this.element.find(kendo.roleSelector("page"));
	            this._paged = this.pageElements.length > 0;
	        }
	    });

	    kendo.mobile.ui.ScrollViewContent = ScrollViewContent;

	    var VirtualScrollViewContent = kendo.Observable.extend({
	        init: function(element, pane, options) {
	            var that = this;

	            kendo.Observable.fn.init.call(this);

	            that.element = element;
	            that.pane = pane;
	            that.options = options;
	            that._templates();
	            that.page = options.page || 0;
	            that.pages = [];
	            that._initPages();
	            that.resizeTo(that.pane.size());

	            that.pane.dimension.forceEnabled();
	        },

	        setDataSource: function(dataSource) {
	            this.dataSource = DataSource.create(dataSource);
	            this._buffer();
	            this._pendingPageRefresh = false;
	            this._pendingWidgetRefresh = false;
	        },

	        _viewShow: function() {
	            var that = this;
	            if (that._pendingWidgetRefresh) {
	                setTimeout(function() {
	                    that._resetPages();
	                }, 0);
	                that._pendingWidgetRefresh = false;
	            }
	        },

	        _buffer: function() {
	            var itemsPerPage = this.options.itemsPerPage;

	            if (this.buffer) {
	                this.buffer.destroy();
	            }

	            if (itemsPerPage > 1) {
	                this.buffer = new BatchBuffer(this.dataSource, itemsPerPage);
	            } else {
	                this.buffer = new Buffer(this.dataSource, itemsPerPage * 3);
	            }

	            this._resizeProxy = proxy(this, "_onResize");
	            this._resetProxy = proxy(this, "_onReset");
	            this._endReachedProxy = proxy(this, "_onEndReached");

	            this.buffer.bind({
	                "resize": this._resizeProxy,
	                "reset": this._resetProxy,
	                "endreached": this._endReachedProxy
	            });
	        },

	        _templates: function() {
	            var template = this.options.template,
	                emptyTemplate = this.options.emptyTemplate,
	                templateProxy = {},
	                emptyTemplateProxy = {};

	            if (typeof template === FUNCTION) {
	                templateProxy.template = template;
	                template = "#=this.template(data)#";
	            }

	            this.template = proxy(kendo.template(template), templateProxy);

	            if (typeof emptyTemplate === FUNCTION) {
	                emptyTemplateProxy.emptyTemplate = emptyTemplate;
	                emptyTemplate = "#=this.emptyTemplate(data)#";
	            }

	            this.emptyTemplate = proxy(kendo.template(emptyTemplate), emptyTemplateProxy);
	        },

	        _initPages: function() {
	            var pages = this.pages,
	                element = this.element,
	                page;

	            for (var i = 0; i < VIRTUAL_PAGE_COUNT; i++) {
	                page = new Page(element);
	                pages.push(page);
	            }

	            this.pane.updateDimension();
	        },

	        resizeTo: function(size) {
	            var pages = this.pages,
	                pane = this.pane;

	            for (var i = 0; i < pages.length; i++) {
	                pages[i].setWidth(size.width);
	            }

	            if (this.options.contentHeight === "auto") {
	                this.element.css("height", this.pages[1].element.height());
	            }

	            else if (this.options.contentHeight === "100%") {
	                var containerHeight = this.element.parent().height();

	                if (this.options.enablePager === true) {
	                    var pager = this.element.parent().find("ol.km-pages");
	                    if (!this.options.pagerOverlay && pager.length) {
	                        containerHeight -= kendo._outerHeight(pager, true);
	                    }
	                }

	                this.element.css("height", containerHeight);
	                pages[0].element.css("height", containerHeight);
	                pages[1].element.css("height", containerHeight);
	                pages[2].element.css("height", containerHeight);
	            }

	            pane.updateDimension();

	            this._repositionPages();

	            this.width = size.width;
	        },

	        scrollTo: function(page) {
	            var buffer = this.buffer,
	                dataItem;

	            buffer.syncDataSource();
	            dataItem = buffer.at(page);

	            if (!dataItem) {
	                return;
	            }

	            this._updatePagesContent(page);

	            this.page = page;
	        },

	        paneMoved: function(swipeType, bounce, callback, /*internal*/ instant) {
	            var that = this,
	                pane = that.pane,
	                width = pane.size().width,
	                offset = pane.offset(),
	                thresholdPassed = Math.abs(offset) >= width / 3,
	                ease = bounce ? kendo.effects.Transition.easeOutBack : kendo.effects.Transition. easeOutExpo,
	                isEndReached = that.page + 2 > that.buffer.total(),
	                nextPage,
	                delta = 0;

	            if (swipeType === RIGHT_SWIPE) {
	                if (that.page !== 0) {
	                    delta = -1; //backward
	                }
	            } else if (swipeType === LEFT_SWIPE && !isEndReached) {
	                delta = 1; //forward
	            } else if (offset > 0 && (thresholdPassed && !isEndReached)) {
	                delta = 1; //forward
	            } else if (offset < 0 && thresholdPassed) {
	                if (that.page !== 0) {
	                    delta = -1; //backward
	                }
	            }

	            nextPage = that.page;
	            if (delta) {
	                nextPage = (delta > 0) ? nextPage + 1 : nextPage - 1;
	            }

	            if (callback && callback({ currentPage: that.page, nextPage: nextPage })) {
	                delta = 0;
	            }

	            if (delta === 0) {
	                that._cancelMove(ease, instant);
	            } else if (delta === -1) {
	                that._moveBackward(instant);
	            } else if (delta === 1) {
	                that._moveForward(instant);
	            }
	        },

	        updatePage: function() {
	            var pages = this.pages;

	            if (this.pane.offset() === 0) {
	                return false;
	            }

	            if (this.pane.offset() > 0) {
	                pages.push(this.pages.shift());//forward
	                this.page++;
	                this.setPageContent(pages[2], this.page + 1);
	            } else {
	                pages.unshift(this.pages.pop()); //back
	                this.page--;
	                this.setPageContent(pages[0], this.page - 1);
	            }

	            this._repositionPages();

	            this._resetMovable();

	            return true;
	        },

	        forcePageUpdate: function() {
	            var offset = this.pane.offset(),
	                threshold  = this.pane.size().width * 3/4;

	            if (abs(offset) > threshold) {
	                return this.updatePage();
	            }

	            return false;
	        },

	        _resetMovable: function() {
	            this.pane.moveTo(0);
	        },

	        _moveForward: function(instant) {
	            this.pane.transitionTo(-this.width, kendo.effects.Transition.easeOutExpo, instant);
	        },

	        _moveBackward: function(instant) {
	            this.pane.transitionTo(this.width, kendo.effects.Transition.easeOutExpo, instant);
	        },

	        _cancelMove: function(ease, /*internal*/ instant) {
	            this.pane.transitionTo(0, ease, instant);
	        },

	        _resetPages: function() {
	            this.page = this.options.page || 0;

	            this._updatePagesContent(this.page);
	            this._repositionPages();

	            this.trigger("reset");
	        },

	        _onResize: function() {
	            this.pageCount = ceil(this.dataSource.total() / this.options.itemsPerPage);

	            if (this._pendingPageRefresh) {
	                this._updatePagesContent(this.page);
	                this._pendingPageRefresh = false;
	            }

	            this.trigger("resize");
	        },

	        _onReset: function() {
	            this.pageCount = ceil(this.dataSource.total() / this.options.itemsPerPage);
	            this._resetPages();
	        },

	        _onEndReached: function() {
	            this._pendingPageRefresh = true;
	        },

	        _repositionPages: function() {
	            var pages = this.pages;

	            pages[0].position(LEFT_PAGE);
	            pages[1].position(CETER_PAGE);
	            pages[2].position(RIGHT_PAGE);
	        },

	        _updatePagesContent: function(offset) {
	            var pages = this.pages,
	                currentPage = offset || 0;

	            this.setPageContent(pages[0], currentPage - 1);
	            this.setPageContent(pages[1], currentPage);
	            this.setPageContent(pages[2], currentPage + 1);
	        },

	        setPageContent: function(page, index) {
	            var buffer = this.buffer,
	                template = this.template,
	                emptyTemplate = this.emptyTemplate,
	                view = null;

	            if (index >= 0) {
	                view = buffer.at(index);
	                if ($.isArray(view) && !view.length) {
	                    view = null;
	                }
	            }

	            this.trigger(CLEANUP, { item: page.element });

	            if (view !== null) {
	                page.content(template(view));
	            } else {
	                page.content(emptyTemplate({}));
	            }

	            kendo.mobile.init(page.element);
	            this.trigger(ITEM_CHANGE, { item: page.element, data: view, ns: kendo.mobile.ui });

	        }
	    });

	    kendo.mobile.ui.VirtualScrollViewContent = VirtualScrollViewContent;

	    var Page = kendo.Class.extend({
	        init: function(container) {
	            this.element = $("<div class='" + className(VIRTUAL_PAGE_CLASS) + "'></div>");
	            this.width = container.width();
	            this.element.width(this.width);
	            container.append(this.element);
	        },

	        content: function(theContent) {
	            this.element.html(theContent);
	        },

	        position: function(position) { //position can be -1, 0, 1
	            this.element.css("transform", "translate3d(" + this.width * position + "px, 0, 0)");
	        },

	        setWidth: function(width) {
	            this.width = width;
	            this.element.width(width);
	        }
	    });

	    kendo.mobile.ui.VirtualPage = Page;

	    var ScrollView = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            options = that.options;
	            element = that.element;

	            kendo.stripWhitespace(element[0]);

	            element
	                .wrapInner("<div/>")
	                .addClass("k-widget " + className("scrollview"));

	            if (this.options.enablePager) {
	                this.pager = new Pager(this);

	                if (this.options.pagerOverlay) {
	                    element.addClass(className("scrollview-overlay"));
	                }
	            }

	            that.inner = element.children().first();
	            that.page = 0;
	            that.inner.css("height", options.contentHeight);

	            that.pane = new ElasticPane(that.inner, {
	                duration: this.options.duration,
	                transitionEnd: proxy(this, "_transitionEnd"),
	                dragStart: proxy(this, "_dragStart"),
	                dragEnd: proxy(this, "_dragEnd"),
	                change: proxy(this, REFRESH)
	            });

	            that.bind("resize", function() {
	                that.pane.refresh();
	            });

	            that.page = options.page;

	            var empty = this.inner.children().length === 0;

	            var content = empty ? new VirtualScrollViewContent(that.inner, that.pane, options) : new ScrollViewContent(that.inner, that.pane, options);

	            content.page = that.page;

	            content.bind("reset", function() {
	                this._pendingPageRefresh = false;
	                that._syncWithContent();
	                that.trigger(REFRESH, { pageCount: content.pageCount, page: content.page });
	            });

	            content.bind("resize", function() {
	                that.trigger(REFRESH, { pageCount: content.pageCount, page: content.page });
	            });

	            content.bind(ITEM_CHANGE, function(e) {
	                that.trigger(ITEM_CHANGE, e);

	                that.angular("compile", function() {
	                    return { elements: e.item, data: [ { dataItem: e.data } ] };
	                });
	            });

	            content.bind(CLEANUP, function(e) {
	                that.angular("cleanup", function() {
	                    return { elements: e.item };
	                });
	            });

	            that._content = content;
	            that.setDataSource(options.dataSource);

	            var mobileContainer = that.container();

	            if (mobileContainer.nullObject) {
	                that.viewInit();
	                that.viewShow();
	            } else {
	                mobileContainer.bind("show", proxy(this, "viewShow")).bind("init", proxy(this, "viewInit"));
	            }
	        },

	        options: {
	            name: "ScrollView",
	            page: 0,
	            duration: 400,
	            velocityThreshold: 0.8,
	            contentHeight: "auto",
	            pageSize: 1,
	            itemsPerPage: 1,
	            bounceVelocityThreshold: 1.6,
	            enablePager: true,
	            pagerOverlay: false,
	            autoBind: true,
	            template: "",
	            emptyTemplate: ""
	        },

	        events: [
	            CHANGING,
	            CHANGE,
	            REFRESH
	        ],

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            kendo.destroy(this.element);
	        },

	        viewInit: function() {
	            if (this.options.autoBind) {
	                this._content.scrollTo(this._content.page, true);
	            }
	        },

	        viewShow: function() {
	            this.pane.refresh();
	        },

	        refresh: function() {
	            var content = this._content;

	            content.resizeTo(this.pane.size());
	            this.page = content.page;
	            this.trigger(REFRESH, { pageCount: content.pageCount, page: content.page });
	        },

	        content: function(html) {
	           this.element.children().first().html(html);
	           this._content._getPages();
	           this.pane.refresh();
	        },

	        value: function(item) {
	            var dataSource = this.dataSource;

	            if (item) {
	                this.scrollTo(dataSource.indexOf(item), true);
	            } else {
	                return dataSource.at(this.page);
	            }
	        },

	        scrollTo: function(page, instant) {
	            this._content.scrollTo(page, instant);
	            this._syncWithContent();
	        },

	        prev: function() {
	            var that = this,
	                prevPage = that.page - 1;

	            if (that._content instanceof VirtualScrollViewContent) {
	                that._content.paneMoved(RIGHT_SWIPE, undefined, function(eventData) {
	                    return that.trigger(CHANGING, eventData);
	                });
	            } else if (prevPage > -1) {
	                that.scrollTo(prevPage);
	            }
	        },

	        next: function() {
	            var that = this,
	                nextPage = that.page + 1;

	            if (that._content instanceof VirtualScrollViewContent) {
	                that._content.paneMoved(LEFT_SWIPE, undefined, function(eventData) {
	                    return that.trigger(CHANGING, eventData);
	                });
	            } else if (nextPage < that._content.pageCount) {
	                that.scrollTo(nextPage);
	            }
	        },

	        setDataSource: function(dataSource) {
	            if (!(this._content instanceof VirtualScrollViewContent)) {
	                return;
	            }
	            // the scrollview should have a ready datasource for MVVM to function properly. But an empty datasource should not empty the element
	            var emptyDataSource = !dataSource;
	            this.dataSource = DataSource.create(dataSource);

	            this._content.setDataSource(this.dataSource);

	            if (this.options.autoBind && !emptyDataSource) {
	                // this.items().remove();
	                this.dataSource.fetch();
	            }
	        },

	        items: function() {
	            return this.element.find(".km-" + VIRTUAL_PAGE_CLASS);
	        },

	        _syncWithContent: function() {
	            var pages = this._content.pages,
	                buffer = this._content.buffer,
	                data,
	                element;

	            this.page = this._content.page;

	            data = buffer ? buffer.at(this.page) : undefined;
	            if (!(data instanceof Array)) {
	                data = [data];
	            }
	            element = pages ? pages[1].element : undefined;

	            this.trigger(CHANGE, { page: this.page, element: element, data: data });
	        },

	        _dragStart: function() {
	            if (this._content.forcePageUpdate()) {
	                this._syncWithContent();
	            }
	        },

	        _dragEnd: function(e) {
	            var that = this,
	                velocity = e.x.velocity,
	                velocityThreshold = this.options.velocityThreshold,
	                swipeType = NUDGE,
	                bounce = abs(velocity) > this.options.bounceVelocityThreshold;

	            if (velocity > velocityThreshold) {
	                swipeType = RIGHT_SWIPE;
	            } else if (velocity < -velocityThreshold) {
	                swipeType = LEFT_SWIPE;
	            }

	            this._content.paneMoved(swipeType, bounce, function(eventData) {
	                return that.trigger(CHANGING, eventData);
	            });
	        },

	        _transitionEnd: function() {
	            if (this._content.updatePage()) {
	                this._syncWithContent();
	            }
	        }
	    });

	    ui.plugin(ScrollView);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "nb/C":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1041);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1041:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1042), __webpack_require__(1043), __webpack_require__(1044), __webpack_require__(1045), __webpack_require__(1046)  ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	    "bundle all";
	    return window.kendo;
	}, __webpack_require__(3));


/***/ }),

/***/ 1042:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lQjy");

/***/ }),

/***/ 1043:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("/4Yk");

/***/ }),

/***/ 1044:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("e8XQ");

/***/ }),

/***/ 1045:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FTkt");

/***/ }),

/***/ 1046:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2btM");

/***/ })

/******/ });

/***/ }),

/***/ "nce5":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1432);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1048:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("BOhp");

/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FZAa");

/***/ }),

/***/ 1432:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1088), __webpack_require__(1086) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "toolbar",
	    name: "ToolBar",
	    category: "web",
	    description: "The ToolBar widget displays one or more command buttons divided into groups.",
	    depends: [ "core" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        Class = kendo.Class,
	        Widget = kendo.ui.Widget,
	        proxy = $.proxy,
	        isFunction = kendo.isFunction,
	        keys = kendo.keys,
	        outerWidth = kendo._outerWidth,
	        ns = ".kendoToolBar",
	        TOOLBAR = "k-toolbar",
	        BUTTON = "k-button",
	        OVERFLOW_BUTTON = "k-overflow-button",
	        TOGGLE_BUTTON = "k-toggle-button",
	        BUTTON_GROUP = "k-button-group",
	        SPLIT_BUTTON = "k-split-button",
	        SEPARATOR = "k-separator",
	        SPACER_CLASS = "k-spacer",
	        SPACER = "spacer",
	        POPUP = "k-popup",

	        RESIZABLE_TOOLBAR = "k-toolbar-resizable",
	        STATE_ACTIVE = "k-state-active",
	        STATE_DISABLED = "k-state-disabled",
	        STATE_HIDDEN = "k-state-hidden",
	        HIDDEN = "k-hidden",
	        GROUP_START = "k-group-start",
	        GROUP_END = "k-group-end",
	        PRIMARY = "k-primary",

	        ARIA_DISABLED = "aria-disabled",
	        ARIA_PRESSED = "aria-pressed",

	        ICON = "k-icon",
	        ICON_PREFIX = "k-i-",
	        BUTTON_ICON = "k-button-icon",
	        BUTTON_ICON_TEXT = "k-button-icontext",

	        LIST_CONTAINER = "k-list-container k-split-container",
	        SPLIT_BUTTON_ARROW = "k-split-button-arrow",

	        OVERFLOW_ANCHOR = "k-overflow-anchor",
	        OVERFLOW_CONTAINER = "k-overflow-container",
	        FIRST_TOOLBAR_VISIBLE = "k-toolbar-first-visible",
	        LAST_TOOLBAR_VISIBLE = "k-toolbar-last-visible",

	        CLICK = "click",
	        TOGGLE = "toggle",
	        OPEN = "open",
	        CLOSE = "close",
	        OVERFLOW_OPEN = "overflowOpen",
	        OVERFLOW_CLOSE = "overflowClose",

	        OVERFLOW_NEVER = "never",
	        OVERFLOW_AUTO = "auto",
	        OVERFLOW_ALWAYS = "always",
	        OVERFLOW_HIDDEN = "k-overflow-hidden",

	        OPTION_LIST_SUFFIX = "_optionlist",

	        KENDO_UID_ATTR = kendo.attr("uid");

	        kendo.toolbar = {};

	        var components = {
	            overflowAnchor: '<div tabindex="0" class="k-overflow-anchor k-button" title="More tools" role="button"></div>',
	            overflowContainer: '<ul class="k-overflow-container k-list-container"></ul>'
	        };

	        kendo.toolbar.registerComponent = function(name, toolbar, overflow) {
	            components[name] = {
	                toolbar: toolbar,
	                overflow: overflow
	            };
	        };

	        var Item = kendo.Class.extend({
	            addOverflowAttr: function() {
	                this.element.attr(kendo.attr("overflow"), this.options.overflow || OVERFLOW_AUTO);
	            },

	            addUidAttr: function() {
	                this.element.attr(KENDO_UID_ATTR, this.options.uid);
	            },

	            addIdAttr: function() {
	                if (this.options.id) {
	                    this.element.attr("id", this.options.id);
	                }
	            },

	            addOverflowIdAttr: function() {
	                if (this.options.id) {
	                    this.element.attr("id", this.options.id + "_overflow");
	                }
	            },

	            attributes: function() {
	                if (this.options.attributes) {
	                    this.element.attr(this.options.attributes);
	                }
	            },

	            show: function() {
	                this.element.removeClass(STATE_HIDDEN);
	                this.element.removeClass(HIDDEN);
	                this.options.hidden = false;
	            },

	            hide: function() {
	                this.element.addClass(STATE_HIDDEN);
	                this.element.addClass(HIDDEN);

	                if (this.overflow && this.overflowHidden){
	                    this.overflowHidden();
	                }
	                this.options.hidden = true;
	            },

	            remove: function() {
	                this.element.remove();
	            },

	            enable: function(isEnabled) {
	                if (isEnabled === undefined) {
	                    isEnabled = true;
	                }
	                this.element.toggleClass(STATE_DISABLED, !isEnabled);
	                this.element.attr(ARIA_DISABLED, !isEnabled);

	                this.options.enable = isEnabled;
	            },

	            twin: function() {
	                var uid = this.element.attr(KENDO_UID_ATTR);
	                if (this.overflow && this.options.splitContainerId) {
	                    return $("#" + this.options.splitContainerId)
	                            .find("[" + KENDO_UID_ATTR + "='" + uid + "']")
	                            .data(this.options.type);
	                } else if (this.overflow) {
	                    return this.toolbar
	                            .element
	                            .find("[" + KENDO_UID_ATTR + "='" + uid + "']")
	                            .data(this.options.type);
	                } else if (this.toolbar.options.resizable) {
	                    return this.toolbar
	                            .popup.element
	                            .find("[" + KENDO_UID_ATTR + "='" + uid + "']")
	                            .data(this.options.type);
	                }
	            }
	        });

	        kendo.toolbar.Item = Item;

	        var Button = Item.extend({
	            init: function(options, toolbar) {
	                var element = options.useButtonTag ? $('<button tabindex="0"></button>') : $('<a role="button" href tabindex="0"></a>');

	                this.element = element;
	                this.options = options;
	                this.toolbar = toolbar;

	                this.attributes();

	                if (options.primary) {
	                    element.addClass(PRIMARY);
	                }

	                if (options.togglable) {
	                    element.addClass(TOGGLE_BUTTON);
	                    this.toggle(options.selected);
	                }

	                if (options.url !== undefined && !options.useButtonTag) {
	                    element.attr("href", options.url);
	                    if (options.mobile) {
	                        element.attr(kendo.attr("role"), "button");
	                    }
	                }

	                if (options.group) {
	                    element.attr(kendo.attr("group"), options.group);
	                    this.group = this.toolbar.addToGroup(this, options.group);
	                }

	                if (!options.togglable && options.click && isFunction(options.click)) {
	                    this.clickHandler = options.click;
	                }

	                if (options.togglable && options.toggle && isFunction(options.toggle)) {
	                    this.toggleHandler = options.toggle;
	                }
	            },

	            toggle: function(state, propagate) {
	                state = !!state;

	                if (this.group && state) {
	                    this.group.select(this);
	                } else if (!this.group) {
	                    this.select(state);
	                }

	                if (propagate && this.twin()) {
	                    this.twin().toggle(state);
	                }
	            },

	            getParentGroup: function() {
	                if (this.options.isChild) {
	                    return this.element.closest("." + BUTTON_GROUP).data("buttonGroup");
	                }
	            },

	            _addGraphics: function() {
	                var element = this.element,
	                    icon = this.options.icon,
	                    spriteCssClass = this.options.spriteCssClass,
	                    imageUrl = this.options.imageUrl,
	                    isEmpty, span, img;

	                if (spriteCssClass || imageUrl || icon) {
	                    isEmpty = true;

	                    element.contents().filter(function() {
	                        return (!$(this).hasClass("k-sprite") && !$(this).hasClass(ICON) && !$(this).hasClass("k-image"));
	                    }).each(function(idx, el){
	                        if (el.nodeType == 1 || el.nodeType == 3 && kendo.trim(el.nodeValue).length > 0) {
	                            isEmpty = false;
	                        }
	                    });

	                    if (isEmpty) {
	                        element.addClass(BUTTON_ICON);
	                    } else {
	                        element.addClass(BUTTON_ICON_TEXT);
	                    }
	                }
	                if (icon) {
	                    span = element.children("span." + ICON).first();
	                    if (!span[0]) {
	                        span = $('<span class="' + ICON + '"></span>').prependTo(element);
	                    }
	                    span.addClass(ICON_PREFIX + icon);
	                } else if (spriteCssClass) {
	                    span = element.children("span.k-sprite").first();
	                    if (!span[0]) {
	                        span = $('<span class="k-sprite ' + ICON + '"></span>').prependTo(element);
	                    }
	                    span.addClass(spriteCssClass);
	                } else if (imageUrl) {
	                    img = element.children("img.k-image").first();
	                    if (!img[0]) {
	                        img = $('<img alt="icon" class="k-image" />').prependTo(element);
	                    }
	                    img.attr("src", imageUrl);
	                }
	            }
	        });

	        kendo.toolbar.Button = Button;

	        var ToolBarButton = Button.extend({
	            init: function(options, toolbar) {
	                Button.fn.init.call(this, options, toolbar);

	                var element = this.element;

	                element.addClass(BUTTON);

	                this.addIdAttr();

	                if (options.align) {
	                    element.addClass("k-align-" + options.align);
	                }

	                if (options.showText != "overflow" && options.text) {
	                    if (options.mobile) {
	                        element.html('<span class="km-text">' + options.text + "</span>");
	                    } else {
	                        element.html(options.text);
	                    }
	                }

	                options.hasIcon = (options.showIcon != "overflow") && (options.icon || options.spriteCssClass || options.imageUrl);
	                if (options.hasIcon) {
	                    this._addGraphics();
	                }

	                this.addUidAttr();
	                this.addOverflowAttr();
	                this.enable(options.enable);

	                if (options.hidden) {
	                    this.hide();
	                }

	                this.element.data({
	                    type: "button",
	                    button: this
	                });
	            },

	            select: function(selected) {
	                if (selected === undefined) {
	                    selected = false;
	                }

	                if (this.options.togglable) {
	                    this.element.attr(ARIA_PRESSED, selected);
	                }

	                this.element.toggleClass(STATE_ACTIVE, selected);
	                this.options.selected = selected;
	            }
	        });

	        kendo.toolbar.ToolBarButton = ToolBarButton;

	        var OverflowButton = Button.extend({
	            init: function(options, toolbar) {
	                this.overflow = true;

	                Button.fn.init.call(this, $.extend({}, options), toolbar);

	                var element = this.element;

	                if (options.showText != "toolbar" && options.text) {
	                    if (options.mobile) {
	                        element.html('<span class="km-text">' + options.text + "</span>");
	                    } else {
	                        element.html('<span class="k-text">' + options.text + "</span>");
	                    }
	                }

	                options.hasIcon = (options.showIcon != "toolbar") && (options.icon || options.spriteCssClass || options.imageUrl);
	                if (options.hasIcon) {
	                    this._addGraphics();
	                }

	                if (!options.isChild) {
	                    this._wrap();
	                }

	                this.addOverflowIdAttr();
	                this.attributes();
	                this.addUidAttr();
	                this.addOverflowAttr();
	                this.enable(options.enable);

	                element.addClass(OVERFLOW_BUTTON + " " + BUTTON);

	                if (options.hidden) {
	                    this.hide();
	                }

	                if (options.togglable){
	                    this.toggle(options.selected);
	                }

	                this.element.data({
	                    type: "button",
	                    button: this
	                });
	            },

	            _wrap: function() {
	                this.element = this.element.wrap("<li></li>").parent();
	            },

	            overflowHidden: function() {
	                this.element.addClass(OVERFLOW_HIDDEN);
	            },

	            select: function(selected) {
	                if (selected === undefined) {
	                    selected = false;
	                }

	                if (this.options.isChild) {
	                    this.element.toggleClass(STATE_ACTIVE, selected);
	                } else {
	                    this.element.find(".k-button").toggleClass(STATE_ACTIVE, selected);
	                }
	                this.options.selected = selected;
	            }
	        });

	        kendo.toolbar.OverflowButton = OverflowButton;
	        kendo.toolbar.registerComponent("button", ToolBarButton, OverflowButton);

	        var ButtonGroup = Item.extend({
	            createButtons: function(buttonConstructor) {
	                var options = this.options;
	                var items = options.buttons || [];
	                var item;

	                for (var i = 0; i < items.length; i++) {
	                    if (!items[i].uid) {
	                        items[i].uid = kendo.guid();
	                    }
	                    item = new buttonConstructor($.extend({ mobile: options.mobile, isChild: true, type: "button" }, items[i]), this.toolbar);
	                    item.element.appendTo(this.element);
	                }
	            },

	            refresh: function() {
	                this.element.children().filter(":not('." + STATE_HIDDEN + "'):first").addClass(GROUP_START);
	                this.element.children().filter(":not('." + STATE_HIDDEN + "'):last").addClass(GROUP_END);
	            }
	        });

	        kendo.toolbar.ButtonGroup = ButtonGroup;

	        var ToolBarButtonGroup = ButtonGroup.extend({
	            init: function(options, toolbar) {
	                var element = this.element = $('<div></div>');
	                this.options = options;
	                this.toolbar = toolbar;

	                this.addIdAttr();

	                if (options.align) {
	                    element.addClass("k-align-" + options.align);
	                }

	                this.createButtons(ToolBarButton);
	                this.attributes();
	                this.addUidAttr();
	                this.addOverflowAttr();
	                this.refresh();

	                element.addClass(BUTTON_GROUP);

	                this.element.data({
	                    type: "buttonGroup",
	                    buttonGroup: this
	                });
	            }
	        });

	        kendo.toolbar.ToolBarButtonGroup = ToolBarButtonGroup;

	        var OverflowButtonGroup = ButtonGroup.extend({
	            init: function(options, toolbar) {
	                var element = this.element = $('<li></li>');
	                this.options = options;
	                this.toolbar = toolbar;
	                this.overflow = true;

	                this.addOverflowIdAttr();

	                this.createButtons(OverflowButton);
	                this.attributes();
	                this.addUidAttr();
	                this.addOverflowAttr();
	                this.refresh();

	                element.addClass((options.mobile ? "" : BUTTON_GROUP) + " k-overflow-group");

	                this.element.data({
	                    type: "buttonGroup",
	                    buttonGroup: this
	                });
	            },

	            overflowHidden: function() {
	                this.element.addClass(OVERFLOW_HIDDEN);
	            }
	        });

	        kendo.toolbar.OverflowButtonGroup = OverflowButtonGroup;
	        kendo.toolbar.registerComponent("buttonGroup", ToolBarButtonGroup, OverflowButtonGroup);

	        var ToolBarSplitButton = Item.extend({
	            init: function(options, toolbar) {
	                var element = this.element = $('<div class="' + SPLIT_BUTTON + '" tabindex="0"></div>');

	                this.options = options;
	                this.toolbar = toolbar;

	                this.mainButton = new ToolBarButton($.extend({}, options, { hidden: false }), toolbar);
	                this.arrowButton = $('<a class="' + BUTTON + " " + SPLIT_BUTTON_ARROW + '"><span class="' + (options.mobile ? "km-icon km-arrowdown" : "k-icon k-i-arrow-60-down") + '"></span></a>');
	                this.popupElement = $('<ul class="' + LIST_CONTAINER + '"></ul>');

	                this.mainButton.element
	                    .removeAttr("href tabindex")
	                    .appendTo(element);

	                this.arrowButton.appendTo(element);
	                this.popupElement.appendTo(element);

	                if (options.align) {
	                    element.addClass("k-align-" + options.align);
	                }

	                if (!options.id) {
	                    options.id = options.uid;
	                }

	                element.attr("id", options.id + "_wrapper");

	                this.addOverflowAttr();
	                this.addUidAttr();

	                this.createMenuButtons();
	                this.createPopup();
	                this._navigatable();

	                this.mainButton.main = true;

	                this.enable(options.enable);

	                if (options.hidden) {
	                    this.hide();
	                }

	                element.data({
	                    type: "splitButton",
	                    splitButton: this,
	                    kendoPopup: this.popup
	                });
	            },

	            _navigatable: function() {
	                var that = this;

	                that.popupElement.on("keydown" + ns, "." + BUTTON, function(e) {
	                    var li = $(e.target).parent();

	                    e.preventDefault();

	                    if (e.keyCode === keys.ESC || e.keyCode === keys.TAB || (e.altKey && e.keyCode === keys.UP)) {
	                        that.toggle();
	                        that.focus();
	                    } else if (e.keyCode === keys.DOWN) {
	                        findFocusableSibling(li, "next").focus();
	                    } else if (e.keyCode === keys.UP) {
	                        findFocusableSibling(li, "prev").focus();
	                    } else if (e.keyCode === keys.SPACEBAR || e.keyCode === keys.ENTER) {
	                        that.toolbar.userEvents.trigger("tap", { target: $(e.target) });
	                    } else if (e.keyCode === keys.HOME) {
	                        li.parent().find(":kendoFocusable").first().focus();
	                    } else if (e.keyCode === keys.END) {
	                        li.parent().find(":kendoFocusable").last().focus();
	                    }
	                });
	            },

	            createMenuButtons: function() {
	                var options = this.options;
	                var items = options.menuButtons;
	                var item;

	                for (var i = 0; i < items.length; i++) {
	                    item = new ToolBarButton($.extend({ mobile: options.mobile, type: "button", click: options.click }, items[i]), this.toolbar);
	                    item.element.wrap("<li></li>").parent().appendTo(this.popupElement);
	                }
	            },

	            createPopup: function() {
	                var that = this;
	                var options = this.options;
	                var element = this.element;

	                this.popupElement
	                        .attr("id", options.id + OPTION_LIST_SUFFIX)
	                        .attr(KENDO_UID_ATTR, options.rootUid);

	                if (options.mobile) {
	                    this.popupElement = actionSheetWrap(this.popupElement);
	                }

	                this.popup = this.popupElement.kendoPopup({
	                    appendTo: options.mobile ? $(options.mobile).children(".km-pane") : null,
	                    anchor: element,
	                    isRtl: this.toolbar._isRtl,
	                    copyAnchorStyles: false,
	                    animation: options.animation,
	                    open: function(e){
	                        var isDefaultPrevented = that.toolbar.trigger(OPEN, { target: element });

	                        if(isDefaultPrevented){
	                            e.preventDefault();
	                            return;
	                        }

	                        that.adjustPopupWidth(e.sender);
	                    },
	                    activate: function() {
	                        this.element.find(":kendoFocusable").first().focus();
	                    },
	                    close: function(e) {
	                        var isDefaultPrevented = that.toolbar.trigger(CLOSE, { target: element });
	                        if(isDefaultPrevented){
	                            e.preventDefault();
	                        }
	                        element.focus();
	                    }
	                }).data("kendoPopup");

	                this.popup.element.on(CLICK + ns, "a.k-button", preventClick);
	            },

	            adjustPopupWidth: function (popup) {
	                var anchor = popup.options.anchor,
	                    computedWidth = outerWidth(anchor),
	                    width;

	                kendo.wrap(popup.element).addClass("k-split-wrapper");

	                if (popup.element.css("box-sizing") !== "border-box") {
	                    width = computedWidth - (outerWidth(popup.element) - popup.element.width());
	                } else {
	                    width = computedWidth;
	                }

	                popup.element.css({
	                    fontFamily: anchor.css("font-family"),
	                    "min-width": width
	                });
	            },

	            remove: function() {
	                this.popup.element.off(CLICK + ns, "a.k-button");
	                this.popup.destroy();
	                this.element.remove();
	            },

	            toggle: function() {
	                if(this.options.enable || this.popup.visible()){
	                    this.popup.toggle();
	                }
	            },

	            enable: function(isEnabled) {
	                if (isEnabled === undefined) {
	                    isEnabled = true;
	                }

	                this.mainButton.enable(isEnabled);
	                this.element.toggleClass(STATE_DISABLED, !isEnabled);
	                this.element.attr(ARIA_DISABLED, !isEnabled);
	                this.options.enable = isEnabled;
	            },

	            focus: function() {
	                this.element.focus();
	            },

	            hide: function() {
	                if (this.popup) {
	                    this.popup.close();
	                }

	                this.element.addClass(STATE_HIDDEN);
	                this.element.addClass(HIDDEN);
	                this.options.hidden = true;
	            },

	            show: function() {
	                this.element.removeClass(STATE_HIDDEN);
	                this.element.removeClass(HIDDEN);
	                this.options.hidden = false;
	            }
	        });

	        kendo.toolbar.ToolBarSplitButton = ToolBarSplitButton;

	        var OverflowSplitButton = Item.extend({
	            init: function(options, toolbar) {
	                var element = this.element = $('<li class="' + SPLIT_BUTTON + '"></li>'),
	                    items = options.menuButtons,
	                    item, splitContainerId;

	                this.options = options;
	                this.toolbar = toolbar;
	                this.overflow = true;
	                splitContainerId = (options.id || options.uid) + OPTION_LIST_SUFFIX;

	                this.mainButton = new OverflowButton($.extend({ isChild: true }, options));
	                this.mainButton.element.appendTo(element);

	                for (var i = 0; i < items.length; i++) {
	                    item = new OverflowButton($.extend({ mobile: options.mobile, type: "button", splitContainerId: splitContainerId, isChild: true }, items[i]), this.toolbar);
	                    item.element.appendTo(element);
	                }

	                this.addUidAttr();
	                this.addOverflowAttr();

	                this.mainButton.main = true;

	                element.data({
	                    type: "splitButton",
	                    splitButton: this
	                });
	            },

	            overflowHidden: function() {
	                this.element.addClass(OVERFLOW_HIDDEN);
	            }
	        });

	        kendo.toolbar.OverflowSplitButton = OverflowSplitButton;
	        kendo.toolbar.registerComponent("splitButton", ToolBarSplitButton, OverflowSplitButton);

	        var ToolBarSeparator = Item.extend({
	            init: function(options, toolbar) {
	                var element = this.element = $('<div>&nbsp;</div>');

	                this.element = element;
	                this.options = options;
	                this.toolbar = toolbar;

	                this.attributes();
	                this.addIdAttr();
	                this.addUidAttr();
	                this.addOverflowAttr();

	                element.addClass(SEPARATOR);

	                element.data({
	                    type: "separator",
	                    separator: this
	                });
	            }
	        });

	        var OverflowSeparator = Item.extend({
	            init: function(options, toolbar) {
	                var element = this.element = $('<li>&nbsp;</li>');

	                this.element = element;
	                this.options = options;
	                this.toolbar = toolbar;
	                this.overflow = true;

	                this.attributes();
	                this.addUidAttr();
	                this.addOverflowIdAttr();

	                element.addClass(SEPARATOR);

	                element.data({
	                    type: "separator",
	                    separator: this
	                });
	            },

	            overflowHidden: function() {
	                this.element.addClass(OVERFLOW_HIDDEN);
	            }
	        });

	        kendo.toolbar.registerComponent("separator", ToolBarSeparator, OverflowSeparator);

	        var ToolBarSpacer = Item.extend({
	            init: function(options, toolbar) {
	                var element = this.element = $('<div>&nbsp;</div>');

	                this.element = element;
	                this.options = options;
	                this.toolbar = toolbar;

	                element.addClass(SPACER_CLASS);

	                element.data({
	                    type: SPACER
	                });
	            }
	        });

	        kendo.toolbar.registerComponent(SPACER, ToolBarSpacer);

	        var TemplateItem = Item.extend({
	            init: function(template, options, toolbar) {
	                var element = isFunction(template) ? template(options) : template;

	                if (!(element instanceof jQuery)) {
	                    element = $("<div></div>").html(element);
	                } else {
	                    element = element.wrap("<div></div>").parent();
	                }

	                this.element = element;
	                this.options = options;
	                this.options.type = "template";
	                this.toolbar = toolbar;

	                this.attributes();
	                this.addUidAttr();
	                this.addIdAttr();
	                this.addOverflowAttr();

	                element.data({
	                    type: "template",
	                    template: this
	                });
	            }
	        });

	        kendo.toolbar.TemplateItem = TemplateItem;

	        var OverflowTemplateItem = Item.extend({
	            init: function(template, options, toolbar) {
	                var element = isFunction(template) ? $(template(options)) : $(template);

	                if (!(element instanceof jQuery)) {
	                    element = $("<li></li>").html(element);
	                } else {
	                    element = element.wrap("<li></li>").parent();
	                }

	                this.element = element;
	                this.options = options;
	                this.options.type = "template";
	                this.toolbar = toolbar;
	                this.overflow = true;

	                this.attributes();
	                this.addUidAttr();
	                this.addOverflowIdAttr();
	                this.addOverflowAttr();

	                element.data({
	                    type: "template",
	                    template: this
	                });
	            },

	            overflowHidden: function() {
	                this.element.addClass(OVERFLOW_HIDDEN);
	            }
	        });

	        kendo.toolbar.OverflowTemplateItem = OverflowTemplateItem;

	        function toggleActive(e) {
	            if (!e.target.is(".k-toggle-button")) {
	                e.target.toggleClass(STATE_ACTIVE, e.type == "press");
	            }
	        }

	        function actionSheetWrap(element) {
	            element = $(element);

	            return element.hasClass("km-actionsheet") ? element.closest(".km-popup-wrapper") : element.addClass("km-widget km-actionsheet")
	                             .wrap('<div class="km-actionsheet-wrapper km-actionsheet-tablet km-widget km-popup"></div>').parent()
	                             .wrap('<div class="km-popup-wrapper k-popup"></div>').parent();
	        }

	        function preventClick(e) {
	            if ($(e.target).closest("a.k-button").length) {
	                e.preventDefault();
	            }
	        }

	        function findFocusableSibling (element, dir) {
	            var getSibling = dir === "next" ? $.fn.next : $.fn.prev;
	            var getter = dir === "next" ? $.fn.first : $.fn.last;
	            var candidate = getSibling.call(element);

	            if(!candidate.length && element.is("." + OVERFLOW_ANCHOR)){
	                return element;
	            }

	            if (candidate.is(":kendoFocusable") || !candidate.length) {
	                return candidate;
	            }

	            if (candidate.find(":kendoFocusable").length) {
	                return getter.call(candidate.find(":kendoFocusable"));
	            }

	            return findFocusableSibling(candidate, dir);
	        }

	        var Group = Class.extend({
	            init: function(name) {
	                this.name = name;
	                this.buttons = [];
	            },

	            add: function(button) {
	                this.buttons[this.buttons.length] = button;
	            },

	            remove: function(button) {
	                var index = $.inArray(button, this.buttons);
	                this.buttons.splice(index, 1);
	            },

	            select: function(button) {
	                var tmp;
	                for (var i = 0; i < this.buttons.length; i ++) {
	                    tmp = this.buttons[i];

	                    tmp.select(false);
	                }

	                button.select(true);
	                if (button.twin()) {
	                    button.twin().select(true);
	                }
	            }
	        });

	        var ToolBar = Widget.extend({
	            init: function(element, options) {
	                var that = this;
	                Widget.fn.init.call(that, element, options);

	                options = that.options;
	                element = that.wrapper = that.element;

	                element.addClass(TOOLBAR + " k-widget");

	                this.uid = kendo.guid();
	                this._isRtl = kendo.support.isRtl(element);
	                this._groups = {};
	                element.attr(KENDO_UID_ATTR, this.uid);

	                that.isMobile = (typeof options.mobile === "boolean") ? options.mobile : that.element.closest(".km-root")[0];
	                that.animation = that.isMobile ? { open: { effects: "fade" } } : {};

	                if (that.isMobile) {
	                    element.addClass("km-widget");
	                    ICON = "km-icon";
	                    ICON_PREFIX = "km-";
	                    BUTTON = "km-button";
	                    BUTTON_GROUP = "km-buttongroup";
	                    STATE_ACTIVE = "km-state-active";
	                    STATE_DISABLED = "km-state-disabled";
	                }

	                if(options.resizable) {
	                    that._renderOverflow();
	                    element.addClass(RESIZABLE_TOOLBAR);

	                    that.overflowUserEvents = new kendo.UserEvents(that.element, {
	                        threshold: 5,
	                        allowSelection: true,
	                        filter: "." + OVERFLOW_ANCHOR,
	                        tap: proxy(that._toggleOverflow, that)
	                    });

	                    that._resizeHandler = kendo.onResize(function() {
	                        that.resize();
	                    });
	                } else {
	                    that.popup = { element: $([]) };
	                }

	                if(options.items && options.items.length) {
	                    for (var i = 0; i < options.items.length; i++) {
	                        that.add(options.items[i]);
	                    }

	                    if(options.resizable) {
	                        that._shrink(that.element.innerWidth());
	                    }
	                }

	                that.userEvents = new kendo.UserEvents(document, {
	                    threshold: 5,
	                    allowSelection: true,
	                    filter:
	                        "[" + KENDO_UID_ATTR + "=" + this.uid + "] a." + BUTTON + ", " +
	                        "[" + KENDO_UID_ATTR + "=" + this.uid + "] ." + OVERFLOW_BUTTON,
	                    tap: proxy(that._buttonClick, that),
	                    press: toggleActive,
	                    release: toggleActive
	                });

	                that.element.on(CLICK + ns, "a.k-button", preventClick);
	                that._navigatable();

	                if (options.resizable) {
	                    that.popup.element.on(CLICK + ns, + "a.k-button", preventClick);
	                }

	                if (options.resizable) {
	                    this._toggleOverflowAnchor();
	                }

	                kendo.notify(that);
	            },

	            events: [
	                CLICK,
	                TOGGLE,
	                OPEN,
	                CLOSE,
	                OVERFLOW_OPEN,
	                OVERFLOW_CLOSE
	            ],

	            options: {
	                name: "ToolBar",
	                items: [],
	                resizable: true,
	                mobile: null
	            },

	            addToGroup: function(button, groupName) {
	                var group;

	                if (!this._groups[groupName]) {
	                    group = this._groups[groupName] = new Group();
	                } else {
	                    group = this._groups[groupName];
	                }

	                group.add(button);
	                return group;
	            },

	            destroy: function() {
	                var that = this;

	                that.element.find("." + SPLIT_BUTTON).each(function(idx, element) {
	                    $(element).data("kendoPopup").destroy();
	                });

	                that.element.off(ns, "a.k-button");

	                that.userEvents.destroy();

	                if (that.options.resizable) {
	                    kendo.unbindResize(that._resizeHandler);
	                    that.overflowUserEvents.destroy();
	                    that.popup.element.off(ns, "a.k-button");
	                    that.popup.destroy();
	                }

	                Widget.fn.destroy.call(that);
	            },

	            add: function(options) {
	                var component = components[options.type],
	                    template = options.template,
	                    tool, that = this,
	                    itemClasses = that.isMobile ? "" : "k-item k-state-default",
	                    overflowTemplate = options.overflowTemplate,
	                    overflowTool;

	                $.extend(options, {
	                    uid: kendo.guid(),
	                    animation: that.animation,
	                    mobile: that.isMobile,
	                    rootUid: that.uid
	                });

	                if (options.menuButtons) {
	                    for (var i = 0; i < options.menuButtons.length; i++) {
	                        $.extend(options.menuButtons[i], {
	                            uid: kendo.guid()
	                        });
	                    }
	                }

	                if ((template && !overflowTemplate) || options.type === SPACER) {
	                    options.overflow = OVERFLOW_NEVER;
	                } else if (!options.overflow) {
	                    options.overflow = OVERFLOW_AUTO;
	                }

	                //add the command in the overflow popup
	                if (options.overflow !== OVERFLOW_NEVER && that.options.resizable) {
	                    if (overflowTemplate) { //template command
	                         overflowTool = new OverflowTemplateItem(overflowTemplate, options, that);
	                    } else if (component) { //build-in command
	                        overflowTool = new component.overflow(options, that);
	                        overflowTool.element.addClass(itemClasses);
	                    }

	                    if (overflowTool) {
	                        if (options.overflow === OVERFLOW_AUTO) {
	                            overflowTool.overflowHidden();
	                        }

	                        overflowTool.element.appendTo(that.popup.container);
	                        that.angular("compile", function(){
	                            return { elements: overflowTool.element.get() };
	                        });
	                    }
	                }

	                //add the command in the toolbar container
	                if (options.overflow !== OVERFLOW_ALWAYS) {
	                    if (template) { //template command
	                        tool = new TemplateItem(template, options, that);
	                    } else if (component) { //build-in command
	                        tool = new component.toolbar(options, that);
	                    }

	                    if (tool) {
	                        tool.element.appendTo(that.element);

	                        that.angular("compile", function(){
	                            return { elements: tool.element.get() };
	                        });
	                    }
	                }
	            },

	            _getItem: function(candidate) {
	                var element,
	                    toolbarItem,
	                    overflowItem,
	                    isResizable = this.options.resizable,
	                    type;

	                //find toolbar item

	                element = this.element.find(candidate);
	                if (!element.length) {
	                    element = $(".k-split-container[data-uid=" + this.uid + "]").find(candidate);
	                }

	                type = element.length ? element.data("type") : "";
	                toolbarItem = element.data(type);

	                if (toolbarItem) {
	                    if (toolbarItem.main) {
	                        element = element.parent("." + SPLIT_BUTTON);
	                        type = "splitButton";
	                        toolbarItem = element.data(type);
	                    }

	                    if (isResizable) {
	                        overflowItem = toolbarItem.twin();
	                    }
	                } else if (isResizable) { //find overflow item
	                    element = this.popup.element.find(candidate);
	                    type = element.length ? element.data("type") : "";
	                    overflowItem = element.data(type);

	                    if (overflowItem && overflowItem.main) {
	                        element = element.parent("." + SPLIT_BUTTON);
	                        type = "splitButton";
	                        overflowItem = element.data(type);
	                    }
	                }

	                return {
	                    type: type,
	                    toolbar: toolbarItem,
	                    overflow: overflowItem
	                };
	            },

	            remove: function(candidate) {
	                var item = this._getItem(candidate);

	                if (item.toolbar) { item.toolbar.remove(); }
	                if (item.overflow) { item.overflow.remove(); }

	                this.resize(true);
	            },

	            hide: function(candidate) {
	                var item = this._getItem(candidate);
	                var buttonGroupInstance;

	                if (item.toolbar) {
	                    if (item.toolbar.options.type === "button" && item.toolbar.options.isChild) {
	                        buttonGroupInstance = item.toolbar.getParentGroup();

	                        item.toolbar.hide();

	                        if (buttonGroupInstance) {
	                            buttonGroupInstance.refresh();
	                        }
	                    } else if (!item.toolbar.options.hidden) {
	                        item.toolbar.hide();
	                    }
	                }

	                if (item.overflow) {
	                    if (item.overflow.options.type === "button" && item.overflow.options.isChild) {
	                        buttonGroupInstance = item.overflow.getParentGroup();

	                        item.overflow.hide();

	                        if(buttonGroupInstance) {
	                            buttonGroupInstance.refresh();
	                        }
	                    } else if(!item.overflow.options.hidden) {
	                        item.overflow.hide();
	                    }
	                }

	                this.resize(true);
	            },

	            show: function(candidate) {
	                var item = this._getItem(candidate);
	                var buttonGroupInstance;

	                if (item.toolbar) {
	                    if (item.toolbar.options.type === "button" && item.toolbar.options.isChild) {
	                        buttonGroupInstance = item.toolbar.getParentGroup();
	                        item.toolbar.show();

	                        if (buttonGroupInstance) {
	                            buttonGroupInstance.refresh();
	                        }
	                    } else if(item.toolbar.options.hidden) {
	                        item.toolbar.show();
	                    }
	                }

	                if (item.overflow) {
	                    if (item.overflow.options.type === "button" && item.overflow.options.isChild) {
	                        buttonGroupInstance = item.overflow.getParentGroup();

	                        item.toolbar.show();

	                        if (buttonGroupInstance) {
	                            buttonGroupInstance.refresh();
	                        }
	                    } else if(item.overflow.options.hidden) {
	                        item.overflow.show();
	                    }
	                }

	                this.resize(true);
	            },

	            enable: function(element, enable) {
	                var item = this._getItem(element);

	                if (typeof enable == "undefined") {
	                    enable = true;
	                }

	                if (item.toolbar) { item.toolbar.enable(enable); }
	                if (item.overflow) { item.overflow.enable(enable); }
	            },

	            getSelectedFromGroup: function(groupName) {
	                return this.element.find("." + TOGGLE_BUTTON + "[data-group='" + groupName + "']").filter("." + STATE_ACTIVE);
	            },

	            toggle: function(button, checked) {
	                var element = $(button),
	                    item = element.data("button");

	                if (item.options.togglable) {
	                    if (checked === undefined) {
	                        checked = true;
	                    }
	                    item.toggle(checked, true);
	                }
	            },

	            _renderOverflow: function() {
	                var that = this,
	                    overflowContainer = components.overflowContainer,
	                    isRtl = that._isRtl,
	                    horizontalDirection = isRtl ? "left" : "right";

	                that.overflowAnchor = $(components.overflowAnchor).addClass(BUTTON);

	                that.element.append(that.overflowAnchor);

	                if (that.isMobile) {
	                    that.overflowAnchor.append('<span class="km-icon km-more"></span>');
	                    overflowContainer = actionSheetWrap(overflowContainer);
	                } else {
	                    that.overflowAnchor.append('<span class="k-icon k-i-more-vertical"></span>');
	                }

	                that.popup = new kendo.ui.Popup(overflowContainer, {
	                    origin: "bottom " + horizontalDirection,
	                    position: "top " + horizontalDirection,
	                    anchor: that.overflowAnchor,
	                    isRtl: isRtl,
	                    animation: that.animation,
	                    appendTo: that.isMobile ? $(that.isMobile).children(".km-pane") : null,
	                    copyAnchorStyles: false,
	                    open: function (e) {
	                        var wrapper = kendo.wrap(that.popup.element)
	                            .addClass("k-overflow-wrapper");

	                        if (!that.isMobile) {
	                            wrapper.css("margin-left", (isRtl ? -1 : 1) * ((outerWidth(wrapper) - wrapper.width()) / 2 + 1));
	                        } else {
	                            that.popup.container.css("max-height", (parseFloat($(".km-content:visible").innerHeight()) - 15) + "px");
	                        }

	                        if (that.trigger(OVERFLOW_OPEN)) {
	                            e.preventDefault();
	                        }
	                    },
	                    activate: function() {
	                        this.element.find(":kendoFocusable").first().focus();
	                    },
	                    close: function (e) {
	                        if (that.trigger(OVERFLOW_CLOSE)) {
	                            e.preventDefault();
	                        }

	                        this.element.focus();
	                    }
	                });

	                that.popup.element.on("keydown" + ns, "." + BUTTON, function(e) {
	                    var target = $(e.target),
	                        li = target.parent(),
	                        isComplexTool = li.is("." + BUTTON_GROUP) || li.is("." + SPLIT_BUTTON),
	                        element;

	                    e.preventDefault();

	                    if (e.keyCode === keys.ESC || e.keyCode === keys.TAB || (e.altKey && e.keyCode === keys.UP)) {

	                        that._toggleOverflow();
	                        that.overflowAnchor.focus();
	                    } else if (e.keyCode === keys.DOWN) {
	                        element = !isComplexTool || (isComplexTool && target.is(":last-child")) ? li : target;
	                        findFocusableSibling(element, "next").focus();
	                    } else if (e.keyCode === keys.UP) {
	                        element = !isComplexTool || (isComplexTool && target.is(":first-child")) ? li : target;
	                        findFocusableSibling(element, "prev").focus();
	                    } else if (e.keyCode === keys.SPACEBAR || e.keyCode === keys.ENTER) {
	                        that.userEvents.trigger("tap", { target: $(e.target) });
	                        that.overflowAnchor.focus();
	                    } else if (e.keyCode === keys.HOME) {
	                        li.parent().find(":kendoFocusable").first().focus();
	                    } else if (e.keyCode === keys.END) {
	                        li.parent().find(":kendoFocusable").last().focus();
	                    }
	                });

	                if (that.isMobile) {
	                    that.popup.container = that.popup.element.find("." + OVERFLOW_CONTAINER);
	                } else {
	                    that.popup.container = that.popup.element;
	                }

	                that.popup.container.attr(KENDO_UID_ATTR, this.uid);
	            },

	            _toggleOverflowAnchor: function() {
	                var hasVisibleChildren = false;
	                var paddingEnd = this._isRtl ? "padding-left" : "padding-right";

	                if (this.options.mobile) {
	                    hasVisibleChildren = this.popup.element.find("." + OVERFLOW_CONTAINER).children(":not(." + OVERFLOW_HIDDEN + ", ." + POPUP + ")").length > 0;
	                } else {
	                    hasVisibleChildren = this.popup.element.children(":not(." + OVERFLOW_HIDDEN + ", ." + POPUP + ")").length > 0;
	                }

	                if (hasVisibleChildren) {
	                    this.overflowAnchor.css({
	                        visibility: "visible",
	                        width: ""
	                    });
	                    this.wrapper.css(paddingEnd, this.overflowAnchor.outerWidth(true));
	                } else {
	                    this.overflowAnchor.css({
	                        visibility: "hidden",
	                        width: "1px"
	                    });
	                    this.wrapper.css(paddingEnd, "");
	                }
	            },

	            _buttonClick: function(e) {
	                var that = this, popup,
	                    target, item, splitContainer,
	                    isSplitButtonArrow = e.target.closest("." + SPLIT_BUTTON_ARROW).length,
	                    handler, eventData, urlTarget;

	                e.preventDefault();

	                if (isSplitButtonArrow) {
	                    that._toggle(e);
	                    return;
	                }

	                target = $(e.target).closest("." + BUTTON, that.element);

	                if (target.hasClass(OVERFLOW_ANCHOR)) {
	                    return;
	                }

	                item = target.data("button");

	                if (!item && that.popup) {
	                    target = $(e.target).closest("." + OVERFLOW_BUTTON, that.popup.container);
	                    item = target.parent("li").data("button");
	                }

	                if (!item || !item.options.enable) {
	                    return;
	                }

	                if (item.options.togglable) {
	                    handler = isFunction(item.toggleHandler) ? item.toggleHandler : null;

	                    item.toggle(!item.options.selected, true);
	                    eventData = { target: target, group: item.options.group, checked: item.options.selected, id: item.options.id, item: item };

	                    if (handler) { handler.call(that, eventData); }
	                    that.trigger(TOGGLE, eventData);
	                } else {
	                    handler = isFunction(item.clickHandler) ? item.clickHandler : null;
	                    eventData = { sender: that, target: target, id: item.options.id, item: item };

	                    if (handler) { handler.call(that, eventData); }
	                    that.trigger(CLICK, eventData);
	                }

	                if (item.options.url) {
	                    if (item.options.attributes && item.options.attributes.target) {
	                        urlTarget = item.options.attributes.target;
	                    }
	                    window.open(item.options.url, urlTarget || "_self");
	                }

	                if (target.hasClass(OVERFLOW_BUTTON)) {
	                    that.popup.close();
	                }

	                splitContainer = target.closest(".k-split-container");
	                if (splitContainer[0]) {
	                    popup = splitContainer.data("kendoPopup");
	                    (popup ? popup : splitContainer.parents(".km-popup-wrapper").data("kendoPopup")).close();
	                }
	            },

	            _navigatable: function() {
	                var that = this;

	                that.element
	                    .attr("tabindex", 0)
	                    .on("focusin" + ns, function(ev) {
	                        var target = $(ev.target);
	                        var element = $(this).find(":kendoFocusable:first");

	                        if (!target.is("." + TOOLBAR) || element.length === 0) {
	                            return;
	                        }

	                        if (element.is("." + OVERFLOW_ANCHOR)) {
	                            element = findFocusableSibling(element, "next");
	                        }

	                        if(element.length) {
	                            element[0].focus();
	                        }
	                    })
	                    .on("keydown" + ns, proxy(that._keydown, that));
	            },

	            _keydown: function(e) {
	                var target = $(e.target),
	                    keyCode = e.keyCode,
	                    items = this.element.children(":not(.k-separator):visible"),
	                    direction = this._isRtl ? -1 : 1;

	                if (keyCode === keys.TAB) {
	                    var element = target.parentsUntil(this.element).last(),
	                        lastHasFocus = false,
	                        firstHasFocus = false,
	                        isOnlyOverflowAnchor = false;

	                    if(!items.not("." + OVERFLOW_ANCHOR).length){
	                        isOnlyOverflowAnchor = true;
	                    }

	                    if (!element.length) {
	                        element = target;
	                    }

	                    if (element.is("." + OVERFLOW_ANCHOR) && !isOnlyOverflowAnchor) {
	                        var lastItemNotOverflowAnchor = items.last();

	                        if (e.shiftKey) {
	                            e.preventDefault();
	                        }

	                        if (lastItemNotOverflowAnchor.is(":kendoFocusable")) {
	                            items.last().focus();
	                        } else {
	                            items.last().find(":kendoFocusable").last().focus();
	                        }
	                    }

	                    if (!e.shiftKey && items.index(element) === items.length - 1) {
	                        if (element.is("." + BUTTON_GROUP)) {
	                            lastHasFocus = target.is(":last-child");
	                        } else {
	                            lastHasFocus = true;
	                        }
	                    }

	                    var isFirstTool = items.index(element) === items.not(".k-overflow-anchor").first().index();
	                    if (e.shiftKey && isFirstTool) {
	                        if (element.is("." + BUTTON_GROUP)) {
	                            firstHasFocus = target.is(":first-child");
	                        } else {
	                            firstHasFocus = true;
	                        }
	                    }

	                    if (lastHasFocus && this.overflowAnchor && this.overflowAnchor.css("visibility") !== "hidden" && !isOnlyOverflowAnchor) {
	                        e.preventDefault();
	                        this.overflowAnchor.focus();
	                    }

	                    if (firstHasFocus || (isOnlyOverflowAnchor && e.shiftKey)) {
	                        e.preventDefault();
	                        var prevFocusable = this._getPrevFocusable(this.wrapper);
	                        if (prevFocusable) {
	                            prevFocusable.focus();
	                        }
	                    }
	                    this._preventNextFocus = false;
	                }

	                if (e.altKey && keyCode === keys.DOWN) {
	                    var splitButton = $(document.activeElement).data("splitButton");
	                    var isOverflowAnchor = $(document.activeElement).is("." + OVERFLOW_ANCHOR);

	                    if (splitButton) {
	                        splitButton.toggle();
	                    } else if (isOverflowAnchor) {
	                        this._toggleOverflow();
	                    }

	                    return;
	                }

	                if ((keyCode === keys.SPACEBAR || keyCode === keys.ENTER) && !target.is("input, checkbox")) {

	                    if(keyCode === keys.SPACEBAR){
	                        e.preventDefault(); //prevent spacebar to scroll the page down
	                    }

	                    if (target.is("." + SPLIT_BUTTON)) {
	                        target = target.children().first();
	                        this.userEvents.trigger("tap", { target: target });
	                    } else if (keyCode === keys.SPACEBAR) {
	                        this.userEvents.trigger("tap", { target: target });
	                    }

	                    return;
	                }

	                if (keyCode === keys.HOME) {
	                    if (target.is(".k-dropdown") || target.is("input")) {
	                        return;
	                    }

	                    if (this.overflowAnchor) {
	                        items.eq(1).focus();
	                    } else {
	                        items.first().focus();
	                    }
	                    e.preventDefault();
	                } else if (keyCode === keys.END) {
	                    if (target.is(".k-dropdown") || target.is("input")) {
	                        return;
	                    }
	                    if (this.overflowAnchor && $(this.overflowAnchor).css("visibility") != "hidden") {
	                        this.overflowAnchor.focus();
	                    } else {
	                        items.last().focus();
	                    }
	                    e.preventDefault();
	                } else if (keyCode === keys.RIGHT && !this._preventNextFocus && !target.is("input, select, .k-dropdown, .k-colorpicker") && this._getNextElement(e.target, 1 * direction)) {
	                    this._getNextElement(e.target, 1 * direction).focus();
	                    e.preventDefault();
	                } else if (keyCode === keys.LEFT && !this._preventNextFocus && !target.is("input, select, .k-dropdown, .k-colorpicker") && this._getNextElement(e.target, -1 * direction)) {
	                    this._getNextElement(e.target, -1 * direction).focus();
	                    e.preventDefault();
	                }
	            },

	            _getNextElement: function (item, direction) {
	                var items = this.element.children(":not(.k-separator):visible");
	                var itemIndex = items.index(item) === -1 ? items.index(item.parentElement) : items.index(item);
	                var startIndex = this.overflowAnchor ? 1 : 0;
	                var directionNumber = direction;
	                var searchIndex = direction === 1 ? items.length - 1 : startIndex;
	                var index = direction === 1 ? startIndex : items.length - 1;
	                var focusableItem = items[itemIndex + direction];
	                this._preventNextFocus = false;

	                if ($(item).closest("." + BUTTON_GROUP).length && !$(item).is(direction === 1 ? ":last-child" : ":first-child")) {
	                    return $(item)
	                        .closest("." + BUTTON_GROUP)
	                        .children()[$(item)
	                        .closest("." + BUTTON_GROUP)
	                        .children()
	                        .index(item) + direction];
	                }

	                if (this.overflowAnchor && item === this.overflowAnchor[0] && direction === -1) {
	                    focusableItem = items[items.length - 1];
	                }

	                if (itemIndex === searchIndex) {
	                    focusableItem = !this.overflowAnchor ||
	                        (this.overflowAnchor &&
	                        $(this.overflowAnchor).css("visibility") === "hidden") ? items[index] : this.overflowAnchor;
	                }

	                while (!$(focusableItem).is(":kendoFocusable")) {
	                    if (direction === -1 && $(focusableItem).closest("." + BUTTON_GROUP).length) {
	                        focusableItem = $(focusableItem).children(":not(label, div)").last();
	                    } else {
	                        focusableItem = $(focusableItem).children(":not(label, div)").first();
	                    }
	                    if (!focusableItem.length) {
	                        directionNumber = directionNumber + direction;
	                        focusableItem = items[itemIndex + directionNumber];
	                        if (!focusableItem) {
	                            return this.overflowAnchor;
	                        }
	                    }
	                    this._preventNextFocus = $(focusableItem).closest("." + BUTTON_GROUP).length ? false : true;
	                }

	                return focusableItem;
	            },

	            _getPrevFocusable: function(element) {
	                if (element.is("html")) {
	                    return element;
	                }

	                var elementToFocus, prevElement,
	                    prevElements = element.prevAll();
	                prevElements.each(function(){
	                    prevElement = $(this);
	                    if (prevElement.is(":kendoFocusable")) {
	                        elementToFocus = prevElement;
	                        return false;
	                    } else if (prevElement.find(":kendoFocusable").length > 0) {
	                        elementToFocus = prevElement.find(":kendoFocusable").last();
	                        return false;
	                    }
	                });
	                if (elementToFocus) {
	                    return elementToFocus;
	                } else {
	                    return this._getPrevFocusable(element.parent());
	                }
	            },

	            _toggle: function(e) {
	                var splitButton = $(e.target).closest("." + SPLIT_BUTTON).data("splitButton");

	                e.preventDefault();

	                if (!splitButton.options.enable) {
	                    return;
	                }

	                splitButton.toggle();
	            },

	            _toggleOverflow: function() {
	                this.popup.toggle();
	            },

	            _resize: function(e) {
	                var containerWidth = e.width;

	                if (!this.options.resizable) {
	                    return;
	                }

	                this.popup.close();

	                this._shrink(containerWidth);
	                this._stretch(containerWidth);

	                this._markVisibles();

	                this._toggleOverflowAnchor();
	            },

	            _childrenWidth: function() {
	                var childrenWidth = 0;

	                this.element.children(":visible:not(." + STATE_HIDDEN + ", ." + SPACER_CLASS + ")").each(function() {
	                    childrenWidth += outerWidth($(this), true);
	                });

	                return Math.ceil(childrenWidth);
	            },

	            _shrink: function(containerWidth) {
	                var commandElement,
	                    visibleCommands;

	                if (containerWidth < this._childrenWidth()) {
	                    visibleCommands = this.element.children(":visible:not([data-overflow='never'], ." + OVERFLOW_ANCHOR + ")");

	                    for (var i = visibleCommands.length - 1; i >= 0; i--) {
	                        commandElement = visibleCommands.eq(i);

	                        if (containerWidth > this._childrenWidth()) {
	                            break;
	                        } else {
	                            this._hideItem(commandElement);
	                        }
	                    }
	                }
	            },

	            _stretch: function(containerWidth) {
	                var commandElement,
	                    hiddenCommands;

	                if (containerWidth > this._childrenWidth()) {
	                    hiddenCommands = this.element.children(":hidden:not('." + STATE_HIDDEN + "')");

	                    for (var i = 0; i < hiddenCommands.length ; i++) {
	                        commandElement = hiddenCommands.eq(i);
	                        if (containerWidth < this._childrenWidth() || !this._showItem(commandElement, containerWidth)) {
	                            break;
	                        }
	                    }
	                }
	            },

	            _hideItem: function(item) {
	                item.addClass(HIDDEN);

	                if (this.popup) {
	                    this.popup.container
	                        .find(">li[data-uid='" + item.data("uid") + "']")
	                        .removeClass(OVERFLOW_HIDDEN);
	                }
	            },

	            _showItem: function(item, containerWidth) {
	                // From jquery.outerWidth docs:
	                //  > jQuery will attempt to temporarily show and then re-hide an element
	                //  > in order to measure its dimensions, but this is unreliable
	                // Thus we show and hide the item
	                item.removeClass(HIDDEN);
	                var itemOuterWidth = outerWidth(item, true);
	                item.addClass(HIDDEN);

	                if (item.length && containerWidth > this._childrenWidth() + itemOuterWidth) {

	                    item.removeClass(HIDDEN);

	                    if (this.popup) {
	                        this.popup.container
	                            .find(">li[data-uid='" + item.data("uid") + "']")
	                            .addClass(OVERFLOW_HIDDEN);
	                    }

	                    return true;
	                }

	                return false;
	            },

	            _markVisibles: function() {
	                var overflowItems = this.popup.container.children(),
	                    toolbarItems = this.element.children(":not(.k-overflow-anchor)"),
	                    visibleOverflowItems = overflowItems.filter(":not(.k-overflow-hidden)"),
	                    visibleToolbarItems = toolbarItems.filter(":visible");

	                overflowItems.add(toolbarItems).removeClass(FIRST_TOOLBAR_VISIBLE + " " + LAST_TOOLBAR_VISIBLE);
	                visibleOverflowItems.first().add(visibleToolbarItems.first()).addClass(FIRST_TOOLBAR_VISIBLE);
	                visibleOverflowItems.last().add(visibleToolbarItems.last()).addClass(LAST_TOOLBAR_VISIBLE);
	            }

	        });

	    kendo.ui.plugin(ToolBar);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1048)))

/***/ })

/******/ });

/***/ }),

/***/ "ndND":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1163);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FZAa");

/***/ }),

/***/ 1111:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nK46");

/***/ }),

/***/ 1163:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1059), __webpack_require__(1088), __webpack_require__(1111) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "dataviz.treeMap",
	    name: "TreeMap",
	    category: "dataviz",
	    description: "The Kendo DataViz TreeMap",
	    depends: [ "data", "userevents", "dataviz.themes" ]
	};

	(function($, undefined) {
	    var math = Math,

	        proxy = $.proxy,
	        isArray = $.isArray,

	        kendo = window.kendo,
	        outerHeight = kendo._outerHeight,
	        outerWidth = kendo._outerWidth,
	        Class = kendo.Class,
	        Widget = kendo.ui.Widget,
	        template = kendo.template,
	        deepExtend = kendo.deepExtend,
	        HierarchicalDataSource = kendo.data.HierarchicalDataSource,
	        getter = kendo.getter,

	        dataviz = kendo.dataviz;

	    var NS = ".kendoTreeMap",
	        CHANGE = "change",
	        DATA_BOUND = "dataBound",
	        ITEM_CREATED = "itemCreated",
	        MAX_VALUE = Number.MAX_VALUE,
	        MOUSEOVER_NS = "mouseover" + NS,
	        MOUSELEAVE_NS = "mouseleave" + NS,
	        UNDEFINED = "undefined";

	    var TreeMap = Widget.extend({
	        init: function(element, options) {
	            kendo.destroy(element);
	            $(element).empty();

	            Widget.fn.init.call(this, element, options);
	            this.wrapper = this.element;

	            this._initTheme(this.options);

	            this.element.addClass("k-widget k-treemap");

	            this._setLayout();

	            this._originalOptions = deepExtend({}, this.options);

	            this._initDataSource();

	            this._attachEvents();

	            kendo.notify(this, dataviz.ui);
	        },

	        options: {
	            name: "TreeMap",
	            theme: "default",
	            autoBind: true,
	            textField: "text",
	            valueField: "value",
	            colorField: "color"
	        },

	        events: [DATA_BOUND, ITEM_CREATED],

	        _initTheme: function(options) {
	            var that = this,
	                themes = dataviz.ui.themes || {},
	                themeName = ((options || {}).theme || "").toLowerCase(),
	                themeOptions = (themes[themeName] || {}).treeMap;

	            that.options = deepExtend({}, themeOptions, options);
	        },

	        _attachEvents: function() {
	            this.element
	                .on(MOUSEOVER_NS, proxy(this._mouseover, this))
	                .on(MOUSELEAVE_NS, proxy(this._mouseleave, this));

	            this._resizeHandler = proxy(this.resize, this, false);
	            kendo.onResize(this._resizeHandler);
	        },

	        _setLayout: function() {
	            if (this.options.type === "horizontal") {
	                this._layout = new SliceAndDice(false);
	                this._view = new SliceAndDiceView(this, this.options);
	            } else if (this.options.type === "vertical") {
	                this._layout = new SliceAndDice(true);
	                this._view = new SliceAndDiceView(this, this.options);
	            } else {
	                this._layout = new Squarified();
	                this._view = new SquarifiedView(this, this.options);
	            }
	        },

	        _initDataSource: function() {
	            var that = this,
	                options = that.options,
	                dataSource = options.dataSource;

	            that._dataChangeHandler = proxy(that._onDataChange, that);

	            that.dataSource = HierarchicalDataSource
	                .create(dataSource)
	                .bind(CHANGE, that._dataChangeHandler);

	            if (dataSource) {
	                if (that.options.autoBind) {
	                    that.dataSource.fetch();
	                }
	            }
	        },

	        setDataSource: function(dataSource) {
	            var that = this;
	            that.dataSource.unbind(CHANGE, that._dataChangeHandler);
	            that.dataSource = dataSource
	                    .bind(CHANGE, that._dataChangeHandler);

	            if (dataSource) {
	                if (that.options.autoBind) {
	                    that.dataSource.fetch();
	                }
	            }
	        },

	        _onDataChange: function(e) {
	            var node = e.node;
	            var items = e.items;
	            var options = this.options;
	            var item, i;

	            if (!node) {
	                this._cleanItems();
	                this.element.empty();
	                item = this._wrapItem(items[0]);
	                this._layout.createRoot(
	                    item,
	                    outerWidth(this.element),
	                    outerHeight(this.element),
	                    this.options.type === "vertical"
	                );
	                this._view.createRoot(item);
	                // Reference of the root
	                this._root = item;
	                this._colorIdx = 0;
	            } else {
	                if (items.length) {
	                    var root = this._getByUid(node.uid);
	                    root.children = [];
	                    items = new kendo.data.Query(items)._sortForGrouping(options.valueField, "desc");

	                    for (i = 0; i < items.length; i++) {
	                        item = items[i];
	                        root.children.push(this._wrapItem(item));
	                    }

	                    var htmlSize = this._view.htmlSize(root);
	                    this._layout.compute(root.children, root.coord, htmlSize);

	                    this._setColors(root.children);
	                    this._view.render(root);
	                }
	            }

	            for (i = 0; i < items.length; i++) {
	                items[i].load();
	            }

	            if (node) {
	                this.trigger(DATA_BOUND, {
	                    node: node
	                });
	            }
	        },

	        _cleanItems: function() {
	            var that = this;
	            that.angular("cleanup", function() {
	               return { elements: that.element.find(".k-leaf div,.k-treemap-title,.k-treemap-title-vertical") };
	            });
	        },

	        _setColors: function(items) {
	            var colors = this.options.colors;
	            var colorIdx = this._colorIdx;
	            var color = colors[colorIdx % colors.length];
	            var colorRange, item;
	            if (isArray(color)) {
	                colorRange = colorsByLength(color[0], color[1], items.length);
	            }

	            var leafNodes = false;
	            for (var i = 0; i < items.length; i++) {
	                item = items[i];

	                if (!defined(item.color)) {
	                    if (colorRange) {
	                        item.color = colorRange[i];
	                    } else {
	                        item.color = color;
	                    }
	                }
	                if (!item.dataItem.hasChildren) {
	                    leafNodes = true;
	                }
	            }

	            if (leafNodes) {
	                this._colorIdx++;
	            }
	        },

	        _contentSize: function(root) {
	            this.view.renderHeight(root);
	        },

	        _wrapItem: function(item) {
	            var wrap = {};

	            if (defined(this.options.valueField)) {
	                wrap.value = getField(this.options.valueField, item);
	            }

	            if (defined(this.options.colorField)) {
	                wrap.color = getField(this.options.colorField, item);
	            }

	            if (defined(this.options.textField)) {
	                wrap.text = getField(this.options.textField, item);
	            }

	            wrap.level = item.level();

	            wrap.dataItem = item;

	            return wrap;
	        },

	        _getByUid: function(uid) {
	            var items = [this._root];
	            var item;

	            while (items.length) {
	                item = items.pop();
	                if (item.dataItem.uid === uid) {
	                    return item;
	                }

	                if (item.children) {
	                    items = items.concat(item.children);
	                }
	            }
	        },

	        dataItem: function(node) {
	            var uid = $(node).attr(kendo.attr("uid")),
	                dataSource = this.dataSource;

	            return dataSource && dataSource.getByUid(uid);
	        },

	        findByUid: function(uid) {
	            return this.element.find(".k-treemap-tile[" + kendo.attr("uid") + "='" + uid + "']");
	        },

	        _mouseover: function(e) {
	            var target = $(e.target);
	            if (target.hasClass("k-leaf")) {
	                this._removeActiveState();
	                target
	                    .removeClass("k-state-hover")
	                    .addClass("k-state-hover");
	            }
	        },

	        _removeActiveState: function() {
	            this.element
	                .find(".k-state-hover")
	                .removeClass("k-state-hover");
	        },

	        _mouseleave: function() {
	            this._removeActiveState();
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            this.element.off(NS);

	            if (this.dataSource) {
	                this.dataSource.unbind(CHANGE, this._dataChangeHandler);
	            }

	            this._root = null;
	            kendo.unbindResize(this._resizeHandler);

	            kendo.destroy(this.element);
	        },

	        items: function() {
	            return $();
	        },

	        getSize: function() {
	            return kendo.dimensions(this.element);
	        },

	        _resize: function() {
	            var root = this._root;
	            if (root) {
	                var element = this.element;
	                var rootElement = element.children();
	                root.coord.width = outerWidth(element);
	                root.coord.height = outerHeight(element);

	                rootElement.css({
	                    width: root.coord.width,
	                    height: root.coord.height
	                });

	                this._resizeItems(root, rootElement);
	            }
	        },

	        _resizeItems: function(root, element) {
	            if (root.children && root.children.length) {
	                var elements = element.children(".k-treemap-wrap").children();
	                var child, childElement;

	                this._layout.compute(root.children, root.coord, {text: this._view.titleSize(root, element)});
	                for (var idx = 0; idx < root.children.length; idx++) {
	                    child = root.children[idx];
	                    childElement = elements.filter("[" + kendo.attr("uid") + "='" + child.dataItem.uid + "']");
	                    this._view.setItemSize(child, childElement);
	                    this._resizeItems(child, childElement);
	                }
	            }
	        },

	        setOptions: function(options) {
	            var dataSource = options.dataSource;

	            options.dataSource = undefined;
	            this._originalOptions = deepExtend(this._originalOptions, options);
	            this.options = deepExtend({}, this._originalOptions);
	            this._setLayout();
	            this._initTheme(this.options);

	            Widget.fn._setEvents.call(this, options);

	            if (dataSource) {
	                this.setDataSource(HierarchicalDataSource.create(dataSource));
	            }

	            if (this.options.autoBind) {
	                this.dataSource.fetch();
	            }
	        }
	    });

	    var Squarified = Class.extend({
	        createRoot: function(root, width, height) {
	            root.coord = {
	                width: width,
	                height: height,
	                top: 0,
	                left: 0
	            };
	        },

	        leaf: function(tree) {
	            return !tree.children;
	        },

	        layoutChildren: function(items, coord) {
	            var parentArea = coord.width * coord.height;
	            var totalArea = 0,
	                itemsArea = [],
	                i;

	            for (i = 0; i < items.length; i++) {
	                itemsArea[i] = parseFloat(items[i].value);
	                totalArea += itemsArea[i];
	            }

	            for (i = 0; i < itemsArea.length; i++) {
	                items[i].area = parentArea * itemsArea[i] / totalArea;
	            }

	            var minimumSideValue = this.layoutHorizontal() ? coord.height : coord.width;

	            var firstElement = [items[0]];
	            var tail = items.slice(1);
	            this.squarify(tail, firstElement, minimumSideValue, coord);
	        },

	        squarify: function(tail, initElement, width, coord) {
	            this.computeDim(tail, initElement, width, coord);
	        },

	        computeDim: function(tail, initElement, width, coord) {
	            if (tail.length + initElement.length == 1) {
	                var element = tail.length == 1 ? tail : initElement;
	                this.layoutLast(element, width, coord);
	                return;
	            }

	            if (tail.length >= 2 && initElement.length === 0) {
	                initElement = [tail[0]];
	                tail = tail.slice(1);
	            }

	            if (tail.length === 0) {
	                if (initElement.length > 0) {
	                    this.layoutRow(initElement, width, coord);
	                }
	                return;
	            }

	            var firstElement = tail[0];

	            if (this.worstAspectRatio(initElement, width) >= this.worstAspectRatio([firstElement].concat(initElement), width)) {
	                this.computeDim(tail.slice(1), initElement.concat([firstElement]), width, coord);
	            } else {
	                var newCoords = this.layoutRow(initElement, width, coord);
	                this.computeDim(tail, [], newCoords.dim, newCoords);
	            }
	        },

	        layoutLast: function(items, w, coord) {
	            items[0].coord = coord;
	        },

	        layoutRow: function(items, width, coord) {
	            if (this.layoutHorizontal()) {
	                return this.layoutV(items, width, coord);
	            } else {
	                return this.layoutH(items, width, coord);
	            }
	        },

	        orientation: "h",

	        layoutVertical: function() {
	            return this.orientation === "v";
	        },

	        layoutHorizontal: function() {
	            return this.orientation === "h";
	        },

	        layoutChange: function() {
	            this.orientation = this.layoutVertical() ? "h" : "v";
	        },

	        worstAspectRatio: function(items, width) {
	            if (!items || items.length === 0) {
	                return MAX_VALUE;
	            }

	            var areaSum = 0,
	                maxArea = 0,
	                minArea = MAX_VALUE;

	            for (var i = 0; i < items.length; i++) {
	                var area = items[i].area;
	                areaSum += area;
	                minArea = (minArea < area) ? minArea : area;
	                maxArea = (maxArea > area) ? maxArea : area;
	            }

	            return math.max(
	                (width * width * maxArea) / (areaSum * areaSum),
	                (areaSum * areaSum) / (width * width * minArea)
	            );
	        },

	        compute: function(children, rootCoord, htmlSize) {
	            if (!(rootCoord.width >= rootCoord.height && this.layoutHorizontal())) {
	                this.layoutChange();
	            }

	            if (children && children.length > 0) {
	                var newRootCoord = {
	                    width: rootCoord.width,
	                    height: rootCoord.height - htmlSize.text,
	                    top: 0,
	                    left: 0
	                };

	                this.layoutChildren(children, newRootCoord);
	            }
	        },

	        layoutV: function(items, width, coord) {
	            var totalArea = this._totalArea(items),
	                top =  0;

	            width = round(totalArea / width);

	            for (var i = 0; i < items.length; i++) {
	                var height = round(items[i].area / width);
	                items[i].coord = {
	                    height: height,
	                    width: width,
	                    top: coord.top + top,
	                    left: coord.left
	                };

	                top += height;
	            }

	            var ans = {
	                height: coord.height,
	                width: coord.width - width,
	                top: coord.top,
	                left: coord.left + width
	            };

	            ans.dim = math.min(ans.width, ans.height);

	            if (ans.dim != ans.height) {
	                this.layoutChange();
	            }

	            return ans;
	        },

	        layoutH: function(items, width, coord) {
	            var totalArea = this._totalArea(items);

	            var height = round(totalArea / width),
	                top = coord.top,
	                left = 0;

	            for (var i=0; i<items.length; i++) {
	                items[i].coord = {
	                    height: height,
	                    width: round(items[i].area / height),
	                    top: top,
	                    left: coord.left + left
	                };
	                left += items[i].coord.width;
	            }

	            var ans = {
	                height: coord.height - height,
	                width: coord.width,
	                top: coord.top + height,
	                left: coord.left
	            };

	            ans.dim = math.min(ans.width, ans.height);

	            if (ans.dim != ans.width) {
	                this.layoutChange();
	            }

	            return ans;
	        },

	        _totalArea: function(items) {
	            var total = 0;

	            for (var i = 0; i < items.length; i++) {
	                total += items[i].area;
	            }

	            return total;
	        }
	    });

	    var SquarifiedView = Class.extend({
	        init: function(treeMap, options) {
	            this.options = deepExtend({}, this.options, options);
	            this.treeMap = treeMap;
	            this.element = $(treeMap.element);

	            this.offset = 0;
	        },

	        titleSize: function(item, element) {
	            var text = element.children(".k-treemap-title");
	            return text.height() || 0;
	        },

	        htmlSize: function(root) {
	            var rootElement = this._getByUid(root.dataItem.uid);
	            var htmlSize = {
	                text: 0
	            };

	            if (root.children) {
	                this._clean(rootElement);

	                var text = this._getText(root);
	                if (text) {
	                    var title = this._createTitle(root);
	                    rootElement.append(title);

	                    this._compile(title, root.dataItem);

	                    htmlSize.text = title.height();
	                }

	                rootElement.append(this._createWrap());

	                this.offset = (outerWidth(rootElement) - rootElement.innerWidth()) / 2;
	            }

	            return htmlSize;
	        },

	        _compile: function(element, dataItem) {
	            this.treeMap.angular("compile", function(){
	                return {
	                    elements: element,
	                    data: [ { dataItem: dataItem } ]
	                };
	            });
	        },

	        _getByUid: function(uid) {
	            return this.element.find(".k-treemap-tile[" + kendo.attr("uid") + "='" + uid + "']");
	        },

	        render: function(root) {
	            var rootElement = this._getByUid(root.dataItem.uid);
	            var children = root.children;
	            if (children) {
	                var rootWrap = rootElement.find(".k-treemap-wrap");

	                for (var i = 0; i < children.length; i++) {
	                    var leaf = children[i];
	                    var htmlElement = this._createLeaf(leaf);
	                    rootWrap.append(htmlElement);

	                    this._compile(htmlElement.children(), leaf.dataItem);

	                    this.treeMap.trigger(ITEM_CREATED, {
	                        element: htmlElement
	                    });
	                }
	            }
	        },

	        createRoot: function(root) {
	            var htmlElement = this._createLeaf(root);
	            this.element.append(htmlElement);
	            this._compile(htmlElement.children(), root.dataItem);

	            this.treeMap.trigger(ITEM_CREATED, {
	                element: htmlElement
	            });
	        },

	        _clean: function(root) {
	            this.treeMap.angular("cleanup", function() {
	                return {
	                    elements: root.children(":not(.k-treemap-wrap)")
	                };
	            });

	            root.css("background-color", "");
	            root.removeClass("k-leaf");
	            root.removeClass("k-inverse");
	            root.empty();
	        },

	        _createLeaf: function(item) {
	            return this._createTile(item)
	                    .css("background-color", item.color)
	                    .addClass("k-leaf")
	                    .toggleClass(
	                        "k-inverse",
	                        this._tileColorBrightness(item) > 180
	                    )
	                    .toggle(item.value !== 0)
	                    .append($("<div></div>")
	                    .html(this._getText(item)));
	        },

	        _createTile: function(item) {
	            var tile = $("<div class='k-treemap-tile'></div>");
	            this.setItemSize(item, tile);

	            if (defined(item.dataItem) && defined(item.dataItem.uid)) {
	                tile.attr(kendo.attr("uid"), item.dataItem.uid);
	            }

	            return tile;
	        },

	        _itemCoordinates: function(item) {
	            var coordinates = {
	                width: item.coord.width,
	                height: item.coord.height,
	                left: item.coord.left,
	                top: item.coord.top
	            };

	            if (coordinates.left && this.offset) {
	                coordinates.width += this.offset * 2;
	            } else {
	                coordinates.width += this.offset;
	            }

	            if (coordinates.top) {
	                coordinates.height += this.offset * 2;
	            } else {
	                coordinates.height += this.offset;
	            }

	            return coordinates;
	        },

	        setItemSize: function(item, element) {
	            var coordinates = this._itemCoordinates(item);
	            element.css({
	                width: coordinates.width,
	                height: coordinates.height,
	                left: coordinates.left,
	                top: coordinates.top
	            });
	        },

	        _getText: function(item) {
	            var text = item.text;

	            if (this.options.template) {
	                text = this._renderTemplate(item);
	            }

	            return text;
	        },

	        _renderTemplate: function(item) {
	            var titleTemplate = template(this.options.template);
	            return titleTemplate({
	                dataItem: item.dataItem,
	                text: item.text
	            });
	        },

	        _createTitle: function(item) {
	            return $("<div class='k-treemap-title'></div>")
	                    .append($("<div></div>").html(this._getText(item)));
	        },

	        _createWrap: function() {
	            return $("<div class='k-treemap-wrap'></div>");
	        },

	        _tileColorBrightness: function(item) {
	            return colorBrightness(item.color);
	        }
	    });

	    var SliceAndDice = Class.extend({
	        createRoot: function(root, width, height, vertical) {
	            root.coord = {
	                width: width,
	                height: height,
	                top: 0,
	                left: 0
	            };
	            root.vertical = vertical;
	        },

	        init: function(vertical) {
	            this.vertical = vertical;
	            this.quotient = vertical ? 1 : 0;
	        },

	        compute: function(children, rootCoord, htmlSize) {

	            if (children.length > 0) {
	                var width = rootCoord.width;
	                var height = rootCoord.height;

	                if (this.vertical) {
	                    height -= htmlSize.text;
	                } else {
	                    width -= htmlSize.text;
	                }

	                var newRootCoord = {
	                    width: width,
	                    height: height,
	                    top: 0,
	                    left: 0
	                };

	                this.layoutChildren(children, newRootCoord);
	            }
	        },

	        layoutChildren: function(items, coord) {
	            var parentArea = coord.width * coord.height;
	            var totalArea = 0;
	            var itemsArea = [];
	            var i;

	            for (i = 0; i < items.length; i++) {
	                var item = items[i];
	                itemsArea[i] = parseFloat(items[i].value);
	                totalArea += itemsArea[i];
	                item.vertical = this.vertical;
	            }

	            for (i = 0; i < itemsArea.length; i++) {
	                items[i].area = parentArea * itemsArea[i] / totalArea;
	            }

	            this.sliceAndDice(items, coord);
	        },

	        sliceAndDice: function(items, coord) {
	            var totalArea = this._totalArea(items);
	            if (items[0].level % 2 === this.quotient) {
	                this.layoutHorizontal(items, coord, totalArea);
	            } else {
	                this.layoutVertical(items, coord, totalArea);
	            }
	        },

	        layoutHorizontal: function(items, coord, totalArea) {
	            var left = 0;

	            for (var i = 0; i < items.length; i++) {
	                var item = items[i];
	                var width = item.area / (totalArea / coord.width);
	                item.coord = {
	                    height: coord.height,
	                    width: width,
	                    top: coord.top,
	                    left: coord.left + left
	                };

	                left += width;
	            }
	        },

	        layoutVertical: function(items, coord, totalArea) {
	            var top = 0;

	            for (var i = 0; i < items.length; i++) {
	                var item = items[i];
	                var height = item.area / (totalArea / coord.height);
	                item.coord = {
	                    height: height,
	                    width: coord.width,
	                    top: coord.top + top,
	                    left: coord.left
	                };

	                top += height;
	            }
	        },

	        _totalArea: function(items) {
	            var total = 0;

	            for (var i = 0; i < items.length; i++) {
	                total += items[i].area;
	            }

	            return total;
	        }
	    });

	    var SliceAndDiceView = SquarifiedView.extend({
	        htmlSize: function(root) {
	            var rootElement = this._getByUid(root.dataItem.uid);
	            var htmlSize = {
	                text: 0,
	                offset: 0
	            };

	            if (root.children) {
	                this._clean(rootElement);

	                var text = this._getText(root);
	                if (text) {
	                    var title = this._createTitle(root);
	                    rootElement.append(title);
	                    this._compile(title, root.dataItem);

	                    if (root.vertical) {
	                        htmlSize.text = title.height();
	                    } else {
	                        htmlSize.text = title.width();
	                    }
	                }

	                rootElement.append(this._createWrap());

	                this.offset = (outerWidth(rootElement) - rootElement.innerWidth()) / 2;
	            }

	            return htmlSize;
	        },

	        titleSize: function(item, element) {
	            var size;
	            if (item.vertical) {
	               size = element.children(".k-treemap-title").height();
	            } else {
	               size = element.children(".k-treemap-title-vertical").width();
	            }
	            return size || 0;
	        },

	        _createTitle: function(item) {
	            var title;
	            if (item.vertical) {
	                title = $("<div class='k-treemap-title'></div>");
	            } else {
	                title = $("<div class='k-treemap-title-vertical'></div>");
	            }

	            return title.append($("<div></div>").html(this._getText(item)));
	        }
	    });

	    function getField(field, row) {
	        if (row === null) {
	            return row;
	        }

	        var get = getter(field, true);
	        return get(row);
	    }

	    function defined(value) {
	        return typeof value !== UNDEFINED;
	    }

	    function colorsByLength(min, max, length) {
	        var minRGBtoDecimal = rgbToDecimal(min);
	        var maxRGBtoDecimal = rgbToDecimal(max);
	        var isDarker = colorBrightness(min) - colorBrightness(max) < 0;
	        var colors = [];

	        colors.push(min);

	        for (var i = 0; i < length; i++) {
	            var rgbColor = {
	                r: colorByIndex(minRGBtoDecimal.r, maxRGBtoDecimal.r, i, length, isDarker),
	                g: colorByIndex(minRGBtoDecimal.g, maxRGBtoDecimal.g, i, length, isDarker),
	                b: colorByIndex(minRGBtoDecimal.b, maxRGBtoDecimal.b, i, length, isDarker)
	            };
	            colors.push(buildColorFromRGB(rgbColor));
	        }

	        colors.push(max);

	        return colors;
	    }

	    function colorByIndex(min, max, index, length, isDarker) {
	        var minColor = math.min(math.abs(min), math.abs(max));
	        var maxColor = math.max(math.abs(min), math.abs(max));
	        var step = (maxColor - minColor) / (length + 1);
	        var currentStep = step * (index + 1);
	        var color;

	        if (isDarker) {
	            color = minColor + currentStep;
	        } else {
	            color = maxColor - currentStep;
	        }

	        return color;
	    }

	    function buildColorFromRGB(color) {
	        return "#" + decimalToRgb(color.r) + decimalToRgb(color.g) + decimalToRgb(color.b);
	    }

	    function rgbToDecimal(color) {
	        color = color.replace("#", "");
	        var rgbColor = colorToRGB(color);

	        return {
	            r: rgbToHex(rgbColor.r),
	            g: rgbToHex(rgbColor.g),
	            b: rgbToHex(rgbColor.b)
	        };
	    }

	    function decimalToRgb(number) {
	        var result = math.round(number).toString(16).toUpperCase();

	        if (result.length === 1) {
	            result = "0" + result;
	        }

	        return result;
	    }

	    function colorToRGB(color) {
	        var colorLength = color.length;
	        var rgbColor = {};
	        if (colorLength === 3) {
	            rgbColor.r = color[0];
	            rgbColor.g = color[1];
	            rgbColor.b = color[2];
	        } else {
	            rgbColor.r = color.substring(0, 2);
	            rgbColor.g = color.substring(2, 4);
	            rgbColor.b = color.substring(4, 6);
	        }

	        return rgbColor;
	    }

	    function rgbToHex(rgb) {
	        return parseInt(rgb.toString(16), 16);
	    }

	    function colorBrightness(color) {
	        var brightness = 0;
	        if (color) {
	            color = rgbToDecimal(color);
	            brightness = math.sqrt(0.241 * color.r * color.r + 0.691 * color.g * color.g + 0.068 * color.b * color.b);
	        }

	        return brightness;
	    }

	    function round(value) {
	        var power = math.pow(10, 4);
	        return math.round(value * power) / power;
	    }

	    dataviz.ui.plugin(TreeMap);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "nky/":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1595);
	module.exports = __webpack_require__(1595);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 948:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Fv0e");

/***/ }),

/***/ 1595:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20), __webpack_require__(948), __webpack_require__(1596), __webpack_require__(1597) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	    "use strict";

	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    /* global JSZip */

	    // WARNING: removing the following jshint declaration and turning
	    // == into === to make JSHint happy will break functionality.
	    /* jshint eqnull:true, laxbreak:true */
	    /* jshint latedef: nofunc */

	    var $ = kendo.jQuery;
	    var parseXML = kendo.util.parseXML;
	    var parseReference = kendo.spreadsheet.calc.parseReference;

	    var MAP_EXCEL_OPERATOR = {
	        // includes only what differs; key is Excel's operator, value
	        // is our operator.
	        greaterThanOrEqual : "greaterThanOrEqualTo",
	        lessThanOrEqual    : "lessThanOrEqualTo"
	    };

	    var ERROR_LOG = null;

	    function readExcel(file, workbook, deferred) {
	        var reader = new FileReader();
	        reader.onload = function(e) {
	            var zip = new JSZip(e.target.result);
	            readWorkbook(zip, workbook, deferred);
	        };

	        reader.readAsArrayBuffer(file);
	    }

	    var SEL_CELL = ["sheetData", "row", "c"];
	    var SEL_COL = ["cols", "col"];
	    var SEL_DEFINED_NAME = ["definedNames", "definedName"];
	    var SEL_FORMULA = ["sheetData", "row", "c", "f"];
	    var SEL_MERGE = ["mergeCells", "mergeCell"];
	    var SEL_PANE = ["sheetViews", "sheetView", "pane"];
	    var SEL_ROW = ["sheetData", "row"];
	    var SEL_SELECTION = ["sheetViews", "sheetView", "selection"];
	    var SEL_SHEET = ["sheets", "sheet"];
	    var SEL_STRING = ["sheetData", "row", "c", "is"];
	    var SEL_TEXT = ["t"];
	    var SEL_SHARED_STRING = ["si"];
	    var SEL_VALUE = ["sheetData", "row", "c", "v"];
	    var SEL_VIEW = ["bookViews", "workbookView"];
	    var SEL_SHEET_VIEW = ["sheetViews", "sheetView"];
	    var SEL_HYPERLINK = ["hyperlinks", "hyperlink"];

	    /* A validation section looks like this:
	     *
	     * <dataValidations count="1">
	     *   <dataValidation type="list" allowBlank="1" showInputMessage="1" showErrorMessage="1" sqref="B2">
	     *     <formula1>$E$2:$E$5</formula1>
	     *   </dataValidation>
	     * </dataValidations>
	     */
	    var SEL_VALIDATION = ["dataValidations", "dataValidation"];
	    var SEL_VALIDATION_FORMULA1 = ["dataValidations", "dataValidation", "formula1"];
	    var SEL_VALIDATION_FORMULA2 = ["dataValidations", "dataValidation", "formula2"];

	    /* However, when a validation formula in one sheet references
	     * cells from another sheet, Excel produces this version instead:
	     *
	     * <extLst>
	     *   <ext xmlns:x14="http://schemas.microsoft.com/office/spreadsheetml/2009/9/main" uri="{CCE6A557-97BC-4b89-ADB6-D9C93CAAB3DF}">
	     *     <x14:dataValidations xmlns:xm="http://schemas.microsoft.com/office/excel/2006/main" count="1">
	     *       <x14:dataValidation type="list" allowBlank="1" showInputMessage="1" showErrorMessage="1">
	     *         <x14:formula1>
	     *           <xm:f>Sheet2!$B$3:$B$6</xm:f>
	     *         </x14:formula1>
	     *         <xm:sqref>B1</xm:sqref>
	     *       </x14:dataValidation>
	     *     </x14:dataValidations>
	     *   </ext>
	     * </extLst>
	     *
	     * I call it the "insane version", because that's what it is.
	     * Barring the case that the engineers who produced this horror
	     * were on LSD, the only plausible reason for it is that Microsoft
	     * does not want third party software to be compatible with Excel
	     * (sentiment I've had over and over while working on the
	     * Spreadsheet widget).
	     */
	    // XXX: technically, the aliases `x14` and `xm` below could be
	    // different, but Excel seems to be hard-coded on these; our
	    // parser does not support proper namespaces for now anyway, so
	    // hard-coded they are.
	    var SEL_VALIDATION_INSANE = ["x14:dataValidations", "x14:dataValidation"];
	    var SEL_VALIDATION_SQREF_INSANE = ["x14:dataValidations", "x14:dataValidation", "xm:sqref"];
	    var SEL_VALIDATION_FORMULA1_INSANE = ["x14:dataValidations", "x14:dataValidation", "x14:formula1", "xm:f"];
	    var SEL_VALIDATION_FORMULA2_INSANE = ["x14:dataValidations", "x14:dataValidation", "x14:formula2", "xm:f"];

	    // comment selectors (in files like comments1.xml)
	    var SEL_COMMENT = ["commentList", "comment"];
	    var SEL_AUTHOR = ["authors", "author"];
	    var SEL_COMMENT_TEXT = ["t"];

	    function xl(file) {
	        if (!/^\//.test(file)) {
	            if (!/^xl\//.test(file)) {
	                file = "xl/" + file;
	            }
	        } else {
	            file = file.substr(1);
	        }
	        return file;
	    }

	    function readWorkbook(zip, workbook, progress) {
	        ERROR_LOG = workbook.excelImportErrors = [];

	        var strings = readStrings(zip);
	        var relationships = readRelationships(zip, "_rels/workbook.xml");
	        var theme = readTheme(zip, relationships.byType.theme[0]);
	        var styles = readStyles(zip, theme);
	        var items = [];
	        var activeSheet = 0;

	        parse(zip, "xl/workbook.xml", {
	            enter: function(tag, attrs) {
	                if (this.is(SEL_SHEET)) {
	                    var relId = attrs["r:id"];
	                    var file = relationships.byId[relId];
	                    var name = attrs.name;
	                    var dim = sheetDimensions(zip, file);

	                    workbook.options.columnWidth = dim.columnWidth || workbook.options.columnWidth;
	                    workbook.options.rowHeight = dim.rowHeight || workbook.options.rowHeight;

	                    items.push({
	                        workbook: workbook,
	                        zip: zip,
	                        strings: strings,
	                        styles: styles,
	                        file: file,
	                        options: {
	                            name: name,
	                            rows: Math.max(workbook.options.rows || 0, dim.rows),
	                            columns: Math.max(workbook.options.columns || 0, dim.cols),
	                            columnWidth: dim.columnWidth,
	                            rowHeight: dim.rowHeight
	                        }
	                    });
	                } else if (this.is(SEL_VIEW)) {
	                    if (attrs.activeTab) {
	                        activeSheet = integer(attrs.activeTab);
	                    }
	                }
	            },
	            text: function(text) {
	                var attrs = this.is(SEL_DEFINED_NAME);
	                if (attrs && !(bool(attrs["function"]) || bool(attrs.vbProcedure))) {
	                    var localSheetId = attrs.localSheetId;
	                    var sheet = null;
	                    if (localSheetId != null) {
	                        sheet = items[localSheetId].options.name;
	                    }
	                    var name = attrs.name;
	                    if (name != "_xlnm._FilterDatabase") {
	                        if (sheet) {
	                            name = "'" + sheet.replace(/\'/g, "\\'") + "'!" + name;
	                        }
	                        withErrorLog(sheet, null, function(){
	                            workbook.defineName(name, text, bool(attrs.hidden));
	                        }, "reading user-defined name: " + name);
	                    }
	                }
	            }
	        });

	        var loading = new $.Deferred();
	        loading.progress(function(args) {
	            if (progress) {
	                progress.notify(args);
	            }
	        })
	        .then(function() {
	            var sheets = workbook.sheets();
	            recalcSheets(sheets);

	            workbook.activeSheet(sheets[activeSheet]);

	            if (progress) {
	                progress.resolve();
	            }
	        });

	        loadSheets(items, workbook, loading);
	    }

	    function loadSheets(items, workbook, progress) {
	        var ready = (new $.Deferred()).resolve();
	        for (var i = 0; i < items.length; i++) {
	            /*jshint -W083 */
	            (function(entry, i) {
	                ready = ready.then(function() {
	                    var sheet = workbook.insertSheet(entry.options);
	                    sheet.suspendChanges(true);

	                    var promise = queueSheet(sheet, entry);
	                    var args = {
	                        sheet: sheet,
	                        progress: i / (items.length - 1)
	                    };

	                    promise.then(function() {
	                        progress.notify(args);
	                    });

	                    return promise;
	                });
	            })(items[i], i);
	        }

	        ready.then(function() {
	            progress.resolve();
	        });
	    }

	    function queueSheet(sheet, ctx) {
	        var deferred = new $.Deferred();

	        setTimeout(function() {
	            readSheet(ctx.zip, ctx.file, sheet, ctx.strings, ctx.styles);
	            deferred.resolve();
	        }, 0);

	        return deferred;
	    }

	    function recalcSheets(sheets) {
	        for (var i = 0; i < sheets.length; i++) {
	            sheets[i]
	                .suspendChanges(false)
	                .triggerChange({ recalc: true });
	        }
	    }

	    function sheetDimensions(zip, file) {
	        var dim = {
	            rows: 0,
	            cols: 0
	        };

	        parse(zip, xl(file), {
	            enter: function(tag, attrs) {
	                if (tag == "dimension") {
	                    var ref = parseReference(attrs.ref);
	                    if (ref.bottomRight) {
	                        dim.cols = ref.bottomRight.col + 1;
	                        dim.rows = ref.bottomRight.row + 1;
	                    }
	                } else if (tag === "sheetFormatPr") {
	                    if (attrs.defaultColWidth) {
	                        dim.columnWidth = toColWidth(parseFloat(attrs.defaultColWidth));
	                    }

	                    if (attrs.defaultRowHeight) {
	                        dim.rowHeight = toRowHeight(parseFloat(attrs.defaultRowHeight));
	                    }
	                } else if (this.is(SEL_ROW)) {
	                    // Don't process actual rows
	                    this.exit();
	                }
	            }
	        });

	        return dim;
	    }

	    function toColWidth(size) {
	        // No font to compute agains, hence the magic number
	        var maximumDigitWidth = 7;

	        // The formula below is taken from the OOXML spec
	        var fraction = (256 * size + Math.floor(128 / maximumDigitWidth)) / 256;
	        return fraction * maximumDigitWidth;
	    }

	    function toRowHeight(pts) {
	        return pts * (4 / 3);
	    }

	    function readSheet(zip, file, sheet, strings, styles) {
	        var sharedFormulas = {};
	        var ref, type, value, formula, formulaRange, isArrayFormula;
	        var nCols = sheet._columns._count;
	        var prevCellRef = null;
	        var relsFile = file.replace(/worksheets\//, "worksheets/_rels/");
	        var relationships = readRelationships(zip, relsFile);
	        var formula1, formula2;

	        var filterRef;
	        var filterColumn;
	        var customFilterLogic;
	        var customFilterCriteria;
	        var valueFilterBlanks;
	        var valueFilterValues;
	        var filters = [];

	        ERROR_LOG = sheet._workbook.excelImportErrors;

	        file = xl(file);

	        parse(zip, file, {
	            enter: function(tag, attrs, closed) {
	                var tmp;
	                if (this.is(SEL_FORMULA)) {
	                    if (closed) {
	                        if (attrs.t == "shared" && attrs.si != null) {
	                            formula = sheet.range(sharedFormulas[attrs.si])._get("formula");
	                        }
	                    }
	                }
	                else if (this.is(SEL_CELL)) {
	                    value = null;
	                    formula = null;
	                    ref = attrs.r;
	                    formulaRange = null;

	                    if (ref == null) {
	                        // apparently some tools omit the `r` for
	                        // consecutive cells in a row, so we'll figure
	                        // it out from the previous cell's reference.
	                        // XXX: this could be slightly optimized by
	                        // keeping it parsed instead of stringifying
	                        // it to parse it again later.
	                        ref = parseReference(prevCellRef);
	                        ref.col++;
	                        ref = ref.toString();
	                    }
	                    prevCellRef = ref;

	                    // XXX: can't find no type actually, so everything is
	                    // interpreted as string.  Additionally, cells having
	                    // a formula will contain both <f> and <v> nodes,
	                    // which makes the value take precedence because it's
	                    // the second node; hence, the hack is to keep note of
	                    // them in the `text` handler, and apply the
	                    // appropriate one in the `leave` handler below.
	                    type = attrs.t;

	                    var styleIndex = attrs.s;
	                    if (styleIndex != null) {
	                        applyStyle(sheet, ref, styles, styleIndex);
	                    }
	                }
	                else if (this.is(SEL_MERGE)) {
	                    sheet.range(attrs.ref).merge();
	                }
	                else if (this.is(SEL_COL)) {
	                    var start = integer(attrs.min) - 1;
	                    var stop = Math.min(nCols, integer(attrs.max)) - 1;
	                    var width;
	                    if (attrs.width) {
	                        width = toColWidth(parseFloat(attrs.width));
	                        if (width !== 0) {
	                            sheet._columns.values.value(start, stop, width);
	                        }
	                    }
	                    if (attrs.hidden === "1" || width === 0) {
	                        for (var ci = start; ci <= stop; ci++) {
	                            sheet.hideColumn(ci);
	                        }
	                    }
	                    if (attrs.style != null) {
	                        // apply style on a whole range of columns
	                        applyStyle(sheet, new kendo.spreadsheet.RangeRef(
	                            new kendo.spreadsheet.CellRef(-Infinity, start),
	                            new kendo.spreadsheet.CellRef(+Infinity, stop)
	                        ), styles, attrs.style);
	                    }
	                }
	                else if (this.is(SEL_ROW)) {
	                    var row = integer(attrs.r) - 1;
	                    var height;
	                    if (attrs.ht) {
	                        height = toRowHeight(parseFloat(attrs.ht));
	                        if (height !== 0) {
	                            sheet._rows.values.value(row, row, height);
	                        }
	                    }
	                    if (attrs.hidden === "1" || height === 0) {
	                        sheet.hideRow(row);
	                    }
	                }
	                else if (this.is(SEL_SELECTION)) {
	                    if (attrs.activeCell) {
	                        var acRef = parseReference(attrs.activeCell);
	                        sheet.select(acRef, true);
	                    }
	                }
	                else if (this.is(SEL_PANE)) {
	                    if (attrs.state == "frozen") {
	                        if (attrs.xSplit) {
	                            sheet.frozenColumns(integer(attrs.xSplit));
	                        }

	                        if (attrs.ySplit) {
	                            sheet.frozenRows(integer(attrs.ySplit));
	                        }
	                    }
	                }
	                else if (this.is(SEL_SHEET_VIEW)) {
	                    sheet.showGridLines(bool(attrs.showGridLines, true));
	                }
	                else if (this.is(SEL_HYPERLINK)) {
	                    var relId = attrs["r:id"];
	                    var target = relationships.byId[relId];
	                    if (target) {
	                        sheet.range(attrs.ref).link(target);
	                    }
	                }
	                else if (this.is(["autoFilter"])) {
	                    filterRef = attrs.ref;
	                    if (closed) {
	                        addAutoFilter();
	                    }
	                }
	                else if (filterRef) {
	                    if (this.is(["filterColumn"])) {
	                        filterColumn = parseInt(attrs.colId, 10);
	                    }
	                    else if (this.is(["customFilters"])) {
	                        customFilterLogic = bool(attrs.and) ? "and" : "or";
	                        customFilterCriteria = [];
	                    }
	                    else if (this.is(["customFilter"])) {
	                        tmp = getCustomFilter(attrs.operator, attrs.val);
	                        if (tmp) {
	                            customFilterCriteria.push({
	                                operator: tmp.operator,
	                                value: tmp.value
	                            });
	                        }
	                    }
	                    else if (this.is(["dynamicFilter"])) {
	                        filters.push({
	                            column: filterColumn,
	                            filter: new kendo.spreadsheet.DynamicFilter({
	                                type: dynamicFilterType(attrs.type)
	                            })
	                        });
	                    }
	                    else if (this.is(["top10"])) {
	                        filters.push({
	                            column: filterColumn,
	                            filter: new kendo.spreadsheet.TopFilter({
	                                value: getFilterVal(attrs.val),
	                                type: (function(percent, top){
	                                    return percent && top ? "topPercent"
	                                        :  top ? "topNumber"
	                                        :  percent ? "bottomPercent"
	                                        :  "bottomNumber";
	                                })(bool(attrs.percent), bool(attrs.top))
	                            })
	                        });
	                    }
	                    else if (this.is(["filters"])) {
	                        valueFilterBlanks = bool(attrs.blank);
	                        valueFilterValues = [];
	                    }
	                    else if (this.is(["filter"])) {
	                        valueFilterValues.push(getFilterVal(attrs.val));
	                    }
	                }
	            },
	            leave: function(tag, attrs) {
	                if (this.is(SEL_FORMULA)) {
	                    if (!formula && attrs.t == "shared" && attrs.si != null) {
	                        formula = sheet.range(sharedFormulas[attrs.si])._get("formula");
	                    }
	                }
	                else if (this.is(SEL_CELL)) {
	                    if (formula != null) {
	                        var failed = withErrorLog(sheet, formulaRange || ref, function(){
	                            sheet.range(formulaRange || ref).formula(formula, isArrayFormula);
	                        }, "parsing formula");
	                        if (failed) {
	                            sheet.range(formulaRange || ref).value(formula)
	                                .background("#ffaaaa");
	                        }
	                    } else if (value != null) {
	                        var range = sheet.range(ref);

	                        if (!range._get("formula")) {
	                            // Check for "shared" formulas before applying a value.
	                            if (!type || type == "n") {
	                                value = parseFloat(value);
	                            } else if (type == "s") {
	                                value = strings[integer(value)];
	                            } else if (type == "b") {
	                                value = value === "1";
	                            } else if (type == "d") {
	                                value = kendo.parseDate(value);
	                            }

	                            if (value != null) {
	                                range.value(value);
	                            }
	                        }
	                    }
	                } else if (this.is(SEL_VALIDATION) ||
	                           this.is(SEL_VALIDATION_INSANE)) {
	                    (function(){
	                        var refs = kendo.spreadsheet.calc.parseSqref(attrs.sqref);
	                        var type = attrs.type.toLowerCase();
	                        var operator = attrs.operator;
	                        if (/^(?:whole|decimal)$/.test(type)) {
	                            // we only support "number"
	                            type = "number";
	                        } else if (type == "list") {
	                            // there'll be no operator from Excel for lists
	                            operator = "list";
	                        }
	                        if (!operator && /^(?:number|date)$/.test(type)) {
	                            // Excel skips setting the operator for
	                            // "between", because why not.
	                            operator = "between";
	                        }
	                        refs.forEach(function(ref){
	                            withErrorLog(sheet, ref, function(){
	                                sheet.range(ref).validation({
	                                    type             : bool(attrs.showErrorMessage, true) ? "reject" : "warning",
	                                    from             : formula1,
	                                    to               : formula2,
	                                    dataType         : type,
	                                    comparerType     : MAP_EXCEL_OPERATOR[operator] || operator,
	                                    allowNulls       : bool(attrs.allowBlank),
	                                    showButton       : bool(attrs.showDropDown) || type == "date" || type == "list",
	                                    messageTemplate  : attrs.error,
	                                    titleTemplate    : attrs.errorTitle
	                                });
	                            }, "parsing validation");
	                        });
	                    })();
	                } else if (tag == "cols") {
	                    sheet._columns._refresh();
	                } else if (tag == "sheetData") {
	                    sheet._rows._refresh();
	                } else if (tag == "autoFilter") {
	                    addAutoFilter();
	                } else if (filterRef) {
	                    if (tag == "customFilters") {
	                        filters.push({
	                            column: filterColumn,
	                            filter: new kendo.spreadsheet.CustomFilter({
	                                logic: customFilterLogic,
	                                criteria: customFilterCriteria
	                            })
	                        });
	                    } else if (tag == "filters") {
	                        filters.push({
	                            column: filterColumn,
	                            filter: new kendo.spreadsheet.ValueFilter({
	                                values: valueFilterValues,
	                                blanks: valueFilterBlanks
	                            })
	                        });
	                    }
	                }
	            },
	            text: function(text) {
	                var attrs;
	                if (this.is(SEL_VALUE) || this.is(SEL_STRING)) {
	                    value = text;
	                } else if ((attrs = this.is(SEL_FORMULA))) {
	                    formula = text;
	                    isArrayFormula = attrs.t == "array";
	                    if (isArrayFormula) {
	                        formulaRange = attrs.ref;
	                    } else if (attrs.t == "shared") {
	                        sharedFormulas[attrs.si] = ref;
	                    }
	                } else if (this.is(SEL_VALIDATION_FORMULA1) ||
	                           this.is(SEL_VALIDATION_FORMULA1_INSANE)) {
	                    formula1 = text;
	                } else if (this.is(SEL_VALIDATION_FORMULA2) ||
	                           this.is(SEL_VALIDATION_FORMULA2_INSANE)) {
	                    formula2 = text;
	                } else if (this.is(SEL_VALIDATION_SQREF_INSANE)) {
	                    // put it in <dataValidation>'s attributes where it should be
	                    this.stack[this.stack.length - 2].sqref = text;
	                }
	            }
	        });

	        if (relationships.byType.comments) {
	            var commentFile = relative_file(file, relationships.byType.comments[0]);
	            readComments(zip, commentFile, sheet);
	        }

	        if (relationships.byType.drawing) {
	            var drawingFile = relative_file(file, relationships.byType.drawing[0]);
	            readDrawings(zip, drawingFile, sheet);
	        }

	        function addAutoFilter() {
	            sheet.range(filterRef).filter(filters);
	            filterRef = null;
	        }
	    }

	    function getContentType(filename) {
	        var m = /\.([^.]+)$/.exec(filename);
	        if (m && m[1]) {
	            return {
	                jpg  : "image/jpeg",
	                jpeg : "image/jpeg",
	                png  : "image/png",
	                gif  : "image/gif"
	            }[m[1].toLowerCase()];
	        }
	    }

	    function getFileName(filename) {
	        var m = /[^/]+$/.exec(filename);
	        return m && m[0];
	    }

	    function readDrawings(zip, file, sheet) {
	        var sel_two_cell_anchor = [ "xdr:twoCellAnchor" ];
	        var sel_ext = [ "xdr:ext" ];
	        var sel_one_cell_anchor = [ "xdr:oneCellAnchor" ];
	        var sel_from = [ "xdr:from" ];
	        var sel_to = [ "xdr:to" ];
	        var sel_row = [ "xdr:row" ];
	        var sel_col = [ "xdr:col" ];
	        var sel_row_offset = [ "xdr:rowOff" ];
	        var sel_col_offset = [ "xdr:colOff" ];
	        var sel_blip = [ "xdr:blipFill", "a:blip" ];

	        var relsFile = file.replace(/drawings\//, "drawings/_rels/");
	        var relationships = readRelationships(zip, relsFile);

	        if (relationships.byType.image) {
	            Object.keys(relationships.byId).forEach(function(id){
	                var img = relative_file(file, relationships.byId[id]);
	                var type = getContentType(img);

	                if (type) {
	                    // XXX: file.asArrayBuffer() is deprecated in JSZip 3
	                    var data = zip.files[img].asArrayBuffer();
	                    var name = getFileName(img);
	                    var blob = name && !(kendo.support.browser.msie || kendo.support.browser.edge)
	                        ? new window.File([ data ], name, { type: type })
	                        : new window.Blob([ data ], { type: type });
	                    relationships.byId[id] = sheet._workbook.addImage(blob);
	                }
	            });
	        }

	        var cdr, ref, width, height;
	        parse(zip, file, {
	            enter: function(tag, attrs) {
	                if (this.is(sel_two_cell_anchor) || this.is(sel_one_cell_anchor)) {
	                    cdr = {};
	                }
	                else if (this.is(sel_from) || this.is(sel_to)) {
	                    ref = {};
	                }
	                else if (this.is(sel_blip)) {
	                    var id = attrs["r:embed"];
	                    cdr.image = relationships.byId[id];
	                }
	                else if (this.is(sel_ext)) {
	                    width = excelToPixels(parseFloat(attrs.cx));
	                    height = excelToPixels(parseFloat(attrs.cy));
	                }
	            },
	            leave: function() {
	                if (this.is(sel_from)) {
	                    cdr.topLeftCell = new kendo.spreadsheet.CellRef(ref.row, ref.col);
	                    cdr.offsetX = excelToPixels(ref.colOffset);
	                    cdr.offsetY = excelToPixels(ref.rowOffset);
	                }
	                else if (this.is(sel_to)) {
	                    cdr.brCell = new kendo.spreadsheet.CellRef(ref.row, ref.col);
	                    cdr.brX = excelToPixels(ref.colOffset);
	                    cdr.brY = excelToPixels(ref.rowOffset);
	                }
	                // Add drawing only when it is image
	                else if (this.is(sel_two_cell_anchor) && cdr.image) {
	                    var left = sheet._columns.sum(0, cdr.topLeftCell.col - 1) + cdr.offsetX;
	                    var top = sheet._rows.sum(0, cdr.topLeftCell.row - 1) + cdr.offsetY;
	                    var right = sheet._columns.sum(0, cdr.brCell.col - 1) + cdr.brX;
	                    var bottom = sheet._rows.sum(0, cdr.brCell.row - 1) + cdr.brY;

	                    sheet.addDrawing({
	                        topLeftCell : cdr.topLeftCell,
	                        offsetX     : cdr.offsetX,
	                        offsetY     : cdr.offsetY,
	                        width       : width != null ? width : right - left,
	                        height      : height != null ? height : bottom - top,
	                        image       : cdr.image,
	                        opacity     : 1
	                    });
	                }
	                // Add drawing only when it is image
	                else if (this.is(sel_one_cell_anchor) && cdr.image) {
	                    sheet.addDrawing({
	                        topLeftCell : cdr.topLeftCell,
	                        offsetX     : cdr.offsetX,
	                        offsetY     : cdr.offsetY,
	                        width       : width,
	                        height      : height,
	                        image       : cdr.image,
	                        opacity     : 1
	                    });
	                }
	            },
	            text: function(text) {
	                if (this.is(sel_row)) {
	                    ref.row = parseFloat(text);
	                }
	                else if (this.is(sel_col)) {
	                    ref.col = parseFloat(text);
	                }
	                else if (this.is(sel_row_offset)) {
	                    ref.rowOffset = parseFloat(text);
	                }
	                else if (this.is(sel_col_offset)) {
	                    ref.colOffset = parseFloat(text);
	                }
	            }
	        });
	    }

	    function readComments(zip, file, sheet) {
	        var authors = [];
	        var author;
	        var comment;
	        parse(zip, file, {
	            enter: function(tag, attrs) {
	                if (this.is(SEL_COMMENT)) {
	                    comment = {
	                        author: authors[attrs.authorId],
	                        ref: attrs.ref,
	                        text: ""
	                    };
	                } else if (this.is(SEL_AUTHOR)) {
	                    author = "";
	                }
	            },
	            leave: function() {
	                if (this.is(SEL_COMMENT)) {
	                    sheet.range(comment.ref).comment(comment.text);
	                } else if (this.is(SEL_AUTHOR)) {
	                    authors.push(author);
	                }
	            },
	            text: function(text) {
	                if (this.is(SEL_COMMENT_TEXT)) {
	                    comment.text += text;
	                } else if (this.is(SEL_AUTHOR)) {
	                    author += text;
	                }
	            }
	        });
	    }

	    function getCustomFilter(op, value) {
	        var ourOp = {
	            equal               : "eq",
	            notEqual            : "ne",
	            greaterThan         : "gt",
	            greaterThanOrEqual  : "gte",
	            lessThan            : "lt",
	            lessThanOrEqual     : "lte"
	        }[op];

	        value = getFilterVal(value);

	        if (ourOp && typeof value == "number") {
	            return { operator: ourOp, value: value };
	        }

	        if ((op == "notEqual" || !op) && typeof value == "string") {
	            // Excel text operators support * and ? wildcards.  Since
	            // our startswith/endswith/contains filters do not, we
	            // can't really use them here, so we'll apply the more
	            // generic "matches" and "doesnotmatch" filters.
	            return {
	                operator: op ? "doesnotmatch" : "matches",
	                value: value
	            };
	        }
	    }

	    function dynamicFilterType(type) {
	        return {
	            Q1  : "quarter1",
	            Q2  : "quarter2",
	            Q3  : "quarter3",
	            Q4  : "quarter4",
	            M1  : "january",
	            M2  : "february",
	            M3  : "march",
	            M4  : "april",
	            M5  : "may",
	            M6  : "june",
	            M7  : "july",
	            M8  : "august",
	            M9  : "september",
	            M10 : "october",
	            M11 : "november",
	            M12 : "december"
	        }[type.toUpperCase()] || type;
	    }

	    function getFilterVal(val) {
	        var tmp = parseFloat(val);
	        if (!isNaN(tmp) && tmp == val) {
	            return tmp;
	        }
	        return val;
	    }

	    function withErrorLog(sheet, ref, func, context) {
	        try {
	            func();
	            return false;
	        } catch(ex) {
	            var err = { context: context, error: String(ex) };
	            if (sheet && sheet.name) {
	                err.sheet = sheet.name();
	            } else if (sheet) {
	                err.sheet = sheet;
	            }
	            if (ref) {
	                err.location = String(ref);
	            }
	            ERROR_LOG.push(err);
	            return true;
	        }
	    }

	    var BORDER_WIDTHS = {
	        "none"            : 0,
	        "thin"            : 1,
	        "medium"          : 2,
	        "dashed"          : 1,
	        "dotted"          : 1,
	        "thick"           : 3,
	        "double"          : 3,
	        "hair"            : 1,
	        "mediumDashed"    : 2,
	        "dashDot"         : 1,
	        "mediumDashDot"   : 2,
	        "dashDotDot"      : 1,
	        "mediumDashDotDot": 2,
	        "slantDashDot"    : 1
	    };

	    var DEFAULT_FORMATS = {
	        0  : "General",
	        1  : "0",
	        2  : "0.00",
	        3  : "#,##0",
	        4  : "#,##0.00",
	        9  : "0%",
	        10 : "0.00%",
	        11 : "0.00E+00",
	        12 : "# ?/?",
	        13 : "# ??/??",
	        14 : "mm-dd-yy",
	        15 : "d-mmm-yy",
	        16 : "d-mmm",
	        17 : "mmm-yy",
	        18 : "h:mm AM/PM",
	        19 : "h:mm:ss AM/PM",
	        20 : "h:mm",
	        21 : "h:mm:ss",
	        22 : "m/d/yy h:mm",
	        37 : "#,##0 ;(#,##0)",
	        38 : "#,##0 ;[Red](#,##0)",
	        39 : "#,##0.00;(#,##0.00)",
	        40 : "#,##0.00;[Red](#,##0.00)",
	        45 : "mm:ss",
	        46 : "[h]:mm:ss",
	        47 : "mmss.0",
	        48 : "##0.0E+0",
	        49 : "@"
	    };

	    function applyStyle(sheet, ref, styles, styleIndex) {
	        var range = sheet.range(ref);
	        var xf = styles.inlineStyles[styleIndex], base, value;
	        if (xf.xfId) {
	            base = styles.namedStyles[xf.xfId];
	        }
	        if (shouldSet("applyBorder", "borderId")) {
	            setBorder(styles.borders[value]);
	        }
	        if (shouldSet("applyFont", "fontId")) {
	            setFont(styles.fonts[value]);
	        }
	        if (shouldSet("applyAlignment", "textAlign")) {
	            range.textAlign(value);
	        }
	        if (shouldSet("applyAlignment", "verticalAlign")) {
	            range.verticalAlign(value);
	        }
	        if (shouldSet("applyAlignment", "indent")) {
	            range.indent(value);
	        }
	        if (shouldSet("applyAlignment", "wrapText")) {
	            // don't use range.wrap to avoid recomputing row height
	            range._property("wrap", value);
	        }
	        if (shouldSet("applyFill", "fillId")) {
	            setFill(styles.fills[value]);
	        }
	        if (shouldSet("applyNumberFormat", "numFmtId")) {
	            setFormat(styles.numFmts[value] || DEFAULT_FORMATS[value]);
	        }

	        function setFormat(f) {
	            var format = typeof f == "string" ? f : f.formatCode;
	            if (format != null && !/^general$/i.test(format)) {
	                // XXX: drop locale info.
	                // http://stackoverflow.com/questions/894805/excel-number-format-what-is-409
	                // not supported by the formatting library.
	                format = format.replace(/^\[\$-[0-9]+\]/, "");
	                range.format(format);
	            }
	        }

	        function setFill(f) {
	            if (f.type == "solid") {
	                range.background(f.color);
	            }
	        }

	        function setFont(f) {
	            range.fontFamily(f.name);
	            //range.fontSize(f.size); //XXX: will recalc row height.
	            // converting from points to pixels
	            if (f.size) {
	                range._property("fontSize", f.size * 4 / 3);
	            }
	            if (f.bold) {
	                range.bold(true);
	            }
	            if (f.italic) {
	                range.italic(true);
	            }
	            if (f.underline) {
	                range.underline(true);
	            }
	            if (f.color) {
	                range.color(f.color);
	            }
	        }

	        function setBorder(b) {
	            function set(side, prop) {
	                var border = b[side];
	                if (!border) {
	                    return;
	                }

	                var width = BORDER_WIDTHS[border.style];
	                if (width === 0) {
	                    return;
	                }

	                var color = border.color;
	                if (color == null) {
	                    color = "#000";
	                }

	                range._property(prop, { size: width, color: color });
	            }

	            set("left", "borderLeft");
	            set("top", "borderTop");
	            set("right", "borderRight");
	            set("bottom", "borderBottom");
	        }

	        function shouldSet(applyName, propName) {
	            var t = xf[applyName];
	            if (t != null && !t) {
	                return false;
	            }
	            value = xf[propName];
	            if (base && value == null) {
	                t = base[applyName];
	                if (t != null && !t) {
	                    return false;
	                }
	                value = base[propName];
	            }
	            return value != null;
	        }
	    }

	    function parse(zip, file, callbacks) {
	        var part = zip.files[file];
	        if (part) {
	            parseXML(part.asUint8Array(), callbacks);
	        }
	    }

	    function readStrings(zip) {
	        var strings = [];
	        var current = null;
	        parse(zip, "xl/sharedStrings.xml", {
	            leave: function() {
	                if (this.is(SEL_SHARED_STRING)) {
	                    strings.push(current);
	                    current = null;
	                }
	            },
	            text: function(text) {
	                if (this.is(SEL_TEXT)) {
	                    if (current == null) {
	                        current = "";
	                    }
	                    current += text;
	                }
	            }
	        });
	        return strings;
	    }

	    function readRelationships(zip, file) {
	        var map = { byId: {}, byType: { theme: [] } };
	        parse(zip, xl(file) + ".rels", {
	            enter: function(tag, attrs) {
	                if (tag == "Relationship") {
	                    map.byId[attrs.Id] = attrs.Target;

	                    var type = attrs.Type.match(/\w+$/)[0];
	                    var entries = map.byType[type] || [];
	                    entries.push(attrs.Target);
	                    map.byType[type] = entries;
	                }
	            }
	        });
	        return map;
	    }

	    var SEL_BORDER = ["borders", "border"];
	    var SEL_FILL = ["fills", "fill"];
	    var SEL_FONT = ["fonts", "font"];
	    var SEL_INLINE_STYLE = ["cellXfs", "xf"];
	    var SEL_NAMED_STYLE = ["cellStyleXfs", "xf"];
	    var SEL_NUM_FMT = ["numFmts", "numFmt"];

	    var INDEXED_COLORS = [
	        toCSSColor("FF000000"), toCSSColor("FFFFFFFF"), toCSSColor("FFFF0000"),
	        toCSSColor("FF00FF00"), toCSSColor("FF0000FF"), toCSSColor("FFFFFF00"),
	        toCSSColor("FFFF00FF"), toCSSColor("FF00FFFF"), toCSSColor("FF000000"),
	        toCSSColor("FFFFFFFF"), toCSSColor("FFFF0000"), toCSSColor("FF00FF00"),
	        toCSSColor("FF0000FF"), toCSSColor("FFFFFF00"), toCSSColor("FFFF00FF"),
	        toCSSColor("FF00FFFF"), toCSSColor("FF800000"), toCSSColor("FF008000"),
	        toCSSColor("FF000080"), toCSSColor("FF808000"), toCSSColor("FF800080"),
	        toCSSColor("FF008080"), toCSSColor("FFC0C0C0"), toCSSColor("FF808080"),
	        toCSSColor("FF9999FF"), toCSSColor("FF993366"), toCSSColor("FFFFFFCC"),
	        toCSSColor("FFCCFFFF"), toCSSColor("FF660066"), toCSSColor("FFFF8080"),
	        toCSSColor("FF0066CC"), toCSSColor("FFCCCCFF"), toCSSColor("FF000080"),
	        toCSSColor("FFFF00FF"), toCSSColor("FFFFFF00"), toCSSColor("FF00FFFF"),
	        toCSSColor("FF800080"), toCSSColor("FF800000"), toCSSColor("FF008080"),
	        toCSSColor("FF0000FF"), toCSSColor("FF00CCFF"), toCSSColor("FFCCFFFF"),
	        toCSSColor("FFCCFFCC"), toCSSColor("FFFFFF99"), toCSSColor("FF99CCFF"),
	        toCSSColor("FFFF99CC"), toCSSColor("FFCC99FF"), toCSSColor("FFFFCC99"),
	        toCSSColor("FF3366FF"), toCSSColor("FF33CCCC"), toCSSColor("FF99CC00"),
	        toCSSColor("FFFFCC00"), toCSSColor("FFFF9900"), toCSSColor("FFFF6600"),
	        toCSSColor("FF666699"), toCSSColor("FF969696"), toCSSColor("FF003366"),
	        toCSSColor("FF339966"), toCSSColor("FF003300"), toCSSColor("FF333300"),
	        toCSSColor("FF993300"), toCSSColor("FF993366"), toCSSColor("FF333399"),
	        toCSSColor("FF333333"),
	        toCSSColor("FF000000"), // System Foreground
	        toCSSColor("FFFFFFFF")  // System Background
	    ];

	    function readStyles(zip, theme) {
	        var styles = {
	            fonts        : [],
	            numFmts      : {},
	            fills        : [],
	            borders      : [],
	            namedStyles  : [],
	            inlineStyles : []
	        };
	        var font = null;
	        var fill = null;
	        var border = null;
	        var xf = null;
	        parse(zip, "xl/styles.xml", {
	            enter: function(tag, attrs, closed) {
	                if (this.is(SEL_NUM_FMT)) {
	                    styles.numFmts[attrs.numFmtId] = attrs;
	                }
	                else if (this.is(SEL_FONT)) {
	                    styles.fonts.push(font = {});
	                    if (closed) {
	                        // apparently, there's XLSX in the wild with
	                        // <font/>, because why not (also, <border/>).
	                        // if we don't null the variable, we always
	                        // enter below and effectively ignore the rest
	                        // of the file.
	                        font = null;
	                    }
	                } else if (font) {
	                    if (tag == "sz") {
	                        font.size = parseFloat(attrs.val);
	                    } else if (tag == "name") {
	                        font.name = attrs.val;
	                    } else if (tag == "b") {
	                        font.bold = bool(attrs.val, true);
	                    } else if (tag == "i") {
	                        font.italic = bool(attrs.val, true);
	                    } else if (tag == "u") {
	                        font.underline = (attrs.val == null || attrs.val == "single");
	                    } else if (tag == "color") {
	                        font.color = getColor(attrs, null);
	                    }
	                }
	                else if (this.is(SEL_FILL)) {
	                    styles.fills.push(fill = {});
	                    if (closed) {
	                        fill = null;
	                    }
	                } else if (fill) {
	                    if (tag == "patternFill") {
	                        fill.type = attrs.patternType;
	                    } else if (tag == "fgColor" && fill.type === "solid") {
	                        fill.color = getColor(attrs, INDEXED_COLORS[0]);
	                    } else if (tag == "bgColor" && fill.type !== "solid") {
	                        fill.color = getColor(attrs, INDEXED_COLORS[0]);
	                    }
	                }
	                else if (this.is(SEL_BORDER)) {
	                    styles.borders.push(border = {});
	                    if (closed) {
	                        border = null;
	                    }
	                } else if (border) {
	                    if (/^(?:left|top|right|bottom)$/.test(tag)) {
	                        border[tag] = { style: attrs.style || "none" };
	                    }
	                    if (tag == "color") {
	                        var side = this.stack[this.stack.length - 2].$tag;
	                        border[side].color = getColor(attrs, INDEXED_COLORS[0]);
	                    }
	                }
	                else if (this.is(SEL_NAMED_STYLE)) {
	                    xf = getXf(attrs);
	                    styles.namedStyles.push(xf);
	                    if (closed) {
	                        xf = null;
	                    }
	                } else if (this.is(SEL_INLINE_STYLE)) {
	                    xf = getXf(attrs);
	                    styles.inlineStyles.push(xf);
	                    if (closed) {
	                        xf = null;
	                    }
	                } else if (xf) {
	                    if (tag == "alignment") {
	                        if (/^(?:left|center|right|justify)$/.test(attrs.horizontal)) {
	                            xf.textAlign = attrs.horizontal;
	                        }
	                        if (/^(?:top|center|bottom)$/.test(attrs.vertical)) {
	                            xf.verticalAlign = attrs.vertical;
	                        }
	                        if (attrs.wrapText != null) {
	                            xf.wrapText = bool(attrs.wrapText);
	                        }
	                        if (attrs.indent != null) {
	                            xf.indent = integer(attrs.indent);
	                        }
	                    }
	                }
	            },
	            leave: function(tag) {
	                if (this.is(SEL_FONT)) {
	                    font = null;
	                } else if (this.is(SEL_FILL)) {
	                    fill = null;
	                } else if (this.is(SEL_BORDER)) {
	                    border = null;
	                } else if (tag == "xf") {
	                    xf = null;
	                }
	            }
	        });

	        function getXf(attrs) {
	            var xf = {
	                borderId          : integer(attrs.borderId),
	                fillId            : integer(attrs.fillId),
	                fontId            : integer(attrs.fontId),
	                numFmtId          : integer(attrs.numFmtId),
	                pivotButton       : bool(attrs.pivotButton),
	                quotePrefix       : bool(attrs.quotePrefix),
	                xfId              : integer(attrs.xfId)
	            };
	            addBool("applyAlignment");
	            addBool("applyBorder");
	            addBool("applyFill");
	            addBool("applyFont");
	            addBool("applyNumberFormat");
	            addBool("applyProtection");
	            function addBool(name) {
	                if (attrs[name] != null) {
	                    xf[name] = bool(attrs[name]);
	                }
	            }
	            return xf;
	        }

	        function getColor(attrs, defaultThemeColor) {
	            if (attrs.rgb) {
	                return toCSSColor(attrs.rgb);
	            } else if (attrs.indexed) {
	                return INDEXED_COLORS[integer(attrs.indexed)];
	            } else if (attrs.theme) {
	                var themeColor = theme.colorScheme[integer(attrs.theme)];
	                if (!themeColor) {
	                    // returning black by default for font color causes
	                    // https://github.com/telerik/kendo-ui-core/issues/5826
	                    // in default cell style, color is undefined
	                    return defaultThemeColor;
	                }

	                var color = kendo.parseColor(themeColor);

	                if (attrs.tint) {
	                    color = color.toHSL();

	                    var tint = parseFloat(attrs.tint);
	                    if (tint < 0) {
	                        color.l = color.l * (1 + tint);
	                    } else {
	                        color.l = color.l * (1 - tint) + (100 - 100 * (1 - tint));
	                    }
	                }

	                return color.toCssRgba();
	            }
	        }

	        return styles;
	    }

	    var SEL_SCHEME_RGBCLR = ["a:clrScheme", "*", "a:srgbClr"];
	    var SEL_SCHEME_SYSCLR = ["a:clrScheme", "*", "a:sysClr"];
	    function readTheme(zip, rel) {
	        var scheme = [];
	        var theme = {
	            colorScheme: scheme
	        };

	        var file = xl(rel);
	        if (zip.files[file]) {
	            parse(zip, file, {
	                enter: function(tag, attrs) {
	                    if (this.is(SEL_SCHEME_SYSCLR)) {
	                        scheme.push(toCSSColor(
	                            attrs.val == "window" ? "FFFFFFFF" : "FF000000"
	                        ));
	                    } else if (this.is(SEL_SCHEME_RGBCLR)) {
	                        scheme.push(toCSSColor("FF" + attrs.val));
	                    }
	                }
	            });

	            if (scheme.length > 3) {
	                // lt1 <-> dk1
	                swap(scheme, 0, 1);
	                // lt2 <-> dk2
	                swap(scheme, 2, 3);
	            }
	        }

	        function swap(arr, a, b) {
	            var tmp = arr[a];
	            arr[a] = arr[b];
	            arr[b] = tmp;
	        }

	        return theme;
	    }

	    function integer(val) {
	        return val == null ? null : parseInt(val, 10);
	    }

	    function bool(val, def) {
	        if (val == null) {
	            return def;
	        }
	        return val == "true" || val === true || val == 1;
	    }

	    function toCSSColor(rgb) {
	        var m = /^([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(rgb);
	        return "rgba(" +
	            parseInt(m[2], 16) + ", " +
	            parseInt(m[3], 16) + ", " +
	            parseInt(m[4], 16) + ", " +
	            parseInt(m[1], 16) / 255 + ")";
	    }

	    function relative_file(base, name) {
	        base = base.split(/\/+/);
	        name = name.split(/\/+/);
	        base.pop();
	        while (name.length) {
	            var part = name.shift();
	            if (part === "") {
	                base = [];      // absolute
	            } else if (part === ".") {
	                continue;
	            } else if (part === "..") {
	                base.pop();
	            } else {
	                base.push(part);
	            }
	        }
	        return base.join("/");
	    }

	    function excelToPixels(val) {
	        return val / 9525;
	    }

	    kendo.spreadsheet.readExcel = readExcel;
	    kendo.spreadsheet._readSheet = readSheet;
	    kendo.spreadsheet._readStrings = readStrings;
	    kendo.spreadsheet._readStyles = readStyles;
	    kendo.spreadsheet._readTheme = readTheme;
	    kendo.spreadsheet._readWorkbook = readWorkbook;

	}, __webpack_require__(3));


/***/ }),

/***/ 1596:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("OmDj");

/***/ }),

/***/ 1597:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("oTNd");

/***/ })

/******/ });

/***/ }),

/***/ "nzx/":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1126);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1126:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1127),
	        __webpack_require__(1128)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "dataviz.core",
	    name: "Core",
	    description: "The DataViz core functions",
	    category: "dataviz",
	    depends: [ "core", "drawing" ],
	    hidden: true
	};

	}, __webpack_require__(3));

/***/ }),

/***/ 1127:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("rs+d");

/***/ }),

/***/ 1128:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("F92I");

/***/ })

/******/ });

/***/ }),

/***/ "o1Yl":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1136);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1111:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nK46");

/***/ }),

/***/ 1136:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1137), __webpack_require__(1111) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "dataviz.gauge",
	    name: "Gauge",
	    category: "dataviz",
	    description: "Linear, Radial and Arc gauges.",
	    depends: [ "dataviz.core", "dataviz.themes" ]
	};

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1137:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("vn1v");

/***/ })

/******/ });

/***/ }),

/***/ "o4s/":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1449);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1048:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("BOhp");

/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1449:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "upload",
	    name: "Upload",
	    category: "web",
	    description: "The Upload widget uses progressive enhancement to deliver the best possible uploading experience to users.",
	    depends: [ "core" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        antiForgeryTokens = kendo.antiForgeryTokens,
	        logToConsole = kendo.logToConsole,
	        rFileExtension = /\.([^\.]+)$/,
	        NS = ".kendoUpload",
	        SELECT = "select",
	        UPLOAD = "upload",
	        SUCCESS = "success",
	        ERROR = "error",
	        COMPLETE = "complete",
	        CANCEL = "cancel",
	        CLEAR = "clear",
	        PAUSE = "pause",
	        RESUME = "resume",
	        PROGRESS = "progress",
	        REMOVE = "remove",
	        VALIDATIONERRORS = "validationErrors",
	        INVALIDMAXFILESIZE = "invalidMaxFileSize",
	        INVALIDMINFILESIZE = "invalidMinFileSize",
	        INVALIDFILEEXTENSION = "invalidFileExtension",
	        PROGRESSHIDEDELAY = 1000,
	        PROGRESSHIDEDURATION = 2000;

	    var headerStatusIcon = {
	        loading: "k-i-upload",
	        warning: "k-i-warning",
	        success: "k-i-check"
	    };

	    var Upload = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            that.name = element.name;
	            that.multiple = that.options.multiple;
	            that.directory = that.options.directory;
	            that.localization = that.options.localization;

	            var activeInput = that.element;
	            that.wrapper = activeInput.closest(".k-upload");
	            if (that.wrapper.length === 0) {
	                that.wrapper = that._wrapInput(activeInput);
	            }

	            that._activeInput(activeInput);
	            that.toggle(that.options.enabled);

	            var ns = that._ns = NS + "-" + kendo.guid();
	            activeInput.closest("form")
	                .on("submit" + ns, $.proxy(that._onParentFormSubmit, that))
	                .on("reset" + ns, $.proxy(that._onParentFormReset, that));

	            that._initUploadModule();

	            that._toggleDropZone();

	            that.wrapper
	            .on("click", ".k-upload-action", $.proxy(that._onFileAction, that))
	            .on("click", ".k-clear-selected", $.proxy(that._onClearSelected, that))
	            .on("click", ".k-upload-selected", $.proxy(that._onUploadSelected, that));

	            if(that.element.val()) {
	                that._onInputChange({ target: that.element });
	            }
	        },

	        events: [
	            SELECT,
	            UPLOAD,
	            SUCCESS,
	            ERROR,
	            COMPLETE,
	            CANCEL,
	            CLEAR,
	            PROGRESS,
	            REMOVE,
	            PAUSE,
	            RESUME
	        ],

	        options: {
	            name: "Upload",
	            enabled: true,
	            multiple: true,
	            directory: false,
	            showFileList: true,
	            template: "",
	            files: [],
	            async: {
	                autoRetryAfter: 0,
	                bufferChunkSize: 10000000,
	                maxAutoRetries: 1,
	                removeVerb: "POST",
	                autoUpload: true,
	                withCredentials: true,
	                accept: "*/*; q=0.5, application/json",
	                useArrayBuffer: false
	            },
	            localization: {
	                "select": "Select files...",
	                "cancel": "Cancel",
	                "retry": "Retry",
	                "remove": "Remove",
	                "pause": "Pause",
	                "resume": "Resume",
	                "clearSelectedFiles": "Clear",
	                "uploadSelectedFiles": "Upload",
	                "dropFilesHere": "Drop files here to upload",
	                "invalidFiles": "Invalid file(s). Please check file upload requirements.",
	                "statusUploading": "uploading",
	                "statusUploaded": "uploaded",
	                "statusWarning": "warning",
	                "statusFailed": "failed",
	                "headerStatusUploading": "Uploading...",
	                "headerStatusPaused": "Paused",
	                "headerStatusUploaded": "Done",
	                "uploadSuccess": "File(s) uploaded successfully.",
	                "uploadFail": "File(s) failed to upload.",
	                "invalidMaxFileSize": "File size too large.",
	                "invalidMinFileSize": "File size too small.",
	                "invalidFileExtension": "File type not allowed."
	            },
	            validation: {
	                allowedExtensions: [],
	                maxFileSize: 0,
	                minFileSize: 0
	            },
	            dropZone: ""
	        },

	        _initUploadModule: function() {
	            var that = this,
	                options = that.options;

	            if (options.async.saveUrl) {
	                that._module = that._supportsFormData() ?
	                new formDataUploadModule(that) :
	                new iframeUploadModule(that);
	                that._async = true;

	                var initialFiles = options.files;
	                if (initialFiles.length > 0) {
	                    that._renderInitialFiles(initialFiles);
	                }

	            } else {
	                that._module = new syncUploadModule(that);
	            }
	        },

	        setOptions: function(options) {
	            var that = this,
	                activeInput = that.element;

	            $(that.options.dropZone).off(that._ns);

	            Widget.fn.setOptions.call(that, options);

	            that.multiple = that.options.multiple;
	            that.directory = that.options.directory;

	            activeInput.attr("multiple", that._supportsMultiple() ? that.multiple : false);
	            if(that.directory){
	                activeInput.attr("webkitdirectory", that.directory);
	                activeInput.attr("directory", that.directory);
	            }
	            that.toggle(that.options.enabled);

	            that._initUploadModule();

	            that._toggleDropZone();
	        },

	        enable: function(enable) {
	            enable = typeof (enable) === "undefined" ? true : enable;
	            this.toggle(enable);
	        },

	        disable: function() {
	            this.toggle(false);
	        },

	        toggle: function(enable) {
	            enable = typeof (enable) === "undefined" ? enable : !enable;
	            this.wrapper.toggleClass("k-state-disabled", enable);
	            this.element.prop("disabled", enable);
	        },

	        focus: function() {
	            this.element.focus();
	        },

	        destroy: function() {
	            var that = this;
	            var customDropZone = $(that.options.dropZone);

	            $(document)
	                .add($(".k-dropzone", that.wrapper))
	                .add(that.wrapper.closest("form"))
	                .off(that._ns);

	            if(customDropZone.length > 0) {
	                customDropZone.off(that._ns);
	            }

	            $(that.element).off(NS);

	            Widget.fn.destroy.call(that);
	        },
	        pause: function(fileEntry){
	            this._module.onPause({ target: $(fileEntry, this.wrapper) });

	            var pauseIcon = fileEntry.find(".k-i-pause-sm");
	            pauseIcon.removeClass("k-i-pause-sm").addClass("k-i-play-sm").attr("title", this.localization.resume);
	            $(pauseIcon).parent().attr("aria-label", this.localization.resume);
	        },
	        resume: function(fileEntry){
	            this._module.onResume({ target: $(fileEntry, this.wrapper) });

	            var playIcon = fileEntry.find(".k-i-play-sm");
	            playIcon.removeClass("k-i-play-sm").addClass("k-i-pause-sm").attr("title", this.localization.pause);
	            $(playIcon).parent().attr("aria-label", this.localization.pause);
	        },
	        upload: function() {
	            var that = this;

	            that._module.onSaveSelected();
	        },

	        getFiles: function() {
	            var that = this;
	            var filesData;
	            var allFiles = [];
	            var listItems = that.wrapper.find(".k-file");

	            for(var i = 0; i < listItems.length; i++) {
	                filesData = $(listItems[i]).data("fileNames");

	                if(filesData) {
	                    for(var j = 0; j < filesData.length; j++) {
	                        allFiles.push(filesData[j]);
	                    }
	                }
	            }

	            return allFiles;
	        },

	        clearAllFiles: function() {
	            var that = this;
	            var files = that.wrapper.find(".k-file");

	            files.each(function(index, file) {
	                that._removeFileByDomElement(file, false);
	            });
	        },

	        removeAllFiles: function() {
	            var that = this;
	            var files = that.wrapper.find(".k-file");

	            files.each(function(index, file) {
	                that._removeFileByDomElement(file, true);
	            });
	        },

	        removeFileByUid: function(uid) {
	            this._removeFileByUid(uid, true);
	        },

	        clearFileByUid: function(uid) {
	            this._removeFileByUid(uid, false);
	        },

	        _removeFileByUid: function(uid, shouldSendRemoveRequest) {
	            var that = this;
	            var fileEntry;

	            if(typeof uid !== 'string') { return; }

	            fileEntry = $('.k-file[' + kendo.attr('uid') + '="' + uid + '"]', that.wrapper);

	            if(fileEntry.length > 0) {
	                that._removeFileByDomElement(fileEntry, shouldSendRemoveRequest);
	            }
	        },

	        clearFile: function(callback) {
	            this._removeFile(callback, false);
	        },

	        removeFile: function(callback) {
	            this._removeFile(callback, true);
	        },

	        _removeFile: function(callback, shouldSendRemoveRequest) {
	            var that = this;
	            var files = that.wrapper.find(".k-file");
	            var fileData;

	            if(typeof callback === "function") {
	                files.each(function(index, file){
	                    fileData = $(file).data("fileNames");

	                    if(callback(fileData)) {
	                        that._removeFileByDomElement(file, shouldSendRemoveRequest);
	                    }
	                });
	            }
	        },

	        _removeFileByDomElement: function(fileEntry, shouldSendRemoveRequest) {
	            var that = this;
	            var fileData = {
	                target: $(fileEntry, that.wrapper)
	            };
	            var allFiles;

	            if(that.options.async.saveUrl) {
	                if($(fileEntry).hasClass("k-file-progress")) {
	                    that._module.onCancel(fileData);
	                } else {
	                    that._module.onRemove(fileData, {}, shouldSendRemoveRequest);
	                }

	                allFiles = $(".k-file", that.wrapper);

	                if(allFiles.length === 0) {
	                    that._hideHeaderUploadstatus();
	                } else {
	                    that._updateHeaderUploadStatus();
	                }
	            } else {
	                that._module.onRemove(fileData, {}, shouldSendRemoveRequest);
	            }
	        },

	        _addInput: function(sourceInput) {
	            //check if source input is a DOM element. Required for some unit tests
	            if (!sourceInput[0].nodeType) {
	                return;
	            }

	            var that = this,
	                input = sourceInput.clone().val("");

	            input
	                .insertAfter(that.element)
	                .data("kendo" + that.options.prefix + that.options.name, that);

	            $(that.element)
	                .hide()
	                .attr("tabindex", "-1")
	                .removeAttr("id")
	                .off(NS);

	            that._activeInput(input);
	            that.element.focus();
	        },

	        _activeInput: function(input) {
	            var that = this,
	                wrapper = that.wrapper;

	            that.element = input;

	            if(that.directory){
	                input.attr("webkitdirectory", that.directory);
	                input.attr("directory", that.directory);
	            }

	            input
	                .attr("multiple", that._supportsMultiple() ? that.multiple : false)
	                .attr("autocomplete", "off")
	                .on("click" + NS, function(e) {
	                    if (wrapper.hasClass("k-state-disabled")) {
	                        e.preventDefault();
	                    }
	                })
	                .on("focus" + NS, function() {
	                    $(this).parent().addClass("k-state-focused");
	                })
	                .on("blur" + NS, function() {
	                    $(this).parent().removeClass("k-state-focused");
	                })
	                .on("change" + NS, $.proxy(that._onInputChange, that))
	                .on("keydown" + NS, $.proxy(that._onInputKeyDown, that));
	        },

	        _onInputKeyDown: function(e) {
	            var that = this;
	            var firstButton = that.wrapper.find(".k-upload-action:visible:first");

	            if (e.keyCode === kendo.keys.TAB && firstButton.length > 0 && !e.shiftKey) {
	                e.preventDefault();

	                firstButton.focus();
	            }
	        },

	        _onInputChange: function(e) {
	            var that = this;
	            var input = $(e.target);
	            var files = assignGuidToFiles(that._inputFiles(input), that._isAsyncNonBatch());

	            validateFiles(files, that.options.validation);

	            var prevented = that.trigger(SELECT, { files: files });
	            if (prevented) {
	                that._addInput(input);
	                input.remove();
	            } else {
	                that._module.onSelect({target : input}, files);
	            }
	        },

	        _readDirectory: function(item){
	            var deferred = new $.Deferred();
	            var dirReader = item.createReader();
	            var allFolderFiles = [];

	            var readEntries = function () {
	                dirReader.readEntries(function(entries) {
	                    if (!entries.length) {
	                        deferred.resolve(allFolderFiles);
	                    } else {
	                        allFolderFiles = allFolderFiles.concat(entries);
	                        readEntries();
	                    }
	                }, deferred.reject);
	            };

	            readEntries();

	             return deferred.promise();
	        },

	        _readFile: function(item){
	            var that = this;
	            var fullpath = item.fullPath;

	            item.file(function(file){
	                    file.relativePath = fullpath.slice(1);
	                    that.droppedFolderFiles.push(file);
	                    that.droppedFolderCounter --;
	                    if(that.droppedFolderCounter === 0){
	                        setTimeout(function(){
	                            if(that.droppedFolderCounter === 0){
	                                if(that.droppedFolderFiles.length){
	                                    that._proceedDroppedItems(that.droppedFolderFiles);
	                                    that.droppedFolderFiles = [];
	                                }
	                            }
	                        },0);
	                    }
	            }, function(){
	                logToConsole("File error.");
	            });
	        },

	        _traverseFileTree: function (item, skipCounter) {
	            var that = this;
	            if(!skipCounter){
	                that.droppedFolderCounter--;
	            }

	            this._readDirectory(item).then(function(items){
	                that.droppedFolderCounter += items.length;
	                for (var i = 0; i < items.length; i++) {
	                    if(items[i].isFile){
	                        that._readFile(items[i]);
	                    } else if (items[i].isDirectory){
	                        that._traverseFileTree(items[i]);
	                    }
	                }
	            });
	        },

	        _onDrop: function (e) {
	            var dt = e.originalEvent.dataTransfer;
	            var that = this;
	            var droppedFiles = dt.files;
	            var length;

	            stopEvent(e);
	           if(that.options.directoryDrop && dt.items){
	                length = dt.items.length;
	                that.droppedFolderCounter = 0;
	                that.droppedFolderFiles = [];

	                for (var i = 0; i < length; i++) {
	                    if(dt.items[i].webkitGetAsEntry){
	                        var entry = dt.items[i].webkitGetAsEntry();

	                        if(entry.isDirectory){
	                            that._traverseFileTree(entry, true);
	                        }else if (entry.isFile){
	                            that.droppedFolderFiles.push(dt.files[i]);
	                        }
	                    }else{
	                         that._proceedDroppedItems(droppedFiles);
	                    }
	                }
	           }else{
	               that._proceedDroppedItems(droppedFiles);
	           }
	        },

	        _proceedDroppedItems: function(droppedFiles){
	            var that = this;
	            var files = assignGuidToFiles(getAllFileInfo(droppedFiles), that._isAsyncNonBatch());

	              if (droppedFiles.length > 0 && !that.wrapper.hasClass("k-state-disabled")) {
	                if (!that.multiple && files.length > 1) {
	                    files.splice(1, files.length - 1);
	                }

	                validateFiles(files, that.options.validation);

	                var prevented = that.trigger(SELECT, { files: files });
	                if (!prevented) {
	                    that._module.onSelect({target : $(".k-dropzone", that.wrapper) }, files);
	                }
	            }
	        },

	        _filesContainValidationErrors: function(files) {
	            var hasErrors = false;

	            $(files).each(function(index, file){
	                if(file[VALIDATIONERRORS] && file[VALIDATIONERRORS].length > 0) {
	                    hasErrors = true;
	                    return false;
	                }
	            });

	            return hasErrors;
	        },

	        _isAsyncNonBatch: function () {
	            return (this._async && !this.options.async.batch) || false;
	        },

	        _renderInitialFiles: function(files) {
	            var that = this;
	            var idx = 0;
	            files = assignGuidToFiles(files, true);

	            for (idx = 0; idx < files.length; idx++) {
	                var currentFile = files[idx];

	                var fileEntry = that._enqueueFile(currentFile.name, { fileNames: [ currentFile ] });
	                fileEntry.addClass("k-file-success").data("files", [ files[idx] ]);

	                if (that._supportsRemove()){
	                    that._fileAction(fileEntry, REMOVE);
	                }
	            }
	        },

	        _prepareTemplateData: function(name, data) {
	            var filesData = data.fileNames,
	                templateData = {},
	                totalSize = 0,
	                idx = 0;

	            for (idx = 0; idx < filesData.length; idx++) {
	                totalSize += filesData[idx].size;
	            }

	            templateData.name = name;
	            templateData.size = totalSize;
	            templateData.files = data.fileNames;

	            return templateData;
	        },

	        _prepareDefaultSingleFileEntryTemplate: function(data) {
	            var that = this;
	            var file = data.fileNames[0];
	            var fileSize = getTotalFilesSizeMessage(data.fileNames);
	            var fileGroup = kendo.getFileGroup(file.extension, true);
	            var errors = file[VALIDATIONERRORS];
	            var template = "";

	            if(errors && errors.length > 0) {
	                template += "<li class='k-file k-file-invalid'><div class='k-progressbar k-hidden'><span class='k-progress'></span></div>" +
	                "<span class='k-file-invalid-group-wrapper'>" +
	                    "<span class='k-file-group k-icon k-i-" + fileGroup + "'></span>" +
	                    "<span class='k-file-state'></span>" +
	                "</span>" +
	                "<span class='k-file-name-size-wrapper'>" +
	                    "<span class='k-file-name k-file-name-invalid' title='" + file.name + "'>" + file.name + "</span>" +
	                    "<span class='k-file-validation-message k-text-error'>" + that.localization[errors[0]] + "</span>" +
	                "</span>";
	            } else {
	                template += "<li class='k-file'><div class='k-progressbar k-hidden'><span class='k-progress'></span></div>" +
	                "<span class='k-file-group-wrapper'>" +
	                    "<span class='k-file-group k-icon k-i-" + fileGroup + "'></span>" +
	                    "<span class='k-file-state'></span>" +
	                "</span>" +
	                "<span class='k-file-name-size-wrapper'><span class='k-file-name' title='" + file.name + "'>" + file.name + "</span>" +
	                "<span class='k-file-size'>" + fileSize + "</span></span>";
	            }

	            template += "<strong class='k-upload-status'></strong>";

	            return $(template);
	        },

	        _prepareDefaultMultipleFileEntriesTemplate: function(data) {
	            var that = this;
	            var files = data.fileNames;
	            var filesHaveValidationErrors = that._filesContainValidationErrors(files);
	            var totalFileSize = getTotalFilesSizeMessage(files);
	            var template = "";
	            var i, currentFile;

	            if(filesHaveValidationErrors) {
	                template += "<li class='k-file k-file-invalid'><div class='k-progressbar k-hidden'><span class='k-progress'></span></div>" +
	                    "<span class='k-multiple-files-invalid-group-wrapper'>" +
	                    "<span class='k-file-group k-icon k-i-files'></span>";
	            } else {
	                template += "<li class='k-file'><div class='k-progressbar k-hidden'><span class='k-progress'></span></div>" +
	                    "<span class='k-multiple-files-group-wrapper'>" +
	                        "<span class='k-file-group k-icon k-i-files'></span>";
	            }

	            template += "<span class='k-file-state'></span></span>";

	            files.sort(function(a, b){
	                if(a[VALIDATIONERRORS]) { return -1; }

	                if (b[VALIDATIONERRORS]) { return 1; }

	                return 0;
	            });

	            template += "<span class='k-multiple-files-wrapper'>";
	            for(i = 0; i < files.length; i++) {
	                currentFile = files[i];
	                var fileSize = getTotalFilesSizeMessage([currentFile]);

	                template += "<span class='k-file-name-size-wrapper'>";
	                if(currentFile[VALIDATIONERRORS] && currentFile[VALIDATIONERRORS].length > 0) {
	                    template += "<span class='k-file-name k-file-name-invalid' title='" + currentFile.name + "'>" + currentFile.name + "</span>";
	                } else {
	                    template += "<span class='k-file-name' title='" + currentFile.name + "'>" + currentFile.name + "</span>";
	                }
	                template += "<span class='k-file-size'>" + fileSize + "</span></span>";
	            }

	            if(filesHaveValidationErrors) {
	                template += "<span class='k-file-validation-message k-text-error'>" + that.localization.invalidFiles +"</span>";
	            } else {
	                template += "<span class='k-file-information'>Total: " + files.length + " files, " + totalFileSize + "</span>";
	            }

	            template += "</span><strong class='k-upload-status'></strong>";

	            return $(template);
	        },

	        _enqueueFile: function(name, data) {
	            var that = this;
	            var existingFileEntries;
	            var fileEntry;
	            var fileUid = data.fileNames[0].uid;
	            var fileList =  $(".k-upload-files", that.wrapper);
	            var options = that.options;
	            var template = options.template;
	            var templateData;
	            var removeEventArgs;

	            if (fileList.length === 0) {
	                fileList = $("<ul class='k-upload-files k-reset'></ul>").appendTo(that.wrapper);
	                if (!that.options.showFileList) {
	                    fileList.hide();
	                }

	                that.wrapper.removeClass("k-upload-empty");
	            }

	            existingFileEntries = $(".k-file", fileList);

	            if (!template) {
	                if(data.fileNames.length === 1) {
	                    fileEntry = that._prepareDefaultSingleFileEntryTemplate(data);
	                } else {
	                    fileEntry = that._prepareDefaultMultipleFileEntriesTemplate(data);
	                }
	            } else {
	                templateData = that._prepareTemplateData(name, data);
	                template = kendo.template(template);

	                fileEntry = $("<li class='k-file'>" + template(templateData) + "</li>");
	                fileEntry.find(".k-upload-action").addClass("k-button k-button-icon k-flat");

	                that.angular("compile", function(){
	                    return {
	                        elements: fileEntry,
	                        data: [ templateData ]
	                    };
	                });
	            }

	            fileEntry
	                .attr(kendo.attr("uid"), fileUid)
	                .appendTo(fileList)
	                .data(data);

	            if (!that._async) {
	                $(".k-progress", fileEntry).width('100%');
	            }

	            if (!that.multiple && existingFileEntries.length > 0) {
	                removeEventArgs = {
	                    files: existingFileEntries.data("fileNames"),
	                    headers: {}
	                };
	                if (!that.trigger(REMOVE, removeEventArgs)) {
	                    that._module.onRemove({target : $(existingFileEntries, that.wrapper)}, removeEventArgs);
	                }
	            }

	            return fileEntry;
	        },

	        _removeFileEntry: function(fileEntry) {
	            var that = this;
	            var fileList = fileEntry.closest(".k-upload-files");
	            var allFiles, allCompletedFiles, allInvalidFiles;

	            fileEntry.remove();
	            allFiles = $(".k-file", fileList);
	            allCompletedFiles = $(".k-file-success, .k-file-error", fileList);
	            allInvalidFiles = $(".k-file-invalid", fileList);

	            if (allCompletedFiles.length === allFiles.length || allInvalidFiles.length === allFiles.length) {
	                this._hideActionButtons();
	            }

	            if (allFiles.length === 0) {
	                fileList.remove();
	                that.wrapper.addClass("k-upload-empty");
	                that._hideHeaderUploadstatus();
	            } else {
	                that._updateHeaderUploadStatus();
	            }
	        },

	        _fileAction: function(fileElement, actionKey, skipClear) {
	            var classDictionary = { remove: "k-i-x", cancel: "k-i-cancel", retry: "k-i-retry", pause: "k-i-pause-sm"};
	            var iconsClassDictionary = {remove: "k-i-close", cancel: "k-i-cancel", retry: "k-i-reload-sm", pause: "k-i-pause-sm"};
	            var firstActionButton;

	            if (!classDictionary.hasOwnProperty(actionKey)) {
	                return;
	            }
	            if(!skipClear){
	                this._clearFileAction(fileElement);
	            }
	            if (!this.options.template) {
	                if(!skipClear){
	                    fileElement.find(".k-upload-status .k-upload-action").remove();
	                }
	                fileElement.find(".k-upload-status").append(
	                    this._renderAction(classDictionary[actionKey], this.localization[actionKey], iconsClassDictionary[actionKey])
	                );
	            } else {
	                firstActionButton = fileElement.find(".k-upload-action").first();
	                if(!firstActionButton.find(".k-icon").length){
	                firstActionButton
	                        .addClass("k-button")
	                        .append("<span class='k-icon " + iconsClassDictionary[actionKey] + " " + classDictionary[actionKey] +
	                                "' title='" + this.localization[actionKey] + "'" +
	                                "aria-label='" + this.localization[actionKey] + "'></span>")
	                        .show();
	                }else if (firstActionButton.next(".k-upload-action").length){
	                    firstActionButton.next(".k-upload-action")
	                        .addClass("k-button")
	                        .append("<span class='k-icon " + iconsClassDictionary[actionKey] + " " + classDictionary[actionKey] +
	                                "' title='" + this.localization[actionKey] + "'" +
	                                "aria-label='" + this.localization[actionKey] + "'></span>")
	                        .show();
	                }
	            }
	        },

	        _fileState: function(fileEntry, stateKey) {
	            var localization = this.localization,
	                states = {
	                    uploading: {
	                        text : localization.statusUploading
	                    },
	                    uploaded: {
	                        text : localization.statusUploaded
	                    },
	                    failed: {
	                        text : localization.statusFailed
	                    }
	                },
	                currentState = states[stateKey];

	            if (currentState) {
	                $("span.k-file-state", fileEntry).text(currentState.text);
	            }
	        },

	        _renderAction: function (actionClass, actionText, iconClass) {
	            if (actionClass !== "") {
	                return $(
	                "<button type='button' class='k-button k-button-icon k-flat k-upload-action' aria-label='" + actionText + "'>" +
	                    "<span class='k-icon "+ iconClass + " " + actionClass + "' title='" + actionText + "'></span>" +
	                "</button>"
	                ).on("focus", function() { $(this).addClass("k-state-focused"); })
	                 .on("blur", function() { $(this).removeClass("k-state-focused"); });
	            }
	            else {
	                return $(
	                "<button type='button' class='k-button'>" +
	                    actionText +
	                "</button>"
	                );
	            }
	        },

	        _clearFileAction: function(fileElement) {
	            $(".k-upload-action", fileElement).empty().hide();
	        },

	        _onFileAction: function(e) {
	            var that = this;
	            if (!that.wrapper.hasClass("k-state-disabled")) {
	                var button = $(e.target).closest(".k-upload-action");
	                var icon = button.find(".k-icon");
	                var fileEntry = button.closest(".k-file");
	                var files = fileEntry.data("fileNames");
	                var hasValidationErrors = that._filesContainValidationErrors(files);
	                var eventArgs = {
	                    files: files,
	                    headers: {}
	                };

	                that._retryClicked = false;

	                if (icon.hasClass("k-i-x")) {
	                    if (!that.trigger(REMOVE, eventArgs)) {
	                        that._module.onRemove({target : $(fileEntry, that.wrapper)}, eventArgs, !hasValidationErrors);
	                    }
	                } else if (icon.hasClass("k-i-cancel")) {
	                    that.trigger(CANCEL, eventArgs);
	                    that._module.onCancel({ target: $(fileEntry, that.wrapper) });
	                    that._checkAllComplete();
	                    that._updateHeaderUploadStatus();
	                } else if (icon.hasClass("k-i-pause-sm")) {
	                    that.trigger(PAUSE, eventArgs);
	                    that.pause(fileEntry);
	                    that._updateHeaderUploadStatus();
	                } else if (icon.hasClass("k-i-play-sm")) {
	                    that.trigger(RESUME, eventArgs);
	                    that.resume(fileEntry);
	                }else if (icon.hasClass("k-i-retry")) {
	                    $(".k-i-warning", fileEntry).remove();
	                    $(".k-progressbar", fileEntry).finish().show();
	                    that._module.onRetry({ target: $(fileEntry, that.wrapper) });
	                    that._retryClicked = true;
	                }
	            }

	            return false;
	        },

	        _onUploadSelected: function() {
	            var that = this;
	            var wrapper = that.wrapper;

	            if (!wrapper.hasClass("k-state-disabled")) {
	                this._module.onSaveSelected();
	            }

	            return false;
	        },

	        _onClearSelected: function() {
	            var that = this;
	            var wrapper = that.wrapper;

	            var clearEventArgs = { };
	            if(!wrapper.hasClass("k-state-disabled") && !that.trigger(CLEAR, clearEventArgs)) {
	                that.clearAllFiles();
	            }

	            return false;
	        },

	        _onFileProgress: function(e, percentComplete) {
	            var progressPct;

	            if (percentComplete > 100) {
	                percentComplete = 100;
	            }

	            $(".k-progressbar", e.target).removeClass('k-hidden');

	            if (!this.options.template) {
	                progressPct = $(".k-upload-pct", e.target);

	                if (progressPct.length === 0) {
	                    $(".k-upload-status", e.target).prepend("<span class='k-upload-pct'></span>");
	                }

	                if(percentComplete !== 100){
	                    $(".k-upload-pct", e.target).text(percentComplete + "%");
	                }else{
	                     $(".k-upload-pct", e.target).remove();
	                }
	                $(".k-progress", e.target).width(percentComplete + "%");
	            } else {
	                $(".k-progress", e.target).width(percentComplete + "%");
	            }

	            this.trigger(PROGRESS, {
	                files: getFileEntry(e).data("fileNames"),
	                percentComplete: percentComplete
	            });
	        },

	        _onUploadSuccess: function(e, response, xhr) {
	            var that = this;
	            var fileEntry = getFileEntry(e);
	            var files = fileEntry.data("fileNames");
	            var fileInfo = fileEntry.find('.k-file-information');
	            var fileSize = fileEntry.find('.k-file-size');

	            var prevented = that.trigger(SUCCESS, {
	                files: fileEntry.data("fileNames"),
	                response: response,
	                operation: "upload",
	                XMLHttpRequest: xhr
	            });

	            if(prevented) {
	                that._setUploadErrorState(fileEntry);
	            } else {
	                that._fileState(fileEntry, "uploaded");
	                fileEntry.removeClass('k-file-progress').addClass('k-file-success');

	                if(fileInfo.length > 0) {
	                    fileInfo.addClass('k-hidden')
	                        .after('<span class="k-file-validation-message k-text-success">' + files.length + ' ' + that.localization.uploadSuccess + '</span>');
	                } else if (fileSize.length > 0) {
	                    fileSize.addClass('k-hidden')
	                        .after('<span class="k-file-validation-message k-text-success">' + that.localization.uploadSuccess + '</span>');
	                }

	                that._updateHeaderUploadStatus();

	                if (that._supportsRemove()) {
	                    that._fileAction(fileEntry, REMOVE);
	                } else {
	                    that._clearFileAction(fileEntry);
	                }
	            }

	            that._hideUploadProgress(fileEntry);

	            that._checkAllComplete();
	        },

	        _onUploadError: function(e, xhr) {
	            var that = this;
	            var module = that._module;
	            var fileEntry = getFileEntry(e);
	            var fileUid = fileEntry.data("uid");

	            that._setUploadErrorState(fileEntry);

	            that.trigger(ERROR, {
	                operation: "upload",
	                files: fileEntry.data("fileNames"),
	                XMLHttpRequest: xhr
	            });

	            logToConsole("Server response: " + xhr.responseText);

	            if(!that.options.async.chunkSize){
	                that._hideUploadProgress(fileEntry);
	            }else{
	                if(module._decreasePosition){
	                    module._decreasePosition(fileUid);
	                }
	            }

	           that._checkAllComplete();

	            if(this.options.async.autoRetryAfter){
	               this._autoRetryAfter(fileEntry);
	            }
	        },
	        _autoRetryAfter: function(fileEntry){
	            var that = this;
	            var retries = this._module.retries;

	            if(!retries){
	                return;
	            }

	            if(!retries[fileEntry.data("uid")]){
	                retries[fileEntry.data("uid")] = 1;
	            }

	            if(retries[fileEntry.data("uid")] <= this.options.async.maxAutoRetries){
	                retries[fileEntry.data("uid")]++;
	                setTimeout(function(){
	                    that._module.performUpload(fileEntry);
	                },this.options.async.autoRetryAfter);
	            }
	        },
	        _setUploadErrorState: function(fileEntry) {
	            var that = this,
	                uploadPercentage,
	                files = fileEntry.data("fileNames"),
	                fileInfo = fileEntry.find('.k-file-information'),
	                fileSize = fileEntry.find('.k-file-size');

	            that._fileState(fileEntry, "failed");
	            fileEntry.removeClass('k-file-progress').addClass('k-file-error');

	            if(fileInfo.length > 0) {
	                fileInfo.addClass('k-hidden')
	                    .after('<span class="k-file-validation-message k-text-error">' + files.length + ' ' + that.localization.uploadFail + '</span>');
	            } else if (fileSize.length > 0) {
	                fileSize.addClass('k-hidden')
	                    .after('<span class="k-file-validation-message k-text-error">' + that.localization.uploadFail + '</span>');
	            }

	            that._updateUploadProgress(fileEntry);

	            uploadPercentage = $('.k-upload-pct', fileEntry);

	            if (uploadPercentage.length > 0) {
	                uploadPercentage.remove();
	            }

	            this._updateHeaderUploadStatus();
	            this._fileAction(fileEntry, "retry");
	            this._fileAction(fileEntry, REMOVE, true);

	            if (that._retryClicked) {
	                fileEntry.find(".k-i-retry").parent().focus();
	            }
	        },

	       _updateUploadProgress: function(fileEntry){
	            var that = this;

	            if(!that.options.async.chunkSize){
	                $('.k-progress', fileEntry).width("100%");
	            }else{
	                var fileUid = fileEntry.data("uid");
	                if(that._module.metaData){
	                    var fileMetaData = that._module.metaData[fileUid];

	                    if(fileMetaData){
	                        var percentComplete = fileMetaData.totalChunks ? Math.round(((fileMetaData.chunkIndex)/fileMetaData.totalChunks)*100):100;

	                        that._onFileProgress({ target : $(fileEntry, that.wrapper) }, percentComplete);
	                    }
	                }
	            }
	        },

	        _hideUploadProgress: function(fileEntry) {
	            $(".k-progressbar", fileEntry)
	                .delay(PROGRESSHIDEDELAY)
	                .fadeOut(PROGRESSHIDEDURATION, function() {
	                    $(this).find('.k-progress').css("width", "0%");
	                });
	        },

	        _showActionButtons: function() {
	            var that = this;
	            var actionsWrapper = $(".k-action-buttons", that.wrapper);
	            var uploadButton = $(".k-upload-selected", that.wrapper);
	            var clearButton = $(".k-clear-selected", that.wrapper);

	            if (uploadButton.length === 0) {
	                uploadButton = that._renderAction("", this.localization.uploadSelectedFiles)
	                                   .addClass("k-upload-selected")
	                                   .addClass("k-primary");

	                clearButton = that._renderAction("", this.localization.clearSelectedFiles)
	                                  .addClass("k-clear-selected");
	            }

	            if (!actionsWrapper.length) {
	                actionsWrapper = $("<div />")
	                    .addClass("k-action-buttons")
	                    .append(clearButton, uploadButton);
	            }


	            this.wrapper.append(actionsWrapper);
	        },

	        _hideActionButtons: function() {
	            $(".k-action-buttons", this.wrapper).remove();
	        },

	        _showHeaderUploadStatus: function(isUploading) {
	            var that = this;
	            var localization = that.localization;
	            var dropZone = $(".k-dropzone", that.wrapper);
	            var headerUploadStatus = $('.k-upload-status-total', that.wrapper);

	            if (headerUploadStatus.length !== 0) {
	                headerUploadStatus.remove();
	            }

	            $('.k-dropzone-hint', that.wrapper).addClass('k-hidden');

	            headerUploadStatus = '<strong class="k-upload-status k-upload-status-total"><span class="k-icon"></span></strong>';

	            if(isUploading) {
	                headerUploadStatus = $(headerUploadStatus).append(localization.headerStatusUploading);
	                headerUploadStatus.find(".k-icon").addClass(headerStatusIcon.loading);
	            } else {
	                headerUploadStatus = $(headerUploadStatus).append(localization.headerStatusUploaded);
	                headerUploadStatus.find(".k-icon").addClass(headerStatusIcon.warning);
	            }

	            if (dropZone.length > 0) {
	                dropZone.append(headerUploadStatus);
	            } else {
	                $('.k-upload-button', that.wrapper).after(headerUploadStatus);
	            }
	        },

	        _updateHeaderUploadStatus: function() {
	            var that = this;
	            var headerUploadStatus = $('.k-upload-status-total', this.wrapper);
	            var currentlyUploading = $('.k-file', that.wrapper).not('.k-file-success, .k-file-error, .k-file-invalid');
	            var currentlyInvalid = $('.k-file-invalid', that.wrapper);
	            var currentlyFailed = $('.k-file-error', that.wrapper);
	            var currentlyPaused = $('.k-file', that.wrapper).find(".k-i-play-sm");
	            var failedUploads, headerUploadStatusIcon;

	            if(currentlyPaused.length &&
	            (currentlyPaused.length === currentlyUploading.length || !that.options.async.concurrent)){
	                headerUploadStatusIcon = $('.k-icon', headerUploadStatus)
	                                .removeClass()
	                                .addClass("k-icon")
	                                .addClass("k-i-pause-sm");

	                headerUploadStatus.html(headerUploadStatusIcon)
	                                  .append(that.localization.headerStatusPaused);
	            }else if (currentlyUploading.length === 0 || currentlyInvalid.length > 0 || currentlyFailed.length > 0) {
	                failedUploads = $('.k-file.k-file-error, .k-file.k-file-invalid', that.wrapper);

	                headerUploadStatus = $('.k-upload-status-total', that.wrapper);
	                headerUploadStatusIcon = $('.k-icon', headerUploadStatus).removeClass().addClass("k-icon")
	                                              .addClass(failedUploads.length !== 0 ? headerStatusIcon.warning : headerStatusIcon.success);

	                headerUploadStatus.html(headerUploadStatusIcon)
	                                  .append(that.localization.headerStatusUploaded);
	            }
	        },

	        _hideHeaderUploadstatus: function() {
	            var that = this,
	                dropZone = that.options.dropZone;

	            $('.k-upload-status-total', this.wrapper).remove();

	            if (dropZone === "") {
	                $('.k-dropzone-hint', that.wrapper).removeClass('k-hidden');
	            }
	        },

	        _onParentFormSubmit: function() {
	            var upload = this,
	                element = upload.element;

	            if(typeof this._module.onAbort !== 'undefined'){
	                this._module.onAbort();
	            }

	            if (!element.value) {
	                var input = $(element);

	                // Prevent submitting an empty input
	                input.attr("disabled", "disabled");

	                window.setTimeout(function() {
	                    // Restore the input so the Upload remains functional
	                    // in case the user cancels the form submit
	                    input.removeAttr("disabled");
	                }, 0);
	            }
	        },

	        _onParentFormReset: function() {
	            $(".k-upload-files", this.wrapper).remove();
	        },

	        _supportsFormData: function() {
	            return typeof(FormData) != "undefined";
	        },

	        _supportsMultiple: function() {
	            var windows = this._userAgent().indexOf("Windows") > -1;

	            return !kendo.support.browser.opera &&
	                   !(kendo.support.browser.safari && windows);
	        },

	        _supportsDrop: function() {
	            var userAgent = this._userAgent().toLowerCase();
	            var isChrome = /chrome/.test(userAgent);
	            var isSafari = !isChrome && /safari/.test(userAgent);
	            var isWindowsSafari = isSafari && /windows/.test(userAgent);

	            return !isWindowsSafari && this._supportsFormData() && (this.options.async.saveUrl);
	        },

	        _userAgent: function() {
	            return navigator.userAgent;
	        },

	        _setupDropZone: function() {
	            var that = this;

	            var ns = that._ns;
	            var dropZone = $(".k-dropzone", that.wrapper)

	                .on("dragenter" + ns, stopEvent)
	                .on("dragover" + ns, function(e) {
	                    if(e.originalEvent){
	                        e.originalEvent.dataTransfer.dropEffect = "copy";
	                    }
	                    e.preventDefault();
	                 })
	                .on("drop" + ns, $.proxy(that._onDrop, that));

	            if (!dropZone.find(".k-dropzone-hint").length) {
	                dropZone.append($("<em class='k-dropzone-hint'>" + that.localization.dropFilesHere + "</em>"));
	            }

	            bindDragEventWrappers(dropZone, ns,
	                function() {
	                    if (!dropZone.closest('.k-upload').hasClass("k-state-disabled")) {
	                        dropZone.addClass("k-dropzone-hovered");
	                    }
	                },
	                function() { dropZone.removeClass("k-dropzone-hovered"); });

	            that._bindDocumentDragEventWrappers(dropZone);
	        },

	        _setupCustomDropZone: function() {
	            var that = this;
	            var dropZone = $(that.options.dropZone);

	            if (!that.wrapper.find(".k-dropzone-hint").length) {
	                $(".k-dropzone", that.wrapper)
	                    .append($("<em class='k-dropzone-hint k-hidden'>" + that.localization.dropFilesHere + "</em>"));
	            } else {
	                // Dropzone hint in upload should be hidden if customDropZone is used
	                $('.k-dropzone-hint', that.wrapper).addClass('k-hidden');
	            }

	            var ns = that._ns;
	            dropZone.on("dragenter" + ns, stopEvent)
	                    .on("dragover" + ns, function(e) {
	                        if(e.originalEvent){
	                            e.originalEvent.dataTransfer.dropEffect = "copy";
	                        }
	                        e.preventDefault();
	                    })
	                    .on("drop" + ns, $.proxy(that._onDrop, that));

	            bindDragEventWrappers(dropZone, ns,
	                function(e) {
	                    if (!that.wrapper.hasClass("k-state-disabled")) {
	                        dropZone.removeClass("k-dropzone-hovered");
	                        dropZone.addClass("k-dropzone-hovered");
	                        $(e.target).addClass("k-dropzone-hovered");
	                    }
	                },
	                function() {
	                    dropZone.removeClass("k-dropzone-hovered");
	                    dropZone.find('.k-dropzone-hovered').removeClass("k-dropzone-hovered");
	                }
	            );

	            that._bindDocumentDragEventWrappers(dropZone);
	        },

	        _bindDocumentDragEventWrappers: function(dropZone) {
	            var that = this;
	            var ns = that._ns;

	            bindDragEventWrappers($(document), ns,
	                function() {
	                    if (!that.wrapper.hasClass("k-state-disabled")) {
	                        dropZone.addClass("k-dropzone-active");
	                        dropZone.closest('.k-upload').removeClass('k-upload-empty');
	                        dropZone.find('.k-dropzone-hint').removeClass('k-hidden');
	                    }
	                },
	                function() {
	                    dropZone.removeClass("k-dropzone-active");
	                    dropZone.find('.k-dropzone-hint').addClass('k-hidden');
	                    if ($('li.k-file', dropZone.closest('.k-upload')).length === 0) {
	                        dropZone.closest('.k-upload').addClass('k-upload-empty');
	                    }
	                }
	            );
	        },

	        _toggleDropZone: function() {
	            var that = this,
	                dropZone = that.options.dropZone;

	            if (!that._supportsDrop()) {
	                return;
	            }

	            $(dropZone).off(that._ns);
	            $(".k-dropzone", that.wrapper).off(that._ns);

	            if (dropZone !== "") {
	                that._setupCustomDropZone();
	            } else {
	                that._setupDropZone();
	            }
	        },

	        _supportsRemove: function() {
	            return !!this.options.async.removeUrl;
	        },

	        _submitRemove: function(fileNames, eventArgs, onSuccess, onError) {
	            var upload = this,
	                removeField = upload.options.async.removeField || "fileNames",
	                params = $.extend(eventArgs.data, antiForgeryTokens());

	            params[removeField] = fileNames;

	            jQuery.ajax({
	                  type: this.options.async.removeVerb,
	                  dataType: "json",
	                  dataFilter: normalizeJSON,
	                  url: this.options.async.removeUrl,
	                  traditional: true,
	                  data: params,
	                  headers: eventArgs.headers,
	                  success: onSuccess,
	                  error: onError,
	                  xhrFields:{
	                    withCredentials: this.options.async.withCredentials
	                  }
	            });
	        },

	        _wrapInput: function(input) {
	            var that = this;
	            var options = that.options;
	            input.wrap("<div class='k-widget k-upload'><div class='k-dropzone'><div class='k-button k-upload-button' aria-label='" + this.localization.select + "'></div></div></div>");

	            if (!options.async.saveUrl) {
	                input.closest(".k-upload").addClass("k-upload-sync");
	            } else {
	                input.closest(".k-upload").addClass("k-upload-async");
	            }

	            input.closest(".k-upload").addClass("k-upload-empty");

	            input.closest(".k-button")
	                .append("<span>" + this.localization.select + "</span>");

	            return input.closest(".k-upload");
	        },

	        _checkAllComplete: function() {
	            if ($(".k-file.k-file-progress", this.wrapper).length === 0) {
	                this.trigger(COMPLETE);
	            }
	        },

	        _inputFiles: function(sourceInput) {
	            return inputFiles(sourceInput);
	        }
	    });

	    // Synchronous upload module
	    var syncUploadModule = function(upload) {
	        this.name = "syncUploadModule";
	        this.element = upload.wrapper;
	        this.upload = upload;
	        this.element
	            .closest("form")
	                .attr("enctype", "multipart/form-data")
	                .attr("encoding", "multipart/form-data");
	    };

	    syncUploadModule.prototype = {
	        onSelect: function(e, files) {
	            var upload = this.upload;
	            var sourceInput = $(e.target);
	            var filesContainErrors = upload._filesContainValidationErrors(files);

	            upload._addInput(sourceInput);

	            var fileData = { "fileNames": files };

	            if(filesContainErrors) {
	                sourceInput.remove();
	            } else {
	                fileData.relatedInput = sourceInput;
	            }

	            var file = upload._enqueueFile(getFileName(sourceInput), fileData);

	            if(filesContainErrors) {
	                upload._hideUploadProgress(file);
	            }

	            upload._fileAction(file, REMOVE);
	        },

	        onRemove: function(e) {
	            var fileEntry = getFileEntry(e);
	            var relatedInput = fileEntry.data("relatedInput");

	            if(relatedInput) {
	                relatedInput.remove();
	            }

	            this.upload._removeFileEntry(fileEntry);
	        }
	    };

	    var iframeUploadModule = function(upload) {
	        this.name = "iframeUploadModule";
	        this.element = upload.wrapper;
	        this.upload = upload;
	        this.iframes = [];
	    };

	    Upload._frameId = 0;

	    iframeUploadModule.prototype = {
	        onSelect: function(e, files) {
	            var upload = this.upload;
	            var sourceInput = $(e.target);
	            var hasValidationErrors = upload._filesContainValidationErrors(files);

	            var fileEntry = this.prepareUpload(sourceInput, files, hasValidationErrors);

	            if (upload.options.async.autoUpload) {
	                if(!hasValidationErrors) {
	                    this.performUpload(fileEntry);
	                } else {
	                    upload._fileAction(fileEntry, REMOVE);
	                    upload._showHeaderUploadStatus(false);
	                }
	            } else {
	                upload._fileAction(fileEntry, REMOVE);

	                if(!hasValidationErrors) {
	                    upload._showActionButtons();
	                } else {
	                    upload._updateHeaderUploadStatus();
	                }
	            }

	            if(hasValidationErrors) {
	                upload._hideUploadProgress(fileEntry);
	            }
	        },

	        prepareUpload: function(sourceInput, files, hasValidationErrors) {
	            var upload = this.upload;
	            var activeInput = $(upload.element);
	            var name = upload.options.async.saveField || sourceInput.attr("name");
	            var fileEntry, fileData, iframe, form;

	            upload._addInput(sourceInput);
	            sourceInput.attr("name", name);

	            if(!hasValidationErrors) {
	                iframe = this.createFrame(upload.name + "_" + Upload._frameId++);
	                this.registerFrame(iframe);

	                form = this.createForm(upload.options.async.saveUrl, iframe.attr("name"))
	                           .append(activeInput);

	                fileData = { "frame": iframe, "relatedInput": activeInput, "fileNames": files };
	            } else {
	                sourceInput.remove();

	                fileData = { "fileNames": files };
	            }

	            fileEntry = upload._enqueueFile(getFileName(sourceInput), fileData);

	            if(iframe) {
	                iframe.data({ "form": form, "file": fileEntry });
	            }

	            return fileEntry;
	        },

	        performUpload: function(fileEntry) {
	            var e = { files: fileEntry.data("fileNames") };
	            var iframe = fileEntry.data("frame");
	            var upload = this.upload;
	            var fileValidation = fileEntry.find('.k-file-validation-message');
	            var fileInfo = fileEntry.find('.k-file-information');
	            var fileSize = fileEntry.find('.k-file-size');

	            if (!upload.trigger(UPLOAD, e)) {
	                upload._hideActionButtons();
	                upload._showHeaderUploadStatus(true);

	                iframe.appendTo(document.body);

	                var form = iframe.data("form")
	                    .attr("action", upload.options.async.saveUrl)
	                    .appendTo(document.body);

	                e.data = $.extend({ }, e.data, antiForgeryTokens());
	                for (var key in e.data) {
	                    var dataInput = form.find("input[name='" + key + "']");
	                    if (dataInput.length === 0) {
	                        dataInput = $("<input>", { type: "hidden", name: key })
	                            .prependTo(form);
	                    }
	                    dataInput.val(e.data[key]);
	                }

	                upload._fileAction(fileEntry, CANCEL);
	                upload._fileState(fileEntry, "uploading");
	                $(fileEntry).removeClass("k-file-error").addClass("k-file-progress");

	                if(fileValidation.length > 0) {
	                    fileValidation.remove();
	                }

	                if(fileInfo.length > 0) {
	                    fileInfo.removeClass('k-hidden');
	                } else if (fileSize.length > 0) {
	                    fileSize.removeClass('k-hidden');
	                }

	                iframe
	                    .one("load", $.proxy(this.onIframeLoad, this));

	                form[0].submit();
	            } else {
	                upload._removeFileEntry(iframe.data("file"));
	                this.cleanupFrame(iframe);
	                this.unregisterFrame(iframe);
	            }
	        },

	        onSaveSelected: function() {
	            var module = this;
	            var upload = module.upload;

	            $(".k-file", this.element).each(function() {
	                var fileEntry = $(this);
	                var started = isFileUploadStarted(fileEntry);
	                var hasValidationErrors = upload._filesContainValidationErrors(fileEntry.data("fileNames"));

	                if (!started && !hasValidationErrors) {
	                    module.performUpload(fileEntry);
	                }
	            });
	        },

	        onIframeLoad: function(e) {
	            var iframe = $(e.target),
	                responseText;

	            try {
	                responseText = iframe.contents().text();
	            } catch (ex) {
	                responseText = "Error trying to get server response: " + ex;
	            }

	            this.processResponse(iframe, responseText);
	        },

	        processResponse: function(iframe, responseText) {
	            var fileEntry = iframe.data("file"),
	                module = this,
	                fakeXHR = {
	                    responseText: responseText
	                };
	            tryParseJSON(responseText,
	                function(jsonResult) {
	                    $.extend(fakeXHR, { statusText: "OK", status: "200" });
	                    module.upload._onFileProgress({ target : $(fileEntry, module.upload.wrapper) }, 100);
	                    module.upload._onUploadSuccess({ target : $(fileEntry, module.upload.wrapper) }, jsonResult, fakeXHR);

	                    module.cleanupFrame(iframe);
	                    module.unregisterFrame(iframe);
	                },
	                function() {
	                    $.extend(fakeXHR, { statusText: "error", status: "500" });
	                    module.upload._onUploadError({ target : $(fileEntry, module.upload.wrapper) }, fakeXHR);
	                }
	            );
	        },

	        onCancel: function(e) {
	            var iframe = $(e.target).data("frame");

	            this.stopFrameSubmit(iframe);
	            this.cleanupFrame(iframe);
	            this.unregisterFrame(iframe);
	            this.upload._removeFileEntry(iframe.data("file"));
	        },

	        onRetry: function(e) {
	            var fileEntry = getFileEntry(e);
	            this.performUpload(fileEntry);
	        },

	        onRemove: function(e, eventArgs, shouldSendRemoveRequest) {
	            var module = this;
	            var upload = module.upload;
	            var fileEntry = getFileEntry(e);
	            var iframe = fileEntry.data("frame");

	            if (iframe) {
	                module.unregisterFrame(iframe);
	                upload._removeFileEntry(fileEntry);
	                module.cleanupFrame(iframe);
	            } else {
	                if (fileEntry.hasClass("k-file-success")) {
	                    removeUploadedFile(fileEntry, upload, eventArgs, shouldSendRemoveRequest);
	                } else {
	                    upload._removeFileEntry(fileEntry);
	                }
	            }
	        },

	        onAbort: function() {
	            var element = this.element,
	                module = this;

	            $.each(this.iframes, function() {
	                $("input", this.data("form")).appendTo(element);
	                module.stopFrameSubmit(this[0]);
	                this.data("form").remove();
	                this.remove();
	            });

	            this.iframes = [];
	        },

	        createFrame: function(id) {
	            return $(
	                "<iframe" +
	                " name='" + id + "'" +
	                " id='" + id + "'" +
	                " style='display:none;' />"
	            );
	        },

	        createForm: function(action, target) {
	            return $(
	                "<form enctype='multipart/form-data' method='POST'" +
	                " action='" + action + "'" +
	                " target='" + target + "'" +
	                "/>");
	        },

	        stopFrameSubmit: function(frame) {
	            if (typeof(frame.stop) != "undefined") {
	                frame.stop();
	            } else if (frame.document) {
	                frame.document.execCommand("Stop");
	            }
	        },

	        registerFrame: function(frame) {
	            this.iframes.push(frame);
	        },

	        unregisterFrame: function(frame) {
	            this.iframes = $.grep(this.iframes, function(value) {
	                return value.attr("name") != frame.attr("name");
	            });
	        },

	        cleanupFrame: function(frame) {
	            var form = frame.data("form");

	            frame.data("file").data("frame", null);

	            setTimeout(function () {
	                form.remove();
	                frame.remove();
	            }, 1);
	        }
	    };

	    // FormData upload module
	    var formDataUploadModule = function(upload) {
	        this.name = "formDataUploadModule";
	        this.element = upload.wrapper;
	        this.upload = upload;
	        this.position = {};
	        this.metaData = {};
	        this.cancelled = {};
	        this.resume = {};
	        this.paused = {};
	        this.retries = {};
	    };

	    formDataUploadModule.prototype = {
	        onSelect: function(e, files) {
	            var upload = this.upload;
	            var module = this;
	            var sourceElement = $(e.target);
	            var fileEntries = this.prepareUpload(sourceElement, files);
	            var hasValidationErrors;
	            var prev;

	            $.each(fileEntries, function(index) {
	                hasValidationErrors = upload._filesContainValidationErrors($(this.data("fileNames")));

	                if (upload.options.async.autoUpload) {
	                    if(!hasValidationErrors) {
	                        if(upload.options.async.chunkSize){
	                            module.prepareChunk(this);
	                            prev = this.prev();

	                            if(upload.options.async.concurrent || (index === 0 && !prev.length) ||
	                             (index === 0 && prev.hasClass("k-file-success"))){
	                                module.performUpload(this);
	                            }
	                        }else{
	                            module.performUpload(this);
	                        }
	                    } else {
	                        upload._fileAction(this, REMOVE);
	                        upload._showHeaderUploadStatus(false);
	                    }
	                } else {
	                    upload._fileAction(this, REMOVE);

	                    if(!hasValidationErrors) {
	                        upload._showActionButtons();
	                        this.addClass("k-toupload");
	                    } else {
	                        upload._updateHeaderUploadStatus();
	                    }
	                }

	                if(hasValidationErrors) {
	                    upload._hideUploadProgress(this);
	                }
	            });
	        },

	        prepareUpload: function(sourceElement, files) {
	            var fileEntries = this.enqueueFiles(files);

	            if (sourceElement.is("input")) {
	                $.each(fileEntries, function() {
	                    $(this).data("relatedInput", sourceElement);
	                });
	                sourceElement.data("relatedFileEntries", fileEntries);
	                this.upload._addInput(sourceElement);
	            }

	            return fileEntries;
	        },

	        enqueueFiles: function(files) {
	            var upload = this.upload;
	            var name;
	            var i;
	            var filesLength = files.length;
	            var currentFile;
	            var fileEntry;
	            var fileEntries = [];

	            if (upload.options.async.batch === true) {
	                name = $.map(files, function(file) { return file.name; }).join(", ");

	                if(upload.directory || upload.options.directoryDrop){
	                    $(files).each(function(){
	                        if(this.rawFile.webkitRelativePath || this.rawFile.relativePath){
	                            this.name = this.rawFile.webkitRelativePath || this.rawFile.relativePath;
	                        }
	                    });
	                }

	                fileEntry = upload._enqueueFile(name, { fileNames: files });
	                fileEntry.data("files", files);

	                fileEntries.push(fileEntry);
	            } else {
	                for (i = 0; i < filesLength; i++) {
	                    currentFile = files[i];
	                    name = currentFile.name;
	                    if(upload.directory || upload.options.directoryDrop){
	                        if(currentFile.rawFile.webkitRelativePath || currentFile.rawFile.relativePath){
	                            currentFile.name = currentFile.rawFile.webkitRelativePath || currentFile.rawFile.relativePath;
	                        }
	                    }
	                    fileEntry = upload._enqueueFile(name, { fileNames: [ currentFile ] });
	                    fileEntry.data("files", [ currentFile ]);

	                    fileEntries.push(fileEntry);
	                }
	            }

	            return fileEntries;
	        },

	        performUpload: function(fileEntry) {
	            var upload = this.upload,
	                formData = this.createFormData(),
	                xhr = this.createXHR(),
	                e = {
	                    files: fileEntry.data("fileNames"),
	                    XMLHttpRequest: xhr
	                },
	                files;
	            var fileValidation = fileEntry.find('.k-file-validation-message');
	            var fileInfo = fileEntry.find('.k-file-information');
	            var fileSize = fileEntry.find('.k-file-size');

	            if (!upload.trigger(UPLOAD, e)) {
	                if (fileEntry.find(".k-i-cancel").length === 0) {
	                    if (upload.options.async.chunkSize) {
	                        upload._fileAction(fileEntry, PAUSE);
	                    }
	                    upload._fileAction(fileEntry, CANCEL, upload.options.async.chunkSize);
	                }

	                if (!upload.wrapper.find(".k-toupload").length) {
	                    upload._hideActionButtons();
	                }

	                upload._showHeaderUploadStatus(true);

	                if (e.formData) {
	                    formData = e.formData;
	                } else {
	                    e.data = $.extend({ }, e.data, antiForgeryTokens());
	                    for (var key in e.data) {
	                        formData.append(key, e.data[key]);
	                    }

	                    files = fileEntry.data("files");
	                    if (files) {
	                        this.populateFormData(formData, files);
	                    }
	                }

	                upload._fileState(fileEntry, "uploading");
	                $(fileEntry).removeClass("k-file-error").addClass("k-file-progress");

	                if(fileValidation.length > 0) {
	                    fileValidation.remove();
	                }

	                if(fileInfo.length > 0) {
	                    fileInfo.removeClass('k-hidden');
	                } else if (fileSize.length > 0) {
	                    fileSize.removeClass('k-hidden');
	                }

	                if (upload.options.async.useArrayBuffer && window.FileReader) {
	                    this._readFile(upload.options.async.saveUrl, formData, fileEntry, xhr);
	                } else {
	                    this.postFormData(upload.options.async.saveUrl, formData, fileEntry, xhr);
	                }
	            } else {
	                this.removeFileEntry(fileEntry);
	            }
	        },

	        _readFile: function(saveUrl, formData, fileEntry, xhr){
	            var that = this;
	            var upload = that.upload;
	            var file = fileEntry.data("files")[0];

	            var reader = new FileReader();
	            reader.onload = function (e) {
	                try{
	                    if(!that.fileArrayBuffer){
	                        that.fileArrayBuffer = e.target.result;
	                    }else{
	                        that.fileArrayBuffer = that._appendBuffer(that.fileArrayBuffer, e.target.result);
	                    }
	                }catch(err) {
	                    upload._onUploadError({ target : $(fileEntry, upload.wrapper) }, xhr);
	                    return;
	                }

	                if(that.position[file.uid] > file.size){
	                    that.postFormData(upload.options.async.saveUrl, that.fileArrayBuffer, fileEntry, xhr);
	                    that.fileArrayBuffer = null;
	                }else{
	                    that._readFile(saveUrl, formData, fileEntry, xhr);
	                }
	            };
	            reader.onerror = function () {
	                upload._onUploadError({ target : $(fileEntry, upload.wrapper) }, xhr);
	            };
	            reader.readAsArrayBuffer(that._getCurrentChunk(file.rawFile, file.uid));
	        },

	        _appendBuffer: function(buffer1, buffer2) {
	            var tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);

	            tmp.set(new Uint8Array(buffer1), 0);
	            tmp.set(new Uint8Array(buffer2), buffer1.byteLength);

	            return tmp.buffer;
	        },

	        onSaveSelected: function() {
	            var module = this;
	            var upload = module.upload;

	            $(".k-toupload", this.element).filter(function() {
	                var fileEntry = $(this);
	                var started = isFileUploadStarted(fileEntry);
	                var hasValidationErrors = upload._filesContainValidationErrors(fileEntry.data("fileNames"));

	                return !started && !hasValidationErrors;
	            }).each(function(index) {
	                var fileEntry = $(this);
	                var prevEntry = fileEntry.prev();

	                fileEntry.removeClass("k-toupload");
	                if(upload.options.async.chunkSize){
	                    module.prepareChunk(fileEntry);

	                    if(upload.options.async.concurrent || (index === 0 && !prevEntry.length) ||
	                        (index === 0 && prevEntry.hasClass("k-file-success") || prevEntry.hasClass("k-file-error"))){
	                        module.performUpload(fileEntry);
	                    }
	                }else{
	                    module.performUpload(fileEntry);
	                }
	            });
	        },

	        onCancel: function(e) {
	            var fileEntry = getFileEntry(e);

	            if(this.upload.options.async.chunkSize){
	                this.cancelled[fileEntry.data("uid")] = true;
	            }
	            this.stopUploadRequest(fileEntry);
	            this.removeFileEntry(fileEntry);
	        },

	        onPause: function(e) {
	            var fileEntry = getFileEntry(e);
	            var fileUid = fileEntry.data("uid");
	            var async = this.upload.options.async;

	            if(async.chunkSize){
	                this.retries[fileUid] = async.maxAutoRetries + 1;
	                this.paused[fileUid] = true;
	                this.resume[fileUid] = false;
	            }
	        },

	        onResume: function(e) {
	            var fileEntry = getFileEntry(e);
	            var fileUid = fileEntry.data("uid");

	            if(this.upload.options.async.chunkSize){
	                delete this.paused[fileUid];
	                this.resume[fileUid] = true;
	                this.retries[fileEntry.data("uid")] = 1;
	                this._increaseChunkIndex(fileUid);
	                this.performUpload(fileEntry);
	            }
	        },

	        onRetry: function(e) {
	            var fileEntry = getFileEntry(e);
	            var async = this.upload.options.async;

	            if(async.chunkSize){
	                this.retries[fileEntry.data("uid")] = async.maxAutoRetries + 1;
	                delete this.paused[fileEntry.data("uid")];
	            }

	            this.performUpload(fileEntry);
	        },

	        onRemove: function(e, eventArgs, shouldSendRemoveRequest) {
	            var module = this;
	            var upload = module.upload;
	            var fileEntry = getFileEntry(e);
	            var async = this.upload.options.async;

	            if(async.chunkSize){
	                this.retries[fileEntry.data("uid")] = async.maxAutoRetries + 1;
	            }

	            if (fileEntry.hasClass("k-file-success")) {
	                removeUploadedFile(fileEntry, upload, eventArgs, shouldSendRemoveRequest);
	            } else {
	                module.removeFileEntry(fileEntry);
	            }
	        },

	        createXHR: function() {
	            return new XMLHttpRequest();
	        },

	        postFormData: function(url, data, fileEntry, xhr) {
	            var module = this;

	            fileEntry.data("request", xhr);

	            xhr.addEventListener("load", function(e) {
	                module.onRequestSuccess.call(module, e, fileEntry);
	            }, false);

	            xhr.addEventListener(ERROR, function(e) {
	                module.onRequestError.call(module, e, fileEntry);
	            }, false);

	            xhr.upload.addEventListener("progress", function(e) {
	                module.onRequestProgress.call(module, e, fileEntry);
	            }, false);

	            xhr.open("POST", url, true);
	            xhr.withCredentials = this.upload.options.async.withCredentials;

	            var accept = this.upload.options.async.accept;
	            if (accept) {
	                xhr.setRequestHeader("Accept", accept);
	            }

	            xhr.send(data);
	        },

	        createFormData: function() {
	            return new FormData();
	        },

	        populateFormData: function(data, files) {
	            var chunk;
	            var i;
	            var length = files.length;
	            var uid;
	            var upload = this.upload;

	            if(upload.options.async.chunkSize){
	                 uid = files[0].uid;
	                 chunk = this._getCurrentChunk(files[0].rawFile, uid);

	                data.append(
	                    upload.options.async.saveField || upload.name,
	                    chunk
	                );

	                var serializedMetaData = JSON.stringify(this.metaData[uid]);
	                data.append("metadata", serializedMetaData);
	            }else{
	                 for (i = 0; i < length; i++) {
	                    data.append(
	                        upload.options.async.saveField || upload.name,
	                        files[i].rawFile
	                    );
	                 }
	            }

	            return data;
	        },

	        onRequestSuccess: function(e, fileEntry) {
	            var xhr = e.target,
	                module = this;

	            function raiseError() {
	                module.upload._onUploadError({ target : $(fileEntry, module.upload.wrapper) }, xhr);
	            }

	            function parseSuccess(jsonResult) {
	                var batch = module.upload.options.async.batch;
	                var chunkSize = module.upload.options.async.chunkSize;
	                var concurrent = module.upload.options.async.concurrent;
	                var fileUid = jsonResult.fileUid;

	                if(module.paused[fileUid] || module.cancelled[fileUid]){
	                    return;
	                }

	                delete module.retries[fileUid];

	                if(chunkSize && !batch && !jsonResult.uploaded){

	                    module._increaseChunkIndex(fileUid);
	                    module.performUpload(fileEntry);
	                }else if(chunkSize && !batch && !concurrent && fileEntry.next().length && !fileEntry.next().hasClass("k-toupload")) {
	                        module.upload._onFileProgress({ target : $(fileEntry, module.upload.wrapper) }, 100);
	                        module._resetChunkIndex(fileUid);
	                        module.upload._onUploadSuccess({ target : $(fileEntry, module.upload.wrapper) }, jsonResult, xhr);

	                        module.performUpload(fileEntry.next());
	                }else{
	                    module.upload._onFileProgress({ target : $(fileEntry, module.upload.wrapper) }, 100);
	                    module.upload._onUploadSuccess({ target : $(fileEntry, module.upload.wrapper) }, jsonResult, xhr);
	                    module.cleanupFileEntry(fileEntry);
	                }
	            }

	            if (xhr.status >= 200 && xhr.status <= 299) {
	                tryParseJSON(xhr.responseText,
	                    parseSuccess,
	                    raiseError
	                );
	            } else {
	                raiseError();
	            }
	        },

	        onRequestError: function(e, fileEntry) {
	            var xhr = e.target;

	            this.upload._onUploadError({ target : $(fileEntry, this.upload.wrapper) }, xhr);
	        },

	        cleanupFileEntry: function(fileEntry) {
	            var relatedInput = fileEntry.data("relatedInput"),
	                uploadComplete = true;

	            if (relatedInput) {
	                $.each(relatedInput.data("relatedFileEntries") || [], function() {
	                    // Exclude removed file entries and self
	                    if (this.parent().length > 0 && this[0] != fileEntry[0]) {
	                        uploadComplete = uploadComplete && this.hasClass("k-file-success");
	                    }
	                });

	                if (uploadComplete) {
	                    relatedInput.remove();
	                }
	            }
	        },

	        removeFileEntry: function(fileEntry) {
	            var chunkSize = this.upload.options.async.chunkSize;
	            var concurrent = this.upload.options.async.concurrent;
	            var isUploadButtonVisible = this.upload.wrapper.find(".k-upload-selected").length > 0;

	            this.cleanupFileEntry(fileEntry);
	            if(chunkSize && !concurrent && !isUploadButtonVisible){
	                 if(fileEntry.next().length){
	                     this.performUpload(fileEntry.next());
	                 }
	            }
	            this.upload._removeFileEntry(fileEntry);
	        },

	        onRequestProgress: function(e, fileEntry) {
	            var percentComplete = Math.round(e.loaded * 100 / e.total);
	            var fileUid = fileEntry.data("uid");
	            var fileMetaData;

	            if(this.upload.options.async.chunkSize){
	                fileMetaData = this.metaData[fileUid];
	                percentComplete = fileMetaData && fileMetaData.totalChunks ? Math.round(((fileMetaData.chunkIndex)/fileMetaData.totalChunks)*100):100;
	            }
	            this.upload._onFileProgress({ target : $(fileEntry, this.upload.wrapper) }, percentComplete);
	        },

	        stopUploadRequest: function(fileEntry) {
	            fileEntry.data("request").abort();
	        },

	        prepareChunk: function (fileEntry) {
	            var file = fileEntry.data("files")[0];
	            var rawFile = file.rawFile;
	            var uid = file.uid;
	            var chunkSize  = this.upload.options.async.chunkSize;
	            this.position[uid] = 0;

	            this.metaData[uid] = {
	                chunkIndex: 0,
	                contentType: rawFile.type,
	                fileName: rawFile.name,
	                relativePath: file.name,
	                totalFileSize: rawFile.size,
	                totalChunks: Math.ceil(rawFile.size / chunkSize),
	                uploadUid: uid
	            };
	        },

	        _decreaseChunkIndex: function(uid){
	            this.metaData[uid].chunkIndex--;
	        },

	        _increaseChunkIndex: function(uid){
	            this.metaData[uid].chunkIndex++;
	        },

	        _resetChunkIndex: function(uid){
	            this.metaData[uid].chunkIndex = 0;
	        },

	        _decreasePosition: function(uid){
	            this.position[uid] -= this.upload.options.async.chunkSize;
	        },

	        _getCurrentChunk: function (file, uid) {
	            var oldPosition = this.position[uid];
	            var methodToInvoke;
	            var async = this.upload.options.async;
	            var chunkSize = async.chunkSize || async.bufferChunkSize;

	            if(!this.position[uid]){
	                this.position[uid] = 0;
	            }
	            this.position[uid] += chunkSize;

	            if (!!(methodToInvoke = this._getChunker(file))){
	                return file[methodToInvoke](oldPosition, this.position[uid]);
	            }else{
	                return file;
	            }
	        },

	        _getChunker: function (file) {
	            if (file.slice) {
	                return "slice";
	            }else if (file.mozSlice) {
	                return "mozSlice";
	            }else if (file.webkitSlice) {
	                    return "webkitSlice";
	            }else {
	                return null;
	            }
	        }
	    };

	    // Helper functions
	    function getFileName(input) {
	        return $.map(inputFiles(input), function (file) {
	            return file.name;
	        }).join(", ");
	    }

	    function inputFiles($input) {
	        var input = $input[0];

	        if (input.files) {
	            return getAllFileInfo(input.files);
	        } else {
	            return [{
	                name: stripPath(input.value),
	                extension: getFileExtension(input.value),
	                size: null
	            }];
	        }
	    }

	    function getAllFileInfo(rawFiles) {
	        return $.map(rawFiles, function (file) {
	            return getFileInfo(file);
	        });
	    }

	    function getFileInfo(rawFile) {
	        // Older Firefox versions (before 3.6) use fileName and fileSize
	        var fileName = rawFile.name || rawFile.fileName;
	        return {
	            name: kendo.htmlEncode(fileName),
	            extension: getFileExtension(fileName),
	            size: typeof rawFile.size == "number" ? rawFile.size : rawFile.fileSize, //rawFile.size || rawFile.fileSize,
	            rawFile: rawFile
	        };
	    }

	    function getFileExtension(fileName) {
	        var matches = fileName.match(rFileExtension);
	        return matches ? matches[0] : "";
	    }

	    function stripPath(name) {
	        var slashIndex = name.lastIndexOf("\\");
	        return (slashIndex != -1) ? name.substr(slashIndex + 1) : name;
	    }

	    function assignGuidToFiles(files, unique) {
	        var uid = kendo.guid();

	        return $.map(files, function(file){
	            file.uid = unique ? kendo.guid() : uid;

	            return file;
	        });
	    }

	    function validateFiles(files, validationInfo) {
	        var allowedExtensions = parseAllowedExtensions(validationInfo.allowedExtensions);
	        var maxFileSize = validationInfo.maxFileSize;
	        var minFileSize = validationInfo.minFileSize;

	        for(var i = 0; i < files.length; i++) {
	            validateFileExtension(files[i], allowedExtensions);
	            validateFileSize(files[i], minFileSize, maxFileSize);
	        }
	    }

	    function parseAllowedExtensions(extensions) {
	        var allowedExtensions = $.map(extensions, function(ext){
	            var parsedExt = (ext.substring(0, 1) === ".") ? ext : ("." + ext);
	            return parsedExt.toLowerCase();
	        });

	        return allowedExtensions;
	    }

	    function validateFileExtension(file, allowedExtensions) {
	        if(allowedExtensions.length > 0) {
	            if(allowedExtensions.indexOf(file.extension.toLowerCase()) < 0) {
	                file.validationErrors = file.validationErrors || [];
	                if($.inArray(INVALIDFILEEXTENSION, file.validationErrors) === -1) {
	                    file.validationErrors.push(INVALIDFILEEXTENSION);
	                }
	            }
	        }
	    }

	    function validateFileSize(file, minFileSize, maxFileSize) {
	        if(minFileSize !== 0 && file.size < minFileSize) {
	            file.validationErrors = file.validationErrors || [];
	            if($.inArray(INVALIDMINFILESIZE, file.validationErrors) === -1) {
	                file.validationErrors.push(INVALIDMINFILESIZE);
	            }
	        }

	        if(maxFileSize !== 0 && file.size > maxFileSize) {
	            file.validationErrors = file.validationErrors || [];
	            if($.inArray(INVALIDMAXFILESIZE, file.validationErrors) === -1) {
	                file.validationErrors.push(INVALIDMAXFILESIZE);
	            }
	        }
	    }

	    function getTotalFilesSizeMessage(files) {
	        var totalSize = 0;

	        if(typeof files[0].size == "number") {
	            for(var i = 0; i < files.length; i++) {
	                if(files[i].size) {
	                    totalSize += files[i].size;
	                }
	            }
	        } else {
	            return "";
	        }

	        totalSize /= 1024;

	        if(totalSize < 1024) {
	            return totalSize.toFixed(2) + " KB";
	        } else {
	            return (totalSize / 1024).toFixed(2) + " MB";
	        }
	    }

	    function shouldRemoveFileEntry(upload) {
	        return !upload.multiple && $(".k-file", upload.wrapper).length > 1;
	    }

	    function removeUploadedFile(fileEntry, upload, eventArgs, shouldSendRemoveRequest) {
	        if (!upload._supportsRemove()) {
	            if(shouldRemoveFileEntry(upload) || !shouldSendRemoveRequest) {
	                upload._removeFileEntry(fileEntry);
	            }

	            return;
	        }

	        var files = fileEntry.data("fileNames");
	        var fileNames = $.map(files, function(file) { return file.name; });

	        if(shouldSendRemoveRequest === false) {
	            upload._removeFileEntry(fileEntry);

	            return;
	        }

	        upload._submitRemove(fileNames, eventArgs,
	            function onSuccess(data, textStatus, xhr) {
	                var prevented = upload.trigger(SUCCESS, {
	                    operation: "remove",
	                    files: files,
	                    response: data,
	                    XMLHttpRequest: xhr
	                });

	                if(!prevented) {
	                    upload._removeFileEntry(fileEntry);
	                }
	            },

	            function onError(xhr) {
	                if(shouldRemoveFileEntry(upload)) {
	                    upload._removeFileEntry(fileEntry);
	                }

	                upload.trigger(ERROR, {
	                    operation: "remove",
	                    files: files,
	                    XMLHttpRequest: xhr
	                });

	                logToConsole("Server response: " + xhr.responseText);
	            }
	        );
	    }

	    function tryParseJSON(input, onSuccess, onError) {
	        var success = false,
	            json = "";

	        try {
	            json = $.parseJSON(normalizeJSON(input));
	            success = true;
	        } catch (e) {
	            onError();
	        }

	        if (success) {
	            onSuccess(json);
	        }
	    }

	    function normalizeJSON(input) {
	        if (typeof input === "undefined" || input === "") {
	            input = "{}";
	        }

	        return input;
	    }

	    function stopEvent(e) {
	        if(e.originalEvent){
	            e.originalEvent.dataTransfer.dropEffect = "copy";
	        }
	        e.stopPropagation(); e.preventDefault();
	    }

	    function bindDragEventWrappers(element, namespace, onDragEnter, onDragLeave) {
	        var hideInterval, lastDrag;

	        element
	            .on("dragenter" + namespace, function(e) {
	                onDragEnter(e);
	                lastDrag = new Date();

	                if (!hideInterval) {
	                    hideInterval = setInterval(function() {
	                        var sinceLastDrag = new Date() - lastDrag;
	                        if (sinceLastDrag > 100) {
	                            onDragLeave();

	                            clearInterval(hideInterval);
	                            hideInterval = null;
	                        }
	                    }, 100);
	                }
	            })
	            .on("dragover" + namespace, function() {
	                lastDrag = new Date();
	            });
	    }

	    function isFileUploadStarted(fileEntry) {
	        return fileEntry.is(".k-file-progress, .k-file-success, .k-file-error");
	    }

	    function getFileEntry(e) {
	        return $(e.target).closest(".k-file");
	    }

	    kendo.ui.plugin(Upload);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1048)))

/***/ })

/******/ });

/***/ }),

/***/ "oJlt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "oNv9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var gridCell_1 = __webpack_require__("hie4");
var constants_1 = __webpack_require__("ZZFX");
var mouseEventService_1 = __webpack_require__("BY3/");
var paginationProxy_1 = __webpack_require__("wYvi");
var focusedCellController_1 = __webpack_require__("4Sr9");
var utils_1 = __webpack_require__("IRr6");
var gridPanel_1 = __webpack_require__("inOk");
var animationFrameService_1 = __webpack_require__("tvEw");
var columnController_1 = __webpack_require__("77lH");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var NavigationService = (function () {
    function NavigationService() {
    }
    NavigationService.prototype.init = function () {
        this.scrollWidth = this.gridOptionsWrapper.getScrollbarWidth();
    };
    NavigationService.prototype.handlePageScrollingKey = function (event) {
        var key = event.which || event.keyCode;
        var alt = event.altKey;
        var ctrl = event.ctrlKey;
        var currentCell = this.mouseEventService.getGridCellForEvent(event).getGridCellDef();
        if (!currentCell) {
            return false;
        }
        var processed = false;
        switch (key) {
            case constants_1.Constants.KEY_PAGE_HOME:
            case constants_1.Constants.KEY_PAGE_END:
                // handle home and end when ctrl & alt are NOT pressed
                if (!ctrl && !alt) {
                    this.onHomeOrEndKey(key);
                    processed = true;
                }
                break;
            case constants_1.Constants.KEY_LEFT:
            case constants_1.Constants.KEY_RIGHT:
                // handle left and right when ctrl is pressed only
                if (ctrl && !alt) {
                    this.onCtrlLeftOrRight(key, currentCell);
                    processed = true;
                }
                break;
            case constants_1.Constants.KEY_UP:
            case constants_1.Constants.KEY_DOWN:
                // handle up and down when ctrl is pressed only
                if (ctrl && !alt) {
                    this.onCtrlUpOrDown(key, currentCell);
                    processed = true;
                }
                break;
            case constants_1.Constants.KEY_PAGE_DOWN:
                // handle page up and page down when ctrl & alt are NOT pressed
                if (!ctrl && !alt) {
                    this.onPageDown(currentCell);
                    processed = true;
                }
                break;
            case constants_1.Constants.KEY_PAGE_UP:
                // handle page up and page down when ctrl & alt are NOT pressed
                if (!ctrl && !alt) {
                    this.onPageUp(currentCell);
                    processed = true;
                }
                break;
        }
        if (processed) {
            event.preventDefault();
        }
        return processed;
    };
    NavigationService.prototype.onPageDown = function (gridCell) {
        var viewport = this.gridPanel.getPrimaryScrollViewport();
        var pixelsInOnePage = viewport.offsetHeight;
        if (this.gridPanel.isHorizontalScrollShowing()) {
            pixelsInOnePage -= this.scrollWidth;
        }
        var pagingPixelOffset = this.paginationProxy.getPixelOffset();
        var currentPageBottomPixel = viewport.scrollTop + pixelsInOnePage;
        var currentPageBottomRow = this.paginationProxy.getRowIndexAtPixel(currentPageBottomPixel + pagingPixelOffset);
        var scrollIndex = currentPageBottomRow;
        var currentCellPixel = this.paginationProxy.getRow(gridCell.rowIndex).rowTop;
        var nextCellPixel = currentCellPixel + pixelsInOnePage - pagingPixelOffset;
        var focusIndex = this.paginationProxy.getRowIndexAtPixel(nextCellPixel + pagingPixelOffset);
        var pageLastRow = this.paginationProxy.getPageLastRow();
        if (focusIndex > pageLastRow) {
            focusIndex = pageLastRow;
        }
        if (scrollIndex > pageLastRow) {
            scrollIndex = pageLastRow;
        }
        this.navigateTo(scrollIndex, 'top', null, focusIndex, gridCell.column);
    };
    NavigationService.prototype.onPageUp = function (gridCell) {
        var viewport = this.gridPanel.getPrimaryScrollViewport();
        var pixelsInOnePage = viewport.offsetHeight;
        if (this.gridPanel.isHorizontalScrollShowing()) {
            pixelsInOnePage -= this.scrollWidth;
        }
        var pagingPixelOffset = this.paginationProxy.getPixelOffset();
        var currentPageTopPixel = viewport.scrollTop;
        var currentPageTopRow = this.paginationProxy.getRowIndexAtPixel(currentPageTopPixel + pagingPixelOffset);
        var scrollIndex = currentPageTopRow;
        var currentRowNode = this.paginationProxy.getRow(gridCell.rowIndex);
        var nextCellPixel = currentRowNode.rowTop + currentRowNode.rowHeight - pixelsInOnePage - pagingPixelOffset;
        var focusIndex = this.paginationProxy.getRowIndexAtPixel(nextCellPixel + pagingPixelOffset);
        var firstRow = this.paginationProxy.getPageFirstRow();
        if (focusIndex < firstRow) {
            focusIndex = firstRow;
        }
        if (scrollIndex < firstRow) {
            scrollIndex = firstRow;
        }
        this.navigateTo(scrollIndex, 'bottom', null, focusIndex, gridCell.column);
    };
    // common logic to navigate. takes parameters:
    // scrollIndex - what row to vertically scroll to
    // scrollType - what position to put scroll index ie top/bottom
    // scrollColumn - what column to horizontally scroll to
    // focusIndex / focusColumn - for page up / down, we want to scroll to one row/column, but focus another
    NavigationService.prototype.navigateTo = function (scrollIndex, scrollType, scrollColumn, focusIndex, focusColumn) {
        if (utils_1._.exists(scrollColumn)) {
            this.gridPanel.ensureColumnVisible(scrollColumn);
        }
        if (utils_1._.exists(scrollIndex)) {
            this.gridPanel.ensureIndexVisible(scrollIndex, scrollType);
        }
        // make sure the cell is rendered, needed if we are to focus
        this.animationFrameService.flushAllFrames();
        // if we don't do this, the range will be left on the last cell, which will leave the last focused cell
        // highlighted.
        this.focusedCellController.setFocusedCell(focusIndex, focusColumn, null, true);
        if (this.rangeController) {
            var gridCell = new gridCell_1.GridCell({ rowIndex: focusIndex, floating: null, column: focusColumn });
            this.rangeController.setRangeToCell(gridCell);
        }
    };
    // ctrl + up/down will bring focus to same column, first/last row. no horizontal scrolling.
    NavigationService.prototype.onCtrlUpOrDown = function (key, gridCell) {
        var upKey = key === constants_1.Constants.KEY_UP;
        var rowIndexToScrollTo = upKey ? 0 : this.paginationProxy.getPageLastRow();
        this.navigateTo(rowIndexToScrollTo, null, gridCell.column, rowIndexToScrollTo, gridCell.column);
    };
    // ctrl + left/right will bring focus to same row, first/last cell. no vertical scrolling.
    NavigationService.prototype.onCtrlLeftOrRight = function (key, gridCell) {
        var leftKey = key === constants_1.Constants.KEY_LEFT;
        var allColumns = this.columnController.getAllDisplayedColumns();
        var columnToSelect = leftKey ? allColumns[0] : allColumns[allColumns.length - 1];
        this.navigateTo(gridCell.rowIndex, null, columnToSelect, gridCell.rowIndex, columnToSelect);
    };
    // home brings focus to top left cell, end brings focus to bottom right, grid scrolled to bring
    // same cell into view (which means either scroll all the way up, or all the way down).
    NavigationService.prototype.onHomeOrEndKey = function (key) {
        var homeKey = key === constants_1.Constants.KEY_PAGE_HOME;
        var allColumns = this.columnController.getAllDisplayedColumns();
        var columnToSelect = homeKey ? allColumns[0] : allColumns[allColumns.length - 1];
        var rowIndexToScrollTo = homeKey ? 0 : this.paginationProxy.getPageLastRow();
        this.navigateTo(rowIndexToScrollTo, null, columnToSelect, rowIndexToScrollTo, columnToSelect);
    };
    __decorate([
        context_1.Autowired('gridPanel'),
        __metadata("design:type", gridPanel_1.GridPanel)
    ], NavigationService.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('mouseEventService'),
        __metadata("design:type", mouseEventService_1.MouseEventService)
    ], NavigationService.prototype, "mouseEventService", void 0);
    __decorate([
        context_1.Autowired('paginationProxy'),
        __metadata("design:type", paginationProxy_1.PaginationProxy)
    ], NavigationService.prototype, "paginationProxy", void 0);
    __decorate([
        context_1.Autowired('focusedCellController'),
        __metadata("design:type", focusedCellController_1.FocusedCellController)
    ], NavigationService.prototype, "focusedCellController", void 0);
    __decorate([
        context_1.Autowired('animationFrameService'),
        __metadata("design:type", animationFrameService_1.AnimationFrameService)
    ], NavigationService.prototype, "animationFrameService", void 0);
    __decorate([
        context_1.Optional('rangeController'),
        __metadata("design:type", Object)
    ], NavigationService.prototype, "rangeController", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], NavigationService.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], NavigationService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NavigationService.prototype, "init", null);
    NavigationService = __decorate([
        context_1.Bean('navigationService')
    ], NavigationService);
    return NavigationService;
}());
exports.NavigationService = NavigationService;


/***/ }),

/***/ "oPvZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
// class returns a unique id to use for the column. it checks the existing columns, and if the requested
// id is already taken, it will start appending numbers until it gets a unique id.
// eg, if the col field is 'name', it will try ids: {name, name_1, name_2...}
// if no field or id provided in the col, it will try the ids of natural numbers
var utils_1 = __webpack_require__("IRr6");
var ColumnKeyCreator = (function () {
    function ColumnKeyCreator() {
        this.existingKeys = [];
    }
    ColumnKeyCreator.prototype.getUniqueKey = function (colId, colField) {
        // in case user passed in number for colId, convert to string
        colId = utils_1.Utils.toStringOrNull(colId);
        var count = 0;
        while (true) {
            var idToTry = void 0;
            if (colId) {
                idToTry = colId;
                if (count !== 0) {
                    idToTry += '_' + count;
                }
            }
            else if (colField) {
                idToTry = colField;
                if (count !== 0) {
                    idToTry += '_' + count;
                }
            }
            else {
                idToTry = '' + count;
            }
            if (this.existingKeys.indexOf(idToTry) < 0) {
                this.existingKeys.push(idToTry);
                return idToTry;
            }
            count++;
        }
    };
    return ColumnKeyCreator;
}());
exports.ColumnKeyCreator = ColumnKeyCreator;


/***/ }),

/***/ "oSV6":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1021);
	module.exports = __webpack_require__(1021);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1021:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20), __webpack_require__(5), __webpack_require__(1022) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, kendo){

	    var ExcelExporter = kendo.excel.ExcelExporter;

	    var extend = $.extend;

	    kendo.excel.TemplateService.register({
	        compile: kendo.template
	    });

	    kendo.ExcelExporter = kendo.Class.extend({
	        init: function(options) {
	            this.options = options;
	            var dataSource = options.dataSource;

	            if (dataSource instanceof kendo.data.DataSource) {

	                if (!dataSource.filter()) {
	                    dataSource.options.filter = undefined;
	                }

	                this.dataSource = new dataSource.constructor(extend(
	                    {},
	                    dataSource.options,
	                    {
	                        page: options.allPages ? 0 : dataSource.page(),
	                        filter: dataSource.filter(),
	                        pageSize: options.allPages ? dataSource.total() : dataSource.pageSize() || dataSource.total(),
	                        sort: dataSource.sort(),
	                        group: dataSource.group(),
	                        aggregate: dataSource.aggregate()
	                    }));

	                var data = dataSource.data();

	                if (data.length > 0) {
	                    if (options.hierarchy) {
	                        for (var i = 0; i < data.length; i++) {
	                            if (data[i].expanded === false || data[i].expanded === undefined) {
	                                data[i].expanded = true;
	                            }
	                        }
	                    }
	                    // Avoid toJSON() for perf and avoid data() to prevent reparenting.
	                    this.dataSource._data = data;

	                    var transport = this.dataSource.transport;
	                    if (dataSource._isServerGrouped() && transport.options && transport.options.data) { // clear the transport data when using aspnet-mvc transport
	                        transport.options.data = null;
	                    }
	                }

	            } else {
	                this.dataSource = kendo.data.DataSource.create(dataSource);
	            }
	        },

	        _hierarchy: function() {
	            var hierarchy = this.options.hierarchy;
	            var dataSource = this.dataSource;

	            if (hierarchy && dataSource.level) {
	                hierarchy = {
	                    itemLevel: function(item) {
	                        return dataSource.level(item);
	                    }
	                };

	                var view = dataSource.view();
	                var depth = 0;
	                var level;

	                for (var idx = 0; idx < view.length; idx++) {
	                    level = dataSource.level(view[idx]);

	                    if (level > depth) {
	                        depth = level;
	                    }
	                }

	                hierarchy.depth = depth + 1;
	            } else {
	                hierarchy = false;
	            }

	            return {
	                hierarchy: hierarchy
	            };
	        },

	        workbook: function() {
	            return $.Deferred($.proxy(function(d) {
	                this.dataSource.fetch()
	                    .then($.proxy(function() {

	                        var workbook = new ExcelExporter(extend({}, this.options, this._hierarchy(), {
	                            data: this.dataSource.view(),
	                            groups: this.dataSource.group(),
	                            aggregates: this.dataSource.aggregates()
	                        })).workbook();

	                        d.resolve(workbook, this.dataSource.view());
	                    }, this));
	            }, this)).promise();
	        }
	    });


	})(kendo.jQuery, kendo);

	return kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1022:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("EBTw");

/***/ })

/******/ });

/***/ }),

/***/ "oTNd":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1583);
	module.exports = __webpack_require__(1583);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1578:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("I2Wh");

/***/ }),

/***/ 1583:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// -*- fill-column: 100 -*-

	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1578) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	    "use strict";

	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    // WARNING: removing the following jshint declaration and turning
	    // == into === to make JSHint happy will break functionality.
	    /* jshint eqnull:true, newcap:false, laxbreak:true, shadow:true, -W054 */
	    /* jshint latedef: false */

	    var util = kendo.util;
	    var spreadsheet = kendo.spreadsheet;
	    var Ref = spreadsheet.Ref;
	    var RangeRef = spreadsheet.RangeRef;
	    var CellRef = spreadsheet.CellRef;
	    var NameRef = spreadsheet.NameRef;
	    var exports = spreadsheet.calc;
	    var runtime = exports.runtime;

	    // Excel formula parser and compiler to JS.
	    // some code adapted from http://lisperator.net/pltut/

	    // these two will hold the same operators, except that when the comma is used as decimal
	    // separator, the union operator must be the semicolon (;) instead of comma.
	    var OPERATORS_STANDARD = Object.create(null);
	    var OPERATORS_COMMA = Object.create(null);

	    (function(ops){
	        ops.forEach(function(cls, i){
	            cls.forEach(function(op){
	                OPERATORS_STANDARD[op] = ops.length - i;
	                OPERATORS_COMMA[op == "," ? ";" : op] = ops.length - i;
	            });
	        });
	    })([
	        [ ":" ],
	        [ " " ],
	        [ "," ],
	        [ "%" ],
	        [ "^" ],
	        [ "*", "/" ],
	        [ "+", "-" ],
	        [ "&" ],
	        [ "=", "<", ">", "<=", ">=", "<>" ]
	    ]);

	    var OPERATORS = OPERATORS_STANDARD;

	    var SEPARATORS = {
	        DEC: ".",
	        ARG: ",",
	        COL: ","
	    };

	    function setDecimalSeparator(sep) {
	        SEPARATORS.DEC = sep;
	        SEPARATORS.ARG = sep == "," ? ";" : ",";
	        SEPARATORS.COL = sep == "," ? "\\" : ",";
	        OPERATORS = sep == "," ? OPERATORS_COMMA : OPERATORS_STANDARD;
	    }

	    exports.withDecimalSeparator = function(sep, f) {
	        if (SEPARATORS.DEC == sep) {
	            return f();
	        }
	        var save = SEPARATORS.DEC;
	        setDecimalSeparator(sep);
	        try {
	            return f();
	        } finally {
	            setDecimalSeparator(save);
	        }
	    };

	    exports._separators = SEPARATORS;

	    var ParseError = kendo.Class.extend({
	        init: function ParseError(message, pos) {
	            this.message = message;
	            this.pos = pos;
	        },
	        toString: function() {
	            return this.message;
	        }
	    });

	    var TRUE = { type: "bool", value: true };
	    var FALSE = { type: "bool", value: false };

	    function getcol(str) {
	        str = str.toUpperCase();
	        for (var col = 0, i = 0; i < str.length; ++i) {
	            col = col * 26 + str.charCodeAt(i) - 64;
	        }
	        return col - 1;
	    }

	    function getrow(str) {
	        return parseInt(str, 10) - 1;
	    }

	    function parseReference(name, noThrow) {
	        if (name.toLowerCase() == "#sheet") {
	            return spreadsheet.SHEETREF;
	        }
	        OUT: {
	            // this is redundant, but let's keep it fast for the most
	            // common case — A1.  If this fails, we'll try to employ the
	            // whole tokenizer.
	            var m;
	            if ((m = /^(\$)?([a-z]+)(\$)?(\d+)$/i.exec(name))) {
	                var row = getrow(m[4]), col = getcol(m[2]);
	                if (row < 0x100000 && col < 0x4000) {
	                    return new CellRef(getrow(m[4]), getcol(m[2]));
	                }
	                // no NameRef-s from this function
	                break OUT;      // jshint ignore:line
	            }
	            var stream = TokenStream(name, {});
	            var a = [];
	            while (true) {
	                var ref = stream.next();
	                if (ref instanceof CellRef) {
	                    // this function always makes absolute references
	                    ref.rel = 0;
	                } else if (ref instanceof RangeRef) {
	                    ref.topLeft.rel = 0;
	                    ref.bottomRight.rel = 0;
	                } else {
	                    break OUT;  // jshint ignore:line
	                }
	                a.push(ref);
	                if (stream.eof()) {
	                    break;
	                }
	                if (!stream.is("op", SEPARATORS.ARG)) {
	                    break OUT;  // jshint ignore:line
	                }
	                stream.next();
	            }
	            return a.length == 1 ? a[0] : new spreadsheet.UnionRef(a);
	        }
	        if (!noThrow) {
	            throw new Error("Cannot parse reference: " + name);
	        }
	    }

	    function parseFormula(sheet, row, col, input) {
	        var refs = [];
	        input = TokenStream(input, { row: row, col: col });
	        var is = input.is;

	        return {
	            type: "exp",
	            ast: parseExpression(true),
	            refs: refs,
	            sheet: sheet,
	            row: row,
	            col: col
	        };

	        function addReference(ref) {
	            ref.index = refs.length;
	            refs.push(ref);
	            return ref;
	        }

	        function skip(type, value, allowEOF) {
	            if (is(type, value)) {
	                return input.next();
	            } else {
	                var tok = input.peek();
	                if (tok) {
	                    input.croak("Expected " + type + " «" + value + "» but found " + tok.type + " «" + tok.value + "»");
	                } else if (!allowEOF) {
	                    input.croak("Expected " + type + " «" + value + "»");
	                }
	            }
	        }

	        function parseExpression(commas) {
	            return maybeBinary(maybeIntersect(parseAtom()), 0, commas);
	        }

	        function parseSymbol(tok) {
	            if (tok.upper == "TRUE" || tok.upper == "FALSE") {
	                return tok.upper == "TRUE" ? TRUE : FALSE;
	            }
	            return addReference(new NameRef(tok.value));
	        }

	        function parseFuncall() {
	            var fname = input.next();
	            fname = fname.value;
	            skip("punc", "(");
	            var args = [];
	            while (1) {
	                if (is("punc", ")")) {
	                    break;
	                }
	                if (is("op", SEPARATORS.ARG)) {
	                    args.push({ type: "null" });
	                    input.next();
	                    continue;
	                }
	                args.push(parseExpression(false));
	                if (input.eof() || is("punc", ")")) {
	                    break;
	                }
	                skip("op", SEPARATORS.ARG);
	            }
	            skip("punc", ")", true);
	            return {
	                type: "func",
	                func: fname,
	                args: args
	            };
	        }

	        function fixReference(ref) {
	            if (!ref.hasSheet()) {
	                ref.setSheet(sheet);
	            }
	            return addReference(ref);
	        }

	        function parseAtom() {
	            var exp;
	            if (is("ref")) {
	                exp = fixReference(input.next());
	            }
	            else if (is("func")) {
	                exp = parseFuncall();
	            }
	            else if (is("punc", "(")) {
	                input.next();
	                exp = parseExpression(true);
	                skip("punc", ")", true);
	            }
	            else if (is("punc", "{")) {
	                input.next();
	                exp = parseArray();
	                skip("punc", "}", true);
	            }
	            else if (is("num") || is("str") || is("error")) {
	                exp = input.next();
	            }
	            else if (is("sym")) {
	                exp = parseSymbol(input.next());
	            }
	            else if (is("op", "+") || is("op", "-")) {
	                exp = {
	                    type: "prefix",
	                    op: input.next().value,
	                    exp: parseAtom()
	                };
	            }
	            else if (!input.peek()) {
	                input.croak("Incomplete expression");
	            }
	            else if (is("punc", "[")) {
	                input.croak("External reference not supported");
	            }
	            else {
	                input.croak("Parse error");
	            }
	            return maybePercent(exp);
	        }

	        function parseArray() {
	            var row = [], value = [ row ], first = true;
	            while (!input.eof() && !is("punc", "}")) {
	                if (first) {
	                    first = false;
	                } else if (is(null, ";")) {
	                    value.push(row = []);
	                    input.next();
	                } else {
	                    skip(null, SEPARATORS.COL);
	                }
	                row.push(parseExpression(false));
	            }
	            return {
	                type: "matrix",
	                value: value
	            };
	        }

	        function maybeIntersect(exp) {
	            if (is("punc", "(") || is("ref") || is("num") || is("func")) {
	                return {
	                    type: "binary",
	                    op: " ",
	                    left: exp,
	                    right: parseExpression(false)
	                };
	            } else {
	                return exp;
	            }
	        }

	        function maybePercent(exp) {
	            if (is("op", "%")) {
	                input.next();
	                return maybePercent({
	                    type: "postfix",
	                    op: "%",
	                    exp: exp
	                });
	            } else {
	                return exp;
	            }
	        }

	        function maybeBinary(left, my_prec, commas) {
	            var tok = is("op");
	            if (tok && (commas || tok.value != SEPARATORS.ARG)) {
	                var his_prec = OPERATORS[tok.value];
	                if (his_prec > my_prec) {
	                    input.next();
	                    var right = maybeBinary(parseAtom(), his_prec, commas);
	                    return maybeBinary({
	                        type: "binary",
	                        op: tok.value == ";" ? "," : tok.value, // translate union back to comma
	                        left: left,
	                        right: right
	                    }, my_prec, commas);
	                }
	            }
	            return left;
	        }
	    }

	    function parseNameDefinition(name, def) {
	        var nameRef = parseFormula(null, 0, 0, name);
	        if (!(nameRef.ast instanceof NameRef)) {
	            throw new ParseError("Invalid name: " + name);
	        }
	        nameRef = nameRef.ast;

	        if (!(def instanceof Ref)) {
	            var defAST = parseFormula(nameRef.sheet, 0, 0, def);
	            if (defAST.ast instanceof Ref) {
	                def = defAST.ast;   // single reference
	            } else if (/^(?:str|num|bool|error)$/.test(defAST.ast.type)) {
	                def = defAST.ast.value; // constant
	            } else {
	                def = makeFormula(defAST); // formula
	            }
	        }

	        return {
	            name: nameRef,
	            value: def
	        };
	    }

	    var makeClosure = (function(cache){
	        return function(code) {
	            var f = cache[code];
	            if (!f) {
	                f = cache[code] = new Function("'use strict';return(" + code + ")")();
	            }
	            return f;
	        };
	    })(Object.create(null));

	    function makePrinter(exp) {
	        return makeClosure("function(row, col, mod){return(" + print(exp.ast, exp, 0) + ")}");
	        function print(node, parent, prec) { // jshint ignore:line, because you are stupid.
	            switch (node.type) {
	              case "num":
	                return "(kendo.spreadsheet.calc._separators.DEC == '.' ? "
	                    +  JSON.stringify(JSON.stringify(node.value)) + " : "
	                    +  JSON.stringify(JSON.stringify(node.value))
	                    +  ".replace('.' , kendo.spreadsheet.calc._separators.DEC))";
	              case "bool":
	                return JSON.stringify(node.value);
	              case "error":
	                return JSON.stringify("#" + node.value);
	              case "str":
	                return JSON.stringify(JSON.stringify(node.value));
	              case "ref":
	                return "this.refs[" + node.index + "].print(row, col, mod)";
	              case "prefix":
	                return withParens(function(){
	                    return JSON.stringify(node.op) + " + " + print(node.exp, node, OPERATORS[node.op]);
	                });
	              case "postfix":
	                return withParens(function(){
	                    return print(node.exp, node, OPERATORS[node.op]) + " + " + JSON.stringify(node.op);
	                });
	              case "binary":
	                return withParens(function(){
	                    var left = parenthesize(
	                        print(node.left, node, OPERATORS[node.op]),
	                        node.left instanceof NameRef && node.op == ":"
	                    );
	                    var right = parenthesize(
	                        print(node.right, node, OPERATORS[node.op]),
	                        node.right instanceof NameRef && node.op == ":"
	                    );
	                    if (/^[,;]/.test(node.op)) {
	                        return left + " + kendo.spreadsheet.calc._separators.ARG + " + right;
	                    } else {
	                        return left + " + " + JSON.stringify(node.op) + " + " + right;
	                    }
	                });
	              case "func":
	                return JSON.stringify(node.func + "(") + " + "
	                    + (node.args.length > 0
	                       ? node.args.map(function(arg){
	                           return print(arg, node, 0);
	                       }).join(" + kendo.spreadsheet.calc._separators.ARG + ' ' + ")
	                       : "''")
	                    + " + ')'";
	              case "matrix":
	                return "'{ ' + " + node.value.map(function(el){
	                    return el.map(function(el){
	                        return print(el, node, 0);
	                    }).join(" + kendo.spreadsheet.calc._separators.COL + ' ' + ");
	                }).join(" + '; ' + ") + "+ ' }'";
	              case "null":
	                return "''";
	            }
	            throw new Error("Cannot make printer for node " + node.type);

	            function withParens(f) {
	                var op = node.op;
	                var needParens = (OPERATORS[op] < prec
	                                  || (!prec && op == ",")
	                                  || (parent.type == "prefix" && prec == OPERATORS[op] && parent.op == "-")
	                                  || (parent.type == "binary" && prec == OPERATORS[op] && node === parent.right));
	                return parenthesize(f(), needParens);
	            }
	        }
	        function parenthesize(code, cond) {
	            return cond ? "'(' + " + code + " + ')'" : code;
	        }
	    }

	    function toCPS(ast, k) {
	        var GENSYM = 0;
	        return cps(ast, k);

	        function cps(node, k){
	            switch (node.type) {
	              case "ref"     : return cpsRef(node, k);
	              case "num"     :
	              case "str"     :
	              case "null"    :
	              case "error"   :
	              case "bool"    : return cpsAtom(node, k);
	              case "prefix"  :
	              case "postfix" : return cpsUnary(node, k);
	              case "binary"  : return cpsBinary(node, k);
	              case "func"    : return cpsFunc(node, k);
	              case "lambda"  : return cpsLambda(node, k);
	              case "matrix"  : return cpsMatrix(node.value, k, true);
	            }
	            throw new Error("Cannot CPS " + node.type);
	        }

	        function cpsRef(node, k) {
	            return node.ref == "name" ? cpsNameRef(node, k) : cpsAtom(node, k);
	        }

	        function cpsAtom(node, k) {
	            return k(node);
	        }

	        function cpsNameRef(node, k) {
	            return {
	                type: "func",
	                func: ",getname",
	                args: [ makeContinuation(k), node ]
	            };
	        }

	        function cpsUnary(node, k) {
	            return cps({
	                type: "func",
	                func: "unary" + node.op,
	                args: [ node.exp ]
	            }, k);
	        }

	        function cpsBinary(node, k) {
	            return cps({
	                type: "func",
	                func: "binary" + node.op,
	                args: [ node.left, node.right ]
	            }, k);
	        }

	        function cpsIf(co, th, el, k) {
	            return cps(co, function(co){
	                // compile THEN and ELSE into a lambda which takes a callback to invoke with the
	                // result of the branches, and the IF itself will become a call the internal "if"
	                // function.
	                var rest = makeContinuation(k);
	                var thenK = gensym("T");
	                var elseK = gensym("E");
	                return {
	                    type: "func",
	                    func: "if",
	                    args: [
	                        rest,
	                        co, // condition
	                        { // then
	                            type: "lambda",
	                            vars: [ thenK ],
	                            body: cps(th || TRUE, function(th){
	                                return {
	                                    type: "call",
	                                    func: { type: "var", name: thenK },
	                                    args: [ th ]
	                                };
	                            })
	                        },
	                        { // else
	                            type: "lambda",
	                            vars: [ elseK ],
	                            body: cps(el || FALSE, function(el){
	                                return {
	                                    type: "call",
	                                    func: { type: "var", name: elseK },
	                                    args: [ el ]
	                                };
	                            })
	                        }
	                    ]
	                };
	            });
	        }

	        function cpsAnd(args, k) {
	            if (args.length === 0) {
	                return cpsAtom(TRUE, k);
	            }
	            return cps({
	                type: "func",
	                func: "IF",
	                args: [
	                    // first item
	                    args[0],
	                    // if true, apply AND for the rest
	                    {
	                        type: "func",
	                        func: "AND",
	                        args: args.slice(1)
	                    },
	                    // otherwise return false
	                    FALSE
	                ]
	            }, k);
	        }

	        function cpsOr(args, k) {
	            if (args.length === 0) {
	                return cpsAtom(FALSE, k);
	            }
	            return cps({
	                type: "func",
	                func: "IF",
	                args: [
	                    // first item
	                    args[0],
	                    // if true, return true
	                    TRUE,
	                    // otherwise apply OR for the rest
	                    {
	                        type: "func",
	                        func: "OR",
	                        args: args.slice(1)
	                    }
	                ]
	            }, k);
	        }

	        function cpsFunc(node, k) {
	            switch (node.func.toLowerCase()) {
	              case "if":
	                return cpsIf(node.args[0], node.args[1], node.args[2], k);
	              case "and":
	                return cpsAnd(node.args, k);
	              case "or":
	                return cpsOr(node.args, k);
	              case "true":
	                return k(TRUE);
	              case "false":
	                return k(FALSE);
	            }
	            // actual function
	            return (function loop(args, i){
	                if (i == node.args.length) {
	                    return {
	                        type : "func",
	                        func : node.func,
	                        args : args
	                    };
	                }
	                else {
	                    return cps(node.args[i], function(value){
	                        return loop(args.concat([ value ]), i + 1);
	                    });
	                }
	            })([ makeContinuation(k) ], 0);
	        }

	        function cpsLambda(node, k) {
	            var cont = gensym("K");
	            var body = cps(node.body, function(body){
	                return { type: "call",
	                         func: { type: "var", value: cont },
	                         args: [ body ] };
	            });
	            return k({ type: "lambda",
	                       vars: [ cont ].concat(node.vars),
	                       body: body });
	        }

	        function cpsMatrix(elements, k, isMatrix) {
	            var a = [];
	            return (function loop(i){
	                if (i == elements.length) {
	                    return k({
	                        type: "matrix",
	                        value: a
	                    });
	                } else {
	                    return (isMatrix ? cpsMatrix : cps)(elements[i], function(val){
	                        a[i] = val;
	                        return loop(i + 1);
	                    });
	                }
	            })(0);
	        }

	        function makeContinuation(k) {
	            var cont = gensym("R");
	            return {
	                type : "lambda",
	                vars : [ cont ],
	                body : k({ type: "var", name: cont })
	            };
	        }

	        function gensym(name) {
	            if (!name) {
	                name = "";
	            }
	            name = "_" + name;
	            return name + (++GENSYM);
	        }
	    }

	    var FORMULA_CACHE = Object.create(null);

	    function makeFormula(exp) {
	        var printer = makePrinter(exp);
	        var hash = printer.call(exp); // needs .refs
	        var formula = FORMULA_CACHE[hash];
	        if (formula) {
	            // we need to clone because formulas cache the result; even if the formula is the same,
	            // its value will depend on its location, hence we need different objects.  Still, using
	            // this cache is a good idea because we'll reuse the same refs array, handler and
	            // printer instead of allocating new ones (and we skip compiling it).
	            return formula.clone(exp.sheet, exp.row, exp.col);
	        }
	        var code = js(toCPS(exp.ast, function(ret){
	            return {
	                type: "return",
	                value: ret
	            };
	        }));

	        code = [
	            "function(){",
	            "var context = this, refs = context.formula.absrefs",
	            code,
	            "}"
	        ].join(";\n");

	        formula = new runtime.Formula(exp.refs, makeClosure(code), printer, exp.sheet, exp.row, exp.col);
	        FORMULA_CACHE[hash] = formula.clone(exp.sheet, exp.row, exp.col);
	        return formula;

	        function js(node){
	            var type = node.type;
	            if (type == "num") {
	                return node.value + "";
	            }
	            else if (type == "str") {
	                return JSON.stringify(node.value);
	            }
	            else if (type == "error") {
	                return "context.error(" + JSON.stringify(node.value) + ")";
	            }
	            else if (type == "return") {
	                return "context.resolve(" + js(node.value) + ")";
	            }
	            else if (type == "func") {
	                return "context.func(" + JSON.stringify(node.func) + ", "
	                    + js(node.args[0]) + ", " // the callback
	                    + jsArray(node.args.slice(1)) // the arguments
	                    + ")";
	            }
	            else if (type == "call") {
	                return js(node.func) + "(" + node.args.map(js).join(", ") + ")";
	            }
	            else if (type == "ref") {
	                return "refs[" + node.index + "]";
	            }
	            else if (type == "bool") {
	                return "" + node.value;
	            }
	            else if (type == "if") {
	                return "(context.bool(" + js(node.co) + ") ? " + js(node.th) + " : " + js(node.el) + ")";
	            }
	            else if (type == "lambda") {
	                return "(function("
	                    + node.vars.join(", ")
	                    + "){ return(" + js(node.body) + ") })";
	            }
	            else if (type == "var") {
	                return node.name;
	            }
	            else if (type == "matrix") {
	                return jsArray(node.value);
	            }
	            else if (type == "null") {
	                return "null";
	            }
	            else {
	                throw new Error("Cannot compile expression " + type);
	            }
	        }

	        function jsArray(a) {
	            return "[ " + a.map(js).join(", ") + " ]";
	        }
	    }

	    function identity(x) {
	        return x;
	    }

	    function TokenStream(input, options) {
	        input = RawTokenStream(InputStream(input), options);
	        var ahead = input.ahead;
	        var skip = input.skip;
	        var token = null;
	        var fixCell = options.row != null && options.col != null
	            ? function(cell) {
	                if (cell.rel & 1) {
	                    cell.col -= options.col;
	                }
	                if (cell.rel & 2) {
	                    cell.row -= options.row;
	                }
	                return cell;
	            }
	            : identity;

	        var addPos = options.forEditor
	            ? function(thing, startToken, endToken) {
	                thing.begin = startToken.begin;
	                thing.end = endToken.end;
	                return thing;
	            }
	            : identity;

	        return {
	            peek  : peek,
	            next  : next,
	            croak : input.croak,
	            eof   : input.eof,
	            is    : is
	        };

	        function is(type, value) {
	            var tok = peek();
	            return tok != null
	                && (type == null || tok.type === type)
	                && (value == null || tok.value === value)
	                ? tok : null;
	        }

	        function peek() {
	            if (token == null) {
	                token = readNext();
	            }
	            return token;
	        }

	        function next() {
	            if (token != null) {
	                var tmp = token;
	                token = null;
	                return tmp;
	            }
	            return readNext();
	        }

	        function readNext() {
	            var ret;
	            var t = input.peek();
	            if (t) {
	                if (t.type == "sym" || t.type == "rc" || t.type == "num") {
	                    ret =  ahead(8, refRange3D)
	                        || ahead(6, refCell3D)
	                        || ahead(6, refSheetRange)
	                        || ahead(4, refSheetCell)
	                        || ahead(4, refRange)
	                        || ahead(2, refCell)
	                        || ahead(2, funcall);
	                }
	                if (!ret) {
	                    ret = input.next();
	                }
	            }
	            return ret;
	        }

	        function toCell(tok, isFirst) {
	            if (tok.type == "rc") {
	                // RC notation is read properly without knowing where
	                // we are, so no need to fixCell on this one.
	                // However, if only absolute refs were asked for (from
	                // i.e. parseReference) I feel it's alright to yell
	                // about it here.
	                if (tok.rel && !options.forEditor && (options.row == null || options.col == null)) {
	                    input.croak("Cannot read relative cell in RC notation");
	                }
	                return new CellRef(tok.row, tok.col, tok.rel);
	            }
	            if (tok.type == "num") {
	                if (tok.value <= 1048577) {
	                    // whole row
	                    return fixCell(new CellRef(
	                        getrow(tok.value),
	                        isFirst ? -Infinity : +Infinity,
	                        2
	                    ));
	                } else {
	                    return null;
	                }
	            }
	            // otherwise it's "sym".  The OOXML spec (SpreadsheetML
	            // 18.2.5) defines the maximum value to be interpreted as
	            // a cell reference to be XFD1048576.
	            var name = tok.value;
	            var m = /^(\$)?([a-z]+)(\$)?(\d+)$/i.exec(name);
	            if (m) {
	                var row = getrow(m[4]), col = getcol(m[2]);
	                if (row <= 1048576 && col <= 16383) {
	                    return fixCell(new CellRef(
	                        getrow(m[4]),
	                        getcol(m[2]),
	                        (m[1] ? 0 : 1) | (m[3] ? 0 : 2)
	                    ));
	                } else {
	                    return null;
	                }
	            }
	            var abs = name.charAt(0) == "$";
	            if (abs) {
	                name = name.substr(1);
	            }
	            if (/^\d+$/.test(name)) {
	                var row = getrow(name);
	                if (row <= 1048576) {
	                    return fixCell(new CellRef(
	                        getrow(name),
	                        isFirst ? -Infinity : +Infinity,
	                        (abs ? 0 : 2)
	                    ));
	                }
	            } else {
	                var col = getcol(name);
	                if (col <= 16383) {
	                    return fixCell(new CellRef(
	                        isFirst ? -Infinity : +Infinity,
	                        getcol(name),
	                        (abs ? 0 : 1)
	                    ));
	                }
	            }
	        }

	        // Sheet1(a) :(b) Sheet2(c) !(d) A1(e) :(f) C3(g) not followed by paren (h)
	        function refRange3D(a, b, c, d, e, f, g, h) {
	            if (a.type == "sym" &&
	                b.type == "op" && b.value == ":" &&
	                c.type == "sym" &&
	                d.type == "punc" && d.value == "!" &&
	                (e.type == "sym" || e.type == "rc" || (e.type == "num" && e.value == e.value|0)) &&
	                f.type == "op" && f.value == ":" &&
	                (g.type == "sym" || g.type == "rc" || (g.type == "num" && g.value == g.value|0)) &&
	                g.type == e.type &&
	                !(h.type == "punc" && h.value == "(" && !g.space))
	            {
	                var tl = toCell(e, true), br = toCell(g, false);
	                if (tl && br) {
	                    // skip them except the last one, we only wanted to
	                    // ensure it's not paren.
	                    skip(7);
	                    return addPos(new RangeRef(
	                        tl.setSheet(a.value, true),
	                        br.setSheet(c.value, true)
	                    ).setSheet(a.value, true), a, g);
	                }
	            }
	        }

	        // Sheet1(a) :(b) Sheet2(c) !(d) A1(e) not followed by paren (f)
	        function refCell3D(a, b, c, d, e, f) {
	            if (a.type == "sym" &&
	                b.type == "op" && b.value == ":" &&
	                c.type == "sym" &&
	                d.type == "punc" && d.value == "!" &&
	                (e.type == "sym" || e.type == "rc" || (e.type == "num" && e.value == e.value|0)) &&
	                !(f.type == "punc" && f.value == "(" && !e.space))
	            {
	                var tl = toCell(e);
	                if (tl) {
	                    skip(5);
	                    var br = tl.clone();
	                    return addPos(new RangeRef(
	                        tl.setSheet(a.value, true),
	                        br.setSheet(c.value, true)
	                    ).setSheet(a.value, true), a, e);
	                }
	            }
	        }

	        // Sheet1(a) !(b) A1(c) :(d) C3(e) not followed by paren (f)
	        function refSheetRange(a, b, c, d, e, f) {
	            if (a.type == "sym" &&
	                b.type == "punc" && b.value == "!" &&
	                (c.type == "sym" || c.type == "rc" || (c.type == "num" && c.value == c.value|0)) &&
	                d.type == "op" && d.value == ":" &&
	                (e.type == "sym" || e.type == "rc" || (e.type == "num" && e.value == e.value|0)) &&
	                !(f.type == "punc" && f.value == "(" && !e.space))
	            {
	                var tl = toCell(c, true), br = toCell(e, false);
	                if (tl && br) {
	                    skip(5);
	                    return addPos(new RangeRef(tl, br).setSheet(a.value, true), a, e);
	                }
	            }
	        }

	        // Sheet1(a) !(b) A1(c) not followed by paren (d)
	        function refSheetCell(a, b, c, d) {
	            if (a.type == "sym" &&
	                b.type == "punc" && b.value == "!" &&
	                (c.type == "sym" || c.type == "rc" || (c.type == "num" && c.value == c.value|0)) &&
	                !(d.type == "punc" && d.value == "(" && !c.space))
	            {
	                skip(3);
	                var x = toCell(c);
	                if (!x || !isFinite(x.row)) {
	                    x = new NameRef(c.value);
	                }
	                return addPos(x.setSheet(a.value, true), a, c);
	            }
	        }

	        // A1(a) :(b) C3(c) not followed by paren (d)
	        function refRange(a, b, c, d) {
	            if ((a.type == "sym" || a.type == "rc" || (a.type == "num" && a.value == a.value|0)) &&
	                (b.type == "op" && b.value == ":") &&
	                (c.type == "sym" || c.type == "rc" || (c.type == "num" && c.value == c.value|0)) &&
	                !(d.type == "punc" && d.value == "(" && !c.space))
	            {
	                var tl = toCell(a, true), br = toCell(c, false);
	                if (tl && br) {
	                    skip(3);
	                    return addPos(new RangeRef(tl, br), a, c);
	                }
	            }
	        }

	        // A1(a) not followed by paren (b)
	        function refCell(a, b) {
	            if ((a.type == "sym" || a.type == "rc") && !(b.type == "punc" && b.value == "(" && !a.space)) {
	                var x = toCell(a);
	                if (x && isFinite(x.row) && isFinite(x.col)) {
	                    skip(1);
	                    return addPos(x, a, a);
	                }
	            }
	        }

	        function funcall(a, b) {
	            if (a.type == "sym" && b.type == "punc" && b.value == "(" && !a.space) {
	                a.type = "func";
	                skip(1);
	                return a;       // already has position
	            }
	        }
	    }

	    function isWhitespace(ch) {
	        return " \t\r\n\xa0\u200b".indexOf(ch) >= 0;
	    }

	    var EOF = { type: "eof" };

	    function RawTokenStream(input, options) {
	        var tokens = [], index = 0;
	        var readWhile = input.readWhile;

	        return {
	            next  : next,
	            peek  : peek,
	            eof   : eof,
	            croak : input.croak,
	            ahead : ahead,
	            skip  : skip
	        };

	        function isDigit(ch) {
	            return (/[0-9]/i.test(ch));
	        }

	        function isIdStart(ch) {
	            return (/[a-z$_]/i.test(ch) || util.isUnicodeLetter(ch));
	        }

	        function isId(ch) {
	            return isIdStart(ch) || isDigit(ch) || ch == ".";
	        }

	        function isOpChar(ch) {
	            return ch in OPERATORS;
	        }

	        function isPunc(ch) {
	            return "\\!;(){}[]".indexOf(ch) >= 0;
	        }

	        function readNumber() {
	            // XXX: TODO: exponential notation
	            var has_dot = false;
	            var number = readWhile(function(ch){
	                if (ch == SEPARATORS.DEC) {
	                    if (has_dot) {
	                        return false;
	                    }
	                    has_dot = true;
	                    return true;
	                }
	                return isDigit(ch);
	            });
	            if (number == SEPARATORS.DEC) {
	                return { type: "punc", value: SEPARATORS.DEC };
	            } else {
	                return { type: "num", value: parseFloat(number.replace(SEPARATORS.DEC, ".")) };
	            }
	        }

	        function symbol(id, quote) {
	            return {
	                type  : "sym",
	                value : id,
	                upper : id.toUpperCase(),
	                space : isWhitespace(input.peek()),
	                quote : quote
	            };
	        }

	        function getRC(a, b, c) {
	            if (!a && !b && !c) {
	                return null;
	            }
	            if ((!a && !c) || (a && c)) {
	                var num = b ? parseInt(b, 10) : 0;
	                return a ? num : num - 1;
	            }
	        }

	        function readSymbol() {
	            var m = input.lookingAt(/^R(\[)?(-?[0-9]+)?(\])?C(\[)?(-?[0-9]+)?(\])?/i);
	            if (m) {
	                var row = getRC(m[1], m[2], m[3]);
	                var col = getRC(m[4], m[5], m[6]);
	                if (row != null && col != null) {
	                    input.skip(m);
	                    return {
	                        type: "rc",
	                        row: row,
	                        col: col,
	                        rel: ((m[4] || !(m[4] || m[5] || m[6]) ? 1 : 0) // col
	                              |
	                              (m[1] || !(m[1] || m[2] || m[3]) ? 2 : 0) // row
	                             )
	                    };
	                }
	            }
	            return symbol(readWhile(isId));
	        }

	        function readString() {
	            input.next();
	            return { type: "str", value: input.readEscaped('"') };
	        }

	        function readSheetName() {
	            input.next();
	            return symbol(input.readEscaped("'"), true);
	        }

	        function readOperator() {
	            return {
	                type  : "op",
	                value : readWhile(function(ch, op){
	                    return (op + ch) in OPERATORS;
	                })
	            };
	        }

	        function readPunc() {
	            return {
	                type  : "punc",
	                value : input.next()
	            };
	        }

	        function readNext() {
	            if (input.eof()) {
	                return null;
	            }
	            var ch = input.peek(), m;
	            if (ch == '"') {
	                return readString();
	            }
	            if (ch == "'") {
	                return readSheetName();
	            }
	            if (isDigit(ch) || ch == SEPARATORS.DEC) {
	                return readNumber();
	            }
	            if (isIdStart(ch)) {
	                return readSymbol();
	            }
	            if (isOpChar(ch)) {
	                return readOperator();
	            }
	            if (isPunc(ch)) {
	                return readPunc();
	            }
	            if ((m = input.lookingAt(/^#([a-z\/]+)[?!]?/i))) {
	                input.skip(m);
	                return { type: "error", value: m[1] };
	            }
	            if (!options.forEditor) {
	                input.croak("Can't handle character with code: " + ch.charCodeAt(0));
	            }
	            return { type: "error", value: input.next() };
	        }

	        function peek() {
	            while (tokens.length <= index) {
	                readWhile(isWhitespace);
	                var begin = input.pos();
	                var tok = readNext();
	                if (options.forEditor && tok) {
	                    tok.begin = begin;
	                    tok.end = input.pos();
	                }
	                tokens.push(tok);
	            }
	            return tokens[index];
	        }

	        function next() {
	            var tok = peek();
	            if (tok) {
	                index++;
	            }
	            return tok;
	        }

	        function ahead(n, f) {
	            var pos = index, a = [];
	            while (n-- > 0) {
	                a.push(next() || EOF);
	            }
	            index = pos;
	            return f.apply(a, a);
	        }

	        function skip(n) {
	            index += n;
	        }

	        function eof() {
	            return peek() == null;
	        }
	    }

	    function InputStream(input) {
	        var pos = 0, line = 1, col = 0;
	        return {
	            next        : next,
	            peek        : peek,
	            eof         : eof,
	            croak       : croak,
	            readWhile   : readWhile,
	            readEscaped : readEscaped,
	            lookingAt   : lookingAt,
	            skip        : skip,
	            forward     : forward,
	            pos         : location
	        };
	        function location() { // jshint ignore:line, :-(
	            return pos;
	        }
	        function next() {
	            var ch = input.charAt(pos++);
	            if (ch == "\n") {
	                line++;
	                col = 0;
	            } else {
	                col++;
	            }
	            return ch;
	        }
	        function peek() {
	            return input.charAt(pos);
	        }
	        function eof() {
	            return peek() === "";
	        }
	        function croak(msg) {
	            throw new ParseError(msg + " (input: " + input + ")", pos);
	        }
	        function skip(ch) {
	            if (typeof ch == "string") {
	                if (input.substr(pos, ch.length) != ch) {
	                    croak("Expected " + ch);
	                }
	                forward(ch.length);
	            } else if (ch instanceof RegExp) {
	                var m = ch.exec(input.substr(pos));
	                if (m) {
	                    forward(m[0].length);
	                    return m;
	                }
	            } else {
	                // assuming RegExp match data
	                forward(ch[0].length);
	            }
	        }
	        function forward(n) {
	            while (n-- > 0) {
	                next();
	            }
	        }
	        function readEscaped(end) {
	            var escaped = false, str = "";
	            while (!eof()) {
	                var ch = next();
	                if (escaped) {
	                    str += ch;
	                    escaped = false;
	                } else if (ch == "\\") {
	                    escaped = true;
	                } else if (ch == end) {
	                    break;
	                } else {
	                    str += ch;
	                }
	            }
	            return str;
	        }
	        function readWhile(predicate) {
	            var str = "";
	            while (!eof() && predicate(peek(), str)) {
	                str += next();
	            }
	            return str;
	        }
	        function lookingAt(rx) {
	            return rx.exec(input.substr(pos));
	        }
	    }

	    //// exports

	    var FORMAT_PARSERS = [];

	    var registerFormatParser = exports.registerFormatParser = function(p) {
	        FORMAT_PARSERS.push(p);
	    };

	    exports.parse = function(sheet, row, col, input, format) {
	        if (input instanceof Date) {
	            return { type: "date", value: runtime.dateToSerial(input) };
	        }
	        if (typeof input == "number") {
	            return { type: "number", value: input };
	        }
	        if (typeof input == "boolean") {
	            return { type: "boolean", value: input };
	        }
	        input += "";
	        if (/^'/.test(input)) {
	            return {
	                type: "string",
	                value: input.substr(1)
	            };
	        }
	        // trivial (integer) percent values; more complex formats are handled below via
	        // registerFormatParser; this case could be dropped completely.
	        if (/^-?[0-9]+%$/.test(input)) {
	            var str = input.substr(0, input.length - 1);
	            var num = parseFloat(str);
	            if (!isNaN(num) && num == str) {
	                return {
	                    type: "percent",
	                    value: num / 100
	                };
	            }
	        }
	        if (/^=/.test(input)) {
	            input = input.substr(1);
	            if (/\S/.test(input)) {
	                return parseFormula(sheet, row, col, input);
	            } else {
	                return {
	                    type: "string",
	                    value: "=" + input
	                };
	            }
	        }
	        for (var i = 0; i < FORMAT_PARSERS.length; ++i) {
	            var result = FORMAT_PARSERS[i](input);
	            if (result) {
	                return result;
	            }
	        }
	        if (input.toLowerCase() == "true") {
	            return { type: "boolean", value: true };
	        }
	        if (input.toLowerCase() == "false") {
	            return { type: "boolean", value: false };
	        }
	        var date = runtime.parseDate(input, format);
	        if (date) {
	            return { type: "date", value: runtime.dateToSerial(date) };
	        }
	        var num = parseFloat(input);
	        if (!isNaN(num) && input.length > 0 && num == input) {
	            format = null;
	            if (num != Math.floor(num)) {
	                format = "0." + String(num).split(".")[1].replace(/\d/g, "0");
	            }
	            return {
	                type: "number",
	                value: num,
	                format: format
	            };
	        }
	        return {
	            type: "string",
	            value: input
	        };
	    };

	    function tokenize(input, row, col) {
	        var tokens = [];
	        input = TokenStream(input, { forEditor: true, row: row, col: col });
	        while (!input.eof()) {
	            tokens.push(next());
	        }
	        var tok = tokens[0];
	        if (tok.type == "op" && tok.value == "=") {
	            tok.type = "startexp";
	        }
	        return tokens;

	        function next() {
	            var tok = input.next();
	            if (tok.type == "sym") {
	                if (tok.upper == "TRUE") {
	                    tok.type = "bool";
	                    tok.value = true;
	                } else if (tok.upper == "FALSE") {
	                    tok.type = "bool";
	                    tok.value = false;
	                }
	            } else if (tok.type == "ref") {
	                tok = {
	                    type  : "ref",
	                    ref   : (row != null && col != null ? tok.absolute(row, col) : tok),
	                    begin : tok.begin,
	                    end   : tok.end
	                };
	            }
	            return tok;
	        }
	    }

	    // The `sqref` attribute in dataValidation (XLSX) will contain a space-separated list of
	    // references.  This helper is called from excel-reader.js to parse them.
	    function parseSqref(input, row, col) {
	        row = row || 0;
	        col = col || 0;
	        input = TokenStream(input, { row: row, col: col });
	        var refs = [];
	        while (!input.eof()) {
	            var ref = input.next();
	            if (ref.type != "ref") {
	                throw new ParseError("Expecting a reference but got: " + JSON.stringify(ref));
	            }
	            refs.push(ref.absolute(row, col));
	        }
	        return refs;
	    }

	    exports.parseNameDefinition = parseNameDefinition;
	    exports.parseFormula = parseFormula;
	    exports.parseReference = parseReference;
	    exports.compile = makeFormula;
	    exports.parseSqref = parseSqref;

	    exports.InputStream = InputStream;
	    exports.ParseError = ParseError;
	    exports.tokenize = tokenize;

	    /* -----[ a few special formats ]----- */

	    // various time formats
	    registerFormatParser(function(input){
	        var m, date = 0, format = "";
	        // have date part?
	        if ((m = /^(\d+)([-/.])(\d+)\2(\d{2}(?:\d{2})?)(\s*)/.exec(input))) {
	            var mo = parseInt(m[1], 10);
	            var sep = m[2];
	            var da = parseInt(m[3], 10);
	            var yr = parseInt(m[4], 10);
	            if (yr < 30) {
	                yr += 2000;
	            } else if (yr < 100) {
	                yr += 1900;
	            }
	            var monthFirst = true;
	            if (mo > 12) {
	                var tmp = mo;
	                mo = da;
	                da = tmp;
	                monthFirst = false;
	            }
	            if (!runtime.validDate(yr, mo, da)) {
	                return null;
	            }
	            date = runtime.packDate(yr, mo - 1, da);
	            if (date < 0) { date--; }
	            if (monthFirst) {
	                format = ["mm", "dd", "yyyy"].join(sep);
	            } else {
	                format = ["dd", "mm", "yyyy"].join(sep);
	            }
	            format += m[5];
	            input = input.substr(m[0].length); // skip the date
	        }
	        // hh:mm
	        if ((m = /^(\d+):(\d+)$/.exec(input))) {
	            var hh = parseInt(m[1], 10);
	            var mm = parseInt(m[2], 10);
	            return {
	                type   : "date",
	                format : format + "hh:mm",
	                value  : date + runtime.packTime(hh, mm, 0, 0)
	            };
	        }
	        // mm:ss.ms
	        if ((m = /^(\d+):(\d+)(\.\d+)$/.exec(input))) {
	            var mm = parseInt(m[1], 10);
	            var ss = parseInt(m[2], 10);
	            var ms = parseFloat(m[3]) * 1000;
	            return {
	                type   : "date",
	                format : format + "mm:ss.00",
	                value  : date + runtime.packTime(0, mm, ss, ms)
	            };
	        }
	        // hh:mm:ss
	        if ((m = /^(\d+):(\d+):(\d+)$/.exec(input))) {
	            var hh = parseInt(m[1], 10);
	            var mm = parseInt(m[2], 10);
	            var ss = parseInt(m[3], 10);
	            return {
	                type   : "date",
	                format : format + "hh:mm:ss",
	                value  : date + runtime.packTime(hh, mm, ss, 0)
	            };
	        }
	        // hh:mm:ss.ms
	        if ((m = /^(\d+):(\d+):(\d+)(\.\d+)$/.exec(input))) {
	            var hh = parseInt(m[1], 10);
	            var mm = parseInt(m[2], 10);
	            var ss = parseInt(m[3], 10);
	            var ms = parseFloat(m[4]) * 1000;
	            return {
	                type   : "date",
	                format : format + "hh:mm:ss.00",
	                value  : date + runtime.packTime(hh, mm, ss, ms)
	            };
	        }
	    });

	    // Support numeric formats with thousands separator and/or currency symbol, like `1,234,567.00`,
	    // `$1234`, `123,456.78 $` etc.  I apologize for this code.
	    registerFormatParser(function(input){
	        var m, n;
	        var culture = kendo.culture();
	        var comma = culture.numberFormat[","];
	        var dot = culture.numberFormat["."];
	        var currency = culture.numberFormat.currency.symbol;
	        var rxnum = getNumberRegexp(comma, dot);
	        var rxcur = new RegExp("^\\s*\\" + currency + "\\s*");
	        var sign = 1;
	        var format = "";
	        var suffix = "";
	        var has_currency = false;
	        var has_percent = false;

	        input = InputStream(input.replace(/^\s+|\s+$/g, ""));

	        // has minus before currency?
	        if (input.skip(/^-\s*/)) {
	            sign = -1;
	        }

	        // has currency before number?
	        if ((m = input.skip(rxcur))) {
	            has_currency = true;
	            format += '"' + m[0] + '"';
	        }

	        // has minus after currency?
	        if (input.skip(/^-\s*/)) {
	            if (sign < 0) {
	                return null;    // not a number
	            }
	            sign = -1;
	        }

	        // read the number itself
	        if (!(n = input.skip(rxnum))) {
	            return null;        // not a number
	        }
	        format += "0";

	        // has currency after number?
	        if ((m = input.skip(rxcur))) {
	            if (has_currency) {
	                return null;    // either before or after, not both.
	            }
	            has_currency = true;
	            suffix = '"' + m[0] + '"';
	        }

	        // has percent after number?
	        if (!has_currency && (m = input.skip(/^\s*%\s*/))) {
	            has_percent = true;
	            suffix = m[0];      // no quotes this time, % is special in format
	        }

	        if (!input.eof()) {
	            return null;        // should anything else follow, not a number
	        }

	        if (n[2] || has_currency) {
	            format = format.replace("0", "#");
	            format += ",0";
	        }
	        if (n[3]) {
	            format += "." + repeat("0", n[3].length - 1);
	        }
	        var value = n[0]
	            .replace(new RegExp("\\" + comma, "g"), "")
	            .replace(new RegExp("\\" + dot, "g"), ".");

	        value = parseFloat(value);
	        if (has_percent) {
	            value /= 100;
	        }

	        format += suffix;
	        if (has_currency) {
	            format += ';-' + format;
	        }

	        return {
	            type: "number",
	            currency: has_currency,
	            format: format,
	            value: sign * value
	        };
	    });

	    registerFormatParser(function(input){
	        var m;
	        if ((m = /^([0-9]*)\.([0-9]+)(\s*%)$/.exec(input))) {
	            return {
	                type: "number",
	                value: parseFloat(input) / 100,
	                format: "0." + repeat("0", m[2].length) + m[3]
	            };
	        }
	    });

	    var NUMBER_FORMAT_RX = {};
	    function getNumberRegexp(comma, dot) {
	        var id = comma + dot;
	        var rx = NUMBER_FORMAT_RX[id];
	        if (!rx) {
	            rx = "^(\\d+(COM\\d{3})*(DOT\\d+)?)";
	            rx = rx.replace(/DOT/g, "\\" + dot).replace(/COM/g, "\\" + comma);
	            rx = new RegExp(rx);
	            NUMBER_FORMAT_RX[id] = rx;
	        }
	        return rx;
	    }

	    function repeat(str, len) {
	        var out = "";
	        while (len-- > 0) {
	            out += str;
	        }
	        return out;
	    }

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "oUmy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var LinkedList = (function () {
    function LinkedList() {
        this.first = null;
        this.last = null;
    }
    LinkedList.prototype.add = function (item) {
        var entry = {
            item: item,
            next: null
        };
        if (this.last) {
            this.last.next = entry;
        }
        else {
            this.first = entry;
        }
        this.last = entry;
    };
    LinkedList.prototype.remove = function () {
        var result = this.first;
        if (result) {
            this.first = result.next;
            if (!this.first) {
                this.last = null;
            }
        }
        return result.item;
    };
    LinkedList.prototype.isEmpty = function () {
        return !this.first;
    };
    return LinkedList;
}());
exports.LinkedList = LinkedList;
var LinkedListItem = (function () {
    function LinkedListItem() {
    }
    return LinkedListItem;
}());


/***/ }),

/***/ "oX25":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1430);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1167:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("bfur");

/***/ }),

/***/ 1430:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1086), __webpack_require__(1167) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "timepicker",
	    name: "TimePicker",
	    category: "web",
	    description: "The TimePicker widget allows the end user to select a value from a list of predefined values or to type a new value.",
	    depends: [ "popup" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        keys = kendo.keys,
	        parse = kendo.parseDate,
	        activeElement = kendo._activeElement,
	        extractFormat = kendo._extractFormat,
	        support = kendo.support,
	        browser = support.browser,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        OPEN = "open",
	        CLOSE = "close",
	        CHANGE = "change",
	        ns = ".kendoTimePicker",
	        CLICK = "click" + ns,
	        DEFAULT = "k-state-default",
	        DISABLED = "disabled",
	        READONLY = "readonly",
	        LI = "li",
	        SPAN = "<span></span>",
	        FOCUSED = "k-state-focused",
	        HOVER = "k-state-hover",
	        HOVEREVENTS = "mouseenter" + ns + " mouseleave" + ns,
	        MOUSEDOWN = "mousedown" + ns,
	        MS_PER_MINUTE = 60000,
	        MS_PER_DAY = 86400000,
	        SELECTED = "k-state-selected",
	        STATEDISABLED = "k-state-disabled",
	        ARIA_SELECTED = "aria-selected",
	        ARIA_EXPANDED = "aria-expanded",
	        ARIA_HIDDEN = "aria-hidden",
	        ARIA_DISABLED = "aria-disabled",
	        ARIA_READONLY = "aria-readonly",
	        ARIA_ACTIVEDESCENDANT = "aria-activedescendant",
	        ID = "id",
	        isArray = $.isArray,
	        extend = $.extend,
	        proxy = $.proxy,
	        DATE = Date,
	        dateFormatRegExp = /d{1,2}|E{1,6}|e{1,6}|c{3,6}|c{1}|M{1,5}|L{1,5}|y{1,4}|H{1,2}|h{1,2}|k{1,2}|K{1,2}|m{1,2}|a{1,5}|s{1,2}|S{1,3}|z{1,4}|Z{1,5}|x{1,5}|X{1,5}|G{1,5}|q{1,5}|Q{1,5}|"[^"]*"|'[^']*'/g,
	        LITERAL = "literal",
	        MONTH = "month",
	        HOUR = "hour",
	        ZONE = "zone",
	        WEEKDAY = "weekday",
	        QUARTER = "quarter",
	        DATE_FIELD_MAP = {
	            "G": "era",
	            "y": "year",
	            "q": QUARTER,
	            "Q": QUARTER,
	            "M": MONTH,
	            "L": MONTH,
	            "d": "day",
	            "E": WEEKDAY,
	            "c": WEEKDAY,
	            "e": WEEKDAY,
	            "h": HOUR,
	            "H": HOUR,
	            "k": HOUR,
	            "K": HOUR,
	            "m": "minute",
	            "s": "second",
	            "a": "dayperiod",
	            "x": ZONE,
	            "X": ZONE,
	            "z": ZONE,
	            "Z": ZONE
	        },
	        NAME_TYPES = {
	            month: {
	                type: "months",
	                minLength: 3,
	                standAlone: "L"
	            },

	            quarter: {
	                type: "quarters",
	                minLength: 3,
	                standAlone: "q"
	            },

	            weekday: {
	                type: "days",
	                minLength: {
	                    E: 0,
	                    c: 3,
	                    e: 3
	                },
	                standAlone: "c"
	            },

	            dayperiod: {
	                type: "dayPeriods",
	                minLength: 0
	            },

	            era: {
	                type: "eras",
	                minLength: 0
	            }
	        },
	        TODAY = new DATE(),
	        MODERN_RENDERING_TEMPLATE = '<div tabindex="0" class="k-timeselector">' +
	            '<div class="k-time-header">' +
	                '<span class="k-title"></span>' +
	                '<button class="k-button k-flat k-time-now" title="Select now" aria-label="Select now">#=messages.now#</button>' +
	            '</div>' +
	            '<div class="k-time-list-container">' +
	                '<span class="k-time-highlight"></span>' +
	            '</div>' +
	        '</div>',
	        NEW_RENDERING_FOOTER = '<div class="k-time-footer k-action-buttons">' +
	            '<button class="k-button k-time-cancel" title="Cancel changes" aria-label="Cancel changes">#=messages.cancel#</button>' +
	            '<button class="k-time-accept k-button k-primary" title="Set time" aria-label="Set time">#=messages.set#</button>' +
	            '</div>',
	        HIGHLIGHTCONTAINER = '<span class="k-time-highlight"></span>';

	        TODAY = new Date(TODAY.getFullYear(), TODAY.getMonth(), TODAY.getDate(), 0, 0, 0);

	    var TimeView = function(options) {
	        var that = this,
	        id = options.id;

	        that.options = options;
	        that._dates = [];

	        that._createList(options.timeView && options.timeView.list === "scroll");

	        if (id) {
	            that._timeViewID = id + "_timeview";
	            that._optionID = id + "_option_selected";

	            that.ul.attr(ID, that._timeViewID);
	        }

	        that._heightHandler = proxy(that._height, that);

	        that._popup();
	    };

	    TimeView.prototype = {
	        _createList: function (scroll) {
	            if (scroll) {
	                this._createScrollList();
	            } else {
	                this._createClassicRenderingList();
	            }
	        },
	        _createScrollList: function () {
	            this.list = $(kendo.template(MODERN_RENDERING_TEMPLATE)(this.options))
	                .on(MOUSEDOWN, preventDefault);

	            if (!this.options.omitPopup) {
	                this.list.append(kendo.template(NEW_RENDERING_FOOTER)(this.options));
	            }

	            this.ul = this.list.find(".k-time-list-container");
	            this.list.on("click"+ns, ".k-time-header button.k-time-now", proxy(this._nowClickHandler, this));
	            this.list.on("click"+ns, ".k-time-footer button.k-time-cancel", proxy(this._cancelClickHandler, this));
	            this.list.on("click"+ns, ".k-time-footer button.k-time-accept", proxy(this._setClickHandler, this));
	            this.list.on("mouseover"+ns, ".k-time-list-wrapper", proxy(this._mouseOverHandler, this));
	            this.list.on("keydown"+ns, proxy(this._scrollerKeyDownHandler, this));
	        },

	        _scrollerKeyDownHandler: function (e) {
	            var that = this,
	                key = e.keyCode,
	                list = $(e.currentTarget).find(".k-time-list-wrapper.k-state-focused"),
	                lists = that.list.find(".k-time-list-wrapper"),
	                length = lists.length,
	                index = lists.index(list),
	                isRtl = kendo.support.isRtl(that.wrapper),
	                itemHeight = getItemHeight(list.find(".k-item:visible:eq(0)")),
	                container = list.find(".k-time-container.k-content.k-scrollable");

	            if (!list.length) {
	                return;
	            }

	            if (key == keys.RIGHT && !isRtl || key == keys.LEFT && isRtl) {
	                if (index + 1 < length) {
	                    that._focusList(lists.eq(index + 1));
	                }

	            } else if (key == keys.LEFT && !isRtl || key == keys.RIGHT && isRtl) {
	                if (index - 1 >= 0) {
	                    that._focusList(lists.eq(index - 1));
	                }
	            } else if (key == keys.UP) {
	                container.scrollTop(container.scrollTop() - itemHeight);
	                e.preventDefault();
	            } else if (key == keys.DOWN) {
	                container.scrollTop(container.scrollTop() + itemHeight);
	                e.preventDefault();
	            } else if (key === keys.ENTER) {
	                that._setClickHandler();
	            } else if (key === keys.ESC) {
	                that._cancelClickHandler();
	            }
	        },

	        _mouseOverHandler: function (e) {
	            this._focusList($(e.currentTarget));
	        },

	        _focusList: function(list){
	            this.list.find(".k-time-list-wrapper").removeClass(FOCUSED);
	            list.addClass(FOCUSED);
	            this.list.focus();
	            this._scrollTop = list.find('.k-scrollable').scrollTop();
	        },
	        _createClassicRenderingList: function () {
	            var that = this;

	            that.ul = $('<ul tabindex="-1" role="listbox" aria-hidden="true" unselectable="on" class="k-list k-reset"/>')
	                .css({
	                    overflow: support.kineticScrollNeeded ? "" : "auto"
	                })
	                .on(CLICK, LI, proxy(that._click, that))
	                .on("mouseenter" + ns, LI, function () {
	                    $(this).addClass(HOVER);
	                })
	                .on("mouseleave" + ns, LI, function () {
	                    $(this).removeClass(HOVER);
	                });

	            that.list = $("<div class='k-list-container k-list-scroller' unselectable='on'/>")
	                .append(that.ul)
	                .on(MOUSEDOWN, preventDefault);

	            that.template = kendo.template('<li tabindex="-1" role="option" class="k-item" unselectable="on">#=data#</li>', {
	                useWithBlock: false
	            });

	        },
	        current: function(candidate) {
	            var that = this,
	                active = that.options.active;

	            if (candidate !== undefined) {
	                if (that._current) {
	                    that._current
	                        .removeClass(SELECTED);
	                        if(that._current && that._current.length) {
	                            that._current[0].removeAttribute(ID);
	                            that._current[0].removeAttribute(ARIA_SELECTED);
	                        }
	                }

	                if (candidate) {
	                    candidate = $(candidate).addClass(SELECTED)
	                                            .attr(ID, that._optionID)
	                                            .attr(ARIA_SELECTED, true);

	                    that.scroll(candidate[0]);
	                }

	                that._current = candidate;

	                if (active) {
	                    active(candidate);
	                }
	            } else {
	                return that._current;
	            }
	        },

	        _updateTitle: function () {
	            this.list.find(".k-time-header > .k-title").html(kendo.toString(this._value, this.options.format, this.options.culture));
	        },

	        applyValue: function (value) {
	            if (!value) {
	                return;
	            }

	            var is12hourFormat = includes(this.options.format.toLowerCase(), "t");
	            var hours = value.getHours();
	            var minutes = value.getMinutes();
	            var seconds = value.getSeconds();
	            var designator;
	            var hoursList = this.ul.find('[data-index="1"]');
	            var minutessList = this.ul.find('[data-index="2"]');
	            var secondsList = this.ul.find('[data-index="3"]');
	            var designatorList = this.ul.find('[data-index="4"]');

	            if (is12hourFormat) {
	                if (hours >= 12) {
	                    designator = "PM";
	                    if (hours > 12) {
	                        hours -= 12;
	                    }
	                } else {
	                    designator = "AM";
	                    if (hours === 0) {
	                        hours = 12;
	                    }
	                }
	            }

	            if (hoursList.length) {
	                this._scrollListToPosition(hoursList, hours);
	            }

	            if (minutessList.length) {
	                this._scrollListToPosition(minutessList, minutes);
	            }

	            if (secondsList.length) {
	                this._scrollListToPosition(secondsList, seconds);
	            }

	            if (designatorList.length) {
	                this._scrollListToPosition(designatorList, designator);
	            }
	        },

	        _scrollListToPosition: function(list, value) {
	            var item = list.find('.k-item[data-value="' + pad(value) + '"]');
	            var itemHeight = getItemHeight(item);

	            list.scrollTop(list.find(".k-item:visible").index(item) * itemHeight);
	        },

	        close: function() {
	            this.popup.close();
	        },

	        destroy: function() {
	            var that = this;

	            that.ul.off(ns);
	            that.list.off(ns);
	            if (this.popup) {
	                that.popup.destroy();
	            }
	        },

	        open: function() {
	            var that = this;
	            var popupHovered;

	            if (!that.ul[0].firstChild || (that.ul.find("li").length < 1)) {
	                that.bind();
	            }

	            // In some cases when the popup is opened resize is triggered which will cause it to close
	            // Setting the below flag will prevent this from happening
	            // Reference: https://github.com/telerik/kendo/pull/7553
	            popupHovered = that.popup._hovered;
	            that.popup._hovered = true;

	            that.popup.open();

	            setTimeout(function() {
	                that.popup._hovered = popupHovered;
	            }, 1);

	            if (that._current) {
	                that.scroll(that._current[0]);
	            }
	        },

	        dataBind: function(dates) {
	            var that = this,
	                options = that.options,
	                format = options.format,
	                toString = kendo.toString,
	                template = that.template,
	                length = dates.length,
	                idx = 0,
	                date,
	                html = "";

	            for (; idx < length; idx++) {
	                date = dates[idx];

	                if (isInRange(date, options.min, options.max)) {
	                    html += template(toString(date, format, options.culture));
	                }
	            }

	            that._html(html);
	        },

	        refresh: function() {
	            var that = this,
	                options = that.options,
	                format = options.format,
	                offset = dst(),
	                ignoreDST = offset < 0,
	                value = kendo.parseDate(that._value),
	                parsedValue = value ? mergeDateAndTime(value, options.min) : mergeDateAndTime(new Date(), options.min),
	                min = options.min,
	                max = options.max,
	                msMin = getMilliseconds(min),
	                msMax = getMilliseconds(max),
	                msLastTime = getMilliseconds(lastTimeOption(options.interval)),
	                msInterval = options.interval * MS_PER_MINUTE,
	                toString = kendo.toString,
	                template = that.template,
	                start = options.useValueToRender ? parsedValue : new Date(+options.min),
	                startDate = new DATE(start),
	                msStart,
	                length,
	                html = "";

	            if (ignoreDST) {
	                length = (MS_PER_DAY + (offset * MS_PER_MINUTE)) / msInterval;
	            } else {
	                length = MS_PER_DAY / msInterval;
	            }

	            if (msMin != msMax || msLastTime === msMax) {
	                if (msMin > msMax) {
	                    msMax += MS_PER_DAY;
	                }

	                length = ((msMax - msMin) / msInterval) + 1;
	            }

	            if (options.timeView && options.timeView.list === "scroll") {
	                html = that._createListContent(splitDateFormat(format));
	            } else {
	                that.getDatesInRange(msStart, msMax, startDate, max, msInterval, start).forEach(function (date) {
	                    html += template(toString(date, format, options.culture));
	                });
	            }

	            that._html(html);
	        },

	        _updateListBottomOffset: function (list) {
	            var itemHeight = getItemHeight(list.find(".k-item:visible:eq(0)"));
	            var listHeight = list.outerHeight();
	            var bottomOffset = listHeight - itemHeight;
	            list.find(".k-scrollable-placeholder").css({
	                height: list.find("ul").height() + bottomOffset
	            });
	        },

	        _updateHoursRange: function () {
	            var that = this;
	            var hoursList = this.ul.find('[data-index="1"]');
	            var minHours = this._minHours;
	            var maxHours = this._maxHours;
	            var is12hourFormat = includes(this.options.format.toLowerCase(), "t");
	            var useMax;
	            var useMin;
	            var selectedDesignator = this._findSelectedValue(this.ul.find('[data-index="4"]'));

	            if (!hoursList.length) {
	                return;
	            }

	            if (is12hourFormat && selectedDesignator) {

	                if (selectedDesignator === "AM") {
	                    if (minHours < 12) {
	                        useMin = true;
	                    }

	                    if (maxHours < 12) {
	                        useMax = true;
	                    }
	                } else if (selectedDesignator === "PM") {

	                    if (minHours > 12) {
	                        useMin = true;
	                        minHours -= 12;
	                    }

	                    if (maxHours > 12) {
	                        useMax = true;
	                        maxHours -= 12;
	                    }
	                }

	                hoursList.find(".k-item").each(function (_, item) {
	                    item = $(item);
	                    var value = +item.attr("data-value");
	                    if ((that._validateMin && useMin && value < minHours) || (that._validateMax && useMax && value > maxHours)) {
	                        item.hide();
	                    } else {
	                        item.show();
	                    }
	                });
	            } else {
	                hoursList.find(".k-item").each(function (_, item) {
	                    item = $(item);
	                    var value = +item.attr("data-value");
	                    if ((that._validateMin && value < minHours) ||
	                        (that._validateMax && value > maxHours)) {
	                        item.hide();
	                    } else {
	                        item.show();
	                    }
	                });
	            }

	            this._updateListBottomOffset(hoursList);
	        },

	        _updateMinutesRange: function () {
	            var that = this;
	            var minutesList = this.ul.find('[data-index="2"]');
	            var minHours = this._minHours;
	            var maxHours = this._maxHours;
	            var minMinutes = this._minMinutes;
	            var maxMinutes = this._maxMinutes;
	            var selectedHour = +this._findSelectedValue(this.ul.find('[data-index="1"]'));
	            var is12hourFormat = includes(this.options.format.toLowerCase(), "t");
	            var selectedDesignator = this._findSelectedValue(this.ul.find('[data-index="4"]'));

	            if (is12hourFormat && selectedDesignator === "PM") {
	                selectedHour += 12;
	            }

	            if (!minutesList.length) {
	                return;
	            }

	            minutesList.find(".k-item").each(function (_, item) {
	                item = $(item);
	                var value = +item.attr("data-value");
	                if ((that._validateMin && value < minMinutes && minHours && selectedHour === minHours) ||
	                    (that._validateMax && value > maxMinutes && maxHours && selectedHour === maxHours)) {
	                    item.hide();
	                } else {
	                    item.show();
	                }
	            });

	            this._updateListBottomOffset(minutesList);
	        },

	        _updateSecondsRange: function () {
	            var that = this;
	            var secondsList = this.ul.find('[data-index="3"]');
	            var minSeconds = this._minSeconds;
	            var maxSeconds = this._minSeconds;
	            var minMinutes = this._minMinutes;
	            var maxMinutes = this._maxMinutes;
	            var selectedMinutes = +this._findSelectedValue(this.ul.find('[data-index="2"]'));

	            if (!secondsList.length) {
	                return;
	            }

	            secondsList.find(".k-item").each(function (_, item) {
	                item = $(item);
	                var value = +item.attr("data-value");
	                if ((that._validateMin && value < minSeconds && minMinutes && selectedMinutes === minMinutes) ||
	                    (that._validateMax && value > maxSeconds && maxMinutes && selectedMinutes === maxMinutes)) {
	                    item.hide();
	                } else {
	                    item.show();
	                }
	            });

	            this._updateListBottomOffset(secondsList);
	        },

	        _updateDesignatorRange: function () {
	            var minHours = this._minHours;
	            var maxHours = this._maxHours;
	            var designatorList = this.ul.find('[data-index="4"]');

	            if (!designatorList.length) {
	               return;
	            }

	            if (this._validateMin && minHours >= 12) {
	                designatorList.find('.k-item[data-value="AM"]').hide();
	            } else {
	                designatorList.find('.k-item[data-value="AM"]').show();
	            }

	            if (this._validateMax && maxHours < 12) {
	                designatorList.find('.k-item[data-value="PM"]').hide();
	            } else {
	                designatorList.find('.k-item[data-value="PM"]').show();
	            }
	        },


	        _updateRanges: function () {
	            if (!this.options.specifiedRange) {
	                return;
	            }
	            if (!this._currentlySelected) {
	                this._currentlySelected = new Date();
	            }

	            var max = this.options.max;
	            var min = this.options.min;

	            if (this.options.validateDate) {
	                if (max.getFullYear() === this._currentlySelected.getFullYear() &&
	                    max.getMonth() === this._currentlySelected.getMonth() &&
	                    max.getDate() === this._currentlySelected.getDate()) {
	                    this._validateMax = true;
	                } else {
	                    this._validateMax = false;
	                }

	                if (min.getFullYear() === this._currentlySelected.getFullYear() &&
	                    min.getMonth() === this._currentlySelected.getMonth() &&
	                    min.getDate() === this._currentlySelected.getDate()) {
	                    this._validateMin = true;
	                } else {
	                    this._validateMin = false;
	                }

	                if (!this._validateMax && !this._validateMin) {
	                    return;
	                }
	            } else {
	                this._validateMax = true;
	                this._validateMin = true;
	            }

	            this._minMinutes = min.getMinutes();
	            this._maxMinutes = max.getMinutes();
	            this._minHours = min.getHours();
	            this._maxHours = max.getHours();
	            this._minSeconds = min.getSeconds();
	            this._maxSeconds = max.getSeconds();

	            this._updateDesignatorRange();
	            this._updateHoursRange();
	            this._updateMinutesRange();
	            this._updateSecondsRange();
	        },

	        addTranslate: function () {
	            var lists = this.ul.find(".k-time-container.k-content.k-scrollable");
	            var length = lists.length;
	            var list;
	            var itemHeight;
	            var listHeight;
	            var topOffset;
	            var translate;
	            var bottomOffset;

	            for (var i = 0; i < length; i++) {
	                list = lists.eq(i);
	                itemHeight = getItemHeight(list.find(".k-item:visible:eq(0)"));
	                listHeight = list.outerHeight();
	                topOffset = (listHeight - itemHeight) / 2;
	                translate = "translateY(" + topOffset + "px)";
	                bottomOffset = listHeight - itemHeight;
	                list.find("ul").css({
	                    transform: translate,
	                    "-ms-transform": translate
	                });
	                list.find(".k-scrollable-placeholder").css({
	                    height: list.find("ul").height() + bottomOffset
	                });
	                list.off(ns)
	                    .on("click" + ns, ".k-item", proxy(this._itemClickHandler, this))
	                    .on("scroll" + ns, proxy(this._listScrollHandler, this));
	            }
	        },

	        _nowClickHandler: function () {
	            var now = new Date();
	            this.value(now);
	            this.options.change(kendo.toString(now, this.options.format, this.options.culture));
	        },

	        _cancelClickHandler: function () {
	            this.value(this._value);
	            this.popup.close();
	        },

	        _setClickHandler: function () {
	            this._value = new Date(this._currentlySelected);

	            this.options.change(kendo.toString(this._currentlySelected, this.options.format, this.options.culture), true);
	            this.popup.close();
	        },

	        _listScrollHandler: function (e) {
	            var that = this;
	            var itemHeight = getItemHeight($(e.currentTarget).find(".k-item:visible:eq(0)"));

	            if (that._scrollingTimeout) {
	                clearTimeout(that._scrollingTimeout);
	            }

	            that._scrollingTimeout = setTimeout(function () {
	                if (e.currentTarget.scrollTop % itemHeight > 1) {
	                    e.currentTarget.scrollTop += itemHeight - e.currentTarget.scrollTop % itemHeight;
	                }
	                that._scrollTop = e.currentTarget.scrollTop;
	                that._updateCurrentlySelected();
	                that._updateRanges();
	            }, 100);
	        },

	        _updateCurrentlySelected: function () {
	            var is12hourFormat = includes(this.options.format.toLowerCase(), "t");
	            var hoursList = this.ul.find('[data-index="1"]');
	            var minutesList = this.ul.find('[data-index="2"]');
	            var secondsList = this.ul.find('[data-index="3"]');
	            var designatorList = this.ul.find('[data-index="4"]');
	            var selectedHour;
	            var selectedMinutes;
	            var selectedSeconds;
	            var selectedDesignator;

	            if (!this.ul.is(":visible")) {
	                return;
	            }

	            if (!this._currentlySelected) {
	                this._currentlySelected = this._value ? new Date(this._value) : new Date();
	            }

	            if (hoursList.length) {
	                selectedHour = +this._findSelectedValue(hoursList);
	            }

	            if (minutesList.length) {
	                selectedMinutes = +this._findSelectedValue(minutesList);
	            }

	            if (secondsList.length) {
	                selectedSeconds = +this._findSelectedValue(secondsList);
	            }

	            if (designatorList.length) {
	                selectedDesignator = this._findSelectedValue(designatorList);
	            }

	            if (is12hourFormat) {
	                if (selectedDesignator == "PM") {
	                    selectedHour += 12;
	                    if (selectedHour == 24) {
	                        selectedHour = 12;
	                    }
	                }

	                if (selectedDesignator === "AM" && selectedHour === 12) {
	                    selectedHour = 0;
	                }
	            }

	            if (selectedHour !== undefined) {
	                this._currentlySelected.setHours(selectedHour);
	            }

	            if (selectedMinutes !== undefined) {
	                this._currentlySelected.setMinutes(selectedMinutes);
	            }

	            if (selectedSeconds !== undefined) {
	                this._currentlySelected.setSeconds(selectedSeconds);
	            }
	        },

	        _findSelectedValue: function(list) {
	           var firstOccurence = firstItemIndex(list.scrollTop(), getItemHeight(list.find(".k-item:visible:eq(0)")));
	           return list.find(".k-item:visible").eq(firstOccurence).attr("data-value");
	        },

	        _itemClickHandler: function (e) {
	            var list = $(e.originalEvent.currentTarget);
	            var index = list.find(".k-item:visible").index($(e.currentTarget));
	            var itemHeight = getItemHeight(list.find(".k-item:visible:eq(0)"));

	            list.scrollTop(index * itemHeight);
	        },

	        getDatesInRange: function (msStart, msMax, startDate, max, msInterval, start) {
	            var result = [];

	            while (true) {
	                if (msMax && (getMilliseconds(start) >= msMax || startDate.getDate() != start.getDate())) {
	                    msStart = getMilliseconds(start);
	                    if (startDate < start) {
	                        msStart += MS_PER_DAY;
	                    }
	                    if (msStart > msMax) {
	                        start = new DATE(+max);
	                    }
	                    if (getMilliseconds(start) > 0) {
	                        result.push(new Date(start));
	                    }
	                    break;
	                }
	                if (startDate.getDate() != start.getDate()) {
	                    break;
	                }
	                result.push(new Date(start));
	                start.setTime(start.getTime() + msInterval);
	                if (!msMax && this.options.maxSet){
	                    break;
	                }
	            }

	            return result;
	        },

	        _createListContent: function (parts) {
	            var length = parts.length;
	            var result = "";
	            var part;
	            var values;

	            for (var i = 0; i < length; i++) {
	                part = parts[i];

	                if (part.type === "literal") {
	                    result += this._literalTemplate(part);
	                } else {
	                    values = this._getValues(part, true);
	                    result += this._itemTemplate(values.values, part, this.options.messages[part.type], values.index);
	                }
	            }

	            return result;
	        },

	        _itemTemplate: function (values, part, title, index) {
	            var result ="";
	            var length = values.length;

	            result += '<div class="k-time-list-wrapper" role="presentation">' +
	                        '<span class="k-title">' + (title || part.type) + '</span>' +
	                        '<div class="k-time-list">' +
	                            '<div class="k-time-container k-content k-scrollable" role="presentation" data-index="' + index + '">' +
	                                '<ul class="k-reset">';

	            for( var i = 0;i < length; i++){
	                result += '<li class="k-item" data-value="' + values[i] + '">' +
	                                '<span>' + values[i] + '</span>' +
	                           '</li>';
	            }

	            result += '</ul>' +
	                      '<div class="k-scrollable-placeholder"></div>' +
	                    '</div>' +
	                '</div>' +
	            '</div>';

	            return result;
	        },

	        _getValues: function (part, shouldPad) {
	            var result = [];
	            var index;
	            var start = 0;
	            var end;

	            if (part.type === "hour") {
	                start = 1;
	                index = 1;
	                end = part.hour12 ? 12 : 24;
	            } else if (part.type === "minute") {
	                index = 2;
	                end = 59;
	            } else if (part.type === "second") {
	                index = 3;
	                end = 59;
	            }

	            for (; start <= end; start++) {
	                result.push(shouldPad ? pad(start) : start);
	            }

	            return {
	                values: result,
	                index: index
	            };
	        },

	        _literalTemplate: function (part) {
	            var result = '<div class="k-time-separator">' +
	                (part.pattern === " tt" ? ':' : part.pattern) +
	                '</div>';

	            if (part.pattern === " tt") {
	                result += this._itemTemplate(["AM", "PM"], part, "AM/PM", 4);
	            }

	            return result;
	        },

	        bind: function() {
	            var that = this,
	                dates = that.options.dates;

	            if (dates && dates[0]) {
	                that.dataBind(dates);
	            } else {
	                that.refresh();
	            }
	        },

	        _html: function(html) {
	            var that = this;

	            if (that.options.timeView && that.options.timeView.list === "scroll") {
	                html = HIGHLIGHTCONTAINER + html;
	                that.ul.html(html);
	            } else {
	                that.ul[0].innerHTML = html;
	                that.popup.unbind(OPEN, that._heightHandler);
	                that.popup.one(OPEN, that._heightHandler);

	                that.current(null);
	                that.select(that._value);
	            }
	        },

	        scroll: function(item) {
	            if (!item) {
	                return;
	            }

	            var content = this.list[0],
	                itemOffsetTop = item.offsetTop,
	                itemOffsetHeight = item.offsetHeight,
	                contentScrollTop = content.scrollTop,
	                contentOffsetHeight = content.clientHeight,
	                bottomDistance = itemOffsetTop + itemOffsetHeight;

	                if (contentScrollTop > itemOffsetTop) {
	                    contentScrollTop = itemOffsetTop;
	                } else if (bottomDistance > (contentScrollTop + contentOffsetHeight)) {
	                    contentScrollTop = (bottomDistance - contentOffsetHeight);
	                }

	                content.scrollTop = contentScrollTop;
	        },

	        select: function(li) {
	            var that = this,
	                options = that.options,
	                current = that._current,
	                selection;

	            if (li instanceof Date) {
	                li = kendo.toString(li, options.format, options.culture);
	            }

	            if (typeof li === "string") {
	                if (!current || current.text() !== li) {
	                    li = $.grep(that.ul[0].childNodes, function(node) {
	                        return (node.textContent || node.innerText) == li;
	                    });

	                    li = li[0] ? li : null;
	                } else {
	                    li = current;
	                }
	            }
	            selection = that._distinctSelection(li);
	            that.current(selection);
	        },

	        _distinctSelection: function(selection) {
	            var that = this,
	                currentValue,
	                selectionIndex;

	            if (selection && selection.length > 1) {
	                currentValue = getMilliseconds(that._value);
	                selectionIndex = $.inArray(currentValue, that._dates);
	                selection = that.ul.children()[selectionIndex];
	            }

	            return selection;
	        },

	        setOptions: function(options) {
	            var old = this.options;

	            options.min = parse(options.min);
	            options.max = parse(options.max);

	            this.options = extend(old, options, {
	                active: old.active,
	                change: old.change,
	                close: old.close,
	                open: old.open
	            });

	            this.bind();
	        },

	        toggle: function() {
	            var that = this;

	            if (that.popup.visible()) {
	                that.close();
	            } else {
	                that.open();
	            }
	        },

	        value: function(value) {
	            var that = this;

	            that._value = value;
	            if (that.ul[0].firstChild) {
	                if (that.options.timeView && that.options.timeView.list === "scroll") {
	                    that.applyValue(value);
	                } else {
	                    that.select(value);
	                }
	            }
	        },

	        _click: function(e) {
	            var that = this,
	                li = $(e.currentTarget),
	                date = li.text(),
	                dates = that.options.dates;

	            if (dates && dates.length > 0) {
	                date = dates[li.index()];
	            }

	            if (!e.isDefaultPrevented()) {
	                that.select(li);
	                that.options.change(date, true);
	                that.close();
	            }
	        },

	        _height: function() {
	            var that = this;
	            var list = that.list;
	            var parent = list.parent(".k-animation-container");
	            var height = that.options.height;

	            if (that.ul[0].children.length) {
	                list.add(parent)
	                    .show()
	                    .height(that.ul[0].scrollHeight > height ? height : "auto")
	                    .hide();
	            }
	        },

	        _parse: function(value) {
	            var that = this,
	                options = that.options,
	                min = getMilliseconds(options.min) != getMilliseconds(TODAY) ? options.min : null,
	                max = getMilliseconds(options.max) != getMilliseconds(TODAY) ? options.max : null,
	                current = that._value || min || max || TODAY;

	            if (value instanceof DATE) {
	                return value;
	            }

	            value = parse(value, options.parseFormats, options.culture);

	            if (value) {
	                value = new DATE(current.getFullYear(),
	                                 current.getMonth(),
	                                 current.getDate(),
	                                 value.getHours(),
	                                 value.getMinutes(),
	                                 value.getSeconds(),
	                                 value.getMilliseconds());
	            }

	            return value;
	        },

	        _adjustListWidth: function() {
	            var list = this.list,
	                width = list[0].style.width,
	                wrapper = this.options.anchor,
	                computedStyle, computedWidth,
	                outerWidth = kendo._outerWidth;

	            if (!list.data("width") && width) {
	                return;
	            }

	            computedStyle = window.getComputedStyle ? window.getComputedStyle(wrapper[0], null) : 0;
	            computedWidth = computedStyle ? parseFloat(computedStyle.width) : outerWidth(wrapper);

	            if (computedStyle && (browser.mozilla || browser.msie)) { // getComputedStyle returns different box in FF and IE.
	                computedWidth += parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight) + parseFloat(computedStyle.borderLeftWidth) + parseFloat(computedStyle.borderRightWidth);
	            }

	            width = computedWidth - (outerWidth(list) - list.width());

	            list.css({
	                fontFamily: wrapper.css("font-family"),
	                width: width
	            })
	            .data("width", width);
	        },

	        _popup: function() {
	            var that = this,
	                list = that.list,
	                options = that.options,
	                anchor = options.anchor;

	            if(!this.options.omitPopup){

	                that.popup = new ui.Popup(list, extend(options.popup, {
	                    anchor: anchor,
	                    open: options.open,
	                    close: options.close,
	                    animation: options.animation,
	                    isRtl: support.isRtl(options.anchor),
	                    activate: function () {
	                        if (that.options.timeView && that.options.timeView.list === "scroll") {
	                            that.addTranslate();
	                            if (that._value) {
	                                that.applyValue(that._value);
	                            } else {
	                                that._updateCurrentlySelected();
	                            }
	                            that._updateRanges();
	                            that._focusList(that.list.find(".k-time-list-wrapper:eq(0)"));
	                        }
	                    }
	                }));
	            } else {
	                list.appendTo(options.timeDiv);
	            }
	        },

	        move: function(e) {
	            var that = this,
	                key = e.keyCode,
	                ul = that.ul[0],
	                current = that._current,
	                down = key === keys.DOWN;

	            if (key === keys.UP || down) {
	                if (e.altKey) {
	                    that.toggle(down);
	                    return;
	                } else if (down) {
	                    current = current ? current[0].nextSibling : ul.firstChild;
	                } else {
	                    current = current ? current[0].previousSibling : ul.lastChild;
	                }

	                if (current) {
	                    that.select(current);
	                }

	                that.options.change(that._current.text());
	                e.preventDefault();

	            } else if (key === keys.ENTER || key === keys.TAB || key === keys.ESC) {
	                e.preventDefault();
	                if (current) {
	                    that.options.change(current.text(), true);
	                }
	                that.close();
	            }
	        }
	    };

	    function dst() {
	        var today = new DATE(),
	            midnight = new DATE(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
	            noon = new DATE(today.getFullYear(), today.getMonth(), today.getDate(), 12, 0, 0);

	        return -1 * (midnight.getTimezoneOffset() - noon.getTimezoneOffset());
	    }

	    function getMilliseconds(date) {
	        return date.getHours() * 60 * MS_PER_MINUTE + date.getMinutes() * MS_PER_MINUTE + date.getSeconds() * 1000 + date.getMilliseconds();
	    }

	    function lastTimeOption(interval) {
	        var date = new Date(2100, 0, 1);
	        date.setMinutes(-interval);
	        return date;
	    }

	    function isInRange(value, min, max) {
	        var msMin = getMilliseconds(min),
	            msMax = getMilliseconds(max),
	            msValue;

	        if (!value || msMin == msMax) {
	            return true;
	        }

	        msValue = getMilliseconds(value);

	        if (msMin > msValue) {
	            msValue += MS_PER_DAY;
	        }

	        if (msMax < msMin) {
	            msMax += MS_PER_DAY;
	        }

	        return msValue >= msMin && msValue <= msMax;
	    }

	    TimeView.getMilliseconds = getMilliseconds;

	    kendo.TimeView = TimeView;

	    var TimePicker = Widget.extend({
	        init: function(element, options) {
	            var that = this, ul, timeView, disabled;

	            options = options || {};
	            options.componentType = options.componentType || "classic";

	            Widget.fn.init.call(that, element, options);

	            element = that.element;
	            options = that.options;

	            options.min = parse(element.attr("min")) || parse(options.min);
	            options.max = parse(element.attr("max")) || parse(options.max);

	            if (+options.max != +TODAY || +options.min != +TODAY) {
	                this._specifiedRange = true;
	            }

	            normalize(options);

	            that._initialOptions = extend({}, options);

	            that._wrapper();

	            if (that.options.timeView && that.options.timeView.list === "scroll") {
	                that.options.height = null;
	            }

	            that.timeView = timeView = new TimeView(extend({}, options, {
	                id: element.attr(ID),
	                anchor: that.wrapper,
	                format: options.format,
	                change: function(value, trigger) {
	                    if (trigger) {
	                        that._change(value);
	                    } else {
	                        element.val(value);
	                    }
	                },
	                open: function(e) {
	                    if (that.options.timeView && that.options.timeView.list !== "scroll") {
	                        that.timeView._adjustListWidth();
	                    } else {
	                        that.timeView._updateTitle();
	                    }

	                    if (that.trigger(OPEN)) {
	                        e.preventDefault();
	                    } else {
	                        element.attr(ARIA_EXPANDED, true);
	                        ul.attr(ARIA_HIDDEN, false);
	                    }
	                },
	                close: function(e) {
	                    if (that.trigger(CLOSE)) {
	                        e.preventDefault();
	                    } else {
	                        element.attr(ARIA_EXPANDED, false);
	                        ul.attr(ARIA_HIDDEN, true);
	                    }
	                },
	                active: function(current) {
	                    if(element && element.length) {
	                        element[0].removeAttribute(ARIA_ACTIVEDESCENDANT);
	                    }
	                    if (current) {
	                        element.attr(ARIA_ACTIVEDESCENDANT, timeView._optionID);
	                    }
	                },
	                specifiedRange: that._specifiedRange,
	                maxSet: +options.max != +TODAY
	            }));
	            ul = timeView.ul;

	            that._icon();
	            that._reset();

	            try {
	                element[0].setAttribute("type", "text");
	            } catch(e) {
	                element[0].type = "text";
	            }

	            element.addClass("k-input")
	                   .attr({
	                        "role": "combobox",
	                        "aria-expanded": false,
	                        "aria-owns": timeView._timeViewID,
	                        "autocomplete": "off"
	                   });

	            disabled = element.is("[disabled]") || $(that.element).parents("fieldset").is(':disabled');
	            if (disabled) {
	                that.enable(false);
	            } else {
	                that.readonly(element.is("[readonly]"));
	            }
	            if (options.dateInput) {
	                var min = options.min;
	                var max = options.max;
	                var today = new DATE();
	                if (getMilliseconds(min) == getMilliseconds(max)) {
	                    min = new DATE(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
	                    max = new DATE(today.getFullYear(), today.getMonth(), today.getDate(), 24, 0, 0);
	                }

	                that._dateInput = new ui.DateInput(element, {
	                    culture: options.culture,
	                    format: options.format,
	                    min: min,
	                    max: max,
	                    value: options.value,
	                    interval: options.interval
	                });
	            }
	            that._old = that._update(options.value || that.element.val());
	            that._oldText = element.val();

	            kendo.notify(that);
	        },

	        options: {
	            name: "TimePicker",
	            min: TODAY,
	            max: TODAY,
	            format: "",
	            dates: [],
	            parseFormats: [],
	            value: null,
	            interval: 30,
	            height: 200,
	            animation: {},
	            dateInput: false,
	            messages: {
	                set: "Set",
	                cancel: "Cancel",
	                hour: "hour",
	                minute: "minute",
	                second: "second",
	                millisecond: "millisecond",
	                now: "Now"
	            },
	            componentType: "classic"
	        },

	        events: [
	         OPEN,
	         CLOSE,
	         CHANGE
	        ],

	        componentTypes: {
	            "classic": {
	                timeView: {
	                    list: "list"
	                }
	            },
	            "modern": {
	                timeView: {
	                    list: "scroll"
	                }
	            }
	        },

	        setOptions: function(options) {
	            var that = this;
	            var value = that._value;

	            Widget.fn.setOptions.call(that, options);
	            options = that.options;

	            normalize(options);

	            that.timeView.setOptions(options);

	            if (value) {
	                that.element.val(kendo.toString(value, options.format, options.culture));
	            }
	        },

	        dataBind: function(dates) {
	            if (isArray(dates)) {
	                this.timeView.dataBind(dates);
	            }
	        },

	        _editable: function(options) {
	            var that = this,
	                disable = options.disable,
	                readonly = options.readonly,
	                arrow = that._arrow.off(ns),
	                element = that.element.off(ns),
	                wrapper = that._inputWrapper.off(ns);

	            if (that._dateInput) {
	                that._dateInput._unbindInput();
	            }

	            if (!readonly && !disable) {
	                wrapper
	                    .addClass(DEFAULT)
	                    .removeClass(STATEDISABLED)
	                    .on(HOVEREVENTS, that._toggleHover);

	                if(element && element.length) {
	                    element[0].removeAttribute(DISABLED);
	                    element[0].removeAttribute(READONLY);
	                }
	                element.attr(ARIA_DISABLED, false)
	                       .attr(ARIA_READONLY, false)
	                       .on("keydown" + ns, proxy(that._keydown, that))
	                       .on("focusout" + ns, proxy(that._blur, that))
	                       .on("focus" + ns, function() {
	                           that._inputWrapper.addClass(FOCUSED);
	                       });

	                if (that._dateInput) {
	                    that._dateInput._bindInput();
	                }
	               arrow.on(CLICK, proxy(that._click, that))
	                   .on(MOUSEDOWN, preventDefault);
	            } else {
	                wrapper
	                    .addClass(disable ? STATEDISABLED : DEFAULT)
	                    .removeClass(disable ? DEFAULT : STATEDISABLED);

	                element.attr(DISABLED, disable)
	                       .attr(READONLY, readonly)
	                       .attr(ARIA_DISABLED, disable)
	                       .attr(ARIA_READONLY, readonly);
	            }
	        },

	        readonly: function(readonly) {
	            this._editable({
	                readonly: readonly === undefined ? true : readonly,
	                disable: false
	            });
	        },

	        enable: function(enable) {
	            this._editable({
	                readonly: false,
	                disable: !(enable = enable === undefined ? true : enable)
	            });
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            that.timeView.destroy();

	            that.element.off(ns);
	            that._arrow.off(ns);
	            that._inputWrapper.off(ns);

	            if (that._form) {
	                that._form.off("reset", that._resetHandler);
	            }
	        },

	        close: function() {
	            this.timeView.close();
	        },

	        open: function() {
	            this.timeView.open();
	        },

	        min: function (value) {
	            return this._option("min", value);
	        },

	        max: function (value) {
	            if (value && this.timeView) {
	                this.timeView.options.maxSet = true;
	            } else if (this.timeView) {
	                this.timeView.options.maxSet = false;
	            }
	            return this._option("max", value);
	        },

	        value: function(value) {
	            var that = this;

	            if (value === undefined) {
	                return that._value;
	            }

	            that._old = that._update(value);

	            if (that._old === null) {
	                that.element.val("");
	            }

	            that._oldText = that.element.val();
	        },

	        _blur: function() {
	            var that = this,
	                value = that.element.val();

	           if (!(that.options.timeView && that.options.timeView.list === "scroll")) {
	               that.close();
	           }

	            if (value !== that._oldText) {
	                that._change(value);
	            }
	            that._inputWrapper.removeClass(FOCUSED);
	        },

	        _click: function() {
	            var that = this,
	                element = that.element;

	            that.timeView.toggle();

	            if (!support.touch && element[0] !== activeElement()) {
	                element.trigger("focus");
	            }
	        },

	        _change: function(value) {
	            var that = this,
	            oldValue = that.element.val(),
	            dateChanged;

	            value = that._update(value);
	            dateChanged = !kendo.calendar.isEqualDate(that._old, value);

	            var valueUpdated = dateChanged && !that._typing;
	            var textFormatted = oldValue !== that.element.val();

	            if (valueUpdated || textFormatted) {
	                that.element.trigger(CHANGE);
	            }

	            if (dateChanged) {
	                that._old = value;
	                that._oldText = that.element.val();

	                that.trigger(CHANGE);
	            }

	            that._typing = false;
	        },

	        _icon: function() {
	            var that = this,
	                element = that.element,
	                arrow;

	            arrow = element.next("span.k-select");

	            if (!arrow[0]) {
	                arrow = $('<span unselectable="on" class="k-select" aria-label="select"><span class="k-icon k-i-clock"></span></span>').insertAfter(element);
	            }

	            that._arrow = arrow.attr({
	                "role": "button",
	                "aria-controls": that.timeView._timeViewID
	            });
	        },

	        _keydown: function(e) {
	            var that = this,
	                key = e.keyCode,
	                timeView = that.timeView,
	                value = that.element.val();

	            if (timeView.popup.visible() || e.altKey) {
	                timeView.move(e);
	                if (that._dateInput && e.stopImmediatePropagation) {
	                    e.stopImmediatePropagation();
	                }
	            } else if (key === keys.ENTER && value !== that._oldText) {
	                that._change(value);
	            } else {
	                that._typing = true;
	            }
	        },

	        _option: function(option, value) {
	            var that = this,
	                options = that.options;

	            if (value === undefined) {
	                return options[option];
	            }

	            value = that.timeView._parse(value);

	            if (!value) {
	                return;
	            }

	            value = new DATE(+value);

	            options[option] = value;
	            that.timeView.options[option] = value;
	            that.timeView.bind();
	        },

	        _toggleHover: function(e) {
	            $(e.currentTarget).toggleClass(HOVER, e.type === "mouseenter");
	        },

	        _update: function(value) {
	            var that = this,
	                options = that.options,
	                timeView = that.timeView,
	                date = timeView._parse(value);

	            if (!isInRange(date, options.min, options.max)) {
	                date = null;
	            }

	            that._value = date;
	            that._currentlySelected = date;
	            if (that._dateInput && date) {
	                that._dateInput.value(date || value);
	            } else {
	                that.element.val(kendo.toString(date || value, options.format, options.culture));
	            }
	            timeView.value(date);

	            return date;
	        },

	        _wrapper: function() {
	            var that = this,
	                element = that.element,
	                wrapper;

	            wrapper = element.parents(".k-timepicker");

	            if (!wrapper[0]) {
	                wrapper = element.wrap(SPAN).parent().addClass("k-picker-wrap k-state-default");
	                wrapper = wrapper.wrap(SPAN).parent();
	            }

	            wrapper[0].style.cssText = element[0].style.cssText;
	            that.wrapper = wrapper.addClass("k-widget k-timepicker")
	                .addClass(element[0].className);

	            element.css({
	                width: "100%",
	                height: element[0].style.height
	            });

	            that._inputWrapper = $(wrapper[0].firstChild);
	        },

	        _reset: function() {
	            var that = this,
	                element = that.element,
	                formId = element.attr("form"),
	                form = formId ? $("#" + formId) : element.closest("form");

	            if (form[0]) {
	                that._resetHandler = function() {
	                    that.value(element[0].defaultValue);
	                    that.max(that._initialOptions.max);
	                    that.min(that._initialOptions.min);
	                };

	                that._form = form.on("reset", that._resetHandler);
	            }
	        }
	    });

	    function normalize(options) {
	        var parseFormats = options.parseFormats;

	        options.format = extractFormat(options.format || kendo.getCulture(options.culture).calendars.standard.patterns.t);

	        parseFormats = isArray(parseFormats) ? parseFormats : [parseFormats];
	        parseFormats.splice(0, 0, options.format);
	        options.parseFormats = parseFormats;
	    }

	    function preventDefault(e) {
	        e.preventDefault();
	    }

	    function mergeDateAndTime(date, time) {
	        return new Date(date.getFullYear(),
	            date.getMonth(),
	            date.getDate(),
	            time.getHours(),
	            time.getMinutes(),
	            time.getSeconds(),
	            time.getMilliseconds());
	    }

	    function datePattern(format, info) {
	        var calendar = info.calendar;
	        var result;
	        if (typeof format === "string") {
	            if (calendar.patterns[format]) {
	                result = calendar.patterns[format];
	            } else {
	                result = format;
	            }
	        }

	        if (!result) {
	            result = calendar.patterns.d;
	        }

	        return result;
	    }

	    function addLiteral(parts, value) {
	        var lastPart = parts[parts.length - 1];
	        if (lastPart && lastPart.type === "LITERAL") {
	            lastPart.pattern += value;
	        } else {
	            parts.push({
	                type: LITERAL,
	                pattern: value
	            });
	        }
	    }

	    function isHour12(pattern) {
	        return pattern === "h" || pattern === "K";
	    }

	    function dateNameType(formatLength) {
	        var nameType;
	        if (formatLength <= 3) {
	            nameType = "abbreviated";
	        } else if (formatLength === 4) {
	            nameType = "wide";
	        } else if (formatLength === 5) {
	            nameType = "narrow";
	        } else if (formatLength === 6) {
	            nameType = "short";
	        }

	        return nameType;
	    }

	    function startsWith(text, searchString, position) {
	        position = position || 0;
	        return text.indexOf(searchString, position) === position;
	    }

	    function includes(text, subStr) {
	        var returnValue = false;

	        if (text.indexOf(subStr) !== -1) {
	            returnValue = true;
	        }

	        return returnValue;
	    }

	    function splitDateFormat(format) {
	        var info = kendo.culture();
	        var pattern = datePattern(format, info);
	        var parts = [];
	        var lastIndex = dateFormatRegExp.lastIndex = 0;
	        var match = dateFormatRegExp.exec(pattern);
	        var specifier;
	        var type;
	        var part;
	        var names;
	        var minLength;
	        var patternLength;

	        while (match) {
	            var value = match[0];

	            if (lastIndex < match.index) {
	                addLiteral(parts, pattern.substring(lastIndex, match.index));
	            }

	            if (startsWith(value, '"') || startsWith(value, "'")) {
	                addLiteral(parts, value);
	            } else {
	                specifier = value[0];
	                type = DATE_FIELD_MAP[specifier];
	                part = {
	                    type: type,
	                    pattern: value
	                };

	                if (type === "hour") {
	                    part.hour12 = isHour12(value);
	                }

	                names = NAME_TYPES[type];

	                if (names) {
	                    minLength = typeof names.minLength === "number" ? names.minLength : names.minLength[specifier];
	                    patternLength = value.length;

	                    if (patternLength >= minLength) {
	                        part.names = {
	                            type: names.type,
	                            nameType: dateNameType(patternLength),
	                            standAlone: names.standAlone === specifier
	                        };
	                    }
	                }

	                parts.push(part);
	            }

	            lastIndex = dateFormatRegExp.lastIndex;
	            match = dateFormatRegExp.exec(pattern);
	        }

	        if (lastIndex < pattern.length) {
	            addLiteral(parts, pattern.substring(lastIndex));
	        }

	        return parts;
	    }

	    function pad(value, size) {
	        var s = String(value);
	        while (s.length < (size || 2)) {
	            s = "0" + s;
	        }
	        return s;
	    }

	    function firstItemIndex(scrollTop, itemHeight) {
	        return Math.max(Math.round(scrollTop / itemHeight), 0);
	    }

	    function getItemHeight (item){
	        return item.length && item[0].getBoundingClientRect().height;
	    }

	    ui.plugin(TimePicker);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "orsE":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1575);
	module.exports = __webpack_require__(1575);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1kkP");

/***/ }),

/***/ 1030:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nce5");

/***/ }),

/***/ 1575:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1030), __webpack_require__(6), __webpack_require__(1576)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {
	    var kendo = window.kendo,
	        extend = $.extend,
	        proxy = $.proxy,
	        ACTION = "action",
	        FLATBUTTONCLASS = "k-flat",
	        KEYDOWN = "keydown",
	        CLICK = kendo.support.click,
	        CHANGE = "change",
	        ZOOMIN = "zoomin",
	        ZOOMOUT = "zoomout",
	        Item = kendo.toolbar.Item,
	        ToolBar = kendo.ui.ToolBar,
	        PREDEFINED_ZOOM_VALUES = {
	            auto: "auto",
	            actual: "actual",
	            fitToWidth: "fitToWidth",
	            fitToPage: "fitToPage"
	        },
	        styles = {
	            zoomOutIcon: "k-i-zoom-out",
	            zoomInIcon: "k-i-zoom-in",
	            zoomButtons: "k-button-icon k-flat",
	            zoomOverflowButtons: "k-button-icontext k-overflow-button",
	            overflowHidden: "k-overflow-hidden"
	        };

	    var ZOOM_BUTTON_TEMPLATE = kendo.template('<a href="\\#" aria-label="#=text#" title="#=text#" data-command="#=command#" class="k-button #=className#"><span class="k-icon #= iconClass #"></span> ${showText ? text : ""}</a>');
	    var ZOOM_COMBOBOX_TEMPLATE = kendo.template('<select title="#=zoomLevel#">' +
	        '#for(var zoomIndex in zoomLevels){#' +
	            '# var zoomLevel = zoomLevels[zoomIndex]; #' +
	            '<option value="#= zoomLevel.percent || (zoomLevel + "%") #">${zoomLevel.text ? zoomLevel.text : zoomLevel + "%"}</option>' +
	        '#}#'  +
	    '</select>');

	    var DefaultTools = {
	        pager: { type: "pager", overflow: "never", command: "PageChangeCommand" },
	        spacer: { type: "spacer" },
	        zoom: { type: "zoom", command: "ZoomCommand", zoomInOut: true, combobox: { zoomLevels: [50, 100, 150, 200, 300, 400] } },
	        toggleSelection: {
	            type: "buttonGroup",
	            attributes: { "class": "k-toggle-selection-group" },
	            buttons: [
	                { togglable: true, text: "Enable Selection", command: "EnableSelectionCommand", icon: "cursor", showText: "overflow", name: "toggleSelection", group: "toggle-pan" },
	                { togglable: true, text: "Enable Panning", command: "EnablePanCommand", icon: "hand", showText: "overflow", name: "togglePan", group: "toggle-pan", selected: true }
	            ]
	        },
	        spacer2: { type: "spacer" },
	        search: { type: "button", text: "Search", command: "OpenSearchCommand", icon: "search", name: "search", showText: "overflow" },
	        open: { type: "button", text: "Open", showText: "overflow", name: "open", icon: "folder-open", command: "OpenCommand" },
	        download: { type: "button", text: "Download", showText: "overflow", name: "download", icon: "download", command: "DownloadCommand" },
	        print: { type: "button", text: "Print", showText: "overflow", name: "print", icon: "print", command: "PrintCommand" }
	    };

	    var AllTools = extend({}, DefaultTools, {
	        exportAs: { type: "button", text: "Export", showText: "overflow", name: "exportAs", icon: "image-export", command: "ExportCommand" }
	    });

	    var ToolbarPager = Item.extend({
	        init: function(options, toolbar) {
	            var pagerElement = $("<div />");

	            this.options = extend(true, options, toolbar.options.pager);

	            this.toolbar = toolbar;

	            this.toolbar.pager = new kendo.pdfviewer.Pager(pagerElement, extend({}, options, {
	                change: proxy(this._change, this)
	            }));

	            this.element = pagerElement;
	            this.element.on(KEYDOWN, proxy(this._keydown, this));

	            this.attributes();
	            this.addUidAttr();
	            this.addOverflowAttr();
	        },
	        _change: function (e) {
	            if (this.options.change && this.options.change(e.page))
	            {
	                return;
	            }

	            this.toolbar.action({
	                command: "PageChangeCommand",
	                options: {
	                    value: e.page
	                }
	            });
	        },
	        _keydown: function (e) {
	            var that = this,
	                target = $(e.target),
	                keyCode = e.keyCode,
	                children = that.element.find(":kendoFocusable"),
	                targetIndex = children.index(target),
	                direction = e.shiftKey ? -1 : 1;

	            if (keyCode === kendo.keys.TAB && children[targetIndex + direction])
	            {
	                children[targetIndex + direction].focus();
	                e.preventDefault();
	                e.stopPropagation();
	            }
	        }
	    });

	    kendo.toolbar.registerComponent("pager", ToolbarPager);

	    function appendZoomButtons (element, messages, isOverflow) {
	        var className = isOverflow ? styles.zoomOverflowButtons : styles.zoomButtons;

	        element.append(ZOOM_BUTTON_TEMPLATE({
	            text: messages.zoomOut,
	            command: ZOOMOUT,
	            iconClass: styles.zoomOutIcon,
	            showText: isOverflow,
	            className: className
	        }));
	        element.append(ZOOM_BUTTON_TEMPLATE({
	            text: messages.zoomIn,
	            command: ZOOMIN,
	            iconClass:  styles.zoomInIcon,
	            showText: isOverflow,
	            className: className
	        }));
	    }

	    var ToolBarZoom = Item.extend({
	        init: function(options, toolbar) {
	            this._init(options, toolbar);
	            this.toolbar.zoom = this;

	            if (toolbar.options.scale)
	            {
	                this._initValue = toolbar.options.scale * 100 + "%";
	            }

	            this._appendElements();

	            this._click = kendo.throttle(
	                this._click.bind(this),
	                200
	            );
	            this._keydown = kendo.throttle(
	                this._keydown.bind(this),
	                200
	            );

	            this.element.on(CLICK, ".k-button", this._click);
	            this.element.on(KEYDOWN, ".k-button", this._keydown);

	            this.attributes();
	            this.addUidAttr();
	            this.addOverflowAttr();
	        },

	        _init: function (options, toolbar) {
	            var zoomElement = $("<div />");

	            this.options = extend(true, options, {
	                messages: toolbar.options.messages.zoom
	            });

	            this.toolbar = toolbar;
	            this.element = zoomElement;
	        },

	        _appendElements: function () {
	            var options = this.options;

	            if (options.zoomInOut) {
	                appendZoomButtons(this.element, options.messages, false);
	            }

	            if (options.combobox) {
	                this._buildComboBox();
	            }
	        },

	        _buildComboBox: function () {
	            var that = this,
	                combobox,
	                messages = that.options.messages,
	                comboOptions = that.options.combobox,
	                zoomLevels = [{
	                    percent: PREDEFINED_ZOOM_VALUES.auto,
	                    text: messages.autoWidth
	                }, {
	                    percent: PREDEFINED_ZOOM_VALUES.actual,
	                    text: messages.actualWidth
	                }, {
	                    percent: PREDEFINED_ZOOM_VALUES.fitToWidth,
	                    text: messages.fitToWidth
	                }, {
	                    percent: PREDEFINED_ZOOM_VALUES.fitToPage,
	                    text: messages.fitToPage
	                }];

	            zoomLevels = zoomLevels.concat(comboOptions.zoomLevels);

	            combobox = $(ZOOM_COMBOBOX_TEMPLATE({
	                zoomLevels: zoomLevels,
	                zoomLevel: messages.zoomLevel
	            }));

	            if (!kendo.support.mobileOS) {
	                combobox = combobox.kendoComboBox(extend({
	                    autoWidth: true,
	                    clearButton: false,
	                    value: that._initValue
	                }, comboOptions)).getKendoComboBox();

	                that.element.append(combobox.wrapper);
	                that.combobox = combobox;
	                that._currentValue = combobox.value();
	            } else {
	                that.element.append(combobox);
	            }

	            combobox.bind(CHANGE, kendo.throttle(that.change.bind(that), 300));
	        },

	        change: function (e) {
	            var value = e.sender ? e.sender.value() : e.target.value,
	                parsedValue;

	            if (value.toString().match(/^[0-9]+%?$/)) {
	                parsedValue = parseInt(value.replace('%', ''), 10) / 100;
	            } else if (!PREDEFINED_ZOOM_VALUES[value]){
	                if (this.combobox)
	                {
	                    this.combobox.value(this._currentValue);
	                }
	                e.preventDefault();
	                return;
	            }

	            this._currentValue = value;
	            this.toolbar.action({
	                command: "ZoomCommand",
	                options: {
	                    scale: parsedValue || value
	                }
	            });
	        },

	        _buttonCommand: function (target) {
	            var button = $(target).closest(".k-button"),
	            command = button.data("command");

	            this.toolbar.action({
	                command: "ZoomCommand",
	                options: {
	                    zoomIn: command === ZOOMIN,
	                    zoomOut: command === ZOOMOUT,
	                    updateComboBox: true
	                }
	            });
	        },

	        _click: function (e) {
	            this._buttonCommand(e.target);
	        },

	        _keydown: function (e) {
	            var key = e.keyCode,
	                keys = kendo.keys;

	            if (key === keys.ENTER) {
	                this._buttonCommand(e.target);
	                e.preventDefault();
	            }
	        },

	        enable: function (value) {
	            var element = this.element;

	            element.find(".k-button, select").toggleClass("k-state-disabled", !value);

	            if (this.combobox) {
	                this.combobox.enable(value);
	            }
	        },

	        destroy: function(){
	            if (this.combobox) {
	                this.combobox.destroy();
	            }
	        }
	    });

	    var ToolBarOverflowZoom = ToolBarZoom.extend({
	        _init: function (options, toolbar) {
	            var zoomElement = $("<li></li>");

	            this.options = extend(true, options, {
	                messages: toolbar.options.messages.zoom
	            });

	            this.toolbar = toolbar;
	            this.element = zoomElement;
	        },
	        _appendElements: function () {
	            var options = this.options;
	            if (options.zoomInOut) {
	                appendZoomButtons(this.element, options.messages, true);
	            }
	        },
	        overflowHidden: function() {
	            this.element.addClass(styles.overflowHidden);
	        }
	    });

	    kendo.toolbar.registerComponent("zoom", ToolBarZoom, ToolBarOverflowZoom);

	    var ViewerToolBar = ToolBar.extend({
	        init: function(element, options) {
	            var that = this;
	            var items = options.items && options.items.length ? options.items : Object.keys(DefaultTools);

	            that.options = options;

	            options.items = that._updateItems(items);

	            ToolBar.fn.init.call(that, element, options);

	            that.bind({
	                click: that._click,
	                toggle: that._click
	            });

	            options.viewer.bind({
	                update: that._update.bind(that)
	            });
	        },
	        events: [
	            ACTION
	        ],
	        _updateItems: function (items) {
	            var that = this;
	            var messages = this.options.messages;

	            return items.map(function (tool) {
	                var isBuiltInTool =  $.isPlainObject(tool) && Object.keys(tool).length === 1 && tool.name;
	                tool = isBuiltInTool ? tool.name : tool;
	                var toolOptions = $.isPlainObject(tool) ? tool : AllTools[tool];
	                var options;
	                var toolName =  toolOptions.name;

	                if (toolOptions.type === "buttonGroup") {
	                    toolOptions.buttons = that._updateItems(toolOptions.buttons);
	                } else if (toolOptions.type !== "pager") {
	                    options = {
	                        name: toolName,
	                        attributes: {
	                            "aria-label": messages[toolName],
	                            "title": messages[toolName],
	                            "data-command": toolOptions.command,
	                            "class": FLATBUTTONCLASS
	                        },
	                        overflow: toolOptions.overflow
	                    };
	                } else {
	                    options = {
	                        overflow: "never"
	                    };
	                }

	                kendo.deepExtend(toolOptions, options);

	                return toolOptions;
	            });
	        },
	        _click: function (e)
	        {
	            var command = $(e.target).data("command");

	            if (!command) {
	                return;
	            }

	            this.action({
	                command: command,
	                options: e.options
	            });
	        },
	        _update: function (e) {
	            var pageOptions = {
	                page: e.page || 1,
	                total: e.total || 1
	            };

	            if (this.zoom) {
	                this.zoom.enable(!e.isBlank);
	                if (e.action === "zoom") {
	                    this._updateZoomComboBox(e.zoom);
	                }
	            }

	            if ((e.action === "pagechange" || e.isBlank) && this.pager) {
	                this.pager.setOptions(pageOptions);
	            }

	            this.enable(this.wrapper.find(".k-toggle-selection-group"), !e.isBlank);

	            this.enable(this.wrapper.find("[data-command='OpenSearchCommand']"), !e.isBlank);
	            this.enable(this.wrapper.find("[data-command='DownloadCommand']"), !e.isBlank);
	            this.enable(this.wrapper.find("[data-command='PrintCommand']"), !e.isBlank);
	        },
	        _updateZoomComboBox: function (value) {
	            var isPredefined = value === PREDEFINED_ZOOM_VALUES.auto ||
	                                value === PREDEFINED_ZOOM_VALUES.actual;

	            if (!isPredefined) {
	                value = Math.round(value * 100) + '%';
	            }

	            if (this.zoom && this.zoom.combobox) {
	                this.zoom._currentValue = value;
	                this.zoom.combobox.value(value);
	            }
	        },
	        action: function (args)
	        {
	            this.trigger(ACTION, args);
	        },
	        destroy: function () {
	            if (this.pager) {
	                this.pager.destroy();
	            }

	            if (this.zoom) {
	                this.zoom.destroy();
	            }
	            ToolBar.fn.destroy.call(this);
	        }
	    });


	    extend(kendo.pdfviewer, {
	        Toolbar: ViewerToolBar,
	        DefaultTools: DefaultTools
	    });
	})(window.kendo.jQuery);

	return window.kendo;
	}, __webpack_require__(3));

/***/ }),

/***/ 1576:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("3f5E");

/***/ })

/******/ });

/***/ }),

/***/ "p1b6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "pBtG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "pOb1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var columnGroup_1 = __webpack_require__("YX13");
var column_1 = __webpack_require__("hDyE");
var eventService_1 = __webpack_require__("k5uU");
var context_1 = __webpack_require__("RQ1/");
var columnApi_1 = __webpack_require__("E/Wy");
var gridApi_1 = __webpack_require__("BAow");
var OriginalColumnGroup = (function () {
    function OriginalColumnGroup(colGroupDef, groupId, padding) {
        this.localEventService = new eventService_1.EventService();
        this.expandable = false;
        this.colGroupDef = colGroupDef;
        this.groupId = groupId;
        this.expanded = colGroupDef && !!colGroupDef.openByDefault;
        this.padding = padding;
    }
    OriginalColumnGroup.prototype.isVisible = function () {
        // return true if at least one child is visible
        if (this.children) {
            return this.children.some(function (child) { return child.isVisible(); });
        }
        else {
            return false;
        }
    };
    OriginalColumnGroup.prototype.isPadding = function () {
        return this.padding;
    };
    OriginalColumnGroup.prototype.setExpanded = function (expanded) {
        this.expanded = expanded;
        var event = {
            type: OriginalColumnGroup.EVENT_EXPANDED_CHANGED
        };
        this.localEventService.dispatchEvent(event);
    };
    OriginalColumnGroup.prototype.isExpandable = function () {
        return this.expandable;
    };
    OriginalColumnGroup.prototype.isExpanded = function () {
        return this.expanded;
    };
    OriginalColumnGroup.prototype.getGroupId = function () {
        return this.groupId;
    };
    OriginalColumnGroup.prototype.getId = function () {
        return this.getGroupId();
    };
    OriginalColumnGroup.prototype.setChildren = function (children) {
        this.children = children;
    };
    OriginalColumnGroup.prototype.getChildren = function () {
        return this.children;
    };
    OriginalColumnGroup.prototype.getColGroupDef = function () {
        return this.colGroupDef;
    };
    OriginalColumnGroup.prototype.getLeafColumns = function () {
        var result = [];
        this.addLeafColumns(result);
        return result;
    };
    OriginalColumnGroup.prototype.addLeafColumns = function (leafColumns) {
        if (!this.children) {
            return;
        }
        this.children.forEach(function (child) {
            if (child instanceof column_1.Column) {
                leafColumns.push(child);
            }
            else if (child instanceof OriginalColumnGroup) {
                child.addLeafColumns(leafColumns);
            }
        });
    };
    OriginalColumnGroup.prototype.getColumnGroupShow = function () {
        if (!this.padding) {
            return this.colGroupDef.columnGroupShow;
        }
        else {
            // if this is padding we have exactly only child. we then
            // take the value from the child and push it up, making
            // this group 'invisible'.
            return this.children[0].getColumnGroupShow();
        }
    };
    // need to check that this group has at least one col showing when both expanded and contracted.
    // if not, then we don't allow expanding and contracting on this group
    OriginalColumnGroup.prototype.setupExpandable = function () {
        var _this = this;
        this.setExpandable();
        // note - we should be removing this event listener
        this.getLeafColumns().forEach(function (col) { return col.addEventListener(column_1.Column.EVENT_VISIBLE_CHANGED, _this.onColumnVisibilityChanged.bind(_this)); });
    };
    OriginalColumnGroup.prototype.setExpandable = function () {
        // want to make sure the group doesn't disappear when it's open
        var atLeastOneShowingWhenOpen = false;
        // want to make sure the group doesn't disappear when it's closed
        var atLeastOneShowingWhenClosed = false;
        // want to make sure the group has something to show / hide
        var atLeastOneChangeable = false;
        for (var i = 0, j = this.children.length; i < j; i++) {
            var abstractColumn = this.children[i];
            if (!abstractColumn.isVisible()) {
                continue;
            }
            // if the abstractColumn is a grid generated group, there will be no colDef
            var headerGroupShow = abstractColumn.getColumnGroupShow();
            if (headerGroupShow === columnGroup_1.ColumnGroup.HEADER_GROUP_SHOW_OPEN) {
                atLeastOneShowingWhenOpen = true;
                atLeastOneChangeable = true;
            }
            else if (headerGroupShow === columnGroup_1.ColumnGroup.HEADER_GROUP_SHOW_CLOSED) {
                atLeastOneShowingWhenClosed = true;
                atLeastOneChangeable = true;
            }
            else {
                atLeastOneShowingWhenOpen = true;
                atLeastOneShowingWhenClosed = true;
            }
        }
        var expandable = atLeastOneShowingWhenOpen && atLeastOneShowingWhenClosed && atLeastOneChangeable;
        if (this.expandable !== expandable) {
            this.expandable = expandable;
            var event_1 = {
                type: OriginalColumnGroup.EVENT_EXPANDABLE_CHANGED
            };
            this.localEventService.dispatchEvent(event_1);
        }
    };
    OriginalColumnGroup.prototype.onColumnVisibilityChanged = function () {
        this.setExpandable();
    };
    OriginalColumnGroup.prototype.addEventListener = function (eventType, listener) {
        this.localEventService.addEventListener(eventType, listener);
    };
    OriginalColumnGroup.prototype.removeEventListener = function (eventType, listener) {
        this.localEventService.removeEventListener(eventType, listener);
    };
    OriginalColumnGroup.EVENT_EXPANDED_CHANGED = 'expandedChanged';
    OriginalColumnGroup.EVENT_EXPANDABLE_CHANGED = 'expandableChanged';
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], OriginalColumnGroup.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], OriginalColumnGroup.prototype, "gridApi", void 0);
    return OriginalColumnGroup;
}());
exports.OriginalColumnGroup = OriginalColumnGroup;


/***/ }),

/***/ "pQ38":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var beanStub_1 = __webpack_require__("xffp");
var compIdSequence = new utils_1.NumberSequence();
var Component = (function (_super) {
    __extends(Component, _super);
    function Component(template) {
        var _this = _super.call(this) || this;
        _this.childComponents = [];
        _this.annotatedEventListeners = [];
        _this.visible = true;
        // unique id for this row component. this is used for getting a reference to the HTML dom.
        // we cannot use the RowNode id as this is not unique (due to animation, old rows can be lying
        // around as we create a new rowComp instance for the same row node).
        _this.compId = compIdSequence.next();
        if (template) {
            _this.setTemplate(template);
        }
        return _this;
    }
    Component.prototype.getCompId = function () {
        return this.compId;
    };
    Component.prototype.instantiate = function (context) {
        this.instantiateRecurse(this.getGui(), context);
    };
    Component.prototype.instantiateRecurse = function (parentNode, context) {
        var childCount = parentNode.childNodes ? parentNode.childNodes.length : 0;
        for (var i = 0; i < childCount; i++) {
            var childNode = parentNode.childNodes[i];
            var newComponent = context.createComponent(childNode);
            if (newComponent) {
                this.swapComponentForNode(newComponent, parentNode, childNode);
            }
            else {
                if (childNode.childNodes) {
                    this.instantiateRecurse(childNode, context);
                }
            }
        }
    };
    Component.prototype.swapComponentForNode = function (newComponent, parentNode, childNode) {
        parentNode.replaceChild(newComponent.getGui(), childNode);
        this.childComponents.push(newComponent);
        this.swapInComponentForQuerySelectors(newComponent, childNode);
    };
    Component.prototype.swapInComponentForQuerySelectors = function (newComponent, childNode) {
        var thisProto = Object.getPrototypeOf(this);
        var thisNoType = this;
        while (thisProto != null) {
            var metaData = thisProto.__agComponentMetaData;
            var currentProtoName = (thisProto.constructor).name;
            if (metaData && metaData[currentProtoName] && metaData[currentProtoName].querySelectors) {
                metaData[currentProtoName].querySelectors.forEach(function (querySelector) {
                    if (thisNoType[querySelector.attributeName] === childNode) {
                        thisNoType[querySelector.attributeName] = newComponent;
                    }
                });
            }
            thisProto = Object.getPrototypeOf(thisProto);
        }
    };
    Component.prototype.setTemplate = function (template) {
        var eGui = utils_1.Utils.loadTemplate(template);
        this.setTemplateFromElement(eGui);
    };
    Component.prototype.setTemplateFromElement = function (element) {
        this.eGui = element;
        this.eGui.__agComponent = this;
        this.addAnnotatedEventListeners();
        this.wireQuerySelectors();
    };
    Component.prototype.attributesSet = function () {
    };
    Component.prototype.wireQuerySelectors = function () {
        var _this = this;
        if (!this.eGui) {
            return;
        }
        var thisProto = Object.getPrototypeOf(this);
        var _loop_1 = function () {
            var metaData = thisProto.__agComponentMetaData;
            var currentProtoName = (thisProto.constructor).name;
            if (metaData && metaData[currentProtoName] && metaData[currentProtoName].querySelectors) {
                var thisNoType_1 = this_1;
                metaData[currentProtoName].querySelectors.forEach(function (querySelector) {
                    var resultOfQuery = _this.eGui.querySelector(querySelector.querySelector);
                    if (resultOfQuery) {
                        var backingComponent = resultOfQuery.__agComponent;
                        if (backingComponent) {
                            thisNoType_1[querySelector.attributeName] = backingComponent;
                        }
                        else {
                            thisNoType_1[querySelector.attributeName] = resultOfQuery;
                        }
                    }
                    else {
                        // put debug msg in here if query selector fails???
                    }
                });
            }
            thisProto = Object.getPrototypeOf(thisProto);
        };
        var this_1 = this;
        while (thisProto != null) {
            _loop_1();
        }
    };
    Component.prototype.addAnnotatedEventListeners = function () {
        var _this = this;
        this.removeAnnotatedEventListeners();
        if (!this.eGui) {
            return;
        }
        var thisProto = Object.getPrototypeOf(this);
        while (thisProto != null) {
            var metaData = thisProto.__agComponentMetaData;
            var currentProtoName = (thisProto.constructor).name;
            if (metaData && metaData[currentProtoName] && metaData[currentProtoName].listenerMethods) {
                if (!this.annotatedEventListeners) {
                    this.annotatedEventListeners = [];
                }
                metaData[currentProtoName].listenerMethods.forEach(function (eventListener) {
                    var listener = _this[eventListener.methodName].bind(_this);
                    _this.eGui.addEventListener(eventListener.eventName, listener);
                    _this.annotatedEventListeners.push({ eventName: eventListener.eventName, listener: listener });
                });
            }
            thisProto = Object.getPrototypeOf(thisProto);
        }
    };
    Component.prototype.removeAnnotatedEventListeners = function () {
        var _this = this;
        if (!this.annotatedEventListeners) {
            return;
        }
        if (!this.eGui) {
            return;
        }
        this.annotatedEventListeners.forEach(function (eventListener) {
            _this.eGui.removeEventListener(eventListener.eventName, eventListener.listener);
        });
        this.annotatedEventListeners = null;
    };
    Component.prototype.getGui = function () {
        return this.eGui;
    };
    // this method is for older code, that wants to provide the gui element,
    // it is not intended for this to be in ag-Stack
    Component.prototype.setGui = function (eGui) {
        this.eGui = eGui;
    };
    Component.prototype.queryForHtmlElement = function (cssSelector) {
        return this.eGui.querySelector(cssSelector);
    };
    Component.prototype.queryForHtmlInputElement = function (cssSelector) {
        return this.eGui.querySelector(cssSelector);
    };
    Component.prototype.appendChild = function (newChild) {
        if (utils_1.Utils.isNodeOrElement(newChild)) {
            this.eGui.appendChild(newChild);
        }
        else {
            var childComponent = newChild;
            this.eGui.appendChild(childComponent.getGui());
            this.childComponents.push(childComponent);
        }
    };
    Component.prototype.addFeature = function (context, feature) {
        context.wireBean(feature);
        if (feature.destroy) {
            this.addDestroyFunc(feature.destroy.bind(feature));
        }
    };
    Component.prototype.isVisible = function () {
        return this.visible;
    };
    Component.prototype.setVisible = function (visible) {
        if (visible !== this.visible) {
            this.visible = visible;
            utils_1.Utils.addOrRemoveCssClass(this.eGui, 'ag-hidden', !visible);
            var event_1 = {
                type: Component.EVENT_VISIBLE_CHANGED,
                visible: this.visible
            };
            this.dispatchEvent(event_1);
        }
    };
    Component.prototype.addOrRemoveCssClass = function (className, addOrRemove) {
        utils_1.Utils.addOrRemoveCssClass(this.eGui, className, addOrRemove);
    };
    Component.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.childComponents.forEach(function (childComponent) { return childComponent.destroy(); });
        this.childComponents.length = 0;
        this.removeAnnotatedEventListeners();
    };
    Component.prototype.addGuiEventListener = function (event, listener) {
        var _this = this;
        this.getGui().addEventListener(event, listener);
        this.addDestroyFunc(function () { return _this.getGui().removeEventListener(event, listener); });
    };
    Component.prototype.addCssClass = function (className) {
        utils_1.Utils.addCssClass(this.getGui(), className);
    };
    Component.prototype.removeCssClass = function (className) {
        utils_1.Utils.removeCssClass(this.getGui(), className);
    };
    Component.prototype.getAttribute = function (key) {
        var eGui = this.getGui();
        if (eGui) {
            return eGui.getAttribute(key);
        }
        else {
            return null;
        }
    };
    Component.prototype.getRefElement = function (refName) {
        return this.queryForHtmlElement('[ref="' + refName + '"]');
    };
    Component.EVENT_VISIBLE_CHANGED = 'visibleChanged';
    return Component;
}(beanStub_1.BeanStub));
exports.Component = Component;


/***/ }),

/***/ "pV45":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(927);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 884:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FTkt");

/***/ }),

/***/ 927:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(884), __webpack_require__(928) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($, undefined) {
	    // Imports ================================================================
	    var math = Math,
	        abs = math.abs,
	        atan = math.atan,
	        atan2 = math.atan2,
	        cos = math.cos,
	        max = math.max,
	        min = math.min,
	        sin = math.sin,
	        tan = math.tan,

	        kendo = window.kendo,
	        Class = kendo.Class,

	        dataviz = kendo.dataviz,
	        deepExtend = kendo.deepExtend,

	        util = kendo.drawing.util,
	        defined = util.defined,
	        deg = util.deg,
	        rad = util.rad,
	        round = util.round,
	        valueOrDefault = util.valueOrDefault,

	        sqr = kendo.util.sqr;

	    // Implementation =========================================================
	    var Location = Class.extend({
	        init: function(lat, lng) {
	            if (arguments.length === 1) {
	                this.lat = lat[0];
	                this.lng = lat[1];
	            } else {
	                this.lat = lat;
	                this.lng = lng;
	            }
	        },

	        DISTANCE_ITERATIONS: 100,
	        DISTANCE_CONVERGENCE: 1e-12,
	        DISTANCE_PRECISION: 2,
	        FORMAT: "{0:N6},{1:N6}",

	        toArray: function() {
	            return [this.lat, this.lng];
	        },

	        equals: function(loc) {
	            return loc && loc.lat === this.lat && loc.lng === this.lng;
	        },

	        clone: function() {
	            return new Location(this.lat, this.lng);
	        },

	        round: function(precision) {
	            this.lng = round(this.lng, precision);
	            this.lat = round(this.lat, precision);
	            return this;
	        },

	        wrap: function() {
	            this.lng = this.lng % 180;
	            this.lat = this.lat % 90;
	            return this;
	        },

	        distanceTo: function(dest, datum) {
	            return this.greatCircleTo(dest, datum).distance;
	        },

	        destination: function(distance, bearing, datum) {
	            bearing = rad(bearing);
	            datum = datum || dataviz.map.datums.WGS84;

	            var fromLat = rad(this.lat);
	            var fromLng = rad(this.lng);
	            var dToR = distance / kendo.dataviz.map.datums.WGS84.a;

	            var lat = math.asin(sin(fromLat) * cos(dToR) +
	                                cos(fromLat) * sin(dToR) * cos(bearing));

	            var lng = fromLng + atan2(sin(bearing) * sin(dToR) * cos(fromLat),
	                                      cos(dToR) - sin(fromLat) * sin(lat));

	           return new Location(deg(lat), deg(lng));
	        },

	        greatCircleTo: function(dest, datum) {
	            dest = Location.create(dest);
	            datum = datum || dataviz.map.datums.WGS84;

	            if (!dest || this.clone().round(8).equals(dest.clone().round(8))) {
	                return {
	                    distance: 0,
	                    azimuthFrom: 0,
	                    azimuthTo: 0
	                };
	            }

	            // See http://en.wikipedia.org/wiki/Vincenty's_formulae#Notation
	            // o == sigma
	            // A == alpha
	            var a = datum.a;
	            var b = datum.b;
	            var f = datum.f;

	            var L = rad(dest.lng - this.lng);

	            var U1 = atan((1 - f) * tan(rad(this.lat)));
	            var sinU1 = sin(U1);
	            var cosU1 = cos(U1);

	            var U2 = atan((1 - f) * tan(rad(dest.lat)));
	            var sinU2 = sin(U2);
	            var cosU2 = cos(U2);

	            var lambda = L;
	            var prevLambda;

	            var i = this.DISTANCE_ITERATIONS;
	            var converged = false;

	            var sinLambda;
	            var cosLambda;
	            var sino;
	            var cosA2;
	            var coso;
	            var cos2om;
	            var sigma;

	            while (!converged && i-- > 0) {
	                sinLambda = sin(lambda);
	                cosLambda = cos(lambda);
	                sino = math.sqrt(
	                    sqr(cosU2 * sinLambda) + sqr(cosU1 * sinU2 - sinU1 * cosU2 * cosLambda)
	                );

	                coso = sinU1 * sinU2 + cosU1 * cosU2 * cosLambda;
	                sigma = atan2(sino, coso);

	                var sinA = cosU1 * cosU2 * sinLambda / sino;
	                cosA2 = 1 - sqr(sinA);
	                cos2om = 0;
	                if (cosA2 !== 0) {
	                    cos2om = coso - 2 * sinU1 * sinU2 / cosA2;
	                }

	                prevLambda = lambda;
	                var C = f / 16 * cosA2 * (4 + f * (4 - 3 * cosA2));
	                lambda = L + (1 - C) * f * sinA * (
	                    sigma + C * sino * (cos2om + C * coso * (-1 + 2 * sqr(cos2om)))
	                );

	                converged = abs(lambda - prevLambda) <= this.DISTANCE_CONVERGENCE;
	            }

	            var u2 = cosA2 * (sqr(a) - sqr(b)) / sqr(b);
	            var A = 1 + u2 / 16384 * (4096 + u2 * (-768 + u2 * (320 - 175 * u2)));
	            var B = u2 / 1024 * (256 + u2 * (-128 + u2 * (74 - 47 * u2)));
	            var deltao = B * sino * (cos2om + B / 4 * (
	                coso * (-1 + 2 * sqr(cos2om)) - B / 6 * cos2om * (-3 + 4 * sqr(sino)) * (-3 + 4 * sqr(cos2om))
	            ));

	            var azimuthFrom = atan2(cosU2 * sinLambda, cosU1 * sinU2 - sinU1 * cosU2 * cosLambda);
	            var azimuthTo = atan2(cosU1 * sinLambda, -sinU1 * cosU2 + cosU1 * sinU2 * cosLambda);

	            return {
	                distance: round(b * A * (sigma - deltao), this.DISTANCE_PRECISION),
	                azimuthFrom: deg(azimuthFrom),
	                azimuthTo: deg(azimuthTo)
	            };
	        }
	    });

	    // IE < 9 doesn't allow to override toString on definition
	    Location.fn.toString = function() {
	        return kendo.format(this.FORMAT, this.lat, this.lng);
	    };

	    Location.fromLngLat = function(ll) {
	        return new Location(ll[1], ll[0]);
	    };

	    Location.fromLatLng = function(ll) {
	        return new Location(ll[0], ll[1]);
	    };

	    Location.create = function(a, b) {
	        if (defined(a)) {
	            if (a instanceof Location) {
	                return a.clone();
	            } else if (arguments.length === 1 && a.length === 2) {
	                return Location.fromLatLng(a);
	            } else {
	                return new Location(a, b);
	            }
	        }
	    };

	    var Extent = Class.extend({
	        init: function(nw, se) {
	            nw = Location.create(nw);
	            se = Location.create(se);

	            if (nw.lng + 180 > se.lng + 180 &&
	                nw.lat + 90 < se.lat + 90) {
	                this.se = nw;
	                this.nw = se;
	            } else {
	                this.se = se;
	                this.nw = nw;
	            }
	        },

	        contains: function(loc) {
	            var nw = this.nw,
	                se = this.se,
	                lng = valueOrDefault(loc.lng, loc[1]),
	                lat = valueOrDefault(loc.lat, loc[0]);

	            return loc &&
	                   lng + 180 >= nw.lng + 180 &&
	                   lng + 180 <= se.lng + 180 &&
	                   lat + 90 >= se.lat + 90 &&
	                   lat + 90 <= nw.lat + 90;
	        },

	        center: function() {
	            var nw = this.nw;
	            var se = this.se;

	            var lng = nw.lng + (se.lng - nw.lng) / 2;
	            var lat = nw.lat + (se.lat - nw.lat) / 2;
	            return new Location(lat, lng);
	        },

	        containsAny: function(locs) {
	            var result = false;
	            for (var i = 0; i < locs.length; i++) {
	                result = result || this.contains(locs[i]);
	            }

	            return result;
	        },

	        include: function(loc) {
	            var nw = this.nw,
	                se = this.se,
	                lng = valueOrDefault(loc.lng, loc[1]),
	                lat = valueOrDefault(loc.lat, loc[0]);

	            nw.lng = min(nw.lng, lng);
	            nw.lat = max(nw.lat, lat);

	            se.lng = max(se.lng, lng);
	            se.lat = min(se.lat, lat);
	        },

	        includeAll: function(locs) {
	            for (var i = 0; i < locs.length; i++) {
	                this.include(locs[i]);
	            }
	        },

	        edges: function() {
	            var nw = this.nw,
	                se = this.se;

	            return {nw: this.nw, ne: new Location(nw.lat, se.lng),
	                    se: this.se, sw: new Location(se.lat, nw.lng)};
	        },

	        toArray: function() {
	            var nw = this.nw,
	                se = this.se;

	            return [nw, new Location(nw.lat, se.lng),
	                    se, new Location(se.lat, nw.lng)];
	        },

	        overlaps: function(extent) {
	            return this.containsAny(extent.toArray()) ||
	                   extent.containsAny(this.toArray());
	        }
	    });

	    Extent.World = new Extent([90, -180], [-90, 180]);

	    Extent.create = function(a, b) {
	        if (a instanceof Extent) {
	            return a;
	        } else if (a && b) {
	            return new Extent(a, b);
	        } else if (a && a.length === 4 && !b) {
	            return new Extent([a[0], a[1]], [a[2], a[3]]);
	        }
	    };

	    // Exports ================================================================
	    deepExtend(dataviz, {
	        map: {
	            Extent: Extent,
	            Location: Location
	        }
	    });

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 928:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Iu+f");

/***/ })

/******/ });

/***/ }),

/***/ "pVp3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var ColDefUtil = (function () {
    function ColDefUtil() {
    }
    ColDefUtil.STRING_PROPERTIES = [
        'headerName',
        'columnGroupShow',
        'headerClass',
        'toolPanelClass',
        'headerValueGetter',
        'pivotKeys',
        'groupId',
        'colId',
        'sort',
        'field',
        'type',
        'tooltipField',
        'headerTooltip',
        'cellClass',
        'showRowGroup',
        'template',
        'templateUrl',
        'filter',
        'aggFunc',
        'cellEditor',
        'pinned'
    ];
    ColDefUtil.OBJECT_PROPERTIES = [
        'headerGroupComponent',
        'headerGroupComponentFramework',
        'headerGroupComponentParams',
        'cellStyle',
        'cellRendererParams',
        'cellEditorFramework',
        'cellEditorParams',
        'pinnedRowCellRendererFramework',
        'pinnedRowCellRendererParams',
        'filterFramework',
        'filterParams',
        'pivotValueColumn',
        'headerComponent',
        'headerComponentFramework',
        'headerComponentParams',
        'floatingFilterComponent',
        'floatingFilterComponentParams',
        'floatingFilterComponentFramework',
        'refData'
    ];
    ColDefUtil.ARRAY_PROPERTIES = [
        'children',
        'sortingOrder',
        'allowedAggFuncs',
        'menuTabs',
        'pivotTotalColumnIds',
        'cellClassRules',
        'icons'
    ];
    ColDefUtil.NUMBER_PROPERTIES = [
        'sortedAt',
        'width',
        'minWidth',
        'maxWidth',
        'rowGroupIndex',
        'pivotIndex'
    ];
    ColDefUtil.BOOLEAN_PROPERTIES = [
        'suppressToolPanel',
        'openByDefault',
        'marryChildren',
        'hide',
        'rowGroup',
        'pivot',
        'checkboxSelection',
        'headerCheckboxSelection',
        'headerCheckboxSelectionFilteredOnly',
        'suppressMenu',
        'suppressSorting',
        'suppressMovable',
        'suppressFilter',
        'lockPosition',
        'lockVisible',
        'lockPinned',
        'unSortIcon',
        'suppressSizeToFit',
        'suppressResize',
        'suppressAutoSize',
        'enableRowGroup',
        'enablePivot',
        'enableValue',
        'editable',
        'suppressPaste',
        'suppressNavigable',
        'enableCellChangeFlash',
        'rowDrag'
    ];
    ColDefUtil.FUNCTION_PROPERTIES = [
        'valueGetter',
        'valueSetter',
        'keyCreator',
        'cellRendererFramework',
        'pinnedRowCellRenderer',
        'valueFormatter',
        'pinnedRowValueFormatter',
        'valueParser',
        'comparator',
        'equals',
        'pivotComparator',
        'suppressKeyboardEvent',
        'colSpan',
        'getQuickFilterText',
        'newValueHandler',
        'onCellValueChanged',
        'onCellClicked',
        'onCellDoubleClicked',
        'onCellContextMenu',
        'tooltip'
    ];
    ColDefUtil.ALL_PROPERTIES = ColDefUtil.ARRAY_PROPERTIES
        .concat(ColDefUtil.OBJECT_PROPERTIES)
        .concat(ColDefUtil.STRING_PROPERTIES)
        .concat(ColDefUtil.NUMBER_PROPERTIES)
        .concat(ColDefUtil.FUNCTION_PROPERTIES)
        .concat(ColDefUtil.BOOLEAN_PROPERTIES);
    return ColDefUtil;
}());
exports.ColDefUtil = ColDefUtil;


/***/ }),

/***/ "pYWG":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1076);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1075:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("BHwR");

/***/ }),

/***/ 1076:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1075) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "buttongroup",
	    name: "ButtonGroup",
	    category: "web",
	    description: "The Kendo ButtonGroup widget is a linear set of grouped buttons.",
	    depends: [ "core", "badge" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo;
	    var ui = kendo.ui;
	    var Widget = ui.Widget;
	    var keys = kendo.keys;
	    var proxy = $.proxy;
	    var template = kendo.template;
	    var NS = ".kendoButtonGroup";
	    var KWIDGET = "k-widget";
	    var KBUTTONGROUP = "k-button-group";
	    var KBUTTON = "k-button";
	    var KBUTTONICONTEXT = "k-button-icontext";
	    var KBUTTONICON = "k-button-icon";
	    var ACTIVE = "k-state-active";
	    var DISABLED = "k-state-disabled";
	    var SELECT = "select";
	    var CLICK = "click";
	    var KEYDOWN = "keydown";
	    var FOCUS = "focus";
	    var FOCUSOUT = "focusout";
	    var MOUSEDOWN = "mousedown";
	    var isIE = kendo.support.browser.msie;
	    var templates = {
	        item: template('<span ' +
	                        '#= item.enabled === false ? \"disabled\" : "" # ' +
	                        '>' +
	                        '#= icon(iconClass) #' +
	                        '#= image(item) #' +
	                        '#= text #' +
	                        '</span>'),
	        image: template('<img alt="icon" src="#=data.imageUrl#" />'),
	        icon: template('<span class="#=data#"></span>'),
	        empty: template("")
	    };

	    function createBadge(badgeOptions, item) {
	        var badgeEelement;

	        if (badgeOptions === null || badgeOptions === undefined) {
	            return;
	        }

	        if (badgeOptions.constructor !== Object) {
	            badgeOptions = { text: badgeOptions };
	        }

	        if (badgeOptions.position === undefined || badgeOptions.position === "") {
	            badgeOptions.position = "edge";

	            if (badgeOptions.align === undefined || badgeOptions.align === "") {
	                badgeOptions.align = "top end";
	            }
	        }

	        badgeOptions._classNames = ["k-button-badge"];

	        item.addClass("k-badge-container");

	        badgeEelement = $('<span />').appendTo(item);
	        item.badge = new ui.Badge(badgeEelement, badgeOptions);
	    }

	    var ButtonGroup = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            that.wrapper = that.element;

	            if (that.options.items) {
	                that._renderItems(that.options.items);
	            }

	            that.selectedIndices = [];

	            that.element
	                .addClass(KWIDGET + " " + KBUTTONGROUP)
	                .attr("role", "group")
	                .attr("tabindex", that.element.attr("tabindex") || "0")
	                .children().each(function () {
	                    var item = $(this);
	                    that._updateClasses.bind(that)(item);
	                });

	            that._enable = true;

	            if (!that.options.enable || !that.options.enabled) {
	                that._enable = false;
	                that.element
	                        .attr("aria-disabled", true)
	                        .addClass(DISABLED);
	            }

	            that.select(that.options.index);

	            that._attachEvents();
	        },

	        events: [
	            SELECT
	        ],

	        options: {
	            name: "ButtonGroup",
	            selection: "single",
	            index: -1,
	            enable: true,
	            enabled: true
	        },

	        current: function() {
	            return this.element.find("." + ACTIVE);
	        },

	        _attachEvents: function() {
	            var that = this;

	            that.element
	                .on(CLICK + NS, "." + KBUTTON, proxy(that._click, that))
	                .on(FOCUS + NS, proxy(that._focus, that))
	                .on(FOCUSOUT + NS, proxy(that._focusout, that))
	                .on(KEYDOWN + NS, proxy(that._keyDown, that))
	                .on(MOUSEDOWN + NS, proxy(that._mouseDown, that));
	        },

	        _renderItems: function (items) {
	            var that = this;

	            items.forEach(function (item) {
	                var renderedItem = $(templates.item({
	                    image: item.imageUrl ? templates.image : templates.empty,
	                    icon: !item.imageUrl && (item.iconClass || item.icon) ? templates.icon : templates.empty,
	                    iconClass: item.iconClass || "k-icon k-i-" + item.icon,
	                    item: item,
	                    text: item.text ? item.encoded === false ? item.text : kendo.htmlEncode(item.text) : ""
	                }));

	                if (item.attributes) {
	                    renderedItem.attr(item.attributes);
	                }

	                if (item.selected) {
	                    renderedItem.addClass(ACTIVE);
	                }

	                if (item.iconClass || item.icon || item.imageUrl) {
	                    renderedItem.addClass(item.text ? "k-button-icontext" : "k-button-icon");
	                }

	                if (item.badge) {
	                    createBadge(item.badge, renderedItem);
	                }

	                renderedItem.appendTo(that.element);
	            });
	        },

	        _mouseDown: function (e) {
	            var x = e.clientX,
	                y = e.clientY,
	                elementMouseIsOver = document.elementFromPoint(x, y);
	            // Prevent programmatic focusing when clicking enabled button
	            if (elementMouseIsOver !== this.element[0]) {
	                this.preventFocus = true;
	                this.preventFocusOut = true;
	            }
	            // Manually trigger focus in IE
	            if(isIE) {
	                this._focus();
	            }
	        },

	        _focus: function () {
	            var element = $(this.element);

	            element.removeAttr("tabindex");
	            element.find("[role='button']").attr("tabindex", "0");

	            if (this.preventFocus) {
	                this.preventFocus = false;
	                return;
	            }

	            if (element.find("." + ACTIVE).length) {
	                element.find("." + ACTIVE).first().focus();
	            } else {
	                element.children().first().focus();
	            }
	        },

	        _focusout: function() {
	            var that = this;
	            var wrapper = that.wrapper;

	            if(this.preventFocusOut) {
	                this.preventFocusOut = false;
	                return;
	            }

	            setTimeout(function() {
	                if(!wrapper[0].contains(document.activeElement)) {
	                    wrapper.attr("tabindex", "0");
	                    wrapper.find("[role='button']").removeAttr("tabindex");
	                }
	            });
	        },

	        _keyDown: function (e) {
	            var that = this;
	            var buttonGroup = $(that.element);
	            var focusableItems = buttonGroup.find("." + KBUTTON);
	            var focusedElement = buttonGroup.find(":focus");
	            var currentIndex = focusableItems.index(focusedElement);
	            var isRtl =  kendo.support.isRtl(that.element);
	            var itemToFocus;

	            if ((e.keyCode === keys.LEFT && !isRtl) || (e.keyCode === keys.RIGHT && isRtl)) {
	                itemToFocus = currentIndex === 0 ? focusableItems.eq(focusableItems.length - 1) : $(focusableItems[currentIndex - 1]);
	                itemToFocus.focus();
	                e.preventDefault();
	            } else if ((e.keyCode === keys.LEFT && isRtl) || (e.keyCode === keys.RIGHT && !isRtl)) {
	                itemToFocus = currentIndex + 1 === focusableItems.length ? focusableItems.eq(0) : $(focusableItems[currentIndex + 1]);
	                itemToFocus.focus();
	                e.preventDefault();
	            } else if (e.keyCode === keys.ENTER || e.keyCode === keys.SPACEBAR) {
	                that._select(focusedElement);
	                e.preventDefault();
	            }
	        },

	        select: function (button) {
	            var that = this,
	                ariaPressed,
	                index = -1;

	            if (button === undefined || button === -1) {
	                return;
	            }

	            if (typeof button === "number") {
	                index = button;
	                button = that.element.children().eq(button);
	            } else if (button.nodeType) {
	                button = $(button);
	                index = button.index();
	            }

	            if (that.options.selection === "multiple") {
	                ariaPressed = button.attr("aria-pressed") === "true";
	                button
	                    .attr("aria-pressed", !ariaPressed)
	                    .toggleClass(ACTIVE);

	                if (that.selectedIndices.indexOf(index) === -1) {
	                    that.selectedIndices.push(index);
	                } else {
	                    that.selectedIndices.splice(that.selectedIndices.indexOf(index), 1);
	                }

	            } else {
	                that.selectedIndices = [];
	                that.current()
	                        .attr("aria-pressed", false)
	                        .removeClass(ACTIVE);

	                button
	                    .attr("aria-pressed", true)
	                    .addClass(ACTIVE);

	                that.selectedIndices.push(index);
	            }
	        },

	        badge: function(item, value) {
	            var buttongroup = this.element;
	            var button = !isNaN(item) ? buttongroup.children().eq(item) : buttongroup.find(item);
	            var validValue = value || value === 0;
	            var badge;

	            if (!button.length) {
	                return;
	            }

	            badge = button.children(".k-badge").eq(0).data('kendoBadge');
	            if (!badge && validValue) {
	                createBadge({ text: kendo.htmlEncode(value)}, button);
	                return kendo.htmlEncode(value);
	            }

	            if (validValue) {
	                badge.text(kendo.htmlEncode(value));
	            } else if (value === false) {
	                badge.element.empty().remove();
	                badge.destroy();
	                return;
	            }

	            return badge ? badge.text() : null;
	        },

	        enable: function(enable) {
	            if(typeof enable == "undefined") {
	                enable = true;
	            }

	            this.element
	                    .attr("aria-disabled", !enable)
	                    .toggleClass(DISABLED, !enable);

	            this._enable = this.options.enable = enable;
	        },

	        destroy: function() {
	            var that = this;

	            that.element.off(NS);
	            that.element.find('.k-badge').each(function(){
	                $(this).data('kendoBadge').destroy();
	            });

	            Widget.fn.destroy.call(that);
	        },

	        _updateClasses: function(button) {
	            var icon = kendo.attrValue(button, "icon");
	            var badge = kendo.attrValue(button, "badge");
	            var image = button.find("img").addClass("k-image");
	            var isEmpty = true;

	            button
	                .attr("aria-pressed", false)
	                .attr("role", "button")
	                .addClass(KBUTTON);

	            if (button.is("[disabled]") || button.hasClass(DISABLED)) {
	                button
	                    .addClass(DISABLED)
	                    .attr("aria-disabled", true)
	                    .removeAttr("disabled");
	            }

	            if (button.is("." + ACTIVE)) {
	                button.removeClass(ACTIVE);
	                if ((!button.hasClass(DISABLED) && this.options.selection === "single") ||
	                    this.options.selection === "multiple") {
	                    this.select(button[0]);
	                }
	            }

	            if (!image[0] && icon) {
	                button.prepend($(templates.icon("k-icon k-i-" + icon)));
	            }

	            button
	                .contents()
	                .filter(function() {
	                    return !$(this).hasClass("k-icon") && !$(this).hasClass("k-image");
	                }).each(function(){
	                    if (this.nodeType == 1 || this.nodeType == 3 && kendo.trim(this.nodeValue).length > 0) {
	                        isEmpty = false;
	                    }
	                });

	            if (image[0] || icon) {
	                button.addClass(isEmpty ? KBUTTONICON : KBUTTONICONTEXT);
	            }

	            if (badge || badge === 0) {
	                createBadge(badge, button);
	            }
	        },

	        _click: function(e) {
	            var target = $(e.target).closest("." + KBUTTON);

	            if (e.isDefaultPrevented()) {
	                return;
	            }

	            e.target.focus();

	            this._select(target);
	        },

	        _select: function (target) {
	            var button = target;

	            if (!this._enable || button.is("." + DISABLED)) {
	                return;
	            }

	            this.select(target[0]);
	            this.trigger(SELECT, { indices: this.selectedIndices});
	        }
	    });

	    ui.plugin(ButtonGroup);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "pfAC":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1326);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1326:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1086) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.shim",
	    name: "Shim",
	    category: "mobile",
	    description: "Mobile Shim",
	    depends: [ "popup" ],
	    hidden: true
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.mobile.ui,
	        Popup = kendo.ui.Popup,
	        SHIM = '<div class="km-shim"></div>',
	        HIDE = "hide",
	        Widget = ui.Widget;

	    var Shim = Widget.extend({
	        init: function(element, options) {
	            var that = this,
	                app = kendo.mobile.application,
	                os = kendo.support.mobileOS,
	                osname = app ? app.os.name : (os ? os.name : "ios"),
	                ioswp = osname === "ios" || osname === "wp" || (app ? app.os.skin : false),
	                bb = osname === "blackberry",
	                align = options.align || (ioswp ?  "bottom center" : bb ? "center right" : "center center"),
	                position = options.position || (ioswp ? "bottom center" : bb ? "center right" : "center center"),
	                effect = options.effect || (ioswp ? "slideIn:up" : bb ? "slideIn:left" : "fade:in"),
	                shim = $(SHIM).handler(that).hide();

	            Widget.fn.init.call(that, element, options);

	            that.shim = shim;
	            element = that.element;
	            options = that.options;

	            if (options.className) {
	                that.shim.addClass(options.className);
	            }

	            if (!options.modal) {
	                that.shim.on("down", "_hide");
	            }

	            (app ? app.element : $(document.body)).append(shim);

	            that.popup = new Popup(that.element, {
	                anchor: shim,
	                modal: true,
	                appendTo: shim,
	                origin: align,
	                position: position,
	                animation: {
	                    open: {
	                        effects: effect,
	                        duration: options.duration
	                    },
	                    close: {
	                        duration: options.duration
	                    }
	                },

	                close: function(e) {
	                    var prevented = false;

	                    if (!that._apiCall) {
	                        prevented = that.trigger(HIDE);
	                    }

	                    if (prevented) {
	                        e.preventDefault();
	                    }

	                    that._apiCall = false;
	                },

	                deactivate: function() { // Deactivate event can't be prevented.
	                    shim.hide();
	                },

	                open: function() {
	                    shim.show();
	                }
	            });

	            kendo.notify(that);
	        },

	        events: [ HIDE ],

	        options: {
	            name: "Shim",
	            modal: false,
	            align: undefined,
	            position: undefined,
	            effect: undefined,
	            duration: 200
	        },

	        show: function() {
	            this.popup.open();
	        },

	        hide: function() {
	            this._apiCall = true;
	            this.popup.close();
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            this.shim.kendoDestroy();
	            this.popup.destroy();
	            this.shim.remove();
	        },

	        _hide: function(e) {
	            if (!e || !$.contains(this.shim.children().children(".k-popup")[0], e.target)) {
	                this.popup.close();
	            }
	        }
	    });

	    ui.plugin(Shim);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "piWI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__("ZZFX");
var utils_1 = __webpack_require__("IRr6");
var gridCell_1 = __webpack_require__("hie4");
var GridRow = (function () {
    function GridRow(rowIndex, floating) {
        this.rowIndex = rowIndex;
        this.floating = utils_1.Utils.makeNull(floating);
    }
    GridRow.prototype.isFloatingTop = function () {
        return this.floating === constants_1.Constants.PINNED_TOP;
    };
    GridRow.prototype.isFloatingBottom = function () {
        return this.floating === constants_1.Constants.PINNED_BOTTOM;
    };
    GridRow.prototype.isNotFloating = function () {
        return !this.isFloatingBottom() && !this.isFloatingTop();
    };
    GridRow.prototype.equals = function (otherSelection) {
        return this.rowIndex === otherSelection.rowIndex
            && this.floating === otherSelection.floating;
    };
    GridRow.prototype.toString = function () {
        return "rowIndex = " + this.rowIndex + ", floating = " + this.floating;
    };
    GridRow.prototype.getGridCell = function (column) {
        var gridCellDef = { rowIndex: this.rowIndex, floating: this.floating, column: column };
        return new gridCell_1.GridCell(gridCellDef);
    };
    // tests if this row selection is before the other row selection
    GridRow.prototype.before = function (otherSelection) {
        var otherFloating = otherSelection.floating;
        switch (this.floating) {
            case constants_1.Constants.PINNED_TOP:
                // we we are floating top, and other isn't, then we are always before
                if (otherFloating !== constants_1.Constants.PINNED_TOP) {
                    return true;
                }
                break;
            case constants_1.Constants.PINNED_BOTTOM:
                // if we are floating bottom, and the other isn't, then we are never before
                if (otherFloating !== constants_1.Constants.PINNED_BOTTOM) {
                    return false;
                }
                break;
            default:
                // if we are not floating, but the other one is floating...
                if (utils_1.Utils.exists(otherFloating)) {
                    if (otherFloating === constants_1.Constants.PINNED_TOP) {
                        // we are not floating, other is floating top, we are first
                        return false;
                    }
                    else {
                        // we are not floating, other is floating bottom, we are always first
                        return true;
                    }
                }
                break;
        }
        return this.rowIndex < otherSelection.rowIndex;
    };
    return GridRow;
}());
exports.GridRow = GridRow;


/***/ }),

/***/ "pjl4":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1019);
	module.exports = __webpack_require__(1019);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 964:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("6GKO");

/***/ }),

/***/ 1019:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(964) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($,undefined) {
	    var kendo = window.kendo;
	    var ui = kendo.ui;
	    var editorNS = ui.editor;
	    var Widget = ui.Widget;
	    var extend = $.extend;
	    var proxy = $.proxy;
	    var keys = kendo.keys;
	    var NS = ".kendoEditor";
	    var EditorUtils = editorNS.EditorUtils;
	    var ToolTemplate = editorNS.ToolTemplate;
	    var Tool = editorNS.Tool;
	    var outerWidth = kendo._outerWidth;
	    var outerHeight = kendo._outerHeight;
	    var OVERFLOWANCHOR = "overflowAnchor";

	    var focusable = ".k-tool-group:visible .k-tool:not(.k-state-disabled)," +
	                    ".k-tool.k-overflow-anchor:visible," +
	                    ".k-tool-group:visible .k-colorpicker:not(input)," +
	                    ".k-tool-group:visible .k-selectbox," +
	                    ".k-tool-group:visible .k-dropdown," +
	                    ".k-tool-group:visible .k-combobox .k-input";

	    var toolNamesByCssClass = {
	        "k-i-sup-script": "superscript",
	        "k-i-sub-script": "subscript",
	        "k-i-align-left": "justifyLeft",
	        "k-i-align-center": "justifyCenter",
	        "k-i-align-right": "justifyRight",
	        "k-i-align-justify": "justifyFull",
	        "k-i-list-unordered": "insertUnorderedList",
	        "k-i-list-ordered": "insertOrderedList",
	        "k-i-login": "import",
	        "k-i-indent-increase": "indent",
	        "k-i-indent-decrease": "outdent",
	        "k-i-link-horizontal": "createLink",
	        "k-i-unlink-horizontal": "unlink",
	        "k-i-image": "insertImage",
	        "k-i-file-add": "insertFile",
	        "k-i-html": "viewHtml",
	        "k-i-foreground-color": "foreColor",
	        "k-i-paint": "backColor",
	        "k-i-table-insert": "createTable",
	        "k-i-table-column-insert-left": "addColumnLeft",
	        "k-i-table-column-insert-right": "addColumnRight",
	        "k-i-table-row-insert-above": "addRowAbove",
	        "k-i-table-row-insert-below": "addRowBelow",
	        "k-i-table-row-delete": "deleteRow",
	        "k-i-table-column-delete": "deleteColumn",
	        "k-i-table-properties": "tableWizard",
	        "k-i-table-wizard": "tableWizardInsert",
	        "k-i-clear-css": "cleanFormatting",
	        "k-i-cells-merge-horizontally": "mergeCellsHorizontally",
	        "k-i-cells-merge-vertically": "mergeCellsVertically",
	        "k-i-cell-split-horizontally": "splitCellHorizontally",
	        "k-i-cell-split-vertically": "splitCellVertically",
	        "k-i-copy-format": "copyFormat",
	        "k-i-apply-format": "applyFormat"
	    };

	    var OverflowAnchorTool = Tool.extend({
	        initialize: function(ui, options) {
	            var toolbar = options.editor.toolbar;

	            ui.attr("aria-controls", options.editor.element.attr("id"))
	                .on("click", $.proxy(function() {
	                    this.overflowPopup.toggle();
	                }, toolbar));
	        },

	        options: {
	            name: OVERFLOWANCHOR
	        },

	        command: $.noop,
	        update: $.noop,
	        destroy: $.noop

	    });

	    EditorUtils.registerTool(OVERFLOWANCHOR, new OverflowAnchorTool({
	        key: "",
	        ctrl: true,
	        template: new ToolTemplate({ template: EditorUtils.overflowAnchorTemplate })
	    }));

	    var Toolbar = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            options = extend({}, options, { name: "EditorToolbar" });

	            Widget.fn.init.call(that, element, options);

	            if (options.popup) {
	                that._initPopup();
	            }

	            if (options.resizable && options.resizable.toolbar) {
	                that._resizeHandler = kendo.onResize(function() {
	                    that.resize(true);
	                });

	                that.element.addClass("k-toolbar-resizable");
	            }
	        },

	        events: [
	            "execute"
	        ],

	        groups: {
	            basic: ["bold", "italic", "underline", "strikethrough"],
	            scripts: ["subscript", "superscript" ],
	            alignment: ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull" ],
	            links: ["insertImage", "insertFile", "createLink", "unlink"],
	            lists: ["insertUnorderedList", "insertOrderedList", "indent", "outdent"],
	            tablesInsert: ["createTable"],
	            tablesAddDelete: [ "addColumnLeft", "addColumnRight", "addRowAbove", "addRowBelow", "deleteRow", "deleteColumn" ],
	            tablesMerge: [ "mergeCellsHorizontally", "mergeCellsVertically", "splitCellHorizontally", "splitCellVertically" ],
	            advanced: [ "viewHtml", "cleanFormatting", "print", "pdf", "exportAs", "import"],
	            fonts: [ "fontName", "fontSize" ],
	            colors: [ "foreColor", "backColor" ],
	            formatPainter: [ "copyFormat", "applyFormat" ]
	        },

	        overflowFlaseTools: [ "formatting", "fontName", "fontSize", "foreColor", "backColor", "insertHtml" ],

	        _initPopup: function() {
	            var that = this;
	            this.window = $(this.element)
	                .wrap("<div class='editorToolbarWindow' />")
	                .parent()
	                .prepend("<span class='k-editortoolbar-dragHandle'><span class='k-icon k-i-handler-drag'></span></span>")
	                .kendoWindow({
	                    title: false,
	                    resizable: false,
	                    draggable: {
	                        dragHandle: ".k-editortoolbar-dragHandle"
	                    },
	                    animation: {
	                        open: { effects: "fade:in" },
	                        close: { effects: "fade:out" }
	                    },
	                    minHeight: 42,
	                    visible: false,
	                    autoFocus: false,
	                    actions: [],
	                    dragend: function() {
	                        this._moved = true;
	                    }
	                })
	                .on("mousedown", function(e){
	                    if (!$(e.target).is(".k-icon")) {
	                        that.preventPopupHide = true;
	                    }
	                })
	                .on("focusout", function(){
	                    that.options.editor.element.focusout();
	                })
	                .data("kendoWindow");
	        },

	        _toggleOverflowStyles: function(element, show) {
	            element
	                .find("> li").toggleClass("k-item", show)
	                .find(".k-tool:not(.k-state-disabled), .k-overflow-button").toggleClass("k-overflow-button", show);
	        },

	        _initOverflowPopup: function(ui) {
	            var that = this;
	            var popupTemplate = "<ul class='k-editor-overflow-popup k-overflow-container k-list-container'></ul>";

	            that.overflowPopup = $(popupTemplate).appendTo("body").kendoPopup({
	                anchor: ui,
	                origin: kendo.support.isRtl(that.element) ? "bottom left" : "bottom right",
	                position: kendo.support.isRtl(that.element) ? "top left" : "top right",
	                copyAnchorStyles: false,
	                open: function(e) {
	                    if (this.element.is(":empty")) {
	                        e.preventDefault();
	                    }

	                    that._toggleOverflowStyles(this.element, true);
	                    ui.attr("aria-expanded", true);
	                },
	                close: function() {
	                    ui.attr("aria-expanded", false);
	                },
	                activate: proxy(that.focusOverflowPopup, that)
	            }).data("kendoPopup");
	        },

	        items: function() {
	            var isResizable = this.options.resizable && this.options.resizable.toolbar,
	                popup, result;

	            result = this.element.children().find("> *, select");

	            if (isResizable) {
	                popup = this.overflowPopup;
	                result = result.add(popup.element.children().find("> *"));
	            }

	            return result;
	        },

	        focused: function() {
	            return this.element.find(".k-state-focused").length > 0 ||
	                    this.preventPopupHide ||
	                    (this.overflowPopup && this.overflowPopup.visible());
	        },

	        toolById: function(name) {
	            var id, tools = this.tools;

	            for (id in tools) {
	                if (id.toLowerCase() == name) {
	                    return tools[id];
	                }
	            }
	        },

	        toolGroupFor: function(toolName) {
	            var i, groups = this.groups;

	            if (this.isCustomTool(toolName)) {
	                return "custom";
	            }

	            for (i in groups) {
	                if ($.inArray(toolName, groups[i]) >= 0) {
	                    return i;
	                }
	            }
	        },

	        bindTo: function(editor) {
	            var that = this,
	                window = that.window;

	            // detach from editor that was previously listened to
	            if (that._editor) {
	                that._editor.unbind("select", proxy(that.resize, that));
	            }

	            that._editor = editor;

	            if (that.options.resizable && that.options.resizable.toolbar) {
	                editor.options.tools.push(OVERFLOWANCHOR);
	            }

	            // re-initialize the tools
	            that.tools = that.expandTools(editor.options.tools);
	            that.render();

	            that.element.find(".k-combobox .k-input").keydown(function(e) {
	                var combobox = $(this).closest(".k-combobox").data("kendoComboBox"),
	                    key = e.keyCode;

	                if (key == keys.RIGHT || key == keys.LEFT) {
	                    combobox.close();
	                } else if (key == keys.DOWN) {
	                    if (!combobox.dropDown.isOpened()) {
	                        e.stopImmediatePropagation();
	                        combobox.open();
	                    }
	                }
	            });

	            that._attachEvents();

	            that.items().each(function initializeTool() {

	                var toolName = that._toolName(this),
	                    tool = toolName !== "moreVertical" ? that.tools[toolName] : that.tools.overflowAnchor,
	                    options = tool && tool.options,
	                    messages = editor.options.messages,
	                    description = options && options.tooltip || messages[toolName],
	                    ui = $(this);

	                if (!tool || !tool.initialize) {
	                    return;
	                }

	                if (toolName == "fontSize" || toolName == "fontName") {
	                    var inheritText = messages[toolName + "Inherit"];

	                    ui.find("input").val(inheritText).end()
	                      .find("span.k-input").text(inheritText).end();
	                }

	                tool.initialize(ui, {
	                    title: that._appendShortcutSequence(description, tool),
	                    editor: that._editor
	                });

	                ui.closest(".k-widget", that.element).addClass("k-editor-widget");

	                ui.closest(".k-colorpicker", that.element).next(".k-colorpicker").addClass("k-editor-widget");
	            });

	            editor.bind("select", proxy(that.resize, that));

	            that.update();

	            if (window) {
	                window.wrapper.css({top: "", left: "", width: ""});
	            }
	        },

	        show: function() {
	            var that = this,
	                window = that.window,
	                editorOptions = that.options.editor,
	                wrapper, editorElement, editorOffset,
	                browser = kendo.support.browser;

	            if (window) {
	                wrapper = window.wrapper;
	                editorElement = editorOptions.element;

	                if (!wrapper.is(":visible") || !that.window.options.visible) {

	                    if (!wrapper[0].style.width) {
	                        wrapper.width(this._getWindowWidth());
	                    }

	                    // track content position when other parts of page change
	                    if (!window._moved) {
	                        editorOffset = editorElement.offset();
	                        wrapper.css({
	                            top: Math.max(0, parseInt(editorOffset.top, 10) - outerHeight(wrapper) - parseInt(that.window.element.css("padding-bottom"), 10)),
	                            left: Math.max(0, parseInt(editorOffset.left, 10))
	                        });
	                    }

	                    if ((browser.msie || browser.edge) && that._overlaps(editorElement)) {
	                        setTimeout(function() {
	                            window.open();
	                        }, 0);
	                    } else {
	                        window.open();
	                    }
	                }
	            }
	        },

	        _getWindowWidth: function(){
	            var that = this,
	                wrapper = that.window.wrapper,
	                editorElement = that.options.editor.element;

	            return outerWidth(editorElement) - parseInt(wrapper.css("border-left-width"), 10) - parseInt(wrapper.css("border-right-width"), 10);
	        },

	        _overlaps: function(box) {
	            var toolbarWrapper = this.window.wrapper,
	                toolbarWrapperOffset = toolbarWrapper.offset(),
	                toolbarWrapperLeft = toolbarWrapperOffset.left,
	                toolbarWrapperTop = toolbarWrapperOffset.top,
	                boxOffset = box.offset(),
	                boxOffsetLeft = boxOffset.left,
	                boxOffsetTop = boxOffset.top;

	            return !(boxOffsetLeft + box.width() < toolbarWrapperLeft ||
	                    boxOffsetLeft > toolbarWrapperLeft + toolbarWrapper.width() ||
	                    boxOffsetTop + box.height() < toolbarWrapperTop ||
	                    boxOffsetTop > toolbarWrapperTop + toolbarWrapper.height());
	        },

	        hide: function() {
	            if (this.window) {
	                this.window.close();
	            }
	        },

	        focus: function() {
	            var TABINDEX = "tabIndex";
	            var element = this.element;
	            var tabIndex = this._editor.element.attr(TABINDEX);

	            // Chrome can't focus something which has already been focused
	            element.attr(TABINDEX, tabIndex || 0).focus()
	                .find(focusable).first().focus();

	            if (!tabIndex && tabIndex !== 0) {
	                element.removeAttr(TABINDEX);
	            }
	        },

	        focusOverflowPopup: function() {
	            var TABINDEX = "tabIndex";
	            var element = this.overflowPopup.element;
	            var tabIndex = this._editor.element.attr(TABINDEX);

	            element.closest(".k-animation-container").addClass("k-overflow-wrapper");

	            element.attr(TABINDEX, tabIndex || 0)
	                .find(focusable).first().focus();

	            if (!tabIndex && tabIndex !== 0) {
	                element.removeAttr(TABINDEX);
	            }
	        },

	        _appendShortcutSequence: function(localizedText, tool) {
	            if (!tool.key) {
	                return localizedText;
	            }

	            var res = localizedText + " (";

	            if (tool.ctrl) {
	                res += "Ctrl + ";
	            }

	            if (tool.shift) {
	                res += "Shift + ";
	            }

	            if (tool.alt) {
	                res += "Alt + ";
	            }

	            res += tool.key + ")";

	            return res;
	        },

	        _nativeTools: [
	            "insertLineBreak",
	            "insertParagraph",
	            "redo",
	            "undo",
	            "autoLink"
	        ],

	        tools: {}, // tools collection is copied from defaultTools during initialization

	        isCustomTool: function(toolName) {
	            return !(toolName in kendo.ui.Editor.defaultTools);
	        },

	        // expand the tools parameter to contain tool options objects
	        expandTools: function(tools) {
	            var currentTool,
	                i,
	                nativeTools = this._nativeTools,
	                options,
	                defaultTools = kendo.deepExtend({}, kendo.ui.Editor.defaultTools),
	                result = {},
	                name;

	            for (i = 0; i < tools.length; i++) {
	                currentTool = tools[i];
	                name = currentTool.name;

	                if ($.isPlainObject(currentTool)) {
	                    if (name && defaultTools[name]) {
	                        // configured tool
	                        result[name] = extend({}, defaultTools[name]);
	                        extend(result[name].options, currentTool);
	                    } else {
	                        // custom tool
	                        options = extend({ cssClass: "k-i-gear", type: "button", title: "" }, currentTool);
	                        if (!options.name) {
	                            options.name = "custom";
	                        }

	                        options.cssClass = "k-" + options.name;

	                        if (!options.template && options.type == "button") {
	                            options.template = editorNS.EditorUtils.buttonTemplate;
	                            options.title = options.title || options.tooltip;
	                        }

	                        result[name] = {
	                            options: options
	                        };
	                    }
	                } else if (defaultTools[currentTool]) {
	                    // tool by name
	                    result[currentTool] = defaultTools[currentTool];
	                }
	            }

	            for (i = 0; i < nativeTools.length; i++) {
	                if (!result[nativeTools[i]]) {
	                    result[nativeTools[i]] = defaultTools[nativeTools[i]];
	                }
	            }

	            return result;
	        },

	        render: function() {
	            var that = this,
	                tools = that.tools,
	                options, template, toolElement,
	                toolName,
	                editorElement = that._editor.element,
	                element = that.element.empty(),
	                groupName, newGroupName,
	                toolConfig = that._editor.options.tools,
	                browser = kendo.support.browser,
	                group, i, groupPosition = 0,
	                resizable = that.options.resizable && that.options.resizable.toolbar,
	                overflowFlaseTools = this.overflowFlaseTools;

	            function stringify(template) {
	                var result = "";

	                if (template.getHtml) {
	                    result = template.getHtml();
	                } else {
	                    if (!$.isFunction(template)) {
	                        template = kendo.template(template);
	                    }

	                    result = template(options);
	                }

	                return kendo.trim(result);
	            }

	            function endGroup() {
	                if (group.children().length) {
	                    if (resizable) {
	                        group.data("position", groupPosition);
	                        groupPosition++;
	                    }

	                    group.appendTo(element);
	                }
	            }

	            function startGroup(toolName) {
	                if (toolName !== OVERFLOWANCHOR) {
	                    group = $("<li class='k-tool-group' role='presentation' />");
	                    group.data("overflow", $.inArray(toolName, overflowFlaseTools) === -1 ? true : false);
	                } else {
	                    group = $("<li class='k-overflow-tools' />");
	                }
	            }

	            element.empty();

	            if (toolConfig.length) {
	                toolName = toolConfig[0].name || toolConfig[0];
	            }
	            startGroup(toolName, overflowFlaseTools);

	            for (i = 0; i < toolConfig.length; i++) {
	                toolName = toolConfig[i].name || toolConfig[i];
	                options = tools[toolName] && tools[toolName].options;

	                if (!options && $.isPlainObject(toolName)) {
	                    options = toolName;
	                }

	                template = options && options.template;

	                if (toolName == "break") {
	                    endGroup();
	                    $("<li class='k-row-break' />").appendTo(that.element);
	                    startGroup(toolName, overflowFlaseTools);
	                }

	                if (!template) {
	                    continue;
	                }

	                newGroupName = that.toolGroupFor(toolName);

	                if (groupName != newGroupName || toolName == OVERFLOWANCHOR) {
	                    endGroup();
	                    startGroup(toolName, overflowFlaseTools);
	                    groupName = newGroupName;
	                }

	                if (toolName == OVERFLOWANCHOR) {
	                    template.options.title = that.options.messages.overflowAnchor;
	                }

	                template = stringify(template);

	                toolElement = $(template).appendTo(group);

	                if (newGroupName == "custom") {
	                    endGroup();
	                    startGroup(toolName, overflowFlaseTools);
	                }

	                if (options.exec && toolElement.hasClass("k-tool")) {
	                    toolElement.click(proxy(options.exec, editorElement[0]));
	                }
	            }

	            endGroup();

	            $(that.element).children(":has(> .k-tool)").not(".k-overflow-tools").addClass("k-button-group");

	            if (that.options.popup && browser.msie && browser.version < 9) {
	                that.window.wrapper.find("*").attr("unselectable", "on");
	            }

	            that.updateGroups();

	            if (resizable) {
	                that._initOverflowPopup(that.element.find(".k-overflow-anchor"));
	            }

	            that.angular("compile", function(){
	                return { elements: that.element };
	            });
	        },

	        updateGroups: function() {
	            $(this.element).children().not(".k-overflow-tools").each(function() {
	                $(this).children()
	                    .removeClass("k-group-start k-group-end")
	                    .first().addClass("k-group-start").end()
	                    .last().addClass("k-group-end").end();
	            });
	        },

	        decorateFrom: function(body) {
	            this.items().filter(".k-decorated")
	                .each(function() {
	                    var selectBox = $(this).data("kendoSelectBox");

	                    if (selectBox) {
	                        selectBox.decorate(body);
	                    }
	                });
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            var id, tools = this.tools;

	            for (id in tools) {
	                if (tools[id].destroy) {
	                    tools[id].destroy();
	                }
	            }

	            if (this.window) {
	                this.window.destroy();
	            }

	            if (this._resizeHandler) {
	                kendo.unbindResize(this._resizeHandler);
	            }

	            if (this.overflowPopup) {
	                this.overflowPopup.destroy();
	            }
	        },

	        _attachEvents: function() {
	            var that = this,
	                popupElement = that.overflowPopup ? that.overflowPopup.element : $([]);

	            that.attachToolsEvents(that.element.add(popupElement));
	        },

	        attachToolsEvents: function(element) {
	            var that = this,
	                buttons = "[role=button].k-tool",
	                enabledButtons = buttons + ":not(.k-state-disabled)",
	                disabledButtons = buttons + ".k-state-disabled",
	                dropdown = ".k-dropdown",
	                colorpicker = ".k-colorpicker",
	                editorTools = [buttons, dropdown, colorpicker].join(",");

	            element.off(NS)
	                .on("mouseenter" + NS, enabledButtons, function() { $(this).addClass("k-state-hover"); })
	                .on("mouseleave" + NS, enabledButtons, function() { $(this).removeClass("k-state-hover"); })
	                .on("mousedown" + NS, editorTools, function(e) {
	                    e.preventDefault();
	                })
	                .on("keydown" + NS, focusable, function(e) {
	                    var current = this;
	                    var resizable = that.options.resizable && that.options.resizable.toolbar;
	                    var direction = kendo.support.isRtl(that.element) ? -1 : 1;
	                    var focusableItems;
	                    var focusElement,
	                        currentContainer,
	                        keyCode = e.keyCode;

	                    function move(direction, container, constrain) {
	                        var tools = container.find(focusable);
	                        var index = tools.index(current) + direction;

	                        if (constrain) {
	                            index = Math.max(0, Math.min(tools.length - 1, index));
	                        }

	                        return tools[index];
	                    }

	                    if (keyCode == keys.RIGHT || keyCode == keys.LEFT) {
	                        if (!$(current).is(".k-dropdown")) {
	                            focusElement = move(keyCode == keys.RIGHT ? 1 * direction : -1 * direction, that.element, true);
	                        } else {
	                            focusElement = $(current);
	                        }
	                    } else if (resizable && (keyCode == keys.UP || keyCode == keys.DOWN)) {
	                        focusElement = move(keyCode == keys.DOWN ? 1 : -1, that.overflowPopup.element, true);
	                    } else if (keyCode == keys.HOME) {
	                        focusElement = that.element.find(focusable)[0];
	                        e.preventDefault();
	                    } else if (keyCode == keys.END) {
	                        focusableItems = that.element.find(focusable).filter(function () {
	                            return $(this).css('visibility') !== 'hidden';
	                        });
	                        focusElement = focusableItems[focusableItems.length - 1];
	                        e.preventDefault();
	                    } else if (keyCode == keys.ESC) {
	                        if (that.overflowPopup && that.overflowPopup.visible()) {
	                            that.overflowPopup.close();
	                        }

	                        focusElement = that._editor;
	                    } else if (keyCode == keys.TAB && !(e.ctrlKey || e.altKey)) {
	                        if (resizable) {
	                            currentContainer = $(current.parentElement).hasClass("k-overflow-tool-group") ? that.overflowPopup.element : that.element;
	                        } else {
	                            currentContainer = that.element;
	                        }

	                        // skip tabbing to disabled tools, and focus the editing area when running out of tools
	                        if (e.shiftKey) {
	                            focusElement = move(-1, currentContainer);
	                        } else {
	                            focusElement = move(1, currentContainer);

	                            if (!focusElement || $(focusElement).closest(".k-overflow-tools").css("visibility") === "hidden") {
	                                focusElement = that._editor;
	                            }
	                        }
	                    }

	                    if (focusElement) {
	                        e.preventDefault();
	                        focusElement.focus();
	                    }

	                    if ((keyCode === keys.ENTER || keyCode === keys.SPACEBAR) && ( $(current).is("button") || $(current).is("a") ) && !$(current).attr("href") ) {
	                        //anchors without href attribute do not respond to Enter key
	                        that._executeToolCommand(current, e);
	                    }
	                })
	                .on("click" + NS, enabledButtons, function(e) {
	                    that._executeToolCommand(this, e);
	                })
	                .on("click" + NS, disabledButtons, function(e) { e.preventDefault(); });

	        },

	        _executeToolCommand: function(toolElement, e) {
	            var that = this;
	            var button = $(toolElement);
	            e.preventDefault();
	            e.stopPropagation();
	            button.removeClass("k-state-hover");
	            if (!button.is("[data-popup]")) {
	                that._editor.exec(that._toolName(toolElement));
	            }
	        },

	        _toolName: function (element) {
	            if (!element) {
	                return;
	            }

	            var className = element.className;

	            if (/k-tool\b/i.test(className)) {
	                className = element.firstChild.className;
	            }

	            var tool = $.grep(className.split(" "), function (x) {
	                return !/^k-(widget|tool|tool-icon|icon|state-hover|header|combobox|dropdown|selectbox|colorpicker)$/i.test(x);
	            });

	            if (tool[0]) {
	                var toolname = tool[0];
	                if (toolNamesByCssClass[toolname]) {
	                    toolname = toolNamesByCssClass[toolname];
	                }
	                if (toolname.indexOf("k-i-") >=0) {
	                    return kendo.toCamelCase(toolname.substring(toolname.indexOf("k-i-") + 4));
	                }
	                else {
	                    return toolname.substring(toolname.lastIndexOf("-") + 1);
	                }
	            }
	            return "custom";
	        },

	        refreshTools: function() {
	            var that = this,
	                editor = that._editor,
	                range = editor.getRange(),
	                nodes = editorNS.RangeUtils.textNodes(range),
	                immutables = editor.options.immutables,
	                immutablesContext = that._immutablesContext(range);

	            nodes = editorNS.Dom.filterBy(nodes, editorNS.Dom.htmlIndentSpace, true);

	            if (!nodes.length) {
	                nodes = [range.startContainer];
	            }

	            that.items().each(function() {
	                var tool = that.tools[that._toolName(this)];
	                if (tool) {
	                    var ui = $(this);
	                    if (tool.update) {
	                        tool.update(ui, nodes);
	                    }

	                    if (immutables) {
	                        that._updateImmutablesState(tool, ui, immutablesContext);
	                    }
	                }
	            });
	            this.update();
	        },

	        _immutablesContext: function(range) {
	            if (this._editor.options.immutables) {
	                if (range.collapsed) {
	                    return editorNS.Immutables.immutablesContext(range);
	                } else {
	                    return editorNS.RangeUtils.editableTextNodes(range).length === 0;
	                }
	            }
	        },

	        _updateImmutablesState: function(tool, ui, immutablesContext) {
	            var name = tool.name;
	            var uiElement = ui;

	            var trackImmutables = tool.options.trackImmutables;
	            if (trackImmutables === undefined) {
	                trackImmutables = $.inArray(name, editorNS.Immutables.toolsToBeUpdated) > -1;
	            }

	            if (trackImmutables) {
	                var display = immutablesContext ? "none" : "";
	                if (!ui.is(".k-tool")) {
	                    var uiData = ui.data();
	                    for (var key in uiData) {
	                        if (key.match(/^kendo[A-Z][a-zA-Z]*/)) {
	                            var widget = uiData[key];
	                            uiElement = widget.wrapper;
	                            break;
	                        }
	                    }
	                }
	                uiElement.css("display", display);
	                var groupUi = uiElement.closest("li");
	                if (groupUi.children(":visible").length === 0) {
	                    groupUi.css("display", display);
	                }
	            }
	        },

	        update: function() {
	            this.updateGroups();
	        },

	        _resize: function(e) {
	            var containerWidth = e.width;
	            var resizable = this.options.resizable && this.options.resizable.toolbar;
	            var popup = this.overflowPopup;
	            var editorElement = this.options.editor.element;
	            var toolbarWindow = this.window;

	            this.refreshTools();

	            if (!resizable) {
	                return;
	            }

	            if(toolbarWindow) {
	                toolbarWindow.wrapper.width(this._getWindowWidth());

	                if(!toolbarWindow._moved) {
	                    toolbarWindow.wrapper.css({
	                        left: Math.max(0, parseInt(editorElement.offset().left, 10))
	                    });
	                }
	            }

	            if (popup.visible()) {
	                popup.close(true);
	            }

	            this._refreshWidths();

	            this._shrink(containerWidth);
	            this._stretch(containerWidth);

	            this._toggleOverflowStyles(this.element, false);
	            this._toggleOverflowStyles(this.overflowPopup.element, true);

	            this.element
	                .children("li.k-overflow-tools")
	                .css("visibility", popup.element.is(":empty") ? "hidden" : "visible");
	        },

	        _refreshWidths: function() {
	            this.element.children("li").each(function(idx, element) {
	                var group = $(element);
	                group.data("outerWidth", outerWidth(group, true));
	            });
	        },

	        _shrink: function(width) {
	            var group, visibleGroups;

	            if (width < this._groupsWidth()) {
	                visibleGroups = this._visibleGroups().filter(":not(.k-overflow-tools)");

	                for (var i = visibleGroups.length - 1; i >= 0; i--) {
	                    group = visibleGroups.eq(i);
	                    if (width > this._groupsWidth()) {
	                        break;
	                    } else {
	                        this._hideGroup(group);
	                    }
	                }
	            }
	        },

	        _stretch: function(width) {
	            var group, hiddenGroups;

	            if (width > this._groupsWidth()) {
	                hiddenGroups = this._hiddenGroups();

	                for (var i = 0; i < hiddenGroups.length ; i++) {
	                    group = hiddenGroups.eq(i);
	                    if (width < this._groupsWidth() || !this._showGroup(group, width)) {
	                        break;
	                    }
	                }
	            }
	        },

	        _hiddenGroups: function() {
	            var popup = this.overflowPopup;

	            var hiddenGroups = this.element.children("li.k-tool-group").filter(":hidden");

	            hiddenGroups = hiddenGroups.add(popup.element.children("li"));

	            hiddenGroups.sort(function(a, b) {
	                return ($(a).data("position") > $(b).data("position")) ? 1 : -1;
	            });

	            return hiddenGroups;
	        },

	        _visibleGroups: function() {
	            return this.element.children("li.k-tool-group, li.k-overflow-tools").filter(":visible");
	        },

	        _groupsWidth: function() {
	            var width = 0;

	            this._visibleGroups().each(function() {
	                width += $(this).data("outerWidth");
	            });

	            return Math.ceil(width);
	        },

	        _hideGroup: function(group) {
	            if (group.data("overflow")) {
	                var popup = this.overflowPopup;
	                group.detach().prependTo(popup.element).addClass("k-overflow-tool-group");
	            } else {
	                group.addClass("k-hidden");
	            }
	        },

	        _showGroup: function(group, width) {
	            var position, previous, groupWidth;

	            if (group.hasClass('k-state-disabled')) {
	                return true;
	            }

	            if (group.hasClass("k-overflow-tool-group")) {
	                groupWidth = group.data("outerWidth");
	            } else {
	                group.removeClass("k-hidden");
	                groupWidth = outerWidth(group, true);
	                group.addClass("k-hidden");
	            }

	            if (group.length && width > this._groupsWidth() + groupWidth) {
	                if (group.hasClass("k-overflow-tool-group")) {
	                    position = group.data("position");

	                    if (position === 0) {
	                        group.detach().prependTo(this.element);
	                    } else {
	                        previous = this.element.children().filter(function(idx, element) {
	                            return $(element).data("position") === position - 1;
	                        });

	                        group.detach().insertAfter(previous);
	                    }

	                    group.removeClass("k-overflow-tool-group");

	                } else {
	                    group.removeClass("k-hidden");
	                }

	                return true;
	            }

	            return false;
	        }

	    });

	$.extend(editorNS, {
	    Toolbar: Toolbar
	});

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "pxG4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "q7rp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var context_1 = __webpack_require__("RQ1/");
var component_1 = __webpack_require__("pQ38");
var LoadingOverlayComponent = (function (_super) {
    __extends(LoadingOverlayComponent, _super);
    function LoadingOverlayComponent() {
        return _super.call(this) || this;
    }
    LoadingOverlayComponent.prototype.init = function (params) {
        var template = this.gridOptionsWrapper.getOverlayLoadingTemplate() ?
            this.gridOptionsWrapper.getOverlayLoadingTemplate() : LoadingOverlayComponent.DEFAULT_LOADING_OVERLAY_TEMPLATE;
        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
        var localisedTemplate = template.replace('[LOADING...]', localeTextFunc('loadingOoo', 'Loading...'));
        this.setTemplate(localisedTemplate);
    };
    LoadingOverlayComponent.DEFAULT_LOADING_OVERLAY_TEMPLATE = '<span class="ag-overlay-loading-center">[LOADING...]</span>';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], LoadingOverlayComponent.prototype, "gridOptionsWrapper", void 0);
    return LoadingOverlayComponent;
}(component_1.Component));
exports.LoadingOverlayComponent = LoadingOverlayComponent;


/***/ }),

/***/ "qDPe":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1026);
	module.exports = __webpack_require__(1026);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1026:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1027)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {
	    var kendo = window.kendo,
	        extend = $.extend,
	        proxy = $.proxy,
	        template = kendo.template,
	        ContextMenu = kendo.ui.ContextMenu,

	        ACTION = "action";

	    var FileManagerContextMenu = ContextMenu.extend({
	        init: function(element, options) {
	            var that = this;

	            ContextMenu.fn.init.call(that, element, options);

	            that._overrideTemplates();
	            that._restrictDefaultItems();
	            that._extendItems();

	            that.bind("select", proxy(that._onSelect, that));
	            that.bind("open", proxy(that._onOpen, that));
	        },

	        _overrideTemplates: function(){
	            this.templates.sprite = template("#if(spriteCssClass) {#<span class='#= spriteCssClass #'></span>#}#");
	        },

	        _restrictDefaultItems: function() {
	            var that = this;

	            if (that.options.isLocalBinding) {
	                that.defaultItems = {};
	            }
	        },

	        defaultItems: {
	            "rename": { text: "Rename", spriteCssClass: "k-icon k-i-edit", command: "RenameCommand" },
	            "delete": { text: "Delete", spriteCssClass: "k-icon k-i-delete", command: "DeleteCommand" }
	        },

	        events: ContextMenu.fn.events.concat([
	            ACTION
	        ]),

	        _extendItems: function(){
	            var that = this,
	                items = that.options.items,
	                item, isBuiltInTool;

	            if(items && items.length){
	                for (var i = 0; i < items.length; i++) {
	                    item = items[i];
	                    isBuiltInTool =  $.isPlainObject(item) && Object.keys(item).length === 1 && item.name;

	                    if(isBuiltInTool){
	                        item = item.name;
	                    }

	                    if($.isPlainObject(item) ) {
	                        that._extendItem(item);
	                        that.append(item);
	                    } else if (that.defaultItems[item]){
	                        item = that.defaultItems[item];
	                        that._extendItem(item);
	                        that.append(item);
	                    }
	                }
	            } else {
	                for (var key in that.defaultItems) {
	                    item = that.defaultItems[key];
	                    that._extendItem(item);
	                    that.append(item);
	                }
	            }
	        },

	        _extendItem: function(item) {
	            var that = this,
	                messages = that.options.messages;

	            extend(item, {
	                text: messages[item.text],
	                spriteCssClass: item.spriteCssClass || "",
	                attr: {
	                    "data-command": item.command
	                }
	            });
	        },

	        _onSelect: function(ev) {
	            var command = $(ev.item).data("command");
	            var target = $(ev.target);

	            if (!command) {
	                return;
	            }

	            this.action({
	                command: command,
	                options: { target: target }
	            });
	        },

	        _onOpen: function(ev) {
	            var menu = ev.sender,
	                items = menu.options.items;

	            if (!items && $.isEmptyObject(this.defaultItems)) {
	                ev.preventDefault();
	            }
	        },

	        action: function (args) {
	            this.trigger(ACTION, args);
	        }
	    });

	    extend(kendo.ui.filemanager, {
	        ContextMenu: FileManagerContextMenu
	    });

	    })(window.kendo.jQuery);

	    return window.kendo;

	    }, __webpack_require__(3));

/***/ }),

/***/ 1027:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("apSr");

/***/ })

/******/ });

/***/ }),

/***/ "qRfI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "qZXN":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1340);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1340:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1059) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "panelbar",
	    name: "PanelBar",
	    category: "web",
	    description: "The PanelBar widget displays hierarchical data as a multi-level expandable panel bar.",
	    depends: [ "core", "data", "data.odata" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        keys = kendo.keys,
	        extend = $.extend,
	        proxy = $.proxy,
	        each = $.each,
	        isArray = $.isArray,
	        template = kendo.template,
	        Widget = ui.Widget,
	        HierarchicalDataSource = kendo.data.HierarchicalDataSource,
	        excludedNodesRegExp = /^(ul|a|div)$/i,
	        NS = ".kendoPanelBar",
	        IMG = "img",
	        HREF = "href",
	        LAST = "k-last",
	        LINK = "k-link",
	        LINKSELECTOR = "." + LINK,
	        ERROR = "error",
	        ITEM = ".k-item",
	        GROUP = ".k-group",
	        VISIBLEGROUP = GROUP + ":visible",
	        IMAGE = "k-image",
	        FIRST = "k-first",
	        CHANGE = "change",
	        EXPAND = "expand",
	        SELECT = "select",
	        CLICK = "click",
	        CONTENT = "k-content",
	        ACTIVATE = "activate",
	        COLLAPSE = "collapse",
	        DATABOUND = "dataBound",
	        MOUSEENTER = "mouseenter",
	        MOUSELEAVE = "mouseleave",
	        CONTENTLOAD = "contentLoad",
	        UNDEFINED = "undefined",
	        ACTIVECLASS = "k-state-active",
	        GROUPS = "> .k-panel",
	        CONTENTS = "> .k-content",
	        STRING = "string",
	        FOCUSEDCLASS = "k-state-focused",
	        DISABLEDCLASS = "k-state-disabled",
	        SELECTEDCLASS = "k-state-selected",
	        SELECTEDSELECTOR = "." + SELECTEDCLASS,
	        HIGHLIGHTCLASS = "k-state-highlight",
	        ACTIVEITEMSELECTOR = ITEM + ":not(.k-state-disabled)",
	        clickableItems = "> " + ACTIVEITEMSELECTOR + " > " + LINKSELECTOR + ", .k-panel > " + ACTIVEITEMSELECTOR + " > " + LINKSELECTOR,
	        disabledItems = ITEM + ".k-state-disabled > .k-link",
	        selectableItems = "> li > " + SELECTEDSELECTOR + ", .k-panel > li > " + SELECTEDSELECTOR,
	        defaultState = "k-state-default",
	        ARIA_DISABLED = "aria-disabled",
	        ARIA_EXPANDED = "aria-expanded",
	        ARIA_HIDDEN = "aria-hidden",
	        ARIA_SELECTED = "aria-selected",
	        VISIBLE = ":visible",
	        EMPTY = ":empty",
	        SINGLE = "single",
	        bindings = {
	            text: "dataTextField",
	            url: "dataUrlField",
	            spriteCssClass: "dataSpriteCssClassField",
	            imageUrl: "dataImageUrlField"
	        },
	        itemIcon,
	        rendering = {
	        aria: function(item) {
	            var attr = "";

	            if (item.items || item.content || item.contentUrl || item.expanded) {
	                attr += ARIA_EXPANDED + "='" + (item.expanded ? "true" : "false") + "' ";
	            }

	            if (item.enabled === false) {
	                attr += ARIA_DISABLED + "='true'";
	            }

	            return attr;
	        },

	    wrapperCssClass: function (group, item) {
	        var result = "k-item",
	            index = item.index;

	        if (item.enabled === false) {
	            result += " " + DISABLEDCLASS;
	        } else if (item.expanded === true) {
	            result += " " + ACTIVECLASS;
	        } else {
	            result += " k-state-default";
	        }

	        if (index === 0) {
	            result += " k-first";
	        }

	        if (index == group.length - 1) {
	            result += " k-last";
	        }

	        if (item.cssClass) {
	            result += " " + item.cssClass;
	        }

	        return result;
	    },

	    textClass: function(item, group) {
	        var result = LINK;

	        if (group.firstLevel) {
	            result += " k-header";
	        }

	        if (item.selected) {
	            result += " " + SELECTEDCLASS;
	        }

	        return result;
	    },
	    textAttributes: function(url) {
	        return url ? " href='" + url + "'" : "";
	    },
	    arrowClass: function(item) {
	        var result = "k-icon";

	        result += item.expanded ? " k-panelbar-collapse k-i-arrow-60-up" : " k-panelbar-expand k-i-arrow-60-down";

	        return result;
	    },
	    text: function(item) {
	         return item.encoded === false ? item.text : kendo.htmlEncode(item.text);
	    },
	    groupAttributes: function(group) {
	        return group.expanded !== true ? " style='display:none'" : "";
	    },
	    ariaHidden: function(group){
	        return group.expanded !== true;
	    },
	    groupCssClass: function() {
	        return "k-group k-panel";
	    },
	    contentAttributes: function(content) {
	        return content.item.expanded !== true ? " style='display:none'" : "";
	    },
	    content: function(item) {
	        return item.content ? item.content : item.contentUrl ? "" : "&nbsp;";
	    },
	    contentUrl: function(item) {
	        return item.contentUrl ? 'href="' + item.contentUrl + '"' : "";
	    }
	};

	    function updateFirstLast (items) {
	        items = $(items);

	        items.filter(".k-first:not(:first-child)").removeClass(FIRST);
	        items.filter(".k-last:not(:last-child)").removeClass(LAST);
	        items.filter(":first-child").addClass(FIRST);
	        items.filter(":last-child").addClass(LAST);
	    }

	     function updateItemHtml(item) {
	        var wrapper = item,
	            group = item.children("ul"),
	            toggleButton = wrapper.children(".k-link").children(".k-icon");

	        if (item.hasClass("k-panelbar")) {
	            return;
	        }

	        if (!toggleButton.length && group.length) {
	            toggleButton = $("<span class='k-icon' />").appendTo(wrapper);
	        } else if (!group.length || !group.children().length) {
	            toggleButton.remove();
	            group.remove();
	        }
	     }

	    itemIcon = function(item) {
	        return item.children("span").children(".k-icon");
	    };

	    var PanelBar = kendo.ui.DataBoundWidget.extend({
	        init: function(element, options) {
	            var that = this,
	                content,
	                hasDataSource;

	           if (isArray(options)) {
	                options = { dataSource: options };
	           }

	            hasDataSource = options && !!options.dataSource;

	            Widget.fn.init.call(that, element, options);

	            element = that.wrapper = that.element.addClass("k-widget k-reset k-header k-panelbar");
	            options = that.options;

	            if (element[0].id) {
	                that._itemId = element[0].id + "_pb_active";
	            }

	            that._tabindex();

	            that._accessors();

	            that._dataSource();

	            that._templates();

	            that._initData(hasDataSource);

	            that._updateClasses();

	            that._animations(options);

	            element
	                .on(CLICK + NS, clickableItems, proxy(that._click, that))
	                .on(MOUSEENTER  + NS + " " + MOUSELEAVE + NS, clickableItems, that._toggleHover)
	                .on(CLICK + NS, disabledItems, false)
	                .on(CLICK + NS, ".k-request-retry", proxy(that._retryRequest, that))
	                .on("keydown" + NS, proxy(that._keydown, that))
	                .on("focus" + NS, function() {
	                    var item = that.select();
	                    that._current(item[0] ? item : that._first());
	                })
	                .on("blur" + NS, function() {
	                    that._current(null);
	                })
	                .attr("role", "tree");

	            content = element.find("li." + ACTIVECLASS + " > ." + CONTENT);

	            if (content[0]) {
	                that.expand(content.parent(), false);
	            }

	            if (!options.dataSource) {
	                that._angularCompile();
	            }

	            kendo.notify(that);
	        },

	        events: [
	            EXPAND,
	            COLLAPSE,
	            SELECT,
	            ACTIVATE,
	            CHANGE,
	            ERROR,
	            DATABOUND,
	            CONTENTLOAD
	        ],
	        options: {
	            name: "PanelBar",
	            dataSource: {},
	            animation: {
	                expand: {
	                    effects: "expand:vertical",
	                    duration: 200
	                },
	                collapse: { // if collapse animation effects are defined, they will be used instead of expand.reverse
	                    duration: 200
	                }
	            },
	            messages: {
	                loading: "Loading...",
	                requestFailed: "Request failed.",
	                retry: "Retry"
	            },
	            autoBind: true,
	            loadOnDemand: true,
	            expandMode: "multiple",
	            template: "",
	            dataTextField: null
	        },

	        _angularCompile: function() {
	            var that = this;
	            that.angular("compile", function(){
	                return {
	                    elements: that.element.children("li"),
	                    data: [{ dataItem: that.options.$angular}]
	                };
	            });
	        },

	        _angularCompileElements: function(html, items) {
	            var that = this;
	            that.angular("compile", function(){
	                return {
	                    elements: html,
	                    data: $.map(items, function(item) {
	                        return [{ dataItem: item }];
	                    })
	                };
	            });
	        },

	        _angularCleanup: function() {
	            var that = this;

	            that.angular("cleanup", function(){
	                return { elements: that.element.children("li") };
	            });
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            this.element.off(NS);

	            this._angularCleanup();

	            kendo.destroy(this.element);
	        },

	        _initData: function(hasDataSource) {
	            var that = this;

	            if (hasDataSource) {
	                that.element.empty();
	                 if (that.options.autoBind) {
	                    that._progress(true);

	                    that.dataSource.fetch();
	                 }
	            }
	        },

	        _templates: function() {
	            var that = this,
	                options = that.options,
	                fieldAccessor = proxy(that._fieldAccessor, that);

	              if (options.template && typeof options.template == STRING) {
	                    options.template = template(options.template);
	              } else if (!options.template) {
	                     options.template = template(
	                        "# var text = " + fieldAccessor("text") + "(data.item); #" +
	                        "# if (typeof data.item.encoded != 'undefined' && data.item.encoded === false) {#" +
	                            "#= text #" +
	                        "# } else { #" +
	                            "#: text #" +
	                        "# } #"
	                    );
	                }

	            that.templates = {
	                content: template(
	                    "<div class='k-content'#= contentAttributes(data) #>#= content(item) #</div>"
	                ),
	                group: template(
	                    "<ul role='group' aria-hidden='#= ariaHidden(group) #' class='#= groupCssClass(group) #'#= groupAttributes(group) #>" +
	                        "#= renderItems(data) #" +
	                    "</ul>"
	                ),
	                itemWrapper: template(
	                     "# var url = " + fieldAccessor("url") + "(item); #" +
	                     "# var imageUrl = " + fieldAccessor("imageUrl") + "(item); #" +
	                     "# var spriteCssClass = " + fieldAccessor("spriteCssClass") + "(item); #" +
	                     "# var contentUrl = contentUrl(item); #" +
	                     "# var tag = url||contentUrl ? 'a' : 'span'; #" +

	                    "<#= tag # class='#= textClass(item, group) #' #= contentUrl ##= textAttributes(url) #>" +
	                        "# if (imageUrl) { #" +
	                              "<img class='k-image' alt='' src='#= imageUrl #' />" +
	                        "# } #" +

	                        "# if (spriteCssClass) { #" +
	                            "<span class='k-sprite #= spriteCssClass #'></span>" +
	                        "# } #" +
	                      "#= data.panelBar.options.template(data) #" +
	                      "#= arrow(data) #" +
	                    "</#= tag #>"
	                ),

	                item: template(
	                    "<li role='treeitem' #=aria(item)#class='#= wrapperCssClass(group, item) #'" +
	                         kendo.attr("uid") + "='#= item.uid #'>" +
	                        "#= itemWrapper(data) #" +
	                        "# if (item.items && item.items.length > 0) { #" +
	                        "#= subGroup({ items: item.items, panelBar: panelBar, group: { expanded: item.expanded } }) #" +
	                        "# } else if (item.content || item.contentUrl) { #" +
	                        "#= renderContent(data) #" +
	                        "# } #" +
	                    "</li>"
	                ),
	                loading: template("<li class='k-item'><span class='k-icon k-i-loading'></span> #: data.messages.loading #</li>"),
	                retry: template(
	                    "<li class='k-item'>" +
	                        "#: data.messages.requestFailed # " +
	                        "<button class='k-button k-request-retry'>#: data.messages.retry #</button>" +
	                    "</li>"
	                ),
	                arrow: template("<span class='#= arrowClass(item) #'></span>"),
	                empty: template("")
	            };
	        },

	        setOptions: function(options) {
	            var animation = this.options.animation;

	            this._animations(options);

	            options.animation = extend(true, animation, options.animation);

	            if ("dataSource" in options) {
	                this.setDataSource(options.dataSource);
	            }

	            Widget.fn.setOptions.call(this, options);
	        },

	        expand: function (element, useAnimation) {
	            var that = this,
	                animBackup = {};

	            element = this.element.find(element);

	            if (that._animating && element.find("ul").is(":visible")) {
	                that.one("complete", function() {
	                    setTimeout(function() {
	                        that.expand(element);
	                    });
	                });
	                return;
	            }
	            that._animating = true;

	            useAnimation = useAnimation !== false;

	            element.each(function (index, item) {
	                item = $(item);
	                var wrapper = element.children(".k-group,.k-content");

	                if (!wrapper.length) {
	                    wrapper =  that._addGroupElement(element);
	                }

	                 var groups = wrapper.add(item.find(CONTENTS));

	                if (!item.hasClass(DISABLEDCLASS) && groups.length > 0) {

	                    if (that.options.expandMode == SINGLE && that._collapseAllExpanded(item)) {
	                        return that;
	                    }

	                    element.find("." + HIGHLIGHTCLASS).removeClass(HIGHLIGHTCLASS);
	                    item.addClass(HIGHLIGHTCLASS);

	                    if (!useAnimation) {
	                        animBackup = that.options.animation;
	                        that.options.animation = { expand: { effects: {} }, collapse: { hide: true, effects: {} } };
	                    }

	                    if (!that._triggerEvent(EXPAND, item)) {
	                        that._toggleItem(item, false, false);
	                    }

	                    if (!useAnimation) {
	                        that.options.animation = animBackup;
	                    }
	                }
	            });

	            return that;
	        },

	        collapse: function (element, useAnimation) {
	            var that = this,
	                animBackup = {};

	            that._animating = true;

	            useAnimation = useAnimation !== false;
	            element = that.element.find(element);

	            element.each(function (index, item) {
	                item = $(item);
	                var groups = item.find(GROUPS).add(item.find(CONTENTS));

	                if (!item.hasClass(DISABLEDCLASS) && groups.is(VISIBLE)) {
	                    item.removeClass(HIGHLIGHTCLASS);

	                    if (!useAnimation) {
	                        animBackup = that.options.animation;
	                        that.options.animation = { expand: { effects: {} }, collapse: { hide: true, effects: {} } };
	                    }

	                    if (!that._triggerEvent(COLLAPSE, item)) {
	                        that._toggleItem(item, true);
	                    }

	                    if (!useAnimation) {
	                        that.options.animation = animBackup;
	                    }
	                }

	            });
	            return that;
	        },

	         updateArrow: function(items) {
	                var that = this;

	                items = $(items);
	                items.children(LINKSELECTOR).children(".k-panelbar-collapse, .k-panelbar-expand").remove();

	                items
	                    .filter(function() {
	                        var dataItem = that.dataItem(this);

	                        if (!dataItem) {
	                            return $(this).find(".k-panel").length > 0 ||
	                                $(this).find(".k-content").length > 0;
	                        }

	                        return dataItem.hasChildren || dataItem.content || dataItem.contentUrl;
	                    })
	                    .children(".k-link:not(:has([class*=k-i-arrow]))")
	                    .each(function () {
	                        var item = $(this),
	                            parent = item.parent();

	                        item.append("<span class='k-icon " + (parent.hasClass(ACTIVECLASS) ? " k-panelbar-collapse k-i-arrow-60-up" : " k-panelbar-expand k-i-arrow-60-down") + "'/>");
	                    });
	         },

	        _accessors: function() {
	            var that = this,
	                options = that.options,
	                i, field, textField,
	                element = that.element;

	            for (i in bindings) {
	                field = options[bindings[i]];
	                textField = element.attr(kendo.attr(i + "-field"));

	                if (!field && textField) {
	                    field = textField;
	                }

	                if (!field) {
	                    field = i;
	                }

	                if (!isArray(field)) {
	                    field = [field];
	                }

	                options[bindings[i]] = field;
	            }
	        },

	        _progress: function(item, showProgress) {
	            var element = this.element;
	            var loadingText = this.templates.loading({ messages: this.options.messages });

	            if (arguments.length == 1) {
	                showProgress = item;

	                if (showProgress) {
	                    element.html(loadingText);
	                } else {
	                    element.empty();
	                }
	            }
	            else {
	                itemIcon(item).toggleClass("k-i-loading", showProgress).removeClass("k-i-refresh");
	            }
	        },

	        _refreshRoot: function(items) {
	            var that = this;
	            var parent = that.element;
	            var  groupData = {
	                firstLevel: true,
	                expanded: true,
	                length: parent.children().length
	            };

	            this.element.empty();

	            var rootItemsHtml = $.map(items, function(value, idx) {
	                    if (typeof value === "string") {
	                        return $(value);
	                    } else {
	                        value.items = [];
	                        return $(that.renderItem({
	                            group: groupData,
	                            item: extend(value, { index: idx })
	                        }));
	                    }
	            });

	            this.element.append(rootItemsHtml);
	            var elements = this.element.children(".k-item");
	            for (var i = 0; i < items.length; i++) {
	                this.trigger("itemChange", {
	                    item: elements.eq(i).find(".k-link").first(),
	                    data: items[i],
	                    ns: ui
	                });
	            }
	            this._angularCompileElements(rootItemsHtml, items);
	        },

	        _refreshChildren: function(item, parentNode) {
	            var i, children, child;

	            parentNode.children(".k-group").empty();
	            var items = item.children.data();
	            if (!items.length) {
	                updateItemHtml(parentNode);
	                children = parentNode.children(".k-group").children("li");
	                this._angularCompileElements(children, items);
	            } else {
	                this.append(item.children, parentNode);

	                if(this.options.loadOnDemand){
	                    this._toggleGroup(parentNode.children(".k-group"), false);
	                }
	                children = parentNode.children(".k-group").children("li");

	                for (i = 0; i < children.length; i++) {
	                    child = children.eq(i);
	                    this.trigger("itemChange", {
	                        item: child.find(".k-link").first(),
	                        data: this.dataItem(child),
	                        ns: ui
	                    });
	                }
	            }
	        },

	        findByUid: function(uid) {
	            var items = this.element.find(".k-item");
	            var uidAttr = kendo.attr("uid");
	            var result;

	            for (var i = 0; i < items.length; i++) {
	                if (items[i].getAttribute(uidAttr) == uid) {
	                    result = items[i];
	                    break;
	                }
	            }

	            return $(result);
	        },

	        refresh: function(e) {
	            var options = this.options;
	            var node = e.node;
	            var action = e.action;
	            var items = e.items;
	            var parentNode = this.wrapper;
	            var loadOnDemand = options.loadOnDemand;

	            if (e.field) {
	                if (!items[0] || !items[0].level) {
	                    return;
	                }

	                return this._updateItems(items, e.field);
	            }

	            if (node) {
	                parentNode = this.findByUid(node.uid);
	                this._progress(parentNode, false);
	            }
	            if (action == "add") {
	                this._appendItems(e.index, items, parentNode);
	            } else if (action == "remove") {
	                this.remove(this.findByUid(items[0].uid));
	            } else if (action == "itemchange") {
	                this._updateItems(items);
	            } else if (action == "itemloaded") {
	                this._refreshChildren(node, parentNode);
	            } else {
	                this._refreshRoot(items);
	            }

	            if (action != "remove") {
	                for (var k = 0; k < items.length; k++) {

	                    if (!loadOnDemand || items[k].expanded) {
	                        var tempItem = items[k];
	                        if (this._hasChildItems(tempItem)) {
	                                tempItem.load();
	                        }
	                    }
	                }
	            }

	            this.trigger(DATABOUND, { node: node ? parentNode : undefined });
	        },

	        _error: function(e) {
	            var node = e.node && this.findByUid(e.node.uid);
	            var retryHtml = this.templates.retry({ messages: this.options.messages });

	            if (node) {
	                this._progress(node, false);
	                this._expanded(node, false);
	                itemIcon(node).addClass("k-i-refresh");
	                e.node.loaded(false);
	            } else {
	                this._progress(false);
	                this.element.html(retryHtml);
	            }
	        },

	        _retryRequest: function(e) {
	            e.preventDefault();

	            this.dataSource.fetch();
	        },

	         items: function() {
	            return this.element.find(".k-item > span:first-child");
	        },

	        setDataSource: function(dataSource) {
	            var options = this.options;

	            options.dataSource = dataSource;

	            this._dataSource();

	            if (this.options.autoBind) {
	                this._progress(true);
	                this.dataSource.fetch();
	            }
	        },

	        _bindDataSource: function() {
	            this._refreshHandler = proxy(this.refresh, this);
	            this._errorHandler = proxy(this._error, this);

	            this.dataSource.bind(CHANGE, this._refreshHandler);
	            this.dataSource.bind(ERROR, this._errorHandler);
	        },

	        _unbindDataSource: function() {
	            var dataSource = this.dataSource;

	            if (dataSource) {
	                dataSource.unbind(CHANGE, this._refreshHandler);
	                dataSource.unbind(ERROR, this._errorHandler);
	            }
	        },

	        // generates accessor function for a given field name, honoring the data*Field arrays
	        _fieldAccessor: function(fieldName) {
	            var fieldBindings = this.options[bindings[fieldName]] || [],
	                count = fieldBindings.length,
	                result = "(function(item) {";

	            if (count === 0) {
	                result += "return item['" + fieldName + "'];";
	            } else {
	                result += "var levels = [" +
	                            $.map(fieldBindings, function(x) {
	                                return "function(d){ return " + kendo.expr(x) + "}";
	                            }).join(",") + "];";
	                result += "if(item.level){return levels[Math.min(item.level(), " + count + "-1)](item);}else";
	                result += "{return levels["+ count + "-1](item)}";
	            }

	            result += "})";

	            return result;
	        },

	        _dataSource: function() {
	            var that = this,
	                options = that.options,
	                dataSource = options.dataSource;

	            if (!dataSource) {
	                return;
	            }

	            dataSource = isArray(dataSource) ? { data: dataSource } : dataSource;

	            that._unbindDataSource();

	            if (!dataSource.fields) {
	                dataSource.fields = [
	                    { field: "text" },
	                    { field: "url" },
	                    { field: "spriteCssClass" },
	                    { field: "imageUrl" }
	                ];
	            }

	            that.dataSource = HierarchicalDataSource.create(dataSource);

	            that._bindDataSource();
	        },

	        _appendItems: function(index, items, parentNode) {
	            var that = this, children, wrapper;

	              if (parentNode.hasClass("k-panelbar")) {
	                  children = parentNode.children("li");
	                  wrapper = parentNode;
	              } else {
	                  wrapper = parentNode.children(".k-group");
	                  if (!wrapper.length) {
	                      wrapper =  that._addGroupElement(parentNode);
	                  }

	                  children = wrapper.children("li");
	              }

	             var  groupData = {
	                firstLevel: parentNode.hasClass("k-panelbar"),
	                expanded: true,
	                length: children.length
	             };

	             var itemsHtml = $.map(items, function(value, idx) {
	                    if (typeof value === "string") {
	                        return $(value);
	                    } else {
	                        return $(that.renderItem({
	                            group: groupData,
	                            item: extend(value, { index: idx })
	                        }));
	                    }
	            });

	              if (typeof index == UNDEFINED) {
	                   index = children.length;
	              }

	              for (var i = 0; i < itemsHtml.length; i++) {
	                  if (children.length === 0 || index === 0) {
	                      wrapper.append(itemsHtml[i]);
	                  } else {
	                       itemsHtml[i].insertAfter(children[index - 1]);
	                  }
	               }

	            that._angularCompileElements(itemsHtml, items);
	              if (that.dataItem(parentNode)) {
	                  that.dataItem(parentNode).hasChildren = true;
	                  that.updateArrow(parentNode);
	              }
	        },

	        _updateItems: function (items, field) {
	            var that = this;
	            var i, node, nodeWrapper, item;
	            var context = { panelBar: that.options, item: item, group: {} };
	            var render = field != "expanded";

	            if (field == "selected") {
	                if(items[0][field]){
	                    var currentNode = that.findByUid(items[0].uid);

	                    if (!currentNode.hasClass(DISABLEDCLASS)) {
	                        that.select(currentNode, true);
	                    }
	                }else{
	                    that.clearSelection();
	                }
	            } else {
	                var elements = $.map(items, function(item) {
	                    return that.findByUid(item.uid);
	                });

	                if (render) {
	                    that.angular("cleanup", function() { return { elements: elements }; });
	                }

	                for (i = 0; i < items.length; i++) {
	                    context.item = item = items[i];
	                    context.panelBar = that;
	                    nodeWrapper = elements[i];
	                    node = nodeWrapper.parent();
	                    if (render) {
	                        context.group = {
	                            firstLevel: node.hasClass("k-panelbar"),
	                            expanded: nodeWrapper.parent().hasClass(ACTIVECLASS),
	                            length: nodeWrapper.children().length
	                        };

	                        nodeWrapper.children(".k-link").remove();
	                        nodeWrapper.prepend(that.templates.itemWrapper(extend(context,
	                            {
	                                arrow: item.hasChildren || item.content || item.contentUrl ? that.templates.arrow : that.templates.empty
	                            },
	                            rendering)));
	                    }

	                    if (field == "expanded") {
	                        that._toggleItem(nodeWrapper, !item[field], item[field] ? "true": true);
	                    } else if (field == "enabled") {
	                        that.enable(nodeWrapper, item[field]);
	                         if (!item[field]) {
	                            if (item.selected) {
	                                item.set("selected", false);
	                            }
	                         }
	                    }

	                    if (nodeWrapper.length) {
	                        this.trigger("itemChange", { item: nodeWrapper.find(".k-link").first(), data: item, ns: ui });
	                    }
	                }

	                if (render) {
	                    that.angular("compile", function(){
	                        return {
	                            elements: elements,
	                            data: $.map(items, function(item) {
	                                return [{ dataItem: item }];
	                            })
	                        };
	                    });
	                }
	            }
	        },

	        _toggleDisabled: function(element, enable) {
	            element = this.element.find(element);
	            element
	                .toggleClass(defaultState, enable)
	                .toggleClass(DISABLEDCLASS, !enable)
	                .attr(ARIA_DISABLED, !enable);
	        },

	       dataItem: function(item) {
	            var uid = $(item).closest(ITEM).attr(kendo.attr("uid")),
	                dataSource = this.dataSource;

	            return dataSource && dataSource.getByUid(uid);
	       },

	       select: function (element, skipChange) {
	           var that = this;

	            if (element === undefined) {
	                return that.element.find(selectableItems).parent();
	            }

	            element = that.element.find(element);

	            if (!element.length) {
	                this._updateSelected(element);
	            } else {
	                element
	                    .each(function () {
	                        var item = $(this),
	                            link = item.children(LINKSELECTOR);

	                        if (item.hasClass(DISABLEDCLASS)) {
	                            return that;
	                        }

	                        that._updateSelected(link, skipChange);
	                    });
	            }

	            return that;
	        },

	        clearSelection: function() {
	            this.select($());
	        },

	        enable: function (element, state) {
	            this._toggleDisabled(element, state !== false);

	            return this;
	        },

	        disable: function (element) {
	            this._toggleDisabled(element, false);

	            return this;
	        },

	        append: function (item, referenceItem) {
	            referenceItem = this.element.find(referenceItem);

	            var inserted = this._insert(item, referenceItem, referenceItem.length ? referenceItem.find(GROUPS) : null);

	            each(inserted.items, function () {
	                inserted.group.append(this);
	                updateFirstLast(this);
	            });

	            this.updateArrow(referenceItem);
	            updateFirstLast(inserted.group.find(".k-first, .k-last"));
	            inserted.group.height("auto");

	            return this;
	        },

	        insertBefore: function (item, referenceItem) {
	            referenceItem = this.element.find(referenceItem);

	            var inserted = this._insert(item, referenceItem, referenceItem.parent());

	            each(inserted.items, function () {
	                referenceItem.before(this);
	                updateFirstLast(this);
	            });

	            updateFirstLast(referenceItem);
	            inserted.group.height("auto");

	            return this;
	        },

	        insertAfter: function (item, referenceItem) {
	            referenceItem = this.element.find(referenceItem);

	            var inserted = this._insert(item, referenceItem, referenceItem.parent());

	            each(inserted.items, function () {
	                referenceItem.after(this);
	                updateFirstLast(this);
	            });

	            updateFirstLast(referenceItem);
	            inserted.group.height("auto");

	            return this;
	        },

	        remove: function (element) {
	            element = this.element.find(element);

	            var that = this,
	                parent = element.parentsUntil(that.element, ITEM),
	                group = element.parent("ul");

	            element.remove();

	            if (group && !group.hasClass("k-panelbar") && !group.children(ITEM).length) {
	                group.remove();
	            }

	            if (parent.length) {
	                parent = parent.eq(0);

	                that.updateArrow(parent);
	                updateFirstLast(parent);
	            }

	            return that;
	        },

	        reload: function (element) {
	            var that = this;
	            element = that.element.find(element);

	            element.each(function () {
	                var item = $(this);

	                that._ajaxRequest(item, item.children("." + CONTENT), !item.is(VISIBLE));
	            });
	        },

	        _first: function() {
	            return this.element.children(ACTIVEITEMSELECTOR).first();
	        },

	        _last: function() {
	            var item = this.element.children(ACTIVEITEMSELECTOR).last(),
	                group = item.children(VISIBLEGROUP);

	            if (group[0]) {
	                return group.children(ACTIVEITEMSELECTOR).last();
	            }
	            return item;
	        },

	        _current: function(candidate) {
	            var that = this,
	                focused = that._focused,
	                id = that._itemId;

	            if (candidate === undefined) {
	                return focused;
	            }

	            that.element.removeAttr("aria-activedescendant");

	            if (focused && focused.length) {
	                if (focused[0].id === id) {
	                    focused.removeAttr("id");
	                }

	                focused
	                    .children(LINKSELECTOR)
	                    .removeClass(FOCUSEDCLASS);
	            }

	            if ($(candidate).length) {
	                id = candidate[0].id || id;

	                candidate.attr("id", id)
	                         .children(LINKSELECTOR)
	                         .addClass(FOCUSEDCLASS);

	                that.element.attr("aria-activedescendant", id);
	            }

	            that._focused = candidate;
	        },

	        _keydown: function(e) {
	            var that = this,
	                key = e.keyCode,
	                current = that._current();

	            if (e.target != e.currentTarget) {
	                return;
	            }

	            if (key == keys.DOWN || key == keys.RIGHT) {
	                that._current(that._nextItem(current));
	                e.preventDefault();
	            } else if (key == keys.UP || key == keys.LEFT) {
	                that._current(that._prevItem(current));
	                e.preventDefault();
	            } else if (key == keys.ENTER || key == keys.SPACEBAR) {
	                that._click(e);
	                e.preventDefault();
	            } else if (key == keys.HOME) {
	                that._current(that._first());
	                e.preventDefault();
	            } else if (key == keys.END) {
	                that._current(that._last());
	                e.preventDefault();
	            }
	        },

	        _nextItem: function(item) {
	            if (!item) {
	                return this._first();
	            }

	            var group = item.children(VISIBLEGROUP),
	                next = item.nextAll(":visible").first();

	            if (group[0]) {
	                next = group.children("." + FIRST);
	            }

	            if (!next[0]) {
	                next = item.parent(VISIBLEGROUP).parent(ITEM).next();
	            }

	            if (!next[0]) {
	                next = this._first();
	            }

	            if (next.hasClass(DISABLEDCLASS)) {
	                next = this._nextItem(next);
	            }

	            return next;
	        },

	        _prevItem: function(item) {
	            if (!item) {
	                return this._last();
	            }

	            var prev = item.prevAll(":visible").first(),
	                result;

	            if (!prev[0]) {
	                prev = item.parent(VISIBLEGROUP).parent(ITEM);
	                if (!prev[0]) {
	                    prev = this._last();
	                }
	            } else {
	                result = prev;
	                while (result[0]) {
	                    result = result.children(VISIBLEGROUP).children("." + LAST);
	                    if (result[0]) {
	                        prev = result;
	                    }
	                }
	            }

	            if (prev.hasClass(DISABLEDCLASS)) {
	                prev = this._prevItem(prev);
	            }

	            return prev;
	        },

	        _insert: function (item, referenceItem, parent) {
	            var that = this,
	                items,
	                plain = $.isPlainObject(item),
	                isReferenceItem = referenceItem && referenceItem[0],
	                groupData;

	            if (!isReferenceItem) {
	                parent = that.element;
	            }

	            groupData = {
	                firstLevel: parent.hasClass("k-panelbar"),
	                expanded: $(referenceItem).hasClass(ACTIVECLASS),
	                length: parent.children().length
	            };

	            if (isReferenceItem && !parent.length) {
	                parent = $(that.renderGroup({ group: groupData, options: that.options })).appendTo(referenceItem);
	            }

	            if (plain || $.isArray(item) || item instanceof HierarchicalDataSource) { // is JSON or HierarchicalDataSource
	                if (item instanceof HierarchicalDataSource) {
	                   item = item.data();
	                }

	                items = $.map(plain ? [item] : item, function(value, idx) {
	                    if (typeof value === "string") {
	                        return $(value);
	                    } else {
	                        return $(that.renderItem({
	                            group: groupData,
	                            item: extend(value, { index: idx })
	                        }));
	                    }
	                });
	                if (isReferenceItem) {
	                    var dataItem = that.dataItem(referenceItem);
	                    if (dataItem) {
	                        dataItem.hasChildren = true;
	                        referenceItem
	                            .attr(ARIA_EXPANDED, dataItem.expanded)
	                            .not("." + ACTIVECLASS)
	                            .children("ul")
	                            .attr(ARIA_HIDDEN, !dataItem.expanded);
	                    }else{
	                        referenceItem.attr(ARIA_EXPANDED, false);
	                    }
	                }
	            } else {
	                if (typeof item == "string" && item.charAt(0) != "<") {
	                    items = that.element.find(item);
	                } else {
	                    items = $(item);
	                }
	                that._updateItemsClasses(items);
	            }

	            if (!item.length){
	                item = [item];
	            }

	            that._angularCompileElements(items, item);
	            return { items: items, group: parent };
	        },

	        _toggleHover: function(e) {
	            var target = $(e.currentTarget);

	            if (!target.parents("li." + DISABLEDCLASS).length) {
	                target.toggleClass("k-state-hover", e.type == MOUSEENTER);
	            }
	        },

	        _updateClasses: function() {
	            var that = this,
	                panels, items, expanded, panelsParent, dataItem;

	            panels = that.element
	                         .find("li > ul")
	                         .not(function () { return $(this).parentsUntil(".k-panelbar", "div").length; })
	                         .addClass("k-group k-panel")
	                         .attr("role", "group");

	            panelsParent = panels.parent();
	            dataItem = that.dataItem(panelsParent);
	            expanded = (dataItem && dataItem.expanded) || false;

	            panels.parent()
	                  .attr(ARIA_EXPANDED, expanded)
	                  .not("." + ACTIVECLASS)
	                  .children("ul")
	                  .attr(ARIA_HIDDEN, !expanded)
	                  .hide();

	            items = that.element.add(panels).children();

	            that._updateItemsClasses(items);
	            that.updateArrow(items);
	            updateFirstLast(items);
	        },

	        _updateItemsClasses: function(items) {
	            var length = items.length,
	                idx = 0;

	            for(; idx < length; idx++) {
	                this._updateItemClasses(items[idx], idx);
	            }
	        },

	        _updateItemClasses: function(item, index) {
	            var selected = this._selected,
	                contentUrls = this.options.contentUrls,
	                url = contentUrls && contentUrls[index],
	                root = this.element[0],
	                wrapElement, link;

	            item = $(item).addClass("k-item").attr("role", "treeitem");

	            if (kendo.support.browser.msie) {  // IE10 doesn't apply list-style: none on invisible items otherwise.
	                item.css("list-style-position", "inside")
	                    .css("list-style-position", "");
	            }

	            item
	                .children(IMG)
	                .addClass(IMAGE);

	            link = item
	                    .children("a")
	                    .addClass(LINK);

	            if (link[0]) {
	                link.attr("href", url); //url can be undefined

	                link.children(IMG)
	                    .addClass(IMAGE);
	            }

	            item
	                .filter(":not([disabled]):not([class*=k-state])")
	                .addClass("k-state-default");

	            item
	                .filter("li[disabled]")
	                .addClass("k-state-disabled")
	                .attr(ARIA_DISABLED, true)
	                .removeAttr("disabled");

	            item
	                .children("div")
	                .addClass(CONTENT)
	                .attr(ARIA_HIDDEN, true)
	                .hide()
	                .parent()
	                .attr(ARIA_EXPANDED, false);

	            link = item.children(SELECTEDSELECTOR);
	            if (link[0]) {
	                if (selected) {
	                    selected.removeAttr(ARIA_SELECTED)
	                            .children(SELECTEDSELECTOR)
	                            .removeClass(SELECTEDCLASS);
	                }

	                link.addClass(SELECTEDCLASS);
	                this._selected = item.attr(ARIA_SELECTED, true);
	            }

	            if (!item.children(LINKSELECTOR)[0]) {
	                wrapElement = "<span class='" + LINK + "'></span>";
	                if (contentUrls && contentUrls[index] && item[0].parentNode == root) {
	                    wrapElement = '<a class="k-link k-header" href="' + contentUrls[index] + '"></a>';
	                }

	                item
	                    .contents()      // exclude groups, real links, templates and empty text nodes
	                    .filter(function() { return (!this.nodeName.match(excludedNodesRegExp) && !(this.nodeType == 3 && !kendo.trim(this.nodeValue.trim))); })
	                    .wrapAll(wrapElement);
	            }

	            if (item.parent(".k-panelbar")[0]) {
	                item
	                    .children(LINKSELECTOR)
	                    .addClass("k-header");
	            }
	        },

	        _click: function (e) {
	            var that = this,
	                target = e.type == CLICK ? $(e.target) : that._current().children(LINKSELECTOR),
	                element = that.element,
	                prevent, contents, href, isAnchor;

	            if (target.parents("li." + DISABLEDCLASS).length) {
	                return;
	            }

	            if (target.closest(".k-widget")[0] != element[0]) {
	                return;
	            }

	            if (target.is(":kendoFocusable") && !target.hasClass(LINK)) {
	                return;
	            }

	            var link = target.closest(LINKSELECTOR),
	                item = link.closest(ITEM);

	            that._updateSelected(link);

	            var wrapper = item.children(".k-group,.k-content");
	            var dataItem = this.dataItem(item);

	            if (!wrapper.length && ((that.options.loadOnDemand && dataItem && dataItem.hasChildren) ||
	             this._hasChildItems(item) || item.content || item.contentUrl)) {
	                wrapper =  that._addGroupElement(item);
	            }

	            contents = item.find(GROUPS).add(item.find(CONTENTS));
	            href = link.attr(HREF);
	            isAnchor = href && (href.charAt(href.length - 1) == "#" || href.indexOf("#" + that.element[0].id + "-") != -1);
	            prevent = !!(isAnchor || contents.length);

	            if (contents.data("animating") && prevent) {
	                e.preventDefault();
	                return;
	            }

	            if (that._triggerEvent(SELECT, item)) {
	                prevent = true;
	            }

	            if (prevent === false) {
	                return;
	            }

	            if (that.options.expandMode == SINGLE) {
	                if (that._collapseAllExpanded(item) && prevent) {
	                    e.preventDefault();
	                    return;
	                }
	            }

	            if (contents.length) {
	                var visibility = contents.is(VISIBLE);

	                if (!that._triggerEvent(!visibility ? EXPAND : COLLAPSE, item)) {
	                    prevent = that._toggleItem(item, visibility);
	                }
	            }

	            if (prevent) {
	                e.preventDefault();
	            }
	        },
	        _hasChildItems: function (item) {
	            return (item.items && item.items.length > 0) || item.hasChildren;
	        },

	        _toggleItem: function (element, isVisible, expanded) {
	            var that = this,
	                childGroup = element.find(GROUPS),
	                link = element.find(LINKSELECTOR),
	                url = link.attr(HREF),
	                prevent, content,
	                dataItem = that.dataItem(element),
	                notVisible = !isVisible;

	            var loaded = dataItem && dataItem.loaded();

	            if (dataItem && !expanded && dataItem.expanded !== notVisible) {
	                dataItem.set("expanded", notVisible);
	                prevent = dataItem.hasChildren || !!dataItem.content || !!dataItem.contentUrl;
	                return prevent;
	            }

	            if (dataItem && (!expanded || expanded === "true") &&  !loaded && !dataItem.content && !dataItem.contentUrl) {
	                 if (that.options.loadOnDemand) {
	                     this._progress(element, true);
	                 }

	                 element.children(".k-group,.k-content").remove();
	                 prevent = dataItem.hasChildren;

	                 dataItem.load();
	             } else {
	                   if (childGroup.length) {
	                        this._toggleGroup(childGroup, isVisible);
	                        prevent = true;
	                   } else {
	                        content = element.children("."  + CONTENT);

	                        if (content.length) {
	                            prevent = true;

	                            if (!content.is(EMPTY) || url === undefined) {
	                                that._toggleGroup(content, isVisible);
	                            } else {
	                                that._ajaxRequest(element, content, isVisible);
	                            }
	                        }
	                    }
	             }

	            return prevent;
	        },

	        _toggleGroup: function (element, visibility) {
	            var that = this,
	                animationSettings = that.options.animation,
	                animation = animationSettings.expand,
	                hasCollapseAnimation = animationSettings.collapse && "effects" in animationSettings.collapse,
	                collapse = extend({}, animationSettings.expand, animationSettings.collapse);

	            if (!hasCollapseAnimation) {
	                collapse = extend(collapse, {reverse: true});
	            }

	            if (element.is(VISIBLE) != visibility) {
	                that._animating = false;
	                return;
	            }

	            element.attr(ARIA_HIDDEN, !!visibility);

	            element.parent()
	                .attr(ARIA_EXPANDED, !visibility)
	                .toggleClass(ACTIVECLASS, !visibility)
	                .find("> .k-link > .k-panelbar-collapse,> .k-link > .k-panelbar-expand")
	                    .toggleClass("k-i-arrow-60-up", !visibility)
	                    .toggleClass("k-panelbar-collapse", !visibility)
	                    .toggleClass("k-i-arrow-60-down", visibility)
	                    .toggleClass("k-panelbar-expand", visibility);
	            if (visibility) {
	                animation = extend(collapse, { hide: true });

	                animation.complete = function() {
	                    that._animationCallback();
	                };
	            } else {
	                animation = extend( { complete: function (element) {
	                        that._triggerEvent(ACTIVATE, element.closest(ITEM));
	                        that._animationCallback();
	                    } }, animation );
	            }

	            element
	                .kendoStop(true, true)
	                .kendoAnimate( animation );
	        },

	        _animationCallback: function() {
	            var that = this;
	            that.trigger("complete");
	            that._animating = false;
	        },

	        _addGroupElement: function(element) {
	            var group = $('<ul role="group" aria-hidden="true" class="k-group k-panel" style="display:none"></ul>');

	            element.append(group);
	            return group;
	        },

	        _collapseAllExpanded: function (item) {
	            var that = this, children, stopExpand = false;

	            var groups = item.find(GROUPS).add(item.find(CONTENTS));

	            if (groups.is(VISIBLE)) {
	                stopExpand = true;
	            }

	            if (!(groups.is(VISIBLE) || groups.length === 0)) {
	                children = item.siblings();
	                children.find(GROUPS).add(children.find(CONTENTS))
	                        .filter(function () { return $(this).is(VISIBLE); })
	                        .each(function (index, content) {
	                            content = $(content);

	                            stopExpand = that._triggerEvent(COLLAPSE, content.closest(ITEM));
	                            if (!stopExpand) {
	                                that._toggleGroup(content, true);
	                            }
	                        });

	                 that.one("complete", function() {
	                    setTimeout(function() {
	                        children.each(function (index, child) {
	                            var dataItem = that.dataItem(child);

	                            if(dataItem){
	                                dataItem.set("expanded", false);
	                            }
	                        });
	                    });
	                });
	            }

	            return stopExpand;
	        },

	        _ajaxRequest: function (element, contentElement, isVisible) {

	            var that = this,
	                statusIcon = element.find(".k-panelbar-collapse, .k-panelbar-expand"),
	                link = element.find(LINKSELECTOR),
	                loadingIconTimeout = setTimeout(function () {
	                    statusIcon.addClass("k-i-loading");
	                }, 100),
	                data = {},
	                url = link.attr(HREF);

	            $.ajax({
	                type: "GET",
	                cache: false,
	                url: url,
	                dataType: "html",
	                data: data,

	                error: function (xhr, status) {
	                    statusIcon.removeClass("k-i-loading");
	                    if (that.trigger(ERROR, { xhr: xhr, status: status })) {
	                        this.complete();
	                    }
	                },

	                complete: function () {
	                    clearTimeout(loadingIconTimeout);
	                    statusIcon.removeClass("k-i-loading");
	                },

	                success: function (data) {
	                    function getElements(){
	                        return { elements: contentElement.get() };
	                    }
	                    try {
	                        that.angular("cleanup", getElements);
	                        contentElement.html(data);
	                        that.angular("compile", getElements);
	                    } catch (e) {
	                        var console = window.console;

	                        if (console && console.error) {
	                            console.error(e.name + ": " + e.message + " in " + url);
	                        }
	                        this.error(this.xhr, "error");
	                    }

	                    that._toggleGroup(contentElement, isVisible);

	                    that.trigger(CONTENTLOAD, { item: element[0], contentElement: contentElement[0] });
	                }
	            });
	        },

	        _triggerEvent: function (eventName, element) {
	            var that = this;

	            return that.trigger(eventName, { item: element[0] });
	        },

	        _updateSelected: function(link, skipChange) {
	            var that = this,
	                element = that.element,
	                item = link.parent(ITEM),
	                selected = that._selected,
	                dataItem = that.dataItem(item);

	            if (selected) {
	                selected.removeAttr(ARIA_SELECTED);
	            }

	            that._selected = item.attr(ARIA_SELECTED, true);

	            element.find(selectableItems).removeClass(SELECTEDCLASS);
	            element.find("> ." + HIGHLIGHTCLASS + ", .k-panel > ." + HIGHLIGHTCLASS).removeClass(HIGHLIGHTCLASS);

	            link.addClass(SELECTEDCLASS);
	            link.parentsUntil(element, ITEM).filter(":has(.k-header)").addClass(HIGHLIGHTCLASS);
	            that._current(item[0] ? item : null);
	            if(dataItem){
	                 dataItem.set("selected", true);
	            }

	            if(!skipChange){
	                that.trigger(CHANGE);
	            }
	        },

	        _animations: function(options) {
	            if (options && ("animation" in options) && !options.animation) {
	                options.animation = { expand: { effects: {} }, collapse: { hide: true, effects: {} } };
	            }
	        },

	        renderItem: function (options) {
	            var that = this;
	                options = extend({ panelBar: that, group: {} }, options);

	            var empty = that.templates.empty,
	                item = options.item;

	            return that.templates.item(extend(options, {
	                itemWrapper: that.templates.itemWrapper,
	                renderContent: that.renderContent,
	                arrow: that._hasChildItems(item) || item.content || item.contentUrl ? that.templates.arrow : empty,
	                subGroup: !options.loadOnDemand || item.expanded ? that.renderGroup : empty
	            }, rendering));
	        },

	        renderGroup: function(options) {
	            var that = this;
	            var templates = that.templates || options.panelBar.templates;

	            return templates.group(extend({
	                renderItems: function(options) {
	                    var html = "",
	                        i = 0,
	                        items = options.items,
	                        len = items ? items.length : 0,
	                        group = extend({ length: len }, options.group);

	                    for (; i < len; i++) {
	                        html += options.panelBar.renderItem(extend(options, {
	                            group: group,
	                            item: extend({ index: i }, items[i])
	                        }));
	                    }

	                    return html;
	                }
	            }, options, rendering));
	        },

	        renderContent: function(options) {
	            return options.panelBar.templates.content(extend(options, rendering));
	        }
	    });

	kendo.ui.plugin(PanelBar);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "qio6":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("evD5");
var anObject = __webpack_require__("77Pl");
var getKeys = __webpack_require__("lktj");

module.exports = __webpack_require__("+E39") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "qkKv":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("FeBl");
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ "qo2y":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1380);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FZAa");

/***/ }),

/***/ 1380:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1088) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "selectable",
	    name: "Selectable",
	    category: "framework",
	    depends: [ "core", "userevents" ],
	    advanced: true
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        proxy = $.proxy,
	        abs = Math.abs,
	        ARIASELECTED = "aria-selected",
	        SELECTED = "k-state-selected",
	        ACTIVE = "k-state-selecting",
	        SELECTABLE = "k-selectable",
	        CHANGE = "change",
	        NS = ".kendoSelectable",
	        UNSELECT = "unselect",
	        UNSELECTING = "k-state-unselecting",
	        INPUTSELECTOR = "input,a,textarea,.k-multiselect-wrap,select,button,.k-button>span,.k-button>img,span.k-icon.k-i-arrow-60-down,span.k-icon.k-i-arrow-60-up,label.k-checkbox-label.k-no-text,.k-icon.k-i-collapse,.k-icon.k-i-expand,span.k-numeric-wrap,.k-focusable",
	        msie = kendo.support.browser.msie,
	        supportEventDelegation = false;

	        (function($) {
	            (function() {
	                $('<div class="parent"><span></span></div>')
	                .on("click", ">*", function() {
	                    supportEventDelegation = true;
	                })
	                .find("span")
	                .trigger("click")
	                .end()
	                .off();
	            })();
	        })($);

	    var Selectable = Widget.extend({
	        init: function(element, options) {
	            var that = this,
	                multiple;

	            Widget.fn.init.call(that, element, options);

	            that._marquee = $("<div class='k-marquee'><div class='k-marquee-color'></div></div>");
	            that._lastActive = null;
	            that.element.addClass(SELECTABLE);

	            that.relatedTarget = that.options.relatedTarget;

	            multiple = that.options.multiple;

	            if (this.options.aria && multiple) {
	                that.element.attr("aria-multiselectable", true);
	            }

	            that.userEvents = new kendo.UserEvents(that.element, {
	                global: true,
	                allowSelection: true,
	                filter: (!supportEventDelegation ? "." + SELECTABLE + " " : "") + that.options.filter,
	                tap: proxy(that._tap, that),
	                touchAction: multiple ? "none" : "pan-x pan-y"
	            });

	            if (multiple) {
	                that.userEvents
	                   .bind("start", proxy(that._start, that))
	                   .bind("move", proxy(that._move, that))
	                   .bind("end", proxy(that._end, that))
	                   .bind("select", proxy(that._select, that));
	            }
	        },

	        events: [CHANGE, UNSELECT],

	        options: {
	            name: "Selectable",
	            filter: ">*",
	            inputSelectors: INPUTSELECTOR,
	            multiple: false,
	            relatedTarget: $.noop
	        },

	        _isElement: function(target) {
	            var elements = this.element;
	            var idx, length = elements.length, result = false;

	            target = target[0];

	            for (idx = 0; idx < length; idx ++) {
	                if (elements[idx] === target) {
	                    result = true;
	                    break;
	                }
	            }

	            return result;
	        },

	        _tap: function(e) {
	            var target = $(e.target),
	                that = this,
	                ctrlKey = e.event.ctrlKey || e.event.metaKey,
	                multiple = that.options.multiple,
	                shiftKey = multiple && e.event.shiftKey,
	                selected,
	                whichCode = e.event.which,
	                buttonCode = e.event.button;

	            //in case of hierarchy or right-click
	            if (!that._isElement(target.closest("." + SELECTABLE)) || whichCode && whichCode == 3 || buttonCode && buttonCode == 2) {
	                return;
	            }

	            if (!this._allowSelection(e.event.target)) {
	                return;
	            }

	            selected = target.hasClass(SELECTED);
	            if (!multiple || !ctrlKey) {
	                that.clear();
	            }

	            target = target.add(that.relatedTarget(target));

	            if (shiftKey) {
	                that.selectRange(that._firstSelectee(), target, e);
	            } else {
	                if (selected && ctrlKey) {
	                    that._unselect(target);
	                    that._notify(CHANGE, e);
	                } else {
	                    that.value(target, e);
	                }

	                that._lastActive = that._downTarget = target;
	            }
	        },

	        _start: function(e) {
	            var that = this,
	                target = $(e.target),
	                selected = target.hasClass(SELECTED),
	                currentElement,
	                ctrlKey = e.event.ctrlKey || e.event.metaKey;

	            if (!this._allowSelection(e.event.target)) {
	                return;
	            }

	            that._downTarget = target;

	            //in case of hierarchy
	            if (!that._isElement(target.closest("." + SELECTABLE))) {
	                that.userEvents.cancel();
	                return;
	            }

	            if (that.options.useAllItems) {
	                that._items = that.element.find(that.options.filter);
	            } else {
	                currentElement = target.closest(that.element);
	                that._items = currentElement.find(that.options.filter);
	            }

	            e.sender.capture();

	            that._marquee
	                .appendTo(document.body)
	                .css({
	                    left: e.x.client + 1,
	                    top: e.y.client + 1,
	                    width: 0,
	                    height: 0
	                });

	            if (!ctrlKey) {
	                that.clear();
	            }

	            target = target.add(that.relatedTarget(target));
	            if (selected) {
	                that._selectElement(target, true);
	                if (ctrlKey) {
	                    target.addClass(UNSELECTING);
	                }
	            }
	        },

	        _move: function(e) {
	            var that = this,
	                position = {
	                    left: e.x.startLocation > e.x.location ? e.x.location : e.x.startLocation,
	                    top: e.y.startLocation > e.y.location ? e.y.location : e.y.startLocation,
	                    width: abs(e.x.initialDelta),
	                    height: abs(e.y.initialDelta)
	                };

	            that._marquee.css(position);

	            that._invalidateSelectables(position, (e.event.ctrlKey || e.event.metaKey));

	            e.preventDefault();
	        },

	        _end: function(e) {
	            var that = this;

	            that._marquee.remove();

	            that._unselect(that.element
	                .find(that.options.filter + "." + UNSELECTING))
	                .removeClass(UNSELECTING);


	            var target = that.element.find(that.options.filter + "." + ACTIVE);
	            target = target.add(that.relatedTarget(target));

	            that.value(target, e);
	            that._lastActive = that._downTarget;
	            that._items = null;
	        },

	        _invalidateSelectables: function(position, ctrlKey) {
	            var idx,
	                length,
	                target = this._downTarget[0],
	                items = this._items,
	                related,
	                toSelect;

	            for (idx = 0, length = items.length; idx < length; idx ++) {
	                toSelect = items.eq(idx);
	                related = toSelect.add(this.relatedTarget(toSelect));

	                if (collision(toSelect, position)) {
	                    if(toSelect.hasClass(SELECTED)) {
	                        if(ctrlKey && target !== toSelect[0]) {
	                            related.removeClass(SELECTED).addClass(UNSELECTING);
	                        }
	                    } else if (!toSelect.hasClass(ACTIVE) && !toSelect.hasClass(UNSELECTING)) {
	                        related.addClass(ACTIVE);
	                    }
	                } else {
	                    if (toSelect.hasClass(ACTIVE)) {
	                        related.removeClass(ACTIVE);
	                    } else if(ctrlKey && toSelect.hasClass(UNSELECTING)) {
	                        related.removeClass(UNSELECTING).addClass(SELECTED);
	                    }
	                }
	            }
	        },

	        value: function(val, e) {
	            var that = this,
	                selectElement = proxy(that._selectElement, that);

	            if(val) {
	                val.each(function() {
	                    selectElement(this);
	                });

	                that._notify(CHANGE, e);
	                return;
	            }

	            return that.element.find(that.options.filter + "." + SELECTED);
	        },

	        _firstSelectee: function() {
	            var that = this,
	                selected;

	            if(that._lastActive !== null) {
	                return that._lastActive;
	            }

	            selected = that.value();
	            return selected.length > 0 ?
	                    selected[0] :
	                    that.element.find(that.options.filter)[0];
	        },

	        _selectElement: function(element, preventNotify) {
	            var toSelect = $(element),
	                isPrevented =  !preventNotify && this._notify("select", { element: element });

	            toSelect.removeClass(ACTIVE);
	            if(!isPrevented) {
	                 toSelect.addClass(SELECTED);

	                if (this.options.aria) {
	                    toSelect.attr(ARIASELECTED, true);
	                }
	            }
	        },

	        _notify: function(name, args) {
	            args = args || { };
	            return this.trigger(name, args);
	        },

	        _unselect: function(element) {
	            if (this.trigger(UNSELECT, { element: element})) {
	                return;
	            }

	            element.removeClass(SELECTED);

	            if (this.options.aria) {
	                element.attr(ARIASELECTED, false);
	            }

	            return element;
	        },

	        _select: function(e) {
	            if (this._allowSelection(e.event.target)) {
	                if (!msie || (msie && !$(kendo._activeElement()).is(this.options.inputSelectors))) {
	                    e.preventDefault();
	                }
	            }
	        },

	        _allowSelection: function(target) {
	            if ($(target).is(this.options.inputSelectors)) {
	                this.userEvents.cancel();
	                this._downTarget = null;
	                return false;
	            }

	            return true;
	        },

	        resetTouchEvents: function() {
	            this.userEvents.cancel();
	        },

	        clear: function() {
	            var items = this.element.find(this.options.filter + "." + SELECTED);
	            this._unselect(items);
	        },

	        selectRange: function(start, end, e) {
	            var that = this,
	                idx,
	                tmp,
	                items;

	            that.clear();

	            if (that.element.length > 1) {
	                items = that.options.continuousItems();
	            }

	            if (!items || !items.length) {
	                items = that.element.find(that.options.filter);
	            }

	            start = $.inArray($(start)[0], items);
	            end = $.inArray($(end)[0], items);

	            if (start > end) {
	                tmp = start;
	                start = end;
	                end = tmp;
	            }

	            if (!that.options.useAllItems) {
	                end += that.element.length - 1;
	            }

	            for (idx = start; idx <= end; idx ++ ) {
	                that._selectElement(items[idx]);
	            }

	            that._notify(CHANGE, e);
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            that.element.off(NS);

	            that.userEvents.destroy();

	            that._marquee = that._lastActive = that.element = that.userEvents = null;
	        }
	    });

	    Selectable.parseOptions = function(selectable) {
	        var asLowerString = typeof selectable === "string" && selectable.toLowerCase();

	        return {
	            multiple: asLowerString && asLowerString.indexOf("multiple") > -1,
	            cell: asLowerString && asLowerString.indexOf("cell") > -1
	        };
	    };

	    function collision(element, position) {
	        if (!element.is(":visible")) {
	            return false;
	        }

	        var elementPosition = kendo.getOffset(element),
	            right = position.left + position.width,
	            bottom = position.top + position.height;

	        elementPosition.right = elementPosition.left + kendo._outerWidth(element);
	        elementPosition.bottom = elementPosition.top + kendo._outerHeight(element);

	        return !(elementPosition.left > right||
	            elementPosition.right < position.left ||
	            elementPosition.top > bottom ||
	            elementPosition.bottom < position.top);
	    }

	    kendo.ui.plugin(Selectable);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "qrfa":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1231);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1054:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CRfZ");

/***/ }),

/***/ 1231:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1232), __webpack_require__(1054), __webpack_require__(1233), __webpack_require__(1234) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "filebrowser",
	    name: "FileBrowser",
	    category: "web",
	    description: "",
	    hidden: true,
	    depends: [ "selectable", "listview", "dropdownlist", "upload", "breadcrumb" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        isPlainObject = $.isPlainObject,
	        proxy = $.proxy,
	        extend = $.extend,
	        placeholderSupported = kendo.support.placeholder,
	        browser = kendo.support.browser,
	        isFunction = kendo.isFunction,
	        trimSlashesRegExp = /(^\/|\/$)/g,
	        CHANGE = "change",
	        APPLY = "apply",
	        ERROR = "error",
	        CLICK = "click",
	        NS = ".kendoFileBrowser",
	        SEARCHBOXNS = ".kendoSearchBox",
	        NAMEFIELD = "name",
	        SIZEFIELD = "size",
	        TYPEFIELD = "type",
	        DEFAULTSORTORDER = { field: TYPEFIELD, dir: "asc" },
	        EMPTYTILE = kendo.template('<div class="k-listview-item k-listview-item-empty"><span class="k-file-preview"><span class="k-file-icon k-icon k-i-none"></span></span><span class="k-file-name">${text}</span></div>'),
	        TOOLBARTMPL = '<div class="k-widget k-filebrowser-toolbar k-toolbar k-floatwrap">' +

	                            '# if (showCreate) { #' +
	                                '<button type="button" class="k-button k-icon-button"><span class="k-icon k-i-folder-add"></span></button>' +
	                            '# } #' +

	                            '# if (showUpload) { # ' +
	                                '<div class="k-widget k-upload"><div class="k-button k-button-icontext k-upload-button">' +
	                                    '<span class="k-icon k-i-plus"></span>#=messages.uploadFile#<input type="file" name="file" /></div></div>' +
	                            '# } #' +

	                            '# if (showDelete) { #' +
	                                '<button type="button" class="k-button k-button-icon k-state-disabled"><span class="k-icon k-i-close"></span></button>' +
	                            '# } #' +
	                            '<div class="k-tiles-arrange">' +
	                                '<label>#=messages.orderBy#: <select></select></label>' +
	                            '</div>' +

	                            '<span class="k-toolbar-spacer" />' +

	                            '<input data-role="searchbox" />' +

	                        '</div>';

	    extend(true, kendo.data, {
	        schemas: {
	            "filebrowser": {
	                data: function(data) {
	                    return data.items || data || [];
	                },
	                model: {
	                    id: "name",
	                    fields: {
	                        name: "name",
	                        size: "size",
	                        type: "type"
	                    }
	                }
	            }
	        }
	    });

	    extend(true, kendo.data, {
	        transports: {
	            "filebrowser": kendo.data.RemoteTransport.extend({
	                init: function(options) {
	                    kendo.data.RemoteTransport.fn.init.call(this, $.extend(true, {}, this.options, options));
	                },
	                _call: function(type, options) {
	                    options.data = $.extend({}, options.data, { path: this.options.path() });

	                    if (isFunction(this.options[type])) {
	                        this.options[type].call(this, options);
	                    } else {
	                        kendo.data.RemoteTransport.fn[type].call(this, options);
	                    }
	                },
	                read: function(options) {
	                    this._call("read", options);
	                },
	                create: function(options) {
	                    this._call("create", options);
	                },
	                destroy: function(options) {
	                    this._call("destroy", options);
	                },
	                update: function() {
	                    //updates are handled by the upload
	                },
	                options: {
	                    read: {
	                        type: "POST"
	                    },
	                    update: {
	                        type: "POST"
	                    },
	                    create: {
	                        type: "POST"
	                    },
	                    destroy: {
	                        type: "POST"
	                    }
	                }
	            })
	        }
	    });

	    function bindDragEventWrappers(element, onDragEnter, onDragLeave) {
	        var hideInterval, lastDrag;

	        element
	            .on("dragenter" + NS, function() {
	                onDragEnter();
	                lastDrag = new Date();

	                if (!hideInterval) {
	                    hideInterval = setInterval(function() {
	                        var sinceLastDrag = new Date() - lastDrag;
	                        if (sinceLastDrag > 100) {
	                            onDragLeave();

	                            clearInterval(hideInterval);
	                            hideInterval = null;
	                        }
	                    }, 100);
	                }
	            })
	            .on("dragover" + NS, function() {
	                lastDrag = new Date();
	            });
	    }

	    var offsetTop;
	    if (browser.msie && browser.version < 8) {
	        offsetTop = function (element) {
	            return element.offsetTop;
	        };
	    } else {
	        offsetTop = function (element) {
	            return element.offsetTop - $(element).height();
	        };
	    }

	    function concatPaths(path, name) {
	        if(path === undefined || !path.match(/\/$/)) {
	            path = (path || "") + "/";
	        }
	        return path + name;
	    }

	    function sizeFormatter(value) {
	        if(!value) {
	            return "";
	        }

	        var suffix = " bytes";

	        if (value >= 1073741824) {
	            suffix = " GB";
	            value /= 1073741824;
	        } else if (value >= 1048576) {
	            suffix = " MB";
	            value /= 1048576;
	        } else  if (value >= 1024) {
	            suffix = " KB";
	            value /= 1024;
	        }

	        return Math.round(value * 100) / 100 + suffix;
	    }

	    function fieldName(fields, name) {
	        var descriptor = fields[name];

	        if (isPlainObject(descriptor)) {
	            return descriptor.from || descriptor.field || name;
	        }
	        return descriptor;
	    }

	    var FileBrowser = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            options = options || {};

	            Widget.fn.init.call(that, element, options);

	            that.element.addClass("k-filebrowser");

	            that.element
	                .on(CLICK + NS, ".k-filebrowser-toolbar button:not(.k-state-disabled):has(.k-i-close)", proxy(that._deleteClick, that))
	                .on(CLICK + NS, ".k-filebrowser-toolbar button:not(.k-state-disabled):has(.k-i-folder-add)", proxy(that._addClick, that))
	                .on("keydown" + NS, ".k-listview-item.k-state-selected input", proxy(that._directoryKeyDown, that))
	                .on("blur" + NS, ".k-listview-item.k-state-selected input", proxy(that._directoryBlur, that));

	            that._dataSource();

	            that.refresh();

	            that.path(that.options.path);
	        },

	        options: {
	            name: "FileBrowser",
	            messages: {
	                uploadFile: "Upload",
	                orderBy: "Arrange by",
	                orderByName: "Name",
	                orderBySize: "Size",
	                directoryNotFound: "A directory with this name was not found.",
	                emptyFolder: "Empty Folder",
	                deleteFile: 'Are you sure you want to delete "{0}"?',
	                invalidFileType: "The selected file \"{0}\" is not valid. Supported file types are {1}.",
	                overwriteFile: "A file with name \"{0}\" already exists in the current directory. Do you want to overwrite it?",
	                dropFilesHere: "drop file here to upload",
	                search: "Search"
	            },
	            transport: {},
	            path: "/",
	            fileTypes: "*.*"
	        },

	        events: [ERROR, CHANGE, APPLY],

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            that.dataSource
	                .unbind(ERROR, that._errorHandler);

	            that.element
	                .add(that.list)
	                .add(that.toolbar)
	                .off(NS);

	            kendo.destroy(that.element);
	        },

	        value: function() {
	            var that = this,
	                selected = that._selectedItem(),
	                path,
	                fileUrl = that.options.transport.fileUrl;

	            if (selected && selected.get(TYPEFIELD) === "f") {
	                path = concatPaths(that.path(), selected.get(NAMEFIELD)).replace(trimSlashesRegExp, "");
	                if (fileUrl) {
	                    path = isFunction(fileUrl) ? fileUrl(path) : kendo.format(fileUrl, encodeURIComponent(path));
	                }
	                return path;
	            }
	        },

	        _selectedItem: function() {
	            var listView = this.listView,
	                selected = listView.select();

	            if (selected.length) {
	                return this.dataSource.getByUid(selected.attr(kendo.attr("uid")));
	            }
	        },

	        _toolbar: function() {
	            var that = this,
	                template = kendo.template(TOOLBARTMPL),
	                messages = that.options.messages,
	                arrangeBy = [
	                    { text: messages.orderByName, value: "name" },
	                    { text: messages.orderBySize, value: "size" }
	                ];

	            that.toolbar = $(template({
	                    messages: messages,
	                    showUpload: that.options.transport.uploadUrl,
	                    showCreate: that.options.transport.create,
	                    showDelete: that.options.transport.destroy
	                }))
	                .appendTo(that.element)
	                .find(".k-upload input")
	                .kendoUpload({
	                    multiple: false,
	                    localization: {
	                        dropFilesHere: messages.dropFilesHere
	                    },
	                    async: {
	                        saveUrl: that.options.transport.uploadUrl,
	                        autoUpload: true
	                    },
	                    upload: proxy(that._fileUpload, that),
	                    error: function(e) {
	                        that._error({ xhr: e.XMLHttpRequest, status: "error" });
	                    }
	                }).end();

	            that.upload = that.toolbar
	                .find(".k-upload input")
	                .data("kendoUpload");

	            that.arrangeBy = that.toolbar.find(".k-tiles-arrange select")
	                .kendoDropDownList({
	                    dataSource: arrangeBy,
	                    dataTextField: "text",
	                    dataValueField: "value",
	                    change: function() {
	                        that.orderBy(this.value());
	                    }
	                })
	                .data("kendoDropDownList");

	            that.searchBox = that.toolbar.find("input[data-role='searchbox']")
	                .kendoSearchBox({
	                    label: that.options.messages.search,
	                    change: function() {
	                        that.search(this.value());
	                    }
	                }).data("kendoSearchBox");

	            that._attachDropzoneEvents();
	        },

	        _attachDropzoneEvents: function() {
	            var that = this;

	            if (that.options.transport.uploadUrl) {
	                bindDragEventWrappers($(document.documentElement),
	                    $.proxy(that._dropEnter, that),
	                    $.proxy(that._dropLeave, that)
	                );
	                that._scrollHandler = proxy(that._positionDropzone, that);
	            }
	        },

	        _dropEnter: function() {
	            this._positionDropzone();
	            $(document).on("scroll" + NS, this._scrollHandler);
	        },

	        _dropLeave: function() {
	            this._removeDropzone();
	            $(document).off("scroll" + NS, this._scrollHandler);
	        },

	        _positionDropzone: function() {
	            var that = this,
	                element = that.element,
	                offset = element.offset();

	            that.toolbar.find(".k-dropzone")
	                .addClass("k-filebrowser-dropzone")
	                .offset(offset)
	                .css({
	                    width: element[0].clientWidth,
	                    height: element[0].clientHeight,
	                    lineHeight: element[0].clientHeight + "px"
	                });
	        },

	        _removeDropzone: function() {
	            this.toolbar.find(".k-dropzone")
	                .removeClass("k-filebrowser-dropzone")
	                .css({ width: "", height: "", lineHeight: "", top: "", left: "" });
	        },

	        _deleteClick: function() {
	            var that = this,
	                item = that.listView.select(),
	                message = kendo.format(that.options.messages.deleteFile, item.find(".k-file-name").text());

	            if (item.length && that._showMessage(message, "confirm")) {
	                that.listView.remove(item);
	            }
	        },

	        _addClick: function() {
	            this.createDirectory();
	        },

	        _getFieldName: function(name) {
	            return fieldName(this.dataSource.reader.model.fields, name);
	        },

	        _fileUpload: function(e) {
	            var that = this,
	                options = that.options,
	                fileTypes = options.fileTypes,
	                filterRegExp = new RegExp(("(" + fileTypes.split(",").join(")|(") + ")").replace(/\*\./g , ".*."), "i"),
	                fileName = e.files[0].name,
	                fileSize = e.files[0].size,
	                fileNameField = NAMEFIELD,
	                sizeField = SIZEFIELD,
	                file;

	            if (filterRegExp.test(fileName)) {
	                e.data = { path: that.path() };

	                file = that._createFile(fileName, fileSize);

	                if (!file) {
	                    e.preventDefault();
	                } else {
	                    that.upload.one("success", function(e) {
	                        var model = that._insertFileToList(file);

	                        if(model._override) {
	                            model.set(fileNameField, e.response[that._getFieldName(fileNameField)]);
	                            model.set(sizeField, e.response[that._getFieldName(sizeField)]);

	                            that.listView.dataSource.pushUpdate(model);
	                        }

	                        that._tiles = that.listView.items().filter("[" + kendo.attr("type") + "=f]");
	                    });
	                }
	            } else {
	                e.preventDefault();
	                that._showMessage(kendo.format(options.messages.invalidFileType, fileName, fileTypes));
	            }
	        },

	        _findFile: function(name) {
	            var data = this.dataSource.data(),
	                idx,
	                result,
	                typeField = TYPEFIELD,
	                nameField = NAMEFIELD,
	                length;

	            name = name.toLowerCase();

	            for (idx = 0, length = data.length; idx < length; idx++) {
	                if (data[idx].get(typeField) === "f" &&
	                    data[idx].get(nameField).toLowerCase() === name) {

	                    result = data[idx];
	                    break;
	                }
	            }
	            return result;
	        },

	        _createFile: function(fileName, fileSize) {
	            var that = this,
	                model = {},
	                typeField = TYPEFIELD,
	                file = that._findFile(fileName);

	            if (file) {
	                if (!that._showMessage(kendo.format(that.options.messages.overwriteFile, fileName), "confirm")) {
	                    return null;
	                } else {
	                    file._override = true;
	                    return file;
	                }
	            }

	            model[typeField] = "f";
	            model[NAMEFIELD] = fileName;
	            model[SIZEFIELD] = fileSize;

	            return model;
	        },

	        _insertFileToList: function(model) {
	            var index;
	            if(model._override) {
	                return model;
	            }

	            var dataSource = this.dataSource;
	            var view = dataSource.view();

	            for (var i = 0, length = view.length; i < length; i++) {
	                if (view[i].get(TYPEFIELD) === "f") {
	                    index = i;
	                    break;
	                }
	            }

	            return dataSource.insert(++index, model);
	        },

	        createDirectory: function() {
	            var that = this,
	                idx,
	                length,
	                lastDirectoryIdx = 0,
	                typeField = TYPEFIELD,
	                nameField = NAMEFIELD,
	                view = that.dataSource.data(),
	                name = that._nameDirectory(),
	                model = new that.dataSource.reader.model();

	            for (idx = 0, length = view.length; idx < length; idx++) {
	                if (view[idx].get(typeField) === "d") {
	                    lastDirectoryIdx = idx;
	                }
	            }

	            model.set(typeField, "d");
	            model.set(nameField, name);

	            that.listView.one("dataBound", function() {
	                var selected = that.listView.items()
	                    .filter("[" + kendo.attr("uid") + "=" + model.uid + "]");

	                if (selected.length) {
	                    this.edit(selected);
	                }

	                this.element.scrollTop(selected.attr("offsetTop") - this.element[0].offsetHeight);

	                setTimeout(function() {
	                    that.listView.element.find('.k-edit-item input').select();
	                });
	            })
	            .one("save", function(e) {
	                var value = e.model.get(nameField);

	                if (!value) {
	                    e.model.set(nameField, name);
	                } else {
	                    e.model.set(nameField, that._nameExists(value, model.uid) ? that._nameDirectory() : value);
	                }
	            });

	            that.dataSource.insert(++lastDirectoryIdx, model);
	        },

	        _directoryKeyDown: function(e) {
	            if (e.keyCode == 13) {
	                e.currentTarget.blur();
	            }
	        },

	        _directoryBlur: function() {
	            this.listView.save();
	        },

	        _nameExists: function(name, uid) {
	            var data = this.dataSource.data(),
	                typeField = TYPEFIELD,
	                nameField = NAMEFIELD,
	                idx,
	                length;

	            for (idx = 0, length = data.length; idx < length; idx++) {
	                if (data[idx].get(typeField) === "d" &&
	                    data[idx].get(nameField).toLowerCase() === name.toLowerCase() &&
	                    data[idx].uid !== uid) {
	                    return true;
	                }
	            }
	            return false;
	        },

	        _nameDirectory: function() {
	            var name = "New folder",
	                data = this.dataSource.data(),
	                directoryNames = [],
	                typeField = TYPEFIELD,
	                nameField = NAMEFIELD,
	                candidate,
	                idx,
	                length;

	            for (idx = 0, length = data.length; idx < length; idx++) {
	                if (data[idx].get(typeField) === "d" && data[idx].get(nameField).toLowerCase().indexOf(name.toLowerCase()) > -1) {
	                    directoryNames.push(data[idx].get(nameField));
	                }
	            }

	            if ($.inArray(name, directoryNames) > -1) {
	                idx = 2;

	                do {
	                    candidate = name + " (" + idx + ")";
	                    idx++;
	                } while ($.inArray(candidate, directoryNames) > -1);

	                name = candidate;
	            }

	            return name;
	        },

	        orderBy: function(field) {
	            this.dataSource.sort([
	                { field: TYPEFIELD, dir: "asc" },
	                { field: field, dir: "asc" }
	            ]);
	        },

	        search: function(name) {
	            this.dataSource.filter({
	                field: NAMEFIELD,
	                operator: "contains",
	                value: name
	            });
	        },

	        _content: function() {
	            var that = this;

	            that.list = $('<div class="k-filemanager-listview" />')
	                .appendTo(that.element)
	                .on("dblclick" + NS, ".k-listview-item", proxy(that._dblClick, that));

	            that.listView = new kendo.ui.ListView(that.list, {
	                layout: "flex",
	                flex: {
	                    direction: "row",
	                    wrap: "wrap"
	                },
	                dataSource: that.dataSource,
	                template: that._itemTmpl(),
	                editTemplate: that._editTmpl(),
	                selectable: true,
	                autoBind: false,
	                dataBinding: function(e) {
	                    that.toolbar.find(".k-i-close").parent().addClass("k-state-disabled");

	                    if (e.action === "remove" || e.action === "sync") {
	                        e.preventDefault();
	                        kendo.ui.progress(that.listView.content, false);
	                    }
	                },
	                dataBound: function() {
	                    if (that.dataSource.view().length) {
	                        that._tiles = this.items().filter("[" + kendo.attr("type") + "=f]");
	                    } else {
	                        this.content.append(EMPTYTILE({ text: that.options.messages.emptyFolder }));
	                    }
	                },
	                change: proxy(that._listViewChange, that)
	            });
	        },

	        _dblClick: function(e) {
	            var that = this,
	                li = $(e.currentTarget);

	            if (li.hasClass("k-edit-item")) {
	                that._directoryBlur();
	            }

	            if (li.filter("[" + kendo.attr("type") + "=d]").length) {
	                var folder = that.dataSource.getByUid(li.attr(kendo.attr("uid")));
	                if (folder) {
	                    that.path(concatPaths(that.path(), folder.get(NAMEFIELD)));
	                    that.breadcrumbs.value("/" + that.path());
	                }
	            } else if (li.filter("[" + kendo.attr("type") + "=f]").length) {
	                that.trigger(APPLY);
	            }
	        },

	        _listViewChange: function() {
	            var selected = this._selectedItem();

	            if (selected) {
	                this.toolbar.find(".k-i-close").parent().removeClass("k-state-disabled");
	                this.trigger(CHANGE, { selected: selected });
	            }
	        },

	        _dataSource: function() {
	            var that = this,
	                options = that.options,
	                transport = options.transport,
	                typeSortOrder = extend({}, DEFAULTSORTORDER),
	                nameSortOrder = { field: NAMEFIELD, dir: "asc" },
	                schema,
	                dataSource = {
	                    type: transport.type || "filebrowser",
	                    sort: [typeSortOrder, nameSortOrder]
	                };

	            if (isPlainObject(transport)) {
	                transport.path = proxy(that.path, that);
	                dataSource.transport = transport;
	            }

	            if (isPlainObject(options.schema)) {
	                dataSource.schema = options.schema;
	            } else if (transport.type && isPlainObject(kendo.data.schemas[transport.type])) {
	                schema = kendo.data.schemas[transport.type];
	            }

	            if (that.dataSource && that._errorHandler) {
	                that.dataSource.unbind(ERROR, that._errorHandler);
	            } else {
	                that._errorHandler = proxy(that._error, that);
	            }

	            that.dataSource = kendo.data.DataSource.create(dataSource)
	                .bind(ERROR, that._errorHandler);
	        },

	        _navigation: function() {
	            var that = this,
	                navigation = $('<div class="k-floatwrap"><nav></nav></div>')
	                    .appendTo(this.element);

	            that.breadcrumbs = navigation.find("nav:first")
	                    .kendoBreadcrumb({
	                        editable: true,
	                        gap: 50,
	                        value: that.options.path || "/",
	                        change: function() {
	                            that.path(this.value());
	                        }
	                    }).data("kendoBreadcrumb");
	        },

	        _error: function(e) {
	            var that = this,
	                status;

	            if (!that.trigger(ERROR, e)) {
	                status = e.xhr.status;

	                if (e.status == 'error') {
	                    if (status == '404') {
	                        that._showMessage(that.options.messages.directoryNotFound);
	                    } else if (status != '0') {
	                        that._showMessage('Error! The requested URL returned ' + status + ' - ' + e.xhr.statusText);
	                    }
	                } else if (status == 'timeout') {
	                    that._showMessage('Error! Server timeout.');
	                }

	                var dataSource = that.dataSource;
	                if (dataSource.hasChanges()) {
	                    dataSource.cancelChanges();
	                }
	            }
	        },

	        _showMessage: function(message, type) {
	            return window[type || "alert"](message);
	        },

	        refresh: function() {
	            var that = this;
	            that._navigation();
	            that._toolbar();
	            that._content();
	        },

	        _editTmpl: function() {
	            var html = '<div class="k-listview-item k-state-selected" ' + kendo.attr("uid") + '="#=uid#" ';

	            html += kendo.attr("type") + '="${' + TYPEFIELD + '}">';
	            html += '#if(' + TYPEFIELD + ' == "d") { #';
	            html += '<div class="k-file-preview"><span class="k-file-icon k-icon k-i-folder"></span></div>';
	            html += "#}else{#";
	            html += '<div class="k-file-preview"><span class="k-file-icon k-icon k-i-loading"></span></div>';
	            html += "#}#";
	            html += '#if(' + TYPEFIELD + ' == "d") { #';
	            html += '<span class="k-file-name"><input class="k-textbox" ' + kendo.attr("bind") + '="value:' + NAMEFIELD + '"/></span>';
	            html += "#}#";
	            html += '</div>';

	            return proxy(kendo.template(html), { sizeFormatter: sizeFormatter } );
	        },

	        _itemTmpl: function() {
	            var html = '<div class="k-listview-item" ' + kendo.attr("uid") + '="#=uid#" ';

	            html += kendo.attr("type") + '="${' + TYPEFIELD + '}">';
	            html += '#if(' + TYPEFIELD + ' == "d") { #';
	            html += '<div class="k-file-preview"><span class="k-file-icon k-icon k-i-folder"></span></div>';
	            html += "#}else{#";
	            html += '<div class="k-file-preview"><span class="k-file-icon k-icon k-i-file"></span></div>';
	            html += "#}#";
	            html += '<span class="k-file-name">${' + NAMEFIELD + '}</span>';
	            html += '#if(' + TYPEFIELD + ' == "f") { # <span class="k-file-size">${this.sizeFormatter(' + SIZEFIELD + ')}</span> #}#';
	            html += '</div>';

	            return proxy(kendo.template(html), { sizeFormatter: sizeFormatter } );
	        },

	        path: function(value) {
	            var that = this,
	                path = that._path || "";

	            if (value !== undefined) {
	                that._path = value.replace(trimSlashesRegExp, "") + "/";
	                that.dataSource.read({ path: that._path });
	                return;
	            }

	            if (path) {
	                path = path.replace(trimSlashesRegExp, "");
	            }

	            return path === "/" || path === "" ? "" : (path + "/");
	        }
	    });

	    var SearchBox = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            options = options || {};

	            Widget.fn.init.call(that, element, options);

	            if (placeholderSupported) {
	                that.element.attr("placeholder", that.options.label);
	            }

	            that._wrapper();

	            that.element
	                .on("keydown" + SEARCHBOXNS, proxy(that._keydown, that))
	                .on("change" + SEARCHBOXNS, proxy(that._updateValue, that));

	            that.wrapper
	                .on(CLICK + SEARCHBOXNS, "a", proxy(that._click, that));

	            if (!placeholderSupported) {
	                that.element.on("focus" + SEARCHBOXNS, proxy(that._focus, that))
	                    .on("blur" + SEARCHBOXNS, proxy(that._blur, that));
	            }
	        },

	        options: {
	            name: "SearchBox",
	            label: "Search",
	            value: ""
	        },

	        events: [ CHANGE ],

	        destroy: function() {
	            var that = this;

	            that.wrapper
	                .add(that.element)
	                .add(that.label)
	                .off(SEARCHBOXNS);

	            Widget.fn.destroy.call(that);
	        },

	        _keydown: function(e) {
	            if (e.keyCode === 13) {
	                this._updateValue();
	            }
	        },

	        _click: function(e) {
	            e.preventDefault();
	            this._updateValue();
	        },

	        _updateValue: function() {
	            var that = this,
	                value = that.element.val();

	            if (value !== that.value()) {
	                that.value(value);

	                that.trigger(CHANGE);
	            }
	        },

	        _blur: function() {
	            this._updateValue();
	            this._toggleLabel();
	        },

	        _toggleLabel: function() {
	            if (!placeholderSupported) {
	                this.label.toggle(!this.element.val());
	            }
	        },

	        _focus: function() {
	            this.label.hide();
	        },

	        _wrapper: function() {
	            var element = this.element,
	                wrapper = element.parents(".k-search-wrap");

	            element[0].style.width = "";
	            element.addClass("k-input");

	            if (!wrapper.length) {
	                wrapper = element.wrap($('<div class="k-widget k-search-wrap k-textbox"/>')).parent();
	                if (!placeholderSupported) {
	                    $('<label style="display:block">' + this.options.label + '</label>').insertBefore(element);
	                }
	                $('<a href="#" class="k-icon k-i-zoom k-search"/>').appendTo(wrapper);
	            }

	            this.wrapper = wrapper;
	            this.label = wrapper.find(">label");
	        },

	        value: function(value) {
	            var that = this;

	            if (value !== undefined) {
	                that.options.value = value;
	                that.element.val(value);
	                that._toggleLabel();
	                return;
	            }
	            return that.options.value;
	        }
	    });

	    kendo.ui.plugin(FileBrowser);
	    kendo.ui.plugin(SearchBox);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1232:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("wIIu");

/***/ }),

/***/ 1233:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("o4s/");

/***/ }),

/***/ 1234:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("9BzU");

/***/ })

/******/ });

/***/ }),

/***/ "qyJz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("+ZMJ");
var $export = __webpack_require__("kM2E");
var toObject = __webpack_require__("sB3e");
var call = __webpack_require__("msXi");
var isArrayIter = __webpack_require__("Mhyx");
var toLength = __webpack_require__("QRG4");
var createProperty = __webpack_require__("fBQ2");
var getIterFn = __webpack_require__("3fs2");

$export($export.S + $export.F * !__webpack_require__("dY0y")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "rQ4N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        popupAppendTo: {
            type: String,
            default: undefined,
            kComposite: 'popup.appendTo'
        },
        popupOrigin: {
            type: String,
            default: undefined,
            kComposite: 'popup.origin'
        },
        popupPosition: {
            type: String,
            default: undefined,
            kComposite: 'popup.position'
        }
    }
};

/***/ }),

/***/ "rS7A":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1101);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1101:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "data.xml",
	    name: "XML",
	    category: "framework",
	    depends: [ "core" ],
	    hidden: true
	};

	/*jshint  eqnull: true, boss: true */
	(function($, undefined) {
	    var kendo = window.kendo,
	        isArray = $.isArray,
	        isPlainObject = $.isPlainObject,
	        map = $.map,
	        each = $.each,
	        extend = $.extend,
	        getter = kendo.getter,
	        Class = kendo.Class;

	    var XmlDataReader = Class.extend({
	        init: function(options) {
	            var that = this,
	                total = options.total,
	                model = options.model,
	                parse = options.parse,
	                errors = options.errors,
	                serialize = options.serialize,
	                data = options.data;

	            if (model) {
	                if (isPlainObject(model)) {
	                    var base = options.modelBase || kendo.data.Model;

	                    if (model.fields) {
	                        each(model.fields, function(field, value) {
	                            if (isPlainObject(value) && value.field) {
	                                if (!$.isFunction(value.field)) {
	                                    value = extend(value, { field: that.getter(value.field) });
	                                }
	                            } else {
	                                value = { field: that.getter(value) };
	                            }
	                            model.fields[field] = value;
	                        });
	                    }

	                    var id = model.id;
	                    if (id) {
	                        var idField = {};

	                        idField[that.xpathToMember(id, true)] = { field : that.getter(id) };
	                        model.fields = extend(idField, model.fields);
	                        model.id = that.xpathToMember(id);
	                    }
	                    model = base.define(model);
	                }

	                that.model = model;
	            }

	            if (total) {
	                if (typeof total == "string") {
	                    total = that.getter(total);
	                    that.total = function(data) {
	                        return parseInt(total(data), 10);
	                    };
	                } else if (typeof total == "function"){
	                    that.total = total;
	                }
	            }

	            if (errors) {
	                if (typeof errors == "string") {
	                    errors = that.getter(errors);
	                    that.errors = function(data) {
	                        return errors(data) || null;
	                    };
	                } else if (typeof errors == "function"){
	                    that.errors = errors;
	                }
	            }

	            if (data) {
	                if (typeof data == "string") {
	                    data = that.xpathToMember(data);
	                    that.data = function(value) {
	                        var result = that.evaluate(value, data),
	                            modelInstance;

	                        result = isArray(result) ? result : [result];

	                        if (that.model && model.fields) {
	                            modelInstance = new that.model();

	                            return map(result, function(value) {
	                                if (value) {
	                                    var record = {}, field;

	                                    for (field in model.fields) {
	                                        record[field] = modelInstance._parse(field, model.fields[field].field(value));
	                                    }

	                                    return record;
	                                }
	                            });
	                        }

	                        return result;
	                    };
	                } else if (typeof data == "function") {
	                    that.data = data;
	                }
	            }

	            if (typeof parse == "function") {
	                var xmlParse = that.parse;

	                that.parse = function(data) {
	                    var xml = parse.call(that, data);
	                    return xmlParse.call(that, xml);
	                };
	            }

	            if (typeof serialize == "function") {
	                that.serialize = serialize;
	            }
	        },
	        total: function(result) {
	            return this.data(result).length;
	        },
	        errors: function(data) {
	            return data ? data.errors : null;
	        },
	        serialize: function(data) {
	            return data;
	        },
	        parseDOM: function(element) {
	            var result = {},
	                parsedNode,
	                node,
	                nodeType,
	                nodeName,
	                member,
	                attribute,
	                attributes = element.attributes,
	                attributeCount = attributes.length,
	                idx;

	            for (idx = 0; idx < attributeCount; idx++) {
	                attribute = attributes[idx];
	                result["@" + attribute.nodeName] = attribute.nodeValue;
	            }

	            for (node = element.firstChild; node; node = node.nextSibling) {
	                nodeType = node.nodeType;

	                if (nodeType === 3 || nodeType === 4) {
	                    // text nodes or CDATA are stored as #text field
	                    result["#text"] = node.nodeValue;
	                } else if (nodeType === 1) {
	                    // elements are stored as fields
	                    parsedNode = this.parseDOM(node);

	                    nodeName = node.nodeName;

	                    member = result[nodeName];

	                    if (isArray(member)) {
	                        // elements of same nodeName are stored as array
	                        member.push(parsedNode);
	                    } else if (member !== undefined) {
	                        member = [member, parsedNode];
	                    } else {
	                        member = parsedNode;
	                    }

	                    result[nodeName] = member;
	                }
	            }
	            return result;
	        },

	        evaluate: function(value, expression) {
	            var members = expression.split("."),
	                member,
	                result,
	                length,
	                intermediateResult,
	                idx;

	            while (member = members.shift()) {
	                value = value[member];

	                if (isArray(value)) {
	                    result = [];
	                    expression = members.join(".");

	                    for (idx = 0, length = value.length; idx < length; idx++) {
	                        intermediateResult = this.evaluate(value[idx], expression);

	                        intermediateResult = isArray(intermediateResult) ? intermediateResult : [intermediateResult];

	                        result.push.apply(result, intermediateResult);
	                    }

	                    return result;
	                }
	            }

	            return value;
	        },

	        parse: function(xml) {
	            var documentElement,
	                tree,
	                result = {};

	            documentElement = xml.documentElement || $.parseXML(xml).documentElement;

	            tree = this.parseDOM(documentElement);

	            result[documentElement.nodeName] = tree;

	            return result;
	        },

	        xpathToMember: function(member, raw) {
	            if (!member) {
	                return "";
	            }

	            member = member.replace(/^\//, "") // remove the first "/"
	                           .replace(/\//g, "."); // replace all "/" with "."

	            if (member.indexOf("@") >= 0) {
	                // replace @attribute with '["@attribute"]'
	                return member.replace(/\.?(@.*)/, raw? '$1':'["$1"]');
	            }

	            if (member.indexOf("text()") >= 0) {
	                // replace ".text()" with '["#text"]'
	                return member.replace(/(\.?text\(\))/, raw? '#text':'["#text"]');
	            }

	            return member;
	        },
	        getter: function(member) {
	            return getter(this.xpathToMember(member), true);
	        }
	    });

	    $.extend(true, kendo.data, {
	        XmlDataReader: XmlDataReader,
	        readers: {
	            xml: XmlDataReader
	        }
	    });
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "rVYJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var componentMetadataProvider_1 = __webpack_require__("djkc");
var utils_1 = __webpack_require__("IRr6");
var AgComponentUtils = (function () {
    function AgComponentUtils() {
    }
    AgComponentUtils.prototype.adaptFunction = function (propertyName, hardcodedJsFunction, type, source) {
        if (hardcodedJsFunction == null)
            return {
                component: null,
                type: type,
                source: source,
                dynamicParams: null
            };
        var metadata = this.componentMetadataProvider.retrieve(propertyName);
        if (metadata && metadata.functionAdapter) {
            return {
                type: type,
                component: metadata.functionAdapter(hardcodedJsFunction),
                source: source,
                dynamicParams: null
            };
        }
        return null;
    };
    AgComponentUtils.prototype.adaptCellRendererFunction = function (callback) {
        var Adapter = (function () {
            function Adapter() {
            }
            Adapter.prototype.refresh = function (params) {
                return false;
            };
            Adapter.prototype.getGui = function () {
                var callbackResult = callback(this.params);
                if (typeof callbackResult != 'string')
                    return callbackResult;
                return utils_1._.loadTemplate('<span>' + callbackResult + '</span>');
            };
            Adapter.prototype.init = function (params) {
                this.params = params;
            };
            return Adapter;
        }());
        return Adapter;
    };
    AgComponentUtils.prototype.doesImplementIComponent = function (candidate) {
        if (!candidate)
            return false;
        return candidate.prototype && 'getGui' in candidate.prototype;
    };
    __decorate([
        context_1.Autowired("componentMetadataProvider"),
        __metadata("design:type", componentMetadataProvider_1.ComponentMetadataProvider)
    ], AgComponentUtils.prototype, "componentMetadataProvider", void 0);
    AgComponentUtils = __decorate([
        context_1.Bean("agComponentUtils")
    ], AgComponentUtils);
    return AgComponentUtils;
}());
exports.AgComponentUtils = AgComponentUtils;


/***/ }),

/***/ "rYKI":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1235);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1190:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("JKVm");

/***/ }),

/***/ 1233:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("o4s/");

/***/ }),

/***/ 1234:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("9BzU");

/***/ }),

/***/ 1235:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1240),
	        __webpack_require__(1237),
	        __webpack_require__(1238),
	        __webpack_require__(1239),
	        __webpack_require__(1236),

	        __webpack_require__(1234),
	        __webpack_require__(1233),
	        __webpack_require__(1241),
	        __webpack_require__(1190)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "filemanager",
	    name: "FileManager",
	    category: "web",
	    description: "The FileManager widget displays offers file management functionality.",
	    depends: [ "core", "data", "listview", "toolbar", "breadcrumb", "menu", "treeview", "upload", "dialog", "switch", "resizable", "selectable", "editable" ],
	    features: [{
	        id: "filemanager-grid-view",
	        name: "GridView",
	        description: "Support for GridView",
	        depends: [ "grid" ]
	    }]
	};

	(function($, undefined) {
	    var ui = kendo.ui,
	        extend = $.extend,
	        isPlainObject = $.isPlainObject,
	        isArray = $.isArray,
	        DataBoundWidget = ui.DataBoundWidget,
	        proxy = $.proxy,
	        template = kendo.template,
	        outerHeight = kendo._outerHeight,

	        NAVIGATE = "navigate",
	        SELECT = "select",
	        OPEN = "open",
	        ERROR = "error",
	        CHANGE = "change",
	        UPLOAD = "upload",
	        SUCCESS = "success",
	        CLOSE = "close",
	        HIDE = "hide",
	        LOAD = "load",
	        DATABINDING = "dataBinding",
	        DATABOUND = "dataBound",
	        DROP = "drop",
	        EXECUTE = "execute",
	        COMMAND = "command",
	        KEYDOWNACTION = "keydownAction",
	        CANCEL = "cancel",

	        TREE_TYPE = "tree",
	        DOT = ".";

	    var fileManagerStyles = {
	        wrapper: "k-widget k-filemanager",
	        header: "k-filemanager-header",
	        navigation: "k-filemanager-navigation",
	        contentContainer: "k-filemanager-content-container",
	        content: "k-filemanager-content",
	        preview: "k-filemanager-preview",
	        toolbar: "k-filemanager-toolbar",
	        treeview: "k-filemanager-treeview",
	        breadcrumb: "k-filemanager-breadcrumb",
	        view: "k-filemanager-view",
	        grid: "k-filemanager-grid",
	        list: "k-filemanager-listview",
	        upload: "k-filemanager-upload",
	        uploadDialog: "k-filemanager-upload-dialog",
	        splitBar: "k-splitbar",
	        splitBarHorizontal: "k-splitbar-horizontal k-splitbar-draggable-horizontal",
	        splitBarHover: "k-splitbar-horizontal-hover",
	        splitBarIcon: "k-icon k-resize-handle",
	        splitBarNavigation: "k-filemanager-splitbar-navigation",
	        splitBarPreview: "k-filemanager-splitbar-preview",
	        resizable: "k-filemanager-resizable"
	    };

	    var fileManagerTemplateStyles = {
	        filePreview: "k-file-preview",
	        fileInfo: "k-file-info",
	        fileName: "k-file-name",
	        fileMeta: "k-file-meta",
	        metaLabel: "k-file-meta-label",
	        metaValue: "k-file-meta-value",
	        extension: "k-file-type",
	        size: "k-file-size",
	        created: "k-file-created",
	        modified: "k-file-modified"
	    };

	    var viewTypes = {
	        grid: "grid",
	        list: "list"
	    };

	    var NO_FILE_PREVIEW_TEMPLATE = '' +
	        '<div class="#:styles.fileInfo#">' +
	            '<div class="#:styles.filePreview#">' +
	                '<span class="k-file-icon k-icon k-i-none"></span>' +
	            '</div>' +
	            '<span class="#:styles.fileName#" k-no-file-selected>#: messages.noFileSelected #</span>' +
	        '</div>';

	    var SINGLE_FILES_PREVIEW_TEMPLATE = '' +
	        '<div class="#:styles.fileInfo#">' +
	            '<div class="#:styles.filePreview#">' +
	                '<span class="k-file-icon k-icon k-i-#: !selection[0].isDirectory ? kendo.getFileGroup(selection[0].extension, true) : "folder" #"></span>' +
	            '</div>' +
	            '<span class="#:styles.fileName#">#:selection[0].name#</span>' +
	            '#if(metaFields){#' +
	                '<dl class="#:styles.fileMeta#">'+
	                    '#for(var i = 0; i < metaFields.length; i+=1){#' +
	                        '#var field = metaFields[i]#' +
	                        '<dt class="#:styles.metaLabel#">#:messages[field]#: </dt>' +
	                        '<dd class="#:styles.metaValue# #:styles[field]#">' +
	                            '#if(field == "size"){#' +
	                                ' #:kendo.getFileSizeMessage(selection[0][field])#' +
	                            '#} else if(selection[0][field] instanceof Date) {#' +
	                                ' #:kendo.toString(selection[0][field], "G")#' +
	                            '#} else if(field == "extension") {#' +
	                                ' #: !selection[0].isDirectory ? kendo.getFileGroup(selection[0].extension) : "folder"#' +
	                            '#} else {#' +
	                                ' #:selection[0][field]#' +
	                            '#}#' +
	                        '</dd>'+
	                        '<dd class="k-line-break"></dd>' +
	                    '# } #' +
	                '</dl>' +
	            '#}#' +
	        '</div>';

	    var MULTIPLE_FILES_PREVIEW_TEMPLATE = '' +
	        '<div class="#:styles.fileInfo#">' +
	            '<div class="#:styles.filePreview#">' +
	                '<span class="k-file-icon k-icon k-i-file"></span>' +
	            '</div>' +
	            '<span class="#:styles.fileName#">' +
	                '#:selection.length# ' +
	                '#:messages.items#' +
	            '</span>' +
	        '</div>';

	    var FileManager = DataBoundWidget.extend({
	        init: function(element, options) {
	            var that = this;

	            DataBoundWidget.fn.init.call(that, element, options);

	            that.options = kendo.deepExtend({}, that.options, options);

	            that.defaultSortOption = { field: "name", dir: "asc" };
	            that.folderSortOption = { field: "isDirectory", dir: "desc" };

	            that._commandStack = new ui.filemanager.CommandStack();

	            that._dataSource();

	            that._wrapper();

	            that._renderHeader();

	            that._renderContentContainer();

	            that._initContextMenu();

	            that._renderNavigation();

	            that._renderContent();

	            that._renderPreview();

	            that._initUploadDialog();

	            that._resizable();

	            that.resize();

	            kendo.notify(that, kendo.ui);
	        },

	        options: {
	            name: "FileManager",
	            height: 500,
	            resizable: true,
	            initialView: viewTypes.list,
	            toolbar: {
	                resizable: true
	            },
	            contextMenu: {},
	            upload: {},
	            uploadUrl: "",
	            views: {},
	            breadcrumb: {},
	            draggable: true,
	            dialogs: {
	                upload: {
	                    width: 530
	                },
	                moveConfirm: {
	                    width: 350,
	                    closable: true
	                },
	                deleteConfirm: {
	                    width: 360,
	                    closable: true
	                },
	                renamePrompt: {
	                    width: 350,
	                    closable: true
	                }
	            },
	            previewPane: {
	                metaFields: ["extension", "size", "created", "modified"],
	                noFileTemplate: NO_FILE_PREVIEW_TEMPLATE,
	                singleFileTemplate: SINGLE_FILES_PREVIEW_TEMPLATE,
	                multipleFilesTemplate: MULTIPLE_FILES_PREVIEW_TEMPLATE
	            },
	            messages: {
	                toolbar: {
	                    createFolder: "New Folder",
	                    upload: "Upload",
	                    sortDirection: "Sort Direction",
	                    sortDirectionAsc: "Sort Direction Ascending",
	                    sortDirectionDesc: "Sort Direction Descending",
	                    sortField: "Sort By",
	                    nameField: "Name",
	                    sizeField: "File Size",
	                    typeField: "Type",
	                    dateModifiedField: "Date Modified",
	                    dateCreatedField: "Date Created",
	                    listView: "List View",
	                    gridView: "Grid View",
	                    search: "Search",
	                    details: "View Details",
	                    detailsChecked: "On",
	                    detailsUnchecked: "Off",
	                    "delete": "Delete",
	                    rename: "Rename"
	                },
	                views: {
	                    nameField: "Name",
	                    sizeField: "File Size",
	                    typeField: "Type",
	                    dateModifiedField: "Date Modified",
	                    dateCreatedField: "Date Created",
	                    items: "items"
	                },
	                dialogs: {
	                    upload: {
	                        title: "Upload Files",
	                        clear: "Clear List",
	                        done: "Done"
	                    },
	                    moveConfirm: {
	                        title: "Confirm",
	                        content: "<p style='text-align: center;'>Do you want to move or copy?</p>",
	                        okText: "Copy",
	                        cancel: "Move",
	                        close: "close"
	                    },
	                    deleteConfirm: {
	                        title: "Confirm",
	                        content: "<p style='text-align: center;'>Are you sure you want to delete the selected file(s)?</br>You cannot undo this action.</p>",
	                        okText: "Delete",
	                        cancel: "Cancel",
	                        close: "close"
	                    },
	                    renamePrompt: {
	                        title: "Prompt",
	                        content: "<p style='text-align: center;'>Enter new name for the file.</p>",
	                        okText: "Rename",
	                        cancel: "Cancel",
	                        close: "close"
	                    }
	                },
	                previewPane: {
	                    noFileSelected: "No File Selected",
	                    extension: "Type",
	                    size: "Size",
	                    created: "Date Created",
	                    createdUtc: "Date Created UTC",
	                    modified: "Date Modified",
	                    modifiedUtc: "Date Modified UTC",
	                    items: "items"
	                }
	            }
	        },

	        events: [
	            NAVIGATE,
	            SELECT,
	            OPEN,
	            DATABINDING,
	            DATABOUND,
	            ERROR,
	            DROP,
	            EXECUTE,
	            COMMAND
	        ],

	        _dataSource: function () {
	            var that = this,
	                options = that.options,
	                dataSourceOptions = options.dataSource || {},
	                typeSortOrder = that.folderSortOption,
	                nameSortOrder = that.defaultSortOption,
	                dataSource;

	            if (!(dataSourceOptions instanceof kendo.data.FileManagerDataSource)) {
	                if(isArray(dataSourceOptions)){
	                    dataSource = {
	                        data: dataSourceOptions,
	                        autoSync: false,
	                        sort: [typeSortOrder, nameSortOrder]
	                     };
	                } else {
	                    dataSource = extend(true, dataSourceOptions, {
	                        autoSync: false,
	                        sort: [typeSortOrder, nameSortOrder]
	                    });
	                }

	                if (dataSourceOptions && isPlainObject(dataSourceOptions.schema)) {
	                    dataSource.schema = dataSourceOptions.schema;
	                } else if (isPlainObject(kendo.data.schemas.filemanager)) {
	                    dataSource.schema = kendo.data.schemas.filemanager;
	                }
	            } else {
	                dataSource = dataSourceOptions;
	            }

	            if (that.dataSource && that._errorHandler) {
	                that.dataSource.unbind(ERROR, that._errorHandler);
	                that.dataSource.unbind(CHANGE, that._changeHandler);
	            } else {
	                that._errorHandler = proxy(that._error, that);
	                that._changeHandler = proxy(that._change, that);
	            }

	            that.dataSource = kendo.data.FileManagerDataSource.create(dataSource)
	                .bind(ERROR, that._errorHandler)
	                .bind(CHANGE, that._changeHandler);
	        },

	        _error: function (ev) {
	            if(!this.trigger(ERROR, ev)) {
	                window.console.warn('Error! The requested URL returned ' + ev.xhr.status + ' - ' + ev.xhr.statusText);
	            }
	        },

	        _wrapper: function() {
	            var that = this,
	                options = that.options,
	                width = options.width,
	                height = options.height;

	            that.wrapper = that.element
	                .addClass(fileManagerStyles.wrapper);

	            if (width) {
	                that.wrapper.width(width);
	            }

	            if (height) {
	                that.wrapper.height(height);
	            }

	            that._resizeHandler = kendo.onResize(function() {
	                that.resize(true);
	            });
	        },

	        _renderHeader: function () {
	            var that = this,
	                options = that.options;

	            if (options.toolbar) {
	                that.header = $("<div />").addClass(fileManagerStyles.header);
	                that.header.append(that._initToolbar().element);
	            }

	            that.wrapper.append(that.header);
	        },

	        _renderContentContainer: function() {
	            var that = this,
	                container = $("<div />").addClass(fileManagerStyles.contentContainer);

	            that.contentContainer = container;

	            that.wrapper.append(that.contentContainer);
	        },

	        _initContextMenu: function(){
	            var that = this,
	                options = that.options,
	                menuOptions = extend({}, options.contextMenu, {
	                    filemanager: that,
	                    messages: options.messages.toolbar,
	                    target: that.contentContainer,
	                    filter: "[data-uid]",
	                    action: that.executeCommand.bind(that),
	                    isLocalBinding: that.dataSource.isLocalBinding
	                });

	            if(options.contextMenu === false) {
	                return;
	            }

	            that.contextMenu = new ui.filemanager.ContextMenu("<ul></ul>", menuOptions);

	            that.contextMenu.bind(OPEN, proxy(that._cacheFocus, that));
	        },

	        _renderNavigation: function() {
	            var that = this;

	            that.navigation = $("<div />").addClass(fileManagerStyles.navigation);
	            that.navigation.append(that._initTreeView().element);

	            that.contentContainer.append(that.navigation);
	        },

	        _renderContent: function() {
	            var that = this,
	                options = that.options,
	                toolbar = that.toolbar;

	            that.content = $("<div />").addClass(fileManagerStyles.content);

	            if (options.breadcrumb) {
	                that.content.append(that._initBreadcrumb().element);
	            }

	            that.content.append(that._initView());

	            if (!toolbar || !toolbar.isToolEnabled(toolbar.defaultTools.upload.name)) {
	                that.content.append(that._initUpload().wrapper.hide());
	            }

	            that.contentContainer.append(that.content);
	        },

	        _renderPreview: function() {
	            var that = this,
	                enablePreview = that.options.previewPane;

	            if (!enablePreview) {
	               return;
	            }

	            that.preview = $("<div />").addClass(fileManagerStyles.preview);
	            that.previewContainer = $("<div />").addClass(fileManagerStyles.previewContainer);
	            that.preview.append(that.previewContainer);

	            that._setPreviewPaneContent();

	            that.contentContainer.append(that.preview.hide());
	        },

	        _setPreviewPaneContent: function() {
	            var that = this,
	                options = that.options,
	                previewPaneMessages = options.messages.previewPane,
	                previewPaneOptions = options.previewPane,
	                selection = that.getSelected(),
	                previewTemplate;

	            if (!selection) {
	                previewTemplate = template(previewPaneOptions.noFileTemplate)({
	                    styles: fileManagerTemplateStyles,
	                    messages: previewPaneMessages
	                });

	                that.previewContainer.html(previewTemplate);
	                return;
	            }

	            previewTemplate = selection.length === 1 ?
	                previewPaneOptions.singleFileTemplate :
	                previewPaneOptions.multipleFilesTemplate;

	            previewTemplate = template(previewTemplate)({
	                styles: fileManagerTemplateStyles,
	                messages: previewPaneMessages,
	                selection: selection,
	                metaFields: previewPaneOptions.metaFields
	            });

	            that.previewContainer.html(previewTemplate);
	        },

	        _initToolbar: function () {
	            var that = this,
	                options = that.options,
	                toolbarElement = $("<div />").addClass(fileManagerStyles.toolbar),
	                toolbarOptions = extend({}, options.toolbar, {
	                    filemanager: this,
	                    messages: options.messages.toolbar,
	                    action: that.executeCommand.bind(that)
	                });

	            that.toolbar = new ui.filemanager.ToolBar(toolbarElement, toolbarOptions);

	            return that.toolbar;
	        },

	        _initTreeView: function() {
	            var that = this,
	                treeViewElement = $("<div />").addClass(fileManagerStyles.treeview),
	                options = that.options.views[TREE_TYPE],
	                explicitOptions = extend(true, {}, {
	                    dataSource: that.options.dataSource,
	                    messages: that.options.messages.views,
	                    draggable: that.options.draggable,
	                    isLocalBinding: that.dataSource.isLocalBinding
	                });

	            that.treeView = new ui.filemanager.ViewComponents[TREE_TYPE](treeViewElement, options, explicitOptions);

	            that.treeView.bind(NAVIGATE, proxy(that._navigate, that))
	                         .bind(LOAD, proxy(that._load, that))
	                         .bind(DROP, proxy(that._drop, that))
	                         .bind(KEYDOWNACTION, proxy(that._keydownAction, that));

	            return that.treeView;
	        },

	        _drop: function (ev) {
	            var that = this;

	            if(!that.trigger(DROP, ev) && ev.items.indexOf(ev.target) < 0) {
	                that._confirm({
	                    type: "move",
	                    target: ev.target
	                }).done(function(){
	                    that.executeCommand({command: "CopyCommand", options: ev});
	                }).fail(function(){
	                    that.executeCommand({command: "MoveCommand", options: ev});
	                });
	            }
	        },

	        _keydownAction: function (ev) {
	            var that = this,
	                keyCode = ev.keyCode,
	                keys = kendo.keys;

	            if (keyCode === keys.DELETE) {
	                that.executeCommand({command: "DeleteCommand", options: { target: ev.target } });
	            }

	            if (keyCode === keys.F2) {
	                that.executeCommand({command: "RenameCommand", options: { target: ev.target } });
	            }
	        },

	        _confirm: function(options){
	            var that = this,
	                messages = that.options.messages.dialogs[options.type + "Confirm"];

	            var confirm = $("<div></div>").kendoConfirm(extend({}, {
	                title: messages.title,
	                content: messages.content,
	                messages: messages
	            }, that.options.dialogs[options.type + "Confirm"])).data("kendoConfirm");

	            confirm.bind(OPEN, proxy(that._cacheFocus, that));
	            confirm.bind(HIDE, proxy(that._restoreFocus, that, options.target));

	            confirm.open();

	            confirm.wrapper.removeClass("k-confirm");

	            return confirm.result;
	        },

	        _prompt: function(options){
	            var that = this,
	                messages = this.options.messages.dialogs[options.type + "Prompt"];

	            var prompt = $("<div></div>").kendoPrompt(extend({}, {
	                title: messages.title,
	                content: messages.content,
	                messages: messages,
	                value: options.defaultInput
	            },this.options.dialogs[options.type + "Prompt"])).data("kendoPrompt");

	            prompt.bind(OPEN, proxy(that._cacheFocus, that));
	            prompt.bind(CLOSE, proxy(that._restoreFocus, that, options.target));

	            prompt.open();

	            prompt.wrapper.removeClass("k-prompt");

	            return prompt.result;
	        },

	        _cacheFocus: function() {
	            var that = this,
	                activeElement = $(document.activeElement),
	                view = that.view(),
	                treeView = that.treeView.widgetComponent;

	            if (that.contextMenu && that.contextMenu.popup.visible()) {
	                return;
	            }

	            that.treeView._shouldFocus = false;

	            if ((treeView.current() && treeView.current().find(".k-state-focused").length) ||
	                activeElement.hasClass(fileManagerStyles.treeview)){
	                that.treeView._shouldFocus = true;
	                view._focusElement = activeElement;
	                return;
	            }

	            view._focusElement = activeElement.hasClass(fileManagerStyles[that._viewType]) ?
	                activeElement :
	                null;
	        },

	        _restoreFocus: function(target) {
	            var that = this,
	                view = that.view();

	            if (!target) {
	                return;
	            }

	            if (view._focusElement) {
	                view._focusElement.focus();
	            } else if (target.closest && target.closest(":kendoFocusable").length) {
	                target.closest(":kendoFocusable").focus();
	            }
	        },

	        _initView: function() {
	            var that = this,
	                viewWrapper = $("<div />").addClass(fileManagerStyles.view),
	                initialView = that.options.initialView;

	            that.viewWrapper = viewWrapper;
	            that.viewWrapper.append(that.view(initialView));

	            return viewWrapper;
	        },

	        _initBreadcrumb: function() {
	            var that = this,
	                options = that.options,
	                breadcrumbElement = $("<nav />").addClass(fileManagerStyles.breadcrumb),
	                breadcrumbOptions = extend({}, {
	                    items: [
	                        {type:"rootitem", text: "" }
	                    ],
	                    change: proxy(that._breadcrumbChange, that)
	                }, options.breadcrumb);

	            that.breadcrumb = new ui.Breadcrumb(breadcrumbElement, breadcrumbOptions);

	            return that.breadcrumb;
	        },

	        _breadcrumbChange: function(ev){
	            this._navigate({ path: ev.value });
	        },

	        _initUploadDialog: function() {
	            var that = this,
	                options = that.options,
	                dialogMessages = options.messages.dialogs.upload,
	                dialogElement = $("<div />"),
	                dialogOptions = extend({}, {
	                    title: dialogMessages.title,
	                    modal: true,
	                    visible: false,
	                    width: 500,
	                    actions: [
	                        { text: dialogMessages.clear, action: proxy(that._clearUploadFilesList, that) },
	                        { text: dialogMessages.done, primary: true }
	                    ],
	                    messages: dialogMessages
	                }, options.dialogs.upload),
	                uploadInstance;

	            if (!that._shouldInitUpload()) {
	                return;
	            }

	            uploadInstance = that._initUpload();

	            that.uploadDialog = new ui.Dialog(dialogElement, dialogOptions);
	            that.uploadDialog.wrapper.addClass(fileManagerStyles.uploadDialog);
	            that.uploadDialog.element.append(uploadInstance.wrapper);

	            that.uploadDialog.bind(OPEN, proxy(that._toggleUploadDropZone, that, ""));
	            that.uploadDialog.bind(CLOSE, proxy(that._toggleUploadDropZone, that, that.viewWrapper));

	            return that.uploadDialog;
	        },

	        _shouldInitUpload: function() {
	            var that = this,
	                options = that.options,
	                shouldInit = false;

	            if ((options.uploadUrl || (options.upload.async && options.upload.async.saveUrl)) &&
	                options.upload !== false) {
	                    shouldInit = true;
	            }

	            return shouldInit;
	        },

	        _initUpload: function() {
	            var that = this,
	                options = that.options,
	                uploadElement = $("<input type='file' name='file'/>").addClass(fileManagerStyles.upload),
	                uploadOptions = extend(true, {
	                    async: {
	                         autoUpload: true,
	                         saveUrl: options.uploadUrl
	                    },
	                    dropZone: that.viewWrapper
	                }, options.upload);

	            that.upload = new ui.Upload(uploadElement[0], uploadOptions);

	            that.upload.bind(UPLOAD, proxy(that._sendUploadPathParameter, that));
	            that.upload.bind(SUCCESS, proxy(that._success, that));

	            return that.upload;
	        },

	        _sendUploadPathParameter: function(ev) {
	            ev.data = extend(ev.data, { path: this.path() });
	        },

	        _success: function(){
	            this._view.widgetComponent.dataSource.read();
	        },

	        _clearUploadFilesList: function() {
	            var that = this,
	                upload = that.upload;

	            if (upload) {
	                upload.clearAllFiles();
	            }
	        },

	        _toggleUploadDropZone: function(zone) {
	            var that = this,
	                upload = that.upload;

	            if (upload) {
	                upload.setOptions({ dropZone: zone});
	            }
	        },

	        _binding: function (ev){
	            if(this.trigger(DATABINDING, { source: "view", action: ev.action, items: ev.items, index: ev.index })){
	                ev.preventDefault();
	            }
	        },

	        _bound: function (){
	            if (this.options.previewPane) {
	                this._setPreviewPaneContent();
	            }
	            this.trigger(DATABOUND);
	        },

	        _createResizableSplitBar: function(cssClass) {
	            var splitBar = $("<div />")
	                    .addClass(fileManagerStyles.splitBar)
	                    .addClass(fileManagerStyles.splitBarHorizontal)
	                    .addClass(cssClass),
	                icon = $("<span />").addClass(fileManagerStyles.splitBarIcon);

	            splitBar.append(icon);

	            splitBar.hover(function () {
	                $(this).toggleClass(fileManagerStyles.splitBarHover);
	            });

	            return splitBar;
	        },

	        _initResizableNavigation: function() {
	            var that = this,
	                wrapper = that.wrapper,
	                splitBar = that._createResizableSplitBar(fileManagerStyles.splitBarNavigation),
	                contentWrapper = wrapper.find(DOT + fileManagerStyles.content),
	                navigationWrapper = wrapper.find(DOT + fileManagerStyles.navigation),
	                contentWrapperWidth,
	                navigationWrapperWidth;

	            splitBar.insertAfter(navigationWrapper);

	            that._resizeDraggable.navigation = that.wrapper.find(splitBar)
	                .end()
	                .kendoResizable({
	                    handle: DOT + fileManagerStyles.splitBarNavigation,
	                    start: function () {
	                        contentWrapperWidth = contentWrapper.width();
	                        navigationWrapperWidth = navigationWrapper.width();
	                    },
	                    resize: function(e) {
	                        var delta = e.x.initialDelta;

	                        if (kendo.support.isRtl(wrapper)) {
	                            delta *= -1;
	                        }

	                        if (navigationWrapperWidth + delta < -2 || contentWrapperWidth - delta < -2) {
	                            return;
	                        }

	                        navigationWrapper.width(navigationWrapperWidth + delta);
	                    }
	                }).getKendoResizable();
	        },

	        _initResizablePreview: function() {
	            var that = this,
	                wrapper = that.wrapper,
	                splitBar = that._createResizableSplitBar(fileManagerStyles.splitBarPreview),
	                contentWrapper = wrapper.find(DOT + fileManagerStyles.content),
	                previewWrapper = wrapper.find(DOT + fileManagerStyles.preview),
	                contentWrapperWidth,
	                previewWrapperWidth;

	            if (!that.options.previewPane) {
	                return;
	            }

	            splitBar.insertBefore(previewWrapper).hide();

	            that._resizeDraggable.preview = wrapper.find(splitBar)
	                .end()
	                .kendoResizable({
	                    handle: DOT + fileManagerStyles.splitBarPreview,
	                    start: function () {
	                        contentWrapperWidth = contentWrapper.width();
	                        previewWrapperWidth = previewWrapper.width();
	                    },
	                    resize: function(e) {
	                        var delta = e.x.initialDelta;

	                        if (kendo.support.isRtl(wrapper)) {
	                            delta *= -1;
	                        }

	                        if (previewWrapperWidth - delta < -2 || contentWrapperWidth + delta < -2) {
	                            return;
	                        }

	                        previewWrapper.width(previewWrapperWidth - delta);
	                    }
	                }).getKendoResizable();
	        },

	        _resizable: function() {
	            var that = this,
	                options = that.options;

	            that._resizeDraggable = {};

	            if (!options.resizable) {
	                return;
	            }

	            that.wrapper.addClass(fileManagerStyles.resizable);

	            that._initResizableNavigation();

	            that._initResizablePreview();
	        },

	        view: function(type) {
	            var that = this,
	                element = $('<div></div>'),
	                options = that.options.views[type],
	                explicitOptions = extend(true, {}, {
	                    dataSource: that._viewDataSource || that.dataSource,
	                    messages: that.options.messages.views,
	                    draggable: that.options.draggable
	                });

	            if(type === undefined) {
	                return that._view;
	            }

	            if(!ui.filemanager.ViewComponents[type]) {
	                throw new Error(kendo.format("There is no {0} ViewComponent registered!", type));
	            }

	            if(that._view && that._view.destroy) {
	                that._view.destroy();
	                that.viewWrapper.empty();
	            }

	            that._viewType = type;
	            that._view = new ui.filemanager.ViewComponents[type](element, options, explicitOptions);

	            that._view.bind(SELECT, proxy(that._select, that));
	            that._view.bind(OPEN, proxy(that._open, that));
	            that._view.bind(DATABINDING, proxy(that._binding, that));
	            that._view.bind(DATABOUND, proxy(that._bound, that));
	            that._view.bind(DROP, proxy(that._drop, that));
	            that._view.bind(KEYDOWNACTION, proxy(that._keydownAction, that));
	            that._view.bind(CANCEL, proxy(that._cancel, that));

	            that._view.element.addClass(fileManagerStyles[type]);

	            that.viewWrapper
	                .removeClass(
	                    Object.keys(ui.filemanager.ViewComponents).map(function(el) {
	                        return fileManagerStyles.view + "-" + el;
	                    }).join(" ")
	                )
	                .addClass(fileManagerStyles.view + "-" + type);

	            that.viewWrapper.append(that._view.element);
	        },

	        executeCommand: function(args) {
	            var commandName = args.command,
	                commandOptions = extend({ filemanager: this }, isPlainObject(args.options) ? args.options : {value: args.options}),
	                command = new ui.filemanager.commands[commandName](commandOptions);

	            if(!this.trigger(EXECUTE, args)) {
	                return command.exec();
	            }
	        },

	        _navigate: function(ev){
	            var that = this,
	                path = ev.path;

	            if(!that.trigger(NAVIGATE, { path: path })) {
	                that.navigate(path);
	            }
	        },

	        _load: function(ev){
	            var entry = this.dataSource.get(ev.entryId);
	            entry.load();
	        },

	        _select: function (ev) {
	            if (this.options.previewPane) {
	                this._setPreviewPaneContent();
	            }

	            this.trigger(SELECT, { entries: ev.entries });
	        },

	        _open: function (ev) {
	            var that = this,
	                entry = ev.entry;

	            that.trigger(OPEN, { entry: entry });

	            if(entry.isDirectory) {
	                that._navigate({ path: entry.id });
	            }
	        },

	        _cancel: function () {
	            var that = this,
	                commandStack = that._commandStack,
	                command = commandStack.next();

	            commandStack.reject(command);
	            that.trigger(COMMAND, { status: "cancel", action: "itemchange", data: command.data });
	        },

	        _change: function (ev) {
	            var that = this,
	                commandStack = that._commandStack,
	                targetDataSource = ev.node ? ev.node.children : that.dataSource;

	            if(that.trigger(DATABINDING, { source: "tree", action: ev.action, items: ev.items, index: ev.index })){
	                return;
	            }

	            that.treeView._refreshDataSource(ev);

	            if(ev.action === "remove" || ev.action === "itemchange" || ev.action === "add") {
	                if (commandStack.empty()) {
	                    targetDataSource.sync();
	                } else {
	                    var command = commandStack.next();

	                    targetDataSource.sync().then(function(res){
	                        commandStack.resolve(command);
	                        that.trigger(COMMAND, { status: "success", action: ev.action, data: command.data, response: res });
	                    }).fail(function(res){
	                        commandStack.reject(command);
	                        that.trigger(COMMAND, { status: "fail", action: ev.action, data: command.data, response: res });
	                    });
	                }
	            }

	            if(ev.action === "remove" && that._viewDataSource && that._viewDataSource.parent() && ev.items[0] === that._viewDataSource.parent()) {
	                that._navigateToParent(ev.items[0]);
	            }

	            if(ev.action == "itemchange" && that._viewDataSource && that._viewDataSource.parent() && that.path().indexOf(ev.items[0].id) >= 0) {
	                that._navigateToParent(ev.items[0]);
	            }

	            if(ev.action === "itemchange") {
	                ev.items[0].loaded(false);
	            }
	        },

	        _navigateToParent: function(item){
	            var that = this;
	            var parent = item.parentNode();
	            var parentNodePath = parent ? parent.id : "";
	            that._navigate({path: parentNodePath});
	        },

	        _buildBreadcrumbPath: function (entry){
	            var that = this,
	                breadcrumb = that.breadcrumb,
	                values = [];

	            while(entry) {
	                values.push(entry.name);
	                entry = entry.parentNode && entry.parentNode();
	            }

	            values.push("");
	            breadcrumb.value(values.reverse().join("/"));
	        },

	        _adjustDimensions: function() {
	            var that = this,
	                wrapper = that.wrapper,
	                gridSelector = DOT + fileManagerStyles.grid,
	                listViewSelector = DOT + fileManagerStyles.list,
	                contentContainer = DOT + fileManagerStyles.contentContainer,
	                totalHeight = wrapper.height(),
	                toolbarHeight = 0,
	                breadcrumbHeight = 0;

	            if (that.toolbar) {
	                toolbarHeight = outerHeight(that.toolbar.wrapper);
	            }

	            if (that.breadcrumb) {
	                breadcrumbHeight = outerHeight(that.breadcrumb.wrapper);
	            }

	            if (that.options.height !== "auto") {
	                wrapper
	                    .find([gridSelector].join(","))
	                    .height(totalHeight - (toolbarHeight + breadcrumbHeight + 1));

	                wrapper
	                    .find(listViewSelector)
	                    .parent()
	                    .height(totalHeight - (toolbarHeight + breadcrumbHeight + 1));

	                wrapper
	                    .find(contentContainer)
	                    .height(totalHeight - toolbarHeight);
	            }
	        },

	        _resize: function() {
	            this._adjustDimensions();
	            kendo.resize(this.element.children());
	        },

	        setDataSource: function(dataSource) {
	            var that = this;

	            that.options.dataSource = dataSource;
	            that._dataSource();

	            if(that.toolbar) {
	                that.toolbar.destroy();
	                that.header.empty();
	                that.header.append(that._initToolbar().element);
	            }

	            if(that.treeView){
	                that.treeView.destroy();
	                that.navigation.empty();
	                that.navigation.append(that._initTreeView().element);
	            }

	            if(that._view) {
	                that.view(that._viewType|| that.options.initialView);
	            }

	            that._initContextMenu();

	        },

	        refresh: function (){
	            var that = this,
	                dataSource = that._viewDataSource || that.dataSource;

	            dataSource.read();
	        },

	        getSize: function() {
	            return kendo.dimensions(this.wrapper);
	        },

	        getSelected: function(){
	            var that = this,
	                items = that._view.getSelected(),
	                treeView = that.treeView;

	            if(items && items.length) {
	                return items;
	            }

	            var item = treeView.getSelected();

	            if(item) {
	                return [ that.dataSource.get(item.id) ];
	            }
	        },

	        path: function () {
	            return this._path || "";
	        },

	        navigate: function (path) {
	            var that = this,
	                dataSource = that.dataSource,
	                entry = dataSource.get(path.replace(/^\//, "")),
	                view = that._view,
	                treeView = that.treeView,
	                breadcrumb = that.breadcrumb;

	            that._path = path;

	            if(that.trigger(DATABINDING, { source: "navigation", action: "rebind", items: [entry] })){
	                return;
	            }

	            if(breadcrumb) {
	                that._buildBreadcrumbPath(entry);
	            }

	            if(path === "" || path === "/") {
	                dataSource.sort([ that.folderSortOption, that.defaultSortOption ]);
	                that._viewDataSource = dataSource;
	                view.refresh(that._viewDataSource);
	                treeView.treeView.select($());

	                if (that.options.previewPane) {
	                    that._setPreviewPaneContent();
	                }

	                return;
	            }

	            if(entry.loaded && !entry.loaded()) {
	                entry.load();
	            }

	            if(view) {
	                that._viewDataSource = entry.children;
	                that._viewDataSource._sort = [ that.folderSortOption, that.defaultSortOption ];
	                view.refresh(that._viewDataSource);
	            }

	            if(treeView) {
	                treeView.refresh(entry.id);
	            }

	            if (that.options.previewPane) {
	                that._setPreviewPaneContent();
	            }
	        },

	        items: function () {
	            var that = this;

	            return that.treeView.widgetComponent.items().add(that._view.widgetComponent.items());
	        },

	        destroy: function() {
	            var that = this;

	            DataBoundWidget.fn.destroy.call(that);

	            that.dataSource
	                .unbind(ERROR, that._errorHandler)
	                .unbind(CHANGE, that._changeHandler);

	            if (that._resizeDraggable.navigation) {
	                that._resizeDraggable.navigation.destroy();
	                that._resizeDraggable.navigation = null;
	            }

	            if (that._resizeDraggable.preview) {
	                that._resizeDraggable.preview.destroy();
	                that._resizeDraggable.preview = null;
	            }

	            if (that.uploadDialog) {
	                that.uploadDialog.destroy();
	                that.uploadDialog = null;
	            }

	            if (that.upload) {
	                that.upload.destroy();
	                that.upload = null;
	            }

	            if (that.contextMenu) {
	                that.contextMenu.destroy();
	                that.contextMenu = null;
	            }

	            kendo.unbindResize(that._resizeHandler);

	            that.dataSource = null;
	            that._viewDataSource = null;

	            kendo.destroy(that.element);
	        }
	    });

	    ui.plugin(FileManager);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ }),

/***/ 1236:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("qDPe");

/***/ }),

/***/ 1237:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("kL5d");

/***/ }),

/***/ 1238:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("86tn");

/***/ }),

/***/ 1239:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("76ON");

/***/ }),

/***/ 1240:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("X+Of");

/***/ }),

/***/ 1241:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Owf0");

/***/ })

/******/ });

/***/ }),

/***/ "ralJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(886);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 882:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nzx/");

/***/ }),

/***/ 884:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FTkt");

/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/***********************************************************************
	 * WARNING: this file is auto-generated.  If you change it directly,
	 * your modifications will eventually be lost.  The source code is in
	 * `kendo-charts` repository, you should make your changes there and
	 * run `src-modules/sync.sh` in this repository.
	 */
	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(887),
	        __webpack_require__(888),
	        __webpack_require__(884),
	        __webpack_require__(882)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {

	window.kendo.dataviz = window.kendo.dataviz || {};
	var dataviz = kendo.dataviz;
	var Class = dataviz.Class;
	var isNumber = dataviz.isNumber;
	var datavizConstants = dataviz.constants;
	var MAX_VALUE = datavizConstants.MAX_VALUE;
	var MIN_VALUE = datavizConstants.MIN_VALUE;
	var VALUE = datavizConstants.VALUE;
	var CENTER = datavizConstants.CENTER;
	var TOP = datavizConstants.TOP;
	var BOTTOM = datavizConstants.BOTTOM;
	var LEFT = datavizConstants.LEFT;
	var WHITE = datavizConstants.WHITE;
	var CIRCLE = datavizConstants.CIRCLE;
	var X = datavizConstants.X;
	var Y = datavizConstants.Y;
	var RIGHT = datavizConstants.RIGHT;
	var BLACK = datavizConstants.BLACK;
	var DATE = datavizConstants.DATE;
	var DEFAULT_PRECISION = datavizConstants.DEFAULT_PRECISION;
	var ARC = datavizConstants.ARC;
	var defined = dataviz.defined;
	var getter = dataviz.getter;
	var isArray = dataviz.isArray;
	var ChartElement = dataviz.ChartElement;
	var Point = dataviz.Point;
	var Box = dataviz.Box;
	var alignPathToPixel = dataviz.alignPathToPixel;
	var setDefaultOptions = dataviz.setDefaultOptions;
	var inArray = dataviz.inArray;
	var isFunction = dataviz.isFunction;
	var valueOrDefault = dataviz.valueOrDefault;
	var isObject = dataviz.isObject;
	var deepExtend = dataviz.deepExtend;
	var last = dataviz.last;
	var eventElement = dataviz.eventElement;
	var getTemplate = dataviz.getTemplate;
	var TextBox = dataviz.TextBox;
	var ShapeElement = dataviz.ShapeElement;
	var getSpacing = dataviz.getSpacing;
	var CurveProcessor = dataviz.CurveProcessor;
	var append = dataviz.append;
	var isString = dataviz.isString;
	var parseDate = dataviz.parseDate;
	var styleValue = dataviz.styleValue;
	var CategoryAxis = dataviz.CategoryAxis;
	var BoxElement = dataviz.BoxElement;
	var round = dataviz.round;
	var limitValue = dataviz.limitValue;
	var grep = dataviz.grep;
	var elementStyles = dataviz.elementStyles;
	var hasClasses = dataviz.hasClasses;
	var bindEvents = dataviz.bindEvents;
	var services = dataviz.services;
	var unbindEvents = dataviz.unbindEvents;
	var support = kendo.support;
	var drawing = kendo.drawing;
	var Path = drawing.Path;
	var Animation = drawing.Animation;
	var AnimationFactory = drawing.AnimationFactory;
	var Group = drawing.Group;
	var Color = kendo.Color;
	var geometry = kendo.geometry;
	var GeometryPoint = geometry.Point;
	var transform = geometry.transform;

	var ChartAxis = Class.extend({
	    init: function(axis) {

	        this._axis = axis;
	        this.options = axis.options;
	    },

	    value: function(point) {
	        var axis = this._axis;
	        var value = axis.getCategory ? axis.getCategory(point) : axis.getValue(point);

	        return value;
	    },

	    slot: function(from, to, limit) {
	        if (limit === void 0) { limit = true; }

	        return this._axis.slot(from, to, limit);
	    },

	    range: function() {
	        return this._axis.range();
	    },

	    valueRange: function() {
	        return this._axis.valueRange();
	    }
	});

	function findAxisByName(name, axes) {
	    for (var idx = 0; idx < axes.length; idx++) {
	        if (axes[idx].options.name === name) {
	            axes[idx].prepareUserOptions();
	            return new ChartAxis(axes[idx]);
	        }
	    }
	}

	var ChartPane = kendo.Class.extend({
	    init: function(pane) {
	        this.visual = pane.visual;
	        this.chartsVisual = pane.chartContainer.visual;
	        this._pane = pane;
	    },

	    findAxisByName: function(name) {
	        return findAxisByName(name, this._pane.axes);
	    }
	});

	var ChartPlotArea = Class.extend({
	    init: function(plotArea) {

	        this._plotArea = plotArea;
	        this.visual = plotArea.visual;
	        this.backgroundVisual = plotArea._bgVisual;
	    }
	});

	function countNumbers(values) {
	    var length = values.length;
	    var count = 0;

	    for (var i = 0; i < length; i++) {
	        var num = values[i];
	        if (isNumber(num)) {
	            count++;
	        }
	    }

	    return count;
	}

	var Aggregates = {
	    min: function(values) {
	        var length = values.length;
	        var min = MAX_VALUE;

	        for (var i = 0; i < length; i++) {
	            var value = values[i];
	            if (isNumber(value)) {
	                min = Math.min(min, value);
	            }
	        }

	        return min === MAX_VALUE ? values[0] : min;
	    },

	    max: function(values) {
	        var length = values.length;
	        var max = MIN_VALUE;

	        for (var i = 0; i < length; i++) {
	            var value = values[i];
	            if (isNumber(value)) {
	                max = Math.max(max, value);
	            }
	        }

	        return max === MIN_VALUE ? values[0] : max;
	    },

	    sum: function(values) {
	        var length = values.length;
	        var sum = 0;

	        for (var i = 0; i < length; i++) {
	            var value = values[i];
	            if (isNumber(value)) {
	                sum += value;
	            }
	        }

	        return sum;
	    },

	    sumOrNull: function(values) {
	        var result = null;

	        if (countNumbers(values)) {
	            result = Aggregates.sum(values);
	        }

	        return result;
	    },

	    count: function(values) {
	        var length = values.length;
	        var count = 0;

	        for (var i = 0; i < length; i++) {
	            var value = values[i];
	            if (value !== null && defined(value)) {
	                count++;
	            }
	        }

	        return count;
	    },

	    avg: function(values) {
	        var count = countNumbers(values);
	        var result = values[0];

	        if (count > 0) {
	            result = Aggregates.sum(values) / count;
	        }

	        return result;
	    },

	    first: function(values) {
	        var length = values.length;

	        for (var i = 0; i < length; i++) {
	            var value = values[i];
	            if (value !== null && defined(value)) {
	                return value;
	            }
	        }

	        return values[0];
	    }
	};

	function getField(field, row) {
	    if (row === null) {
	        return row;
	    }

	    var get = getter(field, true);
	    return get(row);
	}

	var SeriesBinder = Class.extend({
	    init: function() {

	        this._valueFields = {};
	        this._otherFields = {};
	        this._nullValue = {};
	        this._undefinedValue = {};
	    },

	    register: function(seriesTypes, valueFields, otherFields) {
	        var this$1 = this;
	        if (valueFields === void 0) { valueFields = [ VALUE ]; }
	        if (otherFields === void 0) { otherFields = {}; }

	        for (var i = 0; i < seriesTypes.length; i++) {
	            var type = seriesTypes[i];

	            this$1._valueFields[type] = valueFields;
	            this$1._otherFields[type] = otherFields;
	            this$1._nullValue[type] = this$1._makeValue(valueFields, null);
	            this$1._undefinedValue[type] = this$1._makeValue(valueFields, undefined);
	        }
	    },

	    canonicalFields: function(series) {
	        return this.valueFields(series).concat(this.otherFields(series));
	    },

	    valueFields: function(series) {
	        return this._valueFields[series.type] || [ VALUE ];
	    },

	    otherFields: function(series) {
	        return this._otherFields[series.type] || [ VALUE ];
	    },

	    bindPoint: function(series, pointIx, item) {
	        var data = series.data;
	        var pointData = defined(item) ? item : data[pointIx];
	        var result = { valueFields: { value: pointData } };
	        var valueFields = this.valueFields(series);
	        var otherFields = this._otherFields[series.type];
	        var fields, value;

	        if (pointData === null) {
	            value = this._nullValue[series.type];
	        } else if (!defined(pointData)) {
	            value = this._undefinedValue[series.type];
	        } else if (Array.isArray(pointData)) {
	            var fieldData = pointData.slice(valueFields.length);
	            value = this._bindFromArray(pointData, valueFields);
	            fields = this._bindFromArray(fieldData, otherFields);
	        } else if (typeof pointData === "object") {
	            var srcValueFields = this.sourceFields(series, valueFields);
	            var srcPointFields = this.sourceFields(series, otherFields);

	            value = this._bindFromObject(pointData, valueFields, srcValueFields);
	            fields = this._bindFromObject(pointData, otherFields, srcPointFields);
	        }

	        if (defined(value)) {
	            if (valueFields.length === 1) {
	                result.valueFields.value = value[valueFields[0]];
	            } else {
	                result.valueFields = value;
	            }
	        }

	        result.fields = fields || {};

	        return result;
	    },

	    _makeValue: function(fields, initialValue) {
	        var value = {};
	        var length = fields.length;

	        for (var i = 0; i < length; i++) {
	            var fieldName = fields[i];
	            value[fieldName] = initialValue;
	        }

	        return value;
	    },

	    _bindFromArray: function(array, fields) {
	        var value = {};

	        if (fields) {
	            var length = Math.min(fields.length, array.length);

	            for (var i = 0; i < length; i++) {
	                value[fields[i]] = array[i];
	            }
	        }

	        return value;
	    },

	    _bindFromObject: function(object, fields, srcFields) {
	        if (srcFields === void 0) { srcFields = fields; }

	        var value = {};

	        if (fields) {
	            var length = fields.length;

	            for (var i = 0; i < length; i++) {
	                var fieldName = fields[i];
	                var srcFieldName = srcFields[i];
	                if (srcFieldName !== null) {
	                    value[fieldName] = getField(srcFieldName, object);
	                }
	            }
	        }

	        return value;
	    },

	    sourceFields: function(series, canonicalFields) {
	        var sourceFields = [];

	        if (canonicalFields) {
	            var length = canonicalFields.length;

	            for (var i = 0; i < length; i++) {
	                var fieldName = canonicalFields[i];
	                var sourceFieldName = fieldName === VALUE ? "field" : fieldName + "Field";

	                sourceFields.push(series[sourceFieldName] !== null ? (series[sourceFieldName] || fieldName) : null);
	            }
	        }

	        return sourceFields;
	    }
	});

	SeriesBinder.current = new SeriesBinder();

	var STD_ERR = "stderr";
	var STD_DEV = "stddev";
	var percentRegex = /percent(?:\w*)\((\d+)\)/;
	var standardDeviationRegex = new RegExp("^" + STD_DEV + "(?:\\((\\d+(?:\\.\\d+)?)\\))?$");

	var ErrorRangeCalculator = Class.extend({
	    init: function(errorValue, series, field) {

	        this.initGlobalRanges(errorValue, series, field);
	    },

	    initGlobalRanges: function(errorValue, series, field) {
	        var data = series.data;
	        var deviationMatch = standardDeviationRegex.exec(errorValue);

	        if (deviationMatch) {
	            this.valueGetter = this.createValueGetter(series, field);

	            var average = this.getAverage(data);
	            var deviation = this.getStandardDeviation(data, average, false);
	            var multiple = deviationMatch[1] ? parseFloat(deviationMatch[1]) : 1;
	            var errorRange = { low: average.value - deviation * multiple, high: average.value + deviation * multiple };

	            this.globalRange = function() {
	                return errorRange;
	            };
	        } else if (errorValue.indexOf && errorValue.indexOf(STD_ERR) >= 0) {
	            this.valueGetter = this.createValueGetter(series, field);
	            var standardError = this.getStandardError(data, this.getAverage(data));

	            this.globalRange = function(value) {
	                return { low: value - standardError, high: value + standardError };
	            };
	        }
	    },

	    createValueGetter: function(series, field) {
	        var data = series.data;
	        var binder = SeriesBinder.current;
	        var valueFields = binder.valueFields(series);
	        var item = defined(data[0]) ? data[0] : {};
	        var valueGetter;

	        if (isArray(item)) {
	            var index = field ? valueFields.indexOf(field) : 0;
	            valueGetter = getter("[" + index + "]");
	        } else if (isNumber(item)) {
	            valueGetter = getter();
	        } else if (typeof item === datavizConstants.OBJECT) {
	            var srcValueFields = binder.sourceFields(series, valueFields);
	            valueGetter = getter(srcValueFields[valueFields.indexOf(field)]);
	        }

	        return valueGetter;
	    },

	    getErrorRange: function(pointValue, errorValue) {
	        var low, high, value;

	        if (!defined(errorValue)) {
	            return null;
	        }

	        if (this.globalRange) {
	            return this.globalRange(pointValue);
	        }

	        if (isArray(errorValue)) {
	            low = pointValue - errorValue[0];
	            high = pointValue + errorValue[1];
	        } else if (isNumber(value = parseFloat(errorValue))) {
	            low = pointValue - value;
	            high = pointValue + value;
	        } else if ((value = percentRegex.exec(errorValue))) {
	            var percentValue = pointValue * (parseFloat(value[1]) / 100);
	            low = pointValue - Math.abs(percentValue);
	            high = pointValue + Math.abs(percentValue);
	        } else {
	            throw new Error("Invalid ErrorBar value: " + errorValue);
	        }

	        return { low: low, high: high };
	    },

	    getStandardError: function(data, average) {
	        return this.getStandardDeviation(data, average, true) / Math.sqrt(average.count);
	    },

	    getStandardDeviation: function(data, average, isSample) {
	        var this$1 = this;

	        var length = data.length;
	        var total = isSample ? average.count - 1 : average.count;
	        var squareDifferenceSum = 0;

	        for (var idx = 0; idx < length; idx++) {
	            var value = this$1.valueGetter(data[idx]);
	            if (isNumber(value)) {
	                squareDifferenceSum += Math.pow(value - average.value, 2);
	            }
	        }

	        return Math.sqrt(squareDifferenceSum / total);
	    },

	    getAverage: function(data) {
	        var this$1 = this;

	        var length = data.length;
	        var sum = 0;
	        var count = 0;

	        for (var idx = 0; idx < length; idx++) {
	            var value = this$1.valueGetter(data[idx]);
	            if (isNumber(value)) {
	                sum += value;
	                count++;
	            }
	        }

	        return {
	            value: sum / count,
	            count: count
	        };
	    }
	});

	var browser = support.browser || {};

	var INITIAL_ANIMATION_DURATION = 600;
	var FADEIN = "fadeIn";

	var GLASS = "glass";
	var BORDER_BRIGHTNESS = 0.8;
	var TOOLTIP_OFFSET = 5;
	var START_SCALE = browser.msie ? 0.001 : 0;
	var ERROR_LOW_FIELD = "errorLow";
	var ERROR_HIGH_FIELD = "errorHigh";
	var X_ERROR_LOW_FIELD = "xErrorLow";
	var X_ERROR_HIGH_FIELD = "xErrorHigh";
	var Y_ERROR_LOW_FIELD = "yErrorLow";
	var Y_ERROR_HIGH_FIELD = "yErrorHigh";
	var LINE_MARKER_SIZE = 8;
	var ZERO = "zero";
	var INTERPOLATE = "interpolate";
	var GAP = "gap";
	var ABOVE = "above";
	var BELOW = "below";

	var SMOOTH = "smooth";
	var STEP = "step";

	var AREA = "area";
	var BAR = "bar";
	var BOX_PLOT = "boxPlot";
	var BUBBLE = "bubble";
	var BULLET = "bullet";
	var CANDLESTICK = "candlestick";
	var COLUMN = "column";
	var DONUT = "donut";
	var FUNNEL = "funnel";
	var HORIZONTAL_WATERFALL = "horizontalWaterfall";
	var LINE = "line";
	var OHLC = "ohlc";
	var PIE = "pie";
	var POLAR_AREA = "polarArea";
	var POLAR_LINE = "polarLine";
	var POLAR_SCATTER = "polarScatter";
	var RADAR_AREA = "radarArea";
	var RADAR_COLUMN = "radarColumn";
	var RADAR_LINE = "radarLine";
	var RANGE_AREA = "rangeArea";
	var RANGE_BAR = "rangeBar";
	var RANGE_COLUMN = "rangeColumn";
	var SCATTER = "scatter";
	var SCATTER_LINE = "scatterLine";
	var VERTICAL_AREA = "verticalArea";
	var VERTICAL_BOX_PLOT = "verticalBoxPlot";
	var VERTICAL_BULLET = "verticalBullet";
	var VERTICAL_LINE = "verticalLine";
	var VERTICAL_RANGE_AREA = "verticalRangeArea";
	var WATERFALL = "waterfall";
	var EQUALLY_SPACED_SERIES = [
	    BAR, COLUMN, OHLC, CANDLESTICK, BOX_PLOT, VERTICAL_BOX_PLOT,
	    BULLET, RANGE_COLUMN, RANGE_BAR, WATERFALL, HORIZONTAL_WATERFALL
	];

	var LEGEND_ITEM_CLICK = "legendItemClick";
	var LEGEND_ITEM_HOVER = "legendItemHover";
	var LEGEND_ITEM_LEAVE = "legendItemLeave";
	var SERIES_CLICK = "seriesClick";
	var SERIES_HOVER = "seriesHover";
	var SERIES_OVER = "seriesOver";
	var SERIES_LEAVE = "seriesLeave";
	var PLOT_AREA_CLICK = "plotAreaClick";
	var PLOT_AREA_HOVER = "plotAreaHover";
	var PLOT_AREA_LEAVE = "plotAreaLeave";
	var DRAG = "drag";
	var DRAG_END = "dragEnd";
	var DRAG_START = "dragStart";
	var ZOOM_START = "zoomStart";
	var ZOOM = "zoom";
	var ZOOM_END = "zoomEnd";
	var SELECT_START = "selectStart";
	var SELECT = "select";
	var SELECT_END = "selectEnd";
	var RENDER = "render";
	var SHOW_TOOLTIP = "showTooltip";
	var HIDE_TOOLTIP = "hideTooltip";
	var PANE_RENDER = "paneRender";

	var LOGARITHMIC = "log";
	var CATEGORY = "category";

	var INSIDE_END = "insideEnd";
	var INSIDE_BASE = "insideBase";
	var OUTSIDE_END = "outsideEnd";

	var MOUSEWHEEL = "DOMMouseScroll mousewheel";
	var MOUSEWHEEL_DELAY = 150;

	var constants = {
		INITIAL_ANIMATION_DURATION: INITIAL_ANIMATION_DURATION,
		FADEIN: FADEIN,
		LEGEND_ITEM_CLICK: LEGEND_ITEM_CLICK,
		LEGEND_ITEM_HOVER: LEGEND_ITEM_HOVER,
		LEGEND_ITEM_LEAVE: LEGEND_ITEM_LEAVE,
		SERIES_CLICK: SERIES_CLICK,
		SERIES_HOVER: SERIES_HOVER,
		SERIES_OVER: SERIES_OVER,
		SERIES_LEAVE: SERIES_LEAVE,
		GLASS: GLASS,
		BORDER_BRIGHTNESS: BORDER_BRIGHTNESS,
		TOOLTIP_OFFSET: TOOLTIP_OFFSET,
		START_SCALE: START_SCALE,
		ERROR_LOW_FIELD: ERROR_LOW_FIELD,
		ERROR_HIGH_FIELD: ERROR_HIGH_FIELD,
		X_ERROR_LOW_FIELD: X_ERROR_LOW_FIELD,
		X_ERROR_HIGH_FIELD: X_ERROR_HIGH_FIELD,
		Y_ERROR_LOW_FIELD: Y_ERROR_LOW_FIELD,
		Y_ERROR_HIGH_FIELD: Y_ERROR_HIGH_FIELD,
		LINE_MARKER_SIZE: LINE_MARKER_SIZE,
		INTERPOLATE: INTERPOLATE,
		ZERO: ZERO,
		SMOOTH: SMOOTH,
		STEP: STEP,
		CATEGORY: CATEGORY,
		FUNNEL: FUNNEL,
		BAR: BAR,
		CANDLESTICK: CANDLESTICK,
		PIE: PIE,
		COLUMN: COLUMN,
		AREA: AREA,
		VERTICAL_BULLET: VERTICAL_BULLET,
		BOX_PLOT: BOX_PLOT,
		OHLC: OHLC,
		WATERFALL: WATERFALL,
		LINE: LINE,
		BULLET: BULLET,
		VERTICAL_LINE: VERTICAL_LINE,
		VERTICAL_AREA: VERTICAL_AREA,
		RANGE_AREA: RANGE_AREA,
		VERTICAL_RANGE_AREA: VERTICAL_RANGE_AREA,
		RANGE_COLUMN: RANGE_COLUMN,
		VERTICAL_BOX_PLOT: VERTICAL_BOX_PLOT,
		RANGE_BAR: RANGE_BAR,
		HORIZONTAL_WATERFALL: HORIZONTAL_WATERFALL,
		SCATTER: SCATTER,
		SCATTER_LINE: SCATTER_LINE,
		BUBBLE: BUBBLE,
		RADAR_AREA: RADAR_AREA,
		RADAR_LINE: RADAR_LINE,
		RADAR_COLUMN: RADAR_COLUMN,
		POLAR_LINE: POLAR_LINE,
		POLAR_AREA: POLAR_AREA,
		POLAR_SCATTER: POLAR_SCATTER,
		RENDER: RENDER,
		PLOT_AREA_CLICK: PLOT_AREA_CLICK,
		PLOT_AREA_HOVER: PLOT_AREA_HOVER,
		PLOT_AREA_LEAVE: PLOT_AREA_LEAVE,
		LOGARITHMIC: LOGARITHMIC,
		DRAG: DRAG,
		DRAG_START: DRAG_START,
		DRAG_END: DRAG_END,
		ZOOM_START: ZOOM_START,
		ZOOM: ZOOM,
		ZOOM_END: ZOOM_END,
		SELECT_START: SELECT_START,
		SELECT: SELECT,
		SELECT_END: SELECT_END,
		PANE_RENDER: PANE_RENDER,
		GAP: GAP,
		DONUT: DONUT,
		INSIDE_END: INSIDE_END,
		INSIDE_BASE: INSIDE_BASE,
		OUTSIDE_END: OUTSIDE_END,
		MOUSEWHEEL: MOUSEWHEEL,
		MOUSEWHEEL_DELAY: MOUSEWHEEL_DELAY,
		SHOW_TOOLTIP: SHOW_TOOLTIP,
		HIDE_TOOLTIP: HIDE_TOOLTIP,
		EQUALLY_SPACED_SERIES: EQUALLY_SPACED_SERIES,
		ABOVE: ABOVE,
		BELOW: BELOW
	};

	var DEFAULT_ERROR_BAR_WIDTH = 4;

	var ErrorBarBase = ChartElement.extend({
	    init: function(low, high, isVertical, chart, series, options) {
	        ChartElement.fn.init.call(this, options);

	        this.low = low;
	        this.high = high;
	        this.isVertical = isVertical;
	        this.chart = chart;
	        this.series = series;
	    },

	    reflow: function(targetBox) {
	        var endCaps = this.options.endCaps;
	        var isVertical = this.isVertical;
	        var axis = this.getAxis();
	        var valueBox = axis.getSlot(this.low, this.high);
	        var centerBox = targetBox.center();
	        var capsWidth = this.getCapsWidth(targetBox, isVertical);
	        var capValue = isVertical ? centerBox.x : centerBox.y;
	        var capStart = capValue - capsWidth;
	        var capEnd = capValue + capsWidth;
	        var linePoints;

	        if (isVertical) {
	            linePoints = [
	                new Point(centerBox.x, valueBox.y1),
	                new Point(centerBox.x, valueBox.y2)
	            ];
	            if (endCaps) {
	                linePoints.push(new Point(capStart, valueBox.y1),
	                    new Point(capEnd, valueBox.y1),
	                    new Point(capStart, valueBox.y2),
	                    new Point(capEnd, valueBox.y2));
	            }
	            this.box = new Box(capStart, valueBox.y1, capEnd, valueBox.y2);
	        } else {
	            linePoints = [
	                new Point(valueBox.x1, centerBox.y),
	                new Point(valueBox.x2, centerBox.y)
	            ];
	            if (endCaps) {
	                linePoints.push(new Point(valueBox.x1, capStart),
	                    new Point(valueBox.x1, capEnd),
	                    new Point(valueBox.x2, capStart),
	                    new Point(valueBox.x2, capEnd));
	            }
	            this.box = new Box(valueBox.x1, capStart, valueBox.x2, capEnd);
	        }

	        this.linePoints = linePoints;
	    },

	    getCapsWidth: function(box, isVertical) {
	        var boxSize = isVertical ? box.width() : box.height();
	        var capsWidth = Math.min(Math.floor(boxSize / 2), DEFAULT_ERROR_BAR_WIDTH) || DEFAULT_ERROR_BAR_WIDTH;

	        return capsWidth;
	    },

	    createVisual: function() {
	        var this$1 = this;

	        var options = this.options;
	        var visual = options.visual;

	        if (visual) {
	            this.visual = visual({
	                low: this.low,
	                high: this.high,
	                rect: this.box.toRect(),
	                sender: this.getSender(),
	                options: {
	                    endCaps: options.endCaps,
	                    color: options.color,
	                    line: options.line
	                },
	                createVisual: function () {
	                    this$1.createDefaultVisual();
	                    var defaultVisual = this$1.visual;
	                    delete this$1.visual;
	                    return defaultVisual;
	                }
	            });
	        } else {
	            this.createDefaultVisual();
	        }
	    },

	    createDefaultVisual: function() {
	        var this$1 = this;

	        var ref = this;
	        var options = ref.options;
	        var linePoints = ref.linePoints;
	        var lineOptions = {
	            stroke: {
	                color: options.color,
	                width: options.line.width,
	                dashType: options.line.dashType
	            }
	        };

	        ChartElement.fn.createVisual.call(this);

	        for (var idx = 0; idx < linePoints.length; idx += 2) {
	            var line = new Path(lineOptions)
	                .moveTo(linePoints[idx].x, linePoints[idx].y)
	                .lineTo(linePoints[idx + 1].x, linePoints[idx + 1].y);

	            alignPathToPixel(line);
	            this$1.visual.append(line);
	        }
	    }
	});

	setDefaultOptions(ErrorBarBase, {
	    animation: {
	        type: FADEIN,
	        delay: INITIAL_ANIMATION_DURATION
	    },
	    endCaps: true,
	    line: {
	        width: 2
	    },
	    zIndex: 1
	});

	var CategoricalErrorBar = ErrorBarBase.extend({
	    getAxis: function() {
	        var axis = this.chart.seriesValueAxis(this.series);

	        return axis;
	    }
	});

	var MAX_EXPAND_DEPTH = 5;

	function evalOptions(options, context, state, dryRun) {
	    if (state === void 0) { state = {}; }
	    if (dryRun === void 0) { dryRun = false; }

	    var defaults = state.defaults = state.defaults || {};
	    var depth = state.depth = state.depth || 0;
	    var needsEval = false;

	    state.excluded = state.excluded || [];

	    if (depth > MAX_EXPAND_DEPTH) {
	        return null;
	    }

	    for (var property in options) {
	        if (!inArray(property, state.excluded) && options.hasOwnProperty(property)) {
	            var propValue = options[property];
	            if (isFunction(propValue)) {
	                needsEval = true;
	                if (!dryRun) {
	                    options[property] = valueOrDefault(propValue(context), defaults[property]);
	                }
	            } else if (isObject(propValue)) {
	                if (!dryRun) {
	                    state.defaults = defaults[property];
	                }
	                state.depth++;
	                needsEval = evalOptions(propValue, context, state, dryRun) || needsEval;
	                state.depth--;
	            }
	        }
	    }

	    return needsEval;
	}

	function categoriesCount(series) {
	    var seriesCount = series.length;
	    var categories = 0;

	    for (var i = 0; i < seriesCount; i++) {
	        categories = Math.max(categories, series[i].data.length);
	    }

	    return categories;
	}

	var CategoricalChart = ChartElement.extend({
	    init: function(plotArea, options) {
	        ChartElement.fn.init.call(this, options);

	        this.plotArea = plotArea;
	        this.chartService = plotArea.chartService;
	        this.categoryAxis = plotArea.seriesCategoryAxis(options.series[0]);

	        // Value axis ranges grouped by axis name, e.g.:
	        // primary: { min: 0, max: 1 }
	        this.valueAxisRanges = {};

	        this.points = [];
	        this.categoryPoints = [];
	        this.seriesPoints = [];
	        this.seriesOptions = [];
	        this._evalSeries = [];

	        this.render();
	    },

	    render: function() {
	        this.traverseDataPoints(this.addValue.bind(this));
	    },

	    pointOptions: function(series, seriesIx) {
	        var options = this.seriesOptions[seriesIx];
	        if (!options) {
	            var defaults = this.pointType().prototype.defaults;
	            this.seriesOptions[seriesIx] = options = deepExtend({ }, defaults, {
	                vertical: !this.options.invertAxes
	            }, series);
	        }

	        return options;
	    },

	    plotValue: function(point) {
	        if (!point) {
	            return 0;
	        }

	        if (this.options.isStacked100 && isNumber(point.value)) {
	            var categoryIx = point.categoryIx;
	            var categoryPoints = this.categoryPoints[categoryIx];
	            var otherValues = [];
	            var categorySum = 0;

	            for (var i = 0; i < categoryPoints.length; i++) {
	                var other = categoryPoints[i];
	                if (other) {
	                    var stack = point.series.stack;
	                    var otherStack = other.series.stack;

	                    if ((stack && otherStack) && stack.group !== otherStack.group) {
	                        continue;
	                    }

	                    if (isNumber(other.value)) {
	                        categorySum += Math.abs(other.value);
	                        otherValues.push(Math.abs(other.value));
	                    }
	                }
	            }

	            if (categorySum > 0) {
	                return point.value / categorySum;
	            }
	        }

	        return point.value;
	    },

	    plotRange: function(point, startValue) {
	        var this$1 = this;
	        if (startValue === void 0) { startValue = 0; }

	        var categoryPoints = this.categoryPoints[point.categoryIx];

	        if (this.options.isStacked) {
	            var plotValue = this.plotValue(point);
	            var positive = plotValue >= 0;
	            var prevValue = startValue;
	            var isStackedBar = false;

	            for (var i = 0; i < categoryPoints.length; i++) {
	                var other = categoryPoints[i];

	                if (point === other) {
	                    break;
	                }

	                var stack = point.series.stack;
	                var otherStack = other.series.stack;
	                if (stack && otherStack) {
	                    if (typeof stack === datavizConstants.STRING && stack !== otherStack) {
	                        continue;
	                    }

	                    if (stack.group && stack.group !== otherStack.group) {
	                        continue;
	                    }
	                }

	                var otherValue = this$1.plotValue(other);
	                if ((otherValue >= 0 && positive) ||
	                    (otherValue < 0 && !positive)) {
	                    prevValue += otherValue;
	                    plotValue += otherValue;
	                    isStackedBar = true;

	                    if (this$1.options.isStacked100) {
	                        plotValue = Math.min(plotValue, 1);
	                    }
	                }
	            }

	            if (isStackedBar) {
	                prevValue -= startValue;
	            }

	            return [ prevValue, plotValue ];
	        }

	        var series = point.series;
	        var valueAxis = this.seriesValueAxis(series);
	        var axisCrossingValue = this.categoryAxisCrossingValue(valueAxis);

	        return [ axisCrossingValue, dataviz.convertableToNumber(point.value) ? point.value : axisCrossingValue ];
	    },

	    stackLimits: function(axisName, stackName) {
	        var this$1 = this;

	        var min = MAX_VALUE;
	        var max = MIN_VALUE;

	        for (var i = 0; i < this.categoryPoints.length; i++) {
	            var categoryPoints = this$1.categoryPoints[i];
	            if (!categoryPoints) {
	                continue;
	            }

	            for (var pIx = 0; pIx < categoryPoints.length; pIx++) {
	                var point = categoryPoints[pIx];
	                if (point) {
	                    if (point.series.stack === stackName || point.series.axis === axisName) {
	                        var to = this$1.plotRange(point, 0)[1];
	                        if (defined(to) && isFinite(to)) {
	                            max = Math.max(max, to);
	                            min = Math.min(min, to);
	                        }
	                    }
	                }
	            }
	        }

	        return { min: min, max: max };
	    },

	    updateStackRange: function() {
	        var this$1 = this;

	        var ref = this.options;
	        var isStacked = ref.isStacked;
	        var chartSeries = ref.series;
	        var limitsCache = {};

	        if (isStacked) {
	            for (var i = 0; i < chartSeries.length; i++) {
	                var series = chartSeries[i];
	                var axisName = series.axis;
	                var key = axisName + series.stack;

	                var limits = limitsCache[key];
	                if (!limits) {
	                    limits = this$1.stackLimits(axisName, series.stack);

	                    var errorTotals = this$1.errorTotals;
	                    if (errorTotals) {
	                        if (errorTotals.negative.length) {
	                            limits.min = Math.min(limits.min, dataviz.sparseArrayLimits(errorTotals.negative).min);
	                        }
	                        if (errorTotals.positive.length) {
	                            limits.max = Math.max(limits.max, dataviz.sparseArrayLimits(errorTotals.positive).max);
	                        }
	                    }

	                    if (limits.min !== MAX_VALUE || limits.max !== MIN_VALUE) {
	                        limitsCache[key] = limits;
	                    } else {
	                        limits = null;
	                    }
	                }

	                if (limits) {
	                    this$1.valueAxisRanges[axisName] = limits;
	                }
	            }
	        }
	    },

	    addErrorBar: function(point, data, categoryIx) {
	        var value = point.value;
	        var series = point.series;
	        var seriesIx = point.seriesIx;
	        var errorBars = point.options.errorBars;
	        var lowValue = data.fields[ERROR_LOW_FIELD];
	        var highValue = data.fields[ERROR_HIGH_FIELD];
	        var errorRange;

	        if (isNumber(lowValue) && isNumber(highValue)) {
	            errorRange = { low: lowValue, high: highValue };
	        } else if (errorBars && defined(errorBars.value)) {
	            this.seriesErrorRanges = this.seriesErrorRanges || [];
	            this.seriesErrorRanges[seriesIx] = this.seriesErrorRanges[seriesIx] ||
	                new ErrorRangeCalculator(errorBars.value, series, VALUE);

	            errorRange = this.seriesErrorRanges[seriesIx].getErrorRange(value, errorBars.value);
	        }

	        if (errorRange) {
	            point.low = errorRange.low;
	            point.high = errorRange.high;
	            this.addPointErrorBar(point, categoryIx);
	        }
	    },

	    addPointErrorBar: function(point, categoryIx) {
	        var isVertical = !this.options.invertAxes;
	        var options = point.options.errorBars;
	        var series = point.series;
	        var low = point.low;
	        var high = point.high;

	        if (this.options.isStacked) {
	            var stackedErrorRange = this.stackedErrorRange(point, categoryIx);
	            low = stackedErrorRange.low;
	            high = stackedErrorRange.high;
	        } else {
	            var fields = { categoryIx: categoryIx, series: series };
	            this.updateRange({ value: low }, fields);
	            this.updateRange({ value: high }, fields);
	        }

	        var errorBar = new CategoricalErrorBar(low, high, isVertical, this, series, options);
	        point.errorBars = [ errorBar ];
	        point.append(errorBar);
	    },

	    stackedErrorRange: function(point, categoryIx) {
	        var plotValue = this.plotRange(point, 0)[1] - point.value;
	        var low = point.low + plotValue;
	        var high = point.high + plotValue;

	        this.errorTotals = this.errorTotals || { positive: [], negative: [] };

	        if (low < 0) {
	            this.errorTotals.negative[categoryIx] = Math.min(this.errorTotals.negative[categoryIx] || 0, low);
	        }

	        if (high > 0) {
	            this.errorTotals.positive[categoryIx] = Math.max(this.errorTotals.positive[categoryIx] || 0, high);
	        }

	        return { low: low, high: high };
	    },

	    addValue: function(data, fields) {
	        var categoryIx = fields.categoryIx;
	        var series = fields.series;
	        var seriesIx = fields.seriesIx;

	        var categoryPoints = this.categoryPoints[categoryIx];
	        if (!categoryPoints) {
	            this.categoryPoints[categoryIx] = categoryPoints = [];
	        }

	        var seriesPoints = this.seriesPoints[seriesIx];
	        if (!seriesPoints) {
	            this.seriesPoints[seriesIx] = seriesPoints = [];
	        }

	        var point = this.createPoint(data, fields);
	        if (point) {
	            $.extend(point, fields);

	            point.owner = this;
	            point.noteText = data.fields.noteText;
	            if (!defined(point.dataItem)) {
	                point.dataItem = series.data[categoryIx];
	            }
	            this.addErrorBar(point, data, categoryIx);
	        }

	        this.points.push(point);
	        seriesPoints.push(point);
	        categoryPoints.push(point);

	        this.updateRange(data.valueFields, fields);
	    },

	    evalPointOptions: function(options, value, category, categoryIx, series, seriesIx) {
	        var state = { defaults: series._defaults, excluded: [ "data", "aggregate", "_events", "tooltip", "content", "template", "visual", "toggle", "_outOfRangeMinPoint", "_outOfRangeMaxPoint" ] };

	        var doEval = this._evalSeries[seriesIx];
	        if (!defined(doEval)) {
	            this._evalSeries[seriesIx] = doEval = evalOptions(options, {}, state, true);
	        }

	        var pointOptions = options;
	        if (doEval) {
	            pointOptions = deepExtend({}, pointOptions);
	            evalOptions(pointOptions, {
	                value: value,
	                category: category,
	                index: categoryIx,
	                series: series,
	                dataItem: series.data[categoryIx]
	            }, state);
	        }

	        return pointOptions;
	    },

	    updateRange: function(data, fields) {
	        var axisName = fields.series.axis;
	        var value = data.value;
	        var axisRange = this.valueAxisRanges[axisName];

	        if (isFinite(value) && value !== null) {
	            axisRange = this.valueAxisRanges[axisName] =
	                axisRange || { min: MAX_VALUE, max: MIN_VALUE };

	            axisRange.min = Math.min(axisRange.min, value);
	            axisRange.max = Math.max(axisRange.max, value);
	        }
	    },

	    seriesValueAxis: function(series) {
	        var plotArea = this.plotArea;
	        var axisName = series.axis;
	        var axis = axisName ? plotArea.namedValueAxes[axisName] : plotArea.valueAxis;

	        if (!axis) {
	            throw new Error("Unable to locate value axis with name " + axisName);
	        }

	        return axis;
	    },

	    reflow: function(targetBox) {
	        var this$1 = this;

	        var categorySlots = this.categorySlots = [];
	        var chartPoints = this.points;
	        var categoryAxis = this.categoryAxis;
	        var pointIx = 0;

	        this.traverseDataPoints(function (data, fields) {
	            var categoryIx = fields.categoryIx;
	            var currentSeries = fields.series;

	            var valueAxis = this$1.seriesValueAxis(currentSeries);
	            var point = chartPoints[pointIx++];

	            var categorySlot = categorySlots[categoryIx];
	            if (!categorySlot) {
	                categorySlots[categoryIx] = categorySlot =
	                    this$1.categorySlot(categoryAxis, categoryIx, valueAxis);
	            }

	            if (point) {
	                var plotRange = this$1.plotRange(point, valueAxis.startValue());
	                var valueSlot = this$1.valueSlot(valueAxis, plotRange);
	                if (valueSlot) {
	                    var pointSlot = this$1.pointSlot(categorySlot, valueSlot);

	                    point.aboveAxis = this$1.aboveAxis(point, valueAxis);
	                    point.stackValue = plotRange[1];

	                    if (this$1.options.isStacked100) {
	                        point.percentage = this$1.plotValue(point);
	                    }

	                    this$1.reflowPoint(point, pointSlot);
	                } else {
	                    point.visible = false;
	                }
	            }
	        });

	        this.reflowCategories(categorySlots);
	        if (!this.options.clip && this.options.limitPoints && this.points.length) {
	            this.limitPoints();
	        }

	        this.box = targetBox;
	    },

	    valueSlot: function(valueAxis, plotRange) {
	        return valueAxis.getSlot(plotRange[0], plotRange[1], !this.options.clip);
	    },

	    limitPoints: function() {
	        var this$1 = this;

	        var categoryPoints = this.categoryPoints;
	        var points = categoryPoints[0].concat(last(categoryPoints));
	        for (var idx = 0; idx < points.length; idx++) {
	            if (points[idx]) {
	                this$1.limitPoint(points[idx]);
	            }
	        }
	    },

	    limitPoint: function(point) {
	        var limittedSlot = this.categoryAxis.limitSlot(point.box);
	        if (!limittedSlot.equals(point.box)) {
	            point.reflow(limittedSlot);
	        }
	    },

	    aboveAxis: function(point, valueAxis) {
	        var axisCrossingValue = this.categoryAxisCrossingValue(valueAxis);
	        var value = point.value;

	        return valueAxis.options.reverse ?
	            value < axisCrossingValue : value >= axisCrossingValue;
	    },

	    categoryAxisCrossingValue: function(valueAxis) {
	        var categoryAxis = this.categoryAxis;
	        var options = valueAxis.options;
	        var crossingValues = [].concat(
	            options.axisCrossingValues || options.axisCrossingValue
	        );

	        return crossingValues[categoryAxis.axisIndex || 0] || 0;
	    },

	    reflowPoint: function(point, pointSlot) {
	        point.reflow(pointSlot);
	    },

	    reflowCategories: function() { },

	    pointSlot: function(categorySlot, valueSlot) {
	        var options = this.options;
	        var invertAxes = options.invertAxes;
	        var slotX = invertAxes ? valueSlot : categorySlot;
	        var slotY = invertAxes ? categorySlot : valueSlot;

	        return new Box(slotX.x1, slotY.y1, slotX.x2, slotY.y2);
	    },

	    categorySlot: function(categoryAxis, categoryIx) {
	        return categoryAxis.getSlot(categoryIx);
	    },

	    traverseDataPoints: function(callback) {
	        var this$1 = this;

	        var series = this.options.series;
	        var count = categoriesCount(series);
	        var seriesCount = series.length;

	        for (var seriesIx = 0; seriesIx < seriesCount; seriesIx++) {
	            this$1._outOfRangeCallback(series[seriesIx], "_outOfRangeMinPoint", seriesIx, callback);
	        }

	        for (var categoryIx = 0; categoryIx < count; categoryIx++) {
	            for (var seriesIx$1 = 0; seriesIx$1 < seriesCount; seriesIx$1++) {
	                var currentSeries = series[seriesIx$1];
	                var currentCategory = this$1.categoryAxis.categoryAt(categoryIx);
	                var pointData = this$1._bindPoint(currentSeries, seriesIx$1, categoryIx);

	                callback(pointData, {
	                    category: currentCategory,
	                    categoryIx: categoryIx,
	                    categoriesCount: count,
	                    series: currentSeries,
	                    seriesIx: seriesIx$1
	                });
	            }
	        }

	        for (var seriesIx$2 = 0; seriesIx$2 < seriesCount; seriesIx$2++) {
	            this$1._outOfRangeCallback(series[seriesIx$2], "_outOfRangeMaxPoint", seriesIx$2, callback);
	        }
	    },

	    _outOfRangeCallback: function(series, field, seriesIx, callback) {
	        var outOfRangePoint = series[field];
	        if (outOfRangePoint) {
	            var categoryIx = outOfRangePoint.categoryIx;
	            var pointData = this._bindPoint(series, seriesIx, categoryIx, outOfRangePoint.item);

	            callback(pointData, {
	                category: outOfRangePoint.category,
	                categoryIx: categoryIx,
	                series: series,
	                seriesIx: seriesIx,
	                dataItem: outOfRangePoint.item
	            });
	        }
	    },

	    _bindPoint: function(series, seriesIx, categoryIx, item) {
	        if (!this._bindCache) {
	            this._bindCache = [];
	        }

	        var bindCache = this._bindCache[seriesIx];
	        if (!bindCache) {
	            bindCache = this._bindCache[seriesIx] = [];
	        }

	        var data = bindCache[categoryIx];
	        if (!data) {
	            data = bindCache[categoryIx] = SeriesBinder.current.bindPoint(series, categoryIx, item);
	        }

	        return data;
	    },

	    formatPointValue: function(point, format) {
	        if (point.value === null) {
	            return "";
	        }

	        return this.chartService.format.auto(format, point.value);
	    },

	    pointValue: function(data) {
	        return data.valueFields.value;
	    }
	});

	setDefaultOptions(CategoricalChart, {
	    series: [],
	    invertAxes: false,
	    isStacked: false,
	    clip: true,
	    limitPoints: true
	});

	var PointEventsMixin = {
	    click: function(chart, e) {
	        return chart.trigger(
	            SERIES_CLICK,
	            this.eventArgs(e)
	        );
	    },

	    hover: function(chart, e) {
	        return chart.trigger(
	            SERIES_HOVER,
	            this.eventArgs(e)
	        );
	    },

	    over: function(chart, e) {
	        return chart.trigger(
	            SERIES_OVER,
	            this.eventArgs(e)
	        );
	    },

	    out: function(chart, e) {
	        return chart.trigger(
	            SERIES_LEAVE,
	            this.eventArgs(e)
	        );
	    },

	    eventArgs: function(e) {
	        return {
	            value: this.value,
	            percentage: this.percentage,
	            stackValue: this.stackValue,
	            category: this.category,
	            series: this.series,
	            dataItem: this.dataItem,
	            runningTotal: this.runningTotal,
	            total: this.total,
	            element: eventElement(e),
	            originalEvent: e,
	            point: this
	        };
	    }
	};

	var NoteMixin = {
	    createNote: function() {
	        var options = this.options.notes;
	        var text = this.noteText || options.label.text;

	        if (options.visible !== false && defined(text) && text !== null) {
	            this.note = new dataviz.Note({
	                value: this.value,
	                text: text,
	                dataItem: this.dataItem,
	                category: this.category,
	                series: this.series
	            }, this.options.notes, this.owner.chartService);

	            this.append(this.note);
	        }
	    }
	};

	var LinePoint = ChartElement.extend({
	    init: function(value, options) {
	        ChartElement.fn.init.call(this);

	        this.value = value;
	        this.options = options;
	        this.aboveAxis = valueOrDefault(this.options.aboveAxis, true);
	        this.tooltipTracking = true;
	    },

	    render: function() {
	        var ref = this.options;
	        var markers = ref.markers;
	        var labels = ref.labels;

	        if (this._rendered) {
	            return;
	        }

	        this._rendered = true;

	        if (markers.visible && markers.size) {
	            this.marker = this.createMarker();
	            this.append(this.marker);
	        }

	        if (labels.visible) {
	            var labelTemplate = getTemplate(labels);
	            var pointData = this.pointData();
	            var labelText = this.value;
	            if (labelTemplate) {
	                labelText = labelTemplate(pointData);
	            } else if (labels.format) {
	                labelText = this.formatValue(labels.format);
	            }
	            this.label = new TextBox(labelText,
	                deepExtend({
	                    align: CENTER,
	                    vAlign: CENTER,
	                    margin: {
	                        left: 5,
	                        right: 5
	                    },
	                    zIndex: valueOrDefault(labels.zIndex, this.series.zIndex)
	                }, labels),
	                pointData
	            );
	            this.append(this.label);
	        }

	        this.createNote();

	        if (this.errorBar) {
	            this.append(this.errorBar);
	        }
	    },

	    markerBorder: function() {
	        var options = this.options.markers;
	        var background = options.background;
	        var border = deepExtend({ color: this.color }, options.border);

	        if (!defined(border.color)) {
	            border.color = new Color(background).brightness(BORDER_BRIGHTNESS).toHex();
	        }

	        return border;
	    },

	    createVisual: function() {},

	    createMarker: function() {
	        var options = this.options.markers;
	        var marker = new ShapeElement({
	            type: options.type,
	            width: options.size,
	            height: options.size,
	            rotation: options.rotation,
	            background: options.background,
	            border: this.markerBorder(),
	            opacity: options.opacity,
	            zIndex: valueOrDefault(options.zIndex, this.series.zIndex),
	            animation: options.animation,
	            visual: options.visual
	        }, {
	            dataItem: this.dataItem,
	            value: this.value,
	            series: this.series,
	            category: this.category
	        });

	        return marker;
	    },

	    markerBox: function() {
	        if (!this.marker) {
	            this.marker = this.createMarker();
	            this.marker.reflow(this._childBox);
	        }

	        return this.marker.box;
	    },

	    reflow: function(targetBox) {
	        var this$1 = this;

	        var ref = this;
	        var options = ref.options;
	        var aboveAxis = ref.aboveAxis;
	        var vertical = options.vertical;

	        this.render();

	        this.box = targetBox;
	        var childBox = targetBox.clone();

	        if (vertical) {
	            if (aboveAxis) {
	                childBox.y1 -= childBox.height();
	            } else {
	                childBox.y2 += childBox.height();
	            }
	        } else {
	            if (aboveAxis) {
	                childBox.x1 += childBox.width();
	            } else {
	                childBox.x2 -= childBox.width();
	            }
	        }

	        this._childBox = childBox;
	        if (this.marker) {
	            this.marker.reflow(childBox);
	        }

	        this.reflowLabel(childBox);

	        if (this.errorBars) {
	            for (var i = 0; i < this.errorBars.length; i++) {
	                this$1.errorBars[i].reflow(childBox);
	            }
	        }

	        if (this.note) {
	            var noteTargetBox = this.markerBox();

	            if (!(options.markers.visible && options.markers.size)) {
	                var center = noteTargetBox.center();
	                noteTargetBox = new Box(center.x, center.y, center.x, center.y);
	            }

	            this.note.reflow(noteTargetBox);
	        }
	    },

	    reflowLabel: function(box) {
	        var ref = this;
	        var options = ref.options;
	        var label = ref.label;
	        var anchor = options.labels.position;

	        if (label) {
	            anchor = anchor === ABOVE ? TOP : anchor;
	            anchor = anchor === BELOW ? BOTTOM : anchor;

	            label.reflow(box);
	            label.box.alignTo(this.markerBox(), anchor);
	            label.reflow(label.box);
	        }
	    },

	    createHighlight: function() {
	        var markers = this.options.highlight.markers;
	        var defaultColor = this.markerBorder().color;
	        var options = this.options.markers;
	        var size = options.size + (options.border.width || 0) + (markers.border.width || 0);

	        var shadow = new ShapeElement({
	            type: options.type,
	            width: size,
	            height: size,
	            rotation: options.rotation,
	            background: markers.color || defaultColor,
	            border: {
	                color: markers.border.color,
	                width: markers.border.width,
	                opacity: valueOrDefault(markers.border.opacity, 1)
	            },
	            opacity: valueOrDefault(markers.opacity, 1)
	        });
	        shadow.reflow(this._childBox);

	        return shadow.getElement();
	    },

	    highlightVisual: function() {
	        return (this.marker || {}).visual;
	    },

	    highlightVisualArgs: function() {
	        var marker = this.marker;
	        var visual, rect;

	        if (marker) {
	            rect = marker.paddingBox.toRect();
	            visual = marker.visual;
	        } else {
	            var size = this.options.markers.size;
	            var halfSize = size / 2;
	            var center = this.box.center();
	            rect = new geometry.Rect([ center.x - halfSize, center.y - halfSize ], [ size, size ]);
	        }

	        return {
	            options: this.options,
	            rect: rect,
	            visual: visual
	        };
	    },

	    tooltipAnchor: function() {
	        var markerBox = this.markerBox();
	        var clipBox = this.owner.pane.clipBox();
	        var showTooltip = !clipBox || clipBox.overlaps(markerBox);

	        if (showTooltip) {
	            var x = markerBox.x2 + TOOLTIP_OFFSET;
	            var horizontalAlign = LEFT;
	            var y, verticalAlign;

	            if (this.aboveAxis) {
	                y = markerBox.y1;
	                verticalAlign = BOTTOM;
	            } else {
	                y = markerBox.y2;
	                verticalAlign = TOP;
	            }

	            return {
	                point: new Point(x, y),
	                align: {
	                    horizontal: horizontalAlign,
	                    vertical: verticalAlign
	                }
	            };
	        }
	    },

	    formatValue: function(format) {
	        return this.owner.formatPointValue(this, format);
	    },

	    overlapsBox: function(box) {
	        var markerBox = this.markerBox();
	        return markerBox.overlaps(box);
	    },

	    unclipElements: function() {
	        if (this.label) {
	            this.label.options.noclip = true;
	        }

	        if (this.note) {
	            this.note.options.noclip = true;
	        }
	    },

	    pointData: function() {
	        return {
	            dataItem: this.dataItem,
	            category: this.category,
	            value: this.value,
	            percentage: this.percentage,
	            stackValue: this.stackValue,
	            series: this.series
	        };
	    }
	});

	LinePoint.prototype.defaults = {
	    vertical: true,
	    markers: {
	        visible: true,
	        background: WHITE,
	        size: LINE_MARKER_SIZE,
	        type: CIRCLE,
	        border: {
	            width: 2
	        },
	        opacity: 1
	    },
	    labels: {
	        visible: false,
	        position: ABOVE,
	        margin: getSpacing(3),
	        padding: getSpacing(4),
	        animation: {
	            type: FADEIN,
	            delay: INITIAL_ANIMATION_DURATION
	        }
	    },
	    notes: {
	        label: {}
	    },
	    highlight: {
	        markers: {
	            border: {
	                color: "#fff",
	                width: 2
	            }
	        },
	        zIndex: datavizConstants.HIGHLIGHT_ZINDEX
	    },
	    errorBars: {
	        line: {
	            width: 1
	        }
	    }
	};

	deepExtend(LinePoint.prototype, PointEventsMixin);
	deepExtend(LinePoint.prototype, NoteMixin);

	var LineSegment = ChartElement.extend({
	    init: function(linePoints, series, seriesIx) {
	        ChartElement.fn.init.call(this);

	        this.linePoints = linePoints;
	        this.series = series;
	        this.seriesIx = seriesIx;
	    },

	    points: function() {
	        return this.toGeometryPoints(this.linePoints);
	    },

	    toGeometryPoints: function(points) {
	        var result = [];
	        for (var i = 0, length = points.length; i < length; i++) {
	            if (points[i] && points[i].visible !== false) {
	                result.push(points[i]._childBox.toRect().center());
	            }
	        }

	        return result;
	    },

	    createVisual: function() {
	        var this$1 = this;

	        var customVisual = this.series.visual;
	        if (customVisual) {
	            this.visual = customVisual({
	                points: this.toGeometryPoints(this.linePoints),
	                series: this.series,
	                sender: this.getSender(),
	                createVisual: function () {
	                    this$1.segmentVisual();

	                    return this$1.visual;
	                }
	            });
	            if (this.visual && !defined(this.visual.options.zIndex)) {
	                this.visual.options.zIndex = this.series.zIndex;
	            }
	        } else {
	            this.segmentVisual();
	        }
	    },

	    segmentVisual: function() {
	        var ref = this;
	        var options = ref.options;
	        var series = ref.series;
	        var color = series.color;
	        var defaults = series._defaults;

	        if (isFunction(color) && defaults) {
	            color = defaults.color;
	        }

	        var line = Path.fromPoints(this.points(), {
	            stroke: {
	                color: color,
	                width: series.width,
	                opacity: series.opacity,
	                dashType: series.dashType
	            },
	            zIndex: series.zIndex
	        });

	        if (options.closed) {
	            line.close();
	        }

	        this.visual = line;
	    },

	    aliasFor: function(e, coords) {
	        return this.parent.getNearestPoint(coords.x, coords.y, this.seriesIx);
	    }
	});

	setDefaultOptions(LineSegment, {
	    closed: false
	});

	var StepLineMixin = {
	    calculateStepPoints: function(points) {
	        var categoryAxis = this.parent.plotArea.seriesCategoryAxis(this.series);
	        var ref = categoryAxis.options;
	        var justified = ref.justified;
	        var vertical = ref.vertical;
	        var reverse = ref.reverse;

	        var stepAxis = vertical ? X : Y;
	        var axis = vertical ? Y : X;
	        var stepDir = reverse ? 2 : 1;
	        var dir = stepDir;

	        var previousPoint = toGeometryPoint(points[0], stepAxis, stepDir, axis, dir);
	        var result = [ previousPoint ];

	        for (var idx = 1; idx < points.length; idx++) {
	            var point = toGeometryPoint(points[idx], stepAxis, stepDir, axis, dir);

	            if (previousPoint[stepAxis] !== point[stepAxis]) {
	                var stepPoint = new GeometryPoint();
	                stepPoint[stepAxis] = previousPoint[stepAxis];
	                stepPoint[axis] = point[axis];

	                result.push(stepPoint, point);
	            }

	            previousPoint = point;
	        }

	        if (!justified) {
	            result.push(toGeometryPoint(last(points), stepAxis, stepDir, axis, reverse ? 1 : 2));
	        } else if (previousPoint !== last(result)) {
	            result.push(previousPoint);
	        }

	        return result;

	    }
	};

	function toGeometryPoint(lintPoint, stepAxis, stepDir, axis, dir) {
	    var box = lintPoint.box;
	    var result = new GeometryPoint();

	    result[stepAxis] = box[stepAxis + stepDir];
	    result[axis] = box[axis + dir];

	    return result;
	}

	var StepLineSegment = LineSegment.extend({
	    points: function() {
	        return this.calculateStepPoints(this.linePoints);
	    }
	});

	deepExtend(StepLineSegment.prototype, StepLineMixin);

	var SplineSegment = LineSegment.extend({
	    segmentVisual: function() {
	        var series = this.series;
	        var defaults = series._defaults;
	        var color = series.color;

	        if (isFunction(color) && defaults) {
	            color = defaults.color;
	        }

	        var curveProcessor = new CurveProcessor(this.options.closed);
	        var segments = curveProcessor.process(this.points());
	        var curve = new Path({
	            stroke: {
	                color: color,
	                width: series.width,
	                opacity: series.opacity,
	                dashType: series.dashType
	            },
	            zIndex: series.zIndex
	        });

	        curve.segments.push.apply(curve.segments, segments);

	        this.visual = curve;
	    }
	});

	var LineChartMixin = {
	    renderSegments: function() {
	        var this$1 = this;

	        var ref = this;
	        var options = ref.options;
	        var seriesPoints = ref.seriesPoints;
	        var series = options.series;
	        var seriesCount = seriesPoints.length;
	        var lastSegment;

	        this._segments = [];

	        for (var seriesIx = 0; seriesIx < seriesCount; seriesIx++) {
	            var currentSeries = series[seriesIx];
	            var sortedPoints = this$1.sortPoints(seriesPoints[seriesIx]);
	            var pointCount = sortedPoints.length;
	            var linePoints = [];

	            for (var pointIx = 0; pointIx < pointCount; pointIx++) {
	                var point = sortedPoints[pointIx];
	                if (point) {
	                    linePoints.push(point);
	                } else if (this$1.seriesMissingValues(currentSeries) !== INTERPOLATE) {
	                    if (linePoints.length > 1) {
	                        lastSegment = this$1.createSegment(
	                            linePoints, currentSeries, seriesIx, lastSegment
	                        );
	                        this$1._addSegment(lastSegment);
	                    }
	                    linePoints = [];
	                }
	            }

	            if (linePoints.length > 1) {
	                lastSegment = this$1.createSegment(
	                    linePoints, currentSeries, seriesIx, lastSegment
	                );
	                this$1._addSegment(lastSegment);
	            }
	        }

	        this.children.unshift.apply(this.children, this._segments);
	    },

	    _addSegment: function(segment) {
	        this._segments.push(segment);
	        segment.parent = this;
	    },

	    sortPoints: function(points) {
	        return points;
	    },

	    seriesMissingValues: function(series) {
	        var missingValues = series.missingValues;
	        var assumeZero = !missingValues && this.options.isStacked;

	        return assumeZero ? ZERO : missingValues || INTERPOLATE;
	    },

	    getNearestPoint: function(x, y, seriesIx) {
	        var target = new Point(x, y);
	        var allPoints = this.seriesPoints[seriesIx];
	        var nearestPointDistance = MAX_VALUE;
	        var nearestPoint;

	        for (var i = 0; i < allPoints.length; i++) {
	            var point = allPoints[i];

	            if (point && defined(point.value) && point.value !== null && point.visible !== false) {
	                var pointBox = point.box;
	                var pointDistance = pointBox.center().distanceTo(target);

	                if (pointDistance < nearestPointDistance) {
	                    nearestPoint = point;
	                    nearestPointDistance = pointDistance;
	                }
	            }
	        }

	        return nearestPoint;
	    }
	};

	var ClipAnimation = Animation.extend({
	    setup: function() {
	        this._setEnd(this.options.box.x1);
	    },

	    step: function(pos) {
	        var box = this.options.box;
	        this._setEnd(dataviz.interpolateValue(box.x1, box.x2, pos));
	    },

	    _setEnd: function(x) {
	        var element = this.element;
	        var segments = element.segments;
	        var topRight = segments[1].anchor();
	        var bottomRight = segments[2].anchor();

	        element.suspend();
	        topRight.setX(x);
	        element.resume();
	        bottomRight.setX(x);
	    }
	});

	setDefaultOptions(ClipAnimation, {
	    duration: INITIAL_ANIMATION_DURATION
	});

	AnimationFactory.current.register("clip", ClipAnimation);

	function anyHasZIndex(elements) {
	    for (var idx = 0; idx < elements.length; idx++) {
	        if (defined(elements[idx].zIndex)) {
	            return true;
	        }
	    }
	}

	var ClipAnimationMixin = {
	    createAnimation: function() {
	        var root = this.getRoot();
	        if (root && (root.options || {}).transitions !== false) {
	            var box = root.size();
	            var clipPath = Path.fromRect(box.toRect());
	            this.visual.clip(clipPath);
	            this.animation = new ClipAnimation(clipPath, {
	                box: box
	            });
	            if (anyHasZIndex(this.options.series)) {
	                this._setChildrenAnimation(clipPath);
	            }
	        }
	    },

	    _setChildrenAnimation: function(clipPath) {
	        var points = this.animationPoints();

	        for (var idx = 0; idx < points.length; idx++) {
	            var point = points[idx];
	            if (point && point.visual && defined(point.visual.options.zIndex)) {
	                point.visual.clip(clipPath);
	            }
	        }
	    }
	};

	var LineChart = CategoricalChart.extend({
	    render: function() {

	        CategoricalChart.fn.render.call(this);

	        this.updateStackRange();
	        this.renderSegments();
	    },

	    pointType: function() {
	        return LinePoint;
	    },

	    createPoint: function(data, fields) {
	        var categoryIx = fields.categoryIx;
	        var category = fields.category;
	        var series = fields.series;
	        var seriesIx = fields.seriesIx;
	        var missingValues = this.seriesMissingValues(series);
	        var value = data.valueFields.value;

	        if (!defined(value) || value === null) {
	            if (missingValues === ZERO) {
	                value = 0;
	            } else {
	                return null;
	            }
	        }

	        var pointOptions = this.pointOptions(series, seriesIx);
	        pointOptions = this.evalPointOptions(
	            pointOptions, value, category, categoryIx, series, seriesIx
	        );

	        var color = data.fields.color || series.color;
	        if (isFunction(series.color)) {
	            color = pointOptions.color;
	        }

	        var point = new LinePoint(value, pointOptions);
	        point.color = color;

	        this.append(point);

	        return point;
	    },

	    plotRange: function(point) {
	        var this$1 = this;

	        var plotValue = this.plotValue(point);

	        if (this.options.isStacked) {
	            var categoryIx = point.categoryIx;
	            var categoryPoints = this.categoryPoints[categoryIx];

	            for (var i = 0; i < categoryPoints.length; i++) {
	                var other = categoryPoints[i];

	                if (point === other) {
	                    break;
	                }

	                plotValue += this$1.plotValue(other);

	                if (this$1.options.isStacked100) {
	                    plotValue = Math.min(plotValue, 1);
	                }
	            }

	        }

	        return [ plotValue, plotValue ];
	    },

	    createSegment: function(linePoints, currentSeries, seriesIx) {
	        var style = currentSeries.style;
	        var pointType;

	        if (style === STEP) {
	            pointType = StepLineSegment;
	        } else if (style === SMOOTH) {
	            pointType = SplineSegment;
	        } else {
	            pointType = LineSegment;
	        }

	        return new pointType(linePoints, currentSeries, seriesIx);
	    },

	    animationPoints: function() {
	        var points = this.points;
	        var result = [];
	        for (var idx = 0; idx < points.length; idx++) {
	            result.push((points[idx] || {}).marker);
	        }
	        return result.concat(this._segments);
	    }
	});

	deepExtend(LineChart.prototype, LineChartMixin, ClipAnimationMixin);

	var AreaSegment = LineSegment.extend({
	    init: function(linePoints, currentSeries, seriesIx, prevSegment, stackPoints) {
	        LineSegment.fn.init.call(this, linePoints, currentSeries, seriesIx);

	        this.prevSegment = prevSegment;
	        this.stackPoints = stackPoints;
	    },

	    createVisual: function() {
	        var series = this.series;
	        var defaults = series._defaults;
	        var lineOptions = series.line || {};
	        var color = series.color;

	        if (isFunction(color) && defaults) {
	            color = defaults.color;
	        }

	        this.visual = new Group({
	            zIndex: series.zIndex
	        });

	        this.createFill({
	            fill: {
	                color: color,
	                opacity: series.opacity
	            },
	            stroke: null
	        });

	        if (lineOptions.width > 0 && lineOptions.visible !== false) {
	            this.createStroke({
	                stroke: deepExtend({
	                    color: color,
	                    opacity: series.opacity,
	                    lineCap: "butt"
	                }, lineOptions)
	            });
	        }
	    },

	    strokeSegments: function() {
	        var segments = this._strokeSegments;

	        if (!segments) {
	            segments = this._strokeSegments = this.createStrokeSegments();
	        }

	        return segments;
	    },

	    createStrokeSegments: function() {
	        return this.segmentsFromPoints(this.points());
	    },

	    stackSegments: function() {
	        if (this.prevSegment) {
	            return this.prevSegment.createStackSegments(this.stackPoints);
	        }

	        return this.createStackSegments(this.stackPoints);
	    },

	    createStackSegments: function(stackPoints) {
	        return this.segmentsFromPoints(this.toGeometryPoints(stackPoints)).reverse();
	    },

	    segmentsFromPoints: function(points) {
	        return points.map(function (point) { return new geometry.Segment(point); });
	    },

	    createStroke: function(style) {
	        var stroke = new Path(style);
	        stroke.segments.push.apply(stroke.segments, this.strokeSegments());

	        this.visual.append(stroke);
	    },

	    hasStackSegment: function() {
	        return this.prevSegment || (this.stackPoints && this.stackPoints.length);
	    },

	    createFill: function(style) {
	        var strokeSegments = this.strokeSegments();
	        var fillSegments = strokeSegments.slice(0);
	        var hasStackSegments = this.hasStackSegment();

	        if (hasStackSegments) {
	            var stackSegments = this.stackSegments();

	            append(fillSegments, stackSegments);
	        }

	        var fill = new Path(style);
	        fill.segments.push.apply(fill.segments, fillSegments);

	        if (!hasStackSegments && strokeSegments.length > 1) {
	            this.fillToAxes(fill);
	        }

	        this.visual.append(fill);
	    },

	    fillToAxes: function(fillPath) {
	        var chart = this.parent;
	        var invertAxes = chart.options.invertAxes;
	        var valueAxis = chart.seriesValueAxis(this.series);
	        var crossingValue = chart.categoryAxisCrossingValue(valueAxis);
	        var endSlot = valueAxis.getSlot(crossingValue, crossingValue, true);
	        var segments = this.strokeSegments();
	        var firstPoint = segments[0].anchor();
	        var lastPoint = last(segments).anchor();
	        var end = invertAxes ? endSlot.x1 : endSlot.y1;

	        if (invertAxes) {
	            fillPath.lineTo(end, lastPoint.y)
	                    .lineTo(end, firstPoint.y);
	        } else {
	            fillPath.lineTo(lastPoint.x, end)
	                    .lineTo(firstPoint.x, end);
	        }
	    }
	});

	var StepAreaSegment = AreaSegment.extend({
	    createStrokeSegments: function() {
	        return this.segmentsFromPoints(this.calculateStepPoints(this.linePoints));
	    },

	    createStackSegments: function(stackPoints) {
	        return this.segmentsFromPoints(this.calculateStepPoints(stackPoints)).reverse();
	    }
	});

	deepExtend(StepAreaSegment.prototype, StepLineMixin);

	var SplineAreaSegment = AreaSegment.extend({
	    createStrokeSegments: function() {
	        var curveProcessor = new CurveProcessor(this.options.closed);
	        var linePoints = this.points();

	        return curveProcessor.process(linePoints);
	    },

	    createStackSegments: function() {
	        var strokeSegments = this.strokeSegments();
	        var stackSegments = [];
	        for (var idx = strokeSegments.length - 1; idx >= 0; idx--) {
	            var segment = strokeSegments[idx];
	            stackSegments.push(new geometry.Segment(
	                segment.anchor(),
	                segment.controlOut(),
	                segment.controlIn()
	            ));
	        }

	        return stackSegments;
	    }
	});

	var AreaChart = LineChart.extend({
	    createSegment: function(linePoints, currentSeries, seriesIx, prevSegment) {
	        var isStacked = this.options.isStacked;
	        var style = (currentSeries.line || {}).style;
	        var previousSegment;

	        var stackPoints;
	        if (isStacked && seriesIx > 0 && prevSegment) {
	            var missingValues = this.seriesMissingValues(currentSeries);
	            if (missingValues !== "gap") {
	                stackPoints = prevSegment.linePoints;
	                previousSegment = prevSegment;
	            } else {
	                stackPoints = this._gapStackPoints(linePoints, seriesIx, style);
	            }
	        }

	        var pointType;
	        if (style === STEP) {
	            pointType = StepAreaSegment;
	        } else if (style === SMOOTH) {
	            pointType = SplineAreaSegment;
	        } else {
	            pointType = AreaSegment;
	        }

	        return new pointType(linePoints, currentSeries, seriesIx, previousSegment, stackPoints);
	    },

	    reflow: function(targetBox) {
	        var this$1 = this;

	        LineChart.fn.reflow.call(this, targetBox);

	        var stackPoints = this._stackPoints;
	        if (stackPoints) {
	            for (var idx = 0; idx < stackPoints.length; idx++) {
	                var stackPoint = stackPoints[idx];
	                var pointSlot = this$1.categoryAxis.getSlot(stackPoint.categoryIx);
	                stackPoint.reflow(pointSlot);
	            }
	        }
	    },

	    _gapStackPoints: function(linePoints, seriesIx, style) {
	        var this$1 = this;

	        var seriesPoints = this.seriesPoints;
	        var startIdx = linePoints[0].categoryIx;
	        var length = linePoints.length;
	        if (startIdx < 0) {
	            startIdx = 0;
	            length--;
	        }

	        var endIdx = startIdx + length;
	        var pointOffset = this.seriesOptions[0]._outOfRangeMinPoint ? 1 : 0;
	        var stackPoints = [];

	        this._stackPoints = this._stackPoints || [];
	        for (var categoryIx = startIdx; categoryIx < endIdx; categoryIx++) {
	            var pointIx = categoryIx + pointOffset;
	            var currentSeriesIx = seriesIx;
	            var point = (void 0);

	            do {
	                currentSeriesIx--;
	                point = seriesPoints[currentSeriesIx][pointIx];
	            } while (currentSeriesIx > 0 && !point);

	            if (point) {
	                if (style !== STEP && categoryIx > startIdx && !seriesPoints[currentSeriesIx][pointIx - 1]) {
	                    stackPoints.push(this$1._previousSegmentPoint(categoryIx, pointIx, pointIx - 1, currentSeriesIx));
	                }

	                stackPoints.push(point);

	                if (style !== STEP && categoryIx + 1 < endIdx && !seriesPoints[currentSeriesIx][pointIx + 1]) {
	                    stackPoints.push(this$1._previousSegmentPoint(categoryIx, pointIx, pointIx + 1, currentSeriesIx));
	                }
	            } else {
	                var gapStackPoint = this$1._createGapStackPoint(categoryIx);
	                this$1._stackPoints.push(gapStackPoint);
	                stackPoints.push(gapStackPoint);
	            }
	        }

	        return stackPoints;
	    },

	    _previousSegmentPoint: function(categoryIx, pointIx, segmentIx, seriesIdx) {
	        var seriesPoints = this.seriesPoints;
	        var index = seriesIdx;
	        var point;

	        while (index > 0 && !point) {
	            index--;
	            point = seriesPoints[index][segmentIx];
	        }

	        if (!point) {
	            point = this._createGapStackPoint(categoryIx);
	            this._stackPoints.push(point);
	        } else {
	            point = seriesPoints[index][pointIx];
	        }

	        return point;
	    },

	    _createGapStackPoint: function(categoryIx) {
	        var options = this.pointOptions({}, 0);
	        var point = new LinePoint(0, options);
	        point.categoryIx = categoryIx;
	        point.series = {};

	        return point;
	    },

	    seriesMissingValues: function(series) {
	        return series.missingValues || ZERO;
	    }
	});

	var AxisGroupRangeTracker = Class.extend({
	    init: function() {

	        this.axisRanges = {};
	    },

	    update: function(chartAxisRanges) {
	        var axisRanges = this.axisRanges;

	        for (var axisName in chartAxisRanges) {
	            var chartRange = chartAxisRanges[axisName];
	            var range = axisRanges[axisName];
	            axisRanges[axisName] = range = range || { min: MAX_VALUE, max: MIN_VALUE };

	            range.min = Math.min(range.min, chartRange.min);
	            range.max = Math.max(range.max, chartRange.max);
	        }
	    },

	    reset: function(axisName) {
	        this.axisRanges[axisName] = undefined;
	    },

	    query: function(axisName) {
	        return this.axisRanges[axisName];
	    }
	});

	var BarLabel = ChartElement.extend({
	    init: function(content, options, pointData) {
	        ChartElement.fn.init.call(this, options);

	        this.textBox = new TextBox(content, this.options, pointData);
	        this.append(this.textBox);
	    },

	    createVisual: function() {
	        this.textBox.options.noclip = this.options.noclip;
	    },

	    reflow: function(targetBox) {
	        var options = this.options;
	        var vertical = options.vertical;
	        var aboveAxis = options.aboveAxis;
	        var text = this.children[0];
	        var textOptions = text.options;
	        var box = text.box;
	        var padding = text.options.padding;
	        var labelBox = targetBox;

	        textOptions.align = vertical ? CENTER : LEFT;
	        textOptions.vAlign = vertical ? TOP : CENTER;

	        if (options.position === INSIDE_END) {
	            if (vertical) {
	                textOptions.vAlign = TOP;

	                if (!aboveAxis && box.height() < targetBox.height()) {
	                    textOptions.vAlign = BOTTOM;
	                }
	            } else {
	                textOptions.align = aboveAxis ? RIGHT : LEFT;
	            }
	        } else if (options.position === CENTER) {
	            textOptions.vAlign = CENTER;
	            textOptions.align = CENTER;
	        } else if (options.position === INSIDE_BASE) {
	            if (vertical) {
	                textOptions.vAlign = aboveAxis ? BOTTOM : TOP;
	            } else {
	                textOptions.align = aboveAxis ? LEFT : RIGHT;
	            }
	        } else if (options.position === OUTSIDE_END) {
	            if (vertical) {
	                if (aboveAxis) {
	                    labelBox = new Box(
	                        targetBox.x1, targetBox.y1 - box.height(),
	                        targetBox.x2, targetBox.y1
	                    );
	                } else {
	                    labelBox = new Box(
	                        targetBox.x1, targetBox.y2,
	                        targetBox.x2, targetBox.y2 + box.height()
	                    );
	                }
	            } else {
	                textOptions.align = CENTER;
	                if (aboveAxis) {
	                    labelBox = new Box(
	                        targetBox.x2, targetBox.y1,
	                        targetBox.x2 + box.width(), targetBox.y2
	                    );
	                } else {
	                    labelBox = new Box(
	                        targetBox.x1 - box.width(), targetBox.y1,
	                        targetBox.x1, targetBox.y2
	                    );
	                }
	            }
	        }

	        if (!options.rotation) {
	            if (vertical) {
	                padding.left = padding.right =
	                    (labelBox.width() - text.contentBox.width()) / 2;
	            } else {
	                padding.top = padding.bottom =
	                    (labelBox.height() - text.contentBox.height()) / 2;
	            }
	        }

	        text.reflow(labelBox);
	    },

	    alignToClipBox: function(clipBox) {
	        var vertical = this.options.vertical;
	        var field = vertical ? Y : X;
	        var start = field + "1";
	        var end = field + "2";
	        var text = this.children[0];
	        var parentBox = this.parent.box;

	        if (parentBox[start] < clipBox[start] || clipBox[end] < parentBox[end]) {
	            var targetBox = text.paddingBox.clone();
	            targetBox[start] = Math.max(parentBox[start], clipBox[start]);
	            targetBox[end] = Math.min(parentBox[end], clipBox[end]);

	            this.reflow(targetBox);
	        }
	    }
	});

	setDefaultOptions(BarLabel, {
	    position: OUTSIDE_END,
	    margin: getSpacing(3),
	    padding: getSpacing(4),
	    color: BLACK,
	    background: "",
	    border: {
	        width: 1,
	        color: ""
	    },
	    aboveAxis: true,
	    vertical: false,
	    animation: {
	        type: FADEIN,
	        delay: INITIAL_ANIMATION_DURATION
	    },
	    zIndex: 2
	});

	function hasGradientOverlay(options) {
	    var overlay = options.overlay;

	    return overlay && overlay.gradient && overlay.gradient !== "none";
	}

	var BAR_ALIGN_MIN_WIDTH = 6;

	var Bar = ChartElement.extend({
	    init: function(value, options) {
	        ChartElement.fn.init.call(this);

	        this.options = options;
	        this.color = options.color || WHITE;
	        this.aboveAxis = valueOrDefault(this.options.aboveAxis, true);
	        this.value = value;
	    },

	    render: function() {
	        if (this._rendered) {
	            return;
	        }

	        this._rendered = true;

	        this.createLabel();
	        this.createNote();

	        if (this.errorBar) {
	            this.append(this.errorBar);
	        }
	    },

	    createLabel: function() {
	        var options = this.options;
	        var labels = options.labels;

	        if (labels.visible) {
	            var pointData = this.pointData();
	            var labelTemplate = getTemplate(labels);
	            var labelText;

	            if (labelTemplate) {
	                labelText = labelTemplate(pointData);
	            } else {
	                labelText = this.formatValue(labels.format);
	            }

	            this.label = new BarLabel(labelText,
	                deepExtend({
	                    vertical: options.vertical
	                },
	                labels
	            ), pointData);
	            this.append(this.label);
	        }
	    },

	    formatValue: function(format) {
	        return this.owner.formatPointValue(this, format);
	    },

	    reflow: function(targetBox) {
	        var this$1 = this;

	        this.render();

	        var label = this.label;

	        this.box = targetBox;

	        if (label) {
	            label.options.aboveAxis = this.aboveAxis;
	            label.reflow(targetBox);
	        }

	        if (this.note) {
	            this.note.reflow(targetBox);
	        }

	        if (this.errorBars) {
	            for (var i = 0; i < this.errorBars.length; i++) {
	                this$1.errorBars[i].reflow(targetBox);
	            }
	        }
	    },

	    createVisual: function() {
	        var this$1 = this;

	        var ref = this;
	        var box = ref.box;
	        var options = ref.options;
	        var customVisual = options.visual;

	        if (this.visible !== false) {
	            ChartElement.fn.createVisual.call(this);

	            if (customVisual) {
	                var visual = this.rectVisual = customVisual({
	                    category: this.category,
	                    dataItem: this.dataItem,
	                    value: this.value,
	                    sender: this.getSender(),
	                    series: this.series,
	                    percentage: this.percentage,
	                    stackValue: this.stackValue,
	                    runningTotal: this.runningTotal,
	                    total: this.total,
	                    rect: box.toRect(),
	                    createVisual: function () {
	                        var group = new Group();
	                        this$1.createRect(group);
	                        return group;
	                    },
	                    options: options
	                });

	                if (visual) {
	                    this.visual.append(visual);
	                }
	            } else if (box.width() > 0 && box.height() > 0) {
	                this.createRect(this.visual);
	            }
	        }
	    },

	    createRect: function(visual) {
	        var options = this.options;
	        var border = options.border;
	        var strokeOpacity = defined(border.opacity) ? border.opacity : options.opacity;
	        var rect = this.box.toRect();

	        rect.size.width = Math.round(rect.size.width);

	        var path = this.rectVisual = Path.fromRect(rect, {
	            fill: {
	                color: this.color,
	                opacity: options.opacity
	            },
	            stroke: {
	                color: this.getBorderColor(),
	                width: border.width,
	                opacity: strokeOpacity,
	                dashType: border.dashType
	            }
	        });

	        var width = this.box.width();
	        var height = this.box.height();

	        var size = options.vertical ? width : height;

	        if (size > BAR_ALIGN_MIN_WIDTH) {
	            alignPathToPixel(path);

	            // Fixes lineJoin issue in firefox when the joined lines are parallel
	            if (width < 1 || height < 1) {
	                path.options.stroke.lineJoin = "round";
	            }
	        }

	        visual.append(path);

	        if (hasGradientOverlay(options)) {
	            var overlay = this.createGradientOverlay(path, { baseColor: this.color }, deepExtend({
	                end: !options.vertical ? [ 0, 1 ] : undefined
	            }, options.overlay));

	            visual.append(overlay);
	        }
	    },

	    createHighlight: function(style) {
	        var highlight = Path.fromRect(this.box.toRect(), style);

	        return alignPathToPixel(highlight);
	    },

	    highlightVisual: function() {
	        return this.rectVisual;
	    },

	    highlightVisualArgs: function() {
	        return {
	            options: this.options,
	            rect: this.box.toRect(),
	            visual: this.rectVisual
	        };
	    },

	    getBorderColor: function() {
	        var color = this.color;
	        var border = this.options.border;
	        var brightness = border._brightness || BORDER_BRIGHTNESS;
	        var borderColor = border.color;

	        if (!defined(borderColor)) {
	            borderColor = new Color(color).brightness(brightness).toHex();
	        }

	        return borderColor;
	    },

	    tooltipAnchor: function() {
	        var ref = this;
	        var options = ref.options;
	        var box = ref.box;
	        var aboveAxis = ref.aboveAxis;
	        var clipBox = this.owner.pane.clipBox() || box;
	        var horizontalAlign = LEFT;
	        var verticalAlign = TOP;
	        var x, y;

	        if (options.vertical) {
	            x = Math.min(box.x2, clipBox.x2) + TOOLTIP_OFFSET;
	            if (aboveAxis) {
	                y = Math.max(box.y1, clipBox.y1);
	            } else {
	                y = Math.min(box.y2, clipBox.y2);
	                verticalAlign = BOTTOM;
	            }
	        } else {
	            var x1 = Math.max(box.x1, clipBox.x1);
	            var x2 = Math.min(box.x2, clipBox.x2);

	            if (options.isStacked) {
	                verticalAlign = BOTTOM;
	                if (aboveAxis) {
	                    horizontalAlign = RIGHT;
	                    x = x2;
	                } else {
	                    x = x1;
	                }
	                y = Math.max(box.y1, clipBox.y1) - TOOLTIP_OFFSET;
	            } else {
	                if (aboveAxis) {
	                    x = x2 + TOOLTIP_OFFSET;
	                } else {
	                    x = x1 - TOOLTIP_OFFSET;
	                    horizontalAlign = RIGHT;
	                }
	                y = Math.max(box.y1, clipBox.y1);
	            }
	        }

	        return {
	            point: new Point(x, y),
	            align: {
	                horizontal: horizontalAlign,
	                vertical: verticalAlign
	            }
	        };
	    },

	    overlapsBox: function(box) {
	        return this.box.overlaps(box);
	    },

	    pointData: function() {
	        return {
	            dataItem: this.dataItem,
	            category: this.category,
	            value: this.value,
	            percentage: this.percentage,
	            stackValue: this.stackValue,
	            runningTotal: this.runningTotal,
	            total: this.total,
	            series: this.series
	        };
	    }
	});

	deepExtend(Bar.prototype, PointEventsMixin);
	deepExtend(Bar.prototype, NoteMixin);

	Bar.prototype.defaults = {
	    border: {
	        width: 1
	    },
	    vertical: true,
	    overlay: {
	        gradient: "glass"
	    },
	    labels: {
	        visible: false,
	        format: "{0}"
	    },
	    opacity: 1,
	    notes: {
	        label: {}
	    }
	};

	function forEach(elements, callback) {
	    elements.forEach(callback);
	}

	function forEachReverse(elements, callback) {
	    var length = elements.length;

	    for (var idx = length - 1; idx >= 0; idx--) {
	        callback(elements[idx], idx - length - 1);
	    }
	}

	var ClusterLayout = ChartElement.extend({
	    init: function(options) {
	        ChartElement.fn.init.call(this, options);

	        this.forEach = options.rtl ? forEachReverse : forEach;
	    },

	    reflow: function(box) {
	        var ref = this.options;
	        var vertical = ref.vertical;
	        var gap = ref.gap;
	        var spacing = ref.spacing;
	        var children = this.children;
	        var count = children.length;
	        var axis = vertical ? Y : X;
	        var slots = count + gap + (spacing * (count - 1));
	        var slotSize = (vertical ? box.height() : box.width()) / slots;
	        var position = box[axis + 1] + slotSize * (gap / 2);

	        this.forEach(children, function (child, idx) {
	            var childBox = (child.box || box).clone();

	            childBox[axis + 1] = position;
	            childBox[axis + 2] = position + slotSize;

	            child.reflow(childBox);
	            if (idx < count - 1) {
	                position += (slotSize * spacing);
	            }

	            position += slotSize;
	        });
	    }
	});

	setDefaultOptions(ClusterLayout, {
	    vertical: false,
	    gap: 0,
	    spacing: 0
	});

	var StackWrap = ChartElement.extend({
	    reflow: function(targetBox) {
	        var this$1 = this;

	        var positionAxis = this.options.vertical ? X : Y;
	        var children = this.children;
	        var childrenCount = children.length;
	        var box = this.box = new Box();

	        for (var i = 0; i < childrenCount; i++) {
	            var currentChild = children[i];

	            if (currentChild.visible !== false) {
	                var childBox = currentChild.box.clone();
	                childBox.snapTo(targetBox, positionAxis);

	                if (i === 0) {
	                    box = this$1.box = childBox.clone();
	                }

	                currentChild.reflow(childBox);
	                box.wrap(childBox);
	            }
	        }
	    }
	});

	setDefaultOptions(StackWrap, {
	    vertical: true
	});

	var BarChart = CategoricalChart.extend({
	    render: function() {
	        CategoricalChart.fn.render.call(this);
	        this.updateStackRange();
	    },

	    pointType: function() {
	        return Bar;
	    },

	    clusterType: function() {
	        return ClusterLayout;
	    },

	    stackType: function() {
	        return StackWrap;
	    },

	    stackLimits: function(axisName, stackName) {
	        var limits = CategoricalChart.fn.stackLimits.call(this, axisName, stackName);

	        return limits;
	    },

	    createPoint: function(data, fields) {
	        var categoryIx = fields.categoryIx;
	        var category = fields.category;
	        var series = fields.series;
	        var seriesIx = fields.seriesIx;
	        var ref = this;
	        var options = ref.options;
	        var children = ref.children;
	        var isStacked = options.isStacked;
	        var value = this.pointValue(data);
	        var pointOptions = this.pointOptions(series, seriesIx);

	        var labelOptions = pointOptions.labels;
	        if (isStacked) {
	            if (labelOptions.position === OUTSIDE_END) {
	                labelOptions.position = INSIDE_END;
	            }
	        }

	        pointOptions.isStacked = isStacked;

	        var color = data.fields.color || series.color;
	        if (value < 0 && pointOptions.negativeColor) {
	            color = pointOptions.negativeColor;
	        }

	        pointOptions = this.evalPointOptions(
	            pointOptions, value, category, categoryIx, series, seriesIx
	        );

	        if (isFunction(series.color)) {
	            color = pointOptions.color;
	        }

	        var pointType = this.pointType();
	        var point = new pointType(value, pointOptions);
	        point.color = color;

	        var cluster = children[categoryIx];
	        if (!cluster) {
	            var clusterType = this.clusterType();
	            cluster = new clusterType({
	                vertical: options.invertAxes,
	                gap: options.gap,
	                spacing: options.spacing,
	                rtl: !options.invertAxes && (this.chartService || {}).rtl
	            });
	            this.append(cluster);
	        }

	        if (isStacked) {
	            var stackWrap = this.getStackWrap(series, cluster);
	            stackWrap.append(point);
	        } else {
	            cluster.append(point);
	        }

	        return point;
	    },

	    getStackWrap: function(series, cluster) {
	        var stack = series.stack;
	        var stackGroup = stack ? stack.group || stack : stack;
	        var wraps = cluster.children;
	        var stackWrap;

	        if (typeof stackGroup === datavizConstants.STRING) {
	            for (var i = 0; i < wraps.length; i++) {
	                if (wraps[i]._stackGroup === stackGroup) {
	                    stackWrap = wraps[i];
	                    break;
	                }
	            }
	        } else {
	            stackWrap = wraps[0];
	        }

	        if (!stackWrap) {
	            var stackType = this.stackType();
	            stackWrap = new stackType({
	                vertical: !this.options.invertAxes
	            });
	            stackWrap._stackGroup = stackGroup;
	            cluster.append(stackWrap);
	        }

	        return stackWrap;
	    },

	    categorySlot: function(categoryAxis, categoryIx, valueAxis) {
	        var options = this.options;
	        var categorySlot = categoryAxis.getSlot(categoryIx);
	        var startValue = valueAxis.startValue();

	        if (options.isStacked) {
	            var zeroSlot = valueAxis.getSlot(startValue, startValue, true);
	            var stackAxis = options.invertAxes ? X : Y;
	            categorySlot[stackAxis + 1] = categorySlot[stackAxis + 2] = zeroSlot[stackAxis + 1];
	        }

	        return categorySlot;
	    },

	    reflowCategories: function(categorySlots) {
	        var children = this.children;
	        var childrenLength = children.length;

	        for (var i = 0; i < childrenLength; i++) {
	            children[i].reflow(categorySlots[i]);
	        }
	    },

	    createAnimation: function() {
	        this._setAnimationOptions();
	        CategoricalChart.fn.createAnimation.call(this);

	        if (anyHasZIndex(this.options.series)) {
	            this._setChildrenAnimation();
	        }
	    },

	    _setChildrenAnimation: function() {
	        var this$1 = this;

	        var points = this.points;

	        for (var idx = 0; idx < points.length; idx++) {
	            var point = points[idx];
	            var pointVisual = point.visual;
	            if (pointVisual && defined(pointVisual.options.zIndex)) {
	                point.options.animation = this$1.options.animation;
	                point.createAnimation();
	            }
	        }
	    },

	    _setAnimationOptions: function() {
	        var options = this.options;
	        var animation = options.animation || {};
	        var origin;

	        if (options.isStacked) {
	            var valueAxis = this.seriesValueAxis(options.series[0]);
	            origin = valueAxis.getSlot(valueAxis.startValue());
	        } else {
	            origin = this.categoryAxis.getSlot(0);
	        }

	        animation.origin = new GeometryPoint(origin.x1, origin.y1);
	        animation.vertical = !options.invertAxes;
	    }
	});

	setDefaultOptions(BarChart, {
	    animation: {
	        type: BAR
	    }
	});

	var Candlestick = ChartElement.extend({
	    init: function(value, options) {
	        ChartElement.fn.init.call(this, options);
	        this.value = value;
	    },

	    reflow: function(box) {
	        var ref = this;
	        var options = ref.options;
	        var value = ref.value;
	        var chart = ref.owner;
	        var valueAxis = chart.seriesValueAxis(options);
	        var ocSlot = valueAxis.getSlot(value.open, value.close);
	        var lhSlot = valueAxis.getSlot(value.low, value.high);

	        ocSlot.x1 = lhSlot.x1 = box.x1;
	        ocSlot.x2 = lhSlot.x2 = box.x2;

	        this.realBody = ocSlot;

	        var mid = lhSlot.center().x;
	        var points = [];

	        points.push([ [ mid, lhSlot.y1 ], [ mid, ocSlot.y1 ] ]);
	        points.push([ [ mid, ocSlot.y2 ], [ mid, lhSlot.y2 ] ]);

	        this.lines = points;

	        this.box = lhSlot.clone().wrap(ocSlot);

	        if (!this._rendered) {
	            this._rendered = true;
	            this.createNote();
	        }

	        this.reflowNote();
	    },

	    reflowNote: function() {
	        if (this.note) {
	            this.note.reflow(this.box);
	        }
	    },

	    createVisual: function() {
	        ChartElement.fn.createVisual.call(this);
	        this._mainVisual = this.mainVisual(this.options);
	        this.visual.append(
	            this._mainVisual
	        );

	        this.createOverlay();
	    },

	    mainVisual: function(options) {
	        var group = new Group();

	        this.createBody(group, options);
	        this.createLines(group, options);

	        return group;
	    },

	    createBody: function(container, options) {
	        var body = Path.fromRect(this.realBody.toRect(), {
	            fill: {
	                color: this.color,
	                opacity: options.opacity
	            },
	            stroke: null
	        });

	        if (options.border.width > 0) {
	            body.options.set("stroke", {
	                color: this.getBorderColor(),
	                width: options.border.width,
	                dashType: options.border.dashType,
	                opacity: valueOrDefault(options.border.opacity, options.opacity)
	            });
	        }

	        alignPathToPixel(body);
	        container.append(body);

	        if (hasGradientOverlay(options)) {
	            container.append(this.createGradientOverlay(body, { baseColor: this.color }, deepExtend({
	                end: !options.vertical ? [ 0, 1 ] : undefined
	            }, options.overlay)));
	        }
	    },

	    createLines: function(container, options) {
	        this.drawLines(container, options, this.lines, options.line);
	    },

	    drawLines: function(container, options, lines, lineOptions) {
	        if (!lines) {
	            return;
	        }

	        var lineStyle = {
	            stroke: {
	                color: lineOptions.color || this.color,
	                opacity: valueOrDefault(lineOptions.opacity, options.opacity),
	                width: lineOptions.width,
	                dashType: lineOptions.dashType,
	                lineCap: "butt"
	            }
	        };

	        for (var i = 0; i < lines.length; i++) {
	            var line = Path.fromPoints(lines[i], lineStyle);
	            alignPathToPixel(line);
	            container.append(line);
	        }
	    },

	    getBorderColor: function() {
	        var border = this.options.border;
	        var borderColor = border.color;

	        if (!defined(borderColor)) {
	            borderColor = new Color(this.color).brightness(border._brightness).toHex();
	        }

	        return borderColor;
	    },

	    createOverlay: function() {
	        var overlay = Path.fromRect(this.box.toRect(), {
	            fill: {
	                color: WHITE,
	                opacity: 0
	            },
	            stroke: null
	        });

	        this.visual.append(overlay);
	    },

	    createHighlight: function() {
	        var highlight = this.options.highlight;
	        var normalColor = this.color;

	        this.color = highlight.color || this.color;
	        var overlay = this.mainVisual(
	            deepExtend({}, this.options, {
	                line: {
	                    color: this.getBorderColor()
	                }
	            }, highlight)
	        );
	        this.color = normalColor;

	        return overlay;
	    },

	    highlightVisual: function() {
	        return this._mainVisual;
	    },

	    highlightVisualArgs: function() {
	        return {
	            options: this.options,
	            rect: this.box.toRect(),
	            visual: this._mainVisual
	        };
	    },

	    tooltipAnchor: function() {
	        var box = this.box;
	        var clipBox = this.owner.pane.clipBox() || box;

	        return {
	            point: new Point(box.x2 + TOOLTIP_OFFSET, Math.max(box.y1, clipBox.y1) + TOOLTIP_OFFSET),
	            align: {
	                horizontal: LEFT,
	                vertical: TOP
	            }
	        };
	    },

	    formatValue: function(format) {
	        return this.owner.formatPointValue(this, format);
	    },

	    overlapsBox: function(box) {
	        return this.box.overlaps(box);
	    }
	});

	setDefaultOptions(Candlestick, {
	    vertical: true,
	    border: {
	        _brightness: 0.8
	    },
	    line: {
	        width: 2
	    },
	    overlay: {
	        gradient: "glass"
	    },
	    tooltip: {
	        format: "<table>" +
	                    "<tr><th colspan='2'>{4:d}</th></tr>" +
	                    "<tr><td>Open:</td><td>{0:C}</td></tr>" +
	                    "<tr><td>High:</td><td>{1:C}</td></tr>" +
	                    "<tr><td>Low:</td><td>{2:C}</td></tr>" +
	                    "<tr><td>Close:</td><td>{3:C}</td></tr>" +
	                "</table>"
	    },
	    highlight: {
	        opacity: 1,
	        border: {
	            width: 1,
	            opacity: 1
	        },
	        line: {
	            width: 1,
	            opacity: 1
	        }
	    },
	    notes: {
	        visible: true,
	        label: {}
	    }
	});

	deepExtend(Candlestick.prototype, PointEventsMixin);
	deepExtend(Candlestick.prototype, NoteMixin);

	function areNumbers(values) {
	    return countNumbers(values) === values.length;
	}

	var CandlestickChart = CategoricalChart.extend({
	    reflowCategories: function(categorySlots) {
	        var children = this.children;
	        var childrenLength = children.length;

	        for (var i = 0; i < childrenLength; i++) {
	            children[i].reflow(categorySlots[i]);
	        }
	    },

	    addValue: function(data, fields) {
	        var categoryIx = fields.categoryIx;
	        var category = fields.category;
	        var series = fields.series;
	        var seriesIx = fields.seriesIx;
	        var ref = this;
	        var children = ref.children;
	        var options = ref.options;
	        var value = data.valueFields;
	        var valueParts = this.splitValue(value);
	        var hasValue = areNumbers(valueParts);
	        var dataItem = series.data[categoryIx];
	        var categoryPoints = this.categoryPoints[categoryIx];
	        var point;

	        if (!categoryPoints) {
	            this.categoryPoints[categoryIx] = categoryPoints = [];
	        }

	        if (hasValue) {
	            point = this.createPoint(data, fields);
	        }

	        var cluster = children[categoryIx];
	        if (!cluster) {
	            cluster = new ClusterLayout({
	                vertical: options.invertAxes,
	                gap: options.gap,
	                spacing: options.spacing,
	                rtl: !options.invertAxes && (this.chartService || {}).rtl
	            });
	            this.append(cluster);
	        }

	        if (point) {
	            this.updateRange(value, fields);

	            cluster.append(point);

	            point.categoryIx = categoryIx;
	            point.category = category;
	            point.series = series;
	            point.seriesIx = seriesIx;
	            point.owner = this;
	            point.dataItem = dataItem;
	            point.noteText = data.fields.noteText;
	        }

	        this.points.push(point);
	        categoryPoints.push(point);
	    },

	    pointType: function() {
	        return Candlestick;
	    },

	    createPoint: function(data, fields) {
	        var categoryIx = fields.categoryIx;
	        var category = fields.category;
	        var series = fields.series;
	        var seriesIx = fields.seriesIx;
	        var pointType = this.pointType();
	        var value = data.valueFields;
	        var pointOptions = deepExtend({}, series);
	        var color = data.fields.color || series.color;

	        pointOptions = this.evalPointOptions(
	            pointOptions, value, category, categoryIx, series, seriesIx
	        );

	        if (series.type === CANDLESTICK) {
	            if (value.open > value.close) {
	                color = data.fields.downColor || series.downColor || series.color;
	            }
	        }

	        if (isFunction(series.color)) {
	            color = pointOptions.color;
	        }

	        pointOptions.vertical = !this.options.invertAxes;

	        var point = new pointType(value, pointOptions);
	        point.color = color;

	        return point;
	    },

	    splitValue: function(value) {
	        return [ value.low, value.open, value.close, value.high ];
	    },

	    updateRange: function(value, fields) {
	        var axisName = fields.series.axis;
	        var parts = this.splitValue(value);
	        var axisRange = this.valueAxisRanges[axisName];

	        axisRange = this.valueAxisRanges[axisName] =
	            axisRange || { min: MAX_VALUE, max: MIN_VALUE };

	        axisRange = this.valueAxisRanges[axisName] = {
	            min: Math.min.apply(Math, parts.concat([ axisRange.min ])),
	            max: Math.max.apply(Math, parts.concat([ axisRange.max ]))
	        };
	    },

	    formatPointValue: function(point, format) {
	        var value = point.value;

	        return this.chartService.format.auto(format,
	            value.open, value.high,
	            value.low, value.close, point.category
	        );
	    },

	    animationPoints: function() {
	        return this.points;
	    }
	});

	deepExtend(CandlestickChart.prototype, ClipAnimationMixin);

	var BoxPlot = Candlestick.extend({
	    init: function(value, options) {
	        Candlestick.fn.init.call(this, value, options);

	        this.createNote();
	    },

	    reflow: function(box) {
	        var ref = this;
	        var options = ref.options;
	        var value = ref.value;
	        var chart = ref.owner;
	        var valueAxis = chart.seriesValueAxis(options);
	        var whiskerSlot, boxSlot;

	        this.boxSlot = boxSlot = valueAxis.getSlot(value.q1, value.q3);
	        this.realBody = boxSlot;
	        this.reflowBoxSlot(box);

	        this.whiskerSlot = whiskerSlot = valueAxis.getSlot(value.lower, value.upper);
	        this.reflowWhiskerSlot(box);

	        var medianSlot = valueAxis.getSlot(value.median);

	        if (value.mean) {
	            var meanSlot = valueAxis.getSlot(value.mean);
	            this.meanPoints = this.calcMeanPoints(box, meanSlot);
	        }

	        this.whiskerPoints = this.calcWhiskerPoints(boxSlot, whiskerSlot);
	        this.medianPoints = this.calcMedianPoints(box, medianSlot);

	        this.box = whiskerSlot.clone().wrap(boxSlot);
	        this.reflowNote();
	    },

	    reflowBoxSlot: function(box) {
	        this.boxSlot.x1 = box.x1;
	        this.boxSlot.x2 = box.x2;
	    },

	    reflowWhiskerSlot: function(box) {
	        this.whiskerSlot.x1 = box.x1;
	        this.whiskerSlot.x2 = box.x2;
	    },

	    calcMeanPoints: function(box, meanSlot) {
	        return [
	            [ [ box.x1, meanSlot.y1 ], [ box.x2, meanSlot.y1 ] ]
	        ];
	    },

	    calcWhiskerPoints: function(boxSlot, whiskerSlot) {
	        var mid = whiskerSlot.center().x;
	        return [ [
	            [ mid - 5, whiskerSlot.y1 ], [ mid + 5, whiskerSlot.y1 ],
	            [ mid, whiskerSlot.y1 ], [ mid, boxSlot.y1 ]
	        ], [
	            [ mid - 5, whiskerSlot.y2 ], [ mid + 5, whiskerSlot.y2 ],
	            [ mid, whiskerSlot.y2 ], [ mid, boxSlot.y2 ]
	        ] ];
	    },

	    calcMedianPoints: function(box, medianSlot) {
	        return [
	            [ [ box.x1, medianSlot.y1 ], [ box.x2, medianSlot.y1 ] ]
	        ];
	    },

	    renderOutliers: function(options) {
	        var this$1 = this;

	        var value = this.value;
	        var outliers = value.outliers || [];
	        var outerFence = Math.abs(value.q3 - value.q1) * 3;
	        var elements = [];
	        var markers = options.markers || {};

	        for (var i = 0; i < outliers.length; i++) {
	            var outlierValue = outliers[i];
	            if (outlierValue < value.q3 + outerFence && outlierValue > value.q1 - outerFence) {
	                markers = options.outliers;
	            } else {
	                markers = options.extremes;
	            }
	            var markersBorder = deepExtend({}, markers.border);

	            if (!defined(markersBorder.color)) {
	                if (defined(this$1.color)) {
	                    markersBorder.color = this$1.color;
	                } else {
	                    markersBorder.color =
	                        new Color(markers.background).brightness(BORDER_BRIGHTNESS).toHex();
	                }
	            }

	            var shape = new ShapeElement({
	                type: markers.type,
	                width: markers.size,
	                height: markers.size,
	                rotation: markers.rotation,
	                background: markers.background,
	                border: markersBorder,
	                opacity: markers.opacity
	            });

	            shape.value = outlierValue;

	            elements.push(shape);
	        }

	        this.reflowOutliers(elements);
	        return elements;
	    },

	    reflowOutliers: function(outliers) {
	        var this$1 = this;

	        var valueAxis = this.owner.seriesValueAxis(this.options);
	        var center = this.box.center();

	        for (var i = 0; i < outliers.length; i++) {
	            var outlierValue = outliers[i].value;
	            var markerBox = valueAxis.getSlot(outlierValue);

	            if (this$1.options.vertical) {
	                markerBox.move(center.x);
	            } else {
	                markerBox.move(undefined, center.y);
	            }

	            this$1.box = this$1.box.wrap(markerBox);
	            outliers[i].reflow(markerBox);
	        }
	    },

	    mainVisual: function(options) {
	        var group = Candlestick.fn.mainVisual.call(this, options);
	        var outliers = this.renderOutliers(options);

	        for (var i = 0; i < outliers.length; i++) {
	            var element = outliers[i].getElement();
	            if (element) {
	                group.append(element);
	            }
	        }

	        return group;
	    },

	    createLines: function(container, options) {
	        this.drawLines(container, options, this.whiskerPoints, options.whiskers);
	        this.drawLines(container, options, this.medianPoints, options.median);
	        this.drawLines(container, options, this.meanPoints, options.mean);
	    },

	    getBorderColor: function() {
	        if ((this.options.border || {}).color) {
	            return this.options.border.color;
	        }

	        if (this.color) {
	            return this.color;
	        }

	        return Candlestick.fn.getBorderColor.call(this);
	    }
	});

	setDefaultOptions(BoxPlot, {
	    border: {
	        _brightness: 0.8
	    },
	    line: {
	        width: 2
	    },
	    median: {
	        color: "#f6f6f6"
	    },
	    mean: {
	        width: 2,
	        dashType: "dash",
	        color: "#f6f6f6"
	    },
	    overlay: {
	        gradient: "glass"
	    },
	    tooltip: {
	        format: "<table>" +
	                    "<tr><th colspan='2'>{6:d}</th></tr>" +
	                    "<tr><td>Lower:</td><td>{0:C}</td></tr>" +
	                    "<tr><td>Q1:</td><td>{1:C}</td></tr>" +
	                    "<tr><td>Median:</td><td>{2:C}</td></tr>" +
	                    "<tr><td>Mean:</td><td>{5:C}</td></tr>" +
	                    "<tr><td>Q3:</td><td>{3:C}</td></tr>" +
	                    "<tr><td>Upper:</td><td>{4:C}</td></tr>" +
	                "</table>"
	    },
	    highlight: {
	        opacity: 1,
	        border: {
	            width: 1,
	            opacity: 1
	        },
	        line: {
	            width: 1,
	            opacity: 1
	        }
	    },
	    notes: {
	        visible: true,
	        label: {}
	    },
	    outliers: {
	        visible: true,
	        size: LINE_MARKER_SIZE,
	        type: datavizConstants.CROSS,
	        background: WHITE,
	        border: {
	            width: 2,
	            opacity: 1
	        },
	        opacity: 0
	    },
	    extremes: {
	        visible: true,
	        size: LINE_MARKER_SIZE,
	        type: CIRCLE,
	        background: WHITE,
	        border: {
	            width: 2,
	            opacity: 1
	        },
	        opacity: 0
	    }
	});

	deepExtend(BoxPlot.prototype, PointEventsMixin);

	var VerticalBoxPlot = BoxPlot.extend({
	    reflowBoxSlot: function(box) {
	        this.boxSlot.y1 = box.y1;
	        this.boxSlot.y2 = box.y2;
	    },

	    reflowWhiskerSlot: function(box) {
	        this.whiskerSlot.y1 = box.y1;
	        this.whiskerSlot.y2 = box.y2;
	    },

	    calcMeanPoints: function(box, meanSlot) {
	        return [
	            [ [ meanSlot.x1, box.y1 ], [ meanSlot.x1, box.y2 ] ]
	        ];
	    },

	    calcWhiskerPoints: function(boxSlot, whiskerSlot) {
	        var mid = whiskerSlot.center().y;
	        return [ [
	            [ whiskerSlot.x1, mid - 5 ], [ whiskerSlot.x1, mid + 5 ],
	            [ whiskerSlot.x1, mid ], [ boxSlot.x1, mid ]
	        ], [
	            [ whiskerSlot.x2, mid - 5 ], [ whiskerSlot.x2, mid + 5 ],
	            [ whiskerSlot.x2, mid ], [ boxSlot.x2, mid ]
	        ] ];
	    },

	    calcMedianPoints: function(box, medianSlot) {
	        return [
	            [ [ medianSlot.x1, box.y1 ], [ medianSlot.x1, box.y2 ] ]
	        ];
	    }
	});

	var BoxPlotChart = CandlestickChart.extend({
	    addValue: function(data, fields) {
	        var categoryIx = fields.categoryIx;
	        var category = fields.category;
	        var series = fields.series;
	        var seriesIx = fields.seriesIx;
	        var ref = this;
	        var children = ref.children;
	        var options = ref.options;
	        var value = data.valueFields;
	        var valueParts = this.splitValue(value);
	        var hasValue = areNumbers(valueParts);
	        var dataItem = series.data[categoryIx];
	        var categoryPoints = this.categoryPoints[categoryIx];
	        var point;

	        if (!categoryPoints) {
	            this.categoryPoints[categoryIx] = categoryPoints = [];
	        }

	        if (hasValue) {
	            point = this.createPoint(data, fields);
	        }

	        var cluster = children[categoryIx];
	        if (!cluster) {
	            cluster = new ClusterLayout({
	                vertical: options.invertAxes,
	                gap: options.gap,
	                spacing: options.spacing,
	                rtl: !options.invertAxes && (this.chartService || {}).rtl
	            });
	            this.append(cluster);
	        }

	        if (point) {
	            this.updateRange(value, fields);

	            cluster.append(point);

	            point.categoryIx = categoryIx;
	            point.category = category;
	            point.series = series;
	            point.seriesIx = seriesIx;
	            point.owner = this;
	            point.dataItem = dataItem;
	        }

	        this.points.push(point);
	        categoryPoints.push(point);
	    },

	    pointType: function() {
	        if (this.options.invertAxes) {
	            return VerticalBoxPlot;
	        }

	        return BoxPlot;
	    },

	    splitValue: function(value) {
	        return [
	            value.lower, value.q1, value.median,
	            value.q3, value.upper
	        ];
	    },

	    updateRange: function(value, fields) {
	        var axisName = fields.series.axis;
	        var axisRange = this.valueAxisRanges[axisName];
	        var parts = this.splitValue(value).concat(this.filterOutliers(value.outliers));

	        if (defined(value.mean)) {
	            parts = parts.concat(value.mean);
	        }

	        axisRange = this.valueAxisRanges[axisName] =
	            axisRange || { min: MAX_VALUE, max: MIN_VALUE };

	        axisRange = this.valueAxisRanges[axisName] = {
	            min: Math.min.apply(Math, parts.concat([ axisRange.min ])),
	            max: Math.max.apply(Math, parts.concat([ axisRange.max ]))
	        };
	    },

	    formatPointValue: function(point, format) {
	        var value = point.value;

	        return this.chartService.format.auto(format,
	            value.lower, value.q1, value.median,
	            value.q3, value.upper, value.mean, point.category
	        );
	    },

	    filterOutliers: function(items) {
	        var length = (items || []).length;
	        var result = [];

	        for (var i = 0; i < length; i++) {
	            var item = items[i];
	            if (defined(item) && item !== null) {
	                result.push(item);
	            }
	        }

	        return result;
	    }
	});

	var ScatterErrorBar = ErrorBarBase.extend({
	    getAxis: function() {
	        var axes = this.chart.seriesAxes(this.series);
	        var axis = this.isVertical ? axes.y : axes.x;

	        return axis;
	    }
	});

	function hasValue(value) {
	    return defined(value) && value !== null;
	}

	var ScatterChart = ChartElement.extend({
	    init: function(plotArea, options) {

	        ChartElement.fn.init.call(this, options);

	        this.plotArea = plotArea;
	        this.chartService = plotArea.chartService;
	        this._initFields();

	        this.render();
	    },

	    _initFields: function() {
	        // X and Y axis ranges grouped by name, e.g.:
	        // primary: { min: 0, max: 1 }
	        this.xAxisRanges = {};
	        this.yAxisRanges = {};

	        this.points = [];
	        this.seriesPoints = [];
	        this.seriesOptions = [];
	        this._evalSeries = [];
	    },

	    render: function() {
	        this.traverseDataPoints(this.addValue.bind(this));
	    },

	    addErrorBar: function(point, field, fields) {
	        var value = point.value[field];
	        var valueErrorField = field + "Value";
	        var lowField = field + "ErrorLow";
	        var highField = field + "ErrorHigh";
	        var seriesIx = fields.seriesIx;
	        var series = fields.series;
	        var errorBars = point.options.errorBars;
	        var lowValue = fields[lowField];
	        var highValue = fields[highField];

	        if (isNumber(value)) {
	            var errorRange;
	            if (isNumber(lowValue) && isNumber(highValue)) {
	                errorRange = { low: lowValue, high: highValue };
	            }

	            if (errorBars && defined(errorBars[valueErrorField])) {
	                this.seriesErrorRanges = this.seriesErrorRanges || { x: [], y: [] };
	                this.seriesErrorRanges[field][seriesIx] = this.seriesErrorRanges[field][seriesIx] ||
	                    new ErrorRangeCalculator(errorBars[valueErrorField], series, field);

	                errorRange = this.seriesErrorRanges[field][seriesIx].getErrorRange(value, errorBars[valueErrorField]);
	            }

	            if (errorRange) {
	                this.addPointErrorBar(errorRange, point, field);
	            }
	        }
	    },

	    addPointErrorBar: function(errorRange, point, field) {
	        var low = errorRange.low;
	        var high = errorRange.high;
	        var series = point.series;
	        var options = point.options.errorBars;
	        var isVertical = field === Y;
	        var item = {};

	        point[field + "Low"] = low;
	        point[field + "High"] = high;

	        point.errorBars = point.errorBars || [];
	        var errorBar = new ScatterErrorBar(low, high, isVertical, this, series, options);
	        point.errorBars.push(errorBar);
	        point.append(errorBar);

	        item[field] = low;
	        this.updateRange(item, series);
	        item[field] = high;
	        this.updateRange(item, series);
	    },

	    addValue: function(value, fields) {
	        var x = value.x;
	        var y = value.y;
	        var seriesIx = fields.seriesIx;
	        var series = this.options.series[seriesIx];
	        var missingValues = this.seriesMissingValues(series);
	        var seriesPoints = this.seriesPoints[seriesIx];

	        var pointValue = value;
	        if (!(hasValue(x) && hasValue(y))) {
	            pointValue = this.createMissingValue(pointValue, missingValues);
	        }

	        var point;
	        if (pointValue) {
	            point = this.createPoint(pointValue, fields);
	            if (point) {
	                $.extend(point, fields);
	                this.addErrorBar(point, X, fields);
	                this.addErrorBar(point, Y, fields);
	            }
	            this.updateRange(pointValue, fields.series);
	        }

	        this.points.push(point);
	        seriesPoints.push(point);
	    },

	    seriesMissingValues: function(series) {
	        return series.missingValues;
	    },

	    createMissingValue: function() {},

	    updateRange: function(value, series) {
	        var intlService = this.chartService.intl;
	        var xAxisName = series.xAxis;
	        var yAxisName = series.yAxis;
	        var x = value.x;
	        var y = value.y;
	        var xAxisRange = this.xAxisRanges[xAxisName];
	        var yAxisRange = this.yAxisRanges[yAxisName];

	        if (hasValue(x)) {
	            xAxisRange = this.xAxisRanges[xAxisName] =
	                xAxisRange || { min: MAX_VALUE, max: MIN_VALUE };

	            if (isString(x)) {
	                x = parseDate(intlService, x);
	            }

	            xAxisRange.min = Math.min(xAxisRange.min, x);
	            xAxisRange.max = Math.max(xAxisRange.max, x);
	        }

	        if (hasValue(y)) {
	            yAxisRange = this.yAxisRanges[yAxisName] =
	                yAxisRange || { min: MAX_VALUE, max: MIN_VALUE };

	            if (isString(y)) {
	                y = parseDate(intlService, y);
	            }

	            yAxisRange.min = Math.min(yAxisRange.min, y);
	            yAxisRange.max = Math.max(yAxisRange.max, y);
	        }
	    },

	    evalPointOptions: function(options, value, fields) {
	        var series = fields.series;
	        var seriesIx = fields.seriesIx;
	        var state = { defaults: series._defaults, excluded: [ "data", "tooltip", "content", "template", "visual", "toggle", "_outOfRangeMinPoint", "_outOfRangeMaxPoint" ] };

	        var doEval = this._evalSeries[seriesIx];
	        if (!defined(doEval)) {
	            this._evalSeries[seriesIx] = doEval = evalOptions(options, {}, state, true);
	        }

	        var pointOptions = options;
	        if (doEval) {
	            pointOptions = deepExtend({}, options);
	            evalOptions(pointOptions, {
	                value: value,
	                series: series,
	                dataItem: fields.dataItem
	            }, state);
	        }

	        return pointOptions;
	    },

	    pointType: function() {
	        return LinePoint;
	    },

	    pointOptions: function(series, seriesIx) {
	        var options = this.seriesOptions[seriesIx];
	        if (!options) {
	            var defaults = this.pointType().prototype.defaults;
	            this.seriesOptions[seriesIx] = options = deepExtend({}, defaults, {
	                markers: {
	                    opacity: series.opacity
	                },
	                tooltip: {
	                    format: this.options.tooltip.format
	                },
	                labels: {
	                    format: this.options.labels.format
	                }
	            }, series);
	        }

	        return options;
	    },

	    createPoint: function(value, fields) {
	        var series = fields.series;
	        var pointOptions = this.pointOptions(series, fields.seriesIx);
	        var color = fields.color || series.color;

	        pointOptions = this.evalPointOptions(pointOptions, value, fields);

	        if (isFunction(series.color)) {
	            color = pointOptions.color;
	        }

	        var point = new LinePoint(value, pointOptions);
	        point.color = color;

	        this.append(point);

	        return point;
	    },

	    seriesAxes: function(series) {
	        var xAxisName = series.xAxis;
	        var yAxisName = series.yAxis;
	        var plotArea = this.plotArea;
	        var xAxis = xAxisName ? plotArea.namedXAxes[xAxisName] : plotArea.axisX;
	        var yAxis = yAxisName ? plotArea.namedYAxes[yAxisName] : plotArea.axisY;

	        if (!xAxis) {
	            throw new Error("Unable to locate X axis with name " + xAxisName);
	        }

	        if (!yAxis) {
	            throw new Error("Unable to locate Y axis with name " + yAxisName);
	        }

	        return {
	            x: xAxis,
	            y: yAxis
	        };
	    },

	    reflow: function(targetBox) {
	        var this$1 = this;

	        var chartPoints = this.points;
	        var limit = !this.options.clip;
	        var pointIx = 0;

	        this.traverseDataPoints(function (value, fields) {
	            var point = chartPoints[pointIx++];
	            var seriesAxes = this$1.seriesAxes(fields.series);
	            var slotX = seriesAxes.x.getSlot(value.x, value.x, limit);
	            var slotY = seriesAxes.y.getSlot(value.y, value.y, limit);

	            if (point) {
	                if (slotX && slotY) {
	                    var pointSlot = this$1.pointSlot(slotX, slotY);
	                    point.reflow(pointSlot);
	                } else {
	                    point.visible = false;
	                }
	            }
	        });

	        this.box = targetBox;
	    },

	    pointSlot: function(slotX, slotY) {
	        return new Box(slotX.x1, slotY.y1, slotX.x2, slotY.y2);
	    },

	    traverseDataPoints: function(callback) {
	        var this$1 = this;

	        var ref = this;
	        var series = ref.options.series;
	        var seriesPoints = ref.seriesPoints;

	        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
	            var currentSeries = series[seriesIx];
	            var currentSeriesPoints = seriesPoints[seriesIx];
	            if (!currentSeriesPoints) {
	                seriesPoints[seriesIx] = [];
	            }

	            for (var pointIx = 0; pointIx < currentSeries.data.length; pointIx++) {
	                var ref$1 = this$1._bindPoint(currentSeries, seriesIx, pointIx);
	                var value = ref$1.valueFields;
	                var fields = ref$1.fields;

	                callback(value, deepExtend({
	                    pointIx: pointIx,
	                    series: currentSeries,
	                    seriesIx: seriesIx,
	                    dataItem: currentSeries.data[pointIx],
	                    owner: this$1
	                }, fields));
	            }
	        }
	    },

	    formatPointValue: function(point, format) {
	        var value = point.value;
	        return this.chartService.format.auto(format, value.x, value.y);
	    },

	    animationPoints: function() {
	        var points = this.points;
	        var result = [];
	        for (var idx = 0; idx < points.length; idx++) {
	            result.push((points[idx] || {}).marker);
	        }
	        return result;
	    }
	});
	setDefaultOptions(ScatterChart, {
	    series: [],
	    tooltip: {
	        format: "{0}, {1}"
	    },
	    labels: {
	        format: "{0}, {1}"
	    },
	    clip: true
	});
	deepExtend(ScatterChart.prototype, ClipAnimationMixin, {
	    _bindPoint: CategoricalChart.prototype._bindPoint
	});

	var Bubble = LinePoint.extend({
	    init: function(value, options) {
	        LinePoint.fn.init.call(this, value, options);

	        this.category = value.category;
	    },

	    createHighlight: function() {
	        var highlight = this.options.highlight;
	        var border = highlight.border;
	        var markers = this.options.markers;
	        var center = this.box.center();
	        var radius = (markers.size + markers.border.width + border.width) / 2;
	        var highlightGroup = new Group();
	        var shadow = new drawing.Circle(new geometry.Circle([ center.x, center.y + radius / 5 + border.width / 2 ], radius + border.width / 2), {
	            stroke: {
	                color: 'none'
	            },
	            fill: this.createGradient({
	                gradient: 'bubbleShadow',
	                color: markers.background,
	                stops: [ {
	                    offset: 0,
	                    color: markers.background,
	                    opacity: 0.3
	                }, {
	                    offset: 1,
	                    color: markers.background,
	                    opacity: 0
	                } ]
	            })
	        });
	        var overlay = new drawing.Circle(new geometry.Circle([ center.x, center.y ], radius), {
	            stroke: {
	                color: border.color ||
	                    new Color(markers.background).brightness(BORDER_BRIGHTNESS).toHex(),
	                width: border.width,
	                opacity: border.opacity
	            },
	            fill: {
	                color: markers.background,
	                opacity: highlight.opacity
	            }
	        });

	        highlightGroup.append(shadow, overlay);

	        return highlightGroup;
	    }
	});

	Bubble.prototype.defaults = deepExtend({}, Bubble.prototype.defaults, {
	    labels: {
	        position: CENTER
	    },
	    highlight: {
	        opacity: 1,
	        border: {
	            color: "#fff",
	            width: 2,
	            opacity: 1
	        }
	    }
	});

	Bubble.prototype.defaults.highlight.zIndex = undefined;

	var BubbleChart = ScatterChart.extend({
	    _initFields: function() {
	        this._maxSize = MIN_VALUE;
	        ScatterChart.fn._initFields.call(this);
	    },

	    addValue: function(value, fields) {
	        if (value.size !== null && (value.size > 0 || (value.size < 0 && fields.series.negativeValues.visible))) {
	            this._maxSize = Math.max(this._maxSize, Math.abs(value.size));
	            ScatterChart.fn.addValue.call(this, value, fields);
	        } else {
	            this.points.push(null);
	            this.seriesPoints[fields.seriesIx].push(null);
	        }
	    },

	    reflow: function(box) {
	        this.updateBubblesSize(box);
	        ScatterChart.fn.reflow.call(this, box);
	    },

	    pointType: function() {
	        return Bubble;
	    },

	    createPoint: function(value, fields) {
	        var series = fields.series;
	        var pointsCount = series.data.length;
	        var delay = fields.pointIx * (INITIAL_ANIMATION_DURATION / pointsCount);
	        var animationOptions = {
	            delay: delay,
	            duration: INITIAL_ANIMATION_DURATION - delay,
	            type: BUBBLE
	        };

	        var color = fields.color || series.color;
	        if (value.size < 0 && series.negativeValues.visible) {
	            color = valueOrDefault(
	                series.negativeValues.color, color
	            );
	        }

	        var pointOptions = deepExtend({
	            labels: {
	                animation: {
	                    delay: delay,
	                    duration: INITIAL_ANIMATION_DURATION - delay
	                }
	            }
	        }, this.pointOptions(series, fields.seriesIx), {
	            markers: {
	                type: CIRCLE,
	                border: series.border,
	                opacity: series.opacity,
	                animation: animationOptions
	            }
	        });

	        pointOptions = this.evalPointOptions(pointOptions, value, fields);
	        if (isFunction(series.color)) {
	            color = pointOptions.color;
	        }

	        pointOptions.markers.background = color;

	        var point = new Bubble(value, pointOptions);
	        point.color = color;

	        this.append(point);

	        return point;
	    },

	    updateBubblesSize: function(box) {
	        var this$1 = this;

	        var ref = this;
	        var series = ref.options.series;
	        var boxSize = Math.min(box.width(), box.height());

	        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
	            var currentSeries = series[seriesIx];
	            var seriesPoints = this$1.seriesPoints[seriesIx];
	            var minSize = currentSeries.minSize || Math.max(boxSize * 0.02, 10);
	            var maxSize = currentSeries.maxSize || boxSize * 0.2;
	            var minR = minSize / 2;
	            var maxR = maxSize / 2;
	            var minArea = Math.PI * minR * minR;
	            var maxArea = Math.PI * maxR * maxR;
	            var areaRange = maxArea - minArea;
	            var areaRatio = areaRange / this$1._maxSize;

	            for (var pointIx = 0; pointIx < seriesPoints.length; pointIx++) {
	                var point = seriesPoints[pointIx];
	                if (point) {
	                    var area = Math.abs(point.value.size) * areaRatio;
	                    var radius = Math.sqrt((minArea + area) / Math.PI);
	                    var baseZIndex = valueOrDefault(point.options.zIndex, 0);
	                    var zIndex = baseZIndex + (1 - radius / maxR);

	                    deepExtend(point.options, {
	                        zIndex: zIndex,
	                        markers: {
	                            size: radius * 2,
	                            zIndex: zIndex
	                        },
	                        labels: {
	                            zIndex: zIndex + 1
	                        }
	                    });
	                }
	            }
	        }
	    },

	    formatPointValue: function(point, format) {
	        var value = point.value;
	        return this.chartService.format.auto(format, value.x, value.y, value.size, point.category);
	    },

	    createAnimation: function() {},

	    createVisual: function() {}
	});

	setDefaultOptions(BubbleChart, {
	    tooltip: {
	        format: "{3}"
	    },
	    labels: {
	        format: "{3}"
	    }
	});

	var Target = ShapeElement.extend({

	});

	deepExtend(Target.prototype, PointEventsMixin);

	var Bullet = ChartElement.extend({
	    init: function(value, options) {
	        ChartElement.fn.init.call(this, options);

	        this.aboveAxis = this.options.aboveAxis;
	        this.color = options.color || WHITE;
	        this.value = value;
	    },

	    render: function() {
	        var options = this.options;

	        if (!this._rendered) {
	            this._rendered = true;

	            if (defined(this.value.target)) {
	                this.target = new Target({
	                    type: options.target.shape,
	                    background: options.target.color || this.color,
	                    opacity: options.opacity,
	                    zIndex: options.zIndex,
	                    border: options.target.border,
	                    vAlign: TOP,
	                    align: RIGHT
	                });

	                this.target.value = this.value;
	                this.target.dataItem = this.dataItem;
	                this.target.series = this.series;

	                this.append(this.target);
	            }

	            this.createNote();
	        }
	    },

	    reflow: function(box) {
	        this.render();

	        var ref = this;
	        var options = ref.options;
	        var target = ref.target;
	        var chart = ref.owner;
	        var invertAxes = options.invertAxes;
	        var valueAxis = chart.seriesValueAxis(this.options);
	        var categorySlot = chart.categorySlot(chart.categoryAxis, options.categoryIx, valueAxis);
	        var targetValueSlot = valueAxis.getSlot(this.value.target);
	        var targetSlotX = invertAxes ? targetValueSlot : categorySlot;
	        var targetSlotY = invertAxes ? categorySlot : targetValueSlot;

	        if (target) {
	            var targetSlot = new Box(
	                targetSlotX.x1, targetSlotY.y1,
	                targetSlotX.x2, targetSlotY.y2
	            );
	            target.options.height = invertAxes ? targetSlot.height() : options.target.line.width;
	            target.options.width = invertAxes ? options.target.line.width : targetSlot.width();
	            target.reflow(targetSlot);
	        }

	        if (this.note) {
	            this.note.reflow(box);
	        }

	        this.box = box;
	    },

	    createVisual: function() {
	        ChartElement.fn.createVisual.call(this);

	        var options = this.options;
	        var body = Path.fromRect(this.box.toRect(), {
	            fill: {
	                color: this.color,
	                opacity: options.opacity
	            },
	            stroke: null
	        });

	        if (options.border.width > 0) {
	            body.options.set("stroke", {
	                color: options.border.color || this.color,
	                width: options.border.width,
	                dashType: options.border.dashType,
	                opacity: valueOrDefault(options.border.opacity, options.opacity)
	            });
	        }

	        this.bodyVisual = body;

	        alignPathToPixel(body);
	        this.visual.append(body);
	    },

	    createAnimation: function() {
	        if (this.bodyVisual) {
	            this.animation = Animation.create(
	                this.bodyVisual, this.options.animation
	            );
	        }
	    },

	    createHighlight: function(style) {
	        return Path.fromRect(this.box.toRect(), style);
	    },

	    highlightVisual: function() {
	        return this.bodyVisual;
	    },

	    highlightVisualArgs: function() {
	        return {
	            rect: this.box.toRect(),
	            visual: this.bodyVisual,
	            options: this.options
	        };
	    },

	    formatValue: function(format) {
	        return this.owner.formatPointValue(this, format);
	    }
	});

	Bullet.prototype.tooltipAnchor = Bar.prototype.tooltipAnchor;

	setDefaultOptions(Bullet, {
	    border: {
	        width: 1
	    },
	    vertical: false,
	    opacity: 1,
	    target: {
	        shape: "",
	        border: {
	            width: 0,
	            color: "green"
	        },
	        line: {
	            width: 2
	        }
	    },
	    tooltip: {
	        format: "Current: {0}<br />Target: {1}"
	    }
	});

	deepExtend(Bullet.prototype, PointEventsMixin);
	deepExtend(Bullet.prototype, NoteMixin);

	var BulletChart = CategoricalChart.extend({
	    init: function(plotArea, options) {

	        wrapData(options);

	        CategoricalChart.fn.init.call(this, plotArea, options);
	    },

	    reflowCategories: function(categorySlots) {
	        var children = this.children;
	        var childrenLength = children.length;

	        for (var i = 0; i < childrenLength; i++) {
	            children[i].reflow(categorySlots[i]);
	        }
	    },

	    plotRange: function(point) {
	        var series = point.series;
	        var valueAxis = this.seriesValueAxis(series);
	        var axisCrossingValue = this.categoryAxisCrossingValue(valueAxis);

	        return [ axisCrossingValue, point.value.current || axisCrossingValue ];
	    },

	    createPoint: function(data, fields) {
	        var categoryIx = fields.categoryIx;
	        var category = fields.category;
	        var series = fields.series;
	        var seriesIx = fields.seriesIx;
	        var ref = this;
	        var options = ref.options;
	        var children = ref.children;
	        var value = data.valueFields;

	        var bulletOptions = deepExtend({
	            vertical: !options.invertAxes,
	            overlay: series.overlay,
	            categoryIx: categoryIx,
	            invertAxes: options.invertAxes
	        }, series);

	        var color = data.fields.color || series.color;
	        bulletOptions = this.evalPointOptions(
	            bulletOptions, value, category, categoryIx, series, seriesIx
	        );

	        if (isFunction(series.color)) {
	            color = bulletOptions.color;
	        }

	        var bullet = new Bullet(value, bulletOptions);
	        bullet.color = color;

	        var cluster = children[categoryIx];
	        if (!cluster) {
	            cluster = new ClusterLayout({
	                vertical: options.invertAxes,
	                gap: options.gap,
	                spacing: options.spacing,
	                rtl: !options.invertAxes && (this.chartService || {}).rtl
	            });
	            this.append(cluster);
	        }

	        cluster.append(bullet);

	        return bullet;
	    },

	    updateRange: function(value, fields) {
	        var current = value.current;
	        var target = value.target;
	        var axisName = fields.series.axis;
	        var axisRange = this.valueAxisRanges[axisName];

	        if (defined(current) && !isNaN(current) && defined(target && !isNaN(target))) {
	            axisRange = this.valueAxisRanges[axisName] =
	                axisRange || { min: MAX_VALUE, max: MIN_VALUE };

	            axisRange.min = Math.min(axisRange.min, current, target);
	            axisRange.max = Math.max(axisRange.max, current, target);
	        }
	    },

	    formatPointValue: function(point, format) {
	        return this.chartService.format.auto(format, point.value.current, point.value.target);
	    },

	    pointValue: function(data) {
	        return data.valueFields.current;
	    },

	    aboveAxis: function(point) {
	        var value = point.value.current;

	        return value > 0;
	    },

	    createAnimation: function() {
	        var this$1 = this;

	        var points = this.points;

	        this._setAnimationOptions();

	        for (var idx = 0; idx < points.length; idx++) {
	            var point = points[idx];
	            point.options.animation = this$1.options.animation;
	            point.createAnimation();
	        }
	    }
	});

	BulletChart.prototype._setAnimationOptions = BarChart.prototype._setAnimationOptions;

	setDefaultOptions(BulletChart, {
	    animation: {
	        type: BAR
	    }
	});

	function wrapData(options) {
	    var series = options.series;

	    for (var i = 0; i < series.length; i++) {
	        var seriesItem = series[i];
	        var data = seriesItem.data;
	        if (data && !isArray(data[0]) && !isObject(data[0])) {
	            seriesItem.data = [ data ];
	        }
	    }
	}

	var BaseTooltip = Class.extend({
	    init: function(chartService, options) {

	        this.chartService = chartService;
	        this.options = deepExtend({}, this.options, options);
	    },

	    getStyle: function(options, point) {
	        var background = options.background;
	        var border = options.border.color;

	        if (point) {
	            var pointColor = point.color || point.options.color;
	            background = valueOrDefault(background, pointColor);
	            border = valueOrDefault(border, pointColor);
	        }

	        var padding = getSpacing(options.padding || {}, "auto");

	        return {
	            backgroundColor: background,
	            borderColor: border,
	            font: options.font,
	            color: options.color,
	            opacity: options.opacity,
	            borderWidth: styleValue(options.border.width),
	            paddingTop: styleValue(padding.top),
	            paddingBottom: styleValue(padding.bottom),
	            paddingLeft: styleValue(padding.left),
	            paddingRight: styleValue(padding.right)
	        };
	    },

	    show: function(options, tooltipOptions, point) {
	        options.format = tooltipOptions.format;

	        var style = this.getStyle(tooltipOptions, point);
	        options.style = style;

	        if (!defined(tooltipOptions.color) && new Color(style.backgroundColor).percBrightness() > 180) {
	            options.className = "k-chart-tooltip-inverse";
	        }

	        this.chartService.notify(SHOW_TOOLTIP, options);

	        this.visible = true;
	    },

	    hide: function() {
	        if (this.chartService) {
	            this.chartService.notify(HIDE_TOOLTIP);
	        }

	        this.visible = false;
	    },

	    destroy: function() {
	        delete this.chartService;
	    }
	});

	setDefaultOptions(BaseTooltip, {
	    border: {
	        width: 1
	    },
	    opacity: 1
	});

	var CrosshairTooltip = BaseTooltip.extend({
	    init: function(chartService, crosshair, options) {
	        BaseTooltip.fn.init.call(this, chartService, options);

	        this.crosshair = crosshair;
	        this.formatService = chartService.format;
	        this.initAxisName();
	    },

	    initAxisName: function() {
	        var axis = this.crosshair.axis;
	        var plotArea = axis.plotArea;
	        var name;
	        if (plotArea.categoryAxis) {
	            name = axis.getCategory ? "categoryAxis" : "valueAxis";
	        } else {
	            name = axis.options.vertical ? "yAxis" : "xAxis";
	        }
	        this.axisName = name;
	    },

	    showAt: function(point) {
	        var ref = this;
	        var axis = ref.crosshair.axis;
	        var options = ref.options;
	        var value = axis[options.stickyMode ? "getCategory" : "getValue"](point);
	        var formattedValue = value;

	        if (options.format) {
	            formattedValue = this.formatService.auto(options.format, value);
	        } else if (axis.options.type === DATE) {
	            formattedValue = this.formatService.auto(axis.options.labels.dateFormats[axis.options.baseUnit], value);
	        }

	        this.show({
	            point: point,
	            anchor: this.getAnchor(),
	            crosshair: this.crosshair,
	            value: formattedValue,
	            axisName: this.axisName,
	            axisIndex: this.crosshair.axis.axisIndex
	        }, this.options);
	    },

	    hide: function() {
	        this.chartService.notify(HIDE_TOOLTIP, {
	            crosshair: this.crosshair,
	            axisName: this.axisName,
	            axisIndex: this.crosshair.axis.axisIndex
	        });
	    },

	    getAnchor: function() {
	        var ref = this;
	        var crosshair = ref.crosshair;
	        var ref_options = ref.options;
	        var position = ref_options.position;
	        var padding = ref_options.padding;
	        var vertical = !crosshair.axis.options.vertical;
	        var lineBox = crosshair.line.bbox();
	        var horizontalAlign, verticalAlign, point;

	        if (vertical) {
	            horizontalAlign = CENTER;
	            if (position === BOTTOM) {
	                verticalAlign = TOP;
	                point = lineBox.bottomLeft().translate(0, padding);
	            } else {
	                verticalAlign = BOTTOM;
	                point = lineBox.topLeft().translate(0, -padding);
	            }
	        } else {
	            verticalAlign = CENTER;
	            if (position === LEFT) {
	                horizontalAlign = RIGHT;
	                point = lineBox.topLeft().translate(-padding, 0);
	            } else {
	                horizontalAlign = LEFT;
	                point = lineBox.topRight().translate(padding, 0);
	            }
	        }

	        return {
	            point: point,
	            align: {
	                horizontal: horizontalAlign,
	                vertical: verticalAlign
	            }
	        };
	    }
	});

	setDefaultOptions(CrosshairTooltip, {
	    padding: 10
	});

	var Crosshair = ChartElement.extend({
	    init: function(chartService, axis, options) {
	        ChartElement.fn.init.call(this, options);

	        this.axis = axis;
	        this.stickyMode = axis instanceof CategoryAxis;

	        var tooltipOptions = this.options.tooltip;

	        if (tooltipOptions.visible) {
	            this.tooltip = new CrosshairTooltip(chartService, this,
	                deepExtend({}, tooltipOptions, { stickyMode: this.stickyMode })
	            );
	        }
	    },

	    showAt: function(point) {
	        this.point = point;
	        this.moveLine();
	        this.line.visible(true);

	        if (this.tooltip) {
	            this.tooltip.showAt(point);
	        }
	    },

	    hide: function() {
	        this.line.visible(false);

	        if (this.tooltip) {
	            this.tooltip.hide();
	        }
	    },

	    moveLine: function() {
	        var ref = this;
	        var axis = ref.axis;
	        var point = ref.point;
	        var vertical = axis.options.vertical;
	        var box = this.getBox();
	        var dim = vertical ? Y : X;
	        var lineStart = new GeometryPoint(box.x1, box.y1);
	        var lineEnd;

	        if (vertical) {
	            lineEnd = new GeometryPoint(box.x2, box.y1);
	        } else {
	            lineEnd = new GeometryPoint(box.x1, box.y2);
	        }

	        if (point) {
	            if (this.stickyMode) {
	                var slot = axis.getSlot(axis.pointCategoryIndex(point));
	                lineStart[dim] = lineEnd[dim] = slot.center()[dim];
	            } else {
	                lineStart[dim] = lineEnd[dim] = point[dim];
	            }
	        }

	        this.box = box;

	        this.line.moveTo(lineStart).lineTo(lineEnd);
	    },

	    getBox: function() {
	        var axis = this.axis;
	        var axes = axis.pane.axes;
	        var length = axes.length;
	        var vertical = axis.options.vertical;
	        var box = axis.lineBox().clone();
	        var dim = vertical ? X : Y;
	        var axisLineBox;

	        for (var i = 0; i < length; i++) {
	            var currentAxis = axes[i];
	            if (currentAxis.options.vertical !== vertical) {
	                if (!axisLineBox) {
	                    axisLineBox = currentAxis.lineBox().clone();
	                } else {
	                    axisLineBox.wrap(currentAxis.lineBox());
	                }
	            }
	        }

	        box[dim + 1] = axisLineBox[dim + 1];
	        box[dim + 2] = axisLineBox[dim + 2];

	        return box;
	    },

	    createVisual: function() {
	        ChartElement.fn.createVisual.call(this);

	        var options = this.options;
	        this.line = new Path({
	            stroke: {
	                color: options.color,
	                width: options.width,
	                opacity: options.opacity,
	                dashType: options.dashType
	            },
	            visible: false
	        });

	        this.moveLine();
	        this.visual.append(this.line);
	    },

	    destroy: function() {
	        if (this.tooltip) {
	            this.tooltip.destroy();
	        }

	        ChartElement.fn.destroy.call(this);
	    }
	});

	setDefaultOptions(Crosshair, {
	    color: BLACK,
	    width: 2,
	    zIndex: -1,
	    tooltip: {
	        visible: false
	    }
	});

	var ChartContainer = ChartElement.extend({
	    init: function(options, pane) {
	        ChartElement.fn.init.call(this, options);
	        this.pane = pane;
	    },

	    shouldClip: function() {
	        var children = this.children;
	        var length = children.length;

	        for (var i = 0; i < length; i++) {
	            if (children[i].options.clip === true) {
	                return true;
	            }
	        }
	        return false;
	    },

	    _clipBox: function() {
	        return this.pane.chartsBox();
	    },

	    createVisual: function() {
	        this.visual = new Group({
	            zIndex: 0
	        });

	        if (this.shouldClip()) {
	            var clipBox = this.clipBox = this._clipBox();
	            var clipRect = clipBox.toRect();
	            var clipPath = Path.fromRect(clipRect);
	            alignPathToPixel(clipPath);

	            this.visual.clip(clipPath);
	            this.unclipLabels();
	        }
	    },

	    stackRoot: function() {
	        return this;
	    },

	    unclipLabels: function() {
	        var ref = this;
	        var charts = ref.children;
	        var clipBox = ref.clipBox;

	        for (var i = 0; i < charts.length; i++) {
	            var points = charts[i].points || {};
	            var length = points.length;

	            for (var j = 0; j < length; j++) {
	                var point = points[j];
	                if (point && point.visible !== false && point.overlapsBox && point.overlapsBox(clipBox)) {
	                    if (point.unclipElements) {
	                        point.unclipElements();
	                    } else {
	                        var label = point.label;
	                        var note = point.note;

	                        if (label && label.options.visible) {
	                            if (label.alignToClipBox) {
	                                label.alignToClipBox(clipBox);
	                            }
	                            label.options.noclip = true;
	                        }

	                        if (note && note.options.visible) {
	                            note.options.noclip = true;
	                        }
	                    }
	                }
	            }
	        }
	    },

	    destroy: function() {
	        ChartElement.fn.destroy.call(this);

	        delete this.parent;
	    }
	});

	ChartContainer.prototype.isStackRoot = true;

	var Pane = BoxElement.extend({
	    init: function(options) {
	        BoxElement.fn.init.call(this, options);

	        this.id = paneID();

	        this.createTitle();

	        this.content = new ChartElement();

	        this.chartContainer = new ChartContainer({}, this);
	        this.append(this.content);

	        this.axes = [];
	        this.charts = [];
	    },

	    createTitle: function() {
	        var titleOptions = this.options.title;
	        if (isObject(titleOptions)) {
	            titleOptions = deepExtend({}, titleOptions, {
	                align: titleOptions.position,
	                position: TOP
	            });
	        }

	        this.title = dataviz.Title.buildTitle(titleOptions, this, Pane.prototype.options.title);
	    },

	    appendAxis: function(axis) {
	        this.content.append(axis);
	        this.axes.push(axis);
	        axis.pane = this;
	    },

	    appendAxisAt: function(axis, pos) {
	        this.content.append(axis);
	        this.axes.splice(pos, 0, axis);
	        axis.pane = this;
	    },

	    appendChart: function(chart) {
	        if (this.chartContainer.parent !== this.content) {
	            this.content.append(this.chartContainer);
	        }

	        this.charts.push(chart);
	        this.chartContainer.append(chart);
	        chart.pane = this;
	    },

	    empty: function() {
	        var this$1 = this;

	        var plotArea = this.parent;

	        if (plotArea) {
	            for (var i = 0; i < this.axes.length; i++) {
	                plotArea.removeAxis(this$1.axes[i]);
	            }

	            for (var i$1 = 0; i$1 < this.charts.length; i$1++) {
	                plotArea.removeChart(this$1.charts[i$1]);
	            }
	        }

	        this.axes = [];
	        this.charts = [];

	        this.content.destroy();
	        this.content.children = [];
	        this.chartContainer.children = [];
	    },

	    reflow: function(targetBox) {
	        // Content (such as charts) is rendered, but excluded from reflows
	        var content;
	        if (last(this.children) === this.content) {
	            content = this.children.pop();
	        }

	        BoxElement.fn.reflow.call(this, targetBox);

	        if (content) {
	            this.children.push(content);
	        }

	        if (this.title) {
	            this.contentBox.y1 += this.title.box.height();
	        }
	    },

	    visualStyle: function() {
	        var style = BoxElement.fn.visualStyle.call(this);
	        style.zIndex = -10;

	        return style;
	    },

	    renderComplete: function() {
	        if (this.options.visible) {
	            this.createGridLines();
	        }
	    },

	    stackRoot: function() {
	        return this;
	    },

	    clipRoot: function() {
	        return this;
	    },

	    createGridLines: function() {
	        var axes = this.axes;
	        var allAxes = axes.concat(this.parent.axes);
	        var vGridLines = [];
	        var hGridLines = [];

	        // TODO
	        // Is full combination really necessary?
	        for (var i = 0; i < axes.length; i++) {
	            var axis = axes[i];
	            var vertical = axis.options.vertical;
	            var gridLines = vertical ? vGridLines : hGridLines;
	            for (var j = 0; j < allAxes.length; j++) {
	                if (gridLines.length === 0) {
	                    var altAxis = allAxes[j];
	                    if (vertical !== altAxis.options.vertical) {
	                        append(gridLines, axis.createGridLines(altAxis));
	                    }
	                }
	            }
	        }
	    },

	    refresh: function() {
	        this.visual.clear();

	        this.content.parent = null;
	        this.content.createGradient = this.createGradient.bind(this);
	        this.content.renderVisual();
	        this.content.parent = this;

	        if (this.title) {
	            this.visual.append(this.title.visual);
	        }

	        this.visual.append(this.content.visual);

	        this.renderComplete();
	        this.notifyRender();
	    },

	    chartsBox: function() {
	        var axes = this.axes;
	        var length = axes.length;
	        var chartsBox = new Box();

	        for (var idx = 0; idx < length; idx++) {
	            var axis = axes[idx];
	            var axisValueField = axis.options.vertical ? Y : X;
	            var lineBox = axis.lineBox();
	            chartsBox[axisValueField + 1] = lineBox[axisValueField + 1];
	            chartsBox[axisValueField + 2] = lineBox[axisValueField + 2];
	        }

	        if (chartsBox.x2 === 0) {
	            var allAxes = this.parent.axes;
	            var length$1 = allAxes.length;

	            for (var idx$1 = 0; idx$1 < length$1; idx$1++) {
	                var axis$1 = allAxes[idx$1];
	                if (!axis$1.options.vertical) {
	                    var lineBox$1 = axis$1.lineBox();
	                    chartsBox.x1 = lineBox$1.x1;
	                    chartsBox.x2 = lineBox$1.x2;
	                }
	            }
	        }
	        return chartsBox;
	    },

	    clipBox: function() {
	        return this.chartContainer.clipBox;
	    },

	    notifyRender: function() {
	        var service = this.getService();
	        if (service) {
	            service.notify(PANE_RENDER, {
	                pane: new ChartPane(this),
	                index: this.paneIndex,
	                name: this.options.name
	            });
	        }
	    }
	});

	var ID = 1;

	function paneID() {
	    return "pane" + ID++;
	}

	Pane.prototype.isStackRoot = true;

	setDefaultOptions(Pane, {
	    zIndex: -1,
	    shrinkToFit: true,
	    title: {
	        align: LEFT
	    },
	    visible: true
	});

	function appendIfNotNull(array, element) {
	    if (element !== null) {
	        array.push(element);
	    }
	}

	function segmentVisible(series, fields, index) {
	    var visible = fields.visible;
	    if (defined(visible)) {
	        return visible;
	    }

	    var pointVisibility = series.pointVisibility;
	    if (pointVisibility) {
	        return pointVisibility[index];
	    }
	}

	function bindSegments(series) {
	    var data = series.data;
	    var points = [];
	    var sum = 0;
	    var count = 0;

	    for (var idx = 0; idx < data.length; idx++) {
	        var pointData = SeriesBinder.current.bindPoint(series, idx);
	        var value = pointData.valueFields.value;

	        if (isString(value)) {
	            value = parseFloat(value);
	        }

	        if (isNumber(value)) {
	            pointData.visible = segmentVisible(series, pointData.fields, idx) !== false;

	            pointData.value = Math.abs(value);
	            points.push(pointData);

	            if (pointData.visible) {
	                sum += pointData.value;
	            }

	            if (value !== 0) {
	                count++;
	            }
	        } else {
	            points.push(null);
	        }
	    }

	    return {
	        total: sum,
	        points: points,
	        count: count
	    };
	}

	function equalsIgnoreCase(a, b) {
	    if (a && b) {
	        return a.toLowerCase() === b.toLowerCase();
	    }

	    return a === b;
	}

	function filterSeriesByType(series, types) {
	    var result = [];

	    var seriesTypes = [].concat(types);
	    for (var idx = 0; idx < series.length; idx++) {
	        var currentSeries = series[idx];
	        if (inArray(currentSeries.type, seriesTypes)) {
	            result.push(currentSeries);
	        }
	    }

	    return result;
	}

	function getDateField(field, row, intlService) {
	    if (row === null) {
	        return row;
	    }

	    var key = "_date_" + field;
	    var value = row[key];

	    if (!value) {
	        value = parseDate(intlService, getter(field, true)(row));
	        row[key] = value;
	    }

	    return value;
	}

	function isDateAxis(axisOptions, sampleCategory) {
	    var type = axisOptions.type;
	    var dateCategory = sampleCategory instanceof Date;

	    return (!type && dateCategory) || equalsIgnoreCase(type, DATE);
	}

	function singleItemOrArray(array) {
	    return array.length === 1 ? array[0] : array;
	}

	var AREA_REGEX = /area/i;

	function seriesMissingValues(series) {
	    if (series.missingValues) {
	        return series.missingValues;
	    }

	    return AREA_REGEX.test(series.type) || series.stack ? ZERO : INTERPOLATE;
	}

	function hasValue$1(series, item) {
	    var fields = SeriesBinder.current.bindPoint(series, null, item);
	    var valueFields = fields.valueFields;

	    for (var field in valueFields) {
	        if (dataviz.convertableToNumber(valueFields[field])) {
	            return true;
	        }
	    }
	}

	function findNext(ref) {
	    var start = ref.start;
	    var dir = ref.dir;
	    var min = ref.min;
	    var max = ref.max;
	    var getter$$1 = ref.getter;
	    var hasItem = ref.hasItem;
	    var series = ref.series;

	    var pointHasValue, outPoint;
	    var idx = start;
	    do {
	        idx += dir;
	        //aggregating and binding the item takes too much time for large number of categories
	        //will assume that if the aggregation does not create value for a missing item for one it will not create for others
	        if (hasItem(idx)) {
	            outPoint = getter$$1(idx);
	            pointHasValue = hasValue$1(series, outPoint.item);
	        }
	    } while (min <= idx && idx <= max && !pointHasValue);

	    if (pointHasValue) {
	        return outPoint;
	    }
	}

	function createOutOfRangePoints(series, range, count, getter$$1, hasItem) {
	    var min = range.min;
	    var max = range.max;
	    var hasMinPoint = min > 0 && min < count;
	    var hasMaxPoint = max + 1 < count;

	    if (hasMinPoint || hasMaxPoint) {
	        var missingValues = seriesMissingValues(series);
	        var minPoint, maxPoint;
	        if (missingValues !== INTERPOLATE) {
	            if (hasMinPoint) {
	                minPoint = getter$$1(min - 1);
	            }

	            if (hasMaxPoint) {
	                maxPoint = getter$$1(max + 1);
	            }
	        } else {
	            var outPoint, pointHasValue;
	            if (hasMinPoint) {
	                outPoint = getter$$1(min - 1);
	                pointHasValue = hasValue$1(series, outPoint.item);
	                if (!pointHasValue) {
	                    minPoint = findNext({
	                        start: min,
	                        dir: -1,
	                        min: 0,
	                        max: count - 1,
	                        getter: getter$$1,
	                        hasItem: hasItem,
	                        series: series
	                    });
	                } else {
	                    minPoint = outPoint;
	                }
	            }

	            if (hasMaxPoint) {
	                outPoint = getter$$1(max + 1);
	                pointHasValue = hasValue$1(series, outPoint.item);
	                if (!pointHasValue) {
	                    maxPoint = findNext({
	                        start: max,
	                        dir: 1,
	                        min: 0,
	                        max: count - 1,
	                        getter: getter$$1,
	                        hasItem: hasItem,
	                        series: series
	                    });
	                } else {
	                    maxPoint = outPoint;
	                }
	            }
	        }

	        if (minPoint) {
	            series._outOfRangeMinPoint = minPoint;
	        }

	        if (maxPoint) {
	            series._outOfRangeMaxPoint = maxPoint;
	        }
	    }
	}

	var PlotAreaBase = ChartElement.extend({
	    init: function(series, options, chartService) {
	        ChartElement.fn.init.call(this, options);

	        this.initFields(series, options);
	        this.series = series;
	        this.initSeries();
	        this.charts = [];
	        this.options.legend = this.options.legend || {};
	        this.options.legend.items = [];
	        this.axes = [];
	        this.crosshairs = [];
	        this.chartService = chartService;
	        this.originalOptions = options;

	        this.createPanes();
	        this.render();
	        this.createCrosshairs();
	    },

	    initFields: function() { },

	    initSeries: function() {
	        var series = this.series;

	        for (var i = 0; i < series.length; i++) {
	            series[i].index = i;
	        }
	    },

	    createPanes: function() {
	        var this$1 = this;

	        var defaults = { title: { color: (this.options.title || {}).color } };
	        var panes = [];
	        var paneOptions = this.options.panes || [];
	        var panesLength = Math.max(paneOptions.length, 1);

	        function setTitle(options, defaults) {
	            if (isString(options.title)) {
	                options.title = {
	                    text: options.title
	                };
	            }

	            options.title = deepExtend({}, defaults.title, options.title);
	        }

	        for (var i = 0; i < panesLength; i++) {
	            var options = paneOptions[i] || {};
	            setTitle(options, defaults);

	            var currentPane = new Pane(options);
	            currentPane.paneIndex = i;

	            panes.push(currentPane);
	            this$1.append(currentPane);
	        }

	        this.panes = panes;
	    },

	    createCrosshairs: function(panes) {
	        var this$1 = this;
	        if (panes === void 0) { panes = this.panes; }

	        for (var i = 0; i < panes.length; i++) {
	            var pane = panes[i];
	            for (var j = 0; j < pane.axes.length; j++) {
	                var axis = pane.axes[j];
	                if (axis.options.crosshair && axis.options.crosshair.visible) {
	                    var currentCrosshair = new Crosshair(this$1.chartService, axis, axis.options.crosshair);

	                    this$1.crosshairs.push(currentCrosshair);
	                    pane.content.append(currentCrosshair);
	                }
	            }
	        }
	    },

	    removeCrosshairs: function(pane) {
	        var crosshairs = this.crosshairs;
	        var axes = pane.axes;

	        for (var i = crosshairs.length - 1; i >= 0; i--) {
	            for (var j = 0; j < axes.length; j++) {
	                if (crosshairs[i].axis === axes[j]) {
	                    crosshairs.splice(i, 1);
	                    break;
	                }
	            }
	        }
	    },

	    hideCrosshairs: function() {
	        var crosshairs = this.crosshairs;
	        for (var idx = 0; idx < crosshairs.length; idx++) {
	            crosshairs[idx].hide();
	        }
	    },

	    findPane: function(name) {
	        var panes = this.panes;
	        var matchingPane;

	        for (var i = 0; i < panes.length; i++) {
	            if (panes[i].options.name === name) {
	                matchingPane = panes[i];
	                break;
	            }
	        }

	        return matchingPane || panes[0];
	    },

	    findPointPane: function(point) {
	        var panes = this.panes;
	        var matchingPane;

	        for (var i = 0; i < panes.length; i++) {
	            if (panes[i].box.containsPoint(point)) {
	                matchingPane = panes[i];
	                break;
	            }
	        }

	        return matchingPane;
	    },

	    appendAxis: function(axis) {
	        var pane = this.findPane(axis.options.pane);

	        pane.appendAxis(axis);
	        this.axes.push(axis);
	        axis.plotArea = this;
	    },

	    removeAxis: function(axisToRemove) {
	        var this$1 = this;

	        var filteredAxes = [];

	        for (var i = 0; i < this.axes.length; i++) {
	            var axis = this$1.axes[i];
	            if (axisToRemove !== axis) {
	                filteredAxes.push(axis);
	            } else {
	                axis.destroy();
	            }
	        }

	        this.axes = filteredAxes;
	    },

	    appendChart: function(chart, pane) {
	        this.charts.push(chart);
	        if (pane) {
	            pane.appendChart(chart);
	        } else {
	            this.append(chart);
	        }
	    },

	    removeChart: function(chartToRemove) {
	        var this$1 = this;

	        var filteredCharts = [];

	        for (var i = 0; i < this.charts.length; i++) {
	            var chart = this$1.charts[i];
	            if (chart !== chartToRemove) {
	                filteredCharts.push(chart);
	            } else {
	                chart.destroy();
	            }
	        }

	        this.charts = filteredCharts;
	    },

	    addToLegend: function(series) {
	        var count = series.length;
	        var legend = this.options.legend;
	        var labels = legend.labels || {};
	        var inactiveItems = legend.inactiveItems || {};
	        var inactiveItemsLabels = inactiveItems.labels || {};
	        var data = [];

	        for (var i = 0; i < count; i++) {
	            var currentSeries = series[i];
	            var seriesVisible = currentSeries.visible !== false;
	            if (currentSeries.visibleInLegend === false) {
	                continue;
	            }

	            var text = currentSeries.name;
	            var labelTemplate = seriesVisible ? getTemplate(labels) : getTemplate(inactiveItemsLabels) || getTemplate(labels);
	            if (labelTemplate) {
	                text = labelTemplate({
	                    text: hasValue(text) ? text : "",
	                    series: currentSeries
	                });
	            }

	            var defaults = currentSeries._defaults;
	            var color = currentSeries.color;
	            if (isFunction(color) && defaults) {
	                color = defaults.color;
	            }

	            var itemLabelOptions = (void 0), markerColor = (void 0);
	            if (seriesVisible) {
	                itemLabelOptions = {};
	                markerColor = color;
	            } else {
	                itemLabelOptions = {
	                    color: inactiveItemsLabels.color,
	                    font: inactiveItemsLabels.font
	                };
	                markerColor = inactiveItems.markers.color;
	            }

	            if (hasValue(text) && text !== "") {
	                data.push({
	                    text: text,
	                    labels: itemLabelOptions,
	                    markerColor: markerColor,
	                    series: currentSeries,
	                    active: seriesVisible
	                });
	            }
	        }

	        append(legend.items, data);
	    },

	    groupAxes: function(panes) {
	        var xAxes = [];
	        var yAxes = [];

	        for (var paneIx = 0; paneIx < panes.length; paneIx++) {
	            var paneAxes = panes[paneIx].axes;
	            for (var axisIx = 0; axisIx < paneAxes.length; axisIx++) {
	                var axis = paneAxes[axisIx];
	                if (axis.options.vertical) {
	                    yAxes.push(axis);
	                } else {
	                    xAxes.push(axis);
	                }
	            }
	        }

	        return { x: xAxes, y: yAxes, any: xAxes.concat(yAxes) };
	    },

	    groupSeriesByPane: function() {
	        var this$1 = this;

	        var series = this.series;
	        var seriesByPane = {};

	        for (var i = 0; i < series.length; i++) {
	            var currentSeries = series[i];
	            var pane = this$1.seriesPaneName(currentSeries);

	            if (seriesByPane[pane]) {
	                seriesByPane[pane].push(currentSeries);
	            } else {
	                seriesByPane[pane] = [ currentSeries ];
	            }
	        }

	        return seriesByPane;
	    },

	    filterVisibleSeries: function(series) {
	        var result = [];

	        for (var i = 0; i < series.length; i++) {
	            var currentSeries = series[i];
	            if (currentSeries.visible !== false) {
	                result.push(currentSeries);
	            }
	        }

	        return result;
	    },

	    reflow: function(targetBox) {
	        var options = this.options.plotArea;
	        var panes = this.panes;
	        var margin = getSpacing(options.margin);

	        this.box = targetBox.clone().unpad(margin);
	        this.reflowPanes();

	        this.detachLabels();
	        this.reflowAxes(panes);
	        this.reflowCharts(panes);
	    },

	    redraw: function(panes) {
	        var this$1 = this;

	        var panesArray = [].concat(panes);
	        this.initSeries();

	        //prevents leak during partial redraws. the cached gradients observers retain reference to the destroyed elements.
	        var root = this.getRoot();
	        if (root) {
	            root.cleanGradients();
	        }

	        for (var i = 0; i < panesArray.length; i++) {
	            this$1.removeCrosshairs(panesArray[i]);
	            panesArray[i].empty();
	        }

	        this.render(panesArray);
	        this.detachLabels();
	        this.reflowAxes(this.panes);
	        this.reflowCharts(panesArray);

	        this.createCrosshairs(panesArray);

	        for (var i$1 = 0; i$1 < panesArray.length; i$1++) {
	            panesArray[i$1].refresh();
	        }
	    },

	    axisCrossingValues: function(axis, crossingAxes) {
	        var options = axis.options;
	        var crossingValues = [].concat(
	            options.axisCrossingValues || options.axisCrossingValue
	        );
	        var valuesToAdd = crossingAxes.length - crossingValues.length;
	        var defaultValue = crossingValues[0] || 0;

	        for (var i = 0; i < valuesToAdd; i++) {
	            crossingValues.push(defaultValue);
	        }

	        return crossingValues;
	    },

	    alignAxisTo: function(axis, targetAxis, crossingValue, targetCrossingValue) {
	        var slot = axis.getSlot(crossingValue, crossingValue, true);
	        var slotEdge = axis.options.reverse ? 2 : 1;
	        var targetSlot = targetAxis.getSlot(targetCrossingValue, targetCrossingValue, true);
	        var targetEdge = targetAxis.options.reverse ? 2 : 1;
	        var axisBox = axis.box.translate(
	            targetSlot[X + targetEdge] - slot[X + slotEdge],
	            targetSlot[Y + targetEdge] - slot[Y + slotEdge]
	        );

	        if (axis.pane !== targetAxis.pane) {
	            axisBox.translate(0, axis.pane.box.y1 - targetAxis.pane.box.y1);
	        }

	        axis.reflow(axisBox);
	    },

	    alignAxes: function(xAxes, yAxes) {
	        var this$1 = this;

	        var xAnchor = xAxes[0];
	        var yAnchor = yAxes[0];
	        var xAnchorCrossings = this.axisCrossingValues(xAnchor, yAxes);
	        var yAnchorCrossings = this.axisCrossingValues(yAnchor, xAxes);
	        var leftAnchors = {};
	        var rightAnchors = {};
	        var topAnchors = {};
	        var bottomAnchors = {};

	        for (var i = 0; i < yAxes.length; i++) {
	            var axis = yAxes[i];
	            var pane = axis.pane;
	            var paneId = pane.id;
	            var visible = axis.options.visible !== false;

	            // Locate pane anchor, if any, and use its axisCrossingValues
	            var anchor = paneAnchor(xAxes, pane) || xAnchor;
	            var anchorCrossings = xAnchorCrossings;

	            if (anchor !== xAnchor) {
	                anchorCrossings = this$1.axisCrossingValues(anchor, yAxes);
	            }

	            this$1.alignAxisTo(axis, anchor, yAnchorCrossings[i], anchorCrossings[i]);

	            if (axis.options._overlap) {
	                continue;
	            }

	            if (round(axis.lineBox().x1) === round(anchor.lineBox().x1)) {
	                // Push the axis to the left the previous y-axis so they don't overlap
	                if (leftAnchors[paneId]) {
	                    axis.reflow(axis.box
	                        .alignTo(leftAnchors[paneId].box, LEFT)
	                        .translate(-axis.options.margin, 0)
	                    );
	                }

	                if (visible) {
	                    leftAnchors[paneId] = axis;
	                }
	            }

	            if (round(axis.lineBox().x2) === round(anchor.lineBox().x2)) {
	                // Flip the labels on the right if we're at the right end of the pane
	                if (!axis._mirrored) {
	                    axis.options.labels.mirror = !axis.options.labels.mirror;
	                    axis._mirrored = true;
	                }

	                this$1.alignAxisTo(axis, anchor, yAnchorCrossings[i], anchorCrossings[i]);

	                // Push the axis to the right the previous y-axis so they don't overlap
	                if (rightAnchors[paneId]) {
	                    axis.reflow(axis.box
	                        .alignTo(rightAnchors[paneId].box, RIGHT)
	                        .translate(axis.options.margin, 0)
	                    );
	                }

	                if (visible) {
	                    rightAnchors[paneId] = axis;
	                }
	            }

	            if (i !== 0 && yAnchor.pane === axis.pane) {
	                axis.alignTo(yAnchor);
	                axis.reflow(axis.box);
	            }
	        }

	        for (var i$1 = 0; i$1 < xAxes.length; i$1++) {
	            var axis$1 = xAxes[i$1];
	            var pane$1 = axis$1.pane;
	            var paneId$1 = pane$1.id;
	            var visible$1 = axis$1.options.visible !== false;

	            // Locate pane anchor and use its axisCrossingValues
	            var anchor$1 = paneAnchor(yAxes, pane$1) || yAnchor;
	            var anchorCrossings$1 = yAnchorCrossings;
	            if (anchor$1 !== yAnchor) {
	                anchorCrossings$1 = this$1.axisCrossingValues(anchor$1, xAxes);
	            }

	            this$1.alignAxisTo(axis$1, anchor$1, xAnchorCrossings[i$1], anchorCrossings$1[i$1]);

	            if (axis$1.options._overlap) {
	                continue;
	            }

	            if (round(axis$1.lineBox().y1) === round(anchor$1.lineBox().y1)) {
	                // Flip the labels on top if we're at the top of the pane
	                if (!axis$1._mirrored) {
	                    axis$1.options.labels.mirror = !axis$1.options.labels.mirror;
	                    axis$1._mirrored = true;
	                }
	                this$1.alignAxisTo(axis$1, anchor$1, xAnchorCrossings[i$1], anchorCrossings$1[i$1]);

	                // Push the axis above the previous x-axis so they don't overlap
	                if (topAnchors[paneId$1]) {
	                    axis$1.reflow(axis$1.box
	                        .alignTo(topAnchors[paneId$1].box, TOP)
	                        .translate(0, -axis$1.options.margin)
	                    );
	                }

	                if (visible$1) {
	                    topAnchors[paneId$1] = axis$1;
	                }
	            }

	            if (round(axis$1.lineBox().y2, datavizConstants.COORD_PRECISION) === round(anchor$1.lineBox().y2, datavizConstants.COORD_PRECISION)) {
	                // Push the axis below the previous x-axis so they don't overlap
	                if (bottomAnchors[paneId$1]) {
	                    axis$1.reflow(axis$1.box
	                        .alignTo(bottomAnchors[paneId$1].box, BOTTOM)
	                        .translate(0, axis$1.options.margin)
	                    );
	                }

	                if (visible$1) {
	                    bottomAnchors[paneId$1] = axis$1;
	                }
	            }

	            if (i$1 !== 0) {
	                axis$1.alignTo(xAnchor);
	                axis$1.reflow(axis$1.box);
	            }
	        }
	    },

	    shrinkAxisWidth: function(panes) {
	        var axes = this.groupAxes(panes).any;
	        var axisBox = axisGroupBox(axes);
	        var overflowX = 0;

	        for (var i = 0; i < panes.length; i++) {
	            var currentPane = panes[i];

	            if (currentPane.axes.length > 0) {
	                overflowX = Math.max(
	                    overflowX,
	                    axisBox.width() - currentPane.contentBox.width()
	                );
	            }
	        }

	        if (overflowX !== 0) {
	            for (var i$1 = 0; i$1 < axes.length; i$1++) {
	                var currentAxis = axes[i$1];

	                if (!currentAxis.options.vertical) {
	                    currentAxis.reflow(currentAxis.box.shrink(overflowX, 0));
	                }
	            }
	        }
	    },

	    shrinkAxisHeight: function(panes) {
	        var shrinked;

	        for (var i = 0; i < panes.length; i++) {
	            var currentPane = panes[i];
	            var axes = currentPane.axes;
	            var overflowY = Math.max(0, axisGroupBox(axes).height() - currentPane.contentBox.height());

	            if (overflowY !== 0) {
	                for (var j = 0; j < axes.length; j++) {
	                    var currentAxis = axes[j];

	                    if (currentAxis.options.vertical) {
	                        currentAxis.reflow(
	                            currentAxis.box.shrink(0, overflowY)
	                        );
	                    }
	                }
	                shrinked = true;
	            }
	        }

	        return shrinked;
	    },

	    fitAxes: function(panes) {
	        var axes = this.groupAxes(panes).any;
	        var offsetX = 0;

	        for (var i = 0; i < panes.length; i++) {
	            var currentPane = panes[i];
	            var paneAxes = currentPane.axes;
	            var paneBox = currentPane.contentBox;

	            if (paneAxes.length > 0) {
	                var axisBox = axisGroupBox(paneAxes);
	                // OffsetY is calculated and applied per pane
	                var offsetY = Math.max(paneBox.y1 - axisBox.y1, paneBox.y2 - axisBox.y2);

	                // OffsetX is calculated and applied globally
	                offsetX = Math.max(offsetX, paneBox.x1 - axisBox.x1);

	                for (var j = 0; j < paneAxes.length; j++) {
	                    var currentAxis = paneAxes[j];

	                    currentAxis.reflow(
	                        currentAxis.box.translate(0, offsetY)
	                    );
	                }
	            }
	        }

	        for (var i$1 = 0; i$1 < axes.length; i$1++) {
	            var currentAxis$1 = axes[i$1];

	            currentAxis$1.reflow(
	                currentAxis$1.box.translate(offsetX, 0)
	            );
	        }
	    },

	    reflowAxes: function(panes) {
	        var this$1 = this;

	        var axes = this.groupAxes(panes);

	        for (var i = 0; i < panes.length; i++) {
	            this$1.reflowPaneAxes(panes[i]);
	        }

	        if (axes.x.length > 0 && axes.y.length > 0) {
	            this.alignAxes(axes.x, axes.y);
	            this.shrinkAxisWidth(panes);

	            this.autoRotateAxisLabels(axes);

	            this.alignAxes(axes.x, axes.y);
	            if (this.shrinkAxisWidth(panes)) {
	                this.alignAxes(axes.x, axes.y);
	            }

	            this.shrinkAxisHeight(panes);
	            this.alignAxes(axes.x, axes.y);

	            if (this.shrinkAxisHeight(panes)) {
	                this.alignAxes(axes.x, axes.y);
	            }

	            this.fitAxes(panes);
	        }
	    },

	    autoRotateAxisLabels: function(groupedAxes) {
	        var this$1 = this;

	        var ref = this;
	        var panes = ref.panes;
	        var axes = allPaneAxes(panes);
	        var rotated;

	        for (var idx = 0; idx < axes.length; idx++) {
	            var axis = axes[idx];
	            if (axis.autoRotateLabels()) {
	                rotated = true;
	            }
	        }

	        if (rotated) {
	            for (var idx$1 = 0; idx$1 < panes.length; idx$1++) {
	                this$1.reflowPaneAxes(panes[idx$1]);
	            }

	            if (groupedAxes.x.length > 0 && groupedAxes.y.length > 0) {
	                this.alignAxes(groupedAxes.x, groupedAxes.y);
	                this.shrinkAxisWidth(panes);
	            }
	        }
	    },

	    reflowPaneAxes: function(pane) {
	        var axes = pane.axes;
	        var length = axes.length;

	        if (length > 0) {
	            for (var i = 0; i < length; i++) {
	                axes[i].reflow(pane.contentBox);
	            }
	        }
	    },

	    reflowCharts: function(panes) {
	        var charts = this.charts;
	        var count = charts.length;
	        var box = this.box;

	        for (var i = 0; i < count; i++) {
	            var chartPane = charts[i].pane;
	            if (!chartPane || inArray(chartPane, panes)) {
	                charts[i].reflow(box);
	            }
	        }
	    },

	    reflowPanes: function() {
	        var ref = this;
	        var box = ref.box;
	        var panes = ref.panes;
	        var panesLength = panes.length;
	        var remainingHeight = box.height();
	        var remainingPanes = panesLength;
	        var autoHeightPanes = 0;
	        var top = box.y1;

	        for (var i = 0; i < panesLength; i++) {
	            var currentPane = panes[i];
	            var height = currentPane.options.height;

	            currentPane.options.width = box.width();

	            if (!currentPane.options.height) {
	                autoHeightPanes++;
	            } else {
	                if (height.indexOf && height.indexOf("%")) {
	                    var percents = parseInt(height, 10) / 100;
	                    currentPane.options.height = percents * box.height();
	                }

	                currentPane.reflow(box.clone());

	                remainingHeight -= currentPane.options.height;
	            }
	        }

	        for (var i$1 = 0; i$1 < panesLength; i$1++) {
	            var currentPane$1 = panes[i$1];

	            if (!currentPane$1.options.height) {
	                currentPane$1.options.height = remainingHeight / autoHeightPanes;
	            }
	        }

	        for (var i$2 = 0; i$2 < panesLength; i$2++) {
	            var currentPane$2 = panes[i$2];
	            var paneBox = box
	                .clone()
	                .move(box.x1, top);

	            currentPane$2.reflow(paneBox);

	            remainingPanes--;
	            top += currentPane$2.options.height;
	        }
	    },

	    backgroundBox: function() {
	        var axes = this.axes;
	        var axesCount = axes.length;
	        var box;

	        for (var i = 0; i < axesCount; i++) {
	            var axisA = axes[i];

	            for (var j = 0; j < axesCount; j++) {
	                var axisB = axes[j];

	                if (axisA.options.vertical !== axisB.options.vertical) {
	                    var lineBox = axisA.lineBox().clone().wrap(axisB.lineBox());

	                    if (!box) {
	                        box = lineBox;
	                    } else {
	                        box = box.wrap(lineBox);
	                    }
	                }
	            }
	        }

	        return box || this.box;
	    },

	    chartsBoxes: function() {
	        var panes = this.panes;
	        var boxes = [];

	        for (var idx = 0; idx < panes.length; idx++) {
	            boxes.push(panes[idx].chartsBox());
	        }

	        return boxes;
	    },

	    addBackgroundPaths: function(multipath) {
	        var boxes = this.chartsBoxes();
	        for (var idx = 0; idx < boxes.length; idx++) {
	            multipath.paths.push(Path.fromRect(boxes[idx].toRect()));
	        }
	    },

	    backgroundContainsPoint: function(point) {
	        var boxes = this.chartsBoxes();
	        for (var idx = 0; idx < boxes.length; idx++) {
	            if (boxes[idx].containsPoint(point)) {
	                return true;
	            }
	        }
	    },

	    createVisual: function() {
	        ChartElement.fn.createVisual.call(this);

	        var options = this.options.plotArea;
	        var opacity = options.opacity;
	        var background = options.background;
	        var border = options.border; if (border === void 0) { border = {}; }
	        if (isTransparent(background)) {
	            background = WHITE;
	            opacity = 0;
	        }

	        var bg = this._bgVisual = new drawing.MultiPath({
	            fill: {
	                color: background,
	                opacity: opacity
	            },
	            stroke: {
	                color: border.width ? border.color : "",
	                width: border.width,
	                dashType: border.dashType
	            },
	            zIndex: -1
	        });

	        this.addBackgroundPaths(bg);

	        this.appendVisual(bg);
	    },

	    pointsByCategoryIndex: function(categoryIndex) {
	        var charts = this.charts;
	        var result = [];

	        if (categoryIndex !== null) {
	            for (var i = 0; i < charts.length; i++) {
	                var chart = charts[i];
	                if (chart.pane.options.name === "_navigator") {
	                    continue;
	                }

	                var points = charts[i].categoryPoints[categoryIndex];
	                if (points && points.length) {
	                    for (var j = 0; j < points.length; j++) {
	                        var point = points[j];
	                        if (point && defined(point.value) && point.value !== null) {
	                            result.push(point);
	                        }
	                    }
	                }
	            }
	        }

	        return result;
	    },

	    pointsBySeriesIndex: function(seriesIndex) {
	        return this.filterPoints(function(point) {
	            return point.series.index === seriesIndex;
	        });
	    },

	    pointsBySeriesName: function(name) {
	        return this.filterPoints(function(point) {
	            return point.series.name === name;
	        });
	    },

	    filterPoints: function(callback) {
	        var charts = this.charts;
	        var result = [];

	        for (var i = 0; i < charts.length; i++) {
	            var chart = charts[i];
	            var points = chart.points;
	            for (var j = 0; j < points.length; j++) {
	                var point = points[j];
	                if (point && point.visible !== false && callback(point)) {
	                    result.push(point);
	                }
	            }
	        }

	        return result;
	    },

	    findPoint: function(callback) {
	        var charts = this.charts;

	        for (var i = 0; i < charts.length; i++) {
	            var chart = charts[i];
	            var points = chart.points;
	            for (var j = 0; j < points.length; j++) {
	                var point = points[j];
	                if (point && point.visible !== false && callback(point)) {
	                    return point;
	                }
	            }
	        }
	    },

	    paneByPoint: function(point) {
	        var panes = this.panes;

	        for (var i = 0; i < panes.length; i++) {
	            var pane = panes[i];
	            if (pane.box.containsPoint(point)) {
	                return pane;
	            }
	        }
	    },

	    detachLabels: function() {
	        var axes = this.groupAxes(this.panes);
	        var xAxes = axes.x;
	        var yAxes = axes.y;

	        this.detachAxisGroupLabels(yAxes, xAxes);
	        this.detachAxisGroupLabels(xAxes, yAxes);
	    },

	    detachAxisGroupLabels: function(axes, crossingAxes) {
	        var this$1 = this;

	        var labelAxisCount = 0;

	        for (var i = 0; i < axes.length; i++) {
	            var axis = axes[i];
	            var pane = axis.pane;
	            var anchor = paneAnchor(crossingAxes, pane) || crossingAxes[0];
	            var axisIndex = i + labelAxisCount;
	            var labelAxis = this$1.createLabelAxis(axis, axisIndex, anchor);

	            if (labelAxis) {
	                labelAxisCount++;

	                var pos = pane.axes.indexOf(axis) + labelAxisCount;
	                pane.appendAxisAt(labelAxis, pos);
	            }
	        }
	    },

	    createLabelAxis: function(axis, axisIndex, anchor) {
	        var labelOptions = axis.options.labels;
	        var position = labelOptions.position;
	        var onAxis = position !== datavizConstants.END && position !== datavizConstants.START;
	        var visible = labelOptions.visible;

	        if (onAxis || visible === false) {
	            return null;
	        }

	        var allAxes = this.groupAxes(this.panes);
	        var crossingAxes = anchor.options.vertical ? allAxes.x : allAxes.y;
	        var anchorCrossings = this.axisCrossingValues(anchor, crossingAxes);
	        var end = position === datavizConstants.END;
	        var range = anchor.range();
	        var edge = end ? range.max : range.min;
	        var crossingValue = limitValue(anchorCrossings[axisIndex], range.min, range.max);

	        if (crossingValue - edge === 0) {
	            return null;
	        }

	        anchorCrossings.splice(axisIndex + 1, 0, edge);
	        anchor.options.axisCrossingValues = anchorCrossings;

	        var labelAxis = axis.clone();
	        axis.clear();

	        labelAxis.options.name = undefined;
	        labelAxis.options.line.visible = false;

	        labelAxis.options.crosshair = undefined;
	        labelAxis.options.notes = undefined;
	        labelAxis.options.plotBands = undefined;

	        return labelAxis;
	    }
	});

	function isSingleAxis(axis) {
	    return !axis.pane.axes.some(function (a) { return a.options.vertical === axis.options.vertical && a !== axis && a.options.visible !== false; }
	    );
	}

	function axisGroupBox(axes) {
	    var length = axes.length;
	    var box;

	    for (var i = 0; i < length; i++) {
	        var axis = axes[i];
	        var visible = axis.options.visible !== false;
	        if (visible || isSingleAxis(axis)) {
	            var axisBox = visible ? axis.contentBox() : axis.lineBox();

	            if (!box) {
	                box = axisBox.clone();
	            } else {
	                box.wrap(axisBox);
	            }
	        }
	    }

	    return box || new Box();
	}

	function paneAnchor(axes, pane) {
	    for (var i = 0; i < axes.length; i++) {
	        var anchor = axes[i];
	        if (anchor && anchor.pane === pane) {
	            return anchor;
	        }
	    }
	}

	function isTransparent(color) {
	    return color === "" || color === null || color === "none" || color === "transparent" || !defined(color);
	}

	var allPaneAxes = function (panes) { return panes.reduce(function (acc, pane) { return acc.concat(pane.axes); }, []); };

	setDefaultOptions(PlotAreaBase, {
	    series: [],
	    plotArea: {
	        margin: {}
	    },
	    background: "",
	    border: {
	        color: BLACK,
	        width: 0
	    },
	    legend: {
	        inactiveItems: {
	            labels: {
	                color: "#919191"
	            },
	            markers: {
	                color: "#919191"
	            }
	        }
	    }
	});

	var PlotAreaEventsMixin = {
	    hover: function(chart, e) {
	        this._dispatchEvent(chart, e, PLOT_AREA_HOVER);
	    },

	    click: function(chart, e) {
	        this._dispatchEvent(chart, e, PLOT_AREA_CLICK);
	    }
	};

	var SeriesAggregator = Class.extend({
	    init: function(series, binder, defaultAggregates) {

	        var canonicalFields = binder.canonicalFields(series);
	        var valueFields = binder.valueFields(series);
	        var sourceFields = binder.sourceFields(series, canonicalFields);
	        var seriesFields = this._seriesFields = [];
	        var defaults = defaultAggregates.query(series.type);
	        var rootAggregate = series.aggregate || defaults;

	        this._series = series;
	        this._binder = binder;

	        for (var i = 0; i < canonicalFields.length; i++) {
	            var field = canonicalFields[i];
	            var fieldAggregate = (void 0);

	            if (isObject(rootAggregate)) {
	                fieldAggregate = rootAggregate[field];
	            } else if (i === 0 || inArray(field, valueFields)) {
	                fieldAggregate = rootAggregate;
	            } else {
	                break;
	            }

	            if (fieldAggregate) {
	                seriesFields.push({
	                    canonicalName: field,
	                    name: sourceFields[i],
	                    transform: isFunction(fieldAggregate) ? fieldAggregate : Aggregates[fieldAggregate]
	                });
	            }
	        }
	    },

	    aggregatePoints: function(srcPoints, group) {
	        var this$1 = this;

	        var ref = this;
	        var series = ref._series;
	        var seriesFields = ref._seriesFields;
	        var data = this._bindPoints(srcPoints || []);
	        var firstDataItem = data.dataItems[0];
	        var result = {};

	        if (firstDataItem && !isNumber(firstDataItem) && !isArray(firstDataItem)) {
	            var fn = function() {};
	            fn.prototype = firstDataItem;
	            result = new fn();
	        }

	        for (var i = 0; i < seriesFields.length; i++) {
	            var field = seriesFields[i];
	            var srcValues = this$1._bindField(data.values, field.canonicalName);
	            var value = field.transform(srcValues, series, data.dataItems, group);

	            if (value !== null && isObject(value) && !defined(value.length) && !(value instanceof Date)) {
	                result = value;
	                break;
	            } else {
	                if (defined(value)) {
	                    setValue(field.name, result, value);
	                }
	            }
	        }

	        return result;
	    },

	    _bindPoints: function(points) {
	        var ref = this;
	        var binder = ref._binder;
	        var series = ref._series;
	        var values = [];
	        var dataItems = [];

	        for (var i = 0; i < points.length; i++) {
	            var pointIx = points[i];

	            values.push(binder.bindPoint(series, pointIx));
	            dataItems.push(series.data[pointIx]);
	        }

	        return {
	            values: values,
	            dataItems: dataItems
	        };
	    },

	    _bindField: function(data, field) {
	        var values = [];
	        var count = data.length;

	        for (var i = 0; i < count; i++) {
	            var item = data[i];
	            var valueFields = item.valueFields;
	            var value = (void 0);

	            if (defined(valueFields[field])) {
	                value = valueFields[field];
	            } else {
	                value = item.fields[field];
	            }

	            values.push(value);
	        }

	        return values;
	    }
	});

	function setValue(fieldName, target, value) {
	    var parentObj = target;
	    var field = fieldName;

	    if (fieldName.indexOf(".") > -1) {
	        var parts = fieldName.split(".");

	        while (parts.length > 1) {
	            field = parts.shift();
	            if (!defined(parentObj[field])) {
	                parentObj[field] = {};
	            }
	            parentObj = parentObj[field];
	        }
	        field = parts.shift();
	    }

	    parentObj[field] = value;
	}

	var DefaultAggregates = Class.extend({
	    init: function() {

	        this._defaults = {};
	    },

	    register: function(seriesTypes, aggregates) {
	        var this$1 = this;

	        for (var i = 0; i < seriesTypes.length; i++) {
	            this$1._defaults[seriesTypes[i]] = aggregates;
	        }
	    },

	    query: function(seriesType) {
	        return this._defaults[seriesType];
	    }
	});

	DefaultAggregates.current = new DefaultAggregates();

	var RangeBar = Bar.extend({
	    createLabel: function() {
	        var labels = this.options.labels;
	        var fromOptions = deepExtend({}, labels, labels.from);
	        var toOptions = deepExtend({}, labels, labels.to);

	        if (fromOptions.visible) {
	            this.labelFrom = this._createLabel(fromOptions);
	            this.append(this.labelFrom);
	        }

	        if (toOptions.visible) {
	            this.labelTo = this._createLabel(toOptions);
	            this.append(this.labelTo);
	        }
	    },

	    _createLabel: function(options) {
	        var labelTemplate = getTemplate(options);
	        var pointData = this.pointData();

	        var labelText;

	        if (labelTemplate) {
	            labelText = labelTemplate(pointData);
	        } else {
	            labelText = this.formatValue(options.format);
	        }

	        return new BarLabel(labelText,
	            deepExtend({
	                vertical: this.options.vertical
	            },
	            options
	        ), pointData);
	    },

	    reflow: function(targetBox) {
	        this.render();

	        var ref = this;
	        var labelFrom = ref.labelFrom;
	        var labelTo = ref.labelTo;
	        var value = ref.value;

	        this.box = targetBox;

	        if (labelFrom) {
	            labelFrom.options.aboveAxis = value.from > value.to;
	            labelFrom.reflow(targetBox);
	        }

	        if (labelTo) {
	            labelTo.options.aboveAxis = value.to > value.from;
	            labelTo.reflow(targetBox);
	        }

	        if (this.note) {
	            this.note.reflow(targetBox);
	        }
	    }
	});

	RangeBar.prototype.defaults = deepExtend({}, RangeBar.prototype.defaults, {
	    labels: {
	        format: "{0} - {1}"
	    },
	    tooltip: {
	        format: "{1}"
	    }
	});

	var RangeBarChart = BarChart.extend({
	    pointType: function() {
	        return RangeBar;
	    },

	    pointValue: function(data) {
	        return data.valueFields;
	    },

	    formatPointValue: function(point, format) {
	        if (point.value.from === null && point.value.to === null) {
	            return "";
	        }

	        return this.chartService.format.auto(format, point.value.from, point.value.to);
	    },

	    plotRange: function(point) {
	        if (!point) {
	            return 0;
	        }

	        return [ point.value.from, point.value.to ];
	    },

	    updateRange: function(value, fields) {
	        var axisName = fields.series.axis;
	        var from = value.from;
	        var to = value.to;
	        var axisRange = this.valueAxisRanges[axisName];

	        if (value !== null && isNumber(from) && isNumber(to)) {
	            axisRange = this.valueAxisRanges[axisName] = axisRange || { min: MAX_VALUE, max: MIN_VALUE };

	            axisRange.min = Math.min(axisRange.min, from);
	            axisRange.max = Math.max(axisRange.max, from);

	            axisRange.min = Math.min(axisRange.min, to);
	            axisRange.max = Math.max(axisRange.max, to);
	        }
	    },

	    aboveAxis: function(point) {
	        var value = point.value;
	        return value.from < value.to;
	    }
	});

	RangeBarChart.prototype.plotLimits = CategoricalChart.prototype.plotLimits;

	var RangeLinePoint = LinePoint.extend({
	    aliasFor: function() {
	        return this.parent;
	    }
	});

	var AUTO = 'auto';
	var DEFAULT_FROM_FORMAT = '{0}';
	var DEFAULT_TO_FORMAT = '{1}';

	var RangeAreaPoint = ChartElement.extend({
	    init: function(value, options) {
	        ChartElement.fn.init.call(this);

	        this.value = value;
	        this.options = options;
	        this.aboveAxis = valueOrDefault(this.options.aboveAxis, true);
	        this.tooltipTracking = true;
	        this.initLabelsFormat();
	    },

	    render: function() {
	        if (this._rendered) {
	            return;
	        }

	        this._rendered = true;

	        var ref = this.options;
	        var markers = ref.markers;
	        var labels = ref.labels;
	        var value = this.value;

	        var fromPoint = this.fromPoint = new RangeLinePoint(value, deepExtend({}, this.options, {
	            labels: labels.from,
	            markers: markers.from
	        }));

	        var toPoint = this.toPoint = new RangeLinePoint(value, deepExtend({}, this.options, {
	            labels: labels.to,
	            markers: markers.to
	        }));

	        this.copyFields(fromPoint);
	        this.copyFields(toPoint);

	        this.append(fromPoint);
	        this.append(toPoint);
	    },

	    reflow: function(targetBox) {
	        this.render();

	        var fromBox = targetBox.from;
	        var toBox = targetBox.to;

	        this.positionLabels(fromBox, toBox);

	        this.fromPoint.reflow(fromBox);
	        this.toPoint.reflow(toBox);

	        this.box = this.fromPoint.markerBox().clone().wrap(this.toPoint.markerBox());
	    },

	    createHighlight: function() {
	        var group = new Group();
	        group.append(this.fromPoint.createHighlight());
	        group.append(this.toPoint.createHighlight());

	        return group;
	    },

	    highlightVisual: function() {
	        return this.visual;
	    },

	    highlightVisualArgs: function() {
	        return {
	            options: this.options,
	            from: this.fromPoint.highlightVisualArgs(),
	            to: this.toPoint.highlightVisualArgs()
	        };
	    },

	    tooltipAnchor: function() {
	        var clipBox = this.owner.pane.clipBox();
	        var showTooltip = !clipBox || clipBox.overlaps(this.box);

	        if (showTooltip) {
	            var box = this.box;
	            var center = box.center();
	            var horizontalAlign = LEFT;
	            var x, y, verticalAlign;

	            if (this.options.vertical) {
	                x = center.x;
	                y = box.y1 - TOOLTIP_OFFSET;
	                verticalAlign = BOTTOM;
	            } else {
	                x = box.x2 + TOOLTIP_OFFSET;
	                y = center.y;
	                verticalAlign = CENTER;
	            }

	            return {
	                point: new Point(x, y),
	                align: {
	                    horizontal: horizontalAlign,
	                    vertical: verticalAlign
	                }
	            };
	        }
	    },

	    formatValue: function(format) {
	        return this.owner.formatPointValue(this, format);
	    },

	    overlapsBox: function(box) {
	        return this.box.overlaps(box);
	    },

	    unclipElements: function() {
	        this.fromPoint.unclipElements();
	        this.toPoint.unclipElements();
	    },

	    initLabelsFormat: function() {
	        var labels = this.options.labels;
	        if (!labels.format) {
	            if (!labels.from || !labels.from.format) {
	                labels.from = $.extend({}, labels.from, {
	                    format: DEFAULT_FROM_FORMAT
	                });
	            }

	            if (!labels.to || !labels.to.format) {
	                labels.to = $.extend({}, labels.to, {
	                    format: DEFAULT_TO_FORMAT
	                });
	            }
	        }
	    },

	    positionLabels: function(fromBox, toBox) {
	        var ref = this.options;
	        var labels = ref.labels;
	        var vertical = ref.vertical;

	        if (labels.position === AUTO) {
	            var fromLabelPosition, toLabelPosition;
	            if (vertical) {
	                if (toBox.y1 <= fromBox.y1) {
	                    toLabelPosition = ABOVE;
	                    fromLabelPosition = BELOW;
	                } else {
	                    toLabelPosition = BELOW;
	                    fromLabelPosition = ABOVE;
	                }
	            } else {
	                if (toBox.x1 <= fromBox.x1) {
	                    toLabelPosition = LEFT;
	                    fromLabelPosition = RIGHT;
	                } else {
	                    toLabelPosition = RIGHT;
	                    fromLabelPosition = LEFT;
	                }
	            }

	            if (!labels.from || !labels.from.position) {
	                this.fromPoint.options.labels.position = fromLabelPosition;
	            }

	            if (!labels.to || !labels.to.position) {
	                this.toPoint.options.labels.position = toLabelPosition;
	            }
	        }
	    },

	    copyFields: function(point) {
	        point.dataItem = this.dataItem;
	        point.category = this.category;
	        point.series = this.series;
	        point.color = this.color;
	        point.owner = this.owner;
	    }
	});

	deepExtend(RangeAreaPoint.prototype, PointEventsMixin);
	deepExtend(RangeAreaPoint.prototype, NoteMixin);

	RangeAreaPoint.prototype.defaults = {
	    markers: {
	        visible: false,
	        background: WHITE,
	        size: LINE_MARKER_SIZE,
	        type: CIRCLE,
	        border: {
	            width: 2
	        },
	        opacity: 1
	    },
	    labels: {
	        visible: false,
	        margin: getSpacing(3),
	        padding: getSpacing(4),
	        animation: {
	            type: FADEIN,
	            delay: INITIAL_ANIMATION_DURATION
	        },
	        position: AUTO
	    },
	    notes: {
	        label: {}
	    },
	    highlight: {
	        markers: {
	            border: {
	                color: WHITE,
	                width: 2
	            }
	        },
	        zIndex: datavizConstants.HIGHLIGHT_ZINDEX
	    },
	    tooltip: {
	        format: '{0} - {1}'
	    }
	};

	var RangeAreaSegment = AreaSegment.extend({
	    createStrokeSegments: function() {
	        return this.segmentsFromPoints(this.toGeometryPoints(this.toPoints()));
	    },

	    stackSegments: function() {
	        var fromSegments = this.fromSegments;
	        if (!this.fromSegments) {
	            fromSegments = this.fromSegments = this.segmentsFromPoints(this.toGeometryPoints(this.fromPoints().reverse()));
	        }

	        return fromSegments;
	    },

	    createStroke: function(style) {
	        var toPath = new Path(style);
	        var fromPath = new Path(style);

	        toPath.segments.push.apply(toPath.segments, this.strokeSegments());
	        fromPath.segments.push.apply(fromPath.segments, this.stackSegments());

	        this.visual.append(toPath);
	        this.visual.append(fromPath);
	    },

	    hasStackSegment: function() {
	        return true;
	    },

	    fromPoints: function() {
	        return this.linePoints.map(function (point) { return point.fromPoint; });
	    },

	    toPoints: function() {
	        return this.linePoints.map(function (point) { return point.toPoint; });
	    }
	});

	var SplineRangeAreaSegment = RangeAreaSegment.extend({
	    createStrokeSegments: function() {
	        return this.createCurveSegments(this.toPoints());
	    },

	    stackSegments: function() {
	        var fromSegments = this.fromSegments;
	        if (!this.fromSegments) {
	            fromSegments = this.fromSegments = this.createCurveSegments(this.fromPoints().reverse());
	        }

	        return fromSegments;
	    },

	    createCurveSegments: function(points) {
	        var curveProcessor = new CurveProcessor();

	        return curveProcessor.process(this.toGeometryPoints(points));
	    }
	});

	var StepRangeAreaSegment = RangeAreaSegment.extend({
	    createStrokeSegments: function() {
	        return this.segmentsFromPoints(this.calculateStepPoints(this.toPoints()));
	    },

	    stackSegments: function() {
	        var fromSegments = this.fromSegments;
	        if (!this.fromSegments) {
	            fromSegments = this.fromSegments = this.segmentsFromPoints(this.calculateStepPoints(this.fromPoints()));
	            fromSegments.reverse();
	        }

	        return fromSegments;
	    }
	});

	deepExtend(StepRangeAreaSegment.prototype, StepLineMixin);

	var RangeAreaChart = CategoricalChart.extend({
	    render: function() {
	        CategoricalChart.fn.render.call(this);

	        this.renderSegments();
	    },

	    pointType: function() {
	        return RangeAreaPoint;
	    },

	    createPoint: function(data, fields) {
	        var categoryIx = fields.categoryIx;
	        var category = fields.category;
	        var series = fields.series;
	        var seriesIx = fields.seriesIx;
	        var value = data.valueFields;

	        if (!hasValue(value.from) && !hasValue(value.to)) {
	            if (this.seriesMissingValues(series) === ZERO) {
	                value = {
	                    from: 0,
	                    to: 0
	                };
	            } else {
	                return null;
	            }
	        }

	        var pointOptions = this.pointOptions(series, seriesIx);
	        pointOptions = this.evalPointOptions(
	            pointOptions, value, category, categoryIx, series, seriesIx
	        );

	        var color = data.fields.color || series.color;
	        if (isFunction(series.color)) {
	            color = pointOptions.color;
	        }

	        var point = new RangeAreaPoint(value, pointOptions);
	        point.color = color;

	        this.append(point);

	        return point;
	    },

	    createSegment: function(linePoints, currentSeries, seriesIx) {
	        var style = (currentSeries.line || {}).style;
	        var segmentType;
	        if (style === "smooth") {
	            segmentType = SplineRangeAreaSegment;
	        } else if (style === "step") {
	            segmentType = StepRangeAreaSegment;
	        } else {
	            segmentType = RangeAreaSegment;
	        }

	        return new segmentType(linePoints, currentSeries, seriesIx);
	    },

	    plotRange: function(point, startValue) {
	        if (!point) {
	            return [ startValue, startValue ];
	        }

	        return [ point.value.from, point.value.to ];
	    },

	    valueSlot: function(valueAxis, plotRange) {
	        var fromSlot = valueAxis.getSlot(plotRange[0], plotRange[0], !this.options.clip);
	        var toSlot = valueAxis.getSlot(plotRange[1], plotRange[1], !this.options.clip);
	        if (fromSlot && toSlot) {
	            return {
	                from: fromSlot,
	                to: toSlot
	            };
	        }
	    },

	    pointSlot: function(categorySlot, valueSlot) {
	        var from = valueSlot.from;
	        var to = valueSlot.to;
	        var fromSlot, toSlot;

	        if (this.options.invertAxes) {
	            fromSlot = new Box(from.x1, categorySlot.y1, from.x2, categorySlot.y2);
	            toSlot = new Box(to.x1, categorySlot.y1, to.x2, categorySlot.y2);
	        } else {
	            fromSlot = new Box(categorySlot.x1, from.y1, categorySlot.x2, from.y2);
	            toSlot = new Box(categorySlot.x1, to.y1, categorySlot.x2, to.y2);
	        }

	        return {
	            from: fromSlot,
	            to: toSlot
	        };
	    },

	    addValue: function(data, fields) {
	        var valueFields = data.valueFields;
	        if (!isNumber(valueFields.from)) {
	            valueFields.from = valueFields.to;
	        }

	        if (!isNumber(valueFields.to)) {
	            valueFields.to = valueFields.from;
	        }

	        CategoricalChart.fn.addValue.call(this, data, fields);
	    },

	    updateRange: function(value, fields) {
	        if (value !== null && isNumber(value.from) && isNumber(value.to)) {
	            var axisName = fields.series.axis;
	            var axisRange = this.valueAxisRanges[axisName] = this.valueAxisRanges[axisName] || { min: MAX_VALUE, max: MIN_VALUE };
	            var from = value.from;
	            var to = value.to;

	            axisRange.min = Math.min(axisRange.min, from, to);
	            axisRange.max = Math.max(axisRange.max, from, to);
	        }
	    },

	    formatPointValue: function(point, format) {
	        var value = point.value;

	        return this.chartService.format.auto(format, value.from, value.to);
	    },

	    animationPoints: function() {
	        var points = this.points;
	        var result = [];
	        for (var idx = 0; idx < points.length; idx++) {
	            var point = points[idx];
	            if (point) {
	                result.push((point.fromPoint || {}).marker);
	                result.push((point.toPoint || {}).marker);
	            }
	        }

	        return result.concat(this._segments);
	    }
	});

	deepExtend(RangeAreaChart.prototype, LineChartMixin, ClipAnimationMixin);

	var OHLCPoint = Candlestick.extend({
	    reflow: function(box) {
	        var ref = this;
	        var options = ref.options;
	        var value = ref.value;
	        var chart = ref.owner;
	        var valueAxis = chart.seriesValueAxis(options);
	        var oPoints = [];
	        var cPoints = [];
	        var lhPoints = [];

	        var lhSlot = valueAxis.getSlot(value.low, value.high);
	        var oSlot = valueAxis.getSlot(value.open, value.open);
	        var cSlot = valueAxis.getSlot(value.close, value.close);

	        oSlot.x1 = cSlot.x1 = lhSlot.x1 = box.x1;
	        oSlot.x2 = cSlot.x2 = lhSlot.x2 = box.x2;

	        var mid = lhSlot.center().x;

	        oPoints.push([ oSlot.x1, oSlot.y1 ]);
	        oPoints.push([ mid, oSlot.y1 ]);
	        cPoints.push([ mid, cSlot.y1 ]);
	        cPoints.push([ cSlot.x2, cSlot.y1 ]);
	        lhPoints.push([ mid, lhSlot.y1 ]);
	        lhPoints.push([ mid, lhSlot.y2 ]);

	        this.lines = [
	            oPoints, cPoints, lhPoints
	        ];

	        this.box = lhSlot.clone().wrap(oSlot.clone().wrap(cSlot));

	        this.reflowNote();
	    },

	    createBody: function() {}
	});

	var OHLCChart = CandlestickChart.extend({
	    pointType: function() {
	        return OHLCPoint;
	    }
	});

	var WaterfallSegment = ChartElement.extend({
	    init: function(from, to, series) {
	        ChartElement.fn.init.call(this);

	        this.from = from;
	        this.to = to;
	        this.series = series;
	    },

	    linePoints: function() {
	        var from = this.from;
	        var ref = this;
	        var fromBox = ref.from.box;
	        var toBox = ref.to.box;
	        var points = [];

	        if (from.isVertical) {
	            var y = from.aboveAxis ? fromBox.y1 : fromBox.y2;
	            points.push(
	                [ fromBox.x1, y ],
	                [ toBox.x2, y ]
	            );
	        } else {
	            var x = from.aboveAxis ? fromBox.x2 : fromBox.x1;
	            points.push(
	                [ x, fromBox.y1 ],
	                [ x, toBox.y2 ]
	            );
	        }

	        return points;
	    },

	    createVisual: function() {
	        ChartElement.fn.createVisual.call(this);

	        var line = this.series.line || {};

	        var path = Path.fromPoints(this.linePoints(), {
	            stroke: {
	                color: line.color,
	                width: line.width,
	                opacity: line.opacity,
	                dashType: line.dashType
	            }
	        });

	        alignPathToPixel(path);
	        this.visual.append(path);
	    }
	});

	setDefaultOptions(WaterfallSegment, {
	    animation: {
	        type: FADEIN,
	        delay: INITIAL_ANIMATION_DURATION
	    }
	});

	var WaterfallChart = BarChart.extend({
	    render: function() {
	        BarChart.fn.render.call(this);
	        this.createSegments();
	    },

	    traverseDataPoints: function(callback) {
	        var this$1 = this;

	        var series = this.options.series;
	        var totalCategories = categoriesCount(series);
	        var isVertical = !this.options.invertAxes;

	        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
	            var currentSeries = series[seriesIx];
	            var total = 0;
	            var runningTotal = 0;

	            for (var categoryIx = 0; categoryIx < totalCategories; categoryIx++) {
	                var data = SeriesBinder.current.bindPoint(currentSeries, categoryIx);
	                var value = data.valueFields.value;
	                var summary = data.fields.summary;
	                var from = total;
	                var to = (void 0);

	                if (summary) {
	                    if (summary.toLowerCase() === "total") {
	                        data.valueFields.value = total;
	                        from = 0;
	                        to = total;
	                    } else {
	                        data.valueFields.value = runningTotal;
	                        to = from - runningTotal;
	                        runningTotal = 0;
	                    }
	                } else if (isNumber(value)) {
	                    runningTotal += value;
	                    total += value;
	                    to = total;
	                }

	                callback(data, {
	                    category: this$1.categoryAxis.categoryAt(categoryIx),
	                    categoryIx: categoryIx,
	                    series: currentSeries,
	                    seriesIx: seriesIx,
	                    total: total,
	                    runningTotal: runningTotal,
	                    from: from,
	                    to: to,
	                    isVertical: isVertical
	                });
	            }
	        }
	    },

	    updateRange: function(value, fields) {
	        BarChart.fn.updateRange.call(this, { value: fields.to }, fields);
	    },

	    aboveAxis: function(point) {
	        return point.value >= 0;
	    },

	    plotRange: function(point) {
	        return [ point.from, point.to ];
	    },

	    createSegments: function() {
	        var this$1 = this;

	        var series = this.options.series;
	        var seriesPoints = this.seriesPoints;
	        var segments = this.segments = [];

	        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
	            var currentSeries = series[seriesIx];
	            var points = seriesPoints[seriesIx];

	            if (points) {
	                var prevPoint = (void 0);
	                for (var pointIx = 0; pointIx < points.length; pointIx++) {
	                    var point = points[pointIx];

	                    if (point && prevPoint) {
	                        var segment = new WaterfallSegment(prevPoint, point, currentSeries);
	                        segments.push(segment);
	                        this$1.append(segment);
	                    }

	                    prevPoint = point;
	                }
	            }
	        }
	    }
	});

	var AREA_SERIES = [ AREA, VERTICAL_AREA, RANGE_AREA, VERTICAL_RANGE_AREA ];
	var OUT_OF_RANGE_SERIES = [ LINE, VERTICAL_LINE ].concat(AREA_SERIES);

	var CategoricalPlotArea = PlotAreaBase.extend({
	    initFields: function(series) {
	        var this$1 = this;

	        this.namedCategoryAxes = {};
	        this.namedValueAxes = {};
	        this.valueAxisRangeTracker = new AxisGroupRangeTracker();

	        if (series.length > 0) {
	            this.invertAxes = inArray(
	                series[0].type, [ BAR, BULLET, VERTICAL_LINE, VERTICAL_AREA, VERTICAL_RANGE_AREA,
	                                 RANGE_BAR, HORIZONTAL_WATERFALL, VERTICAL_BOX_PLOT ]
	            );

	            for (var i = 0; i < series.length; i++) {
	                var stack = series[i].stack;
	                if (stack && stack.type === "100%") {
	                    this$1.stack100 = true;
	                    break;
	                }
	            }
	        }

	    },

	    render: function(panes) {
	        if (panes === void 0) { panes = this.panes; }

	        this.createCategoryAxes(panes);
	        this.aggregateCategories(panes);
	        this.createCategoryAxesLabels(panes);
	        this.createCharts(panes);
	        this.createValueAxes(panes);
	    },

	    removeAxis: function(axis) {
	        var axisName = axis.options.name;

	        PlotAreaBase.fn.removeAxis.call(this, axis);

	        if (axis instanceof CategoryAxis) {
	            delete this.namedCategoryAxes[axisName];
	        } else {
	            this.valueAxisRangeTracker.reset(axisName);
	            delete this.namedValueAxes[axisName];
	        }

	        if (axis === this.categoryAxis) {
	            delete this.categoryAxis;
	        }

	        if (axis === this.valueAxis) {
	            delete this.valueAxis;
	        }
	    },

	    createCharts: function(panes) {
	        var this$1 = this;

	        var seriesByPane = this.groupSeriesByPane();

	        for (var i = 0; i < panes.length; i++) {
	            var pane = panes[i];
	            var paneSeries = seriesByPane[pane.options.name || "default"] || [];
	            this$1.addToLegend(paneSeries);

	            var visibleSeries = this$1.filterVisibleSeries(paneSeries);
	            if (!visibleSeries) {
	                continue;
	            }

	            var groups = this$1.groupSeriesByCategoryAxis(visibleSeries);
	            for (var groupIx = 0; groupIx < groups.length; groupIx++) {
	                this$1.createChartGroup(groups[groupIx], pane);
	            }
	        }
	    },

	    createChartGroup: function(series, pane) {
	        this.createAreaChart(
	            filterSeriesByType(series, [ AREA, VERTICAL_AREA ]), pane
	        );

	        this.createRangeAreaChart(
	            filterSeriesByType(series, [ RANGE_AREA, VERTICAL_RANGE_AREA ]), pane
	        );

	        this.createBarChart(
	            filterSeriesByType(series, [ COLUMN, BAR ]), pane
	        );

	        this.createRangeBarChart(
	            filterSeriesByType(series, [ RANGE_COLUMN, RANGE_BAR ]), pane
	        );

	        this.createBulletChart(
	            filterSeriesByType(series, [ BULLET, VERTICAL_BULLET ]), pane
	        );

	        this.createCandlestickChart(
	            filterSeriesByType(series, CANDLESTICK), pane
	        );

	        this.createBoxPlotChart(
	            filterSeriesByType(series, [ BOX_PLOT, VERTICAL_BOX_PLOT ]), pane
	        );

	        this.createOHLCChart(
	            filterSeriesByType(series, OHLC), pane
	        );

	        this.createWaterfallChart(
	            filterSeriesByType(series, [ WATERFALL, HORIZONTAL_WATERFALL ]), pane
	        );

	        this.createLineChart(
	            filterSeriesByType(series, [ LINE, VERTICAL_LINE ]), pane
	        );
	    },

	    aggregateCategories: function(panes) {
	        var this$1 = this;

	        var series = this.srcSeries || this.series;
	        var processedSeries = [];
	        this._currentPointsCache = {};
	        this._seriesPointsCache = this._seriesPointsCache || {};

	        for (var i = 0; i < series.length; i++) {
	            var currentSeries = series[i];
	            var categoryAxis = this$1.seriesCategoryAxis(currentSeries);
	            var axisPane = this$1.findPane(categoryAxis.options.pane);
	            var dateAxis = equalsIgnoreCase(categoryAxis.options.type, DATE);

	            if ((dateAxis || currentSeries.categoryField) && inArray(axisPane, panes)) {
	                currentSeries = this$1.aggregateSeries(currentSeries, categoryAxis);
	            } else {
	                currentSeries = this$1.filterSeries(currentSeries, categoryAxis);
	            }

	            processedSeries.push(currentSeries);
	        }

	        this._seriesPointsCache = this._currentPointsCache;
	        this._currentPointsCache = null;

	        this.srcSeries = series;
	        this.series = processedSeries;
	    },

	    filterSeries: function(series, categoryAxis) {
	        var dataLength = (series.data || {}).length;
	        categoryAxis._seriesMax = Math.max(categoryAxis._seriesMax || 0, dataLength);

	        if (!(isNumber(categoryAxis.options.min) || isNumber(categoryAxis.options.max))) {
	            return series;
	        }

	        var range = categoryAxis.currentRangeIndices();
	        var outOfRangePoints = inArray(series.type, OUT_OF_RANGE_SERIES);
	        var currentSeries = deepExtend({}, series);

	        currentSeries.data = (currentSeries.data || []).slice(range.min, range.max + 1);

	        if (outOfRangePoints) {
	            createOutOfRangePoints(currentSeries, range, dataLength, function (idx) { return ({
	                item: series.data[idx],
	                category: categoryAxis.categoryAt(idx, true),
	                categoryIx: idx - range.min
	            }); }, function (idx) { return defined(series.data[idx]); });
	        }

	        return currentSeries;
	    },

	    clearSeriesPointsCache: function() {
	        this._seriesPointsCache = {};
	    },

	    seriesSourcePoints: function(series, categoryAxis) {
	        var this$1 = this;

	        var key = (series.index) + ";" + (categoryAxis.categoriesHash());
	        if (this._seriesPointsCache[key]) {
	            this._currentPointsCache[key] = this._seriesPointsCache[key];
	            return this._seriesPointsCache[key];
	        }

	        var axisOptions = categoryAxis.options;
	        var srcCategories = axisOptions.srcCategories;
	        var dateAxis = equalsIgnoreCase(axisOptions.type, DATE);
	        var srcData = series.data;
	        var getFn = dateAxis ? getDateField : getField;
	        var result = [];
	        if (!dateAxis) {
	            categoryAxis.mapCategories();//fixes major performance issue caused by searching for the index for large data
	        }

	        for (var idx = 0; idx < srcData.length; idx++) {
	            var category = (void 0);
	            if (series.categoryField) {
	                category = getFn(series.categoryField, srcData[idx], this$1.chartService.intl);
	            } else {
	                category = srcCategories[idx];
	            }

	            if (defined(category) && category !== null) {
	                var categoryIx = categoryAxis.totalIndex(category);
	                result[categoryIx] = result[categoryIx] || { items: [], category: category };
	                result[categoryIx].items.push(idx);
	            }
	        }

	        this._currentPointsCache[key] = result;

	        return result;
	    },

	    aggregateSeries: function(series, categoryAxis) {
	        var srcData = series.data;
	        if (!srcData.length) {
	            return series;
	        }

	        var srcPoints = this.seriesSourcePoints(series, categoryAxis);
	        var result = deepExtend({}, series);
	        var aggregator = new SeriesAggregator(deepExtend({}, series), SeriesBinder.current, DefaultAggregates.current);
	        var data = result.data = [];
	        var dataItems = categoryAxis.options.dataItems || [];

	        var range = categoryAxis.currentRangeIndices();
	        var categoryItem = function (idx) {
	            var categoryIdx = idx - range.min;
	            var point = srcPoints[idx];
	            if (!point) {
	                point = srcPoints[idx] = {};
	            }

	            point.categoryIx = categoryIdx;

	            if (!point.item) {
	                var category = categoryAxis.categoryAt(idx, true);
	                point.category = category;
	                point.item = aggregator.aggregatePoints(point.items, category);
	            }

	            return point;
	        };

	        for (var idx = range.min; idx <= range.max; idx++) {
	            var point = categoryItem(idx);
	            data[point.categoryIx] = point.item;

	            if (point.items && point.items.length) {
	                dataItems[point.categoryIx] = point.item;
	            }
	        }

	        if (inArray(result.type, OUT_OF_RANGE_SERIES)) {
	            createOutOfRangePoints(result, range, categoryAxis.totalCount(), categoryItem, function (idx) { return srcPoints[idx]; });
	        }

	        categoryAxis.options.dataItems = dataItems;

	        return result;
	    },

	    appendChart: function(chart, pane) {
	        var series = chart.options.series;
	        var categoryAxis = this.seriesCategoryAxis(series[0]);
	        var categories = categoryAxis.options.categories;
	        var categoriesToAdd = Math.max(0, categoriesCount(series) - categories.length);

	        if (categoriesToAdd > 0) {//consider setting an option to axis instead of adding fake categories
	            categories = categoryAxis.options.categories = categoryAxis.options.categories.slice(0);
	            while (categoriesToAdd--) {
	                categories.push("");
	            }
	        }

	        this.valueAxisRangeTracker.update(chart.valueAxisRanges);

	        PlotAreaBase.fn.appendChart.call(this, chart, pane);
	    },

	    seriesPaneName: function(series) {
	        var options = this.options;
	        var axisName = series.axis;
	        var axisOptions = [].concat(options.valueAxis);
	        var axis = grep(axisOptions, function(a) { return a.name === axisName; })[0];
	        var panes = options.panes || [ {} ];
	        var defaultPaneName = (panes[0] || {}).name || "default";
	        var paneName = (axis || {}).pane || defaultPaneName;

	        return paneName;
	    },

	    seriesCategoryAxis: function(series) {
	        var axisName = series.categoryAxis;
	        var axis = axisName ? this.namedCategoryAxes[axisName] : this.categoryAxis;

	        if (!axis) {
	            throw new Error("Unable to locate category axis with name " + axisName);
	        }

	        return axis;
	    },

	    stackableChartOptions: function(firstSeries, pane) {
	        var stack = firstSeries.stack;
	        var isStacked100 = stack && stack.type === "100%";
	        var clip = pane.options.clip;

	        return {
	            isStacked: stack,
	            isStacked100: isStacked100,
	            clip: clip
	        };
	    },

	    groupSeriesByCategoryAxis: function(series) {
	        var categoryAxes = [];
	        var unique = {};
	        for (var idx = 0; idx < series.length; idx++) {
	            var name = series[idx].categoryAxis || "$$default$$";
	            if (!unique.hasOwnProperty(name)) {
	                unique[name] = true;
	                categoryAxes.push(name);
	            }
	        }

	        var groups = [];
	        for (var axisIx = 0; axisIx < categoryAxes.length; axisIx++) {
	            var axis = categoryAxes[axisIx];
	            var axisSeries = groupSeries(series, axis, axisIx);
	            if (axisSeries.length === 0) {
	                continue;
	            }

	            groups.push(axisSeries);
	        }

	        return groups;
	    },

	    createBarChart: function(series, pane) {
	        if (series.length === 0) {
	            return;
	        }

	        var firstSeries = series[0];
	        var barChart = new BarChart(this, $.extend({
	            series: series,
	            invertAxes: this.invertAxes,
	            gap: firstSeries.gap,
	            spacing: firstSeries.spacing
	        }, this.stackableChartOptions(firstSeries, pane)));

	        this.appendChart(barChart, pane);
	    },

	    createRangeBarChart: function(series, pane) {
	        if (series.length === 0) {
	            return;
	        }

	        var firstSeries = series[0];
	        var rangeColumnChart = new RangeBarChart(this, {
	            series: series,
	            invertAxes: this.invertAxes,
	            gap: firstSeries.gap,
	            spacing: firstSeries.spacing
	        });

	        this.appendChart(rangeColumnChart, pane);
	    },

	    createBulletChart: function(series, pane) {
	        if (series.length === 0) {
	            return;
	        }

	        var firstSeries = series[0];
	        var bulletChart = new BulletChart(this, {
	            series: series,
	            invertAxes: this.invertAxes,
	            gap: firstSeries.gap,
	            spacing: firstSeries.spacing,
	            clip: pane.options.clip
	        });

	        this.appendChart(bulletChart, pane);
	    },

	    createLineChart: function(series, pane) {
	        if (series.length === 0) {
	            return;
	        }

	        var firstSeries = series[0];
	        var lineChart = new LineChart(this, $.extend({
	            invertAxes: this.invertAxes,
	            series: series
	        }, this.stackableChartOptions(firstSeries, pane)));

	        this.appendChart(lineChart, pane);
	    },

	    createAreaChart: function(series, pane) {
	        if (series.length === 0) {
	            return;
	        }

	        var firstSeries = series[0];
	        var areaChart = new AreaChart(this, $.extend({
	            invertAxes: this.invertAxes,
	            series: series
	        }, this.stackableChartOptions(firstSeries, pane)));

	        this.appendChart(areaChart, pane);
	    },

	    createRangeAreaChart: function(series, pane) {
	        if (series.length === 0) {
	            return;
	        }

	        var rangeAreaChart = new RangeAreaChart(this, {
	            invertAxes: this.invertAxes,
	            series: series,
	            clip: pane.options.clip
	        });

	        this.appendChart(rangeAreaChart, pane);
	    },

	    createOHLCChart: function(series, pane) {
	        if (series.length === 0) {
	            return;
	        }

	        var firstSeries = series[0];
	        var chart = new OHLCChart(this, {
	            invertAxes: this.invertAxes,
	            gap: firstSeries.gap,
	            series: series,
	            spacing: firstSeries.spacing,
	            clip: pane.options.clip
	        });

	        this.appendChart(chart, pane);
	    },

	    createCandlestickChart: function(series, pane) {
	        if (series.length === 0) {
	            return;
	        }

	        var firstSeries = series[0];
	        var chart = new CandlestickChart(this, {
	            invertAxes: this.invertAxes,
	            gap: firstSeries.gap,
	            series: series,
	            spacing: firstSeries.spacing,
	            clip: pane.options.clip
	        });

	        this.appendChart(chart, pane);
	    },

	    createBoxPlotChart: function(series, pane) {
	        if (series.length === 0) {
	            return;
	        }

	        var firstSeries = series[0];
	        var chart = new BoxPlotChart(this, {
	            invertAxes: this.invertAxes,
	            gap: firstSeries.gap,
	            series: series,
	            spacing: firstSeries.spacing,
	            clip: pane.options.clip
	        });

	        this.appendChart(chart, pane);
	    },

	    createWaterfallChart: function(series, pane) {
	        if (series.length === 0) {
	            return;
	        }

	        var firstSeries = series[0];
	        var waterfallChart = new WaterfallChart(this, {
	            series: series,
	            invertAxes: this.invertAxes,
	            gap: firstSeries.gap,
	            spacing: firstSeries.spacing
	        });

	        this.appendChart(waterfallChart, pane);
	    },

	    axisRequiresRounding: function(categoryAxisName, categoryAxisIndex) {
	        var this$1 = this;

	        var centeredSeries = filterSeriesByType(this.series, EQUALLY_SPACED_SERIES);

	        for (var seriesIx = 0; seriesIx < this.series.length; seriesIx++) {
	            var currentSeries = this$1.series[seriesIx];
	            if (inArray(currentSeries.type, AREA_SERIES)) {
	                var line = currentSeries.line;
	                if (line && line.style === STEP) {
	                    centeredSeries.push(currentSeries);
	                }
	            }
	        }

	        for (var seriesIx$1 = 0; seriesIx$1 < centeredSeries.length; seriesIx$1++) {
	            var seriesAxis = centeredSeries[seriesIx$1].categoryAxis || "";
	            if (seriesAxis === categoryAxisName || (!seriesAxis && categoryAxisIndex === 0)) {
	                return true;
	            }
	        }
	    },

	    aggregatedAxis: function(categoryAxisName, categoryAxisIndex) {
	        var series = this.series;

	        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
	            var seriesAxis = series[seriesIx].categoryAxis || "";
	            if ((seriesAxis === categoryAxisName || (!seriesAxis && categoryAxisIndex === 0)) && series[seriesIx].categoryField) {
	                return true;
	            }
	        }
	    },

	    createCategoryAxesLabels: function() {
	        var axes = this.axes;
	        for (var i = 0; i < axes.length; i++) {
	            if (axes[i] instanceof CategoryAxis) {
	                axes[i].createLabels();
	            }
	        }
	    },

	    createCategoryAxes: function(panes) {
	        var this$1 = this;

	        var invertAxes = this.invertAxes;
	        var definitions = [].concat(this.options.categoryAxis);
	        var axes = [];

	        for (var i = 0; i < definitions.length; i++) {
	            var axisOptions = definitions[i];
	            var axisPane = this$1.findPane(axisOptions.pane);

	            if (inArray(axisPane, panes)) {
	                var name = axisOptions.name;
	                var categories = axisOptions.categories; if (categories === void 0) { categories = []; }
	                axisOptions = deepExtend({
	                    vertical: invertAxes,
	                    reverse: !invertAxes && this$1.chartService.rtl,
	                    axisCrossingValue: invertAxes ? MAX_VALUE : 0
	                }, axisOptions);

	                if (!defined(axisOptions.justified)) {
	                    axisOptions.justified = this$1.isJustified();
	                }

	                if (this$1.axisRequiresRounding(name, i)) {
	                    axisOptions.justified = false;
	                }

	                var categoryAxis = (void 0);

	                if (isDateAxis(axisOptions, categories[0])) {
	                    categoryAxis = new dataviz.DateCategoryAxis(axisOptions, this$1.chartService);
	                } else {
	                    categoryAxis = new CategoryAxis(axisOptions, this$1.chartService);
	                }

	                definitions[i].categories = categoryAxis.options.srcCategories;

	                if (name) {
	                    if (this$1.namedCategoryAxes[name]) {
	                        throw new Error(("Category axis with name " + name + " is already defined"));
	                    }
	                    this$1.namedCategoryAxes[name] = categoryAxis;
	                }

	                categoryAxis.axisIndex = i;
	                axes.push(categoryAxis);
	                this$1.appendAxis(categoryAxis);
	            }
	        }

	        var primaryAxis = this.categoryAxis || axes[0];
	        this.categoryAxis = primaryAxis;

	        if (invertAxes) {
	            this.axisY = primaryAxis;
	        } else {
	            this.axisX = primaryAxis;
	        }
	    },

	    isJustified: function() {
	        var series = this.series;

	        for (var i = 0; i < series.length; i++) {
	            var currentSeries = series[i];
	            if (!inArray(currentSeries.type, AREA_SERIES)) {
	                return false;
	            }
	        }

	        return true;
	    },

	    createValueAxes: function(panes) {
	        var this$1 = this;

	        var tracker = this.valueAxisRangeTracker;
	        var defaultRange = tracker.query();
	        var definitions = [].concat(this.options.valueAxis);
	        var invertAxes = this.invertAxes;
	        var baseOptions = { vertical: !invertAxes, reverse: invertAxes && this.chartService.rtl };
	        var axes = [];

	        if (this.stack100) {
	            baseOptions.roundToMajorUnit = false;
	            baseOptions.labels = { format: "P0" };
	        }

	        for (var i = 0; i < definitions.length; i++) {
	            var axisOptions = definitions[i];
	            var axisPane = this$1.findPane(axisOptions.pane);

	            if (inArray(axisPane, panes)) {
	                var name = axisOptions.name;
	                var defaultAxisRange = equalsIgnoreCase(axisOptions.type, LOGARITHMIC) ? { min: 0.1, max: 1 } : { min: 0, max: 1 };
	                var range = tracker.query(name) || defaultRange || defaultAxisRange;

	                if (i === 0 && range && defaultRange) {
	                    range.min = Math.min(range.min, defaultRange.min);
	                    range.max = Math.max(range.max, defaultRange.max);
	                }

	                var axisType = (void 0);
	                if (equalsIgnoreCase(axisOptions.type, LOGARITHMIC)) {
	                    axisType = dataviz.LogarithmicAxis;
	                } else {
	                    axisType = dataviz.NumericAxis;
	                }

	                var valueAxis = new axisType(range.min, range.max,
	                    deepExtend({}, baseOptions, axisOptions),
	                    this$1.chartService
	                );

	                if (name) {
	                    if (this$1.namedValueAxes[name]) {
	                        throw new Error(("Value axis with name " + name + " is already defined"));
	                    }
	                    this$1.namedValueAxes[name] = valueAxis;
	                }
	                valueAxis.axisIndex = i;

	                axes.push(valueAxis);
	                this$1.appendAxis(valueAxis);
	            }
	        }

	        var primaryAxis = this.valueAxis || axes[0];
	        this.valueAxis = primaryAxis;

	        if (invertAxes) {
	            this.axisX = primaryAxis;
	        } else {
	            this.axisY = primaryAxis;
	        }
	    },

	    _dispatchEvent: function(chart, e, eventType) {
	        var coords = chart._eventCoordinates(e);
	        var point = new Point(coords.x, coords.y);
	        var pane = this.pointPane(point);
	        var categories = [];
	        var values = [];

	        if (!pane) {
	            return;
	        }

	        var allAxes = pane.axes;
	        for (var i = 0; i < allAxes.length; i++) {
	            var axis = allAxes[i];
	            if (axis.getValue) {
	                appendIfNotNull(values, axis.getValue(point));
	            } else {
	                appendIfNotNull(categories, axis.getCategory(point));
	            }
	        }

	        if (categories.length === 0) {
	            appendIfNotNull(categories, this.categoryAxis.getCategory(point));
	        }

	        if (categories.length > 0 && values.length > 0) {
	            chart.trigger(eventType, {
	                element: eventElement(e),
	                originalEvent: e,
	                category: singleItemOrArray(categories),
	                value: singleItemOrArray(values)
	            });
	        }
	    },

	    pointPane: function(point) {
	        var panes = this.panes;

	        for (var i = 0; i < panes.length; i++) {
	            var currentPane = panes[i];
	            if (currentPane.contentBox.containsPoint(point)) {
	                return currentPane;
	            }
	        }
	    },

	    updateAxisOptions: function(axis, options) {
	        updateAxisOptions(this.options, axis, options);
	        updateAxisOptions(this.originalOptions, axis, options);
	    }
	});

	function updateAxisOptions(targetOptions, axis, options) {
	    var axesOptions = axis instanceof CategoryAxis ? [].concat(targetOptions.categoryAxis) : [].concat(targetOptions.valueAxis);
	    deepExtend(axesOptions[axis.axisIndex], options);
	}

	function groupSeries(series, axis, axisIx) {
	    return grep(series, function(s) {
	        return (axisIx === 0 && !s.categoryAxis) || (s.categoryAxis === axis);
	    });
	}

	setDefaultOptions(CategoricalPlotArea, {
	    categoryAxis: {},
	    valueAxis: {}
	});

	deepExtend(CategoricalPlotArea.prototype, PlotAreaEventsMixin);

	var Highlight = Class.extend({
	    init: function() {

	        this._points = [];
	    },

	    destroy: function() {
	        this._points = [];
	    },

	    show: function(points) {
	        var this$1 = this;

	        var arrayPoints = [].concat(points);
	        this.hide();

	        for (var i = 0; i < arrayPoints.length; i++) {
	            var point = arrayPoints[i];
	            if (point && point.toggleHighlight && point.hasHighlight()) {
	                this$1.togglePointHighlight(point, true);
	                this$1._points.push(point);
	            }
	        }
	    },

	    togglePointHighlight: function(point, show) {
	        var toggleHandler = (point.options.highlight || {}).toggle;
	        if (toggleHandler) {
	            var eventArgs = {
	                category: point.category,
	                series: point.series,
	                dataItem: point.dataItem,
	                value: point.value,
	                stackValue: point.stackValue,
	                preventDefault: preventDefault,
	                visual: point.highlightVisual(),
	                show: show
	            };
	            toggleHandler(eventArgs);
	            if (!eventArgs._defaultPrevented) {
	                point.toggleHighlight(show);
	            }
	        } else {
	            point.toggleHighlight(show);
	        }
	    },

	    hide: function() {
	        var this$1 = this;

	        var points = this._points;
	        while (points.length) {
	            this$1.togglePointHighlight(points.pop(), false);
	        }
	    },

	    isHighlighted: function(element) {
	        var points = this._points;

	        for (var i = 0; i < points.length; i++) {
	            var point = points[i];
	            if (element === point) {
	                return true;
	            }
	        }

	        return false;
	    }
	});

	function preventDefault() {
	    this._defaultPrevented = true;
	}

	function acceptKey(e, mouseKey) {
	    var key = (mouseKey || "").toLowerCase();
	    var event = e.event;
	    var accept = (key === "none" && !(event.ctrlKey || event.shiftKey || event.altKey)) || event[key + "Key"];

	    return accept;
	}

	function toChartAxisRanges(axisRanges) {
	    var ranges = {};
	    for (var idx = 0; idx < axisRanges.length; idx++) {
	        var axisRange = axisRanges[idx];
	        if (axisRange.axis.options.name) {
	            ranges[axisRange.axis.options.name] = {
	                min: axisRange.range.min,
	                max: axisRange.range.max
	            };
	        }
	    }
	    return ranges;
	}

	var Pannable = Class.extend({
	    init: function(plotArea, options) {

	        this.plotArea = plotArea;
	        this.options = deepExtend({}, this.options, options);
	    },

	    start: function(e) {
	        this._active = acceptKey(e, this.options.key);
	        return this._active;
	    },

	    move: function(e) {
	        if (this._active) {
	            var axisRanges = this.axisRanges = this._panAxes(e, X).concat(this._panAxes(e, Y));
	            if (axisRanges.length) {
	                this.axisRanges = axisRanges;
	                return toChartAxisRanges(axisRanges);
	            }
	        }
	    },

	    end: function() {
	        var active = this._active;
	        this._active = false;

	        return active;
	    },

	    pan: function() {
	        var ref = this;
	        var plotArea = ref.plotArea;
	        var axisRanges = ref.axisRanges;
	        if (axisRanges.length) {
	            for (var idx = 0; idx < axisRanges.length; idx++) {
	                var range = axisRanges[idx];
	                plotArea.updateAxisOptions(range.axis, range.range);
	            }
	            plotArea.redraw(plotArea.panes);
	        }
	    },

	    destroy: function() {
	        delete this.plotArea;
	    },

	    _panAxes: function(e, position) {
	        var plotArea = this.plotArea;
	        var delta = -e[position].delta;
	        var lock = (this.options.lock || "").toLowerCase();
	        var updatedAxes = [];

	        if (delta !== 0 && (lock || "").toLowerCase() !== position) {
	            var axes = plotArea.axes;
	            for (var idx = 0; idx < axes.length; idx++) {
	                var axis = axes[idx];

	                if (position === X && !axis.options.vertical || position === Y && axis.options.vertical) {
	                    var range = axis.pan(delta);

	                    if (range) {
	                        range.limitRange = true;
	                        updatedAxes.push({
	                            axis: axis,
	                            range: range
	                        });
	                    }
	                }
	            }
	        }

	        return updatedAxes;
	    }
	});

	Pannable.prototype.options = {
	    key: "none",
	    lock: "none"
	};

	var ZoomSelection = Class.extend({
	    init: function(chart, options) {

	        this.chart = chart;
	        this.options = deepExtend({}, this.options, options);
	        this.createElement();
	    },

	    createElement: function() {
	        var marquee = this._marquee = document.createElement("div");
	        marquee.className = "k-marquee";
	        var marqueeColor = document.createElement("div");
	        marqueeColor.className = "k-marquee-color";
	        marquee.appendChild(marqueeColor);
	    },

	    removeElement: function() {
	        if (this._marquee.parentNode) {
	            this._marquee.parentNode.removeChild(this._marquee);
	        }
	    },

	    setStyles: function(styles) {
	        elementStyles(this._marquee, styles);
	    },

	    start: function(e) {
	        if (acceptKey(e, this.options.key)) {
	            var chart = this.chart;
	            var point = chart._eventCoordinates(e);
	            var zoomPane = this._zoomPane = chart._plotArea.paneByPoint(point);
	            var clipBox = zoomPane ? zoomPane.chartsBox().clone() : null;

	            if (zoomPane && clipBox) {
	                var offset = this._elementOffset();

	                clipBox.translate(offset.left, offset.top);
	                this._zoomPaneClipBox = clipBox;

	                document.body.appendChild(this._marquee);
	                this.setStyles({
	                    left: e.pageX + 1,
	                    top: e.pageY + 1,
	                    width: 0,
	                    height: 0
	                });

	                return true;
	            }
	        }
	        return false;
	    },

	    _elementOffset: function() {
	        var chartElement = this.chart.element;
	        var ref = elementStyles(chartElement, [ "paddingLeft", "paddingTop" ]);
	        var paddingLeft = ref.paddingLeft;
	        var paddingTop = ref.paddingTop;
	        var offset = dataviz.elementOffset(chartElement);

	        return {
	            left: paddingLeft + offset.left,
	            top: paddingTop + offset.top
	        };
	    },

	    move: function(e) {
	        var zoomPane = this._zoomPane;
	        if (zoomPane) {
	            this.setStyles(this._selectionPosition(e));
	        }
	    },

	    end: function(e) {
	        var zoomPane = this._zoomPane;
	        if (zoomPane) {
	            var elementOffset$$1 = this._elementOffset();
	            var selectionPosition = this._selectionPosition(e);
	            selectionPosition.left -= elementOffset$$1.left;
	            selectionPosition.top -= elementOffset$$1.top;

	            var start = { x: selectionPosition.left, y: selectionPosition.top };
	            var end = { x: selectionPosition.left + selectionPosition.width, y: selectionPosition.top + selectionPosition.height };
	            this._updateAxisRanges(start, end);

	            this.removeElement();
	            delete this._zoomPane;

	            return toChartAxisRanges(this.axisRanges);
	        }
	    },

	    zoom: function() {
	        var axisRanges = this.axisRanges;
	        if (axisRanges && axisRanges.length) {
	            var plotArea = this.chart._plotArea;
	            for (var idx = 0; idx < axisRanges.length; idx++) {
	                var axisRange = axisRanges[idx];
	                plotArea.updateAxisOptions(axisRange.axis, axisRange.range);
	            }
	            plotArea.redraw(plotArea.panes);
	        }
	    },

	    destroy: function() {
	        this.removeElement();
	        delete this._marquee;
	        delete this.chart;
	    },

	    _updateAxisRanges: function(start, end) {
	        var lock = (this.options.lock || "").toLowerCase();
	        var axisRanges = [];

	        var axes = this._zoomPane.axes;
	        for (var idx = 0; idx < axes.length; idx++) {
	            var axis = axes[idx];
	            var vertical = axis.options.vertical;
	            if (!(lock === X && !vertical) && !(lock === Y && vertical) && defined(axis.axisIndex)) {
	                var range = axis.pointsRange(start, end);
	                if (range) {
	                    axisRanges.push({
	                        axis: axis,
	                        range: range
	                    });
	                }
	            }
	        }

	        this.axisRanges = axisRanges;
	    },

	    _selectionPosition: function(e) {
	        var clipBox = this._zoomPaneClipBox;
	        var startLocation = {
	            x: e.x.startLocation,
	            y: e.y.startLocation
	        };
	        var pageX = e.x.location;
	        var pageY = e.y.location;
	        var lock = (this.options.lock || "").toLowerCase();
	        var left = Math.min(startLocation.x, pageX);
	        var top = Math.min(startLocation.y, pageY);
	        var width = Math.abs(startLocation.x - pageX);
	        var height = Math.abs(startLocation.y - pageY);

	        if (lock === X) {
	            left = clipBox.x1;
	            width = clipBox.width();
	        }
	        if (lock === Y) {
	            top = clipBox.y1;
	            height = clipBox.height();
	        }

	        if (pageX > clipBox.x2) {
	            width = clipBox.x2 - startLocation.x;
	        }

	        if (pageX < clipBox.x1) {
	            width = startLocation.x - clipBox.x1;
	        }

	        if (pageY > clipBox.y2) {
	            height = clipBox.y2 - startLocation.y;
	        }

	        if (pageY < clipBox.y1) {
	            height = startLocation.y - clipBox.y1;
	        }

	        return {
	            left: Math.max(left, clipBox.x1),
	            top: Math.max(top, clipBox.y1),
	            width: width,
	            height: height
	        };
	    }
	});

	ZoomSelection.prototype.options = {
	    key: "shift",
	    lock: "none"
	};

	var MousewheelZoom = Class.extend({
	    init: function(chart, options) {

	        this.chart = chart;
	        this.options = deepExtend({}, this.options, options);
	    },

	    updateRanges: function(delta) {
	        var lock = (this.options.lock || "").toLowerCase();
	        var axisRanges = [];
	        var axes = this.chart._plotArea.axes;

	        for (var idx = 0; idx < axes.length; idx++) {
	            var axis = axes[idx];
	            var vertical = axis.options.vertical;

	            if (!(lock === X && !vertical) && !(lock === Y && vertical) && axis.zoomRange) {
	                var range = axis.zoomRange(-delta);

	                if (range) {
	                    axisRanges.push({
	                        axis: axis,
	                        range: range
	                    });
	                }
	            }
	        }

	        this.axisRanges = axisRanges;
	        return toChartAxisRanges(axisRanges);
	    },

	    zoom: function() {
	        var axisRanges = this.axisRanges;
	        var plotArea = this.chart._plotArea;

	        if (axisRanges && axisRanges.length && plotArea.updateAxisOptions) {
	            for (var idx = 0; idx < axisRanges.length; idx++) {
	                var axisRange = axisRanges[idx];
	                plotArea.updateAxisOptions(axisRange.axis, axisRange.range);
	            }
	            plotArea.redraw(plotArea.panes);
	        }
	    },

	    destroy: function() {
	        delete this.chart;
	    }
	});

	var LegendLayout = ChartElement.extend({
	    init: function(options, chartService) {
	        ChartElement.fn.init.call(this, options);

	        this.chartService = chartService;
	    },

	    render: function() {
	        var ref = this;
	        var children = ref.children;
	        var options = ref.options;
	        var vertical = options.vertical;

	        this.visual = new drawing.Layout(null, {
	            spacing: vertical ? 0 : options.spacing,
	            lineSpacing: vertical ? options.spacing : 0,
	            orientation: vertical ? "vertical" : "horizontal",
	            reverse: options.rtl,
	            alignItems: vertical ? "start" : "center"
	        });

	        for (var idx = 0; idx < children.length; idx++) {
	            var legendItem = children[idx];
	            legendItem.reflow(new Box());
	            legendItem.renderVisual();
	        }
	    },

	    reflow: function(box) {
	        this.visual.rect(box.toRect());
	        this.visual.reflow();
	        var bbox = this.visual.clippedBBox();

	        if (bbox) {
	            this.box = dataviz.rectToBox(bbox);
	        } else {
	            this.box = new Box();
	        }
	    },

	    renderVisual: function() {
	        this.addVisual();
	    },

	    createVisual: function() {}
	});

	var LegendItem = BoxElement.extend({
	    init: function(options) {
	        BoxElement.fn.init.call(this, options);

	        this.createContainer();
	        if (!options.rtl) {
	            this.createMarker();
	            this.createLabel();
	        } else {
	            this.createLabel();
	            this.createMarker();
	        }
	    },

	    createContainer: function() {
	        this.container = new dataviz.FloatElement({ vertical: false, wrap: false, align: CENTER, spacing: this.options.spacing });
	        this.append(this.container);
	    },

	    createMarker: function() {
	        this.container.append(new ShapeElement(this.markerOptions()));
	    },

	    markerOptions: function() {
	        var options = this.options;
	        var markerColor = options.markerColor;
	        return deepExtend({}, options.markers, {
	            background: markerColor,
	            border: {
	                color: markerColor
	            }
	        });
	    },

	    createLabel: function() {
	        var options = this.options;
	        var labelOptions = deepExtend({}, options.labels);

	        this.container.append(new TextBox(options.text, labelOptions));
	    },

	    renderComplete: function() {
	        BoxElement.fn.renderComplete.call(this);

	        var cursor = this.options.cursor || {};
	        var eventSink = this._itemOverlay = Path.fromRect(this.container.box.toRect(), {
	            fill: {
	                color: WHITE,
	                opacity: 0
	            },
	            stroke: null,
	            cursor: cursor.style || cursor
	        });

	        this.appendVisual(eventSink);
	    },

	    click: function(widget, e) {
	        var args = this.eventArgs(e);

	        if (!widget.trigger(LEGEND_ITEM_CLICK, args) && e && e.type === 'contextmenu') {
	            e.preventDefault();
	        }
	    },

	    over: function(widget, e) {
	        var args = this.eventArgs(e);

	        if (!widget.trigger(LEGEND_ITEM_HOVER, args)) {
	            widget._legendItemHover(args.seriesIndex, args.pointIndex);
	        }

	        // Don't trigger point hover for legend items
	        return true;
	    },

	    out: function(widget, e) {
	        widget._unsetActivePoint();

	        widget.trigger(LEGEND_ITEM_LEAVE, this.eventArgs(e));
	    },

	    eventArgs: function(e) {
	        var options = this.options;

	        return {
	            element: eventElement(e),
	            text: options.text,
	            series: options.series,
	            seriesIndex: options.series.index,
	            pointIndex: options.pointIndex
	        };
	    },

	    renderVisual: function() {
	        var this$1 = this;

	        var options = this.options;
	        var customVisual = options.visual;

	        if (customVisual) {
	            this.visual = customVisual({
	                active: options.active,
	                series: options.series,
	                sender: this.getSender(),
	                pointIndex: options.pointIndex,
	                options: {
	                    markers: this.markerOptions(),
	                    labels: options.labels
	                },
	                createVisual: function () {
	                    this$1.createVisual();
	                    this$1.renderChildren();
	                    this$1.renderComplete();

	                    var defaultVisual = this$1.visual;

	                    delete this$1.visual;

	                    return defaultVisual;
	                }
	            });
	            this.addVisual();
	        } else {
	            BoxElement.fn.renderVisual.call(this);
	        }
	    }
	});

	var HORIZONTAL = "horizontal";
	var POINTER = "pointer";
	var CUSTOM = "custom";

	var Legend = ChartElement.extend({
	    init: function(options, chartService) {
	        if (chartService === void 0) { chartService = {}; }

	        ChartElement.fn.init.call(this, options);

	        this.chartService = chartService;

	        if (!inArray(this.options.position, [ TOP, RIGHT, BOTTOM, LEFT, CUSTOM ])) {
	            this.options.position = RIGHT;
	        }

	        this.createContainers();

	        this.createLegendTitle(options.title);

	        this.createItems();
	    },

	    createContainers: function() {
	        var options = this.options;
	        var position = options.position;
	        var userAlign = options.align;
	        var align = position;
	        var vAlign = CENTER;

	        if (position === CUSTOM) {
	            align = LEFT;
	        } else if (inArray(position, [ TOP, BOTTOM ])) {
	            if (userAlign === "start") {
	                align = LEFT;
	            } else if (userAlign === "end") {
	                align = RIGHT;
	            } else {
	                align = CENTER;
	            }
	            vAlign = position;
	        } else if (userAlign) {
	            if (userAlign === "start") {
	                vAlign = TOP;
	            } else if (userAlign === "end") {
	                vAlign = BOTTOM;
	            }
	        }

	        this.container = new BoxElement({
	            margin: options.margin,
	            padding: options.padding,
	            background: options.background,
	            border: options.border,
	            vAlign: vAlign,
	            align: align,
	            zIndex: options.zIndex,
	            shrinkToFit: true
	        });

	        if (this.hasTitle()) {
	            this.itemsContainer = new BoxElement({
	                vAlign: vAlign,
	                align: align,
	                zIndex: options.zIndex,
	                shrinkToFit: true
	            });
	        } else {
	            this.itemsContainer = this.container;
	        }

	        this.append(this.container);
	    },

	    createItems: function() {
	        var chartService = this.getService();
	        var options = this.options;
	        var vertical = this.isVertical();
	        var innerElement = new LegendLayout({
	            vertical: vertical,
	            spacing: options.spacing,
	            rtl: chartService.rtl
	        }, chartService);
	        var items = options.items;

	        if (options.reverse) {
	            items = items.slice(0).reverse();
	        }

	        var count = items.length;

	        for (var i = 0; i < count; i++) {
	            var item = items[i];

	            innerElement.append(new LegendItem(deepExtend({}, {
	                markers: options.markers,
	                labels: options.labels,
	                rtl: chartService.rtl
	            }, options.item, item)));
	        }

	        innerElement.render();
	        this.itemsContainer.append(innerElement);
	    },

	    isVertical: function() {
	        var ref = this.options;
	        var orientation = ref.orientation;
	        var position = ref.position;
	        var vertical = (position === CUSTOM && orientation !== HORIZONTAL) ||
	               (defined(orientation) ? orientation !== HORIZONTAL : inArray(position, [ LEFT, RIGHT ]));

	        return vertical;
	    },

	    hasItems: function() {
	        return this.container.children[0].children.length > 0;
	    },

	    reflow: function(targetBox) {
	        var options = this.options;
	        var legendBox = targetBox.clone();

	        if (!this.hasItems()) {
	            this.box = legendBox;
	            return;
	        }

	        if (options.position === CUSTOM) {
	            this.containerCustomReflow(legendBox);
	            this.box = legendBox;
	        } else {
	            this.containerReflow(legendBox);
	        }

	        if (this.hasTitle()) {
	            this.title.reflow(new Box(this.container.box.x1, this.title.box.y1, this.container.box.x2, this.title.box.y2));
	        }
	    },

	    containerReflow: function(targetBox) {
	        var ref = this;
	        var options = ref.options;
	        var container = ref.container;
	        var position = options.position;
	        var width = options.width;
	        var height = options.height;
	        var pos = position === TOP || position === BOTTOM ? X : Y;
	        var vertical = this.isVertical();
	        var alignTarget = targetBox.clone();
	        var containerBox = targetBox.clone();

	        if (position === LEFT || position === RIGHT) {
	            containerBox.y1 = alignTarget.y1 = 0;
	        }

	        if (vertical && height) {
	            containerBox.y2 = containerBox.y1 + height;
	            containerBox.align(alignTarget, Y, container.options.vAlign);
	        } else if (!vertical && width) {
	            containerBox.x2 = containerBox.x1 + width;
	            containerBox.align(alignTarget, X, container.options.align);
	        }

	        container.reflow(containerBox);
	        containerBox = container.box;

	        var box = containerBox.clone();

	        if (options.offsetX || options.offsetY) {
	            containerBox.translate(options.offsetX, options.offsetY);
	            container.reflow(containerBox);
	        }

	        box[pos + 1] = targetBox[pos + 1];
	        box[pos + 2] = targetBox[pos + 2];

	        this.box = box;
	    },

	    containerCustomReflow: function(targetBox) {
	        var ref = this;
	        var options = ref.options;
	        var container = ref.container;
	        var offsetX = options.offsetX;
	        var offsetY = options.offsetY;
	        var width = options.width;
	        var height = options.height;
	        var vertical = this.isVertical();
	        var containerBox = targetBox.clone();

	        if (vertical && height) {
	            containerBox.y2 = containerBox.y1 + height;
	        } else if (!vertical && width) {
	            containerBox.x2 = containerBox.x1 + width;
	        }
	        container.reflow(containerBox);
	        containerBox = container.box;

	        container.reflow(new Box(
	            offsetX, offsetY,
	            offsetX + containerBox.width(), offsetY + containerBox.height()
	        ));
	    },

	    renderVisual: function() {
	        if (this.hasItems()) {
	            ChartElement.fn.renderVisual.call(this);
	        }
	    },

	    createLegendTitle: function(title) {
	        var titleOptions = deepExtend({}, {
	            color: BLACK,
	            position: TOP,
	            align: CENTER
	        }, title);
	        var text = titleOptions.text;

	        if (!title || title.visible === false) {
	            return;
	        }

	        if (defined(titleOptions) && titleOptions.visible) {
	            var labelTemplate = getTemplate(titleOptions);
	            if (labelTemplate) {
	                text = labelTemplate({ text: text });
	            } else if (titleOptions.format) {
	                text = this.chartService.format.auto(titleOptions.format, text);
	            }
	        }

	        this.title = new TextBox(text, titleOptions);

	        this.createTitleLayout();

	        this.appendTitleLayoutContent();
	    },

	    createTitleLayout: function() {
	        this.layout = new dataviz.FloatElement({
	            vertical: true,
	            wrap: false
	        });

	        this.container.append(this.layout);
	    },

	    hasTitle: function() {
	        return Boolean(this.options.title && this.options.title.visible !== false);
	    },

	    appendTitleLayoutContent: function() {
	        var options = this.options;

	        if (options.title.position === BOTTOM) {
	            this.layout.append(this.itemsContainer);
	            this.layout.append(this.title);
	        } else {
	            this.layout.append(this.title);
	            this.layout.append(this.itemsContainer);
	        }
	    }
	});

	setDefaultOptions(Legend, {
	    position: RIGHT,
	    items: [],
	    offsetX: 0,
	    offsetY: 0,
	    margin: getSpacing(5),
	    padding: getSpacing(5),
	    border: {
	        color: BLACK,
	        width: 0
	    },
	    item: {
	        cursor: POINTER,
	        spacing: 6
	    },
	    spacing: 6,
	    background: "",
	    zIndex: 1,
	    markers: {
	        border: {
	            width: 0
	        },
	        width: 15,
	        height: 3,
	        type: "rect",
	        align: LEFT,
	        vAlign: CENTER
	    }
	});

	var PlotAreaFactory = Class.extend({
	    init: function() {

	        this._registry = [];
	    },

	    register: function(type, seriesTypes) {
	        this._registry.push({
	            type: type,
	            seriesTypes: seriesTypes
	        });
	    },

	    create: function(srcSeries, options, chartService) {
	        var registry = this._registry;
	        var match = registry[0];
	        var series;

	        for (var idx = 0; idx < registry.length; idx++) {
	            var entry = registry[idx];
	            series = filterSeriesByType(srcSeries, entry.seriesTypes);

	            if (series.length > 0) {
	                match = entry;
	                break;
	            }
	        }

	        return new match.type(series, options, chartService);
	    }
	});

	PlotAreaFactory.current = new PlotAreaFactory();

	var ZOOM_ACCELERATION = 3;
	var SELECTOR_HEIGHT_ADJUST = 0.1;

	function createDiv(className) {
	    var element = document.createElement("div");
	    if (className) {
	        element.className = className;
	    }

	    return element;
	}

	function closestHandle(element) {
	    var current = element;
	    while (current && !hasClasses(current, "k-handle")) {
	        current = current.parentNode;
	    }

	    return current;
	}

	var Selection = Class.extend({
	    init: function(chart, categoryAxis, options, observer) {

	        var chartElement = chart.element;

	        this.options = deepExtend({}, this.options, options);
	        this.chart = chart;
	        this.observer = observer;
	        this.chartElement = chartElement;
	        this.categoryAxis = categoryAxis;
	        this._dateAxis = this.categoryAxis instanceof dataviz.DateCategoryAxis;

	        this.initOptions();

	        this.visible = this.options.visible && chartElement.offsetHeight;

	        if (this.visible) {
	            this.createElements();

	            this.set(this._index(this.options.from), this._index(this.options.to));

	            this.bindEvents();
	        }
	    },

	    onPane: function(pane) {
	        return this.categoryAxis.pane === pane;
	    },

	    createElements: function() {
	        var options = this.options;
	        var wrapper = this.wrapper = createDiv("k-selector");
	        elementStyles(wrapper, {
	            top: options.offset.top,
	            left: options.offset.left,
	            width: options.width,
	            height: options.height,
	            direction: 'ltr'
	        });
	        var selection = this.selection = createDiv("k-selection");
	        this.leftMask = createDiv("k-mask");
	        this.rightMask = createDiv("k-mask");

	        wrapper.appendChild(this.leftMask);
	        wrapper.appendChild(this.rightMask);
	        wrapper.appendChild(selection);

	        selection.appendChild(createDiv("k-selection-bg"));

	        var leftHandle = this.leftHandle = createDiv("k-handle k-left-handle");
	        var rightHandle = this.rightHandle = createDiv("k-handle k-right-handle");
	        leftHandle.appendChild(createDiv());
	        rightHandle.appendChild(createDiv());

	        selection.appendChild(leftHandle);
	        selection.appendChild(rightHandle);

	        this.chartElement.appendChild(wrapper);
	        var selectionStyles = elementStyles(selection, [ "borderLeftWidth", "borderRightWidth", "height" ]);
	        var leftHandleHeight = elementStyles(leftHandle, "height").height;
	        var rightHandleHeight = elementStyles(rightHandle, "height").height;

	        options.selection = {
	            border: {
	                left: selectionStyles.borderLeftWidth,
	                right: selectionStyles.borderRightWidth
	            }
	        };

	        elementStyles(leftHandle, {
	            top: (selectionStyles.height - leftHandleHeight) / 2
	        });

	        elementStyles(rightHandle, {
	            top: (selectionStyles.height - rightHandleHeight) / 2
	        });

	        wrapper.style.cssText = wrapper.style.cssText;
	    },

	    bindEvents: function() {
	        if (this.options.mousewheel !== false) {
	            this._mousewheelHandler = this._mousewheel.bind(this);
	            var obj;
	            bindEvents(this.wrapper, ( obj = {}, obj[ MOUSEWHEEL ] = this._mousewheelHandler, obj ));
	        }

	        this._domEvents = services.DomEventsBuilder.create(this.wrapper, {
	            stopPropagation: true, // applicable for the jQuery UserEvents
	            start: this._start.bind(this),
	            move: this._move.bind(this),
	            end: this._end.bind(this),
	            tap: this._tap.bind(this),
	            press: this._press.bind(this),
	            gesturestart: this._gesturestart.bind(this),
	            gesturechange: this._gesturechange.bind(this),
	            gestureend: this._gestureend.bind(this)
	        });
	    },

	    initOptions: function() {
	        var ref = this;
	        var options = ref.options;
	        var categoryAxis = ref.categoryAxis;
	        var box = categoryAxis.pane.chartsBox();
	        var intlService = this.chart.chartService.intl;

	        if (this._dateAxis) {
	            deepExtend(options, {
	                min: parseDate(intlService, options.min),
	                max: parseDate(intlService, options.max),
	                from: parseDate(intlService, options.from),
	                to: parseDate(intlService, options.to)
	            });
	        }

	        var ref$1 = elementStyles(this.chartElement, [ "paddingLeft", "paddingTop" ]);
	        var paddingLeft = ref$1.paddingLeft;
	        var paddingTop = ref$1.paddingTop;

	        this.options = deepExtend({}, {
	            width: box.width(),
	            height: box.height() + SELECTOR_HEIGHT_ADJUST, //workaround for sub-pixel hover on the paths in chrome
	            padding: {
	                left: paddingLeft,
	                top: paddingTop
	            },
	            offset: {
	                left: box.x1 + paddingLeft,
	                top: box.y1 + paddingTop
	            },
	            from: options.min,
	            to: options.max
	        }, options);
	    },

	    destroy: function() {
	        if (this._domEvents) {
	            this._domEvents.destroy();
	            delete this._domEvents;
	        }

	        clearTimeout(this._mwTimeout);
	        this._state = null;

	        if (this.wrapper) {
	            if (this._mousewheelHandler) {
	                var obj;
	                unbindEvents(this.wrapper, ( obj = {}, obj[ MOUSEWHEEL ] = this._mousewheelHandler, obj ));
	                this._mousewheelHandler = null;
	            }
	            this.chartElement.removeChild(this.wrapper);
	            this.wrapper = null;
	        }
	    },

	    _rangeEventArgs: function(range) {

	        return {
	            axis: this.categoryAxis.options,
	            from: this._value(range.from),
	            to: this._value(range.to)
	        };
	    },

	    _start: function(e) {
	        var options = this.options;
	        var target = eventElement(e);

	        if (this._state || !target) {
	            return;
	        }

	        this.chart._unsetActivePoint();
	        this._state = {
	            moveTarget: closestHandle(target) || target,
	            startLocation: e.x ? e.x.location : 0,
	            range: {
	                from: this._index(options.from),
	                to: this._index(options.to)
	            }
	        };

	        var args = this._rangeEventArgs({
	            from: this._index(options.from),
	            to: this._index(options.to)
	        });

	        if (this.trigger(SELECT_START, args)) {
	            this._state = null;
	        }
	    },

	    _press: function(e) {
	        var handle;
	        if (this._state) {
	            handle = this._state.moveTarget;
	        } else {
	            handle = closestHandle(eventElement(e));
	        }
	        if (handle) {
	            dataviz.addClass(handle, "k-handle-active");
	        }
	    },

	    _move: function(e) {
	        if (!this._state) {
	            return;
	        }

	        var ref = this;
	        var state = ref._state;
	        var options = ref.options;
	        var categoryAxis = ref.categoryAxis;
	        var range = state.range;
	        var target = state.moveTarget;
	        var reverse = categoryAxis.options.reverse;
	        var from = this._index(options.from);
	        var to = this._index(options.to);
	        var min = this._index(options.min);
	        var max = this._index(options.max);
	        var delta = state.startLocation - e.x.location;
	        var oldRange = { from: range.from, to: range.to };
	        var span = range.to - range.from;
	        var scale = elementStyles(this.wrapper, "width").width / (categoryAxis.categoriesCount() - 1);
	        var offset = Math.round(delta / scale) * (reverse ? -1 : 1);

	        if (!target) {
	            return;
	        }

	        var leftHandle = hasClasses(target, "k-left-handle");
	        var rightHandle = hasClasses(target, "k-right-handle");

	        if (hasClasses(target, "k-selection k-selection-bg")) {
	            range.from = Math.min(
	                Math.max(min, from - offset),
	                max - span
	            );
	            range.to = Math.min(
	                range.from + span,
	                max
	            );
	        } else if ((leftHandle && !reverse) || (rightHandle && reverse)) {
	            range.from = Math.min(
	                Math.max(min, from - offset),
	                max - 1
	            );
	            range.to = Math.max(range.from + 1, range.to);
	        } else if ((leftHandle && reverse) || (rightHandle && !reverse)) {
	            range.to = Math.min(
	                Math.max(min + 1, to - offset),
	                max
	            );
	            range.from = Math.min(range.to - 1, range.from);
	        }

	        if (range.from !== oldRange.from || range.to !== oldRange.to) {
	            this.move(range.from, range.to);
	            this.trigger(SELECT, this._rangeEventArgs(range));
	        }
	    },

	    _end: function() {
	        if (this._state) {
	            var moveTarget = this._state.moveTarget;
	            if (moveTarget) {
	                dataviz.removeClass(moveTarget, "k-handle-active");
	            }

	            var range = this._state.range;
	            this.set(range.from, range.to);
	            this.trigger(SELECT_END, this._rangeEventArgs(range));

	            delete this._state;
	        }
	    },

	    _tap: function(e) {
	        var ref = this;
	        var options = ref.options;
	        var categoryAxis = ref.categoryAxis;
	        var coords = this.chart._eventCoordinates(e);
	        var categoryIx = categoryAxis.pointCategoryIndex(new Point(coords.x, categoryAxis.box.y1));
	        var from = this._index(options.from);
	        var to = this._index(options.to);
	        var min = this._index(options.min);
	        var max = this._index(options.max);
	        var span = to - from;
	        var mid = from + span / 2;
	        var range = {};
	        var rightClick = e.event.which === 3;
	        var offset = Math.round(mid - categoryIx);

	        if (this._state || rightClick) {
	            return;
	        }

	        this.chart._unsetActivePoint();

	        if (!categoryAxis.options.justified) {
	            offset--;
	        }

	        range.from = Math.min(
	            Math.max(min, from - offset),
	            max - span
	        );

	        range.to = Math.min(range.from + span, max);

	        this._start(e);
	        if (this._state) {
	            this._state.range = range;
	            this.trigger(SELECT, this._rangeEventArgs(range));
	            this._end();
	        }
	    },

	    _mousewheel: function(e) {
	        var this$1 = this;

	        var delta = dataviz.mousewheelDelta(e);

	        this._start({ target: this.selection });

	        if (this._state) {
	            var range = this._state.range;

	            e.preventDefault();
	            e.stopPropagation();

	            if (Math.abs(delta) > 1) {
	                delta *= ZOOM_ACCELERATION;
	            }

	            if (this.options.mousewheel.reverse) {
	                delta *= -1;
	            }

	            if (this.expand(delta)) {
	                this.trigger(SELECT, {
	                    axis: this.categoryAxis.options,
	                    delta: delta,
	                    originalEvent: e,
	                    from: this._value(range.from),
	                    to: this._value(range.to)
	                });
	            }

	            if (this._mwTimeout) {
	                clearTimeout(this._mwTimeout);
	            }

	            this._mwTimeout = setTimeout(function () {
	                this$1._end();
	            }, MOUSEWHEEL_DELAY);
	        }
	    },

	    _gesturestart: function(e) {
	        var options = this.options;

	        this._state = {
	            range: {
	                from: this._index(options.from),
	                to: this._index(options.to)
	            }
	        };
	        var args = this._rangeEventArgs(this._state.range);

	        if (this.trigger(SELECT_START, args)) {
	            this._state = null;
	        } else {
	            e.preventDefault();
	        }
	    },

	    _gestureend: function() {
	        if (this._state) {
	            this.trigger(SELECT_END, this._rangeEventArgs(this._state.range));
	            delete this._state;
	        }
	    },

	    _gesturechange: function(e) {
	        var ref = this;
	        var chart = ref.chart;
	        var state = ref._state;
	        var options = ref.options;
	        var categoryAxis = ref.categoryAxis;
	        var range = state.range;
	        var p0 = chart._toModelCoordinates(e.touches[0].x.location).x;
	        var p1 = chart._toModelCoordinates(e.touches[1].x.location).x;
	        var left = Math.min(p0, p1);
	        var right = Math.max(p0, p1);

	        e.preventDefault();

	        range.from = categoryAxis.pointCategoryIndex(new Point(left)) || options.min;

	        range.to = categoryAxis.pointCategoryIndex(new Point(right)) || options.max;

	        this.move(range.from, range.to);

	        this.trigger(SELECT, this._rangeEventArgs(range));
	    },

	    _index: function(value) {
	        var index = value;

	        if (value instanceof Date) {
	            index = this.categoryAxis.categoryIndex(value);
	        }

	        return index;
	    },

	    _value: function(index) {
	        var value = index;
	        if (this._dateAxis) {
	            value = this.categoryAxis.categoryAt(index);
	            if (value > this.options.max) {
	                value = this.options.max;
	            }
	        }

	        return value;
	    },

	    _slot: function(value) {
	        var categoryAxis = this.categoryAxis;
	        var index = this._index(value);

	        return categoryAxis.getSlot(index, index, true);
	    },

	    move: function(from, to) {
	        var options = this.options;
	        var reverse = this.categoryAxis.options.reverse;
	        var offset = options.offset;
	        var padding = options.padding;
	        var border = options.selection.border;
	        var left = reverse ? to : from;
	        var right = reverse ? from : to;
	        var edge = 'x' + (reverse ? 2 : 1);

	        var box = this._slot(left);
	        var leftMaskWidth = round(box[edge] - offset.left + padding.left);

	        elementStyles(this.leftMask, {
	            width: leftMaskWidth
	        });
	        elementStyles(this.selection, {
	            left: leftMaskWidth
	        });

	        box = this._slot(right);

	        var rightMaskWidth = round(options.width - (box[edge] - offset.left + padding.left));
	        elementStyles(this.rightMask, {
	            width: rightMaskWidth
	        });

	        var distance = options.width - rightMaskWidth;
	        if (distance !== options.width) {
	            distance += border.right;
	        }

	        elementStyles(this.rightMask, {
	            left: distance
	        });
	        elementStyles(this.selection, {
	            width: Math.max(options.width - (leftMaskWidth + rightMaskWidth) - border.right, 0)
	        });
	    },

	    set: function(from, to) {
	        var options = this.options;
	        var min = this._index(options.min);
	        var max = this._index(options.max);
	        var fromValue = limitValue(this._index(from), min, max);
	        var toValue = limitValue(this._index(to), fromValue + 1, max);

	        if (options.visible) {
	            this.move(fromValue, toValue);
	        }

	        options.from = this._value(fromValue);
	        options.to = this._value(toValue);
	    },

	    expand: function(delta) {
	        var options = this.options;
	        var min = this._index(options.min);
	        var max = this._index(options.max);
	        var zDir = options.mousewheel.zoom;
	        var from = this._index(options.from);
	        var to = this._index(options.to);
	        var range = { from: from, to: to };
	        var oldRange = deepExtend({}, range);

	        if (this._state) {
	            range = this._state.range;
	        }

	        if (zDir !== RIGHT) {
	            range.from = limitValue(
	                limitValue(from - delta, 0, to - 1),
	                min, max
	            );
	        }

	        if (zDir !== LEFT) {
	            range.to = limitValue(
	                limitValue(to + delta, range.from + 1, max),
	                min,
	                max
	             );
	        }

	        if (range.from !== oldRange.from || range.to !== oldRange.to) {
	            this.set(range.from, range.to);
	            return true;
	        }
	    },

	    trigger: function(name, args) {
	        return (this.observer || this.chart).trigger(name, args);
	    }
	});

	setDefaultOptions(Selection, {
	    visible: true,
	    mousewheel: {
	        zoom: "both"
	    },
	    min: MIN_VALUE,
	    max: MAX_VALUE
	});

	var Tooltip = BaseTooltip.extend({
	    show: function(point) {
	        if (!point || !point.tooltipAnchor || (this._current && this._current === point)) {
	            return;
	        }

	        var options = deepExtend({}, this.options, point.options.tooltip);
	        var anchor = point.tooltipAnchor();

	        if (anchor) {
	            this._current = point;
	            BaseTooltip.fn.show.call(this, {
	                point: point,
	                anchor: anchor
	            }, options, point);
	        } else {
	            this.hide();
	        }
	    },

	    hide: function() {
	        delete this._current;
	        BaseTooltip.fn.hide.call(this);
	    }
	});

	var SharedTooltip = BaseTooltip.extend({
	    init: function(plotArea, options) {
	        BaseTooltip.fn.init.call(this, plotArea.chartService, options);

	        this.plotArea = plotArea;
	        this.formatService = plotArea.chartService.format;
	    },

	    showAt: function(points, coords) {
	        var tooltipPoints = grep(points, function(point) {
	            var tooltip = point.series.tooltip;
	            var excluded = tooltip && tooltip.visible === false;

	            return !excluded;
	        });

	        if (tooltipPoints.length > 0) {
	            var point = tooltipPoints[0];
	            var slot = this.plotArea.categoryAxis.getSlot(point.categoryIx);

	            var anchor = coords ? this._slotAnchor(coords, slot) : this._defaultAnchor(point, slot);

	            this.show({
	                anchor: anchor,
	                shared: true,
	                points: points,
	                category: point.category,
	                categoryText: this.formatService.auto(this.options.categoryFormat, point.category),
	                series: this.plotArea.series
	            }, this.options);
	        }
	    },

	    _slotAnchor: function(point, slot) {
	        var axis = this.plotArea.categoryAxis;
	        var align = {
	            horizontal: "left",
	            vertical: "center"
	        };

	        if (!axis.options.vertical) {
	            point.x = slot.center().x;
	        }

	        return {
	            point: point,
	            align: align
	        };
	    },

	    _defaultAnchor: function(point, slot) {
	        var box = point.owner.pane.chartsBox();
	        var vertical = this.plotArea.categoryAxis.options.vertical;
	        var center = box.center();
	        var slotCenter = slot.center();
	        var align = {
	            horizontal: "center",
	            vertical: "center"
	        };

	        var centerPoint;
	        if (vertical) {
	            centerPoint = new Point(center.x, slotCenter.y);
	        } else {
	            centerPoint = new Point(slotCenter.x, center.y);
	        }

	        return {
	            point: centerPoint,
	            align: align
	        };
	    }
	});

	setDefaultOptions(SharedTooltip, {
	    categoryFormat: '{0:d}'
	});

	var BarChartAnimation = Animation.extend({
	    setup: function() {
	        var ref = this;
	        var element = ref.element;
	        var options = ref.options;
	        var bbox = element.bbox();

	        if (bbox) {
	            this.origin = options.origin;
	            var axis = options.vertical ? Y : X;

	            var fromScale = this.fromScale = new GeometryPoint(1, 1);
	            fromScale[axis] = START_SCALE;

	            element.transform(transform()
	                .scale(fromScale.x, fromScale.y)
	            );
	        } else {
	            this.abort();
	        }
	    },

	    step: function(pos) {
	        var scaleX = dataviz.interpolateValue(this.fromScale.x, 1, pos);
	        var scaleY = dataviz.interpolateValue(this.fromScale.y, 1, pos);

	        this.element.transform(transform()
	            .scale(scaleX, scaleY, this.origin)
	        );
	    },

	    abort: function() {
	        Animation.fn.abort.call(this);
	        this.element.transform(null);
	    }
	});

	setDefaultOptions(BarChartAnimation, {
	    duration: INITIAL_ANIMATION_DURATION
	});

	AnimationFactory.current.register(BAR, BarChartAnimation);

	var BubbleAnimation = Animation.extend({
	    setup: function() {
	        var center = this.center = this.element.bbox().center();
	        this.element.transform(transform()
	            .scale(START_SCALE, START_SCALE, center)
	        );
	    },

	    step: function(pos) {
	        this.element.transform(transform()
	            .scale(pos, pos, this.center)
	        );
	    }
	});

	setDefaultOptions(BubbleAnimation, {
	    easing: "easeOutElastic"
	});

	AnimationFactory.current.register(BUBBLE, BubbleAnimation);

	var FadeInAnimation = Animation.extend({
	    setup: function() {
	        this.fadeTo = this.element.opacity();
	        this.element.opacity(0);
	    },

	    step: function(pos) {
	        this.element.opacity(pos * this.fadeTo);
	    }
	});

	setDefaultOptions(FadeInAnimation, {
	    duration: 200,
	    easing: "linear"
	});

	AnimationFactory.current.register(FADEIN, FadeInAnimation);

	var PieAnimation = Animation.extend({
	    setup: function() {
	        this.element.transform(transform()
	            .scale(START_SCALE, START_SCALE, this.options.center)
	        );
	    },

	    step: function(pos) {
	        this.element.transform(transform()
	            .scale(pos, pos, this.options.center)
	        );
	    }
	});

	setDefaultOptions(PieAnimation, {
	    easing: "easeOutElastic",
	    duration: INITIAL_ANIMATION_DURATION
	});

	AnimationFactory.current.register(PIE, PieAnimation);

	var ScatterLineChart = ScatterChart.extend({
	    render: function() {
	        ScatterChart.fn.render.call(this);

	        this.renderSegments();
	    },

	    createSegment: function(linePoints, currentSeries, seriesIx) {
	        var style = currentSeries.style;
	        var pointType;

	        if (style === SMOOTH) {
	            pointType = SplineSegment;
	        } else {
	            pointType = LineSegment;
	        }

	        return new pointType(linePoints, currentSeries, seriesIx);
	    },

	    animationPoints: function() {
	        var points = ScatterChart.fn.animationPoints.call(this);
	        return points.concat(this._segments);
	    },

	    createMissingValue: function(value, missingValues) {
	        if (missingValues === ZERO) {
	            var missingValue = {
	                x: value.x,
	                y: value.y
	            };
	            if (!hasValue(missingValue.x)) {
	                missingValue.x = 0;
	            }
	            if (!hasValue(missingValue.y)) {
	                missingValue.y = 0;
	            }
	            return missingValue;
	        }
	    }
	});

	deepExtend(ScatterLineChart.prototype, LineChartMixin);

	var XYPlotArea = PlotAreaBase.extend({
	    initFields: function() {
	        this.namedXAxes = {};
	        this.namedYAxes = {};

	        this.xAxisRangeTracker = new AxisGroupRangeTracker();
	        this.yAxisRangeTracker = new AxisGroupRangeTracker();
	    },

	    render: function(panes) {
	        var this$1 = this;
	        if (panes === void 0) { panes = this.panes; }

	        var seriesByPane = this.groupSeriesByPane();

	        for (var i = 0; i < panes.length; i++) {
	            var pane = panes[i];
	            var paneSeries = seriesByPane[pane.options.name || "default"] || [];
	            this$1.addToLegend(paneSeries);
	            var filteredSeries = this$1.filterVisibleSeries(paneSeries);

	            if (!filteredSeries) {
	                continue;
	            }

	            this$1.createScatterChart(
	                filterSeriesByType(filteredSeries, SCATTER),
	                pane
	            );

	            this$1.createScatterLineChart(
	                filterSeriesByType(filteredSeries, SCATTER_LINE),
	                pane
	            );

	            this$1.createBubbleChart(
	                filterSeriesByType(filteredSeries, BUBBLE),
	                pane
	            );
	        }

	        this.createAxes(panes);
	    },

	    appendChart: function(chart, pane) {
	        this.xAxisRangeTracker.update(chart.xAxisRanges);
	        this.yAxisRangeTracker.update(chart.yAxisRanges);

	        PlotAreaBase.fn.appendChart.call(this, chart, pane);
	    },

	    removeAxis: function(axis) {
	        var axisName = axis.options.name;

	        PlotAreaBase.fn.removeAxis.call(this, axis);

	        if (axis.options.vertical) {
	            this.yAxisRangeTracker.reset(axisName);
	            delete this.namedYAxes[axisName];
	        } else {
	            this.xAxisRangeTracker.reset(axisName);
	            delete this.namedXAxes[axisName];
	        }

	        if (axis === this.axisX) {
	            delete this.axisX;
	        }

	        if (axis === this.axisY) {
	            delete this.axisY;
	        }
	    },

	    seriesPaneName: function(series) {
	        var options = this.options;
	        var xAxisName = series.xAxis;
	        var xAxisOptions = [].concat(options.xAxis);
	        var xAxis = grep(xAxisOptions, function(a) { return a.name === xAxisName; })[0];
	        var yAxisName = series.yAxis;
	        var yAxisOptions = [].concat(options.yAxis);
	        var yAxis = grep(yAxisOptions, function(a) { return a.name === yAxisName; })[0];
	        var panes = options.panes || [ {} ];
	        var defaultPaneName = panes[0].name || "default";
	        var paneName = (xAxis || {}).pane || (yAxis || {}).pane || defaultPaneName;

	        return paneName;
	    },

	    createScatterChart: function(series, pane) {
	        if (series.length > 0) {
	            this.appendChart(
	                new ScatterChart(this, { series: series, clip: pane.options.clip }),
	                pane
	            );
	        }
	    },

	    createScatterLineChart: function(series, pane) {
	        if (series.length > 0) {
	            this.appendChart(
	                new ScatterLineChart(this, { series: series, clip: pane.options.clip }),
	                pane
	            );
	        }
	    },

	    createBubbleChart: function(series, pane) {
	        if (series.length > 0) {
	            this.appendChart(
	                new BubbleChart(this, { series: series, clip: pane.options.clip }),
	                pane
	            );
	        }
	    },

	    createXYAxis: function(options, vertical, axisIndex) {
	        var axisName = options.name;
	        var namedAxes = vertical ? this.namedYAxes : this.namedXAxes;
	        var tracker = vertical ? this.yAxisRangeTracker : this.xAxisRangeTracker;
	        var axisOptions = deepExtend({ reverse: !vertical && this.chartService.rtl }, options, { vertical: vertical });
	        var isLog = equalsIgnoreCase(axisOptions.type, LOGARITHMIC);
	        var defaultRange = tracker.query();
	        var defaultAxisRange = isLog ? { min: 0.1, max: 1 } : { min: 0, max: 1 };
	        var range = tracker.query(axisName) || defaultRange || defaultAxisRange;
	        var typeSamples = [ axisOptions.min, axisOptions.max ];
	        var series = this.series;

	        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
	            var currentSeries = series[seriesIx];
	            var seriesAxisName = currentSeries[vertical ? "yAxis" : "xAxis"];
	            if ((seriesAxisName === axisOptions.name) || (axisIndex === 0 && !seriesAxisName)) {
	                var firstPointValue = SeriesBinder.current.bindPoint(currentSeries, 0).valueFields;
	                typeSamples.push(firstPointValue[vertical ? "y" : "x"]);

	                break;
	            }
	        }

	        if (axisIndex === 0 && defaultRange) {
	            range.min = Math.min(range.min, defaultRange.min);
	            range.max = Math.max(range.max, defaultRange.max);
	        }

	        var inferredDate;

	        for (var i = 0; i < typeSamples.length; i++) {
	            if (typeSamples[i] instanceof Date) {
	                inferredDate = true;
	                break;
	            }
	        }

	        var axisType;
	        if (equalsIgnoreCase(axisOptions.type, DATE) || (!axisOptions.type && inferredDate)) {
	            axisType = dataviz.DateValueAxis;
	        } else if (isLog) {
	            axisType = dataviz.LogarithmicAxis;
	        } else {
	            axisType = dataviz.NumericAxis;
	        }

	        var axis = new axisType(range.min, range.max, axisOptions, this.chartService);
	        axis.axisIndex = axisIndex;

	        if (axisName) {
	            if (namedAxes[axisName]) {
	                throw new Error(((vertical ? "Y" : "X") + " axis with name " + axisName + " is already defined"));
	            }
	            namedAxes[axisName] = axis;
	        }

	        this.appendAxis(axis);

	        return axis;
	    },

	    createAxes: function(panes) {
	        var this$1 = this;

	        var options = this.options;
	        var xAxesOptions = [].concat(options.xAxis);
	        var xAxes = [];
	        var yAxesOptions = [].concat(options.yAxis);
	        var yAxes = [];

	        for (var idx = 0; idx < xAxesOptions.length; idx++) {
	            var axisPane = this$1.findPane(xAxesOptions[idx].pane);
	            if (inArray(axisPane, panes)) {
	                xAxes.push(this$1.createXYAxis(xAxesOptions[idx], false, idx));
	            }
	        }

	        for (var idx$1 = 0; idx$1 < yAxesOptions.length; idx$1++) {
	            var axisPane$1 = this$1.findPane(yAxesOptions[idx$1].pane);
	            if (inArray(axisPane$1, panes)) {
	                yAxes.push(this$1.createXYAxis(yAxesOptions[idx$1], true, idx$1));
	            }
	        }

	        this.axisX = this.axisX || xAxes[0];
	        this.axisY = this.axisY || yAxes[0];
	    },

	    _dispatchEvent: function(chart, e, eventType) {
	        var coords = chart._eventCoordinates(e);
	        var point = new Point(coords.x, coords.y);
	        var allAxes = this.axes;
	        var length = allAxes.length;
	        var xValues = [];
	        var yValues = [];

	        for (var i = 0; i < length; i++) {
	            var axis = allAxes[i];
	            var values = axis.options.vertical ? yValues : xValues;
	            var currentValue = axis.getValue(point);
	            if (currentValue !== null) {
	                values.push(currentValue);
	            }
	        }

	        if (xValues.length > 0 && yValues.length > 0) {
	            chart.trigger(eventType, {
	                element: eventElement(e),
	                originalEvent: e,
	                x: singleItemOrArray(xValues),
	                y: singleItemOrArray(yValues)
	            });
	        }
	    },

	    updateAxisOptions: function(axis, options) {
	        var vertical = axis.options.vertical;
	        var axes = this.groupAxes(this.panes);
	        var index = (vertical ? axes.y : axes.x).indexOf(axis);

	        updateAxisOptions$1(this.options, index, vertical, options);
	        updateAxisOptions$1(this.originalOptions, index, vertical, options);
	    }
	});

	function updateAxisOptions$1(targetOptions, axisIndex, vertical, options) {
	    var axisOptions = ([].concat(vertical ? targetOptions.yAxis : targetOptions.xAxis))[axisIndex];
	    deepExtend(axisOptions, options);
	}

	setDefaultOptions(XYPlotArea, {
	    xAxis: {},
	    yAxis: {}
	});

	deepExtend(XYPlotArea.prototype, PlotAreaEventsMixin);

	var PieSegment = ChartElement.extend({
	    init: function(value, sector, options) {
	        ChartElement.fn.init.call(this, options);

	        this.value = value;
	        this.sector = sector;
	    },

	    render: function() {
	        var labels = this.options.labels;
	        var chartService = this.owner.chartService;
	        var labelText = this.value;

	        if (this._rendered || this.visible === false) {
	            return;
	        }
	        this._rendered = true;

	        var labelTemplate = getTemplate(labels);
	        var pointData = this.pointData();

	        if (labelTemplate) {
	            labelText = labelTemplate(pointData);
	        } else if (labels.format) {
	            labelText = chartService.format.auto(labels.format, labelText);
	        }

	        if (labels.visible && (labelText || labelText === 0)) {
	            if (labels.position === CENTER || labels.position === INSIDE_END) {
	                if (!labels.color) {
	                    var brightnessValue = new Color(this.options.color).percBrightness();
	                    if (brightnessValue > 180) {
	                        labels.color = BLACK;
	                    } else {
	                        labels.color = WHITE;
	                    }
	                }
	                if (!labels.background) {
	                    labels.background = this.options.color;
	                }
	            } else {
	                var themeLabels = chartService.theme.seriesDefaults.labels;
	                labels.color = labels.color || themeLabels.color;
	                labels.background = labels.background || themeLabels.background;
	            }

	            this.label = new TextBox(labelText, deepExtend({}, labels, {
	                align: CENTER,
	                vAlign: "",
	                animation: {
	                    type: FADEIN,
	                    delay: this.animationDelay
	                }
	            }), pointData);

	            this.append(this.label);
	        }
	    },

	    reflow: function(targetBox) {
	        this.render();
	        this.box = targetBox;
	        this.reflowLabel();
	    },

	    reflowLabel: function() {
	        var ref = this;
	        var labelsOptions = ref.options.labels;
	        var label = ref.label;
	        var sector = this.sector.clone();
	        var labelsDistance = labelsOptions.distance;
	        var angle = sector.middle();

	        if (label) {
	            var labelHeight = label.box.height();
	            var labelWidth = label.box.width();
	            var lp;

	            if (labelsOptions.position === CENTER) {
	                sector.radius = Math.abs((sector.radius - labelHeight) / 2) + labelHeight;
	                lp = sector.point(angle);
	                label.reflow(new Box(lp.x, lp.y - labelHeight / 2, lp.x, lp.y));
	            } else if (labelsOptions.position === INSIDE_END) {
	                sector.radius = sector.radius - labelHeight / 2;
	                lp = sector.point(angle);
	                label.reflow(new Box(lp.x, lp.y - labelHeight / 2, lp.x, lp.y));
	            } else {
	                var x1;
	                lp = sector.clone().expand(labelsDistance).point(angle);
	                if (lp.x >= sector.center.x) {
	                    x1 = lp.x + labelWidth;
	                    label.orientation = RIGHT;
	                } else {
	                    x1 = lp.x - labelWidth;
	                    label.orientation = LEFT;
	                }
	                label.reflow(new Box(x1, lp.y - labelHeight, lp.x, lp.y));
	            }
	        }
	    },

	    createVisual: function() {
	        var this$1 = this;

	        var ref = this;
	        var sector = ref.sector;
	        var options = ref.options;

	        ChartElement.fn.createVisual.call(this);

	        if (this.value) {
	            if (options.visual) {
	                var startAngle = (sector.startAngle + 180) % 360;
	                var visual = options.visual({
	                    category: this.category,
	                    dataItem: this.dataItem,
	                    value: this.value,
	                    series: this.series,
	                    percentage: this.percentage,
	                    center: new GeometryPoint(sector.center.x, sector.center.y),
	                    radius: sector.radius,
	                    innerRadius: sector.innerRadius,
	                    startAngle: startAngle,
	                    endAngle: startAngle + sector.angle,
	                    options: options,
	                    sender: this.getSender(),
	                    createVisual: function () {
	                        var group = new Group();
	                        this$1.createSegmentVisual(group);

	                        return group;
	                    }
	                });

	                if (visual) {
	                    this.visual.append(visual);
	                }
	            } else {
	                this.createSegmentVisual(this.visual);
	            }
	        }
	    },

	    createSegmentVisual: function(group) {
	        var ref = this;
	        var sector = ref.sector;
	        var options = ref.options;
	        var borderOptions = options.border || {};
	        var border = borderOptions.width > 0 ? {
	            stroke: {
	                color: borderOptions.color,
	                width: borderOptions.width,
	                opacity: borderOptions.opacity,
	                dashType: borderOptions.dashType
	            }
	        } : {};
	        var color = options.color;
	        var fill = {
	            color: color,
	            opacity: options.opacity
	        };
	        var visual = this.createSegment(sector, deepExtend({
	            fill: fill,
	            stroke: {
	                opacity: options.opacity
	            },
	            zIndex: options.zIndex
	        }, border));

	        group.append(visual);

	        if (hasGradientOverlay(options)) {
	            group.append(this.createGradientOverlay(visual, {
	                baseColor: color,
	                fallbackFill: fill
	            }, deepExtend({
	                center: [ sector.center.x, sector.center.y ],
	                innerRadius: sector.innerRadius,
	                radius: sector.radius,
	                userSpace: true
	            }, options.overlay)));
	        }
	    },

	    createSegment: function(sector, options) {
	        if (options.singleSegment) {
	            return new drawing.Circle(new geometry.Circle(new GeometryPoint(sector.center.x, sector.center.y), sector.radius), options);
	        }

	        return dataviz.ShapeBuilder.current.createRing(sector, options);
	    },

	    createAnimation: function() {
	        var ref = this;
	        var options = ref.options;
	        var center = ref.sector.center;

	        deepExtend(options, {
	            animation: {
	                center: [ center.x, center.y ],
	                delay: this.animationDelay
	            }
	        });

	        ChartElement.fn.createAnimation.call(this);
	    },

	    createHighlight: function(options) {
	        var highlight = this.options.highlight || {};
	        var border = highlight.border || {};

	        return this.createSegment(this.sector, deepExtend({}, options, {
	            fill: {
	                color: highlight.color,
	                opacity: highlight.opacity
	            },
	            stroke: {
	                opacity: border.opacity,
	                width: border.width,
	                color: border.color
	            }
	        }));
	    },

	    highlightVisual: function() {
	        return this.visual.children[0];
	    },

	    highlightVisualArgs: function() {
	        var sector = this.sector;

	        return {
	            options: this.options,
	            radius: sector.radius,
	            innerRadius: sector.innerRadius,
	            center: new GeometryPoint(sector.center.x, sector.center.y),
	            startAngle: sector.startAngle,
	            endAngle: sector.angle + sector.startAngle,
	            visual: this.visual
	        };
	    },

	    tooltipAnchor: function() {
	        var sector = this.sector.clone().expand(TOOLTIP_OFFSET);
	        var midAndle = sector.middle();
	        var midPoint = sector.point(midAndle);

	        return {
	            point: midPoint,
	            align: tooltipAlignment(midAndle + 180)
	        };
	    },

	    formatValue: function(format) {
	        return this.owner.formatPointValue(this, format);
	    },

	    pointData: function() {
	        return {
	            dataItem: this.dataItem,
	            category: this.category,
	            value: this.value,
	            series: this.series,
	            percentage: this.percentage
	        };
	    }
	});

	var RAD_30 = round(dataviz.rad(30), DEFAULT_PRECISION);
	var RAD_60 = round(dataviz.rad(60), DEFAULT_PRECISION);

	function tooltipAlignment(angle) {
	    var radians = dataviz.rad(angle);
	    var sine = round(Math.sin(radians), DEFAULT_PRECISION);
	    var cosine = round(Math.cos(radians), DEFAULT_PRECISION);

	    var horizontal;
	    if (Math.abs(sine) > RAD_60) {
	        horizontal = CENTER;
	    } else if (cosine < 0) {
	        horizontal = RIGHT;
	    } else {
	        horizontal = LEFT;
	    }

	    var vertical;
	    if (Math.abs(sine) < RAD_30) {
	        vertical = CENTER;
	    } else if (sine < 0) {
	        vertical = BOTTOM;
	    } else {
	        vertical = TOP;
	    }

	    return {
	        horizontal: horizontal,
	        vertical: vertical
	    };
	}

	setDefaultOptions(PieSegment, {
	    color: WHITE,
	    overlay: {
	        gradient: "roundedBevel"
	    },
	    border: {
	        width: 0.5
	    },
	    labels: {
	        visible: false,
	        distance: 35,
	        font: datavizConstants.DEFAULT_FONT,
	        margin: getSpacing(0.5),
	        align: CIRCLE,
	        zIndex: 1,
	        position: OUTSIDE_END
	    },
	    animation: {
	        type: PIE
	    },
	    highlight: {
	        visible: true,
	        border: {
	            width: 1
	        }
	    },
	    visible: true
	});

	deepExtend(PieSegment.prototype, PointEventsMixin);

	var PieChartMixin = {
	    createLegendItem: function(value, point, options) {
	        var legendOptions = this.options.legend || {};
	        var labelsOptions = legendOptions.labels || {};
	        var inactiveItems = legendOptions.inactiveItems || {};
	        var inactiveItemsLabels = inactiveItems.labels || {};

	        if (options && options.visibleInLegend !== false) {
	            var pointVisible = options.visible !== false;
	            var labelTemplate = pointVisible ? getTemplate(labelsOptions) :
	                getTemplate(inactiveItemsLabels) || getTemplate(labelsOptions);
	            var text = options.category;

	            if (labelTemplate) {
	                text = labelTemplate({
	                    text: text,
	                    series: options.series,
	                    dataItem: options.dataItem,
	                    percentage: options.percentage,
	                    value: value
	                });
	            }

	            var itemLabelOptions, markerColor;
	            if (pointVisible) {
	                itemLabelOptions = {};
	                markerColor = point.color;
	            } else {
	                itemLabelOptions = {
	                    color: inactiveItemsLabels.color,
	                    font: inactiveItemsLabels.font
	                };
	                markerColor = (inactiveItems.markers || {}).color;
	            }

	            if (hasValue(text) && text !== "") {
	                this.legendItems.push({
	                    active: pointVisible,
	                    pointIndex: options.index,
	                    text: text,
	                    series: options.series,
	                    markerColor: markerColor,
	                    labels: itemLabelOptions
	                });
	            }
	        }
	    }
	};

	var PIE_SECTOR_ANIM_DELAY = 70;

	var PieChart = ChartElement.extend({
	    init: function(plotArea, options) {
	        ChartElement.fn.init.call(this, options);

	        this.plotArea = plotArea;
	        this.chartService = plotArea.chartService;
	        this.points = [];
	        this.legendItems = [];
	        this.render();
	    },

	    render: function() {
	        this.traverseDataPoints(this.addValue.bind(this));
	    },

	    traverseDataPoints: function(callback) {
	        var this$1 = this;

	        var ref = this;
	        var options = ref.options;
	        var seriesColors = ref.plotArea.options.seriesColors; if (seriesColors === void 0) { seriesColors = []; }
	        var colorsCount = seriesColors.length;
	        var series = options.series;
	        var seriesCount = series.length;

	        for (var seriesIx = 0; seriesIx < seriesCount; seriesIx++) {
	            var currentSeries = series[seriesIx];
	            var data = currentSeries.data;
	            var ref$1 = bindSegments(currentSeries);
	            var total = ref$1.total;
	            var points = ref$1.points;
	            var count = ref$1.count;
	            var anglePerValue = 360 / total;
	            var constantAngle = (void 0);
	            if (!isFinite(anglePerValue)) {
	                constantAngle = 360 / count;
	            }
	            var currentAngle = (void 0);

	            if (defined(currentSeries.startAngle)) {
	                currentAngle = currentSeries.startAngle;
	            } else {
	                currentAngle = options.startAngle;
	            }

	            if (seriesIx !== seriesCount - 1) {
	                if (currentSeries.labels.position === OUTSIDE_END) {
	                    currentSeries.labels.position = CENTER;
	                }
	            }

	            for (var i = 0; i < points.length; i++) {
	                var pointData = points[i];
	                if (!pointData) {
	                    continue;
	                }

	                var fields = pointData.fields;
	                var value = pointData.value;
	                var visible = pointData.visible;
	                var angle = value !== 0 ? (constantAngle || (value * anglePerValue)) : 0;
	                var explode = data.length !== 1 && Boolean(fields.explode);

	                if (!isFunction(currentSeries.color)) {
	                    currentSeries.color = fields.color || seriesColors[i % colorsCount];
	                }

	                callback(pointData.valueFields.value, new dataviz.Ring(null, 0, 0, currentAngle, angle), {
	                    owner: this$1,
	                    category: defined(fields.category) ? fields.category : "",
	                    index: i,
	                    series: currentSeries,
	                    seriesIx: seriesIx,
	                    dataItem: data[i],
	                    percentage: total !== 0 ? value / total : 0,
	                    explode: explode,
	                    visibleInLegend: fields.visibleInLegend,
	                    visible: visible,
	                    zIndex: seriesCount - seriesIx,
	                    animationDelay: this$1.animationDelay(i, seriesIx, seriesCount)
	                });

	                if (visible !== false) {
	                    currentAngle += angle;
	                }
	            }
	        }
	    },

	    evalSegmentOptions: function(options, value, fields) {
	        var series = fields.series;

	        evalOptions(options, {
	            value: value,
	            series: series,
	            dataItem: fields.dataItem,
	            category: fields.category,
	            percentage: fields.percentage
	        }, { defaults: series._defaults, excluded: [ "data", "content", "template", "visual", "toggle" ] });
	    },

	    addValue: function(value, sector, fields) {
	        var segmentOptions = deepExtend({}, fields.series, { index: fields.index });
	        this.evalSegmentOptions(segmentOptions, value, fields);

	        this.createLegendItem(value, segmentOptions, fields);

	        if (fields.visible === false) {
	            return;
	        }

	        var segment = new PieSegment(value, sector, segmentOptions);
	        $.extend(segment, fields);
	        this.append(segment);
	        this.points.push(segment);
	    },

	    reflow: function(targetBox) {
	        var ref = this;
	        var options = ref.options;
	        var points = ref.points;
	        var seriesConfigs = ref.seriesConfigs; if (seriesConfigs === void 0) { seriesConfigs = []; }
	        var count = points.length;
	        var box = targetBox.clone();
	        var space = 5;
	        var minWidth = Math.min(box.width(), box.height());
	        var halfMinWidth = minWidth / 2;
	        var defaultPadding = minWidth - minWidth * 0.85;
	        var newBox = new Box(box.x1, box.y1, box.x1 + minWidth, box.y1 + minWidth);
	        var newBoxCenter = newBox.center();
	        var boxCenter = box.center();
	        var seriesCount = options.series.length;
	        var leftSideLabels = [];
	        var rightSideLabels = [];
	        var padding = valueOrDefault(options.padding, defaultPadding);

	        this.targetBox = targetBox;

	        padding = padding > halfMinWidth - space ? halfMinWidth - space : padding;
	        newBox.translate(boxCenter.x - newBoxCenter.x, boxCenter.y - newBoxCenter.y);

	        var radius = halfMinWidth - padding;
	        var center = new Point(
	            radius + newBox.x1 + padding,
	            radius + newBox.y1 + padding
	        );

	        for (var i = 0; i < count; i++) {
	            var segment = points[i];
	            var sector = segment.sector;
	            var seriesIndex = segment.seriesIx;
	            sector.radius = radius;
	            sector.center = center;

	            if (seriesConfigs.length) {
	                var seriesConfig = seriesConfigs[seriesIndex];
	                sector.innerRadius = seriesConfig.innerRadius;
	                sector.radius = seriesConfig.radius;
	            }

	            if (seriesIndex === seriesCount - 1 && segment.explode) {
	                sector.center = sector.clone().setRadius(sector.radius * 0.15).point(sector.middle());
	            }

	            segment.reflow(newBox);

	            var label = segment.label;
	            if (label) {
	                if (label.options.position === OUTSIDE_END) {
	                    if (seriesIndex === seriesCount - 1) {
	                        if (label.orientation === RIGHT) {
	                            rightSideLabels.push(label);
	                        } else {
	                            leftSideLabels.push(label);
	                        }
	                    }
	                }
	            }
	        }

	        if (leftSideLabels.length > 0) {
	            leftSideLabels.sort(this.labelComparator(true));
	            this.leftLabelsReflow(leftSideLabels);
	        }

	        if (rightSideLabels.length > 0) {
	            rightSideLabels.sort(this.labelComparator(false));
	            this.rightLabelsReflow(rightSideLabels);
	        }

	        this.box = newBox;
	    },

	    leftLabelsReflow: function(labels) {
	        var distances = this.distanceBetweenLabels(labels);

	        this.distributeLabels(distances, labels);
	    },

	    rightLabelsReflow: function(labels) {
	        var distances = this.distanceBetweenLabels(labels);

	        this.distributeLabels(distances, labels);
	    },

	    distanceBetweenLabels: function(labels) {
	        var segment = last(this.points);
	        var sector = segment.sector;
	        var count = labels.length - 1;
	        var lr = sector.radius + segment.options.labels.distance;
	        var distances = [];
	        var firstBox = labels[0].box;
	        var distance = round(firstBox.y1 - (sector.center.y - lr - firstBox.height() - firstBox.height() / 2));

	        distances.push(distance);

	        for (var i = 0; i < count; i++) {
	            var secondBox = labels[i + 1].box;

	            firstBox = labels[i].box;
	            distance = round(secondBox.y1 - firstBox.y2);
	            distances.push(distance);
	        }
	        distance = round(sector.center.y + lr - labels[count].box.y2 - labels[count].box.height() / 2);
	        distances.push(distance);

	        return distances;
	    },

	    distributeLabels: function(distances, labels) {
	        var this$1 = this;

	        var count = distances.length;
	        var left, right, remaining;

	        for (var i = 0; i < count; i++) {
	            remaining = -distances[i];
	            left = right = i;

	            while (remaining > 0 && (left >= 0 || right < count)) {
	                remaining = this$1._takeDistance(distances, i, --left, remaining);
	                remaining = this$1._takeDistance(distances, i, ++right, remaining);
	            }
	        }

	        this.reflowLabels(distances, labels);
	    },

	    _takeDistance: function(distances, anchor, position, amount) {
	        var result = amount;
	        if (distances[position] > 0) {
	            var available = Math.min(distances[position], result);
	            result -= available;
	            distances[position] -= available;
	            distances[anchor] += available;
	        }

	        return result;
	    },

	    reflowLabels: function(distances, labels) {
	        var this$1 = this;

	        var segment = last(this.points);
	        var sector = segment.sector;
	        var labelOptions = segment.options.labels;
	        var labelsCount = labels.length;
	        var labelDistance = labelOptions.distance;
	        var boxY = sector.center.y - (sector.radius + labelDistance) - labels[0].box.height();
	        var boxX;

	        distances[0] += 2;
	        for (var i = 0; i < labelsCount; i++) {
	            var label = labels[i];
	            var box = label.box;

	            boxY += distances[i];
	            boxX = this$1.hAlignLabel(
	                box.x2,
	                sector.clone().expand(labelDistance),
	                boxY,
	                boxY + box.height(),
	                label.orientation === RIGHT);

	            if (label.orientation === RIGHT) {
	                if (labelOptions.align !== CIRCLE) {
	                    boxX = sector.radius + sector.center.x + labelDistance;
	                }
	                label.reflow(new Box(boxX + box.width(), boxY, boxX, boxY));
	            } else {
	                if (labelOptions.align !== CIRCLE) {
	                    boxX = sector.center.x - sector.radius - labelDistance;
	                }
	                label.reflow(new Box(boxX - box.width(), boxY, boxX, boxY));
	            }

	            boxY += box.height();
	        }
	    },

	    createVisual: function() {
	        var this$1 = this;

	        var ref = this;
	        var connectors = ref.options.connectors;
	        var points = ref.points;
	        var count = points.length;
	        var space = 4;

	        ChartElement.fn.createVisual.call(this);

	        this._connectorLines = [];

	        for (var i = 0; i < count; i++) {
	            var segment = points[i];
	            var sector = segment.sector;
	            var label = segment.label;
	            var angle = sector.middle();
	            var connectorsColor = (segment.options.connectors || {}).color || connectors.color;

	            if (label) {
	                var connectorLine = new Path({
	                    stroke: {
	                        color: connectorsColor,
	                        width: connectors.width
	                    },
	                    animation: {
	                        type: FADEIN,
	                        delay: segment.animationDelay
	                    }
	                });

	                if (label.options.position === OUTSIDE_END) {
	                    var box = label.box;
	                    var centerPoint = sector.center;
	                    var start = sector.point(angle);
	                    var middle = new Point(box.x1, box.center().y);
	                    var sr = (void 0), end = (void 0), crossing = (void 0);

	                    start = sector.clone().expand(connectors.padding).point(angle);
	                    connectorLine.moveTo(start.x, start.y);
	                    // TODO: Extract into a method to remove duplication
	                    if (label.orientation === RIGHT) {
	                        end = new Point(box.x1 - connectors.padding, box.center().y);
	                        crossing = intersection(centerPoint, start, middle, end);
	                        middle = new Point(end.x - space, end.y);
	                        crossing = crossing || middle;
	                        crossing.x = Math.min(crossing.x, middle.x);

	                        if (this$1.pointInCircle(crossing, sector.center, sector.radius + space) ||
	                            crossing.x < sector.center.x) {
	                            sr = sector.center.x + sector.radius + space;
	                            if (segment.options.labels.align !== COLUMN) {
	                                if (sr < middle.x) {
	                                    connectorLine.lineTo(sr, start.y);
	                                } else {
	                                    connectorLine.lineTo(start.x + space * 2, start.y);
	                                }
	                            } else {
	                                connectorLine.lineTo(sr, start.y);
	                            }
	                            connectorLine.lineTo(middle.x, end.y);
	                        } else {
	                            crossing.y = end.y;
	                            connectorLine.lineTo(crossing.x, crossing.y);
	                        }
	                    } else {
	                        end = new Point(box.x2 + connectors.padding, box.center().y);
	                        crossing = intersection(centerPoint, start, middle, end);
	                        middle = new Point(end.x + space, end.y);
	                        crossing = crossing || middle;
	                        crossing.x = Math.max(crossing.x, middle.x);

	                        if (this$1.pointInCircle(crossing, sector.center, sector.radius + space) ||
	                            crossing.x > sector.center.x) {
	                            sr = sector.center.x - sector.radius - space;
	                            if (segment.options.labels.align !== COLUMN) {
	                                if (sr > middle.x) {
	                                    connectorLine.lineTo(sr, start.y);
	                                } else {
	                                    connectorLine.lineTo(start.x - space * 2, start.y);
	                                }
	                            } else {
	                                connectorLine.lineTo(sr, start.y);
	                            }
	                            connectorLine.lineTo(middle.x, end.y);
	                        } else {
	                            crossing.y = end.y;
	                            connectorLine.lineTo(crossing.x, crossing.y);
	                        }
	                    }

	                    connectorLine.lineTo(end.x, end.y);

	                    this$1._connectorLines.push(connectorLine);
	                    this$1.visual.append(connectorLine);
	                }
	            }
	        }
	    },

	    renderVisual: function() {
	        ChartElement.fn.renderVisual.call(this);

	        if (dataviz.find(this.options.series, function (options) { return options.autoFit; })) {
	            var targetBox = this.targetBox;
	            var pieCenter = this.box.center();
	            var bbox = this.visual.bbox();
	            if (!bbox) {
	                return;
	            }

	            var bboxBottom = bbox.bottomRight();

	            var scale = Math.min(
	                (pieCenter.y - targetBox.y1) / (pieCenter.y - bbox.origin.y),
	                (targetBox.y2 - pieCenter.y) / (bboxBottom.y - pieCenter.y),
	                (pieCenter.x - targetBox.x1) / (pieCenter.x - bbox.origin.x),
	                (targetBox.x2 - pieCenter.x) / (bboxBottom.x - pieCenter.x)
	            );

	            if (scale < 1) {
	                this.visual.transform(transform().scale(scale, scale, [ pieCenter.x, pieCenter.y ]));
	            }
	        }
	    },

	    labelComparator: function(reverse) {
	        var reverseValue = reverse ? -1 : 1;

	        return function(a, b) {
	            var first = (a.parent.sector.middle() + 270) % 360;
	            var second = (b.parent.sector.middle() + 270) % 360;
	            return (first - second) * reverseValue;
	        };
	    },

	    hAlignLabel: function(originalX, sector, y1, y2, direction) {
	        var radius = sector.radius;
	        var sector_center = sector.center;
	        var cx = sector_center.x;
	        var cy = sector_center.y;
	        var t = Math.min(Math.abs(cy - y1), Math.abs(cy - y2));

	        if (t > radius) {
	            return originalX;
	        }

	        return cx + Math.sqrt((radius * radius) - (t * t)) * (direction ? 1 : -1);
	    },

	    pointInCircle: function(point, center, radius) {
	        return Math.pow(center.x - point.x, 2) + Math.pow(center.y - point.y, 2) < Math.pow(radius, 2);
	    },

	    formatPointValue: function(point, format) {
	        return this.chartService.format.auto(format, point.value);
	    },

	    animationDelay: function(categoryIndex) {
	        return categoryIndex * PIE_SECTOR_ANIM_DELAY;
	    },

	    stackRoot: function() {
	        return this;
	    }
	});

	function intersection(a1, a2, b1, b2) {
	    var uat = (b2.x - b1.x) * (a1.y - b1.y) - (b2.y - b1.y) * (a1.x - b1.x);
	    var ub = (b2.y - b1.y) * (a2.x - a1.x) - (b2.x - b1.x) * (a2.y - a1.y);

	    var result;
	    if (ub !== 0) {
	        var ua = (uat / ub);

	        result = new Point(
	            a1.x + ua * (a2.x - a1.x),
	            a1.y + ua * (a2.y - a1.y)
	        );
	    }

	    return result;
	}

	setDefaultOptions(PieChart, {
	    startAngle: 90,
	    connectors: {
	        width: 2,
	        color: "#939393",
	        padding: 8
	    },
	    inactiveItems: {
	        markers: {},
	        labels: {}
	    }
	});

	deepExtend(PieChart.prototype, PieChartMixin);

	PieChart.prototype.isStackRoot = true;

	var PiePlotArea = PlotAreaBase.extend({
	    render: function() {
	        this.createPieChart(this.series);
	    },

	    createPieChart: function(series) {
	        var firstSeries = series[0];
	        var pieChart = new PieChart(this, {
	            series: series,
	            padding: firstSeries.padding,
	            startAngle: firstSeries.startAngle,
	            connectors: firstSeries.connectors,
	            legend: this.options.legend
	        });

	        this.appendChart(pieChart);
	    },

	    appendChart: function(chart, pane) {
	        PlotAreaBase.fn.appendChart.call(this, chart, pane);
	        append(this.options.legend.items, chart.legendItems);
	    }
	});

	var DonutSegment = PieSegment.extend({
	    reflowLabel: function() {
	        var ref = this;
	        var labelsOptions = ref.options.labels;
	        var label = ref.label;
	        var sector = this.sector.clone();
	        var angle = sector.middle();

	        if (label) {
	            var labelHeight = label.box.height();
	            if (labelsOptions.position === CENTER) {
	                sector.radius -= (sector.radius - sector.innerRadius) / 2;

	                var lp = sector.point(angle);

	                label.reflow(new Box(lp.x, lp.y - labelHeight / 2, lp.x, lp.y));
	            } else {
	                PieSegment.fn.reflowLabel.call(this);
	            }
	        }
	    },

	    createSegment: function(sector, options) {
	        return dataviz.ShapeBuilder.current.createRing(sector, options);
	    }
	});

	setDefaultOptions(DonutSegment, {
	    overlay: {
	        gradient: "roundedGlass"
	    },
	    labels: {
	        position: CENTER
	    },
	    animation: {
	        type: PIE
	    }
	});

	deepExtend(DonutSegment.prototype, PointEventsMixin);

	var DONUT_SECTOR_ANIM_DELAY = 50;

	var DonutChart = PieChart.extend({
	    addValue: function(value, sector, fields) {
	        var segmentOptions = deepExtend({}, fields.series, { index: fields.index });
	        this.evalSegmentOptions(segmentOptions, value, fields);

	        this.createLegendItem(value, segmentOptions, fields);

	        if (!value || fields.visible === false) {
	            return;
	        }

	        var segment = new DonutSegment(value, sector, segmentOptions);

	        $.extend(segment, fields);
	        this.append(segment);
	        this.points.push(segment);
	    },

	    reflow: function(targetBox) {
	        var this$1 = this;

	        var options = this.options;
	        var box = targetBox.clone();
	        var space = 5;
	        var minWidth = Math.min(box.width(), box.height());
	        var halfMinWidth = minWidth / 2;
	        var defaultPadding = minWidth - minWidth * 0.85;
	        var series = options.series;
	        var seriesCount = series.length;

	        var padding = valueOrDefault(options.padding, defaultPadding);
	        padding = padding > halfMinWidth - space ? halfMinWidth - space : padding;

	        var totalSize = halfMinWidth - padding;
	        var seriesWithoutSize = 0;
	        var holeSize;

	        for (var i = 0; i < seriesCount; i++) {
	            var currentSeries = series[i];
	            if (i === 0) {
	                if (defined(currentSeries.holeSize)) {
	                    holeSize = currentSeries.holeSize;
	                    totalSize -= currentSeries.holeSize;
	                }
	            }

	            if (defined(currentSeries.size)) {
	                totalSize -= currentSeries.size;
	            } else {
	                seriesWithoutSize++;
	            }

	            if (defined(currentSeries.margin) && i !== seriesCount - 1) {
	                totalSize -= currentSeries.margin;
	            }
	        }

	        if (!defined(holeSize)) {
	            var currentSize = (halfMinWidth - padding) / (seriesCount + 0.75);
	            holeSize = currentSize * 0.75;
	            totalSize -= holeSize;
	        }

	        var innerRadius = holeSize;
	        var margin = 0;
	        var size, radius;

	        this.seriesConfigs = [];

	        for (var i$1 = 0; i$1 < seriesCount; i$1++) {
	            var currentSeries$1 = series[i$1];
	            size = valueOrDefault(currentSeries$1.size, totalSize / seriesWithoutSize);
	            innerRadius += margin;
	            radius = innerRadius + size;
	            this$1.seriesConfigs.push({ innerRadius: innerRadius, radius: radius });
	            margin = currentSeries$1.margin || 0;
	            innerRadius = radius;
	        }

	        PieChart.fn.reflow.call(this, targetBox);
	    },

	    animationDelay: function(categoryIndex, seriesIndex, seriesCount) {
	        return categoryIndex * DONUT_SECTOR_ANIM_DELAY +
	            (INITIAL_ANIMATION_DURATION * (seriesIndex + 1) / (seriesCount + 1));
	    }
	});

	setDefaultOptions(DonutChart, {
	    startAngle: 90,
	    connectors: {
	        width: 2,
	        color: "#939393",
	        padding: 8
	    }
	});

	var DonutPlotArea = PiePlotArea.extend({
	    render: function() {
	        this.createDonutChart(this.series);
	    },

	    createDonutChart: function(series) {
	        var firstSeries = series[0];
	        var donutChart = new DonutChart(this, {
	            series: series,
	            padding: firstSeries.padding,
	            connectors: firstSeries.connectors,
	            legend: this.options.legend
	        });

	        this.appendChart(donutChart);
	    }
	});

	var DEFAULT_PADDING = 0.15;

	var PolarPlotAreaBase = PlotAreaBase.extend({
	    initFields: function() {
	        this.valueAxisRangeTracker = new AxisGroupRangeTracker();
	    },

	    render: function() {
	        this.addToLegend(this.series);
	        this.createPolarAxis();
	        this.createCharts();
	        this.createValueAxis();
	    },

	    alignAxes: function() {
	        var axis = this.valueAxis;
	        var range = axis.range();
	        var crossingValue = axis.options.reverse ? range.max : range.min;
	        var slot = axis.getSlot(crossingValue);
	        var center = this.polarAxis.getSlot(0).center;
	        var axisBox = axis.box.translate(
	            center.x - slot.x1,
	            center.y - slot.y1
	        );

	        axis.reflow(axisBox);
	    },

	    createValueAxis: function() {
	        var tracker = this.valueAxisRangeTracker;
	        var defaultRange = tracker.query();
	        var axisOptions = this.valueAxisOptions({
	            roundToMajorUnit: false,
	            zIndex: -1
	        });
	        var axisType, axisDefaultRange;

	        if (axisOptions.type === LOGARITHMIC) {
	            axisType = dataviz.RadarLogarithmicAxis;
	            axisDefaultRange = { min: 0.1, max: 1 };
	        } else {
	            axisType = dataviz.RadarNumericAxis;
	            axisDefaultRange = { min: 0, max: 1 };
	        }

	        var range = tracker.query(name) || defaultRange || axisDefaultRange;

	        if (range && defaultRange) {
	            range.min = Math.min(range.min, defaultRange.min);
	            range.max = Math.max(range.max, defaultRange.max);
	        }

	        var valueAxis = new axisType(
	            range.min, range.max,
	            axisOptions,
	            this.chartService
	        );

	        this.valueAxis = valueAxis;
	        this.appendAxis(valueAxis);
	    },

	    reflowAxes: function() {
	        var ref = this;
	        var options = ref.options.plotArea;
	        var valueAxis = ref.valueAxis;
	        var polarAxis = ref.polarAxis;
	        var box = ref.box;
	        var defaultPadding = Math.min(box.width(), box.height()) * DEFAULT_PADDING;
	        var padding = getSpacing(options.padding || {}, defaultPadding);
	        var paddingBox = box.clone().unpad(padding);
	        var axisBox = paddingBox.clone();

	        axisBox.y2 = axisBox.y1 + Math.min(axisBox.width(), axisBox.height());
	        axisBox.align(paddingBox, Y, CENTER);

	        var valueAxisBox = axisBox.clone().shrink(0, axisBox.height() / 2);

	        polarAxis.reflow(axisBox);
	        valueAxis.reflow(valueAxisBox);
	        var heightDiff = valueAxis.lineBox().height() - valueAxis.box.height();
	        valueAxis.reflow(valueAxis.box.unpad({ top: heightDiff }));

	        this.axisBox = axisBox;
	        this.alignAxes(axisBox);
	    },

	    backgroundBox: function() {
	        return this.box;
	    },

	    detachLabels: function() {}
	});

	var PolarScatterChart = ScatterChart.extend({
	    pointSlot: function(slotX, slotY) {
	        var valueRadius = slotX.center.y - slotY.y1;
	        var slot = Point.onCircle(slotX.center, slotX.startAngle, valueRadius);

	        return new Box(slot.x, slot.y, slot.x, slot.y);
	    }
	});

	setDefaultOptions(PolarScatterChart, {
	    clip: false
	});

	var PolarLineChart = ScatterLineChart.extend({

	});

	PolarLineChart.prototype.pointSlot = PolarScatterChart.prototype.pointSlot;

	setDefaultOptions(PolarLineChart, {
	    clip: false
	});

	var SplinePolarAreaSegment = SplineAreaSegment.extend({
	    fillToAxes: function(fillPath) {
	        var center = this._polarAxisCenter();
	        fillPath.lineTo(center.x, center.y);
	    },

	    _polarAxisCenter: function() {
	        var polarAxis = this.parent.plotArea.polarAxis;
	        var center = polarAxis.box.center();
	        return center;
	    },

	    strokeSegments: function() {
	        var segments = this._strokeSegments;

	        if (!segments) {
	            var center = this._polarAxisCenter();
	            var curveProcessor = new CurveProcessor(false);
	            var linePoints = this.points();

	            linePoints.push(center);
	            segments = this._strokeSegments = curveProcessor.process(linePoints);
	            segments.pop();
	        }

	        return segments;
	    }
	});

	var PolarAreaSegment = AreaSegment.extend({
	    fillToAxes: function(fillPath) {
	        var polarAxis = this.parent.plotArea.polarAxis;
	        var center = polarAxis.box.center();
	        var centerSegment = new geometry.Segment([ center.x, center.y ]);

	        fillPath.segments.unshift(centerSegment);
	        fillPath.segments.push(centerSegment);
	    }
	});

	var PolarAreaChart = PolarLineChart.extend({
	    createSegment: function(linePoints, currentSeries, seriesIx) {
	        var style = (currentSeries.line || {}).style;
	        var segment;

	        if (style === SMOOTH) {
	            segment = new SplinePolarAreaSegment(linePoints, currentSeries, seriesIx);
	        } else {
	            segment = new PolarAreaSegment(linePoints, currentSeries, seriesIx);
	        }
	        return segment;
	    },

	    createMissingValue: function(value, missingValues) {
	        var missingValue;

	        if (hasValue(value.x) && missingValues !== INTERPOLATE) {
	            missingValue = {
	                x: value.x,
	                y: value.y
	            };
	            if (missingValues === ZERO) {
	                missingValue.y = 0;
	            }
	        }

	        return missingValue;
	    },

	    seriesMissingValues: function(series) {
	        return series.missingValues || ZERO;
	    },

	    _hasMissingValuesGap: function() {
	        var this$1 = this;

	        var series = this.options.series;

	        for (var idx = 0; idx < series.length; idx++) {
	            if (this$1.seriesMissingValues(series[idx]) === GAP) {
	                return true;
	            }
	        }
	    },

	    sortPoints: function(points) {
	        var this$1 = this;

	        points.sort(xComparer);

	        if (this._hasMissingValuesGap()) {
	            for (var idx = 0; idx < points.length; idx++) {
	                var point = points[idx];
	                if (point) {
	                    var value = point.value;
	                    if (!hasValue(value.y) && this$1.seriesMissingValues(point.series) === GAP) {
	                        delete points[idx];
	                    }
	                }
	            }
	        }

	        return points;
	    }
	});

	function xComparer(a, b) {
	    return a.value.x - b.value.x;
	}

	var PolarPlotArea = PolarPlotAreaBase.extend({
	    createPolarAxis: function() {
	        var polarAxis = new dataviz.PolarAxis(this.options.xAxis, this.chartService);

	        this.polarAxis = polarAxis;
	        this.axisX = polarAxis;
	        this.appendAxis(polarAxis);
	    },

	    valueAxisOptions: function(defaults) {
	        return deepExtend(defaults, {
	            majorGridLines: { type: ARC },
	            minorGridLines: { type: ARC }
	        }, this.options.yAxis);
	    },

	    createValueAxis: function() {
	        PolarPlotAreaBase.fn.createValueAxis.call(this);
	        this.axisY = this.valueAxis;
	    },

	    appendChart: function(chart, pane) {
	        this.valueAxisRangeTracker.update(chart.yAxisRanges);

	        PlotAreaBase.prototype.appendChart.call(this, chart, pane);
	    },

	    createCharts: function() {
	        var series = this.filterVisibleSeries(this.series);
	        var pane = this.panes[0];

	        this.createLineChart(
	            filterSeriesByType(series, [ POLAR_LINE ]),
	            pane
	        );

	        this.createScatterChart(
	            filterSeriesByType(series, [ POLAR_SCATTER ]),
	            pane
	        );

	        this.createAreaChart(
	            filterSeriesByType(series, [ POLAR_AREA ]),
	            pane
	        );
	    },

	    createLineChart: function(series, pane) {
	        if (series.length === 0) {
	            return;
	        }

	        var lineChart = new PolarLineChart(this, { series: series });

	        this.appendChart(lineChart, pane);
	    },

	    createScatterChart: function(series, pane) {
	        if (series.length === 0) {
	            return;
	        }

	        var scatterChart = new PolarScatterChart(this, { series: series });

	        this.appendChart(scatterChart, pane);
	    },

	    createAreaChart: function(series, pane) {
	        if (series.length === 0) {
	            return;
	        }

	        var areaChart = new PolarAreaChart(this, { series: series });

	        this.appendChart(areaChart, pane);
	    },

	    _dispatchEvent: function(chart, e, eventType) {
	        var coords = chart._eventCoordinates(e);
	        var point = new Point(coords.x, coords.y);
	        var xValue = this.axisX.getValue(point);
	        var yValue = this.axisY.getValue(point);

	        if (xValue !== null && yValue !== null) {
	            chart.trigger(eventType, {
	                element: eventElement(e),
	                x: xValue,
	                y: yValue
	            });
	        }
	    },

	    createCrosshairs: function() {}
	});

	setDefaultOptions(PolarPlotArea, {
	    xAxis: {},
	    yAxis: {}
	});

	deepExtend(PolarPlotArea.prototype, PlotAreaEventsMixin);

	function groupBySeriesIx(segments) {
	    var seriesSegments = [];
	    for (var idx = 0; idx < segments.length; idx++) {
	        var segment = segments[idx];
	        seriesSegments[segment.seriesIx] = seriesSegments[segment.seriesIx] || [];
	        seriesSegments[segment.seriesIx].push(segment);
	    }

	    return seriesSegments;
	}

	var RadarLineChart = LineChart.extend({
	    pointSlot: function(categorySlot, valueSlot) {
	        var valueRadius = categorySlot.center.y - valueSlot.y1;
	        var slot = Point.onCircle(categorySlot.center, categorySlot.middle(), valueRadius);

	        return new Box(slot.x, slot.y, slot.x, slot.y);
	    },

	    renderSegments: function() {
	        LineChart.fn.renderSegments.call(this);

	        if (this._segments && this._segments.length > 1) {
	            var seriesSegments = groupBySeriesIx(this._segments);

	            for (var idx = 0; idx < seriesSegments.length; idx++) {
	                var segments = seriesSegments[idx];
	                if (segments && segments.length > 1) {
	                    var firstPoint = segments[0].linePoints[0];
	                    var lastSegment = last(segments);
	                    var lastPoint = last(lastSegment.linePoints);
	                    var isFirstDataPoint = firstPoint.categoryIx === 0;
	                    var isLastDataPoint = lastPoint.categoryIx === lastPoint.categoriesCount - 1;
	                    if (isFirstDataPoint && isLastDataPoint) {
	                        last(segments).linePoints.push(firstPoint);
	                    }
	                }
	            }
	        }
	    },

	    createSegment: function(linePoints, currentSeries, seriesIx) {
	        var style = currentSeries.style;
	        var pointType;

	        if (style === SMOOTH) {
	            pointType = SplineSegment;
	        } else {
	            pointType = LineSegment;
	        }

	        var segment = new pointType(linePoints, currentSeries, seriesIx);
	        var missingValues = this.seriesMissingValues(currentSeries);

	        if (linePoints.length === currentSeries.data.length || missingValues === INTERPOLATE) {
	            segment.options.closed = true;
	        }

	        return segment;
	    }
	});

	setDefaultOptions(RadarLineChart, {
	    clip: false,
	    limitPoints: false
	});

	var SplineRadarAreaSegment = SplineAreaSegment.extend({
	    fillToAxes: function() {}
	});

	var RadarAreaSegment = AreaSegment.extend({
	    fillToAxes: function() {}
	});

	var RadarAreaChart = RadarLineChart.extend({
	    createSegment: function(linePoints, currentSeries, seriesIx, prevSegment) {
	        var isStacked = this.options.isStacked;
	        var style = (currentSeries.line || {}).style;
	        var previousSegment;
	        var stackPoints;
	        var segment;

	        if (isStacked && seriesIx > 0 && prevSegment) {
	            stackPoints = prevSegment.linePoints.slice(0);
	            previousSegment = prevSegment;
	        }

	        if (style === SMOOTH) {
	            segment = new SplineRadarAreaSegment(linePoints, currentSeries, seriesIx, previousSegment, stackPoints);
	            segment.options.closed = true;
	        } else {
	            linePoints.push(linePoints[0]);
	            segment = new RadarAreaSegment(linePoints, currentSeries, seriesIx, previousSegment, stackPoints);
	        }

	        return segment;
	    },

	    seriesMissingValues: function(series) {
	        return series.missingValues || ZERO;
	    }
	});

	var RadarSegment = DonutSegment.extend({
	    init: function(value, options) {
	        DonutSegment.fn.init.call(this, value, null, options);
	    }
	});

	setDefaultOptions(RadarSegment, {
	    overlay: {
	        gradient: "none"
	    },
	    labels: {
	        distance: 10
	    }
	});

	var RadarClusterLayout = ChartElement.extend({
	    init: function(options) {
	        ChartElement.fn.init.call(this, options);

	        this.forEach = options.rtl ? forEachReverse : forEach;
	    },

	    reflow: function(sector) {
	        var ref = this;
	        var options = ref.options;
	        var children = ref.children;
	        var gap = options.gap;
	        var spacing = options.spacing;
	        var count = children.length;
	        var slots = count + gap + (spacing * (count - 1));
	        var slotAngle = sector.angle / slots;
	        var angle = sector.startAngle + slotAngle * (gap / 2);

	        this.forEach(children, function (child) {
	            var slotSector = sector.clone();
	            slotSector.startAngle = angle;
	            slotSector.angle = slotAngle;

	            if (child.sector) {
	                slotSector.radius = child.sector.radius;
	            }

	            child.reflow(slotSector);
	            child.sector = slotSector;

	            angle += slotAngle + (slotAngle * spacing);
	        });
	    }
	});

	setDefaultOptions(RadarClusterLayout, {
	    gap: 1,
	    spacing: 0
	});

	var RadarStackLayout = ChartElement.extend({
	    reflow: function(sector) {
	        var ref = this;
	        var reverse = ref.options.reverse;
	        var children = ref.children;
	        var childrenCount = children.length;
	        var first = reverse ? childrenCount - 1 : 0;
	        var step = reverse ? -1 : 1;

	        this.box = new Box();

	        for (var i = first; i >= 0 && i < childrenCount; i += step) {
	            var childSector = children[i].sector;
	            childSector.startAngle = sector.startAngle;
	            childSector.angle = sector.angle;
	        }
	    }
	});

	var RadarBarChart = BarChart.extend({
	    pointType: function() {
	        return RadarSegment;
	    },

	    clusterType: function() {
	        return RadarClusterLayout;
	    },

	    stackType: function() {
	        return RadarStackLayout;
	    },

	    categorySlot: function(categoryAxis, categoryIx) {
	        return categoryAxis.getSlot(categoryIx);
	    },

	    pointSlot: function(categorySlot, valueSlot) {
	        var slot = categorySlot.clone();
	        var y = categorySlot.center.y;

	        slot.radius = y - valueSlot.y1;
	        slot.innerRadius = y - valueSlot.y2;

	        return slot;
	    },

	    reflowPoint: function(point, pointSlot) {
	        point.sector = pointSlot;
	        point.reflow();
	    },

	    createAnimation: function() {
	        this.options.animation.center = this.box.toRect().center();
	        BarChart.fn.createAnimation.call(this);
	    }
	});

	RadarBarChart.prototype.reflow = CategoricalChart.prototype.reflow;

	setDefaultOptions(RadarBarChart, {
	    clip: false,
	    limitPoints: false,
	    animation: {
	        type: "pie"
	    }
	});

	var RadarPlotArea = PolarPlotAreaBase.extend({
	    createPolarAxis: function() {
	        var categoryAxis = new dataviz.RadarCategoryAxis(this.options.categoryAxis, this.chartService);

	        this.polarAxis = categoryAxis;
	        this.categoryAxis = categoryAxis;
	        this.appendAxis(categoryAxis);
	        this.aggregateCategories();
	        this.createCategoryAxesLabels();
	    },

	    valueAxisOptions: function(defaults) {
	        if (this._hasBarCharts) {
	            deepExtend(defaults, {
	                majorGridLines: { type: ARC },
	                minorGridLines: { type: ARC }
	            });
	        }

	        if (this._isStacked100) {
	            deepExtend(defaults, {
	                roundToMajorUnit: false,
	                labels: { format: "P0" }
	            });
	        }

	        return deepExtend(defaults, this.options.valueAxis);
	    },

	    aggregateCategories: function() {
	        // No separate panes in radar charts
	        CategoricalPlotArea.prototype.aggregateCategories.call(this, this.panes);
	    },

	    createCategoryAxesLabels: function() {
	        CategoricalPlotArea.prototype.createCategoryAxesLabels.call(this, this.panes);
	    },

	    filterSeries: function(currentSeries) {
	        // Not supported for radar charts
	        return currentSeries;
	    },

	    createCharts: function() {
	        var series = this.filterVisibleSeries(this.series);
	        var pane = this.panes[0];

	        this.createAreaChart(
	            filterSeriesByType(series, [ RADAR_AREA ]),
	            pane
	        );

	        this.createLineChart(
	            filterSeriesByType(series, [ RADAR_LINE ]),
	            pane
	        );

	        this.createBarChart(
	            filterSeriesByType(series, [ RADAR_COLUMN ]),
	            pane
	        );
	    },

	    chartOptions: function(series) {
	        var options = { series: series };
	        var firstSeries = series[0];
	        if (firstSeries) {
	            var filteredSeries = this.filterVisibleSeries(series);
	            var stack = firstSeries.stack;
	            options.isStacked = stack && filteredSeries.length > 1;
	            options.isStacked100 = stack && stack.type === "100%" && filteredSeries.length > 1;

	            if (options.isStacked100) {
	                this._isStacked100 = true;
	            }
	        }

	        return options;
	    },

	    createAreaChart: function(series, pane) {
	        if (series.length === 0) {
	            return;
	        }

	        var areaChart = new RadarAreaChart(this, this.chartOptions(series));
	        this.appendChart(areaChart, pane);
	    },

	    createLineChart: function(series, pane) {
	        if (series.length === 0) {
	            return;
	        }

	        var lineChart = new RadarLineChart(this, this.chartOptions(series));
	        this.appendChart(lineChart, pane);
	    },

	    createBarChart: function(series, pane) {
	        if (series.length === 0) {
	            return;
	        }

	        var firstSeries = series[0];
	        var options = this.chartOptions(series);
	        options.gap = firstSeries.gap;
	        options.spacing = firstSeries.spacing;

	        var barChart = new RadarBarChart(this, options);
	        this.appendChart(barChart, pane);

	        this._hasBarCharts = true;
	    },

	    seriesCategoryAxis: function() {
	        return this.categoryAxis;
	    },

	    _dispatchEvent: function(chart, e, eventType) {
	        var coords = chart._eventCoordinates(e);
	        var point = new Point(coords.x, coords.y);
	        var category = this.categoryAxis.getCategory(point);
	        var value = this.valueAxis.getValue(point);

	        if (category !== null && value !== null) {
	            chart.trigger(eventType, {
	                element: eventElement(e),
	                category: category,
	                value: value
	            });
	        }
	    },

	    createCrosshairs: function() {}
	});

	deepExtend(RadarPlotArea.prototype, PlotAreaEventsMixin, {
	    appendChart: CategoricalPlotArea.prototype.appendChart,
	    aggregateSeries: CategoricalPlotArea.prototype.aggregateSeries,
	    seriesSourcePoints: CategoricalPlotArea.prototype.seriesSourcePoints
	});

	setDefaultOptions(RadarPlotArea, {
	    categoryAxis: {
	        categories: []
	    },
	    valueAxis: {}
	});

	var FunnelSegment = ChartElement.extend({
	    init: function(value, options, segmentOptions) {
	        ChartElement.fn.init.call(this, options);

	        this.value = value;
	        this.options.index = segmentOptions.index;
	    },

	    reflow: function(chartBox) {
	        var points = this.points;
	        var label = this.children[0];

	        this.box = new Box(points[0].x, points[0].y, points[1].x, points[2].y);

	        if (label) {
	            label.reflow(new Box(chartBox.x1, points[0].y, chartBox.x2, points[2].y));
	        }
	    },

	    createVisual: function() {
	        var this$1 = this;

	        var options = this.options;
	        var visual;

	        ChartElement.fn.createVisual.call(this);

	        if (options.visual) {
	            visual = options.visual({
	                category: this.category,
	                dataItem: this.dataItem,
	                value: this.value,
	                series: this.series,
	                percentage: this.percentage,
	                points: this.points,
	                options: options,
	                sender: this.getSender(),
	                createVisual: function () { return this$1.createPath(); }
	            });
	        } else {
	            visual = this.createPath();
	        }

	        if (visual) {
	            this.visual.append(visual);
	        }
	    },

	    createPath: function() {
	        var options = this.options;
	        var border = options.border;
	        var path = Path.fromPoints(this.points, {
	            fill: {
	                color: options.color,
	                opacity: options.opacity
	            },
	            stroke: {
	                color: border.color,
	                opacity: border.opacity,
	                width: border.width
	            }
	        }).close();

	        return path;
	    },

	    createHighlight: function(style) {
	        return Path.fromPoints(this.points, style);
	    },

	    highlightVisual: function() {
	        return this.visual.children[0];
	    },

	    highlightVisualArgs: function() {
	        var path = Path.fromPoints(this.points).close();

	        return {
	            options: this.options,
	            path: path
	        };
	    },

	    tooltipAnchor: function() {
	        var box = this.box;
	        return {
	            point: new Point(box.center().x, box.y1),
	            align: {
	                horizontal: "center",
	                vertical: "top"
	            }
	        };
	    },

	    formatValue: function(format) {
	        var point = this;
	        return point.owner.formatPointValue(point, format);
	    }
	});

	setDefaultOptions(FunnelSegment, {
	    color: WHITE,
	    border: {
	        width: 1
	    }
	});

	deepExtend(FunnelSegment.prototype, PointEventsMixin);

	var FunnelChart = ChartElement.extend({
	    init: function(plotArea, options) {
	        ChartElement.fn.init.call(this, options);

	        this.plotArea = plotArea;
	        this.points = [];
	        this.labels = [];
	        this.legendItems = [];
	        this.render();
	    },

	    formatPointValue: function(point, format) {
	        return this.chartService.format.auto(format,point.value);
	    },

	    render: function() {
	        var this$1 = this;

	        var ref = this;
	        var options = ref.options;
	        var seriesColors = ref.plotArea.options.seriesColors; if (seriesColors === void 0) { seriesColors = []; }
	        var series = options.series[0];
	        var data = series.data;

	        if (!data) {
	            return;
	        }

	        var ref$1 = bindSegments(series);
	        var total = ref$1.total;
	        var points = ref$1.points;

	        for (var i = 0; i < points.length; i++) {
	            var pointData = points[i];

	            if (!pointData) {
	                continue;
	            }

	            var fields = pointData.fields;

	            if (!isFunction(series.color)) {
	                series.color = fields.color || seriesColors[i % seriesColors.length];
	            }

	            fields = deepExtend({
	                index: i,
	                owner: this$1,
	                series: series,
	                dataItem: data[i],
	                percentage: pointData.value / total
	            }, fields, { visible: pointData.visible });

	            var value = pointData.valueFields.value;
	            var segment = this$1.createSegment(value, fields);
	            var label = this$1.createLabel(value, fields);

	            if (segment && label) {
	                segment.append(label);
	            }
	        }
	    },

	    evalSegmentOptions: function(options, value, fields) {
	        var series = fields.series;

	        evalOptions(options, {
	            value: value,
	            series: series,
	            dataItem: fields.dataItem,
	            index: fields.index
	        }, { defaults: series._defaults, excluded: [ "data", "content", "template", "toggle", "visual" ] });
	    },

	    createSegment: function(value, fields) {
	        var seriesOptions = deepExtend({}, fields.series);
	        this.evalSegmentOptions(seriesOptions, value, fields);

	        this.createLegendItem(value, seriesOptions, fields);

	        if (fields.visible !== false) {

	            var segment = new FunnelSegment(value, seriesOptions, fields);
	            $.extend(segment, fields);

	            this.append(segment);
	            this.points.push(segment);

	            return segment;
	        }
	    },

	    createLabel: function(value, fields) {
	        var series = fields.series;
	        var dataItem = fields.dataItem;
	        var labels = deepExtend({}, this.options.labels, series.labels);
	        var text = value;

	        if (labels.visible) {
	            var labelTemplate = getTemplate(labels);
	            var data = {
	                dataItem: dataItem,
	                value: value,
	                percentage: fields.percentage,
	                category: fields.category,
	                series: series
	            };
	            if (labelTemplate) {
	                text = labelTemplate(data);
	            } else if (labels.format) {
	                text = this.plotArea.chartService.format.auto(labels.format, text);
	            }

	            if (!labels.color) {
	                var brightnessValue = new Color(series.color).percBrightness();
	                if (brightnessValue > 180) {
	                    labels.color = BLACK;
	                } else {
	                    labels.color = WHITE;
	                }
	                if (!labels.background) {
	                    labels.background = series.color;
	                }
	            }

	            this.evalSegmentOptions(labels, value, fields);
	            var textBox = new TextBox(text, deepExtend({
	                vAlign: labels.position
	            }, labels), data);

	            this.labels.push(textBox);

	            return textBox;
	        }
	    },

	    labelPadding: function() {
	        var labels = this.labels;
	        var padding = { left: 0, right: 0 };

	        for (var i = 0; i < labels.length; i++) {
	            var label = labels[i];
	            var align = label.options.align;
	            if (align !== CENTER) {
	                var width = labels[i].box.width();

	                if (align === LEFT) {
	                    padding.left = Math.max(padding.left, width);
	                } else {
	                    padding.right = Math.max(padding.right, width);
	                }
	            }
	        }

	        return padding;
	    },

	    dynamicSlopeReflow: function(box, width, totalHeight) {
	        var ref = this;
	        var options = ref.options;
	        var segments = ref.points;
	        var count = segments.length;
	        var firstSegment = segments[0];
	        var maxSegment = firstSegment;

	        for (var idx = 0; idx < segments.length; idx++) {
	            if (segments[idx].percentage > maxSegment.percentage) {
	                maxSegment = segments[idx];
	            }
	        }

	        var lastUpperSide = (firstSegment.percentage / maxSegment.percentage) * width;
	        var previousOffset = (width - lastUpperSide) / 2;
	        var previousHeight = 0;

	        for (var idx$1 = 0; idx$1 < count; idx$1++) {
	            var percentage = segments[idx$1].percentage;
	            var nextSegment = segments[idx$1 + 1];
	            var nextPercentage = (nextSegment ? nextSegment.percentage : percentage);
	            var points = segments[idx$1].points = [];
	            var height = (options.dynamicHeight) ? (totalHeight * percentage) : (totalHeight / count);
	            var offset = (void 0);

	            if (!percentage) {
	                offset = nextPercentage ? 0 : width / 2;
	            } else {
	                offset = (width - lastUpperSide * (nextPercentage / percentage)) / 2;
	            }

	            offset = limitValue(offset, 0, width);

	            points.push(new GeometryPoint(box.x1 + previousOffset, box.y1 + previousHeight));
	            points.push(new GeometryPoint(box.x1 + width - previousOffset, box.y1 + previousHeight));
	            points.push(new GeometryPoint(box.x1 + width - offset, box.y1 + height + previousHeight));
	            points.push(new GeometryPoint(box.x1 + offset, box.y1 + height + previousHeight));

	            previousOffset = offset;
	            previousHeight += height + options.segmentSpacing;
	            lastUpperSide = limitValue(width - 2 * offset, 0, width);
	        }
	    },

	    constantSlopeReflow: function(box, width, totalHeight) {
	        var ref = this;
	        var options = ref.options;
	        var segments = ref.points;
	        var count = segments.length;
	        var decreasingWidth = options.neckRatio <= 1;
	        var neckRatio = decreasingWidth ? options.neckRatio * width : width;
	        var previousOffset = decreasingWidth ? 0 : (width - width / options.neckRatio) / 2;
	        var topMostWidth = decreasingWidth ? width : width - previousOffset * 2;
	        var finalNarrow = (topMostWidth - neckRatio) / 2;
	        var previousHeight = 0;

	        for (var idx = 0; idx < count; idx++) {
	            var points = segments[idx].points = [];
	            var percentage = segments[idx].percentage;
	            var offset = (options.dynamicHeight) ? (finalNarrow * percentage) : (finalNarrow / count);
	            var height = (options.dynamicHeight) ? (totalHeight * percentage) : (totalHeight / count);

	            points.push(new GeometryPoint(box.x1 + previousOffset, box.y1 + previousHeight));
	            points.push(new GeometryPoint(box.x1 + width - previousOffset, box.y1 + previousHeight));
	            points.push(new GeometryPoint(box.x1 + width - previousOffset - offset, box.y1 + height + previousHeight));
	            points.push(new GeometryPoint(box.x1 + previousOffset + offset,box.y1 + height + previousHeight));
	            previousOffset += offset;
	            previousHeight += height + options.segmentSpacing;
	        }
	    },

	    reflow: function(chartBox) {
	        var points = this.points;
	        var count = points.length;

	        if (!count) {
	            return;
	        }

	        var options = this.options;
	        var box = chartBox.clone().unpad(this.labelPadding());
	        var totalHeight = box.height() - options.segmentSpacing * (count - 1);
	        var width = box.width();

	        if (options.dynamicSlope) {
	            this.dynamicSlopeReflow(box, width, totalHeight);
	        } else {
	            this.constantSlopeReflow(box, width, totalHeight);
	        }

	        for (var idx = 0; idx < count; idx++) {
	            points[idx].reflow(chartBox);
	        }
	    }
	});

	setDefaultOptions(FunnelChart, {
	    neckRatio: 0.3,
	    width: 300,
	    dynamicSlope: false,
	    dynamicHeight: true,
	    segmentSpacing: 0,
	    labels: {
	        visible: false,
	        align: CENTER,
	        position: CENTER,
	        zIndex: 1
	    }
	});

	deepExtend(FunnelChart.prototype, PieChartMixin);

	var FunnelPlotArea = PlotAreaBase.extend({
	    render: function() {
	        this.createFunnelChart(this.series);
	    },

	    createFunnelChart: function(series) {
	        var firstSeries = series[0];
	        var funnelChart = new FunnelChart(this, {
	            series: series,
	            legend: this.options.legend,
	            neckRatio: firstSeries.neckRatio,
	            dynamicHeight: firstSeries.dynamicHeight,
	            dynamicSlope: firstSeries.dynamicSlope,
	            segmentSpacing: firstSeries.segmentSpacing,
	            highlight: firstSeries.highlight
	        });

	        this.appendChart(funnelChart);
	    },

	    appendChart: function(chart, pane) {
	        PlotAreaBase.fn.appendChart.call(this, chart, pane);
	        append(this.options.legend.items, chart.legendItems);
	    }
	});

	var COLOR = "color";
	var FIRST = "first";
	var FROM = "from";
	var MAX = "max";
	var MIN = "min";
	var NOTE_TEXT = "noteText";
	var SUMMARY_FIELD = "summary";
	var TO = "to";

	PlotAreaFactory.current.register(CategoricalPlotArea, [
	    BAR, COLUMN, LINE, VERTICAL_LINE, AREA, VERTICAL_AREA,
	    CANDLESTICK, OHLC, BULLET, VERTICAL_BULLET, BOX_PLOT, VERTICAL_BOX_PLOT,
	    RANGE_COLUMN, RANGE_BAR, WATERFALL, HORIZONTAL_WATERFALL, RANGE_AREA, VERTICAL_RANGE_AREA
	]);

	PlotAreaFactory.current.register(XYPlotArea, [
	    SCATTER, SCATTER_LINE, BUBBLE
	]);

	PlotAreaFactory.current.register(PiePlotArea, [ PIE ]);
	PlotAreaFactory.current.register(DonutPlotArea, [ DONUT ]);
	PlotAreaFactory.current.register(FunnelPlotArea, [ FUNNEL ]);

	PlotAreaFactory.current.register(PolarPlotArea, [ POLAR_AREA, POLAR_LINE, POLAR_SCATTER ]);
	PlotAreaFactory.current.register(RadarPlotArea, [ RADAR_AREA, RADAR_COLUMN, RADAR_LINE ]);

	SeriesBinder.current.register(
	    [ BAR, COLUMN, LINE, VERTICAL_LINE, AREA, VERTICAL_AREA ],
	    [ VALUE ], [ CATEGORY, COLOR, NOTE_TEXT, ERROR_LOW_FIELD, ERROR_HIGH_FIELD ]
	);

	SeriesBinder.current.register(
	    [ RANGE_COLUMN, RANGE_BAR, RANGE_AREA, VERTICAL_RANGE_AREA ],
	    [ FROM, TO ], [ CATEGORY, COLOR, NOTE_TEXT ]
	);

	SeriesBinder.current.register(
	    [ WATERFALL, HORIZONTAL_WATERFALL ],
	    [ VALUE ], [ CATEGORY, COLOR, NOTE_TEXT, SUMMARY_FIELD ]
	);

	SeriesBinder.current.register([ POLAR_AREA, POLAR_LINE, POLAR_SCATTER ], [ X, Y ], [ COLOR ]);
	SeriesBinder.current.register([ RADAR_AREA, RADAR_COLUMN, RADAR_LINE ], [ VALUE ], [ COLOR ]);

	SeriesBinder.current.register(
	    [ FUNNEL ],
	    [ VALUE ], [ CATEGORY, COLOR, "visibleInLegend", "visible" ]
	);

	DefaultAggregates.current.register(
	    [ BAR, COLUMN, LINE, VERTICAL_LINE, AREA, VERTICAL_AREA, WATERFALL, HORIZONTAL_WATERFALL ],
	    { value: MAX, color: FIRST, noteText: FIRST, errorLow: MIN, errorHigh: MAX }
	);

	DefaultAggregates.current.register(
	    [ RANGE_COLUMN, RANGE_BAR, RANGE_AREA, VERTICAL_RANGE_AREA ],
	    { from: MIN, to: MAX, color: FIRST, noteText: FIRST }
	);

	DefaultAggregates.current.register(
	    [ RADAR_AREA, RADAR_COLUMN, RADAR_LINE ],
	    { value: MAX, color: FIRST }
	);

	SeriesBinder.current.register(
	    [ SCATTER, SCATTER_LINE, BUBBLE ],
	    [ X, Y ], [ COLOR, NOTE_TEXT, X_ERROR_LOW_FIELD, X_ERROR_HIGH_FIELD, Y_ERROR_LOW_FIELD, Y_ERROR_HIGH_FIELD ]
	);

	SeriesBinder.current.register(
	    [ BUBBLE ], [ X, Y, "size" ], [ COLOR, CATEGORY, NOTE_TEXT ]
	);

	SeriesBinder.current.register(
	    [ CANDLESTICK, OHLC ],
	    [ "open", "high", "low", "close" ], [ CATEGORY, COLOR, "downColor", NOTE_TEXT ]
	);

	DefaultAggregates.current.register(
	    [ CANDLESTICK, OHLC ],
	    { open: MAX, high: MAX, low: MIN, close: MAX,
	      color: FIRST, downColor: FIRST, noteText: FIRST }
	);

	SeriesBinder.current.register(
	    [ BOX_PLOT, VERTICAL_BOX_PLOT ],
	    [ "lower", "q1", "median", "q3", "upper", "mean", "outliers" ], [ CATEGORY, COLOR, NOTE_TEXT ]
	);

	DefaultAggregates.current.register(
	    [ BOX_PLOT, VERTICAL_BOX_PLOT ],
	    { lower: MAX, q1: MAX, median: MAX, q3: MAX, upper: MAX, mean: MAX, outliers: FIRST,
	      color: FIRST, noteText: FIRST }
	);

	SeriesBinder.current.register(
	    [ BULLET, VERTICAL_BULLET ],
	    [ "current", "target" ], [ CATEGORY, COLOR, "visibleInLegend", NOTE_TEXT ]
	);

	DefaultAggregates.current.register(
	    [ BULLET, VERTICAL_BULLET ],
	    { current: MAX, target: MAX, color: FIRST, noteText: FIRST }
	);

	SeriesBinder.current.register(
	    [ PIE, DONUT ],
	    [ VALUE ], [ CATEGORY, COLOR, "explode", "visibleInLegend", "visible" ]
	);

	var AXIS_NAMES = [ CATEGORY, VALUE, X, Y ];

	var MOUSEMOVE = "mousemove";
	var CONTEXTMENU = "contextmenu";
	var MOUSELEAVE = "mouseleave";
	var MOUSEMOVE_DELAY = 20;

	var Chart = Class.extend({
	    init: function(element, userOptions, themeOptions, context) {
	        var this$1 = this;
	        if (context === void 0) { context = {}; }

	        this.observers = [];
	        this.addObserver(context.observer);
	        this.chartService = new services.ChartService(this, context);
	        this.chartService.theme = themeOptions;

	        this._initElement(element);

	        var options = deepExtend({}, this.options, userOptions);
	        this._originalOptions = deepExtend({}, options);
	        this._theme = themeOptions;
	        this._initTheme(options, themeOptions);

	        this._initHandlers();
	        this._initSurface();

	        this.bindCategories();
	        dataviz.FontLoader.preloadFonts(userOptions, function () {
	            this$1.fontLoaded = true;
	            if (!this$1._destroyed) {
	                this$1.trigger('init');
	                this$1._redraw();
	                this$1._attachEvents();
	            }
	        });
	    },

	    _initElement: function(element) {
	        this._setElementClass(element);
	        element.style.position = "relative";
	        while (element.firstChild) {
	            element.removeChild(element.firstChild);
	        }
	        this.element = element;
	    },

	    _setElementClass: function(element) {
	        dataviz.addClass(element, "k-chart");
	    },

	    _initTheme: function(options, themeOptions) {
	        var seriesCopies = [];
	        var series = options.series || [];

	        for (var i = 0; i < series.length; i++) {
	            seriesCopies.push($.extend({}, series[i]));
	        }
	        options.series = seriesCopies;

	        resolveAxisAliases(options);
	        this.applyDefaults(options, themeOptions);

	        // Clean up default if not overriden by data attributes
	        if (options.seriesColors === null) {
	            delete options.seriesColors;
	        }

	        this.options = deepExtend({}, themeOptions, options);
	        this.applySeriesColors();
	    },

	    getSize: function() {
	        var chartArea = this.options.chartArea || {};
	        var width = chartArea.width ? parseInt(chartArea.width, 10) : Math.floor(this.element.offsetWidth);
	        var height = chartArea.height ? parseInt(chartArea.height, 10) : Math.floor(this.element.offsetHeight);

	        return {
	            width: width,
	            height: height
	        };
	    },

	    resize: function(force) {
	        var size = this.getSize();
	        var currentSize = this._size;
	        var hasSize = size.width > 0 || size.height > 0;

	        if (force || hasSize && (!currentSize || size.width !== currentSize.width || size.height !== currentSize.height)) {
	            this._size = size;
	            this._resize(size, force);
	            this.trigger("resize", size);
	        } else if (hasSize && this._selections && dataviz.find(this._selections, function (s) { return !s.visible; })) {
	            this._destroySelections();
	            this._setupSelection();
	        }
	    },

	    _resize: function() {
	        this._noTransitionsRedraw();
	    },

	    redraw: function(paneName) {
	        this.applyDefaults(this.options);
	        this.applySeriesColors();

	        if (paneName) {
	            var plotArea = this._model._plotArea;
	            var pane = plotArea.findPane(paneName);
	            plotArea.redraw(pane);
	        } else {
	            this._redraw();
	        }
	    },

	    getAxis: function(name) {
	        return findAxisByName(name, this._plotArea.axes);
	    },

	    findAxisByName: function(name) {
	        return this.getAxis(name);
	    },

	    findPaneByName: function(name) {
	        var panes = this._plotArea.panes;

	        for (var idx = 0; idx < panes.length; idx++) {
	            if (panes[idx].options.name === name) {
	                return new ChartPane(panes[idx]);
	            }
	        }
	    },

	    findPaneByIndex: function(idx) {
	        var panes = this._plotArea.panes;
	        if (panes[idx]) {
	            return new ChartPane(panes[idx]);
	        }
	    },

	    plotArea: function() {
	        return new ChartPlotArea(this._plotArea);
	    },

	    toggleHighlight: function(show, filter) {
	        var plotArea = this._plotArea;
	        var firstSeries = (plotArea.srcSeries || plotArea.series || [])[0];
	        var points;

	        if (isFunction(filter)) {
	            points = plotArea.filterPoints(filter);
	        } else {
	            var seriesName, categoryName;
	            if (isObject(filter)) {
	                seriesName = filter.series;
	                categoryName = filter.category;
	            } else {
	                seriesName = categoryName = filter;
	            }

	            if (firstSeries.type === DONUT) {
	                points = pointByCategoryName(plotArea.pointsBySeriesName(seriesName), categoryName);
	            } else if (firstSeries.type === PIE || firstSeries.type === FUNNEL) {
	                points = pointByCategoryName((plotArea.charts[0] || {}).points, categoryName);
	            } else {
	                points = plotArea.pointsBySeriesName(seriesName);
	            }
	        }

	        if (points) {
	            this.togglePointsHighlight(show, points);
	        }
	    },

	    togglePointsHighlight: function(show, points) {
	        var highlight = this._highlight;
	        for (var idx = 0; idx < points.length; idx++) {
	            highlight.togglePointHighlight(points[idx], show);
	        }
	    },

	    showTooltip: function(filter) {
	        var shared = this._sharedTooltip();
	        var ref = this;
	        var tooltip = ref._tooltip;
	        var plotArea = ref._plotArea;
	        var point, categoryIndex;

	        if (isFunction(filter)) {
	            point = plotArea.findPoint(filter);
	            if (point && shared) {
	                categoryIndex = point.categoryIx;
	            }
	        } else if (shared && defined(filter)) {
	            categoryIndex = plotArea.categoryAxis.categoryIndex(filter);
	        }

	        if (shared) {
	            if (categoryIndex >= 0) {
	                var points = this._plotArea.pointsByCategoryIndex(categoryIndex);
	                tooltip.showAt(points);
	            }
	        } else if (point) {
	            tooltip.show(point);
	        }
	    },

	    hideTooltip: function() {
	        this._tooltip.hide();
	    },

	    _initSurface: function() {
	        var surface = this.surface;
	        var wrap = this._surfaceWrap();

	        var chartArea = this.options.chartArea || {};
	        if (chartArea.width) {
	            dataviz.elementSize(wrap, { width: chartArea.width });
	        }
	        if (chartArea.height) {
	            dataviz.elementSize(wrap, { height: chartArea.height });
	        }

	        if (!surface || surface.options.type !== this.options.renderAs) {
	            this._destroySurface();

	            this.surface = drawing.Surface.create(wrap, {
	                type: this.options.renderAs
	            });

	            this.surface.bind("mouseenter", this._surfaceMouseenterHandler);
	            this.surface.bind("mouseleave", this._surfaceMouseleaveHandler);

	        } else {
	            this.surface.clear();
	            this.surface.resize();
	        }
	    },

	    _surfaceWrap: function() {
	        return this.element;
	    },

	    _redraw: function() {
	        var model = this._getModel();
	        this._size = {
	            width: model.options.width,
	            height: model.options.height
	        };

	        this._destroyView();

	        this._model = model;
	        this._plotArea = model._plotArea;

	        model.renderVisual();

	        if (this.options.transitions !== false) {
	            model.traverse(function(element) {
	                if (element.animation) {
	                    element.animation.setup();
	                }
	            });
	        }

	        this._initSurface();
	        this.surface.draw(model.visual);

	        if (this.options.transitions !== false) {
	            model.traverse(function(element) {
	                if (element.animation) {
	                    element.animation.play();
	                }
	            });
	        }

	        this._tooltip = this._createTooltip();
	        this._highlight = new Highlight();
	        this._setupSelection();
	        this._createPannable();
	        this._createZoomSelection();
	        this._createMousewheelZoom();

	        this.trigger(RENDER);
	        triggerPaneRender(this._plotArea.panes);

	        if (!this._navState) {
	            this._cancelDomEvents();
	        }
	    },

	    exportVisual: function(exportOptions) {
	        var visual;
	        if (exportOptions && (exportOptions.width || exportOptions.height || exportOptions.options)) {
	            var currentOptions = this.options;
	            var options = deepExtend({}, exportOptions.options, {
	                chartArea: {
	                    width: exportOptions.width,
	                    height: exportOptions.height
	                }
	            });

	            clearMissingValues(this._originalOptions, options);
	            this.options = deepExtend({}, this._originalOptions, options);
	            this._initTheme(this.options, this._theme);
	            this.bindCategories();

	            var model = this._getModel();

	            model.renderVisual();
	            triggerPaneRender(model._plotArea.panes);

	            visual = model.visual;

	            this.options = currentOptions;
	        } else {
	            visual = this.surface.exportVisual();
	        }

	        return visual;
	    },

	    _sharedTooltip: function() {
	        return this._plotArea instanceof CategoricalPlotArea && this.options.tooltip && this.options.tooltip.shared;
	    },

	    _createPannable: function() {
	        var options = this.options;
	        if (options.pannable !== false) {
	            this._pannable = new Pannable(this._plotArea, options.pannable);
	        }
	    },

	    _createZoomSelection: function() {
	        var zoomable = this.options.zoomable;
	        var selection = (zoomable || {}).selection;
	        if (zoomable !== false && selection !== false) {
	            this._zoomSelection = new ZoomSelection(this, selection);
	        }
	    },

	    _createMousewheelZoom: function() {
	        var zoomable = this.options.zoomable;
	        var mousewheel = (zoomable || {}).mousewheel;
	        if (zoomable !== false && mousewheel !== false) {
	            this._mousewheelZoom = new MousewheelZoom(this, mousewheel);
	        }
	    },

	    _toggleDragZoomEvents: function() {
	        var pannable = this.options.pannable;
	        var zoomable = this.options.zoomable;
	        var selection = (zoomable || {}).selection;
	        var mousewheel = (zoomable || {}).mousewheel;
	        var allowDrag = !pannable && (zoomable === false || selection === false) && !this.requiresHandlers([ DRAG_START, DRAG, DRAG_END ]);
	        var allowZoom = (zoomable === false || mousewheel === false) && !this.requiresHandlers([ ZOOM_START, ZOOM, ZOOM_END ]);
	        var element = this.element;

	        if (this._dragZoomEnabled && allowDrag && allowZoom) {
	            element.style.touchAction = this._touchAction || '';
	            this._dragZoomEnabled = false;
	        } else if (!this._dragZoomEnabled && !(allowDrag && allowZoom)) {
	            element.style.touchAction = "none";

	            this._dragZoomEnabled = true;
	        }

	        this._toggleDomEvents(!allowDrag, !allowZoom);
	    },

	    _toggleDomEvents: function(drag, zoom) {
	        var domEvents = this.domEvents;
	        if (!domEvents) {
	            return;
	        }

	        if (domEvents.toggleDrag) {
	            domEvents.toggleDrag(drag);
	        }

	        if (domEvents.toggleZoom) {
	            domEvents.toggleZoom(zoom);
	        }
	    },

	    _createTooltip: function() {
	        var ref = this;
	        var tooltipOptions = ref.options.tooltip;
	        var tooltip;

	        if (this._sharedTooltip()) {
	            tooltip = this._createSharedTooltip(tooltipOptions);
	        } else {
	            tooltip = new Tooltip(this.chartService, tooltipOptions);
	        }

	        return tooltip;
	    },

	    _createSharedTooltip: function(options) {
	        return new SharedTooltip(this._plotArea, options);
	    },

	    applyDefaults: function(options, themeOptions) {
	        applyAxisDefaults(options, themeOptions);
	        applySeriesDefaults(options, themeOptions);
	    },

	    applySeriesColors: function() {
	        var options = this.options;
	        var series = options.series;
	        var colors = options.seriesColors || [];

	        for (var i = 0; i < series.length; i++) {
	            var currentSeries = series[i];
	            var seriesColor = colors[i % colors.length];
	            var defaults = currentSeries._defaults;

	            currentSeries.color = currentSeries.color || seriesColor;
	            if (defaults) {
	                defaults.color = defaults.color || seriesColor;
	            }
	        }
	    },

	    _getModel: function() {
	        var options = this.options;
	        var plotArea = this._createPlotArea();
	        var model = new dataviz.RootElement(this._modelOptions());
	        model.chart = this;
	        model._plotArea = plotArea;

	        dataviz.Title.buildTitle(options.title, model);

	        if (options.legend && options.legend.visible) {
	            model.append(new Legend(plotArea.options.legend, this.chartService));
	        }
	        model.append(plotArea);
	        model.reflow();

	        return model;
	    },

	    _modelOptions: function() {
	        var options = this.options;
	        var size = this.getSize();

	        return deepExtend({
	            transitions: options.transitions,
	            width: size.width || datavizConstants.DEFAULT_WIDTH,
	            height: size.height || datavizConstants.DEFAULT_HEIGHT
	        }, options.chartArea);
	    },

	    _createPlotArea: function(skipSeries) {
	        var options = this.options;

	        var plotArea = PlotAreaFactory.current.create(skipSeries ? [] : options.series, options, this.chartService);

	        return plotArea;
	    },

	    _setupSelection: function() {
	        var this$1 = this;

	        var ref = this;
	        var axes = ref._plotArea.axes;
	        var selections = this._selections = [];

	        for (var i = 0; i < axes.length; i++) {
	            var axis = axes[i];
	            var options = axis.options;
	            if (axis instanceof CategoryAxis && options.select && !options.vertical) {
	                var range = axis.range();

	                var selection = new Selection(this$1, axis,
	                    deepExtend({ min: range.min, max: range.max }, options.select)
	                );

	                selections.push(selection);
	            }
	        }
	    },

	    _selectStart: function(e) {
	        return this.trigger(SELECT_START, e);
	    },

	    _select: function(e) {
	        return this.trigger(SELECT, e);
	    },

	    _selectEnd: function(e) {
	        return this.trigger(SELECT_END, e);
	    },

	    _initHandlers: function() {
	        this._clickHandler = this._click.bind(this);
	        this._mousewheelHandler = this._mousewheel.bind(this);
	        this._mouseleaveHandler = this._mouseleave.bind(this);
	        this._surfaceMouseenterHandler = this._mouseover.bind(this);
	        this._surfaceMouseleaveHandler = this._mouseout.bind(this);

	        this._mousemove = kendo.throttle(
	            this._mousemove.bind(this),
	            MOUSEMOVE_DELAY
	        );
	    },

	    addObserver: function(observer) {
	        if (observer) {
	            this.observers.push(observer);
	        }
	    },

	    removeObserver: function(observer) {
	        var index = this.observers.indexOf(observer);
	        if (index >= 0) {
	            this.observers.splice(index, 1);
	        }
	    },

	    requiresHandlers: function(eventNames) {
	        var observers = this.observers;
	        for (var idx = 0; idx < observers.length; idx++) {
	            if (observers[idx].requiresHandlers(eventNames)) {
	                return true;
	            }
	        }
	    },

	    trigger: function(name, args) {
	        if (args === void 0) { args = {}; }

	        if (name === SHOW_TOOLTIP) {
	            args.anchor.point = this._toDocumentCoordinates(args.anchor.point);
	        }
	        args.sender = this;

	        var observers = this.observers;
	        var isDefaultPrevented = false;
	        for (var idx = 0; idx < observers.length; idx++) {
	            if (observers[idx].trigger(name, args)) {
	                isDefaultPrevented = true;
	            }
	        }

	        return isDefaultPrevented;
	    },

	    _attachEvents: function() {
	        var element = this.element;

	        this._touchAction = element.style.touchAction;

	        var obj;
	        bindEvents(element, ( obj = {}, obj[ CONTEXTMENU ] = this._clickHandler, obj[ MOUSEWHEEL ] = this._mousewheelHandler, obj[ MOUSELEAVE ] = this._mouseleaveHandler, obj ));

	        if (this._shouldAttachMouseMove()) {
	            var obj$1;
	            bindEvents(element, ( obj$1 = {}, obj$1[ MOUSEMOVE ] = this._mousemove, obj$1 ));
	        }

	        this.domEvents = services.DomEventsBuilder.create(this.element, {
	            start: this._start.bind(this),
	            move: this._move.bind(this),
	            end: this._end.bind(this),
	            tap: this._tap.bind(this),
	            gesturestart: this._gesturestart.bind(this),
	            gesturechange: this._gesturechange.bind(this),
	            gestureend: this._gestureend.bind(this)
	        });

	        this._toggleDragZoomEvents();
	    },

	    _mouseleave: function(e) {
	        if (this._hoveredPoint) {
	            this._hoveredPoint.out(this, e);
	            this._hoveredPoint = null;
	        }

	        if (this._plotArea.hovered) {
	            this.trigger(PLOT_AREA_LEAVE);
	            this._plotArea.hovered = false;
	        }
	    },

	    _cancelDomEvents: function() {
	        if (this.domEvents && this.domEvents.cancel) {
	            this.domEvents.cancel();
	        }
	    },

	    _gesturestart: function(e) {
	        if (this._mousewheelZoom && !this._stopChartHandlers(e)) {
	            this._gestureDistance = e.distance;
	            this._unsetActivePoint();
	            this.surface.suspendTracking();
	        }
	    },

	    _gestureend: function(e) {
	        if (this._zooming && !this._stopChartHandlers(e)) {
	            if (this.surface) {
	                this.surface.resumeTracking();
	            }
	            this._zooming = false;
	            this.trigger(ZOOM_END, {});
	        }
	    },

	    _gesturechange: function(e) {
	        var mousewheelZoom = this._mousewheelZoom;

	        if (mousewheelZoom && !this._stopChartHandlers(e)) {
	            e.preventDefault();
	            var previousGestureDistance = this._gestureDistance;
	            var scaleDelta = -e.distance / previousGestureDistance + 1;

	            if (Math.abs(scaleDelta) >= 0.1) {
	                scaleDelta = Math.round(scaleDelta * 10);

	                this._gestureDistance = e.distance;
	                var args = { delta: scaleDelta, axisRanges: axisRanges(this._plotArea.axes), originalEvent: e };
	                if (this._zooming || !this.trigger(ZOOM_START, args)) {

	                    if (!this._zooming) {
	                        this._zooming = true;
	                    }

	                    var ranges = args.axisRanges = mousewheelZoom.updateRanges(scaleDelta);
	                    if (ranges && !this.trigger(ZOOM, args)) {
	                        mousewheelZoom.zoom();
	                    }
	                }
	            }
	        }
	    },

	    _mouseout: function(e) {
	        if (e.element) {
	            var element = this._drawingChartElement(e.element, e);

	            if (element && element.leave) {
	                element.leave(this, e.originalEvent);
	            }
	        }
	    },

	    _start: function(e) {
	        var coords = this._eventCoordinates(e);

	        if (this._stopChartHandlers(e) || !this._plotArea.backgroundContainsPoint(coords)) {
	            return;
	        }

	        if (this.requiresHandlers([ DRAG_START, DRAG, DRAG_END ])) {
	            this._startNavigation(e, coords, DRAG_START);
	        }

	        if (this._pannable && this._pannable.start(e)) {
	            this.surface.suspendTracking();
	            this._unsetActivePoint();
	            this._suppressHover = true;
	            this.chartService.panning = true;
	        }

	        if (this._zoomSelection) {
	            if (this._zoomSelection.start(e)) {
	                this.trigger(ZOOM_START, { axisRanges: axisRanges(this._plotArea.axes), originalEvent: e });
	            }
	        }
	    },

	    _move: function(e) {
	        var ref = this;
	        var state = ref._navState;
	        var pannable = ref._pannable;

	        if (this._stopChartHandlers(e)) {
	            return;
	        }

	        if (pannable) {
	            var ranges = pannable.move(e);

	            if (ranges && !this.trigger(DRAG, { axisRanges: ranges, originalEvent: e })) {
	                pannable.pan();
	            }
	        } else if (state) {
	            var ranges$1 = {};
	            var axes = state.axes;

	            for (var i = 0; i < axes.length; i++) {
	                var currentAxis = axes[i];
	                var axisName = currentAxis.options.name;
	                if (axisName) {
	                    var axis = currentAxis.options.vertical ? e.y : e.x;
	                    var delta = axis.startLocation - axis.location;

	                    if (delta !== 0) {
	                        ranges$1[currentAxis.options.name] = currentAxis.translateRange(delta);
	                    }
	                }
	            }

	            state.axisRanges = ranges$1;
	            this.trigger(DRAG, {
	                axisRanges: ranges$1,
	                originalEvent: e
	            });
	        }

	        if (this._zoomSelection) {
	            this._zoomSelection.move(e);
	        }
	    },

	    _end: function(e) {
	        if (this._stopChartHandlers(e)) {
	            return;
	        }

	        var pannable = this._pannable;
	        if (pannable && pannable.end(e)) {
	            this.surface.resumeTracking();
	            this.trigger(DRAG_END, {
	                axisRanges: axisRanges(this._plotArea.axes),
	                originalEvent: e
	            });
	            this._suppressHover = false;
	            this.chartService.panning = false;
	        } else {
	            this._endNavigation(e, DRAG_END);
	        }

	        if (this._zoomSelection) {
	            var ranges = this._zoomSelection.end(e);
	            if (ranges && !this.trigger(ZOOM, { axisRanges: ranges, originalEvent: e })) {
	                this._zoomSelection.zoom();
	                this.trigger(ZOOM_END, { axisRanges: ranges, originalEvent: e });
	            }
	        }
	    },

	    _stopChartHandlers: function(e) {
	        var selections = this._selections || [];
	        if (!selections.length) {
	            return false;
	        }

	        var coords = this._eventCoordinates(e);
	        var pane = this._plotArea.paneByPoint(coords);
	        if (pane) {
	            for (var idx = 0; idx < selections.length; idx++) {
	                if (selections[idx].onPane(pane)) {
	                    return true;
	                }
	            }
	        }
	    },

	    _mousewheel: function(e) {
	        var this$1 = this;

	        var delta = dataviz.mousewheelDelta(e);
	        var mousewheelZoom = this._mousewheelZoom;
	        var coords = this._eventCoordinates(e);

	        if (this._stopChartHandlers(e) || !this._plotArea.backgroundContainsPoint(coords)) {
	            return;
	        }

	        if (mousewheelZoom) {
	            var args = { delta: delta, axisRanges: axisRanges(this._plotArea.axes), originalEvent: e };
	            if (this._zooming || !this.trigger(ZOOM_START, args)) {
	                e.preventDefault();

	                if (!this._zooming) {
	                    this._unsetActivePoint();
	                    this.surface.suspendTracking();
	                    this._zooming = true;
	                }

	                if (this._mwTimeout) {
	                    clearTimeout(this._mwTimeout);
	                }

	                args.axisRanges = mousewheelZoom.updateRanges(delta);
	                if (args.axisRanges && !this.trigger(ZOOM, args)) {
	                    mousewheelZoom.zoom();
	                }

	                this._mwTimeout = setTimeout(function () {
	                    this$1.trigger(ZOOM_END, args);
	                    this$1._zooming = false;
	                    if (this$1.surface) {
	                        this$1.surface.resumeTracking();
	                    }
	                }, MOUSEWHEEL_DELAY);
	            }
	        } else {
	            var state = this._navState;
	            if (!state) {
	                var prevented = this._startNavigation(e, coords, ZOOM_START);
	                if (!prevented) {
	                    state = this._navState;
	                }
	            }

	            if (state) {
	                var totalDelta = state.totalDelta || delta;
	                state.totalDelta = totalDelta + delta;

	                var axes = this._navState.axes;
	                var ranges = {};

	                for (var i = 0; i < axes.length; i++) {
	                    var currentAxis = axes[i];
	                    var axisName = currentAxis.options.name;
	                    if (axisName) {
	                        ranges[axisName] = currentAxis.scaleRange(-totalDelta);
	                    }
	                }

	                this.trigger(ZOOM, {
	                    delta: delta,
	                    axisRanges: ranges,
	                    originalEvent: e
	                });

	                if (this._mwTimeout) {
	                    clearTimeout(this._mwTimeout);
	                }

	                this._mwTimeout = setTimeout(function () {
	                    this$1._endNavigation(e, ZOOM_END);
	                }, MOUSEWHEEL_DELAY);
	            }
	        }
	    },

	    _startNavigation: function(e, coords, chartEvent) {
	        var plotArea = this._model._plotArea;
	        var pane = plotArea.findPointPane(coords);
	        var axes = plotArea.axes.slice(0);

	        if (!pane) {
	            return;
	        }

	        var ranges = axisRanges(axes);

	        var prevented = this.trigger(chartEvent, {
	            axisRanges: ranges,
	            originalEvent: e
	        });

	        if (prevented) {
	            this._cancelDomEvents();
	        } else {
	            this._suppressHover = true;
	            this._unsetActivePoint();
	            this._navState = {
	                axisRanges: ranges,
	                pane: pane,
	                axes: axes
	            };
	        }
	    },

	    _endNavigation: function(e, chartEvent) {
	        if (this._navState) {
	            this.trigger(chartEvent, {
	                axisRanges: this._navState.axisRanges,
	                originalEvent: e
	            });
	            this._suppressHover = false;
	            this._navState = null;
	        }
	    },

	    _getChartElement: function(e, match) {
	        var element = this.surface.eventTarget(e);
	        if (element) {
	            return this._drawingChartElement(element, e, match);
	        }
	    },

	    _drawingChartElement: function(element, e, match) {
	        var current = element;
	        var chartElement;
	        while (current && !chartElement) {
	            chartElement = current.chartElement;
	            current = current.parent;
	        }

	        if (chartElement) {
	            if (chartElement.aliasFor) {
	                chartElement = chartElement.aliasFor(e, this._eventCoordinates(e));
	            }

	            if (match) {
	                chartElement = chartElement.closest(match);
	                if (chartElement && chartElement.aliasFor) {
	                    chartElement = chartElement.aliasFor();
	                }
	            }

	            return chartElement;
	        }
	    },

	    _eventCoordinates: function(e) {
	        var coordinates = dataviz.eventCoordinates(e);
	        return this._toModelCoordinates(coordinates.x, coordinates.y);
	    },

	    _elementPadding: function() {
	        if (!this._padding) {
	            var ref = elementStyles(this.element, [ "paddingLeft", "paddingTop" ]);
	            var paddingLeft = ref.paddingLeft;
	            var paddingTop = ref.paddingTop;
	            this._padding = {
	                top: paddingTop,
	                left: paddingLeft
	            };
	        }

	        return this._padding;
	    },

	    _toDocumentCoordinates: function(point) {
	        var padding = this._elementPadding();
	        var offset = dataviz.elementOffset(this.element);

	        return {
	            left: round(point.x + padding.left + offset.left),
	            top: round(point.y + padding.top + offset.top)
	        };
	    },

	    _toModelCoordinates: function(clientX, clientY) {
	        var element = this.element;
	        var offset = dataviz.elementOffset(element);
	        var padding = this._elementPadding();
	        var inverseTransform = dataviz.elementScale(element).invert();
	        var point = new GeometryPoint(
	            clientX - offset.left - padding.left,
	            clientY - offset.top - padding.top
	        ).transform(inverseTransform);

	        return new Point(point.x, point.y);
	    },

	    _tap: function(e) {
	        var this$1 = this;

	        var drawingElement = this.surface.eventTarget(e);
	        var element = this._drawingChartElement(drawingElement, e);
	        var sharedTooltip = this._sharedTooltip();

	        if (!this._startHover(drawingElement, e) && !sharedTooltip) {
	            this._unsetActivePoint();
	        }

	        if (sharedTooltip) {
	            this._trackSharedTooltip(this._eventCoordinates(e), e, true);
	        }

	        this._propagateClick(element, e);

	        //part of fix for hover issue on windows touch
	        this.handlingTap = true;
	        setTimeout(function () {
	            this$1.handlingTap = false;
	        }, 0);
	    },

	    _click: function(e) {
	        var element = this._getChartElement(e);
	        this._propagateClick(element, e);
	    },

	    _propagateClick: function(element, e) {
	        var this$1 = this;

	        var current = element;
	        while (current) {
	            if (current.click) {
	                current.click(this$1, e);
	            }

	            current = current.parent;
	        }
	    },

	    _startHover: function(element, e) {
	        if (this._suppressHover) {
	            return false;
	        }

	        var point = this._drawingChartElement(element, e, function(element) {
	            return (element.hover || element.over) && !(element instanceof PlotAreaBase);
	        });

	        var activePoint = this._activePoint;
	        var hoveredPoint = this._hoveredPoint;

	        if (hoveredPoint && hoveredPoint !== point) {
	            hoveredPoint.out(this, e);
	            this._hoveredPoint = null;
	        }

	        if (point && hoveredPoint !== point && point.over) {
	            this._hoveredPoint = point;
	            point.over(this, e);
	        }

	        if (point && activePoint !== point && point.hover) {
	            this._activePoint = point;

	            if (!this._sharedTooltip() && !point.hover(this, e)) {
	                var tooltipOptions = deepExtend({}, this.options.tooltip, point.options.tooltip);
	                if (tooltipOptions.visible) {
	                    this._tooltip.show(point);
	                }

	                this._highlight.show(point);
	            }
	        }

	        return point;
	    },

	    _mouseover: function(e) {
	        var point = this._startHover(e.element, e.originalEvent);

	        if (point && point.tooltipTracking && !this._mouseMoveTrackHandler && !this._sharedTooltip()) {
	            this._mouseMoveTrackHandler = this._mouseMoveTracking.bind(this);
	            var obj;
	            bindEvents(document, ( obj = {}, obj[ MOUSEMOVE ] = this._mouseMoveTrackHandler, obj ));
	        }
	    },

	    _mouseMoveTracking: function(e) {
	        var ref = this;
	        var options = ref.options;
	        var tooltip = ref._tooltip;
	        var highlight = ref._highlight;
	        var point = ref._activePoint;
	        var coords = this._eventCoordinates(e);

	        if (this._plotArea.box.containsPoint(coords)) {
	            if (point && point.tooltipTracking && point.series && point.parent.getNearestPoint) {
	                var seriesPoint = point.parent.getNearestPoint(coords.x, coords.y, point.seriesIx);
	                if (seriesPoint && seriesPoint !== point) {
	                    this._activePoint = seriesPoint;

	                    if (!seriesPoint.hover(this, e)) {
	                        var tooltipOptions = deepExtend({}, options.tooltip, seriesPoint.options.tooltip);
	                        if (tooltipOptions.visible) {
	                            tooltip.show(seriesPoint);
	                        }

	                        highlight.show(seriesPoint);
	                    }
	                }
	            }
	        } else {
	            var obj;
	            unbindEvents(document, ( obj = {}, obj[ MOUSEMOVE ] = this._mouseMoveTrackHandler, obj ));
	            this._unsetActivePoint();
	            this._mouseMoveTrackHandler = null;
	        }
	    },

	    _mousemove: function(e) {
	        var coords = this._eventCoordinates(e);
	        var plotArea = this._plotArea;

	        this._trackCrosshairs(coords);

	        if (plotArea.hover) {
	            var overPlotArea = plotArea.backgroundContainsPoint(coords);
	            if (overPlotArea) {
	                plotArea.hovered = true;
	                this._plotArea.hover(this, e);
	            } else if (plotArea.hovered && !overPlotArea) {
	                this.trigger(PLOT_AREA_LEAVE);
	                plotArea.hovered = false;
	            }
	        }

	        if (this._sharedTooltip()) {
	            this._trackSharedTooltip(coords, e);
	        }
	    },

	    _trackCrosshairs: function(coords) {
	        var crosshairs = this._plotArea.crosshairs;

	        for (var i = 0; i < crosshairs.length; i++) {
	            var current = crosshairs[i];

	            if (current.box.containsPoint(coords)) {
	                current.showAt(coords);
	            } else {
	                current.hide();
	            }
	        }
	    },

	    _trackSharedTooltip: function(coords, e, toggle) {
	        if (this._suppressHover) {
	            return;
	        }

	        var ref = this;
	        var tooltipOptions = ref.options.tooltip;
	        var plotArea = ref._plotArea;
	        var categoryAxis = ref._plotArea.categoryAxis;
	        var tooltip = ref._tooltip;
	        var highlight = ref._highlight;

	        if (plotArea.backgroundContainsPoint(coords)) {
	            var index = categoryAxis.pointCategoryIndex(coords);
	            if (index !== this._tooltipCategoryIx || (!this._sharedHighlight && toggle)) {
	                var points = plotArea.pointsByCategoryIndex(index);
	                var pointArgs = points.map(function(point) {
	                    return point.eventArgs(e);
	                });
	                var hoverArgs = pointArgs[0] || {};
	                hoverArgs.categoryPoints = pointArgs;

	                if (points.length > 0 && !this.trigger(SERIES_HOVER, hoverArgs)) {
	                    if (tooltipOptions.visible) {
	                        tooltip.showAt(points, coords);
	                    }

	                    highlight.show(points);

	                    this._sharedHighlight = true;
	                } else {
	                    tooltip.hide();
	                }

	                this._tooltipCategoryIx = index;
	            } else if (toggle && this._sharedHighlight) {
	                highlight.hide();
	                tooltip.hide();
	                this._sharedHighlight = false;
	            }
	        } else if (this._sharedHighlight) {
	            highlight.hide();
	            tooltip.hide();
	            this._tooltipCategoryIx = null;
	            this._sharedHighlight = false;
	        }
	    },

	    hideElements: function(options) {
	        var plotArea = this._plotArea;
	        this._mousemove.cancel();

	        plotArea.hideCrosshairs();

	        this._unsetActivePoint(options);
	    },

	    _unsetActivePoint: function(options) {
	        var ref = this;
	        var tooltip = ref._tooltip;
	        var highlight = ref._highlight;

	        this._activePoint = null;
	        this._hoveredPoint = null;

	        if (tooltip && !(options && options.keepTooltipOpen)) {
	            tooltip.hide();
	        }

	        this._tooltipCategoryIx = null;
	        this._sharedHighlight = false;

	        if (highlight) {
	            highlight.hide();
	        }
	    },

	    _deferRedraw: function() {
	        this._redraw();
	    },

	    _clearRedrawTimeout: function() {
	        if (this._redrawTimeout) {
	            clearInterval(this._redrawTimeout);
	            this._redrawTimeout = null;
	        }
	    },

	    bindCategories: function() {
	        var this$1 = this;

	        var options = this.options;
	        var definitions = [].concat(options.categoryAxis);

	        for (var axisIx = 0; axisIx < definitions.length; axisIx++) {
	            var axis = definitions[axisIx];
	            if (axis.autoBind !== false) {
	                this$1.bindCategoryAxisFromSeries(axis, axisIx);
	            }
	        }
	    },

	    bindCategoryAxisFromSeries: function(axis, axisIx) {
	        var this$1 = this;

	        var series = this.options.series;
	        var seriesLength = series.length;
	        var uniqueCategories = new dataviz.HashMap();//perf improvement in case type category with dates
	        var items = [];
	        var bindable = false;
	        var dateAxis;

	        for (var seriesIx = 0; seriesIx < seriesLength; seriesIx++) {
	            var s = series[seriesIx];
	            var onAxis = s.categoryAxis === axis.name || (!s.categoryAxis && axisIx === 0);
	            var data = s.data;
	            var dataLength = data.length;
	            var bind = s.categoryField && onAxis;
	            bindable = bind || bindable;

	            if (bind && dataLength > 0) {
	                dateAxis = isDateAxis(axis, getField(s.categoryField, data[0]));

	                var getFn = dateAxis ? getDateField : getField;

	                for (var dataIx = 0; dataIx < dataLength; dataIx++) {
	                    var dataRow = data[dataIx];
	                    var category = getFn(s.categoryField, dataRow, this$1.chartService.intl);

	                    if (dateAxis || !uniqueCategories.get(category)) {
	                        items.push([ category, dataRow ]);

	                        if (!dateAxis) {
	                            uniqueCategories.set(category, true);
	                        }
	                    }
	                }
	            }
	        }

	        if (items.length > 0) {
	            if (dateAxis) {
	                items = uniqueDates(items, function(a, b) {
	                    return dataviz.dateComparer(a[0], b[0]);
	                });
	            }

	            var result = transpose(items);
	            axis.categories = result[0];
	        } else if (bindable) {
	            axis.categories = [];
	        }
	    },

	    _isBindable: function(series) {
	        var valueFields = SeriesBinder.current.valueFields(series);
	        var result = true;

	        for (var i = 0; i < valueFields.length; i++) {
	            var field = valueFields[i];
	            if (field === VALUE) {
	                field = "field";
	            } else {
	                field = field + "Field";
	            }

	            if (!defined(series[field])) {
	                result = false;
	                break;
	            }
	        }

	        return result;
	    },

	    _noTransitionsRedraw: function() {
	        var options = this.options;
	        var transitionsState;

	        if (options.transitions !== false) {
	            options.transitions = false;
	            transitionsState = true;
	        }

	        this._redraw();

	        if (transitionsState) {
	            options.transitions = true;
	        }
	    },

	    _legendItemHover: function(seriesIndex, pointIndex) {
	        var ref = this;
	        var plotArea = ref._plotArea;
	        var highlight = ref._highlight;
	        var currentSeries = (plotArea.srcSeries || plotArea.series)[seriesIndex];
	        var items;

	        if (inArray(currentSeries.type, [ PIE, DONUT, FUNNEL ])) {
	            items = plotArea.findPoint(function(point) {
	                return point.series.index === seriesIndex && point.index === pointIndex;
	            });
	        } else {
	            items = plotArea.pointsBySeriesIndex(seriesIndex);
	        }

	        highlight.show(items);
	    },

	    _shouldAttachMouseMove: function() {
	        return this._plotArea.crosshairs.length || (this._tooltip && this._sharedTooltip()) || this.requiresHandlers([ PLOT_AREA_HOVER, PLOT_AREA_LEAVE ]);
	    },

	    updateMouseMoveHandler: function() {
	        var obj;
	        unbindEvents(this.element, ( obj = {}, obj[ MOUSEMOVE ] = this._mousemove, obj ));

	        if (this._shouldAttachMouseMove()) {
	            var obj$1;
	            bindEvents(this.element, ( obj$1 = {}, obj$1[ MOUSEMOVE ] = this._mousemove, obj$1 ));
	        }
	    },

	    applyOptions: function(options, theme) {
	        clearMissingValues(this._originalOptions, options);
	        this._originalOptions = deepExtend(this._originalOptions, options);
	        this.options = deepExtend({}, this._originalOptions);

	        if (theme) {
	            this._theme = theme;
	            this.chartService.theme = theme;
	        }
	        this._initTheme(this.options, this._theme);

	        this._toggleDragZoomEvents();
	    },

	    setOptions: function(options, theme) {
	        this.applyOptions(options, theme);
	        this.bindCategories();
	        this.redraw();
	        this.updateMouseMoveHandler();
	    },

	    setDirection: function(rtl) {
	        this.chartService.rtl = Boolean(rtl);
	        if (this.surface && this.surface.type === 'svg') {
	            this._destroySurface();
	        }
	    },

	    setIntlService: function(intl) {
	        this.chartService.intl = intl;
	    },

	    noTransitionsRedraw: function() {
	        this._noTransitionsRedraw();
	    },

	    destroy: function() {
	        this._destroyed = true;

	        var obj;
	        unbindEvents(this.element, ( obj = {}, obj[ CONTEXTMENU ] = this._clickHandler, obj[ MOUSEWHEEL ] = this._mousewheelHandler, obj[ MOUSEMOVE ] = this._mousemove, obj[ MOUSELEAVE ] = this._mouseleaveHandler, obj ));

	        if (this.domEvents) {
	            this.domEvents.destroy();
	            delete this.domEvents;
	        }

	        if (this._mouseMoveTrackHandler) {
	            var obj$1;
	            unbindEvents(document, ( obj$1 = {}, obj$1[ MOUSEMOVE ] = this._mouseMoveTrackHandler, obj$1 ));
	        }

	        this._destroyView();

	        this._destroySurface();

	        this._clearRedrawTimeout();
	    },

	    _destroySurface: function() {
	        var surface = this.surface;
	        if (surface) {
	            surface.unbind("mouseenter", this._surfaceMouseenterHandler);
	            surface.unbind("mouseleave", this._surfaceMouseleaveHandler);
	            surface.destroy();

	            this.surface = null;
	        }
	    },

	    _destroySelections: function() {
	        var selections = this._selections;

	        if (selections) {
	            while (selections.length > 0) {
	                selections.shift().destroy();
	            }
	        }
	    },

	    _destroyView: function() {
	        var model = this._model;

	        if (model) {
	            model.destroy();
	            this._model = null;
	        }

	        this._unsetActivePoint();

	        this._destroySelections();

	        if (this._tooltip) {
	            this._tooltip.destroy();
	        }

	        if (this._highlight) {
	            this._highlight.destroy();
	        }

	        if (this._zoomSelection) {
	            this._zoomSelection.destroy();
	            delete this._zoomSelection;
	        }

	        if (this._pannable) {
	            this._pannable.destroy();
	            delete this._pannable;
	        }

	        if (this._mousewheelZoom) {
	            this._mousewheelZoom.destroy();
	            delete this._mousewheelZoom;
	        }
	    }
	});

	function resolveAxisAliases(options) {
	    var aliases = AXIS_NAMES;

	    for (var idx = 0; idx < aliases.length; idx++) {
	        var alias = aliases[idx] + "Axes";
	        if (options[alias]) {
	            options[aliases[idx] + "Axis"] = options[alias];
	            delete options[alias];
	        }
	    }
	}

	function pointByCategoryName(points, name) {
	    if (points) {
	        for (var idx = 0; idx < points.length; idx++) {
	            if (points[idx].category === name) {
	                return [ points[idx] ];
	            }
	        }
	    }
	}

	function applyAxisDefaults(options, themeOptions) {
	    var themeAxisDefaults = ((themeOptions || {}).axisDefaults) || {};
	    var axisName, axisDefaults, axes;

	    function mapAxisOptions(axisOptions) {
	        var axisColor = (axisOptions || {}).color || axisDefaults.color;
	        var result = deepExtend({},
	            themeAxisDefaults,
	            themeAxisDefaults[axisName],
	            axisDefaults,
	            axisDefaults[axisName], {
	                line: { color: axisColor },
	                labels: { color: axisColor },
	                title: { color: axisColor }
	            },
	            axisOptions
	        );

	        delete result[axisName];

	        return result;
	    }

	    for (var idx = 0; idx < AXIS_NAMES.length; idx++) {
	        axisName = AXIS_NAMES[idx] + "Axis";
	        axisDefaults = options.axisDefaults || {};
	        axes = [].concat(options[axisName]);

	        axes = axes.map(mapAxisOptions);

	        options[axisName] = axes.length > 1 ? axes : axes[0];
	    }
	}

	function applySeriesDefaults(options, themeOptions) {
	    var series = options.series;
	    var seriesLength = series.length;
	    var seriesDefaults = options.seriesDefaults;
	    var commonDefaults = deepExtend({}, options.seriesDefaults);
	    var themeSeriesDefaults = themeOptions ? deepExtend({}, themeOptions.seriesDefaults) : {};
	    var commonThemeDefaults = deepExtend({}, themeSeriesDefaults);

	    cleanupNestedSeriesDefaults(commonDefaults);
	    cleanupNestedSeriesDefaults(commonThemeDefaults);

	    for (var i = 0; i < seriesLength; i++) {
	        var seriesType = series[i].type || options.seriesDefaults.type;

	        var baseOptions = deepExtend(
	            { data: [] },
	            commonThemeDefaults,
	            themeSeriesDefaults[seriesType],
	            { tooltip: options.tooltip },
	            commonDefaults,
	            seriesDefaults[seriesType]
	        );

	        series[i]._defaults = baseOptions;
	        series[i] = deepExtend({}, baseOptions, series[i]);
	        series[i].data = series[i].data || [];
	    }
	}

	function cleanupNestedSeriesDefaults(seriesDefaults) {
	    delete seriesDefaults.bar;
	    delete seriesDefaults.column;
	    delete seriesDefaults.rangeColumn;
	    delete seriesDefaults.line;
	    delete seriesDefaults.verticalLine;
	    delete seriesDefaults.pie;
	    delete seriesDefaults.donut;
	    delete seriesDefaults.area;
	    delete seriesDefaults.verticalArea;
	    delete seriesDefaults.scatter;
	    delete seriesDefaults.scatterLine;
	    delete seriesDefaults.bubble;
	    delete seriesDefaults.candlestick;
	    delete seriesDefaults.ohlc;
	    delete seriesDefaults.boxPlot;
	    delete seriesDefaults.bullet;
	    delete seriesDefaults.verticalBullet;
	    delete seriesDefaults.polarArea;
	    delete seriesDefaults.polarLine;
	    delete seriesDefaults.radarArea;
	    delete seriesDefaults.radarLine;
	    delete seriesDefaults.waterfall;
	}

	function axisRanges(axes) {
	    var ranges = {};

	    for (var i = 0; i < axes.length; i++) {
	        var axis = axes[i];
	        var axisName = axis.options.name;
	        if (axisName) {
	            ranges[axisName] = axis.range();
	        }
	    }

	    return ranges;
	}

	function sortDates(dates, comparer) {
	    if (comparer === void 0) { comparer = dataviz.dateComparer; }

	    for (var i = 1, length = dates.length; i < length; i++) {
	        if (comparer(dates[i], dates[i - 1]) < 0) {
	            dates.sort(comparer);
	            break;
	        }
	    }

	    return dates;
	}

	function uniqueDates(srcDates, comparer) {
	    if (comparer === void 0) { comparer = dataviz.dateComparer; }

	    var dates = sortDates(srcDates, comparer);
	    var length = dates.length;
	    var result = length > 0 ? [ dates[0] ] : [];

	    for (var i = 1; i < length; i++) {
	        if (comparer(dates[i], last(result)) !== 0) {
	            result.push(dates[i]);
	        }
	    }

	    return result;
	}

	function transpose(rows) {
	    var rowCount = rows.length;
	    var result = [];

	    for (var rowIx = 0; rowIx < rowCount; rowIx++) {
	        var row = rows[rowIx];
	        var colCount = row.length;

	        for (var colIx = 0; colIx < colCount; colIx++) {
	            result[colIx] = result[colIx] || [];
	            result[colIx].push(row[colIx]);
	        }
	    }

	    return result;
	}

	var DATA_FIELDS = [ 'data', 'categories' ];

	function clearMissingValues(originalOptions, options) {
	    for (var field in options) {
	        if (!inArray(field, DATA_FIELDS) && options.hasOwnProperty(field)) {
	            var fieldValue = options[field];
	            var originalValue = originalOptions[field];
	            if (defined(originalValue)) {
	                var nullValue = fieldValue === null;
	                if ((nullValue || !defined(fieldValue))) {
	                    delete originalOptions[field];
	                    if (nullValue) {
	                        delete options[field];
	                    }
	                } else if (originalValue && isObject(fieldValue)) {
	                    if (isObject(originalValue)) {
	                        clearMissingValues(originalValue, fieldValue);
	                    }
	                }
	            }
	        }
	    }
	}

	function triggerPaneRender(panes) {
	    for (var idx = 0; idx < panes.length; idx++) {
	        panes[idx].notifyRender();
	    }
	}

	setDefaultOptions(Chart, {
	    renderAs: "",
	    chartArea: {},
	    legend: {
	        visible: true,
	        labels: {}
	    },
	    categoryAxis: {},
	    seriesDefaults: {
	        type: COLUMN,
	        data: [],
	        highlight: {
	            visible: true
	        },
	        labels: {},
	        negativeValues: {
	            visible: false
	        }
	    },
	    series: [],
	    seriesColors: null,
	    tooltip: {
	        visible: false
	    },
	    transitions: true,
	    valueAxis: {},
	    plotArea: {},
	    title: {},
	    xAxis: {},
	    yAxis: {},
	    panes: [ {} ],
	    pannable: false,
	    zoomable: false
	});

	kendo.deepExtend(kendo.dataviz, {
	    constants: constants,
	    Aggregates: Aggregates,
	    AreaChart: AreaChart,
	    AreaSegment: AreaSegment,
	    AxisGroupRangeTracker: AxisGroupRangeTracker,
	    Bar: Bar,
	    BarChart: BarChart,
	    BarLabel: BarLabel,
	    BoxPlotChart: BoxPlotChart,
	    BoxPlot: BoxPlot,
	    BubbleChart: BubbleChart,
	    Bullet: Bullet,
	    BulletChart: BulletChart,
	    CandlestickChart: CandlestickChart,
	    Candlestick: Candlestick,
	    CategoricalChart: CategoricalChart,
	    CategoricalErrorBar: CategoricalErrorBar,
	    CategoricalPlotArea: CategoricalPlotArea,
	    Chart: Chart,
	    ChartContainer: ChartContainer,
	    ClipAnimation: ClipAnimation,
	    ClusterLayout: ClusterLayout,
	    Crosshair: Crosshair,
	    CrosshairTooltip: CrosshairTooltip,
	    DefaultAggregates: DefaultAggregates,
	    DonutChart: DonutChart,
	    DonutPlotArea: DonutPlotArea,
	    DonutSegment: DonutSegment,
	    ErrorBarBase: ErrorBarBase,
	    ErrorRangeCalculator: ErrorRangeCalculator,
	    Highlight: Highlight,
	    SharedTooltip: SharedTooltip,
	    Legend: Legend,
	    LegendItem: LegendItem,
	    LegendLayout: LegendLayout,
	    LineChart: LineChart,
	    LinePoint: LinePoint,
	    LineSegment: LineSegment,
	    Pane: Pane,
	    PieAnimation: PieAnimation,
	    PieChart: PieChart,
	    PieChartMixin: PieChartMixin,
	    PiePlotArea: PiePlotArea,
	    PieSegment: PieSegment,
	    PlotAreaBase: PlotAreaBase,
	    PlotAreaEventsMixin: PlotAreaEventsMixin,
	    PlotAreaFactory: PlotAreaFactory,
	    PointEventsMixin: PointEventsMixin,
	    RangeBar: RangeBar,
	    RangeBarChart: RangeBarChart,
	    RangeAreaPoint: RangeAreaPoint,
	    RangeAreaChart: RangeAreaChart,
	    ScatterChart: ScatterChart,
	    ScatterErrorBar: ScatterErrorBar,
	    ScatterLineChart: ScatterLineChart,
	    Selection: Selection,
	    SeriesAggregator: SeriesAggregator,
	    SeriesBinder: SeriesBinder,
	    SplineSegment: SplineSegment,
	    SplineAreaSegment: SplineAreaSegment,
	    StackWrap: StackWrap,
	    Tooltip: Tooltip,
	    OHLCChart: OHLCChart,
	    OHLCPoint: OHLCPoint,
	    WaterfallChart: WaterfallChart,
	    WaterfallSegment: WaterfallSegment,
	    XYPlotArea: XYPlotArea,
	    MousewheelZoom: MousewheelZoom,
	    ZoomSelection: ZoomSelection,
	    Pannable: Pannable,
	    ChartAxis: ChartAxis,
	    ChartPane: ChartPane,
	    ChartPlotArea: ChartPlotArea,
	    findAxisByName: findAxisByName,
	    anyHasZIndex: anyHasZIndex,
	    appendIfNotNull: appendIfNotNull,
	    areNumbers: areNumbers,
	    bindSegments: bindSegments,
	    categoriesCount: categoriesCount,
	    countNumbers: countNumbers,
	    equalsIgnoreCase: equalsIgnoreCase,
	    evalOptions: evalOptions,
	    filterSeriesByType: filterSeriesByType,
	    getDateField: getDateField,
	    getField: getField,
	    hasGradientOverlay: hasGradientOverlay,
	    hasValue: hasValue,
	    isDateAxis: isDateAxis,
	    segmentVisible: segmentVisible,
	    singleItemOrArray: singleItemOrArray,
	    createOutOfRangePoints: createOutOfRangePoints
	});

	})(window.kendo.jQuery);

	}, __webpack_require__(3));

/***/ }),

/***/ 887:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 888:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Fv0e");

/***/ })

/******/ });

/***/ }),

/***/ "rbj2":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1341);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1045:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FTkt");

/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1341:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1045), __webpack_require__(1342), __webpack_require__(1343) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

	}) (function(){

	var __meta__ = { // jshint ignore:line
	    id: "pdf",
	    name: "PDF export",
	    description: "PDF Generation framework",
	    mixin: true,
	    category: "framework",
	    depends: [ "core", "drawing" ]
	};

	}, __webpack_require__(3));


/***/ }),

/***/ 1342:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("5dnc");

/***/ }),

/***/ 1343:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("HPXr");

/***/ })

/******/ });

/***/ }),

/***/ "rdB9":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(937);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 934:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("IPyL");

/***/ }),

/***/ 937:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/***********************************************************************
	 * WARNING: this file is auto-generated.  If you change it directly,
	 * your modifications will eventually be lost.  The source code is in
	 * `kendo-charts` repository, you should make your changes there and
	 * run `src-modules/sync.sh` in this repository.
	 */
	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(934)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function () {

	window.kendo.dataviz = window.kendo.dataviz || {};
	var dataviz = kendo.dataviz;
	var elementStyles = dataviz.elementStyles;
	var deepExtend = dataviz.deepExtend;
	var toTime = dataviz.toTime;
	var datavizConstants = dataviz.constants;
	var Chart = dataviz.Chart;
	var drawing = kendo.drawing;

	var FadeOutAnimation = drawing.Animation.extend({
	    setup: function() {
	        this._initialOpacity = parseFloat(elementStyles(this.element, 'opacity').opacity);
	    },

	    step: function(pos) {
	        elementStyles(this.element, {
	            opacity: String(dataviz.interpolateValue(this._initialOpacity, 0, pos))
	        });
	    },

	    abort: function() {
	        drawing.Animation.fn.abort.call(this);
	        elementStyles(this.element, {
	            display: 'none',
	            opacity: String(this._initialOpacity)
	        });
	    },

	    cancel: function() {
	        drawing.Animation.fn.abort.call(this);
	        elementStyles(this.element, {
	            opacity: String(this._initialOpacity)
	        });
	    }
	});

	function createDiv(className, style) {
	    var div = document.createElement("div");
	    div.className = className;
	    if (style) {
	        div.style.cssText = style;
	    }

	    return div;
	}

	var NavigatorHint = dataviz.Class.extend({
	    init: function(container, chartService, options) {

	        this.options = deepExtend({}, this.options, options);
	        this.container = container;
	        this.chartService = chartService;

	        var padding = elementStyles(container, [ "paddingLeft", "paddingTop" ]);
	        this.chartPadding = {
	            top: padding.paddingTop,
	            left: padding.paddingLeft
	        };

	        this.createElements();
	        container.appendChild(this.element);
	    },

	    createElements: function() {
	        var element = this.element = createDiv('k-navigator-hint', 'display: none; position: absolute; top: 1px; left: 1px;');
	        var tooltip = this.tooltip = createDiv('k-tooltip k-chart-tooltip');
	        var scroll = this.scroll = createDiv('k-scroll');

	        tooltip.innerHTML = '&nbsp;';

	        element.appendChild(tooltip);
	        element.appendChild(scroll);
	    },

	    show: function(from, to, bbox) {
	        var ref = this;
	        var element = ref.element;
	        var options = ref.options;
	        var scroll = ref.scroll;
	        var tooltip = ref.tooltip;
	        var middle = dataviz.toDate(toTime(from) + toTime(to - from) / 2);
	        var scrollWidth = bbox.width() * 0.4;
	        var minPos = bbox.center().x - scrollWidth;
	        var maxPos = bbox.center().x;
	        var posRange = maxPos - minPos;
	        var range = options.max - options.min;
	        var scale = posRange / range;
	        var offset = middle - options.min;
	        var text = this.chartService.intl.format(options.format, from, to);
	        var template = dataviz.getTemplate(options);

	        this.clearHideTimeout();

	        if (!this._visible) {
	            elementStyles(element, {
	                visibility: 'hidden',
	                display: 'block'
	            });
	            this._visible = true;
	        }

	        if (template) {
	            text = template({
	                from: from,
	                to: to
	            });
	        }

	        tooltip.innerHTML = text;
	        elementStyles(tooltip, {
	            left: bbox.center().x - tooltip.offsetWidth / 2,
	            top: bbox.y1
	        });

	        var tooltipStyle = elementStyles(tooltip, [ 'marginTop', 'borderTopWidth', 'height' ]);

	        elementStyles(scroll, {
	            width: scrollWidth,
	            left: minPos + offset * scale,
	            top: bbox.y1 + tooltipStyle.marginTop + tooltipStyle.borderTopWidth + tooltipStyle.height / 2
	        });

	        elementStyles(element, {
	            visibility: 'visible'
	        });
	    },

	    clearHideTimeout: function() {
	        if (this._hideTimeout) {
	            clearTimeout(this._hideTimeout);
	        }

	        if (this._hideAnimation) {
	            this._hideAnimation.cancel();
	        }
	    },

	    hide: function() {
	        var this$1 = this;

	        this.clearHideTimeout();

	        this._hideTimeout = setTimeout(function () {
	            this$1._visible = false;
	            this$1._hideAnimation = new FadeOutAnimation(this$1.element);
	            this$1._hideAnimation.setup();
	            this$1._hideAnimation.play();
	        }, this.options.hideDelay);
	    },

	    destroy: function() {
	        this.clearHideTimeout();
	        if (this.container) {
	            this.container.removeChild(this.element);
	        }
	        delete this.container;
	        delete this.chartService;
	        delete this.element;
	        delete this.tooltip;
	        delete this.scroll;
	    }
	});

	dataviz.setDefaultOptions(NavigatorHint, {
	    format: "{0:d} - {1:d}",
	    hideDelay: 500
	});

	var NAVIGATOR_PANE = "_navigator";
	var NAVIGATOR_AXIS = NAVIGATOR_PANE;

	var constants = {
		NAVIGATOR_AXIS: NAVIGATOR_AXIS,
		NAVIGATOR_PANE: NAVIGATOR_PANE
	};

	var ZOOM_ACCELERATION = 3;

	var Navigator = dataviz.Class.extend({
	    init: function(chart) {

	        this.chart = chart;
	        var options = this.options = deepExtend({}, this.options, chart.options.navigator);
	        var select = options.select;
	        if (select) {
	            select.from = this.parseDate(select.from);
	            select.to = this.parseDate(select.to);
	        }

	        if (!dataviz.defined(options.hint.visible)) {
	            options.hint.visible = options.visible;
	        }

	        var obj;
	        this.chartObserver = new dataviz.InstanceObserver(this, ( obj = {}, obj[datavizConstants.DRAG] = '_drag', obj[datavizConstants.DRAG_END] = '_dragEnd', obj[datavizConstants.ZOOM] = '_zoom', obj[datavizConstants.ZOOM_END] = '_zoomEnd', obj ));
	        chart.addObserver(this.chartObserver);
	    },

	    parseDate: function(value) {
	        return dataviz.parseDate(this.chart.chartService.intl, value);
	    },

	    clean: function() {
	        if (this.selection) {
	            this.selection.destroy();
	            this.selection = null;
	        }

	        if (this.hint) {
	            this.hint.destroy();
	            this.hint = null;
	        }
	    },

	    destroy: function() {
	        if (this.chart) {
	            this.chart.removeObserver(this.chartObserver);
	            delete this.chart;
	        }

	        this.clean();
	    },

	    redraw: function() {
	        this._redrawSelf();
	        this.initSelection();
	    },

	    initSelection: function() {
	        var ref = this;
	        var chart = ref.chart;
	        var options = ref.options;
	        var axis = this.mainAxis();
	        var ref$1 = axis.roundedRange();
	        var min = ref$1.min;
	        var max = ref$1.max;
	        var ref$2 = options.select;
	        var from = ref$2.from;
	        var to = ref$2.to;
	        var mousewheel = ref$2.mousewheel;
	        var axisClone = clone(axis);

	        if (axis.categoriesCount() === 0) {
	            return;
	        }

	        this.clean();

	        // "Freeze" the selection axis position until the next redraw
	        axisClone.box = axis.box;

	        this.selection = new dataviz.Selection(chart, axisClone, {
	            min: min,
	            max: max,
	            from: from || min,
	            to: to || max,
	            mousewheel: dataviz.valueOrDefault(mousewheel, { zoom: "left" }),
	            visible: options.visible
	        }, new dataviz.InstanceObserver(this, {
	            selectStart: '_selectStart',
	            select: '_select',
	            selectEnd: '_selectEnd'
	        }));

	        if (options.hint.visible) {
	            this.hint = new NavigatorHint(chart.element, chart.chartService, {
	                min: min,
	                max: max,
	                template: dataviz.getTemplate(options.hint),
	                format: options.hint.format
	            });
	        }
	    },

	    setRange: function() {
	        var plotArea = this.chart._createPlotArea(true);
	        var axis = plotArea.namedCategoryAxes[NAVIGATOR_AXIS];

	        var ref = axis.roundedRange();
	        var min = ref.min;
	        var max = ref.max;

	        var select = this.options.select || {};
	        var from = select.from || min;
	        if (from < min) {
	            from = min;
	        }

	        var to = select.to || max;
	        if (to > max) {
	            to = max;
	        }

	        this.options.select = deepExtend({}, select, {
	            from: from,
	            to: to
	        });

	        this.filterAxes();
	    },

	    _redrawSelf: function(silent) {
	        var plotArea = this.chart._plotArea;

	        if (plotArea) {
	            plotArea.redraw(dataviz.last(plotArea.panes), silent);
	        }
	    },

	    redrawSlaves: function() {
	        var chart = this.chart;
	        var plotArea = chart._plotArea;
	        var slavePanes = plotArea.panes.slice(0, -1);

	        // Update the original series and categoryAxis before partial refresh.
	        plotArea.srcSeries = chart.options.series;
	        plotArea.options.categoryAxis = chart.options.categoryAxis;
	        plotArea.clearSeriesPointsCache();

	        plotArea.redraw(slavePanes);
	    },

	    _drag: function(e) {
	        var ref = this;
	        var chart = ref.chart;
	        var selection = ref.selection;
	        var coords = chart._eventCoordinates(e.originalEvent);
	        var navigatorAxis = this.mainAxis();
	        var naviRange = navigatorAxis.roundedRange();
	        var inNavigator = navigatorAxis.pane.box.containsPoint(coords);
	        var axis = chart._plotArea.categoryAxis;
	        var range = e.axisRanges[axis.options.name];
	        var select = this.options.select;
	        var duration;

	        if (!range || inNavigator || !selection) {
	            return;
	        }

	        if (select.from && select.to) {
	            duration = toTime(select.to) - toTime(select.from);
	        } else {
	            duration = toTime(selection.options.to) - toTime(selection.options.from);
	        }

	        var from = dataviz.toDate(dataviz.limitValue(
	            toTime(range.min),
	            naviRange.min, toTime(naviRange.max) - duration
	        ));

	        var to = dataviz.toDate(dataviz.limitValue(
	            toTime(from) + duration,
	            toTime(naviRange.min) + duration, naviRange.max
	        ));

	        this.options.select = { from: from, to: to };

	        if (this.options.liveDrag) {
	            this.filterAxes();
	            this.redrawSlaves();
	        }

	        selection.set(from, to);

	        this.showHint(from, to);
	    },

	    _dragEnd: function() {
	        this.filterAxes();
	        this.filter();
	        this.redrawSlaves();

	        if (this.hint) {
	            this.hint.hide();
	        }
	    },

	    readSelection: function() {
	        var ref = this;
	        var ref_selection_options = ref.selection.options;
	        var from = ref_selection_options.from;
	        var to = ref_selection_options.to;
	        var select = ref.options.select;

	        select.from = from;
	        select.to = to;
	    },

	    filterAxes: function() {
	        var ref = this;
	        var select = ref.options.select; if (select === void 0) { select = { }; }
	        var chart = ref.chart;
	        var allAxes = chart.options.categoryAxis;
	        var from = select.from;
	        var to = select.to;

	        for (var idx = 0; idx < allAxes.length; idx++) {
	            var axis = allAxes[idx];
	            if (axis.pane !== NAVIGATOR_PANE) {
	                axis.min = from;
	                axis.max = to;
	            }
	        }
	    },

	    filter: function() {
	        var ref = this;
	        var chart = ref.chart;
	        var select = ref.options.select;

	        if (!chart.requiresHandlers([ "navigatorFilter" ])) {
	            return;
	        }

	        var mainAxis = this.mainAxis();
	        var args = {
	            from: select.from,
	            to: select.to
	        };

	        if (mainAxis.options.type !== 'category') {
	            var axisOptions = new dataviz.DateCategoryAxis(deepExtend({
	                baseUnit: "fit"
	            }, chart.options.categoryAxis[0], {
	                categories: [ select.from, select.to ]
	            }), chart.chartService).options;

	            args.from = dataviz.addDuration(axisOptions.min, -axisOptions.baseUnitStep, axisOptions.baseUnit);
	            args.to = dataviz.addDuration(axisOptions.max, axisOptions.baseUnitStep, axisOptions.baseUnit);
	        }

	        this.chart.trigger("navigatorFilter", args);
	    },

	    _zoom: function(e) {
	        var ref = this;
	        var axis = ref.chart._plotArea.categoryAxis;
	        var selection = ref.selection;
	        var ref_options = ref.options;
	        var select = ref_options.select;
	        var liveDrag = ref_options.liveDrag;
	        var mainAxis = this.mainAxis();
	        var delta = e.delta;

	        if (!selection) {
	            return;
	        }

	        var fromIx = mainAxis.categoryIndex(selection.options.from);
	        var toIx = mainAxis.categoryIndex(selection.options.to);

	        e.originalEvent.preventDefault();

	        if (Math.abs(delta) > 1) {
	            delta *= ZOOM_ACCELERATION;
	        }

	        if (toIx - fromIx > 1) {
	            selection.expand(delta);
	            this.readSelection();
	        } else {
	            axis.options.min = select.from;
	            select.from = axis.scaleRange(-e.delta).min;
	        }

	        if (liveDrag) {
	            this.filterAxes();
	            this.redrawSlaves();
	        }

	        selection.set(select.from, select.to);

	        this.showHint(this.options.select.from, this.options.select.to);
	    },

	    _zoomEnd: function(e) {
	        this._dragEnd(e);
	    },

	    showHint: function(from, to) {
	        var plotArea = this.chart._plotArea;

	        if (this.hint) {
	            this.hint.show(from, to, plotArea.backgroundBox());
	        }
	    },

	    _selectStart: function(e) {
	        return this.chart._selectStart(e);
	    },

	    _select: function(e) {
	        this.showHint(e.from, e.to);

	        return this.chart._select(e);
	    },

	    _selectEnd: function(e) {
	        if (this.hint) {
	            this.hint.hide();
	        }

	        this.readSelection();
	        this.filterAxes();
	        this.filter();
	        this.redrawSlaves();

	        return this.chart._selectEnd(e);
	    },

	    mainAxis: function() {
	        var plotArea = this.chart._plotArea;

	        if (plotArea) {
	            return plotArea.namedCategoryAxes[NAVIGATOR_AXIS];
	        }
	    },

	    select: function(from, to) {
	        var select = this.options.select;

	        if (from && to) {
	            select.from = this.parseDate(from);
	            select.to = this.parseDate(to);

	            this.filterAxes();
	            this.filter();
	            this.redrawSlaves();

	            this.selection.set(from, to);
	        }

	        return {
	            from: select.from,
	            to: select.to
	        };
	    }
	});

	Navigator.setup = function(options, themeOptions) {
	    if (options === void 0) { options = {}; }
	    if (themeOptions === void 0) { themeOptions = {}; }

	    if (options.__navi) {
	        return;
	    }
	    options.__navi = true;

	    var naviOptions = deepExtend({}, themeOptions.navigator, options.navigator);
	    var panes = options.panes = [].concat(options.panes);
	    var paneOptions = deepExtend({}, naviOptions.pane, { name: NAVIGATOR_PANE });

	    if (!naviOptions.visible) {
	        paneOptions.visible = false;
	        paneOptions.height = 0.1;
	    }

	    panes.push(paneOptions);

	    Navigator.attachAxes(options, naviOptions);
	    Navigator.attachSeries(options, naviOptions, themeOptions);
	};

	Navigator.attachAxes = function(options, naviOptions) {
	    var series = naviOptions.series || [];
	    var categoryAxes = options.categoryAxis = [].concat(options.categoryAxis);
	    var valueAxes = options.valueAxis = [].concat(options.valueAxis);

	    var equallySpacedSeries = dataviz.filterSeriesByType(series, datavizConstants.EQUALLY_SPACED_SERIES);
	    var justifyAxis = equallySpacedSeries.length === 0;

	    var base = deepExtend({
	        type: "date",
	        pane: NAVIGATOR_PANE,
	        roundToBaseUnit: !justifyAxis,
	        justified: justifyAxis,
	        _collapse: false,
	        majorTicks: { visible: true },
	        tooltip: { visible: false },
	        labels: { step: 1 },
	        autoBind: naviOptions.autoBindElements,
	        autoBaseUnitSteps: {
	            minutes: [ 1 ],
	            hours: [ 1, 2 ],
	            days: [ 1, 2 ],
	            weeks: [],
	            months: [ 1 ],
	            years: [ 1 ]
	        }
	    });
	    var user = naviOptions.categoryAxis;

	    categoryAxes.push(
	        deepExtend({}, base, {
	            maxDateGroups: 200
	        }, user, {
	            name: NAVIGATOR_AXIS,
	            title: null,
	            baseUnit: "fit",
	            baseUnitStep: "auto",
	            labels: { visible: false },
	            majorTicks: { visible: false }
	        }), deepExtend({}, base, user, {
	            name: NAVIGATOR_AXIS + "_labels",
	            maxDateGroups: 20,
	            baseUnitStep: "auto",
	            labels: { position: "" },
	            plotBands: [],
	            autoBaseUnitSteps: {
	                minutes: []
	            },
	            _overlap: true
	        }), deepExtend({}, base, user, {
	            name: NAVIGATOR_AXIS + "_ticks",
	            maxDateGroups: 200,
	            majorTicks: {
	                width: 0.5
	            },
	            plotBands: [],
	            title: null,
	            labels: { visible: false, mirror: true },
	            _overlap: true
	        })
	    );

	    valueAxes.push(deepExtend({
	        name: NAVIGATOR_AXIS,
	        pane: NAVIGATOR_PANE,
	        majorGridLines: {
	            visible: false
	        },
	        visible: false
	    }, naviOptions.valueAxis));
	};

	Navigator.attachSeries = function(options, naviOptions, themeOptions) {
	    var series = options.series = options.series || [];
	    var navigatorSeries = [].concat(naviOptions.series || []);
	    var seriesColors = themeOptions.seriesColors;
	    var defaults = naviOptions.seriesDefaults;

	    for (var idx = 0; idx < navigatorSeries.length; idx++) {
	        series.push(
	            deepExtend({
	                color: seriesColors[idx % seriesColors.length],
	                categoryField: naviOptions.dateField,
	                visibleInLegend: false,
	                tooltip: {
	                    visible: false
	                }
	            }, defaults, navigatorSeries[idx], {
	                axis: NAVIGATOR_AXIS,
	                categoryAxis: NAVIGATOR_AXIS,
	                autoBind: naviOptions.autoBindElements
	            })
	        );
	    }
	};

	function ClonedObject() { }
	function clone(obj) {
	    ClonedObject.prototype = obj;
	    return new ClonedObject();
	}

	var AUTO_CATEGORY_WIDTH = 28;

	var StockChart = Chart.extend({
	    applyDefaults: function(options, themeOptions) {
	        var width = dataviz.elementSize(this.element).width || datavizConstants.DEFAULT_WIDTH;
	        var theme = themeOptions;

	        var stockDefaults = {
	            seriesDefaults: {
	                categoryField: options.dateField
	            },
	            axisDefaults: {
	                categoryAxis: {
	                    name: "default",
	                    majorGridLines: {
	                        visible: false
	                    },
	                    labels: {
	                        step: 2
	                    },
	                    majorTicks: {
	                        visible: false
	                    },
	                    maxDateGroups: Math.floor(width / AUTO_CATEGORY_WIDTH)
	                }
	            }
	        };

	        if (theme) {
	            theme = deepExtend({}, theme, stockDefaults);
	        }

	        Navigator.setup(options, theme);

	        Chart.fn.applyDefaults.call(this, options, theme);
	    },

	    _setElementClass: function(element) {
	        dataviz.addClass(element, 'k-chart k-stockchart');
	    },

	    setOptions: function(options) {
	        this.destroyNavigator();
	        Chart.fn.setOptions.call(this, options);
	    },

	    noTransitionsRedraw: function() {
	        var transitions = this.options.transitions;

	        this.options.transitions = false;
	        this._fullRedraw();
	        this.options.transitions = transitions;
	    },

	    _resize: function() {
	        this.noTransitionsRedraw();
	    },

	    _redraw: function() {
	        var navigator = this.navigator;

	        if (!this._dirty() && navigator && navigator.options.partialRedraw) {
	            navigator.redrawSlaves();
	        } else {
	            this._fullRedraw();
	        }
	    },

	    _dirty: function() {
	        var options = this.options;
	        var series = [].concat(options.series, options.navigator.series);
	        var seriesCount = dataviz.grep(series, function(s) { return s && s.visible; }).length;
	        var dirty = this._seriesCount !== seriesCount;
	        this._seriesCount = seriesCount;

	        return dirty;
	    },

	    _fullRedraw: function() {
	        var navigator = this.navigator;

	        if (!navigator) {
	            navigator = this.navigator = new Navigator(this);
	            this.trigger("navigatorCreated", { navigator: navigator });
	        }

	        navigator.clean();
	        navigator.setRange();

	        Chart.fn._redraw.call(this);

	        navigator.initSelection();
	    },

	    _trackSharedTooltip: function(coords) {
	        var plotArea = this._plotArea;
	        var pane = plotArea.paneByPoint(coords);

	        if (pane && pane.options.name === NAVIGATOR_PANE) {
	            this._unsetActivePoint();
	        } else {
	            Chart.fn._trackSharedTooltip.call(this, coords);
	        }
	    },

	    bindCategories: function() {
	        Chart.fn.bindCategories.call(this);
	        this.copyNavigatorCategories();
	    },

	    copyNavigatorCategories: function() {
	        var definitions = [].concat(this.options.categoryAxis);
	        var categories;

	        for (var axisIx = 0; axisIx < definitions.length; axisIx++) {
	            var axis = definitions[axisIx];
	            if (axis.name === NAVIGATOR_AXIS) {
	                categories = axis.categories;
	            } else if (categories && axis.pane === NAVIGATOR_PANE) {
	                axis.categories = categories;
	            }
	        }
	    },

	    destroyNavigator: function() {
	        if (this.navigator) {
	            this.navigator.destroy();
	            this.navigator = null;
	        }
	    },

	    destroy: function() {
	        this.destroyNavigator();
	        Chart.fn.destroy.call(this);
	    },

	    _stopChartHandlers: function(e) {
	        var coords = this._eventCoordinates(e);
	        var pane = this._plotArea.paneByPoint(coords);

	        return Chart.fn._stopChartHandlers.call(this, e) || (pane && pane.options.name === NAVIGATOR_PANE);
	    },

	    _toggleDragZoomEvents: function() {
	        if (!this._dragZoomEnabled) {
	            this.element.style.touchAction = "none";

	            this._dragZoomEnabled = true;
	        }
	    }
	});

	dataviz.setDefaultOptions(StockChart, {
	    dateField: "date",
	    axisDefaults: {
	        categoryAxis: {
	            type: "date",
	            baseUnit: "fit",
	            justified: true
	        },
	        valueAxis: {
	            narrowRange: true,
	            labels: {
	                format: "C"
	            }
	        }
	    },
	    navigator: {
	        select: {},
	        seriesDefaults: {
	            markers: {
	                visible: false
	            },
	            tooltip: {
	                visible: true
	            },
	            line: {
	                width: 2
	            }
	        },
	        hint: {},
	        visible: true
	    },
	    tooltip: {
	        visible: true
	    },
	    legend: {
	        visible: false
	    }
	});

	kendo.deepExtend(kendo.dataviz, {
	    constants: constants,
	    Navigator: Navigator,
	    NavigatorHint: NavigatorHint,
	    StockChart: StockChart
	});

	})();

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "rjj0":
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__("tTVk")

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "rs+d":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(891);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 884:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FTkt");

/***/ }),

/***/ 887:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/***********************************************************************
	 * WARNING: this file is auto-generated.  If you change it directly,
	 * your modifications will eventually be lost.  The source code is in
	 * `kendo-charts` repository, you should make your changes there and
	 * run `src-modules/sync.sh` in this repository.
	 */
	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(887),
	        __webpack_require__(884)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {
	/* jshint curly:false */
	/* jshint -W058 */

	window.kendo.dataviz = window.kendo.dataviz || {};
	var drawing = kendo.drawing;
	var util = drawing.util;
	var Path = drawing.Path;
	var Group = drawing.Group;
	var Class = kendo.Class;
	var geometry = kendo.geometry;
	var Rect = geometry.Rect;
	var Circle = geometry.Circle;
	var geometryTransform = geometry.transform;
	var Segment = geometry.Segment;
	var dataviz = kendo.dataviz;

	var deepExtend = kendo.deepExtend;
	var isFunction = kendo.isFunction;
	var __common_getter_js = kendo.getter;

	var ARC = "arc";
	var AXIS_LABEL_CLICK = "axisLabelClick";
	var BLACK = "#000";
	var BOTTOM = "bottom";
	var CENTER = "center";
	var CIRCLE = "circle";
	var COORD_PRECISION = 3;
	var CROSS = "cross";
	var DATE = "date";
	var DEFAULT_FONT = "12px sans-serif";
	var DEFAULT_HEIGHT = 400;
	var DEFAULT_PRECISION = 10;
	var DEFAULT_WIDTH = 600;
	var END = "end";
	var FORMAT_REGEX = /\{\d+:?/;
	var HEIGHT = "height";
	var HIGHLIGHT_ZINDEX = 100;
	var INSIDE = "inside";
	var LEFT = "left";
	var MAX_VALUE = Number.MAX_VALUE;
	var MIN_VALUE = -Number.MAX_VALUE;
	var NONE = "none";
	var NOTE_CLICK = "noteClick";
	var NOTE_HOVER = "noteHover";
	var NOTE_LEAVE = "noteLeave";
	var OBJECT = "object";
	var OUTSIDE = "outside";
	var RIGHT = "right";
	var START = "start";
	var STRING = "string";
	var TOP = "top";
	var TRIANGLE = "triangle";
	var VALUE = "value";
	var WHITE = "#fff";
	var WIDTH = "width";
	var X = "x";
	var Y = "y";

	var constants = {
		ARC: ARC,
		AXIS_LABEL_CLICK: AXIS_LABEL_CLICK,
		BLACK: BLACK,
		BOTTOM: BOTTOM,
		CENTER: CENTER,
		CIRCLE: CIRCLE,
		COORD_PRECISION: COORD_PRECISION,
		CROSS: CROSS,
		DATE: DATE,
		DEFAULT_FONT: DEFAULT_FONT,
		DEFAULT_HEIGHT: DEFAULT_HEIGHT,
		DEFAULT_PRECISION: DEFAULT_PRECISION,
		DEFAULT_WIDTH: DEFAULT_WIDTH,
		END: END,
		FORMAT_REGEX: FORMAT_REGEX,
		HEIGHT: HEIGHT,
		HIGHLIGHT_ZINDEX: HIGHLIGHT_ZINDEX,
		INSIDE: INSIDE,
		LEFT: LEFT,
		MAX_VALUE: MAX_VALUE,
		MIN_VALUE: MIN_VALUE,
		NONE: NONE,
		NOTE_CLICK: NOTE_CLICK,
		NOTE_HOVER: NOTE_HOVER,
		NOTE_LEAVE: NOTE_LEAVE,
		OBJECT: OBJECT,
		OUTSIDE: OUTSIDE,
		RIGHT: RIGHT,
		START: START,
		STRING: STRING,
		TOP: TOP,
		TRIANGLE: TRIANGLE,
		VALUE: VALUE,
		WHITE: WHITE,
		WIDTH: WIDTH,
		X: X,
		Y: Y
	};

	function isArray(value) {
	    return Array.isArray(value);
	}

	function addClass(element, classes) {
	    var classArray = isArray(classes) ? classes : [ classes ];

	    for (var idx = 0; idx < classArray.length; idx++) {
	        var className = classArray[idx];
	        if (element.className.indexOf(className) === -1) {
	            element.className += " " + className;
	        }
	    }
	}

	var SPACE_REGEX = /\s+/g;

	function removeClass(element, className) {
	    if (element && element.className) {
	        element.className = element.className.replace(className, "").replace(SPACE_REGEX, " ");
	    }
	}

	function alignPathToPixel(path) {
	    var offset = 0.5;
	    if (path.options.stroke && kendo.drawing.util.defined(path.options.stroke.width)) {
	        if (path.options.stroke.width % 2 === 0) {
	            offset = 0;
	        }
	    }

	    for (var i = 0; i < path.segments.length; i++) {
	        path.segments[i].anchor().round(0).translate(offset, offset);
	    }

	    return path;
	}

	function clockwise(angle1, angle2) {
	    // True if angle2 is clockwise of angle1
	    // assuming angles grow in clock-wise direction
	    // (as in the pie and radar charts)
	    return -angle1.x * angle2.y + angle1.y * angle2.x < 0;
	}

	function isNumber(value) {
	    return typeof value === "number" && !isNaN(value);
	}

	function isString(value) {
	    return typeof value === STRING;
	}

	function convertableToNumber(value) {
	    return isNumber(value) || (isString(value) && isFinite(value));
	}

	function isObject(value) {
	    return typeof value === "object";
	}

	function styleValue(value) {
	    if (isNumber(value)) {
	        return value + "px";
	    }
	    return value;
	}

	var SIZE_STYLES_REGEX = /width|height|top|left|bottom|right/i;

	function isSizeField(field) {
	    return SIZE_STYLES_REGEX.test(field);
	}

	function elementStyles(element, styles) {
	    var stylesArray = isString(styles) ? [ styles ] : styles;

	    if (isArray(stylesArray)) {
	        var result = {};
	        var style = window.getComputedStyle(element);

	        for (var idx = 0; idx < stylesArray.length; idx++) {
	            var field = stylesArray[idx];
	            result[field] = isSizeField(field) ? parseFloat(style[field]) : style[field];
	        }

	        return result;
	    } else if (isObject(styles)) {
	        for (var field$1 in styles) {
	            element.style[field$1] = styleValue(styles[field$1]);
	        }
	    }
	}

	function getSpacing(value, defaultSpacing) {
	    if (defaultSpacing === void 0) { defaultSpacing = 0; }

	    var spacing = { top: 0, right: 0, bottom: 0, left: 0 };

	    if (typeof(value) === "number") {
	        spacing[TOP] = spacing[RIGHT] = spacing[BOTTOM] = spacing[LEFT] = value;
	    } else {
	        spacing[TOP] = value[TOP] || defaultSpacing;
	        spacing[RIGHT] = value[RIGHT] || defaultSpacing;
	        spacing[BOTTOM] = value[BOTTOM] || defaultSpacing;
	        spacing[LEFT] = value[LEFT] || defaultSpacing;
	    }

	    return spacing;
	}

	var defaultImplementation = {
	    format: function (format, value) { return value; },

	    toString: function (value) { return value; },

	    parseDate: function (value) { return new Date(value); },

	    firstDay: function () { return 0; }
	};

	var current = defaultImplementation;

	var IntlService = Class.extend({

	});

	IntlService.register = function(userImplementation) {
	    current = userImplementation;
	};

	if (Object.defineProperties) {
	    Object.defineProperties(IntlService, {
	        implementation: {
	            get: function() {
	                return current;
	            }
	        }
	    });
	}

	var FORMAT_REPLACE_REGEX = /\{(\d+)(:[^\}]+)?\}/g;

	var FormatService = Class.extend({
	    init: function(intlService) {
	        this._intlService = intlService;
	    },

	    auto: function(formatString) {
	        var values = [], len = arguments.length - 1;
	        while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

	        var intl = this.intl;

	        if (isString(formatString) && formatString.match(FORMAT_REGEX)) {
	            return intl.format.apply(intl, [ formatString ].concat( values ));
	        }

	        return intl.toString(values[0], formatString);
	    },

	    localeAuto: function(formatString, values, locale) {
	        var intl = this.intl;
	        var result;

	        if (isString(formatString) && formatString.match(FORMAT_REGEX)) {
	            result = formatString.replace(FORMAT_REPLACE_REGEX, function(match, index, placeholderFormat) {
	                var value = values[parseInt(index, 10)];

	                return intl.toString(value, placeholderFormat ? placeholderFormat.substring(1) : "", locale);
	            });
	        } else {
	            result = intl.toString(values[0], formatString, locale);
	        }

	        return result;
	    }
	});

	if (Object.defineProperties) {
	    Object.defineProperties(FormatService.fn, {
	        intl: {
	            get: function() {
	                return this._intlService || IntlService.implementation;
	            },
	            set: function(value) {
	                this._intlService = value;
	            }
	        }
	    });
	}

	var ChartService = Class.extend({
	    init: function(chart, context) {
	        if (context === void 0) { context = {}; }

	        this._intlService = context.intlService;
	        this.sender = context.sender || chart;
	        this.format = new FormatService(context.intlService);
	        this.chart = chart;
	        this.rtl = Boolean(context.rtl);
	    },

	    notify: function(name, args) {
	        if (this.chart) {
	            this.chart.trigger(name, args);
	        }
	    },

	    isPannable: function(axis) {
	        var pannable = ((this.chart || {}).options || {}).pannable;
	        return pannable && pannable.lock !== axis;
	    }
	});

	if (Object.defineProperties) {
	    Object.defineProperties(ChartService.fn, {
	        intl: {
	            get: function() {
	                return this._intlService || IntlService.implementation;
	            },
	            set: function(value) {
	                this._intlService = value;
	                this.format.intl = value;
	            }
	        }
	    });
	}

	var current$1;

	var DomEventsBuilder = Class.extend({

	});

	DomEventsBuilder.register = function(userImplementation) {
	    current$1 = userImplementation;
	};

	DomEventsBuilder.create = function(element, events) {
	    if (current$1) {
	        return current$1.create(element, events);
	    }
	};

	var current$2 = {
	    compile: function(template) {
	        return template;
	    }
	};

	var TemplateService = Class.extend({

	});

	TemplateService.register = function(userImplementation) {
	    current$2 = userImplementation;
	};

	TemplateService.compile = function(template) {
	    return current$2.compile(template);
	};

	var services = {
		ChartService: ChartService,
		DomEventsBuilder: DomEventsBuilder,
		FormatService: FormatService,
		IntlService: IntlService,
		TemplateService: TemplateService
	};

	function getTemplate(options) {
	    if (options === void 0) { options = {}; }

	    var template;
	    if (options.template) {
	        options.template = template = TemplateService.compile(options.template);
	    } else if (isFunction(options.content)) {
	        template = options.content;
	    }

	    return template;
	}

	function grep(array, callback) {
	    var length = array.length;
	    var result = [];
	    for (var idx = 0; idx < length; idx++) {
	        if (callback(array[idx])) {
	            result .push(array[idx]);
	        }
	    }

	    return result;
	}

	function hasClasses(element, classNames) {
	    if (element.className) {
	        var names = classNames.split(" ");
	        for (var idx = 0; idx < names.length; idx++) {
	            if (element.className.indexOf(names[idx]) !== -1) {
	                return true;
	            }
	        }
	    }
	}

	var HashMap = function HashMap() {
	    this._map = {};
	};

	HashMap.prototype.get = function get (name) {
	    return this._map[this._key(name)];
	};

	HashMap.prototype.set = function set (name, value) {
	    this._map[this._key(name)] = value;
	};

	HashMap.prototype._key = function _key (name) {
	    return name instanceof Date ? name.getTime() : name;
	};

	function inArray(value, array) {
	    if (array) {
	        return array.indexOf(value) !== -1;
	    }
	}

	function interpolateValue(start, end, progress) {
	    return kendo.drawing.util.round(start + (end - start) * progress, COORD_PRECISION);
	}

	var TRIGGER = 'trigger';

	var InstanceObserver = Class.extend({
	    init: function(observer, handlers) {
	        this.observer = observer;
	        this.handlerMap = deepExtend({}, this.handlerMap, handlers);
	    },

	    trigger: function(name, args) {
	        var ref = this;
	        var observer = ref.observer;
	        var handlerMap = ref.handlerMap;
	        var isDefaultPrevented;
	        if (handlerMap[name]) {
	            isDefaultPrevented = this.callObserver(handlerMap[name], args);
	        } else if (observer[TRIGGER]) {
	            isDefaultPrevented = this.callObserver(TRIGGER, name, args);
	        }

	        return isDefaultPrevented;
	    },

	    callObserver: function(fnName) {
	        var args = [], len = arguments.length - 1;
	        while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

	        return this.observer[fnName].apply(this.observer, args);
	    },

	    requiresHandlers: function(names) {
	        var this$1 = this;

	        if (this.observer.requiresHandlers) {
	            return this.observer.requiresHandlers(names);
	        }

	        for (var idx = 0; idx < names.length; idx++) {
	            if (this$1.handlerMap[names[idx]]) {
	                return true;
	            }
	        }
	    }
	});

	function map(array, callback) {
	    var length = array.length;
	    var result = [];
	    for (var idx = 0; idx < length; idx++) {
	        var value = callback(array[idx]);
	        if (kendo.drawing.util.defined(value)) {
	            result.push(value);
	        }
	    }
	    return result;
	}

	function mousewheelDelta(e) {
	    var delta = 0;

	    if (e.wheelDelta) {
	        delta = -e.wheelDelta / 120;
	        delta = delta > 0 ? Math.ceil(delta) : Math.floor(delta);
	    }

	    if (e.detail) {
	        delta = kendo.drawing.util.round(e.detail / 3);
	    }

	    return delta;
	}

	var ref = kendo.drawing.util;
	var append = ref.append;
	var bindEvents = ref.bindEvents;
	var defined = ref.defined;
	var deg = ref.deg;
	var elementOffset = ref.elementOffset;
	var elementSize = ref.elementSize;
	var eventElement = ref.eventElement;
	var eventCoordinates = ref.eventCoordinates;
	var last = ref.last;
	var limitValue = ref.limitValue;
	var objectKey = ref.objectKey;
	var rad = ref.rad;
	var round = ref.round;
	var unbindEvents = ref.unbindEvents;
	var valueOrDefault = ref.valueOrDefault;

	var FontLoader = Class.extend({

	});

	FontLoader.fetchFonts = function(options, fonts, state) {
	    if (state === void 0) { state = { depth: 0 }; }

	    var MAX_DEPTH = 5;

	    if (!options || state.depth > MAX_DEPTH || !document.fonts) {
	        return;
	    }

	    Object.keys(options).forEach(function(key) {
	        var value = options[key];
	        if (key === "dataSource" || key[0] === "$" || !value) {
	            return;
	        }

	        if (key === "font") {
	            fonts.push(value);
	        } else if (typeof value === "object") {
	            state.depth++;
	            FontLoader.fetchFonts(value, fonts, state);
	            state.depth--;
	        }
	    });
	};

	FontLoader.loadFonts = function(fonts, callback) {
	    var promises = [];

	    if (fonts.length > 0 && document.fonts) {
	        try {
	            promises = fonts.map(function(font) {
	                return document.fonts.load(font);
	            });
	        } catch (e) {
	            // Silence font-loading errors
	            kendo.logToConsole(e);
	        }

	        Promise.all(promises).then(callback, callback);
	    } else {
	        callback();
	    }
	};

	FontLoader.preloadFonts = function(options, callback) {
	    var fonts = [];
	    FontLoader.fetchFonts(options, fonts);

	    FontLoader.loadFonts(fonts, callback);
	};

	function setDefaultOptions(type, options) {
	    var proto = type.prototype;
	    if (proto.options) {
	        proto.options = deepExtend({}, proto.options, options);
	    } else {
	        proto.options = options;
	    }
	}

	function sparseArrayLimits(arr) {
	    var min = MAX_VALUE;
	    var max = MIN_VALUE;

	    for (var idx = 0, length = arr.length; idx < length; idx++) {
	        var value = arr[idx];
	        if (value !== null && isFinite(value)) {
	            min = Math.min(min, value);
	            max = Math.max(max, value);
	        }
	    }

	    return {
	        min: min === MAX_VALUE ? undefined : min,
	        max: max === MIN_VALUE ? undefined : max
	    };
	}

	function find(array, predicate) {
	    for (var i = 0; i < array.length; i++) {
	        var item = array[i];
	        if (predicate(item, i, array)) {
	            return item;
	        }
	    }
	}

	var Matrix = geometry.Matrix;
	var matrixRegexp = /matrix\((.*)\)/;

	function parseMatrix(matrixString) {
	    var match = matrixString.match(matrixRegexp);
	    if (match === null || match.length !== 2) {
	        return Matrix.unit();
	    }

	    var members = match[1].split(',').map(function (x) { return parseFloat(x); });
	    return new (Function.prototype.bind.apply( Matrix, [ null ].concat( members) ));
	}

	function transformMatrix(element) {
	    var transform = getComputedStyle(element).transform;

	    if (transform === 'none') {
	        return Matrix.unit();
	    }

	    return parseMatrix(transform);
	}

	function elementScale(element) {
	    if (!element) {
	        return Matrix.unit();
	    }

	    var matrix = transformMatrix(element);
	    var parent = element.parentElement;
	    while (parent) {
	        var parentMatrix = transformMatrix(parent);
	        matrix = matrix.multiplyCopy(parentMatrix);
	        parent = parent.parentElement;
	    }

	    matrix.b = matrix.c = matrix.e = matrix.f = 0;
	    return matrix;
	}

	function autoMajorUnit(min, max) {
	    var diff = round(max - min, DEFAULT_PRECISION - 1);

	    if (diff === 0) {
	        if (max === 0) {
	            return 0.1;
	        }

	        diff = Math.abs(max);
	    }

	    var scale = Math.pow(10, Math.floor(Math.log(diff) / Math.log(10)));
	    var relativeValue = round((diff / scale), DEFAULT_PRECISION);
	    var scaleMultiplier = 1;

	    if (relativeValue < 1.904762) {
	        scaleMultiplier = 0.2;
	    } else if (relativeValue < 4.761904) {
	        scaleMultiplier = 0.5;
	    } else if (relativeValue < 9.523809) {
	        scaleMultiplier = 1;
	    } else {
	        scaleMultiplier = 2;
	    }

	    return round(scale * scaleMultiplier, DEFAULT_PRECISION);
	}

	var Point = Class.extend({
	    init: function(x, y) {

	        this.x = x || 0;
	        this.y = y || 0;
	    },

	    clone: function() {
	        return new Point(this.x, this.y);
	    },

	    equals: function(point) {
	        return point && this.x === point.x && this.y === point.y;
	    },

	    rotate: function(center, degrees) {
	        var theta = rad(degrees);
	        var cosT = Math.cos(theta);
	        var sinT = Math.sin(theta);
	        var cx = center.x;
	        var cy = center.y;
	        var ref = this;
	        var x = ref.x;
	        var y = ref.y;

	        this.x = round(
	            cx + (x - cx) * cosT + (y - cy) * sinT,
	            COORD_PRECISION
	        );

	        this.y = round(
	            cy + (y - cy) * cosT - (x - cx) * sinT,
	            COORD_PRECISION
	        );

	        return this;
	    },

	    multiply: function(a) {

	        this.x *= a;
	        this.y *= a;

	        return this;
	    },

	    distanceTo: function(point) {
	        var dx = this.x - point.x;
	        var dy = this.y - point.y;

	        return Math.sqrt(dx * dx + dy * dy);
	    }
	});

	Point.onCircle = function(center, angle, radius) {
	    var radians = rad(angle);

	    return new Point(
	        center.x - radius * Math.cos(radians),
	        center.y - radius * Math.sin(radians)
	    );
	};

	var Box = Class.extend({
	    init: function(x1, y1, x2, y2) {

	        this.x1 = x1 || 0;
	        this.y1 = y1 || 0;
	        this.x2 = x2 || 0;
	        this.y2 = y2 || 0;
	    },

	    equals: function(box) {
	        return this.x1 === box.x1 && this.x2 === box.x2 &&
	            this.y1 === box.y1 && this.y2 === box.y2;
	    },

	    width: function() {
	        return this.x2 - this.x1;
	    },

	    height: function() {
	        return this.y2 - this.y1;
	    },

	    translate: function(dx, dy) {
	        this.x1 += dx;
	        this.x2 += dx;
	        this.y1 += dy;
	        this.y2 += dy;

	        return this;
	    },

	    move: function(x, y) {
	        var height = this.height();
	        var width = this.width();

	        if (defined(x)) {
	            this.x1 = x;
	            this.x2 = this.x1 + width;
	        }

	        if (defined(y)) {
	            this.y1 = y;
	            this.y2 = this.y1 + height;
	        }

	        return this;
	    },

	    wrap: function(targetBox) {
	        this.x1 = Math.min(this.x1, targetBox.x1);
	        this.y1 = Math.min(this.y1, targetBox.y1);
	        this.x2 = Math.max(this.x2, targetBox.x2);
	        this.y2 = Math.max(this.y2, targetBox.y2);

	        return this;
	    },

	    wrapPoint: function(point) {
	        var arrayPoint = isArray(point);
	        var x = arrayPoint ? point[0] : point.x;
	        var y = arrayPoint ? point[1] : point.y;
	        this.wrap(new Box(x, y, x, y));

	        return this;
	    },

	    snapTo: function(targetBox, axis) {

	        if (axis === X || !axis) {
	            this.x1 = targetBox.x1;
	            this.x2 = targetBox.x2;
	        }

	        if (axis === Y || !axis) {
	            this.y1 = targetBox.y1;
	            this.y2 = targetBox.y2;
	        }

	        return this;
	    },

	    alignTo: function(targetBox, anchor) {
	        var height = this.height();
	        var width = this.width();
	        var axis = anchor === TOP || anchor === BOTTOM ? Y : X;
	        var offset = axis === Y ? height : width;

	        if (anchor === CENTER) {
	            var targetCenter = targetBox.center();
	            var center = this.center();

	            this.x1 += targetCenter.x - center.x;
	            this.y1 += targetCenter.y - center.y;
	        } else if (anchor === TOP || anchor === LEFT) {
	            this[axis + 1] = targetBox[axis + 1] - offset;
	        } else {
	            this[axis + 1] = targetBox[axis + 2];
	        }

	        this.x2 = this.x1 + width;
	        this.y2 = this.y1 + height;

	        return this;
	    },

	    shrink: function(dw, dh) {

	        this.x2 -= dw;
	        this.y2 -= dh;

	        return this;
	    },

	    expand: function(dw, dh) {
	        this.shrink(-dw, -dh);
	        return this;
	    },

	    pad: function(padding) {
	        var spacing = getSpacing(padding);

	        this.x1 -= spacing.left;
	        this.x2 += spacing.right;
	        this.y1 -= spacing.top;
	        this.y2 += spacing.bottom;

	        return this;
	    },

	    unpad: function(padding) {
	        var spacing = getSpacing(padding);

	        spacing.left = -spacing.left;
	        spacing.top = -spacing.top;
	        spacing.right = -spacing.right;
	        spacing.bottom = -spacing.bottom;

	        return this.pad(spacing);
	    },

	    clone: function() {
	        return new Box(this.x1, this.y1, this.x2, this.y2);
	    },

	    center: function() {
	        return new Point(
	            this.x1 + this.width() / 2,
	            this.y1 + this.height() / 2
	        );
	    },

	    containsPoint: function(point) {

	        return point.x >= this.x1 && point.x <= this.x2 &&
	               point.y >= this.y1 && point.y <= this.y2;
	    },

	    points: function() {
	        return [
	            new Point(this.x1, this.y1),
	            new Point(this.x2, this.y1),
	            new Point(this.x2, this.y2),
	            new Point(this.x1, this.y2)
	        ];
	    },

	    getHash: function() {
	        return [ this.x1, this.y1, this.x2, this.y2 ].join(",");
	    },

	    overlaps: function(box) {
	        return !(box.y2 < this.y1 || this.y2 < box.y1 || box.x2 < this.x1 || this.x2 < box.x1);
	    },

	    rotate: function(rotation) {
	        var width = this.width();
	        var height = this.height();
	        var ref = this.center();
	        var cx = ref.x;
	        var cy = ref.y;

	        var r1 = rotatePoint(0, 0, cx, cy, rotation);
	        var r2 = rotatePoint(width, 0, cx, cy, rotation);
	        var r3 = rotatePoint(width, height, cx, cy, rotation);
	        var r4 = rotatePoint(0, height, cx, cy, rotation);

	        width = Math.max(r1.x, r2.x, r3.x, r4.x) - Math.min(r1.x, r2.x, r3.x, r4.x);
	        height = Math.max(r1.y, r2.y, r3.y, r4.y) - Math.min(r1.y, r2.y, r3.y, r4.y);

	        this.x2 = this.x1 + width;
	        this.y2 = this.y1 + height;

	        return this;
	    },

	    toRect: function() {
	        return new Rect([ this.x1, this.y1 ], [ this.width(), this.height() ]);
	    },

	    hasSize: function() {
	        return this.width() !== 0 && this.height() !== 0;
	    },

	    align: function(targetBox, axis, alignment) {
	        var c1 = axis + 1;
	        var c2 = axis + 2;
	        var sizeFunc = axis === X ? WIDTH : HEIGHT;
	        var size = this[sizeFunc]();

	        if (inArray(alignment, [ LEFT, TOP ])) {
	            this[c1] = targetBox[c1];
	            this[c2] = this[c1] + size;
	        } else if (inArray(alignment, [ RIGHT, BOTTOM ])) {
	            this[c2] = targetBox[c2];
	            this[c1] = this[c2] - size;
	        } else if (alignment === CENTER) {
	            this[c1] = targetBox[c1] + (targetBox[sizeFunc]() - size) / 2;
	            this[c2] = this[c1] + size;
	        }
	    }
	});

	function rotatePoint(x, y, cx, cy, angle) {
	    var theta = rad(angle);

	    return new Point(
	        cx + (x - cx) * Math.cos(theta) + (y - cy) * Math.sin(theta),
	        cy - (x - cx) * Math.sin(theta) + (y - cy) * Math.cos(theta)
	    );
	}

	var Ring = Class.extend({
	    init: function(center, innerRadius, radius, startAngle, angle) {

	        this.center = center;
	        this.innerRadius = innerRadius;
	        this.radius = radius;
	        this.startAngle = startAngle;
	        this.angle = angle;
	    },

	    clone: function() {
	        return new Ring(this.center, this.innerRadius, this.radius, this.startAngle, this.angle);
	    },

	    middle: function() {
	        return this.startAngle + this.angle / 2;
	    },

	    setRadius: function(newRadius, innerRadius) {
	        if (innerRadius) {
	            this.innerRadius = newRadius;
	        } else {
	            this.radius = newRadius;
	        }

	        return this;
	    },

	    point: function(angle, innerRadius) {
	        var radianAngle = rad(angle);
	        var ax = Math.cos(radianAngle);
	        var ay = Math.sin(radianAngle);
	        var radius = innerRadius ? this.innerRadius : this.radius;
	        var x = round(this.center.x - (ax * radius), COORD_PRECISION);
	        var y = round(this.center.y - (ay * radius), COORD_PRECISION);

	        return new Point(x, y);
	    },

	    adjacentBox: function(distance, width, height) {
	        var sector = this.clone().expand(distance);
	        var midAndle = sector.middle();
	        var midPoint = sector.point(midAndle);
	        var hw = width / 2;
	        var hh = height / 2;
	        var sa = Math.sin(rad(midAndle));
	        var ca = Math.cos(rad(midAndle));
	        var x = midPoint.x - hw;
	        var y = midPoint.y - hh;

	        if (Math.abs(sa) < 0.9) {
	            x += hw * -ca / Math.abs(ca);
	        }

	        if (Math.abs(ca) < 0.9) {
	            y += hh * -sa / Math.abs(sa);
	        }

	        return new Box(x, y, x + width, y + height);
	    },

	    containsPoint: function(p) {
	        var center = this.center;
	        var innerRadius = this.innerRadius;
	        var radius = this.radius;
	        var startAngle = this.startAngle;
	        var endAngle = this.startAngle + this.angle;
	        var dx = p.x - center.x;
	        var dy = p.y - center.y;
	        var vector = new Point(dx, dy);
	        var startPoint = this.point(startAngle);
	        var startVector = new Point(startPoint.x - center.x, startPoint.y - center.y);
	        var endPoint = this.point(endAngle);
	        var endVector = new Point(endPoint.x - center.x, endPoint.y - center.y);
	        var dist = round(dx * dx + dy * dy, COORD_PRECISION);

	        return (startVector.equals(vector) || clockwise(startVector, vector)) &&
	               !clockwise(endVector, vector) &&
	               dist >= innerRadius * innerRadius && dist <= radius * radius;
	    },

	    getBBox: function() {
	        var this$1 = this;

	        var box = new Box(MAX_VALUE, MAX_VALUE, MIN_VALUE, MIN_VALUE);
	        var startAngle = round(this.startAngle % 360);
	        var endAngle = round((startAngle + this.angle) % 360);
	        var innerRadius = this.innerRadius;
	        var allAngles = [ 0, 90, 180, 270, startAngle, endAngle ].sort(numericComparer);
	        var startAngleIndex = allAngles.indexOf(startAngle);
	        var endAngleIndex = allAngles.indexOf(endAngle);
	        var angles;

	        if (startAngle === endAngle) {
	            angles = allAngles;
	        } else {
	            if (startAngleIndex < endAngleIndex) {
	                angles = allAngles.slice(startAngleIndex, endAngleIndex + 1);
	            } else {
	                angles = [].concat(
	                    allAngles.slice(0, endAngleIndex + 1),
	                    allAngles.slice(startAngleIndex, allAngles.length)
	                );
	            }
	        }

	        for (var i = 0; i < angles.length; i++) {
	            var point = this$1.point(angles[i]);
	            box.wrapPoint(point);
	            box.wrapPoint(point, innerRadius);
	        }

	        if (!innerRadius) {
	            box.wrapPoint(this.center);
	        }

	        return box;
	    },

	    expand: function(value) {
	        this.radius += value;
	        return this;
	    }
	});

	function numericComparer(a, b) {
	    return a - b;
	}

	var Sector = Ring.extend({
	    init: function(center, radius, startAngle, angle) {
	        Ring.fn.init.call(this, center, 0, radius, startAngle, angle);
	    },

	    expand: function(value) {
	        return Ring.fn.expand.call(this, value);
	    },

	    clone: function() {
	        return new Sector(this.center, this.radius, this.startAngle, this.angle);
	    },

	    setRadius: function(newRadius) {
	        this.radius = newRadius;

	        return this;
	    }
	});

	var DIRECTION_ANGLE = 0.001; //any value that will make the endAngle bigger than the start angle will work here.

	var ShapeBuilder = Class.extend({
	    createRing: function(sector, options) {
	        var startAngle = sector.startAngle + 180;
	        var endAngle = sector.angle + startAngle;

	        //required in order to avoid reversing the arc direction in cases like 0.000000000000001 + 100 === 100
	        if (sector.angle > 0 && startAngle === endAngle) {
	            endAngle += DIRECTION_ANGLE;
	        }

	        var center = new geometry.Point(sector.center.x, sector.center.y);
	        var radius = Math.max(sector.radius, 0);
	        var innerRadius = Math.max(sector.innerRadius, 0);
	        var arc = new geometry.Arc(center, {
	            startAngle: startAngle,
	            endAngle: endAngle,
	            radiusX: radius,
	            radiusY: radius
	        });
	        var path = Path.fromArc(arc, options).close();

	        if (innerRadius) {
	            arc.radiusX = arc.radiusY = innerRadius;
	            var innerEnd = arc.pointAt(endAngle);
	            path.lineTo(innerEnd.x, innerEnd.y);
	            path.arc(endAngle, startAngle, innerRadius, innerRadius, true);
	        } else {
	            path.lineTo(center.x, center.y);
	        }

	        return path;
	    }
	});

	ShapeBuilder.current = new ShapeBuilder();

	var ChartElement = Class.extend({
	    init: function(options) {

	        this.children = [];

	        this.options = deepExtend({}, this.options, this.initUserOptions(options));
	    },

	    initUserOptions: function(options) {
	        return options;
	    },

	    reflow: function(targetBox) {
	        var children = this.children;
	        var box;

	        for (var i = 0; i < children.length; i++) {
	            var currentChild = children[i];
	            currentChild.reflow(targetBox);

	            box = box ? box.wrap(currentChild.box) : currentChild.box.clone();
	        }

	        this.box = box || targetBox;
	    },

	    destroy: function() {
	        var children = this.children;

	        if (this.animation) {
	            this.animation.destroy();
	        }

	        for (var i = 0; i < children.length; i++) {
	            children[i].destroy();
	        }
	    },

	    getRoot: function() {
	        var parent = this.parent;

	        return parent ? parent.getRoot() : null;
	    },

	    getSender: function() {
	        var service = this.getService();
	        if (service) {
	            return service.sender;
	        }
	    },

	    getService: function() {
	        var element = this;
	        while (element) {
	            if (element.chartService) {
	                return element.chartService;
	            }
	            element = element.parent;
	        }
	    },

	    translateChildren: function(dx, dy) {
	        var children = this.children;
	        var childrenCount = children.length;

	        for (var i = 0; i < childrenCount; i++) {
	            children[i].box.translate(dx, dy);
	        }
	    },

	    append: function() {
	        var arguments$1 = arguments;
	        var this$1 = this;

	        for (var i = 0; i < arguments.length; i++) {
	            var item = arguments$1[i];
	            this$1.children.push(item);
	            item.parent = this$1;
	        }
	    },

	    renderVisual: function() {
	        if (this.options.visible === false) {
	            return;
	        }

	        this.createVisual();

	        this.addVisual();

	        this.renderChildren();

	        this.createAnimation();
	        this.renderComplete();
	    },

	    addVisual: function() {
	        if (this.visual) {
	            this.visual.chartElement = this;

	            if (this.parent) {
	                this.parent.appendVisual(this.visual);
	            }
	        }
	    },

	    renderChildren: function() {
	        var children = this.children;
	        var length = children.length;
	        for (var i = 0; i < length; i++) {
	            children[i].renderVisual();
	        }
	    },

	    createVisual: function() {
	        this.visual = new Group({
	            zIndex: this.options.zIndex,
	            visible: valueOrDefault(this.options.visible, true)
	        });
	    },

	    createAnimation: function() {
	        if (this.visual && this.options.animation) {
	            this.animation = drawing.Animation.create(
	                this.visual, this.options.animation
	            );
	        }
	    },

	    appendVisual: function(childVisual) {
	        if (!childVisual.chartElement) {
	            childVisual.chartElement = this;
	        }

	        if (childVisual.options.noclip) {
	            this.clipRoot().visual.append(childVisual);
	        } else if (defined(childVisual.options.zIndex)) {
	            this.stackRoot().stackVisual(childVisual);
	        } else if (this.isStackRoot) {
	            this.stackVisual(childVisual);
	        } else if (this.visual) {
	            this.visual.append(childVisual);
	        } else {
	            // Allow chart elements without visuals to
	            // pass through child visuals
	            this.parent.appendVisual(childVisual);
	        }
	    },

	    clipRoot: function() {
	        if (this.parent) {
	            return this.parent.clipRoot();
	        }

	        return this;
	    },

	    stackRoot: function() {
	        if (this.parent) {
	            return this.parent.stackRoot();
	        }

	        return this;
	    },

	    stackVisual: function(childVisual) {
	        var zIndex = childVisual.options.zIndex || 0;
	        var visuals = this.visual.children;
	        var length = visuals.length;
	        var pos;

	        for (pos = 0; pos < length; pos++) {
	            var sibling = visuals[pos];
	            var here = valueOrDefault(sibling.options.zIndex, 0);
	            if (here > zIndex) {
	                break;
	            }
	        }

	        this.visual.insert(pos, childVisual);
	    },

	    traverse: function(callback) {
	        var children = this.children;
	        var length = children.length;

	        for (var i = 0; i < length; i++) {
	            var child = children[i];

	            callback(child);
	            if (child.traverse) {
	                child.traverse(callback);
	            }
	        }
	    },

	    closest: function(match) {
	        var element = this;
	        var matched = false;

	        while (element && !matched) {
	            matched = match(element);

	            if (!matched) {
	                element = element.parent;
	            }
	        }

	        if (matched) {
	            return element;
	        }
	    },

	    renderComplete: function() {},

	    hasHighlight: function() {
	        var options = (this.options || {}).highlight;
	        return !(!this.createHighlight || (options && options.visible === false));
	    },

	    toggleHighlight: function(show) {
	        var this$1 = this;

	        var options = (this.options || {}).highlight || {};
	        var customVisual = options.visual;
	        var highlight = this._highlight;

	        if (!highlight) {
	            var highlightOptions = {
	                fill: {
	                    color: WHITE,
	                    opacity: 0.2
	                },
	                stroke: {
	                    color: WHITE,
	                    width: 1,
	                    opacity: 0.2
	                }
	            };

	            if (customVisual) {
	                highlight = this._highlight = customVisual(
	                    $.extend(this.highlightVisualArgs(), {
	                        createVisual: function () { return this$1.createHighlight(highlightOptions); },
	                        sender: this.getSender(),
	                        series: this.series,
	                        dataItem: this.dataItem,
	                        category: this.category,
	                        value: this.value,
	                        percentage: this.percentage,
	                        runningTotal: this.runningTotal,
	                        total: this.total
	                    }
	                ));

	                if (!highlight) {
	                    return;
	                }
	            } else {
	                highlight = this._highlight = this.createHighlight(highlightOptions);
	            }

	            if (!defined(highlight.options.zIndex)) {
	                highlight.options.zIndex = valueOrDefault(options.zIndex, this.options.zIndex);
	            }

	            this.appendVisual(highlight);
	        }

	        highlight.visible(show);
	    },

	    createGradientOverlay: function(element, options, gradientOptions) {
	        var overlay = new Path($.extend({
	            stroke: {
	                color: "none"
	            },
	            fill: this.createGradient(gradientOptions),
	            closed: element.options.closed
	        }, options));

	        overlay.segments.elements(element.segments.elements());

	        return overlay;
	    },

	    createGradient: function(options) {
	        if (this.parent) {
	            return this.parent.createGradient(options);
	        }
	    }
	});

	ChartElement.prototype.options = { };

	var BoxElement = ChartElement.extend({
	    init: function(options) {
	        ChartElement.fn.init.call(this, options);

	        this.options.margin = getSpacing(this.options.margin);
	        this.options.padding = getSpacing(this.options.padding);
	    },

	    reflow: function(targetBox) {
	        var this$1 = this;

	        var options = this.options;
	        var width = options.width;
	        var height = options.height;
	        var shrinkToFit = options.shrinkToFit;
	        var hasSetSize = width && height;
	        var margin = options.margin;
	        var padding = options.padding;
	        var borderWidth = options.border.width;
	        var box;

	        var reflowPaddingBox = function () {
	            this$1.align(targetBox, X, options.align);
	            this$1.align(targetBox, Y, options.vAlign);
	            this$1.paddingBox = box.clone().unpad(margin).unpad(borderWidth);
	        };

	        var contentBox = targetBox.clone();
	        if (hasSetSize) {
	            contentBox.x2 = contentBox.x1 + width;
	            contentBox.y2 = contentBox.y1 + height;
	        }

	        if (shrinkToFit) {
	            contentBox.unpad(margin).unpad(borderWidth).unpad(padding);
	        }

	        ChartElement.fn.reflow.call(this, contentBox);

	        if (hasSetSize) {
	            box = this.box = new Box(0, 0, width, height);
	        } else {
	            box = this.box;
	        }

	        if (shrinkToFit && hasSetSize) {
	            reflowPaddingBox();
	            contentBox = this.contentBox = this.paddingBox.clone().unpad(padding);
	        } else {
	            contentBox = this.contentBox = box.clone();
	            box.pad(padding).pad(borderWidth).pad(margin);
	            reflowPaddingBox();
	        }

	        this.translateChildren(
	            box.x1 - contentBox.x1 + margin.left + borderWidth + padding.left,
	            box.y1 - contentBox.y1 + margin.top + borderWidth + padding.top
	        );

	        var children = this.children;
	        for (var i = 0; i < children.length; i++) {
	            var item = children[i];
	            item.reflow(item.box);
	        }
	    },

	    align: function(targetBox, axis, alignment) {
	        this.box.align(targetBox, axis, alignment);
	    },

	    hasBox: function() {
	        var options = this.options;
	        return options.border.width || options.background;
	    },

	    createVisual: function() {
	        ChartElement.fn.createVisual.call(this);

	        var options = this.options;
	        if (options.visible && this.hasBox()) {
	            this.visual.append(Path.fromRect(
	                this.paddingBox.toRect(),
	                this.visualStyle()
	            ));
	        }
	    },

	    visualStyle: function() {
	        var options = this.options;
	        var border = options.border || {};

	        return {
	            stroke: {
	                width: border.width,
	                color: border.color,
	                opacity: valueOrDefault(border.opacity, options.opacity),
	                dashType: border.dashType
	            },
	            fill: {
	                color: options.background,
	                opacity: options.opacity
	            },
	            cursor: options.cursor
	        };
	    }
	});

	setDefaultOptions(BoxElement, {
	    align: LEFT,
	    vAlign: TOP,
	    margin: {},
	    padding: {},
	    border: {
	        color: BLACK,
	        width: 0
	    },
	    background: "",
	    shrinkToFit: false,
	    width: 0,
	    height: 0,
	    visible: true
	});

	var ShapeElement = BoxElement.extend({
	    init: function(options, pointData) {
	        BoxElement.fn.init.call(this, options);

	        this.pointData = pointData;
	    },

	    getElement: function() {
	        var ref = this;
	        var options = ref.options;
	        var box = ref.paddingBox;
	        var type = options.type;
	        var rotation = options.rotation;
	        var center = box.center();
	        var halfWidth = box.width() / 2;

	        if (!options.visible || !this.hasBox()) {
	            return null;
	        }

	        var style = this.visualStyle();
	        var element;

	        if (type === CIRCLE) {
	            element = new drawing.Circle(
	                new Circle([
	                    round(box.x1 + halfWidth, COORD_PRECISION),
	                    round(box.y1 + box.height() / 2, COORD_PRECISION)
	                ], halfWidth),
	                style
	            );
	        } else if (type === TRIANGLE) {
	            element = Path.fromPoints([
	                [ box.x1 + halfWidth, box.y1 ],
	                [ box.x1, box.y2 ],
	                [ box.x2, box.y2 ]
	            ], style).close();
	        } else if (type === CROSS) {
	            element = new drawing.MultiPath(style);

	            element.moveTo(box.x1, box.y1).lineTo(box.x2, box.y2);
	            element.moveTo(box.x1, box.y2).lineTo(box.x2, box.y1);
	        } else {
	            element = Path.fromRect(box.toRect(), style);
	        }

	        if (rotation) {
	            element.transform(geometryTransform()
	                .rotate(-rotation, [ center.x, center.y ])
	            );
	        }

	        element.options.zIndex = options.zIndex;
	        return element;
	    },

	    createElement: function() {
	        var this$1 = this;

	        var customVisual = this.options.visual;
	        var pointData = this.pointData || {};
	        var visual;

	        if (customVisual) {
	            visual = customVisual({
	                value: pointData.value,
	                dataItem: pointData.dataItem,
	                sender: this.getSender(),
	                series: pointData.series,
	                category: pointData.category,
	                rect: this.paddingBox.toRect(),
	                options: this.visualOptions(),
	                createVisual: function () { return this$1.getElement(); }
	            });
	        } else {
	            visual = this.getElement();
	        }

	        return visual;
	    },

	    visualOptions: function() {
	        var options = this.options;
	        return {
	            background: options.background,
	            border: options.border,
	            margin: options.margin,
	            padding: options.padding,
	            type: options.type,
	            size: options.width,
	            visible: options.visible
	        };
	    },

	    createVisual: function() {
	        this.visual = this.createElement();
	    }
	});

	setDefaultOptions(ShapeElement, {
	    type: CIRCLE,
	    align: CENTER,
	    vAlign: CENTER
	});

	var LINEAR = "linear";
	var RADIAL = "radial";

	var GRADIENTS = {
	    glass: {
	        type: LINEAR,
	        rotation: 0,
	        stops: [ {
	            offset: 0,
	            color: WHITE,
	            opacity: 0
	        }, {
	            offset: 0.25,
	            color: WHITE,
	            opacity: 0.3
	        }, {
	            offset: 1,
	            color: WHITE,
	            opacity: 0
	        } ]
	    },
	    sharpBevel: {
	        type: RADIAL,
	        stops: [ {
	            offset: 0,
	            color: WHITE,
	            opacity: 0.55
	        }, {
	            offset: 0.65,
	            color: WHITE,
	            opacity: 0
	        }, {
	            offset: 0.95,
	            color: WHITE,
	            opacity: 0.25
	        } ]
	    },
	    roundedBevel: {
	        type: RADIAL,
	        stops: [ {
	            offset: 0.33,
	            color: WHITE,
	            opacity: 0.06
	        }, {
	            offset: 0.83,
	            color: WHITE,
	            opacity: 0.2
	        }, {
	            offset: 0.95,
	            color: WHITE,
	            opacity: 0
	        } ]
	    },
	    roundedGlass: {
	        type: RADIAL,
	        supportVML: false,
	        stops: [ {
	            offset: 0,
	            color: WHITE,
	            opacity: 0
	        }, {
	            offset: 0.5,
	            color: WHITE,
	            opacity: 0.3
	        }, {
	            offset: 0.99,
	            color: WHITE,
	            opacity: 0
	        } ]
	    },
	    sharpGlass: {
	        type: RADIAL,
	        supportVML: false,
	        stops: [ {
	            offset: 0,
	            color: WHITE,
	            opacity: 0.2
	        }, {
	            offset: 0.15,
	            color: WHITE,
	            opacity: 0.15
	        }, {
	            offset: 0.17,
	            color: WHITE,
	            opacity: 0.35
	        }, {
	            offset: 0.85,
	            color: WHITE,
	            opacity: 0.05
	        }, {
	            offset: 0.87,
	            color: WHITE,
	            opacity: 0.15
	        }, {
	            offset: 0.99,
	            color: WHITE,
	            opacity: 0
	        } ]
	    },
	    bubbleShadow: {
	        type: RADIAL,
	        center: [ 0.5, 0.5 ],
	        radius: 0.5
	    }
	};

	function boxDiff(r, s) {
	    if (r.x1 === s.x1 && r.y1 === s.y1 && r.x2 === s.x2 && r.y2 === s.y2) {
	        return s;
	    }

	    var a = Math.min(r.x1, s.x1);
	    var b = Math.max(r.x1, s.x1);
	    var c = Math.min(r.x2, s.x2);
	    var d = Math.max(r.x2, s.x2);
	    var e = Math.min(r.y1, s.y1);
	    var f = Math.max(r.y1, s.y1);
	    var g = Math.min(r.y2, s.y2);
	    var h = Math.max(r.y2, s.y2);
	    var boxes = [];

	    // X = intersection, 0-7 = possible difference areas
	    // h +-+-+-+
	    // . |5|6|7|
	    // g +-+-+-+
	    // . |3|X|4|
	    // f +-+-+-+
	    // . |0|1|2|
	    // e +-+-+-+
	    // . a b c d

	    // we'll always have rectangles 1, 3, 4 and 6
	    boxes[0] = new Box(b, e, c, f);
	    boxes[1] = new Box(a, f, b, g);
	    boxes[2] = new Box(c, f, d, g);
	    boxes[3] = new Box(b, g, c, h);

	    // decide which corners
	    if (r.x1 === a && r.y1 === e || s.x1 === a && s.y1 === e) { // corners 0 and 7
	        boxes[4] = new Box(a, e, b, f);
	        boxes[5] = new Box(c, g, d, h);
	    } else { // corners 2 and 5
	        boxes[4] = new Box(c, e, d, f);
	        boxes[5] = new Box(a, g, b, h);
	    }

	    return grep(boxes, function(box) {
	        return box.height() > 0 && box.width() > 0;
	    })[0];
	}

	var RootElement = ChartElement.extend({
	    init: function(options) {
	        ChartElement.fn.init.call(this, options);

	        var rootOptions = this.options;
	        rootOptions.width = parseInt(rootOptions.width, 10);
	        rootOptions.height = parseInt(rootOptions.height, 10);

	        this.gradients = {};
	    },

	    reflow: function() {
	        var ref = this;
	        var options = ref.options;
	        var children = ref.children;
	        var currentBox = new Box(0, 0, options.width, options.height);

	        this.box = currentBox.unpad(options.margin);

	        for (var i = 0; i < children.length; i++) {
	            children[i].reflow(currentBox);
	            currentBox = boxDiff(currentBox, children[i].box) || new Box();
	        }
	    },

	    createVisual: function() {
	        this.visual = new Group();
	        this.createBackground();
	    },

	    createBackground: function() {
	        var options = this.options;
	        var border = options.border || {};
	        var box = this.box.clone().pad(options.margin).unpad(border.width);

	        var background = Path.fromRect(box.toRect(), {
	            stroke: {
	                color: border.width ? border.color : "",
	                width: border.width,
	                dashType: border.dashType
	            },
	            fill: {
	                color: options.background,
	                opacity: options.opacity
	            },
	            zIndex: -10
	        });

	        this.visual.append(background);
	    },

	    getRoot: function() {
	        return this;
	    },

	    createGradient: function(options) {
	        var gradients = this.gradients;
	        var hashCode = objectKey(options);
	        var gradient = GRADIENTS[options.gradient];
	        var drawingGradient;

	        if (gradients[hashCode]) {
	            drawingGradient = gradients[hashCode];
	        } else {
	            var gradientOptions = $.extend({}, gradient, options);
	            if (gradient.type === "linear") {
	                drawingGradient = new drawing.LinearGradient(gradientOptions);
	            } else {
	                if (options.innerRadius) {
	                    gradientOptions.stops = innerRadialStops(gradientOptions);
	                }
	                drawingGradient = new drawing.RadialGradient(gradientOptions);
	                drawingGradient.supportVML = gradient.supportVML !== false;
	            }
	            gradients[hashCode] = drawingGradient;
	        }

	        return drawingGradient;
	    },

	    cleanGradients: function() {
	        var gradients = this.gradients;
	        for (var hashCode in gradients) {
	            gradients[hashCode]._observers = [];//add clear observers method in drawing ObserversMixin
	        }
	    },

	    size: function() {
	        var options = this.options;
	        return new Box(0, 0, options.width, options.height);
	    }
	});

	setDefaultOptions(RootElement, {
	    width: DEFAULT_WIDTH,
	    height: DEFAULT_HEIGHT,
	    background: WHITE,
	    border: {
	        color: BLACK,
	        width: 0
	    },
	    margin: getSpacing(5),
	    zIndex: -2
	});

	function innerRadialStops(options) {
	    var stops = options.stops;
	    var usedSpace = ((options.innerRadius / options.radius) * 100);
	    var length = stops.length;
	    var currentStops = [];

	    for (var i = 0; i < length; i++) {
	        var currentStop = $.extend({}, stops[i]);
	        currentStop.offset = (currentStop.offset * (100 - usedSpace) + usedSpace) / 100;
	        currentStops.push(currentStop);
	    }

	    return currentStops;
	}

	var FloatElement = ChartElement.extend({
	    init: function(options) {
	        ChartElement.fn.init.call(this, options);
	        this._initDirection();
	    },

	    _initDirection: function() {
	        var options = this.options;
	        if (options.vertical) {
	            this.groupAxis = X;
	            this.elementAxis = Y;
	            this.groupSizeField = WIDTH;
	            this.elementSizeField = HEIGHT;
	            this.groupSpacing = options.spacing;
	            this.elementSpacing = options.vSpacing;
	        } else {
	            this.groupAxis = Y;
	            this.elementAxis = X;
	            this.groupSizeField = HEIGHT;
	            this.elementSizeField = WIDTH;
	            this.groupSpacing = options.vSpacing;
	            this.elementSpacing = options.spacing;
	        }
	    },

	    reflow: function(targetBox) {
	        this.box = targetBox.clone();
	        this.reflowChildren();
	    },

	    reflowChildren: function() {
	        var this$1 = this;

	        var ref = this;
	        var box = ref.box;
	        var elementAxis = ref.elementAxis;
	        var groupAxis = ref.groupAxis;
	        var elementSizeField = ref.elementSizeField;
	        var groupSizeField = ref.groupSizeField;
	        var ref$1 = this.groupOptions();
	        var groups = ref$1.groups;
	        var groupsSize = ref$1.groupsSize;
	        var maxGroupElementsSize = ref$1.maxGroupElementsSize;
	        var groupsCount = groups.length;
	        var groupsStart = box[groupAxis + 1] + this.alignStart(groupsSize, box[groupSizeField]());

	        if (groupsCount) {
	            var groupStart = groupsStart;

	            for (var groupIdx = 0; groupIdx < groupsCount; groupIdx++) {
	                var group = groups[groupIdx];
	                var groupElements = group.groupElements;
	                var elementStart = box[elementAxis + 1];
	                var groupElementsCount = groupElements.length;

	                for (var idx = 0; idx < groupElementsCount; idx++) {
	                    var element = groupElements[idx];
	                    var elementSize$$1 = this$1.elementSize(element);
	                    var groupElementStart = groupStart + this$1.alignStart(elementSize$$1[groupSizeField], group.groupSize);

	                    var elementBox = new Box();
	                    elementBox[groupAxis + 1] = groupElementStart;
	                    elementBox[groupAxis + 2] = groupElementStart + elementSize$$1[groupSizeField];
	                    elementBox[elementAxis + 1] = elementStart;
	                    elementBox[elementAxis + 2] = elementStart + elementSize$$1[elementSizeField];

	                    element.reflow(elementBox);

	                    elementStart += elementSize$$1[elementSizeField] + this$1.elementSpacing;
	                }
	                groupStart += group.groupSize + this$1.groupSpacing;
	            }
	            box[groupAxis + 1] = groupsStart;
	            box[groupAxis + 2] = groupsStart + groupsSize;
	            box[elementAxis + 2] = box[elementAxis + 1] + maxGroupElementsSize;
	        }
	    },

	    alignStart: function(size, maxSize) {
	        var start = 0;
	        var align = this.options.align;
	        if (align === RIGHT || align === BOTTOM) {
	            start = maxSize - size;
	        } else if (align === CENTER) {
	            start = (maxSize - size) / 2;
	        }
	        return start;
	    },

	    groupOptions: function() {
	        var this$1 = this;

	        var ref = this;
	        var box = ref.box;
	        var children = ref.children;
	        var elementSizeField = ref.elementSizeField;
	        var groupSizeField = ref.groupSizeField;
	        var elementSpacing = ref.elementSpacing;
	        var groupSpacing = ref.groupSpacing;
	        var maxSize = round(box[elementSizeField]());
	        var childrenCount = children.length;
	        var groups = [];

	        var groupSize = 0;
	        var groupElementsSize = 0;
	        var groupsSize = 0;
	        var maxGroupElementsSize = 0;
	        var groupElements = [];

	        for (var idx = 0; idx < childrenCount; idx++) {
	            var element = children[idx];
	            if (!element.box) {
	                element.reflow(box);
	            }

	            var elementSize$$1 = this$1.elementSize(element);
	            if (this$1.options.wrap && round(groupElementsSize + elementSpacing + elementSize$$1[elementSizeField]) > maxSize) {
	                groups.push({
	                    groupElements: groupElements,
	                    groupSize: groupSize,
	                    groupElementsSize: groupElementsSize
	                });
	                maxGroupElementsSize = Math.max(maxGroupElementsSize, groupElementsSize);
	                groupsSize += groupSpacing + groupSize;
	                groupSize = 0;
	                groupElementsSize = 0;
	                groupElements = [];
	            }
	            groupSize = Math.max(groupSize, elementSize$$1[groupSizeField]);
	            if (groupElementsSize > 0) {
	                groupElementsSize += elementSpacing;
	            }
	            groupElementsSize += elementSize$$1[elementSizeField];
	            groupElements.push(element);
	        }

	        groups.push({
	            groupElements: groupElements,
	            groupSize: groupSize,
	            groupElementsSize: groupElementsSize
	        });
	        maxGroupElementsSize = Math.max(maxGroupElementsSize, groupElementsSize);
	        groupsSize += groupSize;

	        return {
	            groups: groups,
	            groupsSize: groupsSize,
	            maxGroupElementsSize: maxGroupElementsSize
	        };
	    },

	    elementSize: function(element) {
	        return {
	            width: element.box.width(),
	            height: element.box.height()
	        };
	    },

	    createVisual: function() {}
	});

	setDefaultOptions(FloatElement, {
	    vertical: true,
	    wrap: true,
	    vSpacing: 0,
	    spacing: 0
	});

	var DrawingText = drawing.Text;

	var Text = ChartElement.extend({
	    init: function(content, options) {
	        ChartElement.fn.init.call(this, options);

	        this.content = content;

	        // Calculate size
	        this.reflow(new Box());
	    },

	    reflow: function(targetBox) {
	        var options = this.options;
	        var size = options.size = util.measureText(this.content, { font: options.font });

	        this.baseline = size.baseline;

	        this.box = new Box(targetBox.x1, targetBox.y1,
	                targetBox.x1 + size.width, targetBox.y1 + size.height);
	    },

	    createVisual: function() {
	        var ref = this.options;
	        var font = ref.font;
	        var color = ref.color;
	        var opacity = ref.opacity;
	        var cursor = ref.cursor;

	        this.visual = new DrawingText(this.content, this.box.toRect().topLeft(), {
	            font: font,
	            fill: { color: color, opacity: opacity },
	            cursor: cursor
	        });
	    }
	});

	setDefaultOptions(Text, {
	    font: DEFAULT_FONT,
	    color: BLACK
	});

	function rectToBox(rect) {
	    var origin = rect.origin;
	    var bottomRight = rect.bottomRight();

	    return new Box(origin.x, origin.y, bottomRight.x, bottomRight.y);
	}

	var ROWS_SPLIT_REGEX = /\n/m;

	var TextBox = BoxElement.extend({
	    init: function(content, options, data) {
	        BoxElement.fn.init.call(this, options);
	        this.content = content;
	        this.data = data;

	        this._initContainer();
	        if (this.options._autoReflow !== false) {
	            this.reflow(new Box());
	        }
	    },

	    _initContainer: function() {
	        var options = this.options;
	        var rows = String(this.content).split(ROWS_SPLIT_REGEX);
	        var floatElement = new FloatElement({ vertical: true, align: options.align, wrap: false });
	        var textOptions = deepExtend({ }, options, { opacity: 1, animation: null });

	        this.container = floatElement;
	        this.append(floatElement);

	        for (var rowIdx = 0; rowIdx < rows.length; rowIdx++) {
	            var text = new Text(rows[rowIdx].trim(), textOptions);
	            floatElement.append(text);
	        }
	    },

	    reflow: function(targetBox) {
	        var options = this.options;
	        var visualFn = options.visual;
	        this.container.options.align = options.align;

	        if (visualFn && !this._boxReflow) {
	            var visualBox = targetBox;
	            if (!visualBox.hasSize()) {
	                this._boxReflow = true;
	                this.reflow(visualBox);
	                this._boxReflow = false;
	                visualBox = this.box;
	            }
	            var visual = this.visual = visualFn(this.visualContext(visualBox));

	            if (visual) {
	                visualBox = rectToBox(visual.clippedBBox() || new Rect());

	                visual.options.zIndex = options.zIndex;
	            }

	            this.box = this.contentBox = this.paddingBox = visualBox;
	        } else {
	            BoxElement.fn.reflow.call(this, targetBox);

	            if (options.rotation) {
	                var margin = getSpacing(options.margin);
	                var box = this.box.unpad(margin);

	                this.targetBox = targetBox;
	                this.normalBox = box.clone();

	                box = this.rotate();
	                box.translate(margin.left - margin.right, margin.top - margin.bottom);

	                this.rotatedBox = box.clone();

	                box.pad(margin);
	            }
	        }
	    },

	    createVisual: function() {
	        var options = this.options;

	        this.visual = new Group({
	            transform: this.rotationTransform(),
	            zIndex: options.zIndex,
	            noclip: options.noclip
	        });

	        if (this.hasBox()) {
	            var box = Path.fromRect(this.paddingBox.toRect(), this.visualStyle());
	            this.visual.append(box);
	        }
	    },

	    renderVisual: function() {
	        if (!this.options.visible) {
	            return;
	        }

	        if (this.options.visual) {
	            var visual = this.visual;
	            if (visual && !defined(visual.options.noclip)) {
	                visual.options.noclip = this.options.noclip;
	            }
	            this.addVisual();
	            this.createAnimation();
	        } else {
	            BoxElement.fn.renderVisual.call(this);
	        }
	    },

	    visualContext: function(targetBox) {
	        var this$1 = this;

	        var context = {
	            text: this.content,
	            rect: targetBox.toRect(),
	            sender: this.getSender(),
	            options: this.options,
	            createVisual: function () {
	                this$1._boxReflow = true;
	                this$1.reflow(targetBox);
	                this$1._boxReflow = false;
	                return this$1.getDefaultVisual();
	            }
	        };
	        if (this.data) {
	            $.extend(context, this.data);
	        }

	        return context;
	    },

	    getDefaultVisual: function() {
	        this.createVisual();
	        this.renderChildren();
	        var visual = this.visual;
	        delete this.visual;
	        return visual;
	    },

	    rotate: function() {
	        var options = this.options;
	        this.box.rotate(options.rotation);
	        this.align(this.targetBox, X, options.align);
	        this.align(this.targetBox, Y, options.vAlign);
	        return this.box;
	    },

	    rotationTransform: function() {
	        var rotation = this.options.rotation;
	        if (!rotation) {
	            return null;
	        }

	        var ref = this.normalBox.center();
	        var cx = ref.x;
	        var cy = ref.y;
	        var boxCenter = this.rotatedBox.center();

	        return geometryTransform()
	                   .translate(boxCenter.x - cx, boxCenter.y - cy)
	                   .rotate(rotation, [ cx, cy ]);
	    }
	});

	var Title = ChartElement.extend({
	    init: function(options) {
	        ChartElement.fn.init.call(this, options);

	        this.append(
	            new TextBox(this.options.text, $.extend({}, this.options, {
	                vAlign: this.options.position
	            }))
	        );
	    },

	    reflow: function(targetBox) {
	        ChartElement.fn.reflow.call(this, targetBox);
	        this.box.snapTo(targetBox, X);
	    }
	});

	Title.buildTitle = function(options, parent, defaultOptions) {
	    var titleOptions = options;

	    if (typeof options === "string") {
	        titleOptions = { text: options };
	    }

	    titleOptions = $.extend({ visible: true }, defaultOptions, titleOptions);

	    var title;
	    if (titleOptions && titleOptions.visible && titleOptions.text) {
	        title = new Title(titleOptions);
	        parent.append(title);
	    }

	    return title;
	};

	setDefaultOptions(Title, {
	    color: BLACK,
	    position: TOP,
	    align: CENTER,
	    margin: getSpacing(5),
	    padding: getSpacing(5)
	});

	var AxisLabel = TextBox.extend({
	    init: function(value, text, index, dataItem, options) {
	        TextBox.fn.init.call(this, text, options);

	        this.text = text;
	        this.value = value;
	        this.index = index;
	        this.dataItem = dataItem;
	        this.reflow(new Box());
	    },

	    visualContext: function(targetBox) {
	        var context = TextBox.fn.visualContext.call(this, targetBox);

	        context.value = this.value;
	        context.dataItem = this.dataItem;
	        context.format = this.options.format;
	        context.culture = this.options.culture;

	        return context;
	    },

	    click: function(widget, e) {

	        widget.trigger(AXIS_LABEL_CLICK, {
	            element: eventElement(e),
	            value: this.value,
	            text: this.text,
	            index: this.index,
	            dataItem: this.dataItem,
	            axis: this.parent.options
	        });
	    },

	    rotate: function() {
	        if (this.options.alignRotation !== CENTER) {
	            var box = this.normalBox.toRect();
	            var transform = this.rotationTransform();

	            this.box = rectToBox(box.bbox(transform.matrix()));
	        } else {
	            TextBox.fn.rotate.call(this);
	        }

	        return this.box;
	    },

	    rotationTransform: function() {
	        var options = this.options;
	        var rotation = options.rotation;
	        if (!rotation) {
	            return null;
	        }

	        if (options.alignRotation === CENTER) {
	            return TextBox.fn.rotationTransform.call(this);
	        }

	        var rotationMatrix = geometryTransform().rotate(rotation).matrix();
	        var box = this.normalBox.toRect();
	        var rect = this.targetBox.toRect();

	        var rotationOrigin = options.rotationOrigin || TOP;
	        var alignAxis = rotationOrigin === TOP || rotationOrigin === BOTTOM ? X : Y;
	        var distanceAxis = rotationOrigin === TOP || rotationOrigin === BOTTOM ? Y : X;
	        var axisAnchor = rotationOrigin === TOP || rotationOrigin === LEFT ? rect.origin : rect.bottomRight();

	        var topLeft = box.topLeft().transformCopy(rotationMatrix);
	        var topRight = box.topRight().transformCopy(rotationMatrix);
	        var bottomRight = box.bottomRight().transformCopy(rotationMatrix);
	        var bottomLeft = box.bottomLeft().transformCopy(rotationMatrix);
	        var rotatedBox = Rect.fromPoints(topLeft, topRight, bottomRight, bottomLeft);

	        var translate = {};
	        translate[distanceAxis] = rect.origin[distanceAxis] - rotatedBox.origin[distanceAxis];

	        var distanceLeft = Math.abs(topLeft[distanceAxis] + translate[distanceAxis] - axisAnchor[distanceAxis]);
	        var distanceRight = Math.abs(topRight[distanceAxis] + translate[distanceAxis] - axisAnchor[distanceAxis]);

	        var alignStart, alignEnd;

	        if (round(distanceLeft, DEFAULT_PRECISION) === round(distanceRight, DEFAULT_PRECISION)) {
	            alignStart = topLeft;
	            alignEnd = topRight;
	        } else if (distanceRight < distanceLeft) {
	            alignStart = topRight;
	            alignEnd = bottomRight;
	        } else {
	            alignStart = topLeft;
	            alignEnd = bottomLeft;
	        }

	        var alignCenter = alignStart[alignAxis] + (alignEnd[alignAxis] - alignStart[alignAxis]) / 2;
	        translate[alignAxis] = rect.center()[alignAxis] - alignCenter;

	        return geometryTransform()
	            .translate(translate.x, translate.y)
	            .rotate(rotation);
	    }
	});

	setDefaultOptions(AxisLabel, {
	    _autoReflow: false
	});

	var DEFAULT_ICON_SIZE = 7;
	var DEFAULT_LABEL_COLOR = "#fff";

	var Note = BoxElement.extend({
	    init: function(fields, options, chartService) {
	        BoxElement.fn.init.call(this, options);

	        this.fields = fields;
	        this.chartService = chartService;

	        this.render();
	    },

	    hide: function() {
	        this.options.visible = false;
	    },

	    show: function() {
	        this.options.visible = true;
	    },

	    render: function() {
	        var this$1 = this;

	        var options = this.options;

	        if (options.visible) {
	            var label = options.label;
	            var icon = options.icon;
	            var box = new Box();
	            var childAlias = function () { return this$1; };
	            var size = icon.size;
	            var text = this.fields.text;
	            var width, height;

	            if (defined(label) && label.visible) {
	                var noteTemplate = getTemplate(label);
	                if (noteTemplate) {
	                    text = noteTemplate(this.fields);
	                } else if (label.format) {
	                    text = this.chartService.format.auto(label.format, text);
	                }

	                if (!label.color) {
	                    label.color = label.position === INSIDE ? DEFAULT_LABEL_COLOR : icon.background;
	                }

	                this.label = new TextBox(text, deepExtend({}, label));
	                this.label.aliasFor = childAlias;

	                if (label.position === INSIDE && !defined(size)) {
	                    if (icon.type === CIRCLE) {
	                        size = Math.max(this.label.box.width(), this.label.box.height());
	                    } else {
	                        width = this.label.box.width();
	                        height = this.label.box.height();
	                    }
	                    box.wrap(this.label.box);
	                }
	            }

	            icon.width = width || size || DEFAULT_ICON_SIZE;
	            icon.height = height || size || DEFAULT_ICON_SIZE;

	            var marker = new ShapeElement(deepExtend({}, icon));
	            marker.aliasFor = childAlias;

	            this.marker = marker;
	            this.append(marker);

	            if (this.label) {
	                this.append(this.label);
	            }

	            marker.reflow(new Box());
	            this.wrapperBox = box.wrap(marker.box);
	        }
	    },

	    reflow: function(targetBox) {
	        var ref = this;
	        var options = ref.options;
	        var label = ref.label;
	        var marker = ref.marker;
	        var wrapperBox = ref.wrapperBox;
	        var center = targetBox.center();
	        var length = options.line.length;
	        var position = options.position;

	        // TODO: Review
	        if (options.visible) {
	            var lineStart, box, contentBox;

	            if (inArray(position, [ LEFT, RIGHT ])) {
	                if (position === LEFT) {
	                    contentBox = wrapperBox.alignTo(targetBox, position).translate(-length, targetBox.center().y - wrapperBox.center().y);

	                    if (options.line.visible) {
	                        lineStart = [ targetBox.x1, center.y ];
	                        this.linePoints = [
	                            lineStart,
	                            [ contentBox.x2, center.y ]
	                        ];
	                        box = contentBox.clone().wrapPoint(lineStart);
	                    }
	                } else {
	                    contentBox = wrapperBox.alignTo(targetBox, position).translate(length, targetBox.center().y - wrapperBox.center().y);

	                    if (options.line.visible) {
	                        lineStart = [ targetBox.x2, center.y ];
	                        this.linePoints = [
	                            lineStart,
	                            [ contentBox.x1, center.y ]
	                        ];
	                        box = contentBox.clone().wrapPoint(lineStart);
	                    }
	                }
	            } else {
	                if (position === BOTTOM) {
	                    contentBox = wrapperBox.alignTo(targetBox, position).translate(targetBox.center().x - wrapperBox.center().x, length);

	                    if (options.line.visible) {
	                        lineStart = [ center.x, targetBox.y2 ];
	                        this.linePoints = [
	                            lineStart,
	                            [ center.x, contentBox.y1 ]
	                        ];
	                        box = contentBox.clone().wrapPoint(lineStart);
	                    }
	                } else {
	                    contentBox = wrapperBox.alignTo(targetBox, position).translate(targetBox.center().x - wrapperBox.center().x, -length);

	                    if (options.line.visible) {
	                        lineStart = [ center.x, targetBox.y1 ];
	                        this.linePoints = [
	                            lineStart,
	                            [ center.x, contentBox.y2 ]
	                        ];
	                        box = contentBox.clone().wrapPoint(lineStart);
	                    }
	                }
	            }

	            if (marker) {
	                marker.reflow(contentBox);
	            }

	            if (label) {
	                label.reflow(contentBox);
	                if (marker) {
	                    if (options.label.position === OUTSIDE) {
	                        label.box.alignTo(marker.box, position);
	                    }
	                    label.reflow(label.box);
	                }
	            }

	            this.contentBox = contentBox;
	            this.targetBox = targetBox;
	            this.box = box || contentBox;
	        }
	    },

	    createVisual: function() {
	        BoxElement.fn.createVisual.call(this);
	        this.visual.options.noclip = this.options.noclip;

	        if (this.options.visible) {
	            this.createLine();
	        }
	    },

	    renderVisual: function() {
	        var this$1 = this;

	        var options = this.options;
	        var customVisual = options.visual;
	        if (options.visible && customVisual) {
	            this.visual = customVisual($.extend(this.fields, {
	                sender: this.getSender(),
	                rect: this.targetBox.toRect(),
	                options: {
	                    background: options.background,
	                    border: options.background,
	                    icon: options.icon,
	                    label: options.label,
	                    line: options.line,
	                    position: options.position,
	                    visible: options.visible
	                },
	                createVisual: function () {
	                    this$1.createVisual();
	                    this$1.renderChildren();
	                    var defaultVisual = this$1.visual;
	                    delete this$1.visual;
	                    return defaultVisual;
	                }
	            }));
	            this.addVisual();
	        } else {
	            BoxElement.fn.renderVisual.call(this);
	        }
	    },

	    createLine: function() {
	        var options = this.options.line;

	        if (this.linePoints) {
	            var path = Path.fromPoints(this.linePoints, {
	                stroke: {
	                    color: options.color,
	                    width: options.width,
	                    dashType: options.dashType
	                }
	            });

	            alignPathToPixel(path);
	            this.visual.append(path);
	        }
	    },

	    click: function(widget, e) {
	        var args = this.eventArgs(e);

	        if (!widget.trigger(NOTE_CLICK, args)) {
	            e.preventDefault();
	        }
	    },

	    over: function(widget, e) {
	        var args = this.eventArgs(e);

	        if (!widget.trigger(NOTE_HOVER, args)) {
	            e.preventDefault();
	        }
	    },

	    out: function(widget, e) {
	        var args = this.eventArgs(e);

	        widget.trigger(NOTE_LEAVE, args);
	    },

	    eventArgs: function(e) {
	        var options = this.options;

	        return $.extend(this.fields, {
	            element: eventElement(e),
	            text: defined(options.label) ? options.label.text : "",
	            visual: this.visual
	        });
	    }
	});

	setDefaultOptions(Note, {
	    icon: {
	        visible: true,
	        type: CIRCLE
	    },
	    label: {
	        position: INSIDE,
	        visible: true,
	        align: CENTER,
	        vAlign: CENTER
	    },
	    line: {
	        visible: true
	    },
	    visible: true,
	    position: TOP,
	    zIndex: 2
	});

	function createAxisTick(options, tickOptions) {
	    var tickX = options.tickX;
	    var tickY = options.tickY;
	    var position = options.position;

	    var tick = new Path({
	        stroke: {
	            width: tickOptions.width,
	            color: tickOptions.color
	        }
	    });

	    if (options.vertical) {
	        tick.moveTo(tickX, position)
	            .lineTo(tickX + tickOptions.size, position);
	    } else {
	        tick.moveTo(position, tickY)
	            .lineTo(position, tickY + tickOptions.size);
	    }

	    alignPathToPixel(tick);

	    return tick;
	}

	function createAxisGridLine(options, gridLine) {
	    var lineStart = options.lineStart;
	    var lineEnd = options.lineEnd;
	    var position = options.position;

	    var line = new Path({
	        stroke: {
	            width: gridLine.width,
	            color: gridLine.color,
	            dashType: gridLine.dashType
	        }
	    });

	    if (options.vertical) {
	        line.moveTo(lineStart, position)
	            .lineTo(lineEnd, position);
	    } else {
	        line.moveTo(position, lineStart)
	            .lineTo(position, lineEnd);
	    }

	    alignPathToPixel(line);

	    return line;
	}

	var Axis = ChartElement.extend({
	    init: function(options, chartService) {
	        if (chartService === void 0) { chartService = new ChartService(); }

	        ChartElement.fn.init.call(this, options);

	        this.chartService = chartService;

	        if (!this.options.visible) {
	            this.options = deepExtend({}, this.options, {
	                labels: {
	                    visible: false
	                },
	                line: {
	                    visible: false
	                },
	                margin: 0,
	                majorTickSize: 0,
	                minorTickSize: 0
	            });
	        }

	        this.options.minorTicks = deepExtend({}, {
	            color: this.options.line.color,
	            width: this.options.line.width,
	            visible: this.options.minorTickType !== NONE
	        }, this.options.minorTicks, {
	            size: this.options.minorTickSize,
	            align: this.options.minorTickType
	        });

	        this.options.majorTicks = deepExtend({}, {
	            color: this.options.line.color,
	            width: this.options.line.width,
	            visible: this.options.majorTickType !== NONE
	        }, this.options.majorTicks, {
	            size: this.options.majorTickSize,
	            align: this.options.majorTickType
	        });

	        this.initFields();

	        if (!this.options._deferLabels) {
	            this.createLabels();
	        }

	        this.createTitle();
	        this.createNotes();
	    },

	    initFields: function() {
	    },

	    labelsRange: function() {
	        return {
	            min: this.options.labels.skip,
	            max: this.labelsCount()
	        };
	    },

	    createLabels: function() {
	        var this$1 = this;

	        var options = this.options;
	        var align = options.vertical ? RIGHT : CENTER;
	        var labelOptions = deepExtend({ }, options.labels, {
	            align: align,
	            zIndex: options.zIndex
	        });
	        var step = Math.max(1, labelOptions.step);

	        this.clearLabels();

	        if (labelOptions.visible) {
	            var range = this.labelsRange();
	            var rotation = labelOptions.rotation;

	            if (isObject(rotation)) {
	                labelOptions.alignRotation = rotation.align;
	                labelOptions.rotation = rotation.angle;
	            }

	            if (labelOptions.rotation === "auto") {
	                labelOptions.rotation = 0;
	                options.autoRotateLabels = true;
	            }

	            for (var idx = range.min; idx < range.max; idx += step) {
	                var label = this$1.createAxisLabel(idx, labelOptions);
	                if (label) {
	                    this$1.append(label);
	                    this$1.labels.push(label);
	                }
	            }
	        }
	    },

	    clearLabels: function() {
	        this.children = grep(this.children, function (child) { return !(child instanceof AxisLabel); });
	        this.labels = [];
	    },

	    clearTitle: function() {
	        var this$1 = this;

	        if (this.title) {
	            this.children = grep(this.children, function (child) { return child !== this$1.title; });
	            this.title = undefined;
	        }
	    },

	    clear: function() {
	        this.clearLabels();
	        this.clearTitle();
	    },

	    lineBox: function() {
	        var ref = this;
	        var options = ref.options;
	        var box = ref.box;
	        var vertical = options.vertical;
	        var mirror = options.labels.mirror;
	        var axisX = mirror ? box.x1 : box.x2;
	        var axisY = mirror ? box.y2 : box.y1;
	        var lineWidth = options.line.width || 0;

	        return vertical ?
	            new Box(axisX, box.y1, axisX, box.y2 - lineWidth) :
	            new Box(box.x1, axisY, box.x2 - lineWidth, axisY);
	    },

	    createTitle: function() {
	        var options = this.options;
	        var titleOptions = deepExtend({
	            rotation: options.vertical ? -90 : 0,
	            text: "",
	            zIndex: 1,
	            visualSize: true
	        }, options.title);

	        if (titleOptions.visible && titleOptions.text) {
	            var title = new TextBox(titleOptions.text, titleOptions);
	            this.append(title);
	            this.title = title;
	        }
	    },

	    createNotes: function() {
	        var this$1 = this;

	        var options = this.options;
	        var notes = options.notes;
	        var items = notes.data || [];

	        this.notes = [];

	        for (var i = 0; i < items.length; i++) {
	            var item = deepExtend({}, notes, items[i]);
	            item.value = this$1.parseNoteValue(item.value);

	            var note = new Note({
	                value: item.value,
	                text: item.label.text,
	                dataItem: item
	            }, item, this$1.chartService);

	            if (note.options.visible) {
	                if (defined(note.options.position)) {
	                    if (options.vertical && !inArray(note.options.position, [ LEFT, RIGHT ])) {
	                        note.options.position = options.reverse ? LEFT : RIGHT;
	                    } else if (!options.vertical && !inArray(note.options.position, [ TOP, BOTTOM ])) {
	                        note.options.position = options.reverse ? BOTTOM : TOP;
	                    }
	                } else {
	                    if (options.vertical) {
	                        note.options.position = options.reverse ? LEFT : RIGHT;
	                    } else {
	                        note.options.position = options.reverse ? BOTTOM : TOP;
	                    }
	                }
	                this$1.append(note);
	                this$1.notes.push(note);
	            }
	        }
	    },

	    parseNoteValue: function(value) {
	        return value;
	    },

	    renderVisual: function() {
	        ChartElement.fn.renderVisual.call(this);

	        this.createPlotBands();
	    },

	    createVisual: function() {
	        ChartElement.fn.createVisual.call(this);

	        this.createBackground();
	        this.createLine();
	    },

	    gridLinesVisual: function() {
	        var gridLines = this._gridLines;
	        if (!gridLines) {
	            gridLines = this._gridLines = new Group({
	                zIndex: -2
	            });
	            this.appendVisual(this._gridLines);
	        }

	        return gridLines;
	    },

	    createTicks: function(lineGroup) {
	        var options = this.options;
	        var lineBox = this.lineBox();
	        var mirror = options.labels.mirror;
	        var majorUnit = options.majorTicks.visible ? options.majorUnit : 0;
	        var tickLineOptions = {
	            // TODO
	            // _alignLines: options._alignLines,
	            vertical: options.vertical
	        };

	        function render(tickPositions, tickOptions, skipUnit) {
	            var count = tickPositions.length;
	            var step = Math.max(1, tickOptions.step);

	            if (tickOptions.visible) {
	                for (var i = tickOptions.skip; i < count; i += step) {
	                    if (defined(skipUnit) && (i % skipUnit === 0)) {
	                        continue;
	                    }

	                    tickLineOptions.tickX = mirror ? lineBox.x2 : lineBox.x2 - tickOptions.size;
	                    tickLineOptions.tickY = mirror ? lineBox.y1 - tickOptions.size : lineBox.y1;
	                    tickLineOptions.position = tickPositions[i];

	                    lineGroup.append(createAxisTick(tickLineOptions, tickOptions));
	                }
	            }
	        }

	        render(this.getMajorTickPositions(), options.majorTicks);
	        render(this.getMinorTickPositions(), options.minorTicks, majorUnit / options.minorUnit);
	    },

	    createLine: function() {
	        var options = this.options;
	        var line = options.line;
	        var lineBox = this.lineBox();

	        if (line.width > 0 && line.visible) {
	            var path = new Path({
	                stroke: {
	                    width: line.width,
	                    color: line.color,
	                    dashType: line.dashType
	                }

	                /* TODO
	                zIndex: line.zIndex,
	                */
	            });

	            path.moveTo(lineBox.x1, lineBox.y1)
	                .lineTo(lineBox.x2, lineBox.y2);

	            if (options._alignLines) {
	                alignPathToPixel(path);
	            }

	            var group = this._lineGroup = new Group();
	            group.append(path);

	            this.visual.append(group);
	            this.createTicks(group);
	        }
	    },

	    getActualTickSize: function() {
	        var options = this.options;
	        var tickSize = 0;

	        if (options.majorTicks.visible && options.minorTicks.visible) {
	            tickSize = Math.max(options.majorTicks.size, options.minorTicks.size);
	        } else if (options.majorTicks.visible) {
	            tickSize = options.majorTicks.size;
	        } else if (options.minorTicks.visible) {
	            tickSize = options.minorTicks.size;
	        }

	        return tickSize;
	    },

	    createBackground: function() {
	        var ref = this;
	        var options = ref.options;
	        var box = ref.box;
	        var background = options.background;

	        if (background) {
	            this._backgroundPath = Path.fromRect(box.toRect(), {
	                fill: {
	                    color: background
	                },
	                stroke: null
	            });

	            this.visual.append(this._backgroundPath);
	        }
	    },

	    createPlotBands: function() {
	        var this$1 = this;

	        var options = this.options;
	        var plotBands = options.plotBands || [];
	        var vertical = options.vertical;
	        var plotArea = this.plotArea;

	        if (plotBands.length === 0) {
	            return;
	        }

	        var group = this._plotbandGroup = new Group({
	            zIndex: -1
	        });

	        var altAxis = grep(this.pane.axes, function (axis) { return axis.options.vertical !== this$1.options.vertical; })[0];

	        for (var idx = 0; idx < plotBands.length; idx++) {
	            var item = plotBands[idx];
	            var slotX = (void 0), slotY = (void 0);
	            var labelOptions = item.label;
	            var label = (void 0);

	            if (vertical) {
	                slotX = (altAxis || plotArea.axisX).lineBox();
	                slotY = this$1.getSlot(item.from, item.to, true);
	            } else {
	                slotX = this$1.getSlot(item.from, item.to, true);
	                slotY = (altAxis || plotArea.axisY).lineBox();
	            }

	            if (labelOptions) {
	                labelOptions.vAlign = labelOptions.position || LEFT;
	                label = this$1.createPlotBandLabel(
	                    labelOptions,
	                    item,
	                    new Box(
	                        slotX.x1,
	                        slotY.y1,
	                        slotX.x2,
	                        slotY.y2
	                    )

	                );
	            }

	            if (slotX.width() !== 0 && slotY.height() !== 0) {
	                var bandRect = new Rect(
	                    [ slotX.x1, slotY.y1 ],
	                    [ slotX.width(), slotY.height() ]
	                );

	                var path = Path.fromRect(bandRect, {
	                    fill: {
	                        color: item.color,
	                        opacity: item.opacity
	                    },
	                    stroke: null
	                });

	                group.append(path);
	                if (label) {
	                    group.append(label);
	                }
	            }
	        }

	        this.appendVisual(group);
	    },

	    createPlotBandLabel: function(label, item, box) {

	        if (label.visible === false) {
	            return null;
	        }

	        var text = label.text;
	        var textbox;

	        if (defined(label) && label.visible) {
	            var labelTemplate = getTemplate(label);
	            if (labelTemplate) {
	                text = labelTemplate({ text: text, item: item });
	            } else if (label.format) {
	                text = this.chartService.format.auto(label.format, text);
	            }

	            if (!label.color) {
	                label.color = this.options.labels.color;
	            }
	        }

	        textbox = new TextBox(text, label);
	        textbox.reflow(box);
	        textbox.renderVisual();

	        return textbox.visual;
	    },

	    createGridLines: function(altAxis) {
	        var options = this.options;
	        var minorGridLines = options.minorGridLines;
	        var majorGridLines = options.majorGridLines;
	        var minorUnit = options.minorUnit;
	        var vertical = options.vertical;
	        var axisLineVisible = altAxis.options.line.visible;
	        var majorUnit = majorGridLines.visible ? options.majorUnit : 0;
	        var lineBox = altAxis.lineBox();
	        var linePos = lineBox[vertical ? "y1" : "x1"];
	        var lineOptions = {
	            lineStart: lineBox[vertical ? "x1" : "y1"],
	            lineEnd: lineBox[vertical ? "x2" : "y2"],
	            vertical: vertical
	        };
	        var majorTicks = [];

	        var container = this.gridLinesVisual();

	        function render(tickPositions, gridLine, skipUnit) {
	            var count = tickPositions.length;
	            var step = Math.max(1, gridLine.step);

	            if (gridLine.visible) {
	                for (var i = gridLine.skip; i < count; i += step) {
	                    var pos = round(tickPositions[i]);
	                    if (!inArray(pos, majorTicks)) {
	                        if (i % skipUnit !== 0 && (!axisLineVisible || linePos !== pos)) {
	                            lineOptions.position = pos;
	                            container.append(createAxisGridLine(lineOptions, gridLine));

	                            majorTicks.push(pos);
	                        }
	                    }
	                }
	            }
	        }

	        render(this.getMajorTickPositions(), majorGridLines);
	        render(this.getMinorTickPositions(), minorGridLines, majorUnit / minorUnit);

	        return container.children;
	    },

	    reflow: function(box) {
	        var ref = this;
	        var options = ref.options;
	        var labels = ref.labels;
	        var title = ref.title;
	        var vertical = options.vertical;
	        var count = labels.length;
	        var sizeFn = vertical ? WIDTH : HEIGHT;
	        var titleSize = title ? title.box[sizeFn]() : 0;
	        var space = this.getActualTickSize() + options.margin + titleSize;
	        var rootBox = (this.getRoot() || {}).box || box;
	        var boxSize = rootBox[sizeFn]();
	        var maxLabelSize = 0;

	        for (var i = 0; i < count; i++) {
	            var labelSize = labels[i].box[sizeFn]();
	            if (labelSize + space <= boxSize) {
	                maxLabelSize = Math.max(maxLabelSize, labelSize);
	            }
	        }

	        if (vertical) {
	            this.box = new Box(
	                box.x1, box.y1,
	                box.x1 + maxLabelSize + space, box.y2
	            );
	        } else {
	            this.box = new Box(
	                box.x1, box.y1,
	                box.x2, box.y1 + maxLabelSize + space
	            );
	        }

	        this.arrangeTitle();
	        this.arrangeLabels();
	        this.arrangeNotes();
	    },

	    getLabelsTickPositions: function() {
	        return this.getMajorTickPositions();
	    },

	    labelTickIndex: function(label) {
	        return label.index;
	    },

	    arrangeLabels: function() {
	        var this$1 = this;

	        var ref = this;
	        var options = ref.options;
	        var labels = ref.labels;
	        var labelsBetweenTicks = this.labelsBetweenTicks();
	        var vertical = options.vertical;
	        var lineBox = this.lineBox();
	        var mirror = options.labels.mirror;
	        var tickPositions = this.getLabelsTickPositions();
	        var labelOffset = this.getActualTickSize() + options.margin;

	        for (var idx = 0; idx < labels.length; idx++) {
	            var label = labels[idx];
	            var tickIx = this$1.labelTickIndex(label);
	            var labelSize = vertical ? label.box.height() : label.box.width();
	            var labelPos = tickPositions[tickIx] - (labelSize / 2);
	            var labelBox = (void 0), firstTickPosition = (void 0), nextTickPosition = (void 0);

	            if (vertical) {
	                if (labelsBetweenTicks) {
	                    firstTickPosition = tickPositions[tickIx];
	                    nextTickPosition = tickPositions[tickIx + 1];

	                    var middle = firstTickPosition + (nextTickPosition - firstTickPosition) / 2;
	                    labelPos = middle - (labelSize / 2);
	                }

	                var labelX = lineBox.x2;

	                if (mirror) {
	                    labelX += labelOffset;
	                    label.options.rotationOrigin = LEFT;
	                } else {
	                    labelX -= labelOffset + label.box.width();
	                    label.options.rotationOrigin = RIGHT;
	                }

	                labelBox = label.box.move(labelX, labelPos);
	            } else {
	                if (labelsBetweenTicks) {
	                    firstTickPosition = tickPositions[tickIx];
	                    nextTickPosition = tickPositions[tickIx + 1];
	                } else {
	                    firstTickPosition = labelPos;
	                    nextTickPosition = labelPos + labelSize;
	                }

	                var labelY = lineBox.y1;

	                if (mirror) {
	                    labelY -= labelOffset + label.box.height();
	                    label.options.rotationOrigin = BOTTOM;
	                } else {
	                    labelY += labelOffset;
	                    label.options.rotationOrigin = TOP;
	                }

	                labelBox = new Box(firstTickPosition, labelY,
	                                nextTickPosition, labelY + label.box.height());
	            }

	            label.reflow(labelBox);
	        }
	    },

	    autoRotateLabels: function() {
	        if (this.options.autoRotateLabels && !this.options.vertical) {
	            var tickPositions = this.getMajorTickPositions();
	            var labels = this.labels;
	            var angle;

	            for (var idx = 0; idx < labels.length; idx++) {
	                var width = Math.abs(tickPositions[idx + 1] - tickPositions[idx]);
	                var labelBox = labels[idx].box;

	                if (labelBox.width() > width) {
	                    if (labelBox.height() > width) {
	                        angle = -90;
	                        break;
	                    }
	                    angle = -45;
	                }
	            }

	            if (angle) {
	                for (var idx$1 = 0; idx$1 < labels.length; idx$1++) {
	                    labels[idx$1].options.rotation = angle;
	                    labels[idx$1].reflow(new Box());
	                }
	                return true;
	            }
	        }
	    },

	    arrangeTitle: function() {
	        var ref = this;
	        var options = ref.options;
	        var title = ref.title;
	        var mirror = options.labels.mirror;
	        var vertical = options.vertical;

	        if (title) {
	            if (vertical) {
	                title.options.align = mirror ? RIGHT : LEFT;
	                title.options.vAlign = title.options.position;
	            } else {
	                title.options.align = title.options.position;
	                title.options.vAlign = mirror ? TOP : BOTTOM;
	            }

	            title.reflow(this.box);
	        }
	    },

	    arrangeNotes: function() {
	        var this$1 = this;

	        for (var idx = 0; idx < this.notes.length; idx++) {
	            var item = this$1.notes[idx];
	            var value = item.options.value;
	            var slot = (void 0);

	            if (defined(value)) {
	                if (this$1.shouldRenderNote(value)) {
	                    item.show();
	                } else {
	                    item.hide();
	                }

	                slot = this$1.noteSlot(value);
	            } else {
	                item.hide();
	            }

	            item.reflow(slot || this$1.lineBox());
	        }
	    },

	    noteSlot: function(value) {
	        return this.getSlot(value);
	    },

	    alignTo: function(secondAxis) {
	        var lineBox = secondAxis.lineBox();
	        var vertical = this.options.vertical;
	        var pos = vertical ? Y : X;

	        this.box.snapTo(lineBox, pos);
	        if (vertical) {
	            this.box.shrink(0, this.lineBox().height() - lineBox.height());
	        } else {
	            this.box.shrink(this.lineBox().width() - lineBox.width(), 0);
	        }
	        this.box[pos + 1] -= this.lineBox()[pos + 1] - lineBox[pos + 1];
	        this.box[pos + 2] -= this.lineBox()[pos + 2] - lineBox[pos + 2];
	    },

	    axisLabelText: function(value, dataItem, options) {
	        var tmpl = getTemplate(options);
	        var text = value;

	        if (tmpl) {
	            text = tmpl({ value: value, dataItem: dataItem, format: options.format, culture: options.culture });
	        } else if (options.format) {
	            text = this.chartService.format.localeAuto(options.format, [ value ], options.culture);
	        }

	        return text;
	    },

	    slot: function(from , to, limit) {
	        var slot = this.getSlot(from, to, limit);
	        if (slot) {
	            return slot.toRect();
	        }
	    },

	    contentBox: function() {
	        var box = this.box.clone();
	        var labels = this.labels;
	        if (labels.length) {
	            var axis = this.options.vertical ? Y : X;
	            if (this.chartService.isPannable(axis)) {
	                var offset = this.maxLabelOffset();
	                box[axis + 1] -= offset.start;
	                box[axis + 2] += offset.end;
	            } else {
	                if (labels[0].options.visible) {
	                    box.wrap(labels[0].box);
	                }
	                var lastLabel = labels[labels.length - 1];
	                if (lastLabel.options.visible) {
	                    box.wrap(lastLabel.box);
	                }
	            }
	        }

	        return box;
	    },

	    maxLabelOffset: function() {
	        var this$1 = this;

	        var ref = this.options;
	        var vertical = ref.vertical;
	        var reverse = ref.reverse;
	        var labelsBetweenTicks = this.labelsBetweenTicks();
	        var tickPositions = this.getLabelsTickPositions();
	        var offsetField = vertical ? Y : X;
	        var labels = this.labels;
	        var startPosition = reverse ? 1 : 0;
	        var endPosition = reverse ? 0 : 1;
	        var maxStartOffset = 0;
	        var maxEndOffset = 0;

	        for (var idx = 0; idx < labels.length; idx++) {
	            var label = labels[idx];
	            var tickIx = this$1.labelTickIndex(label);
	            var startTick = (void 0), endTick = (void 0);

	            if (labelsBetweenTicks) {
	                startTick = tickPositions[tickIx + startPosition];
	                endTick = tickPositions[tickIx + endPosition];
	            } else {
	                startTick = endTick = tickPositions[tickIx];
	            }

	            maxStartOffset = Math.max(maxStartOffset, startTick - label.box[offsetField + 1]);
	            maxEndOffset = Math.max(maxEndOffset, label.box[offsetField + 2] - endTick);
	        }

	        return {
	            start: maxStartOffset,
	            end: maxEndOffset
	        };
	    },

	    limitRange: function(from, to, min, max, offset) {
	        var options = this.options;

	        if ((from < min && offset < 0 && (!defined(options.min) || options.min <= min)) || (max < to && offset > 0 && (!defined(options.max) || max <= options.max))) {
	            return null;
	        }

	        if ((to < min && offset > 0) || (max < from && offset < 0)) {
	            return {
	                min: from,
	                max: to
	            };
	        }

	        var rangeSize = to - from;
	        var minValue = from;
	        var maxValue = to;

	        if (from < min && offset < 0) {
	            minValue = limitValue(from, min, max);
	            maxValue = limitValue(from + rangeSize, min + rangeSize, max);
	        } else if (to > max && offset > 0) {
	            maxValue = limitValue(to, min, max);
	            minValue = limitValue(to - rangeSize, min, max - rangeSize);
	        }

	        return {
	            min: minValue,
	            max: maxValue
	        };
	    },

	    valueRange: function() {
	        return {
	            min: this.seriesMin,
	            max: this.seriesMax
	        };
	    },

	    labelsBetweenTicks: function() {
	        return !this.options.justified;
	    },

	    prepareUserOptions: function() {
	    }
	});

	setDefaultOptions(Axis, {
	    labels: {
	        visible: true,
	        rotation: 0,
	        mirror: false,
	        step: 1,
	        skip: 0
	    },
	    line: {
	        width: 1,
	        color: BLACK,
	        visible: true
	    },
	    title: {
	        visible: true,
	        position: CENTER
	    },
	    majorTicks: {
	        align: OUTSIDE,
	        size: 4,
	        skip: 0,
	        step: 1
	    },
	    minorTicks: {
	        align: OUTSIDE,
	        size: 3,
	        skip: 0,
	        step: 1
	    },
	    axisCrossingValue: 0,
	    majorTickType: OUTSIDE,
	    minorTickType: NONE,
	    majorGridLines: {
	        skip: 0,
	        step: 1
	    },
	    minorGridLines: {
	        visible: false,
	        width: 1,
	        color: BLACK,
	        skip: 0,
	        step: 1
	    },
	    // TODO: Move to line or labels options
	    margin: 5,
	    visible: true,
	    reverse: false,
	    justified: true,
	    notes: {
	        label: {
	            text: ""
	        }
	    },

	    _alignLines: true,
	    _deferLabels: false
	});

	var MILLISECONDS = "milliseconds";
	var SECONDS = "seconds";
	var MINUTES = "minutes";
	var HOURS = "hours";
	var DAYS = "days";
	var WEEKS = "weeks";
	var MONTHS = "months";
	var YEARS = "years";

	var TIME_PER_MILLISECOND = 1;
	var TIME_PER_SECOND = 1000;
	var TIME_PER_MINUTE = 60 * TIME_PER_SECOND;
	var TIME_PER_HOUR = 60 * TIME_PER_MINUTE;
	var TIME_PER_DAY = 24 * TIME_PER_HOUR;
	var TIME_PER_WEEK = 7 * TIME_PER_DAY;
	var TIME_PER_MONTH = 31 * TIME_PER_DAY;
	var TIME_PER_YEAR = 365 * TIME_PER_DAY;
	var TIME_PER_UNIT = {
	    "years": TIME_PER_YEAR,
	    "months": TIME_PER_MONTH,
	    "weeks": TIME_PER_WEEK,
	    "days": TIME_PER_DAY,
	    "hours": TIME_PER_HOUR,
	    "minutes": TIME_PER_MINUTE,
	    "seconds": TIME_PER_SECOND,
	    "milliseconds": TIME_PER_MILLISECOND
	};

	function absoluteDateDiff(a, b) {
	    var diff = a.getTime() - b;
	    var offsetDiff = a.getTimezoneOffset() - b.getTimezoneOffset();

	    return diff - (offsetDiff * TIME_PER_MINUTE);
	}

	function addTicks(date, ticks) {
	    return new Date(date.getTime() + ticks);
	}

	function toDate(value) {
	    var result;

	    if (value instanceof Date) {
	        result = value;
	    } else if (value) {
	        result = new Date(value);
	    }

	    return result;
	}

	function startOfWeek(date, weekStartDay) {
	    if (weekStartDay === void 0) { weekStartDay = 0; }

	    var daysToSubtract = 0;
	    var day = date.getDay();

	    if (!isNaN(day)) {
	        while (day !== weekStartDay) {
	            if (day === 0) {
	                day = 6;
	            } else {
	                day--;
	            }

	            daysToSubtract++;
	        }
	    }

	    return addTicks(date, -daysToSubtract * TIME_PER_DAY);
	}

	function adjustDST(date, hours) {
	    if (hours === 0 && date.getHours() === 23) {
	        date.setHours(date.getHours() + 2);
	        return true;
	    }

	    return false;
	}

	function addHours(date, hours) {
	    var roundedDate = new Date(date);

	    roundedDate.setMinutes(0, 0, 0);

	    var tzDiff = (date.getTimezoneOffset() - roundedDate.getTimezoneOffset()) * TIME_PER_MINUTE;

	    return addTicks(roundedDate, tzDiff + hours * TIME_PER_HOUR);
	}

	function addDuration(dateValue, value, unit, weekStartDay) {
	    var result = dateValue;

	    if (dateValue) {
	        var date = toDate(dateValue);
	        var hours = date.getHours();

	        if (unit === YEARS) {
	            result = new Date(date.getFullYear() + value, 0, 1);
	            adjustDST(result, 0);
	        } else if (unit === MONTHS) {
	            result = new Date(date.getFullYear(), date.getMonth() + value, 1);
	            adjustDST(result, hours);
	        } else if (unit === WEEKS) {
	            result = addDuration(startOfWeek(date, weekStartDay), value * 7, DAYS);
	            adjustDST(result, hours);
	        } else if (unit === DAYS) {
	            result = new Date(date.getFullYear(), date.getMonth(), date.getDate() + value);
	            adjustDST(result, hours);
	        } else if (unit === HOURS) {
	            result = addHours(date, value);
	        } else if (unit === MINUTES) {
	            result = addTicks(date, value * TIME_PER_MINUTE);

	            if (result.getSeconds() > 0) {
	                result.setSeconds(0);
	            }
	        } else if (unit === SECONDS) {
	            result = addTicks(date, value * TIME_PER_SECOND);
	        } else if (unit === MILLISECONDS) {
	            result = addTicks(date, value);
	        }

	        if (unit !== MILLISECONDS && result.getMilliseconds() > 0) {
	            result.setMilliseconds(0);
	        }
	    }

	    return result;
	}

	function floorDate(date, unit, weekStartDay) {
	    return addDuration(toDate(date), 0, unit, weekStartDay);
	}

	function ceilDate(dateValue, unit, weekStartDay) {
	    var date = toDate(dateValue);

	    if (date && floorDate(date, unit, weekStartDay).getTime() === date.getTime()) {
	        return date;
	    }

	    return addDuration(date, 1, unit, weekStartDay);
	}

	function dateComparer(a, b) {
	    if (a && b) {
	        return a.getTime() - b.getTime();
	    }

	    return -1;
	}

	function dateDiff(a, b) {
	    return a.getTime() - b;
	}

	function toTime(value) {
	    if (isArray(value)) {
	        var result = [];
	        for (var idx = 0; idx < value.length; idx++) {
	            result.push(toTime(value[idx]));
	        }

	        return result;
	    } else if (value) {
	        return toDate(value).getTime();
	    }
	}

	function dateEquals(a, b) {
	    if (a && b) {
	        return toTime(a) === toTime(b);
	    }

	    return a === b;
	}

	function timeIndex(date, start, baseUnit) {
	    return absoluteDateDiff(date, start) / TIME_PER_UNIT[baseUnit];
	}

	function dateIndex(value, start, baseUnit, baseUnitStep) {
	    var date = toDate(value);
	    var startDate = toDate(start);
	    var index;

	    if (baseUnit === MONTHS) {
	        index = (date.getMonth() - startDate.getMonth() + (date.getFullYear() - startDate.getFullYear()) * 12) +
	            timeIndex(date, new Date(date.getFullYear(), date.getMonth()), DAYS) / new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
	    } else if (baseUnit === YEARS) {
	        index = date.getFullYear() - startDate.getFullYear() + dateIndex(date, new Date(date.getFullYear(), 0), MONTHS, 1) / 12;
	    } else if (baseUnit === DAYS || baseUnit === WEEKS) {
	        index = timeIndex(date, startDate, baseUnit);
	    } else {
	        index = dateDiff(date, start) / TIME_PER_UNIT[baseUnit];
	    }

	    return index / baseUnitStep;
	}

	function duration(a, b, unit) {
	    var diff;

	    if (unit === YEARS) {
	        diff = b.getFullYear() - a.getFullYear();
	    } else if (unit === MONTHS) {
	        diff = duration(a, b, YEARS) * 12 + b.getMonth() - a.getMonth();
	    } else if (unit === DAYS) {
	        diff = Math.floor(dateDiff(b, a) / TIME_PER_DAY);
	    } else {
	        diff = Math.floor(dateDiff(b, a) / TIME_PER_UNIT[unit]);
	    }

	    return diff;
	}

	function lteDateIndex(date, sortedDates) {
	    var low = 0;
	    var high = sortedDates.length - 1;
	    var index;

	    while (low <= high) {
	        index = Math.floor((low + high) / 2);
	        var currentDate = sortedDates[index];

	        if (currentDate < date) {
	            low = index + 1;
	            continue;
	        }

	        if (currentDate > date) {
	            high = index - 1;
	            continue;
	        }

	        while (dateEquals(sortedDates[index - 1], date)) {
	            index--;
	        }

	        return index;
	    }

	    if (sortedDates[index] <= date) {
	        return index;
	    }

	    return index - 1;
	}

	function parseDate(intlService, date) {
	    var result;
	    if (isString(date)) {
	        result = intlService.parseDate(date) || toDate(date);
	    } else {
	        result = toDate(date);
	    }
	    return result;
	}

	function parseDates(intlService, dates) {
	    if (isArray(dates)) {
	        var result = [];
	        for (var idx = 0; idx < dates.length; idx++) {
	            result.push(parseDate(intlService, dates[idx]));
	        }

	        return result;
	    }

	    return parseDate(intlService, dates);
	}

	function firstDay(options, intlService) {
	    if (isNumber(options.weekStartDay)) {
	        return options.weekStartDay;
	    }

	    if (intlService && intlService.firstDay) {
	        return intlService.firstDay();
	    }

	    return 0;
	}

	var MIN_CATEGORY_POINTS_RANGE = 0.01;

	function indexOf(value, arr) {
	    if (value instanceof Date) {
	        var length = arr.length;
	        for (var idx = 0; idx < length; idx++) {
	            if (dateEquals(arr[idx], value)) {
	                return idx;
	            }
	        }

	        return -1;
	    }

	    return arr.indexOf(value);
	}

	var CategoryAxis = Axis.extend({
	    initFields: function() {
	        this._ticks = {};
	    },

	    categoriesHash: function() {
	        return "";
	    },

	    clone: function() {
	        var copy = new CategoryAxis($.extend({}, this.options, {
	            categories: this.options.srcCategories
	        }), this.chartService);
	        copy.createLabels();

	        return copy;
	    },

	    initUserOptions: function(options) {
	        var categories = options.categories || [];
	        var definedMin = defined(options.min);
	        var definedMax = defined(options.max);
	        options.srcCategories = options.categories = categories;

	        if ((definedMin || definedMax) && categories.length) {
	            var min = definedMin ? Math.floor(options.min) : 0;
	            var max;

	            if (definedMax) {
	                max = options.justified ? Math.floor(options.max) + 1 : Math.ceil(options.max);
	            } else {
	                max = categories.length;
	            }

	            options.categories = options.categories.slice(min, max);
	        }

	        return options;
	    },

	    rangeIndices: function() {
	        var options = this.options;
	        var length = options.categories.length || 1;
	        var min = isNumber(options.min) ? options.min % 1 : 0;
	        var max;

	        if (isNumber(options.max) && options.max % 1 !== 0 && options.max < this.totalRange().max) {
	            max = length - (1 - options.max % 1);
	        } else {
	            max = length - (options.justified ? 1 : 0);
	        }

	        return {
	            min: min,
	            max: max
	        };
	    },

	    totalRangeIndices: function(limit) {
	        var options = this.options;
	        var min = isNumber(options.min) ? options.min : 0;
	        var max;

	        if (isNumber(options.max)) {
	            max = options.max;
	        } else if (isNumber(options.min)) {
	            max = min + options.categories.length;
	        } else {
	            max = this.totalRange().max || 1;
	        }

	        if (limit) {
	            var totalRange = this.totalRange();
	            min = limitValue(min, 0, totalRange.max);
	            max = limitValue(max, 0, totalRange.max);
	        }

	        return {
	            min: min,
	            max: max
	        };
	    },

	    range: function() {
	        var options = this.options;
	        var min = isNumber(options.min) ? options.min : 0;
	        var max = isNumber(options.max) ? options.max : this.totalRange().max;

	        return {
	            min: min,
	            max: max
	        };
	    },

	    roundedRange: function() {
	        return this.range();
	    },

	    totalRange: function() {
	        var options = this.options;
	        return { min: 0, max: Math.max(this._seriesMax || 0, options.srcCategories.length) - (options.justified ? 1 : 0) };
	    },

	    scaleOptions: function() {
	        var ref = this.rangeIndices();
	        var min = ref.min;
	        var max = ref.max;
	        var lineBox = this.lineBox();
	        var size = this.options.vertical ? lineBox.height() : lineBox.width();
	        var scale = size / ((max - min) || 1);

	        return {
	            scale: scale * (this.options.reverse ? -1 : 1),
	            box: lineBox,
	            min: min,
	            max: max
	        };
	    },

	    arrangeLabels: function() {
	        Axis.fn.arrangeLabels.call(this);
	        this.hideOutOfRangeLabels();
	    },

	    hideOutOfRangeLabels: function() {
	        var ref = this;
	        var box = ref.box;
	        var labels = ref.labels;

	        if (labels.length) {
	            var valueAxis = this.options.vertical ? Y : X;
	            var start = box[valueAxis + 1];
	            var end = box[valueAxis + 2];
	            var firstLabel = labels[0];
	            var lastLabel = last(labels);

	            if (firstLabel.box[valueAxis + 1] > end || firstLabel.box[valueAxis + 2] < start) {
	                firstLabel.options.visible = false;
	            }
	            if (lastLabel.box[valueAxis + 1] > end || lastLabel.box[valueAxis + 2] < start) {
	                lastLabel.options.visible = false;
	            }
	        }
	    },

	    getMajorTickPositions: function() {
	        return this.getTicks().majorTicks;
	    },

	    getMinorTickPositions: function() {
	        return this.getTicks().minorTicks;
	    },

	    getLabelsTickPositions: function() {
	        return this.getTicks().labelTicks;
	    },

	    tickIndices: function(stepSize) {
	        var ref = this.rangeIndices();
	        var min = ref.min;
	        var max = ref.max;
	        var limit = Math.ceil(max);
	        var current = Math.floor(min);
	        var indices = [];

	        while (current <= limit) {
	            indices.push(current);
	            current += stepSize;
	        }

	        return indices;
	    },

	    getTickPositions: function(stepSize) {
	        var ref = this.options;
	        var vertical = ref.vertical;
	        var reverse = ref.reverse;
	        var ref$1 = this.scaleOptions();
	        var scale = ref$1.scale;
	        var box = ref$1.box;
	        var min = ref$1.min;
	        var pos = box[(vertical ? Y : X) + (reverse ? 2 : 1)];
	        var indices = this.tickIndices(stepSize);
	        var positions = [];

	        for (var idx = 0; idx < indices.length; idx++) {
	            positions.push(pos + round(scale * (indices[idx] - min), COORD_PRECISION));
	        }

	        return positions;
	    },

	    getTicks: function() {
	        var options = this.options;
	        var cache = this._ticks;
	        var range = this.rangeIndices();
	        var lineBox = this.lineBox();
	        var hash = lineBox.getHash() + range.min + "," + range.max + options.reverse + options.justified;

	        if (cache._hash !== hash) {
	            var hasMinor = options.minorTicks.visible || options.minorGridLines.visible;
	            cache._hash = hash;
	            cache.labelTicks = this.getTickPositions(1);
	            cache.majorTicks = this.filterOutOfRangePositions(cache.labelTicks, lineBox);
	            cache.minorTicks = hasMinor ? this.filterOutOfRangePositions(this.getTickPositions(0.5), lineBox) : [];
	        }

	        return cache;
	    },

	    filterOutOfRangePositions: function(positions, lineBox) {
	        if (!positions.length) {
	            return positions;
	        }

	        var axis = this.options.vertical ? Y : X;
	        var inRange = function (position) { return lineBox[axis + 1] <= position && position <= lineBox[axis + 2]; };

	        var end = positions.length - 1;
	        var startIndex = 0;
	        while (!inRange(positions[startIndex]) && startIndex <= end) {
	            startIndex++;
	        }

	        var endIndex = end;

	        while (!inRange(positions[endIndex]) && endIndex >= 0) {
	            endIndex--;
	        }

	        return positions.slice(startIndex, endIndex + 1);
	    },

	    getSlot: function(from, to, limit) {
	        var options = this.options;
	        var reverse = options.reverse;
	        var justified = options.justified;
	        var vertical = options.vertical;
	        var ref = this.scaleOptions();
	        var scale = ref.scale;
	        var box = ref.box;
	        var min = ref.min;
	        var valueAxis = vertical ? Y : X;
	        var lineStart = box[valueAxis + (reverse ? 2 : 1)];
	        var slotBox = box.clone();
	        var singleSlot = !defined(to);

	        var start = valueOrDefault(from, 0);
	        var end = valueOrDefault(to, start);
	        end = Math.max(end - 1, start);

	        // Fixes transient bug caused by iOS 6.0 JIT
	        // (one can never be too sure)
	        end = Math.max(start, end);

	        var p1 = lineStart + (start - min) * scale;
	        var p2 = lineStart + (end + 1 - min) * scale;

	        if (singleSlot && justified) {
	            p2 = p1;
	        }

	        if (limit) {
	            p1 = limitValue(p1, box[valueAxis + 1], box[valueAxis + 2]);
	            p2 = limitValue(p2, box[valueAxis + 1], box[valueAxis + 2]);
	        }

	        slotBox[valueAxis + 1] = reverse ? p2 : p1;
	        slotBox[valueAxis + 2] = reverse ? p1 : p2;

	        return slotBox;
	    },

	    limitSlot: function(slot) {
	        var vertical = this.options.vertical;
	        var valueAxis = vertical ? Y : X;
	        var lineBox = this.lineBox();
	        var limittedSlot = slot.clone();

	        limittedSlot[valueAxis + 1] = limitValue(slot[valueAxis + 1], lineBox[valueAxis + 1], lineBox[valueAxis + 2]);
	        limittedSlot[valueAxis + 2] = limitValue(slot[valueAxis + 2], lineBox[valueAxis + 1], lineBox[valueAxis + 2]);

	        return limittedSlot;
	    },

	    slot: function(from, to, limit) {
	        var min = Math.floor(this.options.min || 0);
	        var start = from;
	        var end = to;

	        if (typeof start === "string") {
	            start = this.categoryIndex(start);
	        } else if (isNumber(start)) {
	            start -= min;
	        }

	        if (typeof end === "string") {
	            end = this.categoryIndex(end);
	        } else if (isNumber(end)) {
	            end -= min;
	        }

	        return Axis.fn.slot.call(this, start, end, limit);
	    },

	    pointCategoryIndex: function(point) {
	        var ref = this.options;
	        var reverse = ref.reverse;
	        var justified = ref.justified;
	        var vertical = ref.vertical;
	        var valueAxis = vertical ? Y : X;
	        var ref$1 = this.scaleOptions();
	        var scale = ref$1.scale;
	        var box = ref$1.box;
	        var min = ref$1.min;
	        var max = ref$1.max;
	        var startValue = reverse ? max : min;
	        var lineStart = box[valueAxis + 1];
	        var lineEnd = box[valueAxis + 2];
	        var pos = point[valueAxis];

	        if (pos < lineStart || pos > lineEnd) {
	            return null;
	        }

	        var value = startValue + (pos - lineStart) / scale;
	        var diff = value % 1;

	        if (justified) {
	            value = Math.round(value);
	        } else if (diff === 0 && value > 0) {
	            value--;
	        }

	        return Math.floor(value);
	    },

	    getCategory: function(point) {
	        var index = this.pointCategoryIndex(point);

	        if (index === null) {
	            return null;
	        }

	        return this.options.categories[index];
	    },

	    categoryIndex: function(value) {
	        return this.totalIndex(value) - Math.floor(this.options.min || 0);
	    },

	    categoryAt: function(index, total) {
	        var options = this.options;

	        return (total ? options.srcCategories : options.categories)[index];
	    },

	    categoriesCount: function() {
	        return (this.options.categories || []).length;
	    },

	    translateRange: function(delta) {
	        var options = this.options;
	        var lineBox = this.lineBox();
	        var size = options.vertical ? lineBox.height() : lineBox.width();
	        var range = options.categories.length;
	        var scale = size / range;
	        var offset = round(delta / scale, DEFAULT_PRECISION);

	        return {
	            min: offset,
	            max: range + offset
	        };
	    },

	    zoomRange: function(rate) {
	        var rangeIndices = this.totalRangeIndices();
	        var ref = this.totalRange();
	        var totalMin = ref.min;
	        var totalMax = ref.max;
	        var min = limitValue(rangeIndices.min + rate, totalMin, totalMax);
	        var max = limitValue(rangeIndices.max - rate, totalMin, totalMax);

	        if (max - min > 0) {
	            return {
	                min: min,
	                max: max
	            };
	        }
	    },

	    scaleRange: function(scale) {
	        var range = this.options.categories.length;
	        var delta = scale * range;

	        return {
	            min: -delta,
	            max: range + delta
	        };
	    },

	    labelsCount: function() {
	        var labelsRange = this.labelsRange();

	        return labelsRange.max - labelsRange.min;
	    },

	    labelsRange: function() {
	        var options = this.options;
	        var justified = options.justified;
	        var labelOptions = options.labels;
	        var ref = this.totalRangeIndices(true);
	        var min = ref.min;
	        var max = ref.max;
	        var start = Math.floor(min);

	        if (!justified) {
	            min = Math.floor(min);
	            max = Math.ceil(max);
	        } else {
	            min = Math.ceil(min);
	            max = Math.floor(max);
	        }

	        var skip;

	        if (min > labelOptions.skip) {
	            skip = labelOptions.skip + labelOptions.step * Math.ceil((min - labelOptions.skip) / labelOptions.step);
	        } else {
	            skip = labelOptions.skip;
	        }

	        return {
	            min: skip - start,
	            max: (options.categories.length ? max + (justified ? 1 : 0) : 0) - start
	        };
	    },

	    createAxisLabel: function(index, labelOptions) {
	        var options = this.options;
	        var dataItem = options.dataItems ? options.dataItems[index] : null;
	        var category = valueOrDefault(options.categories[index], "");
	        var text = this.axisLabelText(category, dataItem, labelOptions);

	        return new AxisLabel(category, text, index, dataItem, labelOptions);
	    },

	    shouldRenderNote: function(value) {
	        var range = this.totalRangeIndices();

	        return Math.floor(range.min) <= value && value <= Math.ceil(range.max);
	    },

	    noteSlot: function(value) {
	        var options = this.options;
	        var index = value - Math.floor(options.min || 0);
	        return this.getSlot(index);
	    },

	    arrangeNotes: function() {
	        Axis.fn.arrangeNotes.call(this);
	        this.hideOutOfRangeNotes();
	    },

	    hideOutOfRangeNotes: function() {
	        var ref = this;
	        var notes = ref.notes;
	        var box = ref.box;
	        if (notes && notes.length) {
	            var valueAxis = this.options.vertical ? Y : X;
	            var start = box[valueAxis + 1];
	            var end = box[valueAxis + 2];

	            for (var idx = 0; idx < notes.length; idx++) {
	                var note = notes[idx];
	                if (note.box && (end < note.box[valueAxis + 1] || note.box[valueAxis + 2] < start)) {
	                    note.hide();
	                }
	            }
	        }
	    },

	    pan: function(delta) {
	        var range = this.totalRangeIndices(true);
	        var ref = this.scaleOptions();
	        var scale = ref.scale;
	        var offset = round(delta / scale, DEFAULT_PRECISION);
	        var totalRange = this.totalRange();
	        var min = range.min + offset;
	        var max = range.max + offset;

	        return this.limitRange(min, max, 0, totalRange.max, offset);
	    },

	    pointsRange: function(start, end) {
	        var ref = this.options;
	        var reverse = ref.reverse;
	        var vertical = ref.vertical;
	        var valueAxis = vertical ? Y : X;
	        var range = this.totalRangeIndices(true);
	        var ref$1 = this.scaleOptions();
	        var scale = ref$1.scale;
	        var box = ref$1.box;
	        var lineStart = box[valueAxis + (reverse ? 2 : 1)];

	        var diffStart = start[valueAxis] - lineStart;
	        var diffEnd = end[valueAxis] - lineStart;

	        var min = range.min + diffStart / scale;
	        var max = range.min + diffEnd / scale;
	        var rangeMin = Math.min(min, max);
	        var rangeMax = Math.max(min, max);

	        if (rangeMax - rangeMin >= MIN_CATEGORY_POINTS_RANGE) {
	            return {
	                min: rangeMin,
	                max: rangeMax
	            };
	        }
	    },

	    valueRange: function() {
	        return this.range();
	    },

	    totalIndex: function(value) {
	        var options = this.options;
	        var index = this._categoriesMap ?
	            this._categoriesMap.get(value) : indexOf(value, options.srcCategories);

	        return index;
	    },

	    currentRangeIndices: function() {
	        var options = this.options;
	        var min = 0;

	        if (isNumber(options.min)) {
	            min = Math.floor(options.min);
	        }

	        var max;
	        if (isNumber(options.max)) {
	            max = options.justified ? Math.floor(options.max) : Math.ceil(options.max) - 1;
	        } else {
	            max = this.totalCount() - 1;
	        }

	        return {
	            min: min,
	            max: max
	        };
	    },

	    mapCategories: function() {
	        if (!this._categoriesMap) {
	            var map$$1 = this._categoriesMap = new HashMap();
	            var srcCategories = this.options.srcCategories;
	            for (var idx = 0; idx < srcCategories.length; idx++) {
	                map$$1.set(srcCategories[idx], idx);
	            }
	        }
	    },

	    totalCount: function() {
	        return Math.max(this.options.srcCategories.length, this._seriesMax || 0);
	    }
	});

	setDefaultOptions(CategoryAxis, {
	    type: "category",
	    vertical: false,
	    majorGridLines: {
	        visible: false,
	        width: 1,
	        color: BLACK
	    },
	    labels: {
	        zIndex: 1
	    },
	    justified: false,
	    _deferLabels: true
	});

	var COORDINATE_LIMIT = 300000;

	var DateLabelFormats = {
	    milliseconds: "HH:mm:ss.fff",
	    seconds: "HH:mm:ss",
	    minutes: "HH:mm",
	    hours: "HH:mm",
	    days: "M/d",
	    weeks: "M/d",
	    months: "MMM 'yy",
	    years: "yyyy"
	};

	var ZERO_THRESHOLD = 0.2;

	var AUTO = "auto";
	var BASE_UNITS = [
	    MILLISECONDS, SECONDS, MINUTES, HOURS, DAYS, WEEKS, MONTHS, YEARS
	];
	var FIT = "fit";

	function categoryRange(categories) {
	    var range = categories._range;
	    if (!range) {
	        range = categories._range = sparseArrayLimits(categories);
	        range.min = toDate(range.min);
	        range.max = toDate(range.max);
	    }

	    return range;
	}

	var EmptyDateRange = Class.extend({
	    init: function(options) {
	        this.options = options;
	    },

	    displayIndices: function() {
	        return {
	            min: 0,
	            max: 1
	        };
	    },

	    displayRange: function() {
	        return {};
	    },

	    total: function() {
	        return {};
	    },

	    valueRange: function() {
	        return {};
	    },

	    valueIndex: function() {
	        return -1;
	    },

	    values: function() {
	        return [];
	    },

	    totalIndex: function() {
	        return -1;
	    },

	    valuesCount: function() {
	        return 0;
	    },

	    totalCount: function() {
	        return 0;
	    },

	    dateAt: function() {
	        return null;
	    }
	});

	var DateRange = Class.extend({
	    init: function(start, end, options) {
	        this.options = options;
	        options.baseUnitStep = options.baseUnitStep || 1;

	        var roundToBaseUnit = options.roundToBaseUnit;
	        var justified = options.justified;

	        this.start = addDuration(start, 0, options.baseUnit, options.weekStartDay);
	        var lowerEnd = this.roundToTotalStep(end);
	        var expandEnd = !justified && dateEquals(end, lowerEnd) && !options.justifyEnd;

	        this.end = this.roundToTotalStep(end, !justified, expandEnd ? 1 : 0);

	        var min = options.min || start;
	        this.valueStart = this.roundToTotalStep(min);
	        this.displayStart = roundToBaseUnit ? this.valueStart : min;

	        var max = options.max;
	        if (!max) {
	            this.valueEnd = lowerEnd;
	            this.displayEnd = roundToBaseUnit || expandEnd ? this.end : end;
	        } else {
	            this.valueEnd = this.roundToTotalStep(max, false, !justified && dateEquals(max, this.roundToTotalStep(max)) ? -1 : 0);
	            this.displayEnd = roundToBaseUnit ? this.roundToTotalStep(max, !justified) : options.max;
	        }

	        if (this.valueEnd < this.valueStart) {
	            this.valueEnd = this.valueStart;
	        }
	        if (this.displayEnd <= this.displayStart) {
	            this.displayEnd = this.roundToTotalStep(this.displayStart, false, 1);
	        }
	    },

	    displayRange: function() {
	        return {
	            min: this.displayStart,
	            max: this.displayEnd
	        };
	    },

	    displayIndices: function() {
	        if (!this._indices) {
	            var options = this.options;

	            var baseUnit = options.baseUnit;
	            var baseUnitStep = options.baseUnitStep;

	            var minIdx = dateIndex(this.displayStart, this.valueStart, baseUnit, baseUnitStep);
	            var maxIdx = dateIndex(this.displayEnd, this.valueStart, baseUnit, baseUnitStep);

	            this._indices = { min: minIdx, max: maxIdx };
	        }

	        return this._indices;
	    },

	    total: function() {
	        return {
	            min: this.start,
	            max: this.end
	        };
	    },

	    totalCount: function() {
	        var last$$1 = this.totalIndex(this.end);

	        return last$$1 + (this.options.justified ? 1 : 0);
	    },

	    valueRange: function() {
	        return {
	            min: this.valueStart,
	            max: this.valueEnd
	        };
	    },

	    valueIndex: function(value) {
	        var options = this.options;
	        return Math.floor(dateIndex(value, this.valueStart, options.baseUnit, options.baseUnitStep));
	    },

	    totalIndex: function(value) {
	        var options = this.options;
	        return Math.floor(dateIndex(value, this.start, options.baseUnit, options.baseUnitStep));
	    },

	    dateIndex: function(value) {
	        var options = this.options;
	        return dateIndex(value, this.valueStart, options.baseUnit, options.baseUnitStep);
	    },

	    valuesCount: function() {
	        var maxIdx = this.valueIndex(this.valueEnd);

	        return maxIdx + 1;
	    },

	    values: function() {
	        var values = this._values;
	        if (!values) {
	            var options = this.options;
	            var range = this.valueRange();
	            this._values = values = [];

	            for (var date = range.min; date <= range.max;) {
	                values.push(date);
	                date = addDuration(date, options.baseUnitStep, options.baseUnit, options.weekStartDay);
	            }
	        }

	        return values;
	    },

	    dateAt: function(index, total) {
	        var options = this.options;

	        return addDuration(total ? this.start : this.valueStart, options.baseUnitStep * index, options.baseUnit, options.weekStartDay);
	    },

	    roundToTotalStep: function(value, upper, next) {
	        var ref = this.options;
	        var baseUnit = ref.baseUnit;
	        var baseUnitStep = ref.baseUnitStep;
	        var weekStartDay = ref.weekStartDay;
	        var start = this.start;

	        var step = dateIndex(value, start, baseUnit, baseUnitStep);
	        var roundedStep = upper ? Math.ceil(step) : Math.floor(step);

	        if (next) {
	            roundedStep += next;
	        }

	        return addDuration(start, roundedStep * baseUnitStep, baseUnit, weekStartDay);
	    }
	});

	function autoBaseUnit(options, startUnit, startStep) {
	    var categoryLimits = categoryRange(options.categories);
	    var span = (options.max || categoryLimits.max) - (options.min || categoryLimits.min);
	    var autoBaseUnitSteps = options.autoBaseUnitSteps;
	    var maxDateGroups = options.maxDateGroups;
	    var autoUnit = options.baseUnit === FIT;
	    var autoUnitIx = startUnit ? BASE_UNITS.indexOf(startUnit) : 0;
	    var baseUnit = autoUnit ? BASE_UNITS[autoUnitIx++] : options.baseUnit;
	    var units = span / TIME_PER_UNIT[baseUnit];
	    var totalUnits = units;
	    var unitSteps, step, nextStep;

	    while (!step || units >= maxDateGroups) {
	        unitSteps = unitSteps || autoBaseUnitSteps[baseUnit].slice(0);

	        do {
	            nextStep = unitSteps.shift();
	        } while (nextStep && startUnit === baseUnit && nextStep < startStep);

	        if (nextStep) {
	            step = nextStep;
	            units = totalUnits / step;
	        } else if (baseUnit === last(BASE_UNITS)) {
	            step = Math.ceil(totalUnits / maxDateGroups);
	            break;
	        } else if (autoUnit) {
	            baseUnit = BASE_UNITS[autoUnitIx++] || last(BASE_UNITS);
	            totalUnits = span / TIME_PER_UNIT[baseUnit];
	            unitSteps = null;
	        } else {
	            if (units > maxDateGroups) {
	                step = Math.ceil(totalUnits / maxDateGroups);
	            }
	            break;
	        }
	    }

	    options.baseUnitStep = step;
	    options.baseUnit = baseUnit;
	}

	function defaultBaseUnit(options) {
	    var categories = options.categories;
	    var count = defined(categories) ? categories.length : 0;
	    var minDiff = MAX_VALUE;
	    var lastCategory, unit;

	    for (var categoryIx = 0; categoryIx < count; categoryIx++) {
	        var category = categories[categoryIx];

	        if (category && lastCategory) {
	            var diff = absoluteDateDiff(category, lastCategory);
	            if (diff > 0) {
	                minDiff = Math.min(minDiff, diff);

	                if (minDiff >= TIME_PER_YEAR) {
	                    unit = YEARS;
	                } else if (minDiff >= TIME_PER_MONTH - TIME_PER_DAY * 3) {
	                    unit = MONTHS;
	                } else if (minDiff >= TIME_PER_WEEK) {
	                    unit = WEEKS;
	                } else if (minDiff >= TIME_PER_DAY) {
	                    unit = DAYS;
	                } else if (minDiff >= TIME_PER_HOUR) {
	                    unit = HOURS;
	                } else if (minDiff >= TIME_PER_MINUTE) {
	                    unit = MINUTES;
	                } else {
	                    unit = SECONDS;
	                }
	            }
	        }

	        lastCategory = category;
	    }

	    options.baseUnit = unit || DAYS;
	}

	function initUnit(options) {
	    var baseUnit = (options.baseUnit || "").toLowerCase();
	    var useDefault = baseUnit !== FIT && !inArray(baseUnit, BASE_UNITS);

	    if (useDefault) {
	        defaultBaseUnit(options);
	    }

	    if (baseUnit === FIT || options.baseUnitStep === AUTO) {
	        autoBaseUnit(options);
	    }

	    return options;
	}

	var DateCategoryAxis = CategoryAxis.extend({
	    clone: function() {
	        var copy = new DateCategoryAxis($.extend({}, this.options), this.chartService);
	        copy.createLabels();

	        return copy;
	    },

	    categoriesHash: function() {
	        var start = this.dataRange.total().min;
	        return this.options.baseUnit + this.options.baseUnitStep + start;
	    },

	    initUserOptions: function(options) {
	        return options;
	    },

	    initFields: function() {
	        CategoryAxis.fn.initFields.call(this);

	        var chartService = this.chartService;
	        var intlService = chartService.intl;
	        var options = this.options;

	        var categories = options.categories || [];
	        if (!categories._parsed) {
	            categories = parseDates(intlService, categories);
	            categories._parsed = true;
	        }

	        options = deepExtend({
	            roundToBaseUnit: true
	        }, options, {
	            categories: categories,
	            min: parseDate(intlService, options.min),
	            max: parseDate(intlService, options.max),
	            weekStartDay: firstDay(options, intlService)
	        });

	        if (chartService.panning && chartService.isPannable(options.vertical ? Y : X)) {
	            options.roundToBaseUnit = false;
	        }

	        options.userSetBaseUnit = options.userSetBaseUnit || options.baseUnit;
	        options.userSetBaseUnitStep = options.userSetBaseUnitStep || options.baseUnitStep;

	        this.options = options;
	        options.srcCategories = categories;

	        if (categories.length > 0) {
	            var range = categoryRange(categories);
	            var maxDivisions = options.maxDivisions;

	            this.dataRange = new DateRange(range.min, range.max, initUnit(options));

	            if (maxDivisions) {
	                var dataRange = this.dataRange.displayRange();

	                var divisionOptions = $.extend({}, options, {
	                    justified: true,
	                    roundToBaseUnit: false,
	                    baseUnit: 'fit',
	                    min: dataRange.min,
	                    max: dataRange.max,
	                    maxDateGroups: maxDivisions
	                });

	                var dataRangeOptions = this.dataRange.options;

	                autoBaseUnit(divisionOptions, dataRangeOptions.baseUnit, dataRangeOptions.baseUnitStep);

	                this.divisionRange = new DateRange(range.min, range.max, divisionOptions);
	            } else {
	                this.divisionRange = this.dataRange;
	            }

	        } else {
	            options.baseUnit = options.baseUnit || DAYS;
	            this.dataRange = this.divisionRange = new EmptyDateRange(options);
	        }
	    },

	    tickIndices: function(stepSize) {
	        var ref = this;
	        var dataRange = ref.dataRange;
	        var divisionRange = ref.divisionRange;
	        var valuesCount = divisionRange.valuesCount();

	        if (!this.options.maxDivisions || !valuesCount) {
	            return CategoryAxis.fn.tickIndices.call(this, stepSize);
	        }

	        var indices = [];
	        var values = divisionRange.values();
	        var offset = 0;

	        if (!this.options.justified) {
	            values = values.concat(divisionRange.dateAt(valuesCount));
	            offset = 0.5;//align ticks to the center of not justified categories
	        }

	        for (var idx = 0; idx < values.length; idx++) {
	            indices.push(dataRange.dateIndex(values[idx]) + offset);
	            if (stepSize !== 1 && idx >= 1) {
	                var last$$1 = indices.length - 1;
	                indices.splice(idx, 0, indices[last$$1 - 1] + (indices[last$$1] - indices[last$$1 - 1]) * stepSize);
	            }
	        }

	        return indices;
	    },

	    shouldRenderNote: function(value) {
	        var range = this.range();
	        var categories = this.options.categories || [];

	        return dateComparer(value, range.min) >= 0 && dateComparer(value, range.max) <= 0 && categories.length;
	    },

	    parseNoteValue: function(value) {
	        return parseDate(this.chartService.intl, value);
	    },

	    noteSlot: function(value) {
	        return this.getSlot(value);
	    },

	    translateRange: function(delta) {
	        var options = this.options;
	        var baseUnit = options.baseUnit;
	        var weekStartDay = options.weekStartDay;
	        var vertical = options.vertical;
	        var lineBox = this.lineBox();
	        var size = vertical ? lineBox.height() : lineBox.width();
	        var range = this.range();
	        var scale = size / (range.max - range.min);
	        var offset = round(delta / scale, DEFAULT_PRECISION);

	        if (range.min && range.max) {
	            var from = addTicks(options.min || range.min, offset);
	            var to = addTicks(options.max || range.max, offset);

	            range = {
	                min: addDuration(from, 0, baseUnit, weekStartDay),
	                max: addDuration(to, 0, baseUnit, weekStartDay)
	            };
	        }

	        return range;
	    },

	    scaleRange: function(delta) {
	        var rounds = Math.abs(delta);
	        var result = this.range();
	        var from = result.min;
	        var to = result.max;

	        if (from && to) {
	            while (rounds--) {
	                var range = dateDiff(from, to);
	                var step = Math.round(range * 0.1);
	                if (delta < 0) {
	                    from = addTicks(from, step);
	                    to = addTicks(to, -step);
	                } else {
	                    from = addTicks(from, -step);
	                    to = addTicks(to, step);
	                }
	            }

	            result = { min: from, max: to };
	        }

	        return result;
	    },

	    labelsRange: function() {
	        return {
	            min: this.options.labels.skip,
	            max: this.divisionRange.valuesCount()
	        };
	    },

	    pan: function(delta) {
	        if (this.isEmpty()) {
	            return null;
	        }

	        var options = this.options;
	        var lineBox = this.lineBox();
	        var size = options.vertical ? lineBox.height() : lineBox.width();
	        var ref = this.dataRange.displayRange();
	        var min = ref.min;
	        var max = ref.max;
	        var totalLimits = this.dataRange.total();
	        var scale = size / (max - min);
	        var offset = round(delta / scale, DEFAULT_PRECISION) * (options.reverse ? -1 : 1);
	        var from = addTicks(min, offset);
	        var to = addTicks(max, offset);

	        var panRange = this.limitRange(toTime(from), toTime(to), toTime(totalLimits.min), toTime(totalLimits.max), offset);

	        if (panRange) {
	            panRange.min = toDate(panRange.min);
	            panRange.max = toDate(panRange.max);
	            panRange.baseUnit = options.baseUnit;
	            panRange.baseUnitStep = options.baseUnitStep || 1;
	            panRange.userSetBaseUnit = options.userSetBaseUnit;
	            panRange.userSetBaseUnitStep = options.userSetBaseUnitStep;

	            return panRange;
	        }
	    },

	    pointsRange: function(start, end) {
	        if (this.isEmpty()) {
	            return null;
	        }

	        var pointsRange = CategoryAxis.fn.pointsRange.call(this, start, end);
	        var datesRange = this.dataRange.displayRange();
	        var indicesRange = this.dataRange.displayIndices();
	        var scale = dateDiff(datesRange.max, datesRange.min) / (indicesRange.max - indicesRange.min);
	        var options = this.options;

	        var min = addTicks(datesRange.min, pointsRange.min * scale);
	        var max = addTicks(datesRange.min, pointsRange.max * scale);

	        return {
	            min: min,
	            max: max,
	            baseUnit: options.userSetBaseUnit || options.baseUnit,
	            baseUnitStep: options.userSetBaseUnitStep || options.baseUnitStep
	        };
	    },

	    zoomRange: function(delta) {
	        if (this.isEmpty()) {
	            return null;
	        }

	        var options = this.options;
	        var fit = options.userSetBaseUnit === FIT;
	        var totalLimits = this.dataRange.total();
	        var ref = this.dataRange.displayRange();
	        var rangeMin = ref.min;
	        var rangeMax = ref.max;
	        var ref$1 = this.dataRange.options;
	        var weekStartDay = ref$1.weekStartDay;
	        var baseUnit = ref$1.baseUnit;
	        var baseUnitStep = ref$1.baseUnitStep;
	        var min = addDuration(rangeMin, delta * baseUnitStep, baseUnit, weekStartDay);
	        var max = addDuration(rangeMax, -delta * baseUnitStep, baseUnit, weekStartDay);

	        if (fit) {
	            var autoBaseUnitSteps = options.autoBaseUnitSteps;
	            var maxDateGroups = options.maxDateGroups;

	            var maxDiff = last(autoBaseUnitSteps[baseUnit]) * maxDateGroups * TIME_PER_UNIT[baseUnit];
	            var rangeDiff = dateDiff(rangeMax, rangeMin);
	            var diff = dateDiff(max, min);
	            var baseUnitIndex = BASE_UNITS.indexOf(baseUnit);
	            var autoBaseUnitStep, ticks;

	            if (diff < TIME_PER_UNIT[baseUnit] && baseUnit !== MILLISECONDS) {
	                baseUnit = BASE_UNITS[baseUnitIndex - 1];
	                autoBaseUnitStep = last(autoBaseUnitSteps[baseUnit]);
	                ticks = (rangeDiff - (maxDateGroups - 1) * autoBaseUnitStep * TIME_PER_UNIT[baseUnit]) / 2;
	                min = addTicks(rangeMin, ticks);
	                max = addTicks(rangeMax, -ticks);

	            } else if (diff > maxDiff && baseUnit !== YEARS) {
	                var stepIndex = 0;

	                do {
	                    baseUnitIndex++;
	                    baseUnit = BASE_UNITS[baseUnitIndex];
	                    stepIndex = 0;
	                    ticks = 2 * TIME_PER_UNIT[baseUnit];
	                    do {
	                        autoBaseUnitStep = autoBaseUnitSteps[baseUnit][stepIndex];
	                        stepIndex++;
	                    } while (stepIndex < autoBaseUnitSteps[baseUnit].length && ticks * autoBaseUnitStep < rangeDiff);
	                } while (baseUnit !== YEARS && ticks * autoBaseUnitStep < rangeDiff);

	                ticks = (ticks * autoBaseUnitStep - rangeDiff) / 2;
	                if (ticks > 0) {
	                    min = addTicks(rangeMin, -ticks);
	                    max = addTicks(rangeMax, ticks);
	                    min = addTicks(min, limitValue(max, totalLimits.min, totalLimits.max) - max);
	                    max = addTicks(max, limitValue(min, totalLimits.min, totalLimits.max) - min);
	                }
	            }
	        }

	        if (min < totalLimits.min) {
	            min = totalLimits.min;
	        }
	        if (max > totalLimits.max) {
	            max = totalLimits.max;
	        }

	        if (min && max && dateDiff(max, min) > 0) {
	            return {
	                min: min,
	                max: max,
	                baseUnit: options.userSetBaseUnit || options.baseUnit,
	                baseUnitStep: options.userSetBaseUnitStep || options.baseUnitStep
	            };
	        }
	    },

	    range: function() {
	        return this.dataRange.displayRange();
	    },

	    createAxisLabel: function(index, labelOptions) {
	        var options = this.options;
	        var dataItem = options.dataItems && !options.maxDivisions ? options.dataItems[index] : null;
	        var date = this.divisionRange.dateAt(index);
	        var unitFormat = labelOptions.dateFormats[this.divisionRange.options.baseUnit];

	        labelOptions.format = labelOptions.format || unitFormat;
	        var text = this.axisLabelText(date, dataItem, labelOptions);
	        if (text) {
	            return new AxisLabel(date, text, index, dataItem, labelOptions);
	        }
	    },

	    categoryIndex: function(value) {
	        return this.dataRange.valueIndex(value);
	    },

	    slot: function(from, to, limit) {
	        var dateRange = this.dataRange;
	        var start = from;
	        var end = to;

	        if (start instanceof Date) {
	            start = dateRange.dateIndex(start);
	        }

	        if (end instanceof Date) {
	            end = dateRange.dateIndex(end);
	        }

	        var slot = this.getSlot(start, end, limit);
	        if (slot) {
	            return slot.toRect();
	        }
	    },

	    getSlot: function(a, b, limit) {
	        var start = a;
	        var end = b;

	        if (typeof start === OBJECT) {
	            start = this.categoryIndex(start);
	        }

	        if (typeof end === OBJECT) {
	            end = this.categoryIndex(end);
	        }

	        return CategoryAxis.fn.getSlot.call(this, start, end, limit);
	    },

	    valueRange: function() {
	        var options = this.options;
	        var range = categoryRange(options.srcCategories);

	        return {
	            min: toDate(range.min),
	            max: toDate(range.max)
	        };
	    },

	    categoryAt: function(index, total) {
	        return this.dataRange.dateAt(index, total);
	    },

	    categoriesCount: function() {
	        return this.dataRange.valuesCount();
	    },

	    rangeIndices: function() {
	        return this.dataRange.displayIndices();
	    },

	    labelsBetweenTicks: function() {
	        return !this.divisionRange.options.justified;
	    },

	    prepareUserOptions: function() {
	        if (this.isEmpty()) {
	            return;
	        }

	        this.options.categories = this.dataRange.values();
	    },

	    getCategory: function(point) {
	        var index = this.pointCategoryIndex(point);

	        if (index === null) {
	            return null;
	        }

	        return this.dataRange.dateAt(index);
	    },

	    totalIndex: function(value) {
	        return this.dataRange.totalIndex(value);
	    },

	    currentRangeIndices: function() {
	        var range = this.dataRange.valueRange();
	        return {
	            min: this.dataRange.totalIndex(range.min),
	            max: this.dataRange.totalIndex(range.max)
	        };
	    },

	    totalRange: function() {
	        return this.dataRange.total();
	    },

	    totalCount: function() {
	        return this.dataRange.totalCount();
	    },

	    isEmpty: function() {
	        return !this.options.srcCategories.length;
	    },

	    roundedRange: function() {
	        if (this.options.roundToBaseUnit !== false || this.isEmpty()) {
	            return this.range();
	        }

	        var options = this.options;
	        var datesRange = categoryRange(options.srcCategories);

	        var dateRange = new DateRange(datesRange.min, datesRange.max, $.extend({}, options, {
	            justified: false,
	            roundToBaseUnit: true,
	            justifyEnd: options.justified
	        }));

	        return dateRange.displayRange();
	    }
	});

	setDefaultOptions(DateCategoryAxis, {
	    type: DATE,
	    labels: {
	        dateFormats: DateLabelFormats
	    },
	    autoBaseUnitSteps: {
	        milliseconds: [ 1, 10, 100 ],
	        seconds: [ 1, 2, 5, 15, 30 ],
	        minutes: [ 1, 2, 5, 15, 30 ],
	        hours: [ 1, 2, 3 ],
	        days: [ 1, 2, 3 ],
	        weeks: [ 1, 2 ],
	        months: [ 1, 2, 3, 6 ],
	        years: [ 1, 2, 3, 5, 10, 25, 50 ]
	    },
	    maxDateGroups: 10
	});

	function autoAxisMin(min, max, narrow) {
	    if (!min && !max) {
	        return 0;
	    }

	    var axisMin;

	    if (min >= 0 && max >= 0) {
	        var minValue = min === max ? 0 : min;

	        var diff = (max - minValue) / max;
	        if (narrow === false || (!narrow && diff > ZERO_THRESHOLD)) {
	            return 0;
	        }

	        axisMin = Math.max(0, minValue - ((max - minValue) / 2));
	    } else {
	        axisMin = min;
	    }

	    return axisMin;
	}

	function autoAxisMax(min, max, narrow) {
	    if (!min && !max) {
	        return 1;
	    }

	    var axisMax;

	    if (min <= 0 && max <= 0) {
	        var maxValue = min === max ? 0 : max;

	        var diff = Math.abs((maxValue - min) / maxValue);
	        if (narrow === false || (!narrow && diff > ZERO_THRESHOLD)) {
	            return 0;
	        }

	        axisMax = Math.min(0, maxValue - ((min - maxValue) / 2));
	    } else {
	        axisMax = max;
	    }

	    return axisMax;
	}

	function floor(value, step) {
	    return round(Math.floor(value / step) * step, DEFAULT_PRECISION);
	}

	function ceil(value, step) {
	    return round(Math.ceil(value / step) * step, DEFAULT_PRECISION);
	}

	function limitCoordinate(value) {
	    return Math.max(Math.min(value, COORDINATE_LIMIT), -COORDINATE_LIMIT);
	}

	var MIN_VALUE_RANGE = Math.pow(10, -DEFAULT_PRECISION + 1);

	var NumericAxis = Axis.extend({
	    init: function(seriesMin, seriesMax, options, chartService) {
	        Axis.fn.init.call(this, $.extend({}, options, {
	            seriesMin: seriesMin,
	            seriesMax: seriesMax
	        }), chartService);
	    },

	    initUserOptions: function(options) {
	        var autoOptions = autoAxisOptions(options.seriesMin, options.seriesMax, options);
	        this.totalOptions = totalAxisOptions(autoOptions, options);

	        return axisOptions(autoOptions, options);
	    },

	    initFields: function() {
	        this.totalMin = this.totalOptions.min;
	        this.totalMax = this.totalOptions.max;
	        this.totalMajorUnit = this.totalOptions.majorUnit;
	        this.seriesMin = this.options.seriesMin;
	        this.seriesMax = this.options.seriesMax;
	    },

	    clone: function() {
	        return new NumericAxis(
	            this.seriesMin,
	            this.seriesMax,
	            $.extend({}, this.options),
	            this.chartService
	        );
	    },

	    startValue: function() {
	        return 0;
	    },

	    range: function() {
	        var options = this.options;
	        return { min: options.min, max: options.max };
	    },

	    getDivisions: function(stepValue) {
	        if (stepValue === 0) {
	            return 1;
	        }

	        var options = this.options;
	        var range = options.max - options.min;

	        return Math.floor(round(range / stepValue, COORD_PRECISION)) + 1;
	    },

	    getTickPositions: function(unit, skipUnit) {
	        var options = this.options;
	        var vertical = options.vertical;
	        var reverse = options.reverse;
	        var lineBox = this.lineBox();
	        var lineSize = vertical ? lineBox.height() : lineBox.width();
	        var range = options.max - options.min;
	        var scale = lineSize / range;
	        var step = unit * scale;
	        var divisions = this.getDivisions(unit);
	        var dir = (vertical ? -1 : 1) * (reverse ? -1 : 1);
	        var startEdge = dir === 1 ? 1 : 2;
	        var positions = [];
	        var pos = lineBox[(vertical ? Y : X) + startEdge];
	        var skipStep = 0;

	        if (skipUnit) {
	            skipStep = skipUnit / unit;
	        }

	        for (var idx = 0; idx < divisions; idx++) {
	            if (idx % skipStep !== 0) {
	                positions.push(round(pos, COORD_PRECISION));
	            }

	            pos = pos + step * dir;
	        }

	        return positions;
	    },

	    getMajorTickPositions: function() {
	        return this.getTickPositions(this.options.majorUnit);
	    },

	    getMinorTickPositions: function() {
	        return this.getTickPositions(this.options.minorUnit);
	    },

	    getSlot: function(a, b, limit) {
	        if (limit === void 0) { limit = false; }

	        var options = this.options;
	        var vertical = options.vertical;
	        var reverse = options.reverse;
	        var valueAxis = vertical ? Y : X;
	        var lineBox = this.lineBox();
	        var lineStart = lineBox[valueAxis + (reverse ? 2 : 1)];
	        var lineSize = vertical ? lineBox.height() : lineBox.width();
	        var dir = reverse ? -1 : 1;
	        var step = dir * (lineSize / (options.max - options.min));
	        var slotBox = new Box(lineBox.x1, lineBox.y1, lineBox.x1, lineBox.y1);

	        var start = a;
	        var end = b;

	        if (!defined(start)) {
	            start = end || 0;
	        }

	        if (!defined(end)) {
	            end = start || 0;
	        }

	        if (limit) {
	            start = Math.max(Math.min(start, options.max), options.min);
	            end = Math.max(Math.min(end, options.max), options.min);
	        }

	        var p1, p2;

	        if (vertical) {
	            p1 = options.max - Math.max(start, end);
	            p2 = options.max - Math.min(start, end);
	        } else {
	            p1 = Math.min(start, end) - options.min;
	            p2 = Math.max(start, end) - options.min;
	        }

	        slotBox[valueAxis + 1] = limitCoordinate(lineStart + step * (reverse ? p2 : p1));
	        slotBox[valueAxis + 2] = limitCoordinate(lineStart + step * (reverse ? p1 : p2));

	        return slotBox;
	    },

	    getValue: function(point) {
	        var options = this.options;
	        var vertical = options.vertical;
	        var reverse = options.reverse;
	        var max = Number(options.max);
	        var min = Number(options.min);
	        var valueAxis = vertical ? Y : X;
	        var lineBox = this.lineBox();
	        var lineStart = lineBox[valueAxis + (reverse ? 2 : 1)];
	        var lineSize = vertical ? lineBox.height() : lineBox.width();
	        var dir = reverse ? -1 : 1;
	        var offset = dir * (point[valueAxis] - lineStart);
	        var step = (max - min) / lineSize;
	        var valueOffset = offset * step;

	        if (offset < 0 || offset > lineSize) {
	            return null;
	        }

	        var value = vertical ?
	                max - valueOffset :
	                min + valueOffset;

	        return round(value, DEFAULT_PRECISION);
	    },

	    translateRange: function(delta) {
	        var options = this.options;
	        var vertical = options.vertical;
	        var reverse = options.reverse;
	        var max = options.max;
	        var min = options.min;
	        var lineBox = this.lineBox();
	        var size = vertical ? lineBox.height() : lineBox.width();
	        var range = max - min;
	        var scale = size / range;
	        var offset = round(delta / scale, DEFAULT_PRECISION);

	        if ((vertical || reverse) && !(vertical && reverse )) {
	            offset = -offset;
	        }

	        return {
	            min: min + offset,
	            max: max + offset,
	            offset: offset
	        };
	    },

	    scaleRange: function(delta) {
	        var options = this.options;
	        var offset = -delta * options.majorUnit;

	        return {
	            min: options.min - offset,
	            max: options.max + offset
	        };
	    },

	    labelsCount: function() {
	        return this.getDivisions(this.options.majorUnit);
	    },

	    createAxisLabel: function(index, labelOptions) {
	        var options = this.options;
	        var value = round(options.min + (index * options.majorUnit), DEFAULT_PRECISION);
	        var text = this.axisLabelText(value, null, labelOptions);

	        return new AxisLabel(value, text, index, null, labelOptions);
	    },

	    shouldRenderNote: function(value) {
	        var range = this.range();
	        return range.min <= value && value <= range.max;
	    },

	    pan: function(delta) {
	        var range = this.translateRange(delta);
	        return this.limitRange(range.min, range.max, this.totalMin, this.totalMax, range.offset);
	    },

	    pointsRange: function(start, end) {
	        var startValue = this.getValue(start);
	        var endValue = this.getValue(end);
	        var min = Math.min(startValue, endValue);
	        var max = Math.max(startValue, endValue);

	        if (this.isValidRange(min, max)) {
	            return {
	                min: min,
	                max: max
	            };
	        }
	    },

	    zoomRange: function(delta) {
	        var ref = this;
	        var totalMin = ref.totalMin;
	        var totalMax = ref.totalMax;
	        var newRange = this.scaleRange(delta);
	        var min = limitValue(newRange.min, totalMin, totalMax);
	        var max = limitValue(newRange.max, totalMin, totalMax);

	        if (this.isValidRange(min, max)) {
	            return {
	                min: min,
	                max: max
	            };
	        }
	    },

	    isValidRange: function(min, max) {
	        return max - min > MIN_VALUE_RANGE;
	    }
	});

	function autoAxisOptions(seriesMin, seriesMax, options) {
	    var narrowRange = options.narrowRange;

	    var autoMin = autoAxisMin(seriesMin, seriesMax, narrowRange);
	    var autoMax = autoAxisMax(seriesMin, seriesMax, narrowRange);

	    var majorUnit = autoMajorUnit(autoMin, autoMax);
	    var autoOptions = {
	        majorUnit: majorUnit
	    };

	    if (options.roundToMajorUnit !== false) {
	        if (autoMin < 0 && remainderClose(autoMin, majorUnit, 1 / 3)) {
	            autoMin -= majorUnit;
	        }

	        if (autoMax > 0 && remainderClose(autoMax, majorUnit, 1 / 3)) {
	            autoMax += majorUnit;
	        }
	    }

	    autoOptions.min = floor(autoMin, majorUnit);
	    autoOptions.max = ceil(autoMax, majorUnit);

	    return autoOptions;
	}

	function totalAxisOptions(autoOptions, options) {
	    return {
	        min: defined(options.min) ? Math.min(autoOptions.min, options.min) : autoOptions.min,
	        max: defined(options.max) ? Math.max(autoOptions.max, options.max) : autoOptions.max,
	        majorUnit: autoOptions.majorUnit
	    };
	}

	function clearNullValues(options, fields) {
	    for (var idx = 0; idx < fields.length; idx++) {
	        var field = fields[idx];
	        if (options[field] === null) {
	            options[field] = undefined;
	        }
	    }
	}

	function axisOptions(autoOptions, userOptions) {
	    var options = userOptions;
	    var userSetMin, userSetMax;

	    if (userOptions) {
	        clearNullValues(userOptions, [ 'min', 'max' ]);

	        userSetMin = defined(userOptions.min);
	        userSetMax = defined(userOptions.max);

	        var userSetLimits = userSetMin || userSetMax;

	        if (userSetLimits) {
	            if (userOptions.min === userOptions.max) {
	                if (userOptions.min > 0) {
	                    userOptions.min = 0;
	                } else {
	                    userOptions.max = 1;
	                }
	            }
	        }

	        if (userOptions.majorUnit) {
	            autoOptions.min = floor(autoOptions.min, userOptions.majorUnit);
	            autoOptions.max = ceil(autoOptions.max, userOptions.majorUnit);
	        } else if (userSetLimits) {
	            options = deepExtend(autoOptions, userOptions);

	            // Determine an auto major unit after min/max have been set
	            autoOptions.majorUnit = autoMajorUnit(options.min, options.max);
	        }
	    }

	    autoOptions.minorUnit = (options.majorUnit || autoOptions.majorUnit) / 5;

	    var result = deepExtend(autoOptions, options);
	    if (result.min >= result.max) {
	        if (userSetMin && !userSetMax) {
	            result.max = result.min + result.majorUnit;
	        } else if (!userSetMin && userSetMax) {
	            result.min = result.max - result.majorUnit;
	        }
	    }

	    return result;
	}

	function remainderClose(value, divisor, ratio) {
	    var remainder = round(Math.abs(value % divisor), DEFAULT_PRECISION);
	    var threshold = divisor * (1 - ratio);

	    return remainder === 0 || remainder > threshold;
	}

	setDefaultOptions(NumericAxis, {
	    type: "numeric",
	    min: 0,
	    max: 1,
	    vertical: true,
	    majorGridLines: {
	        visible: true,
	        width: 1,
	        color: BLACK
	    },
	    labels: {
	        format: "#.####################"
	    },
	    zIndex: 1
	});

	var DateValueAxis = Axis.extend({
	    init: function(seriesMin, seriesMax, axisOptions, chartService) {
	        var min = toDate(seriesMin);
	        var max = toDate(seriesMax);

	        var intlService = chartService.intl;
	        var options = axisOptions || {};
	        options = deepExtend(options || {}, {
	            min: parseDate(intlService, options.min),
	            max: parseDate(intlService, options.max),
	            axisCrossingValue: parseDates(intlService, options.axisCrossingValues || options.axisCrossingValue),
	            weekStartDay: firstDay(options, intlService)
	        });
	        options = applyDefaults(min, max, options);

	        Axis.fn.init.call(this, options, chartService);

	        this.intlService = intlService;
	        this.seriesMin = min;
	        this.seriesMax = max;

	        var weekStartDay = options.weekStartDay || 0;
	        this.totalMin = toTime(floorDate(toTime(min) - 1, options.baseUnit, weekStartDay));
	        this.totalMax = toTime(ceilDate(toTime(max) + 1, options.baseUnit, weekStartDay));
	    },

	    clone: function() {
	        return new DateValueAxis(this.seriesMin, this.seriesMax, $.extend({}, this.options), this.chartService);
	    },

	    range: function() {
	        var options = this.options;
	        return { min: options.min, max: options.max };
	    },

	    getDivisions: function(stepValue) {
	        var options = this.options;

	        return Math.floor(
	            duration(options.min, options.max, options.baseUnit) / stepValue + 1
	        );
	    },

	    getTickPositions: function(step) {
	        var options = this.options;
	        var vertical = options.vertical;
	        var lineBox = this.lineBox();
	        var dir = (vertical ? -1 : 1) * (options.reverse ? -1 : 1);
	        var startEdge = dir === 1 ? 1 : 2;
	        var start = lineBox[(vertical ? Y : X) + startEdge];
	        var divisions = this.getDivisions(step);
	        var timeRange = dateDiff(options.max, options.min);
	        var lineSize = vertical ? lineBox.height() : lineBox.width();
	        var scale = lineSize / timeRange;
	        var weekStartDay = options.weekStartDay || 0;

	        var positions = [ start ];
	        for (var i = 1; i < divisions; i++) {
	            var date = addDuration(options.min, i * step, options.baseUnit, weekStartDay);
	            var pos = start + dateDiff(date, options.min) * scale * dir;

	            positions.push(round(pos, COORD_PRECISION));
	        }

	        return positions;
	    },

	    getMajorTickPositions: function() {
	        return this.getTickPositions(this.options.majorUnit);
	    },

	    getMinorTickPositions: function() {
	        return this.getTickPositions(this.options.minorUnit);
	    },

	    getSlot: function(a, b, limit) {
	        return NumericAxis.prototype.getSlot.call(
	            this, parseDate(this.intlService, a), parseDate(this.intlService, b), limit
	        );
	    },

	    getValue: function(point) {
	        var value = NumericAxis.prototype.getValue.call(this, point);

	        return value !== null ? toDate(value) : null;
	    },

	    labelsCount: function() {
	        return this.getDivisions(this.options.majorUnit);
	    },

	    createAxisLabel: function(index, labelOptions) {
	        var options = this.options;
	        var offset = index * options.majorUnit;
	        var weekStartDay = options.weekStartDay || 0;
	        var date = options.min;

	        if (offset > 0) {
	            date = addDuration(date, offset, options.baseUnit, weekStartDay);
	        }

	        var unitFormat = labelOptions.dateFormats[options.baseUnit];
	        labelOptions.format = labelOptions.format || unitFormat;

	        var text = this.axisLabelText(date, null, labelOptions);
	        return new AxisLabel(date, text, index, null, labelOptions);
	    },

	    translateRange: function(delta, exact) {
	        var options = this.options;
	        var baseUnit = options.baseUnit;
	        var weekStartDay = options.weekStartDay || 0;
	        var lineBox = this.lineBox();
	        var size = options.vertical ? lineBox.height() : lineBox.width();
	        var range = this.range();
	        var scale = size / dateDiff(range.max, range.min);
	        var offset = round(delta / scale, DEFAULT_PRECISION) * (options.reverse ? -1 : 1);
	        var from = addTicks(options.min, offset);
	        var to = addTicks(options.max, offset);

	        if (!exact) {
	            from = addDuration(from, 0, baseUnit, weekStartDay);
	            to = addDuration(to, 0, baseUnit, weekStartDay);
	        }

	        return {
	            min: from,
	            max: to,
	            offset: offset
	        };
	    },

	    scaleRange: function(delta) {
	        var ref = this.options;
	        var from = ref.min;
	        var to = ref.max;
	        var rounds = Math.abs(delta);

	        while (rounds--) {
	            var range = dateDiff(from, to);
	            var step = Math.round(range * 0.1);
	            if (delta < 0) {
	                from = addTicks(from, step);
	                to = addTicks(to, -step);
	            } else {
	                from = addTicks(from, -step);
	                to = addTicks(to, step);
	            }
	        }

	        return { min: from, max: to };
	    },

	    shouldRenderNote: function(value) {
	        var range = this.range();

	        return dateComparer(value, range.min) >= 0 && dateComparer(value, range.max) <= 0;
	    },

	    pan: function(delta) {
	        var range = this.translateRange(delta, true);
	        var limittedRange = this.limitRange(toTime(range.min), toTime(range.max), this.totalMin, this.totalMax, range.offset);

	        if (limittedRange) {
	            return {
	                min: toDate(limittedRange.min),
	                max: toDate(limittedRange.max)
	            };
	        }
	    },

	    pointsRange: function(start, end) {
	        var startValue = this.getValue(start);
	        var endValue = this.getValue(end);
	        var min = Math.min(startValue, endValue);
	        var max = Math.max(startValue, endValue);

	        return {
	            min: toDate(min),
	            max: toDate(max)
	        };
	    },

	    zoomRange: function(delta) {
	        var range = this.scaleRange(delta);
	        var min = toDate(limitValue(toTime(range.min), this.totalMin, this.totalMax));
	        var max = toDate(limitValue(toTime(range.max), this.totalMin, this.totalMax));

	        return {
	            min: min,
	            max: max
	        };
	    }
	});

	function timeUnits(delta) {
	    var unit = HOURS;

	    if (delta >= TIME_PER_YEAR) {
	        unit = YEARS;
	    } else if (delta >= TIME_PER_MONTH) {
	        unit = MONTHS;
	    } else if (delta >= TIME_PER_WEEK) {
	        unit = WEEKS;
	    } else if (delta >= TIME_PER_DAY) {
	        unit = DAYS;
	    }

	    return unit;
	}

	function applyDefaults(seriesMin, seriesMax, options) {
	    var min = options.min || seriesMin;
	    var max = options.max || seriesMax;
	    var baseUnit = options.baseUnit || (max && min ? timeUnits(absoluteDateDiff(max, min)) : HOURS);
	    var baseUnitTime = TIME_PER_UNIT[baseUnit];
	    var weekStartDay = options.weekStartDay || 0;
	    var autoMin = floorDate(toTime(min) - 1, baseUnit, weekStartDay) || toDate(max);
	    var autoMax = ceilDate(toTime(max) + 1, baseUnit, weekStartDay);
	    var userMajorUnit = options.majorUnit ? options.majorUnit : undefined;
	    var majorUnit = userMajorUnit || ceil(
	                        autoMajorUnit(autoMin.getTime(), autoMax.getTime()),
	                        baseUnitTime
	                    ) / baseUnitTime;
	    var actualUnits = duration(autoMin, autoMax, baseUnit);
	    var totalUnits = ceil(actualUnits, majorUnit);
	    var unitsToAdd = totalUnits - actualUnits;
	    var head = Math.floor(unitsToAdd / 2);
	    var tail = unitsToAdd - head;

	    if (!options.baseUnit) {
	        delete options.baseUnit;
	    }

	    options.baseUnit = options.baseUnit || baseUnit;
	    options.min = options.min || addDuration(autoMin, -head, baseUnit, weekStartDay);
	    options.max = options.max || addDuration(autoMax, tail, baseUnit, weekStartDay);
	    options.minorUnit = options.minorUnit || majorUnit / 5;
	    options.majorUnit = majorUnit;

	    return options;
	}

	setDefaultOptions(DateValueAxis, {
	    type: DATE,
	    majorGridLines: {
	        visible: true,
	        width: 1,
	        color: BLACK
	    },
	    labels: {
	        dateFormats: DateLabelFormats
	    }
	});

	var DEFAULT_MAJOR_UNIT = 10;

	var LogarithmicAxis = Axis.extend({
	    init: function(seriesMin, seriesMax, options, chartService) {

	        var axisOptions = deepExtend({ majorUnit: DEFAULT_MAJOR_UNIT, min: seriesMin, max: seriesMax }, options);
	        var base = axisOptions.majorUnit;
	        var autoMax = autoAxisMax$1(seriesMax, base);
	        var autoMin = autoAxisMin$1(seriesMin, seriesMax, axisOptions);
	        var range = initRange(autoMin, autoMax, axisOptions, options);

	        axisOptions.max = range.max;
	        axisOptions.min = range.min;
	        axisOptions.minorUnit = options.minorUnit || round(base - 1, DEFAULT_PRECISION);

	        Axis.fn.init.call(this, axisOptions, chartService);

	        this.totalMin = defined(options.min) ? Math.min(autoMin, options.min) : autoMin;
	        this.totalMax = defined(options.max) ? Math.max(autoMax, options.max) : autoMax;
	        this.logMin = round(log(range.min, base), DEFAULT_PRECISION);
	        this.logMax = round(log(range.max, base), DEFAULT_PRECISION);
	        this.seriesMin = seriesMin;
	        this.seriesMax = seriesMax;

	        this.createLabels();
	    },

	    clone: function() {
	        return new LogarithmicAxis(
	            this.seriesMin,
	            this.seriesMax,
	            $.extend({}, this.options),
	            this.chartService
	        );
	    },

	    startValue: function() {
	        return this.options.min;
	    },

	    getSlot: function(a, b, limit) {
	        var ref = this;
	        var options = ref.options;
	        var logMin = ref.logMin;
	        var logMax = ref.logMax;
	        var reverse = options.reverse;
	        var vertical = options.vertical;
	        var base = options.majorUnit;
	        var valueAxis = vertical ? Y : X;
	        var lineBox = this.lineBox();
	        var lineStart = lineBox[valueAxis + (reverse ? 2 : 1)];
	        var lineSize = vertical ? lineBox.height() : lineBox.width();
	        var dir = reverse ? -1 : 1;
	        var step = dir * (lineSize / (logMax - logMin));
	        var slotBox = new Box(lineBox.x1, lineBox.y1, lineBox.x1, lineBox.y1);
	        var start = a;
	        var end = b;

	        if (!defined(start)) {
	            start = end || 1;
	        }

	        if (!defined(end)) {
	            end = start || 1;
	        }

	        if (start <= 0 || end <= 0) {
	            return null;
	        }

	        if (limit) {
	            start = Math.max(Math.min(start, options.max), options.min);
	            end = Math.max(Math.min(end, options.max), options.min);
	        }

	        start = log(start, base);
	        end = log(end, base);

	        var p1, p2;

	        if (vertical) {
	            p1 = logMax - Math.max(start, end);
	            p2 = logMax - Math.min(start, end);
	        } else {
	            p1 = Math.min(start, end) - logMin;
	            p2 = Math.max(start, end) - logMin;
	        }

	        slotBox[valueAxis + 1] = limitCoordinate(lineStart + step * (reverse ? p2 : p1));
	        slotBox[valueAxis + 2] = limitCoordinate(lineStart + step * (reverse ? p1 : p2));

	        return slotBox;
	    },

	    getValue: function(point) {
	        var ref = this;
	        var options = ref.options;
	        var logMin = ref.logMin;
	        var logMax = ref.logMax;
	        var reverse = options.reverse;
	        var vertical = options.vertical;
	        var base = options.majorUnit;
	        var lineBox = this.lineBox();
	        var dir = vertical === reverse ? 1 : -1;
	        var startEdge = dir === 1 ? 1 : 2;
	        var lineSize = vertical ? lineBox.height() : lineBox.width();
	        var step = ((logMax - logMin) / lineSize);
	        var valueAxis = vertical ? Y : X;
	        var lineStart = lineBox[valueAxis + startEdge];
	        var offset = dir * (point[valueAxis] - lineStart);
	        var valueOffset = offset * step;

	        if (offset < 0 || offset > lineSize) {
	            return null;
	        }

	        var value = logMin + valueOffset;

	        return round(Math.pow(base, value), DEFAULT_PRECISION);
	    },

	    range: function() {
	        var options = this.options;
	        return { min: options.min, max: options.max };
	    },

	    scaleRange: function(delta) {
	        var base = this.options.majorUnit;
	        var offset = -delta;

	        return {
	            min: Math.pow(base, this.logMin - offset),
	            max: Math.pow(base, this.logMax + offset)
	        };
	    },

	    translateRange: function(delta) {
	        var ref = this;
	        var options = ref.options;
	        var logMin = ref.logMin;
	        var logMax = ref.logMax;
	        var reverse = options.reverse;
	        var vertical = options.vertical;
	        var base = options.majorUnit;
	        var lineBox = this.lineBox();
	        var size = vertical ? lineBox.height() : lineBox.width();
	        var scale = size / (logMax - logMin);
	        var offset = round(delta / scale, DEFAULT_PRECISION);

	        if ((vertical || reverse) && !(vertical && reverse )) {
	            offset = -offset;
	        }

	        return {
	            min: Math.pow(base, logMin + offset),
	            max: Math.pow(base, logMax + offset),
	            offset: offset
	        };
	    },

	    labelsCount: function() {
	        var floorMax = Math.floor(this.logMax);
	        var count = Math.floor(floorMax - this.logMin) + 1;

	        return count;
	    },

	    getMajorTickPositions: function() {
	        var ticks = [];

	        this.traverseMajorTicksPositions(function (position) {
	            ticks.push(position);
	        }, { step: 1, skip: 0 });

	        return ticks;
	    },

	    createTicks: function(lineGroup) {
	        var options = this.options;
	        var majorTicks = options.majorTicks;
	        var minorTicks = options.minorTicks;
	        var vertical = options.vertical;
	        var mirror = options.labels.mirror;
	        var lineBox = this.lineBox();
	        var ticks = [];
	        var tickLineOptions = {
	            // TODO
	            // _alignLines: options._alignLines,
	            vertical: vertical
	        };

	        function render(tickPosition, tickOptions) {
	            tickLineOptions.tickX = mirror ? lineBox.x2 : lineBox.x2 - tickOptions.size;
	            tickLineOptions.tickY = mirror ? lineBox.y1 - tickOptions.size : lineBox.y1;
	            tickLineOptions.position = tickPosition;

	            lineGroup.append(createAxisTick(tickLineOptions, tickOptions));
	        }

	        if (majorTicks.visible) {
	            this.traverseMajorTicksPositions(render, majorTicks);
	        }

	        if (minorTicks.visible) {
	            this.traverseMinorTicksPositions(render, minorTicks);
	        }

	        return ticks;
	    },

	    createGridLines: function(altAxis) {
	        var options = this.options;
	        var minorGridLines = options.minorGridLines;
	        var majorGridLines = options.majorGridLines;
	        var vertical = options.vertical;
	        var lineBox = altAxis.lineBox();
	        var lineOptions = {
	            lineStart: lineBox[vertical ? "x1" : "y1"],
	            lineEnd: lineBox[vertical ? "x2" : "y2"],
	            vertical: vertical
	        };
	        var majorTicks = [];

	        var container = this.gridLinesVisual();
	        function render(tickPosition, gridLine) {
	            if (!inArray(tickPosition, majorTicks)) {
	                lineOptions.position = tickPosition;
	                container.append(createAxisGridLine(lineOptions, gridLine));

	                majorTicks.push(tickPosition);
	            }
	        }

	        if (majorGridLines.visible) {
	            this.traverseMajorTicksPositions(render, majorGridLines);
	        }

	        if (minorGridLines.visible) {
	            this.traverseMinorTicksPositions(render, minorGridLines);
	        }

	        return container.children;
	    },

	    traverseMajorTicksPositions: function(callback, tickOptions) {
	        var ref = this._lineOptions();
	        var lineStart = ref.lineStart;
	        var step = ref.step;
	        var ref$1 = this;
	        var logMin = ref$1.logMin;
	        var logMax = ref$1.logMax;

	        for (var power = Math.ceil(logMin) + tickOptions.skip; power <= logMax; power += tickOptions.step) {
	            var position = round(lineStart + step * (power - logMin), DEFAULT_PRECISION);
	            callback(position, tickOptions);
	        }
	    },

	    traverseMinorTicksPositions: function(callback, tickOptions) {
	        var this$1 = this;

	        var ref = this.options;
	        var min = ref.min;
	        var max = ref.max;
	        var minorUnit = ref.minorUnit;
	        var base = ref.majorUnit;
	        var ref$1 = this._lineOptions();
	        var lineStart = ref$1.lineStart;
	        var step = ref$1.step;
	        var ref$2 = this;
	        var logMin = ref$2.logMin;
	        var logMax = ref$2.logMax;
	        var start = Math.floor(logMin);

	        for (var power = start; power < logMax; power++) {
	            var minorOptions = this$1._minorIntervalOptions(power);
	            for (var idx = tickOptions.skip; idx < minorUnit; idx += tickOptions.step) {
	                var value = minorOptions.value + idx * minorOptions.minorStep;
	                if (value > max) {
	                    break;
	                }
	                if (value >= min) {
	                    var position = round(lineStart + step * (log(value, base) - logMin), DEFAULT_PRECISION);
	                    callback(position, tickOptions);
	                }
	            }
	        }
	    },

	    createAxisLabel: function(index, labelOptions) {
	        var power = Math.ceil(this.logMin + index);
	        var value = Math.pow(this.options.majorUnit, power);
	        var text = this.axisLabelText(value, null, labelOptions);

	        return new AxisLabel(value, text, index, null, labelOptions);
	    },

	    shouldRenderNote: function(value) {
	        var range = this.range();
	        return range.min <= value && value <= range.max;
	    },

	    pan: function(delta) {
	        var range = this.translateRange(delta);
	        return this.limitRange(range.min, range.max, this.totalMin, this.totalMax, range.offset);
	    },

	    pointsRange: function(start, end) {
	        var startValue = this.getValue(start);
	        var endValue = this.getValue(end);
	        var min = Math.min(startValue, endValue);
	        var max = Math.max(startValue, endValue);

	        return {
	            min: min,
	            max: max
	        };
	    },

	    zoomRange: function(delta) {
	        var ref = this;
	        var options = ref.options;
	        var totalMin = ref.totalMin;
	        var totalMax = ref.totalMax;
	        var newRange = this.scaleRange(delta);
	        var min = limitValue(newRange.min, totalMin, totalMax);
	        var max = limitValue(newRange.max, totalMin, totalMax);
	        var base = options.majorUnit;
	        var acceptOptionsRange = max > min && options.min && options.max && (round(log(options.max, base) - log(options.min, base), DEFAULT_PRECISION) < 1);
	        var acceptNewRange = !(options.min === totalMin && options.max === totalMax) && round(log(max, base) - log(min, base), DEFAULT_PRECISION) >= 1;

	        if (acceptOptionsRange || acceptNewRange) {
	            return {
	                min: min,
	                max: max
	            };
	        }
	    },

	    _minorIntervalOptions: function(power) {
	        var ref = this.options;
	        var minorUnit = ref.minorUnit;
	        var base = ref.majorUnit;
	        var value = Math.pow(base, power);
	        var nextValue = Math.pow(base, power + 1);
	        var difference = nextValue - value;
	        var minorStep = difference / minorUnit;

	        return {
	            value: value,
	            minorStep: minorStep
	        };
	    },

	    _lineOptions: function() {
	        var ref = this.options;
	        var reverse = ref.reverse;
	        var vertical = ref.vertical;
	        var valueAxis = vertical ? Y : X;
	        var lineBox = this.lineBox();
	        var dir = vertical === reverse ? 1 : -1;
	        var startEdge = dir === 1 ? 1 : 2;
	        var lineSize = vertical ? lineBox.height() : lineBox.width();
	        var step = dir * (lineSize / (this.logMax - this.logMin));
	        var lineStart = lineBox[valueAxis + startEdge];

	        return {
	            step: step,
	            lineStart: lineStart,
	            lineBox: lineBox
	        };
	    }
	});

	function initRange(autoMin, autoMax, axisOptions, options) {
	    var min = axisOptions.min;
	    var max = axisOptions.max;

	    if (defined(axisOptions.axisCrossingValue) && axisOptions.axisCrossingValue <= 0) {
	        throwNegativeValuesError();
	    }

	    if (!defined(options.max)) {
	        max = autoMax;
	    } else if (options.max <= 0) {
	        throwNegativeValuesError();
	    }

	    if (!defined(options.min)) {
	        min = autoMin;
	    } else if (options.min <= 0) {
	        throwNegativeValuesError();
	    }

	    return {
	        min: min,
	        max: max
	    };
	}

	function autoAxisMin$1(min, max, options) {
	    var base = options.majorUnit;
	    var autoMin = min;
	    if (min <= 0) {
	        autoMin = max <= 1 ? Math.pow(base, -2) : 1;
	    } else if (!options.narrowRange) {
	        autoMin = Math.pow(base, Math.floor(log(min, base)));
	    }
	    return autoMin;
	}

	function autoAxisMax$1(max, base) {
	    var logMaxRemainder = round(log(max, base), DEFAULT_PRECISION) % 1;
	    var autoMax;
	    if (max <= 0) {
	        autoMax = base;
	    } else if (logMaxRemainder !== 0 && (logMaxRemainder < 0.3 || logMaxRemainder > 0.9)) {
	        autoMax = Math.pow(base, log(max, base) + 0.2);
	    } else {
	        autoMax = Math.pow(base, Math.ceil(log(max, base)));
	    }

	    return autoMax;
	}

	function throwNegativeValuesError() {
	    throw new Error("Non positive values cannot be used for a logarithmic axis");
	}

	function log(y, x) {
	    return Math.log(y) / Math.log(x);
	}

	setDefaultOptions(LogarithmicAxis, {
	    type: "log",
	    majorUnit: DEFAULT_MAJOR_UNIT,
	    minorUnit: 1,
	    axisCrossingValue: 1,
	    vertical: true,
	    majorGridLines: {
	        visible: true,
	        width: 1,
	        color: BLACK
	    },
	    zIndex: 1,
	    _deferLabels: true
	});

	var GridLinesMixin = {
	    createGridLines: function(altAxis) {
	        var options = this.options;
	        var radius = Math.abs(this.box.center().y - altAxis.lineBox().y1);
	        var gridLines = [];
	        var skipMajor = false;
	        var majorAngles, minorAngles;

	        if (options.majorGridLines.visible) {
	            majorAngles = this.majorGridLineAngles(altAxis);
	            skipMajor = true;

	            gridLines = this.renderMajorGridLines(
	                majorAngles, radius, options.majorGridLines
	            );
	        }

	        if (options.minorGridLines.visible) {
	            minorAngles = this.minorGridLineAngles(altAxis, skipMajor);

	            append(gridLines, this.renderMinorGridLines(
	                minorAngles, radius, options.minorGridLines, altAxis, skipMajor
	            ));
	        }

	        return gridLines;
	    },

	    renderMajorGridLines: function(angles, radius, options) {
	        return this.renderGridLines(angles, radius, options);
	    },

	    renderMinorGridLines: function(angles, radius, options, altAxis, skipMajor) {
	        var radiusCallback = this.radiusCallback && this.radiusCallback(radius, altAxis, skipMajor);
	        return this.renderGridLines(angles, radius, options, radiusCallback);
	    },

	    renderGridLines: function(angles, radius, options, radiusCallback) {
	        var style = {
	            stroke: {
	                width: options.width,
	                color: options.color,
	                dashType: options.dashType
	            }
	        };

	        var center = this.box.center();
	        var circle = new Circle([ center.x, center.y ], radius);
	        var container = this.gridLinesVisual();

	        for (var i = 0; i < angles.length; i++) {
	            var line = new Path(style);
	            if (radiusCallback) {
	                circle.radius = radiusCallback(angles[i]);
	            }

	            line.moveTo(circle.center)
	                .lineTo(circle.pointAt(angles[i] + 180));

	            container.append(line);
	        }

	        return container.children;
	    },

	    gridLineAngles: function(altAxis, size, skip, step, skipAngles) {
	        var this$1 = this;

	        var divs = this.intervals(size, skip, step, skipAngles);
	        var options = altAxis.options;
	        var altAxisVisible = options.visible && (options.line || {}).visible !== false;

	        return map(divs, function (d) {
	            var alpha = this$1.intervalAngle(d);

	            if (!altAxisVisible || alpha !== 90) {
	                return alpha;
	            }
	        });
	    }
	};

	var RadarCategoryAxis = CategoryAxis.extend({
	    range: function() {
	        return { min: 0, max: this.options.categories.length };
	    },

	    reflow: function(box) {
	        this.box = box;
	        this.reflowLabels();
	    },

	    lineBox: function() {
	        return this.box;
	    },

	    reflowLabels: function() {
	        var this$1 = this;

	        var ref = this;
	        var labels = ref.labels;
	        var labelOptions = ref.options.labels;
	        var skip = labelOptions.skip || 0;
	        var step = labelOptions.step || 1;
	        var measureBox = new Box();

	        for (var i = 0; i < labels.length; i++) {
	            labels[i].reflow(measureBox);
	            var labelBox = labels[i].box;

	            labels[i].reflow(this$1.getSlot(skip + i * step).adjacentBox(
	                0, labelBox.width(), labelBox.height()
	            ));
	        }
	    },

	    intervals: function(size, skipOption, stepOption, skipAngles) {
	        if (skipAngles === void 0) { skipAngles = false; }

	        var options = this.options;
	        var categories = options.categories.length;
	        var divCount = categories / size || 1;
	        var divAngle = 360 / divCount;
	        var skip = skipOption || 0;
	        var step = stepOption || 1;
	        var divs = [];
	        var angle = 0;

	        for (var i = skip; i < divCount; i += step) {
	            if (options.reverse) {
	                angle = 360 - i * divAngle;
	            } else {
	                angle = i * divAngle;
	            }

	            angle = round(angle, COORD_PRECISION) % 360;

	            if (!(skipAngles && inArray(angle, skipAngles))) {
	                divs.push(angle);
	            }
	        }

	        return divs;
	    },

	    majorIntervals: function() {
	        return this.intervals(1);
	    },

	    minorIntervals: function() {
	        return this.intervals(0.5);
	    },

	    intervalAngle: function(interval) {
	        return (360 + interval + this.options.startAngle) % 360;
	    },

	    majorAngles: function() {
	        var this$1 = this;

	        return map(this.majorIntervals(), function (interval) { return this$1.intervalAngle(interval); });
	    },

	    createLine: function() {
	        return [];
	    },

	    majorGridLineAngles: function(altAxis) {
	        var majorGridLines = this.options.majorGridLines;
	        return this.gridLineAngles(altAxis, 1, majorGridLines.skip, majorGridLines.step);
	    },

	    minorGridLineAngles: function(altAxis, skipMajor) {
	        var ref = this.options;
	        var minorGridLines = ref.minorGridLines;
	        var majorGridLines = ref.majorGridLines;
	        var majorGridLineAngles = skipMajor ? this.intervals(1, majorGridLines.skip, majorGridLines.step) : null;

	        return this.gridLineAngles(altAxis, 0.5, minorGridLines.skip, minorGridLines.step, majorGridLineAngles);
	    },

	    radiusCallback: function(radius, altAxis, skipMajor) {
	        if (altAxis.options.type !== ARC) {
	            var minorAngle = rad(360 / (this.options.categories.length * 2));
	            var minorRadius = Math.cos(minorAngle) * radius;
	            var majorAngles = this.majorAngles();

	            var radiusCallback = function(angle) {
	                if (!skipMajor && inArray(angle, majorAngles)) {
	                    return radius;
	                }

	                return minorRadius;
	            };
	            return radiusCallback;
	        }
	    },

	    createPlotBands: function() {
	        var this$1 = this;

	        var plotBands = this.options.plotBands || [];

	        var group = this._plotbandGroup = new Group({
	            zIndex: -1
	        });

	        for (var i = 0; i < plotBands.length; i++) {
	            var band = plotBands[i];
	            var slot = this$1.plotBandSlot(band);
	            var singleSlot = this$1.getSlot(band.from);

	            var head = band.from - Math.floor(band.from);
	            slot.startAngle += head * singleSlot.angle;

	            var tail = Math.ceil(band.to) - band.to;
	            slot.angle -= (tail + head) * singleSlot.angle;

	            var ring = ShapeBuilder.current.createRing(slot, {
	                fill: {
	                    color: band.color,
	                    opacity: band.opacity
	                },
	                stroke: {
	                    opacity: band.opacity
	                }
	            });
	            group.append(ring);
	        }

	        this.appendVisual(group);
	    },

	    plotBandSlot: function(band) {
	        return this.getSlot(band.from, band.to - 1);
	    },

	    getSlot: function(from, to) {
	        var options = this.options;
	        var justified = options.justified;
	        var box = this.box;
	        var divs = this.majorAngles();
	        var totalDivs = divs.length;
	        var slotAngle = 360 / totalDivs;
	        var fromValue = from;

	        if (options.reverse && !justified) {
	            fromValue = (fromValue + 1) % totalDivs;
	        }

	        fromValue = limitValue(Math.floor(fromValue), 0, totalDivs - 1);
	        var slotStart = divs[fromValue];

	        if (justified) {
	            slotStart = slotStart - slotAngle / 2;

	            if (slotStart < 0) {
	                slotStart += 360;
	            }
	        }

	        var toValue = limitValue(Math.ceil(to || fromValue), fromValue, totalDivs - 1);
	        var slots = toValue - fromValue + 1;
	        var angle = slotAngle * slots;

	        return new Ring(box.center(), 0, box.height() / 2, slotStart, angle);
	    },

	    slot: function(from, to) {
	        var slot = this.getSlot(from, to);
	        var startAngle = slot.startAngle + 180;
	        var endAngle = startAngle + slot.angle;

	        return new geometry.Arc([ slot.center.x, slot.center.y ], {
	            startAngle: startAngle,
	            endAngle: endAngle,
	            radiusX: slot.radius,
	            radiusY: slot.radius
	        });
	    },

	    pointCategoryIndex: function(point) {
	        var this$1 = this;

	        var length = this.options.categories.length;
	        var index = null;

	        for (var i = 0; i < length; i++) {
	            var slot = this$1.getSlot(i);
	            if (slot.containsPoint(point)) {
	                index = i;
	                break;
	            }
	        }

	        return index;
	    }
	});

	setDefaultOptions(RadarCategoryAxis, {
	    startAngle: 90,
	    labels: {
	        margin: getSpacing(10)
	    },
	    majorGridLines: {
	        visible: true
	    },
	    justified: true
	});
	deepExtend(RadarCategoryAxis.prototype, GridLinesMixin);

	var PolarAxis = Axis.extend({
	    init: function(options, chartService) {
	        Axis.fn.init.call(this, options, chartService);

	        var instanceOptions = this.options;

	        instanceOptions.minorUnit = instanceOptions.minorUnit || instanceOptions.majorUnit / 2;
	    },

	    getDivisions: function(stepValue) {
	        return NumericAxis.prototype.getDivisions.call(this, stepValue) - 1;
	    },

	    reflow: function(box) {
	        this.box = box;
	        this.reflowLabels();
	    },

	    reflowLabels: function() {
	        var this$1 = this;

	        var ref = this;
	        var options = ref.options;
	        var labels = ref.labels;
	        var labelOptions = ref.options.labels;
	        var skip = labelOptions.skip || 0;
	        var step = labelOptions.step || 1;

	        var measureBox = new Box();
	        var divs = this.intervals(options.majorUnit, skip, step);

	        for (var i = 0; i < labels.length; i++) {
	            labels[i].reflow(measureBox);
	            var labelBox = labels[i].box;

	            labels[i].reflow(this$1.getSlot(divs[i]).adjacentBox(0, labelBox.width(), labelBox.height()));
	        }
	    },

	    lineBox: function() {
	        return this.box;
	    },

	    intervals: function(size, skipOption, stepOption, skipAngles) {
	        if (skipAngles === void 0) { skipAngles = false; }

	        var min = this.options.min;
	        var divisions = this.getDivisions(size);
	        var divs = [];
	        var skip = skipOption || 0;
	        var step = stepOption || 1;

	        for (var i = skip; i < divisions; i += step) {
	            var current = (360 + min + i * size) % 360;
	            if (!(skipAngles && inArray(current, skipAngles))) {
	                divs.push(current);
	            }
	        }

	        return divs;
	    },

	    majorIntervals: function() {
	        return this.intervals(this.options.majorUnit);
	    },

	    minorIntervals: function() {
	        return this.intervals(this.options.minorUnit);
	    },

	    intervalAngle: function(i) {
	        return (540 - i - this.options.startAngle) % 360;
	    },

	    createLine: function() {
	        return [];
	    },

	    majorGridLineAngles: function(altAxis) {
	        var majorGridLines = this.options.majorGridLines;
	        return this.gridLineAngles(altAxis, this.options.majorUnit, majorGridLines.skip, majorGridLines.step);
	    },

	    minorGridLineAngles: function(altAxis, skipMajor) {
	        var options = this.options;
	        var minorGridLines = options.minorGridLines;
	        var majorGridLines = options.majorGridLines;
	        var majorGridLineAngles = skipMajor ? this.intervals(options.majorUnit, majorGridLines.skip, majorGridLines.step) : null;

	        return this.gridLineAngles(altAxis, options.minorUnit, minorGridLines.skip, minorGridLines.step, majorGridLineAngles);
	    },

	    plotBandSlot: function(band) {
	        return this.getSlot(band.from, band.to);
	    },

	    getSlot: function(a, b) {
	        var ref = this;
	        var options = ref.options;
	        var box = ref.box;
	        var startAngle = options.startAngle;
	        var start = limitValue(a, options.min, options.max);
	        var end = limitValue(b || start, start, options.max);

	        if (options.reverse) {
	            start *= -1;
	            end *= -1;
	        }

	        start = (540 - start - startAngle) % 360;
	        end = (540 - end - startAngle) % 360;

	        if (end < start) {
	            var tmp = start;
	            start = end;
	            end = tmp;
	        }

	        return new Ring(box.center(), 0, box.height() / 2, start, end - start);
	    },

	    slot: function(from, to) {
	        if (to === void 0) { to = from; }

	        var options = this.options;
	        var start = 360 - options.startAngle;
	        var slot = this.getSlot(from, to);
	        var min = Math.min(from, to);
	        var max = Math.max(from, to);
	        var startAngle, endAngle;

	        if (options.reverse) {
	            startAngle = min;
	            endAngle = max;
	        } else {
	            startAngle = 360 - max;
	            endAngle = 360 - min;
	        }

	        startAngle = (startAngle + start) % 360;
	        endAngle = (endAngle + start) % 360;

	        return new geometry.Arc([ slot.center.x, slot.center.y ], {
	            startAngle: startAngle,
	            endAngle: endAngle,
	            radiusX: slot.radius,
	            radiusY: slot.radius
	        });
	    },

	    getValue: function(point) {
	        var options = this.options;
	        var center = this.box.center();
	        var dx = point.x - center.x;
	        var dy = point.y - center.y;
	        var theta = Math.round(deg(Math.atan2(dy, dx)));
	        var start = options.startAngle;

	        if (!options.reverse) {
	            theta *= -1;
	            start *= -1;
	        }

	        return (theta + start + 360) % 360;
	    },

	    valueRange: function() {
	        return {
	            min: 0,
	            max: Math.PI * 2
	        };
	    }
	});

	setDefaultOptions(PolarAxis, {
	    type: "polar",
	    startAngle: 0,
	    reverse: false,
	    majorUnit: 60,
	    min: 0,
	    max: 360,
	    labels: {
	        margin: getSpacing(10)
	    },
	    majorGridLines: {
	        color: BLACK,
	        visible: true,
	        width: 1
	    },
	    minorGridLines: {
	        color: "#aaa"
	    }
	});

	deepExtend(PolarAxis.prototype, GridLinesMixin, {
	    createPlotBands: RadarCategoryAxis.prototype.createPlotBands,
	    majorAngles: RadarCategoryAxis.prototype.majorAngles,
	    range: NumericAxis.prototype.range,
	    labelsCount: NumericAxis.prototype.labelsCount,
	    createAxisLabel: NumericAxis.prototype.createAxisLabel
	});

	var RadarNumericAxisMixin = {
	    options: {
	        majorGridLines: {
	            visible: true
	        }
	    },

	    createPlotBands: function() {
	        var this$1 = this;

	        var ref = this.options;
	        var type = ref.majorGridLines.type;
	        var plotBands = ref.plotBands; if (plotBands === void 0) { plotBands = []; }
	        var altAxis = this.plotArea.polarAxis;
	        var majorAngles = altAxis.majorAngles();
	        var center = altAxis.box.center();
	        var group = this._plotbandGroup = new Group({
	            zIndex: -1
	        });

	        for (var i = 0; i < plotBands.length; i++) {
	            var band = plotBands[i];
	            var bandStyle = {
	                fill: {
	                    color: band.color,
	                    opacity: band.opacity
	                },
	                stroke: {
	                    opacity: band.opacity
	                }
	            };

	            var slot = this$1.getSlot(band.from, band.to, true);
	            var ring = new Ring(center, center.y - slot.y2, center.y - slot.y1, 0, 360);

	            var shape = (void 0);
	            if (type === ARC) {
	                shape = ShapeBuilder.current.createRing(ring, bandStyle);
	            } else {
	                shape = Path.fromPoints(this$1.plotBandPoints(ring, majorAngles), bandStyle).close();
	            }

	            group.append(shape);
	        }

	        this.appendVisual(group);
	    },

	    plotBandPoints: function(ring, angles) {
	        var innerPoints = [];
	        var outerPoints = [];
	        var center = [ ring.center.x, ring.center.y ];
	        var innerCircle = new Circle(center, ring.innerRadius);
	        var outerCircle = new Circle(center, ring.radius);

	        for (var i = 0; i < angles.length; i++) {
	            innerPoints.push(innerCircle.pointAt(angles[i] + 180));
	            outerPoints.push(outerCircle.pointAt(angles[i] + 180));
	        }

	        innerPoints.reverse();
	        innerPoints.push(innerPoints[0]);
	        outerPoints.push(outerPoints[0]);

	        return outerPoints.concat(innerPoints);
	    },

	    createGridLines: function(altAxis) {
	        var options = this.options;
	        var majorTicks = this.radarMajorGridLinePositions();
	        var majorAngles = altAxis.majorAngles();
	        var center = altAxis.box.center();
	        var gridLines = [];

	        if (options.majorGridLines.visible) {
	            gridLines = this.renderGridLines(
	                center, majorTicks, majorAngles, options.majorGridLines
	            );
	        }

	        if (options.minorGridLines.visible) {
	            var minorTicks = this.radarMinorGridLinePositions();
	            append(gridLines, this.renderGridLines(
	                center, minorTicks, majorAngles, options.minorGridLines
	            ));
	        }

	        return gridLines;
	    },

	    renderGridLines: function(center, ticks, angles, options) {
	        var style = {
	            stroke: {
	                width: options.width,
	                color: options.color,
	                dashType: options.dashType
	            }
	        };
	        var skip = options.skip; if (skip === void 0) { skip = 0; }
	        var step = options.step; if (step === void 0) { step = 0; }
	        var container = this.gridLinesVisual();

	        for (var tickIx = skip; tickIx < ticks.length; tickIx += step) {
	            var tickRadius = center.y - ticks[tickIx];
	            if (tickRadius > 0) {
	                var circle = new Circle([ center.x, center.y ], tickRadius);
	                if (options.type === ARC) {
	                    container.append(new drawing.Circle(circle, style));
	                } else {
	                    var line = new Path(style);
	                    for (var angleIx = 0; angleIx < angles.length; angleIx++) {
	                        line.lineTo(circle.pointAt(angles[angleIx] + 180));
	                    }

	                    line.close();
	                    container.append(line);
	                }
	            }
	        }

	        return container.children;
	    },

	    getValue: function(point) {
	        var lineBox = this.lineBox();
	        var altAxis = this.plotArea.polarAxis;
	        var majorAngles = altAxis.majorAngles();
	        var center = altAxis.box.center();
	        var radius = point.distanceTo(center);
	        var distance = radius;

	        if (this.options.majorGridLines.type !== ARC && majorAngles.length > 1) {
	            var dx = point.x - center.x;
	            var dy = point.y - center.y;
	            var theta = (deg(Math.atan2(dy, dx)) + 540) % 360;

	            majorAngles.sort(function(a, b) {
	                return angularDistance(a, theta) - angularDistance(b, theta);
	            });

	            // Solve triangle (center, point, axis X) using one side (radius) and two angles.
	            // Angles are derived from triangle (center, point, gridline X)
	            var midAngle = angularDistance(majorAngles[0], majorAngles[1]) / 2;
	            var alpha = angularDistance(theta, majorAngles[0]);
	            var gamma = 90 - midAngle;
	            var beta = 180 - alpha - gamma;

	            distance = radius * (Math.sin(rad(beta)) / Math.sin(rad(gamma)));
	        }

	        return this.axisType().prototype.getValue.call(
	            this, new Point(lineBox.x1, lineBox.y2 - distance)
	        );
	    }
	};

	function angularDistance(a, b) {
	    return 180 - Math.abs(Math.abs(a - b) - 180);
	}

	var RadarNumericAxis = NumericAxis.extend({
	    radarMajorGridLinePositions: function() {
	        return this.getTickPositions(this.options.majorUnit);
	    },

	    radarMinorGridLinePositions: function() {
	        var options = this.options;
	        var minorSkipStep = 0;

	        if (options.majorGridLines.visible) {
	            minorSkipStep = options.majorUnit;
	        }
	        return this.getTickPositions(options.minorUnit, minorSkipStep);
	    },

	    axisType: function() {
	        return NumericAxis;
	    }
	});

	deepExtend(RadarNumericAxis.prototype, RadarNumericAxisMixin);

	var RadarLogarithmicAxis = LogarithmicAxis.extend({
	    radarMajorGridLinePositions: function() {
	        var positions = [];

	        this.traverseMajorTicksPositions(function(position) {
	            positions.push(position);
	        }, this.options.majorGridLines);

	        return positions;
	    },

	    radarMinorGridLinePositions: function() {
	        var positions = [];

	        this.traverseMinorTicksPositions(function(position) {
	            positions.push(position);
	        }, this.options.minorGridLines);

	        return positions;
	    },

	    axisType: function() {
	        return LogarithmicAxis;
	    }
	});

	deepExtend(RadarLogarithmicAxis.prototype, RadarNumericAxisMixin);

	var WEIGHT = 0.333;
	var EXTREMUM_ALLOWED_DEVIATION = 0.01;

	var CurveProcessor = Class.extend({
	    init: function(closed) {

	        this.closed = closed;
	    },

	    process: function(dataPoints) {
	        var this$1 = this;

	        var points = dataPoints.slice(0);
	        var segments = [];
	        var closed = this.closed;
	        var length = points.length;

	        if (length > 2) {
	            this.removeDuplicates(0, points);
	            length = points.length;
	        }

	        if (length < 2 || (length === 2 && points[0].equals(points[1]))) {
	            return segments;
	        }

	        var p0 = points[0];
	        var p1 = points[1];
	        var p2 = points[2];

	        segments.push(new Segment(p0));

	        while (p0.equals(points[length - 1])) {
	            closed = true;
	            points.pop();
	            length--;
	        }

	        if (length === 2) {
	            var tangent = this.tangent(p0,p1, X, Y);

	            last(segments).controlOut(
	                this.firstControlPoint(tangent, p0, p1, X, Y)
	            );

	            segments.push(new Segment(
	                p1,
	                this.secondControlPoint(tangent, p0, p1, X, Y)
	            ));

	            return segments;
	        }

	        var initialControlPoint, lastControlPoint;

	        if (closed) {
	            p0 = points[length - 1]; p1 = points[0]; p2 = points[1];
	            var controlPoints = this.controlPoints(p0, p1, p2);
	            initialControlPoint = controlPoints[1];
	            lastControlPoint = controlPoints[0];
	        } else {
	            var tangent$1 = this.tangent(p0, p1, X,Y);
	            initialControlPoint = this.firstControlPoint(tangent$1, p0, p1, X, Y);
	        }

	        var cp0 = initialControlPoint;
	        for (var idx = 0; idx <= length - 3; idx++) {
	            this$1.removeDuplicates(idx, points);
	            length = points.length;
	            if (idx + 3 <= length) {
	                p0 = points[idx]; p1 = points[idx + 1]; p2 = points[idx + 2];
	                var controlPoints$1 = this$1.controlPoints(p0,p1,p2);

	                last(segments).controlOut(cp0);
	                cp0 = controlPoints$1[1];

	                var cp1 = controlPoints$1[0];
	                segments.push(new Segment(p1, cp1));
	            }
	        }

	        if (closed) {
	            p0 = points[length - 2]; p1 = points[length - 1]; p2 = points[0];
	            var controlPoints$2 = this.controlPoints(p0, p1, p2);

	            last(segments).controlOut(cp0);
	            segments.push(new Segment(
	                p1,
	                controlPoints$2[0]
	            ));

	            last(segments).controlOut(controlPoints$2[1]);
	            segments.push(new Segment(
	                p2,
	                lastControlPoint
	            ));
	        } else {
	            var tangent$2 = this.tangent(p1, p2, X, Y);

	            last(segments).controlOut(cp0);
	            segments.push(new Segment(
	                p2,
	                this.secondControlPoint(tangent$2, p1, p2, X, Y)
	            ));
	        }

	        return segments;
	    },

	    removeDuplicates: function(idx, points) {
	        while (points[idx + 1] && (points[idx].equals(points[idx + 1]) || points[idx + 1].equals(points[idx + 2]))) {
	            points.splice(idx + 1, 1);
	        }
	    },

	    invertAxis: function(p0, p1, p2) {
	        var invertAxis = false;

	        if (p0.x === p1.x) {
	            invertAxis = true;
	        } else if (p1.x === p2.x) {
	            if ((p1.y < p2.y && p0.y <= p1.y) || (p2.y < p1.y && p1.y <= p0.y)) {
	                invertAxis = true;
	            }
	        } else {
	            var fn = this.lineFunction(p0,p1);
	            var y2 = this.calculateFunction(fn, p2.x);
	            if (!(p0.y <= p1.y && p2.y <= y2) &&
	                !(p1.y <= p0.y && p2.y >= y2)) {
	                invertAxis = true;
	            }
	        }

	        return invertAxis;
	    },

	    isLine: function(p0, p1, p2) {
	        var fn = this.lineFunction(p0, p1);
	        var y2 = this.calculateFunction(fn, p2.x);

	        return (p0.x === p1.x && p1.x === p2.x) || round(y2, 1) === round(p2.y, 1);
	    },

	    lineFunction: function(p1, p2) {
	        var a = (p2.y - p1.y) / (p2.x - p1.x);
	        var b = p1.y - a * p1.x;

	        return [ b, a ];
	    },

	    controlPoints: function(p0, p1, p2) {
	        var xField = X;
	        var yField = Y;
	        var restrict = false;
	        var switchOrientation = false;
	        var tangent;

	        if (this.isLine(p0, p1, p2)) {
	            tangent = this.tangent(p0, p1, X, Y);
	        } else {
	            var monotonic = {
	                x: this.isMonotonicByField(p0, p1, p2, X),
	                y: this.isMonotonicByField(p0, p1, p2, Y)
	            };

	            if (monotonic.x && monotonic.y) {
	                tangent = this.tangent(p0, p2, X, Y);
	                restrict = true;
	            } else {
	                if (this.invertAxis(p0, p1, p2)) {
	                    xField = Y;
	                    yField = X;
	                }

	                if (monotonic[xField]) {
	                    tangent = 0;
	                } else {
	                    var sign;
	                    if ((p2[yField] < p0[yField] && p0[yField] <= p1[yField]) ||
	                        (p0[yField] < p2[yField] && p1[yField] <= p0[yField])) {
	                        sign = numberSign((p2[yField] - p0[yField]) * (p1[xField] - p0[xField]));
	                    } else {
	                        sign = -numberSign((p2[xField] - p0[xField]) * (p1[yField] - p0[yField]));
	                    }

	                    tangent = EXTREMUM_ALLOWED_DEVIATION * sign;
	                    switchOrientation = true;
	                }
	            }
	        }

	        var secondControlPoint = this.secondControlPoint(tangent, p0, p1, xField, yField);

	        if (switchOrientation) {
	            var oldXField = xField;
	            xField = yField;
	            yField = oldXField;
	        }

	        var firstControlPoint = this.firstControlPoint(tangent, p1, p2, xField, yField);

	        if (restrict) {
	            this.restrictControlPoint(p0, p1, secondControlPoint, tangent);
	            this.restrictControlPoint(p1, p2, firstControlPoint, tangent);
	        }

	        return [ secondControlPoint, firstControlPoint ];
	    },

	    restrictControlPoint: function(p1, p2, cp, tangent) {
	        if (p1.y < p2.y) {
	            if (p2.y < cp.y) {
	                cp.x = p1.x + (p2.y - p1.y) / tangent;
	                cp.y = p2.y;
	            } else if (cp.y < p1.y) {
	                cp.x = p2.x - (p2.y - p1.y) / tangent;
	                cp.y = p1.y;
	            }
	        } else {
	            if (cp.y < p2.y) {
	                cp.x = p1.x - (p1.y - p2.y) / tangent;
	                cp.y = p2.y;
	            } else if (p1.y < cp.y) {
	                cp.x = p2.x + (p1.y - p2.y) / tangent;
	                cp.y = p1.y;
	            }
	        }
	    },

	    tangent: function(p0, p1, xField, yField) {
	        var x = p1[xField] - p0[xField];
	        var y = p1[yField] - p0[yField];
	        var tangent;

	        if (x === 0) {
	            tangent = 0;
	        } else {
	            tangent = y / x;
	        }

	        return tangent;
	    },

	    isMonotonicByField: function(p0, p1, p2, field) {
	        return (p2[field] > p1[field] && p1[field] > p0[field]) ||
	                    (p2[field] < p1[field] && p1[field] < p0[field]);
	    },

	    firstControlPoint: function(tangent, p0, p3, xField, yField) {
	        var t1 = p0[xField];
	        var t2 = p3[xField];
	        var distance = (t2 - t1) * WEIGHT;

	        return this.point(t1 + distance, p0[yField] + distance * tangent, xField, yField);
	    },

	    secondControlPoint: function(tangent, p0, p3, xField, yField) {
	        var t1 = p0[xField];
	        var t2 = p3[xField];
	        var distance = (t2 - t1) * WEIGHT;

	        return this.point(t2 - distance, p3[yField] - distance * tangent, xField, yField);
	    },

	    point: function(xValue, yValue, xField, yField) {
	        var controlPoint = new geometry.Point();
	        controlPoint[xField] = xValue;
	        controlPoint[yField] = yValue;

	        return controlPoint;
	    },

	    calculateFunction: function(fn, x) {
	        var length = fn.length;
	        var result = 0;

	        for (var i = 0; i < length; i++) {
	            result += Math.pow(x,i) * fn[i];
	        }
	        return result;
	    }
	});

	function numberSign(value) {
	    return value <= 0 ? -1 : 1;
	}

	dataviz.Gradients = GRADIENTS;

	kendo.deepExtend(kendo.dataviz, {
	    constants: constants,
	    services: services,
	    autoMajorUnit: autoMajorUnit,
	    Point: Point,
	    Box: Box,
	    Ring: Ring,
	    Sector: Sector,
	    ShapeBuilder: ShapeBuilder,
	    ShapeElement: ShapeElement,
	    ChartElement: ChartElement,
	    BoxElement: BoxElement,
	    RootElement: RootElement,
	    FloatElement: FloatElement,
	    Text: Text,
	    TextBox: TextBox,
	    Title: Title,
	    AxisLabel: AxisLabel,
	    Axis: Axis,
	    Note: Note,
	    CategoryAxis: CategoryAxis,
	    DateCategoryAxis: DateCategoryAxis,
	    DateValueAxis: DateValueAxis,
	    NumericAxis: NumericAxis,
	    LogarithmicAxis: LogarithmicAxis,
	    PolarAxis: PolarAxis,
	    RadarCategoryAxis: RadarCategoryAxis,
	    RadarNumericAxis: RadarNumericAxis,
	    RadarLogarithmicAxis: RadarLogarithmicAxis,
	    CurveProcessor: CurveProcessor,
	    rectToBox: rectToBox,
	    addClass: addClass,
	    removeClass: removeClass,
	    alignPathToPixel: alignPathToPixel,
	    clockwise: clockwise,
	    convertableToNumber: convertableToNumber,
	    deepExtend: deepExtend,
	    elementStyles: elementStyles,
	    getSpacing: getSpacing,
	    getTemplate: getTemplate,
	    getter: __common_getter_js,
	    grep: grep,
	    hasClasses: hasClasses,
	    HashMap: HashMap,
	    inArray: inArray,
	    interpolateValue: interpolateValue,
	    InstanceObserver: InstanceObserver,
	    isArray: isArray,
	    isFunction: isFunction,
	    isNumber: isNumber,
	    isObject: isObject,
	    isString: isString,
	    map: map,
	    mousewheelDelta: mousewheelDelta,
	    FontLoader: FontLoader,
	    setDefaultOptions: setDefaultOptions,
	    sparseArrayLimits: sparseArrayLimits,
	    styleValue: styleValue,
	    find: find,
	    elementScale: elementScale,
	    append: append,
	    bindEvents: bindEvents,
	    Class: Class,
	    defined: defined,
	    deg: deg,
	    elementOffset: elementOffset,
	    elementSize: elementSize,
	    eventElement: eventElement,
	    eventCoordinates: eventCoordinates,
	    last: last,
	    limitValue: limitValue,
	    logToConsole: kendo.logToConsole,
	    objectKey: objectKey,
	    rad: rad,
	    round: round,
	    unbindEvents: unbindEvents,
	    valueOrDefault: valueOrDefault,
	    absoluteDateDiff: absoluteDateDiff,
	    addDuration: addDuration,
	    addTicks: addTicks,
	    ceilDate: ceilDate,
	    dateComparer: dateComparer,
	    dateDiff: dateDiff,
	    dateEquals: dateEquals,
	    dateIndex: dateIndex,
	    duration: duration,
	    floorDate: floorDate,
	    lteDateIndex: lteDateIndex,
	    startOfWeek: startOfWeek,
	    toDate: toDate,
	    parseDate: parseDate,
	    parseDates: parseDates,
	    toTime: toTime,
	    firstDay: firstDay
	});

	})(window.kendo.jQuery);

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "sB3e":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("52gC");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "sHqg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var columnController_1 = __webpack_require__("77lH");
var gridPanel_1 = __webpack_require__("inOk");
var eventService_1 = __webpack_require__("k5uU");
var logger_1 = __webpack_require__("U9Xd");
var events_1 = __webpack_require__("3ok8");
var context_1 = __webpack_require__("RQ1/");
var context_2 = __webpack_require__("RQ1/");
var context_3 = __webpack_require__("RQ1/");
var context_4 = __webpack_require__("RQ1/");
var counter = 0;
var AlignedGridsService = (function () {
    function AlignedGridsService() {
        this.instanceId = counter++;
        // flag to mark if we are consuming. to avoid cyclic events (ie other grid firing back to master
        // while processing a master event) we mark this if consuming an event, and if we are, then
        // we don't fire back any events.
        this.consuming = false;
    }
    AlignedGridsService.prototype.setBeans = function (loggerFactory) {
        this.logger = loggerFactory.create('AlignedGridsService');
    };
    AlignedGridsService.prototype.init = function () {
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_MOVED, this.fireColumnEvent.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_VISIBLE, this.fireColumnEvent.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_PINNED, this.fireColumnEvent.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_GROUP_OPENED, this.fireColumnEvent.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_RESIZED, this.fireColumnEvent.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_BODY_SCROLL, this.fireScrollEvent.bind(this));
    };
    // common logic across all the fire methods
    AlignedGridsService.prototype.fireEvent = function (callback) {
        // if we are already consuming, then we are acting on an event from a master,
        // so we don't cause a cyclic firing of events
        if (this.consuming) {
            return;
        }
        // iterate through the aligned grids, and pass each aligned grid service to the callback
        var otherGrids = this.gridOptionsWrapper.getAlignedGrids();
        if (otherGrids) {
            otherGrids.forEach(function (otherGridOptions) {
                if (otherGridOptions.api) {
                    var alignedGridService = otherGridOptions.api.__getAlignedGridService();
                    callback(alignedGridService);
                }
            });
        }
    };
    // common logic across all consume methods. very little common logic, however extracting
    // guarantees consistency across the methods.
    AlignedGridsService.prototype.onEvent = function (callback) {
        this.consuming = true;
        callback();
        this.consuming = false;
    };
    AlignedGridsService.prototype.fireColumnEvent = function (event) {
        this.fireEvent(function (alignedGridsService) {
            alignedGridsService.onColumnEvent(event);
        });
    };
    AlignedGridsService.prototype.fireScrollEvent = function (event) {
        if (event.direction !== 'horizontal') {
            return;
        }
        this.fireEvent(function (alignedGridsService) {
            alignedGridsService.onScrollEvent(event);
        });
    };
    AlignedGridsService.prototype.onScrollEvent = function (event) {
        var _this = this;
        this.onEvent(function () {
            _this.gridPanel.setHorizontalScrollPosition(event.left);
        });
    };
    AlignedGridsService.prototype.getMasterColumns = function (event) {
        var result = [];
        if (event.columns) {
            event.columns.forEach(function (column) {
                result.push(column);
            });
        }
        else if (event.column) {
            result.push(event.column);
        }
        return result;
    };
    AlignedGridsService.prototype.getColumnIds = function (event) {
        var result = [];
        if (event.columns) {
            event.columns.forEach(function (column) {
                result.push(column.getColId());
            });
        }
        else if (event.columns) {
            result.push(event.column.getColId());
        }
        return result;
    };
    AlignedGridsService.prototype.onColumnEvent = function (event) {
        var _this = this;
        this.onEvent(function () {
            switch (event.type) {
                case events_1.Events.EVENT_COLUMN_MOVED:
                case events_1.Events.EVENT_COLUMN_VISIBLE:
                case events_1.Events.EVENT_COLUMN_PINNED:
                case events_1.Events.EVENT_COLUMN_RESIZED:
                    var colEvent = event;
                    _this.processColumnEvent(colEvent);
                    break;
                case events_1.Events.EVENT_COLUMN_GROUP_OPENED:
                    var groupOpenedEvent = event;
                    _this.processGroupOpenedEvent(groupOpenedEvent);
                    break;
                case events_1.Events.EVENT_COLUMN_PIVOT_CHANGED:
                    // we cannot support pivoting with aligned grids as the columns will be out of sync as the
                    // grids will have columns created based on the row data of the grid.
                    console.warn('ag-Grid: pivoting is not supported with aligned grids. ' +
                        'You can only use one of these features at a time in a grid.');
                    break;
            }
        });
    };
    AlignedGridsService.prototype.processGroupOpenedEvent = function (groupOpenedEvent) {
        // likewise for column group
        var masterColumnGroup = groupOpenedEvent.columnGroup;
        var otherColumnGroup;
        if (masterColumnGroup) {
            var groupId = masterColumnGroup.getGroupId();
            otherColumnGroup = this.columnController.getOriginalColumnGroup(groupId);
        }
        if (masterColumnGroup && !otherColumnGroup) {
            return;
        }
        this.logger.log('onColumnEvent-> processing ' + event + ' expanded = ' + masterColumnGroup.isExpanded());
        this.columnController.setColumnGroupOpened(otherColumnGroup, masterColumnGroup.isExpanded(), "alignedGridChanged");
    };
    AlignedGridsService.prototype.processColumnEvent = function (colEvent) {
        var _this = this;
        // the column in the event is from the master grid. need to
        // look up the equivalent from this (other) grid
        var masterColumn = colEvent.column;
        var otherColumn;
        if (masterColumn) {
            otherColumn = this.columnController.getPrimaryColumn(masterColumn.getColId());
        }
        // if event was with respect to a master column, that is not present in this
        // grid, then we ignore the event
        if (masterColumn && !otherColumn) {
            return;
        }
        // in time, all the methods below should use the column ids, it's a more generic way
        // of handling columns, and also allows for single or multi column events
        var columnIds = this.getColumnIds(colEvent);
        var masterColumns = this.getMasterColumns(colEvent);
        switch (colEvent.type) {
            case events_1.Events.EVENT_COLUMN_MOVED:
                var movedEvent = colEvent;
                this.logger.log('onColumnEvent-> processing ' + colEvent.type + ' toIndex = ' + movedEvent.toIndex);
                this.columnController.moveColumns(columnIds, movedEvent.toIndex, "alignedGridChanged");
                break;
            case events_1.Events.EVENT_COLUMN_VISIBLE:
                var visibleEvent = colEvent;
                this.logger.log('onColumnEvent-> processing ' + colEvent.type + ' visible = ' + visibleEvent.visible);
                this.columnController.setColumnsVisible(columnIds, visibleEvent.visible, "alignedGridChanged");
                break;
            case events_1.Events.EVENT_COLUMN_PINNED:
                var pinnedEvent = colEvent;
                this.logger.log('onColumnEvent-> processing ' + colEvent.type + ' pinned = ' + pinnedEvent.pinned);
                this.columnController.setColumnsPinned(columnIds, pinnedEvent.pinned, "alignedGridChanged");
                break;
            case events_1.Events.EVENT_COLUMN_RESIZED:
                var resizedEvent_1 = colEvent;
                masterColumns.forEach(function (masterColumn) {
                    _this.logger.log('onColumnEvent-> processing ' + colEvent.type + ' actualWidth = ' + masterColumn.getActualWidth());
                    _this.columnController.setColumnWidth(masterColumn.getColId(), masterColumn.getActualWidth(), resizedEvent_1.finished, "alignedGridChanged");
                });
                break;
        }
    };
    __decorate([
        context_3.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], AlignedGridsService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_3.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], AlignedGridsService.prototype, "columnController", void 0);
    __decorate([
        context_3.Autowired('gridPanel'),
        __metadata("design:type", gridPanel_1.GridPanel)
    ], AlignedGridsService.prototype, "gridPanel", void 0);
    __decorate([
        context_3.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], AlignedGridsService.prototype, "eventService", void 0);
    __decorate([
        __param(0, context_2.Qualifier('loggerFactory')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
        __metadata("design:returntype", void 0)
    ], AlignedGridsService.prototype, "setBeans", null);
    __decorate([
        context_4.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AlignedGridsService.prototype, "init", null);
    AlignedGridsService = __decorate([
        context_1.Bean('alignedGridsService')
    ], AlignedGridsService);
    return AlignedGridsService;
}());
exports.AlignedGridsService = AlignedGridsService;


/***/ }),

/***/ "sM3J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponentWrapper = (function () {
    function BaseComponentWrapper() {
    }
    BaseComponentWrapper.prototype.wrap = function (OriginalConstructor, mandatoryMethodList, optionalMethodList, componentName) {
        var _this = this;
        var wrapper = this.createWrapper(OriginalConstructor, componentName);
        mandatoryMethodList.forEach((function (methodName) {
            _this.createMethod(wrapper, methodName, true);
        }));
        if (optionalMethodList) {
            optionalMethodList.forEach((function (methodName) {
                _this.createMethod(wrapper, methodName, false);
            }));
        }
        return wrapper;
    };
    BaseComponentWrapper.prototype.createMethod = function (wrapper, methodName, mandatory) {
        wrapper.addMethod(methodName, this.createMethodProxy(wrapper, methodName, mandatory));
    };
    BaseComponentWrapper.prototype.createMethodProxy = function (wrapper, methodName, mandatory) {
        return function () {
            if (wrapper.hasMethod(methodName)) {
                return wrapper.callMethod(methodName, arguments);
            }
            if (mandatory) {
                console.warn('ag-Grid: Framework component is missing the method ' + methodName + '()');
            }
            return null;
        };
    };
    return BaseComponentWrapper;
}());
exports.BaseComponentWrapper = BaseComponentWrapper;


/***/ }),

/***/ "sUu7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export install */
/* unused harmony export use */
/* unused harmony export directive */
/* unused harmony export mixin */
/* unused harmony export mapFields */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Validator; });
/* unused harmony export ErrorBag */
/* unused harmony export Rules */
/* unused harmony export version */
/**
  * vee-validate v2.0.3
  * (c) 2018 Abdelrahman Awad
  * @license MIT
  */
// 

/**
 * Gets the data attribute. the name must be kebab-case.
 */
var getDataAttribute = function (el, name) { return el.getAttribute(("data-vv-" + name)); };

/**
 * Checks if the value is either null or undefined.
 */
var isNullOrUndefined = function (value) {
  return value === null || value === undefined;
};

/**
 * Sets the data attribute.
 */
var setDataAttribute = function (el, name, value) { return el.setAttribute(("data-vv-" + name), value); };

/**
 * Creates the default flags object.
 */
var createFlags = function () { return ({
  untouched: true,
  touched: false,
  dirty: false,
  pristine: true,
  valid: null,
  invalid: null,
  validated: false,
  pending: false,
  required: false
}); };

/**
 * Shallow object comparison.
 */
var isEqual = function (lhs, rhs) {
  if (lhs instanceof RegExp && rhs instanceof RegExp) {
    return isEqual(lhs.source, rhs.source) && isEqual(lhs.flags, rhs.flags);
  }

  if (Array.isArray(lhs) && Array.isArray(rhs)) {
    if (lhs.length !== rhs.length) { return false; }

    for (var i = 0; i < lhs.length; i++) {
      if (!isEqual(lhs[i], rhs[i])) {
        return false;
      }
    }

    return true;
  }

  // if both are objects, compare each key recursively.
  if (isObject(lhs) && isObject(rhs)) {
    return Object.keys(lhs).every(function (key) {
      return isEqual(lhs[key], rhs[key]);
    }) && Object.keys(rhs).every(function (key) {
      return isEqual(lhs[key], rhs[key]);
    });
  }

  return lhs === rhs;
};

/**
 * Determines the input field scope.
 */
var getScope = function (el) {
  var scope = getDataAttribute(el, 'scope');
  if (isNullOrUndefined(scope) && el.form) {
    scope = getDataAttribute(el.form, 'scope');
  }

  return !isNullOrUndefined(scope) ? scope : null;
};

/**
 * Gets the value in an object safely.
 */
var getPath = function (path, target, def) {
  if ( def === void 0 ) def = undefined;

  if (!path || !target) { return def; }

  var value = target;
  path.split('.').every(function (prop) {
    if (! Object.prototype.hasOwnProperty.call(value, prop) && value[prop] === undefined) {
      value = def;

      return false;
    }

    value = value[prop];

    return true;
  });

  return value;
};

/**
 * Checks if path exists within an object.
 */
var hasPath = function (path, target) {
  var obj = target;
  return path.split('.').every(function (prop) {
    if (! Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }

    obj = obj[prop];

    return true;
  });
};

/**
 * Parses a rule string expression.
 */
var parseRule = function (rule) {
  var params = [];
  var name = rule.split(':')[0];

  if (~rule.indexOf(':')) {
    params = rule.split(':').slice(1).join(':').split(',');
  }

  return { name: name, params: params };
};

/**
 * Debounces a function.
 */
var debounce = function (fn, wait, immediate) {
  if ( wait === void 0 ) wait = 0;
  if ( immediate === void 0 ) immediate = false;

  if (wait === 0) {
    return fn;
  }

  var timeout;

  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var later = function () {
      timeout = null;
      if (!immediate) { fn.apply(void 0, args); }
    };
    /* istanbul ignore next */
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    /* istanbul ignore next */
    if (callNow) { fn.apply(void 0, args); }
  };
};

/**
 * Normalizes the given rules expression.
 */
var normalizeRules = function (rules) {
  // if falsy value return an empty object.
  if (!rules) {
    return {};
  }

  if (isObject(rules)) {
    // $FlowFixMe
    return Object.keys(rules).reduce(function (prev, curr) {
      var params = [];
      // $FlowFixMe
      if (rules[curr] === true) {
        params = [];
      } else if (Array.isArray(rules[curr])) {
        params = rules[curr];
      } else {
        params = [rules[curr]];
      }

      // $FlowFixMe
      if (rules[curr] !== false) {
        prev[curr] = params;
      }

      return prev;
    }, {});
  }

  if (typeof rules !== 'string') {
    warn('rules must be either a string or an object.');
    return {};
  }

  return rules.split('|').reduce(function (prev, rule) {
    var parsedRule = parseRule(rule);
    if (!parsedRule.name) {
      return prev;
    }

    prev[parsedRule.name] = parsedRule.params;
    return prev;
  }, {});
};

/**
 * Emits a warning to the console.
 */
var warn = function (message) {
  console.warn(("[vee-validate] " + message)); // eslint-disable-line
};

/**
 * Creates a branded error object.
 */
var createError = function (message) { return new Error(("[vee-validate] " + message)); };

/**
 * Checks if the value is an object.
 */
var isObject = function (obj) { return obj !== null && obj && typeof obj === 'object' && ! Array.isArray(obj); };

/**
 * Checks if a function is callable.
 */
var isCallable = function (func) { return typeof func === 'function'; };

/**
 * Check if element has the css class on it.
 */
var hasClass = function (el, className) {
  if (el.classList) {
    return el.classList.contains(className);
  }

  return !!el.className.match(new RegExp(("(\\s|^)" + className + "(\\s|$)")));
};

/**
 * Adds the provided css className to the element.
 */
var addClass = function (el, className) {
  if (el.classList) {
    el.classList.add(className);
    return;
  }

  if (!hasClass(el, className)) {
    el.className += " " + className;
  }
};

/**
 * Remove the provided css className from the element.
 */
var removeClass = function (el, className) {
  if (el.classList) {
    el.classList.remove(className);
    return;
  }

  if (hasClass(el, className)) {
    var reg = new RegExp(("(\\s|^)" + className + "(\\s|$)"));
    el.className = el.className.replace(reg, ' ');
  }
};

/**
 * Adds or removes a class name on the input depending on the status flag.
 */
var toggleClass = function (el, className, status) {
  if (!el || !className) { return; }

  if (status) {
    return addClass(el, className);
  }

  removeClass(el, className);
};

/**
 * Converts an array-like object to array, provides a simple polyfill for Array.from
 */
var toArray = function (arrayLike) {
  if (isCallable(Array.from)) {
    return Array.from(arrayLike);
  }

  var array = [];
  var length = arrayLike.length;
  for (var i = 0; i < length; i++) {
    array.push(arrayLike[i]);
  }

  return array;
};

/**
 * Assign polyfill from the mdn.
 */
var assign = function (target) {
  var others = [], len = arguments.length - 1;
  while ( len-- > 0 ) others[ len ] = arguments[ len + 1 ];

  /* istanbul ignore else */
  if (isCallable(Object.assign)) {
    return Object.assign.apply(Object, [ target ].concat( others ));
  }

  /* istanbul ignore next */
  if (target == null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  /* istanbul ignore next */
  var to = Object(target);
  /* istanbul ignore next */
  others.forEach(function (arg) {
    // Skip over if undefined or null
    if (arg != null) {
      Object.keys(arg).forEach(function (key) {
        to[key] = arg[key];
      });
    }
  });
  /* istanbul ignore next */
  return to;
};

var id = 0;
var idTemplate = '{id}';

/**
 * Generates a unique id.
 */
var uniqId = function () {
  // handle too many uses of uniqId, although unlikely.
  if (id >= 9999) {
    id = 0;
    // shift the template.
    idTemplate = idTemplate.replace('{id}', '_{id}');
  }

  id++;
  var newId = idTemplate.replace('{id}', String(id));

  return newId;
};

/**
 * finds the first element that satisfies the predicate callback, polyfills array.find
 */
var find = function (arrayLike, predicate) {
  var array = Array.isArray(arrayLike) ? arrayLike : toArray(arrayLike);
  for (var i = 0; i < array.length; i++) {
    if (predicate(array[i])) {
      return array[i];
    }
  }

  return undefined;
};

/**
 * Returns a suitable event name for the input element.
 */
var getInputEventName = function (el) {
  if (el && (el.tagName === 'SELECT' || ~['radio', 'checkbox', 'file'].indexOf(el.type))) {
    return 'change';
  }

  return 'input';
};

var isBuiltInComponent = function (vnode) {
  if (!vnode) {
    return false;
  }

  var tag = vnode.componentOptions.tag;

  return /keep-alive|transition|transition-group/.test(tag);
};

var makeEventsArray = function (events) {
  return (typeof events === 'string' && events.length) ? events.split('|') : [];
};

var makeDelayObject = function (events, delay, delayConfig) {
  if (typeof delay === 'number') {
    return events.reduce(function (prev, e) {
      prev[e] = delay;
      return prev;
    }, {});
  }

  return events.reduce(function (prev, e) {
    if (typeof delay === 'object' && e in delay) {
      prev[e] = delay[e];
      return prev;
    }

    if (typeof delayConfig === 'number') {
      prev[e] = delayConfig;
      return prev;
    }

    prev[e] = (delayConfig && delayConfig[e]) || 0;

    return prev;
  }, {});
};

var deepParseInt = function (input) {
  if (typeof input === 'number') { return input; }

  if (typeof input === 'string') { return parseInt(input); }

  var map = {};
  for (var element in input) {
    map[element] = parseInt(input[element]);
  }

  return map;
};

var merge = function (target, source) {
  if (! (isObject(target) && isObject(source))) {
    return target;
  }

  Object.keys(source).forEach(function (key) {
    if (isObject(source[key])) {
      if (! target[key]) {
        assign(target, ( obj = {}, obj[key] = {}, obj ));
        var obj;
      }

      merge(target[key], source[key]);
      return;
    }

    assign(target, ( obj$1 = {}, obj$1[key] = source[key], obj$1 ));
    var obj$1;
  });

  return target;
};

// 

var ErrorBag = function ErrorBag () {
  this.items = [];
};

/**
 * Adds an error to the internal array.
 */
ErrorBag.prototype.add = function add (error) {
  // handle old signature.
  if (arguments.length > 1) {
    error = {
      field: arguments[0],
      msg: arguments[1],
      rule: arguments[2],
      scope: !isNullOrUndefined(arguments[3]) ? arguments[3] : null,
      regenerate: null
    };
  }

  error.scope = !isNullOrUndefined(error.scope) ? error.scope : null;
  this.items.push(error);
};

/**
 * Regenrates error messages if they have a generator function.
 */
ErrorBag.prototype.regenerate = function regenerate () {
  this.items.forEach(function (i) {
    i.msg = isCallable(i.regenerate) ? i.regenerate() : i.msg;
  });
};

/**
 * Updates a field error with the new field scope.
 */
ErrorBag.prototype.update = function update (id, error) {
  var item = find(this.items, function (i) { return i.id === id; });
  if (!item) {
    return;
  }

  var idx = this.items.indexOf(item);
  this.items.splice(idx, 1);
  item.scope = error.scope;
  this.items.push(item);
};

/**
 * Gets all error messages from the internal array.
 */
ErrorBag.prototype.all = function all (scope) {
  if (isNullOrUndefined(scope)) {
    return this.items.map(function (e) { return e.msg; });
  }

  return this.items.filter(function (e) { return e.scope === scope; }).map(function (e) { return e.msg; });
};

/**
 * Checks if there are any errors in the internal array.
 */
ErrorBag.prototype.any = function any (scope) {
  if (isNullOrUndefined(scope)) {
    return !!this.items.length;
  }

  return !!this.items.filter(function (e) { return e.scope === scope; }).length;
};

/**
 * Removes all items from the internal array.
 */
ErrorBag.prototype.clear = function clear (scope) {
    var this$1 = this;

  if (isNullOrUndefined(scope)) {
    scope = null;
  }

  for (var i = 0; i < this.items.length; ++i) {
    if (this$1.items[i].scope === scope) {
      this$1.items.splice(i, 1);
      --i;
    }
  }
};

/**
 * Collects errors into groups or for a specific field.
 */
ErrorBag.prototype.collect = function collect (field, scope, map) {
    if ( map === void 0 ) map = true;

  if (!field) {
    var collection = {};
    this.items.forEach(function (e) {
      if (! collection[e.field]) {
        collection[e.field] = [];
      }

      collection[e.field].push(map ? e.msg : e);
    });

    return collection;
  }

  field = !isNullOrUndefined(field) ? String(field) : field;
  if (isNullOrUndefined(scope)) {
    return this.items.filter(function (e) { return e.field === field; }).map(function (e) { return (map ? e.msg : e); });
  }

  return this.items.filter(function (e) { return e.field === field && e.scope === scope; })
    .map(function (e) { return (map ? e.msg : e); });
};
/**
 * Gets the internal array length.
 */
ErrorBag.prototype.count = function count () {
  return this.items.length;
};

/**
 * Finds and fetches the first error message for the specified field id.
 */
ErrorBag.prototype.firstById = function firstById (id) {
  var error = find(this.items, function (i) { return i.id === id; });

  return error ? error.msg : null;
};

/**
 * Gets the first error message for a specific field.
 */
ErrorBag.prototype.first = function first (field, scope) {
    var this$1 = this;
    if ( scope === void 0 ) scope = null;

  field = !isNullOrUndefined(field) ? String(field) : field;
  var selector = this._selector(field);
  var scoped = this._scope(field);

  if (scoped) {
    var result = this.first(scoped.name, scoped.scope);
    // if such result exist, return it. otherwise it could be a field.
    // with dot in its name.
    if (result) {
      return result;
    }
  }

  if (selector) {
    return this.firstByRule(selector.name, selector.rule, scope);
  }

  for (var i = 0; i < this.items.length; ++i) {
    if (this$1.items[i].field === field && (this$1.items[i].scope === scope)) {
      return this$1.items[i].msg;
    }
  }

  return null;
};

/**
 * Returns the first error rule for the specified field
 */
ErrorBag.prototype.firstRule = function firstRule (field, scope) {
  var errors = this.collect(field, scope, false);

  return (errors.length && errors[0].rule) || null;
};

/**
 * Checks if the internal array has at least one error for the specified field.
 */
ErrorBag.prototype.has = function has (field, scope) {
    if ( scope === void 0 ) scope = null;

  return !!this.first(field, scope);
};

/**
 * Gets the first error message for a specific field and a rule.
 */
ErrorBag.prototype.firstByRule = function firstByRule (name, rule, scope) {
    if ( scope === void 0 ) scope = null;

  var error = this.collect(name, scope, false).filter(function (e) { return e.rule === rule; })[0];

  return (error && error.msg) || null;
};

/**
 * Gets the first error message for a specific field that not match the rule.
 */
ErrorBag.prototype.firstNot = function firstNot (name, rule, scope) {
    if ( rule === void 0 ) rule = 'required';
    if ( scope === void 0 ) scope = null;

  var error = this.collect(name, scope, false).filter(function (e) { return e.rule !== rule; })[0];

  return (error && error.msg) || null;
};

/**
 * Removes errors by matching against the id.
 */
ErrorBag.prototype.removeById = function removeById (id) {
    var this$1 = this;

  for (var i = 0; i < this.items.length; ++i) {
    if (this$1.items[i].id === id) {
      this$1.items.splice(i, 1);
      --i;
    }
  }
};

/**
 * Removes all error messages associated with a specific field.
 */
ErrorBag.prototype.remove = function remove (field, scope, id) {
    var this$1 = this;

  field = !isNullOrUndefined(field) ? String(field) : field;
  var removeCondition = function (e) {
    if (e.id && id) {
      return e.id === id;
    }

    if (!isNullOrUndefined(scope)) {
      return e.field === field && e.scope === scope;
    }

    return e.field === field && e.scope === null;
  };

  for (var i = 0; i < this.items.length; ++i) {
    if (removeCondition(this$1.items[i])) {
      this$1.items.splice(i, 1);
      --i;
    }
  }
};

/**
 * Get the field attributes if there's a rule selector.
 */
ErrorBag.prototype._selector = function _selector (field) {
  if (field.indexOf(':') > -1) {
    var ref = field.split(':');
      var name = ref[0];
      var rule = ref[1];

    return { name: name, rule: rule };
  }

  return null;
};

/**
 * Get the field scope if specified using dot notation.
 */
ErrorBag.prototype._scope = function _scope (field) {
  if (field.indexOf('.') > -1) {
    var ref = field.split('.');
      var scope = ref[0];
      var name = ref.slice(1);

    return { name: name.join('.'), scope: scope };
  }

  return null;
};

// 

var LOCALE = 'en';

var Dictionary = function Dictionary (dictionary) {
  if ( dictionary === void 0 ) dictionary = {};

  this.container = {};
  this.merge(dictionary);
};

var prototypeAccessors$2 = { locale: {} };

prototypeAccessors$2.locale.get = function () {
  return LOCALE;
};

prototypeAccessors$2.locale.set = function (value) {
  LOCALE = value || 'en';
};

Dictionary.prototype.hasLocale = function hasLocale (locale) {
  return !!this.container[locale];
};

Dictionary.prototype.setDateFormat = function setDateFormat (locale, format) {
  if (!this.container[locale]) {
    this.container[locale] = {};
  }

  this.container[locale].dateFormat = format;
};

Dictionary.prototype.getDateFormat = function getDateFormat (locale) {
  if (!this.container[locale] || !this.container[locale].dateFormat) {
    return null;
  }

  return this.container[locale].dateFormat;
};

Dictionary.prototype.getMessage = function getMessage (locale, key, data) {
  var message = null;
  if (!this.hasMessage(locale, key)) {
    message = this._getDefaultMessage(locale);
  } else {
    message = this.container[locale].messages[key];
  }

  return isCallable(message) ? message.apply(void 0, data) : message;
};

/**
 * Gets a specific message for field. falls back to the rule message.
 */
Dictionary.prototype.getFieldMessage = function getFieldMessage (locale, field, key, data) {
  if (!this.hasLocale(locale)) {
    return this.getMessage(locale, key, data);
  }

  var dict = this.container[locale].custom && this.container[locale].custom[field];
  if (!dict || !dict[key]) {
    return this.getMessage(locale, key, data);
  }

  var message = dict[key];
  return isCallable(message) ? message.apply(void 0, data) : message;
};

Dictionary.prototype._getDefaultMessage = function _getDefaultMessage (locale) {
  if (this.hasMessage(locale, '_default')) {
    return this.container[locale].messages._default;
  }

  return this.container.en.messages._default;
};

Dictionary.prototype.getAttribute = function getAttribute (locale, key, fallback) {
    if ( fallback === void 0 ) fallback = '';

  if (!this.hasAttribute(locale, key)) {
    return fallback;
  }

  return this.container[locale].attributes[key];
};

Dictionary.prototype.hasMessage = function hasMessage (locale, key) {
  return !! (
    this.hasLocale(locale) &&
          this.container[locale].messages &&
          this.container[locale].messages[key]
  );
};

Dictionary.prototype.hasAttribute = function hasAttribute (locale, key) {
  return !! (
    this.hasLocale(locale) &&
          this.container[locale].attributes &&
          this.container[locale].attributes[key]
  );
};

Dictionary.prototype.merge = function merge$1 (dictionary) {
  merge(this.container, dictionary);
};

Dictionary.prototype.setMessage = function setMessage (locale, key, message) {
  if (! this.hasLocale(locale)) {
    this.container[locale] = {
      messages: {},
      attributes: {}
    };
  }

  this.container[locale].messages[key] = message;
};

Dictionary.prototype.setAttribute = function setAttribute (locale, key, attribute) {
  if (! this.hasLocale(locale)) {
    this.container[locale] = {
      messages: {},
      attributes: {}
    };
  }

  this.container[locale].attributes[key] = attribute;
};

Object.defineProperties( Dictionary.prototype, prototypeAccessors$2 );

// 

var normalizeValue = function (value) {
  if (isObject(value)) {
    return Object.keys(value).reduce(function (prev, key) {
      prev[key] = normalizeValue(value[key]);

      return prev;
    }, {});
  }

  if (isCallable(value)) {
    return value('{0}', ['{1}', '{2}', '{3}']);
  }

  return value;
};

var normalizeFormat = function (locale) {
  // normalize messages
  var messages = normalizeValue(locale.messages);
  var custom = normalizeValue(locale.custom);

  return {
    messages: messages,
    custom: custom,
    attributes: locale.attributes,
    dateFormat: locale.dateFormat
  };
};

var I18nDictionary = function I18nDictionary (i18n, rootKey) {
  this.i18n = i18n;
  this.rootKey = rootKey;
};

var prototypeAccessors$3 = { locale: {} };

prototypeAccessors$3.locale.get = function () {
  return this.i18n.locale;
};

prototypeAccessors$3.locale.set = function (value) {
  warn('Cannot set locale from the validator when using vue-i18n, use i18n.locale setter instead');
};

I18nDictionary.prototype.getDateFormat = function getDateFormat (locale) {
  return this.i18n.getDateTimeFormat(locale || this.locale);
};

I18nDictionary.prototype.setDateFormat = function setDateFormat (locale, value) {
  this.i18n.setDateTimeFormat(locale || this.locale, value);
};

I18nDictionary.prototype.getMessage = function getMessage (locale, key, data) {
  var path = (this.rootKey) + ".messages." + key;
  if (!this.i18n.te(path)) {
    return this.i18n.t(((this.rootKey) + ".messages._default"), locale, data);
  }

  return this.i18n.t(path, locale, data);
};

I18nDictionary.prototype.getAttribute = function getAttribute (locale, key, fallback) {
    if ( fallback === void 0 ) fallback = '';

  var path = (this.rootKey) + ".attributes." + key;
  if (!this.i18n.te(path)) {
    return fallback;
  }

  return this.i18n.t(path, locale);
};

I18nDictionary.prototype.getFieldMessage = function getFieldMessage (locale, field, key, data) {
  var path = (this.rootKey) + ".custom." + field + "." + key;
  if (this.i18n.te(path)) {
    return this.i18n.t(path);
  }

  return this.getMessage(locale, key, data);
};

I18nDictionary.prototype.merge = function merge$1 (dictionary) {
    var this$1 = this;

  Object.keys(dictionary).forEach(function (localeKey) {
    // i18n doesn't deep merge
    // first clone the existing locale (avoid mutations to locale)
    var clone = merge({}, getPath((localeKey + "." + (this$1.rootKey)), this$1.i18n.messages, {}));
    // Merge cloned locale with new one
    var locale = merge(clone, normalizeFormat(dictionary[localeKey]));
    this$1.i18n.mergeLocaleMessage(localeKey, ( obj = {}, obj[this$1.rootKey] = locale, obj ));
      var obj;
    if (locale.dateFormat) {
      this$1.i18n.setDateTimeFormat(localeKey, locale.dateFormat);
    }
  });
};

I18nDictionary.prototype.setMessage = function setMessage (locale, key, value) {
  this.merge(( obj$1 = {}, obj$1[locale] = {
      messages: ( obj = {}, obj[key] = value, obj )
    }, obj$1 ));
    var obj;
    var obj$1;
};

I18nDictionary.prototype.setAttribute = function setAttribute (locale, key, value) {
  this.merge(( obj$1 = {}, obj$1[locale] = {
      attributes: ( obj = {}, obj[key] = value, obj )
    }, obj$1 ));
    var obj;
    var obj$1;
};

Object.defineProperties( I18nDictionary.prototype, prototypeAccessors$3 );

// 

var defaultConfig = {
  locale: 'en',
  delay: 0,
  errorBagName: 'errors',
  dictionary: null,
  strict: true,
  fieldsBagName: 'fields',
  classes: false,
  classNames: null,
  events: 'input|blur',
  inject: true,
  fastExit: true,
  aria: true,
  validity: false,
  i18n: null,
  i18nRootKey: 'validation'
};

var currentConfig = assign({}, defaultConfig);
var dependencies = {
  dictionary: new Dictionary({
    en: {
      messages: {},
      attributes: {},
      custom: {}
    }
  })
};

var Config = function Config () {};

var staticAccessors$1 = { default: {},current: {} };

staticAccessors$1.default.get = function () {
  return defaultConfig;
};

staticAccessors$1.current.get = function () {
  return currentConfig;
};

Config.dependency = function dependency (key) {
  return dependencies[key];
};

/**
 * Merges the config with a new one.
 */
Config.merge = function merge$$1 (config) {
  currentConfig = assign({}, currentConfig, config);
  if (currentConfig.i18n) {
    Config.register('dictionary', new I18nDictionary(currentConfig.i18n, currentConfig.i18nRootKey));
  }
};

/**
 * Registers a dependency.
 */
Config.register = function register (key, value) {
  dependencies[key] = value;
};

/**
 * Resolves the working config from a Vue instance.
 */
Config.resolve = function resolve (context) {
  var selfConfig = getPath('$options.$_veeValidate', context, {});

  return assign({}, Config.current, selfConfig);
};

Object.defineProperties( Config, staticAccessors$1 );

/**
 * Generates the options required to construct a field.
 */
var Generator = function Generator () {};

Generator.generate = function generate (el, binding, vnode) {
  var model = Generator.resolveModel(binding, vnode);
  var options = Config.resolve(vnode.context);

  return {
    name: Generator.resolveName(el, vnode),
    el: el,
    listen: !binding.modifiers.disable,
    scope: Generator.resolveScope(el, binding, vnode),
    vm: Generator.makeVM(vnode.context),
    expression: binding.value,
    component: vnode.child,
    classes: options.classes,
    classNames: options.classNames,
    getter: Generator.resolveGetter(el, vnode, model),
    events: Generator.resolveEvents(el, vnode) || options.events,
    model: model,
    delay: Generator.resolveDelay(el, vnode, options),
    rules: Generator.resolveRules(el, binding),
    initial: !!binding.modifiers.initial,
    validity: options.validity,
    aria: options.aria,
    initialValue: Generator.resolveInitialValue(vnode)
  };
};

Generator.getCtorConfig = function getCtorConfig (vnode) {
  if (!vnode.child) { return null; }

  var config = getPath('child.$options.$_veeValidate', vnode);

  return config;
};

/**
 * Resolves the rules defined on an element.
 */
Generator.resolveRules = function resolveRules (el, binding) {
  if (!binding.value && (!binding || !binding.expression)) {
    return getDataAttribute(el, 'rules');
  }

  if (~['string', 'object'].indexOf(typeof binding.value.rules)) {
    return binding.value.rules;
  }

  return binding.value;
};

/**
 * @param {*} vnode
 */
Generator.resolveInitialValue = function resolveInitialValue (vnode) {
  var model = vnode.data.model || find(vnode.data.directives, function (d) { return d.name === 'model'; });

  return model && model.value;
};

/**
 * Creates a non-circular partial VM instance from a Vue instance.
 * @param {*} vm
 */
Generator.makeVM = function makeVM (vm) {
  return {
    get $el () {
      return vm.$el;
    },
    get $refs () {
      return vm.$refs;
    },
    $watch: vm.$watch ? vm.$watch.bind(vm) : function () {},
    $validator: vm.$validator ? {
      errors: vm.$validator.errors,
      validate: vm.$validator.validate.bind(vm.$validator),
      update: vm.$validator.update.bind(vm.$validator)
    } : null
  };
};

/**
 * Resolves the delay value.
 * @param {*} el
 * @param {*} vnode
 * @param {Object} options
 */
Generator.resolveDelay = function resolveDelay (el, vnode, options) {
  var delay = getDataAttribute(el, 'delay');
  var globalDelay = (options && 'delay' in options) ? options.delay : 0;

  if (!delay && vnode.child && vnode.child.$attrs) {
    delay = vnode.child.$attrs['data-vv-delay'];
  }

  if (!isObject(globalDelay)) {
    return deepParseInt(delay || globalDelay);
  }

  globalDelay.input = delay || 0;

  return deepParseInt(globalDelay);
};

/**
 * Resolves the events to validate in response to.
 * @param {*} el
 * @param {*} vnode
 */
Generator.resolveEvents = function resolveEvents (el, vnode) {
  var events = getDataAttribute(el, 'validate-on');

  if (!events && vnode.child && vnode.child.$attrs) {
    events = vnode.child.$attrs['data-vv-validate-on'];
  }

  if (!events && vnode.child) {
    var config = Generator.getCtorConfig(vnode);
    events = config && config.events;
  }

  return events;
};

/**
 * Resolves the scope for the field.
 * @param {*} el
 * @param {*} binding
 */
Generator.resolveScope = function resolveScope (el, binding, vnode) {
    if ( vnode === void 0 ) vnode = {};

  var scope = null;
  if (vnode.child && isNullOrUndefined(scope)) {
    scope = vnode.child.$attrs && vnode.child.$attrs['data-vv-scope'];
  }

  return !isNullOrUndefined(scope) ? scope : getScope(el);
};

/**
 * Checks if the node directives contains a v-model or a specified arg.
 * Args take priority over models.
 *
 * @return {Object}
 */
Generator.resolveModel = function resolveModel (binding, vnode) {
  if (binding.arg) {
    return binding.arg;
  }

  var model = vnode.data.model || find(vnode.data.directives, function (d) { return d.name === 'model'; });
  if (!model) {
    return null;
  }

  var watchable = /^[a-z_]+[0-9]*(\w*\.[a-z_]\w*)*$/i.test(model.expression) && hasPath(model.expression, vnode.context);
  if (!watchable) {
    return null;
  }

  return model.expression;
};

/**
   * Resolves the field name to trigger validations.
   * @return {String} The field name.
   */
Generator.resolveName = function resolveName (el, vnode) {
  var name = getDataAttribute(el, 'name');

  if (!name && !vnode.child) {
    return el.name;
  }

  if (!name && vnode.child && vnode.child.$attrs) {
    name = vnode.child.$attrs['data-vv-name'] || vnode.child.$attrs['name'];
  }

  if (!name && vnode.child) {
    var config = Generator.getCtorConfig(vnode);
    if (config && isCallable(config.name)) {
      var boundGetter = config.name.bind(vnode.child);

      return boundGetter();
    }

    return vnode.child.name;
  }

  return name;
};

/**
 * Returns a value getter input type.
 */
Generator.resolveGetter = function resolveGetter (el, vnode, model) {
  if (model) {
    return function () {
      return getPath(model, vnode.context);
    };
  }

  if (vnode.child) {
    var path = getDataAttribute(el, 'value-path') || (vnode.child.$attrs && vnode.child.$attrs['data-vv-value-path']);
    if (path) {
      return function () {
        return getPath(path, vnode.child);
      };
    }

    var config = Generator.getCtorConfig(vnode);
    if (config && isCallable(config.value)) {
      var boundGetter = config.value.bind(vnode.child);

      return function () {
        return boundGetter();
      };
    }

    return function () {
      return vnode.child.value;
    };
  }

  switch (el.type) {
  case 'checkbox': return function () {
    var els = document.querySelectorAll(("input[name=\"" + (el.name) + "\"]"));

    els = toArray(els).filter(function (el) { return el.checked; });
    if (!els.length) { return undefined; }

    return els.map(function (checkbox) { return checkbox.value; });
  };
  case 'radio': return function () {
    var els = document.querySelectorAll(("input[name=\"" + (el.name) + "\"]"));
    var elm = find(els, function (el) { return el.checked; });

    return elm && elm.value;
  };
  case 'file': return function (context) {
    return toArray(el.files);
  };
  case 'select-multiple': return function () {
    return toArray(el.options).filter(function (opt) { return opt.selected; }).map(function (opt) { return opt.value; });
  };
  default: return function () {
    return el && el.value;
  };
  }
};

// 

var DEFAULT_OPTIONS = {
  targetOf: null,
  initial: false,
  scope: null,
  listen: true,
  name: null,
  rules: {},
  vm: null,
  classes: false,
  validity: true,
  aria: true,
  events: 'input|blur',
  delay: 0,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  }
};

var Field = function Field (el, options) {
  if ( options === void 0 ) options = {};

  this.id = uniqId();
  this.el = el;
  this.updated = false;
  this.dependencies = [];
  this.watchers = [];
  this.events = [];
  this.delay = 0;
  this.rules = {};
  this._cacheId(options);
  this.classNames = assign({}, DEFAULT_OPTIONS.classNames);
  options = assign({}, DEFAULT_OPTIONS, options);
  this._delay = !isNullOrUndefined(options.delay) ? options.delay : 0; // cache initial delay
  this.validity = options.validity;
  this.aria = options.aria;
  this.flags = createFlags();
  this.vm = options.vm;
  this.component = options.component;
  this.ctorConfig = this.component ? getPath('$options.$_veeValidate', this.component) : undefined;
  this.update(options);
  this.updated = false;
};

var prototypeAccessors$1 = { validator: {},isRequired: {},isDisabled: {},alias: {},value: {},rejectsFalse: {} };

prototypeAccessors$1.validator.get = function () {
  if (!this.vm || !this.vm.$validator) {
    warn('No validator instance detected.');
    return { validate: function () {} };
  }

  return this.vm.$validator;
};

prototypeAccessors$1.isRequired.get = function () {
  return !!this.rules.required;
};

prototypeAccessors$1.isDisabled.get = function () {
  return !!(this.component && this.component.disabled) || !!(this.el && this.el.disabled);
};

/**
 * Gets the display name (user-friendly name).
 */
prototypeAccessors$1.alias.get = function () {
  if (this._alias) {
    return this._alias;
  }

  var alias = null;
  if (this.el) {
    alias = getDataAttribute(this.el, 'as');
  }

  if (!alias && this.component) {
    return this.component.$attrs && this.component.$attrs['data-vv-as'];
  }

  return alias;
};

/**
 * Gets the input value.
 */

prototypeAccessors$1.value.get = function () {
  if (!isCallable(this.getter)) {
    return undefined;
  }

  return this.getter();
};

/**
 * If the field rejects false as a valid value for the required rule.
 */

prototypeAccessors$1.rejectsFalse.get = function () {
  if (this.component && this.ctorConfig) {
    return !!this.ctorConfig.rejectsFalse;
  }

  if (!this.el) {
    return false;
  }

  return this.el.type === 'checkbox';
};

/**
 * Determines if the instance matches the options provided.
 */
Field.prototype.matches = function matches (options) {
  if (options.id) {
    return this.id === options.id;
  }

  if (options.name === undefined && options.scope === undefined) {
    return true;
  }

  if (options.scope === undefined) {
    return this.name === options.name;
  }

  if (options.name === undefined) {
    return this.scope === options.scope;
  }

  return options.name === this.name && options.scope === this.scope;
};

/**
 * Caches the field id.
 */
Field.prototype._cacheId = function _cacheId (options) {
  if (this.el && !options.targetOf) {
    setDataAttribute(this.el, 'id', this.id); // cache field id if it is independent and has a root element.
  }
};

/**
 * Updates the field with changed data.
 */
Field.prototype.update = function update (options) {
  this.targetOf = options.targetOf || null;
  this.initial = options.initial || this.initial || false;

  // update errors scope if the field scope was changed.
  if (!isNullOrUndefined(options.scope) && options.scope !== this.scope && isCallable(this.validator.update)) {
    this.validator.update(this.id, { scope: options.scope });
  }
  this.scope = !isNullOrUndefined(options.scope) ? options.scope
    : !isNullOrUndefined(this.scope) ? this.scope : null;
  this.name = (!isNullOrUndefined(options.name) ? String(options.name) : options.name) || this.name || null;
  this.rules = options.rules !== undefined ? normalizeRules(options.rules) : this.rules;
  this.model = options.model || this.model;
  this.listen = options.listen !== undefined ? options.listen : this.listen;
  this.classes = (options.classes || this.classes || false) && !this.component;
  this.classNames = isObject(options.classNames) ? merge(this.classNames, options.classNames) : this.classNames;
  this.getter = isCallable(options.getter) ? options.getter : this.getter;
  this._alias = options.alias || this._alias;
  this.events = (options.events) ? makeEventsArray(options.events) : this.events;
  this.delay = (options.delay) ? makeDelayObject(this.events, options.delay, this._delay) : makeDelayObject(this.events, this.delay, this._delay);
  this.updateDependencies();
  this.addActionListeners();

  // update required flag flags
  if (options.rules !== undefined) {
    this.flags.required = this.isRequired;
  }

  // validate if it was validated before and field was updated and there was a rules mutation.
  if (this.flags.validated && options.rules !== undefined && this.updated) {
    this.validator.validate(("#" + (this.id)));
  }

  this.updated = true;
  this.addValueListeners();

  // no need to continue.
  if (!this.el) {
    return;
  }

  this.updateClasses();
  this.updateAriaAttrs();
};

/**
 * Resets field flags and errors.
 */
Field.prototype.reset = function reset () {
    var this$1 = this;

  var defaults = createFlags();
  Object.keys(this.flags).filter(function (flag) { return flag !== 'required'; }).forEach(function (flag) {
    this$1.flags[flag] = defaults[flag];
  });

  this.addActionListeners();
  this.updateClasses();
  this.updateAriaAttrs();
  this.updateCustomValidity();
};

/**
 * Sets the flags and their negated counterparts, and updates the classes and re-adds action listeners.
 */
Field.prototype.setFlags = function setFlags (flags) {
    var this$1 = this;

  var negated = {
    pristine: 'dirty',
    dirty: 'pristine',
    valid: 'invalid',
    invalid: 'valid',
    touched: 'untouched',
    untouched: 'touched'
  };

  Object.keys(flags).forEach(function (flag) {
    this$1.flags[flag] = flags[flag];
    // if it has a negation and was not specified, set it as well.
    if (negated[flag] && flags[negated[flag]] === undefined) {
      this$1.flags[negated[flag]] = !flags[flag];
    }
  });

  if (
    flags.untouched !== undefined ||
    flags.touched !== undefined ||
    flags.dirty !== undefined ||
    flags.pristine !== undefined
  ) {
    this.addActionListeners();
  }
  this.updateClasses();
  this.updateAriaAttrs();
  this.updateCustomValidity();
};

/**
 * Determines if the field requires references to target fields.
*/
Field.prototype.updateDependencies = function updateDependencies () {
    var this$1 = this;

  // reset dependencies.
  this.dependencies.forEach(function (d) { return d.field.destroy(); });
  this.dependencies = [];

  // we get the selectors for each field.
  var fields = Object.keys(this.rules).reduce(function (prev, r) {
    if (Validator.isTargetRule(r)) {
      var selector = this$1.rules[r][0];
      if (r === 'confirmed' && !selector) {
        selector = (this$1.name) + "_confirmation";
      }

      prev.push({ selector: selector, name: r });
    }

    return prev;
  }, []);

  if (!fields.length || !this.vm || !this.vm.$el) { return; }

  // must be contained within the same component, so we use the vm root element constrain our dom search.
  fields.forEach(function (ref) {
      var selector = ref.selector;
      var name = ref.name;

    var el = null;
    // vue ref selector.
    if (selector[0] === '$') {
      var ref$1 = this$1.vm.$refs[selector.slice(1)];
      el = Array.isArray(ref$1) ? ref$1[0] : ref$1;
    } else {
      try {
        // try query selector
        el = this$1.vm.$el.querySelector(selector);
      } catch (err) {
        el = null;
      }
    }

    if (!el) {
      try {
        el = this$1.vm.$el.querySelector(("input[name=\"" + selector + "\"]"));
      } catch (err) {
        el = null;
      }
    }

    if (!el) {
      return;
    }

    var options = {
      vm: this$1.vm,
      classes: this$1.classes,
      classNames: this$1.classNames,
      delay: this$1.delay,
      scope: this$1.scope,
      events: this$1.events.join('|'),
      initial: this$1.initial,
      targetOf: this$1.id
    };

    // probably a component.
    if (isCallable(el.$watch)) {
      options.component = el;
      options.el = el.$el;
      options.getter = Generator.resolveGetter(el.$el, { child: el });
    } else {
      options.el = el;
      options.getter = Generator.resolveGetter(el, {});
    }

    this$1.dependencies.push({ name: name, field: new Field(options.el, options) });
  });
};

/**
 * Removes listeners.
 */
Field.prototype.unwatch = function unwatch (tag) {
    if ( tag === void 0 ) tag = null;

  if (!tag) {
    this.watchers.forEach(function (w) { return w.unwatch(); });
    this.watchers = [];
    return;
  }

  this.watchers.filter(function (w) { return tag.test(w.tag); }).forEach(function (w) { return w.unwatch(); });
  this.watchers = this.watchers.filter(function (w) { return !tag.test(w.tag); });
};

/**
 * Updates the element classes depending on each field flag status.
 */
Field.prototype.updateClasses = function updateClasses () {
  if (!this.classes || this.isDisabled) { return; }

  toggleClass(this.el, this.classNames.dirty, this.flags.dirty);
  toggleClass(this.el, this.classNames.pristine, this.flags.pristine);
  toggleClass(this.el, this.classNames.touched, this.flags.touched);
  toggleClass(this.el, this.classNames.untouched, this.flags.untouched);
  // make sure we don't set any classes if the state is undetermined.
  if (!isNullOrUndefined(this.flags.valid) && this.flags.validated) {
    toggleClass(this.el, this.classNames.valid, this.flags.valid);
  }

  if (!isNullOrUndefined(this.flags.invalid) && this.flags.validated) {
    toggleClass(this.el, this.classNames.invalid, this.flags.invalid);
  }
};

/**
 * Adds the listeners required for automatic classes and some flags.
 */
Field.prototype.addActionListeners = function addActionListeners () {
    var this$1 = this;

  // remove previous listeners.
  this.unwatch(/class/);

  var onBlur = function () {
    this$1.flags.touched = true;
    this$1.flags.untouched = false;
    if (this$1.classes) {
      toggleClass(this$1.el, this$1.classNames.touched, true);
      toggleClass(this$1.el, this$1.classNames.untouched, false);
    }

    // only needed once.
    this$1.unwatch(/^class_blur$/);
  };

  var inputEvent = getInputEventName(this.el);
  var onInput = function () {
    this$1.flags.dirty = true;
    this$1.flags.pristine = false;
    if (this$1.classes) {
      toggleClass(this$1.el, this$1.classNames.pristine, false);
      toggleClass(this$1.el, this$1.classNames.dirty, true);
    }

    // only needed once.
    this$1.unwatch(/^class_input$/);
  };

  if (this.component && isCallable(this.component.$once)) {
    this.component.$once('input', onInput);
    this.component.$once('blur', onBlur);
    this.watchers.push({
      tag: 'class_input',
      unwatch: function () {
        this$1.component.$off('input', onInput);
      }
    });
    this.watchers.push({
      tag: 'class_blur',
      unwatch: function () {
        this$1.component.$off('blur', onBlur);
      }
    });
    return;
  }

  if (!this.el) { return; }

  this.el.addEventListener(inputEvent, onInput);
  // Checkboxes and radio buttons on Mac don't emit blur naturally, so we listen on click instead.
  var blurEvent = ['radio', 'checkbox'].indexOf(this.el.type) === -1 ? 'blur' : 'click';
  this.el.addEventListener(blurEvent, onBlur);
  this.watchers.push({
    tag: 'class_input',
    unwatch: function () {
      this$1.el.removeEventListener(inputEvent, onInput);
    }
  });

  this.watchers.push({
    tag: 'class_blur',
    unwatch: function () {
      this$1.el.removeEventListener(blurEvent, onBlur);
    }
  });
};

/**
 * Adds the listeners required for validation.
 */
Field.prototype.addValueListeners = function addValueListeners () {
    var this$1 = this;

  this.unwatch(/^input_.+/);
  if (!this.listen) { return; }

  var fn = this.targetOf ? function () {
    this$1.validator.validate(("#" + (this$1.targetOf)));
  } : function () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

    // if its a DOM event, resolve the value, otherwise use the first parameter as the value.
    if (args.length === 0 || (isCallable(Event) && args[0] instanceof Event) || (args[0] && args[0].srcElement)) {
      args[0] = this$1.value;
    }
    this$1.validator.validate(("#" + (this$1.id)), args[0]);
  };

  var inputEvent = getInputEventName(this.el);
  // replace input event with suitable one.
  var events = this.events.map(function (e) {
    return e === 'input' ? inputEvent : e;
  });

  // if there is a watchable model and an on input validation is requested.
  if (this.model && events.indexOf(inputEvent) !== -1) {
    var debouncedFn = debounce(fn, this.delay[inputEvent]);
    var unwatch = this.vm.$watch(this.model, function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

      this$1.flags.pending = true;
      debouncedFn.apply(void 0, args);
    });
    this.watchers.push({
      tag: 'input_model',
      unwatch: unwatch
    });
    // filter out input event as it is already handled by the watcher API.
    events = events.filter(function (e) { return e !== inputEvent; });
  }

  // Add events.
  events.forEach(function (e) {
    var debouncedFn = debounce(fn, this$1.delay[e]);
    var validate = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

      this$1.flags.pending = true;
      debouncedFn.apply(void 0, args);
    };

    this$1._addComponentEventListener(e, validate);
    this$1._addHTMLEventListener(e, validate);
  });
};

Field.prototype._addComponentEventListener = function _addComponentEventListener (evt, validate) {
    var this$1 = this;

  if (!this.component) { return; }

  this.component.$on(evt, validate);
  this.watchers.push({
    tag: 'input_vue',
    unwatch: function () {
      this$1.component.$off(evt, validate);
    }
  });
};

Field.prototype._addHTMLEventListener = function _addHTMLEventListener (evt, validate) {
    var this$1 = this;

  if (!this.el) { return; }

  if (~['radio', 'checkbox'].indexOf(this.el.type)) {
    var els = document.querySelectorAll(("input[name=\"" + (this.el.name) + "\"]"));
    toArray(els).forEach(function (el) {
      el.addEventListener(evt, validate);
      this$1.watchers.push({
        tag: 'input_native',
        unwatch: function () {
          el.removeEventListener(evt, validate);
        }
      });
    });

    return;
  }

  this.el.addEventListener(evt, validate);
  this.watchers.push({
    tag: 'input_native',
    unwatch: function () {
      this$1.el.removeEventListener(evt, validate);
    }
  });
};

/**
 * Updates aria attributes on the element.
 */
Field.prototype.updateAriaAttrs = function updateAriaAttrs () {
  if (!this.aria || !this.el || !isCallable(this.el.setAttribute)) { return; }

  this.el.setAttribute('aria-required', this.isRequired ? 'true' : 'false');
  this.el.setAttribute('aria-invalid', this.flags.invalid ? 'true' : 'false');
};

/**
 * Updates the custom validity for the field.
 */
Field.prototype.updateCustomValidity = function updateCustomValidity () {
  if (!this.validity || !this.el || !isCallable(this.el.setCustomValidity)) { return; }

  this.el.setCustomValidity(this.flags.valid ? '' : (this.validator.errors.firstById(this.id) || ''));
};

/**
 * Removes all listeners.
 */
Field.prototype.destroy = function destroy () {
  this.unwatch();
  this.dependencies.forEach(function (d) { return d.field.destroy(); });
  this.dependencies = [];
};

Object.defineProperties( Field.prototype, prototypeAccessors$1 );

// 

var FieldBag = function FieldBag () {
  this.items = [];
};

var prototypeAccessors$4 = { length: {} };

/**
 * Gets the current items length.
 */

prototypeAccessors$4.length.get = function () {
  return this.items.length;
};

/**
 * Finds the first field that matches the provided matcher object.
 */
FieldBag.prototype.find = function find$1 (matcher) {
  return find(this.items, function (item) { return item.matches(matcher); });
};

/**
 * Filters the items down to the matched fields.
 */
FieldBag.prototype.filter = function filter (matcher) {
  // multiple matchers to be tried.
  if (Array.isArray(matcher)) {
    return this.items.filter(function (item) { return matcher.some(function (m) { return item.matches(m); }); });
  }

  return this.items.filter(function (item) { return item.matches(matcher); });
};

/**
 * Maps the field items using the mapping function.
 */
FieldBag.prototype.map = function map (mapper) {
  return this.items.map(mapper);
};

/**
 * Finds and removes the first field that matches the provided matcher object, returns the removed item.
 */
FieldBag.prototype.remove = function remove (matcher) {
  var item = null;
  if (matcher instanceof Field) {
    item = matcher;
  } else {
    item = this.find(matcher);
  }

  if (!item) { return null; }

  var index = this.items.indexOf(item);
  this.items.splice(index, 1);

  return item;
};

/**
 * Adds a field item to the list.
 */
FieldBag.prototype.push = function push (item) {
  if (! (item instanceof Field)) {
    throw createError('FieldBag only accepts instances of Field that has an id defined.');
  }

  if (!item.id) {
    throw createError('Field id must be defined.');
  }

  if (this.find({ id: item.id })) {
    throw createError(("Field with id " + (item.id) + " is already added."));
  }

  this.items.push(item);
};

Object.defineProperties( FieldBag.prototype, prototypeAccessors$4 );

// 

var RULES = {};
var STRICT_MODE = true;
var TARGET_RULES = ['confirmed', 'after', 'before'];
var ERRORS = []; // HOLD errors references to trigger regeneration.

var Validator = function Validator (validations, options) {
  var this$1 = this;
  if ( options === void 0 ) options = { vm: null, fastExit: true };

  this.strict = STRICT_MODE;
  this.errors = new ErrorBag();
  ERRORS.push(this.errors);
  this.fields = new FieldBag();
  this.flags = {};
  this._createFields(validations);
  this.paused = false;
  this.fastExit = options.fastExit || false;
  this.ownerId = options.vm && options.vm._uid;
  // create it statically since we don't need constant access to the vm.
  this.reset = options.vm && isCallable(options.vm.$nextTick) ? function (matcher) {
    return new Promise(function (resolve) {
      options.vm.$nextTick(function () {
        options.vm.$nextTick(function () {
          resolve(this$1._reset(matcher));
        });
      });
    });
  } : this._reset;
};

var prototypeAccessors = { dictionary: {},locale: {},rules: {} };
var staticAccessors = { dictionary: {},locale: {},rules: {} };

/**
 * Getter for the dictionary.
 */
prototypeAccessors.dictionary.get = function () {
  return Config.dependency('dictionary');
};

/**
 * Static Getter for the dictionary.
 */
staticAccessors.dictionary.get = function () {
  return Config.dependency('dictionary');
};

/**
 * Getter for the current locale.
 */
prototypeAccessors.locale.get = function () {
  return this.dictionary.locale;
};

/**
 * Setter for the validator locale.
 */
prototypeAccessors.locale.set = function (value) {
  Validator.locale = value;
};

/**
* Static getter for the validator locale.
*/
staticAccessors.locale.get = function () {
  return Validator.dictionary.locale;
};

/**
 * Static setter for the validator locale.
 */
staticAccessors.locale.set = function (value) {
  var hasChanged = value !== Validator.dictionary.locale;
  Validator.dictionary.locale = value;
  if (hasChanged) {
    Validator.regenerate();
  }
};

/**
 * Getter for the rules object.
 */
prototypeAccessors.rules.get = function () {
  return RULES;
};

/**
 * Static Getter for the rules object.
 */
staticAccessors.rules.get = function () {
  return RULES;
};

/**
 * Static constructor.
 */
Validator.create = function create (validations, options) {
  return new Validator(validations, options);
};

/**
 * Adds a custom validator to the list of validation rules.
 */
Validator.extend = function extend (name, validator, options) {
    if ( options === void 0 ) options = {};

  Validator._guardExtend(name, validator);
  Validator._merge(name, validator);
  if (options && options.hasTarget) {
    TARGET_RULES.push(name);
  }
};

/**
 * Regenerates error messages across all validators.
 */
Validator.regenerate = function regenerate () {
  ERRORS.forEach(function (errorBag) { return errorBag.regenerate(); });
};

/**
 * Removes a rule from the list of validators.
 */
Validator.remove = function remove (name) {
  delete RULES[name];
  var idx = TARGET_RULES.indexOf(name);
  if (idx === -1) { return; }

  TARGET_RULES.splice(idx, 1);
};

/**
 * Checks if the given rule name is a rule that targets other fields.
 */
Validator.isTargetRule = function isTargetRule (name) {
  return TARGET_RULES.indexOf(name) !== -1;
};

/**
 * Sets the operating mode for all newly created validators.
 * strictMode = true: Values without a rule are invalid and cause failure.
 * strictMode = false: Values without a rule are valid and are skipped.
 */
Validator.setStrictMode = function setStrictMode (strictMode) {
    if ( strictMode === void 0 ) strictMode = true;

  STRICT_MODE = strictMode;
};

/**
 * Adds and sets the current locale for the validator.
 */
Validator.prototype.localize = function localize (lang, dictionary) {
  Validator.localize(lang, dictionary);
};

/**
 * Adds and sets the current locale for the validator.
 */
Validator.localize = function localize (lang, dictionary) {
  if (isObject(lang)) {
    Validator.dictionary.merge(lang);
    return;
  }

  // merge the dictionary.
  if (dictionary) {
    var locale = lang || dictionary.name;
    dictionary = assign({}, dictionary);
    Validator.dictionary.merge(( obj = {}, obj[locale] = dictionary, obj ));
      var obj;
  }

  if (lang) {
    // set the locale.
    Validator.locale = lang;
  }
};

/**
 * Registers a field to be validated.
 */
Validator.prototype.attach = function attach (field) {
  // deprecate: handle old signature.
  if (arguments.length > 1) {
    warn('This signature of the attach method has been deprecated, please consult the docs.');
    field = assign({}, {
      name: arguments[0],
      rules: arguments[1]
    }, arguments[2] || { vm: { $validator: this } });
  }

  // fixes initial value detection with v-model and select elements.
  var value = field.initialValue;
  if (!(field instanceof Field)) {
    field = new Field(field.el || null, field);
  }

  this.fields.push(field);

  // validate the field initially
  if (field.initial) {
    this.validate(("#" + (field.id)), value || field.value);
  } else {
    this._validate(field, value || field.value, true).then(function (result) {
      field.flags.valid = result.valid;
      field.flags.invalid = !result.valid;
    });
  }

  this._addFlag(field, field.scope);
  return field;
};

/**
 * Sets the flags on a field.
 */
Validator.prototype.flag = function flag (name, flags) {
  var field = this._resolveField(name);
  if (! field || !flags) {
    return;
  }

  field.setFlags(flags);
};

/**
 * Removes a field from the validator.
 */
Validator.prototype.detach = function detach (name, scope) {
  var field = name instanceof Field ? name : this._resolveField(name, scope);
  if (!field) { return; }

  field.destroy();
  this.errors.remove(field.name, field.scope, field.id);
  this.fields.remove(field);
  var flags = this.flags;
  if (!isNullOrUndefined(field.scope) && flags[("$" + (field.scope))]) {
    delete flags[("$" + (field.scope))][field.name];
  } else if (isNullOrUndefined(field.scope)) {
    delete flags[field.name];
  }

  this.flags = assign({}, flags);
};

/**
 * Adds a custom validator to the list of validation rules.
 */
Validator.prototype.extend = function extend (name, validator, options) {
    if ( options === void 0 ) options = {};

  Validator.extend(name, validator, options);
};

/**
 * Updates a field, updating both errors and flags.
 */
Validator.prototype.update = function update (id, ref) {
    var scope = ref.scope;

  var field = this._resolveField(("#" + id));
  if (!field) { return; }

  // remove old scope.
  this.errors.update(id, { scope: scope });
  if (!isNullOrUndefined(field.scope) && this.flags[("$" + (field.scope))]) {
    delete this.flags[("$" + (field.scope))][field.name];
  } else if (isNullOrUndefined(field.scope)) {
    delete this.flags[field.name];
  }

  this._addFlag(field, scope);
};

/**
 * Removes a rule from the list of validators.
 */
Validator.prototype.remove = function remove (name) {
  Validator.remove(name);
};

/**
 * Validates a value against a registered field validations.
 */
Validator.prototype.validate = function validate (name, value, scope) {
    var this$1 = this;
    if ( scope === void 0 ) scope = null;

  if (this.paused) { return Promise.resolve(true); }

  // overload to validate all.
  if (arguments.length === 0) {
    return this.validateScopes();
  }

  // overload to validate scope-less fields.
  if (arguments.length === 1 && arguments[0] === '*') {
    return this.validateAll();
  }

  // overload to validate a scope.
  if (arguments.length === 1 && typeof arguments[0] === 'string' && /^(.+)\.\*$/.test(arguments[0])) {
    var matched = arguments[0].match(/^(.+)\.\*$/)[1];
    return this.validateAll(matched);
  }

  var field = this._resolveField(name, scope);
  if (!field) {
    return this._handleFieldNotFound(name, scope);
  }

  field.flags.pending = true;
  if (arguments.length === 1) {
    value = field.value;
  }

  var silentRun = field.isDisabled;

  return this._validate(field, value, silentRun).then(function (result) {
    this$1.errors.remove(field.name, field.scope, field.id);
    if (silentRun) {
      return Promise.resolve(true);
    } else if (result.errors) {
      result.errors.forEach(function (e) { return this$1.errors.add(e); });
    }

    field.setFlags({
      pending: false,
      valid: result.valid,
      validated: true
    });

    return result.valid;
  });
};

/**
 * Pauses the validator.
 */
Validator.prototype.pause = function pause () {
  this.paused = true;

  return this;
};

/**
 * Resumes the validator.
 */
Validator.prototype.resume = function resume () {
  this.paused = false;

  return this;
};

/**
 * Validates each value against the corresponding field validations.
 */
Validator.prototype.validateAll = function validateAll (values) {
    var arguments$1 = arguments;
    var this$1 = this;

  if (this.paused) { return Promise.resolve(true); }

  var matcher = null;
  var providedValues = false;

  if (typeof values === 'string') {
    matcher = { scope: values };
  } else if (isObject(values)) {
    matcher = Object.keys(values).map(function (key) {
      return { name: key, scope: arguments$1[1] || null };
    });
    providedValues = true;
  } else if (arguments.length === 0) {
    matcher = { scope: null }; // global scope.
  } else if (Array.isArray(values)) {
    matcher = values.map(function (key) {
      return { name: key, scope: arguments$1[1] || null };
    });
  }

  var promises = this.fields.filter(matcher).map(function (field) { return this$1.validate(
    ("#" + (field.id)),
    providedValues ? values[field.name] : field.value
  ); });

  return Promise.all(promises).then(function (results) { return results.every(function (t) { return t; }); });
};

/**
 * Validates all scopes.
 */
Validator.prototype.validateScopes = function validateScopes () {
    var this$1 = this;

  if (this.paused) { return Promise.resolve(true); }

  var promises = this.fields.map(function (field) { return this$1.validate(
    ("#" + (field.id)),
    field.value
  ); });

  return Promise.all(promises).then(function (results) { return results.every(function (t) { return t; }); });
};

/**
 * Perform cleanup.
 */
Validator.prototype.destroy = function destroy () {
  // Remove ErrorBag instance.
  var idx = ERRORS.indexOf(this.errors);
  if (idx === -1) { return; }

  ERRORS.splice(idx, 1);
};

/**
 * Creates the fields to be validated.
 */
Validator.prototype._createFields = function _createFields (validations) {
    var this$1 = this;

  if (!validations) { return; }

  Object.keys(validations).forEach(function (field) {
    var options = assign({}, { name: field, rules: validations[field] });
    this$1.attach(options);
  });
};

/**
 * Date rules need the existence of a format, so date_format must be supplied.
 */
Validator.prototype._getDateFormat = function _getDateFormat (validations) {
  var format = null;
  if (validations.date_format && Array.isArray(validations.date_format)) {
    format = validations.date_format[0];
  }

  return format || this.dictionary.getDateFormat(this.locale);
};

/**
 * Checks if the passed rule is a date rule.
 */
Validator.prototype._isADateRule = function _isADateRule (rule) {
  return !! ~['after', 'before', 'date_between', 'date_format'].indexOf(rule);
};

/**
 * Formats an error message for field and a rule.
 */
Validator.prototype._formatErrorMessage = function _formatErrorMessage (field, rule, data, targetName) {
    if ( data === void 0 ) data = {};
    if ( targetName === void 0 ) targetName = null;

  var name = this._getFieldDisplayName(field);
  var params = this._getLocalizedParams(rule, targetName);

  return this.dictionary.getFieldMessage(this.locale, field.name, rule.name, [name, params, data]);
};

/**
 * Translates the parameters passed to the rule (mainly for target fields).
 */
Validator.prototype._getLocalizedParams = function _getLocalizedParams (rule, targetName) {
    if ( targetName === void 0 ) targetName = null;

  if (~TARGET_RULES.indexOf(rule.name) && rule.params && rule.params[0]) {
    var localizedName = targetName || this.dictionary.getAttribute(this.locale, rule.params[0], rule.params[0]);
    return [localizedName].concat(rule.params.slice(1));
  }

  return rule.params;
};

/**
 * Resolves an appropriate display name, first checking 'data-as' or the registered 'prettyName'
 */
Validator.prototype._getFieldDisplayName = function _getFieldDisplayName (field) {
  return field.alias || this.dictionary.getAttribute(this.locale, field.name, field.name);
};

/**
 * Adds a field flags to the flags collection.
 */
Validator.prototype._addFlag = function _addFlag (field, scope) {
    if ( scope === void 0 ) scope = null;

  if (isNullOrUndefined(scope)) {
    this.flags = assign({}, this.flags, ( obj = {}, obj[("" + (field.name))] = field.flags, obj ));
      var obj;
    return;
  }

  var scopeObj = assign({}, this.flags[("$" + scope)] || {}, ( obj$1 = {}, obj$1[("" + (field.name))] = field.flags, obj$1 ));
    var obj$1;
  this.flags = assign({}, this.flags, ( obj$2 = {}, obj$2[("$" + scope)] = scopeObj, obj$2 ));
    var obj$2;
};

/**
 * Resets fields that matches the matcher options or all fields if not specified.
 */
Validator.prototype._reset = function _reset (matcher) {
    var this$1 = this;

  return new Promise(function (resolve) {
    if (matcher) {
      this$1.fields.filter(matcher).forEach(function (field) {
        field.reset(); // reset field flags.
        this$1.errors.remove(field.name, field.scope, field.id);
      });

      return resolve();
    }

    this$1.fields.items.forEach(function (i) { return i.reset(); });
    this$1.errors.clear();
    resolve();
  });
};

/**
 * Tests a single input value against a rule.
 */
Validator.prototype._test = function _test (field, value, rule) {
    var this$1 = this;

  var validator = RULES[rule.name];
  var params = Array.isArray(rule.params) ? toArray(rule.params) : [];
  var targetName = null;
  if (!validator || typeof validator !== 'function') {
    throw createError(("No such validator '" + (rule.name) + "' exists."));
  }

  // has field dependencies.
  if (TARGET_RULES.indexOf(rule.name) !== -1) {
    var target = find(field.dependencies, function (d) { return d.name === rule.name; });
    if (target) {
      targetName = target.field.alias;
      params = [target.field.value].concat(params.slice(1));
    }
  } else if (rule.name === 'required' && field.rejectsFalse) {
    // invalidate false if no args were specified and the field rejects false by default.
    params = params.length ? params : [true];
  }

  if (this._isADateRule(rule.name)) {
    var dateFormat = this._getDateFormat(field.rules);
    if (rule.name !== 'date_format') {
      params.push(dateFormat);
    }
  }

  var result = validator(value, params);

  // If it is a promise.
  if (isCallable(result.then)) {
    return result.then(function (values) {
      var allValid = true;
      var data = {};
      if (Array.isArray(values)) {
        allValid = values.every(function (t) { return (isObject(t) ? t.valid : t); });
      } else { // Is a single object/boolean.
        allValid = isObject(values) ? values.valid : values;
        data = values.data;
      }

      return {
        valid: allValid,
        error: allValid ? undefined : this$1._createFieldError(field, rule, data, targetName)
      };
    });
  }

  if (!isObject(result)) {
    result = { valid: result, data: {} };
  }

  return {
    valid: result.valid,
    error: result.valid ? undefined : this._createFieldError(field, rule, result.data, targetName)
  };
};

/**
 * Merges a validator object into the RULES and Messages.
 */
Validator._merge = function _merge (name, validator) {
  if (isCallable(validator)) {
    RULES[name] = validator;
    return;
  }

  RULES[name] = validator.validate;
  if (validator.getMessage) {
    Validator.dictionary.setMessage(this.locale, name, validator.getMessage);
  }
};

/**
 * Guards from extension violations.
 */
Validator._guardExtend = function _guardExtend (name, validator) {
  if (isCallable(validator)) {
    return;
  }

  if (!isCallable(validator.validate)) {
    throw createError(
      ("Extension Error: The validator '" + name + "' must be a function or have a 'validate' method.")
    );
  }

  if (!isCallable(validator.getMessage) && typeof validator.getMessage !== 'string') {
    throw createError(
      ("Extension Error: The validator '" + name + "' object must have a 'getMessage' method or string.")
    );
  }
};

/**
 * Creates a Field Error Object.
 */
Validator.prototype._createFieldError = function _createFieldError (field, rule, data, targetName) {
    var this$1 = this;

  return {
    id: field.id,
    field: field.name,
    msg: this._formatErrorMessage(field, rule, data, targetName),
    rule: rule.name,
    scope: field.scope,
    regenerate: function () {
      return this$1._formatErrorMessage(field, rule, data, targetName);
    }
  };
};

/**
 * Tries different strategies to find a field.
 */
Validator.prototype._resolveField = function _resolveField (name, scope) {
  if (!isNullOrUndefined(scope)) {
    return this.fields.find({ name: name, scope: scope });
  }

  if (name[0] === '#') {
    return this.fields.find({ id: name.slice(1) });
  }

  if (name.indexOf('.') > -1) {
    var ref = name.split('.');
      var fieldScope = ref[0];
      var fieldName = ref.slice(1);
    var field = this.fields.find({ name: fieldName.join('.'), scope: fieldScope });
    if (field) {
      return field;
    }
  }

  return this.fields.find({ name: name, scope: null });
};

/**
 * Handles when a field is not found depending on the strict flag.
 */
Validator.prototype._handleFieldNotFound = function _handleFieldNotFound (name, scope) {
  if (!this.strict) { return Promise.resolve(true); }

  var fullName = isNullOrUndefined(scope) ? name : ("" + (!isNullOrUndefined(scope) ? scope + '.' : '') + name);
  throw createError(
    ("Validating a non-existent field: \"" + fullName + "\". Use \"attach()\" first.")
  );
};

/**
 * Starts the validation process.
 */
Validator.prototype._validate = function _validate (field, value, silent) {
    var this$1 = this;
    if ( silent === void 0 ) silent = false;

  if (!field.isRequired && (isNullOrUndefined(value) || value === '')) {
    return Promise.resolve({ valid: true });
  }

  var promises = [];
  var errors = [];
  var isExitEarly = false;
  // use of '.some()' is to break iteration in middle by returning true
  Object.keys(field.rules).some(function (rule) {
    var result = this$1._test(field, value, { name: rule, params: field.rules[rule] });
    if (isCallable(result.then)) {
      promises.push(result);
    } else if (this$1.fastExit && !result.valid) {
      errors.push(result.error);
      isExitEarly = true;
    } else {
      // promisify the result.
      promises.push(new Promise(function (resolve) {
        resolve(result);
      }));
    }

    return isExitEarly;
  });

  if (isExitEarly) {
    return Promise.resolve({
      valid: false,
      errors: errors
    });
  }

  return Promise.all(promises).then(function (values) { return values.map(function (v) {
    if (!v.valid) {
      errors.push(v.error);
    }

    return v.valid;
  }).every(function (t) { return t; }); }
  ).then(function (result) {
    return {
      valid: result,
      errors: errors
    };
  });
};

Object.defineProperties( Validator.prototype, prototypeAccessors );
Object.defineProperties( Validator, staticAccessors );

// 

/**
 * Checks if a parent validator instance was requested.
 */
var requestsValidator = function (injections) {
  if (isObject(injections) && injections.$validator) {
    return true;
  }

  return false;
};

/**
 * Creates a validator instance.
 */
var createValidator = function (vm, options) { return new Validator(null, { vm: vm, fastExit: options.fastExit }); };

var mixin = {
  provide: function provide () {
    if (this.$validator && !isBuiltInComponent(this.$vnode)) {
      return {
        $validator: this.$validator
      };
    }

    return {};
  },
  beforeCreate: function beforeCreate () {
    // if built in do nothing.
    if (isBuiltInComponent(this.$vnode)) {
      return;
    }

    // if its a root instance set the config if it exists.
    if (!this.$parent) {
      Config.merge(this.$options.$_veeValidate || {});
    }

    var options = Config.resolve(this);
    var Vue = this.$options._base; // the vue constructor.
    // TODO: Deprecate
    /* istanbul ignore next */
    if (this.$options.$validates) {
      warn('The ctor $validates option has been deprecated please set the $_veeValidate.validator option to "new" instead');
      this.$validator = createValidator(this, options);
    }

    // if its a root instance, inject anyways, or if it requested a new instance.
    if (!this.$parent || (this.$options.$_veeValidate && /new/.test(this.$options.$_veeValidate.validator))) {
      this.$validator = createValidator(this, options);
    }

    var requested = requestsValidator(this.$options.inject);

    // if automatic injection is enabled and no instance was requested.
    if (! this.$validator && options.inject && !requested) {
      this.$validator = createValidator(this, options);
    }

    // don't inject errors or fieldBag as no validator was resolved.
    if (! requested && ! this.$validator) {
      return;
    }

    // There is a validator but it isn't injected, mark as reactive.
    if (! requested && this.$validator) {
      Vue.util.defineReactive(this.$validator, 'errors', this.$validator.errors);
      Vue.util.defineReactive(this.$validator, 'flags', this.$validator.flags);
    }

    if (! this.$options.computed) {
      this.$options.computed = {};
    }

    this.$options.computed[options.errorBagName || 'errors'] = function errorBagGetter () {
      return this.$validator.errors;
    };
    this.$options.computed[options.fieldsBagName || 'fields'] = function fieldBagGetter () {
      return this.$validator.flags;
    };
  },
  beforeDestroy: function beforeDestroy () {
    if (isBuiltInComponent(this.$vnode)) { return; }

    // mark the validator paused to prevent delayed validation.
    if (this.$validator && this.$validator.ownerId === this._uid) {
      this.$validator.pause();
      this.$validator.destroy();
    }
  }
};

// 

/**
 * Finds the requested field by id from the context object.
 */
var findField = function (el, context) {
  if (!context || !context.$validator) {
    return null;
  }

  return context.$validator.fields.find({ id: getDataAttribute(el, 'id') });
};

var directive = {
  bind: function bind (el, binding, vnode) {
    var validator = vnode.context.$validator;
    if (! validator) {
      warn("No validator instance is present on vm, did you forget to inject '$validator'?");
      return;
    }

    var fieldOptions = Generator.generate(el, binding, vnode);
    validator.attach(fieldOptions);
  },
  inserted: function (el, binding, vnode) {
    var field = findField(el, vnode.context);
    var scope = Generator.resolveScope(el, binding, vnode);

    // skip if scope hasn't changed.
    if (!field || scope === field.scope) { return; }

    // only update scope.
    field.update({ scope: scope });

    // allows the field to re-evaluated once more in the update hook.
    field.updated = false;
  },
  update: function (el, binding, vnode) {
    var field = findField(el, vnode.context);

    // make sure we don't do unneccasary work if no important change was done.
    if (!field || (field.updated && isEqual(binding.value, binding.oldValue))) { return; }
    var scope = Generator.resolveScope(el, binding, vnode);
    var rules = Generator.resolveRules(el, binding);

    field.update({
      scope: scope,
      rules: rules
    });
  },
  unbind: function unbind (el, binding, ref) {
    var context = ref.context;

    var field = findField(el, context);
    if (!field) { return; }

    context.$validator.detach(field);
  }
};

var Vue;

function install (_Vue, options) {
  if ( options === void 0 ) options = {};

  if (Vue && _Vue === Vue) {
    if (false) {
      warn('already installed, Vue.use(VeeValidate) should only be called once.');
    }
    return;
  }

  Vue = _Vue;
  Config.merge(options);
  var ref = Config.current;
  var dictionary = ref.dictionary;
  var i18n = ref.i18n;

  if (dictionary) {
    Validator.localize(dictionary); // merge the dictionary.
  }

  // try to watch locale changes.
  if (i18n && i18n._vm && isCallable(i18n._vm.$watch)) {
    i18n._vm.$watch('locale', function () {
      Validator.regenerate();
    });
  }

  if (!i18n && options.locale) {
    Validator.localize(options.locale); // set the locale
  }

  Validator.setStrictMode(Config.current.strict);

  Vue.mixin(mixin);
  Vue.directive('validate', directive);
}

/**
 * Formates file size.
 *
 * @param {Number|String} size
 */
var formatFileSize = function (size) {
  var units = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var threshold = 1024;
  size = Number(size) * threshold;
  var i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold));
  return (((size / Math.pow(threshold, i)).toFixed(2) * 1) + " " + (units[i]));
};

/**
 * Checks if vee-validate is defined globally.
 */
var isDefinedGlobally = function () {
  return typeof VeeValidate !== 'undefined';
};

var messages = {
  _default: function (field) { return ("The " + field + " value is not valid."); },
  after: function (field, ref) {
    var target = ref[0];
    var inclusion = ref[1];

    return ("The " + field + " must be after " + (inclusion ? 'or equal to ' : '') + target + ".");
},
  alpha_dash: function (field) { return ("The " + field + " field may contain alpha-numeric characters as well as dashes and underscores."); },
  alpha_num: function (field) { return ("The " + field + " field may only contain alpha-numeric characters."); },
  alpha_spaces: function (field) { return ("The " + field + " field may only contain alphabetic characters as well as spaces."); },
  alpha: function (field) { return ("The " + field + " field may only contain alphabetic characters."); },
  before: function (field, ref) {
    var target = ref[0];
    var inclusion = ref[1];

    return ("The " + field + " must be before " + (inclusion ? 'or equal to ' : '') + target + ".");
},
  between: function (field, ref) {
    var min = ref[0];
    var max = ref[1];

    return ("The " + field + " field must be between " + min + " and " + max + ".");
},
  confirmed: function (field) { return ("The " + field + " confirmation does not match."); },
  credit_card: function (field) { return ("The " + field + " field is invalid."); },
  date_between: function (field, ref) {
    var min = ref[0];
    var max = ref[1];

    return ("The " + field + " must be between " + min + " and " + max + ".");
},
  date_format: function (field, ref) {
    var format = ref[0];

    return ("The " + field + " must be in the format " + format + ".");
},
  decimal: function (field, ref) {
    if ( ref === void 0 ) ref = [];
    var decimals = ref[0]; if ( decimals === void 0 ) decimals = '*';

    return ("The " + field + " field must be numeric and may contain " + (!decimals || decimals === '*' ? '' : decimals) + " decimal points.");
},
  digits: function (field, ref) {
    var length = ref[0];

    return ("The " + field + " field must be numeric and exactly contain " + length + " digits.");
},
  dimensions: function (field, ref) {
    var width = ref[0];
    var height = ref[1];

    return ("The " + field + " field must be " + width + " pixels by " + height + " pixels.");
},
  email: function (field) { return ("The " + field + " field must be a valid email."); },
  ext: function (field) { return ("The " + field + " field must be a valid file."); },
  image: function (field) { return ("The " + field + " field must be an image."); },
  in: function (field) { return ("The " + field + " field must be a valid value."); },
  integer: function (field) { return ("The " + field + " field must be an integer."); },
  ip: function (field) { return ("The " + field + " field must be a valid ip address."); },
  length: function (field, ref) {
    var length = ref[0];
    var max = ref[1];

    if (max) {
      return ("The " + field + " length be between " + length + " and " + max + ".");
    }

    return ("The " + field + " length must be " + length + ".");
  },
  max: function (field, ref) {
    var length = ref[0];

    return ("The " + field + " field may not be greater than " + length + " characters.");
},
  max_value: function (field, ref) {
    var max = ref[0];

    return ("The " + field + " field must be " + max + " or less.");
},
  mimes: function (field) { return ("The " + field + " field must have a valid file type."); },
  min: function (field, ref) {
    var length = ref[0];

    return ("The " + field + " field must be at least " + length + " characters.");
},
  min_value: function (field, ref) {
    var min = ref[0];

    return ("The " + field + " field must be " + min + " or more.");
},
  not_in: function (field) { return ("The " + field + " field must be a valid value."); },
  numeric: function (field) { return ("The " + field + " field may only contain numeric characters."); },
  regex: function (field) { return ("The " + field + " field format is invalid."); },
  required: function (field) { return ("The " + field + " field is required."); },
  size: function (field, ref) {
    var size = ref[0];

    return ("The " + field + " size must be less than " + (formatFileSize(size)) + ".");
},
  url: function (field) { return ("The " + field + " field is not a valid URL."); }
};

var locale = {
  name: 'en',
  messages: messages,
  attributes: {}
};

if (isDefinedGlobally()) {
  // eslint-disable-next-line
  VeeValidate.Validator.localize(( obj = {}, obj[locale.name] = locale, obj ));
  var obj;
}

// 

function use (plugin, options) {
  if ( options === void 0 ) options = {};

  if (!isCallable(plugin)) {
    return warn('The plugin must be a callable function');
  }

  plugin({ Validator: Validator, ErrorBag: ErrorBag, Rules: Validator.rules }, options);
}

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;

var patterns = {
  dateTimeDelimeter: /[T ]/,
  plainTime: /:/,

  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/, // 0 additional digits
    /^([+-]\d{3})$/, // 1 additional digit
    /^([+-]\d{4})$/ // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/, // 0 additional digits
    /^([+-]\d{5})/, // 1 additional digit
    /^([+-]\d{6})/ // 2 additional digits
  ],

  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,

  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,

  // timezone tokens
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-])(\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument is null, it is treated as an invalid date.
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
 *
 * @param {*} argument - the value to convert
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = toDate('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = toDate('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function toDate (argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  if (argument === null) {
    return new Date(NaN)
  }

  var options = dirtyOptions || {};

  var additionalDigits = options.additionalDigits === undefined ? DEFAULT_ADDITIONAL_DIGITS : Number(options.additionalDigits);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2')
  }

  // Clone the date
  if (argument instanceof Date) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var dateStrings = splitDateString(argument);

  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;

  var date = parseDate(restDateString, year);

  if (date) {
    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone);
    } else {
      // get offset accurate to hour in timezones that change offset
      offset = new Date(timestamp + time).getTimezoneOffset();
      offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset();
    }

    return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimeter);
  var timeString;

  if (patterns.plainTime.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var patternYYY = patterns.YYY[additionalDigits];
  var patternYYYYY = patterns.YYYYY[additionalDigits];

  var token;

  // YYYY or ±YYYYY
  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token;
  var date;
  var month;
  var week;

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0);
    date.setUTCFullYear(year);
    return date
  }

  // YYYY-MM
  token = patterns.MM.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    date.setUTCFullYear(year, month);
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = patterns.DDD.exec(dateString);
  if (token) {
    date = new Date(0);
    var dayOfYear = parseInt(token[1], 10);
    date.setUTCFullYear(year, 0, dayOfYear);
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = patterns.MMDD.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);
    date.setUTCFullYear(year, month, day);
    return date
  }

  // YYYY-Www or YYYYWww
  token = patterns.Www.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = patterns.WwwD.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token;
  var hours;
  var minutes;

  // hh
  token = patterns.HH.exec(timeString);
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'));
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = patterns.HHMM.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(',', '.'));
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = patterns.HHMMSS.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(',', '.'));
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token;
  var absoluteOffset;

  // Z
  token = patterns.timezoneZ.exec(timezoneString);
  if (token) {
    return 0
  }

  // ±hh
  token = patterns.timezoneHH.exec(timezoneString);
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60;
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = patterns.timezoneHHMM.exec(timezoneString);
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10);
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date = new Date(0);
  date.setUTCFullYear(isoYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var timestamp = toDate(dirtyDate, dirtyOptions).getTime();
  var amount = Number(dirtyAmount);
  return new Date(timestamp + amount)
}

function cloneObject (dirtyObject) {
  dirtyObject = dirtyObject || {};
  var object = {};

  for (var property in dirtyObject) {
    if (dirtyObject.hasOwnProperty(property)) {
      object[property] = dirtyObject[property];
    }
  }

  return object
}

var MILLISECONDS_IN_MINUTE$2 = 60000;

/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE$2, dirtyOptions)
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid('2014-02-31')
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  return !isNaN(date)
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },

  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },

  halfAMinute: 'half a minute',

  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },

  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },

  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },

  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },

  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },

  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },

  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },

  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },

  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },

  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },

  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

function formatDistance (token, count, options) {
  options = options || {};

  var result;
  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result
    } else {
      return result + ' ago'
    }
  }

  return result
}

var tokensToBeShortedPattern = /MMMM|MM|DD|dddd/g;

function buildShortLongFormat (format) {
  return format.replace(tokensToBeShortedPattern, function (token) {
    return token.slice(1)
  })
}

/**
 * @name buildFormatLongFn
 * @category Locale Helpers
 * @summary Build `formatLong` property for locale used by `format`, `formatRelative` and `parse` functions.
 *
 * @description
 * Build `formatLong` property for locale used by `format`, `formatRelative` and `parse` functions.
 * Returns a function which takes one of the following tokens as the argument:
 * `'LTS'`, `'LT'`, `'L'`, `'LL'`, `'LLL'`, `'l'`, `'ll'`, `'lll'`, `'llll'`
 * and returns a long format string written as `format` token strings.
 * See [format]{@link https://date-fns.org/docs/format}
 *
 * `'l'`, `'ll'`, `'lll'` and `'llll'` formats are built automatically
 * by shortening some of the tokens from corresponding unshortened formats
 * (e.g., if `LL` is `'MMMM DD YYYY'` then `ll` will be `MMM D YYYY`)
 *
 * @param {Object} obj - the object with long formats written as `format` token strings
 * @param {String} obj.LT - time format: hours and minutes
 * @param {String} obj.LTS - time format: hours, minutes and seconds
 * @param {String} obj.L - short date format: numeric day, month and year
 * @param {String} [obj.l] - short date format: numeric day, month and year (shortened)
 * @param {String} obj.LL - long date format: day, month in words, and year
 * @param {String} [obj.ll] - long date format: day, month in words, and year (shortened)
 * @param {String} obj.LLL - long date and time format
 * @param {String} [obj.lll] - long date and time format (shortened)
 * @param {String} obj.LLLL - long date, time and weekday format
 * @param {String} [obj.llll] - long date, time and weekday format (shortened)
 * @returns {Function} `formatLong` property of the locale
 *
 * @example
 * // For `en-US` locale:
 * locale.formatLong = buildFormatLongFn({
 *   LT: 'h:mm aa',
 *   LTS: 'h:mm:ss aa',
 *   L: 'MM/DD/YYYY',
 *   LL: 'MMMM D YYYY',
 *   LLL: 'MMMM D YYYY h:mm aa',
 *   LLLL: 'dddd, MMMM D YYYY h:mm aa'
 * })
 */
function buildFormatLongFn (obj) {
  var formatLongLocale = {
    LTS: obj.LTS,
    LT: obj.LT,
    L: obj.L,
    LL: obj.LL,
    LLL: obj.LLL,
    LLLL: obj.LLLL,
    l: obj.l || buildShortLongFormat(obj.L),
    ll: obj.ll || buildShortLongFormat(obj.LL),
    lll: obj.lll || buildShortLongFormat(obj.LLL),
    llll: obj.llll || buildShortLongFormat(obj.LLLL)
  };

  return function (token) {
    return formatLongLocale[token]
  }
}

var formatLong = buildFormatLongFn({
  LT: 'h:mm aa',
  LTS: 'h:mm:ss aa',
  L: 'MM/DD/YYYY',
  LL: 'MMMM D YYYY',
  LLL: 'MMMM D YYYY h:mm aa',
  LLLL: 'dddd, MMMM D YYYY h:mm aa'
});

var formatRelativeLocale = {
  lastWeek: '[last] dddd [at] LT',
  yesterday: '[yesterday at] LT',
  today: '[today at] LT',
  tomorrow: '[tomorrow at] LT',
  nextWeek: 'dddd [at] LT',
  other: 'L'
};

function formatRelative (token, date, baseDate, options) {
  return formatRelativeLocale[token]
}

/**
 * @name buildLocalizeFn
 * @category Locale Helpers
 * @summary Build `localize.weekday`, `localize.month` and `localize.timeOfDay` properties for the locale.
 *
 * @description
 * Build `localize.weekday`, `localize.month` and `localize.timeOfDay` properties for the locale
 * used by `format` function.
 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
 *
 * `localize.weekday` function takes the weekday index as argument (0 - Sunday).
 * `localize.month` takes the month index (0 - January).
 * `localize.timeOfDay` takes the hours. Use `indexCallback` to convert them to an array index (see example).
 *
 * @param {Object} values - the object with arrays of values
 * @param {String} defaultType - the default type for the localize function
 * @param {Function} [indexCallback] - the callback which takes the resulting function argument
 *   and converts it into value array index
 * @returns {Function} the resulting function
 *
 * @example
 * var timeOfDayValues = {
 *   uppercase: ['AM', 'PM'],
 *   lowercase: ['am', 'pm'],
 *   long: ['a.m.', 'p.m.']
 * }
 * locale.localize.timeOfDay = buildLocalizeFn(timeOfDayValues, 'long', function (hours) {
 *   // 0 is a.m. array index, 1 is p.m. array index
 *   return (hours / 12) >= 1 ? 1 : 0
 * })
 * locale.localize.timeOfDay(16, {type: 'uppercase'}) //=> 'PM'
 * locale.localize.timeOfDay(5) //=> 'a.m.'
 */
function buildLocalizeFn (values, defaultType, indexCallback) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var type = options.type ? String(options.type) : defaultType;
    var valuesArray = values[type] || values[defaultType];
    var index = indexCallback ? indexCallback(Number(dirtyIndex)) : Number(dirtyIndex);
    return valuesArray[index]
  }
}

/**
 * @name buildLocalizeArrayFn
 * @category Locale Helpers
 * @summary Build `localize.weekdays`, `localize.months` and `localize.timesOfDay` properties for the locale.
 *
 * @description
 * Build `localize.weekdays`, `localize.months` and `localize.timesOfDay` properties for the locale.
 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
 *
 * @param {Object} values - the object with arrays of values
 * @param {String} defaultType - the default type for the localize function
 * @returns {Function} the resulting function
 *
 * @example
 * var weekdayValues = {
 *   narrow: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
 *   short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
 *   long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
 * }
 * locale.localize.weekdays = buildLocalizeArrayFn(weekdayValues, 'long')
 * locale.localize.weekdays({type: 'narrow'}) //=> ['Su', 'Mo', ...]
 * locale.localize.weekdays() //=> ['Sunday', 'Monday', ...]
 */
function buildLocalizeArrayFn (values, defaultType) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var type = options.type ? String(options.type) : defaultType;
    return values[type] || values[defaultType]
  }
}

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var weekdayValues = {
  narrow: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};

var monthValues = {
  short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  long: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};

// `timeOfDay` is used to designate which part of the day it is, when used with 12-hour clock.
// Use the system which is used the most commonly in the locale.
// For example, if the country doesn't use a.m./p.m., you can use `night`/`morning`/`afternoon`/`evening`:
//
//   var timeOfDayValues = {
//     any: ['in the night', 'in the morning', 'in the afternoon', 'in the evening']
//   }
//
// And later:
//
//   var localize = {
//     // The callback takes the hours as the argument and returns the array index
//     timeOfDay: buildLocalizeFn(timeOfDayValues, 'any', function (hours) {
//       if (hours >= 17) {
//         return 3
//       } else if (hours >= 12) {
//         return 2
//       } else if (hours >= 4) {
//         return 1
//       } else {
//         return 0
//       }
//     }),
//     timesOfDay: buildLocalizeArrayFn(timeOfDayValues, 'any')
//   }
var timeOfDayValues = {
  uppercase: ['AM', 'PM'],
  lowercase: ['am', 'pm'],
  long: ['a.m.', 'p.m.']
};

function ordinalNumber (dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'month', 'quarter', 'week', 'isoWeek', 'dayOfYear',
  // 'dayOfMonth' or 'dayOfWeek'

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

var localize = {
  ordinalNumber: ordinalNumber,
  weekday: buildLocalizeFn(weekdayValues, 'long'),
  weekdays: buildLocalizeArrayFn(weekdayValues, 'long'),
  month: buildLocalizeFn(monthValues, 'long'),
  months: buildLocalizeArrayFn(monthValues, 'long'),
  timeOfDay: buildLocalizeFn(timeOfDayValues, 'long', function (hours) {
    return (hours / 12) >= 1 ? 1 : 0
  }),
  timesOfDay: buildLocalizeArrayFn(timeOfDayValues, 'long')
};

/**
 * @name buildMatchFn
 * @category Locale Helpers
 * @summary Build `match.weekdays`, `match.months` and `match.timesOfDay` properties for the locale.
 *
 * @description
 * Build `match.weekdays`, `match.months` and `match.timesOfDay` properties for the locale used by `parse` function.
 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
 * The result of the match function will be passed into corresponding parser function
 * (`match.weekday`, `match.month` or `match.timeOfDay` respectively. See `buildParseFn`).
 *
 * @param {Object} values - the object with RegExps
 * @param {String} defaultType - the default type for the match function
 * @returns {Function} the resulting function
 *
 * @example
 * var matchWeekdaysPatterns = {
 *   narrow: /^(su|mo|tu|we|th|fr|sa)/i,
 *   short: /^(sun|mon|tue|wed|thu|fri|sat)/i,
 *   long: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
 * }
 * locale.match.weekdays = buildMatchFn(matchWeekdaysPatterns, 'long')
 * locale.match.weekdays('Sunday', {type: 'narrow'}) //=> ['Su', 'Su', ...]
 * locale.match.weekdays('Sunday') //=> ['Sunday', 'Sunday', ...]
 */
function buildMatchFn (patterns, defaultType) {
  return function (dirtyString, dirtyOptions) {
    var options = dirtyOptions || {};
    var type = options.type ? String(options.type) : defaultType;
    var pattern = patterns[type] || patterns[defaultType];
    var string = String(dirtyString);
    return string.match(pattern)
  }
}

/**
 * @name buildParseFn
 * @category Locale Helpers
 * @summary Build `match.weekday`, `match.month` and `match.timeOfDay` properties for the locale.
 *
 * @description
 * Build `match.weekday`, `match.month` and `match.timeOfDay` properties for the locale used by `parse` function.
 * The argument of the resulting function is the result of the corresponding match function
 * (`match.weekdays`, `match.months` or `match.timesOfDay` respectively. See `buildMatchFn`).
 *
 * @param {Object} values - the object with arrays of RegExps
 * @param {String} defaultType - the default type for the parser function
 * @returns {Function} the resulting function
 *
 * @example
 * var parseWeekdayPatterns = {
 *   any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
 * }
 * locale.match.weekday = buildParseFn(matchWeekdaysPatterns, 'long')
 * var matchResult = locale.match.weekdays('Friday')
 * locale.match.weekday(matchResult) //=> 5
 */
function buildParseFn (patterns, defaultType) {
  return function (matchResult, dirtyOptions) {
    var options = dirtyOptions || {};
    var type = options.type ? String(options.type) : defaultType;
    var patternsArray = patterns[type] || patterns[defaultType];
    var string = matchResult[1];

    return patternsArray.findIndex(function (pattern) {
      return pattern.test(string)
    })
  }
}

/**
 * @name buildMatchPatternFn
 * @category Locale Helpers
 * @summary Build match function from a single RegExp.
 *
 * @description
 * Build match function from a single RegExp.
 * Usually used for building `match.ordinalNumbers` property of the locale.
 *
 * @param {Object} pattern - the RegExp
 * @returns {Function} the resulting function
 *
 * @example
 * locale.match.ordinalNumbers = buildMatchPatternFn(/^(\d+)(th|st|nd|rd)?/i)
 * locale.match.ordinalNumbers('3rd') //=> ['3rd', '3', 'rd', ...]
 */
function buildMatchPatternFn (pattern) {
  return function (dirtyString) {
    var string = String(dirtyString);
    return string.match(pattern)
  }
}

/**
 * @name parseDecimal
 * @category Locale Helpers
 * @summary Parses the match result into decimal number.
 *
 * @description
 * Parses the match result into decimal number.
 * Uses the string matched with the first set of parentheses of match RegExp.
 *
 * @param {Array} matchResult - the object returned by matching function
 * @returns {Number} the parsed value
 *
 * @example
 * locale.match = {
 *   ordinalNumbers: (dirtyString) {
 *     return String(dirtyString).match(/^(\d+)(th|st|nd|rd)?/i)
 *   },
 *   ordinalNumber: parseDecimal
 * }
 */
function parseDecimal (matchResult) {
  return parseInt(matchResult[1], 10)
}

var matchOrdinalNumbersPattern = /^(\d+)(th|st|nd|rd)?/i;

var matchWeekdaysPatterns = {
  narrow: /^(su|mo|tu|we|th|fr|sa)/i,
  short: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  long: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};

var parseWeekdayPatterns = {
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};

var matchMonthsPatterns = {
  short: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  long: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};

var parseMonthPatterns = {
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};

// `timeOfDay` is used to designate which part of the day it is, when used with 12-hour clock.
// Use the system which is used the most commonly in the locale.
// For example, if the country doesn't use a.m./p.m., you can use `night`/`morning`/`afternoon`/`evening`:
//
//   var matchTimesOfDayPatterns = {
//     long: /^((in the)? (night|morning|afternoon|evening?))/i
//   }
//
//   var parseTimeOfDayPatterns = {
//     any: [/(night|morning)/i, /(afternoon|evening)/i]
//   }
var matchTimesOfDayPatterns = {
  short: /^(am|pm)/i,
  long: /^([ap]\.?\s?m\.?)/i
};

var parseTimeOfDayPatterns = {
  any: [/^a/i, /^p/i]
};

var match = {
  ordinalNumbers: buildMatchPatternFn(matchOrdinalNumbersPattern),
  ordinalNumber: parseDecimal,
  weekdays: buildMatchFn(matchWeekdaysPatterns, 'long'),
  weekday: buildParseFn(parseWeekdayPatterns, 'any'),
  months: buildMatchFn(matchMonthsPatterns, 'long'),
  month: buildParseFn(parseMonthPatterns, 'any'),
  timesOfDay: buildMatchFn(matchTimesOfDayPatterns, 'long'),
  timeOfDay: buildParseFn(parseTimeOfDayPatterns, 'any')
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 */
var locale$1 = {
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};

var MILLISECONDS_IN_DAY$1 = 86400000;

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCDayOfYear (dirtyDate, dirtyOptions) {
  var date = toDate(dirtyDate, dirtyOptions);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY$1) + 1
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = 1;

  var date = toDate(dirtyDate, dirtyOptions);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeekYear (dirtyDate, dirtyOptions) {
  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();

  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear, dirtyOptions);

  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeekYear (dirtyDate, dirtyOptions) {
  var year = getUTCISOWeekYear(dirtyDate, dirtyOptions);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary, dirtyOptions);
  return date
}

var MILLISECONDS_IN_WEEK$2 = 604800000;

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeek (dirtyDate, dirtyOptions) {
  var date = toDate(dirtyDate, dirtyOptions);
  var diff = startOfUTCISOWeek(date, dirtyOptions).getTime() - startOfUTCISOWeekYear(date, dirtyOptions).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$2) + 1
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getUTCMonth() + 1
  },

  // Month: 1st, 2nd, ..., 12th
  'Mo': function (date, options) {
    var month = date.getUTCMonth() + 1;
    return options.locale.localize.ordinalNumber(month, {unit: 'month'})
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getUTCMonth() + 1, 2)
  },

  // Month: Jan, Feb, ..., Dec
  'MMM': function (date, options) {
    return options.locale.localize.month(date.getUTCMonth(), {type: 'short'})
  },

  // Month: January, February, ..., December
  'MMMM': function (date, options) {
    return options.locale.localize.month(date.getUTCMonth(), {type: 'long'})
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getUTCMonth() + 1) / 3)
  },

  // Quarter: 1st, 2nd, 3rd, 4th
  'Qo': function (date, options) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    return options.locale.localize.ordinalNumber(quarter, {unit: 'quarter'})
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getUTCDate()
  },

  // Day of month: 1st, 2nd, ..., 31st
  'Do': function (date, options) {
    return options.locale.localize.ordinalNumber(date.getUTCDate(), {unit: 'dayOfMonth'})
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getUTCDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return getUTCDayOfYear(date)
  },

  // Day of year: 1st, 2nd, ..., 366th
  'DDDo': function (date, options) {
    return options.locale.localize.ordinalNumber(getUTCDayOfYear(date), {unit: 'dayOfYear'})
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(getUTCDayOfYear(date), 3)
  },

  // Day of week: Su, Mo, ..., Sa
  'dd': function (date, options) {
    return options.locale.localize.weekday(date.getUTCDay(), {type: 'narrow'})
  },

  // Day of week: Sun, Mon, ..., Sat
  'ddd': function (date, options) {
    return options.locale.localize.weekday(date.getUTCDay(), {type: 'short'})
  },

  // Day of week: Sunday, Monday, ..., Saturday
  'dddd': function (date, options) {
    return options.locale.localize.weekday(date.getUTCDay(), {type: 'long'})
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getUTCDay()
  },

  // Day of week: 0th, 1st, 2nd, ..., 6th
  'do': function (date, options) {
    return options.locale.localize.ordinalNumber(date.getUTCDay(), {unit: 'dayOfWeek'})
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getUTCDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return getUTCISOWeek(date)
  },

  // ISO week: 1st, 2nd, ..., 53th
  'Wo': function (date, options) {
    return options.locale.localize.ordinalNumber(getUTCISOWeek(date), {unit: 'isoWeek'})
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(getUTCISOWeek(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getUTCFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getUTCFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(getUTCISOWeekYear(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return getUTCISOWeekYear(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getUTCHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getUTCHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getUTCHours();
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getUTCMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getUTCMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getUTCSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getUTCSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getUTCMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getUTCMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getUTCMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date, options) {
    var originalDate = options._originalDate || date;
    return formatTimezone(originalDate.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date, options) {
    var originalDate = options._originalDate || date;
    return formatTimezone(originalDate.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date, options) {
    var originalDate = options._originalDate || date;
    return Math.floor(originalDate.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date, options) {
    var originalDate = options._originalDate || date;
    return originalDate.getTime()
  },

  // AM, PM
  'A': function (date, options) {
    return options.locale.localize.timeOfDay(date.getUTCHours(), {type: 'uppercase'})
  },

  // am, pm
  'a': function (date, options) {
    return options.locale.localize.timeOfDay(date.getUTCHours(), {type: 'lowercase'})
  },

  // a.m., p.m.
  'aa': function (date, options) {
    return options.locale.localize.timeOfDay(date.getUTCHours(), {type: 'long'})
  }
};

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return output
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function addUTCMinutes (dirtyDate, dirtyAmount, dirtyOptions) {
  var date = toDate(dirtyDate, dirtyOptions);
  var amount = Number(dirtyAmount);
  date.setUTCMinutes(date.getUTCMinutes() + amount);
  return date
}

var longFormattingTokensRegExp = /(\[[^[]*])|(\\)?(LTS|LT|LLLL|LLL|LL|L|llll|lll|ll|l)/g;
var defaultFormattingTokensRegExp = /(\[[^[]*])|(\\)?(x|ss|s|mm|m|hh|h|do|dddd|ddd|dd|d|aa|a|ZZ|Z|YYYY|YY|X|Wo|WW|W|SSS|SS|S|Qo|Q|Mo|MMMM|MMM|MM|M|HH|H|GGGG|GG|E|Do|DDDo|DDDD|DDD|DD|D|A|.)/g;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 * | Long format             | LT    | 05:30 a.m.                       |
 * |                         | LTS   | 05:30:15 a.m.                    |
 * |                         | L     | 07/02/1995                       |
 * |                         | l     | 7/2/1995                         |
 * |                         | LL    | July 2 1995                      |
 * |                         | ll    | Jul 2 1995                       |
 * |                         | LLL   | July 2 1995 05:30 a.m.           |
 * |                         | lll   | Jul 2 1995 05:30 a.m.            |
 * |                         | LLLL  | Sunday, July 2 1995 05:30 a.m.   |
 * |                         | llll  | Sun, Jul 2 1995 05:30 a.m.       |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};

  var locale = options.locale || locale$1;

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property')
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property')
  }

  var localeFormatters = locale.formatters || {};
  var formattingTokensRegExp = locale.formattingTokensRegExp || defaultFormattingTokensRegExp;
  var formatLong = locale.formatLong;

  var originalDate = toDate(dirtyDate, options);

  if (!isValid(originalDate, options)) {
    return 'Invalid Date'
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = originalDate.getTimezoneOffset();
  var utcDate = addUTCMinutes(originalDate, -timezoneOffset, options);

  var formatterOptions = cloneObject(options);
  formatterOptions.locale = locale;
  formatterOptions.formatters = formatters;

  // When UTC functions will be implemented, options._originalDate will likely be a part of public API.
  // Right now, please don't use it in locales. If you have to use an original date,
  // please restore it from `date`, adding a timezone offset to it.
  formatterOptions._originalDate = originalDate;

  var result = formatStr
    .replace(longFormattingTokensRegExp, function (substring) {
      if (substring[0] === '[') {
        return substring
      }

      if (substring[0] === '\\') {
        return cleanEscapedString(substring)
      }

      return formatLong(substring)
    })
    .replace(formattingTokensRegExp, function (substring) {
      var formatter = localeFormatters[substring] || formatters[substring];

      if (formatter) {
        return formatter(utcDate, formatterOptions)
      } else {
        return cleanEscapedString(substring)
      }
    });

  return result
}

function cleanEscapedString (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the mintues subtracted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount);
  return addMinutes(dirtyDate, -amount, dirtyOptions)
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter (dirtyDate, dirtyDateToCompare, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var dateToCompare = toDate(dirtyDateToCompare, dirtyOptions);
  return date.getTime() > dateToCompare.getTime()
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var dateToCompare = toDate(dirtyDateToCompare, dirtyOptions);
  return date.getTime() < dateToCompare.getTime()
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual$1 (dirtyLeftDate, dirtyRightDate, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeft = toDate(dirtyLeftDate, dirtyOptions);
  var dateRight = toDate(dirtyRightDate, dirtyOptions);
  return dateLeft.getTime() === dateRight.getTime()
}

var patterns$1 = {
  'M': /^(1[0-2]|0?\d)/, // 0 to 12
  'D': /^(3[0-1]|[0-2]?\d)/, // 0 to 31
  'DDD': /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, // 0 to 366
  'W': /^(5[0-3]|[0-4]?\d)/, // 0 to 53
  'YYYY': /^(\d{1,4})/, // 0 to 9999
  'H': /^(2[0-3]|[0-1]?\d)/, // 0 to 23
  'm': /^([0-5]?\d)/, // 0 to 59
  'Z': /^([+-])(\d{2}):(\d{2})/,
  'ZZ': /^([+-])(\d{2})(\d{2})/,
  singleDigit: /^(\d)/,
  twoDigits: /^(\d{2})/,
  threeDigits: /^(\d{3})/,
  fourDigits: /^(\d{4})/,
  anyDigits: /^(\d+)/
};

function parseDecimal$1 (matchResult) {
  return parseInt(matchResult[1], 10)
}

var parsers = {
  // Year: 00, 01, ..., 99
  'YY': {
    unit: 'twoDigitYear',
    match: patterns$1.twoDigits,
    parse: function (matchResult) {
      return parseDecimal$1(matchResult)
    }
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': {
    unit: 'year',
    match: patterns$1.YYYY,
    parse: parseDecimal$1
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': {
    unit: 'isoYear',
    match: patterns$1.twoDigits,
    parse: function (matchResult) {
      return parseDecimal$1(matchResult) + 1900
    }
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': {
    unit: 'isoYear',
    match: patterns$1.YYYY,
    parse: parseDecimal$1
  },

  // Quarter: 1, 2, 3, 4
  'Q': {
    unit: 'quarter',
    match: patterns$1.singleDigit,
    parse: parseDecimal$1
  },

  // Ordinal quarter
  'Qo': {
    unit: 'quarter',
    match: function (string, options) {
      return options.locale.match.ordinalNumbers(string, {unit: 'quarter'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.ordinalNumber(matchResult, {unit: 'quarter'})
    }
  },

  // Month: 1, 2, ..., 12
  'M': {
    unit: 'month',
    match: patterns$1.M,
    parse: function (matchResult) {
      return parseDecimal$1(matchResult) - 1
    }
  },

  // Ordinal month
  'Mo': {
    unit: 'month',
    match: function (string, options) {
      return options.locale.match.ordinalNumbers(string, {unit: 'month'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.ordinalNumber(matchResult, {unit: 'month'}) - 1
    }
  },

  // Month: 01, 02, ..., 12
  'MM': {
    unit: 'month',
    match: patterns$1.twoDigits,
    parse: function (matchResult) {
      return parseDecimal$1(matchResult) - 1
    }
  },

  // Month: Jan, Feb, ..., Dec
  'MMM': {
    unit: 'month',
    match: function (string, options) {
      return options.locale.match.months(string, {type: 'short'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.month(matchResult, {type: 'short'})
    }
  },

  // Month: January, February, ..., December
  'MMMM': {
    unit: 'month',
    match: function (string, options) {
      return options.locale.match.months(string, {type: 'long'}) ||
        options.locale.match.months(string, {type: 'short'})
    },
    parse: function (matchResult, options) {
      var parseResult = options.locale.match.month(matchResult, {type: 'long'});

      if (parseResult == null) {
        parseResult = options.locale.match.month(matchResult, {type: 'short'});
      }

      return parseResult
    }
  },

  // ISO week: 1, 2, ..., 53
  'W': {
    unit: 'isoWeek',
    match: patterns$1.W,
    parse: parseDecimal$1
  },

  // Ordinal ISO week
  'Wo': {
    unit: 'isoWeek',
    match: function (string, options) {
      return options.locale.match.ordinalNumbers(string, {unit: 'isoWeek'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.ordinalNumber(matchResult, {unit: 'isoWeek'})
    }
  },

  // ISO week: 01, 02, ..., 53
  'WW': {
    unit: 'isoWeek',
    match: patterns$1.twoDigits,
    parse: parseDecimal$1
  },

  // Day of week: 0, 1, ..., 6
  'd': {
    unit: 'dayOfWeek',
    match: patterns$1.singleDigit,
    parse: parseDecimal$1
  },

  // Ordinal day of week
  'do': {
    unit: 'dayOfWeek',
    match: function (string, options) {
      return options.locale.match.ordinalNumbers(string, {unit: 'dayOfWeek'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.ordinalNumber(matchResult, {unit: 'dayOfWeek'})
    }
  },

  // Day of week: Su, Mo, ..., Sa
  'dd': {
    unit: 'dayOfWeek',
    match: function (string, options) {
      return options.locale.match.weekdays(string, {type: 'narrow'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.weekday(matchResult, {type: 'narrow'})
    }
  },

  // Day of week: Sun, Mon, ..., Sat
  'ddd': {
    unit: 'dayOfWeek',
    match: function (string, options) {
      return options.locale.match.weekdays(string, {type: 'short'}) ||
        options.locale.match.weekdays(string, {type: 'narrow'})
    },
    parse: function (matchResult, options) {
      var parseResult = options.locale.match.weekday(matchResult, {type: 'short'});

      if (parseResult == null) {
        parseResult = options.locale.match.weekday(matchResult, {type: 'narrow'});
      }

      return parseResult
    }
  },

  // Day of week: Sunday, Monday, ..., Saturday
  'dddd': {
    unit: 'dayOfWeek',
    match: function (string, options) {
      return options.locale.match.weekdays(string, {type: 'long'}) ||
        options.locale.match.weekdays(string, {type: 'short'}) ||
        options.locale.match.weekdays(string, {type: 'narrow'})
    },
    parse: function (matchResult, options) {
      var parseResult = options.locale.match.weekday(matchResult, {type: 'long'});

      if (parseResult == null) {
        parseResult = options.locale.match.weekday(matchResult, {type: 'short'});

        if (parseResult == null) {
          parseResult = options.locale.match.weekday(matchResult, {type: 'narrow'});
        }
      }

      return parseResult
    }
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': {
    unit: 'dayOfISOWeek',
    match: patterns$1.singleDigit,
    parse: function (matchResult) {
      return parseDecimal$1(matchResult)
    }
  },

  // Day of month: 1, 2, ..., 31
  'D': {
    unit: 'dayOfMonth',
    match: patterns$1.D,
    parse: parseDecimal$1
  },

  // Ordinal day of month
  'Do': {
    unit: 'dayOfMonth',
    match: function (string, options) {
      return options.locale.match.ordinalNumbers(string, {unit: 'dayOfMonth'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.ordinalNumber(matchResult, {unit: 'dayOfMonth'})
    }
  },

  // Day of month: 01, 02, ..., 31
  'DD': {
    unit: 'dayOfMonth',
    match: patterns$1.twoDigits,
    parse: parseDecimal$1
  },

  // Day of year: 1, 2, ..., 366
  'DDD': {
    unit: 'dayOfYear',
    match: patterns$1.DDD,
    parse: parseDecimal$1
  },

  // Ordinal day of year
  'DDDo': {
    unit: 'dayOfYear',
    match: function (string, options) {
      return options.locale.match.ordinalNumbers(string, {unit: 'dayOfYear'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.ordinalNumber(matchResult, {unit: 'dayOfYear'})
    }
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': {
    unit: 'dayOfYear',
    match: patterns$1.threeDigits,
    parse: parseDecimal$1
  },

  // AM, PM
  'A': {
    unit: 'timeOfDay',
    match: function (string, options) {
      return options.locale.match.timesOfDay(string, {type: 'short'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.timeOfDay(matchResult, {type: 'short'})
    }
  },

  // a.m., p.m.
  'aa': {
    unit: 'timeOfDay',
    match: function (string, options) {
      return options.locale.match.timesOfDay(string, {type: 'long'}) ||
        options.locale.match.timesOfDay(string, {type: 'short'})
    },
    parse: function (matchResult, options) {
      var parseResult = options.locale.match.timeOfDay(matchResult, {type: 'long'});

      if (parseResult == null) {
        parseResult = options.locale.match.timeOfDay(matchResult, {type: 'short'});
      }

      return parseResult
    }
  },

  // Hour: 0, 1, ... 23
  'H': {
    unit: 'hours',
    match: patterns$1.H,
    parse: parseDecimal$1
  },

  // Hour: 00, 01, ..., 23
  'HH': {
    unit: 'hours',
    match: patterns$1.twoDigits,
    parse: parseDecimal$1
  },

  // Hour: 1, 2, ..., 12
  'h': {
    unit: 'timeOfDayHours',
    match: patterns$1.M,
    parse: parseDecimal$1
  },

  // Hour: 01, 02, ..., 12
  'hh': {
    unit: 'timeOfDayHours',
    match: patterns$1.twoDigits,
    parse: parseDecimal$1
  },

  // Minute: 0, 1, ..., 59
  'm': {
    unit: 'minutes',
    match: patterns$1.m,
    parse: parseDecimal$1
  },

  // Minute: 00, 01, ..., 59
  'mm': {
    unit: 'minutes',
    match: patterns$1.twoDigits,
    parse: parseDecimal$1
  },

  // Second: 0, 1, ..., 59
  's': {
    unit: 'seconds',
    match: patterns$1.m,
    parse: parseDecimal$1
  },

  // Second: 00, 01, ..., 59
  'ss': {
    unit: 'seconds',
    match: patterns$1.twoDigits,
    parse: parseDecimal$1
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': {
    unit: 'milliseconds',
    match: patterns$1.singleDigit,
    parse: function (matchResult) {
      return parseDecimal$1(matchResult) * 100
    }
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': {
    unit: 'milliseconds',
    match: patterns$1.twoDigits,
    parse: function (matchResult) {
      return parseDecimal$1(matchResult) * 10
    }
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': {
    unit: 'milliseconds',
    match: patterns$1.threeDigits,
    parse: parseDecimal$1
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': {
    unit: 'timezone',
    match: patterns$1.Z,
    parse: function (matchResult) {
      var sign = matchResult[1];
      var hours = parseInt(matchResult[2], 10);
      var minutes = parseInt(matchResult[3], 10);
      var absoluteOffset = hours * 60 + minutes;
      return (sign === '+') ? absoluteOffset : -absoluteOffset
    }
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': {
    unit: 'timezone',
    match: patterns$1.ZZ,
    parse: function (matchResult) {
      var sign = matchResult[1];
      var hours = parseInt(matchResult[2], 10);
      var minutes = parseInt(matchResult[3], 10);
      var absoluteOffset = hours * 60 + minutes;
      return (sign === '+') ? absoluteOffset : -absoluteOffset
    }
  },

  // Seconds timestamp: 512969520
  'X': {
    unit: 'timestamp',
    match: patterns$1.anyDigits,
    parse: function (matchResult) {
      return parseDecimal$1(matchResult) * 1000
    }
  },

  // Milliseconds timestamp: 512969520900
  'x': {
    unit: 'timestamp',
    match: patterns$1.anyDigits,
    parse: parseDecimal$1
  }
};

parsers['a'] = parsers['A'];

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCDay (dirtyDate, dirtyDay, dirtyOptions) {
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn === undefined ? 0 : Number(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn === undefined ? defaultWeekStartsOn : Number(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var day = Number(dirtyDay);

  var currentDay = date.getUTCDay();

  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;

  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISODay (dirtyDate, dirtyDay, dirtyOptions) {
  var day = Number(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate, dirtyOptions);
  var currentDay = date.getUTCDay();

  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;

  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISOWeek (dirtyDate, dirtyISOWeek, dirtyOptions) {
  var date = toDate(dirtyDate, dirtyOptions);
  var isoWeek = Number(dirtyISOWeek);
  var diff = getUTCISOWeek(date, dirtyOptions) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date
}

var MILLISECONDS_IN_DAY$3 = 86400000;

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISOWeekYear (dirtyDate, dirtyISOYear, dirtyOptions) {
  var date = toDate(dirtyDate, dirtyOptions);
  var isoYear = Number(dirtyISOYear);
  var dateStartOfYear = startOfUTCISOWeekYear(date, dirtyOptions);
  var diff = Math.floor((date.getTime() - dateStartOfYear.getTime()) / MILLISECONDS_IN_DAY$3);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(isoYear, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  date = startOfUTCISOWeekYear(fourthOfJanuary, dirtyOptions);
  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

var MILLISECONDS_IN_MINUTE$7 = 60000;

function setTimeOfDay (hours, timeOfDay) {
  var isAM = timeOfDay === 0;

  if (isAM) {
    if (hours === 12) {
      return 0
    }
  } else {
    if (hours !== 12) {
      return 12 + hours
    }
  }

  return hours
}

var units = {
  twoDigitYear: {
    priority: 10,
    set: function (dateValues, value) {
      var century = Math.floor(dateValues.date.getUTCFullYear() / 100);
      var year = century * 100 + value;
      dateValues.date.setUTCFullYear(year, 0, 1);
      dateValues.date.setUTCHours(0, 0, 0, 0);
      return dateValues
    }
  },

  year: {
    priority: 10,
    set: function (dateValues, value) {
      dateValues.date.setUTCFullYear(value, 0, 1);
      dateValues.date.setUTCHours(0, 0, 0, 0);
      return dateValues
    }
  },

  isoYear: {
    priority: 10,
    set: function (dateValues, value, options) {
      dateValues.date = startOfUTCISOWeekYear(setUTCISOWeekYear(dateValues.date, value, options), options);
      return dateValues
    }
  },

  quarter: {
    priority: 20,
    set: function (dateValues, value) {
      dateValues.date.setUTCMonth((value - 1) * 3, 1);
      dateValues.date.setUTCHours(0, 0, 0, 0);
      return dateValues
    }
  },

  month: {
    priority: 30,
    set: function (dateValues, value) {
      dateValues.date.setUTCMonth(value, 1);
      dateValues.date.setUTCHours(0, 0, 0, 0);
      return dateValues
    }
  },

  isoWeek: {
    priority: 40,
    set: function (dateValues, value, options) {
      dateValues.date = startOfUTCISOWeek(setUTCISOWeek(dateValues.date, value, options), options);
      return dateValues
    }
  },

  dayOfWeek: {
    priority: 50,
    set: function (dateValues, value, options) {
      dateValues.date = setUTCDay(dateValues.date, value, options);
      dateValues.date.setUTCHours(0, 0, 0, 0);
      return dateValues
    }
  },

  dayOfISOWeek: {
    priority: 50,
    set: function (dateValues, value, options) {
      dateValues.date = setUTCISODay(dateValues.date, value, options);
      dateValues.date.setUTCHours(0, 0, 0, 0);
      return dateValues
    }
  },

  dayOfMonth: {
    priority: 50,
    set: function (dateValues, value) {
      dateValues.date.setUTCDate(value);
      dateValues.date.setUTCHours(0, 0, 0, 0);
      return dateValues
    }
  },

  dayOfYear: {
    priority: 50,
    set: function (dateValues, value) {
      dateValues.date.setUTCMonth(0, value);
      dateValues.date.setUTCHours(0, 0, 0, 0);
      return dateValues
    }
  },

  timeOfDay: {
    priority: 60,
    set: function (dateValues, value, options) {
      dateValues.timeOfDay = value;
      return dateValues
    }
  },

  hours: {
    priority: 70,
    set: function (dateValues, value, options) {
      dateValues.date.setUTCHours(value, 0, 0, 0);
      return dateValues
    }
  },

  timeOfDayHours: {
    priority: 70,
    set: function (dateValues, value, options) {
      var timeOfDay = dateValues.timeOfDay;
      if (timeOfDay != null) {
        value = setTimeOfDay(value, timeOfDay);
      }
      dateValues.date.setUTCHours(value, 0, 0, 0);
      return dateValues
    }
  },

  minutes: {
    priority: 80,
    set: function (dateValues, value) {
      dateValues.date.setUTCMinutes(value, 0, 0);
      return dateValues
    }
  },

  seconds: {
    priority: 90,
    set: function (dateValues, value) {
      dateValues.date.setUTCSeconds(value, 0);
      return dateValues
    }
  },

  milliseconds: {
    priority: 100,
    set: function (dateValues, value) {
      dateValues.date.setUTCMilliseconds(value);
      return dateValues
    }
  },

  timezone: {
    priority: 110,
    set: function (dateValues, value) {
      dateValues.date = new Date(dateValues.date.getTime() - value * MILLISECONDS_IN_MINUTE$7);
      return dateValues
    }
  },

  timestamp: {
    priority: 120,
    set: function (dateValues, value) {
      dateValues.date = new Date(value);
      return dateValues
    }
  }
};

var TIMEZONE_UNIT_PRIORITY = 110;
var MILLISECONDS_IN_MINUTE$6 = 60000;

var longFormattingTokensRegExp$1 = /(\[[^[]*])|(\\)?(LTS|LT|LLLL|LLL|LL|L|llll|lll|ll|l)/g;
var defaultParsingTokensRegExp = /(\[[^[]*])|(\\)?(x|ss|s|mm|m|hh|h|do|dddd|ddd|dd|d|aa|a|ZZ|Z|YYYY|YY|X|Wo|WW|W|SSS|SS|S|Qo|Q|Mo|MMMM|MMM|MM|M|HH|H|GGGG|GG|E|Do|DDDo|DDDD|DDD|DD|D|A|.)/g;

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format.
 *
 * Accepted format tokens:
 * | Unit                    | Priority | Token | Input examples                   |
 * |-------------------------|----------|-------|----------------------------------|
 * | Year                    | 10       | YY    | 00, 01, ..., 99                  |
 * |                         |          | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | 10       | GG    | 00, 01, ..., 99                  |
 * |                         |          | GGGG  | 1900, 1901, ..., 2099            |
 * | Quarter                 | 20       | Q     | 1, 2, 3, 4                       |
 * |                         |          | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Month                   | 30       | M     | 1, 2, ..., 12                    |
 * |                         |          | Mo    | 1st, 2nd, ..., 12th              |
 * |                         |          | MM    | 01, 02, ..., 12                  |
 * |                         |          | MMM   | Jan, Feb, ..., Dec               |
 * |                         |          | MMMM  | January, February, ..., December |
 * | ISO week                | 40       | W     | 1, 2, ..., 53                    |
 * |                         |          | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         |          | WW    | 01, 02, ..., 53                  |
 * | Day of week             | 50       | d     | 0, 1, ..., 6                     |
 * |                         |          | do    | 0th, 1st, ..., 6th               |
 * |                         |          | dd    | Su, Mo, ..., Sa                  |
 * |                         |          | ddd   | Sun, Mon, ..., Sat               |
 * |                         |          | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | 50       | E     | 1, 2, ..., 7                     |
 * | Day of month            | 50       | D     | 1, 2, ..., 31                    |
 * |                         |          | Do    | 1st, 2nd, ..., 31st              |
 * |                         |          | DD    | 01, 02, ..., 31                  |
 * | Day of year             | 50       | DDD   | 1, 2, ..., 366                   |
 * |                         |          | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         |          | DDDD  | 001, 002, ..., 366               |
 * | Time of day             | 60       | A     | AM, PM                           |
 * |                         |          | a     | am, pm                           |
 * |                         |          | aa    | a.m., p.m.                       |
 * | Hour                    | 70       | H     | 0, 1, ... 23                     |
 * |                         |          | HH    | 00, 01, ... 23                   |
 * | Time of day hour        | 70       | h     | 1, 2, ..., 12                    |
 * |                         |          | hh    | 01, 02, ..., 12                  |
 * | Minute                  | 80       | m     | 0, 1, ..., 59                    |
 * |                         |          | mm    | 00, 01, ..., 59                  |
 * | Second                  | 90       | s     | 0, 1, ..., 59                    |
 * |                         |          | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | 100      | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | 100      | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | 100      | SSS   | 000, 001, ..., 999               |
 * | Timezone                | 110      | Z     | -01:00, +00:00, ... +12:00       |
 * |                         |          | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | 120      | X     | 512969520                        |
 * | Milliseconds timestamp  | 120      | x     | 512969520900                     |
 *
 * Values will be assigned to the date in the ascending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `baseDate` which works as a context of parsing.
 *
 * `baseDate` must be passed for correct work of the function.
 * If you're not sure which `baseDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/DD/YYYY', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `baseDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * Also, `parse` unfolds long formats like those in [format]{@link https://date-fns.org/docs/format}:
 * | Token | Input examples                 |
 * |-------|--------------------------------|
 * | LT    | 05:30 a.m.                     |
 * | LTS   | 05:30:15 a.m.                  |
 * | L     | 07/02/1995                     |
 * | l     | 7/2/1995                       |
 * | LL    | July 2 1995                    |
 * | ll    | Jul 2 1995                     |
 * | LLL   | July 2 1995 05:30 a.m.         |
 * | lll   | Jul 2 1995 05:30 a.m.          |
 * | LLLL  | Sunday, July 2 1995 05:30 a.m. |
 * | llll  | Sun, Jul 2 1995 05:30 a.m.     |
 *
 * The characters wrapped in square brackets in the format string are escaped.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `baseDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|String|Number} baseDate - the date to took the missing higher priority values from
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse(
 *   '02/11/2014',
 *   'MM/DD/YYYY',
 *   new Date()
 * )
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in English locale in the context of 2010 year:
 * import eoLocale from 'date-fns/locale/eo'
 * var result = parse(
 *   '28-a de februaro',
 *   'Do [de] MMMM',
 *   new Date(2010, 0, 1)
 *   {locale: eoLocale}
 * )
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse (dirtyDateString, dirtyFormatString, dirtyBaseDate, dirtyOptions) {
  if (arguments.length < 3) {
    throw new TypeError('3 arguments required, but only ' + arguments.length + ' present')
  }

  var dateString = String(dirtyDateString);
  var options = dirtyOptions || {};

  var weekStartsOn = options.weekStartsOn === undefined ? 0 : Number(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  var locale = options.locale || locale$1;
  var localeParsers = locale.parsers || {};
  var localeUnits = locale.units || {};

  if (!locale.match) {
    throw new RangeError('locale must contain match property')
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property')
  }

  var formatString = String(dirtyFormatString)
    .replace(longFormattingTokensRegExp$1, function (substring) {
      if (substring[0] === '[') {
        return substring
      }

      if (substring[0] === '\\') {
        return cleanEscapedString$1(substring)
      }

      return locale.formatLong(substring)
    });

  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyBaseDate, options)
    } else {
      return new Date(NaN)
    }
  }

  var subFnOptions = cloneObject(options);
  subFnOptions.locale = locale;

  var tokens = formatString.match(locale.parsingTokensRegExp || defaultParsingTokensRegExp);
  var tokensLength = tokens.length;

  // If timezone isn't specified, it will be set to the system timezone
  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    set: dateToSystemTimezone,
    index: 0
  }];

  var i;
  for (i = 0; i < tokensLength; i++) {
    var token = tokens[i];
    var parser = localeParsers[token] || parsers[token];
    if (parser) {
      var matchResult;

      if (parser.match instanceof RegExp) {
        matchResult = parser.match.exec(dateString);
      } else {
        matchResult = parser.match(dateString, subFnOptions);
      }

      if (!matchResult) {
        return new Date(NaN)
      }

      var unitName = parser.unit;
      var unit = localeUnits[unitName] || units[unitName];

      setters.push({
        priority: unit.priority,
        set: unit.set,
        value: parser.parse(matchResult, subFnOptions),
        index: setters.length
      });

      var substring = matchResult[0];
      dateString = dateString.slice(substring.length);
    } else {
      var head = tokens[i].match(/^\[.*]$/) ? tokens[i].replace(/^\[|]$/g, '') : tokens[i];
      if (dateString.indexOf(head) === 0) {
        dateString = dateString.slice(head.length);
      } else {
        return new Date(NaN)
      }
    }
  }

  var uniquePrioritySetters = setters
    .map(function (setter) {
      return setter.priority
    })
    .sort(function (a, b) {
      return a - b
    })
    .filter(function (priority, index, array) {
      return array.indexOf(priority) === index
    })
    .map(function (priority) {
      return setters
        .filter(function (setter) {
          return setter.priority === priority
        })
        .reverse()
    })
    .map(function (setterArray) {
      return setterArray[0]
    });

  var date = toDate(dirtyBaseDate, options);

  if (isNaN(date)) {
    return new Date(NaN)
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
  var utcDate = subMinutes(date, date.getTimezoneOffset());

  var dateValues = {date: utcDate};

  var settersLength = uniquePrioritySetters.length;
  for (i = 0; i < settersLength; i++) {
    var setter = uniquePrioritySetters[i];
    dateValues = setter.set(dateValues, setter.value, subFnOptions);
  }

  return dateValues.date
}

function dateToSystemTimezone (dateValues) {
  var date = dateValues.date;
  var time = date.getTime();

  // Get the system timezone offset at (moment of time - offset)
  var offset = date.getTimezoneOffset();

  // Get the system timezone offset at the exact moment of time
  offset = new Date(time + offset * MILLISECONDS_IN_MINUTE$6).getTimezoneOffset();

  // Convert date in timezone "UTC+00:00" to the system timezone
  dateValues.date = new Date(time + offset * MILLISECONDS_IN_MINUTE$6);

  return dateValues
}

function cleanEscapedString$1 (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.

// 

/**
 * Custom parse behavior on top of date-fns parse function.
 */
function parseDate$1 (date, format$$1) {
  if (typeof date !== 'string') {
    return isValid(date) ? date : null;
  }

  var parsed = parse(date, format$$1, new Date());

  // if date is not valid or the formatted output after parsing does not match
  // the string value passed in (avoids overflows)
  if (!isValid(parsed) || format(parsed, format$$1) !== date) {
    return null;
  }

  return parsed;
}

var after = function (value, ref) {
  var otherValue = ref[0];
  var inclusion = ref[1];
  var format = ref[2];

  if (typeof format === 'undefined') {
    format = inclusion;
    inclusion = false;
  }
  value = parseDate$1(value, format);
  otherValue = parseDate$1(otherValue, format);

  // if either is not valid.
  if (!value || !otherValue) {
    return false;
  }

  return isAfter(value, otherValue) || (inclusion && isEqual$1(value, otherValue));
};

/**
 * Some Alpha Regex helpers.
 * https://github.com/chriso/validator.js/blob/master/src/lib/alpha.js
 */

var alpha$1 = {
  en: /^[A-Z]*$/i,
  cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
  da: /^[A-ZÆØÅ]*$/i,
  de: /^[A-ZÄÖÜß]*$/i,
  es: /^[A-ZÁÉÍÑÓÚÜ]*$/i,
  fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
  lt: /^[A-ZĄČĘĖĮŠŲŪŽ]*$/i,
  nl: /^[A-ZÉËÏÓÖÜ]*$/i,
  hu: /^[A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
  pl: /^[A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
  pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
  ru: /^[А-ЯЁ]*$/i,
  sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
  sr: /^[A-ZČĆŽŠĐ]*$/i,
  tr: /^[A-ZÇĞİıÖŞÜ]*$/i,
  uk: /^[А-ЩЬЮЯЄІЇҐ]*$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/
};

var alphaSpaces = {
  en: /^[A-Z\s]*$/i,
  cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ\s]*$/i,
  da: /^[A-ZÆØÅ\s]*$/i,
  de: /^[A-ZÄÖÜß\s]*$/i,
  es: /^[A-ZÁÉÍÑÓÚÜ\s]*$/i,
  fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ\s]*$/i,
  lt: /^[A-ZĄČĘĖĮŠŲŪŽ\s]*$/i,
  nl: /^[A-ZÉËÏÓÖÜ\s]*$/i,
  hu: /^[A-ZÁÉÍÓÖŐÚÜŰ\s]*$/i,
  pl: /^[A-ZĄĆĘŚŁŃÓŻŹ\s]*$/i,
  pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ\s]*$/i,
  ru: /^[А-ЯЁ\s]*$/i,
  sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ\s]*$/i,
  sr: /^[A-ZČĆŽŠĐ\s]*$/i,
  tr: /^[A-ZÇĞİıÖŞÜ\s]*$/i,
  uk: /^[А-ЩЬЮЯЄІЇҐ\s]*$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ\s]*$/
};

var alphanumeric = {
  en: /^[0-9A-Z]*$/i,
  cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
  da: /^[0-9A-ZÆØÅ]$/i,
  de: /^[0-9A-ZÄÖÜß]*$/i,
  es: /^[0-9A-ZÁÉÍÑÓÚÜ]*$/i,
  fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
  lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ]*$/i,
  hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
  nl: /^[0-9A-ZÉËÏÓÖÜ]*$/i,
  pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
  pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
  ru: /^[0-9А-ЯЁ]*$/i,
  sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
  sr: /^[0-9A-ZČĆŽŠĐ]*$/i,
  tr: /^[0-9A-ZÇĞİıÖŞÜ]*$/i,
  uk: /^[0-9А-ЩЬЮЯЄІЇҐ]*$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/
};

var alphaDash = {
  en: /^[0-9A-Z_-]*$/i,
  cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ_-]*$/i,
  da: /^[0-9A-ZÆØÅ_-]*$/i,
  de: /^[0-9A-ZÄÖÜß_-]*$/i,
  es: /^[0-9A-ZÁÉÍÑÓÚÜ_-]*$/i,
  fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ_-]*$/i,
  lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ_-]*$/i,
  nl: /^[0-9A-ZÉËÏÓÖÜ_-]*$/i,
  hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ_-]*$/i,
  pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ_-]*$/i,
  pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ_-]*$/i,
  ru: /^[0-9А-ЯЁ_-]*$/i,
  sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ_-]*$/i,
  sr: /^[0-9A-ZČĆŽŠĐ_-]*$/i,
  tr: /^[0-9A-ZÇĞİıÖŞÜ_-]*$/i,
  uk: /^[0-9А-ЩЬЮЯЄІЇҐ_-]*$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ_-]*$/
};

var validate = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var locale = ref[0]; if ( locale === void 0 ) locale = null;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alpha$1).some(function (loc) { return alpha$1[loc].test(value); });
  }

  return (alpha$1[locale] || alpha$1.en).test(value);
};

var validate$1 = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var locale = ref[0]; if ( locale === void 0 ) locale = null;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$1(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alphaDash).some(function (loc) { return alphaDash[loc].test(value); });
  }

  return (alphaDash[locale] || alphaDash.en).test(value);
};

var validate$2 = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var locale = ref[0]; if ( locale === void 0 ) locale = null;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$2(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alphanumeric).some(function (loc) { return alphanumeric[loc].test(value); });
  }

  return (alphanumeric[locale] || alphanumeric.en).test(value);
};

var validate$3 = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var locale = ref[0]; if ( locale === void 0 ) locale = null;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$3(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alphaSpaces).some(function (loc) { return alphaSpaces[loc].test(value); });
  }

  return (alphaSpaces[locale] || alphaSpaces.en).test(value);
};

var before = function (value, ref) {
  var otherValue = ref[0];
  var inclusion = ref[1];
  var format = ref[2];

  if (typeof format === 'undefined') {
    format = inclusion;
    inclusion = false;
  }
  value = parseDate$1(value, format);
  otherValue = parseDate$1(otherValue, format);

  // if either is not valid.
  if (!value || !otherValue) {
    return false;
  }

  return isBefore(value, otherValue) || (inclusion && isEqual$1(value, otherValue));
};

var validate$4 = function (value, ref) {
  var min = ref[0];
  var max = ref[1];

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$4(val, [min, max]); });
  }

  return Number(min) <= value && Number(max) >= value;
};

var confirmed = function (value, other) { return String(value) === String(other); };

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var assertString_1 = createCommonjsModule(function (module, exports) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;
function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    throw new TypeError('This library (validator.js) validates strings only');
  }
}
module.exports = exports['default'];
});

unwrapExports(assertString_1);

var isCreditCard_1 = createCommonjsModule(function (module, exports) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isCreditCard;



var _assertString2 = _interopRequireDefault(assertString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|62[0-9]{14})$/;
/* eslint-enable max-len */

function isCreditCard(str) {
  (0, _assertString2.default)(str);
  var sanitized = str.replace(/[- ]+/g, '');
  if (!creditCard.test(sanitized)) {
    return false;
  }
  var sum = 0;
  var digit = void 0;
  var tmpNum = void 0;
  var shouldDouble = void 0;
  for (var i = sanitized.length - 1; i >= 0; i--) {
    digit = sanitized.substring(i, i + 1);
    tmpNum = parseInt(digit, 10);
    if (shouldDouble) {
      tmpNum *= 2;
      if (tmpNum >= 10) {
        sum += tmpNum % 10 + 1;
      } else {
        sum += tmpNum;
      }
    } else {
      sum += tmpNum;
    }
    shouldDouble = !shouldDouble;
  }
  return !!(sum % 10 === 0 ? sanitized : false);
}
module.exports = exports['default'];
});

var isCreditCard = unwrapExports(isCreditCard_1);

var credit_card = function (value) { return isCreditCard(String(value)); };

var validate$5 = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var decimals = ref[0]; if ( decimals === void 0 ) decimals = '*';
  var separator = ref[1]; if ( separator === void 0 ) separator = '.';

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$5(val, [decimals, separator]); });
  }

  if (value === null || value === undefined || value === '') {
    return true;
  }

  // if is 0.
  if (Number(decimals) === 0) {
    return /^-?\d*$/.test(value);
  }

  var regexPart = decimals === '*' ? '+' : ("{1," + decimals + "}");
  var regex = new RegExp(("^-?\\d*(\\" + separator + "\\d" + regexPart + ")?$"));

  if (! regex.test(value)) {
    return false;
  }

  var parsedValue = parseFloat(value);

  // eslint-disable-next-line
    return parsedValue === parsedValue;
};

var date_between = function (value, params) {
  var min;
  var max;
  var format;
  var inclusivity = '()';

  if (params.length > 3) {
    var assign;
    (assign = params, min = assign[0], max = assign[1], inclusivity = assign[2], format = assign[3]);
  } else {
    var assign$1;
    (assign$1 = params, min = assign$1[0], max = assign$1[1], format = assign$1[2]);
  }

  var minDate = parseDate$1(String(min), format);
  var maxDate = parseDate$1(String(max), format);
  var dateVal = parseDate$1(String(value), format);

  if (!minDate || !maxDate || !dateVal) {
    return false;
  }

  if (inclusivity === '()') {
    return isAfter(dateVal, minDate) && isBefore(dateVal, maxDate);
  }

  if (inclusivity === '(]') {
    return isAfter(dateVal, minDate) && (isEqual$1(dateVal, maxDate) || isBefore(dateVal, maxDate));
  }

  if (inclusivity === '[)') {
    return isBefore(dateVal, maxDate) && (isEqual$1(dateVal, minDate) || isAfter(dateVal, minDate));
  }

  return isEqual$1(dateVal, maxDate) || isEqual$1(dateVal, minDate) ||
        (isBefore(dateVal, maxDate) && isAfter(dateVal, minDate));
};

var date_format = function (value, ref) {
  var format = ref[0];

  return !!parseDate$1(value, format);
};

var validate$6 = function (value, ref) {
  var length = ref[0];

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$6(val, [length]); });
  }
  var strVal = String(value);

  return /^[0-9]*$/.test(strVal) && strVal.length === Number(length);
};

var validateImage = function (file, width, height) {
  var URL = window.URL || window.webkitURL;
  return new Promise(function (resolve) {
    var image = new Image();
    image.onerror = function () { return resolve({ valid: false }); };
    image.onload = function () { return resolve({
      valid: image.width === Number(width) && image.height === Number(height)
    }); };

    image.src = URL.createObjectURL(file);
  });
};

var dimensions = function (files, ref) {
  var width = ref[0];
  var height = ref[1];

  var list = [];
  for (var i = 0; i < files.length; i++) {
    // if file is not an image, reject.
    if (! /\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(files[i].name)) {
      return false;
    }

    list.push(files[i]);
  }

  return Promise.all(list.map(function (file) { return validateImage(file, width, height); }));
};

var merge_1 = createCommonjsModule(function (module, exports) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;
function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments[1];

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }
  return obj;
}
module.exports = exports['default'];
});

unwrapExports(merge_1);

var isByteLength_1 = createCommonjsModule(function (module, exports) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isByteLength;



var _assertString2 = _interopRequireDefault(assertString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString2.default)(str);
  var min = void 0;
  var max = void 0;
  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }
  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = exports['default'];
});

unwrapExports(isByteLength_1);

var isFQDN = createCommonjsModule(function (module, exports) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFDQN;



var _assertString2 = _interopRequireDefault(assertString_1);



var _merge2 = _interopRequireDefault(merge_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false
};

function isFDQN(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_fqdn_options);

  /* Remove the optional trailing dot before checking validity */
  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }
  var parts = str.split('.');
  if (options.require_tld) {
    var tld = parts.pop();
    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    }
    // disallow spaces
    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
      return false;
    }
  }
  for (var part, i = 0; i < parts.length; i++) {
    part = parts[i];
    if (options.allow_underscores) {
      part = part.replace(/_/g, '');
    }
    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    }
    // disallow full-width chars
    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    }
    if (part[0] === '-' || part[part.length - 1] === '-') {
      return false;
    }
  }
  return true;
}
module.exports = exports['default'];
});

unwrapExports(isFQDN);

var isEmail_1 = createCommonjsModule(function (module, exports) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmail;



var _assertString2 = _interopRequireDefault(assertString_1);



var _merge2 = _interopRequireDefault(merge_1);



var _isByteLength2 = _interopRequireDefault(isByteLength_1);



var _isFQDN2 = _interopRequireDefault(isFQDN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true
};

/* eslint-disable max-len */
/* eslint-disable no-control-regex */
var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-enable max-len */
/* eslint-enable no-control-regex */

function isEmail(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(displayName);
    if (display_email) {
      str = display_email[1];
    } else if (options.require_display_name) {
      return false;
    }
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var user = parts.join('@');

  var lower_domain = domain.toLowerCase();
  if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
    user = user.replace(/\./g, '').toLowerCase();
  }

  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 254 })) {
    return false;
  }

  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
    return false;
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;

  var user_parts = user.split('.');
  for (var i = 0; i < user_parts.length; i++) {
    if (!pattern.test(user_parts[i])) {
      return false;
    }
  }

  return true;
}
module.exports = exports['default'];
});

var isEmail = unwrapExports(isEmail_1);

var validate$7 = function (value) {
  if (Array.isArray(value)) {
    return value.every(function (val) { return isEmail(String(val)); });
  }

  return isEmail(String(value));
};

var ext = function (files, extensions) {
  var regex = new RegExp((".(" + (extensions.join('|')) + ")$"), 'i');

  return files.every(function (file) { return regex.test(file.name); });
};

var image = function (files) { return files.every(function (file) { return /\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(file.name); }
); };

var validate$8 = function (value, options) {
  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$8(val, options); });
  }

  // eslint-disable-next-line
  return !! options.filter(function (option) { return option == value; }).length;
};

var isIP_1 = createCommonjsModule(function (module, exports) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isIP;



var _assertString2 = _interopRequireDefault(assertString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
var ipv6Block = /^[0-9A-F]{1,4}$/i;

function isIP(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  (0, _assertString2.default)(str);
  version = String(version);
  if (!version) {
    return isIP(str, 4) || isIP(str, 6);
  } else if (version === '4') {
    if (!ipv4Maybe.test(str)) {
      return false;
    }
    var parts = str.split('.').sort(function (a, b) {
      return a - b;
    });
    return parts[3] <= 255;
  } else if (version === '6') {
    var blocks = str.split(':');
    var foundOmissionBlock = false; // marker to indicate ::

    // At least some OS accept the last 32 bits of an IPv6 address
    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
    // and '::a.b.c.d' is deprecated, but also valid.
    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;

    if (blocks.length > expectedNumberOfBlocks) {
      return false;
    }
    // initial or final ::
    if (str === '::') {
      return true;
    } else if (str.substr(0, 2) === '::') {
      blocks.shift();
      blocks.shift();
      foundOmissionBlock = true;
    } else if (str.substr(str.length - 2) === '::') {
      blocks.pop();
      blocks.pop();
      foundOmissionBlock = true;
    }

    for (var i = 0; i < blocks.length; ++i) {
      // test for a :: which can not be at the string start/end
      // since those cases have been handled above
      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
        if (foundOmissionBlock) {
          return false; // multiple :: in address
        }
        foundOmissionBlock = true;
      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) {
        // it has been checked before that the last
        // block is a valid IPv4 address
      } else if (!ipv6Block.test(blocks[i])) {
        return false;
      }
    }
    if (foundOmissionBlock) {
      return blocks.length >= 1;
    }
    return blocks.length === expectedNumberOfBlocks;
  }
  return false;
}
module.exports = exports['default'];
});

var isIP = unwrapExports(isIP_1);

var ip = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var version = ref[0]; if ( version === void 0 ) version = 4;

  if (isNullOrUndefined(value)) {
    value = '';
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return isIP(val, version); });
  }

  return isIP(value, version);
};

var is = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var other = ref[0];

  return value === other;
};

var is_not = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var other = ref[0];

  return value !== other;
};

/**
 * @param {Array|String} value
 * @param {Number} length
 * @param {Number} max
 */
var compare = function (value, length, max) {
  if (max === undefined) {
    return value.length === length;
  }

  // cast to number.
  max = Number(max);

  return value.length >= length && value.length <= max;
};

var length = function (value, ref) {
  var length = ref[0];
  var max = ref[1]; if ( max === void 0 ) max = undefined;

  length = Number(length);
  if (value === undefined || value === null) {
    return false;
  }

  if (typeof value === 'number') {
    value = String(value);
  }

  if (!value.length) {
    value = toArray(value);
  }

  return compare(value, length, max);
};

var integer = function (value) {
  if (Array.isArray(value)) {
    return value.every(function (val) { return /^-?[0-9]+$/.test(String(val)); });
  }

  return /^-?[0-9]+$/.test(String(value));
};

var max$1 = function (value, ref) {
  var length = ref[0];

  if (value === undefined || value === null) {
    return length >= 0;
  }

  return String(value).length <= length;
};

var max_value = function (value, ref) {
  var max = ref[0];

  if (Array.isArray(value) || value === null || value === undefined || value === '') {
    return false;
  }

  return Number(value) <= max;
};

var mimes = function (files, mimes) {
  var regex = new RegExp(((mimes.join('|').replace('*', '.+')) + "$"), 'i');

  return files.every(function (file) { return regex.test(file.type); });
};

var min$1 = function (value, ref) {
  var length = ref[0];

  if (value === undefined || value === null) {
    return false;
  }
  return String(value).length >= length;
};

var min_value = function (value, ref) {
  var min = ref[0];

  if (Array.isArray(value) || value === null || value === undefined || value === '') {
    return false;
  }

  return Number(value) >= min;
};

var validate$9 = function (value, options) {
  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$9(val, options); });
  }

  // eslint-disable-next-line
  return ! options.filter(function (option) { return option == value; }).length;
};

var numeric = function (value) {
  if (Array.isArray(value)) {
    return value.every(function (val) { return /^[0-9]+$/.test(String(val)); });
  }

  return /^[0-9]+$/.test(String(value));
};

var regex = function (value, ref) {
  var regex = ref[0];
  var flags = ref.slice(1);

  if (regex instanceof RegExp) {
    return regex.test(value);
  }

  return new RegExp(regex, flags).test(String(value));
};

var required = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var invalidateFalse = ref[0]; if ( invalidateFalse === void 0 ) invalidateFalse = false;

  if (Array.isArray(value)) {
    return !! value.length;
  }

  // incase a field considers `false` as an empty value like checkboxes.
  if (value === false && invalidateFalse) {
    return false;
  }

  if (value === undefined || value === null) {
    return false;
  }

  return !! String(value).trim().length;
};

var size = function (files, ref) {
  var size = ref[0];

  if (isNaN(size)) {
    return false;
  }

  var nSize = Number(size) * 1024;
  for (var i = 0; i < files.length; i++) {
    if (files[i].size > nSize) {
      return false;
    }
  }

  return true;
};

var isURL_1 = createCommonjsModule(function (module, exports) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isURL;



var _assertString2 = _interopRequireDefault(assertString_1);



var _isFQDN2 = _interopRequireDefault(isFQDN);



var _isIP2 = _interopRequireDefault(isIP_1);



var _merge2 = _interopRequireDefault(merge_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_url_options = {
  protocols: ['http', 'https', 'ftp'],
  require_tld: true,
  require_protocol: false,
  require_host: true,
  require_valid_protocol: true,
  allow_underscores: false,
  allow_trailing_dot: false,
  allow_protocol_relative_urls: false
};

var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;

function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
}

function checkHost(host, matches) {
  for (var i = 0; i < matches.length; i++) {
    var match = matches[i];
    if (host === match || isRegExp(match) && match.test(host)) {
      return true;
    }
  }
  return false;
}

function isURL(url, options) {
  (0, _assertString2.default)(url);
  if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
    return false;
  }
  if (url.indexOf('mailto:') === 0) {
    return false;
  }
  options = (0, _merge2.default)(options, default_url_options);
  var protocol = void 0,
      auth = void 0,
      host = void 0,
      hostname = void 0,
      port = void 0,
      port_str = void 0,
      split = void 0,
      ipv6 = void 0;

  split = url.split('#');
  url = split.shift();

  split = url.split('?');
  url = split.shift();

  split = url.split('://');
  if (split.length > 1) {
    protocol = split.shift();
    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
      return false;
    }
  } else if (options.require_protocol) {
    return false;
  } else if (options.allow_protocol_relative_urls && url.substr(0, 2) === '//') {
    split[0] = url.substr(2);
  }
  url = split.join('://');

  if (url === '') {
    return false;
  }

  split = url.split('/');
  url = split.shift();

  if (url === '' && !options.require_host) {
    return true;
  }

  split = url.split('@');
  if (split.length > 1) {
    auth = split.shift();
    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
      return false;
    }
  }
  hostname = split.join('@');

  port_str = null;
  ipv6 = null;
  var ipv6_match = hostname.match(wrapped_ipv6);
  if (ipv6_match) {
    host = '';
    ipv6 = ipv6_match[1];
    port_str = ipv6_match[2] || null;
  } else {
    split = hostname.split(':');
    host = split.shift();
    if (split.length) {
      port_str = split.join(':');
    }
  }

  if (port_str !== null) {
    port = parseInt(port_str, 10);
    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
      return false;
    }
  }

  if (!(0, _isIP2.default)(host) && !(0, _isFQDN2.default)(host, options) && (!ipv6 || !(0, _isIP2.default)(ipv6, 6))) {
    return false;
  }

  host = host || ipv6;

  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
    return false;
  }
  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
    return false;
  }

  return true;
}
module.exports = exports['default'];
});

var isURL = unwrapExports(isURL_1);

var url = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var requireProtocol = ref[0]; if ( requireProtocol === void 0 ) requireProtocol = false;

  var options = { require_protocol: !!requireProtocol, allow_underscores: true };
  if (isNullOrUndefined(value)) {
    value = '';
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return isURL(val, options); });
  }

  return isURL(value, options);
};

/* eslint-disable camelcase */
var Rules = {
  after: after,
  alpha_dash: validate$1,
  alpha_num: validate$2,
  alpha_spaces: validate$3,
  alpha: validate,
  before: before,
  between: validate$4,
  confirmed: confirmed,
  credit_card: credit_card,
  date_between: date_between,
  date_format: date_format,
  decimal: validate$5,
  digits: validate$6,
  dimensions: dimensions,
  email: validate$7,
  ext: ext,
  image: image,
  in: validate$8,
  integer: integer,
  length: length,
  ip: ip,
  is_not: is_not,
  is: is,
  max: max$1,
  max_value: max_value,
  mimes: mimes,
  min: min$1,
  min_value: min_value,
  not_in: validate$9,
  numeric: numeric,
  regex: regex,
  required: required,
  size: size,
  url: url
};

// 

var normalize = function (fields) {
  if (Array.isArray(fields)) {
    return fields.reduce(function (prev, curr) {
      if (~curr.indexOf('.')) {
        prev[curr.split('.')[1]] = curr;
      } else {
        prev[curr] = curr;
      }

      return prev;
    }, {});
  }

  return fields;
};

// Combines two flags using either AND or OR depending on the flag type.
var combine = function (lhs, rhs) {
  var mapper = {
    pristine: function (lhs, rhs) { return lhs && rhs; },
    dirty: function (lhs, rhs) { return lhs || rhs; },
    touched: function (lhs, rhs) { return lhs || rhs; },
    untouched: function (lhs, rhs) { return lhs && rhs; },
    valid: function (lhs, rhs) { return lhs && rhs; },
    invalid: function (lhs, rhs) { return lhs || rhs; },
    pending: function (lhs, rhs) { return lhs || rhs; },
    required: function (lhs, rhs) { return lhs || rhs; },
    validated: function (lhs, rhs) { return lhs && rhs; }
  };

  return Object.keys(mapper).reduce(function (flags, flag) {
    flags[flag] = mapper[flag](lhs[flag], rhs[flag]);

    return flags;
  }, {});
};

var mapScope = function (scope, deep) {
  if ( deep === void 0 ) deep = true;

  return Object.keys(scope).reduce(function (flags, field) {
    if (!flags) {
      flags = assign({}, scope[field]);
      return flags;
    }

    // scope.
    var isScope = field.indexOf('$') === 0;
    if (deep && isScope) {
      return combine(mapScope(scope[field]), flags);
    } else if (!deep && isScope) {
      return flags;
    }

    flags = combine(flags, scope[field]);

    return flags;
  }, null);
};

/**
 * Maps fields to computed functions.
 */
var mapFields = function (fields) {
  if (!fields) {
    return function () {
      return mapScope(this.$validator.flags);
    };
  }

  var normalized = normalize(fields);
  return Object.keys(normalized).reduce(function (prev, curr) {
    var field = normalized[curr];
    prev[curr] = function mappedField () {
      // if field exists
      if (this.$validator.flags[field]) {
        return this.$validator.flags[field];
      }

      // scopeless fields were selected.
      if (normalized[curr] === '*') {
        return mapScope(this.$validator.flags, false);
      }

      // if it has a scope defined
      var index = field.indexOf('.');
      if (index <= 0) {
        return {};
      }

      var ref = field.split('.');
      var scope = ref[0];
      var name = ref.slice(1);

      scope = this.$validator.flags[("$" + scope)];
      name = name.join('.');

      // an entire scope was selected: scope.*
      if (name === '*' && scope) {
        return mapScope(scope);
      }

      if (scope && scope[name]) {
        return scope[name];
      }

      return {};
    };

    return prev;
  }, {});
};

var version = '2.0.3';

var rulesPlugin = function (ref) {
  var Validator$$1 = ref.Validator;

  Object.keys(Rules).forEach(function (rule) {
    Validator$$1.extend(rule, Rules[rule]);
  });

  // Merge the english messages.
  Validator$$1.localize('en', locale);
};

use(rulesPlugin);

var index_esm = {
  install: install,
  use: use,
  directive: directive,
  mixin: mixin,
  mapFields: mapFields,
  Validator: Validator,
  ErrorBag: ErrorBag,
  Rules: Rules,
  version: version
};


/* harmony default export */ __webpack_exports__["b"] = (index_esm);


/***/ }),

/***/ "sVZL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var pivotColumnsPanel_1 = __webpack_require__("dbIj");
var PivotCompFactory = (function () {
    function PivotCompFactory() {
    }
    PivotCompFactory.prototype.create = function () {
        var pivotComp = new pivotColumnsPanel_1.PivotColumnsPanel(true);
        this.context.wireBean(pivotComp);
        return pivotComp;
    };
    __decorate([
        main_1.Autowired('context'),
        __metadata("design:type", main_1.Context)
    ], PivotCompFactory.prototype, "context", void 0);
    PivotCompFactory = __decorate([
        main_1.Bean('pivotCompFactory')
    ], PivotCompFactory);
    return PivotCompFactory;
}());
exports.PivotCompFactory = PivotCompFactory;


/***/ }),

/***/ "sWXg":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(990);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 971:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("cmba");

/***/ }),

/***/ 990:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(971) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($) {

	    // Imports ================================================================
	    var kendo = window.kendo,
	        editorNS = kendo.ui.editor,
	        Command = editorNS.Command,
	        GenericCommand = editorNS.GenericCommand,
	        EditorUtils = editorNS.EditorUtils,
	        registerTool = EditorUtils.registerTool,
	        Tool = editorNS.Tool,
	        ToolTemplate = editorNS.ToolTemplate,
	        RestorePoint = editorNS.RestorePoint,
	        extend = $.extend;

	var InsertHtmlCommand = Command.extend({
	    init: function(options) {
	        Command.fn.init.call(this, options);

	        this.managesUndoRedo = true;
	    },

	    exec: function() {
	        var editor = this.editor;
	        var options = this.options;
	        var range = options.range;
	        var body = editor.body;
	        var startRestorePoint = new RestorePoint(range, body);
	        var html = options.html || options.value || '';

	        editor.selectRange(range);

	        editor.clipboard.paste(html, options);

	        if (options.postProcess) {
	            options.postProcess(editor, editor.getRange());
	        }

	        var genericCommand = new GenericCommand(startRestorePoint, new RestorePoint(editor.getRange(), body));
	        genericCommand.editor = editor;
	        editor.undoRedoStack.push(genericCommand);

	        editor.focus();
	    }
	});

	var InsertHtmlTool = Tool.extend({
	    initialize: function(ui, initOptions) {
	        var editor = initOptions.editor,
	            options = this.options,
	            dataSource = options.items ? options.items : editor.options.insertHtml;

	        this._selectBox = new editorNS.SelectBox(ui, {
	            dataSource: dataSource,
	            dataTextField: "text",
	            dataValueField: "value",
	            change: function () {
	                Tool.exec(editor, 'insertHtml', this.value());
	            },
	            title: editor.options.messages.insertHtml,
	            highlightFirst: false
	        });

	        ui.attr("title", initOptions.title);
	        this._selectBox.wrapper.attr("title", initOptions.title);
	    },

	    command: function (commandArguments) {
	        return new InsertHtmlCommand(commandArguments);
	    },

	    update: function(ui) {
	        var selectbox = ui.data("kendoSelectBox") || ui.find("select").data("kendoSelectBox");
	        selectbox.close();
	        selectbox.value(selectbox.options.title);
	    }
	});

	extend(editorNS, {
	    InsertHtmlCommand: InsertHtmlCommand,
	    InsertHtmlTool: InsertHtmlTool
	});

	registerTool("insertHtml", new InsertHtmlTool({template: new ToolTemplate({template: EditorUtils.dropDownListTemplate, title: "Insert HTML", initialValue: "Insert HTML"})}));

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "sYFB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var expressionService_1 = __webpack_require__("1aUC");
var eventService_1 = __webpack_require__("k5uU");
var constants_1 = __webpack_require__("ZZFX");
var utils_1 = __webpack_require__("IRr6");
var context_1 = __webpack_require__("RQ1/");
var component_1 = __webpack_require__("pQ38");
var rowNode_1 = __webpack_require__("bP2e");
var cellRendererService_1 = __webpack_require__("sr48");
var valueFormatterService_1 = __webpack_require__("vFc7");
var checkboxSelectionComponent_1 = __webpack_require__("B21I");
var columnController_1 = __webpack_require__("77lH");
var column_1 = __webpack_require__("hDyE");
var componentAnnotations_1 = __webpack_require__("x5ih");
var mouseEventService_1 = __webpack_require__("BY3/");
var GroupCellRenderer = (function (_super) {
    __extends(GroupCellRenderer, _super);
    function GroupCellRenderer() {
        return _super.call(this, GroupCellRenderer.TEMPLATE) || this;
    }
    GroupCellRenderer.prototype.init = function (params) {
        this.params = params;
        var embeddedRowMismatch = this.isEmbeddedRowMismatch();
        // This allows for empty strings to appear as groups since
        // it will only return for null or undefined.
        var cellIsEmpty = params.value == null;
        this.cellIsBlank = embeddedRowMismatch || cellIsEmpty;
        if (this.cellIsBlank) {
            return;
        }
        this.setupDragOpenParents();
        this.addExpandAndContract();
        this.addCheckboxIfNeeded();
        this.addValueElement();
        this.setupIndent();
    };
    // if we are doing embedded full width rows, we only show the renderer when
    // in the body, or if pinning in the pinned section, or if pinning and RTL,
    // in the right section. otherwise we would have the cell repeated in each section.
    GroupCellRenderer.prototype.isEmbeddedRowMismatch = function () {
        if (this.params.fullWidth && this.gridOptionsWrapper.isEmbedFullWidthRows()) {
            var pinnedLeftCell = this.params.pinned === column_1.Column.PINNED_LEFT;
            var pinnedRightCell = this.params.pinned === column_1.Column.PINNED_RIGHT;
            var bodyCell = !pinnedLeftCell && !pinnedRightCell;
            if (this.gridOptionsWrapper.isEnableRtl()) {
                if (this.columnController.isPinningLeft()) {
                    return !pinnedRightCell;
                }
                else {
                    return !bodyCell;
                }
            }
            else {
                if (this.columnController.isPinningLeft()) {
                    return !pinnedLeftCell;
                }
                else {
                    return !bodyCell;
                }
            }
        }
        else {
            return false;
        }
    };
    GroupCellRenderer.prototype.setIndent = function () {
        if (this.gridOptionsWrapper.isGroupHideOpenParents()) {
            return;
        }
        var params = this.params;
        var rowNode = params.node;
        // let paddingPx: number;
        var paddingCount = rowNode.uiLevel;
        var pivotModeAndLeafGroup = this.columnController.isPivotMode() && params.node.leafGroup;
        var notExpandable = !rowNode.isExpandable();
        if (rowNode.footer || notExpandable || pivotModeAndLeafGroup) {
            paddingCount += 1;
        }
        var userProvidedPaddingPixelsTheDeprecatedWay = params.padding >= 0;
        if (userProvidedPaddingPixelsTheDeprecatedWay) {
            this.setPaddingDeprecatedWay(paddingCount, params.padding);
            return;
        }
        if (this.indentClass) {
            this.removeCssClass(this.indentClass);
        }
        this.indentClass = 'ag-row-group-indent-' + paddingCount;
        this.addCssClass(this.indentClass);
    };
    GroupCellRenderer.prototype.setPaddingDeprecatedWay = function (paddingCount, padding) {
        utils_1.Utils.doOnce(function () { return console.warn('ag-Grid: since v14.2, configuring padding for groupCellRenderer should be done with Sass variables and themes. Please see the ag-Grid documentation page for Themes, in particular the property $row-group-indent-size.'); }, 'groupCellRenderer->doDeprecatedWay');
        var paddingPx = paddingCount * padding;
        if (this.gridOptionsWrapper.isEnableRtl()) {
            // if doing rtl, padding is on the right
            this.getGui().style.paddingRight = paddingPx + 'px';
        }
        else {
            // otherwise it is on the left
            this.getGui().style.paddingLeft = paddingPx + 'px';
        }
    };
    GroupCellRenderer.prototype.setupIndent = function () {
        // only do this if an indent - as this overwrites the padding that
        // the theme set, which will make things look 'not aligned' for the
        // first group level.
        var node = this.params.node;
        var suppressPadding = this.params.suppressPadding;
        if (!suppressPadding) {
            this.addDestroyableEventListener(node, rowNode_1.RowNode.EVENT_UI_LEVEL_CHANGED, this.setIndent.bind(this));
            this.setIndent();
        }
    };
    GroupCellRenderer.prototype.addValueElement = function () {
        var params = this.params;
        var rowNode = this.displayedGroup;
        if (rowNode.footer) {
            this.createFooterCell();
        }
        else if (rowNode.hasChildren() ||
            utils_1.Utils.get(params.colDef, 'cellRendererParams.innerRenderer', null) ||
            utils_1.Utils.get(params.colDef, 'cellRendererParams.innerRendererFramework', null)) {
            this.createGroupCell();
            if (rowNode.hasChildren()) {
                this.addChildCount();
            }
        }
        else {
            this.createLeafCell();
        }
    };
    GroupCellRenderer.prototype.createFooterCell = function () {
        var footerValue;
        var footerValueGetter = this.params.footerValueGetter;
        if (footerValueGetter) {
            // params is same as we were given, except we set the value as the item to display
            var paramsClone = utils_1.Utils.cloneObject(this.params);
            paramsClone.value = this.params.value;
            if (typeof footerValueGetter === 'function') {
                footerValue = footerValueGetter(paramsClone);
            }
            else if (typeof footerValueGetter === 'string') {
                footerValue = this.expressionService.evaluate(footerValueGetter, paramsClone);
            }
            else {
                console.warn('ag-Grid: footerValueGetter should be either a function or a string (expression)');
            }
        }
        else {
            footerValue = 'Total ' + this.params.value;
        }
        this.eValue.innerHTML = footerValue;
    };
    GroupCellRenderer.prototype.createGroupCell = function () {
        var params = this.params;
        var rowGroupColumn = this.displayedGroup.rowGroupColumn;
        // we try and use the cellRenderer of the column used for the grouping if we can
        var columnToUse = rowGroupColumn ? rowGroupColumn : params.column;
        var groupName = this.params.value;
        var valueFormatted = columnToUse ?
            this.valueFormatterService.formatValue(columnToUse, params.node, params.scope, groupName) : null;
        params.valueFormatted = valueFormatted;
        if (params.fullWidth == true) {
            this.cellRendererService.useFullWidthGroupRowInnerCellRenderer(this.eValue, params);
        }
        else {
            this.cellRendererService.useInnerCellRenderer(this.params.colDef.cellRendererParams, columnToUse.getColDef(), this.eValue, params);
        }
    };
    GroupCellRenderer.prototype.addChildCount = function () {
        // only include the child count if it's included, eg if user doing custom aggregation,
        // then this could be left out, or set to -1, ie no child count
        if (this.params.suppressCount) {
            return;
        }
        this.addDestroyableEventListener(this.displayedGroup, rowNode_1.RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED, this.updateChildCount.bind(this));
        // filtering changes the child count, so need to cater for it
        this.updateChildCount();
    };
    GroupCellRenderer.prototype.updateChildCount = function () {
        var allChildrenCount = this.displayedGroup.allChildrenCount;
        this.eChildCount.innerHTML = allChildrenCount >= 0 ? "(" + allChildrenCount + ")" : "";
    };
    GroupCellRenderer.prototype.createLeafCell = function () {
        if (utils_1.Utils.exists(this.params.value)) {
            this.eValue.innerHTML = this.params.valueFormatted ? this.params.valueFormatted : this.params.value;
        }
    };
    GroupCellRenderer.prototype.isUserWantsSelected = function () {
        var paramsCheckbox = this.params.checkbox;
        if (typeof paramsCheckbox === 'function') {
            return paramsCheckbox(this.params);
        }
        else {
            return paramsCheckbox === true;
        }
    };
    GroupCellRenderer.prototype.addCheckboxIfNeeded = function () {
        var rowNode = this.params.node;
        var checkboxNeeded = this.isUserWantsSelected()
            && !rowNode.footer
            && !rowNode.rowPinned
            && !rowNode.detail;
        if (checkboxNeeded) {
            var cbSelectionComponent_1 = new checkboxSelectionComponent_1.CheckboxSelectionComponent();
            this.context.wireBean(cbSelectionComponent_1);
            cbSelectionComponent_1.init({ rowNode: rowNode, column: this.params.column });
            this.eCheckbox.appendChild(cbSelectionComponent_1.getGui());
            this.addDestroyFunc(function () { return cbSelectionComponent_1.destroy(); });
        }
    };
    GroupCellRenderer.prototype.addExpandAndContract = function () {
        var params = this.params;
        var eGroupCell = params.eGridCell;
        var eExpandedIcon = utils_1.Utils.createIconNoSpan('groupExpanded', this.gridOptionsWrapper, null);
        var eContractedIcon = utils_1.Utils.createIconNoSpan('groupContracted', this.gridOptionsWrapper, null);
        this.eExpanded.appendChild(eExpandedIcon);
        this.eContracted.appendChild(eContractedIcon);
        this.addDestroyableEventListener(this.eExpanded, 'click', this.onExpandClicked.bind(this));
        this.addDestroyableEventListener(this.eContracted, 'click', this.onExpandClicked.bind(this));
        // expand / contract as the user hits enter
        this.addDestroyableEventListener(eGroupCell, 'keydown', this.onKeyDown.bind(this));
        this.addDestroyableEventListener(params.node, rowNode_1.RowNode.EVENT_EXPANDED_CHANGED, this.showExpandAndContractIcons.bind(this));
        this.showExpandAndContractIcons();
        // because we don't show the expand / contract when there are no children, we need to check every time
        // the number of children change.
        this.addDestroyableEventListener(this.displayedGroup, rowNode_1.RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED, this.onAllChildrenCountChanged.bind(this));
        // if editing groups, then double click is to start editing
        if (!this.gridOptionsWrapper.isEnableGroupEdit() && this.isExpandable()) {
            this.addDestroyableEventListener(eGroupCell, 'dblclick', this.onCellDblClicked.bind(this));
        }
    };
    GroupCellRenderer.prototype.onAllChildrenCountChanged = function () {
        // maybe if no children now, we should hide the expand / contract icons
        this.showExpandAndContractIcons();
        // if we have no children, this impacts the indent
        this.setIndent();
    };
    GroupCellRenderer.prototype.onKeyDown = function (event) {
        if (utils_1.Utils.isKeyPressed(event, constants_1.Constants.KEY_ENTER)) {
            var cellEditable = this.params.column.isCellEditable(this.params.node);
            if (cellEditable) {
                return;
            }
            event.preventDefault();
            this.onExpandOrContract();
        }
    };
    GroupCellRenderer.prototype.setupDragOpenParents = function () {
        var column = this.params.column;
        var rowNode = this.params.node;
        if (!this.gridOptionsWrapper.isGroupHideOpenParents()) {
            this.draggedFromHideOpenParents = false;
        }
        else if (!rowNode.hasChildren()) {
            // if we are here, and we are not a group, then we must of been dragged down,
            // as otherwise the cell would be blank, and if cell is blank, this method is never called.
            this.draggedFromHideOpenParents = true;
        }
        else {
            var rowGroupColumn = rowNode.rowGroupColumn;
            // if the displayGroup column for this col matches the rowGroupColumn we grouped by for this node,
            // then nothing was dragged down
            this.draggedFromHideOpenParents = !column.isRowGroupDisplayed(rowGroupColumn.getId());
        }
        if (this.draggedFromHideOpenParents) {
            var pointer = rowNode.parent;
            while (true) {
                if (utils_1.Utils.missing(pointer)) {
                    break;
                }
                if (pointer.rowGroupColumn && column.isRowGroupDisplayed(pointer.rowGroupColumn.getId())) {
                    this.displayedGroup = pointer;
                    break;
                }
                pointer = pointer.parent;
            }
        }
        // if we didn't find a displayed group, set it to the row node
        if (utils_1.Utils.missing(this.displayedGroup)) {
            this.displayedGroup = rowNode;
        }
    };
    GroupCellRenderer.prototype.onExpandClicked = function (mouseEvent) {
        if (utils_1.Utils.isStopPropagationForAgGrid(mouseEvent)) {
            return;
        }
        this.onExpandOrContract();
    };
    GroupCellRenderer.prototype.onCellDblClicked = function (mouseEvent) {
        if (utils_1.Utils.isStopPropagationForAgGrid(mouseEvent)) {
            return;
        }
        // we want to avoid acting on double click events on the expand / contract icon,
        // as that icons already has expand / collapse functionality on it. otherwise if
        // the icon was double clicked, we would get 'click', 'click', 'dblclick' which
        // is open->close->open, however double click should be open->close only.
        var targetIsExpandIcon = utils_1.Utils.isElementInEventPath(this.eExpanded, mouseEvent)
            || utils_1.Utils.isElementInEventPath(this.eContracted, mouseEvent);
        if (!targetIsExpandIcon) {
            this.onExpandOrContract();
        }
    };
    GroupCellRenderer.prototype.onExpandOrContract = function () {
        // must use the displayedGroup, so if data was dragged down, we expand the parent, not this row
        var rowNode = this.displayedGroup;
        rowNode.setExpanded(!rowNode.expanded);
        if (this.gridOptionsWrapper.isGroupIncludeFooter()) {
            this.params.api.redrawRows({ rowNodes: [rowNode] });
        }
    };
    GroupCellRenderer.prototype.isExpandable = function () {
        var rowNode = this.params.node;
        var reducedLeafNode = this.columnController.isPivotMode() && rowNode.leafGroup;
        return this.draggedFromHideOpenParents ||
            (rowNode.isExpandable() && !rowNode.footer && !reducedLeafNode);
    };
    GroupCellRenderer.prototype.showExpandAndContractIcons = function () {
        var rowNode = this.params.node;
        if (this.isExpandable()) {
            // if expandable, show one based on expand state.
            // if we were dragged down, means our parent is always expanded
            var expanded = this.draggedFromHideOpenParents ? true : rowNode.expanded;
            utils_1.Utils.setVisible(this.eContracted, !expanded);
            utils_1.Utils.setVisible(this.eExpanded, expanded);
        }
        else {
            // it not expandable, show neither
            utils_1.Utils.setVisible(this.eExpanded, false);
            utils_1.Utils.setVisible(this.eContracted, false);
        }
    };
    GroupCellRenderer.prototype.refresh = function () {
        return false;
    };
    GroupCellRenderer.TEMPLATE = '<span>' +
        '<span class="ag-group-expanded" ref="eExpanded"></span>' +
        '<span class="ag-group-contracted" ref="eContracted"></span>' +
        '<span class="ag-group-checkbox" ref="eCheckbox"></span>' +
        '<span class="ag-group-value" ref="eValue"></span>' +
        '<span class="ag-group-child-count" ref="eChildCount"></span>' +
        '</span>';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], GroupCellRenderer.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('expressionService'),
        __metadata("design:type", expressionService_1.ExpressionService)
    ], GroupCellRenderer.prototype, "expressionService", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], GroupCellRenderer.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('cellRendererService'),
        __metadata("design:type", cellRendererService_1.CellRendererService)
    ], GroupCellRenderer.prototype, "cellRendererService", void 0);
    __decorate([
        context_1.Autowired('valueFormatterService'),
        __metadata("design:type", valueFormatterService_1.ValueFormatterService)
    ], GroupCellRenderer.prototype, "valueFormatterService", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], GroupCellRenderer.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], GroupCellRenderer.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('mouseEventService'),
        __metadata("design:type", mouseEventService_1.MouseEventService)
    ], GroupCellRenderer.prototype, "mouseEventService", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('eExpanded'),
        __metadata("design:type", HTMLElement)
    ], GroupCellRenderer.prototype, "eExpanded", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('eContracted'),
        __metadata("design:type", HTMLElement)
    ], GroupCellRenderer.prototype, "eContracted", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('eCheckbox'),
        __metadata("design:type", HTMLElement)
    ], GroupCellRenderer.prototype, "eCheckbox", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('eValue'),
        __metadata("design:type", HTMLElement)
    ], GroupCellRenderer.prototype, "eValue", void 0);
    __decorate([
        componentAnnotations_1.RefSelector('eChildCount'),
        __metadata("design:type", HTMLElement)
    ], GroupCellRenderer.prototype, "eChildCount", void 0);
    return GroupCellRenderer;
}(component_1.Component));
exports.GroupCellRenderer = GroupCellRenderer;


/***/ }),

/***/ "sc2Y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var beanStub_1 = __webpack_require__("xffp");
var rowNodeBlock_1 = __webpack_require__("8wuL");
var RowNodeCache = (function (_super) {
    __extends(RowNodeCache, _super);
    function RowNodeCache(cacheParams) {
        var _this = _super.call(this) || this;
        _this.maxRowFound = false;
        _this.blocks = {};
        _this.blockCount = 0;
        _this.virtualRowCount = cacheParams.initialRowCount;
        _this.cacheParams = cacheParams;
        return _this;
    }
    RowNodeCache.prototype.destroy = function () {
        var _this = this;
        _super.prototype.destroy.call(this);
        this.forEachBlockInOrder(function (block) { return _this.destroyBlock(block); });
    };
    RowNodeCache.prototype.init = function () {
        var _this = this;
        this.active = true;
        this.addDestroyFunc(function () { return _this.active = false; });
    };
    RowNodeCache.prototype.isActive = function () {
        return this.active;
    };
    RowNodeCache.prototype.getVirtualRowCount = function () {
        return this.virtualRowCount;
    };
    RowNodeCache.prototype.hack_setVirtualRowCount = function (virtualRowCount) {
        this.virtualRowCount = virtualRowCount;
    };
    RowNodeCache.prototype.isMaxRowFound = function () {
        return this.maxRowFound;
    };
    // listener on EVENT_LOAD_COMPLETE
    RowNodeCache.prototype.onPageLoaded = function (event) {
        this.cacheParams.rowNodeBlockLoader.loadComplete();
        this.checkBlockToLoad();
        // if we are not active, then we ignore all events, otherwise we could end up getting the
        // grid to refresh even though we are no longer the active cache
        if (!this.isActive()) {
            return;
        }
        this.logger.log("onPageLoaded: page = " + event.page.getBlockNumber() + ", lastRow = " + event.lastRow);
        if (event.success) {
            this.checkVirtualRowCount(event.page, event.lastRow);
        }
    };
    RowNodeCache.prototype.purgeBlocksIfNeeded = function (blockToExclude) {
        var _this = this;
        // no purge if user didn't give maxBlocksInCache
        if (utils_1.Utils.missing(this.cacheParams.maxBlocksInCache)) {
            return;
        }
        // no purge if block count is less than max allowed
        if (this.blockCount <= this.cacheParams.maxBlocksInCache) {
            return;
        }
        // put all candidate blocks into a list for sorting
        var blocksForPurging = [];
        this.forEachBlockInOrder(function (block) {
            // we exclude checking for the page just created, as this has yet to be accessed and hence
            // the lastAccessed stamp will not be updated for the first time yet
            if (block === blockToExclude) {
                return;
            }
            blocksForPurging.push(block);
        });
        // todo: need to verify that this sorts items in the right order
        blocksForPurging.sort(function (a, b) { return b.getLastAccessed() - a.getLastAccessed(); });
        // we remove (maxBlocksInCache - 1) as we already excluded the 'just created' page.
        // in other words, after the splice operation below, we have taken out the blocks
        // we want to keep, which means we are left with blocks that we can potentially purge
        var blocksToKeep = this.cacheParams.maxBlocksInCache - 1;
        blocksForPurging.splice(0, blocksToKeep);
        // try and purge each block
        blocksForPurging.forEach(function (block) {
            // we never purge blocks if they are open, as purging them would mess up with
            // our indexes, it would be very messy to restore the purged block to it's
            // previous state if it had open children (and what if open children of open
            // children, jeeeesus, just thinking about it freaks me out) so best is have a
            // rule, if block is open, we never purge.
            if (block.isAnyNodeOpen(_this.virtualRowCount)) {
                return;
            }
            // at this point, block is not needed, and no open nodes, so burn baby burn
            _this.removeBlockFromCache(block);
        });
    };
    RowNodeCache.prototype.postCreateBlock = function (newBlock) {
        newBlock.addEventListener(rowNodeBlock_1.RowNodeBlock.EVENT_LOAD_COMPLETE, this.onPageLoaded.bind(this));
        this.setBlock(newBlock.getBlockNumber(), newBlock);
        this.purgeBlocksIfNeeded(newBlock);
        this.checkBlockToLoad();
    };
    RowNodeCache.prototype.removeBlockFromCache = function (blockToRemove) {
        if (!blockToRemove) {
            return;
        }
        this.destroyBlock(blockToRemove);
        // we do not want to remove the 'loaded' event listener, as the
        // concurrent loads count needs to be updated when the load is complete
        // if the purged page is in loading state
    };
    // gets called after: 1) block loaded 2) block created 3) cache refresh
    RowNodeCache.prototype.checkBlockToLoad = function () {
        this.cacheParams.rowNodeBlockLoader.checkBlockToLoad();
    };
    RowNodeCache.prototype.checkVirtualRowCount = function (block, lastRow) {
        // if client provided a last row, we always use it, as it could change between server calls
        // if user deleted data and then called refresh on the grid.
        if (typeof lastRow === 'number' && lastRow >= 0) {
            this.virtualRowCount = lastRow;
            this.maxRowFound = true;
            this.onCacheUpdated();
        }
        else if (!this.maxRowFound) {
            // otherwise, see if we need to add some virtual rows
            var lastRowIndex = (block.getBlockNumber() + 1) * this.cacheParams.blockSize;
            var lastRowIndexPlusOverflow = lastRowIndex + this.cacheParams.overflowSize;
            if (this.virtualRowCount < lastRowIndexPlusOverflow) {
                this.virtualRowCount = lastRowIndexPlusOverflow;
                this.onCacheUpdated();
            }
            else if (this.cacheParams.dynamicRowHeight) {
                // the only other time is if dynamic row height, as loading rows
                // will change the height of the block, given the height of the rows
                // is only known after the row is loaded.
                this.onCacheUpdated();
            }
        }
    };
    RowNodeCache.prototype.setVirtualRowCount = function (rowCount, maxRowFound) {
        this.virtualRowCount = rowCount;
        // if undefined is passed, we do not set this value, if one of {true,false}
        // is passed, we do set the value.
        if (utils_1.Utils.exists(maxRowFound)) {
            this.maxRowFound = maxRowFound;
        }
        // if we are still searching, then the row count must not end at the end
        // of a particular page, otherwise the searching will not pop into the
        // next page
        if (!this.maxRowFound) {
            if (this.virtualRowCount % this.cacheParams.blockSize === 0) {
                this.virtualRowCount++;
            }
        }
        this.onCacheUpdated();
    };
    RowNodeCache.prototype.forEachNodeDeep = function (callback, sequence) {
        var _this = this;
        this.forEachBlockInOrder(function (block) {
            block.forEachNodeDeep(callback, sequence, _this.virtualRowCount);
        });
    };
    RowNodeCache.prototype.forEachBlockInOrder = function (callback) {
        var ids = this.getBlockIdsSorted();
        this.forEachBlockId(ids, callback);
    };
    RowNodeCache.prototype.forEachBlockInReverseOrder = function (callback) {
        var ids = this.getBlockIdsSorted().reverse();
        this.forEachBlockId(ids, callback);
    };
    RowNodeCache.prototype.forEachBlockId = function (ids, callback) {
        var _this = this;
        ids.forEach(function (id) {
            var block = _this.blocks[id];
            callback(block, id);
        });
    };
    RowNodeCache.prototype.getBlockIdsSorted = function () {
        // get all page id's as NUMBERS (not strings, as we need to sort as numbers) and in descending order
        var numberComparator = function (a, b) { return a - b; }; // default comparator for array is string comparison
        var blockIds = Object.keys(this.blocks).map(function (idStr) { return parseInt(idStr); }).sort(numberComparator);
        return blockIds;
    };
    RowNodeCache.prototype.getBlock = function (blockId) {
        return this.blocks[blockId];
    };
    RowNodeCache.prototype.setBlock = function (id, block) {
        this.blocks[id] = block;
        this.blockCount++;
        this.cacheParams.rowNodeBlockLoader.addBlock(block);
    };
    RowNodeCache.prototype.destroyBlock = function (block) {
        delete this.blocks[block.getBlockNumber()];
        block.destroy();
        this.blockCount--;
        this.cacheParams.rowNodeBlockLoader.removeBlock(block);
    };
    // gets called 1) row count changed 2) cache purged 3) items inserted
    RowNodeCache.prototype.onCacheUpdated = function () {
        if (this.isActive()) {
            // this results in both row models (infinite and enterprise) firing ModelUpdated,
            // however enterprise also updates the row indexes first
            var event_1 = {
                type: RowNodeCache.EVENT_CACHE_UPDATED
            };
            this.dispatchEvent(event_1);
        }
    };
    RowNodeCache.prototype.purgeCache = function () {
        var _this = this;
        this.forEachBlockInOrder(function (block) { return _this.removeBlockFromCache(block); });
        this.onCacheUpdated();
    };
    RowNodeCache.prototype.getRowNodesInRange = function (firstInRange, lastInRange) {
        var _this = this;
        var result = [];
        var lastBlockId = -1;
        var inActiveRange = false;
        var numberSequence = new utils_1.NumberSequence();
        // if only one node passed, we start the selection at the top
        if (utils_1.Utils.missing(firstInRange)) {
            inActiveRange = true;
        }
        var foundGapInSelection = false;
        this.forEachBlockInOrder(function (block, id) {
            if (foundGapInSelection)
                return;
            if (inActiveRange && (lastBlockId + 1 !== id)) {
                foundGapInSelection = true;
                return;
            }
            lastBlockId = id;
            block.forEachNodeShallow(function (rowNode) {
                var hitFirstOrLast = rowNode === firstInRange || rowNode === lastInRange;
                if (inActiveRange || hitFirstOrLast) {
                    result.push(rowNode);
                }
                if (hitFirstOrLast) {
                    inActiveRange = !inActiveRange;
                }
            }, numberSequence, _this.virtualRowCount);
        });
        // inActiveRange will be still true if we never hit the second rowNode
        var invalidRange = foundGapInSelection || inActiveRange;
        return invalidRange ? [] : result;
    };
    RowNodeCache.EVENT_CACHE_UPDATED = 'cacheUpdated';
    return RowNodeCache;
}(beanStub_1.BeanStub));
exports.RowNodeCache = RowNodeCache;


/***/ }),

/***/ "spGI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ag_grid_1 = __webpack_require__("F6Mk");
var enterpriseCache_1 = __webpack_require__("HykO");
var EnterpriseRowModel = (function (_super) {
    __extends(EnterpriseRowModel, _super);
    function EnterpriseRowModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EnterpriseRowModel.prototype.postConstruct = function () {
        this.rowHeight = this.gridOptionsWrapper.getRowHeightAsNumber();
        this.addEventListeners();
        var datasource = this.gridOptionsWrapper.getEnterpriseDatasource();
        if (ag_grid_1._.exists(datasource)) {
            this.setDatasource(datasource);
        }
    };
    EnterpriseRowModel.prototype.setBeans = function (loggerFactory) {
        this.logger = loggerFactory.create('EnterpriseRowModel');
    };
    EnterpriseRowModel.prototype.isLastRowFound = function () {
        if (ag_grid_1._.exists(this.rootNode) && ag_grid_1._.exists(this.rootNode.childrenCache)) {
            return this.rootNode.childrenCache.isMaxRowFound();
        }
        else {
            return false;
        }
    };
    EnterpriseRowModel.prototype.addEventListeners = function () {
        this.addDestroyableEventListener(this.eventService, ag_grid_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onColumnRowGroupChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, ag_grid_1.Events.EVENT_ROW_GROUP_OPENED, this.onRowGroupOpened.bind(this));
        this.addDestroyableEventListener(this.eventService, ag_grid_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onPivotModeChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, ag_grid_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.onColumnEverything.bind(this));
        this.addDestroyableEventListener(this.eventService, ag_grid_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.onValueChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, ag_grid_1.Events.EVENT_COLUMN_PIVOT_CHANGED, this.onColumnPivotChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, ag_grid_1.Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, ag_grid_1.Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
    };
    EnterpriseRowModel.prototype.onColumnEverything = function () {
        this.reset();
    };
    EnterpriseRowModel.prototype.onFilterChanged = function () {
        this.reset();
    };
    EnterpriseRowModel.prototype.onSortChanged = function () {
        this.reset();
    };
    EnterpriseRowModel.prototype.onValueChanged = function () {
        this.reset();
    };
    EnterpriseRowModel.prototype.onColumnRowGroupChanged = function () {
        this.reset();
    };
    EnterpriseRowModel.prototype.onColumnPivotChanged = function () {
        this.reset();
    };
    EnterpriseRowModel.prototype.onPivotModeChanged = function () {
        this.reset();
    };
    EnterpriseRowModel.prototype.onRowGroupOpened = function (event) {
        var rowNode = event.node;
        if (rowNode.expanded) {
            if (ag_grid_1._.missing(rowNode.childrenCache)) {
                this.createNodeCache(rowNode);
            }
        }
        else {
            if (this.gridOptionsWrapper.isPurgeClosedRowNodes() && ag_grid_1._.exists(rowNode.childrenCache)) {
                rowNode.childrenCache.destroy();
                rowNode.childrenCache = null;
            }
        }
        this.updateRowIndexesAndBounds();
        var modelUpdatedEvent = {
            type: ag_grid_1.Events.EVENT_MODEL_UPDATED,
            api: this.gridOptionsWrapper.getApi(),
            columnApi: this.gridOptionsWrapper.getColumnApi(),
            newPage: false,
            newData: false,
            animate: true,
            keepRenderedRows: true
        };
        this.eventService.dispatchEvent(modelUpdatedEvent);
    };
    EnterpriseRowModel.prototype.reset = function () {
        this.rootNode = new ag_grid_1.RowNode();
        this.rootNode.group = true;
        this.rootNode.level = -1;
        this.context.wireBean(this.rootNode);
        if (this.datasource) {
            this.createNewRowNodeBlockLoader();
            this.cacheParams = this.createCacheParams();
            this.createNodeCache(this.rootNode);
            this.updateRowIndexesAndBounds();
        }
        // this event: 1) clears selection 2) updates filters 3) shows/hides 'no rows' overlay
        var rowDataChangedEvent = {
            type: ag_grid_1.Events.EVENT_ROW_DATA_CHANGED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(rowDataChangedEvent);
        // this gets the row to render rows (or remove the previously rendered rows, as it's blank to start).
        // important to NOT pass in an event with keepRenderedRows or animate, as we want the renderer
        // to treat the rows as new rows, as it's all new data
        var modelUpdatedEvent = {
            type: ag_grid_1.Events.EVENT_MODEL_UPDATED,
            api: this.gridApi,
            columnApi: this.columnApi,
            animate: false,
            keepRenderedRows: false,
            newData: false,
            newPage: false
        };
        this.eventService.dispatchEvent(modelUpdatedEvent);
    };
    EnterpriseRowModel.prototype.createNewRowNodeBlockLoader = function () {
        this.destroyRowNodeBlockLoader();
        var maxConcurrentRequests = this.gridOptionsWrapper.getMaxConcurrentDatasourceRequests();
        this.rowNodeBlockLoader = new ag_grid_1.RowNodeBlockLoader(maxConcurrentRequests);
        this.context.wireBean(this.rowNodeBlockLoader);
    };
    EnterpriseRowModel.prototype.destroyRowNodeBlockLoader = function () {
        if (this.rowNodeBlockLoader) {
            this.rowNodeBlockLoader.destroy();
            this.rowNodeBlockLoader = null;
        }
    };
    EnterpriseRowModel.prototype.setDatasource = function (datasource) {
        this.datasource = datasource;
        this.reset();
    };
    EnterpriseRowModel.prototype.toValueObjects = function (columns) {
        var _this = this;
        return columns.map(function (col) { return ({
            id: col.getId(),
            aggFunc: col.getAggFunc(),
            displayName: _this.columnController.getDisplayNameForColumn(col, 'model'),
            field: col.getColDef().field
        }); });
    };
    EnterpriseRowModel.prototype.createCacheParams = function () {
        var rowGroupColumnVos = this.toValueObjects(this.columnController.getRowGroupColumns());
        var valueColumnVos = this.toValueObjects(this.columnController.getValueColumns());
        var pivotColumnVos = this.toValueObjects(this.columnController.getPivotColumns());
        var dynamicRowHeight = this.gridOptionsWrapper.isDynamicRowHeight();
        var maxBlocksInCache = this.gridOptionsWrapper.getMaxBlocksInCache();
        if (dynamicRowHeight && maxBlocksInCache >= 0) {
            console.warn('ag-Grid: Enterprise Row Model does not support Dynamic Row Height and Cache Purging. ' +
                'Either a) remove getRowHeight() callback or b) remove maxBlocksInCache property. Purging has been disabled.');
            maxBlocksInCache = undefined;
        }
        var params = {
            // the columns the user has grouped and aggregated by
            valueCols: valueColumnVos,
            rowGroupCols: rowGroupColumnVos,
            pivotCols: pivotColumnVos,
            pivotMode: this.columnController.isPivotMode(),
            // sort and filter model
            filterModel: this.filterManager.getFilterModel(),
            sortModel: this.sortController.getSortModel(),
            rowNodeBlockLoader: this.rowNodeBlockLoader,
            datasource: this.datasource,
            lastAccessedSequence: new ag_grid_1.NumberSequence(),
            overflowSize: 1,
            initialRowCount: 1,
            maxConcurrentRequests: this.gridOptionsWrapper.getMaxConcurrentDatasourceRequests(),
            maxBlocksInCache: maxBlocksInCache,
            blockSize: this.gridOptionsWrapper.getCacheBlockSize(),
            rowHeight: this.rowHeight,
            dynamicRowHeight: dynamicRowHeight
        };
        // set defaults
        if (!(params.maxConcurrentRequests >= 1)) {
            params.maxConcurrentRequests = 2;
        }
        // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
        // server for one page at a time. so the default if not specified is 100.
        if (!(params.blockSize >= 1)) {
            params.blockSize = 100;
        }
        // if user doesn't give initial rows to display, we assume zero
        if (!(params.initialRowCount >= 1)) {
            params.initialRowCount = 0;
        }
        // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
        // the current page and request first row of next page
        if (!(params.overflowSize >= 1)) {
            params.overflowSize = 1;
        }
        return params;
    };
    EnterpriseRowModel.prototype.createNodeCache = function (rowNode) {
        var cache = new enterpriseCache_1.EnterpriseCache(this.cacheParams, rowNode);
        this.context.wireBean(cache);
        cache.addEventListener(ag_grid_1.RowNodeCache.EVENT_CACHE_UPDATED, this.onCacheUpdated.bind(this));
        rowNode.childrenCache = cache;
    };
    EnterpriseRowModel.prototype.onCacheUpdated = function () {
        this.updateRowIndexesAndBounds();
        var modelUpdatedEvent = {
            type: ag_grid_1.Events.EVENT_MODEL_UPDATED,
            api: this.gridApi,
            columnApi: this.columnApi,
            animate: true,
            keepRenderedRows: true,
            newPage: false,
            newData: false
        };
        this.eventService.dispatchEvent(modelUpdatedEvent);
    };
    EnterpriseRowModel.prototype.updateRowIndexesAndBounds = function () {
        var cacheExists = ag_grid_1._.exists(this.rootNode) && ag_grid_1._.exists(this.rootNode.childrenCache);
        if (cacheExists) {
            // todo: should not be casting here, the RowModel should use IEnterpriseRowModel interface?
            var enterpriseCache = this.rootNode.childrenCache;
            this.resetRowTops(enterpriseCache);
            this.setDisplayIndexes(enterpriseCache);
        }
    };
    EnterpriseRowModel.prototype.setDisplayIndexes = function (cache) {
        var numberSequence = new ag_grid_1.NumberSequence();
        var nextRowTop = { value: 0 };
        cache.setDisplayIndexes(numberSequence, nextRowTop);
    };
    // resetting row tops is needed for animation, as part of the operation is saving the old location,
    // which is needed for rows that are transitioning in
    EnterpriseRowModel.prototype.resetRowTops = function (cache) {
        var numberSequence = new ag_grid_1.NumberSequence();
        cache.forEachNodeDeep(function (rowNode) { return rowNode.clearRowTop(); }, numberSequence);
    };
    EnterpriseRowModel.prototype.getRow = function (index) {
        var cacheExists = ag_grid_1._.exists(this.rootNode) && ag_grid_1._.exists(this.rootNode.childrenCache);
        if (cacheExists) {
            return this.rootNode.childrenCache.getRow(index);
        }
        else {
            return null;
        }
    };
    EnterpriseRowModel.prototype.getPageFirstRow = function () {
        return 0;
    };
    EnterpriseRowModel.prototype.getPageLastRow = function () {
        var cacheExists = ag_grid_1._.exists(this.rootNode) && ag_grid_1._.exists(this.rootNode.childrenCache);
        var lastRow;
        if (cacheExists) {
            // todo: should not be casting here, the RowModel should use IEnterpriseRowModel interface?
            var enterpriseCache = this.rootNode.childrenCache;
            lastRow = enterpriseCache.getDisplayIndexEnd() - 1;
        }
        else {
            lastRow = 0;
        }
        // this doesn't make sense, but it works, if there are now rows, then -1 is returned above
        if (lastRow < 0) {
            lastRow = 0;
        }
        return lastRow;
    };
    EnterpriseRowModel.prototype.getRowCount = function () {
        return this.getPageLastRow() + 1;
    };
    EnterpriseRowModel.prototype.getRowBounds = function (index) {
        var cacheMissing = ag_grid_1._.missing(this.rootNode) || ag_grid_1._.missing(this.rootNode.childrenCache);
        if (cacheMissing) {
            return {
                rowTop: 0,
                rowHeight: this.rowHeight
            };
        }
        var enterpriseCache = this.rootNode.childrenCache;
        return enterpriseCache.getRowBounds(index);
    };
    EnterpriseRowModel.prototype.getRowIndexAtPixel = function (pixel) {
        if (pixel === 0)
            return 0;
        var cacheMissing = ag_grid_1._.missing(this.rootNode) || ag_grid_1._.missing(this.rootNode.childrenCache);
        if (cacheMissing)
            return 0;
        var enterpriseCache = this.rootNode.childrenCache;
        var result = enterpriseCache.getRowIndexAtPixel(pixel);
        return result;
    };
    EnterpriseRowModel.prototype.getCurrentPageHeight = function () {
        var pageHeight = this.rowHeight * this.getRowCount();
        return pageHeight;
    };
    EnterpriseRowModel.prototype.isEmpty = function () {
        return false;
    };
    EnterpriseRowModel.prototype.isRowsToRender = function () {
        return this.getRowCount() > 0;
    };
    EnterpriseRowModel.prototype.getType = function () {
        return ag_grid_1.Constants.ROW_MODEL_TYPE_ENTERPRISE;
    };
    EnterpriseRowModel.prototype.forEachNode = function (callback) {
        if (this.rootNode && this.rootNode.childrenCache) {
            this.rootNode.childrenCache.forEachNodeDeep(callback, new ag_grid_1.NumberSequence());
        }
    };
    EnterpriseRowModel.prototype.purgeCache = function (route) {
        if (route === void 0) { route = []; }
        if (this.rootNode && this.rootNode.childrenCache) {
            var topLevelCache = this.rootNode.childrenCache;
            var cacheToPurge = topLevelCache.getChildCache(route);
            if (cacheToPurge) {
                cacheToPurge.purgeCache();
            }
        }
    };
    EnterpriseRowModel.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
        if (ag_grid_1._.exists(firstInRange) && firstInRange.parent !== lastInRange.parent)
            return [];
        return lastInRange.parent.childrenCache.getRowNodesInRange(firstInRange, lastInRange);
    };
    EnterpriseRowModel.prototype.getBlockState = function () {
        if (this.rowNodeBlockLoader) {
            return this.rowNodeBlockLoader.getBlockState();
        }
        else {
            return null;
        }
    };
    EnterpriseRowModel.prototype.isRowPresent = function (rowNode) {
        return false;
    };
    __decorate([
        ag_grid_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", ag_grid_1.GridOptionsWrapper)
    ], EnterpriseRowModel.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        ag_grid_1.Autowired('eventService'),
        __metadata("design:type", ag_grid_1.EventService)
    ], EnterpriseRowModel.prototype, "eventService", void 0);
    __decorate([
        ag_grid_1.Autowired('context'),
        __metadata("design:type", ag_grid_1.Context)
    ], EnterpriseRowModel.prototype, "context", void 0);
    __decorate([
        ag_grid_1.Autowired('columnController'),
        __metadata("design:type", ag_grid_1.ColumnController)
    ], EnterpriseRowModel.prototype, "columnController", void 0);
    __decorate([
        ag_grid_1.Autowired('filterManager'),
        __metadata("design:type", ag_grid_1.FilterManager)
    ], EnterpriseRowModel.prototype, "filterManager", void 0);
    __decorate([
        ag_grid_1.Autowired('sortController'),
        __metadata("design:type", ag_grid_1.SortController)
    ], EnterpriseRowModel.prototype, "sortController", void 0);
    __decorate([
        ag_grid_1.Autowired('gridApi'),
        __metadata("design:type", ag_grid_1.GridApi)
    ], EnterpriseRowModel.prototype, "gridApi", void 0);
    __decorate([
        ag_grid_1.Autowired('columnApi'),
        __metadata("design:type", ag_grid_1.ColumnApi)
    ], EnterpriseRowModel.prototype, "columnApi", void 0);
    __decorate([
        ag_grid_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], EnterpriseRowModel.prototype, "postConstruct", null);
    __decorate([
        __param(0, ag_grid_1.Qualifier('loggerFactory')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ag_grid_1.LoggerFactory]),
        __metadata("design:returntype", void 0)
    ], EnterpriseRowModel.prototype, "setBeans", null);
    EnterpriseRowModel = __decorate([
        ag_grid_1.Bean('rowModel')
    ], EnterpriseRowModel);
    return EnterpriseRowModel;
}(ag_grid_1.BeanStub));
exports.EnterpriseRowModel = EnterpriseRowModel;


/***/ }),

/***/ "sr48":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var componentRecipes_1 = __webpack_require__("EOXx");
var componentResolver_1 = __webpack_require__("migL");
var utils_1 = __webpack_require__("IRr6");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
/** Class to use a cellRenderer. */
var CellRendererService = (function () {
    function CellRendererService() {
    }
    CellRendererService.prototype.useCellRenderer = function (target, eTarget, params) {
        var _this = this;
        var cellRendererPromise = this.componentRecipes.newCellRenderer(target, params);
        if (cellRendererPromise != null) {
            cellRendererPromise.then(function (cellRenderer) {
                if (cellRenderer == null) {
                    eTarget.innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
                }
                else {
                    _this.bindToHtml(cellRendererPromise, eTarget);
                }
            });
        }
        else {
            eTarget.innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
        }
        return cellRendererPromise;
    };
    CellRendererService.prototype.useFilterCellRenderer = function (target, eTarget, params) {
        var cellRendererPromise = this.componentRecipes.newCellRenderer(target.filterParams, params);
        if (cellRendererPromise != null) {
            this.bindToHtml(cellRendererPromise, eTarget);
        }
        else {
            if (params.valueFormatted == null && params.value == null) {
                var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
                eTarget.innerText = '(' + localeTextFunc('blanks', 'Blanks') + ')';
            }
            else {
                eTarget.innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
            }
        }
        return cellRendererPromise;
    };
    CellRendererService.prototype.useRichSelectCellRenderer = function (target, eTarget, params) {
        var cellRendererPromise = this.componentRecipes.newCellRenderer(target.cellEditorParams, params);
        if (cellRendererPromise != null) {
            this.bindToHtml(cellRendererPromise, eTarget);
        }
        else {
            eTarget.innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
        }
        return cellRendererPromise;
    };
    CellRendererService.prototype.useInnerCellRenderer = function (target, originalColumn, eTarget, params) {
        var _this = this;
        var rendererToUsePromise = null;
        var componentToUse = this.componentResolver.getComponentToUse(target, "innerRenderer", null);
        if (componentToUse && componentToUse.component != null && componentToUse.source != componentResolver_1.ComponentSource.DEFAULT) {
            //THERE IS ONE INNER CELL RENDERER HARDCODED IN THE COLDEF FOR THIS GROUP COLUMN
            rendererToUsePromise = this.componentRecipes.newInnerCellRenderer(target, params);
        }
        else {
            var otherRenderer = this.componentResolver.getComponentToUse(originalColumn, "cellRenderer", null);
            if (otherRenderer && otherRenderer.source != componentResolver_1.ComponentSource.DEFAULT) {
                //Only if the original column is using an specific renderer, it it is a using a DEFAULT one
                //ignore it
                //THIS COMES FROM A COLUMN WHICH HAS BEEN GROUPED DYNAMICALLY, WE REUSE ITS RENDERER
                rendererToUsePromise = this.componentRecipes.newCellRenderer(originalColumn, params);
            }
            else if (otherRenderer && otherRenderer.source == componentResolver_1.ComponentSource.DEFAULT && (utils_1._.get(originalColumn, 'cellRendererParams.innerRenderer', null))) {
                //EDGE CASE - THIS COMES FROM A COLUMN WHICH HAS BEEN GROUPED DYNAMICALLY, THAT HAS AS RENDERER 'group'
                //AND HAS A INNER CELL RENDERER
                rendererToUsePromise = this.componentRecipes.newInnerCellRenderer(originalColumn.cellRendererParams, params);
            }
            else {
                //This forces the retrieval of the default plain cellRenderer that just renders the values.
                rendererToUsePromise = this.componentRecipes.newCellRenderer({}, params);
            }
        }
        if (rendererToUsePromise != null) {
            rendererToUsePromise.then(function (rendererToUse) {
                if (rendererToUse == null) {
                    eTarget.innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
                    return;
                }
                _this.bindToHtml(rendererToUsePromise, eTarget);
            });
        }
        else {
            eTarget.innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
        }
        return rendererToUsePromise;
    };
    CellRendererService.prototype.useFullWidthGroupRowInnerCellRenderer = function (eTarget, params) {
        var cellRendererPromise = this.componentRecipes.newFullWidthGroupRowInnerCellRenderer(params);
        if (cellRendererPromise != null) {
            this.bindToHtml(cellRendererPromise, eTarget);
        }
        else {
            eTarget.innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
        }
        return cellRendererPromise;
    };
    CellRendererService.prototype.bindToHtml = function (cellRendererPromise, eTarget) {
        cellRendererPromise.then(function (cellRenderer) {
            var gui = cellRenderer.getGui();
            if (gui != null) {
                if (typeof gui == 'object') {
                    eTarget.appendChild(gui);
                }
                else {
                    eTarget.innerHTML = gui;
                }
            }
        });
        return cellRendererPromise;
    };
    __decorate([
        context_1.Autowired('componentRecipes'),
        __metadata("design:type", componentRecipes_1.ComponentRecipes)
    ], CellRendererService.prototype, "componentRecipes", void 0);
    __decorate([
        context_1.Autowired('componentResolver'),
        __metadata("design:type", componentResolver_1.ComponentResolver)
    ], CellRendererService.prototype, "componentResolver", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], CellRendererService.prototype, "gridOptionsWrapper", void 0);
    CellRendererService = __decorate([
        context_1.Bean('cellRendererService')
    ], CellRendererService);
    return CellRendererService;
}());
exports.CellRendererService = CellRendererService;


/***/ }),

/***/ "synp":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1242);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1242:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1243)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "filter",
	    name: "Filter",
	    category: "web",
	    depends: [ "core", "buttongroup"]
	};

	var editors = {
	    "number": "<input type='text' title='#=field#' data-#=ns#role='numerictextbox' data-#=ns#bind='value: value'/>",
	    "string": "<input type='text' title='#=field#' class='k-textbox' data-#=ns#bind='value: value'/>",
	    "boolean": "<input class='k-checkbox' data-role='checkbox' data-#=ns#bind='checked: value' type='checkbox'>",
	    "date": "<input type='text' title='#=field#' data-#=ns#role='datepicker' data-#=ns#bind='value: value'/>"
	};

	var operatorsTemplate =
	    "<select data-#=ns#bind='value: operator' title='#=operatorsLabel#' data-#=ns#role='dropdownlist'>" +
	        "#for(var op in operators){#"+
	            "<option value='#=op#'>#=operators[op].text || operators[op]#</option>" +
	        "#}#" +
	    "</select>";

	var logicTemplate =
	    "<div data-#=ns#bind='value: logic' data-#=ns#role='filterbuttongroup'>" +
	        "#for(var op in operators){#"+
	            "<span value='#=op#'>#=operators[op]#</span>" +
	        "#}#" +
	    "</div>";

	var mainContainer =
	    "<ul class='k-filter-container'>" +
	        "<li class='k-filter-group-main'></li>" +
	    "</ul>";

	var mainLogicTemplate =
	    "<div class='k-filter-toolbar'>" +
	        "<div class='k-toolbar' id='#=uid#'>" +
	            "<div class='k-filter-toolbar-item'>" +
	                logicTemplate +
	            "</div>" +
	            "<div class='k-filter-toolbar-item'>" +
	                "<button data-role='button' class='k-button k-button-icon' role='button' aria-disabled='false' title='#=addExpression#' aria-label='#=addExpression#' tabindex='0'>" +
	                    "<span class='k-icon k-i-filter-add-expression'>" +
	                    "</span>" +
	                "</button>" +
	            "</div>" +
	            "<div class='k-filter-toolbar-item'>" +
	                "<button data-role='button' class='k-button k-button-icon' role='button' aria-disabled='false' title='#=addGroup#' aria-label='#=addGroup#' tabindex='0'>" +
	                    "<span class='k-icon k-i-filter-add-group'>" +
	                    "</span>" +
	                "</button>" +
	            "</div>" +
	            "<div class='k-filter-toolbar-item'>" +
	                "<button data-role='button' class='k-button-flat k-button k-button-icon' role='button' title='#=close#' aria-label='#=close#' aria-disabled='false' tabindex='0'>" +
	                    "<span class='k-icon k-i-close'>" +
	                    "</span>" +
	                "</button>" +
	            "</div>" +
	        "</div>" +
	    "</div>" ;

	var logicItemTemplate =
	"<li class='k-filter-item'>" +
	    "<div class='k-filter-toolbar'>" +
	        "<div class='k-toolbar'>" +
	            "<div class='k-filter-toolbar-item'>" +
	                logicTemplate +
	            "</div>" +
	            "<div class='k-filter-toolbar-item'>" +
	                "<button data-role='button' class='k-button k-button-icon' role='button' title='#=addExpression#' aria-label='#=addExpression#' aria-disabled='false' tabindex='0'>" +
	                    "<span class='k-icon k-i-filter-add-expression'>" +
	                    "</span>" +
	                "</button>" +
	            "</div>" +
	            "<div class='k-filter-toolbar-item'>" +
	                "<button data-role='button' class='k-button k-button-icon' role='button' title='#=addGroup#' aria-label='#=addGroup#' aria-disabled='false' tabindex='0'>" +
	                    "<span class='k-icon k-i-filter-add-group'>" +
	                    "</span>" +
	                "</button>" +
	            "</div>" +
	            "<div class='k-filter-toolbar-item'>" +
	                "<button data-role='button' class='k-button-flat k-button k-button-icon' role='button' title='#=close#' aria-label='#=close#' aria-disabled='false' tabindex='0'>" +
	                    "<span class='k-icon k-i-close'>" +
	                    "</span>" +
	                "</button>" +
	            "</div>" +
	        "</div>" +
	    "</div>" +
	"</li>";

	var expressionItemTemplate =
	"<li class='k-filter-item'>" +
	    "<div class='k-filter-toolbar'>" +
	       "<div class='k-toolbar' id='#=uid#'>" +
	         "<div class='k-filter-toolbar-item k-filter-field'>" +
	            "<select data-#=ns#bind='value: field' title='#=fieldsLabel#' class='k-filter-dropdown' data-auto-width='true' data-#=ns#role='dropdownlist'>" +
	                "#for(var current in fields){#" +
	                    "<option value='#=fields[current].name#'>#=fields[current].label#</option>" +
	                "#}#" +
	            "</select>" +
	         "</div>" +
	         "<div class='k-filter-toolbar-item k-filter-operator'>" +
	         "</div>" +
	         "<div class='k-filter-toolbar-item k-filter-value'>" +
	         "</div>" +
	         "<div class='k-filter-toolbar-item'>" +
	            "<button data-role='button' class='k-button-flat k-button k-button-icon' role='button' title='#=close#' aria-label='#=close#' aria-disabled='false' tabindex='0'>" +
	                "<span class='k-icon k-i-close'>" +
	                "</span>" +
	            "</button>" +
	         "</div>" +
	       "</div>" +
	    "</div>"+
	"</li>";


	(function($) {
	    var kendo = window.kendo,
	        ui = kendo.ui,
	        Widget = ui.Widget,
	        ButtonGroup = ui.ButtonGroup,
	        CHANGE = "change",
	        NS = ".kendoFilter",
	        EQ = "Is equal to",
	        NEQ = "Is not equal to",
	        proxy = $.proxy;

	    var FilterButtonGroup = ButtonGroup.extend({
	        init: function(element, options) {
	            var that = this;
	            ButtonGroup.fn.init.call(that, element, options);
	        },

	        options: {
	            name: "FilterButtonGroup"
	        },

	        value: function (value) {
	            if (value === undefined) {
	                return this._value;
	            }
	            this._value = value;
	            ButtonGroup.fn.select.call(this, this.wrapper.find("[value='" + value + "']")[0]);
	            this.trigger(CHANGE);
	        },

	        select: function (button) {
	            if (button !== -1) {
	                this.value($(button).attr("value"));
	            }
	        }
	    });

	    var Filter = Widget.extend( {
	        init: function(element, options) {
	            var that = this;
	            var html;

	            Widget.fn.init.call(that, element, options);

	            that.element = $(element).addClass("k-widget k-filter");
	            that.dataSource = options.dataSource;
	            that.operators = $.extend(that.options.operators, options.operators);

	            that._getFieldsInfo();
	            that._modelChangeHandler = proxy(that._modelChange, that);
	            that._renderMain();
	            if (options.expression) {
	                that._addExpressionTree(that.filterModel);
	            }
	            that._renderApplyButton();
	            if (that.options.expressionPreview) {
	                if (!that._previewContainer) {
	                    that._previewContainer = $('<div class="k-filter-preview"></div>').insertAfter(that.element.children().eq(0));
	                }
	                html = that._createPreview(that.filterModel.toJSON());
	                that._previewContainer.html(html);
	            }
	            that._attachEvents();
	            that.hasCustomOperators();
	        },

	        events: [
	            CHANGE
	        ],

	        options: {
	            name: "Filter",
	            dataSource: null,
	            expression: null,
	            applyButton: false,
	            fields: [],
	            mainLogic: "and",
	            messages: {
	                and: "And",
	                or: "Or",
	                apply: "Apply",
	                close: "Close",
	                addExpression: "Add Expression",
	                fields: "Fields",
	                operators: "Operators",
	                addGroup: "Add Group"
	            },
	            operators: {
	                string: {
	                    eq: EQ,
	                    neq: NEQ,
	                    startswith: "Starts with",
	                    contains: "Contains",
	                    doesnotcontain: "Does not contain",
	                    endswith: "Ends with",
	                    isnull: "Is null",
	                    isnotnull: "Is not null",
	                    isempty: "Is empty",
	                    isnotempty: "Is not empty",
	                    isnullorempty: "Has no value",
	                    isnotnullorempty: "Has value"
	                },
	                number: {
	                    eq: EQ,
	                    neq: NEQ,
	                    gte: "Is greater than or equal to",
	                    gt: "Is greater than",
	                    lte: "Is less than or equal to",
	                    lt: "Is less than",
	                    isnull: "Is null",
	                    isnotnull: "Is not null"
	                },
	                date: {
	                    eq: EQ,
	                    neq: NEQ,
	                    gte: "Is after or equal to",
	                    gt: "Is after",
	                    lte: "Is before or equal to",
	                    lt: "Is before",
	                    isnull: "Is null",
	                    isnotnull: "Is not null"
	                },
	                "boolean": {
	                    eq: EQ,
	                    neq: NEQ
	                }
	            }
	        },

	        applyFilter: function () {
	            var filter = this.filterModel.toJSON();

	            if(this._hasCustomOperators){
	                this._mapOperators(filter);
	            }
	            if (this._hasFieldsFilter(filter.filters || [])) {
	                this._removeEmptyGroups(filter.filters);
	                this.dataSource.filter(filter);
	            } else {
	                this.dataSource.filter({});
	            }
	        },

	        destroy: function() {
	            this.element.off(NS);
	            kendo.destroy(this.element.find(".k-filter-group-main"));
	            this._previewContainer = null;
	            this._applyButton = null;
	            this._modelChangeHandler = null;
	            Widget.fn.destroy.call(this);
	        },

	        setOptions: function(options) {
	            kendo.deepExtend(this.options, options);
	            this.destroy();
	            this.element.empty();
	            this.init(this.element, this.options);
	        },

	        getOptions: function() {
	            var result = $.extend(true, {}, this.options);
	            delete result.dataSource;
	            result.expression = this.filterModel.toJSON();

	            return result;
	        },

	        _addExpressionTree: function (model) {
	            if (model.filters) {
	                var parent = this.element.find("[id=" + model.uid + "]");
	                for (var i = 0; i < model.filters.length; i++) {
	                    if (model.filters[i].logic) {
	                        this._addGroup(parent, model.filters[i]);
	                    } else {
	                        this._addExpression(parent, model.filters[i]);
	                    }
	                    if (model.filters[i].filters) {
	                        this._addExpressionTree(model.filters[i]);
	                    }
	                }
	            }
	        },

	        _attachEvents: function () {
	            var that = this;

	            that.element.on("click" + NS, "button.k-button" , function (e) {
	                e.preventDefault();

	                var button  = $(e.currentTarget);
	                var icon = button.find("span");
	                var command = (icon.length ? icon : button).attr("class").split("-").pop();

	                if (command == "close") {
	                    that._removeExpression(button.closest(".k-toolbar"));
	                } else if (command == "expression") {
	                    that._addExpression(button.closest(".k-toolbar"));
	                } else if (command == "group") {
	                    that._addGroup(button.closest(".k-toolbar"));
	                } else if (command == "apply") {
	                    that.applyFilter();
	                }
	            });
	        },

	        _addExpression: function (parentContainer, model) {
	            var that = this;
	            var parentUID = parentContainer.attr("id");
	            var itemsContainer  = parentContainer.closest(".k-filter-toolbar").next("ul.k-filter-lines");
	            var field = model ? that._fields[model.field] : that._defaultField;
	            var expressionModel;
	            var itemHTML = "";

	            if (model) {
	                expressionModel = model;
	            } else {
	                expressionModel = findModel(that.filterModel, parentUID);

	                if (!expressionModel.filters) {
	                    expressionModel.set("filters", []);
	                }

	                expressionModel = that._addNewModel(expressionModel.filters, field);
	            }

	            if (!itemsContainer.length) {
	                itemsContainer = $("<ul class='k-filter-lines'></ul>").appendTo(parentContainer.closest("li"));
	            }

	            itemHTML = $(kendo.template(expressionItemTemplate)({
	                fields: that._fields,
	                operators: that.operators[field.type],
	                close: that.options.messages.close,
	                fieldsLabel: that.options.messages.fields,
	                uid: expressionModel.uid,
	                ns: kendo.ns
	            })).appendTo(itemsContainer);

	            that._addExpressionControls(itemHTML.find(".k-toolbar"), field, expressionModel);

	            if (!model) {
	                that._expressionChange();
	            }
	        },

	        _addExpressionControls: function (container, field, filterModel) {
	            var items = container.find(".k-filter-toolbar-item");
	            var operatorsContainer = items.eq(1);
	            var editorContainer = items.eq(2);

	            kendo.destroy(operatorsContainer);
	            kendo.destroy(editorContainer);
	            operatorsContainer.empty();
	            editorContainer.empty();

	            this._appendOperators(operatorsContainer, field);
	            this._appendEditor(editorContainer, field);
	            this._bindModel(container, filterModel);
	            this._showHideEditor(container, filterModel);
	        },

	        _appendOperators: function (container, field) {
	            $(kendo.template(operatorsTemplate)({
	                operators: field.operators && field.operators[field.type] ? field.operators[field.type] : this.operators[field.type],
	                operatorsLabel: this.options.messages.operators,
	                ns: kendo.ns
	            })).appendTo(container);
	        },

	        _appendEditor: function (container, field) {
	            if (kendo.isFunction(field.editor)) {
	                field.editor(container, $.extend(true, {}, { field: field.name }));
	            } else {
	                $(kendo.template(field.editor)({ns: kendo.ns, field: field.name})).appendTo(container);
	            }
	        },

	        _addNewModel: function (parent, field) {
	            var filterModel;
	            var type = field.type;
	            var operators = field.operators;
	            var operator;
	            if (!operators) {
	                operators = this.options.operators;
	            }

	            operator = Object.keys(operators[type])[0];

	            parent.push({ field: field.name });
	            filterModel = parent[parent.length - 1];

	            filterModel.set("value", field.defaultValue);
	            filterModel.set("operator", operator);

	            return filterModel;
	        },

	        _addGroup: function (parent, model) {
	            var that = this;
	            var filterModel = that.filterModel;
	            var parentUID = parent.attr("id");
	            var itemsContainer  = parent.closest(".k-filter-toolbar").next("ul.k-filter-lines");
	            var logicHTML;

	            if (model) {
	                filterModel = model;

	            } else {
	                filterModel = findModel(filterModel, parentUID);

	                if (!filterModel.filters) {
	                    filterModel.set("filters", []);
	                }
	                filterModel.filters.push({ logic: that.options.mainLogic });
	                filterModel = filterModel.filters[filterModel.filters.length - 1];
	            }

	            if (!itemsContainer.length) {
	                itemsContainer = $("<ul class='k-filter-lines'></ul>").appendTo(parent.closest("li"));
	            }

	            logicHTML = $(kendo.template(logicItemTemplate)({
	                operators: {
	                    and : that.options.messages.and,
	                    or : that.options.messages.or
	                },
	                addExpression: that.options.messages.addExpression,
	                addGroup: that.options.messages.addGroup,
	                close: that.options.messages.close,
	                ns: kendo.ns
	            })).appendTo(itemsContainer);

	            that._bindModel(logicHTML.find(".k-toolbar"), filterModel);

	            if (!model) {
	                that._expressionChange();
	            }
	        },

	        _bindModel: function (container, model) {
	            container.attr("id", model.uid);

	            model.bind("change", this._modelChangeHandler);
	            kendo.bind(container, model);

	            container.parent().attr(kendo.attr("stop"), true);
	        },

	        _createPreview:  function (filter) {
	            var html = "";
	            var createdField = false;
	            var haveFields = this._hasFieldsFilter(filter.filters || []);
	            var childhtml = "";
	            var current;
	            var field;

	            if (!filter.filters || !filter.filters.length || !haveFields) {
	                return "";
	            }
	            html += '<span class="k-filter-preview-bracket">(</span>';
	            for (var i = 0 ; i < filter.filters.length; i++) {
	                current = filter.filters[i];

	                if (current.filters) {
	                    childhtml = this._createPreview(current);
	                    if (childhtml) {
	                        if (createdField) {
	                            html += '<span class="k-filter-preview-operator"> ' + filter.logic.toLocaleUpperCase() + ' </span>';
	                        }
	                        createdField = true;
	                    }
	                    html += childhtml;
	                }
	                if (current.field) {
	                    field = this._fields[current.field];
	                    if (createdField) {
	                        html += '<span class="k-filter-preview-operator"> ' + filter.logic.toLocaleUpperCase() + ' </span>';
	                    }
	                    createdField = true;
	                    html += '<span class="k-filter-preview-field">' + field.label + '</span>';
	                    html += '<span class="k-filter-preview-criteria"> ' + this._getOperatorText(current.field, current.operator);
	                    if (current.operator.indexOf("is") < 0) {
	                        html += ' </span>';
	                        html += "<span class='k-filter-preview-value'>'" + kendo.htmlEncode(field.previewFormat ? kendo.toString(current.value, field.previewFormat) : current.value) + "'</span>";
	                    } else {
	                        html += '</span>';
	                    }
	                }
	            }
	            html += '<span class="k-filter-preview-bracket">)</span>';
	            return html;
	        },

	        _expressionChange: function() {
	            var that = this;
	            var filter = that.filterModel.toJSON();
	            var html = "";

	            if (that.options.expressionPreview) {
	                html = that._createPreview(filter);
	                that._previewContainer.html(html);
	            }

	            that.trigger(CHANGE, { expression: filter });
	        },

	        _getOperatorText: function (field, operator) {
	            var type = this._fields[field].type;
	            var operators = this._fields[field].operators;

	            if (!operators) {
	                operators = this.options.operators;
	            }

	            return operators[type][operator].text || operators[type][operator];
	        },

	        _addField: function(fieldInfo, field) {
	            var that = this;
	            fieldInfo = $.extend(true, {}, {
	                name: fieldInfo.name || field,
	                editor : fieldInfo.editorTemplate || editors[fieldInfo.type || "string"],
	                defaultValue : (fieldInfo.defaultValue || fieldInfo.defaultValue === false || fieldInfo.defaultValue === 0) ? fieldInfo.defaultValue : "",
	                type : fieldInfo.type || "string",
	                label : fieldInfo.label || fieldInfo.name || field,
	                operators: fieldInfo.operators,
	                previewFormat: fieldInfo.previewFormat
	            });
	            that._fields[fieldInfo.name] = fieldInfo;
	            if (!that._defaultField) {
	                that._defaultField = fieldInfo;
	            }
	        },

	        _getFieldsInfo: function () {
	            var that = this;
	            var fieldsCollection = that.options.fields.length ? that.options.fields : (that.options.dataSource.options.schema.model || {}).fields;
	            var fieldInfo;

	            that._fields = {};

	            if (Array.isArray(fieldsCollection)) {
	                for (var i = 0; i < fieldsCollection.length; i++) {
	                    fieldInfo = fieldsCollection[i];
	                    that._addField(fieldInfo);
	                }
	            } else {
	                for (var field in fieldsCollection) {
	                    fieldInfo = fieldsCollection[field];
	                    that._addField(fieldInfo, field);
	                }
	            }
	        },

	        _hasFieldsFilter: function (filters, haveField) {
	            haveField = !!haveField;

	            for (var i = 0 ; i < filters.length; i++) {
	                if (filters[i].filters) {
	                    haveField = this._hasFieldsFilter(filters[i].filters, haveField);
	                }
	                if (filters[i].field) {
	                    return true;
	                }
	            }

	            return haveField;
	        },

	        _removeEmptyGroups: function (filters) {
	            if (!filters) {
	                return;
	            }
	            for (var i = filters.length - 1; i >= 0; i--) {
	                if ((filters[i].logic && !filters[i].filters) || (filters[i].filters && !this._hasFieldsFilter(filters[i].filters)) ) {
	                    filters.splice(i, 1);
	                    continue;
	                }

	                if (filters[i].filters) {
	                    this._removeEmptyGroups(filters[i].filters);
	                }
	            }
	        },

	        _modelChange: function (e) {
	            var that = this;
	            var container = that.element.find("[id=" + e.sender.uid + "]");

	            that._showHideEditor(container, e.sender);
	            if (e.field !== "field") {
	                if (e.field !== "filters") {
	                  that._expressionChange();
	                }
	                return;
	            }

	            var newField = e.sender.field;
	            var parent = e.sender.parent();
	            var field = that._fields[newField];
	            var filterModel = that._addNewModel(parent, field);

	            e.sender.unbind("change", that._modelChangeHandler);

	            parent.remove(e.sender);

	            that._addExpressionControls(container, field, filterModel);

	            that._expressionChange();
	        },

	        _renderMain: function() {
	            var that = this;

	            $(mainContainer).appendTo(that.element);

	            if (that.options.expression) {
	                that.filterModel = kendo.observable(that.options.expression);
	            } else {
	                that.filterModel = kendo.observable({
	                    logic: that.options.mainLogic
	                });
	            }

	            $(kendo.template(mainLogicTemplate)({
	                operators: {
	                    and : that.options.messages.and,
	                    or : that.options.messages.or
	                },
	                addExpression: that.options.messages.addExpression,
	                addGroup: that.options.messages.addGroup,
	                close: that.options.messages.close,
	                uid: that.filterModel.uid,
	                ns: kendo.ns
	            })).appendTo(that.element.find("li:first"));

	            that._bindModel(that.element.find(".k-toolbar:first"), that.filterModel);
	        },

	        _removeExpression: function (parent) {
	            var that = this;
	            var parentUID = parent.attr("id");
	            var itemContainer = parent.closest("li");
	            var isMain = itemContainer.hasClass("k-filter-group-main");
	            var parentModel;
	            var model;

	            if (isMain) {
	                itemContainer = itemContainer.find(".k-filter-lines");
	                if (that.filterModel.filters) {
	                    that.filterModel.filters.empty();
	                    delete that.filterModel.filters;
	                }
	            } else {
	                model = findModel(that.filterModel, parentUID);
	                parentModel = model.parent();
	                model.unbind("change", that._modelChangeHandler);
	                parentModel.remove(model);
	                if (!parentModel.length) {
	                    delete parentModel.parent().filters;
	                }
	                if (!itemContainer.siblings().length) {
	                    itemContainer = itemContainer.parent();
	                }
	            }

	            kendo.destroy(itemContainer);
	            itemContainer.remove();
	            that._expressionChange();
	        },

	        _renderApplyButton: function() {
	            var that = this;

	            if (!that.options.applyButton) {
	                return;
	            }

	            if (!that._applyButton) {
	                that._applyButton = $(kendo.format('<button type="button" aria-label="{0}" title="{0}" class="k-button k-filter-apply">{0}</button>', that.options.messages.apply)).appendTo(that.element);
	            }
	        },

	        _showHideEditor: function (container, model) {
	            if (model.logic) {
	                return;
	            }

	            var operator = model.operator;
	            var editorContainer = container.find(".k-filter-toolbar-item:eq(2)");
	            if (operator == "isnull" || operator == "isnotnull" || operator == "isempty" ||
	                operator == "isnotempty" || operator == "isnullorempty" || operator == "isnotnullorempty") {
	                editorContainer.hide();
	            } else {
	                editorContainer.show();
	            }
	        },

	        _mapOperators: function (expression) {
	            var that = this;
	            if (expression.filters) {
	                expression.filters.forEach(function (filter) {
	                    if (filter.filters) {
	                        that._mapOperators(filter);
	                    } else {
	                        var operator;
	                        var field = that._fields[filter.field];
	                        var type = field.type;
	                        if (field.operators && field.operators[type][filter.operator]) {
	                            operator = field.operators[type][filter.operator];
	                        } else {
	                            operator = that.operators[type][filter.operator];
	                        }

	                        if (operator) {
	                            filter.operator = operator.handler || filter.operator;
	                        }
	                    }
	                });
	            }
	        },

	        hasCustomOperators: function () {
	            var operators = $.extend(true, {}, this.operators);

	            for (var field in this._fields) {
	                operators = $.extend(true, {}, operators, this._fields[field].operators);
	            }
	            this._hasCustomOperators = findCustomOperators(operators);
	        }

	    });

	    function findCustomOperators(operators) {
	        for (var field in operators) {
	            var operator = operators[field];
	            if ((operator.handler && typeof operator.handler === "function") ||
	                (typeof operator === 'object' && operator !== null && findCustomOperators(operator))) {
	                return true;
	            }
	        }
	        return false;
	    }

	    function findModel(model, uid) {

	        if (model.uid === uid) {
	            return model;
	        }

	        if (model.filters) {
	            for(var i = 0; i < model.filters.length; i++) {
	                var temp = findModel(model.filters[i], uid);
	                if (temp) {
	                    return temp;
	                }
	            }
	        }
	    }

	    ui.plugin(Filter);
	    ui.plugin(FilterButtonGroup);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1243:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("pYWG");

/***/ })

/******/ });

/***/ }),

/***/ "t8qj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "tAgt":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1616);
	module.exports = __webpack_require__(1616);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1616:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var Property = kendo.Class.extend({
	        init: function(list) {
	            this.list = list;
	        },

	        get: function(index) {
	            return this.parse(this.list.value(index, index));
	        },

	        set: function(start, end, value) {
	            if (value === undefined) {
	                value = end;
	                end = start;
	            }

	            this.list.value(start, end, value);
	        },

	        parse: function(value) {
	            return value;
	        },

	        copy: function(start, end, dst) {
	            this.list.copy(start, end, dst);
	        },

	        iterator: function(start, end) {
	            return this.list.iterator(start, end);
	        }
	    });

	    var JsonProperty = Property.extend({
	        set: function(start, end, value) {
	            this.list.value(start, end, JSON.stringify(value));
	        },

	        parse: function(value) {
	            return JSON.parse(value);
	        }
	    });

	    var ValueProperty = Property.extend({
	        init: function(values, formats) {
	            Property.prototype.init.call(this, values);
	            this.formats = formats;
	        },

	        set: function(start, end, value) {
	            if (value instanceof Date) {
	                value = kendo.spreadsheet.dateToNumber(value);
	                if (!this.formats.value(start,end)) {
	                    this.formats.value(start, end, toExcelFormat(kendo.culture().calendar.patterns.d));
	                }
	            } else if (typeof value == "number") {
	                value = kendo.spreadsheet.calc.runtime.limitPrecision(value);
	            }

	            this.list.value(start, end, value);
	        }
	    });

	    function toExcelFormat(format) {
	        return format.replace(/M/g, "m").replace(/'/g, '"').replace(/tt/, "am/pm");
	    }

	    kendo.spreadsheet.PropertyBag = kendo.Class.extend({
	        specs: [
	            { property: Property, name: "format", value: null, sortable: true, serializable: true },
	            { property: ValueProperty, name: "value", value: null, sortable: true, serializable: true, depends: "format" },
	            { property: Property, name: "formula", value: null, sortable: true, serializable: true },
	            { property: Property, name: "background", value: null, sortable: true, serializable: true },
	            { property: JsonProperty, name: "vBorders", value: null, sortable: false, serializable: false },
	            { property: JsonProperty, name: "hBorders", value: null, sortable: false, serializable: false },
	            { property: Property, name: "color", value: null, sortable: true, serializable: true },
	            { property: Property, name: "fontFamily", value: null, sortable: true, serializable: true },
	            { property: Property, name: "underline", value: null, sortable: true, serializable: true },
	            { property: Property, name: "fontSize", value: null, sortable: true, serializable: true },
	            { property: Property, name: "italic", value: null, sortable: true, serializable: true },
	            { property: Property, name: "bold", value: null, sortable: true, serializable: true },
	            { property: Property, name: "textAlign", value: null, sortable: true, serializable: true },
	            { property: Property, name: "indent", value: null, sortable: true, serializable: true },
	            { property: Property, name: "verticalAlign", value: null, sortable: true, serializable: true },
	            { property: Property, name: "wrap", value: null, sortable: true, serializable: true },
	            { property: Property, name: "validation", value: null, sortable: false, serializable: true },
	            { property: Property, name: "enable", value: null, sortable: false, serializable: true },
	            { property: Property, name: "link", value: null, sortable: true, serializable: true },
	            { property: Property, name: "editor", value: null, sortable: true, serializable: true },
	            { property: Property, name: "comment", value: null, sortable: true, serializable: true },
	            { property: Property, name: "html", value: null, sortable: true, serializable: true }
	        ],

	        init: function(rowCount, columnCount, defaultValues) {
	            defaultValues = defaultValues || {};
	            var cellCount = rowCount * columnCount - 1;

	            this.rowCount = rowCount;
	            this.columnCount = columnCount;
	            this.cellCount = cellCount;
	            this.properties = {};
	            this.lists = {};

	            this.specs.forEach(function(spec) {
	                var name = spec.name;
	                var value = defaultValues[name];
	                if (value === undefined) {
	                    value = spec.value;
	                }
	                this.lists[name] = new kendo.spreadsheet.SparseRangeList(0, cellCount, value);
	                var prop = this.properties[name] = new spec.property(this.lists[name], this.lists[spec.depends]);
	                prop.spec = spec;
	            }, this);

	            // XXX: this is a hack but I have no better ideas at this
	            // point.  The getState() method in a SparseRangeList
	            // clones the tree (which just copies values over), but
	            // formulas are objects maintaining complex state.
	            // https://github.com/telerik/kendo-ui-core/issues/2816
	            this.lists.formula.tree.clone = cloneFormulaTree;
	            this.lists.validation.tree.clone = cloneFormulaTree;
	        },

	        getState: function() {
	            var state = {};

	            this.specs.forEach(function(spec) {
	               state[spec.name] = this.lists[spec.name].getState();
	            }, this);

	            return state;
	        },

	        setState: function(state) {
	            this.specs.forEach(function(spec) {
	                this.lists[spec.name].setState(state[spec.name]);
	            }, this);
	        },

	        get: function(name, index) {
	            if (index === undefined) {
	                return this.lists[name];
	            }

	            switch (name) {
	              case "borderRight":
	                index += this.rowCount;
	                /* falls through */
	              case "borderLeft":
	                name = "vBorders";
	                break;

	              case "borderBottom":
	                index++;
	                /* falls through */
	              case "borderTop":
	                name = "hBorders";
	                break;
	            }
	            return index > this.cellCount ? null : this.properties[name].get(index);
	        },

	        set: function(name, start, end, value) {
	            switch (name) {
	              case "borderRight":
	                start += this.rowCount;
	                end += this.rowCount;
	                /* falls through */
	              case "borderLeft":
	                name = "vBorders";
	                break;

	              case "borderBottom":
	                start++;
	                end++;
	                /* falls through */
	              case "borderTop":
	                name = "hBorders";
	                break;
	            }
	            if (start <= end && end <= this.cellCount) {
	                this.properties[name].set(start, end, value);
	            }
	        },

	        fromJSON: function(index, value) {
	            for (var si = 0; si < this.specs.length; si++) {
	                var spec = this.specs[si];

	                if (spec.serializable) {
	                    if (value[spec.name] !== undefined) {
	                        this.set(spec.name, index, index, value[spec.name], false);
	                    }
	                }
	            }

	            [ "borderLeft", "borderRight", "borderTop", "borderBottom" ].forEach(function(b){
	                if (value[b] !== undefined) {
	                    this.set(b, index, index, value[b]);
	                }
	            }, this);
	        },

	        copy: function(sourceStart, sourceEnd, targetStart) {
	            this.specs.forEach(function(spec) {
	                this.properties[spec.name].copy(sourceStart, sourceEnd, targetStart);
	            }, this);
	        },

	        iterator: function(name, start, end) {
	            var prop = this.properties[name];
	            var iter = prop.iterator(start, end), at = iter.at;
	            var cellCount = this.cellCount;
	            iter.at = function(index) {
	                return index > cellCount ? null : prop.parse(at.call(iter, index));
	            };
	            iter.name = name;
	            iter.value = prop.spec.value;
	            return iter;
	        },

	        sortable: function() {
	            return this.specs.filter(function(spec) { return spec.sortable; })
	                .map(function(spec) {
	                    return this.lists[spec.name];
	                }, this);
	        },

	        iterators: function(start, end) {
	            return this.specs.reduce(function(ret, spec) {
	                if (spec.serializable) {
	                    ret.push(this.iterator(spec.name, start, end));
	                }
	                return ret;
	            }.bind(this), []);
	        },

	        forEach: function(start, end, callback) {
	            var iterators = this.iterators(start, end);
	            var hBorders = this.iterator("hBorders", start, end + 1);
	            var leftBorders = this.iterator("vBorders", start, end);
	            var rightBorders = this.iterator("vBorders", start + this.rowCount, end + this.rowCount);
	            var values, index;

	            function addBorder(name, iterator, index) {
	                var val = iterator.at(index);
	                if (val !== iterator.value) {
	                    values[name] = val;
	                }
	            }

	            for (index = start; index <= end; index++) {
	                values = {};

	                for (var i = 0; i < iterators.length; i++) {
	                    var iterator = iterators[i];
	                    var value = iterator.at(index);

	                    if (value !== iterator.value) {
	                        values[iterator.name] = value;
	                    }
	                }

	                addBorder("borderLeft", leftBorders, index);
	                addBorder("borderRight", rightBorders, index + this.rowCount);
	                addBorder("borderTop", hBorders, index);
	                if ((index + 1) % this.rowCount) {
	                    addBorder("borderBottom", hBorders, index + 1);
	                }

	                callback(values);
	            }
	        },

	        forEachProperty: function(callback) {
	            for (var name in this.properties) {
	                callback(this.properties[name]);
	            }
	        }
	    });

	    function cloneFormulaValue(x) {
	        x = x.clone();
	        x.value = x.value.deepClone(); // x.value is Formula or Validation
	        return x;
	    }

	    function cloneFormulaTree() {
	        var tree = this.map(cloneFormulaValue);
	        tree.clone = cloneFormulaTree; // because it's a new RangeTree now
	        return tree;
	    }

	    kendo.spreadsheet.ALL_PROPERTIES = kendo.spreadsheet.PropertyBag.prototype.specs.reduce(function(a, spec) {
	        if (spec.serializable) {
	            a.push(spec.name);
	        }
	        return a;
	    }, [ "borderTop", "borderRight", "borderBottom", "borderLeft" ]);

	})(window.kendo);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "tHOz":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1336);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1336:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1337) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "ooxml",
	    name: "XLSX generation",
	    category: "framework",
	    advanced: true,
	    depends: [ "core" ]
	};

	}, __webpack_require__(3));


/***/ }),

/***/ 1337:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Xqqy");

/***/ })

/******/ });

/***/ }),

/***/ "tIFN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var bind = __webpack_require__("JP+z");
var Axios = __webpack_require__("XmWM");
var defaults = __webpack_require__("KCLY");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("dVOP");
axios.CancelToken = __webpack_require__("cWxy");
axios.isCancel = __webpack_require__("pBtG");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("pxG4");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "tQup":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1638);
	module.exports = __webpack_require__(1638);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1638:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(20)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function () {

	window.kendo.util = window.kendo.util || {};
	window.kendo.util.ripple = window.kendo.util.ripple || {};

	var closest = function (element, selector) {
	    if (element.closest) {
	        return element.closest(selector);
	    }
	    var matches = Element.prototype.matches ?
	        function (el, sel) { return el.matches(sel); }
	        : function (el, sel) { return el.msMatchesSelector(sel); };
	    var node = element;
	    while (node) {
	        if (matches(node, selector)) {
	            return node;
	        }
	        node = node.parentElement;
	    }
	};
	var createRipple = function (doc) {
	    var ripple = doc.createElement('div');
	    ripple.className = 'k-ripple';
	    var blob = doc.createElement('div');
	    blob.className = 'k-ripple-blob';
	    ripple.appendChild(blob);
	    return [ripple, blob];
	};
	var once = function (element, eventName, fn) {
	    var listener = function () {
	        fn();
	        element.removeEventListener(eventName, listener, false);
	    };
	    var remove = function () { return element.addEventListener(eventName, listener, false); };
	    remove();
	    return { remove: remove };
	};
	var activate = function (containerSelector, options) { return function (e) {
	    var target = e.target;
	    var doc = target.document || target.ownerDocument;
	    var container;
	    if (options.container) {
	        container = options.container(target);
	    }
	    else {
	        container = closest(target, containerSelector);
	    }
	    if (!container) {
	        return;
	    }
	    // focus event of ripple container triggers double-focus
	    var doubleFocus = /focus/i.test(e.type) && container.classList.contains("k-ripple-target");
	    if (doubleFocus) {
	        return;
	    }
	    // suppress focus when animating ripples
	    container.classList.add("k-ripple-target");
	    var _a = createRipple(doc), ripple = _a[0], blob = _a[1];
	    var state = {
	        animated: false,
	        released: false,
	        blob: blob,
	        container: container,
	        ripple: ripple
	    };
	    var eventType = {
	        'focusin': 'focusout',
	        'keydown': 'keyup',
	        'mousedown': 'mouseup',
	        'pointerdown': 'pointerup',
	        'touchdown': 'touchup'
	    }[e.type];
	    once(e.currentTarget, eventType, function () { return release(state); });
	    container.appendChild(ripple);
	    // recalc to allow the effect to animate
	    window.getComputedStyle(ripple).getPropertyValue('opacity');
	    var rect = container.getBoundingClientRect();
	    var left = 0;
	    var top = 0;
	    if ((/mouse|pointer|touch/).test(e.type)) {
	        left = e.clientX - rect.left;
	        top = e.clientY - rect.top;
	    }
	    else {
	        left = rect.width / 2;
	        top = rect.height / 2;
	    }
	    // coordinates of the farthest corner
	    var xMax = left < rect.width / 2 ? rect.width : 0;
	    var yMax = top < rect.height / 2 ? rect.height : 0;
	    // distance to the farthest corner
	    var dx = left - xMax;
	    var dy = top - yMax;
	    // blob size is twice the blob radius
	    var size = 2 * Math.sqrt(dx * dx + dy * dy);
	    var duration = 500;
	    blob.style.width = blob.style.height = size + "px";
	    // force reflow for Safari 11 to align ripple blob
	    if (blob.offsetWidth < 0) {
	        throw new Error("Inconceivable!");
	    }
	    blob.style.cssText = "\n    width: " + size + "px;\n    height: " + size + "px;\n    transform: translate(-50%, -50%) scale(1);\n    left: " + left + "px;\n    top: " + top + "px;\n  ";
	    setTimeout(function () { return finishAnimation(state); }, duration);
	}; };
	var finishAnimation = function (state) {
	    state.animated = true;
	    deactivate(state);
	};
	var release = function (state) {
	    state.released = true;
	    deactivate(state);
	};
	var deactivate = function (state) {
	    // deactivation happens when both
	    // - the activation event has been released (release)
	    // - the ripple has finished animating (finishAnimation)
	    if (!state.released || !state.animated) {
	        return;
	    }
	    var blob = state.blob, ripple = state.ripple, container = state.container;
	    if (container) {
	        once(container, 'blur', function () { return container.classList.remove("k-ripple-target"); });
	    }
	    if (blob) {
	        once(blob, 'transitionend', function () {
	            if (ripple && ripple.parentNode) {
	                ripple.parentNode.removeChild(ripple);
	            }
	        });
	        blob.style.transition = 'opacity 200ms linear';
	        blob.style.opacity = '0';
	    }
	};
	/**
	 * @hidden
	 */
	var register = function (root, elements) {
	    var flatten = function (arr) { return [].concat.apply([], arr); };
	    var handlers = flatten(elements.map(function (item) {
	        var defaultOptions = {
	            events: ['mousedown', 'touchdown'],
	            global: false
	        };
	        var selector = item.selector, _a = item.options, options = _a === void 0 ? defaultOptions : _a;
	        var activator = activate(selector, options);
	        var events = options.events || defaultOptions.events;
	        var container = options.global ? document.body : root;
	        events.forEach(function (evt) { return container.addEventListener(evt, activator, false); });
	        return { events: events, options: options, activator: activator };
	    }));
	    return function () {
	        if (!root) {
	            return;
	        }
	        var removeListener = function (_a) {
	            var events = _a.events, options = _a.options, activator = _a.activator;
	            var container = options.global ? document.body : root;
	            events.forEach(function (evt) { return container.removeEventListener(evt, activator, false); });
	        };
	        handlers.forEach(removeListener);
	        root = null;
	    };
	};

	kendo.deepExtend(kendo.util.ripple, {
	    register: register
	});

	})();

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "tTVk":
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),

/***/ "tTsr":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1315);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1315:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.buttongroup",
	    name: "ButtonGroup",
	    category: "mobile",
	    description: "The Kendo mobile ButtonGroup widget is a linear set of grouped buttons.",
	    depends: [ "core" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.mobile.ui,
	        Widget = ui.Widget,
	        ACTIVE = "state-active",
	        DISABLE = "state-disabled",
	        SELECT = "select",
	        SELECTOR = "li:not(.km-" + ACTIVE +")";

	    function className(name) {
	        return "k-" + name + " km-" + name;
	    }

	    function createBadge(value) {
	        return $('<span class="' + className("badge") + '">' + value + '</span>');
	    }

	    var ButtonGroup = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            that.element.addClass("km-buttongroup k-widget k-button-group").find("li").each(that._button);

	            that.element.on(that.options.selectOn, SELECTOR, "_select");

	            that._enable = true;
	            that.select(that.options.index);

	            if(!that.options.enable) {
	                that._enable = false;
	                that.wrapper.addClass(className(DISABLE));
	            }
	        },

	        events: [
	            SELECT
	        ],

	        options: {
	            name: "ButtonGroup",
	            selectOn: "down",
	            index: -1,
	            enable: true
	        },

	        current: function() {
	            return this.element.find(".km-" + ACTIVE);
	        },

	        select: function (li) {
	            var that = this,
	                index = -1;

	            if (li === undefined || li === -1 || !that._enable || $(li).is(".km-" + DISABLE)) {
	                return;
	            }

	            that.current().removeClass(className(ACTIVE));

	            if (typeof li === "number") {
	                index = li;
	                li = $(that.element[0].children[li]);
	            } else if (li.nodeType) {
	                li = $(li);
	                index = li.index();
	            }

	            li.addClass(className(ACTIVE));
	            that.selectedIndex = index;
	        },

	        badge: function(item, value) {
	            var buttongroup = this.element, badge;

	            if (!isNaN(item)) {
	                item = buttongroup.children().get(item);
	            }

	            item = buttongroup.find(item);
	            badge = $(item.children(".km-badge")[0] || createBadge(value).appendTo(item));

	            if (value || value === 0) {
	                badge.html(value);
	                return this;
	            }

	            if (value === false) {
	                badge.empty().remove();
	                return this;
	            }

	            return badge.html();
	        },

	        enable: function(enable) {
	            if(typeof enable == "undefined") {
	                enable = true;
	            }

	            this.wrapper.toggleClass(className(DISABLE), !enable);

	            this._enable = this.options.enable = enable;
	        },

	        _button: function() {
	            var button = $(this).addClass(className("button")),
	                icon = kendo.attrValue(button, "icon"),
	                badge = kendo.attrValue(button, "badge"),
	                span = button.children("span"),
	                image = button.find("img").addClass(className("image"));

	            if (!span[0]) {
	                span = button.wrapInner("<span/>").children("span");
	            }

	            span.addClass(className("text"));

	            if (!image[0] && icon) {
	                button.prepend($('<span class="' + className("icon") + ' ' + className(icon) + '"/>'));
	            }

	            if (badge || badge === 0) {
	                createBadge(badge).appendTo(button);
	            }
	        },

	        _select: function(e) {
	            if (e.which > 1 || e.isDefaultPrevented() || !this._enable) {
	                return;
	            }

	            this.select(e.currentTarget);
	            this.trigger(SELECT, { index: this.selectedIndex });
	        }
	    });

	    ui.plugin(ButtonGroup);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "tg5X":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1316);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1316:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.collapsible",
	    name: "Collapsible",
	    category: "mobile",
	    description: "The Kendo mobile Collapsible widget provides ability for creating collapsible blocks of content.",
	    depends: [ "core", "userevents" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.mobile.ui,
	        Widget = ui.Widget,
	        COLLAPSIBLE = "km-collapsible",
	        HEADER = "km-collapsible-header",
	        CONTENT = "km-collapsible-content",
	        INSET = "km-collapsibleinset",
	        HEADER_WRAPPER = "<div data-role='collapsible-header' class='" + HEADER + "'></div>",
	        CONTENT_WRAPPER = "<div data-role='collapsible-content' class='" + CONTENT + "'></div>",

	        COLLAPSED = "km-collapsed",
	        EXPANDED = "km-expanded",
	        ANIMATED = "km-animated",

	        //icon position
	        LEFT = "left",

	        //events
	        EXAPND = "expand",
	        COLLAPSE = "collapse";

	    var Collapsible = Widget.extend({
	        init: function(element, options) {
	            var that = this,
	                container = $(element);

	            Widget.fn.init.call(that, container, options);

	            container.addClass(COLLAPSIBLE);

	            that._buildHeader();
	            that.content = container.children().not(that.header).wrapAll(CONTENT_WRAPPER).parent();

	            that._userEvents = new kendo.UserEvents(that.header, {
	                fastTap: true,
	                tap: function() { that.toggle(); }
	            });

	            container.addClass(that.options.collapsed ? COLLAPSED : EXPANDED);

	            if (that.options.inset) {
	                container.addClass(INSET);
	            }

	            if (that.options.animation) {
	                that.content.addClass(ANIMATED);
	                that.content.height(0);
	                if (that.options.collapsed) {
	                    that.content.hide();
	                }
	            } else if (that.options.collapsed) {
	                that.content.hide();
	            }
	        },

	        events: [
	            EXAPND,
	            COLLAPSE
	        ],

	        options: {
	            name: "Collapsible",
	            collapsed: true,
	            collapseIcon: "arrow-n",
	            expandIcon: "arrow-s",
	            iconPosition: LEFT,
	            animation: true,
	            inset: false
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            this._userEvents.destroy();
	        },

	        expand: function(instant) {
	            var icon = this.options.collapseIcon,
	                content = this.content,
	                ios = kendo.support.mobileOS.ios;

	            if (!this.trigger(EXAPND)) {
	                if (icon) {
	                    this.header.find(".km-icon").removeClass().addClass("km-icon km-" + icon);
	                }
	                this.element.removeClass(COLLAPSED).addClass(EXPANDED);

	                if (this.options.animation && !instant) {
	                    content.off("transitionend");
	                    content.show();
	                    if (ios) { content.removeClass(ANIMATED); } //required to get the height of the content on iOS
	                    content.height(this._getContentHeight());
	                    if (ios) { content.addClass(ANIMATED); }

	                    kendo.resize(content);
	                } else {
	                    content.show();
	                }
	            }
	        },

	        collapse: function(instant) {
	            var icon = this.options.expandIcon,
	                content = this.content;

	            if (!this.trigger(COLLAPSE)) {
	                if (icon) {
	                    this.header.find(".km-icon").removeClass().addClass("km-icon km-" + icon);
	                }
	                this.element.removeClass(EXPANDED).addClass(COLLAPSED);

	                if (this.options.animation && !instant) {
	                    content.one("transitionend", function() { content.hide(); });
	                    content.height(0);
	                } else {
	                    content.hide();
	                }
	            }
	        },

	        toggle: function(instant) {
	            if (this.isCollapsed()) {
	                this.expand(instant);
	            } else {
	                this.collapse(instant);
	            }
	        },

	        isCollapsed: function() {
	            return this.element.hasClass(COLLAPSED);
	        },

	        resize: function() {
	            if (!this.isCollapsed() && this.options.animation) {
	                this.content.height(this._getContentHeight());
	            }
	        },

	        _buildHeader: function() {
	            var header = this.element.children(":header").wrapAll(HEADER_WRAPPER),
	                iconSpan = $('<span class="km-icon"/>'),
	                icon = this.options.collapsed ? this.options.expandIcon : this.options.collapseIcon,
	                iconPosition = this.options.iconPosition;

	            if (icon) {
	                header.prepend(iconSpan);
	                iconSpan.addClass("km-" + icon);
	            }

	            this.header = header.parent();
	            this.header.addClass("km-icon-" + iconPosition);
	        },

	        _getContentHeight: function() {
	            var style = this.content.attr("style"),
	                height;

	            this.content.css({
	                position:   'absolute',
	                visibility: 'hidden',
	                height: "auto"
	            });

	            height = this.content.height();

	            this.content.attr("style", style ? style : "");

	            return height;
	        }
	    });

	    ui.plugin(Collapsible);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "thJu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),

/***/ "thjQ":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.swal=e():t.swal=e()}(this,function(){return function(t){function e(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,o){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:o})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=8)}([function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o="swal-button";e.CLASS_NAMES={MODAL:"swal-modal",OVERLAY:"swal-overlay",SHOW_MODAL:"swal-overlay--show-modal",MODAL_TITLE:"swal-title",MODAL_TEXT:"swal-text",ICON:"swal-icon",ICON_CUSTOM:"swal-icon--custom",CONTENT:"swal-content",FOOTER:"swal-footer",BUTTON_CONTAINER:"swal-button-container",BUTTON:o,CONFIRM_BUTTON:o+"--confirm",CANCEL_BUTTON:o+"--cancel",DANGER_BUTTON:o+"--danger",BUTTON_LOADING:o+"--loading",BUTTON_LOADER:o+"__loader"},e.default=e.CLASS_NAMES},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.getNode=function(t){var e="."+t;return document.querySelector(e)},e.stringToNode=function(t){var e=document.createElement("div");return e.innerHTML=t.trim(),e.firstChild},e.insertAfter=function(t,e){var n=e.nextSibling;e.parentNode.insertBefore(t,n)},e.removeNode=function(t){t.parentElement.removeChild(t)},e.throwErr=function(t){throw t=t.replace(/ +(?= )/g,""),"SweetAlert: "+(t=t.trim())},e.isPlainObject=function(t){if("[object Object]"!==Object.prototype.toString.call(t))return!1;var e=Object.getPrototypeOf(t);return null===e||e===Object.prototype},e.ordinalSuffixOf=function(t){var e=t%10,n=t%100;return 1===e&&11!==n?t+"st":2===e&&12!==n?t+"nd":3===e&&13!==n?t+"rd":t+"th"}},function(t,e,n){"use strict";function o(t){for(var n in t)e.hasOwnProperty(n)||(e[n]=t[n])}Object.defineProperty(e,"__esModule",{value:!0}),o(n(25));var r=n(26);e.overlayMarkup=r.default,o(n(27)),o(n(28)),o(n(29));var i=n(0),a=i.default.MODAL_TITLE,s=i.default.MODAL_TEXT,c=i.default.ICON,l=i.default.FOOTER;e.iconMarkup='\n  <div class="'+c+'"></div>',e.titleMarkup='\n  <div class="'+a+'"></div>\n',e.textMarkup='\n  <div class="'+s+'"></div>',e.footerMarkup='\n  <div class="'+l+'"></div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1);e.CONFIRM_KEY="confirm",e.CANCEL_KEY="cancel";var r={visible:!0,text:null,value:null,className:"",closeModal:!0},i=Object.assign({},r,{visible:!1,text:"Cancel",value:null}),a=Object.assign({},r,{text:"OK",value:!0});e.defaultButtonList={cancel:i,confirm:a};var s=function(t){switch(t){case e.CONFIRM_KEY:return a;case e.CANCEL_KEY:return i;default:var n=t.charAt(0).toUpperCase()+t.slice(1);return Object.assign({},r,{text:n,value:t})}},c=function(t,e){var n=s(t);return!0===e?Object.assign({},n,{visible:!0}):"string"==typeof e?Object.assign({},n,{visible:!0,text:e}):o.isPlainObject(e)?Object.assign({visible:!0},n,e):Object.assign({},n,{visible:!1})},l=function(t){for(var e={},n=0,o=Object.keys(t);n<o.length;n++){var r=o[n],a=t[r],s=c(r,a);e[r]=s}return e.cancel||(e.cancel=i),e},u=function(t){var n={};switch(t.length){case 1:n[e.CANCEL_KEY]=Object.assign({},i,{visible:!1});break;case 2:n[e.CANCEL_KEY]=c(e.CANCEL_KEY,t[0]),n[e.CONFIRM_KEY]=c(e.CONFIRM_KEY,t[1]);break;default:o.throwErr("Invalid number of 'buttons' in array ("+t.length+").\n      If you want more than 2 buttons, you need to use an object!")}return n};e.getButtonListOpts=function(t){var n=e.defaultButtonList;return"string"==typeof t?n[e.CONFIRM_KEY]=c(e.CONFIRM_KEY,t):Array.isArray(t)?n=u(t):o.isPlainObject(t)?n=l(t):!0===t?n=u([!0,!0]):!1===t?n=u([!1,!1]):void 0===t&&(n=e.defaultButtonList),n}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(2),i=n(0),a=i.default.MODAL,s=i.default.OVERLAY,c=n(30),l=n(31),u=n(32),f=n(33);e.injectElIntoModal=function(t){var e=o.getNode(a),n=o.stringToNode(t);return e.appendChild(n),n};var d=function(t){t.className=a,t.textContent=""},p=function(t,e){d(t);var n=e.className;n&&t.classList.add(n)};e.initModalContent=function(t){var e=o.getNode(a);p(e,t),c.default(t.icon),l.initTitle(t.title),l.initText(t.text),f.default(t.content),u.default(t.buttons,t.dangerMode)};var m=function(){var t=o.getNode(s),e=o.stringToNode(r.modalMarkup);t.appendChild(e)};e.default=m},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(3),r={isOpen:!1,promise:null,actions:{},timer:null},i=Object.assign({},r);e.resetState=function(){i=Object.assign({},r)},e.setActionValue=function(t){if("string"==typeof t)return a(o.CONFIRM_KEY,t);for(var e in t)a(e,t[e])};var a=function(t,e){i.actions[t]||(i.actions[t]={}),Object.assign(i.actions[t],{value:e})};e.setActionOptionsFor=function(t,e){var n=(void 0===e?{}:e).closeModal,o=void 0===n||n;Object.assign(i.actions[t],{closeModal:o})},e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(3),i=n(0),a=i.default.OVERLAY,s=i.default.SHOW_MODAL,c=i.default.BUTTON,l=i.default.BUTTON_LOADING,u=n(5);e.openModal=function(){o.getNode(a).classList.add(s),u.default.isOpen=!0};var f=function(){o.getNode(a).classList.remove(s),u.default.isOpen=!1};e.onAction=function(t){void 0===t&&(t=r.CANCEL_KEY);var e=u.default.actions[t],n=e.value;if(!1===e.closeModal){var i=c+"--"+t;o.getNode(i).classList.add(l)}else f();u.default.promise.resolve(n)},e.getState=function(){var t=Object.assign({},u.default);return delete t.promise,delete t.timer,t},e.stopLoading=function(){for(var t=document.querySelectorAll("."+c),e=0;e<t.length;e++){t[e].classList.remove(l)}}},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){(function(e){t.exports=e.sweetAlert=n(9)}).call(e,n(7))},function(t,e,n){(function(e){t.exports=e.swal=n(10)}).call(e,n(7))},function(t,e,n){"undefined"!=typeof window&&n(11),n(16);var o=n(23).default;t.exports=o},function(t,e,n){var o=n(12);"string"==typeof o&&(o=[[t.i,o,""]]);var r={insertAt:"top"};r.transform=void 0;n(14)(o,r);o.locals&&(t.exports=o.locals)},function(t,e,n){e=t.exports=n(13)(void 0),e.push([t.i,'.swal-icon--error{border-color:#f27474;-webkit-animation:animateErrorIcon .5s;animation:animateErrorIcon .5s}.swal-icon--error__x-mark{position:relative;display:block;-webkit-animation:animateXMark .5s;animation:animateXMark .5s}.swal-icon--error__line{position:absolute;height:5px;width:47px;background-color:#f27474;display:block;top:37px;border-radius:2px}.swal-icon--error__line--left{-webkit-transform:rotate(45deg);transform:rotate(45deg);left:17px}.swal-icon--error__line--right{-webkit-transform:rotate(-45deg);transform:rotate(-45deg);right:16px}@-webkit-keyframes animateErrorIcon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}@keyframes animateErrorIcon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}@-webkit-keyframes animateXMark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}@keyframes animateXMark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}.swal-icon--warning{border-color:#f8bb86;-webkit-animation:pulseWarning .75s infinite alternate;animation:pulseWarning .75s infinite alternate}.swal-icon--warning__body{width:5px;height:47px;top:10px;border-radius:2px;margin-left:-2px}.swal-icon--warning__body,.swal-icon--warning__dot{position:absolute;left:50%;background-color:#f8bb86}.swal-icon--warning__dot{width:7px;height:7px;border-radius:50%;margin-left:-4px;bottom:-11px}@-webkit-keyframes pulseWarning{0%{border-color:#f8d486}to{border-color:#f8bb86}}@keyframes pulseWarning{0%{border-color:#f8d486}to{border-color:#f8bb86}}.swal-icon--success{border-color:#a5dc86}.swal-icon--success:after,.swal-icon--success:before{content:"";border-radius:50%;position:absolute;width:60px;height:120px;background:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal-icon--success:before{border-radius:120px 0 0 120px;top:-7px;left:-33px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:60px 60px;transform-origin:60px 60px}.swal-icon--success:after{border-radius:0 120px 120px 0;top:-11px;left:30px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:0 60px;transform-origin:0 60px;-webkit-animation:rotatePlaceholder 4.25s ease-in;animation:rotatePlaceholder 4.25s ease-in}.swal-icon--success__ring{width:80px;height:80px;border:4px solid hsla(98,55%,69%,.2);border-radius:50%;box-sizing:content-box;position:absolute;left:-4px;top:-4px;z-index:2}.swal-icon--success__hide-corners{width:5px;height:90px;background-color:#fff;padding:1px;position:absolute;left:28px;top:8px;z-index:1;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal-icon--success__line{height:5px;background-color:#a5dc86;display:block;border-radius:2px;position:absolute;z-index:2}.swal-icon--success__line--tip{width:25px;left:14px;top:46px;-webkit-transform:rotate(45deg);transform:rotate(45deg);-webkit-animation:animateSuccessTip .75s;animation:animateSuccessTip .75s}.swal-icon--success__line--long{width:47px;right:8px;top:38px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-animation:animateSuccessLong .75s;animation:animateSuccessLong .75s}@-webkit-keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@-webkit-keyframes animateSuccessTip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@keyframes animateSuccessTip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@-webkit-keyframes animateSuccessLong{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}@keyframes animateSuccessLong{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}.swal-icon--info{border-color:#c9dae1}.swal-icon--info:before{width:5px;height:29px;bottom:17px;border-radius:2px;margin-left:-2px}.swal-icon--info:after,.swal-icon--info:before{content:"";position:absolute;left:50%;background-color:#c9dae1}.swal-icon--info:after{width:7px;height:7px;border-radius:50%;margin-left:-3px;top:19px}.swal-icon{width:80px;height:80px;border-width:4px;border-style:solid;border-radius:50%;padding:0;position:relative;box-sizing:content-box;margin:20px auto}.swal-icon:first-child{margin-top:32px}.swal-icon--custom{width:auto;height:auto;max-width:100%;border:none;border-radius:0}.swal-icon img{max-width:100%;max-height:100%}.swal-title{color:rgba(0,0,0,.65);font-weight:600;text-transform:none;position:relative;display:block;padding:13px 16px;font-size:27px;line-height:normal;text-align:center;margin-bottom:0}.swal-title:first-child{margin-top:26px}.swal-title:not(:first-child){padding-bottom:0}.swal-title:not(:last-child){margin-bottom:13px}.swal-text{font-size:16px;position:relative;float:none;line-height:normal;vertical-align:top;text-align:left;display:inline-block;margin:0;padding:0 10px;font-weight:400;color:rgba(0,0,0,.64);max-width:calc(100% - 20px);overflow-wrap:break-word;box-sizing:border-box}.swal-text:first-child{margin-top:45px}.swal-text:last-child{margin-bottom:45px}.swal-footer{text-align:right;padding-top:13px;margin-top:13px;padding:13px 16px;border-radius:inherit;border-top-left-radius:0;border-top-right-radius:0}.swal-button-container{margin:5px;display:inline-block;position:relative}.swal-button{background-color:#7cd1f9;color:#fff;border:none;box-shadow:none;border-radius:5px;font-weight:600;font-size:14px;padding:10px 24px;margin:0;cursor:pointer}.swal-button[not:disabled]:hover{background-color:#78cbf2}.swal-button:active{background-color:#70bce0}.swal-button:focus{outline:none;box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(43,114,165,.29)}.swal-button[disabled]{opacity:.5;cursor:default}.swal-button::-moz-focus-inner{border:0}.swal-button--cancel{color:#555;background-color:#efefef}.swal-button--cancel[not:disabled]:hover{background-color:#e8e8e8}.swal-button--cancel:active{background-color:#d7d7d7}.swal-button--cancel:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(116,136,150,.29)}.swal-button--danger{background-color:#e64942}.swal-button--danger[not:disabled]:hover{background-color:#df4740}.swal-button--danger:active{background-color:#cf423b}.swal-button--danger:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(165,43,43,.29)}.swal-content{padding:0 20px;margin-top:20px;font-size:medium}.swal-content:last-child{margin-bottom:20px}.swal-content__input,.swal-content__textarea{-webkit-appearance:none;background-color:#fff;border:none;font-size:14px;display:block;box-sizing:border-box;width:100%;border:1px solid rgba(0,0,0,.14);padding:10px 13px;border-radius:2px;transition:border-color .2s}.swal-content__input:focus,.swal-content__textarea:focus{outline:none;border-color:#6db8ff}.swal-content__textarea{resize:vertical}.swal-button--loading{color:transparent}.swal-button--loading~.swal-button__loader{opacity:1}.swal-button__loader{position:absolute;height:auto;width:43px;z-index:2;left:50%;top:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);text-align:center;pointer-events:none;opacity:0}.swal-button__loader div{display:inline-block;float:none;vertical-align:baseline;width:9px;height:9px;padding:0;border:none;margin:2px;opacity:.4;border-radius:7px;background-color:hsla(0,0%,100%,.9);transition:background .2s;-webkit-animation:swal-loading-anim 1s infinite;animation:swal-loading-anim 1s infinite}.swal-button__loader div:nth-child(3n+2){-webkit-animation-delay:.15s;animation-delay:.15s}.swal-button__loader div:nth-child(3n+3){-webkit-animation-delay:.3s;animation-delay:.3s}@-webkit-keyframes swal-loading-anim{0%{opacity:.4}20%{opacity:.4}50%{opacity:1}to{opacity:.4}}@keyframes swal-loading-anim{0%{opacity:.4}20%{opacity:.4}50%{opacity:1}to{opacity:.4}}.swal-overlay{position:fixed;top:0;bottom:0;left:0;right:0;text-align:center;font-size:0;overflow-y:auto;background-color:rgba(0,0,0,.4);z-index:10000;pointer-events:none;opacity:0;transition:opacity .3s}.swal-overlay:before{content:" ";display:inline-block;vertical-align:middle;height:100%}.swal-overlay--show-modal{opacity:1;pointer-events:auto}.swal-overlay--show-modal .swal-modal{opacity:1;pointer-events:auto;box-sizing:border-box;-webkit-animation:showSweetAlert .3s;animation:showSweetAlert .3s;will-change:transform}.swal-modal{width:478px;opacity:0;pointer-events:none;background-color:#fff;text-align:center;border-radius:5px;position:static;margin:20px auto;display:inline-block;vertical-align:middle;-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:50% 50%;transform-origin:50% 50%;z-index:10001;transition:opacity .2s,-webkit-transform .3s;transition:transform .3s,opacity .2s;transition:transform .3s,opacity .2s,-webkit-transform .3s}@media (max-width:500px){.swal-modal{width:calc(100% - 20px)}}@-webkit-keyframes showSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1)}1%{-webkit-transform:scale(.5);transform:scale(.5)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes showSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1)}1%{-webkit-transform:scale(.5);transform:scale(.5)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}',""])},function(t,e){function n(t,e){var n=t[1]||"",r=t[3];if(!r)return n;if(e&&"function"==typeof btoa){var i=o(r);return[n].concat(r.sources.map(function(t){return"/*# sourceURL="+r.sourceRoot+t+" */"})).concat([i]).join("\n")}return[n].join("\n")}function o(t){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(t))))+" */"}t.exports=function(t){var e=[];return e.toString=function(){return this.map(function(e){var o=n(e,t);return e[2]?"@media "+e[2]+"{"+o+"}":o}).join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var o={},r=0;r<this.length;r++){var i=this[r][0];"number"==typeof i&&(o[i]=!0)}for(r=0;r<t.length;r++){var a=t[r];"number"==typeof a[0]&&o[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),e.push(a))}},e}},function(t,e,n){function o(t,e){for(var n=0;n<t.length;n++){var o=t[n],r=m[o.id];if(r){r.refs++;for(var i=0;i<r.parts.length;i++)r.parts[i](o.parts[i]);for(;i<o.parts.length;i++)r.parts.push(u(o.parts[i],e))}else{for(var a=[],i=0;i<o.parts.length;i++)a.push(u(o.parts[i],e));m[o.id]={id:o.id,refs:1,parts:a}}}}function r(t,e){for(var n=[],o={},r=0;r<t.length;r++){var i=t[r],a=e.base?i[0]+e.base:i[0],s=i[1],c=i[2],l=i[3],u={css:s,media:c,sourceMap:l};o[a]?o[a].parts.push(u):n.push(o[a]={id:a,parts:[u]})}return n}function i(t,e){var n=v(t.insertInto);if(!n)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var o=w[w.length-1];if("top"===t.insertAt)o?o.nextSibling?n.insertBefore(e,o.nextSibling):n.appendChild(e):n.insertBefore(e,n.firstChild),w.push(e);else{if("bottom"!==t.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(e)}}function a(t){if(null===t.parentNode)return!1;t.parentNode.removeChild(t);var e=w.indexOf(t);e>=0&&w.splice(e,1)}function s(t){var e=document.createElement("style");return t.attrs.type="text/css",l(e,t.attrs),i(t,e),e}function c(t){var e=document.createElement("link");return t.attrs.type="text/css",t.attrs.rel="stylesheet",l(e,t.attrs),i(t,e),e}function l(t,e){Object.keys(e).forEach(function(n){t.setAttribute(n,e[n])})}function u(t,e){var n,o,r,i;if(e.transform&&t.css){if(!(i=e.transform(t.css)))return function(){};t.css=i}if(e.singleton){var l=h++;n=g||(g=s(e)),o=f.bind(null,n,l,!1),r=f.bind(null,n,l,!0)}else t.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=c(e),o=p.bind(null,n,e),r=function(){a(n),n.href&&URL.revokeObjectURL(n.href)}):(n=s(e),o=d.bind(null,n),r=function(){a(n)});return o(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;o(t=e)}else r()}}function f(t,e,n,o){var r=n?"":o.css;if(t.styleSheet)t.styleSheet.cssText=x(e,r);else{var i=document.createTextNode(r),a=t.childNodes;a[e]&&t.removeChild(a[e]),a.length?t.insertBefore(i,a[e]):t.appendChild(i)}}function d(t,e){var n=e.css,o=e.media;if(o&&t.setAttribute("media",o),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}function p(t,e,n){var o=n.css,r=n.sourceMap,i=void 0===e.convertToAbsoluteUrls&&r;(e.convertToAbsoluteUrls||i)&&(o=y(o)),r&&(o+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");var a=new Blob([o],{type:"text/css"}),s=t.href;t.href=URL.createObjectURL(a),s&&URL.revokeObjectURL(s)}var m={},b=function(t){var e;return function(){return void 0===e&&(e=t.apply(this,arguments)),e}}(function(){return window&&document&&document.all&&!window.atob}),v=function(t){var e={};return function(n){return void 0===e[n]&&(e[n]=t.call(this,n)),e[n]}}(function(t){return document.querySelector(t)}),g=null,h=0,w=[],y=n(15);t.exports=function(t,e){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");e=e||{},e.attrs="object"==typeof e.attrs?e.attrs:{},e.singleton||(e.singleton=b()),e.insertInto||(e.insertInto="head"),e.insertAt||(e.insertAt="bottom");var n=r(t,e);return o(n,e),function(t){for(var i=[],a=0;a<n.length;a++){var s=n[a],c=m[s.id];c.refs--,i.push(c)}if(t){o(r(t,e),e)}for(var a=0;a<i.length;a++){var c=i[a];if(0===c.refs){for(var l=0;l<c.parts.length;l++)c.parts[l]();delete m[c.id]}}}};var x=function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}}()},function(t,e){t.exports=function(t){var e="undefined"!=typeof window&&window.location;if(!e)throw new Error("fixUrls requires window.location");if(!t||"string"!=typeof t)return t;var n=e.protocol+"//"+e.host,o=n+e.pathname.replace(/\/[^\/]*$/,"/");return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(t,e){var r=e.trim().replace(/^"(.*)"$/,function(t,e){return e}).replace(/^'(.*)'$/,function(t,e){return e});if(/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(r))return t;var i;return i=0===r.indexOf("//")?r:0===r.indexOf("/")?n+r:o+r.replace(/^\.\//,""),"url("+JSON.stringify(i)+")"})}},function(t,e,n){var o=n(17);"undefined"==typeof window||window.Promise||(window.Promise=o),n(21),String.prototype.includes||(String.prototype.includes=function(t,e){"use strict";return"number"!=typeof e&&(e=0),!(e+t.length>this.length)&&-1!==this.indexOf(t,e)}),Array.prototype.includes||Object.defineProperty(Array.prototype,"includes",{value:function(t,e){if(null==this)throw new TypeError('"this" is null or not defined');var n=Object(this),o=n.length>>>0;if(0===o)return!1;for(var r=0|e,i=Math.max(r>=0?r:o-Math.abs(r),0);i<o;){if(function(t,e){return t===e||"number"==typeof t&&"number"==typeof e&&isNaN(t)&&isNaN(e)}(n[i],t))return!0;i++}return!1}}),"undefined"!=typeof window&&function(t){t.forEach(function(t){t.hasOwnProperty("remove")||Object.defineProperty(t,"remove",{configurable:!0,enumerable:!0,writable:!0,value:function(){this.parentNode.removeChild(this)}})})}([Element.prototype,CharacterData.prototype,DocumentType.prototype])},function(t,e,n){(function(e){!function(n){function o(){}function r(t,e){return function(){t.apply(e,arguments)}}function i(t){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof t)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],f(t,this)}function a(t,e){for(;3===t._state;)t=t._value;if(0===t._state)return void t._deferreds.push(e);t._handled=!0,i._immediateFn(function(){var n=1===t._state?e.onFulfilled:e.onRejected;if(null===n)return void(1===t._state?s:c)(e.promise,t._value);var o;try{o=n(t._value)}catch(t){return void c(e.promise,t)}s(e.promise,o)})}function s(t,e){try{if(e===t)throw new TypeError("A promise cannot be resolved with itself.");if(e&&("object"==typeof e||"function"==typeof e)){var n=e.then;if(e instanceof i)return t._state=3,t._value=e,void l(t);if("function"==typeof n)return void f(r(n,e),t)}t._state=1,t._value=e,l(t)}catch(e){c(t,e)}}function c(t,e){t._state=2,t._value=e,l(t)}function l(t){2===t._state&&0===t._deferreds.length&&i._immediateFn(function(){t._handled||i._unhandledRejectionFn(t._value)});for(var e=0,n=t._deferreds.length;e<n;e++)a(t,t._deferreds[e]);t._deferreds=null}function u(t,e,n){this.onFulfilled="function"==typeof t?t:null,this.onRejected="function"==typeof e?e:null,this.promise=n}function f(t,e){var n=!1;try{t(function(t){n||(n=!0,s(e,t))},function(t){n||(n=!0,c(e,t))})}catch(t){if(n)return;n=!0,c(e,t)}}var d=setTimeout;i.prototype.catch=function(t){return this.then(null,t)},i.prototype.then=function(t,e){var n=new this.constructor(o);return a(this,new u(t,e,n)),n},i.all=function(t){var e=Array.prototype.slice.call(t);return new i(function(t,n){function o(i,a){try{if(a&&("object"==typeof a||"function"==typeof a)){var s=a.then;if("function"==typeof s)return void s.call(a,function(t){o(i,t)},n)}e[i]=a,0==--r&&t(e)}catch(t){n(t)}}if(0===e.length)return t([]);for(var r=e.length,i=0;i<e.length;i++)o(i,e[i])})},i.resolve=function(t){return t&&"object"==typeof t&&t.constructor===i?t:new i(function(e){e(t)})},i.reject=function(t){return new i(function(e,n){n(t)})},i.race=function(t){return new i(function(e,n){for(var o=0,r=t.length;o<r;o++)t[o].then(e,n)})},i._immediateFn="function"==typeof e&&function(t){e(t)}||function(t){d(t,0)},i._unhandledRejectionFn=function(t){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",t)},i._setImmediateFn=function(t){i._immediateFn=t},i._setUnhandledRejectionFn=function(t){i._unhandledRejectionFn=t},void 0!==t&&t.exports?t.exports=i:n.Promise||(n.Promise=i)}(this)}).call(e,n(18).setImmediate)},function(t,e,n){function o(t,e){this._id=t,this._clearFn=e}var r=Function.prototype.apply;e.setTimeout=function(){return new o(r.call(setTimeout,window,arguments),clearTimeout)},e.setInterval=function(){return new o(r.call(setInterval,window,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},o.prototype.unref=o.prototype.ref=function(){},o.prototype.close=function(){this._clearFn.call(window,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout(function(){t._onTimeout&&t._onTimeout()},e))},n(19),e.setImmediate=setImmediate,e.clearImmediate=clearImmediate},function(t,e,n){(function(t,e){!function(t,n){"use strict";function o(t){"function"!=typeof t&&(t=new Function(""+t));for(var e=new Array(arguments.length-1),n=0;n<e.length;n++)e[n]=arguments[n+1];var o={callback:t,args:e};return l[c]=o,s(c),c++}function r(t){delete l[t]}function i(t){var e=t.callback,o=t.args;switch(o.length){case 0:e();break;case 1:e(o[0]);break;case 2:e(o[0],o[1]);break;case 3:e(o[0],o[1],o[2]);break;default:e.apply(n,o)}}function a(t){if(u)setTimeout(a,0,t);else{var e=l[t];if(e){u=!0;try{i(e)}finally{r(t),u=!1}}}}if(!t.setImmediate){var s,c=1,l={},u=!1,f=t.document,d=Object.getPrototypeOf&&Object.getPrototypeOf(t);d=d&&d.setTimeout?d:t,"[object process]"==={}.toString.call(t.process)?function(){s=function(t){e.nextTick(function(){a(t)})}}():function(){if(t.postMessage&&!t.importScripts){var e=!0,n=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage("","*"),t.onmessage=n,e}}()?function(){var e="setImmediate$"+Math.random()+"$",n=function(n){n.source===t&&"string"==typeof n.data&&0===n.data.indexOf(e)&&a(+n.data.slice(e.length))};t.addEventListener?t.addEventListener("message",n,!1):t.attachEvent("onmessage",n),s=function(n){t.postMessage(e+n,"*")}}():t.MessageChannel?function(){var t=new MessageChannel;t.port1.onmessage=function(t){a(t.data)},s=function(e){t.port2.postMessage(e)}}():f&&"onreadystatechange"in f.createElement("script")?function(){var t=f.documentElement;s=function(e){var n=f.createElement("script");n.onreadystatechange=function(){a(e),n.onreadystatechange=null,t.removeChild(n),n=null},t.appendChild(n)}}():function(){s=function(t){setTimeout(a,0,t)}}(),d.setImmediate=o,d.clearImmediate=r}}("undefined"==typeof self?void 0===t?this:t:self)}).call(e,n(7),n(20))},function(t,e){function n(){throw new Error("setTimeout has not been defined")}function o(){throw new Error("clearTimeout has not been defined")}function r(t){if(u===setTimeout)return setTimeout(t,0);if((u===n||!u)&&setTimeout)return u=setTimeout,setTimeout(t,0);try{return u(t,0)}catch(e){try{return u.call(null,t,0)}catch(e){return u.call(this,t,0)}}}function i(t){if(f===clearTimeout)return clearTimeout(t);if((f===o||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(t);try{return f(t)}catch(e){try{return f.call(null,t)}catch(e){return f.call(this,t)}}}function a(){b&&p&&(b=!1,p.length?m=p.concat(m):v=-1,m.length&&s())}function s(){if(!b){var t=r(a);b=!0;for(var e=m.length;e;){for(p=m,m=[];++v<e;)p&&p[v].run();v=-1,e=m.length}p=null,b=!1,i(t)}}function c(t,e){this.fun=t,this.array=e}function l(){}var u,f,d=t.exports={};!function(){try{u="function"==typeof setTimeout?setTimeout:n}catch(t){u=n}try{f="function"==typeof clearTimeout?clearTimeout:o}catch(t){f=o}}();var p,m=[],b=!1,v=-1;d.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];m.push(new c(t,e)),1!==m.length||b||r(s)},c.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=l,d.addListener=l,d.once=l,d.off=l,d.removeListener=l,d.removeAllListeners=l,d.emit=l,d.prependListener=l,d.prependOnceListener=l,d.listeners=function(t){return[]},d.binding=function(t){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(t){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(t,e,n){"use strict";n(22).polyfill()},function(t,e,n){"use strict";function o(t,e){if(void 0===t||null===t)throw new TypeError("Cannot convert first argument to object");for(var n=Object(t),o=1;o<arguments.length;o++){var r=arguments[o];if(void 0!==r&&null!==r)for(var i=Object.keys(Object(r)),a=0,s=i.length;a<s;a++){var c=i[a],l=Object.getOwnPropertyDescriptor(r,c);void 0!==l&&l.enumerable&&(n[c]=r[c])}}return n}function r(){Object.assign||Object.defineProperty(Object,"assign",{enumerable:!1,configurable:!0,writable:!0,value:o})}t.exports={assign:o,polyfill:r}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(24),r=n(6),i=n(5),a=n(36),s=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];if("undefined"!=typeof window){var n=a.getOpts.apply(void 0,t);return new Promise(function(t,e){i.default.promise={resolve:t,reject:e},o.default(n),setTimeout(function(){r.openModal()})})}};s.close=r.onAction,s.getState=r.getState,s.setActionValue=i.setActionValue,s.stopLoading=r.stopLoading,s.setDefaults=a.setDefaults,e.default=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(0),i=r.default.MODAL,a=n(4),s=n(34),c=n(35),l=n(1);e.init=function(t){o.getNode(i)||(document.body||l.throwErr("You can only use SweetAlert AFTER the DOM has loaded!"),s.default(),a.default()),a.initModalContent(t),c.default(t)},e.default=e.init},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.MODAL;e.modalMarkup='\n  <div class="'+r+'" role="dialog" aria-modal="true"></div>',e.default=e.modalMarkup},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.OVERLAY,i='<div \n    class="'+r+'"\n    tabIndex="-1">\n  </div>';e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.ICON;e.errorIconMarkup=function(){var t=r+"--error",e=t+"__line";return'\n    <div class="'+t+'__x-mark">\n      <span class="'+e+" "+e+'--left"></span>\n      <span class="'+e+" "+e+'--right"></span>\n    </div>\n  '},e.warningIconMarkup=function(){var t=r+"--warning";return'\n    <span class="'+t+'__body">\n      <span class="'+t+'__dot"></span>\n    </span>\n  '},e.successIconMarkup=function(){var t=r+"--success";return'\n    <span class="'+t+"__line "+t+'__line--long"></span>\n    <span class="'+t+"__line "+t+'__line--tip"></span>\n\n    <div class="'+t+'__ring"></div>\n    <div class="'+t+'__hide-corners"></div>\n  '}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.CONTENT;e.contentMarkup='\n  <div class="'+r+'">\n\n  </div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.BUTTON_CONTAINER,i=o.default.BUTTON,a=o.default.BUTTON_LOADER;e.buttonMarkup='\n  <div class="'+r+'">\n\n    <button\n      class="'+i+'"\n    ></button>\n\n    <div class="'+a+'">\n      <div></div>\n      <div></div>\n      <div></div>\n    </div>\n\n  </div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(4),r=n(2),i=n(0),a=i.default.ICON,s=i.default.ICON_CUSTOM,c=["error","warning","success","info"],l={error:r.errorIconMarkup(),warning:r.warningIconMarkup(),success:r.successIconMarkup()},u=function(t,e){var n=a+"--"+t;e.classList.add(n);var o=l[t];o&&(e.innerHTML=o)},f=function(t,e){e.classList.add(s);var n=document.createElement("img");n.src=t,e.appendChild(n)},d=function(t){if(t){var e=o.injectElIntoModal(r.iconMarkup);c.includes(t)?u(t,e):f(t,e)}};e.default=d},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(2),r=n(4),i=function(t){navigator.userAgent.includes("AppleWebKit")&&(t.style.display="none",t.offsetHeight,t.style.display="")};e.initTitle=function(t){if(t){var e=r.injectElIntoModal(o.titleMarkup);e.textContent=t,i(e)}},e.initText=function(t){if(t){var e=document.createDocumentFragment();t.split("\n").forEach(function(t,n,o){e.appendChild(document.createTextNode(t)),n<o.length-1&&e.appendChild(document.createElement("br"))});var n=r.injectElIntoModal(o.textMarkup);n.appendChild(e),i(n)}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(4),i=n(0),a=i.default.BUTTON,s=i.default.DANGER_BUTTON,c=n(3),l=n(2),u=n(6),f=n(5),d=function(t,e,n){var r=e.text,i=e.value,d=e.className,p=e.closeModal,m=o.stringToNode(l.buttonMarkup),b=m.querySelector("."+a),v=a+"--"+t;if(b.classList.add(v),d){(Array.isArray(d)?d:d.split(" ")).filter(function(t){return t.length>0}).forEach(function(t){b.classList.add(t)})}n&&t===c.CONFIRM_KEY&&b.classList.add(s),b.textContent=r;var g={};return g[t]=i,f.setActionValue(g),f.setActionOptionsFor(t,{closeModal:p}),b.addEventListener("click",function(){return u.onAction(t)}),m},p=function(t,e){var n=r.injectElIntoModal(l.footerMarkup);for(var o in t){var i=t[o],a=d(o,i,e);i.visible&&n.appendChild(a)}0===n.children.length&&n.remove()};e.default=p},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(3),r=n(4),i=n(2),a=n(5),s=n(6),c=n(0),l=c.default.CONTENT,u=function(t){t.addEventListener("input",function(t){var e=t.target,n=e.value;a.setActionValue(n)}),t.addEventListener("keyup",function(t){if("Enter"===t.key)return s.onAction(o.CONFIRM_KEY)}),setTimeout(function(){t.focus(),a.setActionValue("")},0)},f=function(t,e,n){var o=document.createElement(e),r=l+"__"+e;o.classList.add(r);for(var i in n){var a=n[i];o[i]=a}"input"===e&&u(o),t.appendChild(o)},d=function(t){if(t){var e=r.injectElIntoModal(i.contentMarkup),n=t.element,o=t.attributes;"string"==typeof n?f(e,n,o):e.appendChild(n)}};e.default=d},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(2),i=function(){var t=o.stringToNode(r.overlayMarkup);document.body.appendChild(t)};e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(5),r=n(6),i=n(1),a=n(3),s=n(0),c=s.default.MODAL,l=s.default.BUTTON,u=s.default.OVERLAY,f=function(t){t.preventDefault(),v()},d=function(t){t.preventDefault(),g()},p=function(t){if(o.default.isOpen)switch(t.key){case"Escape":return r.onAction(a.CANCEL_KEY)}},m=function(t){if(o.default.isOpen)switch(t.key){case"Tab":return f(t)}},b=function(t){if(o.default.isOpen)return"Tab"===t.key&&t.shiftKey?d(t):void 0},v=function(){var t=i.getNode(l);t&&(t.tabIndex=0,t.focus())},g=function(){var t=i.getNode(c),e=t.querySelectorAll("."+l),n=e.length-1,o=e[n];o&&o.focus()},h=function(t){t[t.length-1].addEventListener("keydown",m)},w=function(t){t[0].addEventListener("keydown",b)},y=function(){var t=i.getNode(c),e=t.querySelectorAll("."+l);e.length&&(h(e),w(e))},x=function(t){if(i.getNode(u)===t.target)return r.onAction(a.CANCEL_KEY)},_=function(t){var e=i.getNode(u);e.removeEventListener("click",x),t&&e.addEventListener("click",x)},k=function(t){o.default.timer&&clearTimeout(o.default.timer),t&&(o.default.timer=window.setTimeout(function(){return r.onAction(a.CANCEL_KEY)},t))},O=function(t){t.closeOnEsc?document.addEventListener("keyup",p):document.removeEventListener("keyup",p),t.dangerMode?v():g(),y(),_(t.closeOnClickOutside),k(t.timer)};e.default=O},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(3),i=n(37),a=n(38),s={title:null,text:null,icon:null,buttons:r.defaultButtonList,content:null,className:null,closeOnClickOutside:!0,closeOnEsc:!0,dangerMode:!1,timer:null},c=Object.assign({},s);e.setDefaults=function(t){c=Object.assign({},s,t)};var l=function(t){var e=t&&t.button,n=t&&t.buttons;return void 0!==e&&void 0!==n&&o.throwErr("Cannot set both 'button' and 'buttons' options!"),void 0!==e?{confirm:e}:n},u=function(t){return o.ordinalSuffixOf(t+1)},f=function(t,e){o.throwErr(u(e)+" argument ('"+t+"') is invalid")},d=function(t,e){var n=t+1,r=e[n];o.isPlainObject(r)||void 0===r||o.throwErr("Expected "+u(n)+" argument ('"+r+"') to be a plain object")},p=function(t,e){var n=t+1,r=e[n];void 0!==r&&o.throwErr("Unexpected "+u(n)+" argument ("+r+")")},m=function(t,e,n,r){var i=typeof e,a="string"===i,s=e instanceof Element;if(a){if(0===n)return{text:e};if(1===n)return{text:e,title:r[0]};if(2===n)return d(n,r),{icon:e};f(e,n)}else{if(s&&0===n)return d(n,r),{content:e};if(o.isPlainObject(e))return p(n,r),e;f(e,n)}};e.getOpts=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];var n={};t.forEach(function(e,o){var r=m(0,e,o,t);Object.assign(n,r)});var o=l(n);n.buttons=r.getButtonListOpts(o),delete n.button,n.content=i.getContentOpts(n.content);var u=Object.assign({},s,c,n);return Object.keys(u).forEach(function(t){a.DEPRECATED_OPTS[t]&&a.logDeprecation(t)}),u}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r={element:"input",attributes:{placeholder:""}};e.getContentOpts=function(t){var e={};return o.isPlainObject(t)?Object.assign(e,t):t instanceof Element?{element:t}:"input"===t?r:null}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.logDeprecation=function(t){var n=e.DEPRECATED_OPTS[t],o=n.onlyRename,r=n.replacement,i=n.subOption,a=n.link,s=o?"renamed":"deprecated",c='SweetAlert warning: "'+t+'" option has been '+s+".";if(r){c+=" Please use"+(i?' "'+i+'" in ':" ")+'"'+r+'" instead.'}var l="https://sweetalert.js.org";c+=a?" More details: "+l+a:" More details: "+l+"/guides/#upgrading-from-1x",console.warn(c)},e.DEPRECATED_OPTS={type:{replacement:"icon",link:"/docs/#icon"},imageUrl:{replacement:"icon",link:"/docs/#icon"},customClass:{replacement:"className",onlyRename:!0,link:"/docs/#classname"},imageSize:{},showCancelButton:{replacement:"buttons",link:"/docs/#buttons"},showConfirmButton:{replacement:"button",link:"/docs/#button"},confirmButtonText:{replacement:"button",link:"/docs/#button"},confirmButtonColor:{},cancelButtonText:{replacement:"buttons",link:"/docs/#buttons"},closeOnConfirm:{replacement:"button",subOption:"closeModal",link:"/docs/#button"},closeOnCancel:{replacement:"buttons",subOption:"closeModal",link:"/docs/#buttons"},showLoaderOnConfirm:{replacement:"buttons"},animation:{},inputType:{replacement:"content",link:"/docs/#content"},inputValue:{replacement:"content",link:"/docs/#content"},inputPlaceholder:{replacement:"content",link:"/docs/#content"},html:{replacement:"content",link:"/docs/#content"},allowEscapeKey:{replacement:"closeOnEsc",onlyRename:!0,link:"/docs/#closeonesc"},allowClickOutside:{replacement:"closeOnClickOutside",onlyRename:!0,link:"/docs/#closeonclickoutside"}}}])});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("162o").setImmediate, __webpack_require__("162o").clearImmediate))

/***/ }),

/***/ "trYX":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1067);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1067:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1068), __webpack_require__(1069), __webpack_require__(1070) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "autocomplete",
	    name: "AutoComplete",
	    category: "web",
	    description: "The AutoComplete widget provides suggestions depending on the typed text.It also allows multiple value entries.",
	    depends: [ "list" ],
	    features: [ {
	        id: "mobile-scroller",
	        name: "Mobile scroller",
	        description: "Support for kinetic scrolling in mobile device",
	        depends: [ "mobile.scroller" ]
	    }, {
	        id: "virtualization",
	        name: "VirtualList",
	        description: "Support for virtualization",
	        depends: [ "virtuallist" ]
	    } ]
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        support = kendo.support,
	        caret = kendo.caret,
	        activeElement = kendo._activeElement,
	        placeholderSupported = support.placeholder,
	        ui = kendo.ui,
	        List = ui.List,
	        keys = kendo.keys,
	        DataSource = kendo.data.DataSource,
	        ARIA_DISABLED = "aria-disabled",
	        ARIA_READONLY = "aria-readonly",
	        CHANGE = "change",
	        DEFAULT = "k-state-default",
	        DISABLED = "disabled",
	        READONLY = "readonly",
	        FOCUSED = "k-state-focused",
	        SELECTED = "k-state-selected",
	        STATEDISABLED = "k-state-disabled",
	        AUTOCOMPLETEVALUE = "off",
	        HOVER = "k-state-hover",
	        ns = ".kendoAutoComplete",
	        HOVEREVENTS = "mouseenter" + ns + " mouseleave" + ns,
	        proxy = $.proxy;

	    function indexOfWordAtCaret(caretIdx, text, separator) {
	        return separator ? text.substring(0, caretIdx).split(separator).length - 1 : 0;
	    }

	    function wordAtCaret(caretIdx, text, separator) {
	        return text.split(separator)[indexOfWordAtCaret(caretIdx, text, separator)];
	    }

	    function replaceWordAtCaret(caretIdx, text, word, separator, defaultSeparator) {
	        var words = text.split(separator);

	        words.splice(indexOfWordAtCaret(caretIdx, text, separator), 1, word);

	        if (separator && words[words.length - 1] !== "") {
	            words.push("");
	        }

	        return words.join(defaultSeparator);
	    }

	    var AutoComplete = List.extend({
	        init: function (element, options) {
	            var that = this, wrapper, disabled;

	            that.ns = ns;
	            options = $.isArray(options) ? { dataSource: options} : options;

	            List.fn.init.call(that, element, options);

	            element = that.element;
	            options = that.options;

	            options.placeholder = options.placeholder || element.attr("placeholder");
	            if (placeholderSupported) {
	                element.attr("placeholder", options.placeholder);
	            }

	            that._wrapper();
	            that._loader();
	            that._clearButton();

	            that._dataSource();
	            that._ignoreCase();

	            element[0].type = "text";
	            wrapper = that.wrapper;

	            that._popup();

	            element
	                .addClass("k-input")
	                .on("keydown" + ns, proxy(that._keydown, that))
	                .on("keypress" + ns, proxy(that._keypress, that))
	                .on("input" + ns, proxy(that._search, that))
	                .on("paste" + ns, proxy(that._search, that))
	                .on("focus" + ns, function () {
	                    that._prev = that._accessor();
	                    that._oldText = that._prev;
	                    that._placeholder(false);
	                    wrapper.addClass(FOCUSED);
	                })
	                .on("focusout" + ns, function () {
	                    that._change();
	                    that._placeholder();
	                    that.close();
	                    wrapper.removeClass(FOCUSED);
	                })
	                .attr({
	                    autocomplete: AUTOCOMPLETEVALUE,
	                    role: "textbox",
	                    "aria-haspopup": true
	                });

	            that._clear.on("click" + ns + " touchend" + ns, proxy(that._clearValue, that));
	            that._enable();

	            that._old = that._accessor();

	            if (element[0].id) {
	                element.attr("aria-owns", that.ul[0].id);
	            }

	            that._aria();

	            that._placeholder();

	            that._initList();

	            disabled = $(that.element).parents("fieldset").is(':disabled');

	            if (disabled) {
	                that.enable(false);
	            }

	            that.listView.bind("click", function(e) { e.preventDefault(); });

	            that._resetFocusItemHandler = $.proxy(that._resetFocusItem, that);

	            kendo.notify(that);
	            that._toggleCloseVisibility();
	        },

	        options: {
	            name: "AutoComplete",
	            enabled: true,
	            suggest: false,
	            template: "",
	            groupTemplate: "#:data#",
	            fixedGroupTemplate: "#:data#",
	            dataTextField: "",
	            minLength: 1,
	            enforceMinLength: false,
	            delay: 200,
	            height: 200,
	            filter: "startswith",
	            ignoreCase: true,
	            highlightFirst: false,
	            separator: null,
	            placeholder: "",
	            animation: {},
	            virtual: false,
	            value: null,
	            clearButton: true,
	            autoWidth: false,
	            popup: null
	        },

	        _dataSource: function() {
	            var that = this;

	            if (that.dataSource && that._refreshHandler) {
	                that._unbindDataSource();
	            } else {
	                that._progressHandler = proxy(that._showBusy, that);
	                that._errorHandler = proxy(that._hideBusy, that);
	            }

	            that.dataSource = DataSource.create(that.options.dataSource)
	                .bind("progress", that._progressHandler)
	                .bind("error", that._errorHandler);
	        },

	        setDataSource: function(dataSource) {
	            this.options.dataSource = dataSource;
	            this._dataSource();

	            this.listView.setDataSource(this.dataSource);
	        },

	        events: [
	            "open",
	            "close",
	            CHANGE,
	            "select",
	            "filtering",
	            "dataBinding",
	            "dataBound"
	        ],

	        setOptions: function(options) {
	            var listOptions = this._listOptions(options);

	            List.fn.setOptions.call(this, options);

	            this.listView.setOptions(listOptions);
	            this._accessors();
	            this._aria();
	            this._clearButton();
	        },

	        _listOptions: function(options) {
	            var listOptions = List.fn._listOptions.call(this, $.extend(options, {
	                skipUpdateOnBind: true
	            }));

	            listOptions.dataValueField = listOptions.dataTextField;
	            listOptions.selectedItemChange = null;

	            return listOptions;
	        },

	        _editable: function(options) {
	            var that = this,
	                element = that.element,
	                wrapper = that.wrapper.off(ns),
	                readonly = options.readonly,
	                disable = options.disable;

	            if (!readonly && !disable) {
	                wrapper
	                    .addClass(DEFAULT)
	                    .removeClass(STATEDISABLED)
	                    .on(HOVEREVENTS, that._toggleHover);

	                element.removeAttr(DISABLED)
	                       .removeAttr(READONLY)
	                       .attr(ARIA_DISABLED, false)
	                       .attr(ARIA_READONLY, false);
	            } else {
	                wrapper
	                    .addClass(disable ? STATEDISABLED : DEFAULT)
	                    .removeClass(disable ? DEFAULT : STATEDISABLED);

	                element.attr(DISABLED, disable)
	                       .attr(READONLY, readonly)
	                       .attr(ARIA_DISABLED, disable)
	                       .attr(ARIA_READONLY, readonly);
	            }
	        },

	        close: function () {
	            var that = this;
	            var current = that.listView.focus();

	            if (current) {
	                current.removeClass(SELECTED);
	            }

	            that.popup.close();
	        },

	        destroy: function() {
	            var that = this;

	            that.element.off(ns);
	            that._clear.off(ns);
	            that.wrapper.off(ns);

	            List.fn.destroy.call(that);
	        },

	        refresh: function() {
	            this.listView.refresh();
	        },

	        select: function (li) {
	            this._select(li);
	        },

	        search: function (word) {
	            var that = this,
	            options = that.options,
	            ignoreCase = options.ignoreCase,
	            separator = that._separator(),
	            length,
	            accentFoldingFiltering = that.dataSource.options.accentFoldingFiltering;

	            word = word || that._accessor();

	            clearTimeout(that._typingTimeout);

	            if (separator) {
	                word = wordAtCaret(caret(that.element)[0], word, separator);
	            }

	            length = word.length;

	            if ((!options.enforceMinLength && !length) || length >= options.minLength) {
	                that._open = true;

	                that._mute(function() {
	                    this.listView.value([]);
	                });

	                that._filterSource({
	                    value: ignoreCase ? (accentFoldingFiltering ? word.toLocaleLowerCase(accentFoldingFiltering) : word.toLowerCase()) : word,
	                    operator: options.filter,
	                    field: options.dataTextField,
	                    ignoreCase: ignoreCase
	                });

	                that.one("close", $.proxy(that._unifySeparators, that));
	            }
	            that._toggleCloseVisibility();
	        },

	        suggest: function (word) {
	            var that = this,
	                key = that._last,
	                value = that._accessor(),
	                element = that.element[0],
	                caretIdx = caret(element)[0],
	                separator = that._separator(),
	                words = value.split(separator),
	                wordIndex = indexOfWordAtCaret(caretIdx, value, separator),
	                selectionEnd = caretIdx,
	                idx,
	                accentFoldingFiltering = that.dataSource.options.accentFoldingFiltering;

	            if (key == keys.BACKSPACE || key == keys.DELETE) {
	                that._last = undefined;
	                return;
	            }

	            word = word || "";

	            if (typeof word !== "string") {
	                if (word[0]) {
	                    word = that.dataSource.view()[List.inArray(word[0], that.ul[0])];
	                }

	                word = word ? that._text(word) : "";
	            }

	            if (caretIdx <= 0) {
	                caretIdx = (accentFoldingFiltering ? value.toLocaleLowerCase(accentFoldingFiltering) : value.toLowerCase()).indexOf(accentFoldingFiltering ? word.toLocaleLowerCase(accentFoldingFiltering) : word.toLowerCase()) + 1;
	            }

	            idx = value.substring(0, caretIdx).lastIndexOf(separator);
	            idx = idx > -1 ? caretIdx - (idx + separator.length) : caretIdx;
	            value = words[wordIndex].substring(0, idx);

	            if (word) {
	                word = word.toString();
	                idx = (accentFoldingFiltering ? word.toLocaleLowerCase(accentFoldingFiltering) : word.toLowerCase()).indexOf(accentFoldingFiltering ? value.toLocaleLowerCase(accentFoldingFiltering) : value.toLowerCase());
	                if (idx > -1) {
	                    word = word.substring(idx + value.length);

	                    selectionEnd = caretIdx + word.length;

	                    value += word;
	                }

	                if (separator && words[words.length - 1] !== "") {
	                    words.push("");
	                }

	            }

	            words[wordIndex] = value;

	            that._accessor(words.join(separator || ""));

	            if (element === activeElement()) {
	                caret(element, caretIdx, selectionEnd);
	            }
	        },

	        value: function (value) {
	            if (value !== undefined) {
	                this.listView.value(value);

	                this._accessor(value);
	                this._old = this._accessor();
	                this._oldText = this._accessor();
	            } else {
	                return this._accessor();
	            }
	            this._toggleCloseVisibility();
	        },

	        _click: function(e) {
	            var item = e.item;
	            var that = this;
	            var element = that.element;
	            var dataItem = that.listView.dataItemByIndex(that.listView.getElementIndex(item));

	            e.preventDefault();

	            that._active = true;

	            if (that.trigger("select", { dataItem: dataItem, item: item })) {
	                that.close();
	                return;
	            }
	            that._oldText = element.val();
	            that._select(item).done(function() {
	                that._blur();

	                caret(element, element.val().length);
	            });
	        },

	        _clearText: $.noop,

	        _resetFocusItem: function() {
	            var index = this.options.highlightFirst ? 0 : -1;

	            if (this.options.virtual) {
	                this.listView.scrollTo(0);
	            }

	            this.listView.focus(index);
	        },

	        _listBound: function() {
	            var that = this;
	            var popup = that.popup;
	            var options = that.options;
	            var data = that.dataSource.flatView();
	            var length = data.length;
	            var groupsLength = that.dataSource._group ? that.dataSource._group.length : 0;
	            var isActive = that.element[0] === activeElement();
	            var action;

	            that._renderFooter();
	            that._renderNoData();
	            that._toggleNoData(!length);
	            that._toggleHeader(!!groupsLength && !!length);

	            that._resizePopup();

	            popup.position();

	            if (length) {
	                if (options.suggest && isActive && that._inputValue()) {
	                    that.suggest(data[0]);
	                }
	            }

	            if (that._open) {
	                that._open = false;
	                action = that._allowOpening() ? "open" : "close";

	                if (that._typingTimeout && !isActive) {
	                    action = "close";
	                }

	                if (length) {
	                    that._resetFocusItem();

	                    if (options.virtual) {
	                        that.popup
	                            .unbind("activate", that._resetFocusItemHandler)
	                            .one("activate", that._resetFocusItemHandler);
	                    }
	                }

	                popup[action]();
	                that._typingTimeout = undefined;
	            }

	            if (that._touchScroller) {
	                that._touchScroller.reset();
	            }

	            that._hideBusy();
	            that._makeUnselectable();

	            that.trigger("dataBound");
	        },

	        _mute: function(callback) {
	            this._muted = true;
	            callback.call(this);
	            this._muted = false;
	        },

	        _listChange: function() {
	            var isActive = this._active || this.element[0] === activeElement();

	            if (isActive && !this._muted) {
	                this._selectValue(this.listView.selectedDataItems()[0]);
	            }
	        },

	        _selectValue: function(dataItem) {
	            var separator = this._separator();
	            var text = "";

	            if (dataItem) {
	                text = this._text(dataItem);
	            }

	            if (text === null) {
	                text = "";
	            }

	            if (separator) {
	                text = replaceWordAtCaret(caret(this.element)[0], this._accessor(), text, separator, this._defaultSeparator());
	            }

	            this._prev = text;
	            this._accessor(text);
	            this._placeholder();
	        },

	        _unifySeparators: function() {
	            this._accessor(this.value().split(this._separator()).join(this._defaultSeparator()));
	            return this;
	        },

	        _preselect: function(value, text) {
	            this._inputValue(text);
	            this._accessor(value);

	            this._old = this.oldText =  this._accessor();

	            this.listView.setValue(value);
	            this._placeholder();
	        },

	        _change: function() {
	            var that = this;
	            var value = that._unifySeparators().value();
	            var trigger = value !== List.unifyType(that._old, typeof value);

	            var valueUpdated = trigger && !that._typing;
	            var itemSelected = that._oldText !== value;

	            that._old = value;
	            that._oldText = value;

	            if (valueUpdated || itemSelected) {
	                // trigger the DOM change event so any subscriber gets notified
	                that.element.trigger(CHANGE);
	            }

	            if (trigger) {
	                that.trigger(CHANGE);
	            }

	            that.typing = false;
	            that._toggleCloseVisibility();
	        },

	        _accessor: function (value) {
	            var that = this,
	                element = that.element[0];

	            if (value !== undefined) {
	                element.value = value === null ? "" : value;
	                that._placeholder();
	            } else {
	                value = element.value;

	                if (element.className.indexOf("k-readonly") > -1) {
	                    if (value === that.options.placeholder) {
	                        return "";
	                    } else {
	                        return value;
	                    }
	                }

	                return value;
	            }
	        },

	        _keydown: function (e) {
	            var that = this;
	            var key = e.keyCode;
	            var listView = that.listView;
	            var visible = that.popup.visible();
	            var current = listView.focus();

	            that._last = key;

	            if (key === keys.DOWN) {
	                if (visible) {
	                    this._move(current ? "focusNext" : "focusFirst");
	                } else if (that.value()) {
	                    that._filterSource({
	                        value: that.ignoreCase ? that.value().toLowerCase() : that.value(),
	                        operator: that.options.filter,
	                        field: that.options.dataTextField,
	                        ignoreCase: that.ignoreCase
	                    }).done(function () {
	                        if (that._allowOpening()) {
	                            that._resetFocusItem();
	                            that.popup.open();
	                        }
	                    });
	                }
	                e.preventDefault();
	            } else if (key === keys.UP) {
	                if (visible) {
	                    this._move(current ? "focusPrev" : "focusLast");
	                }
	                e.preventDefault();
	            } else if (key === keys.HOME) {
	                this._move("focusFirst");
	            } else if (key === keys.END) {
	                this._move("focusLast");
	            } else if (key === keys.ENTER || key === keys.TAB) {

	                if (key === keys.ENTER && visible) {
	                    e.preventDefault();
	                }

	                if (visible && current) {
	                    var dataItem = listView.dataItemByIndex(listView.getElementIndex(current));
	                    if (that.trigger("select", { dataItem: dataItem, item: current })) {
	                        return;
	                    }

	                    this._select(current);
	                }

	                this._blur();
	            } else if (key === keys.ESC) {
	                if (visible) {
	                    e.preventDefault();
	                } else {
	                    that._clearValue();
	                }
	                that.close();
	            } else if (that.popup.visible() && (key === keys.PAGEDOWN || key === keys.PAGEUP)) {
	                e.preventDefault();

	                var direction = key === keys.PAGEDOWN ? 1 : -1;
	                listView.scrollWith(direction * listView.screenHeight());
	            } else {
	                // In some cases when the popup is opened resize is triggered which will cause it to close
	                // Setting the below flag will prevent this from happening
	                that.popup._hovered = true;
	                that._search();
	            }
	        },

	        _keypress: function() {
	            this._oldText = this.element.val();
	            this._typing = true;
	        },

	        _move: function (action) {
	            this.listView[action]();

	            if (this.options.suggest) {
	                this.suggest(this.listView.focus());
	            }
	        },

	        _hideBusy: function () {
	            var that = this;
	            clearTimeout(that._busy);
	            that._loading.hide();
	            that.element.attr("aria-busy", false);
	            that._busy = null;
	            that._showClear();
	        },

	        _showBusy: function () {
	            var that = this;

	            if (that._busy) {
	                return;
	            }

	            that._busy = setTimeout(function () {
	                that.element.attr("aria-busy", true);
	                that._loading.show();
	                that._hideClear();
	            }, 100);
	        },

	        _placeholder: function(show) {
	            if (placeholderSupported) {
	                return;
	            }

	            var that = this,
	                element = that.element,
	                placeholder = that.options.placeholder,
	                value;

	            if (placeholder) {
	                value = element.val();

	                if (show === undefined) {
	                    show = !value;
	                }

	                if (!show) {
	                    if (value !== placeholder) {
	                        placeholder = value;
	                    } else {
	                        placeholder = "";
	                    }
	                }

	                if (value === that._old && !show) {
	                    return;
	                }

	                element.toggleClass("k-readonly", show)
	                       .val(placeholder);

	                if (!placeholder && element[0] === document.activeElement) {
	                    caret(element[0], 0, 0);
	                }
	            }
	        },

	        _separator: function() {
	            var separator = this.options.separator;
	            if (separator instanceof Array) {
	               return new RegExp(separator.join("|"), 'gi');
	            }
	            return separator;
	        },

	        _defaultSeparator: function() {
	            var separator = this.options.separator;
	            if (separator instanceof Array) {
	                return separator[0];
	            }
	            return separator;
	        },

	        _inputValue: function() {
	            return this.element.val();
	        },

	        _search: function () {
	            var that = this;
	            clearTimeout(that._typingTimeout);

	            that._typingTimeout = setTimeout(function () {
	                if (that._prev !== that._accessor()) {
	                    that._prev = that._accessor();
	                    that.search();
	                }
	            }, that.options.delay);
	        },

	        _select: function(candidate) {
	            var that = this;
	            that._active = true;

	            return that.listView.select(candidate).done(function() {
	                that._active = false;
	            });
	        },

	        _loader: function() {
	            this._loading = $('<span class="k-icon k-i-loading" style="display:none"></span>').insertAfter(this.element);
	        },

	        _clearButton: function() {
	            List.fn._clearButton.call(this);

	            if (this.options.clearButton) {
	                this._clear.insertAfter(this.element);
	                this.wrapper.addClass("k-autocomplete-clearable");
	            }
	        },

	        _toggleHover: function(e) {
	            $(e.currentTarget).toggleClass(HOVER, e.type === "mouseenter");
	        },

	        _toggleCloseVisibility: function() {
	            if (this.value()) {
	                this._showClear();
	            } else {
	                this._hideClear();
	            }
	        },

	        _wrapper: function () {
	            var that = this,
	                element = that.element,
	                DOMelement = element[0],
	                wrapper;

	            wrapper = element.parent();

	            if (!wrapper.is("span.k-widget")) {
	                wrapper = element.wrap("<span />").parent();
	            }

	            wrapper.attr("tabindex", -1);
	            wrapper.attr("role", "presentation");

	            wrapper[0].style.cssText = DOMelement.style.cssText;
	            element.css({
	                width: "",
	                height: DOMelement.style.height
	            });

	            that._focused = that.element;
	            that.wrapper = wrapper
	                .addClass("k-widget k-autocomplete")
	                .addClass(DOMelement.className)
	                .removeClass('input-validation-error');

	            that._inputWrapper = $(wrapper[0]);
	        },

	        _clearValue: function() {
	            List.fn._clearValue.call(this);
	            this.element.focus();
	        }
	    });

	    ui.plugin(AutoComplete);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1068:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("S/9S");

/***/ }),

/***/ 1069:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("jBxA");

/***/ }),

/***/ 1070:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("bFti");

/***/ })

/******/ });

/***/ }),

/***/ "tvEw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var gridPanel_1 = __webpack_require__("inOk");
var linkedList_1 = __webpack_require__("oUmy");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var AnimationFrameService = (function () {
    function AnimationFrameService() {
        this.p1Tasks = new linkedList_1.LinkedList();
        this.p2Tasks = new linkedList_1.LinkedList();
        this.ticking = false;
    }
    AnimationFrameService.prototype.init = function () {
        this.useAnimationFrame = !this.gridOptionsWrapper.isSuppressAnimationFrame();
    };
    // this method is for our ag-Grid sanity only - if animation frames are turned off,
    // then no place in the code should be looking to add any work to be done in animation
    // frames. this stops bugs - where some code is asking for a frame to be executed
    // when it should not.
    AnimationFrameService.prototype.verifyAnimationFrameOn = function (methodName) {
        if (this.useAnimationFrame === false) {
            console.warn("ag-Grid: AnimationFrameService." + methodName + " called but animation frames are off");
        }
    };
    AnimationFrameService.prototype.addP1Task = function (task) {
        this.verifyAnimationFrameOn('addP1Task');
        this.p1Tasks.add(task);
        this.schedule();
    };
    AnimationFrameService.prototype.addP2Task = function (task) {
        this.verifyAnimationFrameOn('addP2Task');
        this.p2Tasks.add(task);
        this.schedule();
    };
    AnimationFrameService.prototype.executeFrame = function (millis) {
        this.verifyAnimationFrameOn('executeFrame');
        var frameStart = new Date().getTime();
        var duration = (new Date().getTime()) - frameStart;
        var gridPanelNeedsAFrame = true;
        // 16ms is 60 fps
        var noMaxMillis = millis <= 0;
        while (noMaxMillis || duration < millis) {
            if (gridPanelNeedsAFrame) {
                gridPanelNeedsAFrame = this.gridPanel.executeFrame();
            }
            else if (!this.p1Tasks.isEmpty()) {
                var task = this.p1Tasks.remove();
                task();
            }
            else if (!this.p2Tasks.isEmpty()) {
                var task = this.p2Tasks.remove();
                task();
            }
            else {
                break;
            }
            duration = (new Date().getTime()) - frameStart;
        }
        if (gridPanelNeedsAFrame || !this.p1Tasks.isEmpty() || !this.p2Tasks.isEmpty()) {
            this.requestFrame();
        }
        else {
            this.ticking = false;
        }
    };
    AnimationFrameService.prototype.flushAllFrames = function () {
        if (!this.useAnimationFrame) {
            return;
        }
        this.executeFrame(-1);
    };
    AnimationFrameService.prototype.schedule = function () {
        if (!this.useAnimationFrame) {
            return;
        }
        if (!this.ticking) {
            this.ticking = true;
            this.requestFrame();
        }
    };
    AnimationFrameService.prototype.requestFrame = function () {
        // check for the existence of requestAnimationFrame, and if
        // it's missing, then we polyfill it with setTimeout()
        var callback = this.executeFrame.bind(this, 60);
        if (window.requestAnimationFrame) {
            window.requestAnimationFrame(callback);
        }
        else if (window.webkitRequestAnimationFrame) {
            window.webkitRequestAnimationFrame(callback);
        }
        else {
            setTimeout(callback, 0);
        }
    };
    __decorate([
        context_1.Autowired('gridPanel'),
        __metadata("design:type", gridPanel_1.GridPanel)
    ], AnimationFrameService.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], AnimationFrameService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AnimationFrameService.prototype, "init", null);
    AnimationFrameService = __decorate([
        context_1.Bean('animationFrameService')
    ], AnimationFrameService);
    return AnimationFrameService;
}());
exports.AnimationFrameService = AnimationFrameService;


/***/ }),

/***/ "twYp":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1572);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1572:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1573)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "pdfjs-processor",
	    name: "PDFJS-Processor",
	    category: "framework",
	    depends: [ "core" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        Class = kendo.Class,
	        extend = $.extend,
	        atob = window.atob,
	        PDFJS;

	    var PDFJSProcessor = Class.extend({
	        init: function(options, viewer) {
	            var that = this;

	            if (kendo.pdfviewer.pdfjs.isLoaded()) {
	                PDFJS = kendo.pdfviewer.pdfjs.lib;
	            }

	            that.file = options.file;
	            that.viewer = viewer;
	        },
	        fetchDocument: function () {
	            var that = this,
	                deferred = $.Deferred(),
	                messages = that.viewer.options.messages.errorMessages;

	            if (!that.file) {
	                return deferred.resolve();
	            }

	            if (that._isBase64Data() && atob)
	            {
	                that.file.data = atob(that.file.data);
	            }

	            PDFJS.getDocument(this.file).promise.then(function (pdf) {
	                var pageSizes = [];
	                that.pdf = pdf;
	                that.pagePromises = [];
	                that._downloadData = $.Deferred();

	                pdf.getData().then(function (data) {
	                    var blob = new Blob([data], { type: 'application/pdf' });
	                    that._downloadData.resolve({
	                        file: blob
	                    });
	                });

	                for (var i = 1; i <= pdf.numPages; i++) {
	                    that.pagePromises.push(pdf.getPage(i));
	                }

	                Promise.all(that.pagePromises).then(function (pagePromises) {
	                    pageSizes = pagePromises.map(function (pagePromise) {
	                        var viewport = pagePromise.getViewport({scale: 4/3});
	                        return {
	                            width: viewport.width,
	                            height: viewport.height
	                        };
	                    });

	                    deferred.resolve({
	                        total: pdf.numPages,
	                        pages: pageSizes
	                    });
	                }).catch(function (e) { // jshint ignore:line
	                    that.viewer._triggerError({
	                        error: e.message,
	                        message: messages.parseError
	                    });
	                });

	            }).catch(function (e) { // jshint ignore:line
	                var notFoundError = e.name.includes("Missing");
	                var alertMessage = notFoundError ? messages.notFound : messages.parseError;
	                that.viewer._triggerError({
	                    error: e.message,
	                    message: alertMessage
	                });
	                if (notFoundError) {
	                    that.viewer._renderBlankPage();
	                }
	            });

	            return deferred;
	        },
	        fetchPageData: function (number) {
	            return this.pagePromises[number - 1];
	        },
	        downloadFile: function (fileName) {
	            var that = this;
	            kendo.ui.progress(that.viewer.pageContainer, true);

	            that._downloadData.done(function (result) {
	                kendo.ui.progress(that.viewer.pageContainer, false);

	                var reader = new FileReader();
	                reader.readAsDataURL(result.file);

	                reader.onload = function() {
	                    kendo.saveAs({
	                        dataURI: reader.result,
	                        fileName: fileName + ".pdf",
	                        proxyURL: function() {
	                            return reader.result;
	                        }
	                    });
	                };
	            });
	        },
	        _updateDocument: function (file) {
	            if(this.pdf && this.pdf.loadingTask) {
	                this.pdf.loadingTask.destroy();
	            }

	            this.file = file;
	        },
	        _isBase64Data: function () {
	            var data = this.file.data,
	                notBase64 = /[^A-Z0-9+\/=]/i,
	                length = data && data.length,
	                equalSign;

	            if (!length || length % 4 !== 0 || notBase64.test(data)) {
	                return false;
	            }

	            equalSign = data.indexOf('=');

	            return equalSign === -1 ||
	                equalSign === length - 1 ||
	                (equalSign === length - 2 && data[length - 1] === '=');
	        },
	        renderTextLayer: function (params) {
	            PDFJS.renderTextLayer(params);
	        }
	    });

	    extend(kendo.pdfviewer.pdfjs, {
	        processor: PDFJSProcessor
	    });
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1573:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("vZ2x");

/***/ })

/******/ });

/***/ }),

/***/ "twlb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
// This should be a component
var BorderLayout = (function () {
    function BorderLayout(params) {
        this.centerHeightLastTime = -1;
        this.centerWidthLastTime = -1;
        this.centerLeftMarginLastTime = -1;
        this.visibleLastTime = false;
        this.sizeChangeListeners = [];
        this.isLayoutPanel = true;
        this.fullHeight = !params.north && !params.south;
        var template;
        if (params.dontFill) {
            template = BorderLayout.TEMPLATE_DONT_FILL;
            this.horizontalLayoutActive = false;
            this.verticalLayoutActive = false;
        }
        else if (params.fillHorizontalOnly) {
            template = BorderLayout.TEMPLATE_DONT_FILL;
            this.horizontalLayoutActive = true;
            this.verticalLayoutActive = false;
        }
        else {
            if (this.fullHeight) {
                template = BorderLayout.TEMPLATE_FULL_HEIGHT;
            }
            else {
                template = BorderLayout.TEMPLATE_NORMAL;
            }
            this.horizontalLayoutActive = true;
            this.verticalLayoutActive = true;
        }
        this.eGui = utils_1.Utils.loadTemplate(template);
        this.id = 'borderLayout';
        if (params.name) {
            this.id += '_' + params.name;
        }
        this.eGui.setAttribute('id', this.id);
        this.childPanels = [];
        if (params) {
            this.setupPanels(params);
        }
        if (params.componentRecipes) {
            this.overlayWrapper = params.componentRecipes.newOverlayWrapperComponent();
        }
    }
    BorderLayout.prototype.addSizeChangeListener = function (listener) {
        this.sizeChangeListeners.push(listener);
    };
    BorderLayout.prototype.fireSizeChanged = function () {
        this.sizeChangeListeners.forEach(function (listener) {
            listener();
        });
    };
    // this logic is also in Component.ts - the plan is sometime in the future,
    // this layout panel may (or may not) extend the Component class, and somehow
    // act as a component.
    BorderLayout.prototype.getRefElement = function (refName) {
        return this.eGui.querySelector('[ref="' + refName + '"]');
    };
    BorderLayout.prototype.setupPanels = function (params) {
        this.eNorthWrapper = this.getRefElement('north');
        this.eSouthWrapper = this.getRefElement('south');
        this.eEastWrapper = this.getRefElement('east');
        this.eWestWrapper = this.getRefElement('west');
        this.eCenterWrapper = this.getRefElement('center');
        this.eOverlayWrapper = this.getRefElement('overlay');
        this.eCenterRow = this.getRefElement('centerRow');
        // initially hide the overlay. this is needed for IE10, if we don't hide the overlay,
        // then it grabs mouse events, and it blocks clicking on the grid (as the overlay consumes
        // the mouse events).
        this.eOverlayWrapper.style.display = 'none';
        this.eNorthChildLayout = this.setupPanel(params.north, this.eNorthWrapper);
        this.eSouthChildLayout = this.setupPanel(params.south, this.eSouthWrapper);
        this.eEastChildLayout = this.setupPanel(params.east, this.eEastWrapper);
        this.eWestChildLayout = this.setupPanel(params.west, this.eWestWrapper);
        this.eCenterChildLayout = this.setupPanel(params.center, this.eCenterWrapper);
    };
    BorderLayout.prototype.setupPanel = function (content, ePanel) {
        if (!ePanel) {
            return;
        }
        if (content) {
            if (content.isLayoutPanel) {
                this.childPanels.push(content);
                ePanel.appendChild(content.getGui());
                return content;
            }
            else {
                ePanel.appendChild(content);
                return null;
            }
        }
        else {
            ePanel.parentNode.removeChild(ePanel);
            return null;
        }
    };
    BorderLayout.prototype.getGui = function () {
        return this.eGui;
    };
    // returns true if any item changed size, otherwise returns false
    BorderLayout.prototype.doLayout = function () {
        var _this = this;
        var isVisible = utils_1.Utils.isVisible(this.eGui);
        if (!isVisible) {
            this.visibleLastTime = false;
            return false;
        }
        var atLeastOneChanged = false;
        if (this.visibleLastTime !== isVisible) {
            atLeastOneChanged = true;
        }
        this.visibleLastTime = true;
        var childLayouts = [this.eNorthChildLayout, this.eSouthChildLayout, this.eEastChildLayout, this.eWestChildLayout];
        childLayouts.forEach(function (childLayout) {
            var childChangedSize = _this.layoutChild(childLayout);
            if (childChangedSize) {
                atLeastOneChanged = true;
            }
        });
        if (this.horizontalLayoutActive) {
            var ourWidthChanged = this.layoutWidth();
            if (ourWidthChanged) {
                atLeastOneChanged = true;
            }
        }
        if (this.verticalLayoutActive) {
            var ourHeightChanged = this.layoutHeight();
            if (ourHeightChanged) {
                atLeastOneChanged = true;
            }
        }
        var centerChanged = this.layoutChild(this.eCenterChildLayout);
        if (centerChanged) {
            atLeastOneChanged = true;
        }
        if (atLeastOneChanged) {
            this.fireSizeChanged();
        }
        return atLeastOneChanged;
    };
    BorderLayout.prototype.layoutChild = function (childPanel) {
        if (childPanel) {
            return childPanel.doLayout();
        }
        else {
            return false;
        }
    };
    BorderLayout.prototype.layoutHeight = function () {
        if (this.fullHeight) {
            return this.layoutHeightFullHeight();
        }
        else {
            return this.layoutHeightNormal();
        }
    };
    // full height never changes the height, because the center is always 100%,
    // however we do check for change, to inform the listeners
    BorderLayout.prototype.layoutHeightFullHeight = function () {
        var centerHeight = utils_1.Utils.offsetHeight(this.eGui);
        if (centerHeight < 0) {
            centerHeight = 0;
        }
        if (this.centerHeightLastTime !== centerHeight) {
            this.centerHeightLastTime = centerHeight;
            return true;
        }
        else {
            return false;
        }
    };
    BorderLayout.prototype.layoutHeightNormal = function () {
        var totalHeight = utils_1.Utils.offsetHeight(this.eGui);
        var northHeight = utils_1.Utils.offsetHeight(this.eNorthWrapper);
        var southHeight = utils_1.Utils.offsetHeight(this.eSouthWrapper);
        var centerHeight = totalHeight - northHeight - southHeight;
        if (centerHeight < 0) {
            centerHeight = 0;
        }
        if (this.centerHeightLastTime !== centerHeight) {
            this.eCenterRow.style.height = centerHeight + 'px';
            this.centerHeightLastTime = centerHeight;
            return true; // return true because there was a change
        }
        else {
            return false;
        }
    };
    BorderLayout.prototype.getCentreHeight = function () {
        return this.centerHeightLastTime;
    };
    BorderLayout.prototype.layoutWidth = function () {
        var totalWidth = utils_1.Utils.offsetWidth(this.eGui);
        var eastWidth = utils_1.Utils.offsetWidth(this.eEastWrapper);
        var westWidth = utils_1.Utils.offsetWidth(this.eWestWrapper);
        var centerWidth = totalWidth - eastWidth - westWidth;
        if (centerWidth < 0) {
            centerWidth = 0;
        }
        var atLeastOneChanged = false;
        if (this.centerLeftMarginLastTime !== westWidth) {
            this.centerLeftMarginLastTime = westWidth;
            this.eCenterWrapper.style.marginLeft = westWidth + 'px';
            atLeastOneChanged = true;
        }
        if (this.centerWidthLastTime !== centerWidth) {
            this.centerWidthLastTime = centerWidth;
            this.eCenterWrapper.style.width = centerWidth + 'px';
            atLeastOneChanged = true;
        }
        return atLeastOneChanged;
    };
    BorderLayout.prototype.setEastVisible = function (visible) {
        if (this.eEastWrapper) {
            this.eEastWrapper.style.display = visible ? '' : 'none';
        }
        this.doLayout();
    };
    BorderLayout.prototype.showLoadingOverlay = function () {
        this.overlayWrapper.showLoadingOverlay(this.eOverlayWrapper);
    };
    BorderLayout.prototype.showNoRowsOverlay = function () {
        this.overlayWrapper.showNoRowsOverlay(this.eOverlayWrapper);
    };
    BorderLayout.prototype.hideOverlay = function () {
        this.overlayWrapper.hideOverlay(this.eOverlayWrapper);
    };
    // this is used if there user has not specified any north or south parts
    BorderLayout.TEMPLATE_FULL_HEIGHT = '<div class="ag-bl ag-bl-full-height">' +
        '  <div class="ag-bl-west ag-bl-full-height-west" ref="west"></div>' +
        '  <div class="ag-bl-east ag-bl-full-height-east" ref="east"></div>' +
        '  <div class="ag-bl-center ag-bl-full-height-center" ref="center"></div>' +
        '  <div class="ag-bl-overlay" ref="overlay"></div>' +
        '</div>';
    BorderLayout.TEMPLATE_NORMAL = '<div class="ag-bl ag-bl-normal">' +
        '  <div ref="north"></div>' +
        '  <div class="ag-bl-center-row ag-bl-normal-center-row" ref="centerRow">' +
        '    <div class="ag-bl-west ag-bl-normal-west" ref="west"></div>' +
        '    <div class="ag-bl-east ag-bl-normal-east" ref="east"></div>' +
        '    <div class="ag-bl-center ag-bl-normal-center" ref="center"></div>' +
        '  </div>' +
        '  <div ref="south"></div>' +
        '  <div class="ag-bl-overlay" ref="overlay"></div>' +
        '</div>';
    BorderLayout.TEMPLATE_DONT_FILL = '<div class="ag-bl ag-bl-dont-fill">' +
        '  <div ref="north"></div>' +
        '  <div ref="centerRow" class="ag-bl-center-row ag-bl-dont-fill-center-row">' +
        '    <div ref="west" class="ag-bl-west ag-bl-dont-fill-west"></div>' +
        '    <div ref="east" class="ag-bl-east ag-bl-dont-fill-east"></div>' +
        '    <div ref="center" class="ag-bl-center ag-bl-dont-fill-center"></div>' +
        '  </div>' +
        '  <div ref="south"></div>' +
        '  <div class="ag-bl-overlay" ref="overlay"></div>' +
        '</div>';
    return BorderLayout;
}());
exports.BorderLayout = BorderLayout;


/***/ }),

/***/ "txAZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1481);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1089:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("+Uqz");

/***/ }),

/***/ 1474:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2Mfy");

/***/ }),

/***/ 1475:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("8Fbg");

/***/ }),

/***/ 1481:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1474), __webpack_require__(1089), __webpack_require__(1475) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "wizard",
	    name: "Wizard",
	    category: "web",
	    description: "The Wizard widget serves as a container of stepped process.",
	    depends: [ "stepper", "button", "form" ],
	    features: [{
	        id: "wizard-form-dropdowns",
	        name: "DropDowns",
	        description: "Support for DropDown editors in Wizard From",
	        depends: [ "autocomplete", "combobox", "multiselect", "dropdowntree", "multicolumncombobox" ]
	    }, {
	        id: "wizard-form-datepickers",
	        name: "DatePickers",
	        description: "Support for DatePicker editors in Wizard From",
	        depends: [ "dateinput", "datepicker", "datetimepicker", "timepicker" ]
	    }, {
	        id: "wizard-form-inputs",
	        name: "Inputs",
	        description: "Support for Input editors in Wizard From",
	        depends: [ "numerictextbox", "maskedtextbox", "switch", "rating", "slider", "colorpicker" ]
	    }, {
	        id: "wizard-form-editor",
	        name: "Editor",
	        description: "Support for Editor editor in Wizard From",
	        depends: [ "editor" ]
	    }]
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        extend = $.extend,
	        proxy = $.proxy,

	        WIZARD = ".kendoWizard",

	        CLICK = "click",
	        ACTIVATE = "activate",
	        SELECT = "select",
	        RESET = "reset",
	        SUBMIT = "submit",
	        PREVIOUS = "previous",
	        NEXT = "next",
	        DONE = "done",
	        ERROR = "error",
	        CONTENTLOAD = "contentLoad",
	        FORM_VALIDATE_FAILED = "formValidateFailed",

	        HIDDEN = "k-hidden",
	        PRIMARY = "k-primary",
	        STEPPER_STEP_LINK = "k-step-link",

	        ARIA_SELECTED = "aria-selected",
	        ARIA_CONTROLS = "aria-controls",
	        ARIA_HIDDEN = "aria-hidden",
	        ARIA_EXPANDED = "aria-expanded",
	        ARIA_LABEL = "aria-label",

	        VERTICAL = "vertical",
	        HORIZONTAL = "horizontal",
	        BOTTOM = "bottom",
	        RIGHT = "right",
	        LEFT = "left",

	        DOT = ".",
	        SPACE = " ",
	        DASH = "-",
	        ID = "id",
	        TABINDEX = "tabindex",
	        ROLE = "role",
	        DATA_WIZARD_PREFIX = "data-wizard-";

	    var wizardClasses = {
	        wizard: "k-widget k-wizard",
	        horizontalWizard: "k-wizard-horizontal",
	        verticalWizard: "k-wizard-vertical",
	        rightWizard: "k-wizard-right",
	        leftWizard: "k-wizard-left",
	        wizardStepsContainer: "k-wizard-steps",
	        wizardStep: "k-wizard-step",
	        wizardContent: "k-wizard-content",
	        wizardButtons: "k-wizard-buttons",
	        wizardLeftButtons: "k-wizard-buttons-left",
	        wizardRightButtons: "k-wizard-buttons-right",
	        wizardPager: "k-wizard-pager"
	    };

	    var Step = kendo.Class.extend({
	        init: function(options) {
	            this.options = extend({}, this.options, options);

	            if(this.options.actionBar) {
	                this._processButtons();
	            }

	            this._render();
	        },

	        options: {
	            name: "WizardStep",
	            index: 0,
	            content: "",
	            contentUrl: null,
	            contentId: null,
	            markupContainer: null,
	            form: null,
	            actionBar: true,
	            buttons: [],
	            pager: true,
	            selected: false,
	            enabled: true,
	            className: "",
	            totalSteps: 1,
	            wizardId: "wizard",
	            formTag: "form",
	            messages: {}
	        },

	        _defaultButtonsConfiguration: {
	            first: [RESET,NEXT],
	            middle: [RESET,PREVIOUS,NEXT],
	            last: [RESET,PREVIOUS,DONE]
	        },

	        _pagerTemplate: '<span class="k-wizard-pager">' +
	            '#: step # ' +
	            '#: currentStep # ' +
	            '#: of # ' +
	            '#: totalSteps #' +
	        '</span>',

	        buttons: function() {
	            return this._buttons;
	        },

	        load: function() {
	            if(this.options.contentUrl) {
	                this._ajaxRequest();
	            }
	        },

	        resetButtons: function() {
	            var buttonsContainer = this.element.find(DOT + wizardClasses.wizardButtons);

	            kendo.destroy(buttonsContainer);
	            buttonsContainer.remove();

	            this.options.buttons = [];
	            this._processButtons();
	            this._buttonsContainer();
	        },

	        _ajaxRequest: function (wizard, triggerActivate) {
	            var that = this,
	                url = that.options.contentUrl,
	                data = {},
	                element = that.element;

	            var ajaxOptions = {
	                type: "GET",
	                cache: false,
	                url: url,
	                dataType: "html",
	                data: data,

	                error: function (xhr, status) {
	                    if(wizard) {
	                        wizard._triggerError(xhr, status, that);
	                    }
	                },

	                complete: function () {
	                    if(wizard && triggerActivate) {
	                        wizard._triggerActivate(that);
	                    }
	                },

	                success: function (content) {
	                    var contentElement = element.find(DOT + wizardClasses.wizardContent);

	                    try {
	                        if(wizard) {
	                            wizard.angular("cleanup", function () { return { elements: element.get() }; });
	                        }

	                        kendo.destroy(contentElement);
	                        contentElement.html(content);

	                        if(wizard) {
	                            wizard._triggerContentLoad(that);
	                        }
	                    } catch (e) {
	                        this.error(this.xhr, "error");
	                    }

	                    if(wizard) {
	                        wizard.angular("compile", function(){ return { elements: element.get() }; });
	                    }
	                }
	            };

	            if (typeof url === "object") {
	                ajaxOptions = $.extend(true, {}, ajaxOptions, url);
	            }

	            $.ajax(ajaxOptions);
	        },

	        _ariaAttributes: function() {
	            var element = this.element,
	                options = this.options,
	                messages = options.messages,
	                label = messages.step + " " + (options.index + 1) + " " + messages.of + " " + options.totalSteps;

	            element.attr(ROLE, "tabpanel")
	                .attr(TABINDEX, 0)
	                .attr(ID, options.wizardId + DASH + options.index)
	                .attr(ARIA_EXPANDED, options.selected)
	                .attr(ARIA_LABEL, label);
	        },

	        _buttonFactory: function(buttonOptions) {
	            var button = $("<button type='button'>").kendoButton().getKendoButton(),
	                buttonElement = button.element;

	            buttonElement.attr(DATA_WIZARD_PREFIX + buttonOptions.name, "");
	            buttonElement.text(buttonOptions.text);

	            if(buttonOptions.click) {
	                button.bind(CLICK, buttonOptions.click);
	            }
	            if(buttonOptions.enabled === false) {
	                button.enable(false);
	            }
	            if(buttonOptions.primary) {
	                buttonElement.addClass(PRIMARY);
	            }

	            if(buttonOptions.position === LEFT) {
	                this._leftButtonsContainer.append(buttonElement);
	            } else {
	                this._rightButtonsContainer.append(buttonElement);
	            }

	            if(buttonOptions.name === "done" && this.options.formTag !== "form") {
	                button.element.attr("type", SUBMIT);
	            }

	            this._buttons.push(button);
	        },

	        _buttonsContainer: function() {
	            var buttonsContainer = $("<div>").addClass(wizardClasses.wizardButtons);

	            this._leftButtonsContainer = $("<span>").addClass(wizardClasses.wizardLeftButtons);
	            this._rightButtonsContainer = $("<span>").addClass(wizardClasses.wizardRightButtons);

	            buttonsContainer.append(this._leftButtonsContainer);
	            buttonsContainer.append(this._rightButtonsContainer);

	            this.element.append(buttonsContainer);

	            this._buttons = [];

	            this.options.buttons.map(proxy(this._buttonFactory, this));

	            if(this.options.pager) {
	                this._pager();
	            }
	        },

	        _content: function() {
	            var options = this.options,
	                loadFromRemote = !!options.contentUrl,
	                contentElement = $("<div>").addClass(wizardClasses.wizardContent);

	            if (!loadFromRemote && options.contentId) {
	                contentElement.html($("#" + options.contentId).html());
	            } else if (!loadFromRemote && options.content) {
	                contentElement.append(options.content);
	            }

	            if (options.markupContainer) {
	                if(!loadFromRemote && !options.contentId && !options.content) {
	                    contentElement.append(options.markupContainer.html());
	                }

	                kendo.destroy(options.markupContainer);
	                options.markupContainer.remove();
	            }

	            this.element.prepend(contentElement);
	        },

	        _form: function() {
	            var formTag = "<" + this.options.formTag + ">",
	                formElement = $(formTag).hide(),
	                contentElement = $("<div>").addClass(wizardClasses.wizardContent),
	                formOptions = this.options.form;

	            $("body").append(formElement);
	            this.element.prepend(contentElement);

	            formOptions.buttonsTemplate = formOptions.buttonsTemplate || "";
	            this.form = formElement.kendoForm(formOptions).getKendoForm();

	            contentElement.append(formElement.show());
	        },

	        _iterateButton: function(button) {
	            var messages = this.options.messages;

	            if(typeof button === "string") {
	                button = {
	                    name: button
	                };
	            }
	            if(!button.text) {
	                button.text = messages[button.name] || button.name.charAt(0).toUpperCase() + button.name.slice(1);
	            }
	            if(button.name === DONE || button.name === NEXT) {
	                button.primary = true;
	            }
	            if(!button.position && button.name === RESET) {
	                button.position = LEFT;
	            } else if(!button.position) {
	                button.position = RIGHT;
	            }

	            return button;
	        },

	        _pager: function() {
	            var options = this.options,
	                messages = options.messages,
	                pagerData = {
	                    step: messages.step,
	                    currentStep: options.index + 1,
	                    of: messages.of,
	                    totalSteps: options.totalSteps
	                },
	                pager = kendo.template(this._pagerTemplate)(pagerData);

	            this._leftButtonsContainer.append(pager);
	        },

	        _processButtons: function() {
	            var options = this.options,
	                buttonsOptions = options.buttons,
	                defaultButtons = this._defaultButtonsConfiguration;

	            if(!buttonsOptions || !buttonsOptions.length || buttonsOptions.length <= 0) {
	                if(options.index === 0) {
	                    buttonsOptions = defaultButtons.first;
	                } else if(options.index + 1 === options.totalSteps) {
	                    buttonsOptions = defaultButtons.last;
	                } else {
	                    buttonsOptions = defaultButtons.middle;
	                }
	            }

	            this.options.buttons = buttonsOptions.map(proxy(this._iterateButton, this));
	        },

	        _render: function() {
	            this.element = $("<div>").addClass(wizardClasses.wizardStep);

	            if(this.options.className) {
	                this.element.addClass(this.options.className);
	            }

	            this._ariaAttributes();

	            if(!this.options.selected) {
	                this.element.addClass(HIDDEN);
	                this.element.attr(ARIA_HIDDEN, true);
	            }

	            if(this.options.actionBar) {
	                this._buttonsContainer();
	            }

	            if(this.options.form) {
	                this._form();
	            } else {
	                this._content();
	            }
	        }
	    });

	    var Wizard = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            options = options || {};

	            Widget.fn.init.call(that, element, options);

	            that._wrapper();
	            that._createSteps();
	            that._stepper();
	            that._attachEvents();
	        },

	        options: {
	            name: "Wizard",
	            contentPosition: BOTTOM,
	            actionBar: true,
	            pager: true,
	            loadOnDemand: false,
	            reloadOnSelect: false,
	            validateForms: true,
	            stepper: {},
	            steps: [],
	            messages: {
	                reset: "Reset",
	                previous: "Previous",
	                next: "Next",
	                done: "Done",
	                step: "Step",
	                of: "of"
	            }
	        },

	        events: [
	            ACTIVATE,
	            SELECT,
	            RESET,
	            DONE,
	            ERROR,
	            CONTENTLOAD,
	            FORM_VALIDATE_FAILED
	        ],

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that.stepper);
	            Widget.fn.destroy.call(that);

	            that.wrapper.off(WIZARD);
	        },

	        activeStep: function() {
	            return this.currentStep;
	        },

	        enableStep: function(stepIndex, value) {
	            var that = this,
	                targetStep;

	            if(stepIndex === undefined || stepIndex === null || isNaN(stepIndex) || stepIndex >= that._steps.length || stepIndex < 0) {
	                return;
	            }

	            stepIndex = Number(stepIndex);
	            targetStep = that._steps[stepIndex];

	            if(targetStep.options.enabled === value) {
	                return;
	            } else {
	                targetStep.options.enabled = value;
	                that.stepper.steps()[stepIndex].enable(value);
	            }
	        },

	        insertAt: function(index, stepOptions) {
	            var steps = this._steps,
	                numberOfSteps = steps.length,
	                step, stepperStepOptions, alteredStepIndex, alteredStep,
	                iterateStep = function(step, i) {
	                    if(i >= index) {
	                        step.options.index += 1;
	                    }
	                    step.options.totalSteps += 1;
	                    step.element.find(DOT + wizardClasses.wizardPager).remove();
	                    step._pager();
	                };

	            if(index === null || index === undefined || isNaN(index) || index < 0 || index > numberOfSteps) {
	                return;
	            }
	            if(!stepOptions) {
	                return;
	            }

	            stepperStepOptions = this._mapStepForStepper(stepOptions);
	            this.stepper.insertAt(index, stepperStepOptions);

	            stepOptions.totalSteps = numberOfSteps + 1;
	            stepOptions.messages = this.options.messages;
	            stepOptions.index = index;
	            stepOptions.formTag = this.wrapper.is("form") ? "div" : "form";

	            if(this.options.pager === false && stepOptions.pager !== true) {
	                stepOptions.pager = false;
	            }

	            step = new Step(stepOptions);
	            steps.forEach(iterateStep);
	            steps.splice(index, 0, step);

	            if(index === 0 || index === numberOfSteps) {
	                alteredStepIndex = index === 0 ? 1 : numberOfSteps - 1;
	                alteredStep = steps[alteredStepIndex];
	                alteredStep.resetButtons();
	            }

	            this._insertStepElementAtIndex(index, step.element);
	        },

	        next: function() {
	            var that = this,
	                stepsLength = that._steps.length,
	                currentStepIndex = that.currentStep.options.index;

	            if(currentStepIndex + 1 === stepsLength) {
	                return;
	            } else if (!that.steps()[currentStepIndex + 1].options.enabled) {
	                return;
	            } else {
	                that._select(currentStepIndex + 1);
	                that._selectStepper(currentStepIndex + 1);
	            }

	        },

	        previous: function() {
	            var that = this,
	                currentStepIndex = that.currentStep.options.index;

	            if(currentStepIndex === 0) {
	                return;
	            } else if (!that.steps()[currentStepIndex - 1].options.enabled) {
	                return;
	            } else {
	                that._select(currentStepIndex - 1);
	                that._selectStepper(currentStepIndex - 1);
	            }
	        },

	        removeAt: function(index) {
	            var steps = this._steps,
	                numberOfSteps = steps.length,
	                removedStep, newSelectedStepIndex, alteredStepIndex, alteredStep, i, step;

	            if(index === null || index === undefined || isNaN(index) || index < 0 || index > numberOfSteps || numberOfSteps === 1) {
	                return;
	            }

	            this.stepper.removeAt(index);
	            removedStep = steps.splice(index, 1)[0];

	            if(removedStep === this.selectedStep) {
	                newSelectedStepIndex = index > 0 ? index - 1 : 0;
	                this.selectedStep = steps[newSelectedStepIndex];
	            }

	            for(i = 0; i < numberOfSteps - 1; i +=1) {
	                step = steps[i];
	                step.options.index = i;
	                step.options.totalSteps = numberOfSteps - 1;
	                step.element.find(DOT + wizardClasses.wizardPager).remove();
	                step._pager();
	            }

	            if(index === 0 || index === numberOfSteps - 2) {
	                alteredStepIndex = index === 0 ? 0 : numberOfSteps - 2;
	                alteredStep = steps[alteredStepIndex];
	                alteredStep.resetButtons();
	            }
	        },

	        select: function(stepIndex) {
	            var that = this,
	                stepper = that.stepper,
	                targetStep;

	            if(stepIndex === undefined || stepIndex === null || isNaN(stepIndex) || stepIndex >= that._steps.length || stepIndex < 0) {
	                return;
	            }

	            stepIndex = Number(stepIndex);
	            targetStep = that._steps[stepIndex];

	            if(!targetStep.options.enabled) {
	                return;
	            }

	            that._select(stepIndex);

	            if(stepper.options.linear) {
	                stepper.setOptions({ linear: false });
	                that._selectStepper(stepIndex);
	                stepper.setOptions({ linear: true });
	            } else {
	                that._selectStepper(stepIndex);
	            }
	        },

	        steps: function() {
	            return this._steps;
	        },

	        _attachEvents: function() {
	            var that = this;

	            that.stepper.bind(SELECT, proxy(that._stepperSelectHandler, that));

	            that.wrapper
	                .on(CLICK + WIZARD, "[" + DATA_WIZARD_PREFIX + RESET + "]", proxy(that._resetClickHandler, that))
	                .on(CLICK + WIZARD, "[" + DATA_WIZARD_PREFIX + PREVIOUS + "]", proxy(that._previousClickHandler, that))
	                .on(CLICK + WIZARD, "[" + DATA_WIZARD_PREFIX + NEXT + "]", proxy(that._nextClickHandler, that));

	            if(that.wrapper.is("form")) {
	                that.wrapper.on(SUBMIT + WIZARD, proxy(that._doneHandler, that));
	            } else {
	                that.wrapper.on(CLICK + WIZARD, "[" + DATA_WIZARD_PREFIX + DONE + "]", proxy(that._doneHandler, that));
	            }
	        },

	        _changeStep: function(step) {
	            var steps = this.wrapper.find(DOT + wizardClasses.wizardStep);

	            this.currentStep = step;

	            steps.addClass(HIDDEN);
	            steps.attr(ARIA_HIDDEN, true);
	            steps.attr(ARIA_EXPANDED, false);

	            step.element.removeClass(HIDDEN);
	            step.element.removeAttr(ARIA_HIDDEN);
	            step.element.attr(ARIA_EXPANDED, true);
	        },

	        _createStep: function(options, index, stepsFromMarkup, total) {
	            var wrapper = this.wrapper,
	                stepsFromMarkupTitles = this.wrapper.children("ol, ul").children("li");

	            if(typeof options === "string") {
	                options = {
	                    title: options
	                };
	            }

	            options.totalSteps = total;
	            options.messages = this.options.messages;
	            options.index = index;
	            options.formTag = this.wrapper.is("form") ? "div" : "form";

	            if(index === 0) {
	                options.selected = true;
	            }
	            if(this.options.actionBar === false) {
	                options.actionBar = false;
	            }
	            if(stepsFromMarkup.length > 0 && stepsFromMarkup[index]) {
	                options.markupContainer = $(stepsFromMarkup[index]);

	                if(!options.title) {
	                    options.title = stepsFromMarkupTitles[index] ? stepsFromMarkupTitles[index].textContent : (index + 1).toString();

	                    if(!this.options.steps) {
	                        this.options.steps = [];
	                    }

	                }
	            }
	            if(wrapper.attr(ID)) {
	                options.wizardId = wrapper.attr(ID);
	            }
	            if(this.options.pager === false && options.pager !== true) {
	                options.pager = false;
	            }

	            this.options.steps[index] = extend(true, {}, options);

	            return new Step(options);
	        },

	        _createSteps: function() {
	            var that = this,
	                wrapper = that.wrapper,
	                stepsOptions = that.options.steps,
	                stepsFromMarkup = wrapper.children("div"),
	                stepsContainer, i, stepOptions, step;

	            stepsContainer = $("<div>").addClass(wizardClasses.wizardStepsContainer);

	            that._steps = [];

	            if(!stepsOptions || stepsOptions.length === 0) {
	                stepsOptions = [];
	                for(i = 0; i < stepsFromMarkup.length; i+= 1) {
	                    stepsOptions.push({});
	                }
	            }

	            for(i = 0; i < stepsOptions.length; i += 1) {
	                stepOptions = stepsOptions[i];

	                step = that._createStep(stepOptions, i, stepsFromMarkup, stepsOptions.length);

	                if(stepOptions.contentUrl && (i === 0 || !that.options.loadOnDemand )) {
	                    kendo.ui.progress(that.wrapper, true);
	                    step._ajaxRequest(that);
	                }

	                stepsContainer.append(step.element);

	                that._steps.push(step);
	            }

	            wrapper.children("ol, ul").remove();

	            wrapper.empty();
	            wrapper.append(stepsContainer);
	            that._refreshEditorWidgets();

	            that.currentStep = that._steps[0];
	        },

	        _doneHandler: function(e) {
	            var steps = this._steps,
	                currentStep = this.currentStep,
	                forms = [],
	                form, i;

	            if(this.options.validateForms && !!currentStep.form && !currentStep.form.validator.validate()) {
	                e.preventDefault();
	                this.trigger(FORM_VALIDATE_FAILED, { sender: this, step: currentStep, form: currentStep.form });
	                return;
	            }

	            for(i = 0; i < steps.length; i += 1) {
	                form = steps[i].form;
	                if(form) {
	                    forms.push(form);
	                }
	            }

	            this.trigger(DONE, { sender: this, forms: forms, originalEvent: e, button: $(e.target).getKendoButton() });
	        },

	        _insertStepElementAtIndex: function(index, stepElement) {
	            var stepsContainer = this.wrapper.find(DOT + wizardClasses.wizardStepsContainer);

	            if(index === 0) {
	                stepsContainer.prepend(stepElement);
	            } else {
	                stepsContainer.find(DOT + wizardClasses.wizardStep + ":nth-child(" + index + ")").after(stepElement);
	            }
	        },

	        _isEmpty: function(element){
	            return !$.trim(element.html());
	        },

	        _mapStepForStepper: function(step) {
	            var stepperStep = extend(true, {}, step );

	            stepperStep.label = stepperStep.title;

	            delete stepperStep.title;
	            delete stepperStep.buttons;
	            delete stepperStep.pager;
	            delete stepperStep.content;
	            delete stepperStep.contentUrl;
	            delete stepperStep.contentId;

	            return stepperStep;
	        },

	        _select: function(index) {
	            var targetStep = this._steps[index],
	                options = this.options;

	            if(targetStep.options.contentUrl &&
	                (options.reloadOnSelect ||
	                    (options.loadOnDemand && this._isEmpty(targetStep.element.find(DOT + wizardClasses.wizardContent))))) {
	                this.ajaxLoad = true;
	                kendo.ui.progress(this.wrapper, true);
	                targetStep._ajaxRequest(this, true);
	            } else {
	                this._changeStep(targetStep);
	            }
	        },

	        _nextClickHandler: function(e) {
	            var that = this,
	                steps = that._steps,
	                numberOfSteps = that._steps.length,
	                currentStep = that.currentStep,
	                currentStepIndex = currentStep.options.index,
	                button = $(e.target).getKendoButton(),
	                targetStep = steps[currentStepIndex + 1];

	            if(numberOfSteps === currentStepIndex + 1 || !targetStep.options.enabled) {
	                return;
	            }

	            if(that.options.validateForms && !!currentStep.form && !currentStep.form.validator.validate()) {
	                that.trigger(FORM_VALIDATE_FAILED, { sender: that, step: currentStep, form: currentStep.form });
	                return;
	            }

	            if(!that.trigger(SELECT, {
	                sender: that,
	                originalEvent: e.originalEvent,
	                step: targetStep,
	                button: button
	            })) {
	                that._select(currentStepIndex + 1);
	                that._selectStepper(currentStepIndex + 1);

	                if(!that.ajaxLoad) {
	                    that.trigger(ACTIVATE, { sender: that, step: targetStep });
	                }

	                that.ajaxLoad = false;
	            }
	        },

	        _previousClickHandler: function(e) {
	            var that = this,
	                steps = that._steps,
	                currentStep = that.currentStep,
	                currentStepIndex = currentStep.options.index,
	                button = $(e.target).getKendoButton(),
	                targetStep = steps[currentStepIndex - 1];

	            if(currentStepIndex === 0 || !targetStep.options.enabled) {
	                return;
	            }

	            if(that.options.validateForms && !!currentStep.form && !currentStep.form.validator.validate()) {
	                that.trigger(FORM_VALIDATE_FAILED, { sender: that, step: currentStep, form: currentStep.form });
	                return;
	            }

	            if(!that.trigger(SELECT, {
	                sender: that,
	                originalEvent: e.originalEvent,
	                step: targetStep,
	                button: button
	            })) {
	                that._select(currentStepIndex - 1);
	                that._selectStepper(currentStepIndex - 1);

	                if(!that.ajaxLoad) {
	                    that.trigger(ACTIVATE, { sender: that, step: targetStep });
	                }

	                that.ajaxLoad = false;
	            }
	        },

	        _refreshEditorWidgets: function() {
	            var editorElements = this.wrapper.find("[data-role='editor']"),
	                i, element;

	            for(i = 0; i < editorElements.length; i += 1) {
	                element = $(editorElements[i]);
	                element.getKendoEditor().refresh();
	            }
	        },

	        _resetClickHandler: function(e) {
	            this.trigger(RESET, { sender: this, originalEvent: e, button: $(e.target).getKendoButton() });
	        },

	        _selectStepper: function(index) {
	            var stepper = this.stepper,
	                targetStep = stepper.steps()[index],
	                targetLink = targetStep.element.find(DOT + STEPPER_STEP_LINK);

	            stepper.select(index);

	            stepper.wrapper.find(DOT + STEPPER_STEP_LINK).attr(ARIA_SELECTED, false);
	            targetLink.attr(ARIA_SELECTED, true).focus();
	        },

	        _stepper: function() {
	            var wrapper = this.wrapper,
	                stepperElement = $("<nav>").prependTo(wrapper),
	                options = this.options,
	                stepperOptions = options.stepper,
	                stepsOptions = options.steps.map(this._mapStepForStepper);

	            stepperOptions.steps = stepsOptions;
	            stepperOptions.orientation = options.contentPosition === BOTTOM ? HORIZONTAL : VERTICAL;
	            stepperOptions.selectOnFocus = true;
	            stepperOptions.kendoKeydown = function(e) {
	                if(e.keyCode === kendo.keys.TAB){
	                    e.preventKendoKeydown = true;
	                }
	            };

	            this.stepper = stepperElement.kendoStepper(stepperOptions).getKendoStepper();

	            this._stepperAriaAttributes();
	        },

	        _stepperAriaAttributes: function() {
	            var stepper = this.stepper,
	                wrapperId = this.wrapper.attr(ID) || "wizard",
	                stepperSteps = stepper.steps(),
	                selected = false,
	                step, i;

	            if(!stepperSteps) {
	                return;
	            }

	            for(i = 0; i < stepperSteps.length; i += 1) {
	                if(i === 0) {
	                    selected = true;
	                }

	                step = stepperSteps[i];
	                step.element.find(DOT + STEPPER_STEP_LINK)
	                    .attr(ROLE, "tab")
	                    .attr(ARIA_CONTROLS, wrapperId + DASH + i)
	                    .attr(ARIA_SELECTED, selected);
	            }
	        },

	        _stepperSelectHandler: function(e) {
	            var that = this,
	                stepper = e.sender,
	                stepperStep = e.step,
	                stepIndex = stepperStep.getIndex(),
	                wizardSteps = that._steps,
	                step = wizardSteps[stepIndex],
	                currentStep = that.currentStep;

	            if(that.options.validateForms && !!currentStep.form && !currentStep.form.validator.validate()) {
	                e.preventDefault();
	                that.trigger(FORM_VALIDATE_FAILED, { sender: that, step: currentStep, form: currentStep.form });
	                return;
	            }

	            if(!that.trigger(SELECT, { sender: that, originalEvent: e.originalEvent, step: step, stepper: stepper })) {
	                that._select(stepIndex);

	                stepper.wrapper.find(DOT + STEPPER_STEP_LINK).attr(ARIA_SELECTED, false);
	                stepperStep.element.find(DOT + STEPPER_STEP_LINK).attr(ARIA_SELECTED, true);

	                if(!that.ajaxLoad) {
	                    that.trigger(ACTIVATE, { sender: that, step: step });
	                }

	                that.ajaxLoad = false;
	            } else {
	                e.preventDefault();
	            }
	        },

	        _triggerActivate: function(step) {
	            this._changeStep(step);
	            this.trigger(ACTIVATE, { sender: this, step: step });
	        },

	        _triggerError: function(xhr, status, step) {
	            kendo.ui.progress(this.wrapper, false);
	            this.trigger(ERROR, { sender: this, xhr: xhr, status: status, step: step });
	        },

	        _triggerContentLoad: function(step) {
	            kendo.ui.progress(this.wrapper, false);
	            this.trigger(CONTENTLOAD, { sender: this, step: step });
	        },

	        _wrapper: function() {
	            var that = this,
	                element = that.element,
	                contentPosition = that.options.contentPosition;

	            that.wrapper = element;
	            that.wrapper.addClass(wizardClasses.wizard);
	            that.wrapper.attr(ROLE, "tablist");

	            if(contentPosition === RIGHT) {
	                that.wrapper.addClass(wizardClasses.verticalWizard + SPACE + wizardClasses.rightWizard);
	            } else if(contentPosition === LEFT) {
	                that.wrapper.addClass(wizardClasses.verticalWizard + SPACE + wizardClasses.leftWizard);
	            } else {
	                that.wrapper.addClass(wizardClasses.horizontalWizard);
	            }
	        }
	    });

	    kendo.wizard = {
	        Step: Step
	    };

	    kendo.ui.plugin(Wizard);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "u5iu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ag_grid_1 = __webpack_require__("F6Mk");
var clipboardService_1 = __webpack_require__("/3L8");
var menuItemComponent_1 = __webpack_require__("CN4P");
var menuList_1 = __webpack_require__("Fjmu");
var menuItemMapper_1 = __webpack_require__("jsXh");
var ContextMenuFactory = (function () {
    function ContextMenuFactory() {
    }
    ContextMenuFactory.prototype.init = function () {
    };
    ContextMenuFactory.prototype.hideActiveMenu = function () {
        if (this.activeMenu) {
            this.activeMenu.destroy();
        }
    };
    ContextMenuFactory.prototype.getMenuItems = function (node, column, value) {
        var defaultMenuOptions;
        if (ag_grid_1.Utils.exists(node)) {
            defaultMenuOptions = [];
            if (column) {
                // only makes sense if column exists, could have originated from a row
                defaultMenuOptions = ['copy', 'copyWithHeaders', 'paste', 'separator'];
            }
            defaultMenuOptions.push('toolPanel');
            // if user clicks a cell
            var suppressExcel = this.gridOptionsWrapper.isSuppressExcelExport();
            var suppressCsv = this.gridOptionsWrapper.isSuppressCsvExport();
            var onIPad = ag_grid_1._.isUserAgentIPad();
            var anyExport = !onIPad && (!suppressExcel || !suppressCsv);
            if (anyExport) {
                defaultMenuOptions.push('export');
            }
        }
        else {
            // if user clicks outside of a cell (eg below the rows, or not rows present)
            defaultMenuOptions = ['toolPanel'];
        }
        if (this.gridOptionsWrapper.getContextMenuItemsFunc()) {
            var userFunc = this.gridOptionsWrapper.getContextMenuItemsFunc();
            var params = {
                node: node,
                column: column,
                value: value,
                defaultItems: defaultMenuOptions,
                api: this.gridOptionsWrapper.getApi(),
                columnApi: this.gridOptionsWrapper.getColumnApi(),
                context: this.gridOptionsWrapper.getContext()
            };
            var menuItemsFromUser = userFunc(params);
            return menuItemsFromUser;
        }
        else {
            return defaultMenuOptions;
        }
    };
    ContextMenuFactory.prototype.showMenu = function (node, column, value, mouseEvent) {
        var _this = this;
        var menuItems = this.getMenuItems(node, column, value);
        if (ag_grid_1.Utils.missingOrEmpty(menuItems)) {
            return;
        }
        var menu = new ContextMenu(menuItems);
        this.context.wireBean(menu);
        var eMenuGui = menu.getGui();
        // need to show filter before positioning, as only after filter
        // is visible can we find out what the width of it is
        var hidePopup = this.popupService.addAsModalPopup(eMenuGui, true, function () { return menu.destroy(); }, mouseEvent);
        this.popupService.positionPopupUnderMouseEvent({
            column: column,
            rowNode: node,
            type: 'contextMenu',
            mouseEvent: mouseEvent,
            ePopup: eMenuGui
        });
        menu.afterGuiAttached({
            hidePopup: hidePopup
        });
        this.activeMenu = menu;
        menu.addEventListener(ag_grid_1.BeanStub.EVENT_DESTORYED, function () {
            if (_this.activeMenu === menu) {
                _this.activeMenu = null;
            }
        });
    };
    __decorate([
        ag_grid_1.Autowired('context'),
        __metadata("design:type", ag_grid_1.Context)
    ], ContextMenuFactory.prototype, "context", void 0);
    __decorate([
        ag_grid_1.Autowired('popupService'),
        __metadata("design:type", ag_grid_1.PopupService)
    ], ContextMenuFactory.prototype, "popupService", void 0);
    __decorate([
        ag_grid_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", ag_grid_1.GridOptionsWrapper)
    ], ContextMenuFactory.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        ag_grid_1.Autowired('rowModel'),
        __metadata("design:type", Object)
    ], ContextMenuFactory.prototype, "rowModel", void 0);
    __decorate([
        ag_grid_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ContextMenuFactory.prototype, "init", null);
    ContextMenuFactory = __decorate([
        ag_grid_1.Bean('contextMenuFactory')
    ], ContextMenuFactory);
    return ContextMenuFactory;
}());
exports.ContextMenuFactory = ContextMenuFactory;
var ContextMenu = (function (_super) {
    __extends(ContextMenu, _super);
    function ContextMenu(menuItems) {
        var _this = _super.call(this, '<div class="ag-menu"></div>') || this;
        _this.menuItems = menuItems;
        return _this;
    }
    ContextMenu.prototype.addMenuItems = function () {
        var menuList = new menuList_1.MenuList();
        this.context.wireBean(menuList);
        var menuItemsMapped = this.menuItemMapper.mapWithStockItems(this.menuItems, null);
        menuList.addMenuItems(menuItemsMapped);
        this.appendChild(menuList);
        menuList.addEventListener(menuItemComponent_1.MenuItemComponent.EVENT_ITEM_SELECTED, this.destroy.bind(this));
    };
    ContextMenu.prototype.afterGuiAttached = function (params) {
        this.addDestroyFunc(params.hidePopup);
        // if the body scrolls, we want to hide the menu, as the menu will not appear in the right location anymore
        this.addDestroyableEventListener(this.eventService, 'bodyScroll', this.destroy.bind(this));
    };
    __decorate([
        ag_grid_1.Autowired('context'),
        __metadata("design:type", ag_grid_1.Context)
    ], ContextMenu.prototype, "context", void 0);
    __decorate([
        ag_grid_1.Autowired('clipboardService'),
        __metadata("design:type", clipboardService_1.ClipboardService)
    ], ContextMenu.prototype, "clipboardService", void 0);
    __decorate([
        ag_grid_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", ag_grid_1.GridOptionsWrapper)
    ], ContextMenu.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        ag_grid_1.Autowired('gridApi'),
        __metadata("design:type", ag_grid_1.GridApi)
    ], ContextMenu.prototype, "gridApi", void 0);
    __decorate([
        ag_grid_1.Autowired('eventService'),
        __metadata("design:type", ag_grid_1.EventService)
    ], ContextMenu.prototype, "eventService", void 0);
    __decorate([
        ag_grid_1.Autowired('menuItemMapper'),
        __metadata("design:type", menuItemMapper_1.MenuItemMapper)
    ], ContextMenu.prototype, "menuItemMapper", void 0);
    __decorate([
        ag_grid_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ContextMenu.prototype, "addMenuItems", null);
    return ContextMenu;
}(ag_grid_1.Component));


/***/ }),

/***/ "uC7k":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(926);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 916:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("pV45");

/***/ }),

/***/ 922:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Rqq1");

/***/ }),

/***/ 926:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(922), __webpack_require__(916) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function() {

	(function ($, undefined) {
	    // Imports ================================================================
	    var math = Math,

	        proxy = $.proxy,

	        kendo = window.kendo,
	        Class = kendo.Class,
	        template = kendo.template,

	        dataviz = kendo.dataviz,
	        deepExtend = kendo.deepExtend,

	        g = kendo.geometry,
	        Point = g.Point,

	        Layer = dataviz.map.layers.Layer,

	        util = kendo.util,
	        renderSize = util.renderSize,

	        drawingUtil = kendo.drawing.util,
	        round = drawingUtil.round,
	        limit = drawingUtil.limitValue;

	    // Image tile layer =============================================================
	    var TileLayer = Layer.extend({
	        init: function(map, options) {
	            Layer.fn.init.call(this, map, options);

	            if (typeof this.options.subdomains === "string") {
	                this.options.subdomains = this.options.subdomains.split("");
	            }

	            var viewType = this._viewType();
	            this._view = new viewType(this.element, this.options);
	        },

	        destroy: function() {
	            Layer.fn.destroy.call(this);

	            this._view.destroy();
	            this._view = null;
	        },

	        _beforeReset: function() {
	            var map = this.map;
	            var origin = map.locationToLayer(map.extent().nw).round();
	            this._view.viewOrigin(origin);
	        },

	        _reset: function() {
	            Layer.fn._reset.call(this);
	            this._updateView();
	            this._view.reset();
	        },

	        _viewType: function() {
	            return TileView;
	        },

	        _activate: function() {
	            Layer.fn._activate.call(this);

	            if (!kendo.support.mobileOS) {
	                if (!this._pan) {
	                    this._pan = kendo.throttle(
	                        proxy(this._render, this),
	                        100
	                    );
	                }

	                this.map.bind("pan", this._pan);
	            }
	        },

	        _deactivate: function() {
	            Layer.fn._deactivate.call(this);

	            if (this._pan) {
	                this.map.unbind("pan", this._pan);
	            }
	        },

	        _updateView: function() {
	            var view = this._view,
	                map = this.map,
	                extent = map.extent(),
	                extentToPoint = {
	                    nw: map.locationToLayer(extent.nw).round(),
	                    se: map.locationToLayer(extent.se).round()
	                };

	            view.center(map.locationToLayer(map.center()));
	            view.extent(extentToPoint);
	            view.zoom(map.zoom());
	        },

	        _resize: function() {
	            this._render();
	        },

	        _panEnd: function(e) {
	            Layer.fn._panEnd.call(this, e);
	            this._render();
	        },

	        _render: function() {
	            this._updateView();
	            this._view.render();
	        }
	    });

	    var TileView = Class.extend({
	        init: function(element, options) {
	            this.element = element;
	            this._initOptions(options);

	            this.pool = new TilePool();
	        },

	        options: {
	            tileSize: 256,
	            subdomains: ["a", "b", "c"],
	            urlTemplate: ""
	        },

	        center: function(center) {
	            this._center = center;
	        },

	        extent: function(extent) {
	            this._extent = extent;
	        },

	        viewOrigin: function(origin) {
	            this._viewOrigin = origin;
	        },

	        zoom: function(zoom) {
	            this._zoom = zoom;
	        },

	        pointToTileIndex: function(point) {
	            return new Point(
	                math.floor(point.x / this.options.tileSize),
	                math.floor(point.y / this.options.tileSize)
	            );
	        },

	        tileCount: function() {
	            var size = this.size(),
	                firstTileIndex = this.pointToTileIndex(this._extent.nw),
	                nw = this._extent.nw,
	                point = this.indexToPoint(firstTileIndex).translate(-nw.x, -nw.y);

	            return {
	                x: math.ceil((math.abs(point.x) + size.width) / this.options.tileSize),
	                y: math.ceil((math.abs(point.y) + size.height) / this.options.tileSize)
	            };
	        },

	        size: function() {
	            var nw = this._extent.nw,
	                se = this._extent.se,
	                diff = se.clone().translate(-nw.x, -nw.y);

	            return {
	                width: diff.x,
	                height: diff.y
	            };
	        },

	        indexToPoint: function(index) {
	            var x = index.x, y = index.y;

	            return new Point(
	                x * this.options.tileSize,
	                y * this.options.tileSize
	            );
	        },

	        subdomainText: function() {
	            var subdomains = this.options.subdomains;

	            return subdomains[this.subdomainIndex++ % subdomains.length];
	        },

	        destroy: function() {
	            this.element.empty();
	            this.pool.empty();
	        },

	        reset: function() {
	            this.pool.reset();
	            this.subdomainIndex = 0;
	            this.render();
	        },

	        render: function() {
	            var size = this.tileCount(),
	                firstTileIndex = this.pointToTileIndex(this._extent.nw),
	                tile, x, y;

	            for (x = 0; x < size.x; x++) {
	                for (y = 0; y < size.y; y++) {
	                    tile = this.createTile({
	                        x: firstTileIndex.x + x,
	                        y: firstTileIndex.y + y
	                    });

	                    if (!tile.visible) {
	                        tile.show();
	                    }
	                }
	            }
	        },

	        createTile: function(currentIndex) {
	            var options = this.tileOptions(currentIndex);
	            var tile = this.pool.get(this._center, options);
	            if (tile.element.parent().length === 0) {
	                this.element.append(tile.element);
	            }

	            return tile;
	        },

	        tileOptions: function(currentIndex) {
	            var index = this.wrapIndex(currentIndex),
	                point = this.indexToPoint(currentIndex),
	                origin = this._viewOrigin,
	                offset = point.clone().translate(-origin.x, -origin.y);

	            return {
	                index: index,
	                currentIndex: currentIndex,
	                point: point,
	                offset: roundPoint(offset),
	                zoom: this._zoom,
	                size: this.options.tileSize,
	                subdomain: this.subdomainText(),
	                urlTemplate: this.options.urlTemplate,
	                errorUrlTemplate: this.options.errorUrlTemplate
	            };
	        },

	        wrapIndex: function(index) {
	            var boundary = math.pow(2, this._zoom);
	            return {
	                x: this.wrapValue(index.x, boundary),
	                y: limit(index.y, 0, boundary - 1)
	            };
	        },

	        wrapValue: function(value, boundary) {
	            var remainder = (math.abs(value) % boundary);
	            if (value >= 0) {
	                value = remainder;
	            } else {
	                value = boundary - (remainder === 0 ? boundary : remainder);
	            }

	            return value;
	        }
	    });

	    var ImageTile = Class.extend({
	        init: function(id, options) {
	            this.id = id;
	            this.visible = true;

	            this._initOptions(options);
	            this.createElement();
	            this.show();
	        },

	        options: {
	            urlTemplate: "",
	            errorUrlTemplate: ""
	        },

	        createElement: function() {
	            this.element = $("<img style='position: absolute; display: block;' alt='' />")
	                            .css({ width: this.options.size, height: this.options.size })
	                            .on("error", proxy(function(e) {
	                                if (this.errorUrl()) {
	                                    e.target.setAttribute("src", this.errorUrl());
	                                } else {
	                                    e.target.removeAttribute("src");
	                                }
	                            }, this));
	        },

	        show: function() {
	            var element = this.element[0];
	            element.style.top = renderSize(this.options.offset.y);
	            element.style.left = renderSize(this.options.offset.x);

	            var url = this.url();
	            if (url) {
	                element.setAttribute("src", url);
	            }

	            element.style.visibility = "visible";
	            this.visible = true;
	        },

	        hide: function() {
	            this.element[0].style.visibility = "hidden";
	            this.visible = false;
	        },

	        url: function() {
	            var urlResult = template(this.options.urlTemplate);

	            return urlResult(this.urlOptions());
	        },

	        errorUrl: function() {
	            var urlResult = template(this.options.errorUrlTemplate);

	            return urlResult(this.urlOptions());
	        },

	        urlOptions: function() {
	            var options = this.options;
	            return {
	                zoom: options.zoom,
	                subdomain: options.subdomain,
	                z: options.zoom,
	                x: options.index.x,
	                y: options.index.y,
	                s: options.subdomain,
	                quadkey: options.quadkey,
	                q: options.quadkey,
	                culture: options.culture,
	                c: options.culture
	            };
	        },

	        destroy: function() {
	            if (this.element) {
	                this.element.remove();
	                this.element = null;
	            }
	        }
	    });

	    var TilePool = Class.extend({
	        init: function() {
	            this._items = [];
	        },

	        options: {
	            maxSize: 100
	        },

	        get: function(center, options) {
	            if (this._items.length >= this.options.maxSize) {
	                this._remove(center);
	            }

	            return this._create(options);
	        },

	        empty: function() {
	            var items = this._items;
	            for (var i = 0; i < items.length; i++) {
	                items[i].destroy();
	            }

	            this._items = [];
	        },

	        reset: function() {
	            var items = this._items;
	            for (var i = 0; i < items.length; i++) {
	                items[i].hide();
	            }
	        },

	        _create: function(options) {
	            var items = this._items;
	            var tile;

	            // Build an unique token for the image
	            // This normally would be the URL, but we don't care about subdomains
	            var id = util.hashKey(
	                options.point.toString() +
	                options.offset.toString() +
	                options.zoom +
	                options.urlTemplate
	            );

	            for (var i = 0; i < items.length; i++) {
	                if (items[i].id === id) {
	                    tile = items[i];
	                    break;
	                }
	            }

	            if (tile) {
	                tile.show();
	            } else {
	                tile = new ImageTile(id, options);
	                this._items.push(tile);
	            }

	            return tile;
	        },

	        _remove: function(center) {
	            var items = this._items;
	            var maxDist = -1;
	            var index = -1;

	            for (var i = 0; i < items.length; i++) {
	                var dist = items[i].options.point.distanceTo(center);
	                if (dist > maxDist && !items[i].visible) {
	                    index = i;
	                    maxDist = dist;
	                }
	            }

	            if (index !== -1) {
	                items[index].destroy();
	                items.splice(index, 1);
	            }
	        }
	    });

	    // Methods ================================================================
	    function roundPoint(point) {
	        return new Point(round(point.x), round(point.y));
	    }

	    // Exports ================================================================
	    deepExtend(dataviz, {
	        map: {
	            layers: {
	                tile: TileLayer,
	                TileLayer: TileLayer,

	                ImageTile: ImageTile,
	                TilePool: TilePool,
	                TileView: TileView
	            }
	        }
	    });

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "uK4n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var pivotStage_1 = __webpack_require__("aQ8F");
var aggFuncService_1 = __webpack_require__("R6MX");
var AggregationStage = (function () {
    function AggregationStage() {
    }
    // it's possible to recompute the aggregate without doing the other parts
    // + gridApi.recomputeAggregates()
    AggregationStage.prototype.execute = function (params) {
        // we don't do aggregation if doing legacy tree good
        var doingLegacyTreeData = main_1._.exists(this.gridOptionsWrapper.getNodeChildDetailsFunc());
        if (doingLegacyTreeData) {
            return null;
        }
        var aggDetails = this.createAggDetails(params);
        this.recursivelyCreateAggData(params.rowNode, aggDetails);
    };
    AggregationStage.prototype.createAggDetails = function (params) {
        var pivotActive = this.columnController.isPivotActive();
        var measureColumns = this.columnController.getValueColumns();
        var pivotColumns = pivotActive ? this.columnController.getPivotColumns() : [];
        var aggDetails = {
            changedPath: params.changedPath,
            valueColumns: measureColumns,
            pivotColumns: pivotColumns
        };
        return aggDetails;
    };
    AggregationStage.prototype.recursivelyCreateAggData = function (rowNode, aggDetails) {
        var _this = this;
        // aggregate all children first, as we use the result in this nodes calculations
        rowNode.childrenAfterFilter.forEach(function (child) {
            var nodeHasChildren = child.hasChildren();
            if (nodeHasChildren) {
                _this.recursivelyCreateAggData(child, aggDetails);
            }
            else {
                if (child.aggData) {
                    child.setAggData(null);
                }
            }
        });
        //Optionally prevent the aggregation at the root Node
        //https://ag-grid.atlassian.net/browse/AG-388
        var isRootNode = rowNode.level === -1;
        if (isRootNode) {
            var notPivoting = !this.columnController.isPivotMode();
            var suppressAggAtRootLevel = this.gridOptionsWrapper.isSuppressAggAtRootLevel();
            if (suppressAggAtRootLevel && notPivoting) {
                return;
            }
        }
        var skipBecauseNoChangedPath = aggDetails.changedPath && !aggDetails.changedPath.isInPath(rowNode);
        if (skipBecauseNoChangedPath) {
            return;
        }
        this.aggregateRowNode(rowNode, aggDetails);
    };
    AggregationStage.prototype.aggregateRowNode = function (rowNode, aggDetails) {
        var measureColumnsMissing = aggDetails.valueColumns.length === 0;
        var pivotColumnsMissing = aggDetails.pivotColumns.length === 0;
        var userFunc = this.gridOptionsWrapper.getGroupRowAggNodesFunc();
        var aggResult;
        if (userFunc) {
            aggResult = userFunc(rowNode.childrenAfterFilter);
        }
        else if (measureColumnsMissing) {
            aggResult = null;
        }
        else if (pivotColumnsMissing) {
            aggResult = this.aggregateRowNodeUsingValuesOnly(rowNode, aggDetails);
        }
        else {
            aggResult = this.aggregateRowNodeUsingValuesAndPivot(rowNode);
        }
        rowNode.setAggData(aggResult);
        // if we are grouping, then it's possible there is a sibling footer
        // to the group, so update the data here also if there is one
        if (rowNode.sibling) {
            rowNode.sibling.setAggData(aggResult);
        }
    };
    AggregationStage.prototype.aggregateRowNodeUsingValuesAndPivot = function (rowNode) {
        var _this = this;
        var result = {};
        var pivotColumnDefs = this.pivotStage.getPivotColumnDefs();
        // Step 1: process value columns
        pivotColumnDefs
            .filter(function (v) { return !main_1.Utils.exists(v.pivotTotalColumnIds); }) // only process pivot value columns
            .forEach(function (valueColDef) {
            var keys = valueColDef.pivotKeys;
            var values;
            var valueColumn = valueColDef.pivotValueColumn;
            if (rowNode.leafGroup) {
                // lowest level group, get the values from the mapped set
                values = _this.getValuesFromMappedSet(rowNode.childrenMapped, keys, valueColumn);
            }
            else {
                // value columns and pivot columns, non-leaf group
                values = _this.getValuesPivotNonLeaf(rowNode, valueColDef.colId);
            }
            result[valueColDef.colId] = _this.aggregateValues(values, valueColumn.getAggFunc());
        });
        // Step 2: process total columns
        pivotColumnDefs
            .filter(function (v) { return main_1.Utils.exists(v.pivotTotalColumnIds); }) // only process pivot total columns
            .forEach(function (totalColDef) {
            var aggResults = [];
            //retrieve results for colIds associated with this pivot total column
            totalColDef.pivotTotalColumnIds.forEach(function (colId) {
                aggResults.push(result[colId]);
            });
            result[totalColDef.colId] = _this.aggregateValues(aggResults, totalColDef.aggFunc);
        });
        return result;
    };
    AggregationStage.prototype.aggregateRowNodeUsingValuesOnly = function (rowNode, aggDetails) {
        var _this = this;
        var result = {};
        var changedValueColumns = aggDetails.changedPath ?
            aggDetails.changedPath.getValueColumnsForNode(rowNode, aggDetails.valueColumns)
            : aggDetails.valueColumns;
        var notChangedValueColumns = aggDetails.changedPath ?
            aggDetails.changedPath.getNotValueColumnsForNode(rowNode, aggDetails.valueColumns)
            : null;
        var values2d = this.getValuesNormal(rowNode, changedValueColumns);
        var oldValues = rowNode.aggData;
        changedValueColumns.forEach(function (valueColumn, index) {
            result[valueColumn.getId()] = _this.aggregateValues(values2d[index], valueColumn.getAggFunc());
        });
        if (notChangedValueColumns && oldValues) {
            notChangedValueColumns.forEach(function (valueColumn) {
                result[valueColumn.getId()] = oldValues[valueColumn.getId()];
            });
        }
        return result;
    };
    AggregationStage.prototype.getValuesPivotNonLeaf = function (rowNode, colId) {
        var values = [];
        rowNode.childrenAfterFilter.forEach(function (rowNode) {
            var value = rowNode.aggData[colId];
            values.push(value);
        });
        return values;
    };
    AggregationStage.prototype.getValuesFromMappedSet = function (mappedSet, keys, valueColumn) {
        var _this = this;
        var mapPointer = mappedSet;
        keys.forEach(function (key) { return mapPointer = mapPointer ? mapPointer[key] : null; });
        if (!mapPointer) {
            return [];
        }
        var values = [];
        mapPointer.forEach(function (rowNode) {
            var value = _this.valueService.getValue(valueColumn, rowNode);
            values.push(value);
        });
        return values;
    };
    AggregationStage.prototype.getValuesNormal = function (rowNode, valueColumns) {
        // create 2d array, of all values for all valueColumns
        var values = [];
        valueColumns.forEach(function () { return values.push([]); });
        var valueColumnCount = valueColumns.length;
        var rowCount = rowNode.childrenAfterFilter.length;
        for (var i = 0; i < rowCount; i++) {
            var childNode = rowNode.childrenAfterFilter[i];
            for (var j = 0; j < valueColumnCount; j++) {
                var valueColumn = valueColumns[j];
                // if the row is a group, then it will only have an agg result value,
                // which means valueGetter is never used.
                var value = this.valueService.getValue(valueColumn, childNode);
                values[j].push(value);
            }
        }
        return values;
    };
    AggregationStage.prototype.aggregateValues = function (values, aggFuncOrString) {
        var aggFunction;
        if (typeof aggFuncOrString === 'string') {
            aggFunction = this.aggFuncService.getAggFunc(aggFuncOrString);
        }
        else {
            aggFunction = aggFuncOrString;
        }
        if (typeof aggFunction !== 'function') {
            console.error("ag-Grid: unrecognised aggregation function " + aggFuncOrString);
            return null;
        }
        return aggFunction(values);
    };
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], AggregationStage.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        main_1.Autowired('columnController'),
        __metadata("design:type", main_1.ColumnController)
    ], AggregationStage.prototype, "columnController", void 0);
    __decorate([
        main_1.Autowired('valueService'),
        __metadata("design:type", main_1.ValueService)
    ], AggregationStage.prototype, "valueService", void 0);
    __decorate([
        main_1.Autowired('pivotStage'),
        __metadata("design:type", pivotStage_1.PivotStage)
    ], AggregationStage.prototype, "pivotStage", void 0);
    __decorate([
        main_1.Autowired('aggFuncService'),
        __metadata("design:type", aggFuncService_1.AggFuncService)
    ], AggregationStage.prototype, "aggFuncService", void 0);
    AggregationStage = __decorate([
        main_1.Bean('aggregationStage')
    ], AggregationStage);
    return AggregationStage;
}());
exports.AggregationStage = AggregationStage;


/***/ }),

/***/ "uKqK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var ValueCache = (function () {
    function ValueCache() {
        this.cacheVersion = 0;
    }
    ValueCache.prototype.init = function () {
        this.active = this.gridOptionsWrapper.isValueCache();
        this.neverExpires = this.gridOptionsWrapper.isValueCacheNeverExpires();
    };
    ValueCache.prototype.onDataChanged = function () {
        if (this.neverExpires) {
            return;
        }
        this.expire();
    };
    ValueCache.prototype.expire = function () {
        this.cacheVersion++;
    };
    ValueCache.prototype.setValue = function (rowNode, colId, value) {
        if (this.active) {
            if (rowNode.__cacheVersion !== this.cacheVersion) {
                rowNode.__cacheVersion = this.cacheVersion;
                rowNode.__cacheData = {};
            }
            rowNode.__cacheData[colId] = value;
        }
    };
    ValueCache.prototype.getValue = function (rowNode, colId) {
        var valueInCache = this.active
            && rowNode.__cacheVersion === this.cacheVersion
            && rowNode.__cacheData[colId] !== undefined;
        if (valueInCache) {
            return rowNode.__cacheData[colId];
        }
        else {
            return undefined;
        }
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], ValueCache.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ValueCache.prototype, "init", null);
    ValueCache = __decorate([
        context_1.Bean('valueCache')
    ], ValueCache);
    return ValueCache;
}());
exports.ValueCache = ValueCache;


/***/ }),

/***/ "uLN9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var column_1 = __webpack_require__("hDyE");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var utils_1 = __webpack_require__("IRr6");
var columnController_1 = __webpack_require__("77lH");
var AutoGroupColService = (function () {
    function AutoGroupColService() {
    }
    AutoGroupColService_1 = AutoGroupColService;
    AutoGroupColService.prototype.createAutoGroupColumns = function (rowGroupColumns) {
        var _this = this;
        var groupAutoColumns = [];
        var doingTreeData = this.gridOptionsWrapper.isTreeData();
        var doingMultiAutoColumn = this.gridOptionsWrapper.isGroupMultiAutoColumn();
        if (doingTreeData && doingMultiAutoColumn) {
            console.log('ag-Grid: you cannot mix groupMultiAutoColumn with treeData, only one column can be used to display groups when doing tree data');
            doingMultiAutoColumn = false;
        }
        // if doing groupMultiAutoColumn, then we call the method multiple times, once
        // for each column we are grouping by
        if (doingMultiAutoColumn) {
            rowGroupColumns.forEach(function (rowGroupCol, index) {
                groupAutoColumns.push(_this.createOneAutoGroupColumn(rowGroupCol, index));
            });
        }
        else {
            groupAutoColumns.push(this.createOneAutoGroupColumn(null));
        }
        return groupAutoColumns;
    };
    // rowGroupCol and index are missing if groupMultiAutoColumn=false
    AutoGroupColService.prototype.createOneAutoGroupColumn = function (rowGroupCol, index) {
        // if one provided by user, use it, otherwise create one
        var defaultAutoColDef = this.generateDefaultColDef(rowGroupCol, index);
        var userAutoColDef = this.gridOptionsWrapper.getAutoGroupColumnDef();
        // if doing multi, set the field
        var colId;
        if (rowGroupCol) {
            colId = AutoGroupColService_1.GROUP_AUTO_COLUMN_ID + "-" + rowGroupCol.getId();
        }
        else {
            colId = AutoGroupColService_1.GROUP_AUTO_COLUMN_BUNDLE_ID;
        }
        utils_1._.mergeDeep(defaultAutoColDef, userAutoColDef);
        defaultAutoColDef.colId = colId;
        var noUserFilterPreferences = userAutoColDef == null || userAutoColDef.suppressFilter == null;
        if (noUserFilterPreferences && !this.gridOptionsWrapper.isTreeData()) {
            var produceLeafNodeValues = defaultAutoColDef.field != null || defaultAutoColDef.valueGetter != null;
            defaultAutoColDef.suppressFilter = !produceLeafNodeValues;
        }
        // if showing many cols, we don't want to show more than one with a checkbox for selection
        if (index > 0) {
            defaultAutoColDef.headerCheckboxSelection = false;
        }
        var newCol = new column_1.Column(defaultAutoColDef, colId, true);
        this.context.wireBean(newCol);
        return newCol;
    };
    AutoGroupColService.prototype.generateDefaultColDef = function (rowGroupCol, index) {
        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
        var defaultAutoColDef = {
            headerName: localeTextFunc('group', 'Group'),
            cellRenderer: 'agGroupCellRenderer'
        };
        // we never allow moving the group column
        // defaultAutoColDef.suppressMovable = true;
        if (rowGroupCol) {
            var rowGroupColDef = rowGroupCol.getColDef();
            utils_1._.assign(defaultAutoColDef, {
                // cellRendererParams.groupKey: colDefToCopy.field;
                headerName: this.columnController.getDisplayNameForColumn(rowGroupCol, 'header'),
                headerValueGetter: rowGroupColDef.headerValueGetter
            });
            if (rowGroupColDef.cellRenderer) {
                utils_1._.assign(defaultAutoColDef, {
                    cellRendererParams: {
                        innerRenderer: rowGroupColDef.cellRenderer,
                        innerRendererParams: rowGroupColDef.cellRendererParams
                    }
                });
            }
            defaultAutoColDef.showRowGroup = rowGroupCol.getColId();
        }
        else {
            defaultAutoColDef.showRowGroup = true;
        }
        return defaultAutoColDef;
    };
    AutoGroupColService.GROUP_AUTO_COLUMN_ID = 'ag-Grid-AutoColumn';
    AutoGroupColService.GROUP_AUTO_COLUMN_BUNDLE_ID = AutoGroupColService_1.GROUP_AUTO_COLUMN_ID;
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], AutoGroupColService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], AutoGroupColService.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], AutoGroupColService.prototype, "columnController", void 0);
    AutoGroupColService = AutoGroupColService_1 = __decorate([
        context_1.Bean('autoGroupColService')
    ], AutoGroupColService);
    return AutoGroupColService;
    var AutoGroupColService_1;
}());
exports.AutoGroupColService = AutoGroupColService;


/***/ }),

/***/ "uQOo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var context_1 = __webpack_require__("RQ1/");
var rowNodeBlock_1 = __webpack_require__("8wuL");
var rowRenderer_1 = __webpack_require__("3RUv");
var InfiniteBlock = (function (_super) {
    __extends(InfiniteBlock, _super);
    function InfiniteBlock(pageNumber, params) {
        var _this = _super.call(this, pageNumber, params) || this;
        _this.cacheParams = params;
        return _this;
    }
    InfiniteBlock.prototype.createBlankRowNode = function (rowIndex) {
        var rowNode = _super.prototype.createBlankRowNode.call(this, rowIndex);
        rowNode.uiLevel = 0;
        this.setIndexAndTopOnRowNode(rowNode, rowIndex);
        return rowNode;
    };
    InfiniteBlock.prototype.setDataAndId = function (rowNode, data, index) {
        if (utils_1.Utils.exists(data)) {
            // this means if the user is not providing id's we just use the
            // index for the row. this will allow selection to work (that is based
            // on index) as long user is not inserting or deleting rows,
            // or wanting to keep selection between server side sorting or filtering
            rowNode.setDataAndId(data, index.toString());
        }
        else {
            rowNode.setDataAndId(undefined, undefined);
        }
    };
    InfiniteBlock.prototype.setRowNode = function (rowIndex, rowNode) {
        _super.prototype.setRowNode.call(this, rowIndex, rowNode);
        this.setIndexAndTopOnRowNode(rowNode, rowIndex);
    };
    InfiniteBlock.prototype.init = function () {
        _super.prototype.init.call(this, {
            context: this.context,
            rowRenderer: this.rowRenderer
        });
    };
    InfiniteBlock.prototype.getNodeIdPrefix = function () {
        return null;
    };
    InfiniteBlock.prototype.getRow = function (displayIndex) {
        return this.getRowUsingLocalIndex(displayIndex);
    };
    InfiniteBlock.prototype.setIndexAndTopOnRowNode = function (rowNode, rowIndex) {
        rowNode.setRowIndex(rowIndex);
        rowNode.rowTop = this.cacheParams.rowHeight * rowIndex;
    };
    InfiniteBlock.prototype.loadFromDatasource = function () {
        var _this = this;
        // PROBLEM . . . . when the user sets sort via colDef.sort, then this code
        // is executing before the sort is set up, so server is not getting the sort
        // model. need to change with regards order - so the server side request is
        // AFTER thus it gets the right sort model.
        var params = {
            startRow: this.getStartRow(),
            endRow: this.getEndRow(),
            successCallback: this.pageLoaded.bind(this, this.getVersion()),
            failCallback: this.pageLoadFailed.bind(this),
            sortModel: this.cacheParams.sortModel,
            filterModel: this.cacheParams.filterModel,
            context: this.gridOptionsWrapper.getContext()
        };
        if (utils_1.Utils.missing(this.cacheParams.datasource.getRows)) {
            console.warn("ag-Grid: datasource is missing getRows method");
            return;
        }
        // check if old version of datasource used
        var getRowsParams = utils_1.Utils.getFunctionParameters(this.cacheParams.datasource.getRows);
        if (getRowsParams.length > 1) {
            console.warn('ag-grid: It looks like your paging datasource is of the old type, taking more than one parameter.');
            console.warn('ag-grid: From ag-grid 1.9.0, now the getRows takes one parameter. See the documentation for details.');
        }
        // put in timeout, to force result to be async
        setTimeout(function () {
            _this.cacheParams.datasource.getRows(params);
        }, 0);
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], InfiniteBlock.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], InfiniteBlock.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('rowRenderer'),
        __metadata("design:type", rowRenderer_1.RowRenderer)
    ], InfiniteBlock.prototype, "rowRenderer", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], InfiniteBlock.prototype, "init", null);
    return InfiniteBlock;
}(rowNodeBlock_1.RowNodeBlock));
exports.InfiniteBlock = InfiniteBlock;


/***/ }),

/***/ "ufFs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var agCheckbox_1 = __webpack_require__("0Gxk");
var beanStub_1 = __webpack_require__("xffp");
var context_1 = __webpack_require__("RQ1/");
var columnApi_1 = __webpack_require__("E/Wy");
var gridApi_1 = __webpack_require__("BAow");
var events_1 = __webpack_require__("3ok8");
var eventService_1 = __webpack_require__("k5uU");
var constants_1 = __webpack_require__("ZZFX");
var selectionController_1 = __webpack_require__("D4cr");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var SelectAllFeature = (function (_super) {
    __extends(SelectAllFeature, _super);
    function SelectAllFeature(cbSelectAll, column) {
        var _this = _super.call(this) || this;
        _this.cbSelectAllVisible = false;
        _this.processingEventFromCheckbox = false;
        _this.cbSelectAll = cbSelectAll;
        _this.column = column;
        var colDef = column.getColDef();
        _this.filteredOnly = colDef ? !!colDef.headerCheckboxSelectionFilteredOnly : false;
        return _this;
    }
    SelectAllFeature.prototype.postConstruct = function () {
        this.showOrHideSelectAll();
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.showOrHideSelectAll.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_SELECTION_CHANGED, this.onSelectionChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_MODEL_UPDATED, this.onModelChanged.bind(this));
        this.addDestroyableEventListener(this.cbSelectAll, agCheckbox_1.AgCheckbox.EVENT_CHANGED, this.onCbSelectAll.bind(this));
    };
    SelectAllFeature.prototype.showOrHideSelectAll = function () {
        this.cbSelectAllVisible = this.isCheckboxSelection();
        this.cbSelectAll.setVisible(this.cbSelectAllVisible);
        if (this.cbSelectAllVisible) {
            // in case user is trying this feature with the wrong model type
            this.checkRightRowModelType();
            // make sure checkbox is showing the right state
            this.updateStateOfCheckbox();
        }
    };
    SelectAllFeature.prototype.onModelChanged = function () {
        if (!this.cbSelectAllVisible) {
            return;
        }
        this.updateStateOfCheckbox();
    };
    SelectAllFeature.prototype.onSelectionChanged = function () {
        if (!this.cbSelectAllVisible) {
            return;
        }
        this.updateStateOfCheckbox();
    };
    SelectAllFeature.prototype.getNextCheckboxState = function (selectionCount) {
        if (selectionCount.selected === 0 && selectionCount.notSelected === 0) {
            // if no rows, always have it unselected
            return false;
        }
        else if (selectionCount.selected > 0 && selectionCount.notSelected > 0) {
            // if mix of selected and unselected, this is the tri-state
            return null;
        }
        else if (selectionCount.selected > 0) {
            // only selected
            return true;
        }
        else {
            // nothing selected
            return false;
        }
    };
    SelectAllFeature.prototype.updateStateOfCheckbox = function () {
        if (this.processingEventFromCheckbox) {
            return;
        }
        this.processingEventFromCheckbox = true;
        var selectionCount = this.getSelectionCount();
        var allSelected = this.getNextCheckboxState(selectionCount);
        this.cbSelectAll.setSelected(allSelected);
        this.processingEventFromCheckbox = false;
    };
    SelectAllFeature.prototype.getSelectionCount = function () {
        var selectedCount = 0;
        var notSelectedCount = 0;
        var callback = function (node) {
            if (node.isSelected()) {
                selectedCount++;
            }
            else {
                notSelectedCount++;
            }
        };
        if (this.filteredOnly) {
            this.gridApi.forEachNodeAfterFilter(callback);
        }
        else {
            this.gridApi.forEachNode(callback);
        }
        return {
            notSelected: notSelectedCount,
            selected: selectedCount
        };
    };
    SelectAllFeature.prototype.checkRightRowModelType = function () {
        var rowModelType = this.rowModel.getType();
        var rowModelMatches = rowModelType === constants_1.Constants.ROW_MODEL_TYPE_IN_MEMORY;
        if (!rowModelMatches) {
            console.log("ag-Grid: selectAllCheckbox is only available if using normal row model, you are using " + rowModelType);
        }
    };
    SelectAllFeature.prototype.onCbSelectAll = function () {
        if (this.processingEventFromCheckbox) {
            return;
        }
        if (!this.cbSelectAllVisible) {
            return;
        }
        var value = this.cbSelectAll.isSelected();
        if (value) {
            this.selectionController.selectAllRowNodes(this.filteredOnly);
        }
        else {
            this.selectionController.deselectAllRowNodes(this.filteredOnly);
        }
    };
    SelectAllFeature.prototype.isCheckboxSelection = function () {
        var result = this.column.getColDef().headerCheckboxSelection;
        if (typeof result === 'function') {
            var func = result;
            result = func({
                column: this.column,
                colDef: this.column.getColDef(),
                columnApi: this.columnApi,
                api: this.gridApi
            });
        }
        if (result) {
            if (this.gridOptionsWrapper.isRowModelEnterprise()) {
                console.warn('headerCheckboxSelection is not supported for Enterprise Row Model');
                return false;
            }
            if (this.gridOptionsWrapper.isRowModelInfinite()) {
                console.warn('headerCheckboxSelection is not supported for Infinite Row Model');
                return false;
            }
            if (this.gridOptionsWrapper.isRowModelViewport()) {
                console.warn('headerCheckboxSelection is not supported for Viewport Row Model');
                return false;
            }
            // otherwise the row model is compatible, so return true
            return true;
        }
        else {
            return false;
        }
    };
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], SelectAllFeature.prototype, "gridApi", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], SelectAllFeature.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], SelectAllFeature.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('rowModel'),
        __metadata("design:type", Object)
    ], SelectAllFeature.prototype, "rowModel", void 0);
    __decorate([
        context_1.Autowired('selectionController'),
        __metadata("design:type", selectionController_1.SelectionController)
    ], SelectAllFeature.prototype, "selectionController", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], SelectAllFeature.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SelectAllFeature.prototype, "postConstruct", null);
    return SelectAllFeature;
}(beanStub_1.BeanStub));
exports.SelectAllFeature = SelectAllFeature;


/***/ }),

/***/ "ungA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KendoSharedMethods = exports.KendoBaseInputComponent = exports.KendoBaseDatasourceComponent = exports.KendoBaseComponent = undefined;

var _kendoBaseComponent = __webpack_require__("hMV3");

var _kendoBaseComponent2 = _interopRequireDefault(_kendoBaseComponent);

var _kendoBaseDatasourceComponent = __webpack_require__("yJFb");

var _kendoBaseDatasourceComponent2 = _interopRequireDefault(_kendoBaseDatasourceComponent);

var _kendoBaseInputComponent = __webpack_require__("0CSa");

var _kendoBaseInputComponent2 = _interopRequireDefault(_kendoBaseInputComponent);

var _kendoSharedMethods = __webpack_require__("CQB/");

var _kendoSharedMethods2 = _interopRequireDefault(_kendoSharedMethods);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoBaseComponent = _kendoBaseComponent2.default;
exports.KendoBaseDatasourceComponent = _kendoBaseDatasourceComponent2.default;
exports.KendoBaseInputComponent = _kendoBaseInputComponent2.default;
exports.KendoSharedMethods = _kendoSharedMethods2.default;

/***/ }),

/***/ "ur7x":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1319);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1319:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.loader",
	    name: "Loader",
	    category: "mobile",
	    description: "Mobile Loader",
	    depends: [ "core" ],
	    hidden: true
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.mobile.ui,
	        Widget = ui.Widget,
	        CAPTURE_EVENTS = $.map(kendo.eventMap, function(value) { return value; }).join(" ").split(" ");

	    var Loader = Widget.extend({
	        init: function(container, options) {
	            var that = this,
	                element = $('<div class="km-loader"><span class="km-loading km-spin"></span><span class="km-loading-left"></span><span class="km-loading-right"></span></div>');

	            Widget.fn.init.call(that, element, options);

	            that.container = container;
	            that.captureEvents = false;

	            that._attachCapture();

	            element.append(that.options.loading).hide().appendTo(container);
	        },

	        options: {
	            name: "Loader",
	            loading: "<h1>Loading...</h1>",
	            timeout: 100
	        },

	        show: function() {
	            var that = this;

	            clearTimeout(that._loading);

	            if (that.options.loading === false) {
	                return;
	            }

	            that.captureEvents = true;
	            that._loading = setTimeout(function() {
	                that.element.show();
	            }, that.options.timeout);
	        },

	        hide: function() {
	            this.captureEvents = false;
	            clearTimeout(this._loading);
	            this.element.hide();
	        },

	        changeMessage: function(message) {
	            this.options.loading = message;
	            this.element.find(">h1").html(message);
	        },

	        transition: function() {
	            this.captureEvents = true;
	            this.container.css("pointer-events", "none");
	        },

	        transitionDone: function() {
	            this.captureEvents = false;
	            this.container.css("pointer-events", "");
	        },

	        _attachCapture: function() {
	            var that = this;
	            that.captureEvents = false;

	            function capture(e) {
	                if (that.captureEvents) {
	                    e.preventDefault();
	                }
	            }

	            for (var i = 0; i < CAPTURE_EVENTS.length; i ++) {
	                that.container[0].addEventListener(CAPTURE_EVENTS[i], capture, true);
	            }
	        }
	    });

	    ui.plugin(Loader);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "vAMl":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1598);
	module.exports = __webpack_require__(1598);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1598:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20), __webpack_require__(5) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    /*jshint evil: true */
	    var Filter = kendo.spreadsheet.Filter = kendo.Class.extend({
	        prepare: function() {
	        },
	        value: function(cell) {
	            return cell.value;
	        },
	        matches: function() {
	            throw new Error("The 'matches' method is not implemented.");
	        },
	        toJSON: function() {
	            throw new Error("The 'toJSON' method is not implemented.");
	        }
	    });

	    Filter.create = function(options) {
	        var filter = options.filter;

	        if (!filter) {
	            throw new Error("Filter type not specified.");
	        }

	        var constructor = kendo.spreadsheet[filter.charAt(0).toUpperCase() + filter.substring(1) + "Filter"];

	        if (!constructor) {
	            throw new Error("Filter type not recognized.");
	        }

	        return new constructor(options);
	    };

	    kendo.spreadsheet.ValueFilter = Filter.extend({
	        _values: [],

	        _dates: [],

	        _blanks: false,

	        init: function ValueFilter(options) {
	            if (options.values !== undefined) {
	                this._values = options.values;
	            }

	            if (options.blanks !== undefined) {
	                this._blanks = options.blanks;
	            }

	            if (options.dates !== undefined) {
	                this._dates = options.dates;
	            }
	        },

	        value: function(cell) {
	            var value = cell.value;

	            if (this._dates.length > 0 && cell.format && typeof value === "number") {
	                var type = kendo.spreadsheet.formatting.type(value, cell.format);

	                if (type === "date") {
	                    value = kendo.spreadsheet.numberToDate(value);
	                }
	            }

	            return value;
	        },

	        matches: function(value) {
	            if (value === null || value === undefined) {
	                return this._blanks;
	            }

	            if (value instanceof Date) {
	                return this._dates.some(function(date) {
	                    return date.year === value.getFullYear() &&
	                        (date.month === undefined || date.month === value.getMonth()) &&
	                        (date.day === undefined || date.day === value.getDate()) &&
	                        (date.hours === undefined || date.hours === value.getHours()) &&
	                        (date.minutes === undefined || date.minutes === value.getMinutes()) &&
	                        (date.seconds === undefined || date.seconds === value.getSeconds());
	                });
	            }

	            return this._values.indexOf(value) >= 0;
	        },
	        toJSON: function() {
	            return {
	                filter: "value",
	                blanks: this._blanks,
	                values: this._values.slice(0)
	            };
	        }
	    });

	    kendo.spreadsheet.CustomFilter = Filter.extend({
	        _logic: "and",
	        init: function CustomFilter(options) {
	            if (options.logic !== undefined) {
	                this._logic = options.logic;
	            }

	            if (options.criteria === undefined) {
	                throw new Error("Must specify criteria.");
	            }

	            this._criteria = options.criteria;

	            var expression = kendo.data.Query.filterExpr({
	                logic: this._logic,
	                filters: this._criteria,
	                accentFoldingFiltering: kendo.culture().name
	            }).expression;

	            this._matches = new Function("d", "return " + expression);
	        },
	        matches: function(value) {
	            if (value === null) {
	                return false;
	            }

	            return this._matches(value);
	        },
	        value: function(cell) {
	            var value = cell.value;
	            var criterionValue = this._criteria[0].value;
	            var criterionType = criterionValue instanceof Date ? "date" : typeof criterionValue;
	            var valueType = typeof value;

	            if (cell.format) {
	                valueType = kendo.spreadsheet.formatting.type(value, cell.format);
	            }

	            if (valueType != criterionType) {
	                if (criterionType == "string") {
	                    if (cell.format) {
	                        value = kendo.spreadsheet.formatting.text(value, cell.format);
	                    }
	                    value = value + "";
	                }
	            } else if (valueType == "date") {
	                value = kendo.spreadsheet.numberToDate(value);
	            }

	            return value;
	        },
	        toJSON: function() {
	            return {
	                filter: "custom",
	                logic: this._logic,
	                criteria: this._criteria
	            };
	        }
	    });

	    kendo.spreadsheet.TopFilter = Filter.extend({
	        init: function TopFilter(options) {
	            this._type = options.type;
	            this._value = options.value;
	            this._values = [];
	        },

	        prepare: function(cells) {
	            var values = cells.map(this.value)
	            .sort()
	            .filter(function(value, index, array) {
	                return index === 0 || value !== array[index - 1];
	            });

	            if (this._type === "topNumber" || this._type == "topPercent") {
	                values.sort(function(x, y) {
	                    return y - x;
	                });
	            } else {
	                values.sort(function(x, y) {
	                    return x - y;
	                });
	            }

	            var count = this._value;

	            if (this._type === "topPercent" || this._type === "bottomPercent") {
	                count = (values.length * count / 100) >> 0;
	            }

	            this._values = values.slice(0, count);
	        },
	        matches: function(value) {
	            return this._values.indexOf(value) >= 0;
	        },
	        toJSON: function() {
	            return {
	                filter: "top",
	                type: this._type,
	                value: this._value
	            };
	        }
	    });

	    kendo.spreadsheet.DynamicFilter = Filter.extend({
	        init: function DynamicFilter(options) {
	            this._type = options.type;

	            this._predicate = this[options.type];

	            if (typeof this._predicate !== "function") {
	                throw new Error("DynamicFilter type '" + options.type + "' not recognized.");
	            }
	        },
	        value: function(cell) {
	            var value = cell.value;

	            if (cell.format) {
	                var type = kendo.spreadsheet.formatting.type(value, cell.format);

	                if (type === "date") {
	                    value = kendo.spreadsheet.numberToDate(value);
	                }
	            }

	            return value;
	        },
	        prepare: function(cells) {
	            var sum = 0;
	            var count = 0;

	            for (var ci = 0; ci < cells.length; ci++) {
	                var value = this.value(cells[ci]);

	                if (typeof value === "number") {
	                    sum += value;
	                    count ++;
	                }
	            }

	            if (count > 0) {
	                this._average = sum / count;
	            } else {
	                this._average = 0;
	            }
	        },
	        matches: function(value) {
	            return this._predicate(value);
	        },
	        aboveAverage: function(value) {
	            if (value instanceof Date) {
	                value = kendo.spreadsheet.dateToNumber(value);
	            }

	            if (typeof value !== "number") {
	                return false;
	            }

	            return value > this._average;
	        },
	        belowAverage: function(value) {
	            if (value instanceof Date) {
	                value = kendo.spreadsheet.dateToNumber(value);
	            }

	            if (typeof value !== "number") {
	                return false;
	            }

	            return value < this._average;
	        },
	        tomorrow: function(value) {
	            if (value instanceof Date) {
	                var tomorrow = kendo.date.addDays(kendo.date.today(), 1);

	                return kendo.date.getDate(value).getTime() === tomorrow.getTime();
	            }

	            return false;
	        },
	        today: function(value) {
	            if (value instanceof Date) {
	                return kendo.date.isToday(value);
	            }

	            return false;
	        },
	        yesterday: function(value) {
	            if (value instanceof Date) {
	                var yesterday = kendo.date.addDays(kendo.date.today(), -1);

	                return kendo.date.getDate(value).getTime() === yesterday.getTime();
	            }

	            return false;
	        },
	        nextWeek: function(value) {
	            return sameWeek(kendo.date.addDays(kendo.date.today(), 7), value);
	        },
	        thisWeek: function(value) {
	            return sameWeek(kendo.date.today(), value);
	        },
	        lastWeek: function(value) {
	            return sameWeek(kendo.date.addDays(kendo.date.today(), -7), value);
	        },
	        nextMonth: function(value) {
	            return sameMonth(value, 1);
	        },
	        thisMonth: function(value) {
	            return sameMonth(value, 0);
	        },
	        lastMonth: function(value) {
	            return sameMonth(value, -1);
	        },
	        nextQuarter: function(value) {
	            if (value instanceof Date) {
	                var today = kendo.date.today();

	                var diff = quarter(value) - quarter(today);

	                return (diff === 1 && today.getFullYear() === value.getFullYear()) ||
	                       (diff == -3 && today.getFullYear() + 1 === value.getFullYear());
	            }

	            return false;
	        },
	        thisQuarter: function(value) {
	            if (value instanceof Date) {
	                var today = kendo.date.today();

	                var diff = quarter(value) - quarter(today);

	                return diff === 0 && today.getFullYear() === value.getFullYear();
	            }

	            return false;
	        },
	        lastQuarter: function(value) {
	            if (value instanceof Date) {
	                var today = kendo.date.today();

	                var diff = quarter(today) - quarter(value);

	                return (diff === 1 && today.getFullYear() === value.getFullYear()) ||
	                       (diff == -3 && today.getFullYear() - 1 === value.getFullYear());
	            }

	            return false;
	        },
	        nextYear: function(value) {
	            return sameYear(value, 1);
	        },
	        thisYear: function(value) {
	            return sameYear(value, 0);
	        },
	        lastYear: function(value) {
	            return sameYear(value, -1);
	        },
	        yearToDate: function(value) {
	            if (value instanceof Date) {
	                var today = kendo.date.today();

	                return value.getFullYear() === today.getFullYear() && value <= today;
	            }

	            return false;
	        },
	        toJSON: function() {
	            return {
	                filter: "dynamic",
	                type: this._type
	            };
	        }
	    });

	    [1, 2, 3, 4].forEach(function(target) {
	        kendo.spreadsheet.DynamicFilter.prototype["quarter" + target] = function(value) {
	           if (value instanceof Date) {
	              return quarter(value) === target;
	           }

	           return false;
	        };
	    });

	    kendo.cultures["en-US"].calendar.months.names.forEach(function(month, index) {
	        kendo.spreadsheet.DynamicFilter.prototype[month.toLowerCase()] = function(value) {
	           if (value instanceof Date) {
	               return value.getMonth() === index;
	           }

	           return false;
	        };
	    });

	    function quarter(value) {
	        var month = value.getMonth() + 1;

	        if (month >= 1 && month <= 3) {
	            return 1;
	        } else if(month >= 4 && month <= 6) {
	            return 2;
	        } else if (month >= 7 && month <= 9) {
	            return 3;
	        } else {
	            return 4;
	        }
	    }

	    function sameYear(value, offset) {
	        if (value instanceof Date) {
	            var today = kendo.date.today();

	            today.setFullYear(today.getFullYear() + offset);

	            return today.getFullYear() === value.getFullYear();
	        }

	        return false;
	    }

	    function sameMonth(value, offset) {
	        if (value instanceof Date) {
	            var today = kendo.date.firstDayOfMonth(kendo.date.today());

	            today.setMonth(today.getMonth() + offset, 1);

	            return today.getTime() === kendo.date.firstDayOfMonth(value).getTime();
	        }

	        return false;
	    }

	    function sameWeek(a, b) {
	        if (b instanceof Date) {
	            var firstWeek = kendo.date.dayOfWeek(kendo.date.getDate(a), 1);

	            var secondWeek = kendo.date.dayOfWeek(kendo.date.getDate(b), 1);

	            return firstWeek.getTime() === secondWeek.getTime();
	        }

	        return false;
	    }

	})(kendo);
	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "vFc/":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("TcQ7");
var toLength = __webpack_require__("QRG4");
var toAbsoluteIndex = __webpack_require__("fkB2");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "vFc7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var expressionService_1 = __webpack_require__("1aUC");
var ValueFormatterService = (function () {
    function ValueFormatterService() {
    }
    ValueFormatterService.prototype.formatValue = function (column, rowNode, $scope, value) {
        var formatter;
        var colDef = column.getColDef();
        // if floating, give preference to the floating formatter
        if (rowNode && rowNode.rowPinned) {
            formatter = colDef.pinnedRowValueFormatter ? colDef.pinnedRowValueFormatter : colDef.valueFormatter;
        }
        else {
            formatter = colDef.valueFormatter;
        }
        var result = null;
        if (formatter) {
            var params = {
                value: value,
                node: rowNode,
                data: rowNode ? rowNode.data : null,
                colDef: column.getColDef(),
                column: column,
                api: this.gridOptionsWrapper.getApi(),
                columnApi: this.gridOptionsWrapper.getColumnApi(),
                context: this.gridOptionsWrapper.getContext()
            };
            // originally we put the angular 1 scope here, but we don't want the scope
            // in the params interface, as other frameworks will see the interface, and
            // angular 1 is not cool any more. so we hack the scope in here (we cannot
            // include it above, as it's not in the interface, so would cause a compile error).
            // in the future, when we stop supporting angular 1, we can take this out.
            params.$scope = $scope;
            result = this.expressionService.evaluate(formatter, params);
        }
        else if (colDef.refData) {
            return colDef.refData[value];
        }
        // if we don't do this, then arrays get displayed as 1,2,3, but we want 1, 2, 3 (ie with spaces)
        if ((result === null || result === undefined) && Array.isArray(value)) {
            result = value.join(', ');
        }
        return result;
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], ValueFormatterService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('expressionService'),
        __metadata("design:type", expressionService_1.ExpressionService)
    ], ValueFormatterService.prototype, "expressionService", void 0);
    ValueFormatterService = __decorate([
        context_1.Bean('valueFormatterService')
    ], ValueFormatterService);
    return ValueFormatterService;
}());
exports.ValueFormatterService = ValueFormatterService;


/***/ }),

/***/ "vGlF":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1265);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1046:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2btM");

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1265:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1046), __webpack_require__(1266), __webpack_require__(1109) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "gantt.timeline",
	    name: "Gantt Timeline",
	    category: "web",
	    description: "The Gantt Timeline",
	    depends: [ "dom", "touch", "draganddrop" ],
	    hidden: true
	};

	(function($) {

	    var Widget = kendo.ui.Widget;
	    var kendoDomElement = kendo.dom.element;
	    var kendoTextElement = kendo.dom.text;
	    var kendoHtmlElement = kendo.dom.html;
	    var isPlainObject = $.isPlainObject;
	    var outerWidth = kendo._outerWidth;
	    var outerHeight = kendo._outerHeight;
	    var extend = $.extend;
	    var proxy = $.proxy;
	    var browser = kendo.support.browser;
	    var isRtl = false;
	    var keys = kendo.keys;
	    var Query = kendo.data.Query;
	    var STRING = "string";
	    var NS = ".kendoGanttTimeline";
	    var CLICK = "click";
	    var DBLCLICK = "dblclick";
	    var MOUSEMOVE = "mousemove";
	    var MOUSEENTER = "mouseenter";
	    var MOUSELEAVE = "mouseleave";
	    var KEYDOWN = "keydown";
	    var DOT = ".";
	    var TIME_HEADER_TEMPLATE = kendo.template("#=kendo.toString(start, 't')#");
	    var DAY_HEADER_TEMPLATE = kendo.template("#=kendo.toString(start, 'ddd M/dd')#");
	    var WEEK_HEADER_TEMPLATE = kendo.template("#=kendo.toString(start, 'ddd M/dd')# - #=kendo.toString(kendo.date.addDays(end, -1), 'ddd M/dd')#");
	    var MONTH_HEADER_TEMPLATE = kendo.template("#=kendo.toString(start, 'MMM')#");
	    var YEAR_HEADER_TEMPLATE = kendo.template("#=kendo.toString(start, 'yyyy')#");
	    var RESIZE_HINT = kendo.template('<div class="#=styles.marquee#">' +
	                           '<div class="#=styles.marqueeColor#"></div>' +
	                       '</div>');
	    var RESIZE_TOOLTIP_TEMPLATE = kendo.template('<div style="z-index: 100002;" class="#=styles.tooltipWrapper# k-gantt-resize-hint">' +
	                                   '<div class="#=styles.tooltipContent#">' +
	                                        '<div>#=messages.start#: #=kendo.toString(start, format)#</div>' +
	                                        '<div>#=messages.end#: #=kendo.toString(end, format)#</div>' +
	                                   '</div>' +
	                              '</div>');
	    var PERCENT_RESIZE_TOOLTIP_TEMPLATE = kendo.template('<div style="z-index: 100002;" class="#=styles.tooltipWrapper#" >' +
	                                   '<div class="#=styles.tooltipContent#">#=text#%</div>' +
	                                   '<div class="#=styles.tooltipCallout#" style="left:13px;"></div>' +
	                              '</div>');
	    var TASK_TOOLTIP_TEMPLATE = kendo.template('<div class="#=kendo.htmlEncode(styles.taskDetails)#">' +
	                                    '<strong>#=kendo.htmlEncode(task.title)#</strong>' +
	                                    '<div class="#=styles.taskDetailsPercent#">#=kendo.toString(task.percentComplete, "p0")#</div>' +
	                                    '<ul class="#=styles.reset#">' +
	                                        '<li>#=messages.start#: #=kendo.toString(task.start, "h:mm tt ddd, MMM d")#</li>' +
	                                        '<li>#=messages.end#: #=kendo.toString(task.end, "h:mm tt ddd, MMM d")#</li>' +
	                                    '</ul>' +
	                                '</div>');
	    var OFFSET_TOOLTIP_TEMPLATE = kendo.template('<span>#=offsetPrefix#: #=offsetText#</span>');
	    var PLANNED_TOOLTIP_TEMPLATE = kendo.template('<div class="k-task-content">' +
	            '<div>#=plannedStart#: #=startDate#</div>' +
	            '<div>#=plannedEnd#: #=endDate#</div>' +
	        '</div>');
	    var SIZE_CALCULATION_TEMPLATE = "<table style='visibility: hidden;'>" +
	        "<tbody>" +
	            "<tr style='height:{0}'>" +
	                "<td>&nbsp;</td>" +
	            "</tr>" +
	        "</tbody>" +
	    "</table>";

	    var defaultViews = {
	        day: {
	            type: "kendo.ui.GanttDayView"
	        },
	        week: {
	            type: "kendo.ui.GanttWeekView"
	        },
	        month: {
	            type: "kendo.ui.GanttMonthView"
	        },
	        year: {
	            type: "kendo.ui.GanttYearView"
	        }
	    };

	    function trimOptions(options) {
	        delete options.name;
	        delete options.prefix;
	        delete options.views;

	        return options;
	    }

	    function getWorkDays(options) {
	        var workDays = [];
	        var dayIndex = options.workWeekStart;

	        workDays.push(dayIndex);

	        while (options.workWeekEnd != dayIndex) {
	            if (dayIndex > 6) {
	                dayIndex -= 7;
	            } else {
	                dayIndex++;
	            }
	            workDays.push(dayIndex);
	        }
	        return workDays;
	    }

	    function blurActiveElement() {
	        var activeElement = kendo._activeElement();

	        if (activeElement && activeElement.nodeName.toLowerCase() !== "body") {
	            $(activeElement).blur();
	        }
	    }

	    var viewStyles = {
	        alt: "k-alt",
	        reset: "k-reset",
	        nonWorking: "k-nonwork-hour",
	        header: "k-header",
	        gridHeader: "k-grid-header",
	        gridHeaderWrap: "k-grid-header-wrap",
	        gridContent: "k-grid-content",
	        tasksWrapper: "k-gantt-tables",
	        rowsTable: "k-gantt-rows",
	        columnsTable: "k-gantt-columns",
	        tasksTable: "k-gantt-tasks",
	        dependenciesWrapper: "k-gantt-dependencies",
	        resource: "k-resource",
	        resourceAlt: "k-resource k-alt",
	        task: "k-task",
	        taskSingle: "k-task-single",
	        taskMilestone: "k-task-milestone",
	        taskSummary: "k-task-summary",
	        taskWrap: "k-task-wrap",
	        taskMilestoneWrap: "k-milestone-wrap",
	        taskSummaryWrap: "k-summary-wrap",
	        taskPlanned: "k-task-planned",
	        taskPlannedMoment: "k-task-moment",
	        taskPlannedDuration: "k-task-duration",
	        taskPlannedMomentLeft: "k-moment-left",
	        taskAdvanced: "k-task-advanced",
	        taskDelayed: "k-task-delayed",
	        taskOffset: "k-task-offset",
	        taskOffsetWrap: "k-task-offset-wrap",
	        taskInnerWrap: "k-task-inner-wrap",
	        resourcesWrap: "k-resources-wrap",
	        taskDot: "k-task-dot",
	        taskDotStart: "k-task-start",
	        taskDotEnd: "k-task-end",
	        taskDragHandle: "k-task-draghandle",
	        taskContent: "k-task-content",
	        taskTemplate: "k-task-template",
	        taskActions: "k-task-actions",
	        taskDelete: "k-task-delete",
	        taskComplete: "k-task-complete",
	        taskDetails: "k-task-details",
	        taskDetailsPercent: "k-task-pct",
	        link: "k-link",
	        icon: "k-icon",
	        iconDelete: "k-i-close",
	        taskResizeHandle: "k-resize-handle",
	        taskResizeHandleWest: "k-resize-w",
	        taskResizeHandleEast: "k-resize-e",
	        taskSummaryProgress: "k-task-summary-progress",
	        taskSummaryComplete: "k-task-summary-complete",
	        line: "k-gantt-line",
	        lineHorizontal: "k-gantt-line-h",
	        lineVertical: "k-gantt-line-v",
	        arrowWest: "k-arrow-w",
	        arrowEast: "k-arrow-e",
	        dragHint: "k-drag-hint",
	        dependencyHint: "k-gantt-dependency-hint",
	        tooltipWrapper: "k-tooltip",
	        tooltipContent: "k-tooltip-content",
	        tooltipCallout: "k-callout k-callout-s",
	        callout: "k-callout",
	        marquee: "k-marquee k-gantt-marquee",
	        marqueeColor: "k-marquee-color",
	        offsetTooltipAdvanced: "k-offset-tooltip-advanced",
	        offsetTooltipDelay: "k-offset-tooltip-delayed",
	        plannedTooltip: "k-planned-tooltip"
	    };

	    var GanttView = kendo.ui.GanttView = Widget.extend({
	        init: function(element, options) {
	            Widget.fn.init.call(this, element, options);

	            this.title = this.options.title || this.options.name;

	            this.header = this.element.find(DOT + GanttView.styles.gridHeader);

	            this.content = this.element.find(DOT + GanttView.styles.gridContent);

	            this.contentWidth = this.content.width();

	            this._workDays = getWorkDays(this.options);

	            this._headerTree = options.headerTree;

	            this._taskTree = options.taskTree;

	            this._taskTemplate = options.taskTemplate ?
	                kendo.template(options.taskTemplate, extend({}, kendo.Template, options.templateSettings)) :
	                null;

	            this._dependencyTree = options.dependencyTree;

	            this._taskCoordinates = {};

	            this._currentTime();
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            clearTimeout(this._tooltipTimeout);

	            this.headerRow = null;
	            this.header = null;
	            this.content = null;

	            this._dragHint = null;
	            this._resizeHint = null;
	            this._resizeTooltip = null;
	            this._taskTooltip = null;
	            this._percentCompleteResizeTooltip = null;

	            this._headerTree = null;
	            this._taskTree = null;
	            this._dependencyTree = null;
	        },

	        options: {
	            showWorkHours: false,
	            showWorkDays: false,
	            workDayStart: new Date(1980, 1, 1, 8, 0, 0),
	            workDayEnd: new Date(1980, 1, 1, 17, 0, 0),
	            workWeekStart: 1,
	            workWeekEnd: 5,
	            hourSpan: 1,
	            slotSize: 100,
	            currentTimeMarker: {
	                 updateInterval: 10000
	            }
	        },

	        renderLayout: function() {
	            this._slots = this._createSlots();

	            this._tableWidth = this._calculateTableWidth();

	            this.createLayout(this._layout());

	            this._slotDimensions();

	            this._adjustHeight();

	            this.content.find(DOT + GanttView.styles.dependenciesWrapper).width(this._tableWidth);
	        },

	        _adjustHeight: function() {
	            if(this.content){
	                this.content.height(this.element.height() - outerHeight(this.header));
	            }
	        },

	        createLayout: function(rows) {
	            var headers = this._headers(rows);
	            var colgroup = this._colgroup();
	            var tree = this._headerTree;
	            var header = kendoDomElement("tbody", null, headers);
	            var table = kendoDomElement("table", { style: { width: this._tableWidth + "px"}, role: "presentation" }, [colgroup, header]);

	            tree.render([table]);

	            this.headerRow = this.header.find("table:first tr").last();
	        },

	        _slotDimensions: function() {
	            var headers = this.headerRow[0].children;
	            var slots = this._timeSlots();
	            var slot;
	            var header;

	            for (var i = 0, length = headers.length; i < length; i++) {
	                header = headers[i];
	                slot = slots[i];

	                slot.offsetLeft = header.offsetLeft;
	                slot.offsetWidth = header.offsetWidth;
	            }
	        },

	        render: function(tasks) {
	            var taskCount = tasks.length;
	            var styles = GanttView.styles;
	            var contentTable;
	            var rowsTable = this._rowsTable(taskCount);
	            var columnsTable = this._columnsTable(taskCount);
	            var tasksTable = this._tasksTable(tasks);
	            var currentTimeMarker = this.options.currentTimeMarker;
	            var calculatedSize = this.options.calculatedSize;
	            var totalHeight;

	            this._taskTree.render([rowsTable, columnsTable, tasksTable]);

	            contentTable = this.content.find(DOT + styles.rowsTable);

	            if (calculatedSize) {
	                totalHeight = calculatedSize.row * tasks.length;
	                this.content.find(DOT + styles.tasksTable).height(totalHeight);
	                contentTable.height(totalHeight);
	            }

	            this._contentHeight = contentTable.height();
	            this._rowHeight = calculatedSize ? calculatedSize.row : this._contentHeight / contentTable.find("tr").length;

	            this.content.find(DOT + styles.columnsTable).height(this._contentHeight);

	            if (currentTimeMarker !== false && currentTimeMarker.updateInterval !== undefined) {
	                this._renderCurrentTime();
	            }
	        },

	        _rowsTable: function(rowCount) {
	            var rows = [];
	            var row;
	            var styles = GanttView.styles;
	            var attributes = [null, { className: styles.alt }];

	            for (var i = 0; i < rowCount; i++) {
	                row = kendoDomElement("tr", attributes[i % 2], [
	                    kendoDomElement("td", null, [
	                        kendoTextElement("\u00a0")
	                    ])
	                ]);

	                rows.push(row);
	            }

	            return this._createTable(1, rows, { className: styles.rowsTable });
	        },

	        _columnsTable: function() {
	            var cells = [];
	            var row;
	            var styles = GanttView.styles;
	            var slots = this._timeSlots();
	            var slotsCount = slots.length;
	            var slot;
	            var slotSpan;
	            var totalSpan = 0;
	            var attributes;

	            for (var i = 0; i < slotsCount; i++) {
	                slot = slots[i];

	                attributes = {};

	                slotSpan = slot.span;

	                totalSpan += slotSpan;

	                if (slotSpan !== 1) {
	                    attributes.colspan = slotSpan;
	                }

	                if (slot.isNonWorking) {
	                    attributes.className = styles.nonWorking;
	                }

	                cells.push(kendoDomElement("td", attributes, [
	                    kendoTextElement("\u00a0")
	                ]));
	            }

	            row = kendoDomElement("tr", null, cells);

	            return this._createTable(totalSpan, [row], { className: styles.columnsTable});
	        },

	        _tasksTable: function(tasks) {
	            var rows = [];
	            var row;
	            var cell;
	            var position;
	            var plannedPosition;
	            var task;
	            var styles = GanttView.styles;
	            var coordinates = this._taskCoordinates = {};
	            var size = this._calculateMilestoneWidth();
	            var milestoneWidth = Math.round(size.width);
	            var resourcesField = this.options.resourcesField;
	            var className = [styles.resource, styles.resourceAlt];
	            var calculatedSize = this.options.calculatedSize;
	            var resourcesPosition;
	            var resourcesMargin = this._calculateResourcesMargin();
	            var taskBorderWidth = this._calculateTaskBorderWidth();
	            var resourceStyle;
	            var showPlannedTasks = this.options.showPlannedTasks;

	            var addCoordinates = function(rowIndex) {
	                var taskLeft;
	                var taskRight;

	                taskLeft = position.left;
	                taskRight = taskLeft + position.width;

	                if (task.isMilestone()) {
	                    taskLeft -= milestoneWidth / 2;
	                    taskRight = taskLeft + milestoneWidth;
	                }

	                coordinates[task.id] = {
	                    start: taskLeft,
	                    end: taskRight,
	                    rowIndex: rowIndex
	                };
	            };

	            for (var i = 0, l = tasks.length; i < l; i++) {
	                task = tasks[i];

	                position = this._taskPosition(task);

	                if(showPlannedTasks) {
	                    plannedPosition = this._taskPositionPlanned(task);
	                    plannedPosition.borderWidth = taskBorderWidth;
	                }
	                position.borderWidth = taskBorderWidth;

	                row = kendoDomElement("tr", null);
	                cell = kendoDomElement("td");

	                if (task.start <= this.end && task.end >= this.start) {
	                    cell.children.push(this._renderTask(tasks[i], position, plannedPosition));

	                    if (task[resourcesField] && task[resourcesField].length) {
	                        if (isRtl) {
	                            resourcesPosition = this._tableWidth - position.left;
	                        } else {
	                            resourcesPosition = Math.max((position.width || size.clientWidth), 0) + position.left;
	                        }

	                        resourceStyle = {
	                            width: (this._tableWidth - (resourcesPosition + resourcesMargin)) + "px"
	                        };

	                        resourceStyle[isRtl ? "right" : "left"] = resourcesPosition + "px";

	                        if (calculatedSize) {
	                            resourceStyle.height = calculatedSize.cell + "px";
	                        }

	                        cell.children.push(kendoDomElement("div",
	                            {
	                                className: styles.resourcesWrap,
	                                style: resourceStyle
	                            },
	                            this._renderResources(task[resourcesField], className[i % 2]))
	                        );
	                    }

	                    addCoordinates(i);
	                }
	                row.children.push(cell);
	                rows.push(row);
	            }

	            return this._createTable(1, rows, { className: GanttView.styles.tasksTable });
	        },

	        _createTable: function(colspan, rows, styles) {
	            var cols = [];
	            var colgroup;
	            var tbody;

	            for (var i = 0; i < colspan; i++) {
	                cols.push(kendoDomElement("col"));
	            }

	            colgroup = kendoDomElement("colgroup", null, cols);

	            tbody = kendoDomElement("tbody", null, rows);

	            if (!styles.style) {
	                styles.style = {};
	            }

	            styles.style.width = this._tableWidth + "px";
	            styles.role = "presentation";

	            return kendoDomElement("table", styles, [colgroup, tbody]);
	        },

	        _calculateTableWidth: function() {
	            var slots = this._timeSlots();
	            var maxSpan = 0;
	            var totalSpan = 0;
	            var currentSpan;
	            var tableWidth;

	            for (var i = 0, length = slots.length; i < length; i++) {
	                currentSpan = slots[i].span;

	                totalSpan += currentSpan;

	                if (currentSpan > maxSpan) {
	                    maxSpan = currentSpan;
	                }
	            }

	            tableWidth = Math.round((totalSpan * this.options.slotSize) / maxSpan);

	            return tableWidth;
	        },

	        _calculateMilestoneWidth: function() {
	            var size;
	            var className = GanttView.styles.task + " " + GanttView.styles.taskMilestone;
	            var milestone = $("<div class='" + className + "' style='visibility: hidden; position: absolute'>");
	            var boundingClientRect;

	            this.content.append(milestone);

	            boundingClientRect = milestone[0].getBoundingClientRect();

	            size = {
	                "width": boundingClientRect.right - boundingClientRect.left,
	                "clientWidth": milestone[0].clientWidth
	            };

	            milestone.remove();

	            return size;
	        },

	        _calculateResourcesMargin: function() {
	            var margin;
	            var wrapper = $("<div class='" + GanttView.styles.resourcesWrap + "' style='visibility: hidden; position: absolute'>");

	            this.content.append(wrapper);

	            margin = parseInt(wrapper.css(isRtl ? "margin-right" : "margin-left"), 10);

	            wrapper.remove();

	            return margin;
	        },

	        _calculateTaskBorderWidth: function() {
	            var width;
	            var className = GanttView.styles.task + " " + GanttView.styles.taskSingle;
	            var task = $("<div class='" + className + "' style='visibility: hidden; position: absolute'>");
	            var computedStyle;

	            this.content.append(task);

	            computedStyle = kendo.getComputedStyles(task[0], ["border-left-width"]);

	            width = parseFloat(computedStyle["border-left-width"], 10);

	            task.remove();

	            return width;
	        },

	        _renderTask: function(task, position, plannedPosition) {
	            var editable = this.options.editable;
	            var taskLeft = position.left;
	            var styles = GanttView.styles;
	            var wrapClassName = styles.taskWrap;
	            var calculatedSize = this.options.calculatedSize;
	            var dragHandleStyle = {};
	            var taskWrapAttr = {
	                className: wrapClassName,
	                style: { left: taskLeft + "px" }
	            };
	            var children = [];
	            var endTaskDotRight = 0;
	            var taskFullWidth = position.width;
	            var taskWrapper, taskElement, progressHandleOffset, plannedElement;
	            var endTaskDotLeft, taskOffsetWrap, offsetElement, offsetWidth;

	            if (calculatedSize) {
	                taskWrapAttr.style.height = calculatedSize.cell + "px";
	            }

	            if(plannedPosition) {
	                if (task.isMilestone()) {
	                    plannedElement = this._renderPlannedMilestone(position, plannedPosition);
	                } else {
	                    plannedElement = this._renderPlannedSingleTask(position, plannedPosition, task);
	                }

	                children.push(plannedElement);

	                if(isRtl && plannedPosition.left <= position.left) {
	                    taskWrapAttr.style.left = plannedPosition.left + "px";
	                }
	            }

	            if (task.summary) {
	                taskElement = this._renderSummary(task, position, plannedPosition);
	                taskWrapAttr.className += " " + styles.taskSummaryWrap;
	            } else if (task.isMilestone()) {
	                taskElement = this._renderMilestone(task, position);
	                taskWrapAttr.className += " " + styles.taskMilestoneWrap;
	            } else {
	                taskElement = this._renderSingleTask(task, position, plannedPosition);
	            }

	            if(plannedPosition && !task.isMilestone() && task.plannedStart < task.end && task.plannedEnd > task.start && task.plannedEnd < task.end) {
	                if(isRtl){
	                    taskFullWidth = position.left + position.width - plannedPosition.left;
	                } else {
	                    taskFullWidth = plannedPosition.left + plannedPosition.width - position.left;
	                }

	                if(isRtl) {
	                    offsetWidth = plannedPosition.left - position.left;
	                } else {
	                    offsetWidth = position.left + position.width - (plannedPosition.left + plannedPosition.width);
	                }

	                offsetElement = kendoDomElement("div", {
	                    className: styles.taskOffset,
	                    style: { width: offsetWidth - 2 * plannedPosition.borderWidth + "px" }
	                });

	                if(editable && editable.resize !== false && editable.update !== false && !task.summary) {
	                    if(editable.destroy !== false) {
	                        offsetElement.children.push(kendoDomElement("span", { className: styles.taskActions }, [
	                            kendoDomElement("a", { className: styles.link + " " + styles.taskDelete, href: "#", "aria-label": "Delete" }, [
	                                kendoDomElement("span", { className: styles.icon + " " + styles.iconDelete })
	                            ])
	                        ]));
	                    }

	                    if(isRtl) {
	                        offsetElement.children.push(kendoDomElement("span", {
	                            className: styles.taskResizeHandle + " " + styles.taskResizeHandleWest,
	                            style: {
	                                right: position.width - 5 + "px"
	                            }
	                        }));
	                    } else {
	                        offsetElement.children.push(kendoDomElement("span", {
	                            className: styles.taskResizeHandle + " " + styles.taskResizeHandleEast
	                        }));
	                    }
	                }

	                taskOffsetWrap = kendoDomElement("div", {
	                    className: styles.taskOffsetWrap + " " + styles.taskInnerWrap
	                }, [ taskElement, offsetElement ]);

	                children.push(taskOffsetWrap);
	            } else if(plannedPosition) {
	                children.push(kendoDomElement("div", {
	                    className: styles.taskInnerWrap
	                }, [ taskElement ]));
	            } else {
	                children.push(taskElement);
	            }

	            taskWrapper = kendoDomElement("div", taskWrapAttr, children);

	            if (editable && editable.dependencyCreate !== false) {
	                if(plannedPosition && task.plannedEnd > task.end) {
	                    endTaskDotRight = plannedPosition.left + plannedPosition.width - position.left - position.width - 3 + "px";
	                }

	                taskWrapper.children.push(kendoDomElement("div", {
	                    className: styles.taskDot + " " + styles.taskDotStart
	                }));

	                if(isRtl) {
	                    endTaskDotRight = "auto";
	                    if(plannedPosition && task.plannedEnd > task.end) {
	                        endTaskDotLeft = position.left - plannedPosition.left + "px";
	                    }
	                }

	                taskWrapper.children.push(kendoDomElement("div", {
	                    className: styles.taskDot + " " + styles.taskDotEnd,
	                    style: { right: endTaskDotRight, left: endTaskDotLeft }
	                }));
	            }

	            if (!task.summary && !task.isMilestone() && editable && editable.dragPercentComplete !== false && editable.update !== false && this._taskTemplate === null) {
	                progressHandleOffset = Math.round(taskFullWidth * task.percentComplete);

	                dragHandleStyle[isRtl ? "right" : "left"] = progressHandleOffset + "px";
	                taskWrapper.children.push(kendoDomElement("div", { className: styles.taskDragHandle, style: dragHandleStyle }));
	            }

	            return taskWrapper;
	        },

	        _renderSingleTask: function(task, position, plannedPosition) {
	            var styles = GanttView.styles;
	            var progressWidth;
	            var taskChildren = [];
	            var taskContent;
	            var editable = this.options.editable;
	            var classes = styles.task + " " + styles.taskSingle;
	            var widthExceptDelay = position.width;

	            if(plannedPosition) {
	                if(task.plannedEnd && task.plannedEnd <= task.start) {
	                    classes += " " + styles.taskDelayed;
	                } else if (task.plannedEnd && task.plannedEnd > task.end) {
	                    classes += " " + styles.taskAdvanced;
	                } else if(task.plannedEnd && task.plannedEnd < task.end) {
	                    if(!isRtl){
	                        widthExceptDelay = widthExceptDelay - (position.left + position.width - plannedPosition.left - plannedPosition.width);
	                    } else {
	                        widthExceptDelay = widthExceptDelay + position.left - plannedPosition.left;
	                    }
	                }
	            }

	            progressWidth = Math.round(widthExceptDelay * task.percentComplete);

	            if (this._taskTemplate !== null) {
	                taskContent = kendoHtmlElement(this._taskTemplate(task));
	            } else {
	                taskContent = kendoTextElement(task.title);
	                taskChildren.push(kendoDomElement("div", { className: styles.taskComplete, style: { width: progressWidth + "px" } }));
	            }

	            var content = kendoDomElement("div", { className: styles.taskContent }, [
	                kendoDomElement("div", { className: styles.taskTemplate }, [
	                    taskContent
	                ])
	            ]);

	            taskChildren.push(content);

	            if (editable) {
	                if (editable.destroy !== false && (!plannedPosition || !task.plannedEnd || (task.end <= task.plannedEnd || task.start >= task.plannedEnd))) {
	                    content.children.push(kendoDomElement("span", { className: styles.taskActions }, [
	                        kendoDomElement("a", { className: styles.link + " " + styles.taskDelete, href: "#", "aria-label": "Delete" }, [
	                            kendoDomElement("span", { className: styles.icon + " " + styles.iconDelete })
	                        ])
	                    ]));
	                }

	                if (editable.resize !== false && editable.update !== false) {
	                    content.children.push(kendoDomElement("span", {
	                        className: styles.taskResizeHandle + " " + styles.taskResizeHandleWest
	                    }));
	                    content.children.push(kendoDomElement("span", {
	                        className: styles.taskResizeHandle + " " + styles.taskResizeHandleEast
	                    }));
	                }
	            }

	            var element = kendoDomElement("div", {
	                className: classes, "data-uid": task.uid, style:
	                    { width: Math.max((widthExceptDelay - position.borderWidth * 2), 0) + "px" }
	            }, taskChildren);

	            return element;
	        },

	        _renderMilestone: function(task) {
	            var styles = GanttView.styles;
	            var classes = styles.task + " " + styles.taskMilestone;
	            var showPlanned = this.options.showPlannedTasks;

	            if(showPlanned && task.plannedEnd && task.plannedEnd < task.start) {
	                classes += " " + styles.taskDelayed;
	            } else if (task.plannedStart && task.plannedStart > task.end) {
	                classes += " " + styles.taskAdvanced;
	            }

	            return kendoDomElement("div", { className: classes, "data-uid": task.uid });
	        },

	        _renderSummary: function(task, position, plannedPosition) {
	            var styles = GanttView.styles;
	            var widthExceptDelay = position.width;
	            var progressWidth;
	            var classes = styles.task + " " + styles.taskSummary;

	            if(plannedPosition) {
	                if(task.plannedEnd && task.plannedEnd <= task.start) {
	                    classes += " " + styles.taskDelayed;
	                } else if (task.plannedEnd && task.plannedEnd > task.end) {
	                    classes += " " + styles.taskAdvanced;
	                } else if(task.plannedEnd && task.plannedEnd < task.end) {
	                    if(!isRtl){
	                        widthExceptDelay = widthExceptDelay - (position.left + position.width - plannedPosition.left - plannedPosition.width);
	                    } else {
	                        widthExceptDelay = widthExceptDelay + position.left - plannedPosition.left;
	                    }
	                }
	            }

	            progressWidth = Math.round(widthExceptDelay * task.percentComplete);

	            var element = kendoDomElement("div", { className: classes, "data-uid": task.uid, style: { width: widthExceptDelay + "px" } }, [
	                kendoDomElement("div", { className: styles.taskSummaryProgress, style: { width: progressWidth + "px" } }, [
	                    kendoDomElement("div", { className: styles.taskSummaryComplete, style: { width: position.width + "px" } })
	                ])
	            ]);

	            return element;
	        },

	        _renderPlannedSingleTask: function(position, plannedPosition, task) {
	            var styles = GanttView.styles;
	            var children = [];
	            var style = {};

	            if(task.plannedStart && task.plannedEnd) {
	                children.push(kendoDomElement("div", { className: styles.taskPlannedMoment + " " + styles.taskPlannedMomentLeft }));
	                children.push(kendoDomElement("div", {
	                    className: styles.taskPlannedDuration, style:
	                        { width: Math.max((plannedPosition.width - plannedPosition.borderWidth * 2 - 16), 0) + "px" }
	                }));
	                children.push(kendoDomElement("div", { className: styles.taskPlannedMoment }));
	            } else if (task.plannedStart) {
	                children.push(kendoDomElement("div", { className: styles.taskPlannedMoment + " " + styles.taskPlannedMomentLeft }));
	            } else if (task.plannedEnd) {
	                children.push(kendoDomElement("div", { className: styles.taskPlannedMoment, style: { "margin-left": Math.max(plannedPosition.width - 5, 0) + "px" } }));
	            }

	            if(isRtl) {
	                style = {
	                    "margin-right": position.left - plannedPosition.left + position.width - plannedPosition.width + "px"
	                };
	            } else {
	                style = {
	                    "margin-left": plannedPosition.left - position.left + "px"
	                };
	            }

	            var element = kendoDomElement("div", {
	                className: styles.taskPlanned,
	                style: style
	            }, children);

	            return element;
	        },

	        _renderPlannedMilestone: function(position, plannedPosition) {
	            var styles = GanttView.styles;
	            var style = {};
	            var element;

	            if(isRtl) {
	                style = {
	                    "margin-right": position.left - plannedPosition.left + "px"
	                };
	            } else {
	                style = {
	                    "margin-left": plannedPosition.left - position.left + "px"
	                };
	            }

	            element = kendoDomElement("div", {
	                className: styles.taskPlanned,
	                style: style
	            }, [
	                kendoDomElement("div", { className: styles.taskPlannedMoment })
	            ]);

	            return element;
	        },

	        _renderResources: function(resources, className) {
	            var children = [];
	            var resource;

	            for (var i = 0, length = resources.length; i < length; i++) {
	                resource = resources[i];
	                children.push(kendoDomElement("span", {
	                    className: className,
	                    style: {
	                        "color": resource.get("color")
	                    }
	                }, [kendoTextElement(resource.get("name"))]));
	            }

	            if (isRtl) {
	                children.reverse();
	            }

	            return children;
	        },

	        _taskPosition: function(task) {
	            var round = Math.round;

	            var startLeft = round(this._offset(isRtl ? task.end : task.start));
	            var endLeft = round(this._offset(isRtl ? task.start : task.end));

	            return { left: startLeft, width: endLeft - startLeft };
	        },

	        _taskPositionPlanned: function(task) {
	            var round = Math.round;

	            var startLeft = round(this._offset(isRtl ? task.plannedEnd : task.plannedStart));
	            var endLeft = round(this._offset(isRtl ? task.plannedStart : task.plannedEnd));

	            return { left: startLeft, width: endLeft - startLeft };
	        },

	        _offset: function(date) {
	            var slots = this._timeSlots();
	            var slot;
	            var startOffset;
	            var slotDuration;
	            var slotOffset = 0;
	            var startIndex;

	            if (!slots.length) {
	                return 0;
	            }

	            startIndex = this._slotIndex("start", date);

	            slot = slots[startIndex];

	            if (slot.end < date) {
	                slotOffset = slot.offsetWidth;
	            } else if (slot.start <= date) {
	                startOffset = date - slot.start;
	                slotDuration = slot.end - slot.start;
	                slotOffset = (startOffset / slotDuration) * slot.offsetWidth;
	            }

	            if (isRtl) {
	                slotOffset = (slot.offsetWidth + 1) - slotOffset; // Add one pixel for border
	            }

	            return slot.offsetLeft + slotOffset;
	        },

	        _slotIndex: function(field, value, reverse) {
	            var slots = this._timeSlots();
	            var startIdx = 0;
	            var endIdx = slots.length - 1;
	            var middle;

	            if (reverse) {
	                slots = [].slice.call(slots).reverse();
	            }

	            do {
	                middle = Math.ceil((endIdx + startIdx) / 2);

	                if (slots[middle][field] < value) {
	                    startIdx = middle;
	                } else {
	                    if (middle === endIdx) {
	                        middle--;
	                    }

	                    endIdx = middle;
	                }
	            } while (startIdx !== endIdx);

	            if (reverse) {
	                startIdx = (slots.length - 1) - startIdx;
	            }

	            return startIdx;
	        },

	        _timeByPosition: function(x, snap, snapToEnd) {
	            var slot = this._slotByPosition(x);

	            if (snap) {
	                return snapToEnd ? slot.end : slot.start;
	            }

	            var offsetLeft = x - this.element.find(DOT + GanttView.styles.tasksTable).offset().left;
	            var duration = slot.end - slot.start;
	            var slotOffset = offsetLeft - slot.offsetLeft;

	            if (isRtl) {
	                slotOffset = slot.offsetWidth - slotOffset;
	            }

	            return new Date(slot.start.getTime() + (duration * (slotOffset / slot.offsetWidth)));
	        },

	        _slotByPosition: function(x) {
	            var offsetLeft = x - this.element.find(DOT + GanttView.styles.tasksTable).offset().left;
	            var slotIndex = this._slotIndex("offsetLeft", offsetLeft, isRtl);

	            return this._timeSlots()[slotIndex];
	        },

	        _renderDependencies: function(dependencies) {
	            var elements = [];
	            var tree = this._dependencyTree;

	            for (var i = 0, l = dependencies.length; i < l; i++) {
	                elements.push.apply(elements, this._renderDependency(dependencies[i]));
	            }

	            tree.render(elements);
	        },

	        _renderDependency: function(dependency) {
	            var predecessor = this._taskCoordinates[dependency.predecessorId];
	            var successor = this._taskCoordinates[dependency.successorId];
	            var elements;
	            var method;

	            if (!predecessor || !successor) {
	                return [];
	            }

	            method = "_render" + ["FF", "FS", "SF", "SS"][isRtl ? 3 - dependency.type : dependency.type];

	            elements = this[method](predecessor, successor);

	            for (var i = 0, length = elements.length; i < length; i++) {
	                elements[i].attr["data-uid"] = dependency.uid;
	            }

	            return elements;
	        },

	        _renderFF: function(from, to) {
	            var lines = this._dependencyFF(from, to, false);

	            lines[lines.length - 1].children[0] = this._arrow(true);

	            return lines;
	        },

	        _renderSS: function(from, to) {
	            var lines = this._dependencyFF(to, from, true);

	            lines[0].children[0] = this._arrow(false);

	            return lines.reverse();
	        },

	        _renderFS: function(from, to) {
	            var lines = this._dependencyFS(from, to, false);

	            lines[lines.length - 1].children[0] = this._arrow(false);

	            return lines;
	        },

	        _renderSF: function(from, to) {
	            var lines = this._dependencyFS(to, from, true);

	            lines[0].children[0] = this._arrow(true);

	            return lines.reverse();
	        },

	        _dependencyFF: function(from, to, reverse) {
	            var that = this;
	            var lines = [];
	            var left = 0;
	            var top = 0;
	            var width = 0;
	            var height = 0;
	            var dir = reverse ? "start" : "end";
	            var delta;
	            var overlap = 2;
	            var arrowOverlap = 1;
	            var rowHeight = this._rowHeight;
	            var minLineWidth = 10;
	            var fromTop = from.rowIndex * rowHeight + Math.floor(rowHeight / 2) - 1;
	            var toTop = to.rowIndex * rowHeight + Math.floor(rowHeight / 2) - 1;
	            var styles = GanttView.styles;

	            var addHorizontal = function() {
	                lines.push(that._line(styles.line + " " + styles.lineHorizontal, { left: left + "px", top: top + "px", width: width + "px" }));
	            };
	            var addVertical = function() {
	                lines.push(that._line(styles.line + " " + styles.lineVertical, { left: left + "px", top: top + "px", height: height + "px" }));
	            };

	            left = from[dir];
	            top = fromTop;
	            width = minLineWidth;

	            delta = to[dir] - from[dir];

	            if ((delta) > 0 !== reverse) {
	                width = Math.abs(delta) + minLineWidth;
	            }

	            if (reverse) {
	                left -= width;
	                width -= arrowOverlap;
	                addHorizontal();
	            } else {
	                addHorizontal();
	                left += width - overlap;
	            }

	            if (toTop < top) {
	                height = top - toTop;
	                height += overlap;
	                top = toTop;
	                addVertical();
	            } else {
	                height = toTop - top;
	                height += overlap;
	                addVertical();
	                top += (height - overlap);
	            }

	            width = Math.abs(left - to[dir]);

	            if (!reverse) {
	                width -= arrowOverlap;
	                left -= width;
	            }

	            addHorizontal();

	            return lines;
	        },

	        _dependencyFS: function(from, to, reverse) {
	            var that = this;
	            var lines = [];
	            var left = 0;
	            var top = 0;
	            var width = 0;
	            var height = 0;
	            var rowHeight = this._rowHeight;
	            var minLineHeight = Math.floor(rowHeight / 2);
	            var minLineWidth = 10;
	            var minDistance = 2 * minLineWidth;
	            var delta = to.start - from.end;
	            var overlap = 2;
	            var arrowOverlap = 1;
	            var fromTop = from.rowIndex * rowHeight + Math.floor(rowHeight / 2) - 1;
	            var toTop = to.rowIndex * rowHeight + Math.floor(rowHeight / 2) - 1;
	            var styles = GanttView.styles;

	            var addHorizontal = function() {
	                lines.push(that._line(styles.line + " " + styles.lineHorizontal, { left: left + "px", top: top + "px", width: width + "px" }));
	            };
	            var addVertical = function() {
	                lines.push(that._line(styles.line + " " + styles.lineVertical, { left: left + "px", top: top + "px", height: height + "px" }));
	            };

	            left = from.end;
	            top = fromTop;
	            width = minLineWidth;

	            if (reverse) {
	                left += arrowOverlap;

	                if (delta > minDistance) {
	                    width = delta - (minLineWidth - overlap);
	                }

	                width -= arrowOverlap;
	            }

	            addHorizontal();
	            left += width - overlap;

	            if ((delta) <= minDistance) {
	                height = reverse ? Math.abs(toTop - fromTop) - minLineHeight : minLineHeight;

	                if (toTop < fromTop) {
	                    top -= height;

	                    height += overlap;

	                    addVertical();
	                } else {
	                    addVertical();
	                    top += height;
	                }

	                width = (from.end - to.start) + minDistance;

	                if (width < minLineWidth) {
	                    width = minLineWidth;
	                }

	                left -= width - overlap;

	                addHorizontal();
	            }

	            if (toTop < fromTop) {
	                height = top - toTop;
	                top = toTop;

	                height += overlap;

	                addVertical();
	            } else {
	                height = toTop - top;
	                addVertical();
	                top += height;
	            }

	            width = to.start - left;

	            if (!reverse) {
	                width -= arrowOverlap;
	            }

	            addHorizontal();

	            return lines;
	        },

	        _line: function(className, styles) {
	            return kendoDomElement("div", { className: className, style: styles });
	        },

	        _arrow: function(direction) {
	            return kendoDomElement("span", { className: direction ? GanttView.styles.arrowWest : GanttView.styles.arrowEast });
	        },

	        _colgroup: function() {
	            var slots = this._timeSlots();
	            var count = slots.length;
	            var cols = [];

	            for (var i = 0; i < count; i++) {
	                for (var j = 0, length = slots[i].span; j < length; j++) {
	                    cols.push(kendoDomElement("col"));
	                }
	            }

	            return kendoDomElement("colgroup", null, cols);
	        },

	        _createDragHint: function(element) {
	            var styles = GanttView.styles;
	            var plannedElement;

	            this._dragHint = element
	                .clone()
	                .addClass(styles.dragHint)
	                .css({
	                    "cursor": "move"
	                });

	            plannedElement = this._dragHint.find(DOT + styles.taskPlanned);

	            plannedElement.css({
	                "visibility": "hidden"
	            });

	            if(isRtl && element.find(DOT + styles.taskAdvanced).length > 0) {
	                plannedElement.css({
	                    "margin-right": "auto",
	                    "width": 0
	                });

	                this._dragHint.find(DOT + styles.taskDotEnd).css({
	                    "left": 0
	                });
	            }

	            element
	                .closest("td")
	                .append(this._dragHint);
	        },

	        _updateDragHint: function(start) {
	            var left = this._offset(start);
	            this._dragHint
	                .css({
	                    "left": left
	                });
	        },

	        _removeDragHint: function() {
	            this._dragHint.remove();
	            this._dragHint = null;
	        },

	        _createResizeHint: function(task) {
	            var styles = GanttView.styles;
	            var taskTop = this._taskCoordinates[task.id].rowIndex * this._rowHeight;
	            var tooltipHeight;
	            var tooltipTop;
	            var options = this.options;
	            var messages = options.messages;

	            this._resizeHint = $(RESIZE_HINT({ styles: styles })).css({
	                "top": 0,
	                "height": this._contentHeight
	            });

	            this.content.append(this._resizeHint);

	            this._resizeTooltip = $(RESIZE_TOOLTIP_TEMPLATE({
	                styles: styles,
	                start: task.start,
	                end: task.end,
	                messages: messages.views,
	                format: options.resizeTooltipFormat
	            }))
	            .css({
	                "top": 0,
	                "left": 0
	            });

	            this.content.append(this._resizeTooltip);

	            this._resizeTooltipWidth = outerWidth(this._resizeTooltip);
	            tooltipHeight = outerHeight(this._resizeTooltip);

	            tooltipTop = taskTop - tooltipHeight;

	            if (tooltipTop < 0) {
	                tooltipTop = taskTop + this._rowHeight;
	            }

	            this._resizeTooltipTop = tooltipTop;
	        },

	        _updateResizeHint: function(start, end, resizeStart) {
	            var left = this._offset(isRtl ? end : start);
	            var right = this._offset(isRtl ? start : end);
	            var width = right - left;
	            var tooltipLeft = (resizeStart !== isRtl) ? left : right;
	            var tablesWidth = this._tableWidth - kendo.support.scrollbar();
	            var tooltipWidth = this._resizeTooltipWidth;
	            var options = this.options;
	            var messages = options.messages;
	            var tableOffset = this.element.find(DOT + GanttView.styles.tasksTable).offset().left - this.element.find(DOT + GanttView.styles.tasksWrapper).offset().left;

	            if (isRtl) {
	                left += tableOffset;
	            }

	            this._resizeHint
	                .css({
	                    "left": left,
	                    "width": width
	                });

	            if (this._resizeTooltip) {
	                this._resizeTooltip.remove();
	            }

	            tooltipLeft -= Math.round(tooltipWidth / 2);

	            if (tooltipLeft < 0) {
	                tooltipLeft = 0;
	            } else if (tooltipLeft + tooltipWidth > tablesWidth) {
	                tooltipLeft = tablesWidth - tooltipWidth;
	            }

	            if (isRtl) {
	                tooltipLeft += tableOffset;
	            }

	            this._resizeTooltip = $(RESIZE_TOOLTIP_TEMPLATE({
	                styles: GanttView.styles,
	                start: start,
	                end: end,
	                messages: messages.views,
	                format: options.resizeTooltipFormat
	            }))
	            .css({
	                "top": this._resizeTooltipTop,
	                "left": tooltipLeft,
	                "min-width": tooltipWidth
	            })
	            .appendTo(this.content);
	        },

	        _removeResizeHint: function() {
	            this._resizeHint.remove();
	            this._resizeHint = null;

	            this._resizeTooltip.remove();
	            this._resizeTooltip = null;
	        },

	        _updatePercentCompleteTooltip: function(top, left, text) {
	            this._removePercentCompleteTooltip();

	            var tooltip = this._percentCompleteResizeTooltip = $(PERCENT_RESIZE_TOOLTIP_TEMPLATE({ styles: GanttView.styles, text: text }))
	                .appendTo(this.element);

	            var tooltipMiddle = Math.round(outerWidth(tooltip) / 2);
	            var arrow = tooltip.find(DOT + GanttView.styles.callout);
	            var arrowHeight = Math.round(outerWidth(arrow) / 2);

	            tooltip.css({
	                "top": top - (outerHeight(tooltip) + arrowHeight),
	                "left": left - tooltipMiddle
	            });

	            arrow.css("left", tooltipMiddle - arrowHeight);
	        },

	        _removePercentCompleteTooltip: function() {
	            if (this._percentCompleteResizeTooltip) {
	                this._percentCompleteResizeTooltip.remove();
	            }

	            this._percentCompleteResizeTooltip = null;
	        },

	        _updateDependencyDragHint: function(from, to, useVML) {
	            this._removeDependencyDragHint();

	            if (useVML) {
	                this._creteVmlDependencyDragHint(from, to);
	            } else {
	                this._creteDependencyDragHint(from, to);
	            }
	        },

	        _creteDependencyDragHint: function(from, to) {
	            var styles = GanttView.styles;

	            var deltaX = to.x - from.x;
	            var deltaY = to.y - from.y;

	            var width = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
	            var angle = Math.atan(deltaY / deltaX);

	            if (deltaX < 0) {
	                angle += Math.PI;
	            }

	            $("<div class='" + styles.line + " " + styles.lineHorizontal + " " + styles.dependencyHint + "'></div>")
	                .css({
	                    "top": from.y,
	                    "left": from.x,
	                    "width": width,
	                    "transform-origin": "0% 0",
	                    "-ms-transform-origin": "0% 0",
	                    "-webkit-transform-origin": "0% 0",
	                    "transform": "rotate(" + angle + "rad)",
	                    "-ms-transform": "rotate(" + angle + "rad)",
	                    "-webkit-transform": "rotate(" + angle + "rad)"
	                })
	                .appendTo(this.content);
	        },

	        _creteVmlDependencyDragHint: function(from, to) {
	            var hint = $("<kvml:line class='" + GanttView.styles.dependencyHint + "' style='position:absolute; top: 0px; left: 0px;' strokecolor='black' strokeweight='2px' from='" +
	                from.x + "px," + from.y + "px' to='" + to.x + "px," + to.y + "px'" + "></kvml:line>")
	                .appendTo(this.content);

	            // IE8 Bug
	            hint[0].outerHTML = hint[0].outerHTML;
	        },

	        _removeDependencyDragHint: function() {
	            this.content.find(DOT + GanttView.styles.dependencyHint).remove();
	        },

	        _createTaskTooltip: function(task, element, mouseLeft) {
	            var styles = GanttView.styles;
	            var options = this.options;
	            var content = this.content;
	            var contentOffset = content.offset();
	            var contentScrollLeft = kendo.scrollLeft(content);
	            var row = $(element).parents("tr").first();
	            var rowOffset = row.offset();
	            var template = (options.tooltip && options.tooltip.template) ? kendo.template(options.tooltip.template) : TASK_TOOLTIP_TEMPLATE;
	            var left = isRtl ? mouseLeft - (contentOffset.left + contentScrollLeft + kendo.support.scrollbar())
	                : mouseLeft - (contentOffset.left - contentScrollLeft);
	            var top = (rowOffset.top + outerHeight(row) - contentOffset.top) + content.scrollTop();
	            var tooltip = this._taskTooltip = $('<div style="z-index: 100002;" class="' + styles.tooltipWrapper + '" >' +
	                                   '<div class="' + styles.taskContent + '"></div></div>');

	            tooltip
	                .css({
	                    "left": left,
	                    "top": top
	                })
	                .appendTo(content)
	                .find(DOT + styles.taskContent)
	                .append(template({
	                    styles: styles,
	                    task: task,
	                    messages: options.messages.views
	                }));

	            this._adjustTooltipDimensions(tooltip, rowOffset, contentOffset, left, contentScrollLeft);
	        },

	        _removeTaskTooltip: function() {
	            if (this._taskTooltip) {
	                this._taskTooltip.remove();
	            }

	            this._taskTooltip = null;
	        },

	        _createOffsetTooltip: function(task, element, mouseLeft) {
	            var styles = GanttView.styles;
	            var content = this.content;
	            var contentOffset = content.offset();
	            var contentScrollLeft = kendo.scrollLeft(content);
	            var row = element.parents("tr").first();
	            var rowOffset = row.offset();
	            var left = isRtl ? mouseLeft - (contentOffset.left + contentScrollLeft + kendo.support.scrollbar())
	                : mouseLeft - (contentOffset.left - contentScrollLeft);
	            var top = (rowOffset.top + outerHeight(row) - contentOffset.top) + content.scrollTop();
	            var tooltip = this._offsetTooltip = $('<div style="z-index: 100002;" class="' + styles.tooltipWrapper + '" ></div>');
	            var offsetValue = Math.round((task.end.getTime() - task.plannedEnd.getTime()) / 60000);
	            var plannedTasksMessages = this.options.messages.plannedTasks;
	            var minutes = offsetValue % 60;
	            var offsetText = minutes + " " + plannedTasksMessages.minutes;
	            var hours, days;

	            if(offsetValue >= 60) {
	                hours = offsetValue = Math.floor(offsetValue / 60);

	                offsetText = hours + " " + plannedTasksMessages.hours;

	                if(minutes !== 0) {
	                    offsetText += (" " + minutes + " " + plannedTasksMessages.minutes);
	                }

	                if(offsetValue >= 24) {
	                    hours = offsetValue % 24;
	                    days = offsetValue = Math.floor(offsetValue / 24);

	                    offsetText = days + " " + plannedTasksMessages.days;

	                    if(hours !== 0) {
	                        offsetText += (" " + hours + " " + plannedTasksMessages.hours);
	                    }
	                }
	            }

	            tooltip
	                .css({
	                    "left": left,
	                    "top": top
	                })
	                .addClass(styles.offsetTooltipDelay)
	                .appendTo(content)
	                .append(OFFSET_TOOLTIP_TEMPLATE({
	                    offsetPrefix: plannedTasksMessages.offsetTooltipDelay,
	                    offsetText: offsetText
	                }));

	            this._adjustTooltipDimensions(tooltip, rowOffset, contentOffset, left, contentScrollLeft);
	        },

	        _removeOffsetTooltip: function() {
	            if (this._offsetTooltip) {
	                this._offsetTooltip.remove();
	            }

	            this._offsetTooltip = null;
	        },

	        _createPlannedTooltip: function(task, element, mouseLeft) {
	            var styles = GanttView.styles;
	            var content = this.content;
	            var contentOffset = content.offset();
	            var contentScrollLeft = kendo.scrollLeft(content);
	            var row = element.parents("tr").first();
	            var rowOffset = row.offset();
	            var left = isRtl ? mouseLeft - (contentOffset.left + contentScrollLeft + kendo.support.scrollbar())
	                : mouseLeft - (contentOffset.left - contentScrollLeft);
	            var top = (rowOffset.top + outerHeight(row) - contentOffset.top) + content.scrollTop();
	            var tooltip = this._plannedTooltip = $('<div style="z-index: 100002;" class="' + styles.tooltipWrapper + ' ' + styles.plannedTooltip + '" ></div>');
	            var editorMessages = this.options.messages.editor;

	            tooltip
	                .css({
	                    "left": left,
	                    "top": top
	                })
	                .appendTo(content)
	                .append(PLANNED_TOOLTIP_TEMPLATE({
	                    plannedStart: editorMessages.plannedStart,
	                    startDate: kendo.toString(task.plannedStart, "H:mm tt ddd, MMM dd"),
	                    plannedEnd: editorMessages.plannedEnd,
	                    endDate: kendo.toString(task.plannedEnd, "H:mm tt ddd, MMM dd")
	                }));

	            this._adjustTooltipDimensions(tooltip, rowOffset, contentOffset, left, contentScrollLeft);
	        },

	        _removePlannedTooltip: function() {
	            if (this._plannedTooltip) {
	                this._plannedTooltip.remove();
	            }

	            this._plannedTooltip = null;
	        },

	        _adjustTooltipDimensions: function(tooltip, rowOffset, contentOffset, left, contentScrollLeft) {
	            var content = this.content;
	            var contentWidth = content.width();
	            var tooltipWidth;

	            if (outerHeight(tooltip) < rowOffset.top - contentOffset.top) {
	                tooltip.css("top", ((rowOffset.top - contentOffset.top) - outerHeight(tooltip)) + content.scrollTop());
	            }

	            tooltipWidth = outerWidth(tooltip);

	            if ((tooltipWidth + left) - contentScrollLeft > contentWidth) {
	                left -= tooltipWidth;

	                if (left < contentScrollLeft) {
	                    left = (contentScrollLeft + contentWidth) - (tooltipWidth + 17);
	                }

	                tooltip.css("left", left);
	            }
	        },

	        _scrollTo: function(element) {
	            var elementLeft = element.offset().left;
	            var elementWidth = element.width();
	            var elementRight = elementLeft + elementWidth;

	            var row = element.closest("tr");
	            var rowTop = row.offset().top;
	            var rowHeight = row.height();
	            var rowBottom = rowTop + rowHeight;

	            var content = this.content;
	            var contentOffset = content.offset();
	            var contentTop = contentOffset.top;
	            var contentHeight = content.height();
	            var contentBottom = contentTop + contentHeight;
	            var contentLeft = contentOffset.left;
	            var contentWidth = content.width();
	            var contentRight = contentLeft + contentWidth;

	            var scrollbarWidth = kendo.support.scrollbar();

	            if (rowTop < contentTop) {
	                content.scrollTop(content.scrollTop() + (rowTop - contentTop));
	            } else if (rowBottom > contentBottom) {
	                content.scrollTop(content.scrollTop() + (rowBottom + scrollbarWidth - contentBottom));
	            }

	            if (elementLeft < contentLeft && elementWidth > contentWidth && elementRight < contentRight ||
	                elementRight > contentRight && elementWidth < contentWidth) {
	                    kendo.scrollLeft(content, kendo.scrollLeft(content) + (elementRight + scrollbarWidth - contentRight));
	            } else if (elementRight > contentRight && elementWidth > contentWidth && elementLeft > contentLeft ||
	                elementLeft < contentLeft && elementWidth < contentWidth) {
	            kendo.scrollLeft(content, kendo.scrollLeft(content) + (elementLeft - contentLeft));
	            }
	        },

	        _scrollToDate: function (date) {
	            var viewStart = this.start;
	            var viewEnd = this.end;
	            var offset;

	            if (date >= viewStart && date < viewEnd) {
	                offset = this._offset(date);

	                if (kendo.support.isRtl(this.element)) {
	                    offset = this._tableWidth - offset;
	                }

	                kendo.scrollLeft(this.content, offset);
	            }
	        },

	        _timeSlots: function() {
	            if (!this._slots || !this._slots.length) {
	                return [];
	            }

	            return this._slots[this._slots.length - 1];
	        },

	        _headers: function(columnLevels) {
	            var rows = [];
	            var level;
	            var headers;
	            var column;
	            var headerText;
	            var styles = GanttView.styles;

	            for (var levelIndex = 0, levelCount = columnLevels.length; levelIndex < levelCount; levelIndex++) {
	                level = columnLevels[levelIndex];
	                headers = [];

	                for (var columnIndex = 0, columnCount = level.length; columnIndex < columnCount; columnIndex++) {
	                    column = level[columnIndex];

	                    headerText = kendoHtmlElement(column.text);
	                    headers.push(kendoDomElement("td", { colspan: column.span, className: styles.header + (column.isNonWorking ? (" " + styles.nonWorking) : "") }, [headerText]));
	                }

	                rows.push(kendoDomElement("tr", null, headers));
	            }

	            return rows;
	        },

	        _hours: function(start, end) {
	            var slotEnd;
	            var slots = [];
	            var options = this.options;
	            var workDayStart = options.workDayStart.getHours();
	            var workDayEnd = options.workDayEnd.getHours();
	            var isWorkHour;
	            var hours;
	            var hourSpan = options.hourSpan;

	            start = new Date(start);
	            end = new Date(end);

	            if (options.showWorkHours) {
	                start.setHours(workDayStart);
	            }

	            while (start < end) {
	                slotEnd = new Date(start);
	                hours = slotEnd.getHours();

	                isWorkHour = hours >= workDayStart && hours < workDayEnd;

	                slotEnd.setHours(slotEnd.getHours() + hourSpan);

	                if (hours == slotEnd.getHours()) {
	                    // Chrome DTS Fix
	                    slotEnd.setHours(slotEnd.getHours() + 2 * hourSpan);
	                }

	                if (!options.showWorkHours || isWorkHour) {
	                    slots.push({
	                        start: start,
	                        end: slotEnd,
	                        isNonWorking: !isWorkHour,
	                        span: 1
	                    });
	                }

	                start = slotEnd;
	            }

	            return slots;
	        },

	        _days: function(start, end) {
	            var slotEnd;
	            var slots = [];
	            var isWorkDay;

	            start = new Date(start);
	            end = new Date(end);

	            while (start < end) {
	                slotEnd = end < kendo.date.nextDay(start) ? end : kendo.date.nextDay(start);

	                isWorkDay = this._isWorkDay(start);

	                if (!this.options.showWorkDays || isWorkDay) {
	                    slots.push({
	                        start: start,
	                        end: slotEnd,
	                        isNonWorking: !isWorkDay,
	                        span: 1
	                    });
	                }

	                start = slotEnd;
	            }

	            return slots;
	        },

	        _weeks: function(start, end) {
	            var slotEnd;
	            var slots = [];
	            var firstDay = this.calendarInfo().firstDay;
	            var daySlots;
	            var span;

	            start = new Date(start);
	            end = new Date(end);

	            while (start < end) {
	                slotEnd = kendo.date.dayOfWeek(kendo.date.addDays(start, 1), firstDay, 1);

	                if (slotEnd > end) {
	                    slotEnd = end;
	                }

	                daySlots = this._days(start, slotEnd);
	                span = daySlots.length;

	                if (span > 0) {
	                    slots.push({
	                        start: daySlots[0].start,
	                        end: daySlots[span - 1].end,
	                        span: span
	                    });
	                }

	                start = slotEnd;
	            }

	            return slots;
	        },

	        _months: function(start, end) {
	            var slotEnd;
	            var endMonth;
	            var slots = [];
	            var daySlots;
	            var span;

	            start = new Date(start);
	            end = new Date(end);

	            while (start < end) {
	                slotEnd = new Date(start);
	                endMonth = kendo.date.firstDayOfMonth(new Date(slotEnd.setMonth(slotEnd.getMonth() + 1)));
	                slotEnd = end < endMonth ? end : endMonth;

	                daySlots = this._days(start, slotEnd);
	                span = daySlots.length;

	                if (span > 0) {
	                    slots.push({
	                        start: daySlots[0].start,
	                        end: daySlots[span - 1].end,
	                        span: span
	                    });
	                }

	                start = slotEnd;
	            }

	            return slots;
	        },

	        _years: function(start, end) {
	            var slotEnd;
	            var monthSpan;
	            var endMonth;
	            var slots = [];

	            start = new Date(start);
	            end = new Date(end);

	            while (start < end) {
	                slotEnd = new Date(start);
	                slotEnd = kendo.date.firstDayOfMonth(new Date(slotEnd.setMonth(12)));

	                if (slotEnd >= end) {
	                    slotEnd = end;
	                }

	                endMonth = slotEnd.getMonth() || 12;
	                monthSpan = endMonth - start.getMonth();

	                slots.push({
	                    start: start,
	                    end: slotEnd,
	                    span: monthSpan
	                });

	                start = slotEnd;
	            }

	            return slots;
	        },

	        _slotHeaders: function(slots, template) {
	            var columns = [];
	            var slot;

	            for (var i = 0, l = slots.length; i < l; i++) {
	                slot = slots[i];

	                columns.push({
	                    text: template(slot),
	                    isNonWorking: !!slot.isNonWorking,
	                    span: slot.span
	                });
	            }

	            return columns;
	        },

	        _isWorkDay: function(date) {
	            var day = date.getDay();
	            var workDays = this._workDays;

	            for (var i = 0, l = workDays.length; i < l; i++) {
	                if (workDays[i] === day) {
	                    return true;
	                }
	            }

	            return false;
	        },

	        calendarInfo: function() {
	            return kendo.getCulture().calendars.standard;
	        },

	        _renderCurrentTime: function() {
	            var currentTime = this._getCurrentTime();
	            var timeOffset = this._offset(currentTime);
	            var element = $("<div class='k-current-time'></div>");
	            var viewStyles = GanttView.styles;
	            var tablesWrap = this.element.find(DOT + viewStyles.tasksWrapper);
	            var tasksTable = this.element.find(DOT + viewStyles.tasksTable);
	            var slot;

	            if (!this.content || !this._timeSlots().length) {
	                return;
	            }

	            this.content.find(".k-current-time").remove();

	            slot = this._timeSlots()[this._slotIndex("start", currentTime)];

	            if (currentTime < slot.start || currentTime > slot.end) {
	                return;
	            }

	            if (tablesWrap.length && tasksTable.length) {
	                timeOffset += tasksTable.offset().left - tablesWrap.offset().left;
	            }

	            element.css({
	                left: timeOffset + "px",
	                top: "0px",
	                width: "1px",
	                height: this._contentHeight + "px"
	            })
	            .appendTo(this.content);
	        },

	        _getCurrentTime: function() {
	            // Introduced for testing purposes
	            return new Date();
	        },

	        _currentTime: function() {
	            var markerOptions = this.options.currentTimeMarker;

	            if (markerOptions !== false && markerOptions.updateInterval !== undefined) {
	                this._renderCurrentTime();
	                this._currentTimeUpdateTimer = setInterval(proxy(this._renderCurrentTime, this), markerOptions.updateInterval);
	            }
	        }
	    });

	    extend(true, GanttView, { styles: viewStyles });

	    kendo.ui.GanttDayView = GanttView.extend({
	        name: "day",

	        options: {
	            timeHeaderTemplate: TIME_HEADER_TEMPLATE,
	            dayHeaderTemplate: DAY_HEADER_TEMPLATE,
	            resizeTooltipFormat: "h:mm tt ddd, MMM d"
	        },

	        range: function(range) {
	            var optionsRange = this.options.range;
	            this.start = kendo.date.getDate(range.start);
	            this.end = kendo.date.getDate(range.end);

	            if (kendo.date.getMilliseconds(range.end) > 0 || this.end.getTime() === this.start.getTime()) {
	                this.end = kendo.date.addDays(this.end, 1);
	            }

	            if (optionsRange && optionsRange.start) {
	                this.start = kendo.date.getDate(optionsRange.start);
	                this.start.setHours(optionsRange.start.getHours());
	            }

	            if (optionsRange && optionsRange.end) {
	                this.end = kendo.date.getDate(optionsRange.end);
	                this.end.setHours(optionsRange.end.getHours());
	            }
	        },

	        _createSlots: function() {
	            var daySlots;
	            var daySlot;
	            var hourSlots;
	            var hours;
	            var slots = [];

	            daySlots = this._days(this.start, this.end);
	            hourSlots = [];

	            for (var i = 0, l = daySlots.length; i < l; i++) {
	                daySlot = daySlots[i];
	                hours = this._hours(daySlot.start, daySlot.end);

	                daySlot.span = hours.length;

	                hourSlots.push.apply(hourSlots, hours);
	            }

	            slots.push(daySlots);
	            slots.push(hourSlots);

	            return slots;
	        },

	        _layout: function() {
	            var rows = [];
	            var options = this.options;

	            rows.push(this._slotHeaders(this._slots[0], kendo.template(options.dayHeaderTemplate)));
	            rows.push(this._slotHeaders(this._slots[1], kendo.template(options.timeHeaderTemplate)));

	            return rows;
	        }
	    });

	    kendo.ui.GanttWeekView = GanttView.extend({
	        name: "week",

	        options: {
	            dayHeaderTemplate: DAY_HEADER_TEMPLATE,
	            weekHeaderTemplate: WEEK_HEADER_TEMPLATE,
	            resizeTooltipFormat: "h:mm tt ddd, MMM d"
	        },

	        range: function(range) {
	            var optionsRange = this.options.range;
	            var calendarInfo = this.calendarInfo();
	            var firstDay = calendarInfo.firstDay;
	            var rangeEnd = range.end;
	            var endDay;

	            if (firstDay === rangeEnd.getDay()) {
	                rangeEnd.setDate(rangeEnd.getDate() + 7);
	            }

	            this.start = kendo.date.getDate(kendo.date.dayOfWeek(range.start, firstDay, -1));
	            this.end = kendo.date.getDate(kendo.date.dayOfWeek(rangeEnd, firstDay, 1));

	            if (optionsRange && optionsRange.start) {
	                this.start = kendo.date.getDate(optionsRange.start);
	            }

	            if (optionsRange && optionsRange.end) {
	                endDay = new Date(optionsRange.end);

	                if (kendo.date.getDate(endDay) < optionsRange.end) {
	                    this.end = kendo.date.getDate(new Date(endDay.setDate(endDay.getDate() + 1)));
	                } else {
	                    this.end = kendo.date.getDate(endDay);
	                }
	            }
	        },

	        _createSlots: function() {
	            var slots = [];

	            slots.push(this._weeks(this.start, this.end));
	            slots.push(this._days(this.start, this.end));

	            return slots;
	        },

	        _layout: function() {
	            var rows = [];
	            var options = this.options;

	            rows.push(this._slotHeaders(this._slots[0], kendo.template(options.weekHeaderTemplate)));
	            rows.push(this._slotHeaders(this._slots[1], kendo.template(options.dayHeaderTemplate)));

	            return rows;
	        }
	    });

	    kendo.ui.GanttMonthView = GanttView.extend({
	        name: "month",

	        options: {
	            weekHeaderTemplate: WEEK_HEADER_TEMPLATE,
	            monthHeaderTemplate: MONTH_HEADER_TEMPLATE,
	            resizeTooltipFormat: "dddd, MMM d, yyyy"
	        },

	        range: function(range) {
	            var optionsRange = this.options.range;
	            var endDay;
	            this.start = kendo.date.firstDayOfMonth(range.start);
	            this.end = kendo.date.addDays(kendo.date.getDate(kendo.date.lastDayOfMonth(range.end)), 1);

	            if (optionsRange && optionsRange.start) {
	                this.start = kendo.date.getDate(optionsRange.start);
	            }

	            if (optionsRange && optionsRange.end) {
	                endDay = new Date(optionsRange.end);

	                if (kendo.date.getDate(endDay) < optionsRange.end) {
	                    this.end = kendo.date.getDate(new Date(endDay.setDate(endDay.getDate() + 1)));
	                } else {
	                    this.end = kendo.date.getDate(endDay);
	                }
	            }
	        },

	        _createSlots: function() {
	            var slots = [];

	            slots.push(this._months(this.start, this.end));
	            slots.push(this._weeks(this.start, this.end));

	            return slots;
	        },

	        _layout: function() {
	            var rows = [];
	            var options = this.options;

	            rows.push(this._slotHeaders(this._slots[0], kendo.template(options.monthHeaderTemplate)));
	            rows.push(this._slotHeaders(this._slots[1], kendo.template(options.weekHeaderTemplate)));

	            return rows;
	        }
	    });

	    kendo.ui.GanttYearView = GanttView.extend({
	        name: "year",

	        options: {
	            yearHeaderTemplate: YEAR_HEADER_TEMPLATE,
	            monthHeaderTemplate: MONTH_HEADER_TEMPLATE,
	            resizeTooltipFormat: "dddd, MMM d, yyyy"
	        },

	        range: function(range) {
	            var optionsRange = this.options.range;
	            var firstDayOfMonth;
	            this.start = kendo.date.firstDayOfMonth(new Date(range.start.setMonth(0)));
	            this.end = kendo.date.firstDayOfMonth(new Date(range.end.setMonth(12))); //set month to first month of next year

	            if (optionsRange && optionsRange.start) {
	                this.start = kendo.date.firstDayOfMonth(optionsRange.start);
	            }

	            if (optionsRange && optionsRange.end) {
	                firstDayOfMonth = kendo.date.firstDayOfMonth(optionsRange.end);

	                this.end = kendo.date.getDate(new Date(firstDayOfMonth.setMonth(firstDayOfMonth.getMonth() + 1)));
	            }
	        },

	        _createSlots: function() {
	            var slots = [];
	            var monthSlots = this._months(this.start, this.end);

	            $(monthSlots).each(function(index, slot) {
	                slot.span = 1;
	            });

	            slots.push(this._years(this.start, this.end));
	            slots.push(monthSlots);

	            return slots;
	        },

	        _layout: function() {
	            var rows = [];
	            var options = this.options;

	            rows.push(this._slotHeaders(this._slots[0], kendo.template(options.yearHeaderTemplate)));
	            rows.push(this._slotHeaders(this._slots[1], kendo.template(options.monthHeaderTemplate)));

	            return rows;
	        }
	    });

	    var timelineStyles = {
	        wrapper: "k-timeline k-grid k-widget",
	        gridHeader: "k-grid-header",
	        gridHeaderWrap: "k-grid-header-wrap",
	        gridContent: "k-grid-content",
	        gridContentWrap: "k-grid-content",
	        tasksWrapper: "k-gantt-tables",
	        dependenciesWrapper: "k-gantt-dependencies",
	        task: "k-task",
	        taskOffset: "k-task-offset",
	        taskOffsetWrap: "k-task-offset-wrap",
	        taskPlanned: "k-task-planned",
	        line: "k-gantt-line",
	        taskResizeHandle: "k-resize-handle",
	        taskResizeHandleWest: "k-resize-w",
	        taskDragHandle: "k-task-draghandle",
	        taskComplete: "k-task-complete",
	        taskDelete: "k-task-delete",
	        taskWrapActive: "k-task-wrap-active",
	        taskWrap: "k-task-wrap",
	        taskDot: "k-task-dot",
	        taskDotStart: "k-task-start",
	        taskDotEnd: "k-task-end",
	        hovered: "k-state-hover",
	        selected: "k-state-selected",
	        origin: "k-origin"
	    };

	    var GanttTimeline = kendo.ui.GanttTimeline = Widget.extend({
	        init: function(element, options) {

	            Widget.fn.init.call(this, element, options);

	            if (!this.options.views || !this.options.views.length) {
	                this.options.views = ["day", "week", "month"];
	            }

	            isRtl = kendo.support.isRtl(element);

	            this._wrapper();

	            this._domTrees();

	            this._views();

	            this._selectable();

	            this._draggable();

	            this._resizable();

	            this._percentResizeDraggable();

	            this._createDependencyDraggable();

	            this._attachEvents();

	            this._tooltip();
	        },

	        options: {
	            name: "GanttTimeline",
	            messages: {
	                views: {
	                    day: "Day",
	                    week: "Week",
	                    month: "Month",
	                    year: "Year",
	                    start: "Start",
	                    end: "End"
	                }
	            },
	            snap: true,
	            selectable: true,
	            editable: true
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            clearTimeout(this._tooltipTimeout);

	            if (this._currentTimeUpdateTimer) {
	                clearInterval(this._currentTimeUpdateTimer);
	            }

	            this._unbindView(this._selectedView);

	            if (this._moveDraggable) {
	                this._moveDraggable.destroy();
	            }

	            if (this._resizeDraggable) {
	                this._resizeDraggable.destroy();
	            }

	            if (this._percentDraggable) {
	                this._percentDraggable.destroy();
	            }

	            if (this._dependencyDraggable) {
	                this._dependencyDraggable.destroy();
	            }

	            if (this.touch) {
	                this.touch.destroy();
	            }

	            this._headerTree = null;
	            this._taskTree = null;
	            this._dependencyTree = null;

	            this.wrapper.off(NS);

	            kendo.destroy(this.wrapper);
	        },

	        _wrapper: function() {
	            var styles = GanttTimeline.styles;
	            var that = this;
	            var options = this.options;
	            var calculateSize = function () {
	                var rowHeight = typeof options.rowHeight === STRING ? options.rowHeight :
	                    options.rowHeight + "px";
	                var table = $(kendo.format(SIZE_CALCULATION_TEMPLATE, rowHeight));
	                var calculatedRowHeight;
	                var calculatedCellHeight;
	                var content = that.wrapper.find(DOT + styles.tasksWrapper);

	                content.append(table);

	                calculatedRowHeight = outerHeight(table.find("tr"));
	                calculatedCellHeight = table.find("td").height();

	                table.remove();

	                return {
	                    "row": calculatedRowHeight,
	                    "cell": calculatedCellHeight
	                };
	            };

	            this.wrapper = this.element
	                .addClass(styles.wrapper)
	                .append("<div class='" + styles.gridHeader + "'><div class='" + styles.gridHeaderWrap + "'></div></div>")
	                .append("<div class='" + styles.gridContentWrap + "'><div class='" + styles.tasksWrapper + "'></div><div class='" + styles.dependenciesWrapper + "'></div></div>");

	            if (options.rowHeight) {
	                this._calculatedSize = calculateSize();
	            }
	        },

	        _domTrees: function() {
	            var styles = GanttTimeline.styles;
	            var tree = kendo.dom.Tree;
	            var wrapper = this.wrapper;

	            this._headerTree = new tree(wrapper.find(DOT + styles.gridHeaderWrap)[0]);

	            this._taskTree = new tree(wrapper.find(DOT + styles.tasksWrapper)[0]);

	            this._dependencyTree = new tree(wrapper.find(DOT + styles.dependenciesWrapper)[0]);
	        },

	        _views: function() {
	            var views = this.options.views;
	            var view;
	            var isSettings;
	            var name;
	            var defaultView;
	            var selected;

	            this.views = {};

	            for (var i = 0, l = views.length; i < l; i++) {
	                view = views[i];

	                isSettings = isPlainObject(view);

	                if (isSettings && view.selectable === false) {
	                    continue;
	                }

	                name = isSettings ? ((typeof view.type !== "string") ? view.title : view.type) : view;

	                defaultView = defaultViews[name];

	                if (defaultView) {
	                    if (isSettings) {
	                        view.type = defaultView.type;
	                    }

	                    defaultView.title = this.options.messages.views[name];
	                }

	                view = extend({ title: name }, defaultView, isSettings ? view : {});

	                if (name) {
	                    this.views[name] = view;

	                    if (!selected || view.selected) {
	                        selected = name;
	                    }
	                }
	            }

	            if (selected) {
	                this._selectedViewName = selected;
	            }
	        },

	        view: function(name) {
	            if (name) {
	                this._selectView(name);

	                this.trigger("navigate", { view: name, action: "changeView" });
	            }

	            return this._selectedView;
	        },

	        _selectView: function(name) {
	            if (name && this.views[name]) {
	                if (this._selectedView) {
	                    this._unbindView(this._selectedView);
	                }

	                this._selectedView = this._initializeView(name);
	                this._selectedViewName = name;
	            }
	        },

	        _viewByIndex: function(index) {
	            var view;
	            var views = this.views;

	            for (view in views) {
	                if (!index) {
	                    return view;
	                }

	                index--;
	            }
	        },

	        _initializeView: function(name) {
	            var view = this.views[name];

	            if (view) {
	                var type = view.type;

	                if (typeof type === "string") {
	                    type = kendo.getter(view.type)(window);
	                }

	                if (type) {
	                    var newRange = {};
	                    extend(newRange, this.options.range, view.range);

	                    var newDate = view.date || this.options.date;

	                    view = new type(this.wrapper, trimOptions(extend(true, {
	                        headerTree: this._headerTree,
	                        taskTree: this._taskTree,
	                        dependencyTree: this._dependencyTree,
	                        calculatedSize: this._calculatedSize
	                    }, view, this.options, {
	                        date: newDate,
	                        range: newRange
	                    })));
	                } else {
	                    throw new Error("There is no such view");
	                }
	            }

	            return view;
	        },

	        _unbindView: function(view) {
	            if (view) {
	                view.destroy();
	            }
	        },

	        _range: function (tasks) {
	            var startOrder = {
	                field: "start",
	                dir: "asc"
	            };
	            var endOrder = {
	                field: "end",
	                dir: "desc"
	            };

	            if (!tasks || !tasks.length) {
	                return { start: new Date(), end: new Date() };
	            }

	            var start = new Query(tasks).sort(startOrder).toArray()[0].start || new Date();
	            var end = new Query(tasks).sort(endOrder).toArray()[0].end || new Date();

	            return {
	                start: new Date(start),
	                end: new Date(end)
	            };
	        },

	        _render: function(tasks) {
	            var view = this.view();
	            var range = this._range(tasks);
	            var date = view.options.date;

	            this._tasks = tasks;

	            view.range(range);

	            view.renderLayout();

	            view.render(tasks);

	            if (date) {
	                view._scrollToDate(date);
	            }
	        },

	        _renderDependencies: function(dependencies) {
	            this.view()._renderDependencies(dependencies);
	        },

	        _taskByUid: function(uid) {
	            var tasks = this._tasks;
	            var length = tasks.length;
	            var task;

	            for (var i = 0; i < length; i++) {
	                task = tasks[i];

	                if (task.uid === uid) {
	                    return task;
	                }
	            }
	        },

	        _draggable: function() {
	            var that = this;
	            var element;
	            var task;
	            var currentStart;
	            var startOffset;
	            var snap = this.options.snap;
	            var styles = GanttTimeline.styles;
	            var editable = this.options.editable;

	            var cleanUp = function() {
	                that.view()._removeDragHint();

	                if (element) {
	                    element.css("opacity", 1);
	                }

	                element = null;
	                task = null;
	                that.dragInProgress = false;
	            };

	            if (!editable || editable.move === false || editable.update === false) {
	                return;
	            }

	            this._moveDraggable = new kendo.ui.Draggable(this.wrapper, {
	                distance: 0,
	                filter: DOT + styles.task + "," + DOT + styles.taskOffset,
	                holdToDrag: kendo.support.mobileOS,
	                ignore: DOT + styles.taskResizeHandle
	            });

	            this._moveDraggable
	                .bind("dragstart", function(e) {
	                    var view = that.view();
	                    element = e.currentTarget.closest(DOT + styles.taskWrap);
	                    task = that._taskByUid(e.currentTarget.parent().find(DOT + styles.task).attr("data-uid"));

	                    if (that.trigger("moveStart", { task: task })) {
	                        e.preventDefault();
	                        return;
	                    }

	                    currentStart = task.start;
	                    startOffset = view._timeByPosition(e.x.location, snap) - currentStart;

	                    view._createDragHint(element);

	                    element.css("opacity", 0.5);

	                    clearTimeout(that._tooltipTimeout);
	                    that.dragInProgress = true;
	                })
	                .bind("drag", kendo.throttle(function(e) {
	                    if (!that.dragInProgress) {
	                        return;
	                    }

	                    var view = that.view();
	                    var date = new Date(view._timeByPosition(e.x.location, snap) - startOffset);
	                    var updateHintDate = date;

	                    if (!that.trigger("move", { task: task, start: date })) {
	                        currentStart = date;

	                        if (isRtl) {
	                            updateHintDate = new Date(currentStart.getTime() + task.duration());
	                        }

	                        view._updateDragHint(updateHintDate);
	                    }
	                }, 15))
	                .bind("dragend", function() {
	                    that.trigger("moveEnd", { task: task, start: currentStart });

	                    cleanUp();
	                })
	                .bind("dragcancel", function() {
	                    cleanUp();
	                })
	                .userEvents.bind("select", function() {
	                    blurActiveElement();
	                });
	        },

	        _resizable: function() {
	            var that = this;
	            var element;
	            var task;
	            var currentStart;
	            var currentEnd;
	            var resizeStart;
	            var snap = this.options.snap;
	            var styles = GanttTimeline.styles;
	            var editable = this.options.editable;

	            var cleanUp = function() {
	                that.view()._removeResizeHint();
	                element = null;
	                task = null;
	                that.dragInProgress = false;
	            };

	            if (!editable || editable.resize === false || editable.update === false) {
	                return;
	            }

	            this._resizeDraggable = new kendo.ui.Draggable(this.wrapper, {
	                distance: 0,
	                filter: DOT + styles.taskResizeHandle,
	                holdToDrag: false
	            });

	            this._resizeDraggable
	                .bind("dragstart", function(e) {
	                    resizeStart = e.currentTarget.hasClass(styles.taskResizeHandleWest);

	                    if (isRtl) {
	                        resizeStart = !resizeStart;
	                    }

	                    element = e.currentTarget.closest(DOT + styles.taskWrap).find(DOT + styles.task);

	                    task = that._taskByUid(element.attr("data-uid"));

	                    if (that.trigger("resizeStart", { task: task })) {
	                        e.preventDefault();
	                        return;
	                    }

	                    currentStart = task.start;
	                    currentEnd = task.end;

	                    that.view()._createResizeHint(task);

	                    clearTimeout(that._tooltipTimeout);
	                    that.dragInProgress = true;
	                })
	                .bind("drag", kendo.throttle(function(e) {
	                    if (!that.dragInProgress) {
	                        return;
	                    }

	                    var view = that.view();
	                    var date = view._timeByPosition(e.x.location, snap, !resizeStart);

	                    if (resizeStart) {
	                        if (date < currentEnd) {
	                            currentStart = date;
	                        } else {
	                            currentStart = currentEnd;
	                        }
	                    } else {
	                        if (date > currentStart) {
	                            currentEnd = date;
	                        } else {
	                            currentEnd = currentStart;
	                        }
	                    }

	                    if (!that.trigger("resize", { task: task, start: currentStart, end: currentEnd })) {
	                        view._updateResizeHint(currentStart, currentEnd, resizeStart);
	                    }
	                }, 15))
	                .bind("dragend", function() {
	                    that.trigger("resizeEnd", { task: task, resizeStart: resizeStart, start: currentStart, end: currentEnd });

	                    cleanUp();
	                })
	                .bind("dragcancel", function() {
	                    cleanUp();
	                })
	                .userEvents.bind("select", function() {
	                    blurActiveElement();
	                });
	        },

	        _percentResizeDraggable: function() {
	            var that = this;
	            var task;
	            var taskElement;
	            var taskElementOffset;
	            var timelineOffset;
	            var originalPercentWidth;
	            var maxPercentWidth;
	            var currentPercentComplete;
	            var tooltipTop;
	            var tooltipLeft;
	            var styles = GanttTimeline.styles;
	            var delta;
	            var editable = this.options.editable;

	            var cleanUp = function() {
	                that.view()._removePercentCompleteTooltip();
	                taskElement = null;
	                task = null;
	                that.dragInProgress = false;
	            };

	            var updateElement = function(width) {
	                var taskDragHandle =  taskElement.siblings(DOT + styles.taskDragHandle);

	                if(!taskDragHandle.length) {
	                    taskDragHandle =  taskElement.closest(DOT + styles.taskWrap).find(DOT + styles.taskDragHandle);
	                }

	                taskDragHandle.css(isRtl ? "right" : "left", width);

	                taskElement
	                    .find(DOT + styles.taskComplete)
	                    .width(width);
	            };

	            if (!editable || editable.dragPercentComplete === false || editable.update === false) {
	                return;
	            }

	            this._percentDraggable = new kendo.ui.Draggable(this.wrapper, {
	                distance: 0,
	                filter: DOT + styles.taskDragHandle,
	                holdToDrag: false
	            });

	            this._percentDraggable
	                .bind("dragstart", function(e) {
	                    if (that.trigger("percentResizeStart")) {
	                        e.preventDefault();
	                        return;
	                    }

	                    taskElement = e.currentTarget.siblings(DOT + styles.task);

	                    if(!taskElement.length) {
	                        taskElement = e.currentTarget.closest(DOT + styles.taskWrap).find(DOT + styles.task);
	                    }

	                    task = that._taskByUid(taskElement.attr("data-uid"));

	                    currentPercentComplete = task.percentComplete;

	                    taskElementOffset = taskElement.offset();
	                    timelineOffset = this.element.offset();

	                    originalPercentWidth = taskElement.find(DOT + styles.taskComplete).width();
	                    maxPercentWidth = outerWidth(taskElement);

	                    clearTimeout(that._tooltipTimeout);
	                    that.dragInProgress = true;
	                })
	                .bind("drag", kendo.throttle(function(e) {
	                    if (!that.dragInProgress) {
	                        return;
	                    }

	                    delta = isRtl ? -e.x.initialDelta : e.x.initialDelta;

	                    var currentWidth = Math.max(0, Math.min(maxPercentWidth, originalPercentWidth + delta));

	                    currentPercentComplete = Math.round((currentWidth / maxPercentWidth) * 100);

	                    updateElement(currentWidth);

	                    tooltipTop = taskElementOffset.top - timelineOffset.top;
	                    tooltipLeft = taskElementOffset.left + currentWidth - timelineOffset.left;

	                    if (isRtl) {
	                        tooltipLeft += (maxPercentWidth - 2 * currentWidth);
	                    }

	                    that.view()._updatePercentCompleteTooltip(tooltipTop, tooltipLeft, currentPercentComplete);
	                }, 15))
	                .bind("dragend", function() {
	                    that.trigger("percentResizeEnd", { task: task, percentComplete: currentPercentComplete / 100 });

	                    cleanUp();
	                })
	                .bind("dragcancel", function() {
	                    updateElement(originalPercentWidth);

	                    cleanUp();
	                })
	                .userEvents.bind("select", function() {
	                    blurActiveElement();
	                });
	        },

	        _createDependencyDraggable: function() {
	            var that = this;
	            var originalHandle;
	            var hoveredHandle = $();
	            var hoveredTask = $();
	            var startX;
	            var startY;
	            var useVML = browser.msie && browser.version < 9;
	            var styles = GanttTimeline.styles;
	            var editable = this.options.editable;

	            var cleanUp = function() {
	                originalHandle
	                    .css("display", "")
	                    .removeClass(styles.hovered);

	                originalHandle.parent().removeClass(styles.origin);
	                originalHandle = null;

	                toggleHandles(false);

	                hoveredTask = $();
	                hoveredHandle = $();

	                that.view()._removeDependencyDragHint();

	                that.dragInProgress = false;
	            };

	            var toggleHandles = function(value) {
	                if (!hoveredTask.hasClass(styles.origin)) {
	                    hoveredTask.find(DOT + styles.taskDot).css("display", value ? "block" : "");
	                    hoveredHandle.toggleClass(styles.hovered, value);
	                }
	            };

	            if (!editable || editable.dependencyCreate === false) {
	                return;
	            }

	            if (useVML && document.namespaces) {
	                document.namespaces.add("kvml", "urn:schemas-microsoft-com:vml", "#default#VML");
	            }

	            this._dependencyDraggable = new kendo.ui.Draggable(this.wrapper, {
	                distance: 0,
	                filter: DOT + styles.taskDot,
	                holdToDrag: false
	            });

	            this._dependencyDraggable
	                .bind("dragstart", function(e) {
	                    if (that.trigger("dependencyDragStart")) {
	                        e.preventDefault();
	                        return;
	                    }

	                    originalHandle = e.currentTarget
	                        .css("display", "block")
	                        .addClass(styles.hovered);

	                    originalHandle.parent().addClass(styles.origin);

	                    var elementOffset = originalHandle.offset();
	                    var tablesOffset = that.wrapper.find(DOT + styles.tasksWrapper).offset();

	                    startX = Math.round(elementOffset.left - tablesOffset.left + (outerHeight(originalHandle) / 2));
	                    startY = Math.round(elementOffset.top - tablesOffset.top + (outerWidth(originalHandle) / 2));

	                    clearTimeout(that._tooltipTimeout);
	                    that.dragInProgress = true;
	                })
	                .bind("drag", kendo.throttle(function(e) {
	                    if (!that.dragInProgress) {
	                        return;
	                    }

	                    that.view()._removeDependencyDragHint();

	                    var target = $(kendo.elementUnderCursor(e));
	                    var tablesOffset = that.wrapper.find(DOT + styles.tasksWrapper).offset();
	                    var currentX = e.x.location - tablesOffset.left;
	                    var currentY = e.y.location - tablesOffset.top;

	                    that.view()._updateDependencyDragHint({ x: startX, y: startY }, { x: currentX, y: currentY }, useVML);

	                    toggleHandles(false);

	                    hoveredHandle = (target.hasClass(styles.taskDot)) ? target : $();
	                    hoveredTask = target.closest(DOT + styles.taskWrap);

	                    toggleHandles(true);
	                }, 15))
	                .bind("dragend", function() {
	                    if (hoveredHandle.length) {
	                        var fromStart = originalHandle.hasClass(styles.taskDotStart);
	                        var toStart = hoveredHandle.hasClass(styles.taskDotStart);

	                        var type = fromStart ? (toStart ? 3 : 2) : (toStart ? 1 : 0);

	                        var predecessorElement = originalHandle.siblings(DOT + styles.task);
	                        if(!predecessorElement.length) {
	                            predecessorElement = originalHandle.closest(DOT + styles.taskWrap).find(DOT + styles.task);
	                        }
	                        var predecessor = that._taskByUid(predecessorElement.attr("data-uid"));

	                        var successorElement = hoveredHandle.siblings(DOT + styles.task);
	                        if(!successorElement.length) {
	                            successorElement = hoveredHandle.closest(DOT + styles.taskWrap).find(DOT + styles.task);
	                        }
	                        var successor = that._taskByUid(successorElement.attr("data-uid"));

	                        if (predecessor !== successor) {
	                            that.trigger("dependencyDragEnd", { type: type, predecessor: predecessor, successor: successor });
	                        }
	                    }

	                    cleanUp();
	                })
	                .bind("dragcancel", function() {
	                    cleanUp();
	                })
	                .userEvents.bind("select", function() {
	                    blurActiveElement();
	                });
	        },

	        _selectable: function() {
	            var that = this;
	            var styles = GanttTimeline.styles;

	            if (this.options.selectable) {
	                this.wrapper
	                    .on(CLICK + NS, DOT + styles.task + "," + DOT + styles.taskOffset, function(e) {
	                        e.stopPropagation();

	                        var uid = $(this).attr("data-uid");

	                        if(!uid) {
	                            uid = $(this).closest(DOT + styles.taskWrap).find(DOT + styles.task).data("uid");
	                        }

	                        if (!e.ctrlKey) {
	                            that.trigger("select", { uid: uid });
	                        } else {
	                            that.trigger("clear");
	                        }
	                    })
	                    .on(CLICK + NS, DOT + styles.taskWrap, function(e) {
	                        e.stopPropagation();

	                        // Decrease z-index of wrap so the we can get to the
	                        // dependency line underneath, if there is any
	                        $(this).css("z-index", "0");

	                        var target = $(document.elementFromPoint(e.clientX, e.clientY));

	                        if (target.hasClass(styles.line)) {
	                            target.click();
	                        }

	                        $(this).css("z-index", "");
	                    })
	                    .on(CLICK + NS, DOT + styles.tasksWrapper, function() {
	                        if (that.selectDependency().length > 0) {
	                            that.clearSelection();
	                        } else {
	                            that.trigger("clear");
	                        }
	                    })
	                    .on(CLICK + NS, DOT + styles.line, function(e) {
	                        e.stopPropagation();

	                        that.selectDependency(this);
	                    });
	            }
	        },

	        select: function(value) {
	            var element = this.wrapper.find(value);
	            var styles = GanttTimeline.styles;

	            if (element.length) {
	                this.clearSelection();

	                element.addClass(styles.selected);

	                if (kendo.support.mobileOS) {
	                    element.parent().addClass(styles.taskWrapActive);
	                }

	                return;
	            }

	            return this.wrapper.find(DOT + styles.task + DOT + styles.selected);
	        },

	        selectDependency: function(value) {
	            var element = this.wrapper.find(value);
	            var uid;
	            var styles = GanttTimeline.styles;

	            if (element.length) {
	                this.clearSelection();
	                this.trigger("clear");

	                uid = $(element).attr("data-uid");

	                this.wrapper.find(DOT + styles.line + "[data-uid='" + uid + "']").addClass(styles.selected);

	                return;
	            }

	            return this.wrapper.find(DOT + styles.line + DOT + styles.selected);
	        },

	        clearSelection: function() {
	            var styles = GanttTimeline.styles;

	            this.wrapper
	                .find(DOT + styles.selected)
	                .removeClass(styles.selected);

	            if (kendo.support.mobileOS) {
	                this.wrapper
	                    .find(DOT + styles.taskWrapActive)
	                    .removeClass(styles.taskWrapActive);
	            }
	        },

	        _attachEvents: function() {
	            var that = this;
	            var styles = GanttTimeline.styles;
	            var editable = this.options.editable;

	            if (editable) {
	                this._tabindex();

	                this.wrapper
	                    .on(CLICK + NS, DOT + styles.taskDelete, function(e) {
	                        that.trigger("removeTask", { uid: $(this).closest(DOT + styles.taskWrap).find(DOT + styles.task).attr("data-uid") });
	                        e.stopPropagation();
	                        e.preventDefault();
	                    })
	                    .on(KEYDOWN + NS, function(e) {
	                        var selectedDependency;
	                        var editable = that.options.editable;

	                        if (e.keyCode === keys.DELETE && editable && editable.dependencyDestroy !== false) {
	                            selectedDependency = that.selectDependency();

	                            if (selectedDependency.length) {
	                                that.trigger("removeDependency", { uid: selectedDependency.attr("data-uid") });
	                                that.clearSelection();
	                            }
	                        }
	                    });

	                if (!kendo.support.mobileOS) {
	                    this.wrapper
	                        .on(DBLCLICK + NS, DOT + styles.task + "," + DOT + styles.taskOffset, function(e) {
	                            if (that.options.editable.update !== false) {
	                                that.trigger("editTask", { uid: $(this).closest(DOT + styles.taskWrap).find(DOT + styles.task).attr("data-uid") });

	                                e.stopPropagation();
	                                e.preventDefault();
	                            }
	                        });
	                } else {
	                    this.touch = this.wrapper
	                        .kendoTouch({
	                            filter: DOT + styles.task + "," + DOT + styles.taskOffset,
	                            doubletap: function(e) {
	                                if (that.options.editable.update !== false) {
	                                    that.trigger("editTask", { uid: $(e.touch.currentTarget).closest(DOT + styles.taskWrap).find(DOT + styles.task).attr("data-uid") });
	                                }
	                            }
	                        }).data("kendoTouch");
	                }
	            }
	        },

	        _tooltip: function() {
	            var that = this;
	            var tooltipOptions = this.options.tooltip;
	            var styles = GanttTimeline.styles;
	            var currentMousePosition;
	            var mouseMoveHandler = function(e) {
	                currentMousePosition = e.clientX;
	            };

	            if (tooltipOptions && tooltipOptions.visible === false) {
	                return;
	            }

	            if (!kendo.support.mobileOS) {
	                this.wrapper
	                        .on(MOUSEENTER + NS, DOT + styles.task, function() {
	                            var element = this;
	                            var task = that._taskByUid($(this).attr("data-uid"));

	                            if (that.dragInProgress) {
	                                return;
	                            }

	                            that._tooltipTimeout = setTimeout(function() {
	                                that.view()._createTaskTooltip(task, element, currentMousePosition);
	                            }, 800);

	                            $(this).on(MOUSEMOVE, mouseMoveHandler);
	                        })
	                        .on(MOUSELEAVE + NS, DOT + styles.task, function() {
	                            clearTimeout(that._tooltipTimeout);

	                            that.view()._removeTaskTooltip();

	                            $(this).off(MOUSEMOVE, mouseMoveHandler);
	                        })
	                        .on(MOUSEENTER + NS, DOT + styles.taskOffset, function() {
	                            var taskElement = $(this).closest(DOT + styles.taskWrap).find(DOT + styles.task);
	                            var task = that._taskByUid(taskElement.attr("data-uid"));

	                            if (that.dragInProgress) {
	                                return;
	                            }

	                            that._offsetTooltipTimeout = setTimeout(function() {
	                                that.view()._createOffsetTooltip(task, taskElement, currentMousePosition);
	                            }, 800);

	                            $(this).on(MOUSEMOVE, mouseMoveHandler);
	                        })
	                        .on(MOUSELEAVE + NS, DOT + styles.taskOffset, function() {
	                            clearTimeout(that._offsetTooltipTimeout);

	                            that.view()._removeOffsetTooltip();

	                            $(this).off(MOUSEMOVE, mouseMoveHandler);
	                        })
	                        .on(MOUSEENTER + NS, DOT + styles.taskPlanned, function() {
	                            var taskElement = $(this).closest(DOT + styles.taskWrap).find(DOT + styles.task);
	                            var task = that._taskByUid(taskElement.attr("data-uid"));

	                            that._plannedTooltipTimeout = setTimeout(function() {
	                                that.view()._createPlannedTooltip(task, taskElement, currentMousePosition);
	                            }, 800);

	                            $(this).on(MOUSEMOVE, mouseMoveHandler);
	                        })
	                        .on(MOUSELEAVE + NS, DOT + styles.taskPlanned, function() {
	                            clearTimeout(that._plannedTooltipTimeout);

	                            that.view()._removePlannedTooltip();

	                            $(this).off(MOUSEMOVE, mouseMoveHandler);
	                        });
	            } else {
	                this.wrapper
	                    .on(CLICK + NS, DOT + styles.taskDelete, function(e) {
	                        e.stopPropagation();
	                        that.view()._removeTaskTooltip();
	                    })
	                    .on(MOUSELEAVE + NS, DOT + styles.task, function(e) {
	                        var parents = $(e.relatedTarget).parents(DOT + styles.taskWrap, DOT + styles.task);

	                        if (parents.length === 0) {
	                            that.view()._removeTaskTooltip();
	                        }
	                    })
	                    .on(MOUSELEAVE + NS, DOT + styles.taskOffset, function(e) {
	                        var parents = $(e.relatedTarget).parents(DOT + styles.taskWrap, DOT + styles.task);

	                        if (parents.length === 0) {
	                            that.view()._removeOffsetTooltip();
	                        }
	                    })
	                    .on(MOUSELEAVE + NS, DOT + styles.taskPlanned, function(e) {
	                        var parents = $(e.relatedTarget).parents(DOT + styles.taskWrap, DOT + styles.task);

	                        if (parents.length === 0) {
	                            that.view()._removePlannedTooltip();
	                        }
	                    });

	                if (this.touch) {
	                    this.touch
	                        .bind("tap", function(e) {
	                            var element = $(e.touch.target);
	                            var currentPosition = e.touch.x.client;
	                            var task;

	                            if(!element.hasClass(styles.task)) {
	                                task = that._taskByUid(element.closest(DOT + styles.taskWrap).find(DOT + styles.task).attr("data-uid"));
	                                if (that.view()._offsetTooltip) {
	                                    that.view()._removeOffsetTooltip();
	                                }

	                                that.view()._createOffsetTooltip(task, element, currentPosition);
	                            } else {
	                                task = that._taskByUid(element.attr("data-uid"));
	                                if (that.view()._taskTooltip) {
	                                    that.view()._removeTaskTooltip();
	                                }

	                                that.view()._createTaskTooltip(task, element, currentPosition);
	                            }
	                        })
	                        .bind("doubletap", function() {
	                            that.view()._removeTaskTooltip();
	                            that.view()._removeOffsetTooltip();
	                        });
	                }
	            }
	        },
	        _setPlanned: function(value) {
	            this.options.showPlannedTasks = value;
	            this.view().options.showPlannedTasks = value;
	        }
	    });

	    extend(true, GanttTimeline, { styles: timelineStyles });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1266:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("/A/6");

/***/ })

/******/ });

/***/ }),

/***/ "vIB/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("O4g8");
var $export = __webpack_require__("kM2E");
var redefine = __webpack_require__("880/");
var hide = __webpack_require__("hJx8");
var has = __webpack_require__("D2L2");
var Iterators = __webpack_require__("/bQp");
var $iterCreate = __webpack_require__("94VQ");
var setToStringTag = __webpack_require__("e6n0");
var getPrototypeOf = __webpack_require__("PzxK");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "vKDZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1327);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1301:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Yz+S");

/***/ }),

/***/ 1327:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1301) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.splitview",
	    name: "SplitView",
	    category: "mobile",
	    description: "The mobile SplitView is a tablet-specific view that consists of two or more mobile Pane widgets.",
	    depends: [ "mobile.pane" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.mobile.ui,
	        Widget = ui.Widget,
	        EXPANED_PANE_SHIM = "<div class='km-expanded-pane-shim'></div>",
	        View = ui.View;

	    var SplitView = View.extend({
	        init: function(element, options) {
	            var that = this,
	            pane, modalViews;

	            Widget.fn.init.call(that, element, options);
	            element = that.element;

	            $.extend(that, options);

	            that._id();

	            if (!that.options.$angular) {
	                that._layout();
	                that._overlay();
	            } else {
	                that._overlay();
	            }

	            that._style();

	            modalViews = element.children(that._locate("modalview"));

	            if (!that.options.$angular) {
	                kendo.mobile.init(modalViews);
	            } else {
	                modalViews.each(function(idx, element) {
	                    kendo.compileMobileDirective($(element), options.$angular[0]);
	                });
	            }

	            that.panes = [];
	            that._paramsHistory = [];

	            if (!that.options.$angular) {
	                that.content.children(kendo.roleSelector("pane")).each(function() {
	                    pane = kendo.initWidget(this, {}, ui.roles);
	                    that.panes.push(pane);
	                });
	            } else {
	                that.element.children(kendo.directiveSelector("pane")).each(function() {
	                    pane = kendo.compileMobileDirective($(this), options.$angular[0]);
	                    that.panes.push(pane);
	                });

	                that.element.children(kendo.directiveSelector("header footer")).each(function() {
	                    kendo.compileMobileDirective($(this), options.$angular[0]);
	                });
	            }

	            that.expandedPaneShim = $(EXPANED_PANE_SHIM).appendTo(that.element);

	            that._shimUserEvents = new kendo.UserEvents(that.expandedPaneShim, {
	                fastTap: true,
	                tap: function() {
	                    that.collapsePanes();
	                }
	            });
	        },

	        _locate: function(selectors) {
	            return this.options.$angular ? kendo.directiveSelector(selectors) : kendo.roleSelector(selectors);
	        },

	        options: {
	            name: "SplitView",
	            style: "horizontal"
	        },

	        expandPanes: function() {
	            this.element.addClass("km-expanded-splitview");
	        },

	        collapsePanes: function() {
	            this.element.removeClass("km-expanded-splitview");
	        },

	        // Implement view interface
	        _layout: function() {
	            var that = this,
	                element = that.element;

	            that.transition = kendo.attrValue(element, "transition");
	            kendo.mobile.ui.View.prototype._layout.call(this);
	            kendo.mobile.init(this.header.add(this.footer));
	            that.element.addClass("km-splitview");
	            that.content.addClass("km-split-content");
	        },

	        _style: function () {
	            var style = this.options.style,
	                element = this.element,
	                styles;

	            if (style) {
	                styles = style.split(" ");
	                $.each(styles, function () {
	                    element.addClass("km-split-" + this);
	                });
	            }
	        },

	        showStart: function() {
	            var that = this;
	            that.element.css("display", "");

	            if (!that.inited) {
	                that.inited = true;
	                $.each(that.panes, function() {
	                    if (this.options.initial) {
	                        this.navigateToInitial();
	                    } else {
	                        this.navigate("");
	                    }
	                });
	                that.trigger("init", {view: that});
	            } else {
	                this._invokeNgController();
	            }

	            that.trigger("show", {view: that});
	        }
	    });

	    ui.plugin(SplitView);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "vLqC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var gridPanel_1 = __webpack_require__("inOk");
var utils_1 = __webpack_require__("IRr6");
var ColumnAnimationService = (function () {
    function ColumnAnimationService() {
        this.executeNextFuncs = [];
        this.executeLaterFuncs = [];
        this.active = false;
        this.animationThreadCount = 0;
    }
    ColumnAnimationService.prototype.isActive = function () {
        return this.active;
    };
    ColumnAnimationService.prototype.start = function () {
        if (this.active) {
            return;
        }
        if (this.gridOptionsWrapper.isSuppressColumnMoveAnimation()) {
            return;
        }
        // if doing RTL, we don't animate open / close as due to how the pixels are inverted,
        // the animation moves all the row the the right rather than to the left (ie it's the static
        // columns that actually get their coordinates updated)
        if (this.gridOptionsWrapper.isEnableRtl()) {
            return;
        }
        this.ensureAnimationCssClassPresent();
        this.active = true;
    };
    ColumnAnimationService.prototype.finish = function () {
        if (!this.active) {
            return;
        }
        this.flush();
        this.active = false;
    };
    ColumnAnimationService.prototype.executeNextVMTurn = function (func) {
        if (this.active) {
            this.executeNextFuncs.push(func);
        }
        else {
            func();
        }
    };
    ColumnAnimationService.prototype.executeLaterVMTurn = function (func) {
        if (this.active) {
            this.executeLaterFuncs.push(func);
        }
        else {
            func();
        }
    };
    ColumnAnimationService.prototype.ensureAnimationCssClassPresent = function () {
        var _this = this;
        // up the count, so we can tell if someone else has updated the count
        // by the time the 'wait' func executes
        this.animationThreadCount++;
        var animationThreadCountCopy = this.animationThreadCount;
        utils_1.Utils.addCssClass(this.gridPanel.getRoot(), 'ag-column-moving');
        this.executeLaterFuncs.push(function () {
            // only remove the class if this thread was the last one to update it
            if (_this.animationThreadCount === animationThreadCountCopy) {
                utils_1.Utils.removeCssClass(_this.gridPanel.getRoot(), 'ag-column-moving');
            }
        });
    };
    ColumnAnimationService.prototype.flush = function () {
        var nowFuncs = this.executeNextFuncs;
        this.executeNextFuncs = [];
        var waitFuncs = this.executeLaterFuncs;
        this.executeLaterFuncs = [];
        if (nowFuncs.length === 0 && waitFuncs.length === 0) {
            return;
        }
        setTimeout(function () { return nowFuncs.forEach(function (func) { return func(); }); }, 0);
        setTimeout(function () { return waitFuncs.forEach(function (func) { return func(); }); }, 300);
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], ColumnAnimationService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('gridPanel'),
        __metadata("design:type", gridPanel_1.GridPanel)
    ], ColumnAnimationService.prototype, "gridPanel", void 0);
    ColumnAnimationService = __decorate([
        context_1.Bean('columnAnimationService')
    ], ColumnAnimationService);
    return ColumnAnimationService;
}());
exports.ColumnAnimationService = ColumnAnimationService;


/***/ }),

/***/ "vZ2x":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1570);
	module.exports = __webpack_require__(1570);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1570:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($, undefined) {
	    var extend = $.extend;
	    var isLoaded = function() {
	        if (!window.pdfjsLib)
	        {
	            var console = window.console;

	            if (console && console.error) {
	                console.error("PDF.JS required.");
	            }

	            return false;
	        }

	        kendo.pdfviewer.pdfjs.lib = window.pdfjsLib;

	        return true;
	    };

	    extend(kendo, {
	        pdfviewer: {
	            pdfjs: {
	                lib: window.pdfjsLib,
	                isLoaded: isLoaded
	            }
	        }
	    });
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "vZJG":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1320);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1294:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("pfAC");

/***/ }),

/***/ 1297:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("RnqI");

/***/ }),

/***/ 1320:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1294), __webpack_require__(1297) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.modalview",
	    name: "ModalView",
	    category: "mobile",
	    description: "The Kendo ModalView is used to present self-contained functionality in the context of the current task.",
	    depends: [ "mobile.shim", "mobile.view" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        ui = kendo.mobile.ui,
	        Shim = ui.Shim,
	        Widget = ui.Widget,
	        BEFORE_OPEN = "beforeOpen",
	        OPEN = "open",
	        CLOSE = "close",
	        INIT = "init",
	        WRAP = '<div class="km-modalview-wrapper"></div>';

	    var ModalView = ui.View.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            that._id();
	            that._wrap();
	            that._shim();

	            if (!this.options.$angular) {
	                that._layout();
	                that._scroller();
	                that._model();
	            }

	            that.element.css("display", "");

	            that.trigger(INIT);
	        },

	        events: [
	            INIT,
	            BEFORE_OPEN,
	            OPEN,
	            CLOSE
	        ],

	        options: {
	            name: "ModalView",
	            modal: true,
	            width: null,
	            height: null
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            this.shim.destroy();
	        },

	        open: function(target) {
	            var that = this;
	            that.target = $(target);
	            that.shim.show();

	            that._invokeNgController();

	            // necessary for the mobile view interface
	            that.trigger("show", { view: that });
	        },

	        // Interface implementation, called from the pane click handlers
	        openFor: function(target) {
	            if (!this.trigger(BEFORE_OPEN, { target: target })) {
	                this.open(target);
	                this.trigger(OPEN, { target: target });
	            }
	        },

	        close: function() {
	            if (this.element.is(":visible") && !this.trigger(CLOSE)) {
	                this.shim.hide();
	            }
	        },

	        _wrap: function() {
	            var that = this,
	                element = that.element,
	                options = that.options,
	                width, height;

	            width = element[0].style.width || "auto";
	            height = element[0].style.height || "auto";

	            element.addClass("km-modalview").wrap(WRAP);

	            that.wrapper = element.parent().css({
	                width: options.width || width || 300,
	                height: options.height || height || 300
	            }).addClass(height == "auto" ? " km-auto-height" : "");

	            element.css({ width: "", height: "" });
	        },

	        _shim: function() {
	            var that = this;

	            that.shim = new Shim(that.wrapper, {
	                modal: that.options.modal,
	                position: "center center",
	                align: "center center",
	                effect: "fade:in",
	                className: "km-modalview-root",
	                hide: function(e) {
	                    if (that.trigger(CLOSE)) {
	                        e.preventDefault();
	                    }
	                }
	            });
	        }
	    });

	    ui.plugin(ModalView);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "vkLX":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(941);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 882:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("nzx/");

/***/ }),

/***/ 941:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/***********************************************************************
	 * WARNING: this file is auto-generated.  If you change it directly,
	 * your modifications will eventually be lost.  The source code is in
	 * `kendo-charts` repository, you should make your changes there and
	 * run `src-modules/sync.sh` in this repository.
	 */
	(function(f, define){
	     !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(882) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function () {

	window.kendo.dataviz = window.kendo.dataviz || {};

	var BAR_GAP = 1.5;
	var BAR_SPACING = 0.4;
	var BLACK = '#000';
	var SANS = 'Arial, Helvetica, sans-serif';
	var SANS11 = "11px " + SANS;
	var SANS12 = '12px ' + SANS;
	var SANS16 = '16px ' + SANS;
	var TRANSPARENT = 'transparent';
	var WHITE = '#fff';

	var notes = function () { return ({
	    icon: {
	        border: {
	            width: 1
	        }
	    },
	    label: {
	        font: SANS12,
	        padding: 3
	    },
	    line: {
	        length: 10,
	        width: 2
	    },
	    visible: true
	}); };

	var axisDefaults = function () { return ({
	    labels: {
	        font: SANS12
	    },
	    notes: notes(),
	    title: {
	        font: SANS16,
	        margin: 5
	    }
	}); };

	var areaSeries = function () { return ({
	    highlight: {
	        markers: {
	            border: {}
	        }
	    },
	    line: {
	        opacity: 1,
	        width: 0
	    },
	    markers: {
	        size: 6,
	        visible: false
	    },
	    opacity: 0.4
	}); };

	var rangeAreaSeries = function () { return ({
	    highlight: {
	        markers: {
	            border: {}
	        }
	    },
	    line: {
	        opacity: 1,
	        width: 0
	    },
	    markers: {
	        size: 6,
	        visible: false
	    },
	    opacity: 0.4
	}); };

	var barSeries = function () { return ({
	    gap: BAR_GAP,
	    spacing: BAR_SPACING
	}); };

	var boxPlotSeries = function () { return ({
	    outliersField: "",
	    meanField: "",
	    border: {
	        _brightness: 0.8,
	        width: 1
	    },
	    downColor: WHITE,
	    gap: 1,
	    highlight: {
	        border: {
	            opacity: 1,
	            width: 2
	        },
	        whiskers: {
	            width: 3
	        },
	        mean: {
	            width: 2
	        },
	        median: {
	            width: 2
	        }
	    },
	    mean: {
	        width: 2
	    },
	    median: {
	        width: 2
	    },
	    spacing: 0.3,
	    whiskers: {
	        width: 2
	    }
	}); };

	var bubbleSeries = function () { return ({
	    border: {
	        width: 0
	    },
	    labels: {
	        background: TRANSPARENT
	    },
	    opacity: 0.6
	}); };

	var bulletSeries = function () { return ({
	    gap: BAR_GAP,
	    spacing: BAR_SPACING,
	    target: {
	        color: "#ff0000"
	    }
	}); };

	var candlestickSeries = function () { return ({
	    border: {
	        _brightness: 0.8,
	        width: 1
	    },
	    downColor: WHITE,
	    gap: 1,
	    highlight: {
	        border: {
	            opacity: 1,
	            width: 2
	        },
	        line: {
	            width: 2
	        }
	    },
	    line: {
	        color: BLACK,
	        width: 1
	    },
	    spacing: 0.3
	}); };

	var columnSeries = function () { return ({
	    gap: BAR_GAP,
	    spacing: BAR_SPACING
	}); };

	var donutSeries = function () { return ({
	    margin: 1
	}); };

	var lineSeries = function () { return ({
	    width: 2
	}); };

	var ohlcSeries = function () { return ({
	    gap: 1,
	    highlight: {
	        line: {
	            opacity: 1,
	            width: 3
	        }
	    },
	    line: {
	        width: 1
	    },
	    spacing: 0.3
	}); };

	var radarAreaSeries = function () { return ({
	    line: {
	        opacity: 1,
	        width: 0
	    },
	    markers: {
	        size: 6,
	        visible: false
	    },
	    opacity: 0.5
	}); };

	var radarLineSeries = function () { return ({
	    markers: {
	        visible: false
	    },
	    width: 2
	}); };

	var rangeBarSeries = function () { return ({
	    gap: BAR_GAP,
	    spacing: BAR_SPACING
	}); };

	var rangeColumnSeries = function () { return ({
	    gap: BAR_GAP,
	    spacing: BAR_SPACING
	}); };

	var scatterLineSeries = function () { return ({
	    width: 1
	}); };

	var waterfallSeries = function () { return ({
	    gap: 0.5,
	    line: {
	        color: BLACK,
	        width: 1
	    },
	    spacing: BAR_SPACING
	}); };

	var pieSeries = function () { return ({
	    labels: {
	        background: '',
	        color: '',
	        padding: {
	            top: 5,
	            bottom: 5,
	            left: 7,
	            right: 7
	        }
	    }
	}); };

	var funnelSeries = function () { return ({
	    labels: {
	        background: '',
	        color: '',
	        padding: {
	            top: 5,
	            bottom: 5,
	            left: 7,
	            right: 7
	        }
	    }
	}); };

	var seriesDefaults = function (options) { return ({
	    visible: true,
	    labels: {
	        font: SANS11
	    },
	    overlay: options.gradients ? {} : {
	        gradient: "none"
	    },
	    area: areaSeries(),
	    rangeArea: rangeAreaSeries(),
	    verticalRangeArea: rangeAreaSeries(),
	    bar: barSeries(),
	    boxPlot: boxPlotSeries(),
	    bubble: bubbleSeries(),
	    bullet: bulletSeries(),
	    candlestick: candlestickSeries(),
	    column: columnSeries(),
	    pie: pieSeries(),
	    donut: donutSeries(),
	    funnel: funnelSeries(),
	    horizontalWaterfall: waterfallSeries(),
	    line: lineSeries(),
	    notes: notes(),
	    ohlc: ohlcSeries(),
	    radarArea: radarAreaSeries(),
	    radarLine: radarLineSeries(),
	    polarArea: radarAreaSeries(),
	    polarLine: radarLineSeries(),
	    rangeBar: rangeBarSeries(),
	    rangeColumn: rangeColumnSeries(),
	    scatterLine: scatterLineSeries(),
	    verticalArea: areaSeries(),
	    verticalBoxPlot: boxPlotSeries(),
	    verticalBullet: bulletSeries(),
	    verticalLine: lineSeries(),
	    waterfall: waterfallSeries()
	}); };

	var title = function () { return ({
	    font: SANS16
	}); };

	var legend = function () { return ({
	    labels: {
	        font: SANS12
	    }
	}); };

	var baseTheme = function (options) {
	    if (options === void 0) { options = {}; }

	    return ({
	    axisDefaults: axisDefaults(),
	    categoryAxis: {
	        majorGridLines: {
	            visible: true
	        }
	    },
	    navigator: {
	        pane: {
	            height: 90,
	            margin: {
	                top: 10
	            }
	        }
	    },
	    seriesDefaults: seriesDefaults(options),
	    title: title(),
	    legend: legend()
	});
	};

	kendo.deepExtend(kendo.dataviz, {
	    chartBaseTheme: baseTheme
	});

	})();

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "vn1v":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(909);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(910)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function ($) {
	    var kendo = window.kendo;
	    var Widget = kendo.ui.Widget;
	    var dataviz = kendo.dataviz;
	    var LinearGauge = dataviz.LinearGauge;
	    var RadialGauge = dataviz.RadialGauge;
	    var ArcGauge = dataviz.ArcGauge;
	    var draw = kendo.drawing;

	    function themeOptions(options) {
	        var themes = dataviz.ui.themes || {};
	        var themeName = options.theme || "";
	        var lowerName = themeName.toLowerCase();

	        if(dataviz.SASS_THEMES.indexOf(lowerName) != -1) {
	            return dataviz.autoTheme().gauge;
	        }

	        return (themes[themeName] || themes[lowerName] || {}).gauge;
	    }

	    var Gauge = Widget.extend({
	        init: function(element, userOptions) {
	            kendo.destroy(element);
	            $(element).empty();

	            Widget.fn.init.call(this, element);

	            this.options = kendo.deepExtend(this.options, userOptions);

	            this.wrapper = this.element;
	            this._createInstance();

	            this.element.addClass('k-gauge');

	            kendo.notify(this, dataviz.ui);
	        },

	        options: {
	            theme: "default",
	            renderAs: "",
	            pointer: {},
	            scale: {},
	            gaugeArea: {
	                background: ""
	            },
	            transitions: true
	        },

	        setOptions: function(options) {
	            this._instance.setOptions(options, themeOptions(options));

	            this._copyFields();
	        },

	        redraw: function() {
	            this._instance.redraw();
	            this._copyFields();
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            this._instance.destroy();
	        },

	        _createInstance: function() {
	            var gaugeType = this._gaugeType();
	            this._instance = new gaugeType(this.element[0], this.options, themeOptions(this.options));
	            this._copyFields();
	        },

	        _copyFields: function() {
	            this._originalOptions = this._instance._originalOptions;
	            this.options = this._instance.options;
	            this.surface = this._instance.surface;
	            this.bbox = this._instance.bbox;
	            this.gaugeArea = this._instance.gaugeArea;
	            this.pointers = this._instance.pointers;
	            this.scale = this._instance.scale;
	        },

	        _resize: function() {
	            this._instance.resize();
	        }
	    });

	    var proxyMembers = ["getSize", "value", "allValues", "exportVisual"];

	    function createProxyMember(name) {
	        Gauge.fn[name] = function() {
	            return this._instance[name].apply(this._instance, arguments);
	        };
	    }

	    for (var idx = 0; idx < proxyMembers.length; idx++) {
	        createProxyMember(proxyMembers[idx]);
	    }

	    dataviz.ExportMixin.extend(Gauge.fn);

	    var RadialGaugeWidget = Gauge.extend({

	        options: {
	            name: "RadialGauge"
	        },

	        _gaugeType: function() {
	            return RadialGauge;
	        }
	    });

	    var LinearGaugeWidget = Gauge.extend({

	        options: {
	            name: "LinearGauge",
	            scale: {
	                vertical: true
	            }
	        },

	        _gaugeType: function() {
	            return LinearGauge;
	        }
	    });

	    var ArcGaugeWidget = Gauge.extend({
	        init: function(element, userOptions) {
	            Gauge.fn.init.call(this, element, userOptions);

	            this.element.css('position', 'relative');
	            this.element.addClass('k-arcgauge');

	            this._centerTemplate();
	        },

	        options: {
	            name: "ArcGauge"
	        },

	        setOptions: function(options) {
	            Gauge.fn.setOptions.call(this, options);
	            this._centerTemplate();
	        },

	        redraw: function() {
	            Gauge.fn.redraw.call(this);
	            this._centerTemplate();
	        },

	        value: function(value) {
	            var instance = this._instance;
	            if (arguments.length === 0) {
	                return instance.value();
	            }

	            instance.value(value);

	            this._centerTemplate();
	        },

	        destroy: function() {
	            Gauge.fn.destroy.call(this);
	            delete this._centerElement;
	        },

	        exportVisual: function() {
	            if (this._centerElement) {
	                return false;
	            }

	            return Gauge.fn.exportVisual.call(this);
	        },

	        _resize: function() {
	            this._instance.resize();

	            this._centerTemplate();
	        },

	        _centerTemplate: function() {
	            if (this.options.centerTemplate) {
	                var template = kendo.template(this.options.centerTemplate);

	                var instance = this._instance;
	                var centerElement = this._getCenterElement();

	                centerElement.html(template({ color: instance.currentColor(), value: instance.value() }));

	                var position = instance.centerLabelPosition(centerElement.width(), centerElement.height());

	                centerElement.css(position);
	            } else if (this._centerElement) {
	                this._centerElement.remove();
	                this._centerElement = null;
	            }
	        },

	        _getCenterElement: function() {
	            var centerElement = this._centerElement;
	            if (!centerElement) {
	                centerElement = this._centerElement = $('<div></div>').addClass('k-arcgauge-label');
	                this.element.append(centerElement);
	            }

	            return centerElement;
	        },

	        _gaugeType: function() {
	            return ArcGauge;
	        }
	    });

	    function createExportMethod(name) {
	        ArcGaugeWidget.fn[name] = function(options) {
	            var gauge = this;
	            var method = draw[name];

	            if (!gauge._centerElement) {
	                return method(gauge.exportVisual(), options);
	            }

	            return draw.drawDOM(gauge.element).then(function(visual) {
	                return method(visual, options);
	            });
	        };
	    }

	    var exportMethods = ['exportSVG', 'exportImage', 'exportPDF'];

	    for (idx = 0; idx < exportMethods.length; idx++) {
	        createExportMethod(exportMethods[idx]);
	    }

	    dataviz.ui.plugin(LinearGaugeWidget);
	    dataviz.ui.plugin(RadialGaugeWidget);
	    dataviz.ui.plugin(ArcGaugeWidget);

	    kendo.deepExtend(dataviz, {
	        Gauge: Gauge,
	        LinearGauge: LinearGaugeWidget,
	        RadialGauge: RadialGaugeWidget,
	        ArcGauge: ArcGaugeWidget
	    });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 910:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("aghF");

/***/ })

/******/ });

/***/ }),

/***/ "vuuZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = __webpack_require__("pQ38");
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var columnController_1 = __webpack_require__("77lH");
var column_1 = __webpack_require__("hDyE");
var eventService_1 = __webpack_require__("k5uU");
var events_1 = __webpack_require__("3ok8");
var utils_1 = __webpack_require__("IRr6");
var headerWrapperComp_1 = __webpack_require__("CTJA");
var headerGroupWrapperComp_1 = __webpack_require__("/9Ut");
var filterManager_1 = __webpack_require__("Up6z");
var componentRecipes_1 = __webpack_require__("EOXx");
var gridApi_1 = __webpack_require__("BAow");
var HeaderRowType;
(function (HeaderRowType) {
    HeaderRowType[HeaderRowType["COLUMN_GROUP"] = 0] = "COLUMN_GROUP";
    HeaderRowType[HeaderRowType["COLUMN"] = 1] = "COLUMN";
    HeaderRowType[HeaderRowType["FLOATING_FILTER"] = 2] = "FLOATING_FILTER";
})(HeaderRowType = exports.HeaderRowType || (exports.HeaderRowType = {}));
var HeaderRowComp = (function (_super) {
    __extends(HeaderRowComp, _super);
    function HeaderRowComp(dept, type, pinned, eRoot, dropTarget) {
        var _this = _super.call(this, "<div class=\"ag-header-row\" role=\"presentation\"/>") || this;
        _this.headerComps = {};
        _this.dept = dept;
        _this.type = type;
        _this.pinned = pinned;
        _this.eRoot = eRoot;
        _this.dropTarget = dropTarget;
        return _this;
    }
    HeaderRowComp.prototype.forEachHeaderElement = function (callback) {
        var _this = this;
        Object.keys(this.headerComps).forEach(function (key) {
            callback(_this.headerComps[key]);
        });
    };
    HeaderRowComp.prototype.destroy = function () {
        var idsOfAllChildren = Object.keys(this.headerComps);
        this.removeAndDestroyChildComponents(idsOfAllChildren);
        _super.prototype.destroy.call(this);
    };
    HeaderRowComp.prototype.removeAndDestroyChildComponents = function (idsToDestroy) {
        var _this = this;
        idsToDestroy.forEach(function (id) {
            var childHeaderComp = _this.headerComps[id];
            _this.getGui().removeChild(childHeaderComp.getGui());
            if (childHeaderComp.destroy) {
                childHeaderComp.destroy();
            }
            delete _this.headerComps[id];
        });
    };
    HeaderRowComp.prototype.onRowHeightChanged = function () {
        var headerRowCount = this.columnController.getHeaderRowCount();
        var sizes = [];
        var numberOfFloating = 0;
        var groupHeight;
        var headerHeight;
        if (!this.columnController.isPivotMode()) {
            if (this.gridOptionsWrapper.isFloatingFilter()) {
                headerRowCount++;
            }
            numberOfFloating = (this.gridOptionsWrapper.isFloatingFilter()) ? 1 : 0;
            groupHeight = this.gridOptionsWrapper.getGroupHeaderHeight();
            headerHeight = this.gridOptionsWrapper.getHeaderHeight();
        }
        else {
            numberOfFloating = 0;
            groupHeight = this.gridOptionsWrapper.getPivotGroupHeaderHeight();
            headerHeight = this.gridOptionsWrapper.getPivotHeaderHeight();
        }
        var numberOfNonGroups = 1 + numberOfFloating;
        var numberOfGroups = headerRowCount - numberOfNonGroups;
        for (var i = 0; i < numberOfGroups; i++)
            sizes.push(groupHeight);
        sizes.push(headerHeight);
        for (var i = 0; i < numberOfFloating; i++)
            sizes.push(this.gridOptionsWrapper.getFloatingFiltersHeight());
        var rowHeight = 0;
        for (var i = 0; i < this.dept; i++)
            rowHeight += sizes[i];
        this.getGui().style.top = rowHeight + 'px';
        this.getGui().style.height = sizes[this.dept] + 'px';
    };
    //noinspection JSUnusedLocalSymbols
    HeaderRowComp.prototype.init = function () {
        this.onRowHeightChanged();
        this.onVirtualColumnsChanged();
        this.setWidth();
        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT, this.onRowHeightChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_VIRTUAL_COLUMNS_CHANGED, this.onVirtualColumnsChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
    };
    HeaderRowComp.prototype.onColumnResized = function () {
        this.setWidth();
    };
    HeaderRowComp.prototype.setWidth = function () {
        var mainRowWidth = this.columnController.getContainerWidth(this.pinned) + 'px';
        this.getGui().style.width = mainRowWidth;
    };
    HeaderRowComp.prototype.onGridColumnsChanged = function () {
        this.removeAndDestroyAllChildComponents();
    };
    HeaderRowComp.prototype.removeAndDestroyAllChildComponents = function () {
        var idsOfAllChildren = Object.keys(this.headerComps);
        this.removeAndDestroyChildComponents(idsOfAllChildren);
    };
    HeaderRowComp.prototype.onDisplayedColumnsChanged = function () {
        this.onVirtualColumnsChanged();
        this.setWidth();
    };
    HeaderRowComp.prototype.onVirtualColumnsChanged = function () {
        var _this = this;
        var currentChildIds = Object.keys(this.headerComps);
        var itemsAtDepth = this.columnController.getVirtualHeaderGroupRow(this.pinned, this.type == HeaderRowType.FLOATING_FILTER ?
            this.dept - 1 :
            this.dept);
        var ensureDomOrder = this.gridOptionsWrapper.isEnsureDomOrder();
        var eBefore;
        itemsAtDepth.forEach(function (child) {
            // skip groups that have no displayed children. this can happen when the group is broken,
            // and this section happens to have nothing to display for the open / closed state.
            // (a broken group is one that is split, ie columns in the group have a non-group column
            // in between them)
            if (child.isEmptyGroup()) {
                return;
            }
            var idOfChild = child.getUniqueId();
            var eParentContainer = _this.getGui();
            // if we already have this cell rendered, do nothing
            var colAlreadyInDom = currentChildIds.indexOf(idOfChild) >= 0;
            var headerComp;
            var eHeaderCompGui;
            if (colAlreadyInDom) {
                utils_1.Utils.removeFromArray(currentChildIds, idOfChild);
                headerComp = _this.headerComps[idOfChild];
                eHeaderCompGui = headerComp.getGui();
                if (ensureDomOrder) {
                    utils_1.Utils.ensureDomOrder(eParentContainer, eHeaderCompGui, eBefore);
                }
                eBefore = eHeaderCompGui;
            }
            else {
                headerComp = _this.createHeaderComp(child);
                _this.headerComps[idOfChild] = headerComp;
                eHeaderCompGui = headerComp.getGui();
                if (ensureDomOrder) {
                    utils_1.Utils.insertWithDomOrder(eParentContainer, eHeaderCompGui, eBefore);
                }
                else {
                    eParentContainer.appendChild(eHeaderCompGui);
                }
                eBefore = eHeaderCompGui;
            }
        });
        // at this point, anything left in currentChildIds is an element that is no longer in the viewport
        this.removeAndDestroyChildComponents(currentChildIds);
    };
    HeaderRowComp.prototype.createHeaderComp = function (columnGroupChild) {
        var result;
        switch (this.type) {
            case HeaderRowType.COLUMN:
                result = new headerWrapperComp_1.HeaderWrapperComp(columnGroupChild, this.eRoot, this.dropTarget, this.pinned);
                break;
            case HeaderRowType.COLUMN_GROUP:
                result = new headerGroupWrapperComp_1.HeaderGroupWrapperComp(columnGroupChild, this.eRoot, this.dropTarget, this.pinned);
                break;
            case HeaderRowType.FLOATING_FILTER:
                var column = columnGroupChild;
                result = this.createFloatingFilterWrapper(column);
                break;
        }
        this.context.wireBean(result);
        return result;
    };
    HeaderRowComp.prototype.createFloatingFilterWrapper = function (column) {
        var _this = this;
        var floatingFilterParams = this.createFloatingFilterParams(column);
        var floatingFilterWrapper = this.componentRecipes.newFloatingFilterWrapperComponent(column, floatingFilterParams);
        this.addDestroyableEventListener(column, column_1.Column.EVENT_FILTER_CHANGED, function () {
            var filterComponentPromise = _this.filterManager.getFilterComponent(column);
            floatingFilterWrapper.onParentModelChanged(filterComponentPromise.resolveNow(null, function (filter) { return filter.getModel(); }));
        });
        var cachedFilter = this.filterManager.cachedFilter(column);
        if (cachedFilter) {
            var filterComponentPromise = this.filterManager.getFilterComponent(column);
            floatingFilterWrapper.onParentModelChanged(filterComponentPromise.resolveNow(null, function (filter) { return filter.getModel(); }));
        }
        return floatingFilterWrapper;
    };
    HeaderRowComp.prototype.createFloatingFilterParams = function (column) {
        var _this = this;
        // We always get the freshest reference to the baseFilter because the filters get sometimes created
        // and destroyed between calls
        //
        // let filterComponent:BaseFilter<any, any, any> = <any>this.filterManager.getFilterComponent(column);
        //
        var baseParams = {
            api: this.gridApi,
            column: column,
            currentParentModel: function () {
                var filterComponentPromise = _this.filterManager.getFilterComponent(column);
                return filterComponentPromise.resolveNow(null, function (filter) {
                    return (filter.getNullableModel) ?
                        filter.getNullableModel() :
                        filter.getModel();
                });
            },
            onFloatingFilterChanged: function (change) {
                var captureModelChangedResolveFunc;
                var modelChanged = new utils_1.Promise(function (resolve) {
                    captureModelChangedResolveFunc = resolve;
                });
                var filterComponentPromise = _this.filterManager.getFilterComponent(column);
                filterComponentPromise.then(function (filterComponent) {
                    if (filterComponent.onFloatingFilterChanged) {
                        //If going through this branch of code the user MUST
                        //be passing an object of type change that contains
                        //a model propery inside and some other stuff
                        var result = filterComponent.onFloatingFilterChanged(change);
                        captureModelChangedResolveFunc(result);
                    }
                    else {
                        //If going through this branch of code the user MUST
                        //be passing the plain model and delegating to ag-Grid
                        //the responsibility to set the parent model and refresh
                        //the filters
                        filterComponent.setModel(change);
                        _this.filterManager.onFilterChanged();
                        captureModelChangedResolveFunc(true);
                    }
                });
                return modelChanged.resolveNow(true, function (modelChanged) { return modelChanged; });
            },
            //This one might be overriden from the colDef
            suppressFilterButton: false
        };
        return baseParams;
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], HeaderRowComp.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], HeaderRowComp.prototype, "gridApi", void 0);
    __decorate([
        context_1.Autowired('columnController'),
        __metadata("design:type", columnController_1.ColumnController)
    ], HeaderRowComp.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], HeaderRowComp.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], HeaderRowComp.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('filterManager'),
        __metadata("design:type", filterManager_1.FilterManager)
    ], HeaderRowComp.prototype, "filterManager", void 0);
    __decorate([
        context_1.Autowired('componentRecipes'),
        __metadata("design:type", componentRecipes_1.ComponentRecipes)
    ], HeaderRowComp.prototype, "componentRecipes", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], HeaderRowComp.prototype, "init", null);
    return HeaderRowComp;
}(component_1.Component));
exports.HeaderRowComp = HeaderRowComp;


/***/ }),

/***/ "w52R":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1321);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1321:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.navbar",
	    name: "NavBar",
	    category: "mobile",
	    description: "The Kendo mobile NavBar widget is used inside a mobile View or Layout Header element to display an application navigation bar.",
	    depends: [ "core" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        mobile = kendo.mobile,
	        ui = mobile.ui,
	        Widget = ui.Widget;

	    function createContainer(align, element) {
	        var items = element.find("[" + kendo.attr("align") + "=" + align + "]");

	        if (items[0]) {
	            return $('<div class="km-' + align + 'item" />').append(items).prependTo(element);
	        }
	    }

	    function toggleTitle(centerElement) {
	        var siblings = centerElement.siblings(),
	            noTitle = !!centerElement.children("ul")[0],
	            showTitle = (!!siblings[0] && kendo.trim(centerElement.text()) === ""),
	            android = !!(kendo.mobile.application && kendo.mobile.application.element.is(".km-android"));

	        centerElement.prevAll().toggleClass("km-absolute", noTitle);
	        centerElement.toggleClass("km-show-title", showTitle);
	        centerElement.toggleClass("km-fill-title", showTitle && !kendo.trim(centerElement.html()));
	        centerElement.toggleClass("km-no-title", noTitle);
	        centerElement.toggleClass("km-hide-title", android && !siblings.children().is(":visible"));
	    }

	    var NavBar = Widget.extend({
	        init: function(element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);

	            element = that.element;

	            that.container().bind("show", $.proxy(this, "refresh"));

	            element.addClass("km-navbar").wrapInner($('<div class="km-view-title km-show-title" />'));
	            that.leftElement = createContainer("left", element);
	            that.rightElement = createContainer("right", element);
	            that.centerElement = element.find(".km-view-title");
	        },

	        options: {
	            name: "NavBar"
	        },

	        title: function(value) {
	            this.element.find(kendo.roleSelector("view-title")).text(value);
	            toggleTitle(this.centerElement);
	        },

	        refresh: function(e) {
	            var view = e.view;
	            this.title(view.options.title);
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);
	            kendo.destroy(this.element);
	        }
	    });

	    ui.plugin(NavBar);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "w8e/":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1037);
	module.exports = __webpack_require__(1037);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 1037:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(1038), __webpack_require__(1039), __webpack_require__(23)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function () {

	    (function ($, undefined) {
	        var kendo = window.kendo,
	            extend = $.extend,
	            proxy = $.proxy,
	            Class = kendo.Class,

	            NS = ".k-imageeditor-pane",

	            CLICK = "click";

	        var paneStyles = {
	            form: "k-imageeditor-pane-form",
	            button: "k-imageeditor-pane-button",
	            confirmButton: "k-imageeditor-pane-confirm-button",
	            cropOverlay: "k-imageeditor-crop-overlay",
	            crop: "k-imageeditor-crop",
	            resizeHandle: "k-resize-handle",
	            resizeHandlePrefix: "k-resize-"
	        };

	        var round = function(f) {
	            return Math.round(f * 1000) / 1000;
	        };

	        var Pane = Class.extend({
	            init: function (imageeditor) {
	                var that = this;

	                that.imageeditor = imageeditor;

	                if (that.imageeditor.currentPaneTool) {
	                    that.imageeditor.currentPaneTool.destroy();
	                }

	                that.element = $("<div></div>").addClass(paneStyles.form);
	            },
	            open: function () {
	                var that = this,
	                    imageeditor = that.imageeditor,
	                    commonMessages = imageeditor.options.messages.common;

	                imageeditor.paneWrapper.append(that.element);
	                that.formWidget = new kendo.ui.Form(that.element, extend(that.formSettings(), {
	                    buttonsTemplate: kendo.format("<button class='{0} k-button' data-action='cancel'>{2}</button>" +
	                                                    "<button class='{0} {1} k-button k-primary' data-action='confirm'>{3}</button>",
	                                                    paneStyles.button,
	                                                    paneStyles.confirmButton,
	                                                    commonMessages.cancel,
	                                                    commonMessages.confirm)
	                }));

	                that.bindButtonEvents();
	                imageeditor.paneWrapper.show();
	                imageeditor.currentPaneTool = that;
	            },
	            bindButtonEvents: function () {
	                var that = this,
	                    formWidget = that.formWidget,
	                    buttons = formWidget.element.find("." + paneStyles.button);

	                that._clickHandler = proxy(that._click, that);

	                buttons.on(CLICK + NS, that._clickHandler);
	            },
	            _click: function (ev) {
	                var that = this,
	                    target = $(ev.target),
	                    action = target.data("action");

	                if(that[action]) {
	                    that[action]();
	                }
	            },
	            cancel: function () {
	                this.destroy();
	            },
	            confirm: function () {
	                window.console.error("Pane's confirm method is not implemented!");
	                this.destroy();
	            },
	            refresh: function () {
	            },
	            destroy: function () {
	                var that = this,
	                    imageeditor = that.imageeditor;

	                that.formWidget.element.find("." + paneStyles.button).off(NS);
	                that.formWidget.destroy();
	                imageeditor.paneWrapper.html("");
	                imageeditor.paneWrapper.hide();
	                delete imageeditor.currentPaneTool;
	            }
	        });

	        var CropPane = Pane.extend({
	            init: function (imageeditor) {
	                var that = this;
	                Pane.fn.init.call(that, imageeditor);
	                that.buildCropModel();
	                that.canvasUI();
	            },
	            confirm: function () {
	                var that = this,
	                    model = that.formWidget._model.toJSON();

	                that.destroy();
	                that.imageeditor.executeCommand({command: "CropImageEditorCommand", options: model });
	            },
	            formSettings: function () {
	                var that = this,
	                    cropMessages = that.imageeditor.options.messages.panes.crop,
	                    commonMessages = that.imageeditor.options.messages.common,
	                    aspectRatioItems = cropMessages.aspectRatioItems,
	                    aspectRatioDS = [];

	                if(aspectRatioItems) {
	                    for (var key in aspectRatioItems) {
	                        aspectRatioDS.push({value: key, text: aspectRatioItems[key]});
	                    }
	                } else {
	                    aspectRatioDS = [
	                        { value: "originalRatio", text: "Original ratio"},
	                        { value: "1:1", text: "1:1 (Square)"},
	                        { value: "4:5", text: "4:5 (8:10)"},
	                        { value: "5:7", text: "5:7"},
	                        { value: "2:3", text: "2:3 (4:6)"},
	                        { value: "16:9", text: "16:9"}
	                    ];
	                }

	                return {
	                    formData: that._model,
	                    change: proxy(that.onChange, that),
	                    items: [{
	                        type: "group",
	                        label: cropMessages.title || "Crop Image",
	                        layout: "grid",
	                        grid: { cols: 2, gutter: "0 8px" },
	                        items: [{
	                                label: cropMessages.aspectRatio || "Aspect ratio:",
	                                field: "aspectRatio",
	                                editor: "DropDownList",
	                                editorOptions: {
	                                    dataValueField: "value",
	                                    dataTextField: "text",
	                                    dataSource: aspectRatioDS
	                                },
	                                colSpan: 2
	                            }, {
	                                label: cropMessages.orientation,
	                                field: "orientation",
	                                editor: $.proxy(that._orientationEditor, that),
	                                colSpan: 2
	                            }, {
	                                label: commonMessages.width || "Width:",
	                                field: "width",
	                                attributes: { style: "max-width: 100px;" },
	                                editor: "NumericTextBox",
	                                editorOptions: {
	                                    format: "n0",
	                                    max: that._model.width,
	                                    min: 0
	                                },
	                                colSpan: 1
	                            }, {
	                                label: commonMessages.height || "Height:",
	                                field: "height",
	                                attributes: { style: "max-width: 100px;" },
	                                editor: "NumericTextBox",
	                                editorOptions: {
	                                    format: "n0",
	                                    max: that._model.height,
	                                    min: 0
	                                },
	                                colSpan: 1
	                            }, {
	                                label: commonMessages.lockAspectRatio || "Lock aspect ratio",
	                                field: "lockAspectRatio",
	                                colSpan: 2
	                            }
	                        ]
	                    }]
	                };
	            },
	            _orientationEditor: function(container, options){
	                var that = this,
	                    cropMessages = that.imageeditor.options.messages.panes.crop,
	                    value = options.model[options.field];

	                $("<div name='" + options.field + "'></div>")
	                    .appendTo(container)
	                    .kendoButtonGroup({
	                        items: [
	                            { text: cropMessages.portrait || "Portrait", attributes: { "data-value": "portrait" }, selected: value === "portrait" },
	                            { text: cropMessages.landscape || "Landscape", attributes: { "data-value": "landscape" }, selected : value === "landscape" }
	                        ],
	                        select: function (ev) {
	                            var value = ev.sender.wrapper.find(".k-state-active").data("value");
	                            options.model.set(options.field, value);
	                        }
	                    });
	            },
	            buildCropModel: function () {
	                var that = this,
	                    imageeditor = that.imageeditor,
	                    canvas = imageeditor.getCanvasElement(),
	                    width = canvas.width,
	                    height = canvas.height;

	                    that._model = {
	                        top: 0,
	                        left: 0,
	                        aspectRatio: "originalRatio",
	                        width: width,
	                        height: height,
	                        orientation: (width - height < 0) ? "portrait" : "landscape",
	                        lockAspectRatio: true
	                    };
	            },
	            canvasUI: function () {
	                var that = this,
	                    imageeditor = that.imageeditor,
	                    canvasContainer = that.imageeditor.canvasContainer,
	                    cropOverlay = $("<div></div>").addClass(paneStyles.cropOverlay),
	                    cropElement = $("<div></div>").addClass(paneStyles.crop),
	                    handle = "<span class='" + paneStyles.resizeHandle + "'></span>",
	                    handles = [ "nw", "n", "ne", "w", "e", "sw", "s", "se" ],
	                    zoomLevel = imageeditor.getZoomLevel();

	                for (var i = 0; i < handles.length; i++) {
	                    var handleElm = $(handle)
	                        .addClass(paneStyles.resizeHandlePrefix + handles[i])
	                        .attr("data-orientation", handles[i]);

	                    that._initResizeHandle(handleElm);

	                    cropElement.append(handleElm);
	                }

	                that.cropElement = cropElement;

	                that._canvasUI = cropOverlay
	                    .append(cropElement)
	                    .appendTo(canvasContainer);

	                var width = Math.round(that._model.width * zoomLevel);
	                var height = Math.round(that._model.height * zoomLevel);
	                var borderWidth = parseInt(that.cropElement.css("border-top-width"), 10);

	                that.cropElement.css({
	                    width: width,
	                    height: height,
	                    backgroundImage: "url('"+ imageeditor._image.src + "')",
	                    backgroundSize: kendo.format("{0}px {1}px", width, height),
	                    backgroundClip: "content-box",
	                    backgroundPosition: kendo.format("-{0}px -{0}px", borderWidth)
	                });

	                that.cropElement.kendoDraggable({
	                    ignore: "." + paneStyles.resizeHandle,
	                    drag: function (ev) {
	                        that._adjustTopLeft(ev.target.offsetTop + ev.y.delta, ev.target.offsetLeft + ev.x.delta);
	                    }
	                });
	            },
	            refresh: function () {
	                var that = this,
	                    newModel = that.formWidget._model,
	                    zoomLevel = that.imageeditor.getZoomLevel(),
	                    width = Math.round(newModel.width * zoomLevel),
	                    height = Math.round(newModel.height * zoomLevel),
	                    top = Math.round(newModel.top * zoomLevel),
	                    left = Math.round(newModel.left * zoomLevel),
	                    borderWidth = parseInt(that.cropElement.css("border-top-width"), 10);

	                that.cropElement.css({
	                    top: top,
	                    left: left,
	                    width: width,
	                    height: height,
	                    backgroundSize: kendo.format("{0}px {1}px", that._model.width * zoomLevel, that._model.height * zoomLevel),
	                    backgroundPosition: kendo.format("-{0}px -{1}px", left + borderWidth, top + borderWidth)
	                });
	            },
	            _initResizeHandle: function (handle) {
	                var that = this;

	                handle.kendoDraggable({
	                    drag: function (ev) {
	                        var $target = $(ev.sender.element),
	                            newModel = that.formWidget._model,
	                            oldModel = that._model,
	                            orientation = $target.data("orientation"),
	                            adjustments = {},
	                            zoomLevel = that.imageeditor.getZoomLevel(),
	                            correctedLeft = newModel.left * zoomLevel,
	                            correctedTop = newModel.top * zoomLevel;

	                        if (orientation.indexOf("w") >= 0) {
	                            adjustments.left = that.cropElement[0].offsetLeft + ev.x.delta;
	                            adjustments.width = that.cropElement[0].offsetWidth - ev.x.delta;
	                        } else if (orientation.indexOf("e") >= 0) {
	                            adjustments.width = that.cropElement[0].offsetWidth + ev.x.delta;
	                        }

	                        if (orientation.indexOf("n") >= 0) {
	                            adjustments.top = that.cropElement[0].offsetTop + ev.y.delta;
	                            adjustments.height = that.cropElement[0].offsetHeight - ev.y.delta;
	                        } else if(orientation.indexOf("s") >= 0) {
	                            adjustments.height = that.cropElement[0].offsetHeight + ev.y.delta;
	                        }

	                        if(adjustments.width && ((adjustments.left || correctedLeft) + adjustments.width <= oldModel.width * zoomLevel)) {
	                            newModel.set("width", Math.round(adjustments.width / zoomLevel));
	                        }

	                        if(adjustments.height && ((adjustments.top || correctedTop) + adjustments.height <= oldModel.height * zoomLevel)) {
	                            newModel.set("height", Math.round(adjustments.height / zoomLevel));
	                        }

	                        if(adjustments.top || adjustments.left) {
	                            that._adjustTopLeft(adjustments.top, adjustments.left);
	                        }
	                    }
	                });
	            },
	            _adjustTopLeft: function (top, left, compare) {
	                var that = this,
	                    compareModel = compare || that.formWidget._model,
	                    newModel = that.formWidget._model,
	                    oldModel = that._model,
	                    zoomLevel = that.imageeditor.getZoomLevel();

	                if(top >= 0 && (top / zoomLevel) + compareModel.height <= oldModel.height) {
	                    newModel.set("top", Math.round(top / zoomLevel));
	                }

	                if(left >= 0 && (left / zoomLevel) + compareModel.width <= oldModel.width) {
	                    newModel.set("left", Math.round(left / zoomLevel));
	                }
	            },
	            onChange: function (ev) {
	                var that = this,
	                    zoomLevel = that.imageeditor.getZoomLevel(),
	                    newModel = ev.sender._model,
	                    oldModel = that._model,
	                    maxWidth = oldModel.width,
	                    maxHeight = oldModel.height,
	                    originalRatio = oldModel.width + ":" + oldModel.height,
	                    gcd = that._gcd(oldModel.width, oldModel.height);

	                originalRatio = oldModel.width/gcd + ":" + oldModel.height/gcd;

	                if(ev.field === "aspectRatio" && ev.value === "originalRatio") {
	                    newModel.set("top", 0);
	                    newModel.set("left", 0);
	                    newModel.set("width", oldModel.width);
	                    newModel.set("height", oldModel.height);
	                    newModel.set("orientation", oldModel.orientation);
	                } else if (ev.field === "orientation") {
	                    var tempModel = extend({}, newModel, {
	                        width: newModel.height,
	                        height: newModel.width
	                    });

	                    var newSize = that._calcSize(tempModel, originalRatio, maxWidth, maxHeight);

	                    newModel.set("width", newSize.width);
	                    newModel.set("height", newSize.height);
	                } else if(newModel.lockAspectRatio) {
	                    var force = ev.field;
	                    var size = that._calcSize(newModel, originalRatio, maxWidth, maxHeight, force);
	                    newModel.set("width", size.width);
	                    newModel.set("height", size.height);
	                }

	                var width = Math.round(newModel.width * zoomLevel);
	                var height = Math.round(newModel.height * zoomLevel);
	                var top = Math.round(newModel.top * zoomLevel);
	                var left = Math.round(newModel.left * zoomLevel);
	                var borderWidth = parseInt(that.cropElement.css("border-top-width"), 10);

	                that.cropElement.css({
	                    top: top,
	                    left: left,
	                    width: width,
	                    height: height,
	                    backgroundPosition: kendo.format("-{0}px -{1}px", left + borderWidth, top + borderWidth)
	                });
	            },
	            _calcSize: function (model, originalRatio, maxWidth, maxHeight, force) {
	                var width = Math.min(model.width, maxWidth),
	                    height = Math.min(model.height, maxHeight),
	                    isPortrait = model.orientation === "portrait",
	                    ratios = model.aspectRatio;

	                if(ratios.indexOf(":") < 0) {
	                    ratios = originalRatio;
	                }

	                ratios = ratios.split(":").map(function (value) {
	                    return parseInt(value, 10);
	                });

	                var wRatio = isPortrait ? Math.min(ratios[0], ratios[1]) : Math.max(ratios[0], ratios[1]);
	                var hRatio = !isPortrait ? Math.min(ratios[0], ratios[1]) : Math.max(ratios[0], ratios[1]);
	                var expectedRatio = round(wRatio/hRatio);
	                var realRatio = round(width/height);

	                var sizeByRatio = {
	                    width: Math.round(height * expectedRatio),
	                    height: Math.round(width / expectedRatio)
	                };

	                if (force === "width") {
	                    return {
	                        width: width,
	                        height: sizeByRatio.height
	                    };
	                }

	                if (force === "height") {
	                    return {
	                        width: sizeByRatio.width,
	                        height: height
	                    };
	                }

	                if (realRatio > expectedRatio) {
	                    width = sizeByRatio.width;
	                } else if (realRatio < expectedRatio){
	                    height = sizeByRatio.height;
	                }

	                return {
	                    width: width,
	                    height: height
	                };
	            },
	            _gcd: function (a, b) {
	                return (b === 0) ? a : this._gcd (b, a%b);
	            },
	            destroy: function () {
	                kendo.destroy(this._canvasUI);
	                this._canvasUI.remove();
	                Pane.fn.destroy.call(this);
	            }
	        });

	        var ResizePane = Pane.extend({
	            init: function (imageeditor) {
	                Pane.fn.init.call(this, imageeditor);
	                this.buildResizeModel();
	            },
	            confirm: function () {
	                var that = this,
	                    originalWidth = that._model.width,
	                    originalHeight = that._model.height,
	                    model = that.formWidget._model.toJSON();

	                if(model.measure === "percents") {
	                    model.width = originalWidth * (model.width / 100);
	                    model.height = originalHeight * (model.height / 100);
	                }

	                that.imageeditor.executeCommand({command: "ResizeImageEditorCommand", options: model });
	                that.destroy();
	            },
	            formSettings: function () {
	                var that = this,
	                    resizeMessages = that.imageeditor.options.messages.panes.resize,
	                    commonMessages = that.imageeditor.options.messages.common;

	                return {
	                    formData: that._model,
	                    change: proxy(that.onChange, that),
	                    items: [{
	                        type: "group",
	                        label: resizeMessages.title || "Resize image",
	                        layout: "grid",
	                        grid: { cols: 2, gutter: "0 8px" },
	                        items: [{
	                            label: commonMessages.width || "Width:",
	                            field: "width",
	                            attributes: { style: "max-width: 100px;" },
	                            editor: "NumericTextBox",
	                            editorOptions: {
	                                format: "n0",
	                                min: 0
	                            },
	                            colSpan: 1
	                        }, {
	                            field: "measureW",
	                            editor: "DropDownList",
	                            attributes: { style: "max-width: 100px;" },
	                            label: { text: "&nbsp;", encoded: false },
	                            editorOptions: {
	                                dataTextField: "text",
	                                dataValueField: "value",
	                                dataSource: [
	                                    { text: resizeMessages.pixels || "Pixels", value: "pixels" },
	                                    { text: resizeMessages.percents || "Percents", value: "percents" }
	                                ]
	                            },
	                            colSpan: 1
	                        }, {
	                            label: commonMessages.height || "Height:",
	                            field: "height",
	                            attributes: { style: "max-width: 100px;" },
	                            editor: "NumericTextBox",
	                            editorOptions: {
	                                format: "n0",
	                                min: 0
	                            },
	                            colSpan: 1
	                        }, {
	                            field: "measureH",
	                            label: { text: "&nbsp;", encoded: false },
	                            attributes: { style: "max-width: 100px;" },
	                            editor: "DropDownList",
	                            editorOptions: {
	                                dataTextField: "text",
	                                dataValueField: "value",
	                                dataSource: [
	                                    { text: resizeMessages.pixels || "Pixels", value: "pixels" },
	                                    { text: resizeMessages.percents || "Percents", value: "percents" }
	                                ]
	                            },
	                            colSpan: 1
	                        }, {
	                            label: commonMessages.lockAspectRatio || "Lock aspect ratio",
	                            field: "lockAspectRatio",
	                            colSpan: 2
	                        }]
	                    }]
	                };
	            },
	            buildResizeModel: function () {
	                var that = this,
	                    imageeditor = that.imageeditor,
	                    canvas = imageeditor.getCanvasElement(),
	                    width = canvas.width,
	                    height = canvas.height;

	                    that._model = {
	                        width: width,
	                        height: height,
	                        measure: "pixels",
	                        measureW: "pixels",
	                        measureH: "pixels",
	                        lockAspectRatio: true,
	                        ratio: round(width/height)
	                    };
	            },
	            onChange: function (ev) {
	                var that = this,
	                    newModel = ev.sender._model,
	                    aspectRatioLocked = newModel.lockAspectRatio;

	                if (ev.field === "measureW" || ev.field === "measureH") {
	                    newModel.set("measureW", ev.value);
	                    newModel.set("measureH", ev.value);
	                    newModel.set("measure", ev.value);
	                } else if (ev.field === "measure") {
	                    that.resetNumericsTo(ev.value);
	                } else if (ev.field === "width" && aspectRatioLocked && !that._preventChange) {
	                    newModel.set("height", newModel.width / newModel.ratio);
	                } else if (ev.field === "height" && aspectRatioLocked && !that._preventChange) {
	                    newModel.set("width", newModel.height * newModel.ratio);
	                }

	                newModel.set("ratio", round(newModel.width/newModel.height));
	            },
	            resetNumericsTo: function (type) {
	                var that = this,
	                    originalWidth = that._model.width,
	                    originalHeight = that._model.height,
	                    formWidget = that.formWidget,
	                    model = formWidget._model,
	                    widthNumeric = formWidget.element.find("[name=width]").data("kendoNumericTextBox"),
	                    heightNumeric = formWidget.element.find("[name=height]").data("kendoNumericTextBox"),
	                    isPercent = type === "percents",
	                    options = {
	                        percents: {
	                            format: "#\\\%"
	                        },
	                        pixels: {
	                            format: "n0"
	                        }
	                    };



	                widthNumeric.setOptions(options[type]);
	                heightNumeric.setOptions(options[type]);

	                that._preventChange = true;
	                model.set("width", isPercent ? (originalWidth / widthNumeric.value()) * 100 : originalWidth * (widthNumeric.value() / 100));
	                model.set("height", isPercent ? (originalHeight / heightNumeric.value()) * 100 : originalHeight * (heightNumeric.value() / 100));
	                that._preventChange = false;
	            }
	        });

	        extend(kendo.ui.imageeditor, {
	            ImageEditorPane: Pane,
	            panes: {
	                crop: CropPane,
	                resize: ResizePane
	            }
	    });

	    })(window.kendo.jQuery);

	    return window.kendo;

	}, __webpack_require__(3));

/***/ }),

/***/ 1038:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("8Fbg");

/***/ }),

/***/ 1039:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("pYWG");

/***/ })

/******/ });

/***/ }),

/***/ "wIIu":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1286);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1078:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("qo2y");

/***/ }),

/***/ 1249:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("9fcU");

/***/ }),

/***/ 1286:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1059), __webpack_require__(1249), __webpack_require__(1078) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "listview",
	    name: "ListView",
	    category: "web",
	    description: "The ListView widget offers rich support for interacting with data.",
	    depends: [ "data" ],
	    features: [ {
	        id: "listview-editing",
	        name: "Editing",
	        description: "Support for record editing",
	        depends: [ "editable" ]
	    }, {
	        id: "listview-selection",
	        name: "Selection",
	        description: "Support for selection",
	        depends: [ "selectable" ]
	    } ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        CHANGE = "change",
	        KENDO_KEYDOWN = "kendoKeydown",
	        CANCEL = "cancel",
	        DATABOUND = "dataBound",
	        DATABINDING = "dataBinding",
	        Widget = kendo.ui.Widget,
	        keys = kendo.keys,
	        EMPTY_STRING = "",
	        FOCUSSELECTOR = "> *:not(.k-loading-mask)",
	        PROGRESS = "progress",
	        ERROR = "error",
	        FOCUSED = "k-state-focused",
	        SELECTED = "k-state-selected",
	        KEDITITEM = "k-edit-item",
	        EDIT = "edit",
	        REMOVE = "remove",
	        SAVE = "save",
	        MOUSEDOWN = "mousedown",
	        CLICK = "click",
	        TOUCHSTART = "touchstart",
	        NS = ".kendoListView",
	        proxy = $.proxy,
	        activeElement = kendo._activeElement,
	        progress = kendo.ui.progress,
	        DataSource = kendo.data.DataSource;

	    var ListView = kendo.ui.DataBoundWidget.extend( {
	        init: function(element, options) {
	            var that = this;

	            options = $.isArray(options) ? { dataSource: options } : options;

	            Widget.fn.init.call(that, element, options);

	            options = that.options;

	            that.wrapper = element = that.element;

	            if (element[0].id) {
	                that._itemId = element[0].id + "_lv_active";
	            }

	            that._element();

	            that._layout();

	            that._dataSource();

	            that._templates();

	            that._navigatable();

	            that._selectable();

	            that._pageable();

	            that._crudHandlers();

	            that._scrollable();

	            if (that.options.autoBind){
	                that.dataSource.fetch();
	            }

	            kendo.notify(that);
	        },

	        events: [
	            CHANGE,
	            CANCEL,
	            DATABINDING,
	            DATABOUND,
	            EDIT,
	            REMOVE,
	            SAVE,
	            KENDO_KEYDOWN
	        ],

	        options: {
	            name: "ListView",
	            autoBind: true,
	            selectable: false,
	            navigatable: false,
	            height: null,
	            template: EMPTY_STRING,
	            altTemplate: EMPTY_STRING,
	            editTemplate: EMPTY_STRING,
	            contentTemplate: "<div data-content='true' />",
	            contentElement: "div",
	            bordered: true,
	            borders: "",
	            layout: "",
	            flex: {
	                direction: "row",
	                wrap: "nowrap"
	            },
	            grid: {},
	            scrollable: false
	        },

	        setOptions: function(options) {
	            Widget.fn.setOptions.call(this, options);

	            this._layout();

	            this._templates();

	            if (this.selectable) {
	                this.selectable.destroy();
	                this.selectable = null;
	            }

	            this._selectable();
	        },

	        _templates: function() {
	            var options = this.options;

	            this.template = kendo.template(options.template || EMPTY_STRING);
	            this.altTemplate = kendo.template(options.altTemplate || options.template);
	            this.editTemplate = kendo.template(options.editTemplate || EMPTY_STRING);
	        },

	        _item: function(action) {
	            return this.content.children()[action]();
	        },

	        items: function() {
	            return this.content.children(":not(.k-loading-mask)");
	        },

	        dataItem: function(element) {
	            var attr = kendo.attr("uid");
	            var uid = $(element).closest("[" + attr + "]").attr(attr);

	            return this.dataSource.getByUid(uid);
	        },

	        setDataSource: function(dataSource) {
	            this.options.dataSource = dataSource;
	            this._dataSource();

	            if (this.options.autoBind) {
	                dataSource.fetch();
	            }

	            if (this.options.scrollable === "endless") {
	                this._bindScrollable();
	            }
	        },

	        _unbindDataSource: function() {
	            var that = this;

	            that.dataSource.unbind(CHANGE, that._refreshHandler)
	                            .unbind(PROGRESS, that._progressHandler)
	                            .unbind(ERROR, that._errorHandler);
	        },

	        _dataSource: function() {
	            var that = this;

	            if (that.dataSource && that._refreshHandler) {
	                that._unbindDataSource();
	            } else {
	                that._refreshHandler = proxy(that.refresh, that);
	                that._progressHandler = proxy(that._progress, that);
	                that._errorHandler = proxy(that._error, that);
	            }

	            that.dataSource = DataSource.create(that.options.dataSource)
	                                .bind(CHANGE, that._refreshHandler)
	                                .bind(PROGRESS, that._progressHandler)
	                                .bind(ERROR, that._errorHandler);
	        },

	        _progress: function(toggle) {
	            var element = this.content;
	            progress(element, toggle, { opacity: true});
	        },

	        _error: function() {
	            progress(this.content, false);
	        },

	        _element: function() {
	            var options = this.options;
	            var height = options.height;

	            this.element.addClass("k-widget k-listview");

	            if (options.navigatable || options.selectable) {
	                this.element.attr("role", "listbox");
	            } else {
	                this.element.attr("role", "list");
	            }

	            if (options.contentElement) {
	                this.content = $(document.createElement(options.contentElement)).appendTo(this.element);
	            } else {
	                this.content = this.element;
	            }

	            if (height) {
	                this.element.css("height", height);
	            }
	        },

	        _layout: function() {
	            var that = this;
	            var options = that.options;
	            var flex = options.flex;
	            var grid = options.grid;
	            var element = that.element;
	            var elementClassNames = ["k-widget", "k-listview"];
	            var content = that.content;
	            var contentClassNames = ["k-listview-content"];

	            element.add(content).removeClass(function (index, className) {
	                if (className.indexOf("k-") >= 0) {
	                    return true;
	                }
	            });

	            // Element class names
	            if (options.bordered === true) {
	                elementClassNames.push("k-listview-bordered");
	            }

	            if (typeof options.borders === "string" && options.borders !== EMPTY_STRING) {
	                elementClassNames.push("k-listview-borders-" + options.borders);
	            }


	            // Content class names
	            if (typeof options.contentPadding === "string" && options.contentPadding !== EMPTY_STRING) {
	                contentClassNames.push("k-listview-content-padding-" + options.contentPadding);
	            }

	            if (typeof options.layout === "string" && options.layout !== EMPTY_STRING) {
	                contentClassNames.push("k-d-" + options.layout);
	            }

	            if (options.layout === "flex" && typeof flex === "object") {
	                if (typeof flex.direction === "string" && flex.direction !== "") {
	                    contentClassNames.push("k-flex-" + flex.direction);
	                }

	                if (typeof flex.wrap === "string" && flex.wrap !== "") {
	                    contentClassNames.push("k-flex-" + flex.wrap);
	                }
	            }

	            if (options.layout === "grid" && typeof grid === "object") {
	                if (typeof grid.cols === "number") {
	                    content.css("grid-template-columns", "repeat(" + grid.cols + ", 1fr)");
	                } else if (typeof grid.cols === "string") {
	                    content.css("grid-template-columns", grid.cols);
	                }

	                if (typeof grid.rows === "number") {
	                    content.css("grid-template-rows", "repeat(" + grid.rows + ", " + (grid.rowHeight !== undefined ? grid.rowHeight : "1fr") + ")");
	                } else if (typeof grid.rows === "string") {
	                    content.css("grid-template-rows", grid.rows);
	                }

	                if (typeof grid.gutter === "number") {
	                    content.css("grid-gap", grid.gutter);
	                } else if (typeof grid.gutter === "string") {
	                    content.css("grid-gap", grid.gutter);
	                }
	            }

	            that.element.addClass(elementClassNames.join(" "));
	            that.content.addClass(contentClassNames.join(" "));

	        },

	        refresh: function(e) {
	            var that = this,
	                view = that.dataSource.view(),
	                data,
	                items,
	                item,
	                html = "",
	                idx,
	                length,
	                template = that.template,
	                altTemplate = that.altTemplate,
	                options = that.options,
	                role = (options.selectable || options.navigatable) ? "option" : "listitem",
	                active = activeElement(),
	                endlessAppend =  that._endlessFetchInProgress,
	                index = endlessAppend ? that._skipRerenderItemsCount : 0,
	                scrollable = that.options.scrollable;

	            e = e || {};

	            if (e.action === "itemchange") {
	                if (!that._hasBindingTarget() && !that.editable) {
	                    data = e.items[0];
	                    item = that.items().filter("[" + kendo.attr("uid") + "=" + data.uid + "]");

	                    if (item.length > 0) {
	                        idx = item.index();

	                        that.angular("cleanup", function() {
	                            return { elements: [ item ]};
	                        });

	                        item.replaceWith(template(data));
	                        item = that.items().eq(idx);
	                        item.attr(kendo.attr("uid"), data.uid);

	                        that.angular("compile", function() {
	                            return { elements: [ item ], data: [ { dataItem: data } ]};
	                        });

	                        that.trigger("itemChange", {
	                            item: item,
	                            data: data
	                        });
	                    }
	                }

	                return;
	            }

	            if (that.trigger(DATABINDING, { action: e.action || "rebind", items: e.items, index: e.index })) {
	                return;
	            }

	            that._angularItems("cleanup");

	            if (!endlessAppend) {
	                that._destroyEditable();
	            }

	            for (idx = index, length = view.length; idx < length; idx++) {
	                if (idx % 2) {
	                    html += altTemplate(view[idx]);
	                } else {
	                    html += template(view[idx]);
	                }
	            }

	            if (endlessAppend) {
	                that.content.append(html);
	            } else {
	                that.content.html(html);
	            }

	            items = that.items().not(".k-loading-mask");

	            for (idx = index, length = view.length; idx < length; idx++) {
	                item = items.eq(idx);
	                item.attr(kendo.attr("uid"), view[idx].uid)
	                    .attr("role", role);

	                if (that.options.selectable) {
	                    item.attr("aria-selected", "false");
	                }
	            }

	            if (that.content[0] === active && that.options.navigatable) {
	                if (that._focusNext) {
	                    that.current(that.current().next());
	                } else {
	                    if (!scrollable) {
	                        that.current(items.eq(0));
	                    }
	                }
	            }

	            that._angularItems("compile");

	            that._progress(false);
	            that._endlessFetchInProgress = null;

	            that.trigger(DATABOUND, { action: e.action || "rebind", items: e.items, index: e.index });
	        },

	        _pageable: function() {
	            var that = this,
	                pageable = that.options.pageable,
	                settings,
	                pagerId;

	            if ($.isPlainObject(pageable)) {
	                pagerId = pageable.pagerId;
	                settings = $.extend({}, pageable, {
	                    dataSource: that.dataSource,
	                    pagerId: null
	                });

	                that.pager = new kendo.ui.Pager($("#" + pagerId), settings);
	            }
	        },

	        _selectable: function() {
	            var that = this,
	                multi,
	                current,
	                selectable = that.options.selectable,
	                navigatable = that.options.navigatable;

	            if (selectable) {
	                multi = kendo.ui.Selectable.parseOptions(selectable).multiple;

	                that.selectable = new kendo.ui.Selectable(that.element, {
	                    aria: true,
	                    multiple: multi,
	                    filter: that.options.contentElement ? ".k-listview-content " + FOCUSSELECTOR : FOCUSSELECTOR,
	                    change: function() {
	                        that.trigger(CHANGE);
	                    }
	                });

	                if (navigatable) {
	                    that.element.on("keydown" + NS, function(e) {
	                        if (e.keyCode === keys.SPACEBAR) {
	                            current = that.current();

	                            if (e.target == e.currentTarget) {
	                                e.preventDefault();
	                            }

	                            if (multi) {
	                                if (!e.ctrlKey) {
	                                    that.selectable.clear();
	                                } else {
	                                    if (current && current.hasClass(SELECTED)) {
	                                        current.removeClass(SELECTED);
	                                        return;
	                                    }
	                                }
	                            } else {
	                                that.selectable.clear();
	                            }

	                            that.selectable.value(current);
	                        }
	                    });
	                }
	            }
	        },

	        _scrollable: function() {
	            var that = this;
	            var scrollable = that.options.scrollable;

	            if (scrollable) {

	                that.content.css({
	                    "overflow-y": "scroll",
	                    "position": "relative",
	                    "-webkit-overflow-scrolling": "touch"
	                });

	                if (scrollable === "endless") {
	                    that._bindScrollable();
	                }
	            }
	        },

	        _bindScrollable: function (){
	            var that = this;
	            var originalPageSize = that._endlessPageSize = that.dataSource.options.pageSize;

	            that.content
	                .off("scroll" + NS)
	                .on("scroll" + NS, function () {
	                    if (this.scrollTop + this.clientHeight - this.scrollHeight >= -15 &&
	                    !that._endlessFetchInProgress &&
	                    that._endlessPageSize < that.dataSource.total()) {
	                        that._skipRerenderItemsCount =  that._endlessPageSize;
	                        that._endlessPageSize = that._skipRerenderItemsCount  + originalPageSize;
	                        that.dataSource.options.endless = true;
	                        that._endlessFetchInProgress = true;
	                        that.dataSource.pageSize(that._endlessPageSize);
	                    }
	                });
	        },

	        current: function(candidate) {
	            var that = this,
	                element = that.element,
	                current = that._current,
	                id = that._itemId;

	            if (candidate === undefined) {
	                return current;
	            }

	            if (current && current[0]) {
	                if (current[0].id === id) {
	                    current.removeAttr("id");
	                }

	                current.removeClass(FOCUSED);
	                element.removeAttr("aria-activedescendant");
	            }

	            if (candidate && candidate[0]) {
	                id = candidate[0].id || id;

	                that._scrollTo(candidate[0]);

	                element.attr("aria-activedescendant", id);
	                candidate.addClass(FOCUSED).attr("id", id);
	            }

	            that._current = candidate;
	        },

	        _scrollTo: function(element) {
	            var that = this,
	                content = that.content,
	                container,
	                UseJQueryoffset = false,
	                SCROLL = "scroll";

	            if (content.css("overflow") === "auto" || content.css("overflow") === SCROLL || content.css("overflow-y") === SCROLL) {
	                container = content[0];
	            } else {
	                container = window;
	                UseJQueryoffset = true;
	            }

	            var scrollDirectionFunc = function(direction, dimension) {

	                var elementOffset = UseJQueryoffset ? $(element).offset()[direction.toLowerCase()] : element["offset" + direction],
	                    elementDimension = element["client" + dimension],
	                    containerScrollAmount = $(container)[SCROLL + direction](),
	                    containerDimension = $(container)[dimension.toLowerCase()]();

	                if (elementOffset + elementDimension > containerScrollAmount + containerDimension) {
	                    $(container)[SCROLL + direction](elementOffset + elementDimension - containerDimension);
	                } else if (elementOffset < containerScrollAmount) {
	                    $(container)[SCROLL + direction](elementOffset);
	                }
	            };

	            scrollDirectionFunc("Top", "Height");
	            scrollDirectionFunc("Left", "Width");
	        },

	        _navigatable: function() {
	            var that = this,
	                navigatable = that.options.navigatable,
	                element = that.element,
	                content = that.content,
	                clickCallback = function(e) {
	                    that.current($(e.currentTarget));
	                    if (!$(e.target).is(":button, a, :input, a > .k-icon, textarea")) {
	                        kendo.focusElement(element);
	                    }
	                };

	            if (navigatable) {
	                that._tabindex();

	                element
	                    .on("focus" + NS, function() {
	                        var current = that._current;

	                        if (!current || !current.is(":visible")) {
	                            current = that._item("first");
	                        }

	                        that.current(current);
	                    })
	                    .on("focusout" + NS, function() {
	                        if (that._current) {
	                            that._current.removeClass(FOCUSED);
	                        }
	                    })
	                    .on("keydown" + NS, that, function(e) {
	                        var key = e.keyCode,
	                            current = that.current(),
	                            target = $(e.target),
	                            canHandle = !target.is(":button, textarea, a, a > .t-icon, input"),
	                            isTextBox = target.is(":text, :password"),
	                            preventDefault = kendo.preventDefault,
	                            editItem = content.find("." + KEDITITEM),
	                            active = activeElement(), idx,
	                            scrollable = that.options.scrollable;

	                        if ((!canHandle && !isTextBox && key !== keys.ESC) || (isTextBox && key !== keys.ESC && key !== keys.ENTER)) {
	                            return;
	                        }

	                        if (key === keys.UP || key === keys.LEFT) {
	                            if (current && current[0]) {
	                                current = current.prev();
	                            }

	                            if (current && current[0]) {
	                                that.current(current);
	                            }
	                            else if (!scrollable) {
	                                that.current(that._item("last"));
	                            }
	                            preventDefault(e);
	                        }

	                        if (key === keys.DOWN || key === keys.RIGHT) {
	                            if (scrollable) {
	                                if (that.options.scrollable === "endless" && !current.next().length) {
	                                    that.content[0].scrollTop = that.content[0].scrollHeight;
	                                    that._focusNext = true;
	                                } else {
	                                    current = current.next();

	                                    if (current && current[0]) {
	                                        that.current(current);
	                                    }
	                                }
	                            }
	                            else {
	                                current = current.next();
	                                that.current(!current || !current[0] ? that._item("first") : current);
	                            }
	                            preventDefault(e);
	                        }

	                        if (key === keys.PAGEUP) {
	                            that.current(null);
	                            that.dataSource.page(that.dataSource.page() - 1);
	                            preventDefault(e);
	                        }

	                        if (key === keys.PAGEDOWN) {
	                            that.current(null);
	                            that.dataSource.page(that.dataSource.page() + 1);
	                            preventDefault(e);
	                        }

	                        if (key === keys.HOME) {
	                            that.current(that._item("first"));
	                            preventDefault(e);
	                        }

	                        if (key === keys.END) {
	                            that.current(that._item("last"));
	                            preventDefault(e);
	                        }

	                        if (key === keys.ENTER) {
	                            if (editItem.length !== 0 && (canHandle || isTextBox)) {
	                                idx = that.items().index(editItem);

	                                if (active) {
	                                    active.blur();
	                                }

	                                that.save();

	                                var focusAgain = function(){
	                                    that.element.trigger("focus");
	                                    that.current(that.items().eq(idx));
	                                };

	                                that.one("dataBound", focusAgain);
	                            } else if (that.options.editTemplate !== "") {
	                                that.edit(current);
	                            }
	                        }

	                        if (key === keys.ESC) {
	                            editItem = content.find("." + KEDITITEM);

	                            if (editItem.length === 0) {
	                                return;
	                            }

	                            idx = that.items().index(editItem);
	                            that.cancel();
	                            that.element.trigger("focus");
	                            that.current(that.items().eq(idx));
	                        }
	                    });

	                element.on(MOUSEDOWN + NS + " " + TOUCHSTART + NS, that.options.contentElement ? ".k-listview-content " + FOCUSSELECTOR : FOCUSSELECTOR, proxy(clickCallback, that));
	            }
	        },

	        clearSelection: function() {
	            var that = this;
	            that.selectable.clear();
	            that.trigger(CHANGE);
	        },

	        select: function(items) {
	            var that = this,
	                selectable = that.selectable;

	            items = $(items);

	            if (items.length) {
	                if (!selectable.options.multiple) {
	                    selectable.clear();
	                    items = items.first();
	                }
	                selectable.value(items);
	                return;
	            }

	            return selectable.value();
	        },

	        _destroyEditable: function() {
	            var that = this;
	            if (that.editable) {
	                that.editable.destroy();
	                delete that.editable;
	            }
	        },

	        _modelFromElement: function(element) {
	            var uid = element.attr(kendo.attr("uid"));

	            return this.dataSource.getByUid(uid);
	        },

	        _closeEditable: function() {
	            var that = this,
	                editable = that.editable,
	                options = that.options,
	                role = (options.selectable || options.navigatable) ? "option" : "listitem",
	                data,
	                item,
	                index,
	                template = that.template;

	            if (editable) {
	                if (editable.element.index() % 2) {
	                    template = that.altTemplate;
	                }

	                that.angular("cleanup", function() {
	                    return { elements: [ editable.element ]};
	                });

	                data = that._modelFromElement(editable.element);
	                that._destroyEditable();

	                index = editable.element.index();
	                editable.element.replaceWith(template(data));
	                item = that.items().eq(index);
	                item.attr(kendo.attr("uid"), data.uid);
	                item.attr("role", role);

	                if (that._hasBindingTarget()) {
	                    kendo.bind(item, data);
	                }

	                that.angular("compile", function() {
	                    return { elements: [ item ], data: [ { dataItem: data } ]};
	                });
	            }
	            return true;
	        },

	        edit: function(item) {
	            var that = this,
	                data = that._modelFromElement(item),
	                container,
	                uid = data.uid,
	                index;

	            that.cancel();

	            item = that.items().filter("[" + kendo.attr("uid") + "=" + uid + "]");
	            index = item.index();
	            item.replaceWith(that.editTemplate(data));
	            container = that.items().eq(index).addClass(KEDITITEM).attr(kendo.attr("uid"), data.uid);
	            that.editable = container.kendoEditable({
	                model: data,
	                clearContainer: false,
	                errorTemplate: false,
	                target: that
	            }).data("kendoEditable");

	            that.trigger(EDIT, { model: data, item: container });
	        },

	        save: function() {
	            var that = this,
	                editable = that.editable,
	                model;

	            if (!editable) {
	                return;
	            }

	            var container = editable.element;
	            model = that._modelFromElement(container);

	            if (editable.end() && !that.trigger(SAVE, { model: model, item: container }))  {
	                that._closeEditable();
	                that.dataSource.sync();
	            }
	        },

	        remove: function(item) {
	            var that = this,
	                dataSource = that.dataSource,
	                data = that._modelFromElement(item);

	            if (that.editable) {
	                dataSource.cancelChanges(that._modelFromElement(that.editable.element));
	                that._closeEditable();
	            }

	            if (!that.trigger(REMOVE, { model: data, item: item })) {
	                item.hide();
	                dataSource.remove(data);
	                dataSource.sync();
	            }
	        },

	        add: function() {
	            var that = this,
	                dataItem,
	                dataSource = that.dataSource,
	                index = dataSource.indexOf((dataSource.view() || [])[0]);

	            if (index < 0) {
	                index = 0;
	            }

	            that.cancel();
	            dataItem = dataSource.insert(index, {});
	            that.edit(that.element.find("[data-uid='" + dataItem.uid + "']"));
	        },

	        cancel: function() {
	            var that = this,
	                dataSource = that.dataSource;

	            if (that.editable) {
	                var container = that.editable.element;
	                var model = that._modelFromElement(container);

	                if (!that.trigger(CANCEL, { model: model, container: container})) {
	                    dataSource.cancelChanges(model);
	                    that._closeEditable();
	                }
	            }
	        },

	        _crudHandlers: function() {
	            var that = this,
	                mousedownNs = MOUSEDOWN + NS,
	                touchstartNs = TOUCHSTART + NS,
	                clickNs = CLICK + NS;

	            that.content.on(mousedownNs + " " + touchstartNs, ".k-edit-button", function(e) {
	                e.preventDefault();
	                var item = $(this).closest("[" + kendo.attr("uid") + "]");
	                setTimeout(function() {
	                    that.edit(item);
	                });
	            });


	            that.content.on(mousedownNs + " " + touchstartNs, ".k-delete-button", function(e) {
	                e.preventDefault();
	                var item = $(this).closest("[" + kendo.attr("uid") + "]");
	                 setTimeout(function() {
	                    that.remove(item);
	                 });
	            });

	            that.content.on(clickNs, ".k-update-button", function(e) {
	                that.save();
	                e.preventDefault();
	            });

	            that.content.on(clickNs, ".k-cancel-button", function(e) {
	                that.cancel();
	                e.preventDefault();
	            });
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            that._unbindDataSource();

	            that._destroyEditable();

	            that.element.off(NS);
	            that.content.off(NS);

	            that._endlessFetchInProgress = that._endlessPageSize = that._skipRerenderItemsCount = that._focusNext = null;

	            if (that.pager) {
	                that.pager.destroy();
	            }

	            kendo.destroy(that.element);
	        }
	    });

	    kendo.ui.plugin(ListView);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "wTNE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var column_1 = __webpack_require__("hDyE");
var rowNode_1 = __webpack_require__("bP2e");
var constants_1 = __webpack_require__("ZZFX");
var events_1 = __webpack_require__("3ok8");
var gridCell_1 = __webpack_require__("hie4");
var component_1 = __webpack_require__("pQ38");
var checkboxSelectionComponent_1 = __webpack_require__("B21I");
var rowDragComp_1 = __webpack_require__("zO4I");
var CellComp = (function (_super) {
    __extends(CellComp, _super);
    function CellComp(scope, beans, column, rowNode, rowComp) {
        var _this = _super.call(this) || this;
        _this.editingCell = false;
        // every time we go into edit mode, or back again, this gets incremented.
        // it's the components way of dealing with the async nature of framework components,
        // so if a framework component takes a while to be created, we know if the object
        // is still relevant when creating is finished. eg we could click edit / unedit 20
        // times before the first React edit component comes back - we should discard
        // the first 19.
        _this.cellEditorVersion = 0;
        _this.cellRendererVersion = 0;
        _this.scope = scope;
        _this.beans = beans;
        _this.column = column;
        _this.rowNode = rowNode;
        _this.rowComp = rowComp;
        _this.createGridCellVo();
        _this.rangeSelectionEnabled = beans.enterprise && beans.gridOptionsWrapper.isEnableRangeSelection();
        _this.cellFocused = _this.beans.focusedCellController.isCellFocused(_this.gridCell);
        _this.firstRightPinned = _this.column.isFirstRightPinned();
        _this.lastLeftPinned = _this.column.isLastLeftPinned();
        if (_this.rangeSelectionEnabled) {
            _this.rangeCount = _this.beans.rangeController.getCellRangeCount(_this.gridCell);
        }
        _this.getValueAndFormat();
        _this.setUsingWrapper();
        _this.chooseCellRenderer();
        _this.setupColSpan();
        return _this;
    }
    CellComp.prototype.getCreateTemplate = function () {
        var templateParts = [];
        var col = this.column;
        var width = this.getCellWidth();
        var left = col.getLeft();
        var valueToRender = this.getInitialValueToRender();
        var valueSanitised = utils_1._.get(this.column, 'colDef.template', null) ? valueToRender : utils_1._.escape(valueToRender);
        var tooltip = this.getToolTip();
        var tooltipSanitised = utils_1._.escape(tooltip);
        var colIdSanitised = utils_1._.escape(col.getId());
        var wrapperStartTemplate;
        var wrapperEndTemplate;
        var stylesFromColDef = this.preProcessStylesFromColDef();
        var cssClasses = this.getInitialCssClasses();
        if (this.usingWrapper) {
            wrapperStartTemplate = '<span ref="eCellWrapper" class="ag-cell-wrapper"><span ref="eCellValue" class="ag-cell-value">';
            wrapperEndTemplate = '</span></span>';
        }
        // hey, this looks like React!!!
        templateParts.push("<div");
        templateParts.push(" tabindex=\"-1\"");
        templateParts.push(" role=\"gridcell\"");
        templateParts.push(" comp-id=\"" + this.getCompId() + "\" ");
        templateParts.push(" col-id=\"" + colIdSanitised + "\"");
        templateParts.push(" class=\"" + cssClasses.join(' ') + "\"");
        templateParts.push(tooltipSanitised ? " title=\"" + tooltipSanitised + "\"" : "");
        templateParts.push(" style=\"width: " + width + "px; left: " + left + "px; " + stylesFromColDef + "\" >");
        templateParts.push(wrapperStartTemplate);
        templateParts.push(valueSanitised);
        templateParts.push(wrapperEndTemplate);
        templateParts.push("</div>");
        return templateParts.join('');
    };
    CellComp.prototype.afterAttached = function () {
        var querySelector = "[comp-id=\"" + this.getCompId() + "\"]";
        var eGui = this.eParentRow.querySelector(querySelector);
        this.setGui(eGui);
        // all of these have dependencies on the eGui, so only do them after eGui is set
        this.addDomData();
        this.populateTemplate();
        this.attachCellRenderer();
        this.angular1Compile();
        this.addDestroyableEventListener(this.beans.eventService, events_1.Events.EVENT_CELL_FOCUSED, this.onCellFocused.bind(this));
        this.addDestroyableEventListener(this.beans.eventService, events_1.Events.EVENT_FLASH_CELLS, this.onFlashCells.bind(this));
        this.addDestroyableEventListener(this.beans.eventService, events_1.Events.EVENT_COLUMN_HOVER_CHANGED, this.onColumnHover.bind(this));
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_ROW_INDEX_CHANGED, this.onRowIndexChanged.bind(this));
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_CELL_CHANGED, this.onCellChanged.bind(this));
        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_LEFT_CHANGED, this.onLeftChanged.bind(this));
        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_WIDTH_CHANGED, this.onWidthChanged.bind(this));
        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_FIRST_RIGHT_PINNED_CHANGED, this.onFirstRightPinnedChanged.bind(this));
        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_LAST_LEFT_PINNED_CHANGED, this.onLastLeftPinnedChanged.bind(this));
        // if not doing enterprise, then range selection service would be missing
        // so need to check before trying to use it
        if (this.rangeSelectionEnabled) {
            this.addDestroyableEventListener(this.beans.eventService, events_1.Events.EVENT_RANGE_SELECTION_CHANGED, this.onRangeSelectionChanged.bind(this));
        }
    };
    CellComp.prototype.onColumnHover = function () {
        var isHovered = this.beans.columnHoverService.isHovered(this.column);
        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-column-hover', isHovered);
    };
    CellComp.prototype.onCellChanged = function (event) {
        var eventImpactsThisCell = event.column === this.column;
        if (eventImpactsThisCell) {
            this.refreshCell({});
        }
    };
    CellComp.prototype.getCellLeft = function () {
        var mostLeftCol;
        if (this.beans.gridOptionsWrapper.isEnableRtl() && this.colsSpanning) {
            mostLeftCol = this.colsSpanning[this.colsSpanning.length - 1];
        }
        else {
            mostLeftCol = this.column;
        }
        return mostLeftCol.getLeft();
    };
    CellComp.prototype.getCellWidth = function () {
        if (this.colsSpanning) {
            var result_1 = 0;
            this.colsSpanning.forEach(function (col) { return result_1 += col.getActualWidth(); });
            return result_1;
        }
        else {
            return this.column.getActualWidth();
        }
    };
    CellComp.prototype.onFlashCells = function (event) {
        var cellId = this.gridCell.createId();
        var shouldFlash = event.cells[cellId];
        if (shouldFlash) {
            this.animateCell('highlight');
        }
    };
    CellComp.prototype.setupColSpan = function () {
        // if no col span is active, then we don't set it up, as it would be wasteful of CPU
        if (utils_1._.missing(this.column.getColDef().colSpan)) {
            return;
        }
        // because we are col spanning, a reorder of the cols can change what cols we are spanning over
        this.addDestroyableEventListener(this.beans.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayColumnsChanged.bind(this));
        // because we are spanning over multiple cols, we check for width any time any cols width changes.
        // this is expensive - really we should be explicitly checking only the cols we are spanning over
        // instead of every col, however it would be tricky code to track the cols we are spanning over, so
        // because hardly anyone will be using colSpan, am favoring this easier way for more maintainable code.
        this.addDestroyableEventListener(this.beans.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onWidthChanged.bind(this));
        this.colsSpanning = this.getColSpanningList();
    };
    CellComp.prototype.getColSpanningList = function () {
        var colSpan = this.column.getColSpan(this.rowNode);
        var colsSpanning = [];
        // if just one col, the col span is just the column we are in
        if (colSpan === 1) {
            colsSpanning.push(this.column);
        }
        else {
            var pointer = this.column;
            var pinned = this.column.getPinned();
            for (var i = 0; i < colSpan; i++) {
                colsSpanning.push(pointer);
                pointer = this.beans.columnController.getDisplayedColAfter(pointer);
                if (utils_1._.missing(pointer)) {
                    break;
                }
                // we do not allow col spanning to span outside of pinned areas
                if (pinned !== pointer.getPinned()) {
                    break;
                }
            }
        }
        return colsSpanning;
    };
    CellComp.prototype.onDisplayColumnsChanged = function () {
        var colsSpanning = this.getColSpanningList();
        if (!utils_1._.compareArrays(this.colsSpanning, colsSpanning)) {
            this.colsSpanning = colsSpanning;
            this.onWidthChanged();
            this.onLeftChanged(); // left changes when doing RTL
        }
    };
    CellComp.prototype.getInitialCssClasses = function () {
        var cssClasses = ["ag-cell", "ag-cell-not-inline-editing"];
        cssClasses.push(this.cellFocused ? 'ag-cell-focus' : 'ag-cell-no-focus');
        if (this.firstRightPinned) {
            cssClasses.push('ag-cell-first-right-pinned');
        }
        if (this.lastLeftPinned) {
            cssClasses.push('ag-cell-last-left-pinned');
        }
        if (this.beans.columnHoverService.isHovered(this.column)) {
            cssClasses.push('ag-column-hover');
        }
        utils_1._.pushAll(cssClasses, this.preProcessClassesFromColDef());
        utils_1._.pushAll(cssClasses, this.preProcessCellClassRules());
        utils_1._.pushAll(cssClasses, this.getRangeClasses());
        // if using the wrapper, this class goes on the wrapper instead
        if (!this.usingWrapper) {
            cssClasses.push('ag-cell-value');
        }
        return cssClasses;
    };
    CellComp.prototype.getInitialValueToRender = function () {
        // if using a cellRenderer, then render the html from the cell renderer if it exists
        if (this.usingCellRenderer) {
            if (typeof this.cellRendererGui === 'string') {
                return this.cellRendererGui;
            }
            else {
                return '';
            }
        }
        var colDef = this.column.getColDef();
        if (colDef.template) {
            // template is really only used for angular 1 - as people using ng1 are used to providing templates with
            // bindings in it. in ng2, people will hopefully want to provide components, not templates.
            return colDef.template;
        }
        else if (colDef.templateUrl) {
            // likewise for templateUrl - it's for ng1 really - when we move away from ng1, we can take these out.
            // niall was pro angular 1 when writing template and templateUrl, if writing from scratch now, would
            // not do these, but would follow a pattern that was friendly towards components, not templates.
            var template = this.beans.templateService.getTemplate(colDef.templateUrl, this.refreshCell.bind(this, true));
            if (template) {
                return template;
            }
            else {
                return '';
            }
        }
        else {
            return this.getValueToUse();
        }
    };
    CellComp.prototype.getRenderedRow = function () {
        return this.rowComp;
    };
    CellComp.prototype.isSuppressNavigable = function () {
        return this.column.isSuppressNavigable(this.rowNode);
    };
    // + stop editing {forceRefresh: true, suppressFlash: true}
    // + event cellChanged {}
    // + cellRenderer.params.refresh() {} -> method passes 'as is' to the cellRenderer, so params could be anything
    // + rowComp: event dataChanged {animate: update, newData: !update}
    // + rowComp: api refreshCells() {animate: true/false}
    // + rowRenderer: api softRefreshView() {}
    CellComp.prototype.refreshCell = function (params) {
        if (this.editingCell) {
            return;
        }
        var newData = params && params.newData;
        var suppressFlash = params && params.suppressFlash;
        var forceRefresh = params && params.forceRefresh;
        var oldValue = this.value;
        this.getValueAndFormat();
        // for simple values only (not pojo's), see if the value is the same, and if it is, skip the refresh.
        // when never allow skipping after an edit, as after editing, we need to put the GUI back to the way
        // if was before the edit.
        var valuesDifferent = !this.valuesAreEqual(oldValue, this.value);
        var dataNeedsUpdating = forceRefresh || valuesDifferent;
        if (dataNeedsUpdating) {
            var cellRendererRefreshed = void 0;
            // if it's 'new data', then we don't refresh the cellRenderer, even if refresh method is available.
            // this is because if the whole data is new (ie we are showing stock price 'BBA' now and not 'SSD')
            // then we are not showing a movement in the stock price, rather we are showing different stock.
            if (newData || suppressFlash) {
                cellRendererRefreshed = false;
            }
            else {
                cellRendererRefreshed = this.attemptCellRendererRefresh();
            }
            // we do the replace if not doing refresh, or if refresh was unsuccessful.
            // the refresh can be unsuccessful if we are using a framework (eg ng2 or react) and the framework
            // wrapper has the refresh method, but the underlying component doesn't
            if (!cellRendererRefreshed) {
                this.replaceContentsAfterRefresh();
            }
            this.refreshToolTip();
            if (!suppressFlash) {
                this.flashCell();
            }
            // need to check rules. note, we ignore colDef classes and styles, these are assumed to be static
            this.postProcessStylesFromColDef();
            this.postProcessClassesFromColDef();
        }
        // we do cellClassRules even if the value has not changed, so that users who have rules that
        // look at other parts of the row (where the other part of the row might of changed) will work.
        this.postProcessCellClassRules();
    };
    CellComp.prototype.flashCell = function () {
        if (this.beans.gridOptionsWrapper.isEnableCellChangeFlash() || this.column.getColDef().enableCellChangeFlash) {
            this.animateCell('data-changed');
        }
    };
    CellComp.prototype.animateCell = function (cssName) {
        var fullName = 'ag-cell-' + cssName;
        var animationFullName = 'ag-cell-' + cssName + '-animation';
        var element = this.getGui();
        // we want to highlight the cells, without any animation
        utils_1._.addCssClass(element, fullName);
        utils_1._.removeCssClass(element, animationFullName);
        // then once that is applied, we remove the highlight with animation
        setTimeout(function () {
            utils_1._.removeCssClass(element, fullName);
            utils_1._.addCssClass(element, animationFullName);
            setTimeout(function () {
                // and then to leave things as we got them, we remove the animation
                utils_1._.removeCssClass(element, animationFullName);
            }, 1000);
        }, 500);
    };
    CellComp.prototype.replaceContentsAfterRefresh = function () {
        // otherwise we rip out the cell and replace it
        utils_1._.removeAllChildren(this.eParentOfValue);
        // remove old renderer component if it exists
        if (this.cellRenderer && this.cellRenderer.destroy) {
            this.cellRenderer.destroy();
        }
        this.cellRenderer = null;
        this.cellRendererGui = null;
        // populate
        this.putDataIntoCellAfterRefresh();
        this.angular1Compile();
    };
    CellComp.prototype.angular1Compile = function () {
        // if angular compiling, then need to also compile the cell again (angular compiling sucks, please wait...)
        if (this.beans.gridOptionsWrapper.isAngularCompileRows()) {
            var eGui = this.getGui();
            this.beans.$compile(eGui)(this.scope);
        }
    };
    CellComp.prototype.postProcessStylesFromColDef = function () {
        var stylesToUse = this.processStylesFromColDef();
        if (stylesToUse) {
            utils_1._.addStylesToElement(this.getGui(), stylesToUse);
        }
    };
    CellComp.prototype.preProcessStylesFromColDef = function () {
        var stylesToUse = this.processStylesFromColDef();
        return utils_1._.cssStyleObjectToMarkup(stylesToUse);
    };
    CellComp.prototype.processStylesFromColDef = function () {
        var colDef = this.column.getColDef();
        if (colDef.cellStyle) {
            var cssToUse = void 0;
            if (typeof colDef.cellStyle === 'function') {
                var cellStyleParams = {
                    value: this.value,
                    data: this.rowNode.data,
                    node: this.rowNode,
                    colDef: colDef,
                    column: this.column,
                    $scope: this.scope,
                    context: this.beans.gridOptionsWrapper.getContext(),
                    api: this.beans.gridOptionsWrapper.getApi()
                };
                var cellStyleFunc = colDef.cellStyle;
                cssToUse = cellStyleFunc(cellStyleParams);
            }
            else {
                cssToUse = colDef.cellStyle;
            }
            return cssToUse;
        }
    };
    CellComp.prototype.postProcessClassesFromColDef = function () {
        var _this = this;
        this.processClassesFromColDef(function (className) { return utils_1._.addCssClass(_this.getGui(), className); });
    };
    CellComp.prototype.preProcessClassesFromColDef = function () {
        var res = [];
        this.processClassesFromColDef(function (className) { return res.push(className); });
        return res;
    };
    CellComp.prototype.processClassesFromColDef = function (onApplicableClass) {
        this.beans.stylingService.processStaticCellClasses(this.column.getColDef(), {
            value: this.value,
            data: this.rowNode.data,
            node: this.rowNode,
            colDef: this.column.getColDef(),
            rowIndex: this.rowNode.rowIndex,
            $scope: this.scope,
            api: this.beans.gridOptionsWrapper.getApi(),
            context: this.beans.gridOptionsWrapper.getContext()
        }, onApplicableClass);
    };
    CellComp.prototype.putDataIntoCellAfterRefresh = function () {
        // template gets preference, then cellRenderer, then do it ourselves
        var colDef = this.column.getColDef();
        if (colDef.template) {
            // template is really only used for angular 1 - as people using ng1 are used to providing templates with
            // bindings in it. in ng2, people will hopefully want to provide components, not templates.
            this.eParentOfValue.innerHTML = colDef.template;
        }
        else if (colDef.templateUrl) {
            // likewise for templateUrl - it's for ng1 really - when we move away from ng1, we can take these out.
            // niall was pro angular 1 when writing template and templateUrl, if writing from scratch now, would
            // not do these, but would follow a pattern that was friendly towards components, not templates.
            var template = this.beans.templateService.getTemplate(colDef.templateUrl, this.refreshCell.bind(this, true));
            if (template) {
                this.eParentOfValue.innerHTML = template;
            }
            // use cell renderer if it exists
        }
        else if (this.usingCellRenderer) {
            this.attachCellRenderer();
        }
        else {
            var valueToUse = this.getValueToUse();
            if (valueToUse !== null && valueToUse !== undefined) {
                this.eParentOfValue.innerText = valueToUse;
            }
        }
    };
    CellComp.prototype.attemptCellRendererRefresh = function () {
        if (utils_1._.missing(this.cellRenderer) || utils_1._.missing(this.cellRenderer.refresh)) {
            return false;
        }
        // if the cell renderer has a refresh method, we call this instead of doing a refresh
        // note: should pass in params here instead of value?? so that client has formattedValue
        var params = this.createCellRendererParams();
        var result = this.cellRenderer.refresh(params);
        // NOTE on undefined: previous version of the cellRenderer.refresh() interface
        // returned nothing, if the method existed, we assumed it refreshed. so for
        // backwards compatibility, we assume if method exists and returns nothing,
        // that it was successful.
        return result === true || result === undefined;
    };
    CellComp.prototype.refreshToolTip = function () {
        var tooltip = this.getToolTip();
        if (utils_1._.exists(tooltip)) {
            this.eParentOfValue.setAttribute('title', tooltip);
        }
        else {
            this.eParentOfValue.removeAttribute('title');
        }
    };
    CellComp.prototype.valuesAreEqual = function (val1, val2) {
        // if the user provided an equals method, use that, otherwise do simple comparison
        var colDef = this.column.getColDef();
        var equalsMethod = colDef ? colDef.equals : null;
        if (equalsMethod) {
            return equalsMethod(val1, val2);
        }
        else {
            return val1 === val2;
        }
    };
    CellComp.prototype.getToolTip = function () {
        var colDef = this.column.getColDef();
        var data = this.rowNode.data;
        if (colDef.tooltipField && utils_1._.exists(data)) {
            return utils_1._.getValueUsingField(data, colDef.tooltipField, this.column.isTooltipFieldContainsDots());
        }
        else if (colDef.tooltip) {
            return colDef.tooltip({
                value: this.value,
                valueFormatted: this.valueFormatted,
                data: this.rowNode.data,
                node: this.rowNode,
                colDef: this.column.getColDef(),
                api: this.beans.gridOptionsWrapper.getApi(),
                $scope: this.scope,
                context: this.beans.gridOptionsWrapper.getContext(),
                rowIndex: this.gridCell.rowIndex
            });
        }
        else {
            return null;
        }
    };
    CellComp.prototype.processCellClassRules = function (onApplicableClass, onNotApplicableClass) {
        this.beans.stylingService.processClassRules(this.column.getColDef().cellClassRules, {
            value: this.value,
            data: this.rowNode.data,
            node: this.rowNode,
            colDef: this.column.getColDef(),
            rowIndex: this.gridCell.rowIndex,
            api: this.beans.gridOptionsWrapper.getApi(),
            $scope: this.scope,
            context: this.beans.gridOptionsWrapper.getContext()
        }, onApplicableClass, onNotApplicableClass);
    };
    CellComp.prototype.postProcessCellClassRules = function () {
        var _this = this;
        this.processCellClassRules(function (className) {
            utils_1._.addCssClass(_this.getGui(), className);
        }, function (className) {
            utils_1._.removeCssClass(_this.getGui(), className);
        });
    };
    CellComp.prototype.preProcessCellClassRules = function () {
        var res = [];
        this.processCellClassRules(function (className) {
            res.push(className);
        }, function (className) {
            // not catered for, if creating, no need
            // to remove class as it was never there
        });
        return res;
    };
    // a wrapper is used when we are putting a selection checkbox in the cell with the value
    CellComp.prototype.setUsingWrapper = function () {
        var colDef = this.column.getColDef();
        // never allow selection or dragging on pinned rows
        if (this.rowNode.rowPinned) {
            this.usingWrapper = false;
            this.includeSelectionComponent = false;
            this.includeRowDraggingComponent = false;
            return;
        }
        var cbSelectionIsFunc = typeof colDef.checkboxSelection === 'function';
        var rowDraggableIsFunc = typeof colDef.rowDrag === 'function';
        this.includeSelectionComponent = cbSelectionIsFunc || colDef.checkboxSelection === true;
        this.includeRowDraggingComponent = rowDraggableIsFunc || colDef.rowDrag === true;
        this.usingWrapper = this.includeRowDraggingComponent || this.includeSelectionComponent;
    };
    CellComp.prototype.chooseCellRenderer = function () {
        // template gets preference, then cellRenderer, then do it ourselves
        var colDef = this.column.getColDef();
        // templates are for ng1, ideally we wouldn't have these, they are ng1 support
        // inside the core which is bad
        if (colDef.template || colDef.templateUrl) {
            this.usingCellRenderer = false;
            return;
        }
        var params = this.createCellRendererParams();
        var cellRenderer = this.beans.componentResolver.getComponentToUse(colDef, 'cellRenderer', params, null);
        var pinnedRowCellRenderer = this.beans.componentResolver.getComponentToUse(colDef, 'pinnedRowCellRenderer', params, null);
        if (pinnedRowCellRenderer && this.rowNode.rowPinned) {
            this.cellRendererType = 'pinnedRowCellRenderer';
            this.usingCellRenderer = true;
        }
        else if (cellRenderer) {
            this.cellRendererType = 'cellRenderer';
            this.usingCellRenderer = true;
        }
        else {
            this.usingCellRenderer = false;
        }
    };
    CellComp.prototype.createCellRendererInstance = function () {
        var params = this.createCellRendererParams();
        this.cellRendererVersion++;
        var callback = this.afterCellRendererCreated.bind(this, this.cellRendererVersion);
        this.beans.componentResolver.createAgGridComponent(this.column.getColDef(), params, this.cellRendererType, params, null).then(callback);
    };
    CellComp.prototype.afterCellRendererCreated = function (cellRendererVersion, cellRenderer) {
        // see if daemon
        if (cellRendererVersion !== this.cellRendererVersion) {
            if (cellRenderer.destroy) {
                cellRenderer.destroy();
            }
            return;
        }
        this.cellRenderer = cellRenderer;
        this.cellRendererGui = this.cellRenderer.getGui();
        if (utils_1._.missing(this.cellRendererGui)) {
            return;
        }
        // if async components, then it's possible the user started editing since
        // this call was made
        if (!this.editingCell) {
            this.eParentOfValue.appendChild(this.cellRendererGui);
        }
    };
    CellComp.prototype.attachCellRenderer = function () {
        if (!this.usingCellRenderer) {
            return;
        }
        this.createCellRendererInstance();
    };
    CellComp.prototype.createCellRendererParams = function () {
        var _this = this;
        var params = {
            value: this.value,
            valueFormatted: this.valueFormatted,
            getValue: this.getValue.bind(this),
            setValue: function (value) {
                _this.beans.valueService.setValue(_this.rowNode, _this.column, value);
            },
            formatValue: this.formatValue.bind(this),
            data: this.rowNode.data,
            node: this.rowNode,
            colDef: this.column.getColDef(),
            column: this.column,
            $scope: this.scope,
            rowIndex: this.gridCell.rowIndex,
            api: this.beans.gridOptionsWrapper.getApi(),
            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
            context: this.beans.gridOptionsWrapper.getContext(),
            refreshCell: this.refreshCell.bind(this),
            eGridCell: this.getGui(),
            eParentOfValue: this.eParentOfValue,
            // these bits are not documented anywhere, so we could drop them?
            // it was in the olden days to allow user to register for when rendered
            // row was removed (the row comp was removed), however now that the user
            // can provide components for cells, the destroy method gets call when this
            // happens so no longer need to fire event.
            addRowCompListener: this.rowComp.addEventListener.bind(this.rowComp),
            addRenderedRowListener: function (eventType, listener) {
                console.warn('ag-Grid: since ag-Grid .v11, params.addRenderedRowListener() is now params.addRowCompListener()');
                _this.rowComp.addEventListener(eventType, listener);
            }
        };
        return params;
    };
    CellComp.prototype.formatValue = function (value) {
        var valueFormatted = this.beans.valueFormatterService.formatValue(this.column, this.rowNode, this.scope, value);
        var valueFormattedExists = valueFormatted !== null && valueFormatted !== undefined;
        return valueFormattedExists ? valueFormatted : value;
    };
    CellComp.prototype.getValueToUse = function () {
        var valueFormattedExists = this.valueFormatted !== null && this.valueFormatted !== undefined;
        return valueFormattedExists ? this.valueFormatted : this.value;
    };
    CellComp.prototype.getValueAndFormat = function () {
        this.value = this.getValue();
        this.valueFormatted = this.beans.valueFormatterService.formatValue(this.column, this.rowNode, this.scope, this.value);
    };
    CellComp.prototype.getValue = function () {
        // if we don't check this, then the grid will render leaf groups as open even if we are not
        // allowing the user to open leaf groups. confused? remember for pivot mode we don't allow
        // opening leaf groups, so we have to force leafGroups to be closed in case the user expanded
        // them via the API, or user user expanded them in the UI before turning on pivot mode
        var lockedClosedGroup = this.rowNode.leafGroup && this.beans.columnController.isPivotMode();
        var isOpenGroup = this.rowNode.group && this.rowNode.expanded && !this.rowNode.footer && !lockedClosedGroup;
        if (isOpenGroup && this.beans.gridOptionsWrapper.isGroupIncludeFooter()) {
            // if doing grouping and footers, we don't want to include the agg value
            // in the header when the group is open
            return this.beans.valueService.getValue(this.column, this.rowNode, true);
        }
        else {
            return this.beans.valueService.getValue(this.column, this.rowNode);
        }
    };
    CellComp.prototype.onMouseEvent = function (eventName, mouseEvent) {
        if (utils_1._.isStopPropagationForAgGrid(mouseEvent)) {
            return;
        }
        switch (eventName) {
            case 'click':
                this.onCellClicked(mouseEvent);
                break;
            case 'mousedown':
                this.onMouseDown();
                break;
            case 'dblclick':
                this.onCellDoubleClicked(mouseEvent);
                break;
            case 'mouseout':
                this.onMouseOut(mouseEvent);
                break;
            case 'mouseover':
                this.onMouseOver(mouseEvent);
                break;
        }
    };
    CellComp.prototype.dispatchCellContextMenuEvent = function (event) {
        var colDef = this.column.getColDef();
        var cellContextMenuEvent = this.createEvent(event, events_1.Events.EVENT_CELL_CONTEXT_MENU);
        this.beans.eventService.dispatchEvent(cellContextMenuEvent);
        if (colDef.onCellContextMenu) {
            // to make the callback async, do in a timeout
            setTimeout(function () { return colDef.onCellContextMenu(cellContextMenuEvent); }, 0);
        }
    };
    CellComp.prototype.createEvent = function (domEvent, eventType) {
        var event = {
            node: this.rowNode,
            data: this.rowNode.data,
            value: this.value,
            column: this.column,
            colDef: this.column.getColDef(),
            context: this.beans.gridOptionsWrapper.getContext(),
            api: this.beans.gridApi,
            columnApi: this.beans.columnApi,
            rowPinned: this.rowNode.rowPinned,
            event: domEvent,
            type: eventType,
            rowIndex: this.rowNode.rowIndex
        };
        // because we are hacking in $scope for angular 1, we have to de-reference
        if (this.scope) {
            event.$scope = this.scope;
        }
        return event;
    };
    CellComp.prototype.onMouseOut = function (mouseEvent) {
        var cellMouseOutEvent = this.createEvent(mouseEvent, events_1.Events.EVENT_CELL_MOUSE_OUT);
        this.beans.eventService.dispatchEvent(cellMouseOutEvent);
    };
    CellComp.prototype.onMouseOver = function (mouseEvent) {
        var cellMouseOverEvent = this.createEvent(mouseEvent, events_1.Events.EVENT_CELL_MOUSE_OVER);
        this.beans.eventService.dispatchEvent(cellMouseOverEvent);
    };
    CellComp.prototype.onCellDoubleClicked = function (mouseEvent) {
        var colDef = this.column.getColDef();
        // always dispatch event to eventService
        var cellDoubleClickedEvent = this.createEvent(mouseEvent, events_1.Events.EVENT_CELL_DOUBLE_CLICKED);
        this.beans.eventService.dispatchEvent(cellDoubleClickedEvent);
        // check if colDef also wants to handle event
        if (typeof colDef.onCellDoubleClicked === 'function') {
            // to make the callback async, do in a timeout
            setTimeout(function () { return colDef.onCellDoubleClicked(cellDoubleClickedEvent); }, 0);
        }
        var editOnDoubleClick = !this.beans.gridOptionsWrapper.isSingleClickEdit()
            && !this.beans.gridOptionsWrapper.isSuppressClickEdit();
        if (editOnDoubleClick) {
            this.startRowOrCellEdit();
        }
    };
    // called by rowRenderer when user navigates via tab key
    CellComp.prototype.startRowOrCellEdit = function (keyPress, charPress) {
        if (this.beans.gridOptionsWrapper.isFullRowEdit()) {
            this.rowComp.startRowEditing(keyPress, charPress, this);
        }
        else {
            this.startEditingIfEnabled(keyPress, charPress, true);
        }
    };
    CellComp.prototype.isCellEditable = function () {
        return this.column.isCellEditable(this.rowNode);
    };
    // either called internally if single cell editing, or called by rowRenderer if row editing
    CellComp.prototype.startEditingIfEnabled = function (keyPress, charPress, cellStartedEdit) {
        if (keyPress === void 0) { keyPress = null; }
        if (charPress === void 0) { charPress = null; }
        if (cellStartedEdit === void 0) { cellStartedEdit = false; }
        // don't do it if not editable
        if (!this.isCellEditable()) {
            return;
        }
        // don't do it if already editing
        if (this.editingCell) {
            return;
        }
        this.editingCell = true;
        this.cellEditorVersion++;
        var callback = this.afterCellEditorCreated.bind(this, this.cellEditorVersion);
        var params = this.createCellEditorParams(keyPress, charPress, cellStartedEdit);
        this.beans.cellEditorFactory.createCellEditor(this.column.getColDef(), params).then(callback);
        // if we don't do this, and editor component is async, then there will be a period
        // when the component isn't present and keyboard navigation won't work - so example
        // of user hitting tab quickly (more quickly than renderers getting created) won't work
        var cellEditorAsync = utils_1._.missing(this.cellEditor);
        if (cellEditorAsync && cellStartedEdit) {
            this.focusCell(true);
        }
    };
    CellComp.prototype.afterCellEditorCreated = function (cellEditorVersion, cellEditor) {
        // if editingCell=false, means user cancelled the editor before component was ready.
        // if versionMismatch, then user cancelled the edit, then started the edit again, and this
        //   is the first editor which is now stale.
        var versionMismatch = cellEditorVersion !== this.cellEditorVersion;
        if (versionMismatch || !this.editingCell) {
            if (cellEditor.destroy) {
                cellEditor.destroy();
            }
            return;
        }
        if (cellEditor.isCancelBeforeStart && cellEditor.isCancelBeforeStart()) {
            if (cellEditor.destroy) {
                cellEditor.destroy();
            }
            this.editingCell = false;
            return;
        }
        if (!cellEditor.getGui) {
            console.warn("ag-Grid: cellEditor for column " + this.column.getId() + " is missing getGui() method");
            // no getGui, for React guys, see if they attached a react component directly
            if (cellEditor.render) {
                console.warn("ag-Grid: we found 'render' on the component, are you trying to set a React renderer but added it as colDef.cellEditor instead of colDef.cellEditorFmk?");
            }
            if (cellEditor.destroy) {
                cellEditor.destroy();
            }
            this.editingCell = false;
            return;
        }
        this.cellEditor = cellEditor;
        this.cellEditorInPopup = cellEditor.isPopup && cellEditor.isPopup();
        this.setInlineEditingClass();
        if (this.cellEditorInPopup) {
            this.addPopupCellEditor();
        }
        else {
            this.addInCellEditor();
        }
        if (cellEditor.afterGuiAttached) {
            cellEditor.afterGuiAttached();
        }
        var event = this.createEvent(null, events_1.Events.EVENT_CELL_EDITING_STARTED);
        this.beans.eventService.dispatchEvent(event);
    };
    CellComp.prototype.addInCellEditor = function () {
        utils_1._.removeAllChildren(this.getGui());
        this.getGui().appendChild(this.cellEditor.getGui());
        this.angular1Compile();
    };
    CellComp.prototype.addPopupCellEditor = function () {
        var _this = this;
        var ePopupGui = this.cellEditor.getGui();
        this.hideEditorPopup = this.beans.popupService.addAsModalPopup(ePopupGui, true, 
        // callback for when popup disappears
        function () {
            _this.onPopupEditorClosed();
        });
        this.beans.popupService.positionPopupOverComponent({
            column: this.column,
            rowNode: this.rowNode,
            type: 'popupCellEditor',
            eventSource: this.getGui(),
            ePopup: ePopupGui,
            keepWithinBounds: true
        });
        this.angular1Compile();
    };
    CellComp.prototype.onPopupEditorClosed = function () {
        // we only call stopEditing if we are editing, as
        // it's possible the popup called 'stop editing'
        // before this, eg if 'enter key' was pressed on
        // the editor.
        if (this.editingCell) {
            // note: this only happens when use clicks outside of the grid. if use clicks on another
            // cell, then the editing will have already stopped on this cell
            this.stopRowOrCellEdit();
            // we only focus cell again if this cell is still focused. it is possible
            // it is not focused if the user cancelled the edit by clicking on another
            // cell outside of this one
            if (this.beans.focusedCellController.isCellFocused(this.gridCell)) {
                this.focusCell(true);
            }
        }
    };
    // if we are editing inline, then we don't have the padding in the cell (set in the themes)
    // to allow the text editor full access to the entire cell
    CellComp.prototype.setInlineEditingClass = function () {
        var editingInline = this.editingCell && !this.cellEditorInPopup;
        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-cell-inline-editing', editingInline);
        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-cell-not-inline-editing', !editingInline);
    };
    CellComp.prototype.createCellEditorParams = function (keyPress, charPress, cellStartedEdit) {
        var params = {
            value: this.getValue(),
            keyPress: keyPress,
            charPress: charPress,
            column: this.column,
            rowIndex: this.gridCell.rowIndex,
            node: this.rowNode,
            api: this.beans.gridOptionsWrapper.getApi(),
            cellStartedEdit: cellStartedEdit,
            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
            context: this.beans.gridOptionsWrapper.getContext(),
            $scope: this.scope,
            onKeyDown: this.onKeyDown.bind(this),
            stopEditing: this.stopEditingAndFocus.bind(this),
            eGridCell: this.getGui(),
            parseValue: this.parseValue.bind(this),
            formatValue: this.formatValue.bind(this)
        };
        return params;
    };
    // cell editors call this, when they want to stop for reasons other
    // than what we pick up on. eg selecting from a dropdown ends editing.
    CellComp.prototype.stopEditingAndFocus = function () {
        this.stopRowOrCellEdit();
        this.focusCell(true);
        this.navigateAfterEdit();
    };
    CellComp.prototype.parseValue = function (newValue) {
        var params = {
            node: this.rowNode,
            data: this.rowNode.data,
            oldValue: this.value,
            newValue: newValue,
            colDef: this.column.getColDef(),
            column: this.column,
            api: this.beans.gridOptionsWrapper.getApi(),
            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
            context: this.beans.gridOptionsWrapper.getContext()
        };
        var valueParser = this.column.getColDef().valueParser;
        return utils_1._.exists(valueParser) ? this.beans.expressionService.evaluate(valueParser, params) : newValue;
    };
    CellComp.prototype.focusCell = function (forceBrowserFocus) {
        if (forceBrowserFocus === void 0) { forceBrowserFocus = false; }
        this.beans.focusedCellController.setFocusedCell(this.gridCell.rowIndex, this.column, this.rowNode.rowPinned, forceBrowserFocus);
    };
    CellComp.prototype.setFocusInOnEditor = function () {
        if (this.editingCell) {
            if (this.cellEditor && this.cellEditor.focusIn) {
                // if the editor is present, then we just focus it
                this.cellEditor.focusIn();
            }
            else {
                // if the editor is not present, it means async cell editor (eg React fibre)
                // and we are trying to set focus before the cell editor is present, so we
                // focus the cell instead
                this.focusCell(true);
            }
        }
    };
    CellComp.prototype.isEditing = function () {
        return this.editingCell;
    };
    CellComp.prototype.onKeyDown = function (event) {
        var key = event.which || event.keyCode;
        // give user a chance to cancel event processing
        if (this.doesUserWantToCancelKeyboardEvent(event)) {
            return;
        }
        switch (key) {
            case constants_1.Constants.KEY_ENTER:
                this.onEnterKeyDown();
                break;
            case constants_1.Constants.KEY_F2:
                this.onF2KeyDown();
                break;
            case constants_1.Constants.KEY_ESCAPE:
                this.onEscapeKeyDown();
                break;
            case constants_1.Constants.KEY_TAB:
                this.onTabKeyDown(event);
                break;
            case constants_1.Constants.KEY_BACKSPACE:
            case constants_1.Constants.KEY_DELETE:
                this.onBackspaceOrDeleteKeyPressed(key);
                break;
            case constants_1.Constants.KEY_DOWN:
            case constants_1.Constants.KEY_UP:
            case constants_1.Constants.KEY_RIGHT:
            case constants_1.Constants.KEY_LEFT:
                this.onNavigationKeyPressed(event, key);
                break;
        }
    };
    CellComp.prototype.doesUserWantToCancelKeyboardEvent = function (event) {
        var callback = this.column.getColDef().suppressKeyboardEvent;
        if (utils_1._.missing(callback)) {
            return false;
        }
        else {
            // if editing is null or undefined, this sets it to false
            var params = {
                event: event,
                editing: this.editingCell,
                column: this.column,
                api: this.beans.gridOptionsWrapper.getApi(),
                node: this.rowNode,
                data: this.rowNode.data,
                colDef: this.column.getColDef(),
                context: this.beans.gridOptionsWrapper.getContext(),
                columnApi: this.beans.gridOptionsWrapper.getColumnApi()
            };
            return callback(params);
        }
    };
    CellComp.prototype.setFocusOutOnEditor = function () {
        if (this.editingCell && this.cellEditor && this.cellEditor.focusOut) {
            this.cellEditor.focusOut();
        }
    };
    CellComp.prototype.onNavigationKeyPressed = function (event, key) {
        if (this.editingCell) {
            this.stopRowOrCellEdit();
        }
        this.beans.rowRenderer.navigateToNextCell(event, key, this.gridCell, true);
        // if we don't prevent default, the grid will scroll with the navigation keys
        event.preventDefault();
    };
    CellComp.prototype.onTabKeyDown = function (event) {
        if (this.beans.gridOptionsWrapper.isSuppressTabbing()) {
            return;
        }
        this.beans.rowRenderer.onTabKeyDown(this, event);
    };
    CellComp.prototype.onBackspaceOrDeleteKeyPressed = function (key) {
        if (!this.editingCell) {
            this.startRowOrCellEdit(key);
        }
    };
    CellComp.prototype.onEnterKeyDown = function () {
        if (this.editingCell || this.rowComp.isEditing()) {
            this.stopEditingAndFocus();
        }
        else {
            this.startRowOrCellEdit(constants_1.Constants.KEY_ENTER);
        }
    };
    CellComp.prototype.navigateAfterEdit = function () {
        var fullRowEdit = this.beans.gridOptionsWrapper.isFullRowEdit();
        if (fullRowEdit) {
            return;
        }
        var enterMovesDownAfterEdit = this.beans.gridOptionsWrapper.isEnterMovesDownAfterEdit();
        if (enterMovesDownAfterEdit) {
            this.beans.rowRenderer.navigateToNextCell(null, constants_1.Constants.KEY_DOWN, this.gridCell, false);
        }
    };
    CellComp.prototype.onF2KeyDown = function () {
        if (!this.editingCell) {
            this.startRowOrCellEdit(constants_1.Constants.KEY_F2);
        }
    };
    CellComp.prototype.onEscapeKeyDown = function () {
        if (this.editingCell) {
            this.stopRowOrCellEdit(true);
            this.focusCell(true);
        }
    };
    CellComp.prototype.onKeyPress = function (event) {
        // check this, in case focus is on a (for example) a text field inside the cell,
        // in which cse we should not be listening for these key pressed
        var eventTarget = utils_1._.getTarget(event);
        var eventOnChildComponent = eventTarget !== this.getGui();
        if (eventOnChildComponent) {
            return;
        }
        if (!this.editingCell) {
            var pressedChar = String.fromCharCode(event.charCode);
            if (pressedChar === ' ') {
                this.onSpaceKeyPressed(event);
            }
            else {
                if (utils_1._.isEventFromPrintableCharacter(event)) {
                    this.startRowOrCellEdit(null, pressedChar);
                    // if we don't prevent default, then the keypress also gets applied to the text field
                    // (at least when doing the default editor), but we need to allow the editor to decide
                    // what it wants to do. we only do this IF editing was started - otherwise it messes
                    // up when the use is not doing editing, but using rendering with text fields in cellRenderer
                    // (as it would block the the user from typing into text fields).
                    event.preventDefault();
                }
            }
        }
    };
    CellComp.prototype.onSpaceKeyPressed = function (event) {
        if (!this.editingCell && this.beans.gridOptionsWrapper.isRowSelection()) {
            var selected = this.rowNode.isSelected();
            this.rowNode.setSelected(!selected);
        }
        // prevent default as space key, by default, moves browser scroll down
        event.preventDefault();
    };
    CellComp.prototype.onMouseDown = function () {
        // we pass false to focusCell, as we don't want the cell to focus
        // also get the browser focus. if we did, then the cellRenderer could
        // have a text field in it, for example, and as the user clicks on the
        // text field, the text field, the focus doesn't get to the text
        // field, instead to goes to the div behind, making it impossible to
        // select the text field.
        this.focusCell(false);
        // if it's a right click, then if the cell is already in range,
        // don't change the range, however if the cell is not in a range,
        // we set a new range
        if (this.beans.rangeController) {
            var thisCell = this.gridCell;
            var cellAlreadyInRange = this.beans.rangeController.isCellInAnyRange(thisCell);
            if (!cellAlreadyInRange) {
                this.beans.rangeController.setRangeToCell(thisCell);
            }
        }
    };
    // returns true if on iPad and this is second 'click' event in 200ms
    CellComp.prototype.isDoubleClickOnIPad = function () {
        if (!utils_1._.isUserAgentIPad()) {
            return false;
        }
        var nowMillis = new Date().getTime();
        var res = nowMillis - this.lastIPadMouseClickEvent < 200;
        this.lastIPadMouseClickEvent = nowMillis;
        return res;
    };
    CellComp.prototype.onCellClicked = function (mouseEvent) {
        // iPad doesn't have double click - so we need to mimic it do enable editing for
        // iPad.
        if (this.isDoubleClickOnIPad()) {
            this.onCellDoubleClicked(mouseEvent);
            mouseEvent.preventDefault(); // if we don't do this, then ipad zooms in
            return;
        }
        var cellClickedEvent = this.createEvent(mouseEvent, events_1.Events.EVENT_CELL_CLICKED);
        this.beans.eventService.dispatchEvent(cellClickedEvent);
        var colDef = this.column.getColDef();
        if (colDef.onCellClicked) {
            // to make callback async, do in a timeout
            setTimeout(function () { return colDef.onCellClicked(cellClickedEvent); }, 0);
        }
        var editOnSingleClick = this.beans.gridOptionsWrapper.isSingleClickEdit()
            && !this.beans.gridOptionsWrapper.isSuppressClickEdit();
        if (editOnSingleClick) {
            this.startRowOrCellEdit();
        }
        this.doIeFocusHack();
    };
    // https://ag-grid.com/forum/showthread.php?tid=4362
    // when in IE or Edge, when you are editing a cell, then click on another cell,
    // the other cell doesn't keep focus, so navigation keys, type to start edit etc
    // don't work. appears that when you update the dom in IE it looses focus
    CellComp.prototype.doIeFocusHack = function () {
        if (utils_1._.isBrowserIE() || utils_1._.isBrowserEdge()) {
            if (utils_1._.missing(document.activeElement) || document.activeElement === document.body) {
                // console.log('missing focus');
                this.getGui().focus();
            }
        }
    };
    CellComp.prototype.createGridCellVo = function () {
        var gridCellDef = {
            rowIndex: this.rowNode.rowIndex,
            floating: this.rowNode.rowPinned,
            column: this.column
        };
        this.gridCell = new gridCell_1.GridCell(gridCellDef);
    };
    CellComp.prototype.getGridCell = function () {
        return this.gridCell;
    };
    CellComp.prototype.getParentRow = function () {
        return this.eParentRow;
    };
    CellComp.prototype.setParentRow = function (eParentRow) {
        this.eParentRow = eParentRow;
    };
    CellComp.prototype.getColumn = function () {
        return this.column;
    };
    CellComp.prototype.detach = function () {
        this.eParentRow.removeChild(this.getGui());
    };
    // if the row is also getting destroyed, then we don't need to remove from dom,
    // as the row will also get removed, so no need to take out the cells from the row
    // if the row is going (removing is an expensive operation, so only need to remove
    // the top part)
    CellComp.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        if (this.cellEditor && this.cellEditor.destroy) {
            this.cellEditor.destroy();
            this.cellEditor = null;
        }
        if (this.cellRenderer && this.cellRenderer.destroy) {
            this.cellRenderer.destroy();
            this.cellRenderer = null;
        }
    };
    CellComp.prototype.onLeftChanged = function () {
        var left = this.getCellLeft();
        this.getGui().style.left = left + 'px';
    };
    CellComp.prototype.onWidthChanged = function () {
        var width = this.getCellWidth();
        this.getGui().style.width = width + 'px';
    };
    CellComp.prototype.getRangeClasses = function () {
        var res = [];
        if (!this.rangeSelectionEnabled) {
            return res;
        }
        if (this.rangeCount !== 0) {
            res.push('ag-cell-range-selected');
        }
        if (this.rangeCount === 1) {
            res.push('ag-cell-range-selected-1');
        }
        if (this.rangeCount === 2) {
            res.push('ag-cell-range-selected-2');
        }
        if (this.rangeCount === 3) {
            res.push('ag-cell-range-selected-3');
        }
        if (this.rangeCount >= 4) {
            res.push('ag-cell-range-selected-4');
        }
        return res;
    };
    CellComp.prototype.onRowIndexChanged = function () {
        // when index changes, this influences items that need the index, so we update the
        // grid cell so they are working off the new index.
        this.createGridCellVo();
        // when the index of the row changes, ie means the cell may have lost or gained focus
        this.onCellFocused();
        // check range selection
        this.onRangeSelectionChanged();
    };
    CellComp.prototype.onRangeSelectionChanged = function () {
        if (!this.beans.enterprise) {
            return;
        }
        var newRangeCount = this.beans.rangeController.getCellRangeCount(this.gridCell);
        var element = this.getGui();
        if (this.rangeCount !== newRangeCount) {
            utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-selected', newRangeCount !== 0);
            utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-selected-1', newRangeCount === 1);
            utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-selected-2', newRangeCount === 2);
            utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-selected-3', newRangeCount === 3);
            utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-selected-4', newRangeCount >= 4);
            this.rangeCount = newRangeCount;
        }
    };
    CellComp.prototype.onFirstRightPinnedChanged = function () {
        var firstRightPinned = this.column.isFirstRightPinned();
        if (this.firstRightPinned !== firstRightPinned) {
            this.firstRightPinned = firstRightPinned;
            utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-cell-first-right-pinned', firstRightPinned);
        }
    };
    CellComp.prototype.onLastLeftPinnedChanged = function () {
        var lastLeftPinned = this.column.isLastLeftPinned();
        if (this.lastLeftPinned !== lastLeftPinned) {
            this.lastLeftPinned = lastLeftPinned;
            utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-cell-last-left-pinned', lastLeftPinned);
        }
    };
    CellComp.prototype.populateTemplate = function () {
        if (this.usingWrapper) {
            this.eParentOfValue = this.getRefElement('eCellValue');
            this.eCellWrapper = this.getRefElement('eCellWrapper');
            if (this.includeRowDraggingComponent) {
                this.addRowDragging();
            }
            if (this.includeSelectionComponent) {
                this.addSelectionCheckbox();
            }
        }
        else {
            this.eParentOfValue = this.getGui();
        }
    };
    CellComp.prototype.addRowDragging = function () {
        // row dragging only available in default row model
        if (!this.beans.gridOptionsWrapper.isRowModelDefault()) {
            utils_1._.doOnce(function () { return console.warn('ag-Grid: row dragging is only allowed in the In Memory Row Model'); }, 'CellComp.addRowDragging');
            return;
        }
        if (this.beans.gridOptionsWrapper.isPagination()) {
            utils_1._.doOnce(function () { return console.warn('ag-Grid: row dragging is not possible when doing pagination'); }, 'CellComp.addRowDragging');
            return;
        }
        var rowDraggingComp = new rowDragComp_1.RowDragComp(this.rowNode, this.column, this.getValueToUse(), this.beans);
        this.addFeature(this.beans.context, rowDraggingComp);
        // let visibleFunc = this.column.getColDef().checkboxSelection;
        // visibleFunc = typeof visibleFunc === 'function' ? visibleFunc : null;
        // cbSelectionComponent.init({rowNode: this.rowNode, column: this.column, visibleFunc: visibleFunc});
        // put the checkbox in before the value
        this.eCellWrapper.insertBefore(rowDraggingComp.getGui(), this.eParentOfValue);
    };
    CellComp.prototype.addSelectionCheckbox = function () {
        var cbSelectionComponent = new checkboxSelectionComponent_1.CheckboxSelectionComponent();
        this.beans.context.wireBean(cbSelectionComponent);
        var visibleFunc = this.column.getColDef().checkboxSelection;
        visibleFunc = typeof visibleFunc === 'function' ? visibleFunc : null;
        cbSelectionComponent.init({ rowNode: this.rowNode, column: this.column, visibleFunc: visibleFunc });
        this.addDestroyFunc(function () { return cbSelectionComponent.destroy(); });
        // put the checkbox in before the value
        this.eCellWrapper.insertBefore(cbSelectionComponent.getGui(), this.eParentOfValue);
    };
    CellComp.prototype.addDomData = function () {
        var _this = this;
        var element = this.getGui();
        this.beans.gridOptionsWrapper.setDomData(element, CellComp.DOM_DATA_KEY_CELL_COMP, this);
        this.addDestroyFunc(function () {
            return _this.beans.gridOptionsWrapper.setDomData(element, CellComp.DOM_DATA_KEY_CELL_COMP, null);
        });
    };
    CellComp.prototype.onCellFocused = function (event) {
        var cellFocused = this.beans.focusedCellController.isCellFocused(this.gridCell);
        // see if we need to change the classes on this cell
        if (cellFocused !== this.cellFocused) {
            utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-cell-focus', cellFocused);
            utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-cell-no-focus', !cellFocused);
            this.cellFocused = cellFocused;
        }
        // if this cell was just focused, see if we need to force browser focus, his can
        // happen if focus is programmatically set.
        if (cellFocused && event && event.forceBrowserFocus) {
            this.getGui().focus();
        }
        // if another cell was focused, and we are editing, then stop editing
        var fullRowEdit = this.beans.gridOptionsWrapper.isFullRowEdit();
        if (!cellFocused && !fullRowEdit && this.editingCell) {
            this.stopRowOrCellEdit();
        }
    };
    // pass in 'true' to cancel the editing.
    CellComp.prototype.stopRowOrCellEdit = function (cancel) {
        if (cancel === void 0) { cancel = false; }
        if (this.beans.gridOptionsWrapper.isFullRowEdit()) {
            this.rowComp.stopRowEditing(cancel);
        }
        else {
            this.stopEditing(cancel);
        }
    };
    CellComp.prototype.stopEditing = function (cancel) {
        if (cancel === void 0) { cancel = false; }
        if (!this.editingCell) {
            return;
        }
        // if no cell editor, this means due to async, that the cell editor never got initialised,
        // so we just carry on regardless as if the editing was never started.
        if (!this.cellEditor) {
            this.editingCell = false;
            return;
        }
        if (!cancel) {
            // also have another option here to cancel after editing, so for example user could have a popup editor and
            // it is closed by user clicking outside the editor. then the editor will close automatically (with false
            // passed above) and we need to see if the editor wants to accept the new value.
            var userWantsToCancel = this.cellEditor.isCancelAfterEnd && this.cellEditor.isCancelAfterEnd();
            if (!userWantsToCancel) {
                var newValue = this.cellEditor.getValue();
                this.rowNode.setDataValue(this.column, newValue);
                this.getValueAndFormat();
            }
        }
        // it is important we set this after setValue() above, as otherwise the cell will flash
        // when editing stops. the 'refresh' method checks editing, and doesn't refresh editing cells.
        // thus it will skip the refresh on this cell until the end of this method where we call
        // refresh directly and we suppress the flash.
        this.editingCell = false;
        if (this.cellEditor.destroy) {
            this.cellEditor.destroy();
        }
        // important to clear this out - as parts of the code will check for
        // this to see if an async cellEditor has yet to be created
        this.cellEditor = null;
        if (this.cellEditorInPopup) {
            this.hideEditorPopup();
            this.hideEditorPopup = null;
        }
        else {
            utils_1._.removeAllChildren(this.getGui());
            // put the cell back the way it was before editing
            if (this.usingWrapper) {
                // if wrapper, then put the wrapper back
                this.getGui().appendChild(this.eCellWrapper);
            }
            else {
                // if cellRenderer, then put the gui back in. if the renderer has
                // a refresh, it will be called. however if it doesn't, then later
                // the renderer will be destroyed and a new one will be created.
                if (this.cellRenderer) {
                    // we know it's a dom element (not a string) because we converted
                    // it after the gui was attached if it was a string.
                    var eCell = this.cellRendererGui;
                    // can be null if cell was previously null / contained empty string,
                    // this will result in new value not being rendered.
                    if (eCell) {
                        this.getGui().appendChild(eCell);
                    }
                }
            }
        }
        this.setInlineEditingClass();
        // we suppress the flash, as it is not correct to flash the cell the user has finished editing,
        // the user doesn't need to flash as they were the one who did the edit, the flash is pointless
        // (as the flash is meant to draw the user to a change that they didn't manually do themselves).
        this.refreshCell({ forceRefresh: true, suppressFlash: true });
        var event = this.createEvent(null, events_1.Events.EVENT_CELL_EDITING_STOPPED);
        this.beans.eventService.dispatchEvent(event);
    };
    CellComp.DOM_DATA_KEY_CELL_COMP = 'cellComp';
    return CellComp;
}(component_1.Component));
exports.CellComp = CellComp;


/***/ }),

/***/ "wVvS":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(959);
	module.exports = __webpack_require__(959);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 959:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(960) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {

	var kendo = window.kendo,
	    DropDownList = kendo.ui.DropDownList,
	    dom = kendo.ui.editor.Dom;

	var SelectBox = DropDownList.extend({
	    init: function(element, options) {
	        var that = this;

	        DropDownList.fn.init.call(that, element, options);

	        // overlay drop-down with popout for snappier interaction
	        if (kendo.support.mobileOS.ios) {
	            this._initSelectOverlay();
	            this.bind("dataBound", $.proxy(this._initSelectOverlay, this));
	        }

	        that.text(that.options.title);

	        that.element.attr("title", that.options.title);
	        that.wrapper.attr("title", that.options.title);

	        that.bind("open", function() {
	            if (that.options.autoSize) {
	                var list = that.list,
	                    listWidth;

	                list.css({
	                        whiteSpace: "nowrap",
	                        width: "auto"
	                    });

	                listWidth = list.width();

	                if (listWidth > 0) {
	                    listWidth += 20;
	                } else {
	                    listWidth = that._listWidth;
	                }

	                list.css("width", listWidth + kendo.support.scrollbar());

	                that._listWidth = listWidth;
	            }
	        });
	    },
	    options: {
	        name: "SelectBox",
	        index: -1
	    },

	    _initSelectOverlay: function() {
	        var selectBox = this;
	        var value = selectBox.value();
	        var view = this.dataSource.view();
	        var item;
	        var html = "";
	        var encode = kendo.htmlEncode;

	        for (var i = 0; i < view.length; i++) {
	            item = view[i];

	            html += "<option value='" + encode(item.value) + "'";

	            if (item.value == value) {
	                html += " selected";
	            }

	            html += ">" + encode(item.text) + "</option>";
	        }

	        var select = $("<select class='k-select-overlay'>" + html + "</select>");
	        var wrapper = $(this.element).closest(".k-widget");

	        wrapper.next(".k-select-overlay").remove();

	        select.insertAfter(wrapper);

	        select.on("change", function() {
	            selectBox.value(this.value);
	            selectBox.trigger("change");
	        });
	    },

	    value: function(value) {
	        var that = this,
	            result = DropDownList.fn.value.call(that, value);

	        if (value === undefined) {
	            return result;
	        }

	        if (!DropDownList.fn.value.call(that)) {
	           that.text(that.options.title);
	        }
	    },

	    decorate: function(body) {
	        var that = this,
	            dataSource = that.dataSource,
	            items = dataSource.data(),
	            i, tag, className, style;

	        if (body) {
	            that.list.css("background-color", dom.getEffectiveBackground($(body)));
	        }

	        for (i = 0; i < items.length; i++) {
	            tag = items[i].tag || "span";
	            className = items[i].className;

	            style = dom.inlineStyle(body, tag, { className : className });

	            style = style.replace(/"/g, "'");

	            items[i].style = style + ";display:inline-block";
	        }

	        dataSource.trigger("change");
	    }
	});


	kendo.ui.plugin(SelectBox);
	kendo.ui.editor.SelectBox = SelectBox;

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 960:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1Xu6");

/***/ })

/******/ });

/***/ }),

/***/ "wYvi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var beanStub_1 = __webpack_require__("xffp");
var eventService_1 = __webpack_require__("k5uU");
var events_1 = __webpack_require__("3ok8");
var utils_1 = __webpack_require__("IRr6");
var context_1 = __webpack_require__("RQ1/");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var gridPanel_1 = __webpack_require__("inOk");
var scrollVisibleService_1 = __webpack_require__("5AnZ");
var selectionController_1 = __webpack_require__("D4cr");
var columnApi_1 = __webpack_require__("E/Wy");
var gridApi_1 = __webpack_require__("BAow");
var PaginationAutoPageSizeService = (function (_super) {
    __extends(PaginationAutoPageSizeService, _super);
    function PaginationAutoPageSizeService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaginationAutoPageSizeService.prototype.notActive = function () {
        return !this.gridOptionsWrapper.isPaginationAutoPageSize();
    };
    PaginationAutoPageSizeService.prototype.postConstruct = function () {
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_BODY_HEIGHT_CHANGED, this.onBodyHeightChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
        this.checkPageSize();
    };
    PaginationAutoPageSizeService.prototype.onScrollVisibilityChanged = function () {
        this.checkPageSize();
    };
    PaginationAutoPageSizeService.prototype.onBodyHeightChanged = function () {
        this.checkPageSize();
    };
    PaginationAutoPageSizeService.prototype.checkPageSize = function () {
        if (this.notActive()) {
            return;
        }
        var rowHeight = this.gridOptionsWrapper.getRowHeightAsNumber();
        var bodyHeight = this.gridPanel.getBodyHeight();
        if (this.scrollVisibleService.isHBodyShowing()) {
            bodyHeight = bodyHeight - this.gridOptionsWrapper.getScrollbarWidth();
        }
        if (bodyHeight > 0) {
            var newPageSize = Math.floor(bodyHeight / rowHeight);
            this.gridOptionsWrapper.setProperty('paginationPageSize', newPageSize);
        }
    };
    __decorate([
        context_1.Autowired('gridPanel'),
        __metadata("design:type", gridPanel_1.GridPanel)
    ], PaginationAutoPageSizeService.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], PaginationAutoPageSizeService.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], PaginationAutoPageSizeService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('scrollVisibleService'),
        __metadata("design:type", scrollVisibleService_1.ScrollVisibleService)
    ], PaginationAutoPageSizeService.prototype, "scrollVisibleService", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PaginationAutoPageSizeService.prototype, "postConstruct", null);
    PaginationAutoPageSizeService = __decorate([
        context_1.Bean('paginationAutoPageSizeService')
    ], PaginationAutoPageSizeService);
    return PaginationAutoPageSizeService;
}(beanStub_1.BeanStub));
exports.PaginationAutoPageSizeService = PaginationAutoPageSizeService;
var PaginationProxy = (function (_super) {
    __extends(PaginationProxy, _super);
    function PaginationProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentPage = 0;
        _this.topRowIndex = 0;
        _this.bottomRowIndex = 0;
        _this.pixelOffset = 0;
        return _this;
    }
    PaginationProxy.prototype.postConstruct = function () {
        this.active = this.gridOptionsWrapper.isPagination();
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_MODEL_UPDATED, this.onModelUpdated.bind(this));
        this.addDestroyableEventListener(this.gridOptionsWrapper, 'paginationPageSize', this.onModelUpdated.bind(this));
        this.onModelUpdated();
    };
    PaginationProxy.prototype.isLastRowFound = function () {
        return this.rowModel.isLastRowFound();
    };
    PaginationProxy.prototype.onModelUpdated = function (modelUpdatedEvent) {
        this.setIndexesAndBounds();
        var paginationChangedEvent = {
            type: events_1.Events.EVENT_PAGINATION_CHANGED,
            animate: modelUpdatedEvent ? modelUpdatedEvent.animate : false,
            newData: modelUpdatedEvent ? modelUpdatedEvent.newData : false,
            newPage: modelUpdatedEvent ? modelUpdatedEvent.newPage : false,
            keepRenderedRows: modelUpdatedEvent ? modelUpdatedEvent.keepRenderedRows : false,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(paginationChangedEvent);
    };
    PaginationProxy.prototype.goToPage = function (page) {
        if (!this.active) {
            return;
        }
        if (this.currentPage === page) {
            return;
        }
        this.currentPage = page;
        var event = {
            type: events_1.Events.EVENT_MODEL_UPDATED,
            animate: false,
            keepRenderedRows: false,
            newData: false,
            newPage: true,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.onModelUpdated(event);
    };
    PaginationProxy.prototype.getPixelOffset = function () {
        return this.pixelOffset;
    };
    PaginationProxy.prototype.getRow = function (index) {
        return this.rowModel.getRow(index);
    };
    PaginationProxy.prototype.getRowIndexAtPixel = function (pixel) {
        return this.rowModel.getRowIndexAtPixel(pixel);
    };
    PaginationProxy.prototype.getCurrentPageHeight = function () {
        if (utils_1._.missing(this.topRowBounds) || utils_1._.missing(this.bottomRowBounds)) {
            return 0;
        }
        return this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight - this.topRowBounds.rowTop;
    };
    PaginationProxy.prototype.isRowPresent = function (rowNode) {
        if (!this.rowModel.isRowPresent(rowNode)) {
            return false;
        }
        var nodeIsInPage = rowNode.rowIndex >= this.topRowIndex && rowNode.rowIndex <= this.bottomRowIndex;
        return nodeIsInPage;
    };
    PaginationProxy.prototype.isEmpty = function () {
        return this.rowModel.isEmpty();
    };
    PaginationProxy.prototype.isRowsToRender = function () {
        return this.rowModel.isRowsToRender();
    };
    PaginationProxy.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
        return this.rowModel.getNodesInRangeForSelection(firstInRange, lastInRange);
    };
    PaginationProxy.prototype.forEachNode = function (callback) {
        return this.rowModel.forEachNode(callback);
    };
    PaginationProxy.prototype.getType = function () {
        return this.rowModel.getType();
    };
    PaginationProxy.prototype.getRowBounds = function (index) {
        return this.rowModel.getRowBounds(index);
    };
    PaginationProxy.prototype.getPageFirstRow = function () {
        return this.pageSize * this.currentPage;
    };
    PaginationProxy.prototype.getPageLastRow = function () {
        var totalLastRow = (this.pageSize * (this.currentPage + 1)) - 1;
        var pageLastRow = this.rowModel.getPageLastRow();
        if (pageLastRow > totalLastRow) {
            return totalLastRow;
        }
        else {
            return pageLastRow;
        }
    };
    PaginationProxy.prototype.getRowCount = function () {
        return this.rowModel.getRowCount();
    };
    PaginationProxy.prototype.goToPageWithIndex = function (index) {
        if (!this.active) {
            return;
        }
        var pageNumber = Math.floor(index / this.pageSize);
        this.goToPage(pageNumber);
    };
    PaginationProxy.prototype.getTotalRowCount = function () {
        return this.rowModel.getPageLastRow() + 1;
    };
    PaginationProxy.prototype.isLastPageFound = function () {
        return this.rowModel.isLastRowFound();
    };
    PaginationProxy.prototype.getCurrentPage = function () {
        return this.currentPage;
    };
    PaginationProxy.prototype.goToNextPage = function () {
        this.goToPage(this.currentPage + 1);
    };
    PaginationProxy.prototype.goToPreviousPage = function () {
        this.goToPage(this.currentPage - 1);
    };
    PaginationProxy.prototype.goToFirstPage = function () {
        this.goToPage(0);
    };
    PaginationProxy.prototype.goToLastPage = function () {
        var rowCount = this.rowModel.getPageLastRow() + 1;
        var lastPage = Math.floor(rowCount / this.pageSize);
        this.goToPage(lastPage);
    };
    PaginationProxy.prototype.getPageSize = function () {
        return this.pageSize;
    };
    PaginationProxy.prototype.getTotalPages = function () {
        return this.totalPages;
    };
    PaginationProxy.prototype.setPageSize = function () {
        // show put this into super class
        this.pageSize = this.gridOptionsWrapper.getPaginationPageSize();
        if (!(this.pageSize >= 1)) {
            this.pageSize = 100;
        }
    };
    PaginationProxy.prototype.setIndexesAndBounds = function () {
        if (this.active) {
            this.setPageSize();
            var totalRowCount = this.getTotalRowCount();
            this.totalPages = Math.floor((totalRowCount - 1) / this.pageSize) + 1;
            if (this.currentPage >= this.totalPages) {
                this.currentPage = this.totalPages - 1;
            }
            if (!utils_1._.isNumeric(this.currentPage) || this.currentPage < 0) {
                this.currentPage = 0;
            }
            this.topRowIndex = this.pageSize * this.currentPage;
            this.bottomRowIndex = (this.pageSize * (this.currentPage + 1)) - 1;
            var maxRowAllowed = this.rowModel.getPageLastRow();
            if (this.bottomRowIndex > maxRowAllowed) {
                this.bottomRowIndex = maxRowAllowed;
            }
        }
        else {
            this.pageSize = this.rowModel.getPageLastRow() + 1;
            this.totalPages = 1;
            this.currentPage = 0;
            this.topRowIndex = 0;
            this.bottomRowIndex = this.rowModel.getPageLastRow();
        }
        this.topRowBounds = this.rowModel.getRowBounds(this.topRowIndex);
        this.bottomRowBounds = this.rowModel.getRowBounds(this.bottomRowIndex);
        this.pixelOffset = utils_1._.exists(this.topRowBounds) ? this.topRowBounds.rowTop : 0;
    };
    __decorate([
        context_1.Autowired('rowModel'),
        __metadata("design:type", Object)
    ], PaginationProxy.prototype, "rowModel", void 0);
    __decorate([
        context_1.Autowired('gridPanel'),
        __metadata("design:type", gridPanel_1.GridPanel)
    ], PaginationProxy.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], PaginationProxy.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], PaginationProxy.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('selectionController'),
        __metadata("design:type", selectionController_1.SelectionController)
    ], PaginationProxy.prototype, "selectionController", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], PaginationProxy.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], PaginationProxy.prototype, "gridApi", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PaginationProxy.prototype, "postConstruct", null);
    PaginationProxy = __decorate([
        context_1.Bean('paginationProxy')
    ], PaginationProxy);
    return PaginationProxy;
}(beanStub_1.BeanStub));
exports.PaginationProxy = PaginationProxy;


/***/ }),

/***/ "wcKb":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1582);
	module.exports = __webpack_require__(1582);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 953:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 969:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("3Bvt");

/***/ }),

/***/ 1582:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20), __webpack_require__(969), __webpack_require__(953) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	    (function(kendo) {
	        if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	            return;
	        }

	        var $ = kendo.jQuery;
	        var BORDER_TYPES = [
	            "allBorders",
	            "insideBorders",
	            "insideHorizontalBorders",
	            "insideVerticalBorders",
	            "outsideBorders",
	            "leftBorder",
	            "topBorder",
	            "rightBorder",
	            "bottomBorder",
	            "noBorders"
	        ];

	        var BORDER_PALETTE_MESSAGES = kendo.spreadsheet.messages.borderPalette = {
	            allBorders: "All borders",
	            insideBorders: "Inside borders",
	            insideHorizontalBorders: "Inside horizontal borders",
	            insideVerticalBorders: "Inside vertical borders",
	            outsideBorders: "Outside borders",
	            leftBorder: "Left border",
	            topBorder: "Top border",
	            rightBorder: "Right border",
	            bottomBorder: "Bottom border",
	            noBorders: "No border"
	        };

	        var COLOR_PICKER_MESSAGES = kendo.spreadsheet.messages.colorPicker = {
	            reset: "Reset color",
	            customColor: "Custom color...",
	            apply: "Apply",
	            cancel: "Cancel"
	        };

	        function withPreventDefault(f) {
	            return function(e) {
	                e.preventDefault();
	                return f.apply(this, arguments);
	            };
	        }

	        var ColorChooser = kendo.ui.Widget.extend({
	            init: function(element, options) {
	                kendo.ui.Widget.call(this, element, options);

	                this.element = element;
	                this.color = options.color;

	                this._resetButton();
	                this._colorPalette();
	                this._customColorPalette();
	                this._customColorButton();

	                this.resetButton.on("click", withPreventDefault(this.resetColor.bind(this)));
	                this.customColorButton.on("click", withPreventDefault(this.customColor.bind(this)));
	            },

	            options: {
	                name: "ColorChooser"
	            },

	            events: [
	                "change"
	            ],

	            destroy: function() {
	                kendo.unbind(this.dialog.element.find(".k-action-buttons"));
	                this.dialog.destroy();
	                this.colorPalette.destroy();
	                this.resetButton.off("click");
	                this.customColorButton.off("click");
	            },

	            value: function(value) {
	                if (value !== undefined) {
	                    this.color = value;
	                    this.customColorButton.find(".k-icon").css("background-color", this.color);
	                    this.colorPalette.value(null);
	                    this.flatColorPicker.value(this.color);
	                } else {
	                    return this.color;
	                }
	            },

	            _change: function(value) {
	                this.color = value;
	                this.trigger("change", { value: value });
	            },

	            _colorPalette: function() {
	                var element = $("<div />", {
	                    "class": "k-spreadsheet-color-palette"
	                });

	                var colorPalette = this.colorPalette = $("<div />").kendoColorPalette({
	                    palette: [ //metro palette
	                        "#ffffff", "#000000", "#d6ecff", "#4e5b6f", "#7fd13b", "#ea157a", "#feb80a", "#00addc", "#738ac8", "#1ab39f",
	                        "#f2f2f2", "#7f7f7f", "#a7d6ff", "#d9dde4", "#e5f5d7", "#fad0e4", "#fef0cd", "#c5f2ff", "#e2e7f4", "#c9f7f1",
	                        "#d8d8d8", "#595959", "#60b5ff", "#b3bcca", "#cbecb0", "#f6a1c9", "#fee29c", "#8be6ff", "#c7d0e9", "#94efe3",
	                        "#bfbfbf", "#3f3f3f", "#007dea", "#8d9baf", "#b2e389", "#f272af", "#fed46b", "#51d9ff", "#aab8de", "#5fe7d5",
	                        "#a5a5a5", "#262626", "#003e75", "#3a4453", "#5ea226", "#af0f5b", "#c58c00", "#0081a5", "#425ea9", "#138677",
	                        "#7f7f7f", "#0c0c0c", "#00192e", "#272d37", "#3f6c19", "#750a3d", "#835d00", "#00566e", "#2c3f71", "#0c594f"
	                    ],
	                    value: this.color,
	                    change: function(e) {
	                        this.customColorButton.find(".k-icon").css("background-color", "transparent");
	                        this.flatColorPicker.value(null);
	                        this._change(e.value);
	                    }.bind(this)
	                }).data("kendoColorPalette");

	                element
	                    .append(colorPalette.wrapper)
	                    .appendTo(this.element);
	            },

	            _customColorPalette: function() {
	                var element = $("<div />", {
	                    "class": "k-spreadsheet-window",
	                    "html": "<div></div>" +
	                            "<div class='k-action-buttons'>" +
	                                "<button class='k-button k-primary' data-bind='click: apply'>" + COLOR_PICKER_MESSAGES.apply + "</button>" +
	                                "<button class='k-button' data-bind='click: close'>" + COLOR_PICKER_MESSAGES.cancel + "</button>" +
	                            "</div>"
	                });

	                var dialog = this.dialog = element.appendTo(document.body).kendoWindow({
	                    animation: false,
	                    scrollable: false,
	                    resizable: false,
	                    maximizable: false,
	                    modal: true,
	                    visible: false,
	                    width: "auto",
	                    open: function() {
	                        this.center();
	                    }
	                }).data("kendoWindow");

	                dialog.one("activate", function() {
	                    this.element.find("[data-role=flatcolorpicker]").data("kendoFlatColorPicker")._hueSlider.resize();
	                });

	                var flatColorPicker = this.flatColorPicker = dialog.element.children().first().kendoFlatColorPicker().data("kendoFlatColorPicker");

	                var viewModel = kendo.observable({
	                    apply: function() {
	                        this.customColorButton.find(".k-icon").css("background-color", flatColorPicker.value());
	                        this.colorPalette.value(null);
	                        this._change(flatColorPicker.value());
	                        dialog.close();
	                    }.bind(this),
	                    close: function() {
	                        flatColorPicker.value(null);
	                        dialog.close();
	                    }
	                });

	                kendo.bind(dialog.element.find(".k-action-buttons"), viewModel);
	            },

	            _resetButton: function() {
	                this.resetButton = $("<a role='button' class='k-button k-reset-color' href='#'>" +
	                                    "<span class='k-icon k-i-reset-color'></span>" + COLOR_PICKER_MESSAGES.reset +
	                                   "</a>").appendTo(this.element);
	            },

	            _customColorButton: function() {
	                this.customColorButton = $("<a role='button' class='k-button k-custom-color' href='#'>" +
	                                            "<span class='k-icon'></span>" + COLOR_PICKER_MESSAGES.customColor +
	                                           "</a>").appendTo(this.element);
	            },

	            resetColor: function() {
	                this.colorPalette.value(null);
	                this.flatColorPicker.value(null);
	                this._change(null);
	            },

	            customColor: function() {
	                this.dialog.open();
	            }

	        });

	        var BorderPalette = kendo.ui.Widget.extend({
	            init: function(element, options) {
	                kendo.ui.Widget.call(this, element, options);

	                this.element = element;
	                this.color = "#000";

	                this.element.addClass("k-spreadsheet-border-palette");

	                this._borderTypePalette();
	                this._borderColorPalette();

	                this.element.on("click", ".k-spreadsheet-border-type-palette .k-button", withPreventDefault(this._click.bind(this)));
	            },

	            options: {
	                name: "BorderPalette"
	            },

	            events: [
	                "change"
	            ],

	            destroy: function() {
	                this.colorChooser.destroy();
	                this.element.off("click");
	            },

	            _borderTypePalette: function() {
	                var messages = BORDER_PALETTE_MESSAGES;
	                var buttons = BORDER_TYPES.map(function(type) {
	                    return '<a role="button" title="' + messages[type] + '" aria-label="' + messages[type] + '" href="#" data-border-type="' + type + '" class="k-button k-button-icon">' +
	                                '<span class="k-icon k-i-' + kendo.toHyphens(type) + '"></span>' +
	                           '</a>';
	                }).join("");

	                var element = $("<div />", {
	                    "class": "k-spreadsheet-border-type-palette",
	                    "html": buttons
	                });

	                element.appendTo(this.element);
	            },

	            _borderColorPalette: function() {
	                var element = $("<div />", {
	                    "class": "k-spreadsheet-border-color-palette"
	                });

	                element.appendTo(this.element);

	                this.colorChooser = new ColorChooser(element, {
	                    color: this.color,
	                    change: this._colorChange.bind(this)
	                });
	            },

	            _click: function(e) {
	                this.type = $(e.currentTarget).data("borderType");
	                this.trigger("change", { type: this.type, color: this.color });
	            },

	            _colorChange: function(e) {
	                this.color = e.value;
	                if (this.type) {
	                    this.trigger("change", { type: this.type, color: this.color });
	                }
	            }
	        });

	        kendo.spreadsheet.ColorChooser = ColorChooser;
	        kendo.spreadsheet.BorderPalette = BorderPalette;

	    })(window.kendo);
	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "wfaU":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(993);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 983:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("/lhy");

/***/ }),

/***/ 993:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(983) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {

	var kendo = window.kendo,
	    Class = kendo.Class,
	    extend = $.extend,
	    proxy = $.proxy,
	    Editor = kendo.ui.editor,
	    dom = Editor.Dom,
	    RangeUtils = Editor.RangeUtils,
	    EditorUtils = Editor.EditorUtils,
	    Command = Editor.Command,
	    Tool = Editor.Tool,
	    ToolTemplate = Editor.ToolTemplate,
	    InlineFormatter = Editor.InlineFormatter,
	    InlineFormatFinder = Editor.InlineFormatFinder,
	    textNodes = RangeUtils.textNodes,
	    editableTextNodes = RangeUtils.editableTextNodes,
	    registerTool = Editor.EditorUtils.registerTool,
	    keys = kendo.keys;

	var HTTP_PROTOCOL = "http://";
	var protocolRegExp = /^\w*:\/\//;
	var endLinkCharsRegExp = /[\w\/\$\-_\*\?]/i;

	var LinkFormatFinder = Class.extend({
	    findSuitable: function (sourceNode) {
	        return dom.parentOfType(sourceNode, ["a"]);
	    }
	});

	var LinkFormatter = Class.extend({
	    init: function() {
	        this.finder = new LinkFormatFinder();
	    },

	    apply: function (range, attributes) {
	        var nodes = this.immutables ? editableTextNodes(range) : textNodes(range);
	        var markers, doc, formatter, a, parent;

	        if (attributes.innerText) {
	            doc = RangeUtils.documentFromRange(range);
	            markers = RangeUtils.getMarkers(range);

	            range.deleteContents();
	            a = dom.create(doc, "a", attributes);
	            range.insertNode(a);

	            parent = a.parentNode;
	            if (dom.name(parent) == "a") {
	                dom.insertAfter(a, parent);
	            }

	            if (dom.emptyNode(parent)) {
	                dom.remove(parent);
	            }

	            // move range and markers after inserted link
	            var ref = a;
	            for (var i = 0; i < markers.length; i++) {
	                dom.insertAfter(markers[i], ref);
	                ref = markers[i];
	            }

	            if (markers.length) {
	                dom.insertBefore(doc.createTextNode("\ufeff"), markers[1] || markers[0]);
	                dom.insertAfter(doc.createTextNode("\ufeff"), markers[1] || markers[0]);
	                range.setStartBefore(markers[0]);
	                range.setEndAfter(markers[markers.length-1]);
	            }
	        } else {
	            formatter = new InlineFormatter([{ tags: ["a"]}], attributes);
	            formatter.finder = this.finder;
	            formatter.apply(nodes);
	        }
	    }
	});

	var UnlinkCommand = Command.extend({
	    init: function(options) {
	        var that = this;
	        options.formatter = /** @ignore */ {
	            toggle : function(range) {
	                var nodes = that.immutables() ? editableTextNodes(range) : textNodes(range);
	                new InlineFormatter([{ tags: ["a"]}]).remove(nodes);
	            }
	        };
	        this.options = options;
	        Command.fn.init.call(this, options);
	    }
	});

	var LinkCommand = Command.extend({
	    init: function(options) {
	        var that;
	        this.options = options;
	        Command.fn.init.call(this, options);
	        this.formatter = new LinkFormatter();

	        if (!options.url) {
	            this.attributes = null;
	            this.async = true;
	        } else {
	            this.exec = function() {
	                this.formatter.immutables = that && that.immutables();
	                this.formatter.apply(options.range, {
	                    href: options.url,
	                    innerText: options.text || options.url,
	                    target: options.target
	                });
	            };
	        }
	    },

	    _dialogTemplate: function() {
	        return kendo.template(
	            '<div class="k-editor-dialog k-popup-edit-form">' +
	                '<div class="k-edit-form-container">' +
	                    "<div class='k-edit-label'>" +
	                        "<label for='k-editor-link-url'>#: messages.linkWebAddress #</label>" +
	                    "</div>" +
	                    "<div class='k-edit-field'>" +
	                        "<input type='text' class='k-textbox' id='k-editor-link-url'>" +
	                    "</div>" +
	                    "<div class='k-edit-label k-editor-link-text-row'>" +
	                        "<label for='k-editor-link-text'>#: messages.linkText #</label>" +
	                    "</div>" +
	                    "<div class='k-edit-field k-editor-link-text-row'>" +
	                        "<input type='text' class='k-textbox' id='k-editor-link-text'>" +
	                    "</div>" +
	                    "<div class='k-edit-label'>" +
	                        "<label for='k-editor-link-title'>#: messages.linkToolTip #</label>" +
	                    "</div>" +
	                    "<div class='k-edit-field'>" +
	                        "<input type='text' class='k-textbox' id='k-editor-link-title'>" +
	                    "</div>" +
	                    "<div class='k-edit-label'></div>" +
	                    "<div class='k-edit-field'>" +
	                        "<input type='checkbox' class='k-checkbox' id='k-editor-link-target'>" +
	                        "<label for='k-editor-link-target' class='k-checkbox-label'>#: messages.linkOpenInNewWindow #</label>" +
	                    "</div>" +
	                    "<div class='k-edit-buttons k-state-default'>" +
	                        '<button class="k-dialog-insert k-button k-primary">#: messages.dialogInsert #</button>' +
	                        '<button class="k-dialog-close k-button">#: messages.dialogCancel #</button>' +
	                    "</div>" +
	                "</div>" +
	            "</div>"
	        )({
	            messages: this.editor.options.messages
	        });
	    },

	    exec: function () {
	        var messages = this.editor.options.messages;
	        this._initialText = "";
	        this._range = this.lockRange(true);
	        this.formatter.immutables = this.immutables();

	        var nodes = textNodes(this._range);
	        var a = nodes.length ? this.formatter.finder.findSuitable(nodes[0]) : null;
	        var img = nodes.length && dom.name(nodes[0]) == "img";

	        var dialog = this.createDialog(this._dialogTemplate(), {
	            title: messages.createLink,
	            close: proxy(this._close, this),
	            visible: false
	        });

	        if (a) {
	            this._range.selectNodeContents(a);
	            nodes = textNodes(this._range);
	        }

	        this._initialText = this.linkText(nodes);

	        dialog
	            .find(".k-dialog-insert").click(proxy(this._apply, this)).end()
	            .find(".k-dialog-close").click(proxy(this._close, this)).end()
	            .find(".k-edit-field input").keydown(proxy(this._keydown, this)).end()
	            .find("#k-editor-link-url").val(this.linkUrl(a)).end()
	            .find("#k-editor-link-text").val(this._initialText).end()
	            .find("#k-editor-link-title").val(a ? a.title : "").end()
	            .find("#k-editor-link-target").attr("checked", a ? a.target == "_blank" : false).end()
	            .find(".k-editor-link-text-row").toggle(!img);

	        this._dialog = dialog.data("kendoWindow").center().open();

	        $("#k-editor-link-url", dialog).focus().select();
	    },

	    _keydown: function (e) {
	        var keys = kendo.keys;

	        if (e.keyCode == keys.ENTER) {
	            this._apply(e);
	        } else if (e.keyCode == keys.ESC) {
	            this._close(e);
	        }
	    },

	    _apply: function (e) {
	        var element = this._dialog.element;
	        var href = $("#k-editor-link-url", element).val();
	        var title, text, target;
	        var textInput = $("#k-editor-link-text", element);

	        if (href && href != HTTP_PROTOCOL) {

	            if (href.indexOf("@") > 0 && !/^(\w+:)|(\/\/)/i.test(href)) {
	                href = "mailto:" + href;
	            }

	            this.attributes = { href: href };

	            title = $("#k-editor-link-title", element).val();
	            if (title) {
	                this.attributes.title = title;
	            }

	            if (textInput.is(":visible")) {
	                text = kendo.trim(textInput.val());
	                if (!text && !this._initialText) {
	                    this.attributes.innerText = href;
	                } else if (text && (text !== this._initialText)) {
	                    this.attributes.innerText = dom.stripBom(text);
	                }
	            }

	            target = $("#k-editor-link-target", element).is(":checked");
	            this.attributes.target = target ? "_blank" : null;

	            this.formatter.apply(this._range, this.attributes);
	        }

	        this._close(e);

	        if (this.change) {
	            this.change();
	        }
	    },

	    _close: function (e) {
	        e.preventDefault();
	        this._dialog.destroy();

	        dom.windowFromDocument(RangeUtils.documentFromRange(this._range)).focus();

	        this.releaseRange(this._range);
	    },

	    linkUrl: function(anchor) {
	        if (anchor) {
	            // IE < 8 returns absolute url if getAttribute is not used
	            return anchor.getAttribute("href", 2);
	        }

	        return HTTP_PROTOCOL;
	    },

	    linkText: function (nodes) {
	        var text = "";
	        var i;

	        for (i = 0; i < nodes.length; i++) {
	            text += nodes[i].nodeValue;
	        }

	        return dom.stripBom(text || "");
	    },

	    redo: function () {
	        var range = this.lockRange(true);

	        this.formatter.apply(range, this.attributes);
	        this.releaseRange(range);
	    }

	});

	var AutoLinkCommand = Command.extend({
	    init: function (options) {
	        Command.fn.init.call(this, options);

	        this.formatter = new LinkFormatter();
	    },

	    exec: function () {
	        var detectedLink = this.detectLink();
	        if (!detectedLink) {
	            return;
	        }

	        var range = this.getRange();
	        var linkMarker = new kendo.ui.editor.Marker();
	        var linkRange = range.cloneRange();

	        linkRange.setStart(detectedLink.start.node, detectedLink.start.offset);
	        linkRange.setEnd(detectedLink.end.node, detectedLink.end.offset);

	        range = this.lockRange();
	        linkMarker.add(linkRange);

	        this.formatter.apply(linkRange, {
	            href: this._ensureWebProtocol(detectedLink.text)
	        });

	        linkMarker.remove(linkRange);
	        this.releaseRange(range);
	    },

	    detectLink: function () {
	        var range = this.getRange();
	        var startNode = range.startContainer;
	        var startOffset = range.startOffset;
	        var prev = startNode.previousSibling;
	        if (!prev && ((dom.isBom(startNode) && !startNode.nextSibling) || (!startOffset && dom.isDataNode(startNode)))) {
	            startNode = startNode.parentNode;
	            startOffset = 0;
	        }
	        var traverser = new LeftDomTextTraverser({
	            node: startNode,
	            offset: startOffset,
	            cancelAtNode: function(node) { return node && dom.name(node) === "a"; }
	        });

	        var detection = new DomTextLinkDetection(traverser);
	        return detection.detectLink();
	    },

	    changesContent: function() {
	        return !!this.detectLink();
	    },

	    _ensureWebProtocol: function (linkText) {
	        var hasProtocol = this._hasProtocolPrefix(linkText);
	        return hasProtocol ? linkText : this._prefixWithWebProtocol(linkText);
	    },

	    _hasProtocolPrefix: function(linkText) {
	        return protocolRegExp.test(linkText);
	    },

	    _prefixWithWebProtocol: function(linkText) {
	        return HTTP_PROTOCOL + linkText;
	    }
	});

	var UnlinkTool = Tool.extend({
	    init: function(options) {
	        this.options = options;
	        this.finder = new InlineFormatFinder([{tags:["a"]}]);

	        Tool.fn.init.call(this, $.extend(options, {command:UnlinkCommand}));
	    },

	    initialize: function(ui, options) {
	        Tool.fn.initialize.call(this, ui, options);
	        ui.addClass("k-state-disabled");
	    },

	    update: function (ui, nodes) {
	        ui.toggleClass("k-state-disabled", !this.finder.isFormatted(nodes))
	          .removeClass("k-state-hover");
	    }
	});

	var DomTextLinkDetection = Class.extend({
	    init: function (traverser) {
	        this.traverser = traverser;
	        this.start = DomPos();
	        this.end = DomPos();
	        this.text = "";
	    },

	    detectLink: function () {
	        var node = this.traverser.node;
	        var offset = this.traverser.offset;
	        if (dom.isDataNode(node)) {
	            var text = node.data.substring(0, offset);
	            if (/\s{2}$/.test(dom.stripBom(text))) {
	                return;
	            }
	        } else if (offset === 0) {//heuristic for new line
	            var p = dom.closestEditableOfType(node, dom.blockElements);
	            if (p && p.previousSibling) {
	                this.traverser.init({
	                    node: p.previousSibling
	                });
	            }
	        }

	        this.traverser.traverse($.proxy(this._detectEnd, this));
	        if (!this.end.blank()) {
	            this.traverser = this.traverser.clone(this.end);
	            this.traverser.traverse($.proxy(this._detectStart, this));

	            if (!this._isLinkDetected()) {
	                var puntuationOptions = this.traverser.extendOptions(this.start);
	                var puntuationTraverser = new RightDomTextTraverser(puntuationOptions);
	                puntuationTraverser.traverse($.proxy(this._skipStartPuntuation, this));
	                if (!this._isLinkDetected()) {
	                    this.start = DomPos();
	                }
	            }
	        }

	        if (this.start.blank()) {
	            return null;
	        } else {
	            return {
	                start: this.start,
	                end: this.end,
	                text: this.text
	            };
	        }
	    },

	    _isLinkDetected: function() {
	        return protocolRegExp.test(this.text) || /^w{3}\./i.test(this.text);
	    },

	    _detectEnd: function(text, node) {
	        var i = lastIndexOfRegExp(text, endLinkCharsRegExp);
	        if (i > -1) {
	            this.end.node = node;
	            this.end.offset = i + 1;

	            return false;
	        }
	    },

	    _detectStart: function(text, node) {
	        var i = lastIndexOfRegExp(text, /\s/);
	        var ii = i + 1;
	        this.text = text.substring(ii) + this.text;

	        this.start.node = node;
	        this.start.offset = ii;

	        if (i > -1) {
	            return false;
	        }
	    },

	    _skipStartPuntuation: function(text, node, offset) {
	        var i = indexOfRegExp(text, /\w/);
	        var ii = i;
	        if (i === -1) {
	            ii = text.length;
	        }

	        this.text = this.text.substring(ii);
	        this.start.node = node;
	        this.start.offset = ii + (offset |0);

	        if (i > -1) {
	            return false;
	        }
	    }
	});

	function lastIndexOfRegExp(str, search) {
	    var i = str.length;
	    while (i-- && !search.test(str[i])) {}

	    return i;
	}
	function indexOfRegExp(str, search) {
	    var r = search.exec(str);

	    return r ? r.index : -1;
	}

	var DomPos = function() {
	    return {
	        node: null,
	        offset: null,
	        blank: function() {
	            return this.node === null && this.offset === null;
	        }
	    };
	};

	var DomTextTraverser = Class.extend({
	    init: function (options) {
	        this.node = options.node;
	        this.offset = options.offset === undefined ? (dom.isDataNode(this.node) && this.node.length) || 0 : options.offset;
	        this.cancelAtNode = options.cancelAtNode || this.cancelAtNode || $.noop;
	    },

	    traverse: function (callback) {
	        if (!callback) {
	            return;
	        }
	        this.cancel = false;
	        this._traverse(callback, this.node, this.offset);
	    },

	    _traverse: function (callback, node, offset) {
	        if (!node || this.cancel) {
	            return;
	        }
	        if (node.nodeType === 3) {
	            var text = node.data;
	            if (offset !== undefined) {
	                text = this.subText(text, offset);
	            }
	            this.cancel = (callback(text, node, offset) === false);
	        }
	        else {
	            var edgeNode = this.edgeNode(node);
	            this.cancel = this.cancel || this.cancelAtNode(edgeNode);
	            return this._traverse(callback, edgeNode);
	        }

	        var next = this.next(node);
	        if (!next) {
	            var parent = node.parentNode;
	            while (!next && dom.isInline(parent)) {
	                next = this.next(parent);
	                parent = parent.parentNode;
	            }
	        }
	        this.cancel = this.cancel || this.cancelAtNode(next);
	        this._traverse(callback, next);
	    },

	    extendOptions: function(o) {
	        return $.extend({
	            node: this.node,
	            offset: this.offset,
	            cancelAtNode: this.cancelAtNode
	        }, o || {});
	    },

	    edgeNode: function(node) {}, //jshint ignore: line
	    next: function(node) {}, //jshint ignore: line
	    subText: function(text, offset) {} //jshint ignore: line

	});

	var LeftDomTextTraverser = DomTextTraverser.extend({
	    subText: function(text, splitIndex) {
	        return text.substring(0, splitIndex);
	    },

	    next: function(node) {
	        return node.previousSibling;
	    },

	    edgeNode: function(node) {
	        return node.lastChild;
	    },

	    clone: function(options) {
	        var o = this.extendOptions(options);
	        return new LeftDomTextTraverser(o);
	    }
	});

	var RightDomTextTraverser = DomTextTraverser.extend({
	    subText: function(text, splitIndex) {
	        return text.substring(splitIndex);
	    },

	    next: function(node) {
	        return node.nextSibling;
	    },

	    edgeNode: function(node) {
	        return node.firstChild;
	    },

	    clone: function(options) {
	        var o = this.extendOptions(options);
	        return new RightDomTextTraverser(o);
	    }
	});

	extend(kendo.ui.editor, {
	    LinkFormatFinder: LinkFormatFinder,
	    LinkFormatter: LinkFormatter,
	    UnlinkCommand: UnlinkCommand,
	    LinkCommand: LinkCommand,
	    AutoLinkCommand: AutoLinkCommand,
	    UnlinkTool: UnlinkTool,
	    DomTextLinkDetection: DomTextLinkDetection,
	    LeftDomTextTraverser: LeftDomTextTraverser,
	    RightDomTextTraverser: RightDomTextTraverser
	});

	registerTool("createLink", new Tool({ key: "K", ctrl: true, command: LinkCommand, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Create Link"})}));
	registerTool("unlink", new UnlinkTool({ key: "K", ctrl: true, shift: true, template: new ToolTemplate({template: EditorUtils.buttonTemplate, title: "Remove Link"})}));
	registerTool("autoLink", new Tool({ key: [keys.ENTER, keys.SPACEBAR], keyPressCommand: true, command: AutoLinkCommand }));

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "x4W5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var popupEditorWrapper_1 = __webpack_require__("KnXB");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var componentResolver_1 = __webpack_require__("migL");
var CellEditorFactory = (function () {
    function CellEditorFactory() {
    }
    CellEditorFactory.prototype.init = function () {
    };
    CellEditorFactory.prototype.addCellEditor = function (key, cellEditor) {
        console.warn("ag-grid: since v13.3.1 this method is not supported anymore. If you want to register your own editor check the docs: https://www.ag-grid.com/javascript-grid-cell-editor/");
    };
    // private registerEditorsFromGridOptions(): void {
    //     let userProvidedCellEditors = this.gridOptionsWrapper.getCellEditors();
    //     _.iterateObject(userProvidedCellEditors, (key: string, cellEditor: {new(): ICellEditor})=> {
    //         this.addCellEditor(key, cellEditor);
    //     });
    // }
    CellEditorFactory.prototype.createCellEditor = function (column, params) {
        var _this = this;
        var cellEditorPromise = this.componentResolver.createAgGridComponent(column, params, 'cellEditor', {
            api: params.api,
            columnApi: params.columnApi,
            node: params.node,
            data: params.node.data,
            rowIndex: params.rowIndex,
            column: params.column,
            colDef: params.column.getColDef()
        }, 'agCellEditor');
        return cellEditorPromise.map(function (cellEditor) {
            var isPopup = cellEditor.isPopup && cellEditor.isPopup();
            if (!isPopup) {
                return cellEditor;
            }
            if (_this.gridOptionsWrapper.isFullRowEdit()) {
                console.warn('ag-Grid: popup cellEditor does not work with fullRowEdit - you cannot use them both ' +
                    '- either turn off fullRowEdit, or stop using popup editors.');
            }
            // if a popup, then we wrap in a popup editor and return the popup
            var popupEditorWrapper = new popupEditorWrapper_1.PopupEditorWrapper(cellEditor);
            _this.context.wireBean(popupEditorWrapper);
            popupEditorWrapper.init(params);
            return popupEditorWrapper;
        });
    };
    __decorate([
        context_1.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], CellEditorFactory.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('componentResolver'),
        __metadata("design:type", componentResolver_1.ComponentResolver)
    ], CellEditorFactory.prototype, "componentResolver", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], CellEditorFactory.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CellEditorFactory.prototype, "init", null);
    CellEditorFactory = __decorate([
        context_1.Bean('cellEditorFactory')
    ], CellEditorFactory);
    return CellEditorFactory;
}());
exports.CellEditorFactory = CellEditorFactory;


/***/ }),

/***/ "x5ih":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
function QuerySelector(selector) {
    return querySelectorFunc.bind(this, selector);
}
exports.QuerySelector = QuerySelector;
function RefSelector(ref) {
    return querySelectorFunc.bind(this, '[ref=' + ref + ']');
}
exports.RefSelector = RefSelector;
function querySelectorFunc(selector, classPrototype, methodOrAttributeName, index) {
    if (selector === null) {
        console.error('ag-Grid: QuerySelector selector should not be null');
        return;
    }
    if (typeof index === 'number') {
        console.error('ag-Grid: QuerySelector should be on an attribute');
        return;
    }
    // it's an attribute on the class
    var props = getOrCreateProps(classPrototype, classPrototype.constructor.name);
    if (!props.querySelectors) {
        props.querySelectors = [];
    }
    props.querySelectors.push({
        attributeName: methodOrAttributeName,
        querySelector: selector
    });
}
function Listener(eventName) {
    return listenerFunc.bind(this, eventName);
}
exports.Listener = Listener;
function listenerFunc(eventName, target, methodName, descriptor) {
    if (eventName === null) {
        console.error('ag-Grid: EventListener eventName should not be null');
        return;
    }
    // it's an attribute on the class
    var props = getOrCreateProps(target, target.constructor.name);
    if (!props.listenerMethods) {
        props.listenerMethods = [];
    }
    props.listenerMethods.push({
        methodName: methodName,
        eventName: eventName
    });
}
function getOrCreateProps(target, instanceName) {
    if (!target.__agComponentMetaData) {
        target.__agComponentMetaData = {};
    }
    if (!target.__agComponentMetaData[instanceName]) {
        target.__agComponentMetaData[instanceName] = {};
    }
    return target.__agComponentMetaData[instanceName];
}


/***/ }),

/***/ "xLtR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var transformData = __webpack_require__("TNV1");
var isCancel = __webpack_require__("pBtG");
var defaults = __webpack_require__("KCLY");
var isAbsoluteURL = __webpack_require__("dIwP");
var combineURLs = __webpack_require__("qRfI");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "xRx6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var rowNode_1 = __webpack_require__("bP2e");
var context_1 = __webpack_require__("RQ1/");
var eventService_1 = __webpack_require__("k5uU");
var context_2 = __webpack_require__("RQ1/");
var events_1 = __webpack_require__("3ok8");
var context_3 = __webpack_require__("RQ1/");
var constants_1 = __webpack_require__("ZZFX");
var utils_1 = __webpack_require__("IRr6");
var columnApi_1 = __webpack_require__("E/Wy");
var gridApi_1 = __webpack_require__("BAow");
var PinnedRowModel = (function () {
    function PinnedRowModel() {
    }
    PinnedRowModel.prototype.init = function () {
        this.setPinnedTopRowData(this.gridOptionsWrapper.getPinnedTopRowData());
        this.setPinnedBottomRowData(this.gridOptionsWrapper.getPinnedBottomRowData());
    };
    PinnedRowModel.prototype.isEmpty = function (floating) {
        var rows = floating === constants_1.Constants.PINNED_TOP ? this.pinnedTopRows : this.pinnedBottomRows;
        return utils_1.Utils.missingOrEmpty(rows);
    };
    PinnedRowModel.prototype.isRowsToRender = function (floating) {
        return !this.isEmpty(floating);
    };
    PinnedRowModel.prototype.getRowAtPixel = function (pixel, floating) {
        var rows = floating === constants_1.Constants.PINNED_TOP ? this.pinnedTopRows : this.pinnedBottomRows;
        if (utils_1.Utils.missingOrEmpty(rows)) {
            return 0; // this should never happen, just in case, 0 is graceful failure
        }
        for (var i = 0; i < rows.length; i++) {
            var rowNode = rows[i];
            var rowTopPixel = rowNode.rowTop + rowNode.rowHeight - 1;
            // only need to range check against the top pixel, as we are going through the list
            // in order, first row to hit the pixel wins
            if (rowTopPixel >= pixel) {
                return i;
            }
        }
        return rows.length - 1;
    };
    PinnedRowModel.prototype.setPinnedTopRowData = function (rowData) {
        this.pinnedTopRows = this.createNodesFromData(rowData, true);
        var event = {
            type: events_1.Events.EVENT_PINNED_ROW_DATA_CHANGED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(event);
    };
    PinnedRowModel.prototype.setPinnedBottomRowData = function (rowData) {
        this.pinnedBottomRows = this.createNodesFromData(rowData, false);
        var event = {
            type: events_1.Events.EVENT_PINNED_ROW_DATA_CHANGED,
            api: this.gridApi,
            columnApi: this.columnApi
        };
        this.eventService.dispatchEvent(event);
    };
    PinnedRowModel.prototype.createNodesFromData = function (allData, isTop) {
        var _this = this;
        var rowNodes = [];
        if (allData) {
            var nextRowTop_1 = 0;
            allData.forEach(function (dataItem, index) {
                var rowNode = new rowNode_1.RowNode();
                _this.context.wireBean(rowNode);
                rowNode.data = dataItem;
                rowNode.rowPinned = isTop ? constants_1.Constants.PINNED_TOP : constants_1.Constants.PINNED_BOTTOM;
                rowNode.setRowTop(nextRowTop_1);
                rowNode.setRowHeight(_this.gridOptionsWrapper.getRowHeightForNode(rowNode));
                rowNode.setRowIndex(index);
                nextRowTop_1 += rowNode.rowHeight;
                rowNodes.push(rowNode);
            });
        }
        return rowNodes;
    };
    PinnedRowModel.prototype.getPinnedTopRowData = function () {
        return this.pinnedTopRows;
    };
    PinnedRowModel.prototype.getPinnedBottomRowData = function () {
        return this.pinnedBottomRows;
    };
    PinnedRowModel.prototype.getPinnedTopTotalHeight = function () {
        return this.getTotalHeight(this.pinnedTopRows);
    };
    PinnedRowModel.prototype.getPinnedTopRowCount = function () {
        return this.pinnedTopRows ? this.pinnedTopRows.length : 0;
    };
    PinnedRowModel.prototype.getPinnedBottomRowCount = function () {
        return this.pinnedBottomRows ? this.pinnedBottomRows.length : 0;
    };
    PinnedRowModel.prototype.getPinnedTopRow = function (index) {
        return this.pinnedTopRows[index];
    };
    PinnedRowModel.prototype.getPinnedBottomRow = function (index) {
        return this.pinnedBottomRows[index];
    };
    PinnedRowModel.prototype.forEachPinnedTopRow = function (callback) {
        if (utils_1.Utils.missingOrEmpty(this.pinnedTopRows)) {
            return;
        }
        this.pinnedTopRows.forEach(callback);
    };
    PinnedRowModel.prototype.forEachPinnedBottomRow = function (callback) {
        if (utils_1.Utils.missingOrEmpty(this.pinnedBottomRows)) {
            return;
        }
        this.pinnedBottomRows.forEach(callback);
    };
    PinnedRowModel.prototype.getPinnedBottomTotalHeight = function () {
        return this.getTotalHeight(this.pinnedBottomRows);
    };
    PinnedRowModel.prototype.getTotalHeight = function (rowNodes) {
        if (!rowNodes || rowNodes.length === 0) {
            return 0;
        }
        else {
            var lastNode = rowNodes[rowNodes.length - 1];
            return lastNode.rowTop + lastNode.rowHeight;
        }
    };
    __decorate([
        context_2.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], PinnedRowModel.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_2.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], PinnedRowModel.prototype, "eventService", void 0);
    __decorate([
        context_2.Autowired('context'),
        __metadata("design:type", context_1.Context)
    ], PinnedRowModel.prototype, "context", void 0);
    __decorate([
        context_2.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], PinnedRowModel.prototype, "columnApi", void 0);
    __decorate([
        context_2.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], PinnedRowModel.prototype, "gridApi", void 0);
    __decorate([
        context_3.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PinnedRowModel.prototype, "init", null);
    PinnedRowModel = __decorate([
        context_1.Bean('pinnedRowModel')
    ], PinnedRowModel);
    return PinnedRowModel;
}());
exports.PinnedRowModel = PinnedRowModel;


/***/ }),

/***/ "xTQk":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1640);
	module.exports = __webpack_require__(1640);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1640:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    var UndoRedoStack = kendo.Observable.extend({
	        init: function(options) {
	            kendo.Observable.fn.init.call(this, options);
	            this.clear();
	        },
	        events: [ "undo", "redo" ],
	        push: function (command) {
	            this.stack = this.stack.slice(0, this.currentCommandIndex + 1);
	            this.currentCommandIndex = this.stack.push(command) - 1;
	        },
	        undo: function () {
	            if (this.canUndo()) {
	                var command = this.stack[this.currentCommandIndex--];
	                command.undo();
	                this.trigger("undo", { command: command });
	            }
	        },
	        redo: function () {
	            if (this.canRedo()) {
	                var command = this.stack[++this.currentCommandIndex];
	                command.redo();
	                this.trigger("redo", { command: command });
	            }
	        },
	        clear: function() {
	            this.stack = [];
	            this.currentCommandIndex = -1;
	        },
	        canUndo: function () {
	            return this.currentCommandIndex >= 0;
	        },
	        canRedo: function () {
	            return this.currentCommandIndex != this.stack.length - 1;
	        }
	    });

	    kendo.deepExtend(kendo, {
	        util: {
	            UndoRedoStack: UndoRedoStack
	        }
	    });
	})(kendo);
	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "xUPt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var richSelectRow_1 = __webpack_require__("bR1D");
var virtualList_1 = __webpack_require__("X1NG");
var ag_grid_1 = __webpack_require__("F6Mk");
var RichSelectCellEditor = (function (_super) {
    __extends(RichSelectCellEditor, _super);
    function RichSelectCellEditor() {
        var _this = _super.call(this, RichSelectCellEditor.TEMPLATE) || this;
        _this.selectionConfirmed = false;
        return _this;
    }
    RichSelectCellEditor.prototype.init = function (params) {
        this.params = params;
        this.selectedValue = params.value;
        this.originalSelectedValue = params.value;
        this.focusAfterAttached = params.cellStartedEdit;
        this.virtualList = new virtualList_1.VirtualList();
        this.context.wireBean(this.virtualList);
        this.virtualList.setComponentCreator(this.createRowComponent.bind(this));
        this.getRefElement('eList').appendChild(this.virtualList.getGui());
        if (main_1.Utils.exists(this.params.cellHeight)) {
            this.virtualList.setRowHeight(this.params.cellHeight);
        }
        this.renderSelectedValue();
        if (main_1.Utils.missing(params.values)) {
            console.log('ag-Grid: richSelectCellEditor requires values for it to work');
            return;
        }
        var values = params.values;
        this.virtualList.setModel({
            getRowCount: function () { return values.length; },
            getRow: function (index) { return values[index]; }
        });
        this.addGuiEventListener('keydown', this.onKeyDown.bind(this));
        this.addDestroyableEventListener(this.virtualList.getGui(), 'click', this.onClick.bind(this));
        this.addDestroyableEventListener(this.virtualList.getGui(), 'mousemove', this.onMouseMove.bind(this));
    };
    RichSelectCellEditor.prototype.onKeyDown = function (event) {
        var key = event.which || event.keyCode;
        switch (key) {
            case main_1.Constants.KEY_ENTER:
                this.onEnterKeyDown();
                break;
            case main_1.Constants.KEY_DOWN:
            case main_1.Constants.KEY_UP:
                this.onNavigationKeyPressed(event, key);
                break;
        }
    };
    RichSelectCellEditor.prototype.onEnterKeyDown = function () {
        this.selectionConfirmed = true;
        this.params.stopEditing();
    };
    RichSelectCellEditor.prototype.onNavigationKeyPressed = function (event, key) {
        // if we don't stop propagation, then the grids navigation kicks in
        event.stopPropagation();
        var oldIndex = this.params.values.indexOf(this.selectedValue);
        var newIndex = key === main_1.Constants.KEY_UP ? oldIndex - 1 : oldIndex + 1;
        if (newIndex >= 0 && newIndex < this.params.values.length) {
            var valueToSelect = this.params.values[newIndex];
            this.setSelectedValue(valueToSelect);
        }
    };
    RichSelectCellEditor.prototype.renderSelectedValue = function () {
        var _this = this;
        var valueFormatted = this.params.formatValue(this.selectedValue);
        var eValue = this.getRefElement('eValue');
        var promise = this.cellRendererService.useRichSelectCellRenderer(this.params.column.getColDef(), eValue, { value: this.selectedValue, valueFormatted: valueFormatted });
        var foundRenderer = ag_grid_1._.exists(promise);
        if (foundRenderer) {
            promise.then(function (renderer) {
                if (renderer && renderer.destroy) {
                    _this.addDestroyFunc(function () { return renderer.destroy(); });
                }
            });
        }
        else {
            if (main_1.Utils.exists(this.selectedValue)) {
                eValue.innerHTML = valueFormatted;
            }
            else {
                eValue.innerHTML = '';
            }
        }
    };
    RichSelectCellEditor.prototype.setSelectedValue = function (value) {
        if (this.selectedValue === value) {
            return;
        }
        var index = this.params.values.indexOf(value);
        if (index >= 0) {
            this.selectedValue = value;
            this.virtualList.ensureIndexVisible(index);
            this.virtualList.refresh();
        }
    };
    RichSelectCellEditor.prototype.createRowComponent = function (value) {
        var valueFormatted = this.params.formatValue(value);
        var row = new richSelectRow_1.RichSelectRow(this.params.column.getColDef());
        this.context.wireBean(row);
        row.setState(value, valueFormatted, value === this.selectedValue);
        return row;
    };
    RichSelectCellEditor.prototype.onMouseMove = function (mouseEvent) {
        var rect = this.virtualList.getGui().getBoundingClientRect();
        var scrollTop = this.virtualList.getScrollTop();
        var mouseY = mouseEvent.clientY - rect.top + scrollTop;
        var row = Math.floor(mouseY / this.virtualList.getRowHeight());
        var value = this.params.values[row];
        // not using utils.exist() as want empty string test to pass
        if (value !== undefined) {
            this.setSelectedValue(value);
        }
    };
    RichSelectCellEditor.prototype.onClick = function () {
        this.selectionConfirmed = true;
        this.params.stopEditing();
    };
    // we need to have the gui attached before we can draw the virtual rows, as the
    // virtual row logic needs info about the gui state
    RichSelectCellEditor.prototype.afterGuiAttached = function () {
        var selectedIndex = this.params.values.indexOf(this.selectedValue);
        // we have to call this here to get the list to have the right height, ie
        // otherwise it would not have scrolls yet and ensureIndeVisible would do nothing
        this.virtualList.refresh();
        if (selectedIndex >= 0) {
            this.virtualList.ensureIndexVisible(selectedIndex);
        }
        // we call refresh again, as the list could of moved, and we need to render the new rows
        this.virtualList.refresh();
        if (this.focusAfterAttached) {
            this.getGui().focus();
        }
    };
    RichSelectCellEditor.prototype.getValue = function () {
        if (this.selectionConfirmed) {
            return this.selectedValue;
        }
        else {
            return this.originalSelectedValue;
        }
    };
    RichSelectCellEditor.prototype.isPopup = function () {
        return true;
    };
    RichSelectCellEditor.TEMPLATE = 
    // tab index is needed so we can focus, which is needed for keyboard events
    '<div class="ag-rich-select" tabindex="0">' +
        '<div ref="eValue" class="ag-rich-select-value"></div>' +
        '<div ref="eList" class="ag-rich-select-list"></div>' +
        '</div>';
    __decorate([
        main_1.Autowired('context'),
        __metadata("design:type", main_1.Context)
    ], RichSelectCellEditor.prototype, "context", void 0);
    __decorate([
        main_1.Autowired('cellRendererService'),
        __metadata("design:type", main_1.CellRendererService)
    ], RichSelectCellEditor.prototype, "cellRendererService", void 0);
    return RichSelectCellEditor;
}(main_1.Component));
exports.RichSelectCellEditor = RichSelectCellEditor;


/***/ }),

/***/ "xVbs":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1571);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 887:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1571:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(887)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "dpl-processor",
	    name: "DPL-Processor",
	    category: "framework",
	    depends: [ "core" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        extend = $.extend,
	        Class = kendo.Class;

	    var DPLProcessor = Class.extend({
	        init: function(options, viewer) {
	            var that = this;

	            that.options = options;
	            that.read = options.read;
	            that.upload = options.upload;
	            that.download = options.download;

	            that.viewer = viewer;
	        },
	        fetchDocument: function () {
	            var that = this,
	                deferred = $.Deferred(),
	                errorMessages = that.viewer.options.messages.errorMessages;

	            if (!that.read) {
	                return deferred.resolve();
	            }

	            $.ajax({
	                type: that.read.type,
	                url: that.read.url,
	                dataType: that.read.dataType,
	                success: function (data) {
	                    if (typeof data != "string") {
	                        data = kendo.stringify(data);
	                    }
	                    deferred.resolve(JSON.parse(data));
	                },
	                error: function (xhr) {
	                    that.viewer._triggerError({
	                        error: xhr.responseText,
	                        message: errorMessages.parseError
	                    });
	                }
	            });

	            return deferred;
	        },
	        fetchPageData: function (number) {
	            var that = this;
	            var deferred = $.Deferred();
	            var page = that.viewer.document.pages[number - 1];
	            var data = {};
	            data[that.read.pageField] = number;

	            if (!page.geometries.length) {
	                $.ajax({
	                    type: that.read.type,
	                    url: that.read.url,
	                    data: data,
	                    success: function (data) {
	                        deferred.resolve(JSON.parse(data));
	                    },
	                    error: function (xhr) {
	                        that.viewer._triggerError({
	                            error: xhr.responseText,
	                            message: that.viewer.options.messages.errorMessages.parseError
	                        });
	                    }
	                });
	            } else {
	                deferred.resolve(page);
	            }

	            return deferred;
	        },
	        downloadFile: function (fileName) {
	            window.location = this.download.url + "?file=" + fileName;
	        },

	        fromJSON: function (json)
	        {
	            var viewer = this.viewer;
	            viewer._clearPages();

	            viewer.document = json;
	            viewer.document.total = viewer.document.pages.length;

	            viewer._renderPages();
	            viewer.resize(true);

	            viewer.activatePage(1);
	        }
	    });

	    extend(kendo.pdfviewer, {
	        dpl: {
	            processor: DPLProcessor
	        }
	    });
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "xW2y":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(963);
	module.exports = __webpack_require__(963);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(964) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {
	    var kendo = window.kendo,
	        Class = kendo.Class,
	        Editor = kendo.ui.editor,
	        dom = Editor.Dom,
	        template = kendo.template,
	        RangeUtils = Editor.RangeUtils,
	        complexBlocks = ["ul", "ol", "tbody", "thead", "table"],
	        toolsToBeUpdated = [
	            "bold",
	            "italic",
	            "underline",
	            "strikethrough",
	            "superscript",
	            "subscript",
	            "forecolor",
	            "backcolor",
	            "fontname",
	            "fontsize",
	            "createlink",
	            "unlink",
	            "autolink",
	            "addcolumnleft",
	            "addcolumnright",
	            "addrowabove",
	            "addrowbelow",
	            "deleterow",
	            "deletecolumn",
	            "mergecells",
	            "formatting",
	            "cleanformatting" ],
	        IMMUTABALE = "k-immutable",
	        IMMUTABALE_MARKER_SELECTOR = "[" + IMMUTABALE + "]",
	        IMMUTABLE_SELECTOR = "[contenteditable='false']";

	    var rootCondition = function(node) {
	        return $(node).is("body,.k-editor");
	    };

	    var immutable = function(node) {
	        return node.getAttribute && node.getAttribute("contenteditable") == "false";
	    };

	    var immutableParent = function (node) {
	        return dom.closestBy(node, immutable, rootCondition);
	    };

	    var expandImmutablesIn = function(range) {
	        var startImmutableParent = immutableParent(range.startContainer);
	        var endImmutableParent = immutableParent(range.endContainer);

	        if (startImmutableParent || endImmutableParent) {
	            if (startImmutableParent){
	                range.setStartBefore(startImmutableParent);
	            }
	            if (endImmutableParent){
	                range.setEndAfter(endImmutableParent);
	            }
	        }
	    };

	    var immutablesContext = function(range) {
	        if (immutableParent(range.commonAncestorContainer)) {
	            return true;
	        } else if(immutableParent(range.startContainer) || immutableParent(range.endContainer)){
	            var editableNodes = RangeUtils.editableTextNodes(range);
	            if (editableNodes.length === 0){
	                return true;
	            }
	        }
	        return false;
	    };

	    var randomId = function(length) {
	        var result = '';
	        var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
	        for (var i = length || 10; i > 0; --i) {
	            result += chars.charAt(Math.round(Math.random() * (chars.length - 1)));
	        }
	        return result;
	    };

	    var removeImmutables = function (root) {
	        var serializedImmutables = {empty: true}, nodeName, id, serialized;
	         $(root).find(IMMUTABLE_SELECTOR).each(function(i, node){
	            nodeName = dom.name(node);
	            id = randomId();
	            serialized = "<" + nodeName + " " + IMMUTABALE + "='" + id + "'></" + nodeName + ">";
	            serializedImmutables[id] = {node: node, style: $(node).attr("style")};
	            serializedImmutables.empty = false;
	            $(node).replaceWith(serialized);
	        });

	        return serializedImmutables;
	    };

	    var restoreImmutables = function(root, serializedImmutables) {
	        var id, immutable;
	        $(root).find(IMMUTABALE_MARKER_SELECTOR).each(function(i, node) {
	            id = node.getAttribute(IMMUTABALE);
	            immutable = serializedImmutables[id];
	            $(node).replaceWith(immutable.node);
	            if (immutable.style != $(immutable.node).attr("style")) {
	                $(immutable.node).removeAttr("style").attr("style", immutable.style);
	            }
	        });
	    };

	    var deletingKey = function (keyCode) {
	        var keys = kendo.keys;
	        return keyCode === keys.BACKSPACE || keyCode == keys.DELETE;
	    };
	    var updateToolOptions = function(tool) {
	        var options = tool ? tool.options : undefined;
	        if (options && options.finder) {
	            options.finder._initOptions({immutables: true});
	        }
	    };

	    var Immutables = Class.extend({
	        init: function (editor) {
	            this.editor = editor;
	            this.serializedImmutables = {};
	            this.options = $.extend({}, editor && editor.options && editor.options.immutables);

	            var tools = editor.toolbar.tools;
	            updateToolOptions(tools.justifyLeft);
	            updateToolOptions(tools.justifyCenter);
	            updateToolOptions(tools.justifyRight);
	            updateToolOptions(tools.justifyFull);
	        },

	        serialize: function(node) {
	            var result = this._toHtml(node),
	                id;

	            if (result.indexOf(IMMUTABALE) === -1) {
	                id = this.randomId();
	                result = result.replace(/>/, ' ' + IMMUTABALE + '="' + id + '">');
	            } else {
	                id = result.match(/k-immutable\s*=\s*['"](.*)['"]/)[1];
	            }

	            this.serializedImmutables[id] = node;
	            return result;
	        },

	        _toHtml: function(node){
	            var serialization = this.options.serialization;
	            var serializationType = typeof serialization;
	            var nodeName;

	            switch (serializationType) {
	                case "string":
	                    return template(serialization)(node);
	                case "function":
	                    return serialization(node);
	                default:
	                    nodeName = dom.name(node);
	                    return "<" + nodeName + "></" + nodeName + ">";
	            }
	        },

	        deserialize: function(node) {
	            var that = this;
	            var deserialization = this.options.deserialization;

	            $(IMMUTABALE_MARKER_SELECTOR, node).each(function() {
	                var id = this.getAttribute(IMMUTABALE);
	                var immutable = that.serializedImmutables[id];
	                if (kendo.isFunction(deserialization)) {
	                    deserialization(this, immutable);
	                }
	                $(this).replaceWith(immutable);
	            });

	            that.serializedImmutables = {};
	        },

	        randomId: function (length) {
	            return randomId(length);
	        },

	        keydown: function(e, range) {
	            var isDeleting = deletingKey(e.keyCode);
	            var shouldCancelEvent = (isDeleting && this._cancelDeleting(e, range)) ||
	                (!isDeleting && this._cancelTyping(e, range));

	            if (shouldCancelEvent) {
	                e.preventDefault();
	                return true;
	            }
	        },

	        _cancelTyping: function(e, range) {
	            var editor = this.editor;
	            var keyboard = editor.keyboard;

	            return range.collapsed && !keyboard.typingInProgress &&
	                keyboard.isTypingKey(e) && immutablesContext(range);
	        },

	        _cancelDeleting: function(e, range) {
	            var keys = kendo.keys;
	            var backspace = e.keyCode === keys.BACKSPACE;
	            var del = e.keyCode == keys.DELETE;

	            if (!backspace && !del) {
	                return false;
	            }
	            var cancelDeleting = false;
	            if (range.collapsed) {
	                if (immutablesContext(range)) {
	                    return true;
	                }
	                var immutable = this.nextImmutable(range, del);
	                if (immutable && backspace) {
	                    var closestSelectionLi = dom.closest(range.commonAncestorContainer, "li");
	                    if (closestSelectionLi) {
	                        var closestImmutableLi = dom.closest(immutable, "li");
	                        if (closestImmutableLi && closestImmutableLi !== closestSelectionLi) {
	                            return cancelDeleting;
	                        }
	                    }
	                }
	                if (immutable && !dom.tableCell(immutable)) {
	                    if (dom.parentOfType(immutable, complexBlocks) === dom.parentOfType(range.commonAncestorContainer, complexBlocks)) {
	                        while (immutable && immutable.parentNode.childNodes.length == 1) {
	                            immutable = immutable.parentNode;
	                        }
	                        if (dom.tableCell(immutable)) {
	                            return cancelDeleting;
	                        }
	                        this._removeImmutable(immutable, range);
	                    }
	                    cancelDeleting = true;
	                }
	            }
	            return cancelDeleting;
	        },

	        nextImmutable: function(range, forwards) {
	            var commonContainer = range.commonAncestorContainer;
	            if (dom.isBom(commonContainer) || ((forwards && RangeUtils.isEndOf(range, commonContainer)) || (!forwards && RangeUtils.isStartOf(range, commonContainer)))) {
	                var next = this._nextNode(commonContainer, forwards);
	                if (next && dom.isBlock(next) && !immutableParent(next)) {
	                    while (next && next.children && next.children[forwards ? 0 : next.children.length - 1]) {
	                        next = next.children[forwards ? 0 : next.children.length - 1];
	                    }
	                }
	                return immutableParent(next);
	            }
	        },

	        _removeImmutable: function(immutable, range) {
	            var editor = this.editor;
	            var startRestorePoint = new Editor.RestorePoint(range, editor.body);
	            dom.remove(immutable);
	            Editor._finishUpdate(editor, startRestorePoint);
	        },

	        _nextNode: function(node, forwards) {
	            var sibling = forwards ? "nextSibling" : "previousSibling";
	            var current = node, next;
	            while(current && !next) {
	                next = current[sibling];
	                if (next && dom.isDataNode(next) && /^\s|[\ufeff]$/.test(next.nodeValue)){
	                    current = next;
	                    next = current[sibling];
	                }
	                if (!next){
	                    current = current.parentNode;
	                }
	            }
	            return next;
	        }
	    });

	    Immutables.immutable = immutable;
	    Immutables.immutableParent = immutableParent;
	    Immutables.expandImmutablesIn = expandImmutablesIn;
	    Immutables.immutablesContext = immutablesContext;
	    Immutables.toolsToBeUpdated = toolsToBeUpdated;
	    Immutables.removeImmutables = removeImmutables;
	    Immutables.restoreImmutables = restoreImmutables;

	    Editor.Immutables = Immutables;
	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 964:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("6GKO");

/***/ })

/******/ });

/***/ }),

/***/ "xXzn":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1009);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 894:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("LT3F");

/***/ }),

/***/ 973:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2UxK");

/***/ }),

/***/ 1002:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lysN");

/***/ }),

/***/ 1009:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(973),  __webpack_require__(894), __webpack_require__(1002)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function() {

	(function(kendo, undefined) {
	    var $ = kendo.jQuery;
	    var extend = $.extend;
	    var noop = $.noop;
	    var proxy = $.proxy;

	    var Editor = kendo.ui.editor;
	    var Class = kendo.Class;
	    var Draggable = kendo.ui.Draggable;
	    var Observable = kendo.Observable;
	    var getScrollBarWidth = Editor.ResizingUtils.getScrollBarWidth;
	    var outerWidth = kendo._outerWidth;
	    var outerHeight = kendo._outerHeight;

	    var NS = ".kendoEditorTableResizeHandle";
	    var RESIZE_HANDLE_CLASS = "k-table-resize-handle";

	    var DRAG_START = "dragStart";
	    var DRAG = "drag";
	    var DRAG_END = "dragEnd";
	    var HALF_INSIDE = "halfInside";
	    var MOUSE_OVER = "mouseover";
	    var MOUSE_OUT = "mouseout";

	    var BODY = "body";
	    var TABLE = "table";

	    var EAST = "east";
	    var NORTH = "north";
	    var NORTHEAST = "northeast";
	    var NORTHWEST = "northwest";
	    var SOUTH = "south";
	    var SOUTHEAST = "southeast";
	    var SOUTHWEST = "southwest";
	    var WEST = "west";

	    var DOT = ".";

	    var TableResizeHandle = Observable.extend({
	        init: function(options) {
	            var that = this;

	            Observable.fn.init.call(that);

	            that.options = extend({}, that.options, options);
	            that.element = $(that.options.template).appendTo(that.options.appendTo)[0];

	            that._attachEventHandlers();
	            that._addStyles();
	            that._initDraggable();
	            that._initPositioningStrategy();
	            that._initDraggingStrategy();

	            $(that.element).data(TABLE, that.options.resizableElement);
	        },

	        destroy: function() {
	            var that = this;

	            $(that.element).off(NS).remove();
	            that.element = null;

	            that._destroyDraggable();

	            that.unbind();
	        },

	        options: {
	            appendTo: null,
	            direction: SOUTHEAST,
	            resizableElement: null,
	            rtl: false,
	            template:
	                "<div class='k-table-resize-handle-wrapper' unselectable='on' contenteditable='false'>"+
	                    "<div class='" + RESIZE_HANDLE_CLASS + "'></div>" +
	                "</div>"
	        },

	        events: [
	            DRAG_START,
	            DRAG,
	            DRAG_END,
	            MOUSE_OVER,
	            MOUSE_OUT
	        ],

	        show: function() {
	            this._setPosition();
	        },

	        _setPosition: function() {
	            var that = this;
	            var position = that._positioningStrategy.getPosition();

	            $(that.element).css({
	                top: position.top,
	                left: position.left,
	                position: "absolute"
	            });
	        },

	        _attachEventHandlers: function() {
	            var that = this;

	            $(that.element)
	                .on(MOUSE_OVER + NS, proxy(that._onMouseOver, that))
	                .on(MOUSE_OUT + NS, proxy(that._onMouseOut, that));
	        },

	        _onMouseOver: function() {
	            this.trigger(MOUSE_OVER);
	        },

	        _onMouseOut: function() {
	            this.trigger(MOUSE_OUT);
	        },

	        _addStyles: function() {
	            var that = this;
	            $(that.element).children(DOT + RESIZE_HANDLE_CLASS).addClass("k-resize-" + that.options.direction);
	        },

	        _initPositioningStrategy: function() {
	            var that = this;
	            var options = that.options;

	            that._positioningStrategy = HandlePositioningStrategy.create({
	                name: options.direction,
	                handle: that.element,
	                resizableElement: options.resizableElement,
	                rootElement: options.rootElement,
	                rtl: options.rtl
	            });
	        },

	        _initDraggable: function() {
	            var that = this;
	            var element = that.element;

	            if (that._draggable || !element) {
	                return;
	            }

	            that._draggable = new Draggable(element, {
	                dragstart: proxy(that._onDragStart, that),
	                drag: proxy(that._onDrag, that),
	                dragend: proxy(that._onDragEnd, that)
	            });
	        },

	        _onDragStart: function() {
	            this.trigger(DRAG_START);
	        },

	        _onDrag: function(e) {
	            var that = this;

	            that.trigger(DRAG, that._draggingStrategy.adjustDragDelta({
	                deltaX: e.x.delta,
	                deltaY: e.y.delta,
	                initialDeltaX: e.x.initialDelta,
	                initialDeltaY: e.y.initialDelta
	            }));
	        },

	        _onDragEnd: function() {
	            this.trigger(DRAG_END);
	        },

	        _destroyDraggable : function() {
	            var that = this;

	            if (that._draggable) {
	                that._draggable.destroy();
	                that._draggable = null;
	            }
	        },

	        _initDraggingStrategy: function() {
	            var that = this;

	            that._draggingStrategy = HandleDraggingStrategy.create({
	                name: that.options.direction
	            });
	        }
	    });

	    var StrategyFactory = Class.extend({
	        init: function() {
	            this._items = [];
	        },

	        register: function(name, type) {
	            this._items.push({
	                name: name,
	                type: type
	            });
	        },

	        create: function(options) {
	            var items = this._items;
	            var itemsLength = items.length;
	            var name = options.name ? options.name.toLowerCase() : "";
	            var match;
	            var item;
	            var i;

	            for (i = 0; i < itemsLength; i++) {
	                item = items[i];

	                if (item.name.toLowerCase() === name) {
	                    match = item;
	                    break;
	                }
	            }

	            if (match) {
	                return new match.type(options);
	            }
	        }
	    });

	    var PositioningStrategyFactory = StrategyFactory.extend({});
	    PositioningStrategyFactory.current = new PositioningStrategyFactory();

	    var HandlePositioningStrategy = Class.extend({
	        init: function(options) {
	            var that = this;
	            that.options = extend({}, that.options, options);
	        },

	        options: {
	            handle: null,
	            offset: HALF_INSIDE,
	            resizableElement: null,
	            rootElement: null,
	            rtl: false
	        },

	        getPosition: function() {
	            var that = this;

	            var position = that.calculatePosition();
	            var handleOffsetPosition = that.applyHandleOffset(position);
	            var scrollOffsetPosition = that.applyScrollOffset(handleOffsetPosition);

	            return scrollOffsetPosition;
	        },

	        calculatePosition: noop,

	        applyHandleOffset: function(position) {
	            var options = this.options;
	            var handle = $(options.handle);

	            if (options.offset === HALF_INSIDE) {
	                return {
	                    top: position.top - (outerHeight(handle) / 2),
	                    left: position.left - (outerWidth(handle) / 2)
	                };
	            }

	            return position;
	        },

	        applyScrollOffset: function(position) {
	            var options = this.options;
	            var rootElement = $(options.rootElement);
	            var scrollBarWidth = options.rtl ? getScrollBarWidth(rootElement[0]) : 0;
	            var browser = kendo.support.browser;
	            var rootLeft;

	            if (!rootElement.is(BODY)) {
	                rootLeft = kendo.scrollLeft(rootElement) || 0;

	                if(options.rtl && (browser.mozilla || (browser.webkit && browser.version >= 85))) {
	                    rootLeft = rootLeft * -1;
	                }

	                return {
	                    top: position.top + (rootElement.scrollTop() || 0),
	                    left: position.left + rootLeft - scrollBarWidth
	                };
	            }

	            return position;
	        }
	    });

	    HandlePositioningStrategy.create = function(options) {
	        return PositioningStrategyFactory.current.create(options);
	    };

	    var EastPositioningStrategy = HandlePositioningStrategy.extend({
	        calculatePosition: function() {
	            var resizableElement = $(this.options.resizableElement);
	            var offset = resizableElement.position();

	            return {
	                top: offset.top + (outerHeight(resizableElement) / 2),
	                left: offset.left + outerWidth(resizableElement)
	            };
	        }
	    });
	    PositioningStrategyFactory.current.register(EAST, EastPositioningStrategy);

	    var NorthPositioningStrategy = HandlePositioningStrategy.extend({
	        calculatePosition: function() {
	            var resizableElement = $(this.options.resizableElement);
	            var offset = resizableElement.position();

	            return {
	                top: offset.top,
	                left: offset.left + (outerWidth(resizableElement) / 2)
	            };
	        }
	    });
	    PositioningStrategyFactory.current.register(NORTH, NorthPositioningStrategy);

	    var NortheastPositioningStrategy = HandlePositioningStrategy.extend({
	        calculatePosition: function() {
	            var resizableElement = $(this.options.resizableElement);
	            var offset = resizableElement.position();

	            return {
	                top: offset.top,
	                left: offset.left + outerWidth(resizableElement)
	            };
	        }
	    });
	    PositioningStrategyFactory.current.register(NORTHEAST, NortheastPositioningStrategy);

	    var NorthwestPositioningStrategy = HandlePositioningStrategy.extend({
	        calculatePosition: function() {
	            var resizableElement = $(this.options.resizableElement);
	            var offset = resizableElement.position();

	            return {
	                top: offset.top,
	                left: offset.left
	            };
	        }
	    });
	    PositioningStrategyFactory.current.register(NORTHWEST, NorthwestPositioningStrategy);

	    var SouthPositioningStrategy = HandlePositioningStrategy.extend({
	        calculatePosition: function() {
	            var resizableElement = $(this.options.resizableElement);
	            var offset = resizableElement.position();

	            return {
	                top: offset.top + outerHeight(resizableElement),
	                left: offset.left + (outerWidth(resizableElement) / 2)
	            };
	        }
	    });
	    PositioningStrategyFactory.current.register(SOUTH, SouthPositioningStrategy);

	    var SoutheastPositioningStrategy = HandlePositioningStrategy.extend({
	        calculatePosition: function() {
	            var resizableElement = $(this.options.resizableElement);
	            var offset = resizableElement.position();

	            return {
	                top: offset.top + outerHeight(resizableElement),
	                left: offset.left + outerWidth(resizableElement)
	            };
	        }
	    });
	    PositioningStrategyFactory.current.register(SOUTHEAST, SoutheastPositioningStrategy);

	    var SouthwestPositioningStrategy = HandlePositioningStrategy.extend({
	        calculatePosition: function() {
	            var resizableElement = $(this.options.resizableElement);
	            var offset = resizableElement.position();

	            return {
	                top: offset.top + outerHeight(resizableElement),
	                left: offset.left
	            };
	        }
	    });
	    PositioningStrategyFactory.current.register(SOUTHWEST, SouthwestPositioningStrategy);

	    var WestPositioningStrategy = HandlePositioningStrategy.extend({
	        calculatePosition: function() {
	            var resizableElement = $(this.options.resizableElement);
	            var offset = resizableElement.position();

	            return {
	                top: offset.top + (outerHeight(resizableElement) / 2),
	                left: offset.left
	            };
	        }
	    });
	    PositioningStrategyFactory.current.register(WEST, WestPositioningStrategy);

	    var DraggingStrategyFactory = StrategyFactory.extend({});
	    DraggingStrategyFactory.current = new DraggingStrategyFactory();

	    var HandleDraggingStrategy = Class.extend({
	        init: function(options) {
	            var that = this;
	            that.options = extend({}, that.options, options);
	        },

	        options: {
	            deltaX: {
	                adjustment: null,
	                modifier: null
	            },
	            deltaY: {
	                adjustment: null,
	                modifier: null
	            }
	        },

	        adjustDragDelta: function(deltas) {
	            var options = this.options;
	            var xAxisAdjustment = options.deltaX.adjustment * options.deltaX.modifier;
	            var yAxisAdjustment = options.deltaY.adjustment * options.deltaY.modifier;

	            return {
	                deltaX: deltas.deltaX * xAxisAdjustment,
	                deltaY: deltas.deltaY * yAxisAdjustment,
	                initialDeltaX: deltas.initialDeltaX * xAxisAdjustment,
	                initialDeltaY: deltas.initialDeltaY * yAxisAdjustment
	            };
	        }
	    });

	    HandleDraggingStrategy.create = function(options) {
	        return DraggingStrategyFactory.current.create(options);
	    };

	    var HorizontalDraggingStrategy = HandleDraggingStrategy.extend({
	        options: {
	            deltaX: {
	                adjustment: 1,
	                modifier: 1
	            },
	            deltaY: {
	                adjustment: 0,
	                modifier: 0
	            }
	        }
	    });

	    var EastDraggingStrategy = HorizontalDraggingStrategy.extend({
	        options: {
	            deltaX: {
	                modifier: 1
	            }
	        }
	    });
	    DraggingStrategyFactory.current.register(EAST, EastDraggingStrategy);

	    var WestDraggingStrategy = HorizontalDraggingStrategy.extend({
	        options: {
	            deltaX: {
	                modifier: (-1)
	            }
	        }
	    });
	    DraggingStrategyFactory.current.register(WEST, WestDraggingStrategy);

	    var VerticalDraggingStrategy = HandleDraggingStrategy.extend({
	        options: {
	            deltaX: {
	                adjustment: 0,
	                modifier: 0
	            },
	            deltaY: {
	                adjustment: 1,
	                modifier: 1
	            }
	        }
	    });

	    var NorthDraggingStrategy = VerticalDraggingStrategy.extend({
	        options: {
	            deltaY: {
	                modifier: (-1)
	            }
	        }
	    });
	    DraggingStrategyFactory.current.register(NORTH, NorthDraggingStrategy);

	    var SouthDraggingStrategy = VerticalDraggingStrategy.extend({
	        options: {
	            deltaY: {
	                modifier: 1
	            }
	        }
	    });
	    DraggingStrategyFactory.current.register(SOUTH, SouthDraggingStrategy);

	    var HorizontalAndVerticalDraggingStrategy = HandleDraggingStrategy.extend({
	        options: {
	            deltaX: {
	                adjustment: 1,
	                modifier: 1
	            },
	            deltaY: {
	                adjustment: 1,
	                modifier: 1
	            }
	        }
	    });

	    var NorthEastDraggingStrategy = HorizontalAndVerticalDraggingStrategy.extend({
	        options: {
	            deltaX: {
	                modifier: 1
	            },
	            deltaY: {
	                modifier: (-1)
	            }
	        }
	    });
	    DraggingStrategyFactory.current.register(NORTHEAST, NorthEastDraggingStrategy);

	    var NorthWestDraggingStrategy = HorizontalAndVerticalDraggingStrategy.extend({
	        options: {
	            deltaX: {
	                modifier: (-1)
	            },
	            deltaY: {
	                modifier: (-1)
	            }
	        }
	    });
	    DraggingStrategyFactory.current.register(NORTHWEST, NorthWestDraggingStrategy);

	    var SouthEastDraggingStrategy = HorizontalAndVerticalDraggingStrategy.extend({
	        options: {
	            deltaX: {
	                modifier: 1
	            },
	            deltaY: {
	                modifier: 1
	            }
	        }
	    });
	    DraggingStrategyFactory.current.register(SOUTHEAST, SouthEastDraggingStrategy);

	    var SouthWestDraggingStrategy = HorizontalAndVerticalDraggingStrategy.extend({
	        options: {
	            deltaX: {
	                modifier: (-1)
	            },
	            deltaY: {
	                modifier: 1
	            }
	        }
	    });
	    DraggingStrategyFactory.current.register(SOUTHWEST, SouthWestDraggingStrategy);

	    extend(Editor, {
	        TableResizeHandle: TableResizeHandle
	    });
	})(window.kendo);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "xchs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var PivotModePanel = (function (_super) {
    __extends(PivotModePanel, _super);
    function PivotModePanel() {
        return _super.call(this) || this;
    }
    PivotModePanel.prototype.createTemplate = function () {
        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
        return "<div class=\"ag-pivot-mode\">\n                <ag-checkbox class=\"ag-pivot-mode-select\" label=\"" + localeTextFunc('pivotMode', 'Pivot Mode') + "\"></ag-checkbox>\n            </div>";
    };
    PivotModePanel.prototype.init = function () {
        this.setTemplate(this.createTemplate());
        this.instantiate(this.context);
        this.cbPivotMode.setSelected(this.columnController.isPivotMode());
        this.addDestroyableEventListener(this.cbPivotMode, main_1.AgCheckbox.EVENT_CHANGED, this.onBtPivotMode.bind(this));
        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.onPivotModeChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, main_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onPivotModeChanged.bind(this));
    };
    PivotModePanel.prototype.onBtPivotMode = function () {
        var newValue = this.cbPivotMode.isSelected();
        if (newValue !== this.columnController.isPivotMode()) {
            this.columnController.setPivotMode(newValue, "toolPanelUi");
            this.gridOptionsWrapper.getApi().refreshHeader();
        }
    };
    PivotModePanel.prototype.onPivotModeChanged = function () {
        var pivotModeActive = this.columnController.isPivotMode();
        this.cbPivotMode.setSelected(pivotModeActive);
    };
    __decorate([
        main_1.Autowired('columnController'),
        __metadata("design:type", main_1.ColumnController)
    ], PivotModePanel.prototype, "columnController", void 0);
    __decorate([
        main_1.Autowired('eventService'),
        __metadata("design:type", main_1.EventService)
    ], PivotModePanel.prototype, "eventService", void 0);
    __decorate([
        main_1.Autowired('context'),
        __metadata("design:type", main_1.Context)
    ], PivotModePanel.prototype, "context", void 0);
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], PivotModePanel.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        main_1.QuerySelector('.ag-pivot-mode-select'),
        __metadata("design:type", main_1.AgCheckbox)
    ], PivotModePanel.prototype, "cbPivotMode", void 0);
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PivotModePanel.prototype, "init", null);
    return PivotModePanel;
}(main_1.Component));
exports.PivotModePanel = PivotModePanel;


/***/ }),

/***/ "xffp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

Object.defineProperty(exports, "__esModule", { value: true });
var eventService_1 = __webpack_require__("k5uU");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var utils_1 = __webpack_require__("IRr6");
var BeanStub = (function () {
    function BeanStub() {
        this.destroyFunctions = [];
        this.destroyed = false;
    }
    BeanStub.prototype.destroy = function () {
        this.destroyFunctions.forEach(function (func) { return func(); });
        this.destroyFunctions.length = 0;
        this.destroyed = true;
        this.dispatchEvent({ type: BeanStub.EVENT_DESTORYED });
    };
    BeanStub.prototype.addEventListener = function (eventType, listener) {
        if (!this.localEventService) {
            this.localEventService = new eventService_1.EventService();
        }
        this.localEventService.addEventListener(eventType, listener);
    };
    BeanStub.prototype.removeEventListener = function (eventType, listener) {
        if (this.localEventService) {
            this.localEventService.removeEventListener(eventType, listener);
        }
    };
    BeanStub.prototype.dispatchEventAsync = function (event) {
        var _this = this;
        setTimeout(function () { return _this.dispatchEvent(event); }, 0);
    };
    BeanStub.prototype.dispatchEvent = function (event) {
        if (this.localEventService) {
            this.localEventService.dispatchEvent(event);
        }
    };
    BeanStub.prototype.addDestroyableEventListener = function (eElement, event, listener) {
        if (this.destroyed) {
            return;
        }
        if (eElement instanceof HTMLElement) {
            utils_1._.addSafePassiveEventListener(eElement, event, listener);
        }
        else if (eElement instanceof gridOptionsWrapper_1.GridOptionsWrapper) {
            eElement.addEventListener(event, listener);
        }
        else {
            eElement.addEventListener(event, listener);
        }
        this.destroyFunctions.push(function () {
            if (eElement instanceof HTMLElement) {
                eElement.removeEventListener(event, listener);
            }
            else if (eElement instanceof gridOptionsWrapper_1.GridOptionsWrapper) {
                eElement.removeEventListener(event, listener);
            }
            else {
                eElement.removeEventListener(event, listener);
            }
        });
    };
    BeanStub.prototype.isAlive = function () {
        return !this.destroyed;
    };
    BeanStub.prototype.addDestroyFunc = function (func) {
        // if we are already destroyed, we execute the func now
        if (this.isAlive()) {
            this.destroyFunctions.push(func);
        }
        else {
            func();
        }
    };
    BeanStub.EVENT_DESTORYED = 'destroyed';
    return BeanStub;
}());
exports.BeanStub = BeanStub;


/***/ }),

/***/ "xnc9":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "y9Zr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var rowRenderer_1 = __webpack_require__("3RUv");
var gridPanel_1 = __webpack_require__("inOk");
var context_1 = __webpack_require__("RQ1/");
var headerRenderer_1 = __webpack_require__("U9s4");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var headerWrapperComp_1 = __webpack_require__("CTJA");
var AutoWidthCalculator = (function () {
    function AutoWidthCalculator() {
    }
    // this is the trick: we create a dummy container and clone all the cells
    // into the dummy, then check the dummy's width. then destroy the dummy
    // as we don't need it any more.
    // drawback: only the cells visible on the screen are considered
    AutoWidthCalculator.prototype.getPreferredWidthForColumn = function (column) {
        var eHeaderCell = this.getHeaderCellForColumn(column);
        // cell isn't visible
        if (!eHeaderCell) {
            return -1;
        }
        var eDummyContainer = document.createElement('span');
        // position fixed, so it isn't restricted to the boundaries of the parent
        eDummyContainer.style.position = 'fixed';
        // we put the dummy into the body container, so it will inherit all the
        // css styles that the real cells are inheriting
        var eBodyContainer = this.gridPanel.getBodyContainer();
        eBodyContainer.appendChild(eDummyContainer);
        // get all the cells that are currently displayed (this only brings back
        // rendered cells, rows not rendered due to row visualisation will not be here)
        this.putRowCellsIntoDummyContainer(column, eDummyContainer);
        // also put header cell in
        // we only consider the lowest level cell, not the group cell. in 99% of the time, this
        // will be enough. if we consider groups, then it gets to complicated for what it's worth,
        // as the groups can span columns and this class only considers one column at a time.
        this.cloneItemIntoDummy(eHeaderCell, eDummyContainer);
        // at this point, all the clones are lined up vertically with natural widths. the dummy
        // container will have a width wide enough just to fit the largest.
        var dummyContainerWidth = eDummyContainer.offsetWidth;
        // we are finished with the dummy container, so get rid of it
        eBodyContainer.removeChild(eDummyContainer);
        // we add padding as I found sometimes the gui still put '...' after some of the texts. so the
        // user can configure the grid to add a few more pixels after the calculated width
        var autoSizePadding = this.gridOptionsWrapper.getAutoSizePadding();
        return dummyContainerWidth + autoSizePadding;
    };
    AutoWidthCalculator.prototype.getHeaderCellForColumn = function (column) {
        var comp = null;
        // find the rendered header cell
        this.headerRenderer.forEachHeaderElement(function (headerElement) {
            if (headerElement instanceof headerWrapperComp_1.HeaderWrapperComp) {
                var headerWrapperComp = headerElement;
                if (headerWrapperComp.getColumn() === column) {
                    comp = headerWrapperComp;
                }
            }
        });
        return comp ? comp.getGui() : null;
    };
    AutoWidthCalculator.prototype.putRowCellsIntoDummyContainer = function (column, eDummyContainer) {
        var _this = this;
        var eCells = this.rowRenderer.getAllCellsForColumn(column);
        eCells.forEach(function (eCell) { return _this.cloneItemIntoDummy(eCell, eDummyContainer); });
    };
    AutoWidthCalculator.prototype.cloneItemIntoDummy = function (eCell, eDummyContainer) {
        // make a deep clone of the cell
        var eCellClone = eCell.cloneNode(true);
        // the original has a fixed width, we remove this to allow the natural width based on content
        eCellClone.style.width = '';
        // the original has position = absolute, we need to remove this so it's positioned normally
        eCellClone.style.position = 'static';
        eCellClone.style.left = '';
        // we put the cell into a containing div, as otherwise the cells would just line up
        // on the same line, standard flow layout, by putting them into divs, they are laid
        // out one per line
        var eCloneParent = document.createElement('div');
        // table-row, so that each cell is on a row. i also tried display='block', but this
        // didn't work in IE
        eCloneParent.style.display = 'table-row';
        // the twig on the branch, the branch on the tree, the tree in the hole,
        // the hole in the bog, the bog in the clone, the clone in the parent,
        // the parent in the dummy, and the dummy down in the vall-e-ooo, OOOOOOOOO! Oh row the rattling bog....
        eCloneParent.appendChild(eCellClone);
        eDummyContainer.appendChild(eCloneParent);
    };
    __decorate([
        context_1.Autowired('rowRenderer'),
        __metadata("design:type", rowRenderer_1.RowRenderer)
    ], AutoWidthCalculator.prototype, "rowRenderer", void 0);
    __decorate([
        context_1.Autowired('headerRenderer'),
        __metadata("design:type", headerRenderer_1.HeaderRenderer)
    ], AutoWidthCalculator.prototype, "headerRenderer", void 0);
    __decorate([
        context_1.Autowired('gridPanel'),
        __metadata("design:type", gridPanel_1.GridPanel)
    ], AutoWidthCalculator.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], AutoWidthCalculator.prototype, "gridOptionsWrapper", void 0);
    AutoWidthCalculator = __decorate([
        context_1.Bean('autoWidthCalculator')
    ], AutoWidthCalculator);
    return AutoWidthCalculator;
}());
exports.AutoWidthCalculator = AutoWidthCalculator;


/***/ }),

/***/ "yJFb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'baseDataSourceComponent',
    props: {
        dataSourceRef: {
            type: String,
            default: undefined
        }
    },
    render: function render(h) {
        return h('div');
    },

    methods: {
        findDataSource: function findDataSource() {
            var dataSource;
            if (this.$children) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.$children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var a = _step.value;

                        if (this.$children.length && a.kendoDataSource) {
                            dataSource = a.kendoDataSource;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            return dataSource;
        },
        setInnerDataSource: function setInnerDataSource() {
            var dataSourceRefProp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'dataSourceRef';
            var rootProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dataSource';
            var subProp = arguments[2];

            var innerDataSource = this.findDataSource();

            if (innerDataSource) {
                if (!subProp) {
                    this.widgetOptions[rootProp] = innerDataSource;
                } else {
                    subProp[rootProp] = innerDataSource;
                }
            } else {
                var refString = subProp ? subProp[dataSourceRefProp] : this[dataSourceRefProp];
                var referredDataSource = this.getParentsRef(refString);

                if (referredDataSource) {
                    this.attachEvents(referredDataSource);
                    if (!subProp) {
                        this.widgetOptions[rootProp] = referredDataSource.kendoDataSource;
                    } else {
                        subProp[rootProp] = referredDataSource.kendoDataSource;
                    }
                }
            }
        },
        getParentsRef: function getParentsRef(anchor) {
            var parent = this.$parent;

            while (parent && !parent.$refs[anchor]) {
                parent = parent.$parent;
            }

            return parent ? parent.$refs[anchor] : undefined;
        },
        setDataSource: function setDataSource(newValue) {
            var newDataSourceRef = this.getParentsRef(newValue);
            var kendoWidget = this.kendoWidget();

            if (kendoWidget.setDataSource && newDataSourceRef) {
                kendoWidget.setDataSource(newDataSourceRef.kendoDataSource);
            } else if (kendoWidget.setDataSource) {
                kendoWidget.setDataSource(newValue);
            }
        },
        attachEvents: function attachEvents(referredDataSource) {
            if (referredDataSource.kendoDataSource) {
                referredDataSource.kendoDataSource.bind('change', function (ev) {
                    if (referredDataSource.getListeners()['change']) {
                        referredDataSource.$emit('change', ev);
                    }
                });

                referredDataSource.kendoDataSource.bind('error', function (ev) {
                    if (referredDataSource.getListeners()['error']) {
                        referredDataSource.$emit('error', ev);
                    }
                });

                referredDataSource.kendoDataSource.bind('push', function (ev) {
                    if (referredDataSource.getListeners()['push']) {
                        referredDataSource.$emit('push', ev);
                    }
                });

                referredDataSource.kendoDataSource.bind('requestEnd', function (ev) {
                    if (referredDataSource.getListeners()['requestend']) {
                        referredDataSource.$emit('requestend', ev);
                    }
                });

                referredDataSource.kendoDataSource.bind('requestStart', function (ev) {
                    if (referredDataSource.getListeners()['requeststart']) {
                        referredDataSource.$emit('requeststart', ev);
                    }
                });

                referredDataSource.kendoDataSource.bind('sync', function (ev) {
                    if (referredDataSource.getListeners()['sync']) {
                        referredDataSource.$emit('sync', ev);
                    }
                });
            }
        }
    },
    mounted: function mounted() {
        var that = this;

        that.$watch('dataSourceRef', function (newValue) {
            that.setDataSource(newValue);
        });
        that.$watch('dataSource', function (newValue) {
            that.setDataSource(newValue);
        });

        that.setInnerDataSource();
    }
};

/***/ }),

/***/ "yLI2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__("IRr6");
var column_1 = __webpack_require__("hDyE");
var beanStub_1 = __webpack_require__("xffp");
var SetLeftFeature = (function (_super) {
    __extends(SetLeftFeature, _super);
    function SetLeftFeature(columnOrGroup, eCell, beans, colsSpanning) {
        var _this = _super.call(this) || this;
        _this.columnOrGroup = columnOrGroup;
        _this.eCell = eCell;
        _this.colsSpanning = colsSpanning;
        _this.beans = beans;
        return _this;
    }
    SetLeftFeature.prototype.setColsSpanning = function (colsSpanning) {
        this.colsSpanning = colsSpanning;
        this.onLeftChanged();
    };
    SetLeftFeature.prototype.getColumnOrGroup = function () {
        if (this.beans.gridOptionsWrapper.isEnableRtl() && this.colsSpanning) {
            return this.colsSpanning[this.colsSpanning.length - 1];
        }
        else {
            return this.columnOrGroup;
        }
    };
    SetLeftFeature.prototype.init = function () {
        this.addDestroyableEventListener(this.columnOrGroup, column_1.Column.EVENT_LEFT_CHANGED, this.onLeftChanged.bind(this));
        this.setLeftFirstTime();
    };
    SetLeftFeature.prototype.setLeftFirstTime = function () {
        var suppressMoveAnimation = this.beans.gridOptionsWrapper.isSuppressColumnMoveAnimation();
        var oldLeftExists = utils_1.Utils.exists(this.columnOrGroup.getOldLeft());
        var animateColumnMove = this.beans.columnAnimationService.isActive() && oldLeftExists && !suppressMoveAnimation;
        if (animateColumnMove) {
            this.animateInLeft();
        }
        else {
            this.onLeftChanged();
        }
    };
    SetLeftFeature.prototype.animateInLeft = function () {
        var _this = this;
        var left = this.getColumnOrGroup().getLeft();
        var oldLeft = this.getColumnOrGroup().getOldLeft();
        this.setLeft(oldLeft);
        // we must keep track of the left we want to set to, as this would otherwise lead to a race
        // condition, if the user changed the left value many times in one VM turn, then we want to make
        // make sure the actualLeft we set in the timeout below (in the next VM turn) is the correct left
        // position. eg if user changes column position twice, then setLeft() below executes twice in next
        // VM turn, but only one (the correct one) should get applied.
        this.actualLeft = left;
        this.beans.columnAnimationService.executeNextVMTurn(function () {
            // test this left value is the latest one to be applied, and if not, do nothing
            if (_this.actualLeft === left) {
                _this.setLeft(left);
            }
        });
    };
    SetLeftFeature.prototype.onLeftChanged = function () {
        this.actualLeft = this.getColumnOrGroup().getLeft();
        this.setLeft(this.actualLeft);
    };
    SetLeftFeature.prototype.setLeft = function (value) {
        // if the value is null, then that means the column is no longer
        // displayed. there is logic in the rendering to fade these columns
        // out, so we don't try and change their left positions.
        if (utils_1.Utils.exists(value)) {
            this.eCell.style.left = value + 'px';
        }
    };
    return SetLeftFeature;
}(beanStub_1.BeanStub));
exports.SetLeftFeature = SetLeftFeature;


/***/ }),

/***/ "yVNj":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(982);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 982:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(983) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($) {

	var kendo = window.kendo,
	    Editor = kendo.ui.editor,
	    Tool = Editor.Tool,
	    ToolTemplate = Editor.ToolTemplate,
	    DelayedExecutionTool = Editor.DelayedExecutionTool,
	    Command = Editor.Command,
	    dom = Editor.Dom,
	    EditorUtils = Editor.EditorUtils,
	    RangeUtils = Editor.RangeUtils,
	    registerTool = EditorUtils.registerTool;


	var FormattingTool = DelayedExecutionTool.extend({
	    init: function(options) {
	        var that = this;
	        Tool.fn.init.call(that, kendo.deepExtend({}, that.options, options));

	        that.type = "kendoSelectBox";

	        that.finder = {
	            getFormat: function() { return ""; }
	        };
	    },

	    options: {
	        items: [
	            { text: "Paragraph", value: "p" },
	            { text: "Quotation", value: "blockquote" },
	            { text: "Heading 1", value: "h1" },
	            { text: "Heading 2", value: "h2" },
	            { text: "Heading 3", value: "h3" },
	            { text: "Heading 4", value: "h4" },
	            { text: "Heading 5", value: "h5" },
	            { text: "Heading 6", value: "h6" }
	        ],
	        width: 110
	    },

	    toFormattingItem: function(item) {
	        var value = item.value;

	        if (!value) {
	            return item;
	        }

	        if (item.tag || item.className) {
	            return item;
	        }

	        var dot = value.indexOf(".");

	        if (dot === 0) {
	            item.className = value.substring(1);
	        } else if (dot == -1) {
	            item.tag = value;
	        } else {
	            item.tag = value.substring(0, dot);
	            item.className = value.substring(dot + 1);
	        }

	        return item;
	    },

	    command: function (args) {
	        var that = this;
	        var item = args.value;

	        item = this.toFormattingItem(item);

	        return new Editor.FormatCommand({
	            range: args.range,
	            formatter: function () {
	                var formatter,
	                    tags = (item.tag || item.context || "span").split(","),
	                    format = [{
	                        tags: tags,
	                        attr: { className: item.className || "" }
	                    }];

	                if ($.inArray(tags[0], dom.inlineElements) >= 0) {
	                    formatter = new Editor.GreedyInlineFormatter(format);
	                } else {
	                    formatter = new Editor.GreedyBlockFormatter(format);
	                }

	                formatter.editor = that.editor;
	                return formatter;
	            }
	        });
	    },

	    initialize: function(ui, initOptions) {
	        var editor = initOptions.editor;
	        var options = this.options;
	        var toolName = options.name;
	        var that = this;
	        var selectBox;

	        that.editor = editor;

	        ui.width(options.width);

	        selectBox = ui.kendoSelectBox({
	            dataTextField: "text",
	            dataValueField: "value",
	            dataSource: options.items || editor.options[toolName],
	            title: editor.options.messages[toolName],
	            autoSize: true,
	            change: function () {
	                var dataItem = this.dataItem();

	                if (dataItem) {
	                    Tool.exec(editor, toolName, dataItem.toJSON());
	                }
	            },
	            dataBound: function() {
	                var i, items = this.dataSource.data();

	                for (i = 0; i < items.length; i++) {
	                    items[i] = that.toFormattingItem(items[i]);
	                }
	            },
	            highlightFirst: false,
	            template: kendo.template(
	                '<span unselectable="on" style="display:block;#=(data.style||"")#">#:data.text#</span>'
	            )
	        }).data("kendoSelectBox");

	        ui.attr("title", initOptions.title);
	        selectBox.wrapper.attr("title", initOptions.title);

	        ui.addClass("k-decorated")
	            .closest(".k-widget")
	                .removeClass("k-" + toolName)
	                .find("*").addBack()
	                    .attr("unselectable", "on");
	    },

	    getFormattingValue: function(items, nodes) {
	        for (var i = 0; i < items.length; i++) {
	            var item = items[i];
	            var tag = item.tag || item.context || "";
	            var className = item.className ? "."+item.className : "";
	            var selector = tag + className;

	            var element = $(nodes[0]).closest(selector)[0];

	            if (!element) {
	                continue;
	            }

	            if (nodes.length == 1) {
	                return item.value;
	            }

	            for (var n = 1; n < nodes.length; n++) {
	                if (!$(nodes[n]).closest(selector)[0]) {
	                    break;
	                } else if (n == nodes.length - 1) {
	                    return item.value;
	                }
	            }
	        }

	        return "";
	    },

	    update: function(ui, nodes) {
	        var selectBox = $(ui).data(this.type);

	        // necessary until formatBlock is deleted
	        if (!selectBox) {
	            return;
	        }

	        var dataSource = selectBox.dataSource,
	            items = dataSource.data(),
	            i, context,
	            ancestor = dom.commonAncestor.apply(null, nodes);

	        if (ancestor != dom.closestEditable(ancestor) && this._ancestor == ancestor) {
	            return;
	        } else {
	            this._ancestor = ancestor;
	        }

	        for (i = 0; i < items.length; i++) {
	            context = items[i].context;

	            items[i].visible = !context || !!$(ancestor).closest(context).length;
	        }

	        dataSource.filter([{ field: "visible", operator: "eq", value: true }]);

	        DelayedExecutionTool.fn.update.call(this, ui, nodes);

	        selectBox.value(this.getFormattingValue(dataSource.view(), nodes));

	        selectBox.wrapper.toggleClass("k-state-disabled", !dataSource.view().length);
	    },

	    destroy: function() {
	        this._ancestor = null;
	    }
	});

	var CleanFormatCommand = Command.extend({
	    exec: function() {
	        var range = this.lockRange(true);
	        this.tagsToClean = this.options.remove || "strong,em,span,sup,sub,del,b,i,u,font".split(",");

	        RangeUtils.wrapSelectedElements(range);

	        var nodes = RangeUtils.mapAll(range, function(node) {
	            return node;
	        });


	        for(var c = nodes.length - 1; c >= 0; c--) {
	            var node = nodes[c];
	            if (!this.immutableParent(node)) {
	                this.clean(node);
	            }
	        }

	        this.releaseRange(range);
	    },

	    clean: function(node) {
	        if (!node || dom.isMarker(node)) {
	            return;
	        }

	        var name = dom.name(node);

	        if (name == "ul" || name == "ol") {
	            var listFormatter = new Editor.ListFormatter(name);
	            var prev = node.previousSibling;
	            var next = node.nextSibling;

	            listFormatter.unwrap(node);

	            // clean contents
	            for (; prev && prev != next; prev = prev.nextSibling) {
	                this.clean(prev);
	            }
	        } else if (name == "blockquote") {
	            dom.changeTag(node, "p");
	        } else if (node.nodeType == 1 && !dom.insignificant(node)) {
	            for (var i = node.childNodes.length-1; i >= 0; i--) {
	                this.clean(node.childNodes[i]);
	            }

	            node.removeAttribute("style");
	            node.removeAttribute("class");
	        } else {
	            unwrapListItem(node);
	        }

	        if ($.inArray(name, this.tagsToClean) > -1) {
	            dom.unwrap(node);
	        }
	    },

	    immutableParent: function(node) {
	        return this.immutables() && Editor.Immutables.immutableParent(node);
	    }
	});


	function unwrapListItem(node) {
	    var li = dom.closestEditableOfType(node, ["li"]);
	    if (li) {
	        var listFormatter = new Editor.ListFormatter(dom.name(li.parentNode));
	        var range = kendo.ui.editor.W3CRange.fromNode(node);
	        range.selectNode(li);
	        listFormatter.toggle(range);
	    }
	}

	$.extend(Editor, {
	    FormattingTool: FormattingTool,
	    CleanFormatCommand: CleanFormatCommand
	});

	registerTool("formatting", new FormattingTool({ template: new ToolTemplate({ template: EditorUtils.dropDownListTemplate, title: "Format" }) }));
	registerTool("cleanFormatting", new Tool({ command: CleanFormatCommand, template: new ToolTemplate({ template: EditorUtils.buttonTemplate, title: "Clean formatting" }) }));

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ }),

/***/ 983:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("/lhy");

/***/ })

/******/ });

/***/ }),

/***/ "yXJn":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1563);
	module.exports = __webpack_require__(1563);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1036:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("o4s/");

/***/ }),

/***/ 1563:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1036)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($, undefined) {
	    var kendo = window.kendo,
	        proxy = $.proxy,
	        extend = $.extend,
	        parseJSON = $.parseJSON,
	        progress = kendo.ui.progress,
	        Class = kendo.Class,
	        OPEN = "open",
	        ZOOMSTART = "zoomStart",
	        ZOOMEND = "zoomEnd";

	    var Command = Class.extend({
	        init: function(options) {
	            this.options = options;
	            this.viewer = options.viewer;
	            this.errorMessages = this.viewer.options.messages.errorMessages;
	        }
	    });

	    var OpenCommand = Command.extend({
	        init: function(options) {
	            Command.fn.init.call(this, options);
	            this.upload = this.viewer.processor.upload;
	        },
	        exec: function () {
	            (this.viewer._upload || this._initUpload()).element.click();
	        },
	        _initUpload: function () {
	            var uploadOptions = {
	                select: proxy(this._onSelect, this),
	                success: proxy(this._onSuccess, this),
	                error: proxy(this._onError, this),
	                complete: proxy(this._onComplete, this),
	                showFileList: false,
	                multiple: false,
	                validation: {
	                    allowedExtensions: [".pdf"]
	                }
	            };

	            if (this.upload) {
	                extend(uploadOptions, {
	                    async: {
	                        saveUrl:  this.upload.url,
	                        autoUpload: true,
	                        saveField: this.upload.saveField
	                    }
	                });
	            }

	            var upload = $('<input name="files" accept=".pdf" type="file" />').kendoUpload(uploadOptions).getKendoUpload();
	            this.viewer._upload = upload;

	            return upload;
	        },
	        _onComplete: function () {
	            progress(this.viewer.pageContainer, false);
	        },
	        _onSuccess: function(e) {
	            var json = parseJSON(e.response);

	            if ($.isPlainObject(json)) {
	                this.viewer.processor.fromJSON(json);
	            }
	            else {
	                this.viewer._triggerError({
	                    error: json,
	                    message: this.errorMessages.parseError
	                });
	            }
	        },
	        _onError: function(e) {
	            this.viewer._triggerError({
	                error: e.XMLHttpRequest.responseText,
	                message: this.errorMessages.notSupported
	            });
	        },
	        _onSelect: function (e) {
	            var that = this;
	            var fileToUpload = e.files[0];

	            progress(that.viewer.pageContainer, true);

	            if (that.viewer.trigger(OPEN, { file: fileToUpload }) || that.upload) {
	                return;
	            } else if (fileToUpload.extension.toLowerCase() !== ".pdf") {
	                that.viewer._triggerError({
	                    error: fileToUpload,
	                    message: that.errorMessages.notSupported
	                });
	                return;
	            }

	            var reader = new FileReader();
	            reader.onload = function(e) {
	                var document = e.target.result;
	                that.viewer.fromFile(document);
	            };
	            reader.onerror = function () {
	                that.viewer._triggerError({
	                    error: fileToUpload,
	                    message: that.errorMessages.parseError
	                });
	            };

	            reader.readAsArrayBuffer(fileToUpload.rawFile);
	        }
	    });

	    var PageChangeCommand = Command.extend({
	        exec: function () {
	            var pageNumber = this.options.value;

	            this.viewer.activatePage(pageNumber);
	        }
	    });

	    var DownloadCommand = Command.extend({
	        exec: function () {
	            if (!this.viewer.document) {
	                this.viewer._triggerError({
	                    message: this.errorMessages.notFound
	                });
	                return;
	            }

	            var fileName = (this.viewer.document.info && this.viewer.document.info.title) ||
	                            this.viewer.options.messages.defaultFileName;

	            this.viewer.processor.downloadFile(fileName);
	        }
	    });

	    var ExportCommand = Command.extend({
	        init: function(options) {
	            options = $.extend(options, this.options);
	            Command.fn.init.call(this, options);
	        },
	        exec: function() {
	            var dialog = (this.viewer._saveDialog || this._initDialog());

	            dialog._updateModel({
	                pagesCount: (this.viewer.document && this.viewer.document.total) || 1,
	                page: this.viewer.options.page
	            });

	            dialog.open();
	        },
	        apply: function (viewModel) {
	            var extension = viewModel.extension;

	            if (extension === ".png") {
	                this.viewer.exportImage(viewModel);
	            } else if (extension === ".svg") {
	                this.viewer.exportSVG(viewModel);
	            }
	        },
	        _initDialog: function () {
	            this.viewer._saveDialog = new kendo.pdfviewer.dialogs.ExportAsDialog({
	                apply: this.apply.bind(this),
	                pagesCount: (this.viewer.document && this.viewer.document.total) || 1,
	                messages: this.viewer.options.messages
	            });
	            return this.viewer._saveDialog;
	        }
	    });

	    var EnableSelectionCommand = Command.extend({
	        exec: function () {
	            var that = this,
	                viewer = that.viewer;

	                viewer._toggleSelection(true);
	        }
	    });

	    var EnablePanCommand = Command.extend({
	        exec: function () {
	            var that = this,
	                viewer = that.viewer;

	                viewer._toggleSelection(false);
	        }
	    });

	    var OpenSearchCommand = Command.extend({
	        init: function(options) {
	            var that = this;

	            that.viewer = options.viewer;

	            if(!that.viewer.searchDialog) {
	                that.viewer.searchDialog = new kendo.pdfviewer.dialogs.SearchDialog({
	                    position: {
	                        top: that.viewer.pageContainer.offset().top,
	                        left: that.viewer.pageContainer.offset().left
	                    },
	                    messages: that.viewer.options.messages.dialogs.search,
	                    open: proxy(that._open, that),
	                    next: proxy(that._next, that),
	                    prev: proxy(that._prev, that),
	                    close: proxy(that._close, that)
	                });
	            }

	            Command.fn.init.call(that, options);
	        },
	        exec: function () {
	            var that = this;

	            that.viewer.searchDialog.open();
	        },
	        _open: function () {
	            var that = this;

	            that.changeHandler = proxy(that._change, that);
	            that.zoomStartHandler = proxy(that._closeDialog, that);
	            that.openFileHandler = proxy(that._closeDialog, that);

	            if(!that.viewer._searchDOM) {
	                that.viewer._initSearchDOM();
	                that.viewer.searchDialog.searchModel.bind("change", that.changeHandler);
	                that.viewer.bind("zoomStart", that.zoomStartHandler);
	                that.viewer.bind("open", that.openFileHandler);
	            }
	        },
	        _close: function () {
	            var that = this;
	            var searchEngine = that.viewer._searchDOM;

	            that.viewer.searchDialog.searchModel.unbind("change", that.changeHandler);
	            that.viewer.unbind("zoomStart", that.zoomStartHandler);
	            that.viewer.unbind("open", that.openFileHandler);
	            searchEngine.destroy();
	            delete that.viewer._searchDOM;
	            that._updateSearchModel();
	        },
	        _change: function (ev) {
	            var that = this;
	            var searchEngine = that.viewer._searchDOM;
	            var field = ev.field;
	            var model = that.viewer.searchDialog.searchModel;
	            var value = model[field];

	            if(!searchEngine) {
	                return;
	            }

	            switch (field) {
	                case "searchText":
	                    searchEngine.search(value, model.matchCase);
	                    that._updateSearchModel();
	                    break;
	                case "matchCase":
	                    searchEngine.search(model.searchText, value);
	                    that._updateSearchModel();
	                    break;
	                default:
	                    break;
	            }
	        },
	        _next: function () {
	            var that = this;
	            var searchEngine = that.viewer._searchDOM;

	            if (searchEngine.matches && searchEngine.matches.length) {
	                searchEngine.nextMatch();
	                that._updateSearchModel();
	            }
	        },
	        _prev: function () {
	            var that = this;
	            var searchEngine = that.viewer._searchDOM;

	            if (searchEngine.matches && searchEngine.matches.length) {
	                searchEngine.previousMatch();
	                that._updateSearchModel();
	            }
	        },
	        _updateSearchModel: function () {
	            var that = this;
	            var searchEngine = that.viewer._searchDOM;
	            var model = that.viewer.searchDialog.searchModel;

	            if(searchEngine) {
	                model.set("matches", searchEngine.matches.length);
	                model.set("matchIndex", searchEngine.getMarkedIndex());
	                that._scrollToMark();
	            } else {
	                model.set("searchText", "");
	                model.set("matches", 0);
	                model.set("matchIndex", 0);
	                model.set("matchCase", false);
	            }
	        },
	        _scrollToMark: function () {
	            var that = this;
	            var searchEngine = that.viewer._searchDOM;
	            var marked = searchEngine.getFirstMarked();
	            var scroller = that.viewer._scroller;
	            var position;

	            if(!marked.length) {
	                return;
	            }

	            position = marked.offset().top - scroller.scrollElement.offset().top - 100;

	            scroller.scrollTo(scroller.scrollLeft, position * -1);
	        },
	        _closeDialog: function () {
	            var that = this;
	            that.viewer.searchDialog.dialog.close();
	        }
	    });

	    var ZoomCommand = Command.extend({
	        exec: function () {
	            var that = this,
	                options = that.options,
	                viewer = that.viewer,
	                scale = options.scale,
	                loadedPagesHeight = 0,
	                page = that.viewer._pageNum,
	                containerHeight = viewer.pageContainer[0].clientHeight,
	                updatedVisiblePagesCount = 1,
	                renderTasks = [];

	            if(viewer.processingLib === "dpl") {
	                return;
	            }

	            scale = that._calculateZoom();

	            var updateViewer = function () {
	                var scroller = that.viewer._scroller,
	                    scrollingStarted = viewer._scrollingStarted;

	                if (scroller.scrollTop > scroller.scrollHeight()) {
	                    scroller._resize();
	                }

	                if (!scrollingStarted)
	                {
	                    viewer.activatePage(page);
	                    viewer._scrollingStarted = false;
	                }
	            };

	            if (!scale) {
	                return;
	            }

	            viewer.zoomScale = scale;
	            viewer._scrollingStarted = false;

	            viewer.pages.forEach(function (page) {
	                var pageHeight;

	                if (viewer._visiblePages.indexOf(page) !== -1 && page.loaded) {
	                    renderTasks.push(page.render(scale));

	                    pageHeight = page._page.getViewport({
	                        scale: scale
	                    }).height;
	                }
	                else {
	                    page.resize(scale);
	                    pageHeight = page.element.height();
	                }

	                loadedPagesHeight += pageHeight;

	                if (loadedPagesHeight <= containerHeight) {
	                    updatedVisiblePagesCount++;
	                }
	            });

	            if (viewer._visiblePagesCount != updatedVisiblePagesCount) {

	                viewer._visiblePagesCount = updatedVisiblePagesCount;
	                viewer._loadVisiblePages();
	            }

	            Promise.all(renderTasks).then(function () {
	                updateViewer();
	                that._triggerZoomEnd(scale);
	            }).catch(function () { // jshint ignore:line
	                updateViewer();
	                that._triggerZoomEnd(scale);
	            });
	        },

	        _calculateZoom: function () {
	            var options = this.options,
	                viewer = this.viewer,
	                viewerOptions = viewer.options,
	                pageContainer = viewer.pageContainer,
	                visibleCanvas = viewer._visiblePages && viewer._visiblePages[0].canvas,
	                scale = options.scale,
	                scaleValue = scale,
	                preventZoom;

	            viewer._allowResize = false;
	            viewer._autoFit = false;

	            if (options.zoomIn) {
	                scaleValue = scale = viewer.zoomScale + viewerOptions.zoomRate;
	            } else if (options.zoomOut) {
	                scaleValue = scale = viewer.zoomScale - viewerOptions.zoomRate;
	            } else if (scale === "auto") {
	                viewer._allowResize = true;
	                scaleValue = viewer._autoZoomScale;
	            } else if (scale === "actual") {
	                scaleValue = 1;
	            } else if (scale === "fitToWidth") {
	                viewer._allowResize = true;
	                viewer._autoFit = "fitToWidth";
	                scaleValue = (pageContainer.width() / (visibleCanvas.width / viewer.zoomScale));
	            } else if (scale === "fitToPage") {
	                viewer._allowResize = true;
	                viewer._autoFit = "fitToPage";
	                scaleValue = (pageContainer.height() / (visibleCanvas.height / viewer.zoomScale));
	            }

	            preventZoom = scale < viewerOptions.zoomMin || scale > viewerOptions.zoomMax;

	            if (preventZoom || viewer.trigger(ZOOMSTART, { scale: scale})) {
	                return;
	            }

	            if (options.updateComboBox && viewer.toolbar)
	            {
	                viewer.toolbar._updateZoomComboBox(scale);
	            }

	            return scaleValue;
	        },

	        _triggerZoomEnd: function (scale) {
	            var that = this,
	                viewer = that.viewer;

	            viewer.trigger(ZOOMEND, { scale: scale });
	        }
	    });

	    var PrintCommand = Command.extend({
	        init: function (options){
	            Command.fn.init.call(this, options);
	        },
	        exec: function () {
	            var that = this;

	             if (!that.viewer.document) {
	                that.viewer._triggerError({
	                    message: this.errorMessages.notFound
	                });
	                return;
	            }

	            progress(that.viewer.pageContainer, true);
	            that._renderPrintContainer();
	            that._loadAllPages().then(proxy(that.processAfterRender,that));
	        },
	        _renderPrintContainer: function () {
	            this.printContainer = $("<div></div>");
	        },
	        _loadAllPages: function () {
	            var that = this;
	            var pages = that.viewer.pages;
	            var loadPromises = [];
	            var renderPromises = [];
	            var promise = $.Deferred();

	            that._originalScale = that.viewer.zoom();

	            function getRenderPromise (page) {
	                renderPromises.push(page._renderPromise);
	            }

	            for (var i = 0; i < pages.length; i++) {
	                loadPromises.push(pages[i].load(3, true).then(getRenderPromise));
	            }

	            Promise.all(loadPromises).then(function(){
	                promise.resolve(renderPromises);
	            });

	            return promise;
	        },
	        processAfterRender: function(renderPromises){
	            var that = this;

	            Promise.all(renderPromises).then(function(){
	                that._renderPrintPages();
	                setTimeout(function () {
	                    that._printDocument();
	                    that.viewer.zoom(that._originalScale);
	                    progress(that.viewer.pageContainer, false);
	                    delete that._originalScale;
	                }, 0);
	            });
	        },
	        _renderPrintPages: function () {
	            var pages = this.viewer.pages;

	            for (var i = 0; i < pages.length; i++) {
	                this._renderPrintImage(pages[i]);
	            }
	         },
	        _renderPrintImage: function (page) {
	            var canvas = page.canvas;
	            var div = $("<div></div>");

	            var img = "<img src='" + canvas.toDataURL() + "' width='" + page.width + "px' height='" + page.height + "px' />";

	            div.append(img);

	            this.printContainer.append(div);
	        },
	        _printDocument: function () {
	            var that = this;
	            var pages = that.viewer.pages;
	            var width = pages[0].width;
	            var height = pages[0].height;

	            var myWindow = window.open('','','innerWidth=' + width + ',innerHeight=' + height + 'location=no,titlebar=no,toolbar=no');

	            if(!myWindow) {
	                that.viewer._triggerError({
	                    message: that.errorMessages.popupBlocked
	                });
	                return;
	            }

	            myWindow.document.write(that.printContainer.html());

	            myWindow.document.close();
	            myWindow.focus();
	            myWindow.print();
	            myWindow.close();
	        }
	    });

	    extend(kendo.pdfviewer, {
	        OpenCommand: OpenCommand,
	        PageChangeCommand: PageChangeCommand,
	        DownloadCommand: DownloadCommand,
	        EnableSelectionCommand: EnableSelectionCommand,
	        EnablePanCommand: EnablePanCommand,
	        ExportCommand: ExportCommand,
	        PrintCommand: PrintCommand,
	        OpenSearchCommand: OpenSearchCommand,
	        ZoomCommand: ZoomCommand
	    });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));

/***/ })

/******/ });

/***/ }),

/***/ "ydSV":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1072);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lXhv");

/***/ }),

/***/ 1072:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1049), __webpack_require__(1059) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "binder",
	    name: "MVVM",
	    category: "framework",
	    description: "Model View ViewModel (MVVM) is a design pattern which helps developers separate the Model (the data) from the View (the UI).",
	    depends: [ "core", "data" ]
	};

	/*jshint eqnull: true */
	(function ($, undefined) {
	    var kendo = window.kendo,
	        Observable = kendo.Observable,
	        ObservableObject = kendo.data.ObservableObject,
	        ObservableArray = kendo.data.ObservableArray,
	        toString = {}.toString,
	        binders = {},
	        Class = kendo.Class,
	        proxy = $.proxy,
	        VALUE = "value",
	        SOURCE = "source",
	        EVENTS = "events",
	        CHECKED = "checked",
	        CSS = "css",
	        deleteExpando = true,
	        FUNCTION = "function",
	        CHANGE = "change";

	    (function() {
	        var a = document.createElement("a");

	        try {
	            delete a.test;
	        } catch(e) {
	            deleteExpando = false;
	        }
	    })();

	    var Binding = Observable.extend( {
	        init: function(parents, path) {
	            var that = this;

	            Observable.fn.init.call(that);

	            that.source = parents[0];
	            that.parents = parents;
	            that.path = path;
	            that.dependencies = {};
	            that.dependencies[path] = true;
	            that.observable = that.source instanceof Observable;

	            that._access = function(e) {
	                that.dependencies[e.field] = true;
	            };

	            if (that.observable) {
	                that._change = function(e) {
	                    that.change(e);
	                };

	                that.source.bind(CHANGE, that._change);
	            }
	        },

	        _parents: function() {
	            var parents = this.parents;
	            var value = this.get();

	            if (value && typeof value.parent == "function") {
	                var parent = value.parent();

	                if ($.inArray(parent, parents) < 0) {
	                    parents = [parent].concat(parents);
	                }
	            }

	            return parents;
	        },

	        change: function(e) {
	            var dependency,
	                ch,
	                field = e.field,
	                that = this;

	            if (that.path === "this") {
	                that.trigger(CHANGE, e);
	            } else {
	                for (dependency in that.dependencies) {
	                    if (dependency.indexOf(field) === 0) {
	                       ch = dependency.charAt(field.length);

	                       if (!ch || ch === "." || ch === "[") {
	                            that.trigger(CHANGE, e);
	                            break;
	                       }
	                    }
	                }
	            }
	        },

	        start: function(source) {
	            source.bind("get", this._access);
	        },

	        stop: function(source) {
	            source.unbind("get", this._access);
	        },

	        get: function() {

	            var that = this,
	                source = that.source,
	                index = 0,
	                path = that.path,
	                result = source;

	            if (!that.observable) {
	                return result;
	            }

	            that.start(that.source);

	            result = source.get(path);

	            // Traverse the observable hierarchy if the binding is not resolved at the current level.
	            while (result === undefined && source) {

	                source = that.parents[++index];

	                if (source instanceof ObservableObject) {
	                    result = source.get(path);
	                }
	            }

	            // second pass try to get the parent from the object hierarchy
	            if (result === undefined) {
	                source = that.source; //get the initial source

	                while (result === undefined && source) {
	                    source = source.parent();

	                    if (source instanceof ObservableObject) {
	                        result = source.get(path);
	                    }
	                }
	            }

	            // If the result is a function - invoke it
	            if (typeof result === "function") {
	                index = path.lastIndexOf(".");

	                // If the function is a member of a nested observable object make that nested observable the context (this) of the function
	                if (index > 0) {
	                    source = source.get(path.substring(0, index));
	                }

	                // Invoke the function
	                that.start(source);

	                if (source !== that.source) {
	                    result = result.call(source, that.source);
	                } else {
	                    result = result.call(source);
	                }

	                that.stop(source);
	            }

	            // If the binding is resolved by a parent object
	            if (source && source !== that.source) {

	                that.currentSource = source; // save parent object

	                // Listen for changes in the parent object
	                source.unbind(CHANGE, that._change)
	                      .bind(CHANGE, that._change);
	            }

	            that.stop(that.source);

	            return result;
	        },

	        set: function(value) {
	            var source = this.currentSource || this.source;

	            var field = kendo.getter(this.path)(source);

	            if (typeof field === "function") {
	                if (source !== this.source) {
	                    field.call(source, this.source, value);
	                } else {
	                    field.call(source, value);
	                }
	            } else {
	                source.set(this.path, value);
	            }
	        },

	        destroy: function() {
	            if (this.observable) {
	                this.source.unbind(CHANGE, this._change);
	                if(this.currentSource) {
	                    this.currentSource.unbind(CHANGE, this._change);
	                }
	            }

	            this.unbind();
	        }
	    });

	    var EventBinding = Binding.extend( {
	        get: function() {
	            var source = this.source,
	                path = this.path,
	                index = 0,
	                handler;

	            handler = source.get(path);

	            while (!handler && source) {
	                source = this.parents[++index];

	                if (source instanceof ObservableObject) {
	                    handler = source.get(path);
	                }
	            }

	            return proxy(handler, source);
	        }
	    });

	    var TemplateBinding = Binding.extend( {
	        init: function(source, path, template) {
	            var that = this;

	            Binding.fn.init.call(that, source, path);

	            that.template = template;
	        },

	        render: function(value) {
	            var html;

	            this.start(this.source);

	            html = kendo.render(this.template, value);

	            this.stop(this.source);

	            return html;
	        }
	    });

	    var Binder = Class.extend({
	        init: function(element, bindings, options) {
	            this.element = element;
	            this.bindings = bindings;
	            this.options = options;
	        },

	        bind: function(binding, attribute) {
	            var that = this;

	            binding = attribute ? binding[attribute] : binding;

	            binding.bind(CHANGE, function(e) {
	                that.refresh(attribute || e);
	            });

	            that.refresh(attribute);
	        },

	        destroy: function() {
	        }
	    });

	    var TypedBinder = Binder.extend({
	        dataType: function() {
	            var dataType = this.element.getAttribute("data-" + kendo.ns + "type") || this.element.type || "text";
	            return dataType.toLowerCase();
	        },

	        parsedValue: function() {
	            return this._parseValue(this.element.value, this.dataType());
	        },

	        _parseValue: function (value, dataType){
	            if (dataType == "date") {
	                value = kendo.parseDate(value, "yyyy-MM-dd");
	            } else if (dataType == "datetime-local") {
	                value = kendo.parseDate(value, ["yyyy-MM-ddTHH:mm:ss", "yyyy-MM-ddTHH:mm"] );
	            } else if (dataType == "number") {
	                value = kendo.parseFloat(value);
	            } else if (dataType == "boolean"){
	                value = value.toLowerCase();
	                if(kendo.parseFloat(value) !== null){
	                    value = Boolean(kendo.parseFloat(value));
	                }else{
	                    value = (value.toLowerCase() === "true");
	                }
	            }
	            return value;
	        }
	    });

	    binders.attr = Binder.extend({
	        refresh: function(key) {
	            this.element.setAttribute(key, this.bindings.attr[key].get());
	        }
	    });

	    binders.css = Binder.extend({
	        init: function(element, bindings, options) {
	            Binder.fn.init.call(this, element, bindings, options);
	            this.classes = {};
	        },
	        refresh: function(className) {
	            var element = $(this.element),
	                binding = this.bindings.css[className],
	                hasClass = this.classes[className] = binding.get();
	            if(hasClass){
	                element.addClass(className);
	            }else{
	                element.removeClass(className);
	            }
	        }
	    });

	    binders.style = Binder.extend({
	        refresh: function(key) {
	            this.element.style[key] = this.bindings.style[key].get() || "";
	        }
	    });

	    binders.enabled = Binder.extend({
	        refresh: function() {
	            if (this.bindings.enabled.get()) {
	                this.element.removeAttribute("disabled");
	            } else {
	                this.element.setAttribute("disabled", "disabled");
	            }
	        }
	    });

	    binders.readonly = Binder.extend({
	       refresh: function() {
	            if (this.bindings.readonly.get()) {
	                this.element.setAttribute("readonly", "readonly");
	            } else {
	                this.element.removeAttribute("readonly");
	            }
	       }
	    });

	    binders.disabled = Binder.extend({
	        refresh: function() {
	            if (this.bindings.disabled.get()) {
	                this.element.setAttribute("disabled", "disabled");
	            } else {
	                this.element.removeAttribute("disabled");
	            }
	        }
	    });

	    binders.events = Binder.extend({
	        init: function(element, bindings, options) {
	            Binder.fn.init.call(this, element, bindings, options);
	            this.handlers = {};
	        },

	        refresh: function(key) {
	            var element = $(this.element),
	                binding = this.bindings.events[key],
	                handler = this.handlers[key];

	            if (handler) {
	                element.off(key, handler);
	            }

	            handler = this.handlers[key] = binding.get();

	            element.on(key, binding.source, handler);
	        },

	        destroy: function() {
	            var element = $(this.element),
	                handler;

	            for (handler in this.handlers) {
	                element.off(handler, this.handlers[handler]);
	            }
	        }
	    });

	    binders.text = Binder.extend({
	        refresh: function() {
	            var text = this.bindings.text.get();
	            var dataFormat = this.element.getAttribute("data-" + kendo.ns + "format") || "";
	            if (text == null) {
	                text = "";
	            }

	            $(this.element).text(kendo.toString(text, dataFormat));
	        }
	    });

	    binders.visible = Binder.extend({
	        refresh: function() {
	            if (this.bindings.visible.get()) {
	                this.element.style.display = "";
	            } else {
	                this.element.style.display = "none";
	            }
	        }
	    });

	    binders.invisible = Binder.extend({
	        refresh: function() {
	            if (!this.bindings.invisible.get()) {
	                this.element.style.display = "";
	            } else {
	                this.element.style.display = "none";
	            }
	        }
	  });

	    binders.html = Binder.extend({
	        refresh: function() {
	            this.element.innerHTML = this.bindings.html.get();
	        }
	    });

	    binders.value = TypedBinder.extend({
	        init: function(element, bindings, options) {
	            TypedBinder.fn.init.call(this, element, bindings, options);

	            this._change = proxy(this.change, this);
	            this.eventName = options.valueUpdate || CHANGE;

	            $(this.element).on(this.eventName, this._change);

	            this._initChange = false;
	        },

	        change: function() {
	            this._initChange = this.eventName != CHANGE;

	            this.bindings[VALUE].set(this.parsedValue());

	            this._initChange = false;
	        },

	        refresh: function() {
	            if (!this._initChange) {
	                var value = this.bindings[VALUE].get();

	                if (value == null) {
	                    value = "";
	                }

	                var type = this.dataType();

	                if (type == "date") {
	                    value = kendo.toString(value, "yyyy-MM-dd");
	                } else if (type == "datetime-local") {
	                    value = kendo.toString(value, "yyyy-MM-ddTHH:mm:ss");
	                }

	                this.element.value = value;
	            }

	            this._initChange = false;
	        },

	        destroy: function() {
	            $(this.element).off(this.eventName, this._change);
	        }
	    });

	    binders.source = Binder.extend({
	        init: function(element, bindings, options) {
	            Binder.fn.init.call(this, element, bindings, options);

	            var source = this.bindings.source.get();

	            if (source instanceof kendo.data.DataSource && options.autoBind !== false) {
	                source.fetch();
	            }
	        },

	        refresh: function(e) {
	            var that = this,
	                source = that.bindings.source.get();

	            if (source instanceof ObservableArray || source instanceof kendo.data.DataSource) {
	                e = e || {};

	                if (e.action == "add") {
	                    that.add(e.index, e.items);
	                } else if (e.action == "remove") {
	                    that.remove(e.index, e.items);
	                } else if (e.action != "itemchange") {
	                    that.render();
	                }
	            } else {
	                that.render();
	            }
	        },

	        container: function() {
	            var element = this.element;

	            if (element.nodeName.toLowerCase() == "table") {
	                if (!element.tBodies[0]) {
	                    element.appendChild(document.createElement("tbody"));
	                }
	                element = element.tBodies[0];
	            }

	            return element;
	        },

	        template: function() {
	            var options = this.options,
	                template = options.template,
	                nodeName = this.container().nodeName.toLowerCase();

	            if (!template) {
	                if (nodeName == "select") {
	                    if (options.valueField || options.textField) {
	                        template = kendo.format('<option value="#:{0}#">#:{1}#</option>',
	                            options.valueField || options.textField, options.textField || options.valueField);
	                    } else {
	                        template = "<option>#:data#</option>";
	                    }
	                } else if (nodeName == "tbody") {
	                    template = "<tr><td>#:data#</td></tr>";
	                } else if (nodeName == "ul" || nodeName == "ol") {
	                    template = "<li>#:data#</li>";
	                } else {
	                    template = "#:data#";
	                }
	                template = kendo.template(template);
	            }

	            return template;
	        },

	        add: function(index, items) {
	            var element = this.container(),
	                parents,
	                idx,
	                length,
	                child,
	                clone = element.cloneNode(false),
	                reference = element.children[index];

	            $(clone).html(kendo.render(this.template(), items));

	            if (clone.children.length) {
	                parents = this.bindings.source._parents();

	                for (idx = 0, length = items.length; idx < length; idx++) {
	                    child = clone.children[0];
	                    element.insertBefore(child, reference || null);
	                    bindElement(child, items[idx], this.options.roles, [items[idx]].concat(parents));
	                }
	            }
	        },

	        remove: function(index, items) {
	            var idx, element = this.container();

	            for (idx = 0; idx < items.length; idx++) {
	                var child = element.children[index];
	                unbindElementTree(child, true);
	                if (child.parentNode == element) {
	                    element.removeChild(child);
	                }
	            }
	        },

	        render: function() {
	            var source = this.bindings.source.get(),
	                parents,
	                idx,
	                length,
	                element = this.container(),
	                template = this.template();

	            if (source == null) {
	                return;
	            }

	            if (source instanceof kendo.data.DataSource) {
	                source = source.view();
	            }

	            if (!(source instanceof ObservableArray) && toString.call(source) !== "[object Array]") {
	                source = [source];
	            }

	            if (this.bindings.template) {
	                unbindElementChildren(element, true);

	                $(element).html(this.bindings.template.render(source));

	                if (element.children.length) {
	                    parents = this.bindings.source._parents();

	                    for (idx = 0, length = source.length; idx < length; idx++) {
	                        bindElement(element.children[idx], source[idx], this.options.roles, [source[idx]].concat(parents));
	                    }
	                }
	            } else {
	                $(element).html(kendo.render(template, source));
	            }
	        }
	    });

	    binders.input = {
	        checked: TypedBinder.extend({
	            init: function(element, bindings, options) {
	                TypedBinder.fn.init.call(this, element, bindings, options);
	                this._change = proxy(this.change, this);

	                $(this.element).change(this._change);
	            },

	            change: function() {
	                var element = this.element;
	                var value = this.value();

	                if (element.type == "radio") {
	                    value = this.parsedValue();
	                    this.bindings[CHECKED].set(value);
	                } else if (element.type == "checkbox") {
	                    var source = this.bindings[CHECKED].get();
	                    var index;

	                    if (source instanceof ObservableArray) {
	                        value = this.parsedValue();
	                        if (value instanceof Date) {
	                            for(var i = 0; i < source.length; i++){
	                                if(source[i] instanceof Date && +source[i] === +value){
	                                    index = i;
	                                    break;
	                                }
	                            }
	                        }else{
	                            index = source.indexOf(value);
	                        }
	                        if (index > -1) {
	                            source.splice(index, 1);
	                        } else {
	                            source.push(value);
	                        }
	                    } else {
	                        this.bindings[CHECKED].set(value);
	                    }
	                }
	            },

	            refresh: function() {
	                var value = this.bindings[CHECKED].get(),
	                    source = value,
	                    type = this.dataType(),
	                    element = this.element;

	                if (element.type == "checkbox") {
	                    if (source instanceof ObservableArray) {
	                        var index = -1;
	                        value = this.parsedValue();
	                        if(value instanceof Date){
	                            for(var i = 0; i < source.length; i++){
	                                if(source[i] instanceof Date && +source[i] === +value){
	                                    index = i;
	                                    break;
	                                }
	                            }
	                        }else{
	                            index = source.indexOf(value);
	                        }
	                        element.checked = (index >= 0);
	                    }else{
	                        element.checked = source;
	                    }
	                } else if (element.type == "radio") {
	                    if (type == "date") {
	                        value = kendo.toString(value, "yyyy-MM-dd");
	                    } else if (type == "datetime-local") {
	                        value = kendo.toString(value, "yyyy-MM-ddTHH:mm:ss");
	                    }

	                    if (value !== null && typeof(value) !== "undefined" && element.value === value.toString()) {
	                        element.checked = true;
	                    } else {
	                        element.checked = false;
	                    }
	                }
	            },

	            value: function() {
	                var element = this.element,
	                    value = element.value;

	                if (element.type == "checkbox") {
	                    value = element.checked;
	                }

	                return value;
	            },
	            destroy: function() {
	                $(this.element).off(CHANGE, this._change);
	            }
	        })
	    };

	    binders.select = {
	        source: binders.source.extend({
	            refresh: function(e) {
	                var that = this,
	                    source = that.bindings.source.get();

	                if (source instanceof ObservableArray || source instanceof kendo.data.DataSource) {
	                    e = e || {};
	                    if (e.action == "add") {
	                        that.add(e.index, e.items);
	                    } else if (e.action == "remove") {
	                        that.remove(e.index, e.items);
	                    } else if (e.action == "itemchange" || e.action === undefined) {
	                        that.render();
	                        if(that.bindings.value){
	                            if (that.bindings.value) {
	                                var val = retrievePrimitiveValues(that.bindings.value.get(), $(that.element).data("valueField"));
	                                if(val === null) {
	                                    that.element.selectedIndex = -1;
	                                } else {
	                                    that.element.value = val;
	                                }
	                            }
	                        }
	                    }
	                } else {
	                    that.render();
	                }
	            }
	        }),
	        value: TypedBinder.extend({
	            init: function(target, bindings, options) {
	                TypedBinder.fn.init.call(this, target, bindings, options);

	                this._change = proxy(this.change, this);
	                $(this.element).change(this._change);
	            },

	            parsedValue : function() {
	                var dataType = this.dataType();
	                var values = [];
	                var value, option, idx, length;
	                for (idx = 0, length = this.element.options.length; idx < length; idx++) {
	                    option = this.element.options[idx];

	                    if (option.selected) {
	                        value = option.attributes.value;

	                        if (value && value.specified) {
	                            value = option.value;
	                        } else {
	                            value = option.text;
	                        }

	                        values.push(this._parseValue(value, dataType));
	                    }
	                }
	                return values;
	            },

	            change: function() {
	                var values = [],
	                    element = this.element,
	                    source,
	                    field = this.options.valueField || this.options.textField,
	                    valuePrimitive = this.options.valuePrimitive,
	                    option,
	                    valueIndex,
	                    value,
	                    idx,
	                    length;

	                for (idx = 0, length = element.options.length; idx < length; idx++) {
	                    option = element.options[idx];

	                    if (option.selected) {
	                        value = option.attributes.value;

	                        if (value && value.specified) {
	                            value = option.value;
	                        } else {
	                            value = option.text;
	                        }

	                        if (field) {
	                            values.push(value);
	                        } else {
	                            values.push(this._parseValue(value, this.dataType()));
	                        }

	                    }
	                }

	                if (field) {
	                    source = this.bindings.source.get();
	                    if (source instanceof kendo.data.DataSource) {
	                        source = source.view();
	                    }

	                    for (valueIndex = 0; valueIndex < values.length; valueIndex++) {
	                        for (idx = 0, length = source.length; idx < length; idx++) {
	                            var sourceValue = source[idx].get(field);
	                            var match = (String(sourceValue) === values[valueIndex]);
	                            if (match) {
	                                values[valueIndex] = source[idx];
	                                break;
	                            }
	                        }
	                    }
	                }

	                value = this.bindings[VALUE].get();
	                if (value instanceof ObservableArray) {
	                    value.splice.apply(value, [0, value.length].concat(values));
	                } else if (!valuePrimitive && (value instanceof ObservableObject || value === null || value === undefined || !field)) {
	                    this.bindings[VALUE].set(values[0]);
	                } else {
	                    this.bindings[VALUE].set(values[0].get(field));
	                }
	            },
	            refresh: function() {
	                var optionIndex,
	                    element = this.element,
	                    options = element.options,
	                    value = this.bindings[VALUE].get(),
	                    values = value,
	                    field = this.options.valueField || this.options.textField,
	                    found = false,
	                    type = this.dataType(),
	                    optionValue;

	                if (!(values instanceof ObservableArray)) {
	                    values = new ObservableArray([value]);
	                }

	                element.selectedIndex = -1;

	                for (var valueIndex = 0; valueIndex < values.length; valueIndex++) {
	                    value = values[valueIndex];


	                    if (field && value instanceof ObservableObject) {
	                        value = value.get(field);
	                    }

	                    if (type == "date") {
	                        value = kendo.toString(values[valueIndex], "yyyy-MM-dd");
	                    } else if (type == "datetime-local") {
	                        value = kendo.toString(values[valueIndex], "yyyy-MM-ddTHH:mm:ss");
	                    }

	                    for (optionIndex = 0; optionIndex < options.length; optionIndex++) {
	                        optionValue = options[optionIndex].value;

	                        if (optionValue === "" && value !== "") {
	                            optionValue = options[optionIndex].text;
	                        }

	                        if (value != null && optionValue == value.toString()) {
	                            options[optionIndex].selected = true;
	                            found = true;
	                        }
	                    }
	                }
	            },
	            destroy: function() {
	                $(this.element).off(CHANGE, this._change);
	            }
	        })
	    };

	    function dataSourceBinding(bindingName, fieldName, setter) {
	        return Binder.extend({
	            init: function(widget, bindings, options) {
	                var that = this;

	                Binder.fn.init.call(that, widget.element[0], bindings, options);

	                that.widget = widget;
	                that._dataBinding = proxy(that.dataBinding, that);
	                that._dataBound = proxy(that.dataBound, that);
	                that._itemChange = proxy(that.itemChange, that);
	            },

	            itemChange: function(e) {
	                bindElement(e.item[0], e.data, this._ns(e.ns), [e.data].concat(this.bindings[bindingName]._parents()));
	            },

	            dataBinding: function(e) {
	                var idx,
	                    length,
	                    widget = this.widget,
	                    items = e.removedItems || widget.items();

	                for (idx = 0, length = items.length; idx < length; idx++) {
	                    unbindElementTree(items[idx], false);
	                }
	            },

	            _ns: function(ns) {
	                ns = ns || kendo.ui;
	                var all = [ kendo.ui, kendo.dataviz.ui, kendo.mobile.ui ];
	                all.splice($.inArray(ns, all), 1);
	                all.unshift(ns);

	                return kendo.rolesFromNamespaces(all);
	            },

	            dataBound: function(e) {
	                var idx,
	                    length,
	                    widget = this.widget,
	                    items = e.addedItems || widget.items(),
	                    dataSource = widget[fieldName],
	                    view,
	                    parents,
	                    hds = kendo.data.HierarchicalDataSource;

	                if (hds && dataSource instanceof hds) {
	                    // suppress binding of HDS items, because calling view() on root
	                    // will return only root items, and widget.items() returns all items
	                    return;
	                }

	                if (items.length) {
	                    view = e.addedDataItems || dataSource.flatView();
	                    parents = this.bindings[bindingName]._parents();

	                    for (idx = 0, length = view.length; idx < length; idx++) {
	                        if (items[idx]) {
	                            bindElement(items[idx], view[idx], this._ns(e.ns), [view[idx]].concat(parents));
	                        }
	                    }
	                }
	            },

	            refresh: function(e) {
	                var that = this,
	                    source,
	                    widget = that.widget,
	                    select, multiselect, dropdowntree;

	                e = e || {};

	                if (!e.action) {
	                    that.destroy();

	                    widget.bind("dataBinding", that._dataBinding);
	                    widget.bind("dataBound", that._dataBound);
	                    widget.bind("itemChange", that._itemChange);

	                    source = that.bindings[bindingName].get();

	                    if (widget[fieldName] instanceof kendo.data.DataSource && widget[fieldName] != source) {
	                        if (source instanceof kendo.data.DataSource) {
	                            widget[setter](source);
	                        } else if (source && source._dataSource) {
	                            widget[setter](source._dataSource);
	                        } else {
	                            select = kendo.ui.Select && widget instanceof kendo.ui.Select;
	                            multiselect = kendo.ui.MultiSelect && widget instanceof kendo.ui.MultiSelect;
	                            dropdowntree = kendo.ui.DropDownTree && widget instanceof kendo.ui.DropDownTree;

	                            if(!dropdowntree){
	                                widget[fieldName].data(source);
	                            }else{
	                                widget.treeview[fieldName].data(source);
	                            }

	                            if (that.bindings.value && (select || multiselect)) {
	                                widget.value(retrievePrimitiveValues(that.bindings.value.get(), widget.options.dataValueField));
	                            }
	                        }
	                    }
	                }
	            },

	            destroy: function() {
	                var widget = this.widget;

	                widget.unbind("dataBinding", this._dataBinding);
	                widget.unbind("dataBound", this._dataBound);
	                widget.unbind("itemChange", this._itemChange);
	            }
	        });
	    }

	    binders.widget = {
	        events : Binder.extend({
	            init: function(widget, bindings, options) {
	                Binder.fn.init.call(this, widget.element[0], bindings, options);
	                this.widget = widget;
	                this.handlers = {};
	            },

	            refresh: function(key) {
	                var binding = this.bindings.events[key],
	                    handler = this.handlers[key];

	                if (handler) {
	                    this.widget.unbind(key, handler);
	                }

	                handler = binding.get();

	                this.handlers[key] = function(e) {
	                    e.data = binding.source;

	                    handler(e);

	                    if (e.data === binding.source) {
	                        delete e.data;
	                    }
	                };

	                this.widget.bind(key, this.handlers[key]);
	            },

	            destroy: function() {
	                var handler;

	                for (handler in this.handlers) {
	                    this.widget.unbind(handler, this.handlers[handler]);
	                }
	            }
	        }),

	        checked: Binder.extend({
	            init: function(widget, bindings, options) {
	                Binder.fn.init.call(this, widget.element[0], bindings, options);

	                this.widget = widget;
	                this._change = proxy(this.change, this);
	                this.widget.bind(CHANGE, this._change);
	            },
	            change: function() {
	                this.bindings[CHECKED].set(this.value());
	            },

	            refresh: function() {
	                this.widget.check(this.bindings[CHECKED].get() === true);
	            },

	            value: function() {
	                var element = this.element,
	                    value = element.value;

	                if (value == "on" || value == "off" || this.element.type == "checkbox") {
	                    value = element.checked;
	                }

	                return value;
	            },

	            destroy: function() {
	                this.widget.unbind(CHANGE, this._change);
	            }
	        }),

	        start: Binder.extend({
	            init: function(widget, bindings, options) {
	                Binder.fn.init.call(this, widget.element[0], bindings, options);
	                this._change = proxy(this.change, this);
	                this.widget = widget;
	                this.widget.bind(CHANGE, this._change);
	            },

	            change: function() {
	                this.bindings.start.set(this.widget.range().start);
	            },

	            refresh: function() {
	                var that = this;
	                var start = this.bindings.start.get();
	                var end = that.widget._range ? that.widget._range.end: null;
	                this.widget.range({start: start, end: end});
	            },

	            destroy: function() {
	                this.widget.unbind(CHANGE, this._change);
	            }
	        }),

	        end: Binder.extend({
	            init: function(widget, bindings, options) {
	                Binder.fn.init.call(this, widget.element[0], bindings, options);
	                this._change = proxy(this.change, this);
	                this.widget = widget;
	                this.widget.bind(CHANGE, this._change);
	            },

	            change: function() {
	                this.bindings.end.set(this.widget.range().end);
	            },

	            refresh: function() {
	                var that = this;
	                var end = this.bindings.end.get();
	                var start = that.widget._range ? that.widget._range.start: null;
	                this.widget.range({start: start, end: end});
	            },

	            destroy: function() {
	                this.widget.unbind(CHANGE, this._change);
	            }
	        }),

	        visible: Binder.extend({
	            init: function(widget, bindings, options) {
	                Binder.fn.init.call(this, widget.element[0], bindings, options);

	                this.widget = widget;
	            },

	            refresh: function() {
	                var visible = this.bindings.visible.get();
	                this.widget.wrapper[0].style.display = visible ? "" : "none";
	            }
	        }),

	        invisible: Binder.extend({
	            init: function(widget, bindings, options) {
	                Binder.fn.init.call(this, widget.element[0], bindings, options);

	                this.widget = widget;
	            },

	            refresh: function() {
	                var invisible = this.bindings.invisible.get();
	                this.widget.wrapper[0].style.display = invisible ? "none" : "";
	            }
	        }),

	        enabled: Binder.extend({
	            init: function(widget, bindings, options) {
	                Binder.fn.init.call(this, widget.element[0], bindings, options);

	                this.widget = widget;
	            },

	            refresh: function() {
	                if (this.widget.enable) {
	                    this.widget.enable(this.bindings.enabled.get());
	                }
	            }
	        }),

	        disabled: Binder.extend({
	            init: function(widget, bindings, options) {
	                Binder.fn.init.call(this, widget.element[0], bindings, options);

	                this.widget = widget;
	            },

	            refresh: function() {
	                if (this.widget.enable) {
	                    this.widget.enable(!this.bindings.disabled.get());
	                }
	            }
	        }),

	        source: dataSourceBinding("source", "dataSource", "setDataSource"),

	        value: Binder.extend({
	            init: function(widget, bindings, options) {
	                Binder.fn.init.call(this, widget.element[0], bindings, options);

	                this.widget = widget;
	                this._change = $.proxy(this.change, this);
	                this.widget.first(CHANGE, this._change);

	                var value = this.bindings.value.get();

	                this._valueIsObservableObject = !options.valuePrimitive && (value == null || value instanceof ObservableObject);
	                this._valueIsObservableArray = value instanceof ObservableArray;
	                this._initChange = false;
	            },

	            _source: function() {
	                var source;

	                if (this.widget.dataItem) {
	                    source = this.widget.dataItem();
	                    if (source && source instanceof ObservableObject) {
	                        return [source];
	                    }
	                }

	                if (this.bindings.source) {
	                    source = this.bindings.source.get();
	                }

	                if (!source || source instanceof kendo.data.DataSource) {
	                    source = this.widget.dataSource.flatView();
	                }

	                return source;
	            },

	            change: function() {
	                var value = this.widget.value(),
	                    field = this.options.dataValueField || this.options.dataTextField,
	                    isArray = toString.call(value) === "[object Array]",
	                    isObservableObject = this._valueIsObservableObject,
	                    valueIndex, valueLength, values = [],
	                    sourceItem, sourceValue,
	                    idx, length, source;

	                this._initChange = true;

	                if (field) {

	                    if (value === "" && (isObservableObject || this.options.valuePrimitive)) {
	                        value = null;
	                    } else {
	                        source = this._source();

	                        if (isArray) {
	                            valueLength = value.length;
	                            values = value.slice(0);
	                        }

	                        for (idx = 0, length = source.length; idx < length; idx++) {
	                            sourceItem = source[idx];
	                            sourceValue = sourceItem.get(field);

	                            if (isArray) {
	                                for (valueIndex = 0; valueIndex < valueLength; valueIndex++) {
	                                    if (sourceValue == values[valueIndex]) {
	                                        values[valueIndex] = sourceItem;
	                                        break;
	                                    }
	                                }
	                            } else if (sourceValue == value) {
	                                value = isObservableObject ? sourceItem : sourceValue;
	                                break;
	                            }
	                        }

	                        if (values[0]) {
	                            if (this._valueIsObservableArray) {
	                                value = values;
	                            } else if (isObservableObject || !field) {
	                                value = values[0];
	                            } else {
	                                value = values[0].get(field);
	                            }
	                        }
	                    }
	                }

	                this.bindings.value.set(value);
	                this._initChange = false;
	            },

	            refresh: function() {
	                if (!this._initChange) {
	                    var widget = this.widget;
	                    var options = widget.options;
	                    var textField = options.dataTextField;
	                    var valueField = options.dataValueField || textField;
	                    var value = this.bindings.value.get();
	                    var text = options.text || "";
	                    var idx = 0, length;
	                    var values = [];

	                    if (value === undefined) {
	                        value = null;
	                    }

	                    if (valueField) {
	                        if (value instanceof ObservableArray) {
	                            for (length = value.length; idx < length; idx++) {
	                                values[idx] = value[idx].get(valueField);
	                            }
	                            value = values;
	                        } else if (value instanceof ObservableObject) {
	                            text = value.get(textField);
	                            value = value.get(valueField);
	                        }
	                    }

	                    if (options.autoBind === false && !options.cascadeFrom && widget.listView && !widget.listView.bound()) {
	                        if (textField === valueField && !text) {
	                            text = value;
	                        }

	                        if (!text && (value || value === 0) && options.valuePrimitive) {
	                            widget.value(value);
	                        } else {
	                            widget._preselect(value, text);
	                        }
	                    } else {
	                        widget.value(value);
	                    }
	                }

	                this._initChange = false;
	            },

	            destroy: function() {
	                this.widget.unbind(CHANGE, this._change);
	            }
	        }),
	        dropdowntree: {
	            value: Binder.extend({
	                init: function(widget, bindings, options) {
	                    Binder.fn.init.call(this, widget.element[0], bindings, options);

	                    this.widget = widget;
	                    this._change = $.proxy(this.change, this);
	                    this.widget.first(CHANGE, this._change);
	                    this._initChange = false;
	                },

	                change: function() {
	                    var that = this,
	                        oldValues = that.bindings[VALUE].get(),
	                        valuePrimitive = that.options.valuePrimitive,
	                        selectedNode = that.widget.treeview.select(),
	                        nonPrimitiveValues = that.widget._isMultipleSelection() ? that.widget._getAllChecked(): (that.widget.treeview.dataItem(selectedNode) || that.widget.value()),
	                        newValues = (valuePrimitive || that.widget.options.autoBind === false) ? that.widget.value() : nonPrimitiveValues;

	                    var field = this.options.dataValueField || this.options.dataTextField;

	                    newValues = newValues.slice ? newValues.slice(0): newValues;

	                    that._initChange = true;

	                    if (oldValues instanceof ObservableArray) {
	                        var remove = [];
	                        var newLength = newValues.length;
	                        var i = 0, j = 0;
	                        var old = oldValues[i];
	                        var same = false;
	                        var removeIndex;
	                        var newValue;
	                        var found;

	                        while (old !== undefined) {
	                            found = false;
	                            for (j = 0; j < newLength; j++) {
	                                if (valuePrimitive) {
	                                    same = newValues[j] == old;
	                                } else {
	                                    newValue = newValues[j];

	                                    newValue = newValue.get ? newValue.get(field) : newValue;
	                                    same = newValue == (old.get ? old.get(field) : old);
	                                }

	                                if (same) {
	                                    newValues.splice(j, 1);
	                                    newLength -= 1;
	                                    found = true;
	                                    break;
	                                }
	                            }

	                            if (!found) {
	                                remove.push(old);
	                                arraySplice(oldValues, i, 1);
	                                removeIndex = i;
	                            } else {
	                                i += 1;
	                            }

	                            old = oldValues[i];
	                        }

	                        arraySplice(oldValues, oldValues.length, 0, newValues);

	                        if (remove.length) {
	                            oldValues.trigger("change", {
	                                action: "remove",
	                                items: remove,
	                                index: removeIndex
	                            });
	                        }

	                        if (newValues.length) {
	                            oldValues.trigger("change", {
	                                action: "add",
	                                items: newValues,
	                                index: oldValues.length - 1
	                            });
	                        }
	                    } else {
	                        that.bindings[VALUE].set(newValues);
	                    }

	                    that._initChange = false;
	                },

	                refresh: function() {
	                    if (!this._initChange) {
	                        var options = this.options,
	                            widget = this.widget,
	                            field = options.dataValueField || options.dataTextField,
	                            value = this.bindings.value.get(),
	                            data = value,
	                            idx = 0, length,
	                            values = [],
	                            selectedValue;

	                        if (field) {
	                            if (value instanceof ObservableArray) {
	                                for (length = value.length; idx < length; idx++) {
	                                    selectedValue = value[idx];
	                                    values[idx] = selectedValue.get ? selectedValue.get(field) : selectedValue;
	                                }
	                                value = values;
	                            } else if (value instanceof ObservableObject) {
	                                value = value.get(field);
	                            }
	                        }
	                        if (options.autoBind === false && options.valuePrimitive !== true) {
	                            widget._preselect(data, value);
	                        } else {
	                            widget.value(value);
	                        }
	                   }
	                },

	                destroy: function() {
	                    this.widget.unbind(CHANGE, this._change);
	                }
	            })
	        },
	        gantt: {
	            dependencies: dataSourceBinding("dependencies", "dependencies", "setDependenciesDataSource")
	        },

	        multiselect: {
	            value: Binder.extend({
	                init: function(widget, bindings, options) {
	                    Binder.fn.init.call(this, widget.element[0], bindings, options);

	                    this.widget = widget;
	                    this._change = $.proxy(this.change, this);
	                    this.widget.first(CHANGE, this._change);
	                    this._initChange = false;
	                },

	                change: function() {
	                    var that = this,
	                        oldValues = that.bindings[VALUE].get(),
	                        valuePrimitive = that.options.valuePrimitive,
	                        newValues = valuePrimitive ? that.widget.value() : that.widget.dataItems();

	                    var field = this.options.dataValueField || this.options.dataTextField;

	                    newValues = newValues.slice(0);

	                    that._initChange = true;

	                    if (oldValues instanceof ObservableArray) {
	                        var remove = [];

	                        var newLength = newValues.length;

	                        var i = 0, j = 0;
	                        var old = oldValues[i];
	                        var same = false;
	                        var removeIndex;
	                        var newValue;
	                        var found;

	                        while (old !== undefined) {
	                            found = false;
	                            for (j = 0; j < newLength; j++) {
	                                if (valuePrimitive) {
	                                    same = newValues[j] == old;
	                                } else {
	                                    newValue = newValues[j];

	                                    newValue = newValue.get ? newValue.get(field) : newValue;
	                                    same = newValue == (old.get ? old.get(field) : old);
	                                }

	                                if (same) {
	                                    newValues.splice(j, 1);
	                                    newLength -= 1;
	                                    found = true;
	                                    break;
	                                }
	                            }

	                            if (!found) {
	                                remove.push(old);
	                                arraySplice(oldValues, i, 1);
	                                removeIndex = i;
	                            } else {
	                                i += 1;
	                            }

	                            old = oldValues[i];
	                        }

	                        arraySplice(oldValues, oldValues.length, 0, newValues);

	                        if (remove.length) {
	                            oldValues.trigger("change", {
	                                action: "remove",
	                                items: remove,
	                                index: removeIndex
	                            });
	                        }

	                        if (newValues.length) {
	                            oldValues.trigger("change", {
	                                action: "add",
	                                items: newValues,
	                                index: oldValues.length - 1
	                            });
	                        }
	                    } else {
	                        that.bindings[VALUE].set(newValues);
	                    }

	                    that._initChange = false;
	                },

	                refresh: function() {
	                    if (!this._initChange) {
	                        var options = this.options,
	                            widget = this.widget,
	                            field = options.dataValueField || options.dataTextField,
	                            value = this.bindings.value.get(),
	                            data = value,
	                            idx = 0, length,
	                            values = [],
	                            selectedValue;

	                        if (value === undefined) {
	                            value = null;
	                        }

	                        if (field) {
	                            if (value instanceof ObservableArray) {
	                                for (length = value.length; idx < length; idx++) {
	                                    selectedValue = value[idx];
	                                    values[idx] = selectedValue.get ? selectedValue.get(field) : selectedValue;
	                                }
	                                value = values;
	                            } else if (value instanceof ObservableObject) {
	                                value = value.get(field);
	                            }
	                        }

	                        if (options.autoBind === false && options.valuePrimitive !== true && !widget._isBound()) {
	                            widget._preselect(data, value);
	                        } else {
	                            widget.value(value);
	                        }
	                    }
	                },

	                destroy: function() {
	                    this.widget.unbind(CHANGE, this._change);
	                }

	            })
	        },
	        scheduler: {
	            source: dataSourceBinding("source", "dataSource", "setDataSource").extend({
	                dataBound: function(e) {
	                    var idx;
	                    var length;
	                    var widget = this.widget;
	                    var elements = e.addedItems || widget.items();
	                    var data, parents;

	                    if (elements.length) {
	                        data = e.addedDataItems || widget.dataItems();
	                        parents = this.bindings.source._parents();

	                        for (idx = 0, length = data.length; idx < length; idx++) {
	                            bindElement(elements[idx], data[idx], this._ns(e.ns), [data[idx]].concat(parents));
	                        }
	                    }
	                }
	            })
	        },

	        grid: {
	            source: dataSourceBinding("source", "dataSource", "setDataSource").extend({
	                dataBound: function(e) {
	                    var idx,
	                    length,
	                    widget = this.widget,
	                    elements = e.addedItems || widget.items(),
	                    parents,
	                    data;

	                    if (elements.length) {
	                        data = e.addedDataItems || widget.dataItems();
	                        parents = this.bindings.source._parents();

	                        for (idx = 0, length = data.length; idx < length; idx++) {
	                            bindElement(elements[idx], data[idx], this._ns(e.ns), [data[idx]].concat(parents));
	                        }
	                    }
	                }
	            })
	        },

	        badge: {
	            text: Binder.extend({
	                init: function(widget, bindings, options) {
	                    Binder.fn.init.call(this, widget.element[0], bindings, options);

	                    this.widget = widget;
	                },
	                refresh: function() {
	                    var text = this.bindings.text.get();

	                    if (text == null) {
	                        text = "";
	                    }
	                    this.widget.text(text);
	                }
	            })
	        }
	    };

	    var arraySplice = function(arr, idx, remove, add) {
	        add = add || [];
	        remove = remove || 0;

	        var addLength = add.length;
	        var oldLength = arr.length;

	        var shifted = [].slice.call(arr, idx + remove);
	        var shiftedLength = shifted.length;
	        var index;

	        if (addLength) {
	            addLength = idx + addLength;
	            index = 0;

	            for (; idx < addLength; idx++) {
	                arr[idx] = add[index];
	                index++;
	            }

	            arr.length = addLength;
	        } else if (remove) {
	            arr.length = idx;

	            remove += idx;
	            while (idx < remove) {
	                delete arr[--remove];
	            }
	        }

	        if (shiftedLength) {
	            shiftedLength = idx + shiftedLength;
	            index = 0;

	            for (; idx < shiftedLength; idx++) {
	                arr[idx] = shifted[index];
	                index++;
	            }

	            arr.length = shiftedLength;
	        }

	        idx = arr.length;

	        while (idx < oldLength) {
	            delete arr[idx];
	            idx++;
	        }
	    };

	    var BindingTarget = Class.extend( {
	        init: function(target, options) {
	            this.target = target;
	            this.options = options;
	            this.toDestroy = [];
	        },

	        bind: function(bindings) {
	            var key,
	                hasValue,
	                hasSource,
	                hasEvents,
	                hasChecked,
	                hasCss,
	                widgetBinding = this instanceof WidgetBindingTarget,
	                specificBinders = this.binders();

	            for (key in bindings) {
	                if (key == VALUE) {
	                    hasValue = true;
	                } else if (key == SOURCE) {
	                    hasSource = true;
	                } else if (key == EVENTS && !widgetBinding) {
	                    hasEvents = true;
	                } else if (key == CHECKED) {
	                    hasChecked = true;
	                } else if (key == CSS) {
	                    hasCss = true;
	                } else {
	                    this.applyBinding(key, bindings, specificBinders);
	                }
	            }
	            if (hasSource) {
	                this.applyBinding(SOURCE, bindings, specificBinders);
	            }

	            if (hasValue) {
	                this.applyBinding(VALUE, bindings, specificBinders);
	            }

	            if (hasChecked) {
	                this.applyBinding(CHECKED, bindings, specificBinders);
	            }

	            if (hasEvents && !widgetBinding) {
	                this.applyBinding(EVENTS, bindings, specificBinders);
	            }

	            if (hasCss && !widgetBinding) {
	                this.applyBinding(CSS, bindings, specificBinders);
	            }
	        },

	        binders: function() {
	            return binders[this.target.nodeName.toLowerCase()] || {};
	        },

	        applyBinding: function(name, bindings, specificBinders) {
	            var binder = specificBinders[name] || binders[name],
	                toDestroy = this.toDestroy,
	                attribute,
	                binding = bindings[name];

	            if (binder) {
	                binder = new binder(this.target, bindings, this.options);

	                toDestroy.push(binder);

	                if (binding instanceof Binding) {
	                    binder.bind(binding);
	                    toDestroy.push(binding);
	                } else {
	                    for (attribute in binding) {
	                        binder.bind(binding, attribute);
	                        toDestroy.push(binding[attribute]);
	                    }
	                }
	            } else if (name !== "template") {
	                throw new Error("The " + name + " binding is not supported by the " + this.target.nodeName.toLowerCase() + " element");
	            }
	        },

	        destroy: function() {
	            var idx,
	                length,
	                toDestroy = this.toDestroy;

	            for (idx = 0, length = toDestroy.length; idx < length; idx++) {
	                toDestroy[idx].destroy();
	            }
	        }
	    });

	    var WidgetBindingTarget = BindingTarget.extend( {
	        binders: function() {
	            return binders.widget[this.target.options.name.toLowerCase()] || {};
	        },

	        applyBinding: function(name, bindings, specificBinders) {
	            var binder = specificBinders[name] || binders.widget[name],
	                toDestroy = this.toDestroy,
	                attribute,
	                binding = bindings[name];

	            if (binder) {
	                binder = new binder(this.target, bindings, this.target.options);

	                toDestroy.push(binder);


	                if (binding instanceof Binding) {
	                    binder.bind(binding);
	                    toDestroy.push(binding);
	                } else {
	                    for (attribute in binding) {
	                        binder.bind(binding, attribute);
	                        toDestroy.push(binding[attribute]);
	                    }
	                }
	            } else {
	                throw new Error("The " + name + " binding is not supported by the " + this.target.options.name + " widget");
	            }
	        }
	    });

	    function bindingTargetForRole(element, roles) {
	        var widget = kendo.initWidget(element, {}, roles);

	        if (widget) {
	            return new WidgetBindingTarget(widget);
	        }
	    }

	    var keyValueRegExp = /[A-Za-z0-9_\-]+:(\{([^}]*)\}|[^,}]+)/g,
	        whiteSpaceRegExp = /\s/g;

	    function parseBindings(bind) {
	        var result = {},
	            idx,
	            length,
	            token,
	            colonIndex,
	            key,
	            value,
	            tokens;

	        tokens = bind.match(keyValueRegExp);

	        for (idx = 0, length = tokens.length; idx < length; idx++) {
	            token = tokens[idx];
	            colonIndex = token.indexOf(":");

	            key = token.substring(0, colonIndex);
	            value = token.substring(colonIndex + 1);

	            if (value.charAt(0) == "{") {
	                value = parseBindings(value);
	            }

	            result[key] = value;
	        }

	        return result;
	    }

	    function createBindings(bindings, source, type) {
	        var binding,
	            result = {};

	        for (binding in bindings) {
	            result[binding] = new type(source, bindings[binding]);
	        }

	        return result;
	    }

	    function bindElement(element, source, roles, parents) {

	        if(!element || element.getAttribute("data-" + kendo.ns + "stop")){
	            return;
	        }

	        var role = element.getAttribute("data-" + kendo.ns + "role"),
	            idx,
	            bind = element.getAttribute("data-" + kendo.ns + "bind"),
	            childrenCopy = [],
	            deep = true,
	            bindings,
	            options = {},
	            target;

	        parents = parents || [source];

	        if (role || bind) {
	            unbindElement(element, false);
	        }

	        if (role) {
	            target = bindingTargetForRole(element, roles);
	        }

	        if (bind) {
	            bind = parseBindings(bind.replace(whiteSpaceRegExp, ""));

	            if (!target) {
	                options = kendo.parseOptions(element, {textField: "", valueField: "", template: "", valueUpdate: CHANGE, valuePrimitive: false, autoBind: true}, source);
	                options.roles = roles;
	                target = new BindingTarget(element, options);
	            }

	            target.source = source;

	            bindings = createBindings(bind, parents, Binding);

	            if (options.template) {
	                bindings.template = new TemplateBinding(parents, "", options.template);
	            }

	            if (bindings.click) {
	                bind.events = bind.events || {};
	                bind.events.click = bind.click;
	                bindings.click.destroy();
	                delete bindings.click;
	            }

	            if (bindings.source) {
	                deep = false;
	            }

	            if (bind.attr) {
	                bindings.attr = createBindings(bind.attr, parents, Binding);
	            }

	            if (bind.style) {
	                bindings.style = createBindings(bind.style, parents, Binding);
	            }

	            if (bind.events) {
	                bindings.events = createBindings(bind.events, parents, EventBinding);
	            }

	            if (bind.css) {
	                bindings.css = createBindings(bind.css, parents, Binding);
	            }

	            target.bind(bindings);
	        }

	        if (target) {
	            element.kendoBindingTarget = target;
	        }

	        var children = element.children;
	        if (deep && children && !element.getAttribute("data-" + kendo.ns + "stop")) {
	            // https://github.com/telerik/kendo/issues/1240 for the weirdness.
	            for (idx = 0; idx < children.length; idx++) {
	                childrenCopy[idx] = children[idx];
	            }

	            for (idx = 0; idx < childrenCopy.length; idx++) {
	                bindElement(childrenCopy[idx], source, roles, parents);
	            }
	        }
	    }

	    function bind(dom, object) {
	        var idx,
	            length,
	            node,
	            roles = kendo.rolesFromNamespaces([].slice.call(arguments, 2));

	        object = kendo.observable(object);
	        dom = $(dom);

	        for (idx = 0, length = dom.length; idx < length; idx++) {
	            node = dom[idx];
	            if (node.nodeType === 1) {
	                bindElement(node, object, roles);
	            }
	        }
	    }

	    function unbindElement(element, destroyWidget) {
	        var bindingTarget = element.kendoBindingTarget;

	        if (bindingTarget) {
	            bindingTarget.destroy();

	            if (deleteExpando) {
	                delete element.kendoBindingTarget;
	            } else if (element.removeAttribute) {
	                element.removeAttribute("kendoBindingTarget");
	            } else {
	                element.kendoBindingTarget = null;
	            }
	        }

	        if(destroyWidget) {
	            var widget = kendo.widgetInstance($(element));
	            if (widget && typeof widget.destroy === FUNCTION) {
	                widget.destroy();
	            }
	        }
	    }

	    function unbindElementTree(element, destroyWidgets) {
	        unbindElement(element, destroyWidgets);

	        unbindElementChildren(element, destroyWidgets);
	    }

	    function unbindElementChildren(element, destroyWidgets) {
	        var children = element.children;

	        if (children) {
	            for (var idx = 0, length = children.length; idx < length; idx++) {
	                unbindElementTree(children[idx], destroyWidgets);
	            }
	        }
	    }

	    function unbind(dom) {
	        var idx, length;

	        dom = $(dom);

	        for (idx = 0, length = dom.length; idx < length; idx++ ) {
	            unbindElementTree(dom[idx], false);
	        }
	    }

	    function notify(widget, namespace) {
	        var element = widget.element,
	            bindingTarget = element[0].kendoBindingTarget;

	        if (bindingTarget) {
	            bind(element, bindingTarget.source, namespace);
	        }
	    }

	    function retrievePrimitiveValues(value, valueField) {
	        var values = [];
	        var idx = 0;
	        var length;
	        var item;

	        if (!valueField) {
	            return value;
	        }

	        if (value instanceof ObservableArray) {
	            for (length = value.length; idx < length; idx++) {
	                item = value[idx];
	                values[idx] = item.get ? item.get(valueField) : item[valueField];
	            }
	            value = values;
	        } else if (value instanceof ObservableObject) {
	            value = value.get(valueField);
	        }

	        return value;
	    }

	    kendo.unbind = unbind;
	    kendo.bind = bind;
	    kendo.data.binders = binders;
	    kendo.data.Binder = Binder;
	    kendo.notify = notify;

	    kendo.observable = function(object) {
	        if (!(object instanceof ObservableObject)) {
	            object = new ObservableObject(object);
	        }

	        return object;
	    };

	    kendo.observableHierarchy = function(array) {
	        var dataSource = kendo.data.HierarchicalDataSource.create(array);

	        function recursiveRead(data) {
	            var i, children;

	            for (i = 0; i < data.length; i++) {
	                data[i]._initChildren();

	                children = data[i].children;

	                children.fetch();

	                data[i].items = children.data();

	                recursiveRead(data[i].items);
	            }
	        }

	        dataSource.fetch();

	        recursiveRead(dataSource.data());

	        dataSource._data._dataSource = dataSource;

	        return dataSource._data;
	    };

	})(window.kendo.jQuery);

	return window.kendo;


	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "ydWu":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(991);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 971:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("cmba");

/***/ }),

/***/ 991:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(971) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function($) {

	// Imports ================================================================
	var kendo = window.kendo,
	    Class = kendo.Class,
	    editorNS = kendo.ui.editor,
	    RangeUtils = editorNS.RangeUtils,
	    dom = editorNS.Dom,
	    RestorePoint = editorNS.RestorePoint,
	    Marker = editorNS.Marker,
	    browser = kendo.support.browser,
	    bomSpan = "<span  class='k-br'>\ufeff</span>",
	    extend = $.extend;
	var nodeTypes = dom.nodeTypes;
	var PREVIOUS_SIBLING = "previousSibling";

	function selected(node, range) {
	    return range.startContainer === node && range.endContainer === node &&
	        range.startOffset === 0 && range.endOffset == node.childNodes.length;
	}

	function getSibling(node, direction, condition) {
	    var sibling = node ? node[direction] : null;

	    while (sibling && !condition(sibling)) {
	        sibling = sibling[direction];
	    }

	    return sibling;
	}

	var tableCells = "td,th,caption";
	var tableCellsWrappers = "table,tbody,thead,tfoot,tr";
	var tableElements = tableCellsWrappers + "," + tableCells;
	var inTable = function (range) { return !range.collapsed && $(range.commonAncestorContainer).is(tableCellsWrappers); };

	var RemoveTableContent = Class.extend({
	    remove: function(range) {
	        var that = this;
	        var marker = new Marker();
	        marker.add(range, false);

	        var nodes = RangeUtils.getAll(range, function (node) { return $(node).is(tableElements); });
	        var doc = RangeUtils.documentFromRange(range);
	        var start = marker.start;
	        var end = marker.end;
	        var cellsTypes = tableCells.split(",");
	        var startCell = dom.parentOfType(start, cellsTypes);
	        var endCell = dom.parentOfType(end, cellsTypes);
	        that._removeContent(start, startCell, true);
	        that._removeContent(end, endCell, false);
	        $(nodes).each(function(i, node) {
	            node = $(node);
	            (node.is(tableCells) ? node : node.find(tableCells)).each(function(j, cell) {
	                cell.innerHTML = "&#65279;";
	            });
	        });
	        if (startCell && !start.previousSibling) {
	            dom.insertBefore(doc.createTextNode("\ufeff"), start);
	        }
	        if (endCell && !end.nextSibling) {
	            dom.insertAfter(doc.createTextNode("\ufeff"), end);
	        }
	        if (startCell) {
	            range.setStartBefore(start);
	        } else if (nodes[0]) {
	            startCell = $(nodes[0]);
	            startCell = startCell.is(tableCells) ? startCell : startCell.find(tableCells).first();
	            if (startCell.length) {
	                range.setStart(startCell.get(0), 0);
	            }
	        }

	        range.collapse(true);

	        dom.remove(start);
	        dom.remove(end);
	    },
	    _removeContent: function (start, top, forwards) {
	        if (top) {
	            var sibling = forwards ? "nextSibling" : "previousSibling",
	                next,
	                getNext = function (node) {
	                    while (node && !node[sibling]) {
	                        node = node.parentNode;
	                    }
	                    return node && $.contains(top, node) ? node[sibling] : null;
	                };
	            start = getNext(start);
	            while (start) {
	                next = getNext(start);
	                dom.remove(start);
	                start = next;
	            }
	        }
	    }
	});

	var TypingHandler = Class.extend({
	    init: function(editor) {
	        this.editor = editor;
	    },

	    keydown: function (e) {
	        var that = this,
	            editor = that.editor,
	            keyboard = editor.keyboard,
	            isTypingKey = keyboard.isTypingKey(e),
	            evt = extend($.Event(), e);

	        that.editor.trigger("keydown", evt);

	        if (evt.isDefaultPrevented()) {
	            e.preventDefault();
	            return true;
	        }

	        if (!evt.isDefaultPrevented() && isTypingKey && !keyboard.isTypingInProgress()) {
	            var range = editor.getRange();
	            var body = editor.body;
	            that.startRestorePoint = new RestorePoint(range, body);

	            if (inTable(range)) {
	                var removeTableContent = new RemoveTableContent(editor);
	                removeTableContent.remove(range);
	                editor.selectRange(range);
	            }

	            if (browser.webkit && !range.collapsed && selected(body, range)) {
	                body.innerHTML = "";
	            }

	            if (editor.immutables && editorNS.Immutables.immutablesContext(range)) {
	                var backspaceHandler = new editorNS.BackspaceHandler(editor);
	                backspaceHandler.deleteSelection(range);
	            }

	            keyboard.startTyping(function () {
	                that.endRestorePoint = editorNS._finishUpdate(editor, that.startRestorePoint);
	            });

	            return true;
	        }

	        return false;
	    },

	    keyup: function (e) {
	        var keyboard = this.editor.keyboard;

	        this.editor.trigger("keyup", e);

	        if (keyboard.isTypingInProgress()) {
	            keyboard.endTyping();
	            return true;
	        }

	        return false;
	    }
	});

	var BackspaceHandler = Class.extend({
	    init: function(editor) {
	        this.editor = editor;
	    },
	    _addCaret: function(container) {
	        var caret = dom.create(this.editor.document, "a");

	        // Only if not Chrome: Make sure to include cared in the formatted inline node
	        if (!kendo.support.browser.chrome && container.firstChild &&
	            container.firstChild.nodeType === nodeTypes.ELEMENT_NODE) {

	            container = container.firstChild;
	        }

	        dom.insertAt(container, caret, 0);
	        dom.stripBomNode(caret.previousSibling);
	        dom.stripBomNode(caret.nextSibling);
	        return caret;
	    },
	    _restoreCaret: function(caret) {
	        var range = this.editor.createRange();

	        if (!caret.nextSibling && dom.isDataNode(caret.previousSibling)) {
	            range.setStart(caret.previousSibling, caret.previousSibling.length);
	        } else {
	            range.setStartAfter(caret);
	        }

	        range.collapse(true);
	        this.editor.selectRange(range);
	        dom.remove(caret);
	    },
	    _handleDelete: function(range) {
	        var node = range.endContainer;
	        var block = dom.closestEditableOfType(node, dom.blockElements);

	        if (block && editorNS.RangeUtils.isEndOf(range, block)) {
	            // join with next sibling
	            var next = dom.next(block);
	            if (!next || dom.name(next) != "p") {
	                return false;
	            }

	            var caret = this._addCaret(next);

	            this._merge(block, next);

	            this._restoreCaret(caret);

	            return true;
	        }

	        return false;
	    },
	    _cleanBomBefore: function(range) {
	        var offset = range.startOffset;
	        var node = range.startContainer;
	        var text = node.nodeValue;
	        var count = 0;
	        while (offset-count >= 0 && text[offset-count-1] == "\ufeff") {
	            count++;
	        }

	        if (count > 0) {
	            node.deleteData(offset-count, count);

	            range.setStart(node, Math.max(0, offset-count));
	            range.collapse(true);

	            this.editor.selectRange(range);
	        }
	    },
	    _handleBackspace: function(range) {
	        var node = range.startContainer;
	        var li = dom.closestEditableOfType(node, ['li']);
	        var block = dom.closestEditableOfType(node, 'p,h1,h2,h3,h4,h5,h6'.split(','));
	        var editor = this.editor;
	        var previousSibling;

	        if (dom.isDataNode(node)) {
	            if (range.collapsed && /^\s[\ufeff]+$/.test(node.nodeValue)) {
	                range.setStart(node, 0);
	                range.setEnd(node, node.length);
	                editor.selectRange(range);
	                return false;
	            }
	            this._cleanBomBefore(range);
	        }

	        previousSibling = getSibling(block, PREVIOUS_SIBLING, function(sibling) {
	            return !dom.htmlIndentSpace(sibling);
	        });

	        //deleting the first list item with empty content in IE results in invalid range
	        if (range.collapsed && range.startOffset !== range.endOffset && range.startOffset < 0) {
	            range.startOffset = 0;
	            range.endOffset = 0;
	            editor.selectRange(range);
	        }

	        var startAtLi = li && editorNS.RangeUtils.isStartOf(range, li);
	        var liIndex = li && $(li).index();
	        var startAtNonFirstLi = startAtLi && liIndex > 0;
	        if (startAtNonFirstLi) {
	            block = li;
	            previousSibling = dom.prev(li);
	        }

	        if(block && previousSibling && dom.is(previousSibling, 'table') && editorNS.RangeUtils.isStartOf(range, block)) {
	            if(block.innerText === ''){
	                block.innerHTML = '\ufeff';
	            }
	            return true;
	        }

	        // outdent
	        if (editorNS.RangeUtils.isStartOf(range, block) && parseInt(block.style.marginLeft,10) > 0) {
	            editor.exec("outdent");
	            return true;
	        }

	        // unwrap block
	        if ((block && previousSibling && editorNS.RangeUtils.isStartOf(range, block)) || startAtNonFirstLi) {
	            var caret = this._addCaret(block);
	            this._merge(previousSibling, block);
	            this._restoreCaret(caret);

	            return true;
	        }

	        // unwrap li element
	        if (startAtLi && liIndex === 0) {
	            var child = li.firstChild;
	            if (!child) {
	                li.innerHTML = editorNS.emptyElementContent;
	                child = li.firstChild;
	            }

	            var formatter = new editorNS.ListFormatter(dom.name(li.parentNode), "p");
	            range.selectNodeContents(li);
	            formatter.toggle(range);

	            if (dom.insignificant(child)) {
	                range.setStartBefore(child);
	            } else {
	                range.setStart(child, 0);
	            }

	            editor.selectRange(range);

	            return true;
	        }

	        var rangeStartNode = node.childNodes[range.startOffset - 1];
	        var linkRange = range;
	        var anchor = rangeStartNode && dom.closestEditableOfType(rangeStartNode, ['a']);
	        var previousNode = getSibling(rangeStartNode || node, PREVIOUS_SIBLING, function(sibling) {
	            return !dom.isDataNode(sibling) || (!dom.isBom(sibling) && sibling.length > 0);
	        });
	        if (anchor || ((range.startOffset === 0 || rangeStartNode) && dom.is(previousNode, "a"))) {
	            anchor = anchor || previousNode;
	            linkRange = editor.createRange();
	            linkRange.setStart(anchor, anchor.childNodes.length);
	            linkRange.collapse(true);
	        }

	        anchor = anchor || dom.closestEditableOfType(rangeStartNode || linkRange.startContainer, ['a']);
	        var isEndOfLink = anchor && editorNS.RangeUtils.isEndOf(linkRange, anchor);
	        if (isEndOfLink) {
	            var command = new editorNS.UnlinkCommand({ range: linkRange, body: editor.body, immutables: !!editor.immutables });
	            editor.execCommand(command);
	            editor._selectionChange();
	        }
	        return false;
	    },
	    _handleSelection: function(range) {
	        var ancestor = range.commonAncestorContainer;
	        var table = dom.closest(ancestor, "table");
	        var emptyParagraphContent = editorNS.emptyElementContent;
	        var editor = this.editor;
	        var parentElementOrNode;

	        if (inTable(range)) {
	            var removeTableContent = new RemoveTableContent(editor);
	            removeTableContent.remove(range);
	            editor.selectRange(range);
	            return true;
	        }

	        var marker = new Marker();
	        marker.add(range, false);

	        if(range.commonAncestorContainer === editor.body) {
	            this._surroundFullyContent(marker, range);
	        }

	        if (editor.immutables) {
	            this._handleImmutables(marker);
	        }

	        this._surroundFullySelectedAnchor(marker, range);

	        range.setStartAfter(marker.start);
	        range.setEndBefore(marker.end);

	        var start = range.startContainer;
	        var end = range.endContainer;

	        range.deleteContents();

	        if(end.tagName.toLocaleLowerCase() === "li" && dom.emptyNode(end)) {
	            range.selectNode(end);
	            range.deleteContents();
	        }

	        if (table && $(table).text() === "") {
	            range.selectNode(table);
	            range.deleteContents();
	        }

	        ancestor = range.commonAncestorContainer;

	        if (dom.name(ancestor) === "p" && ancestor.innerHTML === "") {
	            ancestor.innerHTML = emptyParagraphContent;
	            range.setStart(ancestor, 0);
	        }

	        this._join(start, end);

	        dom.insertAfter(editor.document.createTextNode("\ufeff"), marker.start);
	        marker.remove(range);

	        start = range.startContainer;
	        if (dom.name(start) == "tr") {
	            start = start.childNodes[Math.max(0, range.startOffset-1)];
	            range.setStart(start, dom.getNodeLength(start));
	        }

	        range.collapse(true);

	        editor.selectRange(range);

	        parentElementOrNode = start.parentElement || start.parentNode;

	        if (dom.isDataNode(start) && !dom.emptyNode(parentElementOrNode)) {
	            this._cleanBomBefore(range);
	        }

	        return true;
	    },
	    _handleImmutables: function (marker) {
	        var immutableParent = editorNS.Immutables.immutableParent;
	        var startImmutable = immutableParent(marker.start);
	        var endImmutable = immutableParent(marker.start);
	        if (startImmutable) {
	            dom.insertBefore(marker.start, startImmutable);
	        }
	        if (endImmutable) {
	            dom.insertAfter(marker.end, endImmutable);
	        }
	        if (startImmutable) {
	            dom.remove(startImmutable);
	        }
	        if (endImmutable && endImmutable.parentNode) {
	            dom.remove(endImmutable);
	        }
	    },
	    _surroundFullyContent: function(marker, range) {
	        var children = range.commonAncestorContainer.children,
	            startParent = children[0],
	            endParent = children[children.length - 1];

	        this._moveMarker(marker, range, startParent, endParent);
	    },
	    _surroundFullySelectedAnchor: function(marker, range) {
	        var start = marker.start,
	            startParent = $(start).closest("a").get(0),
	            end = marker.end,
	            endParent = $(end).closest("a").get(0);

	        this._moveMarker(marker, range, startParent, endParent);
	    },
	    _moveMarker: function(marker, range, startParent, endParent) {
	        var start = marker.start,
	            end = marker.end;

	        if(startParent && RangeUtils.isStartOf(range, startParent)){
	            dom.insertBefore(start, startParent);
	        }

	        if(endParent && RangeUtils.isEndOf(range, endParent)){
	            dom.insertAfter(end, endParent);
	        }
	    },
	    _root: function(node) {
	        while (node && dom.name(node) != "body" && node.parentNode && dom.name(node.parentNode) != "body") {
	            node = node.parentNode;
	        }

	        return node;
	    },
	    _join: function(start, end) {
	        start = this._root(start);
	        end = this._root(end);

	        if (start != end && dom.is(end, "p")) {
	            this._merge(start, end);
	        }
	    },
	    _merge: function(dest, src) {
	        dom.removeTrailingBreak(dest);

	        while (dest && src.firstChild) {
	            if (dest.nodeType == 1) {
	                dest = dom.list(dest) ? dest.children[dest.children.length - 1] : dest;

	                if (dest) {
	                    dest.appendChild(src.firstChild);
	                }
	            } else if (dest.nodeType === nodeTypes.TEXT_NODE) {
	                this._mergeWithTextNode(dest, src.firstChild);
	            } else {
	                dest.parentNode.appendChild(src.firstChild);
	            }
	        }

	        dom.remove(src);
	    },

	    _mergeWithTextNode: function(textNode, appendedNode) {
	        if (textNode && textNode.nodeType === nodeTypes.TEXT_NODE) {
	            if (textNode.nextSibling && this._isCaret(textNode.nextSibling)) {
	                dom.insertAfter(appendedNode, textNode.nextSibling);
	            }
	            else {
	                dom.insertAfter(appendedNode, textNode);
	            }
	        }
	    },

	    _isCaret: function(element) {
	        return $(element).is("a");
	    },

	    keydown: function(e) {
	        var method, startRestorePoint;
	        var editor = this.editor;
	        var range = editor.getRange();
	        var keyCode = e.keyCode;
	        var keys = kendo.keys;
	        var backspace = keyCode === keys.BACKSPACE;
	        var del = keyCode == keys.DELETE;

	        if (editor.immutables && editor.immutables.keydown(e, range)) {
	            return;
	        }

	        if ((backspace || del) && !range.collapsed) {
	            method = "_handleSelection";
	        } else if (backspace) {
	            method = "_handleBackspace";
	        } else if (del) {
	            method = "_handleDelete";
	        }

	        if (!method) {
	            return;
	        }

	        startRestorePoint = new RestorePoint(range, editor.body);

	        if (this[method](range)) {
	            e.preventDefault();

	            editorNS._finishUpdate(editor, startRestorePoint);
	        }
	    },
	    deleteSelection: function (range) {
	        this._handleSelection(range);
	    },
	    keyup: $.noop
	});

	var SystemHandler = Class.extend({
	    init: function(editor) {
	        this.editor = editor;
	        this.systemCommandIsInProgress = false;
	    },

	    createUndoCommand: function () {
	        this.startRestorePoint = this.endRestorePoint = editorNS._finishUpdate(this.editor, this.startRestorePoint);
	    },

	    changed: function () {
	        if (this.startRestorePoint) {
	            return this.startRestorePoint.html != this.editor.body.innerHTML;
	        }

	        return false;
	    },

	    keydown: function (e) {
	        var that = this,
	            editor = that.editor,
	            keyboard = editor.keyboard;

	        if (keyboard.isModifierKey(e)) {

	            if (keyboard.isTypingInProgress()) {
	                keyboard.endTyping(true);
	            }

	            that.startRestorePoint = new RestorePoint(editor.getRange(), editor.body);
	            return true;
	        }

	        if (keyboard.isSystem(e)) {
	            that.systemCommandIsInProgress = true;

	            if (that.changed()) {
	                that.systemCommandIsInProgress = false;
	                that.createUndoCommand();
	            }

	            return true;
	        }

	        return false;
	    },

	    keyup: function () {
	        var that = this;

	        if (that.systemCommandIsInProgress && that.changed()) {
	            that.systemCommandIsInProgress = false;
	            that.createUndoCommand();
	            return true;
	        }

	        return false;
	    }
	});

	var SelectAllHandler = Class.extend({
	    init: function(editor) {
	        this.editor = editor;
	    },

	    keydown: function (e) {
	        if (!browser.webkit || e.isDefaultPrevented() ||
	            !(e.ctrlKey && e.keyCode == 65 && !e.altKey && !e.shiftKey)) {
	            return;
	        }
	        if (this.editor.options.immutables) {
	            this._toSelectableImmutables();
	        }
	        this._selectEditorBody();
	    },

	    _selectEditorBody: function() {
	        var editor = this.editor;
	        var range = editor.getRange();
	        range.selectNodeContents(editor.body);

	        setTimeout(function() {
	            editor.selectRange(range);
	        });
	    },

	    _toSelectableImmutables: function() {
	        var editor = this.editor,
	            body = editor.body,
	            immutable = editorNS.Immutables.immutable,
	            emptyTextNode = dom.emptyTextNode,
	            first = body.firstChild,
	            last = body.lastChild;

	        while (emptyTextNode(first)){
	            first = first.nextSibling;
	        }

	        while (emptyTextNode(last)){
	            last = last.previousSibling;
	        }

	        if (first && immutable(first)) {
	            $(bomSpan).prependTo(body);
	        }

	        if (last && immutable(last)) {
	            $(bomSpan).appendTo(body);
	        }
	    },

	    keyup: $.noop
	});

	var Keyboard = Class.extend({
	    init: function(handlers) {
	        this.handlers = handlers;
	        this.typingInProgress = false;
	    },

	    isCharacter: function(keyCode) {
	        return (keyCode >= 48 && keyCode <= 90) || (keyCode >= 96 && keyCode <= 111) ||
	               (keyCode >= 186 && keyCode <= 192) || (keyCode >= 219 && keyCode <= 222) ||
	               keyCode == 229;
	    },

	    toolFromShortcut: function (tools, e) {
	        var key = String.fromCharCode(e.keyCode),
	            toolName,
	            toolOptions,
	            modifier = this._getShortcutModifier(e, navigator.platform);

	        for (toolName in tools) {
	            toolOptions = $.extend({ ctrl: false, alt: false, shift: false }, tools[toolName].options);

	            if ((toolOptions.key == key || toolOptions.key == e.keyCode) &&
	                toolOptions.ctrl == modifier &&
	                toolOptions.alt == e.altKey &&
	                toolOptions.shift == e.shiftKey) {
	                return toolName;
	            }
	        }
	    },

	    _getShortcutModifier: function (e, platform) {
	        var mac = platform.toUpperCase().indexOf('MAC') >= 0;
	        return mac ? e.metaKey : e.ctrlKey;
	    },

	    toolsFromShortcut: function (tools, e) {
	        var key = String.fromCharCode(e.keyCode),
	            toolName,
	            o,
	            matchesKey,
	            found = [];
	        var matchKey = function (toolKey) { return toolKey == key || toolKey == e.keyCode || toolKey == e.charCode; };

	        for (toolName in tools) {
	            o = $.extend({ ctrl: false, alt: false, shift: false }, tools[toolName].options);

	            matchesKey = $.isArray(o.key) ? $.grep(o.key, matchKey).length > 0 : matchKey(o.key);
	            if (matchesKey &&
	                o.ctrl == e.ctrlKey &&
	                o.alt == e.altKey &&
	                o.shift == e.shiftKey) {
	                found.push(tools[toolName]);
	            }
	        }

	        return found;
	    },

	    isTypingKey: function (e) {
	        var keyCode = e.keyCode;
	        return (this.isCharacter(keyCode) && !e.ctrlKey && !e.altKey) ||
	               keyCode == 32 || keyCode == 13 || keyCode == 8 ||
	               (keyCode == 46 && !e.shiftKey && !e.ctrlKey && !e.altKey);
	    },

	    isModifierKey: function (e) {
	        var keyCode = e.keyCode;
	        return (keyCode == 17 && !e.shiftKey && !e.altKey) ||
	               (keyCode == 16 && !e.ctrlKey && !e.altKey) ||
	               (keyCode == 18 && !e.ctrlKey && !e.shiftKey);
	    },

	    isSystem: function (e) {
	        return e.keyCode == 46 && e.ctrlKey && !e.altKey && !e.shiftKey;
	    },

	    startTyping: function (callback) {
	        this.onEndTyping = callback;
	        this.typingInProgress = true;
	    },

	    stopTyping: function() {
	        if (this.typingInProgress && this.onEndTyping) {
	            this.onEndTyping();
	        }
	        this.typingInProgress = false;
	    },

	    endTyping: function (force) {
	        var that = this;
	        that.clearTimeout();
	        if (force) {
	            that.stopTyping();
	        } else {
	            that.timeout = window.setTimeout($.proxy(that.stopTyping, that), 1000);
	        }
	    },

	    isTypingInProgress: function () {
	        return this.typingInProgress;
	    },

	    clearTimeout: function () {
	        window.clearTimeout(this.timeout);
	    },

	    notify: function(e, what) {
	        var i, handlers = this.handlers;

	        for (i = 0; i < handlers.length; i++) {
	            if (handlers[i][what](e)) {
	                break;
	            }
	        }
	    },

	    keydown: function (e) {
	        this.notify(e, 'keydown');
	    },

	    keyup: function (e) {
	        this.notify(e, 'keyup');
	    }
	});

	extend(editorNS, {
	    TypingHandler: TypingHandler,
	    SystemHandler: SystemHandler,
	    BackspaceHandler: BackspaceHandler,
	    SelectAllHandler: SelectAllHandler,
	    Keyboard: Keyboard
	});

	})(window.kendo.jQuery);

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "ylaU":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1010);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 973:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2UxK");

/***/ }),

/***/ 1002:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("lysN");

/***/ }),

/***/ 1010:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(973), __webpack_require__(1011), __webpack_require__(1002)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function() {

	(function(kendo, undefined) {
	    var global = window;
	    var math = global.Math;
	    var min = math.min;
	    var max = math.max;

	    var $ = kendo.jQuery;
	    var contains = $.contains;
	    var extend = $.extend;
	    var proxy = $.proxy;

	    var browser = kendo.support.browser;
	    var Editor = kendo.ui.editor;
	    var Class = kendo.Class;
	    var TableResizeHandle = Editor.TableResizeHandle;
	    var ResizingUtils = Editor.ResizingUtils;
	    var calculatePercentageRatio = ResizingUtils.calculatePercentageRatio;
	    var constrain = ResizingUtils.constrain;
	    var inPercentages = ResizingUtils.inPercentages;
	    var inPixels = ResizingUtils.inPixels;
	    var toPercentages = ResizingUtils.toPercentages;
	    var toPixels = ResizingUtils.toPixels;
	    var outerWidth = kendo._outerWidth;
	    var outerHeight = kendo._outerHeight;

	    var NS = ".kendoEditorTableResizing";
	    var RESIZE_HANDLE_WRAPPER_CLASS = "k-table-resize-handle-wrapper";
	    var TABLE_CLASS = "k-table";
	    var TABLE_RESIZING_CLASS = "k-table-resizing";

	    var DRAG_START = "dragStart";
	    var DRAG = "drag";
	    var DRAG_END = "dragEnd";
	    var KEY_DOWN = "keydown";
	    var MOUSE_DOWN = "mousedown";
	    var MOUSE_OVER = "mouseover";
	    var MOUSE_OUT = "mouseout";

	    var COLUMN = "td";
	    var ROW = "tr";
	    var TBODY = "tbody";
	    var THEAD = "thead";
	    var TABLE = "table";

	    var COMMA = ",";
	    var WIDTH = "width";
	    var HEIGHT = "height";

	    var EAST = "east";
	    var NORTH = "north";
	    var NORTHEAST = "northeast";
	    var NORTHWEST = "northwest";
	    var SOUTH = "south";
	    var SOUTHEAST = "southeast";
	    var SOUTHWEST = "southwest";
	    var WEST = "west";

	    var DOT = ".";

	    function isUndefined(value) {
	        return typeof(value) === "undefined";
	    }

	    var TableResizing = Class.extend({
	        init: function(element, options) {
	            var that = this;

	            that.options = extend({}, that.options, options);
	            that.handles = [];

	            if ($(element).is(TABLE)) {
	                that.element = element;
	            }
	        },

	        destroy: function() {
	            var that = this;

	            $(that.element).off(NS);
	            that.element = null;

	            $(that.options.rootElement).off(KEY_DOWN + NS);

	            that._destroyResizeHandles();
	        },

	        options: {
	            appendHandlesTo: null,
	            rtl: false,
	            rootElement: null,
	            minWidth: 10,
	            minHeight: 10,
	            handles: [{
	                direction: NORTHWEST
	            }, {
	                direction: NORTH
	            }, {
	                direction: NORTHEAST
	            }, {
	                direction: EAST
	            }, {
	                direction: SOUTHEAST
	            }, {
	                direction: SOUTH
	            }, {
	                direction: SOUTHWEST
	            }, {
	                direction: WEST
	            }]
	        },

	        resize: function(args) {
	            var that = this;
	            var deltas = extend({}, {
	                deltaX: 0,
	                deltaY: 0,
	                initialDeltaX: 0,
	                initialDeltaY: 0
	            }, args);

	            that._resizeWidth(deltas.deltaX, deltas.initialDeltaX);
	            that._resizeHeight(deltas.deltaY, deltas.initialDeltaY);

	            that.showResizeHandles();
	        },

	        _resizeWidth: function(delta, initialDelta) {
	            var that = this;
	            var element = $(that.element);
	            var styleWidth = element[0].style[WIDTH];
	            var currentWidth = outerWidth(element);
	            var parentWidth = element.parent().width();
	            var maxWidth = that._getMaxDimensionValue(WIDTH);
	            var newWidth;
	            var ratioValue;
	            var ratioTotalValue;
	            var constrainedWidth;

	            if (delta === 0) {
	                return;
	            }

	            if (isUndefined(that._initialElementWidth)) {
	                that._initialElementWidth = currentWidth;
	            }

	            //use initial delta instead of delta as changing the width with a small value (e.g. 1px)
	            //on each drag does not work due to browser calculation of computed styles
	            constrainedWidth = constrain({
	                value: that._initialElementWidth + initialDelta,
	                min: that.options.minWidth,
	                max: maxWidth
	            });

	            if (inPercentages(styleWidth)) {
	                //detect resizing greater than 100%
	                if (currentWidth + delta > parentWidth) {
	                    ratioValue = max(constrainedWidth, parentWidth);
	                    ratioTotalValue = min(constrainedWidth, parentWidth);
	                }
	                else {
	                    ratioValue = min(constrainedWidth, parentWidth);
	                    ratioTotalValue = max(constrainedWidth, parentWidth);
	                }

	                newWidth = toPercentages(calculatePercentageRatio(ratioValue, ratioTotalValue));
	            }
	            else {
	                newWidth = toPixels(constrainedWidth);
	            }

	            that._setColumnsWidth();

	            element[0].style[WIDTH] = newWidth;
	        },

	        _resizeHeight: function(delta, initialDelta) {
	            var that = this;
	            var element = $(that.element);
	            var styleHeight = element[0].style[HEIGHT];
	            var currentHeight = outerHeight(element);
	            var parent = element.parent();
	            var parentHeight = parent.height();
	            var maxHeight = that._getMaxDimensionValue(HEIGHT);
	            var newHeight;
	            var ratioValue;
	            var ratioTotalValue;
	            var constrainedHeight;
	            var minHeight = that.options.minHeight;
	            var hasRowsInPixels = that._hasRowsInPixels();

	            if (delta === 0) {
	                return;
	            }

	            if (isUndefined(that._initialElementHeight)) {
	                that._initialElementHeight = currentHeight;
	            }

	            //use initial delta instead of delta as changing the height with a small value (e.g. 1px)
	            //on each drag does not work due to browser calculation of computed styles
	            constrainedHeight = constrain({
	                value: that._initialElementHeight + initialDelta,
	                min: minHeight,
	                max: maxHeight
	            });

	            if (hasRowsInPixels && delta < 0) {
	                //decreasing table height when rows are sized in pixels is not possible
	                that._setRowsHeightInPercentages();
	            }

	            if (inPercentages(styleHeight)) {
	                //detect resizing greater than 100%
	                if (currentHeight + delta > parentHeight) {
	                    ratioValue = max(constrainedHeight, parentHeight);
	                    ratioTotalValue = min(constrainedHeight, parentHeight);
	                }
	                else {
	                    ratioValue = min(constrainedHeight, parentHeight);
	                    ratioTotalValue = max(constrainedHeight, parentHeight);
	                }

	                newHeight = toPercentages(calculatePercentageRatio(ratioValue, ratioTotalValue));
	            }
	            else {
	                newHeight = toPixels(constrainedHeight);
	            }

	            element[0].style[HEIGHT] = newHeight;

	            if (hasRowsInPixels && delta < 0) {
	                //restore original rows height unit
	                that._setRowsHeightInPixels();
	            }
	        },

	        _getMaxDimensionValue: function(dimension) {
	            var that = this;
	            var element = $(that.element);
	            var dimensionLowercase = dimension.toLowerCase();
	            var rtlModifier = that.options.rtl ? (-1) : 1;
	            var parent = $(that.element).parent();
	            var parentElement = parent[0];
	            var parentDimension = parent[dimensionLowercase]();
	            var parentScrollOffset = rtlModifier * (dimension === WIDTH ? kendo.scrollLeft(parent) : parent.scrollTop());

	            if (parentElement === element.closest(COLUMN)[0]) {
	                if (parentElement.style[dimensionLowercase] === "" && !inPercentages(that.element.style[dimensionLowercase])) {
	                    return Infinity;
	                }
	                else {
	                    return (parentDimension + parentScrollOffset);
	                }
	            }
	            else {
	                return (parentDimension + parentScrollOffset);
	            }
	        },

	        _setColumnsWidth: function() {
	            var that = this;
	            var element = $(that.element);
	            var parentElement = element.parent()[0];
	            var parentColumn = element.closest(COLUMN);
	            var columns = parentColumn.closest(ROW).children();
	            var columnsLength = columns.length;
	            var i;

	            function isWidthInPercentages(element) {
	                var styleWidth = element.style.width;

	                if (styleWidth !== "") {
	                    return inPercentages(styleWidth) ? true : false;
	                }
	                else {
	                    return $(element).hasClass(TABLE_CLASS) ? true : false;
	                }
	            }

	            if (isWidthInPercentages(element[0]) && parentElement === parentColumn[0] && parentElement.style[WIDTH] === "") {
	                for (i = 0; i < columnsLength; i++) {
	                    columns[i].style[WIDTH] = toPixels($(columns[i]).width());
	                }
	            }
	        },

	        _hasRowsInPixels: function() {
	            var that = this;
	            var rows = $(that.element).children(THEAD + COMMA + TBODY).children(ROW);

	            for (var i = 0; i < rows.length; i++) {
	                if (rows[i].style.height === "" || inPixels(rows[i].style.height)) {
	                    return true;
	                }
	            }

	            return false;
	        },

	        _setRowsHeightInPercentages: function() {
	            var that = this;
	            var tableHead = $(that.element).children(THEAD);
	            var tableHeadHeight = tableHead.length > 0 ? tableHead.height() : 0;
	            var tableBody = $(that.element).children(TBODY);
	            var tableBodyHeight = tableBody.height();
	            var rows = $(that.element).children(THEAD + COMMA + TBODY).children(ROW);
	            var length = rows.length;
	            var currentRowsHeights = rows.map(function() {
	                return outerHeight($(this));
	            });
	            var i;

	            for (i = 0; i < length; i++) {
	                rows[i].style[HEIGHT] = toPercentages(calculatePercentageRatio(currentRowsHeights[i], tableHeadHeight + tableBodyHeight));
	            }
	        },

	        _setRowsHeightInPixels: function() {
	            var that = this;
	            var rows = $(that.element).children(THEAD + COMMA + TBODY).children(ROW);
	            var length = rows.length;
	            var currentRowsHeights = rows.map(function() {
	                return outerHeight($(this));
	            });
	            var i;

	            for (i = 0; i < length; i++) {
	                rows[i].style[HEIGHT] = toPixels(currentRowsHeights[i]);
	            }
	        },

	        showResizeHandles: function() {
	            var that = this;

	            that._initResizeHandles();
	            that._showResizeHandles();
	        },

	        _initResizeHandles: function() {
	            var that = this;
	            var handles = that.handles;
	            var options = that.options;
	            var handleOptions = that.options.handles;
	            var length = handleOptions.length;
	            var i;

	            if (handles && handles.length > 0) {
	                return;
	            }

	            for (i = 0; i < length; i++) {
	                that.handles.push(new TableResizeHandle(extend({
	                    appendTo: options.appendHandlesTo,
	                    resizableElement: that.element,
	                    rootElement: options.rootElement,
	                    rtl: options.rtl
	                }, handleOptions[i])));
	            }

	            that._bindToResizeHandlesEvents();
	        },

	        _destroyResizeHandles: function() {
	            var that = this;
	            var length = that.handles ? that.handles.length : 0;

	            for (var i = 0; i < length; i++) {
	                that.handles[i].destroy();
	            }
	        },

	        _showResizeHandles: function() {
	            var that = this;
	            var handles = that.handles || [];
	            var length = handles.length;
	            var i;

	            for (i = 0; i < length; i++) {
	                that.handles[i].show();
	            }
	        },

	        _bindToResizeHandlesEvents: function() {
	            var that = this;
	            var handles = that.handles || [];
	            var length = handles.length;
	            var i;
	            var handle;

	            for (i = 0; i < length; i++) {
	                handle = handles[i];
	                handle.bind(DRAG_START, proxy(that._onResizeHandleDragStart, that));
	                handle.bind(DRAG, proxy(that._onResizeHandleDrag, that));
	                handle.bind(DRAG_END, proxy(that._onResizeHandleDragEnd, that));
	                handle.bind(MOUSE_OVER, proxy(that._onResizeHandleMouseOver, that));
	                handle.bind(MOUSE_OUT, proxy(that._onResizeHandleMouseOut, that));
	            }
	        },

	        _onResizeHandleDragStart: function() {
	            var that = this;
	            var element = $(that.element);

	            element.addClass(TABLE_RESIZING_CLASS);

	            that._initialElementHeight = outerHeight(element);
	            that._initialElementWidth = outerWidth(element);
	            that._disableKeyboard();
	        },

	        _onResizeHandleDrag: function(e) {
	            this.resize(e);
	        },

	        _onResizeHandleDragEnd: function() {
	            var that = this;
	            $(that.element).removeClass(TABLE_RESIZING_CLASS);
	            that._enableKeyboard();
	        },

	        _enableKeyboard: function() {
	            $(this.options.rootElement).off(KEY_DOWN + NS);
	        },

	        _disableKeyboard: function() {
	            $(this.options.rootElement).on(KEY_DOWN + NS, function(e) {
	                e.preventDefault();
	            });
	        }
	    });

	    var TableResizingFactory = Class.extend({
	        create: function(editor) {
	            var factory = this;

	            $(editor.body)
	                .on(MOUSE_DOWN + NS, TABLE, function(e) {
	                    var eventTarget = e.target;
	                    var eventCurrentTarget = e.currentTarget;
	                    var tableResizing = editor.tableResizing;
	                    var element = tableResizing ? tableResizing.element : null;

	                    if (tableResizing) {
	                        if (element && eventCurrentTarget !== element) {
	                            if (contains(eventCurrentTarget, element) && element !== eventTarget && contains(element, eventTarget)) {
	                                //prevent a parent table resizing init when clicking on a nested table when the event bubbles
	                                //instead of stopping event propagation
	                                return;
	                            }
	                            else {
	                                if (element !== eventTarget) {
	                                    editor._destroyTableResizing();
	                                    factory._initResizing(editor, eventCurrentTarget);
	                                }
	                            }
	                        }
	                    }
	                    else {
	                        factory._initResizing(editor, eventCurrentTarget);
	                    }

	                    editor._showTableResizeHandles();
	                })
	                .on(MOUSE_DOWN + NS, function(e) {
	                    var tableResizing = editor.tableResizing;
	                    var element = tableResizing ? tableResizing.element : null;
	                    var target = e.target;
	                    var isResizeHandleOrChild = $(target).hasClass(RESIZE_HANDLE_WRAPPER_CLASS) || $(target).parents(DOT + RESIZE_HANDLE_WRAPPER_CLASS).length > 0;

	                    if (tableResizing && element !== target && !contains(element, target) && !isResizeHandleOrChild) {
	                        editor._destroyTableResizing();
	                    }
	                });
	        },

	        dispose: function(editor) {
	            $(editor.body).off(NS);
	        },

	        _initResizing: function(editor, table) {
	            //table resizing is natively supported in IE and Firefox
	            if (!browser.msie && !browser.mozilla) {
	                editor.tableResizing = new TableResizing(table, {
	                    appendHandlesTo: editor.body,
	                    rtl:  kendo.support.isRtl(editor.element),
	                    rootElement: editor.body
	                });
	            }
	        }
	    });
	    TableResizingFactory.current = new TableResizingFactory();

	    TableResizing.create = function(editor) {
	        TableResizingFactory.current.create(editor);
	    };

	    TableResizing.dispose = function(editor) {
	        TableResizingFactory.current.dispose(editor);
	    };

	    extend(Editor, {
	        TableResizing: TableResizing
	    });

	})(window.kendo);

	}, __webpack_require__(3));


/***/ }),

/***/ 1011:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("xXzn");

/***/ })

/******/ });

/***/ }),

/***/ "yoqx":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1610);
	module.exports = __webpack_require__(1610);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1597:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("oTNd");

/***/ }),

/***/ 1610:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// -*- fill-column: 100 -*-

	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1597), __webpack_require__(1611), __webpack_require__(1612) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	    "use strict";

	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    // WARNING: removing the following jshint declaration and turning
	    // == into === to make JSHint happy will break functionality.
	    /* jshint eqnull:true, newcap:false, laxbreak:true, shadow:true, -W054 */
	    /* jshint latedef: nofunc */

	    var util = kendo.util;
	    var calc = kendo.spreadsheet.calc;
	    var dom = kendo.dom;

	    var RX_COLORS = /^\[(black|green|white|blue|magenta|yellow|cyan|red)\]/i;
	    var RX_CONDITION = /^\[(<=|>=|<>|<|>|=)(-?[0-9.]+)\]/;

	    /* The proper amount of suffering for whoever designed the Excel
	       Custom Number Format would be to have him implement the
	       formatter himself. */

	    function parse(input) {
	        input = calc.InputStream(input);
	        var sections = [], haveConditional = false, decimalPart;

	        while (!input.eof()) {
	            var sec = readSection();
	            sections.push(sec);
	            if (sec.cond) {
	                haveConditional = true;
	            }
	        }

	        // From https://support.office.com/en-us/article/Create-or-delete-a-custom-number-format-78f2a361-936b-4c03-8772-09fab54be7f4:
	        //
	        //    A number format can have up to four sections of code, separated by semicolons. These
	        //    code sections define the format for positive numbers, negative numbers, zero values,
	        //    and text, in that order.
	        //
	        //    You do not have to include all code sections in your custom number format. If you
	        //    specify only two code sections for your custom number format, the first section is
	        //    used for positive numbers and zeros, and the second section is used for negative
	        //    numbers. If you specify only one code section, it is used for all numbers. If you want
	        //    to skip a code section and include a code section that follows it, you must include
	        //    the ending semicolon for the section that you skip.
	        //
	        // However, if sections have conditionals, it is not clear if:
	        //
	        //    - still at most four are allowed
	        //    - is the last section still for text
	        //
	        // We will assume that if no sections have conditionals, then there must be at most 4, and
	        // they will be interpreted in the order above.  If the first section contains a
	        // conditional, then there can be any number of them; if the last one is not conditional
	        // then it will be interpreted as text format.

	        if (!haveConditional) {
	            if (sections.length == 1) {
	                sections[0].cond = "num";
	            }
	            else if (sections.length == 2) {
	                sections[0].cond = { op: ">=", value: 0 };
	                sections[1].cond = { op: "<", value: 0 };
	            }
	            else if (sections.length >= 3) {
	                sections[0].cond = { op: ">", value: 0 };
	                sections[1].cond = { op: "<", value: 0 };
	                sections[2].cond = { op: "=", value: 0 };
	                if (sections.length > 3) {
	                    sections[3].cond = "text";
	                    sections = sections.slice(0, 4);
	                }
	            }
	        }

	        return sections;

	        function maybeColor() {
	            var m = input.skip(RX_COLORS);
	            if (m) {
	                return m[1].toLowerCase();
	            }
	        }

	        function maybeCondition() {
	            var m = input.skip(RX_CONDITION);
	            if (m) {
	                var val = parseFloat(m[2]);
	                if (!isNaN(val)) {
	                    return { op: m[1], value: val, custom: true };
	                }
	            }
	        }

	        function readFormat() {
	            var format = [], tok, prev = null;
	            while (!input.eof() && (tok = readNext())) {
	                // disambiguate: m/mm might mean month or minutes depending on surrounding context.
	                if (tok.type == "date") {
	                    if (prev && /^(el)?time$/.test(prev.type) && prev.part == "h"
	                        && tok.part == "m" && tok.format < 3) {
	                        // m or mm that follows hours should display minutes
	                        tok.type = "time";
	                    }
	                } else if (/^(el)?time$/.test(tok.type) && tok.part == "s") {
	                    if (prev && prev.type == "date" && prev.part == "m"
	                        && prev.format < 3) {
	                        // m or mm followed by seconds should display minutes
	                        prev.type = "time";
	                    }
	                }
	                if (!(/^(?:str|space|fill)$/.test(tok.type))) {
	                    prev = tok;
	                }
	                format.push(tok);
	            }
	            return format;
	        }

	        function maybeFraction(tok) {
	            if (tok.type != "date" || (tok.part == "m" && tok.format < 3)) {
	                var m = input.skip(/^\.(0+)/);
	                if (m) {
	                    tok.fraction = m[1].length;
	                    if (tok.type == "date") {
	                        tok.type = "time";
	                    }
	                }
	            }
	            return tok;
	        }

	        function readNext() {
	            var ch, m;
	            // numbers
	            if ((m = input.skip(/^([#0?]+)(?:,([#0?]+))+/))) {
	                // thousands separator.  seems convenient to treat
	                // this as a single token.
	                return { type: "digit", sep: true, format: m[1] + m[2], decimal: decimalPart };
	            }
	            if ((m = input.skip(/^[#0?]+/))) {
	                return { type: "digit", sep: false, format: m[0], decimal: decimalPart };
	            }
	            // XXX: handle this one!
	            if ((m = input.skip(/^(e)([+-])/i))) {
	                return { type: "exp", ch: m[1], sign: m[2] };
	            }
	            // dates
	            if ((m = input.skip(/^(d{1,4}|m{1,5}|yyyy|yy)/i))) {
	                m = m[1].toLowerCase();
	                return maybeFraction({ type: "date", part: m.charAt(0), format: m.length });
	            }
	            // time (interpret as a date)
	            if ((m = input.skip(/^(hh?|ss?)/i))) { // m and mm are handled above
	                m = m[1].toLowerCase();
	                return maybeFraction({ type: "time", part: m.charAt(0), format: m.length });
	            }
	            // elapsed time (interpret as interval of days)
	            if ((m = input.skip(/^\[(hh?|mm?|ss?)\]/i))) {
	                m = m[1].toLowerCase();
	                return maybeFraction({ type: "eltime", part: m.charAt(0), format: m.length });
	            }
	            if ((m = input.skip(/^(a[.]?m[.]?\/p[.]?m[.]?|a\/p)/i))) {
	                m = m[1].split("/");
	                return { type: "ampm", am: m[0], pm: m[1] };
	            }
	            switch ((ch = input.next())) { // JSHint sadness
	              case ";":
	                return null;
	              case "\\":
	                // quotes next character
	                return { type: "str", value: input.next() };
	              case '"':
	                return { type: "str", value: input.readEscaped(ch) };
	              case "@":
	                return { type: "text" };
	              case "_":
	                // whitespace of the width of following character
	                return { type: "space", value: input.next() };
	              case "*":
	                // fills cell width with the following character
	                return { type: "fill", value: input.next() };
	              case ".":
	                if (input.lookingAt(/^\s*[#0?]/)) {
	                    decimalPart = true;
	                    return { type: "dec" };
	                }
	                return { type: "str", value: "." };
	              case "%":
	                return { type: "percent" };
	              case ",":
	                return { type: "comma" };
	            }

	            // whatever we can't make sense of, output literally.
	            return { type: "str", value: ch };
	        }

	        function readSection() {
	            decimalPart = false;
	            var color = maybeColor(), cond = maybeCondition();
	            if (!color && cond) {
	                color = maybeColor();
	            }
	            return {
	                color : color,
	                cond  : cond,
	                body  : readFormat()
	            };
	        }
	    }

	    function print(sections) {
	        return sections.map(printSection).join(";");

	        function printSection(sec) {
	            var out = "";
	            if (sec.color) {
	                out += "[" + sec.color + "]";
	            }
	            if (sec.cond) {
	                if (!(sec.cond == "text" || sec.cond == "num")) {
	                    out += "[" + sec.cond.op + sec.cond.value + "]";
	                }
	            }
	            out += sec.body.map(printToken).join("");
	            return out;
	        }

	        function maybeFraction(fmt, tok) {
	            if (tok.fraction) {
	                fmt += "." + padLeft("", tok.fraction, "0");
	            }
	            return fmt;
	        }

	        function printToken(tok) {
	            if (tok.type == "digit") {
	                if (tok.sep) {
	                    return tok.format.charAt(0) + "," + tok.format.substr(1);
	                } else {
	                    return tok.format;
	                }
	            }
	            else if (tok.type == "exp") {
	                return tok.ch + tok.sign;
	            }
	            else if (tok.type == "date" || tok.type == "time") {
	                return maybeFraction(padLeft("", tok.format, tok.part), tok);
	            }
	            else if (tok.type == "eltime") {
	                return maybeFraction("[" + padLeft("", tok.format, tok.part) + "]", tok);
	            }
	            else if (tok.type == "ampm") {
	                return tok.am + "/" + tok.pm;
	            }
	            else if (tok.type == "str") {
	                return JSON.stringify(tok.value);
	            }
	            else if (tok.type == "text") {
	                return "@";
	            }
	            else if (tok.type == "space") {
	                return "_" + tok.value;
	            }
	            else if (tok.type == "fill") {
	                return "*" + tok.value;
	            }
	            else if (tok.type == "dec") {
	                return ".";
	            }
	            else if (tok.type == "percent") {
	                return "%";
	            }
	            else if (tok.type == "comma") {
	                return ",";
	            }
	        }
	    }

	    function adjustDecimals(sections, x) {
	        sections.forEach(function(sec) {
	            var diff = x;
	            if (sec.cond == "text") {
	                return;
	            }
	            var body = sec.body, adjusted = false, i = body.length;
	            while (diff !== 0 && --i >= 0) {
	                var tok = body[i];
	                if (tok.type == "digit") {
	                    if (tok.decimal) {
	                        adjusted = true;
	                        if (diff > 0) {
	                            tok.format += padLeft("", diff, "0");
	                        } else if (diff < 0) {
	                            var tmp = tok.format.length;
	                            tok.format = tok.format.substr(0, tmp + diff);
	                            diff += tmp - tok.format.length;
	                        }
	                        if (tok.format.length === 0) {
	                            body.splice(i, 1);
	                            while (--i >= 0) {
	                                tok = body[i];
	                                if (tok.type == "digit" && tok.decimal) {
	                                    ++i;
	                                    break;
	                                }
	                                if (tok.type == "dec") {
	                                    body.splice(i, 1);
	                                    break;
	                                }
	                            }
	                        }
	                    }
	                    if (diff > 0) {
	                        break;
	                    }
	                }
	            }
	            if (!adjusted && diff > 0) {
	                // no decimal part was found, insert one after the last digit token.
	                body.splice(
	                    i + 1, 0, {
	                        type    : "dec"
	                    }, {
	                        type    : "digit",
	                        sep     : false,
	                        decimal : true,
	                        format  : padLeft("", diff, "0")
	                    }
	                );
	            }
	        });
	    }

	    function TokenStream(parts) {
	        var index = 0;
	        return {
	            next: function() {
	                return parts[index++];
	            },
	            eof: function() {
	                return index >= parts.length;
	            },
	            ahead: function(n, f) {
	                if (index + n <= parts.length) {
	                    var val = f.apply(null, parts.slice(index, index + n));
	                    if (val) {
	                        index += n;
	                    }
	                    return val;
	                }
	            },
	            restart: function() {
	                index = 0;
	            }
	        };
	    }

	    function compileFormatPart(format) {
	        var input = TokenStream(format.body);
	        var hasDate = false;
	        var hasTime = false;
	        var hasAmpm = false;
	        var percentCount = 0;
	        var currency = /[\$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BD\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6]/;
	        var scaleCount = 0;
	        var code = "var intPart, decPart, isNegative, date, time; ";
	        var separeThousands = false;
	        var declen = 0;
	        var intFormat = [], decFormat = [];
	        var condition = format.cond;
	        var preamble = "";

	        if (condition == "text") {
	            preamble = "if (typeof value == 'string' || value instanceof kendo.spreadsheet.CalcError) { ";
	        }
	        else if (condition == "num") {
	            preamble = "if (typeof value == 'number') { ";
	        }
	        else if (condition) {
	            var op = condition.op == "=" ? "==" : condition.op;
	            preamble = "if (typeof value == 'number' && value "
	                + op + " " + condition.value + ") { ";
	            if (!condition.custom) {
	                code += "value = Math.abs(value); ";
	            }
	        }

	        if (format.color) {
	            code += "result.color = " + JSON.stringify(format.color) + "; ";
	        }

	        function checkComma(a, b) {
	            if ((a.type == "digit" && b.type == "comma") ||
	                (a.type == "comma" && a.hidden && b.type == "comma"))
	            {
	                b.hidden = true;
	                scaleCount++;
	            }
	        }

	        while (!input.eof()) {
	            input.ahead(2, checkComma);
	            var tok = input.next();
	            if (tok.type == "percent") {
	                percentCount++;
	            }
	            else if (tok.type == "digit") {
	                if (tok.decimal) {
	                    declen += tok.format.length;
	                    decFormat.push(tok.format);
	                } else {
	                    intFormat.push(tok.format);
	                    if (tok.sep) {
	                        separeThousands = true;
	                    }
	                }
	            }
	            else if (tok.type == "time") {
	                hasTime = true;
	            }
	            else if (tok.type == "date") {
	                hasDate = true;
	            }
	            else if (tok.type == "ampm") {
	                hasAmpm = hasTime = true;
	            }
	        }

	        if (percentCount > 0) {
	            code += "value *= " + Math.pow(100, percentCount) + "; ";
	        }
	        if (scaleCount > 0) {
	            code += "value /= " + Math.pow(1000, scaleCount) + "; ";
	        }
	        if (intFormat.length) {
	            code += "intPart = runtime.formatInt(culture, value, " + JSON.stringify(intFormat) + ", " + declen + ", " + separeThousands + "); ";
	            code += "isNegative = parseInt(intPart[0]) < 0;";
	        }
	        if (decFormat.length) {
	            code += "decPart = runtime.formatDec(value, " + JSON.stringify(decFormat) + ", " + declen + "); ";
	        }
	        if (intFormat.length || decFormat.length) {
	            code += "type = 'number'; ";
	        }
	        if (hasDate) {
	            code += "date = runtime.unpackDate(value); ";
	        }
	        if (hasTime) {
	            code += "time = runtime.unpackTime(value); ";
	        }
	        if (hasDate || hasTime) {
	            code += "type = 'date'; ";
	        }

	        if (percentCount > 0 || scaleCount > 0 || intFormat.length || decFormat.length || hasDate || hasTime) {
	            if (!preamble) {
	                preamble = "if (typeof value == 'number') { ";
	            }
	        }

	        input.restart();
	        code += "var matchedCurrency = false;";
	        while (!input.eof()) {
	            var tok = input.next();
	            if (tok.type == "dec") {
	                code += "output += culture.numberFormat['.']; ";
	            }
	            else if (tok.type == "comma" && !tok.hidden) {
	                code += "output += ','; ";
	            }
	            else if (tok.type == "percent") {
	                code += "type = 'percent'; ";
	                code += "output += culture.numberFormat.percent.symbol; ";
	            }
	            else if (tok.type == "str") {
	                if (currency.test(tok.value)) {
	                    code += "type = 'currency'; ";
	                    code += "if (isNegative) { output += '-'; matchedCurrency = true; }";
	                }
	                code += "output += " + JSON.stringify(tok.value) + "; ";
	            }
	            else if (tok.type == "text") {
	                code += "type = 'text'; ";
	                code += "output += value; ";
	            }
	            else if (tok.type == "space") {
	                code += "if (output) result.body.push(output); ";
	                code += "output = ''; ";
	                code += "result.body.push({ type: 'space', value: " + JSON.stringify(tok.value) + " }); ";
	            }
	            else if (tok.type == "fill") {
	                code += "output += runtime.fill(" + JSON.stringify(tok.value) + "); ";
	            }
	            else if (tok.type == "digit") {
	                code += "if (isNegative && intPart[0] && matchedCurrency) {intPart[0] = intPart[0].replace('-', '');}";
	                code += "output += " + (tok.decimal ? "decPart" : "intPart") + ".shift(); ";
	            }
	            else if (tok.type == "date") {
	                code += "output += runtime.date(culture, date, "
	                    + JSON.stringify(tok.part) + ", " + tok.format + "); ";
	            }
	            else if (tok.type == "time") {
	                code += "output += runtime.time(time, "
	                    + JSON.stringify(tok.part) + ", " + tok.format + ", " + hasAmpm + ", " + tok.fraction + "); ";
	            }
	            else if (tok.type == "eltime") {
	                code += "output += runtime.eltime(value, "
	                    + JSON.stringify(tok.part) + ", " + tok.format + ", " + tok.fraction + "); ";
	            }
	            else if (tok.type == "ampm") {
	                // XXX: should use culture?  As per the "spec", Excel
	                // displays whatever the token was (AM/PM, a/p etc.)
	                code += "output += time.hours < 12 ? " + JSON.stringify(tok.am) + " : " + JSON.stringify(tok.pm) + "; ";
	            }
	        }

	        code += "if (output) result.body.push(output); ";
	        code += "result.type = type; ";
	        code += "return result; ";

	        if (preamble) {
	            code = preamble + code + "}";
	        }

	        return code;
	    }

	    var TEXT = compileFormatPart({ cond: "text", body: [ { type: "text" } ] });

	    var compile = util.memoize(function(format) {
	        var tree = parse(format);
	        var code = tree.map(compileFormatPart);
	        code.push(TEXT);
	        code = code.join("\n");
	        code = "'use strict'; return function(value, culture){ "
	            + "if (!culture) culture = kendo.culture(); "
	            + "var output = '', type = null, result = { body: [] }; " + code + "; return result; };";
	        return new Function("runtime", code)(runtime);
	    });

	    // Attempts to produce a format compatible with kendo.parseDate from our Excel format.  Needed
	    // in runtime.parseDate (passing Excel format to kendo.parseDate will mess up the month or
	    // minutes).  https://github.com/telerik/kendo-ui-core/issues/3797
	    var makeDateFormat = util.memoize(function(format){
	        var tree = parse(format);
	        var section, found = false, hasAmpm = false;

	        // locate a section that contains date/time formatting.  only the first will be converted.
	        for (var i = 0; i < tree.length; ++i) {
	            section = tree[i];
	            for (var j = 0; j < section.body.length; ++j) {
	                if (/^(?:date|time|ampm)$/.test(section.body[j].type)) {
	                    found = true;
	                    if (section.body[j].type == "ampm") {
	                        hasAmpm = true;
	                    }
	                }
	            }
	            if (found) {
	                break;
	            }
	        }
	        if (!found) {
	            return null;
	        }

	        return section.body.map(printToken).join("");

	        // a little copy/paste goes a long way

	        function maybeFraction(fmt, tok) {
	            if (tok.fraction) {
	                fmt += padLeft("", Math.max(tok.fraction, 3), "f");
	            }
	            return fmt;
	        }

	        function printToken(tok) {
	            if (tok.type == "digit") {
	                if (tok.sep) {
	                    return tok.format.charAt(0) + "," + tok.format.substr(1);
	                } else {
	                    return tok.format;
	                }
	            }
	            else if (tok.type == "exp") {
	                return tok.ch + tok.sign;
	            }
	            else if (tok.type == "date" || tok.type == "time") {
	                var part = tok.part;
	                if (tok.type == "date" && /^m/.test(part)) {
	                    part = "M"; // month, not minutes
	                }
	                else if (tok.type == "time" && /^h/.test(part)) {
	                    if (!hasAmpm) {
	                        // 24-hours clock is H or HH
	                        part = part.toUpperCase();
	                    }
	                }
	                return maybeFraction(padLeft("", tok.format, part), tok);
	            }
	            else if (tok.type == "ampm") {
	                return "tt";
	            }
	            else if (tok.type == "str") {
	                // XXX: this is a bit wrong.  it doesn't look like kendo.toString / kendo.parseDate
	                // support arbitrary text (in Excel formats that's quoted), for example:
	                //    kendo.toString(new Date(), "here's the day dude: dd")
	                //  → "3ere'8 t3e 19ay 19u19e: 19"   (it's 19th June, 3 o'clock, probably 8 seconds)
	                return tok.value;
	            }
	            else if (tok.type == "space") {
	                return " ";
	            }
	            else if (tok.type == "dec") {
	                return ".";
	            }
	            else if (tok.type == "percent") {
	                return "%";
	            }
	            else if (tok.type == "comma") {
	                return ",";
	            }
	            else {
	                return "";
	            }
	        }
	    });

	    var runtime = {

	        unpackDate: calc.runtime.unpackDate,
	        unpackTime: calc.runtime.unpackTime,

	        date: function(culture, d, part, length) {
	            switch (part) {
	              case "d":
	                switch (length) {
	                  case 1: return d.date;
	                  case 2: return padLeft(d.date, 2, "0");
	                  case 3: return culture.calendars.standard.days.namesAbbr[d.day];
	                  case 4: return culture.calendars.standard.days.names[d.day];
	                }
	                break;
	              case "m":
	                switch (length) {
	                  case 1: return d.month + 1;
	                  case 2: return padLeft(d.month + 1, 2, "0");
	                  case 3: return culture.calendars.standard.months.namesAbbr[d.month];
	                  case 4: return culture.calendars.standard.months.names[d.month];
	                  case 5: return culture.calendars.standard.months.names[d.month].charAt(0);
	                }
	                break;
	              case "y":
	                switch (length) {
	                  case 2: return d.year % 100;
	                  case 4: return d.year;
	                }
	                break;
	            }
	            return "##";
	        },

	        time: function(t, part, length, ampm, fraclen) {
	            var ret, fraction;
	            switch (part) {
	              case "h":
	                ret = padLeft(ampm ? t.hours % 12 || 12 : t.hours, length, "0");
	                if (fraclen) {
	                    fraction = (t.minutes + (t.seconds + t.milliseconds / 1000) / 60) / 60;
	                }
	                break;
	              case "m":
	                ret = padLeft(t.minutes, length, "0");
	                if (fraclen) {
	                    fraction = (t.seconds + t.milliseconds / 1000) / 60;
	                }
	                break;
	              case "s":
	                ret = padLeft(t.seconds, length, "0");
	                if (fraclen) {
	                    fraction = t.milliseconds / 1000;
	                }
	                break;
	            }
	            if (fraction) {
	                ret += runtime.toFixed(fraction, fraclen).replace(/^0+/, "");
	            }
	            return ret;
	        },

	        eltime: function(value, part, length, fraclen) {
	            var ret, fraction;
	            switch (part) {
	              case "h":
	                ret = value * 24;
	                break;
	              case "m":
	                ret = value * 24 * 60;
	                break;
	              case "s":
	                ret = value * 24 * 60 * 60;
	                break;
	            }
	            if (fraclen) {
	                fraction = ret - (ret | 0);
	            }
	            ret = padLeft(ret | 0, length, "0");
	            if (fraction) {
	                ret += runtime.toFixed(fraction, fraclen).replace(/^0+/, "");
	            }
	            return ret;
	        },

	        fill: function(ch) {
	            // XXX: how to implement this?
	            return ch;
	        },

	        // formatting integer part is slightly different than decimal
	        // part, so they're implemented in two functions.  For the
	        // integer part we need to walk the value and the format
	        // backwards (right-to-left).

	        formatInt: function(culture, value, parts, declen, sep) {
	            // toFixed is perfect for rounding our value; if there is
	            // no format for decimals, for example, we want the number
	            // rounded up.
	            value = runtime.toFixed(value, declen).replace(/\..*$/, "");
	            var lastPart = parts[parts.length - 1];

	            if (declen > 0 && lastPart[parts.length - 1] != "0") {
	                // if the rounded number is zero and we have decimal
	                // format, consider it a non-significant digit (Excel
	                // won't display the leading zero for 0.2 in format #.#).
	                // the zero won't e omitted if using 0.0 format
	                if (value === "0") { value = ""; }
	                else if (value === "-0") { value = "-"; }
	            }

	            var shouldInsertMinus = false;
	            var iv = value.length - 1;
	            var result = [];
	            var len = 0, str;

	            function add(ch, skipMinus) {
	                if (sep && len && len % 3 === 0 && /^[0-9]$/.test(ch)) {
	                    str = culture.numberFormat[","] + str;
	                }
	                if(skipMinus && ch === "-") {
	                    shouldInsertMinus = true;
	                    ch = "0";
	                }
	                str = ch + str;
	                len++;
	            }

	            for (var j = parts.length; --j >= 0;) {
	                var format = parts[j];
	                str = "";
	                for (var k = format.length; --k >= 0;) {
	                    var chf = format.charAt(k);
	                    if (iv < 0) {
	                        if (chf == "0") {
	                            add("0");
	                        } else if (chf == "?") {
	                            add(" ");
	                        }
	                    } else {
	                        if (value == "0" && chf == "?") {
	                            add(" ");
	                        } else if (chf == "0") {
	                            add(value.charAt(iv), true);
	                        } else {
	                            add(value.charAt(iv));
	                        }
	                        iv--;
	                    }
	                }
	                if (j === 0) {
	                    while (iv >= 0) {
	                        add(value.charAt(iv--));
	                    }
	                }
	                result.unshift(str);
	            }

	            if(shouldInsertMinus) {
	                result[0] = "-" + result[0];
	            }

	            return result;
	        },

	        // for decimal part we walk in normal direction and pad on the
	        // right if required (for '0' or '?' chars).

	        formatDec: function(value, parts, declen) {
	            value = runtime.toFixed(value, declen);
	            var pos = value.indexOf(".");
	            if (pos >= 0) {
	                value = value.substr(pos + 1).replace(/0+$/, "");
	            } else {
	                value = "";
	            }

	            var iv = 0;
	            var result = [];

	            for (var j = 0; j < parts.length; ++j) {
	                var format = parts[j];
	                var str = "";
	                for (var k = 0; k < format.length; ++k) {
	                    var chf = format.charAt(k);
	                    if (iv < value.length) {
	                        str += value.charAt(iv++);
	                    } else if (chf == "0") {
	                        str += "0";
	                    } else if (chf == "?") {
	                        str += " ";
	                    }
	                }
	                result.push(str);
	            }

	            return result;
	        },

	        // JS's toFixed is broken, it's only OK to use it on integers.
	        toFixed: function(value, decimals) {
	            return (function toFixed(value, last) {
	                if (!isFinite(value)) {
	                    return "#NUM!";
	                }

	                // deal early with the trivial cases
	                if (value < 0) {    // JS's Math.round is broken with negative numbers
	                    return "-" + toFixed(-value);
	                }

	                if (decimals === 0) { // no decimals
	                    return String(Math.round(value));
	                }

	                if (value === Math.round(value) && !/e/i.test(String(value))) { // value is integer and not too big
	                    return value.toFixed(decimals);
	                }

	                // this handles cases like 0.3.toFixed(20) == "0.29999999999999998890", or
	                // 2.1825.toFixed(20) = "2.18250000000000010658".
	                // https://github.com/telerik/kendo-ui-core/issues/3520#issuecomment-333768221
	                // https://twitter.com/mcbazon/status/1035828655652593665
	                var num = digNumber(value);
	                var intpart = num.intpart;
	                var decpart = num.decpart;
	                if (decpart.length <= decimals) {
	                    while (decpart.length < decimals) {
	                        decpart += "0";
	                    }
	                    return intpart + "." + decpart;
	                }

	                if (last) {
	                    // "we should definitely not get here" (famous last words).  Let's MAKE SURE
	                    // there's no more recursion.
	                    return intpart + "." + decpart.substr(0, decimals);
	                }

	                // if there are more decimals than wanted, round and try again.
	                // it should not recurse more than once.
	                var f = Math.pow(10, decimals);
	                return toFixed(Math.round(value * f) / f, true);

	            })(Number(value.toFixed(14))); /* restrict to 14 decimals, because 0.1 + 0.2 ===
	                                                 * 0.30000000000000004 */
	        }

	    };

	    function padLeft(val, width, ch) {
	        val += "";
	        while (val.length < width) {
	            val = ch + val;
	        }
	        return val;
	    }

	    function padRight(val, width, ch) {
	        val += "";
	        while (val.length < width) {
	            val += ch;
	        }
	        return val;
	    }

	    // given a number, return { intpart, decpart } as strings.  the main difficulty here is that JS
	    // will stringify really large values in scientific notation (e.g. 1.23e+30, which is actually
	    // the integer 1230000000000000000000000000000).
	    function digNumber(num) {
	        var str = String(num).toLowerCase();
	        var intpart, decpart, m;
	        var pos = str.indexOf(".");
	        if (pos < 0) {
	            pos = str.indexOf("e");
	            if (pos < 0) {
	                intpart = str;
	                decpart = "";
	            } else {
	                intpart = str.substr(0, pos);
	                decpart = str.substr(pos);
	            }
	        } else {
	            intpart = str.substr(0, pos);
	            decpart = str.substr(pos + 1);
	        }
	        if ((m = /(\d*)e([-+]?\d+)/.exec(decpart))) {
	            var exp = parseInt(m[2], 10);
	            if (exp >= 0) {
	                decpart = padRight(m[1], exp, "0");
	                intpart += decpart.substr(0, exp);
	                decpart = decpart.substr(exp);
	            } else {
	                intpart = padLeft(intpart, -exp, "0");
	                decpart = intpart.substr(exp) + m[1];
	                intpart = intpart.substr(0, intpart.length + exp);
	            }
	        }
	        return { intpart: intpart || "0", decpart: decpart };
	    }

	    /* -----[ exports ]----- */

	    function text(f) {
	        var a = f.body;
	        var text = "";
	        for (var i = 0; i < a.length; ++i) {
	            var el = a[i];
	            if (typeof el == "string") {
	                text += el;
	            } else if (el.type == "space") {
	                text += " ";
	            }
	        }
	        return text;
	    }

	    kendo.spreadsheet.formatting = {
	        compile : compile,
	        parse: parse,
	        format: function(value, format, culture) {
	            var f = compile(format)(value, culture);
	            var span = dom.element("span");
	            span.__dataType = f.type;
	            var a = f.body;
	            if (f.color) {
	                span.attr.style = { color: f.color };
	            }
	            for (var i = 0; i < a.length; ++i) {
	                var el = a[i];
	                if (typeof el == "string") {
	                    span.children.push(dom.text(el));
	                } else if (el.type == "space") {
	                    span.children.push(dom.element("span", {
	                        style: { visibility: "hidden" }
	                    }, [ dom.text(el.value) ]));
	                }
	            }
	            return span;
	        },
	        text: function(value, format, culture) {
	            var f = compile(format)(value, culture);
	            return text(f);
	        },
	        textAndColor: function(value, format, culture) {
	            var f = compile(format)(value, culture);
	            return { text: text(f), color: f.color, type: f.type };
	        },
	        type: function(value, format) {
	            return compile(format)(value).type;
	        },
	        adjustDecimals: function(format, diff) {
	            var ast = parse(format);
	            adjustDecimals(ast, diff);
	            return print(ast);
	        },
	        makeDateFormat: makeDateFormat
	    };

	}, __webpack_require__(3));


/***/ }),

/***/ 1611:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("2btM");

/***/ }),

/***/ 1612:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("Iu+f");

/***/ })

/******/ });

/***/ }),

/***/ "yrck":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1317);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("FZAa");

/***/ }),

/***/ 1297:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("RnqI");

/***/ }),

/***/ 1317:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1297), __webpack_require__(1088) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "mobile.drawer",
	    name: "Drawer",
	    category: "mobile",
	    description: "The Kendo Mobile Drawer widget provides slide to reveal global application toolbox",
	    depends: [ "mobile.view", "userevents" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	        mobile = kendo.mobile,
	        os = kendo.support.mobileOS,
	        Transition = kendo.effects.Transition,
	        roleSelector = kendo.roleSelector,
	        AXIS = "x",
	        ui = mobile.ui,
	        SWIPE_TO_OPEN = !(os.ios && os.majorVersion == 7 && !os.appMode),
	        BEFORE_SHOW = "beforeShow",
	        INIT = "init",
	        SHOW = "show",
	        HIDE = "hide",
	        AFTER_HIDE = "afterHide",
	        NULL_VIEW = { enable: $.noop };

	    var Drawer = ui.View.extend({
	        init: function(element, options) {
	            // move the drawer to the top, in order to hide it
	            $(element).parent().prepend(element);

	            mobile.ui.Widget.fn.init.call(this, element, options);

	            if (!this.options.$angular) {
	                this._layout();
	                this._scroller();
	            }

	            this._model();

	            var pane = this.element.closest(roleSelector("pane")).data("kendoMobilePane"),
	                userEvents;

	            if (pane) {
	                this.pane = pane;
	                this.pane.bind("viewShow", function(e) {
	                    drawer._viewShow(e);
	                });

	                this.pane.bind("sameViewRequested", function() {
	                    drawer.hide();
	                });

	                userEvents = this.userEvents = new kendo.UserEvents(pane.element, {
	                    fastTap: true,
	                    filter: roleSelector("view splitview"),
	                    allowSelection: true
	                });

	            } else {
	                this.currentView = NULL_VIEW;
	                var container = $(this.options.container);

	                if (!container) {
	                    throw new Error("The drawer needs a container configuration option set.");
	                }

	                userEvents = this.userEvents = new kendo.UserEvents(container, { fastTap: true, allowSelection: true });
	                this._attachTransition(container);
	            }

	            var drawer = this;

	            var hide = function(e) {
	                if (drawer.visible) {
	                    drawer.hide();
	                    e.preventDefault();
	                }
	            };

	            if (this.options.swipeToOpen && SWIPE_TO_OPEN) {
	                userEvents.bind("press", function() { drawer.transition.cancel(); });
	                userEvents.bind("start", function(e) { drawer._start(e); });
	                userEvents.bind("move", function(e) { drawer._update(e); });
	                userEvents.bind("end", function(e) { drawer._end(e); });
	                userEvents.bind("tap", hide);
	            } else {
	                userEvents.bind("press", hide);
	            }

	            this.leftPositioned = this.options.position === "left";

	            this.visible = false;

	            this.element.hide().addClass("km-drawer").addClass(this.leftPositioned ? "km-left-drawer" : "km-right-drawer");
	            this.trigger(INIT);
	        },

	        options: {
	            name: "Drawer",
	            position: "left",
	            views: [],
	            swipeToOpenViews: [],
	            swipeToOpen: true,
	            title: "",
	            container: null
	        },

	        events: [
	            BEFORE_SHOW,
	            HIDE,
	            AFTER_HIDE,
	            INIT,
	            SHOW
	        ],

	        show: function() {
	            if (this._activate()) {
	                this._show();
	            }
	        },

	        hide: function() {
	            if (!this.currentView) {
	                return;
	            }

	            this.currentView.enable();

	            Drawer.current = null;
	            this._moveViewTo(0);
	            this.trigger(HIDE, { view: this });
	        },

	        // Alias in order to support popover/modalview etc. interface
	        openFor: function() {
	            if (this.visible) {
	                this.hide();
	            } else {
	                this.show();
	            }
	        },

	        destroy: function() {
	            ui.View.fn.destroy.call(this);
	            this.userEvents.destroy();
	        },

	        _activate: function() {
	            if (this.visible) {
	                return true;
	            }

	            var visibleOnCurrentView = this._currentViewIncludedIn(this.options.views);

	            if (!visibleOnCurrentView || this.trigger(BEFORE_SHOW, { view: this })) {
	                return false;
	            }

	            this._setAsCurrent();
	            this.element.show();

	            this.trigger(SHOW, { view: this });
	            this._invokeNgController();
	            return true;
	        },

	        _currentViewIncludedIn: function(views) {
	            if (!this.pane || !views.length) {
	                return true;
	            }

	            var view = this.pane.view();
	            return $.inArray(view.id.replace('#', ''), views) > -1 || $.inArray(view.element.attr("id"), views) > -1;
	        },

	        _show: function() {
	            this.currentView.enable(false);

	            this.visible = true;
	            var offset = this.element.width();

	            if (!this.leftPositioned) {
	                offset = -offset;
	            }

	            this._moveViewTo(offset);
	        },

	        _setAsCurrent: function() {
	            if (Drawer.last !== this) {
	                if (Drawer.last) {
	                    Drawer.last.element.hide();
	                }
	                this.element.show();
	            }

	            Drawer.last = this;
	            Drawer.current = this;
	        },

	        _moveViewTo: function(offset) {
	            this.userEvents.cancel();
	            this.transition.moveTo({ location: offset, duration: 400, ease: Transition.easeOutExpo });
	        },

	        _viewShow: function(e) {
	            if (this.currentView) {
	                this.currentView.enable();
	            }

	            if (this.currentView === e.view) {
	                this.hide();
	                return;
	            }

	            this.currentView = e.view;
	            this._attachTransition(e.view.element);
	        },

	        _attachTransition: function(element) {
	            var that = this,
	                movable = this.movable,
	                currentOffset = movable && movable.x;


	            if (this.transition) {
	                this.transition.cancel();
	                this.movable.moveAxis("x", 0);
	            }

	            movable = this.movable = new kendo.ui.Movable(element);

	            this.transition = new Transition({
	                axis: AXIS,
	                movable: this.movable,
	                onEnd: function() {
	                    if (movable[AXIS] === 0) {
	                        element[0].style.cssText = "";
	                        that.element.hide();
	                        that.trigger(AFTER_HIDE);
	                        that.visible = false;
	                    }
	                }
	            });

	            if (currentOffset) {
	                element.addClass("k-fx-hidden");
	                kendo.animationFrame(function() {
	                    element.removeClass("k-fx-hidden");
	                    that.movable.moveAxis(AXIS, currentOffset);
	                    that.hide();
	                });
	            }
	        },

	        _start: function(e) {
	            var userEvents = e.sender;

	            // ignore non-horizontal swipes
	            if (Math.abs(e.x.velocity) < Math.abs(e.y.velocity) || kendo.triggeredByInput(e.event) || !this._currentViewIncludedIn(this.options.swipeToOpenViews)) {
	                userEvents.cancel();
	                return;
	            }

	            var leftPositioned = this.leftPositioned,
	                visible = this.visible,
	                canMoveLeft = leftPositioned && visible || !leftPositioned && !Drawer.current,
	                canMoveRight = !leftPositioned && visible || leftPositioned && !Drawer.current,
	                leftSwipe = e.x.velocity < 0;

	            if ((canMoveLeft && leftSwipe) || (canMoveRight && !leftSwipe)) {
	                if (this._activate()) {
	                    userEvents.capture();
	                    return;
	                }
	            }

	            userEvents.cancel();
	        },

	        _update: function(e) {
	            var movable = this.movable,
	                newPosition = movable.x + e.x.delta,
	                limitedPosition;

	            if (this.leftPositioned) {
	                limitedPosition = Math.min(Math.max(0, newPosition), this.element.width());
	            } else {
	                limitedPosition = Math.max(Math.min(0, newPosition), -this.element.width());
	            }

	            this.movable.moveAxis(AXIS, limitedPosition);
	            e.event.preventDefault();
	            e.event.stopPropagation();
	        },

	        _end: function(e) {
	            var velocity = e.x.velocity,
	                pastHalf = Math.abs(this.movable.x) > this.element.width() / 2,
	                velocityThreshold = 0.8,
	                shouldShow;

	            if (this.leftPositioned) {
	                shouldShow = velocity > -velocityThreshold && (velocity > velocityThreshold || pastHalf);
	            } else {
	                shouldShow = velocity < velocityThreshold && (velocity < -velocityThreshold || pastHalf);
	            }

	            if(shouldShow) {
	                this._show();
	            } else {
	                this.hide();
	            }
	        }
	    });

	    ui.plugin(Drawer);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "ytBa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = __webpack_require__("RQ1/");
var logger_1 = __webpack_require__("U9Xd");
var utils_1 = __webpack_require__("IRr6");
var eventService_1 = __webpack_require__("k5uU");
var events_1 = __webpack_require__("3ok8");
var gridOptionsWrapper_1 = __webpack_require__("Z3DQ");
var columnApi_1 = __webpack_require__("E/Wy");
var gridApi_1 = __webpack_require__("BAow");
/** Adds drag listening onto an element. In ag-Grid this is used twice, first is resizing columns,
 * second is moving the columns and column groups around (ie the 'drag' part of Drag and Drop. */
var DragService = (function () {
    function DragService() {
        this.onMouseUpListener = this.onMouseUp.bind(this);
        this.onMouseMoveListener = this.onMouseMove.bind(this);
        this.onTouchEndListener = this.onTouchUp.bind(this);
        this.onTouchMoveListener = this.onTouchMove.bind(this);
        this.dragEndFunctions = [];
        this.dragSources = [];
    }
    DragService.prototype.init = function () {
        this.logger = this.loggerFactory.create('DragService');
    };
    DragService.prototype.destroy = function () {
        this.dragSources.forEach(this.removeListener.bind(this));
        this.dragSources.length = 0;
    };
    DragService.prototype.removeListener = function (dragSourceAndListener) {
        var element = dragSourceAndListener.dragSource.eElement;
        var mouseDownListener = dragSourceAndListener.mouseDownListener;
        element.removeEventListener('mousedown', mouseDownListener);
        // remove touch listener only if it exists
        if (dragSourceAndListener.touchEnabled) {
            var touchStartListener = dragSourceAndListener.touchStartListener;
            element.removeEventListener('touchstart', touchStartListener, { passive: true });
        }
    };
    DragService.prototype.removeDragSource = function (params) {
        var dragSourceAndListener = utils_1.Utils.find(this.dragSources, function (item) { return item.dragSource === params; });
        if (!dragSourceAndListener) {
            return;
        }
        this.removeListener(dragSourceAndListener);
        utils_1.Utils.removeFromArray(this.dragSources, dragSourceAndListener);
    };
    DragService.prototype.setNoSelectToBody = function (noSelect) {
        var usrDocument = this.gridOptionsWrapper.getDocument();
        var eBody = usrDocument.querySelector('body');
        if (utils_1.Utils.exists(eBody)) {
            utils_1.Utils.addOrRemoveCssClass(eBody, 'ag-body-no-select', noSelect);
        }
    };
    DragService.prototype.addDragSource = function (params, includeTouch) {
        if (includeTouch === void 0) { includeTouch = false; }
        var mouseListener = this.onMouseDown.bind(this, params);
        params.eElement.addEventListener('mousedown', mouseListener);
        var touchListener = null;
        var suppressTouch = this.gridOptionsWrapper.isSuppressTouch();
        var reallyIncludeTouch = includeTouch && !suppressTouch;
        if (reallyIncludeTouch) {
            touchListener = this.onTouchStart.bind(this, params);
            params.eElement.addEventListener('touchstart', touchListener, { passive: false });
        }
        this.dragSources.push({
            dragSource: params,
            mouseDownListener: mouseListener,
            touchStartListener: touchListener,
            touchEnabled: includeTouch
        });
    };
    // gets called whenever mouse down on any drag source
    DragService.prototype.onTouchStart = function (params, touchEvent) {
        var _this = this;
        this.currentDragParams = params;
        this.dragging = false;
        var touch = touchEvent.touches[0];
        this.touchLastTime = touch;
        this.touchStart = touch;
        touchEvent.preventDefault();
        // we temporally add these listeners, for the duration of the drag, they
        // are removed in touch end handling.
        params.eElement.addEventListener('touchmove', this.onTouchMoveListener, { passive: true });
        params.eElement.addEventListener('touchend', this.onTouchEndListener, { passive: true });
        params.eElement.addEventListener('touchcancel', this.onTouchEndListener, { passive: true });
        this.dragEndFunctions.push(function () {
            params.eElement.removeEventListener('touchmove', _this.onTouchMoveListener, { passive: true });
            params.eElement.removeEventListener('touchend', _this.onTouchEndListener, { passive: true });
            params.eElement.removeEventListener('touchcancel', _this.onTouchEndListener, { passive: true });
        });
        // see if we want to start dragging straight away
        if (params.dragStartPixels === 0) {
            this.onCommonMove(touch, this.touchStart);
        }
    };
    // gets called whenever mouse down on any drag source
    DragService.prototype.onMouseDown = function (params, mouseEvent) {
        var _this = this;
        // if there are two elements with parent / child relationship, and both are draggable,
        // when we drag the child, we should NOT drag the parent. an example of this is row moving
        // and range selection - row moving should get preference when use drags the rowDrag component.
        if (mouseEvent._alreadyProcessedByDragService) {
            return;
        }
        mouseEvent._alreadyProcessedByDragService = true;
        // only interested in left button clicks
        if (mouseEvent.button !== 0) {
            return;
        }
        this.currentDragParams = params;
        this.dragging = false;
        this.mouseEventLastTime = mouseEvent;
        this.mouseStartEvent = mouseEvent;
        var usrDocument = this.gridOptionsWrapper.getDocument();
        // we temporally add these listeners, for the duration of the drag, they
        // are removed in mouseup handling.
        usrDocument.addEventListener('mousemove', this.onMouseMoveListener);
        usrDocument.addEventListener('mouseup', this.onMouseUpListener);
        this.dragEndFunctions.push(function () {
            usrDocument.removeEventListener('mousemove', _this.onMouseMoveListener);
            usrDocument.removeEventListener('mouseup', _this.onMouseUpListener);
        });
        // see if we want to start dragging straight away
        if (params.dragStartPixels === 0) {
            this.onMouseMove(mouseEvent);
        }
    };
    // returns true if the event is close to the original event by X pixels either vertically or horizontally.
    // we only start dragging after X pixels so this allows us to know if we should start dragging yet.
    DragService.prototype.isEventNearStartEvent = function (currentEvent, startEvent) {
        // by default, we wait 4 pixels before starting the drag
        var requiredPixelDiff = utils_1.Utils.exists(this.currentDragParams.dragStartPixels) ? this.currentDragParams.dragStartPixels : 4;
        return utils_1.Utils.areEventsNear(currentEvent, startEvent, requiredPixelDiff);
    };
    DragService.prototype.getFirstActiveTouch = function (touchList) {
        for (var i = 0; i < touchList.length; i++) {
            var matches = touchList[i].identifier === this.touchStart.identifier;
            if (matches) {
                return touchList[i];
            }
        }
        return null;
    };
    DragService.prototype.onCommonMove = function (currentEvent, startEvent) {
        if (!this.dragging) {
            // if mouse hasn't travelled from the start position enough, do nothing
            var toEarlyToDrag = !this.dragging && this.isEventNearStartEvent(currentEvent, startEvent);
            if (toEarlyToDrag) {
                return;
            }
            else {
                // alert(`started`);
                this.dragging = true;
                var event_1 = {
                    type: events_1.Events.EVENT_DRAG_STARTED,
                    api: this.gridApi,
                    columnApi: this.columnApi
                };
                this.eventService.dispatchEvent(event_1);
                this.currentDragParams.onDragStart(startEvent);
                this.setNoSelectToBody(true);
            }
        }
        this.currentDragParams.onDragging(currentEvent);
    };
    DragService.prototype.onTouchMove = function (touchEvent) {
        var touch = this.getFirstActiveTouch(touchEvent.touches);
        if (!touch) {
            return;
        }
        // this.___statusBar.setInfoText(Math.random() + ' onTouchMove preventDefault stopPropagation');
        // if we don't preview default, then the browser will try and do it's own touch stuff,
        // like do 'back button' (chrome does this) or scroll the page (eg drag column could  be confused
        // with scroll page in the app)
        // touchEvent.preventDefault();
        this.onCommonMove(touch, this.touchStart);
    };
    // only gets called after a mouse down - as this is only added after mouseDown
    // and is removed when mouseUp happens
    DragService.prototype.onMouseMove = function (mouseEvent) {
        this.onCommonMove(mouseEvent, this.mouseStartEvent);
    };
    DragService.prototype.onTouchUp = function (touchEvent) {
        var touch = this.getFirstActiveTouch(touchEvent.targetTouches);
        // i haven't worked this out yet, but there is no matching touch
        // when we get the touch up event. to get around this, we swap in
        // the last touch. this is a hack to 'get it working' while we
        // figure out what's going on, why we are not getting a touch in
        // current event.
        if (!touch) {
            touch = this.touchLastTime;
        }
        // if mouse was left up before we started to move, then this is a tap.
        // we check this before onUpCommon as onUpCommon resets the dragging
        // let tap = !this.dragging;
        // let tapTarget = this.currentDragParams.eElement;
        this.onUpCommon(touch);
        // if tap, tell user
        // console.log(`${Math.random()} tap = ${tap}`);
        // if (tap) {
        //     tapTarget.click();
        // }
    };
    DragService.prototype.onMouseUp = function (mouseEvent) {
        this.onUpCommon(mouseEvent);
    };
    DragService.prototype.onUpCommon = function (eventOrTouch) {
        if (this.dragging) {
            this.dragging = false;
            this.currentDragParams.onDragStop(eventOrTouch);
            var event_2 = {
                type: events_1.Events.EVENT_DRAG_STOPPED,
                api: this.gridApi,
                columnApi: this.columnApi
            };
            this.eventService.dispatchEvent(event_2);
        }
        this.setNoSelectToBody(false);
        this.mouseStartEvent = null;
        this.mouseEventLastTime = null;
        this.touchStart = null;
        this.touchLastTime = null;
        this.currentDragParams = null;
        this.dragEndFunctions.forEach(function (func) { return func(); });
        this.dragEndFunctions.length = 0;
    };
    __decorate([
        context_1.Autowired('loggerFactory'),
        __metadata("design:type", logger_1.LoggerFactory)
    ], DragService.prototype, "loggerFactory", void 0);
    __decorate([
        context_1.Autowired('eventService'),
        __metadata("design:type", eventService_1.EventService)
    ], DragService.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
    ], DragService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('columnApi'),
        __metadata("design:type", columnApi_1.ColumnApi)
    ], DragService.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'),
        __metadata("design:type", gridApi_1.GridApi)
    ], DragService.prototype, "gridApi", void 0);
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DragService.prototype, "init", null);
    __decorate([
        context_1.PreDestroy,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DragService.prototype, "destroy", null);
    DragService = __decorate([
        context_1.Bean('dragService')
    ], DragService);
    return DragService;
}());
exports.DragService = DragService;


/***/ }),

/***/ "yu0z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: [String, Number],
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    autoWidth: {
        type: Boolean,
        default: undefined
    },
    cascadeFrom: {
        type: String,
        default: undefined
    },
    cascadeFromField: {
        type: String,
        default: undefined
    },
    cascadeFromParentField: {
        type: String,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    dataValueField: {
        type: String,
        default: undefined
    },
    delay: {
        type: Number,
        default: undefined
    },
    enable: {
        type: Boolean,
        default: undefined
    },
    enforceMinLength: {
        type: Boolean,
        default: undefined
    },
    filter: {
        type: String,
        default: undefined
    },
    fixedGroupTemplate: {
        type: [String, Function],
        default: undefined
    },
    footerTemplate: {
        type: [String, Function],
        default: undefined
    },
    groupTemplate: {
        type: [String, Function],
        default: undefined
    },
    height: {
        type: Number,
        default: undefined
    },
    ignoreCase: {
        type: Boolean,
        default: undefined
    },
    index: {
        type: Number,
        default: undefined
    },
    minLength: {
        type: Number,
        default: undefined
    },
    noDataTemplate: {
        type: [String, Function],
        default: undefined
    },
    popup: {
        type: Object,
        default: undefined
    },
    optionLabel: {
        type: [String, Object],
        default: undefined
    },
    optionLabelTemplate: {
        type: [String, Function],
        default: undefined
    },
    headerTemplate: {
        type: [String, Function],
        default: undefined
    },
    template: {
        type: [String, Function],
        default: undefined
    },
    valueTemplate: {
        type: [String, Function],
        default: undefined
    },
    text: {
        type: String,
        default: undefined
    },
    value: {
        type: [String, Number],
        default: undefined
    },
    valuePrimitive: {
        type: Boolean,
        default: undefined
    },
    virtual: {
        type: [Boolean, Object],
        default: undefined
    },

    // Events
    change: Function,
    close: Function,
    dataBound: {
        type: Function,
        default: undefined
    },
    filtering: Function,
    open: Function,
    select: Function,
    cascade: Function
};

/***/ }),

/***/ "z7nc":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1577);
	module.exports = __webpack_require__(1577);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 964:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("QbYn");

/***/ }),

/***/ 1577:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// -*- fill-column: 100 -*-

	(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1578), __webpack_require__(964) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){
	    "use strict";

	    // jshint eqnull:true

	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var spreadsheet = kendo.spreadsheet;
	    var Range = spreadsheet.Range;
	    var runtime = spreadsheet.calc.runtime;
	    var Formula = runtime.Formula;

	    var ERR_INCOMPATIBLE = "incompatibleRanges";
	    var ERR_NO_DIRECTION = "noFillDirection";

	    var FillError = Range.FillError = function(msg) {
	        this.code = msg;
	    };

	    // `srcRange`: the range containing data that we wish to fill.  `direction`: 0↓, 1→, 2↑, 3←.  So
	    // when bit 0 is set we're doing horizontal filling, and when bit 1 is set we're doing it in
	    // reverse order.
	    Range.prototype._previewFillFrom = function(srcRange, direction) {
	        var destRange = this, sheet = destRange._sheet;
	        if (typeof srcRange == "string") {
	            srcRange = sheet.range(srcRange);
	        }
	        var src = srcRange._ref.toRangeRef().clone().setSheet(sheet.name());
	        var dest = destRange._ref.toRangeRef().clone().setSheet(sheet.name());

	        if (src.intersects(dest)) {
	            // the UI will send e.g. C2:C8.fillFrom(C7:D8) (intersecting ranges).  this figures out
	            // the actual destination range.
	            if (src.eq(dest)) {
	                return null; // nothing to do
	            }
	            dest = dest.clone();
	            if (src.topLeft.eq(dest.topLeft)) {
	                if (src.width() == dest.width()) {
	                    dest.topLeft.row += src.height();
	                    direction = 0;
	                } else if (src.height() == dest.height()) {
	                    dest.topLeft.col += src.width();
	                    direction = 1;
	                } else {
	                    throw new FillError(ERR_INCOMPATIBLE);
	                }
	            } else if (src.bottomRight.eq(dest.bottomRight)) {
	                if (src.width() == dest.width()) {
	                    dest.bottomRight.row -= src.height();
	                    direction = 2;
	                } else if (src.height() == dest.height()) {
	                    dest.bottomRight.col -= src.width();
	                    direction = 3;
	                } else {
	                    throw new FillError(ERR_INCOMPATIBLE);
	                }
	            } else {
	                throw new FillError(ERR_INCOMPATIBLE);
	            }
	            return sheet.range(dest)._previewFillFrom(srcRange, direction);
	        }

	        if (direction == null) {
	            // try to determine based on ranges location/geometry
	            if (src.topLeft.col == dest.topLeft.col) {
	                // assume vertical filling
	                direction = src.topLeft.row < dest.topLeft.row ? 0 : 2;
	            } else if (src.topLeft.row == dest.topLeft.row) {
	                direction = src.topLeft.col < dest.topLeft.col ? 1 : 3;
	            } else {
	                throw new FillError(ERR_NO_DIRECTION);
	            }
	        }
	        var horizontal = direction & 1;
	        var descending = direction & 2;
	        if ((horizontal && src.height() != dest.height()) ||
	            (!horizontal && src.width() != dest.width())) {
	            throw new FillError(ERR_INCOMPATIBLE);
	        }
	        var data = srcRange._properties(), n;
	        if (!horizontal) {
	            data = transpose(data);
	            n = dest.height();
	        } else {
	            n = dest.width();
	        }
	        var fill = new Array(data.length);
	        var hint = null;
	        for (var i = 0; i < data.length; ++i) {
	            var s = data[i];
	            var f = findSeries(s);
	            var a = fill[i] = new Array(n);
	            for (var j = 0; j < n; ++j) {
	                var idx = descending ? -j - 1 : s.length + j;
	                var srcIdx = descending ? s.length - (j % s.length) - 1 : (j % s.length);
	                var cell = a[descending ? n - j - 1 : j] = f(idx, srcIdx);
	                if (cell.value != null) {
	                    hint = cell.value;
	                }
	            }
	        }
	        if (!horizontal) {
	            fill = transpose(fill);
	        }
	        return { props: fill, direction: direction, dest: destRange, hint: hint };
	    };

	    Range.prototype.fillFrom = function(srcRange, direction) {
	        var x = this._previewFillFrom(srcRange, direction);
	        x.dest._properties(x.props, true);
	        return x.dest;
	    };

	    // This is essentially the FORECAST function, see ./runtime.functions.2.js.
	    // It receives an array of values, and returns a function that "predicts"
	    // the value in cell N.
	    function linearRegression(data) {
	        var N = data.length;
	        var mx = (N + 1) / 2, my = data.reduce(function(a, b){
	            return a + b;
	        }, 0) / N;
	        var s1 = 0, s2 = 0;
	        for (var i = 0; i < N; i++) {
	            var t1 = (i + 1) - mx, t2 = data[i] - my;
	            s1 += t1 * t2;
	            s2 += t1 * t1;
	        }
	        if (!s2) {
	            return function(N){
	                return data[N % data.length];
	            };
	        }
	        var b = s1 / s2, a = my - b * mx;
	        return function(N) {
	            return a + b * (N + 1);
	        };
	    }

	    function findSeries(properties) {
	        function findStep(a) {
	            var diff = a[1] - a[0];
	            for (var i = 2; i < a.length; ++i) {
	                if (a[i] - a[i-1] != diff) {
	                    return null;
	                }
	            }
	            return diff;
	        }
	        function getData(a) {
	            return a.map(function(v){
	                return v.number;
	            });
	        }
	        var series = [];
	        var data = properties.map(function(x){
	            return x.formula || x.value;
	        });
	        forEachSeries(data, function(begin, end, type, a){
	            var f, values;
	            if (type == "number") {
	                values = getData(a);

	                // This code would increase a date even if a single cell was selected.  Seems it's
	                // not desirable so I commented it out.
	                // https://github.com/telerik/kendo-ui-core/issues/3565
	                //
	                // if (values.length == 1 && (begin > 0 || end < data.length ||
	                //                            formatType(values[0], properties[begin].format) == "date")) {
	                //     values.push(values[0] + 1);
	                // }

	                f = linearRegression(values);
	            } else if (type == "string" || type == "formula" || type == "boolean") {
	                // formulas are simply copied over; the sheet will internally clone the objects
	                f = function(N, i) {
	                    return data[i];
	                };
	            } else if (Array.isArray(type)) {
	                if (a.length == 1) {
	                    f = function(N) {
	                        return type[(a[0].number + N) % type.length];
	                    };
	                } else {
	                    // figure out the step
	                    var diff = findStep(getData(a));
	                    if (diff == null) {
	                        // seemingly no pattern, just repeat those strings
	                        f = function(N) {
	                            return a[(N) % a.length].value;
	                        };
	                    } else {
	                        f = function(N) {
	                            var idx = a[0].number + diff * N;
	                            return type[idx % type.length];
	                        };
	                    }
	                }
	            } else if (type != "null") {
	                values = getData(a);
	                if (values.length == 1) {
	                    values.push(values[0] + 1);
	                }
	                values = linearRegression(values);
	                f = function(N, i) {
	                    return data[i].replace(/^(.*\D)\d+/, "$1" + values(N, i));
	                };
	            } else {
	                f = function() { return null; };
	            }
	            var s = { f: f, begin: begin, end: end, len: end - begin };
	            for (var i = begin; i < end; ++i) {
	                series[i] = s;
	            }
	        });
	        return function(N, i) {
	            var s = series[i];
	            var q = N / data.length | 0;
	            var r = N % data.length;
	            var n = q * s.len + r - s.begin;
	            var value = s.f(n, i);
	            var props = clone(properties[i]);
	            delete props.enable;
	            if (value instanceof Formula) {
	                props.formula = value;
	            } else {
	                props.value = value;
	            }
	            return props;
	        };
	    }

	    // function formatType(value, format) {
	    //     if (format != null) {
	    //         return spreadsheet.formatting.type(value, format);
	    //     }
	    // }

	    function clone(obj) {
	        var copy = {};
	        Object.keys(obj || {}).forEach(function(key){
	            copy[key] = obj[key];
	        });
	        return copy;
	    }

	    function forEachSeries(data, f) {
	        var prev = null, start = 0, a = [], type;
	        for (var i = 0; i < data.length; ++i) {
	            type = getType(data[i]);
	            a.push(type);
	            if (prev != null && type.type !== prev.type) {
	                f(start, i, prev.type, a.slice(start, i));
	                start = i;
	            }
	            prev = type;
	        }
	        f(start, i, prev.type, a.slice(start, i));
	    }

	    function getType(el) {
	        if (typeof el == "number") {
	            return { type: "number", number: el };
	        }
	        if (typeof el == "string") {
	            var lst = findStringList(el);
	            if (lst) {
	                return lst;
	            }
	            var m = /^(.*\D)(\d+)/.exec(el);
	            if (m) {
	                el = el.replace(/^(.*\D)\d+/, "$1-######");
	                return { type: el, match: m, number: parseFloat(m[2]) };
	            }
	            return { type: "string" };
	        }
	        if (typeof el == "boolean") {
	            return { type: "boolean" };
	        }
	        if (el == null) {
	            return { type: "null" };
	        }
	        if (el instanceof Formula) {
	            return { type: "formula" };
	        }
	        window.console.error(el);
	        throw new Error("Cannot fill data");
	    }

	    function stringLists() {
	        var culture = kendo.culture();
	        return [
	            culture.calendars.standard.days.namesAbbr,
	            culture.calendars.standard.days.names,
	            culture.calendars.standard.months.namesAbbr,
	            culture.calendars.standard.months.names
	        ];
	    }

	    function findStringList(str) {
	        var strl = str.toLowerCase();
	        var lists = stringLists();
	        for (var i = 0; i < lists.length; ++i) {
	            var a = lists[i];
	            for (var j = a.length; --j >= 0;) {
	                var el = a[j].toLowerCase();
	                if (el == strl) {
	                    return { type: a, number: j, value: str };
	                }
	            }
	        }
	    }

	    function transpose(a) {
	        var height = a.length, width = a[0].length;
	        var t = [];
	        for (var i = 0; i < width; ++i) {
	            t[i] = [];
	            for (var j = 0; j < height; ++j) {
	                t[i][j] = a[j][i];
	            }
	        }
	        return t;
	    }

	}, __webpack_require__(3));


/***/ }),

/***/ 1578:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("I2Wh");

/***/ })

/******/ });

/***/ }),

/***/ "zFpm":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1594);
	module.exports = __webpack_require__(1594);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1594:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(20) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function(kendo) {
	    if (kendo.support.browser.msie && kendo.support.browser.version < 9) {
	        return;
	    }

	    var $ = kendo.jQuery;

	    var KEY_NAMES = {
	        8: 'backspace',
	        9: 'tab',
	        13: 'enter',
	        27: 'esc',
	        37: 'left',
	        38: 'up',
	        39: 'right',
	        40: 'down',
	        35: 'end',
	        36: 'home',
	        32: 'spacebar',
	        33: 'pageup',
	        34: 'pagedown',
	        46: 'delete',
	        113: ':edit'
	    };

	    var Mac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

	    var isAlphaNum = function(keyCode) {
	        if ((keyCode > 47 && keyCode < 58)   || // number keys
	            (keyCode > 64 && keyCode < 91)   || // letter keys
	            (keyCode > 95 && keyCode < 112)  || // numpad keys
	            (keyCode > 185 && keyCode < 193) || // ;=,-./` (in order)
	            (keyCode > 218 && keyCode < 223) || // [\]' (in order)
	            (keyCode === 229)                   // combined key event?
	           ) {
	            return true;
	        }

	        return false;
	    };

	    var keyName = function(event) {
	        var keyCode = event.keyCode;
	        var name = KEY_NAMES[keyCode];

	        if (!name && isAlphaNum(keyCode)) {
	            name = ":alphanum";
	        }

	        // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
	        //
	        // Fix for https://github.com/telerik/kendo-ui-core/issues/2284
	        // (starting editor with `=` on Firefox)
	        if (!name && event.key && event.key.length == 1) {
	            name = ":alphanum";
	        }

	        return name;
	    };

	    var EventListener = kendo.Class.extend({
	        init: function(target, observer, handlers) {
	            this._handlers = {};
	            this.target = target;
	            this._observer = observer || window;

	            this.keyDownProxy = this.keyDown.bind(this);
	            this.mouseProxy = this.mouse.bind(this);
	            this.touchProxy = this.touch.bind(this);
	            this.threshold = 5;
	            this._pressLocation = null;

	            target.on("keydown", this.keyDownProxy);
	            target.on("contextmenu mousedown cut copy paste scroll wheel click dblclick focus", this.mouseProxy);
	            target.on("touchmove touchend", this.touchProxy);

	            $(document.documentElement).on("mousemove mouseup", this.mouseProxy);
	            $(document.documentElement).on("touchmove touchend", this.touchProxy);

	            if (handlers) {
	                for (var key in handlers) {
	                    this.on(key, handlers[key]);
	                }
	            }
	        },

	        keyDown: function(e) {
	            this.handleEvent(e, keyName(e.originalEvent));
	        },

	        touch: function(e) {
	            this.handleEvent(e, e.type);
	        },

	        mouse: function(e) {

	            var rightClick;

	            if (e.which) {
	                rightClick = (e.which == 3);
	            } else if (e.button) {
	                rightClick = (e.button == 2);
	            }

	            var type = e.type;

	            if (type === "mousedown") {
	                if (rightClick) {
	                   type = "rightmousedown";
	                } else {
	                    this._pressLocation = { x: e.pageX, y: e.pageY };
	                }
	            }

	            if (type === "mouseup") {
	                if (!rightClick) {
	                    this._pressLocation = null;
	                }
	            }

	            if (type === "mousemove" && this._pressLocation) {
	                var dx = this._pressLocation.x - e.pageX;
	                var dy = this._pressLocation.y - e.pageY;
	                var distance = Math.sqrt(dx*dx + dy*dy);

	                if (distance > this.threshold) {
	                    type = "mousedrag";
	                }
	            }

	            this.handleEvent(e, type);
	        },

	        handleEvent: function(e, name) {
	            var eventKey = "";

	            e.mod = Mac ? e.metaKey : (e.ctrlKey && !e.altKey);

	            if (e.altKey) {
	                eventKey += "alt+";
	            }

	            if (e.shiftKey) {
	                eventKey += "shift+";
	            }

	            if (e.ctrlKey) {
	                eventKey += "ctrl+";
	            }

	            eventKey += name;

	            var catchAllHandler = this._handlers['*+' + name];

	            if (catchAllHandler) {
	                catchAllHandler.call(this._observer, e, eventKey);
	            }

	            var handler = this._handlers[eventKey];

	            if (handler) {
	                handler.call(this._observer, e, eventKey);
	            }
	        },

	        on: function(event, callback) {
	            var handlers = this._handlers;

	            if (typeof callback === "string") {
	                callback = this._observer[callback];
	            }

	            if (typeof event === "string") {
	                event = event.split(",");
	            }

	            event.forEach(function(e) {
	                handlers[e] = callback;
	            });
	        },

	        destroy: function() {
	            this.target.off("keydown", this.keyDownProxy);
	            this.target.off("keydown", this.mouseProxy);
	            $(document.documentElement).off("mousemove mouseup", this.mouseProxy);
	        }
	    });

	    kendo.spreadsheet.EventListener = EventListener;
	})(window.kendo);
	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ }),

/***/ "zO4I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v16.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = __webpack_require__("pQ38");
var context_1 = __webpack_require__("RQ1/");
var dragAndDropService_1 = __webpack_require__("I/uN");
var eventKeys_1 = __webpack_require__("+Y9o");
var utils_1 = __webpack_require__("IRr6");
var beanStub_1 = __webpack_require__("xffp");
var RowDragComp = (function (_super) {
    __extends(RowDragComp, _super);
    function RowDragComp(rowNode, column, cellValue, beans) {
        var _this = _super.call(this, "<span class=\"ag-row-drag\"></span>") || this;
        _this.rowNode = rowNode;
        _this.column = column;
        _this.cellValue = cellValue;
        _this.beans = beans;
        return _this;
    }
    RowDragComp.prototype.postConstruct = function () {
        this.addDragSource();
        this.checkCompatibility();
        if (this.beans.gridOptionsWrapper.isRowDragManaged()) {
            this.addFeature(this.beans.context, new ManagedVisibilityStrategy(this, this.beans, this.rowNode, this.column));
        }
        else {
            this.addFeature(this.beans.context, new NonManagedVisibilityStrategy(this, this.beans, this.rowNode, this.column));
        }
    };
    // returns true if all compatibility items work out
    RowDragComp.prototype.checkCompatibility = function () {
        var managed = this.beans.gridOptionsWrapper.isRowDragManaged();
        var treeData = this.beans.gridOptionsWrapper.isTreeData();
        if (treeData && managed) {
            utils_1._.doOnce(function () {
                return console.warn('ag-Grid: If using row drag with tree data, you cannot have rowDragManaged=true');
            }, 'RowDragComp.managedAndTreeData');
        }
    };
    RowDragComp.prototype.addDragSource = function () {
        var _this = this;
        var dragItem = {
            rowNode: this.rowNode
        };
        var dragSource = {
            type: dragAndDropService_1.DragSourceType.RowDrag,
            eElement: this.getGui(),
            dragItemName: this.cellValue,
            dragItemCallback: function () { return dragItem; },
            dragStartPixels: 0
        };
        this.beans.dragAndDropService.addDragSource(dragSource, true);
        this.addDestroyFunc(function () { return _this.beans.dragAndDropService.removeDragSource(dragSource); });
    };
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RowDragComp.prototype, "postConstruct", null);
    return RowDragComp;
}(component_1.Component));
exports.RowDragComp = RowDragComp;
// when non managed, the visibility depends on suppressRowDrag property only
var NonManagedVisibilityStrategy = (function (_super) {
    __extends(NonManagedVisibilityStrategy, _super);
    function NonManagedVisibilityStrategy(parent, beans, rowNode, column) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.beans = beans;
        _this.column = column;
        _this.rowNode = rowNode;
        return _this;
    }
    NonManagedVisibilityStrategy.prototype.postConstruct = function () {
        this.addDestroyableEventListener(this.beans.gridOptionsWrapper, 'suppressRowDrag', this.onSuppressRowDrag.bind(this));
        this.workOutVisibility();
    };
    NonManagedVisibilityStrategy.prototype.onSuppressRowDrag = function () {
        this.workOutVisibility();
    };
    NonManagedVisibilityStrategy.prototype.workOutVisibility = function () {
        // only show the drag if both sort and filter are not present
        var suppressRowDrag = this.beans.gridOptionsWrapper.isSuppressRowDrag();
        if (suppressRowDrag) {
            this.parent.setVisible(false);
        }
        else {
            var visible = this.column.isRowDrag(this.rowNode);
            this.parent.setVisible(visible);
        }
    };
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NonManagedVisibilityStrategy.prototype, "postConstruct", null);
    return NonManagedVisibilityStrategy;
}(beanStub_1.BeanStub));
// when managed, the visibility depends on sort, filter and row group, as well as suppressRowDrag property
var ManagedVisibilityStrategy = (function (_super) {
    __extends(ManagedVisibilityStrategy, _super);
    function ManagedVisibilityStrategy(parent, beans, rowNode, column) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.beans = beans;
        _this.column = column;
        _this.rowNode = rowNode;
        return _this;
    }
    ManagedVisibilityStrategy.prototype.postConstruct = function () {
        // we do not show the component if sort, filter or grouping is active
        this.addDestroyableEventListener(this.beans.eventService, eventKeys_1.Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
        this.addDestroyableEventListener(this.beans.eventService, eventKeys_1.Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
        this.addDestroyableEventListener(this.beans.eventService, eventKeys_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onRowGroupChanged.bind(this));
        this.addDestroyableEventListener(this.beans.gridOptionsWrapper, 'suppressRowDrag', this.onSuppressRowDrag.bind(this));
        this.updateSortActive();
        this.updateFilterActive();
        this.updateRowGroupActive();
        this.workOutVisibility();
    };
    ManagedVisibilityStrategy.prototype.updateRowGroupActive = function () {
        var rowGroups = this.beans.columnController.getRowGroupColumns();
        this.rowGroupActive = !utils_1._.missingOrEmpty(rowGroups);
    };
    ManagedVisibilityStrategy.prototype.onRowGroupChanged = function () {
        this.updateRowGroupActive();
        this.workOutVisibility();
    };
    ManagedVisibilityStrategy.prototype.updateSortActive = function () {
        var sortModel = this.beans.sortController.getSortModel();
        this.sortActive = !utils_1._.missingOrEmpty(sortModel);
    };
    ManagedVisibilityStrategy.prototype.onSortChanged = function () {
        this.updateSortActive();
        this.workOutVisibility();
    };
    ManagedVisibilityStrategy.prototype.updateFilterActive = function () {
        this.filterActive = this.beans.filterManager.isAnyFilterPresent();
    };
    ManagedVisibilityStrategy.prototype.onFilterChanged = function () {
        this.updateFilterActive();
        this.workOutVisibility();
    };
    ManagedVisibilityStrategy.prototype.onSuppressRowDrag = function () {
        this.workOutVisibility();
    };
    ManagedVisibilityStrategy.prototype.workOutVisibility = function () {
        // only show the drag if both sort and filter are not present
        var sortOrFilterOrGroupActive = this.sortActive || this.filterActive || this.rowGroupActive;
        var suppressRowDrag = this.beans.gridOptionsWrapper.isSuppressRowDrag();
        var alwaysHide = sortOrFilterOrGroupActive || suppressRowDrag;
        if (alwaysHide) {
            this.parent.setVisible(false);
        }
        else {
            var visible = this.column.isRowDrag(this.rowNode);
            this.parent.setVisible(visible);
        }
    };
    __decorate([
        context_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ManagedVisibilityStrategy.prototype, "postConstruct", null);
    return ManagedVisibilityStrategy;
}(beanStub_1.BeanStub));


/***/ }),

/***/ "zObk":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1353);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1054:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("CRfZ");

/***/ }),

/***/ 1092:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("apSr");

/***/ }),

/***/ 1191:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("1Z35");

/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1354), __webpack_require__(1092), __webpack_require__(1191), __webpack_require__(1355), __webpack_require__(1054) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "pivot.fieldmenu",
	    name: "PivotFieldMenu",
	    category: "web",
	    description: "The PivotFieldMenu widget allows the user to filter on fields displayed in PivotGrid",
	    depends: [ "menu", "window", "treeview", "dropdownlist" ],
	    advanced: true
	};

	/*jshint eqnull: true*/
	(function($, undefined) {
	    var kendo = window.kendo;
	    var ui = kendo.ui;
	    var MENU = "kendoContextMenu";
	    var proxy = $.proxy;
	    var NS = ".kendoPivotFieldMenu";
	    var Widget = ui.Widget;
	    var FILTER_ITEM = "k-filter-item";
	    var ARIA_LABEL = "aria-label";

	    var PivotFieldMenu = Widget.extend({
	        init: function(element, options) {
	            Widget.fn.init.call(this, element, options);

	            this._dataSource();

	            this._layout();

	            kendo.notify(this);
	        },

	        events: [],

	        options: {
	            name: "PivotFieldMenu",
	            filter: null,
	            filterable: true,
	            sortable: true,
	            messages: {
	                info: "Show items with value that:",
	                sortAscending: "Sort Ascending",
	                sortDescending: "Sort Descending",
	                filterFields: "Fields Filter",
	                filter: "Filter",
	                include: "Include Fields...",
	                title: "Fields to include",
	                clear: "Clear",
	                ok: "OK",
	                cancel: "Cancel",
	                operators: {
	                    contains: "Contains",
	                    doesnotcontain: "Does not contain",
	                    startswith: "Starts with",
	                    endswith: "Ends with",
	                    eq: "Is equal to",
	                    neq: "Is not equal to"
	                }
	            }
	        },

	        _layout: function() {
	            var options = this.options;

	            this.wrapper = $(kendo.template(MENUTEMPLATE)({
	                ns: kendo.ns,
	                filterable: options.filterable,
	                sortable: options.sortable,
	                messages: options.messages
	            }));

	            this.menu = this.wrapper[MENU]({
	                filter: options.filter,
	                target: this.element,
	                orientation: "vertical",
	                showOn: "click",
	                closeOnClick: false,
	                open: proxy(this._menuOpen, this),
	                select: proxy(this._select, this),
	                copyAnchorStyles: false
	            }).data(MENU);

	            this._createWindow();

	            if (options.filterable) {
	                this._initFilterForm();
	            }
	        },

	        _initFilterForm: function() {
	            var filterForm = this.menu.element.find("." + FILTER_ITEM);
	            var filterProxy = proxy(this._filter, this);

	            this._filterOperator = new kendo.ui.DropDownList(filterForm.find("select"));
	            this._filterValue = filterForm.find(".k-textbox");
	            this._updateFilterAriaLabel();

	            filterForm
	                .on("submit" + NS, filterProxy)
	                .on("click" + NS, ".k-button-filter", filterProxy)
	                .on("click" + NS, ".k-button-clear", proxy(this._reset, this));
	        },

	        _setFilterForm: function(expression) {
	            var filterOperator = this._filterOperator;
	            var operator = "";
	            var value = "";

	            if (expression) {
	                operator = expression.operator;
	                value = expression.value;
	            }

	            filterOperator.value(operator);
	            if (!filterOperator.value()) {
	                filterOperator.select(0);
	            }

	            this._filterValue.val(value);
	        },

	        _clearFilters: function(member) {
	            var filter = this.dataSource.filter() || {};
	            var expressions;
	            var idx = 0;
	            var length;

	            filter.filters = filter.filters || [];
	            expressions = findFilters(filter, member);

	            for (length = expressions.length; idx < length; idx++) {
	                filter.filters.splice(filter.filters.indexOf(expressions[idx]), 1);
	            }

	            return filter;
	        },

	        _convert: function(value) {
	            var schema = this.dataSource.options.schema;
	            var field = ((schema.model || {}).fields || {})[this.currentMember];

	            if (field) {
	                if (field.type === "number") {
	                    value = parseFloat(value);
	                } else if (field.type === "boolean") {
	                    value = Boolean($.parseJSON(value));
	                }
	            }

	            return value;
	        },

	        _filter: function(e) {
	            var that = this;
	            var value = that._convert(that._filterValue.val());

	            e.preventDefault();

	            if (value === "") {
	                that.menu.close();
	                return;
	            }

	            var expression = {
	                field: that.currentMember,
	                operator: that._filterOperator.value(),
	                value: value
	            };
	            var filter = that._clearFilters(that.currentMember);

	            filter.filters.push(expression);

	            that.dataSource.filter(filter);
	            that.menu.close();
	        },

	        _updateFilterAriaLabel: function () {
	            var filterForm = this.menu.element.find("." + FILTER_ITEM);
	            var selectedOperator = this._filterOperator.value();
	            var selectedOperatorName = this.options.messages.operators[selectedOperator];

	            filterForm.find("select").attr(ARIA_LABEL, selectedOperatorName);
	        },

	        _reset: function(e) {
	            var that = this;
	            var filter = that._clearFilters(that.currentMember);

	            e.preventDefault();

	            if (!filter.filters[0]) {
	                filter = {};
	            }

	            that.dataSource.filter(filter);
	            that._setFilterForm(null);
	            that.menu.close();
	        },

	        _sort: function(dir) {
	            var field = this.currentMember;
	            var expressions = (this.dataSource.sort() || []);

	            expressions = removeExpr(expressions, field);
	            expressions.push({
	                field: field,
	                dir: dir
	            });

	            this.dataSource.sort(expressions);
	            this.menu.close();
	        },

	        setDataSource: function(dataSource) {
	            this.options.dataSource = dataSource;

	            this._dataSource();
	        },

	        _dataSource: function() {
	            this.dataSource = kendo.data.PivotDataSource.create(this.options.dataSource);
	        },

	        _createWindow: function() {
	            var messages = this.options.messages;

	            this.includeWindow = $(kendo.template(WINDOWTEMPLATE)({
	                messages: messages
	            }))
	            .on("click" + NS, ".k-button-ok", proxy(this._applyIncludes, this))
	            .on("click" + NS, ".k-button-cancel", proxy(this._closeWindow, this));

	            this.includeWindow = new ui.Window(this.includeWindow, {
	                title: messages.title,
	                visible: false,
	                resizable: false,
	                open: proxy(this._windowOpen, this)
	            });
	        },

	        _applyIncludes: function(e) {
	            var checkedNodes = [];
	            var resultExpression;
	            var view = this.treeView.dataSource.view();
	            var rootChecked = view[0].checked;
	            var filter = this.dataSource.filter();
	            var existingExpression = findFilters(filter, this.currentMember, "in")[0];

	            checkedNodeIds(view, checkedNodes);

	            if (existingExpression) {
	                if (rootChecked) {
	                    filter.filters.splice(filter.filters.indexOf(existingExpression), 1);
	                    if (!filter.filters.length) {
	                        filter = {};
	                    }
	                } else {
	                    existingExpression.value = checkedNodes.join(",");
	                }

	                resultExpression = filter;
	            }

	            if (checkedNodes.length) {
	                if (!resultExpression && !rootChecked) {
	                    resultExpression = {
	                        field: this.currentMember,
	                        operator: "in",
	                        value: checkedNodes.join(",")
	                    };

	                    if (filter) {
	                        filter.filters.push(resultExpression);
	                        resultExpression = filter;
	                    }
	                }
	            }

	            if (resultExpression) {
	                this.dataSource.filter(resultExpression);
	            }

	            this._closeWindow(e);
	        },

	        _closeWindow: function(e) {
	            e.preventDefault();

	            this.includeWindow.close();
	        },

	        _treeViewDataSource: function() {
	            var that = this;

	            return kendo.data.HierarchicalDataSource.create({
	                schema: {
	                    model: {
	                        id: "uniqueName",
	                        hasChildren: function(item) {
	                            return parseInt(item.childrenCardinality, 10) > 0;
	                        }
	                    }
	                },
	                transport: {
	                    read: function(options) {
	                        var restrictions = {};
	                        var node = that.treeView.dataSource.get(options.data.uniqueName);
	                        var name = options.data.uniqueName;

	                        if (!name) {
	                            restrictions.levelUniqueName = that.currentMember + ".[(ALL)]";
	                        } else {
	                            restrictions.memberUniqueName = node.uniqueName.replace(/\&/g, "&amp;");
	                            restrictions.treeOp = 1;
	                        }

	                        that.dataSource
	                            .schemaMembers(restrictions)
	                            .done(function (data) {
	                                checkNodes(that.dataSource.filter(), that.currentMember, data);

	                                options.success(data);
	                            })
	                            .fail(options.error);
	                    }
	                }
	            });
	        },

	        _createTreeView: function(element) {
	            var that = this;

	            that.treeView =  new ui.TreeView(element, {
	                autoBind: false,
	                dataSource: that._treeViewDataSource(),
	                dataTextField: "caption",
	                template: "#: data.item.caption || data.item.name #",
	                checkboxes: {
	                    checkChildren: true
	                },
	                dataBound: function() {
	                    ui.progress(that.includeWindow.element, false);
	                }
	            });
	        },

	        _menuOpen: function(e) {
	            if (!e.event) {
	                return;
	            }

	            var attr = kendo.attr("name");

	            this.currentMember = $(e.event.target).closest("[" + attr + "]").attr(attr);

	            if (this.options.filterable) {
	                this._setFilterForm(findFilters(this.dataSource.filter(), this.currentMember)[0]);
	            }
	        },

	        _select: function(e) {
	            var item = $(e.item);

	            $(".k-pivot-filter-window").not(this.includeWindow.element).kendoWindow("close");

	            if (item.hasClass("k-include-item")) {
	                this.includeWindow.center().open();
	            } else if (item.hasClass("k-sort-asc")) {
	                this._sort("asc");
	            } else if (item.hasClass("k-sort-desc")) {
	                this._sort("desc");
	            } else if (item.hasClass(FILTER_ITEM)) {
	                this._updateFilterAriaLabel();
	            }
	        },

	        _windowOpen: function() {
	            if (!this.treeView) {
	                this._createTreeView(this.includeWindow.element.find(".k-treeview"));
	            }

	            ui.progress(this.includeWindow.element, true);
	            this.treeView.dataSource.read();
	        },

	        destroy: function() {
	            Widget.fn.destroy.call(this);

	            if (this.menu) {
	                this.menu.destroy();
	                this.menu = null;
	            }

	            if (this.treeView) {
	                this.treeView.destroy();
	                this.treeView = null;
	            }

	            if (this.includeWindow) {
	                this.includeWindow.destroy();
	                this.includeWindow = null;
	            }

	            this.wrapper = null;
	            this.element = null;
	        }
	    });

	    function removeExpr(expressions, name) {
	        var result = [];

	        for (var idx = 0, length = expressions.length; idx < length; idx++) {
	            if (expressions[idx].field !== name) {
	                result.push(expressions[idx]);
	            }
	        }

	        return result;
	    }

	    function findFilters(filter, member, operator) {
	        if (!filter) {
	            return [];
	        }

	        filter = filter.filters;

	        var idx = 0;
	        var result = [];
	        var length = filter.length;
	        var filterOperator;

	        for ( ; idx < length; idx++) {
	            filterOperator = filter[idx].operator;

	            if (((!operator && filterOperator !== "in") || (filterOperator === operator)) && filter[idx].field === member) {
	                result.push(filter[idx]);
	            }
	        }

	        return result;
	    }

	    function checkNodes(filter, member, nodes) {
	        var values, idx = 0, length = nodes.length;
	        filter = findFilters(filter, member, "in")[0];

	        if (!filter) {
	            for (; idx < length; idx++) {
	                nodes[idx].checked = true;
	            }
	        } else {
	            values = filter.value.split(",");
	            for (; idx < length; idx++) {
	                nodes[idx].checked = $.inArray(nodes[idx].uniqueName, values) >= 0;
	            }
	        }
	    }

	    function checkedNodeIds(nodes, checkedNodes) {
	        var idx, length = nodes.length;

	        for (idx = 0; idx < length; idx++) {
	            if (nodes[idx].checked && nodes[idx].level() !== 0) {
	                checkedNodes.push(nodes[idx].uniqueName);
	            }

	            if (nodes[idx].hasChildren) {
	                checkedNodeIds(nodes[idx].children.view(), checkedNodes);
	            }
	        }
	    }

	    var LABELMENUTEMPLATE =
	        '<div class="k-filterable k-content" tabindex="-1" data-role="fieldmenu">' +
	            '<form class="k-filter-menu">' +
	                '<div class="k-filter-menu-container">' +
	                    '<div class="k-filter-help-text">#=messages.info#</div>'+
	                    '<select>'+
	                        '#for(var op in messages.operators){#'+
	                            '<option value="#=op#">#=messages.operators[op]#</option>' +
	                        '#}#'+
	                    '</select>'+
	                    '<input class="k-textbox" type="text" ' + ARIA_LABEL + '="#=messages.filter#" title="#=messages.filter#" />'+
	                    '<div class="k-action-buttons">'+
	                    '<a class="k-button k-primary k-button-filter" href="\\#">#=messages.filter#</a>'+
	                    '<a class="k-button k-button-clear" href="\\#">#=messages.clear#</a>'+
	                    '</div>'+
	                '</div>' +
	            '</form>' +
	        '</div>';

	    var MENUTEMPLATE = '<ul class="k-pivot-fieldmenu">'+
	                        '# if (sortable) {#'+
	                        '<li class="k-item k-menu-item k-sort-asc">'+
	                            '<span class="k-link k-menu-link">'+
	                                '<span class="k-icon k-i-sort-asc-sm"></span>'+
	                                '${messages.sortAscending}'+
	                            '</span>'+
	                        '</li>'+
	                        '<li class="k-item k-menu-item k-sort-desc">'+
	                            '<span class="k-link k-menu-link">'+
	                                '<span class="k-icon k-i-sort-desc-sm"></span>'+
	                                '${messages.sortDescending}'+
	                            '</span>'+
	                        '</li>'+
	                            '# if (filterable) {#'+
	                            '<li class="k-separator"></li>'+
	                            '# } #'+
	                        '# } #'+
	                        '# if (filterable) {#'+
	                        '<li class="k-item k-menu-item k-include-item">'+
	                            '<span class="k-link k-menu-link">'+
	                                '<span class="k-icon k-i-filter"></span>'+
	                                '${messages.include}'+
	                            '</span>'+
	                        '</li>'+
	                        '<li class="k-separator"></li>'+
	                        '<li class="k-item k-menu-item ' + FILTER_ITEM + '">'+
	                            '<span class="k-link k-menu-link">'+
	                                '<span class="k-icon k-i-filter"></span>'+
	                                '${messages.filterFields}'+
	                            '</span>'+
	                            '<ul>'+
	                                '<li>' + LABELMENUTEMPLATE + '</li>'+
	                            '</ul>'+
	                        '</li>'+
	                        '# } #'+
	                    '</ul>';

	    var WINDOWTEMPLATE = '<div class="k-popup-edit-form k-pivot-filter-window"><div class="k-edit-form-container">'+
	                            '<div class="k-treeview"></div>'+
	                            '<div class="k-edit-buttons k-state-default">'+
	                            '<a class="k-button k-primary k-button-ok" href="\\#">'+
	                                '${messages.ok}'+
	                            '</a>'+
	                            '<a class="k-button k-button-cancel" href="\\#">'+
	                                '${messages.cancel}'+
	                            '</a>'+
	                        '</div></div>';

	    ui.plugin(PivotFieldMenu);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1354:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("YlOY");

/***/ }),

/***/ 1355:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("ed5Q");

/***/ })

/******/ });

/***/ }),

/***/ "zQR9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("h65t")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("vIB/")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "zQRd":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1165);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("MCuu");

/***/ }),

/***/ 1165:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1166), __webpack_require__(1086),  __webpack_require__(1167) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	var __meta__ = { // jshint ignore:line
	    id: "datepicker",
	    name: "DatePicker",
	    category: "web",
	    description: "The DatePicker widget allows the user to select a date from a calendar or by direct input.",
	    depends: [ "calendar", "popup" ]
	};

	(function($, undefined) {
	    var kendo = window.kendo,
	    ui = kendo.ui,
	    Widget = ui.Widget,
	    parse = kendo.parseDate,
	    keys = kendo.keys,
	    support = kendo.support,
	    template = kendo.template,
	    activeElement = kendo._activeElement,
	    DIV = "<div />",
	    SPAN = "<span />",
	    ns = ".kendoDatePicker",
	    CLICK = "click" + ns,
	    UP = support.mouseAndTouchPresent ? kendo.applyEventMap("up", ns.slice(1)) : CLICK,
	    OPEN = "open",
	    CLOSE = "close",
	    CHANGE = "change",
	    DISABLED = "disabled",
	    READONLY = "readonly",
	    DEFAULT = "k-state-default",
	    FOCUSED = "k-state-focused",
	    SELECTED = "k-state-selected",
	    STATEDISABLED = "k-state-disabled",
	    HOVER = "k-state-hover",
	    HOVEREVENTS = "mouseenter" + ns + " mouseleave" + ns,
	    MOUSEDOWN = "mousedown" + ns,
	    ID = "id",
	    MIN = "min",
	    MAX = "max",
	    MONTH = "month",
	    ARIA_DISABLED = "aria-disabled",
	    ARIA_READONLY = "aria-readonly",
	    ARIA_EXPANDED = "aria-expanded",
	    ARIA_HIDDEN = "aria-hidden",
	    calendar = kendo.calendar,
	    isInRange = calendar.isInRange,
	    restrictValue = calendar.restrictValue,
	    isEqualDatePart = calendar.isEqualDatePart,
	    extend = $.extend,
	    proxy = $.proxy,
	    DATE = Date;

	    function normalize(options) {
	        var parseFormats = options.parseFormats,
	            format = options.format;

	        calendar.normalize(options);


	        parseFormats = $.isArray(parseFormats) ? parseFormats : [parseFormats];

	        if (!parseFormats.length) {
	            parseFormats.push("yyyy-MM-dd");
	        }

	        if ($.inArray(format, parseFormats) === -1) {
	            parseFormats.splice(0, 0, options.format);
	        }

	        options.parseFormats = parseFormats;
	    }

	    function preventDefault(e) {
	        e.preventDefault();
	    }

	    var DateView = function(options) {
	        var that = this, id,
	            body = document.body,
	            div = $(DIV).attr(ARIA_HIDDEN, "true")
	                        .addClass("k-calendar-container");

	        that.options = options = options || {};
	        id = options.id;

	        if(!options.omitPopup){
	            div.appendTo(body);
	            that.popup = new ui.Popup(div, extend(options.popup, options, { name: "Popup", isRtl: kendo.support.isRtl(options.anchor) }));
	        } else {
	            div = options.dateDiv;
	        }
	        if (id) {
	            id += "_dateview";

	            div.attr(ID, id);
	            that._dateViewID = id;
	        }
	        that.div = div;

	        that.value(options.value);
	    };

	    DateView.prototype = {
	        _calendar: function() {
	            var that = this;
	            var calendar = that.calendar;
	            var options = that.options;
	            var div;

	            if (!calendar) {
	                div = $(DIV).attr(ID, kendo.guid())
	                            .appendTo(options.omitPopup ? options.dateDiv : that.popup.element)
	                            .on(MOUSEDOWN, preventDefault)
	                            .on(CLICK, "td:has(.k-link)", proxy(that._click, that));

	                that.calendar = calendar = new ui.Calendar(div, { componentType: options.componentType });
	                that._setOptions(options);

	                kendo.calendar.makeUnselectable(calendar.element);

	                calendar.navigate(that._value || that._current, options.start);

	                that.value(that._value);
	            }
	        },

	        _setOptions: function(options) {
	            this.calendar.setOptions({
	                focusOnNav: false,
	                change: options.change,
	                culture: options.culture,
	                dates: options.dates,
	                depth: options.depth,
	                footer: options.footer,
	                format: options.format,
	                max: options.max,
	                min: options.min,
	                month: options.month,
	                weekNumber: options.weekNumber,
	                start: options.start,
	                disableDates: options.disableDates
	            });
	        },

	        setOptions: function(options) {
	            var old = this.options;
	            var disableDates = options.disableDates;

	            if (disableDates) {
	                options.disableDates = calendar.disabled(disableDates);
	            }

	            this.options = extend(old, options, {
	                change: old.change,
	                close: old.close,
	                open: old.open
	            });

	            if (this.calendar) {
	                this._setOptions(this.options);
	            }
	        },

	        destroy: function() {
	            if(this.popup){
	                this.popup.destroy();
	            }
	        },

	        open: function() {
	            var that = this;
	            var popupHovered;

	            that._calendar();

	            // In some cases when the popup is opened resize is triggered which will cause it to close
	            // Setting the below flag will prevent this from happening
	            // Reference: https://github.com/telerik/kendo/pull/7553
	            popupHovered = that.popup._hovered;
	            that.popup._hovered = true;

	            that.popup.open();

	            setTimeout(function() {
	                that.popup._hovered = popupHovered;
	            }, 1);
	        },

	        close: function() {
	            this.popup.close();
	        },

	        min: function(value) {
	            this._option(MIN, value);
	        },

	        max: function(value) {
	            this._option(MAX, value);
	        },

	        toggle: function() {
	            var that = this;

	            that[that.popup.visible() ? CLOSE : OPEN]();
	        },

	        move: function(e) {
	            var that = this,
	                key = e.keyCode,
	                calendar = that.calendar,
	                selectIsClicked = e.ctrlKey && key == keys.DOWN || key == keys.ENTER,
	                handled = false;

	            if (e.altKey) {
	                if (key == keys.DOWN) {
	                    that.open();
	                    e.preventDefault();
	                    handled = true;
	                } else if (key == keys.UP) {
	                    that.close();
	                    e.preventDefault();
	                    handled = true;
	                }

	            } else if (that.popup && that.popup.visible()) {

	                if (key == keys.ESC || (selectIsClicked && calendar._cell.hasClass(SELECTED))) {
	                    that.close();
	                    e.preventDefault();
	                    return true;
	                }
	                //spacebar selects a date in the calendar
	                if (key != keys.SPACEBAR) {
	                    that._current = calendar._move(e);
	                }

	                handled = true;
	            }

	            return handled;
	        },

	        current: function(date) {
	            this._current = date;
	            if (this.calendar) {
	                this.calendar._focus(date);
	            }
	        },

	        value: function(value) {
	            var that = this,
	                calendar = that.calendar,
	                options = that.options,
	                disabledDate = options.disableDates;

	            if (disabledDate && disabledDate(value)) {
	                value = null;
	            }

	            that._value = value;
	            that._current = new DATE(+restrictValue(value, options.min, options.max));

	            if (calendar) {
	                calendar.value(value);
	            }
	        },

	        _click: function(e) {

	            if (e.currentTarget.className.indexOf(SELECTED) !== -1) {
	                this.calendar.trigger("change");
	                this.close();
	            }
	        },

	        _option: function(option, value) {
	            var that = this;
	            var calendar = that.calendar;

	            that.options[option] = value;

	            if (calendar) {
	                calendar[option](value);
	            }
	        }
	    };

	    DateView.normalize = normalize;

	    kendo.DateView = DateView;

	    var DatePicker = Widget.extend({
	        init: function(element, options) {
	            var that = this,
	                disabled,
	                div;

	            Widget.fn.init.call(that, element, options);
	            element = that.element;
	            options = that.options;

	            options.disableDates = kendo.calendar.disabled(options.disableDates);

	            options.min = parse(element.attr("min")) || parse(options.min);
	            options.max = parse(element.attr("max")) || parse(options.max);

	            normalize(options);

	            that._initialOptions = extend({}, options);

	            that._wrapper();

	            that.dateView = new DateView(extend({}, options, {
	                id: element.attr(ID),
	                anchor: that.wrapper,
	                change: function() {
	                    // calendar is the current scope
	                    that._change(this.value());
	                    that.close();
	                },
	                close: function(e) {
	                    if (that.trigger(CLOSE)) {
	                        e.preventDefault();
	                    } else {
	                        element.attr(ARIA_EXPANDED, false);
	                        div.attr(ARIA_HIDDEN, true);
	                    }
	                },
	                open: function(e) {
	                    var options = that.options,
	                        date;

	                    if (that.trigger(OPEN)) {
	                        e.preventDefault();
	                    } else {
	                        if (that.element.val() !== that._oldText) {
	                            date = parse(element.val(), options.parseFormats, options.culture);

	                            that.dateView[date ? "current" : "value"](date);
	                        }

	                        element.attr(ARIA_EXPANDED, true);
	                        div.attr(ARIA_HIDDEN, false);

	                        that._updateARIA(date);

	                    }
	                }
	            }));
	            div = that.dateView.div;

	            that._icon();

	            try {
	                element[0].setAttribute("type", "text");
	            } catch(e) {
	                element[0].type = "text";
	            }

	            element
	                .addClass("k-input")
	                .attr({
	                    role: "combobox",
	                    "aria-expanded": false,
	                    "aria-owns": that.dateView._dateViewID,
	                    "autocomplete": "off"
	                });
	            that._reset();
	            that._template();

	            disabled = element.is("[disabled]") || $(that.element).parents("fieldset").is(':disabled');
	            if (disabled) {
	                that.enable(false);
	            } else {
	                that.readonly(element.is("[readonly]"));
	            }

	            that._createDateInput(options);

	            that._old = that._update(options.value || that.element.val());
	            that._oldText = element.val();

	            kendo.notify(that);
	        },
	        events: [
	        OPEN,
	        CLOSE,
	        CHANGE],
	        options: {
	            name: "DatePicker",
	            value: null,
	            footer: "",
	            format: "",
	            culture: "",
	            parseFormats: [],
	            min: new Date(1900, 0, 1),
	            max: new Date(2099, 11, 31),
	            start: MONTH,
	            depth: MONTH,
	            animation: {},
	            month: {},
	            dates: [],
	            disableDates: null,
	            ARIATemplate: 'Current focused date is #=kendo.toString(data.current, "D")#',
	            dateInput: false,
	            weekNumber: false,
	            componentType: "classic"
	        },

	        setOptions: function(options) {
	            var that = this;
	            var value = that._value;

	            Widget.fn.setOptions.call(that, options);

	            options = that.options;

	            options.min = parse(options.min);
	            options.max = parse(options.max);

	            normalize(options);

	            that.dateView.setOptions(options);
	            that._createDateInput(options);

	            if (!that._dateInput) {
	                that.element.val(kendo.toString(value, options.format, options.culture));
	            }

	            if (value) {
	                that._updateARIA(value);
	            }
	        },

	        _editable: function(options) {
	            var that = this,
	                icon = that._dateIcon.off(ns),
	                element = that.element.off(ns),
	                wrapper = that._inputWrapper.off(ns),
	                readonly = options.readonly,
	                disable = options.disable;

	            if (!readonly && !disable) {
	                wrapper
	                    .addClass(DEFAULT)
	                    .removeClass(STATEDISABLED)
	                    .on(HOVEREVENTS, that._toggleHover);
	                if(element && element.length) {
	                    element[0].removeAttribute(DISABLED);
	                    element[0].removeAttribute(READONLY);
	                }
	                element.attr(ARIA_DISABLED, false)
	                       .attr(ARIA_DISABLED, false)
	                       .on("keydown" + ns, proxy(that._keydown, that))
	                       .on("focusout" + ns, proxy(that._blur, that))
	                       .on("focus" + ns, function() {
	                           that._inputWrapper.addClass(FOCUSED);
	                       });

	               icon.on(UP, proxy(that._click, that))
	                   .on(MOUSEDOWN, preventDefault);
	            } else {
	                wrapper
	                    .addClass(disable ? STATEDISABLED : DEFAULT)
	                    .removeClass(disable ? DEFAULT : STATEDISABLED);

	                element.attr(DISABLED, disable)
	                       .attr(READONLY, readonly)
	                       .attr(ARIA_DISABLED, disable)
	                       .attr(ARIA_READONLY, readonly);
	            }
	        },

	        readonly: function(readonly) {
	            this._editable({
	                readonly: readonly === undefined ? true : readonly,
	                disable: false
	            });
	            if (this._dateInput) {
	                this._dateInput._editable({
	                    readonly: readonly === undefined ? true : readonly,
	                    disable: false
	                });
	            }
	        },

	        enable: function(enable) {
	            this._editable({
	                readonly: false,
	                disable: !(enable = enable === undefined ? true : enable)
	            });
	            if (this._dateInput) {
	                this._dateInput._editable({
	                    readonly: false,
	                    disable: !(enable = enable === undefined ? true : enable)
	                });
	            }
	        },

	        destroy: function() {
	            var that = this;

	            Widget.fn.destroy.call(that);

	            that.dateView.destroy();

	            that.element.off(ns);
	            that._dateIcon.off(ns);
	            that._inputWrapper.off(ns);

	            if (that._form) {
	                that._form.off("reset", that._resetHandler);
	            }
	        },

	        open: function() {
	            this.dateView.open();
	        },

	        close: function() {
	            this.dateView.close();
	        },

	        min: function(value) {
	            return this._option(MIN, value);
	        },

	        max: function(value) {
	            return this._option(MAX, value);
	        },

	        value: function(value) {
	            var that = this;

	            if (value === undefined) {
	                return that._value;
	            }

	            that._old = that._update(value);

	            if (that._old === null && !that._dateInput) {
	                that.element.val("");
	            }

	            that._oldText = that.element.val();
	        },

	        _toggleHover: function(e) {
	            $(e.currentTarget).toggleClass(HOVER, e.type === "mouseenter");
	        },

	        _blur: function() {
	            var that = this,
	                value = that.element.val();

	            that.close();
	            if (value !== that._oldText) {
	                that._change(value);
	                if (!value) {
	                    that.dateView.current(kendo.calendar.getToday());
	                }
	            }

	            that._inputWrapper.removeClass(FOCUSED);
	        },

	        _click: function(e) {
	            var that = this;

	            that.dateView.toggle();
	            that._focusElement(e.type);
	        },

	        _focusElement: function(eventType) {
	            var element = this.element;

	            if ((!support.touch || (support.mouseAndTouchPresent && !(eventType || "").match(/touch/i))) && element[0] !== activeElement()) {
	                element.trigger("focus");
	            }
	        },

	        _change: function(value) {
	            var that = this,
	            oldValue = that.element.val(),
	            dateChanged;

	            value = that._update(value);
	            dateChanged = !kendo.calendar.isEqualDate(that._old, value);

	            var valueUpdated = dateChanged && !that._typing;
	            var textFormatted = oldValue !== that.element.val();

	            if (valueUpdated || textFormatted) {
	                that.element.trigger(CHANGE);
	            }

	            if (dateChanged) {
	                that._old = value;
	                that._oldText = that.element.val();

	                that.trigger(CHANGE);
	            }

	            that._typing = false;
	        },

	        _keydown: function(e) {
	            var that = this,
	                dateView = that.dateView,
	                value = that.element.val(),
	                handled = false;

	            if (!dateView.popup.visible() && e.keyCode == keys.ENTER && value !== that._oldText) {
	                that._change(value);
	            } else {
	                handled = dateView.move(e);
	                that._updateARIA(dateView._current);

	                if (!handled) {
	                    that._typing = true;
	                } else if (that._dateInput && e.stopImmediatePropagation) {
	                    e.stopImmediatePropagation();
	                }
	            }
	        },

	        _icon: function() {
	            var that = this,
	                element = that.element,
	                icon;

	            icon = element.next("span.k-select");

	            if (!icon[0]) {
	                icon = $('<span unselectable="on" class="k-select" aria-label="select"><span class="k-icon k-i-calendar"></span></span>').insertAfter(element);
	            }

	            that._dateIcon = icon.attr({
	                "role": "button",
	                "aria-controls": that.dateView._dateViewID
	            });
	        },

	        _option: function(option, value) {
	            var that = this,
	                options = that.options;

	            if (value === undefined) {
	                return options[option];
	            }

	            value = parse(value, options.parseFormats, options.culture);

	            if (!value) {
	                return;
	            }

	            options[option] = new DATE(+value);
	            that.dateView[option](value);
	        },

	        _update: function(value) {
	            var that = this,
	                options = that.options,
	                min = options.min,
	                max = options.max,
	                current = that._value,
	                date = parse(value, options.parseFormats, options.culture),
	                isSameType = (date === null && current === null) || (date instanceof Date && current instanceof Date),
	                formattedValue;

	            if (options.disableDates(date)) {
	                date = null;
	                if (!that._old && !that.element.val()) {
	                    value = null;
	                }
	            }

	            if (+date === +current && isSameType) {
	                formattedValue = kendo.toString(date, options.format, options.culture);

	                if (formattedValue !== value && !(that._dateInput && !date)) {
	                    that.element.val(date === null ? value : formattedValue);
	                }

	                return date;
	            }

	            if (date !== null && isEqualDatePart(date, min)) {
	                date = restrictValue(date, min, max);
	            } else if (!isInRange(date, min, max)) {
	                date = null;
	            }

	            that._value = date;
	            that.dateView.value(date);
	            if (that._dateInput && date) {
	                that._dateInput.value(date || value);
	            } else {
	                that.element.val(kendo.toString(date || value, options.format, options.culture));
	            }
	            that._updateARIA(date);

	            return date;
	        },

	        _wrapper: function() {
	            var that = this,
	                element = that.element,
	                wrapper;

	            wrapper = element.parents(".k-datepicker");

	            if (!wrapper[0]) {
	                wrapper = element.wrap(SPAN).parent().addClass("k-picker-wrap k-state-default");
	                wrapper = wrapper.wrap(SPAN).parent();
	            }

	            wrapper[0].style.cssText = element[0].style.cssText;
	            element.css({
	                width: "100%",
	                height: element[0].style.height
	            });

	            that.wrapper = wrapper.addClass("k-widget k-datepicker")
	                .addClass(element[0].className).removeClass('input-validation-error');

	            that._inputWrapper = $(wrapper[0].firstChild);
	        },

	        _reset: function() {
	            var that = this,
	                element = that.element,
	                formId = element.attr("form"),
	                options = that.options,
	                disabledDate = options.disableDates,
	                parseFormats = options.parseFormats.length ? options.parseFormats : null,
	                optionsValue = that._initialOptions.value,
	                form = formId ? $("#" + formId) : element.closest("form"),
	                initialValue = element[0].defaultValue;

	            if (optionsValue && (disabledDate && disabledDate(optionsValue))) {
	                optionsValue = null;
	            }

	            if ((!initialValue || !kendo.parseDate(initialValue, parseFormats, options.culture)) && optionsValue) {
	                element.attr("value", kendo.toString(optionsValue, options.format, options.culture));
	            }

	            if (form[0]) {
	                that._resetHandler = function() {
	                    that.value(optionsValue || element[0].defaultValue);
	                    that.max(that._initialOptions.max);
	                    that.min(that._initialOptions.min);
	                };

	                that._form = form.on("reset", that._resetHandler);
	            }
	        },

	        _template: function() {
	            this._ariaTemplate = template(this.options.ARIATemplate);
	        },

	        _createDateInput: function(options) {
	            if (this._dateInput) {
	                this._dateInput.destroy();
	                this._dateInput = null;
	            }

	            if (options.dateInput ) {
	                this._dateInput = new ui.DateInput(this.element, {
	                    culture: options.culture,
	                    format: options.format,
	                    min: options.min,
	                    max: options.max
	                });
	            }
	        },

	        _updateARIA: function(date) {
	            var cell;
	            var that = this;
	            var calendar = that.dateView.calendar;
	            if(that.element && that.element.length) {
	                that.element[0].removeAttribute("aria-activedescendant");
	            }
	            if (calendar) {
	                cell = calendar._cell;
	                cell.attr("aria-label", that._ariaTemplate({ current: date || calendar.current() }));

	                that.element.attr("aria-activedescendant", cell.attr("id"));
	            }
	        }
	    });

	    ui.plugin(DatePicker);

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1166:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("f1E8");

/***/ }),

/***/ 1167:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("bfur");

/***/ })

/******/ });

/***/ }),

/***/ "zVEt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ag-grid-enterprise v16.0.1

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_1 = __webpack_require__("F6Mk");
var statusItem_1 = __webpack_require__("MXce");
var rangeController_1 = __webpack_require__("PH8O");
var StatusBar = (function (_super) {
    __extends(StatusBar, _super);
    function StatusBar() {
        var _this = _super.call(this, StatusBar_1.TEMPLATE) || this;
        _this.aggregationsComponent = new main_1.Component('<div class="ag-status-bar-aggregations"></div>');
        _this.infoLabel = new main_1.Component("<div class=\"ag-status-bar-info-label\"></div>");
        return _this;
    }
    StatusBar_1 = StatusBar;
    StatusBar.prototype.init = function () {
        // we want to hide until the first aggregation comes in
        this.setVisible(false);
        this.createStatusItems();
        this.eventService.addEventListener(main_1.Events.EVENT_RANGE_SELECTION_CHANGED, this.onRangeSelectionChanged.bind(this));
        this.eventService.addEventListener(main_1.Events.EVENT_MODEL_UPDATED, this.onRangeSelectionChanged.bind(this));
    };
    StatusBar.prototype.createStatusItems = function () {
        var _this = this;
        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
        this.statusItemSum = new statusItem_1.StatusItem(localeTextFunc('sum', 'Sum'));
        this.statusItemCount = new statusItem_1.StatusItem(localeTextFunc('count', 'Count'));
        this.statusItemMin = new statusItem_1.StatusItem(localeTextFunc('min', 'Min'));
        this.statusItemMax = new statusItem_1.StatusItem(localeTextFunc('max', 'Max'));
        this.statusItemAvg = new statusItem_1.StatusItem(localeTextFunc('average', 'Average'));
        this.forEachStatusItem(function (statusItem) {
            _this.context.wireBean(statusItem);
            _this.aggregationsComponent.appendChild(statusItem);
            statusItem.setVisible(false);
        });
        this.appendChild(this.infoLabel);
        this.appendChild(this.aggregationsComponent);
    };
    StatusBar.prototype.forEachStatusItem = function (callback) {
        [this.statusItemAvg, this.statusItemCount, this.statusItemMin, this.statusItemMax, this.statusItemSum].forEach(callback);
    };
    StatusBar.prototype.onRangeSelectionChanged = function () {
        var _this = this;
        var cellRanges = this.rangeController.getCellRanges();
        var sum = 0;
        var count = 0;
        var numberCount = 0;
        var min = null;
        var max = null;
        var cellsSoFar = {};
        if (!main_1._.missingOrEmpty(cellRanges)) {
            cellRanges.forEach(function (cellRange) {
                // get starting and ending row, remember rowEnd could be before rowStart
                var startRow = cellRange.start.getGridRow();
                var endRow = cellRange.end.getGridRow();
                var startRowIsFirst = startRow.before(endRow);
                var currentRow = startRowIsFirst ? startRow : endRow;
                var lastRow = startRowIsFirst ? endRow : startRow;
                while (true) {
                    var finishedAllRows = main_1._.missing(currentRow) || lastRow.before(currentRow);
                    if (finishedAllRows) {
                        break;
                    }
                    cellRange.columns.forEach(function (column) {
                        // we only want to include each cell once, in case a cell is in multiple ranges
                        var cellId = currentRow.getGridCell(column).createId();
                        if (cellsSoFar[cellId]) {
                            return;
                        }
                        cellsSoFar[cellId] = true;
                        var rowNode = _this.getRowNode(currentRow);
                        if (main_1._.missing(rowNode)) {
                            return;
                        }
                        var value = _this.valueService.getValue(column, rowNode);
                        // if empty cell, skip it, doesn't impact count or anything
                        if (main_1._.missing(value) || value === '') {
                            return;
                        }
                        // see if value is wrapped, can happen when doing count() or avg() functions
                        if (value.value) {
                            value = value.value;
                        }
                        if (typeof value === 'string') {
                            value = Number(value);
                        }
                        if (typeof value === 'number' && !isNaN(value)) {
                            sum += value;
                            if (max === null || value > max) {
                                max = value;
                            }
                            if (min === null || value < min) {
                                min = value;
                            }
                            numberCount++;
                        }
                        count++;
                    });
                    currentRow = _this.cellNavigationService.getRowBelow(currentRow);
                }
            });
        }
        var gotResult = this.gridOptionsWrapper.isAlwaysShowStatusBar() || count > 1;
        var gotNumberResult = numberCount > 1;
        // we should count even if no numbers
        if (gotResult) {
            this.statusItemCount.setValue(count);
        }
        this.statusItemCount.setVisible(gotResult);
        // if numbers, then show the number items
        if (gotNumberResult) {
            this.statusItemSum.setValue(sum);
            this.statusItemMin.setValue(min);
            this.statusItemMax.setValue(max);
            this.statusItemAvg.setValue(sum / numberCount);
        }
        this.statusItemSum.setVisible(gotNumberResult);
        this.statusItemMin.setVisible(gotNumberResult);
        this.statusItemMax.setVisible(gotNumberResult);
        this.statusItemAvg.setVisible(gotNumberResult);
        if (this.isVisible() !== gotResult) {
            this.setVisible(gotResult);
            this.gridCore.doLayout();
        }
    };
    StatusBar.prototype.getRowNode = function (gridRow) {
        switch (gridRow.floating) {
            case main_1.Constants.PINNED_TOP:
                return this.pinnedRowModel.getPinnedTopRowData()[gridRow.rowIndex];
            case main_1.Constants.PINNED_BOTTOM:
                return this.pinnedRowModel.getPinnedBottomRowData()[gridRow.rowIndex];
            default:
                return this.rowModel.getRow(gridRow.rowIndex);
        }
    };
    StatusBar.TEMPLATE = '<div class="ag-status-bar">' +
        '</div>';
    __decorate([
        main_1.Autowired('eventService'),
        __metadata("design:type", main_1.EventService)
    ], StatusBar.prototype, "eventService", void 0);
    __decorate([
        main_1.Autowired('rangeController'),
        __metadata("design:type", rangeController_1.RangeController)
    ], StatusBar.prototype, "rangeController", void 0);
    __decorate([
        main_1.Autowired('valueService'),
        __metadata("design:type", main_1.ValueService)
    ], StatusBar.prototype, "valueService", void 0);
    __decorate([
        main_1.Autowired('cellNavigationService'),
        __metadata("design:type", main_1.CellNavigationService)
    ], StatusBar.prototype, "cellNavigationService", void 0);
    __decorate([
        main_1.Autowired('pinnedRowModel'),
        __metadata("design:type", main_1.PinnedRowModel)
    ], StatusBar.prototype, "pinnedRowModel", void 0);
    __decorate([
        main_1.Autowired('rowModel'),
        __metadata("design:type", Object)
    ], StatusBar.prototype, "rowModel", void 0);
    __decorate([
        main_1.Autowired('context'),
        __metadata("design:type", main_1.Context)
    ], StatusBar.prototype, "context", void 0);
    __decorate([
        main_1.Autowired('gridOptionsWrapper'),
        __metadata("design:type", main_1.GridOptionsWrapper)
    ], StatusBar.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        main_1.Autowired('gridCore'),
        __metadata("design:type", main_1.GridCore)
    ], StatusBar.prototype, "gridCore", void 0);
    __decorate([
        main_1.PostConstruct,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], StatusBar.prototype, "init", null);
    StatusBar = StatusBar_1 = __decorate([
        main_1.Bean('statusBar'),
        __metadata("design:paramtypes", [])
    ], StatusBar);
    return StatusBar;
    var StatusBar_1;
}(main_1.Component));
exports.StatusBar = StatusBar;


/***/ }),

/***/ "zmaz":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1427);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("D1eD");

/***/ }),

/***/ 1289:
/***/ (function(module, exports) {

	module.exports = __webpack_require__("5AFk");

/***/ }),

/***/ 1427:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1049), __webpack_require__(1289)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function () {

	var __meta__ = {// jshint ignore:line
	    id: "textbox",
	    name: "TextBox",
	    category: "web",
	    description: "The TextBox widget enables you to style and provide a floating label functionality to input elements",
	    depends: ["core", "floatinglabel"]
	};

	(function ($, undefined) {
	    var kendo = window.kendo,
	        Widget = kendo.ui.Widget,
	        ui = kendo.ui,
	        isPlainObject = $.isPlainObject,
	        NS = ".kendoTextBox",
	        CHANGE = "change",
	        DISABLED = "disabled",
	        READONLY = "readonly",
	        INPUT = "k-input",
	        FOCUSED = "k-state-focused",
	        LABELCLASSES = "k-label k-input-label",
	        STATEDISABLED = "k-state-disabled",
	        NOCLICKCLASS = "k-no-click",
	        ARIA_DISABLED = "aria-disabled",
	        proxy = $.proxy;

	    var TextBox = Widget.extend({
	        init: function (element, options) {
	            var that = this;

	            Widget.fn.init.call(that, element, options);
	            options = $.extend(true, {}, options);

	            that.options.value = options.value || that.element.val();
	            that.options.readonly = options.readonly !== undefined ? options.readonly : Boolean(that.element.attr("readonly"));
	            that.options.enable = options.enable !== undefined ? options.enable : !(Boolean(that.element.attr("disabled")));
	            that.options.placeholder = options.placeholder || that.element.attr("placeholder");

	            that.value(that.options.value);
	            that._wrapper();
	            that._label();
	            that._editable({
	                readonly: that.options.readonly,
	                disable: !(that.options.enable)
	            });

	            that.element
	                .addClass(INPUT)
	                .attr("placeholder", that.options.placeholder)
	                .attr("autocomplete", "off");

	            kendo.notify(that);
	        },

	        events: [
	            CHANGE
	        ],

	        options: {
	            name: 'TextBox',
	            value: '',
	            readonly: false,
	            enable: true,
	            placeholder: '',
	            label: null
	        },

	        value: function(value) {
	            var that = this;

	            if (value === undefined) {
	                return that._value;
	            }

	            that._value = value;
	            that.element.val(value);
	        },

	        readonly: function(readonly) {
	            var that = this;

	            this._editable({
	                readonly: readonly === undefined ? true : readonly,
	                disable: false
	            });

	            if (that.floatingLabel) {
	                that.floatingLabel.readonly(readonly === undefined ? true : readonly);
	            }
	        },

	        enable: function(enable) {
	            var that = this;

	            this._editable({
	                readonly: false,
	                disable: !(enable = enable === undefined ? true : enable)
	            });

	            if (that.floatingLabel) {
	                that.floatingLabel.enable(enable = enable === undefined ? true : enable);
	            }
	        },

	        focus: function() {
	            var that = this;

	            that.element[0].focus();
	        },

	        destroy: function() {
	            var that = this;

	            if (that.floatingLabel) {
	                that.floatingLabel.destroy();
	            }

	            that.element.off(NS);
	            Widget.fn.destroy.call(that);
	        },

	        _editable: function(options) {
	            var that = this;
	            var element = that.element;
	            var wrapper = that.wrapper;
	            var disable = options.disable;
	            var readonly = options.readonly;

	            element.off(NS);

	            if (!readonly && !disable) {
	                element.removeAttr(DISABLED)
	                       .removeAttr(READONLY)
	                       .attr(ARIA_DISABLED, false);

	                wrapper.removeClass(STATEDISABLED)
	                        .removeClass(NOCLICKCLASS);

	                element.on("focusin" + NS, proxy(that._focusin, that));
	                element.on("focusout" + NS, proxy(that._focusout, that));
	            } else {
	                element.attr(DISABLED, disable)
	                       .attr(READONLY, readonly)
	                       .attr(ARIA_DISABLED, disable);

	                wrapper.toggleClass(STATEDISABLED, disable)
	                        .toggleClass(NOCLICKCLASS, readonly);
	            }
	        },

	        _label: function() {
	            var that = this;
	            var element = that.element;
	            var options = that.options;
	            var id = element.attr("id");
	            var floating;
	            var labelText;

	            if (options.label !== null) {
	                floating = isPlainObject(options.label) ? options.label.floating : false;
	                labelText = isPlainObject(options.label) ? options.label.content : options.label;

	                if (floating) {
	                    that._floatingLabelContainer = that.wrapper.wrap("<span></span>").parent();
	                    that.floatingLabel = new kendo.ui.FloatingLabel(that._floatingLabelContainer, { widget: that });
	                }

	                if (kendo.isFunction(labelText)) {
	                    labelText = labelText.call(that);
	                }

	                if (!labelText) {
	                    labelText = "";
	                }

	                if (!id) {
	                    id = options.name + "_" + kendo.guid();
	                    element.attr("id", id);
	                }

	                that._inputLabel = $("<label class='" + LABELCLASSES + "' for='" + id + "'>" + labelText + "</label>'").insertBefore(that.wrapper);
	            }
	        },

	        _focusin: function() {
	            var that = this;

	            that.wrapper.addClass(FOCUSED);
	        },

	        _focusout: function() {
	            var that = this;
	            var value = that._value;
	            var newValue = that.element.val();

	            that.wrapper.removeClass(FOCUSED);

	            if (value !== newValue) {
	                that._value = newValue;

	                that.trigger(CHANGE);
	            }
	        },

	        _wrapper: function () {
	            var that = this;
	            var element = that.element;
	            var DOMElement = element[0];
	            var wrapper;

	            wrapper = element.wrap("<span class='k-widget k-textbox'></span>").parent();
	            wrapper[0].style.cssText = DOMElement.style.cssText;
	            DOMElement.style.width = "100%";
	            that._inputWrapper = that.wrapper = wrapper.addClass(DOMElement.className).removeClass('input-validation-error');
	        }
	    });
	    ui.plugin(TextBox);
	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ })

/******/ });

/***/ })

});


// WEBPACK FOOTER //
// static/js/vendor.29a674e8d6772eb480ee.js